import * as i1$4 from '@agm/core';
import { AgmCoreModule } from '@agm/core';
import * as i11 from '@agm/snazzy-info-window';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import * as i1$2 from '@angular/common';
import { CommonModule, DatePipe, formatCurrency, getCurrencySymbol, CurrencyPipe } from '@angular/common';
import * as i0 from '@angular/core';
import { Directive, HostListener, Component, ChangeDetectionStrategy, Injectable, Input, Self, Optional, NgModule, EventEmitter, Output, RendererStyleFlags2, Pipe, ViewChild, ViewChildren, forwardRef, HostBinding, ElementRef, ViewContainerRef, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i4 from '@angular/forms';
import { UntypedFormGroup, UntypedFormControl, FormsModule, ReactiveFormsModule, Validators, UntypedFormArray, NG_VALUE_ACCESSOR, FormControl } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as i2$1 from '@angular/router';
import { RouterModule, NavigationEnd } from '@angular/router';
import * as i1$1 from '@ng-bootstrap/ng-bootstrap';
import { NgbModule, NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import * as i3 from '@uiowa/digit-only';
import { DigitOnlyModule } from '@uiowa/digit-only';
import * as i9 from 'agm-overlays';
import { AgmOverlays } from 'agm-overlays';
import * as i2$2 from 'ngx-infinite-scroll';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import * as i8 from 'ngx-mask';
import { NgxMaskModule } from 'ngx-mask';
import * as i3$1 from 'ngx-spinner';
import { NgxSpinnerModule } from 'ngx-spinner';
import * as i5 from '@tinymce/tinymce-angular';
import { EditorModule } from '@tinymce/tinymce-angular';
import * as i1 from 'vnext-shared';
import { EnvironmentService, LinkType, FormValidationService, SetMemberSearch, AgentState, ClearAgentMemberSearch, ADMIN_PERMISSIONS, SINGLE_AGENCY_PERMISSIONS, AGENCY_ADMIN_PERMISSIONS, MemberState, ProviderState, DeepLinkingParamsState, DataLayerGlobalVariable, AppConfigState, PlansState, GOOGLE_ANALYTICS_NOT_APPLICABLE, GOOGLE_ANALYTICS_NO, GOOGLE_ANALYTICS_YES, Memoize, PAYMENT_METHOD_RATE_FACTOR_IDENTIFIER, TargetType, LiveEditInactive, DateUtilities, NoteActionType, DataLayerEvent, NoteActionTypeName, NOTICE_TYPE, ProfileState, MedicineCabinetState, AgentRole, SelectedAgentGuid, PlanTypeAbbreviation, RegexPattern, HelpfulToolsState, SetCurrentTab, SetPlan, SetPlansDirty, SetZipCode, SetFipsCode, SetPlansFetched, SetLocation, FetchCounties, AppThemeConfig, ColorResourceKeys, DemographicState, MapState, SetIsOptimalZoomEnabled, SetMapCenter, ComparatorType, NumberOfPharmacies, PharmacyState, SetSelectedPharmacy, UpdatePharmacies, SpinnerEvent, FetchDigitalPharmacies, ResetSelectedPharmacies, SetPharmacies, ALL_MEDICARE_PLUS_MEDIGAP_PLAN_TYPE_VALUES, RemovePharmacy, ResetPharmacy, GuidedHelpMapStyleEnum, ALL_MEDICARE_PLAN_TYPE_VALUE, UpdateIsMailOrderSelected, APIPharmacyInfo, PharmacyFilterKeyType, Filter, PharmacyFilterKeyAnalyticsName, GOOGLE_ANALYTICS_NONE, QuoteHttpRequest, QuoteType, MedSupState, PlanType, MemberProgressStatus, PageTags, SendQuoteVia, EmailNames, UTMParameter, UTMValue, SubsidySelected, GuidedHelpHealthStatus, COMBO_PLANS, PlanSubTypes, SetActiveTab, MedSupKeyDefaults, FilterKeyType, ANCILLARY_PLANS, DSNPCodes, PlanDetailsCostLabels, SNPBaseType, ShoppingCartState, MEDICARE_PLAN_TYPES, GuidedHelpAgeSelection, PlanExtraDataKey, ProviderUtilityService, SetIsCostByEffectiveDate, SetTotalEstimatedCostAnnually, UiState, HttpStatusCode, UpdateTotalCostEffectiveDate, DefaultEffectiveDateOption, UpdatePlansRiderBenefitCategories, SectionHeaderType, ExtendedPlanDetailsName, PlanBenefitValueType, BASE_PLAN_HC_OPTION_NAMES, PharmacyType, BenefitType, ConfirmationModalComponent, PlansUtilityService, PLAN_ABBREVIATION_TYPE_MAP, FetchHospitalIndemnityQuestions, UpdateHospitalIndemnityPlanAnswers, ProductType, MedSupFormErrorTypes, GIREASONS_NO_REASON_KEY, UpdateSelectedPlanSubType, MedSupQuestionNames, Gender, SSOPopulatedField, VnextFormControl, VnextFormGroup, DOMKeyboardKeyCode, PLATFORM_OVERRIDES_KEY, PRE_PROCESS_PROP_KEY, LinkRoles, PlanYearType, ClearWidgetErrors, FetchProfileCountyData, FetchCountyData, SetDemographicLoading, EnrollmentUserType, MEDICARE_PLAN_TYPE_VALUES, RiderSubTypes, RiderBuckets, RemovePrimaryCareProvider, SOAActivityType, CROSS_SELL_PLANS, ProviderFilterKeyType, SetIsProviderSearchLoaded, SetProviders, SiteType, DemographicStates, UpdateAgentGuid, InputTypes, AuthorizationCodeSignatureModalFieldNames, AuthorizationCodeSignatureModalSectionNames, AuthorizationCodeVerificationStatus, ExternalContactTypes, AuthorizationCodeStatementActions, ModalEventType, SortPrimaryKey, SortLabels, DataKeyType, SortType, Sort, SetDefaultTab, CoverageType, RateFactorsUtilityService, MemoizeObservable, SetActiveTabPrescription, SetActiveTabTotalCost, SelectPlanDetails, PlanPharmacyNetworkKeywords, PlanStatus, ALL_MEDICARE_PLUS_MEDIGAP_PLAN_TYPE_VALUE, CompareGroup, SortGroup, FilterTab, SortUtilities, PlanCompareLabels, UpdatePlanPharmacies, FetchPlansError, COST_FILTER_KEYS, OperatorType, SNPSubType, TwilioState, CallRecordingBeginVia, CallRecordingEndVia, InputResetContextService, PropertyType, GLOBAL_RESOURCES_KEY, widgetCanValidate, WIDGET_VALIDATE_METHOD, ValueProviderType, MemberAgentTaskStatus, SetAgentNotes, SubscriptionMetaData, AGENT_USERNAME_MAX_LENGTH, LocaleService, UpdateCartSession, ResetHashRequestType, PasswordResetUserType, ResetType, DeactivationGuardStatus, TalkingPointPageType, ResponsiveLayout, BreakPoint, SOAState, SetNextGenSOAFormLoading, PhoneNumberType, SOATransactionEventType, EnrollmentFormType, SendAppVia, CoverageEventType, AccountAddPermissionsInputs, PREDEFINED_PERMISSION_PLAN, SNP_BASE_VALUES, NEW_AGENT_EXCEPTION_DETAIL, ACCOUNT_OVERVIEW, AgentStaticPurlYear, AgentSearchResult, TIMEOUT_ERROR, PassParameterUtilities, SOAFormPage, Answer, UpdateSOATransactionAnswers, ConsumerSiteType, BeneficiaryRedirectTypes, AgentSellingPermissionError, AuthPageErrorTitle, MedSupPaymentMethod, RateFactorsStatus, ANSWERED_RATE_FACTOR_STATUSES, PlanPreferenceLabels, PLANS_WITH_ALTERNATIVE_DRUGS, BenefitNetworkStatus, MedSupPlanRatingMethod, DENTAL_PLANS, VISION_PLANS, HEARING_PLANS, PreferenceDirection, PreferencesState, PreferenceViewType, QuoteBeneficiaryState, SmartVXEventType, BlueButtonStatus, BlueButtonMedicineCabinetState, SetBlueButtonCabinetLoading, UpdateBlueButtonCabinetClaimStatus, ResetBlueButtonMedicineCabinet, WidgetValidationService, GuidedHelpState, NO_DRUGS_COUNT, DrugFlag, DrugType, BlueButtonReturnStatus, SetConfirmationVisited, ResetConfirmationState, InsertPlan, EnrollmentType as EnrollmentType$1, RemovePlan, EnrollmentState, RuntimeState, EnrollmentTransactionRequest, PlanErrorMessage, UpdateMedigapAnswersSession, EnrollmentTransactionStatus, MESSAGE_SOURCE, UserTypeKeys, DaysDifferencePrecision, PlanHRAType, PlanHRAUserType, UserTypes, HRA_CONSUMER_TYPES, HRA_BROKER_TYPES, HRA_CALL_CENTER_TYPES, JsonAnalyticsGlobalVariable, EnrollSystemType, SelectPlan, SelectRider, FOAMHtmlDirectives, QUOTE_TYPES_FROM_SEND_TO_BENEFICIARY_FLOW, SetNextGenFormLoaded, SetNextGenFormLoading, SetNextGenSOAFormLoaded, EnrollmentFormTypeUtillity, PageLevelValidatorType, EligibilityCheckFieldNamesMap, EligibilityCheckDateFieldNamesMap, EligibilityCheckAdditionalFieldNamesMap, EnrollmentFormErrors, RECORDING_AVAILABLE_FORM_ANSWER, CallRecordingAvailability, MillimanHealthInformation, HEALTH_INFORMATION_AUTHORIZATION_DOCUMENT_NAME, HelpfulToolsTabs, ANCILLARY_FORM_TYPE, SelectSubsidySelected, SelectSubsidyPercent, GuidedHelpLinkStatus, SetOptimalZoom, PrimaryCareProviderToggleValues, NewPatientToggleValues, VBC_ORG, UpdateActivePharmacyTab, PharmacyTabType, SetHealthStatus, HealthCostsDurationValues, EstimateHealthCostFlag, SiteState, DeepLinkingParamKey, ConfirmationState, ResetAgentState, ResetHRAAPINativeTransactionID, EnrollmentFormTypeDisplayName, SetAgentError, AddAgentSubscriptionInfo, ResetAgentSubscriptionInfo, AgentError, StripeConstant, StripeSessionStatus, DatePipeFormats, GenderCode, GenderValue, MemberEligibilitySource, ELIGIBILITY_CHECK_REQUIRED_FIELDS, PlanSmartSortFields, UpdatePlanSmartSort, InitializePlanSmartFilterGroups, SetSelectedPlanSmartDetails, PlanSmartStatus, MillimanState, SetMillimanAuthorizationFields, SetMillimanApplicantId, GIREASONS_KEY, MedSupPlanQuestionIds, GIREASONS_VALUES, MILLIMAN_INITIAL, ResetMillimanState, UpdateMilliman, ANCILLARY_PRODUCTS, MillimanTier, UpdateMillimanHealthInformation, ProvidersLinkType, DrugPhaseIds, PlanDetailsTabs, SetActivePlanDetailsTab, GuidedHelpSections, PlanDetailsTabIdentifier, CultureCode, FilterContextNames, SNP_CATEGORY_FILTER_TYPES, PreferenceBannerSectionType, AnalyticsActionType, FilterKeyGroupName, StaticFilterLabel, FILTER_ABBREVIATION_DELIMITER, PlanFilterAbbreviation, PreferenceType, ResetSelectedPlanSmartDetails, ExternallyRatedDataFetchType, SetProvidersDetails, OUTSIDE_LICENSED_AREA, NO_PLANS_COUNT, MFA_CONTACT_TYPES, MultiFactorAuthenticationStep, AgentCallRecordingEnrollmentType, SetDeepLinkingParams, PassParams, MemberLoginOptions, AddPrimaryCareProvider, ExternalEnrollmentModalEventTypes, CrossSellEnrollmentTypes, CrossSellSendToBeneficiaryOptions, ANCILLARY_PLAN_TYPES, SOAUserType, STARTED_BY_AGENT_SOA_ACTIVITY_TYPES, ConfigurablePage, DeactivationGuardService } from 'vnext-shared';
import * as i2 from '@ngxs/store';
import { Select } from '@ngxs/store';
import { combineLatest, from, Subscription, timer, Observable, of, Subject, throttleTime, BehaviorSubject, ReplaySubject, pipe, forkJoin, EMPTY, fromEvent, merge, iif, take as take$1, switchMap as switchMap$1 } from 'rxjs';
import { switchMap, map, take, distinctUntilChanged, filter, skip, debounceTime, exhaustMap, catchError, shareReplay, startWith, pairwise, withLatestFrom, skipWhile, mergeMap, defaultIfEmpty, tap, share, takeUntil, delay, finalize, distinctUntilKeyChanged, pluck, first, takeWhile } from 'rxjs/operators';
import _isEqual from 'lodash.isequal';
import { __decorate } from 'tslib';
import { parsePhoneNumber } from 'libphonenumber-js/min';
import * as i1$3 from '@angular/platform-browser';
import _cloneDeep from 'lodash.clonedeep';
import _groupBy from 'lodash.groupby';
import _sortBy from 'lodash.sortby';
import dayjs from 'dayjs';
import uuid from 'uuid/v4';
import _get from 'lodash.get';
import { Device, Call } from '@twilio/voice-sdk';
import { HttpParams } from '@angular/common/http';
import _flatMap from 'lodash.flatmap';
import { trigger, transition, query, style, stagger, animate, state } from '@angular/animations';
import { loadStripe } from '@stripe/stripe-js/pure';
import _merge from 'lodash.merge';

class NavigationAdapterDirective {
    constructor(navigationService) {
        this.navigationService = navigationService;
        this.getPath = (eventTarget) => {
            const path = [];
            let target = eventTarget;
            while (target.parentNode) {
                path.push(target);
                target = target.parentNode;
            }
            return path;
        };
    }
    onClick(event) {
        const link = this.getPath(event.target).find(element => element.hasAttribute && element.hasAttribute('href'));
        if (link) {
            const href = link.getAttribute('href');
            const target = link.getAttribute('target') || '_blank';
            if (href && event.type === 'click') {
                event.preventDefault();
                if (!EnvironmentService.getEnvironment().liveedit) {
                    this.navigationService.navigate({
                        title: '',
                        href,
                        target,
                        type: LinkType.EXTERNAL,
                        validateWidgets: false
                    });
                }
            }
        }
    }
}
NavigationAdapterDirective.ɵfac = function NavigationAdapterDirective_Factory(t) { return new (t || NavigationAdapterDirective)(i0.ɵɵdirectiveInject(i1.NavigationService)); };
NavigationAdapterDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: NavigationAdapterDirective, selectors: [["", "navigationAdapter", ""]], hostBindings: function NavigationAdapterDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function NavigationAdapterDirective_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavigationAdapterDirective, [{
        type: Directive,
        args: [{ selector: '[navigationAdapter]' }]
    }], function () { return [{ type: i1.NavigationService }]; }, { onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();

function LiveEditModalComponent_h5_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.liveEditProp.metadata.description, " ");
} }
function LiveEditModalComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "editor", 14);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("init", ctx_r1.tinyMCEConfig);
} }
function LiveEditModalComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "textarea", 15);
} }
class LiveEditModalComponent {
    constructor(configResourceService, configLoaderService, navigationService, navigationContext, activeModal, cdr) {
        this.configResourceService = configResourceService;
        this.configLoaderService = configLoaderService;
        this.navigationService = navigationService;
        this.navigationContext = navigationContext;
        this.activeModal = activeModal;
        this.cdr = cdr;
        this.liveEditForm = new UntypedFormGroup({});
        this.tinyMCEConfig = {
            height: 500,
            menubar: false,
            resize: true,
            toolbar_mode: 'wrap',
            plugins: ['link', 'table', 'pagebreak', 'lists', 'autolink', 'directionality', 'code'],
            toolbar: 'undo redo | bold italic forecolor backcolor | fontsizeselect | \
      link autolink | formatselect | \
      lists bullist numlist outdent indent pagebreak | \
      alignleft aligncenter alignright alignjustify | ltr rtl | \
      table | removeformat | code'
        };
    }
    ngOnInit() {
        if (this.liveEditProp && this.liveEditProp.resource && !this.liveEditProp.resource.conditions) {
            this.liveEditForm.addControl('value', new UntypedFormControl(this.liveEditProp.resource.value));
        }
    }
    cancelChanges() {
        this.activeModal.dismiss();
    }
    updateResults() {
        // TODO: test this thoroughly
        // TODO: check if this has changed at all before sending
        this.configResourceService
            .updateResource$({
            lang: this.liveEditProp.lang,
            pageName: this.navigationService.getCurrentPageBaseUrl(),
            widgetName: this.widgetName,
            zoneKey: this.zoneKey,
            // the prop name is the override value in the case of a resource since it is a reference to a resource key
            propName: this.liveEditProp.prop.value,
            type: "resource" /* LiveEditValueType.RESOURCE */,
            value: this.liveEditForm.value.value
        })
            .subscribe({ next: () => this.cdr.detectChanges() });
        const urlParams = this.navigationContext.getUrlParams();
        const shortSiteId = urlParams.shortSiteId;
        const changeSetId = urlParams.changeSetId;
        if (shortSiteId && changeSetId) {
            this.configLoaderService.updateResource(shortSiteId, changeSetId, {
                lang: this.liveEditProp.lang,
                pageName: this.navigationService.getCurrentPageBaseUrl(),
                widgetName: this.widgetName,
                zoneKey: this.zoneKey,
                // Since we are dealing with a resource the prop value will be a string
                propName: this.liveEditProp.prop.value,
                type: "resource" /* LiveEditValueType.RESOURCE */,
                value: this.liveEditForm.value.value
            });
        }
        else {
            console.log('No changeSetId or shortSiteId');
            // TODO: dispatch an action to log this as an error
        }
        // TODO: update in memory and call out to live edit update service
        this.activeModal.close();
    }
}
LiveEditModalComponent.ɵfac = function LiveEditModalComponent_Factory(t) { return new (t || LiveEditModalComponent)(i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.ConfigLoaderService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.NavigationContext), i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
LiveEditModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LiveEditModalComponent, selectors: [["vnext-liveedit-modal"]], decls: 20, vars: 5, consts: [[1, "modal-header", "Spa_Style_InactiveTabAndModal"], [1, "modal-title", "Spa_Style_H4"], ["type", "button", "aria-label", "Close", 1, "close", 3, "click"], ["aria-hidden", "true"], [1, "modal-body"], [1, "text-break"], ["class", "Spa_Style_H5", 4, "ngIf"], [3, "formGroup"], [4, "ngIf", "ngIfElse"], ["textResource", ""], [1, "modal-footer"], [1, "float-right"], ["type", "button", 1, "btn", "btn-outline-dark", 3, "click"], [1, "Spa_Style_H5"], ["formControlName", "value", 3, "init"], ["formControlName", "value"]], template: function LiveEditModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "h2", 1);
        i0.ɵɵtext(2, "Edit Resource");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "button", 2);
        i0.ɵɵlistener("click", function LiveEditModalComponent_Template_button_click_3_listener() { return ctx.cancelChanges(); });
        i0.ɵɵelementStart(4, "span", 3);
        i0.ɵɵtext(5, "\u00D7");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(6, "div", 4)(7, "h3", 5);
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, LiveEditModalComponent_h5_9_Template, 2, 1, "h5", 6);
        i0.ɵɵelementStart(10, "form", 7);
        i0.ɵɵtemplate(11, LiveEditModalComponent_ng_container_11_Template, 2, 1, "ng-container", 8);
        i0.ɵɵtemplate(12, LiveEditModalComponent_ng_template_12_Template, 1, 0, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(14, "div", 10)(15, "div", 11)(16, "button", 12);
        i0.ɵɵlistener("click", function LiveEditModalComponent_Template_button_click_16_listener() { return ctx.cancelChanges(); });
        i0.ɵɵtext(17, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "button", 12);
        i0.ɵɵlistener("click", function LiveEditModalComponent_Template_button_click_18_listener() { return ctx.updateResults(); });
        i0.ɵɵtext(19, "Save");
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(13);
        i0.ɵɵadvance(8);
        i0.ɵɵtextInterpolate1(" ", ctx.liveEditProp.metadata && ctx.liveEditProp.metadata.friendlyName ? ctx.liveEditProp.metadata.friendlyName : ctx.liveEditProp.prop.value, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.liveEditProp.metadata && ctx.liveEditProp.metadata.description);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.liveEditForm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.liveEditProp.metadata && ctx.liveEditProp.metadata.type && ctx.liveEditProp.metadata.type.toLowerCase() === "html")("ngIfElse", _r2);
    } }, dependencies: [i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, i5.EditorComponent], styles: [".collapsible[_ngcontent-%COMP%]{background-color:#eee;color:#444;cursor:pointer;padding:10px;width:100%;border:none;text-align:left;outline:none;font-size:15px;margin-bottom:10px}.active[_ngcontent-%COMP%], .collapsible[_ngcontent-%COMP%]:hover{background-color:#ccc}.modal-header[_ngcontent-%COMP%]{display:flex}textarea[_ngcontent-%COMP%]{width:100%;height:350px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LiveEditModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-liveedit-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"modal-header Spa_Style_InactiveTabAndModal\">\r\n  <h2 class=\"modal-title Spa_Style_H4\">Edit Resource</h2>\r\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"cancelChanges()\">\r\n    <span aria-hidden=\"true\">&times;</span>\r\n  </button>\r\n</div>\r\n<div class=\"modal-body\">\r\n  <h3 class=\"text-break\">\r\n    {{ liveEditProp.metadata && liveEditProp.metadata.friendlyName ? liveEditProp.metadata.friendlyName : liveEditProp.prop.value }}\r\n  </h3>\r\n  <h5 class=\"Spa_Style_H5\" *ngIf=\"liveEditProp.metadata && liveEditProp.metadata.description\">\r\n    {{ liveEditProp.metadata.description }}\r\n  </h5>\r\n  <form [formGroup]=\"liveEditForm\">\r\n    <ng-container\r\n      *ngIf=\"liveEditProp.metadata && liveEditProp.metadata.type && liveEditProp.metadata.type.toLowerCase() === 'html'; else textResource\"\r\n    >\r\n      <editor [init]=\"tinyMCEConfig\" formControlName=\"value\"></editor>\r\n    </ng-container>\r\n    <ng-template #textResource>\r\n      <textarea formControlName=\"value\"></textarea>\r\n    </ng-template>\r\n  </form>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <div class=\"float-right\">\r\n    <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"cancelChanges()\">Cancel</button>\r\n    <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"updateResults()\">Save</button>\r\n  </div>\r\n</div>\r\n", styles: [".collapsible{background-color:#eee;color:#444;cursor:pointer;padding:10px;width:100%;border:none;text-align:left;outline:none;font-size:15px;margin-bottom:10px}.active,.collapsible:hover{background-color:#ccc}.modal-header{display:flex}textarea{width:100%;height:350px}\n"] }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: i1.ConfigLoaderService }, { type: i1.NavigationService }, { type: i1.NavigationContext }, { type: i1$1.NgbActiveModal }, { type: i0.ChangeDetectorRef }]; }, null); })();

/**
 * Service for injecting zone data into widgets
 */
class ZoneService {
    constructor() { }
}
ZoneService.ɵfac = function ZoneService_Factory(t) { return new (t || ZoneService)(); };
ZoneService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ZoneService, factory: ZoneService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ZoneService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * Service for injecting widget data into widget children.
 * There are times sub components need information about the widgets that contain
 * them. This service injects that data.
 */
class WidgetService {
    constructor() {
        this.resourceMap = {};
    }
}
WidgetService.ɵfac = function WidgetService_Factory(t) { return new (t || WidgetService)(); };
WidgetService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: WidgetService, factory: WidgetService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WidgetService, [{
        type: Injectable
    }], function () { return []; }, null); })();

function ContainerComponent_span_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ContainerComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵlistener("click", function ContainerComponent_span_0_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.openLiveEditPanel()); });
    i0.ɵɵtemplate(1, ContainerComponent_span_0_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", "live-edit-container");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.template);
} }
function ContainerComponent_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ContainerComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ContainerComponent_ng_template_1_ng_container_0_Template, 1, 0, "ng-container", 3);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.template);
} }
/**
 * A component wrapper for when we are editting the app in liveedit mode
 */
class ContainerComponent {
    constructor(configResourceService, modalService, cdr, zoneService, widgetService, navigationService) {
        this.configResourceService = configResourceService;
        this.modalService = modalService;
        this.cdr = cdr;
        this.zoneService = zoneService;
        this.widgetService = widgetService;
        this.navigationService = navigationService;
        this.liveEdit = EnvironmentService.getEnvironment().liveedit;
        this.zoneKey = zoneService.zoneKey;
    }
    getLiveEditProp() {
        const overrideKey = this.resourceMap ? this.resourceMap[this.propName] : null;
        this.liveEditProp = this.configResourceService.getLiveEditProp(this.navigationService.getCurrentPageBaseUrl(), this.widgetName, this.zoneKey, this.propName, overrideKey);
    }
    isPropEditable() {
        return this.liveEditProp && this.liveEditProp.resource && !this.liveEditProp.resource.conditions;
    }
    ngAfterContentInit() {
        // since we are using content projection to wrap the widgets we need to use this
        // angular hook in order to give the widget a chance to initialize and set these
        // properties on their instance of WidgetService
        if (EnvironmentService.getEnvironment().liveedit) {
            this.widgetName = this.widgetService.widgetName;
            this.widgetId = this.widgetService.widgetId;
            this.resourceMap = this.widgetService.resourceMap;
            this.getLiveEditProp();
        }
    }
    // ignore click events in live edit containers
    // we don't want to navigate from page to page in live edit containers
    // since we want the user to be able to edit them
    onClick(event) {
        if (this.isLiveEditAndShouldWrap()) {
            event.preventDefault();
        }
    }
    openLiveEditPanel() {
        // stop any click events within the live edit container
        // this is to prevent navigating when the user intends to edit the live edit item
        // get any updates to the live edit prop that have occured
        this.getLiveEditProp();
        // only opening this if we have the data neccessary to make updates
        if (this.shouldWrapComponent()) {
            const liveEditModal = this.modalService.open(LiveEditModalComponent);
            liveEditModal.componentInstance.widgetId = this.widgetId;
            liveEditModal.componentInstance.widgetName = this.widgetName;
            liveEditModal.componentInstance.zoneKey = this.zoneKey;
            liveEditModal.componentInstance.propName = this.propName;
            liveEditModal.componentInstance.liveEditProp = this.liveEditProp;
            this.cdr.detectChanges();
        }
    }
    shouldWrapComponent() {
        return this.isPropEditable() && this.widgetName && this.zoneKey && this.propName && this.widgetId;
    }
    isLiveEditAndShouldWrap() {
        return !!(this.liveEdit && this.shouldWrapComponent());
    }
}
ContainerComponent.ɵfac = function ContainerComponent_Factory(t) { return new (t || ContainerComponent)(i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.NavigationService)); };
ContainerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ContainerComponent, selectors: [["vnext-liveedit-container"]], hostBindings: function ContainerComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function ContainerComponent_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } }, inputs: { template: "template", propName: "propName" }, decls: 3, vars: 2, consts: [[3, "ngClass", "click", 4, "ngIf", "ngIfElse"], ["rawContent", ""], [3, "ngClass", "click"], [4, "ngTemplateOutlet"]], template: function ContainerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ContainerComponent_span_0_Template, 2, 2, "span", 0);
        i0.ɵɵtemplate(1, ContainerComponent_ng_template_1_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.isLiveEditAndShouldWrap())("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$2.NgTemplateOutlet], styles: ["span.live-edit-container[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent4);display:inline-block;padding:5px 20px}span.live-edit-container[_ngcontent-%COMP%]:hover{border:1px solid var(--static-Spa_Style_Warn_Dark)!important;background-color:var(--static-Spa_Style_Gray1)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContainerComponent, [{
        type: Component,
        args: [{ selector: 'vnext-liveedit-container', changeDetection: ChangeDetectionStrategy.OnPush, template: "<span *ngIf=\"isLiveEditAndShouldWrap(); else rawContent\" [ngClass]=\"'live-edit-container'\" (click)=\"openLiveEditPanel()\">\r\n  <ng-container *ngTemplateOutlet=\"template\"></ng-container>\r\n</span>\r\n<ng-template #rawContent>\r\n  <ng-container *ngTemplateOutlet=\"template\"></ng-container>\r\n</ng-template>\r\n", styles: ["span.live-edit-container{border:1px solid var(--static-Spa_Style_Accent4);display:inline-block;padding:5px 20px}span.live-edit-container:hover{border:1px solid var(--static-Spa_Style_Warn_Dark)!important;background-color:var(--static-Spa_Style_Gray1)}\n"] }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: i1$1.NgbModal }, { type: i0.ChangeDetectorRef }, { type: ZoneService }, { type: WidgetService }, { type: i1.NavigationService }]; }, { template: [{
            type: Input
        }], propName: [{
            type: Input
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();

class LiveEditPropDirective {
    constructor(templateRef, viewContainer, componentFactoryResolver) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.componentFactoryResolver = componentFactoryResolver;
    }
    set liveEditProp(propName) {
        this.propName = propName;
        if (this.wrapperContainer && this.wrapperContainer.instance) {
            this.wrapperContainer.instance.propName = this.propName;
        }
    }
    ngOnInit() {
        const containerFactory = this.componentFactoryResolver.resolveComponentFactory(ContainerComponent);
        this.wrapperContainer = this.viewContainer.createComponent(containerFactory);
        this.wrapperContainer.instance.template = this.templateRef;
        this.wrapperContainer.instance.propName = this.propName;
    }
}
LiveEditPropDirective.ɵfac = function LiveEditPropDirective_Factory(t) { return new (t || LiveEditPropDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver)); };
LiveEditPropDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: LiveEditPropDirective, selectors: [["", "liveEditProp", ""]], inputs: { liveEditProp: "liveEditProp" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LiveEditPropDirective, [{
        type: Directive,
        args: [{ selector: '[liveEditProp]' }]
    }], function () { return [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }, { type: i0.ComponentFactoryResolver }]; }, { liveEditProp: [{
            type: Input
        }] }); })();

class FormInputSubmitDirective {
    constructor(formGroupDirective, form) {
        this.formGroupDirective = formGroupDirective;
        this.form = form;
    }
    onKeyDown(event) {
        event?.preventDefault();
    }
    onKeyUp(event) {
        // Used in reactive forms
        if (this.formGroupDirective) {
            this.formGroupDirective.onSubmit(null);
        }
        // Used in template-driven forms
        else if (this.form) {
            this.form.onSubmit(null);
        }
    }
}
FormInputSubmitDirective.ɵfac = function FormInputSubmitDirective_Factory(t) { return new (t || FormInputSubmitDirective)(i0.ɵɵdirectiveInject(i4.FormGroupDirective, 10), i0.ɵɵdirectiveInject(i4.NgForm, 8)); };
FormInputSubmitDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: FormInputSubmitDirective, selectors: [["", "disableKeyDownSubmit", ""]], hostBindings: function FormInputSubmitDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("keydown.enter", function FormInputSubmitDirective_keydown_enter_HostBindingHandler($event) { return ctx.onKeyDown($event); })("keyup.enter", function FormInputSubmitDirective_keyup_enter_HostBindingHandler($event) { return ctx.onKeyUp($event); });
    } } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormInputSubmitDirective, [{
        type: Directive,
        args: [{
                selector: '[disableKeyDownSubmit]'
            }]
    }], function () { return [{ type: i4.FormGroupDirective, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: i4.NgForm, decorators: [{
                type: Optional
            }] }]; }, { onKeyDown: [{
            type: HostListener,
            args: ['keydown.enter', ['$event']]
        }], onKeyUp: [{
            type: HostListener,
            args: ['keyup.enter', ['$event']]
        }] }); })();

const VNEXT_CONFIG_COMPONENT_EXPORTS = [
    ContainerComponent,
    LiveEditModalComponent,
    NavigationAdapterDirective,
    LiveEditPropDirective,
    FormInputSubmitDirective
];
const VNEXT_CONFIG_COMPONENT_DECLARATIONS = [...VNEXT_CONFIG_COMPONENT_EXPORTS];
const VNEXT_CONFIG_COMPONENT_ENTRY_COMPONENTS = [ContainerComponent, LiveEditModalComponent];

class ConfigsModule {
}
ConfigsModule.ɵfac = function ConfigsModule_Factory(t) { return new (t || ConfigsModule)(); };
ConfigsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ConfigsModule });
ConfigsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, FormsModule, ReactiveFormsModule, EditorModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfigsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule, ReactiveFormsModule, EditorModule],
                declarations: VNEXT_CONFIG_COMPONENT_DECLARATIONS,
                exports: VNEXT_CONFIG_COMPONENT_EXPORTS
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ConfigsModule, { declarations: [ContainerComponent, LiveEditModalComponent, NavigationAdapterDirective, LiveEditPropDirective, FormInputSubmitDirective], imports: [CommonModule, FormsModule, ReactiveFormsModule, EditorModule], exports: [ContainerComponent, LiveEditModalComponent, NavigationAdapterDirective, LiveEditPropDirective, FormInputSubmitDirective] }); })();

class RangeSliderDirective {
    constructor(elementRef, renderer, control) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.control = control;
        this.percentageChange = new EventEmitter();
        this.positionChange = new EventEmitter();
        this.position = 0;
        this.currentValue = 0;
        this.values = [];
        this.subscriptions = [];
    }
    ngOnInit() {
        for (let index = 0; index <= this.maxValue; index++) {
            this.values.push(index);
        }
        const range = this.renderer.createElement('input');
        this.renderer.setAttribute(range, 'type', 'range');
        this.renderer.setAttribute(range, 'min', '0');
        this.renderer.setAttribute(range, 'max', (this.values.length - 1).toString());
        this.renderer.addClass(range, 'slider');
        this.renderer.setAttribute(range, 'value', this.position.toString());
        this.elementRef.nativeElement.style = 'display:none';
        this.renderer.appendChild(this.renderer.parentNode(this.elementRef.nativeElement), range);
        this.renderer.listen(range, 'mouseup', event => {
            let percentage = Math.floor((event.layerX / (event.target.offsetWidth - 3)) * 100);
            percentage = percentage > 100 ? 100 : percentage < 0 ? 0 : percentage;
            this.percentageChange.emit(percentage);
            const position = +event.target.value;
            this.setPositionValue(position);
            this.positionChange.emit(this.currentValue);
            this.renderer.setAttribute(range, 'style', `background-size: ${percentage} % 100%;`);
        });
        this.subscriptions.push(this.control.control.valueChanges.subscribe(val => {
            if (this.currentValue !== val) {
                this.currentValue = val;
                this.position = val;
                range.value = `${this.position}`;
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    setPositionValue(position) {
        this.currentValue = +this.getValue(position).toFixed(0);
        this.control.control.setValue(this.currentValue);
    }
    // Calculate slider value from a position
    getValue(position) {
        return this.values[position];
    }
    // Calculate slider position from a value
    getPosition(value) {
        return this.values.findIndex(v => v < value);
    }
}
RangeSliderDirective.ɵfac = function RangeSliderDirective_Factory(t) { return new (t || RangeSliderDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i4.NgControl)); };
RangeSliderDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: RangeSliderDirective, selectors: [["", "vnextRangeSlider", ""]], inputs: { maxValue: "maxValue" }, outputs: { percentageChange: "percentageChange", positionChange: "positionChange" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RangeSliderDirective, [{
        type: Directive,
        args: [{
                selector: '[vnextRangeSlider]'
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i4.NgControl }]; }, { maxValue: [{
            type: Input
        }], percentageChange: [{
            type: Output
        }], positionChange: [{
            type: Output
        }] }); })();

/**
 * Aggregates the root level services needed by ConfigurableWidgets.
 * We are gathering them all here so adding service dependencies and
 * overriding the widgets constructor is cleaner.
 */
class ConfigurableWidgetService {
    constructor(configResourceService, storeResourceService, navigationService, filterService, sortService, spinnerService, modalService, store, router, navigationUtilityService, navigationContext) {
        this.configResourceService = configResourceService;
        this.storeResourceService = storeResourceService;
        this.navigationService = navigationService;
        this.filterService = filterService;
        this.sortService = sortService;
        this.spinnerService = spinnerService;
        this.modalService = modalService;
        this.store = store;
        this.router = router;
        this.navigationUtilityService = navigationUtilityService;
        this.navigationContext = navigationContext;
    }
}
ConfigurableWidgetService.ɵfac = function ConfigurableWidgetService_Factory(t) { return new (t || ConfigurableWidgetService)(i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.StoreResourceService), i0.ɵɵinject(i1.NavigationService), i0.ɵɵinject(i1.FilterService), i0.ɵɵinject(i1.SortService), i0.ɵɵinject(i1.SpinnerService), i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(i1.NavigationUtilityService), i0.ɵɵinject(i1.NavigationContext)); };
ConfigurableWidgetService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ConfigurableWidgetService, factory: ConfigurableWidgetService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfigurableWidgetService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: i1.StoreResourceService }, { type: i1.NavigationService }, { type: i1.FilterService }, { type: i1.SortService }, { type: i1.SpinnerService }, { type: i1$1.NgbModal }, { type: i2.Store }, { type: i2$1.Router }, { type: i1.NavigationUtilityService }, { type: i1.NavigationContext }]; }, null); })();

var BeneficiaryInput;
(function (BeneficiaryInput) {
    BeneficiaryInput["FIRST_NAME"] = "firstName";
    BeneficiaryInput["LAST_NAME"] = "lastName";
    BeneficiaryInput["DOB"] = "dateOfBirth";
    BeneficiaryInput["PHONE"] = "phoneNumber";
    BeneficiaryInput["EMAIL"] = "emailAddress";
    BeneficiaryInput["CONFIRMATION_NUMBER"] = "confirmationNumber";
    BeneficiaryInput["MBI"] = "mbi";
    BeneficiaryInput["APPLICATION_START_DATE"] = "applicationStartDate";
    BeneficiaryInput["APPLICATION_END_DATE"] = "applicationEndDate";
    BeneficiaryInput["AGENT_USER_NAME"] = "agentUserName";
})(BeneficiaryInput || (BeneficiaryInput = {}));
var SortFields;
(function (SortFields) {
    SortFields["LAST_NAME"] = "lastName";
    SortFields["CARRIER_STATUS"] = "carrierStatus";
    SortFields["PROFILE_DATE"] = "profileDate";
    SortFields["AGENT_LAST_NAME"] = "agentLastName";
})(SortFields || (SortFields = {}));
class AgentSearchFacade {
    constructor(configResourceService, formBuilder, formValidationService, store, responsiveLayoutService, navigationService, memberSessionService, agentService, agentPermissionService, localeService) {
        this.configResourceService = configResourceService;
        this.formBuilder = formBuilder;
        this.formValidationService = formValidationService;
        this.store = store;
        this.responsiveLayoutService = responsiveLayoutService;
        this.navigationService = navigationService;
        this.memberSessionService = memberSessionService;
        this.agentService = agentService;
        this.agentPermissionService = agentPermissionService;
        this.localeService = localeService;
        this.standardSpacing = 'col-lg-3 col-md-6 col-12';
        this.smallerSpacing = 'col-lg-2 col-6';
    }
    filterInputControls(keyName) {
        if (!this.showAgentUserName()) {
            if (keyName === BeneficiaryInput.AGENT_USER_NAME) {
                return false;
            }
        }
        return true;
    }
    getSearchFG(widgetName) {
        return this.getSearchFormConfig(widgetName)
            .filter(formInput => this.filterInputControls(formInput.keyName))
            .reduce((fg, input) => {
            const control = new UntypedFormControl(null, {
                updateOn: 'change'
            });
            const validators = [];
            if (input.keyName === BeneficiaryInput.FIRST_NAME || input.keyName === BeneficiaryInput.LAST_NAME) {
                validators.push(Validators.minLength(2), Validators.pattern(FormValidationService.nonWhiteSpacePattern));
            }
            if (input.keyName === BeneficiaryInput.EMAIL) {
                validators.push(Validators.email);
            }
            if (input.keyName === BeneficiaryInput.DOB ||
                input.keyName === BeneficiaryInput.APPLICATION_START_DATE ||
                input.keyName === BeneficiaryInput.APPLICATION_END_DATE) {
                //  date validator
                validators.push(this.formValidationService.validDate());
            }
            if (input.keyName === BeneficiaryInput.CONFIRMATION_NUMBER || input.keyName === BeneficiaryInput.MBI) {
                validators.push(Validators.minLength(3));
            }
            if (input.keyName === BeneficiaryInput.PHONE) {
                validators.push(Validators.minLength(10), Validators.maxLength(10));
            }
            if (input.keyName === BeneficiaryInput.AGENT_USER_NAME) {
                validators.push(Validators.minLength(2));
            }
            control.setValidators(validators);
            fg.addControl(input.keyName, control);
            return fg;
        }, this.formBuilder.group({}, { updateOn: 'blur' }));
    }
    setMemberSearchOnStore(memberSearch) {
        this.store.dispatch(new SetMemberSearch(memberSearch));
    }
    setMemberSearchResult(memberSearchResult) {
        this.agentService.setMemberSearchResult(memberSearchResult);
    }
    searchMembers$(values, milliseconds) {
        return this.store
            .selectOnce(AgentState.agentGuid)
            .pipe(switchMap(agentGuid => this.agentService.memberProfileSearch$(agentGuid, values, milliseconds)));
    }
    getMembers$() {
        return this.store.select(AgentState.memberSearch);
    }
    getCurrentLocale$() {
        return this.localeService.getCurrentLocale$();
    }
    memberSearchResult$() {
        return this.agentService.memberSearchResult$();
    }
    navigateByPageTag(pageTag) {
        this.navigationService.navigateByPageTag(pageTag);
    }
    clearSearch() {
        this.store.dispatch(new ClearAgentMemberSearch());
    }
    selectMember$(memberID, options = {}) {
        const { includeEnrollmentHistory, includeSOA, includeAgentCallHistory, includeLastAccessedHistory } = options;
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        this.memberSessionService.memberLogout();
        return this.memberSessionService.selectMemberForAgent$(agentGuid, memberID, includeEnrollmentHistory, includeSOA, includeAgentCallHistory, includeLastAccessedHistory);
    }
    getSortOptions(widgetName) {
        return [
            {
                label: this.configResourceService.getProcessedResourceValue('Spa_Agent_Search_SortOption1', widgetName, 'Last name'),
                value: SortFields.LAST_NAME
            },
            {
                label: this.configResourceService.getProcessedResourceValue('Spa_Agent_Search_SortOption2', widgetName, 'Status'),
                value: SortFields.CARRIER_STATUS
            },
            {
                label: this.configResourceService.getProcessedResourceValue('Spa_Agent_Search_SortOption3', widgetName, 'Last updated'),
                value: SortFields.PROFILE_DATE
            },
            {
                label: this.configResourceService.getProcessedResourceValue('Spa_Agent_Search_SortOption4', widgetName, 'Agent last name'),
                value: SortFields.AGENT_LAST_NAME
            }
        ];
    }
    getSearchFormConfig(widgetName) {
        const searchFormConfig = this.configResourceService.getProcessedResourceValue('Spa_Agent_Search_FormFields', widgetName, [
            {
                keyName: 'firstName',
                labelKey: 'Spa_Agent_Search_FirstName_Text',
                labelText: 'First name',
                ordinal: 1,
                display: true
            },
            {
                keyName: 'lastName',
                labelKey: 'Spa_Agent_Search_LastName_Text',
                labelText: 'Last name',
                ordinal: 2,
                display: true
            },
            {
                keyName: 'dateOfBirth',
                labelKey: 'Spa_Agent_Search_DOB_Text',
                labelText: 'Date of birth',
                ordinal: 3,
                display: true,
                error: this.formValidationService.errorMessages.invalidDate()
            },
            {
                keyName: 'phoneNumber',
                labelKey: 'Spa_Agent_Search_Phone_Text',
                labelText: 'Phone',
                ordinal: 4,
                display: true
            },
            {
                keyName: 'emailAddress',
                labelKey: 'Spa_Agent_Search_Email_Text',
                labelText: 'Email Address',
                ordinal: 5,
                display: true
            },
            {
                keyName: 'confirmationNumber',
                labelKey: 'Spa_Agent_Search_ConfirmationNumber_Text',
                labelText: 'Confirmation number',
                ordinal: 6,
                display: true
            },
            {
                keyName: 'mbi',
                labelKey: 'Spa_Agent_Search_MBI_Text',
                labelText: 'MBI',
                ordinal: 7,
                display: true
            },
            {
                keyName: 'applicationStartDate',
                labelKey: 'Spa_Agent_Search_StartDate_Text',
                labelText: 'Application start date',
                ordinal: 8,
                display: true
            },
            {
                keyName: 'applicationEndDate',
                labelKey: 'Spa_Agent_Search_EndDate_Text',
                labelText: 'Application end date',
                ordinal: 9,
                display: true
            },
            {
                keyName: 'agentUserName',
                labelKey: 'Spa_Agent_Search_AgentUserName_Text',
                labelText: 'Agent Username',
                ordinal: 10,
                display: true
            }
        ]);
        const formFieldAttributes = {
            firstName: {
                error: this.formValidationService.errorMessages.minCharacters2(),
                class: this.standardSpacing
            },
            lastName: {
                error: this.formValidationService.errorMessages.minCharacters2(),
                class: this.standardSpacing
            },
            dateOfBirth: {
                error: this.formValidationService.errorMessages.invalidDate(),
                class: `${this.smallerSpacing} offset-lg-0`,
                mask: FormValidationService.dateMask
            },
            phoneNumber: {
                error: this.formValidationService.errorMessages.minPhone(),
                class: `${this.smallerSpacing} offset-lg-0`,
                mask: FormValidationService.phoneMask
            },
            emailAddress: {
                error: this.formValidationService.errorMessages.invalidEmail(),
                class: this.standardSpacing
            },
            confirmationNumber: {
                error: this.formValidationService.errorMessages.minCharacters3(),
                class: this.standardSpacing
            },
            mbi: {
                error: this.formValidationService.errorMessages.minCharacters3(),
                class: this.standardSpacing
            },
            applicationStartDate: {
                error: this.formValidationService.errorMessages.invalidDate(),
                class: `${this.smallerSpacing} offset-lg-right-2`,
                mask: FormValidationService.dateMask
            },
            applicationEndDate: {
                error: this.formValidationService.errorMessages.invalidDate(),
                class: `${this.smallerSpacing} offset-lg-right-2`,
                mask: FormValidationService.dateMask
            },
            agentUserName: {
                error: this.formValidationService.errorMessages.minCharacters2(),
                class: this.standardSpacing
            }
        };
        searchFormConfig.forEach(formField => {
            Object.assign(formField, formFieldAttributes[formField.keyName]);
        });
        return searchFormConfig;
    }
    get isDesktop$() {
        return combineLatest(this.responsiveLayoutService.isCompact$, this.responsiveLayoutService.isMedium$).pipe(map(([compact, medium]) => !compact && !medium));
    }
    async updateMemberDetails() {
        await this.memberSessionService.updateSelectedMemberDetails();
    }
    showAgentUserName() {
        const environment = EnvironmentService.getEnvironment();
        return (environment.liveedit ||
            (!this.agentPermissionService.isBroker() &&
                (this.agentPermissionService.hasPermissions(ADMIN_PERMISSIONS) ||
                    this.agentPermissionService.hasPermissions(SINGLE_AGENCY_PERMISSIONS) ||
                    this.agentPermissionService.hasPermissions(AGENCY_ADMIN_PERMISSIONS))));
    }
    getProfileSearchForm(widgetId) {
        return this.getSearchFormConfig(widgetId).filter(formInput => this.filterInputControls(formInput.keyName));
    }
    getSessionByUniqueCode$(uniqueCode) {
        return this.store
            .selectOnce(AgentState.agentGuid)
            .pipe(switchMap(agentGuid => this.memberSessionService.getSessionByUniqueCode$(uniqueCode, agentGuid)));
    }
    setCurrentMemberProfilePageTag(memberPageTag) {
        this.memberSessionService.setCurrentMemberProfilePageTag(memberPageTag);
    }
    loadSessionFromUniqueCode$(sessionId) {
        return this.memberSessionService.fetchMemberSession$({ sessionId, isMemberInitialLoad: true }).pipe(take(1), switchMap(() => from(this.updateMemberDetails())));
    }
    hasSessionValues() {
        return this.isSessionValid(this.store.selectSnapshot(MemberState.session));
    }
    // We will know that a session is valid when a zip has been stored in the session
    isSessionValid(session) {
        const profileSearchZip = session.demographic?.zip;
        return profileSearchZip?.length > 0;
    }
}
AgentSearchFacade.ɵfac = function AgentSearchFacade_Factory(t) { return new (t || AgentSearchFacade)(i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i4.UntypedFormBuilder), i0.ɵɵinject(i1.FormValidationService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.ResponsiveLayoutService), i0.ɵɵinject(i1.NavigationService), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(i1.AgentService), i0.ɵɵinject(i1.AgentPermissionsService), i0.ɵɵinject(i1.LocaleService)); };
AgentSearchFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentSearchFacade, factory: AgentSearchFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentSearchFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: i4.UntypedFormBuilder }, { type: i1.FormValidationService }, { type: i2.Store }, { type: i1.ResponsiveLayoutService }, { type: i1.NavigationService }, { type: i1.MemberSessionService }, { type: i1.AgentService }, { type: i1.AgentPermissionsService }, { type: i1.LocaleService }]; }, null); })();

class SpeakWithAgentFacade {
    constructor(memberSessionService, shoppingCartService, guidedHelpService, configResourceService, agentSearchFacade, siteService) {
        this.memberSessionService = memberSessionService;
        this.shoppingCartService = shoppingCartService;
        this.guidedHelpService = guidedHelpService;
        this.configResourceService = configResourceService;
        this.agentSearchFacade = agentSearchFacade;
        this.siteService = siteService;
        this.mustShowUniqueCodeWhenLoggedIn = this.configResourceService.getProcessedResourceValue('Spa_SpeakWithAgent_ShowUniqueCode_UserLoggedIn_Enabled', null, false);
        this.enableUniqueCodeSection = this.configResourceService.getProcessedResourceValue('Spa_SpeakWithAgent_ShowUniqueCode_Enabled', null, false);
    }
    canDisplayUniqueCode() {
        const loggedIn = this.memberSessionService.isMemberLoggedIn();
        const sessionValues = this.agentSearchFacade.hasSessionValues();
        const hasPlans = !!this.shoppingCartService.getSelectedPlans()?.length;
        const hasGuidedHelp = this.guidedHelpService.getHasVisited() && this.guidedHelpService.getGuidedHelpHasValues();
        return (this.enableUniqueCodeSection && (this.mustShowUniqueCodeWhenLoggedIn || !loggedIn) && (sessionValues || hasPlans || hasGuidedHelp));
    }
    canDisplayUniqueCode$() {
        const loggedIn$ = this.memberSessionService.isMemberLoggedIn$();
        const plans$ = this.shoppingCartService.getSelectedPlans$();
        const hasGuidedHelp = this.guidedHelpService.getHasVisited() && this.guidedHelpService.getGuidedHelpHasValues();
        return combineLatest([loggedIn$, plans$]).pipe(map(([loggedIn, plans]) => this.enableUniqueCodeSection &&
            (this.mustShowUniqueCodeWhenLoggedIn || !loggedIn) &&
            (this.agentSearchFacade.hasSessionValues() || !!plans.length || hasGuidedHelp)));
    }
    getUniqueCode() {
        const uniqueCode = this.memberSessionService.getUniqueCode();
        const canDisplayUniqueCode = this.canDisplayUniqueCode();
        const isPPCSite = this.siteService.isPPCSite();
        return canDisplayUniqueCode && uniqueCode && !isPPCSite ? uniqueCode : null;
    }
}
SpeakWithAgentFacade.ɵfac = function SpeakWithAgentFacade_Factory(t) { return new (t || SpeakWithAgentFacade)(i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(i1.ShoppingCartService), i0.ɵɵinject(i1.GuidedHelpService), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(AgentSearchFacade), i0.ɵɵinject(i1.SiteService)); };
SpeakWithAgentFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SpeakWithAgentFacade, factory: SpeakWithAgentFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpeakWithAgentFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.MemberSessionService }, { type: i1.ShoppingCartService }, { type: i1.GuidedHelpService }, { type: i1.ConfigResourceService }, { type: AgentSearchFacade }, { type: i1.SiteService }]; }, null); })();

class AnalyticsService {
    constructor(configResourceService, googleTagManagerService, configurableWidgetService, memberSessionService, speakWithAgentFacade, weglotService) {
        this.configResourceService = configResourceService;
        this.googleTagManagerService = googleTagManagerService;
        this.configurableWidgetService = configurableWidgetService;
        this.memberSessionService = memberSessionService;
        this.speakWithAgentFacade = speakWithAgentFacade;
        this.weglotService = weglotService;
        this.siteType = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType');
    }
    set googleDataLayerTags(googleTag) {
        this.googleTagManagerService.googleDataLayerTags = googleTag;
    }
    get googleDataLayerTags() {
        return this.googleTagManagerService.googleDataLayerTags;
    }
    setGoogleDataLayerTag(key, value) {
        this.googleTagManagerService.setGoogleDataLayerTag(key, value);
    }
    getBaseUrl() {
        const baseElement = document.getElementsByTagName('base');
        return baseElement[0]?.href?.replace(/^http[s]??:\/\//i, '') ?? '';
    }
    getGlobalDataLayerTags(additionalDataLayerTags) {
        const appId = this.configResourceService.getProcessedResourceValue('AppID', null, 0).toString();
        const memberSession = this.memberSessionService.getMemberSession();
        const providers = this.configurableWidgetService.store.selectSnapshot(ProviderState.selectedProviders);
        let memberId = null;
        if (memberSession && memberSession.memberID) {
            memberId = memberSession.memberID;
        }
        const googleTagManagerNotApplicableText = this.getGoogleTagManagerNotApplicableText();
        const externalMemberId = this.configurableWidgetService.store.selectSnapshot(DeepLinkingParamsState.ssoValue);
        const externalReferenceId = this.configurableWidgetService.store.selectSnapshot(DeepLinkingParamsState.pegi);
        return {
            ...additionalDataLayerTags,
            [DataLayerGlobalVariable.SITE_ID]: this.configurableWidgetService.store.selectSnapshot(AppConfigState.shortSiteId),
            [DataLayerGlobalVariable.SITE_CHANNEL]: this.siteType,
            [DataLayerGlobalVariable.SITE_URL]: this.getBaseUrl(),
            [DataLayerGlobalVariable.LANGUAGE_ID]: this.weglotService.getCurrentWeglotLocaleOrDefault(),
            [DataLayerGlobalVariable.CLIENT_ID]: this.memberSessionService.getClientId(),
            [DataLayerGlobalVariable.COUNTY_FIPS]: memberSession.demographic.fips,
            [DataLayerGlobalVariable.ZIP]: memberSession.demographic.zip,
            [DataLayerGlobalVariable.MEMBER_ID]: memberId,
            [DataLayerGlobalVariable.EXTERNAL_MEMBER_ID]: externalMemberId ? externalMemberId : googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.EXTERNAL_REFERENCE_ID]: externalReferenceId ? externalReferenceId : googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.CLIENT_GAID]: this.configResourceService.getProcessedResourceValue('GoogleAnalyticsClientPropertyID'),
            [DataLayerGlobalVariable.APP_SESSION_ID]: memberSession ? memberSession.sessionId : null,
            [DataLayerGlobalVariable.APP_ID]: appId,
            [DataLayerGlobalVariable.USER_ID_METHOD]: this.memberSessionService.getAuthType(),
            [DataLayerGlobalVariable.PROVIDER_COUNT]: providers && providers.length ? providers.length.toString() : '0',
            [DataLayerGlobalVariable.MEMBER_ASSIST_CODE]: this.speakWithAgentFacade.getUniqueCode() || googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.SITE_PLAN_YEAR]: this.configurableWidgetService.store.selectSnapshot(PlansState.selectedPlanYear)
        };
    }
    async initializeGoogleDataLayerTags(additionalDataLayerTags) {
        this.googleDataLayerTags = this.getGlobalDataLayerTags(additionalDataLayerTags);
    }
    get isDefaultTagToUpdate() {
        return !this.googleDataLayerTags[DataLayerGlobalVariable.CLIENT_GAID];
    }
    getGoogleTagManagerNotApplicableText() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_NotApplicable_Text', null, 'n/a').toLowerCase();
    }
}
AnalyticsService.ɵfac = function AnalyticsService_Factory(t) { return new (t || AnalyticsService)(i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.GoogleTagManagerService), i0.ɵɵinject(ConfigurableWidgetService), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(SpeakWithAgentFacade), i0.ɵɵinject(i1.WeglotService)); };
AnalyticsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AnalyticsService, factory: AnalyticsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AnalyticsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: i1.GoogleTagManagerService }, { type: ConfigurableWidgetService }, { type: i1.MemberSessionService }, { type: SpeakWithAgentFacade }, { type: i1.WeglotService }]; }, null); })();

class GoogleTagManagerDirective {
    constructor(router, analyticsService, configResourceService, store, memberSessionService, speakWithAgentFacade, siteService, weglotService, enrollmentService, agentService) {
        this.router = router;
        this.analyticsService = analyticsService;
        this.configResourceService = configResourceService;
        this.store = store;
        this.memberSessionService = memberSessionService;
        this.speakWithAgentFacade = speakWithAgentFacade;
        this.siteService = siteService;
        this.weglotService = weglotService;
        this.enrollmentService = enrollmentService;
        this.agentService = agentService;
        this.disableCommonEvent = false;
        this.googleTagManagerEnabled = true;
        this.shouldUpdateTags = true;
        this.isTalkingPointsEnabled = false;
    }
    async ngOnInit() {
        if (this.shouldUpdateTags) {
            await this.updateTags();
        }
    }
    async ngOnChanges(changes) {
        if (this.googleTagManagerEnabled) {
            const shouldUpdateChanges = changes.shouldUpdateTags;
            if (shouldUpdateChanges && !shouldUpdateChanges.firstChange) {
                const previousShouldUpdate = shouldUpdateChanges.previousValue;
                const currentShouldUpdate = shouldUpdateChanges.currentValue;
                if (currentShouldUpdate && previousShouldUpdate !== currentShouldUpdate) {
                    await this.updateTags();
                }
            }
        }
    }
    isDuplicateDataLayerTagValue(key, value, tagsToUpdate) {
        const dataLayer = this.analyticsService.googleDataLayerTags;
        return !((!dataLayer?.[key] || dataLayer[key] !== value) && (!tagsToUpdate?.[key] || tagsToUpdate[key] !== value));
    }
    async updateTags() {
        const siteType = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType', null, 'consumer');
        const appId = this.configResourceService.getProcessedResourceValue('AppID', null, 0).toString();
        const googleDataLayerTagsToUpdate = this.tagsToUpdate ? this.tagsToUpdate : {};
        if (this.saveDefaultValues) {
            await this.setDefaultDataLayerTags(googleDataLayerTagsToUpdate, siteType, appId);
        }
        else if (googleDataLayerTagsToUpdate && Object.keys(googleDataLayerTagsToUpdate).length) {
            googleDataLayerTagsToUpdate[DataLayerGlobalVariable.PAGE_PATH] = this.router.url;
            googleDataLayerTagsToUpdate[DataLayerGlobalVariable.EVENT] = DataLayerGlobalVariable.VIEW_PAGE;
            this.analyticsService.googleDataLayerTags = googleDataLayerTagsToUpdate;
        }
        else if (!this.disableCommonEvent &&
            this.analyticsService.googleDataLayerTags[DataLayerGlobalVariable.PAGE_PATH] !== this.router.url) {
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
                [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE
            };
        }
    }
    async setDefaultDataLayerTags(googleDataLayerTagsToUpdate, siteType, appId) {
        const memberSession = this.memberSessionService.getMemberSession();
        const agentUserName = this.store.selectSnapshot(AgentState.userName);
        const userName = agentUserName || memberSession.userName;
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        const agentIsProfileAdmin = this.store.selectSnapshot(AgentState.agentIsProfileAdmin);
        const providers = this.store.selectSnapshot(ProviderState.selectedProviders);
        if (agentGuid) {
            if (!this.isDuplicateDataLayerTagValue(DataLayerGlobalVariable.AGENT_GUID, agentGuid, googleDataLayerTagsToUpdate)) {
                googleDataLayerTagsToUpdate[DataLayerGlobalVariable.AGENT_GUID] = agentGuid;
            }
        }
        if (agentIsProfileAdmin &&
            !this.isDuplicateDataLayerTagValue(DataLayerGlobalVariable.AGENT_IS_PROFILE_ADMIN, agentIsProfileAdmin, googleDataLayerTagsToUpdate)) {
            googleDataLayerTagsToUpdate[DataLayerGlobalVariable.AGENT_IS_PROFILE_ADMIN] = agentIsProfileAdmin;
        }
        if (memberSession?.memberID &&
            !this.isDuplicateDataLayerTagValue(DataLayerGlobalVariable.MEMBER_ID, memberSession.memberID, googleDataLayerTagsToUpdate)) {
            googleDataLayerTagsToUpdate[DataLayerGlobalVariable.MEMBER_ID] = memberSession.memberID;
        }
        const isPPCSite = this.siteService.isPPCSite(siteType);
        if (!isPPCSite) {
            googleDataLayerTagsToUpdate[DataLayerGlobalVariable.MEMBER_ASSIST_CODE] =
                this.speakWithAgentFacade.getUniqueCode() || GOOGLE_ANALYTICS_NOT_APPLICABLE;
        }
        const externalMemberId = this.store.selectSnapshot(DeepLinkingParamsState.ssoValue);
        const externalReferenceId = this.store.selectSnapshot(DeepLinkingParamsState.pegi);
        const isEnrollmentPage = this.enrollmentService.getPageIsEnrollment();
        this.isTalkingPointsEnabled =
            (this.configResourceService.getProcessedResourceValue('Spa_Site_DisplayTalkingPoints_Shopping_Enabled') && !isEnrollmentPage) ||
                (isEnrollmentPage && this.configResourceService.getProcessedResourceValue('Spa_Site_DisplayTalkingPoints_Enrollment_Enabled'));
        const talkingPoints = this.agentService.getTalkingPoints();
        if (talkingPoints?.length) {
            this.defaultTalkingPointsDropDownValue = talkingPoints.find(point => point.isDefault).name;
        }
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.SITE_ID]: this.store.selectSnapshot(AppConfigState.shortSiteId),
            [DataLayerGlobalVariable.SITE_CHANNEL]: siteType,
            [DataLayerGlobalVariable.SITE_URL]: this.analyticsService.getBaseUrl(),
            [DataLayerGlobalVariable.LANGUAGE_ID]: this.weglotService.getCurrentWeglotLocaleOrDefault(),
            [DataLayerGlobalVariable.CLIENT_ID]: this.memberSessionService.getClientId(),
            [DataLayerGlobalVariable.CLIENT_GAID]: this.configResourceService.getProcessedResourceValue('GoogleAnalyticsClientPropertyID'),
            [DataLayerGlobalVariable.APP_SESSION_ID]: memberSession ? memberSession.sessionId : null,
            [DataLayerGlobalVariable.USER_NAME]: userName || null,
            [DataLayerGlobalVariable.USER_ID_METHOD]: this.memberSessionService.getAuthType(),
            [DataLayerGlobalVariable.EXTERNAL_MEMBER_ID]: externalMemberId || GOOGLE_ANALYTICS_NOT_APPLICABLE,
            [DataLayerGlobalVariable.EXTERNAL_REFERENCE_ID]: externalReferenceId || GOOGLE_ANALYTICS_NOT_APPLICABLE,
            [DataLayerGlobalVariable.COUNTY_FIPS]: memberSession.demographic.fips,
            [DataLayerGlobalVariable.ZIP]: memberSession.demographic.zip,
            [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
            [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE,
            [DataLayerGlobalVariable.APP_ID]: appId,
            [DataLayerGlobalVariable.MEMBER_PREF_HEALTH_COST_CALC]: GOOGLE_ANALYTICS_NO,
            [DataLayerGlobalVariable.PROVIDER_COUNT]: providers?.length ? providers.length.toString() : '0',
            [DataLayerGlobalVariable.SITE_PLAN_YEAR]: this.store.selectSnapshot(PlansState.selectedPlanYear),
            [DataLayerGlobalVariable.TALKING_POINTS_ISPRESENT]: this.isTalkingPointsEnabled ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO,
            [DataLayerGlobalVariable.TALKING_POINTS_DEFAULT]: this.isTalkingPointsEnabled
                ? this.defaultTalkingPointsDropDownValue
                    ? this.defaultTalkingPointsDropDownValue
                    : 'no default selected'
                : 'n/a',
            ...googleDataLayerTagsToUpdate
        };
    }
}
GoogleTagManagerDirective.ɵfac = function GoogleTagManagerDirective_Factory(t) { return new (t || GoogleTagManagerDirective)(i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(SpeakWithAgentFacade), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(i1.WeglotService), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(i1.AgentService)); };
GoogleTagManagerDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: GoogleTagManagerDirective, selectors: [["", "vnextGoogleTagManager", ""]], inputs: { saveDefaultValues: "saveDefaultValues", tagsToUpdate: "tagsToUpdate", disableCommonEvent: "disableCommonEvent", googleTagManagerEnabled: "googleTagManagerEnabled", shouldUpdateTags: "shouldUpdateTags" }, features: [i0.ɵɵNgOnChangesFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GoogleTagManagerDirective, [{
        type: Directive,
        args: [{
                selector: '[vnextGoogleTagManager]'
            }]
    }], function () { return [{ type: i2$1.Router }, { type: AnalyticsService }, { type: i1.ConfigResourceService }, { type: i2.Store }, { type: i1.MemberSessionService }, { type: SpeakWithAgentFacade }, { type: i1.SiteService }, { type: i1.WeglotService }, { type: i1.EnrollmentFormService }, { type: i1.AgentService }]; }, { saveDefaultValues: [{
            type: Input
        }], tagsToUpdate: [{
            type: Input
        }], disableCommonEvent: [{
            type: Input
        }], googleTagManagerEnabled: [{
            type: Input
        }], shouldUpdateTags: [{
            type: Input
        }] }); })();

class HideMissingImageDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.imageSelector = 'img';
        this.displayNone = 'none';
    }
    ngOnInit() {
        const rootElement = this.elementRef?.nativeElement;
        const imageElement = rootElement?.tagName?.toLowerCase() === this.imageSelector
            ? rootElement
            : rootElement?.querySelector(this.imageSelector);
        if (imageElement) {
            imageElement.onerror = this.hideMissingImageOnError(rootElement);
        }
    }
    hideMissingImageOnError(rootElement) {
        return () => {
            if (rootElement?.style) {
                rootElement.style.display = this.displayNone;
            }
        };
    }
}
HideMissingImageDirective.ɵfac = function HideMissingImageDirective_Factory(t) { return new (t || HideMissingImageDirective)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
HideMissingImageDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: HideMissingImageDirective, selectors: [["", "vnextHideMissingImage", ""]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HideMissingImageDirective, [{
        type: Directive,
        args: [{
                selector: '[vnextHideMissingImage]'
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, null); })();

class HighlightDifferencesDirective {
    constructor(element) {
        this.element = element;
        // The name of the attribute to search for. All children elements with this attribute will be selected
        // to compare their text content.
        // Note: If the element contains the attribute "data-highlight-ignore-text", the value will be ignored before comparing the text contents.
        this.vnextHighlightDifferences = 'data-highlight-differences-section';
        // Toggle highlight differences
        this.showDifferences = false;
        // Apply the highlight styles to the child element containing this attribute
        this.applyHighlightStylesTo = 'data-highlight-differences';
        // Highlight styles
        this.highlightStyles = {
            backgroundColor: '#fff3dc',
            border: '2px dotted #b07d0f'
        };
        // Keep track on changes that could affect the differences result
        this.trackChanges = {};
        this.subscription = new Subscription();
    }
    ngOnChanges(changes) {
        const { showDifferences, trackChanges } = changes;
        if (showDifferences && !showDifferences.isFirstChange() && showDifferences.previousValue !== showDifferences.currentValue) {
            this.highlightDifferences(this.showDifferences);
        }
        else if (trackChanges && !trackChanges.isFirstChange() && !_isEqual(trackChanges.previousValue, trackChanges.currentValue)) {
            this.subscription.add(
            // The timer is used to push the highlighting after the template updates
            timer(0).subscribe({
                next: () => {
                    this.highlightDifferences(this.showDifferences);
                }
            }));
        }
    }
    ngAfterViewInit() {
        if (this.showDifferences) {
            this.highlightDifferences(this.showDifferences);
        }
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    highlightDifferences(showDifferences) {
        const compareElementsSelectors = this.selectorsRowIndex !== undefined
            ? `[${this.vnextHighlightDifferences}='${this.selectorsRowIndex}']`
            : `[${this.vnextHighlightDifferences}]`;
        const compareElements = Array.from(this.element.nativeElement.querySelectorAll(compareElementsSelectors));
        if (compareElements.length > 0) {
            const [firstElement, ...otherElements] = compareElements;
            const { textContent, dataset } = firstElement;
            const firstElementTextContent = (dataset.highlightIgnoreText ? textContent.replace(dataset.highlightIgnoreText, '') : textContent).trim();
            const hasDifferences = otherElements.some(element => {
                const elementTextContent = (element.dataset.highlightIgnoreText ? element.textContent.replace(element.dataset.highlightIgnoreText, '') : element.textContent).trim();
                return elementTextContent !== firstElementTextContent;
            });
            if (hasDifferences) {
                const highlightElementsSelectors = this.selectorsRowIndex !== undefined
                    ? `[${this.applyHighlightStylesTo}='${this.selectorsRowIndex}']`
                    : `[${this.applyHighlightStylesTo}]`;
                let highlightElements = Array.from(this.element.nativeElement.querySelectorAll(highlightElementsSelectors));
                if (highlightElements.length === 0) {
                    highlightElements = compareElements;
                }
                highlightElements.forEach(element => {
                    if (showDifferences) {
                        Object.entries(this.highlightStyles).forEach(([key, value]) => {
                            element.style[key] = value;
                        });
                    }
                    else {
                        Object.keys(this.highlightStyles).forEach(key => {
                            element.style[key] = null;
                        });
                    }
                });
            }
        }
    }
}
HighlightDifferencesDirective.ɵfac = function HighlightDifferencesDirective_Factory(t) { return new (t || HighlightDifferencesDirective)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
HighlightDifferencesDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: HighlightDifferencesDirective, selectors: [["", "vnextHighlightDifferences", ""]], inputs: { vnextHighlightDifferences: "vnextHighlightDifferences", showDifferences: "showDifferences", applyHighlightStylesTo: "applyHighlightStylesTo", highlightStyles: "highlightStyles", trackChanges: "trackChanges", selectorsRowIndex: "selectorsRowIndex" }, features: [i0.ɵɵNgOnChangesFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HighlightDifferencesDirective, [{
        type: Directive,
        args: [{
                selector: '[vnextHighlightDifferences]'
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, { vnextHighlightDifferences: [{
            type: Input
        }], showDifferences: [{
            type: Input
        }], applyHighlightStylesTo: [{
            type: Input
        }], highlightStyles: [{
            type: Input
        }], trackChanges: [{
            type: Input
        }], selectorsRowIndex: [{
            type: Input
        }] }); })();

class IconAriaAttributesDirective {
    constructor(_elRef, _renderer) {
        this._elRef = _elRef;
        this._renderer = _renderer;
    }
    ngOnInit() {
        this._renderer.setAttribute(this._elRef.nativeElement, 'aria-hidden', 'true');
    }
}
IconAriaAttributesDirective.ɵfac = function IconAriaAttributesDirective_Factory(t) { return new (t || IconAriaAttributesDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2)); };
IconAriaAttributesDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: IconAriaAttributesDirective, selectors: [["i", 8, "fa", 3, "ngbTooltip", "", 3, "ngbDropdownToggle", ""], ["i", 8, "fal", 3, "ngbTooltip", "", 3, "ngbDropdownToggle", ""], ["i", 8, "fas", 3, "ngbTooltip", "", 3, "ngbDropdownToggle", ""], ["i", 8, "far", 3, "ngbTooltip", "", 3, "ngbDropdownToggle", ""]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IconAriaAttributesDirective, [{
        type: Directive,
        args: [{
                selector: 'i.fa:not([ngbTooltip]):not([ngbDropdownToggle]), i.fal:not([ngbTooltip]):not([ngbDropdownToggle]), i.fas:not([ngbTooltip]):not([ngbDropdownToggle]), i.far:not([ngbTooltip]):not([ngbDropdownToggle])'
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, null); })();

class MaximumHeightContextService {
    constructor(stringFormatUtilityService) {
        this.stringFormatUtilityService = stringFormatUtilityService;
    }
    getHeightSelectorsData$(rootElement, parentElementIdentifier, heightSelectorsToCompare, domChange, resizeChange) {
        return new Observable(subscriber => {
            let removedHeightSelector;
            let heightSelectorRecord = {};
            const mutationObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    mutation.addedNodes.forEach((node) => {
                        const parentElement = node?.firstChild?.parentElement;
                        const elementIdentifier = this.getElementIdentifier(parentElement, parentElementIdentifier);
                        if (elementIdentifier) {
                            heightSelectorRecord[elementIdentifier] = this.getHeightSelectors(parentElement, heightSelectorsToCompare);
                            subscriber.next(heightSelectorRecord);
                        }
                    });
                    mutation.removedNodes.forEach((node) => {
                        const parentElement = node?.firstChild?.parentElement;
                        const elementIdentifier = this.getElementIdentifier(parentElement, parentElementIdentifier);
                        if (elementIdentifier) {
                            ({ [elementIdentifier]: removedHeightSelector, ...heightSelectorRecord } = heightSelectorRecord);
                            subscriber.next(heightSelectorRecord);
                        }
                    });
                });
                domChange.emit(mutations);
            });
            mutationObserver.observe(rootElement, { childList: true });
            return () => {
                mutationObserver.disconnect();
            };
        }).pipe(switchMap(heightSelectorRecord => this.getResizeEntries$(heightSelectorRecord, resizeChange)), map(heightSelectors => this.getUpdatedHeightSelectorsDataWithDeltaHeight(heightSelectors, heightSelectorsToCompare)), distinctUntilChanged(_isEqual));
    }
    getResizeEntries$(heightSelectorRecord, resizeChange) {
        if (heightSelectorRecord && Object.keys(heightSelectorRecord).length > 1) {
            const heightSelectors = Object.values(heightSelectorRecord);
            const heightSelectorsData = heightSelectors.reduce((selectedElementAcc, heightSelector) => selectedElementAcc.concat(...Object.values(heightSelector)), []);
            if (heightSelectorsData.length > 1) {
                return new Observable(subscriber => {
                    const resizeObserver = new ResizeObserver(entries => {
                        subscriber.next(heightSelectors);
                        resizeChange.emit(entries);
                    });
                    // Observe one or multiple elements
                    for (const { selectedElement } of heightSelectorsData) {
                        resizeObserver.observe(selectedElement);
                    }
                    return () => {
                        resizeObserver.disconnect();
                    };
                });
            }
        }
        return of([]);
    }
    getElementIdentifier(parentElement, parentElementIdentifier) {
        const dataProperty = this.stringFormatUtilityService.convertToCamelCase(parentElementIdentifier);
        return parentElement?.dataset[dataProperty] ?? '';
    }
    getHeightSelectors(parentElement, heightSelectorsToCompare) {
        const defaultHeightSelector = {};
        if (parentElement && heightSelectorsToCompare?.length) {
            return heightSelectorsToCompare.reduce((heightSelectors, selector) => {
                const selectedElement = parentElement.querySelector(`.${selector}`);
                if (selectedElement) {
                    heightSelectors[selector] = {
                        selectedElement,
                        originalMarginBottom: this.getParsedNumber(getComputedStyle(selectedElement)?.marginBottom)
                    };
                }
                return heightSelectors;
            }, defaultHeightSelector);
        }
        return defaultHeightSelector;
    }
    getUpdatedHeightSelectorsDataWithDeltaHeight(heightSelectors, heightSelectorsToCompare) {
        const maximumHeightRecord = heightSelectorsToCompare.reduce((_maximumHeightRecord, selector) => {
            _maximumHeightRecord[selector] = this.getMaximumHeight(heightSelectors.map(heightSelector => heightSelector[selector]?.selectedElement?.clientHeight ?? 0));
            return _maximumHeightRecord;
        }, {});
        return heightSelectors.reduce((updatedHeightSelectors, heightSelector) => {
            const updatedHeightSelector = {};
            for (const selector of heightSelectorsToCompare) {
                updatedHeightSelector[selector] = {
                    ...heightSelector[selector],
                    deltaHeight: this.getDeltaHeight(heightSelector[selector]?.selectedElement?.clientHeight, maximumHeightRecord[selector])
                };
            }
            updatedHeightSelectors.push(updatedHeightSelector);
            return updatedHeightSelectors;
        }, []);
    }
    getDeltaHeight(clientHeight, maximumHeight) {
        const deltaHeight = Math.abs(maximumHeight - clientHeight);
        return !Number.isNaN(deltaHeight) && deltaHeight > 0 ? deltaHeight : null;
    }
    getParsedNumber(dataValue) {
        const parsedValue = parseFloat(dataValue);
        return !Number.isNaN(parsedValue) ? parsedValue : 0;
    }
    getMaximumHeight(heights) {
        return Math.max(...heights, 0);
    }
}
MaximumHeightContextService.ɵfac = function MaximumHeightContextService_Factory(t) { return new (t || MaximumHeightContextService)(i0.ɵɵinject(i1.StringFormatUtilityService)); };
MaximumHeightContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MaximumHeightContextService, factory: MaximumHeightContextService.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], MaximumHeightContextService.prototype, "getDeltaHeight", null);
__decorate([
    Memoize()
], MaximumHeightContextService.prototype, "getParsedNumber", null);
__decorate([
    Memoize()
], MaximumHeightContextService.prototype, "getMaximumHeight", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MaximumHeightContextService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.StringFormatUtilityService }]; }, { getDeltaHeight: [], getParsedNumber: [], getMaximumHeight: [] }); })();

const MARGIN_BOTTOM_PROPERTY = 'margin-bottom';

class MaximumHeightDirective {
    constructor(elementRef, renderer, maximumHeightContextService) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.maximumHeightContextService = maximumHeightContextService;
        // List of selectors (CSS classes) used to query the elements within the parent element for comparison.
        this.heightSelectorsToCompare = [];
        // Used to identify the parent of the element that contains the selector to obtain the height for comparison.
        // Note: We look this identifier in the element's dataset and it should be camelCase format. For example:
        // To specify the identifier, we use the attribute binding syntax in the parent element [attr.data-attribute-you-are-targeting]="value"
        // To retrieve the value, we pass the identifier in kebab-case format [parentElementIdentifier]="'attribute-you-are-targeting'"
        // Notice we don't prepend the identifier with 'data' when we pass it to the input
        this.parentElementIdentifier = '';
        // Emits any DOM changes in the child list of the root element enhanced with this directive
        this.domChange = new EventEmitter();
        // Emits any resize changes in the child list of the root element enhanced with this directive
        this.resizeChange = new EventEmitter();
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.subscriptions.add(this.maximumHeightContextService
            .getHeightSelectorsData$(this.elementRef.nativeElement, this.parentElementIdentifier, this.heightSelectorsToCompare, this.domChange, this.resizeChange)
            .subscribe(heightSelectors => {
            for (const heightSelector of heightSelectors) {
                const heightSelectorsData = Object.values(heightSelector);
                for (const { deltaHeight, originalMarginBottom, selectedElement } of heightSelectorsData) {
                    if (deltaHeight) {
                        this.renderer.setStyle(selectedElement, MARGIN_BOTTOM_PROPERTY, `${deltaHeight + originalMarginBottom}px`, RendererStyleFlags2.Important);
                    }
                    else if (selectedElement.getAttribute('style')?.includes(MARGIN_BOTTOM_PROPERTY)) {
                        this.renderer.removeStyle(selectedElement, MARGIN_BOTTOM_PROPERTY);
                    }
                }
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
MaximumHeightDirective.ɵfac = function MaximumHeightDirective_Factory(t) { return new (t || MaximumHeightDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(MaximumHeightContextService)); };
MaximumHeightDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: MaximumHeightDirective, selectors: [["", "vnextMaximumHeight", ""]], inputs: { heightSelectorsToCompare: "heightSelectorsToCompare", parentElementIdentifier: "parentElementIdentifier" }, outputs: { domChange: "domChange", resizeChange: "resizeChange" }, features: [i0.ɵɵProvidersFeature([MaximumHeightContextService])] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MaximumHeightDirective, [{
        type: Directive,
        args: [{
                selector: '[vnextMaximumHeight]',
                providers: [MaximumHeightContextService]
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: MaximumHeightContextService }]; }, { heightSelectorsToCompare: [{
            type: Input
        }], parentElementIdentifier: [{
            type: Input
        }], domChange: [{
            type: Output
        }], resizeChange: [{
            type: Output
        }] }); })();

const VNEXT_DIRECTIVES_EXPORTS = [
    GoogleTagManagerDirective,
    HighlightDifferencesDirective,
    IconAriaAttributesDirective,
    MaximumHeightDirective,
    RangeSliderDirective,
    HideMissingImageDirective
];
const VNEXT_DIRECTIVES_DECLARATIONS = [...VNEXT_DIRECTIVES_EXPORTS];

class DirectivesModule {
}
DirectivesModule.ɵfac = function DirectivesModule_Factory(t) { return new (t || DirectivesModule)(); };
DirectivesModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: DirectivesModule });
DirectivesModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DirectivesModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: VNEXT_DIRECTIVES_DECLARATIONS,
                exports: VNEXT_DIRECTIVES_EXPORTS,
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DirectivesModule, { declarations: [GoogleTagManagerDirective, HighlightDifferencesDirective, IconAriaAttributesDirective, MaximumHeightDirective, RangeSliderDirective, HideMissingImageDirective], imports: [CommonModule], exports: [GoogleTagManagerDirective, HighlightDifferencesDirective, IconAriaAttributesDirective, MaximumHeightDirective, RangeSliderDirective, HideMissingImageDirective] }); })();

class EllipsisPipe {
    constructor() {
        this.ELLIPSIS = '...';
    }
    transform(value, ellipsisMaxLength = 10) {
        return value?.length > ellipsisMaxLength ? this.addEllipsis(value, ellipsisMaxLength) : value;
    }
    addEllipsis(value, ellipsisMaxLength) {
        return `${value.substring(0, ellipsisMaxLength - this.ELLIPSIS.length)}${this.ELLIPSIS}`;
    }
}
EllipsisPipe.ɵfac = function EllipsisPipe_Factory(t) { return new (t || EllipsisPipe)(); };
EllipsisPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "ellipsis", type: EllipsisPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EllipsisPipe, [{
        type: Pipe,
        args: [{ name: 'ellipsis' }]
    }], null, null); })();

class PhonePipe {
    transform(phoneValue, country) {
        try {
            const phoneNumber = parsePhoneNumber(phoneValue, country);
            return phoneNumber.formatNational();
        }
        catch (error) {
            return phoneValue;
        }
    }
}
PhonePipe.ɵfac = function PhonePipe_Factory(t) { return new (t || PhonePipe)(); };
PhonePipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "phone", type: PhonePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PhonePipe, [{
        type: Pipe,
        args: [{ name: 'phone' }]
    }], null, null); })();

class CustomCurrencyPipe {
    constructor(currencyPipe) {
        this.currencyPipe = currencyPipe;
    }
    transform(value, currencyCode = 'USD', display = 'symbol', digitsInfo = '1.2-2', locale = 'en-US') {
        // Use the built-in currency pipe to format the value
        const formattedValue = this.currencyPipe.transform(value, currencyCode, display === 'symbol', digitsInfo, locale);
        // Remove '.00' if it exists
        if (formattedValue && formattedValue.endsWith('.00')) {
            return formattedValue.slice(0, -3);
        }
        return formattedValue;
    }
}
CustomCurrencyPipe.ɵfac = function CustomCurrencyPipe_Factory(t) { return new (t || CustomCurrencyPipe)(i0.ɵɵdirectiveInject(i1$2.CurrencyPipe, 16)); };
CustomCurrencyPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "customCurrency", type: CustomCurrencyPipe, pure: true });
CustomCurrencyPipe.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CustomCurrencyPipe, factory: CustomCurrencyPipe.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomCurrencyPipe, [{
        type: Pipe,
        args: [{
                name: 'customCurrency'
            }]
    }, {
        type: Injectable
    }], function () { return [{ type: i1$2.CurrencyPipe }]; }, null); })();

/**
 * Wrapping DatePipe so that the template syntax for using just value and
 * locale is less verbose.
 */
class LocaleDatePipe {
    constructor(datePipe) {
        this.datePipe = datePipe;
    }
    transform(value, locale) {
        return this.datePipe.transform(value, 'MM/dd/yyyy hh:mm a', undefined, locale);
    }
}
LocaleDatePipe.ɵfac = function LocaleDatePipe_Factory(t) { return new (t || LocaleDatePipe)(i0.ɵɵdirectiveInject(i1$2.DatePipe, 16)); };
LocaleDatePipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "localeDate", type: LocaleDatePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocaleDatePipe, [{
        type: Pipe,
        args: [{ name: 'localeDate' }]
    }], function () { return [{ type: i1$2.DatePipe }]; }, null); })();

/*
  Taken from ngx-oder-pipe when we upgraded to Angular 12 as pulling in the
  dependency was causing compatability issues.
*/
class OrderPipe {
    /**
     * Check if a value is a string
     *
     * @param value
     */
    static isString(value) {
        return typeof value === 'string' || value instanceof String;
    }
    /**
     * Sorts values ignoring the case
     *
     * @param a
     * @param b
     */
    static caseInsensitiveSort(a, b) {
        if (OrderPipe.isString(a) && OrderPipe.isString(b)) {
            return a.localeCompare(b);
        }
        return OrderPipe.defaultCompare(a, b);
    }
    /**
     * Default compare method
     *
     * @param a
     * @param b
     */
    static defaultCompare(a, b) {
        if (a && a instanceof Date) {
            a = a.getTime();
        }
        if (b && b instanceof Date) {
            b = b.getTime();
        }
        if (a === b) {
            return 0;
        }
        if (a == null) {
            return 1;
        }
        if (b == null) {
            return -1;
        }
        return a > b ? 1 : -1;
    }
    /**
     * Parse expression, split into items
     * @param expression
     * @returns {string[]}
     */
    static parseExpression(expression) {
        expression = expression.replace(/\[(\w+)\]/g, '.$1');
        expression = expression.replace(/^\./, '');
        return expression.split('.');
    }
    /**
     * Get value by expression
     *
     * @param object
     * @param expression
     * @returns {any}
     */
    static getValue(object, expression) {
        for (let i = 0, n = expression.length; i < n; ++i) {
            if (!object) {
                return;
            }
            const k = expression[i];
            if (!(k in object)) {
                return;
            }
            if (typeof object[k] === 'function') {
                object = object[k]();
            }
            else {
                object = object[k];
            }
        }
        return object;
    }
    /**
     * Set value by expression
     *
     * @param object
     * @param value
     * @param expression
     */
    static setValue(object, value, expression) {
        let i;
        for (i = 0; i < expression.length - 1; i++) {
            object = object[expression[i]];
        }
        object[expression[i]] = value;
    }
    transform(value, expression, reverse, isCaseInsensitive = false, comparator) {
        if (!value) {
            return value;
        }
        if (Array.isArray(expression)) {
            return this.multiExpressionTransform(value, expression.slice(), reverse, isCaseInsensitive, comparator);
        }
        if (Array.isArray(value)) {
            return this.sortArray(value.slice(), expression, reverse, isCaseInsensitive, comparator);
        }
        if (typeof value === 'object') {
            return this.transformObject(Object.assign({}, value), expression, reverse, isCaseInsensitive, comparator);
        }
        return value;
    }
    /**
     * Sort array, returns sorted array
     *
     * @param array
     * @param expression
     * @param reverse
     * @param isCaseInsensitive
     * @param comparator
     * @returns {Type[]}
     */
    sortArray(array, expression, reverse, isCaseInsensitive, comparator) {
        const isDeepLink = expression && expression.indexOf('.') !== -1;
        if (isDeepLink) {
            expression = OrderPipe.parseExpression(expression);
        }
        let compareFn;
        if (comparator && typeof comparator === 'function') {
            compareFn = comparator;
        }
        else {
            compareFn = isCaseInsensitive ? OrderPipe.caseInsensitiveSort : OrderPipe.defaultCompare;
        }
        const sortedArray = array.sort((a, b) => {
            if (!expression) {
                return compareFn(a, b);
            }
            if (!isDeepLink) {
                if (a && b) {
                    return compareFn(a[expression], b[expression]);
                }
                return compareFn(a, b);
            }
            return compareFn(OrderPipe.getValue(a, expression), OrderPipe.getValue(b, expression));
        });
        if (reverse) {
            return sortedArray.reverse();
        }
        return sortedArray;
    }
    /**
     * Transform Object
     *
     * @param value
     * @param expression
     * @param reverse
     * @param isCaseInsensitive
     * @param comparator
     * @returns {any[]}
     */
    transformObject(value, expression, reverse, isCaseInsensitive, comparator) {
        const parsedExpression = OrderPipe.parseExpression(expression);
        let lastPredicate = parsedExpression.pop();
        let oldValue = OrderPipe.getValue(value, parsedExpression);
        if (!Array.isArray(oldValue)) {
            parsedExpression.push(lastPredicate);
            lastPredicate = null;
            oldValue = OrderPipe.getValue(value, parsedExpression);
        }
        if (!oldValue) {
            return value;
        }
        OrderPipe.setValue(value, this.transform(oldValue, lastPredicate, reverse, isCaseInsensitive), parsedExpression);
        return value;
    }
    /**
     * Apply multiple expressions
     *
     * @param value
     * @param {any[]} expressions
     * @param {boolean} reverse
     * @param {boolean} isCaseInsensitive
     * @param {Function} comparator
     * @returns {any}
     */
    multiExpressionTransform(value, expressions, reverse, isCaseInsensitive = false, comparator) {
        return expressions.reverse().reduce((result, expression) => {
            return this.transform(result, expression, reverse, isCaseInsensitive, comparator);
        }, value);
    }
}
OrderPipe.ɵfac = function OrderPipe_Factory(t) { return new (t || OrderPipe)(); };
OrderPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "orderBy", type: OrderPipe, pure: false });
OrderPipe.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: OrderPipe, factory: OrderPipe.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OrderPipe, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }, {
        type: Pipe,
        args: [{
                name: 'orderBy',
                pure: false
            }]
    }], null, null); })();

class RateFactorAppliedPipe {
    transform(rateFactors, rateFactor) {
        return rateFactors && rateFactors.length && rateFactors.includes(rateFactor || PAYMENT_METHOD_RATE_FACTOR_IDENTIFIER);
    }
}
RateFactorAppliedPipe.ɵfac = function RateFactorAppliedPipe_Factory(t) { return new (t || RateFactorAppliedPipe)(); };
RateFactorAppliedPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "rateFactorApplied", type: RateFactorAppliedPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RateFactorAppliedPipe, [{
        type: Pipe,
        args: [{
                name: 'rateFactorApplied'
            }]
    }], null, null); })();

// WARNING - if you are using this pipe to bypass sanitization of user provided content,
// you may be opening up the application cross site scripting attacks! This pipe should
// only be used with values that come from trusted sources.
class SafePipe {
    constructor(domSanitizer) {
        this.domSanitizer = domSanitizer;
    }
    transform(value, sanitizationMethod) {
        if (value) {
            switch (sanitizationMethod) {
                case 'css':
                    return this.domSanitizer.bypassSecurityTrustStyle(value);
                case 'html':
                default:
                    return this.domSanitizer.bypassSecurityTrustHtml(value);
                case 'resource-url':
                    return this.domSanitizer.bypassSecurityTrustResourceUrl(value);
                case 'script':
                    return this.domSanitizer.bypassSecurityTrustScript(value);
                case 'url':
                    return this.domSanitizer.bypassSecurityTrustUrl(value);
            }
        }
        return value;
    }
}
SafePipe.ɵfac = function SafePipe_Factory(t) { return new (t || SafePipe)(i0.ɵɵdirectiveInject(i1$3.DomSanitizer, 16)); };
SafePipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "safe", type: SafePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SafePipe, [{
        type: Pipe,
        args: [{
                name: 'safe'
            }]
    }], function () { return [{ type: i1$3.DomSanitizer }]; }, null); })();

/**
 * Shorten display name (SPA-2506)
 *
 * If first+last Name is longer than 13 characters (fullNameMaxLength), only show first name.
 * If first name is longer than 13 characters (firstNameMaxLength), show ellipsis at 10 characters (ellipsisMaxLength)
 */
class ShortNamePipe {
    constructor(ellipsisPipe) {
        this.ellipsisPipe = ellipsisPipe;
    }
    transform(fullName, fullNameMaxLength = 13, firstNameMaxLength = 13) {
        let firstName = fullName.length > fullNameMaxLength ? fullName.split(' ')[0] : null;
        if (firstName?.length <= firstNameMaxLength) {
            return firstName;
        }
        if (firstName?.length > firstNameMaxLength) {
            return this.ellipsisPipe.transform(firstName, firstNameMaxLength);
        }
        return fullName;
    }
}
ShortNamePipe.ɵfac = function ShortNamePipe_Factory(t) { return new (t || ShortNamePipe)(i0.ɵɵdirectiveInject(EllipsisPipe, 16)); };
ShortNamePipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "shortName", type: ShortNamePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShortNamePipe, [{
        type: Pipe,
        args: [{ name: 'shortName' }]
    }], function () { return [{ type: EllipsisPipe }]; }, null); })();

class TrimTextPipe {
    transform(originalText, textMaxLength) {
        if (textMaxLength) {
            return this.trimText(originalText, textMaxLength);
        }
        return originalText;
    }
    trimText(label, displayLabelMaxWidth) {
        return label.length > displayLabelMaxWidth ? `${label.substr(0, displayLabelMaxWidth - 3)}...` : label;
    }
}
TrimTextPipe.ɵfac = function TrimTextPipe_Factory(t) { return new (t || TrimTextPipe)(); };
TrimTextPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "trimText", type: TrimTextPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TrimTextPipe, [{
        type: Pipe,
        args: [{ name: 'trimText' }]
    }], null, null); })();

const VNEXT_PIPE_EXPORTS = [
    LocaleDatePipe,
    SafePipe,
    TrimTextPipe,
    PhonePipe,
    ShortNamePipe,
    RateFactorAppliedPipe,
    EllipsisPipe,
    OrderPipe,
    CustomCurrencyPipe
];
const VNEXT_PIPE_DECLARATIONS = [...VNEXT_PIPE_EXPORTS];

class PipesModule {
}
PipesModule.ɵfac = function PipesModule_Factory(t) { return new (t || PipesModule)(); };
PipesModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PipesModule });
PipesModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [DatePipe, EllipsisPipe, PhonePipe] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PipesModule, [{
        type: NgModule,
        args: [{
                declarations: VNEXT_PIPE_DECLARATIONS,
                exports: VNEXT_PIPE_EXPORTS,
                providers: [DatePipe, EllipsisPipe, PhonePipe]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PipesModule, { declarations: [LocaleDatePipe, SafePipe, TrimTextPipe, PhonePipe, ShortNamePipe, RateFactorAppliedPipe, EllipsisPipe, OrderPipe, CustomCurrencyPipe], exports: [LocaleDatePipe, SafePipe, TrimTextPipe, PhonePipe, ShortNamePipe, RateFactorAppliedPipe, EllipsisPipe, OrderPipe, CustomCurrencyPipe] }); })();

class AgentCallRecordingShoppingBoxComponent {
    constructor() {
        this.viewRecording = new EventEmitter();
    }
    onViewRecordingClick() {
        this.viewRecording.emit();
    }
}
AgentCallRecordingShoppingBoxComponent.ɵfac = function AgentCallRecordingShoppingBoxComponent_Factory(t) { return new (t || AgentCallRecordingShoppingBoxComponent)(); };
AgentCallRecordingShoppingBoxComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentCallRecordingShoppingBoxComponent, selectors: [["vnext-agent-call-recording-shopping-box"]], inputs: { agentCallRecordingShoppingHeaderText: "agentCallRecordingShoppingHeaderText", agentCallRecordingShoppingSectionText: "agentCallRecordingShoppingSectionText", agentCallRecordingShoppingLinkText: "agentCallRecordingShoppingLinkText" }, outputs: { viewRecording: "viewRecording" }, decls: 10, vars: 12, consts: [[1, "mb-2", "mb-sm-2", "px-2"], [1, "Spa_Style_H2", "call-recording-header", 3, "innerHtml"], [1, "call-recording-content"], [1, "Spa_Style_Paragraph", 3, "innerHtml"], [1, "Spa_Style_Link", "can-click", "d-inline", 3, "click"], [1, "pr-1", 3, "innerHtml"], [1, "fa", "fa-angle-right"]], template: function AgentCallRecordingShoppingBoxComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "h2", 1);
        i0.ɵɵpipe(2, "safe");
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵelement(4, "span", 3);
        i0.ɵɵpipe(5, "safe");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵlistener("click", function AgentCallRecordingShoppingBoxComponent_Template_div_click_6_listener() { return ctx.onViewRecordingClick(); });
        i0.ɵɵelement(7, "span", 5);
        i0.ɵɵpipe(8, "safe");
        i0.ɵɵelement(9, "i", 6);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(2, 3, ctx.agentCallRecordingShoppingHeaderText, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(5, 6, ctx.agentCallRecordingShoppingSectionText, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(8, 9, ctx.agentCallRecordingShoppingLinkText, "html"), i0.ɵɵsanitizeHtml);
    } }, dependencies: [IconAriaAttributesDirective, SafePipe], styles: [".call-recording-header[_ngcontent-%COMP%]{padding-bottom:6px}.call-recording-content[_ngcontent-%COMP%]{margin-top:0;margin-bottom:1rem}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentCallRecordingShoppingBoxComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-call-recording-shopping-box', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"mb-2 mb-sm-2 px-2\">\r\n  <h2 [innerHtml]=\"agentCallRecordingShoppingHeaderText | safe: 'html'\" class=\"Spa_Style_H2 call-recording-header\"></h2>\r\n  <div class=\"call-recording-content\">\r\n    <span [innerHtml]=\"agentCallRecordingShoppingSectionText | safe: 'html'\" class=\"Spa_Style_Paragraph\">\r\n    </span>\r\n  </div>\r\n  <div class=\"Spa_Style_Link can-click d-inline\" (click)= \"onViewRecordingClick()\">\r\n    <span [innerHtml]=\"agentCallRecordingShoppingLinkText | safe: 'html'\" class=\"pr-1\"></span>\r\n    <i class=\"fa fa-angle-right\"></i>\r\n  </div>\r\n</div>", styles: [".call-recording-header{padding-bottom:6px}.call-recording-content{margin-top:0;margin-bottom:1rem}\n"] }]
    }], null, { agentCallRecordingShoppingHeaderText: [{
            type: Input
        }], agentCallRecordingShoppingSectionText: [{
            type: Input
        }], agentCallRecordingShoppingLinkText: [{
            type: Input
        }], viewRecording: [{
            type: Output
        }] }); })();

function LinkComponent_div_0_1_ng_template_0_Template(rf, ctx) { }
function LinkComponent_div_0_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, LinkComponent_div_0_1_ng_template_0_Template, 0, 0, "ng-template");
} }
const _c0$40 = function (a0, a1) { return { "d-inline": a0, "d-inline-block": a1 }; };
function LinkComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, LinkComponent_div_0_1_Template, 1, 0, null, 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r11 = i0.ɵɵreference(12);
    const _r9 = i0.ɵɵreference(10);
    i0.ɵɵclassMap(ctx_r0.customClass);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c0$40, ctx_r0.makeInline, ctx_r0.makeInlineBlock));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isLiveEdit)("ngIfThen", _r11)("ngIfElse", _r9);
} }
const _c1$29 = function (a0) { return { color: a0 }; };
function LinkComponent_div_1_span_5_i_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 13);
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c1$29, ctx_r17.iconColor));
} }
function LinkComponent_div_1_span_5_i_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 14);
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("", ctx_r18.additionalIcon, " pr-1");
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(4, _c1$29, ctx_r18.iconColor));
} }
function LinkComponent_div_1_span_5_3_ng_template_0_Template(rf, ctx) { }
function LinkComponent_div_1_span_5_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, LinkComponent_div_1_span_5_3_ng_template_0_Template, 0, 0, "ng-template");
} }
function LinkComponent_div_1_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, LinkComponent_div_1_span_5_i_1_Template, 1, 3, "i", 11);
    i0.ɵɵtemplate(2, LinkComponent_div_1_span_5_i_2_Template, 1, 6, "i", 12);
    i0.ɵɵtemplate(3, LinkComponent_div_1_span_5_3_Template, 1, 0, null, 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    const _r5 = i0.ɵɵreference(6);
    const _r7 = i0.ɵɵreference(8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.showArrow === "left" || ctx_r16.showArrow === "both");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.additionalIcon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.liveEditEnabled)("ngIfThen", _r5)("ngIfElse", _r7);
} }
const _c2$1k = function (a0, a1, a2, a3, a4) { return { "always-underline": a0, "d-inline": a1, "d-inline-block": a2, "no-underline-on-hover": a3, "disabled": a4 }; };
function LinkComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "a", 8)(2, "div", null, 9);
    i0.ɵɵprojection(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, LinkComponent_div_1_span_5_Template, 4, 5, "span", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r15 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.customClass);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(13, _c0$40, ctx_r1.makeInline, ctx_r1.makeInlineBlock));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("href", ctx_r1.href, i0.ɵɵsanitizeUrl)("target", ctx_r1.linkTarget)("rel", ctx_r1.linkTarget && ctx_r1.linkTarget === "_blank" ? "opener" : null)("ngClass", i0.ɵɵpureFunction5(16, _c2$1k, ctx_r1.alwaysUnderlined, ctx_r1.makeInline, ctx_r1.makeInlineBlock, ctx_r1.noUnderlineOnHover, ctx_r1.disabled))("tabindex", ctx_r1.disabled ? -1 : 0);
    i0.ɵɵattribute("role", ctx_r1.role && ctx_r1.canShowRoleAttribute ? ctx_r1.role : null)("aria-describedby", ctx_r1.ariaDescribedByText ? ctx_r1.ariaDescribedByText : null)("aria-label", ctx_r1.ariaLabel ? ctx_r1.ariaLabel : null);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !_r15.children.length);
} }
function LinkComponent_div_2_a_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c3$Y = function (a0, a1, a2, a3, a4) { return { "always-underline": a0, "d-inline": a1, "d-inline-block": a2, "disabled": a3, "no-underline-on-hover": a4 }; };
function LinkComponent_div_2_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 17);
    i0.ɵɵtemplate(1, LinkComponent_div_2_a_1_ng_container_1_Template, 1, 0, "ng-container", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction5(7, _c3$Y, ctx_r21.alwaysUnderlined, ctx_r21.makeInline, ctx_r21.makeInlineBlock, ctx_r21.disabled, ctx_r21.noUnderlineOnHover))("tabindex", ctx_r21.disabled ? -1 : 0);
    i0.ɵɵattribute("role", ctx_r21.role ? ctx_r21.role : null)("aria-describedby", ctx_r21.ariaDescribedByText ? ctx_r21.ariaDescribedByText : null)("aria-label", ctx_r21.ariaLabel ? ctx_r21.ariaLabel : null)("aria-haspopup", ctx_r21.ariaHasPopup ? ctx_r21.ariaHasPopup : null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function LinkComponent_div_2_ng_template_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function LinkComponent_div_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function LinkComponent_div_2_ng_template_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r26.onClick()); })("keydown.space", function LinkComponent_div_2_ng_template_2_Template_button_keydown_space_0_listener() { i0.ɵɵrestoreView(_r27); const ctx_r28 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r28.onClick()); });
    i0.ɵɵtemplate(1, LinkComponent_div_2_ng_template_2_ng_container_1_Template, 1, 0, "ng-container", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵclassMapInterpolate1("btn-reset Spa_Style_Link ", ctx_r23.customClass, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction5(10, _c3$Y, ctx_r23.alwaysUnderlined, ctx_r23.makeInline, ctx_r23.makeInlineBlock, ctx_r23.disabled, ctx_r23.noUnderlineOnHover))("tabindex", ctx_r23.disabled ? -1 : 0);
    i0.ɵɵattribute("role", ctx_r23.role ? ctx_r23.role : null)("aria-describedby", ctx_r23.ariaDescribedByText ? ctx_r23.ariaDescribedByText : null)("aria-label", ctx_r23.ariaLabel ? ctx_r23.ariaLabel : null)("aria-haspopup", ctx_r23.ariaHasPopup ? ctx_r23.ariaHasPopup : null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function LinkComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, LinkComponent_div_2_a_1_Template, 2, 13, "a", 15);
    i0.ɵɵtemplate(2, LinkComponent_div_2_ng_template_2_Template, 2, 16, "ng-template", null, 16, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r22 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r2.customClass);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c0$40, ctx_r2.makeInline, ctx_r2.makeInlineBlock));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isLinkButton)("ngIfElse", _r22);
} }
function LinkComponent_ng_template_3_span_3_i_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 13);
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c1$29, ctx_r31.iconColor));
} }
function LinkComponent_ng_template_3_span_3_i_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 14);
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("", ctx_r32.additionalIcon, " pr-1");
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(4, _c1$29, ctx_r32.iconColor));
} }
function LinkComponent_ng_template_3_span_3_3_ng_template_0_Template(rf, ctx) { }
function LinkComponent_ng_template_3_span_3_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, LinkComponent_ng_template_3_span_3_3_ng_template_0_Template, 0, 0, "ng-template");
} }
function LinkComponent_ng_template_3_span_3_i_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 21);
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c1$29, ctx_r34.iconColor));
} }
function LinkComponent_ng_template_3_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, LinkComponent_ng_template_3_span_3_i_1_Template, 1, 3, "i", 11);
    i0.ɵɵtemplate(2, LinkComponent_ng_template_3_span_3_i_2_Template, 1, 6, "i", 12);
    i0.ɵɵtemplate(3, LinkComponent_ng_template_3_span_3_3_Template, 1, 0, null, 7);
    i0.ɵɵtemplate(4, LinkComponent_ng_template_3_span_3_i_4_Template, 1, 3, "i", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(2);
    const _r5 = i0.ɵɵreference(6);
    const _r7 = i0.ɵɵreference(8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r30.showArrow === "left" || ctx_r30.showArrow === "both");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r30.additionalIcon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r30.liveEditEnabled)("ngIfThen", _r5)("ngIfElse", _r7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r30.showArrow === "right" || ctx_r30.showArrow === "both");
} }
function LinkComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", null, 9);
    i0.ɵɵprojection(2, 1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, LinkComponent_ng_template_3_span_3_Template, 5, 6, "span", 10);
} if (rf & 2) {
    const _r29 = i0.ɵɵreference(1);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !_r29.children.length);
} }
function LinkComponent_ng_template_5_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(2);
    let tmp_0_0;
    i0.ɵɵclassMap((tmp_0_0 = ctx_r36.titleClass) !== null && tmp_0_0 !== undefined ? tmp_0_0 : ctx_r36.customClass);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r36.title);
} }
function LinkComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, LinkComponent_ng_template_5_span_0_Template, 2, 4, "span", 22);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("liveEditProp", ctx_r6.keyNameForLiveEdit);
} }
function LinkComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    let tmp_0_0;
    i0.ɵɵclassMap((tmp_0_0 = ctx_r8.titleClass) !== null && tmp_0_0 !== undefined ? tmp_0_0 : ctx_r8.customClass);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r8.title);
} }
function LinkComponent_ng_template_9_span_4_i_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 13);
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c1$29, ctx_r39.iconColor));
} }
function LinkComponent_ng_template_9_span_4_i_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 14);
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("", ctx_r40.additionalIcon, " pr-1");
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(4, _c1$29, ctx_r40.iconColor));
} }
function LinkComponent_ng_template_9_span_4_3_ng_template_0_Template(rf, ctx) { }
function LinkComponent_ng_template_9_span_4_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, LinkComponent_ng_template_9_span_4_3_ng_template_0_Template, 0, 0, "ng-template");
} }
function LinkComponent_ng_template_9_span_4_i_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 21);
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c1$29, ctx_r42.iconColor));
} }
function LinkComponent_ng_template_9_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, LinkComponent_ng_template_9_span_4_i_1_Template, 1, 3, "i", 11);
    i0.ɵɵtemplate(2, LinkComponent_ng_template_9_span_4_i_2_Template, 1, 6, "i", 12);
    i0.ɵɵtemplate(3, LinkComponent_ng_template_9_span_4_3_Template, 1, 0, null, 7);
    i0.ɵɵtemplate(4, LinkComponent_ng_template_9_span_4_i_4_Template, 1, 3, "i", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(2);
    const _r5 = i0.ɵɵreference(6);
    const _r7 = i0.ɵɵreference(8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r38.showArrow === "left" || ctx_r38.showArrow === "both");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r38.additionalIcon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r38.liveEditEnabled)("ngIfThen", _r5)("ngIfElse", _r7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r38.showArrow === "right" || ctx_r38.showArrow === "both");
} }
function LinkComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 23);
    i0.ɵɵlistener("click", function LinkComponent_ng_template_9_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r45); const ctx_r44 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r44.onClick()); });
    i0.ɵɵelementStart(1, "div", null, 24);
    i0.ɵɵprojection(3, 2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, LinkComponent_ng_template_9_span_4_Template, 5, 6, "span", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r37 = i0.ɵɵreference(2);
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", !ctx_r10.isLinkButton ? ctx_r10.route : null)("queryParams", !ctx_r10.isLinkButton && ctx_r10.queryParams ? ctx_r10.queryParams : null)("target", ctx_r10.linkTarget)("rel", ctx_r10.linkTarget && ctx_r10.linkTarget === "_blank" ? "opener" : null)("ngClass", i0.ɵɵpureFunction5(10, _c2$1k, ctx_r10.alwaysUnderlined, ctx_r10.makeInline, ctx_r10.makeInlineBlock, ctx_r10.noUnderlineOnHover, ctx_r10.disabled))("tabindex", ctx_r10.disabled ? -1 : 0);
    i0.ɵɵattribute("role", ctx_r10.role ? ctx_r10.role : null)("aria-describedby", ctx_r10.ariaDescribedByText ? ctx_r10.ariaDescribedByText : null)("aria-label", ctx_r10.ariaLabel ? ctx_r10.ariaLabel : null);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !_r37.children.length);
} }
function LinkComponent_ng_template_11_span_4_i_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 13);
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c1$29, ctx_r48.iconColor));
} }
function LinkComponent_ng_template_11_span_4_i_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 14);
} if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("", ctx_r49.additionalIcon, " pr-1");
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(4, _c1$29, ctx_r49.iconColor));
} }
function LinkComponent_ng_template_11_span_4_3_ng_template_0_Template(rf, ctx) { }
function LinkComponent_ng_template_11_span_4_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, LinkComponent_ng_template_11_span_4_3_ng_template_0_Template, 0, 0, "ng-template");
} }
function LinkComponent_ng_template_11_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, LinkComponent_ng_template_11_span_4_i_1_Template, 1, 3, "i", 11);
    i0.ɵɵtemplate(2, LinkComponent_ng_template_11_span_4_i_2_Template, 1, 6, "i", 12);
    i0.ɵɵtemplate(3, LinkComponent_ng_template_11_span_4_3_Template, 1, 0, null, 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(2);
    const _r5 = i0.ɵɵreference(6);
    const _r7 = i0.ɵɵreference(8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r47.showArrow === "left" || ctx_r47.showArrow === "both");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r47.additionalIcon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r47.liveEditEnabled)("ngIfThen", _r5)("ngIfElse", _r7);
} }
function LinkComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 25)(1, "div", null, 24);
    i0.ɵɵprojection(3, 3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, LinkComponent_ng_template_11_span_4_Template, 4, 5, "span", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r46 = i0.ɵɵreference(2);
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction5(3, _c2$1k, ctx_r12.alwaysUnderlined, ctx_r12.makeInline, ctx_r12.makeInlineBlock, ctx_r12.noUnderlineOnHover, ctx_r12.disabled))("tabindex", ctx_r12.disabled ? -1 : 0);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !_r46.children.length);
} }
const _c4$B = [[["", "href-image-body", ""]], [["", "link-body", ""]], [["", "tag-image-body", ""]], [["", "tag-image-body", ""]]];
const _c5$m = ["[href-image-body]", "[link-body]", "[tag-image-body]", "[tag-image-body]"];
class LinkComponent {
    constructor(navigationUtilityService) {
        this.navigationUtilityService = navigationUtilityService;
        // link will always be underlined
        this.alwaysUnderlined = false;
        // determines where to open the link
        this.linkTarget = TargetType.SELF;
        this.keyNameForLiveEdit = '';
        this.additionalIcon = '';
        this.customClass = 'Spa_Style_Link';
        this.iconColor = '';
        this.makeInline = false;
        this.makeInlineBlock = false;
        this.noUnderlineOnHover = false;
        this.disabled = false;
        this.ariaDescribedByText = '';
        this.ariaHasPopup = false;
        this.role = '';
        this.titleClass = '';
        this.isLinkButton = false;
        this.ariaLabel = '';
        this.canShowRoleAttribute = true;
        this.roleLink = 'link';
    }
    ngOnChanges(changes) {
        const { role, href } = changes;
        if ((role && role.currentValue !== role.previousValue) || (href && href.currentValue !== href.previousValue)) {
            if (role?.currentValue === this.roleLink) {
                this.canShowRoleAttribute = false;
            }
        }
    }
    get route() {
        return `/${this.navigationUtilityService.constructHref(this.tag)}`;
    }
    get liveEditEnabled() {
        return this.keyNameForLiveEdit !== '';
    }
    get isLiveEdit() {
        const environment = EnvironmentService.getEnvironment();
        return environment.liveedit;
    }
    onClick() {
        if (this.onClickAction) {
            this.onClickAction();
        }
    }
}
LinkComponent.ɵfac = function LinkComponent_Factory(t) { return new (t || LinkComponent)(i0.ɵɵdirectiveInject(i1.NavigationUtilityService)); };
LinkComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LinkComponent, selectors: [["vnext-link"]], inputs: { title: "title", tag: "tag", href: "href", showArrow: "showArrow", alwaysUnderlined: "alwaysUnderlined", linkTarget: "linkTarget", keyNameForLiveEdit: "keyNameForLiveEdit", additionalIcon: "additionalIcon", customClass: "customClass", iconColor: "iconColor", makeInline: "makeInline", makeInlineBlock: "makeInlineBlock", noUnderlineOnHover: "noUnderlineOnHover", disabled: "disabled", ariaDescribedByText: "ariaDescribedByText", ariaHasPopup: "ariaHasPopup", role: "role", onClickAction: "onClickAction", titleClass: "titleClass", isLinkButton: "isLinkButton", ariaLabel: "ariaLabel", queryParams: "queryParams" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c5$m, decls: 13, vars: 3, consts: [[3, "ngClass", "class", 4, "ngIf"], ["linkDetails", ""], ["liveEdit", ""], ["notLiveEdit", ""], ["enableLinkNavigation", ""], ["disableLinkNavigation", ""], [3, "ngClass"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["navigationAdapter", "", "ngbAutofocus", "", 3, "href", "target", "rel", "ngClass", "tabindex"], ["ref", ""], [4, "ngIf"], ["class", "fa fa-angle-left pr-1", "aria-hidden", "true", 3, "ngStyle", 4, "ngIf"], [3, "class", "ngStyle", 4, "ngIf"], ["aria-hidden", "true", 1, "fa", "fa-angle-left", "pr-1", 3, "ngStyle"], [3, "ngStyle"], ["navigationAdapter", "", "ngbAutofocus", "", 3, "ngClass", "tabindex", 4, "ngIf", "ngIfElse"], ["linkButton", ""], ["navigationAdapter", "", "ngbAutofocus", "", 3, "ngClass", "tabindex"], [4, "ngTemplateOutlet"], ["ngbAutofocus", "", 3, "ngClass", "tabindex", "click", "keydown.space"], ["class", "fa fa-angle-right pl-1", "aria-hidden", "true", 3, "ngStyle", 4, "ngIf"], ["aria-hidden", "true", 1, "fa", "fa-angle-right", "pl-1", 3, "ngStyle"], [3, "class", 4, "liveEditProp"], ["ngbAutofocus", "", 3, "routerLink", "queryParams", "target", "rel", "ngClass", "tabindex", "click"], ["ref1", ""], ["ngbAutofocus", "", 3, "ngClass", "tabindex"]], template: function LinkComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c4$B);
        i0.ɵɵtemplate(0, LinkComponent_div_0_Template, 2, 10, "div", 0);
        i0.ɵɵtemplate(1, LinkComponent_div_1_Template, 6, 22, "div", 0);
        i0.ɵɵtemplate(2, LinkComponent_div_2_Template, 4, 9, "div", 0);
        i0.ɵɵtemplate(3, LinkComponent_ng_template_3_Template, 4, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(5, LinkComponent_ng_template_5_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(7, LinkComponent_ng_template_7_Template, 2, 4, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(9, LinkComponent_ng_template_9_Template, 5, 16, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(11, LinkComponent_ng_template_11_Template, 5, 9, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.tag && !ctx.href);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.href && !ctx.tag);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.href && !ctx.tag);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$2.NgTemplateOutlet, i1$2.NgStyle, i2$1.RouterLink, NavigationAdapterDirective, LiveEditPropDirective, IconAriaAttributesDirective], styles: [".always-underline[_ngcontent-%COMP%]{text-decoration:underline}.fa-angle-right[_ngcontent-%COMP%]{position:relative;top:1px}.no-underline-on-hover[_ngcontent-%COMP%], .no-underline-on-hover[_ngcontent-%COMP%]:hover{text-decoration:none}a[_ngcontent-%COMP%]{cursor:pointer;display:block;color:inherit}a.disabled[_ngcontent-%COMP%]{cursor:default;color:var(--static-Spa_Style_Gray4)}.enable-on-focus[_nghost-%COMP%]   a[_ngcontent-%COMP%]{opacity:0}.enable-on-focus[_nghost-%COMP%]   a[_ngcontent-%COMP%]:focus{opacity:1}.sr-only-link[_nghost-%COMP%]   a[_ngcontent-%COMP%]{border:0;clip:rect(0,0,0,0);height:1px;margin:-4px;overflow:hidden;padding:4px;position:absolute;width:1px}.sr-only-link[_nghost-%COMP%]   a[_ngcontent-%COMP%]:focus{position:static;width:auto;height:auto}@media not all and (min-resolution: .001dpcm){@supports (-webkit-appearance: none) and (stroke-color: transparent){.sr-only-link[_nghost-%COMP%]   a[_ngcontent-%COMP%]{width:auto}}}@media not all and (min-resolution: .001dpcm){@supports (-webkit-appearance: none) and (not (stroke-color: transparent)){.sr-only-link[_nghost-%COMP%]   a[_ngcontent-%COMP%]{width:auto}}}@media screen and (min-color-index: 0) and(-webkit-min-device-pixel-ratio:0){.sr-only-link[_nghost-%COMP%]   a[_ngcontent-%COMP%]{width:auto}}"] });
__decorate([
    LiveEditInactive()
], LinkComponent.prototype, "onClick", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LinkComponent, [{
        type: Component,
        args: [{ selector: 'vnext-link', template: "<div *ngIf=\"tag && !href\" [ngClass]=\"{ 'd-inline': makeInline, 'd-inline-block': makeInlineBlock }\" class=\"{{ customClass }}\">\r\n  <ng-template *ngIf=\"isLiveEdit; then disableLinkNavigation; else enableLinkNavigation\"></ng-template>\r\n</div>\r\n<div *ngIf=\"href && !tag\" [ngClass]=\"{ 'd-inline': makeInline, 'd-inline-block': makeInlineBlock }\" class=\"{{ customClass }}\">\r\n  <a\r\n    navigationAdapter\r\n    [href]=\"href\"\r\n    [target]=\"linkTarget\"\r\n    [rel]=\"linkTarget && linkTarget === '_blank' ? 'opener' : null\"\r\n    [ngClass]=\"{\r\n      'always-underline': alwaysUnderlined,\r\n      'd-inline': makeInline,\r\n      'd-inline-block': makeInlineBlock,\r\n      'no-underline-on-hover': noUnderlineOnHover,\r\n      'disabled': disabled\r\n    }\"\r\n    [tabindex]=\"disabled ? -1 : 0\"\r\n    ngbAutofocus\r\n    [attr.role]=\"role && canShowRoleAttribute ? role : null\"\r\n    [attr.aria-describedby]=\"ariaDescribedByText ? ariaDescribedByText : null\"\r\n    [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\r\n  >\r\n    <div #ref>\r\n      <ng-content select=\"[href-image-body]\"></ng-content>\r\n    </div>\r\n    <span *ngIf=\"!ref.children.length\">\r\n      <i\r\n        *ngIf=\"showArrow === 'left' || showArrow === 'both'\"\r\n        class=\"fa fa-angle-left pr-1\"\r\n        [ngStyle]=\"{ color: iconColor }\"\r\n        aria-hidden=\"true\"\r\n      >\r\n      </i>\r\n      <i *ngIf=\"additionalIcon\" class=\"{{ additionalIcon }} pr-1\" [ngStyle]=\"{ color: iconColor }\"></i>\r\n      <ng-template *ngIf=\"liveEditEnabled; then liveEdit; else notLiveEdit\"> </ng-template>\r\n    </span>\r\n  </a>\r\n</div>\r\n<!-- used for onclick events in the component its called from -->\r\n<div *ngIf=\"!href && !tag\" [ngClass]=\"{ 'd-inline': makeInline, 'd-inline-block': makeInlineBlock }\" class=\"{{ customClass }}\">\r\n  <a\r\n    *ngIf=\"!isLinkButton; else linkButton\"\r\n    navigationAdapter\r\n    [ngClass]=\"{\r\n      'always-underline': alwaysUnderlined,\r\n      'd-inline': makeInline,\r\n      'd-inline-block': makeInlineBlock,\r\n      'disabled': disabled,\r\n      'no-underline-on-hover': noUnderlineOnHover\r\n    }\"\r\n    [tabindex]=\"disabled ? -1 : 0\"\r\n    ngbAutofocus\r\n    [attr.role]=\"role ? role : null\"\r\n    [attr.aria-describedby]=\"ariaDescribedByText ? ariaDescribedByText : null\"\r\n    [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\r\n    [attr.aria-haspopup]=\"ariaHasPopup ? ariaHasPopup : null\"\r\n  >\r\n    <ng-container *ngTemplateOutlet=\"linkDetails\"></ng-container>\r\n  </a>\r\n  <ng-template #linkButton>\r\n    <button\r\n      class=\"btn-reset Spa_Style_Link {{ customClass }}\"\r\n      [ngClass]=\"{\r\n        'always-underline': alwaysUnderlined,\r\n        'd-inline': makeInline,\r\n        'd-inline-block': makeInlineBlock,\r\n        'disabled': disabled,\r\n        'no-underline-on-hover': noUnderlineOnHover\r\n      }\"\r\n      [tabindex]=\"disabled ? -1 : 0\"\r\n      (click)=\"onClick()\"\r\n      (keydown.space)=\"onClick()\"\r\n      ngbAutofocus\r\n      [attr.role]=\"role ? role : null\"\r\n      [attr.aria-describedby]=\"ariaDescribedByText ? ariaDescribedByText : null\"\r\n      [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\r\n      [attr.aria-haspopup]=\"ariaHasPopup ? ariaHasPopup : null\"\r\n    >\r\n      <ng-container *ngTemplateOutlet=\"linkDetails\"></ng-container>\r\n    </button>\r\n  </ng-template>\r\n</div>\r\n\r\n<ng-template #linkDetails>\r\n  <div #ref>\r\n    <ng-content select=\"[link-body]\"></ng-content>\r\n  </div>\r\n  <span *ngIf=\"!ref.children.length\">\r\n    <i\r\n      *ngIf=\"showArrow === 'left' || showArrow === 'both'\"\r\n      class=\"fa fa-angle-left pr-1\"\r\n      [ngStyle]=\"{ color: iconColor }\"\r\n      aria-hidden=\"true\"\r\n    >\r\n    </i>\r\n    <i *ngIf=\"additionalIcon\" class=\"{{ additionalIcon }} pr-1\" [ngStyle]=\"{ color: iconColor }\"></i>\r\n    <ng-template *ngIf=\"liveEditEnabled; then liveEdit; else notLiveEdit\"> </ng-template>\r\n    <i\r\n      *ngIf=\"showArrow === 'right' || showArrow === 'both'\"\r\n      class=\"fa fa-angle-right pl-1\"\r\n      [ngStyle]=\"{ color: iconColor }\"\r\n      aria-hidden=\"true\"\r\n    >\r\n    </i>\r\n  </span>\r\n</ng-template>\r\n\r\n<ng-template #liveEdit>\r\n  <span class=\"{{ titleClass ?? customClass }}\" *liveEditProp=\"keyNameForLiveEdit\">{{ title }}</span>\r\n</ng-template>\r\n<ng-template #notLiveEdit>\r\n  <span class=\"{{ titleClass ?? customClass }}\">{{ title }}</span>\r\n</ng-template>\r\n\r\n<ng-template #enableLinkNavigation>\r\n  <a\r\n    [routerLink]=\"!isLinkButton ? route : null\"\r\n    [queryParams]=\"!isLinkButton && queryParams ? queryParams : null\"\r\n    [target]=\"linkTarget\"\r\n    [rel]=\"linkTarget && linkTarget === '_blank' ? 'opener' : null\"\r\n    [ngClass]=\"{\r\n      'always-underline': alwaysUnderlined,\r\n      'd-inline': makeInline,\r\n      'd-inline-block': makeInlineBlock,\r\n      'no-underline-on-hover': noUnderlineOnHover,\r\n      'disabled': disabled\r\n    }\"\r\n    [tabindex]=\"disabled ? -1 : 0\"\r\n    ngbAutofocus\r\n    (click)=\"onClick()\"\r\n    [attr.role]=\"role ? role : null\"\r\n    [attr.aria-describedby]=\"ariaDescribedByText ? ariaDescribedByText : null\"\r\n    [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\r\n  >\r\n    <div #ref1>\r\n      <ng-content select=\"[tag-image-body]\"></ng-content>\r\n    </div>\r\n    <span *ngIf=\"!ref1.children.length\">\r\n      <i\r\n        *ngIf=\"showArrow === 'left' || showArrow === 'both'\"\r\n        class=\"fa fa-angle-left pr-1\"\r\n        [ngStyle]=\"{ color: iconColor }\"\r\n        aria-hidden=\"true\"\r\n      >\r\n      </i>\r\n      <i *ngIf=\"additionalIcon\" class=\"{{ additionalIcon }} pr-1\" [ngStyle]=\"{ color: iconColor }\"></i>\r\n      <ng-template *ngIf=\"liveEditEnabled; then liveEdit; else notLiveEdit\"> </ng-template>\r\n      <i\r\n        *ngIf=\"showArrow === 'right' || showArrow === 'both'\"\r\n        class=\"fa fa-angle-right pl-1\"\r\n        [ngStyle]=\"{ color: iconColor }\"\r\n        aria-hidden=\"true\"\r\n      >\r\n      </i>\r\n    </span>\r\n  </a>\r\n</ng-template>\r\n<ng-template #disableLinkNavigation>\r\n  <a\r\n    [ngClass]=\"{\r\n      'always-underline': alwaysUnderlined,\r\n      'd-inline': makeInline,\r\n      'd-inline-block': makeInlineBlock,\r\n      'no-underline-on-hover': noUnderlineOnHover,\r\n      'disabled': disabled\r\n    }\"\r\n    [tabindex]=\"disabled ? -1 : 0\"\r\n    ngbAutofocus\r\n  >\r\n    <div #ref1>\r\n      <ng-content select=\"[tag-image-body]\"></ng-content>\r\n    </div>\r\n    <span *ngIf=\"!ref1.children.length\">\r\n      <i\r\n        *ngIf=\"showArrow === 'left' || showArrow === 'both'\"\r\n        class=\"fa fa-angle-left pr-1\"\r\n        [ngStyle]=\"{ color: iconColor }\"\r\n        aria-hidden=\"true\"\r\n      >\r\n      </i>\r\n      <i *ngIf=\"additionalIcon\" class=\"{{ additionalIcon }} pr-1\" [ngStyle]=\"{ color: iconColor }\"></i>\r\n      <ng-template *ngIf=\"liveEditEnabled; then liveEdit; else notLiveEdit\"> </ng-template>\r\n    </span>\r\n  </a>\r\n</ng-template>\r\n", styles: [".always-underline{text-decoration:underline}.fa-angle-right{position:relative;top:1px}.no-underline-on-hover,.no-underline-on-hover:hover{text-decoration:none}a{cursor:pointer;display:block;color:inherit}a.disabled{cursor:default;color:var(--static-Spa_Style_Gray4)}:host(.enable-on-focus) a{opacity:0}:host(.enable-on-focus) a:focus{opacity:1}:host(.sr-only-link) a{border:0;clip:rect(0,0,0,0);height:1px;margin:-4px;overflow:hidden;padding:4px;position:absolute;width:1px}:host(.sr-only-link) a:focus{position:static;width:auto;height:auto}@media not all and (min-resolution: .001dpcm){@supports (-webkit-appearance: none) and (stroke-color: transparent){:host(.sr-only-link) a{width:auto}}}@media not all and (min-resolution: .001dpcm){@supports (-webkit-appearance: none) and (not (stroke-color: transparent)){:host(.sr-only-link) a{width:auto}}}@media screen and (min-color-index: 0) and(-webkit-min-device-pixel-ratio:0){:host(.sr-only-link) a{width:auto}}\n"] }]
    }], function () { return [{ type: i1.NavigationUtilityService }]; }, { title: [{
            type: Input
        }], tag: [{
            type: Input
        }], href: [{
            type: Input
        }], showArrow: [{
            type: Input
        }], alwaysUnderlined: [{
            type: Input
        }], linkTarget: [{
            type: Input
        }], keyNameForLiveEdit: [{
            type: Input
        }], additionalIcon: [{
            type: Input
        }], customClass: [{
            type: Input
        }], iconColor: [{
            type: Input
        }], makeInline: [{
            type: Input
        }], makeInlineBlock: [{
            type: Input
        }], noUnderlineOnHover: [{
            type: Input
        }], disabled: [{
            type: Input
        }], ariaDescribedByText: [{
            type: Input
        }], ariaHasPopup: [{
            type: Input
        }], role: [{
            type: Input
        }], onClickAction: [{
            type: Input
        }], titleClass: [{
            type: Input
        }], isLinkButton: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], queryParams: [{
            type: Input
        }], onClick: [] }); })();

function EnrollmentFormNavigationComponent_vnext_link_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 12);
    i0.ɵɵlistener("click", function EnrollmentFormNavigationComponent_vnext_link_2_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.backEvent.emit(null)); })("keyup.enter", function EnrollmentFormNavigationComponent_vnext_link_2_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.backEvent.emit(null)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r0.previousButtonText)("ariaLabel", ctx_r0.navigateToStringPrepend + ctx_r0.previousButtonText + ctx_r0.pageStringAppend)("makeInlineBlock", true)("showArrow", "left")("isLinkButton", true);
} }
function EnrollmentFormNavigationComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function EnrollmentFormNavigationComponent_button_7_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.showModalEvent.emit(null)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.sendApplicationButtonText, " ");
} }
function EnrollmentFormNavigationComponent_ng_container_9_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function EnrollmentFormNavigationComponent_ng_container_9_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.saveEvent.emit(null)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.saveText, " ");
} }
function EnrollmentFormNavigationComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EnrollmentFormNavigationComponent_ng_container_9_button_1_Template, 2, 1, "button", 14);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Enrollment_SaveProgress_Text");
} }
function EnrollmentFormNavigationComponent_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function EnrollmentFormNavigationComponent_button_10_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.nextEvent.emit(null)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.nextButtonText, " ");
} }
function EnrollmentFormNavigationComponent_ng_container_11_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵelement(1, "i", 20);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r17.voiceSignatureCompletedText, " ");
} }
function EnrollmentFormNavigationComponent_ng_container_11_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function EnrollmentFormNavigationComponent_ng_container_11_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r19.continueToVoiceSignature.emit()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r18.continueToVoiceSignatureText, " ");
} }
function EnrollmentFormNavigationComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EnrollmentFormNavigationComponent_ng_container_11_span_1_Template, 3, 1, "span", 17);
    i0.ɵɵtemplate(2, EnrollmentFormNavigationComponent_ng_container_11_button_2_Template, 2, 1, "button", 18);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.isVoiceSignatureComplete);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.isVoiceSignatureComplete);
} }
function EnrollmentFormNavigationComponent_ng_container_12_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵelement(1, "i", 20);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r21.authorizationCodeCompletedText, " ");
} }
function EnrollmentFormNavigationComponent_ng_container_12_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function EnrollmentFormNavigationComponent_ng_container_12_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r23.continueToAuthorizationCodeSignature.emit()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r22.continueToAuthorizationCodeText, " ");
} }
function EnrollmentFormNavigationComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EnrollmentFormNavigationComponent_ng_container_12_span_1_Template, 3, 1, "span", 17);
    i0.ɵɵtemplate(2, EnrollmentFormNavigationComponent_ng_container_12_button_2_Template, 2, 1, "button", 18);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.isAuthorizationCodeSignatureComplete);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r5.isAuthorizationCodeSignatureComplete);
} }
function EnrollmentFormNavigationComponent_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22, 23);
    i0.ɵɵlistener("click", function EnrollmentFormNavigationComponent_button_13_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r27); const _r25 = i0.ɵɵreference(1); const ctx_r26 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r26.onSubmit(_r25)); })("blur", function EnrollmentFormNavigationComponent_button_13_Template_button_blur_0_listener() { i0.ɵɵrestoreView(_r27); const _r25 = i0.ɵɵreference(1); const ctx_r28 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r28.closeTooltipEvent.emit(_r25)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngbTooltip", ctx_r6.enrollSubmitTooltipText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.submitButtonText, " ");
} }
class EnrollmentFormNavigationComponent {
    constructor() {
        this.backEvent = new EventEmitter();
        this.nextEvent = new EventEmitter();
        this.submitEvent = new EventEmitter();
        this.showModalEvent = new EventEmitter();
        this.closeTooltipEvent = new EventEmitter();
        this.saveEvent = new EventEmitter();
        this.continueToVoiceSignature = new EventEmitter();
        this.continueToAuthorizationCodeSignature = new EventEmitter();
        this.navigateToStringPrepend = "Navigate to ";
        this.pageStringAppend = " page";
        this.subscriptions = new Subscription();
        this.submitEventSubject$ = new Subject();
        this.submitEventThrottle$ = this.submitEventSubject$.asObservable().pipe(throttleTime(200));
    }
    ngOnInit() {
        this.subscriptions.add(this.submitEventThrottle$.subscribe({
            next: tooltip => {
                this.submitEvent.emit(tooltip);
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    onSubmit(tooltip) {
        this.submitEventSubject$.next(tooltip);
    }
}
EnrollmentFormNavigationComponent.ɵfac = function EnrollmentFormNavigationComponent_Factory(t) { return new (t || EnrollmentFormNavigationComponent)(); };
EnrollmentFormNavigationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EnrollmentFormNavigationComponent, selectors: [["vnext-enrollment-form-navigation"]], inputs: { showNext: "showNext", showSubmit: "showSubmit", showPrevious: "showPrevious", showSendApplicationEmail: "showSendApplicationEmail", showContinueToVoiceSignatureText: "showContinueToVoiceSignatureText", showContinueToAuthorizationCodeSignatureText: "showContinueToAuthorizationCodeSignatureText", previousButtonText: "previousButtonText", nextButtonText: "nextButtonText", submitButtonText: "submitButtonText", sendApplicationButtonText: "sendApplicationButtonText", enrollSubmitTooltipText: "enrollSubmitTooltipText", showSave: "showSave", saveText: "saveText", continueToVoiceSignatureText: "continueToVoiceSignatureText", isVoiceSignatureComplete: "isVoiceSignatureComplete", voiceSignatureCompletedText: "voiceSignatureCompletedText", continueToAuthorizationCodeText: "continueToAuthorizationCodeText", isAuthorizationCodeSignatureComplete: "isAuthorizationCodeSignatureComplete", authorizationCodeCompletedText: "authorizationCodeCompletedText" }, outputs: { backEvent: "backEvent", nextEvent: "nextEvent", submitEvent: "submitEvent", showModalEvent: "showModalEvent", closeTooltipEvent: "closeTooltipEvent", saveEvent: "saveEvent", continueToVoiceSignature: "continueToVoiceSignature", continueToAuthorizationCodeSignature: "continueToAuthorizationCodeSignature" }, decls: 14, vars: 7, consts: [[1, "row", "mt-2"], [1, "col-sm-4", "pt-3"], [3, "title", "ariaLabel", "makeInlineBlock", "showArrow", "isLinkButton", "click", "keyup.enter", 4, "ngIf"], [1, "col-sm-8", "mb-2"], [1, "row", "justify-content-sm-end"], [1, "justified-content-wrapper"], [1, "col-md-auto", "ml-md-3", "pr-md-0", "col-xs-12"], ["class", "btn Spa_Style_SecondaryButton mr-2 w-100", "type", "button", 3, "click", 4, "ngIf"], [1, "col-md-auto", "col-xs-12"], [4, "ngIf"], ["class", "btn Spa_Style_PrimaryButton", "type", "button", 3, "click", 4, "ngIf"], ["class", "btn Spa_Style_PrimaryButton", "triggers", "manual", "type", "button", 3, "ngbTooltip", "click", "blur", 4, "ngIf"], [3, "title", "ariaLabel", "makeInlineBlock", "showArrow", "isLinkButton", "click", "keyup.enter"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "mr-2", "w-100", 3, "click"], ["class", "btn Spa_Style_SecondaryButton mr-2 login-popover-container-button", 3, "click", 4, "liveEditProp"], [1, "btn", "Spa_Style_SecondaryButton", "mr-2", "login-popover-container-button", 3, "click"], ["type", "button", 1, "btn", "Spa_Style_PrimaryButton", 3, "click"], ["class", "signature-complete Spa_Style_Small_Font mr-2", 4, "ngIf"], ["class", "btn Spa_Style_SecondaryButton mr-2", "type", "button", 3, "click", 4, "ngIf"], [1, "signature-complete", "Spa_Style_Small_Font", "mr-2"], [1, "fas", "fa-check-circle"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "mr-2", 3, "click"], ["triggers", "manual", "type", "button", 1, "btn", "Spa_Style_PrimaryButton", 3, "ngbTooltip", "click", "blur"], ["tooltip", "ngbTooltip"]], template: function EnrollmentFormNavigationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, EnrollmentFormNavigationComponent_vnext_link_2_Template, 1, 5, "vnext-link", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "div", 6);
        i0.ɵɵtemplate(7, EnrollmentFormNavigationComponent_button_7_Template, 2, 1, "button", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 8);
        i0.ɵɵtemplate(9, EnrollmentFormNavigationComponent_ng_container_9_Template, 2, 1, "ng-container", 9);
        i0.ɵɵtemplate(10, EnrollmentFormNavigationComponent_button_10_Template, 2, 1, "button", 10);
        i0.ɵɵtemplate(11, EnrollmentFormNavigationComponent_ng_container_11_Template, 3, 2, "ng-container", 9);
        i0.ɵɵtemplate(12, EnrollmentFormNavigationComponent_ng_container_12_Template, 3, 2, "ng-container", 9);
        i0.ɵɵtemplate(13, EnrollmentFormNavigationComponent_button_13_Template, 3, 2, "button", 11);
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showPrevious);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.showSendApplicationEmail);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showSave);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showNext);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showContinueToVoiceSignatureText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showContinueToAuthorizationCodeSignatureText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showSubmit);
    } }, dependencies: [i1$2.NgIf, LiveEditPropDirective, i1$1.NgbTooltip, IconAriaAttributesDirective, LinkComponent], styles: [".signature-complete[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text)}@media (max-width: 575.98px){.btn[_ngcontent-%COMP%], vnext-link[_ngcontent-%COMP%]{display:block;width:100%;margin-top:18px;margin-left:0!important;margin-right:0!important;text-align:center}.justified-content-wrapper[_ngcontent-%COMP%]{width:100%}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentFormNavigationComponent, [{
        type: Component,
        args: [{ selector: 'vnext-enrollment-form-navigation', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row mt-2\">\r\n  <div class=\"col-sm-4 pt-3\">\r\n    <vnext-link\r\n      *ngIf=\"showPrevious\"\r\n      [title]=\"previousButtonText\"\r\n      [ariaLabel]=\"navigateToStringPrepend + previousButtonText + pageStringAppend\"\r\n      [makeInlineBlock]=\"true\"\r\n      [showArrow]=\"'left'\"\r\n      (click)=\"backEvent.emit(null)\"\r\n      (keyup.enter)=\"backEvent.emit(null)\"\r\n      [isLinkButton]=\"true\"\r\n    >\r\n    </vnext-link>\r\n  </div>\r\n  <div class=\"col-sm-8 mb-2\">\r\n    <div class=\"row justify-content-sm-end\">\r\n      <div class=\"justified-content-wrapper\">\r\n        <div class=\"col-md-auto ml-md-3 pr-md-0 col-xs-12\">\r\n          <button\r\n            class=\"btn Spa_Style_SecondaryButton mr-2 w-100\"\r\n            *ngIf=\"showSendApplicationEmail\"\r\n            (click)=\"showModalEvent.emit(null)\"\r\n            type=\"button\"\r\n          >\r\n            {{ sendApplicationButtonText }}\r\n          </button>\r\n        </div>\r\n        <div class=\"col-md-auto col-xs-12\">\r\n          <ng-container *ngIf=\"showSave\">\r\n            <button\r\n              *liveEditProp=\"'Spa_Enrollment_SaveProgress_Text'\"\r\n              class=\"btn Spa_Style_SecondaryButton mr-2 login-popover-container-button\"\r\n              (click)=\"saveEvent.emit(null)\"\r\n            >\r\n              {{ saveText }}\r\n            </button>\r\n          </ng-container>\r\n          <button class=\"btn Spa_Style_PrimaryButton\" *ngIf=\"showNext\" (click)=\"nextEvent.emit(null)\" type=\"button\">\r\n            {{ nextButtonText }}\r\n          </button>\r\n          <ng-container *ngIf=\"showContinueToVoiceSignatureText\">\r\n            <span *ngIf=\"isVoiceSignatureComplete\" class=\"signature-complete Spa_Style_Small_Font mr-2\">\r\n              <i class=\"fas fa-check-circle\"></i>\r\n              {{ voiceSignatureCompletedText }}\r\n            </span>\r\n            <button\r\n              *ngIf=\"!isVoiceSignatureComplete\"\r\n              class=\"btn Spa_Style_SecondaryButton mr-2\"\r\n              (click)=\"continueToVoiceSignature.emit()\"\r\n              type=\"button\"\r\n            >\r\n              {{ continueToVoiceSignatureText }}\r\n            </button>\r\n          </ng-container>\r\n\r\n          <ng-container *ngIf=\"showContinueToAuthorizationCodeSignatureText\">\r\n            <span *ngIf=\"isAuthorizationCodeSignatureComplete\" class=\"signature-complete Spa_Style_Small_Font mr-2\">\r\n              <i class=\"fas fa-check-circle\"></i>\r\n              {{ authorizationCodeCompletedText }}\r\n            </span>\r\n            <button\r\n              *ngIf=\"!isAuthorizationCodeSignatureComplete\"\r\n              class=\"btn Spa_Style_SecondaryButton mr-2\"\r\n              type=\"button\"\r\n              (click)=\"continueToAuthorizationCodeSignature.emit()\"\r\n            >\r\n              {{ continueToAuthorizationCodeText }}\r\n            </button>\r\n          </ng-container>\r\n\r\n          <button\r\n            *ngIf=\"showSubmit\"\r\n            class=\"btn Spa_Style_PrimaryButton\"\r\n            (click)=\"onSubmit(tooltip)\"\r\n            (blur)=\"closeTooltipEvent.emit(tooltip)\"\r\n            [ngbTooltip]=\"enrollSubmitTooltipText\"\r\n            #tooltip=\"ngbTooltip\"\r\n            triggers=\"manual\"\r\n            type=\"button\"\r\n          >\r\n            {{ submitButtonText }}\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".signature-complete{color:var(--static-Spa_Style_Cost_Text)}@media (max-width: 575.98px){.btn,vnext-link{display:block;width:100%;margin-top:18px;margin-left:0!important;margin-right:0!important;text-align:center}.justified-content-wrapper{width:100%}}\n"] }]
    }], null, { backEvent: [{
            type: Output
        }], nextEvent: [{
            type: Output
        }], submitEvent: [{
            type: Output
        }], showModalEvent: [{
            type: Output
        }], closeTooltipEvent: [{
            type: Output
        }], saveEvent: [{
            type: Output
        }], continueToVoiceSignature: [{
            type: Output
        }], continueToAuthorizationCodeSignature: [{
            type: Output
        }], showNext: [{
            type: Input
        }], showSubmit: [{
            type: Input
        }], showPrevious: [{
            type: Input
        }], showSendApplicationEmail: [{
            type: Input
        }], showContinueToVoiceSignatureText: [{
            type: Input
        }], showContinueToAuthorizationCodeSignatureText: [{
            type: Input
        }], previousButtonText: [{
            type: Input
        }], nextButtonText: [{
            type: Input
        }], submitButtonText: [{
            type: Input
        }], sendApplicationButtonText: [{
            type: Input
        }], enrollSubmitTooltipText: [{
            type: Input
        }], showSave: [{
            type: Input
        }], saveText: [{
            type: Input
        }], continueToVoiceSignatureText: [{
            type: Input
        }], isVoiceSignatureComplete: [{
            type: Input
        }], voiceSignatureCompletedText: [{
            type: Input
        }], continueToAuthorizationCodeText: [{
            type: Input
        }], isAuthorizationCodeSignatureComplete: [{
            type: Input
        }], authorizationCodeCompletedText: [{
            type: Input
        }] }); })();

var MedCategoryID;
(function (MedCategoryID) {
    MedCategoryID[MedCategoryID["INPATIENT_HOSPITAL_CARE"] = 4] = "INPATIENT_HOSPITAL_CARE";
    MedCategoryID[MedCategoryID["AMBULANCE_BENEFITS"] = 15] = "AMBULANCE_BENEFITS";
    MedCategoryID[MedCategoryID["DURABLE_MEDICAL_EQUIPMENT_BENEFITS"] = 19] = "DURABLE_MEDICAL_EQUIPMENT_BENEFITS";
    MedCategoryID[MedCategoryID["EMERGENCY_ROOM_VISIT_DUE_TO_ACCIDENT_OR_INJURY"] = 16] = "EMERGENCY_ROOM_VISIT_DUE_TO_ACCIDENT_OR_INJURY";
    MedCategoryID[MedCategoryID["LUMP_SUM_CANCER_BENEFITS"] = 22] = "LUMP_SUM_CANCER_BENEFITS";
    MedCategoryID[MedCategoryID["OUTPATIENT_REHAB_BENEFITS"] = 18] = "OUTPATIENT_REHAB_BENEFITS";
    MedCategoryID[MedCategoryID["OUTPATIENT_REHAB_BENEFITS_1"] = 18] = "OUTPATIENT_REHAB_BENEFITS_1";
    MedCategoryID[MedCategoryID["OUTPATIENT_REHAB_BENEFITS_2"] = 18] = "OUTPATIENT_REHAB_BENEFITS_2";
    MedCategoryID[MedCategoryID["PRIMARY_CARE_PHYSICIAN_OFFICE_VISIT"] = 9] = "PRIMARY_CARE_PHYSICIAN_OFFICE_VISIT";
    MedCategoryID[MedCategoryID["SKILLED_NURSING_FACILITY_BENEFITS_1"] = 6] = "SKILLED_NURSING_FACILITY_BENEFITS_1";
    MedCategoryID[MedCategoryID["SKILLED_NURSING_FACILITY_BENEFITS_2"] = 6] = "SKILLED_NURSING_FACILITY_BENEFITS_2";
    MedCategoryID[MedCategoryID["SKILLED_NURSING_FACILITY_BENEFITS_3"] = 6] = "SKILLED_NURSING_FACILITY_BENEFITS_3";
    MedCategoryID[MedCategoryID["SKILLED_NURSING_FACILITY_BENEFITS_4"] = 6] = "SKILLED_NURSING_FACILITY_BENEFITS_4";
})(MedCategoryID || (MedCategoryID = {}));
var HospitalIndemnityRiderBenefit;
(function (HospitalIndemnityRiderBenefit) {
    HospitalIndemnityRiderBenefit["AMBULANCE_BENEFITS"] = "Ambulance Benefits";
    HospitalIndemnityRiderBenefit["DURABLE_MEDICAL_EQUIPMENT_BENEFITS"] = "Durable Medical Equipment Benefits";
    HospitalIndemnityRiderBenefit["EMERGENCY_ROOM_VISIT_DUE_TO_ACCIDENT_OR_INJURY"] = "Emergency Room Visit due to accident or injury";
    HospitalIndemnityRiderBenefit["LUMP_SUM_CANCER_BENEFITS"] = "Lump Sum Cancer Benefits";
    HospitalIndemnityRiderBenefit["OUTPATIENT_REHAB_BENEFITS"] = "Outpatient Rehabilitation Benefits";
    HospitalIndemnityRiderBenefit["OUTPATIENT_REHAB_BENEFITS_1"] = "Outpatient Rehabilitation Benefits 1";
    HospitalIndemnityRiderBenefit["OUTPATIENT_REHAB_BENEFITS_2"] = "Outpatient Rehabilitation Benefits 2";
    HospitalIndemnityRiderBenefit["PRIMARY_CARE_PHYSICIAN_OFFICE_VISIT"] = "Primary Care Physician Office Visit";
    HospitalIndemnityRiderBenefit["SKILLED_NURSING_FACILITY_BENEFITS_1"] = "Skilled Nursing Facility Benefits 1";
    HospitalIndemnityRiderBenefit["SKILLED_NURSING_FACILITY_BENEFITS_2"] = "Skilled Nursing Facility Benefits 2";
    HospitalIndemnityRiderBenefit["SKILLED_NURSING_FACILITY_BENEFITS_3"] = "Skilled Nursing Facility Benefits 3";
    HospitalIndemnityRiderBenefit["SKILLED_NURSING_FACILITY_BENEFITS_4"] = "Skilled Nursing Facility Benefits 4";
})(HospitalIndemnityRiderBenefit || (HospitalIndemnityRiderBenefit = {}));
var PlanQuoteHospitalCareHeightSelectors;
(function (PlanQuoteHospitalCareHeightSelectors) {
    PlanQuoteHospitalCareHeightSelectors["BADGE_TITLE"] = "badge-title-height";
    PlanQuoteHospitalCareHeightSelectors["PLAN_NAME"] = "plan-name-height";
})(PlanQuoteHospitalCareHeightSelectors || (PlanQuoteHospitalCareHeightSelectors = {}));

function ModalHeaderComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵlistener("click", function ModalHeaderComponent_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.modalTitleCancelAction.emit()); });
    i0.ɵɵelementEnd();
} }
class ModalHeaderComponent {
    constructor() {
        this.hideCloseButton = false;
        this.modalTitleClass = 'modal-header Spa_Style_InactiveTabAndModal';
        this.modalTitleCancelAction = new EventEmitter();
    }
}
ModalHeaderComponent.ɵfac = function ModalHeaderComponent_Factory(t) { return new (t || ModalHeaderComponent)(); };
ModalHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ModalHeaderComponent, selectors: [["vnext-widget-modal-header"]], inputs: { modalTitleText: "modalTitleText", hideCloseButton: "hideCloseButton", modalTitleClass: "modalTitleClass" }, outputs: { modalTitleCancelAction: "modalTitleCancelAction" }, decls: 4, vars: 3, consts: [[3, "ngClass"], ["type", "button", "ngbAutofocus", "", "id", "modalHeaderCloseButton", "class", "close fas fa-times Spa_Style_Primary_Color", "aria-label", "Close", 3, "click", 4, "ngIf"], ["id", "modalHeaderTitle", 1, "Spa_Style_H4"], ["type", "button", "ngbAutofocus", "", "id", "modalHeaderCloseButton", "aria-label", "Close", 1, "close", "fas", "fa-times", "Spa_Style_Primary_Color", 3, "click"]], template: function ModalHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, ModalHeaderComponent_button_1_Template, 1, 0, "button", 1);
        i0.ɵɵelementStart(2, "h2", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", ctx.modalTitleClass);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.hideCloseButton);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.modalTitleText);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalHeaderComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-modal-header', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div [ngClass]=\"modalTitleClass\">\r\n  <button\r\n    *ngIf=\"!hideCloseButton\"\r\n    type=\"button\"\r\n    ngbAutofocus\r\n    id=\"modalHeaderCloseButton\"\r\n    class=\"close fas fa-times Spa_Style_Primary_Color\"\r\n    aria-label=\"Close\"\r\n    (click)=\"modalTitleCancelAction.emit()\"\r\n  ></button>\r\n  <h2 id=\"modalHeaderTitle\" class=\"Spa_Style_H4\">{{ modalTitleText }}</h2>\r\n</div>\r\n" }]
    }], null, { modalTitleText: [{
            type: Input
        }], hideCloseButton: [{
            type: Input
        }], modalTitleClass: [{
            type: Input
        }], modalTitleCancelAction: [{
            type: Output
        }] }); })();

function AgentTaskModalComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.getDateErrorMessage());
} }
function AgentTaskModalComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.contentErrorText);
} }
const _c0$3$ = function (a0) { return { "mr-auto": a0 }; };
class AgentTaskModalComponent {
    constructor(activeModal, store, analyticsService) {
        this.activeModal = activeModal;
        this.store = store;
        this.analyticsService = analyticsService;
        this.captureText = '';
        this.sendDate = new EventEmitter();
        this.isPastDate = false;
        this.showError = false;
        this.showDateError = false;
    }
    ngOnInit() {
        this.createAgentTask = new UntypedFormGroup({
            taskText: new UntypedFormControl('', [Validators.required]),
            dueDateText: new UntypedFormControl('', [Validators.required, Validators.maxLength(10), Validators.minLength(10)])
        }, { updateOn: 'blur' });
    }
    cancelTask() {
        this.activeModal.dismiss();
        if (this.cancelAction) {
            this.cancelAction();
        }
    }
    getDateFormat() {
        return DateUtilities.defaultFormat;
    }
    getDateMaskFormat() {
        return this.getDateFormat().replace(/\w/g, '0');
    }
    addTask() {
        this.registerAddFollowUpTaskEvent();
        if (!this.dateValue) {
            this.showDateError = true;
        }
        if (!this.showDateError && this.createAgentTask.valid) {
            const memberAgentTasks = {
                userAgentGUID: this.store.selectSnapshot(AgentState.agentGuid),
                agentNoteActionType: NoteActionType.OtherTask,
                description: this.createAgentTask.value.taskText,
                memberAgentNoteID: '',
                agentName: '',
                scheduledDate: this.createAgentTask.value.dueDateText,
                completedWhen: '',
                createdWhen: '',
                modifiedWhen: ''
            };
            this.activeModal.close(memberAgentTasks);
        }
        else {
            this.showError = true;
            const controls = this.createAgentTask.controls;
            for (const name in controls) {
                if (controls[name].invalid) {
                    this.createAgentTask.get(name).markAsTouched({ onlySelf: true });
                }
            }
        }
    }
    isValid(name) {
        if (this.createAgentTask.get(name).value) {
            return true;
        }
    }
    pastDateCheck(date) {
        this.isPastDate = DateUtilities.dateBefore(date, DateUtilities.getFormattedCurrentDate());
        return this.isPastDate;
    }
    getDateErrorMessage() {
        if (this.dateValue) {
            if (this.isPastDate) {
                return this.pastDateInvalidText;
            }
            return this.dateInvalidText;
        }
        return this.dateRequiredText;
    }
    validateDate(event) {
        if (event && this.dateValue) {
            if (this.dateValue.length === 10 && DateUtilities.isValidDate(this.dateValue)) {
                if (this.pastDateCheck(this.dateValue)) {
                    this.showDateError = true;
                }
                else {
                    this.removeDateErrors();
                }
            }
            else {
                this.showDateError = true;
                this.isPastDate = false;
            }
        }
        else {
            this.removeDateErrors();
        }
    }
    removeDateErrors() {
        this.showDateError = false;
        this.isPastDate = false;
    }
    selectDate(event) {
        const month = event.month.toString().length === 1 ? `0${event.month}` : event.month.toString();
        const day = event.day.toString().length === 1 ? `0${event.day}` : event.day.toString();
        this.dateValue = `${month}/${day}/${event.year}`;
        this.validateDate(this.dateValue);
        this.createAgentTask.get('dueDateText').setValue(this.dateValue);
    }
    registerAddFollowUpTaskEvent() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PROFILE_ADD_TASK,
            [DataLayerGlobalVariable.PROFILE_TASK_TYPE]: NoteActionTypeName.Other
        };
    }
}
AgentTaskModalComponent.ɵfac = function AgentTaskModalComponent_Factory(t) { return new (t || AgentTaskModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(AnalyticsService)); };
AgentTaskModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentTaskModalComponent, selectors: [["ng-component"]], inputs: { captureText: "captureText" }, outputs: { sendDate: "sendDate" }, decls: 28, vars: 17, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [3, "formGroup"], [1, "form-group", "modal-body"], [1, "input-error-asterisk"], ["for", "dueDateText", 1, "Spa_Style_Label"], ["class", "error-container", 4, "ngIf"], ["id", "dueDateText", "type", "text", "ngbAutofocus", "", "inputmode", "numeric", "maxlength", "10", "autocomplete", "off", "formControlName", "dueDateText", "aria-required", "true", 1, "due-date-input", "col-5", "col-sm-4", 3, "placeholder", "mask", "dropSpecialCharacters", "ngModel", "ngModelChange", "blur"], ["type", "text", "aria-hidden", "true", "ngbDatepicker", "", "tabindex", "-1", 1, "date-picker-input", 3, "dateSelect", "select"], ["datePickerInput", "ngbDatepicker"], ["tabindex", "0", 1, "btn", "btn-calendar", 3, "click"], [1, "fas", "fa-calendar-alt"], ["for", "textContent", 1, "Spa_Style_Label"], ["id", "textContent", "type", "text", "tabindex", "0", "rows", "4", "maxlength", "450", "required", "", "name", "textContent", "formControlName", "taskText", 1, "md-textarea", "form-control", 3, "placeholder", "value"], [1, "modal-footer", "justify-content-start"], ["type", "button", "tabindex", "0", 1, "btn", "Spa_Style_SecondaryButton", 3, "ngClass", "click"], ["type", "button", "tabindex", "0", 1, "btn", "Spa_Style_PrimaryButton", 3, "click"], [1, "error-container"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"]], template: function AgentTaskModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r3 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function AgentTaskModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.cancelTask(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "form", 1)(2, "div", 2)(3, "div")(4, "span", 3);
        i0.ɵɵtext(5, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "label", 4);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(8, "br");
        i0.ɵɵtemplate(9, AgentTaskModalComponent_div_9_Template, 4, 1, "div", 5);
        i0.ɵɵelementStart(10, "input", 6);
        i0.ɵɵlistener("ngModelChange", function AgentTaskModalComponent_Template_input_ngModelChange_10_listener($event) { return ctx.dateValue = $event; })("blur", function AgentTaskModalComponent_Template_input_blur_10_listener($event) { return ctx.validateDate($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "input", 7, 8);
        i0.ɵɵlistener("dateSelect", function AgentTaskModalComponent_Template_input_dateSelect_11_listener($event) { return ctx.selectDate($event); })("select", function AgentTaskModalComponent_Template_input_select_11_listener($event) { return ctx.selectDate($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "button", 9);
        i0.ɵɵlistener("click", function AgentTaskModalComponent_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r3); const _r1 = i0.ɵɵreference(12); return i0.ɵɵresetView(_r1.toggle()); });
        i0.ɵɵelement(14, "i", 10);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(15, "div");
        i0.ɵɵelement(16, "br");
        i0.ɵɵelementStart(17, "span", 3);
        i0.ɵɵtext(18, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "label", 11);
        i0.ɵɵtext(20);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(21, AgentTaskModalComponent_div_21_Template, 4, 1, "div", 5);
        i0.ɵɵelement(22, "textarea", 12);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(23, "div", 13)(24, "button", 14);
        i0.ɵɵlistener("click", function AgentTaskModalComponent_Template_button_click_24_listener() { return ctx.cancelTask(); });
        i0.ɵɵtext(25);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "button", 15);
        i0.ɵɵlistener("click", function AgentTaskModalComponent_Template_button_click_26_listener() { return ctx.addTask(); });
        i0.ɵɵtext(27);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.createAgentTask);
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1("", ctx.dueDateLabel, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showDateError);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("placeholder", ctx.getDateFormat());
        i0.ɵɵpropertyInterpolate("mask", ctx.getDateMaskFormat());
        i0.ɵɵproperty("dropSpecialCharacters", false)("ngModel", ctx.dateValue);
        i0.ɵɵadvance(10);
        i0.ɵɵtextInterpolate1("", ctx.taskLabel, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isValid("taskText") && ctx.showError);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("placeholder", ctx.agentTaskPlaceholderText);
        i0.ɵɵproperty("value", ctx.captureText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c0$3$, ctx.confirmButton));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.cancelButton, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.confirmButton, " ");
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.RequiredValidator, i4.MaxLengthValidator, i4.FormGroupDirective, i4.FormControlName, i1$1.NgbInputDatepicker, i8.MaskDirective, IconAriaAttributesDirective, ModalHeaderComponent], styles: [".btn-calendar[_ngcontent-%COMP%]{position:absolute;margin-left:-45px}.due-date-input[_ngcontent-%COMP%]{position:relative}.date-picker-input[_ngcontent-%COMP%]{position:absolute;color:transparent;z-index:-1}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentTaskModalComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"cancelTask()\"></vnext-widget-modal-header>\r\n\r\n<form [formGroup]=\"createAgentTask\">\r\n  <div class=\"form-group modal-body\">\r\n    <div>\r\n      <span class=\"input-error-asterisk\">*</span>\r\n      <label class=\"Spa_Style_Label\" for=\"dueDateText\">{{ dueDateLabel }} </label><br />\r\n      <div class=\"error-container\" *ngIf=\"showDateError\">\r\n        <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n        <span>{{ getDateErrorMessage() }}</span>\r\n      </div>\r\n      <input\r\n        id=\"dueDateText\"\r\n        type=\"text\"\r\n        placeholder=\"{{ getDateFormat() }}\"\r\n        ngbAutofocus\r\n        inputmode=\"numeric\"\r\n        maxlength=\"10\"\r\n        class=\"due-date-input col-5 col-sm-4\"\r\n        autocomplete=\"off\"\r\n        formControlName=\"dueDateText\"\r\n        aria-required=\"true\"\r\n        mask=\"{{ getDateMaskFormat() }}\"\r\n        [dropSpecialCharacters]=\"false\"\r\n        [(ngModel)]=\"dateValue\"\r\n        (blur)=\"validateDate($event)\"\r\n      />\r\n      <input\r\n        type=\"text\"\r\n        aria-hidden=\"true\"\r\n        class=\"date-picker-input\"\r\n        ngbDatepicker\r\n        tabindex=\"-1\"\r\n        #datePickerInput=\"ngbDatepicker\"\r\n        (dateSelect)=\"selectDate($event)\"\r\n        (select)=\"selectDate($event)\"\r\n      />\r\n      <button class=\"btn btn-calendar\" tabindex=\"0\" (click)=\"datePickerInput.toggle()\">\r\n        <i class=\"fas fa-calendar-alt\"></i>\r\n      </button>\r\n    </div>\r\n    <div>\r\n      <br />\r\n      <span class=\"input-error-asterisk\">*</span>\r\n\r\n      <label class=\"Spa_Style_Label\" for=\"textContent\">{{ taskLabel }} </label>\r\n      <div class=\"error-container\" *ngIf=\"!isValid('taskText') && showError\">\r\n        <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n        <span>{{ contentErrorText }}</span>\r\n      </div>\r\n      <textarea\r\n        id=\"textContent\"\r\n        type=\"text\"\r\n        tabindex=\"0\"\r\n        rows=\"4\"\r\n        maxlength=\"450\"\r\n        required\r\n        name=\"textContent\"\r\n        formControlName=\"taskText\"\r\n        placeholder=\"{{ agentTaskPlaceholderText }}\"\r\n        class=\"md-textarea form-control\"\r\n        [value]=\"captureText\"\r\n      ></textarea>\r\n    </div>\r\n  </div>\r\n  <div class=\"modal-footer justify-content-start\">\r\n    <button\r\n      type=\"button\"\r\n      tabindex=\"0\"\r\n      [ngClass]=\"{ 'mr-auto': confirmButton }\"\r\n      class=\"btn Spa_Style_SecondaryButton\"\r\n      (click)=\"cancelTask()\"\r\n    >\r\n      {{ cancelButton }}\r\n    </button>\r\n    <button type=\"button\" tabindex=\"0\" (click)=\"addTask()\" class=\"btn Spa_Style_PrimaryButton\">\r\n      {{ confirmButton }}\r\n    </button>\r\n  </div>\r\n</form>\r\n", styles: [".btn-calendar{position:absolute;margin-left:-45px}.due-date-input{position:relative}.date-picker-input{position:absolute;color:transparent;z-index:-1}\n"] }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i2.Store }, { type: AnalyticsService }]; }, { captureText: [{
            type: Input
        }], sendDate: [{
            type: Output
        }] }); })();

function SelectRxTaskComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵelement(2, "vnext-followup-task", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("taskType", ctx_r0.taskType)("followUpTaskText", ctx_r0.followUpTaskText)("taskDueDateOffset", ctx_r0.taskDueDateOffset)("hideHeaderRow", true);
} }
function SelectRxTaskComponent_ng_template_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.validationMessage);
} }
function SelectRxTaskComponent_ng_template_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r4.errorMessage);
} }
function SelectRxTaskComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, SelectRxTaskComponent_ng_template_3_div_1_Template, 2, 1, "div", 8);
    i0.ɵɵtemplate(2, SelectRxTaskComponent_ng_template_3_div_2_Template, 2, 1, "div", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isEligibleForSelectRxTasks);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.hasSelectRxTask);
} }
class SelectRxTaskComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
        this.hasSelectRxTask = false;
        this.taskType = NoteActionType.SelectRx;
    }
    ngOnInit() { }
    closeAddTaskModal() {
        this.activeModal.dismiss();
        if (this.cancelAction) {
            this.cancelAction();
        }
    }
}
SelectRxTaskComponent.ɵfac = function SelectRxTaskComponent_Factory(t) { return new (t || SelectRxTaskComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal)); };
SelectRxTaskComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectRxTaskComponent, selectors: [["ng-component"]], decls: 8, vars: 4, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [4, "ngIf", "ngIfElse"], ["showValidationMessage", ""], [1, "modal-footer", "justify-content-start"], ["type", "button", 1, "btn", "mr-auto", "Spa_Style_SecondaryButton", 3, "click"], [1, "mb-4"], [3, "taskType", "followUpTaskText", "taskDueDateOffset", "hideHeaderRow"], [1, "Spa_Style_Toggle_Background", "px-3", "pt-4", "pb-4", "rounded", "m-4"], ["class", "Spa_Style_Primary_Color Spa_Style_Paragraph mb-2", 4, "ngIf"], ["class", "Spa_Style_Primary_Color Spa_Style_Paragraph mb-0", 4, "ngIf"], [1, "Spa_Style_Primary_Color", "Spa_Style_Paragraph", "mb-2"], [1, "Spa_Style_Primary_Color", "Spa_Style_Paragraph", "mb-0"]], template: function SelectRxTaskComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div")(1, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function SelectRxTaskComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_1_listener() { return ctx.closeAddTaskModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, SelectRxTaskComponent_ng_container_2_Template, 3, 4, "ng-container", 1);
        i0.ɵɵtemplate(3, SelectRxTaskComponent_ng_template_3_Template, 3, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(5, "div", 3)(6, "button", 4);
        i0.ɵɵlistener("click", function SelectRxTaskComponent_Template_button_click_6_listener() { return ctx.closeAddTaskModal(); });
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(4);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("modalTitleText", ctx.modalTitleText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isEligibleForSelectRxTasks && !ctx.hasSelectRxTask)("ngIfElse", _r1);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", ctx.modalCancelText, " ");
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectRxTaskComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<div>\r\n  <vnext-widget-modal-header [modalTitleText]=\"modalTitleText\" (modalTitleCancelAction)=\"closeAddTaskModal()\"></vnext-widget-modal-header>\r\n\r\n  <ng-container *ngIf=\"isEligibleForSelectRxTasks && !hasSelectRxTask; else showValidationMessage\">\r\n    <div class=\"mb-4\">\r\n      <vnext-followup-task\r\n        [taskType]=\"taskType\"\r\n        [followUpTaskText]=\"followUpTaskText\"\r\n        [taskDueDateOffset]=\"taskDueDateOffset\"\r\n        [hideHeaderRow]=\"true\"\r\n      ></vnext-followup-task>\r\n    </div>\r\n  </ng-container>\r\n  <ng-template #showValidationMessage>\r\n    <div class=\"Spa_Style_Toggle_Background px-3 pt-4 pb-4 rounded m-4\">\r\n      <div *ngIf=\"!isEligibleForSelectRxTasks\" class=\"Spa_Style_Primary_Color Spa_Style_Paragraph mb-2\">{{ validationMessage }}</div>\r\n      <div *ngIf=\"hasSelectRxTask\" class=\"Spa_Style_Primary_Color Spa_Style_Paragraph mb-0\">{{ errorMessage }}</div>\r\n    </div>\r\n  </ng-template>\r\n\r\n  <div class=\"modal-footer justify-content-start\">\r\n    <button type=\"button\" class=\"btn mr-auto Spa_Style_SecondaryButton\" (click)=\"closeAddTaskModal()\">\r\n      {{ modalCancelText }}\r\n    </button>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: i1$1.NgbActiveModal }]; }, null); })();

class AgentTaskFacade {
    constructor(modalService, configResourceService, sessionService, sessionHttpService, store) {
        this.modalService = modalService;
        this.configResourceService = configResourceService;
        this.sessionService = sessionService;
        this.sessionHttpService = sessionHttpService;
        this.store = store;
    }
    showAgentTaskModal(widgetName) {
        const modalTitle = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_Title', widgetName, 'Add Task');
        const modalCancel = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_Cancel_Button', widgetName, 'Cancel');
        const modalSave = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_Save_Button', widgetName, 'Add Task');
        const modalPlaceholderText = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_PlaceholderText', widgetName, 'Task description');
        const contentErrorText = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_ContentErrorText', widgetName, 'Task is required');
        const dateRequiredText = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_DateErrorText', widgetName, 'Date is required');
        const dateInvalidText = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_DateInvalidText', widgetName, 'Please provide a valid date');
        const pastDateInvalidText = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_PastDateInvalidText', widgetName, 'can not be in the past');
        const dueDateLabel = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_DueDate_Label', widgetName, 'Due date');
        const taskLabel = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_Task_Label', widgetName, 'Create a task');
        const agentTaskModal = this.modalService.open(AgentTaskModalComponent, { centered: true });
        agentTaskModal.componentInstance.title = modalTitle;
        agentTaskModal.componentInstance.cancelButton = modalCancel;
        agentTaskModal.componentInstance.confirmButton = modalSave;
        agentTaskModal.componentInstance.agentTaskPlaceholderText = modalPlaceholderText;
        agentTaskModal.componentInstance.contentErrorText = contentErrorText;
        agentTaskModal.componentInstance.dateRequiredText = dateRequiredText;
        agentTaskModal.componentInstance.dateInvalidText = dateInvalidText;
        agentTaskModal.componentInstance.pastDateInvalidText = `${dueDateLabel} ${pastDateInvalidText}`;
        agentTaskModal.componentInstance.taskLabel = taskLabel;
        agentTaskModal.componentInstance.dueDateLabel = dueDateLabel;
        agentTaskModal.result.then(memberAgentTasks => {
            if (memberAgentTasks) {
                this.addAgentTask(memberAgentTasks);
            }
        }, () => { });
    }
    showSelectRxTaskModal(widgetName) {
        const isEligibleForSelectRxTasks = this.sessionService.isEligibleForSelectRxTasks();
        const hasSelectRxTask = this.hasSelectRxTask();
        const modalTitle = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_Title', widgetName, 'Add Task');
        const modalCancelText = this.configResourceService.getProcessedResourceValue('Spa_Site_Close', widgetName, 'Close');
        const followUpTaskText = this.configResourceService.getProcessedResourceValue('Spa_SelectRx_Task_Text', null, 'Call SelectRx to help the user with their prescriptions.');
        const dueDateIntervalDays = this.configResourceService.getProcessedResourceValue('Spa_SelectRx_Task_DueDateIntervalDays', widgetName, '30');
        const validationMessage = this.configResourceService.getProcessedResourceValue('Spa_SelectRx_TaskValidation_Text', widgetName, 'At least 8 medications required');
        const errorMessage = this.configResourceService.getProcessedResourceValue('Spa_SelectRx_TaskError_Text', widgetName, 'SelectRx task already exists');
        const taskDueDateOffset = dueDateIntervalDays && !isNaN(+dueDateIntervalDays) ? +dueDateIntervalDays : 30;
        const selectRxTaskModal = this.modalService.open(SelectRxTaskComponent, { centered: true });
        selectRxTaskModal.componentInstance.modalTitleText = modalTitle;
        selectRxTaskModal.componentInstance.modalCancelText = modalCancelText;
        selectRxTaskModal.componentInstance.followUpTaskText = followUpTaskText;
        selectRxTaskModal.componentInstance.taskDueDateOffset = taskDueDateOffset;
        selectRxTaskModal.componentInstance.isEligibleForSelectRxTasks = isEligibleForSelectRxTasks;
        selectRxTaskModal.componentInstance.validationMessage = validationMessage;
        selectRxTaskModal.componentInstance.hasSelectRxTask = hasSelectRxTask;
        selectRxTaskModal.componentInstance.errorMessage = errorMessage;
        return selectRxTaskModal;
    }
    async addAgentTask(memberAgentNotes) {
        return await this.sessionService.addMemberNoteByAgent(memberAgentNotes);
    }
    async updateAgentTask(memberAgentNotes) {
        return await this.sessionService.updateMemberTask(memberAgentNotes);
    }
    async updateDashboardAgentTask(sessionID, memberAgentNotes) {
        return await this.sessionService.updateDashBoardMemberTask(sessionID, memberAgentNotes);
    }
    async updateAgentNoteTaskByTypes(sessionID, noteTypes) {
        await this.sessionHttpService.updateAgentNoteTaskByTypes$(sessionID, noteTypes).toPromise();
    }
    getSessionId$(agentGuid, memberId) {
        return this.sessionHttpService.createSession$({ agentGuid }, memberId);
    }
    getMemberAgentTasks$() {
        return this.store.select(MemberState.memberAgentTasks);
    }
    getMemberAgentTasks() {
        return this.store.selectSnapshot(MemberState.memberAgentTasks);
    }
    getAgentTaskName(taskType) {
        switch (taskType) {
            case NoteActionType.EnrollmentTask:
                return NoteActionTypeName.Enrollment;
            case NoteActionType.QuoteTask:
                return NoteActionTypeName.Quote;
            case NoteActionType.SOATask:
                return NoteActionTypeName.ScopeOfAppointment;
            case NoteActionType.BlueButtonTask:
                return NoteActionTypeName.BlueButton;
            case NoteActionType.SelectRx:
                return NoteActionTypeName.SelectRx;
            case NoteActionType.RetireFlo:
                return NoteActionTypeName.RetireFlo;
            default:
                return NoteActionTypeName.Other;
        }
    }
    async removeAssociatedTasksByType(noteType) {
        const sessionId = this.sessionService.getMemberSessionId();
        this.updateAgentNoteTaskByTypes(sessionId, noteType);
    }
    hasSelectRxTask() {
        const agentTasks = this.getMemberAgentTasks();
        const selectRxTask = this.getSelectRxTask(agentTasks);
        return !!selectRxTask;
    }
    getSelectRxTask(agentTasks) {
        return agentTasks?.find(task => task.agentNoteActionType === NoteActionType.SelectRx && task.completedWhen === null);
    }
    getTasksByType(noteType) {
        return this.store
            .selectSnapshot(MemberState.memberAgentNotes)
            .filter(note => note.agentNoteActionType === noteType && !note.completedWhen);
    }
}
AgentTaskFacade.ɵfac = function AgentTaskFacade_Factory(t) { return new (t || AgentTaskFacade)(i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(i1.MemberSessionHttpService), i0.ɵɵinject(i2.Store)); };
AgentTaskFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentTaskFacade, factory: AgentTaskFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentTaskFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$1.NgbModal }, { type: i1.ConfigResourceService }, { type: i1.MemberSessionService }, { type: i1.MemberSessionHttpService }, { type: i2.Store }]; }, null); })();

function FollowUpTaskComponent_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
} }
function FollowUpTaskComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵtemplate(2, FollowUpTaskComponent_ng_container_1_div_2_Template, 1, 0, "div", 4);
    i0.ɵɵelementStart(3, "div", 5)(4, "div", 6)(5, "span", 7);
    i0.ɵɵelement(6, "i", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.hideHeaderRow);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.successMessage, " ");
} }
function FollowUpTaskComponent_ng_template_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
} }
function FollowUpTaskComponent_ng_template_2_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelement(1, "i", 26);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r5.getDateErrorMessage());
} }
function FollowUpTaskComponent_ng_template_2_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelement(1, "i", 26);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r7.contentErrorText);
} }
function FollowUpTaskComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, FollowUpTaskComponent_ng_template_2_div_1_Template, 1, 0, "div", 4);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵelement(3, "h5", 11);
    i0.ɵɵpipe(4, "safe");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div")(6, "span", 12);
    i0.ɵɵtext(7, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "label", 13);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "br");
    i0.ɵɵtemplate(11, FollowUpTaskComponent_ng_template_2_div_11_Template, 4, 1, "div", 14);
    i0.ɵɵelementStart(12, "input", 15);
    i0.ɵɵlistener("ngModelChange", function FollowUpTaskComponent_ng_template_2_Template_input_ngModelChange_12_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.dateValue = $event); })("blur", function FollowUpTaskComponent_ng_template_2_Template_input_blur_12_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.validateDate($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "input", 16, 17);
    i0.ɵɵlistener("dateSelect", function FollowUpTaskComponent_ng_template_2_Template_input_dateSelect_13_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.selectDate($event)); })("select", function FollowUpTaskComponent_ng_template_2_Template_input_select_13_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.selectDate($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "button", 18);
    i0.ɵɵlistener("click", function FollowUpTaskComponent_ng_template_2_Template_button_click_15_listener() { i0.ɵɵrestoreView(_r9); const _r6 = i0.ɵɵreference(14); return i0.ɵɵresetView(_r6.toggle()); });
    i0.ɵɵelement(16, "i", 19);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "div", 20)(18, "span", 12);
    i0.ɵɵtext(19, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "label", 21);
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(22, FollowUpTaskComponent_ng_template_2_div_22_Template, 4, 1, "div", 14);
    i0.ɵɵelementStart(23, "textarea", 22);
    i0.ɵɵlistener("ngModelChange", function FollowUpTaskComponent_ng_template_2_Template_textarea_ngModelChange_23_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.captureTaskText = $event); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(24, "div", 23)(25, "button", 24);
    i0.ɵɵlistener("click", function FollowUpTaskComponent_ng_template_2_Template_button_click_25_listener() { i0.ɵɵrestoreView(_r9); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.addTask()); });
    i0.ɵɵtext(26);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.hideHeaderRow);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 12, ctx_r2.taskHeader, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1("", ctx_r2.dueDateLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.showDateError);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r2.getDateFormat());
    i0.ɵɵpropertyInterpolate("mask", ctx_r2.dateMaskFormat);
    i0.ɵɵproperty("dropSpecialCharacters", false)("ngModel", ctx_r2.dateValue);
    i0.ɵɵadvance(9);
    i0.ɵɵtextInterpolate1("", ctx_r2.taskLabel, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isValid("taskText") && ctx_r2.showError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r2.captureTaskText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.addTaskText, " ");
} }
class FollowUpTaskComponent {
    constructor(store, agentTaskFacade, configResourceService, analyticsService) {
        this.store = store;
        this.agentTaskFacade = agentTaskFacade;
        this.configResourceService = configResourceService;
        this.analyticsService = analyticsService;
        this.hideHeaderRow = false;
        this.captureTaskText = '';
        this.isPastDate = false;
        this.showError = false;
        this.showDateError = false;
        this.createdFollowUpTask = false;
    }
    ngOnInit() {
        this.createFollowUpTask = new UntypedFormGroup({
            taskText: new UntypedFormControl('', [Validators.required]),
            dueDateText: new UntypedFormControl('', [Validators.required, Validators.maxLength(10), Validators.minLength(10)])
        }, { updateOn: 'blur' });
        this.dateMaskFormat = this.getDateFormat().replace(/\w/g, '0');
        this.setFormAttributes();
    }
    setFormAttributes() {
        this.taskHeader = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_FollowUp_CreateTask_Header_Label', null, 'Create a task to follow up with the beneficiary');
        this.dueDateLabel = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_DueDate_Label', null, 'Due date');
        this.taskLabel = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_Task_Label', null, 'Create a task');
        this.addTaskText = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_Save_Button', null, 'Add Task');
        this.contentErrorText = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_ContentErrorText', null, 'Task is required');
        this.dateRequiredText = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_DateErrorText', null, 'Date is required');
        this.dateInvalidText = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_DateInvalidText', null, 'Please provide a valid date');
        this.pastDateInvalidText = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_PastDateInvalidText', null, 'can not be in the past');
        if (this.taskType === NoteActionType.SelectRx) {
            this.successMessage = this.configResourceService.getProcessedResourceValue('Spa_SelectRx_TaskCreated_Text', null, 'Task created');
        }
        else {
            this.successMessage = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_FollowUp_TaskCreated_Text', null, 'Task created');
        }
        this.dateValue = DateUtilities.getFormattedDate(this.getDefaultDate());
        this.captureTaskText = this.followUpTaskText;
        this.createdFollowUpTask = false;
    }
    getDefaultDate() {
        this.date = new Date();
        this.date.setDate(this.date.getDate() + (this.taskDueDateOffset ?? 2));
        return this.date;
    }
    getDateFormat() {
        return DateUtilities.defaultFormat;
    }
    getDateMaskFormat() {
        return this.getDateFormat().replace(/\w/g, '0');
    }
    addTask() {
        if (!this.dateValue) {
            this.showDateError = true;
        }
        if (!this.showDateError && this.createFollowUpTask.valid) {
            const memberAgentTasks = {
                userAgentGUID: this.store.selectSnapshot(AgentState.agentGuid),
                agentNoteActionType: this.taskType,
                description: this.createFollowUpTask.value.taskText,
                memberAgentNoteID: '',
                agentName: '',
                scheduledDate: this.createFollowUpTask.value.dueDateText,
                completedWhen: '',
                createdWhen: '',
                modifiedWhen: ''
            };
            this.agentTaskFacade.addAgentTask(memberAgentTasks);
            this.registerAddFollowUpTaskEvent();
            this.createdFollowUpTask = true;
        }
        else {
            this.showError = true;
            const controls = this.createFollowUpTask.controls;
            for (const name in controls) {
                if (controls[name].invalid) {
                    this.createFollowUpTask.get(name).markAsTouched({ onlySelf: true });
                }
            }
        }
    }
    isValid(name) {
        return !!this.createFollowUpTask.get(name)?.value;
    }
    pastDateCheck(date) {
        return DateUtilities.dateBefore(date, DateUtilities.getFormattedCurrentDate());
    }
    getDateErrorMessage() {
        if (this.dateValue) {
            if (this.isPastDate) {
                return `${this.dueDateLabel} ${this.pastDateInvalidText}`;
            }
            return this.dateInvalidText;
        }
        return this.dateRequiredText;
    }
    validateDate(event) {
        if (event && this.dateValue) {
            if (this.dateValue.length === 10 && DateUtilities.isValidDate(this.dateValue)) {
                this.isPastDate = this.pastDateCheck(this.dateValue);
                if (this.isPastDate) {
                    this.showDateError = true;
                }
                else {
                    this.removeDateErrors();
                }
            }
            else {
                this.showDateError = true;
                this.isPastDate = false;
            }
        }
        else {
            this.removeDateErrors();
        }
    }
    removeDateErrors() {
        this.showDateError = false;
        this.isPastDate = false;
    }
    selectDate(event) {
        const month = event.month.toString().length === 1 ? `0${event.month}` : event.month.toString();
        const day = event.day.toString().length === 1 ? `0${event.day}` : event.day.toString();
        this.dateValue = `${month}/${day}/${event.year}`;
        this.validateDate(this.dateValue);
        this.createFollowUpTask.get('dueDateText').setValue(this.dateValue);
    }
    registerAddFollowUpTaskEvent() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PROFILE_ADD_TASK,
            [DataLayerGlobalVariable.PROFILE_TASK_TYPE]: this.agentTaskFacade.getAgentTaskName(this.taskType)
        };
    }
}
FollowUpTaskComponent.ɵfac = function FollowUpTaskComponent_Factory(t) { return new (t || FollowUpTaskComponent)(i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(AgentTaskFacade), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(AnalyticsService)); };
FollowUpTaskComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FollowUpTaskComponent, selectors: [["vnext-followup-task"]], inputs: { taskType: "taskType", followUpTaskText: "followUpTaskText", taskDueDateOffset: "taskDueDateOffset", hideHeaderRow: "hideHeaderRow" }, decls: 4, vars: 3, consts: [[3, "formGroup"], [4, "ngIf", "ngIfElse"], ["displayCreateTaskForm", ""], [1, "form-group", "modal-body"], ["class", "row mb-2", 4, "ngIf"], [1, "mb-4"], [1, "task-created"], [1, "pr-2", "pl-1"], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "task-created"], [1, "row", "mb-2"], [1, "form-group", "modal-body", "mb-5"], [1, "Spa_Style_H5", "mb-2", 3, "innerHTML"], [1, "input-error-asterisk"], ["for", "dueDateText", 1, "Spa_Style_Label"], ["class", "error-container", 4, "ngIf"], ["id", "dueDateText", "type", "text", "ngbAutofocus", "", "inputmode", "numeric", "maxlength", "10", "autocomplete", "off", "formControlName", "dueDateText", "aria-required", "true", 1, "due-date-input", "col-5", "col-sm-4", 3, "placeholder", "mask", "dropSpecialCharacters", "ngModel", "ngModelChange", "blur"], ["type", "text", "aria-hidden", "true", "ngbDatepicker", "", "tabindex", "-1", 1, "date-picker-input", 3, "dateSelect", "select"], ["datePickerInput", "ngbDatepicker"], ["type", "button", "tabindex", "0", 1, "btn", "btn-calendar", 3, "click"], [1, "fas", "fa-calendar-alt"], [1, "mb-2", "mt-3"], ["for", "textContent", 1, "Spa_Style_Label"], ["id", "textContent", "type", "text", "rows", "4", "maxlength", "450", "required", "", "name", "textContent", "formControlName", "taskText", 1, "md-textarea", "form-control", 3, "ngModel", "ngModelChange"], [1, "button-right"], ["type", "button", "tabindex", "0", 1, "btn", "Spa_Style_PrimaryButton", 3, "click"], [1, "error-container"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"]], template: function FollowUpTaskComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 0);
        i0.ɵɵtemplate(1, FollowUpTaskComponent_ng_container_1_Template, 8, 2, "ng-container", 1);
        i0.ɵɵtemplate(2, FollowUpTaskComponent_ng_template_2_Template, 27, 15, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(3);
        i0.ɵɵproperty("formGroup", ctx.createFollowUpTask);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.createdFollowUpTask)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.RequiredValidator, i4.MaxLengthValidator, i4.FormGroupDirective, i4.FormControlName, i1$1.NgbInputDatepicker, i8.MaskDirective, IconAriaAttributesDirective, SafePipe], styles: [".btn-calendar[_ngcontent-%COMP%]{position:absolute;margin-left:-45px}.due-date-input[_ngcontent-%COMP%]{position:relative}.date-picker-input[_ngcontent-%COMP%]{position:absolute;color:transparent;z-index:-1}.row[_ngcontent-%COMP%]{margin-top:auto;border-top:1px solid var(--static-Spa_Style_Gray2);margin-left:0;margin-right:0}.button-right[_ngcontent-%COMP%]{position:relative;float:right}.task-created[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FollowUpTaskComponent, [{
        type: Component,
        args: [{ selector: 'vnext-followup-task', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form [formGroup]=\"createFollowUpTask\">\r\n  <ng-container *ngIf=\"createdFollowUpTask; else displayCreateTaskForm\">\r\n    <div class=\"form-group modal-body\">\r\n      <div *ngIf=\"!hideHeaderRow\" class=\"row mb-2\"></div>\r\n      <div class=\"mb-4\">\r\n        <div class=\"task-created\">\r\n          <span class=\"pr-2 pl-1\">\r\n            <i class=\"fas fa-check-circle task-created\" aria-hidden=\"true\"></i>\r\n          </span>\r\n          {{ successMessage }}\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n  <ng-template #displayCreateTaskForm>\r\n    <div class=\"form-group modal-body mb-5\">\r\n      <div *ngIf=\"!hideHeaderRow\" class=\"row mb-2\"></div>\r\n      <div>\r\n        <h5 class=\"Spa_Style_H5 mb-2\" [innerHTML]=\"taskHeader | safe : 'html'\"></h5>\r\n      </div>\r\n      <div>\r\n        <span class=\"input-error-asterisk\">*</span>\r\n        <label class=\"Spa_Style_Label\" for=\"dueDateText\">{{ dueDateLabel }} </label><br />\r\n        <div class=\"error-container\" *ngIf=\"showDateError\">\r\n          <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n          <span>{{ getDateErrorMessage() }}</span>\r\n        </div>\r\n        <input\r\n          id=\"dueDateText\"\r\n          type=\"text\"\r\n          placeholder=\"{{ getDateFormat() }}\"\r\n          ngbAutofocus\r\n          inputmode=\"numeric\"\r\n          maxlength=\"10\"\r\n          class=\"due-date-input col-5 col-sm-4\"\r\n          autocomplete=\"off\"\r\n          formControlName=\"dueDateText\"\r\n          aria-required=\"true\"\r\n          mask=\"{{ dateMaskFormat }}\"\r\n          [dropSpecialCharacters]=\"false\"\r\n          [(ngModel)]=\"dateValue\"\r\n          (blur)=\"validateDate($event)\"\r\n        />\r\n        <input\r\n          type=\"text\"\r\n          aria-hidden=\"true\"\r\n          class=\"date-picker-input\"\r\n          ngbDatepicker\r\n          tabindex=\"-1\"\r\n          #datePickerInput=\"ngbDatepicker\"\r\n          (dateSelect)=\"selectDate($event)\"\r\n          (select)=\"selectDate($event)\"\r\n        />\r\n        <button type=\"button\" class=\"btn btn-calendar\" tabindex=\"0\" (click)=\"datePickerInput.toggle()\">\r\n          <i class=\"fas fa-calendar-alt\"></i>\r\n        </button>\r\n      </div>\r\n      <div class=\"mb-2 mt-3\">\r\n        <span class=\"input-error-asterisk\">*</span>\r\n\r\n        <label class=\"Spa_Style_Label\" for=\"textContent\">{{ taskLabel }} </label>\r\n        <div class=\"error-container\" *ngIf=\"!isValid('taskText') && showError\">\r\n          <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n          <span>{{ contentErrorText }}</span>\r\n        </div>\r\n        <textarea\r\n          id=\"textContent\"\r\n          type=\"text\"\r\n          rows=\"4\"\r\n          maxlength=\"450\"\r\n          required\r\n          name=\"textContent\"\r\n          formControlName=\"taskText\"\r\n          class=\"md-textarea form-control\"\r\n          [(ngModel)]=\"captureTaskText\"\r\n        ></textarea>\r\n      </div>\r\n      <div class=\"button-right\">\r\n        <button type=\"button\" tabindex=\"0\" (click)=\"addTask()\" class=\"btn Spa_Style_PrimaryButton\">\r\n          {{ addTaskText }}\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n</form>\r\n", styles: [".btn-calendar{position:absolute;margin-left:-45px}.due-date-input{position:relative}.date-picker-input{position:absolute;color:transparent;z-index:-1}.row{margin-top:auto;border-top:1px solid var(--static-Spa_Style_Gray2);margin-left:0;margin-right:0}.button-right{position:relative;float:right}.task-created{color:var(--static-Spa_Style_Cost_Text)}\n"] }]
    }], function () { return [{ type: i2.Store }, { type: AgentTaskFacade }, { type: i1.ConfigResourceService }, { type: AnalyticsService }]; }, { taskType: [{
            type: Input
        }], followUpTaskText: [{
            type: Input
        }], taskDueDateOffset: [{
            type: Input
        }], hideHeaderRow: [{
            type: Input
        }] }); })();

function NoticeWarnListComponent_ul_0_li_1_vnext_link_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-link", 4);
} if (rf & 2) {
    const message_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("title", message_r2.link.title)("tag", message_r2.link.tag)("href", message_r2.link.href);
} }
function NoticeWarnListComponent_ul_0_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelement(1, "span", 2);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵtemplate(3, NoticeWarnListComponent_ul_0_li_1_vnext_link_3_Template, 1, 3, "vnext-link", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r2 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 2, message_r2.message, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", message_r2.link);
} }
function NoticeWarnListComponent_ul_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul");
    i0.ɵɵtemplate(1, NoticeWarnListComponent_ul_0_li_1_Template, 4, 5, "li", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.warningCustomClass);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.messages);
} }
class NoticeWarnListComponent {
    constructor() {
        this.messages = [];
    }
}
NoticeWarnListComponent.ɵfac = function NoticeWarnListComponent_Factory(t) { return new (t || NoticeWarnListComponent)(); };
NoticeWarnListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NoticeWarnListComponent, selectors: [["vnext-notice-warn-list"]], inputs: { messages: "messages", warningCustomClass: "warningCustomClass" }, decls: 1, vars: 1, consts: [[3, "class", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["navigationAdapter", "", 1, "warn-list-message", "Spa_Style_Small_Font", "Spa_Style_Primary_Color", "Spa_Style_Regular_Weight", 3, "innerHTML"], [3, "title", "tag", "href", 4, "ngIf"], [3, "title", "tag", "href"]], template: function NoticeWarnListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, NoticeWarnListComponent_ul_0_Template, 2, 4, "ul", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.messages && ctx.messages.length > 0);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, NavigationAdapterDirective, LinkComponent, SafePipe], styles: ["li[_ngcontent-%COMP%]{list-style-type:none;margin-left:-18px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NoticeWarnListComponent, [{
        type: Component,
        args: [{ selector: 'vnext-notice-warn-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ul class=\"{{warningCustomClass}}\" *ngIf=\"messages && messages.length > 0\">\r\n  <li *ngFor=\"let message of messages\">\r\n    <span\r\n      class=\"warn-list-message Spa_Style_Small_Font Spa_Style_Primary_Color Spa_Style_Regular_Weight\"\r\n      [innerHTML]=\"message.message | safe:'html'\"\r\n      navigationAdapter\r\n    ></span>\r\n    <vnext-link *ngIf=\"message.link\" [title]=\"message.link.title\" [tag]=\"message.link.tag\" [href]=\"message.link.href\"></vnext-link>\r\n  </li>\r\n</ul>\r\n", styles: ["li{list-style-type:none;margin-left:-18px}\n"] }]
    }], null, { messages: [{
            type: Input
        }], warningCustomClass: [{
            type: Input
        }] }); })();

function NoticeSuccessListComponent_div_0_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 3);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const message_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, message_r1.message, "html"), i0.ɵɵsanitizeHtml);
} }
function NoticeSuccessListComponent_div_0_vnext_link_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-link", 4);
} if (rf & 2) {
    const message_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("title", message_r1.link.title)("tag", message_r1.link.tag)("href", message_r1.link.href);
} }
function NoticeSuccessListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, NoticeSuccessListComponent_div_0_span_1_Template, 2, 4, "span", 1);
    i0.ɵɵtemplate(2, NoticeSuccessListComponent_div_0_vnext_link_2_Template, 1, 3, "vnext-link", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r1 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", message_r1.liveEditProp);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", message_r1.link);
} }
class NoticeSuccessListComponent {
    constructor() {
        this.messages = [];
    }
}
NoticeSuccessListComponent.ɵfac = function NoticeSuccessListComponent_Factory(t) { return new (t || NoticeSuccessListComponent)(); };
NoticeSuccessListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NoticeSuccessListComponent, selectors: [["vnext-notice-success-list"]], inputs: { messages: "messages" }, decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], ["class", "Spa_Style_Small_Font Spa_Style_Primary_Color Spa_Style_Regular_Weight", "navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], [3, "title", "tag", "href", 4, "ngIf"], ["navigationAdapter", "", 1, "Spa_Style_Small_Font", "Spa_Style_Primary_Color", "Spa_Style_Regular_Weight", 3, "innerHTML"], [3, "title", "tag", "href"]], template: function NoticeSuccessListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, NoticeSuccessListComponent_div_0_Template, 3, 2, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.messages);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, NavigationAdapterDirective, LiveEditPropDirective, LinkComponent, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NoticeSuccessListComponent, [{
        type: Component,
        args: [{ selector: 'vnext-notice-success-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngFor=\"let message of messages\">\r\n  <span\r\n    class=\"Spa_Style_Small_Font Spa_Style_Primary_Color Spa_Style_Regular_Weight\"\r\n    [innerHTML]=\"message.message | safe:'html'\"\r\n    *liveEditProp=\"message.liveEditProp\"\r\n    navigationAdapter\r\n  ></span>\r\n  <vnext-link *ngIf=\"message.link\" [title]=\"message.link.title\" [tag]=\"message.link.tag\" [href]=\"message.link.href\"></vnext-link>\r\n</div>\r\n" }]
    }], null, { messages: [{
            type: Input
        }] }); })();

function NoticeInfoListComponent_p_0_vnext_link_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-link", 3);
} if (rf & 2) {
    const message_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("title", message_r1.link.title)("tag", message_r1.link.tag)("href", message_r1.link.href);
} }
function NoticeInfoListComponent_p_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵelement(1, "span", 1);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵtemplate(3, NoticeInfoListComponent_p_0_vnext_link_3_Template, 1, 3, "vnext-link", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.infoCustomClass);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 5, message_r1.message, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", message_r1.link);
} }
class NoticeInfoListComponent {
    constructor() {
        this.messages = [];
    }
}
NoticeInfoListComponent.ɵfac = function NoticeInfoListComponent_Factory(t) { return new (t || NoticeInfoListComponent)(); };
NoticeInfoListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NoticeInfoListComponent, selectors: [["vnext-notice-info-list"]], inputs: { messages: "messages", infoCustomClass: "infoCustomClass" }, decls: 1, vars: 1, consts: [[3, "class", 4, "ngFor", "ngForOf"], ["navigationAdapter", "", 1, "Spa_Style_Small_Font", "Spa_Style_Primary_Color", "Spa_Style_Light_Weight", 3, "innerHTML"], [3, "title", "tag", "href", 4, "ngIf"], [3, "title", "tag", "href"]], template: function NoticeInfoListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, NoticeInfoListComponent_p_0_Template, 4, 8, "p", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.messages);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, NavigationAdapterDirective, LinkComponent, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NoticeInfoListComponent, [{
        type: Component,
        args: [{ selector: 'vnext-notice-info-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<p class=\"{{infoCustomClass}}\" *ngFor=\"let message of messages\">\r\n  <span\r\n    class=\"Spa_Style_Small_Font Spa_Style_Primary_Color Spa_Style_Light_Weight\"\r\n    [innerHTML]=\"message.message | safe:'html'\"\r\n    navigationAdapter\r\n  ></span>\r\n  <vnext-link *ngIf=\"message.link\" [title]=\"message.link.title\" [tag]=\"message.link.tag\" [href]=\"message.link.href\"></vnext-link>\r\n</p>\r\n" }]
    }], null, { messages: [{
            type: Input
        }], infoCustomClass: [{
            type: Input
        }] }); })();

function NoticeErrorListComponent_li_1_vnext_link_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-link", 4);
} if (rf & 2) {
    const message_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("title", message_r1.link.title)("tag", message_r1.link.tag)("href", message_r1.link.href);
} }
function NoticeErrorListComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "span", 1);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 2);
    i0.ɵɵpipe(4, "safe");
    i0.ɵɵtemplate(5, NoticeErrorListComponent_li_1_vnext_link_5_Template, 1, 3, "vnext-link", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.errorKeywordText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 3, message_r1.message, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", message_r1.link);
} }
class NoticeErrorListComponent {
    constructor() {
        this.messages = [];
    }
}
NoticeErrorListComponent.ɵfac = function NoticeErrorListComponent_Factory(t) { return new (t || NoticeErrorListComponent)(); };
NoticeErrorListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NoticeErrorListComponent, selectors: [["vnext-notice-error-list"]], inputs: { messages: "messages", errorKeywordText: "errorKeywordText", errorCustomClass: "errorCustomClass" }, decls: 2, vars: 4, consts: [[4, "ngFor", "ngForOf"], [1, "sr-only"], ["navigationAdapter", "", 1, "Spa_Style_Small_Font", "Spa_Style_Primary_Color", "Spa_Style_Regular_Weight", 3, "innerHTML"], [3, "title", "tag", "href", 4, "ngIf"], [3, "title", "tag", "href"]], template: function NoticeErrorListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ul");
        i0.ɵɵtemplate(1, NoticeErrorListComponent_li_1_Template, 6, 6, "li", 0);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassMap(ctx.errorCustomClass);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.messages);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, NavigationAdapterDirective, LinkComponent, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NoticeErrorListComponent, [{
        type: Component,
        args: [{ selector: 'vnext-notice-error-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ul class=\"{{errorCustomClass}}\">\r\n  <li *ngFor=\"let message of messages\">\r\n    <span class=\"sr-only\">{{ errorKeywordText }}</span>\r\n    <span\r\n      class=\"Spa_Style_Small_Font Spa_Style_Primary_Color Spa_Style_Regular_Weight\"\r\n      [innerHTML]=\"message.message | safe:'html'\"\r\n      navigationAdapter\r\n    ></span>\r\n    <vnext-link *ngIf=\"message.link\" [title]=\"message.link.title\" [tag]=\"message.link.tag\" [href]=\"message.link.href\"> </vnext-link>\r\n  </li>\r\n</ul>\r\n" }]
    }], null, { messages: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], errorCustomClass: [{
            type: Input
        }] }); })();

function NoticeComponent_ng_container_2_ng_container_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function NoticeComponent_ng_container_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 12);
    i0.ɵɵtemplate(2, NoticeComponent_ng_container_2_ng_container_4_ng_container_2_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.titleTemplate);
} }
function NoticeComponent_ng_container_2_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 14);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("notice__title mb-0 ", ctx_r5.titleCustomClass, "");
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 4, ctx_r5.title, "html"), i0.ɵɵsanitizeHtml);
} }
function NoticeComponent_ng_container_2_ng_container_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function NoticeComponent_ng_container_2_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p", 15);
    i0.ɵɵtemplate(2, NoticeComponent_ng_container_2_ng_container_7_ng_container_2_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r6.bodyTemplate);
} }
function NoticeComponent_ng_container_2_ng_template_8_vnext_notice_success_list_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice-success-list", 22);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("messages", ctx_r12.messages);
} }
function NoticeComponent_ng_container_2_ng_template_8_vnext_notice_warn_list_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice-warn-list", 23);
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("messages", ctx_r13.messages)("warningCustomClass", ctx_r13.warningCustomClass);
} }
function NoticeComponent_ng_container_2_ng_template_8_vnext_notice_error_list_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice-error-list", 24);
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("messages", ctx_r14.messages)("errorKeywordText", ctx_r14.errorKeywordText)("errorCustomClass", ctx_r14.errorCustomClass);
} }
function NoticeComponent_ng_container_2_ng_template_8_vnext_notice_info_list_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice-info-list", 25);
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("messages", ctx_r15.messages)("infoCustomClass", ctx_r15.infoCustomClass);
} }
function NoticeComponent_ng_container_2_ng_template_8_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 26);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r16.continueText, "html"), i0.ɵɵsanitizeHtml);
} }
function NoticeComponent_ng_container_2_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 16);
    i0.ɵɵtemplate(1, NoticeComponent_ng_container_2_ng_template_8_vnext_notice_success_list_1_Template, 1, 1, "vnext-notice-success-list", 17);
    i0.ɵɵtemplate(2, NoticeComponent_ng_container_2_ng_template_8_vnext_notice_warn_list_2_Template, 1, 2, "vnext-notice-warn-list", 18);
    i0.ɵɵtemplate(3, NoticeComponent_ng_container_2_ng_template_8_vnext_notice_error_list_3_Template, 1, 3, "vnext-notice-error-list", 19);
    i0.ɵɵtemplate(4, NoticeComponent_ng_container_2_ng_template_8_vnext_notice_info_list_4_Template, 1, 2, "vnext-notice-info-list", 20);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(5, NoticeComponent_ng_container_2_ng_template_8_div_5_Template, 2, 4, "div", 21);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngSwitch", ctx_r8.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "success");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "warn");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "error");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "info");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.continueText);
} }
function NoticeComponent_ng_container_2_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27, 28);
    i0.ɵɵlistener("click", function NoticeComponent_ng_container_2_button_12_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r19); const _r17 = i0.ɵɵreference(1); const ctx_r18 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r18.applyClick(_r17)); })("blur", function NoticeComponent_ng_container_2_button_12_Template_button_blur_0_listener() { i0.ɵɵrestoreView(_r19); const _r17 = i0.ɵɵreference(1); const ctx_r20 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r20.closeTooltipEvent.emit(_r17)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    let tmp_2_0;
    i0.ɵɵclassMapInterpolate1("btn Spa_Style_PrimaryButton ", ctx_r9.buttonCustomClass, "");
    i0.ɵɵproperty("ngbTooltip", ctx_r9.toolTipText);
    i0.ɵɵattribute("aria-label", (tmp_2_0 = ctx_r9.buttonAriaLabel) !== null && tmp_2_0 !== undefined ? tmp_2_0 : null);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.buttonText, " ");
} }
function NoticeComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 4)(2, "div", 5)(3, "div", 6);
    i0.ɵɵtemplate(4, NoticeComponent_ng_container_2_ng_container_4_Template, 3, 1, "ng-container", 2);
    i0.ɵɵtemplate(5, NoticeComponent_ng_container_2_ng_template_5_Template, 2, 7, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(7, NoticeComponent_ng_container_2_ng_container_7_Template, 3, 1, "ng-container", 2);
    i0.ɵɵtemplate(8, NoticeComponent_ng_container_2_ng_template_8_Template, 6, 6, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 9)(11, "div", 10);
    i0.ɵɵtemplate(12, NoticeComponent_ng_container_2_button_12_Template, 3, 6, "button", 11);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r4 = i0.ɵɵreference(6);
    const _r7 = i0.ɵɵreference(9);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.titleTemplate)("ngIfElse", _r4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.bodyTemplate)("ngIfElse", _r7);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("liveEditProp", ctx_r0.keyNameForLiveEdit);
} }
function NoticeComponent_ng_template_3_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function NoticeComponent_ng_template_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 12);
    i0.ɵɵtemplate(2, NoticeComponent_ng_template_3_ng_container_1_ng_container_2_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r21.titleTemplate);
} }
function NoticeComponent_ng_template_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 29);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r23.title, "html"), i0.ɵɵsanitizeHtml);
} }
function NoticeComponent_ng_template_3_ng_container_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function NoticeComponent_ng_template_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p", 15);
    i0.ɵɵtemplate(2, NoticeComponent_ng_template_3_ng_container_4_ng_container_2_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r24.bodyTemplate);
} }
function NoticeComponent_ng_template_3_ng_template_5_vnext_notice_success_list_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice-success-list", 22);
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("messages", ctx_r29.messages);
} }
function NoticeComponent_ng_template_3_ng_template_5_vnext_notice_warn_list_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice-warn-list", 23);
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("messages", ctx_r30.messages)("warningCustomClass", ctx_r30.warningCustomClass);
} }
function NoticeComponent_ng_template_3_ng_template_5_vnext_notice_error_list_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice-error-list", 24);
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("messages", ctx_r31.messages)("errorKeywordText", ctx_r31.errorKeywordText)("errorCustomClass", ctx_r31.errorCustomClass);
} }
function NoticeComponent_ng_template_3_ng_template_5_vnext_notice_info_list_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice-info-list", 25);
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("messages", ctx_r32.messages)("infoCustomClass", ctx_r32.infoCustomClass);
} }
function NoticeComponent_ng_template_3_ng_template_5_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 26);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r33.continueText, "html"), i0.ɵɵsanitizeHtml);
} }
function NoticeComponent_ng_template_3_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 16);
    i0.ɵɵtemplate(1, NoticeComponent_ng_template_3_ng_template_5_vnext_notice_success_list_1_Template, 1, 1, "vnext-notice-success-list", 17);
    i0.ɵɵtemplate(2, NoticeComponent_ng_template_3_ng_template_5_vnext_notice_warn_list_2_Template, 1, 2, "vnext-notice-warn-list", 18);
    i0.ɵɵtemplate(3, NoticeComponent_ng_template_3_ng_template_5_vnext_notice_error_list_3_Template, 1, 3, "vnext-notice-error-list", 19);
    i0.ɵɵtemplate(4, NoticeComponent_ng_template_3_ng_template_5_vnext_notice_info_list_4_Template, 1, 2, "vnext-notice-info-list", 20);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(5, NoticeComponent_ng_template_3_ng_template_5_div_5_Template, 2, 4, "div", 21);
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngSwitch", ctx_r26.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "success");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "warn");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "error");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "info");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r26.continueText);
} }
function NoticeComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, NoticeComponent_ng_template_3_ng_container_1_Template, 3, 1, "ng-container", 2);
    i0.ɵɵtemplate(2, NoticeComponent_ng_template_3_ng_template_2_Template, 2, 4, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, NoticeComponent_ng_template_3_ng_container_4_Template, 3, 1, "ng-container", 2);
    i0.ɵɵtemplate(5, NoticeComponent_ng_template_3_ng_template_5_Template, 6, 6, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r22 = i0.ɵɵreference(3);
    const _r25 = i0.ɵɵreference(6);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.titleTemplate)("ngIfElse", _r22);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.bodyTemplate)("ngIfElse", _r25);
} }
class NoticeComponent {
    constructor() {
        this.type = NOTICE_TYPE.INFO;
        this.size = 'large';
        this.title = '';
        this.messages = [];
        this.continueText = '';
        this.hasButton = false;
        this.keyNameForLiveEdit = '';
        this.applyEvent = new EventEmitter();
        this.closeTooltipEvent = new EventEmitter();
    }
    applyClick(tooltip) {
        this.applyEvent.emit(tooltip);
    }
    ngOnInit() {
        this.noticeClass = `notice--${this.type}${this.size === 'small' ? ' notice--small' : ''}`;
        if (this.type === NOTICE_TYPE.INFO) {
            this.noticeClass = `${this.noticeClass} Spa_Style_InfoBackGround Spa_Style_InfoBarAndIconColor`;
        }
        else if (this.type === NOTICE_TYPE.WARN) {
            this.noticeClass = `${this.noticeClass} Spa_Style_WarningBackground Spa_Style_WarningBarAndHealthSlider`;
        }
        else if (this.type === NOTICE_TYPE.SUCCESS) {
            this.noticeClass = `${this.noticeClass} Spa_Style_SuccessBarAndIconColor Spa_Style_SuccessBackground`;
        }
        else if (this.type === NOTICE_TYPE.ERROR) {
            this.noticeClass = `${this.noticeClass} Spa_Style_ErrorBackground Spa_Style_ErrorBarAndIconColor`;
        }
    }
}
NoticeComponent.ɵfac = function NoticeComponent_Factory(t) { return new (t || NoticeComponent)(); };
NoticeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NoticeComponent, selectors: [["vnext-notice"]], inputs: { type: "type", size: "size", title: "title", errorKeywordText: "errorKeywordText", messages: "messages", continueText: "continueText", bodyTemplate: "bodyTemplate", titleTemplate: "titleTemplate", titleCustomClass: "titleCustomClass", buttonCustomClass: "buttonCustomClass", infoCustomClass: "infoCustomClass", warningCustomClass: "warningCustomClass", errorCustomClass: "errorCustomClass", hasButton: "hasButton", buttonText: "buttonText", toolTipText: "toolTipText", keyNameForLiveEdit: "keyNameForLiveEdit", buttonAriaLabel: "buttonAriaLabel" }, outputs: { applyEvent: "applyEvent", closeTooltipEvent: "closeTooltipEvent" }, decls: 5, vars: 3, consts: [[1, "notice", 3, "ngClass"], ["aria-hidden", "true", 1, "notice-icon"], [4, "ngIf", "ngIfElse"], ["noButton", ""], ["role", "alert", 1, "notice__body"], [1, "row"], [1, "col-md-7"], ["titleBlock", ""], ["messageBlock", ""], [1, "col-md-5"], ["continue-button", ""], ["type", "button", "triggers", "manual", 3, "class", "ngbTooltip", "click", "blur", 4, "liveEditProp"], [1, "notice__title", "mb-0"], [4, "ngTemplateOutlet"], [3, "innerHTML"], [1, "Spa_Style_Paragraph", "mb-0"], [3, "ngSwitch"], [3, "messages", 4, "ngSwitchCase"], [3, "messages", "warningCustomClass", 4, "ngSwitchCase"], [3, "messages", "errorKeywordText", "errorCustomClass", 4, "ngSwitchCase"], [3, "messages", "infoCustomClass", 4, "ngSwitchCase"], ["class", "Spa_Style_Small_Font Spa_Style_Primary_Color Spa_Style_Regular_Weight mt-2", 3, "innerHTML", 4, "ngIf"], [3, "messages"], [3, "messages", "warningCustomClass"], [3, "messages", "errorKeywordText", "errorCustomClass"], [3, "messages", "infoCustomClass"], [1, "Spa_Style_Small_Font", "Spa_Style_Primary_Color", "Spa_Style_Regular_Weight", "mt-2", 3, "innerHTML"], ["type", "button", "triggers", "manual", 3, "ngbTooltip", "click", "blur"], ["tooltip", "ngbTooltip"], [1, "notice__title", "mb-0", 3, "innerHTML"]], template: function NoticeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "span", 1);
        i0.ɵɵtemplate(2, NoticeComponent_ng_container_2_Template, 13, 5, "ng-container", 2);
        i0.ɵɵtemplate(3, NoticeComponent_ng_template_3_Template, 7, 4, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(4);
        i0.ɵɵproperty("ngClass", ctx.noticeClass);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.hasButton)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$2.NgTemplateOutlet, i1$2.NgSwitch, i1$2.NgSwitchCase, LiveEditPropDirective, i1$1.NgbTooltip, NoticeWarnListComponent, NoticeSuccessListComponent, NoticeInfoListComponent, NoticeErrorListComponent, SafePipe], styles: [".notice[_ngcontent-%COMP%]{border-radius:5px;border-style:solid;border-color:#fff;border-width:1px;border-left-width:5px;box-shadow:inset 1px 0 #fff;clear:both;line-height:1.3;margin:9px 0;min-height:auto;padding:16px 15px 16px 62px;position:relative;text-align:left;width:100%}.notice[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin:0}.notice[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{word-break:break-word;overflow-wrap:break-word}.notice[_ngcontent-%COMP%]   .notice-icon[_ngcontent-%COMP%], .notice[_ngcontent-%COMP%]   .notice-icon[_ngcontent-%COMP%]:before{display:inline-block;font: 14px/1 \"Font Awesome 5 Pro\";font-size:28px;font-size:1.75rem;font-weight:900;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;content:\"\\f12a\";height:32px;left:12px;position:absolute;text-align:center;top:25%;width:35px}.notice[_ngcontent-%COMP%]   .notice-icon[_ngcontent-%COMP%]:before{left:0;top:0}.notice[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:underline}.notice[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover, .notice[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:focus{text-decoration:underline}.notice[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]{position:absolute;right:12px;top:12px}.notice--error[_ngcontent-%COMP%]{border-left-color:var(--static-Spa_Style_Accent2);background:#f7d9d9}.notice--error[_ngcontent-%COMP%]   .notice-icon[_ngcontent-%COMP%]:before{content:\"\\f06a\";font-family:\"Font Awesome 5 Pro\";font-weight:900;color:var(--static-Spa_Style_Accent2)}.notice--info[_ngcontent-%COMP%]{border-left-color:var(--static-Spa_Style_Info);background:var(--static-Spa_Style_Info_Lighter)}.notice--info[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Info_Darker)}.notice--info[_ngcontent-%COMP%]   .notice-icon[_ngcontent-%COMP%]:before{content:\"\\f05a\";font-family:\"Font Awesome 5 Pro\";font-weight:900;color:var(--static-Spa_Style_Info)}.notice--success[_ngcontent-%COMP%]{border-left-color:var(--static-Spa_Style_Cost_Text);background:var(--static-Spa_Style_Cost)}.notice--success[_ngcontent-%COMP%]   .notice-icon[_ngcontent-%COMP%]:before{content:\"\\f058\";font-family:\"Font Awesome 5 Pro\";font-weight:900;color:var(--static-Spa_Style_Cost_Text)}.notice--warn[_ngcontent-%COMP%]{border-left-color:var(--static-Spa_Style_Accent4);background:var(--static-Spa_Style_Warn_Lighter)}.notice--warn[_ngcontent-%COMP%]   .notice-icon[_ngcontent-%COMP%]:before{content:\"\\f071\";font-family:\"Font Awesome 5 Pro\";font-weight:900;color:var(--static-Spa_Style_Accent4)}.close[_ngcontent-%COMP%]{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0;padding:0}.close[_ngcontent-%COMP%]:before{display:inline-block;font: 14px/1 \"Font Awesome 5 Pro\";font-size:14px;font-size:1rem;font-weight:900;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;content:\"\\f00d\";color:var(--static-Spa_Style_Primary)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NoticeComponent, [{
        type: Component,
        args: [{ selector: 'vnext-notice', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"notice\" [ngClass]=\"noticeClass\">\r\n  <span class=\"notice-icon\" aria-hidden=\"true\"></span>\r\n  <ng-container *ngIf=\"hasButton; else noButton\">\r\n    <div class=\"notice__body\" role=\"alert\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-7\">\r\n          <ng-container *ngIf=\"titleTemplate; else titleBlock\">\r\n            <div class=\"notice__title mb-0\">\r\n              <ng-container *ngTemplateOutlet=\"titleTemplate\"></ng-container>\r\n            </div>\r\n          </ng-container>\r\n          <ng-template #titleBlock>\r\n            <div class=\"notice__title mb-0 {{ titleCustomClass }}\" [innerHTML]=\"title | safe : 'html'\"></div>\r\n          </ng-template>\r\n          <ng-container *ngIf=\"bodyTemplate; else messageBlock\">\r\n            <p class=\"Spa_Style_Paragraph mb-0\">\r\n              <ng-container *ngTemplateOutlet=\"bodyTemplate\"></ng-container>\r\n            </p>\r\n          </ng-container>\r\n          <ng-template #messageBlock>\r\n            <ng-container [ngSwitch]=\"type\">\r\n              <vnext-notice-success-list *ngSwitchCase=\"'success'\" [messages]=\"messages\"></vnext-notice-success-list>\r\n              <vnext-notice-warn-list\r\n                *ngSwitchCase=\"'warn'\"\r\n                [messages]=\"messages\"\r\n                [warningCustomClass]=\"warningCustomClass\"\r\n              ></vnext-notice-warn-list>\r\n              <vnext-notice-error-list\r\n                *ngSwitchCase=\"'error'\"\r\n                [messages]=\"messages\"\r\n                [errorKeywordText]=\"errorKeywordText\"\r\n                [errorCustomClass]=\"errorCustomClass\"\r\n              ></vnext-notice-error-list>\r\n              <vnext-notice-info-list\r\n                *ngSwitchCase=\"'info'\"\r\n                [messages]=\"messages\"\r\n                [infoCustomClass]=\"infoCustomClass\"\r\n              ></vnext-notice-info-list>\r\n            </ng-container>\r\n            <div\r\n              *ngIf=\"continueText\"\r\n              class=\"Spa_Style_Small_Font Spa_Style_Primary_Color Spa_Style_Regular_Weight mt-2\"\r\n              [innerHTML]=\"continueText | safe : 'html'\"\r\n            ></div>\r\n          </ng-template>\r\n        </div>\r\n        <div class=\"col-md-5\">\r\n          <div continue-button>\r\n            <button\r\n              class=\"btn Spa_Style_PrimaryButton {{ buttonCustomClass }}\"\r\n              (click)=\"applyClick(tooltip)\"\r\n              type=\"button\"\r\n              triggers=\"manual\"\r\n              #tooltip=\"ngbTooltip\"\r\n              [ngbTooltip]=\"toolTipText\"\r\n              [attr.aria-label]=\"buttonAriaLabel ?? null\"\r\n              (blur)=\"closeTooltipEvent.emit(tooltip)\"\r\n              *liveEditProp=\"keyNameForLiveEdit\"\r\n            >\r\n              {{ buttonText }}\r\n            </button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n  <ng-template #noButton>\r\n    <div class=\"notice__body\" role=\"alert\">\r\n      <ng-container *ngIf=\"titleTemplate; else titleBlock\">\r\n        <div class=\"notice__title mb-0\">\r\n          <ng-container *ngTemplateOutlet=\"titleTemplate\"></ng-container>\r\n        </div>\r\n      </ng-container>\r\n      <ng-template #titleBlock>\r\n        <div class=\"notice__title mb-0\" [innerHTML]=\"title | safe : 'html'\"></div>\r\n      </ng-template>\r\n      <ng-container *ngIf=\"bodyTemplate; else messageBlock\">\r\n        <p class=\"Spa_Style_Paragraph mb-0\">\r\n          <ng-container *ngTemplateOutlet=\"bodyTemplate\"></ng-container>\r\n        </p>\r\n      </ng-container>\r\n      <ng-template #messageBlock>\r\n        <ng-container [ngSwitch]=\"type\">\r\n          <vnext-notice-success-list *ngSwitchCase=\"'success'\" [messages]=\"messages\"></vnext-notice-success-list>\r\n          <vnext-notice-warn-list\r\n            *ngSwitchCase=\"'warn'\"\r\n            [messages]=\"messages\"\r\n            [warningCustomClass]=\"warningCustomClass\"\r\n          ></vnext-notice-warn-list>\r\n          <vnext-notice-error-list\r\n            *ngSwitchCase=\"'error'\"\r\n            [messages]=\"messages\"\r\n            [errorKeywordText]=\"errorKeywordText\"\r\n            [errorCustomClass]=\"errorCustomClass\"\r\n          ></vnext-notice-error-list>\r\n          <vnext-notice-info-list *ngSwitchCase=\"'info'\" [messages]=\"messages\" [infoCustomClass]=\"infoCustomClass\"></vnext-notice-info-list>\r\n        </ng-container>\r\n        <div\r\n          *ngIf=\"continueText\"\r\n          class=\"Spa_Style_Small_Font Spa_Style_Primary_Color Spa_Style_Regular_Weight mt-2\"\r\n          [innerHTML]=\"continueText | safe : 'html'\"\r\n        ></div>\r\n      </ng-template>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n", styles: [".notice{border-radius:5px;border-style:solid;border-color:#fff;border-width:1px;border-left-width:5px;box-shadow:inset 1px 0 #fff;clear:both;line-height:1.3;margin:9px 0;min-height:auto;padding:16px 15px 16px 62px;position:relative;text-align:left;width:100%}.notice>*{margin:0}.notice h5{word-break:break-word;overflow-wrap:break-word}.notice .notice-icon,.notice .notice-icon:before{display:inline-block;font: 14px/1 \"Font Awesome 5 Pro\";font-size:28px;font-size:1.75rem;font-weight:900;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;content:\"\\f12a\";height:32px;left:12px;position:absolute;text-align:center;top:25%;width:35px}.notice .notice-icon:before{left:0;top:0}.notice a{text-decoration:underline}.notice a:hover,.notice a:focus{text-decoration:underline}.notice .close{position:absolute;right:12px;top:12px}.notice--error{border-left-color:var(--static-Spa_Style_Accent2);background:#f7d9d9}.notice--error .notice-icon:before{content:\"\\f06a\";font-family:\"Font Awesome 5 Pro\";font-weight:900;color:var(--static-Spa_Style_Accent2)}.notice--info{border-left-color:var(--static-Spa_Style_Info);background:var(--static-Spa_Style_Info_Lighter)}.notice--info a{color:var(--static-Spa_Style_Info_Darker)}.notice--info .notice-icon:before{content:\"\\f05a\";font-family:\"Font Awesome 5 Pro\";font-weight:900;color:var(--static-Spa_Style_Info)}.notice--success{border-left-color:var(--static-Spa_Style_Cost_Text);background:var(--static-Spa_Style_Cost)}.notice--success .notice-icon:before{content:\"\\f058\";font-family:\"Font Awesome 5 Pro\";font-weight:900;color:var(--static-Spa_Style_Cost_Text)}.notice--warn{border-left-color:var(--static-Spa_Style_Accent4);background:var(--static-Spa_Style_Warn_Lighter)}.notice--warn .notice-icon:before{content:\"\\f071\";font-family:\"Font Awesome 5 Pro\";font-weight:900;color:var(--static-Spa_Style_Accent4)}.close{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0;padding:0}.close:before{display:inline-block;font: 14px/1 \"Font Awesome 5 Pro\";font-size:14px;font-size:1rem;font-weight:900;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;content:\"\\f00d\";color:var(--static-Spa_Style_Primary)}\n"] }]
    }], null, { type: [{
            type: Input
        }], size: [{
            type: Input
        }], title: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], messages: [{
            type: Input
        }], continueText: [{
            type: Input
        }], bodyTemplate: [{
            type: Input
        }], titleTemplate: [{
            type: Input
        }], titleCustomClass: [{
            type: Input
        }], buttonCustomClass: [{
            type: Input
        }], infoCustomClass: [{
            type: Input
        }], warningCustomClass: [{
            type: Input
        }], errorCustomClass: [{
            type: Input
        }], hasButton: [{
            type: Input
        }], buttonText: [{
            type: Input
        }], toolTipText: [{
            type: Input
        }], keyNameForLiveEdit: [{
            type: Input
        }], buttonAriaLabel: [{
            type: Input
        }], applyEvent: [{
            type: Output
        }], closeTooltipEvent: [{
            type: Output
        }] }); })();

function SendQuoteConfirmationModalComponent_vnext_link_9_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 11);
    i0.ɵɵlistener("click", function SendQuoteConfirmationModalComponent_vnext_link_9_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.viewMemberProfile()); })("keyup.Enter", function SendQuoteConfirmationModalComponent_vnext_link_9_Template_vnext_link_keyup_Enter_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.viewMemberProfile()); });
    i0.ɵɵelementStart(1, "span", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelement(3, "i", 13);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("alwaysUnderlined", false);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.modalViewMemberLink, "");
} }
function SendQuoteConfirmationModalComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "vnext-followup-task", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("taskType", ctx_r1.taskType)("followUpTaskText", ctx_r1.followUpTaskText);
} }
function SendQuoteConfirmationModalComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 15);
    i0.ɵɵlistener("click", function SendQuoteConfirmationModalComponent_ng_container_12_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.closeSendQuoteModal()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.modalCloseText, " ");
} }
function SendQuoteConfirmationModalComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function SendQuoteConfirmationModalComponent_ng_template_13_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.closeSendQuoteModal()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.modalCancelText, " ");
} }
class SendQuoteConfirmationModalComponent {
    constructor(activeModal, configResourceService) {
        this.activeModal = activeModal;
        this.configResourceService = configResourceService;
    }
    ngOnInit() {
        this.isAddFollowUpTaskEnabled = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_AddFollowUp_Enabled', null, false);
        if (this.isAddFollowUpTaskEnabled) {
            this.loadFollowUpTaskAttributes();
        }
    }
    loadFollowUpTaskAttributes(widgetName) {
        this.taskType = NoteActionType.QuoteTask;
        this.followUpTaskText = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_FollowUp_Quote_Text', widgetName, 'Follow up on quote');
        this.modalCloseText = this.configResourceService.getProcessedResourceValue('Spa_Site_Close', null, 'Close');
    }
    closeSendQuoteModal() {
        this.activeModal.dismiss();
        if (this.cancelAction) {
            this.cancelAction();
        }
    }
    viewMemberProfile() {
        this.activeModal.close();
    }
}
SendQuoteConfirmationModalComponent.ɵfac = function SendQuoteConfirmationModalComponent_Factory(t) { return new (t || SendQuoteConfirmationModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i1.ConfigResourceService)); };
SendQuoteConfirmationModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SendQuoteConfirmationModalComponent, selectors: [["ng-component"]], decls: 15, vars: 11, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "px-3", "mt-3", "mb-0"], [1, "mb-1"], [3, "title", "type"], [1, "mb-4"], [1, "Spa_Style_Paragraph", 3, "innerHtml"], ["ngbAutofocus", "", "class", "d-inline-block mb-4", 3, "alwaysUnderlined", "click", "keyup.Enter", 4, "ngIf"], ["class", "mb-4", 4, "ngIf"], [1, "modal-footer", "justify-content-start"], [4, "ngIf", "ngIfElse"], ["showCancelButton", ""], ["ngbAutofocus", "", 1, "d-inline-block", "mb-4", 3, "alwaysUnderlined", "click", "keyup.Enter"], ["link-body", ""], [1, "fas", "fa-angle-right", "ml-1"], [3, "taskType", "followUpTaskText"], ["type", "button", 1, "btn", "mr-auto", "Spa_Style_SecondaryButton", 3, "click"]], template: function SendQuoteConfirmationModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div")(1, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function SendQuoteConfirmationModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_1_listener() { return ctx.closeSendQuoteModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerStart(2);
        i0.ɵɵelementStart(3, "div", 1)(4, "div", 2);
        i0.ɵɵelement(5, "vnext-notice", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵelement(7, "div", 5);
        i0.ɵɵpipe(8, "safe");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, SendQuoteConfirmationModalComponent_vnext_link_9_Template, 4, 2, "vnext-link", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerEnd();
        i0.ɵɵtemplate(10, SendQuoteConfirmationModalComponent_div_10_Template, 2, 2, "div", 7);
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵtemplate(12, SendQuoteConfirmationModalComponent_ng_container_12_Template, 3, 1, "ng-container", 9);
        i0.ɵɵtemplate(13, SendQuoteConfirmationModalComponent_ng_template_13_Template, 2, 1, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(14);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("modalTitleText", ctx.modalTitleText);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("title", ctx.modalSentConfirmationText)("type", "success");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(8, 8, ctx.authCodeSuccessMessage, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showViewMemberLink);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isAddFollowUpTaskEnabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isAddFollowUpTaskEnabled)("ngIfElse", _r3);
    } }, dependencies: [i1$2.NgIf, LinkComponent, FollowUpTaskComponent, NoticeComponent, ModalHeaderComponent, IconAriaAttributesDirective, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SendQuoteConfirmationModalComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<div>\r\n  <vnext-widget-modal-header [modalTitleText]=\"modalTitleText\" (modalTitleCancelAction)=\"closeSendQuoteModal()\"></vnext-widget-modal-header>\r\n\r\n  <ng-container>\r\n    <div class=\"px-3 mt-3 mb-0\">\r\n      <div class=\"mb-1\">\r\n        <vnext-notice [title]=\"modalSentConfirmationText\" [type]=\"'success'\"></vnext-notice>\r\n      </div>\r\n      <div class=\"mb-4\">\r\n        <div class=\"Spa_Style_Paragraph\" [innerHtml]=\"authCodeSuccessMessage | safe : 'html'\"></div>\r\n      </div>\r\n      <vnext-link\r\n        *ngIf=\"showViewMemberLink\"\r\n        ngbAutofocus\r\n        (click)=\"viewMemberProfile()\"\r\n        (keyup.Enter)=\"viewMemberProfile()\"\r\n        class=\"d-inline-block mb-4\"\r\n        [alwaysUnderlined]=\"false\"\r\n        ><span link-body> {{ modalViewMemberLink }}<i class=\"fas fa-angle-right ml-1\"></i></span>\r\n      </vnext-link>\r\n    </div>\r\n  </ng-container>\r\n  <div *ngIf=\"isAddFollowUpTaskEnabled\" class=\"mb-4\">\r\n    <vnext-followup-task [taskType]=\"taskType\" [followUpTaskText]=\"followUpTaskText\"></vnext-followup-task>\r\n  </div>\r\n  <div class=\"modal-footer justify-content-start\">\r\n    <ng-container *ngIf=\"isAddFollowUpTaskEnabled; else showCancelButton\">\r\n      <button type=\"button\" class=\"btn mr-auto Spa_Style_SecondaryButton\" (click)=\"closeSendQuoteModal()\">\r\n        {{ modalCloseText }}\r\n      </button>\r\n    </ng-container>\r\n    <ng-template #showCancelButton>\r\n      <button type=\"button\" class=\"btn mr-auto Spa_Style_SecondaryButton\" (click)=\"closeSendQuoteModal()\">\r\n        {{ modalCancelText }}\r\n      </button>\r\n    </ng-template>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i1.ConfigResourceService }]; }, null); })();

function ContactUsModalComponent_img_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 10);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.getLogoClass());
    i0.ɵɵproperty("src", ctx_r0.primaryLogo, i0.ɵɵsanitizeUrl)("alt", ctx_r0.primaryLogoAltText);
} }
function ContactUsModalComponent_img_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 11);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r1.secondaryLogo, i0.ɵɵsanitizeUrl)("alt", ctx_r1.secondaryLogoAltText);
} }
function ContactUsModalComponent_div_8_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, ",");
    i0.ɵɵelementEnd();
} }
function ContactUsModalComponent_div_8_vnext_link_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-link", 20);
} if (rf & 2) {
    const location_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate1("href", "tel:", location_r3.phoneNumber, "");
    i0.ɵɵproperty("title", location_r3.phoneNumber);
    i0.ɵɵattribute("aria-label", location_r3.title + ": " + location_r3.phoneNumber);
} }
function ContactUsModalComponent_div_8_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const location_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", location_r3.phoneNumber, " ");
} }
function ContactUsModalComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 13)(2, "h3", 14);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 15);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 15);
    i0.ɵɵtext(7);
    i0.ɵɵtemplate(8, ContactUsModalComponent_div_8_span_8_Template, 2, 0, "span", 16);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 13)(11, "div", 17);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 15);
    i0.ɵɵtemplate(14, ContactUsModalComponent_div_8_vnext_link_14_Template, 1, 3, "vnext-link", 18);
    i0.ɵɵtemplate(15, ContactUsModalComponent_div_8_ng_template_15_Template, 2, 1, "ng-template", null, 19, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(17, "div");
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(19, "vnext-link", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const location_r3 = ctx.$implicit;
    const _r6 = i0.ɵɵreference(16);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(location_r3.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(location_r3.address);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", location_r3.city, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", location_r3.city);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", location_r3.state, " ", location_r3.zipCode, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(location_r3.phoneTitle);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.isMobile)("ngIfElse", _r6);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(location_r3.hours);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("href", "mailto:", location_r3.email, "");
    i0.ɵɵproperty("title", location_r3.email);
} }
class ContactUsModalComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
    }
    getLogoClass() {
        if (this.secondaryLogo) {
            return 'header-logo primary-logo';
        }
        return 'header-logo-large primary-logo';
    }
}
ContactUsModalComponent.ɵfac = function ContactUsModalComponent_Factory(t) { return new (t || ContactUsModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal)); };
ContactUsModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ContactUsModalComponent, selectors: [["vnext-contact-us-modal"]], decls: 12, vars: 9, consts: [[3, "modalTitleText", "modalTitleCancelAction"], ["tabindex", "-1", 1, "modal-body"], [1, "container"], [3, "class", "src", "alt", 4, "ngIf"], ["class", "header-logo", 3, "src", "alt", 4, "ngIf"], ["navigationAdapter", "", 1, "Spa_Style_Primary_Color", 3, "innerHTML"], [1, "row"], ["class", "col-md-6 col-12 h-5 d-flex flex-column justify-content-between", 4, "ngFor", "ngForOf"], [1, "modal-footer", "justify-content-start"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "mr-auto", 3, "click"], [3, "src", "alt"], [1, "header-logo", 3, "src", "alt"], [1, "col-md-6", "col-12", "h-5", "d-flex", "flex-column", "justify-content-between"], [1, "no-translate-block"], [1, "Spa_Style_H3", "pt-3", "m-0"], [1, "Spa_Style_Paragraph"], [4, "ngIf"], [1, "Spa_Style_Primary_Color", "Spa_Style_Large_Font", "Spa_Style_Bold_Weight", "pt-2"], [3, "href", "title", 4, "ngIf", "ngIfElse"], ["showPhoneOnDesktop", ""], [3, "href", "title"]], template: function ContactUsModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function ContactUsModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.activeModal.close(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, ContactUsModalComponent_img_3_Template, 1, 5, "img", 3);
        i0.ɵɵtemplate(4, ContactUsModalComponent_img_4_Template, 1, 2, "img", 4);
        i0.ɵɵelement(5, "div", 5);
        i0.ɵɵpipe(6, "safe");
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵtemplate(8, ContactUsModalComponent_div_8_Template, 20, 12, "div", 7);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(9, "div", 8)(10, "button", 9);
        i0.ɵɵlistener("click", function ContactUsModalComponent_Template_button_click_10_listener() { return ctx.activeModal.close(); });
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.primaryLogo);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.secondaryLogo);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(6, 6, ctx.customText, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.locations);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.cancel);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, NavigationAdapterDirective, LinkComponent, ModalHeaderComponent, SafePipe], styles: [".header-logo[_ngcontent-%COMP%]{max-width:300px;max-height:40px}.header-logo-large[_ngcontent-%COMP%]{max-width:350px;max-height:80px}.primary-logo[_ngcontent-%COMP%]{padding-right:18px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContactUsModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-contact-us-modal', template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"activeModal.close()\"></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body\" tabindex=\"-1\">\r\n  <div class=\"container\">\r\n    <img *ngIf=\"primaryLogo\" class=\"{{ getLogoClass() }}\" [src]=\"primaryLogo\" [alt]=\"primaryLogoAltText\" />\r\n    <img *ngIf=\"secondaryLogo\" [src]=\"secondaryLogo\" class=\"header-logo\" [alt]=\"secondaryLogoAltText\" />\r\n    <div [innerHTML]=\"customText | safe : 'html'\" class=\"Spa_Style_Primary_Color\" navigationAdapter></div>\r\n    <div class=\"row\">\r\n      <div *ngFor=\"let location of locations\" class=\"col-md-6 col-12 h-5 d-flex flex-column justify-content-between\">\r\n        <div class=\"no-translate-block\">\r\n          <h3 class=\"Spa_Style_H3 pt-3 m-0\">{{ location.title }}</h3>\r\n          <div class=\"Spa_Style_Paragraph\">{{ location.address }}</div>\r\n          <div class=\"Spa_Style_Paragraph\">\r\n            {{ location.city }}<span *ngIf=\"location.city\">,</span> {{ location.state }} {{ location.zipCode }}\r\n          </div>\r\n        </div>\r\n        <div class=\"no-translate-block\">\r\n          <div class=\"Spa_Style_Primary_Color Spa_Style_Large_Font Spa_Style_Bold_Weight pt-2\">{{ location.phoneTitle }}</div>\r\n          <div class=\"Spa_Style_Paragraph\">\r\n            <vnext-link\r\n              *ngIf=\"isMobile; else showPhoneOnDesktop\"\r\n              href=\"tel:{{ location.phoneNumber }}\"\r\n              [title]=\"location.phoneNumber\"\r\n              [attr.aria-label]=\"location.title + ': ' + location.phoneNumber\"\r\n            ></vnext-link>\r\n            <ng-template #showPhoneOnDesktop>\r\n              <div>\r\n                {{ location.phoneNumber }}\r\n              </div>\r\n            </ng-template>\r\n            <div>{{ location.hours }}</div>\r\n          </div>\r\n          <vnext-link href=\"mailto:{{ location.email }}\" [title]=\"location.email\"></vnext-link>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer justify-content-start\">\r\n  <button type=\"button\" (click)=\"activeModal.close()\" class=\"btn Spa_Style_SecondaryButton mr-auto\">{{ cancel }}</button>\r\n</div>\r\n", styles: [".header-logo{max-width:300px;max-height:40px}.header-logo-large{max-width:350px;max-height:80px}.primary-logo{padding-right:18px}\n"] }]
    }], function () { return [{ type: i1$1.NgbActiveModal }]; }, null); })();

class ProfileFacade {
    constructor(store, memberSessionService, agentPermissionsService, responsiveLayoutService, modalService, configResourceService, injector) {
        this.store = store;
        this.memberSessionService = memberSessionService;
        this.agentPermissionsService = agentPermissionsService;
        this.responsiveLayoutService = responsiveLayoutService;
        this.modalService = modalService;
        this.configResourceService = configResourceService;
        this.injector = injector;
        this._isAgentSearch$ = new BehaviorSubject(false);
        this._isBeneficiarySeach$ = new BehaviorSubject(false);
        this.subscriptions = new Subscription();
        this.isAgentSearch$ = this._isAgentSearch$.asObservable();
        this.isBeneficiarySearch$ = this._isBeneficiarySeach$.asObservable();
    }
    getMemberFullName$() {
        return this.store.select(ProfileState.fullName);
    }
    getMemberFirstName$() {
        return this.store.select(ProfileState.firstName);
    }
    getMemberEmail$() {
        return this.store.select(ProfileState.emailAddress);
    }
    getMemberCellPhone$() {
        return this.store.select(ProfileState.cellPhone);
    }
    getMemberDateOfBirth() {
        return this.store.selectSnapshot(ProfileState.birthdate);
    }
    getMemberGender() {
        return this.store.selectSnapshot(ProfileState.gender);
    }
    getMemberGenderValue() {
        return this.store.selectSnapshot(ProfileState.genderValue);
    }
    getMemberGenderCode() {
        return this.store.selectSnapshot(ProfileState.genderCode);
    }
    getMemberMedicaidId() {
        return this.store.selectSnapshot(ProfileState.medicaidId);
    }
    getAccountGuid() {
        return this.store.selectSnapshot(ProfileState.accountGuid);
    }
    logOutMember(resetAuthType = false) {
        this.memberSessionService.memberLogout();
        if (resetAuthType) {
            this.memberSessionService.resetAuthType();
        }
    }
    agentSearchNavigationClicked(isAgentSearchNavigationClicked) {
        this._isAgentSearch$.next(isAgentSearchNavigationClicked);
    }
    beneficiarySearchNavigationClicked(isMemberSearchNavigationClicked) {
        this._isBeneficiarySeach$.next(isMemberSearchNavigationClicked);
    }
    newMemberSession() {
        this.memberSessionService.createMemberSession$();
    }
    isAdminAgent() {
        return this.agentPermissionsService.isAdmin();
    }
    getSearchFields(formGroupValue) {
        let searchFields = '';
        Object.entries(formGroupValue)
            .reverse()
            .forEach(([key, value]) => {
            if (value) {
                searchFields = `${key}|${searchFields}`;
            }
        });
        if (searchFields.length - 1 === searchFields.lastIndexOf('|')) {
            searchFields = searchFields.substring(0, searchFields.lastIndexOf('|'));
        }
        return searchFields;
    }
    openModal() {
        const options = {
            ariaLabelledBy: 'modalHeaderTitle',
            injector: this.injector
        };
        const modal = this.modalService.open(ContactUsModalComponent, options);
        this.subscriptions.add(this.responsiveLayoutService.isCompact$.subscribe({
            next: isMobile => {
                modal.componentInstance.isMobile = isMobile;
            }
        }));
        modal.componentInstance.customText =
            this.configResourceService.getProcessedResourceValue('Spa_ContactUsModal_CustomText') ||
                'For questions, please contact a location below.';
        modal.componentInstance.title = this.configResourceService.getProcessedResourceValue('Spa_ContactUsModal_Title') || 'Contact us';
        modal.componentInstance.cancel = this.configResourceService.getProcessedResourceValue('Spa_ContactUsModal_Cancel') || 'Close';
        modal.componentInstance.primaryLogo = this.configResourceService.getProcessedResourceValue('Spa_HeaderFooter_PrimaryClientLogo');
        modal.componentInstance.primaryLogoAltText = this.configResourceService.getProcessedResourceValue('Spa_Header_PrimaryLogo_Alt_Text', null, '[[Spa_ClientName]] logo');
        modal.componentInstance.secondaryLogo = this.configResourceService.getProcessedResourceValue('Spa_HeaderFooter_SecondaryClientLogo');
        modal.componentInstance.secondaryLogoAltText = this.configResourceService.getProcessedResourceValue('Spa_Header_SecondaryLogo_Alt_Text', null, '[[Spa_ClientName]] logo');
        modal.componentInstance.locations = this.configResourceService.getProcessedResourceValue('Spa_ContactUsModal_ContactUsLocations') || [];
        modal.result.then(() => {
            this.subscriptions.unsubscribe();
        });
    }
}
ProfileFacade.ɵfac = function ProfileFacade_Factory(t) { return new (t || ProfileFacade)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(i1.AgentPermissionsService), i0.ɵɵinject(i1.ResponsiveLayoutService), i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i0.Injector)); };
ProfileFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProfileFacade, factory: ProfileFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProfileFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i2.Store }, { type: i1.MemberSessionService }, { type: i1.AgentPermissionsService }, { type: i1.ResponsiveLayoutService }, { type: i1$1.NgbModal }, { type: i1.ConfigResourceService }, { type: i0.Injector }]; }, null); })();

function SelectRXSectionComponent_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵlistener("click", function SelectRXSectionComponent_div_0_div_7_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.showAgentTaskModal()); })("keyup.enter", function SelectRXSectionComponent_div_0_div_7_Template_div_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.showAgentTaskModal()); });
    i0.ɵɵelement(1, "span", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r1.selectRxAddTaskText, " ");
} }
function SelectRXSectionComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵelement(2, "i", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 4)(4, "div", 5);
    i0.ɵɵelement(5, "div", 6);
    i0.ɵɵpipe(6, "safe");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, SelectRXSectionComponent_div_0_div_7_Template, 3, 1, "div", 7);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(6, 2, ctx_r0.selectRxMessageText, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.hasSelectRxTask && ctx_r0.selectRxAddTaskText);
} }
class SelectRXSectionComponent {
    constructor(configResourceService, agentTaskFacade, sessionService, cdr, profileFacade, drugsService) {
        this.configResourceService = configResourceService;
        this.agentTaskFacade = agentTaskFacade;
        this.sessionService = sessionService;
        this.cdr = cdr;
        this.profileFacade = profileFacade;
        this.drugsService = drugsService;
        this.showPlanList = this.configResourceService.getProcessedResourceValue('Spa_ProfileNavBar_ShowPlanList_Flag', null, false);
        this.selectRxEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_SelectRx_Enabled', null, false);
        this.selectRxAddTaskText = this.configResourceService.getProcessedResourceValue('Spa_SelectRx_AddTask_Text', null, 'Add Task');
        this.selectRxMessageText = this.configResourceService.getProcessedResourceValue('Spa_SelectRx_MessageText', null, '<b>SelectRx can you help organize your prescriptions</b><br>We will help you with drug packaging and refills (sample text)<br><b><i class="fas fa-phone"></i> Dedicated SelectRx number: <a href="tel:(###)#5#-####">(###)#5#-####</a> to learn more!</b>');
        this.subscriptions = new Subscription();
        this.isAnonymousUser = false;
    }
    ngOnInit() {
        this.hasSelectRxTask = this.agentTaskFacade.hasSelectRxTask();
        this.subscriptions.add(combineLatest([this.cabinet$, this.isEligible$]).subscribe({
            next: ([cabinet, isEligible]) => {
                this.canViewSelectRxBlock = cabinet.length >= 8;
                this.isEligibleForSelectRxTasks = isEligible;
                this.cdr.markForCheck();
            }
        }));
        this.memberName$ = this.showPlanList ? this.profileFacade.getMemberFirstName$() : this.profileFacade.getMemberFullName$();
        this.subscriptions.add(this.memberName$.subscribe(memberName => {
            this.isAnonymousUser = !memberName;
            this.cdr.markForCheck();
        }));
    }
    showAgentTaskModal() {
        this.drugsService.saveDrugList();
        const agentTaskModal = this.agentTaskFacade.showSelectRxTaskModal();
        agentTaskModal.result.then(async () => {
            // don't do anything if the user send result
        }, () => {
            this.hasSelectRxTask = this.agentTaskFacade.hasSelectRxTask();
            this.cdr.markForCheck();
        });
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
SelectRXSectionComponent.ɵfac = function SelectRXSectionComponent_Factory(t) { return new (t || SelectRXSectionComponent)(i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(AgentTaskFacade), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ProfileFacade), i0.ɵɵdirectiveInject(i1.DrugsService)); };
SelectRXSectionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectRXSectionComponent, selectors: [["vnext-selectrx-section"]], decls: 1, vars: 1, consts: [["class", "select-rx-message", 4, "ngIf"], [1, "select-rx-message"], [1, "rx-icon"], [1, "fas", "fa-pills", "py-3", "px-2", "select-rx-pill-icon"], [1, "rx-row-div"], [1, "Spa_Style_Small_Font"], [3, "innerHtml"], ["class", "add-task-button Spa_Style_Link can-click", "tabindex", "0", 3, "click", "keyup.enter", 4, "ngIf"], ["tabindex", "0", 1, "add-task-button", "Spa_Style_Link", "can-click", 3, "click", "keyup.enter"], ["aria-hidden", "true", 1, "fas", "fa-plus-circle", "mr-1"]], template: function SelectRXSectionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SelectRXSectionComponent_div_0_Template, 8, 5, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.isAnonymousUser && ctx.selectRxEnabled && ctx.isEligibleForSelectRxTasks && ctx.canViewSelectRxBlock);
    } }, dependencies: [i1$2.NgIf, IconAriaAttributesDirective, SafePipe], styles: [".select-rx-message[_ngcontent-%COMP%]{display:flex;justify-content:space-between;width:100%;align-items:center;background-color:var(--static-Spa_Style_Gray1);padding:8px;border-left:5px solid var(--static-Spa_Style_TertiaryButton_Border);border-radius:3px;line-height:1.5}.rx-icon[_ngcontent-%COMP%]{flex:0 0 4.3%}.rx-row-div[_ngcontent-%COMP%]{flex:1 1 auto;display:flex;justify-content:space-between;flex-wrap:wrap}.rx-description-strong[_ngcontent-%COMP%]{font-weight:700}.select-rx-pill-icon[_ngcontent-%COMP%]{font-size:28px;font-size:1.75rem}@media (max-width: 576px){.rx-row-div[_ngcontent-%COMP%]{flex-direction:column!important;align-items:normal!important}}@media (min-width: 576px){.rx-row-div[_ngcontent-%COMP%]{flex-direction:row;align-items:center}}.add-task-button[_ngcontent-%COMP%]{white-space:nowrap;padding-right:18px}"], changeDetection: 0 });
__decorate([
    Select(MedicineCabinetState.medicineCabinet)
], SelectRXSectionComponent.prototype, "cabinet$", void 0);
__decorate([
    Select(MemberState.isEligibleForSelectRxTasks)
], SelectRXSectionComponent.prototype, "isEligible$", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectRXSectionComponent, [{
        type: Component,
        args: [{ selector: 'vnext-selectrx-section', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"select-rx-message\" *ngIf=\"!isAnonymousUser && selectRxEnabled && isEligibleForSelectRxTasks && canViewSelectRxBlock\">\r\n  <div class=\"rx-icon\"><i class=\"fas fa-pills py-3 px-2 select-rx-pill-icon\"></i></div>\r\n  <div class=\"rx-row-div\">\r\n    <div class=\"Spa_Style_Small_Font\">\r\n      <div [innerHtml]=\"selectRxMessageText | safe : 'html'\"></div>\r\n    </div>\r\n\r\n    <div\r\n      *ngIf=\"!hasSelectRxTask && selectRxAddTaskText\"\r\n      class=\"add-task-button Spa_Style_Link can-click\"\r\n      tabindex=\"0\"\r\n      (click)=\"showAgentTaskModal()\"\r\n      (keyup.enter)=\"showAgentTaskModal()\"\r\n    >\r\n      <span class=\"fas fa-plus-circle mr-1\" aria-hidden=\"true\"></span>{{ selectRxAddTaskText }}\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".select-rx-message{display:flex;justify-content:space-between;width:100%;align-items:center;background-color:var(--static-Spa_Style_Gray1);padding:8px;border-left:5px solid var(--static-Spa_Style_TertiaryButton_Border);border-radius:3px;line-height:1.5}.rx-icon{flex:0 0 4.3%}.rx-row-div{flex:1 1 auto;display:flex;justify-content:space-between;flex-wrap:wrap}.rx-description-strong{font-weight:700}.select-rx-pill-icon{font-size:28px;font-size:1.75rem}@media (max-width: 576px){.rx-row-div{flex-direction:column!important;align-items:normal!important}}@media (min-width: 576px){.rx-row-div{flex-direction:row;align-items:center}}.add-task-button{white-space:nowrap;padding-right:18px}\n"] }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: AgentTaskFacade }, { type: i1.MemberSessionService }, { type: i0.ChangeDetectorRef }, { type: ProfileFacade }, { type: i1.DrugsService }]; }, { cabinet$: [], isEligible$: [] }); })();

class DuplicatedPermissionModalComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
    }
    confirm() {
        this.activeModal.close();
        if (this.confirmAction) {
            this.confirmAction();
        }
    }
    cancel() {
        this.activeModal.dismiss();
        if (this.cancelAction) {
            this.cancelAction();
        }
    }
}
DuplicatedPermissionModalComponent.ɵfac = function DuplicatedPermissionModalComponent_Factory(t) { return new (t || DuplicatedPermissionModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal)); };
DuplicatedPermissionModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DuplicatedPermissionModalComponent, selectors: [["ng-component"]], decls: 14, vars: 6, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "px-3", "mt-3", "mb-0"], [1, "mb-1"], [3, "title", "type"], [1, "Spa_Style_Primary_Color", "modal-body"], [1, "modal-footer", "justify-content-start"], ["type", "button", 1, "btn", "mr-auto", "Spa_Style_SecondaryButton", 3, "click"], ["type", "button", 1, "btn", "ml-auto", "Spa_Style_PrimaryButton", 3, "click"]], template: function DuplicatedPermissionModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div")(1, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function DuplicatedPermissionModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_1_listener() { return ctx.cancel(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerStart(2);
        i0.ɵɵelementStart(3, "div", 1)(4, "div", 2);
        i0.ɵɵelement(5, "vnext-notice", 3);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "div", 4)(7, "p");
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementStart(9, "div", 5)(10, "button", 6);
        i0.ɵɵlistener("click", function DuplicatedPermissionModalComponent_Template_button_click_10_listener() { return ctx.cancel(); });
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 7);
        i0.ɵɵlistener("click", function DuplicatedPermissionModalComponent_Template_button_click_12_listener() { return ctx.confirm(); });
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("modalTitleText", ctx.modalTitleText);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("title", ctx.modalWarningText)("type", "warn");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.modalPromptText);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.modalCancelText, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.modalConfirmButtonText, " ");
    } }, dependencies: [NoticeComponent, ModalHeaderComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DuplicatedPermissionModalComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<div>\r\n  <vnext-widget-modal-header [modalTitleText]=\"modalTitleText\" (modalTitleCancelAction)=\"cancel()\"></vnext-widget-modal-header>\r\n\r\n  <ng-container>\r\n    <div class=\"px-3 mt-3 mb-0\">\r\n      <div class=\"mb-1\">\r\n        <vnext-notice [title]=\"modalWarningText\" [type]=\"'warn'\"></vnext-notice>\r\n      </div>\r\n    </div>\r\n    <div class=\"Spa_Style_Primary_Color modal-body\">\r\n      <p>{{ modalPromptText }}</p>\r\n    </div>\r\n  </ng-container>\r\n  <div class=\"modal-footer justify-content-start\">\r\n    <button type=\"button\" class=\"btn mr-auto Spa_Style_SecondaryButton\" (click)=\"cancel()\">\r\n      {{ modalCancelText }}\r\n    </button>\r\n    <button type=\"button\" class=\"btn ml-auto Spa_Style_PrimaryButton\" (click)=\"confirm()\">\r\n      {{ modalConfirmButtonText }}\r\n    </button>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: i1$1.NgbActiveModal }]; }, null); })();

const DEFAULT_DATE = '12/31/9999';
var AccountOverviewInputs;
(function (AccountOverviewInputs) {
    AccountOverviewInputs["AGENT_FIRST_NAME"] = "AgentFirstName";
    AccountOverviewInputs["AGENT_LAST_NAME"] = "AgentLastName";
    AccountOverviewInputs["AGENT_EMAIL"] = "AgentEmail";
    AccountOverviewInputs["AGENT_PHONE"] = "AgentPhone";
    AccountOverviewInputs["AGENT_PHONE_EXTENSION"] = "AgentPhoneExtension";
    AccountOverviewInputs["AGENT_USERNAME"] = "UserName";
    AccountOverviewInputs["AGENT_PASSWORD"] = "AgentPassword";
    AccountOverviewInputs["AGENT_NPN"] = "NPN";
    AccountOverviewInputs["AGENT_PERMISSION_LEVEL"] = "PermissionLevel";
    AccountOverviewInputs["AGENT_AGENCY_NAME"] = "AgencyName";
    AccountOverviewInputs["AGENT_AGENCY_ID"] = "AgencyID";
    AccountOverviewInputs["AGENT_EXTERNAL_USER_ID"] = "ExternalUserID";
    AccountOverviewInputs["AGENT_EXPIRATION_DATE"] = "ExpirationDate";
    AccountOverviewInputs["AGENT_ID"] = "AgentID";
    AccountOverviewInputs["AGENT_FLAG"] = "AgentFlag";
    AccountOverviewInputs["AGENT_ADDRESS1"] = "AgentAddress1";
    AccountOverviewInputs["CITY"] = "City";
    AccountOverviewInputs["STATE"] = "State";
    AccountOverviewInputs["ZIP"] = "Zip";
    AccountOverviewInputs["SITE_ACCESS"] = "SiteAccess";
    AccountOverviewInputs["ACCOUNT_STATUS"] = "AccountStatus";
    AccountOverviewInputs["FSR"] = "FSR";
    AccountOverviewInputs["ASP_REQUIRED"] = "ASPRequired";
    AccountOverviewInputs["ASP_ALLOW_ACCESS_TO_ALL_PLAN_YEARS"] = "ASPAllowAccessToAllPlanYears";
    AccountOverviewInputs["ASP_AGENT_PLAN_YEARS"] = "ASPAgentPlanYears";
    AccountOverviewInputs["CONSUMER_FIRST_NAME"] = "ConsumerFirstName";
    AccountOverviewInputs["CONSUMER_LAST_NAME"] = "ConsumerLastName";
    AccountOverviewInputs["CONSUMER_BIRTH_DATE"] = "ConsumerDateOfBirth";
    AccountOverviewInputs["CONSUMER_EMAIL"] = "ConsumerEmail";
    AccountOverviewInputs["CONSUMER_PHONE"] = "ConsumerPhone";
    AccountOverviewInputs["CONSUMER_USERNAME"] = "UserName";
    AccountOverviewInputs["CONSUMER_ADDRESS1"] = "ConsumerAddress1";
    AccountOverviewInputs["CONSUMER_ADDRESS2"] = "ConsumerAddress2";
    AccountOverviewInputs["LICENSE_NUMBER"] = "LicenseNumber";
    AccountOverviewInputs["CONSUMER_CELL_PHONE"] = "ConsumerCellPhone";
    AccountOverviewInputs["PROFILE_ADMIN"] = "ProfileAdmin";
})(AccountOverviewInputs || (AccountOverviewInputs = {}));
const CHAR_MAX = 50;
const PHONE_LENGTH$1 = 10;
const ZIP_LENGTH$2 = 5;
const NPN_LENGTH$1 = 10;
class AccountOverviewFacade {
    constructor(store, configResourceService, formBuilder, formValidationService, agentService, loginService, navigationService, router, accountOverviewService, agentPermissionsService, modalService, memberSessionService, planYearResourceService, siteService, messagesService) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.formBuilder = formBuilder;
        this.formValidationService = formValidationService;
        this.agentService = agentService;
        this.loginService = loginService;
        this.navigationService = navigationService;
        this.router = router;
        this.accountOverviewService = accountOverviewService;
        this.agentPermissionsService = agentPermissionsService;
        this.modalService = modalService;
        this.memberSessionService = memberSessionService;
        this.planYearResourceService = planYearResourceService;
        this.siteService = siteService;
        this.messagesService = messagesService;
        this.agentPersonalFormConfig = [
            {
                keyName: AccountOverviewInputs.AGENT_FIRST_NAME,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_FirstName_Text', null, 'First name'),
                required: true,
                ordinal: 1,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.AGENT_LAST_NAME,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_LastName_Text', null, 'Last name'),
                required: true,
                ordinal: 2,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.AGENT_EMAIL,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Email_Text', null, 'Email address'),
                required: false,
                ordinal: 3,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Email_Display', null, true),
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.AGENT_PHONE,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Phone_Text', null, 'Phone'),
                required: false,
                ordinal: 4,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Phone_Display', null, true),
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.AGENT_PHONE_EXTENSION,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Phone_Extension_Text', null, 'Ext'),
                required: false,
                ordinal: 5,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Phone_Extension_Display', null, true),
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.AGENT_ADDRESS1,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Address_Text', null, 'Address'),
                required: false,
                ordinal: 6,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Address_Display', null, true),
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.CITY,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_City_Text', null, 'City'),
                required: false,
                ordinal: 7,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_City_Display', null, true),
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.STATE,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_State_Text', null, 'State'),
                required: false,
                ordinal: 8,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_State_Display', null, true),
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.ZIP,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_ZipCode_Text', null, 'Zip'),
                required: false,
                ordinal: 9,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_ZipCode_Display', null, true),
                disabled: false
            }
        ];
        this.defaultAgentAccountFormConfig = [
            {
                keyName: AccountOverviewInputs.AGENT_USERNAME,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Username_Text', null, 'Username'),
                required: true,
                ordinal: 1,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.AGENT_PASSWORD,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Password_Text', null, 'Password'),
                required: true,
                ordinal: 2,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.AGENT_NPN,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_NPN_Text', null, 'NPN'),
                required: false,
                ordinal: 3,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_NPN_Display', null, true),
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.AGENT_PERMISSION_LEVEL,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Role_Text', null, 'Role'),
                required: true,
                ordinal: 10,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.PROFILE_ADMIN,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_ProfileAdminFlag_Text', null, 'Profile Admin'),
                required: false,
                ordinal: 11,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.SITE_ACCESS,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_AgentSearch_SiteAccess_Text', null, 'Site access'),
                required: true,
                ordinal: 9,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.ACCOUNT_STATUS,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_AgentSearch_AccountStatus_Text', null, 'Account status'),
                required: false,
                ordinal: 8,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.AGENT_AGENCY_ID,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_AgencyID_Text', null, 'Agency ID'),
                required: false,
                ordinal: 4,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_AgencyID_Display', null, true),
                disabled: true
            },
            {
                keyName: AccountOverviewInputs.AGENT_AGENCY_NAME,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_Account_AgencyName_Label', null, 'Agency Name'),
                required: false,
                ordinal: 6,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_Account_AgencyName_Enabled', null, true),
                disabled: true
            },
            {
                keyName: AccountOverviewInputs.AGENT_ID,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_AgentID_Text', null, 'Agent ID'),
                required: true,
                ordinal: 5,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.AGENT_EXPIRATION_DATE,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_ExpirationDate_Text', null, 'Expiration date'),
                required: true,
                ordinal: 7,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.FSR,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_FSR_Text', null, 'FSR'),
                required: true,
                ordinal: 14,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.ASP_REQUIRED,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_ASPRequired_Text', null, 'Selling permissions required'),
                required: true,
                ordinal: 15,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.ASP_ALLOW_ACCESS_TO_ALL_PLAN_YEARS,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_AllowAccess_AgentPlanYear_Text', null, 'Allow access to all plan year(s)'),
                required: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_AgentPlanYear_Required', null, true),
                ordinal: 12,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_AgentPlanYear_Display', null, false),
                disabled: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_AgentPlanYear_Disabled', null, true)
            },
            {
                keyName: AccountOverviewInputs.ASP_AGENT_PLAN_YEARS,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_AgentPlanYear_Text', null, 'Agent Plan Year(s)'),
                required: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_AgentPlanYear_Required', null, true),
                ordinal: 13,
                // TODO: does this make the check in the html template redundant?
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_AgentPlanYear_Display', null, false),
                disabled: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_AgentPlanYear_Disabled', null, true)
            }
        ];
        this.personalFormConfig = [
            {
                keyName: AccountOverviewInputs.AGENT_FIRST_NAME,
                labelText: 'First name',
                required: true,
                ordinal: 1,
                display: true,
                disabled: false
            },
            { keyName: AccountOverviewInputs.AGENT_LAST_NAME, labelText: 'Last name', required: true, ordinal: 2, display: true, disabled: true },
            { keyName: AccountOverviewInputs.AGENT_EMAIL, labelText: 'Email address', required: false, ordinal: 3, display: true, disabled: false },
            { keyName: AccountOverviewInputs.AGENT_PHONE, labelText: 'Phone', required: false, ordinal: 4, display: true, disabled: false },
            { keyName: AccountOverviewInputs.AGENT_PHONE_EXTENSION, labelText: 'Ext', required: false, ordinal: 5, display: true, disabled: false },
            { keyName: AccountOverviewInputs.AGENT_ADDRESS1, labelText: 'Address', required: false, ordinal: 6, display: true, disabled: false },
            { keyName: AccountOverviewInputs.CITY, labelText: 'City', required: false, ordinal: 7, display: true, disabled: false },
            { keyName: AccountOverviewInputs.STATE, labelText: 'State', required: false, ordinal: 8, display: true, disabled: false },
            { keyName: AccountOverviewInputs.ZIP, labelText: 'Zip', required: false, ordinal: 9, display: true, disabled: false }
        ];
        this.consumerPersonalFormConfig = [
            {
                keyName: AccountOverviewInputs.ZIP,
                labelText: 'Zip',
                required: true,
                ordinal: 1,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.CONSUMER_FIRST_NAME,
                labelText: 'First name',
                required: true,
                ordinal: 2,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.CONSUMER_LAST_NAME,
                labelText: 'Last name',
                required: true,
                ordinal: 3,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.CONSUMER_BIRTH_DATE,
                labelText: 'Date of birth',
                required: false,
                ordinal: 4,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.CONSUMER_EMAIL,
                labelText: 'Email address',
                required: true,
                ordinal: 5,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.CONSUMER_PHONE,
                labelText: 'Phone',
                required: false,
                ordinal: 6,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.CONSUMER_USERNAME,
                labelText: 'Username',
                required: false,
                ordinal: 7,
                display: true,
                disabled: true
            }
        ];
        this.consumerPersonalAddressFormConfig = [
            {
                keyName: AccountOverviewInputs.CONSUMER_ADDRESS1,
                labelText: 'Address 1',
                required: false,
                ordinal: 1,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.CONSUMER_ADDRESS2,
                labelText: 'Address 2',
                required: false,
                ordinal: 2,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.CITY,
                labelText: 'City',
                required: false,
                ordinal: 3,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.STATE,
                labelText: 'State',
                required: false,
                ordinal: 4,
                display: true,
                disabled: false
            }
        ];
        this.defaultAccountFormConfig = [
            { keyName: AccountOverviewInputs.AGENT_USERNAME, labelText: 'Username', required: true, ordinal: 1, display: true, disabled: true },
            { keyName: AccountOverviewInputs.AGENT_PASSWORD, labelText: 'Password', required: true, ordinal: 2, display: true, disabled: true },
            { keyName: AccountOverviewInputs.AGENT_NPN, labelText: 'NPN', required: false, ordinal: 3, display: true, disabled: true },
            {
                keyName: AccountOverviewInputs.AGENT_PERMISSION_LEVEL,
                labelText: 'Role',
                required: true,
                ordinal: 4,
                display: true,
                disabled: true
            },
            {
                keyName: AccountOverviewInputs.PROFILE_ADMIN,
                labelText: 'Profile Admin',
                required: false,
                ordinal: 5,
                display: true,
                disabled: true
            },
            {
                keyName: AccountOverviewInputs.AGENT_AGENCY_NAME,
                labelText: 'Agency name',
                required: true,
                ordinal: 6,
                display: false,
                disabled: true
            },
            { keyName: AccountOverviewInputs.AGENT_AGENCY_ID, labelText: 'Agency ID', required: true, ordinal: 7, display: false, disabled: true },
            {
                keyName: AccountOverviewInputs.AGENT_EXTERNAL_USER_ID,
                labelText: 'External user ID',
                required: false,
                ordinal: 8,
                display: false,
                disabled: true
            },
            {
                keyName: AccountOverviewInputs.AGENT_FLAG,
                labelText: 'Active?',
                required: false,
                ordinal: 9,
                display: false,
                disabled: true
            }
        ];
        this.agentSearchFormConfig = [
            {
                keyName: AccountOverviewInputs.AGENT_FIRST_NAME,
                labelText: 'First name',
                required: false,
                ordinal: 1,
                display: true,
                disabled: false
            },
            { keyName: AccountOverviewInputs.AGENT_LAST_NAME, labelText: 'Last name', required: false, ordinal: 2, display: true, disabled: false },
            { keyName: AccountOverviewInputs.AGENT_USERNAME, labelText: 'Username', required: false, ordinal: 3, display: true, disabled: false },
            {
                keyName: AccountOverviewInputs.AGENT_AGENCY_NAME,
                labelText: 'Agency name',
                required: false,
                ordinal: 4,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.AGENT_FLAG,
                labelText: 'Account status',
                required: false,
                ordinal: 5,
                display: true,
                disabled: false
            },
            { keyName: AccountOverviewInputs.AGENT_NPN, labelText: 'NPN', required: false, ordinal: 6, display: true, disabled: false }
        ];
        this.isViewAgentProfileEnabled = false;
        this.isDentalEnabled = this.configResourceService.getProcessedResourceValue('Spa_PlanList_Tab_Show_DENTAL', null, false);
        this.isVisionEnabled = this.configResourceService.getProcessedResourceValue('Spa_PlanList_Tab_Show_VISION', null, false);
        this.isHospitalIndemnityEnabled = this.configResourceService.getProcessedResourceValue('Spa_PlanList_Tab_Show_HIP', null, false);
    }
    get agentViewPersonalFormConfig() {
        return [
            {
                keyName: AccountOverviewInputs.AGENT_FIRST_NAME,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_FirstName_Text', null, 'First name'),
                required: true,
                ordinal: 1,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.AGENT_LAST_NAME,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_LastName_Text', null, 'Last name'),
                required: true,
                ordinal: 2,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.AGENT_EMAIL,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Email_Text', null, 'Email address'),
                required: false,
                ordinal: 3,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Email_Display', null, true),
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.AGENT_PHONE,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Phone_Text', null, 'Phone'),
                required: false,
                ordinal: 4,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Phone_Display', null, true),
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.AGENT_PHONE_EXTENSION,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Phone_Extension_Text', null, 'Ext'),
                required: false,
                ordinal: 5,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Phone_Extension_Display', null, true),
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.AGENT_ADDRESS1,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Address_Text', null, 'Address'),
                required: false,
                ordinal: 6,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Address_Display', null, true),
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.CITY,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_City_Text', null, 'City'),
                required: false,
                ordinal: 7,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_City_Display', null, true),
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.STATE,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_State_Text', null, 'State'),
                required: false,
                ordinal: 8,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_State_Display', null, true),
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.ZIP,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_ZipCode_Text', null, 'Zip'),
                required: false,
                ordinal: 9,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_ZipCode_Display', null, true),
                disabled: false
            }
        ];
    }
    get agentViewAccountFormConfig() {
        return [
            {
                keyName: AccountOverviewInputs.AGENT_USERNAME,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Username_Text', null, 'Username'),
                required: true,
                ordinal: 1,
                display: true,
                disabled: true
            },
            {
                keyName: AccountOverviewInputs.AGENT_PASSWORD,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Password_Text', null, 'Password'),
                required: true,
                ordinal: 2,
                display: true,
                disabled: true
            },
            {
                keyName: AccountOverviewInputs.AGENT_NPN,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_NPN_Text', null, 'NPN'),
                required: false,
                ordinal: 3,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_NPN_Display', null, true),
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.AGENT_PERMISSION_LEVEL,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_Role_Text', null, 'Role'),
                required: true,
                ordinal: 10,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.PROFILE_ADMIN,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_ProfileAdminFlag_Text', null, 'Profile Admin'),
                required: false,
                ordinal: 11,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.SITE_ACCESS,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_AgentSearch_SiteAccess_Text', null, 'Site access'),
                required: true,
                ordinal: 9,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.ACCOUNT_STATUS,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_AgentSearch_AccountStatus_Text', null, 'Account status'),
                required: false,
                ordinal: 8,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.AGENT_ID,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_AgentID_Text', null, 'Agent ID'),
                required: true,
                ordinal: 4,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.AGENT_AGENCY_NAME,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_AgencyName_Text', null, 'Agency Name'),
                required: false,
                ordinal: 5,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_AgencyName_Display', null, true),
                disabled: true
            },
            {
                keyName: AccountOverviewInputs.AGENT_AGENCY_ID,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_AgencyID_Text', null, 'Agency ID'),
                required: false,
                ordinal: 6,
                display: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_AgencyID_Display', null, true),
                disabled: true
            },
            {
                keyName: AccountOverviewInputs.AGENT_EXPIRATION_DATE,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_ExpirationDate_Text', null, 'Expiration date'),
                required: true,
                ordinal: 7,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.FSR,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_FSR_Text', null, 'FSR'),
                required: true,
                ordinal: 12,
                display: true,
                disabled: false
            },
            {
                keyName: AccountOverviewInputs.ASP_REQUIRED,
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_ASPRequired_Text', null, 'Selling permissions required'),
                required: true,
                ordinal: 13,
                display: true,
                disabled: false
            }
        ];
    }
    getIsAncillaryPlansEnabled() {
        return this.isDentalEnabled || this.isVisionEnabled || this.isHospitalIndemnityEnabled;
    }
    isCreateAgentPage(pageTags) {
        return this.accountOverviewService.isCreateAgentPage(pageTags);
    }
    isAccountOverviewPage(pageTags) {
        return this.accountOverviewService.isAccountOverviewPage(pageTags);
    }
    isViewOtherAgentPage(pageTags) {
        return this.accountOverviewService.isViewOtherAgentPage(pageTags);
    }
    getRoleDescriptions(agentRole) {
        const roleDescriptionSortKey = 'key';
        let baseNonAdminRoleDescriptions = this.getBaseNonAdminRoleDescriptions();
        let baseAdminRoleDescriptions = this.getBaseAdminRoleDescriptions();
        let agencyHierarchyNonAdminRoleDescriptions = [];
        let agencyHierarchyAdminRoleDescriptions = [];
        if (this.isAgencyHierarchyEnabled()) {
            agencyHierarchyNonAdminRoleDescriptions = [
                ...this.getQuoterAgencyNonAdminRoleDescriptions(),
                ...this.getEnrollerAgencyNonAdminRoleDescriptions()
            ];
            if (!this.agentPermissionsService.isAgencyAdmin(agentRole)) {
                agencyHierarchyAdminRoleDescriptions = [this.getEnrollerAgencyAdminRoleDescription(), this.getQuoterAgencyAdminRoleDescription()];
            }
        }
        if (this.agentPermissionsService.isAgencyAdmin(agentRole)) {
            const excludedRoles = [AgentRole.ENROLLER, AgentRole.QUOTER];
            baseNonAdminRoleDescriptions = baseNonAdminRoleDescriptions.filter(roleDescription => !excludedRoles.includes(roleDescription.key));
            baseAdminRoleDescriptions = [];
        }
        return this.sortRoleDescriptions(roleDescriptionSortKey, [
            ...baseNonAdminRoleDescriptions,
            ...baseAdminRoleDescriptions,
            ...agencyHierarchyNonAdminRoleDescriptions,
            ...agencyHierarchyAdminRoleDescriptions
        ]);
    }
    sortRoleDescriptions(roleDescriptionSortKey, roleDescriptions) {
        return roleDescriptions.sort((roleDescriptionA, roleDescriptionB) => roleDescriptionA[roleDescriptionSortKey] > roleDescriptionB[roleDescriptionSortKey] ? 1 : -1);
    }
    getRoleDescription(role) {
        return [
            ...this.getBaseNonAdminRoleDescriptions(),
            ...this.getBaseAdminRoleDescriptions(),
            ...this.getQuoterAgencyNonAdminRoleDescriptions(),
            ...this.getEnrollerAgencyNonAdminRoleDescriptions(),
            this.getEnrollerAgencyAdminRoleDescription(),
            this.getQuoterAgencyAdminRoleDescription()
        ].find((accountRoleDescription) => accountRoleDescription.key === role);
    }
    getAgentProfilePictureAlternateText() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Agent_ProfilePicture_Alternate_Text', null, 'Agent Profile Picture');
    }
    getSelectedAgentGuid() {
        return this.accountOverviewService.getSelectedAgentGuid();
    }
    isSelectedAgentSameAsLoggedInAgent() {
        return this.getSelectedAgentGuid() === this.agentService.getAgentInContextGuid();
    }
    isAgencyHierarchyEnabled() {
        // Format for this key is different than normal due to being created and used by the API team
        return this.agentService.isAgencyHierarchyEnabled();
    }
    updateAgent$(agent) {
        return this.agentService.updateAgentSessionAndStore$(agent);
    }
    updateViewedAgent$(agentGuid, agent, loginAgentId) {
        if (!agentGuid) {
            // For admin user agentGuid and loginAgentId will be same
            return this.agentService.updateViewedAgentSession$(loginAgentId, agent, loginAgentId);
        }
        return this.agentService.updateViewedAgentSession$(agentGuid, agent, loginAgentId);
    }
    getAgentData() {
        return this.store.selectSnapshot(AgentState);
    }
    getAgentSearchResult$() {
        return this.agentService.getAgentSearchResult$();
    }
    setAgentSearchResult(agentSearchResult) {
        this.agentService.setAgentSearchResult(agentSearchResult);
    }
    searchAgents$(agent, milliseconds) {
        return this.store
            .selectOnce(AgentState.agentGuid)
            .pipe(switchMap(agentGuid => this.agentService.searchAgents$(agentGuid, agent, milliseconds)));
    }
    async fetchAgent(agentData) {
        const agentGuid = agentData.userId;
        const currentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        await this.agentService
            .fetchAgent$(agentGuid, currentGuid)
            .toPromise()
            .then(fetchedData => {
            this.viewAgentProfileData = fetchedData.data;
            this.store.dispatch(new SelectedAgentGuid(fetchedData.data.agentGuid));
        });
    }
    createAgent$(agent) {
        return this.agentService.createNewAgent$(agent);
    }
    getAgentPersonalFormGroup() {
        this.agentPersonalFormConfig = this.configResourceService.getProcessedResourceValue('Spa_Agent_Create_PersonalForm', null, this.agentPersonalFormConfig);
        return this.agentPersonalFormConfig.reduce((formGroup, input) => {
            const control = new UntypedFormControl({
                value: this.getAgentPersonalInputValue(input.keyName),
                disabled: input.disabled
            });
            const validators = [];
            if (input.required) {
                validators.push(Validators.required);
            }
            if (input.keyName === AccountOverviewInputs.AGENT_EMAIL) {
                validators.push(Validators.email);
            }
            else if (input.keyName === AccountOverviewInputs.AGENT_PHONE) {
                validators.push(Validators.minLength(10), Validators.maxLength(10));
            }
            else if (input.keyName === AccountOverviewInputs.ZIP) {
                validators.push(Validators.minLength(5), Validators.maxLength(5));
            }
            control.setValidators(validators);
            formGroup.addControl(input.keyName, control);
            return formGroup;
        }, this.formBuilder.group({}, { updateOn: 'blur' }));
    }
    getFilteredAgencies() {
        const agencies = this.agentService.getAgencies();
        return this.sortAgenciesByName(agencies.filter(agency => {
            if (agency.agencyName) {
                return agency;
            }
        }));
    }
    sortAgenciesByName(userAgencies) {
        return [...userAgencies].sort(({ agencyName: agencyNameA }, { agencyName: agencyNameB }) => agencyNameA.toLowerCase() > agencyNameB.toLowerCase() ? 1 : -1);
    }
    getAgentAccountFormGroup() {
        const accountFormConfig = this.configResourceService.getProcessedResourceValue('Spa_Agent_Create_AccountForm', null, this.defaultAgentAccountFormConfig);
        return accountFormConfig.reduce((formGroup, input) => {
            const control = new UntypedFormControl({
                value: this.getAgentAccountInputValue(input.keyName),
                disabled: input.disabled
            });
            const validators = [];
            if (input.required) {
                validators.push(Validators.required);
            }
            if (input.keyName === AccountOverviewInputs.AGENT_PASSWORD) {
                validators.push(Validators.minLength(8), Validators.maxLength(100), Validators.pattern(this.formValidationService.alphaNumericPasswordPattern));
            }
            else if ((input.keyName === AccountOverviewInputs.FSR ||
                input.keyName === AccountOverviewInputs.AGENT_AGENCY_NAME ||
                input.keyName === AccountOverviewInputs.AGENT_AGENCY_ID) &&
                !input.disabled) {
                validators.push(Validators.maxLength(CHAR_MAX));
            }
            else if (input.keyName === AccountOverviewInputs.AGENT_NPN) {
                validators.push(Validators.maxLength(NPN_LENGTH$1));
            }
            else if (input.keyName === AccountOverviewInputs.LICENSE_NUMBER) {
                validators.push(Validators.maxLength(100));
            }
            control.setValidators(validators);
            formGroup.addControl(input.keyName, control);
            return formGroup;
        }, this.formBuilder.group({}, { updateOn: 'blur' }));
    }
    getAgentViewPersonalFormGroup() {
        const agentViewPersonalFormControls = this.configResourceService.getProcessedResourceValue('Spa_Agent_ViewAgentProfile_PersonalForm', null, this.agentViewPersonalFormConfig);
        return agentViewPersonalFormControls.reduce((formGroup, input) => {
            const control = new UntypedFormControl({
                value: this.getAgentViewPersonalInputValues(input.keyName),
                disabled: input.disabled
            });
            const validators = [];
            if (input.required) {
                validators.push(Validators.required);
            }
            if (input.keyName === AccountOverviewInputs.AGENT_EMAIL) {
                validators.push(Validators.email);
            }
            else if (input.keyName === AccountOverviewInputs.AGENT_PHONE) {
                validators.push(Validators.minLength(10), Validators.maxLength(10));
            }
            else if (input.keyName === AccountOverviewInputs.ZIP) {
                validators.push(Validators.minLength(5), Validators.maxLength(5));
            }
            control.setValidators(validators);
            formGroup.addControl(input.keyName, control);
            return formGroup;
        }, this.formBuilder.group({}, { updateOn: 'blur' }));
    }
    getAgentViewAccountFormGroup() {
        const agentViewAccountFormControls = this.configResourceService.getProcessedResourceValue('Spa_Agent_ViewAgentProfile_AccountForm', null, this.agentViewAccountFormConfig);
        return agentViewAccountFormControls.reduce((formGroup, input) => {
            const control = new UntypedFormControl({
                value: this.getAgentViewAccountInputValues(input.keyName),
                disabled: input.disabled
            });
            const validators = [];
            if (input.required) {
                validators.push(Validators.required);
            }
            if (input.keyName === AccountOverviewInputs.AGENT_PASSWORD) {
                validators.push(Validators.minLength(8), Validators.maxLength(100), Validators.pattern(this.formValidationService.alphaNumericPasswordPattern));
            }
            else if ((input.keyName === AccountOverviewInputs.FSR ||
                input.keyName === AccountOverviewInputs.AGENT_AGENCY_NAME ||
                input.keyName === AccountOverviewInputs.AGENT_AGENCY_ID) &&
                !input.disabled) {
                validators.push(Validators.maxLength(CHAR_MAX));
            }
            else if (input.keyName === AccountOverviewInputs.AGENT_NPN) {
                validators.push(Validators.maxLength(NPN_LENGTH$1));
            }
            control.setValidators(validators);
            formGroup.addControl(input.keyName, control);
            return formGroup;
        }, this.formBuilder.group({}, { updateOn: 'blur' }));
    }
    getPersonalFormGroup() {
        this.personalFormConfig = this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_PersonalForm', null, this.personalFormConfig);
        return this.personalFormConfig.reduce((fg, input) => {
            const control = new UntypedFormControl({
                value: this.getPersonalInputValue(input.keyName),
                disabled: input.disabled
            });
            const validators = [];
            if (input.required) {
                validators.push(Validators.required);
            }
            if (input.keyName === AccountOverviewInputs.AGENT_EMAIL) {
                validators.push(Validators.email);
            }
            else if (input.keyName === AccountOverviewInputs.AGENT_PHONE) {
                validators.push(Validators.minLength(10), Validators.maxLength(10));
            }
            else if (input.keyName === AccountOverviewInputs.ZIP) {
                validators.push(Validators.minLength(5), Validators.maxLength(5));
            }
            control.setValidators(validators);
            fg.addControl(input.keyName, control);
            return fg;
        }, this.formBuilder.group({}, { updateOn: 'blur' }));
    }
    getConsumerPersonalFormGroup() {
        const consumerPersonalFormControls = this.configResourceService.getProcessedResourceValue('Spa_Consumer_AccountOverview_PersonalForm', null, this.consumerPersonalFormConfig);
        return consumerPersonalFormControls.reduce((formGroup, input) => {
            const control = new UntypedFormControl({
                value: this.getConsumerPersonalInputValue(input.keyName),
                disabled: input.disabled
            });
            const validators = this.setInputValidators(input);
            control.setValidators(validators);
            formGroup.addControl(input.keyName, control);
            return formGroup;
        }, this.formBuilder.group({}, { updateOn: 'blur' }));
    }
    getConsumerPersonalAddressFormGroup() {
        const consumerPersonalFormControls = this.configResourceService.getProcessedResourceValue('Spa_Consumer_AccountOverview_PersonalAddressForm', null, this.consumerPersonalAddressFormConfig);
        return consumerPersonalFormControls.reduce((formGroup, input) => {
            const control = new UntypedFormControl({
                value: this.getConsumerPersonalAddressInputValue(input.keyName),
                disabled: input.disabled
            });
            const validators = this.setInputValidators(input);
            control.setValidators(validators);
            formGroup.addControl(input.keyName, control);
            return formGroup;
        }, this.formBuilder.group({}, { updateOn: 'blur' }));
    }
    getAccountFormGroup() {
        const accountFormConfig = this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_AccountForm', null, this.defaultAccountFormConfig);
        return accountFormConfig.reduce((fg, input) => {
            const control = new UntypedFormControl({
                value: this.getAccountInputValue(input.keyName),
                disabled: input.disabled
            });
            const validators = [];
            if (input.required) {
                validators.push(Validators.required);
            }
            if (input.keyName === AccountOverviewInputs.AGENT_NPN) {
                validators.push(Validators.maxLength(NPN_LENGTH$1));
            }
            control.setValidators(validators);
            fg.addControl(input.keyName, control);
            return fg;
        }, this.formBuilder.group({}, { updateOn: 'blur' }));
    }
    getAgentSearchFormGroup() {
        this.agentSearchFormConfig = this.configResourceService.getProcessedResourceValue('Spa_AgentSearch_Form', null, this.agentSearchFormConfig);
        return this.agentSearchFormConfig.reduce((fg, input) => {
            const control = new UntypedFormControl({
                value: this.getAgentSearchInputValue(input.keyName),
                disabled: input.disabled
            });
            const validators = [];
            if (input.required) {
                validators.push(Validators.required);
            }
            if (input.keyName === AccountOverviewInputs.AGENT_FIRST_NAME) {
                validators.push(Validators.minLength(2));
            }
            else if (input.keyName === AccountOverviewInputs.AGENT_LAST_NAME) {
                validators.push(Validators.minLength(2));
            }
            else if (input.keyName === AccountOverviewInputs.AGENT_USERNAME) {
                validators.push(Validators.minLength(2));
            }
            else if (input.keyName === AccountOverviewInputs.AGENT_AGENCY_NAME) {
                validators.push(Validators.minLength(2));
            }
            control.setValidators(validators);
            fg.addControl(input.keyName, control);
            return fg;
        }, this.formBuilder.group({}, { updateOn: 'change' }));
    }
    getPersonalErrorMessage(keyName) {
        if (keyName === AccountOverviewInputs.AGENT_FIRST_NAME) {
            return this.formValidationService.errorMessages.requiredFirstName();
        }
        if (keyName === AccountOverviewInputs.AGENT_LAST_NAME) {
            return this.formValidationService.errorMessages.requiredLastName();
        }
        if (keyName === AccountOverviewInputs.AGENT_EMAIL) {
            return this.formValidationService.errorMessages.invalidEmail();
        }
        if (keyName === AccountOverviewInputs.AGENT_PHONE) {
            return this.formValidationService.errorMessages.requiredPhone();
        }
        if (keyName === AccountOverviewInputs.AGENT_PHONE_EXTENSION) {
            return this.formValidationService.errorMessages.requiredPhoneExtension();
        }
        if (keyName === AccountOverviewInputs.ZIP) {
            return this.formValidationService.errorMessages.requiredZipCode();
        }
        if (keyName === AccountOverviewInputs.STATE) {
            return this.formValidationService.errorMessages.requiredState();
        }
        if (keyName === AccountOverviewInputs.CITY) {
            return this.formValidationService.errorMessages.requiredCity();
        }
        if (keyName === AccountOverviewInputs.AGENT_ADDRESS1) {
            return this.formValidationService.errorMessages.requiredAddress();
        }
        return '';
    }
    getAccountErrorMessage(keyName) {
        if (keyName === AccountOverviewInputs.AGENT_USERNAME) {
            return this.formValidationService.errorMessages.requiredUsername();
        }
        if (keyName === AccountOverviewInputs.AGENT_PASSWORD) {
            return this.formValidationService.errorMessages.minLengthPassword();
        }
        if (keyName === AccountOverviewInputs.AGENT_NPN) {
            return this.formValidationService.errorMessages.maxLengthNPN();
        }
        if (keyName === AccountOverviewInputs.AGENT_PERMISSION_LEVEL) {
            return this.formValidationService.errorMessages.requiredRole();
        }
        if (keyName === AccountOverviewInputs.AGENT_EXPIRATION_DATE) {
            return this.formValidationService.errorMessages.requiredExpiryDate();
        }
        if (keyName === AccountOverviewInputs.AGENT_AGENCY_NAME) {
            return this.formValidationService.errorMessages.maxLengthAgencyName();
        }
        if (keyName === AccountOverviewInputs.AGENT_AGENCY_ID) {
            return this.formValidationService.errorMessages.maxLengthAgencyID();
        }
        if (keyName === AccountOverviewInputs.AGENT_EXTERNAL_USER_ID) {
            return '';
        }
        if (keyName === AccountOverviewInputs.AGENT_ID) {
            return this.formValidationService.errorMessages.maxLengthAgentID();
        }
        if (keyName === AccountOverviewInputs.AGENT_FLAG) {
            return '';
        }
        if (keyName === AccountOverviewInputs.FSR) {
            return this.formValidationService.errorMessages.maxLengthFsr();
        }
        if (keyName === AccountOverviewInputs.ASP_REQUIRED) {
            return this.formValidationService.errorMessages.requiredASP();
        }
        if (keyName === AccountOverviewInputs.ASP_ALLOW_ACCESS_TO_ALL_PLAN_YEARS) {
            return this.formValidationService.errorMessages.aspAllowAccessToAllPlanYearsRequired();
        }
        if (keyName === AccountOverviewInputs.ASP_AGENT_PLAN_YEARS) {
            return this.formValidationService.errorMessages.aspAgentPlanYearsRequired();
        }
        if (keyName === AccountOverviewInputs.LICENSE_NUMBER) {
            return this.formValidationService.errorMessages.licenseNumber();
        }
    }
    getAgentSearchErrorMessage(keyName) {
        if (keyName === AccountOverviewInputs.AGENT_FIRST_NAME) {
            return this.formValidationService.errorMessages.minCharacters2();
        }
        if (keyName === AccountOverviewInputs.AGENT_LAST_NAME) {
            return this.formValidationService.errorMessages.minCharacters2();
        }
        if (keyName === AccountOverviewInputs.AGENT_USERNAME) {
            return this.formValidationService.errorMessages.minCharacters2();
        }
        if (keyName === AccountOverviewInputs.AGENT_AGENCY_NAME) {
            return this.formValidationService.errorMessages.minCharacters2();
        }
    }
    logoutNonAdminAgent() {
        if (!this.agentPermissionsService.isAdmin() ||
            !this.configResourceService.getProcessedResourceValue('Spa_Agent_Create_Account_Enabled', null, true)) {
            const siteType = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType', null, 'consumer');
            this.loginService.logout(siteType);
        }
    }
    getProfileRequiredErrorMessage(keyName) {
        if (keyName === AccountOverviewInputs.CONSUMER_FIRST_NAME) {
            return this.formValidationService.errorMessages.requiredFirstName();
        }
        if (keyName === AccountOverviewInputs.CONSUMER_LAST_NAME) {
            return this.formValidationService.errorMessages.requiredLastName();
        }
        if (keyName === AccountOverviewInputs.CONSUMER_PHONE) {
            return this.formValidationService.errorMessages.requiredPhone();
        }
        if (keyName === AccountOverviewInputs.CONSUMER_CELL_PHONE) {
            return this.formValidationService.errorMessages.requiredCellPhone();
        }
        if (keyName === AccountOverviewInputs.ZIP) {
            return this.formValidationService.errorMessages.requiredZipCode();
        }
        if (keyName === AccountOverviewInputs.STATE) {
            return this.formValidationService.errorMessages.requiredState();
        }
        if (keyName === AccountOverviewInputs.CITY) {
            return this.formValidationService.errorMessages.requiredCity();
        }
        if (keyName === AccountOverviewInputs.CONSUMER_ADDRESS1 || keyName === AccountOverviewInputs.CONSUMER_ADDRESS2) {
            return this.formValidationService.errorMessages.requiredAddress();
        }
        if (keyName === AccountOverviewInputs.CONSUMER_BIRTH_DATE) {
            return this.formValidationService.errorMessages.invalidDateOfBirth();
        }
        if (keyName === AccountOverviewInputs.CONSUMER_EMAIL) {
            return this.formValidationService.errorMessages.requiredEmail();
        }
        return '';
    }
    getProfileInvalidErrorMessage(keyName) {
        if (keyName === AccountOverviewInputs.CONSUMER_BIRTH_DATE) {
            return this.formValidationService.errorMessages.invalidDate();
        }
        if (keyName === AccountOverviewInputs.CONSUMER_EMAIL) {
            return this.formValidationService.errorMessages.invalidEmail();
        }
        if (keyName === AccountOverviewInputs.CONSUMER_PHONE) {
            return this.formValidationService.errorMessages.invalidPhone();
        }
        if (keyName === AccountOverviewInputs.CONSUMER_CELL_PHONE) {
            return this.formValidationService.errorMessages.invalidCellPhone();
        }
        return '';
    }
    getErrorBannerList(personalFormValues, accountFormValues, isNewAgent) {
        const errorList = [];
        if (this.checkAccountControlValueHasError(AccountOverviewInputs.AGENT_FIRST_NAME, personalFormValues)) {
            errorList.push({ message: this.getPersonalErrorMessage(AccountOverviewInputs.AGENT_FIRST_NAME) });
        }
        if (this.checkAccountControlValueHasError(AccountOverviewInputs.AGENT_LAST_NAME, personalFormValues)) {
            errorList.push({ message: this.getPersonalErrorMessage(AccountOverviewInputs.AGENT_LAST_NAME) });
        }
        if (isNewAgent) {
            if (this.checkAccountControlValueHasError(AccountOverviewInputs.AGENT_USERNAME, accountFormValues)) {
                errorList.push({ message: this.getAccountErrorMessage(AccountOverviewInputs.AGENT_USERNAME) });
            }
            if (this.checkAccountControlValueHasError(AccountOverviewInputs.AGENT_PASSWORD, accountFormValues) &&
                !accountFormValues.value[AccountOverviewInputs.AGENT_PASSWORD]) {
                errorList.push({ message: this.getAccountErrorMessage(AccountOverviewInputs.AGENT_PASSWORD) });
            }
        }
        if (this.checkAccountControlValueHasError(AccountOverviewInputs.AGENT_ID, accountFormValues) &&
            !accountFormValues.value[AccountOverviewInputs.AGENT_ID]) {
            errorList.push({ message: this.getAccountErrorMessage(AccountOverviewInputs.AGENT_ID) });
        }
        if (this.checkAccountControlValueHasError(AccountOverviewInputs.AGENT_EXPIRATION_DATE, accountFormValues) &&
            !accountFormValues.value[AccountOverviewInputs.AGENT_EXPIRATION_DATE]) {
            errorList.push({
                message: this.getAccountErrorMessage(AccountOverviewInputs.AGENT_EXPIRATION_DATE)
            });
        }
        if (this.checkAccountControlValueHasError(AccountOverviewInputs.AGENT_PERMISSION_LEVEL, accountFormValues) &&
            !accountFormValues.value[AccountOverviewInputs.AGENT_PERMISSION_LEVEL]) {
            errorList.push({
                message: this.getAccountErrorMessage(AccountOverviewInputs.AGENT_PERMISSION_LEVEL)
            });
        }
        if (this.checkAccountControlValueHasError(AccountOverviewInputs.FSR, accountFormValues) ||
            (accountFormValues.value[AccountOverviewInputs.FSR] && accountFormValues.value[AccountOverviewInputs.FSR].length > CHAR_MAX)) {
            errorList.push({
                message: this.getAccountErrorMessage(AccountOverviewInputs.FSR)
            });
        }
        if (accountFormValues.value[AccountOverviewInputs.AGENT_AGENCY_NAME] &&
            accountFormValues.value[AccountOverviewInputs.AGENT_AGENCY_NAME].length > CHAR_MAX) {
            errorList.push({
                message: this.getAccountErrorMessage(AccountOverviewInputs.AGENT_AGENCY_NAME)
            });
        }
        if (accountFormValues.value[AccountOverviewInputs.AGENT_AGENCY_ID] &&
            accountFormValues.value[AccountOverviewInputs.AGENT_AGENCY_ID].length > CHAR_MAX) {
            errorList.push({
                message: this.getAccountErrorMessage(AccountOverviewInputs.AGENT_AGENCY_ID)
            });
        }
        if (this.checkAccountControlValueHasError(AccountOverviewInputs.ASP_REQUIRED, accountFormValues)) {
            errorList.push({ message: this.getAccountErrorMessage(AccountOverviewInputs.ASP_REQUIRED) });
        }
        return errorList;
    }
    checkAccountControlValueHasError(controlName, accountFormGroup) {
        const value = accountFormGroup.value[controlName];
        if (this.accountControlIsRequired(controlName, accountFormGroup) && !value && value !== false) {
            return true;
        }
        return false;
    }
    accountControlIsRequired(controlName, accountFormGroup) {
        const control = accountFormGroup.get(controlName);
        if (!control?.validator) {
            return false;
        }
        const validator = control.validator({});
        return validator?.required;
    }
    async viewLoggedInAgentDetails(pageTag) {
        this.isViewAgentProfileEnabled = false;
        const currentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        this.store.dispatch(new SelectedAgentGuid(currentGuid));
        const currentPage = this.store.selectSnapshot(AppConfigState.page(this.router.url));
        if (currentPage.tags.includes(pageTag)) {
            location.reload();
        }
        else {
            this.navigationService.navigateByPageTag(pageTag);
        }
    }
    async setSelectedAgentData() {
        const agentGuid = this.store.selectSnapshot(AgentState.selectedAgentGuid);
        const currentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        const fetchedAgentData = await this.agentService.fetchAgent$(agentGuid, currentGuid).toPromise();
        this.viewAgentProfileData = fetchedAgentData ? fetchedAgentData.data : {};
    }
    fileChange(files) {
        const fileUploadErrors = [];
        const FILE_MAX_SIZE = 5000000;
        const FILE_TYPES = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'];
        const file = files.item(0);
        if (file.size > FILE_MAX_SIZE) {
            fileUploadErrors.push(this.formValidationService.errorMessages.soaFileSize());
        }
        if (!FILE_TYPES.includes(file.type)) {
            fileUploadErrors.push(this.formValidationService.errorMessages.agentPictureFileType());
        }
        if (fileUploadErrors.length) {
            return fileUploadErrors;
        }
        return [];
    }
    async uploadAgentProfile(file, agentGuid) {
        const response = await this.agentService.uploadProfile(file, agentGuid);
        return response;
    }
    setSelectedAgentGuid(agentGuid) {
        this.store.dispatch(new SelectedAgentGuid(agentGuid));
    }
    updateAgentProfilePicture(profilePictureUrl) {
        this.agentService.updateAgentProfilePicture(profilePictureUrl);
    }
    getZipCodeSelected() {
        return this.store.selectSnapshot(ProfileState.zip);
    }
    getFipsCodeSelected() {
        return this.store.selectSnapshot(ProfileState.county);
    }
    showDuplicatedPermissionModal(agentGuid, permission) {
        const modalTitle = this.getDuplicatedPermissionModalTitle('accountoverview');
        const modalWarning = this.getDuplicatedPermissionModalWarning('accountoverview');
        const modalPrompt = this.getDuplicatedPermissionModalPrompt('accountoverview');
        const modalCancel = this.getDuplicatedPermissionModalCancelText('accountoverview');
        const modalConfirm = this.getDuplicatedPermissionModalConfirmText('accountoverview');
        const confirmationModal = this.modalService.open(DuplicatedPermissionModalComponent, { centered: true });
        confirmationModal.componentInstance.modalTitleText = modalTitle;
        confirmationModal.componentInstance.modalWarningText = modalWarning;
        confirmationModal.componentInstance.modalPromptText = modalPrompt;
        confirmationModal.componentInstance.modalCancelText = modalCancel;
        confirmationModal.componentInstance.modalConfirmButtonText = modalConfirm;
        confirmationModal.result.then(async () => await this.agentService.updateAgentSellingPermissions(agentGuid, permission), () => {
            // don't do anything if the user canceled
        });
    }
    updateProfile$(personalFormValues, personalAddressFormValues, fips) {
        return this.store.selectOnce(MemberState.memberID).pipe(switchMap(memberID => {
            const apiMemberStateModel = {
                memberID,
                profile: {
                    firstName: personalFormValues[AccountOverviewInputs.CONSUMER_FIRST_NAME],
                    lastName: personalFormValues[AccountOverviewInputs.CONSUMER_LAST_NAME],
                    birthdate: personalFormValues[AccountOverviewInputs.CONSUMER_BIRTH_DATE],
                    emailAddress: personalFormValues[AccountOverviewInputs.CONSUMER_EMAIL],
                    homePhone: personalFormValues[AccountOverviewInputs.CONSUMER_PHONE],
                    cellPhone: personalFormValues[AccountOverviewInputs.CONSUMER_CELL_PHONE],
                    addresses: [
                        {
                            zip: personalFormValues[AccountOverviewInputs.ZIP],
                            countyFips: fips,
                            address1: personalAddressFormValues[AccountOverviewInputs.CONSUMER_ADDRESS1],
                            address2: personalAddressFormValues[AccountOverviewInputs.CONSUMER_ADDRESS2],
                            city: personalAddressFormValues[AccountOverviewInputs.CITY],
                            state: personalAddressFormValues[AccountOverviewInputs.STATE],
                            isPrimaryAddress: true
                        }
                    ]
                },
                demographic: {
                    zip: personalFormValues[AccountOverviewInputs.ZIP],
                    fips,
                    birthdate: personalFormValues[AccountOverviewInputs.CONSUMER_BIRTH_DATE]
                }
            };
            return this.memberSessionService.updateMemberProfile$(apiMemberStateModel);
        }));
    }
    getModalTitle(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_LeavingPageModal_Title', widgetName, 'Unsaved changes');
    }
    getModalPrompt(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_LeavingPageModal_Message', widgetName, 'Are you sure you want to leave without saving your changes');
    }
    getModalCancel(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_LeavingPageModal_CancelButton', widgetName, 'Stay on page');
    }
    getModalLeave(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_LeavingPageModal_LeaveButton', widgetName, 'Leave page');
    }
    async getRetireFloPurl(options) {
        const { baseUrl, userName, encode, redirectPageTag } = options;
        return this.agentService.getAgentRetireFloPurl(baseUrl, userName, encode, redirectPageTag);
    }
    async copyRetireFloPurl(retireFloPurl) {
        if (window.navigator.clipboard && window.isSecureContext) {
            await window.navigator.clipboard.writeText(retireFloPurl);
        }
        else {
            this.copyToClipboardLegacy(retireFloPurl);
        }
    }
    async copyPurl(purl) {
        const shortUrl = await this.messagesService.getShortUrl$(purl).toPromise();
        if (window.navigator.clipboard && window.isSecureContext) {
            await window.navigator.clipboard.writeText(shortUrl);
        }
        else {
            this.copyToClipboardLegacy(shortUrl);
        }
    }
    copyToClipboardLegacy(textToCopy) {
        const textArea = document.createElement('textarea');
        if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
            textArea.value = textToCopy;
            // make the textarea out Sof viewport
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            document.execCommand('copy');
            textArea.remove();
        }
    }
    async getPurl(options) {
        const { baseUrl, userName, encode, selectedStaticPurlYear, redirectPageTag, accountGuid } = options;
        return await this.agentService.getAgentPurl(baseUrl, userName, encode, selectedStaticPurlYear, redirectPageTag, accountGuid);
    }
    getConsumerSiteBaseUrl(isDualPlanYearSelected = false) {
        const resourceConsumerSiteUrl = this.configResourceService.getProcessedResourceValue('URL_ConsumerSite', null, '');
        const consumerSiteUrls = this.siteService.getConsumerSiteUrls();
        const selectedPlanYear = isDualPlanYearSelected
            ? this.planYearResourceService.getDualPlanYear()
            : this.planYearResourceService.getCurrentPlanYear();
        return consumerSiteUrls?.find(url => `${url.planYear}` === `${selectedPlanYear}`)?.url ?? resourceConsumerSiteUrl;
    }
    getSiteBaseUrl(isDualPlanYearSelected = false) {
        const consumerSiteIdEnabled = this.configResourceService.getProcessedResourceValue('Spa_ConsumerSiteID_Enabled', null, false);
        return consumerSiteIdEnabled ? this.siteService.getSiteBaseUrl() : this.getConsumerSiteBaseUrl(isDualPlanYearSelected);
    }
    getDuplicatedPermissionModalTitle(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_DuplicatedPermissionModal_Title', widgetName, 'Existing permission');
    }
    getDuplicatedPermissionModalWarning(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_DuplicatedPermissionModal_Warning', widgetName, 'This is an existing permission');
    }
    getDuplicatedPermissionModalPrompt(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_DuplicatedPermissionModal_Prompt', widgetName, 'Are you sure you would like to continue and replace the current permission?');
    }
    getDuplicatedPermissionModalCancelText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_DuplicatedPermissionModal_Cancel', widgetName, 'Cancel');
    }
    getDuplicatedPermissionModalConfirmText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_DuplicatedPermissionModal_Confirm', widgetName, 'Replace current permission');
    }
    setInputValidators(input) {
        const validators = [];
        if (input.required) {
            validators.push(Validators.required);
        }
        if (input.keyName === AccountOverviewInputs.AGENT_EMAIL || input.keyName === AccountOverviewInputs.CONSUMER_EMAIL) {
            validators.push(Validators.email);
        }
        else if (input.keyName === AccountOverviewInputs.AGENT_PHONE || input.keyName === AccountOverviewInputs.CONSUMER_PHONE) {
            validators.push(Validators.minLength(PHONE_LENGTH$1), Validators.maxLength(PHONE_LENGTH$1));
        }
        else if (input.keyName === AccountOverviewInputs.ZIP) {
            validators.push(Validators.minLength(ZIP_LENGTH$2), Validators.maxLength(ZIP_LENGTH$2));
        }
        return validators;
    }
    getPersonalInputValue(keyName) {
        if (keyName === AccountOverviewInputs.AGENT_FIRST_NAME) {
            return this.agentService.getAgentFirstName();
        }
        if (keyName === AccountOverviewInputs.AGENT_LAST_NAME) {
            return this.agentService.getAgentLastName();
        }
        if (keyName === AccountOverviewInputs.AGENT_EMAIL) {
            return this.agentService.getAgentEmailAddress();
        }
        if (keyName === AccountOverviewInputs.AGENT_PHONE) {
            return this.agentService.getAgentPhone();
        }
        if (keyName === AccountOverviewInputs.AGENT_PHONE_EXTENSION) {
            return this.agentService.getAgentExtension();
        }
        if (keyName === AccountOverviewInputs.ZIP) {
            return this.agentService.getAgentZip();
        }
        if (keyName === AccountOverviewInputs.STATE) {
            return this.agentService.getAgentState();
        }
        if (keyName === AccountOverviewInputs.CITY) {
            return this.agentService.getAgentCity();
        }
        if (keyName === AccountOverviewInputs.AGENT_ADDRESS1) {
            return this.agentService.getAgentAddress1();
        }
    }
    getConsumerPersonalInputValue(keyName) {
        if (keyName === AccountOverviewInputs.ZIP) {
            return this.store.selectSnapshot(ProfileState.zip);
        }
        if (keyName === AccountOverviewInputs.CONSUMER_FIRST_NAME) {
            return this.store.selectSnapshot(ProfileState.firstName);
        }
        if (keyName === AccountOverviewInputs.CONSUMER_LAST_NAME) {
            return this.store.selectSnapshot(ProfileState.lastName);
        }
        if (keyName === AccountOverviewInputs.CONSUMER_BIRTH_DATE) {
            return this.store.selectSnapshot(ProfileState.birthdate);
        }
        if (keyName === AccountOverviewInputs.CONSUMER_EMAIL) {
            return this.store.selectSnapshot(ProfileState.emailAddress);
        }
        if (keyName === AccountOverviewInputs.CONSUMER_PHONE) {
            return this.store.selectSnapshot(ProfileState.homePhone);
        }
        if (keyName === AccountOverviewInputs.CONSUMER_CELL_PHONE) {
            return this.store.selectSnapshot(ProfileState.cellPhone);
        }
        if (keyName === AccountOverviewInputs.CONSUMER_USERNAME) {
            return this.store.selectSnapshot(MemberState.userName);
        }
    }
    getConsumerPersonalAddressInputValue(keyName) {
        if (keyName === AccountOverviewInputs.CONSUMER_ADDRESS1) {
            return this.store.selectSnapshot(ProfileState.address1);
        }
        if (keyName === AccountOverviewInputs.CONSUMER_ADDRESS2) {
            return this.store.selectSnapshot(ProfileState.address2);
        }
        if (keyName === AccountOverviewInputs.CITY) {
            return this.store.selectSnapshot(ProfileState.city);
        }
        if (keyName === AccountOverviewInputs.STATE) {
            return this.store.selectSnapshot(ProfileState.state);
        }
    }
    getAccountInputValue(keyName) {
        if (keyName === AccountOverviewInputs.AGENT_USERNAME) {
            return this.agentService.getAgentUserName();
        }
        // we don't actually know the password or the length so throw in some dummy text
        // note this field will always be disabled so the value it holds doesn't matter
        if (keyName === AccountOverviewInputs.AGENT_PASSWORD) {
            return '******';
        }
        if (keyName === AccountOverviewInputs.AGENT_NPN) {
            return this.agentService.getAgentNPN();
        }
        if (keyName === AccountOverviewInputs.AGENT_PERMISSION_LEVEL) {
            return this.agentService.getAgentRole();
        }
        if (keyName === AccountOverviewInputs.AGENT_AGENCY_NAME) {
            return this.agentService.getAgencyName();
        }
        if (keyName === AccountOverviewInputs.AGENT_AGENCY_ID) {
            return this.agentService.getAgencyId();
        }
        if (keyName === AccountOverviewInputs.AGENT_EXTERNAL_USER_ID) {
            return this.agentService.getAgentExternalUserId();
        }
        if (keyName === AccountOverviewInputs.AGENT_ID) {
            return this.agentService.getAgentId();
        }
        // temp until admin stories come around
        if (keyName === AccountOverviewInputs.AGENT_FLAG) {
            const isActive = this.agentService.getAgentIsActive();
            return isActive ? 'Yes' : 'No';
        }
        if (keyName === AccountOverviewInputs.FSR) {
            return this.agentService.getAgentFsr();
        }
        if (keyName === AccountOverviewInputs.ASP_REQUIRED) {
            return this.agentService.getASPRequired();
        }
        // TODO: this should work for agent in context but need to rely on the solution
        // in the component for the agent search
        if (keyName === AccountOverviewInputs.ASP_ALLOW_ACCESS_TO_ALL_PLAN_YEARS) {
            return this.agentService.getASPAllowAccessToAllPlanYears();
        }
        if (keyName === AccountOverviewInputs.ASP_AGENT_PLAN_YEARS) {
            return this.agentService.getASPAgentPlanYear();
        }
        if (keyName === AccountOverviewInputs.PROFILE_ADMIN) {
            return this.agentService.getIsProfileAdmin();
        }
        if (keyName === AccountOverviewInputs.LICENSE_NUMBER) {
            return this.agentService.getCaliforniaLicenseNumber();
        }
    }
    getAgentSearchInputValue(keyName) {
        if (keyName === AccountOverviewInputs.AGENT_FIRST_NAME) {
            return null;
        }
        if (keyName === AccountOverviewInputs.AGENT_LAST_NAME) {
            return null;
        }
        if (keyName === AccountOverviewInputs.AGENT_USERNAME) {
            return null;
        }
        if (keyName === AccountOverviewInputs.AGENT_AGENCY_NAME) {
            return null;
        }
        if (keyName === AccountOverviewInputs.AGENT_NPN) {
            return null;
        }
    }
    getAgentPersonalInputValue(keyName) {
        if (keyName === AccountOverviewInputs.AGENT_FIRST_NAME) {
            return null;
        }
        if (keyName === AccountOverviewInputs.AGENT_LAST_NAME) {
            return null;
        }
        if (keyName === AccountOverviewInputs.AGENT_EMAIL) {
            return null;
        }
        if (keyName === AccountOverviewInputs.AGENT_PHONE) {
            return null;
        }
        if (keyName === AccountOverviewInputs.AGENT_PHONE_EXTENSION) {
            return null;
        }
        if (keyName === AccountOverviewInputs.ZIP) {
            return null;
        }
        if (keyName === AccountOverviewInputs.STATE) {
            return null;
        }
        if (keyName === AccountOverviewInputs.CITY) {
            return null;
        }
        if (keyName === AccountOverviewInputs.AGENT_ADDRESS1) {
            return null;
        }
    }
    getAgentAccountInputValue(keyName) {
        if (keyName === AccountOverviewInputs.SITE_ACCESS) {
            return true;
        }
        if (keyName === AccountOverviewInputs.AGENT_EXPIRATION_DATE) {
            return new Date(`${DEFAULT_DATE} UTC`).toISOString().slice(0, 19);
        }
        // temp until admin stories come around
        if (keyName === AccountOverviewInputs.ACCOUNT_STATUS) {
            return true;
        }
        return null;
    }
    getAgentViewPersonalInputValues(keyName) {
        if (this.isViewAgentProfileEnabled) {
            if (keyName === AccountOverviewInputs.AGENT_FIRST_NAME) {
                return this.viewAgentProfileData?.firstName;
            }
            if (keyName === AccountOverviewInputs.AGENT_LAST_NAME) {
                return this.viewAgentProfileData?.lastName;
            }
            if (keyName === AccountOverviewInputs.AGENT_EMAIL) {
                return this.viewAgentProfileData?.emailAddress;
            }
            if (keyName === AccountOverviewInputs.AGENT_PHONE) {
                return this.viewAgentProfileData?.phoneNumber;
            }
            if (keyName === AccountOverviewInputs.AGENT_PHONE_EXTENSION) {
                return this.viewAgentProfileData?.ext;
            }
            if (keyName === AccountOverviewInputs.ZIP) {
                return this.viewAgentProfileData?.zip;
            }
            if (keyName === AccountOverviewInputs.STATE) {
                return this.viewAgentProfileData?.state;
            }
            if (keyName === AccountOverviewInputs.CITY) {
                return this.viewAgentProfileData?.city;
            }
            if (keyName === AccountOverviewInputs.AGENT_ADDRESS1) {
                return this.viewAgentProfileData?.address1;
            }
        }
        else {
            if (keyName === AccountOverviewInputs.AGENT_FIRST_NAME) {
                return this.agentService.getAgentFirstName();
            }
            if (keyName === AccountOverviewInputs.AGENT_LAST_NAME) {
                return this.agentService.getAgentLastName();
            }
            if (keyName === AccountOverviewInputs.AGENT_EMAIL) {
                return this.agentService.getAgentEmailAddress();
            }
            if (keyName === AccountOverviewInputs.AGENT_PHONE) {
                return this.agentService.getAgentPhone();
            }
            if (keyName === AccountOverviewInputs.AGENT_PHONE_EXTENSION) {
                return this.agentService.getAgentExtension();
            }
            if (keyName === AccountOverviewInputs.ZIP) {
                return this.agentService.getAgentZip();
            }
            if (keyName === AccountOverviewInputs.STATE) {
                return this.agentService.getAgentState();
            }
            if (keyName === AccountOverviewInputs.CITY) {
                return this.agentService.getAgentCity();
            }
            if (keyName === AccountOverviewInputs.AGENT_ADDRESS1) {
                return this.agentService.getAgentAddress1();
            }
        }
    }
    getAgentViewAccountInputValues(keyName) {
        if (this.isViewAgentProfileEnabled) {
            return this.getValuesWhenViewEnabled(keyName);
        }
        return this.getValuesWhenViewDisabled(keyName);
    }
    getValuesWhenViewEnabled(keyName) {
        if (keyName === AccountOverviewInputs.AGENT_USERNAME) {
            return this.viewAgentProfileData?.userName;
        }
        if (keyName === AccountOverviewInputs.AGENT_PASSWORD) {
            return '******';
        }
        if (keyName === AccountOverviewInputs.AGENT_NPN) {
            return this.viewAgentProfileData?.npn;
        }
        if (keyName === AccountOverviewInputs.AGENT_PERMISSION_LEVEL) {
            return this.viewAgentProfileData?.agentRole;
        }
        if (keyName === AccountOverviewInputs.AGENT_AGENCY_ID) {
            return this.viewAgentProfileData?.agencyID;
        }
        if (keyName === AccountOverviewInputs.SITE_ACCESS) {
            return this.viewAgentProfileData?.siteAccess;
        }
        if (keyName === AccountOverviewInputs.AGENT_EXPIRATION_DATE) {
            return this.viewAgentProfileData?.expirationDate
                ? DateUtilities.getFormattedDateTime(new Date(this.viewAgentProfileData?.expirationDate.slice(0, 19)), DateUtilities.defaultDateTimeISOFormat)
                : new Date();
        }
        if (keyName === AccountOverviewInputs.AGENT_ID) {
            return this.viewAgentProfileData?.agentID;
        }
        if (keyName === AccountOverviewInputs.ACCOUNT_STATUS) {
            return this.viewAgentProfileData?.isActive;
        }
        if (keyName === AccountOverviewInputs.AGENT_AGENCY_NAME) {
            return this.viewAgentProfileData?.agencyName;
        }
        if (keyName === AccountOverviewInputs.FSR) {
            return this.viewAgentProfileData?.fsr;
        }
        if (keyName === AccountOverviewInputs.ASP_REQUIRED) {
            return this.viewAgentProfileData?.aspRequired;
        }
        if (keyName === AccountOverviewInputs.ASP_ALLOW_ACCESS_TO_ALL_PLAN_YEARS) {
            return this.agentService.getASPAllowAccessToAllPlanYears();
        }
        if (keyName === AccountOverviewInputs.ASP_AGENT_PLAN_YEARS) {
            return this.agentService.getASPAgentPlanYear();
        }
        if (keyName === AccountOverviewInputs.PROFILE_ADMIN) {
            return this.viewAgentProfileData?.isProfileAdmin;
        }
        // TODO: License is saved as an array in the API but the UI currently only supports CA
        if (keyName === AccountOverviewInputs.LICENSE_NUMBER) {
            return this.getCaliforniaLicenseNumberFromData(this.viewAgentProfileData);
        }
    }
    getValuesWhenViewDisabled(keyName) {
        if (keyName === AccountOverviewInputs.AGENT_USERNAME) {
            return this.agentService.getAgentUserName();
        }
        if (keyName === AccountOverviewInputs.AGENT_PASSWORD) {
            return '******';
        }
        if (keyName === AccountOverviewInputs.AGENT_NPN) {
            return this.agentService.getAgentNPN();
        }
        if (keyName === AccountOverviewInputs.AGENT_PERMISSION_LEVEL) {
            return this.agentService.getAgentRole();
        }
        if (keyName === AccountOverviewInputs.AGENT_AGENCY_ID) {
            return this.agentService.getAgencyId();
        }
        if (keyName === AccountOverviewInputs.AGENT_AGENCY_NAME) {
            return this.agentService.getAgencyName();
        }
        if (keyName === AccountOverviewInputs.SITE_ACCESS) {
            return `${!!this.agentService.getSiteAccess()}`;
        }
        if (keyName === AccountOverviewInputs.AGENT_EXPIRATION_DATE) {
            return DateUtilities.getFormattedDateTime(new Date(this.agentService.getAgentExpirationDate().slice(0, 19)), DateUtilities.defaultDateTimeISOFormat);
        }
        if (keyName === AccountOverviewInputs.AGENT_ID) {
            return this.agentService.getAgentId();
        }
        if (keyName === AccountOverviewInputs.ACCOUNT_STATUS) {
            return this.agentService.getAgentIsActive();
        }
        if (keyName === AccountOverviewInputs.FSR) {
            return this.agentService.getAgentFsr();
        }
        if (keyName === AccountOverviewInputs.ASP_REQUIRED) {
            return this.agentService.getASPRequired();
        }
        if (keyName === AccountOverviewInputs.ASP_ALLOW_ACCESS_TO_ALL_PLAN_YEARS) {
            return this.agentService.getASPAllowAccessToAllPlanYears();
        }
        if (keyName === AccountOverviewInputs.ASP_AGENT_PLAN_YEARS) {
            return this.agentService.getASPAgentPlanYear();
        }
        if (keyName === AccountOverviewInputs.PROFILE_ADMIN) {
            return this.agentService.getIsProfileAdmin();
        }
        // TODO: License is saved as an array in the API but the UI currently only supports CA
        if (keyName === AccountOverviewInputs.LICENSE_NUMBER) {
            return this.agentService.getCaliforniaLicenseNumber();
        }
    }
    getBaseNonAdminRoleDescriptions() {
        return [
            {
                key: AgentRole.QUOTER,
                value: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_QuoterDescription_Text', null, 'May create and view all site prospect profiles')
            },
            {
                key: AgentRole.QUOTER_BROKER,
                value: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_QuoterBrokerDescription_Text', null, 'May create and view own profiles')
            },
            {
                key: AgentRole.ENROLLER,
                value: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_EnrollerDescription_Text', null, 'May create/view all prospect profiles on all site accounts and enroll')
            },
            {
                key: AgentRole.ENROLLER_BROKER,
                value: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_EnrollerBrokerDescription_Text', null, 'May create/view own prospect profiles and enroll')
            }
        ];
    }
    getBaseAdminRoleDescriptions() {
        return [
            {
                key: AgentRole.QUOTER_ADMIN,
                value: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_QuoterAdminDescription_Text', null, 'May create/view profiles on all agent and agency accounts')
            },
            {
                key: AgentRole.ENROLLER_ADMIN,
                value: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_EnrollerAdminDescription_Text', null, 'May create/view all prospect profiles on all agent and agency site accounts and enroll')
            }
        ];
    }
    getQuoterAgencyAdminRoleDescription() {
        return {
            key: AgentRole.QUOTER_AGENCY_ADMIN,
            value: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_QuoterAgencyAdminDescription_Text', null, 'May view/edit any profile they have access to')
        };
    }
    getQuoterAgencyNonAdminRoleDescriptions() {
        return [
            {
                key: AgentRole.QUOTER_AGENCY,
                value: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_QuoterAgencyDescription_Text', null, 'May view/edit any profile they have access to within their agencies')
            },
            {
                key: AgentRole.QUOTER_SINGLE_AGENCY,
                value: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_QuoterSingleAgencyDescription_Text', null, 'May view/edit any profile they have access to within their single agency')
            }
        ];
    }
    getEnrollerAgencyAdminRoleDescription() {
        return {
            key: AgentRole.ENROLLER_AGENCY_ADMIN,
            value: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_EnrollerAgencyAdminDescription_Text', null, 'May create/view all prospect profiles on all agent and agency site accounts within all the agencies they are associated with and enroll')
        };
    }
    getEnrollerAgencyNonAdminRoleDescriptions() {
        return [
            {
                key: AgentRole.ENROLLER_AGENCY,
                value: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_EnrollerAgencyDescription_Text', null, 'May create/view all prospect profiles on all site accounts within all the agencies they are associated with and enroll')
            },
            {
                key: AgentRole.ENROLLER_SINGLE_AGENCY,
                value: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_EnrollerSingleAgencyDescription_Text', null, 'May create/view all prospect profiles on all site accounts within their single agency and enroll')
            }
        ];
    }
    getCaliforniaLicenseNumberFromData(agentData) {
        return agentData?.licenses?.find(license => license.state?.toLowerCase() === 'ca')?.license ?? '';
    }
}
AccountOverviewFacade.ɵfac = function AccountOverviewFacade_Factory(t) { return new (t || AccountOverviewFacade)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i4.UntypedFormBuilder), i0.ɵɵinject(i1.FormValidationService), i0.ɵɵinject(i1.AgentService), i0.ɵɵinject(i1.LoginService), i0.ɵɵinject(i1.NavigationService), i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(i1.AccountOverviewService), i0.ɵɵinject(i1.AgentPermissionsService), i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(i1.PlanYearResourceService), i0.ɵɵinject(i1.SiteService), i0.ɵɵinject(i1.MessagesService)); };
AccountOverviewFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AccountOverviewFacade, factory: AccountOverviewFacade.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], AccountOverviewFacade.prototype, "sortAgenciesByName", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccountOverviewFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i2.Store }, { type: i1.ConfigResourceService }, { type: i4.UntypedFormBuilder }, { type: i1.FormValidationService }, { type: i1.AgentService }, { type: i1.LoginService }, { type: i1.NavigationService }, { type: i2$1.Router }, { type: i1.AccountOverviewService }, { type: i1.AgentPermissionsService }, { type: i1$1.NgbModal }, { type: i1.MemberSessionService }, { type: i1.PlanYearResourceService }, { type: i1.SiteService }, { type: i1.MessagesService }]; }, { sortAgenciesByName: [] }); })();

function AgentProfilePictureComponent_div_0_img_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 6);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r4.agentProfilePictureUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("alt", ctx_r4.agentProfilePictureAlternateText);
} }
function AgentProfilePictureComponent_div_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c0$3_ = function (a0) { return { "agent-profile-wrapper Spa_Style_Accent6_Background": a0 }; };
function AgentProfilePictureComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 3);
    i0.ɵɵtemplate(2, AgentProfilePictureComponent_div_0_img_2_Template, 1, 2, "img", 4);
    i0.ɵɵtemplate(3, AgentProfilePictureComponent_div_0_ng_container_3_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$3_, !ctx_r0.isUpload));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r0.isUpload ? "agent-upload-profile" : "agent-profile Spa_Style_Accent6_Background text-center");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.agentProfilePictureUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function AgentProfilePictureComponent_ng_container_1_img_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 8);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("alt", ctx_r6.agentProfilePictureAlternateText);
    i0.ɵɵproperty("src", ctx_r6.agentProfilePictureUrl, i0.ɵɵsanitizeUrl);
} }
function AgentProfilePictureComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AgentProfilePictureComponent_ng_container_1_img_1_Template, 1, 2, "img", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.agentProfilePictureUrl)("ngIfElse", _r2);
} }
const _c1$28 = function (a0, a1) { return { "agent-initials": a0, "agent-initials-view-only": a1 }; };
function AgentProfilePictureComponent_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c1$28, !ctx_r7.isViewOnly, ctx_r7.isViewOnly));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.agentInitials, " ");
} }
function AgentProfilePictureComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, AgentProfilePictureComponent_ng_template_2_div_0_Template, 2, 5, "div", 9);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r3.agentProfilePictureUrl);
} }
class AgentProfilePictureComponent {
    constructor(accountOverviewFacade, localeService, cdr) {
        this.accountOverviewFacade = accountOverviewFacade;
        this.localeService = localeService;
        this.cdr = cdr;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe(() => {
            this.agentProfilePictureAlternateText = this.accountOverviewFacade.getAgentProfilePictureAlternateText();
            this.cdr.markForCheck();
        }));
    }
    get agentInitials() {
        if (this.broker) {
            const firstName = this.broker.firstName;
            const lastName = this.broker.lastName;
            if (firstName && lastName) {
                return `${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`;
            }
            if (firstName) {
                return `${firstName.charAt(0).toUpperCase()}`;
            }
            if (lastName) {
                return `${lastName.charAt(0).toUpperCase()}`;
            }
        }
        return '';
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
AgentProfilePictureComponent.ɵfac = function AgentProfilePictureComponent_Factory(t) { return new (t || AgentProfilePictureComponent)(i0.ɵɵdirectiveInject(AccountOverviewFacade), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
AgentProfilePictureComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentProfilePictureComponent, selectors: [["vnext-agent-profile-picture"]], inputs: { broker: "broker", isUpload: "isUpload", agentProfilePictureUrl: "agentProfilePictureUrl", isViewOnly: "isViewOnly" }, decls: 4, vars: 2, consts: [[3, "ngClass", 4, "ngIf"], [4, "ngIf"], ["agentInitialsTemplate", ""], [3, "ngClass"], ["class", "agent-profile-pic", 3, "src", "alt", 4, "ngIf"], [4, "ngTemplateOutlet"], [1, "agent-profile-pic", 3, "src", "alt"], ["class", "agent-profile-pic-view-only", 3, "alt", "src", 4, "ngIf", "ngIfElse"], [1, "agent-profile-pic-view-only", 3, "alt", "src"], ["class", "rounded-circle Spa_Style_Gray4_Background Spa_Style_Secondary_Text_Color", 3, "ngClass", 4, "ngIf"], [1, "rounded-circle", "Spa_Style_Gray4_Background", "Spa_Style_Secondary_Text_Color", 3, "ngClass"]], template: function AgentProfilePictureComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, AgentProfilePictureComponent_div_0_Template, 4, 6, "div", 0);
        i0.ɵɵtemplate(1, AgentProfilePictureComponent_ng_container_1_Template, 2, 2, "ng-container", 1);
        i0.ɵɵtemplate(2, AgentProfilePictureComponent_ng_template_2_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.isViewOnly);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isViewOnly);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$2.NgTemplateOutlet], styles: [".agent-profile-wrapper[_ngcontent-%COMP%]{border-radius:100%;padding:10px;text-align:center;width:224px;margin:-80px auto}.agent-profile[_ngcontent-%COMP%]{height:205px;width:205px;position:relative;border-radius:100%;overflow:hidden;border:1px solid var(--static-Spa_Style_Accent1)}.agent-upload-profile[_ngcontent-%COMP%]{height:150px;width:150px;position:relative;border-radius:100%;overflow:hidden;border:1px solid var(--static-Spa_Style_Accent1);margin:0 auto}.agent-profile-pic[_ngcontent-%COMP%]{position:absolute;left:-50%;right:-50%;top:0;margin:auto;height:100%;width:auto;image-rendering:-webkit-optimize-contrast}.agent-profile-pic-view-only[_ngcontent-%COMP%]{width:35px;height:35px;border-radius:100%;image-rendering:-webkit-optimize-contrast}.agent-initials-view-only[_ngcontent-%COMP%]{width:35px;height:35px;display:flex;justify-content:center;align-items:center}.agent-initials[_ngcontent-%COMP%]{width:100%;height:100%;display:flex;justify-content:center;align-items:center;font-size:48px;font-family:montserrat_light}@media (max-width: 767.9px){.agent-profile-wrapper[_ngcontent-%COMP%]{width:189px}.agent-profile[_ngcontent-%COMP%]{width:170px;height:170px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentProfilePictureComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-profile-picture', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"!isViewOnly\" [ngClass]=\"{ 'agent-profile-wrapper Spa_Style_Accent6_Background': !isUpload }\">\r\n  <div [ngClass]=\"isUpload ? 'agent-upload-profile' : 'agent-profile Spa_Style_Accent6_Background text-center'\">\r\n    <img src=\"{{ agentProfilePictureUrl }}\" alt=\"{{agentProfilePictureAlternateText}}\" class=\"agent-profile-pic\" *ngIf=\"agentProfilePictureUrl\" />\r\n    <ng-container *ngTemplateOutlet=\"agentInitialsTemplate\"></ng-container>\r\n  </div>\r\n</div>\r\n<ng-container *ngIf=\"isViewOnly\">\r\n  <img class=\"agent-profile-pic-view-only\" alt=\"{{agentProfilePictureAlternateText}}\" *ngIf=\"agentProfilePictureUrl; else agentInitialsTemplate\"\r\n    [src]=\"agentProfilePictureUrl\" />\r\n</ng-container>\r\n<ng-template #agentInitialsTemplate>\r\n  <div class=\"rounded-circle Spa_Style_Gray4_Background Spa_Style_Secondary_Text_Color\"\r\n    [ngClass]=\"{ 'agent-initials': !isViewOnly, 'agent-initials-view-only': isViewOnly }\"\r\n    *ngIf=\"!agentProfilePictureUrl\">\r\n    {{ agentInitials }}\r\n  </div>\r\n</ng-template>", styles: [".agent-profile-wrapper{border-radius:100%;padding:10px;text-align:center;width:224px;margin:-80px auto}.agent-profile{height:205px;width:205px;position:relative;border-radius:100%;overflow:hidden;border:1px solid var(--static-Spa_Style_Accent1)}.agent-upload-profile{height:150px;width:150px;position:relative;border-radius:100%;overflow:hidden;border:1px solid var(--static-Spa_Style_Accent1);margin:0 auto}.agent-profile-pic{position:absolute;left:-50%;right:-50%;top:0;margin:auto;height:100%;width:auto;image-rendering:-webkit-optimize-contrast}.agent-profile-pic-view-only{width:35px;height:35px;border-radius:100%;image-rendering:-webkit-optimize-contrast}.agent-initials-view-only{width:35px;height:35px;display:flex;justify-content:center;align-items:center}.agent-initials{width:100%;height:100%;display:flex;justify-content:center;align-items:center;font-size:48px;font-family:montserrat_light}@media (max-width: 767.9px){.agent-profile-wrapper{width:189px}.agent-profile{width:170px;height:170px}}\n"] }]
    }], function () { return [{ type: AccountOverviewFacade }, { type: i1.LocaleService }, { type: i0.ChangeDetectorRef }]; }, { broker: [{
            type: Input
        }], isUpload: [{
            type: Input
        }], agentProfilePictureUrl: [{
            type: Input
        }], isViewOnly: [{
            type: Input
        }] }); })();

function SendQuoteModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "h2", 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.quoteSendQuoteToHeader, " ");
} }
function SendQuoteModalComponent_div_5_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r14.firstNameRequiredError);
} }
function SendQuoteModalComponent_div_5_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r15.firstNameInvalidError);
} }
function SendQuoteModalComponent_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelement(1, "i", 25);
    i0.ɵɵtemplate(2, SendQuoteModalComponent_div_5_div_2_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵtemplate(3, SendQuoteModalComponent_div_5_div_2_span_3_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r12.hasRequiredErrors("firstName"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.getFieldErrors("firstName").minlength);
} }
function SendQuoteModalComponent_div_5_div_9_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r16.lastNameRequiredError);
} }
function SendQuoteModalComponent_div_5_div_9_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r17.lastNameInvalidError);
} }
function SendQuoteModalComponent_div_5_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelement(1, "i", 25);
    i0.ɵɵtemplate(2, SendQuoteModalComponent_div_5_div_9_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵtemplate(3, SendQuoteModalComponent_div_5_div_9_span_3_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r13.hasRequiredErrors("lastName"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.getFieldErrors("lastName").minlength);
} }
function SendQuoteModalComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16);
    i0.ɵɵtemplate(2, SendQuoteModalComponent_div_5_div_2_Template, 4, 2, "div", 17);
    i0.ɵɵelementStart(3, "label", 18)(4, "span", 19);
    i0.ɵɵtext(5, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "input", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 16);
    i0.ɵɵtemplate(9, SendQuoteModalComponent_div_5_div_9_Template, 4, 2, "div", 21);
    i0.ɵɵelementStart(10, "label", 22)(11, "span", 19);
    i0.ɵɵtext(12, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "input", 23);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.fieldHasError("firstName"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.modalFirstNameLabelText);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-describedby", ctx_r1.fieldHasError("firstName") ? "firstNameError" : null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.fieldHasError("lastName"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.modalLastNameLabelText);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-describedby", ctx_r1.fieldHasError("lastName") ? "lastNameError" : null);
} }
function SendQuoteModalComponent_ng_container_6_div_2_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r22.dateOfBirthRequiredError);
} }
function SendQuoteModalComponent_ng_container_6_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵelement(1, "i", 25);
    i0.ɵɵtemplate(2, SendQuoteModalComponent_ng_container_6_div_2_div_1_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r21.hasRequiredErrors("dateOfBirth"));
} }
function SendQuoteModalComponent_ng_container_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtemplate(1, SendQuoteModalComponent_ng_container_6_div_2_div_1_Template, 3, 1, "div", 29);
    i0.ɵɵelementStart(2, "label", 30)(3, "span", 19);
    i0.ɵɵtext(4, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "input", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.fieldHasError("dateOfBirth"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r18.modalDateOfBirthLabelText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r18.getDateFormat());
    i0.ɵɵpropertyInterpolate("mask", ctx_r18.getDateMaskFormat());
    i0.ɵɵproperty("dropSpecialCharacters", false);
    i0.ɵɵattribute("aria-describedby", ctx_r18.fieldHasError("dateOfBirth") ? "firstNameError" : null);
} }
function SendQuoteModalComponent_ng_container_6_div_3_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r24.phoneRequiredError);
} }
function SendQuoteModalComponent_ng_container_6_div_3_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r25.phoneInvalidError);
} }
function SendQuoteModalComponent_ng_container_6_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelement(1, "i", 25);
    i0.ɵɵtemplate(2, SendQuoteModalComponent_ng_container_6_div_3_div_1_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵtemplate(3, SendQuoteModalComponent_ng_container_6_div_3_div_1_span_3_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r23.getFieldErrors("phone").required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r23.getFieldErrors("phone").pattern);
} }
function SendQuoteModalComponent_ng_container_6_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtemplate(1, SendQuoteModalComponent_ng_container_6_div_3_div_1_Template, 4, 2, "div", 33);
    i0.ɵɵelementStart(2, "label", 34)(3, "span", 19);
    i0.ɵɵtext(4, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "input", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.fieldHasError("phone"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r19.modalPhoneLabelText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("maxLength", ctx_r19.phoneMask.length)("mask", ctx_r19.phoneMask);
    i0.ɵɵattribute("aria-describedby", ctx_r19.fieldHasError("phone") ? "phoneError" : null);
} }
function SendQuoteModalComponent_ng_container_6_ng_container_4_ng_container_1_div_1_div_1_div_1_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r30 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(field_r30.requiredText);
} }
function SendQuoteModalComponent_ng_container_6_ng_container_4_ng_container_1_div_1_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵelement(1, "i", 25);
    i0.ɵɵtemplate(2, SendQuoteModalComponent_ng_container_6_ng_container_4_ng_container_1_div_1_div_1_div_1_div_1_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r30 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r32 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate("id", field_r30.keyName + "Error");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r32.hasRequiredErrors(field_r30.keyName));
} }
function SendQuoteModalComponent_ng_container_6_ng_container_4_ng_container_1_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SendQuoteModalComponent_ng_container_6_ng_container_4_ng_container_1_div_1_div_1_div_1_div_1_Template, 3, 2, "div", 39);
    i0.ɵɵelementStart(2, "label", 40)(3, "span", 19);
    i0.ɵɵtext(4, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "input", 41);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r30 = i0.ɵɵnextContext().$implicit;
    const ctx_r31 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r31.fieldHasError(field_r30.keyName));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", field_r30.keyName);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(field_r30.labelText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", field_r30.keyName)("formControlName", field_r30.keyName);
    i0.ɵɵattribute("aria-describedby", ctx_r31.fieldHasError(field_r30.keyName) ? field_r30.keyName + "Error" : null);
} }
function SendQuoteModalComponent_ng_container_6_ng_container_4_ng_container_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtemplate(1, SendQuoteModalComponent_ng_container_6_ng_container_4_ng_container_1_div_1_div_1_div_1_Template, 7, 6, "div", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r30 = ctx.$implicit;
    const ctx_r29 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r29.isFieldRequired(field_r30.keyName));
} }
function SendQuoteModalComponent_ng_container_6_ng_container_4_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, SendQuoteModalComponent_ng_container_6_ng_container_4_ng_container_1_div_1_div_1_Template, 2, 1, "div", 38);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const customFieldRow_r27 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", customFieldRow_r27);
} }
function SendQuoteModalComponent_ng_container_6_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SendQuoteModalComponent_ng_container_6_ng_container_4_ng_container_1_div_1_Template, 2, 1, "div", 5);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const customFieldRow_r27 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", customFieldRow_r27 == null ? null : customFieldRow_r27.length);
} }
function SendQuoteModalComponent_ng_container_6_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SendQuoteModalComponent_ng_container_6_ng_container_4_ng_container_1_Template, 2, 1, "ng-container", 37);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r20.customFieldsRows);
} }
function SendQuoteModalComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵtemplate(2, SendQuoteModalComponent_ng_container_6_div_2_Template, 7, 6, "div", 27);
    i0.ɵɵtemplate(3, SendQuoteModalComponent_ng_container_6_div_3_Template, 7, 5, "div", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, SendQuoteModalComponent_ng_container_6_ng_container_4_Template, 2, 1, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.isFieldRequired("dateOfBirth"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isFieldRequired("phone"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.customFieldsRows == null ? null : ctx_r2.customFieldsRows.length);
} }
function SendQuoteModalComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43)(1, "div", 16);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.modalPromptText);
} }
function SendQuoteModalComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44)(1, "div", 45);
    i0.ɵɵelement(2, "i", 25);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r4.checkBoxRequiredError);
} }
function SendQuoteModalComponent_div_9_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r40.emailRequiredError);
} }
function SendQuoteModalComponent_div_9_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r41.emailInvalidError);
} }
function SendQuoteModalComponent_div_9_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵelement(1, "i", 25);
    i0.ɵɵtemplate(2, SendQuoteModalComponent_div_9_div_1_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵtemplate(3, SendQuoteModalComponent_div_9_div_1_span_3_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r38.getFieldErrors("emailAddress").required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r38.getFieldErrors("emailAddress").email);
} }
function SendQuoteModalComponent_div_9_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 53)(1, "label", 54)(2, "input", 55);
    i0.ɵɵlistener("click", function SendQuoteModalComponent_div_9_div_2_Template_input_click_2_listener() { i0.ɵɵrestoreView(_r43); const ctx_r42 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r42.toggleEmailCheckBox()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r39.modalEmailCheckboxLabelText, " ");
} }
const _c0$3Z = function (a0) { return { "no-gutters": a0 }; };
const _c1$27 = function (a0, a1) { return { "col-sm-auto col-md-6": a0, "col": a1 }; };
function SendQuoteModalComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵtemplate(1, SendQuoteModalComponent_div_9_div_1_Template, 4, 2, "div", 47);
    i0.ɵɵtemplate(2, SendQuoteModalComponent_div_9_div_2_Template, 4, 1, "div", 48);
    i0.ɵɵelementStart(3, "div", 49)(4, "label", 50)(5, "span", 19);
    i0.ɵɵtext(6, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "input", 51);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$3Z, !ctx_r5.showCreateNewProfileForm));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.fieldHasError("emailAddress"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.showCheckBoxes);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c1$27, ctx_r5.showCreateNewProfileForm, !ctx_r5.showCreateNewProfileForm));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r5.modalEmailLabelText);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-describedby", ctx_r5.fieldHasError("emailAddress") ? "emailAddressError" : null);
} }
function SendQuoteModalComponent_div_10_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r46.phoneRequiredError);
} }
function SendQuoteModalComponent_div_10_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r47.phoneInvalidError);
} }
function SendQuoteModalComponent_div_10_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 58);
    i0.ɵɵelement(1, "i", 25);
    i0.ɵɵtemplate(2, SendQuoteModalComponent_div_10_div_1_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵtemplate(3, SendQuoteModalComponent_div_10_div_1_span_3_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r44.getFieldErrors("phone").required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r44.getFieldErrors("phone").pattern);
} }
function SendQuoteModalComponent_div_10_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 53)(1, "label", 59)(2, "input", 60);
    i0.ɵɵlistener("click", function SendQuoteModalComponent_div_10_div_2_Template_input_click_2_listener() { i0.ɵɵrestoreView(_r49); const ctx_r48 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r48.togglePhoneCheckBox()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r45.modalPhoneCheckboxLabelText, " ");
} }
const _c2$1j = function (a0, a1) { return { "mt-3": a0, "no-gutters": a1 }; };
function SendQuoteModalComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵtemplate(1, SendQuoteModalComponent_div_10_div_1_Template, 4, 2, "div", 56);
    i0.ɵɵtemplate(2, SendQuoteModalComponent_div_10_div_2_Template, 4, 1, "div", 48);
    i0.ɵɵelementStart(3, "div", 49)(4, "label", 34)(5, "span", 19);
    i0.ɵɵtext(6, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "input", 57);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c2$1j, ctx_r6.showEmail, !ctx_r6.showCreateNewProfileForm));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.fieldHasError("phone"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.showCheckBoxes);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c1$27, ctx_r6.showCreateNewProfileForm, !ctx_r6.showCreateNewProfileForm));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r6.modalPhoneLabelText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("maxLength", ctx_r6.phoneMask.length)("mask", ctx_r6.phoneMask);
    i0.ɵɵattribute("aria-describedby", ctx_r6.fieldHasError("phone") ? "phoneError" : null);
} }
function SendQuoteModalComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 61)(1, "label", 62)(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div")(5, "h5", 63)(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(8, "textarea", 64);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r7.modalAdditionalTitle);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r7.modalAdditionalSubText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r7.modalAdditionalDefaultMessage);
} }
function SendQuoteModalComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 61)(1, "label", 65)(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 66)(5, "div", 67);
    i0.ɵɵelement(6, "vnext-agent-profile-picture", 68);
    i0.ɵɵelementStart(7, "div", 69)(8, "span", 70);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    let tmp_4_0;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r8.sendQuoteSendingAgentLabelText);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("broker", ctx_r8.agentOfRecord == null ? null : ctx_r8.agentOfRecord.data)("isViewOnly", true)("agentProfilePictureUrl", ctx_r8.agentOfRecord == null ? null : ctx_r8.agentOfRecord.data == null ? null : ctx_r8.agentOfRecord.data.agentPictureURL);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", (tmp_4_0 = ctx_r8.agentOfRecord == null ? null : ctx_r8.agentOfRecord.data == null ? null : ctx_r8.agentOfRecord.data.firstName) !== null && tmp_4_0 !== undefined ? tmp_4_0 : "", " ", (tmp_4_0 = ctx_r8.agentOfRecord == null ? null : ctx_r8.agentOfRecord.data == null ? null : ctx_r8.agentOfRecord.data.lastName) !== null && tmp_4_0 !== undefined ? tmp_4_0 : "", "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" (", ctx_r8.agentOfRecordText, ") ");
} }
function SendQuoteModalComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 61)(1, "label", 71)(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 72)(5, "label", 73);
    i0.ɵɵelement(6, "input", 74);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r9.personalizedVideoCheckboxHeaderText);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.personalizedVideoCheckboxLabelText, " ");
} }
function SendQuoteModalComponent_div_16_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r53 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 79);
    i0.ɵɵlistener("click", function SendQuoteModalComponent_div_16_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r53); const ctx_r52 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r52.toggleSelectAll()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r50.plansNotLicensedToSell);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r50.selectAllButtonText, " ");
} }
function SendQuoteModalComponent_div_16_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 84);
    i0.ɵɵelement(1, "i", 25);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementStart(4, "span", 70);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const plan_r54 = i0.ɵɵnextContext().$implicit;
    const ctx_r55 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r55.planCardNotLicensedText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(plan_r54.planName);
} }
function SendQuoteModalComponent_div_16_div_6_ng_container_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 87)(1, "label", 88);
    i0.ɵɵelement(2, "input", 89);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const document_r59 = ctx.$implicit;
    const i_r60 = ctx.index;
    const plan_r54 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r58 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", "documentId" + i_r60);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", "documentId" + i_r60)("formControlName", i_r60);
    i0.ɵɵattribute("disabled", !(ctx_r58.planPermissions == null ? null : ctx_r58.planPermissions[plan_r54.id] == null ? null : ctx_r58.planPermissions[plan_r54.id].hasPermission) ? true : null);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", document_r59.linkName, " ");
} }
function SendQuoteModalComponent_div_16_div_6_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 85);
    i0.ɵɵtemplate(1, SendQuoteModalComponent_div_16_div_6_ng_container_4_div_1_Template, 4, 5, "div", 86);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const plan_r54 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", plan_r54.documents);
} }
function SendQuoteModalComponent_div_16_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 80);
    i0.ɵɵtemplate(1, SendQuoteModalComponent_div_16_div_6_div_1_Template, 6, 2, "div", 81);
    i0.ɵɵelementStart(2, "span", 82);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, SendQuoteModalComponent_div_16_div_6_ng_container_4_Template, 2, 1, "ng-container", 83);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r54 = ctx.$implicit;
    const ctx_r51 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r51.planPermissions == null ? null : ctx_r51.planPermissions[plan_r54.id]) && !(ctx_r51.planPermissions == null ? null : ctx_r51.planPermissions[plan_r54.id] == null ? null : ctx_r51.planPermissions[plan_r54.id].hasPermission));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(plan_r54.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r51.plansIncluded.length === 1);
} }
function SendQuoteModalComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 61)(1, "div", 75)(2, "label", 76)(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, SendQuoteModalComponent_div_16_button_5_Template, 2, 2, "button", 77);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, SendQuoteModalComponent_div_16_div_6_Template, 5, 3, "div", 78);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r10.modalPlansIncludedLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.plansIncluded.length === 1 && ctx_r10.plansIncluded[0].documents.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r10.plansIncluded);
} }
function SendQuoteModalComponent_div_17_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r67 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 72)(1, "label", 88)(2, "input", 92);
    i0.ɵɵlistener("change", function SendQuoteModalComponent_div_17_div_7_Template_input_change_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r67); const pharmacy_r64 = restoredCtx.$implicit; const ctx_r66 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r66.primaryPharmacy = pharmacy_r64); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 70);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const pharmacy_r64 = ctx.$implicit;
    const ctx_r63 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", pharmacy_r64.pharmacyId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", pharmacy_r64.pharmacyId)("name", "pharmacies")("checked", ctx_r63.primaryPharmacy.pharmacyId === pharmacy_r64.pharmacyId);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(pharmacy_r64.name);
} }
function SendQuoteModalComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 61)(1, "div", 75)(2, "label", 65)(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(5, "span", 90);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, SendQuoteModalComponent_div_17_div_7_Template, 5, 5, "div", 91);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r11.modalPharmacyHeaderText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r11.modalPharmacySubText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r11.selectedPharmacies);
} }
class SendQuoteModalComponent {
    constructor(activeModal, store, cdr, profileService) {
        this.activeModal = activeModal;
        this.store = store;
        this.cdr = cdr;
        this.profileService = profileService;
        this.modalSelectAllButtonText = 'Select all';
        this.modalSelectNoneButtonText = 'Clear all';
        this.phoneMask = '(000) 000-0000';
        this.showPersonalizedVideoCheckbox = false;
        this.hasCheckboxRequiredError = false;
        this.subscriptions = [];
        this.selectedPlanDocuments = [];
        this.areAllPlanDocumentsSelected = false;
        this.memberRegistrationFields = [];
        this.customFields = [];
        this.customFieldsRows = [[], [], []];
        this.plansNotLicensedToSell = false;
        this.quoteLinkEmailOnlyEnabled = false;
        this.authCodeTextOnlyEnabled = false;
    }
    get showCreateNewProfileForm() {
        // If feature enabled and we do not have a member profile.
        return this.isCreateNewProfileEnabled && !this.profileService.hasMemberProfile();
    }
    get showProfileNames() {
        // If feature enabled and we do not have a member profile.
        return this.isQuoteShowProfileNamesEnabled && this.profileService.hasMemberProfile();
    }
    get selectAllButtonText() {
        return this.areAllPlanDocumentsSelected ? this.modalSelectNoneButtonText : this.modalSelectAllButtonText;
    }
    get canShowPlanDocuments() {
        // Only display plan documents when sending by email or text
        const email = this.sendQuoteFormGroup.controls.emailAddress;
        const text = this.sendQuoteFormGroup.controls.phone;
        return this.showPlanDocuments && this.plansIncluded && !!this.plansIncluded.length && (email.enabled || text.enabled);
    }
    ngOnInit() {
        this.initializeForm();
        this.initializePlanDocumentControls();
    }
    closeSendQuoteModal() {
        this.activeModal.dismiss();
        if (this.cancelAction) {
            this.cancelAction();
        }
    }
    getFieldErrors(fieldName) {
        const control = this.sendQuoteFormGroup.get(fieldName);
        return control.errors || {};
    }
    hasRequiredErrors(fieldName) {
        const errors = this.getFieldErrors(fieldName);
        return !!errors.required || !!errors.pattern;
    }
    fieldHasError(fieldName) {
        const control = this.sendQuoteFormGroup.get(fieldName);
        return !control.valid && control.touched && !control.disabled;
    }
    isFieldRequired(fieldName) {
        const fieldByName = this.memberRegistrationFields.find(field => field.keyName === fieldName);
        return fieldByName && fieldByName.required;
    }
    getDateFormat() {
        return DateUtilities.defaultFormat;
    }
    getDateMaskFormat() {
        return FormValidationService.dateMask;
    }
    toggleEmailCheckBox() {
        const emailCheckbox = this.sendQuoteFormGroup.controls.emailAddressCheckbox;
        const email = this.sendQuoteFormGroup.controls.emailAddress;
        if (emailCheckbox.value) {
            this.hasCheckboxRequiredError = false;
        }
        const updatedCheckboxValue = !emailCheckbox.value;
        emailCheckbox.setValue(updatedCheckboxValue);
        updatedCheckboxValue ? email.enable() : email.disable();
        this.cdr.markForCheck();
    }
    togglePhoneCheckBox() {
        const phoneCheckbox = this.sendQuoteFormGroup.controls.phoneCheckbox;
        const phone = this.sendQuoteFormGroup.controls.phone;
        if (phoneCheckbox.value) {
            this.hasCheckboxRequiredError = false;
        }
        const updatedCheckboxValue = !phoneCheckbox.value;
        phoneCheckbox.setValue(updatedCheckboxValue);
        updatedCheckboxValue ? phone.enable() : phone.disable();
    }
    onSendQuote() {
        // Validate at least email or phone checkbox is checked
        if (this.showCheckBoxes) {
            const phoneCheckbox = this.sendQuoteFormGroup.controls.phoneCheckbox;
            const emailCheckbox = this.sendQuoteFormGroup.controls.emailAddressCheckbox;
            if (!phoneCheckbox.value && !emailCheckbox.value) {
                this.hasCheckboxRequiredError = true;
                return;
            }
            if (emailCheckbox.value && this.hasRequiredErrors('emailAddress')) {
                this.sendQuoteFormGroup.get('emailAddress').markAsTouched({ onlySelf: true });
            }
            if (phoneCheckbox.value && this.hasRequiredErrors('phone')) {
                this.sendQuoteFormGroup.get('phone').markAsTouched({ onlySelf: true });
            }
            this.hasCheckboxRequiredError = false;
        }
        // Mark each of the controls as touched to trigger validation.
        this.validateCreateProfileControls();
        if (this.sendQuoteFormGroup.status !== 'INVALID') {
            const emailAddressCheckbox = this.sendQuoteFormGroup.get('emailAddressCheckbox').value;
            const emailAddress = emailAddressCheckbox || !this.showCheckBoxes ? this.sendQuoteFormGroup.get('emailAddress').value : null;
            const phoneCheckbox = this.sendQuoteFormGroup.get('phoneCheckbox').value;
            const phone = phoneCheckbox || this.showCreateNewProfileForm ? this.sendQuoteFormGroup.get('phone').value : null;
            const isQuoteVideoEnabled = this.personalizedVideoEnabled && this.personalizedQuoteVideoEnabled;
            const includeVideo = this.showPersonalizedVideoCheckbox
                ? this.sendQuoteFormGroup.get('personalizedVideoCheckbox').value
                : isQuoteVideoEnabled;
            // Disabled controls have value of NULL
            const formData = {
                emailAddress,
                phone,
                additionalMessage: this.sendQuoteFormGroup.get('additionalMessage').value,
                planDocuments: this.selectedPlanDocuments,
                selectedPharmacy: this.primaryPharmacy,
                firstName: this.sendQuoteFormGroup.get('firstName').value,
                lastName: this.sendQuoteFormGroup.get('lastName').value,
                dateOfBirth: this.sendQuoteFormGroup.get('dateOfBirth').value,
                customField1: this.sendQuoteFormGroup.get('customField1').value,
                customField2: this.sendQuoteFormGroup.get('customField2').value,
                customField3: this.sendQuoteFormGroup.get('customField3').value,
                customField4: this.sendQuoteFormGroup.get('customField4').value,
                customField5: this.sendQuoteFormGroup.get('customField5').value,
                includeVideo
            };
            this.activeModal.close(formData);
        }
    }
    toggleSelectAll() {
        const newValue = !this.areAllPlanDocumentsSelected;
        this.planDocumentFormArray.controls.forEach(control => {
            control.setValue(newValue);
        });
    }
    showPharmacySection() {
        if (this.plansIncluded?.length && this.plansIncluded[0]) {
            const planType = this.plansIncluded[0].planTypeAbbreviation;
            return ((planType === PlanTypeAbbreviation.PDP || planType === PlanTypeAbbreviation.MAPD) &&
                this.isMultiPharmacyEnabled &&
                this.selectedPharmacies &&
                this.selectedPharmacies.length > 1);
        }
        return false;
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }
    validateCreateProfileControls() {
        if (this.showCreateNewProfileForm) {
            Object.values(this.sendQuoteFormGroup.controls)
                .filter(control => control.enabled)
                .forEach(control => {
                control.markAsTouched({ onlySelf: true });
            });
        }
    }
    initializeForm() {
        const memberProfileData = this.store.selectSnapshot(MemberState.session);
        this.showCheckBoxes = this.showEmailAndPhoneCheckbox && this.showEmail && this.showPhone;
        this.showPersonalizedVideoCheckbox = this.isPersonalizedVideoCheckboxEnabled();
        const profileEmailAddress = this.profileService.hasMemberProfile() ? memberProfileData.profile.emailAddress : null;
        const profileFirstName = this.profileService.hasMemberProfile() ? memberProfileData.profile.firstName : null;
        const profileLastName = this.profileService.hasMemberProfile() ? memberProfileData.profile.lastName : null;
        const profilePhone = this.profileService.getPrimaryPhoneNumber(memberProfileData);
        const defaultEmailAddress = profileEmailAddress;
        const defaultPhone = profilePhone;
        const defaultAdditionalMessage = this.modalIsPresonalizedMessageEnabled ? this.modalAdditionalDefaultMessage : null;
        // By disabling form control, the form group status will only take into consideration active form controls
        this.sendQuoteFormGroup = new UntypedFormGroup({
            emailAddress: new UntypedFormControl({ value: defaultEmailAddress, disabled: !this.quoteLinkEmailOnlyEnabled }, [
                Validators.required,
                Validators.email
            ]),
            emailAddressCheckbox: new UntypedFormControl({ value: this.quoteLinkEmailOnlyEnabled, disabled: this.quoteLinkEmailOnlyEnabled }),
            phone: new UntypedFormControl({
                value: defaultPhone,
                disabled: !this.isPhoneFieldEnabled(this.authCodeTextOnlyEnabled)
            }, [Validators.pattern(RegexPattern.US_TELEPHONE), Validators.required, Validators.maxLength(this.phoneMask.length)]),
            phoneCheckbox: new UntypedFormControl({ value: this.authCodeTextOnlyEnabled, disabled: this.authCodeTextOnlyEnabled }),
            firstName: new UntypedFormControl({ value: profileFirstName, disabled: !this.showCreateNewProfileForm }, [
                Validators.required,
                Validators.minLength(2),
                Validators.pattern(FormValidationService.nonWhiteSpacePattern)
            ]),
            lastName: new UntypedFormControl({ value: profileLastName, disabled: !this.showCreateNewProfileForm }, [
                Validators.required,
                Validators.minLength(2),
                Validators.pattern(FormValidationService.nonWhiteSpacePattern)
            ]),
            additionalMessage: new UntypedFormControl(defaultAdditionalMessage),
            dateOfBirth: new UntypedFormControl({ value: null, disabled: !this.isFieldEnabled('dateOfBirth') }, [
                Validators.required,
                Validators.maxLength(12)
            ]),
            customField1: new UntypedFormControl({ value: null, disabled: !this.isFieldEnabled('customField1') }, [
                Validators.required,
                Validators.maxLength(255)
            ]),
            customField2: new UntypedFormControl({ value: null, disabled: !this.isFieldEnabled('customField2') }, [
                Validators.required,
                Validators.maxLength(255)
            ]),
            customField3: new UntypedFormControl({ value: null, disabled: !this.isFieldEnabled('customField3') }, [
                Validators.required,
                Validators.maxLength(255)
            ]),
            customField4: new UntypedFormControl({ value: null, disabled: !this.isFieldEnabled('customField4') }, [
                Validators.required,
                Validators.maxLength(255)
            ]),
            customField5: new UntypedFormControl({ value: null, disabled: !this.isFieldEnabled('customField5') }, [
                Validators.required,
                Validators.maxLength(255)
            ]),
            personalizedVideoCheckbox: new UntypedFormControl(this.personalizedVideoCheckboxChecked)
        }, { updateOn: 'blur' });
        if (this.showCreateNewProfileForm) {
            this.setRequiredFormFieldAttributes();
        }
        this.setLicensedToSell();
    }
    setLicensedToSell() {
        const planPermission = this.plansIncluded?.map(plan => {
            return {
                planId: plan.id,
                hasPermission: this.planPermissions?.[plan.id]?.hasPermission
            };
        });
        const hasPermission = planPermission?.filter(plan => !plan.hasPermission);
        if (hasPermission?.length >= 1) {
            this.plansNotLicensedToSell = true;
        }
    }
    isFieldEnabled(fieldName) {
        return this.showCreateNewProfileForm ? this.isFieldRequired(fieldName) : false;
    }
    isPhoneFieldEnabled(isPhoneCheckboxChecked) {
        // If showPhone is set we know that we are on the send enrollment and not quick quote path.
        if (this.showPhone) {
            return isPhoneCheckboxChecked;
        }
        return this.showCreateNewProfileForm && this.isFieldRequired('phone');
    }
    setRequiredFormFieldAttributes() {
        const dateOfBirthField = this.memberRegistrationFields.find(field => field.keyName === 'dateOfBirth');
        const phoneNumberField = this.memberRegistrationFields.find(field => field.keyName === 'phone');
        if (dateOfBirthField) {
            this.dateOfBirthRequiredError = dateOfBirthField.requiredText;
            this.modalDateOfBirthLabelText = dateOfBirthField.labelText;
        }
        if (phoneNumberField) {
            this.modalPhoneLabelText = phoneNumberField.labelText;
        }
        this.setRequiredCustomFields();
    }
    setRequiredCustomFields() {
        this.customFields = this.memberRegistrationFields
            .filter(field => field.keyName.includes('customField'))
            .filter(field => field.required);
        let colIndex = 0;
        let rowCount = 0;
        for (const customField of this.customFields) {
            if (colIndex < 2) {
                const currentRow = this.customFieldsRows[rowCount];
                currentRow.push(customField);
                if (currentRow.length === 2) {
                    colIndex = 0;
                    rowCount++;
                }
                else {
                    colIndex++;
                }
            }
        }
    }
    initializePlanDocumentControls() {
        if (this.plansIncluded && this.plansIncluded.length === 1) {
            const planDocuments = this.plansIncluded[0].documents;
            // Set updateOn 'change' at form control level or else control will use form group level updateOn
            // Since form group updateOn is set to 'blur', checkboxes won't emit value until blurred or clicked on white space in form
            const planDocumentCheckboxes = planDocuments.map(_document => new UntypedFormControl(false, { updateOn: 'change' }));
            this.planDocumentFormArray = new UntypedFormArray(planDocumentCheckboxes);
            this.sendQuoteFormGroup.addControl('selectedPlanDocuments', this.planDocumentFormArray);
            this.subscriptions.push(this.planDocumentFormArray.valueChanges.subscribe({
                next: checkBoxValues => {
                    this.selectedPlanDocuments = checkBoxValues
                        .map((checkBoxValue, index) => (checkBoxValue ? planDocuments[index] : null))
                        .filter((document) => !!document);
                    this.areAllPlanDocumentsSelected = checkBoxValues.every((checkBoxValue) => checkBoxValue);
                    this.cdr.markForCheck();
                }
            }));
        }
    }
    isPersonalizedVideoCheckboxEnabled() {
        return this.personalizedVideoEnabled && this.personalizedQuoteVideoEnabled && this.personalizedQuoteVideoCheckboxEnabled;
    }
}
SendQuoteModalComponent.ɵfac = function SendQuoteModalComponent_Factory(t) { return new (t || SendQuoteModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.ProfileService)); };
SendQuoteModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SendQuoteModalComponent, selectors: [["ng-component"]], decls: 23, vars: 17, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [3, "formGroup"], [1, "form-group", "modal-body"], [1, "mt-0"], [4, "ngIf"], ["class", "row mt-3 align-items-end", 4, "ngIf"], ["class", "row mb-3", 4, "ngIf"], ["class", "row", 4, "ngIf"], ["class", "row align-items-center", 3, "ngClass", 4, "ngIf"], ["class", "mt-3", 4, "ngIf"], [1, "col-12", "p-0"], [1, "modal-footer", "justify-content-start"], ["type", "button", 1, "btn", "mr-auto", "Spa_Style_SecondaryButton", 3, "click"], ["type", "submit", 1, "btn", "Spa_Style_PrimaryButton", 3, "disabled", "click"], [1, "Spa_Style_H2"], [1, "row", "mt-3", "align-items-end"], [1, "col"], ["id", "firstNameError", "class", "error-container", "role", "alert", 4, "ngIf"], ["for", "firstName", 1, "Spa_Style_Label"], ["aria-hidden", "true", 1, "input-error-asterisk"], ["id", "firstName", "aria-required", "true", "type", "text", "formControlName", "firstName", 1, "form-control"], ["id", "lastNameError", "class", "error-container", "role", "alert", 4, "ngIf"], ["for", "lastName", 1, "Spa_Style_Label"], ["id", "lastName", "aria-required", "true", "type", "text", "formControlName", "lastName", 1, "form-control"], ["id", "firstNameError", "role", "alert", 1, "error-container"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], ["id", "lastNameError", "role", "alert", 1, "error-container"], ["class", "col col-md-6", 4, "ngIf"], [1, "col", "col-md-6"], ["id", "dateOfBirthError", "class", "error-container", "role", "alert", 4, "ngIf"], ["for", "dateOfBirth", 1, "Spa_Style_Label"], ["id", "dateOfBirth", "aria-required", "true", "type", "text", "formControlName", "dateOfBirth", "inputmode", "numeric", "autocomplete", "off", 1, "form-control", 3, "placeholder", "mask", "dropSpecialCharacters"], ["id", "dateOfBirthError", "role", "alert", 1, "error-container"], ["id", "phoneError", "class", "error-container", "role", "alert", 4, "ngIf"], ["for", "phone", 1, "Spa_Style_Label"], ["id", "phone", "aria-required", "true", "type", "text", "inputmode", "numeric", "formControlName", "phone", 1, "form-control", 3, "maxLength", "mask"], ["id", "phoneError", "role", "alert", 1, "error-container"], [4, "ngFor", "ngForOf"], ["class", "col col-md-6", 4, "ngFor", "ngForOf"], ["class", "error-container", "role", "alert", 3, "id", 4, "ngIf"], [1, "Spa_Style_Label", 3, "for"], ["aria-required", "true", "type", "text", 1, "form-control", 3, "id", "formControlName"], ["role", "alert", 1, "error-container", 3, "id"], [1, "row", "mb-3"], [1, "row"], ["role", "alert", 1, "col", "error-container"], [1, "row", "align-items-center", 3, "ngClass"], ["id", "emailAddressError", "class", "error-container col-12", "role", "alert", 4, "ngIf"], ["class", "col-2 mr-1 Spa_Style_Paragraph", 4, "ngIf"], [3, "ngClass"], ["for", "emailAddress", 1, "Spa_Style_Label"], ["id", "emailAddress", "aria-required", "true", "ngbAutofocus", "", "type", "email", "formControlName", "emailAddress", 1, "form-control"], ["id", "emailAddressError", "role", "alert", 1, "error-container", "col-12"], [1, "col-2", "mr-1", "Spa_Style_Paragraph"], ["for", "emailAddressCheckbox"], ["id", "emailAddressCheckbox", "type", "checkbox", "formControlName", "emailAddressCheckbox", 3, "click"], ["id", "phoneError", "class", "error-container col-12", "role", "alert", 4, "ngIf"], ["id", "phone", "aria-required", "true", "ngbAutofocus", "", "type", "text", "formControlName", "phone", 1, "form-control", 3, "maxLength", "mask"], ["id", "phoneError", "role", "alert", 1, "error-container", "col-12"], ["for", "phoneCheckbox"], ["id", "phoneCheckbox", "type", "checkbox", "formControlName", "phoneCheckbox", 3, "click"], [1, "mt-3"], ["for", "additionalMessage", 1, "Spa_Style_Label"], [1, "Spa_Style_H5"], ["id", "additionalMessage", "type", "text", "rows", "5", "maxlength", "500", "formControlName", "additionalMessage", 1, "form-control", 3, "value"], [1, "Spa_Style_Label"], [1, "agent-content", "text-left"], [1, "agent-name-container"], [3, "broker", "isViewOnly", "agentProfilePictureUrl"], [1, "ml-2", "agent-name", "Spa_Style_Paragraph"], [1, "no-translate-block"], [1, "Spa_Style_Label", "mb-0"], [1, "mb-1", "Spa_Style_Paragraph"], ["for", "personalizedVideoCheckbox", 1, "mb-0", "can-click"], ["id", "personalizedVideoCheckbox", "type", "checkbox", "formControlName", "personalizedVideoCheckbox", 1, "mr-1", "mt-2", "can-click"], [1, "d-flex", "justify-content-between"], ["id", "planIncluded", 1, "Spa_Style_Label"], ["class", "Spa_Style_Link btn py-0 px-1", 3, "disabled", "click", 4, "ngIf"], ["class", "mb-1", 4, "ngFor", "ngForOf"], [1, "Spa_Style_Link", "btn", "py-0", "px-1", 3, "disabled", "click"], [1, "mb-1"], ["class", "error-container permission-error Spa_Style_Smaller_Font mt-2", "role", "alert", 4, "ngIf"], ["aria-labelledby", "planIncluded", 1, "Spa_Style_Smaller_Font", "no-translate-block"], ["formArrayName", "selectedPlanDocuments", 4, "ngIf"], ["role", "alert", 1, "error-container", "permission-error", "Spa_Style_Smaller_Font", "mt-2"], ["formArrayName", "selectedPlanDocuments"], ["class", "Spa_Style_Paragraph", 4, "ngFor", "ngForOf"], [1, "Spa_Style_Paragraph"], [1, "mt-2", "mb-0", "can-click", 3, "for"], ["type", "checkbox", 1, "mr-1", "mt-2", "can-click", 3, "id", "formControlName"], [1, "Spa_Style_Smaller_Font"], ["class", "mb-1 Spa_Style_Paragraph", 4, "ngFor", "ngForOf"], ["type", "radio", 1, "mr-1", "mt-2", "can-click", 3, "id", "name", "checked", "change"]], template: function SendQuoteModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function SendQuoteModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.closeSendQuoteModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "form", 1)(2, "div", 2)(3, "div", 3);
        i0.ɵɵtemplate(4, SendQuoteModalComponent_div_4_Template, 3, 1, "div", 4);
        i0.ɵɵtemplate(5, SendQuoteModalComponent_div_5_Template, 15, 6, "div", 5);
        i0.ɵɵtemplate(6, SendQuoteModalComponent_ng_container_6_Template, 5, 3, "ng-container", 4);
        i0.ɵɵtemplate(7, SendQuoteModalComponent_div_7_Template, 3, 1, "div", 6);
        i0.ɵɵtemplate(8, SendQuoteModalComponent_div_8_Template, 5, 1, "div", 7);
        i0.ɵɵtemplate(9, SendQuoteModalComponent_div_9_Template, 9, 11, "div", 8);
        i0.ɵɵtemplate(10, SendQuoteModalComponent_div_10_Template, 9, 14, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(11, SendQuoteModalComponent_div_11_Template, 9, 3, "div", 9);
        i0.ɵɵelementStart(12, "div", 10);
        i0.ɵɵelement(13, "vnext-selectrx-section");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(14, SendQuoteModalComponent_div_14_Template, 11, 7, "div", 9);
        i0.ɵɵtemplate(15, SendQuoteModalComponent_div_15_Template, 8, 2, "div", 9);
        i0.ɵɵtemplate(16, SendQuoteModalComponent_div_16_Template, 7, 3, "div", 9);
        i0.ɵɵtemplate(17, SendQuoteModalComponent_div_17_Template, 8, 3, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 11)(19, "button", 12);
        i0.ɵɵlistener("click", function SendQuoteModalComponent_Template_button_click_19_listener() { return ctx.closeSendQuoteModal(); });
        i0.ɵɵtext(20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "button", 13);
        i0.ɵɵlistener("click", function SendQuoteModalComponent_Template_button_click_21_listener() { return ctx.onSendQuote(); });
        i0.ɵɵtext(22);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.modalTitleText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.sendQuoteFormGroup);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.showProfileNames);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showCreateNewProfileForm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showCreateNewProfileForm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.modalPromptText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasCheckboxRequiredError);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showEmail);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showPhone);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.modalIsPresonalizedMessageEnabled);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.sendQuoteAgentOfRecordEnabled && (ctx.agentOfRecord == null ? null : ctx.agentOfRecord.data));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showPersonalizedVideoCheckbox);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.canShowPlanDocuments);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showPharmacySection());
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.modalCancelText, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.plansNotLicensedToSell);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.modalSendEmailText, " ");
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.CheckboxControlValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.MaxLengthValidator, i4.FormGroupDirective, i4.FormControlName, i4.FormArrayName, ModalHeaderComponent, IconAriaAttributesDirective, i8.MaskDirective, SelectRXSectionComponent, AgentProfilePictureComponent], styles: [".modal-body[_ngcontent-%COMP%]{max-height:70vh;overflow-y:auto;margin-bottom:0}.form-control[_ngcontent-%COMP%]:disabled{color:var(--static-Spa_Style_Accent1)}@media (max-width: 992px){.modal-body[_ngcontent-%COMP%]{max-height:none}}.btn.Spa_Style_Link[_ngcontent-%COMP%]{font-size:14px!important;margin-top:-10px}.agent-name[_ngcontent-%COMP%]{word-wrap:break-word;min-width:148px;margin:auto}.agent-name-container[_ngcontent-%COMP%]{padding-bottom:20px;display:flex;align-items:start}.permission-error[_ngcontent-%COMP%]{display:flex;align-items:baseline}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SendQuoteModalComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"modalTitleText\" (modalTitleCancelAction)=\"closeSendQuoteModal()\"></vnext-widget-modal-header>\r\n\r\n<form [formGroup]=\"sendQuoteFormGroup\">\r\n  <div class=\"form-group modal-body\">\r\n    <div class=\"mt-0\">\r\n      <div *ngIf=\"showProfileNames\">\r\n        <h2 class=\"Spa_Style_H2\">\r\n          {{ quoteSendQuoteToHeader }}\r\n        </h2>\r\n      </div>\r\n      <div *ngIf=\"showCreateNewProfileForm\" class=\"row mt-3 align-items-end\">\r\n        <div class=\"col\">\r\n          <div id=\"firstNameError\" *ngIf=\"fieldHasError('firstName')\" class=\"error-container\" role=\"alert\">\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span *ngIf=\"hasRequiredErrors('firstName')\">{{ firstNameRequiredError }}</span>\r\n            <span *ngIf=\"getFieldErrors('firstName').minlength\">{{ firstNameInvalidError }}</span>\r\n          </div>\r\n          <label class=\"Spa_Style_Label\" for=\"firstName\">\r\n            <span class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>{{ modalFirstNameLabelText }}</label\r\n          >\r\n          <input\r\n            id=\"firstName\"\r\n            aria-required=\"true\"\r\n            type=\"text\"\r\n            class=\"form-control\"\r\n            formControlName=\"firstName\"\r\n            [attr.aria-describedby]=\"fieldHasError('firstName') ? 'firstNameError' : null\"\r\n          />\r\n        </div>\r\n        <div class=\"col\">\r\n          <div id=\"lastNameError\" *ngIf=\"fieldHasError('lastName')\" class=\"error-container\" role=\"alert\">\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span *ngIf=\"hasRequiredErrors('lastName')\">{{ lastNameRequiredError }}</span>\r\n            <span *ngIf=\"getFieldErrors('lastName').minlength\">{{ lastNameInvalidError }}</span>\r\n          </div>\r\n          <label class=\"Spa_Style_Label\" for=\"lastName\"\r\n            ><span class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>{{ modalLastNameLabelText }}</label\r\n          >\r\n          <input\r\n            id=\"lastName\"\r\n            aria-required=\"true\"\r\n            type=\"text\"\r\n            class=\"form-control\"\r\n            formControlName=\"lastName\"\r\n            [attr.aria-describedby]=\"fieldHasError('lastName') ? 'lastNameError' : null\"\r\n          />\r\n        </div>\r\n      </div>\r\n      <ng-container *ngIf=\"showCreateNewProfileForm\">\r\n        <div class=\"row mt-3 align-items-end\">\r\n          <div class=\"col col-md-6\" *ngIf=\"isFieldRequired('dateOfBirth')\">\r\n            <div id=\"dateOfBirthError\" *ngIf=\"fieldHasError('dateOfBirth')\" class=\"error-container\" role=\"alert\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"hasRequiredErrors('dateOfBirth')\">{{ dateOfBirthRequiredError }}</span>\r\n            </div>\r\n            <label class=\"Spa_Style_Label\" for=\"dateOfBirth\">\r\n              <span class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>{{ modalDateOfBirthLabelText }}</label\r\n            >\r\n            <input\r\n              id=\"dateOfBirth\"\r\n              aria-required=\"true\"\r\n              type=\"text\"\r\n              class=\"form-control\"\r\n              formControlName=\"dateOfBirth\"\r\n              inputmode=\"numeric\"\r\n              autocomplete=\"off\"\r\n              placeholder=\"{{ getDateFormat() }}\"\r\n              mask=\"{{ getDateMaskFormat() }}\"\r\n              [dropSpecialCharacters]=\"false\"\r\n              [attr.aria-describedby]=\"fieldHasError('dateOfBirth') ? 'firstNameError' : null\"\r\n            />\r\n          </div>\r\n          <div class=\"col col-md-6\" *ngIf=\"isFieldRequired('phone')\">\r\n            <div id=\"phoneError\" *ngIf=\"fieldHasError('phone')\" class=\"error-container\" role=\"alert\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"getFieldErrors('phone').required\">{{ phoneRequiredError }}</span>\r\n              <span *ngIf=\"getFieldErrors('phone').pattern\">{{ phoneInvalidError }}</span>\r\n            </div>\r\n            <label class=\"Spa_Style_Label\" for=\"phone\">\r\n              <span class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>{{ modalPhoneLabelText }}</label\r\n            >\r\n            <input\r\n              id=\"phone\"\r\n              aria-required=\"true\"\r\n              type=\"text\"\r\n              inputmode=\"numeric\"\r\n              class=\"form-control\"\r\n              formControlName=\"phone\"\r\n              [attr.aria-describedby]=\"fieldHasError('phone') ? 'phoneError' : null\"\r\n              [maxLength]=\"phoneMask.length\"\r\n              [mask]=\"phoneMask\"\r\n            />\r\n          </div>\r\n        </div>\r\n        <ng-container *ngIf=\"customFieldsRows?.length\">\r\n          <ng-container *ngFor=\"let customFieldRow of customFieldsRows\">\r\n            <div *ngIf=\"customFieldRow?.length\" class=\"row mt-3 align-items-end\">\r\n              <div class=\"col col-md-6\" *ngFor=\"let field of customFieldRow\">\r\n                <div *ngIf=\"isFieldRequired(field.keyName)\">\r\n                  <div id=\"{{ field.keyName + 'Error' }}\" *ngIf=\"fieldHasError(field.keyName)\" class=\"error-container\" role=\"alert\">\r\n                    <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n                    <span *ngIf=\"hasRequiredErrors(field.keyName)\">{{ field.requiredText }}</span>\r\n                  </div>\r\n                  <label class=\"Spa_Style_Label\" [for]=\"field.keyName\">\r\n                    <span class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>{{ field.labelText }}</label\r\n                  >\r\n                  <input\r\n                    aria-required=\"true\"\r\n                    type=\"text\"\r\n                    class=\"form-control\"\r\n                    [id]=\"field.keyName\"\r\n                    [formControlName]=\"field.keyName\"\r\n                    [attr.aria-describedby]=\"fieldHasError(field.keyName) ? field.keyName + 'Error' : null\"\r\n                  />\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </ng-container>\r\n        </ng-container>\r\n      </ng-container>\r\n      <div class=\"row mb-3\" *ngIf=\"modalPromptText\">\r\n        <div class=\"col\">{{ modalPromptText }}</div>\r\n      </div>\r\n      <div class=\"row\" *ngIf=\"hasCheckboxRequiredError\">\r\n        <div class=\"col error-container\" role=\"alert\">\r\n          <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n          <span>{{ checkBoxRequiredError }}</span>\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"showEmail\" class=\"row align-items-center\" [ngClass]=\"{ 'no-gutters': !showCreateNewProfileForm }\">\r\n        <div id=\"emailAddressError\" *ngIf=\"fieldHasError('emailAddress')\" class=\"error-container col-12\" role=\"alert\">\r\n          <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n          <span *ngIf=\"getFieldErrors('emailAddress').required\">{{ emailRequiredError }}</span>\r\n          <span *ngIf=\"getFieldErrors('emailAddress').email\">{{ emailInvalidError }}</span>\r\n        </div>\r\n        <div *ngIf=\"showCheckBoxes\" class=\"col-2 mr-1 Spa_Style_Paragraph\">\r\n          <label for=\"emailAddressCheckbox\">\r\n            <input id=\"emailAddressCheckbox\" type=\"checkbox\" formControlName=\"emailAddressCheckbox\" (click)=\"toggleEmailCheckBox()\" />\r\n            {{ modalEmailCheckboxLabelText }}\r\n          </label>\r\n        </div>\r\n        <div [ngClass]=\"{ 'col-sm-auto col-md-6': showCreateNewProfileForm, 'col': !showCreateNewProfileForm }\">\r\n          <label class=\"Spa_Style_Label\" for=\"emailAddress\">\r\n            <span class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>{{ modalEmailLabelText }}</label\r\n          >\r\n          <input\r\n            id=\"emailAddress\"\r\n            aria-required=\"true\"\r\n            ngbAutofocus\r\n            type=\"email\"\r\n            class=\"form-control\"\r\n            formControlName=\"emailAddress\"\r\n            [attr.aria-describedby]=\"fieldHasError('emailAddress') ? 'emailAddressError' : null\"\r\n          />\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"showPhone\" class=\"row align-items-center\" [ngClass]=\"{ 'mt-3': showEmail, 'no-gutters': !showCreateNewProfileForm }\">\r\n        <div id=\"phoneError\" *ngIf=\"fieldHasError('phone')\" class=\"error-container col-12\" role=\"alert\">\r\n          <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n          <span *ngIf=\"getFieldErrors('phone').required\">{{ phoneRequiredError }}</span>\r\n          <span *ngIf=\"getFieldErrors('phone').pattern\">{{ phoneInvalidError }}</span>\r\n        </div>\r\n        <div *ngIf=\"showCheckBoxes\" class=\"col-2 mr-1 Spa_Style_Paragraph\">\r\n          <label for=\"phoneCheckbox\">\r\n            <input id=\"phoneCheckbox\" type=\"checkbox\" formControlName=\"phoneCheckbox\" (click)=\"togglePhoneCheckBox()\" />\r\n            {{ modalPhoneCheckboxLabelText }}\r\n          </label>\r\n        </div>\r\n        <div [ngClass]=\"{ 'col-sm-auto col-md-6': showCreateNewProfileForm, 'col': !showCreateNewProfileForm }\">\r\n          <label class=\"Spa_Style_Label\" for=\"phone\">\r\n            <span class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>{{ modalPhoneLabelText }}</label\r\n          >\r\n          <input\r\n            id=\"phone\"\r\n            aria-required=\"true\"\r\n            ngbAutofocus\r\n            type=\"text\"\r\n            class=\"form-control\"\r\n            formControlName=\"phone\"\r\n            [attr.aria-describedby]=\"fieldHasError('phone') ? 'phoneError' : null\"\r\n            [maxLength]=\"phoneMask.length\"\r\n            [mask]=\"phoneMask\"\r\n          />\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div *ngIf=\"modalIsPresonalizedMessageEnabled\" class=\"mt-3\">\r\n      <label class=\"Spa_Style_Label\" for=\"additionalMessage\">\r\n        <span>{{ modalAdditionalTitle }}</span>\r\n      </label>\r\n      <div>\r\n        <h5 class=\"Spa_Style_H5\">\r\n          <span>{{ modalAdditionalSubText }}</span>\r\n        </h5>\r\n      </div>\r\n      <textarea\r\n        id=\"additionalMessage\"\r\n        type=\"text\"\r\n        rows=\"5\"\r\n        maxlength=\"500\"\r\n        formControlName=\"additionalMessage\"\r\n        class=\"form-control\"\r\n        [value]=\"modalAdditionalDefaultMessage\"\r\n      ></textarea>\r\n    </div>\r\n    \r\n    <div class=\"col-12 p-0\">\r\n      <vnext-selectrx-section></vnext-selectrx-section>\r\n    </div>\r\n    \r\n    <div *ngIf=\"sendQuoteAgentOfRecordEnabled && agentOfRecord?.data\" class=\"mt-3\">\r\n      <label class=\"Spa_Style_Label\">\r\n        <span>{{ sendQuoteSendingAgentLabelText }}</span>\r\n      </label>\r\n      <div class=\"agent-content text-left\">\r\n        <div class=\"agent-name-container\">\r\n          <vnext-agent-profile-picture\r\n            [broker]=\"agentOfRecord?.data\"\r\n            [isViewOnly]=\"true\"\r\n            [agentProfilePictureUrl]=\"agentOfRecord?.data?.agentPictureURL\"\r\n          ></vnext-agent-profile-picture>\r\n          <div class=\"ml-2 agent-name Spa_Style_Paragraph\">\r\n            <span class=\"no-translate-block\">{{ agentOfRecord?.data?.firstName ?? '' }} {{ agentOfRecord?.data?.lastName ?? '' }}</span> ({{ agentOfRecordText }})\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"mt-3\" *ngIf=\"showPersonalizedVideoCheckbox\">\r\n      <label class=\"Spa_Style_Label mb-0\">\r\n        <span>{{ personalizedVideoCheckboxHeaderText }}</span>\r\n      </label>\r\n      <div class=\"mb-1 Spa_Style_Paragraph\">\r\n        <label for=\"personalizedVideoCheckbox\" class=\"mb-0 can-click\">\r\n          <input id=\"personalizedVideoCheckbox\" type=\"checkbox\" class=\"mr-1 mt-2 can-click\" formControlName=\"personalizedVideoCheckbox\" />\r\n          {{ personalizedVideoCheckboxLabelText }}\r\n        </label>\r\n      </div>\r\n    </div>\r\n    <div class=\"mt-3\" *ngIf=\"canShowPlanDocuments\">\r\n      <div class=\"d-flex justify-content-between\">\r\n        <label class=\"Spa_Style_Label\" id=\"planIncluded\">\r\n          <span>{{ modalPlansIncludedLabel }}</span>\r\n        </label>\r\n        <button\r\n          class=\"Spa_Style_Link btn py-0 px-1\"\r\n          *ngIf=\"plansIncluded.length === 1 && plansIncluded[0].documents.length\"\r\n          (click)=\"toggleSelectAll()\"\r\n          [disabled]=\"plansNotLicensedToSell\"\r\n        >\r\n          {{ selectAllButtonText }}\r\n        </button>\r\n      </div>\r\n      <div class=\"mb-1\" *ngFor=\"let plan of plansIncluded\">\r\n        <div\r\n          *ngIf=\"planPermissions?.[plan.id] && !planPermissions?.[plan.id]?.hasPermission\"\r\n          class=\"error-container permission-error Spa_Style_Smaller_Font mt-2\"\r\n          role=\"alert\"\r\n        >\r\n          <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n          <span>{{ planCardNotLicensedText }} <span class=\"no-translate-block\">{{ plan.planName }}</span></span>\r\n        </div>\r\n        <span class=\"Spa_Style_Smaller_Font no-translate-block\" aria-labelledby=\"planIncluded\">{{ plan.planName }}</span>\r\n        <ng-container *ngIf=\"plansIncluded.length === 1\" formArrayName=\"selectedPlanDocuments\">\r\n          <div class=\"Spa_Style_Paragraph\" *ngFor=\"let document of plan.documents; index as i\">\r\n            <label class=\"mt-2 mb-0 can-click\" [for]=\"'documentId' + i\">\r\n              <input\r\n                type=\"checkbox\"\r\n                class=\"mr-1 mt-2 can-click\"\r\n                [id]=\"'documentId' + i\"\r\n                [formControlName]=\"i\"\r\n                [attr.disabled]=\"!planPermissions?.[plan.id]?.hasPermission ? true : null\"\r\n              />\r\n              {{ document.linkName }}\r\n            </label>\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n    </div>\r\n    <div class=\"mt-3\" *ngIf=\"showPharmacySection()\">\r\n      <div class=\"d-flex justify-content-between\">\r\n        <label class=\"Spa_Style_Label\">\r\n          <span>{{ modalPharmacyHeaderText }}</span>\r\n        </label>\r\n      </div>\r\n      <span class=\"Spa_Style_Smaller_Font\">{{ modalPharmacySubText }}</span>\r\n      <div class=\"mb-1 Spa_Style_Paragraph\" *ngFor=\"let pharmacy of selectedPharmacies; index as i\">\r\n        <label class=\"mt-2 mb-0 can-click\" [for]=\"pharmacy.pharmacyId\">\r\n          <input\r\n            type=\"radio\"\r\n            class=\"mr-1 mt-2 can-click\"\r\n            [id]=\"pharmacy.pharmacyId\"\r\n            [name]=\"'pharmacies'\"\r\n            [checked]=\"primaryPharmacy.pharmacyId === pharmacy.pharmacyId\"\r\n            (change)=\"primaryPharmacy = pharmacy\"\r\n          />\r\n          <span class=\"no-translate-block\">{{ pharmacy.name }}</span>\r\n        </label>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"modal-footer justify-content-start\">\r\n    <button type=\"button\" class=\"btn mr-auto Spa_Style_SecondaryButton\" (click)=\"closeSendQuoteModal()\">\r\n      {{ modalCancelText }}\r\n    </button>\r\n    <button type=\"submit\" (click)=\"onSendQuote()\" class=\"btn Spa_Style_PrimaryButton\" [disabled]=\"plansNotLicensedToSell\">\r\n      {{ modalSendEmailText }}\r\n    </button>\r\n  </div>\r\n</form>\r\n", styles: [".modal-body{max-height:70vh;overflow-y:auto;margin-bottom:0}.form-control:disabled{color:var(--static-Spa_Style_Accent1)}@media (max-width: 992px){.modal-body{max-height:none}}.btn.Spa_Style_Link{font-size:14px!important;margin-top:-10px}.agent-name{word-wrap:break-word;min-width:148px;margin:auto}.agent-name-container{padding-bottom:20px;display:flex;align-items:start}.permission-error{display:flex;align-items:baseline}\n"] }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i2.Store }, { type: i0.ChangeDetectorRef }, { type: i1.ProfileService }]; }, null); })();

class PlanListContextService {
    constructor() {
        this._tabs$ = new BehaviorSubject([]);
        this.tabs$ = this._tabs$.asObservable().pipe(distinctUntilChanged(_isEqual));
        // Active tab exclusion information
        this.hasExclusion = false;
        this.excludedPlanTypes = [];
        this._openZipCodeModal$ = new Subject();
        this._openMobileFiltersModal$ = new Subject();
        this.openZipCodeModal$ = this._openZipCodeModal$.asObservable();
        this.openMobileFiltersModal$ = this._openMobileFiltersModal$.asObservable();
    }
    // getter and setter for medSupFormIsOpen flag
    setMedSupFormIsOpen(medSupFormOpen$) {
        this.medSupFormIsOpen$ = medSupFormOpen$;
    }
    getMedSupFormIsOpen$() {
        return this.medSupFormIsOpen$;
    }
    // getter and setter for dentalVisionFormIsOpen flag
    setDentalVisionFormIsOpen(dentalVisionFormOpen$) {
        this.dentalVisionFormIsOpen$ = dentalVisionFormOpen$;
    }
    getDentalVisionFormIsOpen$() {
        return this.dentalVisionFormIsOpen$;
    }
    displayZipCodeModal() {
        this._openZipCodeModal$.next(null);
    }
    displayMobileFiltersModal() {
        this._openMobileFiltersModal$.next(null);
    }
    // getter and setter for MedSupExclusionTab active tab type property
    setActiveTabHasPlanTypeExclusion(hasExclusion) {
        this.hasExclusion = hasExclusion;
    }
    getHasMedSupExclusion() {
        return this.hasExclusion;
    }
    // getter and setter for excluded plan types.
    setExcludedPlanTypes(planTypes) {
        this.excludedPlanTypes = planTypes;
    }
    getExcludedPlanTypes() {
        return this.excludedPlanTypes;
    }
    // getter and setter for the filter tabs
    setTabs(tabs) {
        this._tabs$.next(tabs);
    }
    // Kept for backward compatibility
    get tabs() {
        return this._tabs$.value;
    }
    getTabs$() {
        return this.tabs$;
    }
}
PlanListContextService.ɵfac = function PlanListContextService_Factory(t) { return new (t || PlanListContextService)(); };
PlanListContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlanListContextService, factory: PlanListContextService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanListContextService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class HelpfulToolsResourceFacade {
    constructor(configResourceService, drugFrequencyFacade) {
        this.configResourceService = configResourceService;
        this.drugFrequencyFacade = drugFrequencyFacade;
    }
    // Zip code control.
    getZipCodeErrorText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_ZipCodeInput_ZipCodeError', widgetName, 'Zip code is invalid');
    }
    getCountyErrorText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_ZipCodeInput_CountyError', widgetName, 'Please select your county');
    }
    getSelectCountyText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_ZipCodeInput_SelectCounty', widgetName, 'Select county');
    }
    getZipCodeText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_ZipCodeInput_ZipCodeLabel', widgetName, 'Zip code');
    }
    getEditCountyText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_ZipCodeInput_EditCounty', widgetName, 'Edit');
    }
    getSelectedCountyEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_ZipCodeInput_SelectedCountyEnabled', widgetName, true);
    }
    getShowProvider(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_HelpfulTools_Show_Provider', widgetName, true);
    }
    getProviderSearchEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Providers_Enabled', widgetName, false);
    }
    getTabInformation(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanList_Tabs_Data', widgetName, {
            name: 'Spa_PlanList_Tabs_Data',
            value: [
                {
                    title: 'Medicare Advantage',
                    defaultActive: false,
                    secondaryDefaultActive: false,
                    errorHeading: 'No plan results',
                    errorBody: `We are sorry, but we don't currently offer coverage in your area.\n Call <a href='tel:5555555555' class='Spa_Style_Larger_Font Spa_Style_Primary_Color'>(555) 555-5555</a> to contact your broker.`,
                    tabTypes: ['MA'],
                    planTabEducationalText: '[[Spa_PlanList_Tab_Educational_Text_MA]]',
                    sortList: '[[Spa_PlanList_Sort_Options_MA]]',
                    benefits: '[[Spa_PlanCard_Benefit_MA]]',
                    benefitPreferences: '[[Spa_PlanCard_Preferences_MA]]',
                    linkText: 'Shop medicare advantage plans'
                },
                {
                    title: 'Medicare Advantage Prescription Drug',
                    defaultActive: false,
                    secondaryDefaultActive: false,
                    errorHeading: 'No plan results',
                    errorBody: `We are sorry, but we don't currently offer coverage in your area.\n Call <a href='tel:5555555555' class='Spa_Style_Larger_Font Spa_Style_Primary_Color'>(555) 555-5555</a> to contact your broker.`,
                    tabTypes: ['MAPD'],
                    planTabEducationalText: '[[Spa_PlanList_Tab_Educational_Text_MAPD]]',
                    sortList: '[[Spa_PlanList_Sort_Options_MAPD]]',
                    benefits: '[[Spa_PlanCard_Benefit_MAPD]]',
                    benefitPreferences: '[[Spa_PlanCard_Preferences_MAPD]]',
                    linkText: 'Shop medicare advantage prescription plans'
                },
                {
                    title: 'Prescription Drug',
                    defaultActive: false,
                    secondaryDefaultActive: true,
                    errorHeading: 'No plan results',
                    errorBody: `We are sorry, but we don't currently offer coverage in your area.\n Call <a href='tel:5555555555' class='Spa_Style_Larger_Font Spa_Style_Primary_Color'>(555) 555-5555</a> to contact your broker.`,
                    tabTypes: ['PDP'],
                    planTabEducationalText: '[[Spa_PlanList_Tab_Educational_Text_PDP]]',
                    sortList: '[[Spa_PlanList_Sort_Options_PDP]]',
                    benefits: '[[Spa_PlanCard_Benefit_PDP]]',
                    benefitPreferences: '[[Spa_PlanCard_Preferences_PDP]]',
                    linkText: 'Shop prescription drug plans'
                },
                {
                    title: 'Medicare Supplemental',
                    defaultActive: true,
                    secondaryDefaultActive: false,
                    errorHeading: 'No plan results',
                    errorBody: `We are sorry, but we don't currently offer coverage in your area.\n Call <a href='tel:5555555555' class='Spa_Style_Larger_Font Spa_Style_Primary_Color'>(555) 555-5555</a> to contact your broker.`,
                    tabTypes: ['MEDIGAP'],
                    planTabEducationalText: '[[Spa_PlanList_Tab_Educational_Text_MEDIGAP]]',
                    sortList: '[[Spa_PlanList_Sort_Options_MEDIGAP]]',
                    linkText: 'Shop medicare supplement plans'
                }
            ]
        });
    }
    getFilteredFrequencyOptions(frequencyOptions) {
        return this.drugFrequencyFacade.getFilteredFrequencyOptions(frequencyOptions);
    }
    getShowDrugAlternativesNudgeEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_HelpfulTools_ShowDrugAlternatives_Nudge_Enabled', widgetName, false);
    }
}
HelpfulToolsResourceFacade.ɵfac = function HelpfulToolsResourceFacade_Factory(t) { return new (t || HelpfulToolsResourceFacade)(i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.DrugFrequencyFacade)); };
HelpfulToolsResourceFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HelpfulToolsResourceFacade, factory: HelpfulToolsResourceFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpfulToolsResourceFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: i1.DrugFrequencyFacade }]; }, null); })();

class HelpfulToolsContextService {
    constructor(planListContext, helpfulToolsResources) {
        this.planListContext = planListContext;
        this.helpfulToolsResources = helpfulToolsResources;
        this.isHelpfulToolsView = false;
        this.defaultExcludedPlanTypes = [
            PlanTypeAbbreviation.MEDIGAP,
            PlanTypeAbbreviation.DENTAL,
            PlanTypeAbbreviation.VISION,
            PlanTypeAbbreviation.HC
        ];
        this._showFormularyAndFootnotes$ = new BehaviorSubject(false);
        this._selectedDosage$ = new BehaviorSubject('');
    }
    getDefaultExcludedPlanTypes() {
        return this.defaultExcludedPlanTypes;
    }
    setTabs(tabs) {
        this.planListContext.setTabs(tabs);
    }
    setHasExclusion(hasExclusion = false) {
        this.planListContext.setActiveTabHasPlanTypeExclusion(hasExclusion);
    }
    setExcludedPlanTypes(planTypes) {
        this.planListContext.setExcludedPlanTypes(planTypes);
    }
    setSelectedDrugDosageId(dosageId) {
        this._selectedDosage$.next(dosageId);
    }
    getSelectedDrugDosageId$() {
        return this._selectedDosage$.asObservable();
    }
    showFormularyAndFootnotes() {
        this._showFormularyAndFootnotes$.next(true);
    }
    hideFormularyAndFootnotes() {
        this._showFormularyAndFootnotes$.next(false);
    }
    getShowFormularyAndFootnotes$() {
        return this._showFormularyAndFootnotes$.asObservable();
    }
    // Tab data, reusing current value of Spa_PlanList_Tabs_Data
    getTabInformation(widgetName) {
        const providerLinkEnabled = this.helpfulToolsResources.getShowProvider(widgetName);
        const tabs = this.helpfulToolsResources.getTabInformation(widgetName);
        const tabsNoMedigap = tabs.filter(tab => !this.defaultExcludedPlanTypes.some(excludedPlanType => tab.tabTypes.includes(excludedPlanType)));
        // show MA if provider link enabled.
        if (providerLinkEnabled) {
            return tabsNoMedigap;
        }
        // else remove medigap and medicare advantage tabs.
        return tabsNoMedigap.filter(tab => !tab.tabTypes.includes(PlanTypeAbbreviation.MA));
    }
}
HelpfulToolsContextService.ɵfac = function HelpfulToolsContextService_Factory(t) { return new (t || HelpfulToolsContextService)(i0.ɵɵinject(PlanListContextService), i0.ɵɵinject(HelpfulToolsResourceFacade)); };
HelpfulToolsContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HelpfulToolsContextService, factory: HelpfulToolsContextService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpfulToolsContextService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: PlanListContextService }, { type: HelpfulToolsResourceFacade }]; }, null); })();

class HelpfulToolsService {
    constructor(store, plansService, configResourceService, navigationService) {
        this.store = store;
        this.plansService = plansService;
        this.configResourceService = configResourceService;
        this.navigationService = navigationService;
    }
    getZipCodeSelected() {
        return this.store.selectSnapshot(HelpfulToolsState.selectedZipCode);
    }
    getFipsCodeSelected() {
        return this.store.selectSnapshot(HelpfulToolsState.selectedFipsCode);
    }
    getPlanSelected() {
        return this.store.selectSnapshot(HelpfulToolsState.selectedPlan);
    }
    getZipCode$() {
        return this.store.select(HelpfulToolsState.selectedZipCode);
    }
    getFipsCode$() {
        return this.store.select(HelpfulToolsState.selectedFipsCode);
    }
    getPlan() {
        return this.store.selectSnapshot(HelpfulToolsState.selectedPlan);
    }
    getPlan$() {
        return this.store.select(HelpfulToolsState.selectedPlan);
    }
    getCurrentTab$() {
        return this.store.select(HelpfulToolsState.selectedTab);
    }
    setCurrentTab(tab) {
        return this.store.dispatch(new SetCurrentTab(tab));
    }
    setSelectedHelpfulToolsPlan$(plan) {
        return this.store.dispatch(new SetPlan(plan));
    }
    selectZipCode(zipCode) {
        const isDirty = this.getZipCodeSelected() !== zipCode;
        if (isDirty) {
            this.store.dispatch(new SetPlansDirty(true));
        }
        this.store.dispatch(new SetZipCode(zipCode));
    }
    selectFipsCode(fipsCode) {
        this.store.dispatch(new SetFipsCode(fipsCode));
        this.store.dispatch(new SetPlansDirty(true));
    }
    selectLocation(zipCode, fipsCode) {
        const isZipUpdated = this.getZipCodeSelected() !== zipCode;
        const isFipsUpdated = this.getFipsCodeSelected() !== fipsCode;
        if (isZipUpdated || isFipsUpdated) {
            this.store.dispatch(new SetPlansDirty(true));
            this.store.dispatch(new SetPlansFetched(true));
        }
        this.store.dispatch(new SetLocation(zipCode, fipsCode));
    }
    rehydrateHelpfulToolsZipAndFips() {
        const updateZipAndFips = !this.isZipAndFipsSelected();
        if (updateZipAndFips) {
            const hasZipAndFips = this.demographicsZip && this.demographicsFips;
            if (hasZipAndFips) {
                this.selectLocation(this.demographicsZip, this.demographicsFips);
            }
        }
    }
    resetPlan() {
        this.store.dispatch(new SetPlan(null));
    }
    async getHelpfulToolsCounties(zipCode) {
        await this.store.dispatch(new FetchCounties(zipCode)).toPromise();
        return this.store.selectSnapshot(HelpfulToolsState.counties);
    }
    async getPlanDetails(drugs) {
        return await this.plansService
            .fetchAndUpdatePlanDetails(this.store.selectSnapshot(HelpfulToolsState.selectedPlan), {
            zip: this.store.selectSnapshot(HelpfulToolsState.selectedZipCode),
            fips: this.store.selectSnapshot(HelpfulToolsState.selectedFipsCode)
        }, {}, drugs, null, // TODO: add helpful tools pharmacy if helpful tools decides to allow pharmacy selection,
        // i.e. support annual cost calcuation based on pharmacy
        undefined)
            .then(planWithDetails => {
            this.store.dispatch(new SetPlan(planWithDetails));
            return planWithDetails;
        });
    }
    getSecondaryButtonTextColor() {
        const secondaryButtonTextColor = this.configResourceService.getProcessedResourceValue('Spa_Style_SecondaryButton_Text', null, AppThemeConfig.getColorValueByKey(ColorResourceKeys.SECONDARY_BUTTON_TEXT));
        return secondaryButtonTextColor.startsWith('#') ? secondaryButtonTextColor : `#${secondaryButtonTextColor}`;
    }
    navigateToDirectory(plan, link, tabName) {
        if (link?.href) {
            this.navigationService.navigate({ type: LinkType.EXTERNAL, target: TargetType.BLANK, ...link });
        }
        else {
            this.navigateToHelpfulToolsTab(plan, link?.tag, tabName);
        }
    }
    navigateToHelpfulToolsTab(plan, pageTag, tabName) {
        if (plan && pageTag && tabName) {
            this.setSelectedHelpfulToolsPlan$(plan);
            this.setCurrentTab(tabName);
            // We need to use query params here, as we can't be 100% sure the above will be saved and transfered to the new tab every time,
            // Due to an optimization in how we save data in batches instead of immediately on every call.
            this.navigationService.navigateByPageTagToNewTab(pageTag, {
                queryParams: { tab: tabName, detailedPlanId: plan.id }
            });
        }
    }
    // #region Private helper/accessor properties.
    get demographicsZip() {
        return this.store.selectSnapshot(DemographicState.selectedZipCode);
    }
    get demographicsFips() {
        return this.store.selectSnapshot(DemographicState.selectedFipsCode);
    }
    isZipAndFipsSelected() {
        return !!this.getZipCodeSelected() && !!this.getFipsCodeSelected();
    }
}
HelpfulToolsService.ɵfac = function HelpfulToolsService_Factory(t) { return new (t || HelpfulToolsService)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.PlansService), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.NavigationService)); };
HelpfulToolsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HelpfulToolsService, factory: HelpfulToolsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpfulToolsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i2.Store }, { type: i1.PlansService }, { type: i1.ConfigResourceService }, { type: i1.NavigationService }]; }, null); })();

class MapContextService {
    constructor() {
        this.isCenterLocationSetByPharmacy = false;
        this.isMapCenterChanged = false;
        this._fetchDataFromAPI$ = new BehaviorSubject(false);
        this._loadData$ = new BehaviorSubject({});
        this._location$ = new ReplaySubject(1);
        this._bounds$ = new ReplaySubject(1);
        this._markers$ = new ReplaySubject(1);
        this.fetchDataFromAPI$ = this._fetchDataFromAPI$.asObservable();
        this.loadData$ = this._loadData$.asObservable();
        this.location$ = this._location$.asObservable();
        this.bounds$ = this._bounds$.asObservable();
        this.markers$ = this._markers$.asObservable();
    }
    setLocation(location) {
        this._location$.next({
            lat: location.lat,
            lng: location.lng
        });
    }
    setDefaultBounds(bounds) {
        this._bounds$.next(bounds);
    }
    setMarkers(markers) {
        this._markers$.next(markers);
    }
    fetchDataFromAPI(isFetchCall) {
        this._fetchDataFromAPI$.next(isFetchCall);
    }
    loadData(location, bounds, distance) {
        const mapData = {
            location,
            bounds,
            distance
        };
        this._loadData$.next(mapData);
    }
}
MapContextService.ɵfac = function MapContextService_Factory(t) { return new (t || MapContextService)(); };
MapContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MapContextService, factory: MapContextService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MapContextService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class MapFacade {
    constructor(mapLoader, mapContextService, store, spinnerService, demographicsService) {
        this.mapLoader = mapLoader;
        this.mapContextService = mapContextService;
        this.store = store;
        this.spinnerService = spinnerService;
        this.demographicsService = demographicsService;
        this.fetchPharmaciesOnCenterChange = true;
        this.showMap = false;
        this.showSpinner = false;
    }
    getIsOptimalZoomEnabled() {
        return this.store.selectSnapshot(MapState.isOptimalZoomEnabled);
    }
    createCustomMapControl(map) {
        map.controls[google.maps.ControlPosition.TOP_CENTER].clear();
        const controlDiv = document.createElement('div');
        const controlUI = document.createElement('div');
        controlUI.className = 'p-2 Spa_Style_Link text-decoration-none map-custom-search-control';
        const controlText = document.createElement('span');
        controlText.innerHTML = 'Search this area';
        // Search Icon
        const controlIcon = document.createElement('i');
        controlIcon.className = 'pr-2 fas fa-search';
        // Append Child elements
        controlUI.appendChild(controlIcon);
        controlUI.appendChild(controlText);
        controlDiv.appendChild(controlUI);
        controlUI.addEventListener('click', () => {
            this.toggleSpinner(true);
            const bounds = map.getBounds();
            this.mapContextService.setLocation(this.location);
            this.mapContextService.loadData(this.location, bounds, this.getDistanceFromBounds(bounds));
            this.mapContextService.isMapCenterChanged = true;
            map.controls[google.maps.ControlPosition.TOP_CENTER].clear();
        });
        map.controls[google.maps.ControlPosition.TOP_CENTER].push(controlDiv);
    }
    initializeMap(map) {
        this.map = map;
        google.maps.event.addListener(map, 'dragend', () => {
            this.createCustomMapControl(map);
        });
        google.maps.event.addListener(map, 'zoom_changed', () => {
            if (map.zoom >= this.minZoom && map.zoom <= this.maxZoom && (!this.zoomLevel || +this.zoomLevel !== map.zoom)) {
                this.createCustomMapControl(map);
            }
            this.zoomLevel = map.zoom > this.maxZoom ? this.maxZoom : map.zoom < this.minZoom ? this.minZoom : map.zoom;
        });
    }
    getDistanceFromBounds(latLngBounds) {
        // use haversine equation to determine distance between points
        const northEastCoordinates = latLngBounds.getNorthEast();
        const southWestCoordinates = latLngBounds.getSouthWest();
        const earthRadius = 3960; // Average radius of the earth in miles
        const latitudinalRadians = this.degreesToRadians(southWestCoordinates.lat() - northEastCoordinates.lat());
        const longitudinalRadians = this.degreesToRadians(southWestCoordinates.lng() - northEastCoordinates.lng());
        const a = Math.sin(latitudinalRadians / 2) * Math.sin(latitudinalRadians / 2) +
            Math.cos(this.degreesToRadians(northEastCoordinates.lat())) *
                Math.cos(this.degreesToRadians(southWestCoordinates.lat())) *
                Math.sin(longitudinalRadians / 2) *
                Math.sin(longitudinalRadians / 2);
        const angle = Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)) * 2;
        const distance = earthRadius * angle; // Distance in miles
        return distance;
    }
    degreesToRadians(degrees) {
        return degrees * (Math.PI / 180);
    }
    setGeocoder(zip, defaultZoom, minZoom, maxZoom, searchByNameEnabled) {
        this.defaultZoom = defaultZoom;
        this.minZoom = minZoom;
        this.maxZoom = maxZoom;
        if (!this.geocoder) {
            this.mapLoader.load().then(() => {
                this.geocoder = new google.maps.Geocoder();
                this.setLatitudeAndLongitude(zip, searchByNameEnabled);
            });
        }
        else {
            this.setLatitudeAndLongitude(zip, searchByNameEnabled);
        }
    }
    async setLatitudeAndLongitude(zip, searchByNameEnabled) {
        const selectedZipCountryCode = await this.getSelectedZipCountryCode(zip);
        this.geocoder.geocode({ address: `${zip} ${selectedZipCountryCode}`, componentRestrictions: { country: selectedZipCountryCode } }, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
                const location = { lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() };
                const centerByZipcode = this.store.selectSnapshot(MapState.getMapCenterByZipcode);
                if (searchByNameEnabled &&
                    this.mapContextService.isCenterLocationSetByPharmacy &&
                    centerByZipcode &&
                    location &&
                    centerByZipcode.lat === location.lat &&
                    centerByZipcode.lng === location.lng &&
                    this.mapContextService.isMapCenterChanged) {
                    this.mapContextService.setLocation(centerByZipcode);
                    this.store.dispatch(new SetIsOptimalZoomEnabled(true));
                    this.mapContextService.fetchDataFromAPI(true);
                    this.mapContextService.isMapCenterChanged = false;
                }
                else {
                    if (this.mapContextService.isMapCenterChanged) {
                        this.mapContextService.isMapCenterChanged = false;
                    }
                    this.mapContextService.setLocation(location);
                    this.store.dispatch(new SetMapCenter(location));
                    this.mapContextService.fetchDataFromAPI(true);
                }
            }
            if (this.map) {
                this.map.controls[google.maps.ControlPosition.TOP_CENTER].clear();
            }
        });
    }
    getLatitudeAndLongitude(latitude, longitude) {
        return new google.maps.LatLng(latitude, longitude);
    }
    setCenterPosition(location) {
        this.location = location;
    }
    getMarkerBounds(markers) {
        if (markers?.length) {
            const bounds = new google.maps.LatLngBounds();
            markers.forEach(marker => bounds.extend(new google.maps.LatLng({ lat: marker.latitude, lng: marker.longitude })));
            if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
                const extendPoint = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
                bounds.extend(extendPoint);
            }
            return bounds;
        }
        return null;
    }
    getMarkers(pharmacies) {
        if (!pharmacies) {
            return [];
        }
        return pharmacies.map((pharmacy, index) => ({
            latitude: pharmacy.latitude,
            longitude: pharmacy.longitude,
            label: `${index + 1}`,
            draggable: false,
            pharmacyId: pharmacy.pharmacyId,
            name: pharmacy.name,
            address: pharmacy.address1,
            state: pharmacy.state,
            city: pharmacy.city,
            zip: pharmacy.zip,
            hasEPrescriptions: pharmacy.hasEPrescriptions,
            isPreferred: pharmacy.isPreferred
        }));
    }
    getProviderMarkers(providers) {
        if (!providers) {
            return [];
        }
        return providers.map((provider, index) => ({
            latitude: provider.latitude,
            longitude: provider.longitude,
            label: `${index + 1}`,
            draggable: false,
            id: provider.id,
            name: provider.displayName,
            address: provider.address1,
            address2: provider.address2,
            state: provider.state,
            city: provider.city,
            zip: provider.zip,
            specialty: provider.specialty,
            addressId: provider.addressId
        }));
    }
    getBoundsZoomLevel(bounds, mapDim) {
        const WORLD_DIM = { height: 256, width: 256 };
        const northEast = bounds.getNorthEast();
        const southWest = bounds.getSouthWest();
        const latitudeFraction = (this.latRad(northEast.lat()) - this.latRad(southWest.lat())) / Math.PI;
        const longitudeDifference = northEast.lng() - southWest.lng();
        const longitudeFraction = (longitudeDifference < 0 ? longitudeDifference + 360 : longitudeDifference) / 360;
        const latitudeZoom = this.getZoom(mapDim.height, WORLD_DIM.height, latitudeFraction);
        const longitudeZoom = this.getZoom(mapDim.width, WORLD_DIM.width, longitudeFraction);
        const zoomLevel = Math.min(latitudeZoom, longitudeZoom, this.maxZoom) - 1;
        return zoomLevel > this.maxZoom ? this.maxZoom : zoomLevel < this.minZoom ? this.minZoom : zoomLevel;
    }
    toggleSpinner(flag) {
        this.showSpinner = flag !== undefined ? flag : !this.showSpinner;
    }
    hideSpinner(spinnerEvent) {
        this.spinnerService.hide(spinnerEvent); // This used to hide the Page level spinner.
        this.toggleSpinner(false); // This used to hide the toggle spinner on search button click.
    }
    coordinatesWithinBounds(latitude, longitude, bounds) {
        return (latitude < bounds.getNorthEast().lat() &&
            latitude > bounds.getSouthWest().lat() &&
            longitude < bounds.getNorthEast().lng() &&
            longitude > bounds.getSouthWest().lng());
    }
    latRad(lat) {
        const sin = Math.sin((lat * Math.PI) / 180);
        const radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
    }
    getZoom(mapPx, worldPx, fraction) {
        return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
    }
    async getSelectedZipCountryCode(zip) {
        return await this.demographicsService.getCountryCodeForZip(zip);
    }
}
MapFacade.ɵfac = function MapFacade_Factory(t) { return new (t || MapFacade)(i0.ɵɵinject(i1$4.MapsAPILoader), i0.ɵɵinject(MapContextService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.SpinnerService), i0.ɵɵinject(i1.DemographicService)); };
MapFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MapFacade, factory: MapFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MapFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$4.MapsAPILoader }, { type: MapContextService }, { type: i2.Store }, { type: i1.SpinnerService }, { type: i1.DemographicService }]; }, null); })();

var PharmacyDesignation;
(function (PharmacyDesignation) {
    PharmacyDesignation["LongTermCare"] = "long term care";
    PharmacyDesignation["HomeInfusion"] = "home infusion";
    PharmacyDesignation["ExtendedSupply"] = "30+ days supply";
    PharmacyDesignation["Open24Hours"] = "Open 24 hours.";
})(PharmacyDesignation || (PharmacyDesignation = {}));
var PharmacyPlanCost;
(function (PharmacyPlanCost) {
    PharmacyPlanCost["MAIL_ORDER"] = "mailorder";
    PharmacyPlanCost["PHARMARCY_SELECTED"] = "pharmacy";
})(PharmacyPlanCost || (PharmacyPlanCost = {}));
var PharmacyModalViewName;
(function (PharmacyModalViewName) {
    PharmacyModalViewName["SEARCH"] = "search";
    PharmacyModalViewName["MAP"] = "map";
})(PharmacyModalViewName || (PharmacyModalViewName = {}));
const ZIP = 'zip';
const NAME = 'name';
class PharmacyFacade {
    constructor(store, configResourceService, stringFormatUtilityService, pharmacyHttpService, memberSessionService, helpfulToolsContext, helpfulToolsService, analyticsService, guidedHelpService, filterService, mapFacade, pharmacyService) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.stringFormatUtilityService = stringFormatUtilityService;
        this.pharmacyHttpService = pharmacyHttpService;
        this.memberSessionService = memberSessionService;
        this.helpfulToolsContext = helpfulToolsContext;
        this.helpfulToolsService = helpfulToolsService;
        this.analyticsService = analyticsService;
        this.guidedHelpService = guidedHelpService;
        this.filterService = filterService;
        this.mapFacade = mapFacade;
        this.pharmacyService = pharmacyService;
        this.currentModalViewName = PharmacyModalViewName.SEARCH;
        this.multiPharmacyEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_Multi_Pharmacy_Enabled', null, false);
        this.isMailOrderEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_Mail_Order_Pharmacy_Enabled', null, false);
        this.pharmacyBadgeColor = this.configResourceService.getProcessedResourceValue('Spa_Filter_Badge_Color', null, '#fcb215');
        this.pharmacyFilterControl = 'pharmacyFilterControl';
        this.pharmacyLimit = this.configResourceService.getProcessedResourceValue('Spa_Pharmacy_Limit') || 25;
        this.searchPharmacyByNameEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_SearchPharmacyByName_Enabled', null, false);
        this.pharmacyFilterData = [];
        this.pharmacyGroupFilters = [];
        this.parentFilter = { key: 'hasProperties', values: ['properties'], comparator: ComparatorType.EQUAL };
        this.showSpinner = false;
        this._pharmacies$ = new BehaviorSubject([]);
        this.pharmacies$ = this._pharmacies$.asObservable();
        let maximumPharmacyCount = this.configResourceService.getProcessedResourceValue('Spa_Site_Maximum_Pharmacy_Count', null, 3);
        if (!(maximumPharmacyCount >= NumberOfPharmacies.Minimum && maximumPharmacyCount <= NumberOfPharmacies.Maximum)) {
            maximumPharmacyCount = NumberOfPharmacies.Default;
        }
        this.maxPharmacyCount = maximumPharmacyCount;
    }
    get mailOrder$() {
        return this.pharmacyService.getIsMailOrderSelected$();
    }
    get filteredPharmacies$() {
        this.pharmacyGroupFilters.push(this.parentFilter);
        return this.filterService.getPharmacyByFilterGroup$(this.pharmacyGroupFilters);
    }
    getSelectedPharmacies$() {
        return this.store.select(PharmacyState.selectedPharmacies);
    }
    getDigitalPharmacies$() {
        return this.store.select(PharmacyState.digitalPharmacies);
    }
    getDigitalPharmacies() {
        return this.store.selectSnapshot(PharmacyState.digitalPharmacies);
    }
    getSelectedPharmacy$() {
        return this.store.select(PharmacyState.selectedPharmacy);
    }
    getSelectedPharmacy() {
        return this.store.selectSnapshot(PharmacyState.selectedPharmacy);
    }
    setSelectedPharmacy(pharmacy) {
        this.store.dispatch(new SetSelectedPharmacy(pharmacy));
    }
    getIsMailOrderSelected() {
        return this.store.selectSnapshot(PharmacyState.isMailOrderSelected);
    }
    fetchPharmaciesFromLocation(latitude, longitude, bounds, distance) {
        const radius = distance ? (distance / 2).toString() : null;
        const pharmacyName = this.searchPharmacyByNameEnabled && this.pharmacyByName ? this.pharmacyByName : null;
        const currentPlan = this.helpfulToolsService.getPlanSelected();
        this.pharmacyHttpService
            .retrievePharmacyFromLocation$(latitude.toString(), longitude.toString(), this.pharmacyLimit.toString(), radius, currentPlan ? currentPlan.id : null, pharmacyName)
            .pipe(map(pharmacies => this.getPharmaciesWithinBounds(pharmacies, bounds)))
            .toPromise()
            .then(pharmacies => {
            this._pharmacies$.next(pharmacies);
            if (pharmacies) {
                this.store.dispatch(new UpdatePharmacies(pharmacies));
            }
            else {
                this.store.dispatch(new UpdatePharmacies([]));
            }
            this.mapFacade.hideSpinner(SpinnerEvent.PHARMACIES_LOADING);
        }, () => {
            this.mapFacade.hideSpinner(SpinnerEvent.PHARMACIES_LOADING);
        });
    }
    fetchDigitalPharmacies() {
        this.store.dispatch(new FetchDigitalPharmacies());
    }
    async setPharmacy(pharmacies, multiPharmacyEnabled) {
        const sessionId = this.memberSessionService.getMemberSessionId();
        if (!multiPharmacyEnabled) {
            this.store.dispatch(new ResetSelectedPharmacies());
            this.pharmacyHttpService.deletePharmacies(sessionId);
        }
        this.store.dispatch(new SetPharmacies(pharmacies));
        this.store.dispatch(new SetPlansDirty(true, ALL_MEDICARE_PLUS_MEDIGAP_PLAN_TYPE_VALUES));
        if (pharmacies.length) {
            const selectedPharmacies = this.getSelectedNABPPharmacies();
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.SELECTED_PHARMACY, selectedPharmacies);
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PREFERENCES_PHARMACY_ADD,
                [DataLayerGlobalVariable.PHARMACY_NABP]: selectedPharmacies
            };
            const isPrimary = pharmacies[0].isPrimaryPharmacy ? pharmacies[0].isPrimaryPharmacy : false;
            this.pharmacyHttpService.savePharmacy(sessionId, pharmacies[0].nabp, pharmacies[0].isMailOrder, isPrimary);
        }
    }
    removePharmacy(pharmacyId) {
        const sessionId = this.memberSessionService.getMemberSessionId();
        const selectedPharmacies = this.store.selectSnapshot(PharmacyState.selectedPharmacies);
        const selectedPharmacy = this.store.selectSnapshot(PharmacyState.selectedPharmacy);
        const removedPharmacy = selectedPharmacies.find(x => x.pharmacyId === pharmacyId);
        this.store
            .dispatch(new RemovePharmacy(removedPharmacy))
            .pipe(take(1))
            .subscribe({
            next: () => {
                this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.SELECTED_PHARMACY, this.getSelectedNABPPharmacies());
                this.analyticsService.googleDataLayerTags = {
                    [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PREFERENCES_PHARMACY_REMOVE,
                    [DataLayerGlobalVariable.PHARMACY_NABP]: this.getSelectedNABPPharmacies(true)
                };
            }
        });
        this.pharmacyHttpService.deletePharmacy(sessionId, removedPharmacy.nabp);
        const updatedPharmacies = this.store.selectSnapshot(PharmacyState.selectedPharmacies);
        if (removedPharmacy.isPrimaryPharmacy && updatedPharmacies && updatedPharmacies.length > 0) {
            this.setAsPrimaryPharmacy$(updatedPharmacies[0])
                .pipe(take(1))
                .subscribe({ next: () => { } });
        }
        if (selectedPharmacy.pharmacyId === removedPharmacy.pharmacyId) {
            const primaryPharmacy = this.store.selectSnapshot(PharmacyState.primaryPharmacy);
            this.store.dispatch(new SetSelectedPharmacy(primaryPharmacy));
        }
        this.switchMailOrder(false);
    }
    setAnalyticsForPharmacySearch(zip, name) {
        const searchFields = [];
        if (zip) {
            searchFields.push(ZIP);
        }
        if (name) {
            searchFields.push(NAME);
        }
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PREFERENCES_PHARMACY_SEARCH,
            [DataLayerGlobalVariable.PHARMACY_SEARCH_FIELDS]: searchFields.join('|')
        };
    }
    loadPharmaciesFromAPI() {
        const sessionId = this.memberSessionService.getMemberSessionId();
        this.pharmacyHttpService.getPharmacies(sessionId).then(pharmacyData => {
            if (pharmacyData) {
                this.store.dispatch(new ResetPharmacy());
                this.store.dispatch(new SetPharmacies(pharmacyData));
                this.store.dispatch(new SetSelectedPharmacy(pharmacyData[0]));
            }
        });
    }
    noticeAlternateView(selectedPharmacy, pharmacy, isBackground, alwaysDefault) {
        const isSelected = selectedPharmacy && selectedPharmacy.pharmacyId === pharmacy.pharmacyId;
        if (this.helpfulToolsContext.isHelpfulToolsView) {
            if (pharmacy.isPreferred) {
                return this.guidedHelpService.getMapPreferredColorAccent(isBackground);
            }
        }
        else {
            if (alwaysDefault) {
                return this.guidedHelpService.getMapDefaultColorAccent(isBackground);
            }
            if (isSelected) {
                return this.guidedHelpService.getMapSelectedColorAccent(isBackground);
            }
        }
        return this.guidedHelpService.getMapDefaultColorAccent(isBackground);
    }
    noticeAlternatePharmacyIndicator(selectedPharmacy, pharmacy) {
        const isSelected = selectedPharmacy && selectedPharmacy.pharmacyId === pharmacy.pharmacyId;
        if (!this.helpfulToolsContext.isHelpfulToolsView) {
            if (isSelected) {
                return GuidedHelpMapStyleEnum.Spa_Map_Pin_Indicator;
            }
        }
        return GuidedHelpMapStyleEnum.Spa_Style_TooltipTextAndNumberIndicators;
    }
    // construct the pharmacy designation using old fashioned string manipulation
    getPharmacyDesignation(pharmacy) {
        const designations = {};
        let designation;
        let index = 0;
        if (pharmacy.hasExtendedDaysOfSupply) {
            designations[index] = PharmacyDesignation.ExtendedSupply;
            index += 1;
        }
        if (pharmacy.isLongTermCare) {
            designations[index] = PharmacyDesignation.LongTermCare;
            index += 1;
        }
        if (pharmacy.isHomeInfusion) {
            designations[index] = PharmacyDesignation.HomeInfusion;
            index += 1;
        }
        switch (index) {
            case 1:
                // ex: 30+ day supply
                designation = `${designations[0]}.`;
                break;
            case 2:
                // ex: Long term care and home infusion.
                designation = `${designations[0]} and ${designations[1]}.`;
                break;
            case 3:
                // ex: 30+ days supply, long term care, and home infusion.
                designation = `${designations[0]}, ${designations[1]}, and ${designations[2]}.`;
                break;
            default:
                designation = '';
                break;
        }
        // Append the 'Open 24 hours' to the end.
        // 30+ days supply, long term care, and home infusion.  Open 24 hours.
        if (pharmacy.has24hrService) {
            designation = `${designation} ${PharmacyDesignation.Open24Hours}`;
        }
        return this.stringFormatUtilityService.capitalizeFirstLetter(designation);
    }
    toggleSpinner(flag) {
        this.mapFacade.toggleSpinner(flag);
    }
    setAsPrimaryPharmacy$(pharmacy) {
        const selectedPharmacies = this.store.selectSnapshot(PharmacyState.selectedPharmacies);
        const updatedPharmacies = selectedPharmacies.reduce((pharmacies, primaryPharmacy) => {
            let isPrimaryPharmacy = false;
            if (primaryPharmacy && primaryPharmacy.pharmacyId === pharmacy.pharmacyId) {
                isPrimaryPharmacy = true;
            }
            primaryPharmacy = { ...primaryPharmacy, isPrimaryPharmacy };
            pharmacies.push(primaryPharmacy);
            return pharmacies;
        }, []);
        const previousSelectedNABPPharmacies = this.getSelectedNABPPharmacies();
        this.store.dispatch(new ResetSelectedPharmacies());
        return this.store.dispatch(new SetPharmacies(updatedPharmacies)).pipe(take(1), map(() => {
            const selectedNABPPharmacies = this.getSelectedNABPPharmacies();
            if (previousSelectedNABPPharmacies !== selectedNABPPharmacies) {
                this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.SELECTED_PHARMACY, selectedNABPPharmacies);
            }
            if (updatedPharmacies.length) {
                this.setSelectedPharmacy(this.store.selectSnapshot(PharmacyState.primaryPharmacy));
            }
            this.store.dispatch(new SetPlansDirty(true, [ALL_MEDICARE_PLAN_TYPE_VALUE]));
            const sessionId = this.memberSessionService.getMemberSessionId();
            this.pharmacyHttpService.savePharmacy(sessionId, pharmacy.nabp, pharmacy.isMailOrder, true);
            this.switchMailOrder(false);
        }));
    }
    setClickPreferencesPharmacySwitchAnalytics(selectedNABPPharmacies) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PREFERENCES_PHARMACY_SWITCH_PRIMARY,
            [DataLayerGlobalVariable.PHARMACY_NABP]: selectedNABPPharmacies
        };
    }
    getPharmacyBasedonIdAndAdd(pharmacies, id) {
        const pharmacySelectedToAdd = pharmacies.find(pharmacy => pharmacy.pharmacyId === id);
        if (pharmacySelectedToAdd) {
            this.addPharmacy(pharmacySelectedToAdd);
        }
    }
    addPharmacy(pharmacy) {
        let pharmacyList = [];
        const filteredPharmacy = [];
        const selectedPharmacies = this.store.selectSnapshot(PharmacyState.selectedPharmacies);
        if (this.multiPharmacyEnabled) {
            if (selectedPharmacies.length < this.maxPharmacyCount) {
                filteredPharmacy.push(pharmacy);
                pharmacyList = filteredPharmacy.reduce((pharmacies, updatedPharmacy) => {
                    let isPrimaryPharmacy = false;
                    if (updatedPharmacy && updatedPharmacy.pharmacyId === pharmacy.pharmacyId && selectedPharmacies.length <= 0) {
                        isPrimaryPharmacy = true;
                    }
                    updatedPharmacy = { ...updatedPharmacy, isPrimaryPharmacy };
                    pharmacies.push(updatedPharmacy);
                    return pharmacies;
                }, []);
                if (pharmacyList.length !== 0) {
                    this.setPharmacy(pharmacyList, this.multiPharmacyEnabled);
                    if (pharmacyList[0].isPrimaryPharmacy) {
                        this.setSelectedPharmacy(pharmacyList[0]);
                    }
                }
            }
            this.switchMailOrder(false);
        }
        else {
            const isPrimaryPharmacy = true;
            this.setPharmacy([{ ...pharmacy, isPrimaryPharmacy }], this.multiPharmacyEnabled);
            this.setSelectedPharmacy(pharmacy);
        }
    }
    pharmacyCountWithinLimits() {
        const selectedPharmacies = this.store.selectSnapshot(PharmacyState.selectedPharmacies);
        return this.isPharmacyCountWithinLimits(selectedPharmacies, this.multiPharmacyEnabled, this.maxPharmacyCount);
    }
    pharmacyCountWithinLimits$() {
        return this.store.select(PharmacyState.selectedPharmacies).pipe(map(selectedPharmacies => this.isPharmacyCountWithinLimits(selectedPharmacies, this.multiPharmacyEnabled, this.maxPharmacyCount)), distinctUntilChanged());
    }
    isSelectedPharmacy(pharmacy) {
        const selectedPharmacies = this.store.selectSnapshot(PharmacyState.selectedPharmacies);
        const exists = selectedPharmacies.find(existingPharmacy => existingPharmacy.pharmacyId === pharmacy.pharmacyId);
        return !!exists;
    }
    isPrimaryPharmacy(pharmacy, isHelpfulToolsView) {
        if (!isHelpfulToolsView) {
            const selectedPharmacies = this.store.selectSnapshot(PharmacyState.selectedPharmacies);
            const exists = selectedPharmacies.find(existingPharmacy => existingPharmacy.pharmacyId === pharmacy.pharmacyId);
            return !!(exists && exists.isPrimaryPharmacy && this.multiPharmacyEnabled);
        }
        return false;
    }
    getPharmacyMapPinClass(pharmacy, isPharmacyMap, isHelpfulToolsView) {
        const selectedPharmacies = this.store.selectSnapshot(PharmacyState.selectedPharmacies);
        const selectedPharmacy = selectedPharmacies?.length
            ? selectedPharmacies.find(existingPharmacy => existingPharmacy.pharmacyId === pharmacy.pharmacyId)
            : null;
        if (!isHelpfulToolsView && selectedPharmacy && selectedPharmacy.isPrimaryPharmacy && this.multiPharmacyEnabled) {
            return this.guidedHelpService.getPrimaryPinIcon() + ' fa-stack-2x primary-icon-size';
        }
        if (isPharmacyMap) {
            return 'fas fa-map-marker';
        }
        return 'fas fa-map-marker fa-stack-2x pharmacy-map-pin';
    }
    getSelectedPharmacies() {
        return this.store.selectSnapshot(PharmacyState.selectedPharmacies);
    }
    getPharmaciesBasedOnPlan$(zip, planId) {
        return this.pharmacyHttpService.retrievePharmacy$(zip, this.pharmacyLimit.toString(), planId);
    }
    switchMailOrder(mailOrder) {
        this.store.dispatch(new UpdateIsMailOrderSelected(mailOrder));
    }
    showPharmacySelectorToggle(tabType) {
        const selectedPharmacies = this.getSelectedPharmacies();
        return (this.multiPharmacyEnabled &&
            (tabType === PlanTypeAbbreviation.PDP || tabType === PlanTypeAbbreviation.MAPD) &&
            selectedPharmacies &&
            ((selectedPharmacies.length > 0 && this.isMailOrderEnabled) || selectedPharmacies.length > 1));
    }
    getSortedSelectedPharmacies$(planPharmacies) {
        const sortedPharmacies = [];
        if (!planPharmacies?.length) {
            return of(sortedPharmacies);
        }
        return this.getSelectedPharmacies$().pipe(map(selectedPharmacies => {
            selectedPharmacies.forEach(selectedPharmacy => {
                const pharmacy = planPharmacies.find(planPharmacy => planPharmacy && selectedPharmacy && planPharmacy.nabp === selectedPharmacy.nabp);
                if (pharmacy) {
                    sortedPharmacies.push(pharmacy);
                }
            });
            if (sortedPharmacies.length) {
                return sortedPharmacies;
            }
            return selectedPharmacies;
        }));
    }
    getPrimaryPharmacy$() {
        return this.getSelectedPharmacies$().pipe(map(pharmacies => {
            if (pharmacies) {
                return pharmacies.find(pharmacy => !!pharmacy.isPrimaryPharmacy);
            }
            return new APIPharmacyInfo();
        }));
    }
    getPharmacyFilters() {
        return this.configResourceService.getProcessedResourceValue('Spa_Pharmacy_Filters', null, []);
    }
    getPharmacyInNetworkDisplayName(key, inNetworkFilters) {
        if (inNetworkFilters.length) {
            const defaultPharmacyFilterData = inNetworkFilters.find(filteredData => filteredData.dataKey === key);
            return defaultPharmacyFilterData ? defaultPharmacyFilterData.displayName : '';
        }
    }
    getPharmacyDisplayName(key) {
        this.pharmacyFilterData = this.getPharmacyFilters();
        if (this.pharmacyFilterData) {
            const defaultPharmacyFilterData = this.pharmacyFilterData.find(filteredData => filteredData.dataKey === key);
            return defaultPharmacyFilterData ? defaultPharmacyFilterData.displayName : '';
        }
    }
    getFilterKeys(pharmacies) {
        let pharmacyFilterKeys;
        if (pharmacies) {
            pharmacyFilterKeys = pharmacies.reduce((filterKeys, pharmacy) => {
                if (pharmacy.has24hrService ||
                    pharmacy.hasEPrescriptions ||
                    pharmacy.hasHandicapAccess ||
                    pharmacy.hasDurableEquipment ||
                    pharmacy.isMailOrder) {
                    if (pharmacy.has24hrService && !filterKeys.includes(this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_24HR_SERVICE))) {
                        filterKeys.push(this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_24HR_SERVICE));
                    }
                    if (pharmacy.hasEPrescriptions &&
                        !filterKeys.includes(this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_E_PRESCRIPTION))) {
                        filterKeys.push(this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_E_PRESCRIPTION));
                    }
                    if (pharmacy.hasHandicapAccess &&
                        !filterKeys.includes(this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_HANDICAP_ACCESS))) {
                        filterKeys.push(this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_HANDICAP_ACCESS));
                    }
                    if (pharmacy.hasDurableEquipment &&
                        !filterKeys.includes(this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_DURABLE_EQUIPMENT))) {
                        filterKeys.push(this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_DURABLE_EQUIPMENT));
                    }
                    if (pharmacy.isMailOrder && !filterKeys.includes(this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_MAIL_ORDER))) {
                        filterKeys.push(this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_MAIL_ORDER));
                    }
                }
                return filterKeys;
            }, []);
            return this.getFilterKeysWithUpdatedDetails(pharmacyFilterKeys);
        }
        return [];
    }
    getNetworkFilterKeys(pharmacies, inNetworkFilters) {
        if (pharmacies) {
            const pharmacyFilterKeys = pharmacies.reduce((filterKeys, pharmacy) => {
                if (pharmacy.isPreferred != null) {
                    if (pharmacy.isPreferred && !filterKeys.includes(PharmacyFilterKeyType.PREFERRED)) {
                        filterKeys.push(PharmacyFilterKeyType.PREFERRED);
                    }
                    if (!pharmacy.isPreferred && !filterKeys.includes(PharmacyFilterKeyType.STANDARD)) {
                        filterKeys.push(PharmacyFilterKeyType.STANDARD);
                    }
                }
                return filterKeys;
            }, []);
            return pharmacyFilterKeys.reduce((filterKeyList, filterKey) => {
                if (filterKey) {
                    if (filterKey === PharmacyFilterKeyType.STANDARD || filterKey === PharmacyFilterKeyType.PREFERRED) {
                        filterKeyList.push({
                            label: this.getPharmacyInNetworkDisplayName(filterKey, inNetworkFilters),
                            value: filterKey,
                            disabled: false,
                            initiallyChecked: true
                        });
                    }
                }
                return filterKeyList;
            }, []);
        }
        return [];
    }
    getFilterKeysWithUpdatedDetails(filterKeys) {
        return filterKeys.reduce((filterKeyList, filterKey) => {
            if (filterKey) {
                filterKeyList.push({ label: filterKey, value: filterKey, disabled: false });
            }
            return filterKeyList;
        }, []);
    }
    clearPharmacyFilter() {
        this.setAnalyticsEventsForRemovedItems();
        this.filterService.clearPharmacyFilterGroupFilter(this.pharmacyGroupFilters);
    }
    updateFilterForm(type, pharmacyFilter, filterForm) {
        const pharmacyFilterType = filterForm.get(type);
        const value = [];
        pharmacyFilterType.setValue([]);
        if (pharmacyFilter?.length > 0) {
            pharmacyFilter.forEach(pharmacy => {
                if (pharmacy?.values) {
                    const pharmacyFilterKey = pharmacy.key;
                    if (pharmacyFilterKey === PharmacyFilterKeyType.PHARMACY_24HR_SERVICE) {
                        value.push(this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_24HR_SERVICE));
                    }
                    if (pharmacyFilterKey === PharmacyFilterKeyType.PHARMACY_E_PRESCRIPTION) {
                        value.push(this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_E_PRESCRIPTION));
                    }
                    if (pharmacyFilterKey === PharmacyFilterKeyType.PHARMACY_HANDICAP_ACCESS) {
                        value.push(this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_HANDICAP_ACCESS));
                    }
                    if (pharmacyFilterKey === PharmacyFilterKeyType.PHARMACY_DURABLE_EQUIPMENT) {
                        value.push(this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_DURABLE_EQUIPMENT));
                    }
                    if (pharmacyFilterKey === PharmacyFilterKeyType.PHARMACY_MAIL_ORDER) {
                        value.push(this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_MAIL_ORDER));
                    }
                    if (pharmacyFilterKey === PharmacyFilterKeyType.PREFERRED) {
                        value.push(PharmacyFilterKeyType.PREFERRED);
                    }
                    if (pharmacyFilterKey === PharmacyFilterKeyType.STANDARD) {
                        value.push(PharmacyFilterKeyType.STANDARD);
                    }
                }
            });
            pharmacyFilterType.setValue(value);
        }
        else {
            pharmacyFilterType.setValue([]);
        }
    }
    sortFilterControls(filters, orderByAsc) {
        return filters?.sort((a, b) => {
            const labelA = a.label.toLocaleLowerCase();
            const labelB = b.label.toLocaleLowerCase();
            if (labelA < labelB) {
                return orderByAsc ? -1 : 1;
            }
            if (labelA > labelB) {
                return orderByAsc ? 1 : -1;
            }
            return 0;
        });
    }
    updatePharmacyType(isHelpToolRoute, isPharmacyOtherFilterEnabled, isPharmacyInNetworkFilterEnabled, inNetworkFilters) {
        this.pharmacyTypes$ = this.pharmacies$.pipe(map(pharmacies => {
            if (!isHelpToolRoute && isPharmacyOtherFilterEnabled) {
                return this.getFilterKeys(pharmacies);
            }
            if (isHelpToolRoute) {
                if (isPharmacyInNetworkFilterEnabled) {
                    if (isPharmacyOtherFilterEnabled) {
                        return [...this.getFilterKeys(pharmacies), ...this.getNetworkFilterKeys(pharmacies, inNetworkFilters)];
                    }
                    return this.getNetworkFilterKeys(pharmacies, inNetworkFilters);
                }
                if (isPharmacyOtherFilterEnabled) {
                    return this.getFilterKeys(pharmacies);
                }
            }
        }));
    }
    isPharmacyFilterKey(filterKey) {
        return (filterKey === PharmacyFilterKeyType.PHARMACY_24HR_SERVICE ||
            filterKey === PharmacyFilterKeyType.PHARMACY_E_PRESCRIPTION ||
            filterKey === PharmacyFilterKeyType.PHARMACY_HANDICAP_ACCESS ||
            filterKey === PharmacyFilterKeyType.PHARMACY_DURABLE_EQUIPMENT ||
            filterKey === PharmacyFilterKeyType.PHARMACY_MAIL_ORDER ||
            filterKey === PharmacyFilterKeyType.PREFERRED ||
            filterKey === PharmacyFilterKeyType.STANDARD);
    }
    onFilterSelected($event, filterForm) {
        const filterName = $event.target.value;
        const checked = $event.target.checked;
        const pharmacyFilterNameForAnalytics = this.getPharmacyFilterNameForAnalytics(filterName);
        if (checked) {
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PREFERENCES_PHARMACY_FILTER_ADD,
                [DataLayerGlobalVariable.PHARMACY_FILTER_ADDED]: pharmacyFilterNameForAnalytics
            };
        }
        else {
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PREFERENCES_PHARMACY_FILTER_REMOVE,
                [DataLayerGlobalVariable.PHARMACY_FILTER_REMOVED]: pharmacyFilterNameForAnalytics
            };
        }
        this.updateFilter(filterName, checked, filterForm);
    }
    updateFilter(filterName, checked, filterForm) {
        const pharmacyFilterType = filterForm.get(this.pharmacyFilterControl);
        this.pharmacyGroupFilters = [this.parentFilter];
        const standardExists = pharmacyFilterType?.value?.some(filter => filter === PharmacyFilterKeyType.STANDARD);
        const preferredExists = pharmacyFilterType?.value?.some(filter => filter === PharmacyFilterKeyType.PREFERRED);
        const selectedFilter = [];
        selectedFilter.push(checked);
        let filteredFormType = '';
        if (filterName === this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_24HR_SERVICE)) {
            filteredFormType = PharmacyFilterKeyType.PHARMACY_24HR_SERVICE;
        }
        if (filterName === this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_E_PRESCRIPTION)) {
            filteredFormType = PharmacyFilterKeyType.PHARMACY_E_PRESCRIPTION;
        }
        if (filterName === this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_HANDICAP_ACCESS)) {
            filteredFormType = PharmacyFilterKeyType.PHARMACY_HANDICAP_ACCESS;
        }
        if (filterName === this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_DURABLE_EQUIPMENT)) {
            filteredFormType = PharmacyFilterKeyType.PHARMACY_DURABLE_EQUIPMENT;
        }
        if (filterName === this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_MAIL_ORDER)) {
            filteredFormType = PharmacyFilterKeyType.PHARMACY_MAIL_ORDER;
        }
        if (filterName === PharmacyFilterKeyType.PREFERRED) {
            filteredFormType = PharmacyFilterKeyType.PREFERRED;
        }
        if (filterName === PharmacyFilterKeyType.STANDARD) {
            filteredFormType = PharmacyFilterKeyType.STANDARD;
        }
        if (checked) {
            if ((filterName === PharmacyFilterKeyType.STANDARD || filterName === PharmacyFilterKeyType.PREFERRED) &&
                standardExists &&
                preferredExists) {
                this.filterService.addFilterToPharmacyFilterGroups(this.pharmacyGroupFilters, new Filter({ key: PharmacyFilterKeyType.STANDARD, values: [true, false], comparator: ComparatorType.IN }));
                this.filterService.addFilterToPharmacyFilterGroups(this.pharmacyGroupFilters, new Filter({ key: PharmacyFilterKeyType.PREFERRED, values: [true, false], comparator: ComparatorType.IN }));
            }
            else {
                this.filterService.addFilterToPharmacyFilterGroups(this.pharmacyGroupFilters, new Filter({ key: filteredFormType, values: selectedFilter, comparator: ComparatorType.IN }));
            }
        }
        else {
            if (filteredFormType === PharmacyFilterKeyType.PREFERRED || filteredFormType === PharmacyFilterKeyType.STANDARD) {
                if (standardExists) {
                    this.filterService.addFilterToPharmacyFilterGroups(this.pharmacyGroupFilters, new Filter({ key: PharmacyFilterKeyType.STANDARD, values: [true], comparator: ComparatorType.IN }));
                }
                if (preferredExists) {
                    this.filterService.addFilterToPharmacyFilterGroups(this.pharmacyGroupFilters, new Filter({ key: PharmacyFilterKeyType.PREFERRED, values: [true], comparator: ComparatorType.IN }));
                }
            }
            this.filterService.clearPharmacyFilterWithKey(this.pharmacyGroupFilters, filteredFormType);
        }
    }
    setAnalyticsForAddedFilters() {
        const filterNames = this.getPharmacyFilterNames();
        if (filterNames.length) {
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PREFERENCES_PHARMACY_FILTER_ADD,
                [DataLayerGlobalVariable.PHARMACY_FILTER_ADDED]: filterNames
                    .map((filterName) => this.getPharmacyFilterNameForAnalytics(filterName))
                    .join('|')
            };
        }
    }
    getPharmacyFilterNameForAnalytics(filterName) {
        let pharmacyFilterName = '';
        if (filterName === this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_24HR_SERVICE) ||
            filterName === PharmacyFilterKeyType.PHARMACY_24HR_SERVICE) {
            pharmacyFilterName = PharmacyFilterKeyAnalyticsName.PHARMACY_24HR_SERVICE;
        }
        else if (filterName === this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_E_PRESCRIPTION) ||
            filterName === PharmacyFilterKeyType.PHARMACY_E_PRESCRIPTION) {
            pharmacyFilterName = PharmacyFilterKeyAnalyticsName.PHARMACY_E_PRESCRIPTION;
        }
        else if (filterName === this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_HANDICAP_ACCESS) ||
            filterName === PharmacyFilterKeyType.PHARMACY_HANDICAP_ACCESS) {
            pharmacyFilterName = PharmacyFilterKeyAnalyticsName.PHARMACY_HANDICAP_ACCESS;
        }
        else if (filterName === this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_DURABLE_EQUIPMENT) ||
            filterName === PharmacyFilterKeyType.PHARMACY_DURABLE_EQUIPMENT) {
            pharmacyFilterName = PharmacyFilterKeyAnalyticsName.PHARMACY_DURABLE_EQUIPMENT;
        }
        else if (filterName === this.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_MAIL_ORDER) ||
            filterName === PharmacyFilterKeyType.PHARMACY_MAIL_ORDER) {
            pharmacyFilterName = PharmacyFilterKeyAnalyticsName.PHARMACY_MAIL_ORDER;
        }
        else if (filterName === PharmacyFilterKeyType.PREFERRED) {
            pharmacyFilterName = PharmacyFilterKeyAnalyticsName.PREFERRED;
        }
        else if (filterName === PharmacyFilterKeyType.STANDARD) {
            pharmacyFilterName = PharmacyFilterKeyAnalyticsName.STANDARD;
        }
        return pharmacyFilterName;
    }
    getPharmacyBasedOnId(id) {
        const selectedPharmacies = this.store.selectSnapshot(PharmacyState.selectedPharmacies);
        return selectedPharmacies?.length
            ? selectedPharmacies.find(existingPharmacy => id && existingPharmacy.pharmacyId === id)
            : new APIPharmacyInfo();
    }
    noticeAlternateIndicatorForMarker(pharmacy) {
        const selectedPharmacy = this.getPharmacyBasedOnId(pharmacy.pharmacyId);
        return this.noticeAlternatePharmacyIndicator(selectedPharmacy, pharmacy);
    }
    noticeAlternateViewBackgroundForMarker(pharmacy) {
        const selectedPharmacy = this.getPharmacyBasedOnId(pharmacy.pharmacyId);
        return this.noticeAlternateView(selectedPharmacy, pharmacy, true, true);
    }
    noticeAlternateViewForMarker(pharmacy) {
        const selectedPharmacy = this.getPharmacyBasedOnId(pharmacy.pharmacyId);
        return this.noticeAlternateView(selectedPharmacy, pharmacy);
    }
    getBackGroundColor(pharmacy, isHelpfulToolsView) {
        const selectedPharmacies = this.store.selectSnapshot(PharmacyState.selectedPharmacies);
        const selectedPharmacy = selectedPharmacies.find(existingPharmacy => existingPharmacy.pharmacyId === pharmacy.pharmacyId);
        if (selectedPharmacy && selectedPharmacy.isPrimaryPharmacy && !isHelpfulToolsView && this.multiPharmacyEnabled) {
            return { color: this.guidedHelpService.getPrimaryPinIconColor() };
        }
    }
    getBadgeColor() {
        return { background: this.pharmacyBadgeColor };
    }
    isPlanPharmacyCovered(plan) {
        // TODO: should this be plan specific? We don't seem to use plan here but need to look into this more
        const pharmacies = this.pharmacyService.getPharmacyData();
        return plan && pharmacies?.length && this.isSelectedPharmaciesDetailsExistInPlan(plan, pharmacies);
    }
    isSelectedPharmaciesDetailsExistInPlan(plan, pharmacies) {
        const selectedPharmacies = this.store.selectSnapshot(PharmacyState.selectedPharmacies);
        if (!selectedPharmacies && !selectedPharmacies.length) {
            return !(!selectedPharmacies && !selectedPharmacies.length);
        }
        return pharmacies.some(pharmacyCoverage => pharmacyCoverage && selectedPharmacies.some(pharmacy => pharmacy.nabp === pharmacyCoverage.nabp));
    }
    logDataLayerBasedOn(pharmacy) {
        const costsBasedOnValue = this.getIsMailOrderSelected && !pharmacy ? PharmacyPlanCost.MAIL_ORDER : `${PharmacyPlanCost.PHARMARCY_SELECTED}-${pharmacy.nabp}`;
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLANS_COSTS_BASED_ON,
            [DataLayerGlobalVariable.PLANS_COST_BASED_ON]: costsBasedOnValue
        };
    }
    getSelectedNABPPharmacies(displayNone) {
        const primaryPharmacy = this.store.selectSnapshot(PharmacyState.primaryPharmacy);
        const selectedPharmacies = this.store.selectSnapshot(PharmacyState.selectedPharmacies);
        let pharmacies = selectedPharmacies;
        if (primaryPharmacy) {
            pharmacies = selectedPharmacies.filter(pharmacy => pharmacy.pharmacyId !== primaryPharmacy.pharmacyId);
            pharmacies = [primaryPharmacy, ...pharmacies];
        }
        const defaultValue = displayNone ? GOOGLE_ANALYTICS_NONE : this.analyticsService.getGoogleTagManagerNotApplicableText();
        return pharmacies.length ? pharmacies.map(pharmacy => pharmacy.nabp).join('|') : defaultValue;
    }
    getPharmaciesWithinBounds(pharmacies, bounds) {
        if (bounds && pharmacies && !this.mapFacade.getIsOptimalZoomEnabled()) {
            return pharmacies.filter(pharmacy => this.mapFacade.coordinatesWithinBounds(pharmacy.latitude, pharmacy.longitude, bounds));
        }
        return pharmacies ?? [];
    }
    setAnalyticsEventsForRemovedItems() {
        const filterNames = this.getPharmacyFilterNames();
        filterNames.forEach((filterName) => {
            const pharmacyFilterNameForAnalytics = this.getPharmacyFilterNameForAnalytics(filterName);
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PREFERENCES_PHARMACY_FILTER_REMOVE,
                [DataLayerGlobalVariable.PHARMACY_FILTER_REMOVED]: pharmacyFilterNameForAnalytics
            };
        });
    }
    getPharmacyFilterNames() {
        const filters = this.filterService.getPharmacyFiltersByFilterGroup(this.pharmacyGroupFilters);
        const pharmacyFilters = filters.filter((filter) => this.isPharmacyFilterKey(filter.key));
        const filterNames = pharmacyFilters.map((filter) => filter.key);
        return filterNames;
    }
    isPharmacyCountWithinLimits(selectedPharmacies, multiPharmacyEnabled, maxPharmacyCount) {
        if (multiPharmacyEnabled) {
            if (selectedPharmacies.length >= maxPharmacyCount) {
                return !(selectedPharmacies.length >= maxPharmacyCount);
            }
        }
        return true;
    }
}
PharmacyFacade.ɵfac = function PharmacyFacade_Factory(t) { return new (t || PharmacyFacade)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.StringFormatUtilityService), i0.ɵɵinject(i1.PharmacyHttpService), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(HelpfulToolsContextService), i0.ɵɵinject(HelpfulToolsService), i0.ɵɵinject(AnalyticsService), i0.ɵɵinject(i1.GuidedHelpService), i0.ɵɵinject(i1.FilterService), i0.ɵɵinject(MapFacade), i0.ɵɵinject(i1.PharmacyService)); };
PharmacyFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PharmacyFacade, factory: PharmacyFacade.ɵfac, providedIn: 'root' });
__decorate([
    LiveEditInactive()
], PharmacyFacade.prototype, "switchMailOrder", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PharmacyFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i2.Store }, { type: i1.ConfigResourceService }, { type: i1.StringFormatUtilityService }, { type: i1.PharmacyHttpService }, { type: i1.MemberSessionService }, { type: HelpfulToolsContextService }, { type: HelpfulToolsService }, { type: AnalyticsService }, { type: i1.GuidedHelpService }, { type: i1.FilterService }, { type: MapFacade }, { type: i1.PharmacyService }]; }, { switchMailOrder: [] }); })();

class SendQuoteFacade {
    constructor(modalService, configResourceService, injector, formValidationService, quoteService, store, sessionService, agentService, emailService, profileService, siteService, agentSearchFacade, analyticsService, navigationUtilityService, messagesService, pharmacyFacade, providerService, demographicService, planYearResourceService, weglotService) {
        this.modalService = modalService;
        this.configResourceService = configResourceService;
        this.injector = injector;
        this.formValidationService = formValidationService;
        this.quoteService = quoteService;
        this.store = store;
        this.sessionService = sessionService;
        this.agentService = agentService;
        this.emailService = emailService;
        this.profileService = profileService;
        this.siteService = siteService;
        this.agentSearchFacade = agentSearchFacade;
        this.analyticsService = analyticsService;
        this.navigationUtilityService = navigationUtilityService;
        this.messagesService = messagesService;
        this.pharmacyFacade = pharmacyFacade;
        this.providerService = providerService;
        this.demographicService = demographicService;
        this.planYearResourceService = planYearResourceService;
        this.weglotService = weglotService;
        this.planDocuments = [];
        this.isConsumerMemberProgressEnabled = this.configResourceService.getProcessedResourceValue('Spa_Consumer_MemberProgress_Enabled', null, false);
    }
    isMultiPharmacyEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Multi_Pharmacy_Enabled', widgetName, false);
    }
    async showSendQuoteModal(optedPlans, widgetName, planPermissions) {
        this.widgetName = widgetName;
        const assignedAgentOfRecord = this.agentService.getAgentOfRecord();
        const currentAgentGuid = this.agentService.getAgentInContextGuid();
        const isProfileAdmin = this.agentService.getIsProfileAdmin();
        const currentAgentIsNotAssignedAgent = assignedAgentOfRecord && currentAgentGuid && assignedAgentOfRecord.agentData?.data.agentGuid !== currentAgentGuid && isProfileAdmin;
        this.plansIncluded = currentAgentIsNotAssignedAgent
            ? optedPlans
            : optedPlans.filter(plan => plan.isPUF !== true && plan.isNonPermissionedPlan !== true);
        const hasMedigapPlans = this.plansIncluded.some(plan => plan.planTypeAbbreviation === PlanTypeAbbreviation.MEDIGAP);
        this.quoteModalTitle = this.configResourceService.getProcessedResourceValue('Spa_SendQuoteModal_Title_Text', widgetName, 'Send quote');
        this.quoteModalCancel = this.configResourceService.getProcessedResourceValue('Spa_SendQuoteModal_Cancel_Button_Text', widgetName, 'Cancel');
        const quoteModalSendEmail = this.configResourceService.getProcessedResourceValue('Spa_SendQuoteModal_Send_Button_Text', widgetName, 'Send email');
        const emailLabelText = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_Email_Label_Text', widgetName, 'Email address');
        const phoneLabelText = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_Phone_Label_Text', widgetName, 'Phone');
        const firstNameLabelText = this.configResourceService.getProcessedResourceValue('Spa_Profile_FirstName_Label', widgetName, 'First name');
        const lastNameLabelText = this.configResourceService.getProcessedResourceValue('Spa_Profile_LastName_Label', widgetName, 'Last name');
        this.sentConfirmationText = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_ConfirmationMessageSent_Text', widgetName, `We've successfully sent the quote to`);
        this.viewMemberLink = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_ViewMemberProfile_Link_Text', widgetName, `View 's profile`);
        this.isPresonalizedMessageEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_SendQuote_PersonalizedMessage_Enabled', widgetName, true);
        const additionalTitle = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_AdditionalMessage_Title_Text', widgetName, 'Additional message');
        const additionalSubText = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_AdditionalMessage_Sub_Text', widgetName, 'This will show when the user logins back into the site.');
        this.additionalDefaultMessage = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_AdditionalMessage_Default_Message', widgetName, 'Please review this quote at your earliest convenience. let me know if you have any questions.');
        const plansIncludedLabel = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_PlansIncluded_SectionHeader_Text', widgetName, 'Plan(s) included');
        this.planDocumentHeader = this.configResourceService.getProcessedResourceValue('Spa_Quote_Email_Document_Header', widgetName, 'List of selected documents');
        this.showViewMemberLink = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_ViewMemberProfile_Link_Enabled', widgetName, false);
        const isQuoteCreateProfileEnabled = this.configResourceService.getProcessedResourceValue('Spa_Quote_CreateProfile_Enabled', widgetName, this.siteService.isPPCSite());
        const isQuoteShowProfileNamesEnabled = this.configResourceService.getProcessedResourceValue('Spa_Quote_ShowProfileNames_Enabled', widgetName, false);
        const quoteSendQuoteToHeader = this.configResourceService.getProcessedResourceValue('Spa_Quote_SendQuoteTo_Header', widgetName, 'Send quote to <name>');
        const isPlanSearchEnabled = this.configResourceService.getProcessedResourceValue('Spa_ProfileNavBar_ShowPlanList_Flag', widgetName, false);
        const isSendQuoteByTextEnabled = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_Text_Enabled', widgetName, true);
        const emailCheckBoxLabelText = this.configResourceService.getProcessedResourceValue('Spa_SendQuoteModal_Email_CheckBox_Text', widgetName, 'Email');
        const textCheckBoxLabelText = this.configResourceService.getProcessedResourceValue('Spa_SendQuoteModal_Phone_CheckBox_Text', widgetName, 'Text');
        const instructionalText = this.configResourceService.getProcessedResourceValue('Spa_SendQuoteModal_Instructional_Text', widgetName, 'How would the beneficiary like to receive the quote information?');
        const memberRegistrationFields = this.getMemberRegistrationFields(widgetName);
        const showPlanDocuments = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_ShowPlanDocuments', widgetName, true);
        const selectAllText = this.configResourceService.getProcessedResourceValue('Spa_Site_SelectAll_Text', widgetName, 'Select all');
        const clearAllText = this.configResourceService.getProcessedResourceValue('Spa_Site_ClearAll_Text', widgetName, 'Clear all');
        const isCreateMemberProfileEnabled = isPlanSearchEnabled && isQuoteCreateProfileEnabled;
        const pharmacySectionHeaderText = this.configResourceService.getProcessedResourceValue('Spa_Site_Pharmacy_Text', widgetName, 'Pharmacy');
        const pharmacySectionSubText = this.configResourceService.getProcessedResourceValue('Spa_Site_Pharmacy_Sub_Text', widgetName, 'View costs based on one or multiple pharmacies');
        const checkBoxesRequiredText = this.configResourceService.getProcessedResourceValue('Spa_SendQuoteModal_CheckBoxesRequired', widgetName, 'Select at least one option to send quote.');
        const personalizedVideoEnabled = this.configResourceService.getProcessedResourceValue('Spa_PersonalizedVideo_Enabled', null, false);
        const personalizedQuoteVideoEnabled = this.configResourceService.getProcessedResourceValue('Spa_PersonalizedVideo_Quote_Enabled', null, false);
        const personalizedQuoteVideoCheckboxEnabled = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_PersonalizedVideo_Checkbox_Enabled', null, false);
        const personalizedVideoCheckboxHeaderText = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_PersonalizedVideo_Checkbox_Header_Text', null, 'Personalization');
        const personalizedVideoCheckboxLabelText = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_PersonalizedVideo_Checkbox_Label_Text', null, 'Personalized video');
        const personalizedVideoCheckboxChecked = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_PersonalizedVideo_Checkbox_Checked', null, false);
        const sendQuoteAgentOfRecordEnabled = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_AgentOfRecord_Enabled', null, false);
        const sendQuoteSendingAgentLabelText = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_SendingAgentLabel_Text', null, 'Sending agent');
        const planCardNotLicensedText = this.configResourceService.getProcessedResourceValue('Spa_PlanCard_NotLicensed_Text', null, 'Not licensed to sell');
        const agentOfRecordText = this.configResourceService.getProcessedResourceValue('Spa_AddProfile_AssignedAgent_Text', null, 'Agent of record');
        const authCodeTextOnlyEnabled = this.configResourceService.getProcessedResourceValue('SPA_AuthCode_TextOnly_Enabled', null, false);
        const quoteLinkEmailOnlyEnabled = this.configResourceService.getProcessedResourceValue('SPA_QuoteLink_EmailOnly_Enabled', null, false);
        const selectedPharmacies = this.store.selectSnapshot(PharmacyState.selectedPharmacies);
        const primaryPharmacy = this.store.selectSnapshot(PharmacyState.selectedPharmacy);
        const sendQuoteModal = this.modalService.open(SendQuoteModalComponent, { centered: true, injector: this.injector });
        sendQuoteModal.componentInstance.modalTitleText = this.quoteModalTitle;
        sendQuoteModal.componentInstance.modalCancelText = this.quoteModalCancel;
        sendQuoteModal.componentInstance.modalSendEmailText = quoteModalSendEmail;
        sendQuoteModal.componentInstance.modalEmailLabelText = emailLabelText;
        sendQuoteModal.componentInstance.modalFirstNameLabelText = firstNameLabelText;
        sendQuoteModal.componentInstance.modalLastNameLabelText = lastNameLabelText;
        sendQuoteModal.componentInstance.modalIsPresonalizedMessageEnabled = this.isPresonalizedMessageEnabled;
        sendQuoteModal.componentInstance.modalAdditionalTitle = additionalTitle;
        sendQuoteModal.componentInstance.modalAdditionalSubText = additionalSubText;
        sendQuoteModal.componentInstance.modalAdditionalDefaultMessage = this.additionalDefaultMessage;
        sendQuoteModal.componentInstance.modalPlansIncludedLabel = plansIncludedLabel;
        sendQuoteModal.componentInstance.agentOfRecordText = agentOfRecordText;
        sendQuoteModal.componentInstance.emailRequiredError = this.formValidationService.errorMessages.requiredEmail();
        sendQuoteModal.componentInstance.emailInvalidError = this.formValidationService.errorMessages.invalidEmail();
        sendQuoteModal.componentInstance.firstNameRequiredError = this.formValidationService.errorMessages.requiredFirstName();
        sendQuoteModal.componentInstance.firstNameInvalidError = this.formValidationService.errorMessages.minCharacters2();
        sendQuoteModal.componentInstance.lastNameRequiredError = this.formValidationService.errorMessages.requiredLastName();
        sendQuoteModal.componentInstance.lastNameInvalidError = this.formValidationService.errorMessages.minCharacters2();
        sendQuoteModal.componentInstance.phoneRequiredError = this.formValidationService.errorMessages.requiredPhone();
        sendQuoteModal.componentInstance.phoneInvalidError = this.formValidationService.errorMessages.invalidPhone();
        sendQuoteModal.componentInstance.showPlanDocuments = showPlanDocuments;
        sendQuoteModal.componentInstance.showEmail = true;
        sendQuoteModal.componentInstance.isCreateNewProfileEnabled = isCreateMemberProfileEnabled;
        sendQuoteModal.componentInstance.isQuoteShowProfileNamesEnabled = isQuoteShowProfileNamesEnabled;
        sendQuoteModal.componentInstance.quoteSendQuoteToHeader = quoteSendQuoteToHeader.replace('<name>', this.store.selectSnapshot(ProfileState.firstName) + ' ' + this.store.selectSnapshot(ProfileState.lastName));
        sendQuoteModal.componentInstance.modalSelectAllButtonText = selectAllText;
        sendQuoteModal.componentInstance.modalSelectNoneButtonText = clearAllText;
        sendQuoteModal.componentInstance.memberRegistrationFields = memberRegistrationFields;
        sendQuoteModal.componentInstance.modalPharmacyHeaderText = pharmacySectionHeaderText;
        sendQuoteModal.componentInstance.modalPharmacySubText = pharmacySectionSubText;
        sendQuoteModal.componentInstance.isMultiPharmacyEnabled = this.isMultiPharmacyEnabled(widgetName);
        sendQuoteModal.componentInstance.selectedPharmacies = selectedPharmacies;
        sendQuoteModal.componentInstance.primaryPharmacy = primaryPharmacy;
        sendQuoteModal.componentInstance.personalizedVideoEnabled = personalizedVideoEnabled;
        sendQuoteModal.componentInstance.personalizedQuoteVideoEnabled = personalizedQuoteVideoEnabled;
        sendQuoteModal.componentInstance.personalizedQuoteVideoCheckboxEnabled = personalizedQuoteVideoCheckboxEnabled;
        sendQuoteModal.componentInstance.personalizedVideoCheckboxHeaderText = personalizedVideoCheckboxHeaderText;
        sendQuoteModal.componentInstance.personalizedVideoCheckboxLabelText = personalizedVideoCheckboxLabelText;
        sendQuoteModal.componentInstance.personalizedVideoCheckboxChecked = personalizedVideoCheckboxChecked;
        sendQuoteModal.componentInstance.sendQuoteAgentOfRecordEnabled = sendQuoteAgentOfRecordEnabled && currentAgentIsNotAssignedAgent;
        sendQuoteModal.componentInstance.sendQuoteSendingAgentLabelText = sendQuoteSendingAgentLabelText;
        sendQuoteModal.componentInstance.planCardNotLicensedText = planCardNotLicensedText;
        sendQuoteModal.componentInstance.planPermissions = planPermissions;
        sendQuoteModal.componentInstance.agentOfRecord = assignedAgentOfRecord.agentData;
        sendQuoteModal.componentInstance.plansIncluded = this.plansIncluded;
        sendQuoteModal.componentInstance.authCodeTextOnlyEnabled = authCodeTextOnlyEnabled;
        sendQuoteModal.componentInstance.quoteLinkEmailOnlyEnabled = quoteLinkEmailOnlyEnabled;
        if (isSendQuoteByTextEnabled) {
            sendQuoteModal.componentInstance.checkBoxRequiredError = checkBoxesRequiredText;
            sendQuoteModal.componentInstance.showPhone = isSendQuoteByTextEnabled;
            sendQuoteModal.componentInstance.modalPhoneLabelText = phoneLabelText;
            sendQuoteModal.componentInstance.showEmailAndPhoneCheckbox = true;
            sendQuoteModal.componentInstance.modalEmailCheckboxLabelText = emailCheckBoxLabelText;
            sendQuoteModal.componentInstance.modalPhoneCheckboxLabelText = textCheckBoxLabelText;
            sendQuoteModal.componentInstance.modalPromptText = instructionalText;
        }
        sendQuoteModal.result
            .then(async (formData) => {
            if (isCreateMemberProfileEnabled && !this.profileService.hasMemberProfile()) {
                const profile = this.createProfileState(formData);
                await this.createMemberProfile(profile);
            }
            this.sendQuote(formData, hasMedigapPlans);
        })
            .catch(() => {
            // eat the error to prevent a console error
        });
    }
    sendQuote(formData, hasMedigapPlans) {
        const emailAddress = formData.emailAddress;
        const phoneNumber = formData.phone;
        this.memberProfileData = this.store.selectSnapshot(MemberState.session);
        if (this.profileService.hasMemberProfile()) {
            if (this.memberProfileData.profile.emailAddress !== emailAddress) {
                this.updateMemberEmail(emailAddress);
            }
            if (phoneNumber && this.memberProfileData.profile.homePhone !== phoneNumber) {
                this.updateMemberPhone(phoneNumber);
            }
        }
        else {
            // update the profile address but not the API member session
            this.profileService.updateEmailAddress(emailAddress);
            if (phoneNumber) {
                this.profileService.updateHomePhone(phoneNumber);
            }
        }
        this.createQuote(formData, hasMedigapPlans);
    }
    async createMemberProfile(profile) {
        const memberSession = this.sessionService.getMemberSession();
        const apiMemberStateModel = {
            agentGuid: this.agentService.getAgentInContextGuid(),
            memberID: memberSession ? memberSession.memberID : '',
            profile
        };
        return await this.sessionService.updateMemberProfile(apiMemberStateModel);
    }
    async updateMemberEmail(emailAddress) {
        const memberSession = this.sessionService.getMemberSession();
        const assignedAgentGuid = this.agentService.getCreatingAgentGuid();
        const apiMemberStateModel = {
            ...(!assignedAgentGuid && { agentGuid: this.agentService.getAgentInContextGuid() }),
            memberID: memberSession ? memberSession.memberID : '',
            profile: {
                emailAddress
            }
        };
        return await this.sessionService.updateMemberProfile(apiMemberStateModel);
    }
    async updateMemberPhone(homePhone) {
        const memberSession = this.sessionService.getMemberSession();
        const assignedAgentGuid = this.agentService.getCreatingAgentGuid();
        const apiMemberStateModel = {
            ...(!assignedAgentGuid && { agentGuid: this.agentService.getAgentInContextGuid() }),
            memberID: memberSession ? memberSession.memberID : '',
            profile: {
                homePhone
            }
        };
        return await this.sessionService.updateMemberProfile(apiMemberStateModel);
    }
    async createQuote(formData, hasMedigapPlans, widgetName) {
        const assignedAgentOfRecord = this.agentService.getAgentOfRecord();
        const currentAgentGuid = this.agentService.getAgentInContextGuid();
        const agentLoginDomain = this.configResourceService.getProcessedResourceValue('Spa_Site_AgentDomain', widgetName, 'drx');
        const agencyConsumerSharedResourcesEnabled = this.configResourceService.getProcessedResourceValue('Spa_Agency_Consumer_Resource_Sharing_Enabled', null, false);
        const personalizedVideoEnabled = this.configResourceService.getProcessedResourceValue('Spa_PersonalizedVideo_Enabled', null, false);
        const personalizedQuoteVideoEnabled = this.configResourceService.getProcessedResourceValue('Spa_PersonalizedVideo_Quote_Enabled', null, false);
        const isQuoteVideoEnabled = personalizedVideoEnabled && personalizedQuoteVideoEnabled;
        this.agentData = await this.getCreditedAgent();
        const quote = new QuoteHttpRequest();
        quote.quotedPlans = this.plansIncluded.map(plan => plan.id);
        quote.agentGuid = this.agentData.agentGuid;
        quote.planYear = this.planYearResourceService.getSelectedPlanYear();
        quote.brokerMessage = this.isPresonalizedMessageEnabled ? formData.additionalMessage : this.additionalDefaultMessage;
        quote.maxSavedFavoritePlans = 0;
        quote.agentLoginDomain = agentLoginDomain;
        quote.emailAddress = formData ? formData.emailAddress : '';
        quote.phone = formData && formData.phone ? formData.phone : '';
        quote.includeVideo = formData ? formData.includeVideo : isQuoteVideoEnabled;
        quote.deliveryMethod = {
            email: quote.emailAddress,
            phone: quote.phone
        };
        quote.quoteType = QuoteType.QUICKQUOTE;
        if (hasMedigapPlans) {
            quote.isMedigap = true;
            quote.effectiveDate = this.store.selectSnapshot(MedSupState.formField('EffectiveDate'));
        }
        quote.planType = this.plansIncluded.length ? PlanType[this.plansIncluded[0].planType] : null;
        if (agencyConsumerSharedResourcesEnabled && this.siteService.isPPCSite()) {
            quote.sourceSiteId = this.siteService.getSiteId();
        }
        if (assignedAgentOfRecord.agentData && assignedAgentOfRecord.agentData.data.agentGuid !== currentAgentGuid) {
            quote.sendingAgent = assignedAgentOfRecord.agentData.data.agentGuid;
        }
        // Format for these keys is different than normal due to being created and used by the API team
        if (isQuoteVideoEnabled) {
            const providerDetails = this.providerService.getProviderDetails();
            const providerBasicInfo = this.providerService.getSelectedProviders();
            quote.plans = this.plansIncluded.map(plan => {
                const providerDetailInfo = this.providerService.getProviderDetailInfo(plan.id, providerDetails);
                const providers = providerBasicInfo.map(providerInfo => {
                    const npi = providerInfo.npis[0].toString();
                    const inNetwork = providerDetailInfo.find(detailInfo => detailInfo.npi === npi)?.inNetwork;
                    return { npi, addressId: providerInfo.addressId, displayName: providerInfo.displayName, inNetwork };
                });
                return { plan: { ...plan, providers }, providers };
            });
            quote.planPharmacyData = this.store.selectSnapshot(PlansState.pharmacies);
        }
        const sessionId = this.sessionService.getMemberSessionId();
        await this.createQuote$(sessionId, quote)
            .toPromise()
            .then(result => {
            if (result.authCode && result.queryString && result.quoteId) {
                this.generateEmailsWithQuote(formData, this.agentData, result.authCode, result.queryString, result.quoteId);
                if (quote.deliveryMethod.phone) {
                    this.generateTextsWithQuote(formData, result.authCode, result.queryString, result.quoteId);
                }
                this.analyticsService.googleDataLayerTags = {
                    [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLANS_SEND_QUOTE,
                    [DataLayerGlobalVariable.QUOTE_ID]: result.quoteId,
                    [DataLayerGlobalVariable.SEND_QUOTE_VIA]: this.getSendQuoteViaAnalyticsValue(quote.deliveryMethod.email, quote.deliveryMethod.phone)
                };
                if (formData.selectedPharmacy) {
                    this.pharmacyFacade
                        .setAsPrimaryPharmacy$(formData.selectedPharmacy)
                        .pipe(take(1))
                        .subscribe(() => { });
                }
                this.sendQuoteStatus(sessionId, MemberProgressStatus.QUOTE_SENT);
                this.showConfirmationModal(result.authCode, quote.emailAddress);
            }
        });
    }
    showConfirmationModal(authCode, emailAddress, widgetName) {
        this.setSendQuoteConfirmationModalAttributes(widgetName, emailAddress);
        const confirmationModal = this.modalService.open(SendQuoteConfirmationModalComponent, { centered: true });
        confirmationModal.componentInstance.modalTitleText = this.quoteModalTitle;
        confirmationModal.componentInstance.modalSentConfirmationText = this.sentConfirmationText;
        confirmationModal.componentInstance.modalViewMemberLink = this.viewMemberLink;
        confirmationModal.componentInstance.modalCancelText = this.quoteModalCancel;
        // create new session on cancel if profile has been updated
        confirmationModal.componentInstance.cancelAction = this.confirmationModalCancelAction.bind(this);
        confirmationModal.componentInstance.authCodeSuccessMessage = this.getAuthCodeSuccessMessage(authCode);
        confirmationModal.componentInstance.showViewMemberLink = this.showViewMemberLink;
        confirmationModal.result
            .then(async () => {
            this.agentSearchFacade.navigateByPageTag(PageTags.ADD_NEW_PROFILE);
        })
            .catch(() => {
            // eat the error to prevent a console error
        });
    }
    sendQuoteStatus(sessionId, statusId) {
        if (this.isConsumerMemberProgressEnabled) {
            this.quoteService
                .updateMemberProgress$(sessionId, statusId)
                .pipe(take(1))
                .subscribe({
                next: () => { }
            });
        }
    }
    setSendQuoteConfirmationModalAttributes(widgetName, emailAddress) {
        const isCreateProfileEnabled = this.configResourceService.getProcessedResourceValue('Spa_Quote_CreateProfile_Enabled', widgetName, this.siteService.isPPCSite());
        const createProfileLink = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_CreateProfile_Link_Text', widgetName, 'Create a profile');
        if (this.profileService.hasMemberProfile() || isCreateProfileEnabled) {
            const fullName = this.profileService.getMemberFullName();
            this.viewMemberLink = this.profileService.getViewLinkText(this.viewMemberLink, fullName);
            this.sentConfirmationText = this.sentConfirmationText.concat(' ', fullName);
        }
        else {
            this.viewMemberLink = createProfileLink;
            this.sentConfirmationText = this.sentConfirmationText.concat(' ', emailAddress);
        }
    }
    confirmationModalCancelAction() {
        // Create a new member session if we have updated the store for an email address but if no
        // member profile exists.
        const isNewMemberSessionNeeded = !this.profileService.hasMemberProfile() && this.store.selectSnapshot(ProfileState.emailAddress);
        if (isNewMemberSessionNeeded) {
            this.sessionService.createMemberSession$().toPromise();
        }
    }
    createQuote$(sessionId, quote) {
        return this.quoteService.createQuote$(sessionId, quote);
    }
    async generateEmailsWithQuote(formData, agentData, authCode, queryString, quoteId) {
        const agentFullName = agentData ? agentData.firstName.concat(' ', agentData.lastName) : '';
        const sendQuoteSubject = this.configResourceService
            .getProcessedResourceValue('Spa_ViewQuote_Email_Subject', this.widgetName, `<agentFullName> wants to share health insurance options`)
            .replace('<agentFullName>', agentFullName);
        const viewCodeSubject = this.configResourceService.getProcessedResourceValue('Spa_AccessCode_Email_Subject', this.widgetName, 'Your access code');
        const quoteQueryStringShortUrl = await this.generateShortUrl(queryString, quoteId, SendQuoteVia.EMAIL);
        const emailHeader = this.emailService.getFormattedEmailHeader(this.widgetName);
        let agentFooterData;
        if (agentData) {
            agentFooterData = this.agentService.getCreditedAgentEmailFooterData(agentData);
        }
        else {
            agentFooterData = await this.agentService.getAgentEmailFooterData();
        }
        let agentName;
        let agentNPN;
        let californiaLicenseNumber;
        if (this.agentService.isPlanCompareApiAgentDataEnabled()) {
            const planCompareApiAgentData = this.agentService.getPlanCompareApiAgentData();
            ({ agentName, agentNPN, californiaLicenseNumber } = planCompareApiAgentData);
        }
        else {
            agentName = agentFooterData.agentName;
            agentNPN = agentFooterData.agentNPN;
            californiaLicenseNumber = agentFooterData.californiaLicenseNumber;
        }
        const inputs = [
            { key: 'planDocumentHeader', value: this.getDocumentHeader(formData.planDocuments) },
            { key: 'planDocuments', value: this.getDocumentHtml(formData.planDocuments) },
            { key: 'buttonUrl', value: quoteQueryStringShortUrl },
            { key: 'agentName', value: agentName },
            { key: 'agencyName', value: agentFooterData.agencyName },
            { key: 'agentNPN', value: agentNPN },
            { key: 'agentEmail', value: agentFooterData.agentEmail },
            { key: 'agentPhoneAndHours', value: agentFooterData.agentPhoneAndHours },
            { key: 'agentPictureURL', value: agentFooterData.agentPictureURL },
            { key: 'emailHeader', value: emailHeader },
            { key: 'californiaLicenseNumber', value: californiaLicenseNumber }
        ];
        const spaAuthCodeTextOnlyEnabled = this.configResourceService.getProcessedResourceValue('SPA_AuthCode_TextOnly_Enabled', this.widgetName, true);
        if (formData.emailAddress && formData.emailAddress.length > 0) {
            if (!spaAuthCodeTextOnlyEnabled) {
                this.sendAccessCodeEmail(authCode, formData.emailAddress, viewCodeSubject, agentData);
            }
            this.emailService.sendEmail(EmailNames.VIEW_QUOTE, [formData.emailAddress], sendQuoteSubject, inputs);
        }
    }
    async generateShortUrl(queryString, quoteId, sendQuoteVia) {
        const quotingPageTag = this.configResourceService.getProcessedResourceValue('Spa_ViewQuote_Email_PageTag', this.widgetName, PageTags.BENEFICIARY_LOGIN);
        const showAgentProfilePicture = this.configResourceService.getProcessedResourceValue('Spa_Agent_Profile_Picture_Upload_Enabled', this.widgetName, true);
        const agencyConsumerSharedResourcesEnabled = this.configResourceService.getProcessedResourceValue('Spa_Agency_Consumer_Resource_Sharing_Enabled', null, false);
        const showAgentHeader = this.configResourceService.getProcessedResourceValue('Spa_Site_Broker_Info_Enabled', this.widgetName, true);
        const showAgentMiniCart = this.configResourceService.getProcessedResourceValue('Spa_Site_Show_Agent_MiniCart', this.widgetName, true);
        const showMeetWithAgent = this.configResourceService.getProcessedResourceValue('Spa_Site_Show_Meet_With_Agent', this.widgetName, true);
        const hidePdfAgentData = this.configResourceService.getProcessedResourceValue('Spa_Site_Broker_PDF_HideAgentData', this.widgetName, false);
        const baseUrl = this.siteService.getBaseConsumerSiteUrl(this.widgetName);
        const url = this.navigationUtilityService.addHrefToUrl(baseUrl, quotingPageTag, queryString);
        const quoteQueryString = new URL(url);
        quoteQueryString.searchParams.set(UTMParameter.UTM_SOURCE, UTMValue.UTM_SOURCE_PLAN_COMPARE);
        quoteQueryString.searchParams.set(UTMParameter.UTM_MEDIUM, sendQuoteVia === SendQuoteVia.EMAIL ? UTMValue.UTM_MEDIUM_EMAIL : UTMValue.UTM_MEDIUM_SMS);
        quoteQueryString.searchParams.set(UTMParameter.UTM_CAMPAIGN, UTMValue.UTM_CAMPAIGN_QUICK_QUOTE);
        quoteQueryString.searchParams.set(UTMParameter.UTM_CONTENT, quoteId);
        quoteQueryString.searchParams.set('showAgentHeader', showAgentHeader);
        quoteQueryString.searchParams.set('showAgentMiniCart', showAgentMiniCart);
        quoteQueryString.searchParams.set('showMeetWithAgent', showMeetWithAgent);
        quoteQueryString.searchParams.set('showAgentProfilePicture', showAgentProfilePicture);
        quoteQueryString.searchParams.set('hidePdfAgentData', hidePdfAgentData);
        quoteQueryString.searchParams.set('CultureCode', this.weglotService.getCurrentWeglotLocaleOrDefault());
        if (agencyConsumerSharedResourcesEnabled && this.siteService.isPPCSite()) {
            quoteQueryString.searchParams.set('SourceSiteId', this.siteService.getSiteId());
        }
        return await this.messagesService.getShortUrl(quoteQueryString.href);
    }
    async generateTextsWithQuote(formData, authCode, queryString, quoteId) {
        const quoteQueryStringShortUrl = await this.generateShortUrl(queryString, quoteId, SendQuoteVia.TEXT);
        if (formData.phone && formData.phone.length > 0) {
            const spaQuoteLinkEmailOnlyEnabled = this.configResourceService.getProcessedResourceValue('SPA_QuoteLink_EmailOnly_Enabled', this.widgetName, true);
            if (!spaQuoteLinkEmailOnlyEnabled) {
                this.sendText(formData.phone, quoteQueryStringShortUrl);
            }
            this.sendAuthText(formData.phone, authCode);
        }
    }
    sendAccessCodeEmail(authCode, emailAddress, subject, agentData) {
        this.agentService.sendAccessCodeEmail(authCode, emailAddress, subject, agentData);
    }
    getDocumentHeader(planDocuments) {
        this.planDocuments = planDocuments;
        if (this.planDocuments.length === 0) {
            return '';
        }
        return this.planDocumentHeader;
    }
    getDocumentHtml(planDocuments) {
        this.planDocuments = planDocuments;
        if (this.plansIncluded.length > 1 || this.planDocuments.length === 0) {
            return '';
        }
        return this.quoteService.getPlanDocumentsHtml(planDocuments);
    }
    getSendQuoteViaAnalyticsValue(email, phone) {
        if (email && phone) {
            return `${SendQuoteVia.EMAIL}${SendQuoteVia.DELIMITER}${SendQuoteVia.TEXT}`;
        }
        if (email) {
            return SendQuoteVia.EMAIL;
        }
        if (phone) {
            return SendQuoteVia.TEXT;
        }
        return null;
    }
    async sendText(phone, shortUrl) {
        const weglotMultiLanguageEnabled = this.configResourceService.getProcessedResourceValue('Spa_Weglot_MultiLanguage_Enabled', null, false);
        const clientName = this.configResourceService.getProcessedResourceValue('Spa_ClientName', this.widgetName, '');
        let textPrefix = this.configResourceService.getProcessedResourceValue('Spa_ViewQuote_Text_MessagePrefix', this.widgetName, 'View your quote from');
        if (weglotMultiLanguageEnabled) {
            textPrefix = await this.weglotService.getTranslatedText$(textPrefix).toPromise();
        }
        const text = `${textPrefix} ${clientName}: ${shortUrl}`;
        return await this.messagesService.sendText$(phone, text).toPromise();
    }
    async sendAuthText(phone, authcode) {
        let authPrefix = this.configResourceService.getProcessedResourceValue('Spa_ViewQuote_Text_AuthPrefix', this.widgetName, 'Use this authorization code to access your quote: ');
        const weglotMultiLanguageEnabled = this.configResourceService.getProcessedResourceValue('Spa_Weglot_MultiLanguage_Enabled', null, false);
        if (weglotMultiLanguageEnabled) {
            authPrefix = await this.weglotService.getTranslatedText$(authPrefix).toPromise();
        }
        const text = `${authPrefix} ${authcode}`;
        return await this.messagesService.sendText$(phone, text).toPromise();
    }
    createProfileState(formData) {
        return {
            addresses: [
                {
                    address1: '',
                    address2: '',
                    city: this.store.selectSnapshot(HelpfulToolsState.counties)[0]?.countyName,
                    state: this.store.selectSnapshot(HelpfulToolsState.counties)[0]?.state,
                    zip: this.demographicService.getSelectedZipCode(),
                    countyFips: this.demographicService.getSelectedFipsCode(),
                    isPrimaryAddress: true
                }
            ],
            emailAddress: formData.emailAddress,
            homePhone: formData.phone,
            workPhone: formData.phone,
            cellPhone: formData.phone,
            birthdate: formData.dateOfBirth,
            firstName: formData.firstName,
            lastName: formData.lastName,
            customField1: formData.customField1,
            customField2: formData.customField2,
            customField3: formData.customField3,
            customField4: formData.customField4,
            customField5: formData.customField5
        };
    }
    getAuthCodeSuccessMessage(authCode, widgetName) {
        const message = this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_SuccessMessage_AuthCodeMessage', widgetName, 'Authorization code: <b><authCode></b>');
        return message ? message.replace('<authCode>', authCode) : '';
    }
    async getCreditedAgent() {
        const assignedAgentOfRecord = this.agentService.getAgentOfRecord();
        const currentAgentGuid = this.agentService.getAgentInContextGuid();
        const isProfileAdmin = this.agentService.getIsProfileAdmin();
        let agentData;
        const currentAgentIsNotAssignedAgent = assignedAgentOfRecord &&
            currentAgentGuid &&
            assignedAgentOfRecord.agentData &&
            assignedAgentOfRecord.agentData.data.agentGuid !== currentAgentGuid &&
            isProfileAdmin;
        if (currentAgentIsNotAssignedAgent) {
            await this.agentService
                .fetchAgent$(assignedAgentOfRecord.agentData.data.agentGuid, currentAgentGuid)
                .toPromise()
                .then(agentFetchedData => {
                agentData = agentFetchedData?.data;
            });
        }
        else {
            const assignedAgentData = this.store.selectSnapshot(AgentState.agentData);
            agentData = assignedAgentData?.data;
        }
        return agentData;
    }
    getMemberRegistrationFields(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_MemberRegistration_Resource_Content', widgetName, [
            {
                keyName: 'firstName',
                labelText: 'First Name',
                display: true,
                required: true,
                requiredText: 'First name is required'
            },
            {
                keyName: 'lastName',
                labelText: 'Last name',
                display: true,
                required: true,
                requiredText: 'Last name is required'
            },
            {
                keyName: 'dateOfBirth',
                labelText: 'Date of birth',
                display: true,
                required: false,
                requiredText: 'Date of birth is required'
            },
            {
                keyName: 'email',
                labelText: 'Email address',
                display: true,
                required: false,
                requiredText: 'Email address is required'
            },
            {
                keyName: 'phone',
                labelText: 'Phone number',
                display: true,
                required: false,
                requiredText: 'Phone is required'
            },
            {
                keyName: 'address1',
                labelText: 'Address 1',
                display: true,
                required: false,
                requiredText: 'Address 1 is required'
            },
            {
                keyName: 'address2',
                labelText: 'Address 2',
                display: true,
                required: false,
                requiredText: 'Address 2 is required'
            },
            {
                keyName: 'city',
                labelText: 'City',
                display: true,
                required: false,
                requiredText: 'City is required'
            },
            {
                keyName: 'state',
                labelText: 'State',
                display: true,
                required: false,
                requiredText: 'State is required'
            },
            {
                keyName: 'zip',
                labelText: 'ZIP',
                display: true,
                required: true,
                requiredText: 'ZIP is required'
            },
            {
                keyName: 'county',
                labelText: 'County',
                display: false,
                required: false,
                requiredText: 'County is required'
            },
            {
                keyName: 'crm',
                labelText: 'CRM ID',
                display: true,
                required: false,
                requiredText: 'CRM ID is required'
            },
            {
                keyName: 'authRepFirstName',
                labelText: 'First name',
                display: true,
                required: false,
                requiredText: 'First name is required'
            },
            {
                keyName: 'authRepLastName',
                labelText: 'Last name',
                display: true,
                required: false,
                requiredText: 'Last name is required'
            },
            {
                keyName: 'authRepEmail',
                labelText: 'Email',
                display: true,
                required: false,
                requiredText: 'Email is required'
            },
            {
                keyName: 'authRepPhone',
                labelText: 'Phone number',
                display: true,
                required: false,
                requiredText: 'Phone number is required'
            },
            {
                keyName: 'authRepAddress1',
                labelText: 'Address line 1',
                display: true,
                required: false,
                requiredText: 'Address line 1 is required'
            },
            {
                keyName: 'authRepAddress2',
                labelText: 'Address line 2',
                display: true,
                required: false,
                requiredText: 'Address line 2 is required'
            },
            {
                keyName: 'authRepCity',
                labelText: 'City',
                display: true,
                required: false,
                requiredText: 'City is required'
            },
            {
                keyName: 'authRepState',
                labelText: 'State',
                display: true,
                required: false,
                requiredText: 'State is required'
            },
            {
                keyName: 'authRepZip',
                labelText: 'Zip',
                display: true,
                required: false,
                requiredText: 'Zip is required'
            },
            {
                keyName: 'authRepRelationship',
                labelText: 'Relationship to beneficiary',
                display: true,
                required: false,
                requiredText: 'Relationship is required'
            },
            {
                keyName: 'customField1',
                labelText: '[Primary care provider]',
                display: true,
                required: false,
                requiredText: 'Custom field 1 is required'
            },
            {
                keyName: 'customField2',
                labelText: '[Custom 2]',
                display: true,
                required: false,
                requiredText: 'Custom field 2 is required'
            },
            {
                keyName: 'customField3',
                labelText: '[Custom 3]',
                display: true,
                required: false,
                requiredText: 'Custom field 3 is required'
            },
            {
                keyName: 'customField4',
                labelText: '[Custom 4]',
                display: true,
                required: false,
                requiredText: 'Custom field 4 is required'
            },
            {
                keyName: 'customField5',
                labelText: '[Custom 5]',
                display: true,
                required: false,
                requiredText: 'Custom field 5 is required'
            }
        ]);
    }
}
SendQuoteFacade.ɵfac = function SendQuoteFacade_Factory(t) { return new (t || SendQuoteFacade)(i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(i1.FormValidationService), i0.ɵɵinject(i1.QuoteService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(i1.AgentService), i0.ɵɵinject(i1.EmailService), i0.ɵɵinject(i1.ProfileService), i0.ɵɵinject(i1.SiteService), i0.ɵɵinject(AgentSearchFacade), i0.ɵɵinject(AnalyticsService), i0.ɵɵinject(i1.NavigationUtilityService), i0.ɵɵinject(i1.MessagesService), i0.ɵɵinject(PharmacyFacade), i0.ɵɵinject(i1.ProviderService), i0.ɵɵinject(i1.DemographicService), i0.ɵɵinject(i1.PlanYearResourceService), i0.ɵɵinject(i1.WeglotService)); };
SendQuoteFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SendQuoteFacade, factory: SendQuoteFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SendQuoteFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$1.NgbModal }, { type: i1.ConfigResourceService }, { type: i0.Injector }, { type: i1.FormValidationService }, { type: i1.QuoteService }, { type: i2.Store }, { type: i1.MemberSessionService }, { type: i1.AgentService }, { type: i1.EmailService }, { type: i1.ProfileService }, { type: i1.SiteService }, { type: AgentSearchFacade }, { type: AnalyticsService }, { type: i1.NavigationUtilityService }, { type: i1.MessagesService }, { type: PharmacyFacade }, { type: i1.ProviderService }, { type: i1.DemographicService }, { type: i1.PlanYearResourceService }, { type: i1.WeglotService }]; }, null); })();

class PlanFacade {
    constructor(configResourceService, store, plansService, navigationService, modalService, shoppingCartService, medSupService, guidedHelpService, quoteService, agentService, sendQuoteFacade, analyticsService, siteService, millimanService, enrollmentSettingsService, memberSessionService, dateService, localeService, planYearResourceService, demographicService, agentPermissionsService, spinnerService, dsnpService, providerService) {
        this.configResourceService = configResourceService;
        this.store = store;
        this.plansService = plansService;
        this.navigationService = navigationService;
        this.modalService = modalService;
        this.shoppingCartService = shoppingCartService;
        this.medSupService = medSupService;
        this.guidedHelpService = guidedHelpService;
        this.quoteService = quoteService;
        this.agentService = agentService;
        this.sendQuoteFacade = sendQuoteFacade;
        this.analyticsService = analyticsService;
        this.siteService = siteService;
        this.millimanService = millimanService;
        this.enrollmentSettingsService = enrollmentSettingsService;
        this.memberSessionService = memberSessionService;
        this.dateService = dateService;
        this.localeService = localeService;
        this.planYearResourceService = planYearResourceService;
        this.demographicService = demographicService;
        this.agentPermissionsService = agentPermissionsService;
        this.spinnerService = spinnerService;
        this.dsnpService = dsnpService;
        this.providerService = providerService;
        this.isZelisIntegrationEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_ZelisIntegration_Enabled', null, false);
        this.subsidyAccordionItems = [];
        this.initLogoBaseUrl();
        this.showPremiumAsAnnual = this.configResourceService.getProcessedResourceValue('Spa_Site_ShowPremiumAsAnnual') || false;
        this.locale$ = this.localeService.getCurrentLocale$();
        if (this.isShowPartialSubsidy()) {
            this.subsidyAccordionItems = this.getSubsidyAccordionItems().filter(subsidyItem => subsidyItem.id !== SubsidySelected.PARTIAL.toString());
        }
        else {
            this.subsidyAccordionItems = this.getSubsidyAccordionItems();
        }
    }
    get healthStatus() {
        const selectedHealthStatus = this.store.selectSnapshot(DemographicState.healthStatus);
        if (selectedHealthStatus) {
            return selectedHealthStatus;
        }
        return this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_Health_DefaultHealthStatus_Number', null, 3);
    }
    get healthStatusLabel() {
        let healthDescription = this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_Health_SliderHeader1_Text', null, 'Generally healthy');
        if (this.healthStatus === GuidedHelpHealthStatus.MEMBER_HEALTH_FAIR) {
            healthDescription = this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_Health_SliderHeader2_Text', null, 'Some health needs');
        }
        else if (this.healthStatus === GuidedHelpHealthStatus.MEMBER_HEALTH_POOR) {
            healthDescription = this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_Health_SliderHeader3_Text', null, 'Significant health needs');
        }
        return healthDescription;
    }
    get AgeLabel() {
        const selectedAgeRange = this.store.selectSnapshot(DemographicState.ageRange);
        const selectedOrDefaultAgeRange = selectedAgeRange || this.guidedHelpService.getAgeRangeDefault();
        const ageRange = this.guidedHelpService.ageGroups.find(label => label.value === selectedOrDefaultAgeRange);
        if (ageRange) {
            return ageRange.label;
        }
    }
    get siteType() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType', null, 'consumer');
    }
    get isAddToQuoteEnabled() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_AddToQuote_Enabled', null, true);
    }
    get isMedigapQuotingEnabled() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Enable_Medigap_Quoting', null, false);
    }
    get selectedProviders$() {
        return this.providerService.getSelectedProviders$();
    }
    get selectedProviders() {
        return this.providerService.getSelectedProviders();
    }
    get quoteHospitalCareMedicareMap() {
        const quoteHospitalCareMedicareList = this.configResourceService.getProcessedResourceValue('Spa_Site_Quote_Map_HIP_Medicare_List', null, [
            {
                hospitalCareRiderBenefit: HospitalIndemnityRiderBenefit.AMBULANCE_BENEFITS,
                medicareCategoryId: MedCategoryID.AMBULANCE_BENEFITS
            },
            {
                hospitalCareRiderBenefit: HospitalIndemnityRiderBenefit.DURABLE_MEDICAL_EQUIPMENT_BENEFITS,
                medicareCategoryId: MedCategoryID.DURABLE_MEDICAL_EQUIPMENT_BENEFITS
            },
            {
                hospitalCareRiderBenefit: HospitalIndemnityRiderBenefit.EMERGENCY_ROOM_VISIT_DUE_TO_ACCIDENT_OR_INJURY,
                medicareCategoryId: MedCategoryID.EMERGENCY_ROOM_VISIT_DUE_TO_ACCIDENT_OR_INJURY
            },
            {
                hospitalCareRiderBenefit: HospitalIndemnityRiderBenefit.LUMP_SUM_CANCER_BENEFITS,
                medicareCategoryId: MedCategoryID.LUMP_SUM_CANCER_BENEFITS
            },
            {
                hospitalCareRiderBenefit: HospitalIndemnityRiderBenefit.OUTPATIENT_REHAB_BENEFITS,
                medicareCategoryId: MedCategoryID.OUTPATIENT_REHAB_BENEFITS
            },
            {
                hospitalCareRiderBenefit: HospitalIndemnityRiderBenefit.OUTPATIENT_REHAB_BENEFITS_1,
                medicareCategoryId: MedCategoryID.OUTPATIENT_REHAB_BENEFITS_1
            },
            {
                hospitalCareRiderBenefit: HospitalIndemnityRiderBenefit.OUTPATIENT_REHAB_BENEFITS_2,
                medicareCategoryId: MedCategoryID.OUTPATIENT_REHAB_BENEFITS_2
            },
            {
                hospitalCareRiderBenefit: HospitalIndemnityRiderBenefit.PRIMARY_CARE_PHYSICIAN_OFFICE_VISIT,
                medicareCategoryId: MedCategoryID.PRIMARY_CARE_PHYSICIAN_OFFICE_VISIT
            },
            {
                hospitalCareRiderBenefit: HospitalIndemnityRiderBenefit.SKILLED_NURSING_FACILITY_BENEFITS_1,
                medicareCategoryId: MedCategoryID.SKILLED_NURSING_FACILITY_BENEFITS_1
            },
            {
                hospitalCareRiderBenefit: HospitalIndemnityRiderBenefit.SKILLED_NURSING_FACILITY_BENEFITS_2,
                medicareCategoryId: MedCategoryID.SKILLED_NURSING_FACILITY_BENEFITS_2
            },
            {
                hospitalCareRiderBenefit: HospitalIndemnityRiderBenefit.SKILLED_NURSING_FACILITY_BENEFITS_3,
                medicareCategoryId: MedCategoryID.SKILLED_NURSING_FACILITY_BENEFITS_3
            },
            {
                hospitalCareRiderBenefit: HospitalIndemnityRiderBenefit.SKILLED_NURSING_FACILITY_BENEFITS_4,
                medicareCategoryId: MedCategoryID.SKILLED_NURSING_FACILITY_BENEFITS_4
            }
        ]);
        return this.parseToMedicareRidersMap(quoteHospitalCareMedicareList);
    }
    isShowPartialSubsidy() {
        return this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_ShowSubsidyAccordion_Flag', null, true);
    }
    getSubsidyAccordionItems() {
        return [
            {
                title: this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidyMedicaid_Text', null, 'I receive help from Medicaid'),
                id: `${SubsidySelected.MEDICAID}`,
                message: this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_GettingStarted_DSNP_EligibleMessage_Text', null, 'This option may qualify you for a Dual Eligible Special Needs Plan (DSNP).'),
                tooltipLabel: this.configResourceService.getProcessedResourceValue('Spa_DSNP_Eligibility_LearnMore_Text', null, 'Learn more'),
                tooltipText: this.configResourceService.getProcessedResourceValue('Spa_DSNP_Eligibility_Tooltip_Text', null, 'Dual eligible Special Needs Plans (DSNP) are for people who receive both Medicare and Medicaid (dual eligible). Premium depends on your level of Extra Help. You must continue to pay your Medicare Part B premium, unless it is covered through your State Medicaid Program. If you receive Medicaid cost-sharing assistance, you may pay nothing for medical deductibles, copayments, and coinsurance.'),
                showMessage: this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_GettingStarted_Show_DSNP_EligibleMessage', null, false)
            },
            {
                title: this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidySSI_Text', null, 'I get supplemental security income'),
                id: `${SubsidySelected.SSI}`
            },
            {
                title: this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidyMSP_Text', null, 'I belong to a Medicare Savings Program (MSP)'),
                id: `${SubsidySelected.MSP}`
            },
            {
                title: this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidyFull_Text', null, 'I applied and got full help through social security'),
                id: `${SubsidySelected.FULL}`
            },
            {
                title: this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidyPartial_Text', null, 'I applied for and got partial help through social security'),
                id: `${SubsidySelected.PARTIAL}`,
                childItemsLabel: this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidyPercentDetails_HTML', null, ' <b>I receive the following percentage to help pay my drug plan premium</b>'),
                childItems: [
                    {
                        title: this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidyLevel25_Text', null, '25%'),
                        id: '25'
                    },
                    {
                        title: this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidyLevel50_Text', null, '50%'),
                        id: '50'
                    },
                    {
                        title: this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidyLevel75_Text', null, '75%'),
                        id: '75'
                    },
                    {
                        title: this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidyLevel100_Text', null, '100%'),
                        id: '100'
                    }
                ]
            },
            {
                title: this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidyNone_Text', null, 'No, I am not eligible for special assistance'),
                id: `${SubsidySelected.NONE}`
            },
            {
                title: this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidyDontKnow_Text', null, `I don't know`),
                id: `${SubsidySelected.DONT_KNOW}`
            }
        ];
    }
    getFilteredPlansBySNPVisibility$() {
        return this.plansService.getFilteredPlansBySNPVisibility$();
    }
    getHasMedSupAnswers$() {
        return this.medSupService.getHasMedSupAnswers$();
    }
    getHasAncillaryPlanAnswers$() {
        return this.plansService.getHasAncillaryPlanAnswers$();
    }
    getHasHospitalIndemnityAnswers$() {
        return this.plansService.getHasHospitalIndemnityAnswers$();
    }
    getExtraDataValueByName(plan, name, defaultValue) {
        return this.plansService.getExtraDataValueByName(plan, name, defaultValue);
    }
    getMedicareGroupPlanConfiguration() {
        return this.plansService.getMedicareGroupPlanConfiguration();
    }
    setPlansDirty(dirty, planTypes) {
        this.plansService.setPlansDirty(dirty, planTypes);
    }
    getPlanListTabData(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanList_Tabs_Data', widgetName);
    }
    getEmptyPlanTabsToHide() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Hide_EmptyPlanTabs', null, [
            {
                tabType: PlanTypeAbbreviation.MAPD,
                states: []
            },
            {
                tabType: PlanTypeAbbreviation.MA,
                states: []
            },
            {
                tabType: PlanTypeAbbreviation.PDP,
                states: []
            },
            {
                tabType: PlanTypeAbbreviation.MEDIGAP,
                states: []
            },
            {
                tabType: PlanTypeAbbreviation.DENTAL,
                states: []
            },
            {
                tabType: PlanTypeAbbreviation.VISION,
                states: []
            },
            {
                tabType: PlanTypeAbbreviation.HC,
                states: []
            }
        ]);
    }
    getPlanDescription(plan, widgetName) {
        if (plan?.planSubType && COMBO_PLANS.includes(plan.planSubType)) {
            return plan.planSubType;
        }
        let resourceKeyByAbbreviation = {
            PDP: 'Spa_Site_Pdp_Description',
            MAPD: 'Spa_Site_Mapd_Description',
            MEDIGAP: 'Spa_Site_Medigap_Description',
            MA: 'Spa_Site_Ma_Description'
        };
        if (this.displayAncillaryPlans()) {
            resourceKeyByAbbreviation = {
                ...resourceKeyByAbbreviation,
                ...this.getAncillaryPlansTypes()
            };
        }
        return this.configResourceService.getProcessedResourceValue(resourceKeyByAbbreviation[plan?.planTypeAbbreviation], widgetName);
    }
    getPlanDescriptionById(planId) {
        const resourceKeyById = {
            [PlanType.PDP]: 'Spa_Site_Pdp_Description',
            [PlanType.MAPD]: 'Spa_Site_Mapd_Description',
            [PlanType.MEDIGAP]: 'Spa_Site_Medigap_Description',
            [PlanType.DENTAL]: 'Spa_Site_Dental_Description',
            [PlanType.VISION]: 'Spa_Site_Vision_Description',
            [PlanType.MA]: 'Spa_Site_Ma_Description',
            [PlanType.HC]: 'Spa_Site_HIP_Description'
        };
        return this.configResourceService.getProcessedResourceValue(resourceKeyById[planId]);
    }
    isPlanAncillary(selectedPlan) {
        return this.shoppingCartService.isPlanAncillary(selectedPlan);
    }
    displayAncillaryPlans() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_ShowAncillaryPlans_Description', null, false);
    }
    getAncillaryPlansTypes() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_ShowAncillaryPlans_PlanTypes', null, {
            DENTAL: 'Spa_Site_Dental_Description',
            VISION: 'Spa_Site_Vision_Description',
            HC: 'Spa_Site_HIP_Description'
        });
    }
    sortPlansInCartByOrdinal(plans) {
        const planSort = this.getPlansSort();
        if (planSort?.length) {
            const extendedPlans = plans.map(plan => {
                const planSortByPlanType = planSort.find(planSortOption => planSortOption.planTypeAbbreviation === plan.planTypeAbbreviation);
                const planSortByPlanSubType = planSort.find(planSortOption => planSortOption.planSubType === plan.planSubType);
                const { ordinal } = planSortByPlanType || {};
                const subTypeOrdinal = planSortByPlanSubType?.ordinal || {};
                return { ...plan, ordinal, subTypeOrdinal };
            });
            return _sortBy(extendedPlans, ['ordinal', 'subTypeOrdinal']);
        }
        return plans;
    }
    getPlansSort() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_ShowAncillaryPlans_PlansSort', null, [
            {
                ordinal: 1,
                planTypeAbbreviation: PlanTypeAbbreviation.MAPD
            },
            {
                ordinal: 2,
                planTypeAbbreviation: PlanTypeAbbreviation.MA
            },
            {
                ordinal: 3,
                planTypeAbbreviation: PlanTypeAbbreviation.MEDIGAP
            },
            {
                ordinal: 4,
                planTypeAbbreviation: PlanTypeAbbreviation.PDP
            },
            {
                ordinal: 5,
                planTypeAbbreviation: PlanTypeAbbreviation.DENTAL,
                planSubType: PlanSubTypes.Dental
            },
            {
                ordinal: 6,
                planTypeAbbreviation: PlanTypeAbbreviation.DENTAL,
                planSubType: PlanSubTypes.DentalVision
            },
            {
                ordinal: 7,
                planTypeAbbreviation: PlanTypeAbbreviation.DENTAL,
                planSubType: PlanSubTypes.DentalVisionHearing
            },
            {
                ordinal: 8,
                planTypeAbbreviation: PlanTypeAbbreviation.VISION,
                planSubType: PlanSubTypes.Vision
            },
            {
                ordinal: 9,
                planTypeAbbreviation: PlanTypeAbbreviation.HC
            }
        ]);
    }
    /**
     * This method does plan validation and kicks off enrollment process if the plan is valid
     * @param widgetName - widgetName.
     * @param action - function to be executed after current enrollment, in order to proceed to next enrollment.
     */
    async enroll(widgetName, crossSellModalCloseAction) {
        const planValidationObject = await this.validatePlans();
        if (planValidationObject.isValid) {
            this.enrollmentSettingsService.processEnrollmentSettings(PageTags.ENROLLMENT, widgetName, crossSellModalCloseAction);
        }
        else {
            this.openPlanNotAvailableModal().result.then(() => {
                if (planValidationObject.invalidPlans.length > 0) {
                    planValidationObject.invalidPlans.forEach(invalidPlan => {
                        this.shoppingCartService.removePlan(invalidPlan.plan.id);
                    });
                    this.store.dispatch(new SetActiveTab(planValidationObject.invalidPlans[0].plan.planTypeAbbreviation));
                }
                // Set override flag to false so we land on the active tab set above
                this.plansService.setOverrideActiveTab(false);
                this.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
            }, () => {
                // don't do anything if the user canceled
            });
        }
    }
    initLogoBaseUrl() {
        this.logoBaseUrl = this.plansService.getLogoBaseUrl();
    }
    // if logoUrl is defined, return logoUrl normalized with logoBaseUrl
    // otherwise, return logo2Url normalized with logoBaseUrl
    getPlanLogoUrl(plan) {
        let result = '';
        if (this.logoBaseUrl) {
            // normal path inits logoBaseUrl in at creation time
            if (plan) {
                if (plan.logoUrl) {
                    result = new URL(plan.logoUrl, this.logoBaseUrl).toString();
                }
                else {
                    if (plan.logo2Url) {
                        result = new URL(plan.logo2Url, this.logoBaseUrl).toString();
                    }
                }
            }
        }
        return result;
    }
    getPlanCarrierOrgOrGenericName(showCarrierGenericName, selectedPlan) {
        let carrierOrgOrGenericName = '';
        if (selectedPlan) {
            if (showCarrierGenericName) {
                carrierOrgOrGenericName =
                    selectedPlan.carrierInformation?.carrierName || selectedPlan.carrierName || selectedPlan.planCarrierFilter;
            }
            else {
                carrierOrgOrGenericName =
                    selectedPlan.carrierInformation?.organizationName || selectedPlan.organizationName || selectedPlan.planCarrierFilter;
            }
        }
        return carrierOrgOrGenericName;
    }
    getTotalPremium(plans, riders) {
        return this.plansService.getTotalPremium(plans, riders, this.showPremiumAsAnnual);
    }
    getPremiumLabel() {
        if (this.showPremiumAsAnnual) {
            return this.configResourceService.getProcessedResourceValue('Spa_Site_AnnualPremiumLabel') || 'Annual premium';
        }
        return this.configResourceService.getProcessedResourceValue('Spa_Site_MonthlyPremiumLabel') || 'Monthly premium';
    }
    getTotalPremiumLabel() {
        if (this.showPremiumAsAnnual) {
            return this.configResourceService.getProcessedResourceValue('Spa_Site_TotalAnnualPremiumLabel') || 'Total annual premium';
        }
        return this.configResourceService.getProcessedResourceValue('Spa_Site_TotalMonthlyPremiumLabel') || 'Total monthly premium';
    }
    navigateToMedSupForm(plan) {
        this.tagsToUpdate(DataLayerEvent.CLICK_PLANS_GET_QUOTE, plan?.id, plan?.planTypeAbbreviation, null, this.isVbcAgreementExists(plan));
        this.medSupService.navigateToMedSupForm();
    }
    navigateToDentalVisionForm(plan) {
        this.tagsToUpdate(DataLayerEvent.CLICK_PLANS_GET_QUOTE, plan.id, plan.planTypeAbbreviation, null, this.isVbcAgreementExists(plan));
        this.medSupService.navigateToDentalVisionForm(plan.planTypeAbbreviation);
    }
    areAllMedSupQuestionsAnswered(plan) {
        if (this.medSupService.isMedSupPlan(plan)) {
            return this.medSupService.areAllMedSupQuestionsAnswered();
        }
        return true;
    }
    hasPremium$(plan) {
        return this.medSupService.hasPremium$(plan);
    }
    getCostLabel(widgetName) {
        const showPremiumAsAnnual = this.configResourceService.getProcessedResourceValue('Spa_Site_ShowPremiumAsAnnual', null, false);
        if (showPremiumAsAnnual) {
            return this.configResourceService.getProcessedResourceValue('Spa_Cost_AnnualPremiumLabel', widgetName, 'yearly');
        }
        return this.configResourceService.getProcessedResourceValue('Spa_Cost_MonthlyPremiumLabel', widgetName, 'monthly');
    }
    getHosipitalCareBasePlanOptionText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_HIP_BasePlanOption_Text', widgetName, 'Base plan option');
    }
    getMedSupFormKey(questionName, value, widgetName) {
        const trimmedValue = value.trim().replace('-', '');
        const keyName = `Spa_MedSupForm_${questionName}${trimmedValue}_Text`;
        const defaultValue = MedSupKeyDefaults[keyName];
        return this.configResourceService.getProcessedResourceValue(keyName, widgetName, defaultValue);
    }
    updateMedSupFormOpen(isOpen, isGetQuote = false) {
        if (isGetQuote) {
            this.tagsToUpdate(DataLayerEvent.CLICK_PLANS_GET_QUOTE, null, PlanTypeAbbreviation.MEDIGAP);
        }
        this.medSupService.updateMedSupFormOpen(isOpen);
    }
    updateDentalVisionFormOpen(isOpen, planTypeAbbreviation, isGetQuote = false) {
        if (isGetQuote) {
            this.tagsToUpdate(DataLayerEvent.CLICK_PLANS_GET_QUOTE, null, planTypeAbbreviation);
        }
        this.medSupService.updateDentalVisionFormOpen(isOpen);
    }
    logRemoveFromQuoteTags(planId, planType, vbcAgreementStatus) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLANS_REMOVE_FROM_QUOTE,
            [DataLayerGlobalVariable.PLAN_ID]: '',
            [DataLayerGlobalVariable.PLAN_TYPE]: '',
            [DataLayerGlobalVariable.REMOVED_PLAN_ID]: planId ?? GOOGLE_ANALYTICS_NOT_APPLICABLE,
            [DataLayerGlobalVariable.REMOVED_PLAN_TYPE]: planType ?? GOOGLE_ANALYTICS_NOT_APPLICABLE,
            [DataLayerGlobalVariable.PLAN_PROVIDER_VBC_STATUS]: '',
            [DataLayerGlobalVariable.REMOVED_PLAN_PROVIDER_VBC_STATUS]: vbcAgreementStatus ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO
        };
    }
    tagsToUpdate(event, planId, planType, planCarrierName, vbcAgreementStatus) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: event,
            [DataLayerGlobalVariable.PLAN_ID]: planId ?? GOOGLE_ANALYTICS_NOT_APPLICABLE,
            [DataLayerGlobalVariable.PLAN_TYPE]: planType ?? GOOGLE_ANALYTICS_NOT_APPLICABLE,
            [DataLayerGlobalVariable.PLAN_CARRIER]: planCarrierName ?? GOOGLE_ANALYTICS_NOT_APPLICABLE,
            [DataLayerGlobalVariable.PLAN_PROVIDER_VBC_STATUS]: vbcAgreementStatus ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO
        };
    }
    getProductTypeFromPlanTypeAbbreviation(planTypeAbbreviation) {
        return this.plansService.getProductTypeFromPlanTypeAbbreviation(planTypeAbbreviation);
    }
    getSelectedDemographicCounty$() {
        return this.store.select(DemographicState.selectedCounty);
    }
    getSelectedPrimaryAddressCounty$() {
        return this.store.select(ProfileState.selectedPrimaryAddressCounty);
    }
    showMedSupAgeRestrictionBanner$() {
        return this.medSupService.showMedSupAgeRestrictionBanner$();
    }
    showMedSupEffectiveDateRestrictionBanner$() {
        return this.medSupService.showMedSupEffectiveDateRestrictionBanner$();
    }
    isMedSupPlan(plan) {
        return this.medSupService.isMedSupPlan(plan);
    }
    getEffectiveDateRestrictionText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_MedSup_EffectiveDate_Restriction_Text', widgetName, 'You can not currently enroll in plans because the requested effective date is more than 90 days away. ' +
            'You may look at plans and continue shopping. Please try enrolling when the effective is within 90 days.');
    }
    getNotTurning65AsOfEffectiveDateMonthText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_MedSup_NotTurning65_Restriction_Text', widgetName, 'Based on the age you entered, you will not be 65 years old in the the same month as the requested effective date.' +
            'If this is incorrect, please re-enter your date of birth');
    }
    getInsulinSavingsText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Filter_InsulinSavings_Text', widgetName, 'Insulin Savings');
    }
    getInsulinSavingsTooltip(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Filter_InsulinSavings_Tooltip', widgetName, '<div class="Spa_Style_H4"><b>Insulin savings</b></div>View Medicare’s Senior Savings Model plans which can help you save on insulin. Covered insulins in participating plans may not be more than a $35 copay for a one month supply. ');
    }
    getDentalLabel(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_DentalLabel_Text', widgetName, 'Dental');
    }
    getDentalTooltip(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_DentalTooltip_Text', widgetName, '');
    }
    getVisionLabel(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_VisionLabel_Text', widgetName, 'Vision');
    }
    getVisionTooltip(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_VisionTooltip_Text', widgetName, '');
    }
    getComboPlanLabel(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_ComboPlanLabel_Text', widgetName, 'Combo plan');
    }
    getComboPlanTooltip(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_ComboPlanTooltip_Text', widgetName, '<h4>Combo plan</h4><div>This plan may include any of the following coverages:  Dental, Vision, and Hearing.  Find more information on what this plan covers in the details.</div>');
    }
    hospitalCareAvailablePlans(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanDetails_HIP_Call_Out_Available_Plan_Types', widgetName, [
            {
                title: 'Medicare Advantage Prescription Drug',
                enabled: true,
                tabType: PlanTypeAbbreviation.MAPD
            },
            {
                title: 'Medicare Advantage',
                enabled: true,
                tabType: PlanTypeAbbreviation.MA
            },
            {
                title: 'Medicare Supplement',
                enabled: false,
                tabType: PlanTypeAbbreviation.MEDIGAP
            }
        ]);
    }
    // This method is used in other memoized methods and as such, it should remain pure
    isDentalPlan(plan) {
        return plan.planTypeAbbreviation === PlanTypeAbbreviation.DENTAL;
    }
    // This method is used in other memoized methods and as such, it should remain pure
    isVisionPlan(plan) {
        return plan.planTypeAbbreviation === PlanTypeAbbreviation.VISION;
    }
    // This method is used in other memoized methods and as such, it should remain pure
    isHCPlan(plan) {
        return plan?.planTypeAbbreviation === PlanTypeAbbreviation.HC;
    }
    // This method is used in other memoized methods and as such, it should remain pure
    isMedicareOnHospitalCare(plan, medicareTypes) {
        return !!medicareTypes?.find(availablePlan => availablePlan.tabType === plan.planTypeAbbreviation && availablePlan.enabled) ?? false;
    }
    insulinSavingsEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Filter_InsulinSavings_Enabled', widgetName, false);
    }
    planBenefitsFilterGroupEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Filter_PlanBenefitsGroup_Enabled', widgetName, false);
    }
    getShowCarrierGenericName(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Show_Carrier_Generic_Name', widgetName, false);
    }
    getFilterKeys(plans, hasMedSupAnswers, activeTabType, type) {
        const showCarrierGenericName = this.getShowCarrierGenericName();
        const insulinSavingsEnabled = this.insulinSavingsEnabled();
        const planBenefitsFilterGroupEnabled = this.planBenefitsFilterGroupEnabled();
        const getInsulinSavingsText = this.getInsulinSavingsText();
        const isExtraDataFilterKeyType = type === FilterKeyType.PLAN_EXTRADATA;
        const filterKeysMap = plans.reduce((filterControls, plan) => {
            const propValue = plan[type];
            let isPlanTypeEqualToActiveTabType = plan[FilterKeyType.PLAN_TYPE_SHORT] === activeTabType;
            let filterControl = this.getInsulinSavingsFilterControl(insulinSavingsEnabled, planBenefitsFilterGroupEnabled, isPlanTypeEqualToActiveTabType, getInsulinSavingsText, type, Object.keys(filterControls), plan.extraData);
            if (!filterControl && !isExtraDataFilterKeyType) {
                const planCarrierAndOrganizationData = this.getPlanCarrierAndOrganizationData(plan);
                // consider combo plans for both Dental and Vision plans
                isPlanTypeEqualToActiveTabType =
                    isPlanTypeEqualToActiveTabType ||
                        (ANCILLARY_PLANS.includes(activeTabType) && COMBO_PLANS.includes(plan[FilterKeyType.PLAN_SUB_TYPE]));
                filterControl = this.getFilterControl(propValue, hasMedSupAnswers, isPlanTypeEqualToActiveTabType, type, Object.keys(filterControls), showCarrierGenericName, planCarrierAndOrganizationData, plan.medicalPremium);
            }
            if (filterControl) {
                const filterKey = isExtraDataFilterKeyType ? getInsulinSavingsText : propValue;
                filterControls[filterKey] = filterControl;
            }
            return filterControls;
        }, {});
        return Object.values(filterKeysMap);
    }
    getDSNPFilterKeys(plans) {
        const dsnpCodes = [];
        const filterKeysMap = plans.reduce((filterControls, plan) => {
            const dsnpCoverageCode = plan.extraData?.find(data => data?.name === FilterKeyType.DSNP_COVERAGE_CODES);
            if (dsnpCoverageCode) {
                const codes = dsnpCoverageCode?.value?.split(',');
                codes.forEach((code) => {
                    if (!dsnpCodes.includes(code)) {
                        dsnpCodes.push(code);
                        filterControls[code] = this.getDSNPSubFilterControl(code);
                    }
                });
            }
            return filterControls;
        }, {});
        return Object.values(filterKeysMap);
    }
    getDSNPSubFilterControl(dsnpCoverageCode) {
        return { label: DSNPCodes[dsnpCoverageCode], value: dsnpCoverageCode, disabled: false };
    }
    getNestedFilterKeys(plans, activeTabType, type) {
        const pathKeys = type.split('.');
        const filterKeys = [];
        for (const plan of plans) {
            if (plan[FilterKeyType.PLAN_TYPE_SHORT] === activeTabType && plan.medicalPremium !== undefined && plan.medicalPremium !== null) {
                this.getTargetNestedObject(pathKeys, plan, filterKeys);
            }
        }
        return this.getFilterKeyList(filterKeys, type);
    }
    getTargetNestedObject(keys, data, filterKeys) {
        const key = keys[0];
        const nextKey = keys[1];
        if (data[key]) {
            if (Array.isArray(data[key])) {
                for (const propValue of data[key]) {
                    const targetKey = propValue[nextKey];
                    if (Array.isArray(propValue[nextKey])) {
                        const updatedKeys = keys.splice(1, keys.length);
                        this.getTargetNestedObject(updatedKeys, propValue, updatedKeys);
                    }
                    else if (!filterKeys.includes(targetKey)) {
                        filterKeys.push(targetKey);
                    }
                }
            }
            else {
                const targetKey = data[nextKey];
                if (keys.length > 1) {
                    const updatedKeys = keys.splice(1, keys.length);
                    this.getTargetNestedObject(updatedKeys, data[key], updatedKeys);
                }
                else if (!filterKeys.includes(targetKey)) {
                    filterKeys.push(targetKey);
                }
            }
            return filterKeys;
        }
    }
    getFilterKeyList(filterKeys, type) {
        return filterKeys.reduce((filterKeyList, filterKey) => {
            const filterControl = this.generateFilterControl(filterKey, type);
            if (filterControl) {
                filterKeyList.push(filterControl);
            }
            return filterKeyList;
        }, []);
    }
    getCurrentSortGroup(currentTabType) {
        const sortGroups = this.store.selectSnapshot(PlansState.sortGroups);
        return sortGroups.find(sortGroup => sortGroup.groupKey && sortGroup.groupKey.values[0] === currentTabType);
    }
    getCurrentSortType(currentTabType) {
        const selectedSortGroup = this.store
            .selectSnapshot(PlansState.sortGroups)
            .find(sortGroup => sortGroup.groupKey && sortGroup.groupKey.values[0] === currentTabType);
        return selectedSortGroup ? selectedSortGroup.sort : null;
    }
    getPageTag(label) {
        let tags = '';
        if (label === PlanDetailsCostLabels.DRUG_COST) {
            tags = PageTags.GUIDED_HELP_PRESCRIPTIONS;
        }
        else if (label === PlanDetailsCostLabels.HEALTH_COST) {
            tags = PageTags.GUIDED_HELP_HEALTH;
        }
        return tags;
    }
    isHealthCostEstimated() {
        const isHealthCostCustomizationEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_HealthCosts_Customization_Enabled', null, true);
        return isHealthCostCustomizationEnabled ? this.guidedHelpService.getHasHealthCostEstimateSelected() : true;
    }
    getCostSubText(planCostDetails, plan, selectedPharmacy) {
        let subText = planCostDetails.subText;
        if (planCostDetails.title === PlanDetailsCostLabels.HEALTH_COST) {
            const isHealthCostEstimated = this.guidedHelpService.getHasHealthCostEstimateSelected();
            const isHealthCostCustomizationEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_HealthCosts_Customization_Enabled', null, true);
            if (isHealthCostEstimated || !isHealthCostCustomizationEnabled) {
                subText = planCostDetails.subText.replace('<ageRange>', this.AgeLabel).replace('<healthStatus>', this.healthStatusLabel);
            }
            else {
                subText = this.configResourceService.getProcessedResourceValue('Spa_HealthCostsTab_Intro_Text', null, 'Add health information if you would like to view estimated annual costs');
            }
        }
        else if (planCostDetails.title === PlanDetailsCostLabels.DRUG_COST && plan.planRetailDrugCoverageMultiPharmacy?.length) {
            let retailDrugCoverage = plan.planRetailDrugCoverageMultiPharmacy;
            if (selectedPharmacy) {
                retailDrugCoverage = plan.planRetailDrugCoverageMultiPharmacy.filter(retailDrugCoverageMultiPharmacy => retailDrugCoverageMultiPharmacy.pharmacyNABP === selectedPharmacy.nabp);
            }
            const filteredDrugsCoverage = [];
            retailDrugCoverage.map(retailDrug => {
                if (!filteredDrugsCoverage.some(filteredDrug => filteredDrug.ndc === retailDrug.ndc)) {
                    filteredDrugsCoverage.push(retailDrug);
                }
            });
            subText = planCostDetails.subText.replace('<totalDrugs>', filteredDrugsCoverage.length.toString());
        }
        else if (planCostDetails.title === PlanDetailsCostLabels.TOTAL_ESTIMATED_COST) {
            const healthCostEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_HealthCosts_Enabled', null, true);
            if (!healthCostEnabled) {
                if (plan.planTypeAbbreviation === PlanTypeAbbreviation.MA || plan.planTypeAbbreviation === PlanTypeAbbreviation.MEDIGAP) {
                    subText = this.configResourceService.getProcessedResourceValue('Spa_PlanCost_TotalCost_HealthCostDisabled_MA_Subtext', null, 'Based on premium costs.');
                }
                else if (plan.planTypeAbbreviation === PlanTypeAbbreviation.MAPD) {
                    subText = this.configResourceService.getProcessedResourceValue('Spa_PlanCost_TotalCost_HealthCostDisabled_MAPD_Subtext', null, 'Based on premium and drug costs.');
                }
            }
        }
        else {
            subText = planCostDetails.subText.replace('<totalDrugs>', '0');
        }
        return subText;
    }
    removeHealthCostFromDetailCosts(costElements) {
        return costElements.filter(costElement => costElement.title !== PlanDetailsCostLabels.HEALTH_COST);
    }
    removeHealthCostFromDetailCostEquations(costElements) {
        return costElements.filter(costElement => costElement.title !== PlanDetailsCostLabels.HEALTH_COST);
    }
    removeHealthCostFromBenefits(costElements) {
        return costElements.filter(costElement => costElement.title !== PlanDetailsCostLabels.HEALTH_COST);
    }
    showCost(costLabel) {
        if (costLabel === PlanDetailsCostLabels.PREMIUM) {
            return true;
        }
        if (costLabel === PlanDetailsCostLabels.HEALTH_COST) {
            return !!this.configResourceService.getProcessedResourceValue('Spa_Site_HealthCosts_Enabled', null, true);
        }
        if (costLabel === PlanDetailsCostLabels.PLAN_FEES) {
            return this.plansService.getIsPlanFeesEnabled();
        }
        return this.configResourceService.getProcessedResourceValue('Spa_Site_TotalEstimatedCost_Enabled', null, true);
    }
    getSubsidyPercentage() {
        const selectedSubsidyPercent = this.store.selectSnapshot(DemographicState.subsidyPercent);
        return selectedSubsidyPercent;
    }
    getSubsidySelected() {
        const subsidySelected = this.store.selectSnapshot(DemographicState.subsidySelected);
        if (subsidySelected || subsidySelected === 0) {
            const getSubsidySelected = this.subsidyAccordionItems.find(item => item.id === subsidySelected.toString());
            return getSubsidySelected.title;
        }
    }
    getPlanPremiumRange(plan, planTotalPremium) {
        const subsidyValue = this.guidedHelpService.getSubsidySelected();
        const subsidyPercent = this.guidedHelpService.getSubsidyPercent();
        if (!subsidyValue &&
            subsidyValue !== SubsidySelected.DONT_KNOW &&
            !subsidyPercent &&
            planTotalPremium &&
            (plan.snpType === SNPBaseType.dSNP || plan.snpType === SNPBaseType.iSNP)) {
            return '$0 - ';
        }
        return '';
    }
    viewEnrollmentConfirmation(plan) {
        if (this.siteService.isRetentionView()) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_KEEP_PLAN);
        }
        const isSelectedPlanInCart = this.store
            .selectSnapshot(ShoppingCartState.selectedPlans)
            .map(p => p.id)
            .includes(plan.id);
        if (!isSelectedPlanInCart) {
            this.shoppingCartService.selectPlan(plan);
        }
        this.navigationService.navigateByPageTag(PageTags.ENROLLMENT_CONFIRMATION);
    }
    viewPlanDetailsPage(plan) {
        this.navigationService.navigateByPageTag(PageTags.PLAN_DETAILS, {
            queryParams: { id: plan.id }
        });
    }
    removePlanFromQuoteGroup(selectedGroup, plan) {
        this.logRemoveFromQuoteTags(plan.id, plan.planTypeAbbreviation, this.isVbcAgreementExists(plan));
        this.quoteService.removePlanFromQuoteGroup([selectedGroup], plan);
    }
    // isAlwaysHidden is for hiding and displaying in those pages where we share common template
    isAddToQuoteAvailable(activeTabType, plan, isAlwaysHidden) {
        const selectedPlanYear = parseInt(this.planYearResourceService.getSelectedPlanYear(), 10);
        const isAgentLoggedIn = this.agentService.isAgentLoggedIn();
        const hasSellingPermissions = plan ? this.canSellPlan(plan) : true;
        const hasAnswers = this.plansService.getHasMedSupAnswers();
        const isSelectedPlanYearLessThanOrEqualToPlanYear = plan?.planYear ? selectedPlanYear <= plan.planYear : true;
        return (hasSellingPermissions &&
            this.isAddToQuoteEnabled &&
            isAgentLoggedIn &&
            this.siteService.isPPCSite(this.siteType) &&
            isSelectedPlanYearLessThanOrEqualToPlanYear &&
            !isAlwaysHidden &&
            (activeTabType !== PlanTypeAbbreviation.MEDIGAP ||
                (activeTabType === PlanTypeAbbreviation.MEDIGAP && hasAnswers && this.isMedigapQuotingEnabled)));
    }
    isSendQuoteAvailable(activeTabType) {
        return (this.isAddToQuoteEnabled &&
            this.agentService.isAgentLoggedIn() &&
            this.siteService.isPPCSite(this.siteType) &&
            (activeTabType !== PlanTypeAbbreviation.MEDIGAP || (activeTabType === PlanTypeAbbreviation.MEDIGAP && this.isMedigapQuotingEnabled)));
    }
    async openSendQuoteModal(plan) {
        let plans = [];
        if (plan && Array.isArray(plan)) {
            plans = plan;
        }
        else if (plan && !Array.isArray(plan)) {
            plans = [plan];
        }
        else {
            const activeTab = this.store.selectSnapshot(PlansState.activeTabType);
            const quoteGroup = this.store.selectSnapshot(PlansState.quoteGroups);
            const activeTabQuoteGroup = quoteGroup.find(data => data.groupKey.values.find(key => key === activeTab));
            const activePlans = activeTabQuoteGroup.items;
            if (activePlans.length === 1 && !activePlans[0].documents?.length) {
                const detailedPlan = await this.plansService.fetchAndUpdatePlanDetails(activePlans[0]);
                plans = [detailedPlan];
            }
            else {
                plans = activePlans;
            }
        }
        const assignedAgentGuid = this.agentService.getCreatingAgentGuid();
        const currentAgentGuid = this.agentService.getAgentInContextGuid();
        const isProfileAdmin = this.agentService.getIsProfileAdmin();
        const currentAgentIsNotAssignedAgent = assignedAgentGuid && currentAgentGuid && assignedAgentGuid !== currentAgentGuid && isProfileAdmin;
        let planPermissions;
        if (currentAgentIsNotAssignedAgent) {
            this.spinnerService.show(SpinnerEvent.QUOTE_LOADING);
            const selectedPlanYear = this.planYearResourceService.getSelectedPlanYear() ?? new Date().getFullYear();
            const fips = this.demographicService.getSelectedFipsCode();
            const planPermissionsResult = await Promise.all(plans.map(async (plan) => {
                const effectiveDate = this.agentService.getPlanPermissionEffectiveDate(plan.planType);
                const planYear = plan && plan.planYear ? plan.planYear : +selectedPlanYear;
                const planPermission = await this.agentPermissionsService.hasPlanPermission(assignedAgentGuid, plan.id, planYear, effectiveDate, fips, true);
                return { planId: plan.id, planPermission };
            }));
            planPermissions = planPermissionsResult.reduce((selectedPlanPermissions, { planId, planPermission }) => {
                selectedPlanPermissions[planId] = {
                    hasPermission: planPermission
                };
                return selectedPlanPermissions;
            }, {});
            this.spinnerService.hide(SpinnerEvent.QUOTE_LOADING);
        }
        else {
            planPermissions = plans.reduce((selectedPlanPermissions, plan) => {
                selectedPlanPermissions[plan.id] = {
                    hasPermission: true
                };
                return selectedPlanPermissions;
            }, {});
        }
        this.sendQuoteFacade.showSendQuoteModal(plans, null, planPermissions);
    }
    navigateToSummary() {
        const isRetentionView = this.siteService.isRetentionView();
        const isQuotingSite = this.siteService.isQuotingSite();
        if (isRetentionView) {
            this.navigationService.navigateByPageTag(this.guidedHelpService.getRetentionDefaultPageTag());
        }
        else if (isQuotingSite) {
            this.navigationService.navigateByPageTag(PageTags.QUOTE_SUMMARY);
        }
    }
    hasRetentionPage() {
        return this.guidedHelpService.getRetentionDefaultPageTag() === PageTags.RETENTION_SUMMARY;
    }
    setActiveTab(planType) {
        this.store.dispatch(new SetActiveTab(planType));
    }
    getEnabledPlanAbbreviations(planTypes) {
        const sortedPlanTypesData = _sortBy(planTypes.filter(planType => planType.enabled), 'title');
        return sortedPlanTypesData.map(planTypeData => planTypeData.tabType);
    }
    async getPlanHasShortForm(planId) {
        const result = await this.plansService.fetchPlanShortFormSettings(planId);
        if (result?.length) {
            // if successful but the plan has no short form, the return will be [{}], so !! either a string or undefined will tell us if
            // we had a short form result or not
            return !!result[0].formId;
        }
    }
    getPlanShortFormSettings$(planId) {
        return this.plansService.getPlanShortFormSettings$(planId);
    }
    getPlanEnrollmentFormSettings$(planId, formType) {
        return this.plansService.fetchAllPlanEnrollmentSettings$(planId, formType);
    }
    getLiveEditPlans(widgetName) {
        // First attempt to get plans with MAPD from test data
        let statePlans;
        if (widgetName && widgetName.toLowerCase() === 'planlist') {
            statePlans = this.plansService.getAllPlans();
        }
        else {
            statePlans = this.store.selectSnapshot(PlansState.getPlansByPlanType(PlanTypeAbbreviation.MAPD));
        }
        // If no MAPD plans in test data, use default tab plantype
        if (!statePlans.length) {
            const defaultTab = this.getPlanListTabData().find(tab => tab.defaultActive);
            if (defaultTab?.tabTypes?.length) {
                statePlans = this.store.selectSnapshot(PlansState.getPlansByPlanType(defaultTab.tabTypes[0]));
            }
        }
        // If still no plans, find medicare plantype with most count and return those plans
        // This way compare plan always has at least 2 plans, unless test data only has 1 plan
        if (!statePlans.length) {
            const plans = this.plansService.getAllPlans();
            const medicarePlans = plans.filter(plan => plan.planTypeAbbreviation === PlanTypeAbbreviation.MA ||
                plan.planTypeAbbreviation === PlanTypeAbbreviation.MAPD ||
                plan.planTypeAbbreviation === PlanTypeAbbreviation.PDP);
            const planTypes = Object.entries(_groupBy(medicarePlans, 'planTypeAbbreviation')) // Array<[PlanType, PlanTypeCount]>
                .sort((x, y) => y[1].length - x[1].length) // Sort descending
                .map(group => group[0]); // Pick out the plantype
            if (planTypes?.length) {
                statePlans = medicarePlans.filter(plan => plan.planTypeAbbreviation === planTypes[0]);
            }
        }
        return statePlans;
    }
    getHospitalCareQuoteSummaryLiveEditPlans(plans) {
        const hospitalCareQuoteSummaryPlansMap = {
            medicare: [],
            hospitalCare: []
        };
        for (const plan of plans) {
            if (MEDICARE_PLAN_TYPES.includes(plan.planTypeAbbreviation) && hospitalCareQuoteSummaryPlansMap.medicare.length < 1) {
                hospitalCareQuoteSummaryPlansMap.medicare.push(plan);
            }
            else if (plan.planTypeAbbreviation === PlanTypeAbbreviation.HC && hospitalCareQuoteSummaryPlansMap.hospitalCare.length < 2) {
                hospitalCareQuoteSummaryPlansMap.hospitalCare.push(plan);
            }
            if (hospitalCareQuoteSummaryPlansMap.medicare.length === 1 && hospitalCareQuoteSummaryPlansMap.hospitalCare.length === 2) {
                break;
            }
        }
        return [...hospitalCareQuoteSummaryPlansMap.medicare, ...hospitalCareQuoteSummaryPlansMap.hospitalCare];
    }
    getPlan(planId) {
        return this.plansService.getPlan(planId);
    }
    async getPlanByPlanID(planId, planTypeID) {
        return await this.plansService
            .fetchPlansDetails$([planId], PlanType[planTypeID])
            .pipe(map(planData => planData[0]))
            .toPromise();
    }
    isVbcAgreementExists(plan) {
        return !!plan?.providers?.some(provider => provider.hasAgreement);
    }
    getPlanVbcAgreementCount(visiblePlans) {
        const vbcPlanCount = visiblePlans?.filter(plan => plan?.providers?.some(provider => provider?.hasAgreement))?.length;
        return vbcPlanCount ? vbcPlanCount.toString() : '0';
    }
    // add drug alternatives to "planRetailDrugCoverageMultiPharmacy" and returns the extended plan
    // plans are read-only and it's not required to persist the changes in the state, so we have to deep clone the plan in order to extend it
    extendPlanRetailDrugCoverageMultiPharmacyWithDrugAlternatives(plan, drugAlternatives, isMailOrder) {
        let extendedPlan = plan;
        if (drugAlternatives?.length > 0) {
            const drugAlternativesCoverage = drugAlternatives.map(drugAlternative => drugAlternative.drugCostDetails.formularyStatus);
            extendedPlan = _cloneDeep(plan);
            if (isMailOrder) {
                extendedPlan.planMailOrderDrugCoverage = [...(extendedPlan.planMailOrderDrugCoverage ?? []), ...drugAlternativesCoverage];
            }
            else {
                extendedPlan.planRetailDrugCoverageMultiPharmacy = [
                    ...(extendedPlan.planRetailDrugCoverageMultiPharmacy ?? []),
                    ...drugAlternativesCoverage
                ];
            }
        }
        return extendedPlan;
    }
    getDrugAlternatives$(planId, dosageId, conditionId, medicineCabinet, demographicsOptions) {
        return this.plansService
            .getDrugAlternatives$(planId, dosageId, conditionId, medicineCabinet, demographicsOptions)
            .pipe(map(drugs => drugs.map(drugFormularyStatus => this.mapDrugFormularyStatusToDrugAlternativeDetails(drugFormularyStatus))));
    }
    getAgeRangeKey() {
        const ageRangeKey = Object.keys(GuidedHelpAgeSelection).find(key => GuidedHelpAgeSelection[key] === this.store.selectSnapshot(DemographicState.ageRange));
        return ageRangeKey || null;
    }
    getHealthStatusKey() {
        const healthStatusKey = Object.keys(GuidedHelpHealthStatus).find(key => GuidedHelpHealthStatus[key] === this.store.selectSnapshot(DemographicState.healthStatus));
        return healthStatusKey || null;
    }
    canSellPlan(plan) {
        return this.plansService.canSellPlan(plan);
    }
    isPlanCommissionable(plan) {
        return this.plansService.isPlanCommissionable(plan);
    }
    isPlanProfessionalOnly(plan) {
        const professionalOnlyValue = this.getExtraDataValueByName(plan, PlanExtraDataKey.PROFESSIONAL_ONLY);
        return professionalOnlyValue ? JSON.parse(professionalOnlyValue.toLowerCase()) : false;
    }
    isMailOrderPharmacyAvailable(plans, widgetName) {
        if (!plans?.length) {
            return false;
        }
        const isMailOrderEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_Mail_Order_Pharmacy_Enabled', widgetName, false);
        return plans.some(plan => !!plan.hasMailDrugBenefits) && isMailOrderEnabled;
    }
    getEstimatedCost(plan, selectedPharmacy, isMailOrder) {
        if (plan) {
            let planAnnualCost = plan.planAnnualCost;
            if (isMailOrder) {
                planAnnualCost = plan.planAnnualMailOrderCost;
            }
            if (planAnnualCost?.annualCostMultiPharmacy?.length) {
                if (planAnnualCost.annualCostMultiPharmacy.length === 1) {
                    return planAnnualCost.annualCostMultiPharmacy[0];
                }
                const annualCost = planAnnualCost.annualCostMultiPharmacy.find(annualCostMultiPharmacy => selectedPharmacy && annualCostMultiPharmacy.pharmacyNABP === selectedPharmacy.nabp);
                if (annualCost) {
                    return annualCost;
                }
                return {};
            }
        }
        return {};
    }
    getTotalEstimatedCost(plan, selectedPharmacy, isMailOrder = false) {
        const cost = this.getEstimatedCost(plan, selectedPharmacy, isMailOrder);
        if (cost?.totalEstimatedCost) {
            return cost.totalEstimatedCost;
        }
        return 0;
    }
    getCalculatedBasePlanPremiumCost(plan) {
        return plan.calculatedBasePlanPremium ?? 0;
    }
    getHospitalCarePlanWithCalculatedBasePremium(plan) {
        return this.plansService.getHospitalCarePlanWithCalculatedBasePremium(plan);
    }
    getHospitalIndemnityBasePlanRiders(plan) {
        return this.plansService.getHospitalIndemnityBasePlanRiders(plan);
    }
    getHospitalIndemnityBasePlanSectionDetails(basePlanOptions) {
        return this.plansService.getHospitalIndemnityBasePlanSectionDetails(basePlanOptions);
    }
    getTotalAnnualDrugCostShare(plan, selectedPharmacy, isMailOrder = false) {
        const cost = this.getEstimatedCost(plan, selectedPharmacy, isMailOrder);
        if (cost?.totalAnnualDrugCostShare) {
            return cost.totalAnnualDrugCostShare;
        }
        return 0;
    }
    isTotalEstimatedCostAnnually$() {
        return this.store.select(PlansState.isTotalEstimatedCostAnnually);
    }
    isTotalEstimatedCostAnnually() {
        return this.store.selectSnapshot(PlansState.isTotalEstimatedCostAnnually);
    }
    isProviderSearchLoaded$() {
        return this.providerService.isProviderSearchLoaded$();
    }
    getProviders(planId, planProvidersDetails) {
        if (planProvidersDetails?.plans?.length && planId) {
            const plan = planProvidersDetails.plans.find(planProvidersDetail => planProvidersDetail.id === planId);
            if (plan) {
                return plan.providers;
            }
        }
        return [];
    }
    getProviderByVbcAgreement(plans, planProviderDetails, selectedProvider) {
        if (plans?.length) {
            for (const plan of plans) {
                const selectedProviderDetail = this.getSelectedProviderDetails(plan.id, planProviderDetails, selectedProvider);
                if (selectedProviderDetail?.hasAgreement) {
                    return selectedProviderDetail;
                }
            }
        }
    }
    getSelectedProviderDetails(planId, planProviderDetails, selectedProvider) {
        const providers = this.getProviders(planId, planProviderDetails);
        if (providers?.length) {
            let result = ProviderUtilityService.matchProviderDetailInfo({
                providerDetails: providers,
                selectedProvider,
                checkIfSameAddress: true
            });
            // On Zelis, the Networks response won't include out-of-network addresses.
            // If the selected provider's address is not part of the list, that means it is out-of-network. However, we still want to display the selected address.
            if (this.isZelisIntegrationEnabled && !result) {
                result = ProviderUtilityService.convertProviderToProviderDetails(selectedProvider);
            }
            return result;
        }
        return {};
    }
    isProviderLocationInNetwork(id, planProviderDetails, selectedProvider) {
        const providers = planProviderDetails.plans?.find((planResponse) => planResponse.id === id)?.providers || [];
        if (providers?.length) {
            const addresses = this.providerService.getProviderAddresses(providers, selectedProvider.npis[0]);
            return !!addresses?.some(address => address.inNetwork);
        }
        return false;
    }
    async addEffectiveDateInMemberSession() {
        if (this.configResourceService.getProcessedResourceValue('Spa_Site_TotalCostByEffectiveDate_Enabled', null, false)) {
            const sitePlanYear = this.getPlanYear();
            const currentDate = new Date();
            const currentMonth = currentDate.getMonth() + 1;
            const currentYear = currentDate.getFullYear();
            if (!this.store.selectSnapshot(MemberState.totalCostEffectiveDate)) {
                const isRetentionView = this.siteService.isRetentionView();
                let date;
                if (sitePlanYear > currentYear || (isRetentionView && DateUtilities.isAEP(currentMonth))) {
                    date = DateUtilities.getStartOfDateInFutureYear(currentDate.toString());
                }
                else {
                    date = DateUtilities.getFirstOfNextMonth(currentDate.toString());
                }
                await this.updateEffectiveDateAndTotalEstimatedCostStatus(date);
            }
            else {
                const totalCostEffectiveDate = this.store.selectSnapshot(MemberState.totalCostEffectiveDate);
                const effectiveDate = new Date(totalCostEffectiveDate);
                if (sitePlanYear === effectiveDate.getFullYear()) {
                    const isNotCostByEffectiveDate = !this.store.selectSnapshot(MemberState.costByEffectiveDate);
                    this.updateIsTotalEstimatedCostAnnuallyStatus(effectiveDate.getMonth());
                    if (isNotCostByEffectiveDate) {
                        this.store.dispatch(new SetIsCostByEffectiveDate(true));
                        // TODO: update all plantypes or individual plan types here?
                        this.setPlansDirty(true);
                    }
                }
                else {
                    const date = this.calculateEffectiveDate(this.getDefaultEffectiveDateOption(effectiveDate.getFullYear()));
                    await this.updateEffectiveDateAndTotalEstimatedCostStatus(date);
                }
            }
        }
    }
    setTotalEstimatedCostAnnually(isAnnually) {
        this.store.dispatch(new SetTotalEstimatedCostAnnually(isAnnually));
    }
    updateIsTotalEstimatedCostAnnuallyStatus(monthIndex) {
        if (monthIndex !== 0) {
            this.setTotalEstimatedCostAnnually(false);
        }
        else {
            this.setTotalEstimatedCostAnnually(true);
        }
    }
    getTotalEstimatedCostEffectiveDate() {
        if (this.configResourceService.getProcessedResourceValue('Spa_Site_TotalCostByEffectiveDate_Enabled', null, false)) {
            const effectiveDate = DateUtilities.getFormattedDateTime(new Date(this.dateService.getTotalCostEffectiveDate()), 'MMM YYYY', this.localeService.getCurrentLocale());
            const effectiveDateLabel = this.configResourceService.getProcessedResourceValue('Spa_Site_TotalEstimatedCost_EffectiveDate_Text', null, 'Effective');
            return `${effectiveDateLabel} ${effectiveDate}`;
        }
    }
    getIsSelectedEffectiveDate() {
        return this.store.selectSnapshot(UiState.isSelectedEffectiveDate);
    }
    getIsSelectedEffectiveDate$() {
        return this.store.select(UiState.isSelectedEffectiveDate);
    }
    async setDefaultEffectiveDate() {
        if (!this.getIsSelectedEffectiveDate()) {
            const defaultEffectiveDateOption = this.getDefaultEffectiveDateOption();
            const effectiveDate = this.calculateEffectiveDate(defaultEffectiveDateOption);
            if (effectiveDate) {
                await this.updateEffectiveDate(DateUtilities.getFormattedDateTime(effectiveDate));
            }
        }
        else {
            await this.addEffectiveDateInMemberSession();
        }
    }
    getStateCountyInformationalText$(isHelpfulToolsView) {
        if (isHelpfulToolsView) {
            return combineLatest([
                this.store.select(HelpfulToolsState.countyZipSelection),
                this.store.select(HelpfulToolsState.selectedFipsCode),
                this.store.select(HelpfulToolsState.counties),
                this.getForLabel$(),
                this.getCountyLabel$()
            ]).pipe(map(([zip, fips, counties, forLabel, countyLabel]) => {
                if (counties?.length) {
                    const selectedCounty = counties.length > 1 ? counties.find(county => county.countyFIPS === fips) : counties[0];
                    if (selectedCounty) {
                        return `${forLabel} ${selectedCounty.countyName} ${countyLabel?.toString().toLowerCase()}, ${selectedCounty.state}`;
                    }
                }
                return '';
            }));
        }
        return combineLatest([this.store.select(DemographicState.selectedCounty), this.getForLabel$(), this.getCountyLabel$()]).pipe(map(([county, forLabel, countyLabel]) => {
            if (county) {
                return `${forLabel} ${county.countyName} ${countyLabel?.toString().toLowerCase()}, ${county.state}`;
            }
            return '';
        }));
    }
    getForLabel$() {
        return this.locale$.pipe(map(locale => this.configResourceService.getProcessedResourceValue('Spa_ZipCodeInput_ForLabel_Text', null, 'for')));
    }
    getCountyLabel$() {
        return this.locale$.pipe(map(locale => this.configResourceService.getProcessedResourceValue('Spa_ZipCodeInput_CountyLabel_Text', null, 'county')));
    }
    async updateEffectiveDate(effectiveDate) {
        const totalCostEffectiveDate = this.store.selectSnapshot(MemberState.totalCostEffectiveDate);
        if (totalCostEffectiveDate !== effectiveDate) {
            const response = await this.memberSessionService.updateTotalCostEffectiveDateInSession(effectiveDate);
            if (response && response.status === HttpStatusCode.OK) {
                await this.store.dispatch([new UpdateTotalCostEffectiveDate(effectiveDate), new SetIsCostByEffectiveDate(true)]).toPromise();
                // TODO: update all plantypes or individual plan types here?
                this.setPlansDirty(true);
            }
        }
        else if (!this.store.selectSnapshot(MemberState.costByEffectiveDate)) {
            // If we didn't update totalCostEffectiveDate in session (same value) and costByEffectiveDate is false (default), we should update it
            this.store.dispatch(new SetIsCostByEffectiveDate(true));
        }
    }
    getDefaultEffectiveDateOption(effectiveDateYear) {
        const currentMonth = new Date().getMonth() + 1;
        const currentYear = new Date().getFullYear();
        const sitePlanYear = this.getPlanYear();
        // original ticket: SPA-7593
        // During AEP (Oct-Dec)
        if (DateUtilities.isAEP(currentMonth)) {
            // Shopping on a current plan year site or when the member's effective date year is higher than the site's plan year
            if (sitePlanYear === currentYear || effectiveDateYear > sitePlanYear) {
                // Edge case: show Total costs from Jan-Dec (the effective date dropdown won't be visible, as if the feature was configured off)
                // Default effective month is Jan of the current year. Other options are Feb-Dec of the current year
                if (currentMonth === 12) {
                    return DefaultEffectiveDateOption.FIRST_MONTH_OF_CURRENT_PLAN_YEAR;
                }
                // Show Total costs from next month until Dec of the current year
                // Default effective month is the next month. Other options are months remaining in that year
                return DefaultEffectiveDateOption.NEXT_MONTH;
            }
            // Shopping on a next plan year site, show Total costs from Jan-Dec of the next year
            // Default effective month is Jan of the next year. Other options are Feb-Dec of the next year
            return DefaultEffectiveDateOption.FIRST_MONTH_OF_NEXT_PLAN_YEAR;
        }
        // Outside of AEP (Jan-Sep)
        // Shopping on a next plan year site, show Total costs from Jan-Dec of the next year
        // Default effective month is Jan of the next year. Other options are Feb-Dec of the next year
        if (sitePlanYear > currentYear) {
            return DefaultEffectiveDateOption.FIRST_MONTH_OF_NEXT_PLAN_YEAR;
        }
        // Outside of AEP (Jan-Sep)
        // Shopping on a current plan year site, show Total costs from next month until Dec of the current year
        // Default effective month is the next month. Other options are months remaining in that year
        return DefaultEffectiveDateOption.NEXT_MONTH;
    }
    calculateEffectiveDate(defaultEffectiveDateOption) {
        const currentMonth = new Date().getMonth() + 1;
        const currentYear = new Date().getFullYear();
        const effectiveDateOptions = {
            // effective date should be the start of the next month of the current year
            [DefaultEffectiveDateOption.NEXT_MONTH]: () => new Date(`${currentMonth + 1}/1/${currentYear}`),
            // effective date should be the start of January of the current year
            [DefaultEffectiveDateOption.FIRST_MONTH_OF_CURRENT_PLAN_YEAR]: () => new Date(`1/1/${currentYear}`),
            // effective date should be the start of January of the next year
            [DefaultEffectiveDateOption.FIRST_MONTH_OF_NEXT_PLAN_YEAR]: () => new Date(`1/1/${currentYear + 1}`)
        };
        return effectiveDateOptions[defaultEffectiveDateOption]?.();
    }
    isLastMonthOfYear() {
        return new Date().getMonth() + 1 === 12;
    }
    getPlanYear(widgetName) {
        const selectedPlanYear = this.planYearResourceService.getSelectedPlanYear();
        return selectedPlanYear ? +selectedPlanYear : new Date().getFullYear();
    }
    getNonCoveredPlanTabMap$(tabs = this.getPlanListTabData(), hideEmptyPlanTabsBasedStates = this.getEmptyPlanTabsToHide()) {
        const nonCoveredPlanTabStatesRecord = this.getNonCoveredPlanTabStatesRecord(hideEmptyPlanTabsBasedStates);
        const selectedCounty$ = combineLatest([this.getSelectedDemographicCounty$(), this.getSelectedPrimaryAddressCounty$()]).pipe(map(([selectedDemographicCounty, selectedProfileCounty]) => selectedDemographicCounty || selectedProfileCounty));
        return combineLatest([selectedCounty$, this.getPlansSegmentedMetadataByTabsFilters$(tabs), this.quoteService.getQuotePlanIds$()]).pipe(filter(([countySelected, plansSegmentedMetadata, quotePlanIds]) => {
            const ignoreSelectedCounty = quotePlanIds?.length > 0 || this.siteService.isRetentionView();
            return ignoreSelectedCounty ? !!plansSegmentedMetadata : !!countySelected && !!plansSegmentedMetadata;
        }), map(([countySelected, plansSegmentedMetadata]) => {
            const nonCoveredPlanTabMap = plansSegmentedMetadata.reduce((hiddenNonCoveredPlanTypesByStates, planSegmentedMetadata) => {
                const { planTypeAbbreviation, planCount } = planSegmentedMetadata;
                hiddenNonCoveredPlanTypesByStates[planTypeAbbreviation] = {
                    display: !nonCoveredPlanTabStatesRecord[planTypeAbbreviation]?.includes(countySelected?.state) || planCount > 0,
                    planCount
                };
                if (planTypeAbbreviation === PlanTypeAbbreviation.MEDIGAP && this.plansService.showAllMedigapEnabled()) {
                    hiddenNonCoveredPlanTypesByStates[planTypeAbbreviation] = {
                        display: true,
                        planCount
                    };
                }
                return hiddenNonCoveredPlanTypesByStates;
            }, {});
            return nonCoveredPlanTabMap;
        }));
    }
    getHospitalIndemnityBasePlan(plan) {
        return this.plansService.getHospitalIndemnityBasePlan(plan);
    }
    sortRiders(riders, sortParam) {
        return this.plansService.sortRiders(riders, sortParam);
    }
    getPlansRiderBenefitCategories() {
        return this.plansService.getPlansRiderBenefitCategories();
    }
    getSelectedRiderBenefitCategories(plan) {
        const plansRiderBenefitCategories = this.getPlansRiderBenefitCategories();
        return plansRiderBenefitCategories[plan.id] ?? [];
    }
    updatePlansRiderBenefitCategories(planId, selectedRiderBenefitCategories) {
        this.store.dispatch(new UpdatePlansRiderBenefitCategories(planId, selectedRiderBenefitCategories));
    }
    getFormattedFullPlanId(plan) {
        return plan?.contractId && plan.planId && plan.segmentId ? `${plan.contractId}-${plan.planId}-${plan.segmentId}` : '';
    }
    convertToRiderCategory(rawRiderBenefitCategory, showCurrency = true) {
        // rawRiderBenefitCategory is an input to expect maximum 3 string items, first one is the rider name
        // second one amount per that rider and last one is the time recurrence
        // Example about rawRiderBenefitCategory param is the following:
        // ['Emergency Room Visit due to accident or injury', '150.00', 'per Day']
        const currencySign = showCurrency ? '$' : '';
        const benefitAmountValue = `${currencySign}${rawRiderBenefitCategory[1]} ${rawRiderBenefitCategory[2]}`;
        const riderCategory = {
            riderGroupKey: rawRiderBenefitCategory[0],
            icon: null,
            label: rawRiderBenefitCategory[0],
            waiverTooltip: null,
            waiverStateRider: false,
            selectable: false,
            riders: [
                {
                    planID: '',
                    planName: rawRiderBenefitCategory[0],
                    planType: 0,
                    planSubType: rawRiderBenefitCategory[0],
                    calculatedMedicalPremium: 0,
                    applicationFee: 0,
                    hasCalculatedMedicalPremium: false,
                    planTypeAbbreviation: '',
                    planTypeDescription: rawRiderBenefitCategory[0],
                    medicalPremium: 0,
                    mergedRiderIDs: [],
                    partnerRiders: [],
                    isRequiredRider: false,
                    isWaiverStateRider: false,
                    isPlanOptionsRider: false,
                    extendedPlanDetails: [
                        {
                            headerType: SectionHeaderType.ONE,
                            name: ExtendedPlanDetailsName.RIDER_BENEFITS,
                            toolTip: '',
                            ordinal: 1,
                            sectionDetails: [
                                {
                                    description: 'Benefit Amount',
                                    isEnrollLink: false,
                                    isExternalLink: false,
                                    isOutOfNetwork: false,
                                    linkName: '',
                                    name: 'Benefit Amount',
                                    ordinal: 1,
                                    value: benefitAmountValue,
                                    valueTypeID: PlanBenefitValueType.BENEFIT_VALUE
                                },
                                {
                                    description: 'Benefit Notes',
                                    isEnrollLink: false,
                                    isExternalLink: false,
                                    isOutOfNetwork: false,
                                    linkName: '',
                                    name: 'Benefit Notes',
                                    ordinal: 2,
                                    value: '',
                                    valueTypeID: PlanBenefitValueType.BENEFIT_VALUE
                                }
                            ]
                        }
                    ]
                }
            ],
            selectedRider: null
        };
        return riderCategory;
    }
    getHospitalIndemnityBenefitCategories(plan, riderCategories, selectedRiderBenefitCategories, basePlanOptionLabel) {
        let riderBenefitCategoriesForHospitalIndemnity = this.generateHospitalIndemnityBenefitCategories(riderCategories, plan, basePlanOptionLabel);
        if (selectedRiderBenefitCategories?.length > 0) {
            riderBenefitCategoriesForHospitalIndemnity = selectedRiderBenefitCategories.reduce((selectedRiderBenefitCategory, { riderGroupKey, selectedRiderId }) => this.updateRiderBenefitSelection(selectedRiderBenefitCategory, selectedRiderId, riderGroupKey), riderBenefitCategoriesForHospitalIndemnity);
        }
        return riderBenefitCategoriesForHospitalIndemnity;
    }
    updateRiderBenefitSelection(riderCategories, selectedRider, riderGroupKey) {
        const selectedRiderId = selectedRider?.planID ?? selectedRider;
        return riderCategories.map(riderCategory => {
            let result = riderCategory;
            if (riderCategory.riderGroupKey === riderGroupKey) {
                result = {
                    ...riderCategory,
                    selectedRider: selectedRiderId ? riderCategory.riders.find(rider => rider.planID === selectedRiderId) : null
                };
            }
            return result;
        });
    }
    getSelectedHospitalIndemnityBasePlanOptionRiderId(plan) {
        const selectedRiderBenefitCategories = this.getSelectedRiderBenefitCategories(plan);
        const [primaryBasePlanName, secondaryBasePlanName] = BASE_PLAN_HC_OPTION_NAMES;
        let selectedRiderBenefitCategory = selectedRiderBenefitCategories.find(({ riderGroupKey }) => riderGroupKey === primaryBasePlanName);
        if (!selectedRiderBenefitCategory) {
            selectedRiderBenefitCategory = selectedRiderBenefitCategories.find(({ riderGroupKey }) => riderGroupKey === secondaryBasePlanName);
        }
        return selectedRiderBenefitCategory?.selectedRiderId;
    }
    getCoveredDrugDosageIds(plan, isMailOrderSelected = false) {
        const hasPlanAndDrugCoverage = plan?.planTiers && plan.planTiers.length > 0;
        // Any formulary status that is not within the available plan tiers or 0 indicates that it is not covered.
        if (hasPlanAndDrugCoverage) {
            const planTier = plan.planTiers.find(tier => tier.pharmacyType === (isMailOrderSelected && plan.planMailOrderDrugCoverage ? PharmacyType.MailOrder : PharmacyType.Retail));
            if (planTier) {
                const availableTiers = planTier.tierInformation;
                const coveredTiers = availableTiers.map(tier => tier.tierNumber);
                if (isMailOrderSelected && plan.planMailOrderDrugCoverage) {
                    const planMailOrderDrugCoverage = plan.planMailOrderDrugCoverage;
                    return planMailOrderDrugCoverage
                        .filter(mailOrderDrugCoverage => coveredTiers.includes(mailOrderDrugCoverage.tierNumber))
                        .map(filteredMailOrderDrugCoverage => filteredMailOrderDrugCoverage.drugDosageID);
                }
                const selectedPharmacy = this.store.selectSnapshot(PharmacyState.selectedPharmacy);
                let planRetailDrugCoverage = plan.planRetailDrugCoverageMultiPharmacy;
                if (planRetailDrugCoverage) {
                    if (selectedPharmacy) {
                        planRetailDrugCoverage = planRetailDrugCoverage.filter(retailDrugCoverageMultiPharmacy => retailDrugCoverageMultiPharmacy.pharmacyNABP === selectedPharmacy.nabp);
                    }
                    return planRetailDrugCoverage
                        .filter(retailDrugCoverage => coveredTiers.includes(retailDrugCoverage.tierNumber))
                        .map(filteredRetailDrugCoverage => filteredRetailDrugCoverage.drugDosageID);
                }
            }
        }
        return [];
    }
    memberHasOptionsDefined() {
        const plans = this.plansService.getAllPlans();
        const options = plans.filter(p => p.modifiedNextYearPlanOrdinal >= 1);
        return !!options.length;
    }
    arePlansLoading$(planType) {
        return this.plansService.getPlansStateIsLoading$(planType);
    }
    parseRidersNotes(rider) {
        return (rider?.extendedPlanDetails[0]?.sectionDetails
            ?.find(sectionDetail => sectionDetail.name === BenefitType.BENEFIT_NOTES)
            ?.value.split(';')
            .map(sectionCategory => sectionCategory.trim().split('|'))
            .map(subSectionCategories => subSectionCategories.map(subSectionCategory => subSectionCategory.trim())) || []);
    }
    sortCategoriesBenefitAscending(categories, hospitalIndemnityBasePlanName) {
        return categories.sort((riderCategoryA, riderCategoryB) => {
            // place at the beginning the hospital indemnity base plan when we pass its rider group key
            // otherwise, perform an alphabetic sorting (ascending)
            if (hospitalIndemnityBasePlanName) {
                if (riderCategoryA.riderGroupKey === hospitalIndemnityBasePlanName) {
                    return -1;
                }
                if (riderCategoryB.riderGroupKey === hospitalIndemnityBasePlanName) {
                    return 1;
                }
            }
            return riderCategoryA.riderGroupKey > riderCategoryB.riderGroupKey ? 1 : -1;
        });
    }
    generateHospitalIndemnityBenefitCategories(riderCategoriesBase, plan, basePlanOptionLabel) {
        const hospitalIndemnityBasePlanRiders = this.getHospitalIndemnityBasePlan(plan);
        const hospitalIndemnityBasePlanName = hospitalIndemnityBasePlanRiders[0]?.planTypeDescription ?? '';
        const unsortedRiderBenefitCategories = this.getUnsortedHospitalIndemnityBenefitCategories(hospitalIndemnityBasePlanRiders[0], riderCategoriesBase, hospitalIndemnityBasePlanName, basePlanOptionLabel);
        const selectableRiderBenefitCategories = unsortedRiderBenefitCategories.filter(({ selectable }) => selectable);
        const includedRiderBenefitCategories = unsortedRiderBenefitCategories.filter(({ selectable }) => !selectable);
        const riderBenefitCategoriesForHospitalIndemnity = [
            ...this.sortCategoriesBenefitAscending(selectableRiderBenefitCategories, hospitalIndemnityBasePlanName),
            ...this.sortCategoriesBenefitAscending(includedRiderBenefitCategories)
        ];
        return riderBenefitCategoriesForHospitalIndemnity;
    }
    getRidersHospitalCareBasePlans(benefitsPlanCategories) {
        return benefitsPlanCategories.map(({ plan }) => this.getHospitalIndemnityBasePlan(plan));
    }
    getNamesHospitalCareBasePlans(benefitsCategoriesRiders) {
        return benefitsCategoriesRiders.map(riders => riders[0]?.planTypeDescription);
    }
    quoteHospitalCareBenefitCategories(benefitsPlanCategories, basePlanOptionLabel) {
        const plans = [];
        const hospitalCarePlansMap = benefitsPlanCategories.reduce((hospitalCareBenefitsMap, benefitPlanCategories) => {
            const selectedRiderBenefitCategories = this.getSelectedRiderBenefitCategories(benefitPlanCategories.plan);
            plans.push(benefitPlanCategories.plan);
            return {
                ...hospitalCareBenefitsMap,
                ...this.getHospitalCareQuoteBenefits(benefitPlanCategories.plan, benefitPlanCategories.categories, selectedRiderBenefitCategories, basePlanOptionLabel)
            };
        }, {});
        return this.generateQuoteListBenefitCategories(hospitalCarePlansMap, plans, this.hospitalCareAvailablePlans(), this.quoteHospitalCareMedicareMap);
    }
    displayAsClientDefinedOption(plan, displayOptionLabels) {
        return displayOptionLabels && (plan?.modifiedNextYearPlanOrdinal === 1 || plan?.modifiedNextYearPlanOrdinal === 2);
    }
    isNextYearPlan(plan) {
        return !!plan.isNextYearPlan && !plan.isPlanRolloverTerminated;
    }
    canDisplayLinkBorder(plan, displayOptionLabels) {
        return this.isNextYearPlan(plan) || this.displayAsClientDefinedOption(plan, displayOptionLabels);
    }
    isAddToCartAvailableForPlan(plan) {
        const showAddToCartForAncillaryPlans = this.configResourceService.getProcessedResourceValue('Spa_PlanCard_AncillaryAddtoCart_Enabled', null, false);
        const isAncillary = plan.planType === PlanType.HC || plan.planType === PlanType.DENTAL || plan.planType === PlanType.VISION;
        return !isAncillary || showAddToCartForAncillaryPlans;
    }
    getPharmacy(pharmacies, selectedPharmacy) {
        if (pharmacies?.length && selectedPharmacy) {
            return pharmacies.find(pharmacyCoverage => pharmacyCoverage && pharmacyCoverage.nabp === selectedPharmacy.nabp);
        }
        return {};
    }
    /*
     * This should be as string such as '01, 02, 04'
     */
    getDSNPCodesRawValue(plan) {
        return this.dsnpService.getDSNPCodesRawValue(plan);
    }
    /*
     * This should be an array such as ['01', '02', '04']
     */
    getDSNPCodesAsRawArray(plan) {
        return this.dsnpService.getDSNPCodesAsRawArray(plan);
    }
    /*
     * This should be a string such as 'QMB, QMB+, SLMB+'
     */
    getDSNPCodesAsTranslatedString(plan) {
        return this.dsnpService.getDSNPCodesAsTranslatedString(plan);
    }
    /*
     * This should be an array such as ['QMB', 'QMB+', 'SLMB+']
     */
    getDSNPCodesAsTranslatedArray(plan) {
        return this.dsnpService.getDSNPCodesAsTranslatedArray(plan);
    }
    openEditEnrollmentZipModal(cancelAction, confirmAction) {
        return this.plansService.openBackToPlansModal(this.configResourceService.getProcessedResourceValue('Spa_Enrollment_Edit_Zip_Title') || 'Update ZIP code', this.configResourceService.getProcessedResourceValue('Spa_Enrollment_Edit_Zip_Prompt') ||
            'Since your ZIP code determines the service area for your plan, you will need to go back to plans to shop plans in a new ZIP code.', this.configResourceService.getProcessedResourceValue('Spa_Enrollment_Edit_Zip_Cancel_Text') || 'Cancel', this.configResourceService.getProcessedResourceValue('Spa_Enrollment_Edit_Zip_Go_Back_Text') || 'Back to plans', cancelAction, confirmAction);
    }
    generateQuoteListBenefitCategories(hospitalCarePlansMap, plans, medicareTypes, quoteHospitalCareMedicareMap) {
        const optionalRidersPropertyName = 'optionalRiders';
        const includedRidersPropertyName = 'includedRiders';
        const uniqueOptionalRiderGroupKeys = this.getUniqueRiderGroupKeys(hospitalCarePlansMap, optionalRidersPropertyName);
        const uniqueIncludedRiderGroupKeys = this.getUniqueRiderGroupKeys(hospitalCarePlansMap, includedRidersPropertyName);
        const optionalRiderBenefitsRows = this.getQuoteRiderBenefitsRows(uniqueOptionalRiderGroupKeys, optionalRidersPropertyName, plans, hospitalCarePlansMap, medicareTypes, quoteHospitalCareMedicareMap);
        const includedRiderBenefitsRows = this.getQuoteRiderBenefitsRows(uniqueIncludedRiderGroupKeys, includedRidersPropertyName, plans, hospitalCarePlansMap, medicareTypes, quoteHospitalCareMedicareMap);
        return [
            ...this.sortCategoriesBenefitAscending(optionalRiderBenefitsRows),
            ...this.sortCategoriesBenefitAscending(includedRiderBenefitsRows)
        ];
    }
    // This method is used in other memoized methods and as such, it should remain pure
    getRiderBenefitCategoriesMap(riderBenefitCategories, filterPredicate) {
        return riderBenefitCategories
            .filter(filterPredicate)
            .reduce((riderBenefitCategoriesMap, riderBenefitCategory) => this.getRiderBenefitMap(riderBenefitCategoriesMap, riderBenefitCategory), {});
    }
    getHospitalCareQuoteBenefits(plan, categories, selectedRiderBenefitCategories, basePlanOptionLabel) {
        const hospitalCarePlansMap = {};
        const riderBenefitCategories = this.getHospitalIndemnityBenefitCategories(plan, categories, selectedRiderBenefitCategories, basePlanOptionLabel);
        const optionalRiders = this.getRiderBenefitCategoriesMap(riderBenefitCategories, riderBenefitCategory => riderBenefitCategory.selectable);
        const includedRiders = this.getRiderBenefitCategoriesMap(riderBenefitCategories, riderBenefitCategory => !riderBenefitCategory.selectable);
        hospitalCarePlansMap[plan.id] = {
            includedRiders,
            optionalRiders
        };
        return hospitalCarePlansMap;
    }
    getRiderBenefitMap(riderBenefitCategoriesMap, riderBenefitCategory) {
        return {
            ...riderBenefitCategoriesMap,
            [riderBenefitCategory.riderGroupKey]: riderBenefitCategory
        };
    }
    getUniqueRiderGroupKeys(hospitalCarePlansMap, property) {
        return Object.values(hospitalCarePlansMap).reduce((uniqueRiderGroupKeys, plan) => {
            const uniqueKeys = new Set([...uniqueRiderGroupKeys, ...Object.keys(plan[property])]);
            return Array.from(uniqueKeys);
        }, []);
    }
    getQuoteRiderBenefitsRows(riderGroupKeys, property, plans, hospitalIndemnityPlansMap, medicareTypes, quoteHospitalCareMedicareMap) {
        return riderGroupKeys.map(riderGroupKey => {
            const riderBenefitsPlans = plans.map(plan => hospitalIndemnityPlansMap[plan.id]?.[property]?.[riderGroupKey]);
            const existsMedicare = plans.find(plan => this.isMedicareOnHospitalCare(plan, medicareTypes));
            if (existsMedicare) {
                riderBenefitsPlans[0] = this.generateMedicareBenefit(plans[0], riderGroupKey, quoteHospitalCareMedicareMap);
            }
            return {
                riderGroupKey,
                riderBenefitsPlans
            };
        });
    }
    getUnsortedHospitalIndemnityBenefitCategories(hospitalIndemnityBasePlanRider, riderCategories, hospitalIndemnityBasePlanName, basePlanOptionLabel) {
        const basePlanRiderNotes = this.parseRidersNotes(hospitalIndemnityBasePlanRider);
        const missingCategories = basePlanRiderNotes.map(rawRiderBenefitCategory => this.convertToRiderCategory(rawRiderBenefitCategory));
        const benefitsCategoriesBase = riderCategories.map(riderCategory => {
            if (hospitalIndemnityBasePlanName === riderCategory.riderGroupKey) {
                riderCategory.label = basePlanOptionLabel;
            }
            return {
                ...riderCategory,
                selectable: riderCategory.riders.every(rider => rider.isPlanOptionsRider)
            };
        });
        return [...benefitsCategoriesBase, ...missingCategories];
    }
    generateMedicareBenefit(medicarePlan, riderGroupKey, quoteHospitalCareMedicareMap) {
        const medCategoryID = quoteHospitalCareMedicareMap[riderGroupKey];
        const medicareDataFields = medicarePlan.planDataFields.filter(planDataField => planDataField.benefitID === medCategoryID);
        if (medicareDataFields && medicareDataFields.length > 0) {
            const value = medicareDataFields.map(({ description }) => description).join(' ');
            return this.convertToRiderCategory([riderGroupKey, value, ''], false);
        }
        return null;
    }
    parseToMedicareRidersMap(quoteHospitalCareMedicareList) {
        return (quoteHospitalCareMedicareList?.reduce((record, quoteHospitalCareMedicare) => ({
            ...record,
            [quoteHospitalCareMedicare.hospitalCareRiderBenefit]: quoteHospitalCareMedicare.medicareCategoryId
        }), {}) || {});
    }
    async updateEffectiveDateAndTotalEstimatedCostStatus(date) {
        this.updateIsTotalEstimatedCostAnnuallyStatus(date.getMonth());
        const effectiveDate = DateUtilities.getFormattedDateTime(date);
        await this.updateEffectiveDate(effectiveDate);
    }
    async validatePlans() {
        const plansToValidate = this.store.selectSnapshot(ShoppingCartState.selectedPlans);
        const fipsCode = this.memberSessionService.getFipsCode();
        const zipCode = this.memberSessionService.getZipCode();
        const year = this.planYearResourceService.getSelectedPlanYear();
        const cultureCode = this.localeService.getCurrentLocale();
        const millimanServiceCalled = this.millimanService.hasMillimanServiceBeenCalledForPlan(plansToValidate);
        return await this.plansService.validatePlans(plansToValidate, fipsCode, zipCode, year, cultureCode, this.plansService.getMergedMedigapAnswers(), millimanServiceCalled);
    }
    openPlanNotAvailableModal() {
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true });
        confirmationModal.componentInstance.title =
            this.configResourceService.getProcessedResourceValue('Spa_PlanNotAvailableModal_Title') || 'Plan not available';
        confirmationModal.componentInstance.prompt =
            this.configResourceService.getProcessedResourceValue('Spa_PlanNotAvailableModal_Prompt') ||
                'This plan is no longer available for your service area and will be removed from your cart. Please shop for another plan.';
        confirmationModal.componentInstance.cancelButton =
            this.configResourceService.getProcessedResourceValue('Spa_PlanNotAvailableModal_Cancel') || 'Cancel';
        confirmationModal.componentInstance.confirmButton =
            this.configResourceService.getProcessedResourceValue('Spa_PlanNotAvailableModal_Confirm') || 'Shop for plans';
        return confirmationModal;
    }
    getInsulinSavingsFilterControl(insulinSavingsEnabled, planBenefitsFilterGroupEnabled, isPlanTypeEqualToActiveTabType, getInsulinSavingsText, type, filterControlKeys, extraData) {
        if (insulinSavingsEnabled &&
            planBenefitsFilterGroupEnabled &&
            !filterControlKeys.includes(getInsulinSavingsText) &&
            isPlanTypeEqualToActiveTabType &&
            type === FilterKeyType.PLAN_EXTRADATA &&
            extraData?.some(data => data?.name === FilterKeyType.MODEL_DRUG_PROGRAM && data?.value.toLocaleLowerCase() === 'true')) {
            return this.generateFilterControl(getInsulinSavingsText, type);
        }
    }
    getFilterControl(filterKey, hasMedSupAnswers, isPlanTypeEqualToActiveTabType, type, filterControlKeys, showCarrierGenericName, planCarrierAndOrganizationData, medicalPremium) {
        if (!filterControlKeys.includes(filterKey) &&
            (!hasMedSupAnswers || (medicalPremium !== undefined && medicalPremium !== null)) &&
            isPlanTypeEqualToActiveTabType &&
            type !== FilterKeyType.PLAN_EXTRADATA) {
            return this.generateFilterControl(filterKey, type, showCarrierGenericName, planCarrierAndOrganizationData);
        }
    }
    generateFilterControl(filterKey, type, showCarrierGenericName, planCarrierAndOrganizationData) {
        if (filterKey) {
            let label = filterKey;
            if (type === FilterKeyType.PLAN_CARRIER_NAME) {
                label = this.getPlanCarrierOrgOrGenericName(showCarrierGenericName, planCarrierAndOrganizationData);
            }
            return { label, value: filterKey, disabled: false };
        }
    }
    getPlanCarrierAndOrganizationData(plan) {
        const { carrierInformation, carrierName, planCarrierFilter, organizationName } = plan ?? {};
        const planCarrierAndOrganizationData = { carrierInformation, carrierName, planCarrierFilter, organizationName };
        return planCarrierAndOrganizationData;
    }
    mapDrugFormularyStatusToDrugAlternativeDetails(drugFormularyStatus) {
        const dosage = {
            ...drugFormularyStatus.dosageDetail,
            userQuantity: drugFormularyStatus.dosageDetail?.commonUserQuantity ?? 0,
            // We don't have this data available at the moment. It's being discussed in the ticket SPA-12475
            // SPA-12476: SPA Rest API - Alternatives endpoint - Add drugFlag and Dosage details
            daysOfSupply: drugFormularyStatus.dosageDetail?.daysOfSupply ?? 30 /* FrequencyValue.Month */,
            drugFlag: drugFormularyStatus.drugFlag
        };
        const drugCostDetails = {
            dosageId: drugFormularyStatus.drugDosageID,
            dosage,
            ndc: drugFormularyStatus.ndc,
            formularyStatus: drugFormularyStatus
        };
        const cabinetEntry = {
            dosageID: drugFormularyStatus.drugDosageID,
            dosage,
            drugId: drugFormularyStatus.drugID,
            labelName: drugFormularyStatus.labelName,
            isGenericAlternative: false
        };
        const drugAlternativeDetails = { cabinetEntry, drugCostDetails };
        // in case we get packages, it will be only the selected package for this dosage
        if (dosage.packages?.length) {
            cabinetEntry.packageId = dosage.packages[0].packageId;
        }
        return drugAlternativeDetails;
    }
    getNonCoveredPlanTabStatesRecord(planTabsHideStates) {
        return planTabsHideStates?.reduce((states, planTabsStatesHide) => ({
            ...states,
            [planTabsStatesHide.tabType]: planTabsStatesHide.states
        }), {});
    }
    getPlansSegmentedMetadataByTabsFilters$(tabs) {
        const planCountList$ = tabs.map(tab => {
            const tabType = PlansUtilityService.convertToPlanType(tab.tabTypes[0], false);
            return combineLatest([
                this.plansService.loaded$(tabType),
                this.plansService.getPlanCount$(tabType),
                this.plansService.getPlansLength$(tab.tabTypes[0])
            ]).pipe(map(([planLoaded, count, plansLength]) => ({
                planLoaded,
                count: !planLoaded ? count : plansLength,
                tabType
            })));
        });
        return combineLatest(planCountList$).pipe(distinctUntilChanged(_isEqual), map(countedPlanList => countedPlanList.map(({ count, tabType }) => {
            const metadata = {
                planCount: count,
                planTypeAbbreviation: PLAN_ABBREVIATION_TYPE_MAP[tabType]
            };
            return metadata;
        })));
    }
}
PlanFacade.ɵfac = function PlanFacade_Factory(t) { return new (t || PlanFacade)(i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.PlansService), i0.ɵɵinject(i1.NavigationService), i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(i1.ShoppingCartService), i0.ɵɵinject(i1.MedSupService), i0.ɵɵinject(i1.GuidedHelpService), i0.ɵɵinject(i1.QuoteService), i0.ɵɵinject(i1.AgentService), i0.ɵɵinject(SendQuoteFacade), i0.ɵɵinject(AnalyticsService), i0.ɵɵinject(i1.SiteService), i0.ɵɵinject(i1.MillimanService), i0.ɵɵinject(i1.EnrollmentSettingsService), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(i1.DateService), i0.ɵɵinject(i1.LocaleService), i0.ɵɵinject(i1.PlanYearResourceService), i0.ɵɵinject(i1.DemographicService), i0.ɵɵinject(i1.AgentPermissionsService), i0.ɵɵinject(i1.SpinnerService), i0.ɵɵinject(i1.DSNPService), i0.ɵɵinject(i1.ProviderService)); };
PlanFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlanFacade, factory: PlanFacade.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], PlanFacade.prototype, "getPlanCarrierOrgOrGenericName", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "getDSNPSubFilterControl", null);
__decorate([
    LiveEditInactive()
], PlanFacade.prototype, "viewEnrollmentConfirmation", null);
__decorate([
    LiveEditInactive()
], PlanFacade.prototype, "openSendQuoteModal", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "getHospitalCareQuoteSummaryLiveEditPlans", null);
__decorate([
    LiveEditInactive()
], PlanFacade.prototype, "addEffectiveDateInMemberSession", null);
__decorate([
    LiveEditInactive()
], PlanFacade.prototype, "updateEffectiveDate", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "getHospitalIndemnityBasePlan", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "convertToRiderCategory", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "getHospitalIndemnityBenefitCategories", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "updateRiderBenefitSelection", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "parseRidersNotes", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "sortCategoriesBenefitAscending", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "generateHospitalIndemnityBenefitCategories", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "canDisplayLinkBorder", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "getPharmacy", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "generateQuoteListBenefitCategories", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "getHospitalCareQuoteBenefits", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "getRiderBenefitMap", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "getUniqueRiderGroupKeys", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "getQuoteRiderBenefitsRows", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "getUnsortedHospitalIndemnityBenefitCategories", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "generateMedicareBenefit", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "parseToMedicareRidersMap", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "getInsulinSavingsFilterControl", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "getFilterControl", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "generateFilterControl", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "mapDrugFormularyStatusToDrugAlternativeDetails", null);
__decorate([
    Memoize()
], PlanFacade.prototype, "getNonCoveredPlanTabStatesRecord", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: i2.Store }, { type: i1.PlansService }, { type: i1.NavigationService }, { type: i1$1.NgbModal }, { type: i1.ShoppingCartService }, { type: i1.MedSupService }, { type: i1.GuidedHelpService }, { type: i1.QuoteService }, { type: i1.AgentService }, { type: SendQuoteFacade }, { type: AnalyticsService }, { type: i1.SiteService }, { type: i1.MillimanService }, { type: i1.EnrollmentSettingsService }, { type: i1.MemberSessionService }, { type: i1.DateService }, { type: i1.LocaleService }, { type: i1.PlanYearResourceService }, { type: i1.DemographicService }, { type: i1.AgentPermissionsService }, { type: i1.SpinnerService }, { type: i1.DSNPService }, { type: i1.ProviderService }]; }, { getPlanCarrierOrgOrGenericName: [], getDSNPSubFilterControl: [], viewEnrollmentConfirmation: [], openSendQuoteModal: [], getHospitalCareQuoteSummaryLiveEditPlans: [], addEffectiveDateInMemberSession: [], updateEffectiveDate: [], getHospitalIndemnityBasePlan: [], convertToRiderCategory: [], getHospitalIndemnityBenefitCategories: [], updateRiderBenefitSelection: [], parseRidersNotes: [], sortCategoriesBenefitAscending: [], generateHospitalIndemnityBenefitCategories: [], canDisplayLinkBorder: [], getPharmacy: [], generateQuoteListBenefitCategories: [], getHospitalCareQuoteBenefits: [], getRiderBenefitMap: [], getUniqueRiderGroupKeys: [], getQuoteRiderBenefitsRows: [], getUnsortedHospitalIndemnityBenefitCategories: [], generateMedicareBenefit: [], parseToMedicareRidersMap: [], getInsulinSavingsFilterControl: [], getFilterControl: [], generateFilterControl: [], mapDrugFormularyStatusToDrugAlternativeDetails: [], getNonCoveredPlanTabStatesRecord: [] }); })();

class HospitalIndemnityFormFacade {
    constructor(store, plansService, planFacade, navigationService, planYearResourceService) {
        this.store = store;
        this.plansService = plansService;
        this.planFacade = planFacade;
        this.navigationService = navigationService;
        this.planYearResourceService = planYearResourceService;
        this.hospitalIndemnityFormOpenSource$ = new BehaviorSubject(false);
    }
    getHospitalIndemnityQuestions$() {
        return this.plansService.getHospitalIndemnityQuestions$();
    }
    getHospitalIndemnityQuestions() {
        return this.plansService.getHospitalIndemnityQuestions();
    }
    getSortedHospitalIndemnityQuestions$() {
        return this.store.select(PlansState.sortedHospitalIndemnityQuestions(this.plansService.getHospitalIndemnityQuestionMetaData()));
    }
    getSortedHospitalIndemnityQuestions() {
        return this.store.selectSnapshot(PlansState.sortedHospitalIndemnityQuestions(this.plansService.getHospitalIndemnityQuestionMetaData()));
    }
    getFilteredHospitalIndemnityQuestionsMetaDataMap$() {
        return this.store.select(PlansState.hospitalIndemnityQuestionMetaDataMap(this.plansService.getHospitalIndemnityQuestionMetaData()));
    }
    getFilteredHospitalIndemnityQuestionsMetaDataMap() {
        return this.store.selectSnapshot(PlansState.hospitalIndemnityQuestionMetaDataMap(this.plansService.getHospitalIndemnityQuestionMetaData()));
    }
    getHospitalIndemnityAnswersMap$() {
        return this.store.select(PlansState.hospitalIndemnityAnswersMap);
    }
    getHospitalIndemnityAnswersMap() {
        return this.store.selectSnapshot(PlansState.hospitalIndemnityAnswersMap);
    }
    getHospitalIndemnityAnswers$() {
        return this.plansService.getHospitalIndemnityAnswers$();
    }
    getHospitalIndemnityAnswers() {
        return this.plansService.getHospitalIndemnityAnswers();
    }
    getHasHospitalIndemnityQuestions$() {
        return this.plansService.getHasHospitalIndemnityQuestions$();
    }
    getHasHospitalIndemnityQuestions() {
        return this.plansService.getHasHospitalIndemnityQuestions();
    }
    getHasHospitalIndemnityAnswers$() {
        return this.plansService.getHasHospitalIndemnityAnswers$();
    }
    getHasHospitalIndemnityAnswers() {
        return this.plansService.getHasHospitalIndemnityAnswers();
    }
    getAreAllHospitalIndemnityQuestionsAnswered$() {
        return this.plansService.getAreAllHospitalIndemnityQuestionsAnswered$();
    }
    getAreAllHospitalIndemnityQuestionsAnswered() {
        return this.plansService.getAreAllHospitalIndemnityQuestionsAnswered();
    }
    getHospitalIndemnityFormOpenSource$() {
        return this.hospitalIndemnityFormOpenSource$.asObservable();
    }
    getHospitalIndemnityPlansWithoutFilters$() {
        const plans$ = this.plansService.getFilteredPlansBySNPVisibility$();
        return plans$.pipe(map(plans => plans.filter(plan => plan.planTypeAbbreviation === PlanTypeAbbreviation.HC)));
    }
    getHospitalIndemnityPlanCount$() {
        return combineLatest([
            this.getHospitalIndemnityPlansWithoutFilters$(),
            this.plansService.getPlanCount$(PlanType.HC),
            this.store.select(PlansState.loaded(PlanType.HC))
        ]).pipe(map(([plans, count, loaded]) => (loaded ? plans.length : count)));
    }
    fetchHospitalIndemnityQuestions() {
        const fipsCode = this.store.selectSnapshot(DemographicState.selectedFipsCode);
        const zipCode = this.store.selectSnapshot(DemographicState.selectedZipCode);
        const year = this.planYearResourceService.getSelectedPlanYear();
        const effectiveDate = DateUtilities.getFormattedCurrentDate(); // TODO: get effectiveDate
        this.store.dispatch(new FetchHospitalIndemnityQuestions(zipCode, fipsCode, year, effectiveDate));
    }
    updateHospitalIndemnityFormOpen(isOpen, isGetQuote = false) {
        if (isGetQuote) {
            this.planFacade.tagsToUpdate(DataLayerEvent.CLICK_PLANS_GET_QUOTE, null, PlanTypeAbbreviation.HC);
        }
        if (isOpen) {
            this.fetchHospitalIndemnityQuestions();
        }
        this.hospitalIndemnityFormOpenSource$.next(isOpen);
    }
    setHospitalIndemnityFormOpenSource(isOpen) {
        if (isOpen !== this.hospitalIndemnityFormOpenSource$.getValue()) {
            this.hospitalIndemnityFormOpenSource$.next(isOpen);
        }
    }
    onHospitalIndemnityFormClose(fetchPlans) {
        const hasHospitalIndemnityAnswers = this.getHasHospitalIndemnityAnswers();
        if (fetchPlans || hasHospitalIndemnityAnswers) {
            this.updateHospitalIndemnityFormOpen(false);
            if (fetchPlans && hasHospitalIndemnityAnswers) {
                this.planFacade.updateMedSupFormOpen(false);
                this.planFacade.updateDentalVisionFormOpen(false);
            }
        }
    }
    navigateToHospitalIndemnityForm() {
        this.updateHospitalIndemnityFormOpen(true);
        this.store.dispatch(new SetActiveTab(PlanTypeAbbreviation.HC));
        // Set override flag to false so we land on the ActiveTab set above (HC)
        this.plansService.setOverrideActiveTab(false);
        this.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
    }
    async updateHospitalIndemnityPlanAnswers(questions) {
        await this.store.dispatch(new UpdateHospitalIndemnityPlanAnswers(questions)).toPromise();
        const planTypesUpdated = this.plansService.getPlanTypesUpdated(questions);
        this.store.dispatch(new SetPlansDirty(true, planTypesUpdated));
    }
    async selectHospitalIndemnityQuestions(sessionId, year, questions) {
        return this.plansService.selectPlanQuestions(sessionId, year, questions, ProductType.HC);
    }
    async getHospitalIndemnitySelectedQuestions(sessionId, year, updatedQuestions) {
        const filteredQuestions = this.getFilteredQuestions(updatedQuestions);
        return this.selectHospitalIndemnityQuestions(sessionId, year, filteredQuestions);
    }
    getRateFactorSessionDetails() {
        const rateFactorSessionDetails = {
            sessionId: this.store.selectSnapshot(MemberState.sessionId),
            year: this.planYearResourceService.getSelectedPlanYear()
        };
        return rateFactorSessionDetails;
    }
    getFilteredQuestions(questions) {
        const hospitalIndemnityQuestionsNames = Object.keys(this.getFilteredHospitalIndemnityQuestionsMetaDataMap());
        return questions.filter(question => hospitalIndemnityQuestionsNames.includes(question.name));
    }
}
HospitalIndemnityFormFacade.ɵfac = function HospitalIndemnityFormFacade_Factory(t) { return new (t || HospitalIndemnityFormFacade)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.PlansService), i0.ɵɵinject(PlanFacade), i0.ɵɵinject(i1.NavigationService), i0.ɵɵinject(i1.PlanYearResourceService)); };
HospitalIndemnityFormFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HospitalIndemnityFormFacade, factory: HospitalIndemnityFormFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HospitalIndemnityFormFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i2.Store }, { type: i1.PlansService }, { type: PlanFacade }, { type: i1.NavigationService }, { type: i1.PlanYearResourceService }]; }, null); })();

var ValidationErrors;
(function (ValidationErrors) {
    ValidationErrors["Required"] = "required";
    ValidationErrors["MinLength"] = "minlength";
    ValidationErrors["MaxLength"] = "maxlength";
    ValidationErrors["Mask"] = "mask";
    ValidationErrors["MinDate"] = "minDate";
    ValidationErrors["MaxDate"] = "maxDate";
    ValidationErrors["InvalidDate"] = "invalidDate";
})(ValidationErrors || (ValidationErrors = {}));

class MedSupFacade {
    constructor(giReasonsContextService, resourceService, store, medSupService) {
        this.giReasonsContextService = giReasonsContextService;
        this.resourceService = resourceService;
        this.store = store;
        this.medSupService = medSupService;
        this.defaultMaxPastMonths = 1200;
        this.defaultMaxFutureMonths = 3;
    }
    getFormattedGuaranteedIssueReasons() {
        const rawGuaranteedIssueReasons = this.giReasonsContextService.getGuaranteedIssueReasons();
        return rawGuaranteedIssueReasons
            .reduce((reasonCategories, reason) => {
            if (!reasonCategories.includes(reason.category)) {
                reasonCategories.push(reason.category);
            }
            return reasonCategories;
        }, [])
            .map((category, index) => {
            const item = rawGuaranteedIssueReasons.find(raw => raw.category === category);
            return {
                id: item.labelText === null ? item.keyName : index.toString(),
                title: category,
                verticalChildren: true,
                childItems: rawGuaranteedIssueReasons
                    .filter(reason => reason.category === category && reason.labelText !== null)
                    .map(reason => ({ title: reason.labelText, id: reason.keyName }))
            };
        });
    }
    getPartAEffectiveMaxFutureMonths() {
        const partAEffectiveMaxFutureMonths = this.resourceService.getProcessedResourceValue('Spa_MedSupForm_PartA_Effective_Max_Future_Months');
        return partAEffectiveMaxFutureMonths >= 0 ? partAEffectiveMaxFutureMonths : this.defaultMaxFutureMonths;
    }
    getPartBEffectiveMaxFutureMonths() {
        const partBEffectiveMaxFutureMonths = this.resourceService.getProcessedResourceValue('Spa_MedSupForm_PartB_Effective_Max_Future_Months');
        return partBEffectiveMaxFutureMonths >= 0 ? partBEffectiveMaxFutureMonths : this.defaultMaxFutureMonths;
    }
    getPartAEffectiveMaxPastMonths() {
        const partAEffectiveMaxPastMonths = this.resourceService.getProcessedResourceValue('Spa_MedSupForm_PartA_Effective_Max_Past_Months');
        return partAEffectiveMaxPastMonths >= 0 ? partAEffectiveMaxPastMonths : this.defaultMaxPastMonths;
    }
    getPartBEffectiveMaxPastMonths() {
        const partBEffectiveMaxPastMonths = this.resourceService.getProcessedResourceValue('Spa_MedSupForm_PartB_Effective_Max_Past_Months');
        return partBEffectiveMaxPastMonths >= 0 ? partBEffectiveMaxPastMonths : this.defaultMaxPastMonths;
    }
    getResourceMonthByIndex(indexMonth) {
        switch (indexMonth) {
            case 1:
                return 'Spa_Site_Total_Est_Cost_Month_1';
            case 2:
                return 'Spa_Site_Total_Est_Cost_Month_2';
            case 3:
                return 'Spa_Site_Total_Est_Cost_Month_3';
            case 4:
                return 'Spa_Site_Total_Est_Cost_Month_4';
            case 5:
                return 'Spa_Site_Total_Est_Cost_Month_5';
            case 6:
                return 'Spa_Site_Total_Est_Cost_Month_6';
            case 7:
                return 'Spa_Site_Total_Est_Cost_Month_7';
            case 8:
                return 'Spa_Site_Total_Est_Cost_Month_8';
            case 9:
                return 'Spa_Site_Total_Est_Cost_Month_9';
            case 10:
                return 'Spa_Site_Total_Est_Cost_Month_10';
            case 11:
                return 'Spa_Site_Total_Est_Cost_Month_11';
            case 12:
                return 'Spa_Site_Total_Est_Cost_Month_12';
            default:
                return 'Spa_Site_Total_Est_Cost_Month_1';
        }
    }
    getMonthList() {
        return [
            this.resourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_1') || 'January',
            this.resourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_2') || 'February',
            this.resourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_3') || 'March',
            this.resourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_4') || 'April',
            this.resourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_5') || 'May',
            this.resourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_6') || 'June',
            this.resourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_7') || 'July',
            this.resourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_8') || 'August',
            this.resourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_9') || 'September',
            this.resourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_10') || 'October',
            this.resourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_11') || 'November',
            this.resourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_12') || 'December'
        ];
    }
    getMonthsForDropdownParts(maxPastMonths, maxFutureMonths) {
        return DateUtilities.getMonthsFromFloorToCeil(maxPastMonths, maxFutureMonths);
    }
    checkError(date, dateOfBirth, maxFutureMonths, maxPastMonths, priorOrAfterDateValidationEnabled, partAEffectiveDate, partBEffectiveDate) {
        let error;
        if (date === '') {
            error = MedSupFormErrorTypes.REQUIRED;
        }
        else if (!DateUtilities.isValidDate(date)) {
            error = MedSupFormErrorTypes.INVALID;
        }
        else if (dateOfBirth && DateUtilities.dateBefore(date, dateOfBirth)) {
            error = MedSupFormErrorTypes.BEFORE_DOB;
        }
        else if (!DateUtilities.dateIsInFutureMonthRange(date, maxFutureMonths)) {
            error = MedSupFormErrorTypes.FUTURE_DATE;
        }
        else if (!DateUtilities.dateIsInPastMonthRange(date, maxPastMonths)) {
            error = MedSupFormErrorTypes.PAST_DATE;
        }
        else if (priorOrAfterDateValidationEnabled && partAEffectiveDate && DateUtilities.dateBefore(date, partAEffectiveDate)) {
            error = MedSupFormErrorTypes.BEFORE_PART_A_EFFECTIVE_DATE;
        }
        else if (priorOrAfterDateValidationEnabled && partBEffectiveDate && DateUtilities.dateAfter(date, partBEffectiveDate)) {
            error = MedSupFormErrorTypes.AFTER_PART_B_EFFECTIVE_DATE;
        }
        return error;
    }
    isGIReasonSelected(reasonName) {
        return this.medSupService.getIsGIReasonSelected(reasonName);
    }
    isGIReasonsSelected() {
        const giReasons = this.store.selectSnapshot(MedSupState.giReasons);
        if (giReasons && giReasons.length) {
            return giReasons.some(reason => reason.selected && reason.name !== GIREASONS_NO_REASON_KEY);
        }
        return false;
    }
    hasGIReasons() {
        return this.medSupService.hasGIReasons();
    }
    getGIReasons() {
        return this.medSupService.getGIReasons();
    }
    nonNullGIReasonIsSelected() {
        return this.medSupService.nonNullGIReasonIsSelected();
    }
    getRangeMonthList(monthYearRangePartAOrPartB, yearSelected) {
        let listOfMonths = [];
        listOfMonths = this.filterDropdownMonthYearByYear(monthYearRangePartAOrPartB, yearSelected);
        return listOfMonths.map(yearMonth => {
            const indexMonth = parseInt(yearMonth.split('/')[0], 10);
            const labelMonth = this.resourceService.getProcessedResourceValue(this.getResourceMonthByIndex(indexMonth));
            return labelMonth;
        });
    }
    isMedsupTobaccoApplicableStates() {
        const memberCounties = this.store.selectSnapshot(DemographicState.counties);
        if (memberCounties && memberCounties.length) {
            const medsupTobaccoApplicableStates = this.resourceService.getProcessedResourceValue('Spa_MedSupTobacco_Applicable_States', null, [
                'AR',
                'CA',
                'HI',
                'IL',
                'IA',
                'KY',
                'LA',
                'MD',
                'MI',
                'MO',
                'NH',
                'NJ',
                'NC',
                'ND',
                'OH',
                'PA',
                'SC',
                'TN',
                'UT',
                'VA',
                'WI'
            ]);
            return memberCounties.some(county => medsupTobaccoApplicableStates.includes(county.state));
        }
    }
    getYearsForDropdown(maxPastMonths = 0, maxFutureMonths = 0) {
        return DateUtilities.getYearsRange(maxPastMonths, maxFutureMonths);
    }
    getPlanSubTypes() {
        return this.medSupService.getPlanSubTypes();
    }
    updateSelectedPlanSubType(planSubType) {
        this.store.dispatch(new UpdateSelectedPlanSubType(planSubType));
    }
    getSelectedPlanSubType$() {
        return this.store.select(PlansState.selectedPlanSubType);
    }
    filterDropdownMonthYearByYear(monthYearPart, year) {
        return monthYearPart.filter(monthYear => monthYear.includes(year.toString()));
    }
}
MedSupFacade.ɵfac = function MedSupFacade_Factory(t) { return new (t || MedSupFacade)(i0.ɵɵinject(i1.GuaranteedIssueReasonsContextService), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.MedSupService)); };
MedSupFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MedSupFacade, factory: MedSupFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.GuaranteedIssueReasonsContextService }, { type: i1.ConfigResourceService }, { type: i2.Store }, { type: i1.MedSupService }]; }, null); })();

class RateFactorsFormService {
    constructor(store, configResourceService, planFacade, medSupFacade, profileFacade) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.planFacade = planFacade;
        this.medSupFacade = medSupFacade;
        this.profileFacade = profileFacade;
    }
    // Using a separate object to track non-API related data here to keep the model returned from the API
    // clean as it needs to be returned as is (plus answers model) for the answers call
    getDefaultValue(question, questionMetaDataMap) {
        const overwrittenDefaultValue = this.configResourceService.getProcessedResourceValue(`Spa_MedSupForm_${question.name}_DefaultValue`);
        let defaultValue;
        if (overwrittenDefaultValue !== null && overwrittenDefaultValue !== undefined) {
            defaultValue = overwrittenDefaultValue;
        }
        else {
            const profileValues = {
                [MedSupQuestionNames.DateOfBirth]: value => value || this.profileFacade.getMemberDateOfBirth(),
                [MedSupQuestionNames.Gender]: value => {
                    const gender = value || this.profileFacade.getMemberGender();
                    return gender !== Gender.NOT_PROVIDED ? gender : '';
                },
                [MedSupQuestionNames.ZipCode]: value => value || this.store.selectSnapshot(DemographicState.selectedZipCode),
                [MedSupQuestionNames.County_FIPS]: value => value || this.store.selectSnapshot(DemographicState.selectedFipsCode)
            };
            const questionMetaDataDefaultValue = questionMetaDataMap[question.name]?.defaultValue;
            defaultValue = profileValues[question.name]?.(questionMetaDataDefaultValue) ?? questionMetaDataDefaultValue;
        }
        return defaultValue;
    }
    getIsRequired(questionMetadata) {
        return questionMetadata?.required ?? true;
    }
    getIsHidden(questionMetadata, questionMetadataMap) {
        if (questionMetadata?.key === MedSupQuestionNames.Tobacco &&
            this.medSupFacade.isMedsupTobaccoApplicableStates() &&
            this.isGIQuestionsAvailable(questionMetadataMap) &&
            this.medSupFacade.nonNullGIReasonIsSelected()) {
            return true;
        }
        return questionMetadata?.hidden ?? false;
    }
    isGIQuestionsAvailable(questionMetadataMap) {
        return !!questionMetadataMap?.[MedSupQuestionNames.GuaranteedIssue];
    }
    getSortedQuestionUIDataMap(sortedQuestions, rateFactorQuestionMetadataMap, answersMap, ssoPopulatedRateFactorQuestionNames, rateFactorsForm) {
        return sortedQuestions.reduce((questionMetaDataMap, question) => {
            questionMetaDataMap[question.name] = this.getQuestionUIData(question, rateFactorQuestionMetadataMap, answersMap, ssoPopulatedRateFactorQuestionNames, rateFactorsForm);
            return questionMetaDataMap;
        }, {});
    }
    getQuestionUIData(question, questionMetadataMap, answersMap, ssoPopulatedRateFactorQuestionNames, rateFactorsForm) {
        const questionMetadata = questionMetadataMap[question.name];
        return {
            hidden: this.getIsHidden(questionMetadata, questionMetadataMap),
            required: this.getIsRequired(questionMetadata),
            ariaLabelledById: this.getAriaLabelledById(question.questionId),
            isPopulatedFromSSO: this.isPopulatedFromSSO(ssoPopulatedRateFactorQuestionNames, question.name),
            value: answersMap[question.name]?.value,
            defaultValue: this.getDefaultValue(question, questionMetadataMap),
            description: this.planFacade.getMedSupFormKey(question.name, 'Description'),
            tooltip: this.planFacade.getMedSupFormKey(question.name, 'Tooltip'),
            control: rateFactorsForm?.get(question.name)
        };
    }
    getAriaLabelledById(questionId) {
        return `question-name-${questionId}`;
    }
    isPopulatedFromSSO(ssoPopulatedRateFactorQuestionNames, questionName) {
        return ssoPopulatedRateFactorQuestionNames?.includes(questionName);
    }
    mapPrepopulatedFieldsToRateFactorQuestionNames(prePopulatedFields) {
        let rateFactorQuestionNames = [];
        if (prePopulatedFields?.length) {
            rateFactorQuestionNames = prePopulatedFields
                .map(prePopulatedField => {
                const ssoPopulatedFields = {
                    [SSOPopulatedField.GENDER]: MedSupQuestionNames.Gender,
                    [SSOPopulatedField.DEMOGRAPHIC_DATE_OF_BIRTH]: MedSupQuestionNames.DateOfBirth
                };
                return ssoPopulatedFields[prePopulatedField];
            })
                .filter(name => name);
        }
        return rateFactorQuestionNames;
    }
    getDaysBenefitMappings() {
        return this.store.selectSnapshot(PlansState.daysBenefitMappings);
    }
}
RateFactorsFormService.ɵfac = function RateFactorsFormService_Factory(t) { return new (t || RateFactorsFormService)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(PlanFacade), i0.ɵɵinject(MedSupFacade), i0.ɵɵinject(ProfileFacade)); };
RateFactorsFormService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RateFactorsFormService, factory: RateFactorsFormService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RateFactorsFormService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i2.Store }, { type: i1.ConfigResourceService }, { type: PlanFacade }, { type: MedSupFacade }, { type: ProfileFacade }]; }, null); })();

class RateFactorEffectiveDateService {
    constructor(configResourceService) {
        this.configResourceService = configResourceService;
        this.displayFormat = 'MMMM YYYY';
    }
    getDisplayFormat() {
        return this.displayFormat;
    }
    getShowEffectiveDateAsDropdown(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_ShowEffectiveDateAsDropdown_Flag', widgetName, true);
    }
    getShowCurrentMonth(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_ShowCurrentMonthInEffectiveDateDropdown_Flag', widgetName, true);
    }
    getMaxMonthsInFuture(widgetName) {
        return parseInt(this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_EffectiveDateNumberOfMonths_Count', widgetName, 12), 10);
    }
    getListOfMonths(widgetName) {
        const listOfMonths = DateUtilities.getFirstOfFutureMonths(this.getMaxMonthsInFuture(widgetName) + 1);
        if (!this.getShowCurrentMonth(widgetName)) {
            listOfMonths.shift();
        }
        return listOfMonths;
    }
    getFormattedMonth(month, displayFormat, locale) {
        return DateUtilities.getFormattedDateTime(month, displayFormat, locale);
    }
    getMinEffectiveDate(widgetName) {
        const date = this.getShowCurrentMonth(widgetName) ? dayjs().startOf('month') : dayjs().add(1, 'months').startOf('month');
        return DateUtilities.parseDayJSToNgbDate(date);
    }
    getMaxEffectiveDate(widgetName) {
        const date = dayjs().add(this.getMaxMonthsInFuture(widgetName), 'months').endOf('month');
        return DateUtilities.parseDayJSToNgbDate(date);
    }
}
RateFactorEffectiveDateService.ɵfac = function RateFactorEffectiveDateService_Factory(t) { return new (t || RateFactorEffectiveDateService)(i0.ɵɵinject(i1.ConfigResourceService)); };
RateFactorEffectiveDateService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RateFactorEffectiveDateService, factory: RateFactorEffectiveDateService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RateFactorEffectiveDateService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.ConfigResourceService }]; }, null); })();

class RateFactorsFormFacade {
    constructor(formValidationService, configResourceService, rateFactorsFormService, rateFactorEffectiveDateService) {
        this.formValidationService = formValidationService;
        this.configResourceService = configResourceService;
        this.rateFactorsFormService = rateFactorsFormService;
        this.rateFactorEffectiveDateService = rateFactorEffectiveDateService;
        this.errorMessages = {
            [MedSupQuestionNames.DateOfBirth]: {
                [MedSupFormErrorTypes.REQUIRED]: (widgetName) => this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_NoBirthDateError_Text', widgetName, 'Please provide a valid date of birth'),
                [MedSupFormErrorTypes.INVALID]: (widgetName) => this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_NoBirthDateError_Text', widgetName, 'Please provide a valid date of birth'),
                [MedSupFormErrorTypes.FUTURE_DATE]: (widgetName) => this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_FutureBirthDateError_Text', widgetName, 'Please provide a date of birth in the past'),
                [MedSupFormErrorTypes.PAST_DATE]: (widgetName) => this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_BirthDateOutOfRangeError_Text', widgetName, 'The date of birth is too far in the past')
            },
            [MedSupQuestionNames.EffectiveDate]: {
                [MedSupFormErrorTypes.REQUIRED]: (widgetName) => this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_InvalidEffectiveDateError_Text', widgetName, 'Please provide a valid effective date'),
                [MedSupFormErrorTypes.INVALID]: (widgetName) => this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_InvalidEffectiveDateError_Text', widgetName, 'Please provide a valid effective date'),
                [MedSupFormErrorTypes.FUTURE_DATE]: (widgetName) => this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_TooFarInFutureEffectiveDateError_Text', widgetName, 'Effective Date is too far in the future'),
                [MedSupFormErrorTypes.PAST_DATE]: (widgetName) => this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_TooFarInPastEffectiveDateError_Text', widgetName, 'Please provide an effective date in the future')
            },
            [MedSupQuestionNames.Gender]: {
                [MedSupFormErrorTypes.REQUIRED]: (widgetName) => this.configResourceService.getProcessedResourceValue('Spa_MedSup_GenderRequiredError_Text', widgetName, 'Please specify gender')
            },
            [MedSupQuestionNames.Tobacco]: {
                [MedSupFormErrorTypes.REQUIRED]: (widgetName) => this.configResourceService.getProcessedResourceValue('Spa_MedSup_TobaccoRequiredError_Text', widgetName, 'Please specify tobacco use')
            },
            [MedSupQuestionNames.Household]: {
                [MedSupFormErrorTypes.REQUIRED]: (widgetName) => this.configResourceService.getProcessedResourceValue('Spa_MedSup_HouseholdRequiredError_Text', widgetName, 'Please specify if you will be signing up a spouse')
            },
            [MedSupQuestionNames.HCDaysCovered]: {
                [MedSupFormErrorTypes.REQUIRED]: (widgetName) => this.configResourceService.getProcessedResourceValue('Spa_MedSup_HCDaysCoveredRequiredError_Text', widgetName, 'Please specify number of days')
            },
            [MedSupQuestionNames.BenefitAmount]: {
                [MedSupFormErrorTypes.REQUIRED]: (widgetName) => this.configResourceService.getProcessedResourceValue('Spa_MedSup_BenefitAmountRequiredError_Text', widgetName, 'Please specify benefit amount')
            }
        };
        this.formatErrorKeys = [
            ValidationErrors.Mask,
            ValidationErrors.MinLength,
            ValidationErrors.MaxLength,
            ValidationErrors.InvalidDate
        ];
        this.questionSizes = {
            toggle: 'col-6 col-sm-4 col-lg-3',
            small: 'col-6 col-sm-4 col-lg-3',
            medium: 'col-12 col-sm-8 col-lg-6',
            large: 'col-12'
        };
        this.embeddedQuestionSizes = {
            toggle: 'col-12 col-sm-6 col-lg-4',
            small: 'col-12 col-sm-6 col-lg-4',
            medium: 'col-12 col-sm-8 col-lg-6',
            large: 'col-12'
        };
        this.positionRelativeExtraTopClasses = 'position-relative extra-top';
    }
    getRateFactorsForm(options, component) {
        const { questionUIDataMap } = options;
        return Object.entries(questionUIDataMap).reduce((formGroup, [name, { value, defaultValue, required }]) => {
            const validatorOptions = this.getValidatorOptions(required, name, options);
            const validators = this.getValidatorFn(validatorOptions, component);
            const control = VnextFormControl.create({
                name,
                formState: value || defaultValue,
                validatorOrOpts: { validators, updateOn: 'blur' }
            });
            formGroup.addControl(name, control);
            questionUIDataMap[name].control = control;
            return formGroup;
        }, new VnextFormGroup({}));
    }
    getErrorMessages(control, widgetName) {
        const errors = {};
        if (control.dirty || control.touched) {
            if (control.hasError(ValidationErrors.Required)) {
                errors[MedSupFormErrorTypes.REQUIRED] = this.errorMessages[control.name][MedSupFormErrorTypes.REQUIRED](widgetName);
            }
            else if (this.hasControlSomeError(control, this.formatErrorKeys)) {
                errors[MedSupFormErrorTypes.INVALID] = this.errorMessages[control.name][MedSupFormErrorTypes.INVALID](widgetName);
            }
            else if (control.hasError(ValidationErrors.MaxDate)) {
                errors[MedSupFormErrorTypes.FUTURE_DATE] = this.errorMessages[control.name][MedSupFormErrorTypes.FUTURE_DATE](widgetName);
            }
            else if (control.hasError(ValidationErrors.MinDate)) {
                errors[MedSupFormErrorTypes.PAST_DATE] = this.errorMessages[control.name][MedSupFormErrorTypes.PAST_DATE](widgetName);
            }
        }
        return errors;
    }
    isControlInvalid(control) {
        return control.invalid && (control.dirty || control.touched);
    }
    hasControlSomeError(control, errorKeys) {
        return errorKeys.some(errorKey => control.hasError(errorKey));
    }
    getDateMaskFormat() {
        return DateUtilities.defaultFormat.replace('DD', 'd0').replace('MM', 'M0').replace('YYYY', '0000');
    }
    markFormAsTouched(form) {
        Object.values(form.controls).forEach(control => {
            control.markAsTouched();
            control.updateValueAndValidity();
        });
    }
    getQuestionClasses(isEmbedded = false) {
        return {
            [MedSupQuestionNames.DateOfBirth]: isEmbedded ? this.embeddedQuestionSizes.small : this.questionSizes.small,
            [MedSupQuestionNames.EffectiveDate]: isEmbedded ? this.embeddedQuestionSizes.small : this.questionSizes.small,
            [MedSupQuestionNames.Gender]: isEmbedded ? this.embeddedQuestionSizes.toggle : this.questionSizes.toggle,
            [MedSupQuestionNames.Tobacco]: isEmbedded ? this.embeddedQuestionSizes.toggle : this.questionSizes.toggle,
            [MedSupQuestionNames.Household]: isEmbedded ? this.embeddedQuestionSizes.toggle : this.questionSizes.toggle,
            [MedSupQuestionNames.ZipCode]: isEmbedded ? this.embeddedQuestionSizes.small : this.questionSizes.small,
            [MedSupQuestionNames.County_FIPS]: isEmbedded ? this.embeddedQuestionSizes.small : this.questionSizes.small,
            [MedSupQuestionNames.HCDaysCovered]: isEmbedded ? this.embeddedQuestionSizes.small : this.questionSizes.small,
            [MedSupQuestionNames.BenefitAmount]: isEmbedded ? this.embeddedQuestionSizes.small : this.questionSizes.small
        };
    }
    addPositionRelativeExtraTopToDropdownQuestionsClasses(questionsClasses, showEffectiveDateAsDropdown) {
        const dropdownQuestions = [
            MedSupQuestionNames.EffectiveDate,
            MedSupQuestionNames.HCDaysCovered,
            MedSupQuestionNames.BenefitAmount
        ];
        for (const questionName of dropdownQuestions) {
            const questionClasses = questionsClasses[questionName];
            if (questionClasses &&
                ((questionName === MedSupQuestionNames.EffectiveDate && showEffectiveDateAsDropdown) ||
                    questionName !== MedSupQuestionNames.EffectiveDate)) {
                questionsClasses[questionName] = `${questionClasses} ${this.positionRelativeExtraTopClasses}`;
            }
        }
        return questionsClasses;
    }
    getSortedQuestionUIDataMap(sortedQuestions, rateFactorQuestionMetadataMap, answersMap, ssoPopulatedRateFactorQuestionNames, rateFactorsForm) {
        return this.rateFactorsFormService.getSortedQuestionUIDataMap(sortedQuestions, rateFactorQuestionMetadataMap, answersMap, ssoPopulatedRateFactorQuestionNames, rateFactorsForm);
    }
    mapPrepopulatedFieldsToRateFactorQuestionNames(prePopulatedFields) {
        return this.rateFactorsFormService.mapPrepopulatedFieldsToRateFactorQuestionNames(prePopulatedFields);
    }
    getEffectiveDateListOfMonths(widgetName, displayFormat, locale = 'en') {
        return this.rateFactorEffectiveDateService.getListOfMonths(widgetName).map(month => ({
            displayValue: this.rateFactorEffectiveDateService.getFormattedMonth(month, displayFormat, locale),
            selectionValue: this.rateFactorEffectiveDateService.getFormattedMonth(month, DateUtilities.defaultFormat, locale)
        }));
    }
    getNumberOfDaysDropdownItems(widgetName) {
        return this.configResourceService
            .getProcessedResourceValue('Spa_HIPForm_NumberOfDays_Data', widgetName, [])
            .map(dropdownItem => ({ displayValue: dropdownItem.display, selectionValue: dropdownItem.value }));
    }
    updateQuestionsAnswers(outdatedQuestions, rateFactorFormAnswers) {
        return outdatedQuestions.map(question => ({
            ...question,
            value: rateFactorFormAnswers[question.name] ?? question.value
        }));
    }
    getDaysBenefitMappings() {
        return this.rateFactorsFormService.getDaysBenefitMappings();
    }
    getValidatorOptions(required, controlName, options) {
        const { minBirthDate, maxBirthDate, minEffectiveDate, maxEffectiveDate, showEffectiveDateAsDropdown } = options;
        let isDateField = false;
        let minDate;
        let maxDate;
        if (controlName === MedSupQuestionNames.DateOfBirth) {
            isDateField = true;
            minDate = minBirthDate;
            maxDate = maxBirthDate;
        }
        else if (controlName === MedSupQuestionNames.EffectiveDate && !showEffectiveDateAsDropdown) {
            isDateField = true;
            minDate = minEffectiveDate;
            maxDate = maxEffectiveDate;
        }
        return { required, isDateField, minDate, maxDate };
    }
    getValidatorFn(options, component) {
        const { required, isDateField, minDate, maxDate } = options;
        const validators = [];
        const skipInitialCheck = true;
        if (required) {
            validators.push(Validators.required);
        }
        if (isDateField) {
            validators.push(this.formValidationService.validDate());
            if (minDate) {
                validators.push(this.formValidationService.minDate({ minDate }));
            }
            if (maxDate) {
                validators.push(this.formValidationService.maxDate({ maxDate }));
            }
        }
        return FormValidationService.validateOnSubmit(validators, component, skipInitialCheck);
    }
}
RateFactorsFormFacade.ɵfac = function RateFactorsFormFacade_Factory(t) { return new (t || RateFactorsFormFacade)(i0.ɵɵinject(i1.FormValidationService), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(RateFactorsFormService), i0.ɵɵinject(RateFactorEffectiveDateService)); };
RateFactorsFormFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RateFactorsFormFacade, factory: RateFactorsFormFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RateFactorsFormFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.FormValidationService }, { type: i1.ConfigResourceService }, { type: RateFactorsFormService }, { type: RateFactorEffectiveDateService }]; }, null); })();

class RateFactorToggleService {
    constructor(planFacade) {
        this.planFacade = planFacade;
    }
    getToggleItems(question, widgetName) {
        return question.answerList.map(answer => ({
            display: this.planFacade.getMedSupFormKey(question.name, answer, widgetName),
            value: answer
        }));
    }
}
RateFactorToggleService.ɵfac = function RateFactorToggleService_Factory(t) { return new (t || RateFactorToggleService)(i0.ɵɵinject(PlanFacade)); };
RateFactorToggleService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RateFactorToggleService, factory: RateFactorToggleService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RateFactorToggleService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: PlanFacade }]; }, null); })();

class FieldErrorComponent {
}
FieldErrorComponent.ɵfac = function FieldErrorComponent_Factory(t) { return new (t || FieldErrorComponent)(); };
FieldErrorComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FieldErrorComponent, selectors: [["vnext-widget-field-error"]], inputs: { error: "error" }, decls: 2, vars: 1, template: function FieldErrorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "span");
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.error);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FieldErrorComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-field-error', changeDetection: ChangeDetectionStrategy.OnPush, template: "<span>{{ error }}</span>\r\n" }]
    }], null, { error: [{
            type: Input
        }] }); })();

function FieldErrorsComponent_ng_container_0_span_2_vnext_widget_field_error_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-field-error", 6);
} if (rf & 2) {
    const error_r5 = ctx.$implicit;
    i0.ɵɵproperty("error", error_r5);
} }
function FieldErrorsComponent_ng_container_0_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "i", 4);
    i0.ɵɵtemplate(2, FieldErrorsComponent_ng_container_0_span_2_vnext_widget_field_error_2_Template, 1, 1, "vnext-widget-field-error", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.errors);
} }
function FieldErrorsComponent_ng_container_0_ng_template_3_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 4)(2, "vnext-widget-field-error", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r7 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("error", error_r7);
} }
function FieldErrorsComponent_ng_container_0_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FieldErrorsComponent_ng_container_0_ng_template_3_div_0_Template, 3, 1, "div", 7);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.errors);
} }
function FieldErrorsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵtemplate(2, FieldErrorsComponent_ng_container_0_span_2_Template, 3, 1, "span", 2);
    i0.ɵɵtemplate(3, FieldErrorsComponent_ng_container_0_ng_template_3_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r2 = i0.ɵɵreference(4);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showInline)("ngIfElse", _r2);
} }
class FieldErrorsComponent {
    constructor() {
        this.showInline = true;
    }
}
FieldErrorsComponent.ɵfac = function FieldErrorsComponent_Factory(t) { return new (t || FieldErrorsComponent)(); };
FieldErrorsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FieldErrorsComponent, selectors: [["vnext-widget-field-errors"]], inputs: { errors: "errors", showInline: "showInline" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "error-color"], [4, "ngIf", "ngIfElse"], ["showList", ""], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle", "mr-1"], [3, "error", 4, "ngFor", "ngForOf"], [3, "error"], [4, "ngFor", "ngForOf"]], template: function FieldErrorsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, FieldErrorsComponent_ng_container_0_Template, 5, 2, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.errors && ctx.errors.length > 0);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, IconAriaAttributesDirective, FieldErrorComponent], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FieldErrorsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-field-errors', template: "<ng-container *ngIf=\"errors && errors.length > 0\">\r\n  <div class=\"error-color\">\r\n    <span *ngIf=\"showInline; else showList\"\r\n      ><i class=\"fas fa-exclamation-circle mr-1\" aria-hidden=\"true\"></i>\r\n      <vnext-widget-field-error *ngFor=\"let error of errors\" [error]=\"error\"></vnext-widget-field-error>\r\n    </span>\r\n    <ng-template #showList>\r\n      <div *ngFor=\"let error of errors\">\r\n        <i class=\"fas fa-exclamation-circle mr-1\" aria-hidden=\"true\"></i>\r\n        <vnext-widget-field-error [error]=\"error\"></vnext-widget-field-error>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n</ng-container>\r\n" }]
    }], null, { errors: [{
            type: Input
        }], showInline: [{
            type: Input
        }] }); })();

const _c0$3Y = ["datePickerInput"];
const _c1$26 = function (a0) { return { "px-sm-0": a0 }; };
function DatePickerInputComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "vnext-widget-field-errors", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1$26, ctx_r0.inlineLayout));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("errors", ctx_r0.errors)("showInline", false);
} }
const _c2$1i = function (a0, a1) { return { "pr-3 mb-sm-0": a0, "label-error": a1 }; };
function DatePickerInputComponent_label_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("for", ctx_r1.ariaLabelledById)("ngClass", i0.ɵɵpureFunction2(3, _c2$1i, ctx_r1.inlineLayout, ctx_r1.isControlInvalid));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.inputLabel, " ");
} }
function DatePickerInputComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "input", 10, 11);
    i0.ɵɵlistener("ngModelChange", function DatePickerInputComponent_ng_container_8_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.dateValue = $event); })("dateSelect", function DatePickerInputComponent_ng_container_8_Template_input_dateSelect_1_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.selectDate($event)); })("select", function DatePickerInputComponent_ng_container_8_Template_input_select_1_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.selectDate($event)); })("closed", function DatePickerInputComponent_ng_container_8_Template_input_closed_1_listener() { i0.ɵɵrestoreView(_r7); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.onBlur()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 12)(4, "button", 13);
    i0.ɵɵlistener("click", function DatePickerInputComponent_ng_container_8_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r7); const _r5 = i0.ɵɵreference(2); return i0.ɵɵresetView(_r5.toggle()); });
    i0.ɵɵelement(5, "i", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("placement", "bottom")("positionTarget", _r3)("minDate", ctx_r4.minDate)("maxDate", ctx_r4.maxDate)("ngModel", ctx_r4.dateValue);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", ctx_r4.isReadOnly);
    i0.ɵɵattribute("aria-label", ctx_r4.datePickerButtonLabelText);
} }
const _c3$X = function (a0) { return { "d-flex flex-column align-items-center": a0 }; };
const _c4$A = function (a0) { return { "d-flex w-100 flex-column flex-sm-row": a0 }; };
const _c5$l = function (a0) { return { "pr-sm-3": a0 }; };
const _c6$k = function (a0, a1) { return { "has-error": a0, "Spa_Style_Gray4_Color readonly": a1 }; };
class DatePickerInputComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.isReadOnly = false;
        this.showDatePicker = true;
        this.placeholder = DateUtilities.defaultFormat.toLowerCase();
        this.dateSelect = new EventEmitter();
        this.datePickerInputBlur = new EventEmitter();
        this.subscriptions = new Subscription();
        this.isControlInvalid = false;
    }
    ngOnInit() {
        this.onControlValueChanges();
        this.onControlStatusChanges();
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    selectDate(ngbDate) {
        const formattedDate = DateUtilities.getDefaultFormattedDate(ngbDate);
        this.control.setValue(formattedDate);
        this.control.markAsDirty();
        this.control.updateValueAndValidity();
    }
    onBlur() {
        this.control.markAsTouched();
        this.datePickerInputBlur.emit();
    }
    onControlValueChanges() {
        this.subscriptions.add(this.control.valueChanges.subscribe({
            next: (value) => {
                this.dateValue = DateUtilities.parseDateToNgbDate(value);
                this.dateSelect.emit(this.dateValue);
            }
        }));
    }
    onControlStatusChanges() {
        this.subscriptions.add(this.control.statusChanges.subscribe({
            next: () => {
                this.isControlInvalid = this.control.invalid && (this.control.dirty || this.control.touched);
                this.cdr.markForCheck();
            }
        }));
    }
}
DatePickerInputComponent.ɵfac = function DatePickerInputComponent_Factory(t) { return new (t || DatePickerInputComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
DatePickerInputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DatePickerInputComponent, selectors: [["vnext-datepicker-input"]], viewQuery: function DatePickerInputComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3Y, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.datePickerInput = _t.first);
    } }, inputs: { control: "control", inputLabel: "inputLabel", inlineLayout: "inlineLayout", dateMaskFormat: "dateMaskFormat", minDate: "minDate", maxDate: "maxDate", errors: "errors", ariaDescribedById: "ariaDescribedById", ariaLabelledById: "ariaLabelledById", datePickerButtonLabelText: "datePickerButtonLabelText", isReadOnly: "isReadOnly", showDatePicker: "showDatePicker", placeholder: "placeholder" }, outputs: { dateSelect: "dateSelect", datePickerInputBlur: "datePickerInputBlur" }, decls: 9, vars: 23, consts: [[3, "ngClass"], ["class", "error-container mb-1 d-flex align-items-end Spa_Style_Small_Font", 3, "ngClass", 4, "ngIf"], ["class", "align-self-sm-center Spa_Style_Label", 3, "for", "ngClass", 4, "ngIf"], [1, "input-group", 3, "ngClass"], ["type", "text", "ngbAutofocus", "", "inputmode", "numeric", "maxlength", "10", "autocomplete", "off", "aria-required", "true", "tabindex", "0", 1, "form-control", "rounded-right", 3, "id", "formControl", "placeholder", "mask", "dropSpecialCharacters", "readonly", "ngClass", "blur"], ["datePickerInput", "", "dateInput", ""], [4, "ngIf"], [1, "error-container", "mb-1", "d-flex", "align-items-end", "Spa_Style_Small_Font", 3, "ngClass"], [3, "errors", "showInline"], [1, "align-self-sm-center", "Spa_Style_Label", 3, "for", "ngClass"], ["type", "hidden", "aria-hidden", "true", "ngbDatepicker", "", "tabindex", "-1", 3, "placement", "positionTarget", "minDate", "maxDate", "ngModel", "ngModelChange", "dateSelect", "select", "closed"], ["datePicker", "ngbDatepicker"], [1, "input-group-append"], ["type", "button", "tabindex", "0", 1, "btn", "btn-calendar", 3, "disabled", "click"], [1, "fas", "fa-calendar-alt"]], template: function DatePickerInputComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, DatePickerInputComponent_div_1_Template, 2, 5, "div", 1);
        i0.ɵɵelementStart(2, "div", 0);
        i0.ɵɵtemplate(3, DatePickerInputComponent_label_3_Template, 2, 6, "label", 2);
        i0.ɵɵelementStart(4, "div", 3)(5, "input", 4, 5);
        i0.ɵɵlistener("blur", function DatePickerInputComponent_Template_input_blur_5_listener() { return ctx.onBlur(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, DatePickerInputComponent_ng_container_8_Template, 6, 7, "ng-container", 6);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c3$X, ctx.inlineLayout));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isControlInvalid && (ctx.errors == null ? null : ctx.errors.length) > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c4$A, ctx.inlineLayout));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputLabel);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c5$l, ctx.inlineLayout));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("id", ctx.ariaLabelledById)("formControl", ctx.control)("placeholder", ctx.placeholder)("mask", ctx.dateMaskFormat)("dropSpecialCharacters", false)("readonly", ctx.isReadOnly)("ngClass", i0.ɵɵpureFunction2(20, _c6$k, ctx.isControlInvalid, ctx.isReadOnly));
        i0.ɵɵattribute("aria-describedby", ctx.ariaDescribedById);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.showDatePicker);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.DefaultValueAccessor, i4.NgControlStatus, i4.MaxLengthValidator, i4.NgModel, i4.FormControlDirective, i1$1.NgbInputDatepicker, i8.MaskDirective, IconAriaAttributesDirective, FieldErrorsComponent], styles: [".btn-calendar[_ngcontent-%COMP%]{position:absolute;border:none;margin-left:-38px;z-index:3}.btn-calendar[_ngcontent-%COMP%]:focus{outline:none;box-shadow:none!important}.label-error[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent2)}.error-container[_ngcontent-%COMP%]{min-height:35px;max-height:35px;line-height:18px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatePickerInputComponent, [{
        type: Component,
        args: [{ selector: 'vnext-datepicker-input', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div [ngClass]=\"{ 'd-flex flex-column align-items-center': inlineLayout }\">\r\n  <div\r\n    class=\"error-container mb-1 d-flex align-items-end Spa_Style_Small_Font\"\r\n    *ngIf=\"isControlInvalid && errors?.length > 0\"\r\n    [ngClass]=\"{ 'px-sm-0': inlineLayout }\"\r\n  >\r\n    <vnext-widget-field-errors [errors]=\"errors\" [showInline]=\"false\"></vnext-widget-field-errors>\r\n  </div>\r\n\r\n  <div [ngClass]=\"{ 'd-flex w-100 flex-column flex-sm-row': inlineLayout }\">\r\n    <label\r\n      *ngIf=\"inputLabel\"\r\n      class=\"align-self-sm-center Spa_Style_Label\"\r\n      [for]=\"ariaLabelledById\"\r\n      [ngClass]=\"{ 'pr-3 mb-sm-0': inlineLayout, 'label-error': isControlInvalid }\"\r\n    >\r\n      {{ inputLabel }}\r\n    </label>\r\n\r\n    <div class=\"input-group\" [ngClass]=\"{ 'pr-sm-3': inlineLayout }\">\r\n      <input\r\n        #datePickerInput\r\n        type=\"text\"\r\n        ngbAutofocus\r\n        inputmode=\"numeric\"\r\n        maxlength=\"10\"\r\n        class=\"form-control rounded-right\"\r\n        autocomplete=\"off\"\r\n        aria-required=\"true\"\r\n        tabindex=\"0\"\r\n        #dateInput\r\n        [id]=\"ariaLabelledById\"\r\n        [formControl]=\"control\"\r\n        [placeholder]=\"placeholder\"\r\n        [mask]=\"dateMaskFormat\"\r\n        [dropSpecialCharacters]=\"false\"\r\n        [attr.aria-describedby]=\"ariaDescribedById\"\r\n        [readonly]=\"isReadOnly\"\r\n        [ngClass]=\"{ 'has-error': isControlInvalid, 'Spa_Style_Gray4_Color readonly': isReadOnly }\"\r\n        (blur)=\"onBlur()\"\r\n      />\r\n      <ng-container *ngIf=\"showDatePicker\">\r\n        <input\r\n          #datePicker=\"ngbDatepicker\"\r\n          type=\"hidden\"\r\n          aria-hidden=\"true\"\r\n          ngbDatepicker\r\n          tabindex=\"-1\"\r\n          [placement]=\"'bottom'\"\r\n          [positionTarget]=\"dateInput\"\r\n          [minDate]=\"minDate\"\r\n          [maxDate]=\"maxDate\"\r\n          [(ngModel)]=\"dateValue\"\r\n          (dateSelect)=\"selectDate($event)\"\r\n          (select)=\"selectDate($event)\"\r\n          (closed)=\"onBlur()\"\r\n        />\r\n        <div class=\"input-group-append\">\r\n          <button\r\n            type=\"button\"\r\n            class=\"btn btn-calendar\"\r\n            tabindex=\"0\"\r\n            [attr.aria-label]=\"datePickerButtonLabelText\"\r\n            [disabled]=\"isReadOnly\"\r\n            (click)=\"datePicker.toggle()\"\r\n          >\r\n            <i class=\"fas fa-calendar-alt\"></i>\r\n          </button>\r\n        </div>\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".btn-calendar{position:absolute;border:none;margin-left:-38px;z-index:3}.btn-calendar:focus{outline:none;box-shadow:none!important}.label-error{color:var(--static-Spa_Style_Accent2)}.error-container{min-height:35px;max-height:35px;line-height:18px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { datePickerInput: [{
            type: ViewChild,
            args: ['datePickerInput']
        }], control: [{
            type: Input
        }], inputLabel: [{
            type: Input
        }], inlineLayout: [{
            type: Input
        }], dateMaskFormat: [{
            type: Input
        }], minDate: [{
            type: Input
        }], maxDate: [{
            type: Input
        }], errors: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], datePickerButtonLabelText: [{
            type: Input
        }], isReadOnly: [{
            type: Input
        }], showDatePicker: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], dateSelect: [{
            type: Output
        }], datePickerInputBlur: [{
            type: Output
        }] }); })();

const _c0$3X = ["rateFactorDate"];
function RateFactorDateComponent_vnext_datepicker_input_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-datepicker-input", 1, 2);
    i0.ɵɵlistener("dateSelect", function RateFactorDateComponent_vnext_datepicker_input_0_Template_vnext_datepicker_input_dateSelect_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onSelectRateFactorDate($event)); })("datePickerInputBlur", function RateFactorDateComponent_vnext_datepicker_input_0_Template_vnext_datepicker_input_datePickerInputBlur_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.onBlur(ctx_r4.control)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r0.control)("inputLabel", ctx_r0.inputLabel)("dateMaskFormat", ctx_r0.dateMaskFormat)("minDate", ctx_r0.minDate)("maxDate", ctx_r0.maxDate)("errors", ctx_r0.errors)("ariaLabelledById", ctx_r0.ariaLabelledById)("ariaDescribedById", ctx_r0.ariaDescribedById)("datePickerButtonLabelText", ctx_r0.datePickerButtonLabelText)("isReadOnly", ctx_r0.isReadOnly)("showDatePicker", ctx_r0.showDatePicker)("placeholder", ctx_r0.datePicketInputPlaceholder);
} }
class RateFactorDateComponent {
    constructor() {
        this.isReadOnly = false;
        this.showDatePicker = false;
        this.selectRateFactorDate = new EventEmitter();
        this.rateFactorDateInputBlur = new EventEmitter();
    }
    focus() {
        this.rateFactorDate?.datePickerInput?.nativeElement?.focus();
    }
    onSelectRateFactorDate(selectedDate) {
        this.selectRateFactorDate.emit(selectedDate);
    }
    onBlur(control) {
        this.rateFactorDateInputBlur.emit(control);
    }
}
RateFactorDateComponent.ɵfac = function RateFactorDateComponent_Factory(t) { return new (t || RateFactorDateComponent)(); };
RateFactorDateComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RateFactorDateComponent, selectors: [["vnext-rate-factor-date"]], viewQuery: function RateFactorDateComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3X, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rateFactorDate = _t.first);
    } }, inputs: { control: "control", inputLabel: "inputLabel", dateMaskFormat: "dateMaskFormat", minDate: "minDate", maxDate: "maxDate", errors: "errors", ariaDescribedById: "ariaDescribedById", ariaLabelledById: "ariaLabelledById", datePickerButtonLabelText: "datePickerButtonLabelText", datePicketInputPlaceholder: "datePicketInputPlaceholder", isReadOnly: "isReadOnly", showDatePicker: "showDatePicker" }, outputs: { selectRateFactorDate: "selectRateFactorDate", rateFactorDateInputBlur: "rateFactorDateInputBlur" }, decls: 1, vars: 1, consts: [[3, "control", "inputLabel", "dateMaskFormat", "minDate", "maxDate", "errors", "ariaLabelledById", "ariaDescribedById", "datePickerButtonLabelText", "isReadOnly", "showDatePicker", "placeholder", "dateSelect", "datePickerInputBlur", 4, "ngIf"], [3, "control", "inputLabel", "dateMaskFormat", "minDate", "maxDate", "errors", "ariaLabelledById", "ariaDescribedById", "datePickerButtonLabelText", "isReadOnly", "showDatePicker", "placeholder", "dateSelect", "datePickerInputBlur"], ["rateFactorDate", ""]], template: function RateFactorDateComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, RateFactorDateComponent_vnext_datepicker_input_0_Template, 2, 12, "vnext-datepicker-input", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.control);
    } }, dependencies: [i1$2.NgIf, DatePickerInputComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RateFactorDateComponent, [{
        type: Component,
        args: [{ selector: 'vnext-rate-factor-date', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-datepicker-input\r\n  #rateFactorDate\r\n  *ngIf=\"control\"\r\n  [control]=\"control\"\r\n  [inputLabel]=\"inputLabel\"\r\n  [dateMaskFormat]=\"dateMaskFormat\"\r\n  [minDate]=\"minDate\"\r\n  [maxDate]=\"maxDate\"\r\n  [errors]=\"errors\"\r\n  [ariaLabelledById]=\"ariaLabelledById\"\r\n  [ariaDescribedById]=\"ariaDescribedById\"\r\n  [datePickerButtonLabelText]=\"datePickerButtonLabelText\"\r\n  [isReadOnly]=\"isReadOnly\"\r\n  [showDatePicker]=\"showDatePicker\"\r\n  [placeholder]=\"datePicketInputPlaceholder\"\r\n  (dateSelect)=\"onSelectRateFactorDate($event)\"\r\n  (datePickerInputBlur)=\"onBlur(control)\"\r\n>\r\n</vnext-datepicker-input>\r\n" }]
    }], null, { rateFactorDate: [{
            type: ViewChild,
            args: ['rateFactorDate']
        }], control: [{
            type: Input
        }], inputLabel: [{
            type: Input
        }], dateMaskFormat: [{
            type: Input
        }], minDate: [{
            type: Input
        }], maxDate: [{
            type: Input
        }], errors: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], datePickerButtonLabelText: [{
            type: Input
        }], datePicketInputPlaceholder: [{
            type: Input
        }], isReadOnly: [{
            type: Input
        }], showDatePicker: [{
            type: Input
        }], selectRateFactorDate: [{
            type: Output
        }], rateFactorDateInputBlur: [{
            type: Output
        }] }); })();

const _c0$3W = ["rateFactorBirthDate"];
function RateFactorBirthDateComponent_vnext_rate_factor_date_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-rate-factor-date", 1, 2);
    i0.ɵɵlistener("selectRateFactorDate", function RateFactorBirthDateComponent_vnext_rate_factor_date_0_Template_vnext_rate_factor_date_selectRateFactorDate_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onSelectRateFactorBirthDate($event)); })("rateFactorDateInputBlur", function RateFactorBirthDateComponent_vnext_rate_factor_date_0_Template_vnext_rate_factor_date_rateFactorDateInputBlur_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.onBlur(ctx_r4.control)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r0.control)("inputLabel", ctx_r0.inputLabel)("dateMaskFormat", ctx_r0.dateMaskFormat)("minDate", ctx_r0.minDate)("maxDate", ctx_r0.maxDate)("errors", ctx_r0.errors)("ariaLabelledById", ctx_r0.ariaLabelledById)("ariaDescribedById", ctx_r0.ariaDescribedById)("datePickerButtonLabelText", ctx_r0.datePickerButtonLabelText)("isReadOnly", ctx_r0.isReadOnly)("showDatePicker", ctx_r0.showDatePicker)("datePicketInputPlaceholder", ctx_r0.datePicketInputPlaceholder);
} }
class RateFactorBirthDateComponent {
    constructor() {
        this.isReadOnly = false;
        this.showDatePicker = false;
        this.selectRateFactorBirthDate = new EventEmitter();
        this.rateFactorBirthDateInputBlur = new EventEmitter();
    }
    focus() {
        this.rateFactorBirthDate?.rateFactorDate?.datePickerInput?.nativeElement?.focus();
    }
    onSelectRateFactorBirthDate(selectedDate) {
        this.selectRateFactorBirthDate.emit(selectedDate);
    }
    onBlur(control) {
        this.rateFactorBirthDateInputBlur.emit(control);
    }
}
RateFactorBirthDateComponent.ɵfac = function RateFactorBirthDateComponent_Factory(t) { return new (t || RateFactorBirthDateComponent)(); };
RateFactorBirthDateComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RateFactorBirthDateComponent, selectors: [["vnext-rate-factor-birth-date"]], viewQuery: function RateFactorBirthDateComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3W, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rateFactorBirthDate = _t.first);
    } }, inputs: { control: "control", inputLabel: "inputLabel", inlineLayout: "inlineLayout", dateMaskFormat: "dateMaskFormat", minDate: "minDate", maxDate: "maxDate", errors: "errors", datePickerButtonLabelText: "datePickerButtonLabelText", ariaDescribedById: "ariaDescribedById", ariaLabelledById: "ariaLabelledById", datePicketInputPlaceholder: "datePicketInputPlaceholder", isReadOnly: "isReadOnly", showDatePicker: "showDatePicker" }, outputs: { selectRateFactorBirthDate: "selectRateFactorBirthDate", rateFactorBirthDateInputBlur: "rateFactorBirthDateInputBlur" }, decls: 1, vars: 1, consts: [[3, "control", "inputLabel", "dateMaskFormat", "minDate", "maxDate", "errors", "ariaLabelledById", "ariaDescribedById", "datePickerButtonLabelText", "isReadOnly", "showDatePicker", "datePicketInputPlaceholder", "selectRateFactorDate", "rateFactorDateInputBlur", 4, "ngIf"], [3, "control", "inputLabel", "dateMaskFormat", "minDate", "maxDate", "errors", "ariaLabelledById", "ariaDescribedById", "datePickerButtonLabelText", "isReadOnly", "showDatePicker", "datePicketInputPlaceholder", "selectRateFactorDate", "rateFactorDateInputBlur"], ["rateFactorBirthDate", ""]], template: function RateFactorBirthDateComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, RateFactorBirthDateComponent_vnext_rate_factor_date_0_Template, 2, 12, "vnext-rate-factor-date", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.control);
    } }, dependencies: [i1$2.NgIf, RateFactorDateComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RateFactorBirthDateComponent, [{
        type: Component,
        args: [{ selector: 'vnext-rate-factor-birth-date', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-rate-factor-date\r\n  #rateFactorBirthDate\r\n  *ngIf=\"control\"\r\n  [control]=\"control\"\r\n  [inputLabel]=\"inputLabel\"\r\n  [dateMaskFormat]=\"dateMaskFormat\"\r\n  [minDate]=\"minDate\"\r\n  [maxDate]=\"maxDate\"\r\n  [errors]=\"errors\"\r\n  [ariaLabelledById]=\"ariaLabelledById\"\r\n  [ariaDescribedById]=\"ariaDescribedById\"\r\n  [datePickerButtonLabelText]=\"datePickerButtonLabelText\"\r\n  [isReadOnly]=\"isReadOnly\"\r\n  [showDatePicker]=\"showDatePicker\"\r\n  [datePicketInputPlaceholder]=\"datePicketInputPlaceholder\"\r\n  (selectRateFactorDate)=\"onSelectRateFactorBirthDate($event)\"\r\n  (rateFactorDateInputBlur)=\"onBlur(control)\"\r\n></vnext-rate-factor-date>\r\n" }]
    }], null, { rateFactorBirthDate: [{
            type: ViewChild,
            args: ['rateFactorBirthDate']
        }], control: [{
            type: Input
        }], inputLabel: [{
            type: Input
        }], inlineLayout: [{
            type: Input
        }], dateMaskFormat: [{
            type: Input
        }], minDate: [{
            type: Input
        }], maxDate: [{
            type: Input
        }], errors: [{
            type: Input
        }], datePickerButtonLabelText: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], datePicketInputPlaceholder: [{
            type: Input
        }], isReadOnly: [{
            type: Input
        }], showDatePicker: [{
            type: Input
        }], selectRateFactorBirthDate: [{
            type: Output
        }], rateFactorBirthDateInputBlur: [{
            type: Output
        }] }); })();

class SelectDropdownByCharacterDirective {
    constructor() {
        this.items = [];
        this.closeDropdownOnKeyup = true;
        this.valueSelectedByCharacter = new EventEmitter();
    }
    onKeyUp(event) {
        const keyValue = `${event.key}`.toLowerCase();
        if (this.isAlphaNumeric(keyValue) && this.items.length) {
            const matchingItems = this.items.filter(item => item && item.displayValue && item.displayValue[0].toLowerCase() === keyValue);
            if (matchingItems.length) {
                let emitValue;
                const displayValueOfSelectedValue = this.getDisplayValueOfSelectedValue(this.lastSelection);
                if (this.lastSelection && displayValueOfSelectedValue && keyValue === displayValueOfSelectedValue[0].toLowerCase()) {
                    // find the next item
                    const index = this.getIndexOfItemByValue(this.lastSelection, matchingItems);
                    if (index !== -1 && index < matchingItems.length - 1) {
                        // index is not last match, so give next item
                        emitValue = matchingItems[index + 1].selectionValue;
                    }
                    else {
                        // index is last match, so give first again
                        emitValue = matchingItems[0].selectionValue;
                    }
                }
                else {
                    // find the first item
                    emitValue = matchingItems[0].selectionValue;
                }
                this.emitValue(emitValue);
            }
        }
    }
    onKeyDown(event) {
        const keyValue = `${event.key}`.toLowerCase();
        if (this.isTabKey(keyValue)) {
            // Close dropdown when input field lost focus.
            if (this.dropdownInstance) {
                this.dropdownInstance.close();
            }
        }
    }
    getDisplayValueOfSelectedValue(selectionValue) {
        const foundItem = this.items.find(item => _isEqual(selectionValue, item.selectionValue));
        return foundItem ? foundItem.displayValue : '';
    }
    getIndexOfItemByValue(selectionValue, list) {
        for (let i = 0; i < list.length; i++) {
            if (_isEqual(selectionValue, list[i].selectionValue)) {
                return i;
            }
        }
        return -1;
    }
    isAlphaNumeric(key) {
        return key.length === 1 && RegExp('[a-z0-9]').test(key);
    }
    isTabKey(key) {
        return key === 'tab';
    }
    emitValue(value) {
        if (this.dropdownInstance && this.closeDropdownOnKeyup) {
            this.dropdownInstance.close();
        }
        this.valueSelectedByCharacter.emit(value);
    }
}
SelectDropdownByCharacterDirective.ɵfac = function SelectDropdownByCharacterDirective_Factory(t) { return new (t || SelectDropdownByCharacterDirective)(); };
SelectDropdownByCharacterDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: SelectDropdownByCharacterDirective, selectors: [["", "selectDropdownByCharacter", ""]], hostBindings: function SelectDropdownByCharacterDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("keyup", function SelectDropdownByCharacterDirective_keyup_HostBindingHandler($event) { return ctx.onKeyUp($event); })("keydown", function SelectDropdownByCharacterDirective_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); });
    } }, inputs: { items: ["dropdownValues", "items"], lastSelection: ["dropdownLastSelection", "lastSelection"], dropdownInstance: "dropdownInstance", closeDropdownOnKeyup: "closeDropdownOnKeyup" }, outputs: { valueSelectedByCharacter: "valueSelectedByCharacter" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectDropdownByCharacterDirective, [{
        type: Directive,
        args: [{ selector: '[selectDropdownByCharacter]' }]
    }], null, { items: [{
            type: Input,
            args: ['dropdownValues']
        }], lastSelection: [{
            type: Input,
            args: ['dropdownLastSelection']
        }], dropdownInstance: [{
            type: Input,
            args: ['dropdownInstance']
        }], closeDropdownOnKeyup: [{
            type: Input,
            args: ['closeDropdownOnKeyup']
        }], valueSelectedByCharacter: [{
            type: Output
        }], onKeyUp: [{
            type: HostListener,
            args: ['keyup', ['$event']]
        }], onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }] }); })();

const _c0$3V = ["dropdownButton"];
const _c1$25 = ["selectDropDownClose"];
const _c2$1h = ["selectDropDownItems"];
function DropdownButtonComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelement(1, "vnext-widget-field-errors", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("errors", ctx_r0.errors)("showInline", false);
} }
function DropdownButtonComponent_label_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
const _c3$W = function (a0, a1) { return { "label-error": a0, "ml-sm-1": a1 }; };
function DropdownButtonComponent_label_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 15);
    i0.ɵɵtemplate(1, DropdownButtonComponent_label_2_span_1_Template, 2, 0, "span", 16);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("for", ctx_r1.ariaLabelledById)("ngClass", i0.ɵɵpureFunction2(4, _c3$W, ctx_r1.isControlInvalid, !ctx_r1.isRequired));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.isRequired);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dropdownLabel, " ");
} }
const _c4$z = function (a0) { return { Spa_Style_Gray1_Background: a0 }; };
function DropdownButtonComponent_button_15_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18, 19);
    i0.ɵɵlistener("click", function DropdownButtonComponent_button_15_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r10); const dropdownItem_r7 = restoredCtx.$implicit; const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.selectItem(dropdownItem_r7)); })("keyup", function DropdownButtonComponent_button_15_Template_button_keyup_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r10); const dropdownItem_r7 = restoredCtx.$implicit; const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.keyPressedOnDropdownOption($event, dropdownItem_r7)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const dropdownItem_r7 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r5.customClass);
    i0.ɵɵpropertyInterpolate("id", ctx_r5.DROPDOWN_ID_PREFIX + dropdownItem_r7.selectionValue);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c4$z, dropdownItem_r7.selectionValue === (ctx_r5.selectedItem == null ? null : ctx_r5.selectedItem.selectionValue)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", dropdownItem_r7.displayValue, " ");
} }
const _c5$k = function (a0) { return { "has-error": a0 }; };
const _c6$j = function (a0) { return { "scroll-dropdown-menu": a0 }; };
class DropdownButtonComponent {
    constructor(cdr, localeService) {
        this.cdr = cdr;
        this.localeService = localeService;
        this.isRequired = true;
        this.disabled = false;
        this.customClass = '';
        this.selectDropdownItem = new EventEmitter();
        this.dropdownButtonBlur = new EventEmitter();
        this.activeIndex = 0;
        this.selectedItem = null;
        this.subscriptions = new Subscription();
        this.isControlInvalid = false;
        this.DROPDOWN_ID_PREFIX = 'DROPDOWN_ID_PREFIX';
        this.DROPDOWN_PREFIX = 'dropdown_';
    }
    ngOnChanges(changes) {
        const { dropdownItems } = changes;
        if (dropdownItems && !_isEqual(dropdownItems.previousValue, dropdownItems.currentValue)) {
            this.setDefaultItem();
        }
    }
    ngOnInit() {
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe(() => {
            this.cdr.markForCheck();
        }));
        this.onControlStatusChanges();
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    emitDropdownSelection($event) {
        if ($event?.code !== DOMKeyboardKeyCode.TAB) {
            return;
        }
        this.selectDropdownItem.emit(this.selectedItem);
    }
    updateDropdownSelection(selectedValue, mustCloseDropdown = false) {
        this.setSelectedItem(selectedValue);
        this.scrollToItem(selectedValue);
        if (mustCloseDropdown) {
            this.selectDropDownClose.close();
        }
        this.dropdownButton.nativeElement.focus();
        this.cdr.detectChanges();
    }
    selectItem(selectedItem) {
        if (selectedItem && this.control) {
            this.selectedItem = selectedItem;
            this.control.setValue(selectedItem.selectionValue);
            this.selectDropdownItem.emit(this.selectedItem);
        }
        else {
            this.selectedItem = null;
        }
    }
    getItem(itemValue) {
        return this.dropdownItems.find(dropdownItem => _isEqual(dropdownItem.selectionValue, itemValue));
    }
    onDropdownOpenChange(isOpen) {
        if (!isOpen) {
            this.control.markAsTouched();
            this.dropdownButtonBlur.emit();
        }
    }
    keyPressedOnDropdownOption($event, value) {
        if ($event.code === DOMKeyboardKeyCode.SPACE || $event.code === DOMKeyboardKeyCode.ENTER) {
            $event.preventDefault();
            this.updateDropdownSelection(value, false);
        }
    }
    scrollToItem(selectedValue) {
        const parentElement = this.selectDropDownItems?.first?.nativeElement.parentElement;
        this.selectDropDownItems?.forEach(dropdownItem => {
            if (dropdownItem.nativeElement.id === this.DROPDOWN_ID_PREFIX + selectedValue) {
                parentElement.scroll(0, dropdownItem.nativeElement.offsetTop - 100);
            }
        });
    }
    // This method gets a value from a control even if it is set as a simple item
    // or as an array item when the value is set externally
    getValueFromControl() {
        return Array.isArray(this.control.value) ? this.control.value[0] : this.control.value;
    }
    updateSelectedItem() {
        const value = this.getValueFromControl();
        this.selectedItem = this.getItem(value);
    }
    onControlStatusChanges() {
        this.subscriptions.add(this.control.statusChanges.subscribe({
            next: () => {
                this.isControlInvalid = this.control.invalid && (this.control.dirty || this.control.touched);
                if (!this.isControlInvalid) {
                    this.updateSelectedItem();
                }
                this.cdr.markForCheck();
            }
        }));
    }
    setSelectedItem(selectedValue) {
        if (typeof selectedValue === 'string') {
            this.selectedItem = this.getItem(selectedValue);
        }
        else {
            this.selectedItem = selectedValue;
        }
        this.control.setValue(selectedValue);
        this.selectDropdownItem.emit(this.selectedItem);
    }
    setDefaultItem() {
        const value = this.getItem(this.getValueFromControl());
        if (value) {
            this.selectedItem = value;
        }
    }
}
DropdownButtonComponent.ɵfac = function DropdownButtonComponent_Factory(t) { return new (t || DropdownButtonComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.LocaleService)); };
DropdownButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DropdownButtonComponent, selectors: [["vnext-dropdown-button"]], viewQuery: function DropdownButtonComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3V, 5);
        i0.ɵɵviewQuery(_c1$25, 5);
        i0.ɵɵviewQuery(_c2$1h, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownButton = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectDropDownClose = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectDropDownItems = _t);
    } }, inputs: { control: "control", dropdownItems: "dropdownItems", dropdownLabel: "dropdownLabel", isRequired: "isRequired", disabled: "disabled", errors: "errors", dropdownDefaultText: "dropdownDefaultText", ariaLabelledById: "ariaLabelledById", ariaDescribedById: "ariaDescribedById", customClass: "customClass", offsetItems: "offsetItems" }, outputs: { selectDropdownItem: "selectDropdownItem", dropdownButtonBlur: "dropdownButtonBlur" }, features: [i0.ɵɵNgOnChangesFeature], decls: 16, vars: 23, consts: [[1, "form-row"], ["class", "error-container mb-1 d-flex align-items-end Spa_Style_Small_Font", 4, "ngIf"], ["class", "Spa_Style_Label pl-1", 3, "for", "ngClass", 4, "ngIf"], [1, "input-group"], ["ngbDropdown", "", 1, "w-100", 3, "ngClass", "openChange"], ["selectDropDownClose", "ngbDropdown", "dropdownInstance", "ngbDropdown"], ["type", "button", "aria-required", "true", "role", "combobox", "tabindex", "0", "ngbDropdownToggle", "", "selectDropdownByCharacter", "", 1, "form-control", "med-sup-dropdown-toggle", "text-left", 3, "disabled", "id", "dropdownValues", "dropdownLastSelection", "dropdownInstance", "closeDropdownOnKeyup", "valueSelectedByCharacter"], ["dropdownButton", ""], [3, "ngClass"], [1, "fa", "fa-angle-down", "float-right", "pt-1"], [1, "sr-only"], ["ngbDropdownMenu", "", 1, "dropdown-menu", 3, "ngClass"], ["type", "button", "tabindex", "0", "role", "option", "ngbDropdownItem", "", 3, "ngClass", "class", "id", "click", "keyup", 4, "ngFor", "ngForOf"], [1, "error-container", "mb-1", "d-flex", "align-items-end", "Spa_Style_Small_Font"], [3, "errors", "showInline"], [1, "Spa_Style_Label", "pl-1", 3, "for", "ngClass"], ["class", "input-error-asterisk", 4, "ngIf"], [1, "input-error-asterisk"], ["type", "button", "tabindex", "0", "role", "option", "ngbDropdownItem", "", 3, "ngClass", "id", "click", "keyup"], ["selectDropDownItems", ""]], template: function DropdownButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, DropdownButtonComponent_div_1_Template, 2, 2, "div", 1);
        i0.ɵɵtemplate(2, DropdownButtonComponent_label_2_Template, 3, 7, "label", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3)(4, "div", 4, 5);
        i0.ɵɵlistener("openChange", function DropdownButtonComponent_Template_div_openChange_4_listener($event) { return ctx.onDropdownOpenChange($event); });
        i0.ɵɵelementStart(7, "button", 6, 7);
        i0.ɵɵlistener("valueSelectedByCharacter", function DropdownButtonComponent_Template_button_valueSelectedByCharacter_7_listener($event) { return ctx.updateDropdownSelection($event); });
        i0.ɵɵelementStart(9, "span", 8);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(11, "i", 9);
        i0.ɵɵelementStart(12, "span", 10);
        i0.ɵɵtext(13, "Expand menu");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(14, "div", 11);
        i0.ɵɵtemplate(15, DropdownButtonComponent_button_15_Template, 3, 8, "button", 12);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(6);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isControlInvalid && (ctx.errors == null ? null : ctx.errors.length) > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dropdownLabel);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c5$k, ctx.isControlInvalid));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", ctx.disabled)("id", ctx.ariaLabelledById)("dropdownValues", ctx.dropdownItems)("dropdownLastSelection", ctx.selectedItem == null ? null : ctx.selectedItem.selectionValue)("dropdownInstance", _r3)("closeDropdownOnKeyup", false);
        i0.ɵɵattribute("aria-labelledby", ctx.ariaLabelledById)("aria-describedby", ctx.ariaDescribedById);
        i0.ɵɵadvance(2);
        i0.ɵɵclassMapInterpolate1("dropdown-selected-value text-left ", ctx.customClass, "");
        i0.ɵɵproperty("ngClass", (ctx.selectedItem == null ? null : ctx.selectedItem.displayValue) ? "Spa_Style_Primary_Color" : "default-item-text-color");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate((ctx.selectedItem == null ? null : ctx.selectedItem.displayValue) || ctx.dropdownDefaultText);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(21, _c6$j, ctx.offsetItems && ctx.dropdownItems.length > ctx.offsetItems));
        i0.ɵɵattribute("aria-labelledby", ctx.ariaLabelledById);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.dropdownItems);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem, IconAriaAttributesDirective, FieldErrorsComponent, SelectDropdownByCharacterDirective], styles: [".label-error[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent2)}.dropdown-selected-value[_ngcontent-%COMP%]{display:inline-block;overflow-x:hidden;width:calc(100% - 15px);text-overflow:ellipsis}.dropdown-selected-value-small[_ngcontent-%COMP%]{font-size:14px}.error-container[_ngcontent-%COMP%]{min-height:35px;max-height:35px;line-height:18px}.dropdown-menu[_ngcontent-%COMP%]{min-width:100%;width:-moz-fit-content;width:fit-content}.scroll-dropdown-menu[_ngcontent-%COMP%]{height:315px;overflow-y:scroll}.dropdown-item[_ngcontent-%COMP%]:hover, .dropdown-item[_ngcontent-%COMP%]:focus, .dropdown-item[_ngcontent-%COMP%]:active{background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownButtonComponent, [{
        type: Component,
        args: [{ selector: 'vnext-dropdown-button', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"form-row\">\r\n  <div class=\"error-container mb-1 d-flex align-items-end Spa_Style_Small_Font\" *ngIf=\"isControlInvalid && errors?.length > 0\">\r\n    <vnext-widget-field-errors [errors]=\"errors\" [showInline]=\"false\"></vnext-widget-field-errors>\r\n  </div>\r\n\r\n  <label\r\n    *ngIf=\"dropdownLabel\"\r\n    class=\"Spa_Style_Label pl-1\"\r\n    [for]=\"ariaLabelledById\"\r\n    [ngClass]=\"{ 'label-error': isControlInvalid, 'ml-sm-1': !isRequired }\"\r\n  >\r\n    <span *ngIf=\"isRequired\" class=\"input-error-asterisk\">*</span>\r\n    {{ dropdownLabel }}\r\n  </label>\r\n</div>\r\n\r\n<div class=\"input-group\">\r\n  <div\r\n    ngbDropdown\r\n    #selectDropDownClose=\"ngbDropdown\"\r\n    #dropdownInstance=\"ngbDropdown\"\r\n    class=\"w-100\"\r\n    [ngClass]=\"{ 'has-error': isControlInvalid }\"\r\n    (openChange)=\"onDropdownOpenChange($event)\"\r\n  >\r\n    <button\r\n      #dropdownButton\r\n      type=\"button\"\r\n      class=\"form-control med-sup-dropdown-toggle text-left\"\r\n      aria-required=\"true\"\r\n      role=\"combobox\"\r\n      tabindex=\"0\"\r\n      [disabled]=\"disabled\"\r\n      ngbDropdownToggle\r\n      [id]=\"ariaLabelledById\"\r\n      [attr.aria-labelledby]=\"ariaLabelledById\"\r\n      [attr.aria-describedby]=\"ariaDescribedById\"\r\n      selectDropdownByCharacter\r\n      [dropdownValues]=\"dropdownItems\"\r\n      (valueSelectedByCharacter)=\"updateDropdownSelection($event)\"\r\n      [dropdownLastSelection]=\"this.selectedItem?.selectionValue\"\r\n      [dropdownInstance]=\"dropdownInstance\"\r\n      [closeDropdownOnKeyup]=\"false\"\r\n    >\r\n      <span\r\n        class=\"dropdown-selected-value text-left {{ customClass }}\"\r\n        [ngClass]=\"selectedItem?.displayValue ? 'Spa_Style_Primary_Color' : 'default-item-text-color'\"\r\n        >{{ selectedItem?.displayValue || dropdownDefaultText }}</span\r\n      >\r\n      <i class=\"fa fa-angle-down float-right pt-1\"></i>\r\n      <span class=\"sr-only\">Expand menu</span>\r\n    </button>\r\n    <div\r\n      [ngClass]=\"{\r\n        'scroll-dropdown-menu': offsetItems && dropdownItems.length > offsetItems\r\n      }\"\r\n      ngbDropdownMenu\r\n      [attr.aria-labelledby]=\"ariaLabelledById\"\r\n      class=\"dropdown-menu\"\r\n    >\r\n      <button\r\n        type=\"button\"\r\n        tabindex=\"0\"\r\n        role=\"option\"\r\n        ngbDropdownItem\r\n        #selectDropDownItems\r\n        *ngFor=\"let dropdownItem of dropdownItems\"\r\n        [ngClass]=\"{ Spa_Style_Gray1_Background: dropdownItem.selectionValue === selectedItem?.selectionValue }\"\r\n        (click)=\"selectItem(dropdownItem)\"\r\n        class=\"{{ customClass }}\"\r\n        (keyup)=\"keyPressedOnDropdownOption($event, dropdownItem)\"\r\n        id=\"{{ DROPDOWN_ID_PREFIX + dropdownItem.selectionValue }}\"\r\n      >\r\n        {{ dropdownItem.displayValue }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".label-error{color:var(--static-Spa_Style_Accent2)}.dropdown-selected-value{display:inline-block;overflow-x:hidden;width:calc(100% - 15px);text-overflow:ellipsis}.dropdown-selected-value-small{font-size:14px}.error-container{min-height:35px;max-height:35px;line-height:18px}.dropdown-menu{min-width:100%;width:-moz-fit-content;width:fit-content}.scroll-dropdown-menu{height:315px;overflow-y:scroll}.dropdown-item:hover,.dropdown-item:focus,.dropdown-item:active{background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.LocaleService }]; }, { dropdownButton: [{
            type: ViewChild,
            args: ['dropdownButton']
        }], selectDropDownClose: [{
            type: ViewChild,
            args: ['selectDropDownClose']
        }], selectDropDownItems: [{
            type: ViewChildren,
            args: ['selectDropDownItems']
        }], control: [{
            type: Input
        }], dropdownItems: [{
            type: Input
        }], dropdownLabel: [{
            type: Input
        }], isRequired: [{
            type: Input
        }], disabled: [{
            type: Input
        }], errors: [{
            type: Input
        }], dropdownDefaultText: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], customClass: [{
            type: Input
        }], offsetItems: [{
            type: Input
        }], selectDropdownItem: [{
            type: Output
        }], dropdownButtonBlur: [{
            type: Output
        }] }); })();

const _c0$3U = ["rateFactorDropdown"];
function RateFactorDropdownComponent_vnext_dropdown_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-dropdown-button", 1, 2);
    i0.ɵɵlistener("selectDropdownItem", function RateFactorDropdownComponent_vnext_dropdown_button_0_Template_vnext_dropdown_button_selectDropdownItem_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onSelectRateFactorDropdownItem($event)); })("dropdownButtonBlur", function RateFactorDropdownComponent_vnext_dropdown_button_0_Template_vnext_dropdown_button_dropdownButtonBlur_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.onBlur(ctx_r4.control)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r0.control)("dropdownLabel", ctx_r0.dropdownLabel)("dropdownItems", ctx_r0.dropdownItems)("errors", ctx_r0.errors)("dropdownDefaultText", ctx_r0.dropdownDefaultText)("ariaLabelledById", ctx_r0.ariaLabelledById)("ariaDescribedById", ctx_r0.ariaDescribedById)("disabled", ctx_r0.disabled)("offsetItems", ctx_r0.offsetItems);
} }
class RateFactorDropdownComponent {
    constructor() {
        this.disabled = false;
        this.selectRateFactorDropdownItem = new EventEmitter();
        this.rateFactorDropdownBlur = new EventEmitter();
    }
    focus() {
        this.rateFactorDropdown?.dropdownButton?.nativeElement?.focus();
    }
    onSelectRateFactorDropdownItem(selectedItem) {
        this.selectRateFactorDropdownItem.emit(selectedItem);
    }
    onBlur(control) {
        this.rateFactorDropdownBlur.emit(control);
    }
}
RateFactorDropdownComponent.ɵfac = function RateFactorDropdownComponent_Factory(t) { return new (t || RateFactorDropdownComponent)(); };
RateFactorDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RateFactorDropdownComponent, selectors: [["vnext-rate-factor-dropdown"]], viewQuery: function RateFactorDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3U, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rateFactorDropdown = _t.first);
    } }, inputs: { control: "control", dropdownItems: "dropdownItems", dropdownLabel: "dropdownLabel", errors: "errors", dropdownDefaultText: "dropdownDefaultText", ariaLabelledById: "ariaLabelledById", ariaDescribedById: "ariaDescribedById", disabled: "disabled", offsetItems: "offsetItems" }, outputs: { selectRateFactorDropdownItem: "selectRateFactorDropdownItem", rateFactorDropdownBlur: "rateFactorDropdownBlur" }, decls: 1, vars: 1, consts: [[3, "control", "dropdownLabel", "dropdownItems", "errors", "dropdownDefaultText", "ariaLabelledById", "ariaDescribedById", "disabled", "offsetItems", "selectDropdownItem", "dropdownButtonBlur", 4, "ngIf"], [3, "control", "dropdownLabel", "dropdownItems", "errors", "dropdownDefaultText", "ariaLabelledById", "ariaDescribedById", "disabled", "offsetItems", "selectDropdownItem", "dropdownButtonBlur"], ["rateFactorDropdown", ""]], template: function RateFactorDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, RateFactorDropdownComponent_vnext_dropdown_button_0_Template, 2, 9, "vnext-dropdown-button", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.control);
    } }, dependencies: [i1$2.NgIf, DropdownButtonComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RateFactorDropdownComponent, [{
        type: Component,
        args: [{ selector: 'vnext-rate-factor-dropdown', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-dropdown-button\r\n  #rateFactorDropdown\r\n  *ngIf=\"control\"\r\n  [control]=\"control\"\r\n  [dropdownLabel]=\"dropdownLabel\"\r\n  [dropdownItems]=\"dropdownItems\"\r\n  [errors]=\"errors\"\r\n  [dropdownDefaultText]=\"dropdownDefaultText\"\r\n  [ariaLabelledById]=\"ariaLabelledById\"\r\n  [ariaDescribedById]=\"ariaDescribedById\"\r\n  [disabled]=\"disabled\"\r\n  [offsetItems]=\"offsetItems\"\r\n  (selectDropdownItem)=\"onSelectRateFactorDropdownItem($event)\"\r\n  (dropdownButtonBlur)=\"onBlur(control)\"\r\n></vnext-dropdown-button>\r\n" }]
    }], null, { rateFactorDropdown: [{
            type: ViewChild,
            args: ['rateFactorDropdown']
        }], control: [{
            type: Input
        }], dropdownItems: [{
            type: Input
        }], dropdownLabel: [{
            type: Input
        }], errors: [{
            type: Input
        }], dropdownDefaultText: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], disabled: [{
            type: Input
        }], offsetItems: [{
            type: Input
        }], selectRateFactorDropdownItem: [{
            type: Output
        }], rateFactorDropdownBlur: [{
            type: Output
        }] }); })();

const _c0$3T = ["rateFactorEffectiveDate"];
const _c1$24 = ["rateFactorEffectiveDateDropdown"];
function RateFactorEffectiveDateComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function RateFactorEffectiveDateComponent_ng_template_1_vnext_rate_factor_dropdown_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-rate-factor-dropdown", 4, 5);
    i0.ɵɵlistener("selectRateFactorDropdownItem", function RateFactorEffectiveDateComponent_ng_template_1_vnext_rate_factor_dropdown_0_Template_vnext_rate_factor_dropdown_selectRateFactorDropdownItem_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.onSelectRateFactorDropdownItem($event)); })("rateFactorDropdownBlur", function RateFactorEffectiveDateComponent_ng_template_1_vnext_rate_factor_dropdown_0_Template_vnext_rate_factor_dropdown_rateFactorDropdownBlur_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r9.onBlur(ctx_r9.control)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r5.control)("dropdownLabel", ctx_r5.inputLabel)("dropdownItems", ctx_r5.dropdownItems)("dropdownDefaultText", ctx_r5.dropdownDefaultText)("errors", ctx_r5.errors)("ariaLabelledById", ctx_r5.ariaLabelledById)("ariaDescribedById", ctx_r5.ariaDescribedById);
} }
function RateFactorEffectiveDateComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, RateFactorEffectiveDateComponent_ng_template_1_vnext_rate_factor_dropdown_0_Template, 2, 7, "vnext-rate-factor-dropdown", 3);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.control);
} }
function RateFactorEffectiveDateComponent_ng_template_3_vnext_rate_factor_date_0_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-rate-factor-date", 7, 8);
    i0.ɵɵlistener("selectRateFactorDate", function RateFactorEffectiveDateComponent_ng_template_3_vnext_rate_factor_date_0_Template_vnext_rate_factor_date_selectRateFactorDate_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r12.onSelectRateFactorDate($event)); })("rateFactorDateInputBlur", function RateFactorEffectiveDateComponent_ng_template_3_vnext_rate_factor_date_0_Template_vnext_rate_factor_date_rateFactorDateInputBlur_0_listener() { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r14.onBlur(ctx_r14.control)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r10.control)("inputLabel", ctx_r10.inputLabel)("dateMaskFormat", ctx_r10.dateMaskFormat)("minDate", ctx_r10.minDate)("maxDate", ctx_r10.maxDate)("errors", ctx_r10.errors)("ariaLabelledById", ctx_r10.ariaLabelledById)("ariaDescribedById", ctx_r10.ariaDescribedById)("isReadOnly", ctx_r10.isReadOnly)("showDatePicker", ctx_r10.showDatePicker)("datePicketInputPlaceholder", ctx_r10.datePicketInputPlaceholder);
} }
function RateFactorEffectiveDateComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, RateFactorEffectiveDateComponent_ng_template_3_vnext_rate_factor_date_0_Template, 2, 11, "vnext-rate-factor-date", 6);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r4.control);
} }
class RateFactorEffectiveDateComponent {
    constructor() {
        this.isReadOnly = false;
        this.showDatePicker = false;
        this.showAsDropdown = true;
        this.selectRateFactorDate = new EventEmitter();
        this.selectRateFactorDropdownItem = new EventEmitter();
        this.rateFactorEffectiveDateInputBlur = new EventEmitter();
    }
    focus() {
        if (this.showAsDropdown) {
            this.rateFactorEffectiveDateDropdown?.rateFactorDropdown?.dropdownButton?.nativeElement?.focus();
        }
        else {
            this.rateFactorEffectiveDate?.rateFactorDate?.datePickerInput?.nativeElement?.focus();
        }
    }
    onSelectRateFactorDropdownItem(selectedItem) {
        this.selectRateFactorDropdownItem.emit(selectedItem);
    }
    onSelectRateFactorDate(selectedDate) {
        this.selectRateFactorDate.emit(selectedDate);
    }
    onBlur(control) {
        this.rateFactorEffectiveDateInputBlur.emit(control);
    }
}
RateFactorEffectiveDateComponent.ɵfac = function RateFactorEffectiveDateComponent_Factory(t) { return new (t || RateFactorEffectiveDateComponent)(); };
RateFactorEffectiveDateComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RateFactorEffectiveDateComponent, selectors: [["vnext-rate-factor-effective-date"]], viewQuery: function RateFactorEffectiveDateComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3T, 5);
        i0.ɵɵviewQuery(_c1$24, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rateFactorEffectiveDate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rateFactorEffectiveDateDropdown = _t.first);
    } }, inputs: { control: "control", dropdownItems: "dropdownItems", inputLabel: "inputLabel", dateMaskFormat: "dateMaskFormat", minDate: "minDate", maxDate: "maxDate", errors: "errors", ariaDescribedById: "ariaDescribedById", ariaLabelledById: "ariaLabelledById", datePickerButtonLabelText: "datePickerButtonLabelText", datePicketInputPlaceholder: "datePicketInputPlaceholder", dropdownDefaultText: "dropdownDefaultText", isReadOnly: "isReadOnly", showDatePicker: "showDatePicker", showAsDropdown: "showAsDropdown" }, outputs: { selectRateFactorDate: "selectRateFactorDate", selectRateFactorDropdownItem: "selectRateFactorDropdownItem", rateFactorEffectiveDateInputBlur: "rateFactorEffectiveDateInputBlur" }, decls: 5, vars: 3, consts: [[4, "ngIf", "ngIfThen", "ngIfElse"], ["dropdown", ""], ["dateField", ""], [3, "control", "dropdownLabel", "dropdownItems", "dropdownDefaultText", "errors", "ariaLabelledById", "ariaDescribedById", "selectRateFactorDropdownItem", "rateFactorDropdownBlur", 4, "ngIf"], [3, "control", "dropdownLabel", "dropdownItems", "dropdownDefaultText", "errors", "ariaLabelledById", "ariaDescribedById", "selectRateFactorDropdownItem", "rateFactorDropdownBlur"], ["rateFactorEffectiveDateDropdown", ""], [3, "control", "inputLabel", "dateMaskFormat", "minDate", "maxDate", "errors", "ariaLabelledById", "ariaDescribedById", "isReadOnly", "showDatePicker", "datePicketInputPlaceholder", "selectRateFactorDate", "rateFactorDateInputBlur", 4, "ngIf"], [3, "control", "inputLabel", "dateMaskFormat", "minDate", "maxDate", "errors", "ariaLabelledById", "ariaDescribedById", "isReadOnly", "showDatePicker", "datePicketInputPlaceholder", "selectRateFactorDate", "rateFactorDateInputBlur"], ["rateFactorEffectiveDate", ""]], template: function RateFactorEffectiveDateComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, RateFactorEffectiveDateComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        i0.ɵɵtemplate(1, RateFactorEffectiveDateComponent_ng_template_1_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(3, RateFactorEffectiveDateComponent_ng_template_3_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        const _r3 = i0.ɵɵreference(4);
        i0.ɵɵproperty("ngIf", ctx.showAsDropdown)("ngIfThen", _r1)("ngIfElse", _r3);
    } }, dependencies: [i1$2.NgIf, RateFactorDateComponent, RateFactorDropdownComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RateFactorEffectiveDateComponent, [{
        type: Component,
        args: [{ selector: 'vnext-rate-factor-effective-date', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"showAsDropdown; then dropdown; else dateField\"></ng-container>\r\n\r\n<ng-template #dropdown>\r\n  <vnext-rate-factor-dropdown\r\n    #rateFactorEffectiveDateDropdown\r\n    *ngIf=\"control\"\r\n    [control]=\"control\"\r\n    [dropdownLabel]=\"inputLabel\"\r\n    [dropdownItems]=\"dropdownItems\"\r\n    [dropdownDefaultText]=\"dropdownDefaultText\"\r\n    [errors]=\"errors\"\r\n    [ariaLabelledById]=\"ariaLabelledById\"\r\n    [ariaDescribedById]=\"ariaDescribedById\"\r\n    (selectRateFactorDropdownItem)=\"onSelectRateFactorDropdownItem($event)\"\r\n    (rateFactorDropdownBlur)=\"onBlur(control)\"\r\n  ></vnext-rate-factor-dropdown>\r\n</ng-template>\r\n\r\n<ng-template #dateField>\r\n  <vnext-rate-factor-date\r\n    #rateFactorEffectiveDate\r\n    *ngIf=\"control\"\r\n    [control]=\"control\"\r\n    [inputLabel]=\"inputLabel\"\r\n    [dateMaskFormat]=\"dateMaskFormat\"\r\n    [minDate]=\"minDate\"\r\n    [maxDate]=\"maxDate\"\r\n    [errors]=\"errors\"\r\n    [ariaLabelledById]=\"ariaLabelledById\"\r\n    [ariaDescribedById]=\"ariaDescribedById\"\r\n    [isReadOnly]=\"isReadOnly\"\r\n    [showDatePicker]=\"showDatePicker\"\r\n    [datePicketInputPlaceholder]=\"datePicketInputPlaceholder\"\r\n    (selectRateFactorDate)=\"onSelectRateFactorDate($event)\"\r\n    (rateFactorDateInputBlur)=\"onBlur(control)\"\r\n  ></vnext-rate-factor-date>\r\n</ng-template>\r\n" }]
    }], null, { rateFactorEffectiveDate: [{
            type: ViewChild,
            args: ['rateFactorEffectiveDate']
        }], rateFactorEffectiveDateDropdown: [{
            type: ViewChild,
            args: ['rateFactorEffectiveDateDropdown']
        }], control: [{
            type: Input
        }], dropdownItems: [{
            type: Input
        }], inputLabel: [{
            type: Input
        }], dateMaskFormat: [{
            type: Input
        }], minDate: [{
            type: Input
        }], maxDate: [{
            type: Input
        }], errors: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], datePickerButtonLabelText: [{
            type: Input
        }], datePicketInputPlaceholder: [{
            type: Input
        }], dropdownDefaultText: [{
            type: Input
        }], isReadOnly: [{
            type: Input
        }], showDatePicker: [{
            type: Input
        }], showAsDropdown: [{
            type: Input
        }], selectRateFactorDate: [{
            type: Output
        }], selectRateFactorDropdownItem: [{
            type: Output
        }], rateFactorEffectiveDateInputBlur: [{
            type: Output
        }] }); })();

class ToggleFacade {
    focusItem(currentIndex, delta, toggleElements) {
        const maxIndex = toggleElements.length - 1;
        let nextElementIndex = 0;
        // Math in these checks allow for a delta other than 1 to theoretically be used
        if (delta < 0 && currentIndex - delta < 0) {
            nextElementIndex = maxIndex - (Math.abs(delta + 1) % maxIndex) - 1;
        }
        else if (delta > 0 && currentIndex + delta - 1 > maxIndex) {
            nextElementIndex = (delta - 1) % maxIndex;
        }
        else {
            nextElementIndex = currentIndex + delta;
        }
        const optionElement = toggleElements.filter((_element, index) => index === nextElementIndex)[0];
        if (optionElement) {
            // element wont exist if we go previous on the first element, or next on the last
            toggleElements.forEach(element => {
                element.nativeElement.setAttribute('tabindex', '-1');
            });
            optionElement.nativeElement.setAttribute('tabindex', '0');
            optionElement.nativeElement.focus();
        }
    }
    selectOptionByKeyPress(targetIndex, toggleElements) {
        const optionElement = toggleElements.filter((_element, index) => index === targetIndex)[0];
        toggleElements.forEach(element => {
            element.nativeElement.setAttribute('aria-checked', 'false');
            element.nativeElement.setAttribute('tabindex', '-1');
        });
        optionElement.nativeElement.setAttribute('aria-checked', 'true');
        optionElement.nativeElement.setAttribute('tabindex', '0');
        optionElement.nativeElement.focus();
        optionElement.nativeElement.click();
    }
}
ToggleFacade.ɵfac = function ToggleFacade_Factory(t) { return new (t || ToggleFacade)(); };
ToggleFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ToggleFacade, factory: ToggleFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToggleFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

const _c0$3S = ["toggles"];
const _c1$23 = function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10) { return { "Spa_Style_Primary_Link_Color Spa_Style_Bold_Weight Spa_Style_Small_Font Spa_Style_Primary_Link_Border toggle-option-selected": a0, "Spa_Style_SecondaryButtonSelected": a1, "Spa_Style_SecondaryButtonDisabled": a2, "Spa_Style_Secondary_Text_Background": a3, "Spa_Style_SecondaryButton": a4, "hover": a5, "largerText": a6, "w-100": a7, "has-error": a8, "Spa_Style_Gray4_Color readonly": a9, "Spa_Style_Regular_Weight": a10 }; };
const _c2$1g = function (a0) { return { "min-height": a0 }; };
const _c3$V = function (a0) { return { Spa_Style_Paragraph: a0 }; };
const _c4$y = function (a0) { return { color: a0 }; };
function ToggleSelectComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2, 3);
    i0.ɵɵlistener("click", function ToggleSelectComponent_div_1_Template_div_click_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const item_r1 = restoredCtx.$implicit; const index_r2 = restoredCtx.index; const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.setToggleOption(item_r1, index_r2, $event)); })("blur", function ToggleSelectComponent_div_1_Template_div_blur_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.emitToggleOptionOnBlur($event)); })("keyup.enter", function ToggleSelectComponent_div_1_Template_div_keyup_enter_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.selectOptionByKeyPress(index_r2, $event)); })("keyup.arrowup", function ToggleSelectComponent_div_1_Template_div_keyup_arrowup_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.focusPreviousItem(index_r2, $event)); })("keyup.arrowleft", function ToggleSelectComponent_div_1_Template_div_keyup_arrowleft_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.focusPreviousItem(index_r2, $event)); })("keyup.arrowdown", function ToggleSelectComponent_div_1_Template_div_keyup_arrowdown_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.focusNextItem(index_r2, $event)); })("keyup.arrowright", function ToggleSelectComponent_div_1_Template_div_keyup_arrowright_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.focusNextItem(index_r2, $event)); });
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵelement(3, "span", 5);
    i0.ɵɵpipe(4, "safe");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const index_r2 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunctionV(13, _c1$23, [ctx_r0.itemIsSelected(item_r1.value), !ctx_r0.isReadOnly && ctx_r0.itemIsSelected(item_r1.value), ctx_r0.isReadOnly && ctx_r0.itemIsSelected(item_r1.value), ctx_r0.lightBackground && !ctx_r0.itemIsSelected(item_r1.value), !ctx_r0.itemIsSelected(item_r1.value), ctx_r0.darkenOnHover, ctx_r0.largerText, ctx_r0.fullWidth, ctx_r0.hasError, ctx_r0.isReadOnly, !ctx_r0.boldUnselectedItems]))("ngStyle", i0.ɵɵpureFunction1(25, _c2$1g, ctx_r0.buttonHeight));
    i0.ɵɵattribute("aria-checked", ctx_r0.itemIsSelected(item_r1.value) ? "true" : "false")("tabindex", ctx_r0.getTabIndex(!!ctx_r0.activeValue, index_r2, ctx_r0.itemIsSelected(item_r1.value)))("aria-describedby", ctx_r0.ariaDescribedById ? ctx_r0.ariaDescribedById : null)("aria-labelledby", ctx_r0.toggleControlId + "toggle-option-" + index_r2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r0.toggleControlId + "toggle-option-" + index_r2)("ngClass", i0.ɵɵpureFunction1(27, _c3$V, ctx_r0.isNotSelectedItem(item_r1) && !ctx_r0.largerText))("ngStyle", i0.ɵɵpureFunction1(29, _c4$y, ctx_r0.isNotSelectedItem(item_r1) ? ctx_r0.secondaryButtonTextColor : ""));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 10, item_r1.display, "html"), i0.ɵɵsanitizeHtml);
} }
const _c5$j = function (a0, a1) { return { vertical: a0, horizontal: a1 }; };
const _c6$i = function (a0) { return { width: a0 }; };
class ToggleSelectComponent {
    constructor(inputResetContextService, toggleFacade) {
        this.inputResetContextService = inputResetContextService;
        this.toggleFacade = toggleFacade;
        this.verticalGrow = false;
        this.fullWidth = false;
        this.lightBackground = false;
        this.darkenOnHover = true;
        this.largerText = false;
        this.buttonHeight = '36px';
        this.hasError = false;
        this.limitButtonWidth = false;
        this.limitButtonWidthClass = 'col-xs-12 col-md-4 px-0';
        this.ariaRequired = false;
        this.toggleControlId = '';
        this.isReadOnly = false;
        this.disabledBlurEvent = false;
        this.focusFirstItem = false;
        this.selectFirstItemAsDefaultActiveValue = false;
        this.boldUnselectedItems = false;
        this.optionSelected = new EventEmitter();
        this.subscriptions = [];
    }
    ngOnInit() {
        this.activeValue = this.getActiveValue(this.items, this.selectedValue, this.selectFirstItemAsDefaultActiveValue);
        this.subscriptions = [
            this.inputResetContextService.clearInput$.subscribe({
                next: id => {
                    if (id === this.parentId) {
                        this.activeValue = null;
                    }
                }
            })
        ];
    }
    // found an interesting bug where if the state gets updated outside of this component the active value needs to be updated
    // example if someone logs in with data the toggle won't populate with the new info
    ngOnChanges(changes) {
        if (changes.selectedValue &&
            changes.selectedValue.currentValue &&
            changes.selectedValue.currentValue !== changes.selectedValue.previousValue) {
            const value = changes.selectedValue.currentValue;
            this.activeValue = this.items.some(item => item.value === value) ? value : this.activeValue;
        }
    }
    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
    ngAfterViewInit() {
        if (this.focusFirstItem) {
            this.toggleFacade.focusItem(0, 0, this.toggleElements);
        }
    }
    setToggleOption(item, currentIndex, $event) {
        if (this.isReadOnly) {
            return;
        }
        this.activeValue = item.value;
        this.emitToggleOption($event);
        const optionElement = this.toggleElements.filter((_element, index) => index === currentIndex)[0];
        optionElement.nativeElement.focus();
    }
    emitToggleOptionOnBlur(event) {
        if (!this.disabledBlurEvent) {
            this.emitToggleOption(event);
        }
    }
    itemIsSelected(value) {
        return this.activeValue !== null && this.activeValue !== undefined && this.activeValue === value;
    }
    getTabIndex(hasActiveValue, index, itemIsSelected) {
        if (!hasActiveValue && index === 0) {
            return '0';
        }
        return itemIsSelected ? '0' : '-1';
    }
    focusItem(currentIndex, $event, delta) {
        $event.preventDefault();
        if (this.isReadOnly) {
            return;
        }
        this.toggleFacade.focusItem(currentIndex, delta, this.toggleElements);
    }
    focusNextItem(currentIndex, $event) {
        this.focusItem(currentIndex, $event, 1);
    }
    focusPreviousItem(currentIndex, $event) {
        this.focusItem(currentIndex, $event, -1);
    }
    selectOptionByKeyPress(targetIndex, $event) {
        if (this.isReadOnly) {
            $event.preventDefault();
            return;
        }
        this.toggleFacade.selectOptionByKeyPress(targetIndex, this.toggleElements);
    }
    isNotSelectedItem(item) {
        return !this.itemIsSelected(item.value);
    }
    emitToggleOption($event) {
        if (this.activeValue !== '') {
            this.optionSelected.emit({ data: { value: this.activeValue }, event: $event });
        }
        else if (this.selectedValue !== '') {
            this.optionSelected.emit({ data: { value: this.selectedValue }, event: $event });
        }
        else {
            this.optionSelected.emit({ data: null, event: $event });
        }
    }
    getActiveValue(items, selectedValue, selectFirstItemAsDefaultActiveValue = false) {
        const defaultActiveValue = selectFirstItemAsDefaultActiveValue ? items[0]?.value : null;
        return items.some(item => item.value === selectedValue) ? selectedValue : defaultActiveValue;
    }
}
ToggleSelectComponent.ɵfac = function ToggleSelectComponent_Factory(t) { return new (t || ToggleSelectComponent)(i0.ɵɵdirectiveInject(i1.InputResetContextService), i0.ɵɵdirectiveInject(ToggleFacade)); };
ToggleSelectComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ToggleSelectComponent, selectors: [["vnext-toggle-select"]], viewQuery: function ToggleSelectComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3S, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toggleElements = _t);
    } }, inputs: { items: "items", selectedValue: "selectedValue", verticalGrow: "verticalGrow", fullWidth: "fullWidth", lightBackground: "lightBackground", darkenOnHover: "darkenOnHover", largerText: "largerText", parentId: "parentId", buttonHeight: "buttonHeight", hasError: "hasError", limitButtonWidth: "limitButtonWidth", limitButtonWidthClass: "limitButtonWidthClass", ariaLabelledById: "ariaLabelledById", ariaDescribedById: "ariaDescribedById", ariaRequired: "ariaRequired", toggleControlId: "toggleControlId", isReadOnly: "isReadOnly", disabledBlurEvent: "disabledBlurEvent", focusFirstItem: "focusFirstItem", secondaryButtonTextColor: "secondaryButtonTextColor", selectFirstItemAsDefaultActiveValue: "selectFirstItemAsDefaultActiveValue", toggleContainerWidth: "toggleContainerWidth", boldUnselectedItems: "boldUnselectedItems" }, outputs: { optionSelected: "optionSelected" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 12, consts: [["role", "radiogroup", 3, "ngClass", "ngStyle", "className"], ["role", "radio", "name", "toggle-radio-button", "class", "toggle-option can-click", 3, "ngClass", "ngStyle", "click", "blur", "keyup.enter", "keyup.arrowup", "keyup.arrowleft", "keyup.arrowdown", "keyup.arrowright", 4, "ngFor", "ngForOf"], ["role", "radio", "name", "toggle-radio-button", 1, "toggle-option", "can-click", 3, "ngClass", "ngStyle", "click", "blur", "keyup.enter", "keyup.arrowup", "keyup.arrowleft", "keyup.arrowdown", "keyup.arrowright"], ["toggles", ""], [1, "toggle-content-wrapper", 3, "id", "ngClass", "ngStyle"], ["navigationAdapter", "", 3, "innerHTML"]], template: function ToggleSelectComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, ToggleSelectComponent_div_1_Template, 5, 31, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c5$j, ctx.verticalGrow, !ctx.verticalGrow))("ngStyle", i0.ɵɵpureFunction1(10, _c6$i, ctx.toggleContainerWidth ? ctx.toggleContainerWidth : ""))("className", "toggle-container" + (ctx.limitButtonWidth ? " " + ctx.limitButtonWidthClass : ""));
        i0.ɵɵattribute("aria-labelledby", ctx.ariaLabelledById ? ctx.ariaLabelledById : null)("aria-describedby", ctx.ariaDescribedById ? ctx.ariaDescribedById : null)("aria-required", !!ctx.ariaRequired);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.items);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgStyle, NavigationAdapterDirective, SafePipe], styles: [".toggle-container[_ngcontent-%COMP%]{display:flex;text-align:center}.toggle-option[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;border:1px solid var(--static-Spa_Style_Accent1);padding:6px 5px;cursor:pointer;-webkit-user-select:none;user-select:none;flex:1 0}.toggle-option-selected[_ngcontent-%COMP%], .toggle-option-selected[_ngcontent-%COMP%]:focus, .toggle-option-selected[_ngcontent-%COMP%]:active{border-color:var(--static-Spa_Style_Primary_Link);border-width:2px}.vertical[_ngcontent-%COMP%]{flex-direction:column;text-align:left}.toggle-option[_ngcontent-%COMP%]{padding-left:15px;padding-right:15px}.largerText[_ngcontent-%COMP%]{font-size:16px}.horizontal[_ngcontent-%COMP%] > .toggle-option[_ngcontent-%COMP%]:first-of-type{border-top-left-radius:5px;border-bottom-left-radius:5px}.horizontal[_ngcontent-%COMP%] > .toggle-option[_ngcontent-%COMP%]:last-of-type{border-top-right-radius:5px;border-bottom-right-radius:5px}.vertical[_ngcontent-%COMP%] > .toggle-option[_ngcontent-%COMP%]:first-of-type{border-top-left-radius:5px;border-top-right-radius:5px}.vertical[_ngcontent-%COMP%] > .toggle-option[_ngcontent-%COMP%]:last-of-type{border-bottom-left-radius:5px;border-bottom-right-radius:5px}.toggle-content-wrapper[_ngcontent-%COMP%]{display:flex;align-items:center;width:100%;pointer-events:none}.toggle-content-wrapper[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{width:100%}.toggle-option-selected.disable-prepopulated[_ngcontent-%COMP%], .toggle-option-selected.disable-prepopulated[_ngcontent-%COMP%]:focus, .toggle-option-selected.disable-prepopulated[_ngcontent-%COMP%]:active{border-color:var(--static-Spa_Style_Gray4)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToggleSelectComponent, [{
        type: Component,
        args: [{ selector: 'vnext-toggle-select', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  [ngClass]=\"{ vertical: verticalGrow, horizontal: !verticalGrow }\"\r\n  [ngStyle]=\"{ width: toggleContainerWidth ? toggleContainerWidth : '' }\"\r\n  [className]=\"'toggle-container' + (limitButtonWidth ? ' ' + limitButtonWidthClass : '')\"\r\n  [attr.aria-labelledby]=\"ariaLabelledById ? ariaLabelledById : null\"\r\n  [attr.aria-describedby]=\"ariaDescribedById ? ariaDescribedById : null\"\r\n  [attr.aria-required]=\"!!ariaRequired\"\r\n  role=\"radiogroup\"\r\n>\r\n  <div\r\n    *ngFor=\"let item of items; index as index\"\r\n    #toggles\r\n    role=\"radio\"\r\n    name=\"toggle-radio-button\"\r\n    class=\"toggle-option can-click\"\r\n    [ngClass]=\"{\r\n      'Spa_Style_Primary_Link_Color Spa_Style_Bold_Weight Spa_Style_Small_Font Spa_Style_Primary_Link_Border toggle-option-selected':\r\n        itemIsSelected(item.value),\r\n      'Spa_Style_SecondaryButtonSelected': !isReadOnly && itemIsSelected(item.value),\r\n      'Spa_Style_SecondaryButtonDisabled': isReadOnly && itemIsSelected(item.value),\r\n      'Spa_Style_Secondary_Text_Background': lightBackground && !itemIsSelected(item.value),\r\n      'Spa_Style_SecondaryButton': !itemIsSelected(item.value),\r\n      'hover': darkenOnHover,\r\n      'largerText': largerText,\r\n      'w-100': fullWidth,\r\n      'has-error': hasError,\r\n      'Spa_Style_Gray4_Color readonly': isReadOnly,\r\n      'Spa_Style_Regular_Weight': !boldUnselectedItems\r\n    }\"\r\n    [ngStyle]=\"{ 'min-height': buttonHeight }\"\r\n    [attr.aria-checked]=\"itemIsSelected(item.value) ? 'true' : 'false'\"\r\n    [attr.tabindex]=\"getTabIndex(!!activeValue, index, itemIsSelected(item.value))\"\r\n    [attr.aria-describedby]=\"ariaDescribedById ? ariaDescribedById : null\"\r\n    [attr.aria-labelledby]=\"toggleControlId + 'toggle-option-' + index\"\r\n    (click)=\"setToggleOption(item, index, $event)\"\r\n    (blur)=\"emitToggleOptionOnBlur($event)\"\r\n    (keyup.enter)=\"selectOptionByKeyPress(index, $event)\"\r\n    (keyup.arrowup)=\"focusPreviousItem(index, $event)\"\r\n    (keyup.arrowleft)=\"focusPreviousItem(index, $event)\"\r\n    (keyup.arrowdown)=\"focusNextItem(index, $event)\"\r\n    (keyup.arrowright)=\"focusNextItem(index, $event)\"\r\n  >\r\n    <span\r\n      [id]=\"toggleControlId + 'toggle-option-' + index\"\r\n      class=\"toggle-content-wrapper\"\r\n      [ngClass]=\"{ Spa_Style_Paragraph: isNotSelectedItem(item) && !this.largerText }\"\r\n      [ngStyle]=\"{ color: isNotSelectedItem(item) ? secondaryButtonTextColor : '' }\"\r\n    >\r\n      <span [innerHTML]=\"item.display | safe : 'html'\" navigationAdapter> </span>\r\n    </span>\r\n  </div>\r\n</div>\r\n", styles: [".toggle-container{display:flex;text-align:center}.toggle-option{display:flex;align-items:center;justify-content:center;border:1px solid var(--static-Spa_Style_Accent1);padding:6px 5px;cursor:pointer;-webkit-user-select:none;user-select:none;flex:1 0}.toggle-option-selected,.toggle-option-selected:focus,.toggle-option-selected:active{border-color:var(--static-Spa_Style_Primary_Link);border-width:2px}.vertical{flex-direction:column;text-align:left}.toggle-option{padding-left:15px;padding-right:15px}.largerText{font-size:16px}.horizontal>.toggle-option:first-of-type{border-top-left-radius:5px;border-bottom-left-radius:5px}.horizontal>.toggle-option:last-of-type{border-top-right-radius:5px;border-bottom-right-radius:5px}.vertical>.toggle-option:first-of-type{border-top-left-radius:5px;border-top-right-radius:5px}.vertical>.toggle-option:last-of-type{border-bottom-left-radius:5px;border-bottom-right-radius:5px}.toggle-content-wrapper{display:flex;align-items:center;width:100%;pointer-events:none}.toggle-content-wrapper span{width:100%}.toggle-option-selected.disable-prepopulated,.toggle-option-selected.disable-prepopulated:focus,.toggle-option-selected.disable-prepopulated:active{border-color:var(--static-Spa_Style_Gray4)}\n"] }]
    }], function () { return [{ type: i1.InputResetContextService }, { type: ToggleFacade }]; }, { toggleElements: [{
            type: ViewChildren,
            args: ['toggles']
        }], items: [{
            type: Input
        }], selectedValue: [{
            type: Input
        }], verticalGrow: [{
            type: Input
        }], fullWidth: [{
            type: Input
        }], lightBackground: [{
            type: Input
        }], darkenOnHover: [{
            type: Input
        }], largerText: [{
            type: Input
        }], parentId: [{
            type: Input
        }], buttonHeight: [{
            type: Input
        }], hasError: [{
            type: Input
        }], limitButtonWidth: [{
            type: Input
        }], limitButtonWidthClass: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], ariaRequired: [{
            type: Input
        }], toggleControlId: [{
            type: Input
        }], isReadOnly: [{
            type: Input
        }], disabledBlurEvent: [{
            type: Input
        }], focusFirstItem: [{
            type: Input
        }], secondaryButtonTextColor: [{
            type: Input
        }], selectFirstItemAsDefaultActiveValue: [{
            type: Input
        }], toggleContainerWidth: [{
            type: Input
        }], boldUnselectedItems: [{
            type: Input
        }], optionSelected: [{
            type: Output
        }] }); })();

const _c0$3R = ["rateFactorToggle"];
function RateFactorToggleComponent_vnext_toggle_select_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-toggle-select", 1, 2);
    i0.ɵɵlistener("optionSelected", function RateFactorToggleComponent_vnext_toggle_select_0_Template_vnext_toggle_select_optionSelected_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onSelectOption($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("items", ctx_r0.items)("selectedValue", ctx_r0.control == null ? null : ctx_r0.control.value)("limitButtonWidth", ctx_r0.limitButtonWidth)("ariaLabelledById", ctx_r0.ariaLabelledById)("ariaDescribedById", ctx_r0.ariaDescribedById)("ariaRequired", ctx_r0.ariaRequired)("toggleControlId", ctx_r0.toggleControlId)("largerText", true)("isReadOnly", ctx_r0.isReadOnly);
} }
class RateFactorToggleComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.limitButtonWidth = false;
        this.ariaRequired = false;
        this.isReadOnly = false;
        this.selectOption = new EventEmitter();
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.onControlStatusChanges();
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    focus() {
        this.rateFactorToggle?.toggleElements?.first?.nativeElement?.focus();
    }
    isControlInvalid() {
        return this.control.invalid && (this.control.dirty || this.control.touched);
    }
    onSelectOption({ data, event }) {
        event.stopPropagation();
        this.control.setValue(data?.value);
        this.control.markAsDirty();
        this.control.updateValueAndValidity();
        this.selectOption.emit(this.control);
    }
    onControlStatusChanges() {
        this.subscriptions.add(this.control.statusChanges.subscribe({
            next: () => {
                this.cdr.markForCheck();
            }
        }));
    }
}
RateFactorToggleComponent.ɵfac = function RateFactorToggleComponent_Factory(t) { return new (t || RateFactorToggleComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
RateFactorToggleComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RateFactorToggleComponent, selectors: [["vnext-rate-factor-toggle"]], viewQuery: function RateFactorToggleComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3R, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rateFactorToggle = _t.first);
    } }, inputs: { control: "control", limitButtonWidth: "limitButtonWidth", ariaLabelledById: "ariaLabelledById", ariaDescribedById: "ariaDescribedById", ariaRequired: "ariaRequired", toggleControlId: "toggleControlId", fieldName: "fieldName", isReadOnly: "isReadOnly", items: "items" }, outputs: { selectOption: "selectOption" }, decls: 1, vars: 1, consts: [[3, "items", "selectedValue", "limitButtonWidth", "ariaLabelledById", "ariaDescribedById", "ariaRequired", "toggleControlId", "largerText", "isReadOnly", "optionSelected", 4, "ngIf"], [3, "items", "selectedValue", "limitButtonWidth", "ariaLabelledById", "ariaDescribedById", "ariaRequired", "toggleControlId", "largerText", "isReadOnly", "optionSelected"], ["rateFactorToggle", ""]], template: function RateFactorToggleComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, RateFactorToggleComponent_vnext_toggle_select_0_Template, 2, 9, "vnext-toggle-select", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.control);
    } }, dependencies: [i1$2.NgIf, ToggleSelectComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RateFactorToggleComponent, [{
        type: Component,
        args: [{ selector: 'vnext-rate-factor-toggle', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-toggle-select\r\n  #rateFactorToggle\r\n  *ngIf=\"control\"\r\n  [items]=\"items\"\r\n  [selectedValue]=\"control?.value\"\r\n  [limitButtonWidth]=\"limitButtonWidth\"\r\n  [ariaLabelledById]=\"ariaLabelledById\"\r\n  [ariaDescribedById]=\"ariaDescribedById\"\r\n  [ariaRequired]=\"ariaRequired\"\r\n  [toggleControlId]=\"toggleControlId\"\r\n  [largerText]=\"true\"\r\n  [isReadOnly]=\"isReadOnly\"\r\n  (optionSelected)=\"onSelectOption($event)\"\r\n>\r\n</vnext-toggle-select>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { rateFactorToggle: [{
            type: ViewChild,
            args: ['rateFactorToggle']
        }], control: [{
            type: Input
        }], limitButtonWidth: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], ariaRequired: [{
            type: Input
        }], toggleControlId: [{
            type: Input
        }], fieldName: [{
            type: Input
        }], isReadOnly: [{
            type: Input
        }], items: [{
            type: Input
        }], selectOption: [{
            type: Output
        }] }); })();

const _c0$3Q = ["ngFormInstance"];
const _c1$22 = ["errorContainer"];
const _c2$1f = ["rateFactorQuestions"];
const _c3$U = ["rateFactorDateOfBirth", "rateFactorEffectiveDate", "rateFactorGender", "rateFactorTobacco", "rateFactorHousehold", "rateFactorNumberOfDays", "rateFactorBenefitAmount"];
function RateFactorsFormComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-notice", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r1.errorNoticeTitle)("messages", ctx_r1.errorMessages)("type", "error")("errorKeywordText", ctx_r1.errorKeywordText);
} }
function RateFactorsFormComponent_div_6_ng_container_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21)(1, "span", 22);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "vnext-widget-field-errors", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r4 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", question_r4.name + "ValidationError");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r7.errorKeywordText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("errors", ctx_r7.formErrors[question_r4.name])("showInline", false);
} }
function RateFactorsFormComponent_div_6_ng_container_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 24);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function RateFactorsFormComponent_div_6_ng_container_2_span_7_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 28);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const tooltipKey_r19 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, tooltipKey_r19, "html"), i0.ɵɵsanitizeHtml);
} }
function RateFactorsFormComponent_div_6_ng_container_2_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 25);
    i0.ɵɵtemplate(1, RateFactorsFormComponent_div_6_ng_container_2_span_7_ng_template_1_Template, 2, 4, "ng-template", null, 26, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "i", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r20 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbTooltip", _r20);
} }
function RateFactorsFormComponent_div_6_ng_container_2_vnext_rate_factor_birth_date_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-rate-factor-birth-date", 29, 30);
} if (rf & 2) {
    const question_r4 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r10.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r10.rateFactorQuestionUIDataMap[question_r4.name].control)("dateMaskFormat", ctx_r10.dateMaskFormat)("minDate", ctx_r10.minBirthDate)("maxDate", ctx_r10.maxBirthDate)("datePicketInputPlaceholder", ctx_r10.datePicketInputPlaceholder)("ariaDescribedById", ctx_r10.formErrors[question_r4.name] ? question_r4.name + "ValidationError" : "")("ariaLabelledById", ctx_r10.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r10.rateFactorQuestionUIDataMap[question_r4.name].ariaLabelledById)("isReadOnly", ctx_r10.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r10.rateFactorQuestionUIDataMap[question_r4.name].isPopulatedFromSSO);
} }
function RateFactorsFormComponent_div_6_ng_container_2_vnext_rate_factor_effective_date_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-rate-factor-effective-date", 31, 32);
} if (rf & 2) {
    const question_r4 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r11.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r11.rateFactorQuestionUIDataMap[question_r4.name].control)("dropdownItems", ctx_r11.effectiveDateDropdownItems)("dateMaskFormat", ctx_r11.dateMaskFormat)("minDate", ctx_r11.minEffectiveDate)("maxDate", ctx_r11.maxEffectiveDate)("showDatePicker", ctx_r11.showDatePicker)("showAsDropdown", ctx_r11.showEffectiveDateAsDropdown)("dropdownDefaultText", ctx_r11.dropdownDefaultText)("datePicketInputPlaceholder", ctx_r11.datePicketInputPlaceholder)("ariaLabelledById", ctx_r11.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r11.rateFactorQuestionUIDataMap[question_r4.name].ariaLabelledById)("ariaDescribedById", ctx_r11.formErrors[question_r4.name] ? question_r4.name + "ValidationError" : "")("datePickerButtonLabelText", ctx_r11.datePickerButtonLabelText);
} }
function RateFactorsFormComponent_div_6_ng_container_2_vnext_rate_factor_toggle_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-rate-factor-toggle", 33, 34);
} if (rf & 2) {
    const question_r4 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r12.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r12.rateFactorQuestionUIDataMap[question_r4.name].control)("items", ctx_r12.genderToggleItems)("fieldName", ctx_r12.rateFactorQuestionNames.Gender)("limitButtonWidth", question_r4.name === ctx_r12.rateFactorQuestionNames.GIAdditional)("ariaLabelledById", ctx_r12.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r12.rateFactorQuestionUIDataMap[question_r4.name].ariaLabelledById)("ariaDescribedById", ctx_r12.formErrors[question_r4.name] ? question_r4.name + "ValidationError" : "")("ariaRequired", ctx_r12.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r12.rateFactorQuestionUIDataMap[question_r4.name].required)("toggleControlId", question_r4.name)("isReadOnly", ctx_r12.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r12.rateFactorQuestionUIDataMap[question_r4.name].isPopulatedFromSSO);
} }
function RateFactorsFormComponent_div_6_ng_container_2_vnext_rate_factor_toggle_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-rate-factor-toggle", 33, 35);
} if (rf & 2) {
    const question_r4 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r13.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r13.rateFactorQuestionUIDataMap[question_r4.name].control)("items", ctx_r13.tobaccoToggleItems)("fieldName", ctx_r13.rateFactorQuestionNames.Tobacco)("limitButtonWidth", question_r4.name === ctx_r13.rateFactorQuestionNames.GIAdditional)("ariaLabelledById", ctx_r13.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r13.rateFactorQuestionUIDataMap[question_r4.name].ariaLabelledById)("ariaDescribedById", ctx_r13.formErrors[question_r4.name] ? question_r4.name + "ValidationError" : "")("ariaRequired", ctx_r13.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r13.rateFactorQuestionUIDataMap[question_r4.name].required)("toggleControlId", question_r4.name)("isReadOnly", ctx_r13.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r13.rateFactorQuestionUIDataMap[question_r4.name].isPopulatedFromSSO);
} }
function RateFactorsFormComponent_div_6_ng_container_2_vnext_rate_factor_toggle_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-rate-factor-toggle", 36, 37);
} if (rf & 2) {
    const question_r4 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r14.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r14.rateFactorQuestionUIDataMap[question_r4.name].control)("items", ctx_r14.householdToggleItems)("fieldName", ctx_r14.rateFactorQuestionNames.Household)("limitButtonWidth", question_r4.name === ctx_r14.rateFactorQuestionNames.GIAdditional)("ariaLabelledById", ctx_r14.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r14.rateFactorQuestionUIDataMap[question_r4.name].ariaLabelledById)("ariaDescribedById", ctx_r14.formErrors[question_r4.name] ? question_r4.name + "ValidationError" : "")("toggleControlId", question_r4.name)("isReadOnly", ctx_r14.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r14.rateFactorQuestionUIDataMap[question_r4.name].isPopulatedFromSSO);
} }
function RateFactorsFormComponent_div_6_ng_container_2_vnext_rate_factor_dropdown_14_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-rate-factor-dropdown", 38, 39);
    i0.ɵɵlistener("selectRateFactorDropdownItem", function RateFactorsFormComponent_div_6_ng_container_2_vnext_rate_factor_dropdown_14_Template_vnext_rate_factor_dropdown_selectRateFactorDropdownItem_0_listener($event) { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r34.onSelectNumberOfDaysDropdownItem($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r4 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r15 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r15.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r15.rateFactorQuestionUIDataMap[question_r4.name].control)("dropdownItems", ctx_r15.numberOfDaysDropdownItems)("dropdownDefaultText", ctx_r15.dropdownDefaultText)("ariaLabelledById", ctx_r15.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r15.rateFactorQuestionUIDataMap[question_r4.name].ariaLabelledById)("ariaDescribedById", ctx_r15.formErrors[question_r4.name] ? question_r4.name + "ValidationError" : "")("offsetItems", 10);
} }
function RateFactorsFormComponent_div_6_ng_container_2_vnext_rate_factor_dropdown_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-rate-factor-dropdown", 40, 41);
} if (rf & 2) {
    const question_r4 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r16 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r16.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r16.rateFactorQuestionUIDataMap[question_r4.name].control)("dropdownItems", ctx_r16.daysBenefitsDropdownItems)("dropdownDefaultText", ctx_r16.dropdownDefaultText)("ariaLabelledById", ctx_r16.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r16.rateFactorQuestionUIDataMap[question_r4.name].ariaLabelledById)("ariaDescribedById", ctx_r16.formErrors[question_r4.name] ? question_r4.name + "ValidationError" : "")("offsetItems", 10);
} }
function RateFactorsFormComponent_div_6_ng_container_2_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 42);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r17.rateFactorDisclaimer, " ");
} }
const _c4$x = function (a0) { return { "error-color": a0 }; };
const _c5$i = function (a0) { return { Spa_Style_Gray4_Color: a0 }; };
function RateFactorsFormComponent_div_6_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 8);
    i0.ɵɵtemplate(2, RateFactorsFormComponent_div_6_ng_container_2_div_2_Template, 4, 4, "div", 9);
    i0.ɵɵelementStart(3, "div", 10);
    i0.ɵɵtemplate(4, RateFactorsFormComponent_div_6_ng_container_2_span_4_Template, 2, 0, "span", 11);
    i0.ɵɵelement(5, "span", 12);
    i0.ɵɵpipe(6, "safe");
    i0.ɵɵtemplate(7, RateFactorsFormComponent_div_6_ng_container_2_span_7_Template, 4, 1, "span", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(8, 14);
    i0.ɵɵtemplate(9, RateFactorsFormComponent_div_6_ng_container_2_vnext_rate_factor_birth_date_9_Template, 2, 8, "vnext-rate-factor-birth-date", 15);
    i0.ɵɵtemplate(10, RateFactorsFormComponent_div_6_ng_container_2_vnext_rate_factor_effective_date_10_Template, 2, 12, "vnext-rate-factor-effective-date", 16);
    i0.ɵɵtemplate(11, RateFactorsFormComponent_div_6_ng_container_2_vnext_rate_factor_toggle_11_Template, 2, 9, "vnext-rate-factor-toggle", 17);
    i0.ɵɵtemplate(12, RateFactorsFormComponent_div_6_ng_container_2_vnext_rate_factor_toggle_12_Template, 2, 9, "vnext-rate-factor-toggle", 17);
    i0.ɵɵtemplate(13, RateFactorsFormComponent_div_6_ng_container_2_vnext_rate_factor_toggle_13_Template, 2, 8, "vnext-rate-factor-toggle", 18);
    i0.ɵɵtemplate(14, RateFactorsFormComponent_div_6_ng_container_2_vnext_rate_factor_dropdown_14_Template, 2, 6, "vnext-rate-factor-dropdown", 19);
    i0.ɵɵtemplate(15, RateFactorsFormComponent_div_6_ng_container_2_vnext_rate_factor_dropdown_15_Template, 2, 6, "vnext-rate-factor-dropdown", 20);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, RateFactorsFormComponent_div_6_ng_container_2_ng_container_16_Template, 3, 1, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const question_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", ctx_r6.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r6.rateFactorQuestionUIDataMap[question_r4.name].ariaLabelledById);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r6.formErrors[question_r4.name] == null ? null : ctx_r6.formErrors[question_r4.name].length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c4$x, ctx_r6.formErrors[question_r4.name]));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r6.rateFactorQuestionUIDataMap[question_r4.name].required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(6, 16, ctx_r6.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r6.rateFactorQuestionUIDataMap[question_r4.name].description, "html"), i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction1(21, _c5$i, ctx_r6.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r6.rateFactorQuestionUIDataMap[question_r4.name].isPopulatedFromSSO));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r6.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r6.rateFactorQuestionUIDataMap[question_r4.name].tooltip);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", question_r4.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.rateFactorQuestionNames.DateOfBirth);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.rateFactorQuestionNames.EffectiveDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.rateFactorQuestionNames.Gender);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.rateFactorQuestionNames.Tobacco);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.rateFactorQuestionNames.Household);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.rateFactorQuestionNames.HCDaysCovered);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.rateFactorQuestionNames.BenefitAmount);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.rateFactorDisclaimerEnabled && question_r4.name === ctx_r6.rateFactorQuestionNames.EffectiveDate);
} }
function RateFactorsFormComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", null, 7);
    i0.ɵɵtemplate(2, RateFactorsFormComponent_div_6_ng_container_2_Template, 17, 23, "ng-container", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r4 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("question-wrapper ", ctx_r3.questionClasses[question_r4.name], "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !(ctx_r3.rateFactorQuestionUIDataMap[question_r4.name] == null ? null : ctx_r3.rateFactorQuestionUIDataMap[question_r4.name].hidden));
} }
const _c6$h = function (a0) { return { "mx-n1": a0 }; };
class RateFactorsFormComponent {
    constructor(configResourceService, widgetService, rateFactorsFormFacade, rateFactorEffectiveDateService, rateFactorToggleService) {
        this.configResourceService = configResourceService;
        this.widgetService = widgetService;
        this.rateFactorsFormFacade = rateFactorsFormFacade;
        this.rateFactorEffectiveDateService = rateFactorEffectiveDateService;
        this.rateFactorToggleService = rateFactorToggleService;
        // Flag is used when the form is displayed inside a modal
        this.isEmbedded = false;
        this.noneText = 'None';
        this.submitForm = new EventEmitter();
        this.hideForm = new EventEmitter();
        this.formErrors = {
            [MedSupQuestionNames.DateOfBirth]: null,
            [MedSupQuestionNames.Gender]: null,
            [MedSupQuestionNames.Tobacco]: null,
            [MedSupQuestionNames.Household]: null,
            [MedSupQuestionNames.EffectiveDate]: null,
            [MedSupQuestionNames.BenefitAmount]: null,
            [MedSupQuestionNames.HCDaysCovered]: null
        };
        this.numberOfDaysDropdownItems = [];
        this.daysBenefitsDropdownItems = [];
        this.errorMessages = [];
        this.rateFactorQuestionNames = MedSupQuestionNames;
        this.daysBenefitHasNoValue = false;
        this.numberOfDaysHasNoValue = false;
        this.showBenefitsAmountDropdown = false;
        this.widgetName = this.widgetService.widgetName;
        this.showEffectiveDateAsDropdown = this.rateFactorEffectiveDateService.getShowEffectiveDateAsDropdown(this.widgetName);
    }
    ngOnChanges(changes) {
        const { sortedQuestions, questionMetadataMap, answersMap, prePopulatedFields, locale } = changes;
        if ((sortedQuestions && !_isEqual(sortedQuestions.previousValue, sortedQuestions.currentValue)) ||
            (questionMetadataMap && !_isEqual(questionMetadataMap.previousValue, questionMetadataMap.currentValue)) ||
            (answersMap && !_isEqual(answersMap.previousValue, answersMap.currentValue)) ||
            (prePopulatedFields && !_isEqual(prePopulatedFields.previousValue, prePopulatedFields.currentValue))) {
            this.initForm();
        }
        if (locale && locale.previousValue !== locale.currentValue) {
            this.rateFactorQuestionUIDataMap = this.rateFactorsFormFacade.getSortedQuestionUIDataMap(this.sortedQuestions, this.questionMetadataMap, this.answersMap, this.rateFactorsFormFacade.mapPrepopulatedFieldsToRateFactorQuestionNames(this.prePopulatedFields), this.rateFactorsForm);
            this.initializeTranslatableText(this.widgetName);
            if (this.showEffectiveDateAsDropdown) {
                this.configureEffectiveDate(this.rateFactorFormOptions, locale.currentValue);
            }
            this.configureGender();
            this.configureTobacco();
            this.configureHousehold();
            this.validateForm();
            this.numberOfDaysDropdownItems = this.rateFactorsFormFacade.getNumberOfDaysDropdownItems();
            this.pruneDaysAvailableDropdownItems();
            this.updateShowBenefitsAmountDropdown();
        }
    }
    ngOnInit() {
        this.showDatePicker = this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_ShowEffectiveDateInputDatePicker_Flag', this.widgetName, false);
        this.dateMaskFormat = this.rateFactorsFormFacade.getDateMaskFormat();
        this.datePicketInputPlaceholder = DateUtilities.defaultFormat.toLowerCase();
        this.questionClasses = this.rateFactorsFormFacade.addPositionRelativeExtraTopToDropdownQuestionsClasses(this.rateFactorsFormFacade.getQuestionClasses(this.isEmbedded), this.showEffectiveDateAsDropdown);
        this.numberOfDaysDropdownItems = this.rateFactorsFormFacade.getNumberOfDaysDropdownItems();
        this.daysBenefitMapping = this.rateFactorsFormFacade.getDaysBenefitMappings();
        this.initForm();
    }
    ngAfterViewInit() {
        this.rateFactorQuestions?.first?.nativeElement?.querySelector('input')?.focus();
    }
    ngOnDestroy() {
        this.subscriptions?.unsubscribe();
    }
    onSubmitForm() {
        this.rateFactorsFormFacade.markFormAsTouched(this.rateFactorsForm);
        this.validateForm();
        if (this.rateFactorsForm.valid) {
            const updatedQuestions = this.rateFactorsFormFacade.updateQuestionsAnswers(this.sortedQuestions, this.rateFactorsForm.value);
            this.submitForm.emit(updatedQuestions);
        }
    }
    validate(control) {
        // Do not update the form error if the field is hidden
        if (!this.rateFactorQuestionUIDataMap[control.name].hidden) {
            this.formErrors[control.name] = this.getControlErrorMessages(control);
        }
        this.errorMessages = this.getNoticeErrorMessages();
    }
    trackIndex(index) {
        return index;
    }
    onSelectNumberOfDaysDropdownItem(dropdownSelection) {
        this.updateDaysBenefitDropdownItems(dropdownSelection.selectionValue);
        this.updateShowBenefitsAmountDropdown();
    }
    pruneDaysAvailableDropdownItems() {
        const daysWithValues = this.daysBenefitMapping?.map(mapping => mapping.day) ?? [];
        this.numberOfDaysDropdownItems = this.numberOfDaysDropdownItems.filter(dropdownItem => daysWithValues.includes(dropdownItem.selectionValue));
        if (this.numberOfDaysDropdownItems.length === 0) {
            // This value should technically never been seen, but it's left in for defense
            this.numberOfDaysDropdownItems = [{ displayValue: this.noneText, selectionValue: null }];
            this.hideForm.emit(true);
        }
        else {
            this.hideForm.emit(false);
        }
    }
    updateShowBenefitsAmountDropdown() {
        if (this.rateFactorQuestionUIDataMap[MedSupQuestionNames.BenefitAmount]) {
            this.rateFactorQuestionUIDataMap[MedSupQuestionNames.BenefitAmount].hidden =
                !this.rateFactorsForm.value[MedSupQuestionNames.HCDaysCovered];
        }
    }
    updateDaysBenefitDropdownItems(numberOfDays, resetBenefitsAmount = true) {
        if (resetBenefitsAmount) {
            this.resetBenefitsAmountSelection();
        }
        const matchingDay = this.daysBenefitMapping?.find(mapping => mapping.day === numberOfDays);
        if (matchingDay) {
            const sortedValues = [...matchingDay.benefitAmounts].sort((a, b) => a - b);
            this.daysBenefitsDropdownItems = sortedValues.map(dayData => ({
                displayValue: dayData.toString(),
                selectionValue: dayData
            }));
        }
        else {
            // With other logic, this technically should never be used
            this.daysBenefitsDropdownItems = [{ displayValue: this.noneText, selectionValue: null }];
        }
    }
    resetBenefitsAmountSelection() {
        this.rateFactorsForm.controls[MedSupQuestionNames.BenefitAmount]?.reset();
        this.validateForm();
    }
    resetErrors() {
        this.errorMessages = [];
        Object.keys(this.formErrors).forEach(errorKey => {
            this.formErrors[errorKey] = '';
        });
    }
    initForm() {
        this.resetErrors();
        this.initializeTranslatableText(this.widgetName);
        this.rateFactorFormOptions = {
            showEffectiveDateAsDropdown: this.showEffectiveDateAsDropdown
        };
        this.rateFactorQuestionUIDataMap = this.rateFactorsFormFacade.getSortedQuestionUIDataMap(this.sortedQuestions, this.questionMetadataMap, this.answersMap, this.rateFactorsFormFacade.mapPrepopulatedFieldsToRateFactorQuestionNames(this.prePopulatedFields));
        this.rateFactorFormOptions.questionUIDataMap = this.rateFactorQuestionUIDataMap;
        this.configureBirthDate(this.rateFactorFormOptions);
        this.configureEffectiveDate(this.rateFactorFormOptions, this.locale);
        this.configureGender();
        this.configureTobacco();
        this.configureHousehold();
        this.rateFactorsForm = this.rateFactorsFormFacade.getRateFactorsForm(this.rateFactorFormOptions, this);
        const numberOfDaysDefaultValue = this.rateFactorsForm.value[MedSupQuestionNames.HCDaysCovered];
        this.updateDaysBenefitDropdownItems(numberOfDaysDefaultValue, false);
        this.pruneDaysAvailableDropdownItems();
        this.updateShowBenefitsAmountDropdown();
        this.validateFormOnSubmitValueChanges(this.rateFactorsForm, this.ngFormInstance);
    }
    initializeTranslatableText(widgetName) {
        this.datePickerButtonLabelText = this.configResourceService.getProcessedResourceValue('Spa_Site_DatePicker_Button_Label_Text', widgetName, 'Choose Date');
    }
    focusFirstInvalidRateFactorControl() {
        this.errorContainer?.first?.nativeElement?.scrollIntoView({ behavior: 'smooth' });
        this.findAndFocusFirstInvalidRateFactorControl();
    }
    findAndFocusFirstInvalidRateFactorControl() {
        const firstInvalidRateFactorControl = this.findFirstInvalidRateFactorControl();
        if (firstInvalidRateFactorControl) {
            this.rateFactorFields.find(({ control }) => control.name === firstInvalidRateFactorControl.name)?.focus();
        }
    }
    findFirstInvalidRateFactorControl() {
        for (const question of this.sortedQuestions) {
            const control = this.rateFactorsForm.get(question.name);
            if (this.rateFactorsFormFacade.isControlInvalid(control)) {
                return control;
            }
        }
    }
    configureBirthDate(rateFactorFormOptions) {
        if (rateFactorFormOptions.questionUIDataMap?.DateOfBirth) {
            const maxAge = this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_Maximum_Age', this.widgetName, 105);
            rateFactorFormOptions.minBirthDate = DateUtilities.getPreviousDate(new Date(), maxAge, DateUtilities.defaultFormat, 'years');
            rateFactorFormOptions.maxBirthDate = DateUtilities.getFormattedCurrentDate();
            this.minBirthDate = DateUtilities.parseDateToNgbDate(rateFactorFormOptions.minBirthDate);
            this.maxBirthDate = DateUtilities.parseDateToNgbDate(rateFactorFormOptions.maxBirthDate);
        }
    }
    configureEffectiveDate(rateFactorFormOptions, locale) {
        if (rateFactorFormOptions.questionUIDataMap?.EffectiveDate) {
            if (this.showEffectiveDateAsDropdown) {
                this.effectiveDateDropdownItems = this.rateFactorsFormFacade.getEffectiveDateListOfMonths(this.widgetName, this.rateFactorEffectiveDateService.getDisplayFormat(), locale);
            }
            else {
                this.minEffectiveDate = this.rateFactorEffectiveDateService.getMinEffectiveDate(this.widgetName);
                this.maxEffectiveDate = this.rateFactorEffectiveDateService.getMaxEffectiveDate(this.widgetName);
                rateFactorFormOptions.minEffectiveDate = DateUtilities.getDefaultFormattedDate(this.minEffectiveDate);
                rateFactorFormOptions.maxEffectiveDate = DateUtilities.getDefaultFormattedDate(this.maxEffectiveDate);
            }
        }
    }
    configureGender() {
        const genderQuestion = this.sortedQuestions.find(question => question.name === MedSupQuestionNames.Gender);
        if (genderQuestion) {
            this.genderToggleItems = this.rateFactorToggleService.getToggleItems(genderQuestion);
        }
    }
    configureTobacco() {
        const tobaccoQuestion = this.sortedQuestions.find(question => question.name === MedSupQuestionNames.Tobacco);
        if (tobaccoQuestion) {
            this.tobaccoToggleItems = this.rateFactorToggleService.getToggleItems(tobaccoQuestion);
        }
    }
    configureHousehold() {
        const householdQuestion = this.sortedQuestions.find(question => question.name === MedSupQuestionNames.Household);
        if (householdQuestion) {
            this.householdToggleItems = this.rateFactorToggleService.getToggleItems(householdQuestion);
        }
    }
    getControlErrorMessages(control) {
        let errors = null;
        if (this.rateFactorsFormFacade.isControlInvalid(control)) {
            const inputErrors = this.rateFactorsFormFacade.getErrorMessages(control, this.widgetName);
            errors = this.selectErrorMessages(inputErrors);
        }
        return errors;
    }
    validateForm() {
        Object.values(this.rateFactorsForm.controls).forEach((control) => {
            this.validate(control);
        });
        if (this.errorMessages.length > 0) {
            this.focusFirstInvalidRateFactorControl();
        }
    }
    selectErrorMessages(errors) {
        const { Required, Invalid, FutureDate, PastDate } = errors;
        const errorMessages = [Required || Invalid || FutureDate || PastDate].filter(errorMessage => !!errorMessage);
        return errorMessages;
    }
    getNoticeErrorMessages() {
        return Object.values(this.formErrors).reduce((messages, error) => {
            if (error?.length > 0) {
                messages.push({ message: error[0] });
            }
            return messages;
        }, []);
    }
    validateFormOnSubmitValueChanges(rateFactorsForm, ngForm) {
        if (rateFactorsForm?.controls) {
            this.subscriptions?.unsubscribe();
            this.subscriptions = new Subscription();
            for (const control of Object.values(rateFactorsForm.controls)) {
                this.subscriptions.add(control.valueChanges.pipe(filter(() => !ngForm?.submitted)).subscribe({
                    next: () => {
                        this.validate(control);
                    }
                }));
            }
        }
    }
}
RateFactorsFormComponent.ɵfac = function RateFactorsFormComponent_Factory(t) { return new (t || RateFactorsFormComponent)(i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(RateFactorsFormFacade), i0.ɵɵdirectiveInject(RateFactorEffectiveDateService), i0.ɵɵdirectiveInject(RateFactorToggleService)); };
RateFactorsFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RateFactorsFormComponent, selectors: [["vnext-rate-factors-form"]], viewQuery: function RateFactorsFormComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3Q, 5);
        i0.ɵɵviewQuery(_c1$22, 5);
        i0.ɵɵviewQuery(_c2$1f, 5);
        i0.ɵɵviewQuery(_c3$U, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ngFormInstance = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.errorContainer = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rateFactorQuestions = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rateFactorFields = _t);
    } }, inputs: { sortedQuestions: "sortedQuestions", questionMetadataMap: "questionMetadataMap", answersMap: "answersMap", prePopulatedFields: "prePopulatedFields", locale: "locale", errorKeywordText: "errorKeywordText", errorNoticeTitle: "errorNoticeTitle", dropdownDefaultText: "dropdownDefaultText", isEmbedded: "isEmbedded", noneText: "noneText", rateFactorDisclaimer: "rateFactorDisclaimer", rateFactorDisclaimerEnabled: "rateFactorDisclaimerEnabled" }, outputs: { submitForm: "submitForm", hideForm: "hideForm" }, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 7, consts: [["errorContainer", ""], [4, "ngIf"], [3, "formGroup", "ngSubmit"], ["ngFormInstance", "ngForm"], [1, "questions-container", "row", 3, "ngClass"], [3, "class", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "title", "messages", "type", "errorKeywordText"], ["rateFactorQuestions", ""], [1, "question-name", 3, "id"], ["class", "error-message", 3, "id", 4, "ngIf"], ["id", "guaranteed-issue-question-header", 1, "question-header", "Spa_Style_Bold_Weight", 3, "ngClass"], ["class", "input-error-asterisk", 4, "ngIf"], ["navigationAdapter", "", 3, "innerHTML", "ngClass"], ["class", "pl-1 med-sup-tooltip", 4, "ngIf"], [3, "ngSwitch"], [3, "control", "dateMaskFormat", "minDate", "maxDate", "datePicketInputPlaceholder", "ariaDescribedById", "ariaLabelledById", "isReadOnly", 4, "ngSwitchCase"], [3, "control", "dropdownItems", "dateMaskFormat", "minDate", "maxDate", "showDatePicker", "showAsDropdown", "dropdownDefaultText", "datePicketInputPlaceholder", "ariaLabelledById", "ariaDescribedById", "datePickerButtonLabelText", 4, "ngSwitchCase"], [3, "control", "items", "fieldName", "limitButtonWidth", "ariaLabelledById", "ariaDescribedById", "ariaRequired", "toggleControlId", "isReadOnly", 4, "ngSwitchCase"], [3, "control", "items", "fieldName", "limitButtonWidth", "ariaLabelledById", "ariaDescribedById", "toggleControlId", "isReadOnly", 4, "ngSwitchCase"], [3, "control", "dropdownItems", "dropdownDefaultText", "ariaLabelledById", "ariaDescribedById", "offsetItems", "selectRateFactorDropdownItem", 4, "ngSwitchCase"], [3, "control", "dropdownItems", "dropdownDefaultText", "ariaLabelledById", "ariaDescribedById", "offsetItems", 4, "ngSwitchCase"], [1, "error-message", 3, "id"], [1, "sr-only"], [3, "errors", "showInline"], [1, "input-error-asterisk"], [1, "pl-1", "med-sup-tooltip"], ["rateFactorTooltip", ""], ["aria-label", "Show tooltip", 1, "fas", "Spa_Style_QuestionIcon", 3, "ngbTooltip"], ["navigationAdapter", "", 1, "Spa_Style_ToolTip", 3, "innerHTML"], [3, "control", "dateMaskFormat", "minDate", "maxDate", "datePicketInputPlaceholder", "ariaDescribedById", "ariaLabelledById", "isReadOnly"], ["rateFactorDateOfBirth", ""], [3, "control", "dropdownItems", "dateMaskFormat", "minDate", "maxDate", "showDatePicker", "showAsDropdown", "dropdownDefaultText", "datePicketInputPlaceholder", "ariaLabelledById", "ariaDescribedById", "datePickerButtonLabelText"], ["rateFactorEffectiveDate", ""], [3, "control", "items", "fieldName", "limitButtonWidth", "ariaLabelledById", "ariaDescribedById", "ariaRequired", "toggleControlId", "isReadOnly"], ["rateFactorGender", ""], ["rateFactorTobacco", ""], [3, "control", "items", "fieldName", "limitButtonWidth", "ariaLabelledById", "ariaDescribedById", "toggleControlId", "isReadOnly"], ["rateFactorHousehold", ""], [3, "control", "dropdownItems", "dropdownDefaultText", "ariaLabelledById", "ariaDescribedById", "offsetItems", "selectRateFactorDropdownItem"], ["rateFactorNumberOfDays", ""], [3, "control", "dropdownItems", "dropdownDefaultText", "ariaLabelledById", "ariaDescribedById", "offsetItems"], ["rateFactorBenefitAmount", ""], [1, "Spa_Style_Paragraph", "my-2"]], template: function RateFactorsFormComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", null, 0);
        i0.ɵɵtemplate(2, RateFactorsFormComponent_ng_container_2_Template, 2, 4, "ng-container", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "form", 2, 3);
        i0.ɵɵlistener("ngSubmit", function RateFactorsFormComponent_Template_form_ngSubmit_3_listener() { return ctx.onSubmitForm(); });
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵtemplate(6, RateFactorsFormComponent_div_6_Template, 3, 4, "div", 5);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.errorMessages.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.rateFactorsForm);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c6$h, ctx.isEmbedded));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.sortedQuestions)("ngForTrackBy", ctx.trackIndex);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, i4.ɵNgNoValidate, i4.NgControlStatusGroup, i4.FormGroupDirective, NavigationAdapterDirective, i1$1.NgbTooltip, RateFactorBirthDateComponent, RateFactorDropdownComponent, RateFactorEffectiveDateComponent, RateFactorToggleComponent, FieldErrorsComponent, NoticeComponent, SafePipe], styles: ["h2[_ngcontent-%COMP%]{margin-top:50px}.questions-container[_ngcontent-%COMP%]{align-items:baseline;font-size:16px}.question-wrapper[_ngcontent-%COMP%]{margin-bottom:30px}.question-name[_ngcontent-%COMP%]{width:100%}.question-header[_ngcontent-%COMP%]{margin-bottom:6px}.extra-top[_ngcontent-%COMP%]{top:6px}.error-message[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent2)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RateFactorsFormComponent, [{
        type: Component,
        args: [{ selector: 'vnext-rate-factors-form', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div #errorContainer>\r\n  <ng-container *ngIf=\"errorMessages.length\">\r\n    <vnext-notice\r\n      [title]=\"errorNoticeTitle\"\r\n      [messages]=\"errorMessages\"\r\n      [type]=\"'error'\"\r\n      [errorKeywordText]=\"errorKeywordText\"\r\n    ></vnext-notice>\r\n  </ng-container>\r\n</div>\r\n<form [formGroup]=\"rateFactorsForm\" #ngFormInstance=\"ngForm\" (ngSubmit)=\"onSubmitForm()\">\r\n  <div class=\"questions-container row\" [ngClass]=\"{ 'mx-n1': isEmbedded }\">\r\n    <div\r\n      #rateFactorQuestions\r\n      *ngFor=\"let question of sortedQuestions; trackBy: trackIndex\"\r\n      class=\"question-wrapper {{ questionClasses[question.name] }}\"\r\n    >\r\n      <ng-container *ngIf=\"!rateFactorQuestionUIDataMap[question.name]?.hidden\">\r\n        <label class=\"question-name\" [id]=\"rateFactorQuestionUIDataMap[question.name]?.ariaLabelledById\">\r\n          <div class=\"error-message\" *ngIf=\"formErrors[question.name]?.length > 0\" [id]=\"question.name + 'ValidationError'\">\r\n            <span class=\"sr-only\">{{ errorKeywordText }}</span>\r\n            <vnext-widget-field-errors [errors]=\"formErrors[question.name]\" [showInline]=\"false\"></vnext-widget-field-errors>\r\n          </div>\r\n\r\n          <div\r\n            class=\"question-header Spa_Style_Bold_Weight\"\r\n            [ngClass]=\"{ 'error-color': formErrors[question.name] }\"\r\n            id=\"guaranteed-issue-question-header\"\r\n          >\r\n            <span class=\"input-error-asterisk\" *ngIf=\"rateFactorQuestionUIDataMap[question.name]?.required\">*</span>\r\n            <span\r\n              [innerHTML]=\"rateFactorQuestionUIDataMap[question.name]?.description | safe : 'html'\"\r\n              navigationAdapter\r\n              [ngClass]=\"{ Spa_Style_Gray4_Color: rateFactorQuestionUIDataMap[question.name]?.isPopulatedFromSSO }\"\r\n            ></span>\r\n            <span class=\"pl-1 med-sup-tooltip\" *ngIf=\"rateFactorQuestionUIDataMap[question.name]?.tooltip; let tooltipKey\">\r\n              <ng-template #rateFactorTooltip>\r\n                <div [innerHTML]=\"tooltipKey | safe : 'html'\" class=\"Spa_Style_ToolTip\" navigationAdapter></div>\r\n              </ng-template>\r\n              <i class=\"fas Spa_Style_QuestionIcon\" [ngbTooltip]=\"rateFactorTooltip\" aria-label=\"Show tooltip\"></i>\r\n            </span>\r\n          </div>\r\n\r\n          <ng-container [ngSwitch]=\"question.name\">\r\n            <vnext-rate-factor-birth-date\r\n              #rateFactorDateOfBirth\r\n              *ngSwitchCase=\"rateFactorQuestionNames.DateOfBirth\"\r\n              [control]=\"rateFactorQuestionUIDataMap[question.name]?.control\"\r\n              [dateMaskFormat]=\"dateMaskFormat\"\r\n              [minDate]=\"minBirthDate\"\r\n              [maxDate]=\"maxBirthDate\"\r\n              [datePicketInputPlaceholder]=\"datePicketInputPlaceholder\"\r\n              [ariaDescribedById]=\"formErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n              [ariaLabelledById]=\"rateFactorQuestionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [isReadOnly]=\"rateFactorQuestionUIDataMap[question.name]?.isPopulatedFromSSO\"\r\n            ></vnext-rate-factor-birth-date>\r\n\r\n            <vnext-rate-factor-effective-date\r\n              #rateFactorEffectiveDate\r\n              *ngSwitchCase=\"rateFactorQuestionNames.EffectiveDate\"\r\n              [control]=\"rateFactorQuestionUIDataMap[question.name]?.control\"\r\n              [dropdownItems]=\"effectiveDateDropdownItems\"\r\n              [dateMaskFormat]=\"dateMaskFormat\"\r\n              [minDate]=\"minEffectiveDate\"\r\n              [maxDate]=\"maxEffectiveDate\"\r\n              [showDatePicker]=\"showDatePicker\"\r\n              [showAsDropdown]=\"showEffectiveDateAsDropdown\"\r\n              [dropdownDefaultText]=\"dropdownDefaultText\"\r\n              [datePicketInputPlaceholder]=\"datePicketInputPlaceholder\"\r\n              [ariaLabelledById]=\"rateFactorQuestionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [ariaDescribedById]=\"formErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n              [datePickerButtonLabelText]=\"datePickerButtonLabelText\"\r\n            ></vnext-rate-factor-effective-date>\r\n\r\n            <vnext-rate-factor-toggle\r\n              #rateFactorGender\r\n              *ngSwitchCase=\"rateFactorQuestionNames.Gender\"\r\n              [control]=\"rateFactorQuestionUIDataMap[question.name]?.control\"\r\n              [items]=\"genderToggleItems\"\r\n              [fieldName]=\"rateFactorQuestionNames.Gender\"\r\n              [limitButtonWidth]=\"question.name === rateFactorQuestionNames.GIAdditional\"\r\n              [ariaLabelledById]=\"rateFactorQuestionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [ariaDescribedById]=\"formErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n              [ariaRequired]=\"rateFactorQuestionUIDataMap[question.name]?.required\"\r\n              [toggleControlId]=\"question.name\"\r\n              [isReadOnly]=\"rateFactorQuestionUIDataMap[question.name]?.isPopulatedFromSSO\"\r\n            >\r\n            </vnext-rate-factor-toggle>\r\n\r\n            <vnext-rate-factor-toggle\r\n              #rateFactorTobacco\r\n              *ngSwitchCase=\"rateFactorQuestionNames.Tobacco\"\r\n              [control]=\"rateFactorQuestionUIDataMap[question.name]?.control\"\r\n              [items]=\"tobaccoToggleItems\"\r\n              [fieldName]=\"rateFactorQuestionNames.Tobacco\"\r\n              [limitButtonWidth]=\"question.name === rateFactorQuestionNames.GIAdditional\"\r\n              [ariaLabelledById]=\"rateFactorQuestionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [ariaDescribedById]=\"formErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n              [ariaRequired]=\"rateFactorQuestionUIDataMap[question.name]?.required\"\r\n              [toggleControlId]=\"question.name\"\r\n              [isReadOnly]=\"rateFactorQuestionUIDataMap[question.name]?.isPopulatedFromSSO\"\r\n            >\r\n            </vnext-rate-factor-toggle>\r\n\r\n            <vnext-rate-factor-toggle\r\n              #rateFactorHousehold\r\n              *ngSwitchCase=\"rateFactorQuestionNames.Household\"\r\n              [control]=\"rateFactorQuestionUIDataMap[question.name]?.control\"\r\n              [items]=\"householdToggleItems\"\r\n              [fieldName]=\"rateFactorQuestionNames.Household\"\r\n              [limitButtonWidth]=\"question.name === rateFactorQuestionNames.GIAdditional\"\r\n              [ariaLabelledById]=\"rateFactorQuestionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [ariaDescribedById]=\"formErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n              [toggleControlId]=\"question.name\"\r\n              [isReadOnly]=\"rateFactorQuestionUIDataMap[question.name]?.isPopulatedFromSSO\"\r\n            >\r\n            </vnext-rate-factor-toggle>\r\n\r\n            <vnext-rate-factor-dropdown\r\n              #rateFactorNumberOfDays\r\n              *ngSwitchCase=\"rateFactorQuestionNames.HCDaysCovered\"\r\n              [control]=\"rateFactorQuestionUIDataMap[question.name]?.control\"\r\n              [dropdownItems]=\"numberOfDaysDropdownItems\"\r\n              [dropdownDefaultText]=\"dropdownDefaultText\"\r\n              [ariaLabelledById]=\"rateFactorQuestionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [ariaDescribedById]=\"formErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n              [offsetItems]=\"10\"\r\n              (selectRateFactorDropdownItem)=\"onSelectNumberOfDaysDropdownItem($event)\"\r\n            >\r\n            </vnext-rate-factor-dropdown>\r\n\r\n            <vnext-rate-factor-dropdown\r\n              #rateFactorBenefitAmount\r\n              *ngSwitchCase=\"rateFactorQuestionNames.BenefitAmount\"\r\n              [control]=\"rateFactorQuestionUIDataMap[question.name]?.control\"\r\n              [dropdownItems]=\"daysBenefitsDropdownItems\"\r\n              [dropdownDefaultText]=\"dropdownDefaultText\"\r\n              [ariaLabelledById]=\"rateFactorQuestionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [ariaDescribedById]=\"formErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n              [offsetItems]=\"10\"\r\n            >\r\n            </vnext-rate-factor-dropdown>\r\n          </ng-container>\r\n        </label>\r\n\r\n        <ng-container *ngIf=\"rateFactorDisclaimerEnabled && question.name === rateFactorQuestionNames.EffectiveDate\">\r\n          <div class=\"Spa_Style_Paragraph my-2\">\r\n            {{ rateFactorDisclaimer }}\r\n          </div>\r\n        </ng-container>\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n</form>\r\n", styles: ["h2{margin-top:50px}.questions-container{align-items:baseline;font-size:16px}.question-wrapper{margin-bottom:30px}.question-name{width:100%}.question-header{margin-bottom:6px}.extra-top{top:6px}.error-message{color:var(--static-Spa_Style_Accent2)}\n"] }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: WidgetService }, { type: RateFactorsFormFacade }, { type: RateFactorEffectiveDateService }, { type: RateFactorToggleService }]; }, { ngFormInstance: [{
            type: ViewChild,
            args: ['ngFormInstance']
        }], errorContainer: [{
            type: ViewChildren,
            args: ['errorContainer']
        }], rateFactorQuestions: [{
            type: ViewChildren,
            args: ['rateFactorQuestions']
        }], rateFactorFields: [{
            type: ViewChildren,
            args: ['rateFactorDateOfBirth, rateFactorEffectiveDate, rateFactorGender, rateFactorTobacco, rateFactorHousehold, rateFactorNumberOfDays, rateFactorBenefitAmount']
        }], sortedQuestions: [{
            type: Input
        }], questionMetadataMap: [{
            type: Input
        }], answersMap: [{
            type: Input
        }], prePopulatedFields: [{
            type: Input
        }], locale: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], errorNoticeTitle: [{
            type: Input
        }], dropdownDefaultText: [{
            type: Input
        }], isEmbedded: [{
            type: Input
        }], noneText: [{
            type: Input
        }], rateFactorDisclaimer: [{
            type: Input
        }], rateFactorDisclaimerEnabled: [{
            type: Input
        }], submitForm: [{
            type: Output
        }], hideForm: [{
            type: Output
        }] }); })();

/**
 * Marks a property as configurable by platform. Additionally registers each
 * prop annotated as such on the containing class ( should be a ConfigurableWidget )
 * so that this properties value comes from the platform override file.
 */
function PlatformProp(binding, preProcess) {
    return function _platformProp(target, key) {
        if (!target[PLATFORM_OVERRIDES_KEY]) {
            target[PLATFORM_OVERRIDES_KEY] = [];
        }
        // if we are manually setting the config property use that
        // otherwise the property name is expected in the config json
        target[PLATFORM_OVERRIDES_KEY].push(key);
        if (preProcess) {
            if (!target[PRE_PROCESS_PROP_KEY]) {
                target[PRE_PROCESS_PROP_KEY] = [];
            }
            target[PRE_PROCESS_PROP_KEY].push(key);
        }
    };
}

function PageNavButtonComponent_ng_container_0_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵlistener("click", function PageNavButtonComponent_ng_container_0_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.onClick()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("className", "btn " + ctx_r3.btnClass);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.link.title, " ");
} }
function PageNavButtonComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PageNavButtonComponent_ng_container_0_button_1_Template, 2, 2, "button", 2);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", ctx_r0.link.titleResourceName);
} }
function PageNavButtonComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵlistener("click", function PageNavButtonComponent_ng_template_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.onClick()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("className", "btn " + ctx_r2.btnClass);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.link.title, " ");
} }
class PageNavButtonComponent {
    constructor(navigationService) {
        this.navigationService = navigationService;
        this.clickAction = new EventEmitter();
    }
    onClick() {
        if (this.emitAction) {
            this.clickAction.emit();
        }
        else {
            this.navigationService.navigate(this.link);
        }
    }
}
PageNavButtonComponent.ɵfac = function PageNavButtonComponent_Factory(t) { return new (t || PageNavButtonComponent)(i0.ɵɵdirectiveInject(i1.NavigationService)); };
PageNavButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PageNavButtonComponent, selectors: [["vnext-page-nav-button"]], inputs: { link: "link", btnClass: "btnClass", emitAction: "emitAction" }, outputs: { clickAction: "clickAction" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["noTitleResourceName", ""], [3, "className", "click", 4, "liveEditProp"], [3, "className", "click"]], template: function PageNavButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PageNavButtonComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
        i0.ɵɵtemplate(1, PageNavButtonComponent_ng_template_1_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.link.titleResourceName)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgIf, LiveEditPropDirective], encapsulation: 2, changeDetection: 0 });
__decorate([
    LiveEditInactive()
], PageNavButtonComponent.prototype, "onClick", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageNavButtonComponent, [{
        type: Component,
        args: [{ selector: 'vnext-page-nav-button', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"link.titleResourceName; else noTitleResourceName\">\r\n  <button (click)=\"onClick()\" *liveEditProp=\"link.titleResourceName\" [className]=\"'btn ' + btnClass\">\r\n    {{ link.title }}\r\n  </button>\r\n</ng-container>\r\n<ng-template #noTitleResourceName>\r\n  <button (click)=\"onClick()\" [className]=\"'btn ' + btnClass\">\r\n    {{ link.title }}\r\n  </button>\r\n</ng-template>\r\n" }]
    }], function () { return [{ type: i1.NavigationService }]; }, { link: [{
            type: Input
        }], btnClass: [{
            type: Input
        }], emitAction: [{
            type: Input
        }], clickAction: [{
            type: Output
        }], onClick: [] }); })();

class LogoutButtonComponent {
    constructor(agentService, navigationService, memberSessionService, store) {
        this.agentService = agentService;
        this.navigationService = navigationService;
        this.memberSessionService = memberSessionService;
        this.store = store;
    }
    logout() {
        if (!this.emitAnalyticsEvent) {
            this.memberSessionService.memberLogout();
            this.agentService.resetAgentLogout();
            if (this.link) {
                this.navigationService.navigate(this.link);
            }
        }
    }
}
LogoutButtonComponent.ɵfac = function LogoutButtonComponent_Factory(t) { return new (t || LogoutButtonComponent)(i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i2.Store)); };
LogoutButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LogoutButtonComponent, selectors: [["vnext-logout-button"]], inputs: { link: "link", btnClass: "btnClass", emitAnalyticsEvent: "emitAnalyticsEvent" }, decls: 1, vars: 3, consts: [[3, "emitAction", "link", "btnClass", "clickAction"]], template: function LogoutButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-page-nav-button", 0);
        i0.ɵɵlistener("clickAction", function LogoutButtonComponent_Template_vnext_page_nav_button_clickAction_0_listener() { return ctx.logout(); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("emitAction", true)("link", ctx.link)("btnClass", "width-full width-md-initial " + ctx.btnClass);
    } }, dependencies: [PageNavButtonComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LogoutButtonComponent, [{
        type: Component,
        args: [{ selector: 'vnext-logout-button', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-page-nav-button [emitAction]=\"true\" (clickAction)=\"logout()\" [link]=\"link\" [btnClass]=\"'width-full width-md-initial ' + btnClass\">\r\n</vnext-page-nav-button>\r\n" }]
    }], function () { return [{ type: i1.AgentService }, { type: i1.NavigationService }, { type: i1.MemberSessionService }, { type: i2.Store }]; }, { link: [{
            type: Input
        }], btnClass: [{
            type: Input
        }], emitAnalyticsEvent: [{
            type: Input
        }] }); })();

function NavigationBannerComponent_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function NavigationBannerComponent_ng_container_4_ng_template_2_vnext_link_0_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 13);
    i0.ɵɵlistener("click", function NavigationBannerComponent_ng_container_4_ng_template_2_vnext_link_0_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r12.navigationService.backToPrevious()); })("keyup.enter", function NavigationBannerComponent_ng_container_4_ng_template_2_vnext_link_0_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r14.navigationService.backToPrevious()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("title", ctx_r11.Spa_Site_Previous)("isLinkButton", true)("showArrow", "left")("makeInlineBlock", true);
} }
function NavigationBannerComponent_ng_container_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, NavigationBannerComponent_ng_container_4_ng_template_2_vnext_link_0_Template, 1, 4, "vnext-link", 12);
} if (rf & 2) {
    i0.ɵɵproperty("liveEditProp", "Spa_Site_Previous");
} }
function NavigationBannerComponent_ng_container_4_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0);
} }
function NavigationBannerComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NavigationBannerComponent_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵtemplate(2, NavigationBannerComponent_ng_container_4_ng_template_2_Template, 1, 1, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, NavigationBannerComponent_ng_container_4_ng_template_4_Template, 1, 0, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r7 = i0.ɵɵreference(3);
    const _r9 = i0.ɵɵreference(5);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.providedPrevious)("ngIfThen", _r9)("ngIfElse", _r7);
} }
function NavigationBannerComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function NavigationBannerComponent_ng_template_8_vnext_logout_button_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-logout-button", 16);
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("link", ctx_r15.link)("emitAnalyticsEvent", ctx_r15.emitAction)("btnClass", "width-full width-md-initial " + ctx_r15.btnClass);
} }
function NavigationBannerComponent_ng_template_8_vnext_page_nav_button_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-page-nav-button", 17);
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("link", ctx_r16.link)("btnClass", "width-full width-md-initial " + ctx_r16.btnClass);
} }
function NavigationBannerComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, NavigationBannerComponent_ng_template_8_vnext_logout_button_0_Template, 1, 3, "vnext-logout-button", 14);
    i0.ɵɵtemplate(1, NavigationBannerComponent_ng_template_8_vnext_page_nav_button_1_Template, 1, 2, "vnext-page-nav-button", 15);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r3.isUserLogout);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.isUserLogout);
} }
function NavigationBannerComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 1);
} }
const _c0$3P = [[["", "previous-link", ""]], [["", "continue-button", ""]]];
const _c1$21 = function (a0) { return { "wrapper-top-margin": a0 }; };
const _c2$1e = function (a0) { return { "pl-1": a0 }; };
const _c3$T = ["[previous-link]", "[continue-button]"];
class NavigationBannerComponent {
    constructor(navigationService) {
        this.navigationService = navigationService;
        this.topMargin = true;
        this.Spa_Site_Previous = 'Previous';
    }
}
NavigationBannerComponent.ɵfac = function NavigationBannerComponent_Factory(t) { return new (t || NavigationBannerComponent)(i0.ɵɵdirectiveInject(i1.NavigationService)); };
NavigationBannerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NavigationBannerComponent, selectors: [["vnext-navigation-banner"]], inputs: { link: "link", providedPrevious: "providedPrevious", showPrevious: "showPrevious", btnClass: "btnClass", isUserLogout: "isUserLogout", emitAction: "emitAction", topMargin: "topMargin" }, ngContentSelectors: _c3$T, decls: 12, vars: 10, consts: [[1, "form-row", "mx-0"], [1, "navigation-banner-wrapper", 3, "ngClass"], [1, "nav-child", "action-bar-background", "previous-wrapper"], [1, "prev", 3, "ngClass"], [4, "ngIf"], [1, "nav-child", "action-bar-background", "next-wrapper"], [1, "next"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["defaultButton", ""], ["providedButton", ""], ["default", ""], ["provided", ""], [3, "title", "isLinkButton", "showArrow", "makeInlineBlock", "click", "keyup.enter", 4, "liveEditProp"], [3, "title", "isLinkButton", "showArrow", "makeInlineBlock", "click", "keyup.enter"], [3, "link", "emitAnalyticsEvent", "btnClass", 4, "ngIf"], [3, "link", "btnClass", 4, "ngIf"], [3, "link", "emitAnalyticsEvent", "btnClass"], [3, "link", "btnClass"]], template: function NavigationBannerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0$3P);
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3);
        i0.ɵɵtemplate(4, NavigationBannerComponent_ng_container_4_Template, 6, 3, "ng-container", 4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div", 5)(6, "div", 6);
        i0.ɵɵtemplate(7, NavigationBannerComponent_ng_container_7_Template, 1, 0, "ng-container", 7);
        i0.ɵɵtemplate(8, NavigationBannerComponent_ng_template_8_Template, 2, 2, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(10, NavigationBannerComponent_ng_template_10_Template, 1, 0, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(9);
        const _r4 = i0.ɵɵreference(11);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$21, ctx.topMargin));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c2$1e, !ctx.providedPrevious));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showPrevious);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.link)("ngIfThen", _r2)("ngIfElse", _r4);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, LiveEditPropDirective, PageNavButtonComponent, LogoutButtonComponent, LinkComponent], styles: [".navigation-banner-wrapper[_ngcontent-%COMP%]{display:flex;justify-content:space-between;width:100%;flex-direction:row}.wrapper-top-margin[_ngcontent-%COMP%]{margin-top:73px}.nav-child[_ngcontent-%COMP%]{padding:10px;height:60px;min-height:60px;display:flex;align-items:center}.next-wrapper[_ngcontent-%COMP%]{text-align:right;border-top-right-radius:5px;border-bottom-right-radius:5px}.previous-wrapper[_ngcontent-%COMP%]{flex:auto;padding-right:5px;text-align:left;border-top-left-radius:5px;border-bottom-left-radius:5px}.action-bar-background[_ngcontent-%COMP%]{background:linear-gradient(to bottom,var(--static-Spa_Style_Gray2) 0%,var(--static-Spa_Style_Gray1) 100%)}.next-wrapper[_ngcontent-%COMP%]   button[_ngcontent-%COMP%], .next-wrapper[_ngcontent-%COMP%]   input[type=button][_ngcontent-%COMP%]{max-height:38px}@media (max-width: 767px){.nav-child[_ngcontent-%COMP%]{justify-content:center}.navigation-banner-wrapper[_ngcontent-%COMP%]{flex-direction:column}.previous-wrapper[_ngcontent-%COMP%]{background:none}.next-wrapper[_ngcontent-%COMP%]{border-top-left-radius:5px;border-bottom-left-radius:5px;display:inline-block;height:auto}.next[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]{width:100%}}"], changeDetection: 0 });
__decorate([
    PlatformProp('live-edit')
], NavigationBannerComponent.prototype, "Spa_Site_Previous", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavigationBannerComponent, [{
        type: Component,
        args: [{ selector: 'vnext-navigation-banner', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"form-row mx-0\">\r\n  <div class=\"navigation-banner-wrapper\" [ngClass]=\"{ 'wrapper-top-margin': topMargin }\">\r\n    <div class=\"nav-child action-bar-background previous-wrapper\">\r\n      <div class=\"prev\" [ngClass]=\"{ 'pl-1': !providedPrevious }\">\r\n        <ng-container *ngIf=\"showPrevious\">\r\n          <ng-container *ngIf=\"providedPrevious; then provided; else default\"></ng-container>\r\n          <ng-template #default>\r\n            <vnext-link\r\n              [title]=\"Spa_Site_Previous\"\r\n              [isLinkButton]=\"true\"\r\n              [showArrow]=\"'left'\"\r\n              (click)=\"navigationService.backToPrevious()\"\r\n              (keyup.enter)=\"navigationService.backToPrevious()\"\r\n              [makeInlineBlock]=\"true\"\r\n              *liveEditProp=\"'Spa_Site_Previous'\"\r\n            >\r\n            </vnext-link>\r\n          </ng-template>\r\n          <ng-template #provided>\r\n            <ng-content select=\"[previous-link]\"></ng-content>\r\n          </ng-template>\r\n        </ng-container>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"nav-child action-bar-background next-wrapper\">\r\n      <div class=\"next\">\r\n        <ng-container *ngIf=\"link; then defaultButton; else providedButton\"></ng-container>\r\n        <ng-template #defaultButton>\r\n          <vnext-logout-button\r\n            *ngIf=\"isUserLogout\"\r\n            [link]=\"link\"\r\n            [emitAnalyticsEvent]=\"emitAction\"\r\n            [btnClass]=\"'width-full width-md-initial ' + btnClass\"\r\n          ></vnext-logout-button>\r\n          <vnext-page-nav-button\r\n            *ngIf=\"!isUserLogout\"\r\n            [link]=\"link\"\r\n            [btnClass]=\"'width-full width-md-initial ' + btnClass\"\r\n          ></vnext-page-nav-button>\r\n        </ng-template>\r\n        <ng-template #providedButton>\r\n          <ng-content select=\"[continue-button]\"></ng-content>\r\n        </ng-template>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".navigation-banner-wrapper{display:flex;justify-content:space-between;width:100%;flex-direction:row}.wrapper-top-margin{margin-top:73px}.nav-child{padding:10px;height:60px;min-height:60px;display:flex;align-items:center}.next-wrapper{text-align:right;border-top-right-radius:5px;border-bottom-right-radius:5px}.previous-wrapper{flex:auto;padding-right:5px;text-align:left;border-top-left-radius:5px;border-bottom-left-radius:5px}.action-bar-background{background:linear-gradient(to bottom,var(--static-Spa_Style_Gray2) 0%,var(--static-Spa_Style_Gray1) 100%)}.next-wrapper button,.next-wrapper input[type=button]{max-height:38px}@media (max-width: 767px){.nav-child{justify-content:center}.navigation-banner-wrapper{flex-direction:column}.previous-wrapper{background:none}.next-wrapper{border-top-left-radius:5px;border-bottom-left-radius:5px;display:inline-block;height:auto}.next>button{width:100%}}\n"] }]
    }], function () { return [{ type: i1.NavigationService }]; }, { link: [{
            type: Input
        }], providedPrevious: [{
            type: Input
        }], showPrevious: [{
            type: Input
        }], btnClass: [{
            type: Input
        }], isUserLogout: [{
            type: Input
        }], emitAction: [{
            type: Input
        }], topMargin: [{
            type: Input
        }], Spa_Site_Previous: [] }); })();

const _c0$3O = ["rateFactorsForm"];
function HospitalIndemnityFormComponent_ng_container_0_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r5.spaPageSubHeader, "html"), i0.ɵɵsanitizeHtml);
} }
function HospitalIndemnityFormComponent_ng_container_0_ng_container_1_h2_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.spaPageTitle);
} }
const _c1$20 = function (a0) { return { "mt-4": a0 }; };
function HospitalIndemnityFormComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵtemplate(2, HospitalIndemnityFormComponent_ng_container_0_ng_container_1_div_2_Template, 2, 4, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 5)(4, "div", 6);
    i0.ɵɵtemplate(5, HospitalIndemnityFormComponent_ng_container_0_ng_container_1_h2_5_Template, 2, 1, "h2", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1$20, !ctx_r1.isEmbedded));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_PlanList_HIPFormPrompt_Text");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", "Spa_PlanList_HIP_PageTitle_Text");
} }
function HospitalIndemnityFormComponent_ng_container_0_ng_container_2_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "vnext-navigation-banner", 14)(2, "button", 15);
    i0.ɵɵlistener("click", function HospitalIndemnityFormComponent_ng_container_0_ng_container_2_div_4_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r10); i0.ɵɵnextContext(); const _r7 = i0.ɵɵreference(3); return i0.ɵɵresetView(_r7 == null ? null : _r7.ngFormInstance == null ? null : _r7.ngFormInstance.onSubmit()); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("showPrevious", ctx_r8.showPreviousLink);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.continueButtonText, " ");
} }
function HospitalIndemnityFormComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div")(2, "vnext-rate-factors-form", 10, 11);
    i0.ɵɵlistener("submitForm", function HospitalIndemnityFormComponent_ng_container_0_ng_container_2_Template_vnext_rate_factors_form_submitForm_2_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.continueToPlans($event)); })("hideForm", function HospitalIndemnityFormComponent_ng_container_0_ng_container_2_Template_vnext_rate_factors_form_hideForm_2_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.updateFormVisibility($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, HospitalIndemnityFormComponent_ng_container_0_ng_container_2_div_4_Template, 4, 2, "div", 12);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("sortedQuestions", ctx_r2.sortedQuestions)("questionMetadataMap", ctx_r2.questionMetadataMap)("answersMap", ctx_r2.answersMap)("prePopulatedFields", ctx_r2.prePopulatedFields)("locale", ctx_r2.locale)("isEmbedded", ctx_r2.isEmbedded)("errorKeywordText", ctx_r2.errorKeywordText)("errorNoticeTitle", ctx_r2.errorNoticeTitle)("dropdownDefaultText", ctx_r2.dropdownDefaultText)("noneText", ctx_r2.noneText)("rateFactorDisclaimer", ctx_r2.rateFactorDisclaimer)("rateFactorDisclaimerEnabled", ctx_r2.rateFactorDisclaimerEnabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.isEmbedded);
} }
function HospitalIndemnityFormComponent_ng_container_0_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "div", 17);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 18);
    i0.ɵɵpipe(4, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.noPlansAvailableHeaderText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 2, ctx_r4.noPlansAvailableBodyText, "html"), i0.ɵɵsanitizeHtml);
} }
function HospitalIndemnityFormComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HospitalIndemnityFormComponent_ng_container_0_ng_container_1_Template, 6, 5, "ng-container", 0);
    i0.ɵɵtemplate(2, HospitalIndemnityFormComponent_ng_container_0_ng_container_2_Template, 5, 13, "ng-container", 1);
    i0.ɵɵtemplate(3, HospitalIndemnityFormComponent_ng_container_0_ng_template_3_Template, 5, 5, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r3 = i0.ɵɵreference(4);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.hideForm);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.hideForm)("ngIfElse", _r3);
} }
class HospitalIndemnityFormComponent {
    constructor(hospitalIndemnityFormFacade, ssoPopulatedFieldService, localeService, medSupService, cdr, spinnerService, analyticsService, router) {
        this.hospitalIndemnityFormFacade = hospitalIndemnityFormFacade;
        this.ssoPopulatedFieldService = ssoPopulatedFieldService;
        this.localeService = localeService;
        this.medSupService = medSupService;
        this.cdr = cdr;
        this.spinnerService = spinnerService;
        this.analyticsService = analyticsService;
        this.router = router;
        this.continueButtonText = 'Continue to plans';
        this.plansLoading = false;
        // This flag is used to know if this form is called inside a modal or isn't
        this.isEmbedded = false;
        this.noneText = 'None';
        this.formClose = new EventEmitter();
        this.formSubmit = new EventEmitter();
        this.googleTagManagerNotApplicableText = '';
        this.hideForm = false;
        this.isFormSubmitted = false;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        // Making sure that if we opened this due to all questions being answered we set the form to open
        // Not doing so makes it so the plans list form gets unmounted before event handlers can process
        this.hospitalIndemnityFormFacade.setHospitalIndemnityFormOpenSource(true);
        this.googleTagManagerNotApplicableText = this.analyticsService.getGoogleTagManagerNotApplicableText();
        this.subscriptions.add(combineLatest([
            this.hospitalIndemnityFormFacade.getSortedHospitalIndemnityQuestions$(),
            this.hospitalIndemnityFormFacade.getFilteredHospitalIndemnityQuestionsMetaDataMap$(),
            this.hospitalIndemnityFormFacade.getHospitalIndemnityAnswersMap$(),
            this.ssoPopulatedFieldService.getPopulatedFields$(),
            this.localeService.getCurrentLocale$()
        ])
            .pipe(filter(() => !this.isFormSubmitted))
            .subscribe({
            next: ([sortedQuestions, questionMetadataMap, answersMap, prePopulatedFields, locale]) => {
                this.sortedQuestions = sortedQuestions;
                this.questionMetadataMap = questionMetadataMap;
                this.answersMap = answersMap;
                this.prePopulatedFields = prePopulatedFields;
                this.locale = locale;
                this.cdr.markForCheck();
            }
        }));
        this.updateViewModalGoogleTag();
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    async continueToPlans(updatedQuestions) {
        if (!this.isFormSubmitted) {
            if (!this.isEmbedded) {
                this.spinnerService.show(SpinnerEvent.PLANS_LOADING);
            }
            const { sessionId, year } = this.hospitalIndemnityFormFacade.getRateFactorSessionDetails();
            this.updateRateFactorFormGoogleTag();
            this.isFormSubmitted = true;
            this.formSubmit.next(this.isFormSubmitted);
            try {
                await Promise.all([
                    this.hospitalIndemnityFormFacade.getHospitalIndemnitySelectedQuestions(sessionId, year, updatedQuestions),
                    this.medSupService.updateMedSupAnswers(updatedQuestions),
                    this.medSupService.updateAncillaryPlanAnswers(updatedQuestions)
                ]);
                this.formClose.emit(this.isFormSubmitted);
            }
            catch (error) {
                this.isFormSubmitted = false;
                this.formSubmit.next(this.isFormSubmitted);
                this.spinnerService.hide(SpinnerEvent.PLANS_LOADING);
            }
        }
    }
    updateFormVisibility(flag) {
        this.hideForm = flag;
    }
    updateViewModalGoogleTag() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
            [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_MODAL,
            [DataLayerGlobalVariable.MODAL_NAME]: DataLayerGlobalVariable.HC_QUESTIONS
        };
    }
    updateRateFactorFormGoogleTag() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.DATA_PLAN_SUBTYPE_SELECTION]: this.googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLAN_RATE_FACTOR_QUESTIONNAIRE_COMPLETE
        };
    }
}
HospitalIndemnityFormComponent.ɵfac = function HospitalIndemnityFormComponent_Factory(t) { return new (t || HospitalIndemnityFormComponent)(i0.ɵɵdirectiveInject(HospitalIndemnityFormFacade), i0.ɵɵdirectiveInject(i1.SSOPopulatedFieldService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.MedSupService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i2$1.Router)); };
HospitalIndemnityFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HospitalIndemnityFormComponent, selectors: [["vnext-hospital-indemnity-form"]], viewQuery: function HospitalIndemnityFormComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3O, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rateFactorsForm = _t.first);
    } }, inputs: { continueButtonText: "continueButtonText", plansLoading: "plansLoading", spaPageSubHeader: "spaPageSubHeader", spaPageTitle: "spaPageTitle", errorKeywordText: "errorKeywordText", errorNoticeTitle: "errorNoticeTitle", dropdownDefaultText: "dropdownDefaultText", showPreviousLink: "showPreviousLink", isEmbedded: "isEmbedded", noPlansAvailableHeaderText: "noPlansAvailableHeaderText", noPlansAvailableBodyText: "noPlansAvailableBodyText", rateFactorDisclaimer: "rateFactorDisclaimer", rateFactorDisclaimerEnabled: "rateFactorDisclaimerEnabled", noneText: "noneText" }, outputs: { formClose: "formClose", formSubmit: "formSubmit" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [4, "ngIf", "ngIfElse"], ["noPlansAvailableView", ""], [1, "row", "no-gutters", 3, "ngClass"], ["navigationAdapter", "", "class", "Spa_Style_IntroParagraph", 3, "innerHtml", 4, "liveEditProp"], [1, "row", "no-gutters", "mt-4"], [1, "col-12"], ["class", "Spa_Style_H2", 4, "liveEditProp"], ["navigationAdapter", "", 1, "Spa_Style_IntroParagraph", 3, "innerHtml"], [1, "Spa_Style_H2"], [3, "sortedQuestions", "questionMetadataMap", "answersMap", "prePopulatedFields", "locale", "isEmbedded", "errorKeywordText", "errorNoticeTitle", "dropdownDefaultText", "noneText", "rateFactorDisclaimer", "rateFactorDisclaimerEnabled", "submitForm", "hideForm"], ["rateFactorsForm", ""], ["class", "row no-gutters", 4, "ngIf"], [1, "row", "no-gutters"], [1, "col-12", 3, "showPrevious"], ["continue-button", "", 1, "btn", "Spa_Style_PrimaryButton", "width-full", "width-md-initial", 3, "click"], [1, "w-100", "text-center", "no-plans-available"], [1, "Spa_Style_Large_Font", "font-weight-bold"], ["navigationAdapter", "", 1, "Spa_Style_H5", 3, "innerHTML"]], template: function HospitalIndemnityFormComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, HospitalIndemnityFormComponent_ng_container_0_Template, 5, 3, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.plansLoading && (ctx.sortedQuestions == null ? null : ctx.sortedQuestions.length) > 0);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, NavigationAdapterDirective, LiveEditPropDirective, RateFactorsFormComponent, NavigationBannerComponent, SafePipe], styles: [".no-plans-available[_ngcontent-%COMP%]{margin-top:90px;margin-bottom:90px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HospitalIndemnityFormComponent, [{
        type: Component,
        args: [{ selector: 'vnext-hospital-indemnity-form', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"!plansLoading && sortedQuestions?.length > 0\">\r\n  <ng-container *ngIf=\"!hideForm\">\r\n    <div [ngClass]=\"{ 'mt-4': !isEmbedded }\" class=\"row no-gutters\">\r\n      <div\r\n        *liveEditProp=\"'Spa_PlanList_HIPFormPrompt_Text'\"\r\n        navigationAdapter\r\n        class=\"Spa_Style_IntroParagraph\"\r\n        [innerHtml]=\"spaPageSubHeader | safe : 'html'\"\r\n      ></div>\r\n    </div>\r\n    <div class=\"row no-gutters mt-4\">\r\n      <div class=\"col-12\">\r\n        <h2 *liveEditProp=\"'Spa_PlanList_HIP_PageTitle_Text'\" class=\"Spa_Style_H2\">{{ spaPageTitle }}</h2>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"!hideForm; else noPlansAvailableView\">\r\n    <div>\r\n      <vnext-rate-factors-form\r\n        #rateFactorsForm\r\n        [sortedQuestions]=\"sortedQuestions\"\r\n        [questionMetadataMap]=\"questionMetadataMap\"\r\n        [answersMap]=\"answersMap\"\r\n        [prePopulatedFields]=\"prePopulatedFields\"\r\n        [locale]=\"locale\"\r\n        [isEmbedded]=\"isEmbedded\"\r\n        [errorKeywordText]=\"errorKeywordText\"\r\n        [errorNoticeTitle]=\"errorNoticeTitle\"\r\n        [dropdownDefaultText]=\"dropdownDefaultText\"\r\n        [noneText]=\"noneText\"\r\n        [rateFactorDisclaimer]=\"rateFactorDisclaimer\"\r\n        [rateFactorDisclaimerEnabled]=\"rateFactorDisclaimerEnabled\"\r\n        (submitForm)=\"continueToPlans($event)\"\r\n        (hideForm)=\"updateFormVisibility($event)\"\r\n      ></vnext-rate-factors-form>\r\n    </div>\r\n    <div class=\"row no-gutters\" *ngIf=\"!isEmbedded\">\r\n      <vnext-navigation-banner class=\"col-12\" [showPrevious]=\"showPreviousLink\">\r\n        <button\r\n          continue-button\r\n          class=\"btn Spa_Style_PrimaryButton width-full width-md-initial\"\r\n          (click)=\"rateFactorsForm?.ngFormInstance?.onSubmit()\"\r\n        >\r\n          {{ continueButtonText }}\r\n        </button>\r\n      </vnext-navigation-banner>\r\n    </div></ng-container\r\n  >\r\n  <ng-template #noPlansAvailableView>\r\n    <div class=\"w-100 text-center no-plans-available\">\r\n      <div class=\"Spa_Style_Large_Font font-weight-bold\">{{ noPlansAvailableHeaderText }}</div>\r\n      <div class=\"Spa_Style_H5\" [innerHTML]=\"noPlansAvailableBodyText | safe : 'html'\" navigationAdapter></div>\r\n    </div>\r\n  </ng-template>\r\n</ng-container>\r\n", styles: [".no-plans-available{margin-top:90px;margin-bottom:90px}\n"] }]
    }], function () { return [{ type: HospitalIndemnityFormFacade }, { type: i1.SSOPopulatedFieldService }, { type: i1.LocaleService }, { type: i1.MedSupService }, { type: i0.ChangeDetectorRef }, { type: i1.SpinnerService }, { type: AnalyticsService }, { type: i2$1.Router }]; }, { rateFactorsForm: [{
            type: ViewChild,
            args: ['rateFactorsForm']
        }], continueButtonText: [{
            type: Input
        }], plansLoading: [{
            type: Input
        }], spaPageSubHeader: [{
            type: Input
        }], spaPageTitle: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], errorNoticeTitle: [{
            type: Input
        }], dropdownDefaultText: [{
            type: Input
        }], showPreviousLink: [{
            type: Input
        }], isEmbedded: [{
            type: Input
        }], noPlansAvailableHeaderText: [{
            type: Input
        }], noPlansAvailableBodyText: [{
            type: Input
        }], rateFactorDisclaimer: [{
            type: Input
        }], rateFactorDisclaimerEnabled: [{
            type: Input
        }], noneText: [{
            type: Input
        }], formClose: [{
            type: Output
        }], formSubmit: [{
            type: Output
        }] }); })();

class ShoppingCartCrossSellComponent {
}
ShoppingCartCrossSellComponent.ɵfac = function ShoppingCartCrossSellComponent_Factory(t) { return new (t || ShoppingCartCrossSellComponent)(); };
ShoppingCartCrossSellComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ShoppingCartCrossSellComponent, selectors: [["vnext-shopping-cart-cross-sell"]], inputs: { bundlePlansPrompt: "bundlePlansPrompt", marketingMessage: "marketingMessage", shopButton: "shopButton", shopAction: "shopAction" }, decls: 9, vars: 6, consts: [["id", "bundlePlansLabel", 1, "Spa_Style_Primary_Color", "Spa_Style_Regular_Font", "Spa_Style_Bold_Weight", "mt-2", "mb-2", "row"], [1, "Spa_Style_Gray1_Background", "cross-sell-shop-prompt", "row", "mb-3"], [1, "col", "p-3"], ["id", "marketingDescription", 1, "Spa_Style_Primary_Color", "pb-3", 3, "innerHTML"], [1, "row", "justify-content-end", "pr-2"], ["type", "button", "aria-labelledby", "bundlePlansLabel", "aria-describedby", "marketingDescription", 1, "btn", "Spa_Style_PrimaryButton", 3, "click"]], template: function ShoppingCartCrossSellComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h2", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 1)(3, "div", 2);
        i0.ɵɵelement(4, "div", 3);
        i0.ɵɵpipe(5, "safe");
        i0.ɵɵelementStart(6, "div", 4)(7, "button", 5);
        i0.ɵɵlistener("click", function ShoppingCartCrossSellComponent_Template_button_click_7_listener() { return ctx.shopAction(); });
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.bundlePlansPrompt);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(5, 3, ctx.marketingMessage, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.shopButton, " ");
    } }, dependencies: [SafePipe], styles: [".cross-sell-shop-prompt[_ngcontent-%COMP%]{border-radius:5px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShoppingCartCrossSellComponent, [{
        type: Component,
        args: [{ selector: 'vnext-shopping-cart-cross-sell', changeDetection: ChangeDetectionStrategy.OnPush, template: "<h2 class=\"Spa_Style_Primary_Color Spa_Style_Regular_Font Spa_Style_Bold_Weight mt-2 mb-2 row\" id=\"bundlePlansLabel\">{{ bundlePlansPrompt }}</h2>\r\n<div class=\"Spa_Style_Gray1_Background cross-sell-shop-prompt row mb-3\">\r\n  <div class=\"col p-3\">\r\n    <div id=\"marketingDescription\" class=\"Spa_Style_Primary_Color pb-3\" [innerHTML]=\"marketingMessage | safe: 'html'\"></div>\r\n    <div class=\"row justify-content-end pr-2\">\r\n      <button\r\n        type=\"button\"\r\n        class=\"btn Spa_Style_PrimaryButton\"\r\n        aria-labelledby=\"bundlePlansLabel\"\r\n        aria-describedby=\"marketingDescription\"\r\n        (click)=\"shopAction()\"\r\n      >\r\n        {{ shopButton }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".cross-sell-shop-prompt{border-radius:5px}\n"] }]
    }], null, { bundlePlansPrompt: [{
            type: Input
        }], marketingMessage: [{
            type: Input
        }], shopButton: [{
            type: Input
        }], shopAction: [{
            type: Input
        }] }); })();

function ShoppingCartCrossSellModalComponent_ng_container_10_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function ShoppingCartCrossSellModalComponent_ng_container_10_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r5.cancel()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.cancelButton, " ");
} }
function ShoppingCartCrossSellModalComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ShoppingCartCrossSellModalComponent_ng_container_10_button_1_Template, 2, 1, "button", 12);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.cancelButton);
} }
function ShoppingCartCrossSellModalComponent_ng_template_11_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function ShoppingCartCrossSellModalComponent_ng_template_11_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8.cancel()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.cancelButton, " ");
} }
function ShoppingCartCrossSellModalComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ShoppingCartCrossSellModalComponent_ng_template_11_button_0_Template, 2, 1, "button", 14);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.cancelButton);
} }
function ShoppingCartCrossSellModalComponent_vnext_link_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-link", 16);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("linkTarget", "_self")("isLinkButton", true)("role", ctx_r3.linkRoles.LINK)("onClickAction", ctx_r3.confirm)("alwaysUnderlined", true)("showArrow", "right")("title", ctx_r3.confirmButton);
} }
class ShoppingCartCrossSellModalComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
        this.linkRoles = LinkRoles;
        this.pageTags = PageTags;
        this.confirm = () => {
            this.activeModal.close();
            if (this.confirmAction) {
                this.confirmAction();
            }
        };
        this.shop = () => {
            this.activeModal.dismiss();
            if (this.shopAction) {
                this.shopAction();
            }
        };
    }
    cancel() {
        this.activeModal.dismiss();
        if (this.cancelAction) {
            this.cancelAction();
        }
    }
}
ShoppingCartCrossSellModalComponent.ɵfac = function ShoppingCartCrossSellModalComponent_Factory(t) { return new (t || ShoppingCartCrossSellModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal)); };
ShoppingCartCrossSellModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ShoppingCartCrossSellModalComponent, selectors: [["ng-component"]], decls: 14, vars: 9, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "modal-body"], [1, "mb-4"], [1, "Spa_Style_Cost_Background", "Spa_Style_Primary_Color", "Spa_Style_Bold_Weight", "p-3", "confirmation-message"], [1, "Spa_Style_CostPremiumSmall", "pr-2", "pl-1"], ["aria-hidden", "true", 1, "fas", "fa-check-circle"], [1, "p-3"], [3, "bundlePlansPrompt", "marketingMessage", "shopButton", "shopAction"], [1, "modal-footer", "justify-content-start"], [4, "ngIf", "ngIfElse"], ["showFocusOnCancel", ""], [3, "linkTarget", "isLinkButton", "role", "onClickAction", "alwaysUnderlined", "showArrow", "title", 4, "ngIf"], ["type", "button", "class", "btn Spa_Style_SecondaryButton mr-auto", 3, "click", 4, "ngIf"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "mr-auto", 3, "click"], ["ngbAutofocus", "", "type", "button", "class", "btn Spa_Style_SecondaryButton mr-auto", 3, "click", 4, "ngIf"], ["ngbAutofocus", "", "type", "button", 1, "btn", "Spa_Style_SecondaryButton", "mr-auto", 3, "click"], [3, "linkTarget", "isLinkButton", "role", "onClickAction", "alwaysUnderlined", "showArrow", "title"]], template: function ShoppingCartCrossSellModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function ShoppingCartCrossSellModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.cancel(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "span", 4);
        i0.ɵɵelement(5, "i", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵelement(8, "vnext-shopping-cart-cross-sell", 7);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵtemplate(10, ShoppingCartCrossSellModalComponent_ng_container_10_Template, 2, 1, "ng-container", 9);
        i0.ɵɵtemplate(11, ShoppingCartCrossSellModalComponent_ng_template_11_Template, 1, 1, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(13, ShoppingCartCrossSellModalComponent_vnext_link_13_Template, 1, 7, "vnext-link", 11);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(12);
        i0.ɵɵproperty("modalTitleText", ctx.headerText);
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", ctx.successMessage, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("bundlePlansPrompt", ctx.bundlePlansPrompt)("marketingMessage", ctx.marketingMessage)("shopButton", ctx.shopButton)("shopAction", ctx.shop);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.confirmButton)("ngIfElse", _r1);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.confirmButton);
    } }, dependencies: [i1$2.NgIf, IconAriaAttributesDirective, LinkComponent, ShoppingCartCrossSellComponent, ModalHeaderComponent], styles: [".confirmation-message[_ngcontent-%COMP%]{border-left:6px solid var(--static-Spa_Style_Cost_Text);border-radius:5px}.cross-sell-shop-prompt[_ngcontent-%COMP%]{border-radius:5px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShoppingCartCrossSellModalComponent, [{
        type: Component,
        args: [{ template: "<vnext-widget-modal-header [modalTitleText]=\"headerText\" (modalTitleCancelAction)=\"cancel()\"></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body\">\r\n  <div class=\"mb-4\">\r\n    <div class=\"Spa_Style_Cost_Background Spa_Style_Primary_Color Spa_Style_Bold_Weight p-3 confirmation-message\">\r\n      <span class=\"Spa_Style_CostPremiumSmall pr-2 pl-1\">\r\n        <i class=\"fas fa-check-circle\" aria-hidden=\"true\"></i>\r\n      </span>\r\n      {{ successMessage }}\r\n    </div>\r\n  </div>\r\n  <div class=\"p-3\">\r\n    <vnext-shopping-cart-cross-sell\r\n      [bundlePlansPrompt]=\"bundlePlansPrompt\"\r\n      [marketingMessage]=\"marketingMessage\"\r\n      [shopButton]=\"shopButton\"\r\n      [shopAction]=\"shop\"\r\n    >\r\n    </vnext-shopping-cart-cross-sell>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer justify-content-start\">\r\n  <ng-container *ngIf=\"confirmButton; else showFocusOnCancel\">\r\n    <button *ngIf=\"cancelButton\" type=\"button\" class=\"btn Spa_Style_SecondaryButton mr-auto\" (click)=\"cancel()\">\r\n      {{ cancelButton }}\r\n    </button>\r\n  </ng-container>\r\n  <ng-template #showFocusOnCancel>\r\n    <button ngbAutofocus *ngIf=\"cancelButton\" type=\"button\" class=\"btn Spa_Style_SecondaryButton mr-auto\" (click)=\"cancel()\">\r\n      {{ cancelButton }}\r\n    </button>\r\n  </ng-template>\r\n  <vnext-link\r\n    *ngIf=\"confirmButton\"\r\n    [linkTarget]=\"'_self'\"\r\n    [isLinkButton]=\"true\"\r\n    [role]=\"linkRoles.LINK\"\r\n    [onClickAction]=\"confirm\"\r\n    [alwaysUnderlined]=\"true\"\r\n    [showArrow]=\"'right'\"\r\n    [title]=\"confirmButton\"\r\n  >\r\n  </vnext-link>\r\n</div>\r\n", styles: [".confirmation-message{border-left:6px solid var(--static-Spa_Style_Cost_Text);border-radius:5px}.cross-sell-shop-prompt{border-radius:5px}\n"] }]
    }], function () { return [{ type: i1$1.NgbActiveModal }]; }, null); })();

function PlanYearModalComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12);
    i0.ɵɵelement(2, "i", 13)(3, "span", 14);
    i0.ɵɵpipe(4, "safe");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 1, ctx_r0.cartPlanRemovalWarning, "html"), i0.ɵɵsanitizeHtml);
} }
function PlanYearModalComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12);
    i0.ɵɵelement(2, "i", 13)(3, "span", 14);
    i0.ɵɵpipe(4, "safe");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 1, ctx_r1.quotePlanRemovalWarning, "html"), i0.ɵɵsanitizeHtml);
} }
class PlanYearModalComponent {
    constructor(activeModal, configResourceService, planYearService, planYearResourceService, cdr, analyticsService) {
        this.activeModal = activeModal;
        this.configResourceService = configResourceService;
        this.planYearService = planYearService;
        this.planYearResourceService = planYearResourceService;
        this.cdr = cdr;
        this.analyticsService = analyticsService;
        this.displayCartPlanRemovalWarning = false;
        this.displayQuotePlanRemovalWarning = false;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.initializeInstanceVariables();
        this.selectedPlanYearType$ = this.planYearResourceService.getSelectedPlanYearType$();
        this.subscriptions.add(this.selectedPlanYearType$.subscribe({
            next: selectedPlanYearType => {
                this.selectedPlanYearType = selectedPlanYearType;
                this.togglePlanYearType = selectedPlanYearType;
                this.cdr.markForCheck();
            }
        }));
        // need to log the modal open event after getting the selectedPlanYearType in order
        // to determine if the plan year has been updated and the plan removal message is showing
        this.selectedPlanYearType$.pipe(take(1)).subscribe({
            next: () => {
                this.logModalOpenEvent();
            }
        });
        this.planYearValues = this.getPlanYearValues();
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    getPlanYearValues() {
        const planYearMap = this.planYearResourceService.getPlanYearMap();
        return Object.keys(planYearMap).map(planYearType => ({
            display: planYearMap[planYearType],
            value: planYearType
        }));
    }
    cancel() {
        this.activeModal.dismiss();
    }
    selectPlanYear({ data, event }) {
        event.stopPropagation();
        if (data && data !== null) {
            this.togglePlanYearType = data.value;
            this.displayCartPlanRemovalWarning = this.showCartPlanRemovalWarning();
            this.displayQuotePlanRemovalWarning = this.showQuotePlanRemovalWarning();
        }
        else {
            this.togglePlanYearType = PlanYearType.CURRENT;
        }
    }
    setPlanYear() {
        const showPlanRemovalWarning = this.showCartPlanRemovalWarning() || this.showQuotePlanRemovalWarning();
        this.planYearResourceService.setSelectedPlanYear(this.togglePlanYearType);
        this.planYearService.setHasPlanYearPermissionError(false);
        this.activeModal.close(showPlanRemovalWarning);
    }
    showCartPlanRemovalWarning() {
        return this.planYearService.hasRemovableMedicarePlansInCart() && this.togglePlanYearType !== this.selectedPlanYearType;
    }
    showQuotePlanRemovalWarning() {
        return this.planYearService.hasRemovableMedicarePlansInQuoteGroups() && this.togglePlanYearType !== this.selectedPlanYearType;
    }
    logModalOpenEvent() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLAN_YEAR_MODAL_OPEN
        };
    }
    initializeInstanceVariables() {
        this.title = this.configResourceService.getProcessedResourceValue('Spa_DualPlanYear_SelectPlanYearModal_Title_Text', null, 'Select Plan Year');
        this.body = this.configResourceService.getProcessedResourceValue('Spa_DualPlanYear_SelectPlanYearModal_Body_Text', null, 'Select the year you want coverage for.');
        this.planYearLabel = this.configResourceService.getProcessedResourceValue('Spa_DualPlanYear_SelectPlanYearModal_PlanYear_Text', null, 'Plan Year');
        this.cartPlanRemovalWarning = this.configResourceService.getProcessedResourceValue('Spa_DualPlanYear_SelectPlanYearModal_Plan_Removal_Warning', null, 'Changing the Plan Year will remove the Medicare plan you currently have in your Cart');
        this.quotePlanRemovalWarning = this.configResourceService.getProcessedResourceValue('Spa_DualPlanYear_SelectPlanYearModal_Quote_Removal_Warning', null, 'Changing the Plan Year will remove the Medicare plan you currently have in your Quote');
        this.cancelButton = this.configResourceService.getProcessedResourceValue('Spa_Site_Cancel', null, 'Cancel');
        this.continueButton = this.configResourceService.getProcessedResourceValue('Spa_Site_Continue', null, 'Continue');
    }
}
PlanYearModalComponent.ɵfac = function PlanYearModalComponent_Factory(t) { return new (t || PlanYearModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.PlanYearService), i0.ɵɵdirectiveInject(i1.PlanYearResourceService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(AnalyticsService)); };
PlanYearModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanYearModalComponent, selectors: [["ng-component"]], decls: 17, vars: 16, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "modal-body"], [1, "Spa_Style_Primary_Color", 3, "innerHTML"], [1, "row", "col-12"], ["id", "planYearLabel", 1, "Spa_Style_Label", "w-100", "pt-2"], ["aria-live", "off", 1, "input-error-asterisk"], [3, "items", "selectedValue", "largerText", "buttonHeight", "ariaLabelledById", "toggleContainerWidth", "optionSelected"], ["class", "pt-3", 4, "ngIf"], [1, "modal-footer", "justify-content-start"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "mr-auto", 3, "click", "keyup.enter"], ["type", "button", 1, "btn", "Spa_Style_PrimaryButton", 3, "click", "keyup.enter"], [1, "pt-3"], [1, "pl-3", "row"], [1, "fas", "fa-solid", "fa-info-circle"], [1, "Spa_Style_Small_Font", "plan-removal-warning", "col-11", "pl-0", 3, "innerHTML"]], template: function PlanYearModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function PlanYearModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.cancel(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "span", 2);
        i0.ɵɵpipe(3, "safe");
        i0.ɵɵelementStart(4, "div", 3)(5, "label", 4)(6, "span", 5);
        i0.ɵɵtext(7, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "vnext-toggle-select", 6);
        i0.ɵɵlistener("optionSelected", function PlanYearModalComponent_Template_vnext_toggle_select_optionSelected_9_listener($event) { return ctx.selectPlanYear($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, PlanYearModalComponent_div_10_Template, 5, 4, "div", 7);
        i0.ɵɵtemplate(11, PlanYearModalComponent_div_11_Template, 5, 4, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 8)(13, "button", 9);
        i0.ɵɵlistener("click", function PlanYearModalComponent_Template_button_click_13_listener() { return ctx.cancel(); })("keyup.enter", function PlanYearModalComponent_Template_button_keyup_enter_13_listener() { return ctx.cancel(); });
        i0.ɵɵtext(14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "button", 10);
        i0.ɵɵlistener("click", function PlanYearModalComponent_Template_button_click_15_listener() { return ctx.setPlanYear(); })("keyup.enter", function PlanYearModalComponent_Template_button_keyup_enter_15_listener() { return ctx.setPlanYear(); });
        i0.ɵɵtext(16);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(3, 13, ctx.body, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", ctx.planYearLabel, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("items", ctx.planYearValues)("selectedValue", ctx.selectedPlanYearType)("largerText", true)("buttonHeight", "36px")("ariaLabelledById", ctx.planYearLabel)("toggleContainerWidth", "278.34px");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.displayCartPlanRemovalWarning);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.displayQuotePlanRemovalWarning);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.cancelButton, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.continueButton, " ");
    } }, dependencies: [i1$2.NgIf, IconAriaAttributesDirective, ToggleSelectComponent, ModalHeaderComponent, SafePipe], styles: [".fa-info-circle[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Info_Dark);padding-right:10px}.plan-removal-warning[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Primary_Link)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanYearModalComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"cancel()\"></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body\">\r\n  <span class=\"Spa_Style_Primary_Color\" [innerHTML]=\"body | safe : 'html'\"></span>\r\n  <div class=\"row col-12\">\r\n    <label id=\"planYearLabel\" class=\"Spa_Style_Label w-100 pt-2\">\r\n      <span class=\"input-error-asterisk\" aria-live=\"off\">*</span>\r\n      {{ planYearLabel }}\r\n    </label>\r\n  </div>\r\n  <vnext-toggle-select\r\n    [items]=\"planYearValues\"\r\n    [selectedValue]=\"selectedPlanYearType\"\r\n    (optionSelected)=\"selectPlanYear($event)\"\r\n    [largerText]=\"true\"\r\n    [buttonHeight]=\"'36px'\"\r\n    [ariaLabelledById]=\"planYearLabel\"\r\n    [toggleContainerWidth]=\"'278.34px'\"\r\n  ></vnext-toggle-select>\r\n  <div *ngIf=\"displayCartPlanRemovalWarning\" class=\"pt-3\">\r\n    <div class=\"pl-3 row\">\r\n      <i class=\"fas fa-solid fa-info-circle\"></i\r\n      ><span class=\"Spa_Style_Small_Font plan-removal-warning col-11 pl-0\" [innerHTML]=\"cartPlanRemovalWarning | safe : 'html'\"></span>\r\n    </div>\r\n  </div>\r\n  <div *ngIf=\"displayQuotePlanRemovalWarning\" class=\"pt-3\">\r\n    <div class=\"pl-3 row\">\r\n      <i class=\"fas fa-solid fa-info-circle\"></i\r\n      ><span class=\"Spa_Style_Small_Font plan-removal-warning col-11 pl-0\" [innerHTML]=\"quotePlanRemovalWarning | safe : 'html'\"></span>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer justify-content-start\">\r\n  <button type=\"button\" class=\"btn Spa_Style_SecondaryButton mr-auto\" (click)=\"cancel()\" (keyup.enter)=\"cancel()\">\r\n    {{ cancelButton }}\r\n  </button>\r\n  <button type=\"button\" class=\"btn Spa_Style_PrimaryButton\" (click)=\"setPlanYear()\" (keyup.enter)=\"setPlanYear()\">\r\n    {{ continueButton }}\r\n  </button>\r\n</div>\r\n", styles: [".fa-info-circle{color:var(--static-Spa_Style_Info_Dark);padding-right:10px}.plan-removal-warning{color:var(--static-Spa_Style_Primary_Link)}\n"] }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i1.ConfigResourceService }, { type: i1.PlanYearService }, { type: i1.PlanYearResourceService }, { type: i0.ChangeDetectorRef }, { type: AnalyticsService }]; }, null); })();

class ZipCodeContextService {
    constructor(zipCodeService) {
        this.zipCodeService = zipCodeService;
        this.isValidFipForZip$ = new BehaviorSubject(true);
        this.zipFromExternalSource$ = new BehaviorSubject('');
        this.onEnter$ = new Subject();
    }
    getValidationStatus$() {
        return this.isValidFipForZip$.asObservable();
    }
    async checkValidationStatus(zipCode, fipsCode) {
        const { counties, isValid } = await this.zipCodeService.getCountyValidationStatus(zipCode, fipsCode);
        this.isValidFipForZip$.next(isValid);
        return { counties, isValid };
    }
    get externalZipCodeUpdate$() {
        return this.zipFromExternalSource$.asObservable();
    }
    updateZipCodeFromExternalSource(zip) {
        this.zipFromExternalSource$.next(zip);
    }
    pushZipCodeOnEnter(zipCode) {
        this.onEnter$.next(zipCode);
    }
    onZipCodeEnter$() {
        return this.onEnter$.asObservable();
    }
}
ZipCodeContextService.ɵfac = function ZipCodeContextService_Factory(t) { return new (t || ZipCodeContextService)(i0.ɵɵinject(i1.ZipCodeService)); };
ZipCodeContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ZipCodeContextService, factory: ZipCodeContextService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ZipCodeContextService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.ZipCodeService }]; }, null); })();

function InnerTextLinkComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.outerText);
} }
function InnerTextLinkComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "vnext-link", 2);
    i0.ɵɵlistener("click", function InnerTextLinkComponent_ng_template_1_Template_vnext_link_click_2_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.textClicked()); })("keyup.enter", function InnerTextLinkComponent_ng_template_1_Template_vnext_link_keyup_enter_2_listener() { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.textClicked()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r2.customTextClass);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.outerTextParts[0], " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r2.innerLinkText)("customClass", ctx_r2.customClass)("makeInlineBlock", true)("alwaysUnderlined", true)("role", ctx_r2.role)("ariaLabel", ctx_r2.ariaLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.outerTextParts[1], " ");
} }
class InnerTextLinkComponent {
    constructor() {
        this.customClass = 'Spa_Style_Link';
        this.innerTextClicked = new EventEmitter();
    }
    textClicked() {
        this.innerTextClicked.emit();
    }
    ngOnChanges() {
        this.innerTextFound = this.outerText.includes(this.innerText);
        if (this.innerTextFound) {
            this.outerTextParts = this.outerText.split(this.innerText);
            this.innerLinkText = this.outerText.substr(this.outerText.indexOf(this.innerText), this.innerText.length);
        }
    }
}
InnerTextLinkComponent.ɵfac = function InnerTextLinkComponent_Factory(t) { return new (t || InnerTextLinkComponent)(); };
InnerTextLinkComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InnerTextLinkComponent, selectors: [["vnext-inner-text-link"]], inputs: { innerText: "innerText", outerText: "outerText", customTextClass: "customTextClass", customClass: "customClass", role: "role", ariaLabel: "ariaLabel", innerLinkText: "innerLinkText" }, outputs: { innerTextClicked: "innerTextClicked" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["findSucceeded", ""], [1, "d-inline-block", "can-click", 3, "title", "customClass", "makeInlineBlock", "alwaysUnderlined", "role", "ariaLabel", "click", "keyup.enter"]], template: function InnerTextLinkComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, InnerTextLinkComponent_ng_container_0_Template, 3, 1, "ng-container", 0);
        i0.ɵɵtemplate(1, InnerTextLinkComponent_ng_template_1_Template, 4, 11, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", !ctx.innerTextFound)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgIf, LinkComponent], encapsulation: 2 });
__decorate([
    LiveEditInactive()
], InnerTextLinkComponent.prototype, "textClicked", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InnerTextLinkComponent, [{
        type: Component,
        args: [{ selector: 'vnext-inner-text-link', template: "<ng-container *ngIf=\"!innerTextFound; else findSucceeded\">\r\n  <span>{{ outerText }}</span>\r\n</ng-container>\r\n<ng-template #findSucceeded>\r\n  <span class=\"{{ customTextClass }}\">\r\n    {{ outerTextParts[0] }}\r\n    <vnext-link\r\n      (click)=\"textClicked()\"\r\n      (keyup.enter)=\"textClicked()\"\r\n      [title]=\"innerLinkText\"\r\n      [customClass]=\"customClass\"\r\n      class=\"d-inline-block can-click\"\r\n      [makeInlineBlock]=\"true\"\r\n      [alwaysUnderlined]=\"true\"\r\n      [role]=\"role\"\r\n      [ariaLabel]=\"ariaLabel\"\r\n    ></vnext-link>\r\n    {{ outerTextParts[1] }}\r\n  </span>\r\n</ng-template>\r\n" }]
    }], null, { innerText: [{
            type: Input
        }], outerText: [{
            type: Input
        }], customTextClass: [{
            type: Input
        }], customClass: [{
            type: Input
        }], role: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], innerLinkText: [{
            type: Input
        }], innerTextClicked: [{
            type: Output
        }], textClicked: [] }); })();

function ZipCodeInputComponent_div_0_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵelement(1, "i", 15);
    i0.ɵɵelementStart(2, "span", 16);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r5.errorKeywordText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.zipCodeErrorText, "");
} }
function ZipCodeInputComponent_div_0_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵelement(1, "i", 15);
    i0.ɵɵelementStart(2, "span", 16);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r6.errorKeywordText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.countyErrorText);
} }
const _c0$3N = function (a0) { return { Spa_Style_Smaller_Font: a0 }; };
function ZipCodeInputComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, ZipCodeInputComponent_div_0_span_1_Template, 5, 2, "span", 12);
    i0.ɵɵtemplate(2, ZipCodeInputComponent_div_0_span_2_Template, 5, 2, "span", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$3N, ctx_r0.customStyles.smallerErrorFont));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.zipError && !ctx_r0.showDropdown);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.countyError && (ctx_r0.showDropdown || !ctx_r0.zipError));
} }
function ZipCodeInputComponent_ng_container_10_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ZipCodeInputComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵtemplate(2, ZipCodeInputComponent_ng_container_10_ng_container_2_Template, 1, 0, "ng-container", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.searchButtonTemplate);
} }
function ZipCodeInputComponent_div_11_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵlistener("click", function ZipCodeInputComponent_div_11_div_3_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r11); const county_r9 = restoredCtx.$implicit; const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.saveCounty(county_r9)); })("keydown.enter", function ZipCodeInputComponent_div_11_div_3_Template_div_keydown_enter_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r11); const county_r9 = restoredCtx.$implicit; const ctx_r12 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r12.saveCounty(county_r9)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const county_r9 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", county_r9.countyName, ", ", county_r9.state, " ");
} }
const _c1$1$ = function (a0) { return { "county-error": a0 }; };
function ZipCodeInputComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ZipCodeInputComponent_div_11_div_3_Template, 2, 2, "div", 22);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c1$1$, ctx_r2.countyError));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.selectCountyText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(4, 3, ctx_r2.counties$));
} }
function ZipCodeInputComponent_ng_container_12_ng_container_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r16.countyLabel);
} }
function ZipCodeInputComponent_ng_container_12_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ZipCodeInputComponent_ng_container_12_ng_container_4_div_1_Template, 2, 1, "div", 28);
    i0.ɵɵelementStart(2, "span", 29);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const county_r15 = ctx.ngIf;
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.showCountyLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", county_r15.countyName, ", ", county_r15.state, "");
} }
function ZipCodeInputComponent_ng_container_12_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵlistener("click", function ZipCodeInputComponent_ng_container_12_div_6_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.editCounty()); })("keydown.enter", function ZipCodeInputComponent_ng_container_12_div_6_Template_div_keydown_enter_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r19 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r19.editCounty()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-label", ctx_r14.editCountyDescription);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.editCountyText, " ");
} }
const _c2$1d = function (a0, a1, a2) { return { "col-auto": a0, "col-12": a1, "mt-0": a2 }; };
const _c3$S = function (a0) { return { "mt-3": a0 }; };
function ZipCodeInputComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 24)(2, "div", 25)(3, "div", 26);
    i0.ɵɵtemplate(4, ZipCodeInputComponent_ng_container_12_ng_container_4_Template, 4, 3, "ng-container", 8);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, ZipCodeInputComponent_ng_container_12_div_6_Template, 2, 2, "div", 27);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    let tmp_3_0;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(10, _c2$1d, !ctx_r3.customStyles.editCountyAlwaysUnderInput, ctx_r3.customStyles.editCountyAlwaysUnderInput, ctx_r3.customStyles.smallerCountyMarginTop));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c3$S, !ctx_r3.searchButtonTemplate && !ctx_r3.customStyles.smallerCountyMarginTop));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(5, 4, ctx_r3.county$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ((tmp_3_0 = i0.ɵɵpipeBind1(7, 6, ctx_r3.counties$)) == null ? null : tmp_3_0.length) > 1 && i0.ɵɵpipeBind1(8, 8, ctx_r3.county$));
} }
function ZipCodeInputComponent_div_13_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-inner-text-link", 35);
    i0.ɵɵlistener("innerTextClicked", function ZipCodeInputComponent_div_13_ng_container_1_Template_vnext_inner_text_link_innerTextClicked_1_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r23.openPlanYearPopup()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("outerText", ctx_r20.totalCountsString)("innerText", ctx_r20.selectedPlanYear);
} }
function ZipCodeInputComponent_div_13_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate(ctx_r22.totalCountsString);
} }
function ZipCodeInputComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtemplate(1, ZipCodeInputComponent_div_13_ng_container_1_Template, 2, 2, "ng-container", 33);
    i0.ɵɵtemplate(2, ZipCodeInputComponent_div_13_ng_template_2_Template, 1, 1, "ng-template", null, 34, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r21 = i0.ɵɵreference(3);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.totalCountsYearClickable)("ngIfElse", _r21);
} }
const _c4$w = function (a0, a1) { return { "col-12": a0, "col-auto": a1 }; };
const _c5$h = function (a0) { return { Spa_Style_Gray4_Color: a0 }; };
const _c6$g = function (a0) { return { Spa_Style_ErrorText: a0 }; };
const _c7$c = function (a0, a1, a2) { return { "has-error": a0, "remove-right-round": a1, "readonly Spa_Style_Gray4_Color": a2 }; };
class ZipCodeStyleOptions {
}
class ZipCodeInputComponent {
    constructor(store, cdr, widgetValidationService, navigationService, widgetService, configurableWidgetService, demographicHttpService, analyticsService, zipCodeService, zipCodeContextService, carriersService, plansService, planYearService, planYearResourceService, modalService) {
        this.store = store;
        this.cdr = cdr;
        this.widgetValidationService = widgetValidationService;
        this.navigationService = navigationService;
        this.widgetService = widgetService;
        this.configurableWidgetService = configurableWidgetService;
        this.demographicHttpService = demographicHttpService;
        this.analyticsService = analyticsService;
        this.zipCodeService = zipCodeService;
        this.zipCodeContextService = zipCodeContextService;
        this.carriersService = carriersService;
        this.plansService = plansService;
        this.planYearService = planYearService;
        this.planYearResourceService = planYearResourceService;
        this.modalService = modalService;
        this.zipCodeErrorText = 'Zip code is invalid';
        this.countyErrorText = 'Please select your county';
        this.selectCountyText = 'Select county';
        this.zipCodeText = 'ZIP code';
        this.editCountyText = 'Edit';
        this.editCountyDescription = 'Edit';
        this.countyLabel = 'County';
        this.showCountyLabel = false;
        this.isReadOnly = false;
        this.selectedCountyEnabled = true;
        this.showCounty = true;
        this.validateOnBlur = false;
        this.checkCounty = false;
        this.defaultZipCode = '';
        this.defaultFipsCode = '';
        this.customStyles = {
            roundInputRightBorder: false,
            redBorderOnError: false,
            noErrorGapWhenValid: false,
            editCountyAlwaysUnderInput: false
        };
        this.emitOnEmptyValue = false;
        this.fireEnterEvent = true;
        this.logAnalytics = true;
        this.isProfileZip = false;
        this.totalCountsMessageEnabled = false;
        this.isModal = false;
        this.totalCountsYearClickable = false;
        this.zip = new EventEmitter();
        this.fips = new EventEmitter();
        this.onError = new EventEmitter();
        this.onEnterClick = new EventEmitter();
        this.zipError = false;
        this.fetchError = false;
        this.countyError = false;
        this.zipCodeControl = new UntypedFormControl('');
        this.validatorId = uuid();
        this.testingZipComponent = '';
        this.showTotalCountString = false;
        this.skipWidgetValidation = false;
        this.demographicInputName = 'demographic_input';
        this.selectedPlanYear = '';
        this.ZIP_CODE_REQUIRED_LENGTH = 5;
        this.subscriptions = new Subscription();
        this.baseError = {
            severity: 'error',
            widgetId: this.widgetService.widgetId,
            errorData: null
        };
        // SPA-17305 This function needs to stay defined like this instead of a regular function
        this.validateWidget = () => {
            // We also require the dropdown to be hidden to skip, as interacting with it is an extra step that we don't want ovewritten
            if (this.skipWidgetValidation && !this.showDropdown) {
                this.skipWidgetValidation = false;
                return [];
            }
            const errors = [];
            this.zipError = false;
            this.countyError = false;
            errors.push(...this.getZipCodeErrors());
            if (this.showCounty) {
                errors.push(...this.getCountyErrors());
            }
            this.onError.emit(errors);
            // TODO ideally this would be a pure function and would not be determining, reporting, and modifying local
            // component variables in order to display those errors
            this.cdr.detectChanges();
            return errors;
        };
    }
    onBlur() {
        if (this.validateOnBlur && this.zipCodeControl.value.length < 5) {
            // validation already automatically files at maximum characters, so only doing this when we have fewer than that
            // helps prevent errors and weird states happening when clicking on the county select dropdown, technically losing focus
            this.validateWidget();
        }
    }
    getCountyErrors() {
        const errors = [];
        if (this._counties$.getValue()?.length && this.showDropdown) {
            this.countyError = true;
            errors.push({
                ...this.baseError,
                message: 'No county has been selected',
                property: 'selectedCounty'
            });
        }
        return errors;
    }
    getZipCodeErrors() {
        const errors = [];
        const baseError = {
            severity: 'error',
            widgetId: this.widgetService.widgetId,
            errorData: null
        };
        this.zipError = false;
        this.countyError = false;
        if (!this.zipCodeControl.value || this.zipCodeControl.value.length !== this.ZIP_CODE_REQUIRED_LENGTH) {
            this.zipError = true;
            errors.push({
                ...baseError,
                message: `Provided zip code's length was not exactly five characters: ${this.zipCodeControl.value}`,
                property: 'zipCode-input'
            });
        }
        else if (this.fetchError) {
            this.zipError = true;
            errors.push({
                ...baseError,
                message: `API was unable to retrieve counties for given zip code: ${this.zipCodeControl.value}`,
                property: 'zipCode-input'
            });
        }
        else {
            const countyValue = this._counties$.getValue();
            if (countyValue === undefined || countyValue === null || countyValue.length === 0) {
                this.zipError = true;
                errors.push({
                    ...baseError,
                    message: `The zip code provided did not return any counties: ${this.zipCodeControl.value}`,
                    property: 'zipCode-input'
                });
            }
        }
        this.cdr.detectChanges();
        return errors;
    }
    async checkCountySelection() {
        if (!this.checkCounty || !this.zipCodeControl.value) {
            return;
        }
        const counties = await this.zipCodeService.getCountiesForZip(this.zipCodeControl.value);
        if (counties && counties.length > 1) {
            this.openCountyDropDown(counties);
            this.getCountyErrors();
        }
    }
    openCountyDropDown(counties) {
        this.fips$.next(null);
        this._counties$.next(counties);
        this.cdr.detectChanges();
    }
    async onZipChange() {
        this.fips$.next(null);
        this.zipError = false;
        const inputLength = this.zipCodeControl.value.length;
        if (this.zipCodeControl.value && inputLength === this.ZIP_CODE_REQUIRED_LENGTH) {
            if (this.fetchError) {
                this.zipError = true;
            }
            this.store.dispatch(new ClearWidgetErrors(this.widgetService.widgetId));
            // We are about to manually validate anyway, so skip the widget validation to prevent extraneous errors
            this.skipWidgetValidation = true;
            this.emitZip(this.zipCodeControl.value);
            await this.fetchCounties(this.zipCodeControl.value);
            this.validateZipCode();
        }
        else if (inputLength === 0 && this.emitOnEmptyValue) {
            this.store.dispatch(new ClearWidgetErrors(this.widgetService.widgetId));
            this._counties$.next([]);
            this.emitZip('');
        }
        this.cdr.detectChanges();
    }
    validateZipCode() {
        const errors = this.getZipCodeErrors();
        this.onError.emit(errors);
        this.cdr.detectChanges();
    }
    saveCounty(county) {
        this.countyError = false;
        this.fips$.next(county.countyFIPS);
        this.fips.emit(county.countyFIPS);
        const googleDataLayerTags = this.analyticsService.googleDataLayerTags;
        if (this.logAnalytics &&
            (!googleDataLayerTags ||
                googleDataLayerTags[DataLayerGlobalVariable.ZIP] !== this.zipCodeControl.value ||
                googleDataLayerTags[DataLayerGlobalVariable.COUNTY_FIPS] !== county.countyFIPS)) {
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.ZIP]: this.zipCodeControl.value,
                [DataLayerGlobalVariable.COUNTY_FIPS]: county.countyFIPS
            };
        }
        this.cdr.detectChanges();
    }
    async fetchCounties(zipCode) {
        let counties = [];
        if (this.retrieveCounties) {
            counties = await this.retrieveCounties(zipCode);
        }
        else {
            try {
                if (this.isProfileZip) {
                    await this.store.dispatch(new FetchProfileCountyData(zipCode)).toPromise();
                    counties = this.store.selectSnapshot(ProfileState.counties);
                }
                else {
                    await this.store.dispatch(new FetchCountyData(zipCode)).toPromise();
                    counties = this.store.selectSnapshot(DemographicState.counties);
                }
            }
            catch {
                this.configurableWidgetService.store.dispatch(new SetDemographicLoading(false));
            }
        }
        this._counties$.next(counties);
        this.cdr.detectChanges();
    }
    editCounty() {
        this.fips$.next(null);
        this.cdr.detectChanges();
    }
    ngOnInit() {
        this._counties$ = new BehaviorSubject([]);
        this.counties$ = this._counties$.asObservable();
        let initialFips;
        let selectedZipCode;
        if (this.retrieveZipCode) {
            selectedZipCode = this.retrieveZipCode();
        }
        else {
            selectedZipCode = this.getSelectedZipCode();
        }
        if (this.retrieveFipsCode) {
            initialFips = this.retrieveFipsCode();
        }
        else {
            initialFips = this.getSelectedFipsCode();
        }
        this.fips$ = new BehaviorSubject(initialFips);
        this.defaultFipsCode = initialFips;
        if (!selectedZipCode || selectedZipCode.length < this.ZIP_CODE_REQUIRED_LENGTH) {
            this._counties$.next([]);
        }
        else {
            this.emitZip(selectedZipCode);
            this.fips.emit(initialFips);
            this.defaultZipCode = selectedZipCode;
            this.zipCodeControl.patchValue(selectedZipCode);
            this.fetchCounties(selectedZipCode);
        }
        const latestCountiesAndFips$ = combineLatest([this.counties$, this.fips$]);
        this.county$ = latestCountiesAndFips$.pipe(map(([counties, fips]) => counties.find(county => county.countyFIPS === fips)));
        this.showDropdown$ = latestCountiesAndFips$.pipe(map(([counties, fips]) => counties.length > 1 && !fips && this.showCounty && this.zipCodeControl.value.length === this.ZIP_CODE_REQUIRED_LENGTH));
        this.widgetValidationService.addWidgetValidator({
            widgetId: this.widgetService.widgetId,
            validator: this.validateWidget,
            validatorId: this.validatorId
        });
        if (this.isModal) {
            this.demographicInputName += '_modal';
        }
        // subscribe to distinct input value changes
        this.subscriptions.add(this.zipCodeControl.valueChanges.pipe(distinctUntilChanged()).subscribe({
            next: data => {
                this.onZipChange();
            }
        }));
        this.subscriptions.add(this.zipCodeContextService.getValidationStatus$().subscribe({
            next: (isValid) => {
                if (!isValid) {
                    this.checkCountySelection();
                }
            }
        }));
        this.subscriptions.add(this.showDropdown$.subscribe({
            next: showDropdown => {
                this.showDropdown = showDropdown;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.counties$.subscribe({
            next: (counties) => {
                // The only time this should be called without zipCode having a value is a first time visit/after cache clear
                // Only executing the logic if we have a zip code value prevents the page from loading with errors
                if (this.zipCodeControl.value && counties.length === 1) {
                    this.saveCounty(counties[0]);
                }
            }
        }));
        this.subscriptions.add(this.zipCodeContextService.externalZipCodeUpdate$.subscribe({
            next: (zip) => {
                if (zip && zip !== this.zipCodeControl.value) {
                    this.zipCodeControl.setValue(zip);
                }
            }
        }));
        if (this.totalCountsMessageEnabled) {
            this.subscriptions.add(this.carriersService.getTotalCountsResource$().subscribe({
                next: (totalCountString) => {
                    this.totalCountsString = totalCountString;
                    this.cdr.markForCheck();
                }
            }));
        }
        this.subscriptions.add(this.planYearResourceService.getSelectedPlanYear$().subscribe({
            next: selectedPlanYear => {
                this.selectedPlanYear = selectedPlanYear;
                this.totalCountsString = this.carriersService.getTotalCountsResource();
                this.cdr.markForCheck();
            }
        }));
    }
    ngOnChanges(changes) {
        const zipCode = changes.defaultZipCode;
        if (zipCode && zipCode.previousValue !== zipCode.currentValue) {
            this.zipCodeControl.patchValue(zipCode.currentValue);
            if (zipCode.isFirstChange() && this.isProfileZip && zipCode.currentValue?.length === this.ZIP_CODE_REQUIRED_LENGTH) {
                this.fetchCounties(zipCode.currentValue);
            }
        }
        const fipsCode = changes.defaultFipsCode;
        if (fipsCode && fipsCode.previousValue !== fipsCode.currentValue) {
            if (this.fips$) {
                this.fips$.next(fipsCode.currentValue);
            }
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        this.widgetValidationService.removeWidgetValidator(this.validatorId);
    }
    onEnterKeyPress() {
        if (this.fireEnterEvent) {
            this.zipCodeContextService.pushZipCodeOnEnter(this.zipCodeControl.value);
        }
        if (this.validateWidget()?.length <= 0) {
            this.onEnterClick.emit(this.zipCodeControl.value);
        }
    }
    openPlanYearPopup() {
        const planYearModal = this.modalService.open(PlanYearModalComponent, {
            centered: true
        });
        planYearModal.result.then(() => {
            // Disabling the active tab's plan count check before clearing the plan year session ensures to keep the current active tab.
            // This will prevent any undesired automatic selections while the plans and plan counts are being updated.
            // Once it is done, we will enabled it back to check if the current tab still has coverage or we should select another automatically
            this.plansService.setActiveTabPlanCountCheckEnabled(false);
            this.planYearService.clearPlanYearSessionData();
        });
    }
    getSelectedFipsCode() {
        return this.isProfileZip
            ? this.configurableWidgetService.store.selectSnapshot(ProfileState.county)
            : this.configurableWidgetService.store.selectSnapshot(DemographicState.selectedFipsCode);
    }
    getSelectedZipCode() {
        return this.isProfileZip
            ? this.configurableWidgetService.store.selectSnapshot(ProfileState.zip)
            : this.configurableWidgetService.store.selectSnapshot(DemographicState.selectedZipCode);
    }
    emitZip(zip) {
        this.zip.emit(zip);
        if (zip) {
            this.showTotalCountString = true;
        }
    }
}
ZipCodeInputComponent.ɵfac = function ZipCodeInputComponent_Factory(t) { return new (t || ZipCodeInputComponent)(i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(i1.DemographicHttpService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.ZipCodeService), i0.ɵɵdirectiveInject(ZipCodeContextService), i0.ɵɵdirectiveInject(i1.CarriersService), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(i1.PlanYearService), i0.ɵɵdirectiveInject(i1.PlanYearResourceService), i0.ɵɵdirectiveInject(i1$1.NgbModal)); };
ZipCodeInputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ZipCodeInputComponent, selectors: [["vnext-zip-code-input"]], inputs: { retrieveZipCode: "retrieveZipCode", retrieveFipsCode: "retrieveFipsCode", retrieveCounties: "retrieveCounties", zipCodeErrorText: "zipCodeErrorText", countyErrorText: "countyErrorText", selectCountyText: "selectCountyText", zipCodeText: "zipCodeText", editCountyText: "editCountyText", errorKeywordText: "errorKeywordText", editCountyDescription: "editCountyDescription", countyLabel: "countyLabel", showCountyLabel: "showCountyLabel", isReadOnly: "isReadOnly", selectedCountyEnabled: "selectedCountyEnabled", showCounty: "showCounty", validateOnBlur: "validateOnBlur", checkCounty: "checkCounty", searchButtonTemplate: "searchButtonTemplate", defaultZipCode: "defaultZipCode", defaultFipsCode: "defaultFipsCode", customStyles: "customStyles", emitOnEmptyValue: "emitOnEmptyValue", fireEnterEvent: "fireEnterEvent", logAnalytics: "logAnalytics", isProfileZip: "isProfileZip", totalCountsMessageEnabled: "totalCountsMessageEnabled", isModal: "isModal", totalCountsYearClickable: "totalCountsYearClickable" }, outputs: { zip: "zip", fips: "fips", onError: "onError", onEnterClick: "onEnterClick" }, features: [i0.ɵɵNgOnChangesFeature], decls: 14, vars: 27, consts: [["class", "error-display Spa_Style_ErrorText", 3, "ngClass", 4, "ngIf"], ["aria-live", "polite", "aria-atomic", "true", 1, "row"], [3, "ngClass"], [1, "Spa_Style_Label", "w-100", 3, "for", "ngClass"], ["aria-live", "off", 1, "input-error-asterisk"], ["aria-live", "off", 3, "ngClass"], [1, "row", "no-gutters"], ["type", "text", "minlength", "5", "maxlength", "5", "inputmode", "numeric", "pattern", "[0-9]*", "autocomplete", "off", "digitOnly", "", "ngbAutofocus", "", "aria-required", "true", 1, "demographic-input", "col-6", "col-sm-8", "col-md-4", "Spa_Style_Paragraph", 3, "id", "value", "formControl", "ngClass", "readonly", "keydown.enter", "blur"], [4, "ngIf"], ["class", "county-dropdown-list", 3, "ngClass", 4, "ngIf"], ["class", "col-12 Spa_Style_Note py-2", 4, "ngIf"], [1, "error-display", "Spa_Style_ErrorText", 3, "ngClass"], ["id", "zip_error", "class", "zip-error Spa_Style_ErrorText", 4, "ngIf"], ["id", "county_error", "class", "county-error Spa_Style_ErrorText", 4, "ngIf"], ["id", "zip_error", 1, "zip-error", "Spa_Style_ErrorText"], ["aria-hidden", "true", 1, "fa", "fa-exclamation-circle"], [1, "sr-only"], ["id", "county_error", 1, "county-error", "Spa_Style_ErrorText"], ["aria-live", "off"], [4, "ngTemplateOutlet"], [1, "county-dropdown-list", 3, "ngClass"], [1, "Spa_Style_Note", "ml-1"], ["class", "county-dropdown-item Spa_Style_Paragraph no-translate-block", "tabindex", "0", 3, "click", "keydown.enter", 4, "ngFor", "ngForOf"], ["tabindex", "0", 1, "county-dropdown-item", "Spa_Style_Paragraph", "no-translate-block", 3, "click", "keydown.enter"], [1, "county-container", 3, "ngClass"], [1, "selected-county", 3, "ngClass"], [1, "Spa_Style_Paragraph"], ["class", "select-county Spa_Style_Link can-click ml-4", "tabindex", "0", 3, "click", "keydown.enter", 4, "ngIf"], ["class", "Spa_Style_Note d-block", 4, "ngIf"], [1, "no-translate-block"], [1, "Spa_Style_Note", "d-block"], ["tabindex", "0", 1, "select-county", "Spa_Style_Link", "can-click", "ml-4", 3, "click", "keydown.enter"], [1, "col-12", "Spa_Style_Note", "py-2"], [4, "ngIf", "ngIfElse"], ["notClickable", ""], [3, "outerText", "innerText", "innerTextClicked"]], template: function ZipCodeInputComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ZipCodeInputComponent_div_0_Template, 3, 5, "div", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "label", 3)(4, "span", 4);
        i0.ɵɵtext(5, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "span", 5);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "div", 6)(9, "input", 7);
        i0.ɵɵlistener("keydown.enter", function ZipCodeInputComponent_Template_input_keydown_enter_9_listener() { return ctx.onEnterKeyPress(); })("blur", function ZipCodeInputComponent_Template_input_blur_9_listener() { return ctx.onBlur(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, ZipCodeInputComponent_ng_container_10_Template, 3, 1, "ng-container", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(11, ZipCodeInputComponent_div_11_Template, 5, 7, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, ZipCodeInputComponent_ng_container_12_Template, 9, 16, "ng-container", 8);
        i0.ɵɵtemplate(13, ZipCodeInputComponent_div_13_Template, 4, 2, "div", 10);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.customStyles.noErrorGapWhenValid || ctx.zipError || ctx.countyError);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(16, _c4$w, ctx.searchButtonTemplate, !ctx.searchButtonTemplate));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("for", ctx.demographicInputName)("ngClass", i0.ɵɵpureFunction1(19, _c5$h, ctx.isReadOnly));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(21, _c6$g, ctx.zipError || ctx.countyError));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.zipCodeText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("id", ctx.demographicInputName)("value", ctx.defaultZipCode ? ctx.defaultZipCode : "")("formControl", ctx.zipCodeControl)("ngClass", i0.ɵɵpureFunction3(23, _c7$c, ctx.zipError || ctx.countyError, !ctx.customStyles.roundInputRightBorder, ctx.isReadOnly))("readonly", ctx.isReadOnly);
        i0.ɵɵattribute("aria-describedby", ctx.zipError ? "zip_error" : ctx.countyError ? "county_error" : null);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.searchButtonTemplate);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showDropdown);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedCountyEnabled && ctx.showCounty);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.totalCountsMessageEnabled && ctx.showTotalCountString && ctx.totalCountsString);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgTemplateOutlet, i4.DefaultValueAccessor, i4.NgControlStatus, i4.MinLengthValidator, i4.MaxLengthValidator, i4.PatternValidator, i4.FormControlDirective, i3.DigitOnlyDirective, IconAriaAttributesDirective, InnerTextLinkComponent, i1$2.AsyncPipe], styles: [".error-display[_ngcontent-%COMP%]{height:24px}.zip-error[_ngcontent-%COMP%]{white-space:nowrap}.demographic-input[_ngcontent-%COMP%]{min-width:100px;max-width:100px;height:38px;vertical-align:top;padding:5px 11px;font-family:montserratregular}.remove-right-round[_ngcontent-%COMP%]{border-top-right-radius:0;border-bottom-right-radius:0}.county-container[_ngcontent-%COMP%]{position:relative;margin-top:12px;display:inline-block}.selected-county[_ngcontent-%COMP%], .selected-county[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{display:inline-block}.selected-county-display[_ngcontent-%COMP%]{display:inline-block;min-width:65px}.noButtonInputBox[_ngcontent-%COMP%]{flex-basis:auto;width:140px}.select_county[_ngcontent-%COMP%]{cursor:pointer;display:inline-block;padding-left:15px}.county-dropdown-list[_ngcontent-%COMP%]{background-color:#fff;border:1px solid rgba(0,0,0,.15);border-radius:4px;min-width:160px;padding:10px;position:absolute;z-index:1000}.county-dropdown-list.county-error[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent2)}.county-dropdown-item[_ngcontent-%COMP%]{cursor:pointer;padding-bottom:5px;padding-left:5px;padding-top:5px}.county-dropdown-item[_ngcontent-%COMP%]:hover{background-color:var(--static-Spa_Style_Gray1)}.county-dropdown-header[_ngcontent-%COMP%]:hover{background-color:#fff}@media (max-width: 768px){.zip-code-label[_ngcontent-%COMP%]{width:100%}}"], changeDetection: 0 });
__decorate([
    Select(DemographicState.error)
], ZipCodeInputComponent.prototype, "error$", void 0);
__decorate([
    LiveEditInactive()
], ZipCodeInputComponent.prototype, "saveCounty", null);
__decorate([
    LiveEditInactive()
], ZipCodeInputComponent.prototype, "editCounty", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ZipCodeInputComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zip-code-input', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  class=\"error-display Spa_Style_ErrorText\"\r\n  [ngClass]=\"{ Spa_Style_Smaller_Font: customStyles.smallerErrorFont }\"\r\n  *ngIf=\"!customStyles.noErrorGapWhenValid || zipError || countyError\"\r\n>\r\n  <span id=\"zip_error\" class=\"zip-error Spa_Style_ErrorText\" *ngIf=\"zipError && !showDropdown\"\r\n    ><i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i><span class=\"sr-only\">{{ errorKeywordText }}</span>\r\n    {{ zipCodeErrorText }}</span\r\n  >\r\n  <span id=\"county_error\" class=\"county-error Spa_Style_ErrorText\" *ngIf=\"countyError && (showDropdown || !zipError)\"\r\n    ><i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i> <span class=\"sr-only\">{{ errorKeywordText }}</span\r\n    >{{ countyErrorText }}</span\r\n  >\r\n</div>\r\n<div class=\"row\" aria-live=\"polite\" aria-atomic=\"true\">\r\n  <div [ngClass]=\"{ 'col-12': searchButtonTemplate, 'col-auto': !searchButtonTemplate }\">\r\n    <label [for]=\"demographicInputName\" class=\"Spa_Style_Label w-100\" [ngClass]=\"{ Spa_Style_Gray4_Color: isReadOnly }\">\r\n      <span class=\"input-error-asterisk\" aria-live=\"off\">*</span>\r\n      <span [ngClass]=\"{ Spa_Style_ErrorText: zipError || countyError }\" aria-live=\"off\">{{ zipCodeText }}</span>\r\n    </label>\r\n    <div class=\"row no-gutters\">\r\n      <input\r\n        type=\"text\"\r\n        minlength=\"5\"\r\n        maxlength=\"5\"\r\n        class=\"demographic-input col-6 col-sm-8 col-md-4 Spa_Style_Paragraph\"\r\n        inputmode=\"numeric\"\r\n        pattern=\"[0-9]*\"\r\n        autocomplete=\"off\"\r\n        digitOnly\r\n        ngbAutofocus\r\n        aria-required=\"true\"\r\n        [id]=\"demographicInputName\"\r\n        [value]=\"defaultZipCode ? defaultZipCode : ''\"\r\n        [formControl]=\"zipCodeControl\"\r\n        [ngClass]=\"{\r\n          'has-error': zipError || countyError,\r\n          'remove-right-round': !customStyles.roundInputRightBorder,\r\n          'readonly Spa_Style_Gray4_Color': isReadOnly\r\n        }\"\r\n        [attr.aria-describedby]=\"zipError ? 'zip_error' : countyError ? 'county_error' : null\"\r\n        [readonly]=\"isReadOnly\"\r\n        (keydown.enter)=\"onEnterKeyPress()\"\r\n        (blur)=\"onBlur()\"\r\n      />\r\n      <ng-container *ngIf=\"searchButtonTemplate\">\r\n        <div aria-live=\"off\">\r\n          <ng-container *ngTemplateOutlet=\"searchButtonTemplate\">\r\n            <!--spot to put a button directly next to the input when projected-->\r\n          </ng-container>\r\n        </div>\r\n      </ng-container>\r\n    </div>\r\n    <div class=\"county-dropdown-list\" *ngIf=\"showDropdown\" [ngClass]=\"{ 'county-error': countyError }\">\r\n      <div class=\"Spa_Style_Note ml-1\">{{ selectCountyText }}</div>\r\n      <div\r\n        class=\"county-dropdown-item Spa_Style_Paragraph no-translate-block\"\r\n        *ngFor=\"let county of counties$ | async\"\r\n        (click)=\"saveCounty(county)\"\r\n        tabindex=\"0\"\r\n        (keydown.enter)=\"saveCounty(county)\"\r\n      >\r\n        {{ county.countyName }}, {{ county.state }}\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <ng-container *ngIf=\"selectedCountyEnabled && showCounty\">\r\n    <div\r\n      class=\"county-container\"\r\n      [ngClass]=\"{\r\n        'col-auto': !customStyles.editCountyAlwaysUnderInput,\r\n        'col-12': customStyles.editCountyAlwaysUnderInput,\r\n        'mt-0': customStyles.smallerCountyMarginTop\r\n      }\"\r\n    >\r\n      <div class=\"selected-county\" [ngClass]=\"{ 'mt-3': !searchButtonTemplate && !customStyles.smallerCountyMarginTop }\">\r\n        <div class=\"Spa_Style_Paragraph\">\r\n          <ng-container *ngIf=\"county$ | async as county\">\r\n            <div *ngIf=\"showCountyLabel\" class=\"Spa_Style_Note d-block\">{{ countyLabel }}</div>\r\n            <span class=\"no-translate-block\">{{ county.countyName }}, {{ county.state }}</span>\r\n          </ng-container>\r\n        </div>\r\n        <div\r\n          class=\"select-county Spa_Style_Link can-click ml-4\"\r\n          *ngIf=\"(counties$ | async)?.length > 1 && (county$ | async)\"\r\n          (click)=\"editCounty()\"\r\n          (keydown.enter)=\"editCounty()\"\r\n          tabindex=\"0\"\r\n          [attr.aria-label]=\"editCountyDescription\"\r\n        >\r\n          {{ editCountyText }}\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n  <div *ngIf=\"totalCountsMessageEnabled && showTotalCountString && totalCountsString\" class=\"col-12 Spa_Style_Note py-2\">\r\n    <ng-container *ngIf=\"totalCountsYearClickable; else notClickable\">\r\n      <vnext-inner-text-link [outerText]=\"totalCountsString\" [innerText]=\"selectedPlanYear\" (innerTextClicked)=\"openPlanYearPopup()\">\r\n      </vnext-inner-text-link\r\n    ></ng-container>\r\n    <ng-template #notClickable>{{ totalCountsString }}</ng-template>\r\n  </div>\r\n</div>\r\n", styles: [".error-display{height:24px}.zip-error{white-space:nowrap}.demographic-input{min-width:100px;max-width:100px;height:38px;vertical-align:top;padding:5px 11px;font-family:montserratregular}.remove-right-round{border-top-right-radius:0;border-bottom-right-radius:0}.county-container{position:relative;margin-top:12px;display:inline-block}.selected-county,.selected-county div{display:inline-block}.selected-county-display{display:inline-block;min-width:65px}.noButtonInputBox{flex-basis:auto;width:140px}.select_county{cursor:pointer;display:inline-block;padding-left:15px}.county-dropdown-list{background-color:#fff;border:1px solid rgba(0,0,0,.15);border-radius:4px;min-width:160px;padding:10px;position:absolute;z-index:1000}.county-dropdown-list.county-error{border-color:var(--static-Spa_Style_Accent2)}.county-dropdown-item{cursor:pointer;padding-bottom:5px;padding-left:5px;padding-top:5px}.county-dropdown-item:hover{background-color:var(--static-Spa_Style_Gray1)}.county-dropdown-header:hover{background-color:#fff}@media (max-width: 768px){.zip-code-label{width:100%}}\n"] }]
    }], function () { return [{ type: i2.Store }, { type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: i1.NavigationService }, { type: WidgetService }, { type: ConfigurableWidgetService }, { type: i1.DemographicHttpService }, { type: AnalyticsService }, { type: i1.ZipCodeService }, { type: ZipCodeContextService }, { type: i1.CarriersService }, { type: i1.PlansService }, { type: i1.PlanYearService }, { type: i1.PlanYearResourceService }, { type: i1$1.NgbModal }]; }, { error$: [], retrieveZipCode: [{
            type: Input
        }], retrieveFipsCode: [{
            type: Input
        }], retrieveCounties: [{
            type: Input
        }], zipCodeErrorText: [{
            type: Input
        }], countyErrorText: [{
            type: Input
        }], selectCountyText: [{
            type: Input
        }], zipCodeText: [{
            type: Input
        }], editCountyText: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], editCountyDescription: [{
            type: Input
        }], countyLabel: [{
            type: Input
        }], showCountyLabel: [{
            type: Input
        }], isReadOnly: [{
            type: Input
        }], selectedCountyEnabled: [{
            type: Input
        }], showCounty: [{
            type: Input
        }], validateOnBlur: [{
            type: Input
        }], checkCounty: [{
            type: Input
        }], searchButtonTemplate: [{
            type: Input
        }], defaultZipCode: [{
            type: Input
        }], defaultFipsCode: [{
            type: Input
        }], customStyles: [{
            type: Input
        }], emitOnEmptyValue: [{
            type: Input
        }], fireEnterEvent: [{
            type: Input
        }], logAnalytics: [{
            type: Input
        }], isProfileZip: [{
            type: Input
        }], totalCountsMessageEnabled: [{
            type: Input
        }], isModal: [{
            type: Input
        }], totalCountsYearClickable: [{
            type: Input
        }], zip: [{
            type: Output
        }], fips: [{
            type: Output
        }], onError: [{
            type: Output
        }], onEnterClick: [{
            type: Output
        }], saveCounty: [], editCounty: [] }); })();

function ModalFooterComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function ModalFooterComponent_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.cancelButtonAction.emit()); })("keyup.enter", function ModalFooterComponent_button_1_Template_button_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.cancelButtonAction.emit()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.cancelButtonText, " ");
} }
function ModalFooterComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function ModalFooterComponent_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.extraButtonAction.emit()); })("keyup.enter", function ModalFooterComponent_button_2_Template_button_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.extraButtonAction.emit()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.extraButtonText, " ");
} }
function ModalFooterComponent_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function ModalFooterComponent_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.primaryButtonAction.emit()); })("keyup.enter", function ModalFooterComponent_button_3_Template_button_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.primaryButtonAction.emit()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.primaryButtonText, " ");
} }
class ModalFooterComponent {
    constructor() {
        this.cancelButtonEnabled = true;
        this.primaryButtonEnabled = true;
        this.extraButtonEnabled = false;
        this.cancelButtonText = 'Cancel';
        this.primaryButtonText = 'Continue';
        this.extraButtonText = 'Extra';
        this.cancelButtonAction = new EventEmitter();
        this.primaryButtonAction = new EventEmitter();
        this.extraButtonAction = new EventEmitter();
    }
}
ModalFooterComponent.ɵfac = function ModalFooterComponent_Factory(t) { return new (t || ModalFooterComponent)(); };
ModalFooterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ModalFooterComponent, selectors: [["vnext-widget-modal-footer"]], inputs: { cancelButtonEnabled: "cancelButtonEnabled", primaryButtonEnabled: "primaryButtonEnabled", extraButtonEnabled: "extraButtonEnabled", cancelButtonText: "cancelButtonText", primaryButtonText: "primaryButtonText", extraButtonText: "extraButtonText" }, outputs: { cancelButtonAction: "cancelButtonAction", primaryButtonAction: "primaryButtonAction", extraButtonAction: "extraButtonAction" }, decls: 4, vars: 3, consts: [[1, "modal-footer", "justify-content-start"], ["type", "button", "class", "btn Spa_Style_SecondaryButton mr-auto", 3, "click", "keyup.enter", 4, "ngIf"], ["type", "button", "class", "btn Spa_Style_SecondaryButton", 3, "click", "keyup.enter", 4, "ngIf"], ["type", "button", "class", "btn Spa_Style_PrimaryButton", 3, "click", "keyup.enter", 4, "ngIf"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "mr-auto", 3, "click", "keyup.enter"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", 3, "click", "keyup.enter"], ["type", "button", 1, "btn", "Spa_Style_PrimaryButton", 3, "click", "keyup.enter"]], template: function ModalFooterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, ModalFooterComponent_button_1_Template, 2, 1, "button", 1);
        i0.ɵɵtemplate(2, ModalFooterComponent_button_2_Template, 2, 1, "button", 2);
        i0.ɵɵtemplate(3, ModalFooterComponent_button_3_Template, 2, 1, "button", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.cancelButtonEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.extraButtonEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.primaryButtonEnabled);
    } }, dependencies: [i1$2.NgIf], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ModalFooterComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-modal-footer', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"modal-footer justify-content-start\">\r\n  <button\r\n    *ngIf=\"cancelButtonEnabled\"\r\n    type=\"button\"\r\n    class=\"btn Spa_Style_SecondaryButton mr-auto\"\r\n    (click)=\"cancelButtonAction.emit()\"\r\n    (keyup.enter)=\"cancelButtonAction.emit()\"\r\n  >\r\n    {{ cancelButtonText }}\r\n  </button>\r\n  <button\r\n    *ngIf=\"extraButtonEnabled\"\r\n    type=\"button\"\r\n    class=\"btn Spa_Style_SecondaryButton\"\r\n    (click)=\"extraButtonAction.emit()\"\r\n    (keyup.enter)=\"extraButtonAction.emit()\"\r\n  >\r\n    {{ extraButtonText }}\r\n  </button>\r\n  <button\r\n    *ngIf=\"primaryButtonEnabled\"\r\n    type=\"button\"\r\n    class=\"btn Spa_Style_PrimaryButton\"\r\n    (click)=\"primaryButtonAction.emit()\"\r\n    (keyup.enter)=\"primaryButtonAction.emit()\"\r\n  >\r\n    {{ primaryButtonText }}\r\n  </button>\r\n</div>\r\n" }]
    }], null, { cancelButtonEnabled: [{
            type: Input
        }], primaryButtonEnabled: [{
            type: Input
        }], extraButtonEnabled: [{
            type: Input
        }], cancelButtonText: [{
            type: Input
        }], primaryButtonText: [{
            type: Input
        }], extraButtonText: [{
            type: Input
        }], cancelButtonAction: [{
            type: Output
        }], primaryButtonAction: [{
            type: Output
        }], extraButtonAction: [{
            type: Output
        }] }); })();

const _c0$3M = ["zipInput"];
class ZipCodeModalComponent {
    constructor(activeModal, widgetValidationService, navigationService, configResourceService, store, demographicService, zipCodeService, siteService, snpService) {
        this.activeModal = activeModal;
        this.widgetValidationService = widgetValidationService;
        this.navigationService = navigationService;
        this.configResourceService = configResourceService;
        this.store = store;
        this.demographicService = demographicService;
        this.zipCodeService = zipCodeService;
        this.siteService = siteService;
        this.snpService = snpService;
        this.zipCodeStyles = { roundInputRightBorder: true };
        this.checkFocus = false;
        this.isValid = true;
        this.fireInputEnter = true;
        this.isProfileZip = false;
    }
    ngOnInit() {
        this.initializeInstanceVariables();
    }
    ngAfterViewChecked() {
        if (this.checkFocus) {
            const invalidZipFormInput = document.querySelector('.modal-body input.has-error');
            const invalidZipFormInputElement = invalidZipFormInput;
            const invalidCountyFormInput = document.querySelector('.county-error .county-dropdown-item');
            const invalidCountyFormInputElement = invalidCountyFormInput;
            if (invalidZipFormInputElement) {
                invalidZipFormInputElement.focus();
            }
            if (invalidCountyFormInputElement) {
                invalidCountyFormInputElement.focus();
            }
            this.checkFocus = false;
        }
    }
    cancel() {
        this.activeModal.dismiss();
    }
    updateZip(zip) {
        this.zip = zip;
    }
    updateFips(fips) {
        this.fips = fips;
        // Reset validity if receiving events on county selection.
        if (!this.isValid) {
            this.isValid = true;
        }
    }
    updateErrorStatus(errors) {
        this.isValid = !errors.length;
        if (!this.isValid) {
            this.checkFocus = true;
        }
    }
    continue() {
        const zipInputErrors = this.zipInput?.validateWidget?.() ?? [];
        if (this.isValid && !zipInputErrors.length) {
            this.zipCodeService.selectLocation(this.zip, this.fips);
            if (this.continueButtonAction) {
                this.continueButtonAction();
            }
            else {
                // get zip and fips from the zip code input component
                // update store with new zip and fips
                this.demographicService.selectLocation(this.fips, this.zip);
                this.demographicService.updateDemographicSession();
                this.navigate();
            }
        }
    }
    navigate() {
        if (this.isRetentionView && this.redirectToSummary) {
            this.navigationService.navigateByPageTag(this.configResourceService.getProcessedResourceValue('Spa_RetentionSite_Custom_Navigation_PageTag', null, PageTags.RETENTION_SUMMARY));
            this.activeModal.close();
        }
        else if (this.siteService.isQuotingSite() && this.redirectToSummary) {
            this.navigationService.navigateByPageTag(PageTags.QUOTE_SUMMARY);
            this.activeModal.close();
        }
        else {
            this.snpService.updateNullVisibilities();
            this.navigationService
                .navigate({
                title: '',
                type: LinkType.INTERNAL,
                tag: PageTags.PLAN_LIST,
                validateWidgets: false
            })
                .then(success => {
                if (success) {
                    this.activeModal.close();
                }
            });
        }
    }
    initializeInstanceVariables() {
        this.isRetentionView = this.siteService.isRetentionView();
        this.title = this.isCountyModal
            ? this.configResourceService.getProcessedResourceValue('Spa_CountyInputModal_Title_Text', null, 'Select county')
            : this.configResourceService.getProcessedResourceValue('Spa_ZipCodeInputModal_Title', null, 'Enter ZIP code');
        this.body = this.isCountyModal
            ? this.configResourceService.getProcessedResourceValue('Spa_CountyInputModal_Body_Text', null, 'Please select your county to see plans.')
            : this.configResourceService.getProcessedResourceValue('Spa_ZipCodeInputBody_Text', null, 'Please enter your ZIP code to see plans.');
        this.cancelButton = this.isCountyModal
            ? this.configResourceService.getProcessedResourceValue('Spa_ReplacePlanModal_Cancel', null, 'Cancel')
            : this.configResourceService.getProcessedResourceValue('Spa_ZipCodeInputModal_Cancel', null, 'Close');
        this.continueButton = this.configResourceService.getProcessedResourceValue('Spa_ZipCodeInputModal_Confirm', null, 'Shop for plans');
        this.zipCodeLabel = this.configResourceService.getProcessedResourceValue('Spa_Site_ZipCodeInput_ZipCodeLabel', null, 'Zip code');
        this.editCounty = this.configResourceService.getProcessedResourceValue('Spa_Site_ZipCodeInput_EditCounty', null, 'Edit');
        this.editCountyDescription = this.configResourceService.getProcessedResourceValue('Spa_Site_ZipCodeInput_EditCounty_Description', null, 'Edit county');
        this.selectCounty = this.configResourceService.getProcessedResourceValue('Spa_Site_ZipCodeInput_SelectCounty_Dropdown_Title', null, 'Select county');
        this.countyError = this.configResourceService.getProcessedResourceValue('Spa_Site_ZipCodeInput_CountyError', null, 'Please select your county');
        this.zipCodeError = this.configResourceService.getProcessedResourceValue('Spa_Site_ZipCodeInput_ZipCodeError', null, 'Zip code is invalid');
        this.selectedCountyEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_ZipCodeInput_SelectedCountyEnabled', null, true);
        this.errorKeywordText = this.configResourceService.getProcessedResourceValue('Spa_Site_ErrorKeyword_Text', null, 'Error:');
        this.countyLabel = this.configResourceService.getProcessedResourceValue('Spa_ZipCodeInput_CountyLabel_Text', null, 'County');
        this.showCountyLabel = this.configResourceService.getProcessedResourceValue('Spa_ZipCodeInput_CountyLabel_Enabled', null, false);
    }
}
ZipCodeModalComponent.ɵfac = function ZipCodeModalComponent_Factory(t) { return new (t || ZipCodeModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.DemographicService), i0.ɵɵdirectiveInject(i1.ZipCodeService), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(i1.SNPService)); };
ZipCodeModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ZipCodeModalComponent, selectors: [["ng-component"]], viewQuery: function ZipCodeModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3M, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.zipInput = _t.first);
    } }, decls: 6, vars: 22, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "modal-body"], [3, "retrieveFipsCode", "retrieveZipCode", "retrieveCounties", "zipCodeText", "editCountyText", "selectCountyText", "countyErrorText", "zipCodeErrorText", "selectedCountyEnabled", "customStyles", "errorKeywordText", "editCountyDescription", "validateOnBlur", "countyLabel", "showCountyLabel", "fireEnterEvent", "isProfileZip", "isModal", "zip", "fips", "onError", "onEnterClick"], ["zipInput", ""], [3, "cancelButtonText", "primaryButtonText", "cancelButtonAction", "primaryButtonAction"]], template: function ZipCodeModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function ZipCodeModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.cancel(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementStart(3, "vnext-zip-code-input", 2, 3);
        i0.ɵɵlistener("zip", function ZipCodeModalComponent_Template_vnext_zip_code_input_zip_3_listener($event) { return ctx.updateZip($event); })("fips", function ZipCodeModalComponent_Template_vnext_zip_code_input_fips_3_listener($event) { return ctx.updateFips($event); })("onError", function ZipCodeModalComponent_Template_vnext_zip_code_input_onError_3_listener($event) { return ctx.updateErrorStatus($event); })("onEnterClick", function ZipCodeModalComponent_Template_vnext_zip_code_input_onEnterClick_3_listener() { return ctx.continue(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "vnext-widget-modal-footer", 4);
        i0.ɵɵlistener("cancelButtonAction", function ZipCodeModalComponent_Template_vnext_widget_modal_footer_cancelButtonAction_5_listener() { return ctx.cancel(); })("primaryButtonAction", function ZipCodeModalComponent_Template_vnext_widget_modal_footer_primaryButtonAction_5_listener() { return ctx.continue(); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.body, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("retrieveFipsCode", ctx.retrieveFipsCode)("retrieveZipCode", ctx.retrieveZipCode)("retrieveCounties", ctx.retrieveCounties)("zipCodeText", ctx.zipCodeLabel)("editCountyText", ctx.editCounty)("selectCountyText", ctx.selectCounty)("countyErrorText", ctx.countyError)("zipCodeErrorText", ctx.zipCodeError)("selectedCountyEnabled", ctx.selectedCountyEnabled)("customStyles", ctx.zipCodeStyles)("errorKeywordText", ctx.errorKeywordText)("editCountyDescription", ctx.editCountyDescription)("validateOnBlur", false)("countyLabel", ctx.countyLabel)("showCountyLabel", ctx.showCountyLabel)("fireEnterEvent", ctx.fireInputEnter)("isProfileZip", ctx.isProfileZip)("isModal", true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("cancelButtonText", ctx.cancelButton)("primaryButtonText", ctx.continueButton);
    } }, dependencies: [ZipCodeInputComponent, ModalFooterComponent, ModalHeaderComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ZipCodeModalComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"cancel()\"></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body\">\r\n  {{ body }}\r\n  <vnext-zip-code-input\r\n    #zipInput\r\n    [retrieveFipsCode]=\"retrieveFipsCode\"\r\n    [retrieveZipCode]=\"retrieveZipCode\"\r\n    [retrieveCounties]=\"retrieveCounties\"\r\n    [zipCodeText]=\"zipCodeLabel\"\r\n    [editCountyText]=\"editCounty\"\r\n    [selectCountyText]=\"selectCounty\"\r\n    [countyErrorText]=\"countyError\"\r\n    [zipCodeErrorText]=\"zipCodeError\"\r\n    [selectedCountyEnabled]=\"selectedCountyEnabled\"\r\n    [customStyles]=\"zipCodeStyles\"\r\n    (zip)=\"updateZip($event)\"\r\n    (fips)=\"updateFips($event)\"\r\n    (onError)=\"updateErrorStatus($event)\"\r\n    [errorKeywordText]=\"errorKeywordText\"\r\n    [editCountyDescription]=\"editCountyDescription\"\r\n    [validateOnBlur]=\"false\"\r\n    [countyLabel]=\"countyLabel\"\r\n    [showCountyLabel]=\"showCountyLabel\"\r\n    (onEnterClick)=\"continue()\"\r\n    [fireEnterEvent]=\"fireInputEnter\"\r\n    [isProfileZip]=\"isProfileZip\"\r\n    [isModal]=\"true\"\r\n  ></vnext-zip-code-input>\r\n</div>\r\n<vnext-widget-modal-footer\r\n  [cancelButtonText]=\"cancelButton\"\r\n  [primaryButtonText]=\"continueButton\"\r\n  (cancelButtonAction)=\"cancel()\"\r\n  (primaryButtonAction)=\"continue()\"\r\n></vnext-widget-modal-footer>\r\n" }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i1.WidgetValidationService }, { type: i1.NavigationService }, { type: i1.ConfigResourceService }, { type: i2.Store }, { type: i1.DemographicService }, { type: i1.ZipCodeService }, { type: i1.SiteService }, { type: i1.SNPService }]; }, { zipInput: [{
            type: ViewChild,
            args: ['zipInput']
        }] }); })();

const TOOLTIP_TIMEOUT = 3000;
const RESET_REQUIRED_ERROR = 'User account is locked. Password rest required.';
const MESSAGE_ONLY_INTEGRATION = 3; // Message Only Enrollment contains integrationType 3

class GlobalFacade {
    closeTooltip(tooltip, wait) {
        timer(wait ? wait : 0)
            .pipe(take(1))
            .subscribe(() => {
            if (tooltip.isOpen()) {
                tooltip.close();
            }
        });
    }
}
GlobalFacade.ɵfac = function GlobalFacade_Factory(t) { return new (t || GlobalFacade)(); };
GlobalFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GlobalFacade, factory: GlobalFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GlobalFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class EnrollmentHistoryFacade {
    constructor(enrollmentHistoryService, configResourceService, siteService, planYearResourceService) {
        this.enrollmentHistoryService = enrollmentHistoryService;
        this.configResourceService = configResourceService;
        this.siteService = siteService;
        this.planYearResourceService = planYearResourceService;
    }
    /**
     * @returns every enrollment passed in that is in a completed state.
     */
    getCompletedEnrollments(enrollments, includeSOA) {
        const completedEnrollments = this.enrollmentHistoryService.getCompletedEnrollments(enrollments, includeSOA);
        return this.setCompletedMemberEnrollmentFlags(completedEnrollments, includeSOA);
    }
    /**
     * @returns every enrollment passed in that is in an uncompleted state.
     */
    getPartialEnrollments(enrollments, includeSOA) {
        return this.enrollmentHistoryService.getPartialEnrollments(enrollments, includeSOA);
    }
    /**
     * @returns true if every enrollment passed in is completed, false otherwise.
     */
    areAllEnrollmentsComplete(enrollments) {
        return this.enrollmentHistoryService.areAllEnrollmentsComplete(enrollments);
    }
    getSuccessAuthCodeMessage(authCode, widgetName) {
        const message = this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_SuccessMessage_AuthCodeMessage', widgetName, 'Authorization code: <authCode>');
        return message ? message.replace('<authCode>', authCode) : '';
    }
    sortEnrollments(enrollments) {
        if (enrollments) {
            return enrollments
                .map((enrollment) => this.sortCallRecordings(enrollment))
                .sort((firstItem, secondItem) => {
                if (this.isEnrollmentBeforeDate(firstItem, secondItem, !!firstItem.completedWhen && !!secondItem.completedWhen)) {
                    return 1;
                }
                if (this.isEnrollmentAfterDate(firstItem, secondItem, !!firstItem.completedWhen && !!secondItem.completedWhen)) {
                    return -1;
                }
            });
        }
        return [];
    }
    sortCallRecordings(enrollment) {
        const sortedEnrollment = { ...enrollment };
        if (sortedEnrollment.agentCallRecords) {
            sortedEnrollment.agentCallRecords = [...sortedEnrollment.agentCallRecords].sort((firstItem, secondItem) => {
                if (this.isCallRecordingBeforeDate(firstItem, secondItem)) {
                    return 1;
                }
                if (this.isCallRecordingAfterDate(firstItem, secondItem)) {
                    return -1;
                }
            });
        }
        return sortedEnrollment;
    }
    isCallRecordingBeforeDate(firstItem, secondItem) {
        return DateUtilities.dateTimeBefore(DateUtilities.getFormattedDateTime(new Date(firstItem.timestamp)), DateUtilities.getFormattedDateTime(new Date(secondItem.timestamp)));
    }
    isCallRecordingAfterDate(firstItem, secondItem) {
        return DateUtilities.dateTimeAfter(DateUtilities.getFormattedDateTime(new Date(firstItem.timestamp)), DateUtilities.getFormattedDateTime(new Date(secondItem.timestamp)));
    }
    isEnrollmentBeforeDate(firstItem, secondItem, isCompletedEnrollment) {
        if (isCompletedEnrollment) {
            return DateUtilities.dateTimeBefore(DateUtilities.getFormattedDateTime(new Date(firstItem.completedWhen)), DateUtilities.getFormattedDateTime(new Date(secondItem.completedWhen)));
        }
        if (!isCompletedEnrollment) {
            return DateUtilities.dateTimeBefore(DateUtilities.getFormattedDateTime(new Date(firstItem.modifiedWhen)), DateUtilities.getFormattedDateTime(new Date(secondItem.modifiedWhen)));
        }
        return false;
    }
    isEnrollmentAfterDate(firstItem, secondItem, isCompletedEnrollment) {
        if (isCompletedEnrollment) {
            return DateUtilities.dateTimeAfter(DateUtilities.getFormattedDateTime(new Date(firstItem.completedWhen)), DateUtilities.getFormattedDateTime(new Date(secondItem.completedWhen)));
        }
        if (!isCompletedEnrollment) {
            return DateUtilities.dateTimeAfter(DateUtilities.getFormattedDateTime(new Date(firstItem.modifiedWhen)), DateUtilities.getFormattedDateTime(new Date(secondItem.modifiedWhen)));
        }
        return false;
    }
    isSOAEnrollment(coverageTypeEvent) {
        return this.enrollmentHistoryService.isSOAEnrollment(coverageTypeEvent);
    }
    setCompletedMemberEnrollmentFlag(memberEnrollment, includeSOA) {
        if (this.enrollmentHistoryService.isCompletedEnrollment(memberEnrollment, includeSOA)) {
            return {
                ...memberEnrollment,
                canDisplayDocuments: this.getCanDisplayDocumentsFlag(memberEnrollment),
                showViewApplicationLink: this.getShowViewApplicationLink(memberEnrollment)
            };
        }
        return memberEnrollment;
    }
    setCompletedMemberEnrollmentFlags(memberEnrollments, includeSOA) {
        return memberEnrollments?.map(memberEnrollment => this.setCompletedMemberEnrollmentFlag(memberEnrollment, includeSOA)) ?? [];
    }
    getCanDisplayDocumentsFlag(memberEnrollment) {
        const isPPCSite = this.siteService.isPPCSite();
        if (!isPPCSite && memberEnrollment.userType === EnrollmentUserType.BROKER) {
            return false;
        }
        return (!!memberEnrollment.completedWhen && (!this.isPlanYearSpecificEnrollment(memberEnrollment) || memberEnrollment.isCurrentYearEnrollment));
    }
    getShowViewApplicationLink(memberEnrollment) {
        const planYear = this.planYearResourceService.getIsDualPlanYearSite()
            ? this.planYearResourceService.getDualPlanYear()
            : this.planYearResourceService.getCurrentPlanYear();
        const effectiveYear = +memberEnrollment.effectiveDate?.substring(0, 4);
        const showPastMedicareHistory = this.showPastMedicareHistory();
        // Logic for plan year specific plan types (currently PDP, MA, MAPD)
        if (this.isPlanYearSpecificEnrollment(memberEnrollment)) {
            if (showPastMedicareHistory) {
                if (effectiveYear && effectiveYear < planYear) {
                    const visiblePlanYearFloor = planYear - this.getPastMedicareEnrollmentHistoryYears();
                    if (effectiveYear >= visiblePlanYearFloor) {
                        return true;
                    }
                }
            }
            const planYearIsInThePastFromSelectedPlanYear = memberEnrollment.planYear
                ? memberEnrollment.planYear < +this.planYearResourceService.getSelectedPlanYear()
                : false;
            return showPastMedicareHistory
                ? memberEnrollment.isCurrentYearEnrollment
                : memberEnrollment.isCurrentYearEnrollment && !planYearIsInThePastFromSelectedPlanYear;
        }
        // Logic for non plan year specific plan types (currently MedSup, Dental, Vision, HIP)
        if (this.getShowPastHistoryForNonPlanYearSpecificPlans(memberEnrollment)) {
            return DateUtilities.isDateWithinMonthsRange(memberEnrollment?.effectiveDate, this.getNonPlanYearSpecificMonthRange(memberEnrollment), planYear - 1);
        }
        return effectiveYear === planYear;
    }
    getPastMedicareEnrollmentHistoryYears(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_EnrollmentHistory_Medicare_Years', widgetName, 2);
    }
    getPastMedigapEnrollmentHistoryMonths(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_EnrollmentHistory_Medigap_Months', widgetName, 24);
    }
    getPastAncillarynrollmentHistoryMonths(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_EnrollmentHistory_Ancillary_Months', widgetName, 24);
    }
    showPastMedicareHistory(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_EnrollmentHistory_ViewMedicarePastYearPDF_Link_Enabled', widgetName, false);
    }
    showPastMedSupHistory(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_EnrollmentHistory_ViewMedSupPastPDF_Link_Enabled', widgetName, false);
    }
    showPastAncillaryHistory(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_EnrollmentHistory_ViewAncillaryPastPDF_Link_Enabled', widgetName, false);
    }
    // We could have future plan types that are plan year specific that falls out of medicare, but for now they're equivalent.
    isPlanYearSpecificEnrollment(memberEnrollment) {
        return this.isMedicareEnrollment(memberEnrollment);
    }
    isMedicareEnrollment(memberEnrollment) {
        return MEDICARE_PLAN_TYPE_VALUES.includes(memberEnrollment?.planTypeID);
    }
    isMedigapEnrollment(memberEnrollment) {
        return memberEnrollment?.planTypeID === PlanType.MEDIGAP;
    }
    isAncillaryEnrollment(memberEnrollment) {
        return (memberEnrollment?.planTypeID === PlanType.DENTAL ||
            memberEnrollment?.planTypeID === PlanType.VISION ||
            memberEnrollment?.planTypeID === PlanType.HC);
    }
    getNonPlanYearSpecificMonthRange(memberEnrollment, widgetName) {
        if (this.isMedigapEnrollment(memberEnrollment)) {
            return this.getPastMedigapEnrollmentHistoryMonths(widgetName);
        }
        if (this.isAncillaryEnrollment(memberEnrollment)) {
            return this.getPastAncillarynrollmentHistoryMonths(widgetName);
        }
    }
    getShowPastHistoryForNonPlanYearSpecificPlans(memberEnrollment, widgetName) {
        if (this.isMedigapEnrollment(memberEnrollment)) {
            return this.showPastMedSupHistory(widgetName);
        }
        if (this.isAncillaryEnrollment(memberEnrollment)) {
            return this.showPastAncillaryHistory(widgetName);
        }
    }
}
EnrollmentHistoryFacade.ɵfac = function EnrollmentHistoryFacade_Factory(t) { return new (t || EnrollmentHistoryFacade)(i0.ɵɵinject(i1.EnrollmentHistoryService), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.SiteService), i0.ɵɵinject(i1.PlanYearResourceService)); };
EnrollmentHistoryFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EnrollmentHistoryFacade, factory: EnrollmentHistoryFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentHistoryFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.EnrollmentHistoryService }, { type: i1.ConfigResourceService }, { type: i1.SiteService }, { type: i1.PlanYearResourceService }]; }, null); })();

class CrossSellPlanContext {
    constructor() {
        this._resetCrossSellAttributes$ = new Subject();
        this.resetCrossSellAttributes$ = this._resetCrossSellAttributes$.asObservable();
    }
    resetCrossSellAttributes() {
        this._resetCrossSellAttributes$.next(null);
    }
}
CrossSellPlanContext.ɵfac = function CrossSellPlanContext_Factory(t) { return new (t || CrossSellPlanContext)(); };
CrossSellPlanContext.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CrossSellPlanContext, factory: CrossSellPlanContext.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CrossSellPlanContext, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

// These two enums have capital properties as they're based off of data coming from API
var CategoryHeaderDefaults;
(function (CategoryHeaderDefaults) {
    CategoryHeaderDefaults["Dental"] = "Dental";
    CategoryHeaderDefaults["Hearing"] = "Hearing";
    CategoryHeaderDefaults["Vision"] = "Vision";
    CategoryHeaderDefaults["DentalVision"] = "Dental and Vision Package";
    CategoryHeaderDefaults["DentalHearing"] = "Dental and Hearing Package";
    CategoryHeaderDefaults["VisionHearing"] = "Vision and Hearing Package";
    CategoryHeaderDefaults["DentalVisionHearing"] = "Dental, Vision, and Hearing Package";
})(CategoryHeaderDefaults || (CategoryHeaderDefaults = {}));
class RiderFacade {
    constructor(store, configResourceService, demographicService, shoppingCartService, ridersService) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.demographicService = demographicService;
        this.shoppingCartService = shoppingCartService;
        this.ridersService = ridersService;
    }
    removeRider(riderId, planId) {
        this.shoppingCartService.removeRider(riderId, planId);
    }
    selectRider(rider, planId) {
        this.shoppingCartService.selectRider(rider.planID, planId);
    }
    categorySorter() {
        return (firstCategory, secondCategory) => {
            if (firstCategory.riderTypeCount > secondCategory.riderTypeCount) {
                return 1;
            }
            if (firstCategory.riderTypeCount < secondCategory.riderTypeCount) {
                return -1;
            }
            if (firstCategory.header > secondCategory.header) {
                return 1;
            }
            if (firstCategory.header < secondCategory.header) {
                return -1;
            }
            return 0;
        };
    }
    riderSorter() {
        return (firstRider, secondRider) => {
            if (firstRider.planName > secondRider.planName) {
                return 1;
            }
            if (firstRider.planName < secondRider.planName) {
                return -1;
            }
            return 0;
        };
    }
    getRiderCategories(riders) {
        const categories = [];
        riders.forEach(rider => {
            Object.keys(RiderSubTypes).forEach(subType => {
                if (rider.planSubType.includes(subType)) {
                    categories.push(subType);
                }
            });
        });
        return [...new Set(categories)];
    }
    getSelectedRiderIds() {
        return this.store.selectSnapshot(ShoppingCartState.selectedRiderIds);
    }
    getSelectedRiders$() {
        return this.shoppingCartService.getSelectedRiders$();
    }
    riderIsSelected(selectedRiderIds, riderId) {
        return selectedRiderIds.includes(riderId);
    }
    createRiderCategories(riders, isWaiverState) {
        if (isWaiverState) {
            return [
                {
                    header: null,
                    riderTypeCount: 3,
                    riders: [...riders].sort(this.riderSorter()).filter(rider => this.getRiderMedicalPremium(rider) !== 0),
                    showInformationalText: false,
                    informationalText: null,
                    id: 0
                }
            ].filter(category => category.riders?.length);
        }
        const riderCategories = [];
        if (riders) {
            riders.forEach(rider => {
                const headerResource = this.getRiderCategoryHeaderResources(rider.planSubType);
                const foundCategory = riderCategories.find(category => category.header === headerResource.header);
                if (foundCategory) {
                    foundCategory.riders.push(rider);
                }
                else {
                    riderCategories.push({
                        ...headerResource,
                        riders: [rider]
                    });
                }
            });
        }
        riderCategories.forEach(category => (category.riders = category.riders.sort(this.riderSorter())));
        if (riderCategories && riderCategories.length) {
            return riderCategories.sort(this.categorySorter()).map((category, index) => ({ ...category, id: index }));
        }
    }
    getRiderCategoryHeaderResources(subType) {
        let header = '';
        let showInformationalText = false;
        const subTypeMatch = subType.match(/\//g);
        let riderSubType = this.sanitizeRiderSubType(subType);
        let riderTypeCount = subTypeMatch === null ? 1 : subTypeMatch.length + 1;
        if (riderSubType === 'Combined Ancillary') {
            riderSubType = 'DentalVisionHearing';
            riderTypeCount = 3;
        }
        header =
            this.configResourceService.getProcessedResourceValue(`Spa_ShoppingCart_${riderSubType}RiderHeader_Text`) ||
                CategoryHeaderDefaults[riderSubType];
        const informationalText = this.configResourceService.getProcessedResourceValue(`Spa_ShoppingCart_${riderSubType}RiderInformationalSection_Text`, null, '');
        showInformationalText = this.configResourceService.getProcessedResourceValue(`Spa_ShoppingCart_Show${riderSubType}RiderInformationalSection_Flag`);
        showInformationalText = showInformationalText === null ? true : showInformationalText;
        return { header, riderTypeCount, informationalText, showInformationalText };
    }
    sortRidersByCategory(riders, isWaiverState) {
        const categories = this.createRiderCategories(riders, isWaiverState);
        if (categories) {
            return categories.map(category => category.riders).reduce((acc, val) => acc.concat(val), []);
        }
        return [];
    }
    getRidersSortedByCategory$() {
        const selectedCounty = this.demographicService.getSelectedCounty();
        let isWaiverState = false;
        if (selectedCounty) {
            isWaiverState = this.demographicService.isWaiverStateWithoutRiderCategories(selectedCounty.state);
        }
        return this.getSelectedRiders$().pipe(map(riders => this.sortRidersByCategory(riders, isWaiverState)));
    }
    getRiderMedicalPremium(rider) {
        return this.ridersService.getRiderMedicalPremium(rider);
    }
    isCombinedRider(riderSubType) {
        return (riderSubType === RiderSubTypes.VisionHearing ||
            riderSubType === RiderSubTypes.DentalHearing ||
            riderSubType === RiderSubTypes.DentalVision ||
            riderSubType === RiderSubTypes.All ||
            riderSubType === RiderSubTypes.CombinedAncillary ||
            riderSubType === RiderSubTypes.CombinedAncillaryRider ||
            riderSubType === RiderSubTypes.CombinedRider);
    }
    isDentalRider(riderSubType) {
        return riderSubType === RiderSubTypes.Dental || riderSubType === RiderSubTypes.DentalRider;
    }
    sanitizeRiderSubType(riderSubType) {
        return riderSubType.replace('Rider', '').replace(/\//g, '').trim();
    }
    createRiderBuckets(riders) {
        const riderBuckets = new RiderBuckets();
        riders.forEach(rider => {
            if (rider.planSubType.includes(RiderSubTypes.Dental)) {
                riderBuckets.dental.push(rider);
            }
            if (rider.planSubType.includes(RiderSubTypes.Hearing)) {
                riderBuckets.hearing.push(rider);
            }
            if (rider.planSubType.includes(RiderSubTypes.Vision)) {
                riderBuckets.vision.push(rider);
            }
            if (rider.planSubType === 'Combined Ancillary Rider') {
                riderBuckets.dental.push(rider);
                riderBuckets.hearing.push(rider);
                riderBuckets.vision.push(rider);
            }
        });
        return riderBuckets;
    }
    selectedPlanRiderIds(planId) {
        return this.ridersService.selectedPlanRiderIds(planId);
    }
    /**
     * @param rider this should be a selected rider, which means there will also always be a selected plan
     */
    getParentPlanOfSelectedRider(selectedRiderId) {
        const selectedPlans = this.shoppingCartService.getSelectedPlans();
        let parentPlan;
        if (selectedPlans?.length) {
            for (const selectedPlan of selectedPlans) {
                if (selectedPlan.riders?.map(rider => rider.planID).includes(selectedRiderId)) {
                    parentPlan = selectedPlan;
                    break;
                }
            }
        }
        return parentPlan;
    }
}
RiderFacade.ɵfac = function RiderFacade_Factory(t) { return new (t || RiderFacade)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.DemographicService), i0.ɵɵinject(i1.ShoppingCartService), i0.ɵɵinject(i1.RidersService)); };
RiderFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RiderFacade, factory: RiderFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RiderFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i2.Store }, { type: i1.ConfigResourceService }, { type: i1.DemographicService }, { type: i1.ShoppingCartService }, { type: i1.RidersService }]; }, null); })();

class CartFacade {
    constructor(navigationService, shoppingCartService, modalService, configResourceService, store, plansService, siteService, agentService, agentPermissionsService, analyticsService, globalFacade, enrollmentFormService, planFacade, enrollmentHistoryFacade, crossSellPlanContext, enrollmentSettingsService, sessionService, riderFacade, route, deepLinkingService, planYearResourceService) {
        this.navigationService = navigationService;
        this.shoppingCartService = shoppingCartService;
        this.modalService = modalService;
        this.configResourceService = configResourceService;
        this.store = store;
        this.plansService = plansService;
        this.siteService = siteService;
        this.agentService = agentService;
        this.agentPermissionsService = agentPermissionsService;
        this.analyticsService = analyticsService;
        this.globalFacade = globalFacade;
        this.enrollmentFormService = enrollmentFormService;
        this.planFacade = planFacade;
        this.enrollmentHistoryFacade = enrollmentHistoryFacade;
        this.crossSellPlanContext = crossSellPlanContext;
        this.enrollmentSettingsService = enrollmentSettingsService;
        this.sessionService = sessionService;
        this.riderFacade = riderFacade;
        this.route = route;
        this.deepLinkingService = deepLinkingService;
        this.planYearResourceService = planYearResourceService;
        this.isPDPCrossSell = false;
    }
    isMemberLoading$() {
        return this.sessionService.isMemberLoading$();
    }
    loggedInMemberId$() {
        return this.sessionService.loggedInMemberId$();
    }
    isMemberEnrollmentPlanSettingsLoading$() {
        return this.sessionService.isMemberEnrollmentPlanSettingsLoading$();
    }
    removeFromCart(plan) {
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true });
        const modalTitle = this.configResourceService.getProcessedResourceValue('Spa_RemovePlanModal_Title') || 'Remove Plan';
        const modalPrompt = this.configResourceService.getProcessedResourceValue('Spa_RemovePlanModal_Prompt') ||
            'Are you sure you would like to remove this plan from your shopping cart?';
        const modalCancel = this.configResourceService.getProcessedResourceValue('Spa_RemovePlanModal_Cancel') || 'Cancel';
        const modalConfirm = this.configResourceService.getProcessedResourceValue('Spa_RemovePlanModal_Confirm') || 'Remove';
        confirmationModal.componentInstance.title = modalTitle;
        confirmationModal.componentInstance.prompt = modalPrompt;
        confirmationModal.componentInstance.cancelButton = modalCancel;
        confirmationModal.componentInstance.confirmButton = modalConfirm;
        confirmationModal.result.then(() => {
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_CART_REMOVE_PLAN,
                [DataLayerGlobalVariable.PLAN_ID]: '',
                [DataLayerGlobalVariable.PLAN_TYPE]: '',
                [DataLayerGlobalVariable.REMOVED_PLAN_ID]: plan.id,
                [DataLayerGlobalVariable.REMOVED_PLAN_TYPE]: plan.planTypeAbbreviation,
                [DataLayerGlobalVariable.PLAN_PROVIDER_VBC_STATUS]: '',
                [DataLayerGlobalVariable.REMOVED_PLAN_PROVIDER_VBC_STATUS]: this.planFacade.isVbcAgreementExists(plan)
                    ? GOOGLE_ANALYTICS_YES
                    : GOOGLE_ANALYTICS_NO
            };
            this.shoppingCartService.removePlan(plan.id);
            this.store.dispatch(new SetActiveTab(plan.planTypeAbbreviation));
            this.store.dispatch(new RemovePrimaryCareProvider());
            this.crossSellPlanContext.resetCrossSellAttributes();
            if (this.shoppingCartService.getSelectedPlanIds().length === 0) {
                // // Set override flag to false so we land on the tab for the plantype that is being removed
                this.plansService.setOverrideActiveTab(false);
                this.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
            }
        }, () => { });
    }
    showEnrollmentNotEnabledModal(isMedSupUnavailable) {
        const modalTitle = this.configResourceService.getProcessedResourceValue('Spa_ShoppingCart_EnrollmentUnavailable_Title', null, 'Enrollment is not currently available');
        const modalPrompt = isMedSupUnavailable
            ? this.shoppingCartService.getMedSupUnavailableMessage()
            : this.shoppingCartService.getEnrollmentUnavailableMessage();
        const modalConfirm = this.configResourceService.getProcessedResourceValue('Spa_ShoppingCart_EnrollmentUnavailable_Button', null, 'Close');
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true });
        confirmationModal.componentInstance.title = modalTitle;
        confirmationModal.componentInstance.prompt = modalPrompt;
        confirmationModal.componentInstance.confirmButton = modalConfirm;
        confirmationModal.componentInstance.textCenter = isMedSupUnavailable;
    }
    showReplacePlanInCartModal(plan, cartPlans, cartSettings) {
        let showModal = false;
        if (cartPlans.length && cartSettings.isAddToCartEnabled) {
            if (cartSettings.isCrossSellingEnabled) {
                showModal =
                    this.showModalForMAandMAPD(cartPlans, plan) ||
                        this.showModalForMedSupAndPDP(cartPlans, plan) ||
                        this.showModalForAncillary(cartPlans, plan);
            }
            else {
                const cartPlan = cartPlans[0];
                showModal = plan.id !== cartPlan.id || plan.annualPlanPremium !== cartPlan.annualPlanPremium;
            }
        }
        return showModal;
    }
    showModalForMAandMAPD(cartPlans, selectedPlan) {
        return ((this.shoppingCartService.isPlanMAPD(selectedPlan) || this.shoppingCartService.isPlanMA(selectedPlan)) &&
            !this.shoppingCartService.arePlansInCartAncillary(cartPlans) &&
            cartPlans.every(cartPlan => cartPlan.id !== selectedPlan.id));
    }
    showModalForMedSupAndPDP(cartPlans, selectedPlan) {
        const isSelectedPlanMedSupOrPDP = this.shoppingCartService.isPlanMedSup(selectedPlan) || this.shoppingCartService.isPlanPDP(selectedPlan);
        const isSelectedPlanNotInCart = !this.shoppingCartService.isSelectedPlanInCart(selectedPlan, cartPlans);
        const hasMAOrMAPDPlanInCart = cartPlans.some(cartPlan => this.shoppingCartService.isPlanMA(cartPlan) || this.shoppingCartService.isPlanMAPD(cartPlan));
        return (isSelectedPlanMedSupOrPDP &&
            isSelectedPlanNotInCart &&
            !this.shoppingCartService.arePlansInCartAncillary(cartPlans) &&
            (hasMAOrMAPDPlanInCart || cartPlans.some(cartPlan => cartPlan.planType === selectedPlan.planType)));
    }
    showModalForAncillary(cartPlans, selectedPlan) {
        const isSelectedPlanAncillary = this.shoppingCartService.isPlanAncillary(selectedPlan);
        const isSelectedPlanNotInCart = !this.shoppingCartService.isSelectedPlanInCart(selectedPlan, cartPlans);
        const hasSameAncillaryPlanTypeInCart = cartPlans.some(cartPlan => cartPlan.planSubType === selectedPlan.planSubType);
        return isSelectedPlanAncillary && isSelectedPlanNotInCart && hasSameAncillaryPlanTypeInCart;
    }
    navigateToPlans(pageInjector) {
        const fipsCode = this.sessionService.getFipsCode();
        const zipCode = this.sessionService.getZipCode();
        if (fipsCode && zipCode) {
            this.navigationService.navigate({
                title: '',
                type: LinkType.INTERNAL,
                tag: PageTags.PLAN_LIST,
                validateWidgets: true
            });
        }
        else {
            this.modalService.open(ZipCodeModalComponent, { centered: true, injector: pageInjector });
        }
    }
    changePlanInCart(plan) {
        this.planFacade.tagsToUpdate(DataLayerEvent.CLICK_CART_CHANGE_PLAN, plan.id, plan.planTypeAbbreviation, null, this.planFacade.isVbcAgreementExists(plan));
        this.store.dispatch(new SetActiveTab(plan.planTypeAbbreviation));
        // Set override flag to false so we land on the tab for the plantype that is being changed
        this.plansService.setOverrideActiveTab(false);
        this.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
    }
    viewPlanDetails(plan) {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_CART_VIEW_PLANDETAILS);
        this.navigationService.navigateByPageTag(PageTags.PLAN_DETAILS, { queryParams: { id: plan.id } });
    }
    isPPCSite() {
        const siteType = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType');
        return this.siteService.isPPCSite(siteType);
    }
    closeTooltip(toolTip, wait) {
        this.globalFacade.closeTooltip(toolTip, wait);
    }
    showAgentPlanNotAuthorizedModalComponent() {
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true });
        const modalTitle = this.configResourceService.getProcessedResourceValue('Spa_AgentPlanNotAuthorizedModal_Title', null, 'Not authorized to sell plan');
        const modalPrompt = this.configResourceService.getProcessedResourceValue('Spa_AgentPlanNotAuthorizedModal_Prompt', null, 'You are not authorized to sell this plan. Please shop again.');
        const modalCancel = this.configResourceService.getProcessedResourceValue('Spa_Site_Cancel', null, 'Cancel');
        const modalConfirm = this.configResourceService.getProcessedResourceValue('Spa_Site_ShopForPlans', null, 'Shop for plans');
        confirmationModal.componentInstance.title = modalTitle;
        confirmationModal.componentInstance.prompt = modalPrompt;
        confirmationModal.componentInstance.cancelButton = modalCancel;
        confirmationModal.componentInstance.confirmButton = modalConfirm;
        confirmationModal.result.then(() => {
            // If plantype is not available, let plan list page choose the default
            const shoppingCartPlanType = this.getCartPlanType();
            if (shoppingCartPlanType) {
                this.planFacade.setActiveTab(shoppingCartPlanType);
            }
            if (this.shoppingCartService.isCartEnabled() && this.hasPlanInCart()) {
                const planId = this.getCartPlanId();
                this.shoppingCartService.removePlan(planId);
            }
            // In the unlikely event that agent loses permission in the middle of a user session, fetch plan data again (SPA-3501)
            this.plansService.setPlansDirty(true, [this.plansService.getPlanType(shoppingCartPlanType)]);
            // Set override flag to false so we land on the active tab for the plantype set above
            this.plansService.setOverrideActiveTab(false);
            this.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
        }, () => { });
    }
    async checkPermissionsAndSelectPlan(plan, effectiveDate, fips, toolTip, widgetName) {
        this.processAgentEnrollPermissions(plan, effectiveDate, fips, toolTip, this.selectAndValidatePlan.bind(this, plan, widgetName));
    }
    async processAgentEnrollPermissions(plan, effectiveDate, fips, tooltip, hasPermissionAction) {
        const agentGuid = this.agentService.getAgentInContextGuid();
        if (agentGuid) {
            const selectedPlanYear = this.planYearResourceService.getSelectedPlanYear() ?? new Date().getFullYear();
            const planYear = plan?.planYear ? plan.planYear : +selectedPlanYear;
            const enrollPermissions = await this.agentPermissionsService.getAgentInContextEnrollPermissions(plan.id, planYear, effectiveDate, fips);
            const isEnroller = enrollPermissions.isEnroller;
            const hasPlanPermission = enrollPermissions.hasPlanPermission;
            if (isEnroller && hasPlanPermission) {
                hasPermissionAction(plan.id);
            }
            else {
                if (this.isPPCSite()) {
                    if (!isEnroller) {
                        tooltip.open();
                        // the tooltip will close if the user tabs or clicks elsewhere, or after 3 seconds
                        this.closeTooltip(tooltip, TOOLTIP_TIMEOUT);
                    }
                    else {
                        this.showAgentPlanNotAuthorizedModalComponent();
                    }
                }
                else {
                    // ban agent from session when enrolling if consumer site and no enroller role or plan permission
                    await this.agentService.banAgentFromSession(!isEnroller || !hasPlanPermission);
                    hasPermissionAction(plan.id);
                }
            }
        }
        else {
            hasPermissionAction(plan.id);
        }
    }
    async checkEnrollmentStatusAndAgentPermissions(plan, effectiveDate, fips, toolTip, action) {
        let alreadyEnrolled = false;
        const enrollments = this.store.selectSnapshot(MemberState.memberEnrollmentsByPlanIds([plan.id]));
        if (enrollments?.length) {
            alreadyEnrolled = this.enrollmentHistoryFacade.areAllEnrollmentsComplete(enrollments);
        }
        const allowEnrollingInSamePlan = this.configResourceService.getProcessedResourceValue('Spa_Enrollment_Allow_AlreadyEnrolled_Plans', null, false);
        if (alreadyEnrolled && !allowEnrollingInSamePlan) {
            this.enrollmentFormService.setActiveEnrollmentKey(plan.id);
            this.navigationService.navigateByPageTag(PageTags.ENROLLMENT_CONFIRMATION);
        }
        else {
            this.processAgentEnrollPermissions(plan, effectiveDate, fips, toolTip, action);
        }
    }
    async selectPlanAndEnroll(plan, effectiveDate, fips, toolTip, widgetName) {
        this.checkEnrollmentStatusAndAgentPermissions(plan, effectiveDate, fips, toolTip, this.selectAndValidatePlan.bind(this, plan, widgetName));
    }
    getCartPlanType() {
        // First try getting selected plan type
        const selectedPlan = this.shoppingCartService.getSelectedPlan();
        let shoppingCartPlanType = selectedPlan ? PlanType[selectedPlan.planType] : null;
        let planId = selectedPlan ? selectedPlan.id : null;
        const shoppingCartPlans = this.shoppingCartService.getShoppingCartPlans();
        // If selected plan is null, check if there is a plan in shopping cart
        if (!selectedPlan && shoppingCartPlans?.length) {
            shoppingCartPlanType = shoppingCartPlans[0].planType;
            planId = shoppingCartPlans[0].planId;
            // Shopping cart plantype can sometimes be null, so retrieve from PlanState if so
            if (!shoppingCartPlanType) {
                const matchingPlan = this.plansService.getPlan(shoppingCartPlans[0].planId);
                shoppingCartPlanType = matchingPlan ? PlanType[matchingPlan.planType] : null;
            }
        }
        return shoppingCartPlanType;
    }
    getSelectedPlan() {
        return this.shoppingCartService.getSelectedPlan();
    }
    getSelectedPlans$() {
        return this.shoppingCartService.getSelectedPlans$();
    }
    getSelectedPlanIds$() {
        return this.getSelectedPlans$().pipe(map(plans => (plans ? plans.map(plan => (plan ? plan.id : null)) : [])));
    }
    getPlanEnrollmentSettingsForAllPlans$() {
        return this.getSelectedPlanIds$().pipe(distinctUntilChanged((previousPlanIds, currentPlanIds) => !this.hasShoppingCartPlansChange(previousPlanIds, currentPlanIds)), switchMap(planIds => this.plansService.fetchPlanEnrollmentSettingsForAllPlans$(planIds)));
    }
    getCartPlanId() {
        const selectedPlan = this.shoppingCartService.getSelectedPlan();
        if (selectedPlan?.id) {
            return selectedPlan.id;
        }
        const shoppingCartPlans = this.shoppingCartService.getShoppingCartPlans();
        if (shoppingCartPlans?.length) {
            return shoppingCartPlans[0].planId;
        }
        return null;
    }
    hasPlanInCart() {
        const shoppingCartPlans = this.shoppingCartService.getShoppingCartPlans();
        return shoppingCartPlans && !!shoppingCartPlans.length;
    }
    selectAndValidateByPlanId(planId, widgetName, selectFromPersonalizedVideo) {
        if (planId) {
            const plan = this.plansService.getPlan(planId);
            this.selectAndValidatePlan(plan, widgetName, selectFromPersonalizedVideo);
        }
    }
    selectAndValidatePlan(plan, widgetName, selectFromPersonalizedVideo) {
        const isMedSupPlan = this.shoppingCartService.isPlanMedSup(plan);
        const isAddToCartEnabled = this.shoppingCartService.isCartEnabled();
        const isCrossSellingEnabled = this.shoppingCartService.isCrossSellingEnabled();
        const cartSettings = {
            isEnrollmentEnabled: this.shoppingCartService.isEnrollmentEnabled(),
            isCrossSellingEnabled,
            isAddToCartEnabled,
            isMedSupEnrollmentEnabled: this.shoppingCartService.isMedSupEnrollmentEnabled(),
            isDentalEnrollmentEnabled: this.shoppingCartService.isDentalEnrollmentEnabled(),
            isVisionEnrollmentEnabled: this.shoppingCartService.isVisionEnrollmentEnabled(),
            isHIPEnrollmentEnabled: this.shoppingCartService.isHIPEnrollmentEnabled(),
            widgetName
        };
        const planCanEnroll = this.shoppingCartService.isEnrollmentEnabledByPlanType(plan.planType);
        // If cross-sell/bundling of PDP/Medigap plans enabled then show modal.
        if (isMedSupPlan) {
            if (!planCanEnroll && !isAddToCartEnabled) {
                this.showEnrollmentNotEnabledModal(true);
            }
            else {
                this.addMedSupPlanToCart(plan, cartSettings, selectFromPersonalizedVideo);
            }
        }
        else {
            if (planCanEnroll || isAddToCartEnabled) {
                this.addPDPPlanToCart(plan, cartSettings, selectFromPersonalizedVideo);
            }
            else {
                this.showEnrollmentNotEnabledModal();
            }
        }
    }
    showCrossSellOnShoppingCart(cartPlans, nonCoveredPlanTabMap) {
        const showCrossSellOnShoppingCart = this.shoppingCartService.isCartEnabled() &&
            this.shoppingCartService.isCrossSellingEnabled() &&
            this.shoppingCartService.isMedSupEnrollmentEnabled() &&
            this.plansService.hasMedSupPlans() &&
            this.plansService.hasPDPPlans() &&
            this.isMedSupOrPDPInCart(cartPlans) &&
            this.shoppingCartService.hasMedSupAndPartDTabs();
        if (nonCoveredPlanTabMap) {
            return (showCrossSellOnShoppingCart &&
                nonCoveredPlanTabMap[PlanTypeAbbreviation.PDP].display &&
                nonCoveredPlanTabMap[PlanTypeAbbreviation.MEDIGAP].display);
        }
        return showCrossSellOnShoppingCart;
    }
    isMedSupOrPDPInCart(cartPlans) {
        const isPDPInCart = this.shoppingCartService.isPDPInCart(cartPlans);
        const isMedSupInCart = this.shoppingCartService.isMedSupInCart(cartPlans);
        const hasPDPAndMedSup = isPDPInCart && isMedSupInCart;
        return !hasPDPAndMedSup && (isPDPInCart || isMedSupInCart);
    }
    getCrossSellPlanInCart(cartPlans) {
        if (this.isMedSupOrPDPInCart(cartPlans)) {
            return this.shoppingCartService.getCrossSellPlanInCart(cartPlans);
        }
        return null;
    }
    updateShoppingCartPlanPremium(planId, premium) {
        this.shoppingCartService.updateCartPlanPremium(planId, premium);
    }
    getShoppingCartPremium() {
        return this.shoppingCartService.getShoppingCartPremium();
    }
    getAgentPlanPermissionEffectiveDate(planType) {
        return this.agentService.getPlanPermissionEffectiveDate(planType);
    }
    getPDPCrossSellAttributes(plan, isCart, widgetName) {
        const bundlePlansPrompt = this.configResourceService.getProcessedResourceValue('Spa_CrossSell_PDP_Prompt_Text', widgetName, 'Add a Prescription Drug plan');
        const marketingMessage = this.configResourceService.getProcessedResourceValue('Spa_CrossSell_PDP_Marketing_Text', widgetName, 'Adding a Prescription Drug plan can help save money on your prescription costs.');
        const shopButton = this.configResourceService.getProcessedResourceValue('Spa_CrossSell_ShopForPlans_Text', widgetName, 'Shop for plans');
        const shopAction = () => {
            this.crossSellShopActionAnalytics();
            this.store.dispatch(new SetActiveTab(PlanTypeAbbreviation.PDP));
            if (isCart) {
                // Set override flag to false so we land on the PDP tab
                this.plansService.setOverrideActiveTab(false);
                this.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
            }
        };
        const confirmAction = () => {
            this.crossSellShopGoToCartAnalytics();
            this.navigateToPage(plan, true, true, widgetName);
        };
        return { bundlePlansPrompt, marketingMessage, shopButton, shopAction, confirmAction };
    }
    getMedSupCrossSellAttributes(plan, isCart, widgetName) {
        const bundlePlansPrompt = this.configResourceService.getProcessedResourceValue('Spa_CrossSell_Medsup_Prompt_Text', widgetName, 'Add a Medicare Supplement plan');
        const marketingMessage = this.configResourceService.getProcessedResourceValue('Spa_CrossSell_Medsup_Marketing_Text', widgetName, 'Adding a Medicare Supplement plan can help save money on your doctor visits and hospital stays.');
        const shopButton = this.configResourceService.getProcessedResourceValue('Spa_CrossSell_ShopForPlans_Text', widgetName, 'Shop for plans');
        const shopAction = () => {
            this.crossSellShopActionAnalytics();
            this.store.dispatch(new SetActiveTab(PlanTypeAbbreviation.MEDIGAP));
            if (isCart) {
                // Set override flag to false so we land on the MEDIGAP tab
                this.plansService.setOverrideActiveTab(false);
                this.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
            }
        };
        const confirmAction = () => {
            this.crossSellShopGoToCartAnalytics();
            this.navigateToPage(plan, false, true, widgetName);
        };
        return { bundlePlansPrompt, marketingMessage, shopButton, shopAction, confirmAction };
    }
    isMedSupEnrollment(planId) {
        const plan = this.shoppingCartService.getPlan(planId);
        return plan && plan.planType === PlanType.MEDIGAP;
    }
    getPlanTypeByPlanId(planId) {
        return this.shoppingCartService.getPlan(planId)?.planType;
    }
    removePlanAndAddToCartAction(plan, cartPlans, addToCartAction) {
        const plansToReplace = this.findPlansToReplace(plan, cartPlans);
        if (plansToReplace?.length) {
            plansToReplace.forEach(planToReplace => {
                this.shoppingCartService.removePlan(planToReplace.id);
            });
        }
        else {
            this.shoppingCartService.removeAllPlansFromApi();
        }
        addToCartAction();
    }
    findPlansToReplace(plan, cartPlans) {
        let plansToRemove = [];
        if (!this.shoppingCartService.isPlanAncillary(plan) && !this.plansAreCrossSell(plan, cartPlans)) {
            plansToRemove = this.shoppingCartService.getPlansInCartNotAncillary(cartPlans);
        }
        const samePlanTypeToRemove = cartPlans.find(cartPlan => this.shoppingCartService.isPlanAncillary(plan)
            ? cartPlan.planType === plan.planType && cartPlan.planSubType === plan.planSubType
            : cartPlan.planType === plan.planType);
        // Prevents a duplicate call to delete the same plan ID (2nd call always fails with "INVALID_REQUEST_PLAN_NOT_FOUND")
        if (samePlanTypeToRemove && plansToRemove.every(selectedPlan => selectedPlan.id !== samePlanTypeToRemove.id)) {
            return [...plansToRemove, samePlanTypeToRemove];
        }
        return [...plansToRemove];
    }
    mustShowSOANotCompleted(activities, documents) {
        const soaCompletedWarningEnabled = this.checkSOACompletedWarningEnabled();
        const shoppingCartEnabled = this.shoppingCartService.isCartEnabled();
        const soaEnabled = this.getSOAEnabled();
        const isPPCSite = this.isPPCSite();
        const isValidSOAUploaded = this.isValidSOAUploaded(activities, documents);
        return soaCompletedWarningEnabled && shoppingCartEnabled && soaEnabled && isPPCSite && !isValidSOAUploaded;
    }
    isValidSOAUploaded(activities, documents) {
        const isSOAExpired = this.getSOAExpired(activities);
        const uploadedSOAExpired = this.getUploadedSOAExpired(documents);
        return (activities?.length && !isSOAExpired) || (documents?.length && !uploadedSOAExpired);
    }
    getUploadedSOAExpired(soaFileListResponse) {
        // defaulting to false because if we don't have anything uploaded we won't consider it expired
        let isUploadedSOAExpired = false;
        if (soaFileListResponse?.length) {
            const soaValidDays = this.getSOAExpirationDays();
            const latestUploadedSOA = soaFileListResponse.reduce((fileA, fileB) => DateUtilities.dateTimeAfter(fileA.UploadedDate, fileB.UploadedDate) ? fileA : fileB);
            if (latestUploadedSOA) {
                const dayCountDifference = DateUtilities.getDaysDifference(DateUtilities.getFormattedDate(new Date(latestUploadedSOA.UploadedDate), DateUtilities.defaultDateISOFormat), DateUtilities.getFormattedCurrentDate(DateUtilities.defaultDateISOFormat));
                isUploadedSOAExpired = dayCountDifference > soaValidDays;
            }
        }
        return isUploadedSOAExpired;
    }
    navigateToMemberProfilePage() {
        this.navigationService.navigateByPageTag(PageTags.MEMBER_PROFILE_PAGE);
    }
    selectHIPDefaultBenefit(plan, selectedBenefits) {
        const existingSelectedBenefits = selectedBenefits || this.planFacade.getPlansRiderBenefitCategories();
        if (!existingSelectedBenefits[plan.id]) {
            const defaultBenefits = this.planFacade.getHospitalIndemnityBasePlan(plan);
            if (defaultBenefits?.length) {
                const benefitCategory = [
                    { selectedRiderId: defaultBenefits[0].planID, riderGroupKey: defaultBenefits[0].planTypeDescription }
                ];
                this.planFacade.updatePlansRiderBenefitCategories(plan.id, benefitCategory);
            }
        }
    }
    selectHIPDefaultBenefitsForPlans(plans) {
        const existingSelectedBenefits = this.planFacade.getPlansRiderBenefitCategories();
        plans
            .filter(plan => plan.planTypeAbbreviation === PlanTypeAbbreviation.HC)
            .forEach(plan => {
            this.selectHIPDefaultBenefit(plan, existingSelectedBenefits);
        });
    }
    getExternalEnrollments() {
        return this.store.selectSnapshot(MemberState.externalEnrollments);
    }
    clearShoppingCart() {
        this.shoppingCartService.clearShoppingCart();
    }
    fetchSessionForLastAccessedDate$() {
        const sessionId = this.store.selectSnapshot(MemberState.sessionId);
        return this.sessionService.fetchMemberSession$({ sessionId, includeLastAccessedHistory: true });
    }
    showHospitalIndemnityBenefits(plan, benefitsForHIPPopover) {
        const selectedHIPBenefits = this.planFacade.getPlansRiderBenefitCategories();
        const selectedBenefitIds = selectedHIPBenefits[plan?.id]?.map(benefit => benefit.selectedRiderId);
        if (selectedBenefitIds) {
            const selectedBenefits = plan?.riders?.filter(rider => selectedBenefitIds.includes(rider.planID));
            const selectedBenefitDetails = selectedBenefits?.map(selectedBenefit => ({
                name: selectedBenefit.planName,
                cost: this.riderFacade.getRiderMedicalPremium(selectedBenefit),
                details: selectedBenefit.extendedPlanDetails
                    .find(details => details.name === ExtendedPlanDetailsName.RIDER_BENEFITS)
                    ?.sectionDetails.find(sectionDetails => sectionDetails.description === BenefitType.BENEFIT_AMOUNT)?.value
            }));
            if (selectedBenefitDetails?.length) {
                benefitsForHIPPopover.open({ selectedBenefitDetails });
            }
        }
    }
    getPlanFromQueryParams$() {
        return this.route.queryParams.pipe(switchMap((params) => {
            if (Object.keys(params).length) {
                const planIds = this.deepLinkingService.resolvePlanIDs(params?.PlanID);
                if (planIds.length === 1) {
                    const plansInParam = this.deepLinkingService.setPlansOfParams(planIds);
                    const plan = plansInParam.slice(0, 1);
                    return of(plan[0]);
                }
            }
            return of(null);
        }));
    }
    getDeepLinkPlanAndNavigationPageTag$() {
        return this.getPlanFromQueryParams$().pipe(switchMap(plan => {
            let shoppingCartLink = {};
            if (plan && MEDICARE_PLAN_TYPE_VALUES.includes(plan.planType)) {
                shoppingCartLink = { ...{ plan } };
            }
            else {
                shoppingCartLink = { ...{ navigateTo: PageTags.HOME } };
            }
            return of(shoppingCartLink);
        }));
    }
    getSOAExpired(activities) {
        let isSOAExpired = true;
        const soaValidDays = this.getSOAExpirationDays();
        const soaActivity = this.getCompletedSOAActivity(activities);
        if (soaActivity) {
            const dayCountDifference = DateUtilities.getDaysDifference(DateUtilities.getFormattedDate(new Date(soaActivity.date), DateUtilities.defaultDateISOFormat), DateUtilities.getFormattedCurrentDate(DateUtilities.defaultDateISOFormat));
            isSOAExpired = dayCountDifference > soaValidDays;
        }
        return isSOAExpired;
    }
    getCompletedSOAActivity(activities) {
        const completedSOAActivities = activities.filter(activity => activity.type === SOAActivityType.COMPLETED ||
            activity.type === SOAActivityType.COMPLETED_IN_PERSON ||
            activity.type === SOAActivityType.COMPLETED_BY_PHONE);
        return completedSOAActivities?.reduce((selectedSOAActivity, soaActivity) => selectedSOAActivity && DateUtilities.dateTimeAfter(selectedSOAActivity.date, soaActivity.date) ? selectedSOAActivity : soaActivity, null);
    }
    getSOAExpirationDays(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_CheckSOACompleted_ValidDays', widgetName, 60);
    }
    checkSOACompletedWarningEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_CheckSOACompleted_Enabled', widgetName, false);
    }
    getSOAEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_SOA_Enabled', widgetName, true);
    }
    getCrossSellModalHeaderText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_CrossSell_Header_Text', widgetName, 'Plan added to cart');
    }
    getCrossSellModalSuccessText(plan, widgetName) {
        return this.configResourceService
            .getProcessedResourceValue('Spa_CrossSell_Success_Message_Text', widgetName, '<planName> was added to your cart.')
            .replace('<planName>', plan.planName);
    }
    getCrossSellCancelButtonText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Close', widgetName, 'Close');
    }
    getCrossSellConfirmButtonText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_CrossSell_Confirm_Link_Text', widgetName, 'Go to cart');
    }
    plansAreCrossSell(plan, cartPlans) {
        const isCrossSellPlan = CROSS_SELL_PLANS.includes(plan.planType);
        const isPDPInCart = this.shoppingCartService.isPDPInCart(cartPlans);
        const isMedSupInCart = this.shoppingCartService.isMedSupInCart(cartPlans);
        return isCrossSellPlan && (isPDPInCart || isMedSupInCart);
    }
    getReplaceModalConfirmText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_ReplacePlanModal_Confirm', widgetName, 'Confirm');
    }
    getReplaceModalCancelText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_ReplacePlanModal_Cancel', widgetName, 'Cancel');
    }
    getReplaceModalTitle(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_ReplacePlanModal_Title', widgetName, 'Replace plan');
    }
    getReplaceModalPrompt(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_ReplacePlanModal_Prompt', widgetName, 'This plan will replace the plan you currently have in your shopping cart.  Would you like to continue?');
    }
    async addToCart(plan, cartPlans, cartSettings, selectFromPersonalizedVideo) {
        await this.addToCartWithReplace(plan, cartPlans, cartSettings, async () => {
            await this.addPlanAndNavigateToCart(plan, cartPlans, cartSettings.widgetName, selectFromPersonalizedVideo);
        });
    }
    async addToCartAndCrossSellPDP(plan, cartPlans, cartSettings) {
        await this.addToCartWithReplace(plan, cartPlans, cartSettings, async () => {
            await this.showCrossSellPDPModal(plan, cartPlans, cartSettings);
        });
    }
    async addToCartAndCrossSellMedSup(plan, cartPlans, cartSettings) {
        await this.addToCartWithReplace(plan, cartPlans, cartSettings, async () => {
            await this.showCrossSellMedSupModal(plan, cartPlans, cartSettings);
        });
    }
    async addToCartWithReplace(plan, cartPlans, cartSettings, addToCartAction) {
        const showModal = this.showReplacePlanInCartModal(plan, cartPlans, cartSettings);
        if (showModal) {
            this.showReplaceModal(() => {
                this.removePlanAndAddToCartAction(plan, cartPlans, addToCartAction);
            });
        }
        else {
            await addToCartAction();
        }
    }
    addPDPPlanToCart(plan, cartSettings, selectFromPersonalizedVideo) {
        const cartPlans = this.shoppingCartService.getSelectedPlans();
        const isMedSupCrossSell = this.shoppingCartService.isMedSupCrossSell(plan, cartPlans, cartSettings);
        this.promptAddToCartCrossSellModal(plan, cartPlans, cartSettings, isMedSupCrossSell, PlanTypeAbbreviation.PDP, selectFromPersonalizedVideo);
    }
    addMedSupPlanToCart(plan, cartSettings, selectFromPersonalizedVideo) {
        const cartPlans = this.shoppingCartService.getSelectedPlans();
        this.isPDPCrossSell = this.shoppingCartService.isPDPCrossSell(plan, cartPlans, cartSettings);
        this.promptAddToCartCrossSellModal(plan, cartPlans, cartSettings, this.isPDPCrossSell, PlanTypeAbbreviation.MEDIGAP, selectFromPersonalizedVideo);
    }
    promptAddToCartCrossSellModal(plan, cartPlans, cartSettings, isCrossSell, planTypeAbbreviation, selectFromPersonalizedVideo) {
        this.planFacade
            .getNonCoveredPlanTabMap$()
            .pipe(take(1))
            .subscribe({
            next: async (nonCoveredPlanTabMap) => {
                if (planTypeAbbreviation === PlanTypeAbbreviation.MEDIGAP &&
                    isCrossSell &&
                    nonCoveredPlanTabMap[PlanTypeAbbreviation.PDP]?.display) {
                    // Prompt to cross sell PDP plan
                    await this.addToCartAndCrossSellPDP(plan, cartPlans, cartSettings);
                }
                else if (planTypeAbbreviation === PlanTypeAbbreviation.PDP &&
                    isCrossSell &&
                    nonCoveredPlanTabMap[PlanTypeAbbreviation.MEDIGAP]?.display) {
                    // If the plan is PDP, check if we want to prompt to sell MedSup plan
                    await this.addToCartAndCrossSellMedSup(plan, cartPlans, cartSettings);
                }
                else {
                    await this.addToCart(plan, cartPlans, cartSettings, selectFromPersonalizedVideo);
                }
            }
        });
    }
    async showCrossSellMedSupModal(selectedPlan, cartPlans, cartSettings) {
        const modalAttributes = this.getMedSupCrossSellAttributes(selectedPlan, false, cartSettings.widgetName);
        await this.addToCartAndCrossSell(selectedPlan, cartPlans, modalAttributes, cartSettings.widgetName);
    }
    async showCrossSellPDPModal(selectedPlan, cartPlans, cartSettings) {
        const modalAttributes = this.getPDPCrossSellAttributes(selectedPlan, false, cartSettings.widgetName);
        await this.addToCartAndCrossSell(selectedPlan, cartPlans, modalAttributes, cartSettings.widgetName);
    }
    async addToCartAndCrossSell(selectedPlan, cartPlans, modalAttributes, widgetName) {
        await this.addPlanAndAnalyticsTag(cartPlans, selectedPlan);
        this.showCrossSellModal(widgetName, selectedPlan, modalAttributes);
    }
    showReplaceModal(confirmAction, widgetName) {
        const modalTitle = this.getReplaceModalTitle(widgetName);
        const modalPrompt = this.getReplaceModalPrompt(widgetName);
        const modalCancel = this.getReplaceModalCancelText(widgetName);
        const modalConfirm = this.getReplaceModalConfirmText(widgetName);
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true });
        confirmationModal.componentInstance.title = modalTitle;
        confirmationModal.componentInstance.prompt = modalPrompt;
        confirmationModal.componentInstance.cancelButton = modalCancel;
        confirmationModal.componentInstance.confirmButton = modalConfirm;
        confirmationModal.result.then(confirmAction, () => {
            // don't do anything if the user canceled
        });
    }
    showCrossSellModal(widgetName, plan, modalAttributes) {
        const headerText = this.getCrossSellModalHeaderText(widgetName);
        const successMessage = this.getCrossSellModalSuccessText(plan, widgetName);
        const cancelButton = this.getCrossSellCancelButtonText(widgetName);
        const confirmButton = this.getCrossSellConfirmButtonText(widgetName);
        const crossSellModal = this.modalService.open(ShoppingCartCrossSellModalComponent, { centered: true });
        crossSellModal.componentInstance.headerText = headerText;
        crossSellModal.componentInstance.successMessage = successMessage;
        crossSellModal.componentInstance.bundlePlansPrompt = modalAttributes.bundlePlansPrompt;
        crossSellModal.componentInstance.marketingMessage = modalAttributes.marketingMessage;
        crossSellModal.componentInstance.cancelButton = cancelButton;
        crossSellModal.componentInstance.confirmButton = confirmButton;
        crossSellModal.componentInstance.shopButton = modalAttributes.shopButton;
        // confirm action - we navigate to shopping cart page.
        crossSellModal.componentInstance.confirmAction = modalAttributes.confirmAction;
        // shop action - we navigate to the other plan tab
        crossSellModal.componentInstance.shopAction = this.getShopActionWithScrollToTop(modalAttributes.shopAction);
        // cancel action - trigger cancel event analytics
        crossSellModal.componentInstance.cancelAction = this.crossSellCloseActionAnalytics.bind(this);
        this.triggerShowCrossSellModalAnalytics();
    }
    getShopActionWithScrollToTop(shopAction) {
        return () => {
            shopAction();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        };
    }
    async addPlanAndAnalyticsTag(cartPlans, selectedPlan, selectFromPersonalizedVideo) {
        await this.shoppingCartService.addPlan(cartPlans, selectedPlan);
        const addToCartEvent = selectFromPersonalizedVideo
            ? DataLayerEvent.CLICK_PERSONALIZED_VIDEO_PLANS_CART_ADD
            : DataLayerEvent.CLICK_PLANS_CART_ADD;
        this.planFacade.tagsToUpdate(addToCartEvent, selectedPlan.id, selectedPlan.planTypeAbbreviation, selectedPlan.carrierName, this.planFacade.isVbcAgreementExists(selectedPlan));
    }
    async addPlanAndNavigateToCart(plan, selectedPlans, widgetName, selectFromPersonalizedVideo) {
        await this.addPlanAndAnalyticsTag(selectedPlans, plan, selectFromPersonalizedVideo);
        this.navigateToCart(plan, widgetName);
    }
    navigateToCart(plan, widgetName) {
        const isMedigapPlan = plan.planType === PlanType.MEDIGAP;
        const isMedigapInterimPageEnabled = this.shoppingCartService.isMedigapInterimPageEnabled(widgetName);
        this.navigateToPage(plan, isMedigapPlan, isMedigapInterimPageEnabled, widgetName);
    }
    navigateToPage(plan, isMedigapPlan, isMedigapInterimPageEnabled, widgetName) {
        const shoppingCartEnabled = this.shoppingCartService.isCartEnabled();
        if (shoppingCartEnabled) {
            this.navigationService.navigateByPageTag(PageTags.SHOPPING_CART);
        }
        else if (isMedigapInterimPageEnabled && isMedigapPlan) {
            this.setActiveEnrollmentKey(plan.id);
            this.navigationService.navigateByPageTag(PageTags.MEDIGAP_INTERIM);
        }
        else {
            this.setActiveEnrollmentKey(plan.id);
            this.enrollmentSettingsService.processEnrollmentSettings(PageTags.ENROLLMENT, widgetName);
        }
    }
    setActiveEnrollmentKey(planId) {
        this.enrollmentFormService.setActiveEnrollmentKey(planId);
    }
    hasShoppingCartPlansChange(previousPlanIds, currentPlanIds) {
        const sortedPreviousPlanIds = previousPlanIds ? previousPlanIds.sort() : [];
        const sortedCurrentPlanIds = currentPlanIds ? currentPlanIds.sort() : [];
        return (sortedPreviousPlanIds.length !== sortedCurrentPlanIds.length ||
            sortedPreviousPlanIds.some((previousPlanId, index) => previousPlanId !== sortedCurrentPlanIds[index]));
    }
    triggerShowCrossSellModalAnalytics() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_MODAL,
            [DataLayerGlobalVariable.MODAL_NAME]: this.getDataLayerModalName()
        };
    }
    getDataLayerModalName() {
        if (this.isPDPCrossSell) {
            return DataLayerGlobalVariable.CROSS_SELL_PDP;
        }
        return DataLayerGlobalVariable.CROSS_SELL_MEDSUP;
    }
    crossSellShopActionAnalytics() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_MODAL_CROSS_SELL_SHOP_PLANS);
    }
    crossSellShopGoToCartAnalytics() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_MODAL_CROSS_SELL_GO_TO_CART);
    }
    crossSellCloseActionAnalytics() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_MODAL_CROSS_SELL_CLOSE);
    }
}
CartFacade.ɵfac = function CartFacade_Factory(t) { return new (t || CartFacade)(i0.ɵɵinject(i1.NavigationService), i0.ɵɵinject(i1.ShoppingCartService), i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.PlansService), i0.ɵɵinject(i1.SiteService), i0.ɵɵinject(i1.AgentService), i0.ɵɵinject(i1.AgentPermissionsService), i0.ɵɵinject(AnalyticsService), i0.ɵɵinject(GlobalFacade), i0.ɵɵinject(i1.EnrollmentFormService), i0.ɵɵinject(PlanFacade), i0.ɵɵinject(EnrollmentHistoryFacade), i0.ɵɵinject(CrossSellPlanContext), i0.ɵɵinject(i1.EnrollmentSettingsService), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(RiderFacade), i0.ɵɵinject(i2$1.ActivatedRoute), i0.ɵɵinject(i1.DeepLinkingService), i0.ɵɵinject(i1.PlanYearResourceService)); };
CartFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CartFacade, factory: CartFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.NavigationService }, { type: i1.ShoppingCartService }, { type: i1$1.NgbModal }, { type: i1.ConfigResourceService }, { type: i2.Store }, { type: i1.PlansService }, { type: i1.SiteService }, { type: i1.AgentService }, { type: i1.AgentPermissionsService }, { type: AnalyticsService }, { type: GlobalFacade }, { type: i1.EnrollmentFormService }, { type: PlanFacade }, { type: EnrollmentHistoryFacade }, { type: CrossSellPlanContext }, { type: i1.EnrollmentSettingsService }, { type: i1.MemberSessionService }, { type: RiderFacade }, { type: i2$1.ActivatedRoute }, { type: i1.DeepLinkingService }, { type: i1.PlanYearResourceService }]; }, null); })();

class PersonalizedVideoComponent {
    constructor(personalizedVideoService, addToCartContextService, cartFacade, contactUsContextService, profileFacade) {
        this.personalizedVideoService = personalizedVideoService;
        this.addToCartContextService = addToCartContextService;
        this.cartFacade = cartFacade;
        this.contactUsContextService = contactUsContextService;
        this.profileFacade = profileFacade;
        this.handleCallToAction = new EventEmitter();
        this.subscriptions = new Subscription();
    }
    messageEventListener(event) {
        this.personalizedVideoService.handleVideoEvent(event).then(originMatched => {
            if (originMatched) {
                this.handleCallToAction.emit(event);
            }
        });
    }
    ngOnInit() {
        // Behavior subjects fire on subscription, which is a problem in this case due to potential navigation/modal popups.
        // We skip the first emit to prevent that from happening again when you click previous/back from the shopping cart.
        // In a normal flow, it will skip the empty emition from before a value is sent, which is not a problem - nothing happens either way
        this.subscriptions.add(this.addToCartContextService
            .onOpenAddToCartModal$()
            .pipe(skip(1))
            .subscribe({
            next: (planId) => {
                this.cartFacade.selectAndValidateByPlanId(planId, null, true);
            }
        }));
        this.subscriptions.add(this.contactUsContextService.onOpenContactUsModal$().subscribe({
            next: () => {
                this.profileFacade.openModal();
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
PersonalizedVideoComponent.ɵfac = function PersonalizedVideoComponent_Factory(t) { return new (t || PersonalizedVideoComponent)(i0.ɵɵdirectiveInject(i1.PersonalizedVideoService), i0.ɵɵdirectiveInject(i1.AddToCartContextService), i0.ɵɵdirectiveInject(CartFacade), i0.ɵɵdirectiveInject(i1.ContactUsContextService), i0.ɵɵdirectiveInject(ProfileFacade)); };
PersonalizedVideoComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PersonalizedVideoComponent, selectors: [["vnext-personalized-video"]], hostBindings: function PersonalizedVideoComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("message", function PersonalizedVideoComponent_message_HostBindingHandler($event) { return ctx.messageEventListener($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { videoURL: "videoURL", iframeTitle: "iframeTitle" }, outputs: { handleCallToAction: "handleCallToAction" }, decls: 4, vars: 5, consts: [[1, "video-container", "d-flex", "justify-content-center"], [1, "iframe-wrapper"], ["allow", "fullscreen", "scrolling", "no", 1, "iframe", 3, "src", "title"]], template: function PersonalizedVideoComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵelement(2, "iframe", 2);
        i0.ɵɵpipe(3, "safe");
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("src", i0.ɵɵpipeBind2(3, 2, ctx.videoURL, "resource-url"), i0.ɵɵsanitizeResourceUrl)("title", ctx.iframeTitle);
    } }, dependencies: [SafePipe], styles: [".video-container[_ngcontent-%COMP%]{height:100%}.iframe[_ngcontent-%COMP%]{width:100%;height:100%;border:0px}.iframe-wrapper[_ngcontent-%COMP%]{aspect-ratio:16/9;width:100%}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PersonalizedVideoComponent, [{
        type: Component,
        args: [{ selector: 'vnext-personalized-video', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"video-container d-flex justify-content-center\">\r\n  <div class=\"iframe-wrapper\">\r\n    <iframe allow=\"fullscreen\" class=\"iframe\" scrolling=\"no\" [src]=\"videoURL | safe : 'resource-url'\" [title]=\"iframeTitle\"></iframe>\r\n  </div>\r\n</div>\r\n", styles: [".video-container{height:100%}.iframe{width:100%;height:100%;border:0px}.iframe-wrapper{aspect-ratio:16/9;width:100%}\n"] }]
    }], function () { return [{ type: i1.PersonalizedVideoService }, { type: i1.AddToCartContextService }, { type: CartFacade }, { type: i1.ContactUsContextService }, { type: ProfileFacade }]; }, { videoURL: [{
            type: Input
        }], iframeTitle: [{
            type: Input
        }], handleCallToAction: [{
            type: Output
        }], messageEventListener: [{
            type: HostListener,
            args: ['window:message', ['$event']]
        }] }); })();

function ValueBasedCareModalComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "vnext-personalized-video", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("videoURL", ctx_r0.videoURL);
} }
class ValueBasedCareModalComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
    }
    closeVbcModal() {
        this.activeModal.dismiss();
        if (this.cancelAction) {
            this.cancelAction();
        }
    }
}
ValueBasedCareModalComponent.ɵfac = function ValueBasedCareModalComponent_Factory(t) { return new (t || ValueBasedCareModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal)); };
ValueBasedCareModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ValueBasedCareModalComponent, selectors: [["vnext-widget-value-based-care-modal"]], decls: 18, vars: 11, consts: [[3, "modalTitleText", "modalTitleClass", "modalTitleCancelAction"], [1, "modal-body"], [1, "row"], [1, "col-12"], [1, "Spa_Style_Primary_Color"], ["class", "col-xs-12 col-sm-12 col-md-7 my-4", 4, "ngIf"], [1, "col-xs-12", "col-sm-12", "col-md-5", "my-4"], [1, "Spa_Style_H4"], [1, "modal-footer", "justify-content-start"], ["type", "button", 1, "btn", "mr-auto", "Spa_Style_SecondaryButton", 3, "click"], [1, "col-xs-12", "col-sm-12", "col-md-7", "my-4"], [3, "videoURL"]], template: function ValueBasedCareModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function ValueBasedCareModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.closeVbcModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "p", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(6, ValueBasedCareModalComponent_div_6_Template, 2, 1, "div", 5);
        i0.ɵɵelementStart(7, "div", 6)(8, "h5", 7);
        i0.ɵɵelement(9, "i");
        i0.ɵɵelementStart(10, "span");
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(12, "div", 4)(13, "p");
        i0.ɵɵtext(14);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(15, "div", 8)(16, "button", 9);
        i0.ɵɵlistener("click", function ValueBasedCareModalComponent_Template_button_click_16_listener() { return ctx.closeVbcModal(); });
        i0.ɵɵtext(17);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.modalTitleText)("modalTitleClass", "modal-header");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.modalWarningText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.videoURL);
        i0.ɵɵadvance(3);
        i0.ɵɵclassMapInterpolate1("", ctx.videoHeaderIcon, " pr-2");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.videoHeaderText);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.videoBodyText);
        i0.ɵɵadvance(2);
        i0.ɵɵattribute("aria-label", "{ modalCancelText } - popup will close");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.modalCloseText, " ");
    } }, dependencies: [i1$2.NgIf, ModalHeaderComponent, PersonalizedVideoComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValueBasedCareModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-value-based-care-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header\r\n  [modalTitleText]=\"modalTitleText\"\r\n  (modalTitleCancelAction)=\"closeVbcModal()\"\r\n  [modalTitleClass]=\"'modal-header'\"\r\n></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body\">\r\n  <div class=\"row\">\r\n    <div class=\"col-12\">\r\n      <p class=\"Spa_Style_Primary_Color\">{{ modalWarningText }}</p>\r\n    </div>\r\n    <div class=\"col-xs-12 col-sm-12 col-md-7 my-4\" *ngIf=\"videoURL\">\r\n      <vnext-personalized-video [videoURL]=\"videoURL\"></vnext-personalized-video>\r\n    </div>\r\n    <div class=\"col-xs-12 col-sm-12 col-md-5 my-4\">\r\n      <h5 class=\"Spa_Style_H4\">\r\n        <i class=\"{{ videoHeaderIcon }} pr-2\"></i> <span>{{ videoHeaderText }}</span>\r\n      </h5>\r\n      <div class=\"Spa_Style_Primary_Color\">\r\n        <p>{{ videoBodyText }}</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer justify-content-start\">\r\n  <button type=\"button\" class=\"btn mr-auto Spa_Style_SecondaryButton\" (click)=\"closeVbcModal()\" [attr.aria-label]=\"'{ modalCancelText } - popup will close'\">\r\n    {{ modalCloseText }}\r\n  </button>\r\n</div>\r\n" }]
    }], function () { return [{ type: i1$1.NgbActiveModal }]; }, null); })();

class ProviderContextService {
    constructor() {
        this._providers$ = new BehaviorSubject([]);
        this.providers$ = this._providers$.asObservable();
        this.defaultRadius = 10;
    }
    loadProviders(providers) {
        this._providers$.next(providers);
    }
}
ProviderContextService.ɵfac = function ProviderContextService_Factory(t) { return new (t || ProviderContextService)(); };
ProviderContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProviderContextService, factory: ProviderContextService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProviderContextService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class MemberRegistrationFacade {
    constructor(responsiveLayoutService, sessionService, analyticsService, configResourceService, store, plansService) {
        this.responsiveLayoutService = responsiveLayoutService;
        this.sessionService = sessionService;
        this.analyticsService = analyticsService;
        this.configResourceService = configResourceService;
        this.store = store;
        this.plansService = plansService;
    }
    get isMobile$() {
        return this.responsiveLayoutService.isCompact$;
    }
    get isMedium$() {
        return this.responsiveLayoutService.isMedium$;
    }
    async updateProfile(apiMemberStateModel) {
        await this.sessionService.updateMemberProfile(apiMemberStateModel);
    }
    getCurrentMemberSession() {
        return this.sessionService.getMemberSession();
    }
    getCurrentMemberSession$() {
        return this.sessionService.getMemberSession$();
    }
    getMemberPlanEnrollments$() {
        return combineLatest([this.sessionService.getMemberPlanEnrollments$(), this.sessionService.getMemberHasFullName$()]).pipe(filter(([memberEnrollments, hasFullName]) => hasFullName && !!memberEnrollments), map(([memberEnrollments]) => memberEnrollments));
    }
    getNonMedicareMemberEnrollmentIds(memberEnrollments) {
        const medicarePlanTypeValues = [...MEDICARE_PLAN_TYPE_VALUES, ALL_MEDICARE_PLAN_TYPE_VALUE];
        return (memberEnrollments?.reduce((nonMedicareMemberEnrollmentIds, memberEnrollment) => {
            if (!medicarePlanTypeValues.includes(memberEnrollment.planTypeID)) {
                nonMedicareMemberEnrollmentIds.push(memberEnrollment.planID);
            }
            return nonMedicareMemberEnrollmentIds;
        }, []) ?? []);
    }
    getPlanTypesByMemberEnrollmentIds(memberEnrollments, memberEnrollmentIds) {
        return Array.from(memberEnrollments?.reduce((nonMedicareMemberEnrollmentIds, memberEnrollment) => {
            if (memberEnrollmentIds.includes(memberEnrollment.planID)) {
                nonMedicareMemberEnrollmentIds.add(memberEnrollment.planTypeID);
            }
            return nonMedicareMemberEnrollmentIds;
        }, new Set()) ?? []);
    }
    mapMemberEnrollmentsWithFees(isPlanFeesEnabled = this.plansService.getIsPlanFeesEnabled()) {
        return pipe(switchMap(memberEnrollments => {
            if (isPlanFeesEnabled) {
                const nonMedicareMemberEnrollmentIds = this.getNonMedicareMemberEnrollmentIds(memberEnrollments);
                if (nonMedicareMemberEnrollmentIds.length) {
                    const uniquePlanTypes = this.getPlanTypesByMemberEnrollmentIds(memberEnrollments, nonMedicareMemberEnrollmentIds);
                    return this.plansService.getArePlanTypesLoaded$(uniquePlanTypes).pipe(switchMap(arePlanTypesLoaded => {
                        if (arePlanTypesLoaded) {
                            return this.plansService.getPlansMapByIds$(nonMedicareMemberEnrollmentIds).pipe(map(nonMedicarePlans => memberEnrollments.map(memberEnrollment => ({
                                ...memberEnrollment,
                                fees: nonMedicarePlans[memberEnrollment.planID]?.fees ?? []
                            }))));
                        }
                        return of(memberEnrollments);
                    }));
                }
            }
            return of(memberEnrollments);
        }), distinctUntilChanged(_isEqual));
    }
    getCountyErrorText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_ZipCodeInput_CountyError', widgetName, 'Please select your county');
    }
    getCurrentMemberProfilePageTag$() {
        return this.sessionService.getCurrentMemberProfilePageTag$();
    }
    updateGtm() {
        const dataLayer = this.analyticsService.googleDataLayerTags;
        const dataLayerMemberId = dataLayer ? dataLayer[DataLayerGlobalVariable.MEMBER_ID] : null;
        const memberData = this.getCurrentMemberSession();
        if (memberData?.memberID && (!dataLayerMemberId || dataLayerMemberId !== memberData.memberID)) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.MEMBER_ID, memberData.memberID);
        }
    }
    isPartAandBEffDateValidationEnabled() {
        return this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartAandBEffectiveDateValidation_Enabled', null, true);
    }
    getZipCodeSelected() {
        return this.store.selectSnapshot(ProfileState.zip);
    }
    getFipsCodeSelected() {
        return this.store.selectSnapshot(ProfileState.county);
    }
}
MemberRegistrationFacade.ɵfac = function MemberRegistrationFacade_Factory(t) { return new (t || MemberRegistrationFacade)(i0.ɵɵinject(i1.ResponsiveLayoutService), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(AnalyticsService), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.PlansService)); };
MemberRegistrationFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MemberRegistrationFacade, factory: MemberRegistrationFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberRegistrationFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.ResponsiveLayoutService }, { type: i1.MemberSessionService }, { type: AnalyticsService }, { type: i1.ConfigResourceService }, { type: i2.Store }, { type: i1.PlansService }]; }, null); })();

var AddProviderMaxLimit;
(function (AddProviderMaxLimit) {
    AddProviderMaxLimit[AddProviderMaxLimit["MAX_COUNT"] = 10] = "MAX_COUNT";
})(AddProviderMaxLimit || (AddProviderMaxLimit = {}));
var ProviderModalViewName;
(function (ProviderModalViewName) {
    ProviderModalViewName["SEARCH"] = "search";
    ProviderModalViewName["MAP"] = "map";
    ProviderModalViewName["RESULT"] = "result";
})(ProviderModalViewName || (ProviderModalViewName = {}));
class ProviderFacade {
    constructor(store, configResourceService, providerHttpService, helpfulToolsContext, helpfulToolsService, providerService, guidedHelpService, mapFacade, providerContext, analyticsService, responsiveLayoutService, dateService, spinnerService, agentService, demographicService, modalService, siteService, memberRegistrationFacade, localeService, plansService, externalErrorLoggingService) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.providerHttpService = providerHttpService;
        this.helpfulToolsContext = helpfulToolsContext;
        this.helpfulToolsService = helpfulToolsService;
        this.providerService = providerService;
        this.guidedHelpService = guidedHelpService;
        this.mapFacade = mapFacade;
        this.providerContext = providerContext;
        this.analyticsService = analyticsService;
        this.responsiveLayoutService = responsiveLayoutService;
        this.dateService = dateService;
        this.spinnerService = spinnerService;
        this.agentService = agentService;
        this.demographicService = demographicService;
        this.modalService = modalService;
        this.siteService = siteService;
        this.memberRegistrationFacade = memberRegistrationFacade;
        this.localeService = localeService;
        this.plansService = plansService;
        this.externalErrorLoggingService = externalErrorLoggingService;
        this.selectedProviderIds = {};
        this.currentModalViewName = ProviderModalViewName.SEARCH;
        this.isZelisIntegrationEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_ZelisIntegration_Enabled', null, false);
        this.providerLimit = this.configResourceService.getProcessedResourceValue('Spa_Provider_Limit', null, 25) || 25;
        this.searchProviderByNameEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_SearchProviderByName_Enabled', null, false);
        this.providersFilterIndividualText = this.configResourceService.getProcessedResourceValue('Spa_Providers_Filter_Individuals_Text', null, 'Doctors and other professionals');
        this.providersFilterFacilitiesText = this.configResourceService.getProcessedResourceValue('Spa_Providers_Filter_Facilties_Text', null, 'Facilities (hospitals, clinics and urgent care)');
        this.providersValueBasedCareFilterText = this.configResourceService.getProcessedResourceValue('Spa_ValueBasedCare_Filter_Text', null, 'Only show Value Based Care providers');
        this.providersValueBasedCareFilterChecked = this.configResourceService.getProcessedResourceValue('Spa_ValueBasedCare_Filter_Checked', null, false);
        this.providersValueBasedCareFilterEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_ValueBasedCare_Filter_Enabled', null, true);
        this.providersValueBaseCareFilterLinkText = this.configResourceService.getProcessedResourceValue('Spa_ValueBasedCare_LearnMore_Text', null, 'Learn more');
        this.providersValueBasedCareFilterLinkEnabled = this.configResourceService.getProcessedResourceValue('Spa_ValueBasedCare_LearnMoreLink_Enabled', null, true);
        this.isValueBasedCareEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_ValueBasedCare_Enabled', null, true);
        this.valueBasedCareModalHeader = this.configResourceService.getProcessedResourceValue('Spa_ValueBasedCare_Modal_Header', null, 'Value based care');
        this.valueBasedCareModalIntroText = this.configResourceService.getProcessedResourceValue('Spa_ValueBasedCare_Modal_Intro_Text', null, 'Watch a short video on the differences of the different care models and the different types of care you might receive.');
        this.closeButtonText = this.configResourceService.getProcessedResourceValue('Spa_Site_Close', null, 'Close');
        this.valueBasedCareVideoBodyText = this.configResourceService.getProcessedResourceValue('Spa_ValueBasedCare_Modal_Video_Body_Text', null, 'Value Based Care reimburses the provider based on the quality of care they provide and rewards providers for both efficiency and effectiveness.');
        this.valueBasedCareVideoHeaderText = this.configResourceService.getProcessedResourceValue('Spa_ValueBasedCare_Modal_Video_Header_Text', null, 'Value based care');
        this.valueBasedCareIcon = this.configResourceService.getProcessedResourceValue('Spa_Site_ValueBasedCare_Icon', null, 'fas fa-briefcase-medical');
        this.vbcWhitelistedId = this.configResourceService.getProcessedResourceValue('Spa_Site_ValueBasedCare_Whitelisted_ID', null, '');
        this.pcpEligibilityCheckPlanSubtypeItems = this.configResourceService
            .getProcessedResourceValue('Spa_Site_PCPPlanEligibilityCheck_PlanSubtypeItems', null, [
            { planSubType: PlanSubTypes.Cost, enabled: true },
            { planSubType: PlanSubTypes.HMO, enabled: true },
            { planSubType: PlanSubTypes.HMOPOS, enabled: true },
            { planSubType: PlanSubTypes.LPPO, enabled: true },
            { planSubType: PlanSubTypes.MSA, enabled: true },
            { planSubType: PlanSubTypes.PFFS, enabled: true },
            { planSubType: PlanSubTypes.PPO, enabled: true },
            { planSubType: PlanSubTypes.RPPO, enabled: true }
        ])
            .filter(item => item.enabled);
        this.providerFilters = [
            {
                label: this.providersFilterIndividualText,
                value: ProviderFilterKeyType.PROVIDER_INDIVIDUAL,
                disabled: false,
                initiallyChecked: true,
                link: null
            },
            {
                label: this.providersFilterFacilitiesText,
                value: ProviderFilterKeyType.PROVIDER_FACILITIES,
                disabled: false,
                initiallyChecked: true,
                link: null
            },
            {
                label: this.providersValueBasedCareFilterText,
                value: ProviderFilterKeyType.PROVIDER_VALUE_BASED_CARE,
                disabled: !(this.isValueBasedCareEnabled && this.providersValueBasedCareFilterEnabled),
                initiallyChecked: this.providersValueBasedCareFilterChecked,
                link: this.providersValueBasedCareFilterLinkEnabled ? this.providersValueBaseCareFilterLinkText : null
            }
        ];
        this.providersShowAllInNetworkLocationsEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_Provider_ShowAllInNetworkLocations_Enabled', null, false);
    }
    get isMobile$() {
        return this.responsiveLayoutService.isCompact$;
    }
    getSelectedProviders$() {
        return this.providerService.getSelectedProviders$();
    }
    getSelectedProviders() {
        return this.providerService.getSelectedProviders();
    }
    getProviderDetails$() {
        return this.providerService.getProviderDetails$();
    }
    get primaryPinIcon() {
        return this.guidedHelpService.getPrimaryPinIcon();
    }
    getPlanProviderRequest() {
        const selectedPlan = this.helpfulToolsService.getPlanSelected();
        if (selectedPlan) {
            return {
                id: selectedPlan.id,
                contractId: selectedPlan.contractId,
                planId: selectedPlan.planId,
                segmentId: selectedPlan.segmentId
            };
        }
        return null;
    }
    getSelectedPlanProviderRequest(planId) {
        const selectedPlan = this.plansService.getPlan(planId ?? '');
        if (selectedPlan) {
            return {
                id: selectedPlan.id,
                contractId: selectedPlan.contractId,
                planId: selectedPlan.planId,
                segmentId: selectedPlan.segmentId
            };
        }
        return null;
    }
    async fetchProviderDetails(planIds, includeExtendedProviderData) {
        const providerDetailsRequest = this.getProviderLanguagesRequest(planIds);
        return providerDetailsRequest
            ? await this.providerService.fetchProvidersDetails(providerDetailsRequest, includeExtendedProviderData)
            : null;
    }
    fetchProviderDetails$(planIds, includeExtendedProviderData) {
        const providerDetailsRequest = this.getProviderLanguagesRequest(planIds);
        return providerDetailsRequest
            ? this.providerService.fetchProvidersDetails$(providerDetailsRequest, includeExtendedProviderData)
            : of(null);
    }
    getProviderMedicalGroups(providerDetails) {
        let providerMedicalGroups = {};
        if (providerDetails?.plans?.length) {
            providerMedicalGroups = providerDetails.plans.reduce((selectedProviderMedicalGroups, plan) => {
                selectedProviderMedicalGroups[plan.id] = {
                    providers: plan.providers?.reduce((selectedProvider, provider) => {
                        selectedProvider[provider.npi] = provider.groups ?? [];
                        return selectedProvider;
                    }, {}) ?? {}
                };
                return selectedProviderMedicalGroups;
            }, {});
        }
        return providerMedicalGroups;
    }
    fetchValueBasedCareConfirmation$(plan) {
        const primaryCareProvider = this.getSelectedPCP();
        if (primaryCareProvider && plan) {
            const currentLocale = this.localeService.getCurrentLocale();
            const providerNPI = this.getFormattedProviderNpi([primaryCareProvider]);
            const providersDetails$ = plan.providers
                ? of(plan.providers)
                : this.providerService
                    .fetchProvidersDetailsBasedOnAvailablePlans$([plan], this.providersShowAllInNetworkLocationsEnabled)
                    .pipe(map(planProvidersDetails => planProvidersDetails?.plans?.[0]?.providers ?? []));
            return forkJoin([this.getValueBasedCareProvider$(providerNPI, currentLocale), providersDetails$]).pipe(switchMap(([providerVBC, providers]) => {
                if (providerVBC?.length) {
                    const providerPCP = providers?.find(provider => provider.npi?.trim() === providerVBC[0].npi?.trim() && provider.inNetwork);
                    if (providerPCP?.inNetwork) {
                        return of({ ...providerVBC[0], pcpName: primaryCareProvider.displayName });
                    }
                }
                return of(null);
            }));
        }
        return of(null);
    }
    fetchProvidersFromLocation(providerSearchFilter) {
        const payload = {
            lat: providerSearchFilter.latitude.toString(),
            lon: providerSearchFilter.longitude.toString(),
            searchTerm: this.searchProviderByNameEnabled && this.providerContext.providerByName ? this.providerContext.providerByName : '',
            radius: providerSearchFilter.distance ? Math.ceil(providerSearchFilter.distance / 2) : this.providerContext.defaultRadius,
            plan: this.getPlanProviderRequest(),
            perPage: this.providerLimit,
            zip: providerSearchFilter.zip,
            includeGP: providerSearchFilter.includeGP
        };
        const fetchProviderFromLocation$ = this.isZelisIntegrationEnabled
            ? this.providerHttpService.nextGenRetrieveProviderFromLocation$(payload)
            : this.providerHttpService.retrieveProviderFromLocation$(payload);
        fetchProviderFromLocation$
            .pipe(map((response) => this.getProvidersWithinBounds(response?.providers, providerSearchFilter?.bounds)), switchMap((providers) => {
            if (this.isValueBasedCareEnabled && providers?.length) {
                const npis = this.getFormattedProviderNpi(providers);
                const currentLocale = this.localeService.getCurrentLocale();
                return this.getValueBasedCareProvider$(npis, currentLocale).pipe(map(vbcProviders => ({ providers, vbcProviders })));
            }
            return of({ providers, vbcProviders: [] });
        }))
            .toPromise()
            .then(response => {
            if (response?.providers?.length) {
                const formattedProviders = this.isValueBasedCareEnabled && response?.vbcProviders?.length
                    ? this.getFormattedProviderVbcData(response.providers, response.vbcProviders)
                    : response.providers;
                this.setProvidersAndLoadInContext(formattedProviders);
                this.store.dispatch(new SetIsProviderSearchLoaded(true));
            }
            else {
                this.setProvidersAndLoadInContext([]);
            }
        })
            .catch(error => {
            this.externalErrorLoggingService.log(error);
        })
            .finally(() => {
            this.mapFacade.hideSpinner(SpinnerEvent.PROVIDERS_LOADING);
            this.spinnerService.hide(SpinnerEvent.PREFERENCE_BANNER_PROVIDER_LOADING);
        });
    }
    getFormattedProviderNpi(providers) {
        const uniqueNpis = ProviderUtilityService.getUniqueProvidersNpi(providers);
        return [...uniqueNpis].map(uniqueNpi => ({ npi: uniqueNpi.toString() }));
    }
    isWhitelistedVBC(vbcid) {
        return ProviderUtilityService.isWhitelistedVBC(vbcid, this.vbcWhitelistedId);
    }
    getFormattedProviderVbcData(providers, vbcProviders) {
        return providers.reduce((formattedProviders, currentProvider) => {
            const vbcProvider = vbcProviders.find(vbcProvider => currentProvider.npis.includes(+vbcProvider.npi));
            vbcProvider ? formattedProviders.push({ ...currentProvider, valueBasedCare: vbcProvider }) : formattedProviders.push(currentProvider);
            return formattedProviders;
        }, []);
    }
    getValueBasedCareProvider$(npis, currentLocale) {
        return this.providerHttpService.getValueBasedCareProviders$({ NPIList: npis }, currentLocale);
    }
    getVBCVideoInfo() {
        const siteType = this.siteService.getSiteType();
        const vbcVideoPayload = this.getVBCVideoPayload(siteType);
        this.providerHttpService
            .getVBCVideoInfo$(vbcVideoPayload)
            .pipe(take(1))
            .subscribe({
            next: (response) => {
                this.openVbcVideoModal(response);
            }
        });
    }
    getFormattedNpisfromEnrollments(memberEnrollments) {
        return memberEnrollments?.reduce((npis, item) => {
            if (item.pcpNpi) {
                npis.push({ npi: item.pcpNpi });
            }
            return npis;
        }, []);
    }
    reformatVbcProvidersforEnrollments(vbcProviderList) {
        return vbcProviderList.reduce((vbcProvider, item) => {
            vbcProvider[item.npi] = item;
            return vbcProvider;
        }, {});
    }
    noticeAlternateViewBackgroundForMarker(provider) {
        return this.noticeAlternateView(provider, true, true);
    }
    getProviderPinClass(provider, isProviderMap, isHelpfulToolsView) {
        if (this.isPcp(provider) && !isHelpfulToolsView) {
            return `${this.primaryPinIcon} fa-stack-2x primary-icon-size`;
        }
        if (isProviderMap) {
            return 'fas fa-map-marker';
        }
        return 'fas fa-map-marker fa-stack-2x provider-map-pin';
    }
    hasPrimaryCareProviderMarker(markers) {
        const selectedPCP = this.getSelectedPCP();
        return selectedPCP && markers.some(marker => marker.id === selectedPCP.id && marker.addressId === selectedPCP.addressId);
    }
    getGroupProviderPinClass(markers) {
        if (this.helpfulToolsContext.isHelpfulToolsView) {
            return 'fas fa-users ' + this.guidedHelpService.getMapPreferredColorAccent(false);
        }
        return this.hasPrimaryCareProviderMarker(markers)
            ? `${this.primaryPinIcon} fa-stack-2x primary-icon-size`
            : 'fas fa-users ' + this.guidedHelpService.getMapDefaultColorAccent(false);
    }
    sameProviderAlreadySelected(provider) {
        const selectedProviders = this.getSelectedProviders();
        if (selectedProviders.length) {
            this.selectedProviderIds[provider.id] = selectedProviders.some(selectedProvider => selectedProvider.id === provider.id);
        }
        else {
            this.selectedProviderIds = {};
        }
    }
    getPrimaryCareProviderMarker(markers) {
        const selectedPCP = this.getSelectedPCP();
        if (selectedPCP) {
            return markers.find(marker => marker.id === selectedPCP.id && marker.addressId === selectedPCP.addressId);
        }
    }
    getSortedSelectedProviders$(planProviders) {
        const sortedProviders = [];
        if (!planProviders?.length) {
            return of(sortedProviders);
        }
        return this.getSelectedProviders$().pipe(map(selectedProviders => {
            selectedProviders.forEach(selectedProvider => {
                const provider = planProviders.find(planProvider => planProvider.id === selectedProvider.id);
                if (provider) {
                    sortedProviders.push(provider);
                }
            });
            return sortedProviders;
        }));
    }
    addProvider(value) {
        const addedProvider = value.providers.filter(provider => provider.id === value.id && provider.addressId === value.addressId);
        this.providerService.addProviders(addedProvider);
        let providerStatusPCP = GOOGLE_ANALYTICS_NOT_APPLICABLE;
        let providerStatusNewPatient = GOOGLE_ANALYTICS_NOT_APPLICABLE;
        let vbcStatus = GOOGLE_ANALYTICS_NOT_APPLICABLE;
        let vbcOrgName = GOOGLE_ANALYTICS_NOT_APPLICABLE;
        if (addedProvider?.length) {
            providerStatusPCP = addedProvider[0].isPrimary ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO;
            providerStatusNewPatient = addedProvider[0].isNewPatient ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO;
            vbcStatus = addedProvider[0]?.valueBasedCare ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO;
            vbcOrgName = addedProvider[0]?.valueBasedCare?.vbcOrgName ?? GOOGLE_ANALYTICS_NOT_APPLICABLE;
        }
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PREFERENCES_PROVIDER_ADD,
            [DataLayerGlobalVariable.PROVIDER_COUNT]: this.guidedHelpService.getSelectedProviders().length.toString(),
            [DataLayerGlobalVariable.PROVIDER_STATUS_PCP]: providerStatusPCP,
            [DataLayerGlobalVariable.PROVIDER_STATUS_NEW_PATIENT]: providerStatusNewPatient,
            [DataLayerGlobalVariable.PROVIDER_STATUS_VBC]: vbcStatus,
            [DataLayerGlobalVariable.PROVIDER_VBC_ORG_NAME]: vbcOrgName
        };
    }
    addProviders(value) {
        const selectedProviders = this.getSelectedProviders();
        const isEditMode = value.addedProviders?.length &&
            selectedProviders?.some(providerDetail => providerDetail.addressId === value.addedProviders[0]?.addressId && providerDetail.id === value.addedProviders[0]?.id);
        if (isEditMode) {
            if (value.addedProviders[0]?.isPrimary) {
                this.setAsPrimaryCareProvider(value.addedProviders[0]);
            }
            else {
                this.providerService.updateSelectedProvider(value.addedProviders[0]);
            }
        }
        else {
            const pcpPovider = value.addedProviders?.find(provider => provider?.isPrimary);
            if (pcpPovider) {
                this.setAsPrimaryCareProvider(pcpPovider);
            }
            this.providerService.addProviders(value.addedProviders);
        }
        let providerStatusPCP = GOOGLE_ANALYTICS_NOT_APPLICABLE;
        let providerStatusNewPatient = GOOGLE_ANALYTICS_NOT_APPLICABLE;
        let vbcStatus = GOOGLE_ANALYTICS_NOT_APPLICABLE;
        let vbcOrgName = GOOGLE_ANALYTICS_NOT_APPLICABLE;
        if (value?.addedProviders?.length) {
            providerStatusPCP = value.addedProviders[0].isPrimary ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO;
            providerStatusNewPatient = value.addedProviders[0].isNewPatient ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO;
            vbcStatus = value.addedProviders[0]?.valueBasedCare ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO;
            vbcOrgName = value.addedProviders[0]?.valueBasedCare?.vbcOrgName ?? GOOGLE_ANALYTICS_NOT_APPLICABLE;
        }
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PREFERENCES_PROVIDER_ADD,
            [DataLayerGlobalVariable.PROVIDER_COUNT]: this.guidedHelpService.getSelectedProviders().length.toString(),
            [DataLayerGlobalVariable.PROVIDER_STATUS_PCP]: providerStatusPCP,
            [DataLayerGlobalVariable.PROVIDER_STATUS_NEW_PATIENT]: providerStatusNewPatient,
            [DataLayerGlobalVariable.PROVIDER_STATUS_VBC]: vbcStatus,
            [DataLayerGlobalVariable.PROVIDER_VBC_ORG_NAME]: vbcOrgName
        };
    }
    openVbcVideoModal(vbcVideoInfo) {
        const vbcModal = this.modalService.open(ValueBasedCareModalComponent, { centered: true, size: 'lg' });
        vbcModal.componentInstance.modalTitleText = this.valueBasedCareModalHeader;
        vbcModal.componentInstance.modalWarningText = this.valueBasedCareModalIntroText;
        vbcModal.componentInstance.modalCloseText = this.closeButtonText;
        vbcModal.componentInstance.videoURL = vbcVideoInfo.videoURL;
        vbcModal.componentInstance.videoBodyText = this.valueBasedCareVideoBodyText;
        vbcModal.componentInstance.videoHeaderText = this.valueBasedCareVideoHeaderText;
        vbcModal.componentInstance.videoHeaderIcon = this.valueBasedCareIcon;
    }
    getProviderLocationStatus(planIds) {
        return this.providerService.getProviderLocationStatus(planIds);
    }
    addProviderSelectedFromMarker(value) {
        if (value.selectedItem) {
            this.addProvider({ providers: value.providers, id: value.selectedItem.providerId, addressId: value.selectedItem.addressId });
        }
    }
    removeProvider$(provider) {
        const isPrimary = false;
        return this.providerService.removeProviders$({ ...provider, isPrimary });
    }
    getProviderNetworkStatus(planIds) {
        return this.providerService.getProviderNetworkStatus(planIds);
    }
    logRemoveProviderForAnalytics(provider) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PREFERENCES_PROVIDER_REMOVE,
            [DataLayerGlobalVariable.PROVIDER_COUNT]: this.guidedHelpService.getSelectedProviders().length.toString(),
            [DataLayerGlobalVariable.PROVIDER_STATUS_PCP]: provider.isPrimary ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO,
            [DataLayerGlobalVariable.PROVIDER_STATUS_NEW_PATIENT]: provider.isNewPatient ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO,
            [DataLayerGlobalVariable.PROVIDER_STATUS_VBC]: provider?.valueBasedCare ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO,
            [DataLayerGlobalVariable.PROVIDER_VBC_ORG_NAME]: provider?.valueBasedCare?.vbcOrgName ?? GOOGLE_ANALYTICS_NOT_APPLICABLE
        };
    }
    noticeAlternateView(provider, isBackground, alwaysDefault) {
        const isProviderAdded = provider ? this.isProviderAdded(provider.id, provider.addressId, provider.providerGroup) : false;
        if (this.helpfulToolsContext.isHelpfulToolsView) {
            return this.guidedHelpService.getMapPreferredColorAccent(isBackground);
        }
        if (alwaysDefault) {
            return this.guidedHelpService.getMapDefaultColorAccent(isBackground);
        }
        if (isProviderAdded) {
            return this.guidedHelpService.getMapSelectedColorAccent(isBackground);
        }
        return this.guidedHelpService.getMapDefaultColorAccent(isBackground);
    }
    noticeAlternateProviderIndicator(provider) {
        const isProviderAdded = provider ? this.isProviderAdded(provider.id, provider.addressId, provider.providerGroup) : false;
        if (isProviderAdded) {
            return GuidedHelpMapStyleEnum.Spa_Map_Pin_Indicator;
        }
        return GuidedHelpMapStyleEnum.Spa_Style_TooltipTextAndNumberIndicators;
    }
    isProviderAdded(id, addressId, providerGroup, providerSingleSelectEnabled) {
        const selectedProviders = this.getSelectedProviders();
        if (!selectedProviders && !selectedProviders.length) {
            return false;
        }
        if (providerGroup?.length && !providerSingleSelectEnabled) {
            return selectedProviders.some(provider => providerGroup.some(pgroup => pgroup.id === provider.id && pgroup.address1 === provider.address1));
        }
        else if (providerGroup?.length >= 2 && providerSingleSelectEnabled) {
            const selected = selectedProviders.filter(provider => providerGroup.some(pgroup => pgroup.id === provider.id && pgroup.address1 === provider.address1));
            return selected.length === providerGroup.length;
        }
        else {
            return selectedProviders.some(provider => provider.id === id && provider.addressId === addressId);
        }
    }
    isPcp(provider) {
        const pcpProvider = this.getSelectedPCP();
        return pcpProvider && pcpProvider.id === provider.id && pcpProvider.addressId === provider.addressId;
    }
    getSelectedPCP() {
        return this.providerService.getSelectedPCP();
    }
    isPcpSelected() {
        return this.providerService.hasSelectedPCP();
    }
    providerEligibleAsPcpForPlan$() {
        const selectedPCP = this.getSelectedPCP();
        const selectedPlansInCart = this.store.selectSnapshot(ShoppingCartState.selectedPlans);
        const pcpEligiblePlans = selectedPlansInCart.filter(plan => plan.planType === PlanType.MAPD || plan.planType === PlanType.MA);
        if (selectedPCP &&
            pcpEligiblePlans?.some(plan => this.pcpEligibilityCheckPlanSubtypeItems.some(({ planSubType }) => plan.planSubType === planSubType))) {
            const providerDetailInfo = {
                addressId: selectedPCP.addressId,
                npi: selectedPCP.id.toString()
            };
            const planProviderRequests = pcpEligiblePlans.map(selectedPlan => ({
                id: selectedPlan.id,
                contractId: selectedPlan.contractId,
                planId: selectedPlan.planId,
                segmentId: selectedPlan.segmentId
            }));
            const effectiveDate = DateUtilities.getFormattedDateTime(new Date(this.dateService.getTotalCostEffectiveDate()), 'DD/MM/YYYY');
            const providerPcpForPlanRequest = {
                effectiveDate,
                plans: planProviderRequests,
                provider: providerDetailInfo
            };
            const getPlanPrimaryCareProvider$ = this.isZelisIntegrationEnabled
                ? this.providerService.nextGenPlanPrimaryCareProvider$(providerPcpForPlanRequest)
                : this.providerService.getPlanPrimaryCareProvider$(providerPcpForPlanRequest);
            return getPlanPrimaryCareProvider$;
        }
        return of([]);
    }
    providerCountWithinLimits() {
        const selectedProviders = this.getSelectedProviders();
        return selectedProviders && selectedProviders.length < AddProviderMaxLimit.MAX_COUNT;
    }
    providerCountWithinLimits$() {
        return this.getSelectedProviders$().pipe(map(selectedProviders => selectedProviders?.length < AddProviderMaxLimit.MAX_COUNT), distinctUntilChanged());
    }
    getProviderFromSelectedProviders(provider) {
        const selectedProviders = this.getSelectedProviders();
        return selectedProviders?.length
            ? selectedProviders.find(existingProvider => existingProvider.id === provider.id && existingProvider.addressId === provider.addressId)
            : null;
    }
    noticeAlternateIndicatorForMarker(provider) {
        return this.noticeAlternateProviderIndicator(this.getProviderFromSelectedProviders(provider));
    }
    noticeAlternateViewForMarker(provider) {
        return this.noticeAlternateView(this.getProviderFromSelectedProviders(provider));
    }
    setAsPrimaryCareProvider(provider) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PREFERENCES_PROVIDER_SET_AS_PRIMARY
        };
        const selectedProviders = this.getSelectedProviders();
        if (selectedProviders?.length) {
            const pcpProvider = selectedProviders.find(selectedProvider => selectedProvider.isPrimary && (selectedProvider.id !== provider.id || selectedProvider.addressId !== provider.addressId));
            if (pcpProvider) {
                const isPrimary = false;
                const isNewPatient = false;
                this.providerService.updateSelectedProvider({ ...pcpProvider, isPrimary, isNewPatient });
            }
        }
        const isPrimary = true;
        this.providerService.updateSelectedProvider({ ...provider, isPrimary });
    }
    getPrimaryProviderBackgroundColor(provider, isHelpfulToolsView) {
        if (!provider && !isHelpfulToolsView) {
            return { color: this.guidedHelpService.getPrimaryPinIconColor() };
        }
        const isPrimary = this.isPcp(provider);
        if (isPrimary && !isHelpfulToolsView) {
            return { color: this.guidedHelpService.getPrimaryPinIconColor() };
        }
        return {};
    }
    getPrimaryGroupProviderBackgroundColor(markers) {
        const primaryPharmacy = this.getPrimaryCareProviderMarker(markers);
        return primaryPharmacy ? { color: this.guidedHelpService.getPrimaryPinIconColor() } : {};
    }
    fetchProvidersFromAPI(providerSearchFilter) {
        if (providerSearchFilter.latitude && providerSearchFilter.longitude && providerSearchFilter.bounds) {
            this.mapFacade.toggleSpinner(true);
            this.fetchProvidersFromLocation(providerSearchFilter);
        }
    }
    getFilteredProviders(providersFilterCheckBoxes) {
        return this.providerService.getFilteredProviders(providersFilterCheckBoxes, this.vbcWhitelistedId, this.getProviderDisplayName(ProviderFilterKeyType.PROVIDER_INDIVIDUAL), this.getProviderDisplayName(ProviderFilterKeyType.PROVIDER_FACILITIES), this.getProviderDisplayName(ProviderFilterKeyType.PROVIDER_VALUE_BASED_CARE));
    }
    getProviderDisplayName(key) {
        const providerLabel = this.providerFilters.find(provider => provider.value === key);
        return providerLabel ? providerLabel.label : '';
    }
    async updateVbcAttestationConfirmation(vbcAttestation) {
        this.spinnerService.show(SpinnerEvent.VBC_ATTESTATION_LOADING);
        const sessionId = this.store.selectSnapshot(MemberState.sessionId);
        const vbcAttestationPayload = {
            ConfirmationNumber: vbcAttestation.confirmationNumber,
            VBCID: vbcAttestation.vbcid,
            VBCOrgName: vbcAttestation.vbcOrgName,
            NationalProviderID: vbcAttestation.npi
        };
        return await this.providerHttpService
            .saveVbcAttestationConfirmation$(sessionId, vbcAttestationPayload, vbcAttestation.optin)
            .pipe(map((response) => {
            return !!response;
        }))
            .toPromise()
            .catch(error => {
            this.externalErrorLoggingService.log(error);
            return false;
        })
            .finally(() => {
            this.spinnerService.hide(SpinnerEvent.VBC_ATTESTATION_LOADING);
        });
    }
    async getVbcAttestationConfirmation(confirmationNumber) {
        const sessionId = this.store.selectSnapshot(MemberState.sessionId);
        return await this.providerHttpService
            .getVbcAttestationConfirmation$(sessionId, confirmationNumber)
            .pipe(map((response) => {
            return !!response?.valueBasedCareAttestationList?.length;
        }))
            .toPromise()
            .catch(error => {
            this.externalErrorLoggingService.log(error);
            return false;
        });
    }
    createProviderLanguagesMap(providers) {
        const selectedProvidersNpi = this.providerService.getSelectedProvidersNpi();
        const selectedProviderDetails = providers.filter(provider => selectedProvidersNpi.includes(+provider.npi));
        const providerLanguages = {};
        selectedProviderDetails.forEach(provider => (providerLanguages[provider.npi] = provider.languages));
        return providerLanguages;
    }
    getProviderAddresses(providers = [], npi) {
        return this.providerService.getProviderAddresses(providers, npi);
    }
    getProviderDetailInfo(planId, planProviderDetails) {
        return this.providerService.getProviderDetailInfo(planId, planProviderDetails);
    }
    getProvidersWithinBounds(providers, bounds) {
        if (bounds && providers && !this.mapFacade.getIsOptimalZoomEnabled()) {
            return providers.reduce((providersWithinBounds, provider) => {
                if (this.isZelisIntegrationEnabled) {
                    const addressesWithinBounds = provider.addresses?.filter(address => this.mapFacade.coordinatesWithinBounds(address.latitude, address.longitude, bounds)) ??
                        [];
                    if (addressesWithinBounds.length) {
                        providersWithinBounds.push({ ...provider, addresses: addressesWithinBounds });
                    }
                }
                else if (this.mapFacade.coordinatesWithinBounds(provider.latitude, provider.longitude, bounds)) {
                    providersWithinBounds.push(provider);
                }
                return providersWithinBounds;
            }, []);
        }
        return providers ?? [];
    }
    setProvidersAndLoadInContext(rawProviders) {
        if (Array.isArray(rawProviders)) {
            this.store
                .dispatch(new SetProviders(rawProviders))
                .pipe(switchMap(() => this.providerService.getProviders$()), take(1))
                .subscribe({
                next: (providers) => {
                    this.providerContext.loadProviders(providers);
                }
            });
        }
    }
    getVBCVideoPayload(siteType) {
        const selectedCounty = this.demographicService.getSelectedCounty();
        let vbcVideoPayload = {
            sessionId: this.store.selectSnapshot(MemberState.sessionId),
            state: selectedCounty ? selectedCounty.state : this.store.selectSnapshot(DemographicState.counties)[0].state
        };
        if (siteType === SiteType.BROKER) {
            const agentFirstName = this.agentService.getAgentFirstName();
            return (vbcVideoPayload = { ...vbcVideoPayload, agentFirstName });
        }
        else {
            const memberStateModel = this.memberRegistrationFacade.getCurrentMemberSession();
            const consumerFirstName = memberStateModel?.profile?.firstName ?? this.store.selectSnapshot(MemberState.firstName);
            return (vbcVideoPayload = { ...vbcVideoPayload, consumerFirstName });
        }
    }
    getProviderLanguagesRequest(planIds) {
        const plans = this.plansService.getPlansByIds(planIds);
        return this.providerService.getProviderDetailsRequest(plans);
    }
    setProviderSearchLoaded(isLoaded) {
        this.store.dispatch(new SetIsProviderSearchLoaded(isLoaded));
    }
    setCurrentProviderModalView(modalView) {
        this.currentModalViewName = modalView;
    }
}
ProviderFacade.ɵfac = function ProviderFacade_Factory(t) { return new (t || ProviderFacade)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.ProviderHttpService), i0.ɵɵinject(HelpfulToolsContextService), i0.ɵɵinject(HelpfulToolsService), i0.ɵɵinject(i1.ProviderService), i0.ɵɵinject(i1.GuidedHelpService), i0.ɵɵinject(MapFacade), i0.ɵɵinject(ProviderContextService), i0.ɵɵinject(AnalyticsService), i0.ɵɵinject(i1.ResponsiveLayoutService), i0.ɵɵinject(i1.DateService), i0.ɵɵinject(i1.SpinnerService), i0.ɵɵinject(i1.AgentService), i0.ɵɵinject(i1.DemographicService), i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(i1.SiteService), i0.ɵɵinject(MemberRegistrationFacade), i0.ɵɵinject(i1.LocaleService), i0.ɵɵinject(i1.PlansService), i0.ɵɵinject(i1.ExternalErrorLoggingService)); };
ProviderFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProviderFacade, factory: ProviderFacade.ɵfac, providedIn: 'root' });
__decorate([
    LiveEditInactive()
], ProviderFacade.prototype, "addProviderSelectedFromMarker", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProviderFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i2.Store }, { type: i1.ConfigResourceService }, { type: i1.ProviderHttpService }, { type: HelpfulToolsContextService }, { type: HelpfulToolsService }, { type: i1.ProviderService }, { type: i1.GuidedHelpService }, { type: MapFacade }, { type: ProviderContextService }, { type: AnalyticsService }, { type: i1.ResponsiveLayoutService }, { type: i1.DateService }, { type: i1.SpinnerService }, { type: i1.AgentService }, { type: i1.DemographicService }, { type: i1$1.NgbModal }, { type: i1.SiteService }, { type: MemberRegistrationFacade }, { type: i1.LocaleService }, { type: i1.PlansService }, { type: i1.ExternalErrorLoggingService }]; }, { addProviderSelectedFromMarker: [] }); })();

class ProviderAcceptingNewPatientsComponent {
}
ProviderAcceptingNewPatientsComponent.ɵfac = function ProviderAcceptingNewPatientsComponent_Factory(t) { return new (t || ProviderAcceptingNewPatientsComponent)(); };
ProviderAcceptingNewPatientsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProviderAcceptingNewPatientsComponent, selectors: [["vnext-widget-provider-accepting-new-patients"]], inputs: { acceptingNewPatientsText: "acceptingNewPatientsText", acceptingNewPatientsIcon: "acceptingNewPatientsIcon" }, decls: 3, vars: 4, consts: [[1, "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font"]], template: function ProviderAcceptingNewPatientsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "i");
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("", ctx.acceptingNewPatientsIcon, " accent1-static");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.acceptingNewPatientsText, "\n");
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProviderAcceptingNewPatientsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-provider-accepting-new-patients', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"Spa_Style_Gray4_Color Spa_Style_Smaller_Font\">\r\n  <i class=\"{{ acceptingNewPatientsIcon }} accent1-static\"></i>\r\n  {{ acceptingNewPatientsText}}\r\n</div>\r\n" }]
    }], null, { acceptingNewPatientsText: [{
            type: Input
        }], acceptingNewPatientsIcon: [{
            type: Input
        }] }); })();

class ProviderInlineElementComponent {
    ngOnChanges(changes) {
        const { values } = changes;
        if (values && !_isEqual(values.previousValue, values.currentValue)) {
            this.inlineText = this.values.join(', ');
        }
    }
}
ProviderInlineElementComponent.ɵfac = function ProviderInlineElementComponent_Factory(t) { return new (t || ProviderInlineElementComponent)(); };
ProviderInlineElementComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProviderInlineElementComponent, selectors: [["vnext-widget-provider-inline-element"]], inputs: { values: "values", icon: "icon" }, features: [i0.ɵɵNgOnChangesFeature], decls: 4, vars: 4, consts: [[1, "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font", "d-flex", "align-items-baseline"]], template: function ProviderInlineElementComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "i");
        i0.ɵɵelementStart(2, "span");
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("accent1-static ", ctx.icon, " mr-1");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.inlineText);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProviderInlineElementComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-provider-inline-element', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"Spa_Style_Gray4_Color Spa_Style_Smaller_Font d-flex align-items-baseline\">\r\n  <i class=\"accent1-static {{ icon }} mr-1\"></i>\r\n  <span>{{ inlineText }}</span>\r\n</div>\r\n" }]
    }], null, { values: [{
            type: Input
        }], icon: [{
            type: Input
        }] }); })();

function ProviderPhoneComponent_div_0_i_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 2);
} }
function ProviderPhoneComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ProviderPhoneComponent_div_0_i_1_Template, 1, 0, "i", 1);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("Spa_Style_Note my-1 ", ctx_r0.customClass, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showPhoneIcon);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", "Provider Phone Number: " + ctx_r0.providerPhoneNumber);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.providerPhoneNumber);
} }
class ProviderPhoneComponent {
    constructor(phonePipe) {
        this.phonePipe = phonePipe;
        this.customClass = '';
    }
    ngOnChanges(changes) {
        const { phoneNumber, countryCode } = changes;
        if ((phoneNumber && phoneNumber.previousValue !== phoneNumber.currentValue) ||
            (countryCode && countryCode.previousValue !== countryCode.currentValue)) {
            this.providerPhoneNumber = this.getFormattedPhoneNumber(this.phoneNumber, this.countryCode);
        }
    }
    getFormattedPhoneNumber(phoneNumber, countryCode) {
        // Country code could be optional in parsePhoneNumber()
        if (phoneNumber?.length) {
            return this.phonePipe.transform(phoneNumber, countryCode);
        }
        return null;
    }
}
ProviderPhoneComponent.ɵfac = function ProviderPhoneComponent_Factory(t) { return new (t || ProviderPhoneComponent)(i0.ɵɵdirectiveInject(PhonePipe)); };
ProviderPhoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProviderPhoneComponent, selectors: [["vnext-widget-provider-phone"]], inputs: { phoneNumber: "phoneNumber", countryCode: "countryCode", showPhoneIcon: "showPhoneIcon", customClass: "customClass" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[3, "class", 4, "ngIf"], ["class", "fas fa-phone pr-1 accent1-static", "aria-hidden", "true", 4, "ngIf"], ["aria-hidden", "true", 1, "fas", "fa-phone", "pr-1", "accent1-static"]], template: function ProviderPhoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ProviderPhoneComponent_div_0_Template, 4, 6, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.providerPhoneNumber);
    } }, dependencies: [i1$2.NgIf, IconAriaAttributesDirective], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProviderPhoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-provider-phone', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"providerPhoneNumber\" class=\"Spa_Style_Note my-1 {{ customClass }}\">\r\n  <i *ngIf=\"showPhoneIcon\" class=\"fas fa-phone pr-1 accent1-static\" aria-hidden=\"true\"></i>\r\n  <span [attr.aria-label]=\"'Provider Phone Number: ' + providerPhoneNumber\">{{ providerPhoneNumber }}</span>\r\n</div>\r\n" }]
    }], function () { return [{ type: PhonePipe }]; }, { phoneNumber: [{
            type: Input
        }], countryCode: [{
            type: Input
        }], showPhoneIcon: [{
            type: Input
        }], customClass: [{
            type: Input
        }] }); })();

function TooltipComponent_ng_template_0_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 6);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r3.header, "html"), i0.ɵɵsanitizeHtml);
} }
function TooltipComponent_ng_template_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 7);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r4.body, "html"), i0.ɵɵsanitizeHtml);
} }
function TooltipComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, TooltipComponent_ng_template_0_div_0_Template, 2, 4, "div", 4);
    i0.ɵɵtemplate(1, TooltipComponent_ng_template_0_div_1_Template, 2, 4, "div", 5);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.header);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.body);
} }
const _c0$3L = ["*"];
class TooltipComponent {
    getAriaLabelText() {
        return this.ariaLabel || (this.header ? `${this.Spa_Site_Tooltip_Text} ${this.header} ${this.body}` : `${this.Spa_Site_Tooltip_Text} ${this.body}`);
    }
}
TooltipComponent.ɵfac = function TooltipComponent_Factory(t) { return new (t || TooltipComponent)(); };
TooltipComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TooltipComponent, selectors: [["vnext-tooltip"]], inputs: { header: "header", body: "body", customClass: "customClass", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text", ariaLabel: "ariaLabel" }, ngContentSelectors: _c0$3L, decls: 7, vars: 6, consts: [["tooltip", ""], ["tooltipClass", "tooltip", "tabindex", "0", "container", "body", "role", "tooltip", 3, "ngbTooltip"], ["tooltipController", "ngbTooltip"], ["aria-hidden", "true", 1, "hidden-off-screen"], ["class", "Spa_Style_TooltipTextAndNumberIndicators", "navigationAdapter", "", 3, "innerHtml", 4, "ngIf"], ["class", "Spa_Style_ToolTip tooltip-content", "navigationAdapter", "", 3, "innerHtml", 4, "ngIf"], ["navigationAdapter", "", 1, "Spa_Style_TooltipTextAndNumberIndicators", 3, "innerHtml"], ["navigationAdapter", "", 1, "Spa_Style_ToolTip", "tooltip-content", 3, "innerHtml"]], template: function TooltipComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, TooltipComponent_ng_template_0_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(2, "button", 1, 2)(4, "span", 3);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(6);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(1);
        i0.ɵɵadvance(2);
        i0.ɵɵclassMapInterpolate1("action-button tooltip-body Spa_Style_TooltipTextAndNumberIndicators can-click p-1 ", ctx.customClass, "");
        i0.ɵɵproperty("ngbTooltip", _r0);
        i0.ɵɵattribute("aria-label", ctx.getAriaLabelText());
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.getAriaLabelText());
    } }, dependencies: [i1$2.NgIf, NavigationAdapterDirective, i1$1.NgbTooltip, SafePipe], styles: [".tooltip-content[_ngcontent-%COMP%]{padding:0}.border-radius-12[_ngcontent-%COMP%]{border-radius:12px}.tooltip-body[_ngcontent-%COMP%]{display:inline-flex;justify-content:center;align-items:center;vertical-align:text-top}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TooltipComponent, [{
        type: Component,
        args: [{ selector: 'vnext-tooltip', template: "<ng-template #tooltip>\r\n  <div *ngIf=\"header\" class=\"Spa_Style_TooltipTextAndNumberIndicators\" [innerHtml]=\"header | safe: 'html'\" navigationAdapter></div>\r\n  <div *ngIf=\"body\" class=\"Spa_Style_ToolTip tooltip-content\" [innerHtml]=\"body | safe: 'html'\" navigationAdapter></div>\r\n</ng-template>\r\n<button\r\n  class=\"action-button tooltip-body Spa_Style_TooltipTextAndNumberIndicators can-click p-1 {{ customClass }}\"\r\n  [ngbTooltip]=\"tooltip\"\r\n  #tooltipController=\"ngbTooltip\"\r\n  tooltipClass=\"tooltip\"\r\n  tabindex=\"0\"\r\n  container=\"body\"\r\n  [attr.aria-label]=\"getAriaLabelText()\"\r\n  role=\"tooltip\"\r\n>\r\n  <span class=\"hidden-off-screen\" aria-hidden=\"true\">{{ getAriaLabelText() }}</span>\r\n  <ng-content></ng-content>\r\n</button>\r\n", styles: [".tooltip-content{padding:0}.border-radius-12{border-radius:12px}.tooltip-body{display:inline-flex;justify-content:center;align-items:center;vertical-align:text-top}\n"] }]
    }], null, { header: [{
            type: Input
        }], body: [{
            type: Input
        }], customClass: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }] }); })();

function ValueBasedCareAgreementComponent_vnext_tooltip_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-tooltip", 1);
    i0.ɵɵelement(1, "i", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("body", ctx_r0.vbcAgreementTooltip)("Spa_Site_Tooltip_Text", ctx_r0.Spa_Site_Tooltip_Text);
} }
class ValueBasedCareAgreementComponent {
    constructor() {
        this.Spa_Site_Tooltip_Text = 'Tooltip';
    }
}
ValueBasedCareAgreementComponent.ɵfac = function ValueBasedCareAgreementComponent_Factory(t) { return new (t || ValueBasedCareAgreementComponent)(); };
ValueBasedCareAgreementComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ValueBasedCareAgreementComponent, selectors: [["vnext-value-based-care-agreement"]], inputs: { vbcAgreementLabel: "vbcAgreementLabel", vbcAgreementTooltip: "vbcAgreementTooltip", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text", customClass: "customClass" }, decls: 3, vars: 5, consts: [[3, "body", "Spa_Site_Tooltip_Text", 4, "ngIf"], [3, "body", "Spa_Site_Tooltip_Text"], ["aria-hidden", "true", 1, "fas", "fa-question-circle", "icon-tooltip", "ml-1", "Spa_Style_Smaller_Font"]], template: function ValueBasedCareAgreementComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtext(1);
        i0.ɵɵtemplate(2, ValueBasedCareAgreementComponent_vnext_tooltip_2_Template, 2, 2, "vnext-tooltip", 0);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassMapInterpolate1("Spa_Style_Note ", ctx.customClass, "");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.vbcAgreementLabel, "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.vbcAgreementTooltip);
    } }, dependencies: [i1$2.NgIf, IconAriaAttributesDirective, TooltipComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValueBasedCareAgreementComponent, [{
        type: Component,
        args: [{ selector: 'vnext-value-based-care-agreement', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"Spa_Style_Note {{ customClass }}\">\r\n  {{ vbcAgreementLabel\r\n  }}<vnext-tooltip *ngIf=\"vbcAgreementTooltip\" [body]=\"vbcAgreementTooltip\" [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\">\r\n    <i class=\"fas fa-question-circle icon-tooltip ml-1 Spa_Style_Smaller_Font\" aria-hidden=\"true\"></i>\r\n  </vnext-tooltip>\r\n</div>\r\n" }]
    }], null, { vbcAgreementLabel: [{
            type: Input
        }], vbcAgreementTooltip: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }], customClass: [{
            type: Input
        }] }); })();

function PlanCoverageProviderInfoModalComponent_div_8_ng_container_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "vnext-widget-provider-inline-element", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const providerCardTile_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("values", providerCardTile_r1.provider.languages)("icon", ctx_r7.languagesIcon);
} }
function PlanCoverageProviderInfoModalComponent_div_8_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-widget-provider-phone", 16);
    i0.ɵɵtemplate(2, PlanCoverageProviderInfoModalComponent_div_8_ng_container_6_div_2_Template, 2, 2, "div", 13);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const providerCardTile_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("phoneNumber", providerCardTile_r1.provider.phoneNumber)("countryCode", ctx_r2.countryCode)("showPhoneIcon", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", providerCardTile_r1.provider == null ? null : providerCardTile_r1.provider.languages == null ? null : providerCardTile_r1.provider.languages.length);
} }
function PlanCoverageProviderInfoModalComponent_div_8_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "vnext-widget-provider-inline-element", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const providerCardTile_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("values", providerCardTile_r1.provider.medicalGroups)("icon", "fas fa-building");
} }
function PlanCoverageProviderInfoModalComponent_div_8_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "i", 20);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r4.selectedLocationIsOutOfNetworkText, " ");
} }
function PlanCoverageProviderInfoModalComponent_div_8_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-value-based-care-agreement", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("vbcAgreementLabel", ctx_r5.vbcAgreementLabel)("vbcAgreementTooltip", ctx_r5.vbcAgreementTooltip);
} }
function PlanCoverageProviderInfoModalComponent_div_8_ng_container_10_div_1_vnext_widget_provider_phone_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-provider-phone", 29);
} if (rf & 2) {
    const addressDetail_r11 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("phoneNumber", addressDetail_r11.phoneNumber)("countryCode", ctx_r13.countryCode)("showPhoneIcon", true)("customClass", "ml-4");
} }
function PlanCoverageProviderInfoModalComponent_div_8_ng_container_10_div_1_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r14.selectedLocationText);
} }
function PlanCoverageProviderInfoModalComponent_div_8_ng_container_10_div_1_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-widget-provider-accepting-new-patients", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("acceptingNewPatientsIcon", ctx_r15.acceptingNewPatientsIcon)("acceptingNewPatientsText", ctx_r15.acceptingNewPatientsText);
} }
function PlanCoverageProviderInfoModalComponent_div_8_ng_container_10_div_1_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "vnext-widget-provider-inline-element", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const addressDetail_r11 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("values", addressDetail_r11.languages)("icon", ctx_r16.languagesIcon);
} }
const _c0$3K = function (a0) { return { separator: a0 }; };
function PlanCoverageProviderInfoModalComponent_div_8_ng_container_10_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "div", 24);
    i0.ɵɵtemplate(2, PlanCoverageProviderInfoModalComponent_div_8_ng_container_10_div_1_vnext_widget_provider_phone_2_Template, 1, 4, "vnext-widget-provider-phone", 25);
    i0.ɵɵelement(3, "i", 26);
    i0.ɵɵelementStart(4, "span", 9);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, PlanCoverageProviderInfoModalComponent_div_8_ng_container_10_div_1_span_6_Template, 2, 1, "span", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 28)(8, "div", 9)(9, "div");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(13, PlanCoverageProviderInfoModalComponent_div_8_ng_container_10_div_1_div_13_Template, 2, 2, "div", 12);
    i0.ɵɵtemplate(14, PlanCoverageProviderInfoModalComponent_div_8_ng_container_10_div_1_div_14_Template, 2, 2, "div", 13);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const addressDetail_r11 = i0.ɵɵnextContext().$implicit;
    const providerCardTile_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c0$3K, addressDetail_r11.address1 === providerCardTile_r1.provider.address1));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", (addressDetail_r11 == null ? null : addressDetail_r11.inNetwork) ? "Spa_Style_Primary_Color" : "Spa_Style_Gray4_Color");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.isZelisIntegrationEnabled && addressDetail_r11.phoneNumber);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", (addressDetail_r11 == null ? null : addressDetail_r11.inNetwork) ? "fas fa-check text-success" : "fas fa-times-circle");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(addressDetail_r11.address1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", addressDetail_r11.address1 === providerCardTile_r1.provider.address1);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2("", addressDetail_r11.city, ", ", addressDetail_r11.state, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(addressDetail_r11.address2 ? "[" + addressDetail_r11.address2 + "]" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", addressDetail_r11.acceptingNewPatients);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.isZelisIntegrationEnabled && (addressDetail_r11.languages == null ? null : addressDetail_r11.languages.length));
} }
function PlanCoverageProviderInfoModalComponent_div_8_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanCoverageProviderInfoModalComponent_div_8_ng_container_10_div_1_Template, 15, 13, "div", 22);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const addressDetail_r11 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (addressDetail_r11 == null ? null : addressDetail_r11.address1) && (addressDetail_r11 == null ? null : addressDetail_r11.city) && (addressDetail_r11 == null ? null : addressDetail_r11.state));
} }
function PlanCoverageProviderInfoModalComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 9)(2, "h2", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 11);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, PlanCoverageProviderInfoModalComponent_div_8_ng_container_6_Template, 3, 4, "ng-container", 12);
    i0.ɵɵtemplate(7, PlanCoverageProviderInfoModalComponent_div_8_div_7_Template, 2, 2, "div", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, PlanCoverageProviderInfoModalComponent_div_8_div_8_Template, 3, 1, "div", 14);
    i0.ɵɵtemplate(9, PlanCoverageProviderInfoModalComponent_div_8_ng_container_9_Template, 2, 2, "ng-container", 12);
    i0.ɵɵtemplate(10, PlanCoverageProviderInfoModalComponent_div_8_ng_container_10_Template, 2, 1, "ng-container", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const providerCardTile_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(providerCardTile_r1.provider.displayName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", providerCardTile_r1.provider.specialtyDisplayName, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isZelisIntegrationEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", providerCardTile_r1.provider == null ? null : providerCardTile_r1.provider.medicalGroups == null ? null : providerCardTile_r1.provider.medicalGroups.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", providerCardTile_r1.isProviderInNetwork && ctx_r0.providerShowPartialIndicatorEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isVbcAgreementEnabled && (providerCardTile_r1.provider == null ? null : providerCardTile_r1.provider.hasVBCAgreement));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", providerCardTile_r1.provider.providerAddresses);
} }
class PlanCoverageProviderInfoModalComponent {
    constructor(activeModal, analyticsService, providerFacade) {
        this.activeModal = activeModal;
        this.analyticsService = analyticsService;
        this.providerFacade = providerFacade;
        this.providersList = [];
        this.providerCardTiles = [];
        this.pageTags = PageTags;
    }
    ngOnInit() {
        if (this.selectedProviders?.length) {
            this.selectedProviders.forEach(selectedProvider => {
                const selectedProviderNpi = selectedProvider.npis[0];
                const providerLanguages = this.languages?.[selectedProviderNpi] ?? [];
                const providerMedicalGroups = this.providersMedicalGroupDetails?.[this.planId]?.providers?.[selectedProviderNpi] ?? [];
                const providerInfo = {
                    specialtyDisplayName: selectedProvider.specialtyDisplayName,
                    displayName: selectedProvider.displayName,
                    address1: selectedProvider.address1,
                    phoneNumber: selectedProvider.phoneNumber,
                    providerAddresses: [],
                    ...(providerLanguages?.length ? { languages: providerLanguages } : {}),
                    ...(providerMedicalGroups?.length ? { medicalGroups: providerMedicalGroups } : {})
                };
                const providerDetails = this.providerFacade.getProviderDetailInfo(this.planId, this.providerDetailsResponse);
                const providerDetail = ProviderUtilityService.matchProviderDetailInfo({
                    providerDetails,
                    selectedProvider,
                    checkIfSameAddress: true
                });
                const providerAddresses = this.providerFacade.getProviderAddresses(providerDetails, providerDetail?.npi ?? selectedProviderNpi);
                providerInfo.hasVBCAgreement = providerDetail?.hasAgreement || false;
                providerInfo.providerAddresses = ProviderUtilityService.getCoverageProviderAddresses(selectedProvider, providerAddresses, this.providersAcceptingNewPatients);
                this.providersList.push(providerInfo);
            });
            this.providersList = this.getProviderSorted(this.providersList);
            this.providerCardTiles = this.providersList.map((provider) => ({
                provider,
                isProviderInNetwork: this.isProviderInNetwork(provider)
            }));
            this.triggerProviderLocationModalAnalytics();
        }
    }
    getProviderSorted(providersList) {
        return providersList.sort(function (a, b) {
            if (a.displayName < b.displayName) {
                return -1;
            }
            if (a.displayName > b.displayName) {
                return 1;
            }
            return 0;
        });
    }
    isProviderInNetwork(coverageProviderInfo) {
        return (coverageProviderInfo.providerAddresses.some((addressDetail) => addressDetail.address1 === coverageProviderInfo.address1 && !addressDetail?.inNetwork) &&
            coverageProviderInfo.providerAddresses.filter((addressDetail) => addressDetail.address1 !== coverageProviderInfo.address1 && addressDetail?.inNetwork).length > 0);
    }
    triggerProviderLocationModalAnalytics() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_MODAL,
            [DataLayerGlobalVariable.MODAL_NAME]: DataLayerGlobalVariable.PROVIDER_LOCATIONS
        };
    }
    close() {
        this.activeModal.dismiss();
        if (this.cancelAction) {
            this.cancelAction();
        }
    }
    onProviderSearchClick() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_PROVIDER);
        this.activeModal.dismiss();
        if (this.editAction) {
            this.editAction();
        }
    }
}
PlanCoverageProviderInfoModalComponent.ɵfac = function PlanCoverageProviderInfoModalComponent_Factory(t) { return new (t || PlanCoverageProviderInfoModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(ProviderFacade)); };
PlanCoverageProviderInfoModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCoverageProviderInfoModalComponent, selectors: [["ng-component"]], decls: 12, vars: 7, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "Spa_Style_Primary_Color", "modal-body"], [1, "py-3"], [1, "mb-2", "width-fit-content"], ["tabindex", "0", 1, "link", "Spa_Style_Link", "action-button", 3, "title", "click"], [1, "providers-container"], ["class", "py-3", 4, "ngFor", "ngForOf"], [1, "modal-footer", "justify-content-start"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "mr-auto", 3, "click"], [1, "no-translate-block"], [1, "Spa_Style_H4"], [1, "Spa_Style_Primary_Color", "Spa_Style_Note", "mb-1"], [4, "ngIf"], ["class", "Spa_Style_Note mb-2", 4, "ngIf"], ["class", "Spa_Style_Note partial-indicator-text mb-2", 4, "ngIf"], [4, "ngFor", "ngForOf"], [3, "phoneNumber", "countryCode", "showPhoneIcon"], [1, "Spa_Style_Note", "mb-2"], [3, "values", "icon"], [1, "Spa_Style_Note", "partial-indicator-text", "mb-2"], [1, "fas", "fa-exclamation-triangle", "mr-1"], [3, "vbcAgreementLabel", "vbcAgreementTooltip"], ["class", "p-2", 3, "ngClass", 4, "ngIf"], [1, "p-2", 3, "ngClass"], [3, "ngClass"], [3, "phoneNumber", "countryCode", "showPhoneIcon", "customClass", 4, "ngIf"], [1, "pr-2", 3, "ngClass"], ["class", "float-right", 4, "ngIf"], [1, "px-4"], [3, "phoneNumber", "countryCode", "showPhoneIcon", "customClass"], [1, "float-right"], [3, "acceptingNewPatientsIcon", "acceptingNewPatientsText"]], template: function PlanCoverageProviderInfoModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function PlanCoverageProviderInfoModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.close(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1)(2, "p", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3)(5, "button", 4);
        i0.ɵɵlistener("click", function PlanCoverageProviderInfoModalComponent_Template_button_click_5_listener() { return ctx.onProviderSearchClick(); });
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵtemplate(8, PlanCoverageProviderInfoModalComponent_div_8_Template, 11, 7, "div", 6);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "div", 7)(10, "button", 8);
        i0.ɵɵlistener("click", function PlanCoverageProviderInfoModalComponent_Template_button_click_10_listener() { return ctx.close(); });
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.prompt);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("title", ctx.providersAddEditLinkTitle);
        i0.ɵɵattribute("aria-label", ctx.providersAddEditLinkTitle);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.providersAddEditLinkTitle, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.providerCardTiles);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.closeButtonText, " ");
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, IconAriaAttributesDirective, ProviderAcceptingNewPatientsComponent, ProviderInlineElementComponent, ProviderPhoneComponent, ModalHeaderComponent, ValueBasedCareAgreementComponent], styles: [".providers-container[_ngcontent-%COMP%]{min-height:25px;max-height:500px;overflow-y:auto}.separator[_ngcontent-%COMP%]{border-top:1px solid var(--static-Spa_Style_Gray2);border-bottom:1px solid var(--static-Spa_Style_Gray2)}.partial-indicator-text[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Warn_on_Blue)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCoverageProviderInfoModalComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"close()\"></vnext-widget-modal-header>\r\n\r\n<div class=\"Spa_Style_Primary_Color modal-body\">\r\n  <p class=\"py-3\">{{ prompt }}</p>\r\n  <div class=\"mb-2 width-fit-content\">\r\n    <button\r\n      class=\"link Spa_Style_Link action-button\"\r\n      tabindex=\"0\"\r\n      [title]=\"providersAddEditLinkTitle\"\r\n      (click)=\"onProviderSearchClick()\"\r\n      [attr.aria-label]=\"providersAddEditLinkTitle\"\r\n    >\r\n      {{ providersAddEditLinkTitle }}\r\n    </button>\r\n  </div>\r\n  <div class=\"providers-container\">\r\n    <div class=\"py-3\" *ngFor=\"let providerCardTile of providerCardTiles\">\r\n      <div class=\"no-translate-block\">\r\n        <h2 class=\"Spa_Style_H4\">{{ providerCardTile.provider.displayName }}</h2>\r\n        <div class=\"Spa_Style_Primary_Color Spa_Style_Note mb-1\">\r\n          {{ providerCardTile.provider.specialtyDisplayName }}\r\n        </div>\r\n        <ng-container *ngIf=\"!isZelisIntegrationEnabled\">\r\n          <vnext-widget-provider-phone\r\n            [phoneNumber]=\"providerCardTile.provider.phoneNumber\"\r\n            [countryCode]=\"countryCode\"\r\n            [showPhoneIcon]=\"true\"\r\n          ></vnext-widget-provider-phone>\r\n          <div class=\"Spa_Style_Note mb-2\" *ngIf=\"providerCardTile.provider?.languages?.length\">\r\n            <vnext-widget-provider-inline-element [values]=\"providerCardTile.provider.languages\" [icon]=\"languagesIcon\">\r\n            </vnext-widget-provider-inline-element>\r\n          </div>\r\n        </ng-container>\r\n        <div class=\"Spa_Style_Note mb-2\" *ngIf=\"providerCardTile.provider?.medicalGroups?.length\">\r\n          <vnext-widget-provider-inline-element [values]=\"providerCardTile.provider.medicalGroups\" [icon]=\"'fas fa-building'\">\r\n          </vnext-widget-provider-inline-element>\r\n        </div>\r\n      </div>\r\n      <div\r\n        class=\"Spa_Style_Note partial-indicator-text mb-2\"\r\n        *ngIf=\"providerCardTile.isProviderInNetwork && providerShowPartialIndicatorEnabled\"\r\n      >\r\n        <i class=\"fas fa-exclamation-triangle mr-1\"></i>{{ selectedLocationIsOutOfNetworkText }}\r\n      </div>\r\n\r\n      <ng-container *ngIf=\"isVbcAgreementEnabled && providerCardTile.provider?.hasVBCAgreement\">\r\n        <vnext-value-based-care-agreement\r\n          [vbcAgreementLabel]=\"vbcAgreementLabel\"\r\n          [vbcAgreementTooltip]=\"vbcAgreementTooltip\"\r\n        ></vnext-value-based-care-agreement>\r\n      </ng-container>\r\n      <ng-container *ngFor=\"let addressDetail of providerCardTile.provider.providerAddresses\">\r\n        <div\r\n          *ngIf=\"addressDetail?.address1 && addressDetail?.city && addressDetail?.state\"\r\n          class=\"p-2\"\r\n          [ngClass]=\"{ separator: addressDetail.address1 === providerCardTile.provider.address1 }\"\r\n        >\r\n          <div [ngClass]=\"addressDetail?.inNetwork ? 'Spa_Style_Primary_Color' : 'Spa_Style_Gray4_Color'\">\r\n            <vnext-widget-provider-phone\r\n              *ngIf=\"isZelisIntegrationEnabled && addressDetail.phoneNumber\"\r\n              [phoneNumber]=\"addressDetail.phoneNumber\"\r\n              [countryCode]=\"countryCode\"\r\n              [showPhoneIcon]=\"true\"\r\n              [customClass]=\"'ml-4'\"\r\n            ></vnext-widget-provider-phone>\r\n            <i class=\"pr-2\" [ngClass]=\"addressDetail?.inNetwork ? 'fas fa-check text-success' : 'fas fa-times-circle'\"></i>\r\n            <span class=\"no-translate-block\">{{ addressDetail.address1 }}</span>\r\n            <span *ngIf=\"addressDetail.address1 === providerCardTile.provider.address1\" class=\"float-right\">{{\r\n              selectedLocationText\r\n            }}</span>\r\n          </div>\r\n          <div class=\"px-4\">\r\n            <div class=\"no-translate-block\">\r\n              <div>{{ addressDetail.city }}, {{ addressDetail.state }}</div>\r\n              <div>{{ addressDetail.address2 ? '[' + addressDetail.address2 + ']' : '' }}</div>\r\n            </div>\r\n            <div *ngIf=\"addressDetail.acceptingNewPatients\">\r\n              <vnext-widget-provider-accepting-new-patients\r\n                [acceptingNewPatientsIcon]=\"acceptingNewPatientsIcon\"\r\n                [acceptingNewPatientsText]=\"acceptingNewPatientsText\"\r\n              ></vnext-widget-provider-accepting-new-patients>\r\n            </div>\r\n            <div *ngIf=\"isZelisIntegrationEnabled && addressDetail.languages?.length\" class=\"Spa_Style_Note mb-2\">\r\n              <vnext-widget-provider-inline-element [values]=\"addressDetail.languages\" [icon]=\"languagesIcon\">\r\n              </vnext-widget-provider-inline-element>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer justify-content-start\">\r\n  <button type=\"button\" (click)=\"close()\" class=\"btn Spa_Style_SecondaryButton mr-auto\">\r\n    {{ closeButtonText }}\r\n  </button>\r\n</div>\r\n", styles: [".providers-container{min-height:25px;max-height:500px;overflow-y:auto}.separator{border-top:1px solid var(--static-Spa_Style_Gray2);border-bottom:1px solid var(--static-Spa_Style_Gray2)}.partial-indicator-text{color:var(--static-Spa_Style_Warn_on_Blue)}\n"] }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: AnalyticsService }, { type: ProviderFacade }]; }, null); })();

class NotLicensedPlanListComponent {
}
NotLicensedPlanListComponent.ɵfac = function NotLicensedPlanListComponent_Factory(t) { return new (t || NotLicensedPlanListComponent)(); };
NotLicensedPlanListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NotLicensedPlanListComponent, selectors: [["vnext-not-licensed-plan-list"]], inputs: { headerText: "headerText", informationalText: "informationalText" }, decls: 12, vars: 5, consts: [[1, "text-center"], [1, "row", "pt-4"], [1, "col-12", "not-licensed"], ["aria-hidden", "true", 1, "fas", "fa-ban", "Spa_Style_Accent1_Color"], [1, "col-12"], [1, "Spa_Style_H3"], [1, "row"], [1, "Spa_Style_Paragraph", 3, "innerHTML"]], template: function NotLicensedPlanListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵelement(3, "i", 3);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 1)(5, "div", 4)(6, "h3", 5);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(8, "div", 6)(9, "div", 4);
        i0.ɵɵelement(10, "span", 7);
        i0.ɵɵpipe(11, "safe");
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(7);
        i0.ɵɵtextInterpolate(ctx.headerText);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(11, 2, ctx.informationalText, "html"), i0.ɵɵsanitizeHtml);
    } }, dependencies: [IconAriaAttributesDirective, SafePipe], styles: [".not-licensed[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{font-size:72px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotLicensedPlanListComponent, [{
        type: Component,
        args: [{ selector: 'vnext-not-licensed-plan-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"text-center\">\r\n  <div class=\"row pt-4\">\r\n    <div class=\"col-12 not-licensed\">\r\n      <i class=\"fas fa-ban Spa_Style_Accent1_Color\" aria-hidden=\"true\"></i>\r\n    </div>\r\n  </div>\r\n  <div class=\"row pt-4\">\r\n    <div class=\"col-12\">\r\n      <h3 class=\"Spa_Style_H3\">{{ headerText }}</h3>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-12\">\r\n      <span class=\"Spa_Style_Paragraph\" [innerHTML]=\"informationalText | safe: 'html'\"></span>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".not-licensed>i{font-size:72px}\n"] }]
    }], null, { headerText: [{
            type: Input
        }], informationalText: [{
            type: Input
        }] }); })();

function CheckBoxItemComponent_div_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 7);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r2.item.tooltip, "html"), i0.ɵɵsanitizeHtml);
} }
function CheckBoxItemComponent_div_0_i_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 8);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngbTooltip", _r1);
} }
const _c0$3J = function (a0, a1, a2) { return { "label-disabled": a0, "Spa_Style_Note": a1, "Spa_Style_Primary_Color": a2 }; };
const _c1$1_ = function (a0, a1, a2) { return { "underline": a0, "Spa_Style_Bold_Weight": a1, "no-translate-block": a2 }; };
function CheckBoxItemComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, CheckBoxItemComponent_div_0_ng_template_1_Template, 2, 4, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(3, "label", 3)(4, "input", 4);
    i0.ɵɵlistener("change", function CheckBoxItemComponent_div_0_Template_input_change_4_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.toggleItemChecked()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 5);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, CheckBoxItemComponent_div_0_i_7_Template, 1, 1, "i", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r1 = i0.ɵɵreference(2);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵclassMap(ctx_r0.customClass);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(13, _c0$3J, ctx_r0.item.disabled, ctx_r0.enableNoteStyle, ctx_r0.enablePrimaryColor))("ngbTooltip", ctx_r0.item.tooltip && !ctx_r0.showTooltipIcon ? _r1 : "")("for", ctx_r0.itemId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", ctx_r0.itemId)("value", ctx_r0.item.value)("checked", ctx_r0.checked)("disabled", ctx_r0.item.disabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(17, _c1$1_, ctx_r0.showTooltipUnderline && ctx_r0.item.tooltip && !ctx_r0.showTooltipIcon, ctx_r0.highlightItem, ctx_r0.noTranslateBlock));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.item.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showTooltipIcon && ctx_r0.item.tooltip);
} }
class CheckBoxItemComponent {
    constructor() {
        this.showTooltipUnderline = false;
        this.showTooltipIcon = false;
        this.enableNoteStyle = true;
        this.enablePrimaryColor = false;
        this.highlightItem = false;
        this.noTranslateBlock = false;
        this.toggleChecked = new EventEmitter();
        this.checked = false;
        this.hostClasses = '';
        this.itemId = '';
    }
    ngOnChanges(changes) {
        const { item, selectedItems } = changes;
        if ((item && !_isEqual(item.previousValue, item.currentValue)) ||
            (selectedItems && !_isEqual(selectedItems.previousValue, selectedItems.currentValue))) {
            if (this.item && this.selectedItems) {
                this.checked = this.item.initiallyChecked || this.isChecked(this.item);
                this.itemId = this.item.label?.split(' ').join('-') ?? '';
            }
        }
    }
    toggleItemChecked() {
        this.toggleChecked.emit(this.item);
    }
    isChecked(item) {
        return (this.selectedItems?.some(selectedItem => {
            if (Array.isArray(item.value)) {
                return item.value.some(itemValue => _isEqual(selectedItem, itemValue));
            }
            return _isEqual(selectedItem, item.value);
        }) ?? false);
    }
}
CheckBoxItemComponent.ɵfac = function CheckBoxItemComponent_Factory(t) { return new (t || CheckBoxItemComponent)(); };
CheckBoxItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CheckBoxItemComponent, selectors: [["vnext-checkbox-item"]], inputs: { item: "item", selectedItems: "selectedItems", customClass: "customClass", showTooltipUnderline: "showTooltipUnderline", showTooltipIcon: "showTooltipIcon", enableNoteStyle: "enableNoteStyle", enablePrimaryColor: "enablePrimaryColor", highlightItem: "highlightItem", noTranslateBlock: "noTranslateBlock" }, outputs: { toggleChecked: "toggleChecked" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "checkbox-container", 4, "ngIf"], [1, "checkbox-container"], ["checkboxTooltip", ""], [3, "ngClass", "ngbTooltip", "for"], ["type", "checkbox", "tabindex", "0", 3, "id", "value", "checked", "disabled", "change"], [1, "label-text", 3, "ngClass"], ["class", "fas fa-question-circle Spa_Style_Gray4_Color", "aria-label", "Show tooltip", "container", "body", 3, "ngbTooltip", 4, "ngIf"], ["navigationAdapter", "", 1, "Spa_Style_ToolTip", 3, "innerHtml"], ["aria-label", "Show tooltip", "container", "body", 1, "fas", "fa-question-circle", "Spa_Style_Gray4_Color", 3, "ngbTooltip"]], template: function CheckBoxItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CheckBoxItemComponent_div_0_Template, 8, 21, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.item);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, NavigationAdapterDirective, i1$1.NgbTooltip, SafePipe], styles: [".plan-filter-items[_nghost-%COMP%]   .checkbox-container[_ngcontent-%COMP%]{display:flex;justify-content:flex-start;align-items:flex-start;margin-bottom:10px;font-family:montserrat_light}.plan-filter-items[_nghost-%COMP%]   .checkbox-container[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{margin-left:6px;margin-bottom:0;cursor:pointer;word-break:break-word;font-size:14px}.plan-filter-items[_nghost-%COMP%]   .checkbox-container[_ngcontent-%COMP%]   label.no-left-offset[_ngcontent-%COMP%]{margin-left:0}.plan-filter-items[_nghost-%COMP%]   .checkbox-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{cursor:pointer}.plan-filter-items[_nghost-%COMP%]   .checkbox-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:hover{outline:0;border-color:var(--static-Spa_Style_Gray4)}.plan-filter-items[_nghost-%COMP%]   .checkbox-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:disabled{cursor:default}.plan-filter-items[_nghost-%COMP%]   .checkbox-container[_ngcontent-%COMP%]   label.label-disabled[_ngcontent-%COMP%]{cursor:default}.pharmacy-filter-items[_nghost-%COMP%]   .checkbox-container[_ngcontent-%COMP%]{padding:5px;width:100%;color:#fff;font-weight:700;font-size:3em;text-align:left}.pharmacy-filter-modal-items[_nghost-%COMP%]   .checkbox-container[_ngcontent-%COMP%]{padding:5px;width:100%;color:#fff;font-weight:700;text-align:left}.pharmacy-filter-modal-items[_nghost-%COMP%]   .checkbox-container[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{cursor:pointer;font-size:14px}.pharmacy-filter-items[_nghost-%COMP%]   .checkbox-container[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{margin-left:6px;margin-bottom:0;cursor:pointer;vertical-align:top;font-size:14px}.underline[_ngcontent-%COMP%]{text-decoration:underline}.label-text[_ngcontent-%COMP%]{margin-left:5px}.fa-question-circle[_ngcontent-%COMP%]{margin-left:15px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckBoxItemComponent, [{
        type: Component,
        args: [{ selector: 'vnext-checkbox-item', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"item\" class=\"checkbox-container\">\r\n  <ng-template #checkboxTooltip>\r\n    <div [innerHtml]=\"item.tooltip | safe : 'html'\" class=\"Spa_Style_ToolTip\" navigationAdapter></div>\r\n  </ng-template>\r\n\r\n  <label\r\n    class=\"{{ customClass }}\"\r\n    [ngClass]=\"{ 'label-disabled': item.disabled, 'Spa_Style_Note': enableNoteStyle, 'Spa_Style_Primary_Color': enablePrimaryColor }\"\r\n    [ngbTooltip]=\"item.tooltip && !showTooltipIcon ? checkboxTooltip : ''\"\r\n    [for]=\"itemId\"\r\n  >\r\n    <input\r\n      type=\"checkbox\"\r\n      tabindex=\"0\"\r\n      [id]=\"itemId\"\r\n      [value]=\"item.value\"\r\n      [checked]=\"checked\"\r\n      [disabled]=\"item.disabled\"\r\n      (change)=\"toggleItemChecked()\"\r\n    />\r\n    <span\r\n      class=\"label-text\"\r\n      [ngClass]=\"{\r\n        'underline': showTooltipUnderline && item.tooltip && !showTooltipIcon,\r\n        'Spa_Style_Bold_Weight': highlightItem,\r\n        'no-translate-block': noTranslateBlock\r\n      }\"\r\n      >{{ item.label }}</span\r\n    >\r\n  </label>\r\n\r\n  <i class=\"fas fa-question-circle Spa_Style_Gray4_Color\" aria-label=\"Show tooltip\" *ngIf=\"showTooltipIcon && item.tooltip\" container=\"body\" [ngbTooltip]=\"checkboxTooltip\"></i>\r\n</div>\r\n", styles: [":host(.plan-filter-items) .checkbox-container{display:flex;justify-content:flex-start;align-items:flex-start;margin-bottom:10px;font-family:montserrat_light}:host(.plan-filter-items) .checkbox-container label{margin-left:6px;margin-bottom:0;cursor:pointer;word-break:break-word;font-size:14px}:host(.plan-filter-items) .checkbox-container label.no-left-offset{margin-left:0}:host(.plan-filter-items) .checkbox-container input{cursor:pointer}:host(.plan-filter-items) .checkbox-container input:hover{outline:0;border-color:var(--static-Spa_Style_Gray4)}:host(.plan-filter-items) .checkbox-container input:disabled{cursor:default}:host(.plan-filter-items) .checkbox-container label.label-disabled{cursor:default}:host(.pharmacy-filter-items) .checkbox-container{padding:5px;width:100%;color:#fff;font-weight:700;font-size:3em;text-align:left}:host(.pharmacy-filter-modal-items) .checkbox-container{padding:5px;width:100%;color:#fff;font-weight:700;text-align:left}:host(.pharmacy-filter-modal-items) .checkbox-container label{cursor:pointer;font-size:14px}:host(.pharmacy-filter-items) .checkbox-container label{margin-left:6px;margin-bottom:0;cursor:pointer;vertical-align:top;font-size:14px}.underline{text-decoration:underline}.label-text{margin-left:5px}.fa-question-circle{margin-left:15px}\n"] }]
    }], null, { item: [{
            type: Input
        }], selectedItems: [{
            type: Input
        }], customClass: [{
            type: Input
        }], showTooltipUnderline: [{
            type: Input
        }], showTooltipIcon: [{
            type: Input
        }], enableNoteStyle: [{
            type: Input
        }], enablePrimaryColor: [{
            type: Input
        }], highlightItem: [{
            type: Input
        }], noTranslateBlock: [{
            type: Input
        }], toggleChecked: [{
            type: Output
        }] }); })();

function CheckboxGroupComponent_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-checkbox-item", 4);
    i0.ɵɵlistener("toggleChecked", function CheckboxGroupComponent_ng_container_1_ng_container_2_Template_vnext_checkbox_item_toggleChecked_1_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.toggleChecked($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r1.hostClasses);
    i0.ɵɵproperty("item", item_r2)("selectedItems", ctx_r1.selectedItems)("customClass", ctx_r1.customClass)("showTooltipUnderline", ctx_r1.showTooltipUnderline)("showTooltipIcon", ctx_r1.showTooltipIcon)("enableNoteStyle", ctx_r1.enableNoteStyle)("enablePrimaryColor", ctx_r1.enablePrimaryColor)("highlightItem", ctx_r1.itemShouldBeHighlighted[item_r2.label])("noTranslateBlock", ctx_r1.noTranslateBlock);
} }
const _c0$3I = function (a0) { return { scrollable: a0 }; };
function CheckboxGroupComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵtemplate(2, CheckboxGroupComponent_ng_container_1_ng_container_2_Template, 2, 11, "ng-container", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$3I, ctx_r0.scrollable));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.items);
} }
const _c1$1Z = function (a0) { return { "allow-overflow": a0 }; };
class CheckboxGroupComponent {
    constructor(cdr, inputResetContextService, viewContainer) {
        this.cdr = cdr;
        this.inputResetContextService = inputResetContextService;
        this.viewContainer = viewContainer;
        // the list of items we wish to have checkboxes for
        this.items = [];
        this.showTooltipUnderline = false;
        this.showTooltipIcon = false;
        this.enableNoteStyle = true;
        this.scrollable = false;
        this.enablePrimaryColor = false;
        this.highlightedItems = [];
        this.noTranslateBlock = false;
        this.hostClasses = '';
        this.onChanged = () => { };
        this.onTouched = () => { };
        // internally selected items that will reflect the state until we modify them internally
        // after this we need to save these items if we wish to persist them to the store
        this.selectedItems = [];
        this.itemShouldBeHighlighted = {};
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.hostClasses = this.viewContainer.element.nativeElement?.className;
        this.subscriptions.add(this.inputResetContextService.clearInput$.pipe(filter(inputId => inputId === this.parentId)).subscribe({
            next: inputId => {
                this.selectedItems = [];
                this.cdr.markForCheck();
            }
        }));
    }
    ngOnChanges(changes) {
        const { items, highlightedItems } = changes;
        if ((items?.currentValue.length && !_isEqual(items.currentValue, items.previousValue)) ||
            (highlightedItems?.currentValue.length && !_isEqual(highlightedItems.currentValue, highlightedItems.previousValue))) {
            this.items?.forEach(item => {
                if (this.highlightedItems?.includes(item.label)) {
                    this.itemShouldBeHighlighted[item.label] = true;
                }
                else {
                    this.itemShouldBeHighlighted[item.label] = false;
                }
            });
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    writeValue(value) {
        if (value && Array.isArray(value)) {
            this.selectedItems = value;
        }
        else {
            this.selectedItems = [];
        }
    }
    registerOnChange(fn) {
        this.onChanged = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    toggleChecked(item) {
        const selectedValues = Array.isArray(item.value) ? item.value : [item.value];
        const updatedItems = [...this.selectedItems];
        selectedValues.forEach(selectedValue => {
            const itemIndex = updatedItems.findIndex(selectedItem => _isEqual(selectedItem, selectedValue));
            if (itemIndex !== -1) {
                updatedItems.splice(itemIndex, 1);
            }
            else {
                updatedItems.push(selectedValue);
            }
        });
        // track changes internally since multiple changes can be made before the form
        // sends a new value into the input
        this.selectedItems = updatedItems;
        // signal to the parent form that our value has changed
        this.onChanged(updatedItems);
        this.onTouched();
    }
    // This is not used in this component, but is called in plan-filter-items via a viewChild
    markForCheck() {
        this.cdr.markForCheck();
    }
}
CheckboxGroupComponent.ɵfac = function CheckboxGroupComponent_Factory(t) { return new (t || CheckboxGroupComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.InputResetContextService), i0.ɵɵdirectiveInject(i0.ViewContainerRef)); };
CheckboxGroupComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CheckboxGroupComponent, selectors: [["vnext-checkbox-group"]], inputs: { name: "name", items: "items", customStyles: "customStyles", customClass: "customClass", showTooltipUnderline: "showTooltipUnderline", showTooltipIcon: "showTooltipIcon", enableNoteStyle: "enableNoteStyle", scrollable: "scrollable", parentId: "parentId", enablePrimaryColor: "enablePrimaryColor", highlightedItems: "highlightedItems", noTranslateBlock: "noTranslateBlock" }, features: [i0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => CheckboxGroupComponent),
                multi: true
            }
        ]), i0.ɵɵNgOnChangesFeature], decls: 2, vars: 5, consts: [[1, "modal-body", 3, "ngStyle", "ngClass"], [4, "ngIf"], [3, "ngClass"], [4, "ngFor", "ngForOf"], [3, "item", "selectedItems", "customClass", "showTooltipUnderline", "showTooltipIcon", "enableNoteStyle", "enablePrimaryColor", "highlightItem", "noTranslateBlock", "toggleChecked"]], template: function CheckboxGroupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, CheckboxGroupComponent_ng_container_1_Template, 3, 4, "ng-container", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngStyle", ctx.customStyles)("ngClass", i0.ɵɵpureFunction1(3, _c1$1Z, ctx.showTooltipUnderline || ctx.showTooltipIcon));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.items && ctx.items.length);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgStyle, CheckBoxItemComponent], styles: [".plan-filter-items[_nghost-%COMP%]   .modal-body[_ngcontent-%COMP%]{padding:0}.pharmacy-filter-items[_nghost-%COMP%]   .modal-body[_ngcontent-%COMP%]{display:flex;justify-content:space-around;padding:0;margin:0;list-style:none}.pharmacy-filter-modal-items[_nghost-%COMP%]   .modal-body[_ngcontent-%COMP%]{display:inline-block;justify-content:normal}.allow-overflow[_ngcontent-%COMP%]{overflow-y:visible}.scrollable[_ngcontent-%COMP%]{height:220px;overflow-y:auto;border:1px solid var(--static-Spa_Style_Gray4);padding:10px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckboxGroupComponent, [{
        type: Component,
        args: [{ selector: 'vnext-checkbox-group', changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => CheckboxGroupComponent),
                        multi: true
                    }
                ], template: "<div class=\"modal-body\" [ngStyle]=\"customStyles\" [ngClass]=\"{ 'allow-overflow': showTooltipUnderline || showTooltipIcon }\">\r\n  <ng-container *ngIf=\"items && items.length\">\r\n    <div [ngClass]=\"{ scrollable: scrollable }\">\r\n      <ng-container *ngFor=\"let item of items; index as i\">\r\n        <vnext-checkbox-item\r\n          [item]=\"item\"\r\n          [selectedItems]=\"selectedItems\"\r\n          [class]=\"hostClasses\"\r\n          [customClass]=\"customClass\"\r\n          [showTooltipUnderline]=\"showTooltipUnderline\"\r\n          [showTooltipIcon]=\"showTooltipIcon\"\r\n          [enableNoteStyle]=\"enableNoteStyle\"\r\n          [enablePrimaryColor]=\"enablePrimaryColor\"\r\n          [highlightItem]=\"itemShouldBeHighlighted[item.label]\"\r\n          [noTranslateBlock]=\"noTranslateBlock\"\r\n          (toggleChecked)=\"toggleChecked($event)\"\r\n        ></vnext-checkbox-item>\r\n      </ng-container>\r\n    </div>\r\n  </ng-container>\r\n</div>\r\n", styles: [":host(.plan-filter-items) .modal-body{padding:0}:host(.pharmacy-filter-items) .modal-body{display:flex;justify-content:space-around;padding:0;margin:0;list-style:none}:host(.pharmacy-filter-modal-items) .modal-body{display:inline-block;justify-content:normal}.allow-overflow{overflow-y:visible}.scrollable{height:220px;overflow-y:auto;border:1px solid var(--static-Spa_Style_Gray4);padding:10px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.InputResetContextService }, { type: i0.ViewContainerRef }]; }, { name: [{
            type: Input
        }], items: [{
            type: Input
        }], customStyles: [{
            type: Input
        }], customClass: [{
            type: Input
        }], showTooltipUnderline: [{
            type: Input
        }], showTooltipIcon: [{
            type: Input
        }], enableNoteStyle: [{
            type: Input
        }], scrollable: [{
            type: Input
        }], parentId: [{
            type: Input
        }], enablePrimaryColor: [{
            type: Input
        }], highlightedItems: [{
            type: Input
        }], noTranslateBlock: [{
            type: Input
        }] }); })();

function ConfigurableTooltipComponent_ng_template_0_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 6);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r4.header, "html"), i0.ɵɵsanitizeHtml);
} }
function ConfigurableTooltipComponent_ng_template_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 7);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r5.body, "html"), i0.ɵɵsanitizeHtml);
} }
function ConfigurableTooltipComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ConfigurableTooltipComponent_ng_template_0_div_0_Template, 2, 4, "div", 4);
    i0.ɵɵtemplate(1, ConfigurableTooltipComponent_ng_template_0_div_1_Template, 2, 4, "div", 5);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.header);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.body);
} }
const _c0$3H = ["*"];
/**
 * This is an extension of ngbTooltip, where we can set configuration properties through  Inputs().
 * This component should be prefered over vnext-tooltip in the case where anything from the default tooltip
 * is needed.
 *
 * Example: a tooltip that needs to be displayed on click instead of hover, or needs to have clickable
 * content in the tooltip body.
 *
 * Feel free to add  more configurations as needed (https://ng-bootstrap.github.io/#/components/tooltip/api)
 */
class ConfigurableTooltipComponent {
    constructor() {
        this.autoClose = true;
        this.triggers = 'hover focus';
    }
    getAriaLabelText() {
        return this.header ? `${this.Spa_Site_Tooltip_Text} ${this.header} ${this.body}` : `${this.Spa_Site_Tooltip_Text} ${this.body}`;
    }
}
ConfigurableTooltipComponent.ɵfac = function ConfigurableTooltipComponent_Factory(t) { return new (t || ConfigurableTooltipComponent)(); };
ConfigurableTooltipComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ConfigurableTooltipComponent, selectors: [["vnext-configurable-tooltip"]], inputs: { header: "header", body: "body", customClass: "customClass", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text", autoClose: "autoClose", triggers: "triggers" }, ngContentSelectors: _c0$3H, decls: 8, vars: 8, consts: [["tooltipContent", ""], ["tooltipClass", "tooltip", "tabindex", "0", "container", "body", 3, "ngbTooltip", "autoClose", "triggers", "mouseover"], ["tooltip", "ngbTooltip", "tooltipController", "ngbTooltip"], ["aria-hidden", "true", 1, "hidden-off-screen"], ["class", "Spa_Style_TooltipTextAndNumberIndicators tooltip-title", "navigationAdapter", "", 3, "innerHtml", 4, "ngIf"], ["class", "Spa_Style_ToolTip tooltip-content", "navigationAdapter", "", 3, "innerHtml", 4, "ngIf"], ["navigationAdapter", "", 1, "Spa_Style_TooltipTextAndNumberIndicators", "tooltip-title", 3, "innerHtml"], ["navigationAdapter", "", 1, "Spa_Style_ToolTip", "tooltip-content", 3, "innerHtml"]], template: function ConfigurableTooltipComponent_Template(rf, ctx) { if (rf & 1) {
        const _r6 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, ConfigurableTooltipComponent_ng_template_0_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(2, "button", 1, 2);
        i0.ɵɵlistener("mouseover", function ConfigurableTooltipComponent_Template_button_mouseover_2_listener() { i0.ɵɵrestoreView(_r6); const _r2 = i0.ɵɵreference(3); return i0.ɵɵresetView(_r2.open()); });
        i0.ɵɵelementStart(5, "span", 3);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(7);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(1);
        i0.ɵɵadvance(2);
        i0.ɵɵclassMapInterpolate1("action-button tooltip-body Spa_Style_TooltipTextAndNumberIndicators can-click ", ctx.customClass, "");
        i0.ɵɵproperty("ngbTooltip", _r0)("autoClose", ctx.autoClose)("triggers", ctx.triggers);
        i0.ɵɵattribute("aria-label", ctx.getAriaLabelText());
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.getAriaLabelText());
    } }, dependencies: [i1$2.NgIf, NavigationAdapterDirective, i1$1.NgbTooltip, SafePipe], styles: [".tooltip-content[_ngcontent-%COMP%]{padding:0}.border-radius-12[_ngcontent-%COMP%]{border-radius:12px}.tooltip-body[_ngcontent-%COMP%]{display:inline-flex;justify-content:center;align-items:center;vertical-align:text-top}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfigurableTooltipComponent, [{
        type: Component,
        args: [{ selector: 'vnext-configurable-tooltip', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-template #tooltipContent>\r\n  <div *ngIf=\"header\" class=\"Spa_Style_TooltipTextAndNumberIndicators tooltip-title\" [innerHtml]=\"header | safe: 'html'\" navigationAdapter></div>\r\n  <div *ngIf=\"body\" class=\"Spa_Style_ToolTip tooltip-content\" [innerHtml]=\"body | safe: 'html'\" navigationAdapter></div>\r\n</ng-template>\r\n<button \r\n  class=\"action-button tooltip-body Spa_Style_TooltipTextAndNumberIndicators can-click {{ customClass }}\"\r\n  #tooltip=\"ngbTooltip\"\r\n  [ngbTooltip]=\"tooltipContent\"\r\n  #tooltipController=\"ngbTooltip\"\r\n  tooltipClass=\"tooltip\"\r\n  tabindex=\"0\"\r\n  container=\"body\"\r\n  [attr.aria-label]=\"getAriaLabelText()\"\r\n  [autoClose]=\"autoClose\"\r\n  [triggers]=\"triggers\"\r\n  (mouseover)=\"tooltip.open()\"\r\n>\r\n  <span class=\"hidden-off-screen\" aria-hidden=\"true\">{{ getAriaLabelText() }}</span>\r\n  <ng-content></ng-content>\r\n</button>", styles: [".tooltip-content{padding:0}.border-radius-12{border-radius:12px}.tooltip-body{display:inline-flex;justify-content:center;align-items:center;vertical-align:text-top}\n"] }]
    }], null, { header: [{
            type: Input
        }], body: [{
            type: Input
        }], customClass: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }], autoClose: [{
            type: Input
        }], triggers: [{
            type: Input
        }] }); })();

function FootnoteComponent_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 6);
    i0.ɵɵpipe(4, "safe");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const footnoteId_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(footnoteId_r1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 2, ctx_r2.footnotes[footnoteId_r1], "html"), i0.ɵɵsanitizeHtml);
} }
function FootnoteComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, FootnoteComponent_div_3_ng_container_1_Template, 5, 5, "ng-container", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const footnoteId_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.footnotes && ctx_r0.footnotes[footnoteId_r1]);
} }
class FootnoteComponent {
}
FootnoteComponent.ɵfac = function FootnoteComponent_Factory(t) { return new (t || FootnoteComponent)(); };
FootnoteComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FootnoteComponent, selectors: [["vnext-footnote"]], inputs: { footnoteIdsToShow: "footnoteIdsToShow", footnotes: "footnotes", footnoteHeader: "footnoteHeader" }, decls: 4, vars: 5, consts: [[1, "Spa_Style_Note", "mt-5", "pt-3"], ["navigationAdapter", "", 1, "footnote-header", 3, "innerHTML"], ["class", "mt-3 d-flex", 4, "ngFor", "ngForOf"], [1, "mt-3", "d-flex"], [4, "ngIf"], [1, "footnote-type"], ["navigationAdapter", "", 1, "footnotes-text", 3, "innerHTML"]], template: function FootnoteComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵpipe(2, "safe");
        i0.ɵɵtemplate(3, FootnoteComponent_div_3_Template, 2, 1, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 2, ctx.footnoteHeader, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.footnoteIdsToShow);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, NavigationAdapterDirective, SafePipe], styles: [".footnote-header[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Accent1);padding-bottom:1px}.footnote-type[_ngcontent-%COMP%]{max-width:30px;min-width:22px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FootnoteComponent, [{
        type: Component,
        args: [{ selector: 'vnext-footnote', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"Spa_Style_Note mt-5 pt-3\">\r\n  <div class=\"footnote-header\" [innerHTML]=\"footnoteHeader | safe: 'html'\" navigationAdapter></div>\r\n  <div class=\"mt-3 d-flex\" *ngFor=\"let footnoteId of footnoteIdsToShow\">\r\n    <ng-container *ngIf=\"footnotes && footnotes[footnoteId]\">\r\n      <div class=\"footnote-type\">{{ footnoteId }}</div>\r\n      <div class=\"footnotes-text\" [innerHTML]=\"footnotes[footnoteId] | safe: 'html'\" navigationAdapter></div>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n", styles: [".footnote-header{border-bottom:1px solid var(--static-Spa_Style_Accent1);padding-bottom:1px}.footnote-type{max-width:30px;min-width:22px}\n"] }]
    }], null, { footnoteIdsToShow: [{
            type: Input
        }], footnotes: [{
            type: Input
        }], footnoteHeader: [{
            type: Input
        }] }); })();

const _c0$3G = ["formDate"];
const _c1$1Y = function (a0) { return { "has-error": a0 }; };
function FormDateComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "input", 4, 5);
    i0.ɵɵlistener("dateSelect", function FormDateComponent_ng_container_3_Template_input_dateSelect_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.onDateSelection($event)); })("select", function FormDateComponent_ng_container_3_Template_input_select_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onDateSelection($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 6);
    i0.ɵɵlistener("click", function FormDateComponent_ng_container_3_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r4); const _r2 = i0.ɵɵreference(2); return i0.ɵɵresetView(_r2.toggle()); });
    i0.ɵɵelement(4, "i", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("minDate", ctx_r1.datePickerMinDate)("maxDate", ctx_r1.datePickerMaxDate)("ngClass", i0.ɵɵpureFunction1(5, _c1$1Y, ctx_r1.hasError));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.isReadOnly);
    i0.ɵɵattribute("aria-label", ctx_r1.datePickerButtonLabelText ? ctx_r1.datePickerButtonLabelText : null);
} }
const _c2$1c = function (a0) { return { "w-100": a0 }; };
const _c3$R = function (a0, a1) { return { "has-error": a0, "Spa_Style_Gray4_Color readonly": a1 }; };
class FormDateComponent {
    constructor() {
        this.sendDate = new EventEmitter();
        this.showDatePicker = false;
        this.hasError = false;
        this.fullWidth = false;
        this.isReadOnly = false;
        this.dirty = false;
        this.defaultFormat = DateUtilities.defaultFormat.toLowerCase();
        this.maskFormat = this.defaultFormat.replace(/\w/g, '0');
    }
    ngOnInit() {
        this.value = this.getDate();
        if (this.value) {
            this.dirty = true;
        }
    }
    getDate() {
        if (this.defaultValue) {
            // We must take into account date time formats such as "6/1/2020 12:00:00 AM"
            // in addition to the default MM/DD/YYYY format, i.e. 06/01/2020.
            return DateUtilities.getFormattedDate(new Date(this.defaultValue.split(' ')[0]));
        }
        return '';
    }
    onKeyDownEmitDate($event) {
        const isTabEvent = $event && $event.keyCode === 9;
        if (isTabEvent) {
            this.emitDate();
        }
    }
    emitDate() {
        this.dirty = true;
        this.value ? this.sendDate.emit(this.value) : this.sendDate.emit('');
    }
    onDateSelection(event) {
        const month = event.month.toString().length === 1 ? `0${event.month}` : event.month.toString();
        const day = event.day.toString().length === 1 ? `0${event.day}` : event.day.toString();
        this.value = `${month}/${day}/${event.year}`;
        this.emitDate();
    }
}
FormDateComponent.ɵfac = function FormDateComponent_Factory(t) { return new (t || FormDateComponent)(); };
FormDateComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FormDateComponent, selectors: [["vnext-form-date"]], viewQuery: function FormDateComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3G, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.formDate = _t.first);
    } }, inputs: { defaultValue: "defaultValue", showDatePicker: "showDatePicker", datePickerMinDate: "datePickerMinDate", datePickerMaxDate: "datePickerMaxDate", hasError: "hasError", fullWidth: "fullWidth", datePickerButtonLabelText: "datePickerButtonLabelText", ariaDescribedById: "ariaDescribedById", ariaLabelledById: "ariaLabelledById", isReadOnly: "isReadOnly" }, outputs: { sendDate: "sendDate" }, decls: 4, vars: 15, consts: [[1, "date-input", 3, "ngClass"], ["type", "text", "inputmode", "numeric", "autocomplete", "off", "maxlength", "10", "aria-required", "true", 1, "form-date-number-input", 3, "placeholder", "mask", "dropSpecialCharacters", "ngClass", "readonly", "ngModel", "ngModelChange", "keydown", "blur"], ["formDate", ""], [4, "ngIf"], ["type", "text", "aria-hidden", "true", "tabindex", "-1", "ngbDatepicker", "", 1, "date-picker-input", "float-left", "p-0", 3, "minDate", "maxDate", "ngClass", "dateSelect", "select"], ["datePickerInput", "ngbDatepicker"], [1, "btn", "btn-calendar", 3, "disabled", "click"], ["aria-hidden", "true", "role", "presentation", 1, "fas", "fa-calendar-alt"]], template: function FormDateComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "input", 1, 2);
        i0.ɵɵlistener("ngModelChange", function FormDateComponent_Template_input_ngModelChange_1_listener($event) { return ctx.value = $event; })("keydown", function FormDateComponent_Template_input_keydown_1_listener($event) { return ctx.showDatePicker ? ctx.onKeyDownEmitDate($event) : null; })("blur", function FormDateComponent_Template_input_blur_1_listener() { return ctx.emitDate(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, FormDateComponent_ng_container_3_Template, 5, 7, "ng-container", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c2$1c, ctx.fullWidth));
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("placeholder", ctx.defaultFormat);
        i0.ɵɵpropertyInterpolate("mask", ctx.maskFormat);
        i0.ɵɵproperty("dropSpecialCharacters", false)("ngClass", i0.ɵɵpureFunction2(12, _c3$R, ctx.hasError, ctx.isReadOnly))("readonly", ctx.isReadOnly)("ngModel", ctx.value);
        i0.ɵɵattribute("aria-describedby", ctx.ariaDescribedById ? ctx.ariaDescribedById : null)("aria-labelledby", ctx.ariaLabelledById ? ctx.ariaLabelledById : null);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showDatePicker);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.DefaultValueAccessor, i4.NgControlStatus, i4.MaxLengthValidator, i4.NgModel, i1$1.NgbInputDatepicker, i8.MaskDirective, IconAriaAttributesDirective], styles: ["label[_ngcontent-%COMP%]{margin-bottom:0}input[_ngcontent-%COMP%]{width:100%}.form-date-number-input[_ngcontent-%COMP%], .date-input[_ngcontent-%COMP%]{position:relative}.date-picker-input[_ngcontent-%COMP%]{color:transparent;border:transparent;height:0}.btn-calendar[_ngcontent-%COMP%]{position:absolute;right:0;top:0}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormDateComponent, [{
        type: Component,
        args: [{ selector: 'vnext-form-date', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"date-input\" [ngClass]=\"{ 'w-100': fullWidth }\">\r\n  <input\r\n    #formDate\r\n    type=\"text\"\r\n    class=\"form-date-number-input\"\r\n    inputmode=\"numeric\"\r\n    autocomplete=\"off\"\r\n    placeholder=\"{{ defaultFormat }}\"\r\n    mask=\"{{ maskFormat }}\"\r\n    maxlength=\"10\"\r\n    aria-required=\"true\"\r\n    [attr.aria-describedby]=\"ariaDescribedById ? ariaDescribedById : null\"\r\n    [attr.aria-labelledby]=\"ariaLabelledById ? ariaLabelledById : null\"\r\n    [dropSpecialCharacters]=\"false\"\r\n    [ngClass]=\"{ 'has-error': hasError, 'Spa_Style_Gray4_Color readonly': isReadOnly }\"\r\n    [readonly]=\"isReadOnly\"\r\n    [(ngModel)]=\"value\"\r\n    (keydown)=\"showDatePicker ? onKeyDownEmitDate($event) : null\"\r\n    (blur)=\"emitDate()\"\r\n  />\r\n  <ng-container *ngIf=\"showDatePicker\">\r\n    <input\r\n      type=\"text\"\r\n      aria-hidden=\"true\"\r\n      class=\"date-picker-input float-left p-0\"\r\n      tabindex=\"-1\"\r\n      ngbDatepicker\r\n      #datePickerInput=\"ngbDatepicker\"\r\n      [minDate]=\"datePickerMinDate\"\r\n      [maxDate]=\"datePickerMaxDate\"\r\n      [ngClass]=\"{ 'has-error': hasError }\"\r\n      (dateSelect)=\"onDateSelection($event)\"\r\n      (select)=\"onDateSelection($event)\"\r\n    />\r\n    <button\r\n      class=\"btn btn-calendar\"\r\n      [attr.aria-label]=\"datePickerButtonLabelText ? datePickerButtonLabelText : null\"\r\n      [disabled]=\"isReadOnly\"\r\n      (click)=\"datePickerInput.toggle()\"\r\n    >\r\n      <i aria-hidden=\"true\" role=\"presentation\" class=\"fas fa-calendar-alt\"></i>\r\n    </button>\r\n  </ng-container>\r\n</div>\r\n", styles: ["label{margin-bottom:0}input{width:100%}.form-date-number-input,.date-input{position:relative}.date-picker-input{color:transparent;border:transparent;height:0}.btn-calendar{position:absolute;right:0;top:0}\n"] }]
    }], null, { formDate: [{
            type: ViewChild,
            args: ['formDate', { static: true }]
        }], sendDate: [{
            type: Output
        }], defaultValue: [{
            type: Input
        }], showDatePicker: [{
            type: Input
        }], datePickerMinDate: [{
            type: Input
        }], datePickerMaxDate: [{
            type: Input
        }], hasError: [{
            type: Input
        }], fullWidth: [{
            type: Input
        }], datePickerButtonLabelText: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], isReadOnly: [{
            type: Input
        }] }); })();

function FormMonthYearDropdownComponent_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function FormMonthYearDropdownComponent_button_10_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r6); const month_r4 = restoredCtx.$implicit; const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.setSelectedMonth(month_r4)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const month_r4 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", month_r4, " ");
} }
function FormMonthYearDropdownComponent_button_20_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function FormMonthYearDropdownComponent_button_20_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const year_r7 = restoredCtx.$implicit; const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.setSelectedYear(year_r7)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const year_r7 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", year_r7, " ");
} }
const _c0$3F = function (a0) { return { "has-error": a0 }; };
// TODO: This is general month year component will use on every components where required.
class FormMonthYearDropdownComponent {
    constructor(medSupFacade, cdr) {
        this.medSupFacade = medSupFacade;
        this.cdr = cdr;
        this.updatedDate = new EventEmitter();
        this.hasError = false;
        this.selectMonthText = 'Month';
        this.selectYearText = 'Year';
    }
    ngOnInit() {
        if (this.defaultValue) {
            this.setDefaultValue(this.defaultValue);
        }
    }
    ngOnChanges(changes) {
        if (changes.defaultValue && changes.defaultValue?.currentValue !== changes.defaultValue?.previousValue) {
            const newDefault = changes.defaultValue.currentValue ? changes.defaultValue.currentValue : undefined;
            this.setDefaultValue(newDefault);
        }
    }
    resetSelectedValues() {
        this.selectedMonth = null;
        this.selectedYear = null;
        this.cdr.markForCheck();
    }
    setDefaultValue(defaultValue) {
        const date = DateUtilities.getNonOffsetDate(defaultValue);
        this.selectedMonth = this.monthList[date.getMonth()];
        this.selectedYear = date.getFullYear();
    }
    setSelectedYear(value) {
        this.selectedYear = value;
        this.monthList = this.medSupFacade.getRangeMonthList(this.monthRange, value);
        this.updateDate();
    }
    setSelectedMonth(value) {
        this.selectedMonth = value;
        this.updateDate();
    }
    updateDate() {
        if (this.selectedMonth && this.selectedYear) {
            let selectedDate = `${DateUtilities.getIndexMonth(this.selectedMonth)}/01/${this.selectedYear}`;
            selectedDate = DateUtilities.getFormattedDateTime(new Date(selectedDate), DateUtilities.defaultFormat);
            this.updatedDate.emit(selectedDate);
        }
    }
}
FormMonthYearDropdownComponent.ɵfac = function FormMonthYearDropdownComponent_Factory(t) { return new (t || FormMonthYearDropdownComponent)(i0.ɵɵdirectiveInject(MedSupFacade), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
FormMonthYearDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FormMonthYearDropdownComponent, selectors: [["vnext-form-month-year-dropdown"]], inputs: { defaultValue: "defaultValue", hasError: "hasError", monthList: "monthList", yearRange: "yearRange", monthRange: "monthRange", maxFutureMonths: "maxFutureMonths", maxPastMonths: "maxPastMonths" }, outputs: { updatedDate: "updatedDate" }, features: [i0.ɵɵNgOnChangesFeature], decls: 21, vars: 12, consts: [["ngbDropdown", "", 1, "d-inline-block", "pr-1", 3, "ngClass"], ["myDrop", "ngbDropdown"], ["ngbDropdownToggle", "", "tabindex", "0", "aria-required", "true", "role", "combobox", "selectDropdownByCharacter", "", 1, "month-toggle", "med-sup-dropdown-toggle", "w-100"], [3, "ngClass"], [1, "fa", "fa-angle-down", "float-right", "pt-1", "pl-2"], [1, "sr-only"], ["ngbDropdownMenu", ""], ["ngbDropdownItem", "", "tabindex", "0", 3, "click", 4, "ngFor", "ngForOf"], ["ngbDropdown", "", 1, "d-inline-block", 3, "ngClass"], ["ngbDropdownToggle", "", "tabindex", "0", "aria-required", "true", "role", "combobox", "selectDropdownByCharacter", "", 1, "year-toggle", "med-sup-dropdown-toggle", "w-100"], ["ngbDropdownMenu", "", 1, "year-dropdown", "mh-75"], ["ngbDropdownItem", "", "tabindex", "0", 3, "click"]], template: function FormMonthYearDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵelementStart(1, "div", 0, 1)(3, "button", 2)(4, "span", 3);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(6, "i", 4);
        i0.ɵɵelementStart(7, "span", 5);
        i0.ɵɵtext(8, "Expand menu");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵtemplate(10, FormMonthYearDropdownComponent_button_10_Template, 2, 1, "button", 7);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(11, "div", 8, 1)(13, "button", 9)(14, "span", 3);
        i0.ɵɵtext(15);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(16, "i", 4);
        i0.ɵɵelementStart(17, "span", 5);
        i0.ɵɵtext(18, "Expand menu");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(19, "div", 10);
        i0.ɵɵtemplate(20, FormMonthYearDropdownComponent_button_20_Template, 2, 1, "button", 7);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$3F, ctx.hasError));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", ctx.selectedMonth ? "Spa_Style_Primary_Color" : "default-item-text-color");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.selectedMonth ? ctx.selectedMonth : ctx.selectMonthText);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngForOf", ctx.monthList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c0$3F, ctx.hasError));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", ctx.selectedMonth ? "Spa_Style_Primary_Color" : "default-item-text-color");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.selectedYear ? ctx.selectedYear : ctx.selectYearText);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngForOf", ctx.yearRange);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem, IconAriaAttributesDirective, SelectDropdownByCharacterDirective], styles: [".month-toggle[_ngcontent-%COMP%], .year-toggle[_ngcontent-%COMP%]{min-width:100px;text-align:left}.year-dropdown[_ngcontent-%COMP%]{max-height:300px;overflow-y:auto}.dropdown-item[_ngcontent-%COMP%]:active{background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}@media (max-width: 575px){.year-toggle[_ngcontent-%COMP%]{margin-top:10px}.month-toggle[_ngcontent-%COMP%]{margin-right:15px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormMonthYearDropdownComponent, [{
        type: Component,
        args: [{ selector: 'vnext-form-month-year-dropdown', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container>\r\n  <div class=\"d-inline-block pr-1\" ngbDropdown #myDrop=\"ngbDropdown\" [ngClass]=\"{ 'has-error': hasError }\">\r\n    <button\r\n      ngbDropdownToggle\r\n      class=\"month-toggle med-sup-dropdown-toggle w-100\"\r\n      tabindex=\"0\"\r\n      aria-required=\"true\"\r\n      role=\"combobox\"\r\n      selectDropdownByCharacter\r\n    >\r\n      <span [ngClass]=\"selectedMonth ? 'Spa_Style_Primary_Color' : 'default-item-text-color'\">{{\r\n        selectedMonth ? selectedMonth : selectMonthText\r\n      }}</span>\r\n      <i class=\"fa fa-angle-down float-right pt-1 pl-2\"></i>\r\n      <span class=\"sr-only\">Expand menu</span>\r\n    </button>\r\n    <div ngbDropdownMenu>\r\n      <button *ngFor=\"let month of monthList\" ngbDropdownItem (click)=\"setSelectedMonth(month)\" tabindex=\"0\">\r\n        {{ month }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n  <div class=\"d-inline-block\" ngbDropdown #myDrop=\"ngbDropdown\" [ngClass]=\"{ 'has-error': hasError }\">\r\n    <button\r\n      ngbDropdownToggle\r\n      class=\"year-toggle med-sup-dropdown-toggle w-100\"\r\n      tabindex=\"0\"\r\n      aria-required=\"true\"\r\n      role=\"combobox\"\r\n      selectDropdownByCharacter\r\n    >\r\n      <span [ngClass]=\"selectedMonth ? 'Spa_Style_Primary_Color' : 'default-item-text-color'\">{{\r\n        selectedYear ? selectedYear : selectYearText\r\n      }}</span>\r\n      <i class=\"fa fa-angle-down float-right pt-1 pl-2\"></i>\r\n      <span class=\"sr-only\">Expand menu</span>\r\n    </button>\r\n    <div ngbDropdownMenu class=\"year-dropdown mh-75\">\r\n      <button *ngFor=\"let year of yearRange\" ngbDropdownItem (click)=\"setSelectedYear(year)\" tabindex=\"0\">\r\n        {{ year }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n", styles: [".month-toggle,.year-toggle{min-width:100px;text-align:left}.year-dropdown{max-height:300px;overflow-y:auto}.dropdown-item:active{background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}@media (max-width: 575px){.year-toggle{margin-top:10px}.month-toggle{margin-right:15px}}\n"] }]
    }], function () { return [{ type: MedSupFacade }, { type: i0.ChangeDetectorRef }]; }, { updatedDate: [{
            type: Output
        }], defaultValue: [{
            type: Input
        }], hasError: [{
            type: Input
        }], monthList: [{
            type: Input
        }], yearRange: [{
            type: Input
        }], monthRange: [{
            type: Input
        }], maxFutureMonths: [{
            type: Input
        }], maxPastMonths: [{
            type: Input
        }] }); })();

const _c0$3E = ["agencyDropdownMenu"];
const _c1$1X = function (a0) { return { Spa_Style_Gray1_Background: a0 }; };
function AgencyNameSelectorInputComponent_div_0_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9, 10);
    i0.ɵɵlistener("click", function AgencyNameSelectorInputComponent_div_0_div_6_div_1_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r7); const agency_r4 = restoredCtx.$implicit; const ctx_r6 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r6.selectAgency(agency_r4.selectionValue)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const agency_r4 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", ctx_r3.AGENCY_NAME_ID_PREFIX + agency_r4.selectionValue.agencyGuid);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1$1X, agency_r4.selectionValue.agencyGuid === ctx_r3.selectedAgencyGuid));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", agency_r4.displayValue, " ");
} }
function AgencyNameSelectorInputComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, AgencyNameSelectorInputComponent_div_0_div_6_div_1_Template, 3, 5, "div", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.dropdownItems)("ngForTrackBy", ctx_r2.trackByAgency);
} }
const _c2$1b = function (a0) { return { height: a0 }; };
const _c3$Q = function (a0, a1) { return { "has-error": a0, "disable-input": a1 }; };
const _c4$v = function (a0) { return { "can-click": a0 }; };
function AgencyNameSelectorInputComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1, 2)(2, "input", 3);
    i0.ɵɵlistener("valueSelectedByCharacter", function AgencyNameSelectorInputComponent_div_0_Template_input_valueSelectedByCharacter_2_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.selectAgency($event)); })("keydown", function AgencyNameSelectorInputComponent_div_0_Template_input_keydown_2_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.onDropdownToggleKeyDown($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "i", 4);
    i0.ɵɵelementStart(4, "span", 5);
    i0.ɵɵtext(5, "Expand menu");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, AgencyNameSelectorInputComponent_div_0_div_6_Template, 2, 2, "div", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r1 = i0.ɵɵreference(1);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r0.placeholder);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(12, _c2$1b, ctx_r0.height))("ngClass", i0.ɵɵpureFunction2(14, _c3$Q, ctx_r0.control.errors && ctx_r0.formSubmitted, ctx_r0.isReadOnly || (ctx_r0.agencyItems == null ? null : ctx_r0.agencyItems.length) === 0))("value", ctx_r0.selectedAgency == null ? null : ctx_r0.selectedAgency.agencyName)("dropdownValues", ctx_r0.dropdownItems)("dropdownLastSelection", ctx_r0.selectedAgency)("dropdownInstance", _r1)("closeDropdownOnKeyup", false)("disabled", ctx_r0.isReadOnly || !(ctx_r0.dropdownItems == null ? null : ctx_r0.dropdownItems.length));
    i0.ɵɵattribute("aria-labelledby", ctx_r0.ariaLabelledById);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c4$v, (ctx_r0.dropdownItems == null ? null : ctx_r0.dropdownItems.length) > 0));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0.isReadOnly && (ctx_r0.dropdownItems == null ? null : ctx_r0.dropdownItems.length));
} }
class AgencyNameSelectorInputComponent {
    constructor(cdr, configResourceService) {
        this.cdr = cdr;
        this.configResourceService = configResourceService;
        this.formSubmitted = false;
        this.height = '30px';
        this.isReadOnly = false;
        this.agencyItems = [];
        this.emitAgencyId = new EventEmitter();
        this.selectedAgencyGuid = '';
        this.AGENCY_NAME_ID_PREFIX = 'AGENCY_';
        this.selectedAgency = null;
        this.placeholder = '';
        this.dropdownItems = [];
    }
    ngOnInit() {
        if (this.control.value) {
            const agencyName = this.control.value;
            if (this.agencyID) {
                this.selectedAgency = this.getAgencyByNameAndID(agencyName, this.agencyID);
            }
            if (this.selectedAgency) {
                this.control.setValue(this.selectedAgency.agencyName);
                this.scrollToItem(this.selectedAgency); // Scroll to selected item.
            }
        }
        if (this.agencyItems?.length === 1) {
            this.selectAgency(this.agencyItems[0]);
        }
    }
    ngOnChanges(changes) {
        if (!_isEqual(changes.agencyItems?.previousValue, changes.agencyItems?.currentValue)) {
            this.placeholder = this.agencyItems?.length === 0 ? this.noneAvailableLabel : '';
            this.dropdownItems = this.agencyItems?.map(state => ({ displayValue: state.agencyName, selectionValue: state }));
        }
    }
    selectAgency(agency) {
        if (agency && this.control) {
            this.selectedAgencyGuid = agency.agencyGuid;
            this.selectedAgency = agency;
            this.control.setValue(this.selectedAgency.agencyName);
            this.scrollToItem(this.selectedAgency); // Scroll to selected item.
        }
        else {
            this.selectedAgencyGuid = null;
        }
        this.emitAgencyId.emit(agency?.agencyID);
        this.cdr.detectChanges();
    }
    scrollToItem(selectedAgency) {
        if (this.agencyDropdownMenu) {
            const parentElement = this.agencyDropdownMenu.first?.nativeElement.parentElement;
            const agencyElement = document.getElementById(this.AGENCY_NAME_ID_PREFIX + selectedAgency.agencyGuid);
            if (agencyElement) {
                parentElement.scroll(0, agencyElement.offsetTop - 100);
            }
        }
    }
    onDropdownToggleKeyDown(event) {
        if (event && event.key.toLowerCase() === 'backspace') {
            this.cdr.detectChanges();
        }
        if (event && event.key.toLowerCase() !== 'tab') {
            event.preventDefault();
        }
    }
    getAgencyByNameAndID(agencyName, agencyId) {
        return this.agencyItems?.find(agency => agency.agencyID === agencyId && agency.agencyName === agencyName);
    }
    trackByAgency(index, agency) {
        return agency.agencyID;
    }
}
AgencyNameSelectorInputComponent.ɵfac = function AgencyNameSelectorInputComponent_Factory(t) { return new (t || AgencyNameSelectorInputComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.ConfigResourceService)); };
AgencyNameSelectorInputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgencyNameSelectorInputComponent, selectors: [["vnext-agency-name-selector-input"]], viewQuery: function AgencyNameSelectorInputComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3E, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.agencyDropdownMenu = _t);
    } }, inputs: { control: "control", formSubmitted: "formSubmitted", height: "height", controlValue: "controlValue", isReadOnly: "isReadOnly", agencyItems: "agencyItems", agencyID: "agencyID", noneAvailableLabel: "noneAvailableLabel", ariaLabelledById: "ariaLabelledById" }, outputs: { emitAgencyId: "emitAgencyId" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "position-relative", "ngbDropdown", "", 4, "ngIf"], ["ngbDropdown", "", 1, "position-relative"], ["dropdownInstance", "ngbDropdown"], ["ngbDropdownToggle", "", "selectDropdownByCharacter", "", "type", "text", "tabindex", "0", "autocomplete", "new-text", 1, "form-control", "can-click", 3, "placeholder", "ngStyle", "ngClass", "value", "dropdownValues", "dropdownLastSelection", "dropdownInstance", "closeDropdownOnKeyup", "disabled", "valueSelectedByCharacter", "keydown"], ["ngbDropdownToggle", "", 1, "fas", "fa-angle-down", "icon-in-input", "float-right", 3, "ngClass"], [1, "sr-only"], ["ngbDropdownMenu", "", "class", "dropdown-menu no-translate-block", 4, "ngIf"], ["ngbDropdownMenu", "", 1, "dropdown-menu", "no-translate-block"], ["ngbDropdownItem", "", 3, "id", "ngClass", "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["ngbDropdownItem", "", 3, "id", "ngClass", "click"], ["agencyDropdownMenu", ""]], template: function AgencyNameSelectorInputComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, AgencyNameSelectorInputComponent_div_0_Template, 7, 19, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.control);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgStyle, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem, SelectDropdownByCharacterDirective], styles: [".icon-in-input[_ngcontent-%COMP%]{position:absolute;top:8px;left:calc(100% - 15px)}.dropdown-menu[_ngcontent-%COMP%]{max-height:300px;overflow-y:auto;min-width:100%}.disable-input[_ngcontent-%COMP%]{cursor:default}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgencyNameSelectorInputComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agency-name-selector-input', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"position-relative\" ngbDropdown #dropdownInstance=\"ngbDropdown\" *ngIf=\"control\">\r\n  <input\r\n    ngbDropdownToggle\r\n    selectDropdownByCharacter\r\n    type=\"text\"\r\n    tabindex=\"0\"\r\n    autocomplete=\"new-text\"\r\n    placeholder=\"{{ placeholder }}\"\r\n    class=\"form-control can-click\"\r\n    [ngStyle]=\"{ height: height }\"\r\n    [ngClass]=\"{ 'has-error': control.errors && formSubmitted, 'disable-input': isReadOnly || agencyItems?.length === 0 }\"\r\n    [value]=\"selectedAgency?.agencyName\"\r\n    [dropdownValues]=\"dropdownItems\"\r\n    [dropdownLastSelection]=\"selectedAgency\"\r\n    [dropdownInstance]=\"dropdownInstance\"\r\n    [closeDropdownOnKeyup]=\"false\"\r\n    [disabled]=\"isReadOnly || !dropdownItems?.length\"\r\n    [attr.aria-labelledby]=\"ariaLabelledById\"\r\n    (valueSelectedByCharacter)=\"selectAgency($event)\"\r\n    (keydown)=\"onDropdownToggleKeyDown($event)\"\r\n  />\r\n  <i class=\"fas fa-angle-down icon-in-input float-right\" ngbDropdownToggle [ngClass]=\"{ 'can-click': dropdownItems?.length > 0 }\"></i>\r\n  <span class=\"sr-only\">Expand menu</span>\r\n  <div ngbDropdownMenu class=\"dropdown-menu no-translate-block\" *ngIf=\"!isReadOnly && dropdownItems?.length\">\r\n    <div\r\n      *ngFor=\"let agency of dropdownItems; trackBy: trackByAgency\"\r\n      (click)=\"selectAgency(agency.selectionValue)\"\r\n      ngbDropdownItem\r\n      #agencyDropdownMenu\r\n      id=\"{{ AGENCY_NAME_ID_PREFIX + agency.selectionValue.agencyGuid }}\"\r\n      [ngClass]=\"{ Spa_Style_Gray1_Background: agency.selectionValue.agencyGuid === selectedAgencyGuid }\"\r\n    >\r\n      {{ agency.displayValue }}\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".icon-in-input{position:absolute;top:8px;left:calc(100% - 15px)}.dropdown-menu{max-height:300px;overflow-y:auto;min-width:100%}.disable-input{cursor:default}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.ConfigResourceService }]; }, { control: [{
            type: Input
        }], formSubmitted: [{
            type: Input
        }], height: [{
            type: Input
        }], controlValue: [{
            type: Input
        }], isReadOnly: [{
            type: Input
        }], agencyDropdownMenu: [{
            type: ViewChildren,
            args: ['agencyDropdownMenu']
        }], agencyItems: [{
            type: Input
        }], agencyID: [{
            type: Input
        }], noneAvailableLabel: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], emitAgencyId: [{
            type: Output
        }] }); })();

const _c0$3D = ["stateAbbrevItems"];
function StateSelectorInputComponent_div_0_i_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 7);
} }
const _c1$1W = function (a0) { return { Spa_Style_Gray1_Background: a0 }; };
function StateSelectorInputComponent_div_0_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10, 11);
    i0.ɵɵlistener("click", function StateSelectorInputComponent_div_0_div_6_div_1_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r8); const state_r5 = restoredCtx.$implicit; const ctx_r7 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r7.selectState(state_r5.selectionValue)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const state_r5 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("id", ctx_r4.STATE_ABBREV_ID_PREFIX + state_r5.selectionValue.StateAbbrev);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1$1W, state_r5.selectionValue.StateAbbrev === ctx_r4.selectedStateAbbrev));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", state_r5.displayValue, " ");
} }
function StateSelectorInputComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, StateSelectorInputComponent_div_0_div_6_div_1_Template, 3, 5, "div", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.dropdownItems);
} }
const _c2$1a = function (a0) { return { height: a0 }; };
const _c3$P = function (a0, a1, a2) { return { "has-error": a0, "form-control can-click": a1, "Spa_Style_Gray4_Color readonly": a2 }; };
function StateSelectorInputComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1, 2)(2, "input", 3);
    i0.ɵɵlistener("ngModelChange", function StateSelectorInputComponent_div_0_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.selectedStateAbbrev = $event); })("valueSelectedByCharacter", function StateSelectorInputComponent_div_0_Template_input_valueSelectedByCharacter_2_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.selectState($event)); })("keydown", function StateSelectorInputComponent_div_0_Template_input_keydown_2_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.onDropdownToggleKeyDown($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, StateSelectorInputComponent_div_0_i_3_Template, 1, 0, "i", 4);
    i0.ɵɵelementStart(4, "span", 5);
    i0.ɵɵtext(5, "Expand menu");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, StateSelectorInputComponent_div_0_div_6_Template, 2, 1, "div", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r1 = i0.ɵɵreference(1);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(ctx_r0.customClass);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(14, _c2$1a, ctx_r0.height))("ngClass", i0.ɵɵpureFunction3(16, _c3$P, ctx_r0.control.errors && ctx_r0.formSubmitted, !ctx_r0.isReadOnly, ctx_r0.isReadOnly))("dropdownValues", ctx_r0.dropdownItems)("dropdownLastSelection", ctx_r0.getStateByAbbreviation(ctx_r0.selectedStateAbbrev))("dropdownInstance", _r1)("closeDropdownOnKeyup", false)("disabled", ctx_r0.isReadOnly)("ngModel", ctx_r0.selectedStateAbbrev);
    i0.ɵɵattribute("aria-labelledby", ctx_r0.ariaLabelledById);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isReadOnly);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0.isReadOnly);
} }
class StateSelectorInputComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.formSubmitted = false;
        this.height = '30px';
        this.isReadOnly = false;
        this.dropdownItems = [];
        this.selectedStateAbbrev = '';
        this.STATE_ABBREV_ID_PREFIX = 'STATE_';
        this.onStateSelect = new EventEmitter();
    }
    selectState(state) {
        if (state && this.control) {
            this.selectedStateAbbrev = state.StateAbbrev;
            this.control.setValue(state.StateAbbrev);
        }
        else {
            this.selectedStateAbbrev = '';
        }
        this.cdr.detectChanges();
        this.scrollToItem(this.selectedStateAbbrev); // Scroll to selected item.
        this.onStateSelect.emit(this.selectedStateAbbrev);
    }
    scrollToItem(selectedStateAbbrev) {
        const parentElement = this.stateAbbrevItems.first?.nativeElement.parentElement;
        this.stateAbbrevItems.forEach(stateAbbrev => {
            if (stateAbbrev.nativeElement.id === this.STATE_ABBREV_ID_PREFIX + selectedStateAbbrev) {
                parentElement.scroll(0, stateAbbrev.nativeElement.offsetTop - 100);
            }
        });
    }
    ngOnInit() {
        this.dropdownItems = DemographicStates.map(state => ({ displayValue: state.StateName, selectionValue: state }));
        if (this.control.value) {
            const selectedState = this.getStateByAbbreviation(this.control.value);
            if (selectedState) {
                this.selectedStateAbbrev = selectedState.StateAbbrev;
            }
        }
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('controlValue')) {
            const controlValue = changes.controlValue?.currentValue;
            if (this.selectedStateAbbrev !== undefined && controlValue !== this.selectedStateAbbrev) {
                const selectedState = DemographicStates.find(state => state.StateAbbrev === controlValue);
                this.selectedStateAbbrev = selectedState ? selectedState.StateAbbrev : '';
            }
        }
    }
    getStateByAbbreviation(abbreviation = '') {
        return DemographicStates.find(state => state.StateAbbrev.toLowerCase() === abbreviation.toString().toLowerCase());
    }
    onDropdownToggleKeyDown(event) {
        if (event && event.key.toLowerCase() === 'backspace') {
            // clear field on backspace
            this.selectedStateAbbrev = '';
            this.cdr.detectChanges();
            this.onStateSelect.emit(this.selectedStateAbbrev);
        }
        if (event && event.key.toLowerCase() !== 'tab') {
            event.preventDefault();
        }
    }
}
StateSelectorInputComponent.ɵfac = function StateSelectorInputComponent_Factory(t) { return new (t || StateSelectorInputComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
StateSelectorInputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StateSelectorInputComponent, selectors: [["vnext-state-selector-input"]], viewQuery: function StateSelectorInputComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3D, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.stateAbbrevItems = _t);
    } }, inputs: { control: "control", formSubmitted: "formSubmitted", height: "height", controlValue: "controlValue", isReadOnly: "isReadOnly", customClass: "customClass", ariaLabelledById: "ariaLabelledById" }, outputs: { onStateSelect: "onStateSelect" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "position-relative no-translate-block", "ngbDropdown", "", 4, "ngIf"], ["ngbDropdown", "", 1, "position-relative", "no-translate-block"], ["dropdownInstance", "ngbDropdown"], ["selectDropdownByCharacter", "", "type", "text", "tabindex", "0", "autocomplete", "new-text", "ngbDropdownToggle", "", "placeholder", "", 3, "ngStyle", "ngClass", "dropdownValues", "dropdownLastSelection", "dropdownInstance", "closeDropdownOnKeyup", "disabled", "ngModel", "ngModelChange", "valueSelectedByCharacter", "keydown"], ["class", "fas fa-angle-down icon-in-input can-click float-right", "ngbDropdownToggle", "", 4, "ngIf"], [1, "sr-only"], ["ngbDropdownMenu", "", "class", "dropdown-menu", 4, "ngIf"], ["ngbDropdownToggle", "", 1, "fas", "fa-angle-down", "icon-in-input", "can-click", "float-right"], ["ngbDropdownMenu", "", 1, "dropdown-menu"], ["ngbDropdownItem", "", "class", "Spa_Style_Small_Font", 3, "id", "ngClass", "click", 4, "ngFor", "ngForOf"], ["ngbDropdownItem", "", 1, "Spa_Style_Small_Font", 3, "id", "ngClass", "click"], ["stateAbbrevItems", ""]], template: function StateSelectorInputComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, StateSelectorInputComponent_div_0_Template, 7, 20, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.control);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgStyle, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem, SelectDropdownByCharacterDirective], styles: [".button-container[_ngcontent-%COMP%]{max-width:84px}.icon-in-input[_ngcontent-%COMP%]{position:absolute;top:8px;left:calc(100% - 15px)}.dropdown-menu[_ngcontent-%COMP%]{max-height:300px;overflow-y:auto}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StateSelectorInputComponent, [{
        type: Component,
        args: [{ selector: 'vnext-state-selector-input', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"position-relative no-translate-block\" ngbDropdown #dropdownInstance=\"ngbDropdown\" *ngIf=\"control\">\r\n  <input\r\n    selectDropdownByCharacter\r\n    type=\"text\"\r\n    tabindex=\"0\"\r\n    autocomplete=\"new-text\"\r\n    ngbDropdownToggle\r\n    placeholder=\"\"\r\n    class=\"{{ customClass }}\"\r\n    [attr.aria-labelledby]=\"ariaLabelledById\"\r\n    [ngStyle]=\"{ height: height }\"\r\n    [ngClass]=\"{\r\n      'has-error': control.errors && formSubmitted,\r\n      'form-control can-click': !isReadOnly,\r\n      'Spa_Style_Gray4_Color readonly': isReadOnly\r\n    }\"\r\n    [dropdownValues]=\"dropdownItems\"\r\n    [dropdownLastSelection]=\"getStateByAbbreviation(selectedStateAbbrev)\"\r\n    [dropdownInstance]=\"dropdownInstance\"\r\n    [closeDropdownOnKeyup]=\"false\"\r\n    [disabled]=\"isReadOnly\"\r\n    [(ngModel)]=\"selectedStateAbbrev\"\r\n    (valueSelectedByCharacter)=\"selectState($event)\"\r\n    (keydown)=\"onDropdownToggleKeyDown($event)\"\r\n  />\r\n  <i class=\"fas fa-angle-down icon-in-input can-click float-right\" ngbDropdownToggle *ngIf=\"!isReadOnly\"></i>\r\n  <span class=\"sr-only\">Expand menu</span>\r\n  <div ngbDropdownMenu class=\"dropdown-menu\" *ngIf=\"!isReadOnly\">\r\n    <div\r\n      *ngFor=\"let state of dropdownItems\"\r\n      (click)=\"selectState(state.selectionValue)\"\r\n      ngbDropdownItem\r\n      #stateAbbrevItems\r\n      id=\"{{ STATE_ABBREV_ID_PREFIX + state.selectionValue.StateAbbrev }}\"\r\n      class=\"Spa_Style_Small_Font\"\r\n      [ngClass]=\"{ Spa_Style_Gray1_Background: state.selectionValue.StateAbbrev === selectedStateAbbrev }\"\r\n    >\r\n      {{ state.displayValue }}\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".button-container{max-width:84px}.icon-in-input{position:absolute;top:8px;left:calc(100% - 15px)}.dropdown-menu{max-height:300px;overflow-y:auto}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { control: [{
            type: Input
        }], formSubmitted: [{
            type: Input
        }], height: [{
            type: Input
        }], controlValue: [{
            type: Input
        }], isReadOnly: [{
            type: Input
        }], stateAbbrevItems: [{
            type: ViewChildren,
            args: ['stateAbbrevItems']
        }], customClass: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], onStateSelect: [{
            type: Output
        }] }); })();

const _c0$3C = ["tooltip"];
const _c1$1V = function (a0) { return { "text-underline": a0 }; };
function LearnMoreTooltipComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2, 3);
    i0.ɵɵlistener("shown", function LearnMoreTooltipComponent_button_0_Template_button_shown_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.trackSNPExtraHelpToolTipEvent()); });
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngbTooltip", _r1)("placement", ctx_r0.tooltipPlacement)("triggers", ctx_r0.triggers)("autoClose", ctx_r0.autoClose)("tooltipClass", ctx_r0.tooltipCustomClass);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1$1V, ctx_r0.underlineTooltipButton));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.tooltipLabelText);
} }
function LearnMoreTooltipComponent_ng_template_1_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function LearnMoreTooltipComponent_ng_template_1_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.tooltip.close()); });
    i0.ɵɵelementEnd();
} }
function LearnMoreTooltipComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, LearnMoreTooltipComponent_ng_template_1_button_0_Template, 1, 0, "button", 5);
    i0.ɵɵelementStart(1, "div", 6)(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.isMobile && ctx_r2.showTooltipCloseButton);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.tooltipContent);
} }
class LearnMoreTooltipComponent {
    constructor(analyticsService) {
        this.analyticsService = analyticsService;
        this.isMobile = false;
        this.autoClose = true;
        this.underlineTooltipButton = false;
        this.showTooltipCloseButton = true;
    }
    trackSNPExtraHelpToolTipEvent() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_SNP_PLAN_EXTRA_HELP_TOOLTIP_EVENT);
    }
}
LearnMoreTooltipComponent.ɵfac = function LearnMoreTooltipComponent_Factory(t) { return new (t || LearnMoreTooltipComponent)(i0.ɵɵdirectiveInject(AnalyticsService)); };
LearnMoreTooltipComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LearnMoreTooltipComponent, selectors: [["vnext-learn-more-tooltip"]], viewQuery: function LearnMoreTooltipComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3C, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltip = _t.first);
    } }, inputs: { isMobile: "isMobile", tooltipContent: "tooltipContent", tooltipLabelText: "tooltipLabelText", tooltipCustomClass: "tooltipCustomClass", tooltipPlacement: "tooltipPlacement", triggers: "triggers", autoClose: "autoClose", underlineTooltipButton: "underlineTooltipButton", showTooltipCloseButton: "showTooltipCloseButton" }, decls: 3, vars: 1, consts: [["class", "d-inline action-button Spa_Style_Primary_Link_Color", "container", "body", 3, "ngbTooltip", "placement", "triggers", "autoClose", "tooltipClass", "shown", 4, "ngIf"], ["learnMoreTooltip", ""], ["container", "body", 1, "d-inline", "action-button", "Spa_Style_Primary_Link_Color", 3, "ngbTooltip", "placement", "triggers", "autoClose", "tooltipClass", "shown"], ["tooltip", "ngbTooltip"], [3, "ngClass"], ["class", "btn close Spa_Style_Small_Font fa fa-times Spa_Style_Primary_Color", "type", "button", "aria-label", "Close", 3, "click", 4, "ngIf"], [1, "Spa_Style_ToolTip"], ["type", "button", "aria-label", "Close", 1, "btn", "close", "Spa_Style_Small_Font", "fa", "fa-times", "Spa_Style_Primary_Color", 3, "click"]], template: function LearnMoreTooltipComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LearnMoreTooltipComponent_button_0_Template, 4, 9, "button", 0);
        i0.ɵɵtemplate(1, LearnMoreTooltipComponent_ng_template_1_Template, 4, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.tooltipLabelText && ctx.tooltipContent);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$1.NgbTooltip], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LearnMoreTooltipComponent, [{
        type: Component,
        args: [{ selector: 'vnext-learn-more-tooltip', changeDetection: ChangeDetectionStrategy.OnPush, template: "<button\r\n  *ngIf=\"tooltipLabelText && tooltipContent\"\r\n  class=\"d-inline action-button Spa_Style_Primary_Link_Color\"\r\n  [ngbTooltip]=\"learnMoreTooltip\"\r\n  [placement]=\"tooltipPlacement\"\r\n  [triggers]=\"triggers\"\r\n  [autoClose]=\"autoClose\"\r\n  container=\"body\"\r\n  [tooltipClass]=\"tooltipCustomClass\"\r\n  #tooltip=\"ngbTooltip\"\r\n  (shown)=\"trackSNPExtraHelpToolTipEvent()\"\r\n>\r\n  <span [ngClass]=\"{ 'text-underline': underlineTooltipButton }\">{{ tooltipLabelText }}</span>\r\n</button>\r\n<ng-template #learnMoreTooltip>\r\n  <button\r\n    *ngIf=\"isMobile && showTooltipCloseButton\"\r\n    class=\"btn close Spa_Style_Small_Font fa fa-times Spa_Style_Primary_Color\"\r\n    type=\"button\"\r\n    (click)=\"tooltip.close()\"\r\n    aria-label=\"Close\"\r\n  ></button>\r\n  <div class=\"Spa_Style_ToolTip\">\r\n    <div>{{ tooltipContent }}</div>\r\n  </div>\r\n</ng-template>\r\n" }]
    }], function () { return [{ type: AnalyticsService }]; }, { tooltip: [{
            type: ViewChild,
            args: ['tooltip']
        }], isMobile: [{
            type: Input
        }], tooltipContent: [{
            type: Input
        }], tooltipLabelText: [{
            type: Input
        }], tooltipCustomClass: [{
            type: Input
        }], tooltipPlacement: [{
            type: Input
        }], triggers: [{
            type: Input
        }], autoClose: [{
            type: Input
        }], underlineTooltipButton: [{
            type: Input
        }], showTooltipCloseButton: [{
            type: Input
        }] }); })();

var SpinnerSize;
(function (SpinnerSize) {
    SpinnerSize["SMALL"] = "la-sm";
    SpinnerSize["DEFAULT"] = "default";
    SpinnerSize["DOUBLE"] = "la-2x";
    SpinnerSize["TRIPLE"] = "la-3x";
})(SpinnerSize || (SpinnerSize = {}));

class SpinnerComponent {
    constructor() {
        this.size = SpinnerSize.DEFAULT;
    }
}
SpinnerComponent.ɵfac = function SpinnerComponent_Factory(t) { return new (t || SpinnerComponent)(); };
SpinnerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SpinnerComponent, selectors: [["vnext-spinner"]], inputs: { size: "size" }, decls: 9, vars: 2, template: function SpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵelement(1, "div")(2, "div")(3, "div")(4, "div")(5, "div")(6, "div")(7, "div")(8, "div");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassMap("la-ball-spin-clockwise " + ctx.size);
    } }, styles: [".la-ball-spin-clockwise[_ngcontent-%COMP%], .la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{position:relative;box-sizing:border-box}.la-ball-spin-clockwise[_ngcontent-%COMP%]{display:block;font-size:0;color:#666}.la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:inline-block;float:none;background-color:currentColor;border:0 solid currentColor}.la-ball-spin-clockwise[_ngcontent-%COMP%]{width:32px;height:32px}.la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;width:8px;height:8px;margin-top:-4px;margin-left:-4px;border-radius:100%;animation:_ngcontent-%COMP%_ball-spin-clockwise 1s infinite ease-in-out}.la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(1){top:5%;left:50%;animation-delay:-.875s}.la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(2){top:18.1801948466%;left:81.8198051534%;animation-delay:-.75s}.la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(3){top:50%;left:95%;animation-delay:-.625s}.la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(4){top:81.8198051534%;left:81.8198051534%;animation-delay:-.5s}.la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(5){top:94.9999999966%;left:50.0000000005%;animation-delay:-.375s}.la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(6){top:81.8198046966%;left:18.1801949248%;animation-delay:-.25s}.la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(7){top:49.9999750815%;left:5.0000051215%;animation-delay:-.125s}.la-ball-spin-clockwise[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:nth-child(8){top:18.179464974%;left:18.1803700518%;animation-delay:0s}.la-ball-spin-clockwise.la-sm[_ngcontent-%COMP%]{width:16px;height:16px}.la-ball-spin-clockwise.la-sm[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:4px;height:4px;margin-top:-2px;margin-left:-2px}.la-ball-spin-clockwise.la-2x[_ngcontent-%COMP%]{width:64px;height:64px}.la-ball-spin-clockwise.la-2x[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:16px;height:16px;margin-top:-8px;margin-left:-8px}.la-ball-spin-clockwise.la-3x[_ngcontent-%COMP%]{width:96px;height:96px}.la-ball-spin-clockwise.la-3x[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:24px;height:24px;margin-top:-12px;margin-left:-12px}@keyframes _ngcontent-%COMP%_ball-spin-clockwise{0%,to{opacity:1;transform:scale(1)}20%{opacity:1}80%{opacity:0;transform:scale(0)}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpinnerComponent, [{
        type: Component,
        args: [{ selector: 'vnext-spinner', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div [class]=\"'la-ball-spin-clockwise ' + size\">\r\n  <div></div>\r\n  <div></div>\r\n  <div></div>\r\n  <div></div>\r\n  <div></div>\r\n  <div></div>\r\n  <div></div>\r\n  <div></div>\r\n</div>\r\n", styles: ["/*!\n * Load Awesome v1.1.0 (http://github.danielcardoso.net/load-awesome/)\n * Copyright 2015 Daniel Cardoso <@DanielCardoso>\n * Licensed under MIT\n */.la-ball-spin-clockwise,.la-ball-spin-clockwise>div{position:relative;box-sizing:border-box}.la-ball-spin-clockwise{display:block;font-size:0;color:#666}.la-ball-spin-clockwise>div{display:inline-block;float:none;background-color:currentColor;border:0 solid currentColor}.la-ball-spin-clockwise{width:32px;height:32px}.la-ball-spin-clockwise>div{position:absolute;top:50%;left:50%;width:8px;height:8px;margin-top:-4px;margin-left:-4px;border-radius:100%;animation:ball-spin-clockwise 1s infinite ease-in-out}.la-ball-spin-clockwise>div:nth-child(1){top:5%;left:50%;animation-delay:-.875s}.la-ball-spin-clockwise>div:nth-child(2){top:18.1801948466%;left:81.8198051534%;animation-delay:-.75s}.la-ball-spin-clockwise>div:nth-child(3){top:50%;left:95%;animation-delay:-.625s}.la-ball-spin-clockwise>div:nth-child(4){top:81.8198051534%;left:81.8198051534%;animation-delay:-.5s}.la-ball-spin-clockwise>div:nth-child(5){top:94.9999999966%;left:50.0000000005%;animation-delay:-.375s}.la-ball-spin-clockwise>div:nth-child(6){top:81.8198046966%;left:18.1801949248%;animation-delay:-.25s}.la-ball-spin-clockwise>div:nth-child(7){top:49.9999750815%;left:5.0000051215%;animation-delay:-.125s}.la-ball-spin-clockwise>div:nth-child(8){top:18.179464974%;left:18.1803700518%;animation-delay:0s}.la-ball-spin-clockwise.la-sm{width:16px;height:16px}.la-ball-spin-clockwise.la-sm>div{width:4px;height:4px;margin-top:-2px;margin-left:-2px}.la-ball-spin-clockwise.la-2x{width:64px;height:64px}.la-ball-spin-clockwise.la-2x>div{width:16px;height:16px;margin-top:-8px;margin-left:-8px}.la-ball-spin-clockwise.la-3x{width:96px;height:96px}.la-ball-spin-clockwise.la-3x>div{width:24px;height:24px;margin-top:-12px;margin-left:-12px}@keyframes ball-spin-clockwise{0%,to{opacity:1;transform:scale(1)}20%{opacity:1}80%{opacity:0;transform:scale(0)}}\n"] }]
    }], null, { size: [{
            type: Input
        }] }); })();

function LoaderPlaceholderComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-spinner", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("size", ctx_r0.spinnerSize);
} }
function LoaderPlaceholderComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r2.loaderTextCustomClasses);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.loaderText, " ");
} }
class LoaderPlaceholderComponent {
    constructor() {
        this.loaderIconEnabled = false;
        this.spinnerSize = SpinnerSize.DEFAULT;
    }
}
LoaderPlaceholderComponent.ɵfac = function LoaderPlaceholderComponent_Factory(t) { return new (t || LoaderPlaceholderComponent)(); };
LoaderPlaceholderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LoaderPlaceholderComponent, selectors: [["vnext-loader-placeholder"]], inputs: { loaderIconEnabled: "loaderIconEnabled", loaderTextCustomClasses: "loaderTextCustomClasses", loaderText: "loaderText", spinnerSize: "spinnerSize" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["textPlaceholder", ""], [3, "size"], [3, "ngClass"]], template: function LoaderPlaceholderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LoaderPlaceholderComponent_div_0_Template, 2, 1, "div", 0);
        i0.ɵɵtemplate(1, LoaderPlaceholderComponent_ng_template_1_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.loaderIconEnabled)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, SpinnerComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoaderPlaceholderComponent, [{
        type: Component,
        args: [{ selector: 'vnext-loader-placeholder', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"loaderIconEnabled; else textPlaceholder\">\r\n  <vnext-spinner [size]=\"spinnerSize\"></vnext-spinner>\r\n</div>\r\n\r\n<ng-template #textPlaceholder>\r\n  <div [ngClass]=\"loaderTextCustomClasses\">\r\n    {{ loaderText }}\r\n  </div>\r\n</ng-template>\r\n" }]
    }], null, { loaderIconEnabled: [{
            type: Input
        }], loaderTextCustomClasses: [{
            type: Input
        }], loaderText: [{
            type: Input
        }], spinnerSize: [{
            type: Input
        }] }); })();

function AgentNoteModalComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "i", 11);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.errorText);
} }
const _c0$3B = function (a0) { return { "mr-auto": a0 }; };
class AgentNoteModalComponent {
    constructor(activeModal, store) {
        this.activeModal = activeModal;
        this.store = store;
        this.showError = false;
        this.captureText = '';
    }
    ngOnInit() {
        this.createAgentNote = new UntypedFormGroup({
            noteText: new UntypedFormControl('', [Validators.required])
        }, { updateOn: 'blur' });
    }
    cancel() {
        this.activeModal.dismiss();
        if (this.cancelAction) {
            this.cancelAction();
        }
    }
    confirm() {
        if (this.createAgentNote.valid) {
            const memberAgentNotes = {
                userAgentGUID: this.store.selectSnapshot(AgentState.agentGuid),
                agentNoteActionType: NoteActionType.Note,
                description: this.createAgentNote.value.noteText,
                memberAgentNoteID: '',
                agentName: '',
                scheduledDate: '',
                completedWhen: '',
                createdWhen: '',
                modifiedWhen: ''
            };
            this.activeModal.close(memberAgentNotes);
        }
        else {
            this.showError = true;
        }
    }
}
AgentNoteModalComponent.ɵfac = function AgentNoteModalComponent_Factory(t) { return new (t || AgentNoteModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i2.Store)); };
AgentNoteModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentNoteModalComponent, selectors: [["ng-component"]], inputs: { captureText: "captureText" }, decls: 14, vars: 11, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [3, "formGroup"], [1, "form-group", "modal-body"], [1, "input-error-asterisk"], ["rows", "5", "cols", "40", "placeholder", "text", "for", "textContent", 1, "Spa_Style_Label"], ["class", "error-container", 4, "ngIf"], ["ngbAutofocus", "", "id", "textContent", "type", "text", "rows", "4", "maxlength", "450", "tabindex", "0", "required", "", "formControlName", "noteText", 1, "md-textarea", "form-control", 3, "placeholder", "value"], [1, "modal-footer", "justify-content-start"], ["type", "button", "tabindex", "0", 1, "btn", "Spa_Style_SecondaryButton", 3, "ngClass", "click", "keyup.enter"], ["type", "button", "tabindex", "0", 1, "btn", "Spa_Style_PrimaryButton", 3, "keyup.enter", "click"], [1, "error-container"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"]], template: function AgentNoteModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function AgentNoteModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.cancel(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "form", 1)(2, "div", 2)(3, "span", 3);
        i0.ɵɵtext(4, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "label", 4);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, AgentNoteModalComponent_div_7_Template, 4, 1, "div", 5);
        i0.ɵɵelement(8, "textarea", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 7)(10, "button", 8);
        i0.ɵɵlistener("click", function AgentNoteModalComponent_Template_button_click_10_listener() { return ctx.cancel(); })("keyup.enter", function AgentNoteModalComponent_Template_button_keyup_enter_10_listener() { return ctx.cancel(); });
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 9);
        i0.ɵɵlistener("keyup.enter", function AgentNoteModalComponent_Template_button_keyup_enter_12_listener() { return ctx.confirm(); })("click", function AgentNoteModalComponent_Template_button_click_12_listener() { return ctx.confirm(); });
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.createAgentNote);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.sectionHeader);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showError);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("placeholder", ctx.agentNotePlaceholderText);
        i0.ɵɵproperty("value", ctx.captureText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0$3B, ctx.confirmButton));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.cancelButton, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.confirmButton, " ");
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.RequiredValidator, i4.MaxLengthValidator, i4.FormGroupDirective, i4.FormControlName, IconAriaAttributesDirective, ModalHeaderComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentNoteModalComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"cancel()\"></vnext-widget-modal-header>\r\n\r\n<form [formGroup]=\"createAgentNote\">\r\n  <div class=\"form-group modal-body\">\r\n    <span class=\"input-error-asterisk\">*</span>\r\n    <label class=\"Spa_Style_Label\" rows=\"5\" cols=\"40\" placeholder=\"text\" for=\"textContent\">{{ sectionHeader }}</label>\r\n    <div class=\"error-container\" *ngIf=\"showError\">\r\n      <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n      <span>{{ errorText }}</span>\r\n    </div>\r\n    <textarea\r\n      ngbAutofocus\r\n      id=\"textContent\"\r\n      type=\"text\"\r\n      rows=\"4\"\r\n      maxlength=\"450\"\r\n      tabindex=\"0\"\r\n      required\r\n      formControlName=\"noteText\"\r\n      placeholder=\"{{ agentNotePlaceholderText }}\"\r\n      class=\"md-textarea form-control\"\r\n      [value]=\"captureText\"\r\n    ></textarea>\r\n  </div>\r\n  <div class=\"modal-footer justify-content-start\">\r\n    <button\r\n      type=\"button\"\r\n      [ngClass]=\"{ 'mr-auto': confirmButton }\"\r\n      class=\"btn Spa_Style_SecondaryButton\"\r\n      tabindex=\"0\"\r\n      (click)=\"cancel()\"\r\n      (keyup.enter)=\"cancel()\"\r\n    >\r\n      {{ cancelButton }}\r\n    </button>\r\n    <button type=\"button\" (keyup.enter)=\"confirm()\" (click)=\"confirm()\" tabindex=\"0\" class=\"btn Spa_Style_PrimaryButton\">\r\n      {{ confirmButton }}\r\n    </button>\r\n  </div>\r\n</form>\r\n" }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i2.Store }]; }, { captureText: [{
            type: Input
        }] }); })();

function AgentOfRecordModalResultsComponent_ng_container_0_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 10)(2, "label", 11)(3, "div", 12)(4, "input", 13);
    i0.ɵɵlistener("change", function AgentOfRecordModalResultsComponent_ng_container_0_div_6_Template_input_change_4_listener() { const restoredCtx = i0.ɵɵrestoreView(_r6); const agent_r4 = restoredCtx.$implicit; const ctx_r5 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r5.updateSelectedAgentGuid.emit(agent_r4.userId)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 14)(6, "div", 15);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 16);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const agent_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", agent_r4.userId);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", agent_r4.userId);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", agent_r4.firstName, " ", agent_r4.lastName, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(agent_r4.userName);
} }
function AgentOfRecordModalResultsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "h3", 3);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 4);
    i0.ɵɵtemplate(6, AgentOfRecordModalResultsComponent_ng_container_0_div_6_Template, 10, 5, "div", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 6)(8, "span", 7);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "vnext-link", 8);
    i0.ɵɵlistener("click", function AgentOfRecordModalResultsComponent_ng_container_0_Template_vnext_link_click_10_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.resetToSearchView.emit()); })("keyup.Enter", function AgentOfRecordModalResultsComponent_ng_container_0_Template_vnext_link_keyup_Enter_10_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.resetToSearchView.emit()); });
    i0.ɵɵelementStart(11, "span", 9);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.confirmSelectionText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.selectAgentText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.searchResults);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.orText, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("makeInlineBlock", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.searchAgainLinkText);
} }
function AgentOfRecordModalResultsComponent_ng_template_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 20);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 1, ctx_r10.timeoutMessageText, "html"), i0.ɵɵsanitizeHtml);
} }
function AgentOfRecordModalResultsComponent_ng_template_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r12.noSearchResultsText);
} }
function AgentOfRecordModalResultsComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtemplate(1, AgentOfRecordModalResultsComponent_ng_template_1_ng_container_1_Template, 3, 4, "ng-container", 0);
    i0.ɵɵtemplate(2, AgentOfRecordModalResultsComponent_ng_template_1_ng_template_2_Template, 2, 1, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(4, "button", 19);
    i0.ɵɵlistener("click", function AgentOfRecordModalResultsComponent_ng_template_1_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.resetToSearchView.emit()); })("keyup.Enter", function AgentOfRecordModalResultsComponent_ng_template_1_Template_button_keyup_Enter_4_listener() { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.resetToSearchView.emit()); });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r11 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.timeoutMessageEnabled)("ngIfElse", _r11);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.searchAgainButtonText, " ");
} }
class AgentOfRecordModalResultsComponent {
    constructor() {
        this.updateSelectedAgentGuid = new EventEmitter();
        this.resetToSearchView = new EventEmitter();
        this.closeModal = new EventEmitter();
    }
}
AgentOfRecordModalResultsComponent.ɵfac = function AgentOfRecordModalResultsComponent_Factory(t) { return new (t || AgentOfRecordModalResultsComponent)(); };
AgentOfRecordModalResultsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentOfRecordModalResultsComponent, selectors: [["vnext-agent-of-record-modal-results"]], inputs: { confirmSelectionText: "confirmSelectionText", selectAgentText: "selectAgentText", orText: "orText", searchAgainLinkText: "searchAgainLinkText", cancelButtonText: "cancelButtonText", continueButtonText: "continueButtonText", searchResults: "searchResults", timeoutMessageText: "timeoutMessageText", searchAgainButtonText: "searchAgainButtonText", timeoutMessageEnabled: "timeoutMessageEnabled", noSearchResultsText: "noSearchResultsText" }, outputs: { updateSelectedAgentGuid: "updateSelectedAgentGuid", resetToSearchView: "resetToSearchView", closeModal: "closeModal" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["showNoResult", ""], [1, "Spa_Style_Primary_Color", "pb-4"], [1, "Spa_Style_Primary_Color", "Spa_Style_Larger_Font", "pb-4"], [1, "agent-search-results"], [4, "ngFor", "ngForOf"], [1, "search-again-text", "text-center", "pb-4"], [1, "mr-1", "d-inline-block"], [1, "Spa_Style_Small_Font", "Spa_Style_Paragraph", 3, "makeInlineBlock", "click", "keyup.Enter"], ["link-body", ""], [1, "agent-result-card"], [1, "d-flex", 3, "for"], [1, "col-1", "pl-0"], ["type", "radio", "name", "group", 1, "radio-button", 3, "id", "change"], [1, "agent-result-details", "col-11", "Spa_Style_Primary_Color", "Spa_Style_Paragraph", "no-translate-block"], [1, "agent-name"], [1, "agent-username"], [1, "text-center"], ["showNoResultText", ""], ["type", "button", 1, "btn", "Spa_Style_PrimaryButton", "mt-4", 3, "click", "keyup.Enter"], [1, "Spa_Style_Primary_Color", "Spa_Style_Paragraph", 3, "innerHTML"], [1, "Spa_Style_Primary_Color", "Spa_Style_Paragraph"]], template: function AgentOfRecordModalResultsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, AgentOfRecordModalResultsComponent_ng_container_0_Template, 13, 6, "ng-container", 0);
        i0.ɵɵtemplate(1, AgentOfRecordModalResultsComponent_ng_template_1_Template, 6, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.searchResults == null ? null : ctx.searchResults.length)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, LinkComponent, SafePipe], styles: [".radio-button[_ngcontent-%COMP%]{height:100%}.agent-result-details[_ngcontent-%COMP%]{border:2px solid var(--static-Spa_Style_Gray2);border-radius:5px;padding:10px}.agent-search-results[_ngcontent-%COMP%]{max-height:145px;overflow-y:auto}label[_ngcontent-%COMP%], input[_ngcontent-%COMP%]{cursor:pointer}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentOfRecordModalResultsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-of-record-modal-results', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"searchResults?.length; else showNoResult\">\r\n  <div class=\"Spa_Style_Primary_Color pb-4\">{{ confirmSelectionText }}</div>\r\n  <h3 class=\"Spa_Style_Primary_Color Spa_Style_Larger_Font pb-4\">{{ selectAgentText }}</h3>\r\n  <div class=\"agent-search-results\">\r\n    <div *ngFor=\"let agent of searchResults\">\r\n      <div class=\"agent-result-card\">\r\n        <label class=\"d-flex\" [for]=\"agent.userId\">\r\n          <div class=\"col-1 pl-0\">\r\n            <input\r\n              class=\"radio-button\"\r\n              type=\"radio\"\r\n              name=\"group\"\r\n              [id]=\"agent.userId\"\r\n              (change)=\"updateSelectedAgentGuid.emit(agent.userId)\"\r\n            />\r\n          </div>\r\n          <div class=\"agent-result-details col-11 Spa_Style_Primary_Color Spa_Style_Paragraph no-translate-block\">\r\n            <div class=\"agent-name\">{{ agent.firstName }} {{ agent.lastName }}</div>\r\n            <div class=\"agent-username\">{{ agent.userName }}</div>\r\n          </div>\r\n        </label>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"search-again-text text-center pb-4\">\r\n    <span class=\"mr-1 d-inline-block\"> {{ orText }}</span>\r\n    <vnext-link\r\n      class=\"Spa_Style_Small_Font Spa_Style_Paragraph\"\r\n      (click)=\"resetToSearchView.emit()\"\r\n      (keyup.Enter)=\"resetToSearchView.emit()\"\r\n      [makeInlineBlock]=\"true\"\r\n      ><span link-body>{{ searchAgainLinkText }}</span>\r\n    </vnext-link>\r\n  </div>\r\n</ng-container>\r\n<ng-template #showNoResult>\r\n  <div class=\"text-center\">\r\n    <ng-container *ngIf=\"timeoutMessageEnabled; else showNoResultText\">\r\n      <div class=\"Spa_Style_Primary_Color Spa_Style_Paragraph\" [innerHTML]=\"timeoutMessageText | safe : 'html'\"></div>\r\n    </ng-container>\r\n    <ng-template #showNoResultText>\r\n      <div class=\"Spa_Style_Primary_Color Spa_Style_Paragraph\">{{ noSearchResultsText }}</div>\r\n    </ng-template>\r\n    <button\r\n      type=\"button\"\r\n      class=\"btn Spa_Style_PrimaryButton mt-4\"\r\n      (click)=\"resetToSearchView.emit()\"\r\n      (keyup.Enter)=\"resetToSearchView.emit()\"\r\n    >\r\n      {{ searchAgainButtonText }}\r\n    </button>\r\n  </div>\r\n</ng-template>\r\n", styles: [".radio-button{height:100%}.agent-result-details{border:2px solid var(--static-Spa_Style_Gray2);border-radius:5px;padding:10px}.agent-search-results{max-height:145px;overflow-y:auto}label,input{cursor:pointer}\n"] }]
    }], null, { confirmSelectionText: [{
            type: Input
        }], selectAgentText: [{
            type: Input
        }], orText: [{
            type: Input
        }], searchAgainLinkText: [{
            type: Input
        }], cancelButtonText: [{
            type: Input
        }], continueButtonText: [{
            type: Input
        }], searchResults: [{
            type: Input
        }], timeoutMessageText: [{
            type: Input
        }], searchAgainButtonText: [{
            type: Input
        }], timeoutMessageEnabled: [{
            type: Input
        }], noSearchResultsText: [{
            type: Input
        }], updateSelectedAgentGuid: [{
            type: Output
        }], resetToSearchView: [{
            type: Output
        }], closeModal: [{
            type: Output
        }] }); })();

function AgentOfRecordModalSearchComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "i", 13);
    i0.ɵɵelementStart(2, "span", 14);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.firstNameErrorText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.firstNameErrorText, " ");
} }
function AgentOfRecordModalSearchComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "i", 13);
    i0.ɵɵelementStart(2, "span", 14);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.lastNameErrorText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.lastNameErrorText, " ");
} }
function AgentOfRecordModalSearchComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "i", 13);
    i0.ɵɵelementStart(2, "span", 14);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.userNameErrorText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.userNameErrorText, " ");
} }
const _c0$3A = function (a0) { return { "has-error": a0 }; };
class AgentOfRecordModalSearchComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.submitForm = new EventEmitter();
        this.firstNameFieldName = 'firstName';
        this.lastNameFieldName = 'lastName';
        this.userNameFieldName = 'userName';
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.firstNameControl = this.reassignAgentForm.controls[this.firstNameFieldName];
        this.lastNameControl = this.reassignAgentForm.controls[this.lastNameFieldName];
        this.userNameControl = this.reassignAgentForm.controls[this.userNameFieldName];
        this.subscriptions.add(combineLatest([this.reassignAgentForm.valueChanges, this.reassignAgentForm.statusChanges]).subscribe((result) => {
            this.updateFormErrors();
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    updateFormErrors() {
        Object.keys(this.reassignAgentForm.controls).forEach(name => {
            if (this.reassignAgentForm.controls[name].hasError) {
                this.updateErrorText(name);
            }
        });
        this.cdr.markForCheck();
    }
    updateErrorText(controlName) {
        const errors = this.reassignAgentForm.controls[controlName].errors;
        let newError = '';
        if (errors?.required) {
            newError = this.errorMessages.required[controlName];
        }
        else if (errors?.minlength) {
            newError = this.errorMessages.minlength;
        }
        this[controlName + 'ErrorText'] = newError;
    }
}
AgentOfRecordModalSearchComponent.ɵfac = function AgentOfRecordModalSearchComponent_Factory(t) { return new (t || AgentOfRecordModalSearchComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
AgentOfRecordModalSearchComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentOfRecordModalSearchComponent, selectors: [["vnext-agent-of-record-modal-search"]], inputs: { introText: "introText", formTitleText: "formTitleText", firstNameLabelText: "firstNameLabelText", lastNameLabelText: "lastNameLabelText", userNameLabelText: "userNameLabelText", errorMessages: "errorMessages", reassignAgentForm: "reassignAgentForm" }, outputs: { submitForm: "submitForm" }, decls: 27, vars: 24, consts: [[1, "Spa_Style_Primary_Color", "Spa_Style_Smaller_Font", "pb-4"], [1, "Spa_Style_Primary_Color", "Spa_Style_Larger_Font", "pb-4"], [1, "reassign-form-wrapper", "row", "align-items-end", 3, "formGroup"], [1, "form-item", "col-12", "col-md-6", "pb-2"], ["class", "error-container mb-3 d-flex align-items-baseline has-error text-left Spa_Style_Small_Font", 4, "ngIf"], ["for", "firstName", 1, "Spa_Style_Bold_Weight", "Spa_Style_Small_Font", "text-left", 3, "ngClass"], [1, "input-error-asterisk"], ["id", "firstName", "type", "text", "formControlName", "firstName", 1, "form-control", 3, "maxlength", "ngClass", "keyup.Enter"], ["for", "lastName", 1, "Spa_Style_Bold_Weight", "Spa_Style_Small_Font", "text-left", 3, "ngClass"], ["id", "lastName", "type", "text", "formControlName", "lastName", 1, "form-control", 3, "maxlength", "ngClass", "keyup.Enter"], ["for", "userName", 1, "Spa_Style_Bold_Weight", "Spa_Style_Small_Font", "text-left", 3, "ngClass"], ["id", "userName", "type", "text", "formControlName", "userName", 1, "form-control", 3, "maxlength", "ngClass", "keyup.Enter"], [1, "error-container", "mb-3", "d-flex", "align-items-baseline", "has-error", "text-left", "Spa_Style_Small_Font"], [1, "fas", "fa-exclamation-circle"], [1, "sr-only"]], template: function AgentOfRecordModalSearchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "h3", 1);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "form", 2)(5, "div", 3);
        i0.ɵɵtemplate(6, AgentOfRecordModalSearchComponent_div_6_Template, 5, 2, "div", 4);
        i0.ɵɵelementStart(7, "label", 5)(8, "span", 6);
        i0.ɵɵtext(9, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "span");
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(12, "input", 7);
        i0.ɵɵlistener("keyup.Enter", function AgentOfRecordModalSearchComponent_Template_input_keyup_Enter_12_listener() { return ctx.submitForm.emit(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "div", 3);
        i0.ɵɵtemplate(14, AgentOfRecordModalSearchComponent_div_14_Template, 5, 2, "div", 4);
        i0.ɵɵelementStart(15, "label", 8)(16, "span", 6);
        i0.ɵɵtext(17, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "span");
        i0.ɵɵtext(19);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(20, "input", 9);
        i0.ɵɵlistener("keyup.Enter", function AgentOfRecordModalSearchComponent_Template_input_keyup_Enter_20_listener() { return ctx.submitForm.emit(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(21, "div", 3);
        i0.ɵɵtemplate(22, AgentOfRecordModalSearchComponent_div_22_Template, 5, 2, "div", 4);
        i0.ɵɵelementStart(23, "label", 10)(24, "span");
        i0.ɵɵtext(25);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(26, "input", 11);
        i0.ɵɵlistener("keyup.Enter", function AgentOfRecordModalSearchComponent_Template_input_keyup_Enter_26_listener() { return ctx.submitForm.emit(); });
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.introText);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.formTitleText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.reassignAgentForm);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.firstNameControl.invalid && ctx.firstNameControl.touched && ctx.firstNameErrorText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.firstNameControl.invalid && ctx.firstNameControl.touched && ctx.firstNameErrorText ? "error-color" : "Spa_Style_Primary_Color");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.firstNameLabelText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("maxlength", 100)("ngClass", i0.ɵɵpureFunction1(18, _c0$3A, ctx.firstNameControl.invalid && ctx.firstNameControl.touched && ctx.firstNameErrorText));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.lastNameControl.invalid && ctx.lastNameControl.touched && ctx.lastNameErrorText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.lastNameControl.invalid && ctx.lastNameControl.touched && ctx.lastNameErrorText ? "error-color" : "Spa_Style_Primary_Color");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.lastNameLabelText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("maxlength", 100)("ngClass", i0.ɵɵpureFunction1(20, _c0$3A, ctx.lastNameControl.invalid && ctx.lastNameControl.touched && ctx.firstNameErrorText));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.userNameControl.invalid && ctx.userNameControl.touched && ctx.userNameErrorText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.userNameControl.invalid && ctx.userNameControl.touched && ctx.userNameErrorText ? "error-color" : "Spa_Style_Primary_Color");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.userNameLabelText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("maxlength", 100)("ngClass", i0.ɵɵpureFunction1(22, _c0$3A, ctx.userNameControl.invalid && ctx.userNameControl.touched && ctx.userNameErrorText));
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.MaxLengthValidator, i4.FormGroupDirective, i4.FormControlName, IconAriaAttributesDirective], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentOfRecordModalSearchComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-of-record-modal-search', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"Spa_Style_Primary_Color Spa_Style_Smaller_Font pb-4\">{{ introText }}</div>\r\n<h3 class=\"Spa_Style_Primary_Color Spa_Style_Larger_Font pb-4\">{{ formTitleText }}</h3>\r\n<form class=\"reassign-form-wrapper row align-items-end\" [formGroup]=\"reassignAgentForm\">\r\n  <div class=\"form-item col-12 col-md-6 pb-2\">\r\n    <div\r\n      *ngIf=\"firstNameControl.invalid && firstNameControl.touched && firstNameErrorText\"\r\n      class=\"error-container mb-3 d-flex align-items-baseline has-error text-left Spa_Style_Small_Font\"\r\n    >\r\n      <i class=\"fas fa-exclamation-circle\"></i>\r\n      <span class=\"sr-only\">{{ firstNameErrorText }}</span>\r\n      {{ firstNameErrorText }}\r\n    </div>\r\n    <label\r\n      class=\"Spa_Style_Bold_Weight Spa_Style_Small_Font text-left\"\r\n      for=\"firstName\"\r\n      [ngClass]=\"firstNameControl.invalid && firstNameControl.touched && firstNameErrorText ? 'error-color' : 'Spa_Style_Primary_Color'\"\r\n    >\r\n      <span class=\"input-error-asterisk\">*</span><span>{{ firstNameLabelText }}</span>\r\n    </label>\r\n    <input\r\n      id=\"firstName\"\r\n      type=\"text\"\r\n      class=\"form-control\"\r\n      formControlName=\"firstName\"\r\n      [maxlength]=\"100\"\r\n      [ngClass]=\"{\r\n        'has-error': firstNameControl.invalid && firstNameControl.touched && firstNameErrorText\r\n      }\"\r\n      (keyup.Enter)=\"submitForm.emit()\"\r\n    />\r\n  </div>\r\n\r\n  <div class=\"form-item col-12 col-md-6 pb-2\">\r\n    <div\r\n      *ngIf=\"lastNameControl.invalid && lastNameControl.touched && lastNameErrorText\"\r\n      class=\"error-container mb-3 d-flex align-items-baseline has-error text-left Spa_Style_Small_Font\"\r\n    >\r\n      <i class=\"fas fa-exclamation-circle\"></i>\r\n      <span class=\"sr-only\">{{ lastNameErrorText }}</span>\r\n      {{ lastNameErrorText }}\r\n    </div>\r\n    <label\r\n      class=\"Spa_Style_Bold_Weight Spa_Style_Small_Font text-left\"\r\n      for=\"lastName\"\r\n      [ngClass]=\"lastNameControl.invalid && lastNameControl.touched && lastNameErrorText ? 'error-color' : 'Spa_Style_Primary_Color'\"\r\n    >\r\n      <span class=\"input-error-asterisk\">*</span><span>{{ lastNameLabelText }}</span>\r\n    </label>\r\n    <input\r\n      id=\"lastName\"\r\n      type=\"text\"\r\n      class=\"form-control\"\r\n      formControlName=\"lastName\"\r\n      [maxlength]=\"100\"\r\n      [ngClass]=\"{\r\n        'has-error': lastNameControl.invalid && lastNameControl.touched && firstNameErrorText\r\n      }\"\r\n      (keyup.Enter)=\"submitForm.emit()\"\r\n    />\r\n  </div>\r\n\r\n  <div class=\"form-item col-12 col-md-6 pb-2\">\r\n    <div\r\n      *ngIf=\"userNameControl.invalid && userNameControl.touched && userNameErrorText\"\r\n      class=\"error-container mb-3 d-flex align-items-baseline has-error text-left Spa_Style_Small_Font\"\r\n    >\r\n      <i class=\"fas fa-exclamation-circle\"></i>\r\n      <span class=\"sr-only\">{{ userNameErrorText }}</span>\r\n      {{ userNameErrorText }}\r\n    </div>\r\n    <label\r\n      class=\"Spa_Style_Bold_Weight Spa_Style_Small_Font text-left\"\r\n      for=\"userName\"\r\n      [ngClass]=\"userNameControl.invalid && userNameControl.touched && userNameErrorText ? 'error-color' : 'Spa_Style_Primary_Color'\"\r\n    >\r\n      <span>{{ userNameLabelText }}</span>\r\n    </label>\r\n    <input\r\n      id=\"userName\"\r\n      type=\"text\"\r\n      class=\"form-control\"\r\n      formControlName=\"userName\"\r\n      [maxlength]=\"100\"\r\n      [ngClass]=\"{\r\n        'has-error': userNameControl.invalid && userNameControl.touched && userNameErrorText\r\n      }\"\r\n      (keyup.Enter)=\"submitForm.emit()\"\r\n    />\r\n  </div>\r\n</form>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { introText: [{
            type: Input
        }], formTitleText: [{
            type: Input
        }], firstNameLabelText: [{
            type: Input
        }], lastNameLabelText: [{
            type: Input
        }], userNameLabelText: [{
            type: Input
        }], errorMessages: [{
            type: Input
        }], reassignAgentForm: [{
            type: Input
        }], submitForm: [{
            type: Output
        }] }); })();

class AgentOfRecordModalSuccessComponent {
    constructor() {
        this.closeModal = new EventEmitter();
    }
}
AgentOfRecordModalSuccessComponent.ɵfac = function AgentOfRecordModalSuccessComponent_Factory(t) { return new (t || AgentOfRecordModalSuccessComponent)(); };
AgentOfRecordModalSuccessComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentOfRecordModalSuccessComponent, selectors: [["vnext-agent-of-record-modal-success"]], inputs: { noticeText: "noticeText" }, outputs: { closeModal: "closeModal" }, decls: 1, vars: 2, consts: [[3, "type", "title"]], template: function AgentOfRecordModalSuccessComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "vnext-notice", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("type", "success")("title", ctx.noticeText);
    } }, dependencies: [NoticeComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentOfRecordModalSuccessComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-of-record-modal-success', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-notice [type]=\"'success'\" [title]=\"noticeText\"></vnext-notice>\r\n" }]
    }], null, { noticeText: [{
            type: Input
        }], closeModal: [{
            type: Output
        }] }); })();

class AgentNoteFacade {
    constructor(modalService, configResourceService, sessionService, store) {
        this.modalService = modalService;
        this.configResourceService = configResourceService;
        this.sessionService = sessionService;
        this.store = store;
    }
    showAgentNoteModal() {
        const modalTitle = this.configResourceService.getProcessedResourceValue('Spa_AgentNote_Title', null, 'Add note');
        const modalCancel = this.configResourceService.getProcessedResourceValue('Spa_AgentNote_Cancel_Button', null, 'Cancel');
        const modalSave = this.configResourceService.getProcessedResourceValue('Spa_AgentNote_Save_Button', null, 'Add note');
        const modalSectionHeader = this.configResourceService.getProcessedResourceValue('Spa_AgentNote_SectionHeader', null, 'Create a note');
        const modalPlaceholderText = this.configResourceService.getProcessedResourceValue('Spa_AgentNote_PlaceholderText', null, 'Create a note for this beneficiary');
        const modalErrorText = this.configResourceService.getProcessedResourceValue('Spa_AgentNote_ErrorText', null, 'Note is required');
        const agentNoteModal = this.modalService.open(AgentNoteModalComponent, { centered: true });
        agentNoteModal.componentInstance.title = modalTitle;
        agentNoteModal.componentInstance.cancelButton = modalCancel;
        agentNoteModal.componentInstance.confirmButton = modalSave;
        agentNoteModal.componentInstance.sectionHeader = modalSectionHeader;
        agentNoteModal.componentInstance.agentNotePlaceholderText = modalPlaceholderText;
        agentNoteModal.componentInstance.errorText = modalErrorText;
        agentNoteModal.result.then(memberAgentNotes => {
            if (memberAgentNotes) {
                this.addAgentNote(memberAgentNotes);
            }
        }, () => { });
    }
    async addAgentNote(memberAgentNotes) {
        return this.sessionService.addMemberNoteByAgent(memberAgentNotes);
    }
    getMemberAgentNotes$() {
        return this.store
            .select(MemberState.memberAgentNotes)
            .pipe(map(notes => notes.filter(note => note.agentNoteActionType === NoteActionType.Note)));
    }
    addSOAByEmailNote(email, agentName, userAgentGUID, timeStamp) {
        const date = DateUtilities.getFormattedCurrentDate();
        let description = this.configResourceService.getProcessedResourceValue('Spa_AgentNote_SoaNote_Text', null, `SOA sent to <email>`);
        description = description.replace('<email>', email);
        const note = {
            userAgentGUID,
            agentNoteActionType: NoteActionType.SOANote,
            description,
            agentName,
            createdWhen: timeStamp ? timeStamp : date
        };
        this.addAgentNote(note);
    }
    addSOAByTextNote(agentName, userAgentGUID, phoneNumber, timeStamp) {
        const date = DateUtilities.getFormattedCurrentDate();
        const description = this.getSOANoteDescription(phoneNumber);
        const note = {
            userAgentGUID,
            agentNoteActionType: NoteActionType.Note,
            description,
            agentName,
            createdWhen: timeStamp ? timeStamp : date
        };
        this.addAgentNote(note);
    }
    getSOANoteDescription(phoneNumber, widgetName) {
        const description = this.configResourceService.getProcessedResourceValue('Spa_SOA_AgentNote_Description_Text', widgetName, 'SOA sent to <phone>.');
        return description.replace('<phone>', this.getFormattedPhoneNumber(phoneNumber));
    }
    getFormattedPhoneNumber(phone) {
        return phone && phone.length === 10 ? `(${phone.substring(0, 3)}) ${phone.substring(3, 6)}-${phone.substring(6, 10)}` : '';
    }
}
AgentNoteFacade.ɵfac = function AgentNoteFacade_Factory(t) { return new (t || AgentNoteFacade)(i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(i2.Store)); };
AgentNoteFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentNoteFacade, factory: AgentNoteFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentNoteFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$1.NgbModal }, { type: i1.ConfigResourceService }, { type: i1.MemberSessionService }, { type: i2.Store }]; }, null); })();

function AgentOfRecordModalComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 11);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function AgentOfRecordModalComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 11);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(9);
    i0.ɵɵproperty("ngTemplateOutlet", _r5);
} }
function AgentOfRecordModalComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 11);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r7 = i0.ɵɵreference(11);
    i0.ɵɵproperty("ngTemplateOutlet", _r7);
} }
function AgentOfRecordModalComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-agent-of-record-modal-search", 12);
    i0.ɵɵlistener("submitForm", function AgentOfRecordModalComponent_ng_template_6_Template_vnext_agent_of_record_modal_search_submitForm_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.submitForm()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("introText", ctx_r4.introText)("formTitleText", ctx_r4.formTitleText)("firstNameLabelText", ctx_r4.firstNameLabelText)("lastNameLabelText", ctx_r4.lastNameLabelText)("userNameLabelText", ctx_r4.userNameLabelText)("errorMessages", ctx_r4.errorMessages)("reassignAgentForm", ctx_r4.reassignAgentForm);
} }
function AgentOfRecordModalComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-agent-of-record-modal-results", 13);
    i0.ɵɵlistener("updateSelectedAgentGuid", function AgentOfRecordModalComponent_ng_template_8_Template_vnext_agent_of_record_modal_results_updateSelectedAgentGuid_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.updateSelectedAgentGuid($event)); })("resetToSearchView", function AgentOfRecordModalComponent_ng_template_8_Template_vnext_agent_of_record_modal_results_resetToSearchView_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.resetToSearchView()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("confirmSelectionText", ctx_r6.confirmSelectionText)("selectAgentText", ctx_r6.selectAgentText)("orText", ctx_r6.orText)("searchAgainLinkText", ctx_r6.searchAgainLinkText)("timeoutMessageEnabled", ctx_r6.timeoutMessageEnabled)("noSearchResultsText", ctx_r6.noSearchResultsText)("searchAgainButtonText", ctx_r6.searchAgainButtonText)("timeoutMessageText", ctx_r6.timeoutMessageText)("searchResults", ctx_r6.searchResults);
} }
function AgentOfRecordModalComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-agent-of-record-modal-success", 14);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("noticeText", ctx_r8.noticeText);
} }
const _c0$3z = function (a0) { return { "col-6 m-0": a0 }; };
const _c1$1U = function (a0) { return { "w-100 mt-2": a0 }; };
const _c2$19 = function (a0) { return { "col-12 m-0": a0 }; };
const _c3$O = function (a0) { return { "w-100 mt-3": a0 }; };
function AgentOfRecordModalComponent_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 15)(2, "button", 9);
    i0.ɵɵlistener("click", function AgentOfRecordModalComponent_ng_container_16_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.assignToMe()); })("keyup.enter", function AgentOfRecordModalComponent_ng_container_16_Template_button_keyup_enter_2_listener() { i0.ɵɵrestoreView(_r17); const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.assignToMe()); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 15)(5, "button", 16);
    i0.ɵɵlistener("click", function AgentOfRecordModalComponent_ng_container_16_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r17); const ctx_r19 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r19.submitForm()); })("keyup.enter", function AgentOfRecordModalComponent_ng_container_16_Template_button_keyup_enter_5_listener() { i0.ɵɵrestoreView(_r17); const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.submitForm()); });
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$3z, ctx_r9.mobile));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c1$1U, ctx_r9.mobile));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.assignButtonText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c2$19, ctx_r9.mobile));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c3$O, ctx_r9.mobile));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.searchButtonText, " ");
} }
function AgentOfRecordModalComponent_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 15)(2, "button", 17);
    i0.ɵɵlistener("click", function AgentOfRecordModalComponent_ng_container_17_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r21.assignAgent()); })("keyup.enter", function AgentOfRecordModalComponent_ng_container_17_Template_button_keyup_enter_2_listener() { i0.ɵɵrestoreView(_r22); const ctx_r23 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r23.assignAgent()); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$3z, ctx_r10.mobile));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$1U, ctx_r10.mobile))("disabled", !ctx_r10.selectedAgentGuid);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.continueButtonText, " ");
} }
const _c4$u = function (a0) { return { "row m-0 pl-0 pr-0 pb-3": a0 }; };
var AgentOfRecordModalViewName;
(function (AgentOfRecordModalViewName) {
    AgentOfRecordModalViewName["SEARCH"] = "search";
    AgentOfRecordModalViewName["RESULTS"] = "results";
    AgentOfRecordModalViewName["SUCCESS"] = "success";
})(AgentOfRecordModalViewName || (AgentOfRecordModalViewName = {}));
class AgentOfRecordModalComponent {
    constructor(store, configResourceService, cdr, spinnerService, activeModal, agentService, accountOverviewFacade, profileService, sessionService, agentNoteFacade, analyticsService, responsiveLayoutService, agentTaskFacade) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.cdr = cdr;
        this.spinnerService = spinnerService;
        this.activeModal = activeModal;
        this.agentService = agentService;
        this.accountOverviewFacade = accountOverviewFacade;
        this.profileService = profileService;
        this.sessionService = sessionService;
        this.agentNoteFacade = agentNoteFacade;
        this.analyticsService = analyticsService;
        this.responsiveLayoutService = responsiveLayoutService;
        this.agentTaskFacade = agentTaskFacade;
        this.subscriptions = new Subscription();
        this.modalTitleText = 'Reassign agent of record';
        this.introText = 'Reassign a new agent of record for this beneficiary.';
        this.formTitleText = 'Search for an agent to assign to <firstName> <lastName>.';
        this.firstNameLabelText = 'First name';
        this.firstNameRequiredErrorText = 'First name is required';
        this.firstNameErrorText = '';
        this.lastNameLabelText = 'Last name';
        this.lastNameRequiredErrorText = 'Last name is required';
        this.lastNameErrorText = '';
        this.userNameLabelText = 'User name';
        this.userNameRequiredErrorText = 'User name is required';
        this.userNameErrorText = '';
        this.cancelButtonText = 'Cancel';
        this.closeButtonText = 'Close';
        this.searchButtonText = 'Search profiles';
        this.assignButtonText = 'Assign to me';
        this.continueButtonText = 'Continue';
        this.confirmSelectionText = 'Please confirm you would like to reassign the selected agent to <firstName> <lastName>.';
        this.selectAgentText = 'Select agent';
        this.searchAgainLinkText = 'Search again';
        this.searchAgainButtonText = 'Refine search';
        this.orText = 'Or';
        this.minLengthErrorText = 'Please provide minimum 2 characters';
        this.noSearchResultsText = 'There are no results for the profile you searched, but you may create a new profile with that information.';
        this.agentHierachyEnabled = false;
        this.timeoutMessageEnabled = false;
        this.agentOfRecordModalViewName = AgentOfRecordModalViewName;
        this.currentViewName = AgentOfRecordModalViewName.SEARCH;
        this.searchResults = [];
        this.firstNameFieldName = 'firstName';
        this.firstNameControl = new UntypedFormControl('', [Validators.required, Validators.minLength(2)]);
        this.lastNameFieldName = 'lastName';
        this.lastNameControl = new UntypedFormControl('', [Validators.required, Validators.minLength(2)]);
        this.userNameFieldName = 'userName';
        this.userNameControl = new UntypedFormControl('', [Validators.minLength(2)]);
    }
    ngOnInit() {
        this.reassignAgentForm = new UntypedFormGroup({
            [this.firstNameFieldName]: this.firstNameControl,
            [this.lastNameFieldName]: this.lastNameControl,
            [this.userNameFieldName]: this.userNameControl
        });
        this.memberFirstName = this.profileService.getFirstName();
        this.memberLastName = this.profileService.getLastName();
        this.getAgentName();
        this.applyResources();
        this.agentHierachyEnabled = this.agentService.isAgencyHierarchyEnabled();
        this.assigningAgentGuid = this.agentService.getAgentInContextGuid();
        this.subscriptions.add(this.responsiveLayoutService.isCompact$.subscribe(compact => {
            if (this.mobile !== compact) {
                this.mobile = compact;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.agentTaskFacade.getMemberAgentTasks$().subscribe(data => {
            if (data) {
                this.memberAgentTasks = data;
                this.cdr.markForCheck();
            }
        }));
    }
    submitForm() {
        this.reassignAgentForm.markAllAsTouched();
        this.reassignAgentForm.updateValueAndValidity();
        this.setAnalyticsEvent(DataLayerEvent.CLICK_PROFILE_AGENT_REASSIGN_SEARCH_PROFILES);
        if (this.reassignAgentForm.valid) {
            this.spinnerService.show(SpinnerEvent.AGENT_SEARCH_LOADING);
            const fullInputValues = { ...this.reassignAgentForm.value, isActive: true };
            if (this.agentHierachyEnabled) {
                fullInputValues.agencyName = this.agentService.getAgencyName();
            }
            this.accountOverviewFacade
                .searchAgents$(fullInputValues, this.searchTimeoutMilliSeconds)
                .pipe(take(1))
                .subscribe({
                next: (result) => {
                    this.searchResults = result.data ?? [];
                    this.currentViewName = AgentOfRecordModalViewName.RESULTS;
                    this.cdr.markForCheck();
                    this.spinnerService.hide(SpinnerEvent.AGENT_SEARCH_LOADING);
                },
                error: () => {
                    this.spinnerService.hide(SpinnerEvent.AGENT_SEARCH_LOADING);
                }
            });
        }
    }
    closeModal() {
        this.activeModal.dismiss();
    }
    getAgentName() {
        this.agentFirstName = this.agentService.getAgentFirstName();
        this.agentLastName = this.agentService.getAgentLastName();
    }
    updateSelectedAgentGuid(agentGuid) {
        this.selectedAgentGuid = agentGuid;
        const selectedAgent = this.searchResults.find(agent => agent.userId === agentGuid);
        if (selectedAgent) {
            this.agentFirstName = selectedAgent.firstName;
            this.agentLastName = selectedAgent.lastName;
            this.applyAgentNameResources();
        }
    }
    assignToMe() {
        this.setAnalyticsEvent(DataLayerEvent.CLICK_PROFILE_AGENT_REASSIGN_ASSIGN_TO_ME);
        this.submitAssignAgent(this.assigningAgentGuid, this.assigningAgentGuid);
    }
    assignAgent(assigningAgentGuid = this.assigningAgentGuid, selectedAgentGuid = this.selectedAgentGuid) {
        this.setAnalyticsEvent(DataLayerEvent.CLICK_PROFILE_AGENT_REASSIGN_CONTINUE);
        this.submitAssignAgent(assigningAgentGuid, selectedAgentGuid);
    }
    submitAssignAgent(assigningAgentGuid, selectedAgentGuid) {
        this.sessionService
            .assignPrimaryAgent$(assigningAgentGuid, selectedAgentGuid)
            .pipe(switchMap(() => this.agentService.fetchAgentOfRecord$(selectedAgentGuid)))
            .subscribe({
            next: () => {
                this.store.dispatch(new UpdateAgentGuid(selectedAgentGuid));
                const note = {
                    userAgentGUID: selectedAgentGuid,
                    agentNoteActionType: NoteActionType.Note,
                    description: this.noteText,
                    createdWhen: DateUtilities.getFormattedCurrentDate(),
                    memberId: this.sessionService.getMemberSessionId()
                };
                this.agentNoteFacade.addAgentNote(note);
                this.currentViewName = this.agentOfRecordModalViewName.SUCCESS;
            }
        });
        this.currentViewName = this.agentOfRecordModalViewName.SUCCESS;
        if (this.memberAgentTasks[0]?.agentNoteActionType === NoteActionType.SelectRx) {
            this.subscriptions.add(this.sessionService
                .reassignSelectRxTask$(this.memberAgentTasks[0].memberAgentNoteID, selectedAgentGuid)
                .pipe(switchMap(() => this.agentService.fetchAgentOfRecord$(selectedAgentGuid)))
                .subscribe({
                next: () => {
                    this.currentViewName = this.agentOfRecordModalViewName.SUCCESS;
                    this.cdr.markForCheck();
                }
            }));
        }
    }
    resetToSearchView() {
        this.setAnalyticsEvent(DataLayerEvent.CLICK_PROFILE_AGENT_REASSIGN_SEARCH_AGAIN);
        this.reassignAgentForm.reset();
        this.selectedAgentGuid = '';
        this.currentViewName = this.agentOfRecordModalViewName.SEARCH;
        this.searchResults = [];
        this.getAgentName();
        this.applyAgentNameResources();
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    applyResources() {
        this.searchTimeoutMilliSeconds = DateUtilities.secondsToMilliseconds(this.configResourceService.getProcessedResourceValue('Spa_Site_Search_Timeout_Seconds', null, 30));
        this.modalTitleText = this.configResourceService.getProcessedResourceValue('Spa_AgentOfRecord_ModalHeader_Text', null, this.modalTitleText);
        this.introText = this.configResourceService.getProcessedResourceValue('Spa_AgentOfRecord_ModalIntro_Text', null, this.introText);
        this.formTitleText = this.configResourceService
            .getProcessedResourceValue('Spa_AgentOfRecord_SearchHeader_Text', null, this.formTitleText)
            .replace('<firstName>', this.memberFirstName)
            .replace('<lastName>', this.memberLastName);
        this.firstNameLabelText = this.configResourceService.getProcessedResourceValue('Spa_Site_FirstName_Text', null, this.firstNameLabelText);
        this.firstNameRequiredErrorText = this.configResourceService.getProcessedResourceValue('Spa_Site_FirstNameRequired_Error', null, this.firstNameRequiredErrorText);
        this.lastNameLabelText = this.configResourceService.getProcessedResourceValue('Spa_Site_LastName_Text', null, this.lastNameLabelText);
        this.lastNameRequiredErrorText = this.configResourceService.getProcessedResourceValue('Spa_Site_LastNameRequired_Error', null, this.lastNameRequiredErrorText);
        this.userNameLabelText = this.configResourceService.getProcessedResourceValue('Spa_AgentLogin_Username_Text', null, this.userNameLabelText);
        this.userNameRequiredErrorText = this.configResourceService.getProcessedResourceValue('Spa_Site_UserNameRequired_Error', null, this.userNameRequiredErrorText);
        this.cancelButtonText = this.configResourceService.getProcessedResourceValue('Spa_Site_Cancel', null, this.cancelButtonText);
        this.closeButtonText = this.configResourceService.getProcessedResourceValue('Spa_Site_Close', null, this.cancelButtonText);
        this.searchButtonText = this.configResourceService.getProcessedResourceValue('Spa_Agent_Search_Button_Text', null, this.searchButtonText);
        this.assignButtonText = this.configResourceService.getProcessedResourceValue('Spa_AgentOfRecord_AssignToMe_Text', null, this.assignButtonText);
        this.continueButtonText = this.configResourceService.getProcessedResourceValue('Spa_Site_Continue', null, this.continueButtonText);
        this.confirmSelectionText = this.configResourceService
            .getProcessedResourceValue('Spa_AgentOfRecord_ConfirmSelection_Text', null, this.confirmSelectionText)
            .replace('<firstName>', this.memberFirstName)
            .replace('<lastName>', this.memberLastName);
        this.selectAgentText = this.configResourceService.getProcessedResourceValue('Spa_AgentOfRecord_SelectAgent_Text', null, this.selectAgentText);
        this.searchAgainLinkText = this.configResourceService.getProcessedResourceValue('Spa_AgentSearch_SearchAgain_Link_Text', null, this.searchAgainLinkText);
        this.searchAgainButtonText = this.configResourceService.getProcessedResourceValue('Spa_Site_Search_SearchAgain_Button_Text', null, this.searchAgainButtonText);
        this.orText = this.configResourceService.getProcessedResourceValue('Spa_AgentSearch_SearchAgainOr_Text', null, this.orText);
        this.minLengthErrorText = this.configResourceService.getProcessedResourceValue('Spa_Form_MinError_2Characters', null, this.noticeText);
        this.timeoutMessageText = this.agentService.getSearchTimeoutMessageText();
        this.timeoutMessageEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_Search_Timeout_Message_Enabled', null, this.timeoutMessageEnabled);
        this.noSearchResultsText = this.configResourceService.getProcessedResourceValue('Spa_Agent_Search_NoResults_Text', null, this.noSearchResultsText);
        this.errorMessages = {
            required: {
                [this.firstNameFieldName]: this.firstNameRequiredErrorText,
                [this.lastNameFieldName]: this.lastNameRequiredErrorText,
                [this.userNameFieldName]: this.userNameRequiredErrorText
            },
            minlength: this.minLengthErrorText
        };
        this.applyAgentNameResources();
    }
    applyAgentNameResources() {
        this.noticeText = this.configResourceService
            .getProcessedResourceValue('Spa_AgentOfRecord_ModalSuccess_Text', null, "<memberFirstName> <memberLastName> is now assigned to <agentFirstName> <agentLastName>'s profile.")
            .replace('<memberFirstName>', this.memberFirstName)
            .replace('<memberLastName>', this.memberLastName)
            .replace('<agentFirstName>', this.agentFirstName)
            .replace('<agentLastName>', this.agentLastName);
        this.noteText = this.configResourceService
            .getProcessedResourceValue('Spa_AgentOfRecord_NoteDescription_Text', null, 'Agent of record updated to <agentFirstName> <agentLastName>')
            .replace('<agentFirstName>', this.agentFirstName)
            .replace('<agentLastName>', this.agentLastName);
        this.cdr.markForCheck();
    }
    setAnalyticsEvent(dataLayerEvent) {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, dataLayerEvent);
    }
}
AgentOfRecordModalComponent.ɵfac = function AgentOfRecordModalComponent_Factory(t) { return new (t || AgentOfRecordModalComponent)(i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(AccountOverviewFacade), i0.ɵɵdirectiveInject(i1.ProfileService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(AgentNoteFacade), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService), i0.ɵɵdirectiveInject(AgentTaskFacade)); };
AgentOfRecordModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentOfRecordModalComponent, selectors: [["ng-component"]], decls: 18, vars: 17, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "modal-body"], [3, "ngSwitch"], [3, "ngTemplateOutlet", 4, "ngSwitchCase"], ["searchView", ""], ["resultsView", ""], ["successView", ""], [1, "modal-footer", "justify-content-start", 3, "ngClass"], [1, "mr-auto", 3, "ngClass"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", 3, "ngClass", "click", "keyup.enter"], [4, "ngIf"], [3, "ngTemplateOutlet"], [3, "introText", "formTitleText", "firstNameLabelText", "lastNameLabelText", "userNameLabelText", "errorMessages", "reassignAgentForm", "submitForm"], [3, "confirmSelectionText", "selectAgentText", "orText", "searchAgainLinkText", "timeoutMessageEnabled", "noSearchResultsText", "searchAgainButtonText", "timeoutMessageText", "searchResults", "updateSelectedAgentGuid", "resetToSearchView"], [3, "noticeText"], [3, "ngClass"], ["type", "button", 1, "btn", "Spa_Style_PrimaryButton", 3, "ngClass", "click", "keyup.enter"], ["type", "button", 1, "btn", "Spa_Style_PrimaryButton", 3, "ngClass", "disabled", "click", "keyup.enter"]], template: function AgentOfRecordModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function AgentOfRecordModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, AgentOfRecordModalComponent_ng_container_3_Template, 1, 1, "ng-container", 3);
        i0.ɵɵtemplate(4, AgentOfRecordModalComponent_ng_container_4_Template, 1, 1, "ng-container", 3);
        i0.ɵɵtemplate(5, AgentOfRecordModalComponent_ng_container_5_Template, 1, 1, "ng-container", 3);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(6, AgentOfRecordModalComponent_ng_template_6_Template, 1, 7, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(8, AgentOfRecordModalComponent_ng_template_8_Template, 1, 9, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(10, AgentOfRecordModalComponent_ng_template_10_Template, 1, 1, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(12, "div", 7)(13, "div", 8)(14, "button", 9);
        i0.ɵɵlistener("click", function AgentOfRecordModalComponent_Template_button_click_14_listener() { return ctx.closeModal(); })("keyup.enter", function AgentOfRecordModalComponent_Template_button_keyup_enter_14_listener() { return ctx.closeModal(); });
        i0.ɵɵtext(15);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(16, AgentOfRecordModalComponent_ng_container_16_Template, 7, 14, "ng-container", 10);
        i0.ɵɵtemplate(17, AgentOfRecordModalComponent_ng_container_17_Template, 4, 8, "ng-container", 10);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.modalTitleText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngSwitch", ctx.currentViewName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.agentOfRecordModalViewName.SEARCH);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.agentOfRecordModalViewName.RESULTS);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.agentOfRecordModalViewName.SUCCESS);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c4$u, ctx.mobile));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c0$3z, ctx.mobile));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c1$1U, ctx.mobile));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.currentViewName === ctx.agentOfRecordModalViewName.SUCCESS ? ctx.closeButtonText : ctx.cancelButtonText, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.currentViewName === ctx.agentOfRecordModalViewName.SEARCH);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.currentViewName === ctx.agentOfRecordModalViewName.RESULTS);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$2.NgTemplateOutlet, i1$2.NgSwitch, i1$2.NgSwitchCase, ModalHeaderComponent, AgentOfRecordModalSearchComponent, AgentOfRecordModalResultsComponent, AgentOfRecordModalSuccessComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentOfRecordModalComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"modalTitleText\" (modalTitleCancelAction)=\"closeModal()\"></vnext-widget-modal-header>\r\n<div class=\"modal-body\">\r\n  <div [ngSwitch]=\"currentViewName\">\r\n    <ng-container *ngSwitchCase=\"agentOfRecordModalViewName.SEARCH\" [ngTemplateOutlet]=\"searchView\"> </ng-container>\r\n    <ng-container *ngSwitchCase=\"agentOfRecordModalViewName.RESULTS\" [ngTemplateOutlet]=\"resultsView\"></ng-container>\r\n    <ng-container *ngSwitchCase=\"agentOfRecordModalViewName.SUCCESS\" [ngTemplateOutlet]=\"successView\"></ng-container>\r\n  </div>\r\n</div>\r\n\r\n<ng-template #searchView>\r\n  <vnext-agent-of-record-modal-search\r\n    [introText]=\"introText\"\r\n    [formTitleText]=\"formTitleText\"\r\n    [firstNameLabelText]=\"firstNameLabelText\"\r\n    [lastNameLabelText]=\"lastNameLabelText\"\r\n    [userNameLabelText]=\"userNameLabelText\"\r\n    [errorMessages]=\"errorMessages\"\r\n    [reassignAgentForm]=\"reassignAgentForm\"\r\n    (submitForm)=\"submitForm()\"\r\n  ></vnext-agent-of-record-modal-search>\r\n</ng-template>\r\n\r\n<ng-template #resultsView>\r\n  <vnext-agent-of-record-modal-results\r\n    [confirmSelectionText]=\"confirmSelectionText\"\r\n    [selectAgentText]=\"selectAgentText\"\r\n    [orText]=\"orText\"\r\n    [searchAgainLinkText]=\"searchAgainLinkText\"\r\n    [timeoutMessageEnabled]=\"timeoutMessageEnabled\"\r\n    [noSearchResultsText]=\"noSearchResultsText\"\r\n    [searchAgainButtonText]=\"searchAgainButtonText\"\r\n    [timeoutMessageText]=\"timeoutMessageText\"\r\n    [searchResults]=\"searchResults\"\r\n    (updateSelectedAgentGuid)=\"updateSelectedAgentGuid($event)\"\r\n    (resetToSearchView)=\"resetToSearchView()\"\r\n  ></vnext-agent-of-record-modal-results>\r\n</ng-template>\r\n\r\n<ng-template #successView>\r\n  <vnext-agent-of-record-modal-success [noticeText]=\"noticeText\"></vnext-agent-of-record-modal-success>\r\n</ng-template>\r\n\r\n<div class=\"modal-footer justify-content-start\" [ngClass]=\"{ 'row m-0 pl-0 pr-0 pb-3': mobile }\">\r\n  <div class=\"mr-auto\" [ngClass]=\"{ 'col-6 m-0': mobile }\">\r\n    <button\r\n      type=\"button\"\r\n      class=\"btn Spa_Style_SecondaryButton\"\r\n      [ngClass]=\"{ 'w-100 mt-2': mobile }\"\r\n      (click)=\"closeModal()\"\r\n      (keyup.enter)=\"closeModal()\"\r\n    >\r\n      {{ currentViewName === agentOfRecordModalViewName.SUCCESS ? closeButtonText : cancelButtonText }}\r\n    </button>\r\n  </div>\r\n  <ng-container *ngIf=\"currentViewName === agentOfRecordModalViewName.SEARCH\">\r\n    <div [ngClass]=\"{ 'col-6 m-0': mobile }\">\r\n      <button\r\n        type=\"button\"\r\n        class=\"btn Spa_Style_SecondaryButton\"\r\n        [ngClass]=\"{ 'w-100 mt-2': mobile }\"\r\n        (click)=\"assignToMe()\"\r\n        (keyup.enter)=\"assignToMe()\"\r\n      >\r\n        {{ assignButtonText }}\r\n      </button>\r\n    </div>\r\n    <div [ngClass]=\"{ 'col-12 m-0': mobile }\">\r\n      <button\r\n        type=\"button\"\r\n        class=\"btn Spa_Style_PrimaryButton\"\r\n        [ngClass]=\"{ 'w-100 mt-3': mobile }\"\r\n        (click)=\"submitForm()\"\r\n        (keyup.enter)=\"submitForm()\"\r\n      >\r\n        {{ searchButtonText }}\r\n      </button>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"currentViewName === agentOfRecordModalViewName.RESULTS\">\r\n    <div [ngClass]=\"{ 'col-6 m-0': mobile }\">\r\n      <button\r\n        type=\"button\"\r\n        class=\"btn Spa_Style_PrimaryButton\"\r\n        [ngClass]=\"{ 'w-100 mt-2': mobile }\"\r\n        (click)=\"assignAgent()\"\r\n        (keyup.enter)=\"assignAgent()\"\r\n        [disabled]=\"!selectedAgentGuid\"\r\n      >\r\n        {{ continueButtonText }}\r\n      </button>\r\n    </div>\r\n  </ng-container>\r\n</div>\r\n" }]
    }], function () { return [{ type: i2.Store }, { type: i1.ConfigResourceService }, { type: i0.ChangeDetectorRef }, { type: i1.SpinnerService }, { type: i1$1.NgbActiveModal }, { type: i1.AgentService }, { type: AccountOverviewFacade }, { type: i1.ProfileService }, { type: i1.MemberSessionService }, { type: AgentNoteFacade }, { type: AnalyticsService }, { type: i1.ResponsiveLayoutService }, { type: AgentTaskFacade }]; }, null); })();

class AgentRetireFloFacade {
    constructor(modalService, memberSessionService, store, configResourceService, injector, agentService, navigationService) {
        this.modalService = modalService;
        this.memberSessionService = memberSessionService;
        this.store = store;
        this.configResourceService = configResourceService;
        this.injector = injector;
        this.agentService = agentService;
        this.navigationService = navigationService;
    }
    showRetireFloModal() {
        const modalTitle = this.configResourceService.getProcessedResourceValue('Spa_RetireFlo_UpdateIntake_Header_Text', null, 'Send update form');
        const modalDescriptiveText = this.configResourceService.getProcessedResourceValue('Spa_RetireFlo_UpdateIntake_Description_Text', null, 'This will send a form that will allow the beneficiary');
        const modalAdditionalSubText = this.configResourceService.getProcessedResourceValue('Spa_RetireFlo_UpdateIntake_CustomMessage_Description_Text', null, 'This will be the first paragraph on the update form ');
        const modalAdditionalDefaultMessage = this.configResourceService.getProcessedResourceValue('Spa_RetireFlo_UpdateIntake_CustomMessage_Default_Text', null, 'Please complete the linked form');
        const sessionId = this.memberSessionService.getMemberSessionId();
        if (sessionId) {
            const options = {
                ariaLabelledBy: 'modalHeaderTitle',
                centered: true,
                injector: this.injector
            };
            const sendRetireFloModal = this.modalService.open(SendRetireFloModalComponent, options);
            sendRetireFloModal.componentInstance.isNewMember = false;
            sendRetireFloModal.componentInstance.modalTitleText = modalTitle;
            sendRetireFloModal.componentInstance.modalDescriptiveText = modalDescriptiveText;
            sendRetireFloModal.componentInstance.modalAdditionalSubText = modalAdditionalSubText;
            sendRetireFloModal.componentInstance.modalAdditionalDefaultMessage = modalAdditionalDefaultMessage;
            sendRetireFloModal.result.then(formData => {
                this.memberSessionService.sendRetireFloSurvey$(sessionId, formData).subscribe({
                    next: (memberagentNotes) => {
                        if (memberagentNotes) {
                            this.updateAgentRetireFlo(memberagentNotes[memberagentNotes.length - 1]);
                        }
                    }
                });
            });
        }
    }
    async updateAgentRetireFlo(memberAgentNotes) {
        return await this.memberSessionService.updateMemberTask(memberAgentNotes);
    }
    getMemberRetireFlo$() {
        return this.store
            .select(MemberState.memberAgentNotes)
            .pipe(map(retireFlos => retireFlos.filter(retireFlo => retireFlo.agentNoteActionType === NoteActionType.RetireFlo)));
    }
    navigateToRetireFloSignUpOrLogin(signUpURL, signUpFlag) {
        const baseUrl = `${signUpURL}`;
        const agentGuid = this.agentService.getAgentInContextGuid();
        this.memberSessionService.updateSession$(this.memberSessionService.getMemberSessionId(), { agentGuid }).subscribe({
            next: () => {
                this.navigationService.navigateToRetireFlo(baseUrl, signUpFlag, agentGuid);
            }
        });
    }
    showRetireFloSurveyModal(url) {
        const modalTitle = this.configResourceService.getProcessedResourceValue('Spa_RetireFlo_ExternalLink_InstructionTitle_Text', null, 'Leaving Our Site');
        const modalDescriptiveText = this.configResourceService.getProcessedResourceValue('Spa_RetireFlo_ExternalLink_Instructions_Text', null, 'You are about to leave our site and visit an external URL. Do you wish to continue?');
        const cancelButtonText = this.configResourceService.getProcessedResourceValue('Spa_Site_Cancel', null, 'Cancel');
        const confirmButtonText = this.configResourceService.getProcessedResourceValue('Spa_Site_Continue', null, 'Continue');
        const options = {
            ariaLabelledBy: 'modalHeaderTitle',
            centered: true,
            injector: this.injector
        };
        const sendRetireFloSurveyModal = this.modalService.open(RetireFloSurveyModalComponent, options);
        sendRetireFloSurveyModal.componentInstance.title = modalTitle;
        sendRetireFloSurveyModal.componentInstance.htmlContent = modalDescriptiveText;
        sendRetireFloSurveyModal.componentInstance.cancelButton = cancelButtonText;
        sendRetireFloSurveyModal.componentInstance.confirmButton = confirmButtonText;
        sendRetireFloSurveyModal.componentInstance.confirmAction = () => {
            this.navigationService.navigateToRetireFloSurvey(url);
        };
    }
    getRetireFloSurveyUrl$() {
        const agentGuid = this.agentService.getAgentInContextGuid();
        const sessionId = this.memberSessionService.getMemberSessionId();
        const memberId = this.store.selectSnapshot(MemberState.memberID);
        return this.memberSessionService.getRetireFloSurvey$(sessionId, agentGuid, memberId);
    }
}
AgentRetireFloFacade.ɵfac = function AgentRetireFloFacade_Factory(t) { return new (t || AgentRetireFloFacade)(i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(i1.AgentService), i0.ɵɵinject(i1.NavigationService)); };
AgentRetireFloFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentRetireFloFacade, factory: AgentRetireFloFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentRetireFloFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$1.NgbModal }, { type: i1.MemberSessionService }, { type: i2.Store }, { type: i1.ConfigResourceService }, { type: i0.Injector }, { type: i1.AgentService }, { type: i1.NavigationService }]; }, null); })();

class AgentRetireFloSignupModalComponent {
    constructor(activeModal, agentRetireFloFacade) {
        this.activeModal = activeModal;
        this.agentRetireFloFacade = agentRetireFloFacade;
    }
    signUp() {
        const baseUrl = `${this.signUpURL}`;
        this.agentRetireFloFacade.navigateToRetireFloSignUpOrLogin(baseUrl, true);
        this.activeModal.close();
    }
}
AgentRetireFloSignupModalComponent.ɵfac = function AgentRetireFloSignupModalComponent_Factory(t) { return new (t || AgentRetireFloSignupModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(AgentRetireFloFacade)); };
AgentRetireFloSignupModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentRetireFloSignupModalComponent, selectors: [["vnext-agent-retireflo-signup-modal"]], decls: 9, vars: 6, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "modal-body"], [1, "center"], [3, "src", "alt"], [3, "cancelButtonText", "primaryButtonText", "cancelButtonAction", "primaryButtonAction"]], template: function AgentRetireFloSignupModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function AgentRetireFloSignupModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.activeModal.dismiss(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1)(2, "span", 2);
        i0.ɵɵelement(3, "img", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(4, "br");
        i0.ɵɵelementStart(5, "span");
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(7, "br");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "vnext-widget-modal-footer", 4);
        i0.ɵɵlistener("cancelButtonAction", function AgentRetireFloSignupModalComponent_Template_vnext_widget_modal_footer_cancelButtonAction_8_listener() { return ctx.activeModal.dismiss(); })("primaryButtonAction", function AgentRetireFloSignupModalComponent_Template_vnext_widget_modal_footer_primaryButtonAction_8_listener() { return ctx.signUp(); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("src", ctx.primaryLogo, i0.ɵɵsanitizeUrl)("alt", ctx.primaryLogoAltText);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.contenttext, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("cancelButtonText", ctx.cancelButton)("primaryButtonText", ctx.confirmButton);
    } }, dependencies: [ModalFooterComponent, ModalHeaderComponent], styles: [".label-error[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent2)}.input-error[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent2)}.center[_ngcontent-%COMP%]{display:flex;margin-left:30%;height:40px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentRetireFloSignupModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-retireflo-signup-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"activeModal.dismiss()\"></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body\">\r\n  <span class=\"center\"><img [src]=\"primaryLogo\" [alt]=\"primaryLogoAltText\" /></span>\r\n  <br />\r\n  <span>\r\n    {{ contenttext }}\r\n  </span>\r\n  <br />\r\n</div>\r\n\r\n<vnext-widget-modal-footer\r\n  [cancelButtonText]=\"cancelButton\"\r\n  [primaryButtonText]=\"confirmButton\"\r\n  (cancelButtonAction)=\"activeModal.dismiss()\"\r\n  (primaryButtonAction)=\"signUp()\"\r\n></vnext-widget-modal-footer>\r\n", styles: [".label-error{color:var(--static-Spa_Style_Accent2)}.input-error{border-color:var(--static-Spa_Style_Accent2)}.center{display:flex;margin-left:30%;height:40px}\n"] }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: AgentRetireFloFacade }]; }, null); })();

function AuthorizationCodeSignatureStatementComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "i", 9);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("id", (ctx_r0.statement == null ? null : ctx_r0.statement.name) + "Error");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.errorMessage);
} }
function AuthorizationCodeSignatureStatementComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r1.statement == null ? null : ctx_r1.statement.preInstructionalText, "html"), i0.ɵɵsanitizeHtml);
} }
function AuthorizationCodeSignatureStatementComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.statement == null ? null : ctx_r2.statement.value);
} }
const _c0$3y = function (a0) { return { "error-color": a0 }; };
function AuthorizationCodeSignatureStatementComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 11)(2, "div", 12)(3, "input", 13);
    i0.ɵɵlistener("change", function AuthorizationCodeSignatureStatementComponent_ng_container_6_Template_input_change_3_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.statementToggled()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(4, "div", 14);
    i0.ɵɵpipe(5, "safe");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", ctx_r3.statement == null ? null : ctx_r3.statement.name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r3.statement == null ? null : ctx_r3.statement.name)("formControl", ctx_r3.control);
    i0.ɵɵattribute("aria-describedby", ctx_r3.isControlInvalid ? (ctx_r3.statement == null ? null : ctx_r3.statement.name) + "Error" : null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0$3y, ctx_r3.isControlInvalid))("innerHtml", i0.ɵɵpipeBind2(5, 6, ctx_r3.statement == null ? null : ctx_r3.statement.value, "html"), i0.ɵɵsanitizeHtml);
} }
function AuthorizationCodeSignatureStatementComponent_ng_container_7_label_4_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 18)(1, "input", 19);
    i0.ɵɵlistener("change", function AuthorizationCodeSignatureStatementComponent_ng_container_7_label_4_Template_input_change_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r16); const option_r13 = restoredCtx.$implicit; const ctx_r15 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r15.optionSelected(option_r13)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 20);
    i0.ɵɵpipe(3, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r13 = ctx.$implicit;
    const i_r14 = ctx.index;
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("name", (ctx_r12.statement == null ? null : ctx_r12.statement.name) + "group")("checked", (ctx_r12.control == null ? null : ctx_r12.control.value) === option_r13);
    i0.ɵɵattribute("aria-labelledby", "statementLabelId " + (ctx_r12.statement == null ? null : ctx_r12.statement.name) + i_r14);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", (ctx_r12.statement == null ? null : ctx_r12.statement.name) + i_r14)("innerHtml", i0.ɵɵpipeBind2(3, 5, option_r13, "html"), i0.ɵɵsanitizeHtml);
} }
function AuthorizationCodeSignatureStatementComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h4", 15);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 16);
    i0.ɵɵtemplate(4, AuthorizationCodeSignatureStatementComponent_ng_container_7_label_4_Template, 4, 8, "label", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.statement == null ? null : ctx_r4.statement.value);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r4.statement == null ? null : ctx_r4.statement.radioOptions)("ngForTrackBy", ctx_r4.trackByRadioOption);
} }
function AuthorizationCodeSignatureStatementComponent_ng_container_8_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28)(1, "button", 29);
    i0.ɵɵlistener("click", function AuthorizationCodeSignatureStatementComponent_ng_container_8_div_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r18.emitStatementAction(ctx_r18.statement == null ? null : ctx_r18.statement.statementAction)); })("keyup.enter", function AuthorizationCodeSignatureStatementComponent_ng_container_8_div_9_Template_button_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r19); const ctx_r20 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r20.emitStatementAction(ctx_r20.statement == null ? null : ctx_r20.statement.statementAction)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r17.statement == null ? null : ctx_r17.statement.buttonText, " ");
} }
const _c1$1T = function (a0) { return { "has-error": a0 }; };
function AuthorizationCodeSignatureStatementComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 21)(2, "div", 22)(3, "label", 23);
    i0.ɵɵtext(4);
    i0.ɵɵelementStart(5, "span", 24);
    i0.ɵɵtext(6, "*");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "div", 25);
    i0.ɵɵelement(8, "input", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, AuthorizationCodeSignatureStatementComponent_ng_container_8_div_9_Template, 3, 1, "div", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("for", ctx_r5.statement == null ? null : ctx_r5.statement.name)("ngClass", i0.ɵɵpureFunction1(8, _c0$3y, ctx_r5.isControlInvalid));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r5.statement == null ? null : ctx_r5.statement.value, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("id", ctx_r5.statement == null ? null : ctx_r5.statement.name)("ngClass", i0.ɵɵpureFunction1(10, _c1$1T, ctx_r5.isControlInvalid))("formControl", ctx_r5.control);
    i0.ɵɵattribute("aria-describedby", ctx_r5.isControlInvalid ? (ctx_r5.statement == null ? null : ctx_r5.statement.name) + "Error" : null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.statement == null ? null : ctx_r5.statement.buttonText);
} }
function AuthorizationCodeSignatureStatementComponent_ng_container_9_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28)(1, "button", 29);
    i0.ɵɵlistener("click", function AuthorizationCodeSignatureStatementComponent_ng_container_9_div_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r22.emitStatementAction(ctx_r22.statement == null ? null : ctx_r22.statement.statementAction)); })("keyup.enter", function AuthorizationCodeSignatureStatementComponent_ng_container_9_div_9_Template_button_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r23); const ctx_r24 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r24.emitStatementAction(ctx_r24.statement == null ? null : ctx_r24.statement.statementAction)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r21.statement == null ? null : ctx_r21.statement.buttonText, " ");
} }
function AuthorizationCodeSignatureStatementComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 21)(2, "div", 22)(3, "label", 23);
    i0.ɵɵtext(4);
    i0.ɵɵelementStart(5, "span", 24);
    i0.ɵɵtext(6, "*");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "div", 25);
    i0.ɵɵelement(8, "input", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, AuthorizationCodeSignatureStatementComponent_ng_container_9_div_9_Template, 3, 1, "div", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("for", ctx_r6.statement == null ? null : ctx_r6.statement.name)("ngClass", i0.ɵɵpureFunction1(10, _c0$3y, ctx_r6.isControlInvalid));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r6.statement == null ? null : ctx_r6.statement.value, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("id", ctx_r6.statement == null ? null : ctx_r6.statement.name)("mask", ctx_r6.phoneMask)("maxLength", ctx_r6.phoneMask.length)("ngClass", i0.ɵɵpureFunction1(12, _c1$1T, ctx_r6.isControlInvalid))("formControl", ctx_r6.control);
    i0.ɵɵattribute("aria-describedby", ctx_r6.isControlInvalid ? (ctx_r6.statement == null ? null : ctx_r6.statement.name) + "Error" : null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.statement == null ? null : ctx_r6.statement.buttonText);
} }
function AuthorizationCodeSignatureStatementComponent_ng_container_10_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28)(1, "button", 29);
    i0.ɵɵlistener("click", function AuthorizationCodeSignatureStatementComponent_ng_container_10_div_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r26.emitStatementAction(ctx_r26.statement == null ? null : ctx_r26.statement.statementAction)); })("keyup.enter", function AuthorizationCodeSignatureStatementComponent_ng_container_10_div_9_Template_button_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r27); const ctx_r28 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r28.emitStatementAction(ctx_r28.statement == null ? null : ctx_r28.statement.statementAction)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r25.statement == null ? null : ctx_r25.statement.buttonText, " ");
} }
function AuthorizationCodeSignatureStatementComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 21)(2, "div", 22)(3, "label", 23);
    i0.ɵɵtext(4);
    i0.ɵɵelementStart(5, "span", 24);
    i0.ɵɵtext(6, "*");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "div", 25);
    i0.ɵɵelement(8, "input", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, AuthorizationCodeSignatureStatementComponent_ng_container_10_div_9_Template, 3, 1, "div", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("for", ctx_r7.statement == null ? null : ctx_r7.statement.name)("ngClass", i0.ɵɵpureFunction1(8, _c0$3y, ctx_r7.isControlInvalid));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r7.statement == null ? null : ctx_r7.statement.value, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("id", ctx_r7.statement == null ? null : ctx_r7.statement.name)("ngClass", i0.ɵɵpureFunction1(10, _c1$1T, ctx_r7.isControlInvalid))("formControl", ctx_r7.control);
    i0.ɵɵattribute("aria-describedby", ctx_r7.isControlInvalid ? (ctx_r7.statement == null ? null : ctx_r7.statement.name) + "Error" : null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.statement == null ? null : ctx_r7.statement.buttonText);
} }
function AuthorizationCodeSignatureStatementComponent_ul_11_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelement(1, "vnext-widget-authorization-code-signature-statement", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subStatement_r30 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("statement", subStatement_r30)("displayAsListItem", true);
} }
function AuthorizationCodeSignatureStatementComponent_ul_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul");
    i0.ɵɵtemplate(1, AuthorizationCodeSignatureStatementComponent_ul_11_li_1_Template, 2, 2, "li", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r8.statement == null ? null : ctx_r8.statement.subStatements)("ngForTrackBy", ctx_r8.trackBySubStatementName);
} }
function AuthorizationCodeSignatureStatementComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 34);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r9.statement == null ? null : ctx_r9.statement.instructionalText, "html"), i0.ɵɵsanitizeHtml);
} }
class AuthorizationCodeSignatureStatementComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.valueUpdated = new EventEmitter();
        this.statementAction = new EventEmitter();
        this.isControlInvalid = false;
        this.errorMessage = '';
        this.inputTypes = InputTypes;
        this.phoneMask = FormValidationService.phoneMask;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.onControlValueChanges();
        this.onControlStatusChanges();
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    statementToggled() {
        if (this.control) {
            this.control.setValue(!this.control.value);
            this.control.markAsDirty();
            this.control.markAsTouched();
        }
    }
    optionSelected(value) {
        if (this.control) {
            this.control.setValue(value);
            this.control.markAsDirty();
            this.control.markAsTouched();
        }
    }
    emitStatementAction(fieldAction) {
        const isControlInvalid = this.control?.invalid ?? false;
        if (!isControlInvalid) {
            this.statementAction.emit(fieldAction);
        }
        else {
            this.updateFieldValidity(isControlInvalid);
        }
    }
    updateFieldValidity(isControlInvalid = this.getIsControlInvalid(this.control)) {
        if (this.control) {
            this.isControlInvalid = isControlInvalid;
            if (this.isControlInvalid) {
                if (this.control.value === null || this.control.value === false || this.control.value === '') {
                    this.errorMessage = this.requiredText;
                }
                else if (this.statement.name === AuthorizationCodeSignatureModalFieldNames.PHONE_FIELD_NAME) {
                    this.errorMessage = this.invalidPhoneText;
                }
                else if (this.statement.name === AuthorizationCodeSignatureModalFieldNames.EMAIL_FIELD_NAME) {
                    this.errorMessage = this.invalidEmailText;
                }
                else if (this.statement.name === AuthorizationCodeSignatureModalFieldNames.VERIFY_AUTHORIZATION_CODE_FIELD_NAME) {
                    this.errorMessage = this.invalidCodeText;
                }
            }
            else {
                this.errorMessage = '';
            }
            this.cdr.markForCheck();
        }
    }
    trackBySubStatementName(index, subStatement) {
        return subStatement.name;
    }
    trackByRadioOption(index, option) {
        return `${index}-${option}`;
    }
    onControlValueChanges() {
        if (this.control) {
            this.subscriptions.add(this.control.valueChanges.subscribe({
                next: (value) => {
                    this.valueUpdated.emit(value);
                }
            }));
        }
    }
    onControlStatusChanges() {
        if (this.control) {
            this.subscriptions.add(this.control.statusChanges.subscribe({
                next: () => {
                    this.updateFieldValidity();
                }
            }));
        }
    }
    getIsControlInvalid(control) {
        return control && control.invalid && (control.dirty || control.touched);
    }
}
AuthorizationCodeSignatureStatementComponent.ɵfac = function AuthorizationCodeSignatureStatementComponent_Factory(t) { return new (t || AuthorizationCodeSignatureStatementComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
AuthorizationCodeSignatureStatementComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AuthorizationCodeSignatureStatementComponent, selectors: [["vnext-widget-authorization-code-signature-statement"]], inputs: { statement: "statement", control: "control", requiredText: "requiredText", invalidEmailText: "invalidEmailText", invalidPhoneText: "invalidPhoneText", invalidCodeText: "invalidCodeText", fieldHasError: "fieldHasError", displayAsListItem: "displayAsListItem" }, outputs: { valueUpdated: "valueUpdated", statementAction: "statementAction" }, decls: 13, vars: 11, consts: [["class", "error-color", "role", "alert", 3, "id", 4, "ngIf"], [1, "row"], [1, "col-12", "Spa_Style_Paragraph"], ["class", "preInstructional-text Spa_Style_Note", 3, "innerHTML", 4, "ngIf"], [4, "ngIf"], [3, "ngSwitch"], [4, "ngSwitchCase"], ["class", "instructional-text Spa_Style_Note ml-4 mb-2", 3, "innerHTML", 4, "ngIf"], ["role", "alert", 1, "error-color", 3, "id"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle", "mr-2"], [1, "preInstructional-text", "Spa_Style_Note", 3, "innerHTML"], [1, "d-flex", "checkbox-label", 3, "for"], [1, "checkbox-wrapper"], ["type", "checkbox", "aria-required", "true", 1, "mr-2", "can-click", 3, "id", "formControl", "change"], [3, "ngClass", "innerHtml"], ["id", "statementLabelId", 1, "Spa_Style_Label"], [1, "radio-options-container"], ["class", "text-capitalize", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "text-capitalize"], ["type", "radio", 1, "mr-2", "can-click", 3, "name", "checked", "change"], [3, "id", "innerHtml"], [1, "row", "mb-4"], [1, "col-12"], [1, "Spa_Style_Small_Font", "Spa_Style_Semi_Bold_Weight", 3, "for", "ngClass"], [1, "error-color", "Spa_Style_Bold_Weight"], [1, "col-12", "col-sm-6", "col-md-4", "mb-3", "mb-sm-0"], ["type", "email", "autocomplete", "off", "aria-required", "true", 1, "w-100", 3, "id", "ngClass", "formControl"], ["class", "col-12 col-sm-6 col-md-8", 4, "ngIf"], [1, "col-12", "col-sm-6", "col-md-8"], [1, "btn", "Spa_Style_PrimaryButton", 3, "click", "keyup.enter"], ["type", "text", "inputmode", "numeric", "autocomplete", "off", "aria-required", "true", 1, "w-100", 3, "id", "mask", "maxLength", "ngClass", "formControl"], ["type", "text", "autocomplete", "off", "aria-required", "true", 1, "w-100", 3, "id", "ngClass", "formControl"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "statement", "displayAsListItem"], [1, "instructional-text", "Spa_Style_Note", "ml-4", "mb-2", 3, "innerHTML"]], template: function AuthorizationCodeSignatureStatementComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, AuthorizationCodeSignatureStatementComponent_div_0_Template, 4, 2, "div", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, AuthorizationCodeSignatureStatementComponent_div_3_Template, 2, 4, "div", 3);
        i0.ɵɵtemplate(4, AuthorizationCodeSignatureStatementComponent_ng_container_4_Template, 3, 1, "ng-container", 4);
        i0.ɵɵelementContainerStart(5, 5);
        i0.ɵɵtemplate(6, AuthorizationCodeSignatureStatementComponent_ng_container_6_Template, 6, 11, "ng-container", 6);
        i0.ɵɵtemplate(7, AuthorizationCodeSignatureStatementComponent_ng_container_7_Template, 5, 3, "ng-container", 6);
        i0.ɵɵtemplate(8, AuthorizationCodeSignatureStatementComponent_ng_container_8_Template, 10, 12, "ng-container", 6);
        i0.ɵɵtemplate(9, AuthorizationCodeSignatureStatementComponent_ng_container_9_Template, 10, 14, "ng-container", 6);
        i0.ɵɵtemplate(10, AuthorizationCodeSignatureStatementComponent_ng_container_10_Template, 10, 12, "ng-container", 6);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵtemplate(11, AuthorizationCodeSignatureStatementComponent_ul_11_Template, 2, 2, "ul", 4);
        i0.ɵɵtemplate(12, AuthorizationCodeSignatureStatementComponent_div_12_Template, 2, 4, "div", 7);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.isControlInvalid);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.statement == null ? null : ctx.statement.preInstructionalText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.displayAsListItem);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitch", ctx.statement == null ? null : ctx.statement.inputType);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.inputTypes.CHECKBOX);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.inputTypes.RADIO);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.inputTypes.EMAIL);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.inputTypes.PHONE);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.inputTypes.TEXT);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.statement == null ? null : ctx.statement.displaySubStatementsAsList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.statement == null ? null : ctx.statement.instructionalText);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, i4.DefaultValueAccessor, i4.CheckboxControlValueAccessor, i4.NgControlStatus, i4.FormControlDirective, i8.MaskDirective, IconAriaAttributesDirective, AuthorizationCodeSignatureStatementComponent, SafePipe], styles: ["label[_ngcontent-%COMP%]{cursor:pointer}.checkbox-wrapper[_ngcontent-%COMP%]{margin-top:2px}.radio-options-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;column-gap:10px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizationCodeSignatureStatementComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-authorization-code-signature-statement', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"isControlInvalid\" class=\"error-color\" id=\"{{ statement?.name + 'Error' }}\" role=\"alert\">\r\n  <i class=\"fas fa-exclamation-circle mr-2\" aria-hidden=\"true\"></i>\r\n  <span>{{ errorMessage }}</span>\r\n</div>\r\n<div class=\"row\">\r\n  <div class=\"col-12 Spa_Style_Paragraph\">\r\n    <div\r\n      *ngIf=\"statement?.preInstructionalText\"\r\n      class=\"preInstructional-text Spa_Style_Note\"\r\n      [innerHTML]=\"statement?.preInstructionalText | safe : 'html'\"\r\n    ></div>\r\n\r\n    <ng-container *ngIf=\"displayAsListItem\">\r\n      <li>{{ statement?.value }}</li>\r\n    </ng-container>\r\n\r\n    <ng-container [ngSwitch]=\"statement?.inputType\">\r\n      <ng-container *ngSwitchCase=\"inputTypes.CHECKBOX\">\r\n        <label class=\"d-flex checkbox-label\" [for]=\"statement?.name\">\r\n          <div class=\"checkbox-wrapper\">\r\n            <input\r\n              class=\"mr-2 can-click\"\r\n              type=\"checkbox\"\r\n              aria-required=\"true\"\r\n              [id]=\"statement?.name\"\r\n              [formControl]=\"control\"\r\n              [attr.aria-describedby]=\"isControlInvalid ? statement?.name + 'Error' : null\"\r\n              (change)=\"statementToggled()\"\r\n            />\r\n          </div>\r\n          <div [ngClass]=\"{ 'error-color': isControlInvalid }\" [innerHtml]=\"statement?.value | safe : 'html'\"></div\r\n        ></label>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"inputTypes.RADIO\">\r\n        <h4 id=\"statementLabelId\" class=\"Spa_Style_Label\">{{ statement?.value }}</h4>\r\n        <div class=\"radio-options-container\">\r\n          <label *ngFor=\"let option of statement?.radioOptions; trackBy: trackByRadioOption; let i = index\" class=\"text-capitalize\">\r\n            <input\r\n              class=\"mr-2 can-click\"\r\n              type=\"radio\"\r\n              [name]=\"statement?.name + 'group'\"\r\n              [checked]=\"control?.value === option\"\r\n              [attr.aria-labelledby]=\"'statementLabelId ' + statement?.name + i\"\r\n              (change)=\"optionSelected(option)\"\r\n            />\r\n            <span [id]=\"statement?.name + i\" [innerHtml]=\"option | safe : 'html'\"></span>\r\n          </label>\r\n        </div>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"inputTypes.EMAIL\">\r\n        <div class=\"row mb-4\">\r\n          <div class=\"col-12\">\r\n            <label\r\n              class=\"Spa_Style_Small_Font Spa_Style_Semi_Bold_Weight\"\r\n              [for]=\"statement?.name\"\r\n              [ngClass]=\"{ 'error-color': isControlInvalid }\"\r\n              >{{ statement?.value }} <span class=\"error-color Spa_Style_Bold_Weight\">*</span></label\r\n            >\r\n          </div>\r\n\r\n          <div class=\"col-12 col-sm-6 col-md-4 mb-3 mb-sm-0\">\r\n            <input\r\n              class=\"w-100\"\r\n              type=\"email\"\r\n              autocomplete=\"off\"\r\n              aria-required=\"true\"\r\n              [id]=\"statement?.name\"\r\n              [ngClass]=\"{ 'has-error': isControlInvalid }\"\r\n              [formControl]=\"control\"\r\n              [attr.aria-describedby]=\"isControlInvalid ? statement?.name + 'Error' : null\"\r\n            />\r\n          </div>\r\n\r\n          <div *ngIf=\"statement?.buttonText\" class=\"col-12 col-sm-6 col-md-8\">\r\n            <button\r\n              class=\"btn Spa_Style_PrimaryButton\"\r\n              (click)=\"emitStatementAction(statement?.statementAction)\"\r\n              (keyup.enter)=\"emitStatementAction(statement?.statementAction)\"\r\n            >\r\n              {{ statement?.buttonText }}\r\n            </button>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"inputTypes.PHONE\">\r\n        <div class=\"row mb-4\">\r\n          <div class=\"col-12\">\r\n            <label\r\n              [for]=\"statement?.name\"\r\n              class=\"Spa_Style_Small_Font Spa_Style_Semi_Bold_Weight\"\r\n              [ngClass]=\"{ 'error-color': isControlInvalid }\"\r\n              >{{ statement?.value }} <span class=\"error-color Spa_Style_Bold_Weight\">*</span></label\r\n            >\r\n          </div>\r\n\r\n          <div class=\"col-12 col-sm-6 col-md-4 mb-3 mb-sm-0\">\r\n            <input\r\n              class=\"w-100\"\r\n              type=\"text\"\r\n              inputmode=\"numeric\"\r\n              autocomplete=\"off\"\r\n              aria-required=\"true\"\r\n              [id]=\"statement?.name\"\r\n              [mask]=\"phoneMask\"\r\n              [maxLength]=\"phoneMask.length\"\r\n              [ngClass]=\"{ 'has-error': isControlInvalid }\"\r\n              [formControl]=\"control\"\r\n              [attr.aria-describedby]=\"isControlInvalid ? statement?.name + 'Error' : null\"\r\n            />\r\n          </div>\r\n\r\n          <div *ngIf=\"statement?.buttonText\" class=\"col-12 col-sm-6 col-md-8\">\r\n            <button\r\n              class=\"btn Spa_Style_PrimaryButton\"\r\n              (click)=\"emitStatementAction(statement?.statementAction)\"\r\n              (keyup.enter)=\"emitStatementAction(statement?.statementAction)\"\r\n            >\r\n              {{ statement?.buttonText }}\r\n            </button>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"inputTypes.TEXT\">\r\n        <div class=\"row mb-4\">\r\n          <div class=\"col-12\">\r\n            <label\r\n              class=\"Spa_Style_Small_Font Spa_Style_Semi_Bold_Weight\"\r\n              [for]=\"statement?.name\"\r\n              [ngClass]=\"{ 'error-color': isControlInvalid }\"\r\n              >{{ statement?.value }} <span class=\"error-color Spa_Style_Bold_Weight\">*</span></label\r\n            >\r\n          </div>\r\n\r\n          <div class=\"col-12 col-sm-6 col-md-4 mb-3 mb-sm-0\">\r\n            <input\r\n              class=\"w-100\"\r\n              type=\"text\"\r\n              autocomplete=\"off\"\r\n              aria-required=\"true\"\r\n              [id]=\"statement?.name\"\r\n              [ngClass]=\"{ 'has-error': isControlInvalid }\"\r\n              [formControl]=\"control\"\r\n              [attr.aria-describedby]=\"isControlInvalid ? statement?.name + 'Error' : null\"\r\n            />\r\n          </div>\r\n\r\n          <div *ngIf=\"statement?.buttonText\" class=\"col-12 col-sm-6 col-md-8\">\r\n            <button\r\n              class=\"btn Spa_Style_PrimaryButton\"\r\n              (click)=\"emitStatementAction(statement?.statementAction)\"\r\n              (keyup.enter)=\"emitStatementAction(statement?.statementAction)\"\r\n            >\r\n              {{ statement?.buttonText }}\r\n            </button>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n    </ng-container>\r\n\r\n    <ul *ngIf=\"statement?.displaySubStatementsAsList\">\r\n      <li *ngFor=\"let subStatement of statement?.subStatements; trackBy: trackBySubStatementName\">\r\n        <vnext-widget-authorization-code-signature-statement [statement]=\"subStatement\" [displayAsListItem]=\"true\">\r\n        </vnext-widget-authorization-code-signature-statement>\r\n      </li>\r\n    </ul>\r\n\r\n    <div\r\n      *ngIf=\"statement?.instructionalText\"\r\n      class=\"instructional-text Spa_Style_Note ml-4 mb-2\"\r\n      [innerHTML]=\"statement?.instructionalText | safe : 'html'\"\r\n    ></div>\r\n  </div>\r\n</div>\r\n", styles: ["label{cursor:pointer}.checkbox-wrapper{margin-top:2px}.radio-options-container{display:flex;flex-direction:row;column-gap:10px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { statement: [{
            type: Input
        }], control: [{
            type: Input
        }], requiredText: [{
            type: Input
        }], invalidEmailText: [{
            type: Input
        }], invalidPhoneText: [{
            type: Input
        }], invalidCodeText: [{
            type: Input
        }], fieldHasError: [{
            type: Input
        }], displayAsListItem: [{
            type: Input
        }], valueUpdated: [{
            type: Output
        }], statementAction: [{
            type: Output
        }] }); })();

function AuthorizationCodeSignatureModalComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r0.headerInstructionalText, "html"), i0.ɵɵsanitizeHtml);
} }
function AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 17);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const section_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, section_r4.sectionHeader, "html"), i0.ɵɵsanitizeHtml);
} }
function AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 18);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const section_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, section_r4.preInstructionalText, "html"), i0.ɵɵsanitizeHtml);
} }
function AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_ng_container_1_ng_container_3_div_1_vnext_widget_authorization_code_signature_statement_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-widget-authorization-code-signature-statement", 20);
    i0.ɵɵlistener("valueUpdated", function AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_ng_container_1_ng_container_3_div_1_vnext_widget_authorization_code_signature_statement_1_Template_vnext_widget_authorization_code_signature_statement_valueUpdated_0_listener($event) { i0.ɵɵrestoreView(_r19); const statement_r15 = i0.ɵɵnextContext().$implicit; const ctx_r17 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r17.updateControl(statement_r15 == null ? null : statement_r15.name, $event)); })("statementAction", function AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_ng_container_1_ng_container_3_div_1_vnext_widget_authorization_code_signature_statement_1_Template_vnext_widget_authorization_code_signature_statement_statementAction_0_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r20 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r20.handleStatementAction($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const statement_r15 = i0.ɵɵnextContext().$implicit;
    const ctx_r16 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("statement", statement_r15)("control", ctx_r16.authorizationCodeSignatureFormGroup.controls[statement_r15 == null ? null : statement_r15.name])("requiredText", ctx_r16.requiredText)("invalidEmailText", ctx_r16.invalidEmailText)("invalidPhoneText", ctx_r16.invalidPhoneText)("invalidCodeText", ctx_r16.invalidCodeText);
} }
function AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_ng_container_1_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_ng_container_1_ng_container_3_div_1_vnext_widget_authorization_code_signature_statement_1_Template, 1, 6, "vnext-widget-authorization-code-signature-statement", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const statement_r15 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (statement_r15 == null ? null : statement_r15.visible) !== false);
} }
function AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_ng_container_1_ng_container_3_div_1_Template, 2, 1, "div", 10);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const section_r4 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", section_r4.statements)("ngForTrackBy", ctx_r8.trackByStatementName);
} }
function AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_ng_container_1_ng_template_4_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelement(1, "vnext-widget-authorization-code-signature-statement", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const statement_r24 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("statement", statement_r24)("displayAsListItem", true);
} }
function AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_ng_container_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul");
    i0.ɵɵtemplate(1, AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_ng_container_1_ng_template_4_li_1_Template, 2, 2, "li", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const section_r4 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", section_r4 == null ? null : section_r4.statements)("ngForTrackBy", ctx_r10.trackByStatementName);
} }
function AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_ng_container_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 22);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const section_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, section_r4.instructionalText, "html"), i0.ɵɵsanitizeHtml);
} }
function AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_ng_container_1_div_1_Template, 2, 4, "div", 12);
    i0.ɵɵtemplate(2, AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_ng_container_1_div_2_Template, 2, 4, "div", 13);
    i0.ɵɵtemplate(3, AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_ng_container_1_ng_container_3_Template, 2, 2, "ng-container", 14);
    i0.ɵɵtemplate(4, AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_ng_container_1_ng_template_4_Template, 2, 2, "ng-template", null, 15, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(6, AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_ng_container_1_div_6_Template, 2, 4, "div", 16);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r9 = i0.ɵɵreference(5);
    const section_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", section_r4 == null ? null : section_r4.sectionHeader);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", section_r4 == null ? null : section_r4.preInstructionalText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(section_r4 == null ? null : section_r4.displayStatementsAsList))("ngIfElse", _r9);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", section_r4 == null ? null : section_r4.instructionalText);
} }
function AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_ng_container_1_Template, 7, 5, "ng-container", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const section_r4 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (section_r4 == null ? null : section_r4.visible) !== false);
} }
function AuthorizationCodeSignatureModalComponent_form_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "form", 9);
    i0.ɵɵtemplate(1, AuthorizationCodeSignatureModalComponent_form_3_ng_container_1_Template, 2, 1, "ng-container", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.authorizationCodeSignatureFormGroup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.authorizationCodeSignatureSections)("ngForTrackBy", ctx_r1.trackBySectionName);
} }
function AuthorizationCodeSignatureModalComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function AuthorizationCodeSignatureModalComponent_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r28.cancel()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.cancelButtonText, " ");
} }
class AuthorizationCodeSignatureModalComponent {
    constructor(formBuilder, cdr, externalErrorLoggingService) {
        this.formBuilder = formBuilder;
        this.cdr = cdr;
        this.externalErrorLoggingService = externalErrorLoggingService;
        this.authCodeLength = 6;
        this.authorizationCodeSignatureSections = [];
        this.cancelButtonEnabled = true;
        this.authorizationCodeVerified = false;
        this.sendEmailDebounceTime = 75;
        this.subscriptions = new Subscription();
        this.requestSendAuthorizationCodeSub$ = new Subject();
        this.requestValidateAuthorizationCodeSub$ = new Subject();
        this.signatureAgreementSectionNames = [
            AuthorizationCodeSignatureModalSectionNames.AGREE_TO_TERMS_AND_CONDITIONS_APPLICANT,
            AuthorizationCodeSignatureModalSectionNames.AGENT_SIGNATURE,
            AuthorizationCodeSignatureModalSectionNames.AGREE_TO_TERMS_AND_CONDITIONS_AGENT
        ];
        this.cancel = () => {
            this.cancelAction?.();
        };
        this.confirm = () => {
            this.authorizationCodeSignatureFormGroup.markAllAsTouched();
            this.statements?.forEach(statement => {
                statement.updateFieldValidity();
            });
            const isAuthorizationCodeSignatureComplete = this.isAuthorizationCodeSignatureComplete();
            if (isAuthorizationCodeSignatureComplete) {
                this.confirmAction?.(isAuthorizationCodeSignatureComplete);
            }
        };
    }
    ngOnInit() {
        // We clone deep the sections because they're used as initial state and are mutated during the modal's flow.
        // Without clone deep, the processed resource's value will be affected.
        this.authorizationCodeSignatureSections = _cloneDeep(this.authorizationCodeSignatureSections);
        this.authorizationCodeSignatureFormGroup = this.initializeAuthorizationCodeSignatureFormGroup();
        const contactTypeControl = this.authorizationCodeSignatureFormGroup.controls[AuthorizationCodeSignatureModalFieldNames.CONTACT_TYPE_FIELD_NAME];
        const sendAuthorizationCodeSection = this.authorizationCodeSignatureSections.find(section => section.sectionName === AuthorizationCodeSignatureModalSectionNames.SEND_AUTHORIZATION_CODE);
        this.phoneStatement = sendAuthorizationCodeSection?.statements?.find(statement => statement.name === AuthorizationCodeSignatureModalFieldNames.PHONE_FIELD_NAME);
        this.emailStatement = sendAuthorizationCodeSection?.statements?.find(statement => statement.name === AuthorizationCodeSignatureModalFieldNames.EMAIL_FIELD_NAME);
        this.updateControl(contactTypeControl.name, contactTypeControl.value);
        this.subscriptions.add(this.requestSendAuthorizationCodeSub$
            .asObservable()
            .pipe(debounceTime(this.sendEmailDebounceTime), exhaustMap(() => from(this.sendAuthorizationCode()).pipe(catchError(error => {
            this.externalErrorLoggingService.log(error);
            return EMPTY;
        }))))
            .subscribe());
        this.subscriptions.add(this.requestValidateAuthorizationCodeSub$
            .asObservable()
            .pipe(debounceTime(this.sendEmailDebounceTime), exhaustMap(() => from(this.verifyAuthorizationCode()).pipe(catchError(error => {
            this.externalErrorLoggingService.log(error);
            return EMPTY;
        }))))
            .subscribe({
            next: (result) => {
                if (result?.status === AuthorizationCodeVerificationStatus.VALID) {
                    this.authorizationCodeVerified = true;
                }
                else if (result?.status === AuthorizationCodeVerificationStatus.INVALID) {
                    const verifyAuthenticationCodeStatement = this.statements?.find(statement => statement.statement.name === AuthorizationCodeSignatureModalFieldNames.VERIFY_AUTHORIZATION_CODE_FIELD_NAME);
                    verifyAuthenticationCodeStatement?.updateFieldValidity(true);
                    this.authorizationCodeVerified = false;
                }
                else {
                    this.authorizationCodeVerified = false;
                }
                this.toggleSignatureAgreementSections(this.authorizationCodeVerified);
                this.cdr.markForCheck();
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    updateControl(fieldName, value) {
        if (fieldName === AuthorizationCodeSignatureModalFieldNames.CONTACT_TYPE_FIELD_NAME) {
            this.updateStatementAndResetField(this.phoneStatement, value === ExternalContactTypes.TEXT);
            this.updateStatementAndResetField(this.emailStatement, value === ExternalContactTypes.EMAIL);
        }
        this.cdr.markForCheck();
    }
    handleStatementAction(statementAction) {
        if (statementAction === AuthorizationCodeStatementActions.SEND_AUTHORIZATION_CODE) {
            this.requestSendAuthorizationCode();
        }
        else if (statementAction === AuthorizationCodeStatementActions.VERIFY_AUTHORIZATION_CODE) {
            this.requestValidateAuthorizationCode();
        }
    }
    trackBySectionName(index, section) {
        return section.sectionName;
    }
    trackByStatementName(index, statement) {
        return statement.name;
    }
    requestSendAuthorizationCode() {
        this.requestSendAuthorizationCodeSub$.next(null);
    }
    requestValidateAuthorizationCode() {
        this.requestValidateAuthorizationCodeSub$.next(null);
    }
    async sendAuthorizationCode() {
        const contactTypeControl = this.authorizationCodeSignatureFormGroup.controls[AuthorizationCodeSignatureModalFieldNames.CONTACT_TYPE_FIELD_NAME];
        const phoneControl = this.authorizationCodeSignatureFormGroup.controls[AuthorizationCodeSignatureModalFieldNames.PHONE_FIELD_NAME];
        const emailControl = this.authorizationCodeSignatureFormGroup.controls[AuthorizationCodeSignatureModalFieldNames.EMAIL_FIELD_NAME];
        if (contactTypeControl?.valid && (phoneControl?.valid || emailControl?.valid)) {
            const deliverySettings = {
                type: contactTypeControl.value
            };
            if (deliverySettings.type === ExternalContactTypes.TEXT && phoneControl?.valid) {
                deliverySettings.sendTextRequest = await this.createProcessedTextMessage(phoneControl.value);
                return this.createAuthorizationCode(deliverySettings);
            }
            else if (deliverySettings.type === ExternalContactTypes.EMAIL && emailControl?.valid) {
                deliverySettings.sendEmailSettings = await this.createProcessedEmail(EmailNames.ELECTRONIC_SIGNATURE_AUTH_CODE, [emailControl.value], this.emailSubject);
                return this.createAuthorizationCode(deliverySettings);
            }
        }
    }
    async verifyAuthorizationCode() {
        const verifyAuthorizationCodeControl = this.authorizationCodeSignatureFormGroup.controls[AuthorizationCodeSignatureModalFieldNames.VERIFY_AUTHORIZATION_CODE_FIELD_NAME];
        if (verifyAuthorizationCodeControl?.valid) {
            return this.validateAuthorizationCode(verifyAuthorizationCodeControl.value);
        }
    }
    initializeAuthorizationCodeSignatureFormGroup() {
        const dynamicFormGroup = this.authorizationCodeSignatureSections?.reduce((authorizationCodeSignatureForm, section) => {
            section?.statements?.forEach((statement) => {
                if (statement.inputType) {
                    const isCheckboxControl = statement.inputType === InputTypes.CHECKBOX;
                    const validators = isCheckboxControl ? [Validators.requiredTrue] : [Validators.required];
                    let controlDefaultState = isCheckboxControl ? false : null;
                    if (statement.inputType === InputTypes.EMAIL) {
                        validators.push(Validators.maxLength(255), Validators.pattern(FormValidationService.emailPattern));
                    }
                    else if (statement.inputType === InputTypes.PHONE) {
                        validators.push(Validators.minLength(10), Validators.maxLength(10), Validators.pattern(FormValidationService.phoneNumberPattern));
                    }
                    else if (statement.inputType === InputTypes.TEXT) {
                        validators.push(Validators.minLength(this.authCodeLength), Validators.maxLength(this.authCodeLength), Validators.pattern(/^\d+?$/));
                    }
                    else if (statement.inputType === InputTypes.RADIO) {
                        controlDefaultState = ExternalContactTypes.TEXT;
                    }
                    authorizationCodeSignatureForm[statement.name] = VnextFormControl.create({
                        name: statement.name,
                        formState: controlDefaultState,
                        validatorOrOpts: { validators }
                    });
                }
            });
            return authorizationCodeSignatureForm;
        }, {}) ?? {};
        return this.formBuilder.group(dynamicFormGroup, { updateOn: 'blur' });
    }
    updateStatementAndResetField(statement, shouldShowStatement) {
        if (statement) {
            statement.visible = shouldShowStatement;
            if (!shouldShowStatement) {
                this.authorizationCodeSignatureFormGroup.controls[statement.name]?.reset();
            }
        }
    }
    toggleSignatureAgreementSections(shouldShowSection) {
        let updateSectionsReference = false;
        for (const sectionName of this.signatureAgreementSectionNames) {
            const foundSection = this.authorizationCodeSignatureSections.find(section => section.sectionName === sectionName);
            if (foundSection) {
                foundSection.visible = shouldShowSection;
                updateSectionsReference = true;
            }
        }
        if (updateSectionsReference) {
            // We update the reference to trigger a change detection after calling markForCheck()
            this.authorizationCodeSignatureSections = [...this.authorizationCodeSignatureSections];
        }
    }
    isAuthorizationCodeSignatureComplete() {
        const authorizationCodeSignatureFormValues = this.authorizationCodeSignatureFormGroup?.value;
        if (authorizationCodeSignatureFormValues) {
            return (authorizationCodeSignatureFormValues[AuthorizationCodeSignatureModalFieldNames.AGREE_TO_TERMS_AND_CONDITIONS_APPLICANT] &&
                authorizationCodeSignatureFormValues[AuthorizationCodeSignatureModalFieldNames.AGREE_TO_TERMS_AND_CONDITIONS_AGENT]);
        }
        return false;
    }
}
AuthorizationCodeSignatureModalComponent.ɵfac = function AuthorizationCodeSignatureModalComponent_Factory(t) { return new (t || AuthorizationCodeSignatureModalComponent)(i0.ɵɵdirectiveInject(i4.UntypedFormBuilder), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.ExternalErrorLoggingService)); };
AuthorizationCodeSignatureModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AuthorizationCodeSignatureModalComponent, selectors: [["ng-component"]], viewQuery: function AuthorizationCodeSignatureModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(AuthorizationCodeSignatureStatementComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.statements = _t);
    } }, decls: 9, vars: 6, consts: [[3, "modalTitleText", "hideCloseButton", "modalTitleCancelAction"], ["tabindex", "-1", 1, "modal-body", "col-12"], ["class", "mb-1 Spa_Style_Primary_Color", 3, "innerHTML", 4, "ngIf"], [3, "formGroup", 4, "ngIf"], [1, "modal-footer", "justify-content-start"], [1, "mr-auto"], ["class", "btn Spa_Style_SecondaryButton", "type", "button", 3, "click", 4, "ngIf"], ["type", "button", 1, "btn", "Spa_Style_PrimaryButton", "ml-auto", 3, "click"], [1, "mb-1", "Spa_Style_Primary_Color", 3, "innerHTML"], [3, "formGroup"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [4, "ngIf"], ["class", "pb-1 mt-2", 3, "innerHTML", 4, "ngIf"], ["class", "Spa_Style_Paragraph", 3, "innerHTML", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["displayStatementsAsList", ""], ["class", "pb-2 Spa_Style_Primary_Color Spa_Style_Note", 3, "innerHTML", 4, "ngIf"], [1, "pb-1", "mt-2", 3, "innerHTML"], [1, "Spa_Style_Paragraph", 3, "innerHTML"], [3, "statement", "control", "requiredText", "invalidEmailText", "invalidPhoneText", "invalidCodeText", "valueUpdated", "statementAction", 4, "ngIf"], [3, "statement", "control", "requiredText", "invalidEmailText", "invalidPhoneText", "invalidCodeText", "valueUpdated", "statementAction"], [3, "statement", "displayAsListItem"], [1, "pb-2", "Spa_Style_Primary_Color", "Spa_Style_Note", 3, "innerHTML"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", 3, "click"]], template: function AuthorizationCodeSignatureModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function AuthorizationCodeSignatureModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.cancelAction(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, AuthorizationCodeSignatureModalComponent_div_2_Template, 2, 4, "div", 2);
        i0.ɵɵtemplate(3, AuthorizationCodeSignatureModalComponent_form_3_Template, 2, 3, "form", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4)(5, "div", 5);
        i0.ɵɵtemplate(6, AuthorizationCodeSignatureModalComponent_button_6_Template, 2, 1, "button", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "button", 7);
        i0.ɵɵlistener("click", function AuthorizationCodeSignatureModalComponent_Template_button_click_7_listener() { return ctx.confirm(); });
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title)("hideCloseButton", !ctx.cancelButtonEnabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.headerInstructionalText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.authorizationCodeSignatureSections == null ? null : ctx.authorizationCodeSignatureSections.length);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.cancelButtonEnabled);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.continueButtonText);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, i4.ɵNgNoValidate, i4.NgControlStatusGroup, i4.FormGroupDirective, ModalHeaderComponent, AuthorizationCodeSignatureStatementComponent, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthorizationCodeSignatureModalComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header\r\n  [modalTitleText]=\"title\"\r\n  [hideCloseButton]=\"!cancelButtonEnabled\"\r\n  (modalTitleCancelAction)=\"cancelAction()\"\r\n></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body col-12\" tabindex=\"-1\">\r\n  <div *ngIf=\"headerInstructionalText\" [innerHTML]=\"headerInstructionalText | safe : 'html'\" class=\"mb-1 Spa_Style_Primary_Color\"></div>\r\n  <form *ngIf=\"authorizationCodeSignatureSections?.length\" [formGroup]=\"authorizationCodeSignatureFormGroup\">\r\n    <ng-container *ngFor=\"let section of authorizationCodeSignatureSections; trackBy: trackBySectionName\">\r\n      <ng-container *ngIf=\"section?.visible !== false\">\r\n        <div *ngIf=\"section?.sectionHeader\" class=\"pb-1 mt-2\" [innerHTML]=\"section.sectionHeader | safe : 'html'\"></div>\r\n        <div\r\n          *ngIf=\"section?.preInstructionalText\"\r\n          class=\"Spa_Style_Paragraph\"\r\n          [innerHTML]=\"section.preInstructionalText | safe : 'html'\"\r\n        ></div>\r\n        <ng-container *ngIf=\"!section?.displayStatementsAsList; else displayStatementsAsList\">\r\n          <div *ngFor=\"let statement of section.statements; trackBy: trackByStatementName\">\r\n            <vnext-widget-authorization-code-signature-statement\r\n              *ngIf=\"statement?.visible !== false\"\r\n              [statement]=\"statement\"\r\n              [control]=\"authorizationCodeSignatureFormGroup.controls[statement?.name]\"\r\n              [requiredText]=\"requiredText\"\r\n              [invalidEmailText]=\"invalidEmailText\"\r\n              [invalidPhoneText]=\"invalidPhoneText\"\r\n              [invalidCodeText]=\"invalidCodeText\"\r\n              (valueUpdated)=\"updateControl(statement?.name, $event)\"\r\n              (statementAction)=\"handleStatementAction($event)\"\r\n            >\r\n            </vnext-widget-authorization-code-signature-statement>\r\n          </div>\r\n        </ng-container>\r\n\r\n        <ng-template #displayStatementsAsList>\r\n          <ul>\r\n            <li *ngFor=\"let statement of section?.statements; trackBy: trackByStatementName\">\r\n              <vnext-widget-authorization-code-signature-statement [statement]=\"statement\" [displayAsListItem]=\"true\">\r\n              </vnext-widget-authorization-code-signature-statement>\r\n            </li>\r\n          </ul>\r\n        </ng-template>\r\n\r\n        <div\r\n          *ngIf=\"section?.instructionalText\"\r\n          class=\"pb-2 Spa_Style_Primary_Color Spa_Style_Note\"\r\n          [innerHTML]=\"section.instructionalText | safe : 'html'\"\r\n        ></div>\r\n      </ng-container>\r\n    </ng-container>\r\n  </form>\r\n</div>\r\n\r\n<div class=\"modal-footer justify-content-start\">\r\n  <div class=\"mr-auto\">\r\n    <button *ngIf=\"cancelButtonEnabled\" class=\"btn Spa_Style_SecondaryButton\" type=\"button\" (click)=\"cancel()\">\r\n      {{ cancelButtonText }}\r\n    </button>\r\n  </div>\r\n  <button type=\"button\" class=\"btn Spa_Style_PrimaryButton ml-auto\" (click)=\"confirm()\">{{ continueButtonText }}</button>\r\n</div>\r\n" }]
    }], function () { return [{ type: i4.UntypedFormBuilder }, { type: i0.ChangeDetectorRef }, { type: i1.ExternalErrorLoggingService }]; }, { statements: [{
            type: ViewChildren,
            args: [AuthorizationCodeSignatureStatementComponent]
        }] }); })();

function EmailConfirmationModalComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function EmailConfirmationModalComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
} }
const _c0$3x = function (a0, a1, a2) { return { "label-error": a0, "Spa_Style_Bold_Weight": a1, "Spa_Style_Regular_Weight": a2 }; };
const _c1$1S = function (a0) { return { "input-error": a0 }; };
class EmailConfirmationModalComponent {
    constructor(activeModal, formBuilder, profileService, agentService, navigationService, externalErrorLoggingService) {
        this.activeModal = activeModal;
        this.formBuilder = formBuilder;
        this.profileService = profileService;
        this.agentService = agentService;
        this.navigationService = navigationService;
        this.externalErrorLoggingService = externalErrorLoggingService;
        this.errors = [];
        this.isBold = true;
        this.updateErrors = () => {
            this.errors = [];
            if (this.emailControl.errors) {
                if (this.emailControl.errors.required) {
                    this.errors.push(this.emailAddressRequired);
                }
                if (this.emailControl.errors.email) {
                    this.errors.push(this.emailAddressInvalid);
                }
            }
        };
    }
    ngOnInit() {
        this.emailControl = new UntypedFormControl('', [Validators.required, Validators.email]);
        this.emailFormGroup = this.formBuilder.group({ email: this.emailControl });
        this.initialEmail = this.profileService.getEmailAddress();
        if (this.updateAgentEmailAddress) {
            this.isBold = false;
        }
        if (this.isSendEnrollment) {
            this.emailControl.patchValue(this.initialEmail);
        }
    }
    sendEmail() {
        this.updateErrors();
        const email = this.emailFormGroup.controls.email.value;
        if (!this.emailFormGroup.invalid) {
            if (this.updateAgentEmailAddress) {
                const agent = {
                    emailAddress: email,
                    isActive: true
                };
                const loginAgentGuid = this.agentService.getAgentInContextGuid();
                this.agentService
                    .updateViewedAgentSession$(this.agentGuid, agent, loginAgentGuid)
                    .pipe(take(1))
                    .subscribe({
                    next: (agentData) => {
                        if (agentData) {
                            const agentGuid = this.agentService.getAgentInContextGuid();
                            this.navigationService.navigateToLmsInNewTab(agentGuid);
                        }
                    },
                    error: error => {
                        this.externalErrorLoggingService.log(error);
                    }
                });
            }
            else {
                // update member profile email address
                if (this.isEmailUpdated(email)) {
                    this.profileService.updateEmailAddressInSession(email);
                }
            }
            this.activeModal.close(email);
        }
    }
    isEmailUpdated(email) {
        return this.initialEmail !== email && this.isSendEnrollment;
    }
}
EmailConfirmationModalComponent.ɵfac = function EmailConfirmationModalComponent_Factory(t) { return new (t || EmailConfirmationModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i4.UntypedFormBuilder), i0.ɵɵdirectiveInject(i1.ProfileService), i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.ExternalErrorLoggingService)); };
EmailConfirmationModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EmailConfirmationModalComponent, selectors: [["ng-component"]], decls: 18, vars: 17, consts: [[3, "modalTitleText", "modalTitleCancelAction"], ["disableKeyDownSubmit", "", 3, "formGroup", "ngSubmit"], [1, "modal-body"], [3, "errors"], ["for", "email-to-input", 1, "w-100"], ["id", "email-to-label", 3, "ngClass"], ["id", "email-to-asterisk", "class", "input-error-asterisk", 4, "ngIf"], [1, "row", "mb-4", "no-gutters"], [1, "col"], ["id", "email-to-input", "type", "email", "autocomplete", "off", 1, "w-100", 3, "ngClass", "formControl"], ["class", "col-3", 4, "ngIf"], [1, "modal-footer", "justify-content-start"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "mr-auto", 3, "click"], ["type", "submit", 1, "btn", "Spa_Style_PrimaryButton"], ["id", "email-to-asterisk", 1, "input-error-asterisk"], [1, "col-3"]], template: function EmailConfirmationModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function EmailConfirmationModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.activeModal.dismiss(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "form", 1);
        i0.ɵɵlistener("ngSubmit", function EmailConfirmationModalComponent_Template_form_ngSubmit_1_listener() { return ctx.sendEmail(); });
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelement(3, "vnext-widget-field-errors", 3);
        i0.ɵɵelementStart(4, "label", 4)(5, "span", 5);
        i0.ɵɵtemplate(6, EmailConfirmationModalComponent_span_6_Template, 2, 0, "span", 6);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(8, "br");
        i0.ɵɵelementStart(9, "div", 7)(10, "div", 8);
        i0.ɵɵelement(11, "input", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, EmailConfirmationModalComponent_div_12_Template, 1, 0, "div", 10);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(13, "div", 11)(14, "button", 12);
        i0.ɵɵlistener("click", function EmailConfirmationModalComponent_Template_button_click_14_listener() { return ctx.activeModal.dismiss(); });
        i0.ɵɵtext(15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "button", 13);
        i0.ɵɵtext(17);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.emailFormGroup);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("errors", ctx.errors);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(11, _c0$3x, ctx.errors.length > 0, ctx.isBold, !ctx.isBold));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !(ctx.isSendEnrollment || ctx.updateAgentEmailAddress));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.emailPrompt, " ");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c1$1S, ctx.errors.length > 0))("formControl", ctx.emailControl);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSendEnrollment);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.cancelButton);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.confirmButton);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormControlDirective, i4.FormGroupDirective, FormInputSubmitDirective, FieldErrorsComponent, ModalHeaderComponent], styles: ["#email-to-label[_ngcontent-%COMP%]{font-size:var(--Spa_Style_Regular_Font);margin-bottom:0}.label-error[_ngcontent-%COMP%], #email-to-asterisk[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent2)}.input-error[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent2)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EmailConfirmationModalComponent, [{
        type: Component,
        args: [{ template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"activeModal.dismiss()\"></vnext-widget-modal-header>\r\n\r\n<form disableKeyDownSubmit [formGroup]=\"emailFormGroup\" (ngSubmit)=\"sendEmail()\">\r\n  <div class=\"modal-body\">\r\n    <vnext-widget-field-errors [errors]=\"errors\"></vnext-widget-field-errors>\r\n    <label class=\"w-100\" for=\"email-to-input\">\r\n      <span\r\n        id=\"email-to-label\"\r\n        [ngClass]=\"{ 'label-error': errors.length > 0, 'Spa_Style_Bold_Weight': isBold, 'Spa_Style_Regular_Weight': !isBold }\"\r\n      >\r\n        <span *ngIf=\"!(isSendEnrollment || updateAgentEmailAddress)\" id=\"email-to-asterisk\" class=\"input-error-asterisk\">*</span>\r\n        {{ emailPrompt }}\r\n      </span>\r\n      <br />\r\n      <div class=\"row mb-4 no-gutters\">\r\n        <div class=\"col\">\r\n          <input\r\n            id=\"email-to-input\"\r\n            type=\"email\"\r\n            autocomplete=\"off\"\r\n            class=\"w-100\"\r\n            [ngClass]=\"{ 'input-error': errors.length > 0 }\"\r\n            [formControl]=\"emailControl\"\r\n          />\r\n        </div>\r\n        <div *ngIf=\"isSendEnrollment\" class=\"col-3\"></div>\r\n      </div>\r\n    </label>\r\n  </div>\r\n  <div class=\"modal-footer justify-content-start\">\r\n    <button type=\"button\" (click)=\"activeModal.dismiss()\" class=\"btn Spa_Style_SecondaryButton mr-auto\">{{ cancelButton }}</button>\r\n    <button type=\"submit\" class=\"btn Spa_Style_PrimaryButton\">{{ confirmButton }}</button>\r\n  </div>\r\n</form>\r\n", styles: ["#email-to-label{font-size:var(--Spa_Style_Regular_Font);margin-bottom:0}.label-error,#email-to-asterisk{color:var(--static-Spa_Style_Accent2)}.input-error{border-color:var(--static-Spa_Style_Accent2)}\n"] }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i4.UntypedFormBuilder }, { type: i1.ProfileService }, { type: i1.AgentService }, { type: i1.NavigationService }, { type: i1.ExternalErrorLoggingService }]; }, null); })();

const _c0$3w = ["closeBtn"];
function EmailConfirmationSuccessModalComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r0.subPrompt, "html"), i0.ɵɵsanitizeHtml);
} }
function EmailConfirmationSuccessModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r1.crossSellPrompt, "html"), i0.ɵɵsanitizeHtml);
} }
function EmailConfirmationSuccessModalComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "vnext-link", 13);
    i0.ɵɵlistener("click", function EmailConfirmationSuccessModalComponent_div_5_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.redirect()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r2.redirectPrompt)("makeInlineBlock", true);
} }
function EmailConfirmationSuccessModalComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "vnext-followup-task", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("taskType", ctx_r3.taskType)("followUpTaskText", ctx_r3.followUpTaskText);
} }
function EmailConfirmationSuccessModalComponent_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function EmailConfirmationSuccessModalComponent_button_11_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.continueApplying()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.continueApplyingButton, " ");
} }
function EmailConfirmationSuccessModalComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r7.subPrompt);
} }
class EmailConfirmationSuccessModalComponent {
    constructor(activeModal, configResourceService, enrollmentFormService) {
        this.activeModal = activeModal;
        this.configResourceService = configResourceService;
        this.enrollmentFormService = enrollmentFormService;
        this.taskType = NoteActionType.EnrollmentTask;
    }
    ngOnInit() {
        this.isAddFollowUpTaskEnabled = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_AddFollowUp_Enabled', null, false);
        if (this.isAddFollowUpTaskEnabled) {
            this.loadFollowUpTaskAttributes();
        }
    }
    loadFollowUpTaskAttributes(widgetName) {
        const followUpText = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_FollowUp_Enrollment_Text', widgetName, 'Follow up on Application for <plan name>');
        const enrollingPlanId = this.enrollmentFormService.getActiveEnrollmentKey();
        this.followUpTaskText = followUpText ? followUpText.replace('<plan name>', enrollingPlanId) : '';
    }
    redirect() {
        const modalEvent = { eventType: ModalEventType.REDIRECT };
        this.activeModal.close(modalEvent);
    }
    continueApplying() {
        const modalEvent = { eventType: ModalEventType.CROSSSELL_APPLY };
        this.activeModal.close(modalEvent);
    }
}
EmailConfirmationSuccessModalComponent.ɵfac = function EmailConfirmationSuccessModalComponent_Factory(t) { return new (t || EmailConfirmationSuccessModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.EnrollmentFormService)); };
EmailConfirmationSuccessModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EmailConfirmationSuccessModalComponent, selectors: [["ng-component"]], viewQuery: function EmailConfirmationSuccessModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3w, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.closeBtn = _t.first);
    } }, decls: 14, vars: 9, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "modal-body"], [3, "type", "title"], ["class", "Spa_Style_Paragraph mt-2", 3, "innerHtml", 4, "ngIf"], ["class", "mt-3 mb-n3", 4, "ngIf"], ["class", "mb-4", 4, "ngIf"], [1, "modal-footer", "justify-content-start"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "mr-auto", 3, "click"], ["closeBtn", ""], ["type", "button", "class", "btn Spa_Style_PrimaryButton ml-auto", 3, "click", 4, "ngIf"], ["defaultSubPrompt", ""], [1, "Spa_Style_Paragraph", "mt-2", 3, "innerHtml"], [1, "mt-3", "mb-n3"], [3, "title", "makeInlineBlock", "click"], [1, "mb-4"], [3, "taskType", "followUpTaskText"], ["type", "button", 1, "btn", "Spa_Style_PrimaryButton", "ml-auto", 3, "click"], [1, "Spa_Style_Paragraph"]], template: function EmailConfirmationSuccessModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function EmailConfirmationSuccessModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.activeModal.dismiss(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "vnext-notice", 2);
        i0.ɵɵtemplate(3, EmailConfirmationSuccessModalComponent_div_3_Template, 2, 4, "div", 3);
        i0.ɵɵtemplate(4, EmailConfirmationSuccessModalComponent_div_4_Template, 2, 4, "div", 3);
        i0.ɵɵtemplate(5, EmailConfirmationSuccessModalComponent_div_5_Template, 2, 2, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, EmailConfirmationSuccessModalComponent_div_6_Template, 2, 2, "div", 5);
        i0.ɵɵelementStart(7, "div", 6)(8, "button", 7, 8);
        i0.ɵɵlistener("click", function EmailConfirmationSuccessModalComponent_Template_button_click_8_listener() { return ctx.activeModal.close(); });
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(11, EmailConfirmationSuccessModalComponent_button_11_Template, 2, 1, "button", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, EmailConfirmationSuccessModalComponent_ng_template_12_Template, 2, 1, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("type", "success")("title", ctx.prompt);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.subPrompt);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.crossSellPrompt);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.redirectPrompt);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isAddFollowUpTaskEnabled);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.closeButton, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.continueApplyingButton);
    } }, dependencies: [i1$2.NgIf, LinkComponent, FollowUpTaskComponent, NoticeComponent, ModalHeaderComponent, SafePipe], styles: [".success-message[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EmailConfirmationSuccessModalComponent, [{
        type: Component,
        args: [{ template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"activeModal.dismiss()\"></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body\">\r\n  <vnext-notice [type]=\"'success'\" [title]=\"prompt\"></vnext-notice>\r\n  <div *ngIf=\"subPrompt\" class=\"Spa_Style_Paragraph mt-2\" [innerHtml]=\"subPrompt | safe : 'html'\"></div>\r\n  <div *ngIf=\"crossSellPrompt\" class=\"Spa_Style_Paragraph mt-2\" [innerHtml]=\"crossSellPrompt | safe : 'html'\"></div>\r\n  <div *ngIf=\"redirectPrompt\" class=\"mt-3 mb-n3\">\r\n    <vnext-link [title]=\"redirectPrompt\" [makeInlineBlock]=\"true\" (click)=\"redirect()\"></vnext-link>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"isAddFollowUpTaskEnabled\" class=\"mb-4\">\r\n  <vnext-followup-task [taskType]=\"taskType\" [followUpTaskText]=\"followUpTaskText\"></vnext-followup-task>\r\n</div>\r\n<div class=\"modal-footer justify-content-start\">\r\n  <button #closeBtn type=\"button\" (click)=\"activeModal.close()\" class=\"btn Spa_Style_SecondaryButton mr-auto\">\r\n    {{ closeButton }}\r\n  </button>\r\n  <button *ngIf=\"continueApplyingButton\" type=\"button\" class=\"btn Spa_Style_PrimaryButton ml-auto\" (click)=\"continueApplying()\">\r\n    {{ continueApplyingButton }}\r\n  </button>\r\n</div>\r\n<ng-template #defaultSubPrompt>\r\n  <div class=\"Spa_Style_Paragraph\">{{ subPrompt }}</div>\r\n</ng-template>\r\n", styles: [".success-message{color:var(--static-Spa_Style_Cost_Text)}\n"] }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i1.ConfigResourceService }, { type: i1.EnrollmentFormService }]; }, { closeBtn: [{
            type: ViewChild,
            args: ['closeBtn']
        }] }); })();

const _c0$3v = ["tooltipController"];
function StatusButtonComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 4);
    i0.ɵɵelementContainerEnd();
} }
function StatusButtonComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.buttonText);
} }
const _c1$1R = function (a0, a1) { return { success: a0, error: a1 }; };
const _c2$18 = function (a0, a1) { return { "fa-exclamation-circle": a0, "fa-check-circle": a1 }; };
function StatusButtonComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "i", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c1$1R, ctx_r4.success, !ctx_r4.success));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c2$18, !ctx_r4.success, ctx_r4.success));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.message, " ");
} }
// Note to use this inside another component you will need to include the viewChild decorator
// example: @ViewChild(ButtonWithTooltipComponent, { static: false }) saveButton: ButtonWithTooltipComponent;
// You can then call its methods like so: this.saveButton.showSuccessMessage()
class StatusButtonComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.tooltipMessageSuccess = 'Success';
        this.tooltipMessageError = 'Error';
        this.buttonClass = 'Spa_Style_SecondaryButton';
        this.buttonText = 'Save';
        this.placement = 'top';
        this.isButtonTypeSubmit = false;
        this.showSpinner = false;
        this.success = true;
    }
    get message() {
        return this.success ? this.tooltipMessageSuccess : this.tooltipMessageError;
    }
    closeTooltip(wait = 0) {
        timer(wait)
            .pipe(take(1))
            .subscribe(() => {
            this.ngbToolTip.close();
        });
    }
    toggleSpinner(flag) {
        this.showSpinner = flag !== undefined ? flag : !this.showSpinner;
        this.cdr.markForCheck();
    }
    showSuccessMessage() {
        this.success = true;
        this.showSpinner = false;
        this.showTooltip();
    }
    showErrorMessage() {
        this.success = false;
        this.showSpinner = false;
        this.showTooltip();
    }
    showTooltip() {
        this.ngbToolTip.open();
    }
}
StatusButtonComponent.ɵfac = function StatusButtonComponent_Factory(t) { return new (t || StatusButtonComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
StatusButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StatusButtonComponent, selectors: [["vnext-status-button"]], viewQuery: function StatusButtonComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3v, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ngbToolTip = _t.first);
    } }, inputs: { tooltipMessageSuccess: "tooltipMessageSuccess", tooltipMessageError: "tooltipMessageError", buttonClass: "buttonClass", buttonText: "buttonText", placement: "placement", isButtonTypeSubmit: "isButtonTypeSubmit" }, decls: 6, vars: 8, consts: [["triggers", "manual", 3, "type", "ngbTooltip", "placement"], ["tooltipController", "ngbTooltip"], [4, "ngIf"], ["tooltip", ""], [1, "fas", "fa-spinner", "fa-spin"], [1, "text-center", 3, "ngClass"], ["aria-hidden", "true", 1, "fas", 3, "ngClass"]], template: function StatusButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0, 1);
        i0.ɵɵtemplate(2, StatusButtonComponent_ng_container_2_Template, 2, 0, "ng-container", 2);
        i0.ɵɵtemplate(3, StatusButtonComponent_ng_container_3_Template, 2, 1, "ng-container", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, StatusButtonComponent_ng_template_4_Template, 3, 9, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(5);
        i0.ɵɵclassMapInterpolate1("btn ", ctx.buttonClass, " w-100");
        i0.ɵɵpropertyInterpolate("placement", ctx.placement);
        i0.ɵɵproperty("type", ctx.isButtonTypeSubmit ? "submit" : "button")("ngbTooltip", _r3);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showSpinner);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.showSpinner);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$1.NgbTooltip, IconAriaAttributesDirective], styles: [".success[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text)}.error[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent2)}.DFSpaButton[_ngcontent-%COMP%]{height:100%!important;margin:0;border-radius:.25rem;font-family:montserrat_semibold!important}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StatusButtonComponent, [{
        type: Component,
        args: [{ selector: 'vnext-status-button', changeDetection: ChangeDetectionStrategy.OnPush, template: "<button\r\n  [type]=\"isButtonTypeSubmit ? 'submit' : 'button'\"\r\n  class=\"btn {{ buttonClass }} w-100\"\r\n  #tooltipController=\"ngbTooltip\"\r\n  [ngbTooltip]=\"tooltip\"\r\n  placement=\"{{ placement }}\"\r\n  triggers=\"manual\"\r\n>\r\n  <ng-container *ngIf=\"showSpinner\"><i class=\"fas fa-spinner fa-spin\"></i> </ng-container>\r\n  <ng-container *ngIf=\"!showSpinner\">{{ buttonText }}</ng-container>\r\n</button>\r\n\r\n<ng-template #tooltip>\r\n  <div class=\"text-center\" [ngClass]=\"{ success: success, error: !success }\">\r\n    <i class=\"fas\" [ngClass]=\"{ 'fa-exclamation-circle': !success, 'fa-check-circle': success }\" aria-hidden=\"true\"></i>\r\n    {{ message }}\r\n  </div>\r\n</ng-template>\r\n", styles: [".success{color:var(--static-Spa_Style_Cost_Text)}.error{color:var(--static-Spa_Style_Accent2)}.DFSpaButton{height:100%!important;margin:0;border-radius:.25rem;font-family:montserrat_semibold!important}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { tooltipMessageSuccess: [{
            type: Input
        }], tooltipMessageError: [{
            type: Input
        }], buttonClass: [{
            type: Input
        }], buttonText: [{
            type: Input
        }], placement: [{
            type: Input
        }], isButtonTypeSubmit: [{
            type: Input
        }], ngbToolTip: [{
            type: ViewChild,
            args: ['tooltipController']
        }] }); })();

class PlanListResourceFacade {
    constructor(configResourceService) {
        this.configResourceService = configResourceService;
    }
    isStarRatingEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_StarRating_Enabled', widgetName, true);
    }
    isPlanCardTotalEstimatedCostEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_TotalEstimatedCost_Enabled', widgetName, true);
    }
    getPlanListMedSupQuestionData(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanList_MedSupQuestion_Data', widgetName, [
            { key: 'DateOfBirth', defaultValue: '', ordinal: 1, required: true },
            { key: 'Gender', defaultValue: 'Male', ordinal: 3, required: true },
            { key: 'Tobacco', defaultValue: 'Smoker', ordinal: 4, required: false },
            { key: 'Weight', defaultValue: '', ordinal: 6, required: true },
            { key: 'Height', defaultValue: '', ordinal: 5, required: true },
            { key: 'PaymentMethod', defaultValue: '', ordinal: 7, required: true },
            { key: 'Household', defaultValue: '', ordinal: 8, required: true },
            { key: 'EffectiveDate', defaultValue: '', ordinal: 2, required: true },
            { key: 'PartAEffectiveDate', defaultValue: '', ordinal: 9, required: true },
            { key: 'PartBEffectiveDate', defaultValue: '', ordinal: 10, required: true },
            { key: 'GuaranteedIssue', defaultValue: '', ordinal: 12, required: true },
            { key: 'GIAdditional', defaultValue: '', ordinal: 11, required: true },
            { key: 'MillimanUWTier', defaultValue: 'P', ordinal: 13, hidden: true, required: true }
        ]);
    }
    getPlanListDentalVisionQuestionData(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanList_DentalVisionQuestion_Data', widgetName, [
            { key: 'DateOfBirth', defaultValue: '', ordinal: 1, required: true },
            { key: 'EffectiveDate', defaultValue: '', ordinal: 2, required: true },
            { key: 'Gender', defaultValue: '', ordinal: 3, required: true },
            { key: 'Tobacco', defaultValue: '', ordinal: 4, required: true },
            { key: 'Household', defaultValue: '', ordinal: 5, required: true }
        ]);
    }
    isMedSupFormPaymentMethodToggled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PaymentMethod_UseToggle', widgetName, false);
    }
    getMedSuppPaymentMethodUseToggle(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PaymentMethod_UseToggle', widgetName, false);
    }
    get planListGuaranteedIssueHeader() {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanList_GuaranteedIssue_Header', null, 'Do any of these apply to you?');
    }
    getEstCostMonthLabelByIndex(currentMonth, widgetName) {
        return currentMonth
            ? this.configResourceService.getProcessedResourceValue(`Spa_Site_Total_Est_Cost_Month_${currentMonth}`, widgetName, '')
            : '';
    }
}
PlanListResourceFacade.ɵfac = function PlanListResourceFacade_Factory(t) { return new (t || PlanListResourceFacade)(i0.ɵɵinject(i1.ConfigResourceService)); };
PlanListResourceFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlanListResourceFacade, factory: PlanListResourceFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanListResourceFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.ConfigResourceService }]; }, null); })();

class PlanListFacadeService {
    constructor(configurableWidgetService, planFacade, store, planListContext, planListResourceFacade, pharmacyFacade, plansService, configResourceService, guidedHelpService, snpService, medSupFacade, medSupService, preferencesService, navigationUtilityService, analyticsService, hospitalIndemnityFormFacade, millimanService, planYearResourceService, agentService, siteService) {
        this.configurableWidgetService = configurableWidgetService;
        this.planFacade = planFacade;
        this.store = store;
        this.planListContext = planListContext;
        this.planListResourceFacade = planListResourceFacade;
        this.pharmacyFacade = pharmacyFacade;
        this.plansService = plansService;
        this.configResourceService = configResourceService;
        this.guidedHelpService = guidedHelpService;
        this.snpService = snpService;
        this.medSupFacade = medSupFacade;
        this.medSupService = medSupService;
        this.preferencesService = preferencesService;
        this.navigationUtilityService = navigationUtilityService;
        this.analyticsService = analyticsService;
        this.hospitalIndemnityFormFacade = hospitalIndemnityFormFacade;
        this.millimanService = millimanService;
        this.planYearResourceService = planYearResourceService;
        this.agentService = agentService;
        this.siteService = siteService;
        this.plans$ = this.plansService.getFilteredPlansBySNPVisibility$();
        this.allPlans$ = this.plansService.getAllPlans$();
        // Global Resource and platform prop values
        this.Spa_StarRating_Enabled = true;
        this.Spa_Site_TotalEstimatedCost_Enabled = true;
        this.Spa_PlanList_BestMatchPlan_Enabled = false;
        this.Spa_MedSupForm_PaymentMethod_UseToggle = false;
        this.isMailOrder = false;
        this.isScoreExist = false;
        this.sortPrimaryKey = SortPrimaryKey;
        this.medigapBeforeAnswersSort = {
            primaryKey: this.sortPrimaryKey.IS_CURRENT_YEAR_PLAN,
            dataKey: SortLabels.MEDICAL_PREMIUM,
            secondaryDataKey: SortLabels.PLAN_NAME,
            dataKeyType: DataKeyType.NUMERIC,
            sortType: SortType.DESCENDING,
            displayName: this.getPlanListSortByPremiumLabel(),
            display: true,
            secondarySortType: SortType.ASCENDING,
            sortTransformer: null
        };
        this.medigapAfterAnswersSort = {
            primaryKey: this.sortPrimaryKey.IS_CURRENT_YEAR_PLAN,
            dataKey: SortLabels.PLAN_NAME,
            secondaryDataKey: SortLabels.MEDICAL_PREMIUM,
            dataKeyType: DataKeyType.STRING,
            sortType: SortType.ASCENDING,
            displayName: this.getPlanListSortByPlanNameLabel(),
            display: true,
            secondarySortType: SortType.ASCENDING,
            sortTransformer: null
        };
        this.arePlansOrShortPlansLoading$ = combineLatest([
            this.getPlansLoading$(),
            this.getAreShortPlansLoading$()
        ]).pipe(map(([arePlansLoading, areShortPlansLoading]) => arePlansLoading || areShortPlansLoading), distinctUntilChanged(), shareReplay(1));
        this.visiblePlanCountsByPlanType$ = combineLatest([
            this.plansService.getPlanCounts$().pipe(
            // We use startWith() with a default value here because pairwise() does not emit for the first event
            // Otherwise, the zip code link won't be visible and the tabs won't display any plans in the Plan List page when we refresh it
            startWith({}), pairwise()),
            this.plansService.getLoadedPlanTypes$(),
            this.getPlansLoading$(),
            this.plans$,
            this.getFilterGroups$()
        ]).pipe(distinctUntilChanged(_isEqual), map(([[oldPlanCounts, planCounts], loadedPlanTypes, arePlansLoading, allPlans, filterGroups]) => {
            const werePlanCountsReset = arePlansLoading && Object.keys(oldPlanCounts).length && !Object.keys(planCounts).length;
            const planTypePlanCountMap = this.filterService.getPlanTypePlanCountMapByFilterGroupSnapshot(this.tabs, false);
            return this.tabs.reduce((tabCountMap, tab) => {
                const tabPlanType = PlansUtilityService.convertToPlanType(tab.tabTypes[0], false);
                // We reset the plan counts during member logout or when switching between plan year.
                // For the latter, we will consider the tab as not loaded until we finish fetching the medicare plans.
                // After we fetch them by calling /short, the plan count should be populated again and we might consider the tabs as loaded again
                const isTabLoaded = werePlanCountsReset ? false : this.isPlanTypeLoaded(tabPlanType, loadedPlanTypes);
                const tabCount = this.getTabCount(isTabLoaded, tabPlanType, planTypePlanCountMap, planCounts);
                tabCountMap[tabPlanType] = tabCount;
                return tabCountMap;
            }, {});
        }), distinctUntilChanged(_isEqual), shareReplay(1));
        this.visiblePlanCountsByTabIndex$ = this.visiblePlanCountsByPlanType$.pipe(distinctUntilChanged(_isEqual), map(tabCountMap => this.tabs.map(tab => tabCountMap[PlansUtilityService.convertToPlanType(tab.tabTypes[0], false)] ?? 0)), shareReplay(1));
        this.totalPlanCount$ = this.visiblePlanCountsByPlanType$.pipe(map(tabCountMap => {
            const tabCounts = Object.values(tabCountMap);
            return tabCounts?.reduce((total, planCount) => total + planCount, 0) ?? 0;
        }));
        this.defaultTabType$ = combineLatest([
            this.visiblePlanCountsByTabIndex$,
            this.store.select(PlansState.defaultTabType),
            this.arePlansOrShortPlansLoading$
        ]).pipe(distinctUntilChanged(_isEqual), filter(([planCounts, defaultActiveTabType, arePlansOrShortPlansLoading]) => !arePlansOrShortPlansLoading && planCounts?.length > 0), map(([planCounts, defaultActiveTabType]) => {
            let defaultTabIndex = this.tabs.findIndex(tab => tab.tabTypes[0] === defaultActiveTabType);
            // Check if existing default tab is valid and displayed on page (e.g. default tab = Medigap, but is hidden on helpful tools)
            if (defaultActiveTabType && this.isTabVisible(defaultActiveTabType) && defaultTabIndex >= 0 && planCounts[defaultTabIndex] > 0) {
                return defaultActiveTabType;
            }
            // Determine new default tab by primary/secondary default active
            defaultTabIndex = this.tabs.findIndex(tab => tab.defaultActive);
            if (defaultTabIndex >= 0 && planCounts[defaultTabIndex] === 0) {
                const secondaryDefaultIndex = this.tabs.findIndex(tab => tab.secondaryDefaultActive);
                if (secondaryDefaultIndex >= 0 && planCounts[secondaryDefaultIndex] > 0) {
                    defaultTabIndex = secondaryDefaultIndex;
                }
            }
            if (planCounts[defaultTabIndex] > 0) {
                return this.getTabType(defaultTabIndex);
            }
            // Use first tab that has plans or default to first tab on page
            const hasPlansIndex = planCounts.findIndex(planCount => planCount > 0);
            defaultTabIndex = hasPlansIndex >= 0 ? hasPlansIndex : 0;
            return this.getTabType(defaultTabIndex);
        }), 
        // Prevents emitting the same default type. Even if the sources change, we could still end up with the same default type.
        distinctUntilChanged(), shareReplay(1));
        this.activeTabIndex$ = combineLatest([
            this.defaultTabType$,
            this.getActiveTabType$(),
            this.visiblePlanCountsByPlanType$,
            this.arePlansOrShortPlansLoading$
        ]).pipe(filter(([defaultTabType, activeTabType, tabCountMap, arePlansOrShortPlansLoading]) => !arePlansOrShortPlansLoading), withLatestFrom(this.plansService.getActiveTabPlanCountCheckEnabled$()), distinctUntilChanged(_isEqual), map(([[defaultTabType, activeTabType, tabCountMap], activeTabPlanCountCheckEnabled]) => {
            if (this.hasExcludedPlanType && this.excludedPlanTypes.includes(activeTabType)) {
                return defaultTabType;
            }
            // Choose the active tab type when it was selected by the user regardless of coverage
            let selectedType = activeTabType || defaultTabType;
            // When the activate tab's plan count check is enabled, it could override the user's selection if the active tab doesn't have coverage
            // This automatic selection is mostly used when switching to a new zip code or after login a member
            if (activeTabPlanCountCheckEnabled) {
                const activeTabPlanCount = tabCountMap[PlansUtilityService.convertToPlanType(activeTabType, false)] ?? 0;
                selectedType = activeTabPlanCount > 0 ? activeTabType : defaultTabType;
            }
            return selectedType;
        }), 
        // Prevents emitting the same selection. Even if the sources change, we could still end up with the same selected type.
        distinctUntilChanged(), map(selectedType => this.getIndexByFilterAndSelectedType(selectedType)), shareReplay(1));
        this.loaded$ = this.getActiveTabType$().pipe(switchMap(activeTabType => this.plansService.getPlansStateIsLoaded$(PlansUtilityService.convertToPlanType(activeTabType))));
        this.dirty$ = this.getActiveTabType$().pipe(switchMap(activeTabType => this.plansService.getPlansStateIsDirty$(PlansUtilityService.convertToPlanType(activeTabType))));
        this.preloadedPlanCount$ = this.getActiveTabType$().pipe(switchMap(activeTabType => this.plansService.getPlanCount$(PlansUtilityService.convertToPlanType(activeTabType, false))));
        this.activeTabPlansCount$ = combineLatest([this.plans$, this.getActiveTabType$()]).pipe(map(([plans, activeTabType]) => plans.reduce((planCount, plan) => planCount + (activeTabType === plan.planTypeAbbreviation ? 1 : 0), 0)));
        this.filterPlanByActiveTab$ = this.activeTabIndex$.pipe(switchMap(activeTabIndex => this.filterService.getPayloadByFilterGroup$(this.tabs[activeTabIndex].filters)));
        // TODO: update and where is this used? refactor?
        this.currentTabPlanCount$ = combineLatest([
            this.activeTabPlansCount$,
            this.preloadedPlanCount$,
            this.loaded$
        ]).pipe(map(([activeTabPlansCount, preloadedPlanCount, loaded]) => (loaded ? activeTabPlansCount : preloadedPlanCount)));
        this.lastActiveTabThatIsNotDefault$ = this.activeTabIndex$.pipe(map(index => this.tabs.find(tab => tab.tabIndex === index && !this.isPrimaryTab(tab))));
        this.filteredPlans$ = combineLatest([
            this.activeTabIndex$,
            this.getVisibleSNPTypes$(),
            this.loaded$
        ]).pipe(distinctUntilChanged(_isEqual), skipWhile(([activeTabIndex, visibleSNPTypes, plansLoaded]) => !plansLoaded), switchMap(([activeTabIndex]) => this.filterService.getPlansByFilterAndSortGroup$(this.tabs[activeTabIndex].filters, this.tabs[activeTabIndex].sortGroup, this.getSortTransformer.bind(this))), map(plans => (this.plansService.getIsHospitalIndemnityEnabled() ? this.plansService.updateHIPCalculatedPremium(plans) : plans)), map(plans => this.snpService.moveSNPPlansToTop(plans)), map(plans => this.plansService.moveNonLicensedPlansToBottom(plans)), shareReplay(1));
        this.filterService = this.configurableWidgetService.filterService;
        this.Spa_StarRating_Enabled = this.planListResourceFacade.isStarRatingEnabled();
        this.Spa_Site_TotalEstimatedCost_Enabled = this.planListResourceFacade.isPlanCardTotalEstimatedCostEnabled();
        this.Spa_PlanList_BestMatchPlan_Enabled = this.isBestMatchPlanEnabled();
        this.Spa_PlanList_GuaranteedIssue_Header = this.getGuaranteedIssueHeader();
        this.Spa_PlanList_MedSupQuestion_Data = this.getMedSupQuestionData();
        this.Spa_PlanList_DentalVisionQuestion_Data = this.getDentalVisionQuestionData();
        this.Spa_MedSupForm_PaymentMethod_UseToggle = this.planListResourceFacade.isMedSupFormPaymentMethodToggled();
    }
    getMedSupFormIsOpen$() {
        return this.planListContext.getMedSupFormIsOpen$();
    }
    getDentalVisionFormIsOpen$() {
        return this.planListContext.getDentalVisionFormIsOpen$();
    }
    get hasExcludedPlanType() {
        return this.planListContext.getHasMedSupExclusion();
    }
    get excludedPlanTypes() {
        return this.planListContext.getExcludedPlanTypes();
    }
    get tabs() {
        return this.planListContext.tabs;
    }
    getEnrollmentSettingsLoading$() {
        return this.store.select(MemberState.loading);
    }
    get zipCode() {
        return this.store.selectSnapshot(DemographicState.selectedZipCode);
    }
    getZipCode$() {
        return this.store.select(DemographicState.selectedZipCode);
    }
    getFipsCode$() {
        return this.store.select(DemographicState.selectedFipsCode);
    }
    getOverrideActiveTab$() {
        return this.store.select(UiState.overrideActiveTab);
    }
    getHasMedSupQuestions$() {
        return this.medSupService.getHasMedSupQuestions$();
    }
    getMedSupQuestions$() {
        return this.plansService.getMedSupQuestions$();
    }
    getHasMedSupAnswers$() {
        return this.medSupService.getHasMedSupAnswers$();
    }
    getMedSupStateIsLoading$() {
        return this.medSupService.getLoadingMedSupQuestions$();
    }
    getAncillaryQuestions$() {
        return this.medSupService.getAncillaryQuestions$();
    }
    getHasAncillaryQuestions$() {
        return this.medSupService.getHasAncillaryQuestions$();
    }
    getHasAncillaryAnswers$() {
        return this.medSupService.getHasAncillaryAnswers$();
    }
    getCompareGroups$() {
        return this.store.select(PlansState.compareGroups);
    }
    getQuoteGroups$() {
        return this.store.select(PlansState.quoteGroups);
    }
    getFilteredPlansHasSNPPlans$() {
        return this.filterPlanByActiveTab$.pipe(map(plans => !!plans.filter(plan => plan.snpType !== undefined).length));
    }
    getFilteredCSNPPlansCount$() {
        return this.filterPlanByActiveTab$.pipe(map(plans => plans.filter(plan => plan.snpType === SNPBaseType.cSNP).length));
    }
    getFilteredDSNPPlansCount$() {
        return this.filterPlanByActiveTab$.pipe(map(plans => plans.filter(plan => plan.snpType === SNPBaseType.dSNP).length));
    }
    getFilteredISNPPlansCount$() {
        return this.filterPlanByActiveTab$.pipe(map(plans => plans.filter(plan => plan.snpType === SNPBaseType.iSNP).length));
    }
    getTotalAppliedFilters$() {
        return this.activeTabIndex$.pipe(mergeMap(activeTabIndex => this.filterService.getFiltersByFilterGroup$(this.tabs[activeTabIndex].filters)), map(filterList => filterList.filter(filters => filters.key !== FilterKeyType.PLAN_TYPE_SHORT && filters.key !== SortLabels.MEDICAL_PREMIUM && filters.visible)), map(filters => filters.reduce((allFilters, currentFilter) => {
            const filtersLength = currentFilter.values.length;
            const comboPlanFiltersLength = currentFilter.values.filter(value => COMBO_PLANS.includes(value)).length;
            let result = filtersLength - comboPlanFiltersLength;
            // Combo plan count as 1 applied filter
            if (comboPlanFiltersLength > 1) {
                result += 1;
            }
            return allFilters + result;
        }, 0)));
    }
    getAppliedFilterValues$() {
        // returning "Filter -> values" which is dynamic and could be any[] type
        return this.activeTabIndex$.pipe(mergeMap(activeTabIndex => this.filterService.getFiltersByFilterGroup$(this.tabs[activeTabIndex].filters)), map(filterList => filterList.filter(filters => filters.key !== FilterKeyType.PLAN_TYPE_SHORT)), map(filters => filters.reduce((allFilters, currentFilter) => allFilters.concat(currentFilter.values), [])));
    }
    getShowEmptyFilterMessage$() {
        return combineLatest([
            this.filterService.filterKeys$(FilterKeyType.PLAN_CARRIER_NAME),
            this.filterService.filterKeys$(FilterKeyType.PLAN_SUB_TYPE),
            this.filterService.filterKeys$(FilterKeyType.HIP_PLAN_DAYS),
            this.getVisibleSNPTypes$(),
            this.insulinPlansExist$(),
            this.pufPlansExist$(),
            this.activeTabIndex$
        ]).pipe(map(([carrier, subtype, planDay, visibleSNPTypes, insulinPlansExist, pufPlansExist, activeTabIndex]) => !(carrier.length > 1 ||
            subtype.length > 1 ||
            planDay.length > 1 ||
            visibleSNPTypes?.cSNP ||
            visibleSNPTypes?.dSNP ||
            visibleSNPTypes?.iSNP ||
            (insulinPlansExist
                ? this.configResourceService.getProcessedResourceValue('Spa_Filter_InsulinSavings_Enabled', null, false)
                : true) ||
            (pufPlansExist ? this.canDisplayPUFFilter(this.tabs[activeTabIndex].tabTypes) : true))));
    }
    getMedSupPlansWithoutFilters$() {
        return this.plans$.pipe(map(plans => plans.filter(plan => plan.planTypeAbbreviation === PlanTypeAbbreviation.MEDIGAP)));
    }
    getMedSupPlanCount$() {
        return combineLatest([
            this.getMedSupPlansWithoutFilters$(),
            this.plansService.getPlanCount$(PlanType.MEDIGAP),
            this.getPlansLoaded$(PlanType.MEDIGAP)
        ]).pipe(map(([plans, count, loaded]) => (loaded ? plans.length : count)));
    }
    getDentalPlansWithoutFilters$() {
        return this.plans$.pipe(map(plans => plans.filter(plan => plan.planTypeAbbreviation === PlanTypeAbbreviation.DENTAL)));
    }
    getDentalPlanCount$() {
        return combineLatest([
            this.getDentalPlansWithoutFilters$(),
            this.plansService.getPlanCount$(PlanType.DENTAL),
            this.getPlansLoaded$(PlanType.DENTAL)
        ]).pipe(map(([plans, count, loaded]) => (loaded ? plans.length : count)));
    }
    getVisionPlansWithoutFilters$() {
        return this.plans$.pipe(map(plans => plans.filter(plan => plan.planTypeAbbreviation === PlanTypeAbbreviation.VISION)));
    }
    getVisionPlanCount$() {
        return combineLatest([
            this.getVisionPlansWithoutFilters$(),
            this.plansService.getPlanCount$(PlanType.VISION),
            this.getPlansLoaded$(PlanType.VISION)
        ]).pipe(map(([plans, count, loaded]) => (loaded ? plans.length : count)));
    }
    // TODO: do we need all plans or just some based on planType?
    // getLocale changes were removed from here as now this.planListContext.getTabs$ will emit after locale change and tabs are correctly updated
    getSelectedTabSortList$() {
        return combineLatest([
            this.activeTabIndex$,
            this.pharmacyFacade.mailOrder$,
            this.allPlans$,
            this.getMedSupFormIsOpen$(),
            this.planListContext.getTabs$()
        ]).pipe(distinctUntilChanged(_isEqual), map(([activeTabIndex, mailOrder, plans, medSupFormIsOpen, tabs]) => {
            this.isMailOrder = !!mailOrder;
            let sortList = tabs[activeTabIndex].sortList;
            let drugExists = false;
            const sortByScoreEnabled = this.configResourceService.getProcessedResourceValue('Spa_PlanList_Sort_By_PreferenceScore_Enabled', null, false);
            const filteredPlans = this.filterService.getPlansByFilterGroupSnapshot(tabs[activeTabIndex].filters);
            const isPremiumExist = filteredPlans?.some(plan => !!plan.medicalPremium || !!plan.drugPremium) ?? true;
            const isAnnualPlanPremium = filteredPlans?.some(plan => !!plan.annualPlanPremium) ?? true;
            const isMedicalDeductible = filteredPlans?.some(plan => !!plan.medicalDeductible) ?? true;
            const isMaximumOutOfPocketCost = filteredPlans?.some(plan => !!plan.maximumOutOfPocketCost) ?? true;
            const isStarSortExist = filteredPlans?.some(plan => !!plan.planRating);
            // scores of 0 are valid scores and thus must be considered as existing as far as sorting is concerned
            this.isScoreExist = sortByScoreEnabled && filteredPlans?.some(plan => plan.score !== undefined && plan.score !== null);
            const medicineCabinet = this.configurableWidgetService.store.selectSnapshot(MedicineCabinetState.medicineCabinet);
            if (medicineCabinet && medicineCabinet.length !== 0) {
                drugExists = true;
            }
            sortList =
                !isStarSortExist || !this.Spa_StarRating_Enabled
                    ? sortList.filter(sortItem => sortItem.dataKey !== SortLabels.PLAN_RATING)
                    : sortList;
            sortList = isPremiumExist ? sortList : sortList.filter(sortItem => sortItem.dataKey !== SortLabels.MEDICAL_PREMIUM);
            sortList = isAnnualPlanPremium ? sortList : sortList.filter(sortItem => sortItem.dataKey !== SortLabels.ANNUAL_PLAN_PREMIUM);
            sortList = drugExists ? sortList : sortList.filter(sortItem => sortItem.dataKey !== SortLabels.ESTIMATED_DRUG_COSTS);
            sortList = isMaximumOutOfPocketCost
                ? sortList
                : sortList.filter(sortItem => sortItem.dataKey !== SortLabels.MAXIMUM_OUT_OF_POCKET_COST);
            sortList = isMedicalDeductible ? sortList : sortList.filter(sortItem => sortItem.dataKey !== SortLabels.MEDICAL_DEDUCTIBLE);
            sortList = this.getSortListForScore(this.isScoreExist, sortList, activeTabIndex);
            this.updateSortDefault(tabs[activeTabIndex], sortList);
            return sortList;
        }));
    }
    getShowNoPlansFromAnswersMessage$() {
        return combineLatest([
            this.filteredPlans$,
            this.getHasMedSupAnswers$(),
            this.getActiveTabType$(),
            this.getMedSupPlanCount$(),
            this.getTotalAppliedFilters$(),
            this.getHasAncillaryAnswers$(),
            this.hospitalIndemnityFormFacade.getHasHospitalIndemnityAnswers$(),
            this.getDentalPlanCount$(),
            this.getVisionPlanCount$(),
            this.hospitalIndemnityFormFacade.getHospitalIndemnityPlanCount$()
        ]).pipe(map(([filteredPlans, hasMedSupAnswers, activeTabType, medSupPlanCount, totalAppliedFilters, hasAncillaryAnswers, hasHospitalIndemnityAnswers, dentalPlanCount, visionPlanCount, hospitalIndemnityPlanCount]) => filteredPlans?.length === 0 &&
            totalAppliedFilters === 0 &&
            // no medigap plans from answers
            ((activeTabType === PlanTypeAbbreviation.MEDIGAP && hasMedSupAnswers && medSupPlanCount > 0) ||
                // no dental plans from answers
                (activeTabType === PlanTypeAbbreviation.DENTAL && hasAncillaryAnswers && dentalPlanCount > 0) ||
                // no vision plans from answers
                (activeTabType === PlanTypeAbbreviation.VISION && hasAncillaryAnswers && visionPlanCount > 0) ||
                // no hospital indemnity plans from answers
                (activeTabType === PlanTypeAbbreviation.HC && hasHospitalIndemnityAnswers && hospitalIndemnityPlanCount > 0))));
    }
    getShowMedSupForm$() {
        const sources = [
            this.getMedSupFormIsOpen$(),
            this.getActiveTabType$(),
            this.getHasMedSupQuestions$(),
            this.getHasMedSupAnswers$(),
            this.getMedSupStateIsLoading$()
        ];
        const isAllowMedSupFormWhenNoPlansAvailableEnabled = this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_AllowFormWhenNoPlansAvailable_Enabled', null, false);
        const isPlanListShowAllMedigapEnabled = this.configResourceService.getProcessedResourceValue('Spa_PlanList_ShowAllMedigap_Enabled', null, false);
        const checkIfAvailableMedigapPlans = !isAllowMedSupFormWhenNoPlansAvailableEnabled && !isPlanListShowAllMedigapEnabled;
        let medigapFilter;
        if (checkIfAvailableMedigapPlans) {
            medigapFilter = new Filter({ key: FilterKeyType.PLAN_TYPE_SHORT, values: [PlanTypeAbbreviation.MEDIGAP] });
        }
        if (this.millimanService.isMedSupMillimanEnabled()) {
            sources.push(this.millimanService.getMillimanServiceError$());
        }
        return combineLatest(sources).pipe(withLatestFrom(this.getAreAllMedSupQuestionsAnswered$()), map(([[medSupFormIsOpen, activeTabType, hasMedSupQuestions, hasMedSupAnswers, medSupStateIsLoading, millimanError], areAllMedSupQuestionsAnswered]) => [
            !!medSupFormIsOpen,
            activeTabType === PlanTypeAbbreviation.MEDIGAP &&
                (hasMedSupQuestions || hasMedSupAnswers || !this.plansService.includeMedSupInPlansCall()) &&
                !medSupStateIsLoading,
            hasMedSupAnswers,
            areAllMedSupQuestionsAnswered,
            millimanError !== null && millimanError !== undefined
        ]), switchMap(([medSupFormIsOpen, showMedSupForm, hasMedSupAnswers, areAllMedSupQuestionsAnswered, hasError]) => {
            if (showMedSupForm && (hasError || (hasMedSupAnswers && !areAllMedSupQuestionsAnswered))) {
                return of(true);
            }
            // if there are no plans in the area, then we would not show rate factor questions
            if (medSupFormIsOpen && showMedSupForm && !hasError && checkIfAvailableMedigapPlans) {
                return this.getMedSupPlanCountByFilterList$(medigapFilter).pipe(map((planCount) => planCount > 0));
            }
            return of(showMedSupForm && medSupFormIsOpen);
        }));
    }
    getShowDentalForm$() {
        return combineLatest([
            this.getDentalVisionFormIsOpen$(),
            this.getActiveTabType$(),
            this.getDentalPlanCount$(),
            this.getHasAncillaryQuestions$(),
            this.getHasAncillaryAnswers$(),
            this.getPlansLoading$(PlanType.DENTAL)
        ]).pipe(withLatestFrom(this.getAreAllAncillaryQuestionsAnswered$()), map(([[dentalVisionFormIsOpen, activeTabType, dentalPlanCount, hasAncillaryQuestions, hasAncillaryAnswers, dentalPlansLoading], areAllAncillaryQuestionsAnswered]) => [
            dentalVisionFormIsOpen,
            !dentalPlansLoading &&
                activeTabType === PlanTypeAbbreviation.DENTAL &&
                (dentalPlanCount > 0 || (hasAncillaryQuestions && hasAncillaryAnswers)),
            hasAncillaryAnswers,
            areAllAncillaryQuestionsAnswered
        ]), map(([dentalVisionFormIsOpen, showDentalForm, hasAncillaryAnswers, areAllAncillaryQuestionsAnswered]) => showDentalForm && ((hasAncillaryAnswers && !areAllAncillaryQuestionsAnswered) || dentalVisionFormIsOpen)));
    }
    getShowVisionForm$() {
        return combineLatest([
            this.getDentalVisionFormIsOpen$(),
            this.getActiveTabType$(),
            this.getVisionPlanCount$(),
            this.getHasAncillaryQuestions$(),
            this.getHasAncillaryAnswers$(),
            this.getPlansLoading$(PlanType.VISION)
        ]).pipe(withLatestFrom(this.getAreAllAncillaryQuestionsAnswered$()), map(([[dentalVisionFormIsOpen, activeTabType, visionPlanCount, hasAncillaryQuestions, hasAncillaryAnswers, visionPlansLoading], areAllAncillaryQuestionsAnswered]) => [
            dentalVisionFormIsOpen,
            !visionPlansLoading &&
                activeTabType === PlanTypeAbbreviation.VISION &&
                (visionPlanCount > 0 || (hasAncillaryQuestions && hasAncillaryAnswers)),
            hasAncillaryAnswers,
            areAllAncillaryQuestionsAnswered
        ]), map(([dentalVisionFormIsOpen, showVisionForm, hasAncillaryAnswers, areAllAncillaryQuestionsAnswered]) => showVisionForm && ((hasAncillaryAnswers && !areAllAncillaryQuestionsAnswered) || dentalVisionFormIsOpen)));
    }
    getSortedQuestions$() {
        return this.getMedSupQuestions$().pipe(map(questions => this.sortQuestionsByMetaDataOrder(questions)), map(questions => this.replaceAdditionalGiQuestionText(questions)), map(questions => (this.Spa_MedSupForm_PaymentMethod_UseToggle ? this.replacePaymentQuestionWithToggle(questions) : questions)));
    }
    getFilteredQuestionsMetaData$() {
        return this.getSortedQuestions$().pipe(map(questions => this.filterQuestionMetaData(questions)));
    }
    getFilteredAncillaryQuestionsMetaData$() {
        return this.getAncillaryQuestions$().pipe(map(questions => this.filterAncillaryQuestionMetaData(questions)));
    }
    getShowPlanNotAvailableForNextYearText$() {
        return this.allPlans$.pipe(map(plans => {
            const nextYearPlan = plans?.find(plan => plan.isNextYearPlan);
            if (nextYearPlan === undefined) {
                return true;
            }
            return nextYearPlan.isPlanRolloverTerminated;
        }));
    }
    get isCostFilterEnabled() {
        let costResourceKey = '';
        const activeTabType = this.getActiveTabType();
        switch (activeTabType) {
            case PlanTypeAbbreviation.PDP:
                costResourceKey = 'Spa_Site_ShowCostsFilters_PDP';
                break;
            case PlanTypeAbbreviation.MAPD:
                costResourceKey = 'Spa_Site_ShowCostsFilters_MAPD';
                break;
            case PlanTypeAbbreviation.MA:
                costResourceKey = 'Spa_Site_ShowCostsFilters_MA';
                break;
            default:
                break;
        }
        if (costResourceKey) {
            const costFilterEnabled = this.configResourceService.getProcessedResourceValue(costResourceKey, null, false);
            return costFilterEnabled;
        }
        return false;
    }
    getVisiblePlanCountsByPlanType$() {
        return this.visiblePlanCountsByPlanType$;
    }
    getMedSupPlanCountByFilterList$(medigapFilter) {
        // SPA-13230: Edge case with "Spa_Site_ForceMedSupFormBeforePlansList = true"
        // When all available plans were external, additional filtering was being applied,
        // causing the plan count to be 0 and subsequently, hiding the rate factor form
        const skipAdditionalFiltering = true;
        return combineLatest([
            this.filterService.getPlansByFilterList$([medigapFilter], skipAdditionalFiltering),
            this.plansService.getPlanCount$(PlanType.MEDIGAP),
            this.getPlansLoaded$(PlanType.MEDIGAP)
        ]).pipe(map(([plans, count, loaded]) => (loaded ? plans.length : count)));
    }
    getPlansLoading$(planType) {
        return this.plansService.getPlansStateIsLoading$(planType);
    }
    getPlansLoaded$(planType) {
        return this.plansService.getPlansStateIsLoaded$(planType);
    }
    getAreShortPlansLoading$() {
        return this.plansService.getAreShortPlansLoading$();
    }
    getArePlansOrShortPlansLoading$() {
        return this.arePlansOrShortPlansLoading$;
    }
    getActiveTabType$() {
        return this.store.select(PlansState.activeTabType);
    }
    getActiveTabType() {
        return this.store.selectSnapshot(PlansState.activeTabType);
    }
    getFilterGroups$() {
        return this.store.select(PlansState.filterGroups);
    }
    getFilterGroups() {
        return this.store.selectSnapshot(PlansState.filterGroups);
    }
    getAreAllMedSupQuestionsAnswered$() {
        return this.plansService.getAreAllMedSupQuestionsAnswered$();
    }
    getAreAllMedSupQuestionsAnswered() {
        return this.plansService.getAreAllMedSupQuestionsAnswered();
    }
    getAreAllAncillaryQuestionsAnswered$() {
        return this.plansService.getAreAllAncillaryQuestionsAnswered$();
    }
    getAreAllAncillaryQuestionsAnswered() {
        return this.plansService.getAreAllAncillaryQuestionsAnswered();
    }
    getVisiblePlanCountsByTabIndex$() {
        return this.visiblePlanCountsByTabIndex$;
    }
    // TODO: ???
    getTotalPlanCount$() {
        return this.totalPlanCount$;
    }
    getDefaultTabType$() {
        return this.defaultTabType$;
    }
    getActiveTabIndex$() {
        return this.activeTabIndex$;
    }
    getFilterPlanByActiveTab$() {
        return this.filterPlanByActiveTab$;
    }
    getCurrentTabPlanCount$() {
        return this.currentTabPlanCount$;
    }
    getLastActiveTabThatIsNotDefault$() {
        return this.lastActiveTabThatIsNotDefault$;
    }
    getFilteredPlans$() {
        return this.filteredPlans$;
    }
    getShowHospitalIndemnityForm$() {
        return combineLatest([
            this.hospitalIndemnityFormFacade.getHospitalIndemnityFormOpenSource$(),
            this.getActiveTabType$(),
            this.hospitalIndemnityFormFacade.getHospitalIndemnityPlanCount$(),
            this.hospitalIndemnityFormFacade.getHasHospitalIndemnityQuestions$(),
            this.hospitalIndemnityFormFacade.getHasHospitalIndemnityAnswers$(),
            this.getPlansLoading$()
        ]).pipe(withLatestFrom(this.hospitalIndemnityFormFacade.getAreAllHospitalIndemnityQuestionsAnswered$()), map(([[hospitalIndemnityFormIsOpen, activeTabType, hospitalIndemnityPlanCount, hasHospitalIndemnityQuestions, hasHospitalIndemnityAnswers, plansStateIsLoading], areAllHospitalIndemnityQuestionsAnswered]) => [
            hospitalIndemnityFormIsOpen,
            !plansStateIsLoading &&
                activeTabType === PlanTypeAbbreviation.HC &&
                (hospitalIndemnityPlanCount > 0 || (hasHospitalIndemnityQuestions && hasHospitalIndemnityAnswers)),
            hasHospitalIndemnityAnswers,
            areAllHospitalIndemnityQuestionsAnswered
        ]), map(([hospitalIndemnityFormIsOpen, showHospitalIndemnityForm, hasHospitalIndemnityAnswers, areAllHospitalIndemnityQuestionsAnswered]) => showHospitalIndemnityForm &&
            ((hasHospitalIndemnityAnswers && !areAllHospitalIndemnityQuestionsAnswered) || hospitalIndemnityFormIsOpen)));
    }
    insulinPlansExist$() {
        return this.plans$.pipe(map(plans => plans
            .map(plan => plan.extraData)
            .some(extraData => extraData?.find(data => data.name === FilterKeyType.MODEL_DRUG_PROGRAM)?.value.toLowerCase() === 'true')));
    }
    canDisplayPUFFilter(tabTypes) {
        return (!tabTypes.includes(PlanTypeAbbreviation.DENTAL) &&
            !tabTypes.includes(PlanTypeAbbreviation.VISION) &&
            !tabTypes.includes(PlanTypeAbbreviation.MEDIGAP));
    }
    pufPlansExist$() {
        return this.plans$.pipe(map(plans => plans.some(plan => plan.isPUF)));
    }
    getVisibleSNPTypes$() {
        return this.store.select(PlansState.snpVisibility);
    }
    setAllSNPTypesVisibility(show) {
        this.snpService.setAllSNPTypesVisibility(show);
    }
    getNonLicensedInformationText(widgetName) {
        const zip = this.zipCode;
        const notLicensedText = this.configResourceService.getProcessedResourceValue('Spa_PlanList_NotLicensed_Text', widgetName, 'You are not licensed to sell plans in the Zip Code: <zip>. Please transfer the member to a new agent so they may continue shopping for plans in their area.');
        return zip ? notLicensedText.replace('<zip>', zip) : notLicensedText;
    }
    getNonLicensedHeaderText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanList_NonLicensed_Header_Text', widgetName, 'Member outside licensed area.');
    }
    getNonLicensedPlanCardBadgeText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanCard_NotLicensedToSell_Badge_Text', widgetName, 'Not authorized to sell');
    }
    getNonLicensedPlanCardMessageText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanCard_NotLicensedToSell_Message_Text', widgetName, 'Our records indicate you are not appointed for this carrier’s product. If the member is interested' +
            ' in this product, please transfer the member to an MSR that is appointed for this carrier.');
    }
    isBestMatchPlanEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanList_BestMatchPlan_Enabled', widgetName, false);
    }
    isBestCoverageTypeEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanList_BestCoverageType_Enabled', widgetName, false);
    }
    getMedSupQuestionData() {
        return this.planListResourceFacade.getPlanListMedSupQuestionData();
    }
    getDentalVisionQuestionData() {
        return this.planListResourceFacade.getPlanListDentalVisionQuestionData();
    }
    getGuaranteedIssueHeader() {
        return this.planListResourceFacade.planListGuaranteedIssueHeader;
    }
    getInitialActiveTabIndexBasedOnScores(plans) {
        const planScores = this.getHighestScoreByTabIndex(plans);
        const coverageType = this.getCoverageType();
        if (!planScores.every(score => score === 0)) {
            const activeIndexSelectedByScore = this.getIndexFromCurrentPlanScores(planScores, coverageType);
            if (activeIndexSelectedByScore >= 0) {
                return activeIndexSelectedByScore;
            }
        }
        // If there is tie between maximum scores,
        // send back default tab index based on selected Coverage type
        return this.getInitialActiveTabIndex();
    }
    getInitialActiveTabType() {
        // this.store.selectSnapshot(GuidedHelpState.selectedCoverageType);
        // OR const defaultTabType = this.store.selectSnapshot(PlansState.defaultTabType);
        // If no coverage selected, find the default tab defined for the site
        const defaultTabType = this.getDefaultTabFromCoverageType() ?? this.store.selectSnapshot(PlansState.defaultTabType);
        return defaultTabType;
    }
    getInitialActiveTabIndex(initialActiveTabType = this.getInitialActiveTabType()) {
        return this.getIndexByFilterAndSelectedType(initialActiveTabType);
    }
    getDefaultTabFromCoverageType() {
        const selectedCoverageType = this.getCoverageType();
        if (selectedCoverageType) {
            // Find the default tab for the selected coverage type
            const medicalOnlyDefault = this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_MedicalOnly_Default');
            return this.guidedHelpService.coverageTypeToTab(selectedCoverageType, medicalOnlyDefault);
        }
        return null;
    }
    getMobileTabs(lastActiveTab, isMobileExtraSmall, activeTabIndex) {
        const tabsToExclude = [];
        if (isMobileExtraSmall && activeTabIndex !== null && activeTabIndex !== undefined) {
            return this.tabs.filter(tab => tab.tabIndex !== activeTabIndex);
        }
        if (lastActiveTab) {
            tabsToExclude.push(lastActiveTab);
        }
        tabsToExclude.push(this.tabs[0]);
        if (activeTabIndex === 0) {
            tabsToExclude.push(this.tabs[1]);
        }
        return this.tabs.filter(tab => !tabsToExclude.includes(tab)).filter(tab => !this.isPrimaryTab(tab));
    }
    // Sorts questions based on resource JSON
    sortQuestionsByMetaDataOrder(medSupQuestions) {
        const sorted = [];
        this.Spa_PlanList_MedSupQuestion_Data.forEach(resourceQuestionData => {
            const item = medSupQuestions.find(filteredQuestion => filteredQuestion.name === resourceQuestionData.key);
            if (item !== undefined) {
                sorted.push(item);
            }
        });
        if (sorted?.length && this.medSupFacade.isMedsupTobaccoApplicableStates()) {
            const tobaccoIndex = sorted.findIndex(item => item.name === MedSupQuestionNames.Tobacco);
            const tobaccoQuestion = sorted.find(item => item.name === MedSupQuestionNames.Tobacco);
            const guaranteedIssueIndex = sorted.findIndex(item => item.name === MedSupQuestionNames.GuaranteedIssue);
            if (tobaccoIndex > -1 && guaranteedIssueIndex > -1) {
                // moving tobacco question right after Guaranteed Issue for some applicable states if both questions exists
                sorted.splice(tobaccoIndex, 1);
                sorted.splice(guaranteedIssueIndex, 0, tobaccoQuestion);
            }
        }
        return sorted;
    }
    filterQuestionMetaData(sortedQuestions) {
        return this.Spa_PlanList_MedSupQuestion_Data.filter(metaData => sortedQuestions.find(sortedQuestion => sortedQuestion.name === metaData.key));
    }
    filterAncillaryQuestionMetaData(sortedQuestions) {
        return this.Spa_PlanList_DentalVisionQuestion_Data.filter(metaData => sortedQuestions.some(sortedQuestion => sortedQuestion.name === metaData.key));
    }
    replaceAdditionalGiQuestionText(medSupQuestions) {
        return medSupQuestions.map(question => {
            if (question && question.name === MedSupQuestionNames.GIAdditional) {
                return { ...question, text: this.Spa_PlanList_GuaranteedIssue_Header };
            }
            return question;
        });
    }
    replacePaymentQuestionWithToggle(medSupQuestions) {
        return medSupQuestions.map(question => {
            if (question.name === MedSupQuestionNames.PaymentMethod) {
                const monthlyAnnuallyAnswerList = question.answerList.filter(answer => answer === 'Monthly' || answer === 'Annually');
                return { ...question, answerList: monthlyAnnuallyAnswerList };
            }
            return question;
        });
    }
    updateTabSortGroups(tab, predicate) {
        const tabType = tab?.tabTypes[0];
        const currentSortType = this.planFacade.getCurrentSortType(tabType);
        if (currentSortType && this.isSaveSortOrderEnabled()) {
            this.updateSortGroup(currentSortType, tabType);
        }
        else {
            const predicateSortOption = tab ? tab.sortList.find(predicate) : null;
            if (predicateSortOption) {
                this.updateSortGroup(predicateSortOption, tabType);
            }
        }
    }
    updateSortDefault(tab, updatedSortList) {
        const existingSortList = tab ? tab.sortList : null;
        if (existingSortList && updatedSortList) {
            const currentSortGroup = this.planFacade.getCurrentSortGroup(tab.tabTypes[0]);
            // Sets default sort option
            let currentSortType = updatedSortList.find(sort => sort.isDefault);
            if (!currentSortType) {
                currentSortType = updatedSortList.sort(sortData => sortData.order).find(sort => sort.display);
            }
            // Checks if current sort group exist and looks for it in the updatedSortList list
            if (currentSortGroup?.sort) {
                const currentActiveSort = updatedSortList.find(sort => sort.dataKey === currentSortGroup.sort.dataKey);
                if (currentActiveSort) {
                    currentSortType = currentActiveSort;
                }
            }
            const canOverwriteSortType = !this.isSaveSortOrderEnabled() || !currentSortGroup?.isDirty;
            if (canOverwriteSortType) {
                // Lookup the target default sort option.
                const targetSortSelection = this.plansService.getDefaultSortOption(updatedSortList);
                if (targetSortSelection) {
                    currentSortType = targetSortSelection;
                }
                // Save sort order flag should take precedence over preferences logic, unless visiting the plan list for the first time.
                // There is a slight gap here, which product would like to address in a future enhancement.
                if (this.isPreferenceScoreEnabled() && this.isScoreExist) {
                    const preferencesSortSelection = updatedSortList.find(sortItem => sortItem.dataKey === SortLabels.SCORE);
                    if (preferencesSortSelection) {
                        currentSortType = preferencesSortSelection;
                    }
                }
                // Preferences score tab may be set as default, therefore check isDefault setting
                // and grab secondary sort option if set as default.
                currentSortType = this.getSortOptionByDataKey(existingSortList, updatedSortList) ?? currentSortType;
                const selectedPlanSmartDetails = this.store.selectSnapshot(PlansState.selectedPlanSmartDetails);
                if (selectedPlanSmartDetails?.memberId) {
                    // Default select sort SortLabels.TOTAL_ESTIMATED_COST when plan smart is selected
                    currentSortType = updatedSortList.find(sortItem => sortItem.dataKey === SortLabels.TOTAL_ESTIMATED_COST) ?? currentSortType;
                }
            }
            if (currentSortType) {
                this.updateSortGroup(currentSortType, this.getActiveTabType());
            }
        }
    }
    updateSortGroup(sortOption, tabType) {
        const activeTab = this.tabs.find(tab => tab.filters[0].values[0] === tabType);
        if (activeTab) {
            this.configurableWidgetService.sortService.updateSortGroup(activeTab.sortGroup, new Sort(SortPrimaryKey.IS_CURRENT_YEAR_PLAN, sortOption.dataKey, sortOption.secondaryDataKey, sortOption.dataKeyType === 'numeric' ? DataKeyType.NUMERIC : DataKeyType.STRING, sortOption.sortType === 'ascending' ? SortType.ASCENDING : SortType.DESCENDING, sortOption.displayName, sortOption.display, this.getSortTransformer(sortOption.dataKey), sortOption.secondarySortType));
        }
    }
    sort(tabs) {
        const primaryTab = tabs.find(tab => tab.defaultActive);
        const secondaryTab = tabs.find(tab => tab.secondaryDefaultActive && tab !== primaryTab);
        let remainingTabs = tabs.filter(tab => tab !== primaryTab && tab !== secondaryTab);
        if (secondaryTab) {
            remainingTabs = [secondaryTab, ...remainingTabs];
        }
        if (primaryTab) {
            remainingTabs = [primaryTab, ...remainingTabs];
        }
        return remainingTabs;
    }
    getPlansSelectedToQuote$() {
        return combineLatest([this.getActiveTabType$(), this.getQuoteGroups$()]).pipe(map(([activeTabType, quoteGroups]) => {
            const selectedQuoteGroup = quoteGroups.filter(group => group.groupKey.values[0] === activeTabType);
            if (!selectedQuoteGroup) {
                return [];
            }
            const plans = selectedQuoteGroup[0]
                ? selectedQuoteGroup[0].items.map((item) => {
                    const plan = { ...item };
                    plan.medicalPremium = this.planFacade.getTotalPremium([item]);
                    return plan;
                })
                : [];
            return plans;
        }));
    }
    updateDefaultTab(planType) {
        this.configurableWidgetService.store.dispatch(new SetDefaultTab(planType));
        if (!this.getActiveTabType()) {
            this.updateActiveTab(planType);
        }
    }
    updateDefaultTabForLiveEdit() {
        // Set default tab as MAPD if store has MAPD plans
        if (this.store.selectSnapshot(PlansState.plans).findIndex(plan => plan.planType === PlanType.MAPD) > -1) {
            const planType = PlanTypeAbbreviation.MAPD;
            this.configurableWidgetService.store.dispatch(new SetDefaultTab(planType));
            if (!this.getActiveTabType()) {
                this.updateActiveTab(planType);
            }
        }
    }
    updateActiveTab(planType) {
        this.configurableWidgetService.store.dispatch(new SetActiveTab(planType));
    }
    getPlanListSortByScoreLabel(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanList_Sort_By_PreferenceScore_Label', widgetName, 'Preference Score (High to Low)');
    }
    toggleSNPPlanVisibility(snpVisibility, activeTabType, filterModalEnabled) {
        // Set override flag to false so the current ActiveTab remains as is
        this.plansService.setOverrideActiveTab(false);
        if (snpVisibility && !filterModalEnabled) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_SNP_PLAN_DISPLAY_EVENT);
        }
        else {
            if (!snpVisibility) {
                const filter = { comparator: ComparatorType.EQUAL, key: FilterKeyType.PLAN_TYPE_SHORT, values: [activeTabType] };
                this.filterService.clearFilterGroupFilter([filter], FilterKeyType.SNP_BASE_TYPE);
            }
            if (!filterModalEnabled) {
                this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_SNP_PLAN_HIDE_EVENT);
            }
        }
        this.snpService.setAllSNPTypesVisibility(snpVisibility);
    }
    getPlanListSortByPlanNameLabel(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanList_Sort_Text_PlanName', widgetName, 'Plan name (A - Z)');
    }
    getPlanListSortByPremiumLabel(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanList_Sort_Text_Premium', widgetName, 'Plan Premium (Low to High)');
    }
    isSaveSortOrderEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanList_Save_Sort_Order_Enabled', widgetName, false);
    }
    isPreferenceScoreEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Preferences_Score_Enabled', widgetName, false);
    }
    getTabType(index) {
        return _get(this.tabs, `[${index}].filters[0].values[0]`);
    }
    getActiveTabData(activeTabType) {
        return this.tabs.find(tab => tab.tabTypes?.includes(activeTabType));
    }
    updateMailOrder(isMailOrder) {
        this.isMailOrder = isMailOrder;
    }
    getTotalEstimatedCost(plans) {
        if (!plans?.length) {
            return 0;
        }
        const selectedPharmacy = this.pharmacyFacade.getSelectedPharmacy();
        return this.planFacade.getTotalEstimatedCost(plans[0], selectedPharmacy, this.isMailOrder);
    }
    getCalculatedBasePlanPremium(plans) {
        if (!plans?.length) {
            return 0;
        }
        const [selectedPlan] = plans;
        // SPA-12083: the available plan's riders are the selected options from Plan Details / HIP Quote Summary or the default base option
        return this.plansService.getTotalPremium([selectedPlan], selectedPlan.riders) ?? 0;
    }
    getTotalDrugCost(plans) {
        if (!plans?.length) {
            return 0;
        }
        const selectedPharmacy = this.pharmacyFacade.getSelectedPharmacy();
        return this.planFacade.getTotalAnnualDrugCostShare(plans[0], selectedPharmacy, this.isMailOrder);
    }
    getSortTransformer(dataKey) {
        let sortTransformer = null;
        if (dataKey === SortLabels.MEDICAL_PREMIUM) {
            sortTransformer = this.plansService.getTotalPremium.bind(this.plansService);
        }
        else if (dataKey === SortLabels.TOTAL_ESTIMATED_COST) {
            sortTransformer = this.getTotalEstimatedCost.bind(this);
        }
        else if (dataKey === SortLabels.ESTIMATED_DRUG_COSTS) {
            sortTransformer = this.getTotalDrugCost.bind(this);
        }
        else if (dataKey === SortLabels.CALCULATED_BASE_PLAN_PREMIUM) {
            sortTransformer = this.getCalculatedBasePlanPremium.bind(this);
        }
        return sortTransformer;
    }
    getHighestScoreByTabIndex(plans) {
        const maxScoresByTab = [];
        this.tabs.forEach(tab => {
            const plansWithScores = this.filterService.getPlansByFilterGroupSnapshot(tab.filters).filter(plan => !!plan.score);
            if (plansWithScores.length) {
                const planScores = plansWithScores.map(plan => plan.score);
                if (planScores.length) {
                    maxScoresByTab.push(Math.max(...planScores));
                }
                else {
                    maxScoresByTab.push(0);
                }
            }
            else {
                maxScoresByTab.push(0);
            }
        });
        return maxScoresByTab;
    }
    getSortOptionByDataKey(sortListLookup, currentSortList) {
        const defaultSort = sortListLookup.find(sort => sort.isDefault);
        if (defaultSort) {
            const currentDefault = currentSortList.find(sort => sort.dataKey === defaultSort.dataKey);
            if (!currentDefault) {
                return currentSortList.find(sort => sort.dataKey === defaultSort.secondaryDataKey);
            }
            return currentDefault;
        }
        return defaultSort;
    }
    // NOTE: Highest scoring plan on the coverageType selected(MA, PDP, MAPD, MedSup are possible) in guided help
    getBestMatchPlanId$() {
        if (this.Spa_PlanList_BestMatchPlan_Enabled && this.mustShowBestMatchPlan()) {
            return this.getCoverageType$().pipe(switchMap((coverageType) => {
                const coverageTypeAbbreviation = this.guidedHelpService.coverageTypeToTab(coverageType);
                return this.store.select(PlansState.bestMatchPlanId(coverageTypeAbbreviation));
            }));
        }
        return of('');
    }
    // If conditions to show Best Match Plan are met, then it must be displayed in the tab Best Match PLan is
    // If conditions to show Best Match Plan are not met, but have selected Coverage Type, show in that tab
    // Returning null if Best Coverage Badge must not be shown
    getBestCoverageTabAbbreviation$() {
        return this.getCoverageType$().pipe(switchMap((coverageType) => {
            const coverageTypeAbbreviation = this.guidedHelpService.coverageTypeToTab(coverageType);
            return this.store.select(PlansState.bestCoverageTabAbbreviation(coverageTypeAbbreviation));
        }), map((bestCoverageTabAbbreviation) => this.getBestCoverageTabAbbreviationOrDefault(bestCoverageTabAbbreviation)));
    }
    getReturnToPreferencesClickAction(bestCoverageTypeTooltipText, returnToPreferencesText) {
        const guidedHelpURL = this.navigationUtilityService.constructAbsoluteUrl(PageTags.GUIDED_HELP_GETTING_STARTED);
        return bestCoverageTypeTooltipText
            ? bestCoverageTypeTooltipText.replace('<returnToPreferencesAction>', `<a class="can-click Spa_Style_Link" href="${guidedHelpURL}" target="_self"> ${returnToPreferencesText}<a>`)
            : '';
    }
    getBestMatchPlanIdValueForAnalytics() {
        const bestMatchPlanId = this.store.selectSnapshot(PlansState.bestMatchPlanId(this.getCoverageTypeAbbreviation()));
        const bestMatchPlanIdOrDefault = this.mustShowBestMatchPlan() ? bestMatchPlanId : null;
        return this.getBestMatchPlanIdAnalyticsValue(bestMatchPlanIdOrDefault);
    }
    getBestCoverageTabAbbreviationValueForAnalytics() {
        const bestCoverageTabAbbreviation = this.store.selectSnapshot(PlansState.bestCoverageTabAbbreviation(this.getCoverageTypeAbbreviation()));
        const bestCoverageTabAbbreviationOrDefault = this.getBestCoverageTabAbbreviationOrDefault(bestCoverageTabAbbreviation);
        return this.getBestMatchTabAbbreviationAnalyticsValue(bestCoverageTabAbbreviationOrDefault);
    }
    getCoverageTypeAbbreviation() {
        return this.guidedHelpService.coverageTypeToTab(this.getCoverageType());
    }
    getEnabledPlanTypesData(planTypes) {
        return _sortBy(planTypes.filter(planType => planType.enabled), 'title');
    }
    isPlanYearUpdateModalEnabled(widgetName) {
        return (this.planYearResourceService.getIsDualPlanYearSite() &&
            this.configResourceService.getProcessedResourceValue('Spa_DualPlanYear_Update_Enabled', widgetName, true) &&
            this.configResourceService.getProcessedResourceValue('Spa_DualPlanYear_PlanList_Text_Enabled', widgetName, true) &&
            !!this.configResourceService.getProcessedResourceValue('Spa_DualPlanYear_PlanList_Text', widgetName, 'for <YYYY>') &&
            this.agentService.agentInContextHasAccessToViewAllPlanYears());
    }
    isPlanTypeLoaded(planType, loadedPlanTypes) {
        // since we load medicare plans using the aggregate type(7) but display them on the basis of
        // individual plan types(1,2,4) we need to convert to the aggregate type before checking
        // if plans have been loaded
        const loadedPlanType = PlansUtilityService.getPlanBucketKey(planType);
        return loadedPlanTypes?.includes(loadedPlanType);
    }
    getTabCount(isTabLoaded, tabPlanType, planTypePlanCountMap, planCounts) {
        const selectedPlanCountMap = isTabLoaded ? planTypePlanCountMap : planCounts;
        return selectedPlanCountMap?.[tabPlanType] ?? 0;
    }
    getBestMatchPlanIdAnalyticsValue(bestMatchPlanId) {
        if (this.isBestMatchPlanEnabled()) {
            return bestMatchPlanId ?? GOOGLE_ANALYTICS_NONE;
        }
        return this.analyticsService.getGoogleTagManagerNotApplicableText();
    }
    getBestMatchTabAbbreviationAnalyticsValue(bestCoverageTabAbbreviation) {
        if (this.isBestCoverageTypeEnabled()) {
            return bestCoverageTabAbbreviation ?? GOOGLE_ANALYTICS_NONE;
        }
        return this.analyticsService.getGoogleTagManagerNotApplicableText();
    }
    getBestCoverageTabAbbreviationOrDefault(bestCoverageTabAbbreviation) {
        if (this.mustShowBestCoverage()) {
            return bestCoverageTabAbbreviation || this.getDefaultTabFromCoverageType();
        }
        return null;
    }
    // If all parts of GH are answered, show Best Match Plan badge
    // If provider is added, show Best Match Plan badge
    // If NO provider and only ONE other piece of GH (Drug OR Pharmacy OR Other Pref Question), do NOT show Best Match Plan
    // If NO provider and TWO pieces of GH including Other Pref (Drug OR Pharmacy + Other Pref Question), show Best Match Plan
    // If ONLY Drug and/or Pharmacy added (no provider, no Other Pref), do NOT show Best Match Plan
    mustShowBestMatchPlan() {
        let mustShowBestMatchPlan = false;
        const providers = this.guidedHelpService.getSelectedProviders();
        if (providers?.length) {
            mustShowBestMatchPlan = true;
        }
        else {
            const hasSelectedPharmacy = this.guidedHelpService.getSelectedPharmacy();
            const hasMedicineCabinet = this.guidedHelpService.getMedicineCabinet();
            mustShowBestMatchPlan = this.hasSelectedOtherPreferences() && (!!hasSelectedPharmacy || !!hasMedicineCabinet?.length);
        }
        return mustShowBestMatchPlan;
    }
    // If all conditions for Best Match Plan badge are met, show Best Coverage badge,
    // else only show it if COverage Type has been selected
    mustShowBestCoverage() {
        let mustShowBestCoverage = false;
        const mustShowBestMatchPlan = this.mustShowBestMatchPlan();
        if (mustShowBestMatchPlan) {
            mustShowBestCoverage = true;
        }
        else {
            const hasSelectedPlanPreference = this.guidedHelpService.coverageType();
            // Coverage Type "I don't know": If no best match plan, then do not show best coverage type.
            mustShowBestCoverage = !!hasSelectedPlanPreference && hasSelectedPlanPreference !== CoverageType.I_DONT_KNOW;
        }
        return mustShowBestCoverage;
    }
    hasSelectedOtherPreferences() {
        const preferenceAnswerIdsWithType = this.preferencesService.getPreferenceAnswerIdsWithType();
        // Check for valid responses, any Id bellow 0 is not a valid response to consider
        // ie.'None of these' preference has id -1
        const hasAnsweredValidResponses = preferenceAnswerIdsWithType.some(preference => parseInt(preference.id, 10) > 0);
        return hasAnsweredValidResponses;
    }
    getCoverageType$() {
        return this.guidedHelpService.coverageType$();
    }
    getCoverageType() {
        return this.guidedHelpService.coverageType();
    }
    getIndexFromCurrentPlanScores(planScores, coverageType) {
        if (!!coverageType && coverageType !== CoverageType.I_DONT_KNOW) {
            // For MedicalOnly Coverage type, find the tab with max scores between Medsup and MA
            if (coverageType === CoverageType.MEDICAL_ONLY) {
                const medicalOnlyScores = this.loadMedicalOnlyScoresWithIndex(planScores);
                const scores = medicalOnlyScores.map(medicalOnlyScore => medicalOnlyScore.score);
                if (scores && !this.maxScoreTied(scores)) {
                    const maxScore = Math.max(...scores);
                    const maxScoreItem = medicalOnlyScores.find(scoreWithIndex => scoreWithIndex.score === maxScore);
                    if (typeof maxScoreItem?.tabIndex !== 'undefined' && maxScoreItem.tabIndex !== null) {
                        const medicalMaxIndex = maxScoreItem.tabIndex;
                        const tabSelectedByScore = this.getTabType(medicalMaxIndex);
                        return this.getIndexByFilterAndSelectedType(tabSelectedByScore);
                    }
                }
            }
            return -1;
        }
        if (!this.maxScoreTied(planScores)) {
            const maxIndex = planScores.indexOf(Math.max(...planScores));
            const tabSelectedByScore = this.getTabType(maxIndex);
            return this.getIndexByFilterAndSelectedType(tabSelectedByScore);
        }
        return -1;
    }
    loadMedicalOnlyScoresWithIndex(planScores) {
        const medicalOnlyScores = [];
        const medigapTabIndex = this.getIndexByFilterAndSelectedType(PlanTypeAbbreviation.MEDIGAP);
        if (typeof medigapTabIndex !== 'undefined' && medigapTabIndex !== null) {
            medicalOnlyScores.push({ tabIndex: medigapTabIndex, score: planScores[medigapTabIndex] });
        }
        const maTabIndex = this.getIndexByFilterAndSelectedType(PlanTypeAbbreviation.MA);
        if (typeof maTabIndex !== 'undefined' && maTabIndex !== null) {
            medicalOnlyScores.push({ tabIndex: maTabIndex, score: planScores[maTabIndex] });
        }
        return medicalOnlyScores;
    }
    maxScoreTied(scores) {
        const maxScore = Math.max(...scores);
        const newScoreArray = scores.filter(score => score === maxScore);
        return newScoreArray.length > 1;
    }
    getSortListForScore(scoreFlag, sortList, activeTabIndex) {
        return !scoreFlag
            ? sortList.filter(sortItem => sortItem.dataKey !== SortLabels.SCORE)
            : sortList.map(sortItem => {
                if (sortItem.dataKey === SortLabels.SCORE) {
                    const tabType = this.getTabType(activeTabIndex);
                    if (tabType === PlanTypeAbbreviation.MEDIGAP || ANCILLARY_PLANS.includes(tabType)) {
                        const answers = tabType === PlanTypeAbbreviation.MEDIGAP ? this.medSupService.getMedSupAnswers() : this.medSupService.getAncillaryAnswers();
                        if (RateFactorsUtilityService.hasAnswers(answers)) {
                            sortItem.secondaryDataKey = this.medigapAfterAnswersSort.secondaryDataKey;
                            sortItem.secondarySortType = this.medigapAfterAnswersSort.secondarySortType;
                        }
                        else {
                            sortItem.secondaryDataKey = this.medigapBeforeAnswersSort.secondaryDataKey;
                            sortItem.secondarySortType = this.medigapBeforeAnswersSort.secondarySortType;
                        }
                    }
                    return sortItem;
                }
                return sortItem;
            });
    }
    getTabIndexByType(tabs, selectedType) {
        // Consider the tab's first type value as the main type
        const tabIndex = tabs.findIndex(tab => tab.filters.some(tabFilter => tabFilter.key && tabFilter.values[0] === selectedType));
        return tabIndex === -1 ? 0 : tabIndex;
    }
    getIndexByFilterAndSelectedType(selectedType) {
        return this.getTabIndexByType(this.tabs, selectedType);
    }
    isTabVisible(selectedType) {
        return this.getIndexByFilterAndSelectedType(selectedType) > -1;
    }
    isPrimaryTab(tab) {
        return tab.tabIndex === 0 || tab.defaultActive;
    }
}
PlanListFacadeService.ɵfac = function PlanListFacadeService_Factory(t) { return new (t || PlanListFacadeService)(i0.ɵɵinject(ConfigurableWidgetService), i0.ɵɵinject(PlanFacade), i0.ɵɵinject(i2.Store), i0.ɵɵinject(PlanListContextService), i0.ɵɵinject(PlanListResourceFacade), i0.ɵɵinject(PharmacyFacade), i0.ɵɵinject(i1.PlansService), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.GuidedHelpService), i0.ɵɵinject(i1.SNPService), i0.ɵɵinject(MedSupFacade), i0.ɵɵinject(i1.MedSupService), i0.ɵɵinject(i1.PreferencesService), i0.ɵɵinject(i1.NavigationUtilityService), i0.ɵɵinject(AnalyticsService), i0.ɵɵinject(HospitalIndemnityFormFacade), i0.ɵɵinject(i1.MillimanService), i0.ɵɵinject(i1.PlanYearResourceService), i0.ɵɵinject(i1.AgentService), i0.ɵɵinject(i1.SiteService)); };
PlanListFacadeService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlanListFacadeService, factory: PlanListFacadeService.ɵfac, providedIn: 'root' });
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getMedSupFormIsOpen$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getDentalVisionFormIsOpen$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getEnrollmentSettingsLoading$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getZipCode$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getFipsCode$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getOverrideActiveTab$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getHasMedSupQuestions$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getMedSupQuestions$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getHasMedSupAnswers$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getMedSupStateIsLoading$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getAncillaryQuestions$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getHasAncillaryQuestions$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getHasAncillaryAnswers$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getCompareGroups$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getQuoteGroups$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getFilteredPlansHasSNPPlans$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getFilteredCSNPPlansCount$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getFilteredDSNPPlansCount$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getFilteredISNPPlansCount$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getTotalAppliedFilters$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getAppliedFilterValues$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getShowEmptyFilterMessage$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getMedSupPlansWithoutFilters$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getMedSupPlanCount$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getDentalPlansWithoutFilters$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getDentalPlanCount$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getVisionPlansWithoutFilters$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getVisionPlanCount$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getSelectedTabSortList$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getShowNoPlansFromAnswersMessage$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getShowMedSupForm$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getShowDentalForm$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getShowVisionForm$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getSortedQuestions$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getFilteredQuestionsMetaData$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getFilteredAncillaryQuestionsMetaData$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getShowPlanNotAvailableForNextYearText$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getMedSupPlanCountByFilterList$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getActiveTabType$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getFilterGroups$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getShowHospitalIndemnityForm$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "insulinPlansExist$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "pufPlansExist$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getVisibleSNPTypes$", null);
__decorate([
    MemoizeObservable()
], PlanListFacadeService.prototype, "getPlansSelectedToQuote$", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanListFacadeService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ConfigurableWidgetService }, { type: PlanFacade }, { type: i2.Store }, { type: PlanListContextService }, { type: PlanListResourceFacade }, { type: PharmacyFacade }, { type: i1.PlansService }, { type: i1.ConfigResourceService }, { type: i1.GuidedHelpService }, { type: i1.SNPService }, { type: MedSupFacade }, { type: i1.MedSupService }, { type: i1.PreferencesService }, { type: i1.NavigationUtilityService }, { type: AnalyticsService }, { type: HospitalIndemnityFormFacade }, { type: i1.MillimanService }, { type: i1.PlanYearResourceService }, { type: i1.AgentService }, { type: i1.SiteService }]; }, { getMedSupFormIsOpen$: [], getDentalVisionFormIsOpen$: [], getEnrollmentSettingsLoading$: [], getZipCode$: [], getFipsCode$: [], getOverrideActiveTab$: [], getHasMedSupQuestions$: [], getMedSupQuestions$: [], getHasMedSupAnswers$: [], getMedSupStateIsLoading$: [], getAncillaryQuestions$: [], getHasAncillaryQuestions$: [], getHasAncillaryAnswers$: [], getCompareGroups$: [], getQuoteGroups$: [], getFilteredPlansHasSNPPlans$: [], getFilteredCSNPPlansCount$: [], getFilteredDSNPPlansCount$: [], getFilteredISNPPlansCount$: [], getTotalAppliedFilters$: [], getAppliedFilterValues$: [], getShowEmptyFilterMessage$: [], getMedSupPlansWithoutFilters$: [], getMedSupPlanCount$: [], getDentalPlansWithoutFilters$: [], getDentalPlanCount$: [], getVisionPlansWithoutFilters$: [], getVisionPlanCount$: [], getSelectedTabSortList$: [], getShowNoPlansFromAnswersMessage$: [], getShowMedSupForm$: [], getShowDentalForm$: [], getShowVisionForm$: [], getSortedQuestions$: [], getFilteredQuestionsMetaData$: [], getFilteredAncillaryQuestionsMetaData$: [], getShowPlanNotAvailableForNextYearText$: [], getMedSupPlanCountByFilterList$: [], getActiveTabType$: [], getFilterGroups$: [], getShowHospitalIndemnityForm$: [], insulinPlansExist$: [], pufPlansExist$: [], getVisibleSNPTypes$: [], getPlansSelectedToQuote$: [] }); })();

const _c0$3u = ["promptElement"];
function SNPInfoModalComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "vnext-link", 9);
    i0.ɵɵlistener("click", function SNPInfoModalComponent_div_5_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.preferencesIndicatorClick()); })("keyup.enter", function SNPInfoModalComponent_div_5_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r5); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.preferencesIndicatorClick()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r1.preferencesIndicatorLinkText)("makeInlineBlock", true)("alwaysUnderlined", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.preferencesIndicatorText, " ");
} }
function SNPInfoModalComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "vnext-link", 9);
    i0.ɵɵlistener("click", function SNPInfoModalComponent_div_6_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.profileClick()); })("keyup.enter", function SNPInfoModalComponent_div_6_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.profileClick()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r2.profileEligibilityLinkText)("makeInlineBlock", true)("alwaysUnderlined", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.profileEligibilityText, " ");
} }
function SNPInfoModalComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function SNPInfoModalComponent_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.cancel()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.cancelButtonText, " ");
} }
const SSA_GOV_URL = 'https://www.ssa.gov';
class SNPInfoModalComponent {
    constructor(guidedHelpService, navigationService, activeModal, renderer, analyticsService) {
        this.guidedHelpService = guidedHelpService;
        this.navigationService = navigationService;
        this.activeModal = activeModal;
        this.renderer = renderer;
        this.analyticsService = analyticsService;
        this.trackSNPExtraHelpApplyOnlineEvent = () => {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_SNP_PLAN_EXTRA_HELP_APPLY_ONLINE_EVENT);
        };
        this.listeners = [];
    }
    ngAfterViewInit() {
        // Selects the first link whose URL starts with "https://www.ssa.gov" (it is assumed there should only be one ssa.gov link within the prompt)
        const hrefAttrSelector = `a[href^="${SSA_GOV_URL}"]`;
        const ssaGovLinkElement = this.promptElement?.nativeElement?.querySelector(hrefAttrSelector);
        if (ssaGovLinkElement) {
            this.listeners.push(this.renderer.listen(ssaGovLinkElement, 'click', this.trackSNPExtraHelpApplyOnlineEvent));
            this.listeners.push(this.renderer.listen(ssaGovLinkElement, 'keyup.enter', this.trackSNPExtraHelpApplyOnlineEvent));
        }
    }
    ngOnDestroy() {
        this.listeners.forEach(removeListener => removeListener?.());
    }
    cancel() {
        this.activeModal.dismiss();
        if (this.cancelAction) {
            this.cancelAction();
        }
    }
    preferencesIndicatorClick() {
        this.guidedHelpService.selectCoverageType(CoverageType.MEDICAL_AND_PRESCRIPTION_DRUG);
        this.cancel();
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_SNP_PLAN_EXTRA_HELP_PREFERENCES_EVENT);
        this.navigationService.navigateByPageTag(PageTags.GUIDED_HELP_GETTING_STARTED);
    }
    profileClick() {
        this.cancel();
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_SNP_PLAN_EXTRA_HELP_CHECK_ELIGIBILITY_EVENT);
        this.navigationService.navigateByPageTag(PageTags.ADD_NEW_PROFILE);
    }
}
SNPInfoModalComponent.ɵfac = function SNPInfoModalComponent_Factory(t) { return new (t || SNPInfoModalComponent)(i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(AnalyticsService)); };
SNPInfoModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SNPInfoModalComponent, selectors: [["ng-component"]], viewQuery: function SNPInfoModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3u, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.promptElement = _t.first);
    } }, decls: 9, vars: 8, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "Spa_Style_Primary_Color", "modal-body", "Spa_Style_Paragraph", 3, "innerHtml"], ["promptElement", ""], [1, "separator", "Spa_Style_Paragraph"], ["class", "mt-4 mb-2", 4, "ngIf"], ["class", "mt-2 mb-4", 4, "ngIf"], [1, "modal-footer", "justify-content-start"], ["type", "button", "class", "btn Spa_Style_SecondaryButton mr-auto", 3, "click", 4, "ngIf"], [1, "mt-4", "mb-2"], [3, "title", "makeInlineBlock", "alwaysUnderlined", "click", "keyup.enter"], [1, "mt-2", "mb-4"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "mr-auto", 3, "click"]], template: function SNPInfoModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function SNPInfoModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.cancel(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(1, "div", 1, 2);
        i0.ɵɵpipe(3, "safe");
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtemplate(5, SNPInfoModalComponent_div_5_Template, 3, 4, "div", 4);
        i0.ɵɵtemplate(6, SNPInfoModalComponent_div_6_Template, 3, 4, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵtemplate(8, SNPInfoModalComponent_button_8_Template, 2, 1, "button", 7);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(3, 5, ctx.prompt, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.profileEligibilityLinkEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.eligibilityCheckEnabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.cancelButtonText);
    } }, dependencies: [i1$2.NgIf, LinkComponent, ModalHeaderComponent, SafePipe], styles: [".separator[_ngcontent-%COMP%]{border-top:1px solid var(--static-Spa_Style_Accent1);margin:0 15px 20px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SNPInfoModalComponent, [{
        type: Component,
        args: [{ template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"cancel()\"></vnext-widget-modal-header>\r\n\r\n<div #promptElement class=\"Spa_Style_Primary_Color modal-body Spa_Style_Paragraph\" [innerHtml]=\"prompt | safe : 'html'\"></div>\r\n\r\n<div class=\"separator Spa_Style_Paragraph\">\r\n  <div class=\"mt-4 mb-2\" *ngIf=\"profileEligibilityLinkEnabled\">\r\n    <vnext-link\r\n      [title]=\"preferencesIndicatorLinkText\"\r\n      [makeInlineBlock]=\"true\"\r\n      [alwaysUnderlined]=\"true\"\r\n      (click)=\"preferencesIndicatorClick()\"\r\n      (keyup.enter)=\"preferencesIndicatorClick()\"\r\n    ></vnext-link>\r\n    {{ preferencesIndicatorText }}\r\n  </div>\r\n  <div class=\"mt-2 mb-4\" *ngIf=\"eligibilityCheckEnabled\">\r\n    <vnext-link\r\n      [title]=\"profileEligibilityLinkText\"\r\n      [makeInlineBlock]=\"true\"\r\n      [alwaysUnderlined]=\"true\"\r\n      (click)=\"profileClick()\"\r\n      (keyup.enter)=\"profileClick()\"\r\n    ></vnext-link>\r\n    {{ profileEligibilityText }}\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer justify-content-start\">\r\n  <button *ngIf=\"cancelButtonText\" type=\"button\" class=\"btn Spa_Style_SecondaryButton mr-auto\" (click)=\"cancel()\">\r\n    {{ cancelButtonText }}\r\n  </button>\r\n</div>\r\n", styles: [".separator{border-top:1px solid var(--static-Spa_Style_Accent1);margin:0 15px 20px}\n"] }]
    }], function () { return [{ type: i1.GuidedHelpService }, { type: i1.NavigationService }, { type: i1$1.NgbActiveModal }, { type: i0.Renderer2 }, { type: AnalyticsService }]; }, { promptElement: [{
            type: ViewChild,
            args: ['promptElement']
        }] }); })();

function PlanCoveragePrescriptionInfoModalComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "vnext-selectrx-section");
    i0.ɵɵelementEnd();
} }
function PlanCoveragePrescriptionInfoModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12);
    i0.ɵɵelement(2, "i", 12);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const medicine_r3 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", medicine_r3.isCovered ? "Spa_Style_Primary_Color" : "Spa_Style_Gray4_Color");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", medicine_r3.isCovered ? "fas fa-check text-cost" : "fas fa-times-circle");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", medicine_r3.drugDetails == null ? null : medicine_r3.drugDetails.drugName, " ");
} }
function PlanCoveragePrescriptionInfoModalComponent_div_9_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelement(1, "div", 22);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 1, ctx_r6.drugAlternativesTooltipText, "html"), i0.ɵɵsanitizeHtml);
} }
function PlanCoveragePrescriptionInfoModalComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14);
    i0.ɵɵtemplate(2, PlanCoveragePrescriptionInfoModalComponent_div_9_ng_template_2_Template, 3, 4, "ng-template", null, 15, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(4, "button", 16, 17);
    i0.ɵɵlistener("click", function PlanCoveragePrescriptionInfoModalComponent_div_9_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.onDrugAlternativesNudgeClick()); });
    i0.ɵɵelementStart(6, "div", 18);
    i0.ɵɵelement(7, "i", 19);
    i0.ɵɵelementStart(8, "span", 20);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const _r5 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngbTooltip", _r5)("disableTooltip", ctx_r2.isMobile);
    i0.ɵɵadvance(3);
    i0.ɵɵclassMapInterpolate1("", ctx_r2.drugAlternativesIndicatorIcon, " save-on-prescriptions-icon");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.nudgeDrugAlternativesLabelText, " ");
} }
class PlanCoveragePrescriptionInfoModalComponent {
    constructor(activeModal, analyticsService) {
        this.activeModal = activeModal;
        this.analyticsService = analyticsService;
        this.medicineCabinet = [];
        this.pageTags = PageTags;
        this.showOffFormularyDrugAlternativesTooltip = false;
        this.selectRxPlanListDrugModalTextEnabled = false;
    }
    ngOnInit() {
        this.updateMedicineCabinet();
    }
    updateMedicineCabinet() {
        this.medicineCabinet = this.medicineCabinet.map(medicine => ({
            ...medicine,
            isCovered: this.isDrugCovered(medicine.dosageID)
        }));
    }
    isDrugCovered(drugDoseId) {
        return !!this.coveredDrugDosageIds?.includes(drugDoseId);
    }
    trackByDosageId(index, medicine) {
        return medicine.dosageID;
    }
    onDrugAlternativesNudgeClick() {
        this.activeModal.dismiss();
        if (this.drugAlternativesNudgeAction) {
            this.drugAlternativesNudgeAction(this.plan);
        }
    }
    onPrescriptionAddOrEditClick() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_PRESCRIPTION);
        this.activeModal.dismiss();
        if (this.editAction) {
            this.editAction();
        }
    }
    close() {
        this.activeModal.dismiss();
        if (this.cancelAction) {
            this.cancelAction();
        }
    }
}
PlanCoveragePrescriptionInfoModalComponent.ɵfac = function PlanCoveragePrescriptionInfoModalComponent_Factory(t) { return new (t || PlanCoveragePrescriptionInfoModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(AnalyticsService)); };
PlanCoveragePrescriptionInfoModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCoveragePrescriptionInfoModalComponent, selectors: [["ng-component"]], decls: 13, vars: 14, consts: [[3, "modalTitleText", "modalTitleCancelAction"], ["class", "col-12 pt-3", 4, "ngIf"], [1, "Spa_Style_Primary_Color", "modal-body"], [1, "prescription-container"], ["class", "mb-2 no-translate-block", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "mb-2", "mt-3", "width-fit-content", "add-edit-link"], ["tabindex", "0", 1, "link", "Spa_Style_Link", "action-button", 3, "title", "click"], ["class", "mt-4", 4, "ngIf"], [1, "modal-footer", "justify-content-start"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "mr-auto", 3, "click"], [1, "col-12", "pt-3"], [1, "mb-2", "no-translate-block"], [3, "ngClass"], [1, "mt-4"], [1, "Spa_Style_Link"], ["nudgeDrugAlternativesTooltip", ""], ["tooltipClass", "nudge-drug-alternatives-tooltip", 1, "action-button", "Spa_Style_Link", 3, "ngbTooltip", "disableTooltip", "click"], ["drugAlternativesTooltip", "ngbTooltip"], [1, "d-flex", "flex-row", "align-items-center"], ["aria-hidden", "true"], [1, "text-left", "text-underline"], [1, "Spa_Style_ToolTip", "p-0"], [3, "innerHTML"]], template: function PlanCoveragePrescriptionInfoModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function PlanCoveragePrescriptionInfoModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.close(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(1, PlanCoveragePrescriptionInfoModalComponent_div_1_Template, 2, 0, "div", 1);
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3);
        i0.ɵɵtemplate(4, PlanCoveragePrescriptionInfoModalComponent_div_4_Template, 4, 3, "div", 4);
        i0.ɵɵpipe(5, "orderBy");
        i0.ɵɵelementStart(6, "div", 5)(7, "button", 6);
        i0.ɵɵlistener("click", function PlanCoveragePrescriptionInfoModalComponent_Template_button_click_7_listener() { return ctx.onPrescriptionAddOrEditClick(); });
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(9, PlanCoveragePrescriptionInfoModalComponent_div_9_Template, 10, 6, "div", 7);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "div", 8)(11, "button", 9);
        i0.ɵɵlistener("click", function PlanCoveragePrescriptionInfoModalComponent_Template_button_click_11_listener() { return ctx.close(); });
        i0.ɵɵtext(12);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectRxPlanListDrugModalTextEnabled);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind4(5, 9, ctx.medicineCabinet, "labelName", false, true))("ngForTrackBy", ctx.trackByDosageId);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("title", ctx.prescriptionsAddEditLinkTitle);
        i0.ɵɵattribute("aria-label", ctx.prescriptionsAddEditLinkTitle);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.prescriptionsAddEditLinkTitle, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showOffFormularyDrugAlternativesTooltip);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.closeButtonText, " ");
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, ModalHeaderComponent, i1$1.NgbTooltip, SelectRXSectionComponent, SafePipe, OrderPipe], styles: [".prescription-container[_ngcontent-%COMP%]{min-height:25px;max-height:500px;overflow-y:auto}.save-on-prescriptions-icon[_ngcontent-%COMP%]{margin-right:10px}.action-button[_ngcontent-%COMP%], .action-button[_ngcontent-%COMP%]:hover{text-decoration:none}.text-cost[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text)}.add-edit-link[_ngcontent-%COMP%]{margin-left:6px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCoveragePrescriptionInfoModalComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"close()\"></vnext-widget-modal-header>\r\n\r\n<div *ngIf=\"selectRxPlanListDrugModalTextEnabled\" class=\"col-12 pt-3\">\r\n  <vnext-selectrx-section></vnext-selectrx-section>\r\n</div>\r\n\r\n<div class=\"Spa_Style_Primary_Color modal-body\">\r\n  <div class=\"prescription-container\">\r\n    <div\r\n      class=\"mb-2 no-translate-block\"\r\n      *ngFor=\"let medicine of medicineCabinet | orderBy : 'labelName' : false : true; index as index; trackBy: trackByDosageId\"\r\n    >\r\n      <div [ngClass]=\"medicine.isCovered ? 'Spa_Style_Primary_Color' : 'Spa_Style_Gray4_Color'\">\r\n        <i [ngClass]=\"medicine.isCovered ? 'fas fa-check text-cost' : 'fas fa-times-circle'\"></i>\r\n        {{ medicine.drugDetails?.drugName }}\r\n      </div>\r\n    </div>\r\n    <div class=\"mb-2 mt-3 width-fit-content add-edit-link\">\r\n      <button\r\n        class=\"link Spa_Style_Link action-button\"\r\n        tabindex=\"0\"\r\n        [title]=\"prescriptionsAddEditLinkTitle\"\r\n        (click)=\"onPrescriptionAddOrEditClick()\"\r\n        [attr.aria-label]=\"prescriptionsAddEditLinkTitle\"\r\n      >\r\n        {{ prescriptionsAddEditLinkTitle }}\r\n      </button>\r\n    </div>\r\n\r\n    <div class=\"mt-4\" *ngIf=\"showOffFormularyDrugAlternativesTooltip\">\r\n      <div class=\"Spa_Style_Link\">\r\n        <ng-template #nudgeDrugAlternativesTooltip>\r\n          <div class=\"Spa_Style_ToolTip p-0\">\r\n            <div [innerHTML]=\"drugAlternativesTooltipText | safe : 'html'\"></div>\r\n          </div>\r\n        </ng-template>\r\n\r\n        <button\r\n          class=\"action-button Spa_Style_Link\"\r\n          #drugAlternativesTooltip=\"ngbTooltip\"\r\n          [ngbTooltip]=\"nudgeDrugAlternativesTooltip\"\r\n          [disableTooltip]=\"isMobile\"\r\n          tooltipClass=\"nudge-drug-alternatives-tooltip\"\r\n          (click)=\"onDrugAlternativesNudgeClick()\"\r\n        >\r\n          <div class=\"d-flex flex-row align-items-center\">\r\n            <i class=\"{{ drugAlternativesIndicatorIcon }} save-on-prescriptions-icon\" aria-hidden=\"true\"></i>\r\n            <span class=\"text-left text-underline\">\r\n              {{ nudgeDrugAlternativesLabelText }}\r\n            </span>\r\n          </div>\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"modal-footer justify-content-start\">\r\n  <button type=\"button\" (click)=\"close()\" class=\"btn Spa_Style_SecondaryButton mr-auto\">\r\n    {{ closeButtonText }}\r\n  </button>\r\n</div>\r\n", styles: [".prescription-container{min-height:25px;max-height:500px;overflow-y:auto}.save-on-prescriptions-icon{margin-right:10px}.action-button,.action-button:hover{text-decoration:none}.text-cost{color:var(--static-Spa_Style_Cost_Text)}.add-edit-link{margin-left:6px}\n"] }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: AnalyticsService }]; }, null); })();

class PlanCardFacade {
    constructor(store, demographicService, configResourceService, pharmacyService, providerService, providerFacade, modalService, rendererFactory, localeService, planFacade, spinnerService, navigationService, analyticsService, guidedHelpModalContextService) {
        this.store = store;
        this.demographicService = demographicService;
        this.configResourceService = configResourceService;
        this.pharmacyService = pharmacyService;
        this.providerService = providerService;
        this.providerFacade = providerFacade;
        this.modalService = modalService;
        this.rendererFactory = rendererFactory;
        this.localeService = localeService;
        this.planFacade = planFacade;
        this.spinnerService = spinnerService;
        this.navigationService = navigationService;
        this.analyticsService = analyticsService;
        this.guidedHelpModalContextService = guidedHelpModalContextService;
        this.isProviderEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_Providers_Enabled', null, false);
        this.isZelisIntegrationEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_ZelisIntegration_Enabled', null, false);
        this.medicineCabinet$ = this.store.select(MedicineCabinetState.medicineCabinet);
        this.selectedPharmacy$ = this.store.select(PharmacyState.selectedPharmacy);
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }
    isShoppingTalkingPointEnabled() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_DisplayTalkingPoints_Shopping_Enabled', null, false);
    }
    isProviderInfoEnabled() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Provider_ShowAllInNetworkLocations_Enabled', null, true);
    }
    getMedicineCabinet$() {
        return this.medicineCabinet$;
    }
    getSelectedPharmacy$() {
        return this.selectedPharmacy$;
    }
    getDrugsCount$() {
        return this.medicineCabinet$.pipe(map(medicineCabinet => medicineCabinet.length));
    }
    getDrugCoverageText(totalDrugsInCabinet, drugCoveredText, plan, isMailOrderSelected = false) {
        // allow drug coverage text to be translatable.
        return drugCoveredText
            .replace('<coveredDrugCount>', this.getCoveredDrugsCount(plan, isMailOrderSelected).toString())
            .replace('<totalDrugCount>', totalDrugsInCabinet.toString());
    }
    getCoveredDrugsCount(plan, isMailOrderSelected = false) {
        const hasPlanAndDrugCoverage = plan?.planTiers && plan.planTiers.length > 0;
        // Any formulary status that is not within the available plan tiers or 0 indicates that it is not covered.
        if (hasPlanAndDrugCoverage) {
            const planTier = plan.planTiers.find(t => t.pharmacyType === (isMailOrderSelected && plan.planMailOrderDrugCoverage ? PharmacyType.MailOrder : PharmacyType.Retail));
            if (planTier) {
                const availableTiers = planTier.tierInformation;
                const coveredTiers = availableTiers.map(tier => tier.tierNumber);
                if (isMailOrderSelected && plan.planMailOrderDrugCoverage) {
                    const planMailOrderDrugCoverage = plan.planMailOrderDrugCoverage;
                    return planMailOrderDrugCoverage.filter(mailOrderDrugCoverage => coveredTiers.includes(mailOrderDrugCoverage.tierNumber)).length;
                }
                const selectedPharmacy = this.store.selectSnapshot(PharmacyState.selectedPharmacy);
                if (plan.planRetailDrugCoverageMultiPharmacy) {
                    let planRetailDrugCoverage = plan.planRetailDrugCoverageMultiPharmacy;
                    if (selectedPharmacy && planRetailDrugCoverage) {
                        planRetailDrugCoverage = planRetailDrugCoverage.filter(retailDrugCoverageMultiPharmacy => retailDrugCoverageMultiPharmacy.pharmacyNABP === selectedPharmacy.nabp);
                    }
                    return planRetailDrugCoverage.filter(retailDrugCoverage => coveredTiers.includes(retailDrugCoverage.tierNumber)).length;
                }
            }
        }
        return 0;
    }
    getPharmacyCoverageText(plan, pharmacyCoveredText) {
        const pharmacies = this.pharmacyService.getPharmacyData();
        const coveredPharmacies = pharmacies?.length ? 1 : 0;
        const totalPharmacies = 1;
        return pharmacyCoveredText
            .replace('<coveredPharmacies>', coveredPharmacies.toString())
            .replace('<totalPharamcies>', totalPharmacies.toString());
    }
    showSnpRangeModal() {
        const snpInfoModal = this.modalService.open(SNPInfoModalComponent, {
            centered: true,
            backdrop: 'static',
            keyboard: false,
            size: 'lg'
        });
        snpInfoModal.componentInstance.title = this.configResourceService.getProcessedResourceValue('Spa_SNPRangeModal_Title_Text', null, 'Eligible for extra help?');
        snpInfoModal.componentInstance.prompt = this.configResourceService.getProcessedResourceValue('Spa_SNPRangeModal_InformationalText_HTML', null, `<p>Plan premiums vary based on the amount of extra help you receive. Contact the agencies below to see if you qualify.</p>
      <ul style="list-style-type: none;padding-left: 0px;">
        <li><b>1-800-MEDICARE</b></li>
        <li>1-800-633-4227</li>
        <li>TTY users should call 1-877-486-2048</li>
        <li>24 hours a day, 7 days a week.</li>
        <li>Your state medicaid office.</li>
      </ul>
      <p><b>Your State Medicaid Office</b></p>
      <ul style="list-style-type: none;padding-left: 0px;">
        <li><b>Social Security Administration</b></li>
        <li>1-800-772-1213</li>
        <li>TTY users should call 1-800-325-0778</li>
        <li>7 a.m. - 7 p.m., Monday through Friday</li>
      </ul>
      <p>You may also apply online at <a target="_blank" class="Spa_Style_Primary_Link_Color text-underline" href="https://www.ssa.gov/medicare/part-d-extra-help">ssa.gov/medicare/part-d-extra-help</a></p>`);
        snpInfoModal.componentInstance.profileEligibilityLinkEnabled = this.configResourceService.getProcessedResourceValue('Spa_SNPRangeModal_ReturntoPreferences_Link_Enabled', null, true);
        snpInfoModal.componentInstance.preferencesIndicatorLinkText = this.configResourceService.getProcessedResourceValue('Spa_SNPRangeModal_ReturntoPreferences_Link_Text', null, 'Indicate your level of help');
        snpInfoModal.componentInstance.preferencesIndicatorText = this.configResourceService.getProcessedResourceValue('Spa_SNPRangeModal_ReturntoPreferences_Text', null, 'in preferences. The monthly premium will adjust based on your selection.');
        const eligibilityCheckEnabled = this.configResourceService.getProcessedResourceValue('Spa_ProfileEligiblityCheck_Enabled', null, true);
        const snpRangeEligibilityCheckEnabled = this.configResourceService.getProcessedResourceValue('Spa_SNPRangeModal_ReturntoProfile_Link_Enabled', null, true);
        snpInfoModal.componentInstance.eligibilityCheckEnabled = eligibilityCheckEnabled && snpRangeEligibilityCheckEnabled;
        snpInfoModal.componentInstance.profileEligibilityLinkText = this.configResourceService.getProcessedResourceValue('Spa_SNPRangeModal_ReturntoProfile_Link_Text', null, 'Check eligibility');
        snpInfoModal.componentInstance.profileEligibilityText = this.configResourceService.getProcessedResourceValue('Spa_SNPRangeModal_ReturntoProfile_Text', null, 'in the beneficiary’s profile to see if they qualify for extra help.');
        snpInfoModal.componentInstance.cancelButtonText = this.configResourceService.getProcessedResourceValue('Spa_Site_Close', null, 'Close');
    }
    showMedSupAddOnCoverageText() {
        const selectedCounty = this.demographicService.getSelectedCounty();
        if (selectedCounty) {
            return this.demographicService.isWaiverStateWithoutRiderCategories(selectedCounty.state);
        }
        return false;
    }
    showRiderSection(plan, shoppingCartEnabled, showRidersOnPlanCards, showPremiumAsAnnual, riderDisplayMap) {
        return (plan &&
            shoppingCartEnabled &&
            showRidersOnPlanCards &&
            !showPremiumAsAnnual &&
            riderDisplayMap[plan.planTypeAbbreviation] &&
            !!plan.riders.length &&
            (!plan.isNextYearPlan || plan.isPlanRolloverTerminated) &&
            !plan.isCurrentYearPlan);
    }
    showDrugCoverage(displayDrugsCovered, totalDrugsInCabinet) {
        return displayDrugsCovered && totalDrugsInCabinet !== 0;
    }
    getAnnualCost$(plan, isMailOrderSelected = false) {
        const annualCost = {};
        if (plan) {
            let planAnnualCost = plan.planAnnualCost;
            if (isMailOrderSelected &&
                plan.planTypeAbbreviation !== PlanTypeAbbreviation.MEDIGAP &&
                plan.planTypeAbbreviation !== PlanTypeAbbreviation.MA) {
                planAnnualCost = plan.planAnnualMailOrderCost;
            }
            if (planAnnualCost?.annualCostMultiPharmacy) {
                if (planAnnualCost.annualCostMultiPharmacy.length === 1) {
                    return of(planAnnualCost.annualCostMultiPharmacy[0]);
                }
                return this.selectedPharmacy$.pipe(map(pharmacy => {
                    if (pharmacy) {
                        const planAnnualCostMultiPharmacy = planAnnualCost.annualCostMultiPharmacy.find(annualCostMultiPharmacy => annualCostMultiPharmacy && annualCostMultiPharmacy.pharmacyNABP === pharmacy.nabp);
                        if (planAnnualCostMultiPharmacy) {
                            return planAnnualCostMultiPharmacy;
                        }
                    }
                    return annualCost;
                }));
            }
        }
        return of(annualCost);
    }
    drugAlternativesNudge(plan) {
        this.setAnalyticsForPlansSaveOnDrugs(plan);
        this.store.dispatch(new SetActiveTabPrescription(true));
        this.navigationService.navigateByPageTag(PageTags.PLAN_DETAILS, {
            queryParams: { id: plan.id }
        });
    }
    showPrescriptionInfo(plan, medicineCabinet, coveredDrugDosageIds, showOffFormularyDrugAlternativesTooltip, isMobile) {
        const prescriptionModal = this.modalService.open(PlanCoveragePrescriptionInfoModalComponent, {
            centered: true,
            backdrop: 'static',
            keyboard: false
        });
        prescriptionModal.componentInstance.title = this.configResourceService.getProcessedResourceValue('Spa_Site_Prescriptions_Info_Text', null, 'Prescription Information');
        prescriptionModal.componentInstance.closeButtonText = this.configResourceService.getProcessedResourceValue('Spa_Site_Close', null, 'Close');
        prescriptionModal.componentInstance.guidedHelpGetStartedText = this.configResourceService.getProcessedResourceValue('Spa_Site_GetStarted_Text', null, 'Get Started');
        prescriptionModal.componentInstance.prescriptionsAddEditLinkTitle = this.configResourceService.getProcessedResourceValue('Spa_Prescription_Add_Edit_Link', null, 'Add/edit prescription list');
        prescriptionModal.componentInstance.drugAlternativesTooltipText = this.configResourceService.getProcessedResourceValue('Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text', null, 'There may be lower cost alternatives to your non-covered prescriptions.');
        prescriptionModal.componentInstance.nudgeDrugAlternativesLabelText = this.configResourceService.getProcessedResourceValue('Spa_PlanCard_ShowDrugAlternatives_Nudge_Text', null, 'Savings might be available');
        prescriptionModal.componentInstance.drugAlternativesIndicatorIcon = this.configResourceService.getProcessedResourceValue('Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon', null, 'fas fa-tag');
        prescriptionModal.componentInstance.selectRxPlanListDrugModalTextEnabled = this.configResourceService.getProcessedResourceValue('Spa_SelectRx_PlanListDrugModal_Text_Enabled', null, false);
        prescriptionModal.componentInstance.plan = plan;
        prescriptionModal.componentInstance.medicineCabinet = medicineCabinet;
        prescriptionModal.componentInstance.coveredDrugDosageIds = coveredDrugDosageIds;
        prescriptionModal.componentInstance.showOffFormularyDrugAlternativesTooltip = showOffFormularyDrugAlternativesTooltip;
        prescriptionModal.componentInstance.isMobile = isMobile;
        prescriptionModal.componentInstance.drugAlternativesNudgeAction = this.drugAlternativesNudge.bind(this);
        prescriptionModal.componentInstance.editAction = () => {
            this.guidedHelpModalContextService.openGuidedHelpModal(PageTags.GUIDED_HELP_PRESCRIPTIONS);
        };
    }
    async showProvidersInfo(plan) {
        this.spinnerService.show(SpinnerEvent.PROVIDERS_LOADING);
        try {
            const selectedProviders = this.providerService.getSelectedProviders();
            const providerDetailsExtendedData = await this.providerService.fetchProvidersDetailsBasedOnAvailablePlans([plan], true);
            const listOfProviders = this.providerService.planTypeSupportsProviders(plan?.planTypeAbbreviation)
                ? providerDetailsExtendedData?.plans?.find((planData) => planData.id === plan.id)?.providers ?? []
                : [];
            const providersMedicalGroupDetails = this.providerFacade.getProviderMedicalGroups(providerDetailsExtendedData);
            const providerLanguages = this.providerFacade.createProviderLanguagesMap(listOfProviders);
            const providerModal = this.modalService.open(PlanCoverageProviderInfoModalComponent, {
                centered: true,
                backdrop: 'static',
                keyboard: false
            });
            this.setProviderModalResources(providerModal);
            providerModal.componentInstance.providers = this.providerService.getProviders();
            providerModal.componentInstance.providerDetailsResponse = providerDetailsExtendedData;
            providerModal.componentInstance.planId = plan.id;
            providerModal.componentInstance.selectedProviders = selectedProviders;
            providerModal.componentInstance.providersAcceptingNewPatients = listOfProviders;
            providerModal.componentInstance.countryCode = this.localeService.getCountryCode();
            providerModal.componentInstance.languages = providerLanguages;
            providerModal.componentInstance.providersMedicalGroupDetails = providersMedicalGroupDetails;
            providerModal.componentInstance.editAction = () => {
                this.guidedHelpModalContextService.openGuidedHelpModal(PageTags.GUIDED_HELP_PROVIDER_SEARCH);
            };
            providerModal.componentInstance.isZelisIntegrationEnabled = this.isZelisIntegrationEnabled;
        }
        finally {
            this.spinnerService.hide(SpinnerEvent.PROVIDERS_LOADING);
        }
    }
    getProviderCoveredText(planId, selectedProviders, providerDetails, inNetworkText, providerNoPlanDataText, noProviderNetworkAccessText, showProviderSearch, canSellPlan) {
        if (!this.isProviderEnabled || !selectedProviders?.length || !providerDetails) {
            return '';
        }
        if (!canSellPlan) {
            return noProviderNetworkAccessText;
        }
        if (!showProviderSearch || !inNetworkText) {
            return this.getFormattedNoteMessage(providerNoPlanDataText);
        }
        // This will have duplicates of providers, one entry for each address
        const providersBasedOnPlan = this.getProviderDetailInfo(planId, providerDetails);
        if (!providersBasedOnPlan) {
            return this.getFormattedNoteMessage(providerNoPlanDataText);
        }
        else {
            const inNetworkProviders = this.isProviderInfoEnabled()
                ? providersBasedOnPlan.reduce((previousValue, currentValue) => {
                    const providerAddresses = this.providerService.getProviderAddresses(providersBasedOnPlan, currentValue.npi);
                    return providerAddresses?.some(address => address.inNetwork) ? [...previousValue, currentValue] : previousValue;
                }, [])
                : providersBasedOnPlan.filter(provider => provider.inNetwork);
            return inNetworkText
                .replace('<inNetwork>', this.getUniqueProviderDetailsCount(inNetworkProviders).toString())
                .replace('<totalProviders>', this.getUniqueProvidersCount(selectedProviders).toString());
        }
    }
    getUniqueProvidersCount(providers) {
        return ProviderUtilityService.getUniqueProvidersCount(providers);
    }
    getUniqueProviderDetailsCount(providers) {
        return ProviderUtilityService.getUniqueProviderDetailsCount(providers);
    }
    getIsProviderInNetworkOnOtherLocation(id, selectedProviders, providerDetails, showProviderSearch, canSellPlan) {
        if (!this.isProviderEnabled || !showProviderSearch || !canSellPlan || !selectedProviders?.length || !providerDetails) {
            return false;
        }
        const providersBasedOnPlan = this.getProviderDetailInfo(id, providerDetails);
        if (providersBasedOnPlan?.length) {
            return providersBasedOnPlan.some(provider => {
                if (!provider.inNetwork) {
                    const providerAddresses = this.providerService.getProviderAddresses(providersBasedOnPlan, provider.npi);
                    return providerAddresses?.some(address => address.inNetwork && address.addressLine1 !== provider.addressLine1);
                }
                return false;
            });
        }
        return false;
    }
    getProviderPcpText(id, selectedProviders, providerDetails, pcpInNetworkText, pcpOutOfNetworkText, showProviderSearch, canSellPlan) {
        if (!this.isProviderEnabled || !selectedProviders?.length || !providerDetails || !canSellPlan || !showProviderSearch) {
            return '';
        }
        const primaryProvider = selectedProviders.find(selectedProvider => selectedProvider.isPrimary);
        if (!primaryProvider) {
            return '';
        }
        const providerDetailsInfo = this.getProviderDetailInfo(id, providerDetails);
        if (!providerDetailsInfo) {
            return '';
        }
        const isPcpInNetwork = ProviderUtilityService.matchProviderDetailInfo({
            providerDetails: providerDetailsInfo,
            selectedProvider: primaryProvider,
            checkIfInNetwork: true
        });
        return isPcpInNetwork ? pcpInNetworkText : pcpOutOfNetworkText;
    }
    getAltImgText(plan) {
        if (plan.planTypeAbbreviation === PlanTypeAbbreviation.DENTAL ||
            plan.planTypeAbbreviation === PlanTypeAbbreviation.VISION ||
            plan.planTypeAbbreviation === PlanTypeAbbreviation.HC) {
            return plan.organizationName;
        }
        return plan.logo2Description;
    }
    calculateMaxSectionHeight(elements, calculatedHeight, padding = 0) {
        if (elements?.length) {
            if (calculatedHeight !== 0) {
                this.setCalculatedHeight(elements, calculatedHeight + padding);
                return calculatedHeight;
            }
            const customHeight = Math.max.apply(Math, elements.map(element => element.nativeElement.offsetHeight));
            this.setCalculatedHeight(elements, customHeight);
            return customHeight;
        }
    }
    setCalculatedHeight(elements, calculatedHeight) {
        elements.forEach(element => {
            this.renderer.setStyle(element.nativeElement, 'height', `${calculatedHeight}px`);
        });
    }
    setPrefHeight(elements, className) {
        const maxPrefHeight = this.getMaxHeightOfChildComponents(elements, className);
        this.setCalculatedHeight(elements, maxPrefHeight);
    }
    getProviderDetailInfo(planId, planProviderDetails) {
        return this.providerService.getProviderDetailInfo(planId, planProviderDetails);
    }
    getMaxHeightOfChildComponents(elements, className) {
        let maxHeight = 0;
        elements.forEach(element => {
            const prefHeight = element.nativeElement.getElementsByClassName(className)[0]?.offsetHeight || 0;
            if (prefHeight > maxHeight) {
                maxHeight = prefHeight;
            }
        });
        return maxHeight;
    }
    setAnalyticsForPlansSaveOnDrugs(plan) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLANS_SAVE_ON_DRUGS,
            [DataLayerGlobalVariable.PLAN_ID]: plan.id,
            [DataLayerGlobalVariable.PLAN_TYPE]: plan.planTypeAbbreviation,
            [DataLayerGlobalVariable.PLAN_CARRIER]: plan.carrierName,
            [DataLayerGlobalVariable.PLAN_PROVIDER_VBC_STATUS]: this.planFacade.isVbcAgreementExists(plan)
                ? GOOGLE_ANALYTICS_YES
                : GOOGLE_ANALYTICS_NO
        };
    }
    setProviderModalResources(providerModal) {
        providerModal.componentInstance.title = this.configResourceService.getProcessedResourceValue('Spa_Site_Providers_Info_Text', null, 'Provider Information');
        providerModal.componentInstance.selectedLocationText = this.configResourceService.getProcessedResourceValue('Spa_Site_Providers_Selected_Location_Text', null, 'Selected location');
        providerModal.componentInstance.prompt = this.configResourceService.getProcessedResourceValue('Spa_Site_Providers_Intro_Text', null, 'View your selected provider location network status and other in network locations for each of your providers for this plan.');
        providerModal.componentInstance.acceptingNewPatientsText = this.configResourceService.getProcessedResourceValue('Spa_Providers_AcceptingNewPatients_Text', null, 'Accepting new patients');
        providerModal.componentInstance.acceptingNewPatientsIcon = this.configResourceService.getProcessedResourceValue('Spa_Providers_AcceptingNewPatients_Icon', null, 'fas fa-user-plus');
        providerModal.componentInstance.languagesIcon = this.configResourceService.getProcessedResourceValue('Spa_Providers_Languages_Icon', null, 'fas fa-globe');
        providerModal.componentInstance.selectedLocationIsOutOfNetworkText = this.configResourceService.getProcessedResourceValue('Spa_Providers_Selected_LocationOutOfNetwork_Text', null, 'Selected location is out-of-network.');
        providerModal.componentInstance.providerShowPartialIndicatorEnabled = this.configResourceService.getProcessedResourceValue('Spa_Provider_ShowPartialIndicator_Enabled', null, false);
        providerModal.componentInstance.providersAddEditLinkTitle = this.configResourceService.getProcessedResourceValue('Spa_Providers_Add_Edit_Link', null, false);
        providerModal.componentInstance.guidedHelpGetStartedText = this.configResourceService.getProcessedResourceValue('Spa_Site_GetStarted_Text', null, false);
        providerModal.componentInstance.isVbcAgreementEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_ValueBasedCare_Agreement_Enabled', null, false);
        providerModal.componentInstance.vbcAgreementLabel = this.configResourceService.getProcessedResourceValue('Spa_Site_ValueBasedCare_Agreement_Label', null, 'Value Based Care agreement');
        providerModal.componentInstance.vbcAgreementTooltip = this.configResourceService.getProcessedResourceValue('Spa_Site_ValueBasedCare_Agreement_Tooltip', null, 'A Value Based Care agreement exists between your primary care provider and this carrier. See plan details for more information.');
        providerModal.componentInstance.closeButtonText = this.configResourceService.getProcessedResourceValue('Spa_Site_Close', null, 'Close');
    }
    getFormattedNoteMessage(noteMessage) {
        return `<div class="Spa_Style_Note">${noteMessage}</div>`;
    }
}
PlanCardFacade.ɵfac = function PlanCardFacade_Factory(t) { return new (t || PlanCardFacade)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.DemographicService), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.PharmacyService), i0.ɵɵinject(i1.ProviderService), i0.ɵɵinject(ProviderFacade), i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(i0.RendererFactory2), i0.ɵɵinject(i1.LocaleService), i0.ɵɵinject(PlanFacade), i0.ɵɵinject(i1.SpinnerService), i0.ɵɵinject(i1.NavigationService), i0.ɵɵinject(AnalyticsService), i0.ɵɵinject(i1.GuidedHelpModalContextService)); };
PlanCardFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlanCardFacade, factory: PlanCardFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCardFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i2.Store }, { type: i1.DemographicService }, { type: i1.ConfigResourceService }, { type: i1.PharmacyService }, { type: i1.ProviderService }, { type: ProviderFacade }, { type: i1$1.NgbModal }, { type: i0.RendererFactory2 }, { type: i1.LocaleService }, { type: PlanFacade }, { type: i1.SpinnerService }, { type: i1.NavigationService }, { type: AnalyticsService }, { type: i1.GuidedHelpModalContextService }]; }, null); })();

class PlanDetailsFacade {
    constructor(responsiveLayoutService, configResourceService, medSupService, riderFacade, planFacade, memberSessionService, store, analyticsService, navigationService, planCardFacade, pharmacyFacade, helpfulToolsService, plansService, siteService, planListFacade, localeService, pharmacyService, drugsService, providerFacade) {
        this.responsiveLayoutService = responsiveLayoutService;
        this.configResourceService = configResourceService;
        this.medSupService = medSupService;
        this.riderFacade = riderFacade;
        this.planFacade = planFacade;
        this.memberSessionService = memberSessionService;
        this.store = store;
        this.analyticsService = analyticsService;
        this.navigationService = navigationService;
        this.planCardFacade = planCardFacade;
        this.pharmacyFacade = pharmacyFacade;
        this.helpfulToolsService = helpfulToolsService;
        this.plansService = plansService;
        this.siteService = siteService;
        this.planListFacade = planListFacade;
        this.localeService = localeService;
        this.pharmacyService = pharmacyService;
        this.drugsService = drugsService;
        this.providerFacade = providerFacade;
        this.monthYearDateFormat = 'MMMM YYYY';
        this.riderIcons = {
            Dental: 'fas fa-tooth',
            Hearing: 'fas fa-ear',
            Vision: 'fas fa-glasses',
            combo: 'fas fa-plus'
        };
        this.googleTagManagerNotApplicableText = this.configResourceService
            .getProcessedResourceValue('Spa_Site_NotApplicable_Text', null, 'n/a')
            .toLowerCase();
    }
    get mobile$() {
        return this.responsiveLayoutService.isCompact$;
    }
    getMonthYearDateFormat() {
        return this.monthYearDateFormat;
    }
    getCostLabel(widgetName) {
        return this.planFacade.getCostLabel(widgetName);
    }
    getRiderCategories(detailedPlan) {
        // This is setting up groups of rider types and removing any potential duplicates.
        // new Set removes duplicate values
        // the map get the supType name
        // get rider label transforms the string for presentations
        let planTypes;
        if (!this.isHCPlan(detailedPlan)) {
            planTypes = new Set(detailedPlan.riders?.map(rider => rider.planSubType));
        }
        else {
            const [hospitalIndemnityBasePlanRider] = this.planFacade.getHospitalIndemnityBasePlan(detailedPlan);
            planTypes = new Set(detailedPlan.riders?.reduce((riderCategories, rider) => {
                // Exclude the base plan rider category to avoid displaying that row
                if (hospitalIndemnityBasePlanRider?.planTypeDescription !== rider.planTypeDescription) {
                    riderCategories.push(rider.planTypeDescription);
                }
                return riderCategories;
            }, []));
        }
        const categories = [...planTypes];
        return this.sortRiderCategories(categories);
    }
    getSelectedRiderBenefitCategories(plan) {
        return this.planFacade.getSelectedRiderBenefitCategories(plan);
    }
    getSelectedHospitalIndemnityBasePlanOptionRiderId(plan) {
        return this.planFacade.getSelectedHospitalIndemnityBasePlanOptionRiderId(plan);
    }
    isMedSupPlan(plan) {
        return plan.planTypeAbbreviation === PlanTypeAbbreviation.MEDIGAP;
    }
    isDentalPlan(plan) {
        return this.planFacade.isDentalPlan(plan);
    }
    isVisionPlan(plan) {
        return this.planFacade.isVisionPlan(plan);
    }
    isHCPlan(plan) {
        return this.planFacade.isHCPlan(plan);
    }
    getLowIncomeSubsidyLabel(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanDetails_LowIncomeSubsidy_Label', widgetName, 'Low income subsidy');
    }
    getLowIncomeSubsidyText(genericPrice, brandPrice, widgetName) {
        return this.configResourceService
            .getProcessedResourceValue('Spa_PlanDetails_LowIncomeSubsidy_Text', widgetName, 'Generic: <genericPrice>, Brand: <brandPrice>')
            .replace('<genericPrice>', genericPrice ?? '')
            .replace('<brandPrice>', brandPrice ?? '');
    }
    getLowIncomeSubsidyInformationalText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanDetails_LowIncomeSubsidyInformational_Text', widgetName, 'If you are eligible for the subsidy you selected, you will pay the lowest cost,' +
            ' which may be the plan benefit listed below if lower.' +
            ' View the Prescriptions tab above for an estimate of the cost you will pay for the subsidy selected.');
    }
    getRiderIcon(riderSubType) {
        if (this.riderFacade.isCombinedRider(riderSubType)) {
            return this.riderIcons.combo;
        }
        if (this.riderFacade.isDentalRider(riderSubType)) {
            return this.riderIcons.Dental;
        }
        return this.riderIcons[riderSubType];
    }
    getRiderLabel(riderSubType) {
        const resourceLabel = this.riderFacade.getRiderCategoryHeaderResources(riderSubType).header;
        return resourceLabel || this.riderFacade.sanitizeRiderSubType(riderSubType);
    }
    getRidersByCategory(riderCategory, plan) {
        return plan.riders.filter(rider => this.getRiderLabel(rider.planSubType) === riderCategory).map(rider => rider.planName);
    }
    getRidersWithMatchingCategory(category, plan, riderKey = 'planSubType') {
        return plan.riders.filter(rider => rider[riderKey] === category).sort((riderA, riderB) => (riderA.planName > riderB.planName ? 1 : -1));
    }
    hasPremium$(plan) {
        return this.medSupService.hasPremium$(plan);
    }
    getTotalPremium(plans, riders) {
        return this.planFacade.getTotalPremium(plans, riders);
    }
    getRiderMedicalPremium(rider) {
        return this.riderFacade.getRiderMedicalPremium(rider);
    }
    isMedicareRiderSubType(riderSubType) {
        return Object.values(RiderSubTypes).includes(riderSubType);
    }
    isWaiverStateRider(riderSubType, plan) {
        const currentRider = plan.riders.find(rider => rider.planSubType === riderSubType);
        return currentRider.isWaiverStateRider;
    }
    getCostValue$(plan, label, isMailOrderSelected = false) {
        if (!plan) {
            return of(0);
        }
        if (label === PlanDetailsCostLabels.PREMIUM) {
            return of(this.planFacade.getTotalPremium([plan]));
        }
        return this.planCardFacade.getAnnualCost$(plan, isMailOrderSelected).pipe(map(annualCost => {
            if (annualCost) {
                return this.getPlanDetailsValueFromAnnualCost(annualCost, label);
            }
            return 0;
        }));
    }
    getPlanDetailsValueFromAnnualCost(annualCost, label) {
        let planDetailsValue = 0;
        if (label === PlanDetailsCostLabels.DRUG_COST && annualCost.totalAnnualDrugCostShare) {
            planDetailsValue = annualCost.totalAnnualDrugCostShare;
        }
        else if (label === PlanDetailsCostLabels.HEALTH_COST && annualCost.totalAnnualMedicalCostShare) {
            planDetailsValue = annualCost.totalAnnualMedicalCostShare;
        }
        else if (label === PlanDetailsCostLabels.TOTAL_ESTIMATED_COST && annualCost.totalEstimatedCost) {
            planDetailsValue = annualCost.totalEstimatedCost;
        }
        return planDetailsValue;
    }
    getWaiverTooltip(riderSubType, waiverStateRiderTooltips) {
        if (!this.isMedicareRiderSubType(riderSubType) && waiverStateRiderTooltips.some(tooltip => tooltip.id === riderSubType)) {
            return waiverStateRiderTooltips.find(tooltip => tooltip.id === riderSubType).body;
        }
        return '';
    }
    showRiders(plan, riderCategory) {
        const showPremiumAsAnnual = this.configResourceService.getProcessedResourceValue('Spa_Site_ShowPremiumAsAnnual', null, false);
        const isShoppingCartEnabled = this.configResourceService.getProcessedResourceValue('Spa_ShoppingCart_Enabled', null, true);
        let isMatchingRiderCategoryAvailable = true;
        if (riderCategory) {
            const riders = this.getRidersWithMatchingCategory(riderCategory, plan);
            isMatchingRiderCategoryAvailable = riders && riders.length > 0;
        }
        return (!showPremiumAsAnnual &&
            isShoppingCartEnabled &&
            plan?.riders &&
            plan.riders.length > 0 &&
            !plan.isCurrentYearPlan &&
            (!plan.isNextYearPlan || plan.isPlanRolloverTerminated) &&
            isMatchingRiderCategoryAvailable);
    }
    tagsToUpdate(plan, noCostMedSupPlanText, isRetentionView, selectedTab, annualCost, planTotalPremium) {
        let totalEstimatedCost;
        if (ANCILLARY_PLANS.includes(plan.planTypeAbbreviation)) {
            totalEstimatedCost = plan.annualCalculatedPlanPremium?.toString() ?? noCostMedSupPlanText;
        }
        else if (plan.planTypeAbbreviation === PlanTypeAbbreviation.HC && planTotalPremium !== null && planTotalPremium !== undefined) {
            totalEstimatedCost = this.planTotalPremiumAnnualCost(planTotalPremium).toFixed(2);
        }
        else {
            totalEstimatedCost = annualCost?.totalEstimatedCost ? annualCost.totalEstimatedCost.toString() : noCostMedSupPlanText;
        }
        if (isRetentionView) {
            return this.getRetentionTags(plan, totalEstimatedCost, selectedTab);
        }
        return this.getPlanDetailsTag(plan, totalEstimatedCost, selectedTab);
    }
    navigateByPageTag(pageTag) {
        if (pageTag === PageTags.GUIDED_HELP_PHARMACY_SEARCH) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_PHARMACY);
        }
        this.navigationService.navigateByPageTag(pageTag);
    }
    getAnnualCost$(plan, isMailOrderSelected = false) {
        return this.planCardFacade.getAnnualCost$(plan, isMailOrderSelected);
    }
    getPharmacyDetailsBasedOnPlan(plan, selectedPharmacy) {
        if (plan) {
            const pharmacies = this.pharmacyService.getAPIPharmacyInfoForPlan(plan.id);
            if (pharmacies?.length && selectedPharmacy) {
                return pharmacies.find(pharmacyCoverageMultiPharmacy => pharmacyCoverageMultiPharmacy && pharmacyCoverageMultiPharmacy.nabp === selectedPharmacy.nabp);
            }
        }
        return {};
    }
    getPharmacyNetworkText(plan, selectedPharmacy, widgetName) {
        let pharmacyNetwork = '';
        const networkLabelText = this.configResourceService.getProcessedResourceValue('Spa_Site_Selected_Pharmacy_Network_Label', widgetName, '<selectedPharmacy> is a <networkType> pharmacy');
        const preferredLabelText = this.configResourceService.getProcessedResourceValue('Spa_Site_Preferred_Text', widgetName, 'preferred');
        const standardLabelText = this.configResourceService.getProcessedResourceValue('Spa_Site_Standard_Text', widgetName, 'standard');
        const pharmacy = this.getPharmacyDetailsBasedOnPlan(plan, selectedPharmacy);
        if (pharmacy && pharmacy.isInNetwork) {
            pharmacyNetwork = pharmacy.isPreferred ? preferredLabelText : standardLabelText;
        }
        return pharmacy && pharmacyNetwork
            ? networkLabelText.replace('<selectedPharmacy>', pharmacy.name).replace('<networkType>', pharmacyNetwork)
            : '';
    }
    getExtendedPlanDetails(plan, selectedPharmacy, isMailOrderSelected) {
        const planExtendedDetails = plan ? plan.extendedPlanDetails : null;
        if (!planExtendedDetails ||
            plan.planTypeAbbreviation === PlanTypeAbbreviation.MEDIGAP ||
            plan.planTypeAbbreviation === PlanTypeAbbreviation.MA) {
            return planExtendedDetails;
        }
        if (isMailOrderSelected) {
            return this.getUpdatedExtendedPlanDetails(planExtendedDetails, true);
        }
        const pharmacy = this.getPharmacyDetailsBasedOnPlan(plan, selectedPharmacy);
        if (pharmacy && pharmacy.isInNetwork && planExtendedDetails) {
            return this.getUpdatedExtendedPlanDetails(planExtendedDetails, false, pharmacy);
        }
        return planExtendedDetails;
    }
    getUpdatedExtendedPlanDetails(planExtendedDetails, isMailOrder, pharmacy) {
        let isPreferredMailOrderExist = false;
        let extendedMailOrderPlanDetails;
        if (isMailOrder) {
            extendedMailOrderPlanDetails = this.getExtendedMailOrderDetails(planExtendedDetails);
            if (!extendedMailOrderPlanDetails?.length) {
                return planExtendedDetails;
            }
            isPreferredMailOrderExist = this.isPreferredMailOrderExist(extendedMailOrderPlanDetails);
        }
        return planExtendedDetails.reduce((updatedPlanExtendedDetails, planExtendedDetail) => {
            let planDetail = { ...planExtendedDetail };
            if (planExtendedDetail.headerType === SectionHeaderType.TWO && planExtendedDetail.name) {
                if (isMailOrder) {
                    planDetail = this.getMailOrderPlanDetails(planExtendedDetail, extendedMailOrderPlanDetails, isPreferredMailOrderExist);
                }
                else {
                    planDetail = this.getRetailPlanDetails(planExtendedDetail, pharmacy);
                }
            }
            updatedPlanExtendedDetails.push(planDetail);
            return updatedPlanExtendedDetails;
        }, []);
    }
    async convertAndUpdateValueFromDropdown(value, setActiveTabToTotalCost = true, reload = true) {
        const date = DateUtilities.monthYearToDate(value, this.localeService.getCurrentLocale());
        const effectiveDate = DateUtilities.getFormattedDateTime(date);
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLAN_CHANGE_COST_EFF_DATE,
            [DataLayerGlobalVariable.PLANS_COST_EFF_DATE_SELECTION]: value
        };
        await this.updateEffectiveDate(effectiveDate, setActiveTabToTotalCost, reload);
        this.setIsSelectedEffectiveDate(true);
        return date;
    }
    async updateEffectiveDate(effectiveDate, setActiveTabToTotalCost = true, reload = true) {
        const totalCostEffectiveDateResponse = await this.memberSessionService.updateTotalCostEffectiveDateInSession(effectiveDate);
        if (totalCostEffectiveDateResponse.status === HttpStatusCode.OK) {
            this.store.dispatch(new UpdateTotalCostEffectiveDate(effectiveDate));
            this.store.dispatch(new SetIsCostByEffectiveDate(true));
            // TODO: get the planType we are updating here?
            this.store.dispatch(new SetPlansDirty(true));
            this.store.dispatch(new SetActiveTabTotalCost(setActiveTabToTotalCost));
            if (reload) {
                // We need to reload the page in such a way as to make sure the preceding dispatches persist
                this.navigationService.reloadCurrentRoute();
            }
        }
    }
    setIsSelectedEffectiveDate(isSelectedEffectiveDate) {
        this.plansService.setIsSelectedEffectiveDate(isSelectedEffectiveDate);
    }
    getTotalCostEffectiveDate$() {
        return this.store.select(MemberState.totalCostEffectiveDate);
    }
    getSelectedProviderDetails(planId, planProviderDetails, selectedProvider) {
        return this.planFacade.getSelectedProviderDetails(planId, planProviderDetails, selectedProvider);
    }
    showPharmacySelectorToggle(plan) {
        return this.pharmacyFacade.isPlanPharmacyCovered(plan) && this.pharmacyFacade.showPharmacySelectorToggle(plan.planTypeAbbreviation);
    }
    resetHelpfulToolsPlan() {
        this.helpfulToolsService.resetPlan();
    }
    getClickPlansRiderDetailsTags(rider) {
        return {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLANS_VIEW_RIDER_DETAILS,
            [DataLayerGlobalVariable.RIDER_PLANID]: rider?.planID ?? this.googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.RIDER_NAME]: rider?.planName ?? this.googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.RIDER_PLANTYPE]: rider?.planType.toString() ?? this.googleTagManagerNotApplicableText
        };
    }
    getListOfEffectiveDateMonths() {
        const defaultEffectiveDateOption = this.planFacade.getDefaultEffectiveDateOption();
        const listOfMonthsOptions = {
            // list of months should be all the months for the rest of the year, after the current month
            [DefaultEffectiveDateOption.NEXT_MONTH]: () => DateUtilities.getFutureMonthsForRestOfYear(),
            // list of months should be all 12 months of the current year
            [DefaultEffectiveDateOption.FIRST_MONTH_OF_CURRENT_PLAN_YEAR]: () => DateUtilities.getMonthsOfYear(),
            // list of months should be all 12 months of the following year
            [DefaultEffectiveDateOption.FIRST_MONTH_OF_NEXT_PLAN_YEAR]: () => DateUtilities.getMonthsOfYear(1)
        };
        const listOfMonths = listOfMonthsOptions[defaultEffectiveDateOption]?.() ?? [];
        return listOfMonths;
    }
    getDefaultEffectiveDateLabel(currentMonth, defaultEffectiveDateOption, firstMonth) {
        let defaultEffectiveDateLabel = null;
        if (!DateUtilities.isAEP(currentMonth) && defaultEffectiveDateOption === DefaultEffectiveDateOption.FIRST_MONTH_OF_NEXT_PLAN_YEAR) {
            defaultEffectiveDateLabel = this.formatDateAsMonthYear(firstMonth);
        }
        return defaultEffectiveDateLabel;
    }
    formatDateAsMonthYear(date) {
        return DateUtilities.getFormattedDate(date, this.getMonthYearDateFormat(), this.localeService.getCurrentLocale());
    }
    getTotalPremiumBySelectedRiders(plan) {
        const selectedRiders = this.getSelectedRiders(plan);
        return selectedRiders.length ? this.getTotalPremium([plan], selectedRiders) : plan.calculatedBasePlanPremium;
    }
    getSelectedRiderBasePlanExtraction(plan) {
        const selectedRiders = this.getSelectedRiders(plan);
        const benefitAmount = selectedRiders?.[0]?.extendedPlanDetails?.[0]?.sectionDetails?.find((sectionDetail) => sectionDetail.name === BenefitType.BENEFIT_AMOUNT);
        return benefitAmount;
    }
    getPlanExtraction(plan) {
        const hospitalIndemnityBasePlanRiders = this.planFacade.getHospitalIndemnityBasePlanRiders(plan);
        const basePlanExtraction = this.planFacade.getHospitalIndemnityBasePlanSectionDetails(hospitalIndemnityBasePlanRiders);
        const selectedRiderBasePlanExtraction = this.getSelectedRiderBasePlanExtraction(plan);
        const planExtraction = selectedRiderBasePlanExtraction ?? basePlanExtraction;
        return planExtraction;
    }
    updatePayloadWithDetailedPlan(detailedPlan) {
        this.store.dispatch(new SelectPlanDetails(detailedPlan));
    }
    getViewDrugAlternativesTag(plan, cabinetEntry, isMailOrderSelected = this.pharmacyService.getIsMailOrderSelected(), includePlanData = false) {
        const googleTagManagerNotApplicableText = this.analyticsService.getGoogleTagManagerNotApplicableText();
        const drugName = this.drugsService.getDrugNameForAnalytics(cabinetEntry, isMailOrderSelected);
        const drugType = this.drugsService.getDrugTypeForAnalytics(cabinetEntry);
        const { dosageId } = cabinetEntry.dosage;
        const drugMedicalConditionId = this.drugsService.getMedicineCabinetConditionId(dosageId);
        const drugCoverage = isMailOrderSelected ? plan.planMailOrderDrugCoverage : plan.planRetailDrugCoverageMultiPharmacy;
        const drugMedicalCondition = this.drugsService
            .getMedicalCondition(drugCoverage, dosageId, drugMedicalConditionId)
            ?.conditionID?.toString();
        let tagsToUpdate = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLANS_DRUG_ALTERNATIVES_VIEW,
            [DataLayerGlobalVariable.DRUG_NAME]: drugName,
            [DataLayerGlobalVariable.DRUG_IS_BRANDED_OR_GENERIC]: drugType,
            [DataLayerGlobalVariable.DRUG_CONDITION]: drugMedicalCondition ?? googleTagManagerNotApplicableText
        };
        if (includePlanData) {
            tagsToUpdate = {
                ...tagsToUpdate,
                [DataLayerGlobalVariable.PLAN_ID]: plan.id,
                [DataLayerGlobalVariable.PLAN_TYPE]: plan.planTypeAbbreviation,
                [DataLayerGlobalVariable.PLAN_CARRIER]: plan.carrierName,
                [DataLayerGlobalVariable.PLAN_PROVIDER_VBC_STATUS]: this.planFacade.isVbcAgreementExists(plan)
                    ? GOOGLE_ANALYTICS_YES
                    : GOOGLE_ANALYTICS_NO
            };
        }
        return tagsToUpdate;
    }
    getSelectedRiders(plan) {
        const detailPlanRidersMap = plan?.riders.reduce((ridersMap, rider) => {
            ridersMap[rider.planID] = rider;
            return ridersMap;
        }, {}) ?? {};
        const selectedRiders = this.getSelectedRiderBenefitCategories(plan).reduce((selectedPlanRiders, { selectedRiderId }) => {
            const selectedRider = detailPlanRidersMap[selectedRiderId];
            if (selectedRider) {
                selectedPlanRiders.push(selectedRider);
            }
            return selectedPlanRiders;
        }, []);
        return selectedRiders;
    }
    sortRiderCategories(categories) {
        // group by logic.
        const sortedSingleCategories = categories.filter(riderType => !this.riderFacade.isCombinedRider(riderType)).sort();
        const sortedCombinedCategories = categories.filter(riderType => this.riderFacade.isCombinedRider(riderType)).sort();
        return [...sortedSingleCategories, ...sortedCombinedCategories];
    }
    getRetailPlanDetails(planExtendedDetail, pharmacy) {
        if (!pharmacy || !this.isRetailPharmacy(planExtendedDetail)) {
            return planExtendedDetail;
        }
        if (pharmacy.isPreferred && this.isPreferredDetailExist(planExtendedDetail)) {
            return { ...planExtendedDetail, isPreferred: true };
        }
        // Also handle the case if we dont get a standard keyword from the plan details but it satisfies the retail pharmacy criteria.
        if (!pharmacy.isPreferred &&
            pharmacy.isInNetwork &&
            (this.isStandardDetailExist(planExtendedDetail) || !this.isPreferredDetailExist(planExtendedDetail))) {
            return { ...planExtendedDetail, isInNetwork: true };
        }
        return planExtendedDetail;
    }
    getMailOrderPlanDetails(planExtendedDetail, extendedMailOrderPlanDetails, isPreferredMailOrderExist) {
        if (!this.isMailOrderDetail(planExtendedDetail)) {
            return planExtendedDetail;
        }
        if (extendedMailOrderPlanDetails.length === 1) {
            return { ...planExtendedDetail, isMailOrder: true };
        }
        if (isPreferredMailOrderExist && this.isPreferredDetailExist(planExtendedDetail)) {
            return { ...planExtendedDetail, isMailOrder: true };
        }
        if (!isPreferredMailOrderExist) {
            return { ...planExtendedDetail, isMailOrder: true };
        }
        return planExtendedDetail;
    }
    getExtendedMailOrderDetails(planExtendedDetails) {
        return planExtendedDetails.filter(planExtendedDetail => this.isMailOrderDetail(planExtendedDetail));
    }
    isPreferredMailOrderExist(mailOrderPlanDetails) {
        return mailOrderPlanDetails.some(extendedMailOrderPlanDetail => this.isPreferredDetailExist(extendedMailOrderPlanDetail));
    }
    isMailOrderDetail(planExtendedDetail) {
        return (planExtendedDetail.name &&
            (planExtendedDetail.name.toLowerCase().includes(PlanPharmacyNetworkKeywords.MAILORDER.toLowerCase()) ||
                planExtendedDetail.name.toLowerCase().includes(PlanPharmacyNetworkKeywords.MAIL_ORDER.toLowerCase()) ||
                planExtendedDetail.name.toLowerCase().includes(PlanPharmacyNetworkKeywords.MAILORDER_SPANISH.toLowerCase()) ||
                planExtendedDetail.name.toLowerCase().includes(PlanPharmacyNetworkKeywords.NINETY.toLowerCase()) ||
                planExtendedDetail.name.toLowerCase().includes(PlanPharmacyNetworkKeywords.NUMERIC_NINETY.toLowerCase()) ||
                planExtendedDetail.name.toLowerCase().includes(PlanPharmacyNetworkKeywords.THREE_MONTH.toLowerCase()) ||
                planExtendedDetail.name.toLowerCase().includes(PlanPharmacyNetworkKeywords.NUMERIC_THREE_MONTH.toLowerCase())));
    }
    isRetailPharmacy(planExtendedDetail) {
        return (planExtendedDetail.name &&
            (planExtendedDetail.name.toLowerCase().includes(PlanPharmacyNetworkKeywords.RETAIL.toLowerCase()) ||
                planExtendedDetail.name.toLowerCase().includes(PlanPharmacyNetworkKeywords.RETAIL_SPANISH.toLowerCase()) ||
                planExtendedDetail.name.toLowerCase().includes(PlanPharmacyNetworkKeywords.THIRTY.toLowerCase()) ||
                planExtendedDetail.name.toLowerCase().includes(PlanPharmacyNetworkKeywords.NUMERIC_THIRTY.toLowerCase()) ||
                planExtendedDetail.name.toLowerCase().includes(PlanPharmacyNetworkKeywords.ONE_MONTH.toLowerCase()) ||
                planExtendedDetail.name.toLowerCase().includes(PlanPharmacyNetworkKeywords.NUMERIC_ONE_MONTH.toLowerCase())));
    }
    isPreferredDetailExist(extendedPlanDetail) {
        return (extendedPlanDetail.name &&
            (extendedPlanDetail.name.toLowerCase().includes(PlanPharmacyNetworkKeywords.PREFERRED.toLowerCase()) ||
                extendedPlanDetail.name.toLowerCase().includes(PlanPharmacyNetworkKeywords.PREFERRED_SPANISH.toLowerCase())));
    }
    isStandardDetailExist(extendedPlanDetail) {
        return (extendedPlanDetail.name &&
            (extendedPlanDetail.name.toLowerCase().includes(PlanPharmacyNetworkKeywords.STANDARD.toLowerCase()) ||
                extendedPlanDetail.name.toLowerCase().includes(PlanPharmacyNetworkKeywords.STANDARD_SPANISH.toLowerCase())));
    }
    getPlanDetailsTag(plan, totalEstimatedCost, selectedTab) {
        const sellablePlan = this.plansService.canSellPlan(plan);
        const googleTagManagerNotApplicableText = this.analyticsService.getGoogleTagManagerNotApplicableText();
        const planType = ANCILLARY_PLANS.includes(plan?.planTypeAbbreviation) ? plan?.planSubType : plan?.planTypeAbbreviation;
        let tagsToUpdate;
        if (this.siteService.isPPCSite()) {
            tagsToUpdate = {
                [DataLayerGlobalVariable.PLAN_NON_LICENSED]: sellablePlan ? GOOGLE_ANALYTICS_NO : GOOGLE_ANALYTICS_YES
            };
        }
        if (this.planCardFacade.isProviderInfoEnabled()) {
            const providerStatus = this.providerFacade.getProviderLocationStatus([plan.id]);
            tagsToUpdate = {
                [DataLayerGlobalVariable.PROVIDER_LOCATIONS_STATUS]: providerStatus
            };
        }
        tagsToUpdate = {
            ...tagsToUpdate,
            [DataLayerGlobalVariable.PLAN_ID]: plan?.id ?? googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.PLAN_TOTAL_ANNUAL_COST]: totalEstimatedCost,
            [DataLayerGlobalVariable.PAGE_TAB_NAME]: selectedTab,
            [DataLayerGlobalVariable.PLAN_CARRIER]: plan?.carrierName ?? googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.PLAN_TYPE]: planType ?? googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.PLAN_ID_BEST_MATCH]: this.planListFacade.getBestMatchPlanIdValueForAnalytics(),
            [DataLayerGlobalVariable.PLAN_TYPE_BEST_MATCH]: this.planListFacade.getBestCoverageTabAbbreviationValueForAnalytics(),
            [DataLayerGlobalVariable.SELECTED_PHARMACY]: this.pharmacyFacade.getSelectedNABPPharmacies(),
            [DataLayerGlobalVariable.PLAN_PROVIDER_VBC_STATUS]: this.planFacade.isVbcAgreementExists(plan)
                ? GOOGLE_ANALYTICS_YES
                : GOOGLE_ANALYTICS_NO
        };
        return tagsToUpdate;
    }
    getRetentionTags(plan, totalEstimatedCost, selectedTab) {
        const googleTagManagerNotApplicableText = this.analyticsService.getGoogleTagManagerNotApplicableText();
        const planType = ANCILLARY_PLANS.includes(plan?.planTypeAbbreviation) ? plan?.planSubType : plan?.planTypeAbbreviation;
        let planStatus = PlanStatus.NEW_PLAN;
        if (plan?.isCurrentYearPlan) {
            planStatus = PlanStatus.CURRENT_PLAN;
        }
        else if (plan?.isNextYearPlan) {
            planStatus = PlanStatus.NEXT_YEAR_PLAN;
        }
        return {
            [DataLayerGlobalVariable.PLAN_ID]: plan?.id ?? googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.PLAN_TOTAL_ANNUAL_COST]: totalEstimatedCost,
            [DataLayerGlobalVariable.PLAN_STATUS]: planStatus,
            [DataLayerGlobalVariable.PAGE_TAB_NAME]: selectedTab,
            [DataLayerGlobalVariable.PLAN_CARRIER]: plan?.carrierName ?? googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.PLAN_TYPE]: planType ?? googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.PLAN_ID_BEST_MATCH]: this.planListFacade.getBestMatchPlanIdValueForAnalytics(),
            [DataLayerGlobalVariable.PLAN_TYPE_BEST_MATCH]: this.planListFacade.getBestCoverageTabAbbreviationValueForAnalytics(),
            [DataLayerGlobalVariable.SELECTED_PHARMACY]: this.pharmacyFacade.getSelectedNABPPharmacies(),
            [DataLayerGlobalVariable.PLAN_PROVIDER_VBC_STATUS]: this.planFacade.isVbcAgreementExists(plan)
                ? GOOGLE_ANALYTICS_YES
                : GOOGLE_ANALYTICS_NO
        };
    }
    planTotalPremiumAnnualCost(monthlyPlanPremium) {
        if (monthlyPlanPremium) {
            return monthlyPlanPremium * 12;
        }
        return 0;
    }
}
PlanDetailsFacade.ɵfac = function PlanDetailsFacade_Factory(t) { return new (t || PlanDetailsFacade)(i0.ɵɵinject(i1.ResponsiveLayoutService), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.MedSupService), i0.ɵɵinject(RiderFacade), i0.ɵɵinject(PlanFacade), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(AnalyticsService), i0.ɵɵinject(i1.NavigationService), i0.ɵɵinject(PlanCardFacade), i0.ɵɵinject(PharmacyFacade), i0.ɵɵinject(HelpfulToolsService), i0.ɵɵinject(i1.PlansService), i0.ɵɵinject(i1.SiteService), i0.ɵɵinject(PlanListFacadeService), i0.ɵɵinject(i1.LocaleService), i0.ɵɵinject(i1.PharmacyService), i0.ɵɵinject(i1.DrugsService), i0.ɵɵinject(ProviderFacade)); };
PlanDetailsFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlanDetailsFacade, factory: PlanDetailsFacade.ɵfac, providedIn: 'root' });
__decorate([
    LiveEditInactive()
], PlanDetailsFacade.prototype, "navigateByPageTag", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanDetailsFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.ResponsiveLayoutService }, { type: i1.ConfigResourceService }, { type: i1.MedSupService }, { type: RiderFacade }, { type: PlanFacade }, { type: i1.MemberSessionService }, { type: i2.Store }, { type: AnalyticsService }, { type: i1.NavigationService }, { type: PlanCardFacade }, { type: PharmacyFacade }, { type: HelpfulToolsService }, { type: i1.PlansService }, { type: i1.SiteService }, { type: PlanListFacadeService }, { type: i1.LocaleService }, { type: i1.PharmacyService }, { type: i1.DrugsService }, { type: ProviderFacade }]; }, { navigateByPageTag: [] }); })();

class RetentionFacade {
    constructor(store, plansService, configResourceService, navigationService, memberSessionService, planCompareService, responsiveLayoutService, demographicHttpService, sortService, planFacade, providerService, dateService, drugsService, modalService, agentService) {
        this.store = store;
        this.plansService = plansService;
        this.configResourceService = configResourceService;
        this.navigationService = navigationService;
        this.memberSessionService = memberSessionService;
        this.planCompareService = planCompareService;
        this.responsiveLayoutService = responsiveLayoutService;
        this.demographicHttpService = demographicHttpService;
        this.sortService = sortService;
        this.planFacade = planFacade;
        this.providerService = providerService;
        this.dateService = dateService;
        this.drugsService = drugsService;
        this.modalService = modalService;
        this.agentService = agentService;
        this.sortPrimaryKey = SortPrimaryKey;
        this.sort = {
            primaryKey: this.sortPrimaryKey.IS_CURRENT_YEAR_PLAN,
            dataKey: SortLabels.TOTAL_ESTIMATED_COST,
            secondaryDataKey: SortLabels.PLAN_NAME,
            dataKeyType: DataKeyType.NUMERIC,
            sortType: SortType.ASCENDING,
            displayName: 'Total Estimated Cost',
            display: true,
            sortTransformer: this.getTotalEstimatedCost.bind(this)
        };
        this.comparatorType = ComparatorType;
    }
    fetchPlans() {
        const demographicsOptions = this.plansService.createPlansDemographicsOptionsWithDefaults();
        const memberData = this.memberSessionService.getMemberSession();
        const currentYearPlanId = memberData?.currentYearPlanID ? memberData.currentYearPlanID : '';
        const searchOptions = this.plansService.updateSearchOptionsPlanType(this.plansService.createPlansSearchOptionsWithDefaults(), ALL_MEDICARE_PLUS_MEDIGAP_PLAN_TYPE_VALUE);
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        const drugs = this.drugsService.mapCabinetToDosage();
        const pharmacies = this.plansService.getSelectedAPIPharmacyInfo();
        const planTypes = PlansUtilityService.splitBitWise(searchOptions?.planType ? +searchOptions?.planType : 0);
        const hasUnloadedPlanTypes = !!this.plansService.getUnloadedPlanTypes(planTypes)?.length;
        let memberID = '';
        // Only get counts if we have unloaded plan types that aren't part of the current fetchPlans request
        searchOptions.planCount = hasUnloadedPlanTypes;
        searchOptions.getClientDefinedPlans = this.configResourceService.getProcessedResourceValue('Spa_Retention_ClientDefinedPlanOptions_Enabled', null, false);
        if (searchOptions.getClientDefinedPlans) {
            memberID = this.store.selectSnapshot(MemberState.memberID);
        }
        this.plansService.fetchPlansByOptionsAndSave({
            demographicsOptions,
            searchOptions,
            medigapAnswers: this.plansService.getMergedMedigapAnswers(),
            drugs,
            pharmacies,
            currentYearPlanId,
            agentGuid,
            memberID
        });
    }
    checkActiveTabTypeExist() {
        this.activeTabType$
            .pipe(take(1), map(tabType => !!tabType), defaultIfEmpty(false))
            .subscribe({
            next: isTabExist => {
                if (!isTabExist) {
                    this.setActiveTab();
                }
            }
        });
    }
    setActiveTab() {
        const activeTab = this.getActiveTab();
        if (activeTab && activeTab.filters.length > 0 && activeTab.filters[0].values.length) {
            this.store.dispatch(new SetDefaultTab(activeTab.filters[0].values[0]));
            this.store.dispatch(new SetActiveTab(activeTab.filters[0].values[0]));
        }
    }
    setCompareGroup() {
        this.getTabDetails().forEach(tab => {
            this.planCompareService.setCompareGroup(new CompareGroup(FilterKeyType.PLAN_TYPE_SHORT, tab.tabTypes));
        });
    }
    setSortGroup() {
        this.getTabDetails().forEach(tab => {
            let defaultSortOption = this.plansService.getDefaultSortOption(tab.sortList);
            if (!defaultSortOption) {
                defaultSortOption = this.sort;
            }
            this.sortService.setSortGroup(new SortGroup(FilterKeyType.PLAN_TYPE_SHORT, tab.tabTypes, this.comparatorType.EQUAL, new Sort(defaultSortOption.primaryKey, defaultSortOption.dataKey, defaultSortOption.secondaryDataKey, defaultSortOption.dataKeyType, defaultSortOption.sortType, defaultSortOption.displayName, defaultSortOption.display, defaultSortOption.sortTransformer, defaultSortOption.secondarySortType)));
        });
    }
    clearSortGroupSort() {
        const sortGroup = this.getActiveTab().sortGroup;
        this.sortService.clearSortGroupSort(sortGroup);
    }
    getActiveTab() {
        const tabsData = this.configResourceService.getProcessedResourceValue('Spa_PlanList_Tabs_Data');
        const tabs = tabsData.map((tabData, index) => new FilterTab(tabData, index));
        let defaultTab = tabs.find(tab => tab.defaultActive);
        if (this.enrolledPlanType) {
            defaultTab = tabs.find(tab => tab.filters[0].values[0] === this.enrolledPlanType);
        }
        if (defaultTab) {
            return defaultTab;
        }
        defaultTab = tabs.find(tab => tab.secondaryDefaultActive);
        return defaultTab;
    }
    getTabDetails() {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanList_Tabs_Data');
    }
    getPlans$(widgetName) {
        const maximumPlanCountToDisplay = 3;
        const disableNextYearPlan = this.configResourceService.getProcessedResourceValue('Spa_Site_Disable_Next_Year_Plan', widgetName, false);
        const clientDefinedOptionsEnabled = this.configResourceService.getProcessedResourceValue('Spa_Retention_ClientDefinedPlanOptions_Enabled', widgetName, false);
        return this.plans$.pipe(map(plans => {
            if (clientDefinedOptionsEnabled && plans.some(plan => plan.modifiedNextYearPlanOrdinal >= 1)) {
                return this.getPlansToDisplayWithOptions(plans);
            }
            return this.getPlansToDisplayWithoutOptions(plans, maximumPlanCountToDisplay, disableNextYearPlan);
        }));
    }
    viewPlanDetailsPage(plan) {
        this.navigationService.navigateByPageTag(PageTags.PLAN_DETAILS, {
            queryParams: { id: plan.id }
        });
    }
    updatePlansOnCompareGroupAndNavigate(plans) {
        this.setActiveTab();
        this.clearSortGroupSort();
        combineLatest([this.responsiveLayoutService.isCompact$, this.responsiveLayoutService.isMedium$])
            .pipe(map(([isMobile, isMedium]) => isMobile || isMedium), take(1))
            .subscribe({
            next: isMobileOrMediumDevice => {
                const compareGroup = this.getActiveTab().compareGroup[0];
                const planCompareDesktopLimit = this.configResourceService.getProcessedResourceValue('Spa_PlanCard_CompareLimit_Desktop', null, 3);
                const planCompareMobileLimit = this.configResourceService.getProcessedResourceValue('Spa_PlanCard_CompareLimit_Mobile', null, 2);
                let totalPlansToCompare = planCompareDesktopLimit;
                if (isMobileOrMediumDevice) {
                    totalPlansToCompare = planCompareMobileLimit;
                }
                this.planCompareService.removeAllPlansFromCompareGroup([compareGroup]);
                const plansToCompare = plans?.slice(0, totalPlansToCompare);
                if (plansToCompare?.length) {
                    const selectedPlan = plansToCompare[0];
                    if (selectedPlan) {
                        this.planCompareService.setPlanComparePlanType(selectedPlan.planTypeAbbreviation);
                    }
                    this.planCompareService.addPlansToCompareGroup([compareGroup], plansToCompare);
                }
                this.navigationService.navigateByPageTag(PageTags.PLAN_COMPARISON);
            }
        });
    }
    shopAllPlans() {
        this.enrolledPlanType = '';
        this.setActiveTab();
        // Set override flag to false so we land on the active tab set above
        this.plansService.setOverrideActiveTab(false);
        this.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
    }
    getCounty$() {
        return this.memberSessionService.getMemberSession$().pipe(
        // Guard against calling the /counties endpoint without a zip code when we clear the session and then create an anonymous session
        filter(memberData => !!memberData.demographic.zip), switchMap(memberData => this.demographicHttpService
            .retrieveCounties$(memberData.demographic.zip)
            .pipe(map(counties => counties.find(county => county.countyFIPS === memberData.demographic.fips)))));
    }
    getTotalEstimatedCost(plans) {
        if (!plans?.length) {
            return 0;
        }
        const selectedPharmacy = this.store.selectSnapshot(PharmacyState.selectedPharmacy);
        return this.planFacade.getTotalEstimatedCost(plans[0], selectedPharmacy);
    }
    getProviders$() {
        return this.providerService.getSelectedProviders$();
    }
    fetchProvidersDetails$(availablePlans, includeExtendedProviderData) {
        return this.providerService.fetchProvidersDetailsBasedOnAvailablePlans$(availablePlans, includeExtendedProviderData);
    }
    getPlansToDisplayWithOptions(plans) {
        const clientDefinedOptionPlans = plans.filter(plan => plan.isClientDefinedPlan);
        const plansToDisplay = [];
        const enrolledPlan = clientDefinedOptionPlans.find(plan => plan.modifiedNextYearPlanOrdinal === 0);
        const option1 = clientDefinedOptionPlans.find(plan => plan.modifiedNextYearPlanOrdinal === 1);
        const option2 = this.getOption2PlanFromPlansList(clientDefinedOptionPlans);
        if (enrolledPlan) {
            plansToDisplay.push(enrolledPlan);
        }
        if (option1) {
            plansToDisplay.push(option1);
        }
        if (option2) {
            plansToDisplay.push(option2);
        }
        return plansToDisplay;
    }
    getNextYearPlanFromPlansList(plans) {
        return plans.find(plan => {
            if (plan.modifiedNextYearPlanOrdinal) {
                return plan.isNextYearPlan && plan.modifiedNextYearPlanOrdinal === 1;
            }
            return plan.isNextYearPlan;
        });
    }
    getOption2PlanFromPlansList(plans) {
        return plans.find(plan => plan.modifiedNextYearPlanOrdinal === 2);
    }
    getPlansToDisplayWithoutOptions(plans, maximumPlanCountToDisplay, disableNextYearPlan) {
        const nextYearPlan = plans.find(plan => plan.isNextYearPlan);
        const enrolledPlan = plans.find(plan => plan.isCurrentYearPlan);
        this.enrolledPlanType = enrolledPlan ? enrolledPlan.planTypeAbbreviation : '';
        const activeTab = this.getActiveTab();
        return this._getSortedFilteredPlan(plans, maximumPlanCountToDisplay, disableNextYearPlan, activeTab, nextYearPlan, enrolledPlan, this.sort);
    }
    async handleRetentionMemberLogin(pageTag, injector) {
        const { zip: selectedZip, fips: memberFips } = this.memberSessionService.getMemberSession().demographic;
        if (!memberFips && selectedZip) {
            const counties = await this.demographicHttpService.retrieveCounties(selectedZip);
            if (counties && counties.length > 1) {
                const options = {
                    ariaLabelledBy: 'modalHeaderTitle',
                    centered: true,
                    injector
                };
                const zipCodeModalComponent = this.modalService.open(ZipCodeModalComponent, options);
                zipCodeModalComponent.componentInstance.isCountyModal = true;
                zipCodeModalComponent.componentInstance.redirectToSummary = true;
                // No operation here. ZipCodeModalComponent will handle the navigation.
                return await zipCodeModalComponent.result.catch(async () => {
                    this.memberSessionService.memberLogout();
                    this.memberSessionService.resetAuthType();
                    this.agentService.resetAgentState();
                    return await this.navigationService.navigateByPageTag(this.configResourceService.getProcessedResourceValue('Spa_Site_Retention_MemberLogout_RedirectPageTag', null, PageTags.RETENTION));
                });
            }
            else {
                return await this.navigationService.navigateByPageTag(pageTag);
            }
        }
        else {
            return await this.navigationService.navigateByPageTag(pageTag);
        }
    }
    _getSortedFilteredPlan(plans, maximumPlanCountToDisplay, disableNextYearPlan, activeTab, nextYearPlan, enrolledPlan, sort) {
        let activeTabType = '';
        if (activeTab && activeTab.filters.length > 0) {
            activeTabType = activeTab.filters[0].values[0];
        }
        const sortedFilteredPlan = plans.reduce((filteredPlans, plan) => {
            if (plan.planType === +PlanType[activeTabType] &&
                !plan.isCurrentYearPlan &&
                (!plan.isNextYearPlan || (plan.isNextYearPlan && plan.isPlanRolloverTerminated && disableNextYearPlan)) &&
                !plan?.snpType) {
                filteredPlans.push(plan);
            }
            const sortedPlans = SortUtilities.sort(filteredPlans, sort);
            return sortedPlans.slice(0, maximumPlanCountToDisplay);
        }, []);
        if (enrolledPlan) {
            if (nextYearPlan && (!nextYearPlan.isPlanRolloverTerminated || !disableNextYearPlan)) {
                return [enrolledPlan, nextYearPlan, ...sortedFilteredPlan].slice(0, maximumPlanCountToDisplay);
            }
            return [enrolledPlan, ...sortedFilteredPlan].slice(0, maximumPlanCountToDisplay);
        }
        return sortedFilteredPlan;
    }
}
RetentionFacade.ɵfac = function RetentionFacade_Factory(t) { return new (t || RetentionFacade)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.PlansService), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.NavigationService), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(i1.PlanCompareService), i0.ɵɵinject(i1.ResponsiveLayoutService), i0.ɵɵinject(i1.DemographicHttpService), i0.ɵɵinject(i1.SortService), i0.ɵɵinject(PlanFacade), i0.ɵɵinject(i1.ProviderService), i0.ɵɵinject(i1.DateService), i0.ɵɵinject(i1.DrugsService), i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(i1.AgentService)); };
RetentionFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RetentionFacade, factory: RetentionFacade.ɵfac, providedIn: 'root' });
__decorate([
    Select(PlansState.activeTabType)
], RetentionFacade.prototype, "activeTabType$", void 0);
__decorate([
    Select(PlansState.plans)
], RetentionFacade.prototype, "plans$", void 0);
__decorate([
    Memoize()
], RetentionFacade.prototype, "getNextYearPlanFromPlansList", null);
__decorate([
    Memoize()
], RetentionFacade.prototype, "getOption2PlanFromPlansList", null);
__decorate([
    LiveEditInactive()
], RetentionFacade.prototype, "handleRetentionMemberLogin", null);
__decorate([
    Memoize()
], RetentionFacade.prototype, "_getSortedFilteredPlan", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RetentionFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i2.Store }, { type: i1.PlansService }, { type: i1.ConfigResourceService }, { type: i1.NavigationService }, { type: i1.MemberSessionService }, { type: i1.PlanCompareService }, { type: i1.ResponsiveLayoutService }, { type: i1.DemographicHttpService }, { type: i1.SortService }, { type: PlanFacade }, { type: i1.ProviderService }, { type: i1.DateService }, { type: i1.DrugsService }, { type: i1$1.NgbModal }, { type: i1.AgentService }]; }, { activeTabType$: [], plans$: [], getNextYearPlanFromPlansList: [], getOption2PlanFromPlansList: [], handleRetentionMemberLogin: [], _getSortedFilteredPlan: [] }); })();

class PlanCompareFacade {
    constructor(store, planFacade, plansHttpService, plansService, drugsService, guidedHelpService, planListFacade, preferencesService, planDetailsFacade, configResourceService, memberSessionService, siteService, pharmacyFacade, providerService, pharmacyService, retentionFacade, riderFacade, providerFacade, planCardFacade) {
        this.store = store;
        this.planFacade = planFacade;
        this.plansHttpService = plansHttpService;
        this.plansService = plansService;
        this.drugsService = drugsService;
        this.guidedHelpService = guidedHelpService;
        this.planListFacade = planListFacade;
        this.preferencesService = preferencesService;
        this.planDetailsFacade = planDetailsFacade;
        this.configResourceService = configResourceService;
        this.memberSessionService = memberSessionService;
        this.siteService = siteService;
        this.pharmacyFacade = pharmacyFacade;
        this.providerService = providerService;
        this.pharmacyService = pharmacyService;
        this.retentionFacade = retentionFacade;
        this.riderFacade = riderFacade;
        this.providerFacade = providerFacade;
        this.planCardFacade = planCardFacade;
        this.planCompareLabels = PlanCompareLabels;
        this.planType = PlanType;
        this.educationalContent = 'EducationalContent';
        this.highlightBorder = '2px dotted #b07d0f';
        this.highlightColor = '#fff3dc';
        this.googleTagManagerNotApplicableText = this.configResourceService
            .getProcessedResourceValue('Spa_Site_NotApplicable_Text', null, 'n/a')
            .toLowerCase();
        this.highlightBorder = this.configResourceService.getProcessedResourceValue('Spa_PlanCompare_Plan_Differences_Border', null, '2px dotted #b07d0f');
        this.highlightColor = this.configResourceService.getProcessedResourceValue('Spa_PlanCompare_Plan_Differences_Color', null, '#fff3dc');
    }
    get mailOrder$() {
        return this.pharmacyFacade.mailOrder$;
    }
    getPlansLoading$(planType) {
        return this.store.select(PlansState.loading(planType));
    }
    getActiveTabType$() {
        return this.store.select(PlansState.activeTabType);
    }
    showCostsSection$() {
        return combineLatest([this.planComparePlanType$, this.planListFacade.getHasMedSupAnswers$()]).pipe(map(([planComparePlanType, hasMedSupAnswers]) => {
            if (planComparePlanType === PlanTypeAbbreviation.MEDIGAP) {
                return hasMedSupAnswers;
            }
            return true;
        }));
    }
    getPlansSelectedForCompare$() {
        return this.getPlansToCompare$(this.planComparePlanType$).pipe(this.mapCompareGroups());
    }
    getHospitalIndemnityPlansSelectedForQuote$() {
        return combineLatest([this.storeCompareGroups$, this.getActiveTabType$()]).pipe(map(([storeCompareGroups, planType]) => storeCompareGroups.find(compareGroup => compareGroup.groupKey && compareGroup.groupKey.values[0] === planType)), map(compareGroup => ({
            ...compareGroup,
            items: compareGroup?.items?.map(plan => this.planFacade.getHospitalCarePlanWithCalculatedBasePremium(plan))
        })));
    }
    getHospitalIndemnityPlansSelectedForQuote() {
        const storeCompareGroups = this.getCompareGroup();
        return this.getCompareGroupByPlanType(storeCompareGroups, PlanTypeAbbreviation.HC);
    }
    getHospitalCareQuoteComparePlans$(medicarePlanTypes) {
        return this.getPlansToCompare$(this.getActiveTabType$()).pipe(this.mapCompareGroups(true), map(plans => this.plansService.updateHIPCalculatedPremium(plans)), map(plans => this.sortHospitalCareQuoteCompare(plans, medicarePlanTypes)));
    }
    getPlansToCompare$(planType$) {
        return planType$.pipe(withLatestFrom(this.storeCompareGroups$), map(([planType, storeCompareGroups]) => storeCompareGroups.find(compareGroup => compareGroup.groupKey && compareGroup.groupKey.values[0] === planType)));
    }
    mapPlanDetailsSelection(planIds, planTypes, currentTabType, skipPlanDetailsUpdate) {
        return pipe(switchMap((response) => {
            const planUpdates = [];
            if (!skipPlanDetailsUpdate) {
                response?.data?.forEach(detailedPlan => {
                    planUpdates.push(this.store.dispatch(new SelectPlanDetails(detailedPlan)));
                });
            }
            planUpdates.push(this.store.dispatch(new UpdatePlanPharmacies(response?.planPharmacyData, planTypes, planIds)));
            return forkJoin(planUpdates);
        }), map(() => {
            // Remove currentYearPlan if not selected to compare
            // the order the plans come in can matter for retention, so we maintain that order here.
            // The sort further down will still fire, but when there are ties, this order will then be respected
            const plans = this.plansService.getPlansByIds(planIds);
            const currentSortType = this.planFacade.getCurrentSortType(currentTabType);
            return currentTabType === PlanTypeAbbreviation.HC ? plans : SortUtilities.sort(plans, currentSortType);
        }), tap({
            next: () => {
                this.plansService.setPlansLoading(planTypes, false);
            }
        }), catchError(error => {
            this.store.dispatch(new FetchPlansError(error, planTypes));
            this.plansService.setPlansLoading(planTypes, false);
            return of([]);
        }));
    }
    mapCompareGroups(isHospitalIndemnityQuoteCompareGroup = false) {
        return pipe(switchMap(activeCompareGroup => {
            this.activeCompareGroup = activeCompareGroup;
            if (!this.activeCompareGroup) {
                return of([]);
            }
            const currentTabType = this.activeCompareGroup.groupKey.values[0];
            const planIds = this.activeCompareGroup.items.map(plan => plan.id);
            const demographicsOptionsWithDefaults = this.plansService.createPlansDemographicsOptionsWithDefaults();
            const searchOptionsWithDefaults = this.plansService.createPlansSearchOptionsWithDefaults();
            const medicalCostCabinetUpdatePayload = this.plansService.getMedicalCostInputs(searchOptionsWithDefaults, demographicsOptionsWithDefaults);
            const drugs = this.drugsService.mapCabinetToDosage();
            const pharmacies = this.getPharmacies();
            const providers = this.providerService.getNpiAndAddressOfSelectedProviders();
            const memberData = this.memberSessionService.getMemberSession();
            const isRetentionView = this.siteService.isRetentionView();
            const currentYearPlanID = isRetentionView && memberData?.currentYearPlanID ? memberData.currentYearPlanID : '';
            const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
            const costByEffectiveDate = this.store.selectSnapshot(MemberState.costByEffectiveDate);
            const totalCostEffectiveDate = this.store.selectSnapshot(MemberState.totalCostEffectiveDate);
            searchOptionsWithDefaults.drugMedTocEffectiveDate = totalCostEffectiveDate;
            const miscFields = {
                medigapAnswers: this.plansService.getMergedMedigapAnswers(),
                drugs,
                pharmacies,
                providers,
                agentGuid,
                currentYearPlanID,
                costByEffectiveDate,
                healthCostsEnabled: this.configResourceService.getProcessedResourceValue('Spa_Site_HealthCosts_Enabled', null, true),
                filterPlanMarketingNameEnabled: this.configResourceService.getProcessedResourceValue('Spa_Filter_Plan_Marketing_Name_Enabled', null, false)
            };
            const isPlanFeesEnabled = this.plansService.getIsPlanFeesEnabled();
            const planIdsForFeeRetrieval = isPlanFeesEnabled
                ? this.plansService.getNonMedicarePlanIds(this.activeCompareGroup.items)
                : [];
            // We initially won't update the plans details state only when the plan fees is enabled and there are plans for fee retrieval.
            // We will update the state later, after we include their fees.
            const shouldFetchPlansDetailsWithFees = isPlanFeesEnabled && planIdsForFeeRetrieval.length && !MEDICARE_PLAN_TYPES.includes(currentTabType);
            const planTypes = this.plansService.getPlanTypesArray(searchOptionsWithDefaults?.planType);
            this.plansService.setPlansLoading(planTypes, true);
            const fetchPlans$ = this.plansHttpService
                .retrievePlans$(demographicsOptionsWithDefaults, searchOptionsWithDefaults, miscFields, planIds, medicalCostCabinetUpdatePayload)
                .pipe(this.mapPlanDetailsSelection(planIds, planTypes, currentTabType, shouldFetchPlansDetailsWithFees));
            let plans$ = fetchPlans$;
            if (shouldFetchPlansDetailsWithFees) {
                plans$ = this.plansService.fetchPlansDetailsWithFees$(fetchPlans$, planIdsForFeeRetrieval).pipe(
                // We update the state with the plans details (including their fees)
                switchMap(detailedPlans => forkJoin(detailedPlans.map(detailedPlan => this.store.dispatch(new SelectPlanDetails(detailedPlan)))).pipe(map(() => detailedPlans))));
            }
            // We require the plan details for Hospital Indemnity Quote Compare because those will include all riders (benefits) available
            if (isHospitalIndemnityQuoteCompareGroup) {
                return plans$.pipe(switchMap(detailedPlans => {
                    const idsForExternalRating = this.plansService.getIdsForExternallyRatedData(detailedPlans, true);
                    return this.plansService.getExternallyRatedPlanData$(idsForExternalRating).pipe(map(externalRatingData => {
                        const showPremiumAsAnnual = this.configResourceService.getProcessedResourceValue('Spa_Site_ShowPremiumAsAnnual', null, false);
                        return detailedPlans.map(detailedPlan => this.plansService.updatePlanWithExternallyRatedPlanData(externalRatingData, detailedPlan, showPremiumAsAnnual));
                    }));
                }));
            }
            const idsForExternalRating = this.plansService.getIdsForExternallyRatedData(this.activeCompareGroup.items, true);
            return forkJoin([plans$, this.plansService.getExternallyRatedPlanData$(idsForExternalRating)]).pipe(map(([detailedPlans, externalRatingData]) => {
                const showPremiumAsAnnual = this.configResourceService.getProcessedResourceValue('Spa_Site_ShowPremiumAsAnnual', null, false);
                return detailedPlans.map(detailedPlan => this.plansService.updatePlanWithExternallyRatedPlanData(externalRatingData, detailedPlan, showPremiumAsAnnual));
            }));
        }), share());
    }
    getSelectedCompareGroup() {
        return this.activeCompareGroup;
    }
    getPlanLevelContentResourceTag() {
        return `Spa_PlanLevel_Content_Label_${this.getSelectedCompareGroup().groupKey.values[0]}`;
    }
    getPlansCompareTags(plans) {
        const planTypeUnderComparison = plans.length ? plans[0].planTypeAbbreviation : this.googleTagManagerNotApplicableText;
        let tagsToUpdate;
        if (this.siteService.isRetentionView()) {
            this.retentionFacade
                .getPlans$()
                .pipe(take(1))
                .subscribe({
                next: retentionPlans => {
                    const currentYearPlan = retentionPlans.find(plan => plan.isCurrentYearPlan);
                    const nextYearPlan = this.retentionFacade.getNextYearPlanFromPlansList(retentionPlans);
                    const secondOptionPlan = this.retentionFacade.getOption2PlanFromPlansList(retentionPlans);
                    tagsToUpdate = {
                        [DataLayerGlobalVariable.PLAN_ID_CURRENT]: currentYearPlan?.id ?? this.googleTagManagerNotApplicableText,
                        [DataLayerGlobalVariable.PLAN_ID_NEXT_YEAR]: nextYearPlan?.id ?? this.googleTagManagerNotApplicableText,
                        [DataLayerGlobalVariable.PLAN_ID_NEXT_YEAR2]: secondOptionPlan?.id ?? this.googleTagManagerNotApplicableText,
                        [DataLayerGlobalVariable.PLAN_TYPE]: planTypeUnderComparison,
                        [DataLayerGlobalVariable.PLAN_ID_BEST_MATCH]: this.planListFacade.getBestMatchPlanIdValueForAnalytics(),
                        [DataLayerGlobalVariable.PLAN_TYPE_BEST_MATCH]: this.planListFacade.getBestCoverageTabAbbreviationValueForAnalytics(),
                        [DataLayerGlobalVariable.SELECTED_PHARMACY]: this.pharmacyFacade.getSelectedNABPPharmacies()
                    };
                }
            });
        }
        else {
            tagsToUpdate = {
                [DataLayerGlobalVariable.PLAN_TYPE]: planTypeUnderComparison,
                [DataLayerGlobalVariable.PLAN_ID]: plans.map(plan => plan.id).join('|'),
                [DataLayerGlobalVariable.PLAN_ID_BEST_MATCH]: this.planListFacade.getBestMatchPlanIdValueForAnalytics(),
                [DataLayerGlobalVariable.PLAN_TYPE_BEST_MATCH]: this.planListFacade.getBestCoverageTabAbbreviationValueForAnalytics(),
                [DataLayerGlobalVariable.SELECTED_PHARMACY]: this.pharmacyFacade.getSelectedNABPPharmacies()
            };
            if (this.planCardFacade.isProviderInfoEnabled()) {
                const providerStatus = this.providerFacade.getProviderLocationStatus(plans.map(plan => plan.id));
                tagsToUpdate = {
                    ...tagsToUpdate,
                    [DataLayerGlobalVariable.PROVIDER_LOCATIONS_STATUS]: providerStatus
                };
            }
            if (this.siteService.isPPCSite()) {
                tagsToUpdate = {
                    ...tagsToUpdate,
                    [DataLayerGlobalVariable.PLANS_COUNT_NON_LICENSED]: plans
                        .map(plan => (this.planFacade.canSellPlan(plan) ? GOOGLE_ANALYTICS_NO : GOOGLE_ANALYTICS_YES))
                        .join('|'),
                    [DataLayerGlobalVariable.PLAN_ID_BEST_MATCH]: this.planListFacade.getBestMatchPlanIdValueForAnalytics(),
                    [DataLayerGlobalVariable.PLAN_TYPE_BEST_MATCH]: this.planListFacade.getBestCoverageTabAbbreviationValueForAnalytics(),
                    [DataLayerGlobalVariable.PLAN_PROVIDER_VBC_STATUS]: plans
                        .map(plan => (this.planFacade.isVbcAgreementExists(plan) ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO))
                        .join('|')
                };
            }
        }
        return tagsToUpdate;
    }
    isPlanLevelContentExist(plans) {
        return plans.some(plan => plan.extraData?.some(data => data.name === this.educationalContent));
    }
    getCompareGroup() {
        return this.store.selectSnapshot(PlansState.compareGroups);
    }
    getMedicineCabinet() {
        return this.guidedHelpService.getMedicineCabinet();
    }
    getSelectedPharmacy() {
        return this.store.selectSnapshot(PharmacyState.selectedPharmacy);
    }
    getSelectedPharmacy$() {
        return this.store.select(PharmacyState.selectedPharmacy);
    }
    getDrugFreqencyAndQuantity(drugDosageValue, drugPackageValue) {
        return this.drugsService.getQuantityAndFrequency(drugDosageValue, drugPackageValue);
    }
    getSelectedProviders$() {
        return this.planFacade.selectedProviders$;
    }
    isDrugCovered(plan, drugNdc) {
        let planRetailDrugCoverage = plan ? plan.planRetailDrugCoverageMultiPharmacy : [];
        this.getSelectedPharmacy$().pipe(map(pharmacy => {
            if (pharmacy && planRetailDrugCoverage?.length) {
                planRetailDrugCoverage = planRetailDrugCoverage.filter(retailDrugCoverage => retailDrugCoverage.pharmacyNABP === pharmacy.nabp);
            }
        }));
        const coverage = planRetailDrugCoverage ? planRetailDrugCoverage.find(drugCoverage => drugCoverage.ndc === drugNdc) : null;
        return coverage && coverage.tierNumber > 0;
    }
    isPrescriptionDrugExist(plans) {
        return plans.some(plan => plan.extendedPlanDetails.some(extendedPlanDetails => extendedPlanDetails.sectionDetails.some(sectionDetails => sectionDetails.valueTypeID === PlanBenefitValueType.DRUG_BENEFIT)));
    }
    getMedicalBenefitValue(plan, notAvailableText, title) {
        let benefitValue = notAvailableText;
        if (title === this.planCompareLabels.MEDICAL_DEDUCTIBLE) {
            benefitValue = plan.medicalDeductible;
        }
        else if (title === this.planCompareLabels.MEDICAL_OUT_OF_POCKET_MAXIMUM) {
            benefitValue = plan.maximumOutOfPocketCost;
        }
        if (typeof benefitValue === 'number') {
            return formatCurrency(benefitValue, 'en-US', getCurrencySymbol('USD', 'wide'), 'USD', '1.2-2');
        }
        return benefitValue;
    }
    getBenefitValue(plan, notAvailableText, compareBenefit) {
        let benefitValue = notAvailableText;
        if (compareBenefit) {
            if (compareBenefit.benefitID) {
                const planBenefits = this.getPlanBenefit(plan, compareBenefit);
                benefitValue = planBenefits ? planBenefits.description : notAvailableText;
            }
            if (compareBenefit.title === this.planCompareLabels.MEDICAL_DEDUCTIBLE) {
                benefitValue = plan.medicalDeductible;
            }
            else if (compareBenefit.title === this.planCompareLabels.MEDICAL_OUT_OF_POCKET_MAXIMUM) {
                benefitValue = plan.maximumOutOfPocketCost;
            }
            if (typeof benefitValue === 'number') {
                const locale = 'en-US';
                const currencyCode = 'USD';
                const digitsInfo = '1.2-2';
                return formatCurrency(benefitValue, locale, getCurrencySymbol(currencyCode, 'wide'), currencyCode, digitsInfo);
            }
        }
        return benefitValue;
    }
    getBenefitsBasedOnPlanType(plans, planCompareBenefitValuesMAPD, planCompareBenefitValuesMA, planCompareBenefitValuesMEDIGAP) {
        const planTypeValue = plans[0].planType;
        if (plans.length > 0) {
            if (planTypeValue === this.planType.MAPD) {
                return planCompareBenefitValuesMAPD;
            }
            if (planTypeValue === this.planType.MA) {
                return planCompareBenefitValuesMA;
            }
            if (planTypeValue === this.planType.MEDIGAP) {
                return planCompareBenefitValuesMEDIGAP.map(benefitValue => ({
                    ...benefitValue,
                    detail: benefitValue.detail ? benefitValue.detail : this.getBenefitDetailName(benefitValue.benefitID, plans[0].planDataFields)
                }));
            }
        }
    }
    getBenefitDetailName(benefitId, planDataFields) {
        const detailName = planDataFields.find(planData => planData.benefitID === benefitId);
        if (detailName) {
            return detailName.name;
        }
    }
    showBenefitValues(plans, compareBenefit) {
        return (!!compareBenefit.title ||
            (plans.some(planBenefit => !!this.getPlanBenefit(planBenefit, compareBenefit)) && !!compareBenefit.benefitID));
    }
    getPlanBenefit(plan, compareBenefit) {
        return plan.planDataFields.find(benefit => benefit.benefitID === compareBenefit.benefitID && benefit.type === this.planCompareLabels.IN_NETWORK && !!benefit.description);
    }
    getPlanCompareStyles(plans, notAvailableText, showDifferences, planComparePlanDifferencesColor, planComparePlanDifferencesBorder, options) {
        if (this.showHighlightDifferences({
            plans,
            notAvailableText,
            showDifferences,
            label: options.costTitle,
            benefit: options.benefit
        })) {
            return {
                'background-color': planComparePlanDifferencesColor,
                'border': planComparePlanDifferencesBorder
            };
        }
    }
    showHighlightDifferences(options) {
        let areAnyDifferences = false;
        if (options.showDifferences) {
            const { plans, notAvailableText, label, benefit, benefitsTitle, isMailOrder, isQuoteSummaryMode } = options;
            // Costs section
            if (label) {
                // Plan fees
                if (!isQuoteSummaryMode &&
                    label === PlanDetailsCostLabels.PLAN_FEES &&
                    this.plansService.getIsPlanFeesEnabled() &&
                    plans.some(plan => plan.fees?.length)) {
                    const uniqueFees = Array.from(new Set(plans.map(plan => this.getStringifiedPlanFees(plan))));
                    areAnyDifferences = uniqueFees.length !== 1;
                }
                // Other costs
                else {
                    const uniqueCosts = Array.from(new Set(plans.map(plan => this.getCostValue(plan, label, isMailOrder))));
                    areAnyDifferences = uniqueCosts.length !== 1;
                }
            }
            // Benefits section
            else if (benefit) {
                const uniqueBenefits = Array.from(new Set(plans.map(plan => this.getBenefitValue(plan, notAvailableText, benefit))));
                areAnyDifferences = uniqueBenefits.length !== 1;
            }
            // Medical Benefits section
            else if (benefitsTitle) {
                const uniqueMedicalBenefits = Array.from(new Set(plans.map(plan => this.getMedicalBenefitValue(plan, notAvailableText, benefitsTitle))));
                areAnyDifferences = uniqueMedicalBenefits.length !== 1;
            }
        }
        return areAnyDifferences;
    }
    getRiderCategories(plans) {
        const categoryNames = [];
        plans.forEach(plan => {
            if (!plan.isCurrentYearPlan && (!plan.isNextYearPlan || plan.isPlanRolloverTerminated)) {
                categoryNames.push(...new Set(plan.riders.filter(rider => this.riderFacade.getRiderMedicalPremium(rider) !== 0).map(rider => rider.planSubType)));
            }
        });
        const filteredCategories = categoryNames.filter((category, index) => categoryNames.indexOf(category) === index);
        const sortedSingleCategories = filteredCategories.filter(riderSubType => !this.isCombinedRider(riderSubType)).sort();
        const sortedCombinedCategories = filteredCategories.filter(riderSubType => this.isCombinedRider(riderSubType)).sort();
        return [...sortedSingleCategories, ...sortedCombinedCategories];
    }
    getRiderDifferenceCustomStyles(plans, riderCategory, showHighlightPlanDifferences) {
        const riderIncludedText = this.configResourceService.getProcessedResourceValue('Spa_ShoppingCart_IncludedRider_Text', null, 'Included');
        const riderNotSupportedText = this.configResourceService.getProcessedResourceValue('Spa_Site_Rider_NotSupported_Text', null, 'No');
        const riderNotApplicableText = this.configResourceService.getProcessedResourceValue('Spa_Site_NotApplicable_Text', null, 'N/A');
        const riders = Array.from(new Set(plans.map(plan => {
            const planSelectedCategoryRider = this.planDetailsFacade.getRidersWithMatchingCategory(riderCategory, plan);
            if (planSelectedCategoryRider.length === 0) {
                return riderNotSupportedText;
            }
            if (plan.isCurrentYearPlan || (plan.isNextYearPlan && !plan.isPlanRolloverTerminated)) {
                return riderNotApplicableText;
            }
            if (planSelectedCategoryRider[0].isRequiredRider) {
                return riderIncludedText;
            }
            const premium = this.planDetailsFacade.getRiderMedicalPremium(planSelectedCategoryRider[0]);
            if (premium === undefined || isNaN(premium)) {
                return null;
            }
            return premium;
        })));
        if (showHighlightPlanDifferences && !riders.every(rider => rider === riders[0])) {
            return {
                'background-color': this.highlightColor,
                'border': this.highlightBorder
            };
        }
    }
    getBenefitCoveredDifferenceCustomStyles(answeredPreferenceBenefits, showHighlightPlanDifferences, plans, differentBenefitCoveredIndex) {
        let highlightStyle = {};
        if (showHighlightPlanDifferences) {
            const differentBenefitCoveredHighlightStyles = answeredPreferenceBenefits[0]?.preferenceBenefits[differentBenefitCoveredIndex];
            const preferenceOptionIsCoveredList = new Set(plans.map((plan) => {
                const preferenceBenefit = answeredPreferenceBenefits.find(answeredPreferenceBenefit => answeredPreferenceBenefit.planId === plan.id);
                if (preferenceBenefit?.preferenceBenefits) {
                    const preferenceOption = preferenceBenefit.preferenceBenefits.find(preferenceBenefit => preferenceBenefit.id === differentBenefitCoveredHighlightStyles.id);
                    return preferenceOption ? (preferenceOption.isCovered ? 1 : 0) : 0;
                }
                return 0;
            }));
            highlightStyle =
                [...preferenceOptionIsCoveredList].length > 1
                    ? {
                        'background-color': this.highlightColor,
                        'border': this.highlightBorder
                    }
                    : {};
            return highlightStyle;
        }
        return highlightStyle;
    }
    isCurrentOrNextYearPlan(plan) {
        return plan.isCurrentYearPlan || (plan.isNextYearPlan && !plan.isPlanRolloverTerminated);
    }
    getriderIconClass(riderCategory) {
        return `${this.planDetailsFacade.getRiderIcon(riderCategory)} Spa_Style_Primary_Link_Color mt-1`;
    }
    getMedicalBenefitHighlightStyles(plans, notAvailableText, showDifferences, planComparePlanDifferencesColor, planComparePlanDifferencesBorder, benefitsTitle, benefit) {
        if (this.showHighlightDifferences({
            plans,
            notAvailableText,
            showDifferences,
            benefit,
            benefitsTitle
        })) {
            return {
                'background-color': planComparePlanDifferencesColor,
                'border': planComparePlanDifferencesBorder
            };
        }
    }
    openSendQuoteModal() {
        const activeTab = this.store.selectSnapshot(PlansState.activeTabType);
        const compareGroup = this.store.selectSnapshot(PlansState.compareGroups);
        const activeTabCompareGroup = compareGroup.find(data => data.groupKey.values.find(key => key === activeTab));
        this.planFacade.openSendQuoteModal(activeTabCompareGroup.items);
    }
    getPreferencesHighlightStyles(plans, showHighlightPlanDifferences, options, selectedPharmacy) {
        if (options) {
            if (options.ndc) {
                const coveredDrugText = this.configResourceService.getProcessedResourceValue('Spa_PlanDetails_Covered_Text', null, 'Covered');
                const nonCoveredDrugText = this.configResourceService.getProcessedResourceValue('Spa_PlanDetails_Non_Covered_Text', null, 'Not covered');
                const drugs = Array.from(new Set(plans.map(plan => {
                    if (this.isDrugCovered(plan, options.ndc)) {
                        return coveredDrugText;
                    }
                    return nonCoveredDrugText;
                })));
                if (showHighlightPlanDifferences && drugs.length !== 1) {
                    return {
                        'background-color': this.highlightColor,
                        'border': this.highlightBorder
                    };
                }
            }
            else if (options.isProvider) {
                const provider = plans.some(plan => !plan.providerURL);
                if (provider) {
                    return {
                        'background-color': this.highlightColor,
                        'border': this.highlightBorder
                    };
                }
            }
            else if (options.providerDetails?.length) {
                if (showHighlightPlanDifferences) {
                    if (options.providerDetails.length !== plans.length) {
                        return {
                            'background-color': this.highlightColor,
                            'border': this.highlightBorder
                        };
                    }
                    const inNetworkProviders = options.providerDetails.filter(providerDetail => providerDetail.inNetwork);
                    if (inNetworkProviders?.length && inNetworkProviders.length !== plans.length) {
                        return {
                            'background-color': this.highlightColor,
                            'border': this.highlightBorder
                        };
                    }
                }
            }
            else if (options.mailOrder) {
                if (showHighlightPlanDifferences) {
                    const hasNoMailOrder = plans.some(plan => !plan.hasMailDrugBenefits);
                    if (hasNoMailOrder) {
                        return {
                            'background-color': this.highlightColor,
                            'border': this.highlightBorder
                        };
                    }
                    const isPharmacyNotCovered = plans.some(plan => this.isPlanPharmacyNotCovered(plan));
                    if (isPharmacyNotCovered) {
                        return {
                            'background-color': this.highlightColor,
                            'border': this.highlightBorder
                        };
                    }
                }
            }
        }
        else {
            const inNetworkPreferredText = this.configResourceService.getProcessedResourceValue('Spa_Pharmacy_InNetwork_Preferred_Pricing_Text', null, 'In-network pharmacy with preferred pricing');
            const inNetworkStandardText = this.configResourceService.getProcessedResourceValue('Spa_Pharmacy_InNetwork_Standard_Pricing_Text', null, 'In-network pharmacy with standard pricing');
            const outOfNetworkText = this.configResourceService.getProcessedResourceValue('Spa_Pharmacy_OutOfNetwork_Pricing_Text', null, 'Out-of-network pharmacy');
            const notCoveredText = this.configResourceService.getProcessedResourceValue('Spa_PlanDetails_Non_Covered_Text', null, 'Not Covered');
            const pharmacy = Array.from(new Set(plans.map(plan => {
                const pharmacies = this.pharmacyService.getAPIPharmacyInfoForPlan(plan.id);
                if (pharmacies?.length) {
                    const planPharmacyCoverage = pharmacies.find(planMultiCoveragePharmacy => selectedPharmacy && planMultiCoveragePharmacy && planMultiCoveragePharmacy.nabp === selectedPharmacy.nabp);
                    if (planPharmacyCoverage && planPharmacyCoverage.isInNetwork) {
                        if (planPharmacyCoverage.isPreferred) {
                            return inNetworkPreferredText;
                        }
                        return inNetworkStandardText;
                    }
                    if (plan.isCurrentYearPlan && !planPharmacyCoverage) {
                        return notCoveredText;
                    }
                    return outOfNetworkText;
                }
                if (plan.isCurrentYearPlan) {
                    return notCoveredText;
                }
                return outOfNetworkText;
            })));
            if (showHighlightPlanDifferences && pharmacy.length !== 1) {
                return {
                    'background-color': this.highlightColor,
                    'border': this.highlightBorder
                };
            }
        }
    }
    getProviderDetails(provider, providerDetails) {
        if (providerDetails?.plans?.length && provider) {
            const plans = providerDetails.plans;
            const providers = [];
            plans.forEach(plan => {
                if (plan.providers?.length) {
                    const selectedProvider = ProviderUtilityService.matchProviderDetailInfo({
                        providerDetails: plan.providers,
                        selectedProvider: provider
                    });
                    if (selectedProvider) {
                        providers.push(selectedProvider);
                    }
                }
            });
            return providers;
        }
        return [];
    }
    getSelectedPharmacies$() {
        return this.pharmacyFacade.getSelectedPharmacies$();
    }
    showPharmacySelectorToggle() {
        const activeTab = this.store.selectSnapshot(PlansState.activeTabType);
        return this.pharmacyFacade.showPharmacySelectorToggle(activeTab);
    }
    showUpdateEffectiveDate() {
        const activeTab = this.store.selectSnapshot(PlansState.activeTabType);
        return activeTab === PlanTypeAbbreviation.MAPD || activeTab === PlanTypeAbbreviation.PDP;
    }
    getPrimaryPharmacy$() {
        return this.pharmacyFacade.getPrimaryPharmacy$();
    }
    getDetailsOfSelectedPharmacy(pharmacies, selectedPharmacy) {
        return pharmacies.filter(pharmacy => pharmacy && pharmacy.nabp === selectedPharmacy.nabp);
    }
    getPreferenceBenefits(plans) {
        return plans.reduce((preferenceBenefits, plan) => {
            const preferences = this.preferencesService.getPlanPreferenceBenefits(plan);
            const planPreferenceBenefits = {
                planId: plan.id,
                preferenceBenefits: preferences
            };
            preferenceBenefits.push(planPreferenceBenefits);
            return preferenceBenefits;
        }, []);
    }
    updateSelectedPharamcyAndFetchPlanDetails(updatedPharmacy) {
        this.switchMailOrder(false);
        this.pharmacyFacade.setSelectedPharmacy(updatedPharmacy);
    }
    getCostValue(plan, label, isMailOrderSelected = false) {
        if (!plan) {
            return 0;
        }
        if (label === PlanDetailsCostLabels.PREMIUM) {
            return this.planDetailsFacade.getTotalPremium([plan]);
        }
        let costValue = 0;
        const estimatedCost = this.planFacade.getEstimatedCost(plan, this.getSelectedPharmacy(), isMailOrderSelected);
        if (label === PlanDetailsCostLabels.DRUG_COST && estimatedCost?.totalAnnualDrugCostShare) {
            costValue = estimatedCost.totalAnnualDrugCostShare;
        }
        else if (label === PlanDetailsCostLabels.HEALTH_COST && estimatedCost.totalAnnualMedicalCostShare) {
            costValue = estimatedCost.totalAnnualMedicalCostShare;
        }
        else if (label === PlanDetailsCostLabels.TOTAL_ESTIMATED_COST && estimatedCost) {
            costValue = estimatedCost.totalEstimatedCost;
        }
        return costValue;
    }
    getStringifiedPlanFees(plan) {
        return (plan.fees?.reduce((stringifiedPlanFees, planFee) => this.stringifyPlanFees(planFee.type, planFee.label, planFee.amount, planFee.isIncludedInMonthlyPremium, stringifiedPlanFees), '') ?? '');
    }
    switchMailOrder(isMailOrderEnabled) {
        this.pharmacyFacade.switchMailOrder(isMailOrderEnabled);
    }
    isMailOrderPharmacyAvailable(plans) {
        return this.planFacade.isMailOrderPharmacyAvailable(plans);
    }
    isPlanPharmacyNotCovered(plan) {
        return !this.pharmacyFacade.isPlanPharmacyCovered(plan);
    }
    getLowIncomeSubsidyText(plan) {
        return this.planDetailsFacade.getLowIncomeSubsidyText(plan.subsidy?.generic, plan.subsidy?.brand);
    }
    getLowIncomeSubsidyLabel(widgetName) {
        return this.planDetailsFacade.getLowIncomeSubsidyLabel(widgetName);
    }
    getLowIncomeSubsidyInformationalText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanCompare_LowIncomeSubsidyInformational_Text', widgetName, 'If you are eligible for the subsidy you selected, you will pay the lowest cost, which may be the plan benefit listed below. ' +
            '  View the Prescriptions tab in Plan Details for an estimate of the cost you will pay for the subsidy selected.');
    }
    stringifyPlanFees(planFeeType, planFeeLabel, planFeeAmount, isPlanFeeIncludedInMonthlyPremium, stringifiedPlanFees) {
        const stringifiedPlanFee = `${planFeeType} - ${planFeeLabel} - ${planFeeAmount} - ${isPlanFeeIncludedInMonthlyPremium}`;
        return stringifiedPlanFees ? `${stringifiedPlanFees} / ${stringifiedPlanFee}` : stringifiedPlanFee;
    }
    getCompareGroupByPlanType(storeCompareGroups, planTypeAbbreviation) {
        return storeCompareGroups.find(compareGroup => compareGroup.groupKey && compareGroup.groupKey.values[0] === planTypeAbbreviation);
    }
    getPharmacies() {
        const defaultPharmacy = this.getSelectedPharmacy();
        const selectedPharmacies = this.store.selectSnapshot(PharmacyState.selectedPharmacies);
        const pharmacies = [];
        if (selectedPharmacies?.length) {
            selectedPharmacies.forEach(selectedPharmacy => {
                pharmacies.push({
                    pharmacyNABP: selectedPharmacy.nabp,
                    isMailOrder: selectedPharmacy.isMailOrder
                });
            });
        }
        else if (defaultPharmacy) {
            pharmacies.push({
                pharmacyNABP: defaultPharmacy.nabp,
                isMailOrder: defaultPharmacy.isMailOrder
            });
        }
        return pharmacies;
    }
    isCombinedRider(riderSubType) {
        return (riderSubType === RiderSubTypes.VisionHearing ||
            riderSubType === RiderSubTypes.DentalHearing ||
            riderSubType === RiderSubTypes.DentalVision ||
            riderSubType === RiderSubTypes.All ||
            riderSubType === RiderSubTypes.CombinedAncillary ||
            riderSubType === RiderSubTypes.CombinedAncillaryRider ||
            riderSubType === RiderSubTypes.CombinedRider);
    }
    sortHospitalCareQuoteCompare(plans, medicarePlanTypes) {
        const medicarePlan = plans.find(plan => medicarePlanTypes.find(availablePlan => availablePlan.tabType === plan.planTypeAbbreviation && availablePlan.enabled));
        if (medicarePlan) {
            return [medicarePlan, ...plans.filter(plan => plan.id !== medicarePlan.id)];
        }
        return plans;
    }
}
PlanCompareFacade.ɵfac = function PlanCompareFacade_Factory(t) { return new (t || PlanCompareFacade)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(PlanFacade), i0.ɵɵinject(i1.PlansHttpService), i0.ɵɵinject(i1.PlansService), i0.ɵɵinject(i1.DrugsService), i0.ɵɵinject(i1.GuidedHelpService), i0.ɵɵinject(PlanListFacadeService), i0.ɵɵinject(i1.PreferencesService), i0.ɵɵinject(PlanDetailsFacade), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(i1.SiteService), i0.ɵɵinject(PharmacyFacade), i0.ɵɵinject(i1.ProviderService), i0.ɵɵinject(i1.PharmacyService), i0.ɵɵinject(RetentionFacade), i0.ɵɵinject(RiderFacade), i0.ɵɵinject(ProviderFacade), i0.ɵɵinject(PlanCardFacade)); };
PlanCompareFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlanCompareFacade, factory: PlanCompareFacade.ɵfac, providedIn: 'root' });
__decorate([
    Select(PlansState.compareGroups)
], PlanCompareFacade.prototype, "storeCompareGroups$", void 0);
__decorate([
    Select(PlansState.planComparePlanType)
], PlanCompareFacade.prototype, "planComparePlanType$", void 0);
__decorate([
    LiveEditInactive()
], PlanCompareFacade.prototype, "updateSelectedPharamcyAndFetchPlanDetails", null);
__decorate([
    LiveEditInactive()
], PlanCompareFacade.prototype, "switchMailOrder", null);
__decorate([
    Memoize()
], PlanCompareFacade.prototype, "stringifyPlanFees", null);
__decorate([
    Memoize()
], PlanCompareFacade.prototype, "sortHospitalCareQuoteCompare", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCompareFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i2.Store }, { type: PlanFacade }, { type: i1.PlansHttpService }, { type: i1.PlansService }, { type: i1.DrugsService }, { type: i1.GuidedHelpService }, { type: PlanListFacadeService }, { type: i1.PreferencesService }, { type: PlanDetailsFacade }, { type: i1.ConfigResourceService }, { type: i1.MemberSessionService }, { type: i1.SiteService }, { type: PharmacyFacade }, { type: i1.ProviderService }, { type: i1.PharmacyService }, { type: RetentionFacade }, { type: RiderFacade }, { type: ProviderFacade }, { type: PlanCardFacade }]; }, { storeCompareGroups$: [], planComparePlanType$: [], updateSelectedPharamcyAndFetchPlanDetails: [], switchMailOrder: [], stringifyPlanFees: [], sortHospitalCareQuoteCompare: [] }); })();

class HospitalIndemnityFactorModalComponent {
    constructor(activeModal, navigationService, configResourceService, plansService, planListFacade, hospitalIndemnityFormFacade, planCompareFacade, planFacade, cdr) {
        this.activeModal = activeModal;
        this.navigationService = navigationService;
        this.configResourceService = configResourceService;
        this.plansService = plansService;
        this.planListFacade = planListFacade;
        this.hospitalIndemnityFormFacade = hospitalIndemnityFormFacade;
        this.planCompareFacade = planCompareFacade;
        this.planFacade = planFacade;
        this.cdr = cdr;
    }
    ngOnInit() {
        this.initializeInstanceVariables();
    }
    cancel() {
        this.activeModal.dismiss();
    }
    onHospitalIndemnityFormClose(fetchPlans) {
        this.hospitalIndemnityFormFacade.onHospitalIndemnityFormClose(fetchPlans);
        this.navigate();
    }
    toggleSpinner(isFormSubmitted) {
        this.continueButton?.toggleSpinner(isFormSubmitted);
        this.cdr.detectChanges();
    }
    onViewPlans(rateFactorsForm) {
        rateFactorsForm?.ngFormInstance?.onSubmit(null);
        this.toggleSpinner(rateFactorsForm?.rateFactorsForm.valid);
    }
    navigate() {
        const activeRateFactorPlan = this.plansService.getRateFactorPlan();
        const hospitalIndemnityPlansSelectedForQuote = this.planCompareFacade.getHospitalIndemnityPlansSelectedForQuote();
        // If shouldReplaceExistingRateFactor is false, it should NOT replace the previously selected medicare plan
        // but if there is not previously selected plan, it should select the one just provided
        if ((this.shouldReplaceExistingRateFactor || !activeRateFactorPlan) &&
            (hospitalIndemnityPlansSelectedForQuote?.items?.length < this.addToQuoteLimit ||
                hospitalIndemnityPlansSelectedForQuote?.items?.some((hospitalIndemnityPlan) => !this.planFacade.isHCPlan(hospitalIndemnityPlan)))) {
            this.plansService.setRateFactorPlan(this.rateFactorPlan);
        }
        this.plansService.setOverrideActiveTab(false);
        this.planListFacade.updateActiveTab(PlanTypeAbbreviation.HC);
        this.navigationService
            .navigate({
            title: '',
            type: LinkType.INTERNAL,
            tag: PageTags.PLAN_LIST,
            validateWidgets: false
        })
            .then(success => {
            if (success) {
                this.activeModal.close();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        });
    }
    initializeInstanceVariables() {
        this.viewPlansButtonText = this.configResourceService.getProcessedResourceValue('Spa_Consumer_AccountOverview_ViewPlans_Text', null, 'View Plans');
        this.cancelButtonText = this.configResourceService.getProcessedResourceValue('Spa_Site_Cancel', null, 'Cancel');
    }
}
HospitalIndemnityFactorModalComponent.ɵfac = function HospitalIndemnityFactorModalComponent_Factory(t) { return new (t || HospitalIndemnityFactorModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(PlanListFacadeService), i0.ɵɵdirectiveInject(HospitalIndemnityFormFacade), i0.ɵɵdirectiveInject(PlanCompareFacade), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
HospitalIndemnityFactorModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HospitalIndemnityFactorModalComponent, selectors: [["ng-component"]], viewQuery: function HospitalIndemnityFactorModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(StatusButtonComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.continueButton = _t.first);
    } }, decls: 12, vars: 10, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "modal-body"], [1, "row"], [1, "col-12"], [3, "spaPageSubHeader", "spaPageTitle", "isEmbedded", "errorKeywordText", "errorNoticeTitle", "dropdownDefaultText", "formClose", "formSubmit"], ["hospitalIndemnityForm", ""], [1, "modal-footer", "justify-content-start"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "mr-auto", 3, "click", "keyup.enter"], [1, "d-flex", "justify-content-end"], [1, "button-container"], [3, "buttonClass", "buttonText", "click", "keyup.enter"]], template: function HospitalIndemnityFactorModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function HospitalIndemnityFactorModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.cancel(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "vnext-hospital-indemnity-form", 4, 5);
        i0.ɵɵlistener("formClose", function HospitalIndemnityFactorModalComponent_Template_vnext_hospital_indemnity_form_formClose_4_listener($event) { return ctx.onHospitalIndemnityFormClose($event); })("formSubmit", function HospitalIndemnityFactorModalComponent_Template_vnext_hospital_indemnity_form_formSubmit_4_listener($event) { return ctx.toggleSpinner($event); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(6, "div", 6)(7, "button", 7);
        i0.ɵɵlistener("click", function HospitalIndemnityFactorModalComponent_Template_button_click_7_listener() { return ctx.cancel(); })("keyup.enter", function HospitalIndemnityFactorModalComponent_Template_button_keyup_enter_7_listener() { return ctx.cancel(); });
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 8)(10, "div", 9)(11, "vnext-status-button", 10);
        i0.ɵɵlistener("click", function HospitalIndemnityFactorModalComponent_Template_vnext_status_button_click_11_listener() { i0.ɵɵrestoreView(_r1); const _r0 = i0.ɵɵreference(5); return i0.ɵɵresetView(ctx.onViewPlans(_r0 == null ? null : _r0.rateFactorsForm)); })("keyup.enter", function HospitalIndemnityFactorModalComponent_Template_vnext_status_button_keyup_enter_11_listener() { i0.ɵɵrestoreView(_r1); const _r0 = i0.ɵɵreference(5); return i0.ɵɵresetView(ctx.onViewPlans(_r0 == null ? null : _r0.rateFactorsForm)); });
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("spaPageSubHeader", ctx.rateFactorFormPromptText)("spaPageTitle", ctx.rateFactorFormPageTitleText)("isEmbedded", true)("errorKeywordText", ctx.errorKeywordText)("errorNoticeTitle", ctx.errorNoticeTitle)("dropdownDefaultText", ctx.dropdownDefaultText);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.cancelButtonText, " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("buttonClass", "Spa_Style_PrimaryButton width-full width-md-initial")("buttonText", ctx.viewPlansButtonText);
    } }, dependencies: [HospitalIndemnityFormComponent, StatusButtonComponent, ModalHeaderComponent], styles: [".button-container[_ngcontent-%COMP%]{min-width:150px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HospitalIndemnityFactorModalComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"cancel()\"></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body\">\r\n  <div class=\"row\">\r\n    <div class=\"col-12\">\r\n      <vnext-hospital-indemnity-form\r\n        #hospitalIndemnityForm\r\n        [spaPageSubHeader]=\"rateFactorFormPromptText\"\r\n        [spaPageTitle]=\"rateFactorFormPageTitleText\"\r\n        [isEmbedded]=\"true\"\r\n        [errorKeywordText]=\"errorKeywordText\"\r\n        [errorNoticeTitle]=\"errorNoticeTitle\"\r\n        [dropdownDefaultText]=\"dropdownDefaultText\"\r\n        (formClose)=\"onHospitalIndemnityFormClose($event)\"\r\n        (formSubmit)=\"toggleSpinner($event)\"\r\n      ></vnext-hospital-indemnity-form>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer justify-content-start\">\r\n  <button type=\"button\" class=\"btn Spa_Style_SecondaryButton mr-auto\" (click)=\"cancel()\" (keyup.enter)=\"cancel()\">\r\n    {{ cancelButtonText }}\r\n  </button>\r\n  <div class=\"d-flex justify-content-end\">\r\n    <div class=\"button-container\">\r\n      <vnext-status-button\r\n        [buttonClass]=\"'Spa_Style_PrimaryButton width-full width-md-initial'\"\r\n        [buttonText]=\"viewPlansButtonText\"\r\n        (click)=\"onViewPlans(hospitalIndemnityForm?.rateFactorsForm)\"\r\n        (keyup.enter)=\"onViewPlans(hospitalIndemnityForm?.rateFactorsForm)\"\r\n      >\r\n      </vnext-status-button>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".button-container{min-width:150px}\n"] }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i1.NavigationService }, { type: i1.ConfigResourceService }, { type: i1.PlansService }, { type: PlanListFacadeService }, { type: HospitalIndemnityFormFacade }, { type: PlanCompareFacade }, { type: PlanFacade }, { type: i0.ChangeDetectorRef }]; }, { continueButton: [{
            type: ViewChild,
            args: [StatusButtonComponent]
        }] }); })();

function HtmlConfirmationModalComponent_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function HtmlConfirmationModalComponent_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.cancel()); })("keyup.enter", function HtmlConfirmationModalComponent_button_5_Template_button_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.cancel()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.cancelButton, " ");
} }
function HtmlConfirmationModalComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("keyup.enter", function HtmlConfirmationModalComponent_button_6_Template_button_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.confirm()); })("click", function HtmlConfirmationModalComponent_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.confirm()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.confirmButton, " ");
} }
class HtmlConfirmationModalComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
    }
    cancel() {
        this.activeModal.dismiss();
        if (this.cancelAction) {
            this.cancelAction();
        }
    }
    confirm() {
        this.activeModal.close();
        if (this.confirmAction) {
            this.confirmAction();
        }
    }
}
HtmlConfirmationModalComponent.ɵfac = function HtmlConfirmationModalComponent_Factory(t) { return new (t || HtmlConfirmationModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal)); };
HtmlConfirmationModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HtmlConfirmationModalComponent, selectors: [["ng-component"]], decls: 7, vars: 7, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "modal-body"], [3, "innerHtml"], [1, "modal-footer", "justify-content-between"], ["type", "button", "class", "btn Spa_Style_SecondaryButton", "tabindex", "0", 3, "click", "keyup.enter", 4, "ngIf"], ["type", "button", "tabindex", "0", "class", "btn Spa_Style_PrimaryButton", 3, "keyup.enter", "click", 4, "ngIf"], ["type", "button", "tabindex", "0", 1, "btn", "Spa_Style_SecondaryButton", 3, "click", "keyup.enter"], ["type", "button", "tabindex", "0", 1, "btn", "Spa_Style_PrimaryButton", 3, "keyup.enter", "click"]], template: function HtmlConfirmationModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function HtmlConfirmationModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.cancel(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "div", 2);
        i0.ɵɵpipe(3, "safe");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtemplate(5, HtmlConfirmationModalComponent_button_5_Template, 2, 1, "button", 4);
        i0.ɵɵtemplate(6, HtmlConfirmationModalComponent_button_6_Template, 2, 1, "button", 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.modalHeader);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(3, 4, ctx.modalContent, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.cancelButton);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.confirmButton);
    } }, dependencies: [i1$2.NgIf, ModalHeaderComponent, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HtmlConfirmationModalComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"modalHeader\" (modalTitleCancelAction)=\"cancel()\"></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body\">\r\n  <div [innerHtml]=\"modalContent | safe : 'html'\"></div>\r\n</div>\r\n<div class=\"modal-footer justify-content-between\">\r\n  <button type=\"button\" *ngIf=\"cancelButton\" class=\"btn Spa_Style_SecondaryButton\" tabindex=\"0\" (click)=\"cancel()\" (keyup.enter)=\"cancel()\">\r\n    {{ cancelButton }}\r\n  </button>\r\n  <button\r\n    type=\"button\"\r\n    *ngIf=\"confirmButton\"\r\n    (keyup.enter)=\"confirm()\"\r\n    (click)=\"confirm()\"\r\n    tabindex=\"0\"\r\n    class=\"btn Spa_Style_PrimaryButton\"\r\n  >\r\n    {{ confirmButton }}\r\n  </button>\r\n</div>\r\n" }]
    }], function () { return [{ type: i1$1.NgbActiveModal }]; }, null); })();

function MedicalConditionDrugAlternativesSelectionModalComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "label", 12)(2, "input", 13);
    i0.ɵɵlistener("change", function MedicalConditionDrugAlternativesSelectionModalComponent_div_7_Template_input_change_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const medicalCondition_r1 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.onChangeMedicalCondition(medicalCondition_r1)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const medicalCondition_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", medicalCondition_r1.conditionID);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", medicalCondition_r1.conditionID)("checked", ctx_r0.medicalConditionSelectedId === medicalCondition_r1.conditionID);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", medicalCondition_r1.conditionDisplayName, " ");
} }
class MedicalConditionDrugAlternativesSelectionModalComponent {
    constructor(activeModal, configResourceService, localeService, cdr) {
        this.activeModal = activeModal;
        this.configResourceService = configResourceService;
        this.localeService = localeService;
        this.cdr = cdr;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe({
            next: () => {
                this.updateResourcesText();
                this.cdr.markForCheck();
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    cancel() {
        this.activeModal.dismiss();
    }
    continue() {
        this.activeModal.close(this.medicalConditionSelectedId);
    }
    onChangeMedicalCondition(medicalConditionSelected) {
        this.medicalConditionSelectedId = medicalConditionSelected.conditionID;
    }
    trackByMedicalConditionIdFn(index, medicalCondition) {
        return medicalCondition.conditionID;
    }
    updateResourcesText() {
        this.cancelButtonText = this.configResourceService.getProcessedResourceValue('Spa_Site_Cancel', null, 'Cancel');
        this.continueButtonText = this.configResourceService.getProcessedResourceValue('Spa_Site_Continue', null, 'Continue');
    }
}
MedicalConditionDrugAlternativesSelectionModalComponent.ɵfac = function MedicalConditionDrugAlternativesSelectionModalComponent_Factory(t) { return new (t || MedicalConditionDrugAlternativesSelectionModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
MedicalConditionDrugAlternativesSelectionModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedicalConditionDrugAlternativesSelectionModalComponent, selectors: [["ng-component"]], decls: 14, vars: 10, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "modal-body"], [1, "row"], [1, "col-12"], [1, "mt-1", 3, "innerHTML"], ["class", "mb-1 Spa_Style_Paragraph", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "modal-footer", "justify-content-start"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "mr-auto", 3, "click", "keyup.enter"], [1, "d-flex", "justify-content-end"], [1, "button-container"], [3, "buttonClass", "buttonText", "click", "keyup.enter"], [1, "mb-1", "Spa_Style_Paragraph"], [1, "mt-2", "mb-0", "can-click", 3, "for"], ["type", "radio", "name", "medicalConditions", 1, "mr-1", "mt-2", "can-click", 3, "id", "checked", "change"]], template: function MedicalConditionDrugAlternativesSelectionModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function MedicalConditionDrugAlternativesSelectionModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.cancel(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3);
        i0.ɵɵelement(4, "div", 4);
        i0.ɵɵpipe(5, "safe");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 3);
        i0.ɵɵtemplate(7, MedicalConditionDrugAlternativesSelectionModalComponent_div_7_Template, 4, 4, "div", 5);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(8, "div", 6)(9, "button", 7);
        i0.ɵɵlistener("click", function MedicalConditionDrugAlternativesSelectionModalComponent_Template_button_click_9_listener() { return ctx.cancel(); })("keyup.enter", function MedicalConditionDrugAlternativesSelectionModalComponent_Template_button_keyup_enter_9_listener() { return ctx.cancel(); });
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 8)(12, "div", 9)(13, "vnext-status-button", 10);
        i0.ɵɵlistener("click", function MedicalConditionDrugAlternativesSelectionModalComponent_Template_vnext_status_button_click_13_listener() { return ctx.continue(); })("keyup.enter", function MedicalConditionDrugAlternativesSelectionModalComponent_Template_vnext_status_button_keyup_enter_13_listener() { return ctx.continue(); });
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(5, 7, ctx.conditionPrescribedForText, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.medicalConditions)("ngForTrackBy", ctx.trackByMedicalConditionIdFn);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.cancelButtonText, " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("buttonClass", "Spa_Style_PrimaryButton width-full width-md-initial")("buttonText", ctx.continueButtonText);
    } }, dependencies: [i1$2.NgForOf, StatusButtonComponent, ModalHeaderComponent, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedicalConditionDrugAlternativesSelectionModalComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"cancel()\"></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body\">\r\n  <div class=\"row\">\r\n    <div class=\"col-12\">\r\n      <div class=\"mt-1\" [innerHTML]=\"conditionPrescribedForText | safe : 'html'\"></div>\r\n    </div>\r\n\r\n    <div class=\"col-12\">\r\n      <div\r\n        class=\"mb-1 Spa_Style_Paragraph\"\r\n        *ngFor=\"let medicalCondition of medicalConditions; index as i; trackBy: trackByMedicalConditionIdFn\"\r\n      >\r\n        <label class=\"mt-2 mb-0 can-click\" [for]=\"medicalCondition.conditionID\">\r\n          <input\r\n            type=\"radio\"\r\n            class=\"mr-1 mt-2 can-click\"\r\n            name=\"medicalConditions\"\r\n            [id]=\"medicalCondition.conditionID\"\r\n            [checked]=\"medicalConditionSelectedId === medicalCondition.conditionID\"\r\n            (change)=\"onChangeMedicalCondition(medicalCondition)\"\r\n          />\r\n          {{ medicalCondition.conditionDisplayName }}\r\n        </label>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer justify-content-start\">\r\n  <button type=\"button\" class=\"btn Spa_Style_SecondaryButton mr-auto\" (click)=\"cancel()\" (keyup.enter)=\"cancel()\">\r\n    {{ cancelButtonText }}\r\n  </button>\r\n  <div class=\"d-flex justify-content-end\">\r\n    <div class=\"button-container\">\r\n      <vnext-status-button\r\n        [buttonClass]=\"'Spa_Style_PrimaryButton width-full width-md-initial'\"\r\n        [buttonText]=\"continueButtonText\"\r\n        (click)=\"continue()\"\r\n        (keyup.enter)=\"continue()\"\r\n      >\r\n      </vnext-status-button>\r\n    </div>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i1.ConfigResourceService }, { type: i1.LocaleService }, { type: i0.ChangeDetectorRef }]; }, null); })();

class RetireFloSurveyModalComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
    }
    cancel() {
        this.activeModal.dismiss();
        if (this.cancelAction) {
            this.cancelAction();
        }
    }
    confirm() {
        this.activeModal.close();
        if (this.confirmAction) {
            this.confirmAction();
        }
    }
}
RetireFloSurveyModalComponent.ɵfac = function RetireFloSurveyModalComponent_Factory(t) { return new (t || RetireFloSurveyModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal)); };
RetireFloSurveyModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RetireFloSurveyModalComponent, selectors: [["vnext-retire-flo-survey"]], decls: 5, vars: 7, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "modal-body"], [3, "innerHtml"], [3, "cancelButtonText", "primaryButtonText", "cancelButtonAction", "primaryButtonAction"]], template: function RetireFloSurveyModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function RetireFloSurveyModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.activeModal.dismiss(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "div", 2);
        i0.ɵɵpipe(3, "safe");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "vnext-widget-modal-footer", 3);
        i0.ɵɵlistener("cancelButtonAction", function RetireFloSurveyModalComponent_Template_vnext_widget_modal_footer_cancelButtonAction_4_listener() { return ctx.cancel(); })("primaryButtonAction", function RetireFloSurveyModalComponent_Template_vnext_widget_modal_footer_primaryButtonAction_4_listener() { return ctx.confirm(); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(3, 4, ctx.htmlContent, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("cancelButtonText", ctx.cancelButton)("primaryButtonText", ctx.confirmButton);
    } }, dependencies: [ModalFooterComponent, ModalHeaderComponent, SafePipe], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RetireFloSurveyModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-retire-flo-survey', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"activeModal.dismiss()\"></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body\">\r\n  <div [innerHtml]=\"htmlContent | safe : 'html'\"></div>\r\n</div>\r\n\r\n<vnext-widget-modal-footer\r\n  [cancelButtonText]=\"cancelButton\"\r\n  [primaryButtonText]=\"confirmButton\"\r\n  (cancelButtonAction)=\"cancel()\"\r\n  (primaryButtonAction)=\"confirm()\"\r\n></vnext-widget-modal-footer>\r\n" }]
    }], function () { return [{ type: i1$1.NgbActiveModal }]; }, null); })();

function SendRetireFloModalComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "h2", 16);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.sendRetireFloToHeader, " ");
} }
function SendRetireFloModalComponent_div_8_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r7.firstNameRequiredError);
} }
function SendRetireFloModalComponent_div_8_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r8.firstNameInvalidError);
} }
function SendRetireFloModalComponent_div_8_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelement(1, "i", 26);
    i0.ɵɵtemplate(2, SendRetireFloModalComponent_div_8_div_2_span_2_Template, 2, 1, "span", 6);
    i0.ɵɵtemplate(3, SendRetireFloModalComponent_div_8_div_2_span_3_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.retireFloForm.controls.firstName.errors == null ? null : ctx_r5.retireFloForm.controls.firstName.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.retireFloForm.controls.firstName.errors == null ? null : ctx_r5.retireFloForm.controls.firstName.errors.minlength);
} }
function SendRetireFloModalComponent_div_8_div_9_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r9.lastNameRequiredError);
} }
function SendRetireFloModalComponent_div_8_div_9_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r10.lastNameInvalidError);
} }
function SendRetireFloModalComponent_div_8_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelement(1, "i", 26);
    i0.ɵɵtemplate(2, SendRetireFloModalComponent_div_8_div_9_span_2_Template, 2, 1, "span", 6);
    i0.ɵɵtemplate(3, SendRetireFloModalComponent_div_8_div_9_span_3_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r6.retireFloForm.controls.lastName.errors == null ? null : ctx_r6.retireFloForm.controls.lastName.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.retireFloForm.controls.lastName.errors == null ? null : ctx_r6.retireFloForm.controls.lastName.errors.minlength);
} }
function SendRetireFloModalComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17)(1, "div", 5);
    i0.ɵɵtemplate(2, SendRetireFloModalComponent_div_8_div_2_Template, 4, 2, "div", 18);
    i0.ɵɵelementStart(3, "label", 19)(4, "span", 20);
    i0.ɵɵtext(5, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "input", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 5);
    i0.ɵɵtemplate(9, SendRetireFloModalComponent_div_8_div_9_Template, 4, 2, "div", 22);
    i0.ɵɵelementStart(10, "label", 23)(11, "span", 20);
    i0.ɵɵtext(12, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "input", 24);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.retireFloForm.controls.firstName.valid && (ctx_r1.retireFloForm.controls.firstName.dirty || ctx_r1.retireFloForm.controls.firstName.touched));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.modalFirstNameLabelText);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.retireFloForm.controls.lastName.valid && (ctx_r1.retireFloForm.controls.lastName.dirty || ctx_r1.retireFloForm.controls.lastName.touched));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.modalLastNameLabelText);
} }
function SendRetireFloModalComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28)(1, "div", 29);
    i0.ɵɵelement(2, "i", 26);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r2.checkBoxRequiredError);
} }
function SendRetireFloModalComponent_div_13_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r13.emailRequiredError);
} }
function SendRetireFloModalComponent_div_13_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r14.emailInvalidError);
} }
function SendRetireFloModalComponent_div_13_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelement(1, "i", 26);
    i0.ɵɵtemplate(2, SendRetireFloModalComponent_div_13_div_1_span_2_Template, 2, 1, "span", 6);
    i0.ɵɵtemplate(3, SendRetireFloModalComponent_div_13_div_1_span_3_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r11.retireFloForm.controls.emailAddress.errors == null ? null : ctx_r11.retireFloForm.controls.emailAddress.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.retireFloForm.controls.emailAddress.errors == null ? null : ctx_r11.retireFloForm.controls.emailAddress.errors.email);
} }
function SendRetireFloModalComponent_div_13_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37)(1, "label", 38)(2, "input", 39);
    i0.ɵɵlistener("click", function SendRetireFloModalComponent_div_13_div_2_Template_input_click_2_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r15.toggleEmailCheckBox()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.modalEmailCheckboxLabelText, " ");
} }
const _c0$3t = function (a0) { return { "no-gutters": a0 }; };
const _c1$1Q = function (a0, a1) { return { "col-sm-auto col-md-6": a0, "col": a1 }; };
function SendRetireFloModalComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, SendRetireFloModalComponent_div_13_div_1_Template, 4, 2, "div", 31);
    i0.ɵɵtemplate(2, SendRetireFloModalComponent_div_13_div_2_Template, 4, 1, "div", 32);
    i0.ɵɵelementStart(3, "div", 33)(4, "label", 34)(5, "span", 20);
    i0.ɵɵtext(6, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "input", 35);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0$3t, !ctx_r3.showCreateNewProfileForm));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.retireFloForm.controls.emailAddress.errors && ctx_r3.retireFloForm.controls.emailAddress.touched);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.showCheckBoxes);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c1$1Q, ctx_r3.showCreateNewProfileForm, !ctx_r3.showCreateNewProfileForm));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r3.modalEmailLabelText);
} }
function SendRetireFloModalComponent_div_14_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r20.phoneRequiredError);
} }
function SendRetireFloModalComponent_div_14_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r21.phoneInvalidError);
} }
function SendRetireFloModalComponent_div_14_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵelement(1, "i", 26);
    i0.ɵɵtemplate(2, SendRetireFloModalComponent_div_14_div_2_span_2_Template, 2, 1, "span", 6);
    i0.ɵɵtemplate(3, SendRetireFloModalComponent_div_14_div_2_span_3_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r17.retireFloForm.controls.phone.errors == null ? null : ctx_r17.retireFloForm.controls.phone.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.retireFloForm.controls.phone.errors == null ? null : ctx_r17.retireFloForm.controls.phone.errors.pattern);
} }
function SendRetireFloModalComponent_div_14_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37)(1, "label", 46)(2, "input", 47);
    i0.ɵɵlistener("click", function SendRetireFloModalComponent_div_14_div_3_Template_input_click_2_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r22.togglePhoneCheckBox()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r18.modalPhoneCheckboxLabelText, " ");
} }
function SendRetireFloModalComponent_div_14_div_10_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 50);
    i0.ɵɵelement(1, "i", 26);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r24.attestationRequiredError);
} }
function SendRetireFloModalComponent_div_14_div_10_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 51)(1, "label", 52)(2, "input", 53);
    i0.ɵɵlistener("click", function SendRetireFloModalComponent_div_14_div_10_div_2_Template_input_click_2_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r26.toggleAttestationCheckBox()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 54);
    i0.ɵɵtext(4, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("", ctx_r25.modalAttestationLabelText, " ");
} }
const _c2$17 = function (a0, a1) { return { "mt-3": a0, "no-gutters": a1 }; };
function SendRetireFloModalComponent_div_14_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵtemplate(1, SendRetireFloModalComponent_div_14_div_10_div_1_Template, 4, 1, "div", 48);
    i0.ɵɵtemplate(2, SendRetireFloModalComponent_div_14_div_10_div_2_Template, 6, 1, "div", 49);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c2$17, ctx_r19.showEmail, !ctx_r19.showCreateNewProfileForm));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.hasAttestationRequiredError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.showCheckBoxes);
} }
function SendRetireFloModalComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 40);
    i0.ɵɵtemplate(2, SendRetireFloModalComponent_div_14_div_2_Template, 4, 2, "div", 41);
    i0.ɵɵtemplate(3, SendRetireFloModalComponent_div_14_div_3_Template, 4, 1, "div", 32);
    i0.ɵɵelementStart(4, "div", 33)(5, "label", 42)(6, "span", 20);
    i0.ɵɵtext(7, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "input", 43);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, SendRetireFloModalComponent_div_14_div_10_Template, 3, 6, "div", 44);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c2$17, ctx_r4.showEmail, !ctx_r4.showCreateNewProfileForm));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.retireFloForm.controls.phone.errors && ctx_r4.retireFloForm.controls.phone.touched);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.showCheckBoxes);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c1$1Q, ctx_r4.showCreateNewProfileForm, !ctx_r4.showCreateNewProfileForm));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r4.modalPhoneLabelText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("maxLength", ctx_r4.phoneMask.length)("mask", ctx_r4.phoneMask);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.phoneCheckbox.value);
} }
class SendRetireFloModalComponent {
    constructor(activeModal, cdr, profileService, formValidationService, configResourceService, sessionService) {
        this.activeModal = activeModal;
        this.cdr = cdr;
        this.profileService = profileService;
        this.formValidationService = formValidationService;
        this.configResourceService = configResourceService;
        this.sessionService = sessionService;
        this.modalTitleText = 'Send RetireFlo';
        this.showCreateNewProfileForm = false;
        this.showProfileNames = true;
        this.showEmail = true;
        this.showPhone = true;
        this.showEmailAndPhoneCheckbox = true;
        this.hasCheckboxRequiredError = false;
        this.hasAttestationRequiredError = false;
        this.isNewMember = false;
        this.isAttestationCheckboxChecked = false;
    }
    ngOnInit() {
        this.setModalTexts();
        this.initializeForm();
    }
    closeSendRetireFloModal() {
        this.activeModal.dismiss();
    }
    onSendRetireFlo() {
        // Mark each of the controls as touched to trigger validation.
        this.checkEmailOrPhone();
        if (!this.hasCheckboxRequiredError && !this.hasAttestationRequiredError) {
            this.validateCreateProfileControls();
            if (this.retireFloForm.valid) {
                const emailAddressCheckboxValue = this.retireFloForm.controls.emailAddressCheckbox.value;
                const emailAddress = emailAddressCheckboxValue || !this.showCheckBoxes ? this.retireFloForm.controls.emailAddress.value : null;
                const phoneCheckboxValue = this.retireFloForm.controls.phoneCheckbox.value;
                const phoneNumber = phoneCheckboxValue || this.showCreateNewProfileForm ? this.retireFloForm.controls.phone.value : null;
                const formData = {
                    userAgentGUID: this.sessionService.getAgentInContextGuid(),
                    emailAddress,
                    phoneNumber,
                    introText: this.retireFloForm.controls.additionalMessage.value,
                    isNewMember: this.isNewMember,
                    firstName: this.retireFloForm.controls.firstName.value,
                    lastName: this.retireFloForm.controls.lastName.value
                };
                this.activeModal.close(formData);
            }
        }
    }
    checkEmailOrPhone() {
        if (this.showCheckBoxes) {
            const phoneCheckbox = this.retireFloForm.controls.phoneCheckbox;
            const emailCheckbox = this.retireFloForm.controls.emailAddressCheckbox;
            const attestationCheckbox = this.retireFloForm.controls.attestationCheckbox;
            if (phoneCheckbox.value || emailCheckbox.value) {
                this.hasCheckboxRequiredError = false;
                if (emailCheckbox.value && !this.retireFloForm.controls.emailAddress.valid) {
                    this.retireFloForm.controls.emailAddress.markAsTouched({ onlySelf: true });
                }
                if (phoneCheckbox.value) {
                    this.hasAttestationRequiredError = !attestationCheckbox.value;
                    if (!this.retireFloForm.controls.phone.valid) {
                        this.retireFloForm.controls.phone.markAsTouched({ onlySelf: true });
                    }
                }
            }
            else {
                this.hasCheckboxRequiredError = true;
            }
        }
    }
    toggleAttestationCheckBox() {
        const attestationCheckbox = this.retireFloForm.controls.attestationCheckbox;
        const updatedCheckboxValue = !attestationCheckbox.value;
        attestationCheckbox.setValue(updatedCheckboxValue);
        if (attestationCheckbox.value) {
            this.hasAttestationRequiredError = false;
        }
        this.cdr.markForCheck();
    }
    toggleEmailCheckBox() {
        const emailCheckbox = this.retireFloForm.controls.emailAddressCheckbox;
        const email = this.retireFloForm.controls.emailAddress;
        if (emailCheckbox.value) {
            this.hasCheckboxRequiredError = false;
        }
        const updatedCheckboxValue = !emailCheckbox.value;
        emailCheckbox.setValue(updatedCheckboxValue);
        updatedCheckboxValue ? email.enable() : email.disable();
        this.cdr.markForCheck();
    }
    togglePhoneCheckBox() {
        const phone = this.retireFloForm.controls.phone;
        const attestationCheckbox = this.retireFloForm.controls.attestationCheckbox;
        if (this.phoneCheckbox.value) {
            this.hasCheckboxRequiredError = false;
        }
        const updatedCheckboxValue = !this.phoneCheckbox.value;
        this.phoneCheckbox.setValue(updatedCheckboxValue);
        if (updatedCheckboxValue) {
            phone.enable();
            attestationCheckbox.enable();
        }
        else {
            phone.disable();
            attestationCheckbox.disable();
        }
        this.cdr.markForCheck();
    }
    validateCreateProfileControls() {
        if (this.showCreateNewProfileForm) {
            Object.values(this.retireFloForm.controls)
                .filter(control => control.enabled)
                .forEach(control => {
                control.markAsTouched({ onlySelf: true });
            });
        }
    }
    setModalTexts() {
        this.modalCancelText = this.configResourceService.getProcessedResourceValue('Spa_Site_Cancel', '', 'Cancel');
        this.modalSendFormText = this.configResourceService.getProcessedResourceValue('Spa_RetireFlo_NewIntake_SendButton_Text');
        this.modalEmailLabelText = this.configResourceService.getProcessedResourceValue('Spa_Site_EmailAddress_Text', '', 'Email address');
        this.sendRetireFloToHeader = this.configResourceService.getProcessedResourceValue('Spa_RetireFlo_SendRetireFlo_Header', '', 'Send Servey to <name>');
        this.modalPhoneLabelText = this.configResourceService.getProcessedResourceValue('Spa_Site_Primary_Text', '', 'Primary phone number');
        this.modalFirstNameLabelText = this.configResourceService.getProcessedResourceValue('Spa_RetireFlo_NewIntake_FirstName_Text');
        this.modalLastNameLabelText = this.configResourceService.getProcessedResourceValue('Spa_RetireFlo_NewIntake_LastName_Text');
        this.modalAdditionalTitle = this.configResourceService.getProcessedResourceValue('Spa_RetireFlo_NewIntake_CustomMessage_Header_Text', '', 'Intro text');
        this.modalPromptText = this.configResourceService.getProcessedResourceValue('Spa_RetireFlo_NewIntake_DeliveryMethod_Text');
        this.modalEmailCheckboxLabelText = this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_EmailCheckBox_Prompt', '', 'Email');
        this.modalPhoneCheckboxLabelText = this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_PhoneCheckBox_Prompt', '', 'Text');
        this.modalAttestationLabelText = this.configResourceService.getProcessedResourceValue('Spa_RetireFlo_Attestation_Text', '', 'I confirm that I am operating in compliance with applicable SMS laws and regulations');
        this.phoneMask = FormValidationService.phoneMask;
        this.emailRequiredError = this.formValidationService.errorMessages.requiredEmail();
        this.emailInvalidError = this.formValidationService.errorMessages.invalidEmail();
        this.firstNameRequiredError = this.formValidationService.errorMessages.requiredFirstName();
        this.firstNameInvalidError = this.formValidationService.errorMessages.minCharacters2();
        this.lastNameRequiredError = this.formValidationService.errorMessages.requiredLastName();
        this.lastNameInvalidError = this.formValidationService.errorMessages.minCharacters2();
        this.phoneRequiredError = this.formValidationService.errorMessages.requiredPhone();
        this.phoneInvalidError = this.formValidationService.errorMessages.invalidPhone();
        this.attestationRequiredError = this.configResourceService.getProcessedResourceValue('Spa_RetireFlo_AttestationRequired_Error_Text', '', 'Please review and check the attestation checkbox');
        this.checkBoxRequiredError = this.configResourceService.getProcessedResourceValue('Spa_RetireFlo_CheckBoxRequired_Error_Text', '', 'Select at least one option to send intake form.');
    }
    initializeForm() {
        const memberProfileData = this.sessionService.getMemberSession();
        this.showCheckBoxes = this.showEmailAndPhoneCheckbox && this.showEmail && this.showPhone;
        this.showCreateNewProfileForm = this.isNewMember;
        this.showProfileNames = this.profileService.hasMemberProfile() && !this.isNewMember;
        const profileEmailAddress = this.showProfileNames ? memberProfileData.profile.emailAddress : null;
        const profileFirstName = this.showProfileNames ? memberProfileData.profile.firstName : null;
        const profileLastName = this.showProfileNames ? memberProfileData.profile.lastName : null;
        const profilePhone = this.showProfileNames ? this.profileService.getPrimaryPhoneNumber(memberProfileData) : null;
        const isEmailCheckboxChecked = this.showCheckBoxes ? !!profileEmailAddress : this.showEmail;
        const isPhoneCheckboxChecked = this.showCheckBoxes ? !!profilePhone : this.showPhone;
        const defaultAdditionalMessage = this.modalAdditionalDefaultMessage;
        this.retireFloForm = new UntypedFormGroup({
            emailAddress: new UntypedFormControl({ value: profileEmailAddress, disabled: !isEmailCheckboxChecked }, [
                Validators.required,
                Validators.email
            ]),
            emailAddressCheckbox: new UntypedFormControl(isEmailCheckboxChecked),
            phone: new UntypedFormControl({
                value: profilePhone,
                disabled: !this.isPhoneFieldEnabled(isPhoneCheckboxChecked)
            }, [Validators.pattern(RegexPattern.US_TELEPHONE), Validators.required, Validators.maxLength(this.phoneMask.length)]),
            phoneCheckbox: new UntypedFormControl(isPhoneCheckboxChecked),
            attestationCheckbox: new UntypedFormControl({
                value: false,
                disabled: !this.isPhoneFieldEnabled(isPhoneCheckboxChecked)
            }, [Validators.required]),
            firstName: new UntypedFormControl({ value: profileFirstName, disabled: !this.showCreateNewProfileForm }, [
                Validators.required,
                Validators.minLength(2),
                Validators.pattern(FormValidationService.nonWhiteSpacePattern)
            ]),
            lastName: new UntypedFormControl({ value: profileLastName, disabled: !this.showCreateNewProfileForm }, [
                Validators.required,
                Validators.minLength(2),
                Validators.pattern(FormValidationService.nonWhiteSpacePattern)
            ]),
            additionalMessage: new UntypedFormControl(defaultAdditionalMessage)
        }, { updateOn: 'blur' });
        this.phoneCheckbox = this.retireFloForm.controls.phoneCheckbox;
        if (this.showProfileNames) {
            this.sendRetireFloToHeader = this.sendRetireFloToHeader.replace('<name>', this.profileService.getMemberFullName());
        }
    }
    isPhoneFieldEnabled(isPhoneCheckboxChecked) {
        // If showPhone is set we know that we are on the send enrollment and not quick RetireFlo path.
        if (this.showPhone) {
            return isPhoneCheckboxChecked;
        }
        return this.showCreateNewProfileForm;
    }
}
SendRetireFloModalComponent.ɵfac = function SendRetireFloModalComponent_Factory(t) { return new (t || SendRetireFloModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.ProfileService), i0.ɵɵdirectiveInject(i1.FormValidationService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.MemberSessionService)); };
SendRetireFloModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SendRetireFloModalComponent, selectors: [["ng-component"]], decls: 25, vars: 14, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "form-group", "modal-body"], [3, "formGroup"], [1, "mt-0"], [1, "row", "mb-3"], [1, "col"], [4, "ngIf"], ["class", "row mt-3 align-items-end", 4, "ngIf"], [1, "row", "mb-3", "mt-2"], ["class", "row", 4, "ngIf"], ["class", "row align-items-center mt-3", 3, "ngClass", 4, "ngIf"], [1, "mt-3"], ["for", "additionalMessage", 1, "Spa_Style_Label"], [1, "Spa_Style_H5"], ["id", "additionalMessage", "type", "text", "rows", "5", "maxlength", "500", "formControlName", "additionalMessage", 1, "form-control", "mt-2", 3, "value"], [3, "cancelButtonText", "primaryButtonText", "cancelButtonAction", "primaryButtonAction"], [1, "Spa_Style_H2"], [1, "row", "mt-3", "align-items-end"], ["id", "firstNameError", "class", "error-container", "role", "alert", 4, "ngIf"], ["for", "firstName", 1, "Spa_Style_Label"], ["aria-hidden", "true", 1, "input-error-asterisk"], ["id", "firstName", "aria-required", "true", "type", "text", "formControlName", "firstName", 1, "form-control"], ["id", "lastNameError", "class", "error-container", "role", "alert", 4, "ngIf"], ["for", "lastName", 1, "Spa_Style_Label"], ["id", "lastName", "aria-required", "true", "type", "text", "formControlName", "lastName", 1, "form-control"], ["id", "firstNameError", "role", "alert", 1, "error-container"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], ["id", "lastNameError", "role", "alert", 1, "error-container"], [1, "row"], ["role", "alert", 1, "col", "error-container"], [1, "row", "align-items-center", "mt-3", 3, "ngClass"], ["id", "emailAddressError", "class", "error-container col-12", "role", "alert", 4, "ngIf"], ["class", "col-2 mr-1 Spa_Style_Paragraph", 4, "ngIf"], [3, "ngClass"], ["for", "emailAddress", 1, "Spa_Style_Label"], ["id", "emailAddress", "aria-required", "true", "ngbAutofocus", "", "type", "email", "formControlName", "emailAddress", 1, "form-control"], ["id", "emailAddressError", "role", "alert", 1, "error-container", "col-12"], [1, "col-2", "mr-1", "Spa_Style_Paragraph"], ["for", "emailAddressCheckbox"], ["id", "emailAddressCheckbox", "type", "checkbox", "formControlName", "emailAddressCheckbox", 3, "click"], [1, "row", "align-items-center", 3, "ngClass"], ["id", "phoneError", "class", "error-container col-12", "role", "alert", 4, "ngIf"], ["for", "phone", 1, "Spa_Style_Label"], ["id", "phone", "aria-required", "true", "ngbAutofocus", "", "type", "text", "formControlName", "phone", 1, "form-control", 3, "maxLength", "mask"], ["class", "row align-items-center", 3, "ngClass", 4, "ngIf"], ["id", "phoneError", "role", "alert", 1, "error-container", "col-12"], ["for", "phoneCheckbox"], ["id", "phoneCheckbox", "type", "checkbox", "formControlName", "phoneCheckbox", 3, "click"], ["class", "error-container col-12", "role", "alert", 4, "ngIf"], ["class", "col Spa_Style_Paragraph", 4, "ngIf"], ["role", "alert", 1, "error-container", "col-12"], [1, "col", "Spa_Style_Paragraph"], ["for", "attestationCheckbox"], ["id", "attestationCheckbox", "type", "checkbox", "formControlName", "attestationCheckbox", 3, "click"], ["aria-hidden", "true", 1, "input-error-asterisk", "ml-1"]], template: function SendRetireFloModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function SendRetireFloModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.closeSendRetireFloModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1)(2, "form", 2)(3, "div", 3)(4, "div", 4)(5, "div", 5);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(7, SendRetireFloModalComponent_div_7_Template, 3, 1, "div", 6);
        i0.ɵɵtemplate(8, SendRetireFloModalComponent_div_8_Template, 15, 4, "div", 7);
        i0.ɵɵelementStart(9, "div", 8)(10, "div", 5);
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(12, SendRetireFloModalComponent_div_12_Template, 5, 1, "div", 9);
        i0.ɵɵtemplate(13, SendRetireFloModalComponent_div_13_Template, 9, 10, "div", 10);
        i0.ɵɵtemplate(14, SendRetireFloModalComponent_div_14_Template, 11, 14, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "div", 11)(16, "label", 12)(17, "span");
        i0.ɵɵtext(18);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(19, "div")(20, "h5", 13)(21, "span");
        i0.ɵɵtext(22);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(23, "textarea", 14);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(24, "vnext-widget-modal-footer", 15);
        i0.ɵɵlistener("cancelButtonAction", function SendRetireFloModalComponent_Template_vnext_widget_modal_footer_cancelButtonAction_24_listener() { return ctx.closeSendRetireFloModal(); })("primaryButtonAction", function SendRetireFloModalComponent_Template_vnext_widget_modal_footer_primaryButtonAction_24_listener() { return ctx.onSendRetireFlo(); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.modalTitleText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("formGroup", ctx.retireFloForm);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.modalDescriptiveText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showProfileNames);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showCreateNewProfileForm);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.modalPromptText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasCheckboxRequiredError);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showEmail);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showPhone);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.modalAdditionalTitle);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.modalAdditionalSubText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("value", ctx.modalAdditionalDefaultMessage);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("cancelButtonText", ctx.modalCancelText)("primaryButtonText", ctx.modalSendFormText);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.CheckboxControlValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.MaxLengthValidator, i4.FormGroupDirective, i4.FormControlName, i8.MaskDirective, IconAriaAttributesDirective, ModalFooterComponent, ModalHeaderComponent], styles: [".modal-body[_ngcontent-%COMP%]{max-height:70vh;overflow-y:auto;margin-bottom:0}.form-control[_ngcontent-%COMP%]:disabled{color:var(--static-Spa_Style_Accent1)}@media (max-width: 992px){.modal-body[_ngcontent-%COMP%]{max-height:none}}.btn.Spa_Style_Link[_ngcontent-%COMP%]{font-size:14px!important;margin-top:-10px}.error-container[_ngcontent-%COMP%]{min-height:35px;max-height:35px;line-height:18px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SendRetireFloModalComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header\r\n  [modalTitleText]=\"modalTitleText\"\r\n  (modalTitleCancelAction)=\"closeSendRetireFloModal()\"\r\n></vnext-widget-modal-header>\r\n<div class=\"form-group modal-body\">\r\n  <form [formGroup]=\"retireFloForm\">\r\n    <div class=\"mt-0\">\r\n      <div class=\"row mb-3\">\r\n        <div class=\"col\">{{ modalDescriptiveText }}</div>\r\n      </div>\r\n      <div *ngIf=\"showProfileNames\">\r\n        <h2 class=\"Spa_Style_H2\">\r\n          {{ sendRetireFloToHeader }}\r\n        </h2>\r\n      </div>\r\n      <div *ngIf=\"showCreateNewProfileForm\" class=\"row mt-3 align-items-end\">\r\n        <div class=\"col\">\r\n          <div\r\n            id=\"firstNameError\"\r\n            *ngIf=\"\r\n              !retireFloForm.controls.firstName.valid &&\r\n              (retireFloForm.controls.firstName.dirty || retireFloForm.controls.firstName.touched)\r\n            \"\r\n            class=\"error-container\"\r\n            role=\"alert\"\r\n          >\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span *ngIf=\"retireFloForm.controls.firstName.errors?.required\">{{ firstNameRequiredError }}</span>\r\n            <span *ngIf=\"retireFloForm.controls.firstName.errors?.minlength\">{{ firstNameInvalidError }}</span>\r\n          </div>\r\n          <label class=\"Spa_Style_Label\" for=\"firstName\">\r\n            <span class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>{{ modalFirstNameLabelText }}</label\r\n          >\r\n          <input id=\"firstName\" aria-required=\"true\" type=\"text\" class=\"form-control\" formControlName=\"firstName\" />\r\n        </div>\r\n        <div class=\"col\">\r\n          <div\r\n            id=\"lastNameError\"\r\n            *ngIf=\"\r\n              !retireFloForm.controls.lastName.valid && (retireFloForm.controls.lastName.dirty || retireFloForm.controls.lastName.touched)\r\n            \"\r\n            class=\"error-container\"\r\n            role=\"alert\"\r\n          >\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span *ngIf=\"retireFloForm.controls.lastName.errors?.required\">{{ lastNameRequiredError }}</span>\r\n            <span *ngIf=\"retireFloForm.controls.lastName.errors?.minlength\">{{ lastNameInvalidError }}</span>\r\n          </div>\r\n          <label class=\"Spa_Style_Label\" for=\"lastName\"\r\n            ><span class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>{{ modalLastNameLabelText }}</label\r\n          >\r\n          <input id=\"lastName\" aria-required=\"true\" type=\"text\" class=\"form-control\" formControlName=\"lastName\" />\r\n        </div>\r\n      </div>\r\n      <div class=\"row mb-3 mt-2\">\r\n        <div class=\"col\">{{ modalPromptText }}</div>\r\n      </div>\r\n      <div class=\"row\" *ngIf=\"hasCheckboxRequiredError\">\r\n        <div class=\"col error-container\" role=\"alert\">\r\n          <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n          <span>{{ checkBoxRequiredError }}</span>\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"showEmail\" class=\"row align-items-center mt-3\" [ngClass]=\"{ 'no-gutters': !showCreateNewProfileForm }\">\r\n        <div\r\n          id=\"emailAddressError\"\r\n          *ngIf=\"retireFloForm.controls.emailAddress.errors && retireFloForm.controls.emailAddress.touched\"\r\n          class=\"error-container col-12\"\r\n          role=\"alert\"\r\n        >\r\n          <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n          <span *ngIf=\"retireFloForm.controls.emailAddress.errors?.required\">{{ emailRequiredError }}</span>\r\n          <span *ngIf=\"retireFloForm.controls.emailAddress.errors?.email\">{{ emailInvalidError }}</span>\r\n        </div>\r\n        <div *ngIf=\"showCheckBoxes\" class=\"col-2 mr-1 Spa_Style_Paragraph\">\r\n          <label for=\"emailAddressCheckbox\">\r\n            <input id=\"emailAddressCheckbox\" type=\"checkbox\" formControlName=\"emailAddressCheckbox\" (click)=\"toggleEmailCheckBox()\" />\r\n            {{ modalEmailCheckboxLabelText }}\r\n          </label>\r\n        </div>\r\n        <div [ngClass]=\"{ 'col-sm-auto col-md-6': showCreateNewProfileForm, 'col': !showCreateNewProfileForm }\">\r\n          <label class=\"Spa_Style_Label\" for=\"emailAddress\">\r\n            <span class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>{{ modalEmailLabelText }}</label\r\n          >\r\n          <input id=\"emailAddress\" aria-required=\"true\" ngbAutofocus type=\"email\" class=\"form-control\" formControlName=\"emailAddress\" />\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"showPhone\">\r\n        <div class=\"row align-items-center\" [ngClass]=\"{ 'mt-3': showEmail, 'no-gutters': !showCreateNewProfileForm }\">\r\n          <div\r\n            id=\"phoneError\"\r\n            *ngIf=\"retireFloForm.controls.phone.errors && retireFloForm.controls.phone.touched\"\r\n            class=\"error-container col-12\"\r\n            role=\"alert\"\r\n          >\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span *ngIf=\"retireFloForm.controls.phone.errors?.required\">{{ phoneRequiredError }}</span>\r\n            <span *ngIf=\"retireFloForm.controls.phone.errors?.pattern\">{{ phoneInvalidError }}</span>\r\n          </div>\r\n          <div *ngIf=\"showCheckBoxes\" class=\"col-2 mr-1 Spa_Style_Paragraph\">\r\n            <label for=\"phoneCheckbox\">\r\n              <input id=\"phoneCheckbox\" type=\"checkbox\" formControlName=\"phoneCheckbox\" (click)=\"togglePhoneCheckBox()\" />\r\n              {{ modalPhoneCheckboxLabelText }}\r\n            </label>\r\n          </div>\r\n          <div [ngClass]=\"{ 'col-sm-auto col-md-6': showCreateNewProfileForm, 'col': !showCreateNewProfileForm }\">\r\n            <label class=\"Spa_Style_Label\" for=\"phone\">\r\n              <span class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>{{ modalPhoneLabelText }}</label\r\n            >\r\n            <input\r\n              id=\"phone\"\r\n              aria-required=\"true\"\r\n              ngbAutofocus\r\n              type=\"text\"\r\n              class=\"form-control\"\r\n              formControlName=\"phone\"\r\n              [maxLength]=\"phoneMask.length\"\r\n              [mask]=\"phoneMask\"\r\n            />\r\n          </div>\r\n        </div>\r\n        <div *ngIf=\"phoneCheckbox.value\" class=\"row align-items-center\" [ngClass]=\"{ 'mt-3': showEmail, 'no-gutters': !showCreateNewProfileForm }\">\r\n          <div\r\n            *ngIf=\"hasAttestationRequiredError\"\r\n            class=\"error-container col-12\"\r\n            role=\"alert\"\r\n          >\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span>{{ attestationRequiredError }}</span>\r\n          </div>\r\n          <div *ngIf=\"showCheckBoxes\" class=\"col Spa_Style_Paragraph\">\r\n            <label for=\"attestationCheckbox\">\r\n              <input id=\"attestationCheckbox\" type=\"checkbox\" formControlName=\"attestationCheckbox\" (click)=\"toggleAttestationCheckBox()\" />\r\n              <span class=\"input-error-asterisk ml-1\" aria-hidden=\"true\">*</span>{{ modalAttestationLabelText }}\r\n            </label>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"mt-3\">\r\n      <label class=\"Spa_Style_Label\" for=\"additionalMessage\">\r\n        <span>{{ modalAdditionalTitle }}</span>\r\n      </label>\r\n      <div>\r\n        <h5 class=\"Spa_Style_H5\">\r\n          <span>{{ modalAdditionalSubText }}</span>\r\n        </h5>\r\n      </div>\r\n      <textarea\r\n        id=\"additionalMessage\"\r\n        type=\"text\"\r\n        rows=\"5\"\r\n        maxlength=\"500\"\r\n        formControlName=\"additionalMessage\"\r\n        class=\"form-control mt-2\"\r\n        [value]=\"modalAdditionalDefaultMessage\"\r\n      ></textarea>\r\n    </div>\r\n  </form>\r\n</div>\r\n<vnext-widget-modal-footer\r\n  [cancelButtonText]=\"modalCancelText\"\r\n  [primaryButtonText]=\"modalSendFormText\"\r\n  (cancelButtonAction)=\"closeSendRetireFloModal()\"\r\n  (primaryButtonAction)=\"onSendRetireFlo()\"\r\n></vnext-widget-modal-footer>\r\n", styles: [".modal-body{max-height:70vh;overflow-y:auto;margin-bottom:0}.form-control:disabled{color:var(--static-Spa_Style_Accent1)}@media (max-width: 992px){.modal-body{max-height:none}}.btn.Spa_Style_Link{font-size:14px!important;margin-top:-10px}.error-container{min-height:35px;max-height:35px;line-height:18px}\n"] }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i0.ChangeDetectorRef }, { type: i1.ProfileService }, { type: i1.FormValidationService }, { type: i1.ConfigResourceService }, { type: i1.MemberSessionService }]; }, null); })();

function UpdateEffectiveDateModalComponent_button_18_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function UpdateEffectiveDateModalComponent_button_18_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r3); const value_r1 = restoredCtx.$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateDropdownSelection(value_r1)); })("keyup.enter", function UpdateEffectiveDateModalComponent_button_18_Template_button_keyup_enter_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r3); const value_r1 = restoredCtx.$implicit; const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.updateDropdownSelection(value_r1)); });
    i0.ɵɵelementStart(1, "span", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const value_r1 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(value_r1);
} }
class UpdateEffectiveDateModalComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
        this.cancel = () => {
            this.activeModal.dismiss();
            if (this.cancelAction) {
                this.cancelAction();
            }
        };
        this.confirm = () => {
            this.activeModal.close();
            if (this.confirmAction) {
                this.confirmAction(this.selectedValue);
            }
        };
    }
    updateDropdownSelection(value) {
        this.selectedValue = value;
    }
}
UpdateEffectiveDateModalComponent.ɵfac = function UpdateEffectiveDateModalComponent_Factory(t) { return new (t || UpdateEffectiveDateModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal)); };
UpdateEffectiveDateModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UpdateEffectiveDateModalComponent, selectors: [["ng-component"]], decls: 24, vars: 8, consts: [[3, "modalTitleText", "modalTitleCancelAction"], ["role", "popup", 1, "modal-body", "Spa_Style_Primary_Color"], [1, "pb-1"], [1, "pt-2"], [1, "Spa_Style_Bold_Weight", "pb-1"], [1, "input-error-asterisk"], ["ngbDropdown", "", 1, "dropdown-container"], ["id", "effectiveDateDropDown", "role", "combobox", "ngbDropdownToggle", "", 1, "btn", "effective-date-width"], [1, "Spa_Style_Primary_Color"], [1, "fa", "fa-angle-down", "float-right"], [1, "sr-only"], ["ngbDropdownMenu", "", "aria-labelledby", "effectiveDateDropDown", "aria-haspopup", "grid"], ["ngbDropdownItem", "", 3, "click", "keyup.enter", 4, "ngFor", "ngForOf"], [1, "modal-footer", "justify-content-start"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "mr-auto", 3, "click", "keyup.enter"], ["type", "button", 1, "btn", "Spa_Style_PrimaryButton", 3, "click", "keyup.enter"], ["ngbDropdownItem", "", 3, "click", "keyup.enter"]], template: function UpdateEffectiveDateModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function UpdateEffectiveDateModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.cancel(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1)(2, "span", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3)(5, "div", 4)(6, "span", 5);
        i0.ɵɵtext(7, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "span");
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "div", 6)(11, "button", 7)(12, "span", 8);
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "i", 9);
        i0.ɵɵelementStart(15, "span", 10);
        i0.ɵɵtext(16, "Expand menu");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(17, "div", 11);
        i0.ɵɵtemplate(18, UpdateEffectiveDateModalComponent_button_18_Template, 3, 1, "button", 12);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(19, "div", 13)(20, "button", 14);
        i0.ɵɵlistener("click", function UpdateEffectiveDateModalComponent_Template_button_click_20_listener() { return ctx.cancel(); })("keyup.enter", function UpdateEffectiveDateModalComponent_Template_button_keyup_enter_20_listener() { return ctx.cancel(); });
        i0.ɵɵtext(21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "button", 15);
        i0.ɵɵlistener("click", function UpdateEffectiveDateModalComponent_Template_button_click_22_listener() { return ctx.confirm(); })("keyup.enter", function UpdateEffectiveDateModalComponent_Template_button_keyup_enter_22_listener() { return ctx.confirm(); });
        i0.ɵɵtext(23);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.titleText);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.bodyText, " ");
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate(ctx.effectiveDateLabel);
        i0.ɵɵadvance(2);
        i0.ɵɵattribute("aria-label", ctx.selectedValue);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.selectedValue);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngForOf", ctx.effectiveDateDropDownItems);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.cancelButtonText, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.continueButtonText, " ");
    } }, dependencies: [i1$2.NgForOf, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem, IconAriaAttributesDirective, ModalHeaderComponent], styles: [".dropdown-toggle[_ngcontent-%COMP%]{line-height:18px;padding:8px 11px;box-shadow:inset 0 1px 1px #00000013;display:flex;justify-content:space-between;cursor:pointer;-webkit-user-select:none;user-select:none;border-width:1px;border-style:solid;border-color:var(--static-Spa_Style_Accent1);border-radius:5px;height:36px}.dropdown-item[_ngcontent-%COMP%]{cursor:pointer;-webkit-user-select:none;user-select:none}.dropdown-item[_ngcontent-%COMP%]:hover, .dropdown-item[_ngcontent-%COMP%]:focus, .dropdown-item[_ngcontent-%COMP%]:active{background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}.dropdown-toggle[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%]{padding-top:3px}.dropdown-toggle[_ngcontent-%COMP%]:after{content:none}.effective-date-width[_ngcontent-%COMP%]{width:220px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UpdateEffectiveDateModalComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"titleText\" (modalTitleCancelAction)=\"cancel()\"></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body Spa_Style_Primary_Color\" role=\"popup\">\r\n  <span class=\"pb-1\"> {{ bodyText }} </span>\r\n  <div class=\"pt-2\">\r\n    <div class=\"Spa_Style_Bold_Weight pb-1\">\r\n      <span class=\"input-error-asterisk\">*</span><span>{{ effectiveDateLabel }}</span>\r\n    </div>\r\n    <div class=\"dropdown-container\" ngbDropdown>\r\n      <button\r\n        class=\"btn effective-date-width\"\r\n        id=\"effectiveDateDropDown\"\r\n        [attr.aria-label]=\"selectedValue\"\r\n        role=\"combobox\"\r\n        ngbDropdownToggle\r\n      >\r\n        <span class=\"Spa_Style_Primary_Color\">{{ selectedValue }}</span>\r\n        <i class=\"fa fa-angle-down float-right\"></i>\r\n        <span class=\"sr-only\">Expand menu</span>\r\n      </button>\r\n      <div ngbDropdownMenu aria-labelledby=\"effectiveDateDropDown\" aria-haspopup=\"grid\">\r\n        <button\r\n          *ngFor=\"let value of effectiveDateDropDownItems\"\r\n          ngbDropdownItem\r\n          (click)=\"updateDropdownSelection(value)\"\r\n          (keyup.enter)=\"updateDropdownSelection(value)\"\r\n        >\r\n          <span class=\"Spa_Style_Primary_Color\">{{ value }}</span>\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer justify-content-start\">\r\n  <button type=\"button\" class=\"btn Spa_Style_SecondaryButton mr-auto\" (click)=\"cancel()\" (keyup.enter)=\"cancel()\">\r\n    {{ cancelButtonText }}\r\n  </button>\r\n  <button type=\"button\" class=\"btn Spa_Style_PrimaryButton\" (click)=\"confirm()\" (keyup.enter)=\"confirm()\">\r\n    {{ continueButtonText }}\r\n  </button>\r\n</div>\r\n", styles: [".dropdown-toggle{line-height:18px;padding:8px 11px;box-shadow:inset 0 1px 1px #00000013;display:flex;justify-content:space-between;cursor:pointer;-webkit-user-select:none;user-select:none;border-width:1px;border-style:solid;border-color:var(--static-Spa_Style_Accent1);border-radius:5px;height:36px}.dropdown-item{cursor:pointer;-webkit-user-select:none;user-select:none}.dropdown-item:hover,.dropdown-item:focus,.dropdown-item:active{background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}.dropdown-toggle>.fa{padding-top:3px}.dropdown-toggle:after{content:none}.effective-date-width{width:220px}\n"] }]
    }], function () { return [{ type: i1$1.NgbActiveModal }]; }, null); })();

function VoiceSignatureStatementComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "i", 11);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("id", ctx_r0.statement.name + "Error");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.requiredText);
} }
function VoiceSignatureStatementComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r1.statement.preInstructionalText, "html"), i0.ɵɵsanitizeHtml);
} }
function VoiceSignatureStatementComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ul", 13)(2, "li");
    i0.ɵɵelement(3, "div", 14);
    i0.ɵɵpipe(4, "safe");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(4, 1, ctx_r2.statement.value, "html"), i0.ɵɵsanitizeHtml);
} }
const _c0$3s = function (a0) { return { "error-color": a0 }; };
function VoiceSignatureStatementComponent_ng_template_5_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 16)(2, "div", 17)(3, "input", 18);
    i0.ɵɵlistener("change", function VoiceSignatureStatementComponent_ng_template_5_ng_container_0_ng_container_1_Template_input_change_3_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r16.statementToggled()); })("ngModelChange", function VoiceSignatureStatementComponent_ng_template_5_ng_container_0_ng_container_1_Template_input_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r18 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r18.checkboxValue = $event); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(4, "div", 19);
    i0.ɵɵpipe(5, "safe");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", ctx_r13.statement.name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r13.statement.name)("ngModel", ctx_r13.checkboxValue);
    i0.ɵɵattribute("aria-describedby", ctx_r13.fieldHasError ? ctx_r13.statement.name + "Error" : null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0$3s, ctx_r13.fieldHasError))("innerHtml", i0.ɵɵpipeBind2(5, 6, ctx_r13.statement.value, "html"), i0.ɵɵsanitizeHtml);
} }
function VoiceSignatureStatementComponent_ng_template_5_ng_container_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 14);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r15.statement.value, "html"), i0.ɵɵsanitizeHtml);
} }
function VoiceSignatureStatementComponent_ng_template_5_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, VoiceSignatureStatementComponent_ng_template_5_ng_container_0_ng_container_1_Template, 6, 11, "ng-container", 4);
    i0.ɵɵtemplate(2, VoiceSignatureStatementComponent_ng_template_5_ng_container_0_ng_template_2_Template, 2, 4, "ng-template", null, 15, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r14 = i0.ɵɵreference(3);
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.showRadioOrCheckBox)("ngIfElse", _r14);
} }
function VoiceSignatureStatementComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, VoiceSignatureStatementComponent_ng_template_5_ng_container_0_Template, 4, 2, "ng-container", 4);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(8);
    i0.ɵɵproperty("ngIf", ctx_r4.statement.inputType !== "radio")("ngIfElse", _r5);
} }
function VoiceSignatureStatementComponent_ng_template_7_ng_container_0_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c1$1P = function (a0, a1) { return { option: a0, index: a1 }; };
function VoiceSignatureStatementComponent_ng_template_7_ng_container_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, VoiceSignatureStatementComponent_ng_template_7_ng_container_0_div_3_ng_container_1_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r21 = ctx.$implicit;
    const i_r22 = ctx.index;
    const ctx_r20 = i0.ɵɵnextContext(3);
    const _r7 = i0.ɵɵreference(10);
    const _r9 = i0.ɵɵreference(12);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r20.showRadioOrCheckBox ? _r7 : _r9)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c1$1P, option_r21, i_r22));
} }
function VoiceSignatureStatementComponent_ng_template_7_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 21);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵtemplate(3, VoiceSignatureStatementComponent_ng_template_7_ng_container_0_div_3_Template, 2, 5, "div", 22);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$3s, ctx_r19.fieldHasError))("innerHtml", i0.ɵɵpipeBind2(2, 3, ctx_r19.statement.value, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r19.statement.radioOptions);
} }
function VoiceSignatureStatementComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, VoiceSignatureStatementComponent_ng_template_7_ng_container_0_Template, 4, 8, "ng-container", 20);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r6.statement.inputType === "radio");
} }
function VoiceSignatureStatementComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 24)(1, "input", 25);
    i0.ɵɵlistener("change", function VoiceSignatureStatementComponent_ng_template_9_Template_input_change_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r27); const option_r24 = restoredCtx.option; const ctx_r26 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r26.optionSelected(option_r24)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "div", 26);
    i0.ɵɵpipe(3, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r24 = ctx.option;
    const i_r25 = ctx.index;
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("name", ctx_r8.statement.name + "group");
    i0.ɵɵattribute("aria-labelledby", "statementLabelId " + ctx_r8.statement.name + i_r25);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", ctx_r8.statement.name + i_r25)("innerHtml", i0.ɵɵpipeBind2(3, 4, option_r24, "html"), i0.ɵɵsanitizeHtml);
} }
function VoiceSignatureStatementComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 27);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const option_r28 = ctx.option;
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, option_r28, "html"), i0.ɵɵsanitizeHtml);
} }
function VoiceSignatureStatementComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 28);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r11.statement.instructionalText, "html"), i0.ɵɵsanitizeHtml);
} }
class VoiceSignatureStatementComponent {
    constructor() {
        this.showRadioOrCheckBox = false;
        this.isLastStatement = false;
        this.showPlanBenefitRadioOrCheckBox = false;
        this.valueUpdated = new EventEmitter();
        this.checkboxValue = false;
    }
    statementToggled() {
        this.valueUpdated.emit(this.checkboxValue);
    }
    optionSelected(value) {
        this.valueUpdated.emit(value);
    }
}
VoiceSignatureStatementComponent.ɵfac = function VoiceSignatureStatementComponent_Factory(t) { return new (t || VoiceSignatureStatementComponent)(); };
VoiceSignatureStatementComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: VoiceSignatureStatementComponent, selectors: [["vnext-widget-voice-signature-statement"]], inputs: { statement: "statement", requiredText: "requiredText", fieldHasError: "fieldHasError", showRadioOrCheckBox: "showRadioOrCheckBox", isLastStatement: "isLastStatement", showPlanBenefitRadioOrCheckBox: "showPlanBenefitRadioOrCheckBox" }, outputs: { valueUpdated: "valueUpdated" }, decls: 14, vars: 5, consts: [["class", "error-color", "role", "alert", 3, "id", 4, "ngIf"], [1, "row"], [1, "col-12", "Spa_Style_Paragraph"], ["class", "preInstructional-text Spa_Style_Note", 3, "innerHTML", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["showRadioOrCheckBoxTemplates", ""], ["radioTemplate", ""], ["labelTemplate", ""], ["readonlyLabelTemplate", ""], ["class", "instructional-text Spa_Style_Note ml-4 mb-2", 3, "innerHTML", 4, "ngIf"], ["role", "alert", 1, "error-color", 3, "id"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle", "mr-2"], [1, "preInstructional-text", "Spa_Style_Note", 3, "innerHTML"], [1, "voice-signature-statement"], [3, "innerHtml"], ["showReadOnlyLabel", ""], [1, "d-flex", "checkbox-label", 3, "for"], [1, "checkbox-wrapper"], ["aria-required", "true", "type", "checkbox", 1, "mr-2", "can-click", 3, "id", "ngModel", "change", "ngModelChange"], [3, "ngClass", "innerHtml"], [4, "ngIf"], ["id", "statementLabelId", 1, "radio-text", 3, "ngClass", "innerHtml"], [4, "ngFor", "ngForOf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "d-flex"], ["type", "radio", 1, "mr-2", "can-click", 3, "name", "change"], [3, "id", "innerHtml"], [1, "d-flex", 3, "innerHtml"], [1, "instructional-text", "Spa_Style_Note", "ml-4", "mb-2", 3, "innerHTML"]], template: function VoiceSignatureStatementComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, VoiceSignatureStatementComponent_div_0_Template, 4, 2, "div", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, VoiceSignatureStatementComponent_div_3_Template, 2, 4, "div", 3);
        i0.ɵɵtemplate(4, VoiceSignatureStatementComponent_ng_container_4_Template, 5, 4, "ng-container", 4);
        i0.ɵɵtemplate(5, VoiceSignatureStatementComponent_ng_template_5_Template, 1, 2, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(7, VoiceSignatureStatementComponent_ng_template_7_Template, 1, 1, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(9, VoiceSignatureStatementComponent_ng_template_9_Template, 4, 7, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(11, VoiceSignatureStatementComponent_ng_template_11_Template, 2, 4, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(13, VoiceSignatureStatementComponent_div_13_Template, 2, 4, "div", 9);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(6);
        i0.ɵɵproperty("ngIf", ctx.fieldHasError);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.statement.preInstructionalText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isLastStatement && !ctx.showPlanBenefitRadioOrCheckBox && ctx.statement.inputType !== "radio")("ngIfElse", _r3);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngIf", ctx.statement.instructionalText);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgTemplateOutlet, i4.CheckboxControlValueAccessor, i4.NgControlStatus, i4.NgModel, IconAriaAttributesDirective, SafePipe], styles: ["label[_ngcontent-%COMP%]{cursor:pointer}.checkbox-wrapper[_ngcontent-%COMP%]{margin-top:2px}ul.voice-signature-statement[_ngcontent-%COMP%]{padding-left:30px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VoiceSignatureStatementComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-voice-signature-statement', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"fieldHasError\" class=\"error-color\" id=\"{{ statement.name + 'Error' }}\" role=\"alert\">\r\n  <i class=\"fas fa-exclamation-circle mr-2\" aria-hidden=\"true\"></i>\r\n  <span>{{ requiredText }}</span>\r\n</div>\r\n<div class=\"row\">\r\n  <div class=\"col-12 Spa_Style_Paragraph\">\r\n    <div\r\n      *ngIf=\"statement.preInstructionalText\"\r\n      class=\"preInstructional-text Spa_Style_Note\"\r\n      [innerHTML]=\"statement.preInstructionalText | safe : 'html'\"\r\n    ></div>\r\n\r\n    <ng-container\r\n      *ngIf=\"!isLastStatement && !showPlanBenefitRadioOrCheckBox && statement.inputType !== 'radio'; else showRadioOrCheckBoxTemplates\"\r\n    >\r\n      <ul class=\"voice-signature-statement\">\r\n        <li><div [innerHtml]=\"statement.value | safe : 'html'\"></div></li>\r\n      </ul>\r\n    </ng-container>\r\n\r\n    <ng-template #showRadioOrCheckBoxTemplates>\r\n      <ng-container *ngIf=\"statement.inputType !== 'radio'; else radioTemplate\">\r\n        <ng-container *ngIf=\"showRadioOrCheckBox; else showReadOnlyLabel\">\r\n          <!-- Checkbox Template -->\r\n          <label class=\"d-flex checkbox-label\" [for]=\"statement.name\">\r\n            <div class=\"checkbox-wrapper\">\r\n              <input\r\n                class=\"mr-2 can-click\"\r\n                aria-required=\"true\"\r\n                type=\"checkbox\"\r\n                [id]=\"statement.name\"\r\n                [attr.aria-describedby]=\"fieldHasError ? statement.name + 'Error' : null\"\r\n                (change)=\"statementToggled()\"\r\n                [(ngModel)]=\"checkboxValue\"\r\n              />\r\n            </div>\r\n            <div [ngClass]=\"{ 'error-color': fieldHasError }\" [innerHtml]=\"statement.value | safe : 'html'\"></div>\r\n          </label>\r\n        </ng-container>\r\n\r\n        <ng-template #showReadOnlyLabel>\r\n          <div [innerHtml]=\"statement.value | safe : 'html'\"></div>\r\n        </ng-template>\r\n      </ng-container>\r\n    </ng-template>\r\n\r\n    <!-- Radio Template -->\r\n    <ng-template #radioTemplate>\r\n      <ng-container *ngIf=\"statement.inputType === 'radio'\">\r\n        <div\r\n          id=\"statementLabelId\"\r\n          class=\"radio-text\"\r\n          [ngClass]=\"{ 'error-color': fieldHasError }\"\r\n          [innerHtml]=\"statement.value | safe : 'html'\"\r\n        ></div>\r\n        <div *ngFor=\"let option of statement.radioOptions; let i = index\">\r\n          <!-- Conditional template for showing div or label -->\r\n          <ng-container\r\n            *ngTemplateOutlet=\"showRadioOrCheckBox ? labelTemplate : readonlyLabelTemplate; context: { option: option, index: i }\"\r\n          ></ng-container>\r\n        </div>\r\n      </ng-container>\r\n    </ng-template>\r\n\r\n    <ng-template #labelTemplate let-option=\"option\" let-i=\"index\">\r\n      <label class=\"d-flex\">\r\n        <input\r\n          type=\"radio\"\r\n          class=\"mr-2 can-click\"\r\n          [name]=\"statement.name + 'group'\"\r\n          [attr.aria-labelledby]=\"'statementLabelId ' + statement.name + i\"\r\n          (change)=\"optionSelected(option)\"\r\n        />\r\n        <div [id]=\"statement.name + i\" [innerHtml]=\"option | safe : 'html'\"></div>\r\n      </label>\r\n    </ng-template>\r\n\r\n    <ng-template #readonlyLabelTemplate let-option=\"option\" let-i=\"index\">\r\n      <div class=\"d-flex\" [innerHtml]=\"option | safe : 'html'\"></div>\r\n    </ng-template>\r\n\r\n    <div\r\n      *ngIf=\"statement.instructionalText\"\r\n      class=\"instructional-text Spa_Style_Note ml-4 mb-2\"\r\n      [innerHTML]=\"statement.instructionalText | safe : 'html'\"\r\n    ></div>\r\n  </div>\r\n</div>\r\n", styles: ["label{cursor:pointer}.checkbox-wrapper{margin-top:2px}ul.voice-signature-statement{padding-left:30px}\n"] }]
    }], null, { statement: [{
            type: Input
        }], requiredText: [{
            type: Input
        }], fieldHasError: [{
            type: Input
        }], showRadioOrCheckBox: [{
            type: Input
        }], isLastStatement: [{
            type: Input
        }], showPlanBenefitRadioOrCheckBox: [{
            type: Input
        }], valueUpdated: [{
            type: Output
        }] }); })();

function VoiceSignatureModalComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r0.headerInstructionalText, "html"), i0.ɵɵsanitizeHtml);
} }
function VoiceSignatureModalComponent_form_3_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const section_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, section_r4.sectionHeader, "html"), i0.ɵɵsanitizeHtml);
} }
function VoiceSignatureModalComponent_form_3_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 16);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const section_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, section_r4.preInstructionalText, "html"), i0.ɵɵsanitizeHtml);
} }
const _c0$3r = function (a0) { return { "no-top-border": a0 }; };
function VoiceSignatureModalComponent_form_3_div_1_div_3_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19)(1, "div", 20)(2, "div", 21)(3, "vnext-widget-voice-signature-statement", 22);
    i0.ɵɵlistener("valueUpdated", function VoiceSignatureModalComponent_form_3_div_1_div_3_div_1_div_1_Template_vnext_widget_voice_signature_statement_valueUpdated_3_listener($event) { i0.ɵɵrestoreView(_r19); const statement_r13 = i0.ɵɵnextContext().$implicit; const ctx_r17 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r17.updateControl(statement_r13.name, $event)); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(4, "div", 20);
    i0.ɵɵelement(5, "div", 23);
    i0.ɵɵpipe(6, "safe");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext();
    const first_r14 = ctx_r20.first;
    const statement_r13 = ctx_r20.$implicit;
    const ctx_r16 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c0$3r, first_r14));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("statement", statement_r13)("requiredText", ctx_r16.requiredText)("fieldHasError", ctx_r16.fieldHasError(statement_r13.name))("showRadioOrCheckBox", false)("showPlanBenefitRadioOrCheckBox", ctx_r16.showPlanBenefitRadioOrCheckBox);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(6, 7, statement_r13.planBenefitDetails, "html"), i0.ɵɵsanitizeHtml);
} }
function VoiceSignatureModalComponent_form_3_div_1_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, VoiceSignatureModalComponent_form_3_div_1_div_3_div_1_div_1_Template, 7, 12, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const statement_r13 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !!statement_r13.planBenefitDetails);
} }
function VoiceSignatureModalComponent_form_3_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtemplate(1, VoiceSignatureModalComponent_form_3_div_1_div_3_div_1_Template, 2, 1, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const section_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", section_r4.statements);
} }
function VoiceSignatureModalComponent_form_3_div_1_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-widget-voice-signature-statement", 25);
    i0.ɵɵlistener("valueUpdated", function VoiceSignatureModalComponent_form_3_div_1_div_4_div_1_Template_vnext_widget_voice_signature_statement_valueUpdated_1_listener($event) { i0.ɵɵrestoreView(_r27); const statement_r22 = i0.ɵɵnextContext().$implicit; const ctx_r25 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r25.updateControl(statement_r22.name, $event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext();
    const statement_r22 = ctx_r28.$implicit;
    const last_r23 = ctx_r28.last;
    const ctx_r24 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("statement", statement_r22)("requiredText", ctx_r24.requiredText)("fieldHasError", ctx_r24.fieldHasError(statement_r22.name))("showRadioOrCheckBox", true)("showPlanBenefitRadioOrCheckBox", ctx_r24.showPlanBenefitRadioOrCheckBox)("isLastStatement", last_r23);
} }
function VoiceSignatureModalComponent_form_3_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, VoiceSignatureModalComponent_form_3_div_1_div_4_div_1_Template, 2, 6, "div", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const statement_r22 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !statement_r22.planBenefitDetails);
} }
function VoiceSignatureModalComponent_form_3_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 26);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const section_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, section_r4.instructionalText, "html"), i0.ɵɵsanitizeHtml);
} }
function VoiceSignatureModalComponent_form_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, VoiceSignatureModalComponent_form_3_div_1_div_1_Template, 2, 4, "div", 11);
    i0.ɵɵtemplate(2, VoiceSignatureModalComponent_form_3_div_1_div_2_Template, 2, 4, "div", 12);
    i0.ɵɵtemplate(3, VoiceSignatureModalComponent_form_3_div_1_div_3_Template, 2, 1, "div", 13);
    i0.ɵɵtemplate(4, VoiceSignatureModalComponent_form_3_div_1_div_4_Template, 2, 1, "div", 10);
    i0.ɵɵtemplate(5, VoiceSignatureModalComponent_form_3_div_1_div_5_Template, 2, 4, "div", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const section_r4 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", section_r4.sectionHeader);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", section_r4.preInstructionalText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", section_r4.containsPlanBenefitsTable);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", section_r4.statements);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", section_r4 == null ? null : section_r4.instructionalText);
} }
function VoiceSignatureModalComponent_form_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "form", 9);
    i0.ɵɵtemplate(1, VoiceSignatureModalComponent_form_3_div_1_Template, 6, 5, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.voiceSignatureFormGroup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.voiceSignatureSections);
} }
function VoiceSignatureModalComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵlistener("click", function VoiceSignatureModalComponent_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r30.cancel()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.cancelButtonText, " ");
} }
class VoiceSignatureModalComponent {
    constructor() {
        this.cancelButtonEnabled = true;
        this.showPlanBenefitRadioOrCheckBox = false;
        this.cancel = () => {
            if (this.cancelAction) {
                this.cancelAction();
            }
        };
        this.confirm = () => {
            this.voiceSignatureFormGroup.markAllAsTouched();
            this.voiceSignatureFormGroup.updateValueAndValidity();
            if (this.voiceSignatureFormGroup.valid && this.confirmAction) {
                // passing this because they can click continue without completing i think...
                // if not then we can merely assume if continue is allowed to emit it's because
                // we have validated the json-sourced form and it has been completed
                const isVoiceSignatureComplete = this.isVoiceSignatureComplete();
                this.confirmAction(isVoiceSignatureComplete);
            }
        };
    }
    ngOnInit() {
        this.voiceSignatureFormGroup = this.initializeVoiceSignatureFormGroup();
    }
    fieldHasError(fieldName) {
        const fieldControl = this.voiceSignatureFormGroup.get(fieldName);
        if (fieldControl) {
            return !fieldControl.valid && fieldControl.touched && !fieldControl.disabled;
        }
        else {
            return false;
        }
    }
    updateControl(fieldName, value) {
        const fieldControl = this.voiceSignatureFormGroup.get(fieldName);
        fieldControl.setValue(value);
        fieldControl.markAsTouched();
        fieldControl.markAsDirty();
    }
    initializeVoiceSignatureFormGroup() {
        const dynamicFormGroup = this.voiceSignatureSections?.reduce((voiceSignatureForm, section, sectionIndex) => {
            section?.statements.forEach((statement, statementIndex) => {
                if (!statement.planBenefitDetails || !section?.containsPlanBenefitsTable) {
                    statement.name = `${sectionIndex}-${statementIndex}`;
                    const questionKey = statement.name;
                    const isLastStatement = statementIndex === section.statements.length - 1;
                    if (statement.inputType === 'radio') {
                        voiceSignatureForm[questionKey] = new UntypedFormControl(null, this.showPlanBenefitRadioOrCheckBox ? Validators.required : null);
                    }
                    else {
                        voiceSignatureForm[questionKey] = new UntypedFormControl(false, isLastStatement || this.showPlanBenefitRadioOrCheckBox ? Validators.requiredTrue : null);
                    }
                }
            });
            return voiceSignatureForm;
        }, {}) ?? {};
        return new UntypedFormGroup(dynamicFormGroup);
    }
    isVoiceSignatureComplete() {
        const voiceSignatureFormValues = this.voiceSignatureFormGroup?.value;
        if (voiceSignatureFormValues) {
            return Object.values(voiceSignatureFormValues).every(formValue => formValue === true || formValue !== '');
        }
        return false;
    }
}
VoiceSignatureModalComponent.ɵfac = function VoiceSignatureModalComponent_Factory(t) { return new (t || VoiceSignatureModalComponent)(); };
VoiceSignatureModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: VoiceSignatureModalComponent, selectors: [["ng-component"]], decls: 9, vars: 6, consts: [[3, "modalTitleText", "hideCloseButton", "modalTitleCancelAction"], ["tabindex", "-1", 1, "modal-body", "col-12"], ["class", "mb-1 Spa_Style_Primary_Color", 3, "innerHTML", 4, "ngIf"], [3, "formGroup", 4, "ngIf"], [1, "modal-footer", "justify-content-start"], [1, "mr-auto"], ["type", "button", "class", "btn Spa_Style_SecondaryButton", 3, "click", 4, "ngIf"], ["type", "button", 1, "btn", "Spa_Style_PrimaryButton", "ml-auto", 3, "click"], [1, "mb-1", "Spa_Style_Primary_Color", 3, "innerHTML"], [3, "formGroup"], [4, "ngFor", "ngForOf"], ["class", "pb-1", 3, "innerHTML", 4, "ngIf"], ["class", "Spa_Style_Note", 3, "innerHTML", 4, "ngIf"], ["class", "plan-benefits-table mt-2", 4, "ngIf"], ["class", "pb-2 Spa_Style_Primary_Color Spa_Style_Note", 3, "innerHTML", 4, "ngIf"], [1, "pb-1", 3, "innerHTML"], [1, "Spa_Style_Note", 3, "innerHTML"], [1, "plan-benefits-table", "mt-2"], ["class", "row table-row no-gutters", 3, "ngClass", 4, "ngIf"], [1, "row", "table-row", "no-gutters", 3, "ngClass"], [1, "col-6"], [1, "table-statement"], [3, "statement", "requiredText", "fieldHasError", "showRadioOrCheckBox", "showPlanBenefitRadioOrCheckBox", "valueUpdated"], [1, "table-description", "Spa_Style_Paragraph", 3, "innerHtml"], [4, "ngIf"], [3, "statement", "requiredText", "fieldHasError", "showRadioOrCheckBox", "showPlanBenefitRadioOrCheckBox", "isLastStatement", "valueUpdated"], [1, "pb-2", "Spa_Style_Primary_Color", "Spa_Style_Note", 3, "innerHTML"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", 3, "click"]], template: function VoiceSignatureModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function VoiceSignatureModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.cancelAction(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, VoiceSignatureModalComponent_div_2_Template, 2, 4, "div", 2);
        i0.ɵɵtemplate(3, VoiceSignatureModalComponent_form_3_Template, 2, 2, "form", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4)(5, "div", 5);
        i0.ɵɵtemplate(6, VoiceSignatureModalComponent_button_6_Template, 2, 1, "button", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "button", 7);
        i0.ɵɵlistener("click", function VoiceSignatureModalComponent_Template_button_click_7_listener() { return ctx.confirm(); });
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title)("hideCloseButton", !ctx.cancelButtonEnabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.headerInstructionalText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.voiceSignatureSections == null ? null : ctx.voiceSignatureSections.length);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.cancelButtonEnabled);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.continueButtonText);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i4.ɵNgNoValidate, i4.NgControlStatusGroup, i4.FormGroupDirective, ModalHeaderComponent, VoiceSignatureStatementComponent, SafePipe], styles: [".plan-benefits-table[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px}.table-statement[_ngcontent-%COMP%], .table-description[_ngcontent-%COMP%]{padding:15px}.no-top-border[_ngcontent-%COMP%]{border-top:0px!important}.table-statement[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);height:100%}.table-row[_ngcontent-%COMP%]{border-top:1px solid var(--static-Spa_Style_Accent1)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VoiceSignatureModalComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header\r\n  [modalTitleText]=\"title\"\r\n  [hideCloseButton]=\"!cancelButtonEnabled\"\r\n  (modalTitleCancelAction)=\"cancelAction()\"\r\n></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body col-12\" tabindex=\"-1\">\r\n  <div *ngIf=\"headerInstructionalText\" [innerHTML]=\"headerInstructionalText | safe : 'html'\" class=\"mb-1 Spa_Style_Primary_Color\"></div>\r\n  <form *ngIf=\"voiceSignatureSections?.length\" [formGroup]=\"voiceSignatureFormGroup\">\r\n    <div *ngFor=\"let section of voiceSignatureSections\">\r\n      <div *ngIf=\"section.sectionHeader\" class=\"pb-1\" [innerHTML]=\"section.sectionHeader | safe : 'html'\"></div>\r\n      <div *ngIf=\"section.preInstructionalText\" class=\"Spa_Style_Note\" [innerHTML]=\"section.preInstructionalText | safe : 'html'\"></div>\r\n\r\n      <div *ngIf=\"section.containsPlanBenefitsTable\" class=\"plan-benefits-table mt-2\">\r\n        <div *ngFor=\"let statement of section.statements; let first = first; let last = last\">\r\n          <div *ngIf=\"!!statement.planBenefitDetails\" class=\"row table-row no-gutters\" [ngClass]=\"{ 'no-top-border': first }\">\r\n            <div class=\"col-6\">\r\n              <div class=\"table-statement\">\r\n                <vnext-widget-voice-signature-statement\r\n                  [statement]=\"statement\"\r\n                  [requiredText]=\"requiredText\"\r\n                  [fieldHasError]=\"fieldHasError(statement.name)\"\r\n                  (valueUpdated)=\"updateControl(statement.name, $event)\"\r\n                  [showRadioOrCheckBox]=\"false\"\r\n                  [showPlanBenefitRadioOrCheckBox]=\"showPlanBenefitRadioOrCheckBox\"\r\n                >\r\n                </vnext-widget-voice-signature-statement>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-6\">\r\n              <div class=\"table-description Spa_Style_Paragraph\" [innerHtml]=\"statement.planBenefitDetails | safe : 'html'\"></div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div *ngFor=\"let statement of section.statements; let last = last\">\r\n        <div *ngIf=\"!statement.planBenefitDetails\">\r\n          <vnext-widget-voice-signature-statement\r\n            [statement]=\"statement\"\r\n            [requiredText]=\"requiredText\"\r\n            [fieldHasError]=\"fieldHasError(statement.name)\"\r\n            (valueUpdated)=\"updateControl(statement.name, $event)\"\r\n            [showRadioOrCheckBox]=\"true\"\r\n            [showPlanBenefitRadioOrCheckBox]=\"showPlanBenefitRadioOrCheckBox\"\r\n            [isLastStatement]=\"last\"\r\n          >\r\n          </vnext-widget-voice-signature-statement>\r\n        </div>\r\n      </div>\r\n      <div\r\n        *ngIf=\"section?.instructionalText\"\r\n        [innerHTML]=\"section.instructionalText | safe : 'html'\"\r\n        class=\"pb-2 Spa_Style_Primary_Color Spa_Style_Note\"\r\n      ></div>\r\n    </div>\r\n  </form>\r\n</div>\r\n<div class=\"modal-footer justify-content-start\">\r\n  <div class=\"mr-auto\">\r\n    <button *ngIf=\"cancelButtonEnabled\" type=\"button\" (click)=\"cancel()\" class=\"btn Spa_Style_SecondaryButton\">\r\n      {{ cancelButtonText }}\r\n    </button>\r\n  </div>\r\n  <button type=\"button\" (click)=\"confirm()\" class=\"btn Spa_Style_PrimaryButton ml-auto\">{{ continueButtonText }}</button>\r\n</div>\r\n", styles: [".plan-benefits-table{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px}.table-statement,.table-description{padding:15px}.no-top-border{border-top:0px!important}.table-statement{border-right:1px solid var(--static-Spa_Style_Accent1);height:100%}.table-row{border-top:1px solid var(--static-Spa_Style_Accent1)}\n"] }]
    }], null, null); })();

function NoticeContainerComponent_vnext_notice_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice", 3);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r0.title)("type", "error")("messages", ctx_r0.errorMessages)("errorCustomClass", "mb-0");
} }
function NoticeContainerComponent_vnext_notice_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice", 4);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("type", "warn")("title", ctx_r1.title)("messages", ctx_r1.warningMessages)("continueText", ctx_r1.continueText)("warningCustomClass", "mb-0");
} }
function NoticeContainerComponent_vnext_notice_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice", 5);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("type", "info")("messages", ctx_r2.infoMessages)("title", ctx_r2.title);
} }
class NoticeContainerComponent {
    constructor() {
        this.errorMessages = [];
        this.warningMessages = [];
        this.infoMessages = [];
    }
    ngOnChanges(changes) {
        const notice = changes.notice;
        if (!_isEqual(notice.currentValue, notice.previousValue)) {
            if (this.notice) {
                const currentMessages = this.notice.messages;
                this.title = this.notice.title;
                this.continueText = this.notice.continueText;
                this.errorMessages = currentMessages.filter(currentMessage => currentMessage.severity === NOTICE_TYPE.ERROR);
                this.warningMessages = currentMessages.filter(currentMessage => currentMessage.severity === NOTICE_TYPE.WARN);
                this.infoMessages = currentMessages.filter(currentMessage => currentMessage.severity === NOTICE_TYPE.INFO);
            }
        }
    }
}
NoticeContainerComponent.ɵfac = function NoticeContainerComponent_Factory(t) { return new (t || NoticeContainerComponent)(); };
NoticeContainerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NoticeContainerComponent, selectors: [["vnext-notice-container"]], inputs: { notice: "notice" }, features: [i0.ɵɵNgOnChangesFeature], decls: 4, vars: 3, consts: [[3, "title", "type", "messages", "errorCustomClass", 4, "ngIf"], [3, "type", "title", "messages", "continueText", "warningCustomClass", 4, "ngIf"], [3, "type", "messages", "title", 4, "ngIf"], [3, "title", "type", "messages", "errorCustomClass"], [3, "type", "title", "messages", "continueText", "warningCustomClass"], [3, "type", "messages", "title"]], template: function NoticeContainerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, NoticeContainerComponent_vnext_notice_1_Template, 1, 4, "vnext-notice", 0);
        i0.ɵɵtemplate(2, NoticeContainerComponent_vnext_notice_2_Template, 1, 5, "vnext-notice", 1);
        i0.ɵɵtemplate(3, NoticeContainerComponent_vnext_notice_3_Template, 1, 3, "vnext-notice", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errorMessages == null ? null : ctx.errorMessages.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.warningMessages == null ? null : ctx.warningMessages.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.infoMessages == null ? null : ctx.infoMessages.length);
    } }, dependencies: [i1$2.NgIf, NoticeComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NoticeContainerComponent, [{
        type: Component,
        args: [{ selector: 'vnext-notice-container', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div>\r\n  <vnext-notice\r\n    *ngIf=\"errorMessages?.length\"\r\n    [title]=\"title\"\r\n    [type]=\"'error'\"\r\n    [messages]=\"errorMessages\"\r\n    [errorCustomClass]=\"'mb-0'\"\r\n  ></vnext-notice>\r\n  <vnext-notice\r\n    *ngIf=\"warningMessages?.length\"\r\n    [type]=\"'warn'\"\r\n    [title]=\"title\"\r\n    [messages]=\"warningMessages\"\r\n    [continueText]=\"continueText\"\r\n    [warningCustomClass]=\"'mb-0'\"\r\n  ></vnext-notice>\r\n  <vnext-notice *ngIf=\"infoMessages?.length\" [type]=\"'info'\" [messages]=\"infoMessages\" [title]=\"title\"> </vnext-notice>\r\n</div>\r\n" }]
    }], null, { notice: [{
            type: Input
        }] }); })();

function PaginationComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "i", 8);
    i0.ɵɵelementStart(2, "span", 9);
    i0.ɵɵtext(3, "Previous");
    i0.ɵɵelementEnd()();
} }
function PaginationComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const page_r3 = ctx.$implicit;
    i0.ɵɵattribute("aria-label", page_r3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(page_r3);
} }
function PaginationComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelement(1, "i", 12);
    i0.ɵɵelementStart(2, "span", 9);
    i0.ɵɵtext(3, "Next");
    i0.ɵɵelementEnd()();
} }
class PaginationComponent {
    constructor(config) {
        this.updatePagination = new EventEmitter();
        // customize default values of paginations used by this component tree
        config.size = 'sm';
    }
    ngOnInit() {
        this.emitPagination();
    }
    emitPagination() {
        this.updatePagination.emit({ pageSize: this.itemsPerPage, defaultStartItem: this.defaultStartItem });
    }
    loadPage(page) {
        this.defaultStartItem = page;
        this.emitPagination();
    }
    get paginationPageText() {
        const startPageItem = this.defaultStartItem * this.itemsPerPage - this.itemsPerPage + 1;
        const endPageItem = this.defaultStartItem * this.itemsPerPage - this.pagination.length > 0
            ? this.pagination.length
            : this.defaultStartItem * this.itemsPerPage;
        return this.paginationText
            .replace('<startPageItem>', startPageItem.toString())
            .replace('<endPageItem>', endPageItem)
            .replace('<totalPages>', this.pagination.length);
    }
}
PaginationComponent.ɵfac = function PaginationComponent_Factory(t) { return new (t || PaginationComponent)(i0.ɵɵdirectiveInject(i1$1.NgbPaginationConfig)); };
PaginationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PaginationComponent, selectors: [["vnext-pagination"]], inputs: { pagination: "pagination", itemsPerPage: "itemsPerPage", paginationText: "paginationText", defaultStartItem: "defaultStartItem" }, outputs: { updatePagination: "updatePagination" }, decls: 9, vars: 7, consts: [[1, "d-inline"], [1, "d-inline-block", "my-2", "Spa_Style_Small_Font", "mr-2"], [1, "Spa_Style_Small_Font", "float-right"], ["aria-label", "Default pagination", 3, "collectionSize", "pageSize", "page", "maxSize", "rotate", "ellipses", "pageChange"], ["ngbPaginationPrevious", ""], ["ngbPaginationNumber", ""], ["ngbPaginationNext", ""], ["tabindex", "-1", 1, "btn", "pagination-previous", "Spa_Style_SecondaryButton", "Spa_Style_Bold_Weight"], [1, "fas", "fa-angle-left"], [1, "sr-only"], ["tabindex", "-1", 1, "btn", "Spa_Style_SecondaryButton", "Spa_Style_Bold_Weight", "rounded-0"], ["tabindex", "-1", 1, "btn", "pagination-next", "Spa_Style_SecondaryButton", "Spa_Style_Bold_Weight"], [1, "fas", "fa-angle-right"]], template: function PaginationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2)(4, "strong")(5, "ngb-pagination", 3);
        i0.ɵɵlistener("pageChange", function PaginationComponent_Template_ngb_pagination_pageChange_5_listener($event) { return ctx.loadPage($event); })("pageChange", function PaginationComponent_Template_ngb_pagination_pageChange_5_listener($event) { return ctx.defaultStartItem = $event; });
        i0.ɵɵtemplate(6, PaginationComponent_ng_template_6_Template, 4, 0, "ng-template", 4);
        i0.ɵɵtemplate(7, PaginationComponent_ng_template_7_Template, 2, 2, "ng-template", 5);
        i0.ɵɵtemplate(8, PaginationComponent_ng_template_8_Template, 4, 0, "ng-template", 6);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.paginationPageText, " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("collectionSize", ctx.pagination.length)("pageSize", ctx.itemsPerPage)("page", ctx.defaultStartItem)("maxSize", 4)("rotate", false)("ellipses", false);
    } }, dependencies: [i1$1.NgbPagination, i1$1.NgbPaginationNext, i1$1.NgbPaginationNumber, i1$1.NgbPaginationPrevious, IconAriaAttributesDirective], styles: [".pagination-view-text[_ngcontent-%COMP%]{display:contents;padding:0}@media (max-width: 768px){.pagination-view-text[_ngcontent-%COMP%]{display:flex}}.pagination-previous[_ngcontent-%COMP%]{border-top-right-radius:0;border-bottom-right-radius:0}.pagination-next[_ngcontent-%COMP%]{border-top-left-radius:0;border-bottom-left-radius:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationComponent, [{
        type: Component,
        args: [{ selector: 'vnext-pagination', template: "<div class=\"d-inline\">\r\n  <div class=\"d-inline-block my-2 Spa_Style_Small_Font mr-2\">\r\n    {{ paginationPageText }}\r\n  </div>\r\n  <div class=\"Spa_Style_Small_Font float-right\">\r\n    <strong>\r\n      <ngb-pagination\r\n        [collectionSize]=\"pagination.length\"\r\n        [pageSize]=\"itemsPerPage\"\r\n        (pageChange)=\"loadPage($event)\"\r\n        [(page)]=\"defaultStartItem\"\r\n        [maxSize]=\"4\"\r\n        [rotate]=\"false\"\r\n        [ellipses]=\"false\"\r\n        aria-label=\"Default pagination\"\r\n      >\r\n        <ng-template ngbPaginationPrevious>\r\n          <div class=\"btn pagination-previous Spa_Style_SecondaryButton Spa_Style_Bold_Weight\" tabindex=\"-1\">\r\n            <i class=\"fas fa-angle-left\"></i>\r\n            <span class=\"sr-only\">Previous</span>\r\n          </div>\r\n        </ng-template>\r\n\r\n        <ng-template ngbPaginationNumber let-page>\r\n          <div class=\"btn Spa_Style_SecondaryButton Spa_Style_Bold_Weight rounded-0\" tabindex=\"-1\" [attr.aria-label]=\"page\">{{ page }}</div>\r\n        </ng-template>\r\n\r\n        <ng-template ngbPaginationNext>\r\n          <div class=\"btn pagination-next Spa_Style_SecondaryButton Spa_Style_Bold_Weight\" tabindex=\"-1\">\r\n            <i class=\"fas fa-angle-right\"></i>\r\n            <span class=\"sr-only\">Next</span>\r\n          </div>\r\n        </ng-template>\r\n      </ngb-pagination>\r\n    </strong>\r\n  </div>\r\n</div>\r\n", styles: [".pagination-view-text{display:contents;padding:0}@media (max-width: 768px){.pagination-view-text{display:flex}}.pagination-previous{border-top-right-radius:0;border-bottom-right-radius:0}.pagination-next{border-top-left-radius:0;border-bottom-left-radius:0}\n"] }]
    }], function () { return [{ type: i1$1.NgbPaginationConfig }]; }, { updatePagination: [{
            type: Output
        }], pagination: [{
            type: Input
        }], itemsPerPage: [{
            type: Input
        }], paginationText: [{
            type: Input
        }], defaultStartItem: [{
            type: Input
        }] }); })();

class PlanYearBadgeComponent {
    constructor() {
        this.isDualPlanYearActive = true;
    }
}
PlanYearBadgeComponent.ɵfac = function PlanYearBadgeComponent_Factory(t) { return new (t || PlanYearBadgeComponent)(); };
PlanYearBadgeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanYearBadgeComponent, selectors: [["vnext-plan-year-badge"]], inputs: { planYear: "planYear", isDualPlanYearActive: "isDualPlanYearActive" }, decls: 3, vars: 2, consts: [[1, "plan-year-badge-wrapper"], [1, "plan-year-badge", "Spa_Style_Small_Font", "Spa_Style_Bold_Weight", 3, "ngClass"]], template: function PlanYearBadgeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.isDualPlanYearActive ? "Spa_Style_Primary_Color active" : "Spa_Style_Gray4 inactive");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.planYear, " ");
    } }, dependencies: [i1$2.NgClass], styles: [".plan-year-badge[_ngcontent-%COMP%]{padding:1px 6px;border-radius:5px;display:inline-block}.plan-year-badge.active[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray2)}.plan-year-badge.inactive[_ngcontent-%COMP%]{background-color:#fff}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanYearBadgeComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-year-badge', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"plan-year-badge-wrapper\">\r\n  <div\r\n    class=\"plan-year-badge Spa_Style_Small_Font Spa_Style_Bold_Weight\"\r\n    [ngClass]=\"isDualPlanYearActive ? 'Spa_Style_Primary_Color active' : 'Spa_Style_Gray4 inactive'\"\r\n  >\r\n    {{ planYear }}\r\n  </div>\r\n</div>\r\n", styles: [".plan-year-badge{padding:1px 6px;border-radius:5px;display:inline-block}.plan-year-badge.active{background-color:var(--static-Spa_Style_Gray2)}.plan-year-badge.inactive{background-color:#fff}\n"] }]
    }], null, { planYear: [{
            type: Input
        }], isDualPlanYearActive: [{
            type: Input
        }] }); })();

const _c0$3q = function (a0) { return { "no-translate-block": a0 }; };
function ScrollableMultiSelectCheckboxComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "label", 3)(2, "input", 4);
    i0.ɵɵlistener("change", function ScrollableMultiSelectCheckboxComponent_div_3_Template_input_change_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const item_r1 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.toggleChecked(item_r1)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 5);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", item_r1)("checked", ctx_r0.isChecked(item_r1));
    i0.ɵɵattribute("aria-labelledby", "labelId itemLabelId" + i_r2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", "itemLabelId" + i_r2)("ngClass", i0.ɵɵpureFunction1(6, _c0$3q, ctx_r0.noTranslateBlock));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r1.label);
} }
const _c1$1O = function (a0) { return { "overflow-container": a0 }; };
class ScrollableMultiSelectCheckboxComponent {
    constructor() {
        // the list of items we wish to have checkboxes for
        this.items = [];
        this.noTranslateBlock = false;
        this.selectedItems = new EventEmitter();
        this.selectedValues = [];
        this.onChanged = () => { };
        this.onTouched = () => { };
    }
    ngOnInit() {
        this.items
            .filter(item => item.initiallyChecked)
            .forEach(item => {
            this.toggleChecked(item);
        });
    }
    writeValue(value) {
        if (value && Array.isArray(value)) {
            this.selectedValues = value;
        }
        else {
            this.selectedValues = [];
        }
    }
    registerOnChange(fn) {
        this.onChanged = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    toggleChecked(selectstate) {
        const updatedItems = [...this.selectedValues];
        const itemIndex = updatedItems.findIndex(selectedItem => selectedItem.value === selectstate.value);
        if (itemIndex !== -1) {
            updatedItems.splice(itemIndex, 1);
        }
        else {
            updatedItems.push(selectstate);
        }
        // track changes internally since multiple changes can be made before the form
        // sends a new value into the input
        this.selectedValues = updatedItems;
        // signal to the parent form that our value has changed
        // this.onChanged(this.selectedValues);
        this.onTouched();
        this.emitValue(this.selectedValues);
    }
    isChecked(item) {
        return this.selectedValues && this.selectedValues.findIndex(selectedItem => selectedItem.value === item.value) !== -1;
    }
    emitValue(value) {
        this.selectedItems.emit(value);
    }
}
ScrollableMultiSelectCheckboxComponent.ɵfac = function ScrollableMultiSelectCheckboxComponent_Factory(t) { return new (t || ScrollableMultiSelectCheckboxComponent)(); };
ScrollableMultiSelectCheckboxComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ScrollableMultiSelectCheckboxComponent, selectors: [["vnext-scrollable-multi-select-checkbox"]], inputs: { items: "items", label: "label", noTranslateBlock: "noTranslateBlock" }, outputs: { selectedItems: "selectedItems" }, decls: 4, vars: 5, consts: [["id", "labelId", 1, "Spa_Style_H4"], [1, "multi-select-container", 3, "ngClass"], [4, "ngFor", "ngForOf"], [1, "Spa_Style_Note"], ["type", "checkbox", "tabindex", "0", 3, "value", "checked", "change"], [1, "label-text", 3, "id", "ngClass"]], template: function ScrollableMultiSelectCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h4", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵtemplate(3, ScrollableMultiSelectCheckboxComponent_div_3_Template, 5, 8, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.label, "\n");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1$1O, (ctx.items == null ? null : ctx.items.length) > 10));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.items);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf], styles: [".label-text[_ngcontent-%COMP%]{margin-left:5px}.multi-select-container[_ngcontent-%COMP%]{min-height:160px}.overflow-container[_ngcontent-%COMP%]{height:260px;overflow-y:auto;border:1px solid var(--static-Spa_Style_Gray4);padding:10px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ScrollableMultiSelectCheckboxComponent, [{
        type: Component,
        args: [{ selector: 'vnext-scrollable-multi-select-checkbox', changeDetection: ChangeDetectionStrategy.OnPush, template: "<h4 id=\"labelId\" class=\"Spa_Style_H4\">\r\n  {{ label }}\r\n</h4>\r\n<div class=\"multi-select-container\" [ngClass]=\"{ 'overflow-container': items?.length > 10 }\">\r\n  <div *ngFor=\"let item of items; let i = index\">\r\n    <label class=\"Spa_Style_Note\">\r\n      <input\r\n        type=\"checkbox\"\r\n        tabindex=\"0\"\r\n        [attr.aria-labelledby]=\"'labelId itemLabelId' + i\"\r\n        [value]=\"item\"\r\n        [checked]=\"isChecked(item)\"\r\n        (change)=\"toggleChecked(item)\"\r\n      />\r\n      <span [id]=\"'itemLabelId' + i\" class=\"label-text\" [ngClass]=\"{ 'no-translate-block': noTranslateBlock }\">{{ item.label }}</span>\r\n    </label>\r\n  </div>\r\n</div>\r\n", styles: [".label-text{margin-left:5px}.multi-select-container{min-height:160px}.overflow-container{height:260px;overflow-y:auto;border:1px solid var(--static-Spa_Style_Gray4);padding:10px}\n"] }]
    }], null, { items: [{
            type: Input
        }], label: [{
            type: Input
        }], noTranslateBlock: [{
            type: Input
        }], selectedItems: [{
            type: Output
        }] }); })();

class PlanFilterItemsFacade {
    constructor(store, configResourceService, guidedHelpService, planFacade, stringFormatUtilityService, filterService, localeService, snpService, plansService) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.guidedHelpService = guidedHelpService;
        this.planFacade = planFacade;
        this.stringFormatUtilityService = stringFormatUtilityService;
        this.filterService = filterService;
        this.localeService = localeService;
        this.snpService = snpService;
        this.plansService = plansService;
        this.carriersControlName = 'planCarriers';
        this.planBenefitsControlName = 'planDataFields';
        this.subTypesControlName = 'planSubTypes';
        this.ancillaryPlanTypeControlName = 'planTypeDescription';
        this.snpBaseTypesControlName = 'snpType';
        this.sellableControlName = 'isPUF';
        this.ridersPlanSubtypeName = 'ridersPlanSubtype';
        this.snpSubTypesControlName = 'planSNPCategories';
        this.dsnpSubTypesControlName = 'dsnpCoverageCode';
        this.providersNpiName = 'providersNpi';
        this.extraDataControlName = 'extraData';
        this.medicalDeductibleControlName = 'medicalDeductible';
        this.maximumOutOfPocketCostControlName = 'maximumOutOfPocketCost';
        this.drugDeductibleControlName = 'drugDeductible';
        this.medicalPremiumControlName = 'medicalPremium';
        this.drugPremiumControlName = 'drugPremium';
        this.starRatingControlName = 'planRating';
        this.validModelDrugProgramValue = 'True';
        this.snpBaseLabels = {};
        this.snpSubTypeTooltips = {};
        this.dsnpSubTypeTooltips = {};
        this.snpSubTypeLabels = {};
        this.ridersBaseLabels = {};
        this.ridersTooltips = {};
        this.filterPlanMarketingNameEnabled = this.configResourceService.getProcessedResourceValue('Spa_Filter_Plan_Marketing_Name_Enabled', null, false);
        this.selectedCarrierSessionKey = 'selected_carriers';
        this.filterFormTypes = {
            [this.carriersControlName]: this.filterPlanMarketingNameEnabled ? FilterKeyType.PLAN_CARRIER_FILTER : FilterKeyType.PLAN_CARRIER_NAME,
            [this.planBenefitsControlName]: FilterKeyType.PLAN_BENEFIT_NAME,
            [this.subTypesControlName]: FilterKeyType.PLAN_SUB_TYPE,
            [this.ancillaryPlanTypeControlName]: FilterKeyType.PLAN_TYPE_DESCRIPTION,
            [this.sellableControlName]: FilterKeyType.PLAN_ISPUF,
            [this.snpBaseTypesControlName]: FilterKeyType.SNP_BASE_TYPE,
            [this.snpSubTypesControlName]: FilterKeyType.SNP_CATEGORY,
            [this.dsnpSubTypesControlName]: FilterKeyType.DSNP_COVERAGE_CODES,
            [this.extraDataControlName]: FilterKeyType.PLAN_EXTRADATA,
            [this.medicalDeductibleControlName]: FilterKeyType.PLAN_MEDICAL_DEDUCTIBLE,
            [this.maximumOutOfPocketCostControlName]: FilterKeyType.PLAN_MAXIMUM_OUT_POCKET_COST,
            [this.drugDeductibleControlName]: FilterKeyType.PLAN_PHARMACY_DEDUCTIBLE,
            [this.medicalPremiumControlName]: FilterKeyType.PLAN_PREMIUM,
            [this.drugPremiumControlName]: FilterKeyType.PLAN_DRUG_PREMIUM,
            [this.ridersPlanSubtypeName]: FilterKeyType.RIDERS_PLAN_SUB_TYPE,
            [this.providersNpiName]: FilterKeyType.PROVIDERS_NPI,
            [this.starRatingControlName]: FilterKeyType.PLAN_RATING
        };
        this.destroy$ = new Subject();
        this.onFilterClickedSubject$ = new Subject();
        this.onFilterClicked$ = this.onFilterClickedSubject$.asObservable();
        this.comboPlans = COMBO_PLANS;
        this.activeTabType$ = this.store.select(PlansState.activeTabType).pipe(shareReplay(1));
        this.plans$ = this.planFacade.getFilteredPlansBySNPVisibility$();
        this.hasMedSupAnswers$ = this.planFacade.getHasMedSupAnswers$().pipe(shareReplay(1));
        this.hasDentalVisionAnswers$ = this.planFacade.getHasAncillaryPlanAnswers$().pipe(shareReplay(1));
        this.hasHospitalIndemnityAnswers$ = this.planFacade.getHasHospitalIndemnityAnswers$().pipe(shareReplay(1));
        this.showSellablePlanFilter$ = this.store
            .select(PlansState.showSellablePlanFilter(this.planFacade.getPlanListTabData()))
            .pipe(shareReplay(1));
        this.sellablePlansOnlyCheckboxLabel = this.configResourceService.getProcessedResourceValue('Spa_Filter_SellablePlansOnlyCheckbox_Label', null, 'Only show plans I can sell');
        this.locale$ = this.localeService.getCurrentLocale$().pipe(takeUntil(this.destroy$));
        this.locale$.subscribe({
            next: () => {
                this.initSNPLabels();
                this.initSNPTooltips();
                this.initSNPSubTypeLabels();
                this.initRidersLabels();
                this.initRidersTooltips();
            }
        });
    }
    createFilterForm() {
        return new UntypedFormGroup({
            [this.carriersControlName]: new UntypedFormControl(null),
            [this.planBenefitsControlName]: new UntypedFormControl(null),
            [this.subTypesControlName]: new UntypedFormControl(null),
            [this.ancillaryPlanTypeControlName]: new UntypedFormControl(null),
            [this.sellableControlName]: new UntypedFormControl(null),
            [this.snpBaseTypesControlName]: new UntypedFormControl(null),
            [this.snpSubTypesControlName]: new UntypedFormControl(null),
            [this.dsnpSubTypesControlName]: new UntypedFormControl(null),
            [this.extraDataControlName]: new UntypedFormControl(null),
            [this.medicalDeductibleControlName]: new UntypedFormControl(null),
            [this.maximumOutOfPocketCostControlName]: new UntypedFormControl(null),
            [this.drugDeductibleControlName]: new UntypedFormControl(null),
            [this.medicalPremiumControlName]: new UntypedFormControl(null),
            [this.drugPremiumControlName]: new UntypedFormControl(null),
            [this.ridersPlanSubtypeName]: new UntypedFormControl(null),
            [this.providersNpiName]: new UntypedFormControl(null),
            [this.starRatingControlName]: new UntypedFormControl(null)
        });
    }
    getShowSellablePlanFilter$() {
        return this.showSellablePlanFilter$;
    }
    getCarriersControls$(filterList$) {
        const filterType = this.filterPlanMarketingNameEnabled ? FilterKeyType.PLAN_CARRIER_FILTER : FilterKeyType.PLAN_CARRIER_NAME;
        return this.getLatestValuesForFilterControls$(filterList$).pipe(map(([[plans, hasMedSupAnswers, hasDentalVisionAnswers, hasHospitalIndemnityAnswers, locale, filterList], activeTabType]) => {
            const rateFactorAnswers = {
                [PlanTypeAbbreviation.MEDIGAP]: hasMedSupAnswers,
                [PlanTypeAbbreviation.DENTAL]: hasDentalVisionAnswers,
                [PlanTypeAbbreviation.VISION]: hasDentalVisionAnswers,
                [PlanTypeAbbreviation.HC]: hasHospitalIndemnityAnswers
            };
            const hasAnswers = rateFactorAnswers[activeTabType] ?? hasMedSupAnswers;
            return this.availableCarriers(filterList, plans, hasAnswers, activeTabType, filterType);
        }), map(filters => this.sortFilterControls(filters, true)), distinctUntilChanged(_isEqual));
    }
    getPlanBenefitsControls$(filterList$, defaultPlanBenefitFilters) {
        return this.getLatestValuesForFilterControls$(filterList$).pipe(map(([[plans, hasMedSupAnswers, hasDentalVisionAnswers, hasHospitalIndemnityAnswers, locale, filterList], activeTabType]) => this.availableBenefits(filterList, plans, activeTabType, defaultPlanBenefitFilters)), map(filters => this.sortFilterControls(filters, true)), distinctUntilChanged(_isEqual));
    }
    getPlanSubTypeControls$(filterList$) {
        return this.getLatestValuesForFilterControls$(filterList$).pipe(map(([[plans, hasMedSupAnswers, hasDentalVisionAnswers, hasHospitalIndemnityAnswers, locale, filterList], activeTabType]) => {
            const rateFactorAnswers = {
                [PlanTypeAbbreviation.MEDIGAP]: hasMedSupAnswers,
                [PlanTypeAbbreviation.DENTAL]: hasDentalVisionAnswers,
                [PlanTypeAbbreviation.VISION]: hasDentalVisionAnswers,
                [PlanTypeAbbreviation.HC]: hasHospitalIndemnityAnswers
            };
            const hasAnswers = rateFactorAnswers[activeTabType] ?? hasMedSupAnswers;
            let filters = this.planFacade.getFilterKeys(plans, hasAnswers, activeTabType, FilterKeyType.PLAN_SUB_TYPE);
            if (activeTabType === PlanTypeAbbreviation.DENTAL) {
                filters = this.combineDentalFiltersByLabel(filters, this.comboPlans);
            }
            if (activeTabType === PlanTypeAbbreviation.VISION) {
                filters = this.combineVisionFiltersByLabel(filters, this.comboPlans);
            }
            return filters;
        }), map(filters => this.sortFilterControls(filters, true)), distinctUntilChanged(_isEqual));
    }
    getAncillaryPlanTypeControls$(filterList$) {
        return this.getLatestValuesForFilterControls$(filterList$).pipe(map(([[plans, hasMedSupAnswers, hasDentalVisionAnswers, hasHospitalIndemnityAnswers, locale, filterList], activeTabType]) => {
            const rateFactorAnswers = {
                [PlanTypeAbbreviation.MEDIGAP]: hasMedSupAnswers,
                [PlanTypeAbbreviation.DENTAL]: hasDentalVisionAnswers,
                [PlanTypeAbbreviation.VISION]: hasDentalVisionAnswers,
                [PlanTypeAbbreviation.HC]: hasHospitalIndemnityAnswers
            };
            const hasAnswers = rateFactorAnswers[activeTabType] ?? hasMedSupAnswers;
            return this.planFacade.getFilterKeys(plans, hasAnswers, activeTabType, FilterKeyType.PLAN_TYPE_DESCRIPTION);
        }), map(filters => this.sortFilterControls(filters, true).sort((a, b) => a.label?.length - b.label?.length)), distinctUntilChanged(_isEqual));
    }
    getPlanSellableControls$(filterList$) {
        return this.getLatestValuesForFilterControls$(filterList$).pipe(map(([[plans, hasMedSupAnswers, hasDentalVisionAnswers, hasHospitalIndemnityAnswers, locale, filterList], activeTabType]) => this.planFacade.getFilterKeys(plans, hasMedSupAnswers, activeTabType, FilterKeyType.PLAN_ISPUF)), map(filters => this.sortFilterControls(filters, true)), map(filters => [{ label: this.sellablePlansOnlyCheckboxLabel, value: true, disabled: false }]), distinctUntilChanged(_isEqual));
    }
    getModelDrugProgramControls$(filterList$) {
        return this.getLatestValuesForFilterControls$(filterList$).pipe(map(([[plans, hasMedSupAnswers, hasDentalVisionAnswers, hasHospitalIndemnityAnswers, locale, filterList], activeTabType]) => this.planFacade.getFilterKeys(plans, hasMedSupAnswers, activeTabType, FilterKeyType.PLAN_EXTRADATA)), map(filters => this.sortFilterControls(filters, true)), map(filters => filters.map(filter => ({
            label: this.planFacade.getInsulinSavingsText(),
            value: { name: FilterKeyType.MODEL_DRUG_PROGRAM, value: this.validModelDrugProgramValue },
            disabled: false,
            tooltip: this.planFacade.getInsulinSavingsTooltip()
        }))), distinctUntilChanged(_isEqual));
    }
    getCostFilterControl$(filterList$, filterKeyType) {
        return this.getLatestValuesForFilterControls$(filterList$).pipe(map(([[plans, hasMedSupAnswers, hasDentalVisionAnswers, hasHospitalIndemnityAnswers, locale, filterList], activeTabType]) => this.planFacade.getFilterKeys(plans, hasMedSupAnswers, activeTabType, filterKeyType)), map(filters => {
            if (filters.length < 1) {
                return [];
            }
            switch (filterKeyType) {
                case FilterKeyType.PLAN_MEDICAL_DEDUCTIBLE:
                    return this.getCostFilterOptions('MedicalDeductible');
                case FilterKeyType.PLAN_MAXIMUM_OUT_POCKET_COST:
                    return this.getCostFilterOptions('OOP');
                case FilterKeyType.PLAN_PHARMACY_DEDUCTIBLE:
                    return this.getCostFilterOptions('PharmacyDeductible');
                case FilterKeyType.PLAN_PREMIUM:
                case FilterKeyType.PLAN_DRUG_PREMIUM:
                    return this.getCostFilterOptions('Premium');
                default:
                    return [];
            }
        }), distinctUntilChanged(_isEqual));
    }
    getCostFilterOptions(groupName) {
        const costLowText = this.configResourceService.getProcessedResourceValue(`Spa_Filter_${groupName}Low_Text`, null, '$0-$199');
        const costLowMinValue = this.configResourceService.getProcessedResourceValue(`Spa_Filter_${groupName}Low_Min`, null, 0);
        const costLowMaxValue = this.configResourceService.getProcessedResourceValue(`Spa_Filter_${groupName}Low_Max`, null, 199.99);
        const costMediumText = this.configResourceService.getProcessedResourceValue(`Spa_Filter_${groupName}Mid_Text`, null, '$200-$999');
        const costMediumMinValue = this.configResourceService.getProcessedResourceValue(`Spa_Filter_${groupName}Mid_Min`, null, 200);
        const costMediumMaxValue = this.configResourceService.getProcessedResourceValue(`Spa_Filter_${groupName}Mid_Max`, null, 999.99);
        const costHighText = this.configResourceService.getProcessedResourceValue(`Spa_Filter_${groupName}High_Text`, null, '$1000+');
        const costHighMinValue = this.configResourceService.getProcessedResourceValue(`Spa_Filter_${groupName}High_Min`, null, 1000);
        const costHighMaxValue = this.configResourceService.getProcessedResourceValue(`Spa_Filter_${groupName}High_Max`, null, 999999);
        const costFilter = [
            {
                label: costLowText,
                value: {
                    name: `${groupName}Low`,
                    value: costLowMinValue,
                    minValue: costLowMinValue,
                    maxValue: costLowMaxValue
                },
                disabled: false
            },
            {
                label: costMediumText,
                value: {
                    name: `${groupName}Medium`,
                    value: costMediumMinValue,
                    minValue: costMediumMinValue,
                    maxValue: costMediumMaxValue
                },
                disabled: false
            },
            {
                label: costHighText,
                value: {
                    name: `${groupName}High`,
                    value: costHighMinValue,
                    minValue: costHighMinValue,
                    maxValue: costHighMaxValue
                },
                disabled: false
            }
        ];
        return costFilter;
    }
    getSNPBaseControls$(filterList$) {
        return this.getLatestValuesForFilterControls$(filterList$, this.plansService.getAllPlans$()).pipe(map(([[plans, hasMedSupAnswers, hasDentalVisionAnswers, hasHospitalIndemnityAnswers, locale, filterList], activeTabType]) => this.planFacade.getFilterKeys(plans, hasMedSupAnswers, activeTabType, FilterKeyType.SNP_BASE_TYPE)), map(filters => filters.map(filter => ({
            label: this.getSNPLabel(filter),
            value: filter.value,
            disabled: filter.disabled,
            defaultReturnValue: false,
            tooltip: this.getSNPFilterItemTooltip(filter.value)
        }))), map(labeledFilters => this.sortFilterControls(labeledFilters, true)), distinctUntilChanged(_isEqual));
    }
    getRidersControls$(filterList$) {
        return this.getLatestValuesForFilterControls$(filterList$).pipe(map(([[plans, hasMedSupAnswers, hasDentalVisionAnswers, hasHospitalIndemnityAnswers, locale, filterList], activeTabType]) => this.planFacade.getNestedFilterKeys(plans, activeTabType, FilterKeyType.RIDERS_PLAN_SUB_TYPE)), map(filters => this.getRidersCombinationLabels(filters).filter(item => this.getRidersLabel(item.value))), map(filters => filters.map(item => ({
            label: this.getRidersLabel(item.value),
            value: {
                predicates: this.getRidersPredicates(item.value)
            },
            disabled: item.disabled,
            defaultReturnValue: false,
            tooltip: this.getRidersTooltip(item.value)
        }))), map(labeledFilters => this.sortFilterControls(labeledFilters, true)), distinctUntilChanged(_isEqual));
    }
    getProvidersNpiControls$(filterList$, allInNetworkLocationsEnabled) {
        return this.getLatestValuesForFilterControls$(filterList$).pipe(map(([[plans, hasMedSupAnswers, hasDentalVisionAnswers, hasHospitalIndemnityAnswers, locale, filterList], activeTabType]) => this.planFacade.getNestedFilterKeys(plans, activeTabType, FilterKeyType.PROVIDERS_NPI)), map(filters => filters.map(item => ({
            label: this.getNpiLabel(item.value),
            value: {
                predicates: [
                    {
                        key: this.getNestedTargetKey(FilterKeyType.PROVIDERS_NPI),
                        value: item.value
                    },
                    {
                        key: allInNetworkLocationsEnabled
                            ? FilterKeyType.PROVIDERS_NPI_IN_NETWORK
                            : this.getNestedTargetKey(FilterKeyType.PROVIDERS_NPI_IN_NETWORK),
                        value: true
                    }
                ]
            },
            disabled: item.disabled,
            defaultReturnValue: false
        }))), map(filters => filters.filter(item => item.label?.length > 0)), map(labeledFilters => this.sortFilterControls(labeledFilters, true)), distinctUntilChanged(_isEqual));
    }
    getSNPSubControls$(filterList$, subSNPFilter, baseSNPValue) {
        return this.getLatestValuesForFilterControls$(filterList$, this.plansService.getAllPlans$()).pipe(map(([[plans, hasMedSupAnswers, hasDentalVisionAnswers, hasHospitalIndemnityAnswers, locale, filterList], activeTabType]) => this.planFacade.getNestedFilterKeys(plans, activeTabType, FilterKeyType.SNP_CATEGORY)), map(filters => filters.filter(control => this.snpService[subSNPFilter](control.value))), map(filters => filters.map(item => ({
            label: this.getSNPSubTypeLabel(item.value),
            value: {
                syncOtherActiveFilter: {
                    key: FilterKeyType.SNP_BASE_TYPE,
                    comparator: ComparatorType.MATCH_ANY,
                    values: baseSNPValue // filter only the data with the same parent
                },
                predicates: [
                    {
                        key: this.getNestedTargetKey(FilterKeyType.SNP_CATEGORY),
                        value: item.value
                    }
                ]
            },
            disabled: item.disabled,
            defaultReturnValue: false,
            tooltip: this.getSNPSubTypeTooltip(item.value)
        }))), map(labeledFilters => this.sortFilterControls(labeledFilters, true)), distinctUntilChanged(_isEqual));
    }
    getDSNPSubControls$(filterList$) {
        return this.getLatestValuesForFilterControls$(filterList$, this.plansService.getAllPlans$()).pipe(map(([[plans, hasMedSupAnswers, hasDentalVisionAnswers, hasHospitalIndemnityAnswers, locale, filterList], activeTabType]) => this.planFacade.getDSNPFilterKeys(plans)), map(filters => this.sortFilterControls(filters, true)), map(filters => {
            return filters.map(filter => ({
                label: filter.label,
                value: { name: FilterKeyType.DSNP_COVERAGE_CODES, value: filter.value },
                disabled: false,
                tooltip: this.getDSNPSubTypeTooltip(filter.value)
            }));
        }), distinctUntilChanged(_isEqual));
    }
    getCSNPBaseControls$(filterList$) {
        return this.getSNPBaseControls$(filterList$).pipe(map(snpBaseFilterControls => snpBaseFilterControls.filter(snpBaseFilterControl => snpBaseFilterControl.value === SNPBaseType.cSNP)), distinctUntilChanged(_isEqual), shareReplay(1));
    }
    getDSNPBaseControls$(filterList$) {
        return this.getSNPBaseControls$(filterList$).pipe(map(snpBaseFilterControls => snpBaseFilterControls.filter(snpBaseFilterControl => snpBaseFilterControl.value === SNPBaseType.dSNP)), distinctUntilChanged(_isEqual));
    }
    getISNPBaseControls$(filterList$) {
        return this.getSNPBaseControls$(filterList$).pipe(map(snpBaseFilterControls => snpBaseFilterControls.filter(snpBaseFilterControl => snpBaseFilterControl.value === SNPBaseType.iSNP)), distinctUntilChanged(_isEqual));
    }
    getFormFilterTypes() {
        return this.filterFormTypes;
    }
    onFilterSelected(filterForm, currentTabFilters, controlName, currentTabType) {
        const selectedFilterValues = filterForm.value[controlName];
        const hiddenFilters = currentTabFilters.filter(filter => !filter.visible);
        const visibleFilters = currentTabFilters.filter(filter => filter.visible);
        if (selectedFilterValues?.length > 0) {
            const selectedFilter = selectedFilterValues.reduce((filter, values) => {
                const filterValues = Array.isArray(values) ? values : [values];
                // Remove any hidden filter values from the selected filters
                const visibleFilterValues = filterValues.filter(filterValue => !hiddenFilters.some(({ values }) => values.includes(filterValue)));
                if (visibleFilterValues.length > 0) {
                    filter.push(...visibleFilterValues);
                }
                return filter;
            }, []);
            let comparator = selectedFilter.length > 1 ? ComparatorType.IN : ComparatorType.EQUAL;
            let multiFilterKeys = [];
            let operatorType = null;
            if (controlName === this.sellableControlName) {
                comparator = ComparatorType.NOT_ANY_MULTI;
                multiFilterKeys = [FilterKeyType.PLAN_ISPUF, FilterKeyType.PLAN_IS_BLACKLISTED, FilterKeyType.PLAN_IS_NON_PERMISSIONED];
            }
            else if (controlName === FilterKeyType.PLAN_EXTRADATA) {
                comparator = ComparatorType.IN_ARRAY;
            }
            else if (COST_FILTER_KEYS.includes(controlName)) {
                comparator = ComparatorType.BETWEEN;
            }
            else if (this.filterPlanMarketingNameEnabled && controlName === this.carriersControlName) {
                this.setSelectedCarrierSession(selectedFilter); // a session variable should be readily available to use in scripting
            }
            else if (controlName === FilterKeyType.PLAN_BENEFIT_NAME) {
                comparator = ComparatorType.PARTIAL_MATCH;
            }
            else if (controlName === this.ridersPlanSubtypeName) {
                comparator = ComparatorType.MATCH_ANY;
            }
            else if (controlName === this.snpSubTypesControlName) {
                comparator = ComparatorType.MATCH_ANY_SETS;
            }
            else if (controlName === this.providersNpiName) {
                comparator = ComparatorType.MATCH_ALL;
            }
            else if (controlName === this.dsnpSubTypesControlName) {
                comparator = ComparatorType.CUSTOM_EXTRADATA_ARRAY_CONTAINS;
            }
            if (controlName === FilterKeyType.PLAN_PREMIUM && currentTabType === PlanTypeAbbreviation.MAPD) {
                multiFilterKeys = [FilterKeyType.PLAN_PREMIUM, FilterKeyType.PLAN_DRUG_PREMIUM];
                operatorType = OperatorType.SUM;
            }
            this.filterService.addFilterToFilterGroups(visibleFilters, new Filter({
                key: this.filterFormTypes[controlName],
                values: selectedFilter,
                comparator,
                defaultReturnValue: this.getDefaultReturnValue(this.filterFormTypes[controlName]),
                visible: true,
                multiKeys: multiFilterKeys,
                operatorType
            }));
        }
        else {
            this.filterService.clearFilterGroupFilter(visibleFilters, this.filterFormTypes[controlName]);
        }
    }
    filterClicked() {
        this.onFilterClickedSubject$.next(null);
    }
    getOnFilterClicked$() {
        return this.onFilterClicked$.pipe(
        // Performance: adding a delay, even if it's 0 milliseconds, breaks up any previous task and creates a new one in the browser.
        // This matters because when tasks are broken up, the browser has more opportunities to respond to higher-priority work, and that includes user interactions.
        delay(0));
    }
    setSelectedCarrierSession(selectedCarrier) {
        localStorage.setItem(this.selectedCarrierSessionKey, selectedCarrier.join(', '));
    }
    getSelectedCarrierSession() {
        return localStorage.getItem(this.selectedCarrierSessionKey);
    }
    updateFilterForm(filterForm, controlName, planFilter) {
        const planFilterType = filterForm.get(controlName);
        if (planFilter?.values) {
            planFilterType.setValue(planFilter.values);
        }
        else {
            planFilterType.setValue([]);
        }
    }
    getCarriersControlName() {
        return this.carriersControlName;
    }
    getplanBenefitsControlName() {
        return this.planBenefitsControlName;
    }
    getSubTypesControlName() {
        return this.subTypesControlName;
    }
    getAncillaryPlanTypeControlName() {
        return this.ancillaryPlanTypeControlName;
    }
    getSnpBaseTypesControlName() {
        return this.snpBaseTypesControlName;
    }
    getProvidersNpiName() {
        return this.providersNpiName;
    }
    getSellableControlName() {
        return this.sellableControlName;
    }
    getRidersPlanSubtypeName() {
        return this.ridersPlanSubtypeName;
    }
    getExtraDataControlName() {
        return this.extraDataControlName;
    }
    getStarRatingControlName() {
        return this.starRatingControlName;
    }
    getCostFilterControlName(filterKeyType) {
        switch (filterKeyType) {
            case FilterKeyType.PLAN_MEDICAL_DEDUCTIBLE:
                return this.medicalDeductibleControlName;
            case FilterKeyType.PLAN_MAXIMUM_OUT_POCKET_COST:
                return this.maximumOutOfPocketCostControlName;
            case FilterKeyType.PLAN_PHARMACY_DEDUCTIBLE:
                return this.drugDeductibleControlName;
            case FilterKeyType.PLAN_PREMIUM:
                return this.medicalPremiumControlName;
            case FilterKeyType.PLAN_DRUG_PREMIUM:
                return this.drugPremiumControlName;
            default:
                return null;
        }
    }
    getSNPSubTypesControlName() {
        return this.snpSubTypesControlName;
    }
    getDSNPSubTypesControlName() {
        return this.dsnpSubTypesControlName;
    }
    ngOnDestroy() {
        this.destroy$.next(true);
    }
    getRidersLabelForTags(filters) {
        const riderCombinations = this.getRidersCombinationLabels(filters);
        const matchingItem = riderCombinations?.find(item => this.getRidersLabel(item.value));
        return matchingItem ? this.getRidersLabel(matchingItem.value) : undefined;
    }
    getSNPBaseLabelForTags(filter) {
        return this.getSNPLabel(filter);
    }
    getSNPSubTypeLabelForTags(snpValues) {
        if ('predicates' in snpValues && snpValues?.predicates?.length) {
            const baseType = snpValues?.predicates.find(predicate => this.getSNPSubTypeLabel(predicate?.value));
            return this.getSNPSubTypeLabel(baseType?.value);
        }
        else if ('name' in snpValues && snpValues.name === FilterKeyType.DSNP_COVERAGE_CODES) {
            return DSNPCodes[snpValues.value];
        }
        return '';
    }
    unionArrays(arr1, arr2) {
        const map = new Map();
        for (const item of [...arr1, ...arr2]) {
            map.set(JSON.stringify(item), item);
        }
        return Array.from(map.values());
    }
    getLatestValuesForFilterControls$(filterList$, plans$) {
        return combineLatest([
            plans$ ?? this.plans$,
            this.hasMedSupAnswers$,
            this.hasDentalVisionAnswers$,
            this.hasHospitalIndemnityAnswers$,
            this.locale$,
            filterList$
        ]).pipe(distinctUntilChanged(_isEqual), withLatestFrom(this.activeTabType$));
    }
    combineDentalFiltersByLabel(filters, comboPlan) {
        const dentalFilters = filters.filter(filter => filter.label !== PlanSubTypes.Vision);
        const options = {
            individualPlanLabel: this.planFacade.getDentalLabel(),
            individualPlanTooltip: this.planFacade.getDentalTooltip(),
            comboPlanLabel: this.planFacade.getComboPlanLabel(),
            comboPlanTooltip: this.planFacade.getComboPlanTooltip()
        };
        return this.combineFiltersByLabel(this.configureComboFilters(dentalFilters, comboPlan, options));
    }
    combineVisionFiltersByLabel(filters, comboPlan) {
        const visionFilters = filters.filter(filter => filter.label !== PlanSubTypes.Dental);
        const options = {
            individualPlanLabel: this.planFacade.getVisionLabel(),
            individualPlanTooltip: this.planFacade.getVisionTooltip(),
            comboPlanLabel: this.planFacade.getComboPlanLabel(),
            comboPlanTooltip: this.planFacade.getComboPlanTooltip()
        };
        return this.combineFiltersByLabel(this.configureComboFilters(visionFilters, comboPlan, options));
    }
    configureComboFilters(filters, comboPlan, filterControlOptions) {
        return filters.map(filter => {
            const { individualPlanLabel, individualPlanTooltip, comboPlanLabel, comboPlanTooltip } = filterControlOptions;
            const selectedFilterValue = Array.isArray(filter.value) ? filter.value : [filter.value];
            const isComboPlan = selectedFilterValue.every(value => comboPlan.includes(value));
            const toolTip = isComboPlan ? comboPlanTooltip : individualPlanTooltip;
            if (toolTip.length > 0) {
                filter.tooltip = toolTip;
            }
            filter.label = isComboPlan ? comboPlanLabel : individualPlanLabel;
            return filter;
        });
    }
    combineFiltersByLabel(filters) {
        return Object.values(filters.reduce((combinedByLabel, filter) => {
            const selectedFilter = combinedByLabel[filter.label];
            if (selectedFilter) {
                const selectedFilterValue = Array.isArray(selectedFilter.value) ? selectedFilter.value : [selectedFilter.value];
                const uniqueFilterValues = new Set(Array.isArray(filter.value) ? [...selectedFilterValue, ...filter.value] : [...selectedFilterValue, filter.value]);
                selectedFilter.value = Array.from(uniqueFilterValues);
            }
            else {
                combinedByLabel[filter.label] = filter;
            }
            return combinedByLabel;
        }, {}));
    }
    getSNPFilterItemTooltip(id) {
        if (id === SNPBaseType.cSNP) {
            return this.configResourceService.getProcessedResourceValue('Spa_PlanCard_CSNP_Tooltip_Text', null, 'Chronic Condition Special Needs Plan – This plan is designed for an individual with a severe or disabling chronic condition, as specified by CMS.');
        }
        if (id === SNPBaseType.dSNP) {
            return this.configResourceService.getProcessedResourceValue('Spa_PlanCard_DSNP_Tooltip_Text', null, 'Dual Eligible Special Needs Plan – This plan is designed for an individual eligible for both Medicare and Medicaid.');
        }
        if (id === SNPBaseType.iSNP) {
            return this.configResourceService.getProcessedResourceValue('Spa_PlanCard_ISNP_Tooltip_Text', null, 'Institutional Special Needs Plan – This plan is designed for an individual residing in a long term care facility.');
        }
    }
    sortFilterControls(filters, orderByAsc) {
        return filters.sort((a, b) => {
            const labelA = a.label.toLocaleLowerCase();
            const labelB = b.label.toLocaleLowerCase();
            if (labelA < labelB) {
                return orderByAsc ? -1 : 1;
            }
            if (labelA > labelB) {
                return orderByAsc ? 1 : -1;
            }
            return 0;
        });
    }
    sortNumericStringDropdownItems(filters, orderByAsc) {
        return filters.sort((a, b) => {
            const displayValueA = a.displayValue.toLocaleLowerCase();
            const evaluatedA = displayValueA.match(/(\d+)/g)?.length && displayValueA.match(/(\d+)/g)[0];
            const displayValueB = b.displayValue.toLocaleLowerCase();
            const evaluatedB = displayValueB.match(/(\d+)/g)?.length && displayValueB.match(/(\d+)/g)[0];
            const numericValueFromEvaluatedA = Number(evaluatedA);
            const numericValueFromEvaluatedB = Number(evaluatedB);
            if (numericValueFromEvaluatedA < numericValueFromEvaluatedB) {
                return orderByAsc ? -1 : 1;
            }
            if (numericValueFromEvaluatedA > numericValueFromEvaluatedB) {
                return orderByAsc ? 1 : -1;
            }
            return 0;
        });
    }
    initSNPLabels() {
        this.snpBaseLabels = {
            [`${SNPBaseType.cSNP}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_CSNP_Label', null, 'Chronic condition'),
            [`${SNPBaseType.dSNP}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_DSNP_Label', null, 'Medicare and Medicaid'),
            [`${SNPBaseType.iSNP}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_ISNP_Label', null, 'Long term care')
        };
    }
    initSNPTooltips() {
        this.snpSubTypeTooltips = {
            [`${SNPSubType.CHRONIC_DEPENDENCE}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_ChronicDependence_SNPTooltip_Text', null, ''),
            [`${SNPSubType.AUTOIMMUNE_DISORDERS}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_AutoImmune_SNPTooltip_Text', null, 'Limited to: Polyarteritis nodosa, Polymyalgia rheumatica, Polymyositis, Rheumatoid arthritis, and Systemic lupus erythematosus'),
            [`${SNPSubType.CANCER}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_Cancer_SNPTooltip_Text', null, ''),
            [`${SNPSubType.CARDIOVASCULAR}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_Cardiovascular_SNPTooltip_Text', null, 'Limited to: Cardiac arrhythmias, Coronary artery disease, Peripheral vascular disease, and Chronic venous thromboembolic disorder'),
            [`${SNPSubType.CHRONIC_HEART_FAILURE}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_ChronicHeartFailure_SNPTooltip_Text', null, ''),
            [`${SNPSubType.DEMENTIA}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_Dementia_SNPTooltip_Text', null, ''),
            [`${SNPSubType.DIABETES}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_Diabetes_SNPTooltip_Text', null, ''),
            [`${SNPSubType.END_STAGE_LIVER}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_EndStageLiver_SNPTooltip_Text', null, ''),
            [`${SNPSubType.END_STAGE_RENAL}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_EndStageRenal_SNPTooltip_Text', null, ''),
            [`${SNPSubType.SEVERE_HEMATOLOGIC}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_Hematologic_SNPTooltip_Text', null, 'Limited to: Aplastic anemia, Hemophilia, Immune thrombocytopenic purpura, Myelodysplatic syndrome, Sickle-cell disease (excluding sickle-cell trait), and Chronic venous thromboembolic disorder'),
            [`${SNPSubType.HIV_AND_AIDS}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_HIVAIDS_SNPTooltip_Text', null, ''),
            [`${SNPSubType.CHRONIC_LUNG}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_ChronicLung_SNPTooltip_Text', null, 'Limited to: Asthma, Chronic bronchitis, Emphysema, Pulmonary fibrosis, and Pulmonary hypertension'),
            [`${SNPSubType.CHRONIC_MENTAL_HEALTH}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_ChronicMentalHealth_SNPTooltip_Text', null, 'Limited to: Bipolar disorders, Major depressive disorders, Paranoid disorder, Schizophrenia, and Schizoaffective disorder'),
            [`${SNPSubType.NEUROLOGIC}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_Neurologic_SNPTooltip_Text', null, 'Limited to: Amyotrophic lateral sclerosis (ALS), Epilepsy, Extensive paralysis (i.e., hemiplegia, quadriplegia, paraplegia, monoplegia), Huntington’s disease, Multiple sclerosis, Parkinson’s disease, Polyneuropathy, Spinal stenosis, and Stroke-related neurologic deficit'),
            [`${SNPSubType.STROKE}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_Stroke_SNPTooltip_Text', null, ''),
            [`${SNPSubType.NURSING_HOME}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_NursingHome_SNPTooltip_Text', null, ''),
            [`${SNPSubType.REQUIRES_NURSING_CARE}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_RequiresNursingCare_SNPTooltip_Text', null, '')
        };
        this.dsnpSubTypeTooltips = {
            '01': this.configResourceService.getProcessedResourceValue('Spa_DSNP_QMBTooltip_Text', null, 'QMB Only. Partial Benefit. Member makes too much for proper low income Medicare. Medicaid pays Medicare Part A premiums, if any, and Medicare Part B premiums.'),
            '02': this.configResourceService.getProcessedResourceValue('Spa_DSNP_QMBPlusTooltip_Text', null, 'QMBs plus full Medicaid (QMB Plus) – Full Benefit. Medicaid pays Medicare Part A premiums, if any, and Medicare Part B premiums.'),
            '03': this.configResourceService.getProcessedResourceValue('Spa_DSNP_SLMBTooltip_Text', null, 'Specified Low-Income Medicare Beneficiaries (SLMB) – Partial Benefit. Members have income between 100% and 120% of the FPL. Medicaid pays only the Medicare Part B premiums.'),
            '04': this.configResourceService.getProcessedResourceValue('Spa_DSNP_SLMBPlusTooltip_Text', null, 'SLMBs plus full Medicaid (SLMB Plus) – Full Benefit. Medicaid pays Medicare Part B premiums, and provides full Medicaid benefits.'),
            '05': this.configResourceService.getProcessedResourceValue('Spa_DSNP_QDWITooltip_Text', null, 'Qualified Disabled and Working Individuals (QDWI) – Partial Benefit. Members have income up to 200% of the FPL. Medicaid pays the Medicare Part A premiums only.'),
            '06': this.configResourceService.getProcessedResourceValue('Spa_DSNP_QITooltip_Text', null, 'Qualifying Individuals (Qis) – Partial Benefit. Members have income between 120% and 135% of the FPL. Medicaid pays Medicare Part B premiums, if their state has the funds.'),
            '08': this.configResourceService.getProcessedResourceValue('Spa_DSNP_FBDETooltip_Text', null, 'Full Benefit Dual Eligible (FBDE) – Full Benefit. Members are enrolled in Medicare Part A and/or Part B, and qualify for full Medicaid benefits.')
        };
    }
    initSNPSubTypeLabels() {
        this.snpSubTypeLabels = {
            [`${SNPSubType.CHRONIC_DEPENDENCE}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_ChronicDependence_SNPLabel_Text', null, 'Chronic alcohol and other drug dependence'),
            [`${SNPSubType.AUTOIMMUNE_DISORDERS}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_AutoImmune_SNPLabel_Text', null, 'Autoimmune disorders'),
            [`${SNPSubType.CANCER}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_Cancer_SNPLabel_Text', null, 'Cancer (excluding pre-cancer conditions)'),
            [`${SNPSubType.CARDIOVASCULAR}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_Cardiovascular_SNPLabel_Text', null, 'Cardiovascular disorders'),
            [`${SNPSubType.CHRONIC_HEART_FAILURE}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_ChronicHeartFailure_SNPLabel_Text', null, 'Chronic heart failure'),
            [`${SNPSubType.DEMENTIA}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_Dementia_SNPLabel_Text', null, 'Dementia'),
            [`${SNPSubType.DIABETES}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_Diabetes_SNPLabel_Text', null, 'Diabetes mellitus'),
            [`${SNPSubType.END_STAGE_LIVER}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_EndStageLiver_SNPLabel_Text', null, 'End-stage liver disease'),
            [`${SNPSubType.END_STAGE_RENAL}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_EndStageRenal_SNPLabel_Text', null, 'End-Stage Renal Disease (ESRD) requiring dialysis (any mode of dialysis)'),
            [`${SNPSubType.SEVERE_HEMATOLOGIC}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_Hematologic_SNPLabel_Text', null, 'Severe hematologic disorders'),
            [`${SNPSubType.HIV_AND_AIDS}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_HIVAIDS_SNPLabel_Text', null, 'HIV/AIDS'),
            [`${SNPSubType.CHRONIC_LUNG}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_ChronicLung_SNPLabel_Text', null, 'Chronic lung disorders'),
            [`${SNPSubType.CHRONIC_MENTAL_HEALTH}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_ChronicMentalHealth_SNPLabel_Text', null, 'Chronic and disabling mental health conditions'),
            [`${SNPSubType.NEUROLOGIC}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_Neurologic_SNPLabel_Text', null, 'Neurologic disorders'),
            [`${SNPSubType.STROKE}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_Stroke_SNPLabel_Text', null, 'Stroke'),
            [`${SNPSubType.NURSING_HOME}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_NursingHome_SNPLabel_Text', null, 'Nursing home'),
            [`${SNPSubType.REQUIRES_NURSING_CARE}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_RequiresNursingCare_SNPLabel_Text', null, 'Require nursing care at home')
        };
    }
    getSNPLabel(filter) {
        return this.snpBaseLabels[`${filter.label}`];
    }
    getSNPSubTypeTooltip(id) {
        return this.snpSubTypeTooltips[`${id}`];
    }
    getDSNPSubTypeTooltip(id) {
        return this.dsnpSubTypeTooltips[id];
    }
    getSNPSubTypeLabel(id) {
        return this.snpSubTypeLabels[`${id}`];
    }
    availableBenefits(filterList, plans, activeTabType, defaultPlanBenefitFilters) {
        let planList = [];
        // if the filterList has the object for PUF then it'll filtered out only the PUF plans/Carriers.
        const filterPUF = filterList.filter(plan => plan.key === FilterKeyType.PLAN_ISPUF && plan.comparator === ComparatorType.NOT_EQUAL);
        if (filterList.some(plan => plan.values?.some(value => value === PlanTypeAbbreviation.PDP || value === PlanTypeAbbreviation.MA || value === PlanTypeAbbreviation.MAPD) && filterPUF.length)) {
            planList = plans.filter(plan => !plan.isPUF);
        }
        else {
            planList = plans;
        }
        const availableBenefitsFilterList = [];
        const plansByActiveTab = planList.filter(plan => plan.planTypeAbbreviation === activeTabType);
        if (plansByActiveTab.length) {
            plansByActiveTab.forEach(plan => plan.planDataFields.forEach(planData => {
                const defaultBenefitFiltersIndex = defaultPlanBenefitFilters.findIndex(planBenefit => planBenefit.value === planData.benefitID && planBenefit.enable);
                if (planData.isCovered && defaultBenefitFiltersIndex !== -1) {
                    const benefitExists = availableBenefitsFilterList.some(benefit => benefit.value?.benefitID === planData.benefitID && benefit.value?.isCovered === planData.isCovered);
                    if (!benefitExists) {
                        availableBenefitsFilterList.push({
                            label: defaultPlanBenefitFilters[defaultBenefitFiltersIndex].name,
                            value: { benefitID: planData.benefitID, isCovered: planData.isCovered },
                            disabled: false,
                            tooltip: defaultPlanBenefitFilters[defaultBenefitFiltersIndex].tooltip
                        });
                    }
                }
            }));
        }
        return availableBenefitsFilterList;
    }
    getNpiLabel(npi) {
        const provider = this.guidedHelpService.getSelectedProviders().find(item => `${item.id}` === npi);
        if (provider?.firstName && provider?.lastName) {
            const npiLabel = `${provider.title ? this.stringFormatUtilityService.capitalizeName(provider.title) : ''} ${provider.firstName ? this.stringFormatUtilityService.capitalizeName(provider.firstName) : ''} ${provider.middleName ? this.stringFormatUtilityService.capitalizeName(provider.middleName) : ''} ${provider.lastName ? this.stringFormatUtilityService.capitalizeName(provider.lastName) : ''}`;
            return npiLabel.replace(/\s\s+/g, ' ').trim(); // removed extra spaces between label text.
        }
        else if (provider?.organizationName) {
            return `${this.stringFormatUtilityService.capitalizeName(provider.organizationName)}`;
        }
        return '';
    }
    getRidersTooltip(filter) {
        return this.ridersTooltips[filter];
    }
    initRidersLabels() {
        this.ridersBaseLabels = {
            [`${RiderSubTypes.DentalRider}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_Dental_Rider_Display_Text', null, RiderSubTypes.Dental),
            [`${RiderSubTypes.Vision}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_VisionLabel_Text', null, RiderSubTypes.Vision),
            [`${RiderSubTypes.Hearing}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_Hearing_Rider_Display_Text', null, RiderSubTypes.Hearing)
        };
    }
    initRidersTooltips() {
        this.ridersTooltips = {
            [`${RiderSubTypes.DentalRider}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_Dental_Tooltip_Text', null, 'This plan includes optional add-on dental coverage that can be purchased for an additional cost'),
            [`${RiderSubTypes.Vision}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_Vision_Tooltip_Text', null, 'This plan includes optional add-on vision coverage that can be purchased for an additional cost'),
            [`${RiderSubTypes.Hearing}`]: this.configResourceService.getProcessedResourceValue('Spa_Site_Hearing_Tooltip_Text', null, 'This plan includes optional add-on hearing coverage that can be purchased for an additional cost')
        };
    }
    availableCarriers(filterList, plans, hasAnswers, activeTabType, filterType) {
        let planList = [];
        // if the filterList has the object for PUF then it'll filtered out only the PUF plans/Carriers.
        const filterPUF = filterList.filter(plan => plan.key === FilterKeyType.PLAN_ISPUF && plan.comparator === ComparatorType.NOT_ANY_MULTI);
        if (filterList.some(plan => plan.values?.some(value => value === PlanTypeAbbreviation.PDP || value === PlanTypeAbbreviation.MA || value === PlanTypeAbbreviation.MAPD) && filterPUF.length)) {
            planList = plans.filter(plan => !plan.isPUF);
        }
        else {
            planList = plans;
        }
        return this.planFacade.getFilterKeys(planList, hasAnswers, activeTabType, filterType);
    }
    getNestedTargetKey(key) {
        const path = key.split('.');
        return path[path.length - 1];
    }
    getRidersCombinationLabels(filters) {
        const setFilters = [];
        filters.forEach(item => {
            if (item.value === RiderSubTypes.DentalRider) {
                if (!setFilters.some(filter => filter.value === RiderSubTypes.DentalRider)) {
                    setFilters.push(item);
                }
            }
            else if (item.value === RiderSubTypes.Vision) {
                if (!setFilters.some(filter => filter.value === RiderSubTypes.Vision)) {
                    setFilters.push(item);
                }
            }
            else if (item.value === RiderSubTypes.Hearing) {
                if (!setFilters.some(filter => filter.value === RiderSubTypes.Hearing)) {
                    setFilters.push(item);
                }
            }
            else if (item.value === RiderSubTypes.DentalVision) {
                if (!setFilters.some(filter => filter.value === RiderSubTypes.Vision)) {
                    setFilters.push({ ...item, value: RiderSubTypes.Vision });
                }
                if (!setFilters.some(filter => filter.value === RiderSubTypes.DentalRider)) {
                    setFilters.push({ ...item, value: RiderSubTypes.DentalRider });
                }
            }
            else if (item.value === RiderSubTypes.DentalHearing) {
                if (!setFilters.some(filter => filter.value === RiderSubTypes.Hearing)) {
                    setFilters.push({ ...item, value: RiderSubTypes.Hearing });
                }
                if (!setFilters.some(filter => filter.value === RiderSubTypes.DentalRider)) {
                    setFilters.push({ ...item, value: RiderSubTypes.DentalRider });
                }
            }
            else if (item.value === RiderSubTypes.VisionHearing) {
                if (!setFilters.some(filter => filter.value === RiderSubTypes.Hearing)) {
                    setFilters.push({ ...item, value: RiderSubTypes.Hearing });
                }
                if (!setFilters.some(filter => filter.value === RiderSubTypes.Vision)) {
                    setFilters.push({ ...item, value: RiderSubTypes.Vision });
                }
            }
            else if (item.value === RiderSubTypes.All) {
                if (!setFilters.some(filter => filter.value === RiderSubTypes.Hearing)) {
                    setFilters.push({ ...item, value: RiderSubTypes.Hearing });
                }
                if (!setFilters.some(filter => filter.value === RiderSubTypes.Vision)) {
                    setFilters.push({ ...item, value: RiderSubTypes.Vision });
                }
                if (!setFilters.some(filter => filter.value === RiderSubTypes.DentalRider)) {
                    setFilters.push({ ...item, value: RiderSubTypes.DentalRider });
                }
            }
        });
        return setFilters;
    }
    getRidersPredicates(filter) {
        const nestedKey = this.getNestedTargetKey(FilterKeyType.RIDERS_PLAN_SUB_TYPE);
        const dentalPredicates = [
            {
                key: nestedKey,
                value: RiderSubTypes.DentalRider
            },
            {
                key: nestedKey,
                value: RiderSubTypes.DentalVision
            },
            {
                key: nestedKey,
                value: RiderSubTypes.DentalHearing
            },
            {
                key: nestedKey,
                value: RiderSubTypes.All
            }
        ];
        const visionPredicates = [
            {
                key: nestedKey,
                value: RiderSubTypes.Vision
            },
            {
                key: nestedKey,
                value: RiderSubTypes.VisionHearing
            },
            {
                key: nestedKey,
                value: RiderSubTypes.DentalVision
            },
            {
                key: nestedKey,
                value: RiderSubTypes.All
            }
        ];
        const hearingPredicates = [
            {
                key: nestedKey,
                value: RiderSubTypes.Hearing
            },
            {
                key: nestedKey,
                value: RiderSubTypes.DentalHearing
            },
            {
                key: nestedKey,
                value: RiderSubTypes.VisionHearing
            },
            {
                key: nestedKey,
                value: RiderSubTypes.All
            }
        ];
        switch (filter) {
            case RiderSubTypes.DentalRider:
                return dentalPredicates;
            case RiderSubTypes.Hearing:
                return hearingPredicates;
            case RiderSubTypes.Vision:
                return visionPredicates;
            default:
                return [];
        }
    }
    getRidersLabel(filter) {
        return this.ridersBaseLabels[filter];
    }
    getDefaultReturnValue(controlName) {
        return ![FilterKeyType.SNP_BASE_TYPE, FilterKeyType.SNP_CATEGORY, FilterKeyType.DSNP_COVERAGE_CODES].includes(controlName);
    }
}
PlanFilterItemsFacade.ɵfac = function PlanFilterItemsFacade_Factory(t) { return new (t || PlanFilterItemsFacade)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.GuidedHelpService), i0.ɵɵinject(PlanFacade), i0.ɵɵinject(i1.StringFormatUtilityService), i0.ɵɵinject(i1.FilterService), i0.ɵɵinject(i1.LocaleService), i0.ɵɵinject(i1.SNPService), i0.ɵɵinject(i1.PlansService)); };
PlanFilterItemsFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlanFilterItemsFacade, factory: PlanFilterItemsFacade.ɵfac, providedIn: 'root' });
__decorate([
    MemoizeObservable()
], PlanFilterItemsFacade.prototype, "getCarriersControls$", null);
__decorate([
    MemoizeObservable()
], PlanFilterItemsFacade.prototype, "getPlanBenefitsControls$", null);
__decorate([
    MemoizeObservable()
], PlanFilterItemsFacade.prototype, "getPlanSubTypeControls$", null);
__decorate([
    MemoizeObservable()
], PlanFilterItemsFacade.prototype, "getAncillaryPlanTypeControls$", null);
__decorate([
    MemoizeObservable()
], PlanFilterItemsFacade.prototype, "getPlanSellableControls$", null);
__decorate([
    MemoizeObservable()
], PlanFilterItemsFacade.prototype, "getModelDrugProgramControls$", null);
__decorate([
    MemoizeObservable()
], PlanFilterItemsFacade.prototype, "getCostFilterControl$", null);
__decorate([
    MemoizeObservable()
], PlanFilterItemsFacade.prototype, "getSNPBaseControls$", null);
__decorate([
    MemoizeObservable()
], PlanFilterItemsFacade.prototype, "getRidersControls$", null);
__decorate([
    MemoizeObservable()
], PlanFilterItemsFacade.prototype, "getProvidersNpiControls$", null);
__decorate([
    MemoizeObservable()
], PlanFilterItemsFacade.prototype, "getSNPSubControls$", null);
__decorate([
    MemoizeObservable()
], PlanFilterItemsFacade.prototype, "getDSNPSubControls$", null);
__decorate([
    MemoizeObservable()
], PlanFilterItemsFacade.prototype, "getCSNPBaseControls$", null);
__decorate([
    MemoizeObservable()
], PlanFilterItemsFacade.prototype, "getDSNPBaseControls$", null);
__decorate([
    MemoizeObservable()
], PlanFilterItemsFacade.prototype, "getISNPBaseControls$", null);
__decorate([
    MemoizeObservable()
], PlanFilterItemsFacade.prototype, "getLatestValuesForFilterControls$", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanFilterItemsFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i2.Store }, { type: i1.ConfigResourceService }, { type: i1.GuidedHelpService }, { type: PlanFacade }, { type: i1.StringFormatUtilityService }, { type: i1.FilterService }, { type: i1.LocaleService }, { type: i1.SNPService }, { type: i1.PlansService }]; }, { getCarriersControls$: [], getPlanBenefitsControls$: [], getPlanSubTypeControls$: [], getAncillaryPlanTypeControls$: [], getPlanSellableControls$: [], getModelDrugProgramControls$: [], getCostFilterControl$: [], getSNPBaseControls$: [], getRidersControls$: [], getProvidersNpiControls$: [], getSNPSubControls$: [], getDSNPSubControls$: [], getCSNPBaseControls$: [], getDSNPBaseControls$: [], getISNPBaseControls$: [], getLatestValuesForFilterControls$: [] }); })();

function SNPCategoryToggleComponent_ng_container_0_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-checkbox-item", 5);
    i0.ɵɵlistener("toggleChecked", function SNPCategoryToggleComponent_ng_container_0_div_1_ng_container_2_Template_vnext_checkbox_item_toggleChecked_1_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r5.toggleSnpChecked($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("item", item_r4)("selectedItems", ctx_r2.snpSelectedItems)("showTooltipUnderline", ctx_r2.showTooltipUnderline)("showTooltipIcon", ctx_r2.showTooltipIcon)("enablePrimaryColor", ctx_r2.enablePrimaryColor)("enableNoteStyle", false);
} }
function SNPCategoryToggleComponent_ng_container_0_div_1_ng_container_3_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-checkbox-item", 5);
    i0.ɵɵlistener("toggleChecked", function SNPCategoryToggleComponent_ng_container_0_div_1_ng_container_3_div_1_ng_container_2_Template_vnext_checkbox_item_toggleChecked_1_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r10.toggleSubSnpChecked($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r9 = ctx.$implicit;
    const ctx_r8 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("item", item_r9)("selectedItems", ctx_r8.selectedSubSnpItems)("showTooltipUnderline", ctx_r8.showTooltipUnderline)("showTooltipIcon", ctx_r8.showTooltipIcon)("enablePrimaryColor", ctx_r8.enablePrimaryColor)("enableNoteStyle", false);
} }
const _c0$3p = function (a0) { return { "allow-overflow": a0 }; };
function SNPCategoryToggleComponent_ng_container_0_div_1_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8);
    i0.ɵɵtemplate(2, SNPCategoryToggleComponent_ng_container_0_div_1_ng_container_3_div_1_ng_container_2_Template, 2, 6, "ng-container", 4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$3p, ctx_r7.showTooltipUnderline || ctx_r7.showTooltipIcon));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r7.snpSubItems)("ngForTrackBy", ctx_r7.trackBySubSnpFilterName);
} }
function SNPCategoryToggleComponent_ng_container_0_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SNPCategoryToggleComponent_ng_container_0_div_1_ng_container_3_div_1_Template, 3, 5, "div", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r3.snpSubItems == null ? null : ctx_r3.snpSubItems.length) >= 1);
} }
const _c1$1N = function (a0, a1) { return { "pl-3": a0, "disable-click": a1 }; };
function SNPCategoryToggleComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtemplate(2, SNPCategoryToggleComponent_ng_container_0_div_1_ng_container_2_Template, 2, 6, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SNPCategoryToggleComponent_ng_container_0_div_1_ng_container_3_Template, 2, 1, "ng-container", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c1$1N, ctx_r1.planFilterModalEnabled, !ctx_r1.snpVisibility));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$3p, ctx_r1.showTooltipUnderline || ctx_r1.showTooltipIcon));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.snpItems)("ngForTrackBy", ctx_r1.trackBySubSnpFilterName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.snpSubItems);
} }
function SNPCategoryToggleComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SNPCategoryToggleComponent_ng_container_0_div_1_Template, 4, 10, "div", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r0.snpItems == null ? null : ctx_r0.snpItems.length) >= 1);
} }
class SNPCategoryToggleComponent {
    constructor(cdr, planFilterItemsFacade) {
        this.cdr = cdr;
        this.planFilterItemsFacade = planFilterItemsFacade;
        this.snpFilterSelectedEvent = new EventEmitter();
        this.snpSelectedItems = [];
        this.selectedSubSnpItems = [];
    }
    ngOnChanges(changes) {
        const { clearSnpFilters, snpBaseTypesControlValue, snpSubTypesControlValue } = changes;
        if (clearSnpFilters?.firstChange === false && clearSnpFilters?.currentValue !== clearSnpFilters?.previousValue) {
            if (this.clearSnpFilters) {
                this.uncheckFilters();
            }
        }
        if ((snpBaseTypesControlValue && !_isEqual(snpBaseTypesControlValue?.currentValue, snpBaseTypesControlValue?.previousValue)) ||
            (snpSubTypesControlValue && !_isEqual(snpSubTypesControlValue?.currentValue, snpSubTypesControlValue?.previousValue))) {
            this.snpSelectedItems = this.snpBaseTypesControlValue || [];
            this.selectedSubSnpItems = this.snpSubTypesControlValue || [];
        }
    }
    onSnpFilterSelection() {
        this.snpFilterSelectedEvent.emit({
            snpBaseTypesControlName: this.snpBaseTypesControlName,
            snpSelectedItems: this.snpSelectedItems,
            snpSubTypesControlName: this.snpSubTypesControlName,
            subSnpSelectedItems: this.selectedSubSnpItems
        });
    }
    uncheckFilters() {
        this.snpSelectedItems = [];
        this.selectedSubSnpItems = [];
        this.onSnpFilterSelection();
        this.cdr.markForCheck();
    }
    toggleSnpChecked(item) {
        const selectedValue = item.value;
        const hasSelectedItem = this.snpSelectedItems?.some(snpItem => snpItem === selectedValue);
        if (hasSelectedItem) {
            this.snpSelectedItems = this.snpSelectedItems?.filter(snpItem => snpItem !== selectedValue) ?? [];
            if (this.snpSelectedItems?.length) {
                this.selectedSubSnpItems =
                    this.selectedSubSnpItems?.filter(snpItem => !this.snpSubItems?.some(removeSnpSubItem => _isEqual(removeSnpSubItem?.value, snpItem))) ?? [];
            }
            else {
                this.selectedSubSnpItems = [];
            }
        }
        else {
            this.snpSelectedItems = [...(this.snpSelectedItems ?? []), selectedValue];
            this.selectedSubSnpItems = this.planFilterItemsFacade.unionArrays(this.selectedSubSnpItems, this.snpSubItems?.map(snpItem => ({ ...snpItem.value })) ?? []);
        }
        this.onSnpFilterSelection();
        this.cdr.markForCheck();
    }
    toggleSubSnpChecked(item) {
        const selectedValues = Array.isArray(item.value) ? item.value : [item.value];
        let updatedItems = [...this.selectedSubSnpItems];
        selectedValues.forEach(selectedValue => {
            const hasSelectedItem = updatedItems.some(selectedItem => _isEqual(selectedItem, item?.value));
            if (hasSelectedItem) {
                updatedItems = updatedItems?.filter(selectedItem => !_isEqual(selectedItem, item?.value)) ?? [];
            }
            else {
                if (typeof selectedValue === 'object') {
                    updatedItems.push({ ...selectedValue });
                }
                else {
                    updatedItems.push(selectedValue);
                }
            }
        });
        this.selectedSubSnpItems = updatedItems;
        this.onSnpFilterSelection();
        this.cdr.markForCheck();
    }
    trackBySnpFilterName(index, filterOption) {
        return filterOption?.label;
    }
    trackBySubSnpFilterName(index, filterOption) {
        return filterOption?.label;
    }
}
SNPCategoryToggleComponent.ɵfac = function SNPCategoryToggleComponent_Factory(t) { return new (t || SNPCategoryToggleComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlanFilterItemsFacade)); };
SNPCategoryToggleComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SNPCategoryToggleComponent, selectors: [["vnext-snp-category-toggle"]], inputs: { snpItems: "snpItems", snpSubItems: "snpSubItems", snpBaseTypesControlName: "snpBaseTypesControlName", snpSubTypesControlName: "snpSubTypesControlName", snpVisibility: "snpVisibility", planFilterModalEnabled: "planFilterModalEnabled", clearSnpFilters: "clearSnpFilters", snpBaseTypesControlValue: "snpBaseTypesControlValue", snpSubTypesControlValue: "snpSubTypesControlValue", showTooltipIcon: "showTooltipIcon", showTooltipUnderline: "showTooltipUnderline", enablePrimaryColor: "enablePrimaryColor" }, outputs: { snpFilterSelectedEvent: "snpFilterSelectedEvent" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "ngClass", 4, "ngIf"], [3, "ngClass"], [1, "p-0", 3, "ngClass"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "plan-filter-items", 3, "item", "selectedItems", "showTooltipUnderline", "showTooltipIcon", "enablePrimaryColor", "enableNoteStyle", "toggleChecked"], ["class", "ml-3", 4, "ngIf"], [1, "ml-3"], [1, "py-0", 3, "ngClass"]], template: function SNPCategoryToggleComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SNPCategoryToggleComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.snpItems);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, CheckBoxItemComponent], styles: [".disable-click[_ngcontent-%COMP%]{pointer-events:none;opacity:.7}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SNPCategoryToggleComponent, [{
        type: Component,
        args: [{ selector: 'vnext-snp-category-toggle', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"snpItems\">\r\n  <div *ngIf=\"snpItems?.length >= 1\" [ngClass]=\"{ 'pl-3': planFilterModalEnabled, 'disable-click': !snpVisibility }\">\r\n    <div class=\"p-0\" [ngClass]=\"{ 'allow-overflow': showTooltipUnderline || showTooltipIcon }\">\r\n      <ng-container *ngFor=\"let item of snpItems; trackBy: trackBySubSnpFilterName\">\r\n        <vnext-checkbox-item\r\n          class=\"plan-filter-items\"\r\n          [item]=\"item\"\r\n          [selectedItems]=\"snpSelectedItems\"\r\n          [showTooltipUnderline]=\"showTooltipUnderline\"\r\n          [showTooltipIcon]=\"showTooltipIcon\"\r\n          [enablePrimaryColor]=\"enablePrimaryColor\"\r\n          [enableNoteStyle]=\"false\"\r\n          (toggleChecked)=\"toggleSnpChecked($event)\"\r\n        ></vnext-checkbox-item>\r\n      </ng-container>\r\n    </div>\r\n\r\n    <ng-container *ngIf=\"snpSubItems\">\r\n      <div *ngIf=\"snpSubItems?.length >= 1\" class=\"ml-3\">\r\n        <div class=\"py-0\" [ngClass]=\"{ 'allow-overflow': showTooltipUnderline || showTooltipIcon }\">\r\n          <ng-container *ngFor=\"let item of snpSubItems; trackBy: trackBySubSnpFilterName\">\r\n            <vnext-checkbox-item\r\n              class=\"plan-filter-items\"\r\n              [item]=\"item\"\r\n              [selectedItems]=\"selectedSubSnpItems\"\r\n              [showTooltipUnderline]=\"showTooltipUnderline\"\r\n              [showTooltipIcon]=\"showTooltipIcon\"\r\n              [enablePrimaryColor]=\"enablePrimaryColor\"\r\n              [enableNoteStyle]=\"false\"\r\n              (toggleChecked)=\"toggleSubSnpChecked($event)\"\r\n            ></vnext-checkbox-item>\r\n          </ng-container>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n  </div>\r\n</ng-container>\r\n", styles: [".disable-click{pointer-events:none;opacity:.7}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: PlanFilterItemsFacade }]; }, { snpItems: [{
            type: Input
        }], snpSubItems: [{
            type: Input
        }], snpBaseTypesControlName: [{
            type: Input
        }], snpSubTypesControlName: [{
            type: Input
        }], snpVisibility: [{
            type: Input
        }], planFilterModalEnabled: [{
            type: Input
        }], clearSnpFilters: [{
            type: Input
        }], snpBaseTypesControlValue: [{
            type: Input
        }], snpSubTypesControlValue: [{
            type: Input
        }], showTooltipIcon: [{
            type: Input
        }], showTooltipUnderline: [{
            type: Input
        }], enablePrimaryColor: [{
            type: Input
        }], snpFilterSelectedEvent: [{
            type: Output
        }] }); })();

function SNPToggleComponent_ng_container_0_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵlistener("click", function SNPToggleComponent_ng_container_0_span_1_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r5.toggleSNPPlanVisibility(true)); })("keyup.enter", function SNPToggleComponent_ng_container_0_span_1_Template_span_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.toggleSNPPlanVisibility(true)); });
    i0.ɵɵelement(1, "i", 4);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("role", ctx_r2.linkRoles.BUTTON)("aria-label", ctx_r2.showLinkText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.showLinkText);
} }
function SNPToggleComponent_ng_container_0_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵlistener("click", function SNPToggleComponent_ng_container_0_ng_template_3_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8.toggleSNPPlanVisibility(false)); })("keyup.enter", function SNPToggleComponent_ng_container_0_ng_template_3_Template_span_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.toggleSNPPlanVisibility(false)); });
    i0.ɵɵelement(1, "i", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("role", ctx_r4.linkRoles.BUTTON)("aria-label", ctx_r4.hideLinkText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r4.hideLinkText, " ");
} }
function SNPToggleComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SNPToggleComponent_ng_container_0_span_1_Template, 4, 3, "span", 1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, SNPToggleComponent_ng_container_0_ng_template_3_Template, 3, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r3 = i0.ɵɵreference(4);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.areAllSNPTypesVisible(i0.ɵɵpipeBind1(2, 2, ctx_r0.planListFacade.getVisibleSNPTypes$())))("ngIfElse", _r3);
} }
function SNPToggleComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 6)(2, "input", 7);
    i0.ɵɵlistener("change", function SNPToggleComponent_ng_container_1_Template_input_change_2_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.toggleSNPPlanChangeEvent.emit(!($event == null ? null : $event.target.checked))); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r1.hideAllSnpType.initiallyChecked);
    i0.ɵɵattribute("aria-labelledby", ctx_r1.hideAllSnpType.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", ctx_r1.hideAllSnpType.label);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.hideAllSnpType.label);
} }
class SNPToggleComponent {
    constructor(planListFacade) {
        this.planListFacade = planListFacade;
        this.showCheckbox = false;
        this.toggleSNPPlanChangeEvent = new EventEmitter();
        this.linkRoles = LinkRoles;
    }
    toggleSNPPlanVisibility(snpVisibility) {
        this.planListFacade.toggleSNPPlanVisibility(snpVisibility, this.activeTabType, this.showCheckbox);
    }
    areAllSNPTypesVisible(snpTypeVisibility) {
        return snpTypeVisibility && snpTypeVisibility.dSNP && snpTypeVisibility.cSNP && snpTypeVisibility.iSNP;
    }
}
SNPToggleComponent.ɵfac = function SNPToggleComponent_Factory(t) { return new (t || SNPToggleComponent)(i0.ɵɵdirectiveInject(PlanListFacadeService)); };
SNPToggleComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SNPToggleComponent, selectors: [["vnext-snp-toggle"]], inputs: { filteredPlansHasSNPPlans: "filteredPlansHasSNPPlans", showLinkText: "showLinkText", hideLinkText: "hideLinkText", activeTabType: "activeTabType", showCheckbox: "showCheckbox", hideAllSnpType: "hideAllSnpType" }, outputs: { toggleSNPPlanChangeEvent: "toggleSNPPlanChangeEvent" }, decls: 2, vars: 2, consts: [[4, "ngIf"], ["class", "Spa_Style_Link SNP-link p-1", "tabindex", "0", 3, "click", "keyup.enter", 4, "ngIf", "ngIfElse"], ["hideSNPLink", ""], ["tabindex", "0", 1, "Spa_Style_Link", "SNP-link", "p-1", 3, "click", "keyup.enter"], [1, "fas", "fa-plus-circle", "SNP-link-icon"], [1, "fas", "fa-minus-circle", "SNP-link-icon"], [1, "Spa_Style_Note", "Spa_Style_Small_Font", "Spa_Style_Primary_Color"], ["type", "checkbox", "tabindex", "0", 3, "checked", "change"], [1, "label-text", "pl-1", 3, "id"]], template: function SNPToggleComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SNPToggleComponent_ng_container_0_Template, 5, 4, "ng-container", 0);
        i0.ɵɵtemplate(1, SNPToggleComponent_ng_container_1_Template, 5, 4, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.showCheckbox && ctx.filteredPlansHasSNPPlans);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showCheckbox && ctx.hideAllSnpType);
    } }, dependencies: [i1$2.NgIf, IconAriaAttributesDirective, i1$2.AsyncPipe], styles: [".SNP-link[_ngcontent-%COMP%]{cursor:pointer}.SNP-link-icon[_ngcontent-%COMP%]{margin-right:5px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SNPToggleComponent, [{
        type: Component,
        args: [{ selector: 'vnext-snp-toggle', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"!showCheckbox && filteredPlansHasSNPPlans\">\r\n  <span\r\n    class=\"Spa_Style_Link SNP-link p-1\"\r\n    *ngIf=\"!areAllSNPTypesVisible(planListFacade.getVisibleSNPTypes$() | async); else hideSNPLink\"\r\n    (click)=\"toggleSNPPlanVisibility(true)\"\r\n    (keyup.enter)=\"toggleSNPPlanVisibility(true)\"\r\n    tabindex=\"0\"\r\n    [attr.role]=\"linkRoles.BUTTON\"\r\n    [attr.aria-label]=\"showLinkText\"\r\n  >\r\n    <i class=\"fas fa-plus-circle SNP-link-icon\"></i><span>{{ showLinkText }}</span>\r\n  </span>\r\n  <ng-template #hideSNPLink\r\n    ><span\r\n      class=\"Spa_Style_Link SNP-link p-1\"\r\n      (click)=\"toggleSNPPlanVisibility(false)\"\r\n      (keyup.enter)=\"toggleSNPPlanVisibility(false)\"\r\n      tabindex=\"0\"\r\n      [attr.role]=\"linkRoles.BUTTON\"\r\n      [attr.aria-label]=\"hideLinkText\"\r\n    >\r\n      <i class=\"fas fa-minus-circle SNP-link-icon\"></i>{{ hideLinkText }}\r\n    </span></ng-template\r\n  >\r\n</ng-container>\r\n\r\n<ng-container *ngIf=\"showCheckbox && hideAllSnpType\">\r\n  <label class=\"Spa_Style_Note Spa_Style_Small_Font Spa_Style_Primary_Color\">\r\n    <input\r\n      type=\"checkbox\"\r\n      tabindex=\"0\"\r\n      [checked]=\"hideAllSnpType.initiallyChecked\"\r\n      [attr.aria-labelledby]=\"hideAllSnpType.label\"\r\n      (change)=\"toggleSNPPlanChangeEvent.emit(!$event?.target.checked)\"\r\n    />\r\n    <span [id]=\"hideAllSnpType.label\" class=\"label-text pl-1\">{{ hideAllSnpType.label }}</span>\r\n  </label>\r\n</ng-container>\r\n", styles: [".SNP-link{cursor:pointer}.SNP-link-icon{margin-right:5px}\n"] }]
    }], function () { return [{ type: PlanListFacadeService }]; }, { filteredPlansHasSNPPlans: [{
            type: Input
        }], showLinkText: [{
            type: Input
        }], hideLinkText: [{
            type: Input
        }], activeTabType: [{
            type: Input
        }], showCheckbox: [{
            type: Input
        }], hideAllSnpType: [{
            type: Input
        }], toggleSNPPlanChangeEvent: [{
            type: Output
        }] }); })();

const _c0$3o = function (a0) { return { active: a0 }; };
class TabComponent {
    constructor() {
        this.setFocusToTabEvent = new EventEmitter();
    }
    setFocusToPreviousTabElement(currentIndex, $event) {
        if (this.lastIndex) {
            $event.preventDefault();
            this.setFocusToTabEvent.emit(currentIndex === 0 ? this.lastIndex : currentIndex - 1);
        }
    }
    setFocusToNextTabElement(currentIndex, $event) {
        if (this.lastIndex) {
            $event.preventDefault();
            this.setFocusToTabEvent.emit(currentIndex === this.lastIndex ? 0 : currentIndex + 1);
        }
    }
}
TabComponent.ɵfac = function TabComponent_Factory(t) { return new (t || TabComponent)(); };
TabComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TabComponent, selectors: [["vnext-tab"]], inputs: { title: "title", currentIndex: "currentIndex", lastIndex: "lastIndex", isActiveTab: "isActiveTab", ariaControlsId: "ariaControlsId" }, outputs: { setFocusToTabEvent: "setFocusToTabEvent" }, decls: 3, vars: 9, consts: [["role", "tab", "tabindex", "0", 1, "tab_link", "d-block", "Spa_Style_Primary_Color", 3, "ngClass", "keyup.arrowleft", "keyup.arrowright"]], template: function TabComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "a", 0);
        i0.ɵɵlistener("keyup.arrowleft", function TabComponent_Template_a_keyup_arrowleft_0_listener($event) { return ctx.setFocusToPreviousTabElement(ctx.currentIndex, $event); })("keyup.arrowright", function TabComponent_Template_a_keyup_arrowright_0_listener($event) { return ctx.setFocusToNextTabElement(ctx.currentIndex, $event); });
        i0.ɵɵelementStart(1, "div");
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0$3o, ctx.isActiveTab));
        i0.ɵɵattribute("aria-posinset", ctx.currentIndex + 1)("aria-setsize", ctx.lastIndex + 1)("aria-selected", ctx.isActiveTab)("aria-label", ctx.title)("aria-controls", ctx.ariaControlsId);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
    } }, dependencies: [i1$2.NgClass], styles: [".tab_link[_ngcontent-%COMP%]{padding:1rem .8rem;text-decoration:none}.tab_link[_ngcontent-%COMP%]:hover{text-decoration:none}.tab_link.active[_ngcontent-%COMP%]{font-weight:700}@media (max-width: 992px){.tab_link[_ngcontent-%COMP%]{font-size:var(--Spa_Style_Smaller_Font)}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabComponent, [{
        type: Component,
        args: [{ selector: 'vnext-tab', changeDetection: ChangeDetectionStrategy.OnPush, template: "<a\r\n  role=\"tab\"\r\n  [ngClass]=\"{ active: isActiveTab }\"\r\n  class=\"tab_link d-block Spa_Style_Primary_Color\"\r\n  tabindex=\"0\"\r\n  (keyup.arrowleft)=\"setFocusToPreviousTabElement(currentIndex, $event)\"\r\n  (keyup.arrowright)=\"setFocusToNextTabElement(currentIndex, $event)\"\r\n  [attr.aria-posinset]=\"currentIndex + 1\"\r\n  [attr.aria-setsize]=\"lastIndex + 1\"\r\n  [attr.aria-selected]=\"isActiveTab\"\r\n  [attr.aria-label]=\"title\"\r\n  [attr.aria-controls]=\"ariaControlsId\"\r\n>\r\n  <div>\r\n    {{ title }}\r\n  </div>\r\n</a>\r\n", styles: [".tab_link{padding:1rem .8rem;text-decoration:none}.tab_link:hover{text-decoration:none}.tab_link.active{font-weight:700}@media (max-width: 992px){.tab_link{font-size:var(--Spa_Style_Smaller_Font)}}\n"] }]
    }], null, { title: [{
            type: Input
        }], currentIndex: [{
            type: Input
        }], lastIndex: [{
            type: Input
        }], isActiveTab: [{
            type: Input
        }], ariaControlsId: [{
            type: Input
        }], setFocusToTabEvent: [{
            type: Output
        }] }); })();

const _c0$3n = function (a0) { return { "active Spa_Style_Bold_Weight": a0 }; };
function TabListComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 2);
    i0.ɵɵlistener("click", function TabListComponent_li_1_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r3); const tabDetail_r1 = restoredCtx.$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.setActiveTab(tabDetail_r1)); })("keyup.enter", function TabListComponent_li_1_Template_li_keyup_enter_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r3); const tabDetail_r1 = restoredCtx.$implicit; const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.setActiveTab(tabDetail_r1)); })("keyup.Space", function TabListComponent_li_1_Template_li_keyup_Space_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r3); const tabDetail_r1 = restoredCtx.$implicit; const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.setActiveTab(tabDetail_r1)); });
    i0.ɵɵelement(1, "vnext-tab", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tabDetail_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$3n, ctx_r0.activeTab.title === tabDetail_r1.title));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", tabDetail_r1.title)("isActiveTab", ctx_r0.activeTab.title === tabDetail_r1.title)("ariaControlsId", tabDetail_r1.title);
} }
class TabListComponent {
    constructor() {
        this.updateActiveTab = new EventEmitter();
    }
    setActiveTab(activeTab) {
        this.activeTab = activeTab;
        this.updateActiveTab.emit(activeTab);
    }
}
TabListComponent.ɵfac = function TabListComponent_Factory(t) { return new (t || TabListComponent)(); };
TabListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TabListComponent, selectors: [["vnext-tab-list"]], inputs: { tabList: "tabList", activeTab: "activeTab" }, outputs: { updateActiveTab: "updateActiveTab" }, decls: 2, vars: 1, consts: [["role", "tablist", 1, "tabs", "tabs--horizontal", "generic-tab", "text-center"], ["role", "presentation", "class", "tab Spa_Style_Gray2_Background Spa_Style_Primary_Color", 3, "ngClass", "click", "keyup.enter", "keyup.Space", 4, "ngFor", "ngForOf"], ["role", "presentation", 1, "tab", "Spa_Style_Gray2_Background", "Spa_Style_Primary_Color", 3, "ngClass", "click", "keyup.enter", "keyup.Space"], [3, "title", "isActiveTab", "ariaControlsId"]], template: function TabListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ul", 0);
        i0.ɵɵtemplate(1, TabListComponent_li_1_Template, 2, 6, "li", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.tabList);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, TabComponent], styles: [".tab[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px 5px 0 0;margin:0 6px -1px;min-width:83px;display:block;position:relative;text-decoration:none;outline:none;cursor:pointer}.tab[_ngcontent-%COMP%]:hover, .tab.active[_ngcontent-%COMP%]{background-color:#fff}.tab.active[_ngcontent-%COMP%]{border-bottom-color:#fff}.tabs[_ngcontent-%COMP%]{margin:0;padding:0;list-style:none;display:flex;justify-content:center;align-items:flex-end}.tabs--horizontal[_ngcontent-%COMP%]   .tab.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{border-bottom-color:#fff}.generic-tab.tabs[_ngcontent-%COMP%]{padding:15px 10px 0}.tabs--horizontal[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Primary_Light);border-bottom-style:solid;border-bottom-color:var(--static-Spa_Style_Primary_Light)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabListComponent, [{
        type: Component,
        args: [{ selector: 'vnext-tab-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ul class=\"tabs tabs--horizontal generic-tab text-center\" role=\"tablist\">\r\n  <li\r\n    *ngFor=\"let tabDetail of tabList\"\r\n    role=\"presentation\"\r\n    class=\"tab Spa_Style_Gray2_Background Spa_Style_Primary_Color\"\r\n    (click)=\"setActiveTab(tabDetail)\"\r\n    (keyup.enter)=\"setActiveTab(tabDetail)\"\r\n    (keyup.Space)=\"setActiveTab(tabDetail)\"\r\n    [ngClass]=\"{ 'active Spa_Style_Bold_Weight': activeTab.title === tabDetail.title }\"\r\n  >\r\n    <vnext-tab [title]=\"tabDetail.title\" [isActiveTab]=\"activeTab.title === tabDetail.title\" [ariaControlsId]=\"tabDetail.title\">\r\n    </vnext-tab>\r\n  </li>\r\n</ul>\r\n", styles: [".tab{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px 5px 0 0;margin:0 6px -1px;min-width:83px;display:block;position:relative;text-decoration:none;outline:none;cursor:pointer}.tab:hover,.tab.active{background-color:#fff}.tab.active{border-bottom-color:#fff}.tabs{margin:0;padding:0;list-style:none;display:flex;justify-content:center;align-items:flex-end}.tabs--horizontal .tab.active>a{border-bottom-color:#fff}.generic-tab.tabs{padding:15px 10px 0}.tabs--horizontal{border-bottom:1px solid var(--static-Spa_Style_Primary_Light);border-bottom-style:solid;border-bottom-color:var(--static-Spa_Style_Primary_Light)}\n"] }]
    }], null, { tabList: [{
            type: Input
        }], activeTab: [{
            type: Input
        }], updateActiveTab: [{
            type: Output
        }] }); })();

const _c0$3m = ["toggles"];
const _c1$1M = function (a0, a1, a2, a3, a4, a5, a6) { return { "Spa_Style_SecondaryButtonSelected Spa_Style_Primary_Link_Color Spa_Style_Bold_Weight Spa_Style_Small_Font Spa_Style_Primary_Link_Border toggle-option-selected": a0, "Spa_Style_Secondary_Text_Background": a1, "Spa_Style_SecondaryButton Spa_Style_Regular_Weight": a2, "hover": a3, "largerText": a4, "w-100": a5, "has-error": a6 }; };
const _c2$16 = function (a0) { return { "min-height": a0 }; };
const _c3$N = function (a0) { return { Spa_Style_Paragraph: a0 }; };
function ToggleMultiSelectComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2, 3);
    i0.ɵɵlistener("click", function ToggleMultiSelectComponent_div_1_Template_div_click_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const item_r1 = restoredCtx.$implicit; const index_r2 = restoredCtx.index; const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.setToggleOption(item_r1, index_r2, $event)); })("keyup.enter", function ToggleMultiSelectComponent_div_1_Template_div_keyup_enter_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.selectOptionByKeyPress(index_r2, $event)); })("keyup.arrowup", function ToggleMultiSelectComponent_div_1_Template_div_keyup_arrowup_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.focusPreviousItem(index_r2, $event)); })("keyup.arrowleft", function ToggleMultiSelectComponent_div_1_Template_div_keyup_arrowleft_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.focusPreviousItem(index_r2, $event)); })("keyup.arrowdown", function ToggleMultiSelectComponent_div_1_Template_div_keyup_arrowdown_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.focusNextItem(index_r2, $event)); })("keyup.arrowright", function ToggleMultiSelectComponent_div_1_Template_div_keyup_arrowright_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.focusNextItem(index_r2, $event)); });
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵelement(3, "input", 5)(4, "span", 6);
    i0.ɵɵpipe(5, "safe");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const index_r2 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction7(13, _c1$1M, ctx_r0.itemIsSelected(item_r1.value), ctx_r0.lightBackground && !ctx_r0.itemIsSelected(item_r1.value), !ctx_r0.itemIsSelected(item_r1.value), ctx_r0.darkenOnHover, ctx_r0.largerText, ctx_r0.fullWidth, ctx_r0.hasError))("ngStyle", i0.ɵɵpureFunction1(21, _c2$16, ctx_r0.buttonHeight));
    i0.ɵɵattribute("aria-checked", ctx_r0.itemIsSelected(item_r1.value) ? "true" : "false")("tabindex", ctx_r0.getTabIndex(!!(ctx_r0.activeValues == null ? null : ctx_r0.activeValues.length), index_r2, ctx_r0.itemIsSelected(item_r1.value)))("aria-describedby", ctx_r0.ariaDescribedById ? ctx_r0.ariaDescribedById : null)("aria-labelledby", ctx_r0.toggleControlId + "toggle-option-" + index_r2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r0.toggleControlId + "toggle-option-" + index_r2)("ngClass", i0.ɵɵpureFunction1(23, _c3$N, !ctx_r0.itemIsSelected(item_r1.value) && !ctx_r0.largerText));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("checked", ctx_r0.itemIsSelected(item_r1.value));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(5, 10, item_r1.display, "html"), i0.ɵɵsanitizeHtml);
} }
const _c4$t = function (a0, a1, a2) { return { "vertical": a0, "horizontal": a1, "col-xs-12 col-md-4 px-0": a2 }; };
class ToggleMultiSelectComponent {
    constructor(inputResetContextService, toggleFacade) {
        this.inputResetContextService = inputResetContextService;
        this.toggleFacade = toggleFacade;
        this.selectedValues = [];
        this.verticalGrow = false;
        this.fullWidth = false;
        this.lightBackground = false;
        this.darkenOnHover = true;
        this.largerText = false;
        this.buttonHeight = '60px';
        this.hasError = false;
        this.limitButtonWidth = false;
        this.toggleControlId = '';
        this.focusFirstItem = false;
        this.optionSelected = new EventEmitter();
    }
    ngOnInit() {
        this.activeValues = this.items.filter(item => this.selectedValues.includes(item.value)).map(item => item.value);
        this.subscriptions = [
            this.inputResetContextService.clearInput$.subscribe({
                next: id => {
                    if (id === this.parentId) {
                        this.activeValues = [];
                    }
                }
            })
        ];
    }
    // Required to update the active values if data is changed from an external source, ie logging into an account
    ngOnChanges(changes) {
        if (changes.selectedValues &&
            changes.selectedValues.currentValue.length &&
            !_isEqual(changes.selectedValues.currentValue, changes.selectedValues.previousValue)) {
            this.activeValues = this.items.filter(item => changes.selectedValues.currentValue.includes(item.value)).map(item => item.value);
        }
    }
    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
    ngAfterViewInit() {
        if (this.focusFirstItem) {
            this.toggleFacade.focusItem(0, 0, this.toggleElements);
        }
    }
    emitToggleOption(event) {
        this.optionSelected.emit({ data: { values: this.activeValues.length ? this.activeValues : null }, event });
    }
    setToggleOption(item, currentIndex, $event) {
        if (this.activeValues.includes(item.value)) {
            this.activeValues = this.activeValues.filter(activeItem => activeItem !== item.value);
        }
        else {
            this.activeValues.push(item.value);
        }
        this.emitToggleOption($event);
        const optionElement = this.toggleElements.filter((_element, index) => index === currentIndex)[0];
        optionElement.nativeElement.focus();
    }
    itemIsSelected(value) {
        return this.activeValues && this.activeValues.includes(value);
    }
    getTabIndex(hasActiveValue, index, itemIsSelected) {
        if (!hasActiveValue && index === 0) {
            return '0';
        }
        return itemIsSelected ? '0' : '-1';
    }
    focusItem(currentIndex, $event, delta) {
        $event.preventDefault();
        this.toggleFacade.focusItem(currentIndex, delta, this.toggleElements);
    }
    focusNextItem(currentIndex, $event) {
        this.focusItem(currentIndex, $event, 1);
    }
    focusPreviousItem(currentIndex, $event) {
        this.focusItem(currentIndex, $event, -1);
    }
    selectOptionByKeyPress(targetIndex, $event) {
        if ($event.target instanceof HTMLInputElement) {
            this.toggleFacade.selectOptionByKeyPress(targetIndex, this.toggleElements);
        }
    }
}
ToggleMultiSelectComponent.ɵfac = function ToggleMultiSelectComponent_Factory(t) { return new (t || ToggleMultiSelectComponent)(i0.ɵɵdirectiveInject(i1.InputResetContextService), i0.ɵɵdirectiveInject(ToggleFacade)); };
ToggleMultiSelectComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ToggleMultiSelectComponent, selectors: [["vnext-toggle-multi-select"]], viewQuery: function ToggleMultiSelectComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3m, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toggleElements = _t);
    } }, inputs: { items: "items", selectedValues: "selectedValues", verticalGrow: "verticalGrow", fullWidth: "fullWidth", lightBackground: "lightBackground", darkenOnHover: "darkenOnHover", largerText: "largerText", parentId: "parentId", buttonHeight: "buttonHeight", hasError: "hasError", limitButtonWidth: "limitButtonWidth", ariaLabelledById: "ariaLabelledById", ariaDescribedById: "ariaDescribedById", toggleControlId: "toggleControlId", focusFirstItem: "focusFirstItem" }, outputs: { optionSelected: "optionSelected" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 8, consts: [["role", "radiogroup", 1, "toggle-container", 3, "ngClass"], ["role", "checkbox", "name", "toggle-checkbox-button", "class", "toggle-option can-click", 3, "ngClass", "ngStyle", "click", "keyup.enter", "keyup.arrowup", "keyup.arrowleft", "keyup.arrowdown", "keyup.arrowright", 4, "ngFor", "ngForOf"], ["role", "checkbox", "name", "toggle-checkbox-button", 1, "toggle-option", "can-click", 3, "ngClass", "ngStyle", "click", "keyup.enter", "keyup.arrowup", "keyup.arrowleft", "keyup.arrowdown", "keyup.arrowright"], ["toggles", ""], [1, "toggle-content-wrapper", 3, "id", "ngClass"], ["type", "checkbox", 1, "checkbox", 3, "checked"], ["navigationAdapter", "", 3, "innerHTML"]], template: function ToggleMultiSelectComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, ToggleMultiSelectComponent_div_1_Template, 6, 25, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(4, _c4$t, ctx.verticalGrow, !ctx.verticalGrow, ctx.limitButtonWidth));
        i0.ɵɵattribute("aria-labelledby", ctx.ariaLabelledById ? ctx.ariaLabelledById : null)("aria-describedby", ctx.ariaDescribedById ? ctx.ariaDescribedById : null);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.items);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgStyle, NavigationAdapterDirective, SafePipe], styles: [".toggle-container[_ngcontent-%COMP%]{display:flex;text-align:center}.toggle-option[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;border:1px solid var(--static-Spa_Style_Accent1);padding:6px 5px;cursor:pointer;-webkit-user-select:none;user-select:none;flex:1 0}.toggle-option-selected[_ngcontent-%COMP%], .toggle-option-selected[_ngcontent-%COMP%]:focus, .toggle-option-selected[_ngcontent-%COMP%]:active{border-color:var(--static-Spa_Style_Primary_Link)}.vertical[_ngcontent-%COMP%]{flex-direction:column;text-align:left}.toggle-option[_ngcontent-%COMP%]{padding-left:15px;padding-right:15px}.largerText[_ngcontent-%COMP%]{font-size:16px}.horizontal[_ngcontent-%COMP%] > .toggle-option[_ngcontent-%COMP%]:first-of-type{border-top-left-radius:5px;border-bottom-left-radius:5px}.horizontal[_ngcontent-%COMP%] > .toggle-option[_ngcontent-%COMP%]:last-of-type{border-top-right-radius:5px;border-bottom-right-radius:5px}.vertical[_ngcontent-%COMP%] > .toggle-option[_ngcontent-%COMP%]:first-of-type{border-top-left-radius:5px;border-top-right-radius:5px}.vertical[_ngcontent-%COMP%] > .toggle-option[_ngcontent-%COMP%]:last-of-type{border-bottom-left-radius:5px;border-bottom-right-radius:5px}.checkbox[_ngcontent-%COMP%]{min-width:16px;height:16px;margin-right:10px;cursor:pointer}.toggle-content-wrapper[_ngcontent-%COMP%]{display:flex;align-items:center;width:100%;pointer-events:none}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToggleMultiSelectComponent, [{
        type: Component,
        args: [{ selector: 'vnext-toggle-multi-select', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  class=\"toggle-container\"\r\n  [ngClass]=\"{ 'vertical': verticalGrow, 'horizontal': !verticalGrow, 'col-xs-12 col-md-4 px-0': limitButtonWidth }\"\r\n  [attr.aria-labelledby]=\"ariaLabelledById ? ariaLabelledById : null\"\r\n  [attr.aria-describedby]=\"ariaDescribedById ? ariaDescribedById : null\"\r\n  role=\"radiogroup\"\r\n>\r\n  <div\r\n    *ngFor=\"let item of items; index as index\"\r\n    #toggles\r\n    role=\"checkbox\"\r\n    name=\"toggle-checkbox-button\"\r\n    class=\"toggle-option can-click\"\r\n    [ngClass]=\"{\r\n      'Spa_Style_SecondaryButtonSelected Spa_Style_Primary_Link_Color Spa_Style_Bold_Weight Spa_Style_Small_Font Spa_Style_Primary_Link_Border toggle-option-selected':\r\n        itemIsSelected(item.value),\r\n      'Spa_Style_Secondary_Text_Background': lightBackground && !itemIsSelected(item.value),\r\n      'Spa_Style_SecondaryButton Spa_Style_Regular_Weight': !itemIsSelected(item.value),\r\n      'hover': darkenOnHover,\r\n      'largerText': largerText,\r\n      'w-100': fullWidth,\r\n      'has-error': hasError\r\n    }\"\r\n    [ngStyle]=\"{ 'min-height': buttonHeight }\"\r\n    [attr.aria-checked]=\"itemIsSelected(item.value) ? 'true' : 'false'\"\r\n    [attr.tabindex]=\"getTabIndex(!!activeValues?.length, index, itemIsSelected(item.value))\"\r\n    [attr.aria-describedby]=\"ariaDescribedById ? ariaDescribedById : null\"\r\n    [attr.aria-labelledby]=\"toggleControlId + 'toggle-option-' + index\"\r\n    (click)=\"setToggleOption(item, index, $event)\"\r\n    (keyup.enter)=\"selectOptionByKeyPress(index, $event)\"\r\n    (keyup.arrowup)=\"focusPreviousItem(index, $event)\"\r\n    (keyup.arrowleft)=\"focusPreviousItem(index, $event)\"\r\n    (keyup.arrowdown)=\"focusNextItem(index, $event)\"\r\n    (keyup.arrowright)=\"focusNextItem(index, $event)\"\r\n  >\r\n    <span\r\n      [id]=\"toggleControlId + 'toggle-option-' + index\"\r\n      class=\"toggle-content-wrapper\"\r\n      [ngClass]=\"{ Spa_Style_Paragraph: !itemIsSelected(item.value) && !largerText }\"\r\n      ><input type=\"checkbox\" [checked]=\"itemIsSelected(item.value)\" class=\"checkbox\" />\r\n      <span [innerHTML]=\"item.display | safe : 'html'\" navigationAdapter> </span>\r\n    </span>\r\n  </div>\r\n</div>\r\n", styles: [".toggle-container{display:flex;text-align:center}.toggle-option{display:flex;align-items:center;justify-content:center;border:1px solid var(--static-Spa_Style_Accent1);padding:6px 5px;cursor:pointer;-webkit-user-select:none;user-select:none;flex:1 0}.toggle-option-selected,.toggle-option-selected:focus,.toggle-option-selected:active{border-color:var(--static-Spa_Style_Primary_Link)}.vertical{flex-direction:column;text-align:left}.toggle-option{padding-left:15px;padding-right:15px}.largerText{font-size:16px}.horizontal>.toggle-option:first-of-type{border-top-left-radius:5px;border-bottom-left-radius:5px}.horizontal>.toggle-option:last-of-type{border-top-right-radius:5px;border-bottom-right-radius:5px}.vertical>.toggle-option:first-of-type{border-top-left-radius:5px;border-top-right-radius:5px}.vertical>.toggle-option:last-of-type{border-bottom-left-radius:5px;border-bottom-right-radius:5px}.checkbox{min-width:16px;height:16px;margin-right:10px;cursor:pointer}.toggle-content-wrapper{display:flex;align-items:center;width:100%;pointer-events:none}\n"] }]
    }], function () { return [{ type: i1.InputResetContextService }, { type: ToggleFacade }]; }, { toggleElements: [{
            type: ViewChildren,
            args: ['toggles']
        }], items: [{
            type: Input
        }], selectedValues: [{
            type: Input
        }], verticalGrow: [{
            type: Input
        }], fullWidth: [{
            type: Input
        }], lightBackground: [{
            type: Input
        }], darkenOnHover: [{
            type: Input
        }], largerText: [{
            type: Input
        }], parentId: [{
            type: Input
        }], buttonHeight: [{
            type: Input
        }], hasError: [{
            type: Input
        }], limitButtonWidth: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], toggleControlId: [{
            type: Input
        }], focusFirstItem: [{
            type: Input
        }], optionSelected: [{
            type: Output
        }] }); })();

function TotalPremiumBannerComponent_h4_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h4", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.premiumLabel, " ");
} }
const _c0$3l = function (a0) { return { "mb-lg-5": a0 }; };
class TotalPremiumBannerComponent {
    constructor(configResourceService, planFacade, localeService, cdr) {
        this.configResourceService = configResourceService;
        this.planFacade = planFacade;
        this.localeService = localeService;
        this.cdr = cdr;
        this.riders = [];
        this.bottomMargin = true;
    }
    ngOnInit() {
        this.localeSubscription = this.localeService.getCurrentLocale$().subscribe(locale => {
            this.premiumLabel = this.planFacade.getTotalPremiumLabel();
            this.cdr.markForCheck();
        });
    }
    ngOnDestroy() {
        this.localeSubscription.unsubscribe();
    }
}
TotalPremiumBannerComponent.ɵfac = function TotalPremiumBannerComponent_Factory(t) { return new (t || TotalPremiumBannerComponent)(i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
TotalPremiumBannerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TotalPremiumBannerComponent, selectors: [["vnext-total-premium-banner"]], inputs: { plans: "plans", riders: "riders", customClass: "customClass", bottomMargin: "bottomMargin" }, decls: 7, vars: 10, consts: [[1, "row"], [1, "col-12"], [3, "ngClass"], ["class", "Spa_Style_H4 d-sm-block d-lg-inline-block mb-0", 4, "liveEditProp"], [1, "Spa_Style_Larger_Font", "Spa_Style_CostPremiumSmall", "ml-3"], [1, "Spa_Style_H4", "d-sm-block", "d-lg-inline-block", "mb-0"]], template: function TotalPremiumBannerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, TotalPremiumBannerComponent_h4_3_Template, 2, 1, "h4", 3);
        i0.ɵɵelementStart(4, "span", 4);
        i0.ɵɵtext(5);
        i0.ɵɵpipe(6, "currency");
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵclassMapInterpolate1("total-premium-banner Spa_Style_Cost_Background ", ctx.customClass, "");
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$3l, ctx.bottomMargin));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_TotalMonthlyPremiumLabel");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 6, ctx.planFacade.getTotalPremium(ctx.plans, ctx.riders)));
    } }, dependencies: [i1$2.NgClass, LiveEditPropDirective, i1$2.CurrencyPipe], styles: [".total-premium-banner[_ngcontent-%COMP%]{display:flex;border-radius:5px;margin-bottom:25px;padding:7px 12px;align-items:center;justify-content:flex-end}@media (max-width: 768px){.total-premium-banner[_ngcontent-%COMP%]{flex-direction:column;align-items:flex-end}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TotalPremiumBannerComponent, [{
        type: Component,
        args: [{ selector: 'vnext-total-premium-banner', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row\">\r\n  <div class=\"col-12\">\r\n    <div class=\"total-premium-banner Spa_Style_Cost_Background {{ customClass }}\" [ngClass]=\"{ 'mb-lg-5': bottomMargin }\">\r\n      <h4 *liveEditProp=\"'Spa_Site_TotalMonthlyPremiumLabel'\" class=\"Spa_Style_H4 d-sm-block d-lg-inline-block mb-0\">\r\n        {{ premiumLabel }}\r\n      </h4>\r\n      <span class=\"Spa_Style_Larger_Font Spa_Style_CostPremiumSmall ml-3\">{{ planFacade.getTotalPremium(plans, riders) | currency }}</span>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".total-premium-banner{display:flex;border-radius:5px;margin-bottom:25px;padding:7px 12px;align-items:center;justify-content:flex-end}@media (max-width: 768px){.total-premium-banner{flex-direction:column;align-items:flex-end}}\n"] }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: PlanFacade }, { type: i1.LocaleService }, { type: i0.ChangeDetectorRef }]; }, { plans: [{
            type: Input
        }], riders: [{
            type: Input
        }], customClass: [{
            type: Input
        }], bottomMargin: [{
            type: Input
        }] }); })();

class WarningMessageManyResultsAgentSearchComponent {
    constructor() {
        this.timeoutMessageText = `
    <div class="d-flex justify-content-center col-12">
      <div class="Spa_Style_Paragraph Spa_Style_Large_Font font-weight-bold mx-auto no-search-result-text">
        Too many results
      </div>
    </div>

    <div class="d-flex justify-content-center col-12 mt-2">
      <div class="Spa_Style_Paragraph Spa_Style_Regular_Font mx-auto no-search-result-text">
        Please specify additional search criteria to return results
      </div>
    </div>
  `;
        this.searchAgainButtonText = 'Refine Search';
        this.clearSearch = new EventEmitter();
    }
}
WarningMessageManyResultsAgentSearchComponent.ɵfac = function WarningMessageManyResultsAgentSearchComponent_Factory(t) { return new (t || WarningMessageManyResultsAgentSearchComponent)(); };
WarningMessageManyResultsAgentSearchComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: WarningMessageManyResultsAgentSearchComponent, selectors: [["vnext-warning-message-many-results-agent-search"]], inputs: { timeoutMessageText: "timeoutMessageText", searchAgainButtonText: "searchAgainButtonText" }, outputs: { clearSearch: "clearSearch" }, decls: 6, vars: 6, consts: [[1, "row", "flex-column", "pt-3", "mt-5"], [3, "innerHTML"], [1, "d-flex", "justify-content-center", "mt-3"], [1, "button-container"], [3, "buttonClass", "buttonText", "click"]], template: function WarningMessageManyResultsAgentSearchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵpipe(2, "safe");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2)(4, "div", 3)(5, "vnext-status-button", 4);
        i0.ɵɵlistener("click", function WarningMessageManyResultsAgentSearchComponent_Template_vnext_status_button_click_5_listener() { return ctx.clearSearch.emit(); });
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 3, ctx.timeoutMessageText, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("buttonClass", "Spa_Style_PrimaryButton")("buttonText", ctx.searchAgainButtonText);
    } }, dependencies: [StatusButtonComponent, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WarningMessageManyResultsAgentSearchComponent, [{
        type: Component,
        args: [{ selector: 'vnext-warning-message-many-results-agent-search', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row flex-column pt-3 mt-5\">\r\n  <div [innerHTML]=\"timeoutMessageText | safe: 'html'\"></div>\r\n</div>\r\n\r\n<div class=\"d-flex justify-content-center mt-3\">\r\n  <div class=\"button-container\">\r\n    <vnext-status-button\r\n      [buttonClass]=\"'Spa_Style_PrimaryButton'\"\r\n      [buttonText]=\"searchAgainButtonText\"\r\n      (click)=\"clearSearch.emit()\"\r\n    >\r\n    </vnext-status-button>\r\n  </div>\r\n</div>" }]
    }], null, { timeoutMessageText: [{
            type: Input
        }], searchAgainButtonText: [{
            type: Input
        }], clearSearch: [{
            type: Output
        }] }); })();

class AgentCallRecordingShoppingFacade {
    constructor(store, configResourceService, phoneUtilityService, modalService, navigationService, agentCallRecordingNavigationService, profileService) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.phoneUtilityService = phoneUtilityService;
        this.modalService = modalService;
        this.navigationService = navigationService;
        this.agentCallRecordingNavigationService = agentCallRecordingNavigationService;
        this.profileService = profileService;
    }
    getCallBeneficiaryText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingModal_CallBeneficiary', widgetName, 'Call Beneficiary');
    }
    getContinueButtonText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Continue', widgetName, 'Continue');
    }
    getInstructLabel(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingShoppingModal_InstructLabel', widgetName, `To start a call recording, confirm that the phone number from the profile is populated in the phone input.
       Instruct beneficiary to consent to call in order to speak with an agent.`);
    }
    getCallBeneficiarySectionHeader(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingModal_CallBeneficiarySectionHeader', widgetName, 'Call the beneficiary');
    }
    getCallBeneficiaryLabel(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingModal_CallBeneficiarySectionText', widgetName, 'You may update the phone number in the');
    }
    getCallBeneficiaryProfileLinkLabel(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingModal_CallBeneficiarySection_ProfileLink', widgetName, `beneficiary's profile.`);
    }
    getTitle(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingModal_Title', widgetName, 'Record your call');
    }
    isAgentCallRecordingEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_AgentCallRecording_Enabled', widgetName, false);
    }
    getCancelText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Cancel', widgetName, 'Cancel');
    }
    getAcceptCallText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingAcceptCall_Title', widgetName, 'Accept Call');
    }
    getCallingCallText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingCallingCall_Title', widgetName, 'Calling');
    }
    getRingingCallIcon(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingAcceptCall_Icon', widgetName, 'fas fa-phone-volume');
    }
    getRingingCallText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingRingingCall_Title', widgetName, '"Ringing"');
    }
    getCallInProgressText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallInProgressAcceptCall_Title', widgetName, 'Call in progress');
    }
    getCallInProgressIcon(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallInProgressAcceptCall_Icon', widgetName, 'fas fa-phone');
    }
    getEndCallIcon(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallEndCall_Icon', widgetName, 'fas fa-phone-slash');
    }
    getEndCallText(widgetName) {
        return this.agentCallRecordingNavigationService.getEndCallText(widgetName);
    }
    getCallEndedText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallEnded_Title', widgetName, 'Call ended');
    }
    getCallEndedIcon(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallInProgressAcceptCall_Icon', widgetName, 'fas fa-phone');
    }
    getEnrollingInPlanText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingModal_Enrolling_In_Plan_Header_Text', widgetName, 'Enrolling in');
    }
    getAgentCallRecordingHeaderText(widgetName) {
        return this.configResourceService
            .getProcessedResourceValue('Spa_Site_AgentCallRecordingShopping_Header_Text', widgetName, 'Start a recording for <member>')
            .replace('<member>', this.getMemberFullName());
    }
    getMemberPhoneNumber() {
        return this.getMemberMobilePhoneNumber() ?? this.getMemberPrimaryPhoneNumber();
    }
    getFormattedMemberPhoneNumber() {
        return this.formatPhoneNumber(this.getMemberPhoneNumber());
    }
    getMemberPrimaryPhoneNumber() {
        return this.profileService.getHomePhone();
    }
    getFormattedMemberPrimaryPhonenUmber() {
        return this.formatPhoneNumber(this.getMemberPrimaryPhoneNumber());
    }
    getMemberMobilePhoneNumber() {
        return this.profileService.getCellPhone();
    }
    getFormattedMemberMobilePhoneNumber() {
        return this.formatPhoneNumber(this.getMemberMobilePhoneNumber());
    }
    getMemberFullName() {
        return this.agentCallRecordingNavigationService.getMemberFullName();
    }
    getTwilioAgentPhoneNumber() {
        return this.phoneUtilityService.parsePhoneNumber(this.store.selectSnapshot(TwilioState.phoneNumber));
    }
    getTwilioCallTrackingId() {
        return this.store.selectSnapshot(TwilioState.callTrackingId);
    }
    getTwilioAuthCode() {
        return this.store.selectSnapshot(TwilioState.authCode);
    }
    getPhoneNumberNotAvailableErrorMessage(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_AgentCallRecording_PhoneNumberNotAvailableErrorMessage', widgetName, 'An issue has occurred. Please close this window and open it again to start a call recording.');
    }
    getTwilioFailedEventMessage(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_AgentCallRecording_TwilioFailedEventMessage', widgetName, 'There is an issue with the call recording. Please hang up, close this window, and reopen the window to start a new recording.');
    }
    getAgentPhoneNumberLabel(widgetName) {
        return this.configResourceService
            .getProcessedResourceValue('Spa_Profile_AgentCallRecording_AgentPhoneNumberLabel', widgetName, 'Your phone number will display as: <number>')
            .replace('<number>', this.getTwilioAgentPhoneNumber());
    }
    getPrimaryPhoneLabel(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Primary_Text', widgetName, 'Primary');
    }
    getMobilePhoneLabel(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Mobile_Text', widgetName, 'Mobile');
    }
    checkForMemberPhoneNumber() {
        // We require a primary number for call recording. Having a mobile but no primary should show the error modal.
        if (!this.getMemberPrimaryPhoneNumber()) {
            this.showNoNumberModal();
            return false;
        }
        return true;
    }
    showNoNumberModal() {
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, {
            centered: true,
            backdrop: 'static',
            keyboard: false
        });
        confirmationModal.componentInstance.title = this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingShoppingModal_NoPhone_Title', null, 'Beneficiary phone number required');
        confirmationModal.componentInstance.prompt = this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingShoppingModal_NoPhone_InstructLabel', null, 'You must have a phone number associated with this beneficiary before continuing with call recording. Navigate back to Profile to populate a phone number.');
        confirmationModal.componentInstance.cancelButton = this.configResourceService.getProcessedResourceValue('Spa_Site_Close', null, 'Close');
        confirmationModal.componentInstance.confirmButton = this.configResourceService.getProcessedResourceValue('Spa_Site_GoToProfile_Label', null, 'Go to profile');
        confirmationModal.componentInstance.confirmAction = () => {
            this.navigationService.navigateByPageTag(PageTags.MEMBER_PROFILE_PAGE);
        };
    }
    setupEndCallConfirmationModal() {
        return this.agentCallRecordingNavigationService.setupEndCallConfirmationModal();
    }
    getActionOnAcceptEndCallRecordingModal() {
        return this.actionOnAcceptEndCallRecordingModal;
    }
    setActionOnAcceptEndCallRecordingModal(actionFn) {
        this.actionOnAcceptEndCallRecordingModal = actionFn;
    }
    formatPhoneNumber(phone) {
        return phone && phone.length === 10 ? `(${phone.substring(0, 3)}) ${phone.substring(3, 6)}-${phone.substring(6, 10)}` : '';
    }
    getCallRecordingNonStickyPage(pageName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Call_Recording_Non_Sticky_Page', null, false, false, pageName);
    }
}
AgentCallRecordingShoppingFacade.ɵfac = function AgentCallRecordingShoppingFacade_Factory(t) { return new (t || AgentCallRecordingShoppingFacade)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.PhoneUtilityService), i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(i1.NavigationService), i0.ɵɵinject(i1.AgentCallRecordingNavigationService), i0.ɵɵinject(i1.ProfileService)); };
AgentCallRecordingShoppingFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentCallRecordingShoppingFacade, factory: AgentCallRecordingShoppingFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentCallRecordingShoppingFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i2.Store }, { type: i1.ConfigResourceService }, { type: i1.PhoneUtilityService }, { type: i1$1.NgbModal }, { type: i1.NavigationService }, { type: i1.AgentCallRecordingNavigationService }, { type: i1.ProfileService }]; }, null); })();

function AgentCallRecordingShoppingModalComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.errorMessage);
} }
function AgentCallRecordingShoppingModalComponent_ng_container_28_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 22)(2, "div", 23)(3, "input", 24);
    i0.ɵɵlistener("change", function AgentCallRecordingShoppingModalComponent_ng_container_28_Template_input_change_3_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.updateSelectedPhoneNumber(ctx_r7.memberCallPrimaryPhoneNumber)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div")(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "label", 25)(8, "div", 23)(9, "input", 26);
    i0.ɵɵlistener("change", function AgentCallRecordingShoppingModalComponent_ng_container_28_Template_input_change_9_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.updateSelectedPhoneNumber(ctx_r9.memberCallMobilePhoneNumber)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div")(11, "span");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate2("", ctx_r1.primaryLabel, ": ", ctx_r1.memberCallPrimaryPhoneNumber, "");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate2("", ctx_r1.mobileLabel, ": ", ctx_r1.memberCallMobilePhoneNumber, "");
} }
function AgentCallRecordingShoppingModalComponent_ng_template_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.selectedMemberCallPhoneNumber);
} }
function AgentCallRecordingShoppingModalComponent_ng_container_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 27)(2, "div", 28);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "a")(5, "span", 29);
    i0.ɵɵelement(6, "i", 30);
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.ringingCallText, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵclassMapInterpolate1("", ctx_r4.ringingCallIcon, " mr-1 pr-1");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.callingText);
} }
function AgentCallRecordingShoppingModalComponent_ng_container_36_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 31)(2, "span", 32);
    i0.ɵɵelement(3, "i", 30);
    i0.ɵɵelementStart(4, "div", 33)(5, "span", 34);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 35);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "async");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(10, "div", 36)(11, "a", 37);
    i0.ɵɵlistener("click", function AgentCallRecordingShoppingModalComponent_ng_container_36_Template_a_click_11_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.endCall(true)); });
    i0.ɵɵelement(12, "i", 30);
    i0.ɵɵelementStart(13, "div", 38)(14, "span", 39);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵclassMapInterpolate1("", ctx_r5.callInProgressIcon, " mr-1 pr-1");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r5.callInProgressText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 9, ctx_r5.elapsedTimeText$));
    i0.ɵɵadvance(4);
    i0.ɵɵclassMapInterpolate1("", ctx_r5.endCallIcon, " mr-1 pr-1");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r5.endCallText);
} }
function AgentCallRecordingShoppingModalComponent_ng_container_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 31)(2, "span", 40);
    i0.ɵɵelement(3, "i", 30);
    i0.ɵɵelementStart(4, "div", 33)(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 35);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "async");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵclassMapInterpolate1("", ctx_r6.callEndedIcon, " mr-1 pr-1");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r6.callEndedText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 5, ctx_r6.elapsedTimeText$));
} }
class AgentCallRecordingShoppingModalComponent {
    constructor(activeModal, agentCallRecordingService, agentCallRecordingShoppingFacade, cdr, twilioService, spinnerService, navigationService, enrollmentFormService, genericFormService, shoppingRecordingContextService, analyticsService) {
        this.activeModal = activeModal;
        this.agentCallRecordingService = agentCallRecordingService;
        this.agentCallRecordingShoppingFacade = agentCallRecordingShoppingFacade;
        this.cdr = cdr;
        this.twilioService = twilioService;
        this.spinnerService = spinnerService;
        this.navigationService = navigationService;
        this.enrollmentFormService = enrollmentFormService;
        this.genericFormService = genericFormService;
        this.shoppingRecordingContextService = shoppingRecordingContextService;
        this.analyticsService = analyticsService;
        this.phoneMask = FormValidationService.phoneMask;
        this.memberPhoneNumber = '';
        this.selectedMemberCallPhoneNumber = '';
        this.deviceReadySubscription = new Subscription();
        this.deviceErrorSubscription = new Subscription();
        this.deviceConnectSubscription = new Subscription();
        this.connectionDisconnectSubscription = new Subscription();
        this.connectionIncomingSubscription = new Subscription();
        this.connectionCancelSubscription = new Subscription();
        this.subscriptions = [];
        this.twilioSubscriptions = [];
    }
    ngOnInit() {
        this.showCallRecordingLoadingSpinner(true);
        this.setAttributes();
        this.registerExternalPhoneNumber();
    }
    ngOnDestroy() {
        this.twilioService.setModalOpen(false);
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
        this.twilioSubscriptions.forEach(subscription => subscription.unsubscribe());
        if (!this.isCallRecording) {
            this.twilioService.destroyDevice();
        }
    }
    setAttributes() {
        this.cancelText = this.agentCallRecordingShoppingFacade.getCancelText();
        this.ringingCallText = this.agentCallRecordingShoppingFacade.getRingingCallText();
        this.callingText = this.agentCallRecordingShoppingFacade.getCallingCallText();
        this.ringingCallIcon = this.agentCallRecordingShoppingFacade.getRingingCallIcon();
        this.callInProgressText = this.agentCallRecordingShoppingFacade.getCallInProgressText();
        this.callInProgressIcon = this.agentCallRecordingShoppingFacade.getCallInProgressIcon();
        this.endCallText = this.agentCallRecordingShoppingFacade.getEndCallText();
        this.endCallIcon = this.agentCallRecordingShoppingFacade.getEndCallIcon();
        this.callEndedText = this.agentCallRecordingShoppingFacade.getCallEndedText();
        this.callEndedIcon = this.agentCallRecordingShoppingFacade.getCallEndedIcon();
        this.title = this.agentCallRecordingShoppingFacade.getTitle();
        this.header = this.agentCallRecordingShoppingFacade.getAgentCallRecordingHeaderText();
        this.instructLabel = this.agentCallRecordingShoppingFacade.getInstructLabel();
        this.callBeneficiaryLabel = this.agentCallRecordingShoppingFacade.getCallBeneficiaryLabel();
        this.beneficiaryProfileLinkLabel = this.agentCallRecordingShoppingFacade.getCallBeneficiaryProfileLinkLabel();
        this.callBeneficiarySectionHeader = this.agentCallRecordingShoppingFacade.getCallBeneficiarySectionHeader();
        this.continueButtonText = this.agentCallRecordingShoppingFacade.getContinueButtonText();
        this.callBeneficiaryButtonLabel = this.agentCallRecordingShoppingFacade.getCallBeneficiaryText();
        this.primaryLabel = this.agentCallRecordingShoppingFacade.getPrimaryPhoneLabel();
        this.mobileLabel = this.agentCallRecordingShoppingFacade.getMobilePhoneLabel();
        this.memberCallMobilePhoneNumber = this.agentCallRecordingShoppingFacade.getFormattedMemberMobilePhoneNumber();
        this.memberCallPrimaryPhoneNumber = this.agentCallRecordingShoppingFacade.getFormattedMemberPrimaryPhonenUmber();
        this.selectedMemberCallPhoneNumber = this.memberCallPrimaryPhoneNumber;
    }
    async onCallBeneficiary() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_CALL_RECORDING_INVITE_VIA_CALL
        };
        this.showCallBeneficiaryPhoneError = true;
        await this.callBeneficiary();
    }
    registerExternalPhoneNumber() {
        // Destroy any existing device and connection to avoid having 2 or more living at the same time
        this.twilioService.destroyDevice();
        this.twilioSubscriptions.forEach(subscription => subscription.unsubscribe());
        this.agentCallRecordingService
            .getTwilioPhoneNumber$()
            .pipe(switchMap(phoneNumber => this.agentCallRecordingService.getTwilioAuthToken$(phoneNumber).pipe(map(twilioToken => ({ phoneNumber, twilioToken })))), finalize(() => {
            this.agentPhoneNumberLabel = this.agentCallRecordingShoppingFacade.getAgentPhoneNumberLabel();
            this.cdr.markForCheck();
        }))
            .subscribe({
            next: async (phoneNumberAndTwilioToken) => {
                this.agentCallRecordingService.storeTwilioAuthCode(phoneNumberAndTwilioToken.twilioToken?.authCode);
                this.agentCallRecordingService.storeTwilioCallTrackingId(phoneNumberAndTwilioToken.twilioToken?.callTrackingID);
                this.agentCallRecordingService.storeTwilioPhoneNumber(phoneNumberAndTwilioToken.phoneNumber);
                await this.setupTwilioDevice(phoneNumberAndTwilioToken.twilioToken?.accessToken);
            },
            error: () => {
                this.showCallRecordingLoadingSpinner(false);
                this.errorMessage = this.agentCallRecordingShoppingFacade.getPhoneNumberNotAvailableErrorMessage();
                this.cdr.markForCheck();
            }
        });
    }
    async setupTwilioDevice(accessToken) {
        await this.twilioService.setupDevice(accessToken);
        this.twilioSubscriptions.push(this.twilioService.getDeviceRegistered$().subscribe((device) => {
            this.isCallRecording = false;
            this.callInProgress = false;
            this.hasCallEnded = false;
            this.incomingCall = false;
            // TODO: this correct?
            if (device?.state === Device.State.Registered) {
                this.twilioDevice = device;
            }
            this.showCallRecordingLoadingSpinner(false);
            this.cdr.markForCheck();
        }));
        this.twilioSubscriptions.push(this.twilioService.getConnectionIncoming$().subscribe((connection) => {
            if (connection?.status() === Call.State.Pending) {
                this.twilioConnection = connection;
                this.isCallRinging = true;
                this.incomingCall = true;
                this.callInProgress = false;
                this.hasCallEnded = false;
                this.cdr.markForCheck();
            }
        }));
        this.twilioSubscriptions.push(this.twilioService
            .getConnectionDisconnect$()
            .pipe(skip(1))
            .subscribe(connection => {
            this.handleDisconnect(connection);
        }));
        this.twilioSubscriptions.push(this.twilioService.getConnectionCancel$().subscribe(connection => {
            this.handleDisconnect(connection);
        }));
        this.twilioSubscriptions.push(this.twilioService
            .getDeviceConnect$()
            .pipe(switchMap((connection) => {
            if (connection?.status() === Call.State.Connecting || connection?.status() === Call.State.Open) {
                const activeEnrollmentKey = this.enrollmentFormService.getActiveEnrollmentKey();
                const confirmationNumber = this.genericFormService.getConfirmationNumber(activeEnrollmentKey);
                if (this.enrollmentFormService.getPageIsEnrollment() && !confirmationNumber) {
                    return this.agentCallRecordingService.associateCallRecordToEnrollment$().pipe(map(() => connection), catchError(() => EMPTY));
                }
            }
            return of(connection);
        }))
            .subscribe({
            next: (connection) => {
                if (connection?.status() === Call.State.Connecting || connection?.status() === Call.State.Open) {
                    this.isCallRinging = false;
                    this.isCallRecording = true;
                    this.callInProgress = true;
                    this.elapsedTimeText$ = this.twilioService.getElapsedTimeText$();
                    this.cdr.markForCheck();
                }
            }
        }));
        this.twilioSubscriptions.push(this.twilioService.getDeviceError$().subscribe((error) => {
            if (error) {
                this.hasCallEnded = this.incomingCall || this.isCallRinging || this.callInProgress;
                this.incomingCall = false;
                this.isCallRinging = false;
                this.callInProgress = false;
                this.errorMessage = this.agentCallRecordingShoppingFacade.getTwilioFailedEventMessage();
                this.cdr.markForCheck();
                this.showCallRecordingLoadingSpinner(false);
            }
        }));
    }
    goToProfile() {
        this.navigationService.navigateByPageTag(PageTags.MEMBER_PROFILE_PAGE);
        this.activeModal.close();
    }
    confirmAndCloseModal() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_CALL_RECORDING_CONTINUE_APPLYING
        };
        this.confirmAction();
        this.activeModal.close();
        this.twilioService.markAsNotSkipped();
    }
    endCall(hasCallManuallyEnded) {
        this.twilioService.setShoppingCallRecording(false);
        // In case we are handling a Pending (incoming) connection, reject it before disconnecting
        this.twilioConnection?.reject();
        this.shoppingRecordingContextService.endCall();
        this.twilioService.hangup(true, hasCallManuallyEnded);
        this.callInProgress = false;
        this.hasCallEnded = true;
    }
    closeModal() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_CALL_RECORDING_MODAL_CANCEL
        };
        this.endCall();
        this.activeModal.close();
    }
    updateSelectedPhoneNumber(phoneNumber) {
        this.selectedMemberCallPhoneNumber = phoneNumber;
    }
    showCallRecordingLoadingSpinner(loading) {
        if (loading) {
            this.spinnerService.show(SpinnerEvent.NAVIGATION);
        }
        else {
            this.spinnerService.hide(SpinnerEvent.NAVIGATION);
        }
    }
    handleDisconnect(connection) {
        if (connection?.status() === Call.State.Closed) {
            this.twilioService.hangup();
            this.twilioConnection = connection;
            this.isCallRinging = false;
            this.incomingCall = false;
            this.callInProgress = false;
            this.hasCallEnded = true;
            this.isCallRecording = false;
            this.reloadDevice();
        }
        else {
            // This covers the edge case where a modal is open, a call received, cancelled and then closed.
            // If we open the modal again, an event will be triggered with a connection closed that shows the "Call Ended" label
            this.hasCallEnded = false;
        }
        this.cdr.markForCheck();
    }
    reloadDevice() {
        this.showCallRecordingLoadingSpinner(true);
        this.registerExternalPhoneNumber();
    }
    async callBeneficiary() {
        this.twilioConnection = await this.twilioService.callPhone(this.selectedMemberCallPhoneNumber);
        this.twilioService.setShoppingCallRecording(true);
        this.isCallRinging = true;
        this.incomingCall = false;
        this.hasCallEnded = false;
        this.agentCallRecordingService.addCallRecordingInitiatedNote(this.selectedMemberCallPhoneNumber);
        this.cdr.markForCheck();
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CASE_CALL_RECORDING_CALL_BEGIN,
            [DataLayerGlobalVariable.CALL_RECORDING_BEGIN_VIA]: CallRecordingBeginVia.OUTGOING_CALL,
            [DataLayerGlobalVariable.CALL_RECORDING_TRACKING_ID]: this.agentCallRecordingShoppingFacade.getTwilioCallTrackingId()
        };
    }
}
AgentCallRecordingShoppingModalComponent.ɵfac = function AgentCallRecordingShoppingModalComponent_Factory(t) { return new (t || AgentCallRecordingShoppingModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i1.AgentCallRecordingService), i0.ɵɵdirectiveInject(AgentCallRecordingShoppingFacade), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.TwilioDeviceService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(i1.GenericFormService), i0.ɵɵdirectiveInject(i1.ShoppingRecordingContextService), i0.ɵɵdirectiveInject(AnalyticsService)); };
AgentCallRecordingShoppingModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentCallRecordingShoppingModalComponent, selectors: [["vnext-agent-call-recording-shopping-modal"]], decls: 43, vars: 30, consts: [[3, "modalTitleText", "modalTitleCancelAction"], ["tabindex", "-1", 1, "modal-body"], [1, "container"], [1, "row"], [1, "col-12"], ["class", "error-container", 4, "ngIf"], [1, "col-12", "p-0", "Spa_Style_H2", "m-0"], [1, "col-12", "mt-2", "p-0", "Spa_Style_Paragraph", "paragraph"], [3, "innerHTML"], [1, "Spa_Style_H4", "pt-3", "m-0"], [1, "col-12", "p-0", "mt-2", "Spa_Style_Paragraph", "paragraph"], [1, "Spa_Style_Link", "can-click", "underline", 3, "innerHTML", "click"], [1, "col-12", "p-0", "mt-4", "mb-4", "Spa_Style_Paragraph", "paragraph"], [4, "ngIf", "ngIfElse"], ["onlyPrimaryView", ""], ["type", "submit", 1, "col-12", "col-sm-auto", "btn", "Spa_Style_SecondaryButton", 3, "disabled", "click"], [1, "row", "float-right", "call-wrapper", "mb-4", "mr-4"], [4, "ngIf"], [1, "modal-footer", "justify-content-start"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "mr-auto", 3, "click"], ["type", "submit", 1, "btn", "Spa_Style_PrimaryButton", 3, "disabled", "click"], [1, "error-container"], ["for", "memberCallPrimaryPhoneNumber", 1, "d-flex"], [1, "mr-2", "d-flex"], ["checked", "", "id", "memberCallPrimaryPhoneNumber", "type", "radio", "name", "phoneMethodRadioGroup", 3, "change"], ["for", "memberCallMobilePhoneNumber", 1, "d-flex"], ["id", "memberCallMobilePhoneNumber", "type", "radio", "name", "phoneMethodRadioGroup", 3, "change"], [1, "ringing-call-wrapper", "mt-2"], [1, "call-label", "mb-1"], [1, "Spa_Style_Primary", "Spa_Style_Paragraph"], ["aria-hidden", "true"], [1, "mt-2", "mr-2"], [1, "d-flex", "Spa_Style_Primary_Color"], [1, "d-flex", "flex-column"], [1, "Spa_Style_Paragraph"], [1, "Spa_Style_Gray4_Color", "elapsed-time-text"], [1, "end-call-wrapper", "mt-2", "mr-2"], ["role", "button", 1, "can-click", "d-flex", 3, "click"], [1, "Spa_Style_Paragraph", "d-flex", "flex-column"], [1, "end-call"], [1, "d-flex", "Spa_Style_Paragraph"]], template: function AgentCallRecordingShoppingModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function AgentCallRecordingShoppingModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 3);
        i0.ɵɵtemplate(6, AgentCallRecordingShoppingModalComponent_div_6_Template, 2, 1, "div", 5);
        i0.ɵɵelementStart(7, "h2", 6);
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 7);
        i0.ɵɵelement(10, "span", 8);
        i0.ɵɵpipe(11, "safe");
        i0.ɵɵelementStart(12, "span");
        i0.ɵɵtext(13, "\u00A0");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(14, "span", 8);
        i0.ɵɵpipe(15, "safe");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(16, "div", 3)(17, "h4", 9);
        i0.ɵɵtext(18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div", 10);
        i0.ɵɵelement(20, "span", 8);
        i0.ɵɵpipe(21, "safe");
        i0.ɵɵelementStart(22, "span");
        i0.ɵɵtext(23, "\u00A0");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "span", 11);
        i0.ɵɵlistener("click", function AgentCallRecordingShoppingModalComponent_Template_span_click_24_listener() { return ctx.goToProfile(); });
        i0.ɵɵpipe(25, "safe");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(26, "div", 3)(27, "div", 12);
        i0.ɵɵtemplate(28, AgentCallRecordingShoppingModalComponent_ng_container_28_Template, 13, 4, "ng-container", 13);
        i0.ɵɵtemplate(29, AgentCallRecordingShoppingModalComponent_ng_template_29_Template, 2, 1, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(31, "div", 3)(32, "button", 15);
        i0.ɵɵlistener("click", function AgentCallRecordingShoppingModalComponent_Template_button_click_32_listener() { return ctx.onCallBeneficiary(); });
        i0.ɵɵtext(33);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(34, "div", 16);
        i0.ɵɵtemplate(35, AgentCallRecordingShoppingModalComponent_ng_container_35_Template, 9, 5, "ng-container", 17);
        i0.ɵɵtemplate(36, AgentCallRecordingShoppingModalComponent_ng_container_36_Template, 16, 11, "ng-container", 17);
        i0.ɵɵtemplate(37, AgentCallRecordingShoppingModalComponent_ng_container_37_Template, 10, 7, "ng-container", 17);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(38, "div", 18)(39, "button", 19);
        i0.ɵɵlistener("click", function AgentCallRecordingShoppingModalComponent_Template_button_click_39_listener() { return ctx.closeModal(); });
        i0.ɵɵtext(40);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(41, "button", 20);
        i0.ɵɵlistener("click", function AgentCallRecordingShoppingModalComponent_Template_button_click_41_listener() { return ctx.confirmAndCloseModal(); });
        i0.ɵɵtext(42);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(30);
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.errorMessage);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.header);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(11, 18, ctx.instructLabel, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(15, 21, ctx.agentPhoneNumberLabel, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.callBeneficiarySectionHeader);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(21, 24, ctx.callBeneficiaryLabel, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(25, 27, ctx.beneficiaryProfileLinkLabel, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.memberCallMobilePhoneNumber && ctx.memberCallPrimaryPhoneNumber)("ngIfElse", _r2);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("disabled", ctx.errorMessage || !ctx.twilioDevice || ctx.isCallRinging || ctx.callInProgress);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.callBeneficiaryButtonLabel, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isCallRinging);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.callInProgress);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasCallEnded);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.cancelText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", !ctx.isCallRecording);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.continueButtonText, " ");
    } }, dependencies: [i1$2.NgIf, ModalHeaderComponent, i1$2.AsyncPipe, SafePipe], styles: [".call-wrapper[_ngcontent-%COMP%]{font-size:14px;font-weight:400}.paragraph[_ngcontent-%COMP%]{line-height:1.6}.underline[_ngcontent-%COMP%]{text-decoration:underline}.ringing-call-wrapper[_ngcontent-%COMP%], .ringing-call-wrapper[_ngcontent-%COMP%]   .call-info[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text)}.ringing-call-wrapper[_ngcontent-%COMP%]   .call-label[_ngcontent-%COMP%]{font-weight:700}.elapsed-time-text[_ngcontent-%COMP%]{font-size:13px}.end-call-wrapper[_ngcontent-%COMP%], .end-call-wrapper[_ngcontent-%COMP%]   .end-call[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent2)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentCallRecordingShoppingModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-call-recording-shopping-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"closeModal()\"></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body\" tabindex=\"-1\">\r\n  <div class=\"container\">\r\n    <div class=\"row\">\r\n      <div class=\"col-12\">\r\n        <div class=\"row\">\r\n          <div *ngIf=\"errorMessage\" class=\"error-container\">{{ errorMessage }}</div>\r\n          <h2 class=\"col-12 p-0 Spa_Style_H2 m-0\">{{ header }}</h2>\r\n          <div class=\"col-12 mt-2 p-0 Spa_Style_Paragraph paragraph\">\r\n            <span [innerHTML]=\"instructLabel | safe : 'html'\"></span>\r\n            <span>&nbsp;</span>\r\n            <span [innerHTML]=\"agentPhoneNumberLabel | safe : 'html'\"></span>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <h4 class=\"Spa_Style_H4 pt-3 m-0\">{{ callBeneficiarySectionHeader }}</h4>\r\n          <div class=\"col-12 p-0 mt-2 Spa_Style_Paragraph paragraph\">\r\n            <span [innerHTML]=\"callBeneficiaryLabel | safe : 'html'\"></span>\r\n            <span>&nbsp;</span>\r\n            <span\r\n              class=\"Spa_Style_Link can-click underline\"\r\n              (click)=\"goToProfile()\"\r\n              [innerHTML]=\"beneficiaryProfileLinkLabel | safe : 'html'\"\r\n            ></span>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col-12 p-0 mt-4 mb-4 Spa_Style_Paragraph paragraph\">\r\n            <ng-container *ngIf=\"memberCallMobilePhoneNumber && memberCallPrimaryPhoneNumber; else onlyPrimaryView\">\r\n              <label class=\"d-flex\" for=\"memberCallPrimaryPhoneNumber\">\r\n                <div class=\"mr-2 d-flex\">\r\n                  <input\r\n                    checked\r\n                    id=\"memberCallPrimaryPhoneNumber\"\r\n                    type=\"radio\"\r\n                    name=\"phoneMethodRadioGroup\"\r\n                    (change)=\"updateSelectedPhoneNumber(memberCallPrimaryPhoneNumber)\"\r\n                  />\r\n                </div>\r\n                <div>\r\n                  <span>{{ primaryLabel }}: {{ memberCallPrimaryPhoneNumber }}</span>\r\n                </div>\r\n              </label>\r\n              <label class=\"d-flex\" for=\"memberCallMobilePhoneNumber\">\r\n                <div class=\"mr-2 d-flex\">\r\n                  <input\r\n                    id=\"memberCallMobilePhoneNumber\"\r\n                    type=\"radio\"\r\n                    name=\"phoneMethodRadioGroup\"\r\n                    (change)=\"updateSelectedPhoneNumber(memberCallMobilePhoneNumber)\"\r\n                  />\r\n                </div>\r\n                <div>\r\n                  <span>{{ mobileLabel }}: {{ memberCallMobilePhoneNumber }}</span>\r\n                </div>\r\n              </label>\r\n            </ng-container>\r\n\r\n            <ng-template #onlyPrimaryView>\r\n              <span>{{ selectedMemberCallPhoneNumber }}</span>\r\n            </ng-template>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <button\r\n            [disabled]=\"errorMessage || !twilioDevice || isCallRinging || callInProgress\"\r\n            class=\"col-12 col-sm-auto btn Spa_Style_SecondaryButton\"\r\n            type=\"submit\"\r\n            (click)=\"onCallBeneficiary()\"\r\n          >\r\n            {{ callBeneficiaryButtonLabel }}\r\n          </button>\r\n        </div>\r\n\r\n        <div class=\"row float-right call-wrapper mb-4 mr-4\">\r\n          <ng-container *ngIf=\"isCallRinging\">\r\n            <div class=\"ringing-call-wrapper mt-2\">\r\n              <div class=\"call-label mb-1\">\r\n                {{ ringingCallText }}\r\n              </div>\r\n              <a>\r\n                <span class=\"Spa_Style_Primary Spa_Style_Paragraph\">\r\n                  <i aria-hidden=\"true\" class=\"{{ ringingCallIcon }} mr-1 pr-1\"></i>\r\n                  <span>{{ callingText }}</span>\r\n                </span>\r\n              </a>\r\n            </div>\r\n          </ng-container>\r\n\r\n          <ng-container *ngIf=\"callInProgress\">\r\n            <div class=\"mt-2 mr-2\">\r\n              <span class=\"d-flex Spa_Style_Primary_Color\">\r\n                <i aria-hidden=\"true\" class=\"{{ callInProgressIcon }} mr-1 pr-1\"></i>\r\n                <div class=\"d-flex flex-column\">\r\n                  <span class=\"Spa_Style_Paragraph\">{{ callInProgressText }}</span>\r\n                  <div class=\"Spa_Style_Gray4_Color elapsed-time-text\">{{ elapsedTimeText$ | async }}</div>\r\n                </div>\r\n              </span>\r\n            </div>\r\n            <div class=\"end-call-wrapper mt-2 mr-2\">\r\n              <a class=\"can-click d-flex\" role=\"button\" (click)=\"endCall(true)\">\r\n                <i aria-hidden=\"true\" class=\"{{ endCallIcon }} mr-1 pr-1\"></i>\r\n                <div class=\"Spa_Style_Paragraph d-flex flex-column\">\r\n                  <span class=\"end-call\">{{ endCallText }}</span>\r\n                </div>\r\n              </a>\r\n            </div>\r\n          </ng-container>\r\n\r\n          <ng-container *ngIf=\"hasCallEnded\">\r\n            <div class=\"mt-2 mr-2\">\r\n              <span class=\"d-flex Spa_Style_Paragraph\">\r\n                <i aria-hidden=\"true\" class=\"{{ callEndedIcon }} mr-1 pr-1\"></i>\r\n                <div class=\"d-flex flex-column\">\r\n                  <span>{{ callEndedText }}</span>\r\n                  <div class=\"Spa_Style_Gray4_Color elapsed-time-text\">{{ elapsedTimeText$ | async }}</div>\r\n                </div>\r\n              </span>\r\n            </div>\r\n          </ng-container>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer justify-content-start\">\r\n  <button type=\"button\" (click)=\"closeModal()\" class=\"btn Spa_Style_SecondaryButton mr-auto\">{{ cancelText }}</button>\r\n  <button type=\"submit\" [disabled]=\"!isCallRecording\" (click)=\"confirmAndCloseModal()\" class=\"btn Spa_Style_PrimaryButton\">\r\n    {{ continueButtonText }}\r\n  </button>\r\n</div>\r\n", styles: [".call-wrapper{font-size:14px;font-weight:400}.paragraph{line-height:1.6}.underline{text-decoration:underline}.ringing-call-wrapper,.ringing-call-wrapper .call-info{color:var(--static-Spa_Style_Cost_Text)}.ringing-call-wrapper .call-label{font-weight:700}.elapsed-time-text{font-size:13px}.end-call-wrapper,.end-call-wrapper .end-call{color:var(--static-Spa_Style_Accent2)}\n"] }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i1.AgentCallRecordingService }, { type: AgentCallRecordingShoppingFacade }, { type: i0.ChangeDetectorRef }, { type: i1.TwilioDeviceService }, { type: i1.SpinnerService }, { type: i1.NavigationService }, { type: i1.EnrollmentFormService }, { type: i1.GenericFormService }, { type: i1.ShoppingRecordingContextService }, { type: AnalyticsService }]; }, null); })();

class AgentCallRecordingFacade {
    constructor(store, configResourceService, agentService, phoneUtilityService, profileService, weglotService) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.agentService = agentService;
        this.phoneUtilityService = phoneUtilityService;
        this.profileService = profileService;
        this.weglotService = weglotService;
    }
    getEmailSentLabel(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingModal_EmailSent', widgetName, 'Email sent');
    }
    getEmailInvitation(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingModal_Email_Invitation', widgetName, 'Email invitation');
    }
    getEmailAddressText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_EmailAddress_Text', widgetName, 'Email address');
    }
    getTextInvitation(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingModal_Text_Invitation', widgetName, 'Text Invitation');
    }
    getCallBeneficiaryText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingModal_CallBeneficiary', widgetName, 'Call Beneficiary');
    }
    getPhoneNumberText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_PhoneNumber_Text', widgetName, 'Phone Number');
    }
    getSkipRecordingLinkText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Skip_Recording_Text', widgetName, 'Skip recording');
    }
    async getTextMessage(widgetName) {
        let textMessage = this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingModal_TextMessage', widgetName, `Your Agent has invited you to call the following number regarding your
         <client_name> enrollment: <agent_phone_number>, then enter <security_code>#`);
        const weglotMultiLanguageEnabled = this.configResourceService.getProcessedResourceValue('Spa_Weglot_MultiLanguage_Enabled', null, false);
        if (weglotMultiLanguageEnabled) {
            textMessage = await this.weglotService
                .getTranslatedText$(textMessage, ['<client_name>', '<agent_phone_number>', '<security_code>'])
                .toPromise();
        }
        return textMessage
            .replace('<client_name>', this.getMemberFullName())
            .replace('<agent_phone_number>', this.getTwilioAgentPhoneNumber())
            .replace('<security_code>', this.getTwilioAuthCode());
    }
    getApplyButtonText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_ShoppingCart_ApplyButton_Text', widgetName, 'Continue to apply');
    }
    getSectionHeader(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingModal_SectionHeader', widgetName, 'Request a call');
    }
    getInstructLabel(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingModal_InstructLabel', widgetName, `To start an enrollment call recording, send a text or email invitation to the beneficiary.
       The beneficiary will then call you and you can accept the call from this window.
       You can also call the beneficiary directly. Once your call is recording, continue to apply.`);
    }
    getCallBeneficiarySectionHeader(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingModal_CallBeneficiarySectionHeader', widgetName, 'Call the beneficiary');
    }
    getCallBeneficiaryLabel(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingModal_CallBeneficiaryInstructLabel', widgetName, `Must be an existing beneficiary.`);
    }
    getTitle(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingModal_Title', widgetName, 'Record your call');
    }
    getTextSentLabel(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingModal_TextSent', widgetName, 'Text sent');
    }
    getEmailInvalidFormatText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SOA_EmailInput_Error_InvalidFormat', widgetName, 'Please provide a valid email address');
    }
    getPhoneNumberInvalidFormatText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SOA_PhoneInput_Error_InvalidFormat', widgetName, 'Please provide a valid phone number');
    }
    isAgentCallRecodingEmailInviteEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_AgentCallRecording_EmailInvite_Enabled', widgetName, false);
    }
    isAgentCallRecordingEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_AgentCallRecording_Enabled', widgetName, false);
    }
    isAgentCallRecordingShoppingEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_AgentCallRecordingShopping_Enabled', widgetName, false);
    }
    isAgentCallRecodingTextInviteEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_AgentCallRecording_TextInvite_Enabled', widgetName, false);
    }
    isAgentCallRecordingFromProfilePartialEnrollmentEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_AgentCallRecording_FromPartialEnrollment_Enabled', widgetName, false);
    }
    isAgentCallRecordingSkipRecordingLinkEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecording_SkipRecording_Link_Enabled', widgetName, true);
    }
    isAgentCallRecordingCallBeneficiaryEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_AgentCallRecording_CallBeneficiary_Enabled', widgetName, false);
    }
    getCancelText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Cancel', widgetName, 'Cancel');
    }
    getAcceptCallText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingAcceptCall_Title', widgetName, 'Accept Call');
    }
    getCallingCallText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingCallingCall_Title', widgetName, 'Calling');
    }
    getRingingCallIcon(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingAcceptCall_Icon', widgetName, 'fas fa-phone-volume');
    }
    getRingingCallText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingRingingCall_Title', widgetName, '"Ringing"');
    }
    getCallInProgressText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallInProgressAcceptCall_Title', widgetName, 'Call in progress');
    }
    getCallInProgressIcon(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallInProgressAcceptCall_Icon', widgetName, 'fas fa-phone');
    }
    getEndCallIcon(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallEndCall_Icon', widgetName, 'fas fa-phone-slash');
    }
    getEndCallText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallEndCall_Title', widgetName, 'End call');
    }
    getCallEndedText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallEnded_Title', widgetName, 'Call ended');
    }
    getCallEndedIcon(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallEnded_Icon', widgetName, 'fas fa-phone');
    }
    getEnrollingInPlanText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentCallRecordingModal_Enrolling_In_Plan_Header_Text', widgetName, 'Enrolling in');
    }
    getAgentCallRecodingHeaderText(widgetName) {
        return this.configResourceService
            .getProcessedResourceValue('Spa_Site_AgentCallRecording_Header_Text', widgetName, 'Start an enrollment recording for <member>')
            .replace('<member>', this.getMemberFullName());
    }
    getMemberPhoneNumber() {
        return this.getMemberMobilePhoneNumber() ?? this.getMemberPrimaryPhoneNumber();
    }
    getMemberPrimaryPhoneNumber() {
        return this.profileService.getHomePhone();
    }
    getMemberMobilePhoneNumber() {
        return this.profileService.getCellPhone();
    }
    getMemberEmail() {
        return this.store.selectSnapshot(ProfileState.emailAddress);
    }
    getMemberFullName() {
        return this.store.selectSnapshot(ProfileState.fullName);
    }
    getTwilioAgentPhoneNumber() {
        return this.phoneUtilityService.parsePhoneNumber(this.store.selectSnapshot(TwilioState.phoneNumber));
    }
    getTwilioCallTrackingId() {
        return this.store.selectSnapshot(TwilioState.callTrackingId);
    }
    getTwilioAuthCode() {
        return this.store.selectSnapshot(TwilioState.authCode);
    }
    getMemberFirstName() {
        return this.store.selectSnapshot(ProfileState.firstName);
    }
    getEmailSubject(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_AgentCallRecording_EmailSubject', widgetName, 'Call your Agent to continue your enrollment');
    }
    getPhoneNumberNotAvailableErrorMessage(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_AgentCallRecording_PhoneNumberNotAvailableErrorMessage', widgetName, 'An issue has occurred. Please close this window and open it again to start a call recording.');
    }
    getTwilioFailedEventMessage(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_AgentCallRecording_TwilioFailedEventMessage', widgetName, 'There is an issue with the call recording. Please hang up, close this window, and reopen the window to start a new recording.');
    }
    isDisplayRecordingLinkEnabled(widgetName) {
        return this.agentService.isDisplayRecordingLinkEnabled(widgetName);
    }
    isDisplayPlayAudioRecordingEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Profile_AgentCallRecording_DisplayPlayAudioRecording_Enabled', widgetName, false);
    }
    callRecordingFileDurationEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_AgentCallRecording_DisplayFileDuration_Enabled', widgetName, false);
    }
    getAgentPhoneNumberLabel(widgetName) {
        return this.configResourceService
            .getProcessedResourceValue('Spa_Profile_AgentCallRecording_AgentPhoneNumberLabel', widgetName, 'Your phone number will display as: <number>')
            .replace('<number>', this.getTwilioAgentPhoneNumber());
    }
    getAgentFullName() {
        return this.store.selectSnapshot(AgentState.fullName);
    }
    getAgentFormatedPhonenumber() {
        const agentPhoneNumberFormatted = this.phoneUtilityService.formatPhoneNumberWithExtension(this.agentService.getAgentPhone(), this.agentService.getAgentExtension());
        return agentPhoneNumberFormatted;
    }
    getAgentEmail() {
        return this.store.selectSnapshot(AgentState.emailAddress);
    }
    async getAgentProfilePicture() {
        return (await this.agentService.getAgentEmailFooterData())?.agentPictureURL;
    }
}
AgentCallRecordingFacade.ɵfac = function AgentCallRecordingFacade_Factory(t) { return new (t || AgentCallRecordingFacade)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.AgentService), i0.ɵɵinject(i1.PhoneUtilityService), i0.ɵɵinject(i1.ProfileService), i0.ɵɵinject(i1.WeglotService)); };
AgentCallRecordingFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentCallRecordingFacade, factory: AgentCallRecordingFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentCallRecordingFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i2.Store }, { type: i1.ConfigResourceService }, { type: i1.AgentService }, { type: i1.PhoneUtilityService }, { type: i1.ProfileService }, { type: i1.WeglotService }]; }, null); })();

function AgentCallRecordingModalComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.errorMessage);
} }
function AgentCallRecordingModalComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "h4", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 20)(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.enrollInPlanText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.enrollingPlan.planName, " ");
} }
function AgentCallRecordingModalComponent_ng_container_19_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.phoneNumberInvalidFormatText, "");
} }
function AgentCallRecordingModalComponent_ng_container_19_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelement(1, "i", 31);
    i0.ɵɵtemplate(2, AgentCallRecordingModalComponent_ng_container_19_div_2_span_2_Template, 2, 1, "span", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r9.phoneNumberInput.errors == null ? null : ctx_r9.phoneNumberInput.errors.required) || (ctx_r9.phoneNumberInput.errors == null ? null : ctx_r9.phoneNumberInput.errors.pattern));
} }
function AgentCallRecordingModalComponent_ng_container_19_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1, "\u00A0");
    i0.ɵɵelementEnd();
} }
function AgentCallRecordingModalComponent_ng_container_19_label_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵelementStart(2, "span", 33);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.textSentLabel, " ");
} }
function AgentCallRecordingModalComponent_ng_container_19_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 21);
    i0.ɵɵtemplate(2, AgentCallRecordingModalComponent_ng_container_19_div_2_Template, 3, 1, "div", 22);
    i0.ɵɵtemplate(3, AgentCallRecordingModalComponent_ng_container_19_ng_template_3_Template, 2, 0, "ng-template", null, 23, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "form", 24);
    i0.ɵɵlistener("ngSubmit", function AgentCallRecordingModalComponent_ng_container_19_Template_form_ngSubmit_5_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.onSendText()); });
    i0.ɵɵelementStart(6, "label", 25);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 26)(9, "input", 27);
    i0.ɵɵlistener("focus", function AgentCallRecordingModalComponent_ng_container_19_Template_input_focus_9_listener() { i0.ɵɵrestoreView(_r15); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.showPhoneError = false); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "button", 28);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, AgentCallRecordingModalComponent_ng_container_19_label_12_Template, 4, 1, "label", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r10 = i0.ɵɵreference(4);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.showPhoneError && ctx_r2.phoneNumberInput.invalid)("ngIfElse", _r10);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.phoneNumberText, "");
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("has-error", ctx_r2.showPhoneError && ctx_r2.phoneNumberInput.invalid);
    i0.ɵɵpropertyInterpolate("mask", ctx_r2.phoneMask);
    i0.ɵɵproperty("formControl", ctx_r2.phoneNumberInput);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r2.errorMessage);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.textInvitation, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isTextSent);
} }
function AgentCallRecordingModalComponent_ng_container_21_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r21.emailInvalidFormatText, "");
} }
function AgentCallRecordingModalComponent_ng_container_21_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelement(1, "i", 31);
    i0.ɵɵtemplate(2, AgentCallRecordingModalComponent_ng_container_21_div_2_span_2_Template, 2, 1, "span", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r17.emailAddressInput.errors == null ? null : ctx_r17.emailAddressInput.errors.required) || (ctx_r17.emailAddressInput.errors == null ? null : ctx_r17.emailAddressInput.errors.pattern));
} }
function AgentCallRecordingModalComponent_ng_container_21_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1, "\u00A0");
    i0.ɵɵelementEnd();
} }
function AgentCallRecordingModalComponent_ng_container_21_label_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵelementStart(2, "span", 33);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r20.emailSentLabel, " ");
} }
function AgentCallRecordingModalComponent_ng_container_21_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 36);
    i0.ɵɵtemplate(2, AgentCallRecordingModalComponent_ng_container_21_div_2_Template, 3, 1, "div", 37);
    i0.ɵɵtemplate(3, AgentCallRecordingModalComponent_ng_container_21_ng_template_3_Template, 2, 0, "ng-template", null, 38, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "form", 39);
    i0.ɵɵlistener("ngSubmit", function AgentCallRecordingModalComponent_ng_container_21_Template_form_ngSubmit_5_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r22.onSendEmail()); });
    i0.ɵɵelementStart(6, "label", 40);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 26)(9, "input", 41);
    i0.ɵɵlistener("focus", function AgentCallRecordingModalComponent_ng_container_21_Template_input_focus_9_listener() { i0.ɵɵrestoreView(_r23); const ctx_r24 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r24.showEmailError = false); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "button", 42);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, AgentCallRecordingModalComponent_ng_container_21_label_12_Template, 4, 1, "label", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r18 = i0.ɵɵreference(4);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.showEmailError && ctx_r3.emailAddressInput.invalid)("ngIfElse", _r18);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.emailAddress, "");
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("has-error", ctx_r3.showEmailError && ctx_r3.emailAddressInput.invalid);
    i0.ɵɵproperty("formControl", ctx_r3.emailAddressInput);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r3.errorMessage);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.emailInvitation, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.isEmailSent);
} }
function AgentCallRecordingModalComponent_ng_container_22_div_9_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r28.phoneNumberInvalidFormatText, "");
} }
function AgentCallRecordingModalComponent_ng_container_22_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelement(1, "i", 31);
    i0.ɵɵtemplate(2, AgentCallRecordingModalComponent_ng_container_22_div_9_span_2_Template, 2, 1, "span", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r25.callBeneficiaryPhoneNumberInput.errors == null ? null : ctx_r25.callBeneficiaryPhoneNumberInput.errors.required) || (ctx_r25.callBeneficiaryPhoneNumberInput.errors == null ? null : ctx_r25.callBeneficiaryPhoneNumberInput.errors.pattern));
} }
function AgentCallRecordingModalComponent_ng_container_22_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1, "\u00A0");
    i0.ɵɵelementEnd();
} }
function AgentCallRecordingModalComponent_ng_container_22_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3)(2, "h4", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 7);
    i0.ɵɵelement(5, "span", 8);
    i0.ɵɵpipe(6, "safe");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 3)(8, "div", 21);
    i0.ɵɵtemplate(9, AgentCallRecordingModalComponent_ng_container_22_div_9_Template, 3, 1, "div", 22);
    i0.ɵɵtemplate(10, AgentCallRecordingModalComponent_ng_container_22_ng_template_10_Template, 2, 0, "ng-template", null, 23, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "form", 44);
    i0.ɵɵlistener("ngSubmit", function AgentCallRecordingModalComponent_ng_container_22_Template_form_ngSubmit_12_listener() { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r29.onCallBeneficiary()); });
    i0.ɵɵelementStart(13, "label", 25);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 26)(16, "input", 27);
    i0.ɵɵlistener("focus", function AgentCallRecordingModalComponent_ng_container_22_Template_input_focus_16_listener() { i0.ɵɵrestoreView(_r30); const ctx_r31 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r31.showCallBeneficiaryPhoneError = false); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "button", 28);
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r26 = i0.ɵɵreference(11);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r4.callBeneficiarySectionHeader);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(6, 12, ctx_r4.callBeneficiaryLabel, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r4.showCallBeneficiaryPhoneError && ctx_r4.callBeneficiaryPhoneNumberInput.invalid)("ngIfElse", _r26);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.phoneNumberText, "");
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("has-error", ctx_r4.showCallBeneficiaryPhoneError && ctx_r4.callBeneficiaryPhoneNumberInput.invalid);
    i0.ɵɵpropertyInterpolate("mask", ctx_r4.phoneMask);
    i0.ɵɵproperty("formControl", ctx_r4.callBeneficiaryPhoneNumberInput);
    i0.ɵɵattribute("aria-labelledby", "agent-call-recording-phone-text-input");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r4.errorMessage);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.callBeneficiaryButtonLabel, " ");
} }
function AgentCallRecordingModalComponent_ng_container_24_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 49);
    i0.ɵɵlistener("click", function AgentCallRecordingModalComponent_ng_container_24_ng_container_4_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r35.acceptCall()); });
    i0.ɵɵelementStart(2, "span", 50);
    i0.ɵɵelement(3, "i", 51);
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵclassMapInterpolate1("", ctx_r32.ringingCallIcon, " mr-1 pr-1");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r32.acceptCallText);
} }
function AgentCallRecordingModalComponent_ng_container_24_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a")(1, "span", 52);
    i0.ɵɵelement(2, "i", 51);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("", ctx_r34.ringingCallIcon, " mr-1 pr-1");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r34.callingText);
} }
function AgentCallRecordingModalComponent_ng_container_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 45)(2, "div", 46);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, AgentCallRecordingModalComponent_ng_container_24_ng_container_4_Template, 6, 4, "ng-container", 47);
    i0.ɵɵtemplate(5, AgentCallRecordingModalComponent_ng_container_24_ng_template_5_Template, 5, 4, "ng-template", null, 48, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r33 = i0.ɵɵreference(6);
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.ringingCallText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.incomingCall)("ngIfElse", _r33);
} }
function AgentCallRecordingModalComponent_ng_container_25_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 53)(2, "span", 54);
    i0.ɵɵelement(3, "i", 51);
    i0.ɵɵelementStart(4, "div", 55)(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 56);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "async");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(10, "div", 57)(11, "a", 49);
    i0.ɵɵlistener("click", function AgentCallRecordingModalComponent_ng_container_25_Template_a_click_11_listener() { i0.ɵɵrestoreView(_r38); const ctx_r37 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r37.endCall()); });
    i0.ɵɵelementStart(12, "span", 58);
    i0.ɵɵelement(13, "i", 51);
    i0.ɵɵelementStart(14, "span");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵclassMapInterpolate1("", ctx_r6.callInProgressIcon, " mr-1 pr-1");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r6.callInProgressText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 9, ctx_r6.elapsedTimeText$));
    i0.ɵɵadvance(5);
    i0.ɵɵclassMapInterpolate1("", ctx_r6.endCallIcon, " mr-1 pr-1");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r6.endCallText);
} }
function AgentCallRecordingModalComponent_ng_container_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 53)(2, "span", 59);
    i0.ɵɵelement(3, "i", 51);
    i0.ɵɵelementStart(4, "div", 60)(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 56);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "async");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵclassMapInterpolate1("", ctx_r7.callEndedIcon, " mr-1 pr-1");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r7.callEndedText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 5, ctx_r7.elapsedTimeText$));
} }
function AgentCallRecordingModalComponent_div_30_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 61)(1, "vnext-link", 62);
    i0.ɵɵlistener("click", function AgentCallRecordingModalComponent_div_30_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r40); const ctx_r39 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r39.skipRecording()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r8.skipRecordingButtonText)("showArrow", "right");
} }
class AgentCallRecordingModalComponent {
    constructor(activeModal, agentCallRecordingService, agentCallRecordingFacade, messageService, emailService, cdr, twilioService, analyticsService, spinnerService, agentService) {
        this.activeModal = activeModal;
        this.agentCallRecordingService = agentCallRecordingService;
        this.agentCallRecordingFacade = agentCallRecordingFacade;
        this.messageService = messageService;
        this.emailService = emailService;
        this.cdr = cdr;
        this.twilioService = twilioService;
        this.analyticsService = analyticsService;
        this.spinnerService = spinnerService;
        this.agentService = agentService;
        this.phoneMask = FormValidationService.phoneMask;
        this.memberPhoneNumber = '';
        this.memberEmailAddress = '';
        this.memberCallPhoneNumber = '';
        this.phoneNumberInput = new UntypedFormControl(this.memberPhoneNumber, [
            Validators.required,
            Validators.pattern(FormValidationService.phoneNumberPattern)
        ]);
        this.emailAddressInput = new UntypedFormControl(this.memberEmailAddress, [
            Validators.required,
            Validators.pattern(FormValidationService.emailPattern)
        ]);
        this.callBeneficiaryPhoneNumberInput = new UntypedFormControl(this.memberCallPhoneNumber, [
            Validators.required,
            Validators.pattern(FormValidationService.phoneNumberPattern)
        ]);
        this.deviceReadySubscription = new Subscription();
        this.deviceErrorSubscription = new Subscription();
        this.deviceConnectSubscription = new Subscription();
        this.connectionDisconnectSubscription = new Subscription();
        this.connectionIncomingSubscription = new Subscription();
        this.connectionCancelSubscription = new Subscription();
        this.subscriptions = [];
    }
    ngOnInit() {
        this.showCallRecordingLoadingSpinner(true);
        this.setAttributes();
        this.registerExternalPhoneNumber();
    }
    ngOnDestroy() {
        this.twilioService.setModalOpen(false);
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
        if (!this.isCallRecording) {
            this.twilioService.destroyDevice();
        }
    }
    setAttributes() {
        this.isAgentCallRecodingTextInviteEnabled = this.agentCallRecordingFacade.isAgentCallRecodingTextInviteEnabled();
        this.cancelText = this.agentCallRecordingFacade.getCancelText();
        this.isAgentCallRecodingEmailInviteEnabled = this.agentCallRecordingFacade.isAgentCallRecodingEmailInviteEnabled();
        this.phoneNumberInvalidFormatText = this.agentCallRecordingFacade.getPhoneNumberInvalidFormatText();
        this.emailInvalidFormatText = this.agentCallRecordingFacade.getEmailInvalidFormatText();
        this.textSentLabel = this.agentCallRecordingFacade.getTextSentLabel();
        this.ringingCallText = this.agentCallRecordingFacade.getRingingCallText();
        this.acceptCallText = this.agentCallRecordingFacade.getAcceptCallText();
        this.callingText = this.agentCallRecordingFacade.getCallingCallText();
        this.ringingCallIcon = this.agentCallRecordingFacade.getRingingCallIcon();
        this.callInProgressText = this.agentCallRecordingFacade.getCallInProgressText();
        this.callInProgressIcon = this.agentCallRecordingFacade.getCallInProgressIcon();
        this.endCallText = this.agentCallRecordingFacade.getEndCallText();
        this.endCallIcon = this.agentCallRecordingFacade.getEndCallIcon();
        this.callEndedText = this.agentCallRecordingFacade.getCallEndedText();
        this.callEndedIcon = this.agentCallRecordingFacade.getCallEndedIcon();
        this.title = this.agentCallRecordingFacade.getTitle();
        this.header = this.agentCallRecordingFacade.getAgentCallRecodingHeaderText();
        this.enrollInPlanText = this.agentCallRecordingFacade.getEnrollingInPlanText();
        this.instructLabel = this.agentCallRecordingFacade.getInstructLabel();
        this.sectionHeader = this.agentCallRecordingFacade.getSectionHeader();
        this.callBeneficiaryLabel = this.agentCallRecordingFacade.getCallBeneficiaryLabel();
        this.callBeneficiarySectionHeader = this.agentCallRecordingFacade.getCallBeneficiarySectionHeader();
        this.applyButtonText = this.agentCallRecordingFacade.getApplyButtonText();
        this.phoneNumberText = this.agentCallRecordingFacade.getPhoneNumberText();
        this.isAgentCallRecordingSkipRecordingLinkEnabled = this.agentCallRecordingFacade.isAgentCallRecordingSkipRecordingLinkEnabled();
        this.isAgentCallRecordingCallBeneficiaryEnabled = this.agentCallRecordingFacade.isAgentCallRecordingCallBeneficiaryEnabled();
        this.skipRecordingButtonText = this.agentCallRecordingFacade.getSkipRecordingLinkText();
        this.textInvitation = this.agentCallRecordingFacade.getTextInvitation();
        this.callBeneficiaryButtonLabel = this.agentCallRecordingFacade.getCallBeneficiaryText();
        this.emailAddress = this.agentCallRecordingFacade.getEmailAddressText();
        this.emailInvitation = this.agentCallRecordingFacade.getEmailInvitation();
        this.emailSentLabel = this.agentCallRecordingFacade.getEmailSentLabel();
        this.phoneNumberInput.setValue(this.agentCallRecordingFacade.getMemberPhoneNumber());
        this.callBeneficiaryPhoneNumberInput.setValue(this.agentCallRecordingFacade.getMemberPhoneNumber());
        this.emailAddressInput.setValue(this.agentCallRecordingFacade.getMemberEmail());
    }
    async onSendText() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_CALL_RECORDING_INVITE_VIA_TEXT
        };
        this.showPhoneError = true;
        if (!this.phoneNumberInput.invalid) {
            this.memberPhoneNumber = this.phoneNumberInput.value;
            if (!!this.memberPhoneNumber) {
                if (this.memberPhoneNumber !== this.agentCallRecordingFacade.getMemberPhoneNumber()) {
                    this.agentCallRecordingService.updateMemberPhoneData(this.memberPhoneNumber);
                }
                this.sendTextMessage();
            }
        }
    }
    async onSendEmail() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_CALL_RECORDING_INVITE_VIA_EMAIL
        };
        this.showEmailError = true;
        if (!this.emailAddressInput.invalid) {
            this.memberEmailAddress = this.emailAddressInput.value;
            // Only update email if email was changed
            if (!!this.memberEmailAddress) {
                if (this.memberEmailAddress !== this.agentCallRecordingFacade.getMemberEmail()) {
                    this.agentCallRecordingService.updateMemberEmail(this.emailAddressInput.value);
                }
                this.sendEmail();
            }
        }
    }
    async onCallBeneficiary() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_CALL_RECORDING_INVITE_VIA_CALL
        };
        this.showCallBeneficiaryPhoneError = true;
        if (!this.callBeneficiaryPhoneNumberInput.invalid) {
            this.memberCallPhoneNumber = this.callBeneficiaryPhoneNumberInput.value;
            if (!!this.memberCallPhoneNumber) {
                if (this.memberCallPhoneNumber !== this.agentCallRecordingFacade.getMemberPhoneNumber()) {
                    await this.agentCallRecordingService.updateMemberPhoneData(this.memberCallPhoneNumber);
                }
                await this.callBeneficiary();
            }
        }
    }
    registerExternalPhoneNumber() {
        // Destroy any existing device and connection to avoid having 2 or more living at the same time
        this.twilioService.destroyDevice();
        this.agentCallRecordingService
            .getTwilioPhoneNumber$()
            .pipe(switchMap(phoneNumber => this.agentCallRecordingService.getTwilioAuthToken$(phoneNumber).pipe(map(twilioToken => ({ phoneNumber, twilioToken })))), finalize(() => {
            this.agentPhoneNumberLabel = this.agentCallRecordingFacade.getAgentPhoneNumberLabel();
            this.cdr.markForCheck();
        }))
            .subscribe({
            next: phoneNumberAndtwilioToken => {
                this.agentCallRecordingService.storeTwilioAuthCode(phoneNumberAndtwilioToken.twilioToken?.authCode);
                this.agentCallRecordingService.storeTwilioCallTrackingId(phoneNumberAndtwilioToken.twilioToken?.callTrackingID);
                this.agentCallRecordingService.storeTwilioPhoneNumber(phoneNumberAndtwilioToken.phoneNumber);
                this.setupTwilioDevice(phoneNumberAndtwilioToken.twilioToken?.accessToken);
            },
            error: () => {
                this.showCallRecordingLoadingSpinner(false);
                this.errorMessage = this.agentCallRecordingFacade.getPhoneNumberNotAvailableErrorMessage();
            }
        });
    }
    setupTwilioDevice(accessToken) {
        this.twilioService.setupDevice(accessToken);
        this.subscriptions.push(this.twilioService.getDeviceRegistered$().subscribe((device) => {
            this.isCallRecording = false;
            this.callInProgress = false;
            this.hasCallEnded = false;
            this.incomingCall = false;
            this.twilioDevice = device;
            this.showCallRecordingLoadingSpinner(false);
        }));
        this.subscriptions.push(this.twilioService.getConnectionIncoming$().subscribe((connection) => {
            if (connection?.status() === Call.State.Pending) {
                this.twilioConnection = connection;
                this.isCallRinging = true;
                this.incomingCall = true;
                this.callInProgress = false;
                this.hasCallEnded = false;
                this.cdr.markForCheck();
                this.analyticsService.googleDataLayerTags = {
                    [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CASE_CALL_RECORDING_CALL_BEGIN,
                    [DataLayerGlobalVariable.CALL_RECORDING_BEGIN_VIA]: CallRecordingBeginVia.INCOMING_CALL,
                    [DataLayerGlobalVariable.CALL_RECORDING_TRACKING_ID]: this.agentCallRecordingFacade.getTwilioCallTrackingId()
                };
            }
        }));
        this.subscriptions.push(this.twilioService.getConnectionDisconnect$().subscribe(connection => {
            this.handleDisconnect(connection);
        }));
        this.subscriptions.push(this.twilioService.getConnectionCancel$().subscribe(connection => {
            this.handleDisconnect(connection);
        }));
        this.subscriptions.push(this.twilioService.getDeviceConnect$().subscribe(connection => {
            if (connection?.status() === Call.State.Connecting || connection?.status() === Call.State.Open) {
                this.isCallRinging = false;
                this.isCallRecording = true;
                this.callInProgress = true;
                this.elapsedTimeText$ = this.twilioService.getElapsedTimeText$();
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.push(this.twilioService.getDeviceError$().subscribe(error => {
            if (error) {
                this.hasCallEnded = this.incomingCall || this.isCallRinging || this.callInProgress;
                this.incomingCall = false;
                this.isCallRinging = false;
                this.callInProgress = false;
                this.errorMessage = this.agentCallRecordingFacade.getTwilioFailedEventMessage();
                this.cdr.markForCheck();
                this.showCallRecordingLoadingSpinner(false);
            }
        }));
    }
    continue() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_CALL_RECORDING_CONTINUE_APPLYING
        };
        this.confirmAction();
        this.activeModal.close();
        this.twilioService.markAsNotSkipped();
    }
    skipRecording() {
        this.twilioService.hangup(true);
        this.twilioService.skipTheCall();
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_CALL_RECORDING_SKIP_RECORDING
        };
        this.confirmAction();
        this.activeModal.close();
        this.cdr.markForCheck();
    }
    acceptCall() {
        this.twilioConnection.accept();
        this.isCallRecording = true;
        this.isCallRinging = false;
        this.callInProgress = true;
        this.hasCallEnded = false;
        this.incomingCall = false;
        this.elapsedTimeText$ = this.twilioService.getElapsedTimeText$();
    }
    endCall(mustDestroyDevice) {
        // In case we are handling a Pending (incoming) connection, reject it before disconnecting
        this.twilioConnection?.reject();
        this.twilioService.hangup(mustDestroyDevice);
        this.callInProgress = false;
        this.hasCallEnded = true;
        this.hasCallEndedManually = true;
        if (!mustDestroyDevice) {
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CASE_CALL_RECORDING_CALL_END,
                [DataLayerGlobalVariable.CALL_RECORDING_END_VIA]: CallRecordingEndVia.END_BUTTON,
                [DataLayerGlobalVariable.CALL_RECORDING_TRACKING_ID]: this.agentCallRecordingFacade.getTwilioCallTrackingId(),
                [DataLayerGlobalVariable.CALL_RECORDING_DURATION]: `${this.twilioService.getCallDurationInSeconds()}`
            };
        }
    }
    closeModal() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_CALL_RECORDING_MODAL_CANCEL
        };
        this.endCall(true);
        this.activeModal.close();
    }
    showCallRecordingLoadingSpinner(loading) {
        if (loading) {
            this.spinnerService.show(SpinnerEvent.NAVIGATION);
        }
        else {
            this.spinnerService.hide(SpinnerEvent.NAVIGATION);
        }
    }
    handleDisconnect(connection) {
        if (connection?.status() === Call.State.Closed) {
            this.twilioService.hangup();
            this.twilioConnection = connection;
            this.isCallRinging = false;
            this.incomingCall = false;
            this.callInProgress = false;
            this.hasCallEnded = true;
            this.isCallRecording = false;
            this.cdr.markForCheck();
            if (!this.hasCallEndedManually && !this.twilioService.isPreviousDeviceDestroyed) {
                this.analyticsService.googleDataLayerTags = {
                    [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CASE_CALL_RECORDING_CALL_END,
                    [DataLayerGlobalVariable.CALL_RECORDING_END_VIA]: CallRecordingEndVia.DISCONNECTED,
                    [DataLayerGlobalVariable.CALL_RECORDING_TRACKING_ID]: this.agentCallRecordingFacade.getTwilioCallTrackingId(),
                    [DataLayerGlobalVariable.CALL_RECORDING_DURATION]: `${this.twilioService.getCallDurationInSeconds()}`
                };
            }
            this.hasCallEndedManually = false;
        }
        else {
            // This covers the edge case where a modal is open, a call received, cancelled and then closed.
            // If we open the modal again, an event will be triggered with a connection closed that shows the "Call Ended" label
            this.hasCallEnded = false;
        }
    }
    sendTextMessage() {
        from(this.agentCallRecordingFacade.getTextMessage())
            .pipe(switchMap(textMessage => this.messageService.sendText$(this.memberPhoneNumber, textMessage)), take(1))
            .subscribe(() => {
            this.isTextSent = true;
            this.cdr.markForCheck();
            this.agentCallRecordingService.addCallInvitationSentNote(this.memberPhoneNumber, null);
        });
    }
    async sendEmail() {
        const inputs = [
            { key: 'agentName', value: this.agentCallRecordingFacade.getAgentFullName() },
            { key: 'agentNPN', value: this.agentService.getAgentNPN() },
            { key: 'agentPhone', value: this.agentCallRecordingFacade.getAgentFormatedPhonenumber() },
            { key: 'agentEmail', value: this.agentCallRecordingFacade.getAgentEmail() ? this.agentCallRecordingFacade.getAgentEmail() : '' },
            { key: 'agentPictureURL', value: await this.agentCallRecordingFacade.getAgentProfilePicture() },
            { key: 'clientName', value: this.agentCallRecordingFacade.getMemberFirstName() },
            { key: 'callRecordingPhoneNumber', value: this.agentCallRecordingFacade.getTwilioAgentPhoneNumber() },
            { key: 'callRecordingSecurityCode', value: `${this.agentCallRecordingFacade.getTwilioAuthCode()}#` },
            { key: 'californiaLicenseNumber', value: this.agentService.getCaliforniaLicenseNumber() }
        ];
        await this.emailService.sendEmail(EmailNames.YOUR_AGENT_HAS_INVITED, [this.memberEmailAddress], this.agentCallRecordingFacade.getEmailSubject(), inputs);
        this.isEmailSent = true;
        this.cdr.markForCheck();
        this.agentCallRecordingService.addCallInvitationSentNote(null, this.memberEmailAddress);
    }
    async callBeneficiary() {
        this.twilioConnection = await this.twilioService.callPhone(this.memberCallPhoneNumber);
        this.isCallRinging = true;
        this.incomingCall = false;
        this.hasCallEnded = false;
        this.agentCallRecordingService.addCallRecordingInitiatedNote(this.memberCallPhoneNumber);
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CASE_CALL_RECORDING_CALL_BEGIN,
            [DataLayerGlobalVariable.CALL_RECORDING_BEGIN_VIA]: CallRecordingBeginVia.OUTGOING_CALL,
            [DataLayerGlobalVariable.CALL_RECORDING_TRACKING_ID]: this.agentCallRecordingFacade.getTwilioCallTrackingId()
        };
    }
}
AgentCallRecordingModalComponent.ɵfac = function AgentCallRecordingModalComponent_Factory(t) { return new (t || AgentCallRecordingModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i1.AgentCallRecordingService), i0.ɵɵdirectiveInject(AgentCallRecordingFacade), i0.ɵɵdirectiveInject(i1.MessagesService), i0.ɵɵdirectiveInject(i1.EmailService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.TwilioDeviceService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i1.AgentService)); };
AgentCallRecordingModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentCallRecordingModalComponent, selectors: [["vnext-agent-call-recording-modal"]], decls: 33, vars: 23, consts: [[3, "modalTitleText", "modalTitleCancelAction"], ["tabindex", "-1", 1, "modal-body"], [1, "container"], [1, "row"], [1, "col-12"], ["class", "error-container", 4, "ngIf"], [1, "col-12", "p-0", "Spa_Style_H2", "m-0"], [1, "col-12", "p-0", "Spa_Style_Paragraph"], [3, "innerHTML"], [1, "col-12", "p-0", "mt-1", "Spa_Style_Paragraph"], ["class", "col-12 p-0 mt-3", 4, "ngIf"], [1, "Spa_Style_H4", "pt-3", "m-0"], [4, "ngIf"], [1, "row", "float-right", "call-wrapper", "mb-4", "mr-4"], [1, "modal-footer", "justify-content-start"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "mr-auto", 3, "click"], ["class", "pr-2 mr-1", "skip-recording-link", "", 4, "ngIf"], ["type", "submit", 1, "btn", "Spa_Style_PrimaryButton", 3, "disabled", "click"], [1, "error-container"], [1, "col-12", "p-0", "mt-3"], [1, "mt-1", "Spa_Style_Paragraph", "no-translate-block"], [1, "row", "mt-0", "col-12"], ["class", "col-12 p-0 error-color", 4, "ngIf", "ngIfElse"], ["phoneErrorPlaceHolder", ""], ["disableKeyDownSubmit", "", 1, "row", "col-12", "email-wrapper", "p-0", "no-gutters", 3, "ngSubmit"], ["for", "agent-call-recording-phone-text-input", 1, "col-12", "Spa_Style_Label"], [1, "col-12", "col-sm-auto"], ["id", "agent-call-recording-phone-text-input", "type", "text", 1, "w-100", "phone-input", "mr-0", 3, "mask", "formControl", "focus"], ["type", "submit", 1, "col-12", "col-sm-auto", "phone-button", "p-0", "pl-2", "pr-2", "mt-md-0", "mr-2", "btn", "Spa_Style_SecondaryButton", 3, "disabled"], ["class", "col-auto info-label mb-0 d-flex align-items-center", 4, "ngIf"], [1, "col-12", "p-0", "error-color"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], ["role", "alert", 4, "ngIf"], ["role", "alert"], [1, "col-auto", "info-label", "mb-0", "d-flex", "align-items-center"], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "mr-1"], [1, "row", "col-12", "p-0", "mt-0"], ["class", "col-12 error-color", 4, "ngIf", "ngIfElse"], ["errorPlaceHolder", ""], ["disableKeyDownSubmit", "", 1, "row", "col-12", "email-wrapper", "mb-3", "p-0", "no-gutters", 3, "ngSubmit"], ["for", "agent-call-recording-email-input", 1, "col-12", "Spa_Style_Label"], ["id", "agent-call-recording-email-input", "type", "text", 1, "w-100", "email-input", 3, "formControl", "focus"], ["type", "submit", 1, "col-12", "col-sm-auto", "email-button", "p-0", "pl-2", "pr-2", "mt-md-0", "mr-2", "btn", "Spa_Style_SecondaryButton", 3, "disabled"], [1, "col-12", "error-color"], ["disableKeyDownSubmit", "", 1, "row", "col-12", "email-wrapper", "p-0", "mb-5", "no-gutters", 3, "ngSubmit"], [1, "ringing-call-wrapper", "mt-2"], [1, "call-label", "mb-1"], [4, "ngIf", "ngIfElse"], ["outgoingCall", ""], ["role", "button", 1, "can-click", 3, "click"], [1, "call-info"], ["aria-hidden", "true"], [1, "call-info", "calling-text"], [1, "mt-2", "mr-2"], [1, "d-flex", "call-in-progress-wrapper"], [1, "call-in-progress", "d-flex", "flex-column"], [1, "Spa_Style_Gray4_Color"], [1, "end-call-wrapper", "mt-2", "mr-2"], [1, "end-call"], [1, "d-flex"], [1, "d-flex", "flex-column"], ["skip-recording-link", "", 1, "pr-2", "mr-1"], [3, "title", "showArrow", "click"]], template: function AgentCallRecordingModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function AgentCallRecordingModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 3);
        i0.ɵɵtemplate(6, AgentCallRecordingModalComponent_div_6_Template, 2, 1, "div", 5);
        i0.ɵɵelementStart(7, "h2", 6);
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 7);
        i0.ɵɵelement(10, "span", 8);
        i0.ɵɵpipe(11, "safe");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 9);
        i0.ɵɵelement(13, "span", 8);
        i0.ɵɵpipe(14, "safe");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(15, AgentCallRecordingModalComponent_div_15_Template, 6, 2, "div", 10);
        i0.ɵɵelementStart(16, "h4", 11);
        i0.ɵɵtext(17);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(18, "div", 3);
        i0.ɵɵtemplate(19, AgentCallRecordingModalComponent_ng_container_19_Template, 13, 10, "ng-container", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 3);
        i0.ɵɵtemplate(21, AgentCallRecordingModalComponent_ng_container_21_Template, 13, 9, "ng-container", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(22, AgentCallRecordingModalComponent_ng_container_22_Template, 19, 15, "ng-container", 12);
        i0.ɵɵelementStart(23, "div", 13);
        i0.ɵɵtemplate(24, AgentCallRecordingModalComponent_ng_container_24_Template, 7, 3, "ng-container", 12);
        i0.ɵɵtemplate(25, AgentCallRecordingModalComponent_ng_container_25_Template, 16, 11, "ng-container", 12);
        i0.ɵɵtemplate(26, AgentCallRecordingModalComponent_ng_container_26_Template, 10, 7, "ng-container", 12);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(27, "div", 14)(28, "button", 15);
        i0.ɵɵlistener("click", function AgentCallRecordingModalComponent_Template_button_click_28_listener() { return ctx.closeModal(); });
        i0.ɵɵtext(29);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(30, AgentCallRecordingModalComponent_div_30_Template, 2, 2, "div", 16);
        i0.ɵɵelementStart(31, "button", 17);
        i0.ɵɵlistener("click", function AgentCallRecordingModalComponent_Template_button_click_31_listener() { return ctx.continue(); });
        i0.ɵɵtext(32);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.errorMessage);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.header);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(11, 17, ctx.instructLabel, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(14, 20, ctx.agentPhoneNumberLabel, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.enrollingPlan);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.sectionHeader);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isAgentCallRecodingTextInviteEnabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isAgentCallRecodingEmailInviteEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isAgentCallRecordingCallBeneficiaryEnabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isCallRinging);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.callInProgress);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasCallEnded);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.cancelText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isAgentCallRecordingSkipRecordingLinkEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", !ctx.isCallRecording);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.applyButtonText, " ");
    } }, dependencies: [i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.NgForm, i4.FormControlDirective, LinkComponent, ModalHeaderComponent, FormInputSubmitDirective, IconAriaAttributesDirective, i8.MaskDirective, i1$2.AsyncPipe, SafePipe], styles: [".email-input[_ngcontent-%COMP%], .phone-input[_ngcontent-%COMP%]{border-top-right-radius:0;border-bottom-right-radius:0}.email-button[_ngcontent-%COMP%], .phone-button[_ngcontent-%COMP%]{border-top-left-radius:0;border-bottom-left-radius:0}.info-label[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Gray4)}.call-wrapper[_ngcontent-%COMP%]{font-size:14px;font-weight:400}.ringing-call-wrapper[_ngcontent-%COMP%], .ringing-call-wrapper[_ngcontent-%COMP%]   .call-info[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text)}.ringing-call-wrapper[_ngcontent-%COMP%]   .call-info.calling-text[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Gray4)}.ringing-call-wrapper[_ngcontent-%COMP%]   .call-label[_ngcontent-%COMP%]{font-weight:700}.call-in-progress-wrapper[_ngcontent-%COMP%], .call-in-progress-wrapper[_ngcontent-%COMP%]   .call-in-progress[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Gray4)}.end-call-wrapper[_ngcontent-%COMP%], .end-call-wrapper[_ngcontent-%COMP%]   .end-call[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent2)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentCallRecordingModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-call-recording-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"closeModal()\"></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body\" tabindex=\"-1\">\r\n  <div class=\"container\">\r\n    <div class=\"row\">\r\n      <div class=\"col-12\">\r\n        <div class=\"row\">\r\n          <div *ngIf=\"errorMessage\" class=\"error-container\">{{ errorMessage }}</div>\r\n          <h2 class=\"col-12 p-0 Spa_Style_H2 m-0\">{{ header }}</h2>\r\n          <div class=\"col-12 p-0 Spa_Style_Paragraph\">\r\n            <span [innerHTML]=\"instructLabel | safe : 'html'\"></span>\r\n          </div>\r\n          <div class=\"col-12 p-0 mt-1 Spa_Style_Paragraph\">\r\n            <span [innerHTML]=\"agentPhoneNumberLabel | safe : 'html'\"></span>\r\n          </div>\r\n          <div *ngIf=\"enrollingPlan\" class=\"col-12 p-0 mt-3\">\r\n            <h4 class=\"Spa_Style_H4 pt-3 m-0\">{{ enrollInPlanText }}</h4>\r\n            <div class=\"mt-1 Spa_Style_Paragraph no-translate-block\">\r\n              <span>\r\n                {{ enrollingPlan.planName }}\r\n              </span>\r\n            </div>\r\n          </div>\r\n          <h4 class=\"Spa_Style_H4 pt-3 m-0\">{{ sectionHeader }}</h4>\r\n        </div>\r\n        <div class=\"row\">\r\n          <ng-container *ngIf=\"isAgentCallRecodingTextInviteEnabled\">\r\n            <div class=\"row mt-0 col-12\">\r\n              <div class=\"col-12 p-0 error-color\" *ngIf=\"showPhoneError && phoneNumberInput.invalid; else phoneErrorPlaceHolder\">\r\n                <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n                <span *ngIf=\"phoneNumberInput.errors?.required || phoneNumberInput.errors?.pattern\" role=\"alert\">\r\n                  {{ phoneNumberInvalidFormatText }}</span\r\n                >\r\n              </div>\r\n              <ng-template #phoneErrorPlaceHolder>\r\n                <div class=\"col-12\">&nbsp;</div>\r\n              </ng-template>\r\n            </div>\r\n            <form disableKeyDownSubmit (ngSubmit)=\"onSendText()\" class=\"row col-12 email-wrapper p-0 no-gutters\">\r\n              <label class=\"col-12 Spa_Style_Label\" for=\"agent-call-recording-phone-text-input\"> {{ phoneNumberText }}</label>\r\n              <div class=\"col-12 col-sm-auto\">\r\n                <input\r\n                  id=\"agent-call-recording-phone-text-input\"\r\n                  class=\"w-100 phone-input mr-0\"\r\n                  type=\"text\"\r\n                  mask=\"{{ phoneMask }}\"\r\n                  [class.has-error]=\"showPhoneError && phoneNumberInput.invalid\"\r\n                  [formControl]=\"phoneNumberInput\"\r\n                  (focus)=\"showPhoneError = false\"\r\n                />\r\n              </div>\r\n              <button\r\n                [disabled]=\"errorMessage\"\r\n                class=\"col-12 col-sm-auto phone-button p-0 pl-2 pr-2 mt-md-0 mr-2 btn Spa_Style_SecondaryButton\"\r\n                type=\"submit\"\r\n              >\r\n                {{ textInvitation }}\r\n              </button>\r\n              <label class=\"col-auto info-label mb-0 d-flex align-items-center\" *ngIf=\"isTextSent\">\r\n                <i class=\"fas fa-check-circle mr-1\" aria-hidden=\"true\"></i>\r\n                <span role=\"alert\">\r\n                  {{ textSentLabel }}\r\n                </span>\r\n              </label>\r\n            </form>\r\n          </ng-container>\r\n        </div>\r\n        <div class=\"row\">\r\n          <ng-container *ngIf=\"isAgentCallRecodingEmailInviteEnabled\">\r\n            <div class=\"row col-12 p-0 mt-0\">\r\n              <div class=\"col-12 error-color\" *ngIf=\"showEmailError && emailAddressInput.invalid; else errorPlaceHolder\">\r\n                <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n                <span *ngIf=\"emailAddressInput.errors?.required || emailAddressInput.errors?.pattern\" role=\"alert\">\r\n                  {{ emailInvalidFormatText }}</span\r\n                >\r\n              </div>\r\n              <ng-template #errorPlaceHolder>\r\n                <div class=\"col-12\">&nbsp;</div>\r\n              </ng-template>\r\n            </div>\r\n            <form disableKeyDownSubmit (ngSubmit)=\"onSendEmail()\" class=\"row col-12 email-wrapper mb-3 p-0 no-gutters\">\r\n              <label class=\"col-12 Spa_Style_Label\" for=\"agent-call-recording-email-input\"> {{ emailAddress }}</label>\r\n              <div class=\"col-12 col-sm-auto\">\r\n                <input\r\n                  id=\"agent-call-recording-email-input\"\r\n                  class=\"w-100 email-input\"\r\n                  type=\"text\"\r\n                  [formControl]=\"emailAddressInput\"\r\n                  [class.has-error]=\"showEmailError && emailAddressInput.invalid\"\r\n                  (focus)=\"showEmailError = false\"\r\n                />\r\n              </div>\r\n              <button\r\n                [disabled]=\"errorMessage\"\r\n                class=\"col-12 col-sm-auto email-button p-0 pl-2 pr-2 mt-md-0 mr-2 btn Spa_Style_SecondaryButton\"\r\n                type=\"submit\"\r\n              >\r\n                {{ emailInvitation }}\r\n              </button>\r\n              <label class=\"col-auto info-label mb-0 d-flex align-items-center\" *ngIf=\"isEmailSent\">\r\n                <i class=\"fas fa-check-circle mr-1\" aria-hidden=\"true\"></i>\r\n                <span role=\"alert\">\r\n                  {{ emailSentLabel }}\r\n                </span>\r\n              </label>\r\n            </form>\r\n          </ng-container>\r\n        </div>\r\n\r\n        <ng-container *ngIf=\"isAgentCallRecordingCallBeneficiaryEnabled\">\r\n          <div class=\"row\">\r\n            <h4 class=\"Spa_Style_H4 pt-3 m-0\">{{ callBeneficiarySectionHeader }}</h4>\r\n            <div class=\"col-12 p-0 Spa_Style_Paragraph\">\r\n              <span [innerHTML]=\"callBeneficiaryLabel | safe : 'html'\"></span>\r\n            </div>\r\n          </div>\r\n          <div class=\"row\">\r\n            <div class=\"row mt-0 col-12\">\r\n              <div\r\n                class=\"col-12 p-0 error-color\"\r\n                *ngIf=\"showCallBeneficiaryPhoneError && callBeneficiaryPhoneNumberInput.invalid; else phoneErrorPlaceHolder\"\r\n              >\r\n                <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n                <span\r\n                  *ngIf=\"callBeneficiaryPhoneNumberInput.errors?.required || callBeneficiaryPhoneNumberInput.errors?.pattern\"\r\n                  role=\"alert\"\r\n                >\r\n                  {{ phoneNumberInvalidFormatText }}</span\r\n                >\r\n              </div>\r\n              <ng-template #phoneErrorPlaceHolder>\r\n                <div class=\"col-12\">&nbsp;</div>\r\n              </ng-template>\r\n            </div>\r\n            <form disableKeyDownSubmit (ngSubmit)=\"onCallBeneficiary()\" class=\"row col-12 email-wrapper p-0 mb-5 no-gutters\">\r\n              <label class=\"col-12 Spa_Style_Label\" for=\"agent-call-recording-phone-text-input\"> {{ phoneNumberText }}</label>\r\n              <div class=\"col-12 col-sm-auto\">\r\n                <input\r\n                  id=\"agent-call-recording-phone-text-input\"\r\n                  class=\"w-100 phone-input mr-0\"\r\n                  type=\"text\"\r\n                  mask=\"{{ phoneMask }}\"\r\n                  [class.has-error]=\"showCallBeneficiaryPhoneError && callBeneficiaryPhoneNumberInput.invalid\"\r\n                  [formControl]=\"callBeneficiaryPhoneNumberInput\"\r\n                  [attr.aria-labelledby]=\"'agent-call-recording-phone-text-input'\"\r\n                  (focus)=\"showCallBeneficiaryPhoneError = false\"\r\n                />\r\n              </div>\r\n              <button\r\n                [disabled]=\"errorMessage\"\r\n                class=\"col-12 col-sm-auto phone-button p-0 pl-2 pr-2 mt-md-0 mr-2 btn Spa_Style_SecondaryButton\"\r\n                type=\"submit\"\r\n              >\r\n                {{ callBeneficiaryButtonLabel }}\r\n              </button>\r\n            </form>\r\n          </div>\r\n        </ng-container>\r\n\r\n        <div class=\"row float-right call-wrapper mb-4 mr-4\">\r\n          <ng-container *ngIf=\"isCallRinging\">\r\n            <div class=\"ringing-call-wrapper mt-2\">\r\n              <div class=\"call-label mb-1\">\r\n                {{ ringingCallText }}\r\n              </div>\r\n              <ng-container *ngIf=\"incomingCall; else outgoingCall\">\r\n                <a class=\"can-click\" role=\"button\" (click)=\"acceptCall()\">\r\n                  <span class=\"call-info\">\r\n                    <i aria-hidden=\"true\" class=\"{{ ringingCallIcon }} mr-1 pr-1\"></i>\r\n                    <span>{{ acceptCallText }}</span>\r\n                  </span>\r\n                </a>\r\n              </ng-container>\r\n              <ng-template #outgoingCall>\r\n                <a>\r\n                  <span class=\"call-info calling-text\">\r\n                    <i aria-hidden=\"true\" class=\"{{ ringingCallIcon }} mr-1 pr-1\"></i>\r\n                    <span>{{ callingText }}</span>\r\n                  </span>\r\n                </a>\r\n              </ng-template>\r\n            </div>\r\n          </ng-container>\r\n\r\n          <ng-container *ngIf=\"callInProgress\">\r\n            <div class=\"mt-2 mr-2\">\r\n              <span class=\"d-flex call-in-progress-wrapper\">\r\n                <i aria-hidden=\"true\" class=\"{{ callInProgressIcon }} mr-1 pr-1\"></i>\r\n                <div class=\"call-in-progress d-flex flex-column\">\r\n                  <span>{{ callInProgressText }}</span>\r\n                  <div class=\"Spa_Style_Gray4_Color\">{{ elapsedTimeText$ | async }}</div>\r\n                </div>\r\n              </span>\r\n            </div>\r\n            <div class=\"end-call-wrapper mt-2 mr-2\">\r\n              <a class=\"can-click\" role=\"button\" (click)=\"endCall()\">\r\n                <span class=\"end-call\">\r\n                  <i aria-hidden=\"true\" class=\"{{ endCallIcon }} mr-1 pr-1\"></i>\r\n                  <span>{{ endCallText }}</span>\r\n                </span>\r\n              </a>\r\n            </div>\r\n          </ng-container>\r\n\r\n          <ng-container *ngIf=\"hasCallEnded\">\r\n            <div class=\"mt-2 mr-2\">\r\n              <span class=\"d-flex\">\r\n                <i aria-hidden=\"true\" class=\"{{ callEndedIcon }} mr-1 pr-1\"></i>\r\n                <div class=\"d-flex flex-column\">\r\n                  <span>{{ callEndedText }}</span>\r\n                  <div class=\"Spa_Style_Gray4_Color\">{{ elapsedTimeText$ | async }}</div>\r\n                </div>\r\n              </span>\r\n            </div>\r\n          </ng-container>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer justify-content-start\">\r\n  <button type=\"button\" (click)=\"closeModal()\" class=\"btn Spa_Style_SecondaryButton mr-auto\">{{ cancelText }}</button>\r\n  <div *ngIf=\"isAgentCallRecordingSkipRecordingLinkEnabled\" class=\"pr-2 mr-1\" skip-recording-link>\r\n    <vnext-link [title]=\"skipRecordingButtonText\" [showArrow]=\"'right'\" (click)=\"skipRecording()\"> </vnext-link>\r\n  </div>\r\n  <button type=\"submit\" [disabled]=\"!isCallRecording\" (click)=\"continue()\" class=\"btn Spa_Style_PrimaryButton\">\r\n    {{ applyButtonText }}\r\n  </button>\r\n</div>\r\n", styles: [".email-input,.phone-input{border-top-right-radius:0;border-bottom-right-radius:0}.email-button,.phone-button{border-top-left-radius:0;border-bottom-left-radius:0}.info-label{color:var(--static-Spa_Style_Gray4)}.call-wrapper{font-size:14px;font-weight:400}.ringing-call-wrapper,.ringing-call-wrapper .call-info{color:var(--static-Spa_Style_Cost_Text)}.ringing-call-wrapper .call-info.calling-text{color:var(--static-Spa_Style_Gray4)}.ringing-call-wrapper .call-label{font-weight:700}.call-in-progress-wrapper,.call-in-progress-wrapper .call-in-progress{color:var(--static-Spa_Style_Gray4)}.end-call-wrapper,.end-call-wrapper .end-call{color:var(--static-Spa_Style_Accent2)}\n"] }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i1.AgentCallRecordingService }, { type: AgentCallRecordingFacade }, { type: i1.MessagesService }, { type: i1.EmailService }, { type: i0.ChangeDetectorRef }, { type: i1.TwilioDeviceService }, { type: AnalyticsService }, { type: i1.SpinnerService }, { type: i1.AgentService }]; }, null); })();

const VNEXT_COMPONENT_EXPORTS = [
    CheckBoxItemComponent,
    CheckboxGroupComponent,
    EnrollmentFormNavigationComponent,
    HospitalIndemnityFormComponent,
    RateFactorsFormComponent,
    RateFactorBirthDateComponent,
    RateFactorDateComponent,
    RateFactorDropdownComponent,
    RateFactorEffectiveDateComponent,
    RateFactorToggleComponent,
    ZipCodeInputComponent,
    TabComponent,
    TabListComponent,
    ZipCodeModalComponent,
    PlanYearModalComponent,
    HospitalIndemnityFactorModalComponent,
    MedicalConditionDrugAlternativesSelectionModalComponent,
    ContactUsModalComponent,
    EmailConfirmationModalComponent,
    EmailConfirmationSuccessModalComponent,
    FieldErrorsComponent,
    FieldErrorComponent,
    TotalPremiumBannerComponent,
    NavigationBannerComponent,
    PageNavButtonComponent,
    LogoutButtonComponent,
    PaginationComponent,
    LinkComponent,
    FollowUpTaskComponent,
    InnerTextLinkComponent,
    ToggleSelectComponent,
    ToggleMultiSelectComponent,
    TooltipComponent,
    ConfigurableTooltipComponent,
    LearnMoreTooltipComponent,
    StatusButtonComponent,
    FootnoteComponent,
    StateSelectorInputComponent,
    AgencyNameSelectorInputComponent,
    AgentNoteModalComponent,
    AgentTaskModalComponent,
    HtmlConfirmationModalComponent,
    ShoppingCartCrossSellModalComponent,
    ShoppingCartCrossSellComponent,
    SelectDropdownByCharacterDirective,
    SNPToggleComponent,
    SNPCategoryToggleComponent,
    SpinnerComponent,
    LoaderPlaceholderComponent,
    NotLicensedPlanListComponent,
    ScrollableMultiSelectCheckboxComponent,
    DatePickerInputComponent,
    DropdownButtonComponent,
    FormMonthYearDropdownComponent,
    WarningMessageManyResultsAgentSearchComponent,
    FormDateComponent,
    NoticeContainerComponent,
    NoticeWarnListComponent,
    NoticeSuccessListComponent,
    NoticeInfoListComponent,
    NoticeErrorListComponent,
    NoticeComponent,
    UpdateEffectiveDateModalComponent,
    PlanCoverageProviderInfoModalComponent,
    AgentCallRecordingShoppingBoxComponent,
    PlanYearBadgeComponent,
    ProviderAcceptingNewPatientsComponent,
    ProviderInlineElementComponent,
    ProviderPhoneComponent,
    ModalFooterComponent,
    ModalHeaderComponent,
    AgentOfRecordModalComponent,
    AgentOfRecordModalSearchComponent,
    AgentOfRecordModalResultsComponent,
    AgentOfRecordModalSuccessComponent,
    AuthorizationCodeSignatureModalComponent,
    AuthorizationCodeSignatureStatementComponent,
    VoiceSignatureModalComponent,
    VoiceSignatureStatementComponent,
    SendRetireFloModalComponent,
    ValueBasedCareAgreementComponent,
    AgentRetireFloSignupModalComponent,
    RetireFloSurveyModalComponent
];
const VNEXT_COMPONENT_DECLARATIONS = [...VNEXT_COMPONENT_EXPORTS];
const VNEXT_COMPONENT_ENTRY_COMPONENTS = [
    ZipCodeModalComponent,
    PlanYearModalComponent,
    HospitalIndemnityFactorModalComponent,
    MedicalConditionDrugAlternativesSelectionModalComponent,
    ContactUsModalComponent,
    EmailConfirmationModalComponent,
    EmailConfirmationSuccessModalComponent,
    AgentNoteModalComponent,
    AgentTaskModalComponent,
    HtmlConfirmationModalComponent,
    ShoppingCartCrossSellModalComponent,
    ShoppingCartCrossSellComponent,
    NotLicensedPlanListComponent,
    UpdateEffectiveDateModalComponent,
    PlanCoverageProviderInfoModalComponent,
    ProviderAcceptingNewPatientsComponent,
    ProviderInlineElementComponent,
    ProviderPhoneComponent,
    AgentOfRecordModalComponent,
    AgentOfRecordModalSearchComponent,
    AgentOfRecordModalResultsComponent,
    AgentOfRecordModalSuccessComponent,
    SendRetireFloModalComponent,
    ValueBasedCareAgreementComponent,
    AgentRetireFloSignupModalComponent,
    RetireFloSurveyModalComponent
];

class ComponentsModule {
}
ComponentsModule.ɵfac = function ComponentsModule_Factory(t) { return new (t || ComponentsModule)(); };
ComponentsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ComponentsModule });
ComponentsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ConfigsModule,
        DigitOnlyModule,
        NgbModule,
        PipesModule,
        NgxMaskModule,
        DirectivesModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ComponentsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    RouterModule,
                    ConfigsModule,
                    DigitOnlyModule,
                    NgbModule,
                    PipesModule,
                    NgxMaskModule,
                    DirectivesModule
                ],
                declarations: VNEXT_COMPONENT_DECLARATIONS,
                exports: VNEXT_COMPONENT_EXPORTS
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ComponentsModule, { declarations: [CheckBoxItemComponent, CheckboxGroupComponent, EnrollmentFormNavigationComponent, HospitalIndemnityFormComponent, RateFactorsFormComponent, RateFactorBirthDateComponent, RateFactorDateComponent, RateFactorDropdownComponent, RateFactorEffectiveDateComponent, RateFactorToggleComponent, ZipCodeInputComponent, TabComponent, TabListComponent, ZipCodeModalComponent, PlanYearModalComponent, HospitalIndemnityFactorModalComponent, MedicalConditionDrugAlternativesSelectionModalComponent, ContactUsModalComponent, EmailConfirmationModalComponent, EmailConfirmationSuccessModalComponent, FieldErrorsComponent, FieldErrorComponent, TotalPremiumBannerComponent, NavigationBannerComponent, PageNavButtonComponent, LogoutButtonComponent, PaginationComponent, LinkComponent, FollowUpTaskComponent, InnerTextLinkComponent, ToggleSelectComponent, ToggleMultiSelectComponent, TooltipComponent, ConfigurableTooltipComponent, LearnMoreTooltipComponent, StatusButtonComponent, FootnoteComponent, StateSelectorInputComponent, AgencyNameSelectorInputComponent, AgentNoteModalComponent, AgentTaskModalComponent, HtmlConfirmationModalComponent, ShoppingCartCrossSellModalComponent, ShoppingCartCrossSellComponent, SelectDropdownByCharacterDirective, SNPToggleComponent, SNPCategoryToggleComponent, SpinnerComponent, LoaderPlaceholderComponent, NotLicensedPlanListComponent, ScrollableMultiSelectCheckboxComponent, DatePickerInputComponent, DropdownButtonComponent, FormMonthYearDropdownComponent, WarningMessageManyResultsAgentSearchComponent, FormDateComponent, NoticeContainerComponent, NoticeWarnListComponent, NoticeSuccessListComponent, NoticeInfoListComponent, NoticeErrorListComponent, NoticeComponent, UpdateEffectiveDateModalComponent, PlanCoverageProviderInfoModalComponent, AgentCallRecordingShoppingBoxComponent, PlanYearBadgeComponent, ProviderAcceptingNewPatientsComponent, ProviderInlineElementComponent, ProviderPhoneComponent, ModalFooterComponent, ModalHeaderComponent, AgentOfRecordModalComponent, AgentOfRecordModalSearchComponent, AgentOfRecordModalResultsComponent, AgentOfRecordModalSuccessComponent, AuthorizationCodeSignatureModalComponent, AuthorizationCodeSignatureStatementComponent, VoiceSignatureModalComponent, VoiceSignatureStatementComponent, SendRetireFloModalComponent, ValueBasedCareAgreementComponent, AgentRetireFloSignupModalComponent, RetireFloSurveyModalComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ConfigsModule,
        DigitOnlyModule,
        NgbModule,
        PipesModule,
        NgxMaskModule,
        DirectivesModule], exports: [CheckBoxItemComponent, CheckboxGroupComponent, EnrollmentFormNavigationComponent, HospitalIndemnityFormComponent, RateFactorsFormComponent, RateFactorBirthDateComponent, RateFactorDateComponent, RateFactorDropdownComponent, RateFactorEffectiveDateComponent, RateFactorToggleComponent, ZipCodeInputComponent, TabComponent, TabListComponent, ZipCodeModalComponent, PlanYearModalComponent, HospitalIndemnityFactorModalComponent, MedicalConditionDrugAlternativesSelectionModalComponent, ContactUsModalComponent, EmailConfirmationModalComponent, EmailConfirmationSuccessModalComponent, FieldErrorsComponent, FieldErrorComponent, TotalPremiumBannerComponent, NavigationBannerComponent, PageNavButtonComponent, LogoutButtonComponent, PaginationComponent, LinkComponent, FollowUpTaskComponent, InnerTextLinkComponent, ToggleSelectComponent, ToggleMultiSelectComponent, TooltipComponent, ConfigurableTooltipComponent, LearnMoreTooltipComponent, StatusButtonComponent, FootnoteComponent, StateSelectorInputComponent, AgencyNameSelectorInputComponent, AgentNoteModalComponent, AgentTaskModalComponent, HtmlConfirmationModalComponent, ShoppingCartCrossSellModalComponent, ShoppingCartCrossSellComponent, SelectDropdownByCharacterDirective, SNPToggleComponent, SNPCategoryToggleComponent, SpinnerComponent, LoaderPlaceholderComponent, NotLicensedPlanListComponent, ScrollableMultiSelectCheckboxComponent, DatePickerInputComponent, DropdownButtonComponent, FormMonthYearDropdownComponent, WarningMessageManyResultsAgentSearchComponent, FormDateComponent, NoticeContainerComponent, NoticeWarnListComponent, NoticeSuccessListComponent, NoticeInfoListComponent, NoticeErrorListComponent, NoticeComponent, UpdateEffectiveDateModalComponent, PlanCoverageProviderInfoModalComponent, AgentCallRecordingShoppingBoxComponent, PlanYearBadgeComponent, ProviderAcceptingNewPatientsComponent, ProviderInlineElementComponent, ProviderPhoneComponent, ModalFooterComponent, ModalHeaderComponent, AgentOfRecordModalComponent, AgentOfRecordModalSearchComponent, AgentOfRecordModalResultsComponent, AgentOfRecordModalSuccessComponent, AuthorizationCodeSignatureModalComponent, AuthorizationCodeSignatureStatementComponent, VoiceSignatureModalComponent, VoiceSignatureStatementComponent, SendRetireFloModalComponent, ValueBasedCareAgreementComponent, AgentRetireFloSignupModalComponent, RetireFloSurveyModalComponent] }); })();

class CollapsibleListAnimationDirective {
    constructor(element) {
        this.element = element;
    }
    // Name should match trigger in animation, this passes in data to the animation and causes it to fire
    // Should fire on any input change
    get collapsibleListTrigger() {
        return { value: this.collapsibleList ? 'show' : 'hide', params: { startHeight: this.element.nativeElement.clientHeight } };
    }
}
CollapsibleListAnimationDirective.ɵfac = function CollapsibleListAnimationDirective_Factory(t) { return new (t || CollapsibleListAnimationDirective)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
CollapsibleListAnimationDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: CollapsibleListAnimationDirective, selectors: [["", "collapsibleList", ""]], hostVars: 1, hostBindings: function CollapsibleListAnimationDirective_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵsyntheticHostProperty("@collapsibleListTrigger", ctx.collapsibleListTrigger);
    } }, inputs: { collapsibleList: "collapsibleList" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CollapsibleListAnimationDirective, [{
        type: Directive,
        args: [{
                selector: '[collapsibleList]'
            }]
    }], function () { return [{ type: i0.ElementRef }]; }, { collapsibleList: [{
            type: Input
        }], collapsibleListTrigger: [{
            type: HostBinding,
            args: ['@collapsibleListTrigger']
        }] }); })();

const _c0$3k = ["accordionDiv"];
const _c1$1L = ["tooltip"];
function AccordionComponent_ng_container_2_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelement(3, "vnext-learn-more-tooltip", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r1.message, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("tooltipLabelText", item_r1.tooltipLabel)("tooltipContent", item_r1.tooltipText)("tooltipPlacement", "bottom")("triggers", "click")("autoClose", "outside")("tooltipCustomClass", "accordion-item-tooltip")("showTooltipCloseButton", true)("isMobile", ctx_r4.isMobile)("underlineTooltipButton", true);
} }
function AccordionComponent_ng_container_2_div_4_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    const index_r2 = ctx_r8.index;
    const item_r1 = ctx_r8.$implicit;
    i0.ɵɵproperty("id", "toggle-sub-question-" + index_r2)("innerHTML", i0.ɵɵpipeBind2(1, 2, item_r1.childItemsLabel, "html"), i0.ɵɵsanitizeHtml);
} }
function AccordionComponent_ng_container_2_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, AccordionComponent_ng_container_2_div_4_div_2_div_1_Template, 2, 5, "div", 10);
    i0.ɵɵelementStart(2, "vnext-toggle-select", 11);
    i0.ɵɵlistener("optionSelected", function AccordionComponent_ng_container_2_div_4_div_2_Template_vnext_toggle_select_optionSelected_2_listener($event) { i0.ɵɵrestoreView(_r11); const item_r1 = i0.ɵɵnextContext(2).$implicit; const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.onClickChild($event, item_r1)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    const item_r1 = ctx_r12.$implicit;
    const index_r2 = ctx_r12.index;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r1.childItemsLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("items", ctx_r5.toggleItems[item_r1.id])("selectedValue", ctx_r5.selectedChild || ctx_r5.defaultToggle)("verticalGrow", item_r1.verticalChildren)("buttonHeight", ctx_r5.buttonHeight)("lightBackground", true)("darkenOnHover", false)("largerText", true)("parentId", ctx_r5.widgetId)("ariaLabelledById", item_r1.childItemsLabel ? "toggle-sub-question-" + index_r2 : "toggle-question-" + index_r2)("toggleControlId", "accordian-toggle")("boldUnselectedItems", false);
} }
function AccordionComponent_ng_container_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AccordionComponent_ng_container_2_div_4_div_1_Template, 4, 10, "div", 5);
    i0.ɵɵtemplate(2, AccordionComponent_ng_container_2_div_4_div_2_Template, 3, 12, "div", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r1.showMessage && item_r1.message);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.toggleItems[item_r1.id] == null ? null : ctx_r3.toggleItems[item_r1.id].length);
} }
const _c2$15 = function (a0, a1, a2) { return { "selected-outer": a0, "Spa_Style_SecondaryButtonSelected Spa_Style_Primary_Link_Color Spa_Style_Bold_Weight Spa_Style_Regular_Font selected-accordion-border": a1, "Spa_Style_SecondaryButton Spa_Style_Regular_Weight": a2 }; };
const _c3$M = function (a0) { return { "Spa_Style_Primary Spa_Style_Regular_Weight Spa_Style_Regular_Font": a0 }; };
const _c4$s = function (a0) { return { color: a0 }; };
function AccordionComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵlistener("click", function AccordionComponent_ng_container_2_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r15); const item_r1 = restoredCtx.$implicit; const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.onClickOuter(item_r1.id)); })("keydown.enter", function AccordionComponent_ng_container_2_Template_div_keydown_enter_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r15); const item_r1 = restoredCtx.$implicit; const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.onClickOuter(item_r1.id)); })("keydown.spacebar", function AccordionComponent_ng_container_2_Template_div_keydown_spacebar_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r15); const item_r1 = restoredCtx.$implicit; const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.onClickOuter(item_r1.id)); })("keydown.space", function AccordionComponent_ng_container_2_Template_div_keydown_space_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r15); const item_r1 = restoredCtx.$implicit; const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.onClickOuter(item_r1.id)); });
    i0.ɵɵelement(2, "span", 3);
    i0.ɵɵpipe(3, "safe");
    i0.ɵɵtemplate(4, AccordionComponent_ng_container_2_div_4_Template, 3, 2, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const index_r2 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(12, _c2$15, ctx_r0.selectedParent === item_r1.id, item_r1.id === ctx_r0.highlightedParent && (item_r1.id !== ctx_r0.selectedParent || !(item_r1.childItems == null ? null : item_r1.childItems.length)), !(item_r1.id === ctx_r0.highlightedParent && (item_r1.id !== ctx_r0.selectedParent || !(item_r1.childItems == null ? null : item_r1.childItems.length)))));
    i0.ɵɵattribute("id", item_r1.id)("aria-checked", item_r1.id === ctx_r0.highlightedParent && (item_r1.id !== ctx_r0.selectedParent || !(item_r1.childItems == null ? null : item_r1.childItems.length)) ? "true" : "false")("aria-describedby", ctx_r0.ariaDescribedById ? ctx_r0.ariaDescribedById : null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", "toggle-question-" + index_r2)("ngClass", i0.ɵɵpureFunction1(16, _c3$M, ctx_r0.isNotHighlightedParent(item_r1)))("ngStyle", i0.ɵɵpureFunction1(18, _c4$s, ctx_r0.isNotHighlightedParent(item_r1) ? ctx_r0.secondaryButtonTextColor : ""))("innerHTML", i0.ɵɵpipeBind2(3, 9, item_r1.title, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.selectedParent === item_r1.id || ctx_r0.alwaysShowChildren);
} }
class AccordionComponent {
    constructor(clearInputService, widgetService) {
        this.clearInputService = clearInputService;
        this.widgetService = widgetService;
        this.items = [];
        this.allowParentValues = false;
        this.alwaysShowChildren = false;
        this.emitParentValueWhenNoChildrenSelected = false;
        this.buttonHeight = '36px';
        this.secondaryButtonTextColor = '#1F1F1F';
        this.toggleItems = {};
        this.valueSelected = new EventEmitter();
    }
    getName() {
        return this.fieldName;
    }
    focus() {
        this.accordionDiv.nativeElement.parentElement.firstElementChild.focus();
    }
    ngOnInit() {
        this.widgetId = this.widgetService.widgetId;
        this.highlightedParent = this.selectedParent;
    }
    ngOnChanges(changes) {
        if (changes.items) {
            const previousItems = changes.items.previousValue;
            const currentItems = changes.items.currentValue;
            if (!_isEqual(previousItems, currentItems)) {
                this.items.forEach(accordionItem => {
                    const children = accordionItem.childItems;
                    if (children) {
                        this.toggleItems[accordionItem.id] = [];
                        children.forEach(childItem => {
                            const toggleItem = this.transformChildItemToToggleItem(childItem);
                            this.toggleItems[accordionItem.id].push(toggleItem);
                            if (childItem.id === this.selectedChild) {
                                this.defaultToggle = toggleItem.value;
                            }
                        });
                    }
                });
            }
        }
        if (!changes.selectedParent?.currentValue) {
            this.highlightedParent = undefined;
        }
    }
    isNotHighlightedParent(item) {
        return item.id !== this.highlightedParent;
    }
    onClickOuter(itemId) {
        this.selectedParent = itemId;
        if (this.allowParentValues) {
            const foundItem = this.items.find(item => item.id === itemId);
            if (!foundItem.childItems || !foundItem.childItems.length || this.emitParentValueWhenNoChildrenSelected) {
                this.highlightedParent = this.selectedParent;
                this.valueSelected.emit({ id: itemId });
                this.selectedChild = null;
            }
        }
        else {
            this.clearInputService.clearInputById(this.widgetId);
        }
    }
    onClickChild({ data, event }, parentItem) {
        event.stopPropagation();
        this.selectedParent = parentItem.id;
        this.highlightedParent = this.selectedParent;
        this.selectedChild = data.value;
        this.valueSelected.emit({ id: this.selectedChild });
    }
    transformChildItemToToggleItem(childItem) {
        return { display: childItem.title, value: childItem.id };
    }
}
AccordionComponent.ɵfac = function AccordionComponent_Factory(t) { return new (t || AccordionComponent)(i0.ɵɵdirectiveInject(i1.InputResetContextService), i0.ɵɵdirectiveInject(WidgetService)); };
AccordionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AccordionComponent, selectors: [["vnext-accordion"]], viewQuery: function AccordionComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3k, 5);
        i0.ɵɵviewQuery(_c1$1L, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.accordionDiv = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltip = _t.first);
    } }, inputs: { items: "items", selectedParent: "selectedParent", selectedChild: "selectedChild", allowParentValues: "allowParentValues", alwaysShowChildren: "alwaysShowChildren", emitParentValueWhenNoChildrenSelected: "emitParentValueWhenNoChildrenSelected", ariaDescribedById: "ariaDescribedById", ariaLabelledById: "ariaLabelledById", fieldName: "fieldName", largerText: "largerText", buttonHeight: "buttonHeight", secondaryButtonTextColor: "secondaryButtonTextColor", isMobile: "isMobile" }, outputs: { valueSelected: "valueSelected" }, features: [i0.ɵɵProvidersFeature([InputResetContextService]), i0.ɵɵNgOnChangesFeature], decls: 3, vars: 2, consts: [["role", "radiogroup", 1, "accordion"], [4, "ngFor", "ngForOf"], ["role", "radio", "tabindex", "0", 1, "outer-accordion-button", 3, "ngClass", "click", "keydown.enter", "keydown.spacebar", "keydown.space"], ["navigationAdapter", "", 3, "id", "ngClass", "ngStyle", "innerHTML"], [4, "ngIf"], ["class", "Spa_Style_Regular_Weight Spa_Style_Smaller_Font d-flex", 4, "ngIf"], ["class", "inner-options", 4, "ngIf"], [1, "Spa_Style_Regular_Weight", "Spa_Style_Smaller_Font", "d-flex"], [3, "tooltipLabelText", "tooltipContent", "tooltipPlacement", "triggers", "autoClose", "tooltipCustomClass", "showTooltipCloseButton", "isMobile", "underlineTooltipButton"], [1, "inner-options"], ["navigationAdapter", "", 3, "id", "innerHTML", 4, "ngIf"], [3, "items", "selectedValue", "verticalGrow", "buttonHeight", "lightBackground", "darkenOnHover", "largerText", "parentId", "ariaLabelledById", "toggleControlId", "boldUnselectedItems", "optionSelected"], ["navigationAdapter", "", 3, "id", "innerHTML"]], template: function AccordionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div")(1, "div", 0);
        i0.ɵɵtemplate(2, AccordionComponent_ng_container_2_Template, 5, 20, "ng-container", 1);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵattribute("aria-labelledby", ctx.ariaLabelledById);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.items);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgStyle, ToggleSelectComponent, LearnMoreTooltipComponent, NavigationAdapterDirective, SafePipe], styles: [".outer-accordion-button[_ngcontent-%COMP%]{padding:6px 10px;border-radius:0;width:100%;height:auto;min-height:36px;font-weight:400;text-align:left;border:1px solid;border-color:var(--static-Spa_Style_Accent1);cursor:pointer}.Spa_Style_SecondaryButtonSelected[_ngcontent-%COMP%]{min-height:36px}.selected-accordion-border[_ngcontent-%COMP%], .selected-accordion-border[_ngcontent-%COMP%]:active, .selected-accordion-border[_ngcontent-%COMP%]:focus{border:1px solid var(--static-Spa_Style_Primary_Link)!important}.selected-outer[_ngcontent-%COMP%]{box-shadow:0 0 5px var(--static-Spa_Style_Black);border-color:var(--static-Spa_Style_Gray4)}.outer-accordion-button[_ngcontent-%COMP%]:first-of-type{border-top-left-radius:5px;border-top-right-radius:5px}.outer-accordion-button[_ngcontent-%COMP%]:last-of-type{border-bottom-left-radius:5px;border-bottom-right-radius:5px}.inner-options[_ngcontent-%COMP%]{margin-top:10px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccordionComponent, [{
        type: Component,
        args: [{ selector: 'vnext-accordion', providers: [InputResetContextService], template: "<div>\r\n  <div class=\"accordion\" role=\"radiogroup\" [attr.aria-labelledby]=\"ariaLabelledById\">\r\n    <ng-container *ngFor=\"let item of items; index as index\">\r\n      <!-- IE does not support nested click events inside buttons, so this has to be a div-->\r\n      <div\r\n        class=\"outer-accordion-button\"\r\n        role=\"radio\"\r\n        [attr.id]=\"item.id\"\r\n        [attr.aria-checked]=\"item.id === highlightedParent && (item.id !== selectedParent || !item.childItems?.length) ? 'true' : 'false'\"\r\n        tabindex=\"0\"\r\n        (click)=\"onClickOuter(item.id)\"\r\n        (keydown.enter)=\"onClickOuter(item.id)\"\r\n        (keydown.spacebar)=\"onClickOuter(item.id)\"\r\n        (keydown.space)=\"onClickOuter(item.id)\"\r\n        [ngClass]=\"{\r\n          'selected-outer': selectedParent === item.id,\r\n          'Spa_Style_SecondaryButtonSelected Spa_Style_Primary_Link_Color Spa_Style_Bold_Weight Spa_Style_Regular_Font selected-accordion-border':\r\n            item.id === highlightedParent && (item.id !== selectedParent || !item.childItems?.length),\r\n          'Spa_Style_SecondaryButton Spa_Style_Regular_Weight': !(\r\n            item.id === highlightedParent &&\r\n            (item.id !== selectedParent || !item.childItems?.length)\r\n          )\r\n        }\"\r\n        [attr.aria-describedby]=\"ariaDescribedById ? ariaDescribedById : null\"\r\n      >\r\n        <span\r\n          [id]=\"'toggle-question-' + index\"\r\n          [ngClass]=\"{ 'Spa_Style_Primary Spa_Style_Regular_Weight Spa_Style_Regular_Font': isNotHighlightedParent(item) }\"\r\n          [ngStyle]=\"{ color: isNotHighlightedParent(item) ? secondaryButtonTextColor : '' }\"\r\n          [innerHTML]=\"item.title | safe : 'html'\"\r\n          navigationAdapter\r\n        ></span>\r\n        <div *ngIf=\"selectedParent === item.id || alwaysShowChildren\">\r\n          <div *ngIf=\"item.showMessage && item.message\" class=\"Spa_Style_Regular_Weight Spa_Style_Smaller_Font d-flex\">\r\n            <span>\r\n              {{ item.message }}\r\n              <vnext-learn-more-tooltip\r\n                [tooltipLabelText]=\"item.tooltipLabel\"\r\n                [tooltipContent]=\"item.tooltipText\"\r\n                [tooltipPlacement]=\"'bottom'\"\r\n                [triggers]=\"'click'\"\r\n                [autoClose]=\"'outside'\"\r\n                [tooltipCustomClass]=\"'accordion-item-tooltip'\"\r\n                [showTooltipCloseButton]=\"true\"\r\n                [isMobile]=\"isMobile\"\r\n                [underlineTooltipButton]=\"true\"\r\n              ></vnext-learn-more-tooltip\r\n            ></span>\r\n          </div>\r\n          <div class=\"inner-options\" *ngIf=\"toggleItems[item.id]?.length\">\r\n            <div\r\n              [id]=\"'toggle-sub-question-' + index\"\r\n              *ngIf=\"item.childItemsLabel\"\r\n              [innerHTML]=\"item.childItemsLabel | safe : 'html'\"\r\n              navigationAdapter\r\n            ></div>\r\n            <vnext-toggle-select\r\n              [items]=\"toggleItems[item.id]\"\r\n              [selectedValue]=\"selectedChild || defaultToggle\"\r\n              [verticalGrow]=\"item.verticalChildren\"\r\n              [buttonHeight]=\"buttonHeight\"\r\n              [lightBackground]=\"true\"\r\n              [darkenOnHover]=\"false\"\r\n              [largerText]=\"true\"\r\n              [parentId]=\"widgetId\"\r\n              (optionSelected)=\"onClickChild($event, item)\"\r\n              [ariaLabelledById]=\"item.childItemsLabel ? 'toggle-sub-question-' + index : 'toggle-question-' + index\"\r\n              [toggleControlId]=\"'accordian-toggle'\"\r\n              [boldUnselectedItems]=\"false\"\r\n            ></vnext-toggle-select>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n", styles: [".outer-accordion-button{padding:6px 10px;border-radius:0;width:100%;height:auto;min-height:36px;font-weight:400;text-align:left;border:1px solid;border-color:var(--static-Spa_Style_Accent1);cursor:pointer}.Spa_Style_SecondaryButtonSelected{min-height:36px}.selected-accordion-border,.selected-accordion-border:active,.selected-accordion-border:focus{border:1px solid var(--static-Spa_Style_Primary_Link)!important}.selected-outer{box-shadow:0 0 5px var(--static-Spa_Style_Black);border-color:var(--static-Spa_Style_Gray4)}.outer-accordion-button:first-of-type{border-top-left-radius:5px;border-top-right-radius:5px}.outer-accordion-button:last-of-type{border-bottom-left-radius:5px;border-bottom-right-radius:5px}.inner-options{margin-top:10px}\n"] }]
    }], function () { return [{ type: i1.InputResetContextService }, { type: WidgetService }]; }, { accordionDiv: [{
            type: ViewChild,
            args: ['accordionDiv']
        }], tooltip: [{
            type: ViewChild,
            args: ['tooltip']
        }], items: [{
            type: Input
        }], selectedParent: [{
            type: Input
        }], selectedChild: [{
            type: Input
        }], allowParentValues: [{
            type: Input
        }], alwaysShowChildren: [{
            type: Input
        }], emitParentValueWhenNoChildrenSelected: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], fieldName: [{
            type: Input
        }], largerText: [{
            type: Input
        }], buttonHeight: [{
            type: Input
        }], secondaryButtonTextColor: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], valueSelected: [{
            type: Output
        }] }); })();

function BenefitsDisplayComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "a", 4);
    i0.ɵɵlistener("click", function BenefitsDisplayComponent_div_0_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.closeButtonClicked()); })("keyup.enter", function BenefitsDisplayComponent_div_0_Template_a_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.closeButtonClicked()); });
    i0.ɵɵelementStart(2, "span", 5);
    i0.ɵɵtext(3, "Close");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "i", 6);
    i0.ɵɵelementEnd()();
} }
function BenefitsDisplayComponent_ng_container_2_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const detail_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(+", i0.ɵɵpipeBind4(2, 1, detail_r5.cost, "USD", "symbol", "1.2-2"), ")");
} }
function BenefitsDisplayComponent_ng_container_2_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵelement(1, "hr");
    i0.ɵɵelementEnd();
} }
function BenefitsDisplayComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 8);
    i0.ɵɵtext(4);
    i0.ɵɵtemplate(5, BenefitsDisplayComponent_ng_container_2_ng_container_5_Template, 3, 6, "ng-container", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, BenefitsDisplayComponent_ng_container_2_span_6_Template, 2, 0, "span", 10);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const detail_r5 = ctx.$implicit;
    const last_r6 = ctx.last;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(detail_r5.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", detail_r5.details, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", detail_r5.cost);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !last_r6);
} }
class BenefitsDisplayComponent {
    constructor() {
        this.displayCloseButton = true;
        this.closeButtonAction = new EventEmitter();
    }
    closeButtonClicked() {
        this.closeButtonAction.emit();
    }
}
BenefitsDisplayComponent.ɵfac = function BenefitsDisplayComponent_Factory(t) { return new (t || BenefitsDisplayComponent)(); };
BenefitsDisplayComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BenefitsDisplayComponent, selectors: [["vnext-benefits-display"]], inputs: { benefitsData: "benefitsData", displayCloseButton: "displayCloseButton" }, outputs: { closeButtonAction: "closeButtonAction" }, decls: 3, vars: 2, consts: [["class", "pb-1 d-flex justify-content-end", 4, "ngIf"], [1, "row", "no-gutters"], [4, "ngFor", "ngForOf"], [1, "pb-1", "d-flex", "justify-content-end"], ["role", "button", "tabindex", "0", 1, "can-click", "Spa_Style_Primary_Color", "close-popover", 3, "click", "keyup.enter"], [1, "sr-only"], [1, "fas", "fa-times"], [1, "Spa_Style_Primary_Color", "col-12", "col-md-6", "hip-popover-benefit-name"], [1, "Spa_Style_Primary_Color", "col-12", "col-md-6"], [4, "ngIf"], ["class", "col-12", 4, "ngIf"], [1, "col-12"]], template: function BenefitsDisplayComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, BenefitsDisplayComponent_div_0_Template, 5, 0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, BenefitsDisplayComponent_ng_container_2_Template, 7, 4, "ng-container", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.displayCloseButton);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.benefitsData);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, IconAriaAttributesDirective, i1$2.CurrencyPipe], styles: [".close-popover[_ngcontent-%COMP%]{cursor:pointer;width:20px;text-align:center;height:20px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BenefitsDisplayComponent, [{
        type: Component,
        args: [{ selector: 'vnext-benefits-display', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"displayCloseButton\" class=\"pb-1 d-flex justify-content-end\">\r\n  <a\r\n    role=\"button\"\r\n    (click)=\"closeButtonClicked()\"\r\n    tabindex=\"0\"\r\n    (keyup.enter)=\"closeButtonClicked()\"\r\n    class=\"can-click Spa_Style_Primary_Color close-popover\"\r\n  >\r\n    <span class=\"sr-only\">Close</span>\r\n    <i class=\"fas fa-times\"></i>\r\n  </a>\r\n</div>\r\n<div class=\"row no-gutters\">\r\n  <ng-container *ngFor=\"let detail of benefitsData; let last = last\">\r\n    <span class=\"Spa_Style_Primary_Color col-12 col-md-6 hip-popover-benefit-name\">{{ detail.name }}</span>\r\n    <span class=\"Spa_Style_Primary_Color col-12 col-md-6\"\r\n      >{{ detail.details }} <ng-container *ngIf=\"detail.cost\">(+{{ detail.cost | currency: 'USD':'symbol':'1.2-2' }})</ng-container></span\r\n    >\r\n    <span *ngIf=\"!last\" class=\"col-12\"><hr /></span>\r\n  </ng-container>\r\n</div>\r\n", styles: [".close-popover{cursor:pointer;width:20px;text-align:center;height:20px}\n"] }]
    }], null, { benefitsData: [{
            type: Input
        }], displayCloseButton: [{
            type: Input
        }], closeButtonAction: [{
            type: Output
        }] }); })();

function PageSpinnerComponent_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.loaderText, " ");
} }
class PageSpinnerComponent {
}
PageSpinnerComponent.ɵfac = function PageSpinnerComponent_Factory(t) { return new (t || PageSpinnerComponent)(); };
PageSpinnerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PageSpinnerComponent, selectors: [["vnext-page-spinner"]], inputs: { loaderIcon: "loaderIcon", showLoaderMessage: "showLoaderMessage", loaderText: "loaderText" }, decls: 2, vars: 3, consts: [["aria-live", "polite", "aria-relevant", "text", "aria-atomic", "true", "size", "medium", "id", "page-loader", 3, "type", "fullScreen"], ["class", "spinner-page-load-text", 4, "ngIf"], [1, "spinner-page-load-text"]], template: function PageSpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ngx-spinner", 0);
        i0.ɵɵtemplate(1, PageSpinnerComponent_p_1_Template, 2, 1, "p", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("type", ctx.loaderIcon)("fullScreen", true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.loaderText && ctx.showLoaderMessage);
    } }, dependencies: [i1$2.NgIf, i3$1.NgxSpinnerComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageSpinnerComponent, [{
        type: Component,
        args: [{ selector: 'vnext-page-spinner', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ngx-spinner aria-live=\"polite\" aria-relevant=\"text\" aria-atomic=\"true\" size=\"medium\" [type]=\"loaderIcon\" [fullScreen]=\"true\" id=\"page-loader\">\r\n  <p *ngIf=\"loaderText && showLoaderMessage\" class=\"spinner-page-load-text\">\r\n    {{ loaderText }}\r\n  </p>\r\n</ngx-spinner>\r\n" }]
    }], null, { loaderIcon: [{
            type: Input
        }], showLoaderMessage: [{
            type: Input
        }], loaderText: [{
            type: Input
        }] }); })();

/**
 * Applies styling for DOM events that cannot be covered by ngStyle.
 * Set EventStyle.styles.key to CSS attribute (e.g. color, backgroundColor) and value to CSS value.
 *
 * Example input:
 * [{ event: DOMEvent.MOUSE_ENTER, styles: {color: 'red', backgroundColor: 'yellow'} }]
 */
class EventStylingDirective {
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.unlistens = [];
    }
    ngOnInit() {
        this.element = this.elementRef.nativeElement;
        if (this.eventStyles) {
            this.eventStyles.forEach(eventStyle => {
                if (eventStyle.event && eventStyle.styles) {
                    const unlisten = this.renderer.listen(this.element, eventStyle.event, () => {
                        for (const key in eventStyle.styles) {
                            if (eventStyle.styles.hasOwnProperty(key)) {
                                this.element.style[key] = eventStyle.styles[key];
                            }
                        }
                    });
                    this.unlistens.push(unlisten);
                }
            });
        }
    }
    ngOnDestroy() {
        this.unlistens.forEach(unlisten => unlisten());
        this.renderer.destroy();
    }
}
EventStylingDirective.ɵfac = function EventStylingDirective_Factory(t) { return new (t || EventStylingDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2)); };
EventStylingDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: EventStylingDirective, selectors: [["", "vnextEventStyling", ""]], inputs: { eventStyles: ["vnextEventStyling", "eventStyles"] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EventStylingDirective, [{
        type: Directive,
        args: [{
                selector: '[vnextEventStyling]'
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, { eventStyles: [{
            type: Input,
            args: ['vnextEventStyling']
        }] }); })();

// this data table sample is taken from the follwoing link
// https://ng-bootstrap.github.io/#/components/table/examples
const rotate = { 'asc': 'desc', 'desc': '', '': 'asc' };
const compare = (v1, v2) => (v1 < v2 ? -1 : v1 > v2 ? 1 : 0);
class NgbdSortableHeaderDirective {
    constructor() {
        this.direction = '';
        this.sort = new EventEmitter();
    }
    rotate() {
        this.direction = rotate[this.direction];
        this.sort.emit({ column: this.sortable, direction: this.direction });
    }
}
NgbdSortableHeaderDirective.ɵfac = function NgbdSortableHeaderDirective_Factory(t) { return new (t || NgbdSortableHeaderDirective)(); };
NgbdSortableHeaderDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: NgbdSortableHeaderDirective, selectors: [["th", "sortable", ""]], hostVars: 4, hostBindings: function NgbdSortableHeaderDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function NgbdSortableHeaderDirective_click_HostBindingHandler() { return ctx.rotate(); });
    } if (rf & 2) {
        i0.ɵɵclassProp("asc", ctx.direction === "asc")("desc", ctx.direction === "desc");
    } }, inputs: { sortable: "sortable", direction: "direction" }, outputs: { sort: "sort" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgbdSortableHeaderDirective, [{
        type: Directive,
        args: [{
                selector: 'th[sortable]',
                host: { '[class.asc]': 'direction === "asc"', '[class.desc]': 'direction === "desc"', '(click)': 'rotate()' }
            }]
    }], null, { sortable: [{
            type: Input
        }], direction: [{
            type: Input
        }], sort: [{
            type: Output
        }] }); })();

const PREPROCESS_PROPERTIES_METHOD = 'preProcessProperties';
function shouldPreProcess(component) {
    return component[PREPROCESS_PROPERTIES_METHOD] !== undefined;
}

const WIDGET_SUBSCRIBERS_KEY = '_widgetSubscribers';
class ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService) {
        this.cdr = cdr;
        this.widgetValidationService = widgetValidationService;
        this.configurableWidgetService = configurableWidgetService;
        this.zoneService = zoneService;
        this.widgetService = widgetService;
        // the list of registered overrides
        // Property.prop must exist in platform overrides to be registered here
        this.overrides = [];
        // properties annotated with @GlobalResource will be injected into here and resolved
        // globalResources;
        this.subscribers = { [WIDGET_SUBSCRIBERS_KEY]: [] };
        this.preProcess = () => { };
        this.liveedit = EnvironmentService.getEnvironment().liveedit;
        this.widgetId = uuid();
        // this is optional as not every component needs to pass down
        // widget information to sub components
        if (this.widgetService) {
            this.widgetService.widgetId = this.widgetId;
        }
        if (shouldPreProcess(this)) {
            this.preProcess = () => {
                this[PREPROCESS_PROPERTIES_METHOD]();
                this.cdr.markForCheck();
            };
        }
    }
    set widgetName(key) {
        if (this.widgetService) {
            this.widgetService.widgetName = key;
        }
    }
    get widgetName() {
        return this.widgetService ? this.widgetService.widgetName : null;
    }
    /**
     * [PLATFORM_OVERRIDES_KEY] is the list of valid override props
     * and is set by @PlatformProp annotation
     */
    // these are the overrides from the config json
    setOverrides(overrides) {
        const validOverrides = [];
        if (this[PLATFORM_OVERRIDES_KEY]) {
            for (let i = 0, n = this[PLATFORM_OVERRIDES_KEY].length; i < n; ++i) {
                const platformProp = this[PLATFORM_OVERRIDES_KEY][i];
                if (overrides) {
                    const overrideMatch = overrides.find(override => override.prop === platformProp);
                    if (overrideMatch) {
                        // if there is an override in the config json use that
                        validOverrides.push(overrideMatch);
                    }
                    else {
                        // if not and there is a resource of the same name lets create an override to look up the platform prop as a resource
                        if (this.configurableWidgetService.configResourceService.lookupResource(platformProp, this.widgetName)) {
                            validOverrides.push({ prop: platformProp, value: platformProp, type: PropertyType.RESOURCE });
                        }
                    }
                }
                else {
                    // if there are no overrides in the config json for this widget and there is a resource of
                    // the same name then look up the platform prop as a resource
                    if (this.configurableWidgetService.configResourceService.lookupResource(platformProp, this.widgetName)) {
                        validOverrides.push({ prop: platformProp, value: platformProp, type: PropertyType.RESOURCE });
                    }
                }
            }
        }
        this.overrides = validOverrides;
    }
    ngOnInit() {
        // check if we used the @GlobalResource to register any global resources we need to track
        if (this[GLOBAL_RESOURCES_KEY]) {
            this.overrides = this[GLOBAL_RESOURCES_KEY].reduce((mergedOverrides, resource) => {
                if (mergedOverrides.find(override => override.prop === resource)) {
                    // TODO: add class name
                    console.log(`Global resource ${resource} is already being set by config overrides.`);
                }
                else {
                    // Note: That if there is not an entry in the locale that is active on page load or
                    // an entry in the universal bundle then the resource will not be added to the merged
                    // overrides and thus will not be responsive on locale change.
                    if (this.configurableWidgetService.configResourceService.lookupResource(resource, this.widgetName)) {
                        mergedOverrides.push({ prop: resource, value: resource, type: PropertyType.RESOURCE });
                    }
                }
                return mergedOverrides;
            }, [...this.overrides]);
        }
        // subscribe to locale and change all props if locale changes
        if (this.overrides.length) {
            // set up value provider observers for resource and value overrides
            for (let i = 0, n = this.overrides.length; i < n; ++i) {
                const override = this.overrides[i];
                // initialize our subscriber map
                this.subscribers[override.prop] = [];
                // we need to get the updated values and let the change detector know
                // that it needs to re-render
                if (this.liveedit ||
                    this.configurableWidgetService.configResourceService.isDynamicResourceAllowed(override.prop) ||
                    this.configurableWidgetService.configResourceService.retrieveValueProviders(override, this.widgetName)?.length) {
                    const resourceSubscriber = this.configurableWidgetService.configResourceService.getResourceObserver(override.value, this.widgetName);
                    // This is the top level resource... not sure this will change... perhaps with live edit sourcing from
                    // an external source? test that out as we may not need a subscriber here
                    this.subscribers[override.prop].push({
                        valueProvider: null,
                        subscriber: resourceSubscriber.subscribe({
                            next: () => {
                                this.setResourceOverride(override);
                            }
                        })
                    });
                    // set up our resource and store observers so the widget values will change
                    //  when resource and store values are updated
                    this.processValueProviders(override);
                }
                else {
                    this[override.prop] = this.configurableWidgetService.configResourceService.lookupPropertyValue(override, this.widgetName);
                }
            }
        }
        const urlSubscriber = this.configurableWidgetService.navigationContext.getUrl$().subscribe(url => {
            this.refreshResourceOverrides();
        });
        this.currentLocale$.subscribe({
            next: () => {
                this.refreshResourceOverrides();
            }
        });
        this.subscribers[WIDGET_SUBSCRIBERS_KEY].push({ valueProvider: null, subscriber: urlSubscriber });
        // if this widget can validate register a validator with the widgetValidationService which is provided at the page level
        if (widgetCanValidate(this)) {
            this.widgetValidationService.addWidgetValidator({ widgetId: this.widgetId, validator: this[WIDGET_VALIDATE_METHOD] });
        }
        // observing for store errors relative to this widget
        // TODO: process errors for value providers or no? we have a mechanism to pass in error info already so this seems unnecessary
        this.errors$ = this.widgetValidationService.getWidgetErrors$(this.widgetId);
        // TODO: https://angular.io/api/core/Renderer2 an option to calculate derived values?
        this.preProcess();
    }
    processValueProviders(override) {
        const valueProviders = this.configurableWidgetService.configResourceService.retrieveValueProviders(override, this.widgetName);
        const environment = EnvironmentService.getEnvironment();
        for (let i = 0, n = valueProviders.length; i < n; ++i) {
            const valueProvider = valueProviders[i];
            if (environment.liveedit && valueProvider.type === ValueProviderType.NESTED) {
                const resourceSubscriber = this.configurableWidgetService.configResourceService.getResourceObserver(valueProvider.resourceKey, this.widgetName);
                this.subscribers[override.prop].push({
                    valueProvider,
                    subscriber: resourceSubscriber.subscribe({
                        next: () => {
                            this.setResourceOverride(override);
                        }
                    })
                });
            }
            else if (valueProvider.type === ValueProviderType.SESSION) {
                const storeSubscriber = this.configurableWidgetService.storeResourceService.getResourceObserver(valueProvider.resourceKey);
                this.subscribers[override.prop].push({
                    valueProvider,
                    subscriber: storeSubscriber.subscribe({
                        next: () => {
                            this.setResourceOverride(override);
                        }
                    })
                });
            }
        }
    }
    // setting our resource override value if it has changed
    setResourceOverride(override) {
        const propValue = this[override.prop];
        const newValue = this.getNewPropValue(override);
        // need to make sure we are getting a new value before updating the prop
        if (propValue === undefined || propValue !== newValue) {
            this[override.prop] = newValue;
            if (this.isPreProcessedProperty(override.prop)) {
                this.preProcess();
            }
            this.cdr.markForCheck();
        }
    }
    ngOnDestroy() {
        Object.keys(this.subscribers).forEach(key => {
            this.subscribers[key].forEach(subscriberData => {
                subscriberData.subscriber.unsubscribe();
            });
        });
    }
    getNewPropValue(override) {
        if (override.type === PropertyType.RESOURCE) {
            // need to track the exact resources used to construct this widget so we can
            // look the backing resource up at a later time
            this.widgetService.resourceMap[override.prop] = override.value;
        }
        return this.configurableWidgetService.configResourceService.lookupPropertyValue(override, this.widgetName);
    }
    batchUpdateResourceOverrides(overrides) {
        let shouldPreProcessProperties = false;
        let hasUpdates = false;
        for (let i = 0, n = overrides.length; i < n; ++i) {
            const override = overrides[i];
            const propValue = this[override.prop];
            const newValue = this.getNewPropValue(override);
            if (propValue === undefined || propValue !== newValue) {
                this[override.prop] = newValue;
                if (!hasUpdates) {
                    hasUpdates = true;
                }
                if (!shouldPreProcessProperties && this.isPreProcessedProperty(override.prop)) {
                    shouldPreProcessProperties = true;
                }
            }
        }
        if (shouldPreProcessProperties) {
            this.preProcess();
        }
        if (hasUpdates) {
            this.cdr.markForCheck();
        }
    }
    refreshResourceOverrides() {
        if (this.overrides) {
            this.batchUpdateResourceOverrides(this.overrides);
        }
    }
    isPreProcessedProperty(prop) {
        return !!this[PRE_PROCESS_PROP_KEY]?.includes(prop);
    }
}
ConfigurableWidget.ɵfac = function ConfigurableWidget_Factory(t) { return new (t || ConfigurableWidget)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService, 8)); };
ConfigurableWidget.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ConfigurableWidget });
ConfigurableWidget.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ConfigurableWidget, factory: ConfigurableWidget.ɵfac });
__decorate([
    Select(AppConfigState.currentLocale)
], ConfigurableWidget.prototype, "currentLocale$", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfigurableWidget, [{
        type: Directive
    }, {
        type: Injectable
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService, decorators: [{
                type: Optional
            }] }]; }, { currentLocale$: [] }); })();

/**
 * Marks a class as a platform widget.
 * Type information about widgets with this decorator will be exported to platform
 * so we know which widgets are configurable.
 * @param constructor
 */
function PlatformWidget(constructor) {
    return class extends constructor {
    };
}

function GlobalResource(preProcess) {
    return (target, key) => {
        if (!target[GLOBAL_RESOURCES_KEY]) {
            target[GLOBAL_RESOURCES_KEY] = [];
        }
        // if we are manually setting the config property use that
        // otherwise the property name is expected in the config json
        target[GLOBAL_RESOURCES_KEY].push(key);
        if (preProcess) {
            if (!target[PRE_PROCESS_PROP_KEY]) {
                target[PRE_PROCESS_PROP_KEY] = [];
            }
            target[PRE_PROCESS_PROP_KEY].push(key);
        }
    };
}

class AgentDashboardTaskListContextService {
    constructor() {
        this.selectedValues = [];
    }
    onTaskSelection(selectedTask) {
        const indexOfValue = this.selectedValues.findIndex(x => x.memberAgentNoteID === selectedTask.memberAgentNoteID);
        if (selectedTask.selected) {
            indexOfValue === -1 && this.selectedValues.push(selectedTask);
        }
        else {
            indexOfValue > -1 && this.selectedValues.splice(indexOfValue, 1);
        }
        return this.selectedValues;
    }
}
AgentDashboardTaskListContextService.ɵfac = function AgentDashboardTaskListContextService_Factory(t) { return new (t || AgentDashboardTaskListContextService)(); };
AgentDashboardTaskListContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentDashboardTaskListContextService, factory: AgentDashboardTaskListContextService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentDashboardTaskListContextService, [{
        type: Injectable
    }], null, null); })();

function AgentDashboardTaskDetailComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r0.dueLabel, " ", ctx_r0.scheduledDate, "");
} }
function AgentDashboardTaskDetailComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", ctx_r1.completedLabel, " ", ctx_r1.completedWhen, "");
} }
const _c0$3j = function (a0) { return { "line-through": a0 }; };
class AgentDashboardTaskDetailComponent {
    constructor() {
        this.taskStatusChanged = new EventEmitter();
        this.linkClick = new EventEmitter();
        this.onSelection = new EventEmitter();
    }
    ngOnInit() {
        const selectedTask = this.selectedValues.find(x => x.memberAgentNoteID === this.memberAgentNoteID);
        this.completedWhen = selectedTask?.completedWhen;
    }
    changeTaskStatus() {
        if (this.completedWhen) {
            this.completedWhen = null;
            this.taskStatusChanged.emit({
                memberId: this.memberId,
                userAgentGUID: this.userAgentGUID,
                memberAgentNoteID: this.memberAgentNoteID,
                status: MemberAgentTaskStatus.COMPLETE
            });
        }
        else {
            this.completedWhen = DateUtilities.getFormattedDateTime(new Date(), DateUtilities.defaultFormat);
            this.taskStatusChanged.emit({
                memberId: this.memberId,
                userAgentGUID: this.userAgentGUID,
                memberAgentNoteID: this.memberAgentNoteID,
                status: MemberAgentTaskStatus.OPEN
            });
        }
    }
    toggleTaskSelection() {
        const emitData = {
            memberAgentNoteID: this.memberAgentNoteID,
            selected: false,
            completedWhen: this.completedWhen
        };
        if (this.completedWhen) {
            emitData.selected = true;
        }
        this.onSelection.emit(emitData);
    }
    toggleTaskStatus() {
        this.changeTaskStatus();
        this.toggleTaskSelection();
    }
}
AgentDashboardTaskDetailComponent.ɵfac = function AgentDashboardTaskDetailComponent_Factory(t) { return new (t || AgentDashboardTaskDetailComponent)(); };
AgentDashboardTaskDetailComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentDashboardTaskDetailComponent, selectors: [["vnext-agent-dashboard-task-detail"]], inputs: { namePrefix: "namePrefix", memberName: "memberName", description: "description", memberAgentNoteID: "memberAgentNoteID", userAgentGUID: "userAgentGUID", memberId: "memberId", scheduledDate: "scheduledDate", dueLabel: "dueLabel", completedLabel: "completedLabel", selectedValues: "selectedValues" }, outputs: { taskStatusChanged: "taskStatusChanged", linkClick: "linkClick", onSelection: "onSelection" }, decls: 11, vars: 9, consts: [[1, "Spa_Style_Paragraph", "task-item", "container"], [1, "row"], [1, "Spa_Style_Primary", "col-sm-12", "col-md-12", "col-lg-7", "d-flex", "align-items-baseline"], ["id", "chkCompleted", "type", "checkbox", "aria-labelledby", "descriptionId", 3, "checked", "change"], ["id", "descriptionId", 1, "no-translate-block", 3, "ngClass"], [1, "col-6", "col-md-6", "col-lg-3"], ["class", "error-color", 4, "ngIf"], ["class", "Spa_Style_Gray4_Color completed-task", 4, "ngIf"], [1, "Spa_Style_Link", "can-click", "col-6", "col-md-6", "col-lg-2", "no-translate-block", 3, "click"], [1, "error-color"], [1, "Spa_Style_Gray4_Color", "completed-task"]], template: function AgentDashboardTaskDetailComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "input", 3);
        i0.ɵɵlistener("change", function AgentDashboardTaskDetailComponent_Template_input_change_3_listener() { return ctx.toggleTaskStatus(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵtemplate(7, AgentDashboardTaskDetailComponent_div_7_Template, 3, 2, "div", 6);
        i0.ɵɵtemplate(8, AgentDashboardTaskDetailComponent_div_8_Template, 2, 2, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵlistener("click", function AgentDashboardTaskDetailComponent_Template_div_click_9_listener() { return ctx.linkClick.emit(); });
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("checked", ctx.completedWhen);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0$3j, ctx.completedWhen));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.description);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.completedWhen);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.completedWhen);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate2("", ctx.namePrefix, " ", ctx.memberName, "");
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf], styles: [".container.task-item[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{overflow-wrap:anywhere;margin-block-end:1em;padding:0}.task-item.container[_ngcontent-%COMP%]{margin-bottom:-30px}.task-item[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(1)   input[_ngcontent-%COMP%]{margin-top:3px}.task-item[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(1) div{margin-left:5px}.task-item[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:nth-child(3){text-align:right;text-decoration:underline}.line-through[_ngcontent-%COMP%]{text-decoration:line-through}.completed-task[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentDashboardTaskDetailComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-dashboard-task-detail', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"Spa_Style_Paragraph task-item container\">\r\n  <div class=\"row\">\r\n    <div class=\"Spa_Style_Primary col-sm-12 col-md-12 col-lg-7 d-flex align-items-baseline\">\r\n      <input id=\"chkCompleted\" [checked]=\"completedWhen\" type=\"checkbox\" aria-labelledby=\"descriptionId\" (change)=\"toggleTaskStatus()\" />\r\n      <div id=\"descriptionId\" class=\"no-translate-block\" [ngClass]=\"{ 'line-through': completedWhen }\">{{ description }}</div>\r\n    </div>\r\n    <div class=\"col-6 col-md-6 col-lg-3\">\r\n      <div class=\"error-color\" *ngIf=\"!completedWhen\">\r\n        <span>{{ dueLabel }} {{ scheduledDate }}</span>\r\n      </div>\r\n      <div class=\"Spa_Style_Gray4_Color completed-task\" *ngIf=\"completedWhen\">{{ completedLabel }} {{ completedWhen }}</div>\r\n    </div>\r\n    <div class=\"Spa_Style_Link can-click col-6 col-md-6 col-lg-2 no-translate-block\" (click)=\"linkClick.emit()\">{{ namePrefix }} {{ memberName }}</div>\r\n  </div>\r\n</div>\r\n", styles: [".container.task-item div{overflow-wrap:anywhere;margin-block-end:1em;padding:0}.task-item.container{margin-bottom:-30px}.task-item .row div:nth-child(1) input{margin-top:3px}.task-item .row div:nth-child(1) div{margin-left:5px}.task-item .row div:nth-child(3){text-align:right;text-decoration:underline}.line-through{text-decoration:line-through}.completed-task{color:var(--static-Spa_Style_Cost_Text)}\n"] }]
    }], null, { namePrefix: [{
            type: Input
        }], memberName: [{
            type: Input
        }], description: [{
            type: Input
        }], memberAgentNoteID: [{
            type: Input
        }], userAgentGUID: [{
            type: Input
        }], memberId: [{
            type: Input
        }], scheduledDate: [{
            type: Input
        }], dueLabel: [{
            type: Input
        }], completedLabel: [{
            type: Input
        }], selectedValues: [{
            type: Input
        }], taskStatusChanged: [{
            type: Output
        }], linkClick: [{
            type: Output
        }], onSelection: [{
            type: Output
        }] }); })();

function AgentDashboardTaskListComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.header, " ");
} }
function AgentDashboardTaskListComponent_div_7_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-agent-dashboard-task-detail", 13);
    i0.ɵɵlistener("taskStatusChanged", function AgentDashboardTaskListComponent_div_7_div_1_div_2_Template_vnext_agent_dashboard_task_detail_taskStatusChanged_1_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r9.changeTaskStatus($event)); })("linkClick", function AgentDashboardTaskListComponent_div_7_div_1_div_2_Template_vnext_agent_dashboard_task_detail_linkClick_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r10); const note_r7 = restoredCtx.$implicit; const ctx_r11 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r11.viewMember(note_r7)); })("onSelection", function AgentDashboardTaskListComponent_div_7_div_1_div_2_Template_vnext_agent_dashboard_task_detail_onSelection_1_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r12 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r12.onSelection($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const note_r7 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("namePrefix", note_r7.namePrefix)("memberName", note_r7.memberName)("dueLabel", ctx_r5.dueLabel)("completedLabel", ctx_r5.completedLabel)("description", note_r7.description)("memberAgentNoteID", note_r7.memberAgentNoteID)("memberId", note_r7.memberId)("userAgentGUID", note_r7.userAgentGUID)("scheduledDate", ctx_r5.formatDate(note_r7.scheduledDate))("selectedValues", ctx_r5.selectedValues);
} }
function AgentDashboardTaskListComponent_div_7_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "vnext-pagination", 15);
    i0.ɵɵlistener("updatePagination", function AgentDashboardTaskListComponent_div_7_div_1_div_4_Template_vnext_pagination_updatePagination_1_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r13.updateAgentDetails($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pagination", ctx_r6.memberNotesHistory)("defaultStartItem", ctx_r6.defaultStartItem)("itemsPerPage", ctx_r6.itemsPerPage)("paginationText", ctx_r6.paginationText);
} }
const _c0$3i = function (a0) { return { borderLeftColor: a0 }; };
function AgentDashboardTaskListComponent_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 10);
    i0.ɵɵtemplate(2, AgentDashboardTaskListComponent_div_7_div_1_div_2_Template, 2, 10, "div", 11);
    i0.ɵɵpipe(3, "slice");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, AgentDashboardTaskListComponent_div_7_div_1_div_4_Template, 2, 4, "div", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(7, _c0$3i, ctx_r4.leftBorderColor));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(3, 3, ctx_r4.memberNotesHistory, ctx_r4.pageStartIndex(), ctx_r4.pageEndIndex()));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r4.memberNotesHistory == null ? null : ctx_r4.memberNotesHistory.length) > ctx_r4.itemsPerPage);
} }
function AgentDashboardTaskListComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AgentDashboardTaskListComponent_div_7_div_1_Template, 5, 9, "div", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.isExpanded);
} }
function AgentDashboardTaskListComponent_ng_template_8_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r15.emptyListLabel, " ");
} }
function AgentDashboardTaskListComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, AgentDashboardTaskListComponent_ng_template_8_p_1_Template, 2, 1, "p", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Dashboard_Empty_Task_List");
} }
class AgentDashboardTaskListComponent {
    constructor(agentSearchFacade, agentDashboardTaskListContextService, profileFacade, analyticsService, agentTaskFacade) {
        this.agentSearchFacade = agentSearchFacade;
        this.agentDashboardTaskListContextService = agentDashboardTaskListContextService;
        this.profileFacade = profileFacade;
        this.analyticsService = analyticsService;
        this.agentTaskFacade = agentTaskFacade;
        this.taskStatusChanged = new EventEmitter();
        this.itemsPerPage = 5;
        this.isExpanded = true;
        this.defaultStartItem = 1;
        this.pageIndex = 1;
        this.selectedValues = [];
        this.subscriptions = new Subscription();
        this.viewMemberSubject$ = new Subject();
    }
    ngOnInit() {
        this.subscriptions.add(this.onViewMember$().subscribe(() => {
            this.handleOnViewMember();
        }));
    }
    formatDate(date) {
        // API data in Pacific Time (PT). Just need to format as MM/DD/YYYY
        return date ? DateUtilities.getFormattedDateTime(new Date(date), DateUtilities.defaultFormat) : '';
    }
    changeTaskStatus(memberTaskDetails) {
        this.taskStatusChanged.emit({
            memberId: memberTaskDetails.memberId,
            userAgentGUID: memberTaskDetails.userAgentGUID,
            memberAgentNoteID: memberTaskDetails.memberAgentNoteID,
            status: memberTaskDetails.status
        });
        if (memberTaskDetails.status !== MemberAgentTaskStatus.COMPLETE) {
            this.updateTags();
        }
    }
    viewMember(note) {
        this.viewMemberSubject$.next(note);
    }
    toggle() {
        this.isExpanded = !this.isExpanded;
    }
    updateAgentDetails(pagination) {
        this.defaultStartItem = pagination.defaultStartItem;
        this.pageIndex = pagination.defaultStartItem;
    }
    pageStartIndex() {
        return (this.pageIndex - 1) * this.itemsPerPage;
    }
    pageEndIndex() {
        return (this.pageIndex - 1) * this.itemsPerPage + this.itemsPerPage;
    }
    onSelection(emitData) {
        this.selectedValues = this.agentDashboardTaskListContextService.onTaskSelection(emitData);
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    updateTags() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PROFILE_TASK_COMPLETE,
            [DataLayerGlobalVariable.PROFILE_TASK_TYPE]: this.agentTaskFacade.getAgentTaskName(this.noteActionType)
        };
    }
    onViewMember$() {
        return this.viewMemberSubject$.pipe(exhaustMap((note) => this.agentSearchFacade.selectMember$(note.memberId)));
    }
    handleOnViewMember() {
        this.agentSearchFacade.clearSearch();
        this.agentSearchFacade.updateMemberDetails();
        this.agentSearchFacade.navigateByPageTag(PageTags.ADD_NEW_PROFILE);
        this.profileFacade.beneficiarySearchNavigationClicked(true);
    }
}
AgentDashboardTaskListComponent.ɵfac = function AgentDashboardTaskListComponent_Factory(t) { return new (t || AgentDashboardTaskListComponent)(i0.ɵɵdirectiveInject(AgentSearchFacade), i0.ɵɵdirectiveInject(AgentDashboardTaskListContextService), i0.ɵɵdirectiveInject(ProfileFacade), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(AgentTaskFacade)); };
AgentDashboardTaskListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentDashboardTaskListComponent, selectors: [["vnext-agent-dashboard-task-list"]], inputs: { itemsPerPage: "itemsPerPage", memberNotesHistory: "memberNotesHistory", header: "header", headerKeyName: "headerKeyName", dueLabel: "dueLabel", completedLabel: "completedLabel", emptyListLabel: "emptyListLabel", paginationText: "paginationText", leftBorderColor: "leftBorderColor", noteActionType: "noteActionType" }, outputs: { taskStatusChanged: "taskStatusChanged" }, features: [i0.ɵɵProvidersFeature([AgentDashboardTaskListContextService])], decls: 10, vars: 6, consts: [[1, "dashboard-task"], [1, "dashboard-task-header"], [1, "d-flex", "justify-content-between", "w-100", 3, "click"], ["class", "Spa_Style_H2 accordion-header py-2", 4, "liveEditProp"], ["aria-hidden", "true"], [1, "sr-only"], [4, "ngIf", "ngIfElse"], ["elseBlock", ""], [1, "Spa_Style_H2", "accordion-header", "py-2"], [4, "ngIf"], [1, "dashboard-task-list", "no-translate-block", 3, "ngStyle"], [4, "ngFor", "ngForOf"], ["class", "dashboard-task-pagination", 4, "ngIf"], [3, "namePrefix", "memberName", "dueLabel", "completedLabel", "description", "memberAgentNoteID", "memberId", "userAgentGUID", "scheduledDate", "selectedValues", "taskStatusChanged", "linkClick", "onSelection"], [1, "dashboard-task-pagination"], [3, "pagination", "defaultStartItem", "itemsPerPage", "paginationText", "updatePagination"], [1, "empty-list-label"], ["class", "Spa_Style_Note c-mt-30", 4, "liveEditProp"], [1, "Spa_Style_Note", "c-mt-30"]], template: function AgentDashboardTaskListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵlistener("click", function AgentDashboardTaskListComponent_Template_div_click_2_listener() { return ctx.toggle(); });
        i0.ɵɵtemplate(3, AgentDashboardTaskListComponent_div_3_Template, 2, 1, "div", 3);
        i0.ɵɵelement(4, "i", 4);
        i0.ɵɵelementStart(5, "span", 5);
        i0.ɵɵtext(6, "Expand/collapse menu");
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(7, AgentDashboardTaskListComponent_div_7_Template, 2, 1, "div", 6);
        i0.ɵɵtemplate(8, AgentDashboardTaskListComponent_ng_template_8_Template, 2, 1, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(9);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", ctx.headerKeyName);
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("fas ", ctx.isExpanded ? "fa-angle-up" : "fa-angle-down", " \n               Spa_Style_Large_Font\n               py-3 \n               can-click");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", (ctx.memberNotesHistory == null ? null : ctx.memberNotesHistory.length) > 0)("ngIfElse", _r2);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, i1$2.NgStyle, PaginationComponent, LiveEditPropDirective, AgentDashboardTaskDetailComponent, i1$2.SlicePipe], styles: [".dashboard-task[_ngcontent-%COMP%]   .dashboard-task-header[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-weight:400;color:var(--static-Spa_Style_Primary)}.dashboard-task-header[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.dashboard-task-list[_ngcontent-%COMP%]{border-left:5px solid;margin-top:20px}.dashboard-task-list[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{padding:10px 0 0 30px}.dashboard-task-pagination[_ngcontent-%COMP%]{position:relative;top:10px;max-width:50%;float:right}@media (max-width: 720px){.dashboard-task-pagination[_ngcontent-%COMP%]{max-width:65%}}@media (max-width: 540px){.dashboard-task-pagination[_ngcontent-%COMP%]{max-width:100%}}.empty-list-label[_ngcontent-%COMP%]{text-align:center}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], AgentDashboardTaskListComponent.prototype, "changeTaskStatus", null);
__decorate([
    LiveEditInactive()
], AgentDashboardTaskListComponent.prototype, "viewMember", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentDashboardTaskListComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-dashboard-task-list', providers: [AgentDashboardTaskListContextService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"dashboard-task\">\r\n  <div class=\"dashboard-task-header\">\r\n    <div class=\"d-flex justify-content-between w-100\" (click)=\"toggle()\">\r\n      <div *liveEditProp=\"headerKeyName\" class=\"Spa_Style_H2 accordion-header py-2\">\r\n        {{ header }} \r\n      </div>\r\n      <i\r\n        class=\"fas {{ isExpanded ? 'fa-angle-up' : 'fa-angle-down' }} \r\n               Spa_Style_Large_Font\r\n               py-3 \r\n               can-click\"\r\n        aria-hidden=\"true\"\r\n      ></i>\r\n      <span class=\"sr-only\">Expand/collapse menu</span>\r\n    </div>\r\n  </div>\r\n  \r\n  <div *ngIf=\"memberNotesHistory?.length > 0; else elseBlock\">\r\n    <div *ngIf=\"isExpanded\">\r\n      <div class=\"dashboard-task-list no-translate-block\" [ngStyle]=\"{ borderLeftColor: leftBorderColor }\">\r\n        <div *ngFor=\"let note of memberNotesHistory  | slice: pageStartIndex():pageEndIndex(); index as i\">\r\n          <vnext-agent-dashboard-task-detail\r\n            [namePrefix]=\"note.namePrefix\"\r\n            [memberName]=\"note.memberName\"\r\n            [dueLabel]=\"dueLabel\"\r\n            [completedLabel]=\"completedLabel\"\r\n            [description]=\"note.description\"\r\n            [memberAgentNoteID]=\"note.memberAgentNoteID\"\r\n            [memberId]=\"note.memberId\"\r\n            [userAgentGUID]=\"note.userAgentGUID\"\r\n            [scheduledDate]=\"formatDate(note.scheduledDate)\"\r\n            [selectedValues] = \"selectedValues\"\r\n            (taskStatusChanged)=\"changeTaskStatus($event)\"\r\n            (linkClick)=\"viewMember(note)\"\r\n            (onSelection)=\"onSelection($event)\">\r\n          </vnext-agent-dashboard-task-detail>\r\n        </div>\r\n      </div>\r\n  \r\n      <div class=\"dashboard-task-pagination\" *ngIf=\"memberNotesHistory?.length > itemsPerPage\">\r\n        <vnext-pagination\r\n          [pagination]=\"memberNotesHistory\"\r\n          [defaultStartItem]=\"defaultStartItem\"\r\n          [itemsPerPage]=\"itemsPerPage\"\r\n          [paginationText]=\"paginationText\"\r\n          (updatePagination)=\"updateAgentDetails($event)\"\r\n        ></vnext-pagination>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <ng-template #elseBlock>\r\n    <div class=\"empty-list-label\">\r\n      <p class=\"Spa_Style_Note c-mt-30\" *liveEditProp=\"'Spa_Dashboard_Empty_Task_List'\">\r\n        {{ emptyListLabel }}\r\n      </p>\r\n    </div>\r\n  </ng-template>\r\n</div>", styles: [".dashboard-task .dashboard-task-header i{font-weight:400;color:var(--static-Spa_Style_Primary)}.dashboard-task-header{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.dashboard-task-list{border-left:5px solid;margin-top:20px}.dashboard-task-list div{padding:10px 0 0 30px}.dashboard-task-pagination{position:relative;top:10px;max-width:50%;float:right}@media (max-width: 720px){.dashboard-task-pagination{max-width:65%}}@media (max-width: 540px){.dashboard-task-pagination{max-width:100%}}.empty-list-label{text-align:center}\n"] }]
    }], function () { return [{ type: AgentSearchFacade }, { type: AgentDashboardTaskListContextService }, { type: ProfileFacade }, { type: AnalyticsService }, { type: AgentTaskFacade }]; }, { taskStatusChanged: [{
            type: Output
        }], itemsPerPage: [{
            type: Input
        }], memberNotesHistory: [{
            type: Input
        }], header: [{
            type: Input
        }], headerKeyName: [{
            type: Input
        }], dueLabel: [{
            type: Input
        }], completedLabel: [{
            type: Input
        }], emptyListLabel: [{
            type: Input
        }], paginationText: [{
            type: Input
        }], leftBorderColor: [{
            type: Input
        }], noteActionType: [{
            type: Input
        }], changeTaskStatus: [], viewMember: [] }); })();

function AgentDashboardComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.Spa_AgentDashboard_Header_Text, " ");
} }
function AgentDashboardComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r1.Spa_Site_PageSubHeader_Text ? i0.ɵɵpipeBind2(1, 1, ctx_r1.Spa_Site_PageSubHeader_Text, "html") : "", i0.ɵɵsanitizeHtml);
} }
function AgentDashboardComponent_vnext_notice_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice", 12);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("messages", ctx_r2.subscriptionMessages)("type", "warn");
} }
function AgentDashboardComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "button", 14);
    i0.ɵɵlistener("click", function AgentDashboardComponent_div_6_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.navigateToEnrollmentReports()); })("keyup.Enter", function AgentDashboardComponent_div_6_Template_button_keyup_Enter_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.navigateToEnrollmentReports()); });
    i0.ɵɵelement(2, "i", 15);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r3.Spa_Site_PlanSmart_Enabled && (ctx_r3.Spa_Site_AgentTrainingMaterials_Enabled || ctx_r3.Spa_Site_LMS_AgentTrainingMaterials_Enabled) ? "col-md-4" : "col-md-6");
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("", ctx_r3.Spa_Site_AgentReports_Icon, " mr-3");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.Spa_AgentReports_Header_Text, " ");
} }
function AgentDashboardComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "button", 14);
    i0.ɵɵlistener("click", function AgentDashboardComponent_div_7_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.navigateToPlanSmart()); })("keyup.Enter", function AgentDashboardComponent_div_7_Template_button_keyup_Enter_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.navigateToPlanSmart()); });
    i0.ɵɵelement(2, "i", 17);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r4.isAgentReportsEnabled && (ctx_r4.Spa_Site_AgentTrainingMaterials_Enabled || ctx_r4.Spa_Site_LMS_AgentTrainingMaterials_Enabled) ? "col-md-4" : "col-md-6");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.Spa_PlanSmart_Header_Text, " ");
} }
function AgentDashboardComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "button", 14);
    i0.ɵɵlistener("click", function AgentDashboardComponent_div_8_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.navigateToTraining()); })("keyup.Enter", function AgentDashboardComponent_div_8_Template_button_keyup_Enter_1_listener() { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.navigateToTraining()); });
    i0.ɵɵelement(2, "i", 19);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r5.isAgentReportsEnabled && ctx_r5.Spa_Site_PlanSmart_Enabled ? "col-md-4" : "col-md-6");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r5.Spa_AgentDashboard_TrainingMaterials_Icon);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.Spa_Site_AgentTrainingMaterials_Text, " ");
} }
function AgentDashboardComponent_div_9_div_1_vnext_agent_dashboard_task_list_1_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-agent-dashboard-task-list", 23);
    i0.ɵɵlistener("taskStatusChanged", function AgentDashboardComponent_div_9_div_1_vnext_agent_dashboard_task_list_1_Template_vnext_agent_dashboard_task_list_taskStatusChanged_0_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r19.changeTaskStatus($event)); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const taskList_r17 = i0.ɵɵnextContext().$implicit;
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("memberNotesHistory", i0.ɵɵpipeBind1(1, 10, taskList_r17.tasks$))("header", taskList_r17.header)("headerKeyName", taskList_r17.headerKeyName)("noteActionType", taskList_r17.noteActionType)("dueLabel", ctx_r18.Spa_AddProfile_AgentNote_Due_Label)("completedLabel", ctx_r18.Spa_AddProfile_AgentNote_Completed_Label)("emptyListLabel", ctx_r18.Spa_Dashboard_Empty_Task_List)("leftBorderColor", taskList_r17.color)("itemsPerPage", ctx_r18.Spa_Dashboard_Notes_Page_Size)("paginationText", ctx_r18.Spa_Site_Pagination_View_Text);
} }
function AgentDashboardComponent_div_9_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtemplate(1, AgentDashboardComponent_div_9_div_1_vnext_agent_dashboard_task_list_1_Template, 2, 12, "vnext-agent-dashboard-task-list", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const taskList_r17 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", taskList_r17.permission);
} }
function AgentDashboardComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AgentDashboardComponent_div_9_div_1_Template, 2, 1, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r6.dashboardTasks);
} }
let AgentDashboardComponent = class AgentDashboardComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, navigationService, router, analyticsService, memberSessionService, agentTaskFacade, store, weglotService, spinnerService, agentPermissionsService, configResourceService, planYearResourceService, agentService, injector, modalService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.navigationService = navigationService;
        this.router = router;
        this.analyticsService = analyticsService;
        this.memberSessionService = memberSessionService;
        this.agentTaskFacade = agentTaskFacade;
        this.store = store;
        this.weglotService = weglotService;
        this.spinnerService = spinnerService;
        this.agentPermissionsService = agentPermissionsService;
        this.configResourceService = configResourceService;
        this.planYearResourceService = planYearResourceService;
        this.agentService = agentService;
        this.injector = injector;
        this.modalService = modalService;
        this.Spa_Site_Pagination_View_Text = 'Viewing <startPageItem> - <endPageItem> of <totalPages>';
        this.Spa_AddProfile_AgentNote_Completed_Label = 'Completed';
        this.Spa_AddProfile_AgentNote_Due_Label = 'Due';
        this.Spa_Dashboard_Notes_Page_Size = 5;
        this.Spa_Site_SOA_Enabled = true;
        this.Spa_Site_Enable_BlueButton = true;
        this.Spa_SendEnrollment_Email_Enabled = true;
        this.Spa_SendEnrollment_TextMessage_Enabled = true;
        this.Spa_Site_AddToQuote_Enabled = true;
        this.Spa_Site_AgentDashboard_Enabled = false;
        this.Spa_AgentTask_AddFollowUp_Enabled = false;
        this.Spa_Dashboard_Enrollment_Header_Text = 'Enrollment';
        this.Spa_Dashboard_Quote_Header_Text = 'Quote';
        this.Spa_Dashboard_SOA_Header_Text = 'Scope of Appointment';
        this.Spa_Dashboard_BlueButton_Header_Text = 'MyMedicare.gov connections';
        this.Spa_Dashboard_Other_Header_Text = 'Other';
        this.Spa_Dashboard_Empty_Task_List = 'You have no tasks for this category';
        this.Spa_AgentDashboard_Header_Text = 'Dashboard';
        this.Spa_Site_PageSubHeader_Text = '';
        this.Spa_Site_AgentTrainingMaterials_Text = 'Agent training Materials';
        this.Spa_AgentDashboard_TrainingMaterials_Icon = 'fa-book';
        this.Spa_Site_AgentReports_Enabled = false;
        this.Spa_Site_AgentReports_AdminOnly_Enabled = false;
        this.Spa_AgentReports_Header_Text = 'Reports';
        this.Spa_Site_AgentReports_Icon = 'fas fa-book';
        this.Spa_PlanSmart_Header_Text = 'Plan Smart';
        this.Spa_Site_PlanSmart_Enabled = true;
        this.AppID = 0;
        this.Spa_Site_SiteType = SiteType.BROKER;
        this.Spa_Site_AgentTrainingMaterials_Enabled = false;
        this.Spa_Site_LMS_AgentTrainingMaterials_Enabled = false;
        this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Cancel = 'Cancel';
        this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Continue = 'Continue';
        this.Spa_Agent_Modal_Contents_Message = 'In order to perform this action, you will need to provide a valid email address. This address will be saved to your agent profile.';
        this.Spa_Agent_EmailAddress_ModalTitle_Text = 'Agent Email Address';
        this.Spa_Agent_EmailAddress_InvalidText = 'Invalid email address';
        this.Spa_Dashboard_SelectRx_Header_Text = 'SelectRx Tasks';
        this.Spa_Site_SelectRx_Enabled = false;
        this.Spa_Dashboard_Subscription_Warning_Banner_Text = '<b>Your PlanCompare Edge for Agents subscription will expire on <mm/dd/yyyy>.</b> </br>This is because you have either elected to cancel your subscription or your payment has lapsed. If your payment has lapsed, go to your Account Overview/Manage my subscription section to update your payment information. Failing to do so will result in you no longer having access to PlanCompare Edge for Agents after <mm/dd/yyyy>';
        this.Spa_Site_Agent_Subscription_Expire_Days_Count = 30;
        this.isEnroller = false;
        this.isQuoter = false;
        this.dashboardTasks = [];
        this.isAdmin = false;
        this.isAgentReportsEnabled = false;
        this.subscriptions = [];
        this.subscriptionMessages = [];
    }
    ngOnInit() {
        super.ngOnInit();
        const agentRole = this.agentPermissionsService.getAgentRole();
        this.isAdmin = this.agentPermissionsService.isAdmin(agentRole);
        this.isEnroller = this.agentPermissionsService.hasBasicEnrollerRole(agentRole);
        this.isQuoter = this.agentPermissionsService.hasBasicQuoterRole(agentRole);
        this.isAgentReportsEnabled =
            this.Spa_Site_AgentReports_Enabled &&
                (!this.Spa_Site_AgentReports_AdminOnly_Enabled || this.isAdmin) &&
                !this.isEnroller &&
                !this.isQuoter;
        const subscriptionEvents = this.agentService.getAgentSubscriptionEvents();
        if (subscriptionEvents?.length) {
            this.setSubscriptionBanner(subscriptionEvents);
        }
        this.subscriptions = [
            this.memberSessionService.getMemberNotesHistory$().subscribe((response) => {
                this.agentGuid = response.data?.agentGuid;
                if (response?.data?.memberAgentNotes) {
                    this.store.dispatch(new SetAgentNotes(response?.data?.memberAgentNotes));
                }
                else {
                    this.store.dispatch(new SetAgentNotes([]));
                }
            }),
            this.memberSessionService.isMemberLoading$().subscribe(loading => {
                loading ? this.spinnerService.show(SpinnerEvent.MEMBER_LOADING) : this.spinnerService.hide(SpinnerEvent.MEMBER_LOADING);
            })
        ];
    }
    setSubscriptionBanner(subscriptionEvents) {
        if (subscriptionEvents?.some(event => Object.values(SubscriptionMetaData).find(dataType => dataType === event.EventType))) {
            const subscriptionExpirationDate = DateUtilities.addDays(subscriptionEvents[0]?.EventTime, this.Spa_Site_Agent_Subscription_Expire_Days_Count);
            const formattedExpireDate = DateUtilities.getFormattedDate(new Date(subscriptionExpirationDate));
            const message = this.Spa_Dashboard_Subscription_Warning_Banner_Text.replaceAll('<mm/dd/yyyy>', formattedExpireDate);
            this.subscriptionMessages.push({ message });
        }
    }
    getTagsToUpdate() {
        const appId = this.AppID.toString();
        const siteType = this.Spa_Site_SiteType;
        const memberSession = this.memberSessionService.getMemberSession();
        return {
            [DataLayerGlobalVariable.SITE_ID]: this.store.selectSnapshot(AppConfigState.shortSiteId),
            [DataLayerGlobalVariable.SITE_URL]: this.analyticsService.getBaseUrl(),
            [DataLayerGlobalVariable.SITE_CHANNEL]: siteType,
            [DataLayerGlobalVariable.AGENT_GUID]: this.store.selectSnapshot(AgentState.agentGuid),
            [DataLayerGlobalVariable.AGENT_IS_PROFILE_ADMIN]: this.store.selectSnapshot(AgentState.agentIsProfileAdmin),
            [DataLayerGlobalVariable.LANGUAGE_ID]: this.weglotService.getCurrentWeglotLocaleOrDefault(),
            [DataLayerGlobalVariable.APP_SESSION_ID]: memberSession ? memberSession.sessionId : null,
            [DataLayerGlobalVariable.USER_ID_METHOD]: this.memberSessionService.getAuthType(),
            [DataLayerGlobalVariable.CLIENT_ID]: this.memberSessionService.getClientId(),
            [DataLayerGlobalVariable.CLIENT_GAID]: this.configResourceService.getProcessedResourceValue('GoogleAnalyticsClientPropertyID'),
            [DataLayerGlobalVariable.APP_ID]: appId,
            [DataLayerGlobalVariable.SITE_PLAN_YEAR]: this.planYearResourceService.getSelectedPlanYear()
        };
    }
    preProcessProperties() {
        this.dashboardTasks = [
            {
                tasks$: this.selectAgentNotes$(NoteActionType.EnrollmentTask),
                noteActionType: NoteActionType.EnrollmentTask,
                header: this.Spa_Dashboard_Enrollment_Header_Text,
                headerKeyName: 'Spa_Dashboard_Enrollment_Header_Text',
                color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT5),
                permission: this.Spa_AgentTask_AddFollowUp_Enabled && (this.Spa_SendEnrollment_Email_Enabled || this.Spa_SendEnrollment_TextMessage_Enabled)
            },
            {
                tasks$: this.selectAgentNotes$(NoteActionType.QuoteTask),
                noteActionType: NoteActionType.QuoteTask,
                header: this.Spa_Dashboard_Quote_Header_Text,
                headerKeyName: 'Spa_Dashboard_Quote_Header_Text',
                color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT3),
                permission: this.Spa_AgentTask_AddFollowUp_Enabled && this.Spa_Site_AddToQuote_Enabled
            },
            {
                tasks$: this.selectAgentNotes$(NoteActionType.SOATask),
                noteActionType: NoteActionType.SOATask,
                header: this.Spa_Dashboard_SOA_Header_Text,
                headerKeyName: 'Spa_Dashboard_SOA_Header_Text',
                color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT6),
                permission: this.Spa_AgentTask_AddFollowUp_Enabled && this.Spa_Site_SOA_Enabled
            },
            {
                tasks$: this.selectAgentNotes$(NoteActionType.BlueButtonTask),
                noteActionType: NoteActionType.BlueButtonTask,
                header: this.Spa_Dashboard_BlueButton_Header_Text,
                headerKeyName: 'Spa_Dashboard_BlueButton_Header_Text',
                color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT4),
                permission: this.Spa_AgentTask_AddFollowUp_Enabled && this.Spa_Site_Enable_BlueButton
            },
            {
                tasks$: this.selectAgentNotes$(NoteActionType.SelectRx),
                noteActionType: NoteActionType.SelectRx,
                header: this.Spa_Dashboard_SelectRx_Header_Text,
                headerKeyName: 'Spa_Dashboard_SelectRx_Header_Text',
                color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT1),
                permission: this.Spa_Site_SelectRx_Enabled
            },
            {
                tasks$: this.selectAgentNotes$(NoteActionType.OtherTask),
                noteActionType: NoteActionType.OtherTask,
                header: this.Spa_Dashboard_Other_Header_Text,
                headerKeyName: 'Spa_Dashboard_Other_Header_Text',
                color: AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT1),
                permission: true
            }
        ];
    }
    selectAgentNotes$(noteType) {
        return this.store.select(AgentState.uncompletedAgentNotes(noteType));
    }
    navigateToTraining() {
        if (this.Spa_Site_LMS_AgentTrainingMaterials_Enabled) {
            const agentEmailAddressExists = this.agentService.getAgentData();
            if (!agentEmailAddressExists.data.emailAddress) {
                const options = {
                    ariaLabelledBy: 'modalHeaderTitle',
                    centered: true,
                    injector: this.injector
                };
                const emailModal = this.modalService.open(EmailConfirmationModalComponent, options);
                emailModal.componentInstance.updateAgentEmailAddress = true;
                emailModal.componentInstance.isSendEnrollment = true;
                emailModal.componentInstance.agentGuid = this.agentGuid;
                emailModal.componentInstance.title = this.Spa_Agent_EmailAddress_ModalTitle_Text;
                emailModal.componentInstance.emailPrompt = this.Spa_Agent_Modal_Contents_Message;
                emailModal.componentInstance.cancelButton = this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Cancel;
                emailModal.componentInstance.confirmButton = this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Continue;
                emailModal.componentInstance.emailAddressRequired = this.Spa_Agent_EmailAddress_InvalidText;
                emailModal.componentInstance.emailAddressInvalid = this.Spa_Agent_EmailAddress_InvalidText;
            }
            else {
                const agentGuid = this.agentService.getAgentInContextGuid();
                this.navigationService.navigateToLmsInNewTab(agentGuid);
            }
        }
        else {
            this.navigationService.navigateByPageTag(PageTags.AGENT_TRAINING_MATERIALS);
        }
    }
    navigateToEnrollmentReports() {
        this.navigationService.navigateByPageTag(PageTags.REPORTS_SUMMARY);
    }
    navigateToPlanSmart() {
        this.navigationService.navigateByPageTag(PageTags.PLAN_SMART);
    }
    changeTaskStatus(memberTaskDetails) {
        this.agentTaskFacade.getSessionId$(memberTaskDetails.userAgentGUID, memberTaskDetails.memberId).subscribe(data => {
            if (memberTaskDetails.status === MemberAgentTaskStatus.COMPLETE) {
                this.unCompleteTask(data.sessionId, memberTaskDetails.memberAgentNoteID);
            }
            else {
                this.completeTask(data.sessionId, memberTaskDetails.memberAgentNoteID);
            }
        });
    }
    completeTask(sessionId, agentNoteId) {
        const memberAgentNotes = {
            userAgentGUID: '',
            agentNoteActionType: NoteActionType.OtherTask,
            description: '',
            memberAgentNoteID: agentNoteId,
            agentName: '',
            scheduledDate: '',
            completedWhen: DateUtilities.getDefaultDateTimeISOFormat(new Date().toString()),
            createdWhen: '',
            modifiedWhen: ''
        };
        // Only 'completedWhen' value is updated by the API. All other values are just placeholders.
        // !!Note!! When the api is changed to update all values in the future,
        // the correct 'agentNoteActionType' needs to be passed back !!Note!!
        this.agentTaskFacade.updateDashboardAgentTask(sessionId, memberAgentNotes);
    }
    unCompleteTask(sessionId, agentNoteId) {
        const memberAgentNotes = {
            userAgentGUID: '',
            agentNoteActionType: NoteActionType.OtherTask,
            description: '',
            memberAgentNoteID: agentNoteId,
            agentName: '',
            scheduledDate: '',
            completedWhen: '',
            createdWhen: '',
            modifiedWhen: ''
        };
        // Only 'completedWhen' value is updated by the API. All other values are just placeholders.
        // !!Note!! When the api is changed to update all values in the future,
        // the correct 'agentNoteActionType' needs to be passed back !!Note!!
        this.agentTaskFacade.updateDashboardAgentTask(sessionId, memberAgentNotes);
    }
    filterMemberAgentNotes(memberAgentNotes, type) {
        return memberAgentNotes.filter(note => note.agentNoteActionType === type && !note.completedWhen);
    }
    formatDate(date) {
        const format = DateUtilities.defaultDateTimeISOFormat;
        return DateUtilities.getFormattedPTDate(new Date(date), format);
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }
};
AgentDashboardComponent.ɵfac = function AgentDashboardComponent_Factory(t) { return new (t || AgentDashboardComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(AgentTaskFacade), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.WeglotService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i1.AgentPermissionsService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.PlanYearResourceService), i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1$1.NgbModal)); };
AgentDashboardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentDashboardComponent, selectors: [["vnext-agent-dashboard"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 10, vars: 9, consts: [["vnextGoogleTagManager", "", 1, "col-12", "c-mt-30", "c-mb-30", "container", 3, "saveDefaultValues", "tagsToUpdate"], ["class", "Spa_Style_H1 text-center", 4, "liveEditProp"], [1, "subheader-container", "row", "col-12", "c-mt-30", "c-mb-30"], ["navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [3, "messages", "type", 4, "ngIf"], [1, "buttons-container", "row"], ["class", "reports-button-wrapper col-12 mb-3", 3, "ngClass", 4, "ngIf"], ["class", "plan-smart-button-wrapper col-12 mb-3", 3, "ngClass", 4, "ngIf"], ["class", "training-button-wrapper col-12 mb-3", 3, "ngClass", 4, "ngIf"], [4, "ngIf"], [1, "Spa_Style_H1", "text-center"], ["navigationAdapter", "", 3, "innerHtml"], [3, "messages", "type"], [1, "reports-button-wrapper", "col-12", "mb-3", 3, "ngClass"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "w-100", 3, "click", "keyup.Enter"], ["aria-hidden", "true"], [1, "plan-smart-button-wrapper", "col-12", "mb-3", 3, "ngClass"], ["aria-hidden", "true", 1, "fas", "fa-book-user", "mr-3"], [1, "training-button-wrapper", "col-12", "mb-3", 3, "ngClass"], ["aria-hidden", "true", 1, "training-icon", "fas", "mr-3", 3, "ngClass"], ["class", "list-container", 4, "ngFor", "ngForOf"], [1, "list-container"], [3, "memberNotesHistory", "header", "headerKeyName", "noteActionType", "dueLabel", "completedLabel", "emptyListLabel", "leftBorderColor", "itemsPerPage", "paginationText", "taskStatusChanged", 4, "ngIf"], [3, "memberNotesHistory", "header", "headerKeyName", "noteActionType", "dueLabel", "completedLabel", "emptyListLabel", "leftBorderColor", "itemsPerPage", "paginationText", "taskStatusChanged"]], template: function AgentDashboardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, AgentDashboardComponent_div_1_Template, 2, 1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, AgentDashboardComponent_div_3_Template, 2, 4, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, AgentDashboardComponent_vnext_notice_4_Template, 1, 2, "vnext-notice", 4);
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵtemplate(6, AgentDashboardComponent_div_6_Template, 4, 5, "div", 6);
        i0.ɵɵtemplate(7, AgentDashboardComponent_div_7_Template, 4, 2, "div", 7);
        i0.ɵɵtemplate(8, AgentDashboardComponent_div_8_Template, 4, 3, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, AgentDashboardComponent_div_9_Template, 2, 1, "div", 9);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("saveDefaultValues", true)("tagsToUpdate", ctx.getTagsToUpdate());
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_AgentDashboard_Header_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_PageSubHeader_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.subscriptionMessages == null ? null : ctx.subscriptionMessages.length);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isAgentReportsEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Site_PlanSmart_Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Site_AgentTrainingMaterials_Enabled || ctx.Spa_Site_LMS_AgentTrainingMaterials_Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Site_AgentDashboard_Enabled && (ctx.dashboardTasks == null ? null : ctx.dashboardTasks.length));
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, NoticeComponent, NavigationAdapterDirective, LiveEditPropDirective, GoogleTagManagerDirective, IconAriaAttributesDirective, AgentDashboardTaskListComponent, i1$2.AsyncPipe, SafePipe], styles: [".list-container[_ngcontent-%COMP%]:not(:last-child){margin-bottom:65px}.buttons-container[_ngcontent-%COMP%]{display:flex;justify-content:space-evenly}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_Site_Pagination_View_Text", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_AddProfile_AgentNote_Completed_Label", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_AddProfile_AgentNote_Due_Label", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_Dashboard_Notes_Page_Size", void 0);
__decorate([
    GlobalResource(true)
], AgentDashboardComponent.prototype, "Spa_Site_SOA_Enabled", void 0);
__decorate([
    GlobalResource(true)
], AgentDashboardComponent.prototype, "Spa_Site_Enable_BlueButton", void 0);
__decorate([
    GlobalResource(true)
], AgentDashboardComponent.prototype, "Spa_SendEnrollment_Email_Enabled", void 0);
__decorate([
    GlobalResource(true)
], AgentDashboardComponent.prototype, "Spa_SendEnrollment_TextMessage_Enabled", void 0);
__decorate([
    GlobalResource(true)
], AgentDashboardComponent.prototype, "Spa_Site_AddToQuote_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_Site_AgentDashboard_Enabled", void 0);
__decorate([
    GlobalResource(true)
], AgentDashboardComponent.prototype, "Spa_AgentTask_AddFollowUp_Enabled", void 0);
__decorate([
    PlatformProp('live-edit', true)
], AgentDashboardComponent.prototype, "Spa_Dashboard_Enrollment_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], AgentDashboardComponent.prototype, "Spa_Dashboard_Quote_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], AgentDashboardComponent.prototype, "Spa_Dashboard_SOA_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], AgentDashboardComponent.prototype, "Spa_Dashboard_BlueButton_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], AgentDashboardComponent.prototype, "Spa_Dashboard_Other_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentDashboardComponent.prototype, "Spa_Dashboard_Empty_Task_List", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentDashboardComponent.prototype, "Spa_AgentDashboard_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentDashboardComponent.prototype, "Spa_Site_PageSubHeader_Text", void 0);
__decorate([
    PlatformProp()
], AgentDashboardComponent.prototype, "Spa_Site_AgentTrainingMaterials_Text", void 0);
__decorate([
    PlatformProp()
], AgentDashboardComponent.prototype, "Spa_AgentDashboard_TrainingMaterials_Icon", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_Site_AgentReports_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_Site_AgentReports_AdminOnly_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_AgentReports_Header_Text", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_Site_AgentReports_Icon", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_PlanSmart_Header_Text", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_Site_PlanSmart_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "AppID", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_Site_SiteType", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_Site_AgentTrainingMaterials_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_Site_LMS_AgentTrainingMaterials_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_EnrollmentConfirmation_EmailConfirmationModal_Cancel", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_EnrollmentConfirmation_EmailConfirmationModal_Continue", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_Agent_Modal_Contents_Message", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_Agent_EmailAddress_ModalTitle_Text", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_Agent_EmailAddress_InvalidText", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_Dashboard_SelectRx_Header_Text", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_Site_SelectRx_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_Dashboard_Subscription_Warning_Banner_Text", void 0);
__decorate([
    GlobalResource()
], AgentDashboardComponent.prototype, "Spa_Site_Agent_Subscription_Expire_Days_Count", void 0);
AgentDashboardComponent = __decorate([
    PlatformWidget
], AgentDashboardComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentDashboardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-dashboard', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"col-12 c-mt-30 c-mb-30 container\" [saveDefaultValues]=\"true\" [tagsToUpdate]=\"getTagsToUpdate()\" vnextGoogleTagManager>\r\n  <div class=\"Spa_Style_H1 text-center\" *liveEditProp=\"'Spa_AgentDashboard_Header_Text'\">\r\n    {{ Spa_AgentDashboard_Header_Text }}\r\n  </div>\r\n  <div class=\"subheader-container row col-12 c-mt-30 c-mb-30\">\r\n    <div\r\n      *liveEditProp=\"'Spa_Site_PageSubHeader_Text'\"\r\n      [innerHtml]=\"Spa_Site_PageSubHeader_Text ? (Spa_Site_PageSubHeader_Text | safe : 'html') : ''\"\r\n      navigationAdapter\r\n    ></div>\r\n  </div>\r\n\r\n  <vnext-notice *ngIf=\"subscriptionMessages?.length\" [messages]=\"subscriptionMessages\" [type]=\"'warn'\"></vnext-notice>\r\n  <div class=\"buttons-container row\">\r\n    <div\r\n      *ngIf=\"isAgentReportsEnabled\"\r\n      class=\"reports-button-wrapper col-12 mb-3\"\r\n      [ngClass]=\"\r\n        Spa_Site_PlanSmart_Enabled && (Spa_Site_AgentTrainingMaterials_Enabled || Spa_Site_LMS_AgentTrainingMaterials_Enabled)\r\n          ? 'col-md-4'\r\n          : 'col-md-6'\r\n      \"\r\n    >\r\n      <button\r\n        type=\"button\"\r\n        class=\"btn Spa_Style_SecondaryButton w-100\"\r\n        (click)=\"navigateToEnrollmentReports()\"\r\n        (keyup.Enter)=\"navigateToEnrollmentReports()\"\r\n      >\r\n        <i class=\"{{ Spa_Site_AgentReports_Icon }} mr-3\" aria-hidden=\"true\"></i>\r\n        {{ Spa_AgentReports_Header_Text }}\r\n      </button>\r\n    </div>\r\n    <div\r\n      *ngIf=\"Spa_Site_PlanSmart_Enabled\"\r\n      class=\"plan-smart-button-wrapper col-12 mb-3\"\r\n      [ngClass]=\"\r\n        isAgentReportsEnabled && (Spa_Site_AgentTrainingMaterials_Enabled || Spa_Site_LMS_AgentTrainingMaterials_Enabled)\r\n          ? 'col-md-4'\r\n          : 'col-md-6'\r\n      \"\r\n    >\r\n      <button\r\n        type=\"button\"\r\n        class=\"btn Spa_Style_SecondaryButton w-100\"\r\n        (click)=\"navigateToPlanSmart()\"\r\n        (keyup.Enter)=\"navigateToPlanSmart()\"\r\n      >\r\n        <i class=\"fas fa-book-user mr-3\" aria-hidden=\"true\"></i>\r\n        {{ Spa_PlanSmart_Header_Text }}\r\n      </button>\r\n    </div>\r\n    <div\r\n      *ngIf=\"Spa_Site_AgentTrainingMaterials_Enabled || Spa_Site_LMS_AgentTrainingMaterials_Enabled\"\r\n      class=\"training-button-wrapper col-12 mb-3\"\r\n      [ngClass]=\"isAgentReportsEnabled && Spa_Site_PlanSmart_Enabled ? 'col-md-4' : 'col-md-6'\"\r\n    >\r\n      <button type=\"button\" class=\"btn Spa_Style_SecondaryButton w-100\" (click)=\"navigateToTraining()\" (keyup.Enter)=\"navigateToTraining()\">\r\n        <i class=\"training-icon fas mr-3\" aria-hidden=\"true\" [ngClass]=\"Spa_AgentDashboard_TrainingMaterials_Icon\"></i>\r\n        {{ Spa_Site_AgentTrainingMaterials_Text }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n  <div *ngIf=\"Spa_Site_AgentDashboard_Enabled && dashboardTasks?.length\">\r\n    <div class=\"list-container\" *ngFor=\"let taskList of dashboardTasks\">\r\n      <vnext-agent-dashboard-task-list\r\n        *ngIf=\"taskList.permission\"\r\n        [memberNotesHistory]=\"taskList.tasks$ | async\"\r\n        [header]=\"taskList.header\"\r\n        [headerKeyName]=\"taskList.headerKeyName\"\r\n        [noteActionType]=\"taskList.noteActionType\"\r\n        [dueLabel]=\"Spa_AddProfile_AgentNote_Due_Label\"\r\n        [completedLabel]=\"Spa_AddProfile_AgentNote_Completed_Label\"\r\n        [emptyListLabel]=\"Spa_Dashboard_Empty_Task_List\"\r\n        [leftBorderColor]=\"taskList.color\"\r\n        [itemsPerPage]=\"Spa_Dashboard_Notes_Page_Size\"\r\n        [paginationText]=\"Spa_Site_Pagination_View_Text\"\r\n        (taskStatusChanged)=\"changeTaskStatus($event)\"\r\n      ></vnext-agent-dashboard-task-list>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".list-container:not(:last-child){margin-bottom:65px}.buttons-container{display:flex;justify-content:space-evenly}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.NavigationService }, { type: i2$1.Router }, { type: AnalyticsService }, { type: i1.MemberSessionService }, { type: AgentTaskFacade }, { type: i2.Store }, { type: i1.WeglotService }, { type: i1.SpinnerService }, { type: i1.AgentPermissionsService }, { type: i1.ConfigResourceService }, { type: i1.PlanYearResourceService }, { type: i1.AgentService }, { type: i0.Injector }, { type: i1$1.NgbModal }]; }, { Spa_Site_Pagination_View_Text: [], Spa_AddProfile_AgentNote_Completed_Label: [], Spa_AddProfile_AgentNote_Due_Label: [], Spa_Dashboard_Notes_Page_Size: [], Spa_Site_SOA_Enabled: [], Spa_Site_Enable_BlueButton: [], Spa_SendEnrollment_Email_Enabled: [], Spa_SendEnrollment_TextMessage_Enabled: [], Spa_Site_AddToQuote_Enabled: [], Spa_Site_AgentDashboard_Enabled: [], Spa_AgentTask_AddFollowUp_Enabled: [], Spa_Dashboard_Enrollment_Header_Text: [], Spa_Dashboard_Quote_Header_Text: [], Spa_Dashboard_SOA_Header_Text: [], Spa_Dashboard_BlueButton_Header_Text: [], Spa_Dashboard_Other_Header_Text: [], Spa_Dashboard_Empty_Task_List: [], Spa_AgentDashboard_Header_Text: [], Spa_Site_PageSubHeader_Text: [], Spa_Site_AgentTrainingMaterials_Text: [], Spa_AgentDashboard_TrainingMaterials_Icon: [], Spa_Site_AgentReports_Enabled: [], Spa_Site_AgentReports_AdminOnly_Enabled: [], Spa_AgentReports_Header_Text: [], Spa_Site_AgentReports_Icon: [], Spa_PlanSmart_Header_Text: [], Spa_Site_PlanSmart_Enabled: [], AppID: [], Spa_Site_SiteType: [], Spa_Site_AgentTrainingMaterials_Enabled: [], Spa_Site_LMS_AgentTrainingMaterials_Enabled: [], Spa_EnrollmentConfirmation_EmailConfirmationModal_Cancel: [], Spa_EnrollmentConfirmation_EmailConfirmationModal_Continue: [], Spa_Agent_Modal_Contents_Message: [], Spa_Agent_EmailAddress_ModalTitle_Text: [], Spa_Agent_EmailAddress_InvalidText: [], Spa_Dashboard_SelectRx_Header_Text: [], Spa_Site_SelectRx_Enabled: [], Spa_Dashboard_Subscription_Warning_Banner_Text: [], Spa_Site_Agent_Subscription_Expire_Days_Count: [] }); })();

function AgentTrainingMaterialsComponent_vnext_link_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 9);
    i0.ɵɵlistener("click", function AgentTrainingMaterialsComponent_vnext_link_2_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.backToPrevious()); })("keyup.enter", function AgentTrainingMaterialsComponent_vnext_link_2_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.backToPrevious()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r0.Spa_Site_Previous)("showArrow", "left");
} }
function AgentTrainingMaterialsComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.Spa_Site_AgentTrainingMaterials_Text, " ");
} }
function AgentTrainingMaterialsComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r2.Spa_Site_PageSubHeader_Text ? i0.ɵɵpipeBind2(1, 1, ctx_r2.Spa_Site_PageSubHeader_Text, "html") : "", i0.ɵɵsanitizeHtml);
} }
function AgentTrainingMaterialsComponent_ng_container_8_div_1_div_5_vnext_link_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 20);
    i0.ɵɵlistener("click", function AgentTrainingMaterialsComponent_ng_container_8_div_1_div_5_vnext_link_1_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r14); const link_r10 = i0.ɵɵnextContext().$implicit; const ctx_r12 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r12.registerTrainingMaterialsClickEvent(link_r10.title, link_r10.url)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("title", link_r10.title)("href", link_r10.url)("alwaysUnderlined", true)("linkTarget", link_r10.newTab === false ? "_self" : "_blank")("customClass", "Spa_Style_Link Spa_Style_Small Spa_Style_Light_Weight");
} }
function AgentTrainingMaterialsComponent_ng_container_8_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, AgentTrainingMaterialsComponent_ng_container_8_div_1_div_5_vnext_link_1_Template, 1, 5, "vnext-link", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r10 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", link_r10.display);
} }
function AgentTrainingMaterialsComponent_ng_container_8_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14)(2, "div", 15);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 16);
    i0.ɵɵtemplate(5, AgentTrainingMaterialsComponent_ng_container_8_div_1_div_5_Template, 2, 1, "div", 17);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const section_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(section_r7.title);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", section_r7.materials);
} }
function AgentTrainingMaterialsComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AgentTrainingMaterialsComponent_ng_container_8_div_1_Template, 6, 2, "div", 12);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const section_r7 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", section_r7.display);
} }
let AgentTrainingMaterialsComponent = class AgentTrainingMaterialsComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, navigationService, localeService, router, analyticsService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.navigationService = navigationService;
        this.localeService = localeService;
        this.router = router;
        this.analyticsService = analyticsService;
        this.Spa_Site_AgentTrainingMaterials_Text = 'Agent Training Materials';
        this.Spa_Site_PageSubHeader_Text = '';
        this.Spa_Site_AgentTrainingMaterials_Enabled = false;
        this.Spa_Site_Previous = 'Previous';
        this.Spa_AgentTrainingMaterials_JSON = [];
        this.subscriptions = [];
    }
    ngOnInit() {
        super.ngOnInit();
        this.subscriptions.push(this.localeService.getCurrentLocale$().subscribe(() => {
            const trainingMaterialsSections = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_AgentTrainingMaterials_JSON', null, []);
            this.sortedTrainingMaterials = this.sortTrainingMaterials(trainingMaterialsSections);
            this.cdr.markForCheck();
        }));
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE,
            [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
        };
    }
    backToPrevious() {
        this.navigationService.backToPrevious();
    }
    registerTrainingMaterialsClickEvent(title, url) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_TRAINING_MATERIAL_LINK,
            [DataLayerGlobalVariable.TRAINING_MATERIAL_NAME]: title,
            [DataLayerGlobalVariable.TRAINING_MATERIAL_URL]: url
        };
    }
    sortTrainingMaterials(trainingMaterialsSections) {
        const materials = trainingMaterialsSections.sort((sectionA, sectionB) => sectionA.order - sectionB.order);
        materials.forEach(section => {
            section.materials.sort((materialA, materialB) => materialA.order - materialB.order);
        });
        return materials;
    }
};
AgentTrainingMaterialsComponent.ɵfac = function AgentTrainingMaterialsComponent_Factory(t) { return new (t || AgentTrainingMaterialsComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(AnalyticsService)); };
AgentTrainingMaterialsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentTrainingMaterialsComponent, selectors: [["vnext-agent-training-materials"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 9, vars: 4, consts: [[1, "col-12", "c-mt-30", "c-mb-30", "container"], [1, "col-auto", "mx-auto", "text-center"], [3, "title", "showArrow", "click", "keyup.enter", 4, "liveEditProp"], ["class", "Spa_Style_H1 c-mt-30 c-mb-30 text-center", 4, "liveEditProp"], [1, "row", "col-12", "c-mb-30"], ["navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [1, "training-materials-container"], [1, "row"], [4, "ngFor", "ngForOf"], [3, "title", "showArrow", "click", "keyup.enter"], [1, "Spa_Style_H1", "c-mt-30", "c-mb-30", "text-center"], ["navigationAdapter", "", 3, "innerHtml"], ["class", "materials-wrapper col-12 col-md-6", 4, "ngIf"], [1, "materials-wrapper", "col-12", "col-md-6"], [1, "materials-section"], [1, "header-section", "Spa_Style_Bold_Weight", "Spa_Style_Gray1_Background", "Spa_Style_Primary_Color"], [1, "body-section"], ["class", "link-wrapper", 4, "ngFor", "ngForOf"], [1, "link-wrapper"], [3, "title", "href", "alwaysUnderlined", "linkTarget", "customClass", "click", 4, "ngIf"], [3, "title", "href", "alwaysUnderlined", "linkTarget", "customClass", "click"]], template: function AgentTrainingMaterialsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, AgentTrainingMaterialsComponent_vnext_link_2_Template, 1, 2, "vnext-link", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, AgentTrainingMaterialsComponent_div_3_Template, 2, 1, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtemplate(5, AgentTrainingMaterialsComponent_div_5_Template, 2, 4, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 6)(7, "div", 7);
        i0.ɵɵtemplate(8, AgentTrainingMaterialsComponent_ng_container_8_Template, 2, 1, "ng-container", 8);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_Previous");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_AgentTrainingMaterials_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_PageSubHeader_Text");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.sortedTrainingMaterials);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, LinkComponent, NavigationAdapterDirective, LiveEditPropDirective, SafePipe], styles: [".materials-section[_ngcontent-%COMP%]{border-radius:5px;border:1px solid var(--static-Spa_Style_Accent1);text-align:left;margin-bottom:15px}.header-section[_ngcontent-%COMP%]{border-bottom:2px solid var(--static-Spa_Style_Accent1);border-top-left-radius:5px;border-top-right-radius:5px;padding:10px 15px}.body-section[_ngcontent-%COMP%]{padding:10px 15px}.link-wrapper[_ngcontent-%COMP%]{padding-bottom:10px}"], changeDetection: 0 });
__decorate([
    PlatformProp('live-edit')
], AgentTrainingMaterialsComponent.prototype, "Spa_Site_AgentTrainingMaterials_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentTrainingMaterialsComponent.prototype, "Spa_Site_PageSubHeader_Text", void 0);
__decorate([
    PlatformProp()
], AgentTrainingMaterialsComponent.prototype, "Spa_Site_AgentTrainingMaterials_Enabled", void 0);
__decorate([
    PlatformProp()
], AgentTrainingMaterialsComponent.prototype, "Spa_Site_Previous", void 0);
__decorate([
    PlatformProp()
], AgentTrainingMaterialsComponent.prototype, "Spa_AgentTrainingMaterials_JSON", void 0);
AgentTrainingMaterialsComponent = __decorate([
    PlatformWidget
], AgentTrainingMaterialsComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentTrainingMaterialsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-training-materials', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"col-12 c-mt-30 c-mb-30 container\">\r\n  <div class=\"col-auto mx-auto text-center\">\r\n    <vnext-link\r\n      [title]=\"Spa_Site_Previous\"\r\n      [showArrow]=\"'left'\"\r\n      (click)=\"backToPrevious()\"\r\n      (keyup.enter)=\"backToPrevious()\"\r\n      *liveEditProp=\"'Spa_Site_Previous'\"\r\n    >\r\n    </vnext-link>\r\n  </div>\r\n  <div class=\"Spa_Style_H1 c-mt-30 c-mb-30 text-center\" *liveEditProp=\"'Spa_Site_AgentTrainingMaterials_Text'\">\r\n    {{ Spa_Site_AgentTrainingMaterials_Text }}\r\n  </div>\r\n  <div class=\"row col-12 c-mb-30\">\r\n    <div\r\n      *liveEditProp=\"'Spa_Site_PageSubHeader_Text'\"\r\n      [innerHtml]=\"Spa_Site_PageSubHeader_Text ? (Spa_Site_PageSubHeader_Text | safe: 'html') : ''\"\r\n      navigationAdapter\r\n    ></div>\r\n  </div>\r\n  <div class=\"training-materials-container\">\r\n    <div class=\"row\">\r\n      <ng-container *ngFor=\"let section of sortedTrainingMaterials\">\r\n        <div class=\"materials-wrapper col-12 col-md-6\" *ngIf=\"section.display\">\r\n          <div class=\"materials-section\">\r\n            <div class=\"header-section Spa_Style_Bold_Weight Spa_Style_Gray1_Background Spa_Style_Primary_Color\">{{ section.title }}</div>\r\n            <div class=\"body-section\">\r\n              <div class=\"link-wrapper\" *ngFor=\"let link of section.materials\">\r\n                <vnext-link\r\n                  *ngIf=\"link.display\"\r\n                  [title]=\"link.title\"\r\n                  [href]=\"link.url\"\r\n                  [alwaysUnderlined]=\"true\"\r\n                  [linkTarget]=\"link.newTab === false ? '_self' : '_blank'\"\r\n                  [customClass]=\"'Spa_Style_Link Spa_Style_Small Spa_Style_Light_Weight'\"\r\n                  (click)=\"registerTrainingMaterialsClickEvent(link.title, link.url)\"\r\n                ></vnext-link>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".materials-section{border-radius:5px;border:1px solid var(--static-Spa_Style_Accent1);text-align:left;margin-bottom:15px}.header-section{border-bottom:2px solid var(--static-Spa_Style_Accent1);border-top-left-radius:5px;border-top-right-radius:5px;padding:10px 15px}.body-section{padding:10px 15px}.link-wrapper{padding-bottom:10px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.NavigationService }, { type: i1.LocaleService }, { type: i2$1.Router }, { type: AnalyticsService }]; }, { Spa_Site_AgentTrainingMaterials_Text: [], Spa_Site_PageSubHeader_Text: [], Spa_Site_AgentTrainingMaterials_Enabled: [], Spa_Site_Previous: [], Spa_AgentTrainingMaterials_JSON: [] }); })();

var ProgressStatus;
(function (ProgressStatus) {
    ProgressStatus["Completed"] = "completed";
    ProgressStatus["Open"] = "open";
})(ProgressStatus || (ProgressStatus = {}));

function ProgressStatusComponent_div_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 8)(2, "vnext-link", 9);
    i0.ɵɵlistener("click", function ProgressStatusComponent_div_0_ng_container_4_Template_vnext_link_click_2_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r5.navigateTo(ctx_r5.progressStatus)); })("keyup.Enter", function ProgressStatusComponent_div_0_ng_container_4_Template_vnext_link_keyup_Enter_2_listener() { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.navigateTo(ctx_r7.progressStatus)); });
    i0.ɵɵpipe(3, "titlecase");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(3, 3, ctx_r1.progressStatus == null ? null : ctx_r1.progressStatus.name));
    i0.ɵɵproperty("alwaysUnderlined", true)("makeInline", true);
} }
function ProgressStatusComponent_div_0_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "titlecase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r3.progressStatus == null ? null : ctx_r3.progressStatus.name));
} }
function ProgressStatusComponent_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, ctx_r4.progressStatus == null ? null : ctx_r4.progressStatus.modifiedWhen, "MM/dd/yyyy h:mm a"), "");
} }
const _c0$3h = function (a0, a1) { return { "fas Spa_Style_Accent5_Color": a0, "far": a1 }; };
function ProgressStatusComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵelement(2, "i", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵtemplate(4, ProgressStatusComponent_div_0_ng_container_4_Template, 4, 5, "ng-container", 5);
    i0.ɵɵtemplate(5, ProgressStatusComponent_div_0_ng_template_5_Template, 3, 3, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(7, ProgressStatusComponent_div_0_div_7_Template, 3, 4, "div", 7);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r2 = i0.ɵɵreference(6);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c0$3h, ctx_r0.progressStatus == null ? null : ctx_r0.progressStatus.modifiedWhen, !(ctx_r0.progressStatus == null ? null : ctx_r0.progressStatus.modifiedWhen)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isValidLink)("ngIfElse", _r2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.progressStatus == null ? null : ctx_r0.progressStatus.modifiedWhen);
} }
var ProgressNavigation;
(function (ProgressNavigation) {
    ProgressNavigation[ProgressNavigation["PROFILE_CREATED"] = 1] = "PROFILE_CREATED";
    ProgressNavigation[ProgressNavigation["PROVIDERS_UPDATED"] = 2] = "PROVIDERS_UPDATED";
    ProgressNavigation[ProgressNavigation["PRESCRIPTIONS_UPDATED"] = 3] = "PRESCRIPTIONS_UPDATED";
    ProgressNavigation[ProgressNavigation["PHARMACIES_UPDATED"] = 4] = "PHARMACIES_UPDATED";
    ProgressNavigation[ProgressNavigation["QUOTE_SENT"] = 5] = "QUOTE_SENT";
    ProgressNavigation[ProgressNavigation["PLAN_IN_CART"] = 6] = "PLAN_IN_CART";
    ProgressNavigation[ProgressNavigation["SEND_TO_BENEFICIARY"] = 7] = "SEND_TO_BENEFICIARY";
    ProgressNavigation[ProgressNavigation["ENROLLMENT_STARTED"] = 8] = "ENROLLMENT_STARTED";
    ProgressNavigation[ProgressNavigation["ENROLLMENT_COMPLETED"] = 9] = "ENROLLMENT_COMPLETED";
})(ProgressNavigation || (ProgressNavigation = {}));
class ProgressStatusComponent {
    constructor(analyticsService) {
        this.analyticsService = analyticsService;
        this.eventLinkClick = new EventEmitter();
        this.redirectRouteEvent = new EventEmitter();
        this.isValidLink = false;
        this.isProgressStatusEnabled = false;
        this.redirectRoute = PageTags.MEMBER_PROFILE_PAGE;
    }
    ngOnChanges(changes) {
        const { progressStatus, isProfilePage, providersEnabled, prescriptionsEnabled, pharmacyEnabled } = changes;
        if ((progressStatus && !_isEqual(progressStatus.currentValue, progressStatus.previousValue)) ||
            isProfilePage ||
            providersEnabled ||
            prescriptionsEnabled ||
            pharmacyEnabled) {
            this.isValidLink = this.isValidUrl();
            this.isProgressStatusEnabled = this.isStatusEnabled();
        }
    }
    isValidUrl() {
        return (this.progressStatus?.modifiedWhen &&
            (([
                ProgressNavigation.PROVIDERS_UPDATED,
                ProgressNavigation.PRESCRIPTIONS_UPDATED,
                ProgressNavigation.PHARMACIES_UPDATED,
                ProgressNavigation.PLAN_IN_CART
            ].includes(this.progressStatus.value) &&
                this.isProfilePage) ||
                ([
                    ProgressNavigation.PROFILE_CREATED,
                    ProgressNavigation.PROVIDERS_UPDATED,
                    ProgressNavigation.PRESCRIPTIONS_UPDATED,
                    ProgressNavigation.PHARMACIES_UPDATED,
                    ProgressNavigation.QUOTE_SENT,
                    ProgressNavigation.PLAN_IN_CART,
                    ProgressNavigation.SEND_TO_BENEFICIARY,
                    ProgressNavigation.ENROLLMENT_STARTED,
                    ProgressNavigation.ENROLLMENT_COMPLETED
                ].includes(this.progressStatus?.value) &&
                    !this.isProfilePage)));
    }
    isStatusEnabled() {
        return ([
            ProgressNavigation.PROFILE_CREATED,
            ProgressNavigation.QUOTE_SENT,
            ProgressNavigation.PLAN_IN_CART,
            ProgressNavigation.SEND_TO_BENEFICIARY,
            ProgressNavigation.ENROLLMENT_STARTED,
            ProgressNavigation.ENROLLMENT_COMPLETED
        ].includes(this.progressStatus?.value) ||
            (this.progressStatus?.value === ProgressNavigation.PROVIDERS_UPDATED && this.providersEnabled) ||
            (this.progressStatus?.value === ProgressNavigation.PRESCRIPTIONS_UPDATED && this.prescriptionsEnabled) ||
            (this.progressStatus?.value === ProgressNavigation.PHARMACIES_UPDATED && this.pharmacyEnabled));
    }
    navigateTo(progressStatus) {
        const statusId = progressStatus.value;
        const route = this.getRoute(statusId);
        const statusDate = progressStatus.modifiedWhen.split('T')[0];
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PROFILE_PROGRESS_TRACKER,
            [DataLayerGlobalVariable.PROFILE_PROGRESS_TRACKER_STATUS_NAMEPC]: route ?? this.redirectRoute,
            [DataLayerGlobalVariable.PROFILE_PROGRESS_TRACKER_STATUS_NAMEUI]: progressStatus.name,
            [DataLayerGlobalVariable.PROFILE_PROGRESS_TRACKER_STATUS_TYPE]: progressStatus.value ? ProgressStatus.Completed : ProgressStatus.Open,
            [DataLayerGlobalVariable.PROFILE_PROGRESS_TACKER_STATUS_DATE]: statusDate
        };
        if (route) {
            this.redirectRouteEvent.emit(route);
        }
        this.eventLinkClick.emit();
    }
    getRoute(progressStatus) {
        let route;
        switch (progressStatus) {
            case ProgressNavigation.PROVIDERS_UPDATED:
                route = PageTags.GUIDED_HELP_PROVIDER_SEARCH;
                break;
            case ProgressNavigation.PRESCRIPTIONS_UPDATED:
                route = PageTags.GUIDED_HELP_PRESCRIPTIONS;
                break;
            case ProgressNavigation.PHARMACIES_UPDATED:
                route = PageTags.GUIDED_HELP_PHARMACY_SEARCH;
                break;
            case ProgressNavigation.PLAN_IN_CART:
                route = PageTags.SHOPPING_CART;
                break;
            default:
                break;
        }
        return route;
    }
}
ProgressStatusComponent.ɵfac = function ProgressStatusComponent_Factory(t) { return new (t || ProgressStatusComponent)(i0.ɵɵdirectiveInject(AnalyticsService)); };
ProgressStatusComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProgressStatusComponent, selectors: [["vnext-progress-status"]], inputs: { progressStatus: "progressStatus", isProfilePage: "isProfilePage", prescriptionsEnabled: "prescriptionsEnabled", pharmacyEnabled: "pharmacyEnabled", providersEnabled: "providersEnabled" }, outputs: { eventLinkClick: "eventLinkClick", redirectRouteEvent: "redirectRouteEvent" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "row", 4, "ngIf"], [1, "row"], [1, "col-1", "px-0"], ["aria-hidden", "true", 1, "pr-2", "Spa_Style_Smaller_Font", "fa-circle", 3, "ngClass"], [1, "col-11", "pl-1", "pr-0", "progress-card-div"], [4, "ngIf", "ngIfElse"], ["showProgressLabel", ""], ["class", "Spa_Style_Note progress-card-status-date", 4, "ngIf"], [1, "Spa_Style_Note", "align-self-center", "progress-card-status-code"], [1, "text-content-wrap", "no-translate-block", 3, "alwaysUnderlined", "makeInline", "title", "click", "keyup.Enter"], [1, "Spa_Style_Note", "progress-card-status-date"]], template: function ProgressStatusComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ProgressStatusComponent_div_0_Template, 8, 7, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.isProgressStatusEnabled);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, LinkComponent, i1$2.TitleCasePipe, i1$2.DatePipe], styles: [".progress-card-status-date[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Gray4);opacity:.8}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressStatusComponent, [{
        type: Component,
        args: [{ selector: 'vnext-progress-status', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row\" *ngIf=\"isProgressStatusEnabled\">\r\n  <div class=\"col-1 px-0\">\r\n    <i\r\n      class=\"pr-2 Spa_Style_Smaller_Font fa-circle\"\r\n      [ngClass]=\"{ 'fas Spa_Style_Accent5_Color': progressStatus?.modifiedWhen, 'far': !progressStatus?.modifiedWhen }\"\r\n      aria-hidden=\"true\"\r\n    ></i>\r\n  </div>\r\n  <div class=\"col-11 pl-1 pr-0 progress-card-div\">\r\n    <ng-container *ngIf=\"isValidLink; else showProgressLabel\">\r\n      <div class=\"Spa_Style_Note align-self-center progress-card-status-code\"\r\n        ><vnext-link\r\n          class=\"text-content-wrap no-translate-block\"\r\n          (click)=\"navigateTo(progressStatus)\"\r\n          (keyup.Enter)=\"navigateTo(progressStatus)\"\r\n          [alwaysUnderlined]=\"true\"\r\n          [makeInline]=\"true\"\r\n          title=\"{{ progressStatus?.name | titlecase }}\"\r\n        >\r\n        </vnext-link\r\n      ></div>\r\n    </ng-container>\r\n    <ng-template #showProgressLabel>\r\n      <div class=\"Spa_Style_Note align-self-center progress-card-status-code\">{{ progressStatus?.name | titlecase }}</div>\r\n    </ng-template>\r\n    <div *ngIf=\"progressStatus?.modifiedWhen\" class=\"Spa_Style_Note progress-card-status-date\">\r\n      {{ progressStatus?.modifiedWhen | date : 'MM/dd/yyyy h:mm a' }}</div\r\n    >\r\n  </div>\r\n</div>\r\n", styles: [".progress-card-status-date{color:var(--static-Spa_Style_Gray4);opacity:.8}\n"] }]
    }], function () { return [{ type: AnalyticsService }]; }, { progressStatus: [{
            type: Input
        }], isProfilePage: [{
            type: Input
        }], prescriptionsEnabled: [{
            type: Input
        }], pharmacyEnabled: [{
            type: Input
        }], providersEnabled: [{
            type: Input
        }], eventLinkClick: [{
            type: Output
        }], redirectRouteEvent: [{
            type: Output
        }] }); })();

function MemberResultCardComponent_div_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, ",");
    i0.ɵɵelementContainerEnd();
} }
function MemberResultCardComponent_div_0_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 13);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "phone");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("href", "tel:", ctx_r6.member.homePhone, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("aria-label", (ctx_r6.member == null ? null : ctx_r6.member.firstName) + " " + (ctx_r6.member == null ? null : ctx_r6.member.lastName) + ": " + (ctx_r6.member == null ? null : ctx_r6.member.homePhone));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 3, ctx_r6.member.homePhone, ctx_r6.locale.slice(3)), " ");
} }
function MemberResultCardComponent_div_0_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.transferCodeLabelText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r7.member.memberProgressInfo.transferCode);
} }
function MemberResultCardComponent_div_0_ng_container_15_ng_container_1_div_1_vnext_progress_status_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-progress-status", 18);
    i0.ɵɵlistener("eventLinkClick", function MemberResultCardComponent_div_0_ng_container_15_ng_container_1_div_1_vnext_progress_status_1_Template_vnext_progress_status_eventLinkClick_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r16.linkClick.emit()); })("redirectRouteEvent", function MemberResultCardComponent_div_0_ng_container_15_ng_container_1_div_1_vnext_progress_status_1_Template_vnext_progress_status_redirectRouteEvent_0_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r18 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r18.redirectRouteEvent.emit($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const event_r14 = i0.ɵɵnextContext().$implicit;
    const ctx_r15 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("progressStatus", event_r14)("isProfilePage", ctx_r15.isProfilePage)("prescriptionsEnabled", ctx_r15.prescriptionsEnabled)("pharmacyEnabled", ctx_r15.pharmacyEnabled)("providersEnabled", ctx_r15.providersEnabled);
} }
function MemberResultCardComponent_div_0_ng_container_15_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MemberResultCardComponent_div_0_ng_container_15_ng_container_1_div_1_vnext_progress_status_1_Template, 1, 5, "vnext-progress-status", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const event_r14 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", event_r14.enabled);
} }
function MemberResultCardComponent_div_0_ng_container_15_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MemberResultCardComponent_div_0_ng_container_15_ng_container_1_div_1_Template, 2, 1, "div", 16);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r10.memberProgressEventTypes)("ngForTrackBy", ctx_r10.trackByProgressEvent);
} }
function MemberResultCardComponent_div_0_ng_container_15_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 19);
    i0.ɵɵlistener("click", function MemberResultCardComponent_div_0_ng_container_15_ng_template_2_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r20.fetchMemberProgressInfo()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("alwaysUnderlined", true)("makeInline", true)("title", ctx_r12.viewProgressLinkText);
} }
function MemberResultCardComponent_div_0_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MemberResultCardComponent_div_0_ng_container_15_ng_container_1_Template, 2, 2, "ng-container", 9);
    i0.ɵɵtemplate(2, MemberResultCardComponent_div_0_ng_container_15_ng_template_2_Template, 1, 3, "ng-template", null, 15, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r11 = i0.ɵɵreference(3);
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.isSearchByTransferCode || ctx_r8.hasMemberProgressInfoBeenRequested)("ngIfElse", _r11);
} }
function MemberResultCardComponent_div_0_div_16_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r23.agencyNameOrAgentUsername);
} }
function MemberResultCardComponent_div_0_div_16_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, MemberResultCardComponent_div_0_div_16_div_1_div_3_Template, 2, 1, "div", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r22.member.agentFirstName, " ", ctx_r22.member.agentLastName, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r22.agencyNameOrAgentUsername);
} }
function MemberResultCardComponent_div_0_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtemplate(1, MemberResultCardComponent_div_0_div_16_div_1_Template, 4, 3, "div", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.searchShowAgentUserName);
} }
function MemberResultCardComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "div")(3, "vnext-link", 5);
    i0.ɵɵlistener("click", function MemberResultCardComponent_div_0_Template_vnext_link_click_3_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r24.linkClick.emit()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵtext(5);
    i0.ɵɵtemplate(6, MemberResultCardComponent_div_0_ng_container_6_Template, 2, 0, "ng-container", 7);
    i0.ɵɵtext(7);
    i0.ɵɵelementStart(8, "div", 8)(9, "div");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, MemberResultCardComponent_div_0_ng_container_11_Template, 4, 6, "ng-container", 9);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(12, "div", 10);
    i0.ɵɵtemplate(13, MemberResultCardComponent_div_0_div_13_Template, 5, 2, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 11);
    i0.ɵɵtemplate(15, MemberResultCardComponent_div_0_ng_container_15_Template, 4, 2, "ng-container", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, MemberResultCardComponent_div_0_div_16_Template, 2, 1, "div", 12);
    i0.ɵɵelementStart(17, "div");
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "date");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("", ctx_r0.isAdminUser || ctx_r0.showAgentDetails ? "col-md-3" : "col-md-2", " col-12 align-self-start align-self-md-center pb-2 pb-md-0");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("title", "", ctx_r0.member.firstName, " ", ctx_r0.member.lastName, "");
    i0.ɵɵproperty("alwaysUnderlined", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3(" ", ctx_r0.member.address1, " ", ctx_r0.member.address2, " ", ctx_r0.member.city, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.member.address1 && ctx_r0.member.state);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r0.member.state, " ", ctx_r0.member.zip, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.member.primaryEmailAddress);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isMobile)("ngIfElse", _r3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r0.member.memberProgressInfo == null ? null : ctx_r0.member.memberProgressInfo.transferCode) && ctx_r0.isTransferCodeEnabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isMemberProgressEnabled && ctx_r0.isMemberProgressVisible);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isAdminUser || ctx_r0.showAgentDetails);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("", ctx_r0.isAdminUser || ctx_r0.showAgentDetails ? "col-md-2" : "col-md-3", " col-12 Spa_Style_Note align-self-start align-self-md-center pb-2 pb-md-0 text-left text-md-right");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r0.updated, " ", i0.ɵɵpipeBind2(19, 23, ctx_r0.member.profileDate, "MM/dd/yyyy"), " ");
} }
function MemberResultCardComponent_ng_template_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, ",");
    i0.ɵɵelementContainerEnd();
} }
function MemberResultCardComponent_ng_template_1_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 13);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "phone");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("href", "tel:", ctx_r27.member.homePhone, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("aria-label", (ctx_r27.member == null ? null : ctx_r27.member.firstName) + " " + (ctx_r27.member == null ? null : ctx_r27.member.lastName) + ": " + (ctx_r27.member == null ? null : ctx_r27.member.homePhone));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 3, ctx_r27.member.homePhone, ctx_r27.locale.slice(3)), " ");
} }
function MemberResultCardComponent_ng_template_1_div_19_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r30.agencyNameOrAgentUsername);
} }
function MemberResultCardComponent_ng_template_1_div_19_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, MemberResultCardComponent_ng_template_1_div_19_div_1_div_3_Template, 2, 1, "div", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r29.member.agentFirstName, " ", ctx_r29.member.agentLastName, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r29.agencyNameOrAgentUsername);
} }
function MemberResultCardComponent_ng_template_1_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtemplate(1, MemberResultCardComponent_ng_template_1_div_19_div_1_Template, 4, 3, "div", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r28.searchShowAgentUserName);
} }
const _c0$3g = function (a0, a1) { return { Spa_Style_Accent3_Color: a0, Spa_Style_Accent5_Color: a1 }; };
function MemberResultCardComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23)(1, "div", 4)(2, "div")(3, "vnext-link", 24);
    i0.ɵɵlistener("click", function MemberResultCardComponent_ng_template_1_Template_vnext_link_click_3_listener() { i0.ɵɵrestoreView(_r32); const ctx_r31 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r31.linkClick.emit()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵtext(5);
    i0.ɵɵtemplate(6, MemberResultCardComponent_ng_template_1_ng_container_6_Template, 2, 0, "ng-container", 7);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div")(9, "div");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, MemberResultCardComponent_ng_template_1_ng_container_11_Template, 4, 6, "ng-container", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 25);
    i0.ɵɵelement(13, "i", 26);
    i0.ɵɵpipe(14, "uppercase");
    i0.ɵɵpipe(15, "uppercase");
    i0.ɵɵelementStart(16, "span", 27);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "titlecase");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(19, MemberResultCardComponent_ng_template_1_div_19_Template, 2, 1, "div", 12);
    i0.ɵɵelementStart(20, "div");
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "date");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("", ctx_r2.isAdminUser || ctx_r2.showAgentDetails ? "col-md-3" : "col-md-2", " col-12 align-self-start align-self-md-center pb-2 pb-md-0 no-translate-block");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("title", "", ctx_r2.member.firstName, " ", ctx_r2.member.lastName, "");
    i0.ɵɵproperty("alwaysUnderlined", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3(" ", ctx_r2.member.address1, " ", ctx_r2.member.address2, " ", ctx_r2.member.city, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.member.address1 && ctx_r2.member.state);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r2.member.state, " ", ctx_r2.member.zip, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("", ctx_r2.isAdminUser || ctx_r2.showAgentDetails ? "col-md-3" : "col-md-5", " col-12 Spa_Style_Note align-self-start align-self-md-center pb-2 pb-md-0 no-translate-block");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.member.primaryEmailAddress);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isMobile)("ngIfElse", _r3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(35, _c0$3g, i0.ɵɵpipeBind1(14, 26, ctx_r2.member.carrierStatus) === "REGISTRANT", i0.ɵɵpipeBind1(15, 28, ctx_r2.member.carrierStatus) === "APPLICANT"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 30, ctx_r2.member.carrierStatus));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.isAdminUser || ctx_r2.showAgentDetails);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("", ctx_r2.isAdminUser || ctx_r2.showAgentDetails ? "col-md-2" : "col-md-3", " col-12 Spa_Style_Note align-self-start align-self-md-center pb-2 pb-md-0 text-left text-md-right no-translate-block");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r2.updated, " ", i0.ɵɵpipeBind2(22, 32, ctx_r2.member.profileDate, "MM/dd/yyyy"), " ");
} }
function MemberResultCardComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "phone");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, ctx_r4.member.homePhone, ctx_r4.locale.slice(3)));
} }
class MemberResultCardComponent {
    constructor(cdr, agentService, elementRef) {
        this.cdr = cdr;
        this.agentService = agentService;
        this.elementRef = elementRef;
        this.isMemberProgressEnabled = false;
        this.isMemberProgressVisible = false;
        this.isTransferCodeEnabled = false;
        this.isProfilePage = false;
        this.isMobile = false;
        this.linkClick = new EventEmitter();
        this.redirectRouteEvent = new EventEmitter();
        this.memberProgressEventTypes = [];
        this.hasMemberProgressInfoBeenRequested = false;
    }
    ngOnChanges(changes) {
        const { member, agencyHierarchyEnabled, isSearchByTransferCode } = changes;
        const hasMemberChanged = member && !_isEqual(member.currentValue, member.previousValue);
        if (hasMemberChanged || (agencyHierarchyEnabled && agencyHierarchyEnabled.currentValue !== agencyHierarchyEnabled.previousValue)) {
            this.agencyNameOrAgentUsername = this.agencyHierarchyEnabled ? this.member.agencyName : this.member.agentUserName;
        }
        if (this.isMemberProgressEnabled &&
            (hasMemberChanged || (isSearchByTransferCode && isSearchByTransferCode.currentValue !== isSearchByTransferCode.previousValue))) {
            this.setProfileStatuses();
        }
    }
    trackByProgressEvent(index, progressEvent) {
        return progressEvent.value;
    }
    fetchMemberProgressInfo() {
        if (this.isMemberProgressEnabled && !this.hasMemberProgressInfoBeenRequested) {
            this.agentService
                .fetchMemberProgressInfo$(this.member.memberID)
                .pipe(take(1))
                .subscribe({
                next: () => {
                    this.hasMemberProgressInfoBeenRequested = true;
                    this.elementRef?.nativeElement?.scrollIntoView({
                        behavior: 'instant',
                        block: 'center',
                        inline: 'center'
                    });
                    this.cdr.markForCheck();
                }
            });
        }
    }
    setProfileStatuses() {
        this.memberProgressEventTypes = this.memberProgressEvents.map(event => {
            const statusDetail = this.member.memberProgressInfo?.memberProgressList?.find(progress => event.value === progress.statusEventId);
            return { ...event, modifiedWhen: statusDetail?.modifiedWhen || '' };
        });
    }
}
MemberResultCardComponent.ɵfac = function MemberResultCardComponent_Factory(t) { return new (t || MemberResultCardComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(i0.ElementRef)); };
MemberResultCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MemberResultCardComponent, selectors: [["vnext-member-result-card"]], inputs: { member: "member", updated: "updated", agencyHierarchyEnabled: "agencyHierarchyEnabled", locale: "locale", isAdminUser: "isAdminUser", showAgentDetails: "showAgentDetails", searchShowAgentUserName: "searchShowAgentUserName", isMemberProgressEnabled: "isMemberProgressEnabled", isMemberProgressVisible: "isMemberProgressVisible", transferCodeLabelText: "transferCodeLabelText", isTransferCodeEnabled: "isTransferCodeEnabled", isProfilePage: "isProfilePage", prescriptionsEnabled: "prescriptionsEnabled", pharmacyEnabled: "pharmacyEnabled", providersEnabled: "providersEnabled", memberProgressEvents: "memberProgressEvents", isSearchByTransferCode: "isSearchByTransferCode", viewProgressLinkText: "viewProgressLinkText", isMobile: "isMobile" }, outputs: { linkClick: "linkClick", redirectRouteEvent: "redirectRouteEvent" }, features: [i0.ɵɵNgOnChangesFeature], decls: 5, vars: 2, consts: [["class", "container no-translate-block", 4, "ngIf", "ngIfElse"], ["defaultResultCard", ""], ["showPhoneOnDesktop", ""], [1, "container", "no-translate-block"], [1, "row", "h-100", "flex-md-row", "flex-column", "align-items-start"], [1, "no-translate-block", 3, "alwaysUnderlined", "title", "click"], [1, "Spa_Style_Note", "no-translate-block"], [4, "ngIf"], [1, "Spa_Style_Note", "align-self-start", "align-self-md-center", "pb-2", "pb-md-0"], [4, "ngIf", "ngIfElse"], [1, "col-md-2", "col-12", "Spa_Style_Note", "align-self-start", "align-self-md-center", "pb-2", "pb-md-0", "text-left"], [1, "col-md-3", "col-12", "align-self-start", "align-self-md-center", "pb-2", "pb-md-0", "member-card-div"], ["class", "col-md-2 col-12 Spa_Style_Note align-self-start align-self-md-center pb-2 pb-md-0 text-break", 4, "ngIf"], [1, "Spa_Style_Note", 3, "href"], [1, "Spa_Style_Bold_Weight"], ["showViewProgressLink", ""], [4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "progressStatus", "isProfilePage", "prescriptionsEnabled", "pharmacyEnabled", "providersEnabled", "eventLinkClick", "redirectRouteEvent", 4, "ngIf"], [3, "progressStatus", "isProfilePage", "prescriptionsEnabled", "pharmacyEnabled", "providersEnabled", "eventLinkClick", "redirectRouteEvent"], [3, "alwaysUnderlined", "makeInline", "title", "click"], [1, "col-md-2", "col-12", "Spa_Style_Note", "align-self-start", "align-self-md-center", "pb-2", "pb-md-0", "text-break"], ["class", "no-translate-block", 4, "ngIf"], [1, "no-translate-block"], [1, "container"], [3, "alwaysUnderlined", "title", "click"], [1, "col-md-2", "col-12", "align-self-start", "align-self-md-center", "pb-2", "pb-md-0", "no-translate-block"], ["aria-hidden", "true", 1, "fas", "fa-circle", "pr-2", "Spa_Style_Smaller_Font", 3, "ngClass"], [1, "Spa_Style_Note", "align-self-center"], [1, "Spa_Style_Note"]], template: function MemberResultCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MemberResultCardComponent_div_0_Template, 20, 26, "div", 0);
        i0.ɵɵtemplate(1, MemberResultCardComponent_ng_template_1_Template, 23, 38, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(3, MemberResultCardComponent_ng_template_3_Template, 3, 4, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.isMemberProgressEnabled && ctx.isMemberProgressVisible || ctx.isTransferCodeEnabled)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, IconAriaAttributesDirective, ProgressStatusComponent, i1$2.UpperCasePipe, i1$2.TitleCasePipe, i1$2.DatePipe, PhonePipe], styles: [".container[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px}.row[_ngcontent-%COMP%]{min-height:60px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberResultCardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-member-result-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  class=\"container no-translate-block\"\r\n  *ngIf=\"(isMemberProgressEnabled && isMemberProgressVisible) || isTransferCodeEnabled; else defaultResultCard\"\r\n>\r\n  <div class=\"row h-100 flex-md-row flex-column align-items-start\">\r\n    <div class=\"{{ isAdminUser || showAgentDetails ? 'col-md-3' : 'col-md-2' }} col-12 align-self-start align-self-md-center pb-2 pb-md-0\">\r\n      <vnext-link\r\n        class=\"no-translate-block\"\r\n        [alwaysUnderlined]=\"true\"\r\n        title=\"{{ member.firstName }} {{ member.lastName }}\"\r\n        (click)=\"linkClick.emit()\"\r\n      ></vnext-link>\r\n      <div class=\"Spa_Style_Note no-translate-block\">\r\n        {{ member.address1 }} {{ member.address2 }} {{ member.city }}\r\n        <ng-container *ngIf=\"member.address1 && member.state\">,</ng-container>\r\n        {{ member.state }} {{ member.zip }}\r\n\r\n        <div class=\"Spa_Style_Note align-self-start align-self-md-center pb-2 pb-md-0\">\r\n          <div>{{ member.primaryEmailAddress }}</div>\r\n          <ng-container *ngIf=\"isMobile; else showPhoneOnDesktop\">\r\n            <a href=\"tel:{{ member.homePhone }}\" class=\"Spa_Style_Note\" [attr.aria-label]=\"member?.firstName + ' ' + member?.lastName + ': ' + member?.homePhone\">\r\n              {{ member.homePhone | phone : locale.slice(3) }}\r\n            </a>\r\n          </ng-container>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"col-md-2 col-12 Spa_Style_Note align-self-start align-self-md-center pb-2 pb-md-0 text-left\">\r\n      <div *ngIf=\"member.memberProgressInfo?.transferCode && isTransferCodeEnabled\">\r\n        <div class=\"Spa_Style_Bold_Weight\">\r\n          {{ transferCodeLabelText }}\r\n        </div>\r\n        <div>{{ member.memberProgressInfo.transferCode }}</div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"col-md-3 col-12 align-self-start align-self-md-center pb-2 pb-md-0 member-card-div\">\r\n      <ng-container *ngIf=\"isMemberProgressEnabled && isMemberProgressVisible\">\r\n        <ng-container *ngIf=\"isSearchByTransferCode || hasMemberProgressInfoBeenRequested; else showViewProgressLink\">\r\n          <div *ngFor=\"let event of memberProgressEventTypes; trackBy: trackByProgressEvent\">\r\n            <vnext-progress-status\r\n              *ngIf=\"event.enabled\"\r\n              [progressStatus]=\"event\"\r\n              [isProfilePage]=\"isProfilePage\"\r\n              [prescriptionsEnabled]=\"prescriptionsEnabled\"\r\n              [pharmacyEnabled]=\"pharmacyEnabled\"\r\n              [providersEnabled]=\"providersEnabled\"\r\n              (eventLinkClick)=\"linkClick.emit()\"\r\n              (redirectRouteEvent)=\"redirectRouteEvent.emit($event)\"\r\n            ></vnext-progress-status>\r\n          </div>\r\n        </ng-container>\r\n\r\n        <ng-template #showViewProgressLink>\r\n          <vnext-link (click)=\"fetchMemberProgressInfo()\" [alwaysUnderlined]=\"true\" [makeInline]=\"true\" [title]=\"viewProgressLinkText\">\r\n          </vnext-link>\r\n        </ng-template>\r\n      </ng-container>\r\n    </div>\r\n    <div\r\n      *ngIf=\"isAdminUser || showAgentDetails\"\r\n      class=\"col-md-2 col-12 Spa_Style_Note align-self-start align-self-md-center pb-2 pb-md-0 text-break\"\r\n    >\r\n      <div *ngIf=\"searchShowAgentUserName\" class=\"no-translate-block\">\r\n        <div>{{ member.agentFirstName }} {{ member.agentLastName }}</div>\r\n        <div *ngIf=\"agencyNameOrAgentUsername\">{{ agencyNameOrAgentUsername }}</div>\r\n      </div>\r\n    </div>\r\n    <div\r\n      class=\"{{\r\n        isAdminUser || showAgentDetails ? 'col-md-2' : 'col-md-3'\r\n      }} col-12 Spa_Style_Note align-self-start align-self-md-center pb-2 pb-md-0 text-left text-md-right\"\r\n    >\r\n      {{ updated }} {{ member.profileDate | date : 'MM/dd/yyyy' }}\r\n    </div>\r\n  </div>\r\n</div>\r\n<ng-template #defaultResultCard>\r\n  <div class=\"container\">\r\n    <div class=\"row h-100 flex-md-row flex-column align-items-start\">\r\n      <div\r\n        class=\"{{\r\n          isAdminUser || showAgentDetails ? 'col-md-3' : 'col-md-2'\r\n        }} col-12 align-self-start align-self-md-center pb-2 pb-md-0 no-translate-block\"\r\n      >\r\n        <vnext-link [alwaysUnderlined]=\"true\" title=\"{{ member.firstName }} {{ member.lastName }}\" (click)=\"linkClick.emit()\"></vnext-link>\r\n        <div class=\"Spa_Style_Note no-translate-block\">\r\n          {{ member.address1 }} {{ member.address2 }} {{ member.city }}\r\n          <ng-container *ngIf=\"member.address1 && member.state\">,</ng-container>\r\n          {{ member.state }} {{ member.zip }}\r\n        </div>\r\n      </div>\r\n\r\n      <div\r\n        class=\"{{\r\n          isAdminUser || showAgentDetails ? 'col-md-3' : 'col-md-5'\r\n        }} col-12 Spa_Style_Note align-self-start align-self-md-center pb-2 pb-md-0 no-translate-block\"\r\n      >\r\n        <div>{{ member.primaryEmailAddress }}</div>\r\n        <ng-container *ngIf=\"isMobile; else showPhoneOnDesktop\">\r\n          <a href=\"tel:{{ member.homePhone }}\" class=\"Spa_Style_Note\" [attr.aria-label]=\"member?.firstName + ' ' + member?.lastName + ': ' + member?.homePhone\">\r\n            {{ member.homePhone | phone : locale.slice(3) }}\r\n          </a>\r\n        </ng-container>\r\n      </div>\r\n      <div class=\"col-md-2 col-12 align-self-start align-self-md-center pb-2 pb-md-0 no-translate-block\">\r\n        <i\r\n          class=\"fas fa-circle pr-2 Spa_Style_Smaller_Font\"\r\n          [ngClass]=\"{\r\n            Spa_Style_Accent3_Color: (member.carrierStatus | uppercase) === 'REGISTRANT',\r\n            Spa_Style_Accent5_Color: (member.carrierStatus | uppercase) === 'APPLICANT'\r\n          }\"\r\n          aria-hidden=\"true\"\r\n        ></i\r\n        ><span class=\"Spa_Style_Note align-self-center\">{{ member.carrierStatus | titlecase }}</span>\r\n      </div>\r\n      <div\r\n        *ngIf=\"isAdminUser || showAgentDetails\"\r\n        class=\"col-md-2 col-12 Spa_Style_Note align-self-start align-self-md-center pb-2 pb-md-0 text-break\"\r\n      >\r\n        <div *ngIf=\"searchShowAgentUserName\" class=\"no-translate-block\">\r\n          <div>{{ member.agentFirstName }} {{ member.agentLastName }}</div>\r\n          <div *ngIf=\"agencyNameOrAgentUsername\">{{ agencyNameOrAgentUsername }}</div>\r\n        </div>\r\n      </div>\r\n      <div\r\n        class=\"{{\r\n          isAdminUser || showAgentDetails ? 'col-md-2' : 'col-md-3'\r\n        }} col-12 Spa_Style_Note align-self-start align-self-md-center pb-2 pb-md-0 text-left text-md-right no-translate-block\"\r\n      >\r\n        {{ updated }} {{ member.profileDate | date : 'MM/dd/yyyy' }}\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n<ng-template #showPhoneOnDesktop>\r\n  <div class=\"Spa_Style_Note\">{{ member.homePhone | phone : locale.slice(3) }}</div>\r\n</ng-template>\r\n", styles: [".container{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px}.row{min-height:60px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.AgentService }, { type: i0.ElementRef }]; }, { member: [{
            type: Input
        }], updated: [{
            type: Input
        }], agencyHierarchyEnabled: [{
            type: Input
        }], locale: [{
            type: Input
        }], isAdminUser: [{
            type: Input
        }], showAgentDetails: [{
            type: Input
        }], searchShowAgentUserName: [{
            type: Input
        }], isMemberProgressEnabled: [{
            type: Input
        }], isMemberProgressVisible: [{
            type: Input
        }], transferCodeLabelText: [{
            type: Input
        }], isTransferCodeEnabled: [{
            type: Input
        }], isProfilePage: [{
            type: Input
        }], prescriptionsEnabled: [{
            type: Input
        }], pharmacyEnabled: [{
            type: Input
        }], providersEnabled: [{
            type: Input
        }], memberProgressEvents: [{
            type: Input
        }], isSearchByTransferCode: [{
            type: Input
        }], viewProgressLinkText: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], linkClick: [{
            type: Output
        }], redirectRouteEvent: [{
            type: Output
        }] }); })();

function ReportListComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ReportListComponent_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 4)(2, "vnext-member-result-card", 5);
    i0.ɵɵlistener("linkClick", function ReportListComponent_ng_template_1_ng_container_0_Template_vnext_member_result_card_linkClick_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r8); const member_r6 = restoredCtx.$implicit; const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.linkClick.emit(member_r6)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const member_r6 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("locale", ctx_r5.locale)("updated", ctx_r5.updated)("member", member_r6)("isAdminUser", ctx_r5.isAdminUser)("agencyHierarchyEnabled", ctx_r5.agencyHierarchyEnabled)("showAgentDetails", ctx_r5.showAgentDetails)("searchShowAgentUserName", ctx_r5.searchShowAgentUserName)("agencyHierarchyEnabled", ctx_r5.agencyHierarchyEnabled);
} }
function ReportListComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ReportListComponent_ng_template_1_ng_container_0_Template, 3, 8, "ng-container", 3);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", ctx_r2.reportList);
} }
function ReportListComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "div", 7);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 1, ctx_r4.noResultsText, "html"), i0.ɵɵsanitizeHtml);
} }
class ReportListComponent {
    constructor() {
        this.linkClick = new EventEmitter();
    }
}
ReportListComponent.ɵfac = function ReportListComponent_Factory(t) { return new (t || ReportListComponent)(); };
ReportListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ReportListComponent, selectors: [["vnext-report-list"]], inputs: { reportList: "reportList", noResultsText: "noResultsText", updated: "updated", locale: "locale", isAdminUser: "isAdminUser", showAgentDetails: "showAgentDetails", agencyHierarchyEnabled: "agencyHierarchyEnabled", searchShowAgentUserName: "searchShowAgentUserName" }, outputs: { linkClick: "linkClick" }, decls: 5, vars: 3, consts: [[4, "ngIf", "ngIfThen", "ngIfElse"], ["searchResults", ""], ["noResults", ""], [4, "ngFor", "ngForOf"], [1, "my-3"], [3, "locale", "updated", "member", "isAdminUser", "agencyHierarchyEnabled", "showAgentDetails", "searchShowAgentUserName", "linkClick"], [1, "row", "flex-column", "align-items-center", "text-center", "py-5"], [3, "innerHTML"]], template: function ReportListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ReportListComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        i0.ɵɵtemplate(1, ReportListComponent_ng_template_1_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(3, ReportListComponent_ng_template_3_Template, 3, 4, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        const _r3 = i0.ɵɵreference(4);
        i0.ɵɵproperty("ngIf", ctx.reportList.length > 0)("ngIfThen", _r1)("ngIfElse", _r3);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, MemberResultCardComponent, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReportListComponent, [{
        type: Component,
        args: [{ selector: 'vnext-report-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"reportList.length > 0; then searchResults; else noResults\"></ng-container>\r\n\r\n<ng-template #searchResults>\r\n  <ng-container *ngFor=\"let member of reportList\">\r\n    <div class=\"my-3\">\r\n      <vnext-member-result-card\r\n        [locale]=\"locale\"\r\n        [updated]=\"updated\"\r\n        [member]=\"member\"\r\n        [isAdminUser]=\"isAdminUser\"\r\n        [agencyHierarchyEnabled]=\"agencyHierarchyEnabled\"\r\n        [showAgentDetails]=\"showAgentDetails\"\r\n        [searchShowAgentUserName]=\"searchShowAgentUserName\"\r\n        [agencyHierarchyEnabled]=\"agencyHierarchyEnabled\"\r\n        (linkClick)=\"linkClick.emit(member)\"\r\n      ></vnext-member-result-card>\r\n    </div>\r\n  </ng-container>\r\n</ng-template>\r\n\r\n<ng-template #noResults>\r\n  <div class=\"row flex-column align-items-center text-center py-5\">\r\n    <div [innerHTML]=\"noResultsText | safe: 'html'\"></div>\r\n  </div>\r\n</ng-template>\r\n" }]
    }], null, { reportList: [{
            type: Input
        }], noResultsText: [{
            type: Input
        }], updated: [{
            type: Input
        }], locale: [{
            type: Input
        }], isAdminUser: [{
            type: Input
        }], showAgentDetails: [{
            type: Input
        }], agencyHierarchyEnabled: [{
            type: Input
        }], searchShowAgentUserName: [{
            type: Input
        }], linkClick: [{
            type: Output
        }] }); })();

var SearchPlaceholder;
(function (SearchPlaceholder) {
    SearchPlaceholder["DateRangeMax"] = "<dateRangeMax>";
    SearchPlaceholder["FieldName"] = "<fieldName>";
})(SearchPlaceholder || (SearchPlaceholder = {}));
var SearchType;
(function (SearchType) {
    SearchType["Enrollment"] = "enrollment";
    SearchType["HRA"] = "hra";
    SearchType["SOA"] = "soa";
})(SearchType || (SearchType = {}));
const AGENT_REPORT_RESULTS_FILENAME = 'Search-Report';
const AGENT_REPORT_FILE_TYPE = '.csv';
const AGENT_REPORT_RESULTS_FILE_EXTENSION = 'text/csv';
const REPORT_SEARCH_RESULTS_FILE_COLUMN_FIELDS = [
    'confirmationNumber',
    'agentFirstName',
    'agentLastName',
    'carrierName',
    'plan',
    'contractPlanSegment',
    'planType',
    'planSubType',
    'planSNPType',
    'riderNames',
    'submissionDate',
    'requestedEffectiveDate',
    'effectiveDate',
    'agentUsername',
    'partnerID',
    'agencyID',
    'agentID',
    'agentProducerID'
];
const REPORT_SEARCH_RESULTS_FILE_COLUMN_HEADINGS = [
    'Confirmation Number',
    'First Name',
    'Last Name',
    'Carrier Name',
    'Plan',
    'Contract Plan Segment',
    'Plan Type',
    'Plan Sub Type',
    'Plan SS Type',
    'Rider Names',
    'Submission Date',
    'Requested Effective date',
    'EffectiveDate',
    'Agent Username',
    'partner ID',
    'Agency ID',
    'Agent ID',
    'AgentProducer ID'
];
var REPORT_SEARCH_CALL_RECORD_COLUMN;
(function (REPORT_SEARCH_CALL_RECORD_COLUMN) {
    REPORT_SEARCH_CALL_RECORD_COLUMN["CALL_RECORD_HEADER"] = "Recording Available";
    REPORT_SEARCH_CALL_RECORD_COLUMN["CALL_RECORD_COLUMN_FIELD"] = "recordingAvailable";
})(REPORT_SEARCH_CALL_RECORD_COLUMN || (REPORT_SEARCH_CALL_RECORD_COLUMN = {}));
var REPORT_SEARCH_ENROLLMENT_STATUS_COLUMN;
(function (REPORT_SEARCH_ENROLLMENT_STATUS_COLUMN) {
    REPORT_SEARCH_ENROLLMENT_STATUS_COLUMN["ENROLLMENT_STATUS_HEADER"] = "Enrollment Status";
    REPORT_SEARCH_ENROLLMENT_STATUS_COLUMN["ENROLLMENT_STATUS_COLUMN_FIELD"] = "enrollmentStatus";
})(REPORT_SEARCH_ENROLLMENT_STATUS_COLUMN || (REPORT_SEARCH_ENROLLMENT_STATUS_COLUMN = {}));
var REPORT_SEARCH_ENROLLMENT_STATUS_UPDATE_COLUMN;
(function (REPORT_SEARCH_ENROLLMENT_STATUS_UPDATE_COLUMN) {
    REPORT_SEARCH_ENROLLMENT_STATUS_UPDATE_COLUMN["ENROLLMENT_STATUS_UPDATE_HEADER"] = "Status Update Date";
    REPORT_SEARCH_ENROLLMENT_STATUS_UPDATE_COLUMN["ENROLLMENT_STATUS_UPDATE_COLUMN_FIELD"] = "statusUpdateDate";
})(REPORT_SEARCH_ENROLLMENT_STATUS_UPDATE_COLUMN || (REPORT_SEARCH_ENROLLMENT_STATUS_UPDATE_COLUMN = {}));
const SearchTypeItems = [
    {
        displayValue: 'Enrollment',
        selectionValue: SearchType.Enrollment
    },
    {
        displayValue: 'HRA',
        selectionValue: SearchType.HRA
    },
    {
        displayValue: 'SOA',
        selectionValue: SearchType.SOA
    }
];
var SNP_TYPE;
(function (SNP_TYPE) {
    SNP_TYPE["NOT_SNP"] = "NOT_SNP";
    SNP_TYPE["SNP"] = "SNP";
})(SNP_TYPE || (SNP_TYPE = {}));
var EnrollmentType;
(function (EnrollmentType) {
    EnrollmentType["Medicare"] = "medicare";
    EnrollmentType["MedicareSupplement"] = "medigap";
    EnrollmentType["Ancillary"] = "ancillary";
})(EnrollmentType || (EnrollmentType = {}));
const EnrollmentTypeItems = [
    {
        displayValue: 'Medicare',
        selectionValue: EnrollmentType.Medicare
    },
    {
        displayValue: 'Medicare Supplement',
        selectionValue: EnrollmentType.MedicareSupplement
    },
    {
        displayValue: 'Ancillary',
        selectionValue: EnrollmentType.Ancillary
    }
];
class ReportSelectedFilter {
}

class ReportSearchFormFacade {
    constructor(formValidationService, configResourceService) {
        this.formValidationService = formValidationService;
        this.configResourceService = configResourceService;
        this.formInputConfig = this.getFormInputConfig();
        this.errorMessages = this.getErrorMessagesConfig();
        this.formatErrorKeys = [
            ReportSearchFormFacade.maskErrorKey,
            ReportSearchFormFacade.minLengthErrorKey,
            ReportSearchFormFacade.maxLengthErrorKey,
            ReportSearchFormFacade.invalidDateErrorKey
        ];
        this.dateRangeErrorKeys = [
            ReportSearchFormFacade.minDateErrorKey,
            ReportSearchFormFacade.maxDateErrorKey,
            ReportSearchFormFacade.dateOutOfRange
        ];
    }
    getSearchForm(options) {
        const { maxAllowedDays, minDate, maxDate, isAdminUser, agencyHierarchyEnabled, isAgentUsernameFieldEnabled, isAgentUsernameFieldRequired, agencyNameFieldEnabled, agencyNameFieldRequired } = options;
        const fromDateControl = new UntypedFormControl('', { updateOn: 'blur' });
        const toDateControl = new UntypedFormControl('', { updateOn: 'blur' });
        fromDateControl.setValue(DateUtilities.getPreviousDate(new Date(), options.maxAllowedDays));
        fromDateControl.markAsDirty();
        toDateControl.setValue(DateUtilities.getPreviousDate(new Date(), 1));
        toDateControl.markAsDirty();
        fromDateControl.setValidators([
            Validators.required,
            Validators.maxLength(10),
            Validators.minLength(10),
            this.formValidationService.validDate(),
            this.formValidationService.minDate({ minDate }),
            this.formValidationService.maxDate({ maxDate, dateControl: toDateControl }),
            this.formValidationService.dateRange({ dateControl: toDateControl, maxAllowedDays, order: 'asc' })
        ]);
        toDateControl.setValidators([
            Validators.required,
            Validators.maxLength(10),
            Validators.minLength(10),
            this.formValidationService.validDate(),
            this.formValidationService.minDate({ minDate, dateControl: fromDateControl }),
            this.formValidationService.maxDate({ maxDate }),
            this.formValidationService.dateRange({ dateControl: fromDateControl, maxAllowedDays, order: 'desc' })
        ]);
        const searchForm = new UntypedFormGroup({
            [ReportSearchFormFacade.fromDateControlName]: fromDateControl,
            [ReportSearchFormFacade.toDateControlName]: toDateControl,
            [ReportSearchFormFacade.searchTypeControlName]: new UntypedFormControl('', { validators: [Validators.required], updateOn: 'blur' })
        }, { updateOn: 'blur' });
        if (agencyHierarchyEnabled) {
            if (isAdminUser && agencyNameFieldEnabled) {
                searchForm.addControl(ReportSearchFormFacade.agencyGuidControlName, new UntypedFormControl('', {
                    updateOn: 'blur'
                }));
                if (agencyNameFieldRequired) {
                    searchForm.controls[ReportSearchFormFacade.agencyGuidControlName].setValidators([Validators.required]);
                }
            }
        }
        else if (isAdminUser && isAgentUsernameFieldEnabled) {
            searchForm.addControl(ReportSearchFormFacade.agentUsernameControlName, new UntypedFormControl('', {
                validators: [Validators.maxLength(AGENT_USERNAME_MAX_LENGTH)],
                updateOn: 'blur'
            }));
            if (isAgentUsernameFieldRequired) {
                searchForm.controls[ReportSearchFormFacade.agentUsernameControlName].setValidators([Validators.required]);
            }
        }
        return searchForm;
    }
    getErrorMessagesConfig() {
        return {
            dateRange: {
                required: this.configResourceService.getProcessedResourceValue('Spa_Site_AgentReports_RequiredField_Error', null, `Please provide ${SearchPlaceholder.FieldName}`),
                invalid: this.configResourceService.getProcessedResourceValue('Spa_Site_AgentReports_DateRangeInvalid_Error', null, `${SearchPlaceholder.FieldName} is invalid`),
                invalidDateRange: this.configResourceService.getProcessedResourceValue('Spa_Site_AgentReports_DateRangeInvalid_Error', null, `${SearchPlaceholder.FieldName} is invalid`),
                invalidDateOutOfRange: this.configResourceService.getProcessedResourceValue('Spa_Site_AgentReports_DateOutOfRange_Error', null, `Date range must be ${SearchPlaceholder.DateRangeMax} days or less`),
                invalidFutureDateRange: this.configResourceService.getProcessedResourceValue('Spa_Site_AgentReports_FutureDateRange_Error', null, `${SearchPlaceholder.FieldName} must be in the past`),
                invalidDateTooFarInPast: this.configResourceService.getProcessedResourceValue('Spa_Site_AgentReports_DateTooFarInThePast_Error', null, `${SearchPlaceholder.FieldName} is too far in the past`)
            },
            agentUsername: {
                required: this.configResourceService.getProcessedResourceValue('Spa_Site_AgentReports_RequiredField_Error', null, `Please provide ${SearchPlaceholder.FieldName}`),
                invalid: this.configResourceService.getProcessedResourceValue('Spa_Site_AgentReports_DateRangeInvalid_Error', null, `${SearchPlaceholder.FieldName} is invalid`)
            },
            agencyName: {
                required: this.configResourceService.getProcessedResourceValue('Spa_Site_AgentReports_RequiredField_Error', null, `Please provide ${SearchPlaceholder.FieldName}`)
            },
            searchType: {
                required: this.configResourceService.getProcessedResourceValue('Spa_Site_AgentReports_RequiredField_Error', null, `Please provide ${SearchPlaceholder.FieldName}`)
            },
            enrollmentType: {
                required: this.configResourceService.getProcessedResourceValue('Spa_Site_AgentReports_RequiredField_Error', null, `Please provide ${SearchPlaceholder.FieldName}`)
            }
        };
    }
    getFormInputConfig() {
        return {
            dateRange: {
                labelText: this.configResourceService.getProcessedResourceValue('Spa_AgentReports_SubmittedDateRange_Label', null, 'Submitted date range')
            },
            agentUsername: {
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_Search_AgentUserName_Text', null, 'Agent Username')
            },
            agencyName: {
                labelText: this.configResourceService.getProcessedResourceValue('Spa_Agent_AccountOverview_AgencyName_Text', null, 'Agency Name')
            },
            searchType: {
                labelText: this.configResourceService.getProcessedResourceValue('Spa_AgentReports_Type_Label', null, 'Type')
            },
            enrollmentType: {
                labelText: this.configResourceService.getProcessedResourceValue('Spa_AgentReports_EnrollmentType_Label', null, 'Enrollment type')
            }
        };
    }
    addControlEnrollmentType(form) {
        if (!form.contains(ReportSearchFormFacade.enrollmentTypeControlName)) {
            form.addControl(ReportSearchFormFacade.enrollmentTypeControlName, new UntypedFormControl('', { validators: [Validators.required], updateOn: 'blur' }));
        }
    }
    removeControlEnrollmentType(form) {
        if (form.contains(ReportSearchFormFacade.enrollmentTypeControlName)) {
            form.removeControl(ReportSearchFormFacade.enrollmentTypeControlName);
        }
    }
    getErrorMessages(control, controlName) {
        let errors = {};
        this.formInputConfig = this.getFormInputConfig();
        this.errorMessages = this.getErrorMessagesConfig();
        if (control.dirty || control.touched) {
            if (control.hasError(ReportSearchFormFacade.requiredErrorKey)) {
                const inputConfig = this.formInputConfig[controlName];
                const placeholders = [{ placeholder: SearchPlaceholder.FieldName, value: inputConfig.labelText }];
                errors = {
                    required: this.replaceTextPlaceholder(this.errorMessages[controlName].required, placeholders)
                };
            }
            else if (this.hasControlSomeError(control, this.formatErrorKeys)) {
                const inputConfig = this.formInputConfig[controlName];
                const placeholders = [{ placeholder: SearchPlaceholder.FieldName, value: inputConfig.labelText }];
                errors = {
                    invalid: this.replaceTextPlaceholder(this.errorMessages[controlName].invalid, placeholders)
                };
            }
        }
        return errors;
    }
    getDateRangeErrorMessages(searchForm, minDate, maxDate, maxAllowedDays) {
        const controlName = ReportSearchFormFacade.dateRangeControlName;
        const fromDateControl = searchForm.get(ReportSearchFormFacade.fromDateControlName);
        const toDateControl = searchForm.get(ReportSearchFormFacade.toDateControlName);
        let errors = {
            ...this.getErrorMessages(fromDateControl, controlName),
            ...this.getErrorMessages(toDateControl, controlName)
        };
        if (Object.keys(errors).length === 0) {
            const inputConfig = this.formInputConfig.dateRange;
            let placeholders = [{ placeholder: SearchPlaceholder.FieldName, value: inputConfig.labelText }];
            if (toDateControl.hasError(ReportSearchFormFacade.maxDateErrorKey) ||
                (fromDateControl.hasError(ReportSearchFormFacade.maxDateErrorKey) && DateUtilities.dateAfter(fromDateControl.value, maxDate))) {
                errors = {
                    invalidFutureDateRange: this.replaceTextPlaceholder(this.errorMessages[controlName].invalidFutureDateRange, placeholders)
                };
            }
            else if (fromDateControl.hasError(ReportSearchFormFacade.minDateErrorKey) ||
                (toDateControl.hasError(ReportSearchFormFacade.minDateErrorKey) && DateUtilities.dateBefore(toDateControl.value, minDate))) {
                errors = {
                    invalidDateTooFarInPast: this.replaceTextPlaceholder(this.errorMessages[controlName].invalidDateTooFarInPast, placeholders)
                };
            }
            else if (fromDateControl.hasError(ReportSearchFormFacade.maxDateErrorKey) &&
                toDateControl.hasError(ReportSearchFormFacade.minDateErrorKey)) {
                errors = {
                    invalidDateRange: this.replaceTextPlaceholder(this.errorMessages[controlName].invalidDateRange, placeholders)
                };
            }
            else if (fromDateControl.hasError(ReportSearchFormFacade.dateOutOfRange) ||
                toDateControl.hasError(ReportSearchFormFacade.dateOutOfRange)) {
                placeholders = [{ placeholder: SearchPlaceholder.DateRangeMax, value: maxAllowedDays }];
                errors = {
                    invalidDateOutOfRange: this.replaceTextPlaceholder(this.errorMessages[controlName].invalidDateOutOfRange, placeholders)
                };
            }
        }
        return errors;
    }
    isControlInvalid(dateControl) {
        return dateControl.invalid && (dateControl.dirty || dateControl.touched);
    }
    hasControlSomeError(control, errorKeys) {
        return errorKeys.some(errorKey => control.hasError(errorKey));
    }
    formHasErrorMessages(formErrors, options) {
        let selectedFormErrors = Object.entries(formErrors);
        if (options) {
            selectedFormErrors = selectedFormErrors.filter(([controlName]) => !options.omittedKeys.includes(controlName));
        }
        return selectedFormErrors.some(([_controlName, errorMessages]) => errorMessages.length > 0);
    }
    getDateMaskFormat() {
        return DateUtilities.defaultFormat.replace('DD', 'd0').replace('MM', 'M0').replace('YYYY', '0000');
    }
    parseDateToNgbDate(date) {
        return DateUtilities.parseDateToNgbDate(date);
    }
    getNgbDate(subtractAmount) {
        const date = dayjs().subtract(+subtractAmount, 'days');
        return DateUtilities.parseDayJSToNgbDate(date);
    }
    replaceTextPlaceholder(originalText = '', placeholders) {
        return placeholders.reduce((text, { placeholder, value }) => text.replace(placeholder, value), originalText);
    }
    markFormAsTouched(form) {
        Object.values(form.controls).forEach(control => {
            control.markAsTouched();
            control.updateValueAndValidity();
        });
    }
    getFormattedDate(ngbDate) {
        return DateUtilities.getDefaultFormattedDate(ngbDate);
    }
}
ReportSearchFormFacade.fromDateControlName = 'applicationStartDate';
ReportSearchFormFacade.toDateControlName = 'applicationEndDate';
ReportSearchFormFacade.dateRangeControlName = 'dateRange';
ReportSearchFormFacade.agentUsernameControlName = 'agentUsername';
ReportSearchFormFacade.agencyGuidControlName = 'agencyGuid';
ReportSearchFormFacade.searchTypeControlName = 'searchType';
ReportSearchFormFacade.enrollmentTypeControlName = 'enrollmentType';
ReportSearchFormFacade.minDateErrorKey = 'minDate';
ReportSearchFormFacade.maxDateErrorKey = 'maxDate';
ReportSearchFormFacade.dateOutOfRange = 'dateOutOfRange';
ReportSearchFormFacade.requiredErrorKey = 'required';
ReportSearchFormFacade.maskErrorKey = 'mask';
ReportSearchFormFacade.minLengthErrorKey = 'minlength';
ReportSearchFormFacade.maxLengthErrorKey = 'maxlength';
ReportSearchFormFacade.invalidDateErrorKey = 'invalidDate';
ReportSearchFormFacade.ɵfac = function ReportSearchFormFacade_Factory(t) { return new (t || ReportSearchFormFacade)(i0.ɵɵinject(i1.FormValidationService), i0.ɵɵinject(i1.ConfigResourceService)); };
ReportSearchFormFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ReportSearchFormFacade, factory: ReportSearchFormFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReportSearchFormFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.FormValidationService }, { type: i1.ConfigResourceService }]; }, null); })();

function ReportSearchComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 23);
} }
function ReportSearchComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelement(1, "vnext-widget-field-errors", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("errors", ctx_r1.formErrors.dateRange)("showInline", true);
} }
function ReportSearchComponent_ng_container_20_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 23);
} }
const _c0$3f = function (a0) { return [a0]; };
const _c1$1K = function (a0) { return { omittedKeys: a0 }; };
function ReportSearchComponent_ng_container_20_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵtemplate(2, ReportSearchComponent_ng_container_20_ng_container_1_div_2_Template, 1, 0, "div", 4);
    i0.ɵɵelementStart(3, "vnext-dropdown-button", 27);
    i0.ɵɵlistener("dropdownButtonBlur", function ReportSearchComponent_ng_container_20_ng_container_1_Template_vnext_dropdown_button_dropdownButtonBlur_3_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.validate({ controlName: ctx_r11.agencyGuidControlName })); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r9.formHasErrorMessages(i0.ɵɵpureFunction1(13, _c1$1K, i0.ɵɵpureFunction1(11, _c0$3f, ctx_r9.agencyGuidControlName))) && !(ctx_r9.formErrors[ctx_r9.agencyGuidControlName] == null ? null : ctx_r9.formErrors[ctx_r9.agencyGuidControlName].length));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("control", ctx_r9.searchForm.get(ctx_r9.agencyGuidControlName))("ariaLabelledById", ctx_r9.controlNameRecord[ctx_r9.reportSearchFormFacade.agencyGuidControlName])("isRequired", ctx_r9.agencyNameFieldRequired)("dropdownLabel", ctx_r9.agencyNameLabel)("dropdownItems", ctx_r9.agencyItems)("dropdownDefaultText", ctx_r9.agencyItems.length > 0 ? "" : ctx_r9.noneAvailableLabel)("disabled", ctx_r9.agencyItems.length === 0)("offsetItems", 10)("errors", ctx_r9.formErrors[ctx_r9.agencyGuidControlName])("customClass", "no-translate-block");
} }
function ReportSearchComponent_ng_container_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ReportSearchComponent_ng_container_20_ng_container_1_Template, 4, 15, "ng-container", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isAdminUser && ctx_r2.agencyNameFieldEnabled);
} }
function ReportSearchComponent_ng_template_21_ng_container_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 23);
} }
function ReportSearchComponent_ng_template_21_ng_container_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelement(1, "vnext-widget-field-errors", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("errors", ctx_r15.formErrors[ctx_r15.agentUsernameControlName])("showInline", false);
} }
function ReportSearchComponent_ng_template_21_ng_container_0_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
const _c2$14 = function (a0) { return { controlName: a0 }; };
const _c3$L = function (a0) { return { "label-error": a0 }; };
const _c4$r = function (a0) { return { "has-error": a0 }; };
function ReportSearchComponent_ng_template_21_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 26)(2, "div", 3);
    i0.ɵɵtemplate(3, ReportSearchComponent_ng_template_21_ng_container_0_div_3_Template, 1, 0, "div", 4);
    i0.ɵɵtemplate(4, ReportSearchComponent_ng_template_21_ng_container_0_div_4_Template, 2, 2, "div", 5);
    i0.ɵɵelementStart(5, "label", 28);
    i0.ɵɵtemplate(6, ReportSearchComponent_ng_template_21_ng_container_0_span_6_Template, 2, 0, "span", 29);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 30)(9, "input", 31);
    i0.ɵɵlistener("blur", function ReportSearchComponent_ng_template_21_ng_container_0_Template_input_blur_9_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.validate({ controlName: ctx_r17.agentUsernameControlName })); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r13.formHasErrorMessages(i0.ɵɵpureFunction1(11, _c1$1K, i0.ɵɵpureFunction1(9, _c0$3f, ctx_r13.agentUsernameControlName))) && !ctx_r13.formErrors[ctx_r13.agentUsernameControlName].length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.isControlInvalid(i0.ɵɵpureFunction1(13, _c2$14, ctx_r13.agentUsernameControlName)) && ctx_r13.formErrors[ctx_r13.agentUsernameControlName].length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", ctx_r13.controlNameRecord[ctx_r13.reportSearchFormFacade.agentUsernameControlName])("ngClass", i0.ɵɵpureFunction1(17, _c3$L, ctx_r13.isControlInvalid(i0.ɵɵpureFunction1(15, _c2$14, ctx_r13.agentUsernameControlName)) && (ctx_r13.formErrors[ctx_r13.agentUsernameControlName] == null ? null : ctx_r13.formErrors[ctx_r13.agentUsernameControlName].length) > 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.agentUsernameFieldRequired);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.agentUsernameLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r13.controlNameRecord[ctx_r13.reportSearchFormFacade.agentUsernameControlName])("formControlName", ctx_r13.agentUsernameControlName)("ngClass", i0.ɵɵpureFunction1(21, _c4$r, ctx_r13.isControlInvalid(i0.ɵɵpureFunction1(19, _c2$14, ctx_r13.agentUsernameControlName))));
} }
function ReportSearchComponent_ng_template_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ReportSearchComponent_ng_template_21_ng_container_0_Template, 10, 23, "ng-container", 19);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r4.isAdminUser && ctx_r4.agentUsernameFieldEnabled);
} }
function ReportSearchComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 23);
} }
function ReportSearchComponent_ng_container_26_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 23);
} }
function ReportSearchComponent_ng_container_26_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵtemplate(2, ReportSearchComponent_ng_container_26_div_2_Template, 1, 0, "div", 4);
    i0.ɵɵelementStart(3, "vnext-dropdown-button", 33);
    i0.ɵɵlistener("dropdownButtonBlur", function ReportSearchComponent_ng_container_26_Template_vnext_dropdown_button_dropdownButtonBlur_3_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.validate({ controlName: ctx_r20.enrollmentTypeControlName })); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r6.formHasErrorMessages(i0.ɵɵpureFunction1(8, _c1$1K, i0.ɵɵpureFunction1(6, _c0$3f, ctx_r6.enrollmentTypeControlName))) && !ctx_r6.formErrors[ctx_r6.enrollmentTypeControlName].length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("control", ctx_r6.searchForm.get(ctx_r6.enrollmentTypeControlName))("ariaLabelledById", ctx_r6.controlNameRecord[ctx_r6.reportSearchFormFacade.enrollmentTypeControlName])("dropdownLabel", ctx_r6.enrollmentTypeLabel)("dropdownItems", ctx_r6.enrollmentTypesItems)("errors", ctx_r6.formErrors[ctx_r6.enrollmentTypeControlName]);
} }
function ReportSearchComponent_ng_container_27_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 34)(2, "div", 35)(3, "vnext-dropdown-button", 33);
    i0.ɵɵlistener("dropdownButtonBlur", function ReportSearchComponent_ng_container_27_Template_vnext_dropdown_button_dropdownButtonBlur_3_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r22.validate({ controlName: ctx_r22.enrollmentTypeControlName })); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("control", ctx_r7.searchForm.get(ctx_r7.enrollmentTypeControlName))("ariaLabelledById", ctx_r7.controlNameRecord[ctx_r7.reportSearchFormFacade.enrollmentTypeControlName])("dropdownLabel", ctx_r7.enrollmentTypeLabel)("dropdownItems", ctx_r7.enrollmentTypesItems)("errors", ctx_r7.formErrors[ctx_r7.enrollmentTypeControlName]);
} }
function ReportSearchComponent_button_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 36);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.runReportButtonText, " ");
} }
const _c5$g = function (a0) { return { "mb-5": a0 }; };
const _c6$f = function (a0, a1) { return [a0, a1]; };
class ReportSearchComponent {
    constructor(reportSearchFacade, analyticsService) {
        this.reportSearchFacade = reportSearchFacade;
        this.analyticsService = analyticsService;
        this.runSearch = new EventEmitter();
        this.controlNameRecord = {
            [ReportSearchFormFacade.fromDateControlName]: `${ReportSearchFormFacade.fromDateControlName}_input`,
            [ReportSearchFormFacade.toDateControlName]: `${ReportSearchFormFacade.toDateControlName}_input`,
            [ReportSearchFormFacade.agentUsernameControlName]: `${ReportSearchFormFacade.agentUsernameControlName}_input`,
            [ReportSearchFormFacade.agencyGuidControlName]: `${ReportSearchFormFacade.agencyGuidControlName}_dropdown`,
            [ReportSearchFormFacade.searchTypeControlName]: `${ReportSearchFormFacade.searchTypeControlName}_dropdown`,
            [ReportSearchFormFacade.enrollmentTypeControlName]: `${ReportSearchFormFacade.enrollmentTypeControlName}_dropdown`
        };
        this.fromDateControlName = ReportSearchFormFacade.fromDateControlName;
        this.toDateControlName = ReportSearchFormFacade.toDateControlName;
        this.agentUsernameControlName = ReportSearchFormFacade.agentUsernameControlName;
        this.agencyGuidControlName = ReportSearchFormFacade.agencyGuidControlName;
        this.searchTypeControlName = ReportSearchFormFacade.searchTypeControlName;
        this.enrollmentTypeControlName = ReportSearchFormFacade.enrollmentTypeControlName;
        this.reportSearchFormFacade = ReportSearchFormFacade;
        this.formErrors = {
            dateRange: [],
            agentUsername: [],
            searchType: [],
            enrollmentType: [],
            agencyName: []
        };
    }
    ngOnInit() {
        const dateRangeMin = 1;
        this.dateMaskFormat = this.reportSearchFacade.getDateMaskFormat();
        this.minNgbDate = this.reportSearchFacade.parseDateToNgbDate(this.minDate);
        this.maxNgbDate = this.reportSearchFacade.getNgbDate(dateRangeMin);
        this.maxDate = this.reportSearchFacade.getFormattedDate(this.maxNgbDate);
        this.searchForm = this.reportSearchFacade.getSearchForm({
            minDate: this.minDate,
            maxDate: this.maxDate,
            maxAllowedDays: parseInt(this.dateRangeMax, 10),
            isAdminUser: this.isAdminUser,
            isAgentUsernameFieldEnabled: this.agentUsernameFieldEnabled,
            isAgentUsernameFieldRequired: this.agentUsernameFieldRequired,
            agencyNameFieldEnabled: this.agencyNameFieldEnabled,
            agencyNameFieldRequired: this.agencyNameFieldRequired,
            agencyHierarchyEnabled: this.agencyHierarchyEnabled
        });
    }
    ngOnChanges(changes) {
        const locale = changes.locale;
        if (locale && locale.previousValue !== locale.currentValue && this.searchForm) {
            for (const controlRecordKey of Object.keys(this.controlNameRecord)) {
                const controlName = controlRecordKey;
                if (this.searchForm.get(controlName)) {
                    if ([this.fromDateControlName, this.toDateControlName].includes(controlName)) {
                        this.validateDateRange(controlName);
                    }
                    else {
                        this.validate({ controlName });
                    }
                }
            }
        }
    }
    onSubmit() {
        if (this.searchForm.valid) {
            // searchType isn't required in the API call
            const { searchType, agencyGuid, ...searchReportParameters } = this.searchForm.value;
            const startEndTime = '00:00:00';
            const dayEndTime = '23:59:59';
            searchReportParameters.agentReport = true;
            if (this.searchForm?.controls?.searchType?.value !== SearchType.Enrollment) {
                searchReportParameters.enrollmentType = this.searchForm.controls.searchType.value;
            }
            searchReportParameters.applicationStartDate = DateUtilities.getDateFromString(`${searchReportParameters.applicationStartDate} ${startEndTime}`, 'MM/DD/YYYY HH:mm:ss');
            searchReportParameters.applicationEndDate = DateUtilities.getDateFromString(`${searchReportParameters.applicationEndDate} ${dayEndTime}`, 'MM/DD/YYYY HH:mm:ss');
            if (this.agentUsernameFieldEnabled && !this.agentUsernameFieldRequired && !searchReportParameters.agentUsername) {
                delete searchReportParameters.agentUsername;
            }
            if (this.agencyHierarchyEnabled && this.agencyNameFieldEnabled) {
                searchReportParameters.agencyGuid = agencyGuid;
            }
            this.runSearch.emit(searchReportParameters);
        }
        else {
            this.reportSearchFacade.markFormAsTouched(this.searchForm);
            this.validateForm();
        }
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_REPORT_SEARCH,
            [DataLayerGlobalVariable.REPORT_SEARCH_BEGIN_DATE]: this.searchForm.controls.applicationStartDate?.value || 'none',
            [DataLayerGlobalVariable.REPORT_SEARCH_END_DATE]: this.searchForm.controls.applicationEndDate?.value || 'none',
            [DataLayerGlobalVariable.REPORT_SEARCH_TYPE]: this.searchForm.controls.searchType?.value || 'none',
            [DataLayerGlobalVariable.REPORT_SEARCH_ENROLLMENT_TYPE]: this.searchForm.controls.enrollmentType?.value || 'none',
            [DataLayerGlobalVariable.REPORT_SEARCH_FIELD_VALIDATION]: this.searchForm.valid ? 'pass' : 'fail'
        };
    }
    getDateRangeHintText() {
        const dateRangeHintPlaceholder = [{ placeholder: SearchPlaceholder.DateRangeMax, value: this.dateRangeMax }];
        return this.reportSearchFacade.replaceTextPlaceholder(this.dateRangeHintText, dateRangeHintPlaceholder);
    }
    validate(options) {
        this.formErrors[options.controlName] = this.getControlErrorMessages(options);
        this.updateControlValidity(options);
    }
    validateDateRange(originFormControl) {
        const fromDateControlOptions = {
            controlName: this.fromDateControlName,
            emitEvent: originFormControl === this.fromDateControlName
        };
        const toDateControlOptions = {
            controlName: this.toDateControlName,
            emitEvent: originFormControl === this.toDateControlName
        };
        // when the to field is changed and blurred these are called triggering a value update in from
        // and causing an values changes event to emit
        this.updateControlValidity(fromDateControlOptions);
        this.updateControlValidity(toDateControlOptions);
        if (this.isControlInvalid(fromDateControlOptions) || this.isControlInvalid(toDateControlOptions)) {
            this.formErrors.dateRange = this.getDateRangeErrorMessages();
        }
        else {
            this.formErrors.dateRange = [];
        }
    }
    onDateSelection() {
        if (this.searchForm.controls.applicationStartDate?.value) {
            const fromDate = this.searchForm.controls.applicationStartDate?.value;
            const previousDate = DateUtilities.getPreviousDate(new Date(), 1);
            const dayCountDifference = DateUtilities.getDaysDifference(DateUtilities.getFormattedDate(fromDate), previousDate);
            const maxDays = parseInt(this.dateRangeMax, 10);
            if (dayCountDifference >= maxDays) {
                const result = new Date(fromDate);
                // minus 1 will help to calculate exactly same dateRangeMax from selected startDate
                result.setDate(result.getDate() + parseInt(this.dateRangeMax, 10) - 1);
                this.searchForm.controls.applicationEndDate.setValue(DateUtilities.getFormattedDate(result));
            }
            else {
                this.searchForm.controls.applicationEndDate.setValue(previousDate);
            }
        }
    }
    selectSearchType(searchType) {
        if (searchType.selectionValue === SearchType.Enrollment) {
            this.reportSearchFacade.addControlEnrollmentType(this.searchForm);
        }
        else {
            this.reportSearchFacade.removeControlEnrollmentType(this.searchForm);
            this.formErrors.enrollmentType = [];
        }
    }
    isControlInvalid(options) {
        const { controlName, control = this.searchForm.get(controlName) } = options;
        return this.reportSearchFacade.isControlInvalid(control);
    }
    formHasErrorMessages(options) {
        return this.reportSearchFacade.formHasErrorMessages(this.formErrors, options);
    }
    updateControlValidity(options) {
        const { controlName, emitEvent, control = this.searchForm.get(controlName) } = options;
        control.updateValueAndValidity({ emitEvent });
    }
    getControlErrorMessages(options) {
        const { controlName, control = this.searchForm.get(controlName) } = options;
        let errors = [];
        if (this.reportSearchFacade.isControlInvalid(control)) {
            const inputErrors = this.reportSearchFacade.getErrorMessages(control, controlName);
            errors = this.selectErrorMessages(inputErrors);
        }
        return errors;
    }
    getDateRangeErrorMessages() {
        const inputErrors = this.reportSearchFacade.getDateRangeErrorMessages(this.searchForm, this.minDate, this.maxDate, this.dateRangeMax);
        return this.selectErrorMessages(inputErrors);
    }
    validateForm() {
        this.validateDateRange();
        Object.entries(this.searchForm.controls)
            .filter(([controlName]) => ![this.fromDateControlName, this.toDateControlName].includes(controlName))
            .forEach(([controlName, control]) => {
            const options = { controlName, control };
            this.validate(options);
        });
    }
    selectErrorMessages(errors) {
        const { required, invalid, invalidFutureDateRange, invalidDateTooFarInPast, invalidDateRange, invalidDateOutOfRange } = errors;
        const errorMessages = [
            required || invalid || invalidFutureDateRange || invalidDateTooFarInPast || invalidDateRange || invalidDateOutOfRange
        ].filter(errorMessage => !!errorMessage);
        return errorMessages;
    }
}
ReportSearchComponent.ɵfac = function ReportSearchComponent_Factory(t) { return new (t || ReportSearchComponent)(i0.ɵɵdirectiveInject(ReportSearchFormFacade), i0.ɵɵdirectiveInject(AnalyticsService)); };
ReportSearchComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ReportSearchComponent, selectors: [["vnext-report-search"]], inputs: { submittedDateRangeLabel: "submittedDateRangeLabel", fromLabel: "fromLabel", toLabel: "toLabel", agentUsernameLabel: "agentUsernameLabel", agencyNameLabel: "agencyNameLabel", typeLabel: "typeLabel", enrollmentTypeLabel: "enrollmentTypeLabel", runReportButtonText: "runReportButtonText", agentUsernameFieldEnabled: "agentUsernameFieldEnabled", agentUsernameFieldRequired: "agentUsernameFieldRequired", agencyNameFieldEnabled: "agencyNameFieldEnabled", agencyNameFieldRequired: "agencyNameFieldRequired", isAdminUser: "isAdminUser", searchTypeItems: "searchTypeItems", agencyItems: "agencyItems", noneAvailableLabel: "noneAvailableLabel", enrollmentTypesItems: "enrollmentTypesItems", dateRangeMax: "dateRangeMax", minDate: "minDate", dateRangeHintText: "dateRangeHintText", agencyHierarchyEnabled: "agencyHierarchyEnabled", locale: "locale" }, outputs: { runSearch: "runSearch" }, features: [i0.ɵɵNgOnChangesFeature], decls: 31, vars: 53, consts: [["disableKeyDownSubmit", "", 3, "formGroup", "ngSubmit"], [1, "form-row", 3, "ngClass"], [1, "col-12", "col-lg-6", "mb-3"], [1, "form-row"], ["class", "error-container mb-1", 4, "ngIf"], ["class", "error-container mb-1 d-flex align-items-end Spa_Style_Small_Font", 4, "ngIf"], [1, "Spa_Style_Label", 3, "for", "ngClass"], [1, "input-error-asterisk"], [1, "col-12", "col-sm-6", "mb-3", "mb-sm-0", "pr-sm-0"], [3, "control", "ariaLabelledById", "inputLabel", "inlineLayout", "dateMaskFormat", "minDate", "maxDate", "datePickerInputBlur", "dateSelect"], [1, "col-12", "col-sm-6", "pl-sm-0"], [3, "control", "ariaLabelledById", "inputLabel", "inlineLayout", "dateMaskFormat", "minDate", "maxDate", "datePickerInputBlur"], [1, "pt-2", "pl-2", "pl-lg-4", "offset-sm-1", "Spa_Style_Smaller"], [1, "col-12", "col-lg-6"], [1, "row"], [4, "ngIf", "ngIfElse"], ["agentUsernameField", ""], [1, "col-12", "col-sm-6", "col-lg-4", "mb-3"], [3, "control", "ariaLabelledById", "dropdownLabel", "dropdownItems", "errors", "selectDropdownItem", "dropdownButtonBlur"], [4, "ngIf"], [3, "providedPrevious", "showPrevious", "topMargin"], ["continue-button", "", 1, "form-row", "flex-column", "align-items-end"], ["type", "submit", "tabindex", "0", "class", "btn Spa_Style_PrimaryButton", 4, "liveEditProp"], [1, "error-container", "mb-1"], [1, "error-container", "mb-1", "d-flex", "align-items-end", "Spa_Style_Small_Font"], [3, "errors", "showInline"], [1, "col-12", "col-sm-6", "mb-3"], [3, "control", "ariaLabelledById", "isRequired", "dropdownLabel", "dropdownItems", "dropdownDefaultText", "disabled", "offsetItems", "errors", "customClass", "dropdownButtonBlur"], [1, "Spa_Style_Label", "pl-2", 3, "for", "ngClass"], ["class", "input-error-asterisk", 4, "ngIf"], [1, "input-group"], ["type", "text", "tabindex", "0", "autocomplete", "new-text", "placeholder", "", 1, "form-control", 3, "id", "formControlName", "ngClass", "blur"], [1, "col-12", "col-sm-6", "pr-sm-3", "mb-3"], [3, "control", "ariaLabelledById", "dropdownLabel", "dropdownItems", "errors", "dropdownButtonBlur"], [1, "form-row", "mb-5"], [1, "col-12", "col-sm-6", "col-lg-3", "pr-sm-3", "mb-3"], ["type", "submit", "tabindex", "0", 1, "btn", "Spa_Style_PrimaryButton"]], template: function ReportSearchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 0);
        i0.ɵɵlistener("ngSubmit", function ReportSearchComponent_Template_form_ngSubmit_0_listener() { return ctx.onSubmit(); });
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3);
        i0.ɵɵtemplate(4, ReportSearchComponent_div_4_Template, 1, 0, "div", 4);
        i0.ɵɵtemplate(5, ReportSearchComponent_div_5_Template, 2, 2, "div", 5);
        i0.ɵɵelementStart(6, "label", 6)(7, "span", 7);
        i0.ɵɵtext(8, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "div", 3)(11, "div", 8)(12, "vnext-datepicker-input", 9);
        i0.ɵɵlistener("datePickerInputBlur", function ReportSearchComponent_Template_vnext_datepicker_input_datePickerInputBlur_12_listener() { return ctx.validateDateRange(ctx.fromDateControlName); })("dateSelect", function ReportSearchComponent_Template_vnext_datepicker_input_dateSelect_12_listener() { return ctx.onDateSelection(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "div", 10)(14, "vnext-datepicker-input", 11);
        i0.ɵɵlistener("datePickerInputBlur", function ReportSearchComponent_Template_vnext_datepicker_input_datePickerInputBlur_14_listener() { return ctx.validateDateRange(ctx.toDateControlName); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(15, "div", 3)(16, "span", 12);
        i0.ɵɵtext(17);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(18, "div", 13)(19, "div", 14);
        i0.ɵɵtemplate(20, ReportSearchComponent_ng_container_20_Template, 2, 1, "ng-container", 15);
        i0.ɵɵtemplate(21, ReportSearchComponent_ng_template_21_Template, 1, 1, "ng-template", null, 16, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(23, "div", 17);
        i0.ɵɵtemplate(24, ReportSearchComponent_div_24_Template, 1, 0, "div", 4);
        i0.ɵɵelementStart(25, "vnext-dropdown-button", 18);
        i0.ɵɵlistener("selectDropdownItem", function ReportSearchComponent_Template_vnext_dropdown_button_selectDropdownItem_25_listener($event) { return ctx.selectSearchType($event); })("dropdownButtonBlur", function ReportSearchComponent_Template_vnext_dropdown_button_dropdownButtonBlur_25_listener() { return ctx.validate({ controlName: ctx.searchTypeControlName }); });
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(26, ReportSearchComponent_ng_container_26_Template, 4, 10, "ng-container", 19);
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(27, ReportSearchComponent_ng_container_27_Template, 4, 5, "ng-container", 19);
        i0.ɵɵelementStart(28, "vnext-navigation-banner", 20)(29, "div", 21);
        i0.ɵɵtemplate(30, ReportSearchComponent_button_30_Template, 2, 1, "button", 22);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(22);
        i0.ɵɵproperty("formGroup", ctx.searchForm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(36, _c5$g, !ctx.searchForm.contains(ctx.enrollmentTypeControlName) || !ctx.agentUsernameFieldEnabled));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.formHasErrorMessages(i0.ɵɵpureFunction1(41, _c1$1K, i0.ɵɵpureFunction2(38, _c6$f, ctx.fromDateControlName, ctx.toDateControlName))) && !ctx.formErrors.dateRange.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.formErrors.dateRange.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("for", ctx.controlNameRecord[ctx.reportSearchFormFacade.fromDateControlName])("ngClass", i0.ɵɵpureFunction1(47, _c3$L, ctx.isControlInvalid(i0.ɵɵpureFunction1(43, _c2$14, ctx.fromDateControlName)) || ctx.isControlInvalid(i0.ɵɵpureFunction1(45, _c2$14, ctx.toDateControlName)) || ctx.formErrors.dateRange.length > 0));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.submittedDateRangeLabel, " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("control", ctx.searchForm.get(ctx.fromDateControlName))("ariaLabelledById", ctx.controlNameRecord[ctx.reportSearchFormFacade.fromDateControlName])("inputLabel", ctx.fromLabel)("inlineLayout", true)("dateMaskFormat", ctx.dateMaskFormat)("minDate", ctx.minNgbDate)("maxDate", ctx.maxNgbDate);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("control", ctx.searchForm.get(ctx.toDateControlName))("ariaLabelledById", ctx.controlNameRecord[ctx.reportSearchFormFacade.toDateControlName])("inputLabel", ctx.toLabel)("inlineLayout", true)("dateMaskFormat", ctx.dateMaskFormat)("minDate", ctx.minNgbDate)("maxDate", ctx.maxNgbDate);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.getDateRangeHintText());
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.agencyHierarchyEnabled)("ngIfElse", _r3);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.formHasErrorMessages(i0.ɵɵpureFunction1(51, _c1$1K, i0.ɵɵpureFunction1(49, _c0$3f, ctx.searchTypeControlName))) && !ctx.formErrors[ctx.searchTypeControlName].length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("control", ctx.searchForm.get(ctx.searchTypeControlName))("ariaLabelledById", ctx.controlNameRecord[ctx.reportSearchFormFacade.searchTypeControlName])("dropdownLabel", ctx.typeLabel)("dropdownItems", ctx.searchTypeItems)("errors", ctx.formErrors[ctx.searchTypeControlName]);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (!ctx.agentUsernameFieldEnabled || !ctx.isAdminUser) && ctx.searchForm.contains(ctx.enrollmentTypeControlName));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.agentUsernameFieldEnabled && ctx.isAdminUser && ctx.searchForm.contains(ctx.enrollmentTypeControlName));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("providedPrevious", false)("showPrevious", false)("topMargin", false);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_AgentReports_RunReport_Text");
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, FieldErrorsComponent, NavigationBannerComponent, DatePickerInputComponent, DropdownButtonComponent, LiveEditPropDirective, FormInputSubmitDirective], styles: [".error-container[_ngcontent-%COMP%]{min-height:35px;max-height:35px;line-height:18px}.label-error[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent2)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReportSearchComponent, [{
        type: Component,
        args: [{ selector: 'vnext-report-search', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form disableKeyDownSubmit [formGroup]=\"searchForm\" (ngSubmit)=\"onSubmit()\">\r\n  <div class=\"form-row\" [ngClass]=\"{ 'mb-5': !searchForm.contains(enrollmentTypeControlName) || !agentUsernameFieldEnabled }\">\r\n    <div class=\"col-12 col-lg-6 mb-3\">\r\n      <div class=\"form-row\">\r\n        <div\r\n          class=\"error-container mb-1\"\r\n          *ngIf=\"formHasErrorMessages({ omittedKeys: [fromDateControlName, toDateControlName] }) && !formErrors.dateRange.length\"\r\n        ></div>\r\n        <div class=\"error-container mb-1 d-flex align-items-end Spa_Style_Small_Font\" *ngIf=\"formErrors.dateRange.length > 0\">\r\n          <vnext-widget-field-errors [errors]=\"formErrors.dateRange\" [showInline]=\"true\"></vnext-widget-field-errors>\r\n        </div>\r\n\r\n        <label\r\n          class=\"Spa_Style_Label\"\r\n          [for]=\"controlNameRecord[reportSearchFormFacade.fromDateControlName]\"\r\n          [ngClass]=\"{\r\n            'label-error':\r\n              isControlInvalid({ controlName: fromDateControlName }) ||\r\n              isControlInvalid({ controlName: toDateControlName }) ||\r\n              formErrors.dateRange.length > 0\r\n          }\"\r\n        >\r\n          <span class=\"input-error-asterisk\">*</span>\r\n          {{ submittedDateRangeLabel }}\r\n        </label>\r\n      </div>\r\n\r\n      <div class=\"form-row\">\r\n        <div class=\"col-12 col-sm-6 mb-3 mb-sm-0 pr-sm-0\">\r\n          <vnext-datepicker-input\r\n            [control]=\"searchForm.get(fromDateControlName)\"\r\n            [ariaLabelledById]=\"controlNameRecord[reportSearchFormFacade.fromDateControlName]\"\r\n            [inputLabel]=\"fromLabel\"\r\n            [inlineLayout]=\"true\"\r\n            [dateMaskFormat]=\"dateMaskFormat\"\r\n            [minDate]=\"minNgbDate\"\r\n            [maxDate]=\"maxNgbDate\"\r\n            (datePickerInputBlur)=\"validateDateRange(fromDateControlName)\"\r\n            (dateSelect)=\"onDateSelection()\"\r\n          >\r\n          </vnext-datepicker-input>\r\n        </div>\r\n\r\n        <div class=\"col-12 col-sm-6 pl-sm-0\">\r\n          <vnext-datepicker-input\r\n            [control]=\"searchForm.get(toDateControlName)\"\r\n            [ariaLabelledById]=\"controlNameRecord[reportSearchFormFacade.toDateControlName]\"\r\n            [inputLabel]=\"toLabel\"\r\n            [inlineLayout]=\"true\"\r\n            [dateMaskFormat]=\"dateMaskFormat\"\r\n            [minDate]=\"minNgbDate\"\r\n            [maxDate]=\"maxNgbDate\"\r\n            (datePickerInputBlur)=\"validateDateRange(toDateControlName)\"\r\n          >\r\n          </vnext-datepicker-input>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-row\">\r\n        <span class=\"pt-2 pl-2 pl-lg-4 offset-sm-1 Spa_Style_Smaller\">{{ getDateRangeHintText() }}</span>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"col-12 col-lg-6\">\r\n      <div class=\"row\">\r\n        <ng-container *ngIf=\"agencyHierarchyEnabled; else agentUsernameField\">\r\n          <ng-container *ngIf=\"isAdminUser && agencyNameFieldEnabled\">\r\n            <div class=\"col-12 col-sm-6 mb-3\">\r\n              <div\r\n                class=\"error-container mb-1\"\r\n                *ngIf=\"formHasErrorMessages({ omittedKeys: [agencyGuidControlName] }) && !formErrors[agencyGuidControlName]?.length\"\r\n              ></div>\r\n              <vnext-dropdown-button\r\n                [control]=\"searchForm.get(agencyGuidControlName)\"\r\n                [ariaLabelledById]=\"controlNameRecord[reportSearchFormFacade.agencyGuidControlName]\"\r\n                [isRequired]=\"agencyNameFieldRequired\"\r\n                [dropdownLabel]=\"agencyNameLabel\"\r\n                [dropdownItems]=\"agencyItems\"\r\n                [dropdownDefaultText]=\"agencyItems.length > 0 ? '' : noneAvailableLabel\"\r\n                [disabled]=\"agencyItems.length === 0\"\r\n                [offsetItems]=\"10\"\r\n                [errors]=\"formErrors[agencyGuidControlName]\"\r\n                [customClass]=\"'no-translate-block'\"\r\n                (dropdownButtonBlur)=\"validate({ controlName: agencyGuidControlName })\"\r\n              ></vnext-dropdown-button>\r\n            </div>\r\n          </ng-container>\r\n        </ng-container>\r\n\r\n        <ng-template #agentUsernameField>\r\n          <ng-container *ngIf=\"isAdminUser && agentUsernameFieldEnabled\">\r\n            <div class=\"col-12 col-sm-6 mb-3\">\r\n              <div class=\"form-row\">\r\n                <div\r\n                  class=\"error-container mb-1\"\r\n                  *ngIf=\"formHasErrorMessages({ omittedKeys: [agentUsernameControlName] }) && !formErrors[agentUsernameControlName].length\"\r\n                ></div>\r\n                <div\r\n                  class=\"error-container mb-1 d-flex align-items-end Spa_Style_Small_Font\"\r\n                  *ngIf=\"isControlInvalid({ controlName: agentUsernameControlName }) && formErrors[agentUsernameControlName].length > 0\"\r\n                >\r\n                  <vnext-widget-field-errors\r\n                    [errors]=\"formErrors[agentUsernameControlName]\"\r\n                    [showInline]=\"false\"\r\n                  ></vnext-widget-field-errors>\r\n                </div>\r\n                <label\r\n                  class=\"Spa_Style_Label pl-2\"\r\n                  [for]=\"controlNameRecord[reportSearchFormFacade.agentUsernameControlName]\"\r\n                  [ngClass]=\"{\r\n                    'label-error':\r\n                      isControlInvalid({ controlName: agentUsernameControlName }) && formErrors[agentUsernameControlName]?.length > 0\r\n                  }\"\r\n                >\r\n                  <span class=\"input-error-asterisk\" *ngIf=\"agentUsernameFieldRequired\">*</span>\r\n                  {{ agentUsernameLabel }}\r\n                </label>\r\n              </div>\r\n\r\n              <div class=\"input-group\">\r\n                <input\r\n                  type=\"text\"\r\n                  tabindex=\"0\"\r\n                  autocomplete=\"new-text\"\r\n                  placeholder=\"\"\r\n                  class=\"form-control\"\r\n                  [id]=\"controlNameRecord[reportSearchFormFacade.agentUsernameControlName]\"\r\n                  [formControlName]=\"agentUsernameControlName\"\r\n                  [ngClass]=\"{ 'has-error': isControlInvalid({ controlName: agentUsernameControlName }) }\"\r\n                  (blur)=\"validate({ controlName: agentUsernameControlName })\"\r\n                />\r\n              </div>\r\n            </div>\r\n          </ng-container>\r\n        </ng-template>\r\n        <div class=\"col-12 col-sm-6 col-lg-4 mb-3\">\r\n          <div\r\n            class=\"error-container mb-1\"\r\n            *ngIf=\"formHasErrorMessages({ omittedKeys: [searchTypeControlName] }) && !formErrors[searchTypeControlName].length\"\r\n          ></div>\r\n          <vnext-dropdown-button\r\n            [control]=\"searchForm.get(searchTypeControlName)\"\r\n            [ariaLabelledById]=\"controlNameRecord[reportSearchFormFacade.searchTypeControlName]\"\r\n            [dropdownLabel]=\"typeLabel\"\r\n            [dropdownItems]=\"searchTypeItems\"\r\n            [errors]=\"formErrors[searchTypeControlName]\"\r\n            (selectDropdownItem)=\"selectSearchType($event)\"\r\n            (dropdownButtonBlur)=\"validate({ controlName: searchTypeControlName })\"\r\n          ></vnext-dropdown-button>\r\n        </div>\r\n\r\n        <ng-container *ngIf=\"(!agentUsernameFieldEnabled || !isAdminUser) && searchForm.contains(enrollmentTypeControlName)\">\r\n          <div class=\"col-12 col-sm-6 pr-sm-3 mb-3\">\r\n            <div\r\n              class=\"error-container mb-1\"\r\n              *ngIf=\"formHasErrorMessages({ omittedKeys: [enrollmentTypeControlName] }) && !formErrors[enrollmentTypeControlName].length\"\r\n            ></div>\r\n            <vnext-dropdown-button\r\n              [control]=\"searchForm.get(enrollmentTypeControlName)\"\r\n              [ariaLabelledById]=\"controlNameRecord[reportSearchFormFacade.enrollmentTypeControlName]\"\r\n              [dropdownLabel]=\"enrollmentTypeLabel\"\r\n              [dropdownItems]=\"enrollmentTypesItems\"\r\n              [errors]=\"formErrors[enrollmentTypeControlName]\"\r\n              (dropdownButtonBlur)=\"validate({ controlName: enrollmentTypeControlName })\"\r\n            ></vnext-dropdown-button>\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <ng-container *ngIf=\"agentUsernameFieldEnabled && isAdminUser && searchForm.contains(enrollmentTypeControlName)\">\r\n    <div class=\"form-row mb-5\">\r\n      <div class=\"col-12 col-sm-6 col-lg-3 pr-sm-3 mb-3\">\r\n        <vnext-dropdown-button\r\n          [control]=\"searchForm.get(enrollmentTypeControlName)\"\r\n          [ariaLabelledById]=\"controlNameRecord[reportSearchFormFacade.enrollmentTypeControlName]\"\r\n          [dropdownLabel]=\"enrollmentTypeLabel\"\r\n          [dropdownItems]=\"enrollmentTypesItems\"\r\n          [errors]=\"formErrors[enrollmentTypeControlName]\"\r\n          (dropdownButtonBlur)=\"validate({ controlName: enrollmentTypeControlName })\"\r\n        ></vnext-dropdown-button>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <vnext-navigation-banner [providedPrevious]=\"false\" [showPrevious]=\"false\" [topMargin]=\"false\">\r\n    <div class=\"form-row flex-column align-items-end\" continue-button>\r\n      <button type=\"submit\" tabindex=\"0\" class=\"btn Spa_Style_PrimaryButton\" *liveEditProp=\"'Spa_AgentReports_RunReport_Text'\">\r\n        {{ runReportButtonText }}\r\n      </button>\r\n    </div>\r\n  </vnext-navigation-banner>\r\n</form>\r\n", styles: [".error-container{min-height:35px;max-height:35px;line-height:18px}.label-error{color:var(--static-Spa_Style_Accent2)}\n"] }]
    }], function () { return [{ type: ReportSearchFormFacade }, { type: AnalyticsService }]; }, { submittedDateRangeLabel: [{
            type: Input
        }], fromLabel: [{
            type: Input
        }], toLabel: [{
            type: Input
        }], agentUsernameLabel: [{
            type: Input
        }], agencyNameLabel: [{
            type: Input
        }], typeLabel: [{
            type: Input
        }], enrollmentTypeLabel: [{
            type: Input
        }], runReportButtonText: [{
            type: Input
        }], agentUsernameFieldEnabled: [{
            type: Input
        }], agentUsernameFieldRequired: [{
            type: Input
        }], agencyNameFieldEnabled: [{
            type: Input
        }], agencyNameFieldRequired: [{
            type: Input
        }], isAdminUser: [{
            type: Input
        }], searchTypeItems: [{
            type: Input
        }], agencyItems: [{
            type: Input
        }], noneAvailableLabel: [{
            type: Input
        }], enrollmentTypesItems: [{
            type: Input
        }], dateRangeMax: [{
            type: Input
        }], minDate: [{
            type: Input
        }], dateRangeHintText: [{
            type: Input
        }], agencyHierarchyEnabled: [{
            type: Input
        }], locale: [{
            type: Input
        }], runSearch: [{
            type: Output
        }] }); })();

const _c0$3e = ["carrierSelections"];
const _c1$1J = function (a0) { return { "overflow-container": a0 }; };
function ReportSummaryFilterItemsComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "h4", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 9);
    i0.ɵɵelement(4, "vnext-checkbox-group", 10, 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.carrierLabel, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c1$1J, (ctx_r0.carriers == null ? null : ctx_r0.carriers.length) > 10));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("items", ctx_r0.carriers)("showTooltipUnderline", true)("noTranslateBlock", true);
} }
function ReportSummaryFilterItemsComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "vnext-scrollable-multi-select-checkbox", 12);
    i0.ɵɵlistener("selectedItems", function ReportSummaryFilterItemsComponent_div_6_Template_vnext_scrollable_multi_select_checkbox_selectedItems_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.onStatesFilterSelection($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("label", ctx_r1.stateLabel)("items", ctx_r1.states)("noTranslateBlock", true);
} }
class ReportSummaryFilterItemsComponent {
    constructor() {
        this.reportFilterControl = 'reportFilterControl';
        this.selectedStates = [];
        // selected filter details
        this.selectedReportFilters = new EventEmitter();
        this.closePopover = new EventEmitter();
        this.SearchType = SearchType;
    }
    onStatesFilterSelection(selectedItems) {
        this.selectedStates = selectedItems;
    }
    applyFilter(clearFilterValues) {
        // handle clear all filter value
        clearFilterValues = clearFilterValues ? clearFilterValues : false;
        // data passing to reports
        this.selectedReportFilters.emit({
            carriers: this.carrierSelections?.selectedItems || [],
            states: this.selectedStates,
            clearFilters: clearFilterValues
        });
    }
    close() {
        this.closePopover.emit();
    }
}
ReportSummaryFilterItemsComponent.ɵfac = function ReportSummaryFilterItemsComponent_Factory(t) { return new (t || ReportSummaryFilterItemsComponent)(); };
ReportSummaryFilterItemsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ReportSummaryFilterItemsComponent, selectors: [["vnext-report-summary-filter-items"]], viewQuery: function ReportSummaryFilterItemsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3e, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.carrierSelections = _t.first);
    } }, inputs: { reportApplyButtonText: "reportApplyButtonText", reportCancelButtonText: "reportCancelButtonText", reportFilterClearText: "reportFilterClearText", carriers: "carriers", carrierLabel: "carrierLabel", carrierEnabled: "carrierEnabled", states: "states", stateLabel: "stateLabel", stateEnabled: "stateEnabled", enrollmentType: "enrollmentType" }, outputs: { selectedReportFilters: "selectedReportFilters", closePopover: "closePopover" }, decls: 10, vars: 5, consts: [[1, "row"], [1, "col-12", "align-text-right"], [3, "title", "alwaysUnderlined", "click"], [1, "close-button", "can-click", "Spa_Style_Primary_Color", "ml-4"], [1, "fa", "fa-times", 3, "click"], ["class", "col-sm-4 col-md-3 col-lg-3 mx-1 px-1 mr-10", 4, "ngIf"], ["type", "button", 1, "btn", "Spa_Style_PrimaryButton", 3, "click"], [1, "col-sm-4", "col-md-3", "col-lg-3", "mx-1", "px-1", "mr-10"], [1, "Spa_Style_H4", "mx-1", "mb-2"], [1, "checkbox-group", 3, "ngClass"], [1, "plan-filter-items", 3, "items", "showTooltipUnderline", "noTranslateBlock"], ["carrierSelections", ""], [3, "label", "items", "noTranslateBlock", "selectedItems"]], template: function ReportSummaryFilterItemsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "vnext-link", 2);
        i0.ɵɵlistener("click", function ReportSummaryFilterItemsComponent_Template_vnext_link_click_2_listener() { return ctx.applyFilter(true); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3)(4, "i", 4);
        i0.ɵɵlistener("click", function ReportSummaryFilterItemsComponent_Template_i_click_4_listener() { return ctx.close(); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(5, ReportSummaryFilterItemsComponent_div_5_Template, 6, 7, "div", 5);
        i0.ɵɵtemplate(6, ReportSummaryFilterItemsComponent_div_6_Template, 2, 3, "div", 5);
        i0.ɵɵelementStart(7, "div", 1)(8, "button", 6);
        i0.ɵɵlistener("click", function ReportSummaryFilterItemsComponent_Template_button_click_8_listener() { return ctx.applyFilter(); });
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("title", ctx.reportFilterClearText)("alwaysUnderlined", true);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.carrierEnabled && ctx.carriers.length > 1 && ctx.enrollmentType !== ctx.SearchType.SOA);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.stateEnabled && (ctx.states == null ? null : ctx.states.length) > 1);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.reportApplyButtonText);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, CheckboxGroupComponent, LinkComponent, ScrollableMultiSelectCheckboxComponent, IconAriaAttributesDirective], styles: [".align-text-right[_ngcontent-%COMP%]{display:flex;justify-content:flex-end}.checkbox-group[_ngcontent-%COMP%]{min-height:160px}.overflow-container[_ngcontent-%COMP%]{height:260px;overflow-y:auto;border:1px solid var(--static-Spa_Style_Gray4);padding:10px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReportSummaryFilterItemsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-report-summary-filter-items', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row\">\r\n  <div class=\"col-12 align-text-right\">\r\n    <vnext-link [title]=\"reportFilterClearText\" (click)=\"applyFilter(true)\" [alwaysUnderlined]=\"true\"></vnext-link>\r\n    <div class=\"close-button can-click Spa_Style_Primary_Color ml-4\"><i (click)=\"close()\" class=\"fa fa-times\"></i></div>\r\n  </div>\r\n  <div\r\n    class=\"col-sm-4 col-md-3 col-lg-3 mx-1 px-1 mr-10\"\r\n    *ngIf=\"carrierEnabled && carriers.length > 1 && enrollmentType !== SearchType.SOA\"\r\n  >\r\n    <h4 class=\"Spa_Style_H4 mx-1 mb-2\">\r\n      {{ carrierLabel }}\r\n    </h4>\r\n    <div class=\"checkbox-group\" [ngClass]=\"{ 'overflow-container': carriers?.length > 10 }\">\r\n      <vnext-checkbox-group\r\n        #carrierSelections\r\n        [items]=\"carriers\"\r\n        class=\"plan-filter-items\"\r\n        [showTooltipUnderline]=\"true\"\r\n        [noTranslateBlock]=\"true\"\r\n      >\r\n      </vnext-checkbox-group>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"col-sm-4 col-md-3 col-lg-3 mx-1 px-1 mr-10\" *ngIf=\"stateEnabled && states?.length > 1\">\r\n    <vnext-scrollable-multi-select-checkbox [label]=\"stateLabel\" [items]=\"states\" (selectedItems)=\"onStatesFilterSelection($event)\" [noTranslateBlock]=\"true\">\r\n    </vnext-scrollable-multi-select-checkbox>\r\n  </div>\r\n  <div class=\"col-12 align-text-right\">\r\n    <button type=\"button\" class=\"btn Spa_Style_PrimaryButton\" (click)=\"applyFilter()\">{{ reportApplyButtonText }}</button>\r\n  </div>\r\n</div>\r\n", styles: [".align-text-right{display:flex;justify-content:flex-end}.checkbox-group{min-height:160px}.overflow-container{height:260px;overflow-y:auto;border:1px solid var(--static-Spa_Style_Gray4);padding:10px}\n"] }]
    }], null, { reportApplyButtonText: [{
            type: Input
        }], reportCancelButtonText: [{
            type: Input
        }], reportFilterClearText: [{
            type: Input
        }], carriers: [{
            type: Input
        }], carrierLabel: [{
            type: Input
        }], carrierEnabled: [{
            type: Input
        }], carrierSelections: [{
            type: ViewChild,
            args: ['carrierSelections']
        }], states: [{
            type: Input
        }], stateLabel: [{
            type: Input
        }], stateEnabled: [{
            type: Input
        }], enrollmentType: [{
            type: Input
        }], selectedReportFilters: [{
            type: Output
        }], closePopover: [{
            type: Output
        }] }); })();

const _c0$3d = ["reportPopover"];
function ReportsSummaryComponent_vnext_link_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 12);
    i0.ɵɵlistener("click", function ReportsSummaryComponent_vnext_link_3_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.backToPrevious()); })("keyup.enter", function ReportsSummaryComponent_vnext_link_3_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.backToPrevious()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r0.Spa_Site_Previous)("showArrow", "left");
} }
function ReportsSummaryComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.Spa_AgentReports_Header_Text, " ");
} }
function ReportsSummaryComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 14);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r2.Spa_Site_PageSubHeader_Text ? i0.ɵɵpipeBind2(1, 1, ctx_r2.Spa_Site_PageSubHeader_Text, "html") : "", i0.ɵɵsanitizeHtml);
} }
function ReportsSummaryComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ReportsSummaryComponent_ng_template_10_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 18);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r11.Spa_AgentReports_EmptyState_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function ReportsSummaryComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelement(1, "i", 16);
    i0.ɵɵtemplate(2, ReportsSummaryComponent_ng_template_10_div_2_Template, 2, 4, "div", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_AgentReports_EmptyState_Text");
} }
function ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_vnext_link_3_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 36);
    i0.ɵɵlistener("click", function ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_vnext_link_3_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r26.downloadResults()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("title", ctx_r17.Spa_Site_DownloadLink_Text)("alwaysUnderlined", true)("linkTarget", "_blank")("additionalIcon", ctx_r17.Spa_Site_Download_Icon)("iconColor", ctx_r17.Spa_Style_Primary_Link);
} }
function ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵelement(1, "i", 38)(2, "div", 39);
    i0.ɵɵpipe(3, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(3, 1, ctx_r18.Spa_Site_Download_Report_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_h4_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h4", 40);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r19.Spa_Agent_Search_SortHeader_Text, " ");
} }
function ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵlistener("click", function ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_div_13_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r30); const sort_r28 = restoredCtx.$implicit; const ctx_r29 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r29.sortOption = sort_r28); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sort_r28 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", sort_r28.label, " ");
} }
function ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_div_14_button_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 44, 45);
    i0.ɵɵelement(2, "i", 46);
    i0.ɵɵelementStart(3, "span", 47);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "i", 48);
    i0.ɵɵelementStart(6, "span", 30);
    i0.ɵɵtext(7, "Expand filter");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r22 = i0.ɵɵreference(16);
    const ctx_r31 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngbPopover", _r22)("autoClose", "outside");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r31.Spa_Filter_Header_Text);
} }
function ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵtemplate(1, ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_div_14_button_1_Template, 8, 3, "button", 43);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r24 = i0.ɵɵreference(18);
    const ctx_r21 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.showHideFilter())("ngIfElse", _r24);
} }
function ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 49)(1, "vnext-report-summary-filter-items", 50);
    i0.ɵɵlistener("selectedReportFilters", function ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_ng_template_15_Template_vnext_report_summary_filter_items_selectedReportFilters_1_listener($event) { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r33.applyReportFilters($event)); })("closePopover", function ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_ng_template_15_Template_vnext_report_summary_filter_items_closePopover_1_listener() { i0.ɵɵrestoreView(_r34); const ctx_r35 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r35.popover.close()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("reportFilterClearText", ctx_r23.Spa_Filter_Clear_All)("carriers", ctx_r23.carrierList)("carrierLabel", ctx_r23.Spa_PlanFilters_CarrierLabel_Text)("carrierEnabled", ctx_r23.Spa_Report_Carrier_Filter_Enabled)("states", ctx_r23.stateList)("stateLabel", ctx_r23.Spa_Agent_Search_State_Text)("stateEnabled", ctx_r23.Spa_Report_State_Filter_Enabled)("reportApplyButtonText", ctx_r23.Spa_PlanFilters_Modal_Apply_Button)("reportCancelButtonText", ctx_r23.Spa_PlanFilters_Modal_Cancel_Button)("enrollmentType", ctx_r23.enrollmentType);
} }
function ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_ng_template_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r25.Spa_Filter_Default_Filter_Text);
} }
function ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 21)(2, "div", 22);
    i0.ɵɵtemplate(3, ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_vnext_link_3_Template, 1, 5, "vnext-link", 23);
    i0.ɵɵtemplate(4, ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_div_4_Template, 4, 4, "div", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 25);
    i0.ɵɵtemplate(6, ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_h4_6_Template, 2, 1, "h4", 26);
    i0.ɵɵelementStart(7, "div", 27)(8, "input", 28);
    i0.ɵɵlistener("keydown", function ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_Template_input_keydown_8_listener($event) { return $event.preventDefault(); })("ngModelChange", function ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_Template_input_ngModelChange_8_listener() { i0.ɵɵrestoreView(_r38); const ctx_r37 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r37.sortOption); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "i", 29);
    i0.ɵɵelementStart(10, "span", 30);
    i0.ɵɵtext(11, "Expand menu");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 31);
    i0.ɵɵtemplate(13, ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_div_13_Template, 2, 1, "div", 32);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(14, ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_div_14_Template, 2, 2, "div", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_ng_template_15_Template, 2, 10, "ng-template", null, 34, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(17, ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_ng_template_17_Template, 2, 1, "ng-template", null, 35, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r15.Spa_AgentReports_Download_Enabled && !ctx_r15.showDownloadSpinner);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.showDownloadSpinner);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_Search_SortHeader_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r15.sortOption.label);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r15.sortOptions);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.Spa_Site_Report_Filter_Enabled && (ctx_r15.carrierList.length > 1 || ctx_r15.stateList.length > 1));
} }
function ReportsSummaryComponent_ng_template_12_ng_container_0_vnext_report_list_2_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-report-list", 52);
    i0.ɵɵlistener("linkClick", function ReportsSummaryComponent_ng_template_12_ng_container_0_vnext_report_list_2_Template_vnext_report_list_linkClick_0_listener($event) { i0.ɵɵrestoreView(_r40); const ctx_r39 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r39.viewMember($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const reportList_r14 = i0.ɵɵnextContext().ngIf;
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("reportList", reportList_r14)("locale", ctx_r16.locale)("noResultsText", ctx_r16.Spa_AgentReports_NoResults_Text)("updated", ctx_r16.Spa_Agent_Search_Updated_Text)("isAdminUser", ctx_r16.isAdminUser)("showAgentDetails", ctx_r16.showAgentDetails)("searchShowAgentUserName", ctx_r16.Spa_Profile_Search_Show_AgentUserName)("agencyHierarchyEnabled", ctx_r16.AgencyHierarchy_Enabled);
} }
function ReportsSummaryComponent_ng_template_12_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ReportsSummaryComponent_ng_template_12_ng_container_0_ng_container_1_Template, 19, 6, "ng-container", 19);
    i0.ɵɵtemplate(2, ReportsSummaryComponent_ng_template_12_ng_container_0_vnext_report_list_2_Template, 1, 8, "vnext-report-list", 20);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const reportList_r14 = ctx.ngIf;
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (reportList_r14 == null ? null : reportList_r14.length) && !ctx_r12.showSpinner);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r12.showSpinner);
} }
function ReportsSummaryComponent_ng_template_12_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 15);
    i0.ɵɵelement(2, "i", 53)(3, "div", 18);
    i0.ɵɵpipe(4, "safe");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 1, ctx_r13.Spa_AgentReports_LoadingReport_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function ReportsSummaryComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ReportsSummaryComponent_ng_template_12_ng_container_0_Template, 3, 2, "ng-container", 19);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵtemplate(2, ReportsSummaryComponent_ng_template_12_div_2_Template, 5, 4, "div", 19);
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx_r7.reportList$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r7.showSpinner);
} }
let ReportsSummaryComponent = class ReportsSummaryComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, agentSearchFacade, localeService, navigationService, agentService, agentPermissionsService, profileFacade, orderPipe, analyticsService, agentHttpService, fileUtilityService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.agentSearchFacade = agentSearchFacade;
        this.localeService = localeService;
        this.navigationService = navigationService;
        this.agentService = agentService;
        this.agentPermissionsService = agentPermissionsService;
        this.profileFacade = profileFacade;
        this.orderPipe = orderPipe;
        this.analyticsService = analyticsService;
        this.agentHttpService = agentHttpService;
        this.fileUtilityService = fileUtilityService;
        this.Spa_AgentReports_Header_Text = 'Reports';
        this.Spa_Site_PageSubHeader_Text = '';
        this.Spa_AgentReports_RunReport_Text = 'Run report';
        this.Spa_AgentReports_EmptyState_Text = `<h3 class="Spa_Style_H3">Run a report</h3>
  <div class="Spa_Style_Regular_Font Spa_Style_Primary_Color Spa_Style_Regular_Weight">Run a report to see updated information.</div>`;
        this.Spa_AgentReports_SubmittedDateRange_Label = 'Submitted date range';
        this.Spa_AgentReports_From_Label = 'From';
        this.Spa_AgentReports_To_Label = 'To';
        this.Spa_Agent_Search_AgentUserName_Text = 'Agent Username';
        this.Spa_Agent_AccountOverview_AgencyName_Text = 'Agency name';
        this.Spa_AgentReports_Type_Label = 'Type';
        this.Spa_AgentReports_EnrollmentType_Label = 'Enrollment type';
        this.Spa_Site_AgentReports_AgentUsername_Field_Enabled = true;
        this.Spa_AgentReports_AgentUsername_Required = true;
        this.Spa_Site_AgentReports_AgencyName_Field_Enabled = true;
        this.Spa_AgentReports_AgencyName_Required = true;
        this.Spa_Site_AgentReports_SearchTypes_DropdownItems = SearchTypeItems;
        this.Spa_Site_AgentReports_EnrollmentTypes_DropdownItems = EnrollmentTypeItems;
        this.Spa_Site_Previous = 'Previous';
        this.Spa_Site_AgentReports_DateRangeHint_Text = `Date range must be ${SearchPlaceholder.DateRangeMax} days or less.`;
        this.Spa_AgentReports_LoadingReport_Text = `<h3 class="Spa_Style_H3">Loading report...</h3>
  <div class="Spa_Style_Regular_Font Spa_Style_Primary_Color Spa_Style_Regular_Weight">This may take a few minutes, don’t navigate away from the page while the report finishes.</div>`;
        this.Spa_Site_Download_Report_Text = `<span>Downloading results...</span>`;
        this.Spa_AgentReports_NoResults_Text = `<h3 class="Spa_Style_H3">No results</h3>
  <div class="Spa_Style_Regular_Font Spa_Style_Primary_Color Spa_Style_Regular_Weight">There are no profiles that match this search criteria. Try selecting a new date range or report type and run the report again.</div>`;
        this.Spa_Agent_Search_Updated_Text = 'updated';
        this.Spa_DateRange_Maximum = '7';
        this.Spa_Site_AgentReports_Enabled = false;
        this.Spa_Site_AgentReports_AdminOnly_Enabled = false;
        this.Spa_DateRange_MinimumDate = '01/01/2016';
        this.AgencyHierarchy_Enabled = false;
        this.Spa_EnrollmentHistory_EnrollmentStatus_Enabled = false;
        this.isAdminUser = false;
        this.showAgentDetails = false;
        this.isPristine = true;
        this.showSpinner = false;
        this.reportFormattedData = [];
        this.showDownloadSpinner = false;
        this.reportListLength = 0;
        this.agencyDropdownItems = [];
        this.Spa_Agent_Search_SortHeader_Text = 'Sort';
        this.Spa_Filter_Header_Text = 'Filters';
        this.Spa_Filter_Default_Filter_Text = 'No filters available';
        this.Spa_Site_Report_Filter_Enabled = true;
        // download
        this.Spa_Site_Download_Icon = 'fas fa-download';
        this.Spa_Style_Primary_Link = '#016C86';
        this.Spa_Site_DownloadLink_Text = ' Download results';
        this.Spa_AgentReports_Download_Enabled = true;
        this.sortOptions = [];
        // carrier
        this.carrierList = [];
        this.Spa_PlanFilters_CarrierLabel_Text = 'Carriers';
        this.Spa_Report_Carrier_Filter_Enabled = true;
        // state
        this.stateList = [];
        this.Spa_Agent_Search_State_Text = 'States';
        this.Spa_Report_State_Filter_Enabled = true;
        // filter
        this.Spa_Filter_Clear_All = 'Clear all';
        this.Spa_PlanFilters_Modal_Cancel_Button = 'Cancel';
        this.Spa_PlanFilters_Modal_Apply_Button = 'Apply';
        this.Spa_Site_None_Available_Text = 'None available';
        this.Spa_Profile_Search_Show_AgentUserName = true;
        this.Spa_Site_AgentCallRecordingShopping_Enabled = true;
        this.subscriptions = new Subscription();
        this.viewMemberSubject$ = new Subject();
        this.widgetId = uuid();
    }
    ngOnInit() {
        super.ngOnInit();
        const agentRole = this.agentPermissionsService.getAgentRole();
        this.isAdminUser = this.agentPermissionsService.isAdmin(agentRole);
        this.showAgentDetails = this.agentPermissionsService.hasBasicRole(agentRole);
        this.sortOptions = this.agentSearchFacade.getSortOptions(this.widgetId);
        // will always default to be last name so grabbing the first option is fine
        this.sortOption = this.sortOptions[0];
        this.subscriptions.add(this.profileFacade.isBeneficiarySearch$.subscribe({
            next: isReportSearchNavigationClicked => {
                if (!isReportSearchNavigationClicked) {
                    this.agentSearchFacade.clearSearch();
                }
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.onViewMember$().subscribe(() => this.handleOnViewMember()));
        this.subscriptions.add(this.agentService.getAgencies$().subscribe(agencies => {
            this.agencyDropdownItems = this.agenciesToDropdownItems(agencies);
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe(locale => {
            this.locale = locale;
            this.cdr.markForCheck();
        }));
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
    runSearch(payload) {
        this.isPristine = false;
        this.showSpinner = true;
        this.enrollmentType = payload?.enrollmentType;
        const searchStartDate = new Date();
        this.agentSearchFacade
            .searchMembers$(payload)
            .pipe(take(1))
            .subscribe({
            next: () => {
                this.cdr.markForCheck();
            },
            complete: () => {
                this.getFilterOptions();
                const searchEndDate = new Date();
                this.analyticsService.googleDataLayerTags = {
                    [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CASE_REPORT_SEARCH_RESULT_RETURN,
                    [DataLayerGlobalVariable.REPORT_SEARCH_RESULT_COUNT]: this.reportListLength.toString(),
                    [DataLayerGlobalVariable.REPORT_SEARCH_RESULT_LOAD_TIME]: DateUtilities.getTimeDuration(searchStartDate, searchEndDate)?.toString()
                };
                this.showSpinner = false;
            }
        });
    }
    backToPrevious() {
        this.navigationService.backToPrevious();
    }
    navigateByPageTag(pageTag) {
        this.navigationService.navigateByPageTag(pageTag);
    }
    showHideFilter() {
        return true;
    }
    downloadResults() {
        const ReportDownloadPayload = [];
        let memberSearchList = [];
        this.showDownloadSpinner = true;
        this.reportList$.pipe(take(1)).subscribe(reportDetails => {
            if (reportDetails.length) {
                memberSearchList = reportDetails;
                reportDetails.forEach(item => item.enrollments.filter(enrollment => {
                    ReportDownloadPayload.push({ agentGuid: enrollment.agentGUID, transactionGuid: enrollment.transactionGUID });
                }));
            }
        });
        this.reportFormattedData = [];
        this.agentHttpService
            .memberProfileDownload$({ memberSearchReportRequestElements: ReportDownloadPayload })
            .subscribe((reportDetail) => {
            if (reportDetail?.memberSearchReports.length) {
                reportDetail.memberSearchReports.forEach(report => {
                    memberSearchList.forEach(memberDetail => {
                        memberDetail.enrollments.forEach(enrollment => {
                            if (report.transactionGuid === enrollment.transactionGUID) {
                                this.reportFormattedData.push({
                                    confirmationNumber: memberDetail.confirmationNumber,
                                    agentFirstName: memberDetail.firstName,
                                    agentLastName: memberDetail.lastName,
                                    carrierName: report.carrierName,
                                    plan: enrollment.plan?.replace(/,/g, ''),
                                    contractPlanSegment: report.contractPlanSegment,
                                    planType: report.planType === PlanTypeAbbreviation.MEDIGAP ? 'MedSup' : report.planType,
                                    planSubType: report.planSubType,
                                    planSNPType: report.planSNPType === SNP_TYPE.NOT_SNP ? '' : report.planSNPType,
                                    riderNames: report.riderNames,
                                    submissionDate: report.submissionDate,
                                    requestedEffectiveDate: report.requestedEffectiveDate,
                                    effectiveDate: report.effectiveDate,
                                    agentUsername: report.agentUsername,
                                    partnerID: report.partnerID,
                                    agencyID: report.agencyID,
                                    agentID: report.agentID,
                                    agentProducerID: report.agentID,
                                    recordingAvailable: report.recordingAvailable,
                                    enrollmentStatus: report.enrollmentStatus ?? '',
                                    statusUpdateDate: report.enrollmentStatusDate ?? ''
                                });
                            }
                        });
                    });
                });
                this.formattedReportSearch(this.reportFormattedData);
                this.updateGoogDataLayerTags();
            }
            this.showDownloadSpinner = false;
            this.cdr.markForCheck();
        });
    }
    formattedReportSearch(reportData) {
        let reportSearchHeadings = REPORT_SEARCH_RESULTS_FILE_COLUMN_HEADINGS;
        let reportSearchColumnfields = REPORT_SEARCH_RESULTS_FILE_COLUMN_FIELDS;
        // Reorder Json response for specific fields
        if (this.Spa_Site_AgentCallRecordingShopping_Enabled) {
            reportSearchColumnfields = [...reportSearchColumnfields, REPORT_SEARCH_CALL_RECORD_COLUMN.CALL_RECORD_COLUMN_FIELD];
            reportSearchHeadings = [...reportSearchHeadings, REPORT_SEARCH_CALL_RECORD_COLUMN.CALL_RECORD_HEADER];
        }
        if (this.Spa_EnrollmentHistory_EnrollmentStatus_Enabled && this.enrollmentType === EnrollmentType.Medicare) {
            reportSearchColumnfields = [
                ...reportSearchColumnfields,
                REPORT_SEARCH_ENROLLMENT_STATUS_COLUMN.ENROLLMENT_STATUS_COLUMN_FIELD,
                REPORT_SEARCH_ENROLLMENT_STATUS_UPDATE_COLUMN.ENROLLMENT_STATUS_UPDATE_COLUMN_FIELD
            ];
            reportSearchHeadings = [
                ...reportSearchHeadings,
                REPORT_SEARCH_ENROLLMENT_STATUS_COLUMN.ENROLLMENT_STATUS_HEADER,
                REPORT_SEARCH_ENROLLMENT_STATUS_UPDATE_COLUMN.ENROLLMENT_STATUS_UPDATE_HEADER
            ];
        }
        const formatData = JSON.parse(JSON.stringify(reportData, reportSearchColumnfields));
        const contentType = AGENT_REPORT_RESULTS_FILE_EXTENSION;
        // download file data and header names
        const dataURI = `${this.fileUtilityService.convertToCsv(formatData, reportSearchHeadings)}`;
        const fileName = `${AGENT_REPORT_RESULTS_FILENAME} - ${DateUtilities.getFormattedCurrentDate(DateUtilities.defaultDateISOFormat)}${AGENT_REPORT_FILE_TYPE}`;
        this.fileUtilityService.downloadFile(dataURI, fileName, contentType);
    }
    updateGoogDataLayerTags() {
        const googleDataLayerTags = this.analyticsService.googleDataLayerTags;
        const previousDownloadCount = googleDataLayerTags[DataLayerGlobalVariable.REPORT_DOWNLOAD_COUNT];
        let downloadCount = 1;
        if (previousDownloadCount) {
            downloadCount = downloadCount + parseInt(previousDownloadCount, 10);
        }
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_REPORT_DOWNLOAD,
            [DataLayerGlobalVariable.REPORT_DOWNLOAD_COUNT]: `${downloadCount}`
        };
    }
    applyReportFilters(selectedFilters) {
        this.popover.close();
        const initiallyChecked = !selectedFilters.clearFilters;
        // set all initial check to false whenever new search appears
        this.stateList.map(stateDetail => (stateDetail.initiallyChecked = false));
        this.carrierList.map(carrierDetail => (carrierDetail.initiallyChecked = false));
        if (selectedFilters.carriers.length) {
            selectedFilters.carriers.map(carrierId => {
                this.carrierList[this.carrierList.findIndex(x => x.value === carrierId)].initiallyChecked = initiallyChecked;
            });
        }
        if (selectedFilters.states.length) {
            selectedFilters.states.map(stateDetail => {
                this.stateList[this.stateList.findIndex(x => x.value === stateDetail.value)].initiallyChecked = initiallyChecked;
            });
        }
        if (selectedFilters.clearFilters) {
            this.popover.open();
        }
    }
    get reportList$() {
        return this.agentSearchFacade.getMembers$().pipe(map((members) => {
            this.reportListLength = (members && members.length) || 0;
            if (!members || members.length === 0) {
                return [];
            }
            const carriersFilterSelected = this.carrierList.some(carrier => carrier.initiallyChecked === true);
            const statesFilterSelected = this.stateList.some(state => state.initiallyChecked === true);
            if (members.length && (statesFilterSelected || carriersFilterSelected)) {
                const filteredResult = [];
                const filteredMember = [];
                if (statesFilterSelected) {
                    this.stateList
                        .filter(state => state.initiallyChecked === true)
                        .forEach(stateDetail => members.forEach(memberDetails => {
                        if (memberDetails?.state === stateDetail.value) {
                            if (carriersFilterSelected) {
                                filteredMember.push(memberDetails);
                            }
                            else {
                                filteredResult.push(memberDetails);
                            }
                        }
                    }));
                }
                if (filteredMember.length && carriersFilterSelected) {
                    filteredMember.forEach(member => {
                        this.carrierList
                            .filter(carrier => carrier.initiallyChecked === true)
                            .forEach(carrierDetail => {
                            const exists = member?.enrollments.some(filteredState => filteredState.carrierName === carrierDetail.value);
                            if (exists) {
                                filteredResult.push(member);
                            }
                        });
                    });
                }
                else {
                    this.carrierList
                        .filter(carrier => carrier.initiallyChecked === true)
                        .forEach(carrierDetail => {
                        members.forEach(memberDetails => {
                            const exists = memberDetails?.enrollments.some(enroll => enroll.carrierName === carrierDetail.value);
                            if (exists) {
                                filteredResult.push(memberDetails);
                            }
                        });
                    });
                }
                return this.getSortedMembers(filteredResult);
            }
            return this.getSortedMembers(members);
        }));
    }
    getSortedMembers(members) {
        if (this.sortOption.value === SortFields.PROFILE_DATE) {
            return this.orderPipe.transform(members, [this.sortOption.value, this.sortOptions[0].value], true, true);
        }
        else {
            return this.orderPipe.transform(members, [this.sortOption.value, this.sortOptions[0].value], null, true);
        }
    }
    getFilterOptions() {
        // get only unique states to view in filters popover
        const states = this.getUniqueValue('state');
        this.stateList = [];
        states.forEach(stateExists => {
            const index = DemographicStates.findIndex(state => stateExists === state.StateAbbrev);
            // get state full name from demographic
            if (index !== -1) {
                this.stateList.push({
                    label: DemographicStates[index].StateName,
                    value: DemographicStates[index].StateAbbrev,
                    initiallyChecked: false,
                    disabled: false
                });
            }
        });
        this.stateList.sort((state, sortItem) => (state.label > sortItem.label ? 1 : -1));
        // get only unique carrierName to view in filters popover
        this.carrierList = [];
        const carriers = this.getUniqueValue('carrierName');
        carriers.forEach(carrier => {
            this.carrierList.push({
                label: carrier,
                value: carrier,
                initiallyChecked: false,
                disabled: false
            });
        });
        this.carrierList.sort((carrier, sortItem) => (carrier.label > sortItem.label ? 1 : -1));
    }
    getUniqueValue(key) {
        const uniqueOptions = [];
        this.reportList$.pipe(take(1)).subscribe((reportDetails) => {
            if (reportDetails.length) {
                reportDetails.forEach(item => {
                    if (key === 'state') {
                        if (item[key]) {
                            const exists = uniqueOptions.some(x => x === item[key]);
                            if (!exists) {
                                uniqueOptions.push(item[key]);
                            }
                        }
                    }
                    if (key === 'carrierName') {
                        item?.enrollments.forEach(enroll => {
                            if (enroll[key]) {
                                const exists = uniqueOptions.some(x => x === enroll[key]);
                                if (!exists) {
                                    uniqueOptions.push(enroll[key]);
                                }
                            }
                        });
                    }
                    return null;
                });
            }
        });
        return uniqueOptions;
    }
    viewMember(member) {
        this.viewMemberSubject$.next(member);
    }
    onViewMember$() {
        return this.viewMemberSubject$.pipe(exhaustMap((member) => this.agentSearchFacade.selectMember$(member.memberID)));
    }
    handleOnViewMember() {
        this.agentSearchFacade.clearSearch();
        this.agentSearchFacade.updateMemberDetails();
        this.agentSearchFacade.navigateByPageTag(PageTags.ADD_NEW_PROFILE);
        this.profileFacade.beneficiarySearchNavigationClicked(true);
    }
    agenciesToDropdownItems(agencies) {
        const allAgencies = agencies
            .reduce((selectedAgencies, agency) => {
            if (agency.agencyName && agency.agencyName !== 'null') {
                selectedAgencies.push({
                    displayValue: agency.agencyName,
                    selectionValue: agency.agencyGuid
                });
            }
            return selectedAgencies;
        }, [])
            .sort(({ displayValue: displayValueA }, { displayValue: displayValueB }) => (displayValueA > displayValueB ? 1 : -1));
        allAgencies.unshift({ displayValue: 'None', selectionValue: '' });
        return allAgencies;
    }
};
ReportsSummaryComponent.ɵfac = function ReportsSummaryComponent_Factory(t) { return new (t || ReportsSummaryComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(AgentSearchFacade), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(i1.AgentPermissionsService), i0.ɵɵdirectiveInject(ProfileFacade), i0.ɵɵdirectiveInject(OrderPipe), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.AgentHttpService), i0.ɵɵdirectiveInject(i1.FileDownloadUtilityService)); };
ReportsSummaryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ReportsSummaryComponent, selectors: [["vnext-widget-reports-summary"]], viewQuery: function ReportsSummaryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3d, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popover = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService, OrderPipe]), i0.ɵɵInheritDefinitionFeature], decls: 14, vars: 29, consts: [["vnextGoogleTagManager", "", 1, "container", 3, "saveDefaultValues"], [1, "col-12", "c-mt-30", "c-mb-30"], [1, "col-auto", "mx-auto", "text-center"], [3, "title", "showArrow", "click", "keyup.enter", 4, "liveEditProp"], ["class", "Spa_Style_H1 c-mt-30 c-mb-30 text-center", 4, "liveEditProp"], [1, "row", "col-12", "c-mb-30"], ["navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [1, "px-1", "mb-5"], [3, "submittedDateRangeLabel", "fromLabel", "toLabel", "agentUsernameLabel", "agencyNameLabel", "typeLabel", "enrollmentTypeLabel", "runReportButtonText", "agentUsernameFieldEnabled", "agentUsernameFieldRequired", "agencyNameFieldEnabled", "agencyNameFieldRequired", "searchTypeItems", "agencyItems", "noneAvailableLabel", "enrollmentTypesItems", "dateRangeMax", "minDate", "dateRangeHintText", "isAdminUser", "agencyHierarchyEnabled", "locale", "runSearch"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["emptyState", ""], ["searchResults", ""], [3, "title", "showArrow", "click", "keyup.enter"], [1, "Spa_Style_H1", "c-mt-30", "c-mb-30", "text-center"], ["navigationAdapter", "", 3, "innerHtml"], [1, "row", "flex-column", "align-items-center", "text-center", "py-5"], [1, "fas", "fa-chart-bar", "fa-3x", "mb-3", "report-icon"], [3, "innerHTML", 4, "liveEditProp"], [3, "innerHTML"], [4, "ngIf"], [3, "reportList", "locale", "noResultsText", "updated", "isAdminUser", "showAgentDetails", "searchShowAgentUserName", "agencyHierarchyEnabled", "linkClick", 4, "ngIf"], [1, "form-row", "px-1", "mt-5", "py-3"], [1, "col-12", "col-sm-4", "col-md-4", "px-0", "float-left", "download-text"], ["class", "pl-2 link", 3, "title", "alwaysUnderlined", "linkTarget", "additionalIcon", "iconColor", "click", 4, "ngIf"], ["class", "pl-2 pt-4 Spa_Style_Primary_Link_Color Spa_Style_Link", 4, "ngIf"], [1, "col-12", "col-sm-6", "col-md-4", "ml-md-auto", "ml-sm-auto", "px-0"], ["id", "sortHeaderId", "class", "Spa_Style_H4", 4, "liveEditProp"], ["ngbDropdown", "", 1, "position-relative"], ["tabindex", "0", "type", "text", "autocomplete", "new-text", "ngbDropdownToggle", "", "placeholder", "", "aria-labelledby", "sortHeaderId", 1, "form-control", "can-click", "dropdown", 3, "ngModel", "keydown", "ngModelChange"], ["ngbDropdownToggle", "", 1, "fas", "fa-angle-down", "icon-in-input", "can-click", "float-right"], [1, "sr-only"], ["ngbDropdownMenu", ""], ["ngbDropdownItem", "", "class", "can-click", 3, "click", 4, "ngFor", "ngForOf"], ["class", "mr-0 d-none d-md-block filter-text", 4, "ngIf"], ["filterTooltipContent", ""], ["showNoFilterMessage", ""], [1, "pl-2", "link", 3, "title", "alwaysUnderlined", "linkTarget", "additionalIcon", "iconColor", "click"], [1, "pl-2", "pt-4", "Spa_Style_Primary_Link_Color", "Spa_Style_Link"], [1, "fa", "fa-spinner", "fa-pulse", "fa-fw", "float-left"], [1, "pl-4", 3, "innerHTML"], ["id", "sortHeaderId", 1, "Spa_Style_H4"], ["ngbDropdownItem", "", 1, "can-click", 3, "click"], [1, "mr-0", "d-none", "d-md-block", "filter-text"], ["class", "flex-row-nowrap ml-4 mb-2 can-click reportFilter", "placement", "bottom-right", 3, "ngbPopover", "autoClose", 4, "ngIf", "ngIfElse"], ["placement", "bottom-right", 1, "flex-row-nowrap", "ml-4", "mb-2", "can-click", "reportFilter", 3, "ngbPopover", "autoClose"], ["reportPopover", "ngbPopover"], [1, "fas", "fa-filter", "Spa_Style_Accent3_Color", "mb-1"], [1, "ml-1", "Spa_Style_Paragraph"], [1, "fas", "fa-chevron-down", "Spa_Style_Accent3_Color", "ml-2", "pb-1", "Spa_Style_Smaller_Font"], [1, "px-2", "filter-popover"], [3, "reportFilterClearText", "carriers", "carrierLabel", "carrierEnabled", "states", "stateLabel", "stateEnabled", "reportApplyButtonText", "reportCancelButtonText", "enrollmentType", "selectedReportFilters", "closePopover"], [1, "my-2", "ml-2"], [3, "reportList", "locale", "noResultsText", "updated", "isAdminUser", "showAgentDetails", "searchShowAgentUserName", "agencyHierarchyEnabled", "linkClick"], [1, "fa", "fa-spinner", "fa-pulse", "fa-2x", "fa-fw", "mb-3"]], template: function ReportsSummaryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, ReportsSummaryComponent_vnext_link_3_Template, 1, 2, "vnext-link", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, ReportsSummaryComponent_div_4_Template, 2, 1, "div", 4);
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵtemplate(6, ReportsSummaryComponent_div_6_Template, 2, 4, "div", 6);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 7)(8, "vnext-report-search", 8);
        i0.ɵɵlistener("runSearch", function ReportsSummaryComponent_Template_vnext_report_search_runSearch_8_listener($event) { return ctx.runSearch($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(9, ReportsSummaryComponent_ng_container_9_Template, 1, 0, "ng-container", 9);
        i0.ɵɵtemplate(10, ReportsSummaryComponent_ng_template_10_Template, 3, 1, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(12, ReportsSummaryComponent_ng_template_12_Template, 3, 4, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r4 = i0.ɵɵreference(11);
        const _r6 = i0.ɵɵreference(13);
        i0.ɵɵproperty("saveDefaultValues", true);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_Previous");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_AgentReports_Header_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_PageSubHeader_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("submittedDateRangeLabel", ctx.Spa_AgentReports_SubmittedDateRange_Label)("fromLabel", ctx.Spa_AgentReports_From_Label)("toLabel", ctx.Spa_AgentReports_To_Label)("agentUsernameLabel", ctx.Spa_Agent_Search_AgentUserName_Text)("agencyNameLabel", ctx.Spa_Agent_AccountOverview_AgencyName_Text)("typeLabel", ctx.Spa_AgentReports_Type_Label)("enrollmentTypeLabel", ctx.Spa_AgentReports_EnrollmentType_Label)("runReportButtonText", ctx.Spa_AgentReports_RunReport_Text)("agentUsernameFieldEnabled", ctx.Spa_Site_AgentReports_AgentUsername_Field_Enabled)("agentUsernameFieldRequired", ctx.Spa_AgentReports_AgentUsername_Required)("agencyNameFieldEnabled", ctx.Spa_Site_AgentReports_AgencyName_Field_Enabled)("agencyNameFieldRequired", ctx.Spa_AgentReports_AgencyName_Required)("searchTypeItems", ctx.Spa_Site_AgentReports_SearchTypes_DropdownItems)("agencyItems", ctx.agencyDropdownItems)("noneAvailableLabel", ctx.Spa_Site_None_Available_Text)("enrollmentTypesItems", ctx.Spa_Site_AgentReports_EnrollmentTypes_DropdownItems)("dateRangeMax", ctx.Spa_DateRange_Maximum)("minDate", ctx.Spa_DateRange_MinimumDate)("dateRangeHintText", ctx.Spa_Site_AgentReports_DateRangeHint_Text)("isAdminUser", ctx.isAdminUser)("agencyHierarchyEnabled", ctx.AgencyHierarchy_Enabled)("locale", ctx.locale);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isPristine)("ngIfThen", _r4)("ngIfElse", _r6);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, LinkComponent, NavigationAdapterDirective, LiveEditPropDirective, GoogleTagManagerDirective, IconAriaAttributesDirective, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem, i1$1.NgbPopover, ReportSearchComponent, ReportListComponent, ReportSummaryFilterItemsComponent, i1$2.AsyncPipe, SafePipe], styles: [".report-icon[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Gray2)}.icon-in-input[_ngcontent-%COMP%]{position:absolute;top:8px;left:calc(100% - 15px)}input.dropdown[_ngcontent-%COMP%]{height:30px}.dropdown[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{width:100%;padding:0;margin-top:0}.dropdown-menu[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]{padding:6px 10px;white-space:normal}.reportFilter[_ngcontent-%COMP%]{background:none;border:none;padding:0;cursor:pointer}[_nghost-%COMP%]     .popover, .bs-popover-auto[_ngcontent-%COMP%]{max-width:95%;margin-top:24px;box-shadow:2px 4px 12px 2px;color:var(--static-Spa_Style-Gray2)!important;z-index:1}.filter-popover[_ngcontent-%COMP%]{width:980px}.download-text[_ngcontent-%COMP%]{margin-top:8px}.filter-text[_ngcontent-%COMP%]{margin-top:auto}@media (max-width: 768px){.download-text[_ngcontent-%COMP%]{padding-bottom:24px;margin-top:auto}}"], changeDetection: 0 });
__decorate([
    PlatformProp('live-edit')
], ReportsSummaryComponent.prototype, "Spa_AgentReports_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], ReportsSummaryComponent.prototype, "Spa_Site_PageSubHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], ReportsSummaryComponent.prototype, "Spa_AgentReports_RunReport_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], ReportsSummaryComponent.prototype, "Spa_AgentReports_EmptyState_Text", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_AgentReports_SubmittedDateRange_Label", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_AgentReports_From_Label", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_AgentReports_To_Label", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Agent_Search_AgentUserName_Text", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Agent_AccountOverview_AgencyName_Text", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_AgentReports_Type_Label", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_AgentReports_EnrollmentType_Label", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Site_AgentReports_AgentUsername_Field_Enabled", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_AgentReports_AgentUsername_Required", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Site_AgentReports_AgencyName_Field_Enabled", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_AgentReports_AgencyName_Required", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Site_AgentReports_SearchTypes_DropdownItems", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Site_AgentReports_EnrollmentTypes_DropdownItems", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Site_Previous", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Site_AgentReports_DateRangeHint_Text", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_AgentReports_LoadingReport_Text", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Site_Download_Report_Text", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_AgentReports_NoResults_Text", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Agent_Search_Updated_Text", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_DateRange_Maximum", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Site_AgentReports_Enabled", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Site_AgentReports_AdminOnly_Enabled", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_DateRange_MinimumDate", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "AgencyHierarchy_Enabled", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_EnrollmentHistory_EnrollmentStatus_Enabled", void 0);
__decorate([
    PlatformProp()
], ReportsSummaryComponent.prototype, "Spa_Agent_Search_SortHeader_Text", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Filter_Header_Text", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Filter_Default_Filter_Text", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Site_Report_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Site_Download_Icon", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Style_Primary_Link", void 0);
__decorate([
    PlatformProp()
], ReportsSummaryComponent.prototype, "Spa_Site_DownloadLink_Text", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_AgentReports_Download_Enabled", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_PlanFilters_CarrierLabel_Text", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Report_Carrier_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Report_State_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Filter_Clear_All", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_PlanFilters_Modal_Cancel_Button", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_PlanFilters_Modal_Apply_Button", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Site_None_Available_Text", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Profile_Search_Show_AgentUserName", void 0);
__decorate([
    GlobalResource()
], ReportsSummaryComponent.prototype, "Spa_Site_AgentCallRecordingShopping_Enabled", void 0);
__decorate([
    Memoize()
], ReportsSummaryComponent.prototype, "agenciesToDropdownItems", null);
ReportsSummaryComponent = __decorate([
    PlatformWidget
], ReportsSummaryComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReportsSummaryComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-reports-summary', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService, OrderPipe], template: "<div class=\"container\" vnextGoogleTagManager [saveDefaultValues]=\"true\">\r\n  <div class=\"col-12 c-mt-30 c-mb-30\">\r\n    <div class=\"col-auto mx-auto text-center\">\r\n      <vnext-link\r\n        [title]=\"Spa_Site_Previous\"\r\n        [showArrow]=\"'left'\"\r\n        (click)=\"backToPrevious()\"\r\n        (keyup.enter)=\"backToPrevious()\"\r\n        *liveEditProp=\"'Spa_Site_Previous'\"\r\n      >\r\n      </vnext-link>\r\n    </div>\r\n    <div class=\"Spa_Style_H1 c-mt-30 c-mb-30 text-center\" *liveEditProp=\"'Spa_AgentReports_Header_Text'\">\r\n      {{ Spa_AgentReports_Header_Text }}\r\n    </div>\r\n    <div class=\"row col-12 c-mb-30\">\r\n      <div\r\n        *liveEditProp=\"'Spa_Site_PageSubHeader_Text'\"\r\n        [innerHtml]=\"Spa_Site_PageSubHeader_Text ? (Spa_Site_PageSubHeader_Text | safe : 'html') : ''\"\r\n        navigationAdapter\r\n      ></div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"px-1 mb-5\">\r\n    <vnext-report-search\r\n      [submittedDateRangeLabel]=\"Spa_AgentReports_SubmittedDateRange_Label\"\r\n      [fromLabel]=\"Spa_AgentReports_From_Label\"\r\n      [toLabel]=\"Spa_AgentReports_To_Label\"\r\n      [agentUsernameLabel]=\"Spa_Agent_Search_AgentUserName_Text\"\r\n      [agencyNameLabel]=\"Spa_Agent_AccountOverview_AgencyName_Text\"\r\n      [typeLabel]=\"Spa_AgentReports_Type_Label\"\r\n      [enrollmentTypeLabel]=\"Spa_AgentReports_EnrollmentType_Label\"\r\n      [runReportButtonText]=\"Spa_AgentReports_RunReport_Text\"\r\n      [agentUsernameFieldEnabled]=\"Spa_Site_AgentReports_AgentUsername_Field_Enabled\"\r\n      [agentUsernameFieldRequired]=\"Spa_AgentReports_AgentUsername_Required\"\r\n      [agencyNameFieldEnabled]=\"Spa_Site_AgentReports_AgencyName_Field_Enabled\"\r\n      [agencyNameFieldRequired]=\"Spa_AgentReports_AgencyName_Required\"\r\n      [searchTypeItems]=\"Spa_Site_AgentReports_SearchTypes_DropdownItems\"\r\n      [agencyItems]=\"agencyDropdownItems\"\r\n      [noneAvailableLabel]=\"Spa_Site_None_Available_Text\"\r\n      [enrollmentTypesItems]=\"Spa_Site_AgentReports_EnrollmentTypes_DropdownItems\"\r\n      [dateRangeMax]=\"Spa_DateRange_Maximum\"\r\n      [minDate]=\"Spa_DateRange_MinimumDate\"\r\n      [dateRangeHintText]=\"Spa_Site_AgentReports_DateRangeHint_Text\"\r\n      [isAdminUser]=\"isAdminUser\"\r\n      [agencyHierarchyEnabled]=\"AgencyHierarchy_Enabled\"\r\n      [locale]=\"locale\"\r\n      (runSearch)=\"runSearch($event)\"\r\n    ></vnext-report-search>\r\n  </div>\r\n\r\n  <ng-container *ngIf=\"isPristine; then emptyState; else searchResults\"></ng-container>\r\n\r\n  <ng-template #emptyState>\r\n    <div class=\"row flex-column align-items-center text-center py-5\">\r\n      <i class=\"fas fa-chart-bar fa-3x mb-3 report-icon\"></i>\r\n      <div [innerHTML]=\"Spa_AgentReports_EmptyState_Text | safe : 'html'\" *liveEditProp=\"'Spa_AgentReports_EmptyState_Text'\"></div>\r\n    </div>\r\n  </ng-template>\r\n\r\n  <ng-template #searchResults>\r\n    <ng-container *ngIf=\"reportList$ | async as reportList\">\r\n      <ng-container *ngIf=\"reportList?.length && !showSpinner\">\r\n        <div class=\"form-row px-1 mt-5 py-3\">\r\n          <div class=\"col-12 col-sm-4 col-md-4 px-0 float-left download-text\">\r\n            <vnext-link\r\n              *ngIf=\"Spa_AgentReports_Download_Enabled && !showDownloadSpinner\"\r\n              class=\"pl-2 link\"\r\n              (click)=\"downloadResults()\"\r\n              [title]=\"Spa_Site_DownloadLink_Text\"\r\n              [alwaysUnderlined]=\"true\"\r\n              [linkTarget]=\"'_blank'\"\r\n              [additionalIcon]=\"Spa_Site_Download_Icon\"\r\n              [iconColor]=\"Spa_Style_Primary_Link\"\r\n            ></vnext-link>\r\n            <div *ngIf=\"showDownloadSpinner\" class=\"pl-2 pt-4 Spa_Style_Primary_Link_Color Spa_Style_Link\">\r\n              <i class=\"fa fa-spinner fa-pulse fa-fw float-left\"></i>\r\n              <div class=\"pl-4\" [innerHTML]=\"Spa_Site_Download_Report_Text | safe : 'html'\"></div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-12 col-sm-6 col-md-4 ml-md-auto ml-sm-auto px-0\">\r\n            <h4 id=\"sortHeaderId\" class=\"Spa_Style_H4\" *liveEditProp=\"'Spa_Agent_Search_SortHeader_Text'\">\r\n              {{ Spa_Agent_Search_SortHeader_Text }}\r\n            </h4>\r\n            <div class=\"position-relative\" ngbDropdown>\r\n              <input\r\n                tabindex=\"0\"\r\n                type=\"text\"\r\n                autocomplete=\"new-text\"\r\n                ngbDropdownToggle\r\n                placeholder=\"\"\r\n                class=\"form-control can-click dropdown\"\r\n                aria-labelledby=\"sortHeaderId\"\r\n                [ngModel]=\"sortOption.label\"\r\n                (keydown)=\"$event.preventDefault()\"\r\n                (ngModelChange)=\"(sortOption)\"\r\n              />\r\n              <i class=\"fas fa-angle-down icon-in-input can-click float-right\" ngbDropdownToggle></i>\r\n              <span class=\"sr-only\">Expand menu</span>\r\n              <div ngbDropdownMenu>\r\n                <div *ngFor=\"let sort of sortOptions\" (click)=\"sortOption = sort\" ngbDropdownItem class=\"can-click\">\r\n                  {{ sort.label }}\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <div\r\n            class=\"mr-0 d-none d-md-block filter-text\"\r\n            *ngIf=\"Spa_Site_Report_Filter_Enabled && (carrierList.length > 1 || stateList.length > 1)\"\r\n          >\r\n            <button\r\n              *ngIf=\"showHideFilter(); else showNoFilterMessage\"\r\n              class=\"flex-row-nowrap ml-4 mb-2 can-click reportFilter\"\r\n              #reportPopover=\"ngbPopover\"\r\n              [ngbPopover]=\"filterTooltipContent\"\r\n              placement=\"bottom-right\"\r\n              [autoClose]=\"'outside'\"\r\n            >\r\n              <i class=\"fas fa-filter Spa_Style_Accent3_Color mb-1\"></i\r\n              ><span class=\"ml-1 Spa_Style_Paragraph\">{{ Spa_Filter_Header_Text }}</span\r\n              ><i class=\"fas fa-chevron-down Spa_Style_Accent3_Color ml-2 pb-1 Spa_Style_Smaller_Font\"></i>\r\n              <span class=\"sr-only\">Expand filter</span>\r\n            </button>\r\n          </div>\r\n        </div>\r\n\r\n        <ng-template #filterTooltipContent>\r\n          <div class=\"px-2 filter-popover\">\r\n            <vnext-report-summary-filter-items\r\n              [reportFilterClearText]=\"Spa_Filter_Clear_All\"\r\n              [carriers]=\"carrierList\"\r\n              [carrierLabel]=\"Spa_PlanFilters_CarrierLabel_Text\"\r\n              [carrierEnabled]=\"Spa_Report_Carrier_Filter_Enabled\"\r\n              [states]=\"stateList\"\r\n              [stateLabel]=\"Spa_Agent_Search_State_Text\"\r\n              [stateEnabled]=\"Spa_Report_State_Filter_Enabled\"\r\n              (selectedReportFilters)=\"applyReportFilters($event)\"\r\n              [reportApplyButtonText]=\"Spa_PlanFilters_Modal_Apply_Button\"\r\n              [reportCancelButtonText]=\"Spa_PlanFilters_Modal_Cancel_Button\"\r\n              [enrollmentType]=\"enrollmentType\"\r\n              (closePopover)=\"popover.close()\"\r\n            >\r\n            </vnext-report-summary-filter-items>\r\n          </div>\r\n        </ng-template>\r\n\r\n        <ng-template #showNoFilterMessage>\r\n          <div class=\"my-2 ml-2\">{{ Spa_Filter_Default_Filter_Text }}</div>\r\n        </ng-template>\r\n      </ng-container>\r\n\r\n      <!-- TODO: SPA-8815 - check if showAgentDetails's value should change depending on the user's permissions -->\r\n      <vnext-report-list\r\n        *ngIf=\"!showSpinner\"\r\n        [reportList]=\"reportList\"\r\n        [locale]=\"locale\"\r\n        [noResultsText]=\"Spa_AgentReports_NoResults_Text\"\r\n        [updated]=\"Spa_Agent_Search_Updated_Text\"\r\n        [isAdminUser]=\"isAdminUser\"\r\n        [showAgentDetails]=\"showAgentDetails\"\r\n        [searchShowAgentUserName]=\"Spa_Profile_Search_Show_AgentUserName\"\r\n        [agencyHierarchyEnabled]=\"AgencyHierarchy_Enabled\"\r\n        (linkClick)=\"viewMember($event)\"\r\n      ></vnext-report-list>\r\n    </ng-container>\r\n    <div *ngIf=\"showSpinner\">\r\n      <div class=\"row flex-column align-items-center text-center py-5\">\r\n        <i class=\"fa fa-spinner fa-pulse fa-2x fa-fw mb-3\"></i>\r\n        <div [innerHTML]=\"Spa_AgentReports_LoadingReport_Text | safe : 'html'\"></div>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n", styles: [".report-icon{color:var(--static-Spa_Style_Gray2)}.icon-in-input{position:absolute;top:8px;left:calc(100% - 15px)}input.dropdown{height:30px}.dropdown .dropdown-menu{width:100%;padding:0;margin-top:0}.dropdown-menu .dropdown-item{padding:6px 10px;white-space:normal}.reportFilter{background:none;border:none;padding:0;cursor:pointer}:host >>> .popover,.bs-popover-auto{max-width:95%;margin-top:24px;box-shadow:2px 4px 12px 2px;color:var(--static-Spa_Style-Gray2)!important;z-index:1}.filter-popover{width:980px}.download-text{margin-top:8px}.filter-text{margin-top:auto}@media (max-width: 768px){.download-text{padding-bottom:24px;margin-top:auto}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: AgentSearchFacade }, { type: i1.LocaleService }, { type: i1.NavigationService }, { type: i1.AgentService }, { type: i1.AgentPermissionsService }, { type: ProfileFacade }, { type: OrderPipe }, { type: AnalyticsService }, { type: i1.AgentHttpService }, { type: i1.FileDownloadUtilityService }]; }, { Spa_AgentReports_Header_Text: [], Spa_Site_PageSubHeader_Text: [], Spa_AgentReports_RunReport_Text: [], Spa_AgentReports_EmptyState_Text: [], Spa_AgentReports_SubmittedDateRange_Label: [], Spa_AgentReports_From_Label: [], Spa_AgentReports_To_Label: [], Spa_Agent_Search_AgentUserName_Text: [], Spa_Agent_AccountOverview_AgencyName_Text: [], Spa_AgentReports_Type_Label: [], Spa_AgentReports_EnrollmentType_Label: [], Spa_Site_AgentReports_AgentUsername_Field_Enabled: [], Spa_AgentReports_AgentUsername_Required: [], Spa_Site_AgentReports_AgencyName_Field_Enabled: [], Spa_AgentReports_AgencyName_Required: [], Spa_Site_AgentReports_SearchTypes_DropdownItems: [], Spa_Site_AgentReports_EnrollmentTypes_DropdownItems: [], Spa_Site_Previous: [], Spa_Site_AgentReports_DateRangeHint_Text: [], Spa_AgentReports_LoadingReport_Text: [], Spa_Site_Download_Report_Text: [], Spa_AgentReports_NoResults_Text: [], Spa_Agent_Search_Updated_Text: [], Spa_DateRange_Maximum: [], Spa_Site_AgentReports_Enabled: [], Spa_Site_AgentReports_AdminOnly_Enabled: [], Spa_DateRange_MinimumDate: [], AgencyHierarchy_Enabled: [], Spa_EnrollmentHistory_EnrollmentStatus_Enabled: [], Spa_Agent_Search_SortHeader_Text: [], popover: [{
            type: ViewChild,
            args: ['reportPopover']
        }], Spa_Filter_Header_Text: [], Spa_Filter_Default_Filter_Text: [], Spa_Site_Report_Filter_Enabled: [], Spa_Site_Download_Icon: [], Spa_Style_Primary_Link: [], Spa_Site_DownloadLink_Text: [], Spa_AgentReports_Download_Enabled: [], Spa_PlanFilters_CarrierLabel_Text: [], Spa_Report_Carrier_Filter_Enabled: [], Spa_Report_State_Filter_Enabled: [], Spa_Filter_Clear_All: [], Spa_PlanFilters_Modal_Cancel_Button: [], Spa_PlanFilters_Modal_Apply_Button: [], Spa_Site_None_Available_Text: [], Spa_Profile_Search_Show_AgentUserName: [], Spa_Site_AgentCallRecordingShopping_Enabled: [], agenciesToDropdownItems: [] }); })();

var SubHeaderActions;
(function (SubHeaderActions) {
    SubHeaderActions["GLOSSARY"] = "glossary";
    SubHeaderActions["CONTACT"] = "contact";
    SubHeaderActions["SAVE"] = "save";
    SubHeaderActions["LANGUAGE"] = "language";
    SubHeaderActions["PRINT"] = "print";
})(SubHeaderActions || (SubHeaderActions = {}));

const _c0$3c = ["languageDropDown"];
const _c1$1I = ["weglotLanguageDropDown"];
function LocalePickerComponent_ng_container_0_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵlistener("click", function LocalePickerComponent_ng_container_0_div_1_div_7_Template_div_click_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r9); const option_r7 = restoredCtx.$implicit; const ctx_r8 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r8.setWeglotLocale($event, option_r7)); })("keydown", function LocalePickerComponent_ng_container_0_div_1_div_7_Template_div_keydown_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r9); const option_r7 = restoredCtx.$implicit; const ctx_r10 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r10.setWeglotLocale($event, option_r7)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r7 = ctx.$implicit;
    i0.ɵɵattribute("role", "option")("aria-label", "Select " + option_r7.name + " language");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", option_r7.name, " ");
} }
const _c2$13 = function (a0, a1, a2) { return { "underline-title": a0, "icon-hover": a1, "agent-locale-picker": a2 }; };
const _c3$K = function (a0, a1) { return { "header-icon": a0, "header-icon-hover": a1 }; };
function LocalePickerComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4, 5);
    i0.ɵɵlistener("mouseover", function LocalePickerComponent_ng_container_0_div_1_Template_div_mouseover_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.hover = true); })("mouseleave", function LocalePickerComponent_ng_container_0_div_1_Template_div_mouseleave_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.hover = false); })("keyup.enter", function LocalePickerComponent_ng_container_0_div_1_Template_div_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r12); const _r5 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r5.toggle()); });
    i0.ɵɵelement(2, "i", 6);
    i0.ɵɵelementStart(3, "span", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelement(5, "i", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 9);
    i0.ɵɵtemplate(7, LocalePickerComponent_ng_container_0_div_1_div_7_Template, 2, 3, "div", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r5 = i0.ɵɵreference(1);
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(13, _c2$13, ctx_r3.isFooter && ctx_r3.hover, !ctx_r3.isFooter && ctx_r3.hover, ctx_r3.isAgentHeader))("autoClose", true);
    i0.ɵɵattribute("role", "combobox")("aria-label", ctx_r3.currentLanguageLabelText + " " + ctx_r3.currentWeglotLanguageName || ctx_r3.defaultWeglotLanguageName)("aria-expanded", _r5.isOpen());
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("", ctx_r3.link == null ? null : ctx_r3.link.iconName, " pr-1 Spa_Style_Gray4_Color");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(17, _c3$K, !ctx_r3.isFooter, !ctx_r3.isFooter && ctx_r3.hover));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.currentWeglotLanguageName || ctx_r3.defaultWeglotLanguageName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("role", "listbox");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.supportedWeglotLanguages)("ngForTrackBy", ctx_r3.trackByIndex);
} }
const _c4$q = function (a0) { return { "header-icon-selected": a0 }; };
function LocalePickerComponent_ng_container_0_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵlistener("mouseover", function LocalePickerComponent_ng_container_0_div_2_div_1_Template_div_mouseover_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r20); const index_r17 = restoredCtx.index; const ctx_r19 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r19.mobileHover = index_r17); })("mouseleave", function LocalePickerComponent_ng_container_0_div_2_div_1_Template_div_mouseleave_0_listener() { i0.ɵɵrestoreView(_r20); const ctx_r21 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r21.mobileHover = null); });
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵlistener("click", function LocalePickerComponent_ng_container_0_div_2_div_1_Template_div_click_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r20); const option_r16 = restoredCtx.$implicit; const ctx_r22 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r22.setWeglotLocale($event, option_r16)); })("keyup.enter", function LocalePickerComponent_ng_container_0_div_2_div_1_Template_div_keyup_enter_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r20); const option_r16 = restoredCtx.$implicit; const ctx_r23 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r23.setWeglotLocale($event, option_r16)); });
    i0.ɵɵelement(2, "i", 16);
    i0.ɵɵelementStart(3, "span", 17);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const option_r16 = ctx.$implicit;
    const last_r18 = ctx.last;
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", !last_r18 || last_r18 && ctx_r15.showLastBorder ? "border-bottom" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("tabindex", option_r16.locale === ctx_r15.currentWeglotLocale ? "-1" : "0");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c4$q, option_r16.locale === ctx_r15.currentWeglotLocale));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", option_r16.locale === ctx_r15.currentWeglotLocale ? "fas fa-check-circle" : ctx_r15.getLinkIconName() + " header-icon");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(option_r16.name);
} }
function LocalePickerComponent_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, LocalePickerComponent_ng_container_0_div_2_div_1_Template, 5, 7, "div", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.supportedWeglotLanguages)("ngForTrackBy", ctx_r4.trackByIndex);
} }
function LocalePickerComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LocalePickerComponent_ng_container_0_div_1_Template, 8, 20, "div", 2);
    i0.ɵɵtemplate(2, LocalePickerComponent_ng_container_0_div_2_Template, 2, 2, "div", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.headerDropdown);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.headerDropdown);
} }
function LocalePickerComponent_ng_template_1_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵlistener("click", function LocalePickerComponent_ng_template_1_div_0_div_7_Template_div_click_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r30); const option_r28 = restoredCtx.$implicit; const ctx_r29 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r29.setLocale($event, option_r28)); })("keydown", function LocalePickerComponent_ng_template_1_div_0_div_7_Template_div_keydown_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r30); const option_r28 = restoredCtx.$implicit; const ctx_r31 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r31.setLocale($event, option_r28)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r28 = ctx.$implicit;
    const ctx_r27 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("role", "option")("aria-label", "Select " + ctx_r27.LOCALE_ALIAS[option_r28] + " language");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r27.LOCALE_ALIAS[option_r28], " ");
} }
function LocalePickerComponent_ng_template_1_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4, 18);
    i0.ɵɵlistener("mouseover", function LocalePickerComponent_ng_template_1_div_0_Template_div_mouseover_0_listener() { i0.ɵɵrestoreView(_r33); const ctx_r32 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r32.hover = true); })("mouseleave", function LocalePickerComponent_ng_template_1_div_0_Template_div_mouseleave_0_listener() { i0.ɵɵrestoreView(_r33); const ctx_r34 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r34.hover = false); })("keyup.enter", function LocalePickerComponent_ng_template_1_div_0_Template_div_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r33); const _r26 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r26.toggle()); });
    i0.ɵɵelement(2, "i", 6);
    i0.ɵɵelementStart(3, "span", 19);
    i0.ɵɵtext(4);
    i0.ɵɵelement(5, "i", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 9);
    i0.ɵɵtemplate(7, LocalePickerComponent_ng_template_1_div_0_div_7_Template, 2, 3, "div", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r26 = i0.ɵɵreference(1);
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(13, _c2$13, ctx_r24.isFooter && ctx_r24.hover, !ctx_r24.isFooter && ctx_r24.hover, ctx_r24.isAgentHeader))("autoClose", true);
    i0.ɵɵattribute("role", "combobox")("aria-label", ctx_r24.currentLanguageLabelText + " " + ctx_r24.LOCALE_ALIAS[ctx_r24.currentLocale] || ctx_r24.LOCALE_ALIAS[ctx_r24.defaultLocale])("aria-expanded", _r26.isOpen());
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("", ctx_r24.link == null ? null : ctx_r24.link.iconName, " pr-1 Spa_Style_Gray4_Color");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(17, _c3$K, !ctx_r24.isFooter, !ctx_r24.isFooter && ctx_r24.hover));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r24.LOCALE_ALIAS[ctx_r24.currentLocale] || ctx_r24.LOCALE_ALIAS[ctx_r24.defaultLocale], " ");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("role", "listbox");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r24.supportedLanguages)("ngForTrackBy", ctx_r24.trackByIndex);
} }
function LocalePickerComponent_ng_template_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵlistener("mouseover", function LocalePickerComponent_ng_template_1_div_1_div_1_Template_div_mouseover_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r41); const index_r38 = restoredCtx.index; const ctx_r40 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r40.mobileHover = index_r38); })("mouseleave", function LocalePickerComponent_ng_template_1_div_1_div_1_Template_div_mouseleave_0_listener() { i0.ɵɵrestoreView(_r41); const ctx_r42 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r42.mobileHover = null); });
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵlistener("click", function LocalePickerComponent_ng_template_1_div_1_div_1_Template_div_click_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r41); const option_r37 = restoredCtx.$implicit; const ctx_r43 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r43.setLocale($event, option_r37)); })("keyup.enter", function LocalePickerComponent_ng_template_1_div_1_div_1_Template_div_keyup_enter_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r41); const option_r37 = restoredCtx.$implicit; const ctx_r44 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r44.setLocale($event, option_r37)); });
    i0.ɵɵelement(2, "i", 16);
    i0.ɵɵelementStart(3, "span", 17);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const option_r37 = ctx.$implicit;
    const last_r39 = ctx.last;
    const ctx_r36 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", !last_r39 || last_r39 && ctx_r36.showLastBorder ? "border-bottom" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("tabindex", option_r37 === ctx_r36.currentLocale ? "-1" : "0");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c4$q, option_r37 === ctx_r36.currentLocale));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", option_r37 === ctx_r36.currentLocale ? "fas fa-check-circle" : ctx_r36.getLinkIconName() + " header-icon");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r36.LOCALE_ALIAS[option_r37], " ");
} }
function LocalePickerComponent_ng_template_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, LocalePickerComponent_ng_template_1_div_1_div_1_Template, 5, 7, "div", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r25.supportedLanguages)("ngForTrackBy", ctx_r25.trackByIndex);
} }
function LocalePickerComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, LocalePickerComponent_ng_template_1_div_0_Template, 8, 20, "div", 2);
    i0.ɵɵtemplate(1, LocalePickerComponent_ng_template_1_div_1_Template, 2, 2, "div", 3);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r2.headerDropdown);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.headerDropdown);
} }
class LocalePickerComponent {
    constructor(localeService, widgetService, analyticsService, weglotService, store, cdr) {
        this.localeService = localeService;
        this.widgetService = widgetService;
        this.analyticsService = analyticsService;
        this.weglotService = weglotService;
        this.store = store;
        this.cdr = cdr;
        this.headerDropdown = false;
        this.showLastBorder = true;
        this.weglotMultiLanguageEnabled = false;
        this.LOCALE_ALIAS = LocaleService.LOCALE_ALIAS;
        this.hover = false;
        this.supportedLanguages = [];
        this.supportedWeglotLanguages = [];
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.subscriptions.add(this.store.select(AppConfigState.defaultLocale).subscribe((locale) => {
            this.defaultLocale = locale;
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe((locale) => {
            this.currentLocale = locale;
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.store.select(AppConfigState.supportedLanguages).subscribe((languages) => {
            this.supportedLanguages = languages;
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.store.select(AppConfigState.defaultWeglotLocale).subscribe((locale) => {
            this.defaultWeglotLocale = locale;
            this.updateWeglotLanguageNames();
        }));
        this.subscriptions.add(this.store.select(AppConfigState.currentWeglotLocale).subscribe((locale) => {
            this.currentWeglotLocale = locale;
            this.updateWeglotLanguageNames();
        }));
        this.subscriptions.add(this.store.select(AppConfigState.supportedWeglotLanguages).subscribe((languages) => {
            this.supportedWeglotLanguages = languages;
            this.updateWeglotLanguageNames();
        }));
    }
    ngAfterViewInit() {
        this.weglotService.initializeWeglot(this.weglotMultiLanguageEnabled);
    }
    updateWeglotLanguageNames() {
        const currentLang = this.supportedWeglotLanguages.find(lang => lang.locale === this.currentWeglotLocale);
        this.currentWeglotLanguageName = currentLang ? currentLang.name : undefined;
        const defaultLang = this.supportedWeglotLanguages.find(lang => lang.locale === this.defaultWeglotLocale);
        this.defaultWeglotLanguageName = defaultLang ? defaultLang.name : undefined;
        this.cdr.markForCheck();
    }
    setWeglotLocale(event, weglotLanguage) {
        this.updateLocale(event, () => {
            this.weglotService.switchLanguage(weglotLanguage.languageCode);
            this.updateGoogleTags(weglotLanguage.name, weglotLanguage.locale);
        }, this.weglotLanguageDropDown);
    }
    setLocale(event, locale) {
        this.updateLocale(event, () => {
            this.localeService.setLocale(locale);
            this.updateGoogleTags(this.LOCALE_ALIAS[locale], locale);
        }, this.languageDropDown);
    }
    updateLocale(event, action, dropdownRef) {
        const key = event.key;
        const target = event.target;
        const hasNoNextSiblings = !target.nextElementSibling;
        if (event.type !== 'keydown' || key === 'Enter') {
            action();
        }
        if (event.type !== 'keydown' || key === 'Enter' || hasNoNextSiblings) {
            dropdownRef?.close();
        }
    }
    getLinkIconName() {
        if (this.link?.iconName) {
            if (Array.isArray(this.link.iconName)) {
                return this.link.iconName[0];
            }
            return this.link.iconName;
        }
    }
    trackByIndex(index) {
        return index;
    }
    get isFooter() {
        return this.widgetService.widgetName === 'dynamicfooter';
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    updateGoogleTags(languageSelection, locale) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_HEADER_CHANGE_LANGUAGE,
            [DataLayerGlobalVariable.LANGUAGE_SELECTION]: languageSelection,
            [DataLayerGlobalVariable.LANGUAGE_ID]: locale
        };
    }
}
LocalePickerComponent.ɵfac = function LocalePickerComponent_Factory(t) { return new (t || LocalePickerComponent)(i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.WeglotService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
LocalePickerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LocalePickerComponent, selectors: [["vnext-locale-picker"]], viewQuery: function LocalePickerComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3c, 5);
        i0.ɵɵviewQuery(_c1$1I, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.languageDropDown = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.weglotLanguageDropDown = _t.first);
    } }, inputs: { headerDropdown: "headerDropdown", link: "link", currentLanguageLabelText: "currentLanguageLabelText", isAgentHeader: "isAgentHeader", showLastBorder: "showLastBorder", weglotMultiLanguageEnabled: "weglotMultiLanguageEnabled" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["defaultLocaleContainer", ""], ["class", "Spa_Style_Primary_Color Spa_Style_Smaller_Font can-click dropdown d-inline-block focus-text", "ngbDropdown", "", "tabindex", "0", 3, "ngClass", "autoClose", "mouseover", "mouseleave", "keyup.enter", 4, "ngIf"], ["class", "container", 4, "ngIf"], ["ngbDropdown", "", "tabindex", "0", 1, "Spa_Style_Primary_Color", "Spa_Style_Smaller_Font", "can-click", "dropdown", "d-inline-block", "focus-text", 3, "ngClass", "autoClose", "mouseover", "mouseleave", "keyup.enter"], ["weglotLanguageDropDown", "ngbDropdown"], ["aria-hidden", "true", 3, "ngClass"], ["ngbDropdownToggle", "", "role", "button", 1, "dropdown-toggle", "no-translate-block"], ["aria-hidden", "true", 1, "fa", "fa-angle-down", "Spa_Style_Smaller_Font"], ["ngbDropdownMenu", "", 1, "dropdown-menu"], ["class", "dropdown-item can-click Spa_Style_Primary_Color Spa_Style_Small_Font no-translate-block", "ngbDropdownItem", "", "tabindex", "0", 3, "click", "keydown", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["ngbDropdownItem", "", "tabindex", "0", 1, "dropdown-item", "can-click", "Spa_Style_Primary_Color", "Spa_Style_Small_Font", "no-translate-block", 3, "click", "keydown"], [1, "container"], ["class", "row can-click", 3, "ngClass", "mouseover", "mouseleave", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "row", "can-click", 3, "ngClass", "mouseover", "mouseleave"], ["role", "button", 1, "col", "pt-2", "pb-2", "pl-4", "locale", "Spa_Style_Smaller_Font", "Spa_Style_Primary_Color", "no-translate-block", 3, "ngClass", "tabindex", "click", "keyup.enter"], ["aria-hidden", "true", 1, "pr-1", 3, "ngClass"], [1, "locale"], ["languageDropDown", "ngbDropdown"], ["ngbDropdownToggle", "", "role", "button", 1, "dropdown-toggle"], ["class", "dropdown-item can-click Spa_Style_Primary_Color Spa_Style_Small_Font", "ngbDropdownItem", "", "tabindex", "0", 3, "click", "keydown", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["ngbDropdownItem", "", "tabindex", "0", 1, "dropdown-item", "can-click", "Spa_Style_Primary_Color", "Spa_Style_Small_Font", 3, "click", "keydown"], [1, "col", "pt-2", "pb-2", "pl-4", "locale", "Spa_Style_Smaller_Font", "Spa_Style_Primary_Color", 3, "ngClass", "tabindex", "click", "keyup.enter"]], template: function LocalePickerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LocalePickerComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
        i0.ɵɵtemplate(1, LocalePickerComponent_ng_template_1_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.weglotMultiLanguageEnabled)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, IconAriaAttributesDirective, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem], styles: [".dropdown-toggle[_ngcontent-%COMP%]:after{display:none}.agent-locale-picker[_ngcontent-%COMP%]{margin-right:10px}", ".margin-link[_ngcontent-%COMP%]:last-child{padding-right:0}.margin-link.first[_ngcontent-%COMP%]{border-left:none}.margin-link[_ngcontent-%COMP%]{padding-left:10px}.sub-header-container-footer[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:center;padding:8px}.sub-header-container-header[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:center}.header-icon[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent1)}.header-icon-hover[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Gray4)}.header-icon-selected[_ngcontent-%COMP%]{font-weight:700}.underline-title[_ngcontent-%COMP%]{text-decoration:underline}.plan-year-badge[_ngcontent-%COMP%]{margin-top:3px}@media (max-width: 768px){.sub-header-container-footer[_ngcontent-%COMP%]{flex-direction:column;justify-content:flex-end;align-items:flex-end}.sub-header-container-footer[_ngcontent-%COMP%]   .margin-link[_ngcontent-%COMP%]{border-left:none;padding-left:15px}.container[_ngcontent-%COMP%]{padding:0 20px 0 0}.margin-link[_ngcontent-%COMP%]{min-height:0px;padding-left:4px;padding-right:4px}}@media (max-width: 767.9px){.margin-link[_ngcontent-%COMP%]{min-height:44px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocalePickerComponent, [{
        type: Component,
        args: [{ selector: 'vnext-locale-picker', changeDetection: ChangeDetectionStrategy.OnPush, template: "<!-- default locale picker -->\r\n<ng-container *ngIf=\"weglotMultiLanguageEnabled; else defaultLocaleContainer\">\r\n  <div\r\n    class=\"Spa_Style_Primary_Color Spa_Style_Smaller_Font can-click dropdown d-inline-block focus-text\"\r\n    [ngClass]=\"{ 'underline-title': isFooter && hover, 'icon-hover': !isFooter && hover, 'agent-locale-picker': isAgentHeader }\"\r\n    *ngIf=\"!headerDropdown\"\r\n    ngbDropdown\r\n    (mouseover)=\"hover = true\"\r\n    (mouseleave)=\"hover = false\"\r\n    #weglotLanguageDropDown=\"ngbDropdown\"\r\n    tabindex=\"0\"\r\n    (keyup.enter)=\"weglotLanguageDropDown.toggle()\"\r\n    [autoClose]=\"true\"\r\n    [attr.role]=\"'combobox'\"\r\n    [attr.aria-label]=\"currentLanguageLabelText + ' ' + currentWeglotLanguageName || defaultWeglotLanguageName\"\r\n    [attr.aria-expanded]=\"weglotLanguageDropDown.isOpen()\"\r\n  >\r\n    <i\r\n      class=\"{{ link?.iconName }} pr-1 Spa_Style_Gray4_Color\"\r\n      [ngClass]=\"{ 'header-icon': !isFooter, 'header-icon-hover': !isFooter && hover }\"\r\n      aria-hidden=\"true\"\r\n    ></i\r\n    ><span class=\"dropdown-toggle no-translate-block\" ngbDropdownToggle role=\"button\">\r\n      {{ currentWeglotLanguageName || defaultWeglotLanguageName }}\r\n      <i aria-hidden=\"true\" class=\"fa fa-angle-down Spa_Style_Smaller_Font\"></i>\r\n    </span>\r\n    <div class=\"dropdown-menu\" [attr.role]=\"'listbox'\" ngbDropdownMenu>\r\n      <div\r\n        *ngFor=\"let option of supportedWeglotLanguages; trackBy: trackByIndex\"\r\n        class=\"dropdown-item can-click Spa_Style_Primary_Color Spa_Style_Small_Font no-translate-block\"\r\n        ngbDropdownItem\r\n        tabindex=\"0\"\r\n        [attr.role]=\"'option'\"\r\n        [attr.aria-label]=\"'Select ' + option.name + ' language'\"\r\n        (click)=\"setWeglotLocale($event, option)\"\r\n        (keydown)=\"setWeglotLocale($event, option)\"\r\n      >\r\n        {{ option.name }}\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"headerDropdown\" class=\"container\">\r\n    <div\r\n      *ngFor=\"let option of supportedWeglotLanguages; index as index; let last = last; trackBy: trackByIndex\"\r\n      class=\"row can-click\"\r\n      [ngClass]=\"!last || (last && showLastBorder) ? 'border-bottom' : ''\"\r\n      (mouseover)=\"mobileHover = index\"\r\n      (mouseleave)=\"mobileHover = null\"\r\n    >\r\n      <div\r\n        class=\"col pt-2 pb-2 pl-4 locale Spa_Style_Smaller_Font Spa_Style_Primary_Color no-translate-block\"\r\n        [ngClass]=\"{ 'header-icon-selected': option.locale === currentWeglotLocale }\"\r\n        (click)=\"setWeglotLocale($event, option)\"\r\n        tabindex=\"{{ option.locale === currentWeglotLocale ? '-1' : '0' }}\"\r\n        (keyup.enter)=\"setWeglotLocale($event, option)\"\r\n        role=\"button\"\r\n      >\r\n        <i\r\n          class=\"pr-1\"\r\n          [ngClass]=\"option.locale === currentWeglotLocale ? 'fas fa-check-circle' : getLinkIconName() + ' header-icon'\"\r\n          aria-hidden=\"true\"\r\n        ></i>\r\n        <span class=\"locale\">{{ option.name }}</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n\r\n<ng-template #defaultLocaleContainer>\r\n  <div\r\n    class=\"Spa_Style_Primary_Color Spa_Style_Smaller_Font can-click dropdown d-inline-block focus-text\"\r\n    [ngClass]=\"{ 'underline-title': isFooter && hover, 'icon-hover': !isFooter && hover, 'agent-locale-picker': isAgentHeader }\"\r\n    *ngIf=\"!headerDropdown\"\r\n    ngbDropdown\r\n    (mouseover)=\"hover = true\"\r\n    (mouseleave)=\"hover = false\"\r\n    #languageDropDown=\"ngbDropdown\"\r\n    tabindex=\"0\"\r\n    (keyup.enter)=\"languageDropDown.toggle()\"\r\n    [autoClose]=\"true\"\r\n    [attr.role]=\"'combobox'\"\r\n    [attr.aria-label]=\"currentLanguageLabelText + ' ' + LOCALE_ALIAS[currentLocale] || LOCALE_ALIAS[defaultLocale]\"\r\n    [attr.aria-expanded]=\"languageDropDown.isOpen()\"\r\n  >\r\n    <i\r\n      class=\"{{ link?.iconName }} pr-1 Spa_Style_Gray4_Color\"\r\n      [ngClass]=\"{ 'header-icon': !isFooter, 'header-icon-hover': !isFooter && hover }\"\r\n      aria-hidden=\"true\"\r\n    ></i\r\n    ><span class=\"dropdown-toggle\" ngbDropdownToggle role=\"button\"\r\n      >{{ LOCALE_ALIAS[currentLocale] || LOCALE_ALIAS[defaultLocale] }}\r\n      <i aria-hidden=\"true\" class=\"fa fa-angle-down Spa_Style_Smaller_Font\"></i>\r\n    </span>\r\n    <div class=\"dropdown-menu\" [attr.role]=\"'listbox'\" ngbDropdownMenu>\r\n      <div\r\n        *ngFor=\"let option of supportedLanguages; trackBy: trackByIndex\"\r\n        class=\"dropdown-item can-click Spa_Style_Primary_Color Spa_Style_Small_Font\"\r\n        ngbDropdownItem\r\n        tabindex=\"0\"\r\n        [attr.role]=\"'option'\"\r\n        [attr.aria-label]=\"'Select ' + LOCALE_ALIAS[option] + ' language'\"\r\n        (click)=\"setLocale($event, option)\"\r\n        (keydown)=\"setLocale($event, option)\"\r\n      >\r\n        {{ LOCALE_ALIAS[option] }}\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- locale picker in the menu dropdown -->\r\n  <div *ngIf=\"headerDropdown\" class=\"container\">\r\n    <div\r\n      *ngFor=\"let option of supportedLanguages; index as index; let last = last; trackBy: trackByIndex\"\r\n      class=\"row can-click\"\r\n      [ngClass]=\"!last || (last && showLastBorder) ? 'border-bottom' : ''\"\r\n      (mouseover)=\"mobileHover = index\"\r\n      (mouseleave)=\"mobileHover = null\"\r\n    >\r\n      <div\r\n        class=\"col pt-2 pb-2 pl-4 locale Spa_Style_Smaller_Font Spa_Style_Primary_Color\"\r\n        [ngClass]=\"{ 'header-icon-selected': option === currentLocale }\"\r\n        (click)=\"setLocale($event, option)\"\r\n        tabindex=\"{{ option === currentLocale ? '-1' : '0' }}\"\r\n        (keyup.enter)=\"setLocale($event, option)\"\r\n      >\r\n        <i\r\n          class=\"pr-1\"\r\n          [ngClass]=\"option === currentLocale ? 'fas fa-check-circle' : getLinkIconName() + ' header-icon'\"\r\n          aria-hidden=\"true\"\r\n        ></i>\r\n        <span class=\"locale\"> {{ LOCALE_ALIAS[option] }} </span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n", styles: [".dropdown-toggle:after{display:none}.agent-locale-picker{margin-right:10px}\n", ".margin-link:last-child{padding-right:0}.margin-link.first{border-left:none}.margin-link{padding-left:10px}.sub-header-container-footer{display:flex;justify-content:flex-end;align-items:center;padding:8px}.sub-header-container-header{display:flex;justify-content:flex-end;align-items:center}.header-icon{color:var(--static-Spa_Style_Accent1)}.header-icon-hover{color:var(--static-Spa_Style_Gray4)}.header-icon-selected{font-weight:700}.underline-title{text-decoration:underline}.plan-year-badge{margin-top:3px}@media (max-width: 768px){.sub-header-container-footer{flex-direction:column;justify-content:flex-end;align-items:flex-end}.sub-header-container-footer .margin-link{border-left:none;padding-left:15px}.container{padding:0 20px 0 0}.margin-link{min-height:0px;padding-left:4px;padding-right:4px}}@media (max-width: 767.9px){.margin-link{min-height:44px}}\n"] }]
    }], function () { return [{ type: i1.LocaleService }, { type: WidgetService }, { type: AnalyticsService }, { type: i1.WeglotService }, { type: i2.Store }, { type: i0.ChangeDetectorRef }]; }, { languageDropDown: [{
            type: ViewChild,
            args: ['languageDropDown']
        }], weglotLanguageDropDown: [{
            type: ViewChild,
            args: ['weglotLanguageDropDown']
        }], headerDropdown: [{
            type: Input
        }], link: [{
            type: Input
        }], currentLanguageLabelText: [{
            type: Input
        }], isAgentHeader: [{
            type: Input
        }], showLastBorder: [{
            type: Input
        }], weglotMultiLanguageEnabled: [{
            type: Input
        }] }); })();

function AgentHeaderComponent_vnext_locale_picker_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-locale-picker", 19);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("headerDropdown", false)("link", ctx_r0.languageLink)("currentLanguageLabelText", ctx_r0.currentLanguageLabelText)("isAgentHeader", true)("weglotMultiLanguageEnabled", ctx_r0.weglotMultiLanguageEnabled);
} }
function AgentHeaderComponent_ng_template_2_ng_container_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 26);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "phone");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("href", "tel: ", ctx_r13.agentData == null ? null : ctx_r13.agentData.data == null ? null : ctx_r13.agentData.data.phoneNumber, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("aria-label", (ctx_r13.agentData == null ? null : ctx_r13.agentData.data == null ? null : ctx_r13.agentData.data.fullName) + ": " + (ctx_r13.agentData == null ? null : ctx_r13.agentData.data == null ? null : ctx_r13.agentData.data.phoneNumber));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 3, ctx_r13.agentPhoneNumber, ctx_r13.locale.slice(3)), " ");
} }
function AgentHeaderComponent_ng_template_2_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AgentHeaderComponent_ng_template_2_ng_container_7_ng_container_1_Template, 4, 6, "ng-container", 25);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    const _r8 = i0.ɵɵreference(28);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.isMobile)("ngIfElse", _r8);
} }
function AgentHeaderComponent_ng_template_2_h2_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r11.agentData == null ? null : ctx_r11.agentData.data == null ? null : ctx_r11.agentData.data.emailAddress, " ");
} }
function AgentHeaderComponent_ng_template_2_ng_container_9_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 30);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r14.uniqueCodeText, "html"), i0.ɵɵsanitizeHtml);
} }
function AgentHeaderComponent_ng_template_2_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AgentHeaderComponent_ng_template_2_ng_container_9_div_1_Template, 2, 4, "div", 28);
    i0.ɵɵelementStart(2, "div", 29);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_SpeakWithAgent_UniqueCodeDescription_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r12.uniqueCode);
} }
function AgentHeaderComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function AgentHeaderComponent_ng_template_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); const _r4 = i0.ɵɵreference(6); return i0.ɵɵresetView(ctx_r15.closeAgentPopover(_r4)); })("keyup.enter", function AgentHeaderComponent_ng_template_2_Template_button_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r17 = i0.ɵɵnextContext(); const _r4 = i0.ɵɵreference(6); return i0.ɵɵresetView(ctx_r17.closeAgentPopover(_r4)); });
    i0.ɵɵelementStart(1, "span", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "i", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 22)(5, "h2", 23);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, AgentHeaderComponent_ng_template_2_ng_container_7_Template, 2, 2, "ng-container", 16);
    i0.ɵɵtemplate(8, AgentHeaderComponent_ng_template_2_h2_8_Template, 2, 1, "h2", 24);
    i0.ɵɵtemplate(9, AgentHeaderComponent_ng_template_2_ng_container_9_Template, 4, 2, "ng-container", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.closeText);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.fullName, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.agentData == null ? null : ctx_r2.agentData.data == null ? null : ctx_r2.agentData.data.phoneNumber);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.agentData == null ? null : ctx_r2.agentData.data == null ? null : ctx_r2.agentData.data.emailAddress);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.displayUniqueCode);
} }
function AgentHeaderComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelement(1, "vnext-agent-profile-picture", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("broker", ctx_r3.agentData == null ? null : ctx_r3.agentData.data)("isViewOnly", true)("agentProfilePictureUrl", ctx_r3.agentData == null ? null : ctx_r3.agentData.data.agentPictureURL);
} }
function AgentHeaderComponent_ng_container_24_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 33);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "phone");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("href", "tel: ", ctx_r18.agentData == null ? null : ctx_r18.agentData.data == null ? null : ctx_r18.agentData.data.phoneNumber, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("aria-label", (ctx_r18.agentData == null ? null : ctx_r18.agentData.data == null ? null : ctx_r18.agentData.data.fullName) + ": " + (ctx_r18.agentData == null ? null : ctx_r18.agentData.data == null ? null : ctx_r18.agentData.data.phoneNumber));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 3, ctx_r18.agentData == null ? null : ctx_r18.agentData.data == null ? null : ctx_r18.agentData.data.phoneNumber, ctx_r18.locale.slice(3)), " ");
} }
function AgentHeaderComponent_ng_container_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AgentHeaderComponent_ng_container_24_ng_container_1_Template, 4, 6, "ng-container", 25);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    const _r8 = i0.ɵɵreference(28);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.isMobile)("ngIfElse", _r8);
} }
function AgentHeaderComponent_h2_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.agentData == null ? null : ctx_r6.agentData.data == null ? null : ctx_r6.agentData.data.emailAddress, " ");
} }
function AgentHeaderComponent_ng_container_26_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 30);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r19.uniqueCodeText, "html"), i0.ɵɵsanitizeHtml);
} }
function AgentHeaderComponent_ng_container_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AgentHeaderComponent_ng_container_26_div_1_Template, 2, 4, "div", 28);
    i0.ɵɵelementStart(2, "div", 35);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_SpeakWithAgent_UniqueCodeDescription_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r7.uniqueCode);
} }
function AgentHeaderComponent_ng_template_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "phone");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, ctx_r9.agentData == null ? null : ctx_r9.agentData.data == null ? null : ctx_r9.agentData.data.phoneNumber, ctx_r9.locale.slice(3)));
} }
class AgentHeaderComponent {
    constructor(phoneService) {
        this.phoneService = phoneService;
        this.weglotMultiLanguageEnabled = false;
        this.isMobile = false;
    }
    ngOnChanges(changes) {
        const { agentData } = changes;
        if (agentData && !_isEqual(agentData.previousValue, agentData.currentValue)) {
            this.fullName = this.agentData?.data ? this.agentData.data.firstName.concat(' ', this.agentData.data.lastName) : '';
            this.agentPhoneNumber = this.phoneService.parsePhoneNumberWithExtension(this.agentData?.data?.phoneNumber, this.agentData?.data?.ext);
        }
    }
    closeAgentPopover(agentPopover) {
        if (agentPopover.isOpen()) {
            agentPopover.close();
        }
    }
}
AgentHeaderComponent.ɵfac = function AgentHeaderComponent_Factory(t) { return new (t || AgentHeaderComponent)(i0.ɵɵdirectiveInject(i1.PhoneUtilityService)); };
AgentHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentHeaderComponent, selectors: [["vnext-agent-header"]], inputs: { brokerText: "brokerText", isLoggedIn: "isLoggedIn", agentData: "agentData", locale: "locale", closeText: "closeText", uniqueCodeText: "uniqueCodeText", uniqueCode: "uniqueCode", displayUniqueCode: "displayUniqueCode", isAgentProfilePictureEnabled: "isAgentProfilePictureEnabled", agentHeaderLocalePickerEnabled: "agentHeaderLocalePickerEnabled", currentLanguageLabelText: "currentLanguageLabelText", languageLink: "languageLink", motionPointEnabled: "motionPointEnabled", weglotMultiLanguageEnabled: "weglotMultiLanguageEnabled", isMobile: "isMobile" }, features: [i0.ɵɵNgOnChangesFeature], decls: 29, vars: 16, consts: [[1, "row", "d-none", "d-md-flex", "justify-content-end", "agent-with-popover"], [3, "headerDropdown", "link", "currentLanguageLabelText", "isAgentHeader", "weglotMultiLanguageEnabled", 4, "ngIf"], ["agentWidget", ""], ["class", "d-none d-sm-flex align-items-center mr-2", 4, "ngIf"], ["placement", "bottom-right", "popoverClass", "agent-popover", "tabindex", "0", "role", "button", 1, "can-click", "welcome-user-wrapper", "focus-text", 3, "ngbPopover", "autoClose", "keyup.enter"], ["agentPopover", "ngbPopover"], [1, "d-flex", "justify-content-start", "mr-5", "can-click"], [1, "Spa_Style_Paragraph", "Spa_Style_Semi_Bold_Weight", "no-translate-block"], [1, "d-flex", "align-items-center"], [1, "text-right", "pr-2", "Spa_Style_Paragraph", "Spa_Style_Primary_Color", "mt-n2"], [1, "agent-name", "no-translate-block"], [1, "fas", "fa-chevron-down", "Spa_Style_Primary_Color", "Spa_Style_Smaller_Font", "ml-1", "mr-3", "mt-n2"], [1, "sr-only"], [1, "d-md-none"], [1, "Spa_Style_Paragraph", "no-translate-block"], [1, "Spa_Style_Phase_Names_Text"], [4, "ngIf"], ["class", "Spa_Style_Phase_Names_Text agent-email no-translate-block", 4, "ngIf"], ["showPhoneOnDesktop", ""], [3, "headerDropdown", "link", "currentLanguageLabelText", "isAgentHeader", "weglotMultiLanguageEnabled"], ["tabindex", "0", 1, "agent-popover-cancel", "action-button", 3, "click", "keyup.enter"], [1, "fas", "fa-times"], [1, "mr-3", "mt-2", "agent-popover-template", "no-translate-block"], [1, "Spa_Style_H2", "font-weight-normal"], ["class", "Spa_Style_Paragraph", 4, "ngIf"], [4, "ngIf", "ngIfElse"], [1, "Spa_Style_Paragraph", "Spa_Style_Primary_Color", 3, "href"], [1, "Spa_Style_Paragraph"], ["class", "Spa_Style_Paragraph unique-code-text mt-3", 3, "innerHTML", 4, "liveEditProp"], [1, "Spa_Style_H3"], [1, "Spa_Style_Paragraph", "unique-code-text", "mt-3", 3, "innerHTML"], [1, "d-none", "d-sm-flex", "align-items-center", "mr-2"], [3, "broker", "isViewOnly", "agentProfilePictureUrl"], ["tabindex", "0", 1, "Spa_Style_Phase_Names_Text", 3, "href"], [1, "Spa_Style_Phase_Names_Text", "agent-email", "no-translate-block"], [1, "Spa_Style_H3", "no-translate-block"]], template: function AgentHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        const _r20 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, AgentHeaderComponent_vnext_locale_picker_1_Template, 1, 5, "vnext-locale-picker", 1);
        i0.ɵɵtemplate(2, AgentHeaderComponent_ng_template_2_Template, 10, 5, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(4, AgentHeaderComponent_div_4_Template, 2, 3, "div", 3);
        i0.ɵɵelementStart(5, "a", 4, 5);
        i0.ɵɵlistener("keyup.enter", function AgentHeaderComponent_Template_a_keyup_enter_5_listener() { i0.ɵɵrestoreView(_r20); const _r4 = i0.ɵɵreference(6); return i0.ɵɵresetView(_r4.toggle()); });
        i0.ɵɵelementStart(7, "div", 6)(8, "h3", 7);
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "div", 8)(11, "div", 9)(12, "div", 10);
        i0.ɵɵtext(13);
        i0.ɵɵpipe(14, "shortName");
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(15, "i", 11);
        i0.ɵɵelementStart(16, "span", 12);
        i0.ɵɵtext(17, "Expand menu");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(18, "div", 13)(19, "h2", 14);
        i0.ɵɵtext(20);
        i0.ɵɵpipe(21, "shortName");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "h2", 15);
        i0.ɵɵtext(23);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(24, AgentHeaderComponent_ng_container_24_Template, 2, 2, "ng-container", 16);
        i0.ɵɵtemplate(25, AgentHeaderComponent_h2_25_Template, 2, 1, "h2", 17);
        i0.ɵɵtemplate(26, AgentHeaderComponent_ng_container_26_Template, 4, 2, "ng-container", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(27, AgentHeaderComponent_ng_template_27_Template, 3, 4, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(3);
        const _r4 = i0.ɵɵreference(6);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.motionPointEnabled && ctx.agentHeaderLocalePickerEnabled);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isAgentProfilePictureEnabled && (ctx.agentData == null ? null : ctx.agentData.data));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngbPopover", _r1)("autoClose", "outside");
        i0.ɵɵattribute("aria-expanded", _r4.isOpen());
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.brokerText, " ");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 12, ctx.fullName));
        i0.ɵɵadvance(7);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(21, 14, ctx.fullName), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.brokerText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.agentData == null ? null : ctx.agentData.data == null ? null : ctx.agentData.data.phoneNumber);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.agentData == null ? null : ctx.agentData.data == null ? null : ctx.agentData.data.emailAddress);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.displayUniqueCode);
    } }, dependencies: [i1$2.NgIf, LiveEditPropDirective, IconAriaAttributesDirective, i1$1.NgbPopover, AgentProfilePictureComponent, LocalePickerComponent, SafePipe, PhonePipe, ShortNamePipe], styles: [".agent-popover-cancel[_ngcontent-%COMP%]{position:absolute;top:0;right:0;cursor:pointer;color:var(--Spa_Style_Primary);height:20px;width:20px;text-align:center;margin-top:5px;margin-right:5px}.agent-popover-template[_ngcontent-%COMP%]{min-width:200px;position:relative}.unique-code-text[_ngcontent-%COMP%]{white-space:break-spaces}.welcome-user-wrapper[_ngcontent-%COMP%], .welcome-user-wrapper[_ngcontent-%COMP%]:hover{text-decoration:none}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentHeaderComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-header', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row d-none d-md-flex justify-content-end agent-with-popover\">\r\n  <vnext-locale-picker\r\n    *ngIf=\"!motionPointEnabled && agentHeaderLocalePickerEnabled\"\r\n    [headerDropdown]=\"false\"\r\n    [link]=\"languageLink\"\r\n    [currentLanguageLabelText]=\"currentLanguageLabelText\"\r\n    [isAgentHeader]=\"true\"\r\n    [weglotMultiLanguageEnabled]=\"weglotMultiLanguageEnabled\"\r\n  ></vnext-locale-picker>\r\n  <ng-template #agentWidget>\r\n    <button\r\n      (click)=\"closeAgentPopover(agentPopover)\"\r\n      tabindex=\"0\"\r\n      (keyup.enter)=\"closeAgentPopover(agentPopover)\"\r\n      class=\"agent-popover-cancel action-button\"\r\n    >\r\n      <span class=\"sr-only\">{{ closeText }}</span>\r\n      <i class=\"fas fa-times\"></i>\r\n    </button>\r\n    <div class=\"mr-3 mt-2 agent-popover-template no-translate-block\">\r\n      <h2 class=\"Spa_Style_H2 font-weight-normal\">\r\n        {{ fullName }}\r\n      </h2>\r\n      <ng-container *ngIf=\"agentData?.data?.phoneNumber\">\r\n        <ng-container *ngIf=\"isMobile; else showPhoneOnDesktop\">\r\n          <a href=\"tel: {{ agentData?.data?.phoneNumber }}\" class=\"Spa_Style_Paragraph Spa_Style_Primary_Color\" [attr.aria-label]=\"agentData?.data?.fullName + ': ' + agentData?.data?.phoneNumber\">\r\n            {{ agentPhoneNumber | phone : locale.slice(3) }}\r\n          </a>\r\n        </ng-container>\r\n      </ng-container>\r\n      <h2 class=\"Spa_Style_Paragraph\" *ngIf=\"agentData?.data?.emailAddress\">\r\n        {{ agentData?.data?.emailAddress }}\r\n      </h2>\r\n      <ng-container *ngIf=\"displayUniqueCode\">\r\n        <div\r\n          class=\"Spa_Style_Paragraph unique-code-text mt-3\"\r\n          *liveEditProp=\"'Spa_SpeakWithAgent_UniqueCodeDescription_Text'\"\r\n          [innerHTML]=\"uniqueCodeText | safe : 'html'\"\r\n        ></div>\r\n        <div class=\"Spa_Style_H3\">{{ uniqueCode }}</div>\r\n      </ng-container>\r\n    </div>\r\n  </ng-template>\r\n  <div class=\"d-none d-sm-flex align-items-center mr-2\" *ngIf=\"isAgentProfilePictureEnabled && agentData?.data\">\r\n    <vnext-agent-profile-picture\r\n      [broker]=\"agentData?.data\"\r\n      [isViewOnly]=\"true\"\r\n      [agentProfilePictureUrl]=\"agentData?.data.agentPictureURL\"\r\n    ></vnext-agent-profile-picture>\r\n  </div>\r\n  <a\r\n    placement=\"bottom-right\"\r\n    [ngbPopover]=\"agentWidget\"\r\n    class=\"can-click welcome-user-wrapper focus-text\"\r\n    [autoClose]=\"'outside'\"\r\n    #agentPopover=\"ngbPopover\"\r\n    popoverClass=\"agent-popover\"\r\n    tabindex=\"0\"\r\n    role=\"button\"\r\n    (keyup.enter)=\"agentPopover.toggle()\"\r\n    [attr.aria-expanded]=\"agentPopover.isOpen()\"\r\n  >\r\n    <div class=\"d-flex justify-content-start mr-5 can-click\">\r\n      <h3 class=\"Spa_Style_Paragraph Spa_Style_Semi_Bold_Weight no-translate-block\">\r\n        {{ brokerText }}\r\n      </h3>\r\n    </div>\r\n    <div class=\"d-flex align-items-center\">\r\n      <div class=\"text-right pr-2 Spa_Style_Paragraph Spa_Style_Primary_Color mt-n2\">\r\n        <div class=\"agent-name no-translate-block\">{{ fullName | shortName }}</div>\r\n      </div>\r\n      <i class=\"fas fa-chevron-down Spa_Style_Primary_Color Spa_Style_Smaller_Font ml-1 mr-3 mt-n2\"></i>\r\n      <span class=\"sr-only\">Expand menu</span>\r\n    </div>\r\n  </a>\r\n</div>\r\n\r\n<div class=\"d-md-none\">\r\n  <h2 class=\"Spa_Style_Paragraph no-translate-block\">\r\n    {{ fullName | shortName }}\r\n  </h2>\r\n  <h2 class=\"Spa_Style_Phase_Names_Text\">{{ brokerText }}</h2>\r\n  <ng-container *ngIf=\"agentData?.data?.phoneNumber\">\r\n    <ng-container *ngIf=\"isMobile; else showPhoneOnDesktop\">\r\n      <a href=\"tel: {{ agentData?.data?.phoneNumber }}\" class=\"Spa_Style_Phase_Names_Text\" tabindex=\"0\" [attr.aria-label]=\"agentData?.data?.fullName + ': ' + agentData?.data?.phoneNumber\">\r\n        {{ agentData?.data?.phoneNumber | phone : locale.slice(3) }}\r\n      </a>\r\n    </ng-container>\r\n  </ng-container>\r\n  <h2 class=\"Spa_Style_Phase_Names_Text agent-email no-translate-block\" *ngIf=\"agentData?.data?.emailAddress\">\r\n    {{ agentData?.data?.emailAddress }}\r\n  </h2>\r\n  <ng-container *ngIf=\"displayUniqueCode\">\r\n    <div\r\n      class=\"Spa_Style_Paragraph unique-code-text mt-3\"\r\n      *liveEditProp=\"'Spa_SpeakWithAgent_UniqueCodeDescription_Text'\"\r\n      [innerHTML]=\"uniqueCodeText | safe : 'html'\"\r\n    ></div>\r\n    <div class=\"Spa_Style_H3 no-translate-block\">{{ uniqueCode }}</div>\r\n  </ng-container>\r\n</div>\r\n<ng-template #showPhoneOnDesktop>\r\n  <div>{{ agentData?.data?.phoneNumber | phone : locale.slice(3) }}</div>\r\n</ng-template>\r\n", styles: [".agent-popover-cancel{position:absolute;top:0;right:0;cursor:pointer;color:var(--Spa_Style_Primary);height:20px;width:20px;text-align:center;margin-top:5px;margin-right:5px}.agent-popover-template{min-width:200px;position:relative}.unique-code-text{white-space:break-spaces}.welcome-user-wrapper,.welcome-user-wrapper:hover{text-decoration:none}\n"] }]
    }], function () { return [{ type: i1.PhoneUtilityService }]; }, { brokerText: [{
            type: Input
        }], isLoggedIn: [{
            type: Input
        }], agentData: [{
            type: Input
        }], locale: [{
            type: Input
        }], closeText: [{
            type: Input
        }], uniqueCodeText: [{
            type: Input
        }], uniqueCode: [{
            type: Input
        }], displayUniqueCode: [{
            type: Input
        }], isAgentProfilePictureEnabled: [{
            type: Input
        }], agentHeaderLocalePickerEnabled: [{
            type: Input
        }], currentLanguageLabelText: [{
            type: Input
        }], languageLink: [{
            type: Input
        }], motionPointEnabled: [{
            type: Input
        }], weglotMultiLanguageEnabled: [{
            type: Input
        }], isMobile: [{
            type: Input
        }] }); })();

function AgentContainerComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-agent-header", 2);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("agentData", ctx_r0.agentData)("brokerText", ctx_r0.brokerText)("locale", ctx_r0.locale)("closeText", ctx_r0.closeText)("uniqueCode", ctx_r0.uniqueCode)("uniqueCodeText", ctx_r0.uniqueCodeText)("displayUniqueCode", ctx_r0.displayUniqueCode)("isAgentProfilePictureEnabled", ctx_r0.isAgentProfilePictureEnabled)("agentHeaderLocalePickerEnabled", ctx_r0.agentHeaderLocalePickerEnabled)("currentLanguageLabelText", ctx_r0.currentLanguageLabelText)("languageLink", ctx_r0.languageLink)("motionPointEnabled", ctx_r0.motionPointEnabled)("weglotMultiLanguageEnabled", ctx_r0.weglotMultiLanguageEnabled);
} }
function AgentContainerComponent_ng_template_1_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.brokerText, " ");
} }
function AgentContainerComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, AgentContainerComponent_ng_template_1_div_0_Template, 2, 1, "div", 3);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.brokerText);
} }
class AgentContainerComponent {
    constructor() {
        this.brokerText = '';
        this.isLoggedIn = false;
        this.locale = '';
        this.closeText = '';
        this.uniqueCodeText = '';
        this.uniqueCode = '';
        this.displayUniqueCode = false;
        this.isAgentProfilePictureEnabled = false;
        this.agentHeaderLocalePickerEnabled = false;
        this.currentLanguageLabelText = '';
        this.motionPointEnabled = false;
        this.weglotMultiLanguageEnabled = false;
        this.isMobile = false;
    }
}
AgentContainerComponent.ɵfac = function AgentContainerComponent_Factory(t) { return new (t || AgentContainerComponent)(); };
AgentContainerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentContainerComponent, selectors: [["vnext-agent-container"]], inputs: { brokerText: "brokerText", isLoggedIn: "isLoggedIn", agentData: "agentData", locale: "locale", closeText: "closeText", uniqueCodeText: "uniqueCodeText", uniqueCode: "uniqueCode", displayUniqueCode: "displayUniqueCode", isAgentProfilePictureEnabled: "isAgentProfilePictureEnabled", agentHeaderLocalePickerEnabled: "agentHeaderLocalePickerEnabled", currentLanguageLabelText: "currentLanguageLabelText", languageLink: "languageLink", motionPointEnabled: "motionPointEnabled", weglotMultiLanguageEnabled: "weglotMultiLanguageEnabled", isMobile: "isMobile" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["notLoggedIn", ""], [3, "agentData", "brokerText", "locale", "closeText", "uniqueCode", "uniqueCodeText", "displayUniqueCode", "isAgentProfilePictureEnabled", "agentHeaderLocalePickerEnabled", "currentLanguageLabelText", "languageLink", "motionPointEnabled", "weglotMultiLanguageEnabled"], ["class", "can-click Spa_Style_H3 agent-container-broker-text focus-text", "tabindex", "0", 4, "ngIf"], ["tabindex", "0", 1, "can-click", "Spa_Style_H3", "agent-container-broker-text", "focus-text"]], template: function AgentContainerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, AgentContainerComponent_ng_container_0_Template, 2, 13, "ng-container", 0);
        i0.ɵɵtemplate(1, AgentContainerComponent_ng_template_1_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.isLoggedIn || (ctx.agentData == null ? null : ctx.agentData.data))("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgIf, AgentHeaderComponent], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentContainerComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-container', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"isLoggedIn || agentData?.data; else notLoggedIn\">\r\n  <vnext-agent-header\r\n    [agentData]=\"agentData\"\r\n    [brokerText]=\"brokerText\"\r\n    [locale]=\"locale\"\r\n    [closeText]=\"closeText\"\r\n    [uniqueCode]=\"uniqueCode\"\r\n    [uniqueCodeText]=\"uniqueCodeText\"\r\n    [displayUniqueCode]=\"displayUniqueCode\"\r\n    [isAgentProfilePictureEnabled]=\"isAgentProfilePictureEnabled\"\r\n    [agentHeaderLocalePickerEnabled]=\"agentHeaderLocalePickerEnabled\"\r\n    [currentLanguageLabelText]=\"currentLanguageLabelText\"\r\n    [languageLink]=\"languageLink\"\r\n    [motionPointEnabled]=\"motionPointEnabled\"\r\n    [weglotMultiLanguageEnabled]=\"weglotMultiLanguageEnabled\"\r\n  >\r\n  </vnext-agent-header>\r\n</ng-container>\r\n\r\n<ng-template #notLoggedIn>\r\n  <div *ngIf=\"brokerText\" class=\"can-click Spa_Style_H3 agent-container-broker-text focus-text\" tabindex=\"0\">\r\n    {{ brokerText }}\r\n  </div>\r\n</ng-template>\r\n" }]
    }], null, { brokerText: [{
            type: Input
        }], isLoggedIn: [{
            type: Input
        }], agentData: [{
            type: Input
        }], locale: [{
            type: Input
        }], closeText: [{
            type: Input
        }], uniqueCodeText: [{
            type: Input
        }], uniqueCode: [{
            type: Input
        }], displayUniqueCode: [{
            type: Input
        }], isAgentProfilePictureEnabled: [{
            type: Input
        }], agentHeaderLocalePickerEnabled: [{
            type: Input
        }], currentLanguageLabelText: [{
            type: Input
        }], languageLink: [{
            type: Input
        }], motionPointEnabled: [{
            type: Input
        }], weglotMultiLanguageEnabled: [{
            type: Input
        }], isMobile: [{
            type: Input
        }] }); })();

class CreateAccountFormData {
}
var LoginFormType;
(function (LoginFormType) {
    LoginFormType[LoginFormType["Default"] = 0] = "Default";
    LoginFormType[LoginFormType["CreateAccount"] = 1] = "CreateAccount";
    LoginFormType[LoginFormType["ForgotUsername"] = 2] = "ForgotUsername";
    LoginFormType[LoginFormType["ForgotPassword"] = 3] = "ForgotPassword";
})(LoginFormType || (LoginFormType = {}));
var EditZipCodeModalEventTypes;
(function (EditZipCodeModalEventTypes) {
    EditZipCodeModalEventTypes[EditZipCodeModalEventTypes["OPEN"] = 0] = "OPEN";
    EditZipCodeModalEventTypes[EditZipCodeModalEventTypes["CLOSE"] = 1] = "CLOSE";
})(EditZipCodeModalEventTypes || (EditZipCodeModalEventTypes = {}));

class CreateAccountService {
    constructor(drugsService, store, preferencesService, medSupService, medSupHttpService, planYearResourceService) {
        this.drugsService = drugsService;
        this.store = store;
        this.preferencesService = preferencesService;
        this.medSupService = medSupService;
        this.medSupHttpService = medSupHttpService;
        this.planYearResourceService = planYearResourceService;
    }
    saveAccountSession(sessionId) {
        this.store.dispatch(new UpdateCartSession(sessionId));
        const questions = this.medSupService.getMedSupQuestions();
        const preferences = this.preferencesService.getMemberPreferences();
        if (this.areMedSupQuestionsValid(questions)) {
            this.medSupHttpService.sendMedSupQuestions(sessionId, this.planYearResourceService.getSelectedPlanYear(), DateUtilities.getFormattedCurrentDate(), MedSupState.transformSessionModelToHttpModel(questions));
        }
        this.drugsService.saveDrugListToAPI(sessionId);
        if (this.arePreferencesValid(preferences)) {
            this.preferencesService.saveMemberPreferencesToAPI(sessionId, preferences);
        }
    }
    areMedSupQuestionsValid(questions) {
        return questions && questions.length > 0;
    }
    arePreferencesValid(preferences) {
        return preferences && preferences.length > 0;
    }
}
CreateAccountService.ɵfac = function CreateAccountService_Factory(t) { return new (t || CreateAccountService)(i0.ɵɵinject(i1.DrugsService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.PreferencesService), i0.ɵɵinject(i1.MedSupService), i0.ɵɵinject(i1.MedSupHttpService), i0.ɵɵinject(i1.PlanYearResourceService)); };
CreateAccountService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CreateAccountService, factory: CreateAccountService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CreateAccountService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.DrugsService }, { type: i2.Store }, { type: i1.PreferencesService }, { type: i1.MedSupService }, { type: i1.MedSupHttpService }, { type: i1.PlanYearResourceService }]; }, null); })();

class CreateAccountFacade {
    constructor(createAccountService) {
        this.createAccountService = createAccountService;
    }
    saveAccountSession(sessionId) {
        this.createAccountService.saveAccountSession(sessionId);
    }
}
CreateAccountFacade.ɵfac = function CreateAccountFacade_Factory(t) { return new (t || CreateAccountFacade)(i0.ɵɵinject(CreateAccountService)); };
CreateAccountFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CreateAccountFacade, factory: CreateAccountFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CreateAccountFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: CreateAccountService }]; }, null); })();

class LoginComponentObservableData {
}
class LoginFacade {
    constructor(siteService, memberSessionService, analyticsService, guidedHelpService, pharmacyFacade, accountOverviewFacade, configResourceService, modalService, navigationService, store, ssoHttpService) {
        this.siteService = siteService;
        this.memberSessionService = memberSessionService;
        this.analyticsService = analyticsService;
        this.guidedHelpService = guidedHelpService;
        this.pharmacyFacade = pharmacyFacade;
        this.accountOverviewFacade = accountOverviewFacade;
        this.configResourceService = configResourceService;
        this.modalService = modalService;
        this.navigationService = navigationService;
        this.store = store;
        this.ssoHttpService = ssoHttpService;
        this.qsIdentifier = '?qs';
        this.sigIdIdentifier = 'sigid';
        this.editZipCodeSubject$ = new Subject();
        this.editZipCode$ = this.editZipCodeSubject$.asObservable();
    }
    setDataLayer() {
        const memberData = this.memberSessionService.getMemberSession();
        const selectedPharmacies = this.pharmacyFacade.getSelectedNABPPharmacies();
        const appId = this.configResourceService.getProcessedResourceValue('AppID', null, 0).toString();
        const providers = this.guidedHelpService.getSelectedProviders();
        let agentIsProfileAdmin = null;
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        if (memberData.agentGuid === agentGuid) {
            agentIsProfileAdmin = this.store.selectSnapshot(AgentState.agentIsProfileAdmin);
        }
        if (memberData) {
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.MEMBER_ID]: memberData.memberID,
                [DataLayerGlobalVariable.AGENT_GUID]: memberData.agentGuid,
                [DataLayerGlobalVariable.AGENT_IS_PROFILE_ADMIN]: agentIsProfileAdmin,
                [DataLayerGlobalVariable.ZIP]: memberData.demographic.zip,
                [DataLayerGlobalVariable.COUNTY_FIPS]: memberData.demographic.fips,
                [DataLayerGlobalVariable.SITE_HAS_GUIDED_HELP_INFO]: this.guidedHelpService.getHasVisited() ? 'yes' : 'no',
                [DataLayerGlobalVariable.SELECTED_PHARMACY]: selectedPharmacies,
                [DataLayerGlobalVariable.APP_SESSION_ID]: memberData.sessionId ? memberData.sessionId : null,
                [DataLayerGlobalVariable.USER_NAME]: memberData.userName ? memberData.userName : null,
                [DataLayerGlobalVariable.APP_ID]: appId,
                [DataLayerGlobalVariable.CLIENT_ID]: this.memberSessionService.getClientId(),
                [DataLayerGlobalVariable.PROVIDER_COUNT]: providers && providers.length ? providers.length.toString() : '0'
            };
        }
    }
    getBasicData(siteType) {
        if (this.siteService.isPPCSite(siteType)) {
            return this.getAgentBasicData();
        }
        return this.getMemberBasicData();
    }
    getAgentBasicData() {
        return {
            fullName$: this.agentName$,
            firstName$: this.agentFirstName$,
            lastName$: this.agentLastName$,
            loginError$: this.agentLoginError$,
            loading$: this.agentLoading$
        };
    }
    getMemberBasicData() {
        return {
            fullName$: this.memberName$,
            firstName$: this.memberFirstName$,
            lastName$: this.memberLastName$,
            loginError$: this.memberLoginError$,
            loading$: this.memberLoading$
        };
    }
    editZipCodeModal(eventType) {
        this.editZipCodeSubject$.next(eventType);
    }
    getEditZipCode$() {
        return this.editZipCode$;
    }
    viewLoggedInAgentDetails(pageTag) {
        this.accountOverviewFacade.viewLoggedInAgentDetails(pageTag);
    }
    async showExternalLoginPrompt(isUpdatePlanTags, planId, planType) {
        let portalUrl = this.configResourceService.getProcessedResourceValue('Spa_CustomerMemberPortalIntegration_PortalLink_URL', null, 'http://example.com');
        const title = this.configResourceService.getProcessedResourceValue('Spa_CustomerMemberPortalIntegration_ModalHeader', null, 'Login or create an account');
        const prompt = this.configResourceService.getProcessedResourceValue('Spa_CustomerMemberPortalIntegration_ModalBody', null, 'Please login or create an account on the [[Spa_ClientName]] member portal to continue.');
        const cancelButtonText = this.configResourceService.getProcessedResourceValue('Spa_Site_Cancel', null, 'Cancel');
        const confirmButtonText = this.configResourceService.getProcessedResourceValue('Spa_CustomerMemberPortalIntegration_ConfirmButton', null, 'Login or create an account');
        const sessionId = this.store.selectSnapshot(MemberState.session).sessionId;
        const encryptedQueryString = await this.getEncryptedQueryString(sessionId);
        if (encryptedQueryString) {
            portalUrl = portalUrl + '?sessionId=' + this.getQsAndSigIdFromEncryption(encryptedQueryString);
        }
        const confirmAction = () => {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_HEADER_LOGIN_MEMBER_PORTAL);
            if (isUpdatePlanTags) {
                this.planTagsToUpdate(DataLayerEvent.CLICK_EXTERNAL_ENROLL_NOTIFICATION_CONTINUE, planId, planType);
            }
            this.navigationService.navigate({
                title: '',
                href: portalUrl,
                type: LinkType.EXTERNAL,
                target: '_self'
            });
        };
        const cancelAction = () => {
            if (isUpdatePlanTags) {
                this.planTagsToUpdate(DataLayerEvent.CLICK_EXTERNAL_ENROLL_NOTIFICATION_CANCEL, planId, planType);
            }
        };
        if (!this.modalService.hasOpenModals()) {
            const externalLoginModal = this.modalService.open(ConfirmationModalComponent, {
                centered: true,
                backdrop: 'static',
                keyboard: false
            });
            externalLoginModal.componentInstance.title = title;
            externalLoginModal.componentInstance.prompt = prompt;
            externalLoginModal.componentInstance.cancelButton = cancelButtonText;
            externalLoginModal.componentInstance.confirmButton = confirmButtonText;
            externalLoginModal.componentInstance.confirmAction = confirmAction;
            externalLoginModal.componentInstance.cancelAction = cancelAction;
        }
    }
    planTagsToUpdate(event, planId, planType) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: event,
            [DataLayerGlobalVariable.PLAN_ID]: planId ?? GOOGLE_ANALYTICS_NOT_APPLICABLE,
            [DataLayerGlobalVariable.PLAN_TYPE]: planType ?? GOOGLE_ANALYTICS_NOT_APPLICABLE
        };
    }
    checkToPromptMemberPortalLogin() {
        // if member is logged in then allow,  else prompt depending on resource for member portal consumer site
        const memberPortalIntegrationEnable = this.configResourceService.getProcessedResourceValue('Spa_Site_CustomerMemberPortalIntegration_Enabled', null, false);
        const memberPortalEnrollmentCheckEnable = this.configResourceService.getProcessedResourceValue('Spa_CustomerMemberPortalIntegration_EnrollmentCheck_Enabled', null, false);
        const siteType = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType', null, SiteType.CONSUMER);
        return memberPortalIntegrationEnable &&
            memberPortalEnrollmentCheckEnable &&
            !this.memberSessionService.isMemberLoggedIn() &&
            siteType.toString() === SiteType.CONSUMER
            ? true
            : false;
    }
    getEncryptedQueryString(sessionId) {
        const ssoEncryptionRequest = {
            queryString: sessionId
        };
        return this.ssoHttpService.encrypt$(ssoEncryptionRequest).toPromise();
    }
    getParamValue(encryptedQueryString, param) {
        const params = encryptedQueryString.split('&');
        return params.find(a => a.startsWith(param));
    }
    getQsAndSigIdFromEncryption(encryptedQueryString) {
        if (encryptedQueryString.indexOf('&') > -1 &&
            encryptedQueryString.indexOf(this.qsIdentifier) > -1 &&
            encryptedQueryString.indexOf(this.sigIdIdentifier) > -1) {
            const qs = this.getParamValue(encryptedQueryString, this.qsIdentifier);
            const sigId = this.getParamValue(encryptedQueryString, this.sigIdIdentifier);
            if (qs && sigId) {
                return `${qs.replace('?', '')}` + `&${sigId}`;
            }
        }
        return '';
    }
}
LoginFacade.ɵfac = function LoginFacade_Factory(t) { return new (t || LoginFacade)(i0.ɵɵinject(i1.SiteService), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(AnalyticsService), i0.ɵɵinject(i1.GuidedHelpService), i0.ɵɵinject(PharmacyFacade), i0.ɵɵinject(AccountOverviewFacade), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(i1.NavigationService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.SSOHttpService)); };
LoginFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LoginFacade, factory: LoginFacade.ɵfac, providedIn: 'root' });
__decorate([
    Select(AgentState.fullName)
], LoginFacade.prototype, "agentName$", void 0);
__decorate([
    Select(AgentState.firstName)
], LoginFacade.prototype, "agentFirstName$", void 0);
__decorate([
    Select(AgentState.lastName)
], LoginFacade.prototype, "agentLastName$", void 0);
__decorate([
    Select(AgentState.hasError)
], LoginFacade.prototype, "agentLoginError$", void 0);
__decorate([
    Select(AgentState.loading)
], LoginFacade.prototype, "agentLoading$", void 0);
__decorate([
    Select(ProfileState.fullName)
], LoginFacade.prototype, "memberName$", void 0);
__decorate([
    Select(ProfileState.firstName)
], LoginFacade.prototype, "memberFirstName$", void 0);
__decorate([
    Select(ProfileState.lastName)
], LoginFacade.prototype, "memberLastName$", void 0);
__decorate([
    Select(MemberState.loading)
], LoginFacade.prototype, "memberLoading$", void 0);
__decorate([
    Select(MemberState.loginError)
], LoginFacade.prototype, "memberLoginError$", void 0);
__decorate([
    LiveEditInactive()
], LoginFacade.prototype, "viewLoggedInAgentDetails", null);
__decorate([
    LiveEditInactive()
], LoginFacade.prototype, "showExternalLoginPrompt", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.SiteService }, { type: i1.MemberSessionService }, { type: AnalyticsService }, { type: i1.GuidedHelpService }, { type: PharmacyFacade }, { type: AccountOverviewFacade }, { type: i1.ConfigResourceService }, { type: i1$1.NgbModal }, { type: i1.NavigationService }, { type: i2.Store }, { type: i1.SSOHttpService }]; }, { agentName$: [], agentFirstName$: [], agentLastName$: [], agentLoginError$: [], agentLoading$: [], memberName$: [], memberFirstName$: [], memberLastName$: [], memberLoading$: [], memberLoginError$: [], viewLoggedInAgentDetails: [], showExternalLoginPrompt: [] }); })();

const _c0$3b = ["createAccountZipInput"];
const _c1$1H = ["createAccountFirstNameInput"];
function CreateAccountComponent_div_4_ng_container_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r13.Spa_Profile_FirstNameRequired_Error);
} }
function CreateAccountComponent_div_4_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CreateAccountComponent_div_4_ng_container_4_span_1_Template, 2, 1, "span", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const firstNameErrors_r12 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", firstNameErrors_r12.required);
} }
function CreateAccountComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelement(1, "i", 28);
    i0.ɵɵelementStart(2, "span", 29);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CreateAccountComponent_div_4_ng_container_4_Template, 2, 1, "ng-container", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.Spa_Site_ErrorKeyword_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.getFieldErrors(ctx_r0.firstNameFieldName));
} }
function CreateAccountComponent_div_13_ng_container_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r16.Spa_Profile_LastNameRequired_Error);
} }
function CreateAccountComponent_div_13_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CreateAccountComponent_div_13_ng_container_4_span_1_Template, 2, 1, "span", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const lastNameErrors_r15 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", lastNameErrors_r15.required);
} }
function CreateAccountComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelement(1, "i", 28);
    i0.ɵɵelementStart(2, "span", 29);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CreateAccountComponent_div_13_ng_container_4_Template, 2, 1, "ng-container", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.Spa_Site_ErrorKeyword_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.getFieldErrors(ctx_r2.lastNameFieldName));
} }
function CreateAccountComponent_ng_template_24_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 32);
    i0.ɵɵlistener("click", function CreateAccountComponent_ng_template_24_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r18.editZipCode()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r17.Spa_Site_ZipCodeInput_EditCounty, " ");
} }
function CreateAccountComponent_ng_template_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, CreateAccountComponent_ng_template_24_button_0_Template, 2, 1, "button", 31);
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r5.editZipCodeEnabled);
} }
function CreateAccountComponent_div_27_ng_container_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r22.Spa_Profile_EmailRequired_Error);
} }
function CreateAccountComponent_div_27_ng_container_4_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r23.Spa_Profile_EmailExists_Error);
} }
function CreateAccountComponent_div_27_ng_container_4_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r24.Spa_Profile_EmailInvalid_Error);
} }
function CreateAccountComponent_div_27_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CreateAccountComponent_div_27_ng_container_4_span_1_Template, 2, 1, "span", 19);
    i0.ɵɵtemplate(2, CreateAccountComponent_div_27_ng_container_4_span_2_Template, 2, 1, "span", 19);
    i0.ɵɵtemplate(3, CreateAccountComponent_div_27_ng_container_4_span_3_Template, 2, 1, "span", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const emailErrors_r21 = ctx.ngIf;
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", emailErrors_r21.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r20.Spa_Profile_ConsumerUserNameField_Enabled && emailErrors_r21.existing);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", emailErrors_r21.email);
} }
function CreateAccountComponent_div_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelement(1, "i", 28);
    i0.ɵɵelementStart(2, "span", 29);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CreateAccountComponent_div_27_ng_container_4_Template, 4, 3, "ng-container", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r6.Spa_Site_ErrorKeyword_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.getFieldErrors(ctx_r6.emailFieldName));
} }
function CreateAccountComponent_ng_container_35_div_1_ng_container_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r28.Spa_Profile_UserNameRequired_Error);
} }
function CreateAccountComponent_ng_container_35_div_1_ng_container_4_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r29.Spa_Profile_UserNameExists_Error);
} }
function CreateAccountComponent_ng_container_35_div_1_ng_container_4_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r30.Spa_Profile_UserNameRequired_Error);
} }
function CreateAccountComponent_ng_container_35_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CreateAccountComponent_ng_container_35_div_1_ng_container_4_span_1_Template, 2, 1, "span", 19);
    i0.ɵɵtemplate(2, CreateAccountComponent_ng_container_35_div_1_ng_container_4_span_2_Template, 2, 1, "span", 19);
    i0.ɵɵtemplate(3, CreateAccountComponent_ng_container_35_div_1_ng_container_4_span_3_Template, 2, 1, "span", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const userNameErrors_r27 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", userNameErrors_r27.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", userNameErrors_r27.existing);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", userNameErrors_r27.minlength);
} }
function CreateAccountComponent_ng_container_35_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelement(1, "i", 28);
    i0.ɵɵelementStart(2, "span", 29);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CreateAccountComponent_ng_container_35_div_1_ng_container_4_Template, 4, 3, "ng-container", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r25.Spa_Site_ErrorKeyword_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r25.getFieldErrors(ctx_r25.userNameFieldName));
} }
const _c2$12 = function (a0) { return { "has-error": a0 }; };
const _c3$J = function (a0) { return { "error-color": a0 }; };
function CreateAccountComponent_ng_container_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CreateAccountComponent_ng_container_35_div_1_Template, 5, 2, "div", 34);
    i0.ɵɵelementStart(2, "label", 4)(3, "span", 5);
    i0.ɵɵtext(4, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 6)(6, "span", 7);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(8, "input", 35);
    i0.ɵɵelementStart(9, "span", 22);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.fieldHasError(ctx_r7.userNameFieldName));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", ctx_r7.userNameFieldName)("ngClass", i0.ɵɵpureFunction1(8, _c2$12, ctx_r7.fieldHasError(ctx_r7.userNameFieldName)));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c3$J, ctx_r7.fieldHasError(ctx_r7.userNameFieldName)));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r7.Spa_Profile_Username_Label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", ctx_r7.userNameFieldName)("ngClass", i0.ɵɵpureFunction1(12, _c2$12, ctx_r7.fieldHasError(ctx_r7.userNameFieldName)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r7.Spa_Profile_UserNameHint_Text);
} }
function CreateAccountComponent_div_36_ng_container_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r33.Spa_Profile_PasswordRequired_Error);
} }
function CreateAccountComponent_div_36_ng_container_4_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r34.Spa_Profile_PasswordInvalid_Error);
} }
function CreateAccountComponent_div_36_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CreateAccountComponent_div_36_ng_container_4_span_1_Template, 2, 1, "span", 19);
    i0.ɵɵtemplate(2, CreateAccountComponent_div_36_ng_container_4_span_2_Template, 2, 1, "span", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const passwordErrors_r32 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", passwordErrors_r32.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", passwordErrors_r32.pattern);
} }
function CreateAccountComponent_div_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵelement(1, "i", 28);
    i0.ɵɵelementStart(2, "span", 29);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CreateAccountComponent_div_36_ng_container_4_Template, 3, 2, "ng-container", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r8.Spa_Site_ErrorKeyword_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.getFieldErrors(ctx_r8.passwordFieldName));
} }
function CreateAccountComponent_div_46_ng_container_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r37.Spa_Profile_PasswordConfirmRequired_Error);
} }
function CreateAccountComponent_div_46_ng_container_4_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r38.Spa_Profile_PasswordMismatch_Error);
} }
function CreateAccountComponent_div_46_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CreateAccountComponent_div_46_ng_container_4_span_1_Template, 2, 1, "span", 19);
    i0.ɵɵtemplate(2, CreateAccountComponent_div_46_ng_container_4_span_2_Template, 2, 1, "span", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const passwordConfirmErrors_r36 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", passwordConfirmErrors_r36.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", passwordConfirmErrors_r36.valueMismatch);
} }
function CreateAccountComponent_div_46_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵelement(1, "i", 28);
    i0.ɵɵelementStart(2, "span", 29);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CreateAccountComponent_div_46_ng_container_4_Template, 3, 2, "ng-container", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r9.Spa_Site_ErrorKeyword_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.getFieldErrors(ctx_r9.passwordConfirmFieldName));
} }
function CreateAccountComponent_vnext_status_button_55_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-status-button", 39);
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isButtonTypeSubmit", true)("buttonText", ctx_r10.Spa_Profile_CreateAccountButton_Text)("tooltipMessageError", ctx_r10.Spa_Profile_AccountCreationFailed_Error)("buttonClass", "w-100 Spa_Style_PrimaryButton login-popover-container-button");
} }
class CreateAccountComponent extends ConfigurableWidget {
    constructor(store, sessionService, formValidationService, cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, createAccountFacade, planFacade, profileService, loginFacade, navigationService, analyticsService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.store = store;
        this.sessionService = sessionService;
        this.formValidationService = formValidationService;
        this.createAccountFacade = createAccountFacade;
        this.planFacade = planFacade;
        this.profileService = profileService;
        this.loginFacade = loginFacade;
        this.navigationService = navigationService;
        this.analyticsService = analyticsService;
        this.defaultFirstName = '';
        this.defaultLastName = '';
        this.defaultEmail = '';
        this.Spa_Profile_CreateAccount_Text = 'Create an account';
        this.Spa_Profile_FirstName_Label = 'First name';
        this.Spa_Profile_FirstNameRequired_Error = 'Please provide first name';
        this.Spa_Profile_LastName_Label = 'Last name';
        this.Spa_Profile_LastNameRequired_Error = 'Please provide last name';
        this.Spa_Profile_Email_Label = 'Email address';
        this.Spa_Profile_EmailRequired_Error = 'Please provide email address';
        this.Spa_Profile_EmailInvalid_Error = 'Please provide a valid email address';
        this.Spa_Profile_EmailExists_Error = 'Email exists, please provide another.';
        this.Spa_Profile_Password_Label = 'Create a password';
        this.Spa_Profile_PasswordRequired_Error = 'Please provide a password';
        this.Spa_Profile_PasswordInvalid_Error = 'Please provide a valid password';
        this.Spa_Profile_PasswordHint_Text = 'Must contain at least 8 characters with 1 number and 1 capital letter.';
        this.Spa_Profile_PasswordConfirm_Label = 'Confirm password';
        this.Spa_Profile_PasswordConfirmRequired_Error = 'Please confirm your password';
        this.Spa_Profile_PasswordMismatch_Error = 'Passwords do not match';
        this.Spa_Profile_CreateAccountButton_Text = 'Create an account';
        this.Spa_Site_ZipCodeInput_SelectedCountyEnabled = true;
        this.Spa_Site_ZipCodeInput_ZipCodeError = 'Zip code is invalid';
        this.Spa_Site_ZipCodeInput_CountyError = 'Please select your county';
        this.Spa_Site_ZipCodeInput_SelectCounty = 'Select county';
        this.Spa_Site_ZipCodeInput_ZipCodeLabel = 'Zip code';
        this.Spa_Site_ZipCodeInput_EditCounty = 'Edit';
        this.Spa_Profile_AccountCreationFailed_Error = 'Try again';
        this.Spa_Site_ErrorKeyword_Text = 'Error:';
        this.Spa_Profile_Username_Label = 'Username';
        this.Spa_Profile_UserNameRequired_Error = 'Please provide a valid username.';
        this.Spa_Profile_UserNameExists_Error = 'Username exists. Please provide another.';
        this.Spa_Profile_UserNameHint_Text = 'Must be between 6 and 50 characters.';
        this.Spa_Profile_ConsumerUserNameField_Enabled = true;
        this.Spa_ZipCodeInput_CountyLabel_Text = 'County';
        this.Spa_ZipCodeInput_CountyLabel_Enabled = false;
        this.passwordRegexPattern = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,100}$';
        this.passwordRegex = new RegExp(this.passwordRegexPattern);
        this.checkFocus = false;
        this.zipCodeCustomStyles = {
            roundInputRightBorder: true,
            noErrorGapWhenValid: true,
            redBorderOnError: true,
            editCountyAlwaysUnderInput: true,
            smallerCountyMarginTop: true
        };
        this.emailFieldName = 'email';
        this.firstNameFieldName = 'firstName';
        this.lastNameFieldName = 'lastName';
        this.zipFieldName = 'zip';
        this.countyFipsFieldName = 'countyFips';
        this.passwordFieldName = 'password';
        this.passwordConfirmFieldName = 'passwordConfirm';
        this.userNameFieldName = 'userName';
        this.editZipCodeEnabled = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.createAccountForm = new UntypedFormGroup({
            [this.firstNameFieldName]: new UntypedFormControl(this.defaultFirstName, [Validators.required]),
            [this.lastNameFieldName]: new UntypedFormControl(this.defaultLastName, [Validators.required]),
            [this.zipFieldName]: new UntypedFormControl(this.sessionService.getZipCode(), Validators.required),
            [this.countyFipsFieldName]: new UntypedFormControl(this.sessionService.getFipsCode(), Validators.required),
            [this.emailFieldName]: new UntypedFormControl(this.defaultEmail, [Validators.required, Validators.email]),
            [this.passwordFieldName]: new UntypedFormControl('', [Validators.required, Validators.pattern(this.passwordRegex)]),
            [this.passwordConfirmFieldName]: new UntypedFormControl('', [Validators.required])
        }, this.formValidationService.getMatchFieldsValidator(this.passwordFieldName, this.passwordConfirmFieldName));
        if (this.Spa_Profile_ConsumerUserNameField_Enabled) {
            this.createAccountForm.addControl(this.userNameFieldName, new UntypedFormControl('', [Validators.required, Validators.minLength(6)]));
        }
        if (this.profileService.getZip()) {
            this.editZipCodeEnabled = true;
        }
    }
    ngAfterViewChecked() {
        if (this.checkFocus) {
            const firstInvalidCreateAccountFormInput = document.querySelector('.popover-body input.has-error');
            const firstInvalidCreateAccountFormElenment = firstInvalidCreateAccountFormInput;
            const invalidCountyFormInput = document.querySelector('.popover-body .county-error .county-dropdown-item');
            const invalidCountyFormInputElement = invalidCountyFormInput;
            if ((invalidCountyFormInputElement &&
                firstInvalidCreateAccountFormElenment &&
                (firstInvalidCreateAccountFormElenment.getAttribute('formcontrolname').indexOf(this.lastNameFieldName) === -1 ||
                    firstInvalidCreateAccountFormElenment.getAttribute('formcontrolname').indexOf(this.firstNameFieldName) !== -1)) ||
                (invalidCountyFormInputElement && !firstInvalidCreateAccountFormElenment)) {
                invalidCountyFormInputElement.focus();
            }
            else if (firstInvalidCreateAccountFormElenment) {
                firstInvalidCreateAccountFormElenment.focus();
            }
            this.checkFocus = false;
        }
    }
    createAccount() {
        this.submitButton.closeTooltip();
        if (this.zipInput) {
            this.createAccountForm.markAllAsTouched();
            const profileAddress = this.profileService.getPrimaryAddress();
            const zipInputWidgetId = this.zipInput.widgetService.widgetId;
            const zipErrors = this.widgetValidationService
                .validate({ widgetIds: [zipInputWidgetId] })
                .filter(error => error.widgetId === zipInputWidgetId);
            if (this.createAccountForm.status === 'VALID' && !zipErrors.length) {
                const accountData = {
                    firstName: this.createAccountForm.get(this.firstNameFieldName).value,
                    lastName: this.createAccountForm.get(this.lastNameFieldName).value,
                    zip: this.createAccountForm.get(this.zipFieldName).value,
                    CountyFips: this.createAccountForm.get(this.countyFipsFieldName).value,
                    emailAddress: this.createAccountForm.get(this.emailFieldName).value,
                    userName: this.Spa_Profile_ConsumerUserNameField_Enabled
                        ? this.createAccountForm.get(this.userNameFieldName).value
                        : this.createAccountForm.get(this.emailFieldName).value,
                    password: this.createAccountForm.get(this.passwordFieldName).value,
                    passwordRegex: this.passwordRegexPattern,
                    address1: profileAddress?.address1 ?? null,
                    address2: profileAddress?.address2 ?? null,
                    city: profileAddress?.city ?? null,
                    isPrimaryAddress: profileAddress?.isPrimaryAddress ?? null,
                    state: profileAddress?.state ?? null
                };
                this.sessionService
                    .createAccountAndLogin(accountData)
                    .then(() => {
                    this.createAccountFacade.saveAccountSession(this.sessionService.getMemberSessionId());
                    this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CASE_CREATE_ACCOUNT_SUCCESS);
                })
                    .catch(error => {
                    // we don't have any good error code to check except for this error string
                    const APIResponseExistingUsername = 'Error creating user, Username Already Exists';
                    if (error.error.Detail === APIResponseExistingUsername) {
                        const fieldName = this.Spa_Profile_ConsumerUserNameField_Enabled ? this.userNameFieldName : this.emailFieldName;
                        this.createAccountForm.get(fieldName).setErrors({ existing: true });
                    }
                    else {
                        this.submitButton.showErrorMessage();
                    }
                    this.checkFocus = true;
                    this.cdr.markForCheck();
                });
            }
            else {
                this.checkFocus = true;
            }
        }
    }
    fieldHasError(fieldName) {
        const control = this.createAccountForm.get(fieldName);
        if (this.createAccountForm.touched) {
            return !control.valid && control.touched;
        }
        return false;
    }
    getFieldErrors(fieldName) {
        const field = this.createAccountForm.get(fieldName);
        return field.errors || {};
    }
    updateZip($event) {
        this.createAccountForm.get(this.zipFieldName).setValue($event);
    }
    updateFips($event) {
        this.createAccountForm.get(this.countyFipsFieldName).setValue($event);
    }
    editZipCode() {
        const cancelAction = () => {
            this.loginFacade.editZipCodeModal(EditZipCodeModalEventTypes.CLOSE);
        };
        const confirmAction = () => {
            this.loginFacade.editZipCodeModal(EditZipCodeModalEventTypes.CLOSE);
            this.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
        };
        this.loginFacade.editZipCodeModal(EditZipCodeModalEventTypes.OPEN);
        this.planFacade.openEditEnrollmentZipModal(cancelAction, confirmAction);
    }
    ngAfterViewInit() {
        this.setViewFocus();
    }
    setViewFocus() {
        if (this.createAccountFirstNameInput) {
            this.createAccountFirstNameInput.nativeElement.focus();
        }
    }
}
CreateAccountComponent.ɵfac = function CreateAccountComponent_Factory(t) { return new (t || CreateAccountComponent)(i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.FormValidationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(CreateAccountFacade), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.ProfileService), i0.ɵɵdirectiveInject(LoginFacade), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(AnalyticsService)); };
CreateAccountComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CreateAccountComponent, selectors: [["vnext-create-account"]], viewQuery: function CreateAccountComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3b, 5);
        i0.ɵɵviewQuery(StatusButtonComponent, 5);
        i0.ɵɵviewQuery(_c1$1H, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.zipInput = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.submitButton = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.createAccountFirstNameInput = _t.first);
    } }, inputs: { defaultFirstName: "defaultFirstName", defaultLastName: "defaultLastName", defaultEmail: "defaultEmail" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 56, vars: 84, consts: [["disableKeyDownSubmit", "", 1, "container", 3, "formGroup", "ngSubmit"], [1, "row"], [1, "Spa_Style_H2"], ["class", "error-container", "id", "firstNameRequiredFieldError", 4, "ngIf"], [3, "for", "ngClass"], [1, "input-error-asterisk"], [1, "Spa_Style_Label", "account-creation-label"], [3, "ngClass"], ["type", "text", "formControlName", "firstName", "maxlength", "100", "aria-describedby", "firstNameRequiredFieldError", "aria-required", "true", 1, "col-12", 3, "id", "ngClass"], ["createAccountFirstNameInput", ""], ["class", "error-container", "id", "lastNameRequiredFieldError", 4, "ngIf"], ["type", "text", "formControlName", "lastName", "maxlength", "100", "aria-describedby", "lastNameRequiredFieldError", "aria-required", "true", 1, "col-12", 3, "id", "ngClass"], [1, "zip-label"], [3, "selectedCountyEnabled", "zipCodeErrorText", "countyErrorText", "selectCountyText", "zipCodeText", "editCountyText", "customStyles", "errorKeywordText", "validateOnBlur", "countyLabel", "showCountyLabel", "searchButtonTemplate", "isReadOnly", "isProfileZip", "zip", "fips"], ["createAccountZipInput", ""], ["zipCodeButton", ""], ["type", "hidden", "formControlName", "zip"], ["class", "error-container", "id", "emailFieldValidationError", 4, "ngIf"], ["type", "text", "formControlName", "email", "maxlength", "255", "autocomplete", "off", "aria-describedby", "emailFieldValidationError", "aria-required", "true", 1, "col-12", 3, "id", "ngClass"], [4, "ngIf"], ["class", "error-container", "id", "passwordFieldValidationError", 4, "ngIf"], ["type", "password", "formControlName", "password", "maxlength", "100", "autocomplete", "off", "aria-describedby", "passwordFieldValidationError", "aria-required", "true", 1, "col-12", 3, "id", "ngClass"], [1, "Spa_Style_Smaller"], ["class", "error-container", "id", "confirmPasswordFieldValidationError", 4, "ngIf"], ["type", "password", "formControlName", "passwordConfirm", "maxlength", "100", "aria-describedby", "confirmPasswordFieldValidationError", "aria-required", "true", 1, "col-12", 3, "id", "ngClass"], [1, "create-account-button", "w-100"], [3, "isButtonTypeSubmit", "buttonText", "tooltipMessageError", "buttonClass", 4, "liveEditProp"], ["id", "firstNameRequiredFieldError", 1, "error-container"], ["aria-hidden", "true", 1, "fa", "fa-exclamation-circle"], [1, "sr-only"], ["id", "lastNameRequiredFieldError", 1, "error-container"], ["type", "button", "class", "Spa_Style_Link action-button d-inline ml-1 mt-1 p-1 login-popover-container-button", 3, "click", 4, "ngIf"], ["type", "button", 1, "Spa_Style_Link", "action-button", "d-inline", "ml-1", "mt-1", "p-1", "login-popover-container-button", 3, "click"], ["id", "emailFieldValidationError", 1, "error-container"], ["class", "error-container", "id", "userNameFieldValidationError", 4, "ngIf"], ["type", "text", "formControlName", "userName", "maxlength", "50", "autocomplete", "off", "aria-describedby", "userNameFieldValidationError", "aria-required", "true", 1, "col-12", 3, "id", "ngClass"], ["id", "userNameFieldValidationError", 1, "error-container"], ["id", "passwordFieldValidationError", 1, "error-container"], ["id", "confirmPasswordFieldValidationError", 1, "error-container"], [3, "isButtonTypeSubmit", "buttonText", "tooltipMessageError", "buttonClass"]], template: function CreateAccountComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 0);
        i0.ɵɵlistener("ngSubmit", function CreateAccountComponent_Template_form_ngSubmit_0_listener() { return ctx.createAccount(); });
        i0.ɵɵelementStart(1, "div", 1)(2, "h2", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, CreateAccountComponent_div_4_Template, 5, 2, "div", 3);
        i0.ɵɵelementStart(5, "label", 4)(6, "span", 5);
        i0.ɵɵtext(7, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "span", 6)(9, "span", 7);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(11, "input", 8, 9);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, CreateAccountComponent_div_13_Template, 5, 2, "div", 10);
        i0.ɵɵelementStart(14, "label", 4)(15, "span", 5);
        i0.ɵɵtext(16, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "span", 6)(18, "span", 7);
        i0.ɵɵtext(19);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(20, "input", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "label", 12)(22, "vnext-zip-code-input", 13, 14);
        i0.ɵɵlistener("zip", function CreateAccountComponent_Template_vnext_zip_code_input_zip_22_listener($event) { return ctx.updateZip($event); })("fips", function CreateAccountComponent_Template_vnext_zip_code_input_fips_22_listener($event) { return ctx.updateFips($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(24, CreateAccountComponent_ng_template_24_Template, 1, 1, "ng-template", null, 15, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelement(26, "input", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(27, CreateAccountComponent_div_27_Template, 5, 2, "div", 17);
        i0.ɵɵelementStart(28, "label", 4)(29, "span", 5);
        i0.ɵɵtext(30, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "span", 6)(32, "span", 7);
        i0.ɵɵtext(33);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(34, "input", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(35, CreateAccountComponent_ng_container_35_Template, 11, 14, "ng-container", 19);
        i0.ɵɵtemplate(36, CreateAccountComponent_div_36_Template, 5, 2, "div", 20);
        i0.ɵɵelementStart(37, "label", 4)(38, "span", 5);
        i0.ɵɵtext(39, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(40, "span", 6)(41, "span", 7);
        i0.ɵɵtext(42);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(43, "input", 21);
        i0.ɵɵelementStart(44, "span", 22);
        i0.ɵɵtext(45);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(46, CreateAccountComponent_div_46_Template, 5, 2, "div", 23);
        i0.ɵɵelementStart(47, "label", 4)(48, "span", 5);
        i0.ɵɵtext(49, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(50, "span", 6)(51, "span", 7);
        i0.ɵɵtext(52);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(53, "input", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(54, "div", 25);
        i0.ɵɵtemplate(55, CreateAccountComponent_vnext_status_button_55_Template, 1, 4, "vnext-status-button", 26);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        const _r4 = i0.ɵɵreference(25);
        i0.ɵɵproperty("formGroup", ctx.createAccountForm);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.Spa_Profile_CreateAccount_Text);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fieldHasError(ctx.firstNameFieldName));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("for", ctx.firstNameFieldName)("ngClass", i0.ɵɵpureFunction1(54, _c2$12, ctx.fieldHasError(ctx.firstNameFieldName)));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(56, _c3$J, ctx.fieldHasError(ctx.firstNameFieldName)));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.Spa_Profile_FirstName_Label);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("id", ctx.firstNameFieldName)("ngClass", i0.ɵɵpureFunction1(58, _c2$12, ctx.fieldHasError(ctx.firstNameFieldName)));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.fieldHasError(ctx.lastNameFieldName));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("for", ctx.lastNameFieldName)("ngClass", i0.ɵɵpureFunction1(60, _c2$12, ctx.fieldHasError(ctx.lastNameFieldName)));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(62, _c3$J, ctx.fieldHasError(ctx.lastNameFieldName)));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.Spa_Profile_LastName_Label);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("id", ctx.lastNameFieldName)("ngClass", i0.ɵɵpureFunction1(64, _c2$12, ctx.fieldHasError(ctx.lastNameFieldName)));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("selectedCountyEnabled", ctx.Spa_Site_ZipCodeInput_SelectedCountyEnabled)("zipCodeErrorText", ctx.Spa_Site_ZipCodeInput_ZipCodeError)("countyErrorText", ctx.Spa_Site_ZipCodeInput_CountyError)("selectCountyText", ctx.Spa_Site_ZipCodeInput_SelectCounty)("zipCodeText", ctx.Spa_Site_ZipCodeInput_ZipCodeLabel)("editCountyText", ctx.Spa_Site_ZipCodeInput_EditCounty)("customStyles", ctx.zipCodeCustomStyles)("errorKeywordText", ctx.Spa_Site_ErrorKeyword_Text)("validateOnBlur", true)("countyLabel", ctx.Spa_ZipCodeInput_CountyLabel_Text)("showCountyLabel", ctx.Spa_ZipCodeInput_CountyLabel_Enabled)("searchButtonTemplate", _r4)("isReadOnly", ctx.editZipCodeEnabled)("isProfileZip", true);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.fieldHasError(ctx.emailFieldName));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("for", ctx.emailFieldName)("ngClass", i0.ɵɵpureFunction1(66, _c2$12, ctx.fieldHasError(ctx.emailFieldName)));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(68, _c3$J, ctx.fieldHasError(ctx.emailFieldName)));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.Spa_Profile_Email_Label);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("id", ctx.emailFieldName)("ngClass", i0.ɵɵpureFunction1(70, _c2$12, ctx.fieldHasError(ctx.emailFieldName)));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Profile_ConsumerUserNameField_Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fieldHasError(ctx.passwordFieldName));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("for", ctx.passwordFieldName)("ngClass", i0.ɵɵpureFunction1(72, _c2$12, ctx.fieldHasError(ctx.passwordFieldName)));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(74, _c3$J, ctx.fieldHasError(ctx.passwordFieldName)));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.Spa_Profile_Password_Label);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("id", ctx.passwordFieldName)("ngClass", i0.ɵɵpureFunction1(76, _c2$12, ctx.fieldHasError(ctx.passwordFieldName)));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.Spa_Profile_PasswordHint_Text);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fieldHasError(ctx.passwordConfirmFieldName));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("for", ctx.passwordConfirmFieldName)("ngClass", i0.ɵɵpureFunction1(78, _c2$12, ctx.fieldHasError(ctx.passwordConfirmFieldName)));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(80, _c3$J, ctx.fieldHasError(ctx.passwordConfirmFieldName)));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.Spa_Profile_PasswordConfirm_Label);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("id", ctx.passwordConfirmFieldName)("ngClass", i0.ɵɵpureFunction1(82, _c2$12, ctx.fieldHasError(ctx.passwordConfirmFieldName)));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_Profile_CreateAccountButton_Text");
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.MaxLengthValidator, i4.FormGroupDirective, i4.FormControlName, ZipCodeInputComponent, StatusButtonComponent, LiveEditPropDirective, FormInputSubmitDirective, IconAriaAttributesDirective], styles: [".zip-label[_ngcontent-%COMP%], label[_ngcontent-%COMP%]{width:100%}.create-account-button[_ngcontent-%COMP%]{margin-top:15px;margin-bottom:15px}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_CreateAccount_Text", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_FirstName_Label", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_FirstNameRequired_Error", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_LastName_Label", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_LastNameRequired_Error", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_Email_Label", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_EmailRequired_Error", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_EmailInvalid_Error", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_EmailExists_Error", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_Password_Label", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_PasswordRequired_Error", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_PasswordInvalid_Error", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_PasswordHint_Text", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_PasswordConfirm_Label", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_PasswordConfirmRequired_Error", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_PasswordMismatch_Error", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_CreateAccountButton_Text", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Site_ZipCodeInput_SelectedCountyEnabled", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Site_ZipCodeInput_ZipCodeError", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Site_ZipCodeInput_CountyError", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Site_ZipCodeInput_SelectCounty", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Site_ZipCodeInput_ZipCodeLabel", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Site_ZipCodeInput_EditCounty", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_AccountCreationFailed_Error", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Site_ErrorKeyword_Text", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_Username_Label", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_UserNameRequired_Error", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_UserNameExists_Error", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_UserNameHint_Text", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_Profile_ConsumerUserNameField_Enabled", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Text", void 0);
__decorate([
    GlobalResource()
], CreateAccountComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Enabled", void 0);
__decorate([
    LiveEditInactive()
], CreateAccountComponent.prototype, "createAccount", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CreateAccountComponent, [{
        type: Component,
        args: [{ selector: 'vnext-create-account', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form class=\"container\" disableKeyDownSubmit [formGroup]=\"createAccountForm\" (ngSubmit)=\"createAccount()\">\r\n  <div class=\"row\">\r\n    <h2 class=\"Spa_Style_H2\">{{ Spa_Profile_CreateAccount_Text }}</h2>\r\n    <!-- Begin First Name Input -->\r\n    <div class=\"error-container\" *ngIf=\"fieldHasError(firstNameFieldName)\" id=\"firstNameRequiredFieldError\">\r\n      <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n      <span class=\"sr-only\">{{ Spa_Site_ErrorKeyword_Text }}</span>\r\n      <ng-container *ngIf=\"getFieldErrors(firstNameFieldName) as firstNameErrors\">\r\n        <span *ngIf=\"firstNameErrors.required\">{{ Spa_Profile_FirstNameRequired_Error }}</span>\r\n      </ng-container>\r\n    </div>\r\n    <label [for]=\"firstNameFieldName\" [ngClass]=\"{ 'has-error': fieldHasError(firstNameFieldName) }\">\r\n      <span class=\"input-error-asterisk\">*</span>\r\n      <span class=\"Spa_Style_Label account-creation-label\">\r\n        <span [ngClass]=\"{ 'error-color': fieldHasError(firstNameFieldName) }\">{{ Spa_Profile_FirstName_Label }}</span>\r\n      </span>\r\n\r\n      <input\r\n        #createAccountFirstNameInput\r\n        type=\"text\"\r\n        class=\"col-12\"\r\n        formControlName=\"firstName\"\r\n        maxlength=\"100\"\r\n        aria-describedby=\"firstNameRequiredFieldError\"\r\n        aria-required=\"true\"\r\n        [id]=\"firstNameFieldName\"\r\n        [ngClass]=\"{ 'has-error': fieldHasError(firstNameFieldName) }\"\r\n      />\r\n    </label>\r\n    <!-- End First Name Input -->\r\n    <!-- Begin Last Name Input -->\r\n    <div class=\"error-container\" *ngIf=\"fieldHasError(lastNameFieldName)\" id=\"lastNameRequiredFieldError\">\r\n      <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n      <span class=\"sr-only\">{{ Spa_Site_ErrorKeyword_Text }}</span>\r\n      <ng-container *ngIf=\"getFieldErrors(lastNameFieldName) as lastNameErrors\">\r\n        <span *ngIf=\"lastNameErrors.required\">{{ Spa_Profile_LastNameRequired_Error }}</span>\r\n      </ng-container>\r\n    </div>\r\n    <label [for]=\"lastNameFieldName\" [ngClass]=\"{ 'has-error': fieldHasError(lastNameFieldName) }\">\r\n      <span class=\"input-error-asterisk\">*</span>\r\n      <span class=\"Spa_Style_Label account-creation-label\">\r\n        <span [ngClass]=\"{ 'error-color': fieldHasError(lastNameFieldName) }\">{{ Spa_Profile_LastName_Label }}</span>\r\n      </span>\r\n\r\n      <input\r\n        type=\"text\"\r\n        class=\"col-12\"\r\n        formControlName=\"lastName\"\r\n        maxlength=\"100\"\r\n        aria-describedby=\"lastNameRequiredFieldError\"\r\n        aria-required=\"true\"\r\n        [id]=\"lastNameFieldName\"\r\n        [ngClass]=\"{ 'has-error': fieldHasError(lastNameFieldName) }\"\r\n      />\r\n    </label>\r\n    <!-- End Last Name Input -->\r\n    <!-- Begin Zip Input -->\r\n    <label class=\"zip-label\">\r\n      <vnext-zip-code-input\r\n        #createAccountZipInput\r\n        [selectedCountyEnabled]=\"Spa_Site_ZipCodeInput_SelectedCountyEnabled\"\r\n        [zipCodeErrorText]=\"Spa_Site_ZipCodeInput_ZipCodeError\"\r\n        [countyErrorText]=\"Spa_Site_ZipCodeInput_CountyError\"\r\n        [selectCountyText]=\"Spa_Site_ZipCodeInput_SelectCounty\"\r\n        [zipCodeText]=\"Spa_Site_ZipCodeInput_ZipCodeLabel\"\r\n        [editCountyText]=\"Spa_Site_ZipCodeInput_EditCounty\"\r\n        [customStyles]=\"zipCodeCustomStyles\"\r\n        (zip)=\"updateZip($event)\"\r\n        (fips)=\"updateFips($event)\"\r\n        [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n        [validateOnBlur]=\"true\"\r\n        [countyLabel]=\"Spa_ZipCodeInput_CountyLabel_Text\"\r\n        [showCountyLabel]=\"Spa_ZipCodeInput_CountyLabel_Enabled\"\r\n        [searchButtonTemplate]=\"zipCodeButton\"\r\n        [isReadOnly]=\"editZipCodeEnabled\"\r\n        [isProfileZip]=\"true\"\r\n      >\r\n      </vnext-zip-code-input>\r\n      <ng-template #zipCodeButton>\r\n        <button\r\n          *ngIf=\"editZipCodeEnabled\"\r\n          type=\"button\"\r\n          class=\"Spa_Style_Link action-button d-inline ml-1 mt-1 p-1 login-popover-container-button\"\r\n          (click)=\"editZipCode()\"\r\n        >\r\n          {{ Spa_Site_ZipCodeInput_EditCounty }}\r\n        </button>\r\n      </ng-template>\r\n      <input type=\"hidden\" formControlName=\"zip\" />\r\n    </label>\r\n    <!-- End Zip Input -->\r\n    <!-- Begin Email Input -->\r\n    <div class=\"error-container\" *ngIf=\"fieldHasError(emailFieldName)\" id=\"emailFieldValidationError\">\r\n      <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n      <span class=\"sr-only\">{{ Spa_Site_ErrorKeyword_Text }}</span>\r\n      <ng-container *ngIf=\"getFieldErrors(emailFieldName) as emailErrors\">\r\n        <span *ngIf=\"emailErrors.required\">{{ Spa_Profile_EmailRequired_Error }}</span>\r\n        <span *ngIf=\"!Spa_Profile_ConsumerUserNameField_Enabled && emailErrors.existing\">{{ Spa_Profile_EmailExists_Error }}</span>\r\n        <span *ngIf=\"emailErrors.email\">{{ Spa_Profile_EmailInvalid_Error }}</span>\r\n      </ng-container>\r\n    </div>\r\n    <label [for]=\"emailFieldName\" [ngClass]=\"{ 'has-error': fieldHasError(emailFieldName) }\">\r\n      <span class=\"input-error-asterisk\">*</span>\r\n      <span class=\"Spa_Style_Label account-creation-label\">\r\n        <span [ngClass]=\"{ 'error-color': fieldHasError(emailFieldName) }\">{{ Spa_Profile_Email_Label }}</span>\r\n      </span>\r\n\r\n      <input\r\n        type=\"text\"\r\n        class=\"col-12\"\r\n        formControlName=\"email\"\r\n        maxlength=\"255\"\r\n        autocomplete=\"off\"\r\n        aria-describedby=\"emailFieldValidationError\"\r\n        aria-required=\"true\"\r\n        [id]=\"emailFieldName\"\r\n        [ngClass]=\"{ 'has-error': fieldHasError(emailFieldName) }\"\r\n      />\r\n    </label>\r\n    <!-- End Email Input -->\r\n    <!-- Start Username Input -->\r\n    <ng-container *ngIf=\"Spa_Profile_ConsumerUserNameField_Enabled\">\r\n      <div class=\"error-container\" *ngIf=\"fieldHasError(userNameFieldName)\" id=\"userNameFieldValidationError\">\r\n        <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n        <span class=\"sr-only\">{{ Spa_Site_ErrorKeyword_Text }}</span>\r\n        <ng-container *ngIf=\"getFieldErrors(userNameFieldName) as userNameErrors\">\r\n          <span *ngIf=\"userNameErrors.required\">{{ Spa_Profile_UserNameRequired_Error }}</span>\r\n          <span *ngIf=\"userNameErrors.existing\">{{ Spa_Profile_UserNameExists_Error }}</span>\r\n          <span *ngIf=\"userNameErrors.minlength\">{{ Spa_Profile_UserNameRequired_Error }}</span>\r\n        </ng-container>\r\n      </div>\r\n      <label [for]=\"userNameFieldName\" [ngClass]=\"{ 'has-error': fieldHasError(userNameFieldName) }\">\r\n        <span class=\"input-error-asterisk\">*</span>\r\n        <span class=\"Spa_Style_Label account-creation-label\">\r\n          <span [ngClass]=\"{ 'error-color': fieldHasError(userNameFieldName) }\">{{ Spa_Profile_Username_Label }}</span>\r\n        </span>\r\n\r\n        <input\r\n          type=\"text\"\r\n          class=\"col-12\"\r\n          formControlName=\"userName\"\r\n          maxlength=\"50\"\r\n          autocomplete=\"off\"\r\n          aria-describedby=\"userNameFieldValidationError\"\r\n          aria-required=\"true\"\r\n          [id]=\"userNameFieldName\"\r\n          [ngClass]=\"{ 'has-error': fieldHasError(userNameFieldName) }\"\r\n        />\r\n        <span class=\"Spa_Style_Smaller\">{{ Spa_Profile_UserNameHint_Text }}</span>\r\n      </label>\r\n    </ng-container>\r\n    <!-- End Username Input -->\r\n    <!-- Start Password Input -->\r\n    <div class=\"error-container\" *ngIf=\"fieldHasError(passwordFieldName)\" id=\"passwordFieldValidationError\">\r\n      <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n      <span class=\"sr-only\">{{ Spa_Site_ErrorKeyword_Text }}</span>\r\n      <ng-container *ngIf=\"getFieldErrors(passwordFieldName) as passwordErrors\">\r\n        <span *ngIf=\"passwordErrors.required\">{{ Spa_Profile_PasswordRequired_Error }}</span>\r\n        <span *ngIf=\"passwordErrors.pattern\">{{ Spa_Profile_PasswordInvalid_Error }}</span>\r\n      </ng-container>\r\n    </div>\r\n    <label [for]=\"passwordFieldName\" [ngClass]=\"{ 'has-error': fieldHasError(passwordFieldName) }\">\r\n      <span class=\"input-error-asterisk\">*</span>\r\n      <span class=\"Spa_Style_Label account-creation-label\">\r\n        <span [ngClass]=\"{ 'error-color': fieldHasError(passwordFieldName) }\">{{ Spa_Profile_Password_Label }}</span>\r\n      </span>\r\n\r\n      <input\r\n        type=\"password\"\r\n        class=\"col-12\"\r\n        formControlName=\"password\"\r\n        maxlength=\"100\"\r\n        autocomplete=\"off\"\r\n        aria-describedby=\"passwordFieldValidationError\"\r\n        aria-required=\"true\"\r\n        [id]=\"passwordFieldName\"\r\n        [ngClass]=\"{ 'has-error': fieldHasError(passwordFieldName) }\"\r\n      />\r\n      <span class=\"Spa_Style_Smaller\">{{ Spa_Profile_PasswordHint_Text }}</span>\r\n    </label>\r\n    <!-- End Password Input -->\r\n    <!-- Start Password Reset Input -->\r\n    <div class=\"error-container\" *ngIf=\"fieldHasError(passwordConfirmFieldName)\" id=\"confirmPasswordFieldValidationError\">\r\n      <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n      <span class=\"sr-only\">{{ Spa_Site_ErrorKeyword_Text }}</span>\r\n      <ng-container *ngIf=\"getFieldErrors(passwordConfirmFieldName) as passwordConfirmErrors\">\r\n        <span *ngIf=\"passwordConfirmErrors.required\">{{ Spa_Profile_PasswordConfirmRequired_Error }}</span>\r\n        <span *ngIf=\"passwordConfirmErrors.valueMismatch\">{{ Spa_Profile_PasswordMismatch_Error }}</span>\r\n      </ng-container>\r\n    </div>\r\n    <label [for]=\"passwordConfirmFieldName\" [ngClass]=\"{ 'has-error': fieldHasError(passwordConfirmFieldName) }\">\r\n      <span class=\"input-error-asterisk\">*</span>\r\n      <span class=\"Spa_Style_Label account-creation-label\">\r\n        <span [ngClass]=\"{ 'error-color': fieldHasError(passwordConfirmFieldName) }\">{{ Spa_Profile_PasswordConfirm_Label }}</span>\r\n      </span>\r\n\r\n      <input\r\n        type=\"password\"\r\n        class=\"col-12\"\r\n        formControlName=\"passwordConfirm\"\r\n        maxlength=\"100\"\r\n        aria-describedby=\"confirmPasswordFieldValidationError\"\r\n        aria-required=\"true\"\r\n        [id]=\"passwordConfirmFieldName\"\r\n        [ngClass]=\"{ 'has-error': fieldHasError(passwordConfirmFieldName) }\"\r\n      />\r\n    </label>\r\n    <!-- End Password Confirm Input -->\r\n    <div class=\"create-account-button w-100\">\r\n      <vnext-status-button\r\n        [isButtonTypeSubmit]=\"true\"\r\n        [buttonText]=\"Spa_Profile_CreateAccountButton_Text\"\r\n        [tooltipMessageError]=\"Spa_Profile_AccountCreationFailed_Error\"\r\n        [buttonClass]=\"'w-100 Spa_Style_PrimaryButton login-popover-container-button'\"\r\n        *liveEditProp=\"'Spa_Profile_CreateAccountButton_Text'\"\r\n      ></vnext-status-button>\r\n    </div>\r\n  </div>\r\n</form>\r\n", styles: [".zip-label,label{width:100%}.create-account-button{margin-top:15px;margin-bottom:15px}\n"] }]
    }], function () { return [{ type: i2.Store }, { type: i1.MemberSessionService }, { type: i1.FormValidationService }, { type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: CreateAccountFacade }, { type: PlanFacade }, { type: i1.ProfileService }, { type: LoginFacade }, { type: i1.NavigationService }, { type: AnalyticsService }]; }, { zipInput: [{
            type: ViewChild,
            args: ['createAccountZipInput']
        }], submitButton: [{
            type: ViewChild,
            args: [StatusButtonComponent]
        }], createAccountFirstNameInput: [{
            type: ViewChild,
            args: ['createAccountFirstNameInput']
        }], defaultFirstName: [{
            type: Input
        }], defaultLastName: [{
            type: Input
        }], defaultEmail: [{
            type: Input
        }], Spa_Profile_CreateAccount_Text: [], Spa_Profile_FirstName_Label: [], Spa_Profile_FirstNameRequired_Error: [], Spa_Profile_LastName_Label: [], Spa_Profile_LastNameRequired_Error: [], Spa_Profile_Email_Label: [], Spa_Profile_EmailRequired_Error: [], Spa_Profile_EmailInvalid_Error: [], Spa_Profile_EmailExists_Error: [], Spa_Profile_Password_Label: [], Spa_Profile_PasswordRequired_Error: [], Spa_Profile_PasswordInvalid_Error: [], Spa_Profile_PasswordHint_Text: [], Spa_Profile_PasswordConfirm_Label: [], Spa_Profile_PasswordConfirmRequired_Error: [], Spa_Profile_PasswordMismatch_Error: [], Spa_Profile_CreateAccountButton_Text: [], Spa_Site_ZipCodeInput_SelectedCountyEnabled: [], Spa_Site_ZipCodeInput_ZipCodeError: [], Spa_Site_ZipCodeInput_CountyError: [], Spa_Site_ZipCodeInput_SelectCounty: [], Spa_Site_ZipCodeInput_ZipCodeLabel: [], Spa_Site_ZipCodeInput_EditCounty: [], Spa_Profile_AccountCreationFailed_Error: [], Spa_Site_ErrorKeyword_Text: [], Spa_Profile_Username_Label: [], Spa_Profile_UserNameRequired_Error: [], Spa_Profile_UserNameExists_Error: [], Spa_Profile_UserNameHint_Text: [], Spa_Profile_ConsumerUserNameField_Enabled: [], Spa_ZipCodeInput_CountyLabel_Text: [], Spa_ZipCodeInput_CountyLabel_Enabled: [], createAccount: [] }); })();

class CreateAccountContext {
    constructor() {
        this._openCreateAccount$ = new Subject();
        this._showCreateAccountNudge$ = new BehaviorSubject(false);
        this._isCreateAccountFromExternal$ = new Subject();
        this.openCreateAccount$ = this._openCreateAccount$.asObservable();
        this.showCreateAccountNudge$ = this._showCreateAccountNudge$.asObservable();
        this.isCreateAccountFromExternal$ = this._isCreateAccountFromExternal$.asObservable();
    }
    openCreateAccount(createAccountFormData) {
        this._openCreateAccount$.next(createAccountFormData);
    }
    displayCreateAccountNudge() {
        this._showCreateAccountNudge$.next(true);
    }
    hideCreateAccountNudge() {
        this._showCreateAccountNudge$.next(false);
    }
    isCreateAccountFromExternal(isExternalClick = false) {
        this._isCreateAccountFromExternal$.next(isExternalClick);
    }
}
CreateAccountContext.ɵfac = function CreateAccountContext_Factory(t) { return new (t || CreateAccountContext)(); };
CreateAccountContext.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CreateAccountContext, factory: CreateAccountContext.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CreateAccountContext, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

function ConsumerForgotPasswordComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div")(2, "div", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵelement(5, "i", 5);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.checkEmailText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r0.emailSentText, " ");
} }
function ConsumerForgotPasswordComponent_ng_template_3_div_3_ng_container_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r5.userNameRequiredError);
} }
function ConsumerForgotPasswordComponent_ng_template_3_div_3_ng_container_4_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.invalidUserNameError);
} }
function ConsumerForgotPasswordComponent_ng_template_3_div_3_ng_container_4_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r7.emailFailedError);
} }
function ConsumerForgotPasswordComponent_ng_template_3_div_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConsumerForgotPasswordComponent_ng_template_3_div_3_ng_container_4_span_1_Template, 2, 1, "span", 17);
    i0.ɵɵtemplate(2, ConsumerForgotPasswordComponent_ng_template_3_div_3_ng_container_4_span_2_Template, 2, 1, "span", 17);
    i0.ɵɵtemplate(3, ConsumerForgotPasswordComponent_ng_template_3_div_3_ng_container_4_span_3_Template, 2, 1, "span", 17);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.userNameFieldErrors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.userNameFieldErrors.invalidUsername);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.userNameFieldErrors.emailFailed);
} }
function ConsumerForgotPasswordComponent_ng_template_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "i", 15);
    i0.ɵɵelementStart(2, "span", 16);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ConsumerForgotPasswordComponent_ng_template_3_div_3_ng_container_4_Template, 4, 3, "ng-container", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.errorKeywordText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.userNameFieldErrors);
} }
const _c0$3a = function (a0) { return { "has-error": a0 }; };
const _c1$1G = function (a0) { return { "error-color": a0 }; };
function ConsumerForgotPasswordComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 6);
    i0.ɵɵlistener("ngSubmit", function ConsumerForgotPasswordComponent_ng_template_3_Template_form_ngSubmit_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.submitPasswordReset()); });
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ConsumerForgotPasswordComponent_ng_template_3_div_3_Template, 5, 2, "div", 7);
    i0.ɵɵelementStart(4, "label", 8)(5, "span", 9);
    i0.ɵɵtext(6, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 10)(8, "span", 11);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "input", 12);
    i0.ɵɵlistener("blur", function ConsumerForgotPasswordComponent_ng_template_3_Template_input_blur_10_listener() { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.updateUserNameErrors()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "button", 13);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r2.forgotPasswordForm);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.instructionsText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.userNameFieldHasErrors);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$3a, ctx_r2.userNameFieldHasErrors));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c1$1G, ctx_r2.userNameFieldHasErrors));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.usernameLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c0$3a, ctx_r2.userNameFieldHasErrors));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.sendEmailText, " ");
} }
class ConsumerForgotPasswordComponent {
    constructor(passwordResetService, emailService, store, navigationUtilityService, configResourceService, cdr) {
        this.passwordResetService = passwordResetService;
        this.emailService = emailService;
        this.store = store;
        this.navigationUtilityService = navigationUtilityService;
        this.configResourceService = configResourceService;
        this.cdr = cdr;
        this.forgotPasswordForm = new UntypedFormGroup({ userName: new UntypedFormControl('', [Validators.required]) });
        this.userNameFieldErrors = {};
        this.userNameFieldHasErrors = false;
        this.submitSuccess = false;
    }
    updateUserNameErrors() {
        const control = this.forgotPasswordForm.get('userName');
        if (control.invalid) {
            this.userNameFieldHasErrors = true;
            this.userNameFieldErrors = control.errors;
        }
        else {
            this.userNameFieldHasErrors = false;
            this.userNameFieldErrors = {};
        }
        this.cdr.markForCheck();
    }
    async submitPasswordReset() {
        if (this.forgotPasswordForm.valid) {
            const userName = `${this.forgotPasswordForm.get('userName').value}`.trim();
            const recoveryHashReturn = await this.passwordResetService
                .generateRecoveryHash(userName, ResetHashRequestType.USER_NAME, PasswordResetUserType.CONSUMER)
                .catch(error => {
                // This does not fail on an invalid username, but could fail for some other reason.
                // An invalid username will be handled in the if statement right after this
                this.forgotPasswordForm.get('userName').setErrors({
                    invalidUsername: true
                });
            });
            if (recoveryHashReturn && recoveryHashReturn.emailAddress) {
                this.submitSuccess = true;
                let sendPasswordEmailReturn = false;
                await this.sendPasswordResetEmail(recoveryHashReturn)
                    .then(() => {
                    sendPasswordEmailReturn = true;
                })
                    .catch(error => {
                    this.forgotPasswordForm.get('userName').setErrors({
                        emailFailed: true
                    });
                });
            }
            else {
                this.forgotPasswordForm.get('userName').setErrors({
                    invalidUsername: true
                });
            }
            this.updateUserNameErrors();
        }
        this.cdr.markForCheck();
    }
    async sendPasswordResetEmail(accountData) {
        const to = [accountData.emailAddress];
        const subject = `${this.headerText}`;
        const baseUrlValue = this.store.selectSnapshot(AppConfigState.defaultUrl);
        const resetPasswordUrl = `${baseUrlValue}/${this.navigationUtilityService.constructHref(PageTags.RESET_PASSWORD)}`;
        const data = [
            {
                key: 'primaryButtonColor',
                value: this.emailService.getPrimaryButtonColor()
            },
            {
                key: 'loginLink',
                value: `${baseUrlValue}/${this.navigationUtilityService.constructHref(PageTags.HOME)}`
            }
        ];
        const resetHashValidityTime = this.configResourceService.getProcessedResourceValue('Spa_Consumer_HashValidity_Time', null, 60);
        const resetRequest = {
            userName: accountData.userName,
            emailAddress: accountData.emailAddress,
            resetHash: accountData.resetHash,
            resetHashValidityTime,
            userType: PasswordResetUserType.CONSUMER,
            requestType: ResetHashRequestType.USER_NAME
        };
        return this.emailService.recoverPassword(ResetType.CONSUMER, to, subject, resetRequest, resetPasswordUrl, data);
    }
}
ConsumerForgotPasswordComponent.ɵfac = function ConsumerForgotPasswordComponent_Factory(t) { return new (t || ConsumerForgotPasswordComponent)(i0.ɵɵdirectiveInject(i1.PasswordResetService), i0.ɵɵdirectiveInject(i1.EmailService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
ConsumerForgotPasswordComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ConsumerForgotPasswordComponent, selectors: [["vnext-consumer-forgot-password"]], inputs: { emailSentText: "emailSentText", checkEmailText: "checkEmailText", instructionsText: "instructionsText", userNameRequiredError: "userNameRequiredError", invalidUserNameError: "invalidUserNameError", usernameLabel: "usernameLabel", sendEmailText: "sendEmailText", errorKeywordText: "errorKeywordText", headerText: "headerText", emailFailedError: "emailFailedError" }, decls: 5, vars: 3, consts: [[1, "Spa_Style_H2"], [4, "ngIf", "ngIfElse"], ["forgotPasswordFormTemplate", ""], [1, "Spa_Style_Primary_Color", "Spa_Style_Paragraph"], [1, "mt-4", "mb-5", "Spa_Style_Cost_Text_Color", "Spa_Style_Paragraph", "text-center"], [1, "fas", "fa-check-circle", "mr-2"], ["disableKeyDownSubmit", "", 3, "formGroup", "ngSubmit"], ["class", "error-container", "id", "userNameFieldValidationError", 4, "ngIf"], ["for", "userName", 1, "w-100", 3, "ngClass"], [1, "input-error-asterisk"], [1, "Spa_Style_Label", "label"], [3, "ngClass"], ["id", "userName", "type", "text", "formControlName", "userName", "maxlength", "50", "autocomplete", "off", "aria-describedby", "userNameFieldValidationError", "aria-required", "true", 1, "col-12", 3, "ngClass", "blur"], ["type", "submit", 1, "btn", "Spa_Style_PrimaryButton", "w-100", "mt-2", "mb-2", "login-popover-container-button"], ["id", "userNameFieldValidationError", 1, "error-container"], ["aria-hidden", "true", 1, "fa", "fa-exclamation-circle"], [1, "sr-only"], [4, "ngIf"]], template: function ConsumerForgotPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h2", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, ConsumerForgotPasswordComponent_ng_container_2_Template, 7, 2, "ng-container", 1);
        i0.ɵɵtemplate(3, ConsumerForgotPasswordComponent_ng_template_3_Template, 13, 14, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(4);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.headerText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.submitSuccess)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.MaxLengthValidator, i4.FormGroupDirective, i4.FormControlName, FormInputSubmitDirective, IconAriaAttributesDirective], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConsumerForgotPasswordComponent, [{
        type: Component,
        args: [{ selector: 'vnext-consumer-forgot-password', changeDetection: ChangeDetectionStrategy.OnPush, template: "<h2 class=\"Spa_Style_H2\">{{ headerText }}</h2>\r\n\r\n<ng-container *ngIf=\"submitSuccess; else forgotPasswordFormTemplate\">\r\n  <div>\r\n    <div class=\"Spa_Style_Primary_Color Spa_Style_Paragraph\">{{ checkEmailText }}</div>\r\n    <div class=\"mt-4 mb-5 Spa_Style_Cost_Text_Color Spa_Style_Paragraph text-center\">\r\n      <i class=\"fas fa-check-circle mr-2\"></i>{{ emailSentText }}\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n<ng-template #forgotPasswordFormTemplate>\r\n  <form disableKeyDownSubmit [formGroup]=\"forgotPasswordForm\" (ngSubmit)=\"submitPasswordReset()\">\r\n    <div class=\"Spa_Style_Primary_Color Spa_Style_Paragraph\">{{ instructionsText }}</div>\r\n\r\n    <div class=\"error-container\" *ngIf=\"userNameFieldHasErrors\" id=\"userNameFieldValidationError\">\r\n      <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n      <span class=\"sr-only\">{{ errorKeywordText }}</span>\r\n      <ng-container *ngIf=\"userNameFieldErrors\">\r\n        <span *ngIf=\"userNameFieldErrors.required\">{{ userNameRequiredError }}</span>\r\n        <span *ngIf=\"userNameFieldErrors.invalidUsername\">{{ invalidUserNameError }}</span>\r\n        <span *ngIf=\"userNameFieldErrors.emailFailed\">{{ emailFailedError }}</span>\r\n      </ng-container>\r\n    </div>\r\n    <label for=\"userName\" class=\"w-100\" [ngClass]=\"{ 'has-error': userNameFieldHasErrors }\">\r\n      <span class=\"input-error-asterisk\">*</span>\r\n      <span class=\"Spa_Style_Label label\">\r\n        <span [ngClass]=\"{ 'error-color': userNameFieldHasErrors }\">{{ usernameLabel }}</span>\r\n      </span>\r\n\r\n      <input\r\n        id=\"userName\"\r\n        type=\"text\"\r\n        class=\"col-12\"\r\n        formControlName=\"userName\"\r\n        maxlength=\"50\"\r\n        autocomplete=\"off\"\r\n        aria-describedby=\"userNameFieldValidationError\"\r\n        aria-required=\"true\"\r\n        [ngClass]=\"{ 'has-error': userNameFieldHasErrors }\"\r\n        (blur)=\"updateUserNameErrors()\"\r\n      />\r\n    </label>\r\n    <button class=\"btn Spa_Style_PrimaryButton w-100 mt-2 mb-2 login-popover-container-button\" type=\"submit\">\r\n      {{ sendEmailText }}\r\n    </button>\r\n  </form>\r\n</ng-template>\r\n" }]
    }], function () { return [{ type: i1.PasswordResetService }, { type: i1.EmailService }, { type: i2.Store }, { type: i1.NavigationUtilityService }, { type: i1.ConfigResourceService }, { type: i0.ChangeDetectorRef }]; }, { emailSentText: [{
            type: Input
        }], checkEmailText: [{
            type: Input
        }], instructionsText: [{
            type: Input
        }], userNameRequiredError: [{
            type: Input
        }], invalidUserNameError: [{
            type: Input
        }], usernameLabel: [{
            type: Input
        }], sendEmailText: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], headerText: [{
            type: Input
        }], emailFailedError: [{
            type: Input
        }] }); })();

function ConsumerForgotUsernameComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div")(2, "div", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵelement(5, "i", 5);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.checkEmailText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r0.emailSentText, " ");
} }
function ConsumerForgotUsernameComponent_ng_template_3_div_3_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r5.firstNameRequiredError);
} }
function ConsumerForgotUsernameComponent_ng_template_3_div_3_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.invalidUserEmailComboErrorText);
} }
function ConsumerForgotUsernameComponent_ng_template_3_div_3_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r7.emailFailedError);
} }
function ConsumerForgotUsernameComponent_ng_template_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵelementStart(2, "span", 18);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ConsumerForgotUsernameComponent_ng_template_3_div_3_span_4_Template, 2, 1, "span", 19);
    i0.ɵɵtemplate(5, ConsumerForgotUsernameComponent_ng_template_3_div_3_span_5_Template, 2, 1, "span", 19);
    i0.ɵɵtemplate(6, ConsumerForgotUsernameComponent_ng_template_3_div_3_span_6_Template, 2, 1, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.errorKeywordText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.firstNameFieldErrors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.invalidUserEmailComboError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.firstNameFieldErrors.emailFailed);
} }
function ConsumerForgotUsernameComponent_ng_template_3_div_11_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r8.emailRequiredError);
} }
function ConsumerForgotUsernameComponent_ng_template_3_div_11_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r9.emailRequiredError);
} }
function ConsumerForgotUsernameComponent_ng_template_3_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵelementStart(2, "span", 18);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ConsumerForgotUsernameComponent_ng_template_3_div_11_span_4_Template, 2, 1, "span", 19);
    i0.ɵɵtemplate(5, ConsumerForgotUsernameComponent_ng_template_3_div_11_span_5_Template, 2, 1, "span", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r4.errorKeywordText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.emailFieldErrors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.emailFieldErrors.email);
} }
const _c0$39 = function (a0) { return { "has-error": a0 }; };
const _c1$1F = function (a0) { return { "error-color": a0 }; };
function ConsumerForgotUsernameComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 6);
    i0.ɵɵlistener("ngSubmit", function ConsumerForgotUsernameComponent_ng_template_3_Template_form_ngSubmit_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.submitUsernameRequest()); });
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ConsumerForgotUsernameComponent_ng_template_3_div_3_Template, 7, 4, "div", 7);
    i0.ɵɵelementStart(4, "label", 8)(5, "span", 9);
    i0.ɵɵtext(6, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 10)(8, "span", 11);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "input", 12);
    i0.ɵɵlistener("blur", function ConsumerForgotUsernameComponent_ng_template_3_Template_input_blur_10_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.updateErrors(ctx_r12.firstNameFieldName)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(11, ConsumerForgotUsernameComponent_ng_template_3_div_11_Template, 6, 3, "div", 13);
    i0.ɵɵelementStart(12, "label", 8)(13, "span", 9);
    i0.ɵɵtext(14, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "span", 10)(16, "span", 11);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "input", 14);
    i0.ɵɵlistener("blur", function ConsumerForgotUsernameComponent_ng_template_3_Template_input_blur_18_listener() { i0.ɵɵrestoreView(_r11); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.updateErrors(ctx_r13.emailFieldName)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "button", 15);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r2.forgotUserNameForm);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.instructionsText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.firstNameFieldHasValidationErrors || ctx_r2.invalidUserEmailComboError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", ctx_r2.firstNameFieldName)("ngClass", i0.ɵɵpureFunction1(19, _c0$39, ctx_r2.firstNameFieldHasValidationErrors || ctx_r2.invalidUserEmailComboError));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(21, _c1$1F, ctx_r2.firstNameFieldHasValidationErrors || ctx_r2.invalidUserEmailComboError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.firstNameLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", ctx_r2.firstNameFieldName)("ngClass", i0.ɵɵpureFunction1(23, _c0$39, ctx_r2.firstNameFieldHasValidationErrors || ctx_r2.invalidUserEmailComboError))("formControlName", ctx_r2.firstNameFieldName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.emailFieldHasValidationErrors);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", ctx_r2.emailFieldName)("ngClass", i0.ɵɵpureFunction1(25, _c0$39, ctx_r2.emailFieldHasValidationErrors || ctx_r2.invalidUserEmailComboError));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(27, _c1$1F, ctx_r2.emailFieldHasValidationErrors || ctx_r2.invalidUserEmailComboError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.emailLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", ctx_r2.emailFieldName)("ngClass", i0.ɵɵpureFunction1(29, _c0$39, ctx_r2.emailFieldHasValidationErrors || ctx_r2.invalidUserEmailComboError))("formControlName", ctx_r2.emailFieldName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.sendEmailText, " ");
} }
class ConsumerForgotUsernameComponent {
    constructor(passwordResetService, emailService, store, navigationUtilityService, cdr) {
        this.passwordResetService = passwordResetService;
        this.emailService = emailService;
        this.store = store;
        this.navigationUtilityService = navigationUtilityService;
        this.cdr = cdr;
        this.firstNameFieldName = 'firstName';
        this.firstNameFieldErrors = {};
        this.firstNameFieldHasValidationErrors = false;
        this.emailFieldName = 'email';
        this.emailFieldErrors = {};
        this.emailFieldHasValidationErrors = false;
        this.invalidUserEmailComboError = false;
        this.forgotUserNameForm = new UntypedFormGroup({
            [this.firstNameFieldName]: new UntypedFormControl('', [Validators.required]),
            [this.emailFieldName]: new UntypedFormControl('', [Validators.required, Validators.email, Validators.maxLength(255)])
        });
        this.submitSuccess = false;
    }
    updateErrors(fieldName) {
        const control = this.forgotUserNameForm.get(fieldName);
        if (control) {
            if (control.touched && !control.valid) {
                this[`${fieldName}FieldHasValidationErrors`] = true;
                this[`${fieldName}FieldErrors`] = control.errors;
                this.invalidUserEmailComboError = false;
            }
            else {
                this[`${fieldName}FieldHasValidationErrors`] = false;
                this[`${fieldName}FieldErrors`] = {};
            }
            this.cdr.markForCheck();
        }
    }
    getFirstNameField() {
        return this.forgotUserNameForm.get(this.firstNameFieldName);
    }
    getEmailField() {
        return this.forgotUserNameForm.get(this.emailFieldName);
    }
    async submitUsernameRequest() {
        this.forgotUserNameForm.markAllAsTouched();
        this.updateErrors(this.firstNameFieldName);
        this.updateErrors(this.emailFieldName);
        if (this.forgotUserNameForm.valid) {
            const emailValue = `${this.getEmailField().value}`.trim();
            const firstNameValue = `${this.getFirstNameField().value}`.trim();
            const recoveryHashReturn = await this.passwordResetService
                .generateRecoveryHash(emailValue, ResetHashRequestType.EMAIL_ADDRESS, PasswordResetUserType.CONSUMER, firstNameValue)
                .catch(error => {
                this.invalidUserEmailComboError = true;
            });
            // Can't use recoveryHasReturn?.emailAddress due to the type of the promise technically being void | GenerateResteHashReturnModel
            // property emailAddress does not exist on an object of type void. !!void === false though, so it exists after the &&
            if (recoveryHashReturn && recoveryHashReturn.emailAddress) {
                this.submitSuccess = true;
                await this.sendUserNameResetEmail(recoveryHashReturn).catch(error => {
                    this.getFirstNameField().setErrors({
                        emailFailed: true
                    });
                });
            }
            else {
                this.invalidUserEmailComboError = true;
            }
        }
        this.cdr.markForCheck();
    }
    async sendUserNameResetEmail(accountData) {
        const baseUrlValue = this.store.selectSnapshot(AppConfigState.defaultUrl);
        const buttonColorValue = this.emailService.getPrimaryButtonColor();
        const userName = accountData.userName;
        const inputs = [
            {
                key: 'primaryButtonColor',
                value: buttonColorValue
            },
            { key: 'baseUrl', value: baseUrlValue },
            {
                key: 'loginLink',
                value: `${baseUrlValue}/${this.navigationUtilityService.constructHref(PageTags.HOME)}`
            },
            {
                key: 'buttonColorStroke',
                value: AppThemeConfig.adjustColor(buttonColorValue, -50, true)
            },
            {
                key: 'userName',
                value: `${userName}`
            }
        ];
        return this.emailService.sendEmail(EmailNames.CONSUMER_FORGOT_USERNAME, [accountData.emailAddress], `${this.headerText}`, inputs);
    }
}
ConsumerForgotUsernameComponent.ɵfac = function ConsumerForgotUsernameComponent_Factory(t) { return new (t || ConsumerForgotUsernameComponent)(i0.ɵɵdirectiveInject(i1.PasswordResetService), i0.ɵɵdirectiveInject(i1.EmailService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
ConsumerForgotUsernameComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ConsumerForgotUsernameComponent, selectors: [["vnext-consumer-forgot-username"]], inputs: { emailSentText: "emailSentText", checkEmailText: "checkEmailText", instructionsText: "instructionsText", firstNameRequiredError: "firstNameRequiredError", invalidUserEmailComboErrorText: "invalidUserEmailComboErrorText", emailRequiredError: "emailRequiredError", emailLabel: "emailLabel", firstNameLabel: "firstNameLabel", sendEmailText: "sendEmailText", errorKeywordText: "errorKeywordText", headerText: "headerText", emailFailedError: "emailFailedError" }, decls: 5, vars: 3, consts: [[1, "Spa_Style_H2"], [4, "ngIf", "ngIfElse"], ["forgotUsernameFormTemplate", ""], [1, "Spa_Style_Primary_Color", "Spa_Style_Paragraph"], [1, "mt-4", "mb-5", "Spa_Style_Cost_Text_Color", "Spa_Style_Paragraph", "text-center"], [1, "fas", "fa-check-circle", "mr-2"], ["disableKeyDownSubmit", "", 3, "formGroup", "ngSubmit"], ["class", "error-container", "id", "firstNameFieldValidationError", 4, "ngIf"], [1, "w-100", 3, "for", "ngClass"], [1, "input-error-asterisk"], [1, "Spa_Style_Label", "label"], [3, "ngClass"], ["type", "text", "maxlength", "50", "autocomplete", "off", "aria-describedby", "firstNameFieldValidationError", "aria-required", "true", 1, "col-12", 3, "id", "ngClass", "formControlName", "blur"], ["class", "error-container", "id", "emailFieldValidationError", 4, "ngIf"], ["type", "text", "maxlength", "50", "autocomplete", "off", "aria-describedby", "emailFieldValidationError", "aria-required", "true", 1, "col-12", 3, "id", "ngClass", "formControlName", "blur"], ["type", "submit", 1, "btn", "Spa_Style_PrimaryButton", "w-100", "mt-2", "mb-2", "login-popover-container-button"], ["id", "firstNameFieldValidationError", 1, "error-container"], ["aria-hidden", "true", 1, "fa", "fa-exclamation-circle"], [1, "sr-only"], [4, "ngIf"], ["id", "emailFieldValidationError", 1, "error-container"]], template: function ConsumerForgotUsernameComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h2", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, ConsumerForgotUsernameComponent_ng_container_2_Template, 7, 2, "ng-container", 1);
        i0.ɵɵtemplate(3, ConsumerForgotUsernameComponent_ng_template_3_Template, 21, 31, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(4);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.headerText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.submitSuccess)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.MaxLengthValidator, i4.FormGroupDirective, i4.FormControlName, FormInputSubmitDirective, IconAriaAttributesDirective], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConsumerForgotUsernameComponent, [{
        type: Component,
        args: [{ selector: 'vnext-consumer-forgot-username', changeDetection: ChangeDetectionStrategy.OnPush, template: "<h2 class=\"Spa_Style_H2\">{{ headerText }}</h2>\r\n\r\n<ng-container *ngIf=\"submitSuccess; else forgotUsernameFormTemplate\">\r\n  <div>\r\n    <div class=\"Spa_Style_Primary_Color Spa_Style_Paragraph\">{{ checkEmailText }}</div>\r\n    <div class=\"mt-4 mb-5 Spa_Style_Cost_Text_Color Spa_Style_Paragraph text-center\">\r\n      <i class=\"fas fa-check-circle mr-2\"></i>{{ emailSentText }}\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n<ng-template #forgotUsernameFormTemplate>\r\n  <form disableKeyDownSubmit [formGroup]=\"forgotUserNameForm\" (ngSubmit)=\"submitUsernameRequest()\">\r\n    <div class=\"Spa_Style_Primary_Color Spa_Style_Paragraph\">{{ instructionsText }}</div>\r\n    <div class=\"error-container\" *ngIf=\"firstNameFieldHasValidationErrors || invalidUserEmailComboError\" id=\"firstNameFieldValidationError\">\r\n      <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n      <span class=\"sr-only\">{{ errorKeywordText }}</span>\r\n      <span *ngIf=\"firstNameFieldErrors.required\">{{ firstNameRequiredError }}</span>\r\n      <span *ngIf=\"invalidUserEmailComboError\">{{ invalidUserEmailComboErrorText }}</span>\r\n      <span *ngIf=\"firstNameFieldErrors.emailFailed\">{{ emailFailedError }}</span>\r\n    </div>\r\n    <label\r\n      class=\"w-100\"\r\n      [for]=\"firstNameFieldName\"\r\n      [ngClass]=\"{ 'has-error': firstNameFieldHasValidationErrors || invalidUserEmailComboError }\"\r\n    >\r\n      <span class=\"input-error-asterisk\">*</span>\r\n      <span class=\"Spa_Style_Label label\">\r\n        <span [ngClass]=\"{ 'error-color': firstNameFieldHasValidationErrors || invalidUserEmailComboError }\">{{ firstNameLabel }}</span>\r\n      </span>\r\n\r\n      <input\r\n        type=\"text\"\r\n        class=\"col-12\"\r\n        maxlength=\"50\"\r\n        autocomplete=\"off\"\r\n        aria-describedby=\"firstNameFieldValidationError\"\r\n        aria-required=\"true\"\r\n        [id]=\"firstNameFieldName\"\r\n        [ngClass]=\"{ 'has-error': firstNameFieldHasValidationErrors || invalidUserEmailComboError }\"\r\n        [formControlName]=\"firstNameFieldName\"\r\n        (blur)=\"updateErrors(firstNameFieldName)\"\r\n      />\r\n    </label>\r\n\r\n    <div class=\"error-container\" *ngIf=\"emailFieldHasValidationErrors\" id=\"emailFieldValidationError\">\r\n      <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n      <span class=\"sr-only\">{{ errorKeywordText }}</span>\r\n      <span *ngIf=\"emailFieldErrors.required\">{{ emailRequiredError }}</span>\r\n      <span *ngIf=\"emailFieldErrors.email\">{{ emailRequiredError }}</span>\r\n    </div>\r\n    <label class=\"w-100\" [for]=\"emailFieldName\" [ngClass]=\"{ 'has-error': emailFieldHasValidationErrors || invalidUserEmailComboError }\">\r\n      <span class=\"input-error-asterisk\">*</span>\r\n      <span class=\"Spa_Style_Label label\">\r\n        <span [ngClass]=\"{ 'error-color': emailFieldHasValidationErrors || invalidUserEmailComboError }\">{{ emailLabel }}</span>\r\n      </span>\r\n\r\n      <input\r\n        type=\"text\"\r\n        class=\"col-12\"\r\n        maxlength=\"50\"\r\n        autocomplete=\"off\"\r\n        aria-describedby=\"emailFieldValidationError\"\r\n        aria-required=\"true\"\r\n        [id]=\"emailFieldName\"\r\n        [ngClass]=\"{ 'has-error': emailFieldHasValidationErrors || invalidUserEmailComboError }\"\r\n        [formControlName]=\"emailFieldName\"\r\n        (blur)=\"updateErrors(emailFieldName)\"\r\n      />\r\n    </label>\r\n    <button class=\"btn Spa_Style_PrimaryButton w-100 mt-2 mb-2 login-popover-container-button\" type=\"submit\">\r\n      {{ sendEmailText }}\r\n    </button>\r\n  </form>\r\n</ng-template>\r\n" }]
    }], function () { return [{ type: i1.PasswordResetService }, { type: i1.EmailService }, { type: i2.Store }, { type: i1.NavigationUtilityService }, { type: i0.ChangeDetectorRef }]; }, { emailSentText: [{
            type: Input
        }], checkEmailText: [{
            type: Input
        }], instructionsText: [{
            type: Input
        }], firstNameRequiredError: [{
            type: Input
        }], invalidUserEmailComboErrorText: [{
            type: Input
        }], emailRequiredError: [{
            type: Input
        }], emailLabel: [{
            type: Input
        }], firstNameLabel: [{
            type: Input
        }], sendEmailText: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], headerText: [{
            type: Input
        }], emailFailedError: [{
            type: Input
        }] }); })();

const _c0$38 = ["loginPopover"];
const _c1$1E = ["logOutPopover"];
const _c2$11 = ["userNameField"];
const _c3$I = ["passwordField"];
const _c4$p = ["loginPopoverToggle"];
const _c5$f = ["logOutPopoverToggle"];
function LoginComponent_ng_container_0_ng_template_1_ng_container_9_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "vnext-link", 15);
    i0.ɵɵlistener("click", function LoginComponent_ng_container_0_ng_template_1_ng_container_9_div_1_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r11.navigateToConsumerAccountSummary()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r10.consumerAccountSummaryText)("keyNameForLiveEdit", "Spa_Consumer_AccountOverview_Header_Text")("customClass", "Spa_Style_Paragraph no-underline ml-1");
} }
function LoginComponent_ng_container_0_ng_template_1_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LoginComponent_ng_container_0_ng_template_1_ng_container_9_div_1_Template, 2, 3, "div", 13);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.consumerAccountOverviewEnabled && !ctx_r8.isPPCSite);
} }
function LoginComponent_ng_container_0_ng_template_1_ng_container_10_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17)(1, "vnext-link", 12);
    i0.ɵɵlistener("click", function LoginComponent_ng_container_0_ng_template_1_ng_container_10_div_1_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r17.navigateToEnrollmentReports()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r13.agentReportsHeaderText)("customClass", "Spa_Style_Paragraph no-underline ml-1");
} }
function LoginComponent_ng_container_0_ng_template_1_ng_container_10_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17)(1, "vnext-link", 12);
    i0.ɵɵlistener("click", function LoginComponent_ng_container_0_ng_template_1_ng_container_10_div_2_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r19.navigateToPlanSmart()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r14.planSmartText)("customClass", "Spa_Style_Paragraph no-underline ml-1");
} }
function LoginComponent_ng_container_0_ng_template_1_ng_container_10_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17)(1, "vnext-link", 12);
    i0.ɵɵlistener("click", function LoginComponent_ng_container_0_ng_template_1_ng_container_10_div_3_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r21.navigateToTrainingMaterials()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r15.trainingMaterialsText)("customClass", "Spa_Style_Paragraph no-underline ml-1");
} }
function LoginComponent_ng_container_0_ng_template_1_ng_container_10_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17)(1, "vnext-link", 12);
    i0.ɵɵlistener("click", function LoginComponent_ng_container_0_ng_template_1_ng_container_10_div_4_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r23.loginFacade.viewLoggedInAgentDetails(ctx_r23.pageTags.AGENT_ACCOUNT_OVERVIEW)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r16.accountOverviewText)("customClass", "Spa_Style_Paragraph no-underline ml-1");
} }
function LoginComponent_ng_container_0_ng_template_1_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LoginComponent_ng_container_0_ng_template_1_ng_container_10_div_1_Template, 2, 2, "div", 16);
    i0.ɵɵtemplate(2, LoginComponent_ng_container_0_ng_template_1_ng_container_10_div_2_Template, 2, 2, "div", 16);
    i0.ɵɵtemplate(3, LoginComponent_ng_container_0_ng_template_1_ng_container_10_div_3_Template, 2, 2, "div", 16);
    i0.ɵɵtemplate(4, LoginComponent_ng_container_0_ng_template_1_ng_container_10_div_4_Template, 2, 2, "div", 16);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.agentReportsHeaderText && ctx_r9.enrollmentReportsEnabled && (!ctx_r9.enrollmentReportsAdminOnlyEnabled || ctx_r9.isAdmin) && !ctx_r9.isEnroller && !ctx_r9.isQuoter);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.isPlanSmartEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.trainingMaterialsEnabled || ctx_r9.lmsTrainingMaterialsEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.accountOverviewEnabled);
} }
function LoginComponent_ng_container_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "button", 7);
    i0.ɵɵlistener("click", function LoginComponent_ng_container_0_ng_template_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r26); i0.ɵɵnextContext(); const _r6 = i0.ɵɵreference(5); const ctx_r25 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r25.closeLogoutPopover(_r6)); });
    i0.ɵɵelementStart(2, "span", 8);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "i", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 10)(6, "h2", 11);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(9, LoginComponent_ng_container_0_ng_template_1_ng_container_9_Template, 2, 1, "ng-container", 5);
    i0.ɵɵtemplate(10, LoginComponent_ng_container_0_ng_template_1_ng_container_10_Template, 5, 4, "ng-container", 5);
    i0.ɵɵelementStart(11, "vnext-link", 12);
    i0.ɵɵlistener("click", function LoginComponent_ng_container_0_ng_template_1_Template_vnext_link_click_11_listener() { i0.ɵɵrestoreView(_r26); const ctx_r27 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r27.logOut()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.closeText, "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 6, ctx_r4.userName$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r4.isPPCSite);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.isPPCSite);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r4.logoutText)("customClass", "Spa_Style_Paragraph mt-3 ml-1 no-underline");
} }
function LoginComponent_ng_container_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 18)(2, "div", 19)(3, "div", 20);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "shortName");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "i", 21);
    i0.ɵɵelementStart(8, "span", 8);
    i0.ɵɵtext(9, "Expand menu");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r7.siteType === ctx_r7.siteTypes.CONSUMER ? "Spa_Style_H3 pl-2" : "Spa_Style_Paragraph Spa_Style_Smaller_Font");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 2, i0.ɵɵpipeBind1(6, 4, ctx_r7.userName$)), " ");
} }
const _c6$e = function (a0) { return { "login-header": a0 }; };
function LoginComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LoginComponent_ng_container_0_ng_template_1_Template, 12, 8, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(3, "a", 3, 4);
    i0.ɵɵlistener("keyup.enter", function LoginComponent_ng_container_0_Template_a_keyup_enter_3_listener() { i0.ɵɵrestoreView(_r29); const _r6 = i0.ɵɵreference(5); return i0.ɵɵresetView(_r6.toggle()); });
    i0.ɵɵtemplate(6, LoginComponent_ng_container_0_ng_container_6_Template, 10, 6, "ng-container", 5);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r3 = i0.ɵɵreference(2);
    const _r6 = i0.ɵɵreference(5);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbPopover", _r3)("ngClass", i0.ɵɵpureFunction1(9, _c6$e, ctx_r0.siteType === ctx_r0.siteTypes.BROKER))("autoClose", "outside");
    i0.ɵɵattribute("aria-expanded", _r6.isOpen());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(7, 5, ctx_r0.primaryLoggedIn$) && i0.ɵɵpipeBind1(8, 7, ctx_r0.userName$));
} }
function LoginComponent_ng_template_2_ng_template_0_ng_container_6_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelement(1, "i", 44);
    i0.ɵɵelementStart(2, "span", 8);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r40.errorKeywordText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r40.loginErrorMessageText, " ");
} }
function LoginComponent_ng_template_2_ng_template_0_ng_container_6_div_24_Template(rf, ctx) { if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-link", 45);
    i0.ɵɵlistener("click", function LoginComponent_ng_template_2_ng_template_0_ng_container_6_div_24_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r48); const ctx_r47 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r47.showForgotPassword()); })("keyup.enter", function LoginComponent_ng_template_2_ng_template_0_ng_container_6_div_24_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r48); const ctx_r49 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r49.showForgotPassword()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r43.forgotPasswordLinkText)("role", ctx_r43.linkRoles.BUTTON)("ariaLabel", ctx_r43.forgotPasswordLinkText)("customClass", "Spa_Style_Link login-popover-container-linktext");
} }
function LoginComponent_ng_template_2_ng_template_0_ng_container_6_div_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵtext(1, "|");
    i0.ɵɵelementEnd();
} }
function LoginComponent_ng_template_2_ng_template_0_ng_container_6_div_26_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-link", 45);
    i0.ɵɵlistener("click", function LoginComponent_ng_template_2_ng_template_0_ng_container_6_div_26_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r51); const ctx_r50 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r50.showForgotUsername()); })("keyup.enter", function LoginComponent_ng_template_2_ng_template_0_ng_container_6_div_26_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r51); const ctx_r52 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r52.showForgotUsername()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r45.forgotUsernameLinkText)("role", ctx_r45.linkRoles.BUTTON)("ariaLabel", ctx_r45.forgotUsernameLinkText)("customClass", "Spa_Style_Link login-popover-container-linktext");
} }
function LoginComponent_ng_template_2_ng_template_0_ng_container_6_div_27_Template(rf, ctx) { if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 47)(1, "p", 48);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 49);
    i0.ɵɵlistener("click", function LoginComponent_ng_template_2_ng_template_0_ng_container_6_div_27_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r54); const ctx_r53 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r53.createAccount()); });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r46.createAccountLabelText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r46.createAccountButtonText, " ");
} }
const _c7$b = function (a0) { return { "error-color": a0 }; };
const _c8$8 = function (a0) { return { "has-error": a0 }; };
function LoginComponent_ng_template_2_ng_template_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "form", 28);
    i0.ɵɵlistener("ngSubmit", function LoginComponent_ng_template_2_ng_template_0_ng_container_6_Template_form_ngSubmit_1_listener() { i0.ɵɵrestoreView(_r56); const ctx_r55 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r55.validateLogin()); });
    i0.ɵɵelementStart(2, "h2", 29);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, LoginComponent_ng_template_2_ng_template_0_ng_container_6_div_4_Template, 5, 2, "div", 30);
    i0.ɵɵelementStart(5, "div", 31)(6, "label", 32)(7, "div", 20)(8, "span", 33);
    i0.ɵɵtext(9, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(11, "input", 34, 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 31)(14, "label", 36)(15, "div", 20)(16, "span", 33);
    i0.ɵɵtext(17, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(19, "input", 37, 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "button", 39);
    i0.ɵɵtext(22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 40);
    i0.ɵɵtemplate(24, LoginComponent_ng_template_2_ng_template_0_ng_container_6_div_24_Template, 2, 4, "div", 5);
    i0.ɵɵtemplate(25, LoginComponent_ng_template_2_ng_template_0_ng_container_6_div_25_Template, 2, 0, "div", 41);
    i0.ɵɵtemplate(26, LoginComponent_ng_template_2_ng_template_0_ng_container_6_div_26_Template, 2, 4, "div", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(27, LoginComponent_ng_template_2_ng_template_0_ng_container_6_div_27_Template, 5, 2, "div", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r35.loginForm);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r35.loginTitle);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.showLoginError);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c7$b, ctx_r35.showLoginError));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r35.loginUserName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c8$8, ctx_r35.showLoginError));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c7$b, ctx_r35.showLoginError));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r35.loginPassword);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c8$8, ctx_r35.showLoginError));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r35.loginSubmit, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r35.forgotPasswordLinkEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.forgotPasswordLinkEnabled && ctx_r35.forgotUsernameLinkEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.forgotUsernameLinkEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.showCreateAccountSection !== false);
} }
function LoginComponent_ng_template_2_ng_template_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-create-account", 50);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("defaultFirstName", ctx_r36.createAccountFormData == null ? null : ctx_r36.createAccountFormData.firstName)("defaultLastName", ctx_r36.createAccountFormData == null ? null : ctx_r36.createAccountFormData.lastName)("defaultEmail", ctx_r36.createAccountFormData == null ? null : ctx_r36.createAccountFormData.email);
} }
function LoginComponent_ng_template_2_ng_template_0_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-consumer-forgot-password", 51);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("emailSentText", ctx_r37.emailSentText)("checkEmailText", ctx_r37.forgotPasswordCheckEmailText)("instructionsText", ctx_r37.forgotPasswordInstructionsText)("userNameRequiredError", ctx_r37.userNameRequiredError)("invalidUserNameError", ctx_r37.invalidUserNameError)("usernameLabel", ctx_r37.usernameLabel)("sendEmailText", ctx_r37.sendEmailText)("errorKeywordText", ctx_r37.errorKeywordText)("headerText", ctx_r37.forgotPasswordHeaderText)("emailFailedError", ctx_r37.emailFailedError);
} }
function LoginComponent_ng_template_2_ng_template_0_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-consumer-forgot-username", 52);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("emailSentText", ctx_r38.emailSentText)("checkEmailText", ctx_r38.forgotUsernameCheckEmailText)("instructionsText", ctx_r38.forgotUsernameInstructionsText)("firstNameRequiredError", ctx_r38.firstNameRequiredError)("invalidUserEmailComboErrorText", ctx_r38.invalidUserEmailComboError)("emailRequiredError", ctx_r38.emailRequiredError)("emailLabel", ctx_r38.emailLabel)("firstNameLabel", ctx_r38.firstNameLabel)("sendEmailText", ctx_r38.sendEmailText)("errorKeywordText", ctx_r38.errorKeywordText)("emailFailedError", ctx_r38.emailFailedError)("headerText", ctx_r38.forgotUsernameHeaderText);
} }
function LoginComponent_ng_template_2_ng_template_0_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 53)(2, "vnext-inner-text-link", 54);
    i0.ɵɵlistener("innerTextClicked", function LoginComponent_ng_template_2_ng_template_0_ng_container_10_Template_vnext_inner_text_link_innerTextClicked_2_listener() { i0.ɵɵrestoreView(_r58); const ctx_r57 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r57.revertToDefaultView()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("outerText", ctx_r39.loginToAccountText)("innerText", ctx_r39.loginToAccountClickableText)("customClass", "Spa_Style_Link login-popover-container-linktext")("customTextClass", "Spa_Style_Paragraph")("role", ctx_r39.linkRoles.BUTTON)("ariaLabel", ctx_r39.loginToAccountText);
} }
function LoginComponent_ng_template_2_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r60 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "button", 25);
    i0.ɵɵlistener("click", function LoginComponent_ng_template_2_ng_template_0_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r60); const ctx_r59 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r59.closeLoginPopover(ctx_r59.loginPopover)); });
    i0.ɵɵelementStart(2, "span", 8);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "i", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(5, 26);
    i0.ɵɵtemplate(6, LoginComponent_ng_template_2_ng_template_0_ng_container_6_Template, 28, 22, "ng-container", 27);
    i0.ɵɵtemplate(7, LoginComponent_ng_template_2_ng_template_0_ng_container_7_Template, 2, 3, "ng-container", 27);
    i0.ɵɵtemplate(8, LoginComponent_ng_template_2_ng_template_0_ng_container_8_Template, 2, 10, "ng-container", 27);
    i0.ɵɵtemplate(9, LoginComponent_ng_template_2_ng_template_0_ng_container_9_Template, 2, 12, "ng-container", 27);
    i0.ɵɵtemplate(10, LoginComponent_ng_template_2_ng_template_0_ng_container_10_Template, 3, 6, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-label", ctx_r31.loginTitle);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r31.closeText, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitch", ctx_r31.visibleFormType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r31.LoginFormType.Default);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r31.LoginFormType.CreateAccount);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r31.LoginFormType.ForgotPassword);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r31.LoginFormType.ForgotUsername);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r31.visibleFormType !== ctx_r31.LoginFormType.Default);
} }
function LoginComponent_ng_template_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 55);
    i0.ɵɵlistener("click", function LoginComponent_ng_template_2_ng_container_2_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r62); const ctx_r61 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r61.showExternalLoginPrompt()); })("keyup.enter", function LoginComponent_ng_template_2_ng_container_2_Template_a_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r62); const ctx_r63 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r63.showExternalLoginPrompt()); });
    i0.ɵɵelementStart(2, "div", 56)(3, "span", 57);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 58);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "i", 59);
    i0.ɵɵelementStart(8, "span", 8);
    i0.ɵɵtext(9, "Expand menu");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r32.loginHeader);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r32.loginHeader);
} }
function LoginComponent_ng_template_2_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r67 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 60, 61);
    i0.ɵɵlistener("click", function LoginComponent_ng_template_2_ng_template_3_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r67); const ctx_r66 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r66.resetLogin()); })("keyup.enter", function LoginComponent_ng_template_2_ng_template_3_Template_a_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r67); const _r65 = i0.ɵɵreference(2); return i0.ɵɵresetView(_r65.toggle()); });
    i0.ɵɵelementStart(3, "div", 56)(4, "span", 57);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 58);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "i", 59);
    i0.ɵɵelementStart(9, "span", 8);
    i0.ɵɵtext(10, "Expand menu");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const _r65 = i0.ɵɵreference(2);
    i0.ɵɵnextContext();
    const _r30 = i0.ɵɵreference(1);
    const ctx_r34 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngbPopover", _r30)("autoClose", false);
    i0.ɵɵattribute("aria-expanded", _r65.isOpen());
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r34.loginHeader);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r34.loginHeader);
} }
function LoginComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, LoginComponent_ng_template_2_ng_template_0_Template, 11, 8, "ng-template", null, 22, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(2, LoginComponent_ng_template_2_ng_container_2_Template, 10, 2, "ng-container", 0);
    i0.ɵɵtemplate(3, LoginComponent_ng_template_2_ng_template_3_Template, 11, 5, "ng-template", null, 23, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r33 = i0.ɵɵreference(4);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.externalLogin)("ngIfElse", _r33);
} }
class LoginComponent {
    constructor(loginFacade, loginService, siteService, drugsService, analyticsService, elementRef, navigationService, createAccountContext, cdr, agentPermissionsService, memberSessionService, configResourceService, navigationUtilityService, agentService, injector, modalService) {
        this.loginFacade = loginFacade;
        this.loginService = loginService;
        this.siteService = siteService;
        this.drugsService = drugsService;
        this.analyticsService = analyticsService;
        this.elementRef = elementRef;
        this.navigationService = navigationService;
        this.createAccountContext = createAccountContext;
        this.cdr = cdr;
        this.agentPermissionsService = agentPermissionsService;
        this.memberSessionService = memberSessionService;
        this.configResourceService = configResourceService;
        this.navigationUtilityService = navigationUtilityService;
        this.agentService = agentService;
        this.injector = injector;
        this.modalService = modalService;
        this.isRetentionEnabled = true;
        this.consumerAccountOverviewEnabled = false;
        this.enrollmentReportsEnabled = false;
        this.enrollmentReportsAdminOnlyEnabled = false;
        this.forgotPasswordLinkText = 'Forgot password?';
        this.forgotPasswordLinkEnabled = true;
        this.emailSentText = 'An email has been sent.';
        this.forgotPasswordCheckEmailText = 'Check your email to reset your password. If you do not receive an email, try again.';
        this.forgotPasswordInstructionsText = 'Enter your username or email and then check your email to continue.';
        this.userNameRequiredError = 'Username is required';
        this.invalidUserNameError = 'The username is not associated with an account. Please create an account.';
        this.usernameLabel = 'Username';
        this.sendEmailText = 'Send email';
        this.forgotPasswordHeaderText = 'Forgot Password';
        this.emailFailedError = 'Email not sent. Try again later.';
        this.forgotUsernameLinkText = 'Forgot username?';
        this.forgotUsernameLinkEnabled = true;
        this.includeSOA = false;
        this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Cancel = 'Cancel';
        this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Continue = 'Continue';
        this.Spa_Agent_Modal_Contents_Message = 'In order to perform this action, you will need to provide a valid email address. This address will be saved to your agent profile.';
        this.Spa_Agent_EmailAddress_ModalTitle_Text = 'Agent Email Address';
        this.Spa_Agent_EmailAddress_InvalidText = 'Invalid email address';
        this.pageTags = PageTags;
        this.siteTypes = SiteType;
        this.checkFocus = false;
        this.createAccountFormData = { firstName: '', lastName: '', email: '' };
        this.isAdmin = false;
        this.isOpenedFromExternal = false;
        this.subscriptions = [];
        this.visibleFormType = LoginFormType.Default;
        this.LoginFormType = LoginFormType;
        this.loginErrorMessageText = '';
        this.isPPCSite = false;
        this.isEnroller = false;
        this.isQuoter = false;
        this.linkRoles = LinkRoles;
        this.editZipCodeModalIsOpen = false;
    }
    onDocumentClick(event) {
        if (this.loginPopoverToggle && this.loginPopover && this.loginPopover.isOpen() && !this.editZipCodeModalIsOpen) {
            const clickedInsideloginPopoverToggle = this.loginPopoverToggle.nativeElement.contains(event.target);
            const clickedInsideLoginPopover = this.elementRef.nativeElement.contains(event.target);
            const clickedButtonInsideLoginPopover = this.isButtonElementInPopoverClicked(event.target);
            // Close popover if click is outside popover window
            if (!clickedInsideloginPopoverToggle && !clickedInsideLoginPopover && !clickedButtonInsideLoginPopover) {
                this.loginPopover.close();
                this.cdr.detectChanges();
            }
        }
    }
    onKeyUp(event) {
        if (this.loginPopoverToggle && this.loginPopover && this.loginPopover.isOpen() && !this.editZipCodeModalIsOpen) {
            this.loginPopover.close();
            this.cdr.detectChanges();
        }
    }
    ngOnInit() {
        this.loginErrorMessageText = this.loginErrorMessage;
        this.isPPCSite = this.siteService.isPPCSite(this.siteType);
        this.subscriptions = [
            this.createAccountContext.isCreateAccountFromExternal$.subscribe(isExternal => {
                this.isOpenedFromExternal = isExternal;
            }),
            this.createAccountContext.openCreateAccount$.subscribe(createAccountFormData => {
                // if member portal enabled then show external login prompt
                if (this.isMemberPortalLoginEnabled()) {
                    this.showExternalLoginPrompt();
                }
                if (this.loginPopover) {
                    this.createAccountFormData = createAccountFormData;
                    this.createAccount(this.isOpenedFromExternal);
                    if (!this.loginPopover.isOpen()) {
                        this.loginPopover.open();
                    }
                    if (this.createAccountComponent) {
                        this.createAccountComponent.setViewFocus();
                    }
                    this.isOpenedFromExternal = false;
                    this.cdr.detectChanges();
                }
            })
        ];
        const basicData = this.loginFacade.getBasicData(this.siteType);
        this.fullName$ = basicData.fullName$;
        this.firstName$ = basicData.firstName$;
        this.lastName$ = basicData.lastName$;
        this.primaryLoggedIn$ = this.loginService.loggedIn$();
        this.loginForm = new UntypedFormGroup({
            userName: new UntypedFormControl(),
            password: new UntypedFormControl()
        });
        this.userName$ = this.fullName$.pipe(map(name => name));
        const agentRole = this.agentPermissionsService.getAgentRole();
        this.isAdmin = this.agentPermissionsService.isAdmin(agentRole);
        this.isEnroller = this.agentPermissionsService.hasBasicEnrollerRole(agentRole);
        this.isQuoter = this.agentPermissionsService.hasBasicQuoterRole(agentRole);
    }
    ngAfterViewInit() {
        const loginPopoverHidden$ = this.loginPopover?.hidden;
        if (loginPopoverHidden$) {
            this.subscriptions.push(loginPopoverHidden$.subscribe({
                next: () => {
                    this.loginPopoverToggle?.nativeElement?.focus();
                    this.cdr.markForCheck();
                }
            }));
        }
        const logOutPopoverHidden$ = this.logOutPopover?.hidden;
        if (logOutPopoverHidden$) {
            this.subscriptions.push(logOutPopoverHidden$.subscribe({
                next: () => {
                    this.logOutPopoverToggle?.nativeElement?.focus();
                    this.cdr.markForCheck();
                }
            }));
        }
    }
    ngAfterViewChecked() {
        if (this.showLoginError && this.checkFocus) {
            if (this.loginForm.value.userName && !this.loginForm.value.password) {
                this.passwordField?.nativeElement?.focus();
            }
            else {
                this.userNameField?.nativeElement?.focus();
            }
            this.checkFocus = false;
        }
        const loginPopoverShown$ = this.loginPopover?.shown;
        if (loginPopoverShown$) {
            const loginPopoverCancelButtonElement = document.querySelector('.login-popover-cancel');
            this.subscriptions.push(loginPopoverShown$.subscribe({
                next: () => {
                    if (loginPopoverCancelButtonElement) {
                        loginPopoverCancelButtonElement.focus();
                    }
                    this.cdr.markForCheck();
                }
            }));
        }
        const logOutPopoverShown$ = this.logOutPopover?.shown;
        if (logOutPopoverShown$) {
            const logOutPopoverCancelButtonElement = document.querySelector('.logout-popover-cancel');
            this.subscriptions.push(logOutPopoverShown$.subscribe({
                next: () => {
                    if (logOutPopoverCancelButtonElement) {
                        logOutPopoverCancelButtonElement.focus();
                    }
                    this.cdr.markForCheck();
                }
            }));
        }
        this.subscriptions.push(this.loginFacade.getEditZipCode$().subscribe((eventType) => {
            if (eventType === EditZipCodeModalEventTypes.OPEN) {
                this.handleEditZipCodeOpen();
            }
            else if (eventType === EditZipCodeModalEventTypes.CLOSE) {
                this.handleEditZipCodeClose();
            }
            this.cdr.markForCheck();
        }));
    }
    ngOnDestroy() {
        this.subscriptions.forEach(sub => {
            sub.unsubscribe();
        });
    }
    closeLoginPopover(loginPopover) {
        this.revertToDefaultView();
        if (loginPopover.isOpen()) {
            loginPopover.close();
        }
    }
    validateLogin() {
        this.showLoginError = false;
        const userName = this.loginForm.value.userName;
        const password = this.loginForm.value.password;
        if (!userName || !password) {
            this.showLoginError = true;
            this.checkFocus = true;
            this.loginErrorMessageText = this.loginErrorMessage;
        }
        else {
            this.loginService
                .login(this.siteType, userName, password, {
                includeEnrollmentHistory: true,
                fetchCreatingAgent: true,
                includePlanData: true,
                includeSOA: this.includeSOA
            })
                .then(() => {
                this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CASE_LOGIN_SUCCESS);
                if (this.siteType === this.siteTypes.CONSUMER) {
                    this.loginFacade.setDataLayer();
                }
            })
                .catch((error) => {
                this.handleLoginError(error);
            });
        }
    }
    resetLogin() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_HEADER_LOGIN);
        this.revertToDefaultView();
        this.loginForm.reset();
        this.showLoginError = false;
    }
    showExternalLoginPrompt() {
        this.loginFacade.showExternalLoginPrompt();
    }
    logOut() {
        const isRetentionView = this.siteService.isRetentionView();
        if (!isRetentionView) {
            this.drugsService.saveDrugList();
        }
        this.loginService.logout(this.siteType);
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CASE_LOGOUT_SUCCESS);
    }
    createAccount(forceStopGtm = false) {
        if (!forceStopGtm) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_HEADER_CREATE_ACCOUNT);
        }
        this.visibleFormType = LoginFormType.CreateAccount;
    }
    showForgotPassword() {
        this.addOnForgotPasswordClickGoogleTag();
        this.visibleFormType = LoginFormType.ForgotPassword;
    }
    showForgotUsername() {
        this.addOnForgotUsernameClickGoogleTag();
        this.visibleFormType = LoginFormType.ForgotUsername;
    }
    revertToDefaultView() {
        this.visibleFormType = LoginFormType.Default;
    }
    closeLogoutPopover(logOutPopover) {
        if (logOutPopover.isOpen()) {
            logOutPopover.close();
        }
    }
    navigateToConsumerAccountSummary() {
        this.navigationService.navigateByPageTag(PageTags.CONSUMER_ACCOUNT_SUMMARY);
    }
    navigateToEnrollmentReports() {
        this.navigationService.navigateByPageTag(PageTags.REPORTS_SUMMARY);
    }
    navigateToTrainingMaterials() {
        if (this.lmsTrainingMaterialsEnabled) {
            const agentGuid = this.agentService.getAgentInContextGuid();
            if (!this.agentService.getAgentData()?.data?.emailAddress) {
                const options = {
                    ariaLabelledBy: 'modalHeaderTitle',
                    centered: true,
                    injector: this.injector
                };
                const emailModal = this.modalService.open(EmailConfirmationModalComponent, options);
                emailModal.componentInstance.updateAgentEmailAddress = true;
                emailModal.componentInstance.agentGuid = agentGuid;
                emailModal.componentInstance.title = this.Spa_Agent_EmailAddress_ModalTitle_Text;
                emailModal.componentInstance.emailPrompt = this.Spa_Agent_Modal_Contents_Message;
                emailModal.componentInstance.cancelButton = this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Cancel;
                emailModal.componentInstance.confirmButton = this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Continue;
                emailModal.componentInstance.emailAddressRequired = this.Spa_Agent_EmailAddress_InvalidText;
                emailModal.componentInstance.emailAddressInvalid = this.Spa_Agent_EmailAddress_InvalidText;
            }
            else {
                this.navigationService.navigateToLmsInNewTab(agentGuid);
            }
        }
        else {
            this.navigationService.navigateByPageTag(PageTags.AGENT_TRAINING_MATERIALS);
        }
    }
    navigateToPlanSmart() {
        this.navigationService.navigateByPageTag(PageTags.PLAN_SMART);
    }
    handleLoginError(error) {
        this.showLoginError = true;
        if (error?.status === HttpStatusCode.TOO_MANY_REQUESTS) {
            this.loginErrorMessageText = this.attemptsExceededErrorText;
        }
        else {
            this.loginErrorMessageText = this.loginErrorMessage;
        }
        this.userNameField?.nativeElement?.focus();
        this.checkFocus = true;
        this.cdr.markForCheck();
    }
    isMemberPortalLoginEnabled() {
        const isMemberLoggedIn = this.memberSessionService.isMemberLoggedIn();
        const isMemberPortalIntegrationEnable = this.configResourceService.getProcessedResourceValue('Spa_Site_CustomerMemberPortalIntegration_Enabled', null, false);
        return !isMemberLoggedIn && isMemberPortalIntegrationEnable;
    }
    addOnForgotPasswordClickGoogleTag() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_HEADER_FORGOT_PASSWORD
        };
    }
    addOnForgotUsernameClickGoogleTag() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_HEADER_FORGOT_USERNAME
        };
    }
    handleEditZipCodeOpen() {
        this.editZipCodeModalIsOpen = true;
    }
    handleEditZipCodeClose() {
        this.editZipCodeModalIsOpen = false;
    }
    isButtonElementInPopoverClicked(clickedElement) {
        return ((clickedElement.tagName === 'BUTTON' && clickedElement.classList.contains('login-popover-container-button')) ||
            clickedElement.classList.contains('update-zipcode-modal-button') ||
            clickedElement.classList.contains('county-dropdown-item') ||
            clickedElement.classList.contains('select-county') ||
            (clickedElement.tagName === 'SPAN' && clickedElement.closest('div.login-popover-container-linktext')));
    }
}
LoginComponent.ɵfac = function LoginComponent_Factory(t) { return new (t || LoginComponent)(i0.ɵɵdirectiveInject(LoginFacade), i0.ɵɵdirectiveInject(i1.LoginService), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(i1.DrugsService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(CreateAccountContext), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.AgentPermissionsService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1$1.NgbModal)); };
LoginComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LoginComponent, selectors: [["vnext-login"]], viewQuery: function LoginComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(CreateAccountComponent, 5);
        i0.ɵɵviewQuery(_c0$38, 5);
        i0.ɵɵviewQuery(_c1$1E, 5);
        i0.ɵɵviewQuery(_c2$11, 5);
        i0.ɵɵviewQuery(_c3$I, 5);
        i0.ɵɵviewQuery(_c4$p, 5);
        i0.ɵɵviewQuery(_c5$f, 5);
        i0.ɵɵviewQuery(_c0$38, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.createAccountComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.loginPopover = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.logOutPopover = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.userNameField = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.passwordField = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.loginPopoverToggle = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.logOutPopoverToggle = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.loginPopoverRef = _t.first);
    } }, hostBindings: function LoginComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function LoginComponent_click_HostBindingHandler($event) { return ctx.onDocumentClick($event); }, false, i0.ɵɵresolveDocument)("keyup.escape", function LoginComponent_keyup_escape_HostBindingHandler($event) { return ctx.onKeyUp($event); }, false, i0.ɵɵresolveDocument);
    } }, inputs: { loginUserName: "loginUserName", loginPassword: "loginPassword", loginHeader: "loginHeader", loginTitle: "loginTitle", loginSubmit: "loginSubmit", loginErrorMessage: "loginErrorMessage", attemptsExceededErrorText: "attemptsExceededErrorText", logoutText: "logoutText", showCreateAccountSection: "showCreateAccountSection", createAccountLabelText: "createAccountLabelText", createAccountButtonText: "createAccountButtonText", siteType: "siteType", loginToAccountText: "loginToAccountText", loginToAccountClickableText: "loginToAccountClickableText", isRetentionEnabled: "isRetentionEnabled", accountOverviewText: "accountOverviewText", accountOverviewEnabled: "accountOverviewEnabled", trainingMaterialsText: "trainingMaterialsText", trainingMaterialsEnabled: "trainingMaterialsEnabled", lmsTrainingMaterialsEnabled: "lmsTrainingMaterialsEnabled", consumerAccountSummaryText: "consumerAccountSummaryText", consumerAccountOverviewEnabled: "consumerAccountOverviewEnabled", agentReportsHeaderText: "agentReportsHeaderText", enrollmentReportsEnabled: "enrollmentReportsEnabled", enrollmentReportsAdminOnlyEnabled: "enrollmentReportsAdminOnlyEnabled", errorKeywordText: "errorKeywordText", closeText: "closeText", externalLogin: "externalLogin", forgotPasswordLinkText: "forgotPasswordLinkText", forgotPasswordLinkEnabled: "forgotPasswordLinkEnabled", emailSentText: "emailSentText", forgotPasswordCheckEmailText: "forgotPasswordCheckEmailText", forgotPasswordInstructionsText: "forgotPasswordInstructionsText", userNameRequiredError: "userNameRequiredError", invalidUserNameError: "invalidUserNameError", usernameLabel: "usernameLabel", sendEmailText: "sendEmailText", forgotPasswordHeaderText: "forgotPasswordHeaderText", emailFailedError: "emailFailedError", forgotUsernameLinkText: "forgotUsernameLinkText", forgotUsernameLinkEnabled: "forgotUsernameLinkEnabled", emailLabel: "emailLabel", firstNameLabel: "firstNameLabel", invalidUserEmailComboError: "invalidUserEmailComboError", firstNameRequiredError: "firstNameRequiredError", emailRequiredError: "emailRequiredError", forgotUsernameHeaderText: "forgotUsernameHeaderText", forgotUsernameInstructionsText: "forgotUsernameInstructionsText", forgotUsernameCheckEmailText: "forgotUsernameCheckEmailText", isPlanSmartEnabled: "isPlanSmartEnabled", planSmartText: "planSmartText", includeSOA: "includeSOA" }, decls: 4, vars: 4, consts: [[4, "ngIf", "ngIfElse"], ["login", ""], ["logOutWidget", ""], ["placement", "bottom-right", "popoverClass", "logout-popover", "tabindex", "0", "role", "button", 1, "welcome-user-wrapper", "no-underline", "d-block", "can-click", "focus-text", 3, "ngbPopover", "ngClass", "autoClose", "keyup.enter"], ["logOutPopoverToggle", "", "logOutPopover", "ngbPopover"], [4, "ngIf"], [1, "logout-popover-template"], ["tabindex", "0", "role", "button", 1, "popover-cancel", "logout-popover-cancel", "action-button", 3, "click"], [1, "sr-only"], [1, "fas", "fa-times", "Spa_Style_Primary_Color"], [1, "mt-1", "mr-2"], ["tabindex", "0", 1, "Spa_Style_H2", "ml-1", "no-translate-block"], [3, "title", "customClass", "click"], ["class", "mt-3", 4, "ngIf"], [1, "mt-3"], [3, "title", "keyNameForLiveEdit", "customClass", "click"], ["class", "mt-3", "tabindex", "0", 4, "ngIf"], ["tabindex", "0", 1, "mt-3"], [1, "d-flex", "justify-content-end", "align-items-center"], [1, "pr-1", "text-right", "no-translate-block"], [3, "ngClass"], [1, "fas", "fa-chevron-down", "ml-1", "Spa_Style_Smaller_Font", "Spa_Style_Primary_Color"], ["loginWidget", ""], ["internalLogin", ""], ["role", "dialog"], ["tabindex", "0", "role", "button", 1, "popover-cancel", "login-popover-cancel", "action-button", 3, "click"], [3, "ngSwitch"], [4, "ngSwitchCase"], ["disableKeyDownSubmit", "", 3, "formGroup", "ngSubmit"], [1, "Spa_Style_H2"], ["class", "error-color my-2", "id", "loginFormError", 4, "ngIf"], [1, "form-group"], ["for", "userName", 1, "Spa_Style_Label"], [1, "mr-1", "input-error-asterisk"], ["id", "userName", "type", "text", "formControlName", "userName", "autocomplete", "off", "aria-describedby", "loginFormError", "aria-required", "true", 1, "form-control", 3, "ngClass"], ["userNameField", ""], ["for", "pwd", 1, "Spa_Style_Label"], ["id", "pwd", "type", "password", "formControlName", "password", "autocomplete", "off", "aria-describedby", "loginFormError", "aria-required", "true", 1, "form-control", 3, "ngClass"], ["passwordField", ""], ["type", "submit", 1, "btn", "Spa_Style_PrimaryButton", "btn-block", "login-popover-container-button"], [1, "d-flex", "justify-content-between", "links"], ["class", "pipe", 4, "ngIf"], ["class", "form-group create-account-container", 4, "ngIf"], ["id", "loginFormError", 1, "error-color", "my-2"], ["aria-hidden", "true", 1, "fa", "fa-exclamation-circle"], [3, "title", "role", "ariaLabel", "customClass", "click", "keyup.enter"], [1, "pipe"], [1, "form-group", "create-account-container"], [1, "Spa_Style_Paragraph"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "btn-block", "login-popover-container-button", 3, "click"], [3, "defaultFirstName", "defaultLastName", "defaultEmail"], [3, "emailSentText", "checkEmailText", "instructionsText", "userNameRequiredError", "invalidUserNameError", "usernameLabel", "sendEmailText", "errorKeywordText", "headerText", "emailFailedError"], [3, "emailSentText", "checkEmailText", "instructionsText", "firstNameRequiredError", "invalidUserEmailComboErrorText", "emailRequiredError", "emailLabel", "firstNameLabel", "sendEmailText", "errorKeywordText", "emailFailedError", "headerText"], [1, "login-to-account-link"], [3, "outerText", "innerText", "customClass", "customTextClass", "role", "ariaLabel", "innerTextClicked"], ["placement", "bottom-right", "tabindex", "0", "role", "button", 1, "no-underline", "d-inline-block", "can-click", "focus-text", 3, "click", "keyup.enter"], [1, "can-click"], [1, "Spa_Style_H3", "can-click", "d-none", "d-md-inline"], [1, "Spa_Style_Paragraph", "can-click", "d-inline", "d-md-none"], [1, "fas", "fa-chevron-down", "Spa_Style_Primary_Color", "Spa_Style_Smaller_Font", "ml-2"], ["placement", "bottom-right", "popoverClass", "login-popover", "tabindex", "0", "role", "button", 1, "popover-toggle", "no-underline", "d-inline-block", "can-click", "focus-text", 3, "ngbPopover", "autoClose", "click", "keyup.enter"], ["loginPopoverToggle", "", "loginPopover", "ngbPopover"]], template: function LoginComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LoginComponent_ng_container_0_Template, 9, 11, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵtemplate(2, LoginComponent_ng_template_2_Template, 5, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(3);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.primaryLoggedIn$))("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, LinkComponent, InnerTextLinkComponent, FormInputSubmitDirective, IconAriaAttributesDirective, i1$1.NgbPopover, CreateAccountComponent, ConsumerForgotPasswordComponent, ConsumerForgotUsernameComponent, i1$2.AsyncPipe, ShortNamePipe], styles: [".logout-popover-template[_ngcontent-%COMP%]{min-width:200px;position:relative;padding-right:15px}.welcome-user-wrapper[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Primary);cursor:pointer;text-decoration:none}.welcome-user-wrapper[_ngcontent-%COMP%]:hover{text-decoration:none}.user-name[_ngcontent-%COMP%]{float:left;width:220px}.login-header[_ngcontent-%COMP%]{vertical-align:middle;display:table-cell;text-decoration:none}.popover-cancel[_ngcontent-%COMP%]{position:absolute;top:0;right:0;cursor:pointer;color:var(--Spa_Style_Primary);width:20px;height:20px;text-align:center}.login-popover-cancel[_ngcontent-%COMP%]{margin:.5rem}.links[_ngcontent-%COMP%]{margin:25px 0}@media (max-width: 767.98px){.login-popover.popover[_ngcontent-%COMP%]{margin-top:22px}.close-button[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Gray4)}a[_ngcontent-%COMP%]:hover{text-decoration:none}.login-header[_ngcontent-%COMP%]{vertical-align:initial;min-width:73px}}@media (max-width: 479.98px){.logout-link[_ngcontent-%COMP%]{font-size:var(--Spa_Style_Small_Fonter)}}.create-account-container[_ngcontent-%COMP%]{border-top:1px solid var(--static-Spa_Style_Accent1);margin-top:15px;padding-top:15px}.create-account-container[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-bottom:5px}a.popover-toggle[_ngcontent-%COMP%]{vertical-align:bottom;text-decoration:none}a.login-header[_ngcontent-%COMP%]:hover, a.popover-toggle[_ngcontent-%COMP%]:hover{text-decoration:none}a.popover-toggle[_ngcontent-%COMP%]   i.fas[_ngcontent-%COMP%]{vertical-align:middle}.fa-chevron-down[_ngcontent-%COMP%]{cursor:pointer}.login-to-account-link[_ngcontent-%COMP%]{width:100%;text-align:center}.logout-container[_ngcontent-%COMP%]{min-width:250px}.pipe[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent1)}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], LoginComponent.prototype, "Spa_EnrollmentConfirmation_EmailConfirmationModal_Cancel", void 0);
__decorate([
    GlobalResource()
], LoginComponent.prototype, "Spa_EnrollmentConfirmation_EmailConfirmationModal_Continue", void 0);
__decorate([
    GlobalResource()
], LoginComponent.prototype, "Spa_Agent_Modal_Contents_Message", void 0);
__decorate([
    GlobalResource()
], LoginComponent.prototype, "Spa_Agent_EmailAddress_ModalTitle_Text", void 0);
__decorate([
    GlobalResource()
], LoginComponent.prototype, "Spa_Agent_EmailAddress_InvalidText", void 0);
__decorate([
    LiveEditInactive()
], LoginComponent.prototype, "validateLogin", null);
__decorate([
    LiveEditInactive()
], LoginComponent.prototype, "resetLogin", null);
__decorate([
    LiveEditInactive()
], LoginComponent.prototype, "showExternalLoginPrompt", null);
__decorate([
    LiveEditInactive()
], LoginComponent.prototype, "logOut", null);
__decorate([
    LiveEditInactive()
], LoginComponent.prototype, "createAccount", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginComponent, [{
        type: Component,
        args: [{ selector: 'vnext-login', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"primaryLoggedIn$ | async; else login\">\r\n  <ng-template #logOutWidget>\r\n    <div class=\"logout-popover-template\">\r\n      <button\r\n        (click)=\"closeLogoutPopover(logOutPopover)\"\r\n        tabindex=\"0\"\r\n        role=\"button\"\r\n        class=\"popover-cancel logout-popover-cancel action-button\"\r\n      >\r\n        <span class=\"sr-only\"> {{ closeText }}</span>\r\n        <i class=\"fas fa-times Spa_Style_Primary_Color\"></i>\r\n      </button>\r\n\r\n      <div class=\"mt-1 mr-2\">\r\n        <h2 class=\"Spa_Style_H2 ml-1 no-translate-block\" tabindex=\"0\">{{ userName$ | async }}</h2>\r\n      </div>\r\n\r\n      <!-- consumer links -->\r\n      <ng-container *ngIf=\"!isPPCSite\">\r\n        <div class=\"mt-3\" *ngIf=\"consumerAccountOverviewEnabled && !isPPCSite\">\r\n          <vnext-link\r\n            (click)=\"navigateToConsumerAccountSummary()\"\r\n            [title]=\"consumerAccountSummaryText\"\r\n            [keyNameForLiveEdit]=\"'Spa_Consumer_AccountOverview_Header_Text'\"\r\n            [customClass]=\"'Spa_Style_Paragraph no-underline ml-1'\"\r\n          ></vnext-link>\r\n        </div>\r\n      </ng-container>\r\n      <!-- end consumer links -->\r\n      <!-- agent links -->\r\n      <ng-container *ngIf=\"isPPCSite\">\r\n        <div\r\n          class=\"mt-3\"\r\n          tabindex=\"0\"\r\n          *ngIf=\"\r\n            agentReportsHeaderText &&\r\n            enrollmentReportsEnabled &&\r\n            (!enrollmentReportsAdminOnlyEnabled || isAdmin) &&\r\n            !isEnroller &&\r\n            !isQuoter\r\n          \"\r\n        >\r\n          <vnext-link\r\n            (click)=\"navigateToEnrollmentReports()\"\r\n            [title]=\"agentReportsHeaderText\"\r\n            [customClass]=\"'Spa_Style_Paragraph no-underline ml-1'\"\r\n          ></vnext-link>\r\n        </div>\r\n        <div class=\"mt-3\" tabindex=\"0\" *ngIf=\"isPlanSmartEnabled\">\r\n          <vnext-link\r\n            (click)=\"navigateToPlanSmart()\"\r\n            [title]=\"planSmartText\"\r\n            [customClass]=\"'Spa_Style_Paragraph no-underline ml-1'\"\r\n          ></vnext-link>\r\n        </div>\r\n        <div class=\"mt-3\" tabindex=\"0\" *ngIf=\"trainingMaterialsEnabled || lmsTrainingMaterialsEnabled\">\r\n          <vnext-link\r\n            (click)=\"navigateToTrainingMaterials()\"\r\n            [title]=\"trainingMaterialsText\"\r\n            [customClass]=\"'Spa_Style_Paragraph no-underline ml-1'\"\r\n          ></vnext-link>\r\n        </div>\r\n        <div class=\"mt-3\" tabindex=\"0\" *ngIf=\"accountOverviewEnabled\">\r\n          <vnext-link\r\n            (click)=\"loginFacade.viewLoggedInAgentDetails(pageTags.AGENT_ACCOUNT_OVERVIEW)\"\r\n            [title]=\"accountOverviewText\"\r\n            [customClass]=\"'Spa_Style_Paragraph no-underline ml-1'\"\r\n          ></vnext-link>\r\n        </div>\r\n      </ng-container>\r\n      <!-- end  agent links -->\r\n      <vnext-link (click)=\"logOut()\" [title]=\"logoutText\" [customClass]=\"'Spa_Style_Paragraph mt-3 ml-1 no-underline'\"> </vnext-link>\r\n    </div>\r\n  </ng-template>\r\n  <a\r\n    #logOutPopoverToggle\r\n    placement=\"bottom-right\"\r\n    [ngbPopover]=\"logOutWidget\"\r\n    [ngClass]=\"{ 'login-header': siteType === siteTypes.BROKER }\"\r\n    class=\"welcome-user-wrapper no-underline d-block can-click focus-text\"\r\n    [autoClose]=\"'outside'\"\r\n    #logOutPopover=\"ngbPopover\"\r\n    popoverClass=\"logout-popover\"\r\n    tabindex=\"0\"\r\n    (keyup.enter)=\"logOutPopover.toggle()\"\r\n    role=\"button\"\r\n    [attr.aria-expanded]=\"logOutPopover.isOpen()\"\r\n  >\r\n    <ng-container *ngIf=\"(primaryLoggedIn$ | async) && (userName$ | async)\">\r\n      <div class=\"d-flex justify-content-end align-items-center\">\r\n        <div class=\"pr-1 text-right no-translate-block\">\r\n          <div [ngClass]=\"siteType === siteTypes.CONSUMER ? 'Spa_Style_H3 pl-2' : 'Spa_Style_Paragraph Spa_Style_Smaller_Font'\">\r\n            {{ userName$ | async | shortName }}\r\n          </div>\r\n        </div>\r\n        <i class=\"fas fa-chevron-down ml-1 Spa_Style_Smaller_Font Spa_Style_Primary_Color\"></i>\r\n        <span class=\"sr-only\">Expand menu</span>\r\n      </div>\r\n    </ng-container>\r\n  </a>\r\n</ng-container>\r\n<ng-template #login>\r\n  <ng-template #loginWidget>\r\n    <div role=\"dialog\" [attr.aria-label]=\"loginTitle\">\r\n      <button\r\n        (click)=\"closeLoginPopover(loginPopover)\"\r\n        tabindex=\"0\"\r\n        role=\"button\"\r\n        class=\"popover-cancel login-popover-cancel action-button\"\r\n      >\r\n        <span class=\"sr-only\"> {{ closeText }}</span>\r\n        <i class=\"fas fa-times Spa_Style_Primary_Color\"></i>\r\n      </button>\r\n      <ng-container [ngSwitch]=\"visibleFormType\">\r\n        <ng-container *ngSwitchCase=\"LoginFormType.Default\">\r\n          <form disableKeyDownSubmit [formGroup]=\"loginForm\" (ngSubmit)=\"validateLogin()\">\r\n            <h2 class=\"Spa_Style_H2\">{{ loginTitle }}</h2>\r\n            <div class=\"error-color my-2\" *ngIf=\"showLoginError\" id=\"loginFormError\">\r\n              <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i> <span class=\"sr-only\">{{ errorKeywordText }}</span>\r\n              {{ loginErrorMessageText }}\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label class=\"Spa_Style_Label\" for=\"userName\">\r\n                <div [ngClass]=\"{ 'error-color': showLoginError }\"><span class=\"mr-1 input-error-asterisk\">*</span>{{ loginUserName }}</div>\r\n              </label>\r\n              <input\r\n                #userNameField\r\n                id=\"userName\"\r\n                type=\"text\"\r\n                formControlName=\"userName\"\r\n                class=\"form-control\"\r\n                autocomplete=\"off\"\r\n                aria-describedby=\"loginFormError\"\r\n                aria-required=\"true\"\r\n                [ngClass]=\"{ 'has-error': showLoginError }\"\r\n              />\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label class=\"Spa_Style_Label\" for=\"pwd\">\r\n                <div [ngClass]=\"{ 'error-color': showLoginError }\"><span class=\"mr-1 input-error-asterisk\">*</span>{{ loginPassword }}</div>\r\n              </label>\r\n              <input\r\n                #passwordField\r\n                id=\"pwd\"\r\n                type=\"password\"\r\n                formControlName=\"password\"\r\n                class=\"form-control\"\r\n                autocomplete=\"off\"\r\n                aria-describedby=\"loginFormError\"\r\n                aria-required=\"true\"\r\n                [ngClass]=\"{ 'has-error': showLoginError }\"\r\n              />\r\n            </div>\r\n            <button type=\"submit\" class=\"btn Spa_Style_PrimaryButton btn-block login-popover-container-button\">\r\n              {{ loginSubmit }}\r\n            </button>\r\n            <div class=\"d-flex justify-content-between links\">\r\n              <div *ngIf=\"forgotPasswordLinkEnabled\">\r\n                <vnext-link\r\n                  (click)=\"showForgotPassword()\"\r\n                  (keyup.enter)=\"showForgotPassword()\"\r\n                  [title]=\"forgotPasswordLinkText\"\r\n                  [role]=\"linkRoles.BUTTON\"\r\n                  [ariaLabel]=\"forgotPasswordLinkText\"\r\n                  [customClass]=\"'Spa_Style_Link login-popover-container-linktext'\"\r\n                ></vnext-link>\r\n              </div>\r\n              <div *ngIf=\"forgotPasswordLinkEnabled && forgotUsernameLinkEnabled\" class=\"pipe\">|</div>\r\n              <div *ngIf=\"forgotUsernameLinkEnabled\">\r\n                <vnext-link\r\n                  (click)=\"showForgotUsername()\"\r\n                  (keyup.enter)=\"showForgotUsername()\"\r\n                  [title]=\"forgotUsernameLinkText\"\r\n                  [role]=\"linkRoles.BUTTON\"\r\n                  [ariaLabel]=\"forgotUsernameLinkText\"\r\n                  [customClass]=\"'Spa_Style_Link login-popover-container-linktext'\"\r\n                ></vnext-link>\r\n              </div>\r\n            </div>\r\n\r\n            <div *ngIf=\"showCreateAccountSection !== false\" class=\"form-group create-account-container\">\r\n              <p class=\"Spa_Style_Paragraph\">{{ createAccountLabelText }}</p>\r\n              <button\r\n                type=\"button\"\r\n                class=\"btn Spa_Style_SecondaryButton btn-block login-popover-container-button\"\r\n                (click)=\"createAccount()\"\r\n              >\r\n                {{ createAccountButtonText }}\r\n              </button>\r\n            </div>\r\n          </form>\r\n        </ng-container>\r\n        <ng-container *ngSwitchCase=\"LoginFormType.CreateAccount\">\r\n          <vnext-create-account\r\n            [defaultFirstName]=\"createAccountFormData?.firstName\"\r\n            [defaultLastName]=\"createAccountFormData?.lastName\"\r\n            [defaultEmail]=\"createAccountFormData?.email\"\r\n          ></vnext-create-account>\r\n        </ng-container>\r\n        <ng-container *ngSwitchCase=\"LoginFormType.ForgotPassword\">\r\n          <vnext-consumer-forgot-password\r\n            [emailSentText]=\"emailSentText\"\r\n            [checkEmailText]=\"forgotPasswordCheckEmailText\"\r\n            [instructionsText]=\"forgotPasswordInstructionsText\"\r\n            [userNameRequiredError]=\"userNameRequiredError\"\r\n            [invalidUserNameError]=\"invalidUserNameError\"\r\n            [usernameLabel]=\"usernameLabel\"\r\n            [sendEmailText]=\"sendEmailText\"\r\n            [errorKeywordText]=\"errorKeywordText\"\r\n            [headerText]=\"forgotPasswordHeaderText\"\r\n            [emailFailedError]=\"emailFailedError\"\r\n          ></vnext-consumer-forgot-password>\r\n        </ng-container>\r\n        <ng-container *ngSwitchCase=\"LoginFormType.ForgotUsername\">\r\n          <vnext-consumer-forgot-username\r\n            [emailSentText]=\"emailSentText\"\r\n            [checkEmailText]=\"forgotUsernameCheckEmailText\"\r\n            [instructionsText]=\"forgotUsernameInstructionsText\"\r\n            [firstNameRequiredError]=\"firstNameRequiredError\"\r\n            [invalidUserEmailComboErrorText]=\"invalidUserEmailComboError\"\r\n            [emailRequiredError]=\"emailRequiredError\"\r\n            [emailLabel]=\"emailLabel\"\r\n            [firstNameLabel]=\"firstNameLabel\"\r\n            [sendEmailText]=\"sendEmailText\"\r\n            [errorKeywordText]=\"errorKeywordText\"\r\n            [emailFailedError]=\"emailFailedError\"\r\n            [headerText]=\"forgotUsernameHeaderText\"\r\n          ></vnext-consumer-forgot-username>\r\n        </ng-container>\r\n        <ng-container *ngIf=\"visibleFormType !== LoginFormType.Default\">\r\n          <div class=\"login-to-account-link\">\r\n            <vnext-inner-text-link\r\n              [outerText]=\"loginToAccountText\"\r\n              [innerText]=\"loginToAccountClickableText\"\r\n              (innerTextClicked)=\"revertToDefaultView()\"\r\n              [customClass]=\"'Spa_Style_Link login-popover-container-linktext'\"\r\n              [customTextClass]=\"'Spa_Style_Paragraph'\"\r\n              [role]=\"linkRoles.BUTTON\"\r\n              [ariaLabel]=\"loginToAccountText\"\r\n            ></vnext-inner-text-link>\r\n          </div>\r\n        </ng-container>\r\n      </ng-container></div\r\n  ></ng-template>\r\n  <ng-container *ngIf=\"externalLogin; else internalLogin\">\r\n    <a\r\n      placement=\"bottom-right\"\r\n      class=\"no-underline d-inline-block can-click focus-text\"\r\n      (click)=\"showExternalLoginPrompt()\"\r\n      tabindex=\"0\"\r\n      (keyup.enter)=\"showExternalLoginPrompt()\"\r\n      role=\"button\"\r\n    >\r\n      <div class=\"can-click\">\r\n        <span class=\"Spa_Style_H3 can-click d-none d-md-inline\">{{ loginHeader }}</span>\r\n        <span class=\"Spa_Style_Paragraph can-click d-inline d-md-none\">{{ loginHeader }}</span>\r\n        <i class=\"fas fa-chevron-down Spa_Style_Primary_Color Spa_Style_Smaller_Font ml-2\"></i>\r\n        <span class=\"sr-only\">Expand menu</span>\r\n      </div>\r\n    </a>\r\n  </ng-container>\r\n  <ng-template #internalLogin>\r\n    <a\r\n      #loginPopoverToggle\r\n      placement=\"bottom-right\"\r\n      [ngbPopover]=\"loginWidget\"\r\n      class=\"popover-toggle no-underline d-inline-block can-click focus-text\"\r\n      [autoClose]=\"false\"\r\n      #loginPopover=\"ngbPopover\"\r\n      popoverClass=\"login-popover\"\r\n      (click)=\"resetLogin()\"\r\n      tabindex=\"0\"\r\n      (keyup.enter)=\"loginPopover.toggle()\"\r\n      role=\"button\"\r\n      [attr.aria-expanded]=\"loginPopover.isOpen()\"\r\n    >\r\n      <div class=\"can-click\">\r\n        <span class=\"Spa_Style_H3 can-click d-none d-md-inline\">{{ loginHeader }}</span>\r\n        <span class=\"Spa_Style_Paragraph can-click d-inline d-md-none\">{{ loginHeader }}</span>\r\n        <i class=\"fas fa-chevron-down Spa_Style_Primary_Color Spa_Style_Smaller_Font ml-2\"></i>\r\n        <span class=\"sr-only\">Expand menu</span>\r\n      </div>\r\n    </a>\r\n  </ng-template>\r\n</ng-template>\r\n", styles: [".logout-popover-template{min-width:200px;position:relative;padding-right:15px}.welcome-user-wrapper{color:var(--static-Spa_Style_Primary);cursor:pointer;text-decoration:none}.welcome-user-wrapper:hover{text-decoration:none}.user-name{float:left;width:220px}.login-header{vertical-align:middle;display:table-cell;text-decoration:none}.popover-cancel{position:absolute;top:0;right:0;cursor:pointer;color:var(--Spa_Style_Primary);width:20px;height:20px;text-align:center}.login-popover-cancel{margin:.5rem}.links{margin:25px 0}@media (max-width: 767.98px){.login-popover.popover{margin-top:22px}.close-button{color:var(--static-Spa_Style_Gray4)}a:hover{text-decoration:none}.login-header{vertical-align:initial;min-width:73px}}@media (max-width: 479.98px){.logout-link{font-size:var(--Spa_Style_Small_Fonter)}}.create-account-container{border-top:1px solid var(--static-Spa_Style_Accent1);margin-top:15px;padding-top:15px}.create-account-container p{margin-bottom:5px}a.popover-toggle{vertical-align:bottom;text-decoration:none}a.login-header:hover,a.popover-toggle:hover{text-decoration:none}a.popover-toggle i.fas{vertical-align:middle}.fa-chevron-down{cursor:pointer}.login-to-account-link{width:100%;text-align:center}.logout-container{min-width:250px}.pipe{color:var(--static-Spa_Style_Accent1)}\n"] }]
    }], function () { return [{ type: LoginFacade }, { type: i1.LoginService }, { type: i1.SiteService }, { type: i1.DrugsService }, { type: AnalyticsService }, { type: i0.ElementRef }, { type: i1.NavigationService }, { type: CreateAccountContext }, { type: i0.ChangeDetectorRef }, { type: i1.AgentPermissionsService }, { type: i1.MemberSessionService }, { type: i1.ConfigResourceService }, { type: i1.NavigationUtilityService }, { type: i1.AgentService }, { type: i0.Injector }, { type: i1$1.NgbModal }]; }, { createAccountComponent: [{
            type: ViewChild,
            args: [CreateAccountComponent]
        }], loginPopover: [{
            type: ViewChild,
            args: ['loginPopover']
        }], logOutPopover: [{
            type: ViewChild,
            args: ['logOutPopover']
        }], userNameField: [{
            type: ViewChild,
            args: ['userNameField']
        }], passwordField: [{
            type: ViewChild,
            args: ['passwordField']
        }], loginPopoverToggle: [{
            type: ViewChild,
            args: ['loginPopoverToggle']
        }], logOutPopoverToggle: [{
            type: ViewChild,
            args: ['logOutPopoverToggle']
        }], loginPopoverRef: [{
            type: ViewChild,
            args: ['loginPopover', { read: ElementRef }]
        }], loginUserName: [{
            type: Input
        }], loginPassword: [{
            type: Input
        }], loginHeader: [{
            type: Input
        }], loginTitle: [{
            type: Input
        }], loginSubmit: [{
            type: Input
        }], loginErrorMessage: [{
            type: Input
        }], attemptsExceededErrorText: [{
            type: Input
        }], logoutText: [{
            type: Input
        }], showCreateAccountSection: [{
            type: Input
        }], createAccountLabelText: [{
            type: Input
        }], createAccountButtonText: [{
            type: Input
        }], siteType: [{
            type: Input
        }], loginToAccountText: [{
            type: Input
        }], loginToAccountClickableText: [{
            type: Input
        }], isRetentionEnabled: [{
            type: Input
        }], accountOverviewText: [{
            type: Input
        }], accountOverviewEnabled: [{
            type: Input
        }], trainingMaterialsText: [{
            type: Input
        }], trainingMaterialsEnabled: [{
            type: Input
        }], lmsTrainingMaterialsEnabled: [{
            type: Input
        }], consumerAccountSummaryText: [{
            type: Input
        }], consumerAccountOverviewEnabled: [{
            type: Input
        }], agentReportsHeaderText: [{
            type: Input
        }], enrollmentReportsEnabled: [{
            type: Input
        }], enrollmentReportsAdminOnlyEnabled: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], closeText: [{
            type: Input
        }], externalLogin: [{
            type: Input
        }], forgotPasswordLinkText: [{
            type: Input
        }], forgotPasswordLinkEnabled: [{
            type: Input
        }], emailSentText: [{
            type: Input
        }], forgotPasswordCheckEmailText: [{
            type: Input
        }], forgotPasswordInstructionsText: [{
            type: Input
        }], userNameRequiredError: [{
            type: Input
        }], invalidUserNameError: [{
            type: Input
        }], usernameLabel: [{
            type: Input
        }], sendEmailText: [{
            type: Input
        }], forgotPasswordHeaderText: [{
            type: Input
        }], emailFailedError: [{
            type: Input
        }], forgotUsernameLinkText: [{
            type: Input
        }], forgotUsernameLinkEnabled: [{
            type: Input
        }], emailLabel: [{
            type: Input
        }], firstNameLabel: [{
            type: Input
        }], invalidUserEmailComboError: [{
            type: Input
        }], firstNameRequiredError: [{
            type: Input
        }], emailRequiredError: [{
            type: Input
        }], forgotUsernameHeaderText: [{
            type: Input
        }], forgotUsernameInstructionsText: [{
            type: Input
        }], forgotUsernameCheckEmailText: [{
            type: Input
        }], isPlanSmartEnabled: [{
            type: Input
        }], planSmartText: [{
            type: Input
        }], includeSOA: [{
            type: Input
        }], Spa_EnrollmentConfirmation_EmailConfirmationModal_Cancel: [], Spa_EnrollmentConfirmation_EmailConfirmationModal_Continue: [], Spa_Agent_Modal_Contents_Message: [], Spa_Agent_EmailAddress_ModalTitle_Text: [], Spa_Agent_EmailAddress_InvalidText: [], onDocumentClick: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], onKeyUp: [{
            type: HostListener,
            args: ['document:keyup.escape', ['$event']]
        }], validateLogin: [], resetLogin: [], showExternalLoginPrompt: [], logOut: [], createAccount: [] }); })();

function LoginContainerComponent_vnext_login_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-login", 1);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loginUserName", ctx_r0.Spa_LoginWidget_Username_Text)("loginPassword", ctx_r0.Spa_LoginWidget_Password_Text)("loginErrorMessage", ctx_r0.Spa_Login_Error_Message)("attemptsExceededErrorText", ctx_r0.Spa_Login_ConsumerAttemptsExceeded_Text)("logoutText", ctx_r0.Spa_LoginWidget_Logout_Text)("loginHeader", ctx_r0.Spa_LoginWidget_Login_Header_Text)("loginTitle", ctx_r0.Spa_LoginWidget_Login_Title_Text)("loginSubmit", ctx_r0.Spa_LoginWidget_Login_Submit_Text)("showCreateAccountSection", ctx_r0.Spa_LoginWidget_Create_Account_Display)("createAccountLabelText", ctx_r0.Spa_LoginWidget_Create_Account_Label_Text)("createAccountButtonText", ctx_r0.Spa_LoginWidget_Create_Account_Button_Text)("siteType", ctx_r0.Spa_Site_SiteType)("loginToAccountText", ctx_r0.Spa_LoginWidget_LoginToAccount_Text)("loginToAccountClickableText", ctx_r0.Spa_LoginWidget_LoginToAccount_ClickableText)("isRetentionEnabled", i0.ɵɵpipeBind1(1, 52, ctx_r0.isRetentionView$))("accountOverviewText", ctx_r0.Spa_LoginWidget_AccountOverview_Text)("accountOverviewEnabled", ctx_r0.Spa_Site_Agent_AccountOverview_Enabled)("trainingMaterialsText", ctx_r0.Spa_Site_AgentTrainingMaterials_Text)("isPlanSmartEnabled", ctx_r0.Spa_Site_PlanSmart_Enabled)("planSmartText", ctx_r0.Spa_PlanSmart_Header_Text)("trainingMaterialsEnabled", ctx_r0.Spa_Site_AgentTrainingMaterials_Enabled)("lmsTrainingMaterialsEnabled", ctx_r0.Spa_Site_LMS_AgentTrainingMaterials_Enabled)("consumerAccountSummaryText", ctx_r0.Spa_Consumer_AccountOverview_Header_Text)("agentReportsHeaderText", ctx_r0.Spa_AgentReports_Header_Text)("consumerAccountOverviewEnabled", ctx_r0.Spa_Site_Consumer_AccountOverview_Enabled)("enrollmentReportsEnabled", ctx_r0.Spa_Site_AgentReports_Enabled)("enrollmentReportsAdminOnlyEnabled", ctx_r0.Spa_Site_AgentReports_AdminOnly_Enabled)("errorKeywordText", ctx_r0.Spa_Site_ErrorKeyword_Text)("closeText", ctx_r0.Spa_Site_Close)("externalLogin", ctx_r0.Spa_Site_CustomerMemberPortalIntegration_Enabled)("emailSentText", ctx_r0.Spa_Login_ForgotPasswordEmailSent_Text)("forgotPasswordCheckEmailText", ctx_r0.Spa_Login_ForgotPasswordCheckEmail_Text)("forgotPasswordInstructionsText", ctx_r0.Spa_Login_ForgotPasswordInstructions_Text)("userNameRequiredError", ctx_r0.Spa_Login_ForgotPasswordUserNameRequired_Error)("invalidUserNameError", ctx_r0.Spa_Login_ForgotPasswordInvalidUserName_Error)("usernameLabel", ctx_r0.Spa_Profile_Username_Label)("sendEmailText", ctx_r0.Spa_Login_ForgotPasswordSendEmail_Text)("forgotPasswordHeaderText", ctx_r0.Spa_Login_ForgotPasswordHeader_Text)("emailFailedError", ctx_r0.Spa_Login_ForgotPasswordEmailFailed_Error)("forgotPasswordLinkText", ctx_r0.Spa_Login_ForgotPasswordLink_Text)("forgotPasswordLinkEnabled", ctx_r0.Spa_Login_ForgotPasswordLink_Enabled)("forgotUsernameLinkText", ctx_r0.Spa_Login_ForgotUsernameLink_Text)("forgotUsernameLinkEnabled", ctx_r0.Spa_Login_ForgotUsernameLink_Enabled)("emailLabel", ctx_r0.Spa_Login_EmailLabel_Text)("firstNameLabel", ctx_r0.Spa_Login_FirstNameLabel_Text)("invalidUserEmailComboError", ctx_r0.Spa_Login_InvalidUserEmailCombination_Error)("firstNameRequiredError", ctx_r0.Spa_Login_FirstNameRequired_Error)("emailRequiredError", ctx_r0.Spa_Login_EmailRequired_Error)("forgotUsernameHeaderText", ctx_r0.Spa_Login_ForgotUsernameHeader_Text)("forgotUsernameInstructionsText", ctx_r0.Spa_Login_ForgotUsernameInstructions_Text)("forgotUsernameCheckEmailText", ctx_r0.Spa_Login_ForgotUsernameCheckEmail_Text)("includeSOA", ctx_r0.Spa_Site_SOA_Enabled && ctx_r0.Spa_Consumer_AccountOverview_DisplayCallToAction_Enabled);
} }
class LoginContainerComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, siteService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.siteService = siteService;
        this.Spa_LoginWidget_Username_Text = 'Email or username';
        this.Spa_LoginWidget_Password_Text = 'Password';
        this.Spa_LoginWidget_Login_Header_Text = 'Login';
        this.Spa_LoginWidget_Login_Title_Text = 'Login';
        this.Spa_LoginWidget_Login_Submit_Text = 'Login';
        this.Spa_Login_Error_Message = 'Please provide valid login credentials.';
        this.Spa_Login_ConsumerAttemptsExceeded_Text = 'The maximum number of log in attempts have been exceeded. Try again later.';
        this.Spa_LoginWidget_Logout_Text = 'Logout';
        this.Spa_LoginWidget_Create_Account_Display = true;
        this.Spa_LoginWidget_Create_Account_Label_Text = 'No account? Create your own in a matter of minutes';
        this.Spa_LoginWidget_Create_Account_Button_Text = 'Create account';
        this.Spa_Site_SiteType = SiteType.CONSUMER;
        this.Spa_LoginWidget_LoginToAccount_Text = 'Or login to your account';
        this.Spa_LoginWidget_LoginToAccount_ClickableText = 'login';
        this.Spa_LoginWidget_AccountOverview_Text = 'Account overview';
        this.Spa_Site_Agent_AccountOverview_Enabled = true;
        this.Spa_Site_AgentTrainingMaterials_Text = 'Agent training materials';
        this.Spa_Site_AgentTrainingMaterials_Enabled = false;
        this.Spa_Site_ErrorKeyword_Text = 'Error:';
        this.Spa_Site_Close = 'Close';
        this.Spa_Site_Consumer_AccountOverview_Enabled = false;
        this.Spa_Site_AgentReports_Enabled = false;
        this.Spa_Site_AgentReports_AdminOnly_Enabled = false;
        this.Spa_Consumer_AccountOverview_Header_Text = 'Account Summary';
        this.Spa_Site_CustomerMemberPortalIntegration_Enabled = false;
        this.Spa_Login_ForgotPasswordEmailSent_Text = 'An email has been sent.';
        this.Spa_Login_ForgotPasswordCheckEmail_Text = 'Check your email to reset your password. If you do not receive an email, try again.';
        this.Spa_Login_ForgotPasswordInstructions_Text = 'Enter your username or email and then check your email to continue.';
        this.Spa_Login_ForgotPasswordUserNameRequired_Error = 'Username is required';
        this.Spa_Login_ForgotPasswordInvalidUserName_Error = 'The username is not associated with an account. Please create an account.';
        this.Spa_Profile_Username_Label = 'Username';
        this.Spa_Login_ForgotPasswordSendEmail_Text = 'Send email';
        this.Spa_Login_ForgotPasswordHeader_Text = 'Forgot Password';
        this.Spa_Login_ForgotPasswordEmailFailed_Error = 'Email not sent. Try again later.';
        this.Spa_Login_ForgotPasswordLink_Enabled = true;
        this.Spa_Login_ForgotPasswordLink_Text = 'Forgot password?';
        this.Spa_AgentReports_Header_Text = 'Reports';
        this.Spa_Login_ForgotUsernameLink_Enabled = true;
        this.Spa_Login_ForgotUsernameLink_Text = 'Forgot username?';
        this.Spa_Login_EmailLabel_Text = 'Email';
        this.Spa_Login_FirstNameLabel_Text = 'First name';
        this.Spa_Login_InvalidUserEmailCombination_Error = 'This name and email is not associated with an account. Please create an account.';
        this.Spa_Login_FirstNameRequired_Error = 'Please enter first name';
        this.Spa_Login_EmailRequired_Error = 'Please provide a valid email address';
        this.Spa_Login_ForgotUsernameHeader_Text = 'Forgot username';
        this.Spa_Login_ForgotUsernameInstructions_Text = 'fEnter your first name and email address and then check your email to continue.';
        this.Spa_Login_ForgotUsernameCheckEmail_Text = 'Check your email for your username. If you do not receive an email, try again.';
        this.Spa_Site_PlanSmart_Enabled = true;
        this.Spa_PlanSmart_Header_Text = 'Plan Smart';
        this.Spa_Site_LMS_AgentTrainingMaterials_Enabled = false;
        this.Spa_Site_SOA_Enabled = true;
        this.Spa_Consumer_AccountOverview_DisplayCallToAction_Enabled = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.isRetentionView$ = this.siteService.isRetentionView$();
    }
}
LoginContainerComponent.ɵfac = function LoginContainerComponent_Factory(t) { return new (t || LoginContainerComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.SiteService)); };
LoginContainerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LoginContainerComponent, selectors: [["vnext-login-container"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["aria-live", "polite", "aria-relevant", "text", 3, "loginUserName", "loginPassword", "loginErrorMessage", "attemptsExceededErrorText", "logoutText", "loginHeader", "loginTitle", "loginSubmit", "showCreateAccountSection", "createAccountLabelText", "createAccountButtonText", "siteType", "loginToAccountText", "loginToAccountClickableText", "isRetentionEnabled", "accountOverviewText", "accountOverviewEnabled", "trainingMaterialsText", "isPlanSmartEnabled", "planSmartText", "trainingMaterialsEnabled", "lmsTrainingMaterialsEnabled", "consumerAccountSummaryText", "agentReportsHeaderText", "consumerAccountOverviewEnabled", "enrollmentReportsEnabled", "enrollmentReportsAdminOnlyEnabled", "errorKeywordText", "closeText", "externalLogin", "emailSentText", "forgotPasswordCheckEmailText", "forgotPasswordInstructionsText", "userNameRequiredError", "invalidUserNameError", "usernameLabel", "sendEmailText", "forgotPasswordHeaderText", "emailFailedError", "forgotPasswordLinkText", "forgotPasswordLinkEnabled", "forgotUsernameLinkText", "forgotUsernameLinkEnabled", "emailLabel", "firstNameLabel", "invalidUserEmailComboError", "firstNameRequiredError", "emailRequiredError", "forgotUsernameHeaderText", "forgotUsernameInstructionsText", "forgotUsernameCheckEmailText", "includeSOA", 4, "liveEditProp"], ["aria-live", "polite", "aria-relevant", "text", 3, "loginUserName", "loginPassword", "loginErrorMessage", "attemptsExceededErrorText", "logoutText", "loginHeader", "loginTitle", "loginSubmit", "showCreateAccountSection", "createAccountLabelText", "createAccountButtonText", "siteType", "loginToAccountText", "loginToAccountClickableText", "isRetentionEnabled", "accountOverviewText", "accountOverviewEnabled", "trainingMaterialsText", "isPlanSmartEnabled", "planSmartText", "trainingMaterialsEnabled", "lmsTrainingMaterialsEnabled", "consumerAccountSummaryText", "agentReportsHeaderText", "consumerAccountOverviewEnabled", "enrollmentReportsEnabled", "enrollmentReportsAdminOnlyEnabled", "errorKeywordText", "closeText", "externalLogin", "emailSentText", "forgotPasswordCheckEmailText", "forgotPasswordInstructionsText", "userNameRequiredError", "invalidUserNameError", "usernameLabel", "sendEmailText", "forgotPasswordHeaderText", "emailFailedError", "forgotPasswordLinkText", "forgotPasswordLinkEnabled", "forgotUsernameLinkText", "forgotUsernameLinkEnabled", "emailLabel", "firstNameLabel", "invalidUserEmailComboError", "firstNameRequiredError", "emailRequiredError", "forgotUsernameHeaderText", "forgotUsernameInstructionsText", "forgotUsernameCheckEmailText", "includeSOA"]], template: function LoginContainerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LoginContainerComponent_vnext_login_0_Template, 2, 54, "vnext-login", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("liveEditProp", "Spa_LoginWidget_AccountOverview_Text");
    } }, dependencies: [LiveEditPropDirective, LoginComponent, i1$2.AsyncPipe], encapsulation: 2, changeDetection: 0 });
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_LoginWidget_Username_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_LoginWidget_Password_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_LoginWidget_Login_Header_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_LoginWidget_Login_Title_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_LoginWidget_Login_Submit_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_Error_Message", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_ConsumerAttemptsExceeded_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_LoginWidget_Logout_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_LoginWidget_Create_Account_Display", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_LoginWidget_Create_Account_Label_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_LoginWidget_Create_Account_Button_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Site_SiteType", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_LoginWidget_LoginToAccount_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_LoginWidget_LoginToAccount_ClickableText", void 0);
__decorate([
    PlatformProp('live-edit')
], LoginContainerComponent.prototype, "Spa_LoginWidget_AccountOverview_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Site_Agent_AccountOverview_Enabled", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Site_AgentTrainingMaterials_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Site_AgentTrainingMaterials_Enabled", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Site_ErrorKeyword_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Site_Close", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Site_Consumer_AccountOverview_Enabled", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Site_AgentReports_Enabled", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Site_AgentReports_AdminOnly_Enabled", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Consumer_AccountOverview_Header_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Site_CustomerMemberPortalIntegration_Enabled", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_ForgotPasswordEmailSent_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_ForgotPasswordCheckEmail_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_ForgotPasswordInstructions_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_ForgotPasswordUserNameRequired_Error", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_ForgotPasswordInvalidUserName_Error", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Profile_Username_Label", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_ForgotPasswordSendEmail_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_ForgotPasswordHeader_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_ForgotPasswordEmailFailed_Error", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_ForgotPasswordLink_Enabled", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_ForgotPasswordLink_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_AgentReports_Header_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_ForgotUsernameLink_Enabled", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_ForgotUsernameLink_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_EmailLabel_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_FirstNameLabel_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_InvalidUserEmailCombination_Error", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_FirstNameRequired_Error", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_EmailRequired_Error", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_ForgotUsernameHeader_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_ForgotUsernameInstructions_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Login_ForgotUsernameCheckEmail_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Site_PlanSmart_Enabled", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_PlanSmart_Header_Text", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Site_LMS_AgentTrainingMaterials_Enabled", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Site_SOA_Enabled", void 0);
__decorate([
    GlobalResource()
], LoginContainerComponent.prototype, "Spa_Consumer_AccountOverview_DisplayCallToAction_Enabled", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginContainerComponent, [{
        type: Component,
        args: [{ selector: 'vnext-login-container', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-login\r\n  *liveEditProp=\"'Spa_LoginWidget_AccountOverview_Text'\"\r\n  aria-live=\"polite\"\r\n  aria-relevant=\"text\"\r\n  [loginUserName]=\"Spa_LoginWidget_Username_Text\"\r\n  [loginPassword]=\"Spa_LoginWidget_Password_Text\"\r\n  [loginErrorMessage]=\"Spa_Login_Error_Message\"\r\n  [attemptsExceededErrorText]=\"Spa_Login_ConsumerAttemptsExceeded_Text\"\r\n  [logoutText]=\"Spa_LoginWidget_Logout_Text\"\r\n  [loginHeader]=\"Spa_LoginWidget_Login_Header_Text\"\r\n  [loginTitle]=\"Spa_LoginWidget_Login_Title_Text\"\r\n  [loginSubmit]=\"Spa_LoginWidget_Login_Submit_Text\"\r\n  [showCreateAccountSection]=\"Spa_LoginWidget_Create_Account_Display\"\r\n  [createAccountLabelText]=\"Spa_LoginWidget_Create_Account_Label_Text\"\r\n  [createAccountButtonText]=\"Spa_LoginWidget_Create_Account_Button_Text\"\r\n  [siteType]=\"Spa_Site_SiteType\"\r\n  [loginToAccountText]=\"Spa_LoginWidget_LoginToAccount_Text\"\r\n  [loginToAccountClickableText]=\"Spa_LoginWidget_LoginToAccount_ClickableText\"\r\n  [isRetentionEnabled]=\"isRetentionView$ | async\"\r\n  [accountOverviewText]=\"Spa_LoginWidget_AccountOverview_Text\"\r\n  [accountOverviewEnabled]=\"Spa_Site_Agent_AccountOverview_Enabled\"\r\n  [trainingMaterialsText]=\"Spa_Site_AgentTrainingMaterials_Text\"\r\n  [isPlanSmartEnabled]=\"Spa_Site_PlanSmart_Enabled\"\r\n  [planSmartText]=\"Spa_PlanSmart_Header_Text\"\r\n  [trainingMaterialsEnabled]=\"Spa_Site_AgentTrainingMaterials_Enabled\"\r\n  [lmsTrainingMaterialsEnabled]=\"Spa_Site_LMS_AgentTrainingMaterials_Enabled\"\r\n  [consumerAccountSummaryText]=\"Spa_Consumer_AccountOverview_Header_Text\"\r\n  [agentReportsHeaderText]=\"Spa_AgentReports_Header_Text\"\r\n  [consumerAccountOverviewEnabled]=\"Spa_Site_Consumer_AccountOverview_Enabled\"\r\n  [enrollmentReportsEnabled]=\"Spa_Site_AgentReports_Enabled\"\r\n  [enrollmentReportsAdminOnlyEnabled]=\"Spa_Site_AgentReports_AdminOnly_Enabled\"\r\n  [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n  [closeText]=\"Spa_Site_Close\"\r\n  [externalLogin]=\"Spa_Site_CustomerMemberPortalIntegration_Enabled\"\r\n  [emailSentText]=\"Spa_Login_ForgotPasswordEmailSent_Text\"\r\n  [forgotPasswordCheckEmailText]=\"Spa_Login_ForgotPasswordCheckEmail_Text\"\r\n  [forgotPasswordInstructionsText]=\"Spa_Login_ForgotPasswordInstructions_Text\"\r\n  [userNameRequiredError]=\"Spa_Login_ForgotPasswordUserNameRequired_Error\"\r\n  [invalidUserNameError]=\"Spa_Login_ForgotPasswordInvalidUserName_Error\"\r\n  [usernameLabel]=\"Spa_Profile_Username_Label\"\r\n  [sendEmailText]=\"Spa_Login_ForgotPasswordSendEmail_Text\"\r\n  [forgotPasswordHeaderText]=\"Spa_Login_ForgotPasswordHeader_Text\"\r\n  [emailFailedError]=\"Spa_Login_ForgotPasswordEmailFailed_Error\"\r\n  [forgotPasswordLinkText]=\"Spa_Login_ForgotPasswordLink_Text\"\r\n  [forgotPasswordLinkEnabled]=\"Spa_Login_ForgotPasswordLink_Enabled\"\r\n  [forgotUsernameLinkText]=\"Spa_Login_ForgotUsernameLink_Text\"\r\n  [forgotUsernameLinkEnabled]=\"Spa_Login_ForgotUsernameLink_Enabled\"\r\n  [emailLabel]=\"Spa_Login_EmailLabel_Text\"\r\n  [firstNameLabel]=\"Spa_Login_FirstNameLabel_Text\"\r\n  [invalidUserEmailComboError]=\"Spa_Login_InvalidUserEmailCombination_Error\"\r\n  [firstNameRequiredError]=\"Spa_Login_FirstNameRequired_Error\"\r\n  [emailRequiredError]=\"Spa_Login_EmailRequired_Error\"\r\n  [forgotUsernameHeaderText]=\"Spa_Login_ForgotUsernameHeader_Text\"\r\n  [forgotUsernameInstructionsText]=\"Spa_Login_ForgotUsernameInstructions_Text\"\r\n  [forgotUsernameCheckEmailText]=\"Spa_Login_ForgotUsernameCheckEmail_Text\"\r\n  [includeSOA]=\"Spa_Site_SOA_Enabled && Spa_Consumer_AccountOverview_DisplayCallToAction_Enabled\"\r\n>\r\n</vnext-login>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.SiteService }]; }, { Spa_LoginWidget_Username_Text: [], Spa_LoginWidget_Password_Text: [], Spa_LoginWidget_Login_Header_Text: [], Spa_LoginWidget_Login_Title_Text: [], Spa_LoginWidget_Login_Submit_Text: [], Spa_Login_Error_Message: [], Spa_Login_ConsumerAttemptsExceeded_Text: [], Spa_LoginWidget_Logout_Text: [], Spa_LoginWidget_Create_Account_Display: [], Spa_LoginWidget_Create_Account_Label_Text: [], Spa_LoginWidget_Create_Account_Button_Text: [], Spa_Site_SiteType: [], Spa_LoginWidget_LoginToAccount_Text: [], Spa_LoginWidget_LoginToAccount_ClickableText: [], Spa_LoginWidget_AccountOverview_Text: [], Spa_Site_Agent_AccountOverview_Enabled: [], Spa_Site_AgentTrainingMaterials_Text: [], Spa_Site_AgentTrainingMaterials_Enabled: [], Spa_Site_ErrorKeyword_Text: [], Spa_Site_Close: [], Spa_Site_Consumer_AccountOverview_Enabled: [], Spa_Site_AgentReports_Enabled: [], Spa_Site_AgentReports_AdminOnly_Enabled: [], Spa_Consumer_AccountOverview_Header_Text: [], Spa_Site_CustomerMemberPortalIntegration_Enabled: [], Spa_Login_ForgotPasswordEmailSent_Text: [], Spa_Login_ForgotPasswordCheckEmail_Text: [], Spa_Login_ForgotPasswordInstructions_Text: [], Spa_Login_ForgotPasswordUserNameRequired_Error: [], Spa_Login_ForgotPasswordInvalidUserName_Error: [], Spa_Profile_Username_Label: [], Spa_Login_ForgotPasswordSendEmail_Text: [], Spa_Login_ForgotPasswordHeader_Text: [], Spa_Login_ForgotPasswordEmailFailed_Error: [], Spa_Login_ForgotPasswordLink_Enabled: [], Spa_Login_ForgotPasswordLink_Text: [], Spa_AgentReports_Header_Text: [], Spa_Login_ForgotUsernameLink_Enabled: [], Spa_Login_ForgotUsernameLink_Text: [], Spa_Login_EmailLabel_Text: [], Spa_Login_FirstNameLabel_Text: [], Spa_Login_InvalidUserEmailCombination_Error: [], Spa_Login_FirstNameRequired_Error: [], Spa_Login_EmailRequired_Error: [], Spa_Login_ForgotUsernameHeader_Text: [], Spa_Login_ForgotUsernameInstructions_Text: [], Spa_Login_ForgotUsernameCheckEmail_Text: [], Spa_Site_PlanSmart_Enabled: [], Spa_PlanSmart_Header_Text: [], Spa_Site_LMS_AgentTrainingMaterials_Enabled: [], Spa_Site_SOA_Enabled: [], Spa_Consumer_AccountOverview_DisplayCallToAction_Enabled: [] }); })();

class ShoppingCartIconFacade {
    constructor(navigationUtilityService, configResourceService, store) {
        this.navigationUtilityService = navigationUtilityService;
        this.configResourceService = configResourceService;
        this.store = store;
    }
    getRoute() {
        // TODO set defaults in a central location
        const environment = EnvironmentService.getEnvironment();
        if (!environment.liveedit) {
            let shoppingCartEnabled = this.configResourceService.getProcessedResourceValue('Spa_ShoppingCart_Enabled');
            if (shoppingCartEnabled === null || shoppingCartEnabled === undefined) {
                shoppingCartEnabled = true;
            }
            const tag = shoppingCartEnabled ? PageTags.SHOPPING_CART : PageTags.ENROLLMENT;
            return `/${this.navigationUtilityService.constructHref(tag)}`;
        }
    }
    getMemberEnrollments$() {
        return this.store.select(MemberState.memberEnrollments);
    }
}
ShoppingCartIconFacade.ɵfac = function ShoppingCartIconFacade_Factory(t) { return new (t || ShoppingCartIconFacade)(i0.ɵɵinject(i1.NavigationUtilityService), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i2.Store)); };
ShoppingCartIconFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ShoppingCartIconFacade, factory: ShoppingCartIconFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShoppingCartIconFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.NavigationUtilityService }, { type: i1.ConfigResourceService }, { type: i2.Store }]; }, null); })();

function ShoppingCartIconComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const numberOfSelectedPlans_r1 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(numberOfSelectedPlans_r1);
} }
const _c0$37 = function (a0) { return { "cart-icon-hover": a0 }; };
class ShoppingCartIconComponent {
    constructor(cdr, shoppingCartIconFacade, memberSessionService, navigationUtilityService, shoppingCartService, planFacade) {
        this.cdr = cdr;
        this.shoppingCartIconFacade = shoppingCartIconFacade;
        this.memberSessionService = memberSessionService;
        this.navigationUtilityService = navigationUtilityService;
        this.shoppingCartService = shoppingCartService;
        this.planFacade = planFacade;
        this.hover = false;
    }
    get route() {
        return this.shoppingCartIconFacade.getRoute();
    }
    ngOnInit() {
        // TODO: may want to explore the viability of tracking enrolledPlans in store rather than calculating this
        this.numberOfSelectedPlans$ = combineLatest(this.shoppingCartService.getSelectedPlans$().pipe(map(selectedPlans => selectedPlans?.filter(selectedPlan => this.planFacade.isAddToCartAvailableForPlan(selectedPlan))), map(visiblePlans => (visiblePlans ? visiblePlans?.map(visiblePlan => (visiblePlan ? visiblePlan.id : null)) : []))), this.shoppingCartIconFacade.getMemberEnrollments$()).pipe(map(([selectedPlanIds, memberEnrollments]) => {
            const page = this.getCurrentPage();
            if (memberEnrollments && page && page.tags.includes(PageTags.ENROLLMENT_CONFIRMATION)) {
                const completedCurrentEnrollment = memberEnrollments.filter(enrollment => enrollment &&
                    enrollment.planID &&
                    enrollment.isActive &&
                    enrollment.completedWhen &&
                    enrollment.confirmationNumber &&
                    selectedPlanIds.indexOf(enrollment.planID) !== -1);
                if (completedCurrentEnrollment.length) {
                    return selectedPlanIds.length - 1;
                }
            }
            return selectedPlanIds.length;
        }));
    }
    clearMemberSession() {
        const page = this.getCurrentPage();
        if (page && page.tags.includes(PageTags.ENROLLMENT_CONFIRMATION)) {
            this.memberSessionService.memberLogout();
        }
    }
    getCurrentPage() {
        return this.navigationUtilityService.getCurrentPage();
    }
}
ShoppingCartIconComponent.ɵfac = function ShoppingCartIconComponent_Factory(t) { return new (t || ShoppingCartIconComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ShoppingCartIconFacade), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(i1.ShoppingCartService), i0.ɵɵdirectiveInject(PlanFacade)); };
ShoppingCartIconComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ShoppingCartIconComponent, selectors: [["vnext-shopping-cart-icon"]], inputs: { label: "label" }, decls: 7, vars: 8, consts: [[1, "shopping-cart-container", "align-items-baseline", "focus-text", 3, "routerLink", "mouseover", "mouseleave", "click"], ["aria-hidden", "true", 1, "fas", "fa-shopping-cart", "cart-icon", 3, "ngClass"], ["class", "badge Spa_Style_PrimaryButton", 4, "ngIf"], [1, "Spa_Style_H3", "mt-1"], [1, "badge", "Spa_Style_PrimaryButton"]], template: function ShoppingCartIconComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "a", 0);
        i0.ɵɵlistener("mouseover", function ShoppingCartIconComponent_Template_a_mouseover_0_listener() { return ctx.hover = true; })("mouseleave", function ShoppingCartIconComponent_Template_a_mouseleave_0_listener() { return ctx.hover = false; })("click", function ShoppingCartIconComponent_Template_a_click_0_listener() { return ctx.clearMemberSession(); });
        i0.ɵɵelementStart(1, "div");
        i0.ɵɵelement(2, "i", 1);
        i0.ɵɵtemplate(3, ShoppingCartIconComponent_span_3_Template, 2, 1, "span", 2);
        i0.ɵɵpipe(4, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "span", 3);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("routerLink", ctx.route);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$37, ctx.hover));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 4, ctx.numberOfSelectedPlans$));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.label);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i2$1.RouterLink, IconAriaAttributesDirective, i1$2.AsyncPipe], styles: [".shopping-cart-container[_ngcontent-%COMP%]{justify-content:flex-start;padding:10px 0 10px 10px;display:flex}a[_ngcontent-%COMP%], a[_ngcontent-%COMP%]:hover{text-decoration:none}.cart-icon[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent1)}.cart-icon-hover[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Gray4)}.shopping-cart-container[_ngcontent-%COMP%] > [_ngcontent-%COMP%]:first-child{margin-right:5px}.badge[_ngcontent-%COMP%]{position:relative;bottom:10px;right:5px;width:14px;height:14px;border-radius:50%;padding:0;font-family:montserrat_bold;font-size:14px}@media (min-width: 768px){.shopping-cart-container[_ngcontent-%COMP%]{display:flex;justify-content:center;cursor:pointer;padding:4px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShoppingCartIconComponent, [{
        type: Component,
        args: [{ selector: 'vnext-shopping-cart-icon', changeDetection: ChangeDetectionStrategy.OnPush, template: "<a\r\n  class=\"shopping-cart-container align-items-baseline focus-text\"\r\n  [routerLink]=\"route\"\r\n  (mouseover)=\"hover = true\"\r\n  (mouseleave)=\"hover = false\"\r\n  (click)=\"clearMemberSession()\"\r\n>\r\n  <div>\r\n    <i class=\"fas fa-shopping-cart cart-icon\" [ngClass]=\"{ 'cart-icon-hover': hover }\" aria-hidden=\"true\"></i>\r\n    <span class=\"badge Spa_Style_PrimaryButton\" *ngIf=\"numberOfSelectedPlans$ | async as numberOfSelectedPlans\">{{\r\n      numberOfSelectedPlans\r\n    }}</span>\r\n  </div>\r\n  <span class=\"Spa_Style_H3 mt-1\">{{ label }}</span>\r\n</a>\r\n", styles: [".shopping-cart-container{justify-content:flex-start;padding:10px 0 10px 10px;display:flex}a,a:hover{text-decoration:none}.cart-icon{color:var(--static-Spa_Style_Accent1)}.cart-icon-hover{color:var(--static-Spa_Style_Gray4)}.shopping-cart-container>:first-child{margin-right:5px}.badge{position:relative;bottom:10px;right:5px;width:14px;height:14px;border-radius:50%;padding:0;font-family:montserrat_bold;font-size:14px}@media (min-width: 768px){.shopping-cart-container{display:flex;justify-content:center;cursor:pointer;padding:4px}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: ShoppingCartIconFacade }, { type: i1.MemberSessionService }, { type: i1.NavigationUtilityService }, { type: i1.ShoppingCartService }, { type: PlanFacade }]; }, { label: [{
            type: Input
        }] }); })();

var IconClassNames;
(function (IconClassNames) {
    IconClassNames["SEARCH_ICON"] = "fas fa-search";
    IconClassNames["PLUS_ICON"] = "fas fa-plus-square";
    IconClassNames["PLANS_ICON"] = "fas fa-layer-group";
    IconClassNames["DASHBOARD_ICON"] = "fas fa-tachometer-alt";
})(IconClassNames || (IconClassNames = {}));
var AdminRoleType;
(function (AdminRoleType) {
    AdminRoleType["Enroller_Admin"] = "Enroller_Admin";
    AdminRoleType["Quoter_Admin"] = "Quoter_Admin";
})(AdminRoleType || (AdminRoleType = {}));

const _c0$36 = ["profilePopover"];
const _c1$1D = ["profilePopoverToggle"];
function PopoverComponent_i_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 14);
} }
const _c2$10 = function (a0) { return { "mt-3": a0 }; };
function PopoverComponent_ng_template_10_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵlistener("click", function PopoverComponent_ng_template_10_div_7_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); const _r1 = i0.ɵɵreference(3); return i0.ɵɵresetView(ctx_r10.closePopover(_r1)); })("keyup.enter", function PopoverComponent_ng_template_10_div_7_Template_div_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(2); const _r1 = i0.ɵɵreference(3); return i0.ɵɵresetView(ctx_r12.closePopover(_r1)); });
    i0.ɵɵelementStart(1, "vnext-link", 20);
    i0.ɵɵlistener("click", function PopoverComponent_ng_template_10_div_7_Template_vnext_link_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r11); const link_r8 = restoredCtx.$implicit; const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.onPopoverClickEvent(link_r8.tag)); })("keyup.Enter", function PopoverComponent_ng_template_10_div_7_Template_vnext_link_keyup_Enter_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r11); const link_r8 = restoredCtx.$implicit; const ctx_r14 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r14.onPopoverClickEvent(link_r8.tag)); });
    i0.ɵɵelementStart(2, "div", 21)(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const link_r8 = ctx.$implicit;
    const isFirst_r9 = ctx.first;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c2$10, !isFirst_r9));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("noUnderlineOnHover", true)("makeInlineBlock", true);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(link_r8.title);
} }
function PopoverComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 15)(2, "div")(3, "span", 16);
    i0.ɵɵlistener("click", function PopoverComponent_ng_template_10_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); const _r1 = i0.ɵɵreference(3); return i0.ɵɵresetView(ctx_r15.closePopover(_r1)); })("keyup.enter", function PopoverComponent_ng_template_10_Template_span_keyup_enter_3_listener() { i0.ɵɵrestoreView(_r16); const ctx_r17 = i0.ɵɵnextContext(); const _r1 = i0.ɵɵreference(3); return i0.ɵɵresetView(ctx_r17.closePopover(_r1)); });
    i0.ɵɵelementStart(4, "span", 6);
    i0.ɵɵtext(5, "Close");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "i", 17);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, PopoverComponent_ng_template_10_div_7_Template, 5, 6, "div", 18);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngForOf", ctx_r4.dropdownLinks);
} }
function PopoverComponent_i_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 22);
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r5.isCollapsed ? "fas fa-chevron-down" : "fas fa-chevron-up");
} }
function PopoverComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23)(1, "vnext-link", 24);
    i0.ɵɵlistener("click", function PopoverComponent_div_22_Template_vnext_link_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r20); const link_r18 = restoredCtx.$implicit; const ctx_r19 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r19.onPopoverClickEvent(link_r18.tag)); })("keyup.Enter", function PopoverComponent_div_22_Template_vnext_link_keyup_Enter_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r20); const link_r18 = restoredCtx.$implicit; const ctx_r21 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r21.onPopoverClickEvent(link_r18.tag)); });
    i0.ɵɵelementStart(2, "div", 21)(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const link_r18 = ctx.$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(link_r18.title);
} }
class PopoverComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.popoverClickEvent = new EventEmitter();
        this.isCollapsed = true;
        this.subscriptions = [];
    }
    ngAfterViewInit() {
        const profilePopoverHidden$ = this.profilePopover?.hidden;
        if (profilePopoverHidden$) {
            this.subscriptions.push(profilePopoverHidden$.subscribe({
                next: () => {
                    this.profilePopoverToggle?.nativeElement?.focus();
                    this.cdr.markForCheck();
                }
            }));
        }
    }
    ngAfterViewChecked() {
        const profilePopoverShown$ = this.profilePopover?.shown;
        if (profilePopoverShown$) {
            const profilePopoverCancelButtonElement = document.querySelector('.profile-popover-cancel');
            this.subscriptions.push(profilePopoverShown$.subscribe({
                next: () => {
                    if (profilePopoverCancelButtonElement) {
                        profilePopoverCancelButtonElement.focus();
                    }
                    this.cdr.markForCheck();
                }
            }));
        }
    }
    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
    navigateOrTogglePopover(popover) {
        if (this.dropdownLinks.length === 1) {
            const tag = this.dropdownLinks[0].tag;
            this.onPopoverClickEvent(tag);
        }
        else {
            if (popover) {
                popover.toggle();
            }
            else {
                this.isCollapsed = !this.isCollapsed;
            }
        }
    }
    onPopoverClickEvent(pageTag) {
        this.popoverClickEvent.emit(pageTag);
    }
    closePopover(popover) {
        if (popover.isOpen()) {
            popover.close();
        }
    }
}
PopoverComponent.ɵfac = function PopoverComponent_Factory(t) { return new (t || PopoverComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
PopoverComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PopoverComponent, selectors: [["vnext-profile-popover"]], viewQuery: function PopoverComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$36, 5);
        i0.ɵɵviewQuery(_c1$1D, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.profilePopover = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.profilePopoverToggle = _t.first);
    } }, inputs: { headerMenuLinkText: "headerMenuLinkText", dropdownLinks: "dropdownLinks", iconClass: "iconClass" }, outputs: { popoverClickEvent: "popoverClickEvent" }, decls: 23, vars: 16, consts: [[1, "profile-nav-link", "px-2", "px-sm-3", "px-md-3", "px-lg-2", "py-2", "d-none", "d-sm-block"], ["placement", "bottom-right", "popoverClass", "profile-popover", "tabindex", "0", "triggers", "manual", 1, "Spa_Style_Paragraph", "can-click", "focus-text", 3, "ngbPopover", "autoClose", "disablePopover", "click", "keyup.enter"], ["profilePopoverToggle", "", "profilePopover", "ngbPopover"], ["aria-hidden", "true"], [1, "d-none", "d-lg-inline"], ["class", "fas fa-chevron-down Spa_Style_Smaller_Font ml-1 ml-sm-2 ml-md-2 ml-lg-1", "aria-hidden", "true", 4, "ngIf"], [1, "sr-only"], ["profileWidget", ""], [1, "d-sm-none"], [1, "profile-nav-bottom-border"], ["aria-controls", "collapseWidget", 1, "Spa_Style_Paragraph", "w-100", "can-click", "pl-4", "pr-2", "py-2", 3, "click", "keyup.Enter"], ["aria-hidden", "true", "class", "collapse-expand-icon Spa_Style_Smaller_Font", 3, "ngClass", 4, "ngIf"], ["id", "collapseWidget", 1, "pl-5", "pb-2", "w-100", 3, "ngbCollapse"], ["class", "pt-2", 4, "ngFor", "ngForOf"], ["aria-hidden", "true", 1, "fas", "fa-chevron-down", "Spa_Style_Smaller_Font", "ml-1", "ml-sm-2", "ml-md-2", "ml-lg-1"], [1, "profile-popover-template"], ["role", "button", "tabindex", "0", 1, "can-click", "Spa_Style_Primary_Color", "profile-popover-cancel", 3, "click", "keyup.enter"], [1, "fas", "fa-times"], ["class", "ml-1", 3, "ngClass", "click", "keyup.enter", 4, "ngFor", "ngForOf"], [1, "ml-1", 3, "ngClass", "click", "keyup.enter"], [3, "noUnderlineOnHover", "makeInlineBlock", "click", "keyup.Enter"], ["link-body", "", 1, "Spa_Style_Small_Font", "Spa_Style_Paragraph"], ["aria-hidden", "true", 1, "collapse-expand-icon", "Spa_Style_Smaller_Font", 3, "ngClass"], [1, "pt-2"], [3, "click", "keyup.Enter"]], template: function PopoverComponent_Template(rf, ctx) { if (rf & 1) {
        const _r22 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1, 2);
        i0.ɵɵlistener("click", function PopoverComponent_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r22); const _r1 = i0.ɵɵreference(3); return i0.ɵɵresetView(ctx.navigateOrTogglePopover(_r1)); })("keyup.enter", function PopoverComponent_Template_div_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r22); const _r1 = i0.ɵɵreference(3); return i0.ɵɵresetView(ctx.navigateOrTogglePopover(_r1)); });
        i0.ɵɵelement(4, "i", 3);
        i0.ɵɵelementStart(5, "span", 4);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, PopoverComponent_i_7_Template, 1, 0, "i", 5);
        i0.ɵɵelementStart(8, "span", 6);
        i0.ɵɵtext(9, "Expand menu");
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(10, PopoverComponent_ng_template_10_Template, 8, 1, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(12, "div", 8)(13, "div", 9)(14, "div", 10);
        i0.ɵɵlistener("click", function PopoverComponent_Template_div_click_14_listener() { return ctx.navigateOrTogglePopover(); })("keyup.Enter", function PopoverComponent_Template_div_keyup_Enter_14_listener() { return ctx.navigateOrTogglePopover(); });
        i0.ɵɵelement(15, "i", 3);
        i0.ɵɵelementStart(16, "span");
        i0.ɵɵtext(17);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(18, PopoverComponent_i_18_Template, 1, 1, "i", 11);
        i0.ɵɵelementStart(19, "span", 6);
        i0.ɵɵtext(20, "Expand/collapse menu");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(21, "div", 12);
        i0.ɵɵtemplate(22, PopoverComponent_div_22_Template, 5, 1, "div", 13);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(11);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngbPopover", _r3)("autoClose", "outside")("disablePopover", ctx.dropdownLinks.length < 2);
        i0.ɵɵadvance(3);
        i0.ɵɵclassMapInterpolate1("", ctx.iconClass, " Spa_Style_Accent1_Color pr-sm-0 pr-md-1");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.headerMenuLinkText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dropdownLinks.length > 1);
        i0.ɵɵadvance(7);
        i0.ɵɵattribute("aria-expanded", !ctx.isCollapsed);
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("", ctx.iconClass, " Spa_Style_Accent1_Color pr-1");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.headerMenuLinkText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.dropdownLinks.length > 1);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngbCollapse", ctx.isCollapsed);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.dropdownLinks);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, IconAriaAttributesDirective, i1$1.NgbCollapse, i1$1.NgbPopover], styles: [".profile-nav-link[_ngcontent-%COMP%]{border-left:1px solid var(--static-Spa_Style_Gray2)}.profile-nav-link[_ngcontent-%COMP%]:focus{border-radius:5px}.profile-popover-template[_ngcontent-%COMP%]{min-width:200px;position:relative}.profile-popover-cancel[_ngcontent-%COMP%]{position:absolute;top:0;right:0;cursor:pointer;width:20px;text-align:center;height:20px;margin-top:-5px;margin-right:-5px}.collapse-expand-icon[_ngcontent-%COMP%]{position:absolute;right:0}.profile-popover-template[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:none}@media (max-width: 767px){.profile-nav-link[_ngcontent-%COMP%]{border-left:none;border-bottom:1px solid var(--static-Spa_Style_Gray2)}.profile-nav-bottom-border[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Gray2)}}@media print{.d-lg-inline[_ngcontent-%COMP%]{display:inline!important}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PopoverComponent, [{
        type: Component,
        args: [{ selector: 'vnext-profile-popover', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"profile-nav-link px-2 px-sm-3 px-md-3 px-lg-2 py-2 d-none d-sm-block\">\r\n  <div\r\n    #profilePopoverToggle\r\n    placement=\"bottom-right\"\r\n    [ngbPopover]=\"profileWidget\"\r\n    class=\"Spa_Style_Paragraph can-click focus-text\"\r\n    [autoClose]=\"'outside'\"\r\n    #profilePopover=\"ngbPopover\"\r\n    popoverClass=\"profile-popover\"\r\n    tabindex=\"0\"\r\n    triggers=\"manual\"\r\n    (click)=\"navigateOrTogglePopover(profilePopover)\"\r\n    (keyup.enter)=\"navigateOrTogglePopover(profilePopover)\"\r\n    [disablePopover]=\"dropdownLinks.length < 2\"\r\n  >\r\n    <i class=\"{{ iconClass }} Spa_Style_Accent1_Color pr-sm-0 pr-md-1\" aria-hidden=\"true\"></i>\r\n    <span class=\"d-none d-lg-inline\">{{ headerMenuLinkText }}</span>\r\n    <i\r\n      class=\"fas fa-chevron-down Spa_Style_Smaller_Font ml-1 ml-sm-2 ml-md-2 ml-lg-1\"\r\n      aria-hidden=\"true\"\r\n      *ngIf=\"dropdownLinks.length > 1\"\r\n    ></i>\r\n    <span class=\"sr-only\">Expand menu</span>\r\n  </div>\r\n</div>\r\n<ng-template #profileWidget>\r\n  <div>\r\n    <div class=\"profile-popover-template\">\r\n      <div>\r\n        <span\r\n          role=\"button\"\r\n          (click)=\"closePopover(profilePopover)\"\r\n          tabindex=\"0\"\r\n          (keyup.enter)=\"closePopover(profilePopover)\"\r\n          class=\"can-click Spa_Style_Primary_Color profile-popover-cancel\"\r\n        >\r\n          <span class=\"sr-only\">Close</span>\r\n          <i class=\"fas fa-times\"></i>\r\n        </span>\r\n      </div>\r\n      <div\r\n        *ngFor=\"let link of dropdownLinks, first as isFirst\"\r\n        (click)=\"closePopover(profilePopover)\"\r\n        (keyup.enter)=\"closePopover(profilePopover)\"\r\n        [ngClass]=\"{'mt-3' : !isFirst}\"\r\n        class=\"ml-1\"\r\n      >\r\n        <vnext-link\r\n          (click)=\"onPopoverClickEvent(link.tag)\"\r\n          (keyup.Enter)=\"onPopoverClickEvent(link.tag)\"\r\n          [noUnderlineOnHover]=\"true\"\r\n          [makeInlineBlock]=\"true\"\r\n        >\r\n          <div link-body class=\"Spa_Style_Small_Font Spa_Style_Paragraph\">\r\n            <span>{{ link.title }}</span>\r\n          </div>\r\n        </vnext-link>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n\r\n<div class=\"d-sm-none\">\r\n  <div class=\"profile-nav-bottom-border\">\r\n    <div\r\n      class=\"Spa_Style_Paragraph w-100 can-click pl-4 pr-2 py-2\"\r\n      (click)=\"navigateOrTogglePopover()\"\r\n      (keyup.Enter)=\"navigateOrTogglePopover()\"\r\n      [attr.aria-expanded]=\"!isCollapsed\"\r\n      aria-controls=\"collapseWidget\"\r\n    >\r\n      <i class=\"{{ iconClass }} Spa_Style_Accent1_Color pr-1\" aria-hidden=\"true\"></i>\r\n      <span>{{ headerMenuLinkText }}</span>\r\n      <i\r\n        [ngClass]=\"isCollapsed ? 'fas fa-chevron-down' : 'fas fa-chevron-up'\"\r\n        *ngIf=\"dropdownLinks.length > 1\"\r\n        aria-hidden=\"true\"\r\n        class=\"collapse-expand-icon Spa_Style_Smaller_Font\"\r\n      ></i>\r\n      <span class=\"sr-only\">Expand/collapse menu</span>\r\n    </div>\r\n    <div id=\"collapseWidget\" [ngbCollapse]=\"isCollapsed\" class=\"pl-5 pb-2 w-100\">\r\n      <div *ngFor=\"let link of dropdownLinks\" class=\"pt-2\">\r\n        <vnext-link (click)=\"onPopoverClickEvent(link.tag)\" (keyup.Enter)=\"onPopoverClickEvent(link.tag)\">\r\n          <div link-body class=\"Spa_Style_Small_Font Spa_Style_Paragraph\">\r\n            <span>{{ link.title }}</span>\r\n          </div>\r\n        </vnext-link>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".profile-nav-link{border-left:1px solid var(--static-Spa_Style_Gray2)}.profile-nav-link:focus{border-radius:5px}.profile-popover-template{min-width:200px;position:relative}.profile-popover-cancel{position:absolute;top:0;right:0;cursor:pointer;width:20px;text-align:center;height:20px;margin-top:-5px;margin-right:-5px}.collapse-expand-icon{position:absolute;right:0}.profile-popover-template a{text-decoration:none}@media (max-width: 767px){.profile-nav-link{border-left:none;border-bottom:1px solid var(--static-Spa_Style_Gray2)}.profile-nav-bottom-border{border-bottom:1px solid var(--static-Spa_Style_Gray2)}}@media print{.d-lg-inline{display:inline!important}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { profilePopover: [{
            type: ViewChild,
            args: ['profilePopover']
        }], profilePopoverToggle: [{
            type: ViewChild,
            args: ['profilePopoverToggle']
        }], headerMenuLinkText: [{
            type: Input
        }], dropdownLinks: [{
            type: Input
        }], iconClass: [{
            type: Input
        }], popoverClickEvent: [{
            type: Output
        }] }); })();

function ProfileNavigationAgentItemComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2)(2, "vnext-link", 3);
    i0.ɵɵlistener("click", function ProfileNavigationAgentItemComponent_ng_container_0_Template_vnext_link_click_2_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.goToNewBeneficiary()); })("keyup.enter", function ProfileNavigationAgentItemComponent_ng_container_0_Template_vnext_link_keyup_enter_2_listener() { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.goToNewBeneficiary()); });
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵelement(4, "i", 5);
    i0.ɵɵelementStart(5, "span", 6);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵclassMapInterpolate1("Spa_Style_Accent1_Color ", ctx_r0.iconClassNames.PLUS_ICON, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.profileNavBarNewProfileLinkText, " ");
} }
function ProfileNavigationAgentItemComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-profile-popover", 7);
    i0.ɵɵlistener("popoverClickEvent", function ProfileNavigationAgentItemComponent_ng_template_1_Template_vnext_profile_popover_popoverClickEvent_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.navigateByPageTag($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("headerMenuLinkText", ctx_r2.profileNavBarNewProfileLinkText)("dropdownLinks", ctx_r2.profileDropdownLinks)("iconClass", ctx_r2.iconClassNames.PLUS_ICON);
} }
class ProfileNavigationAgentItemComponent {
    constructor() {
        this.iconClassNames = IconClassNames;
        this.popoverClickEvent = new EventEmitter();
        this.redirectToNewBeneficiary = new EventEmitter();
    }
    navigateByPageTag(pageTag) {
        this.popoverClickEvent.emit(pageTag);
    }
    goToNewBeneficiary() {
        this.redirectToNewBeneficiary.emit();
    }
}
ProfileNavigationAgentItemComponent.ɵfac = function ProfileNavigationAgentItemComponent_Factory(t) { return new (t || ProfileNavigationAgentItemComponent)(); };
ProfileNavigationAgentItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProfileNavigationAgentItemComponent, selectors: [["vnext-profile-navigation-agent-item"]], inputs: { lockDownAgentCreate: "lockDownAgentCreate", profileNavBarNewProfileLinkText: "profileNavBarNewProfileLinkText", profileDropdownLinks: "profileDropdownLinks", isAdminAgent: "isAdminAgent" }, outputs: { popoverClickEvent: "popoverClickEvent", redirectToNewBeneficiary: "redirectToNewBeneficiary" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["agentCreationPopover", ""], [1, "profile-nav-link", "px-2", "px-sm-3", "px-md-3", "px-lg-2", "py-2", "d-none", "d-sm-block"], [3, "click", "keyup.enter"], ["link-body", "", 1, "Spa_Style_Small_Font", "Spa_Style_Paragraph"], ["aria-hidden", "true"], [1, "d-none", "d-lg-inline-block", "ml-0", "ml-lg-1"], [3, "headerMenuLinkText", "dropdownLinks", "iconClass", "popoverClickEvent"]], template: function ProfileNavigationAgentItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ProfileNavigationAgentItemComponent_ng_container_0_Template, 7, 4, "ng-container", 0);
        i0.ɵɵtemplate(1, ProfileNavigationAgentItemComponent_ng_template_1_Template, 1, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.lockDownAgentCreate && ctx.isAdminAgent)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgIf, LinkComponent, PopoverComponent], styles: [".profile-nav-link[_ngcontent-%COMP%]{border-left:1px solid var(--static-Spa_Style_Gray2)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProfileNavigationAgentItemComponent, [{
        type: Component,
        args: [{ selector: 'vnext-profile-navigation-agent-item', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"lockDownAgentCreate && isAdminAgent; else agentCreationPopover\">\r\n  <div class=\"profile-nav-link px-2 px-sm-3 px-md-3 px-lg-2 py-2 d-none d-sm-block\">\r\n    <vnext-link (click)=\"goToNewBeneficiary()\" (keyup.enter)=\"goToNewBeneficiary()\">\r\n      <div link-body class=\"Spa_Style_Small_Font Spa_Style_Paragraph\">\r\n        <i class=\"Spa_Style_Accent1_Color {{ iconClassNames.PLUS_ICON }}\" aria-hidden=\"true\"></i>\r\n        <span class=\"d-none d-lg-inline-block ml-0 ml-lg-1\">\r\n          {{ profileNavBarNewProfileLinkText }}\r\n        </span>\r\n      </div>\r\n    </vnext-link>\r\n  </div>\r\n</ng-container>\r\n\r\n<ng-template #agentCreationPopover>\r\n  <vnext-profile-popover\r\n    [headerMenuLinkText]=\"profileNavBarNewProfileLinkText\"\r\n    [dropdownLinks]=\"profileDropdownLinks\"\r\n    [iconClass]=\"iconClassNames.PLUS_ICON\"\r\n    (popoverClickEvent)=\"navigateByPageTag($event)\"\r\n  ></vnext-profile-popover>\r\n</ng-template>\r\n", styles: [".profile-nav-link{border-left:1px solid var(--static-Spa_Style_Gray2)}\n"] }]
    }], null, { lockDownAgentCreate: [{
            type: Input
        }], profileNavBarNewProfileLinkText: [{
            type: Input
        }], profileDropdownLinks: [{
            type: Input
        }], isAdminAgent: [{
            type: Input
        }], popoverClickEvent: [{
            type: Output
        }], redirectToNewBeneficiary: [{
            type: Output
        }] }); })();

const _c0$35 = ["dropDownPopover"];
const _c1$1C = ["dropDownPopoverToggle"];
function ProfileNavbarDropdownComponent_ng_container_1_ng_template_12_ng_container_5_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 23);
} }
const _c2$$ = function (a0) { return { "ml-4": a0 }; };
function ProfileNavbarDropdownComponent_ng_container_1_ng_template_12_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProfileNavbarDropdownComponent_ng_container_1_ng_template_12_ng_container_5_div_1_Template, 1, 0, "div", 20);
    i0.ɵɵelementStart(2, "div", 21)(3, "span", 22);
    i0.ɵɵlistener("click", function ProfileNavbarDropdownComponent_ng_container_1_ng_template_12_ng_container_5_Template_span_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r13); const link_r10 = restoredCtx.$implicit; i0.ɵɵnextContext(2); const _r4 = i0.ɵɵreference(4); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.navigateToPageTag(link_r10.tag, _r4)); })("keyup.enter", function ProfileNavbarDropdownComponent_ng_container_1_ng_template_12_ng_container_5_Template_span_keyup_enter_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r13); const link_r10 = restoredCtx.$implicit; i0.ɵɵnextContext(2); const _r4 = i0.ɵɵreference(4); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.navigateToPageTag(link_r10.tag, _r4)); });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const link_r10 = ctx.$implicit;
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", link_r10.tag === ctx_r8.PAGE_TAGS.RETENTION_SUMMARY);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c2$$, ctx_r8.isGuidedHelpSubPage(link_r10)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(link_r10.title);
} }
function ProfileNavbarDropdownComponent_ng_container_1_ng_template_12_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 24)(2, "span", 25);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r9.transferCodeLabelText, " :");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r9.transferCode);
} }
function ProfileNavbarDropdownComponent_ng_container_1_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "span", 16);
    i0.ɵɵlistener("click", function ProfileNavbarDropdownComponent_ng_container_1_ng_template_12_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r16); i0.ɵɵnextContext(); const _r4 = i0.ɵɵreference(4); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.closePopover(_r4)); })("keyup.enter", function ProfileNavbarDropdownComponent_ng_container_1_ng_template_12_Template_span_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r16); i0.ɵɵnextContext(); const _r4 = i0.ɵɵreference(4); const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.closePopover(_r4)); });
    i0.ɵɵelementStart(2, "span", 9);
    i0.ɵɵtext(3, "Close");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "i", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ProfileNavbarDropdownComponent_ng_container_1_ng_template_12_ng_container_5_Template, 5, 5, "ng-container", 18);
    i0.ɵɵtemplate(6, ProfileNavbarDropdownComponent_ng_container_1_ng_template_12_ng_container_6_Template, 6, 2, "ng-container", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r6.links);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.isTransferCodeEnabled);
} }
const _c3$H = function (a0) { return { "d-none": a0 }; };
function ProfileNavbarDropdownComponent_ng_container_1_div_22_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 27);
    i0.ɵɵlistener("click", function ProfileNavbarDropdownComponent_ng_container_1_div_22_ng_container_1_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r21); const link_r19 = restoredCtx.$implicit; i0.ɵɵnextContext(2); const _r4 = i0.ɵɵreference(4); const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.navigateToPageTag(link_r19.tag, _r4)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const link_r19 = ctx.$implicit;
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c3$H, ctx_r18.isGuidedHelpSubPage(link_r19)));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", link_r19.title, " ");
} }
function ProfileNavbarDropdownComponent_ng_container_1_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtemplate(1, ProfileNavbarDropdownComponent_ng_container_1_div_22_ng_container_1_Template, 3, 4, "ng-container", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r7.links);
} }
function ProfileNavbarDropdownComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3)(2, "div", 4, 5);
    i0.ɵɵelement(5, "i", 6);
    i0.ɵɵelementStart(6, "span", 7);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "shortName");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "i", 8);
    i0.ɵɵelementStart(10, "span", 9);
    i0.ɵɵtext(11, "Expand menu");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(12, ProfileNavbarDropdownComponent_ng_container_1_ng_template_12_Template, 7, 2, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 11)(15, "div", 12);
    i0.ɵɵlistener("click", function ProfileNavbarDropdownComponent_ng_container_1_Template_div_click_15_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r22.toggleSubMenuDropdown()); });
    i0.ɵɵelement(16, "i", 6);
    i0.ɵɵelementStart(17, "span", 7);
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(19, "i", 13);
    i0.ɵɵelementStart(20, "span", 9);
    i0.ɵɵtext(21, "Expand menu");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(22, ProfileNavbarDropdownComponent_ng_container_1_div_22_Template, 2, 1, "div", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r5 = i0.ɵɵreference(13);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngbPopover", _r5)("autoClose", "outside");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 5, ctx_r0.memberName));
    i0.ɵɵadvance(11);
    i0.ɵɵtextInterpolate(ctx_r0.memberName);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.showSubMenuDropdown);
} }
function ProfileNavbarDropdownComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelement(1, "i", 28);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.noMemberInSessionText);
} }
class ProfileNavbarDropdownComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.links = [];
        this.pageTagSelected = new EventEmitter();
        this.subscriptions = [];
        this.showSubMenuDropdown = false; // When ProfileNavbarDropdownComponent used as submenu
        this.PAGE_TAGS = PageTags;
    }
    ngAfterViewInit() {
        const dropDownPopoverHidden$ = this.dropDownPopover?.hidden;
        if (dropDownPopoverHidden$) {
            this.subscriptions.push(dropDownPopoverHidden$.subscribe({
                next: () => {
                    this.dropDownPopoverToggle?.nativeElement?.focus();
                    this.cdr.markForCheck();
                }
            }));
        }
    }
    ngAfterViewChecked() {
        const dropDownPopoverShown$ = this.dropDownPopover?.shown;
        if (dropDownPopoverShown$) {
            const dropDownPopoverCancelButtonElement = document.querySelector('.dropdown-popover-cancel');
            this.subscriptions.push(dropDownPopoverShown$.subscribe({
                next: () => {
                    if (dropDownPopoverCancelButtonElement) {
                        dropDownPopoverCancelButtonElement.focus();
                    }
                    this.cdr.markForCheck();
                }
            }));
        }
    }
    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
    isGuidedHelpSubPage(link) {
        return link.tag.startsWith('GuidedHelp_') && link.tag !== PageTags.GUIDED_HELP_GETTING_STARTED;
    }
    toggleSubMenuDropdown() {
        this.showSubMenuDropdown = !this.showSubMenuDropdown;
    }
    closePopover(popover) {
        if (popover?.isOpen()) {
            popover.close();
        }
    }
    navigateToPageTag(pageTag, popover) {
        this.closePopover(popover);
        this.pageTagSelected.emit(pageTag);
    }
}
ProfileNavbarDropdownComponent.ɵfac = function ProfileNavbarDropdownComponent_Factory(t) { return new (t || ProfileNavbarDropdownComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
ProfileNavbarDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProfileNavbarDropdownComponent, selectors: [["vnext-profile-navbar-dropdown"]], viewQuery: function ProfileNavbarDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$35, 5);
        i0.ɵɵviewQuery(_c1$1C, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropDownPopover = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropDownPopoverToggle = _t.first);
    } }, inputs: { links: "links", noMemberInSessionText: "noMemberInSessionText", memberName: "memberName", isTransferCodeEnabled: "isTransferCodeEnabled", transferCode: "transferCode", transferCodeLabelText: "transferCodeLabelText" }, outputs: { pageTagSelected: "pageTagSelected" }, decls: 4, vars: 2, consts: [[1, "Spa_Style_Paragraph"], [4, "ngIf", "ngIfElse"], ["noMemberInSession", ""], [1, "d-sm-block", "d-none"], ["placement", "bottom-right", "tabindex", "0", 1, "can-click", "focus-text", 3, "ngbPopover", "autoClose"], ["dropDownPopoverToggle", "", "dropDownPopover", "ngbPopover"], ["aria-hidden", "true", 1, "fa", "fa-user", "mr-1", "Spa_Style_Accent1_Color"], [1, "memberName", "no-translate-block"], [1, "fas", "fa-chevron-down", "Spa_Style_Primary_Color", "Spa_Style_Smaller_Font", "ml-2"], [1, "sr-only"], ["dropdown", ""], [1, "d-sm-none", "d-block"], [1, "can-click", 3, "click"], [1, "fas", "fa-chevron-down", "Spa_Style_Primary_Color", "Spa_Style_Smaller_Font", "ml-2", "pt-1", "chevronIcon"], ["class", "pt-2 pl-3", 4, "ngIf"], [2, "min-width", "200px"], ["role", "button", "tabindex", "0", 1, "float-right", "can-click", "dropdown-close", "dropdown-popover-cancel", 3, "click", "keyup.enter"], [1, "fas", "fa-times", "Spa_Style_Primary_Color"], [4, "ngFor", "ngForOf"], [4, "ngIf"], ["class", "navigation-separator mt-1 mb-1", 4, "ngIf"], [1, "Spa_Style_Paragraph", "py-2", "px-1", "dropdown-link", 3, "ngClass"], ["tabIndex", "0", 1, "focus-text", "can-click", 3, "click", "keyup.enter"], [1, "navigation-separator", "mt-1", "mb-1"], [1, "Spa_Style_Paragraph", "py-2", "px-1"], [1, "Spa_Style_Bold_Weight", "pr-1"], [1, "pt-2", "pl-3"], [1, "Spa_Style_Paragraph", "can-click", "pl-2", "p-1", 3, "ngClass", "click"], ["aria-hidden", "true", 1, "fa", "fa-user", "mr-1"]], template: function ProfileNavbarDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, ProfileNavbarDropdownComponent_ng_container_1_Template, 23, 7, "ng-container", 1);
        i0.ɵɵtemplate(2, ProfileNavbarDropdownComponent_ng_template_2_Template, 4, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(3);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.memberName)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, IconAriaAttributesDirective, i1$1.NgbPopover, ShortNamePipe], styles: [".memberName[_ngcontent-%COMP%]{max-width:100px}.chevronIcon[_ngcontent-%COMP%]{position:absolute;right:15px}.dropdown-link[_ngcontent-%COMP%]:focus{border-radius:5px}.dropdown-close[_ngcontent-%COMP%]{width:20px;height:20px;text-align:center}.dropdown-close[_ngcontent-%COMP%]:focus{border-radius:50%}.navigation-separator[_ngcontent-%COMP%]{width:100%;border-top:1px solid var(--static-Spa_Style_Gray2)}@media (max-width: 768px){.memberName[_ngcontent-%COMP%]{max-width:280px}}.fa-user[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent1)}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], ProfileNavbarDropdownComponent.prototype, "navigateToPageTag", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProfileNavbarDropdownComponent, [{
        type: Component,
        args: [{ selector: 'vnext-profile-navbar-dropdown', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"Spa_Style_Paragraph\">\r\n  <ng-container *ngIf=\"memberName; else noMemberInSession\">\r\n    <!-- Desktop View Start -->\r\n    <div class=\"d-sm-block d-none\">\r\n      <div\r\n        #dropDownPopoverToggle\r\n        [ngbPopover]=\"dropdown\"\r\n        #dropDownPopover=\"ngbPopover\"\r\n        placement=\"bottom-right\"\r\n        class=\"can-click focus-text\"\r\n        tabindex=\"0\"\r\n        [autoClose]=\"'outside'\"\r\n      >\r\n        <i class=\"fa fa-user mr-1 Spa_Style_Accent1_Color\" aria-hidden=\"true\"></i>\r\n        <span class=\"memberName no-translate-block\">{{ memberName | shortName }}</span>\r\n        <i class=\"fas fa-chevron-down Spa_Style_Primary_Color Spa_Style_Smaller_Font ml-2\"></i>\r\n        <span class=\"sr-only\">Expand menu</span>\r\n      </div>\r\n      <ng-template #dropdown>\r\n        <div style=\"min-width: 200px\">\r\n          <span\r\n            class=\"float-right can-click dropdown-close dropdown-popover-cancel\"\r\n            role=\"button\"\r\n            tabindex=\"0\"\r\n            (click)=\"closePopover(dropDownPopover)\"\r\n            (keyup.enter)=\"closePopover(dropDownPopover)\"\r\n          >\r\n            <span class=\"sr-only\">Close</span>\r\n            <i class=\"fas fa-times Spa_Style_Primary_Color\"></i>\r\n          </span>\r\n          <ng-container *ngFor=\"let link of links\">\r\n            <div *ngIf=\"link.tag === PAGE_TAGS.RETENTION_SUMMARY\" class=\"navigation-separator mt-1 mb-1\"></div>\r\n            <div class=\"Spa_Style_Paragraph py-2 px-1 dropdown-link\" [ngClass]=\"{ 'ml-4': isGuidedHelpSubPage(link) }\">\r\n              <span\r\n                tabIndex=\"0\"\r\n                class=\"focus-text can-click\"\r\n                (click)=\"navigateToPageTag(link.tag, dropDownPopover)\"\r\n                (keyup.enter)=\"navigateToPageTag(link.tag, dropDownPopover)\"\r\n                >{{ link.title }}</span\r\n              >\r\n            </div>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"isTransferCodeEnabled\">\r\n            <div class=\"Spa_Style_Paragraph py-2 px-1\">\r\n              <span class=\"Spa_Style_Bold_Weight pr-1\">{{ transferCodeLabelText }} :</span> <span>{{ transferCode }}</span>\r\n            </div>\r\n          </ng-container>\r\n        </div>\r\n      </ng-template>\r\n    </div>\r\n    <!-- Desktop View End -->\r\n    <!-- Mobile View Start -->\r\n    <div class=\"d-sm-none d-block\">\r\n      <div class=\"can-click\" (click)=\"toggleSubMenuDropdown()\">\r\n        <i class=\"fa fa-user mr-1 Spa_Style_Accent1_Color\" aria-hidden=\"true\"></i>\r\n        <span class=\"memberName no-translate-block\">{{ memberName }}</span>\r\n        <i class=\"fas fa-chevron-down Spa_Style_Primary_Color Spa_Style_Smaller_Font ml-2 pt-1 chevronIcon\"></i>\r\n        <span class=\"sr-only\">Expand menu</span>\r\n      </div>\r\n      <div *ngIf=\"showSubMenuDropdown\" class=\"pt-2 pl-3\">\r\n        <ng-container *ngFor=\"let link of links\">\r\n          <div\r\n            class=\"Spa_Style_Paragraph can-click pl-2 p-1\"\r\n            [ngClass]=\"{ 'd-none': isGuidedHelpSubPage(link) }\"\r\n            (click)=\"navigateToPageTag(link.tag, dropDownPopover)\"\r\n          >\r\n            {{ link.title }}\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n    </div>\r\n    <!-- Mobile View End -->\r\n  </ng-container>\r\n  <ng-template #noMemberInSession>\r\n    <div class=\"Spa_Style_Paragraph\">\r\n      <i class=\"fa fa-user mr-1\" aria-hidden=\"true\"></i>\r\n      <span>{{ noMemberInSessionText }}</span>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n", styles: [".memberName{max-width:100px}.chevronIcon{position:absolute;right:15px}.dropdown-link:focus{border-radius:5px}.dropdown-close{width:20px;height:20px;text-align:center}.dropdown-close:focus{border-radius:50%}.navigation-separator{width:100%;border-top:1px solid var(--static-Spa_Style_Gray2)}@media (max-width: 768px){.memberName{max-width:280px}}.fa-user{color:var(--static-Spa_Style_Accent1)}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { dropDownPopover: [{
            type: ViewChild,
            args: ['dropDownPopover']
        }], dropDownPopoverToggle: [{
            type: ViewChild,
            args: ['dropDownPopoverToggle']
        }], links: [{
            type: Input
        }], noMemberInSessionText: [{
            type: Input
        }], memberName: [{
            type: Input
        }], isTransferCodeEnabled: [{
            type: Input
        }], transferCode: [{
            type: Input
        }], transferCodeLabelText: [{
            type: Input
        }], pageTagSelected: [{
            type: Output
        }], navigateToPageTag: [] }); })();

function ProfileNavigationBarComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-profile-popover", 4);
    i0.ɵɵlistener("popoverClickEvent", function ProfileNavigationBarComponent_ng_container_3_Template_vnext_profile_popover_popoverClickEvent_1_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.navigateByPageTag($event, true)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("headerMenuLinkText", ctx_r0.Spa_ProfileNavBar_AgentDashboard_Text)("iconClass", ctx_r0.iconClassNames.DASHBOARD_ICON)("dropdownLinks", ctx_r0.dashboardLinks);
} }
function ProfileNavigationBarComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-profile-popover", 4);
    i0.ɵɵlistener("popoverClickEvent", function ProfileNavigationBarComponent_ng_container_4_Template_vnext_profile_popover_popoverClickEvent_1_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.navigateByPageTag($event, true)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("headerMenuLinkText", ctx_r1.Spa_ProfileNavBar_BrowsePlans_Text)("iconClass", ctx_r1.iconClassNames.PLANS_ICON)("dropdownLinks", ctx_r1.browsePlansLinks);
} }
class ProfileNavigationBarComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, unsavedModalContext, agentPermissionsService, configResourceService, navigationService, profileFacade, guidedHelpService, memberSessionService, store, siteService, planListContext, shoppingRecordingContextService, twilioService, agentService, deactivationGuardService, modalService, externalErrorLoggingService, agentSearchFacade, injector) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.unsavedModalContext = unsavedModalContext;
        this.agentPermissionsService = agentPermissionsService;
        this.configResourceService = configResourceService;
        this.navigationService = navigationService;
        this.profileFacade = profileFacade;
        this.guidedHelpService = guidedHelpService;
        this.memberSessionService = memberSessionService;
        this.store = store;
        this.siteService = siteService;
        this.planListContext = planListContext;
        this.shoppingRecordingContextService = shoppingRecordingContextService;
        this.twilioService = twilioService;
        this.agentService = agentService;
        this.deactivationGuardService = deactivationGuardService;
        this.modalService = modalService;
        this.externalErrorLoggingService = externalErrorLoggingService;
        this.agentSearchFacade = agentSearchFacade;
        this.injector = injector;
        this.Spa_ProfileNavBar_NoMemberInSessionText = '---';
        this.Spa_ProfileNavBar_SearchProfileLinkText = 'Search profile';
        this.Spa_ProfileNavBar_SearchProfileLinkShortText = 'Search';
        this.Spa_ProfileNavBar_NewProfileLinkText = 'New profile';
        this.Spa_ProfileNavDropdown_ProfileLinkText = 'Profile';
        this.Spa_ProfileNavDropdown_SOALinkText = 'Scope of appointment';
        this.Spa_ProfileNavDropdown_PreferencesLinkText = 'Preferences';
        this.Spa_ProfileNavDropdown_HealthLinkText = 'Health';
        this.Spa_ProfileNavDropdown_PrescriptionsLinkText = 'Prescription';
        this.Spa_ProfileNavDropdown_PharmacyLinkText = 'Pharmacy';
        this.Spa_ProfileNavDropdown_PlansLinkText = 'Plans';
        this.Spa_ProfileNavDropdown_CartLinkText = 'Cart';
        this.Spa_Site_OtherPreferences_Text = 'Other preferences';
        this.Spa_Site_SiteType = SiteType.CONSUMER;
        this.Spa_ProfileNavBar_DropdownLinks = [];
        this.Spa_ProfileNavBar_ShowPlanList_Flag = false;
        this.Spa_ProfileNavBar_BrowsePlans_Text = 'Plans';
        this.Spa_Site_AgentDashboard_Enabled = false;
        this.Spa_ProfileNavBar_AgentDashboard_Text = 'Dashboard';
        this.Spa_ProfileNavDropdown_NewBeneficiary_LinkText = 'New Beneficiary';
        this.Spa_ProfileNavDropdown_NewAgent_LinkText = 'New Agent';
        this.Spa_ProfileNavDropdown_SearchBeneficiary_LinkText = 'Search Beneficiary';
        this.Spa_ProfileNavDropdown_SearchAgent_LinkText = 'Search Agent';
        this.Spa_Agent_Create_Account_Enabled = true;
        this.Spa_Agent_Create_Lock_Down = false;
        this.Spa_ProfileNavDropdown_ProvidersLinkText = 'Providers';
        this.Spa_Site_TransferCode_Label_Text = 'Transfer code';
        this.Spa_Site_TransferCode_Enabled = false;
        this.Spa_ProfileNavDropdown_NewRetireFlo_LinkText = 'New RetireFlo';
        this.Spa_Agent_RetireFlo_NavDropdown_Enabled = false;
        this.Spa_RetireFlo_NewIntake_Header_Text = 'Send RetireFlo';
        this.Spa_RetireFlo_NewIntake_Description_Text = 'RetireFlo';
        this.Spa_RetireFlo_NewIntake_CustomMessage_Description_Text = 'Send RetireFlo Description';
        this.Spa_RetireFlo_NewIntake_CustomMessage_Default_Text = 'Send RetireFlo Default Text';
        this.pageTags = PageTags;
        this.iconClassNames = IconClassNames;
        this.isAdminAgent = false;
        this.searchProfilePageTag = PageTags.PROFILE_SEARCH;
        this.createProfilePageTag = PageTags.ADD_NEW_PROFILE;
        this.isNewRetireFloEnabled = false;
        this.pageTagIsEnabledStatus = [
            {
                pageTag: PageTags.MEMBER_PROFILE_PAGE,
                enabled: this.configResourceService.getProcessedResourceValue('Spa_Site_MemberProfile_Enabled', null, true)
            },
            {
                pageTag: PageTags.SOA,
                enabled: this.configResourceService.getProcessedResourceValue('Spa_Site_SOA_Enabled', null, true)
            },
            {
                pageTag: PageTags.GUIDED_HELP_GETTING_STARTED,
                enabled: this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_Enabled', null, true)
            },
            {
                pageTag: PageTags.GUIDED_HELP_HEALTH,
                enabled: this.configResourceService.getProcessedResourceValue('Spa_Site_Health_Enabled', null, true)
            },
            {
                pageTag: PageTags.GUIDED_HELP_PROVIDER_SEARCH,
                enabled: this.configResourceService.getProcessedResourceValue('Spa_Site_Providers_Enabled', null, false)
            },
            {
                pageTag: PageTags.GUIDED_HELP_PRESCRIPTIONS,
                enabled: this.configResourceService.getProcessedResourceValue('Spa_Site_Prescriptions_Enabled', null, true)
            },
            {
                pageTag: PageTags.GUIDED_HELP_PHARMACY_SEARCH,
                enabled: this.configResourceService.getProcessedResourceValue('Spa_Site_Pharmacy_Enabled', null, true)
            },
            {
                pageTag: PageTags.GUIDED_HELP_OTHER_PREFERENCES,
                enabled: this.configResourceService.getProcessedResourceValue('Spa_Site_OtherPreferences_Enabled', null, false)
            },
            {
                pageTag: PageTags.SHOPPING_CART,
                enabled: this.configResourceService.getProcessedResourceValue('Spa_ShoppingCart_Enabled', null, true)
            },
            {
                pageTag: PageTags.PLAN_LIST,
                enabled: this.configResourceService.getProcessedResourceValue('Spa_PlanList_Enabled', null, true)
            },
            {
                pageTag: PageTags.RETENTION_SUMMARY,
                enabled: this.configResourceService.getProcessedResourceValue('Spa_RetentionSummary_Profile_Enabled', null, false)
            }
        ];
        this.guidedHelpPageTagPrefix = 'GuidedHelp';
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        super.ngOnInit();
        this.isPPCSite = this.siteService.isPPCSite(this.Spa_Site_SiteType);
        const enabledPageTags = this.getEnabledPageTags({
            pageTagIsEnabledStatus: this.pageTagIsEnabledStatus,
            isPPCSite: this.isPPCSite,
            isRetentionMemberFromSource: this.memberSessionService.isRetentionMemberFromSource()
        });
        this.enabledLinks = this.Spa_ProfileNavBar_DropdownLinks.filter(link => enabledPageTags.some(enabledPage => enabledPage.pageTag === link.tag));
        this.memberName$ = this.Spa_ProfileNavBar_ShowPlanList_Flag
            ? this.profileFacade.getMemberFirstName$()
            : this.profileFacade.getMemberFullName$();
        this.subscriptions.add(this.memberName$.subscribe({
            next: memberName => {
                this.memberName = memberName;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.memberSessionService
            .getMemberHasFullName$()
            .pipe(distinctUntilChanged())
            .subscribe({
            next: () => {
                this.initializeDropdownLinks();
            }
        }));
        this.subscriptions.add(this.agentService.getAgentProgressEvents$().subscribe({
            next: (memberProgressInfo) => {
                if (memberProgressInfo?.transferCode) {
                    this.transferCode = memberProgressInfo.transferCode;
                }
                this.cdr.markForCheck();
            }
        }));
        this.isAdminAgent = this.profileFacade.isAdminAgent();
    }
    preProcessProperties() {
        this.initializeDropdownLinks();
        this.browsePlansLinks = [{ title: this.Spa_ProfileNavDropdown_PlansLinkText, tag: PageTags.PLAN_LIST }];
        this.dashboardLinks = [{ title: this.Spa_ProfileNavBar_AgentDashboard_Text, tag: PageTags.AGENT_DASHBOARD }];
        this.Spa_ProfileNavBar_DropdownLinks = this.Spa_ProfileNavBar_DropdownLinks?.length
            ? this.Spa_ProfileNavBar_DropdownLinks
            : [
                { title: this.Spa_ProfileNavDropdown_ProfileLinkText, tag: PageTags.MEMBER_PROFILE_PAGE },
                { title: this.Spa_ProfileNavDropdown_SOALinkText, tag: PageTags.SOA },
                { title: this.Spa_ProfileNavDropdown_PreferencesLinkText, tag: PageTags.GUIDED_HELP_GETTING_STARTED },
                { title: this.Spa_ProfileNavDropdown_HealthLinkText, tag: PageTags.GUIDED_HELP_HEALTH },
                { title: this.Spa_ProfileNavDropdown_ProvidersLinkText, tag: PageTags.GUIDED_HELP_PROVIDER_SEARCH },
                { title: this.Spa_ProfileNavDropdown_PrescriptionsLinkText, tag: PageTags.GUIDED_HELP_PRESCRIPTIONS },
                { title: this.Spa_ProfileNavDropdown_PharmacyLinkText, tag: PageTags.GUIDED_HELP_PHARMACY_SEARCH },
                {
                    title: this.configResourceService.getProcessedResourceValue('Spa_Site_OtherPreferences_Text', null, 'Other preferences'),
                    tag: PageTags.GUIDED_HELP_OTHER_PREFERENCES
                },
                { title: this.Spa_ProfileNavDropdown_PlansLinkText, tag: PageTags.PLAN_LIST },
                { title: this.Spa_ProfileNavDropdown_CartLinkText, tag: PageTags.SHOPPING_CART }
            ];
    }
    initializeDropdownLinks() {
        this.isNewRetireFloEnabled =
            this.Spa_Agent_RetireFlo_NavDropdown_Enabled && this.agentService.getAgentHasRetireFlo() && !this.hasMemberProfile();
        if (this.hasAdminAuthorization()) {
            if (this.Spa_Agent_Create_Account_Enabled) {
                this.profileDropdownLinks = [
                    { title: this.Spa_ProfileNavDropdown_NewBeneficiary_LinkText, tag: PageTags.ADD_NEW_PROFILE },
                    ...(this.isNewRetireFloEnabled
                        ? [{ title: this.Spa_ProfileNavDropdown_NewRetireFlo_LinkText, tag: PageTags.ADD_NEW_RETIREFLO }]
                        : []),
                    { title: this.Spa_ProfileNavDropdown_NewAgent_LinkText, tag: PageTags.ADD_NEW_AGENT }
                ];
            }
            else {
                this.profileDropdownLinks = [
                    { title: this.Spa_ProfileNavDropdown_NewBeneficiary_LinkText, tag: PageTags.ADD_NEW_PROFILE },
                    ...(this.isNewRetireFloEnabled
                        ? [{ title: this.Spa_ProfileNavDropdown_NewRetireFlo_LinkText, tag: PageTags.ADD_NEW_RETIREFLO }]
                        : [])
                ];
            }
            this.searchDropdownLinks = [
                { title: this.Spa_ProfileNavDropdown_SearchBeneficiary_LinkText, tag: PageTags.PROFILE_SEARCH },
                { title: this.Spa_ProfileNavDropdown_SearchAgent_LinkText, tag: PageTags.AGENT_SEARCH }
            ];
        }
        else {
            this.searchDropdownLinks = [{ title: this.Spa_ProfileNavDropdown_SearchBeneficiary_LinkText, tag: PageTags.PROFILE_SEARCH }];
            this.profileDropdownLinks = [
                { title: this.Spa_ProfileNavDropdown_NewBeneficiary_LinkText, tag: PageTags.ADD_NEW_PROFILE },
                ...(this.isNewRetireFloEnabled
                    ? [{ title: this.Spa_ProfileNavDropdown_NewRetireFlo_LinkText, tag: PageTags.ADD_NEW_RETIREFLO }]
                    : [])
            ];
        }
    }
    navigateByPageTag(pageTag, logOutMember = false) {
        const currentPage = this.getCurrentPage(this.configurableWidgetService.router.url);
        const currentTag = currentPage.tags[0];
        const callRecordingInProgress = this.twilioService.isShoppingCallRecordingInProgress();
        if (callRecordingInProgress && logOutMember) {
            this.shoppingRecordingContextService.displayEndCallConfirmationModal();
        }
        // Because we are navigating to the same URL, using more than 1 Pagetag,
        // in order to differentiate internally at the component level, This data type (MemberProfilePageTags)
        // is exclusive to member profile (beneficiary) tags. Possibly this fragment will be removed
        // in future features when said tags are independent by URL
        if ([PageTags.ADD_NEW_PROFILE, PageTags.MEMBER_PROFILE_PAGE].includes(pageTag)) {
            this.memberSessionService.setCurrentMemberProfilePageTag(pageTag);
        }
        // We check the Deactivation guards manually to run additional operations before starting the navigation
        // This could help in cases where we have to clear the member's session only after checking all Deactivation guards
        this.deactivationGuardService.canDeactivate().then(canDeactivate => {
            if (canDeactivate) {
                if (pageTag === PageTags.GUIDED_HELP_GETTING_STARTED) {
                    if (logOutMember) {
                        this.profileFacade.logOutMember();
                    }
                    this.guidedHelpService.goToFirstLink();
                }
                if (pageTag === PageTags.PLAN_LIST && currentTag === PageTags.PLAN_LIST && logOutMember) {
                    this.profileFacade.logOutMember();
                    this.planListContext.displayZipCodeModal();
                    return;
                }
                if (pageTag === PageTags.ADD_NEW_RETIREFLO) {
                    this.sendRetrieFloModal();
                    return;
                }
                if (pageTag === PageTags.MEMBER_PROFILE_PAGE) {
                    const sessionId = this.getMemberSessionId();
                    if (sessionId) {
                        this.memberSessionService.setIsSelectedMemberDetailsUpdating(true);
                        this.memberSessionService.fetchMemberSession$({ sessionId });
                        this.memberSessionService.updateCart(null, null, null, null, true).finally(() => {
                            this.memberSessionService.setIsSelectedMemberDetailsUpdating(false);
                        });
                        // We skip the next canDeactivate() check triggered automatically by the navigation because we already checked it manually
                        this.deactivationGuardService.setDeactivationGuardStatus(DeactivationGuardStatus.SKIP_NEXT_CAN_DEACTIVATE_CHECK);
                        this.navigationService.navigateByPageTag(pageTag);
                    }
                }
                else if (pageTag === PageTags.PROFILE_SEARCH) {
                    this.profileFacade.beneficiarySearchNavigationClicked(false);
                }
                else if (pageTag === PageTags.AGENT_SEARCH) {
                    this.profileFacade.agentSearchNavigationClicked(false);
                }
                if (currentTag === PageTags.ADD_NEW_AGENT && pageTag === currentTag) {
                    this.unsavedModalContext.displayModal();
                    this.navigationService.navigateByPageTag(pageTag);
                }
                else {
                    if (logOutMember) {
                        this.profileFacade.logOutMember();
                    }
                    // We skip the next canDeactivate() check triggered by the navigation because we already checked it manually
                    this.deactivationGuardService.setDeactivationGuardStatus(DeactivationGuardStatus.SKIP_NEXT_CAN_DEACTIVATE_CHECK);
                    this.navigationService.navigateByPageTag(pageTag);
                }
            }
        });
    }
    sendRetrieFloModal() {
        const sessionId = this.getMemberSessionId();
        if (sessionId) {
            const options = {
                ariaLabelledBy: 'modalHeaderTitle',
                centered: true,
                injector: this.injector
            };
            const sendRetireFloModal = this.modalService.open(SendRetireFloModalComponent, options);
            sendRetireFloModal.componentInstance.isNewMember = true;
            sendRetireFloModal.componentInstance.modalTitleText = this.Spa_RetireFlo_NewIntake_Header_Text;
            sendRetireFloModal.componentInstance.modalDescriptiveText = this.Spa_RetireFlo_NewIntake_Description_Text;
            sendRetireFloModal.componentInstance.modalAdditionalSubText = this.Spa_RetireFlo_NewIntake_CustomMessage_Description_Text;
            sendRetireFloModal.componentInstance.modalAdditionalDefaultMessage = this.Spa_RetireFlo_NewIntake_CustomMessage_Default_Text;
            sendRetireFloModal.result
                .then(formData => {
                this.memberSessionService.sendRetireFloSurvey$(sessionId, formData).subscribe({
                    next: (memberagentNotes) => {
                        if (memberagentNotes.length > 0) {
                            const lastUpdatedMemberAgentNote = memberagentNotes[memberagentNotes.length - 1];
                            this.memberId = lastUpdatedMemberAgentNote.memberId;
                            this.updateAgentRetireFlo(lastUpdatedMemberAgentNote);
                        }
                        const apiMemberStateModel = {
                            memberID: this.memberId ?? '',
                            profile: {
                                firstName: formData.firstName,
                                lastName: formData.lastName,
                                emailAddress: formData.emailAddress ?? '',
                                homePhone: formData.phoneNumber ?? ''
                            }
                        };
                        this.updateMemberProfileAndNavigateToProfilePage(apiMemberStateModel);
                    }
                });
            })
                .catch(error => {
                this.externalErrorLoggingService.log(error);
            });
        }
    }
    async updateAgentRetireFlo(memberAgentNotes) {
        return await this.memberSessionService.updateMemberTask(memberAgentNotes);
    }
    async updateMemberProfileAndNavigateToProfilePage(apiMemberStateModel) {
        await this.memberSessionService.updateMemberProfile$(apiMemberStateModel).toPromise();
        this.agentSearchFacade.navigateByPageTag(PageTags.MEMBER_PROFILE_PAGE);
    }
    getMemberSessionId() {
        return this.memberSessionService.getMemberSessionId();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
    goToNewBeneficiary() {
        this.navigateByPageTag(PageTags.ADD_NEW_PROFILE, true);
    }
    getCurrentPage(pageName) {
        return this.store.selectSnapshot(AppConfigState.page(pageName));
    }
    hasAdminAuthorization() {
        return this.agentPermissionsService.isAdmin() && this.agentPermissionsService.hasAdminPermissions();
    }
    hasMemberProfile() {
        return this.memberSessionService.getMemberHasFullName();
    }
    getEnabledPageTags(params) {
        const { pageTagIsEnabledStatus, isPPCSite, isRetentionMemberFromSource } = params;
        const guidedHelpPageTag = pageTagIsEnabledStatus.find(page => page.pageTag === PageTags.GUIDED_HELP_GETTING_STARTED);
        const isGuidedHealthEnabled = guidedHelpPageTag?.enabled ?? false;
        return pageTagIsEnabledStatus.filter(page => {
            if (!isGuidedHealthEnabled && page.pageTag?.startsWith(this.guidedHelpPageTagPrefix)) {
                return false;
            }
            if (page.pageTag === PageTags.SOA && !isPPCSite) {
                return false;
            }
            if (page.pageTag === PageTags.RETENTION_SUMMARY) {
                return page.enabled && isRetentionMemberFromSource;
            }
            return page.enabled;
        });
    }
}
ProfileNavigationBarComponent.ɵfac = function ProfileNavigationBarComponent_Factory(t) { return new (t || ProfileNavigationBarComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.UnsavedModalContext), i0.ɵɵdirectiveInject(i1.AgentPermissionsService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(ProfileFacade), i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(PlanListContextService), i0.ɵɵdirectiveInject(i1.ShoppingRecordingContextService), i0.ɵɵdirectiveInject(i1.TwilioDeviceService), i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(i1.DeactivationGuardService), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(i1.ExternalErrorLoggingService), i0.ɵɵdirectiveInject(AgentSearchFacade), i0.ɵɵdirectiveInject(i0.Injector)); };
ProfileNavigationBarComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProfileNavigationBarComponent, selectors: [["vnext-profile-navigation-bar"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 9, vars: 15, consts: [["id", "profileNavBarContainer"], [1, "pr-md-4"], [1, "row", "flex-column", "justify-content-sm-end", "flex-sm-row"], [4, "ngIf"], [3, "headerMenuLinkText", "iconClass", "dropdownLinks", "popoverClickEvent"], [3, "lockDownAgentCreate", "profileNavBarNewProfileLinkText", "profileDropdownLinks", "isAdminAgent", "popoverClickEvent", "redirectToNewBeneficiary"], [1, "col", "col-sm-auto", "profile-nav-link", "pl-4", "pl-sm-2", "pl-md-2"], [3, "links", "noMemberInSessionText", "memberName", "isTransferCodeEnabled", "transferCodeLabelText", "transferCode", "pageTagSelected"]], template: function ProfileNavigationBarComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, ProfileNavigationBarComponent_ng_container_3_Template, 2, 3, "ng-container", 3);
        i0.ɵɵtemplate(4, ProfileNavigationBarComponent_ng_container_4_Template, 2, 3, "ng-container", 3);
        i0.ɵɵelementStart(5, "vnext-profile-popover", 4);
        i0.ɵɵlistener("popoverClickEvent", function ProfileNavigationBarComponent_Template_vnext_profile_popover_popoverClickEvent_5_listener($event) { return ctx.navigateByPageTag($event, true); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "vnext-profile-navigation-agent-item", 5);
        i0.ɵɵlistener("popoverClickEvent", function ProfileNavigationBarComponent_Template_vnext_profile_navigation_agent_item_popoverClickEvent_6_listener($event) { return ctx.navigateByPageTag($event, true); })("redirectToNewBeneficiary", function ProfileNavigationBarComponent_Template_vnext_profile_navigation_agent_item_redirectToNewBeneficiary_6_listener() { return ctx.goToNewBeneficiary(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 6)(8, "vnext-profile-navbar-dropdown", 7);
        i0.ɵɵlistener("pageTagSelected", function ProfileNavigationBarComponent_Template_vnext_profile_navbar_dropdown_pageTagSelected_8_listener($event) { return ctx.navigateByPageTag($event); });
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.Spa_Site_AgentDashboard_Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_ProfileNavBar_ShowPlanList_Flag);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("headerMenuLinkText", ctx.Spa_ProfileNavBar_ShowPlanList_Flag ? ctx.Spa_ProfileNavBar_SearchProfileLinkShortText : ctx.Spa_ProfileNavBar_SearchProfileLinkText)("iconClass", ctx.iconClassNames.SEARCH_ICON)("dropdownLinks", ctx.searchDropdownLinks);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("lockDownAgentCreate", ctx.Spa_Agent_Create_Lock_Down)("profileNavBarNewProfileLinkText", ctx.Spa_ProfileNavBar_NewProfileLinkText)("profileDropdownLinks", ctx.profileDropdownLinks)("isAdminAgent", ctx.isAdminAgent);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("links", ctx.enabledLinks)("noMemberInSessionText", ctx.Spa_ProfileNavBar_NoMemberInSessionText)("memberName", ctx.memberName)("isTransferCodeEnabled", ctx.Spa_Site_TransferCode_Enabled)("transferCodeLabelText", ctx.Spa_Site_TransferCode_Label_Text)("transferCode", ctx.transferCode);
    } }, dependencies: [i1$2.NgIf, PopoverComponent, ProfileNavigationAgentItemComponent, ProfileNavbarDropdownComponent], styles: [".profile-nav-link[_ngcontent-%COMP%]{border-left:1px solid var(--static-Spa_Style_Gray2);padding:.5rem;display:flex;align-items:center}.profile-nav-link[_ngcontent-%COMP%]:last-of-type{border-right:1px solid var(--static-Spa_Style_Gray2)}@media (max-width: 767px){#profileNavBarContainer[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]{padding-left:15px;padding-right:15px}.profile-nav-link[_ngcontent-%COMP%]{border-left:none;border-right:none;border-bottom:1px solid var(--static-Spa_Style_Gray2);padding-left:.25rem}.profile-nav-link[_ngcontent-%COMP%]:last-of-type{border:none}}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavBar_NoMemberInSessionText", void 0);
__decorate([
    GlobalResource()
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavBar_SearchProfileLinkText", void 0);
__decorate([
    GlobalResource()
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavBar_SearchProfileLinkShortText", void 0);
__decorate([
    GlobalResource()
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavBar_NewProfileLinkText", void 0);
__decorate([
    GlobalResource(true)
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavDropdown_ProfileLinkText", void 0);
__decorate([
    GlobalResource(true)
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavDropdown_SOALinkText", void 0);
__decorate([
    GlobalResource(true)
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavDropdown_PreferencesLinkText", void 0);
__decorate([
    GlobalResource(true)
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavDropdown_HealthLinkText", void 0);
__decorate([
    GlobalResource(true)
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavDropdown_PrescriptionsLinkText", void 0);
__decorate([
    GlobalResource(true)
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavDropdown_PharmacyLinkText", void 0);
__decorate([
    GlobalResource(true)
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavDropdown_PlansLinkText", void 0);
__decorate([
    GlobalResource(true)
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavDropdown_CartLinkText", void 0);
__decorate([
    GlobalResource(true)
], ProfileNavigationBarComponent.prototype, "Spa_Site_OtherPreferences_Text", void 0);
__decorate([
    GlobalResource()
], ProfileNavigationBarComponent.prototype, "Spa_Site_SiteType", void 0);
__decorate([
    GlobalResource(true)
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavBar_DropdownLinks", void 0);
__decorate([
    GlobalResource()
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavBar_ShowPlanList_Flag", void 0);
__decorate([
    GlobalResource()
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavBar_BrowsePlans_Text", void 0);
__decorate([
    GlobalResource()
], ProfileNavigationBarComponent.prototype, "Spa_Site_AgentDashboard_Enabled", void 0);
__decorate([
    GlobalResource(true)
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavBar_AgentDashboard_Text", void 0);
__decorate([
    GlobalResource(true)
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavDropdown_NewBeneficiary_LinkText", void 0);
__decorate([
    GlobalResource(true)
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavDropdown_NewAgent_LinkText", void 0);
__decorate([
    GlobalResource(true)
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavDropdown_SearchBeneficiary_LinkText", void 0);
__decorate([
    GlobalResource(true)
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavDropdown_SearchAgent_LinkText", void 0);
__decorate([
    GlobalResource(true)
], ProfileNavigationBarComponent.prototype, "Spa_Agent_Create_Account_Enabled", void 0);
__decorate([
    GlobalResource()
], ProfileNavigationBarComponent.prototype, "Spa_Agent_Create_Lock_Down", void 0);
__decorate([
    GlobalResource()
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavDropdown_ProvidersLinkText", void 0);
__decorate([
    GlobalResource()
], ProfileNavigationBarComponent.prototype, "Spa_Site_TransferCode_Label_Text", void 0);
__decorate([
    GlobalResource()
], ProfileNavigationBarComponent.prototype, "Spa_Site_TransferCode_Enabled", void 0);
__decorate([
    GlobalResource(true)
], ProfileNavigationBarComponent.prototype, "Spa_ProfileNavDropdown_NewRetireFlo_LinkText", void 0);
__decorate([
    GlobalResource(true)
], ProfileNavigationBarComponent.prototype, "Spa_Agent_RetireFlo_NavDropdown_Enabled", void 0);
__decorate([
    GlobalResource()
], ProfileNavigationBarComponent.prototype, "Spa_RetireFlo_NewIntake_Header_Text", void 0);
__decorate([
    GlobalResource()
], ProfileNavigationBarComponent.prototype, "Spa_RetireFlo_NewIntake_Description_Text", void 0);
__decorate([
    GlobalResource()
], ProfileNavigationBarComponent.prototype, "Spa_RetireFlo_NewIntake_CustomMessage_Description_Text", void 0);
__decorate([
    GlobalResource()
], ProfileNavigationBarComponent.prototype, "Spa_RetireFlo_NewIntake_CustomMessage_Default_Text", void 0);
__decorate([
    Memoize()
], ProfileNavigationBarComponent.prototype, "getEnabledPageTags", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProfileNavigationBarComponent, [{
        type: Component,
        args: [{ selector: 'vnext-profile-navigation-bar', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div id=\"profileNavBarContainer\">\r\n  <div class=\"pr-md-4\">\r\n    <div class=\"row flex-column justify-content-sm-end flex-sm-row\">\r\n      <ng-container *ngIf=\"Spa_Site_AgentDashboard_Enabled\">\r\n        <vnext-profile-popover\r\n          [headerMenuLinkText]=\"Spa_ProfileNavBar_AgentDashboard_Text\"\r\n          [iconClass]=\"iconClassNames.DASHBOARD_ICON\"\r\n          [dropdownLinks]=\"dashboardLinks\"\r\n          (popoverClickEvent)=\"navigateByPageTag($event, true)\"\r\n        ></vnext-profile-popover>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"Spa_ProfileNavBar_ShowPlanList_Flag\">\r\n        <vnext-profile-popover\r\n          [headerMenuLinkText]=\"Spa_ProfileNavBar_BrowsePlans_Text\"\r\n          [iconClass]=\"iconClassNames.PLANS_ICON\"\r\n          [dropdownLinks]=\"browsePlansLinks\"\r\n          (popoverClickEvent)=\"navigateByPageTag($event, true)\"\r\n        ></vnext-profile-popover>\r\n      </ng-container>\r\n      <vnext-profile-popover\r\n        [headerMenuLinkText]=\"\r\n          Spa_ProfileNavBar_ShowPlanList_Flag ? Spa_ProfileNavBar_SearchProfileLinkShortText : Spa_ProfileNavBar_SearchProfileLinkText\r\n        \"\r\n        [iconClass]=\"iconClassNames.SEARCH_ICON\"\r\n        [dropdownLinks]=\"searchDropdownLinks\"\r\n        (popoverClickEvent)=\"navigateByPageTag($event, true)\"\r\n      ></vnext-profile-popover>\r\n\r\n      <vnext-profile-navigation-agent-item\r\n        [lockDownAgentCreate]=\"Spa_Agent_Create_Lock_Down\"\r\n        [profileNavBarNewProfileLinkText]=\"Spa_ProfileNavBar_NewProfileLinkText\"\r\n        [profileDropdownLinks]=\"profileDropdownLinks\"\r\n        [isAdminAgent]=\"isAdminAgent\"\r\n        (popoverClickEvent)=\"navigateByPageTag($event, true)\"\r\n        (redirectToNewBeneficiary)=\"goToNewBeneficiary()\"\r\n      >\r\n      </vnext-profile-navigation-agent-item>\r\n      <div class=\"col col-sm-auto profile-nav-link pl-4 pl-sm-2 pl-md-2\">\r\n        <vnext-profile-navbar-dropdown\r\n          [links]=\"enabledLinks\"\r\n          [noMemberInSessionText]=\"Spa_ProfileNavBar_NoMemberInSessionText\"\r\n          [memberName]=\"memberName\"\r\n          [isTransferCodeEnabled]=\"Spa_Site_TransferCode_Enabled\"\r\n          [transferCodeLabelText]=\"Spa_Site_TransferCode_Label_Text\"\r\n          [transferCode]=\"transferCode\"\r\n          (pageTagSelected)=\"navigateByPageTag($event)\"\r\n        ></vnext-profile-navbar-dropdown>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".profile-nav-link{border-left:1px solid var(--static-Spa_Style_Gray2);padding:.5rem;display:flex;align-items:center}.profile-nav-link:last-of-type{border-right:1px solid var(--static-Spa_Style_Gray2)}@media (max-width: 767px){#profileNavBarContainer .container{padding-left:15px;padding-right:15px}.profile-nav-link{border-left:none;border-right:none;border-bottom:1px solid var(--static-Spa_Style_Gray2);padding-left:.25rem}.profile-nav-link:last-of-type{border:none}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.UnsavedModalContext }, { type: i1.AgentPermissionsService }, { type: i1.ConfigResourceService }, { type: i1.NavigationService }, { type: ProfileFacade }, { type: i1.GuidedHelpService }, { type: i1.MemberSessionService }, { type: i2.Store }, { type: i1.SiteService }, { type: PlanListContextService }, { type: i1.ShoppingRecordingContextService }, { type: i1.TwilioDeviceService }, { type: i1.AgentService }, { type: i1.DeactivationGuardService }, { type: i1$1.NgbModal }, { type: i1.ExternalErrorLoggingService }, { type: AgentSearchFacade }, { type: i0.Injector }]; }, { Spa_ProfileNavBar_NoMemberInSessionText: [], Spa_ProfileNavBar_SearchProfileLinkText: [], Spa_ProfileNavBar_SearchProfileLinkShortText: [], Spa_ProfileNavBar_NewProfileLinkText: [], Spa_ProfileNavDropdown_ProfileLinkText: [], Spa_ProfileNavDropdown_SOALinkText: [], Spa_ProfileNavDropdown_PreferencesLinkText: [], Spa_ProfileNavDropdown_HealthLinkText: [], Spa_ProfileNavDropdown_PrescriptionsLinkText: [], Spa_ProfileNavDropdown_PharmacyLinkText: [], Spa_ProfileNavDropdown_PlansLinkText: [], Spa_ProfileNavDropdown_CartLinkText: [], Spa_Site_OtherPreferences_Text: [], Spa_Site_SiteType: [], Spa_ProfileNavBar_DropdownLinks: [], Spa_ProfileNavBar_ShowPlanList_Flag: [], Spa_ProfileNavBar_BrowsePlans_Text: [], Spa_Site_AgentDashboard_Enabled: [], Spa_ProfileNavBar_AgentDashboard_Text: [], Spa_ProfileNavDropdown_NewBeneficiary_LinkText: [], Spa_ProfileNavDropdown_NewAgent_LinkText: [], Spa_ProfileNavDropdown_SearchBeneficiary_LinkText: [], Spa_ProfileNavDropdown_SearchAgent_LinkText: [], Spa_Agent_Create_Account_Enabled: [], Spa_Agent_Create_Lock_Down: [], Spa_ProfileNavDropdown_ProvidersLinkText: [], Spa_Site_TransferCode_Label_Text: [], Spa_Site_TransferCode_Enabled: [], Spa_ProfileNavDropdown_NewRetireFlo_LinkText: [], Spa_Agent_RetireFlo_NavDropdown_Enabled: [], Spa_RetireFlo_NewIntake_Header_Text: [], Spa_RetireFlo_NewIntake_Description_Text: [], Spa_RetireFlo_NewIntake_CustomMessage_Description_Text: [], Spa_RetireFlo_NewIntake_CustomMessage_Default_Text: [], getEnabledPageTags: [] }); })();

const _c0$34 = ["rightSidePanel"];
function TalkingPointSideNavComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r1.content, "html"), i0.ɵɵsanitizeHtml);
} }
const _c1$1B = function (a0, a1) { return { "fa-angle-right": a0, "fa-angle-left": a1 }; };
class TalkingPointSideNavComponent {
    constructor(analyticsService, router, cdr) {
        this.analyticsService = analyticsService;
        this.router = router;
        this.cdr = cdr;
        this.dropdownItems = [];
        this.talkingPointControl = new UntypedFormControl('');
        this.startX = 0;
        this.startWidth = 0;
        this.isResizing = false;
        this.defaultTalkingPointWidth = 315;
        this.defaultRightSpacing = 0;
        this.subscriptions = new Subscription();
    }
    ngOnChanges(changes) {
        const { talkingPoints, currentPath } = changes;
        if ((talkingPoints && !_isEqual(talkingPoints.previousValue, talkingPoints.currentValue)) ||
            (currentPath && currentPath.previousValue !== currentPath.currentValue)) {
            this.updateDropdownItems();
        }
    }
    ngOnInit() {
        this.subscriptions.add(this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe({
            next: () => {
                this.adjustWidth(this.defaultTalkingPointWidth);
            },
            error: error => {
                console.error(error);
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    ngAfterViewChecked() {
        this.adjustWidth(this.defaultTalkingPointWidth);
    }
    onResize(event) {
        if (this.isResizing) {
            const newWidth = this.startWidth - (event.clientX - this.startX);
            this.setWidth(newWidth);
            this.adjustWidth(newWidth);
        }
    }
    stopResize() {
        this.isResizing = false;
    }
    selectTalkingPoint(event) {
        this.content = this.getContent(event.selectionValue);
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_TALKING_POINTS,
            [DataLayerGlobalVariable.TALKING_POINTS_SELECTION]: event.displayValue ?? GOOGLE_ANALYTICS_NOT_APPLICABLE
        };
    }
    getContent(talkingPoint) {
        if (talkingPoint?.pages?.length) {
            const isEnrollmentPage = talkingPoint.documentType === TalkingPointPageType.ENROLLMENT;
            return isEnrollmentPage
                ? talkingPoint?.pages[0].content || ''
                : talkingPoint?.pages?.find(page => page.pageFullName === this.currentPath)?.content || '';
        }
        return '';
    }
    togglePanel() {
        this.isSideNavOpen = !this.isSideNavOpen;
        if (this.isSideNavOpen) {
            this.adjustWidth(this.defaultTalkingPointWidth);
        }
        else {
            this.adjustWidth(0);
            this.setWidth(this.defaultTalkingPointWidth - this.defaultRightSpacing);
        }
    }
    adjustWidth(newWidth) {
        const childElement = document.getElementById('templateContainer');
        if (childElement) {
            if (newWidth > 0 && this.isSideNavOpen) {
                let screenWidth = window.innerWidth;
                if (this.defaultTalkingPointWidth >= newWidth) {
                    screenWidth = screenWidth - this.defaultTalkingPointWidth;
                }
                else {
                    screenWidth = screenWidth - (newWidth + this.defaultRightSpacing);
                }
                childElement.style.width = screenWidth + 'px';
            }
            else {
                childElement.style.width = '100%';
            }
        }
        this.cdr.detectChanges();
    }
    startResize(event) {
        this.startX = event.clientX;
        this.startWidth = this.getWidth();
        this.isResizing = true;
    }
    getWidth() {
        return this.rightSidePanel.nativeElement.offsetWidth;
    }
    setWidth(width) {
        this.rightSidePanel.nativeElement.style.width = width + 'px';
    }
    updateDropdownItems() {
        this.dropdownItems =
            this.talkingPoints?.map(pointItem => ({
                displayValue: pointItem.name,
                selectionValue: pointItem
            })) ?? [];
        const defaultOption = this.talkingPoints?.find(point => point.isDefault);
        if (defaultOption?.name) {
            this.talkingPointControl.setValue(defaultOption);
            if (this.currentPath) {
                this.content = this.getContent(defaultOption);
            }
        }
    }
}
TalkingPointSideNavComponent.ɵfac = function TalkingPointSideNavComponent_Factory(t) { return new (t || TalkingPointSideNavComponent)(i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
TalkingPointSideNavComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TalkingPointSideNavComponent, selectors: [["vnext-talking-point-sidenav"]], viewQuery: function TalkingPointSideNavComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$34, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rightSidePanel = _t.first);
    } }, hostBindings: function TalkingPointSideNavComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("mousemove", function TalkingPointSideNavComponent_mousemove_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveDocument)("mouseup", function TalkingPointSideNavComponent_mouseup_HostBindingHandler() { return ctx.stopResize(); }, false, i0.ɵɵresolveDocument);
    } }, inputs: { talkingPointsTitle: "talkingPointsTitle", dropdownDefaultText: "dropdownDefaultText", talkingPoints: "talkingPoints", currentPath: "currentPath", isSideNavOpen: "isSideNavOpen" }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵNgOnChangesFeature], decls: 11, vars: 14, consts: [[1, "right-side-panel"], ["rightSidePanel", ""], [1, "resize-handle", 3, "mousedown"], [1, "btn-align"], [1, "btn-arrow", 3, "click"], [1, "pl-1", "fa", 3, "ngClass"], [1, "sr-only"], [3, "control", "dropdownLabel", "dropdownItems", "isRequired", "customClass", "dropdownDefaultText", "disabled", "selectDropdownItem"], ["class", "points-content", 3, "innerHTML", 4, "ngIf"], [1, "points-content", 3, "innerHTML"]], template: function TalkingPointSideNavComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0, 1)(2, "div", 2);
        i0.ɵɵlistener("mousedown", function TalkingPointSideNavComponent_Template_div_mousedown_2_listener($event) { return ctx.startResize($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3)(4, "button", 4);
        i0.ɵɵlistener("click", function TalkingPointSideNavComponent_Template_button_click_4_listener() { return ctx.togglePanel(); });
        i0.ɵɵelement(5, "i", 5);
        i0.ɵɵelementStart(6, "span", 6);
        i0.ɵɵtext(7, "Show/hide panel");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(8, "div")(9, "vnext-dropdown-button", 7);
        i0.ɵɵlistener("selectDropdownItem", function TalkingPointSideNavComponent_Template_vnext_dropdown_button_selectDropdownItem_9_listener($event) { return ctx.selectTalkingPoint($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, TalkingPointSideNavComponent_div_10_Template, 2, 4, "div", 8);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵclassProp("open", ctx.isSideNavOpen);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c1$1B, ctx.isSideNavOpen, !ctx.isSideNavOpen));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("control", ctx.talkingPointControl)("dropdownLabel", ctx.talkingPointsTitle)("dropdownItems", ctx.dropdownItems)("isRequired", false)("customClass", "Spa_Style_Small_Font Spa_Style_Primary_Color")("dropdownDefaultText", ctx.dropdownItems.length > 0 ? "" : ctx.dropdownDefaultText)("disabled", ctx.dropdownItems.length === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.content);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, DropdownButtonComponent, IconAriaAttributesDirective, SafePipe], styles: [".right-side-panel[_ngcontent-%COMP%]{position:fixed;top:0;right:-300px;height:102vh;min-width:300px;background-color:#f5f5f5;box-shadow:4px 0 5px #00000080;border:1px solid #adadad;z-index:1050;overflow-y:auto;transition:right .3s;padding:15px;resize:horizontal;scrollbar-width:thin}.right-side-panel.open[_ngcontent-%COMP%]{right:0}.btn-align[_ngcontent-%COMP%]{position:inherit;margin-top:50vh}.points-content[_ngcontent-%COMP%]{position:absolute;margin-top:20px}.btn-arrow[_ngcontent-%COMP%]{position:absolute;top:10px;right:15px;padding:12px 3px;border-radius:5px 0 0 5px;border:1px solid #adadad}.content-width[_ngcontent-%COMP%]{width:calc(100% - 300px)}.resize-handle[_ngcontent-%COMP%]{position:absolute;top:0;left:-5px;width:10px;height:100%;cursor:ew-resize}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TalkingPointSideNavComponent, [{
        type: Component,
        args: [{ selector: 'vnext-talking-point-sidenav', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"right-side-panel\" [class.open]=\"isSideNavOpen\" #rightSidePanel>\r\n  <div class=\"resize-handle\" (mousedown)=\"startResize($event)\"></div>\r\n  <div class=\"btn-align\">\r\n    <button class=\"btn-arrow\" (click)=\"togglePanel()\">\r\n      <i class=\"pl-1 fa\" [ngClass]=\"{ 'fa-angle-right': isSideNavOpen, 'fa-angle-left': !isSideNavOpen }\"></i>\r\n      <span class=\"sr-only\">Show/hide panel</span>\r\n    </button>\r\n  </div>\r\n  <div>\r\n    <vnext-dropdown-button\r\n      [control]=\"talkingPointControl\"\r\n      [dropdownLabel]=\"talkingPointsTitle\"\r\n      [dropdownItems]=\"dropdownItems\"\r\n      [isRequired]=\"false\"\r\n      [customClass]=\"'Spa_Style_Small_Font Spa_Style_Primary_Color'\"\r\n      [dropdownDefaultText]=\"dropdownItems.length > 0 ? '' : dropdownDefaultText\"\r\n      [disabled]=\"dropdownItems.length === 0\"\r\n      (selectDropdownItem)=\"selectTalkingPoint($event)\"\r\n    ></vnext-dropdown-button>\r\n    <div *ngIf=\"content\" class=\"points-content\"[innerHTML]=\"content | safe : 'html'\"></div>\r\n  </div>\r\n</div>\r\n", styles: [".right-side-panel{position:fixed;top:0;right:-300px;height:102vh;min-width:300px;background-color:#f5f5f5;box-shadow:4px 0 5px #00000080;border:1px solid #adadad;z-index:1050;overflow-y:auto;transition:right .3s;padding:15px;resize:horizontal;scrollbar-width:thin}.right-side-panel.open{right:0}.btn-align{position:inherit;margin-top:50vh}.points-content{position:absolute;margin-top:20px}.btn-arrow{position:absolute;top:10px;right:15px;padding:12px 3px;border-radius:5px 0 0 5px;border:1px solid #adadad}.content-width{width:calc(100% - 300px)}.resize-handle{position:absolute;top:0;left:-5px;width:10px;height:100%;cursor:ew-resize}\n"] }]
    }], function () { return [{ type: AnalyticsService }, { type: i2$1.Router }, { type: i0.ChangeDetectorRef }]; }, { rightSidePanel: [{
            type: ViewChild,
            args: ['rightSidePanel', { static: true }]
        }], talkingPointsTitle: [{
            type: Input
        }], dropdownDefaultText: [{
            type: Input
        }], talkingPoints: [{
            type: Input
        }], currentPath: [{
            type: Input
        }], isSideNavOpen: [{
            type: Input
        }], onResize: [{
            type: HostListener,
            args: ['document:mousemove', ['$event']]
        }], stopResize: [{
            type: HostListener,
            args: ['document:mouseup']
        }] }); })();

class HeaderFacade {
    constructor(agentService) {
        this.agentService = agentService;
    }
    getAgentInContextGuid() {
        return this.agentService.getAgentInContextGuid();
    }
}
HeaderFacade.ɵfac = function HeaderFacade_Factory(t) { return new (t || HeaderFacade)(i0.ɵɵinject(i1.AgentService)); };
HeaderFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HeaderFacade, factory: HeaderFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.AgentService }]; }, null); })();

class MotionPointLocalePickerComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.MotionPoint_DomainUrl = 'localhost:4200';
        this.MotionPoint_LinkClass = 'Spa_Style_Link';
        this.MotionPoint_LinkText = 'Espanol';
        this.MotionPoint_Protocol = 'http';
        this.motionPointHref = '';
    }
    preProcessProperties() {
        this.motionPointHref = `${this.MotionPoint_Protocol}://${this.MotionPoint_DomainUrl}`;
    }
}
MotionPointLocalePickerComponent.ɵfac = function MotionPointLocalePickerComponent_Factory(t) { return new (t || MotionPointLocalePickerComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService)); };
MotionPointLocalePickerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MotionPointLocalePickerComponent, selectors: [["vnext-motionpoint-locale-picker"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 6, consts: [["data-lang", "es", "mporgnav", "", 3, "href"]], template: function MotionPointLocalePickerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "a", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassMapInterpolate1("langLink ", ctx.MotionPoint_LinkClass, "");
        i0.ɵɵproperty("href", ctx.motionPointHref, i0.ɵɵsanitizeUrl);
        i0.ɵɵattribute("data-href", ctx.motionPointHref);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.MotionPoint_LinkText);
    } }, encapsulation: 2, changeDetection: 0 });
__decorate([
    GlobalResource(true)
], MotionPointLocalePickerComponent.prototype, "MotionPoint_DomainUrl", void 0);
__decorate([
    GlobalResource()
], MotionPointLocalePickerComponent.prototype, "MotionPoint_LinkClass", void 0);
__decorate([
    GlobalResource()
], MotionPointLocalePickerComponent.prototype, "MotionPoint_LinkText", void 0);
__decorate([
    GlobalResource(true)
], MotionPointLocalePickerComponent.prototype, "MotionPoint_Protocol", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MotionPointLocalePickerComponent, [{
        type: Component,
        args: [{ selector: 'vnext-motionpoint-locale-picker', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<a class=\"langLink {{ MotionPoint_LinkClass }}\" [attr.data-href]=\"motionPointHref\" [href]=\"motionPointHref\" data-lang=\"es\" mporgnav=\"\">{{\r\n  MotionPoint_LinkText\r\n}}</a>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }]; }, { MotionPoint_DomainUrl: [], MotionPoint_LinkClass: [], MotionPoint_LinkText: [], MotionPoint_Protocol: [] }); })();

const _c0$33 = function (a0, a1) { return { "icon-hover": a0, "header": a1 }; };
const _c1$1A = function (a0) { return { "underline-title": a0 }; };
function SubHeaderActionComponent_vnext_link_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 5);
    i0.ɵɵlistener("click", function SubHeaderActionComponent_vnext_link_1_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.submitAction(ctx_r4.link)); });
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelement(2, "i", 7);
    i0.ɵɵelementStart(3, "span", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("customClass", "Spa_Style_Primary_Color focus-text")("alwaysUnderlined", false)("makeInlineBlock", true)("noUnderlineOnHover", true)("role", ctx_r0.linkRoles.BUTTON);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("", ctx_r0.link.iconName, " Spa_Style_Gray4_Color pr-1 Spa_Style_Smaller_Font");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c0$33, ctx_r0.hover && !ctx_r0.isFooter, !ctx_r0.isFooter));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c1$1A, ctx_r0.isFooter && ctx_r0.hover));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.link.title);
} }
function SubHeaderActionComponent_vnext_link_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-link", 9)(1, "div", 10);
    i0.ɵɵelement(2, "i", 7);
    i0.ɵɵelementStart(3, "span", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("makeInlineBlock", true)("alwaysUnderlined", false)("customClass", "Spa_Style_Primary_Color Spa_Style_Smaller_Font focus-text")("tag", ctx_r1.link.tag)("linkTarget", "_blank")("title", ctx_r1.link.title)("noUnderlineOnHover", true)("role", ctx_r1.linkRoles.BUTTON);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("", ctx_r1.link.iconName, " Spa_Style_Gray4_Color Spa_Style_Smaller_Font pr-1");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(14, _c0$33, ctx_r1.hover && !ctx_r1.isFooter, !ctx_r1.isFooter));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c1$1A, ctx_r1.isFooter && ctx_r1.hover));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.link.title, "");
} }
const _c2$_ = function (a0, a1, a2) { return { "icon-hover": a0, "header": a1, "underline-title": a2 }; };
function SubHeaderActionComponent_vnext_link_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-link", 11)(1, "div", 12);
    i0.ɵɵelement(2, "i", 7);
    i0.ɵɵelementStart(3, "span", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("makeInlineBlock", true)("alwaysUnderlined", false)("customClass", "Spa_Style_Primary_Color Spa_Style_Smaller_Font focus-text")("linkTarget", "_blank")("title", ctx_r2.link.title)("noUnderlineOnHover", true)("role", ctx_r2.linkRoles.BUTTON);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("", ctx_r2.link.iconName, " Spa_Style_Gray4_Color Spa_Style_Smaller_Font pr-1");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(13, _c2$_, ctx_r2.hover && !ctx_r2.isFooter, !ctx_r2.isFooter, ctx_r2.isFooter && ctx_r2.hover));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c1$1A, ctx_r2.isFooter && ctx_r2.hover));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.link.title);
} }
function SubHeaderActionComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function SubHeaderActionComponent_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.submitAction(ctx_r6.link)); })("keyup.enter", function SubHeaderActionComponent_button_4_Template_button_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.submitAction(ctx_r8.link)); });
    i0.ɵɵelement(1, "i", 14);
    i0.ɵɵelementStart(2, "span", 8);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("", ctx_r3.link.iconName, " Spa_Style_Gray4_Color Spa_Style_Smaller_Font pr-1");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(6, _c2$_, ctx_r3.hover && !ctx_r3.isFooter, !ctx_r3.isFooter, ctx_r3.isFooter && ctx_r3.hover));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c1$1A, ctx_r3.isFooter && ctx_r3.hover));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.link.title);
} }
class SubHeaderActionComponent {
    constructor(widgetService, navigationUtilityService, profileFacade) {
        this.widgetService = widgetService;
        this.navigationUtilityService = navigationUtilityService;
        this.profileFacade = profileFacade;
        this.hover = false;
        this.linkRoles = LinkRoles;
        this.defaultAction = (link) => {
            if (link.action === SubHeaderActions.CONTACT) {
                this.profileFacade.openModal();
            }
            else {
                this.navigationUtilityService.openLinkInNewWindow(link);
            }
        };
    }
    get isFooter() {
        return this.widgetService.widgetName === 'dynamicfooter';
    }
    ngOnInit() {
        if (!this.submitAction) {
            this.submitAction = this.defaultAction;
        }
    }
}
SubHeaderActionComponent.ɵfac = function SubHeaderActionComponent_Factory(t) { return new (t || SubHeaderActionComponent)(i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(ProfileFacade)); };
SubHeaderActionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SubHeaderActionComponent, selectors: [["vnext-sub-header-action"]], inputs: { link: "link", submitAction: "submitAction" }, decls: 5, vars: 4, consts: [[3, "mouseover", "mouseleave"], [3, "customClass", "alwaysUnderlined", "makeInlineBlock", "noUnderlineOnHover", "role", "click", 4, "ngIf"], [3, "makeInlineBlock", "alwaysUnderlined", "customClass", "tag", "linkTarget", "title", "noUnderlineOnHover", "role", 4, "ngIf"], [3, "makeInlineBlock", "alwaysUnderlined", "customClass", "linkTarget", "title", "noUnderlineOnHover", "role", 4, "ngIf"], ["class", "d-inline action-button Spa_Style_Primary_Color Spa_Style_Smaller_Font", "tabindex", "0", 3, "click", "keyup.enter", 4, "ngIf"], [3, "customClass", "alwaysUnderlined", "makeInlineBlock", "noUnderlineOnHover", "role", "click"], ["link-body", ""], ["aria-hidden", "true", 3, "ngClass"], [1, "Spa_Style_Primary_Color", "Spa_Style_Smaller_Font", 3, "ngClass"], [3, "makeInlineBlock", "alwaysUnderlined", "customClass", "tag", "linkTarget", "title", "noUnderlineOnHover", "role"], ["tag-image-body", ""], [3, "makeInlineBlock", "alwaysUnderlined", "customClass", "linkTarget", "title", "noUnderlineOnHover", "role"], ["link-body", "", 1, "can-click"], ["tabindex", "0", 1, "d-inline", "action-button", "Spa_Style_Primary_Color", "Spa_Style_Smaller_Font", 3, "click", "keyup.enter"], [3, "ngClass"]], template: function SubHeaderActionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("mouseover", function SubHeaderActionComponent_Template_div_mouseover_0_listener() { return ctx.hover = true; })("mouseleave", function SubHeaderActionComponent_Template_div_mouseleave_0_listener() { return ctx.hover = false; });
        i0.ɵɵtemplate(1, SubHeaderActionComponent_vnext_link_1_Template, 5, 16, "vnext-link", 1);
        i0.ɵɵtemplate(2, SubHeaderActionComponent_vnext_link_2_Template, 5, 19, "vnext-link", 2);
        i0.ɵɵtemplate(3, SubHeaderActionComponent_vnext_link_3_Template, 5, 19, "vnext-link", 3);
        i0.ɵɵtemplate(4, SubHeaderActionComponent_button_4_Template, 4, 12, "button", 4);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.link.href);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.link.tag);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.link.tag && !ctx.link.href && !ctx.link.action);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.link.tag && !ctx.link.href && ctx.link.action);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, LinkComponent], styles: [".margin-link[_ngcontent-%COMP%]:last-child{padding-right:0}.margin-link.first[_ngcontent-%COMP%]{border-left:none}.margin-link[_ngcontent-%COMP%]{padding-left:10px}.sub-header-container-footer[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:center;padding:8px}.sub-header-container-header[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:center}.header-icon[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent1)}.header-icon-hover[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Gray4)}.header-icon-selected[_ngcontent-%COMP%]{font-weight:700}.underline-title[_ngcontent-%COMP%]{text-decoration:underline}.plan-year-badge[_ngcontent-%COMP%]{margin-top:3px}@media (max-width: 768px){.sub-header-container-footer[_ngcontent-%COMP%]{flex-direction:column;justify-content:flex-end;align-items:flex-end}.sub-header-container-footer[_ngcontent-%COMP%]   .margin-link[_ngcontent-%COMP%]{border-left:none;padding-left:15px}.container[_ngcontent-%COMP%]{padding:0 20px 0 0}.margin-link[_ngcontent-%COMP%]{min-height:0px;padding-left:4px;padding-right:4px}}@media (max-width: 767.9px){.margin-link[_ngcontent-%COMP%]{min-height:44px}}", ".header[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent1)}.icon-hover[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Gray4)}.underline-title[_ngcontent-%COMP%]{text-decoration:underline}.action-button[_ngcontent-%COMP%]{box-shadow:none;border:0;background:transparent;padding:0}.action-button[_ngcontent-%COMP%]:focus{padding:2px;margin:-2px;border-radius:5px;box-shadow:0 0 5px var(--static-Spa_Style_Black)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubHeaderActionComponent, [{
        type: Component,
        args: [{ selector: 'vnext-sub-header-action', template: "<div (mouseover)=\"hover = true\" (mouseleave)=\"hover = false\">\r\n  <vnext-link\r\n    *ngIf=\"link.href\"\r\n    (click)=\"submitAction(link)\"\r\n    [customClass]=\"'Spa_Style_Primary_Color focus-text'\"\r\n    [alwaysUnderlined]=\"false\"\r\n    [makeInlineBlock]=\"true\"\r\n    [noUnderlineOnHover]=\"true\"\r\n    [role]=\"linkRoles.BUTTON\"\r\n  >\r\n    <div link-body>\r\n      <i\r\n        class=\"{{ link.iconName }} Spa_Style_Gray4_Color pr-1 Spa_Style_Smaller_Font\"\r\n        [ngClass]=\"{ 'icon-hover': hover && !isFooter, 'header': !isFooter }\"\r\n        aria-hidden=\"true\"\r\n      ></i>\r\n      <span [ngClass]=\"{ 'underline-title': isFooter && hover }\" class=\"Spa_Style_Primary_Color Spa_Style_Smaller_Font\">{{\r\n        link.title\r\n      }}</span>\r\n    </div>\r\n  </vnext-link>\r\n\r\n  <vnext-link\r\n    [makeInlineBlock]=\"true\"\r\n    [alwaysUnderlined]=\"false\"\r\n    *ngIf=\"link.tag\"\r\n    [customClass]=\"'Spa_Style_Primary_Color Spa_Style_Smaller_Font focus-text'\"\r\n    [tag]=\"link.tag\"\r\n    [linkTarget]=\"'_blank'\"\r\n    [title]=\"link.title\"\r\n    [noUnderlineOnHover]=\"true\"\r\n    [role]=\"linkRoles.BUTTON\"\r\n  >\r\n    <div tag-image-body>\r\n      <i\r\n        class=\"{{ link.iconName }} Spa_Style_Gray4_Color Spa_Style_Smaller_Font pr-1\"\r\n        [ngClass]=\"{ 'icon-hover': hover && !isFooter, 'header': !isFooter }\"\r\n        aria-hidden=\"true\"\r\n      ></i>\r\n      <span [ngClass]=\"{ 'underline-title': isFooter && hover }\" class=\"Spa_Style_Primary_Color Spa_Style_Smaller_Font\">\r\n        {{ link.title }}</span\r\n      >\r\n    </div>\r\n  </vnext-link>\r\n\r\n  <vnext-link\r\n    [makeInlineBlock]=\"true\"\r\n    [alwaysUnderlined]=\"false\"\r\n    *ngIf=\"!link.tag && !link.href && !link.action\"\r\n    [customClass]=\"'Spa_Style_Primary_Color Spa_Style_Smaller_Font focus-text'\"\r\n    [linkTarget]=\"'_blank'\"\r\n    [title]=\"link.title\"\r\n    [noUnderlineOnHover]=\"true\"\r\n    [role]=\"linkRoles.BUTTON\"\r\n  >\r\n    <div link-body class=\"can-click\">\r\n      <i\r\n        class=\"{{ link.iconName }} Spa_Style_Gray4_Color Spa_Style_Smaller_Font pr-1\"\r\n        [ngClass]=\"{ 'icon-hover': hover && !isFooter, 'header': !isFooter, 'underline-title': isFooter && hover }\"\r\n        aria-hidden=\"true\"\r\n      ></i>\r\n      <span [ngClass]=\"{ 'underline-title': isFooter && hover }\" class=\"Spa_Style_Primary_Color Spa_Style_Smaller_Font\">{{\r\n        link.title\r\n      }}</span>\r\n    </div>\r\n  </vnext-link>\r\n\r\n  <button\r\n    *ngIf=\"!link.tag && !link.href && link.action\"\r\n    class=\"d-inline action-button Spa_Style_Primary_Color Spa_Style_Smaller_Font\"\r\n    (click)=\"submitAction(link)\"\r\n    (keyup.enter)=\"submitAction(link)\"\r\n    tabindex=\"0\"\r\n  >\r\n    <i\r\n      class=\"{{ link.iconName }} Spa_Style_Gray4_Color Spa_Style_Smaller_Font pr-1\"\r\n      [ngClass]=\"{ 'icon-hover': hover && !isFooter, 'header': !isFooter, 'underline-title': isFooter && hover }\"\r\n    ></i>\r\n    <span [ngClass]=\"{ 'underline-title': isFooter && hover }\" class=\"Spa_Style_Primary_Color Spa_Style_Smaller_Font\">{{\r\n      link.title\r\n    }}</span>\r\n  </button>\r\n</div>\r\n", styles: [".margin-link:last-child{padding-right:0}.margin-link.first{border-left:none}.margin-link{padding-left:10px}.sub-header-container-footer{display:flex;justify-content:flex-end;align-items:center;padding:8px}.sub-header-container-header{display:flex;justify-content:flex-end;align-items:center}.header-icon{color:var(--static-Spa_Style_Accent1)}.header-icon-hover{color:var(--static-Spa_Style_Gray4)}.header-icon-selected{font-weight:700}.underline-title{text-decoration:underline}.plan-year-badge{margin-top:3px}@media (max-width: 768px){.sub-header-container-footer{flex-direction:column;justify-content:flex-end;align-items:flex-end}.sub-header-container-footer .margin-link{border-left:none;padding-left:15px}.container{padding:0 20px 0 0}.margin-link{min-height:0px;padding-left:4px;padding-right:4px}}@media (max-width: 767.9px){.margin-link{min-height:44px}}\n", ".header{color:var(--static-Spa_Style_Accent1)}.icon-hover{color:var(--static-Spa_Style_Gray4)}.underline-title{text-decoration:underline}.action-button{box-shadow:none;border:0;background:transparent;padding:0}.action-button:focus{padding:2px;margin:-2px;border-radius:5px;box-shadow:0 0 5px var(--static-Spa_Style_Black)}\n"] }]
    }], function () { return [{ type: WidgetService }, { type: i1.NavigationUtilityService }, { type: ProfileFacade }]; }, { link: [{
            type: Input
        }], submitAction: [{
            type: Input
        }] }); })();

const _c0$32 = function (a0, a1, a2) { return { "Spa_Style_Gray4_Color": a0, "header-icon": a1, "header-icon-hover": a2 }; };
function ContactUsComponent_button_0_i_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 4);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("", ctx_r2.link.iconName, " pr-1");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(4, _c0$32, ctx_r2.isFooter, !ctx_r2.isFooter, ctx_r2.hover && !ctx_r2.isFooter));
} }
const _c1$1z = function (a0) { return { "no-underline": a0 }; };
const _c2$Z = function (a0) { return { "underline-title": a0 }; };
function ContactUsComponent_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function ContactUsComponent_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.openModal()); })("mouseover", function ContactUsComponent_button_0_Template_button_mouseover_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onHover(true)); })("mouseleave", function ContactUsComponent_button_0_Template_button_mouseleave_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.onHover(false)); });
    i0.ɵɵtemplate(1, ContactUsComponent_button_0_i_1_Template, 1, 8, "i", 3);
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("Spa_Style_Primary_Color Spa_Style_Smaller_Font can-click action-button focus-text d-inline ", ctx_r0.customClass, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1$1z, ctx_r0.isHeader && !ctx_r0.alwaysUnderlined));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.link.iconName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c2$Z, ctx_r0.alwaysUnderlined || ctx_r0.isFooter && ctx_r0.hover));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.link.title);
} }
function ContactUsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("mouseover", function ContactUsComponent_div_1_Template_div_mouseover_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.onHover(true)); })("mouseleave", function ContactUsComponent_div_1_Template_div_mouseleave_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.onHover(false)); });
    i0.ɵɵelementStart(1, "span", 6);
    i0.ɵɵlistener("keyup.enter", function ContactUsComponent_div_1_Template_span_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.openModal()); })("click", function ContactUsComponent_div_1_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.openModal()); });
    i0.ɵɵelement(2, "i", 7);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.link.title, " ");
} }
class ContactUsComponent {
    constructor(cdr, widgetService, profileFacade, analyticsService) {
        this.cdr = cdr;
        this.widgetService = widgetService;
        this.profileFacade = profileFacade;
        this.analyticsService = analyticsService;
        this.headerDropdown = false;
        this.alwaysUnderlined = false;
        this.customClass = '';
        this.hover = false;
        this.isFooter = false;
        this.isHeader = false;
        this.dynamicHeaderLookupName = 'dynamicheader';
        this.dynamicFooterLookupName = 'dynamicfooter';
    }
    ngOnInit() {
        this.isHeader = this.widgetService.widgetName === this.dynamicHeaderLookupName;
        this.isFooter = this.widgetService.widgetName === this.dynamicFooterLookupName;
    }
    openModal() {
        this.profileFacade.openModal();
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_HEADER_CONTACT_US);
    }
    onHover(isMouseHover) {
        this.hover = isMouseHover;
        this.cdr.markForCheck();
    }
}
ContactUsComponent.ɵfac = function ContactUsComponent_Factory(t) { return new (t || ContactUsComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(ProfileFacade), i0.ɵɵdirectiveInject(AnalyticsService)); };
ContactUsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ContactUsComponent, selectors: [["vnext-contact-us"]], inputs: { link: "link", headerDropdown: "headerDropdown", alwaysUnderlined: "alwaysUnderlined", customClass: "customClass" }, decls: 2, vars: 2, consts: [["type", "button", 3, "class", "ngClass", "click", "mouseover", "mouseleave", 4, "ngIf"], ["class", "header-dropdown", 3, "mouseover", "mouseleave", 4, "ngIf"], ["type", "button", 3, "ngClass", "click", "mouseover", "mouseleave"], [3, "class", "ngClass", 4, "ngIf"], [3, "ngClass"], [1, "header-dropdown", 3, "mouseover", "mouseleave"], ["tabindex", "0", "role", "button", 1, "Spa_Style_Primary_Color", "Spa_Style_Smaller_Font", "can-click", 3, "keyup.enter", "click"], [1, "fas", "fa-phone", "pr-1", "header-icon", "Spa_Style_Smaller_Font"]], template: function ContactUsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ContactUsComponent_button_0_Template, 4, 11, "button", 0);
        i0.ɵɵtemplate(1, ContactUsComponent_div_1_Template, 4, 1, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.headerDropdown);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.headerDropdown);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, IconAriaAttributesDirective], styles: [".margin-link[_ngcontent-%COMP%]:last-child{padding-right:0}.margin-link.first[_ngcontent-%COMP%]{border-left:none}.margin-link[_ngcontent-%COMP%]{padding-left:10px}.sub-header-container-footer[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:center;padding:8px}.sub-header-container-header[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:center}.header-icon[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent1)}.header-icon-hover[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Gray4)}.header-icon-selected[_ngcontent-%COMP%]{font-weight:700}.underline-title[_ngcontent-%COMP%]{text-decoration:underline}.plan-year-badge[_ngcontent-%COMP%]{margin-top:3px}@media (max-width: 768px){.sub-header-container-footer[_ngcontent-%COMP%]{flex-direction:column;justify-content:flex-end;align-items:flex-end}.sub-header-container-footer[_ngcontent-%COMP%]   .margin-link[_ngcontent-%COMP%]{border-left:none;padding-left:15px}.container[_ngcontent-%COMP%]{padding:0 20px 0 0}.margin-link[_ngcontent-%COMP%]{min-height:0px;padding-left:4px;padding-right:4px}}@media (max-width: 767.9px){.margin-link[_ngcontent-%COMP%]{min-height:44px}}", "a[_ngcontent-%COMP%], a[_ngcontent-%COMP%]:hover{cursor:pointer;text-decoration:none}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], ContactUsComponent.prototype, "openModal", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContactUsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-contact-us', changeDetection: ChangeDetectionStrategy.OnPush, template: "<button\r\n  type=\"button\"\r\n  *ngIf=\"!headerDropdown\"\r\n  class=\"Spa_Style_Primary_Color Spa_Style_Smaller_Font can-click action-button focus-text d-inline {{ customClass }}\"\r\n  [ngClass]=\"{ 'no-underline': isHeader && !alwaysUnderlined }\"\r\n  (click)=\"openModal()\"\r\n  (mouseover)=\"onHover(true)\"\r\n  (mouseleave)=\"onHover(false)\"\r\n>\r\n  <i\r\n    *ngIf=\"link.iconName\"\r\n    class=\"{{ link.iconName }} pr-1\"\r\n    [ngClass]=\"{ 'Spa_Style_Gray4_Color': isFooter, 'header-icon': !isFooter, 'header-icon-hover': hover && !isFooter }\"\r\n  ></i\r\n  ><span [ngClass]=\"{ 'underline-title': alwaysUnderlined || (isFooter && hover) }\">{{ link.title }}</span>\r\n</button>\r\n<div *ngIf=\"headerDropdown\" class=\"header-dropdown\" (mouseover)=\"onHover(true)\" (mouseleave)=\"onHover(false)\">\r\n  <span\r\n    class=\"Spa_Style_Primary_Color Spa_Style_Smaller_Font can-click\"\r\n    tabindex=\"0\"\r\n    role=\"button\"\r\n    (keyup.enter)=\"openModal()\"\r\n    (click)=\"openModal()\"\r\n  >\r\n    <i class=\"fas fa-phone pr-1 header-icon Spa_Style_Smaller_Font\"></i>\r\n    {{ link.title }}\r\n  </span>\r\n</div>\r\n", styles: [".margin-link:last-child{padding-right:0}.margin-link.first{border-left:none}.margin-link{padding-left:10px}.sub-header-container-footer{display:flex;justify-content:flex-end;align-items:center;padding:8px}.sub-header-container-header{display:flex;justify-content:flex-end;align-items:center}.header-icon{color:var(--static-Spa_Style_Accent1)}.header-icon-hover{color:var(--static-Spa_Style_Gray4)}.header-icon-selected{font-weight:700}.underline-title{text-decoration:underline}.plan-year-badge{margin-top:3px}@media (max-width: 768px){.sub-header-container-footer{flex-direction:column;justify-content:flex-end;align-items:flex-end}.sub-header-container-footer .margin-link{border-left:none;padding-left:15px}.container{padding:0 20px 0 0}.margin-link{min-height:0px;padding-left:4px;padding-right:4px}}@media (max-width: 767.9px){.margin-link{min-height:44px}}\n", "a,a:hover{cursor:pointer;text-decoration:none}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: WidgetService }, { type: ProfileFacade }, { type: AnalyticsService }]; }, { link: [{
            type: Input
        }], headerDropdown: [{
            type: Input
        }], alwaysUnderlined: [{
            type: Input
        }], customClass: [{
            type: Input
        }], openModal: [] }); })();

class SaveProgressComponent {
    save() { }
}
SaveProgressComponent.ɵfac = function SaveProgressComponent_Factory(t) { return new (t || SaveProgressComponent)(); };
SaveProgressComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SaveProgressComponent, selectors: [["vnext-save-progress"]], inputs: { link: "link" }, decls: 3, vars: 5, consts: [["tabindex", "0", "role", "button", 1, "Spa_Style_Smaller_Font", "Spa_Style_Primary_Link_Color", "can-click", 3, "click", "keyup.enter"], ["aria-hidden", "true"]], template: function SaveProgressComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "span", 0);
        i0.ɵɵlistener("click", function SaveProgressComponent_Template_span_click_0_listener() { return ctx.save(); })("keyup.enter", function SaveProgressComponent_Template_span_keyup_enter_0_listener() { return ctx.save(); });
        i0.ɵɵelement(1, "i", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵattribute("aria-label", ctx.link.title);
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("", ctx.link.iconName, "  pr-1");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.link.title);
    } }, styles: ["span[_ngcontent-%COMP%]:hover{text-decoration:underline}"] });
__decorate([
    LiveEditInactive()
], SaveProgressComponent.prototype, "save", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SaveProgressComponent, [{
        type: Component,
        args: [{ selector: 'vnext-save-progress', template: "<span\r\n  (click)=\"save()\"\r\n  (keyup.enter)=\"save()\"\r\n  tabindex=\"0\"\r\n  role=\"button\"\r\n  class=\"Spa_Style_Smaller_Font Spa_Style_Primary_Link_Color can-click\"\r\n  [attr.aria-label]=\"link.title\"\r\n>\r\n  <i class=\"{{ link.iconName }}  pr-1\" aria-hidden=\"true\"></i>{{ link.title }}</span\r\n>\r\n", styles: ["span:hover{text-decoration:underline}\n"] }]
    }], null, { link: [{
            type: Input
        }], save: [] }); })();

class SkipToMainContentService {
    constructor() {
        this._setFocusToContent$ = new Subject();
        this._setFocusToMainContent$ = this._setFocusToContent$.asObservable();
    }
    setFocusToContent() {
        this._setFocusToContent$.next(null);
    }
}
SkipToMainContentService.ɵfac = function SkipToMainContentService_Factory(t) { return new (t || SkipToMainContentService)(); };
SkipToMainContentService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SkipToMainContentService, factory: SkipToMainContentService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SkipToMainContentService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

function FocusOnMainContentComponent_vnext_link_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 1);
    i0.ɵɵlistener("keyup.enter", function FocusOnMainContentComponent_vnext_link_0_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setFocusToMainContent()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r0.linkText)("role", ctx_r0.linkRoles.LINK)("ariaLabel", ctx_r0.linkText);
} }
class FocusOnMainContentComponent {
    constructor(skipToMainContentService, widgetService) {
        this.skipToMainContentService = skipToMainContentService;
        this.widgetService = widgetService;
        this.linkText = 'Skip to main content';
        this.linkRoles = LinkRoles;
    }
    setFocusToMainContent() {
        this.skipToMainContentService.setFocusToContent();
    }
    get isFooter() {
        return this.widgetService.widgetName === 'dynamicfooter';
    }
}
FocusOnMainContentComponent.ɵfac = function FocusOnMainContentComponent_Factory(t) { return new (t || FocusOnMainContentComponent)(i0.ɵɵdirectiveInject(SkipToMainContentService), i0.ɵɵdirectiveInject(WidgetService)); };
FocusOnMainContentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FocusOnMainContentComponent, selectors: [["vnext-focus-on-main-content"]], inputs: { linkText: "linkText" }, decls: 1, vars: 1, consts: [["class", "sr-only-link", 3, "title", "role", "ariaLabel", "keyup.enter", 4, "ngIf"], [1, "sr-only-link", 3, "title", "role", "ariaLabel", "keyup.enter"]], template: function FocusOnMainContentComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, FocusOnMainContentComponent_vnext_link_0_Template, 1, 3, "vnext-link", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.isFooter);
    } }, dependencies: [i1$2.NgIf, LinkComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FocusOnMainContentComponent, [{
        type: Component,
        args: [{ selector: 'vnext-focus-on-main-content', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-link\r\n  *ngIf=\"!isFooter\"\r\n  [title]=\"linkText\"\r\n  (keyup.enter)=\"setFocusToMainContent()\"\r\n  class=\"sr-only-link\"\r\n  [role]=\"linkRoles.LINK\"\r\n  [ariaLabel]=\"linkText\"\r\n></vnext-link>\r\n" }]
    }], function () { return [{ type: SkipToMainContentService }, { type: WidgetService }]; }, { linkText: [{
            type: Input
        }] }); })();

const _c0$31 = ["skipToContentElement"];
function SubHeaderComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵelement(2, "vnext-plan-year-badge", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("planYear", ctx_r1.planYear);
} }
function SubHeaderComponent_div_4_vnext_save_progress_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-save-progress", 14);
} if (rf & 2) {
    const link_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("link", link_r4);
} }
function SubHeaderComponent_div_4_ng_container_2_vnext_locale_picker_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-locale-picker", 17);
} if (rf & 2) {
    const link_r4 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵproperty("link", link_r4)("currentLanguageLabelText", ctx_r12.currentLanguageLabelText)("weglotMultiLanguageEnabled", ctx_r12.weglotMultiLanguageEnabled);
} }
function SubHeaderComponent_div_4_ng_container_2_vnext_motionpoint_locale_picker_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-motionpoint-locale-picker");
} }
function SubHeaderComponent_div_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SubHeaderComponent_div_4_ng_container_2_vnext_locale_picker_1_Template, 1, 3, "vnext-locale-picker", 15);
    i0.ɵɵtemplate(2, SubHeaderComponent_div_4_ng_container_2_vnext_motionpoint_locale_picker_2_Template, 1, 0, "vnext-motionpoint-locale-picker", 16);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r7.motionPointEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.motionPointEnabled);
} }
function SubHeaderComponent_div_4_vnext_contact_us_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-contact-us", 14);
} if (rf & 2) {
    const link_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("link", link_r4);
} }
function SubHeaderComponent_div_4_vnext_sub_header_action_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-sub-header-action", 18);
} if (rf & 2) {
    const link_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("link", link_r4)("submitAction", ctx_r9.printAction);
} }
function SubHeaderComponent_div_4_vnext_sub_header_action_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-sub-header-action", 14);
} if (rf & 2) {
    const link_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("link", link_r4);
} }
const _c1$1y = function (a0) { return { first: a0 }; };
function SubHeaderComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, SubHeaderComponent_div_4_vnext_save_progress_1_Template, 1, 1, "vnext-save-progress", 10);
    i0.ɵɵtemplate(2, SubHeaderComponent_div_4_ng_container_2_Template, 3, 2, "ng-container", 11);
    i0.ɵɵtemplate(3, SubHeaderComponent_div_4_vnext_contact_us_3_Template, 1, 1, "vnext-contact-us", 10);
    i0.ɵɵtemplate(4, SubHeaderComponent_div_4_vnext_sub_header_action_4_Template, 1, 2, "vnext-sub-header-action", 12);
    i0.ɵɵtemplate(5, SubHeaderComponent_div_4_vnext_sub_header_action_5_Template, 1, 1, "vnext-sub-header-action", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r4 = ctx.$implicit;
    const first_r5 = ctx.first;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$1y, first_r5))("ngSwitch", link_r4.action);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.actions.SAVE);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.actions.LANGUAGE);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.actions.CONTACT);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.actions.PRINT);
} }
function SubHeaderComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "vnext-login-container");
    i0.ɵɵelementEnd();
} }
class SubHeaderComponent {
    constructor(navigationUtilityService, store, headerFacade) {
        this.navigationUtilityService = navigationUtilityService;
        this.store = store;
        this.headerFacade = headerFacade;
        this.links = [];
        this.linkText = 'Skip to main content';
        this.isFocusSkipToContent = false;
        this.hideContactUsLink = false;
        this.motionPointEnabled = false;
        this.showPrintLink = false;
        this.loginWidgetEnabled = false;
        this.isPPCSite = false;
        this.showPlanYearBadge = true;
        this.weglotMultiLanguageEnabled = false;
        this.supportedLanguages = [];
        this.actions = SubHeaderActions;
        this.printAction = () => {
            window.print();
        };
    }
    ngOnInit() {
        this.supportedLanguages = this.store.selectSnapshot(AppConfigState.supportedLanguages) || [];
        // Display 'ContactUs' link only when Spa_HeaderFooter_HideContactUs_Link is disabled OR
        // Spa_HeaderFooter_HideContactUs_Link is enabled and Agent is NOT in context.
        this.agentInContext = this.headerFacade.getAgentInContextGuid().length > 0;
        this.showContactUsLink = !this.hideContactUsLink || !this.agentInContext;
    }
    ngAfterViewInit() {
        this.subscriptions = [
            this.navigationUtilityService.headerElementFocused$.subscribe(() => {
                if (this.skipToContentElement && this.skipToContentElement.nativeElement && this.isFocusSkipToContent) {
                    this.skipToContentElement.nativeElement.focus();
                }
            })
        ];
    }
    getRoute(link) {
        return this.navigationUtilityService.constructHref(link.tag);
    }
    get linksToDisplay() {
        return this.links.filter(link => (link.action !== SubHeaderActions.LANGUAGE && link.action !== SubHeaderActions.CONTACT && link.action !== SubHeaderActions.PRINT) ||
            (link.action === SubHeaderActions.LANGUAGE && this.supportedLanguages.length) ||
            (link.action === SubHeaderActions.PRINT && this.showPrintLink) ||
            (link.action === SubHeaderActions.CONTACT && this.showContactUsLink));
    }
    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
SubHeaderComponent.ɵfac = function SubHeaderComponent_Factory(t) { return new (t || SubHeaderComponent)(i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(HeaderFacade)); };
SubHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SubHeaderComponent, selectors: [["vnext-sub-header"]], viewQuery: function SubHeaderComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$31, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.skipToContentElement = _t.first);
    } }, inputs: { links: "links", linkContainerClass: "linkContainerClass", linkText: "linkText", currentLanguageLabelText: "currentLanguageLabelText", isFocusSkipToContent: "isFocusSkipToContent", hideContactUsLink: "hideContactUsLink", motionPointEnabled: "motionPointEnabled", showPrintLink: "showPrintLink", loginWidgetEnabled: "loginWidgetEnabled", isPPCSite: "isPPCSite", showPlanYearBadge: "showPlanYearBadge", planYear: "planYear", weglotMultiLanguageEnabled: "weglotMultiLanguageEnabled" }, decls: 6, vars: 5, consts: [["tabindex", "-1", "id", "subheader", 1, "pr-lg-3", "pt-1", 3, "ngClass"], ["skipToContentElement", ""], [3, "title"], ["class", "margin-link d-flex align-items-center", 4, "ngIf"], ["class", "margin-link d-flex align-items-center", 3, "ngClass", "ngSwitch", 4, "ngFor", "ngForOf"], ["class", "d-flex align-items-center margin-link", 4, "ngIf"], [1, "margin-link", "d-flex", "align-items-center"], [1, "plan-year-badge"], [3, "planYear"], [1, "margin-link", "d-flex", "align-items-center", 3, "ngClass", "ngSwitch"], [3, "link", 4, "ngSwitchCase"], [4, "ngSwitchCase"], [3, "link", "submitAction", 4, "ngSwitchCase"], [3, "link", 4, "ngSwitchDefault"], [3, "link"], [3, "link", "currentLanguageLabelText", "weglotMultiLanguageEnabled", 4, "ngIf"], [4, "ngIf"], [3, "link", "currentLanguageLabelText", "weglotMultiLanguageEnabled"], [3, "link", "submitAction"], [1, "d-flex", "align-items-center", "margin-link"]], template: function SubHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0, 1);
        i0.ɵɵelement(2, "vnext-focus-on-main-content", 2);
        i0.ɵɵtemplate(3, SubHeaderComponent_div_3_Template, 3, 1, "div", 3);
        i0.ɵɵtemplate(4, SubHeaderComponent_div_4_Template, 6, 8, "div", 4);
        i0.ɵɵtemplate(5, SubHeaderComponent_div_5_Template, 2, 0, "div", 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", ctx.linkContainerClass);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("title", ctx.linkText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showPlanYearBadge && ctx.planYear);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.linksToDisplay);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isPPCSite && ctx.loginWidgetEnabled !== false);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, i1$2.NgSwitchDefault, PlanYearBadgeComponent, LoginContainerComponent, LocalePickerComponent, MotionPointLocalePickerComponent, SubHeaderActionComponent, ContactUsComponent, SaveProgressComponent, FocusOnMainContentComponent], styles: [".margin-link[_ngcontent-%COMP%]:last-child{padding-right:0}.margin-link.first[_ngcontent-%COMP%]{border-left:none}.margin-link[_ngcontent-%COMP%]{padding-left:10px}.sub-header-container-footer[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:center;padding:8px}.sub-header-container-header[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;align-items:center}.header-icon[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent1)}.header-icon-hover[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Gray4)}.header-icon-selected[_ngcontent-%COMP%]{font-weight:700}.underline-title[_ngcontent-%COMP%]{text-decoration:underline}.plan-year-badge[_ngcontent-%COMP%]{margin-top:3px}@media (max-width: 768px){.sub-header-container-footer[_ngcontent-%COMP%]{flex-direction:column;justify-content:flex-end;align-items:flex-end}.sub-header-container-footer[_ngcontent-%COMP%]   .margin-link[_ngcontent-%COMP%]{border-left:none;padding-left:15px}.container[_ngcontent-%COMP%]{padding:0 20px 0 0}.margin-link[_ngcontent-%COMP%]{min-height:0px;padding-left:4px;padding-right:4px}}@media (max-width: 767.9px){.margin-link[_ngcontent-%COMP%]{min-height:44px}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubHeaderComponent, [{
        type: Component,
        args: [{ selector: 'vnext-sub-header', template: "<div #skipToContentElement class=\"pr-lg-3 pt-1\" [ngClass]=\"linkContainerClass\" tabindex=\"-1\" id=\"subheader\">\r\n  <vnext-focus-on-main-content [title]=\"linkText\"></vnext-focus-on-main-content>\r\n  <div *ngIf=\"showPlanYearBadge && planYear\" class=\"margin-link d-flex align-items-center\">\r\n    <div class=\"plan-year-badge\">\r\n      <vnext-plan-year-badge [planYear]=\"planYear\"></vnext-plan-year-badge>\r\n    </div>\r\n  </div>\r\n  <div\r\n    *ngFor=\"let link of linksToDisplay; let first = first\"\r\n    class=\"margin-link d-flex align-items-center\"\r\n    [ngClass]=\"{ first: first }\"\r\n    [ngSwitch]=\"link.action\"\r\n  >\r\n    <vnext-save-progress *ngSwitchCase=\"actions.SAVE\" [link]=\"link\"></vnext-save-progress>\r\n    <ng-container *ngSwitchCase=\"actions.LANGUAGE\">\r\n      <vnext-locale-picker\r\n        *ngIf=\"!motionPointEnabled\"\r\n        [link]=\"link\"\r\n        [currentLanguageLabelText]=\"currentLanguageLabelText\"\r\n        [weglotMultiLanguageEnabled]=\"weglotMultiLanguageEnabled\"\r\n      ></vnext-locale-picker>\r\n      <vnext-motionpoint-locale-picker *ngIf=\"motionPointEnabled\"></vnext-motionpoint-locale-picker>\r\n    </ng-container>\r\n    <vnext-contact-us *ngSwitchCase=\"actions.CONTACT\" [link]=\"link\"></vnext-contact-us>\r\n    <vnext-sub-header-action *ngSwitchCase=\"actions.PRINT\" [link]=\"link\" [submitAction]=\"printAction\"></vnext-sub-header-action>\r\n    <vnext-sub-header-action *ngSwitchDefault [link]=\"link\"></vnext-sub-header-action>\r\n  </div>\r\n\r\n  <!-- login -->\r\n  <div *ngIf=\"isPPCSite && loginWidgetEnabled !== false\" class=\"d-flex align-items-center margin-link\">\r\n    <vnext-login-container></vnext-login-container>\r\n  </div>\r\n</div>\r\n", styles: [".margin-link:last-child{padding-right:0}.margin-link.first{border-left:none}.margin-link{padding-left:10px}.sub-header-container-footer{display:flex;justify-content:flex-end;align-items:center;padding:8px}.sub-header-container-header{display:flex;justify-content:flex-end;align-items:center}.header-icon{color:var(--static-Spa_Style_Accent1)}.header-icon-hover{color:var(--static-Spa_Style_Gray4)}.header-icon-selected{font-weight:700}.underline-title{text-decoration:underline}.plan-year-badge{margin-top:3px}@media (max-width: 768px){.sub-header-container-footer{flex-direction:column;justify-content:flex-end;align-items:flex-end}.sub-header-container-footer .margin-link{border-left:none;padding-left:15px}.container{padding:0 20px 0 0}.margin-link{min-height:0px;padding-left:4px;padding-right:4px}}@media (max-width: 767.9px){.margin-link{min-height:44px}}\n"] }]
    }], function () { return [{ type: i1.NavigationUtilityService }, { type: i2.Store }, { type: HeaderFacade }]; }, { links: [{
            type: Input
        }], linkContainerClass: [{
            type: Input
        }], linkText: [{
            type: Input
        }], currentLanguageLabelText: [{
            type: Input
        }], isFocusSkipToContent: [{
            type: Input
        }], hideContactUsLink: [{
            type: Input
        }], motionPointEnabled: [{
            type: Input
        }], showPrintLink: [{
            type: Input
        }], loginWidgetEnabled: [{
            type: Input
        }], isPPCSite: [{
            type: Input
        }], showPlanYearBadge: [{
            type: Input
        }], planYear: [{
            type: Input
        }], weglotMultiLanguageEnabled: [{
            type: Input
        }], skipToContentElement: [{
            type: ViewChild,
            args: ['skipToContentElement']
        }] }); })();

function CallRecordingStickyBoxComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function CallRecordingStickyBoxComponent_div_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-link", 5);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("isLinkButton", true)("onClickAction", ctx_r3.startRecording())("additionalIcon", ctx_r3.iconClass + " pr-2")("title", ctx_r3.callRecordingText);
} }
function CallRecordingStickyBoxComponent_div_0_ng_template_4_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.elapsedTimeText);
} }
function CallRecordingStickyBoxComponent_div_0_ng_template_4_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "vnext-link", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isLinkButton", true)("customClass", "Spa_Style_Small_Font error-color")("onClickAction", ctx_r7.onEndRecordingButtonClick())("additionalIcon", ctx_r7.endCallIconClass + " no-underline pr-2")("title", ctx_r7.endCallText);
} }
function CallRecordingStickyBoxComponent_div_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵelement(2, "i", 8);
    i0.ɵɵelementStart(3, "div", 9)(4, "div", 10);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, CallRecordingStickyBoxComponent_div_0_ng_template_4_div_6_Template, 2, 1, "div", 11);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, CallRecordingStickyBoxComponent_div_0_ng_template_4_div_7_Template, 2, 5, "div", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r5.iconClass);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r5.showCallEndedView ? "pr-2" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.showCallEndedView ? ctx_r5.callEndedText : ctx_r5.callInProgressText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.elapsedTimeText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r5.showCallEndedView);
} }
const _c0$30 = function (a0) { return { "scripting-fixed-top": a0 }; };
function CallRecordingStickyBoxComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, CallRecordingStickyBoxComponent_div_0_ng_container_1_Template, 1, 0, "ng-container", 2);
    i0.ɵɵtemplate(2, CallRecordingStickyBoxComponent_div_0_ng_template_2_Template, 1, 4, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, CallRecordingStickyBoxComponent_div_0_ng_template_4_Template, 8, 5, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r2 = i0.ɵɵreference(3);
    const _r4 = i0.ɵɵreference(5);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$30, ctx_r0.isSticky));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.recordingInProgress)("ngIfThen", _r2)("ngIfElse", _r4);
} }
class CallRecordingStickyBoxComponent {
    constructor(cdr, agentCallRecordingShoppingFacade, twilioService, profileService, shoppingRecordingContextService, modalService, memberSessionService, spinnerService, deactivationGuardService, analyticsService, navigationContext) {
        this.cdr = cdr;
        this.agentCallRecordingShoppingFacade = agentCallRecordingShoppingFacade;
        this.twilioService = twilioService;
        this.profileService = profileService;
        this.shoppingRecordingContextService = shoppingRecordingContextService;
        this.modalService = modalService;
        this.memberSessionService = memberSessionService;
        this.spinnerService = spinnerService;
        this.deactivationGuardService = deactivationGuardService;
        this.analyticsService = analyticsService;
        this.navigationContext = navigationContext;
        this.isPPCSite = false;
        this.shoppingRecordingEnabled = false;
        this.shoppingRecordingCallBeneficiaryEnabled = false;
        this.iconClass = 'fas fa-phone';
        this.endCallIconClass = 'fas fa-phone-slash';
        this.callRecordingText = 'Start call recording';
        this.callInProgressText = 'Call in progress';
        this.endCallText = 'End call';
        this.callEndedText = 'Call Ended';
        this.shoppingRecordingStickyEnabled = false;
        this.showCallRecordingStickyBox = false;
        this.recordingInProgress = false;
        this.elapsedTimeText = '';
        this.isMemberInSession = false;
        this.showCallEndedView = false;
        this.isSticky = false;
        this.nonStickyPage = false;
        this.headerHeight = 100;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.deactivationGuardService.addDeactivationGuard({
            // We check this guard last because we clear the member's session when we pass the check
            // Other guards like Unsaved Changes depend on having a member's session to save any pending changes when checked
            checkLast: true,
            canDeactivate: this.showEndCallConfirmationModal.bind(this)
        });
        this.nonStickyPage = this.agentCallRecordingShoppingFacade.getCallRecordingNonStickyPage(this.navigationContext.getUrl()?.substring(1));
        this.subscriptions.add(this.profileService.hasMemberProfile$().subscribe({
            next: isMemberInSession => {
                this.isMemberInSession = isMemberInSession;
                this.updateBoxDisplay();
            }
        }));
        this.subscriptions.add(this.twilioService.getConnectionDisconnect$().subscribe({
            next: (deviceConnection) => {
                if (deviceConnection?.status() === Call.State.Closed) {
                    this.analyticsService.googleDataLayerTags = {
                        [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CASE_CALL_RECORDING_CALL_END,
                        [DataLayerGlobalVariable.CALL_RECORDING_END_VIA]: deviceConnection.hasCallManuallyEnded
                            ? CallRecordingEndVia.END_BUTTON
                            : CallRecordingEndVia.DISCONNECTED,
                        [DataLayerGlobalVariable.CALL_RECORDING_TRACKING_ID]: this.agentCallRecordingShoppingFacade.getTwilioCallTrackingId(),
                        [DataLayerGlobalVariable.CALL_RECORDING_DURATION]: `${this.twilioService.getCallDurationInSeconds()}`
                    };
                    this.endRecording();
                    this.cdr.markForCheck();
                }
            }
        }));
        this.subscriptions.add(this.twilioService.getDeviceConnect$().subscribe({
            next: () => {
                if (this.twilioService.isConnectionOpen()) {
                    this.shoppingRecordingContextService.startCall();
                }
            }
        }));
        this.subscriptions.add(this.twilioService.getElapsedTimeText$().subscribe({
            next: text => {
                this.elapsedTimeText = text;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.shoppingRecordingContextService.getCallInProgress$().subscribe({
            next: recordingInProgress => {
                this.recordingInProgress = recordingInProgress;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.shoppingRecordingContextService.getCallRecentlyEnded$().subscribe({
            next: recentlyEnded => {
                this.showCallEndedView = recentlyEnded;
                if (recentlyEnded && this.twilioService.isConnectionOpen()) {
                    this.endRecording();
                }
                this.cdr.markForCheck();
            }
        }));
        this.updateBoxDisplay();
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    updateBoxDisplay() {
        this.showCallRecordingStickyBox =
            this.isPPCSite && this.shoppingRecordingEnabled && this.shoppingRecordingCallBeneficiaryEnabled && this.isMemberInSession;
        this.cdr.markForCheck();
    }
    startRecording() {
        // TODO: Still need to figure out how to not allow a start if enrollment call is happening
        return () => {
            if (this.agentCallRecordingShoppingFacade.checkForMemberPhoneNumber()) {
                this.showAgentCallRecordingModal(() => { });
            }
        };
    }
    onEndRecordingButtonClick() {
        return () => {
            this.endRecording(true);
        };
    }
    endRecording(hasCallManuallyEnded) {
        this.twilioService.hangup(true, hasCallManuallyEnded);
        this.shoppingRecordingContextService.endCall();
    }
    applyActionOnAcceptEndCallRecordingModal() {
        const actionOnAcceptEndCallRecordingModal = this.agentCallRecordingShoppingFacade.getActionOnAcceptEndCallRecordingModal();
        if (actionOnAcceptEndCallRecordingModal) {
            actionOnAcceptEndCallRecordingModal();
        }
    }
    onScroll(event) {
        if (this.shoppingRecordingStickyEnabled) {
            this.isSticky = window.scrollY > this.headerHeight && !this.nonStickyPage;
            this.cdr.detectChanges();
        }
    }
    showAgentCallRecordingModal(confirmAction) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_CALL_RECORDING_MODAL_OPEN
        };
        const confirmationModal = this.modalService.open(AgentCallRecordingShoppingModalComponent, {
            centered: true,
            backdrop: 'static',
            size: 'lg'
        });
        confirmationModal.componentInstance.confirmAction = confirmAction;
    }
    async showEndCallConfirmationModal() {
        const [displayEndCallConfirmationModal, isOpenEndCallConfirmationModal] = await Promise.all([
            await this.shoppingRecordingContextService.getEndCallConfirmationModalMustDisplayContext$().pipe(take(1)).toPromise(),
            await this.shoppingRecordingContextService.getEndCallConfirmationModalOpenContext$().pipe(take(1)).toPromise()
        ]);
        if (this.recordingInProgress && displayEndCallConfirmationModal && !isOpenEndCallConfirmationModal) {
            this.shoppingRecordingContextService.setEndCallConfirmationModalOpen(true);
            // To prevent any un-expected stuck spinner event at moment to shows up the modal
            this.spinnerService.reset();
            const endCallConfirmationModal = this.agentCallRecordingShoppingFacade.setupEndCallConfirmationModal();
            return await endCallConfirmationModal.result
                .then(() => {
                this.applyActionOnAcceptEndCallRecordingModal();
                this.endRecording();
                this.memberSessionService.memberLogout();
                return true;
            })
                .catch(() => false)
                .finally(() => {
                this.agentCallRecordingShoppingFacade.setActionOnAcceptEndCallRecordingModal(null);
                this.shoppingRecordingContextService.hideEndCallConfirmationModal();
                this.shoppingRecordingContextService.setEndCallConfirmationModalOpen(false);
            });
        }
        return true;
    }
}
CallRecordingStickyBoxComponent.ɵfac = function CallRecordingStickyBoxComponent_Factory(t) { return new (t || CallRecordingStickyBoxComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(AgentCallRecordingShoppingFacade), i0.ɵɵdirectiveInject(i1.TwilioDeviceService), i0.ɵɵdirectiveInject(i1.ProfileService), i0.ɵɵdirectiveInject(i1.ShoppingRecordingContextService), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i1.DeactivationGuardService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.NavigationContext)); };
CallRecordingStickyBoxComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CallRecordingStickyBoxComponent, selectors: [["vnext-call-recording-sticky-box"]], hostBindings: function CallRecordingStickyBoxComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("scroll", function CallRecordingStickyBoxComponent_scroll_HostBindingHandler($event) { return ctx.onScroll($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { isPPCSite: "isPPCSite", shoppingRecordingEnabled: "shoppingRecordingEnabled", shoppingRecordingCallBeneficiaryEnabled: "shoppingRecordingCallBeneficiaryEnabled", iconClass: "iconClass", endCallIconClass: "endCallIconClass", callRecordingText: "callRecordingText", callInProgressText: "callInProgressText", endCallText: "endCallText", callEndedText: "callEndedText", shoppingRecordingStickyEnabled: "shoppingRecordingStickyEnabled" }, decls: 1, vars: 1, consts: [["class", "sticky-box", 3, "ngClass", 4, "ngIf"], [1, "sticky-box", 3, "ngClass"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["startRecordingTemplate", ""], ["recordingInProgressTemplate", ""], [3, "isLinkButton", "onClickAction", "additionalIcon", "title"], [1, "row", "Spa_Style_Small_Font", "text-nowrap"], [1, "d-flex", "pl-3", "mr-2"], [1, "pr-2", "call-icon", 3, "ngClass"], [1, "progress-text-container", "Spa_Style_Primary_Color"], [1, "Spa_Style_Paragraph", 3, "ngClass"], ["class", "Spa_Style_Note", 4, "ngIf"], ["class", "d-flex pr-3 ml-2 text-right", 4, "ngIf"], [1, "Spa_Style_Note"], [1, "d-flex", "pr-3", "ml-2", "text-right"], [3, "isLinkButton", "customClass", "onClickAction", "additionalIcon", "title"]], template: function CallRecordingStickyBoxComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CallRecordingStickyBoxComponent_div_0_Template, 6, 6, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showCallRecordingStickyBox);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, LinkComponent], styles: [".sticky-box[_ngcontent-%COMP%]{right:28px;border:2px solid var(--static-Spa_Style_Accent1);border-radius:0 0 5px 5px;background-color:#fff;padding:10px;position:absolute}@media (min-width: 1460px){.sticky-box[_ngcontent-%COMP%]{right:calc(50% - 692px)}}.call-icon[_ngcontent-%COMP%]{margin-top:5px}.scripting-fixed-top[_ngcontent-%COMP%]{position:fixed;top:0;z-index:910}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CallRecordingStickyBoxComponent, [{
        type: Component,
        args: [{ selector: 'vnext-call-recording-sticky-box', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"showCallRecordingStickyBox\" class=\"sticky-box\" [ngClass]=\"{ 'scripting-fixed-top': isSticky }\">\r\n  <ng-container *ngIf=\"!recordingInProgress; then startRecordingTemplate; else recordingInProgressTemplate\"></ng-container>\r\n  <ng-template #startRecordingTemplate\r\n    ><vnext-link\r\n      [isLinkButton]=\"true\"\r\n      [onClickAction]=\"startRecording()\"\r\n      [additionalIcon]=\"iconClass + ' pr-2'\"\r\n      [title]=\"callRecordingText\"\r\n    ></vnext-link\r\n  ></ng-template>\r\n  <ng-template #recordingInProgressTemplate\r\n    ><div class=\"row Spa_Style_Small_Font text-nowrap\">\r\n      <div class=\"d-flex pl-3 mr-2\">\r\n        <i class=\"pr-2 call-icon\" [ngClass]=\"iconClass\"></i>\r\n        <div class=\"progress-text-container Spa_Style_Primary_Color\">\r\n          <div class=\"Spa_Style_Paragraph\" [ngClass]=\"showCallEndedView ? 'pr-2' : ''\">\r\n            {{ showCallEndedView ? callEndedText : callInProgressText }}\r\n          </div>\r\n          <div *ngIf=\"elapsedTimeText\" class=\"Spa_Style_Note\">{{ elapsedTimeText }}</div>\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"!showCallEndedView\" class=\"d-flex pr-3 ml-2 text-right\">\r\n        <vnext-link\r\n          [isLinkButton]=\"true\"\r\n          [customClass]=\"'Spa_Style_Small_Font error-color'\"\r\n          [onClickAction]=\"onEndRecordingButtonClick()\"\r\n          [additionalIcon]=\"endCallIconClass + ' no-underline pr-2'\"\r\n          [title]=\"endCallText\"\r\n        ></vnext-link>\r\n      </div></div\r\n  ></ng-template>\r\n</div>\r\n", styles: [".sticky-box{right:28px;border:2px solid var(--static-Spa_Style_Accent1);border-radius:0 0 5px 5px;background-color:#fff;padding:10px;position:absolute}@media (min-width: 1460px){.sticky-box{right:calc(50% - 692px)}}.call-icon{margin-top:5px}.scripting-fixed-top{position:fixed;top:0;z-index:910}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: AgentCallRecordingShoppingFacade }, { type: i1.TwilioDeviceService }, { type: i1.ProfileService }, { type: i1.ShoppingRecordingContextService }, { type: i1$1.NgbModal }, { type: i1.MemberSessionService }, { type: i1.SpinnerService }, { type: i1.DeactivationGuardService }, { type: AnalyticsService }, { type: i1.NavigationContext }]; }, { isPPCSite: [{
            type: Input
        }], shoppingRecordingEnabled: [{
            type: Input
        }], shoppingRecordingCallBeneficiaryEnabled: [{
            type: Input
        }], iconClass: [{
            type: Input
        }], endCallIconClass: [{
            type: Input
        }], callRecordingText: [{
            type: Input
        }], callInProgressText: [{
            type: Input
        }], endCallText: [{
            type: Input
        }], callEndedText: [{
            type: Input
        }], shoppingRecordingStickyEnabled: [{
            type: Input
        }], onScroll: [{
            type: HostListener,
            args: ['window:scroll', ['$event']]
        }] }); })();

function HeaderMenuDropdownComponent_ng_container_14_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-agent-container", 20);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("brokerText", ctx_r8.brokerText)("isLoggedIn", ctx_r8.agentLoggedIn)("agentData", ctx_r8.agentData)("locale", ctx_r8.locale)("closeText", ctx_r8.closeText)("uniqueCodeText", ctx_r8.uniqueCodeText)("uniqueCode", ctx_r8.uniqueCode)("displayUniqueCode", ctx_r8.displayUniqueCode)("weglotMultiLanguageEnabled", ctx_r8.weglotMultiLanguageEnabled)("isMobile", ctx_r8.isMobile);
} }
function HeaderMenuDropdownComponent_ng_container_14_div_1_ng_template_2_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.speakWithAgentHeader, " ");
} }
function HeaderMenuDropdownComponent_ng_container_14_div_1_ng_template_2_ng_container_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 24);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r13.speakWithAgentContactInfo, "html"), i0.ɵɵsanitizeHtml);
} }
function HeaderMenuDropdownComponent_ng_container_14_div_1_ng_template_2_ng_container_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 25);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementStart(3, "div", 26);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 2, ctx_r14.uniqueCodeText, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r14.uniqueCode);
} }
function HeaderMenuDropdownComponent_ng_container_14_div_1_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 21);
    i0.ɵɵtemplate(2, HeaderMenuDropdownComponent_ng_container_14_div_1_ng_template_2_ng_container_0_div_2_Template, 2, 1, "div", 22);
    i0.ɵɵtemplate(3, HeaderMenuDropdownComponent_ng_container_14_div_1_ng_template_2_ng_container_0_div_3_Template, 2, 4, "div", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, HeaderMenuDropdownComponent_ng_container_14_div_1_ng_template_2_ng_container_0_ng_container_4_Template, 5, 5, "ng-container", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_SpeakWithAgent_Header_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_SpeakWithAgent_ContactInfo_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.displayUniqueCode);
} }
function HeaderMenuDropdownComponent_ng_container_14_div_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, HeaderMenuDropdownComponent_ng_container_14_div_1_ng_template_2_ng_container_0_Template, 5, 3, "ng-container", 11);
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r10.speakWithAgentEnabled);
} }
function HeaderMenuDropdownComponent_ng_container_14_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtemplate(1, HeaderMenuDropdownComponent_ng_container_14_div_1_ng_container_1_Template, 2, 10, "ng-container", 18);
    i0.ɵɵtemplate(2, HeaderMenuDropdownComponent_ng_container_14_div_1_ng_template_2_Template, 1, 1, "ng-template", null, 19, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r9 = i0.ɵɵreference(3);
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.brokerInfoEnabled && (ctx_r3.agentData == null ? null : ctx_r3.agentData.data))("ngIfElse", _r9);
} }
function HeaderMenuDropdownComponent_ng_container_14_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "div", 27);
    i0.ɵɵelementEnd();
} }
function HeaderMenuDropdownComponent_ng_container_14_vnext_plan_year_badge_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-plan-year-badge", 28);
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("planYear", ctx_r5.planYear);
} }
function HeaderMenuDropdownComponent_ng_container_14_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelement(1, "vnext-shopping-cart-icon", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("label", ctx_r6.cartText);
} }
function HeaderMenuDropdownComponent_ng_container_14_div_6_vnext_profile_navigation_bar_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-profile-navigation-bar", 32);
} }
function HeaderMenuDropdownComponent_ng_container_14_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtemplate(1, HeaderMenuDropdownComponent_ng_container_14_div_6_vnext_profile_navigation_bar_1_Template, 1, 0, "vnext-profile-navigation-bar", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.showDropdown);
} }
function HeaderMenuDropdownComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HeaderMenuDropdownComponent_ng_container_14_div_1_Template, 4, 2, "div", 13);
    i0.ɵɵtemplate(2, HeaderMenuDropdownComponent_ng_container_14_div_2_Template, 2, 0, "div", 11);
    i0.ɵɵelementStart(3, "div", 14);
    i0.ɵɵtemplate(4, HeaderMenuDropdownComponent_ng_container_14_vnext_plan_year_badge_4_Template, 1, 1, "vnext-plan-year-badge", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, HeaderMenuDropdownComponent_ng_container_14_div_5_Template, 2, 1, "div", 16);
    i0.ɵɵtemplate(6, HeaderMenuDropdownComponent_ng_container_14_div_6_Template, 2, 1, "div", 16);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.isPPCSite);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.showCartLink);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showPlanYearBadge);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showCartLink);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.isProfileSearchEnabled && ctx_r1.isPPCSite);
} }
function HeaderMenuDropdownComponent_div_15_ng_container_1_vnext_locale_picker_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-locale-picker", 39);
} if (rf & 2) {
    const link_r16 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r22 = i0.ɵɵnextContext();
    i0.ɵɵproperty("headerDropdown", true)("link", link_r16)("currentLanguageLabelText", ctx_r22.currentLanguageLabelText)("weglotMultiLanguageEnabled", ctx_r22.weglotMultiLanguageEnabled);
} }
function HeaderMenuDropdownComponent_div_15_ng_container_1_vnext_motionpoint_locale_picker_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-motionpoint-locale-picker");
} }
function HeaderMenuDropdownComponent_div_15_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HeaderMenuDropdownComponent_div_15_ng_container_1_vnext_locale_picker_1_Template, 1, 4, "vnext-locale-picker", 38);
    i0.ɵɵtemplate(2, HeaderMenuDropdownComponent_div_15_ng_container_1_vnext_motionpoint_locale_picker_2_Template, 1, 0, "vnext-motionpoint-locale-picker", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r18.motionPointEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.motionPointEnabled);
} }
function HeaderMenuDropdownComponent_div_15_vnext_contact_us_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-contact-us", 40);
} if (rf & 2) {
    const link_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("link", link_r16)("headerDropdown", true);
} }
function HeaderMenuDropdownComponent_div_15_vnext_sub_header_action_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-sub-header-action", 41);
} if (rf & 2) {
    const link_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r20 = i0.ɵɵnextContext();
    i0.ɵɵproperty("link", link_r16)("submitAction", ctx_r20.printAction);
} }
function HeaderMenuDropdownComponent_div_15_vnext_sub_header_action_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-sub-header-action", 42);
} if (rf & 2) {
    const link_r16 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("link", link_r16);
} }
function HeaderMenuDropdownComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵtemplate(1, HeaderMenuDropdownComponent_div_15_ng_container_1_Template, 3, 2, "ng-container", 34);
    i0.ɵɵtemplate(2, HeaderMenuDropdownComponent_div_15_vnext_contact_us_2_Template, 1, 2, "vnext-contact-us", 35);
    i0.ɵɵtemplate(3, HeaderMenuDropdownComponent_div_15_vnext_sub_header_action_3_Template, 1, 2, "vnext-sub-header-action", 36);
    i0.ɵɵtemplate(4, HeaderMenuDropdownComponent_div_15_vnext_sub_header_action_4_Template, 1, 1, "vnext-sub-header-action", 37);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r16 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", link_r16.action);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.subHeaderActions.LANGUAGE);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.subHeaderActions.CONTACT);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.subHeaderActions.PRINT);
} }
const _c0$2$ = function (a0) { return { "text-center": a0 }; };
class HeaderMenuDropdownComponent {
    constructor(headerFacade) {
        this.headerFacade = headerFacade;
        this.isPPCSite = false;
        this.motionPointEnabled = false;
        this.showPlanYearBadge = false;
        this.weglotMultiLanguageEnabled = false;
        this.isMobile = false;
        this.subHeaderActions = SubHeaderActions;
        this.printAction = () => {
            window.print();
        };
    }
    ngOnInit() {
        // Display 'ContactUs' link only when Spa_HeaderFooter_HideContactUs_Link is disabled OR
        // Spa_HeaderFooter_HideContactUs_Link is enabled and Agent is NOT in context.
        this.agentInContext = this.headerFacade.getAgentInContextGuid().length > 0;
        this.showContactUsLink = !this.hideContactUsLink || !this.agentInContext;
    }
    ngOnChanges(changes) {
        const { isShoppingCartEnabled, isPPCSite } = changes;
        if (isShoppingCartEnabled?.currentValue !== isShoppingCartEnabled?.previousValue ||
            isPPCSite?.currentValue !== isPPCSite?.previousValue) {
            this.showCartLink = isShoppingCartEnabled?.currentValue && !isPPCSite?.currentValue;
        }
    }
    setDropdownStatus(event) {
        this.showDropdown = event;
    }
    get linksToDisplay() {
        return this.links?.length
            ? this.links.filter(link => (link.action !== SubHeaderActions.CONTACT && link.action !== SubHeaderActions.PRINT) ||
                (link.action === SubHeaderActions.PRINT && this.showPrintLink) ||
                (link.action === SubHeaderActions.CONTACT && this.showContactUsLink))
            : [];
    }
}
HeaderMenuDropdownComponent.ɵfac = function HeaderMenuDropdownComponent_Factory(t) { return new (t || HeaderMenuDropdownComponent)(i0.ɵɵdirectiveInject(HeaderFacade)); };
HeaderMenuDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HeaderMenuDropdownComponent, selectors: [["vnext-header-menu-dropdown"]], inputs: { links: "links", menuTitle: "menuTitle", isRetention: "isRetention", isProfileSearchEnabled: "isProfileSearchEnabled", isPPCSite: "isPPCSite", brokerText: "brokerText", isAgentLoggedIn: "isAgentLoggedIn", agentFirstName: "agentFirstName", agentLastName: "agentLastName", agentPhoneNumber: "agentPhoneNumber", agentEmailAddress: "agentEmailAddress", agentLoggedIn: "agentLoggedIn", agentData: "agentData", brokerInfoEnabled: "brokerInfoEnabled", isUserLoggedIn: "isUserLoggedIn", isShoppingCartEnabled: "isShoppingCartEnabled", primaryLoggedIn: "primaryLoggedIn", currentLanguageLabelText: "currentLanguageLabelText", locale: "locale", hideContactUsLink: "hideContactUsLink", closeText: "closeText", motionPointEnabled: "motionPointEnabled", cartText: "cartText", showPrintLink: "showPrintLink", speakWithAgentEnabled: "speakWithAgentEnabled", speakWithAgentHeader: "speakWithAgentHeader", speakWithAgentContactInfo: "speakWithAgentContactInfo", uniqueCode: "uniqueCode", uniqueCodeText: "uniqueCodeText", displayUniqueCode: "displayUniqueCode", showPlanYearBadge: "showPlanYearBadge", planYear: "planYear", weglotMultiLanguageEnabled: "weglotMultiLanguageEnabled", isMobile: "isMobile" }, features: [i0.ɵɵNgOnChangesFeature], decls: 16, vars: 7, consts: [["ngbDropdown", "", "placement", "bottom-right", 1, "dropdown-container", 3, "ngClass", "openChange"], ["headerMenuDropdown", "ngbDropdown"], ["type", "button", "id", "dropdownMenuButton", "ngbDropdownToggle", "", 1, "menu-button", "btn", "p-0", "Spa_Style_Paragraph"], [1, "fas", "fa-bars"], [1, "pl-1"], ["ngbDropdownMenu", "", "aria-labelledby", "dropdownMenuButton", 1, "menu", "pb-0", "w-100"], [1, "px-3"], [1, "arrow"], ["tabindex", "0", "role", "button", 1, "times-btn", "can-click", 3, "click", "keyup.enter"], [1, "sr-only"], [1, "fa", "fa-times", "Spa_Style_Primary_Color"], [4, "ngIf"], ["class", "margin-link row", 3, "ngSwitch", 4, "ngFor", "ngForOf"], ["class", "mr-5 mt-1 d-md-none", 4, "ngIf"], [1, "plan-year-badge"], [3, "planYear", 4, "ngIf"], ["class", "border-bottom", 4, "ngIf"], [1, "mr-5", "mt-1", "d-md-none"], [4, "ngIf", "ngIfElse"], ["speakWithAgent", ""], [3, "brokerText", "isLoggedIn", "agentData", "locale", "closeText", "uniqueCodeText", "uniqueCode", "displayUniqueCode", "weglotMultiLanguageEnabled", "isMobile"], [1, "Spa_Style_Primary_Color", "Spa_Style_Paragraph"], [4, "liveEditProp"], [3, "innerHTML", 4, "liveEditProp"], [3, "innerHTML"], [1, "Spa_Style_Paragraph", "unique-code-text", "mt-3", "mb-1", 3, "innerHTML"], [1, "Spa_Style_H3", "no-translate-block"], [1, "row", 2, "min-height", "35px"], [3, "planYear"], [1, "border-bottom"], [3, "label"], ["class", "col p-0", 4, "ngIf"], [1, "col", "p-0"], [1, "margin-link", "row", 3, "ngSwitch"], [4, "ngSwitchCase"], ["class", "col-12 border-bottom py-2 pl-4", 3, "link", "headerDropdown", 4, "ngSwitchCase"], ["class", "col-12 border-bottom py-2 pl-4", 3, "link", "submitAction", 4, "ngSwitchCase"], ["class", "col p-2 pl-4 border-bottom", 3, "link", 4, "ngSwitchDefault"], ["class", "col-12", 3, "headerDropdown", "link", "currentLanguageLabelText", "weglotMultiLanguageEnabled", 4, "ngIf"], [1, "col-12", 3, "headerDropdown", "link", "currentLanguageLabelText", "weglotMultiLanguageEnabled"], [1, "col-12", "border-bottom", "py-2", "pl-4", 3, "link", "headerDropdown"], [1, "col-12", "border-bottom", "py-2", "pl-4", 3, "link", "submitAction"], [1, "col", "p-2", "pl-4", "border-bottom", 3, "link"]], template: function HeaderMenuDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        const _r28 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 0, 1);
        i0.ɵɵlistener("openChange", function HeaderMenuDropdownComponent_Template_div_openChange_0_listener($event) { return ctx.setDropdownStatus($event); });
        i0.ɵɵelementStart(2, "button", 2);
        i0.ɵɵelement(3, "i", 3);
        i0.ɵɵelementStart(4, "span", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "div", 5)(7, "div", 6);
        i0.ɵɵelement(8, "div", 7);
        i0.ɵɵelementStart(9, "div")(10, "span", 8);
        i0.ɵɵlistener("click", function HeaderMenuDropdownComponent_Template_span_click_10_listener() { i0.ɵɵrestoreView(_r28); const _r0 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r0.close()); })("keyup.enter", function HeaderMenuDropdownComponent_Template_span_keyup_enter_10_listener() { i0.ɵɵrestoreView(_r28); const _r0 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r0.close()); });
        i0.ɵɵelementStart(11, "span", 9);
        i0.ɵɵtext(12, "Close");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(13, "i", 10);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(14, HeaderMenuDropdownComponent_ng_container_14_Template, 7, 5, "ng-container", 11);
        i0.ɵɵtemplate(15, HeaderMenuDropdownComponent_div_15_Template, 5, 4, "div", 12);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0$2$, ctx.isUserLoggedIn));
        i0.ɵɵadvance(2);
        i0.ɵɵattribute("aria-expanded", _r0.isOpen());
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1("", ctx.menuTitle, " ");
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngIf", ctx.isRetention && ctx.primaryLoggedIn || !ctx.isRetention);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.linksToDisplay);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, i1$2.NgSwitchDefault, PlanYearBadgeComponent, LiveEditPropDirective, IconAriaAttributesDirective, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, AgentContainerComponent, ShoppingCartIconComponent, ProfileNavigationBarComponent, LocalePickerComponent, MotionPointLocalePickerComponent, SubHeaderActionComponent, ContactUsComponent, SafePipe], styles: [".dropdown-toggle[_ngcontent-%COMP%]:after{display:none}.menu-button[_ngcontent-%COMP%]{border:none;font-weight:400}.row[_ngcontent-%COMP%]{font-size:var(--Spa_Style_Small_Font)}.container[_ngcontent-%COMP%]{min-width:250px}.name-and-icon-header[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent1)}.dropdown-container[_ngcontent-%COMP%]{position:static}.margin-link[_ngcontent-%COMP%]:last-child{border-bottom:none}.times-btn[_ngcontent-%COMP%]{position:absolute;right:15px;top:15px}vnext-text-size[_ngcontent-%COMP%]{padding-left:8px}.arrow[_ngcontent-%COMP%]{left:70%;top:-8px;position:absolute;width:1rem;height:1.5rem}.arrow[_ngcontent-%COMP%]:after{top:-1.5rem;border-width:0 1.5rem 1.5rem;position:absolute;content:\"\";border-color:transparent transparent white;border-style:solid}.dropdown-menu[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:after, .dropdown-menu[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.dropdown-menu[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:after{top:1px;border-width:0 .5rem .5rem;border-bottom-color:#fff}.dropdown-menu[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:before{top:0;border-width:0 .5rem .5rem;border-bottom-color:#00000040}.unique-code-text[_ngcontent-%COMP%]{white-space:break-spaces}@media only screen and (max-width: 767px){.dropdown-container[_ngcontent-%COMP%]   .menu.dropdown-menu[_ngcontent-%COMP%]{white-space:normal;top:-20px!important}}.plan-year-badge[_ngcontent-%COMP%]{margin-left:-5px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderMenuDropdownComponent, [{
        type: Component,
        args: [{ selector: 'vnext-header-menu-dropdown', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  ngbDropdown\r\n  (openChange)=\"setDropdownStatus($event)\"\r\n  #headerMenuDropdown=\"ngbDropdown\"\r\n  class=\"dropdown-container\"\r\n  placement=\"bottom-right\"\r\n  [ngClass]=\"{ 'text-center': isUserLoggedIn }\"\r\n>\r\n  <button\r\n    type=\"button\"\r\n    class=\"menu-button btn p-0 Spa_Style_Paragraph\"\r\n    id=\"dropdownMenuButton\"\r\n    ngbDropdownToggle\r\n    [attr.aria-expanded]=\"headerMenuDropdown.isOpen()\"\r\n  >\r\n    <i class=\"fas fa-bars\"></i>\r\n    <span class=\"pl-1\">{{ menuTitle }} </span>\r\n  </button>\r\n\r\n  <div ngbDropdownMenu aria-labelledby=\"dropdownMenuButton\" class=\"menu pb-0 w-100\">\r\n    <div class=\"px-3\">\r\n      <div class=\"arrow\"></div>\r\n      <div>\r\n        <span\r\n          class=\"times-btn can-click\"\r\n          (click)=\"headerMenuDropdown.close()\"\r\n          tabindex=\"0\"\r\n          role=\"button\"\r\n          (keyup.enter)=\"headerMenuDropdown.close()\"\r\n        >\r\n          <span class=\"sr-only\">Close</span>\r\n          <i class=\"fa fa-times Spa_Style_Primary_Color\"></i>\r\n        </span>\r\n      </div>\r\n      <ng-container *ngIf=\"(isRetention && primaryLoggedIn) || !isRetention\">\r\n        <div class=\"mr-5 mt-1 d-md-none\" *ngIf=\"!isPPCSite\">\r\n          <ng-container *ngIf=\"brokerInfoEnabled && agentData?.data; else speakWithAgent\">\r\n            <vnext-agent-container\r\n              [brokerText]=\"brokerText\"\r\n              [isLoggedIn]=\"agentLoggedIn\"\r\n              [agentData]=\"agentData\"\r\n              [locale]=\"locale\"\r\n              [closeText]=\"closeText\"\r\n              [uniqueCodeText]=\"uniqueCodeText\"\r\n              [uniqueCode]=\"uniqueCode\"\r\n              [displayUniqueCode]=\"displayUniqueCode\"\r\n              [weglotMultiLanguageEnabled]=\"weglotMultiLanguageEnabled\"\r\n              [isMobile]=\"isMobile\"\r\n            >\r\n            </vnext-agent-container>\r\n          </ng-container>\r\n          <ng-template #speakWithAgent>\r\n            <ng-container *ngIf=\"speakWithAgentEnabled\">\r\n              <div class=\"Spa_Style_Primary_Color Spa_Style_Paragraph\">\r\n                <div *liveEditProp=\"'Spa_SpeakWithAgent_Header_Text'\">\r\n                  {{ speakWithAgentHeader }}\r\n                </div>\r\n                <div *liveEditProp=\"'Spa_SpeakWithAgent_ContactInfo_Text'\" [innerHTML]=\"speakWithAgentContactInfo | safe : 'html'\"></div>\r\n              </div>\r\n              <ng-container *ngIf=\"displayUniqueCode\">\r\n                <div class=\"Spa_Style_Paragraph unique-code-text mt-3 mb-1\" [innerHTML]=\"uniqueCodeText | safe : 'html'\"></div>\r\n                <div class=\"Spa_Style_H3 no-translate-block\">{{ uniqueCode }}</div>\r\n              </ng-container>\r\n            </ng-container>\r\n          </ng-template>\r\n        </div>\r\n        <div *ngIf=\"!showCartLink\">\r\n          <div class=\"row\" style=\"min-height: 35px\"></div>\r\n        </div>\r\n        <div class=\"plan-year-badge\">\r\n          <vnext-plan-year-badge *ngIf=\"showPlanYearBadge\" [planYear]=\"planYear\"></vnext-plan-year-badge>\r\n        </div>\r\n        <div class=\"border-bottom\" *ngIf=\"showCartLink\">\r\n          <vnext-shopping-cart-icon [label]=\"cartText\"></vnext-shopping-cart-icon>\r\n        </div>\r\n        <div class=\"border-bottom\" *ngIf=\"isProfileSearchEnabled && isPPCSite\">\r\n          <vnext-profile-navigation-bar *ngIf=\"showDropdown\" class=\"col p-0\"></vnext-profile-navigation-bar>\r\n        </div>\r\n      </ng-container>\r\n      <div [ngSwitch]=\"link.action\" *ngFor=\"let link of linksToDisplay; let last = last\" class=\"margin-link row\">\r\n        <ng-container *ngSwitchCase=\"subHeaderActions.LANGUAGE\">\r\n          <vnext-locale-picker\r\n            *ngIf=\"!motionPointEnabled\"\r\n            class=\"col-12\"\r\n            [headerDropdown]=\"true\"\r\n            [link]=\"link\"\r\n            [currentLanguageLabelText]=\"currentLanguageLabelText\"\r\n            [weglotMultiLanguageEnabled]=\"weglotMultiLanguageEnabled\"\r\n          >\r\n          </vnext-locale-picker>\r\n          <vnext-motionpoint-locale-picker *ngIf=\"motionPointEnabled\"></vnext-motionpoint-locale-picker>\r\n        </ng-container>\r\n        <vnext-contact-us\r\n          *ngSwitchCase=\"subHeaderActions.CONTACT\"\r\n          class=\"col-12 border-bottom py-2 pl-4\"\r\n          [link]=\"link\"\r\n          [headerDropdown]=\"true\"\r\n        ></vnext-contact-us>\r\n        <vnext-sub-header-action\r\n          class=\"col-12 border-bottom py-2 pl-4\"\r\n          *ngSwitchCase=\"subHeaderActions.PRINT\"\r\n          [link]=\"link\"\r\n          [submitAction]=\"printAction\"\r\n        ></vnext-sub-header-action>\r\n        <vnext-sub-header-action class=\"col p-2 pl-4 border-bottom\" *ngSwitchDefault [link]=\"link\"> </vnext-sub-header-action>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".dropdown-toggle:after{display:none}.menu-button{border:none;font-weight:400}.row{font-size:var(--Spa_Style_Small_Font)}.container{min-width:250px}.name-and-icon-header i{color:var(--static-Spa_Style_Accent1)}.dropdown-container{position:static}.margin-link:last-child{border-bottom:none}.times-btn{position:absolute;right:15px;top:15px}vnext-text-size{padding-left:8px}.arrow{left:70%;top:-8px;position:absolute;width:1rem;height:1.5rem}.arrow:after{top:-1.5rem;border-width:0 1.5rem 1.5rem;position:absolute;content:\"\";border-color:transparent transparent white;border-style:solid}.dropdown-menu .arrow:after,.dropdown-menu .arrow:before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.dropdown-menu .arrow:after{top:1px;border-width:0 .5rem .5rem;border-bottom-color:#fff}.dropdown-menu .arrow:before{top:0;border-width:0 .5rem .5rem;border-bottom-color:#00000040}.unique-code-text{white-space:break-spaces}@media only screen and (max-width: 767px){.dropdown-container .menu.dropdown-menu{white-space:normal;top:-20px!important}}.plan-year-badge{margin-left:-5px}\n"] }]
    }], function () { return [{ type: HeaderFacade }]; }, { links: [{
            type: Input
        }], menuTitle: [{
            type: Input
        }], isRetention: [{
            type: Input
        }], isProfileSearchEnabled: [{
            type: Input
        }], isPPCSite: [{
            type: Input
        }], brokerText: [{
            type: Input
        }], isAgentLoggedIn: [{
            type: Input
        }], agentFirstName: [{
            type: Input
        }], agentLastName: [{
            type: Input
        }], agentPhoneNumber: [{
            type: Input
        }], agentEmailAddress: [{
            type: Input
        }], agentLoggedIn: [{
            type: Input
        }], agentData: [{
            type: Input
        }], brokerInfoEnabled: [{
            type: Input
        }], isUserLoggedIn: [{
            type: Input
        }], isShoppingCartEnabled: [{
            type: Input
        }], primaryLoggedIn: [{
            type: Input
        }], currentLanguageLabelText: [{
            type: Input
        }], locale: [{
            type: Input
        }], hideContactUsLink: [{
            type: Input
        }], closeText: [{
            type: Input
        }], motionPointEnabled: [{
            type: Input
        }], cartText: [{
            type: Input
        }], showPrintLink: [{
            type: Input
        }], speakWithAgentEnabled: [{
            type: Input
        }], speakWithAgentHeader: [{
            type: Input
        }], speakWithAgentContactInfo: [{
            type: Input
        }], uniqueCode: [{
            type: Input
        }], uniqueCodeText: [{
            type: Input
        }], displayUniqueCode: [{
            type: Input
        }], showPlanYearBadge: [{
            type: Input
        }], planYear: [{
            type: Input
        }], weglotMultiLanguageEnabled: [{
            type: Input
        }], isMobile: [{
            type: Input
        }] }); })();

const _c0$2_ = ["speakWithAgentPopover"];
const _c1$1x = ["speakWithAgentPopoverToggle"];
function SpeakWithAgentComponent_ng_template_0_h2_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r4.headerText);
} }
function SpeakWithAgentComponent_ng_template_0_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r5.contactInfo, "html"), i0.ɵɵsanitizeHtml);
} }
function SpeakWithAgentComponent_ng_template_0_ng_container_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 18);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r7.uniqueCodeText, "html"), i0.ɵɵsanitizeHtml);
} }
function SpeakWithAgentComponent_ng_template_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SpeakWithAgentComponent_ng_template_0_ng_container_7_div_1_Template, 2, 4, "div", 16);
    i0.ɵɵelementStart(2, "div", 17);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_SpeakWithAgent_UniqueCodeDescription_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r6.uniqueCode);
} }
function SpeakWithAgentComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function SpeakWithAgentComponent_ng_template_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); const _r3 = i0.ɵɵreference(4); return i0.ɵɵresetView(ctx_r8.closePopover(_r3)); });
    i0.ɵɵelement(1, "i", 8);
    i0.ɵɵelementStart(2, "span", 9);
    i0.ɵɵtext(3, "Close");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 10);
    i0.ɵɵtemplate(5, SpeakWithAgentComponent_ng_template_0_h2_5_Template, 2, 1, "h2", 11);
    i0.ɵɵtemplate(6, SpeakWithAgentComponent_ng_template_0_div_6_Template, 2, 4, "div", 12);
    i0.ɵɵtemplate(7, SpeakWithAgentComponent_ng_template_0_ng_container_7_Template, 4, 2, "ng-container", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", ctx_r1.closeText);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("liveEditProp", "Spa_SpeakWithAgent_Header_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_SpeakWithAgent_ContactInfo_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.displayUniqueCode);
} }
class SpeakWithAgentComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.uniqueCodeText = 'When you call, give the agent your personal code so they can pick up where you left off.';
        this.displayUniqueCode = true;
        this.subscriptions = [];
    }
    ngAfterViewInit() {
        const speakWithAgentPopoverHidden$ = this.speakWithAgentPopover?.hidden;
        if (speakWithAgentPopoverHidden$) {
            this.subscriptions.push(speakWithAgentPopoverHidden$.subscribe({
                next: () => {
                    this.speakWithAgentPopoverToggle?.nativeElement?.focus();
                    this.cdr.markForCheck();
                }
            }));
        }
    }
    ngAfterViewChecked() {
        const speakWithAgentPopoverShown$ = this.speakWithAgentPopover?.shown;
        if (speakWithAgentPopoverShown$) {
            const speakWithAgentPopoverCancelButtonElement = document.querySelector('.speak-with-agent-popover-cancel');
            this.subscriptions.push(speakWithAgentPopoverShown$.subscribe({
                next: () => {
                    if (speakWithAgentPopoverCancelButtonElement) {
                        speakWithAgentPopoverCancelButtonElement.focus();
                    }
                    this.cdr.markForCheck();
                }
            }));
        }
    }
    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
    closePopover(popover) {
        if (popover.isOpen()) {
            popover.close();
        }
    }
    toggleSpeakWithAgentPopover() {
        this.speakWithAgentPopover?.toggle();
        this.isPopoverOpen = this.speakWithAgentPopover?.isOpen() ?? false;
        this.cdr.markForCheck();
    }
}
SpeakWithAgentComponent.ɵfac = function SpeakWithAgentComponent_Factory(t) { return new (t || SpeakWithAgentComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
SpeakWithAgentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SpeakWithAgentComponent, selectors: [["vnext-speak-with-agent"]], viewQuery: function SpeakWithAgentComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$2_, 5);
        i0.ɵɵviewQuery(_c1$1x, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.speakWithAgentPopover = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.speakWithAgentPopoverToggle = _t.first);
    } }, inputs: { linkText: "linkText", headerText: "headerText", contactInfo: "contactInfo", uniqueCodeText: "uniqueCodeText", uniqueCode: "uniqueCode", displayUniqueCode: "displayUniqueCode", closeText: "closeText" }, decls: 9, vars: 4, consts: [["popOverTemplate", ""], ["placement", "bottom", "popoverClass", "speak-with-agent-popover", "tabindex", "0", "role", "button", 1, "no-underline", "d-block", "can-click", "focus-text", "speak-with-agent-link", 3, "ngbPopover", "autoClose", "keyup.enter"], ["speakWithAgentPopoverToggle", "", "speakWithAgentPopover", "ngbPopover"], [1, "d-flex", "align-items-center"], [1, "comment-icon", "mr-2"], [1, "fas", "fa-comment", "Spa_Style_Large_Font"], [1, "text-left", "Spa_Style_Primary_Color", "Spa_Style_Paragraph", 3, "innerHTML"], ["role", "button", 1, "popover-cancel", "speak-with-agent-popover-cancel", "m-2", "action-button", 3, "click"], [1, "fas", "fa-times"], [1, "sr-only"], [1, "pr-3", "Spa_Style_Primary_Color"], ["class", "Spa_Style_H2 pb-3", 4, "liveEditProp"], ["class", "Spa_Style_Paragraph", 3, "innerHTML", 4, "liveEditProp"], [4, "ngIf"], [1, "Spa_Style_H2", "pb-3"], [1, "Spa_Style_Paragraph", 3, "innerHTML"], ["class", "Spa_Style_Paragraph unique-code-text mt-3", 3, "innerHTML", 4, "liveEditProp"], [1, "Spa_Style_H3", "no-translate-block"], [1, "Spa_Style_Paragraph", "unique-code-text", "mt-3", 3, "innerHTML"]], template: function SpeakWithAgentComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SpeakWithAgentComponent_ng_template_0_Template, 8, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(2, "a", 1, 2);
        i0.ɵɵlistener("keyup.enter", function SpeakWithAgentComponent_Template_a_keyup_enter_2_listener() { return ctx.toggleSpeakWithAgentPopover(); });
        i0.ɵɵelementStart(5, "div", 3)(6, "div", 4);
        i0.ɵɵelement(7, "i", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(8, "div", 6);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngbPopover", _r0)("autoClose", "outside");
        i0.ɵɵattribute("aria-expanded", ctx.isPopoverOpen);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("innerHTML", ctx.linkText, i0.ɵɵsanitizeHtml);
    } }, dependencies: [i1$2.NgIf, LiveEditPropDirective, IconAriaAttributesDirective, i1$1.NgbPopover, SafePipe], styles: ["a[_ngcontent-%COMP%], a[_ngcontent-%COMP%]:hover{text-decoration:none}.popover-cancel[_ngcontent-%COMP%]{position:absolute;top:0;right:0;cursor:pointer;color:var(--Spa_Style_Primary);width:20px;height:20px;text-align:center}.comment-icon[_ngcontent-%COMP%]{display:flex;color:var(--static-Spa_Style_Accent1);align-items:center}.unique-code-text[_ngcontent-%COMP%]{max-width:300px}.speak-with-agent-link[_ngcontent-%COMP%]:hover   .comment-icon[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Gray4)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpeakWithAgentComponent, [{
        type: Component,
        args: [{ selector: 'vnext-speak-with-agent', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-template #popOverTemplate>\r\n  <button (click)=\"closePopover(speakWithAgentPopover)\" [attr.aria-label]=\"closeText\" role=\"button\" class=\"popover-cancel speak-with-agent-popover-cancel m-2 action-button\">\r\n    <i class=\"fas fa-times\"></i>\r\n    <span class=\"sr-only\">Close</span>\r\n  </button>\r\n  <div class=\"pr-3 Spa_Style_Primary_Color\">\r\n    <h2 class=\"Spa_Style_H2 pb-3\" *liveEditProp=\"'Spa_SpeakWithAgent_Header_Text'\">{{ headerText }}</h2>\r\n    <div class=\"Spa_Style_Paragraph\" *liveEditProp=\"'Spa_SpeakWithAgent_ContactInfo_Text'\" [innerHTML]=\"contactInfo | safe: 'html'\"></div>\r\n    <ng-container *ngIf=\"displayUniqueCode\">\r\n      <div\r\n        class=\"Spa_Style_Paragraph unique-code-text mt-3\"\r\n        *liveEditProp=\"'Spa_SpeakWithAgent_UniqueCodeDescription_Text'\"\r\n        [innerHTML]=\"uniqueCodeText | safe: 'html'\"\r\n      ></div>\r\n      <div class=\"Spa_Style_H3 no-translate-block\">{{ uniqueCode }}</div>\r\n    </ng-container>\r\n  </div>\r\n</ng-template>\r\n\r\n<a\r\n  #speakWithAgentPopoverToggle\r\n  placement=\"bottom\"\r\n  [ngbPopover]=\"popOverTemplate\"\r\n  class=\"no-underline d-block can-click focus-text speak-with-agent-link\"\r\n  [autoClose]=\"'outside'\"\r\n  #speakWithAgentPopover=\"ngbPopover\"\r\n  popoverClass=\"speak-with-agent-popover\"\r\n  tabindex=\"0\"\r\n  (keyup.enter)=\"toggleSpeakWithAgentPopover()\"\r\n  role=\"button\"\r\n  [attr.aria-expanded]=\"isPopoverOpen\"\r\n>\r\n  <div class=\"d-flex align-items-center\">\r\n    <div class=\"comment-icon mr-2\"><i class=\"fas fa-comment Spa_Style_Large_Font\"></i></div>\r\n    <div class=\"text-left Spa_Style_Primary_Color Spa_Style_Paragraph\" [innerHTML]=\"linkText\"></div></div\r\n></a>\r\n", styles: ["a,a:hover{text-decoration:none}.popover-cancel{position:absolute;top:0;right:0;cursor:pointer;color:var(--Spa_Style_Primary);width:20px;height:20px;text-align:center}.comment-icon{display:flex;color:var(--static-Spa_Style_Accent1);align-items:center}.unique-code-text{max-width:300px}.speak-with-agent-link:hover .comment-icon{color:var(--static-Spa_Style_Gray4)}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { speakWithAgentPopover: [{
            type: ViewChild,
            args: ['speakWithAgentPopover']
        }], speakWithAgentPopoverToggle: [{
            type: ViewChild,
            args: ['speakWithAgentPopoverToggle']
        }], linkText: [{
            type: Input
        }], headerText: [{
            type: Input
        }], contactInfo: [{
            type: Input
        }], uniqueCodeText: [{
            type: Input
        }], uniqueCode: [{
            type: Input
        }], displayUniqueCode: [{
            type: Input
        }], closeText: [{
            type: Input
        }] }); })();

function DynamicHeaderComponent_ng_container_0_header_1_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-link", 18)(2, "div", 19);
    i0.ɵɵelement(3, "img", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 21);
    i0.ɵɵelement(5, "img", 20);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("href", ctx_r10.medicareGroupPlanConfig == null ? null : ctx_r10.medicareGroupPlanConfig.headerFooterPrimaryClientLogo == null ? null : ctx_r10.medicareGroupPlanConfig.headerFooterPrimaryClientLogo.href)("tag", ctx_r10.medicareGroupPlanConfig == null ? null : ctx_r10.medicareGroupPlanConfig.headerFooterPrimaryClientLogo == null ? null : ctx_r10.medicareGroupPlanConfig.headerFooterPrimaryClientLogo.tag)("queryParams", ctx_r10.medicareGroupQueryParams)("linkTarget", ctx_r10.medicareGroupPlanConfig == null ? null : ctx_r10.medicareGroupPlanConfig.headerFooterPrimaryClientLogo == null ? null : ctx_r10.medicareGroupPlanConfig.headerFooterPrimaryClientLogo.target)("role", ctx_r10.linkRoles.LINK);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(ctx_r10.logoClass);
    i0.ɵɵproperty("alt", ctx_r10.medicareGroupPlanConfig == null ? null : ctx_r10.medicareGroupPlanConfig.headerFooterPrimaryClientLogo == null ? null : ctx_r10.medicareGroupPlanConfig.headerFooterPrimaryClientLogo.alternateText)("src", ctx_r10.primaryLogo, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(ctx_r10.logoClass);
    i0.ɵɵproperty("alt", ctx_r10.medicareGroupPlanConfig == null ? null : ctx_r10.medicareGroupPlanConfig.headerFooterPrimaryClientLogo == null ? null : ctx_r10.medicareGroupPlanConfig.headerFooterPrimaryClientLogo.alternateText)("src", ctx_r10.primaryLogo, i0.ɵɵsanitizeUrl);
} }
function DynamicHeaderComponent_ng_container_0_header_1_div_3_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-link", 22)(2, "div", 19);
    i0.ɵɵelement(3, "img", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 21);
    i0.ɵɵelement(5, "img", 20);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("href", ctx_r16.Spa_HeaderFooter_PrimaryClientLogo_Url[0].href)("tag", ctx_r16.siteLogoTag && ctx_r16.Spa_HeaderFooter_PrimaryClientLogo_Url[0].tag ? ctx_r16.siteLogoTag : ctx_r16.Spa_HeaderFooter_PrimaryClientLogo_Url[0].tag)("linkTarget", ctx_r16.Spa_HeaderFooter_PrimaryClientLogo_Url[0].target)("onClickAction", ctx_r16.Spa_Site_SiteType !== ctx_r16.siteType.CONSUMER ? ctx_r16.logoutMember : ctx_r16.submitLogoAction.bind(ctx_r16, ctx_r16.Spa_HeaderFooter_PrimaryClientLogo_Url, ctx_r16.siteLogoTag))("isLinkButton", ctx_r16.Spa_Site_SiteType === ctx_r16.siteType.BROKER)("role", ctx_r16.linkRoles.LINK);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(ctx_r16.logoClass);
    i0.ɵɵproperty("alt", ctx_r16.Spa_HeaderFooter_PrimaryLogo_Alt_Text)("src", ctx_r16.primaryLogo, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(ctx_r16.logoClass);
    i0.ɵɵproperty("alt", ctx_r16.Spa_HeaderFooter_PrimaryLogo_Alt_Text)("src", ctx_r16.primaryLogo, i0.ɵɵsanitizeUrl);
} }
function DynamicHeaderComponent_ng_container_0_header_1_div_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, DynamicHeaderComponent_ng_container_0_header_1_div_3_ng_template_2_ng_container_0_Template, 6, 16, "ng-container", 14);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r13 = i0.ɵɵreference(5);
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", (ctx_r12.Spa_HeaderFooter_PrimaryClientLogo_Url == null ? null : ctx_r12.Spa_HeaderFooter_PrimaryClientLogo_Url.length) && !(ctx_r12.Spa_HeaderFooter_PrimaryClientLogo_UsePlanLogo && ctx_r12.showPlanLogo))("ngIfElse", _r13);
} }
function DynamicHeaderComponent_ng_container_0_header_1_div_3_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "img", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r14.logoClass);
    i0.ɵɵproperty("alt", ctx_r14.getPrimaryAltText())("src", ctx_r14.getPrimaryLogo(), i0.ɵɵsanitizeUrl);
} }
function DynamicHeaderComponent_ng_container_0_header_1_div_3_vnext_link_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-link", 23)(1, "div", 19);
    i0.ɵɵelement(2, "img", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("tag", ctx_r15.siteLogoTag ? ctx_r15.siteLogoTag : ctx_r15.pageTags.HOME)("linkTarget", ctx_r15.Spa_HeaderFooter_PrimaryClientLogo_Url[0].target)("onClickAction", ctx_r15.Spa_Site_SiteType === ctx_r15.siteType.CONSUMER ? ctx_r15.submitLogoAction.bind(ctx_r15, ctx_r15.Spa_HeaderFooter_PrimaryClientLogo_Url, ctx_r15.siteLogoTag) : null);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(ctx_r15.logoClass);
    i0.ɵɵproperty("alt", ctx_r15.Spa_HeaderFooter_PrimaryLogo_Alt_Text)("src", ctx_r15.primaryLogo, i0.ɵɵsanitizeUrl);
} }
function DynamicHeaderComponent_ng_container_0_header_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, DynamicHeaderComponent_ng_container_0_header_1_div_3_ng_container_1_Template, 6, 15, "ng-container", 14);
    i0.ɵɵtemplate(2, DynamicHeaderComponent_ng_container_0_header_1_div_3_ng_template_2_Template, 1, 2, "ng-template", null, 15, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, DynamicHeaderComponent_ng_container_0_header_1_div_3_ng_template_4_Template, 2, 5, "ng-template", null, 16, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(6, DynamicHeaderComponent_ng_container_0_header_1_div_3_vnext_link_6_Template, 3, 8, "vnext-link", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r11 = i0.ɵɵreference(3);
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("col-md-5 ", ctx_r5.logoWrapperClass, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.Spa_Site_MedicareGroup_Enabled)("ngIfElse", _r11);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", (ctx_r5.Spa_HeaderFooter_PrimaryClientLogo_Url == null ? null : ctx_r5.Spa_HeaderFooter_PrimaryClientLogo_Url.length) && !ctx_r5.Spa_HeaderFooter_PrimaryClientLogo_Url[0].tag && !ctx_r5.Spa_HeaderFooter_PrimaryClientLogo_Url[0].href && !(ctx_r5.Spa_HeaderFooter_PrimaryClientLogo_UsePlanLogo && ctx_r5.showPlanLogo));
} }
function DynamicHeaderComponent_ng_container_0_header_1_div_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-link", 18)(2, "div", 19);
    i0.ɵɵelement(3, "img", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 21);
    i0.ɵɵelement(5, "img", 20);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("href", ctx_r17.medicareGroupPlanConfig == null ? null : ctx_r17.medicareGroupPlanConfig.headerFooterSecondaryClientLogo == null ? null : ctx_r17.medicareGroupPlanConfig.headerFooterSecondaryClientLogo.href)("tag", ctx_r17.medicareGroupPlanConfig == null ? null : ctx_r17.medicareGroupPlanConfig.headerFooterSecondaryClientLogo == null ? null : ctx_r17.medicareGroupPlanConfig.headerFooterSecondaryClientLogo.tag)("queryParams", ctx_r17.medicareGroupQueryParams)("linkTarget", ctx_r17.medicareGroupPlanConfig == null ? null : ctx_r17.medicareGroupPlanConfig.headerFooterSecondaryClientLogo == null ? null : ctx_r17.medicareGroupPlanConfig.headerFooterSecondaryClientLogo.target)("role", ctx_r17.linkRoles.LINK);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(ctx_r17.logoClass);
    i0.ɵɵproperty("alt", ctx_r17.medicareGroupPlanConfig == null ? null : ctx_r17.medicareGroupPlanConfig.headerFooterSecondaryClientLogo == null ? null : ctx_r17.medicareGroupPlanConfig.headerFooterSecondaryClientLogo.alternateText)("src", ctx_r17.secondaryLogo, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(ctx_r17.logoClass);
    i0.ɵɵproperty("alt", ctx_r17.medicareGroupPlanConfig == null ? null : ctx_r17.medicareGroupPlanConfig.headerFooterSecondaryClientLogo == null ? null : ctx_r17.medicareGroupPlanConfig.headerFooterSecondaryClientLogo.alternateText)("src", ctx_r17.secondaryLogo, i0.ɵɵsanitizeUrl);
} }
function DynamicHeaderComponent_ng_container_0_header_1_div_4_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-link", 27)(2, "div", 19);
    i0.ɵɵelement(3, "img", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 21);
    i0.ɵɵelement(5, "img", 20);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("tag", ctx_r23.siteLogoTag && (ctx_r23.Spa_HeaderFooter_SecondaryClientLogo_Url[0] == null ? null : ctx_r23.Spa_HeaderFooter_SecondaryClientLogo_Url[0].tag) ? ctx_r23.siteLogoTag : ctx_r23.Spa_HeaderFooter_SecondaryClientLogo_Url[0].tag)("href", ctx_r23.Spa_HeaderFooter_SecondaryClientLogo_Url[0].href)("linkTarget", ctx_r23.Spa_HeaderFooter_SecondaryClientLogo_Url[0].target)("onClickAction", ctx_r23.Spa_Site_SiteType === ctx_r23.siteType.CONSUMER ? ctx_r23.submitLogoAction.bind(ctx_r23, ctx_r23.Spa_HeaderFooter_SecondaryClientLogo_Url, ctx_r23.siteLogoTag) : null);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(ctx_r23.logoClass);
    i0.ɵɵproperty("alt", ctx_r23.Spa_HeaderFooter_SecondaryLogo_Alt_Text)("src", ctx_r23.secondaryLogo, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(ctx_r23.logoClass);
    i0.ɵɵproperty("alt", ctx_r23.Spa_HeaderFooter_SecondaryLogo_Alt_Text)("src", ctx_r23.secondaryLogo, i0.ɵɵsanitizeUrl);
} }
function DynamicHeaderComponent_ng_container_0_header_1_div_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, DynamicHeaderComponent_ng_container_0_header_1_div_4_ng_template_2_ng_container_0_Template, 6, 14, "ng-container", 14);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r20 = i0.ɵɵreference(5);
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r19.Spa_HeaderFooter_SecondaryClientLogo_Url && ctx_r19.Spa_HeaderFooter_SecondaryClientLogo_Url.length)("ngIfElse", _r20);
} }
function DynamicHeaderComponent_ng_container_0_header_1_div_4_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "img", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r21.logoClass);
    i0.ɵɵproperty("alt", ctx_r21.Spa_HeaderFooter_SecondaryLogo_Alt_Text)("src", ctx_r21.secondaryLogo, i0.ɵɵsanitizeUrl);
} }
function DynamicHeaderComponent_ng_container_0_header_1_div_4_vnext_link_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-link", 23)(1, "div", 19);
    i0.ɵɵelement(2, "img", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("tag", ctx_r22.siteLogoTag ? ctx_r22.siteLogoTag : ctx_r22.pageTags.HOME)("linkTarget", ctx_r22.Spa_HeaderFooter_SecondaryClientLogo_Url[0].target)("onClickAction", ctx_r22.Spa_Site_SiteType === ctx_r22.siteType.CONSUMER ? ctx_r22.submitLogoAction.bind(ctx_r22, ctx_r22.Spa_HeaderFooter_SecondaryClientLogo_Url, ctx_r22.siteLogoTag) : null);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(ctx_r22.logoClass);
    i0.ɵɵproperty("alt", ctx_r22.Spa_HeaderFooter_SecondaryLogo_Alt_Text)("src", ctx_r22.secondaryLogo, i0.ɵɵsanitizeUrl);
} }
function DynamicHeaderComponent_ng_container_0_header_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, DynamicHeaderComponent_ng_container_0_header_1_div_4_ng_container_1_Template, 6, 15, "ng-container", 14);
    i0.ɵɵtemplate(2, DynamicHeaderComponent_ng_container_0_header_1_div_4_ng_template_2_Template, 1, 2, "ng-template", null, 25, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, DynamicHeaderComponent_ng_container_0_header_1_div_4_ng_template_4_Template, 2, 5, "ng-template", null, 26, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(6, DynamicHeaderComponent_ng_container_0_header_1_div_4_vnext_link_6_Template, 3, 8, "vnext-link", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r18 = i0.ɵɵreference(3);
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.Spa_Site_MedicareGroup_Enabled)("ngIfElse", _r18);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r6.Spa_HeaderFooter_SecondaryClientLogo_Url && ctx_r6.Spa_HeaderFooter_SecondaryClientLogo_Url.length && !ctx_r6.Spa_HeaderFooter_SecondaryClientLogo_Url[0].href && !ctx_r6.Spa_HeaderFooter_SecondaryClientLogo_Url[0].tag);
} }
function DynamicHeaderComponent_ng_container_0_header_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelement(1, "vnext-header-menu-dropdown", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isRetention", ctx_r7.isRetentionView)("menuTitle", ctx_r7.Spa_HeaderFooter_MenuTitle)("links", ctx_r7.Spa_HeaderFooter_SubHeaderLinks)("isProfileSearchEnabled", ctx_r7.Spa_Site_Profile_Enabled)("isPPCSite", ctx_r7.isPPCSite)("brokerText", ctx_r7.Spa_HeaderFooter_Broker)("agentLoggedIn", ctx_r7.isAgentLoggedIn)("agentData", ctx_r7.agentData)("brokerInfoEnabled", ctx_r7.Spa_Site_Broker_Info_Enabled && ctx_r7.showAgentHeader)("isUserLoggedIn", ctx_r7.isUserLoggedIn)("isShoppingCartEnabled", ctx_r7.Spa_ShoppingCart_Enabled)("primaryLoggedIn", ctx_r7.primaryLoggedIn)("currentLanguageLabelText", ctx_r7.Spa_HeaderFooter_Language_Label_Text)("locale", ctx_r7.locale)("hideContactUsLink", ctx_r7.Spa_HeaderFooter_HideContactUs_Link)("closeText", ctx_r7.Spa_Site_Close)("motionPointEnabled", ctx_r7.MotionPoint_WidgetEnabled)("cartText", ctx_r7.Spa_Site_Cart_Text)("showPrintLink", ctx_r7.Spa_HeaderFooter_Print_Display)("speakWithAgentContactInfo", ctx_r7.Spa_SpeakWithAgent_ContactInfo_Text)("speakWithAgentEnabled", ctx_r7.Spa_Site_SpeakWithAgent_Enabled)("speakWithAgentHeader", ctx_r7.Spa_SpeakWithAgent_Header_Text)("uniqueCode", ctx_r7.uniqueCode)("displayUniqueCode", ctx_r7.displayUniqueCode)("uniqueCodeText", ctx_r7.Spa_SpeakWithAgent_UniqueCodeDescription_Text)("showPlanYearBadge", ctx_r7.isPlanYearBadgeEnabled)("planYear", ctx_r7.badgePlanYear)("weglotMultiLanguageEnabled", ctx_r7.Spa_Weglot_MultiLanguage_Enabled)("isMobile", ctx_r7.isMobile);
} }
function DynamicHeaderComponent_ng_container_0_header_1_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelement(1, "vnext-login-container");
    i0.ɵɵelementEnd();
} }
function DynamicHeaderComponent_ng_container_0_header_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicHeaderComponent_ng_container_0_header_1_ng_container_6_div_1_Template, 2, 0, "div", 30);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.Spa_Site_Login_Widget_Enabled !== false);
} }
function DynamicHeaderComponent_ng_container_0_header_1_ng_container_13_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-speak-with-agent", 37);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("headerText", ctx_r31.Spa_SpeakWithAgent_Header_Text)("linkText", ctx_r31.Spa_SpeakWithAgent_Link_Text)("contactInfo", ctx_r31.Spa_SpeakWithAgent_ContactInfo_Text)("uniqueCode", ctx_r31.uniqueCode)("uniqueCodeText", ctx_r31.Spa_SpeakWithAgent_UniqueCodeDescription_Text)("displayUniqueCode", ctx_r31.displayUniqueCode)("closeText", ctx_r31.Spa_Site_Close);
} }
function DynamicHeaderComponent_ng_container_0_header_1_ng_container_13_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, DynamicHeaderComponent_ng_container_0_header_1_ng_container_13_ng_template_1_ng_container_0_Template, 2, 7, "ng-container", 0);
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngIf", !ctx_r26.isPPCSite && ctx_r26.Spa_Site_SpeakWithAgent_Enabled);
} }
function DynamicHeaderComponent_ng_container_0_header_1_ng_container_13_div_3_vnext_agent_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-agent-container", 40);
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("brokerText", ctx_r32.Spa_HeaderFooter_Broker)("agentData", ctx_r32.agentData)("locale", ctx_r32.locale)("closeText", ctx_r32.Spa_Site_Close)("uniqueCodeText", ctx_r32.Spa_SpeakWithAgent_UniqueCodeDescription_Text)("uniqueCode", ctx_r32.uniqueCode)("displayUniqueCode", ctx_r32.displayUniqueCode)("isAgentProfilePictureEnabled", ctx_r32.Spa_Agent_Profile_Picture_Upload_Enabled)("weglotMultiLanguageEnabled", ctx_r32.Spa_Weglot_MultiLanguage_Enabled)("isMobile", ctx_r32.isMobile);
} }
function DynamicHeaderComponent_ng_container_0_header_1_ng_container_13_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵtemplate(1, DynamicHeaderComponent_ng_container_0_header_1_ng_container_13_div_3_vnext_agent_container_1_Template, 1, 10, "vnext-agent-container", 39);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r25 = i0.ɵɵreference(2);
    const ctx_r27 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r27.agentData || ctx_r27.Spa_HeaderFooter_Broker)("ngIfElse", _r25);
} }
const _c0$2Z = function (a0, a1) { return { "pl-3": a0, "pl-2": a1 }; };
function DynamicHeaderComponent_ng_container_0_header_1_ng_container_13_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵelement(1, "vnext-shopping-cart-icon", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c0$2Z, !ctx_r28.agentData, ctx_r28.agentData));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("label", ctx_r28.Spa_Site_Cart_Text);
} }
function DynamicHeaderComponent_ng_container_0_header_1_ng_container_13_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelement(1, "vnext-profile-navigation-bar");
    i0.ɵɵelementEnd();
} }
function DynamicHeaderComponent_ng_container_0_header_1_ng_container_13_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵelement(1, "vnext-login-container");
    i0.ɵɵelementEnd();
} }
function DynamicHeaderComponent_ng_container_0_header_1_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicHeaderComponent_ng_container_0_header_1_ng_container_13_ng_template_1_Template, 1, 1, "ng-template", null, 32, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(3, DynamicHeaderComponent_ng_container_0_header_1_ng_container_13_div_3_Template, 2, 2, "div", 33);
    i0.ɵɵtemplate(4, DynamicHeaderComponent_ng_container_0_header_1_ng_container_13_div_4_Template, 2, 5, "div", 34);
    i0.ɵɵtemplate(5, DynamicHeaderComponent_ng_container_0_header_1_ng_container_13_div_5_Template, 2, 0, "div", 35);
    i0.ɵɵtemplate(6, DynamicHeaderComponent_ng_container_0_header_1_ng_container_13_div_6_Template, 2, 0, "div", 36);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r25 = i0.ɵɵreference(2);
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r9.Spa_Site_Broker_Info_Enabled && ctx_r9.showAgentHeader && !ctx_r9.isPPCSite)("ngIfElse", _r25);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.Spa_ShoppingCart_Enabled && !ctx_r9.isPPCSite);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.Spa_Site_Profile_Enabled && ctx_r9.isPPCSite);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r9.isPPCSite && ctx_r9.Spa_Site_Login_Widget_Enabled !== false);
} }
const _c1$1w = function (a0, a1) { return { "pb-2": a0, "pb-0": a1 }; };
const _c2$Y = function (a0, a1) { return { "pt-2": a0, "pt-0": a1 }; };
const _c3$G = function (a0) { return { "logo-wrapper-margin-left": a0 }; };
const _c4$o = function (a0) { return { "sub-header-margin": a0 }; };
function DynamicHeaderComponent_ng_container_0_header_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "header", 2)(1, "div", 3)(2, "div", 4);
    i0.ɵɵtemplate(3, DynamicHeaderComponent_ng_container_0_header_1_div_3_Template, 7, 6, "div", 5);
    i0.ɵɵtemplate(4, DynamicHeaderComponent_ng_container_0_header_1_div_4_Template, 7, 3, "div", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, DynamicHeaderComponent_ng_container_0_header_1_div_5_Template, 2, 29, "div", 7);
    i0.ɵɵtemplate(6, DynamicHeaderComponent_ng_container_0_header_1_ng_container_6_Template, 2, 1, "ng-container", 0);
    i0.ɵɵelementStart(7, "div", 8)(8, "div", 9)(9, "div", 10)(10, "div", 11);
    i0.ɵɵelement(11, "vnext-sub-header", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div");
    i0.ɵɵtemplate(13, DynamicHeaderComponent_ng_container_0_header_1_ng_container_13_Template, 7, 5, "ng-container", 0);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelement(14, "vnext-call-recording-sticky-box", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(34, _c1$1w, !ctx_r2.agentData, ctx_r2.agentData));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(37, _c2$Y, !ctx_r2.agentData, ctx_r2.agentData));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(40, _c3$G, ctx_r2.secondaryLogo !== ""));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.primaryLogo);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.secondaryLogo);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isMobile);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isRetentionView && ctx_r2.primaryLoggedIn || !ctx_r2.isRetentionView);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(42, _c4$o, !ctx_r2.agentData));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("linkContainerClass", "sub-header-container-header")("links", ctx_r2.Spa_HeaderFooter_SubHeaderLinks)("currentLanguageLabelText", ctx_r2.Spa_HeaderFooter_Language_Label_Text)("isFocusSkipToContent", true)("hideContactUsLink", ctx_r2.Spa_HeaderFooter_HideContactUs_Link)("motionPointEnabled", ctx_r2.MotionPoint_WidgetEnabled)("showPrintLink", ctx_r2.Spa_HeaderFooter_Print_Display)("loginWidgetEnabled", ctx_r2.Spa_Site_Login_Widget_Enabled)("isPPCSite", ctx_r2.isPPCSite)("showPlanYearBadge", ctx_r2.isPlanYearBadgeEnabled)("planYear", ctx_r2.badgePlanYear)("weglotMultiLanguageEnabled", ctx_r2.Spa_Weglot_MultiLanguage_Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("row ", ctx_r2.alignmentClass, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isRetentionView && ctx_r2.primaryLoggedIn || !ctx_r2.isRetentionView);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isPPCSite", ctx_r2.isPPCSite)("shoppingRecordingEnabled", ctx_r2.Spa_Site_AgentCallRecordingShopping_Enabled)("shoppingRecordingCallBeneficiaryEnabled", ctx_r2.Spa_Site_AgentCallRecordingShopping_CallBeneficiary_Enabled)("shoppingRecordingStickyEnabled", ctx_r2.Spa_Site_AgentCallRecordingShopping_Sticky_Enabled)("iconClass", ctx_r2.Spa_AgentCallInProgressAcceptCall_Icon)("endCallIconClass", ctx_r2.Spa_AgentCallEndCall_Icon)("callRecordingText", ctx_r2.Spa_CallRecording_StartRecording_Text)("callInProgressText", ctx_r2.Spa_AgentCallInProgressAcceptCall_Title)("endCallText", ctx_r2.Spa_AgentCallEndCall_Title)("callEndedText", ctx_r2.Spa_AgentCallEnded_Title);
} }
function DynamicHeaderComponent_ng_container_0_header_2_ng_container_3_vnext_link_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-link", 48)(1, "div", 19);
    i0.ɵɵelement(2, "img", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 21);
    i0.ɵɵelement(4, "img", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("href", ctx_r35.Spa_HeaderFooter_PrimaryClientLogo_Url[0].href)("tag", ctx_r35.Spa_HeaderFooter_PrimaryClientLogo_Url[0].tag)("linkTarget", ctx_r35.Spa_HeaderFooter_PrimaryClientLogo_Url[0].target);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("can-click ", ctx_r35.logoClass, " basic-primary-logo mt-2 mb-2");
    i0.ɵɵproperty("alt", ctx_r35.Spa_HeaderFooter_PrimaryLogo_Alt_Text)("src", ctx_r35.primaryLogo, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("can-click ", ctx_r35.logoClass, " mt-2 mb-2");
    i0.ɵɵproperty("alt", ctx_r35.Spa_HeaderFooter_PrimaryLogo_Alt_Text)("src", ctx_r35.primaryLogo, i0.ɵɵsanitizeUrl);
} }
function DynamicHeaderComponent_ng_container_0_header_2_ng_container_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "img", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("", ctx_r37.logoClass, " mt-2 mb-2");
    i0.ɵɵproperty("alt", ctx_r37.getPrimaryAltText())("src", ctx_r37.getPrimaryLogo(), i0.ɵɵsanitizeUrl);
} }
function DynamicHeaderComponent_ng_container_0_header_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicHeaderComponent_ng_container_0_header_2_ng_container_3_vnext_link_1_Template, 5, 13, "vnext-link", 46);
    i0.ɵɵtemplate(2, DynamicHeaderComponent_ng_container_0_header_2_ng_container_3_ng_template_2_Template, 2, 5, "ng-template", null, 47, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r36 = i0.ɵɵreference(3);
    const ctx_r33 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r33.Spa_HeaderFooter_PrimaryClientLogo_Url == null ? null : ctx_r33.Spa_HeaderFooter_PrimaryClientLogo_Url.length) && !(ctx_r33.Spa_HeaderFooter_PrimaryClientLogo_UsePlanLogo && ctx_r33.showPlanLogo))("ngIfElse", _r36);
} }
function DynamicHeaderComponent_ng_container_0_header_2_ng_container_4_vnext_link_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-link", 48)(1, "div", 19);
    i0.ɵɵelement(2, "img", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 21);
    i0.ɵɵelement(4, "img", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("href", ctx_r38.Spa_HeaderFooter_SecondaryClientLogo_Url[0].href)("tag", ctx_r38.Spa_HeaderFooter_SecondaryClientLogo_Url[0].tag)("linkTarget", ctx_r38.Spa_HeaderFooter_SecondaryClientLogo_Url[0].target);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("can-click ", ctx_r38.logoClass, " mt-2");
    i0.ɵɵproperty("alt", ctx_r38.Spa_HeaderFooter_SecondaryLogo_Alt_Text)("src", ctx_r38.secondaryLogo, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("can-click ", ctx_r38.logoClass, " mt-2");
    i0.ɵɵproperty("alt", ctx_r38.Spa_HeaderFooter_SecondaryLogo_Alt_Text)("src", ctx_r38.secondaryLogo, i0.ɵɵsanitizeUrl);
} }
function DynamicHeaderComponent_ng_container_0_header_2_ng_container_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "img", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("can-click ", ctx_r40.logoClass, " mt-2");
    i0.ɵɵproperty("alt", ctx_r40.Spa_HeaderFooter_SecondaryLogo_Alt_Text)("src", ctx_r40.secondaryLogo, i0.ɵɵsanitizeUrl);
} }
function DynamicHeaderComponent_ng_container_0_header_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicHeaderComponent_ng_container_0_header_2_ng_container_4_vnext_link_1_Template, 5, 13, "vnext-link", 46);
    i0.ɵɵtemplate(2, DynamicHeaderComponent_ng_container_0_header_2_ng_container_4_ng_template_2_Template, 2, 5, "ng-template", null, 49, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r39 = i0.ɵɵreference(3);
    const ctx_r34 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r34.Spa_HeaderFooter_SecondaryClientLogo_Url && ctx_r34.Spa_HeaderFooter_SecondaryClientLogo_Url.length)("ngIfElse", _r39);
} }
function DynamicHeaderComponent_ng_container_0_header_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "header")(1, "div", 45);
    i0.ɵɵelement(2, "div");
    i0.ɵɵtemplate(3, DynamicHeaderComponent_ng_container_0_header_2_ng_container_3_Template, 4, 2, "ng-container", 0);
    i0.ɵɵtemplate(4, DynamicHeaderComponent_ng_container_0_header_2_ng_container_4_Template, 4, 2, "ng-container", 0);
    i0.ɵɵelement(5, "div");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r3.primaryLogo);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.secondaryLogo);
} }
function DynamicHeaderComponent_ng_container_0_header_3_vnext_sub_header_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-sub-header", 56);
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("linkContainerClass", "sub-header-container-header")("links", ctx_r41.Spa_HeaderFooter_SubHeaderLinks)("currentLanguageLabelText", ctx_r41.Spa_HeaderFooter_Language_Label_Text)("hideContactUsLink", ctx_r41.Spa_HeaderFooter_HideContactUs_Link)("motionPointEnabled", ctx_r41.MotionPoint_WidgetEnabled)("showPrintLink", ctx_r41.Spa_HeaderFooter_Print_Display)("loginWidgetEnabled", ctx_r41.Spa_Site_Login_Widget_Enabled)("isPPCSite", ctx_r41.isPPCSite)("weglotMultiLanguageEnabled", ctx_r41.Spa_Weglot_MultiLanguage_Enabled);
} }
function DynamicHeaderComponent_ng_container_0_header_3_img_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 57);
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("src", ctx_r42.getPrimaryLogo(), i0.ɵɵsanitizeUrl)("alt", ctx_r42.getPrimaryAltText());
} }
function DynamicHeaderComponent_ng_container_0_header_3_img_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 58);
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("src", ctx_r43.secondaryLogo, i0.ɵɵsanitizeUrl)("alt", ctx_r43.Spa_HeaderFooter_SecondaryLogo_Alt_Text);
} }
function DynamicHeaderComponent_ng_container_0_header_3_div_8_ng_container_1_vnext_locale_picker_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-locale-picker", 76);
} if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("headerDropdown", true)("link", ctx_r49.languageLink)("currentLanguageLabelText", ctx_r49.Spa_HeaderFooter_Language_Label_Text)("showLastBorder", false)("weglotMultiLanguageEnabled", ctx_r49.Spa_Weglot_MultiLanguage_Enabled);
} }
function DynamicHeaderComponent_ng_container_0_header_3_div_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 61, 62)(3, "button", 63);
    i0.ɵɵlistener("click", function DynamicHeaderComponent_ng_container_0_header_3_div_8_ng_container_1_Template_button_click_3_listener($event) { i0.ɵɵrestoreView(_r51); const _r48 = i0.ɵɵreference(2); const ctx_r50 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r50.toggleDropdown(_r48, $event)); });
    i0.ɵɵelement(4, "i", 64);
    i0.ɵɵelementStart(5, "span", 65);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 66);
    i0.ɵɵelement(8, "div", 67);
    i0.ɵɵelementStart(9, "div")(10, "span", 68);
    i0.ɵɵlistener("click", function DynamicHeaderComponent_ng_container_0_header_3_div_8_ng_container_1_Template_span_click_10_listener() { i0.ɵɵrestoreView(_r51); const _r48 = i0.ɵɵreference(2); return i0.ɵɵresetView(_r48.close()); })("keyup.enter", function DynamicHeaderComponent_ng_container_0_header_3_div_8_ng_container_1_Template_span_keyup_enter_10_listener() { i0.ɵɵrestoreView(_r51); const _r48 = i0.ɵɵreference(2); return i0.ɵɵresetView(_r48.close()); });
    i0.ɵɵelementStart(11, "span", 69);
    i0.ɵɵtext(12, "Close");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "i", 70);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 71)(15, "div", 72);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 73);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "phone");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 74);
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(22, DynamicHeaderComponent_ng_container_0_header_3_div_8_ng_container_1_vnext_locale_picker_22_Template, 1, 5, "vnext-locale-picker", 75);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r48 = i0.ɵɵreference(2);
    const ctx_r45 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-expanded", _r48.isOpen());
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r45.Spa_HeaderFooter_MenuTitle, " ");
    i0.ɵɵadvance(10);
    i0.ɵɵtextInterpolate(ctx_r45.agentName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(19, 6, ctx_r45.agentPhone, ctx_r45.locale.slice(3)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r45.agentEmail);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r45.MotionPoint_WidgetEnabled);
} }
function DynamicHeaderComponent_ng_container_0_header_3_div_8_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-agent-container", 77);
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("brokerText", ctx_r47.Spa_HeaderFooter_Broker)("isLoggedIn", false)("agentData", ctx_r47.agentData)("locale", ctx_r47.locale)("closeText", ctx_r47.Spa_Site_Close)("agentHeaderLocalePickerEnabled", ctx_r47.agentHeaderLocalePickerEnabled)("currentLanguageLabelText", ctx_r47.Spa_HeaderFooter_Language_Label_Text)("languageLink", ctx_r47.languageLink)("motionPointEnabled", ctx_r47.MotionPoint_WidgetEnabled)("weglotMultiLanguageEnabled", ctx_r47.Spa_Weglot_MultiLanguage_Enabled)("isMobile", ctx_r47.isMobile);
} }
function DynamicHeaderComponent_ng_container_0_header_3_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵtemplate(1, DynamicHeaderComponent_ng_container_0_header_3_div_8_ng_container_1_Template, 23, 9, "ng-container", 14);
    i0.ɵɵtemplate(2, DynamicHeaderComponent_ng_container_0_header_3_div_8_ng_template_2_Template, 1, 11, "ng-template", null, 60, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r46 = i0.ɵɵreference(3);
    const ctx_r44 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r44.type === "soa" && ctx_r44.isMobile)("ngIfElse", _r46);
} }
function DynamicHeaderComponent_ng_container_0_header_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "header")(1, "div");
    i0.ɵɵtemplate(2, DynamicHeaderComponent_ng_container_0_header_3_vnext_sub_header_2_Template, 1, 9, "vnext-sub-header", 50);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 51)(4, "div")(5, "div", 52);
    i0.ɵɵtemplate(6, DynamicHeaderComponent_ng_container_0_header_3_img_6_Template, 1, 2, "img", 53);
    i0.ɵɵtemplate(7, DynamicHeaderComponent_ng_container_0_header_3_img_7_Template, 1, 2, "img", 54);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, DynamicHeaderComponent_ng_container_0_header_3_div_8_Template, 4, 2, "div", 55);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.type === "shareprescription");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r4.primaryLogo);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.secondaryLogo);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.Spa_Site_Broker_Info_Enabled && ctx_r4.isBrokerInfoEnabled);
} }
function DynamicHeaderComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicHeaderComponent_ng_container_0_header_1_Template, 15, 44, "header", 1);
    i0.ɵɵtemplate(2, DynamicHeaderComponent_ng_container_0_header_2_Template, 6, 2, "header", 0);
    i0.ɵɵtemplate(3, DynamicHeaderComponent_ng_container_0_header_3_Template, 9, 4, "header", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.type === "default");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.type === "basic");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.type === "soa" || ctx_r0.type === "shareprescription");
} }
function DynamicHeaderComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-talking-point-sidenav", 78);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("talkingPoints", ctx_r1.filteredTalkingPoints)("currentPath", ctx_r1.currentPath)("talkingPointsTitle", ctx_r1.Spa_Site_DisplayTalkingPoints_Title)("dropdownDefaultText", ctx_r1.Spa_Site_TalkingPoints_Dropdown_Default_Text)("isSideNavOpen", ctx_r1.Spa_Site_DisplayTalkingPoints_By_Default);
} }
let DynamicHeaderComponent = class DynamicHeaderComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, navigationService, loginService, siteService, profileFacade, localeService, navigationUtilityService, navigationContext, shoppingCartService, planFacade, memberSessionService, speakWithAgentFacade, analyticsService, agentService, shoppingRecordingContextService, twilioService, deactivationGuardService, planYearResourceService, enrollmentService, route) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.navigationService = navigationService;
        this.loginService = loginService;
        this.siteService = siteService;
        this.profileFacade = profileFacade;
        this.localeService = localeService;
        this.navigationUtilityService = navigationUtilityService;
        this.navigationContext = navigationContext;
        this.shoppingCartService = shoppingCartService;
        this.planFacade = planFacade;
        this.memberSessionService = memberSessionService;
        this.speakWithAgentFacade = speakWithAgentFacade;
        this.analyticsService = analyticsService;
        this.agentService = agentService;
        this.shoppingRecordingContextService = shoppingRecordingContextService;
        this.twilioService = twilioService;
        this.deactivationGuardService = deactivationGuardService;
        this.planYearResourceService = planYearResourceService;
        this.enrollmentService = enrollmentService;
        this.route = route;
        this.headerType = 'default';
        this.isBrokerInfoEnabled = true;
        this.primaryLogo = '';
        this.secondaryLogo = '';
        this.broker = '';
        this.Spa_Site_SiteType = SiteType.CONSUMER;
        this.Spa_ShoppingCart_Enabled = true;
        this.Spa_Site_Login_Widget_Enabled = true;
        this.Spa_Site_Broker_Info_Enabled = true;
        this.Spa_Site_Profile_Enabled = true;
        this.Spa_Site_Cart_Text = 'Cart';
        this.Spa_HeaderFooter_PrimaryClientLogo = '';
        this.Spa_HeaderFooter_SecondaryClientLogo = '';
        this.Spa_HeaderFooter_PrimaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_HeaderFooter_SecondaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_HeaderFooter_MenuTitle = 'Menu';
        this.Spa_HeaderFooter_Broker = 'Licensed Agent';
        this.Spa_HeaderFooter_SubHeaderLinks = [];
        this.Spa_HeaderFooter_PrimaryLogo_Alt_Text = 'Go to [Your Client Name] home page';
        this.Spa_HeaderFooter_SecondaryLogo_Alt_Text = 'Go to [Your Client Name] home page';
        this.Spa_HeaderFooter_PrimaryClientLogo_UsePlanLogo = false;
        this.Spa_HeaderFooter_HideContactUs_Link = false;
        this.Spa_AgentReports_Header_Text = 'Reports';
        this.Spa_HeaderFooter_Language_Label_Text = 'Current Language : ';
        this.Spa_Site_Show_Header = true;
        this.Spa_Site_Header_Type = 'default';
        this.Spa_Site_Close = 'Close';
        this.MotionPoint_WidgetEnabled = false;
        this.Spa_HeaderFooter_Print_Display = false;
        this.Spa_HeaderFooter_Language_Display = true;
        this.Spa_Site_SpeakWithAgent_Enabled = true;
        this.Spa_SpeakWithAgent_Link_Text = '<div class="speak-with-agent-link-top Spa_Style_Small_Font">Speak with a</div> <div class="Spa_Style_Label speak-with-agent-link-bottom">licensed agent<i class="fas fa-chevron-down pl-1"></i></div>';
        this.Spa_SpeakWithAgent_Header_Text = 'Speak with a licensed agent.';
        this.Spa_SpeakWithAgent_ContactInfo_Text = '<div>(555) 555-555 (TTY 555)</div><div>Mon - Fri 8am - 6pm ET</div>';
        this.Spa_SpeakWithAgent_ShowUniqueCode_Enabled = false;
        this.Spa_SpeakWithAgent_UniqueCodeDescription_Text = 'When you call, give the agent your personal code so they can pick up where you left off.';
        // Copied from login-container.component.ts, so they show up in client admin
        this.Spa_LoginWidget_Username_Text = 'Email or username';
        this.Spa_LoginWidget_Password_Text = 'Password';
        this.Spa_LoginWidget_Login_Header_Text = 'Login';
        this.Spa_LoginWidget_Login_Title_Text = 'Login';
        this.Spa_LoginWidget_Login_Submit_Text = 'Login';
        this.Spa_Login_Error_Message = 'Please provide valid login credentials.';
        this.Spa_LoginWidget_Logout_Text = 'Logout';
        this.Spa_LoginWidget_Create_Account_Display = true;
        this.Spa_LoginWidget_Create_Account_Label_Text = 'No account? Create your own in a matter of minutes';
        this.Spa_LoginWidget_Create_Account_Button_Text = 'Create account';
        this.Spa_LoginWidget_LoginToAccount_Text = 'Or login to your account';
        this.Spa_LoginWidget_LoginToAccount_ClickableText = 'login';
        this.Spa_LoginWidget_AccountOverview_Text = 'Account overview';
        this.Spa_Site_Agent_AccountOverview_Enabled = true;
        this.Spa_Site_ErrorKeyword_Text = 'Error:';
        this.Spa_Site_AgentReports_Enabled = false;
        this.Spa_Site_AgentReports_AdminOnly_Enabled = false;
        this.Spa_Consumer_AccountOverview_Header_Text = 'Account Overview';
        this.Spa_Site_CustomerMemberPortalIntegration_Enabled = false;
        this.Spa_Login_ForgotPasswordEmailSent_Text = 'An email has been sent.';
        this.Spa_Login_ForgotPasswordCheckEmail_Text = 'Check your email to reset your password. If you do not receive an email, try again.';
        this.Spa_Login_ForgotPasswordInstructions_Text = 'Enter your username or email and then check your email to continue.';
        this.Spa_Login_ForgotPasswordUserNameRequired_Error = 'Username is required';
        this.Spa_Login_ForgotPasswordInvalidUserName_Error = 'The username is not associated with an account. Please create an account.';
        this.Spa_Profile_Username_Label = 'Username';
        this.Spa_Login_ForgotPasswordSendEmail_Text = 'Send email';
        this.Spa_Login_ForgotPasswordHeader_Text = 'Forgot Password';
        this.Spa_Login_ForgotPasswordEmailFailed_Error = 'Email not sent. Try again later.';
        this.Spa_Login_ForgotPasswordLink_Enabled = true;
        this.Spa_Login_ForgotPasswordLink_Text = 'Forgot password?';
        this.Spa_Agent_Profile_Picture_Upload_Enabled = false;
        this.Spa_Login_ForgotUsernameLink_Enabled = true;
        this.Spa_Login_ForgotUsernameLink_Text = 'Forgot username?';
        this.Spa_Login_EmailLabel_Text = 'Email';
        this.Spa_Login_FirstNameLabel_Text = 'First name';
        this.Spa_Login_InvalidUserEmailCombination_Error = 'This name and email is not associated with an account. Please create an account.';
        this.Spa_Login_FirstNameRequired_Error = 'Please enter first name';
        this.Spa_Login_EmailRequired_Error = 'Please provide a valid email address';
        this.Spa_Login_ForgotUsernameHeader_Text = 'Forgot username';
        this.Spa_Login_ForgotUsernameInstructions_Text = 'fEnter your first name and email address and then check your email to continue.';
        this.Spa_Login_ForgotUsernameCheckEmail_Text = 'Check your email for your username. If you do not receive an email, try again.';
        this.Spa_Site_Consumer_AccountOverview_Enabled = false;
        // End login-container keys
        this.Spa_Site_AgentCallRecordingShopping_Enabled = false;
        this.Spa_Site_AgentCallRecordingShopping_CallBeneficiary_Enabled = false;
        this.Spa_AgentCallInProgressAcceptCall_Icon = 'fas fa-phone';
        this.Spa_AgentCallEndCall_Icon = 'fas fa-phone-slash';
        this.Spa_CallRecording_StartRecording_Text = 'Start call recording';
        this.Spa_AgentCallInProgressAcceptCall_Title = 'Call in progress';
        this.Spa_AgentCallEndCall_Title = 'End call';
        this.Spa_AgentCallEnded_Title = 'Call Ended';
        this.Spa_Site_AgentCallRecordingShopping_Sticky_Enabled = true;
        this.Spa_Site_MedicareGroup_Enabled = false;
        this.Spa_Site_DisplayTalkingPoints_Shopping_Enabled = false;
        this.Spa_Site_DisplayTalkingPoints_Enrollment_Enabled = false;
        this.Spa_Site_DisplayTalkingPoints_By_Default = false;
        this.Spa_Site_DisplayTalkingPoints_Title = 'Talking points';
        this.Spa_Site_TalkingPoints_Dropdown_Default_Text = 'Select a document';
        this.Spa_Weglot_MultiLanguage_Enabled = false;
        this.siteTypeEnum = SiteType;
        this.pageTags = PageTags;
        this.siteType = SiteType;
        this.initialLoad = true;
        this.isPlanYearBadgeEnabled = false;
        this.agentHeaderLocalePickerEnabled = false;
        this.linkRoles = LinkRoles;
        this.isTalkingPointsEnabled = false;
        this.subscriptions = new Subscription();
        this.logoutMember = () => {
            if (this.siteService.isPPCSite()) {
                const callRecordingInProgress = this.twilioService.isShoppingCallRecordingInProgress();
                if (callRecordingInProgress) {
                    this.shoppingRecordingContextService.displayEndCallConfirmationModal();
                }
                // We check the Deactivation guards manually to run additional operations before starting the navigation
                // This could help in cases where we have to clear the member's session only after checking all Deactivation guards
                this.deactivationGuardService.canDeactivate().then(canDeactivate => {
                    if (canDeactivate) {
                        const siteLogoTag = this.siteLogoTag || this.Spa_HeaderFooter_PrimaryClientLogo_Url[0].tag;
                        this.profileFacade.logOutMember(true);
                        // We skip the next canDeactivate() check triggered automatically by the navigation because we already checked it manually
                        this.deactivationGuardService.setDeactivationGuardStatus(DeactivationGuardStatus.SKIP_NEXT_CAN_DEACTIVATE_CHECK);
                        return this.navigationService.navigateByPageTag(siteLogoTag);
                    }
                });
            }
            else {
                this.profileFacade.logOutMember(true);
            }
        };
        this.submitLogoAction = (logoDetails, siteLogoTag) => {
            if ((logoDetails &&
                logoDetails.length &&
                ((logoDetails[0].tag && (logoDetails[0].tag === PageTags.HOME || logoDetails[0].tag === PageTags.RETENTION)) ||
                    (!logoDetails[0].tag && !logoDetails[0].href))) ||
                (siteLogoTag && (siteLogoTag === PageTags.HOME || siteLogoTag === PageTags.RETENTION))) {
                const page = this.navigationUtilityService.getCurrentPage();
                if (page.tags.includes(PageTags.ENROLLMENT_CONFIRMATION)) {
                    this.logoutMember();
                }
            }
        };
    }
    get isPPCSite() {
        return this.siteService.isPPCSite(this.Spa_Site_SiteType);
    }
    ngOnInit() {
        super.ngOnInit();
        // We intentionally do not want this resource as part of the keys on platform admin.
        // But since this resource will be page configured, we need to pass that page name in.
        // Normally that's not required, it's handled via GlobalResource/PlatformProp.
        this.isPlanYearBadgeEnabled = this.planYearResourceService.getIsHeaderPlanYearBadgeEnabled(this.widgetService.widgetName, this.navigationContext.getUrl().substring(1) // url will be something like '/Shopping/Planlist'
        );
        this.type = this.Spa_Site_Header_Type && this.Spa_Site_Header_Type !== 'default' ? this.Spa_Site_Header_Type : this.headerType;
        this.medicareGroupPlanConfig = this.planFacade.getMedicareGroupPlanConfiguration();
        const isEnrollmentPage = this.enrollmentService.getPageIsEnrollment();
        this.isTalkingPointsEnabled =
            (this.Spa_Site_DisplayTalkingPoints_Shopping_Enabled && !isEnrollmentPage) ||
                (isEnrollmentPage && this.Spa_Site_DisplayTalkingPoints_Enrollment_Enabled);
        if (this.Spa_Site_MedicareGroup_Enabled && this.medicareGroupPlanConfig) {
            this.getMedicareGroupLogo();
        }
        else {
            this.primaryLogo = this.getFormattedLogo(this.primaryLogo?.length > 0 ? this.primaryLogo : this.Spa_HeaderFooter_PrimaryClientLogo);
            this.Spa_HeaderFooter_PrimaryClientLogo_Url = this.primaryLogoUrl?.length
                ? this.primaryLogoUrl
                : this.Spa_HeaderFooter_PrimaryClientLogo_Url;
            this.secondaryLogo = this.getFormattedLogo(this.secondaryLogo?.length ? this.secondaryLogo : this.Spa_HeaderFooter_SecondaryClientLogo);
            this.Spa_HeaderFooter_SecondaryClientLogo_Url = this.secondaryLogoUrl?.length
                ? this.secondaryLogoUrl
                : this.Spa_HeaderFooter_SecondaryClientLogo_Url;
        }
        this.navigationContext.getUrl$().subscribe(url => {
            this.currentPath = url?.substring(1).split('?')[0];
            this.cdr.markForCheck();
        });
        if (this.isTalkingPointsEnabled && this.type === 'default') {
            const unfilteredTalkingPoints = this.agentService.getTalkingPoints();
            if (unfilteredTalkingPoints?.length) {
                this.filteredTalkingPoints = this.getFilteredTalkingPoints(unfilteredTalkingPoints, isEnrollmentPage);
            }
            else {
                this.agentService.fetchTalkingPoints();
            }
        }
        this.setBroker(this.broker);
        this.agentHeaderLocalePickerEnabled = this.type === 'soa' && this.Spa_HeaderFooter_Language_Display;
        this.languageLink = this.Spa_HeaderFooter_SubHeaderLinks.find(link => link.action === SubHeaderActions.LANGUAGE);
        // Display Plan logo instead of Primary logo on Enrollment, ShoppingCart and MedsupInterim pages
        // based on the resource Spa_HeaderFooter_PrimaryClientLogo_UsePlanLogo
        this.showPlanLogo = this.getIsPlanLogoReqdPage();
        const shoppingCartPlan = this.shoppingCartService.getSelectedPlan();
        this.currentPlanLogo = this.getFormattedLogo(this.planFacade.getPlanLogoUrl(shoppingCartPlan));
        this.agentLoggedIn$ = this.loginService.agentLoggedIn$;
        this.memberLoggedIn$ = this.loginService.memberLoggedIn$;
        this.siteLogoTag$ = this.siteService.getSiteLogoTag$();
        this.subscriptions.add(this.siteService.getSiteLogoTag$().subscribe({
            next: siteLogoTag => {
                this.siteLogoTag = siteLogoTag;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.loginService.loggedIn$().subscribe({
            next: loggedIn => {
                this.isUserLoggedIn = loggedIn;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.loginService.agentLoggedIn$.subscribe({
            next: agentLoggedIn => {
                this.isAgentLoggedIn = agentLoggedIn;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.speakWithAgentFacade.canDisplayUniqueCode$().subscribe({
            next: canDisplayUniqueCode => {
                this.displayUniqueCode = canDisplayUniqueCode;
                this.updateUniqueCodeTag();
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.session$.subscribe({
            next: session => {
                this.uniqueCode = this.memberSessionService.getUniqueCode(session);
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe({
            next: locale => {
                this.locale = locale;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(combineLatest([this.siteService.isRetentionView$(), this.siteService.isQuotingSite$()]).subscribe({
            next: ([isRetentionView, isQuotingSite]) => {
                this.isRetentionView = isRetentionView;
                this.logoClass = this.getLogoClass(this.isPPCSite, isRetentionView, isQuotingSite, this.secondaryLogo);
                this.logoWrapperClass = this.getLogoWrapperClass(this.isPPCSite, isRetentionView, isQuotingSite, this.secondaryLogo);
                this.alignmentClass = this.getAlignmentClass(this.isPPCSite, isRetentionView, isQuotingSite);
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.loginService.loggedIn$().subscribe({
            next: loggedIn => {
                this.primaryLoggedIn = loggedIn;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.agentService.getAgentData$().subscribe({
            next: agentData => {
                this.agentData = agentData;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.agentService.getTalkingPoints$().subscribe({
            next: unfilteredTalkingPoints => {
                if (unfilteredTalkingPoints?.length) {
                    this.filteredTalkingPoints = this.getFilteredTalkingPoints(unfilteredTalkingPoints, isEnrollmentPage);
                }
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.showAgentHeader$.subscribe({
            next: showAgentHeader => {
                this.showAgentHeader = showAgentHeader;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.planYearResourceService.getSelectedPlanYear$().subscribe({
            next: planYear => {
                this.badgePlanYear = planYear;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.isMobile$.pipe(filter(compact => this.isMobile !== compact)).subscribe(compact => {
            this.isMobile = compact;
            this.cdr.markForCheck();
        }));
        if (this.type === 'soa') {
            this.subscriptions.add(combineLatest([
                this.agentService.getBrokerEmail$(),
                this.agentService.getBrokerPhoneNumber$(),
                this.agentService.getBrokerFullName$()
            ])
                .pipe(filter(([agentEmail, agentPhone, agentName]) => !!agentEmail || !!agentPhone || !!agentName))
                .subscribe({
                next: ([agentEmail, agentPhone, agentName]) => {
                    this.agentEmail = agentEmail;
                    this.agentPhone = agentPhone;
                    this.agentName = agentName;
                    this.cdr.markForCheck();
                }
            }));
        }
        this.initialLoad = false;
        this.cdr.markForCheck();
    }
    ngOnChanges(changes) {
        const broker = changes.broker;
        if (broker && !broker.firstChange && broker.previousValue !== broker.currentValue) {
            this.setBroker(this.broker);
        }
    }
    getFilteredTalkingPoints(talkingPoints, isEnrollment) {
        const documentType = isEnrollment ? TalkingPointPageType.ENROLLMENT : TalkingPointPageType.SHOPPING;
        return talkingPoints.filter(point => point.documentType === documentType);
    }
    goHome() {
        this.navigationService.navigateByPageTag(PageTags.HOME);
    }
    getFormattedLogo(logo) {
        const formatLogo = logo ? logo.substr(logo.lastIndexOf('.') + 1) : '';
        const validFormats = ['jpg', 'jpeg', 'gif', 'png', 'svg'];
        if (!validFormats.includes(formatLogo.toLowerCase())) {
            return '';
        }
        return logo;
    }
    getIsPlanLogoReqdPage() {
        return (this.navigationUtilityService.pageTagURLMatch(PageTags.ENROLLMENT, this.navigationContext.getUrl()) ||
            this.navigationUtilityService.pageTagURLMatch(PageTags.ENROLLMENT_CONFIRMATION, this.navigationContext.getUrl()) ||
            this.navigationUtilityService.pageTagURLMatch(PageTags.ENROLLMENT_DENTAL, this.navigationContext.getUrl()) ||
            this.navigationUtilityService.pageTagURLMatch(PageTags.SHOPPING_CART, this.navigationContext.getUrl()) ||
            this.navigationUtilityService.pageTagURLMatch(PageTags.MEDIGAP_INTERIM, this.navigationContext.getUrl()));
    }
    getPrimaryLogo() {
        if (this.Spa_HeaderFooter_PrimaryClientLogo_UsePlanLogo && this.showPlanLogo) {
            return this.currentPlanLogo;
        }
        return this.primaryLogo;
    }
    getPrimaryAltText() {
        if (this.Spa_HeaderFooter_PrimaryClientLogo_UsePlanLogo && this.showPlanLogo) {
            return '';
        }
        return this.Spa_HeaderFooter_PrimaryLogo_Alt_Text;
    }
    toggleDropdown(dropdown, event) {
        event.stopPropagation();
        return dropdown.isOpen() ? dropdown.close() : dropdown.open();
    }
    getMedicareGroupLogo() {
        this.primaryLogo = this.getFormattedLogo(this.medicareGroupPlanConfig?.headerFooterPrimaryClientLogo?.imageUrl);
        this.secondaryLogo = this.getFormattedLogo(this.medicareGroupPlanConfig?.headerFooterSecondaryClientLogo?.imageUrl);
        this.medicareGroupQueryParams = { MedicareGroupID: this.medicareGroupPlanConfig?.medicareGroupId };
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
    setBroker(broker) {
        this.Spa_HeaderFooter_Broker = this.broker && this.broker.length > 0 ? this.broker : this.Spa_HeaderFooter_Broker;
    }
    updateUniqueCodeTag() {
        const googleDataLayerTags = this.analyticsService.googleDataLayerTags;
        const uniqueCode = this.speakWithAgentFacade.getUniqueCode() || GOOGLE_ANALYTICS_NOT_APPLICABLE;
        if (!this.initialLoad && googleDataLayerTags[DataLayerGlobalVariable.MEMBER_ASSIST_CODE] !== uniqueCode) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.MEMBER_ASSIST_CODE, uniqueCode);
        }
    }
    getLogoClass(isPPCSite, isRetentionView, isQuotingSite, secondaryLogo) {
        let logoClass = 'header-primary-logo';
        if (isPPCSite || isQuotingSite || isRetentionView) {
            logoClass = secondaryLogo ? 'header-logo-broker' : 'header-primary-logo-broker';
        }
        else if (secondaryLogo) {
            logoClass = 'header-logo';
        }
        return logoClass;
    }
    getLogoWrapperClass(isPPCSite, isRetentionView, isQuotingSite, secondaryLogo) {
        let logoWrapperClass = 'header-primary-logo';
        if (isPPCSite || isQuotingSite || isRetentionView) {
            logoWrapperClass = secondaryLogo ? 'primary-logo-broker' : 'header-primary-logo-broker';
        }
        else if (secondaryLogo) {
            logoWrapperClass = 'primary-logo';
        }
        return logoWrapperClass;
    }
    getAlignmentClass(isPPCSite, isRetentionView, isQuotingSite) {
        let alignmentClass = 'sub-header-container-alignment sub-header-margin';
        if (isPPCSite) {
            alignmentClass = 'sub-header-alignment sub-header-broker-alignment';
        }
        else if (isQuotingSite || isRetentionView) {
            alignmentClass = 'sub-header-alignment';
        }
        return alignmentClass;
    }
};
DynamicHeaderComponent.ɵfac = function DynamicHeaderComponent_Factory(t) { return new (t || DynamicHeaderComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.LoginService), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(ProfileFacade), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(i1.NavigationContext), i0.ɵɵdirectiveInject(i1.ShoppingCartService), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(SpeakWithAgentFacade), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(i1.ShoppingRecordingContextService), i0.ɵɵdirectiveInject(i1.TwilioDeviceService), i0.ɵɵdirectiveInject(i1.DeactivationGuardService), i0.ɵɵdirectiveInject(i1.PlanYearResourceService), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute)); };
DynamicHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DynamicHeaderComponent, selectors: [["vnext-dynamic-header"]], inputs: { headerType: "headerType", isBrokerInfoEnabled: "isBrokerInfoEnabled", primaryLogo: "primaryLogo", primaryLogoUrl: "primaryLogoUrl", secondaryLogo: "secondaryLogo", secondaryLogoUrl: "secondaryLogoUrl", broker: "broker" }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[4, "ngIf"], [3, "ngClass", 4, "ngIf"], [3, "ngClass"], [1, "nav-bar", "container", "justify-content-between", "align-items-center", "align-items-sm-end", 3, "ngClass"], [1, "row", "logo-wrapper", 3, "ngClass"], [3, "class", 4, "ngIf"], ["class", "col-md-5 logo-header secondary-logo", 4, "ngIf"], ["class", "d-block d-sm-none header-menu mr-1", 4, "ngIf"], [1, "header-links", "d-none", "d-sm-flex", "options", "align-items-center", "justify-content-end"], [1, "d-flex", "flex-column", "justify-content-between", "align-items-center"], [1, "row", "sub-header-alignment", 3, "ngClass"], [1, "sub-header"], [1, "d-none", "d-sm-block", 3, "linkContainerClass", "links", "currentLanguageLabelText", "isFocusSkipToContent", "hideContactUsLink", "motionPointEnabled", "showPrintLink", "loginWidgetEnabled", "isPPCSite", "showPlanYearBadge", "planYear", "weglotMultiLanguageEnabled"], [3, "isPPCSite", "shoppingRecordingEnabled", "shoppingRecordingCallBeneficiaryEnabled", "shoppingRecordingStickyEnabled", "iconClass", "endCallIconClass", "callRecordingText", "callInProgressText", "endCallText", "callEndedText"], [4, "ngIf", "ngIfElse"], ["showDefaultLogo", ""], ["showPrimaryClientLogo", ""], [3, "tag", "linkTarget", "onClickAction", 4, "ngIf"], [3, "href", "tag", "queryParams", "linkTarget", "role"], ["tag-image-body", ""], [3, "alt", "src"], ["href-image-body", ""], [3, "href", "tag", "linkTarget", "onClickAction", "isLinkButton", "role"], [3, "tag", "linkTarget", "onClickAction"], [1, "col-md-5", "logo-header", "secondary-logo"], ["showDefaultSecondaryLogo", ""], ["showSecondaryClientLogo", ""], [3, "tag", "href", "linkTarget", "onClickAction"], [1, "d-block", "d-sm-none", "header-menu", "mr-1"], [3, "isRetention", "menuTitle", "links", "isProfileSearchEnabled", "isPPCSite", "brokerText", "agentLoggedIn", "agentData", "brokerInfoEnabled", "isUserLoggedIn", "isShoppingCartEnabled", "primaryLoggedIn", "currentLanguageLabelText", "locale", "hideContactUsLink", "closeText", "motionPointEnabled", "cartText", "showPrintLink", "speakWithAgentContactInfo", "speakWithAgentEnabled", "speakWithAgentHeader", "uniqueCode", "displayUniqueCode", "uniqueCodeText", "showPlanYearBadge", "planYear", "weglotMultiLanguageEnabled", "isMobile"], ["class", "d-block d-sm-none", 4, "ngIf"], [1, "d-block", "d-sm-none"], ["speakWithAgentSection", ""], ["class", "row d-none d-sm-flex mt-1", 4, "ngIf", "ngIfElse"], ["class", "ml-4 ml-sm-3 ml-md-4 pl-3", 3, "ngClass", 4, "ngIf"], ["class", "profile-section", 4, "ngIf"], ["class", "mt-1 ml-4 ml-sm-3 ml-md-4", 4, "ngIf"], [3, "headerText", "linkText", "contactInfo", "uniqueCode", "uniqueCodeText", "displayUniqueCode", "closeText"], [1, "row", "d-none", "d-sm-flex", "mt-1"], [3, "brokerText", "agentData", "locale", "closeText", "uniqueCodeText", "uniqueCode", "displayUniqueCode", "isAgentProfilePictureEnabled", "weglotMultiLanguageEnabled", "isMobile", 4, "ngIf", "ngIfElse"], [3, "brokerText", "agentData", "locale", "closeText", "uniqueCodeText", "uniqueCode", "displayUniqueCode", "isAgentProfilePictureEnabled", "weglotMultiLanguageEnabled", "isMobile"], [1, "ml-4", "ml-sm-3", "ml-md-4", "pl-3", 3, "ngClass"], [3, "label"], [1, "profile-section"], [1, "mt-1", "ml-4", "ml-sm-3", "ml-md-4"], [1, "container", "d-flex", "justify-content-center"], [3, "href", "tag", "linkTarget", 4, "ngIf", "ngIfElse"], ["showBasicPrimaryClientLogo", ""], [3, "href", "tag", "linkTarget"], ["showBasicSecondaryClientLogo", ""], ["class", "d-none d-md-block", 3, "linkContainerClass", "links", "currentLanguageLabelText", "hideContactUsLink", "motionPointEnabled", "showPrintLink", "loginWidgetEnabled", "isPPCSite", "weglotMultiLanguageEnabled", 4, "ngIf"], [1, "container", "d-flex", "justify-content-between", "align-items-center", "align-items-md-end", "pt-1"], [1, "my-auto"], ["class", "header-primary-logo basic-primary-logo", 3, "src", "alt", 4, "ngIf"], ["class", "header-primary-logo", 3, "src", "alt", 4, "ngIf"], ["class", "justify-content-end my-auto", 4, "ngIf"], [1, "d-none", "d-md-block", 3, "linkContainerClass", "links", "currentLanguageLabelText", "hideContactUsLink", "motionPointEnabled", "showPrintLink", "loginWidgetEnabled", "isPPCSite", "weglotMultiLanguageEnabled"], [1, "header-primary-logo", "basic-primary-logo", 3, "src", "alt"], [1, "header-primary-logo", 3, "src", "alt"], [1, "justify-content-end", "my-auto"], ["sharedPrescription", ""], ["ngbDropdown", "", "placement", "bottom-right", "ngbDropdownAnchor", "", 1, "dropdown-container"], ["headerMenuDropdown", "ngbDropdown"], ["id", "dropdownMenuButton", 1, "menu-button", "btn", "p-0", "Spa_Style_Paragraph", 3, "click"], [1, "fas", "fa-bars"], [1, "pl-1"], ["ngbDropdownMenu", "", "aria-labelledby", "dropdownMenuButton", 1, "menu", "pl-2", "pb-0"], [1, "arrow"], ["tabindex", "0", "role", "button", 1, "soa-header-close", "can-click", 3, "click", "keyup.enter"], [1, "sr-only"], [1, "fa", "fa-times", "Spa_Style_Primary_Color"], [1, "agent-info", "Spa_Style_Primary_Color", "px-2"], [1, "agent-name", "Spa_Style_Larger_Font", "pt-3"], [1, "agent-phone", "Spa_Style_Small_Font", "pt-2"], [1, "agent-email", "Spa_Style_Small_Font", "pt-2"], ["class", "col-12", 3, "headerDropdown", "link", "currentLanguageLabelText", "showLastBorder", "weglotMultiLanguageEnabled", 4, "ngIf"], [1, "col-12", 3, "headerDropdown", "link", "currentLanguageLabelText", "showLastBorder", "weglotMultiLanguageEnabled"], [3, "brokerText", "isLoggedIn", "agentData", "locale", "closeText", "agentHeaderLocalePickerEnabled", "currentLanguageLabelText", "languageLink", "motionPointEnabled", "weglotMultiLanguageEnabled", "isMobile"], [3, "talkingPoints", "currentPath", "talkingPointsTitle", "dropdownDefaultText", "isSideNavOpen"]], template: function DynamicHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, DynamicHeaderComponent_ng_container_0_Template, 4, 3, "ng-container", 0);
        i0.ɵɵtemplate(1, DynamicHeaderComponent_ng_container_1_Template, 2, 5, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.Spa_Site_Show_Header);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.type === "default" && ctx.isTalkingPointsEnabled && !ctx.isMobile);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, LinkComponent, IconAriaAttributesDirective, i1$1.NgbDropdown, i1$1.NgbDropdownAnchor, i1$1.NgbDropdownMenu, AgentContainerComponent, LoginContainerComponent, ShoppingCartIconComponent, ProfileNavigationBarComponent, TalkingPointSideNavComponent, SubHeaderComponent, CallRecordingStickyBoxComponent, HeaderMenuDropdownComponent, LocalePickerComponent, SpeakWithAgentComponent, PhonePipe], styles: ["header[_ngcontent-%COMP%]{box-shadow:-4px 4px 3px 0 var(--static-Spa_Style_Accent1);z-index:900;box-sizing:border-box;position:relative}.nav-bar[_ngcontent-%COMP%]{display:flex;justify-content:space-between;flex-direction:row;align-items:center!important}.nav-bar[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:1}.options[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:flex-end}.options[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{text-align:center}.options[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:last-of-type{margin-right:0}.header-menu[_ngcontent-%COMP%]{padding-left:24px}.logo-wrapper[_ngcontent-%COMP%]{max-width:350px;flex-wrap:nowrap}.logo-wrapper-margin-left[_ngcontent-%COMP%]{margin-left:-5px}.sub-header-margin[_ngcontent-%COMP%]{margin-bottom:8px}.primary-logo[_ngcontent-%COMP%], .primary-logo-broker[_ngcontent-%COMP%]{padding:6px}.basic-primary-logo[_ngcontent-%COMP%]{margin-right:10px}.secondary-logo[_ngcontent-%COMP%]{padding:6px 0 6px 12px}.header-logo[_ngcontent-%COMP%], .primary-logo[_ngcontent-%COMP%], .secondary-logo[_ngcontent-%COMP%]{max-width:290px;max-height:80px;display:flex;align-items:center;-ms-flex:1 0 auto}.header-primary-logo[_ngcontent-%COMP%], .header-primary-logo-broker[_ngcontent-%COMP%]{max-width:350px;max-height:80px}.header-logo-broker[_ngcontent-%COMP%], .primary-logo-broker[_ngcontent-%COMP%]{max-width:220px;max-height:80px;display:flex;align-items:center;-ms-flex:1 0 auto}.header-links[_ngcontent-%COMP%]{margin:auto 0}.profile-section[_ngcontent-%COMP%]{min-width:300px}.sub-header-alignment[_ngcontent-%COMP%]{margin-left:auto}.unique-code-text[_ngcontent-%COMP%]{white-space:break-spaces}@media print{.sub-header-alignment[_ngcontent-%COMP%], .sub-header-container-alignment[_ngcontent-%COMP%]{margin-left:auto;margin-right:0}}@media (min-width: 1024px){.sub-header-broker-alignment[_ngcontent-%COMP%]{margin-top:8px}.sub-header-alignment[_ngcontent-%COMP%]{margin-left:auto}.sub-header-container-alignment[_ngcontent-%COMP%]{margin-left:auto;margin-right:0;align-items:center}}@media (min-width: 810px) and (max-width: 1024px){.sub-header-alignment[_ngcontent-%COMP%]{margin-left:auto}.sub-header-container-alignment[_ngcontent-%COMP%]{margin-left:auto;margin-right:0}.header-logo[_ngcontent-%COMP%]{max-height:80px;max-width:275px}.header-logo-broker[_ngcontent-%COMP%], .primary-logo-broker[_ngcontent-%COMP%]{max-width:227px;max-height:80px}.profile-section[_ngcontent-%COMP%]{min-width:291px}}@media (min-width: 768px) and (max-width: 809.98px){.header-logo[_ngcontent-%COMP%]{max-height:80px;max-width:165px}.header-logo-broker[_ngcontent-%COMP%], .primary-logo-broker[_ngcontent-%COMP%]{max-width:131px;max-height:80px}.profile-section[_ngcontent-%COMP%]{min-width:270px}.header-primary-logo-broker[_ngcontent-%COMP%]{max-width:270px;max-height:80px}}@media (max-width: 767.98px){.nav-bar[_ngcontent-%COMP%]{align-items:center!important}.nav-bar[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{text-align:right}.nav-bar[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:first-child{text-align:left}.header-logo[_ngcontent-%COMP%], .primary-logo[_ngcontent-%COMP%], .secondary-logo[_ngcontent-%COMP%]{max-height:80px;max-width:170px}.header-logo-broker[_ngcontent-%COMP%], .primary-logo-broker[_ngcontent-%COMP%]{max-height:80px;max-width:145px}.logo-wrapper[_ngcontent-%COMP%]{flex-wrap:wrap}.profile-section[_ngcontent-%COMP%]{min-width:280px}.header-primary-logo[_ngcontent-%COMP%]{max-width:235px;max-height:80px}.header-primary-logo-broker[_ngcontent-%COMP%]{max-width:245px;max-height:80px}.sub-header-margin[_ngcontent-%COMP%]{margin-bottom:0}.sub-header-alignment[_ngcontent-%COMP%], .sub-header-container-alignment[_ngcontent-%COMP%]{margin-left:auto;margin-right:0}}@media (min-width: 576px) and (max-width: 767.98px){.nav-bar[_ngcontent-%COMP%]{align-items:center!important}.header-links[_ngcontent-%COMP%]{flex:1 1 auto!important}.sub-header-alignment[_ngcontent-%COMP%]{align-self:flex-end;margin-left:-20%;margin-right:0}}@media screen and (max-width: 575.98px){.nav-bar[_ngcontent-%COMP%]   .logo-wrapper[_ngcontent-%COMP%]{flex-basis:40%}.header-primary-logo[_ngcontent-%COMP%]{max-width:100%}}.dropdown-container[_ngcontent-%COMP%]{position:static}.arrow[_ngcontent-%COMP%]{left:93%;top:-8px;position:absolute;width:1rem;height:1.5rem}.arrow[_ngcontent-%COMP%]:after{top:-1.5rem;border-width:0 1.5rem 1.5rem;position:absolute;content:\"\";border-color:transparent transparent white;border-style:solid}.dropdown-menu[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:after, .dropdown-menu[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.dropdown-menu[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:after{top:1px;border-width:0 .5rem .5rem;border-bottom-color:#fff}.dropdown-menu[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%]:before{top:0;border-width:0 .5rem .5rem;border-bottom-color:#00000040}.soa-header-close[_ngcontent-%COMP%]{position:absolute;right:15px}.agent-name[_ngcontent-%COMP%]{word-wrap:break-word;white-space:break-spaces;overflow-wrap:break-word}"], changeDetection: 0 });
__decorate([
    Select(UiState.showAgentHeader)
], DynamicHeaderComponent.prototype, "showAgentHeader$", void 0);
__decorate([
    Select(MemberState.session)
], DynamicHeaderComponent.prototype, "session$", void 0);
__decorate([
    PlatformProp()
], DynamicHeaderComponent.prototype, "Spa_Site_SiteType", void 0);
__decorate([
    PlatformProp()
], DynamicHeaderComponent.prototype, "Spa_ShoppingCart_Enabled", void 0);
__decorate([
    PlatformProp()
], DynamicHeaderComponent.prototype, "Spa_Site_Login_Widget_Enabled", void 0);
__decorate([
    PlatformProp()
], DynamicHeaderComponent.prototype, "Spa_Site_Broker_Info_Enabled", void 0);
__decorate([
    PlatformProp()
], DynamicHeaderComponent.prototype, "Spa_Site_Profile_Enabled", void 0);
__decorate([
    PlatformProp()
], DynamicHeaderComponent.prototype, "Spa_Site_Cart_Text", void 0);
__decorate([
    PlatformProp()
], DynamicHeaderComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo", void 0);
__decorate([
    PlatformProp()
], DynamicHeaderComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo", void 0);
__decorate([
    PlatformProp()
], DynamicHeaderComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo_Url", void 0);
__decorate([
    PlatformProp()
], DynamicHeaderComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo_Url", void 0);
__decorate([
    PlatformProp()
], DynamicHeaderComponent.prototype, "Spa_HeaderFooter_MenuTitle", void 0);
__decorate([
    PlatformProp()
], DynamicHeaderComponent.prototype, "Spa_HeaderFooter_Broker", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_HeaderFooter_SubHeaderLinks", void 0);
__decorate([
    PlatformProp()
], DynamicHeaderComponent.prototype, "Spa_HeaderFooter_PrimaryLogo_Alt_Text", void 0);
__decorate([
    PlatformProp()
], DynamicHeaderComponent.prototype, "Spa_HeaderFooter_SecondaryLogo_Alt_Text", void 0);
__decorate([
    PlatformProp()
], DynamicHeaderComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo_UsePlanLogo", void 0);
__decorate([
    PlatformProp()
], DynamicHeaderComponent.prototype, "Spa_HeaderFooter_HideContactUs_Link", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_AgentReports_Header_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_HeaderFooter_Language_Label_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Site_Show_Header", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Site_Header_Type", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Site_Close", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "MotionPoint_WidgetEnabled", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_HeaderFooter_Print_Display", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_HeaderFooter_Language_Display", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Site_SpeakWithAgent_Enabled", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_SpeakWithAgent_Link_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_SpeakWithAgent_Header_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_SpeakWithAgent_ContactInfo_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_SpeakWithAgent_ShowUniqueCode_Enabled", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_SpeakWithAgent_UniqueCodeDescription_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_LoginWidget_Username_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_LoginWidget_Password_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_LoginWidget_Login_Header_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_LoginWidget_Login_Title_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_LoginWidget_Login_Submit_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_Error_Message", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_LoginWidget_Logout_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_LoginWidget_Create_Account_Display", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_LoginWidget_Create_Account_Label_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_LoginWidget_Create_Account_Button_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_LoginWidget_LoginToAccount_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_LoginWidget_LoginToAccount_ClickableText", void 0);
__decorate([
    PlatformProp('live-edit')
], DynamicHeaderComponent.prototype, "Spa_LoginWidget_AccountOverview_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Site_Agent_AccountOverview_Enabled", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Site_ErrorKeyword_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Site_AgentReports_Enabled", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Site_AgentReports_AdminOnly_Enabled", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Consumer_AccountOverview_Header_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Site_CustomerMemberPortalIntegration_Enabled", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_ForgotPasswordEmailSent_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_ForgotPasswordCheckEmail_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_ForgotPasswordInstructions_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_ForgotPasswordUserNameRequired_Error", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_ForgotPasswordInvalidUserName_Error", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Profile_Username_Label", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_ForgotPasswordSendEmail_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_ForgotPasswordHeader_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_ForgotPasswordEmailFailed_Error", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_ForgotPasswordLink_Enabled", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_ForgotPasswordLink_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Agent_Profile_Picture_Upload_Enabled", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_ForgotUsernameLink_Enabled", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_ForgotUsernameLink_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_EmailLabel_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_FirstNameLabel_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_InvalidUserEmailCombination_Error", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_FirstNameRequired_Error", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_EmailRequired_Error", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_ForgotUsernameHeader_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_ForgotUsernameInstructions_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Login_ForgotUsernameCheckEmail_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Site_Consumer_AccountOverview_Enabled", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Site_AgentCallRecordingShopping_Enabled", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Site_AgentCallRecordingShopping_CallBeneficiary_Enabled", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_AgentCallInProgressAcceptCall_Icon", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_AgentCallEndCall_Icon", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_CallRecording_StartRecording_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_AgentCallInProgressAcceptCall_Title", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_AgentCallEndCall_Title", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_AgentCallEnded_Title", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Site_AgentCallRecordingShopping_Sticky_Enabled", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Site_MedicareGroup_Enabled", void 0);
__decorate([
    ResponsiveLayout(BreakPoint.COMPACT)
], DynamicHeaderComponent.prototype, "isMobile$", void 0);
__decorate([
    GlobalResource(true)
], DynamicHeaderComponent.prototype, "Spa_Site_DisplayTalkingPoints_Shopping_Enabled", void 0);
__decorate([
    GlobalResource(true)
], DynamicHeaderComponent.prototype, "Spa_Site_DisplayTalkingPoints_Enrollment_Enabled", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Site_DisplayTalkingPoints_By_Default", void 0);
__decorate([
    GlobalResource(true)
], DynamicHeaderComponent.prototype, "Spa_Site_DisplayTalkingPoints_Title", void 0);
__decorate([
    GlobalResource(true)
], DynamicHeaderComponent.prototype, "Spa_Site_TalkingPoints_Dropdown_Default_Text", void 0);
__decorate([
    GlobalResource()
], DynamicHeaderComponent.prototype, "Spa_Weglot_MultiLanguage_Enabled", void 0);
__decorate([
    Memoize()
], DynamicHeaderComponent.prototype, "getFormattedLogo", null);
__decorate([
    Memoize()
], DynamicHeaderComponent.prototype, "getLogoClass", null);
__decorate([
    Memoize()
], DynamicHeaderComponent.prototype, "getLogoWrapperClass", null);
__decorate([
    Memoize()
], DynamicHeaderComponent.prototype, "getAlignmentClass", null);
DynamicHeaderComponent = __decorate([
    PlatformWidget
], DynamicHeaderComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicHeaderComponent, [{
        type: Component,
        args: [{ selector: 'vnext-dynamic-header', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<ng-container *ngIf=\"Spa_Site_Show_Header\">\r\n  <header *ngIf=\"type === 'default'\" [ngClass]=\"{ 'pb-2': !agentData, 'pb-0': agentData }\">\r\n    <div\r\n      [ngClass]=\"{\r\n        'pt-2': !agentData,\r\n        'pt-0': agentData\r\n      }\"\r\n      class=\"nav-bar container justify-content-between align-items-center align-items-sm-end\"\r\n    >\r\n      <div class=\"row logo-wrapper\" [ngClass]=\"{ 'logo-wrapper-margin-left': secondaryLogo !== '' }\">\r\n        <div class=\"col-md-5 {{ logoWrapperClass }}\" *ngIf=\"primaryLogo\">\r\n          <ng-container *ngIf=\"Spa_Site_MedicareGroup_Enabled; else showDefaultLogo\">\r\n            <vnext-link\r\n              [href]=\"medicareGroupPlanConfig?.headerFooterPrimaryClientLogo?.href\"\r\n              [tag]=\"medicareGroupPlanConfig?.headerFooterPrimaryClientLogo?.tag\"\r\n              [queryParams]=\"medicareGroupQueryParams\"\r\n              [linkTarget]=\"medicareGroupPlanConfig?.headerFooterPrimaryClientLogo?.target\"\r\n              [role]=\"linkRoles.LINK\"\r\n            >\r\n              <div tag-image-body>\r\n                <img\r\n                  class=\"{{ logoClass }}\"\r\n                  [alt]=\"medicareGroupPlanConfig?.headerFooterPrimaryClientLogo?.alternateText\"\r\n                  [src]=\"primaryLogo\"\r\n                />\r\n              </div>\r\n              <div href-image-body>\r\n                <img\r\n                  class=\"{{ logoClass }}\"\r\n                  [alt]=\"medicareGroupPlanConfig?.headerFooterPrimaryClientLogo?.alternateText\"\r\n                  [src]=\"primaryLogo\"\r\n                />\r\n              </div>\r\n            </vnext-link>\r\n          </ng-container>\r\n          <ng-template #showDefaultLogo>\r\n            <ng-container\r\n              *ngIf=\"\r\n                Spa_HeaderFooter_PrimaryClientLogo_Url?.length && !(Spa_HeaderFooter_PrimaryClientLogo_UsePlanLogo && showPlanLogo);\r\n                else showPrimaryClientLogo\r\n              \"\r\n            >\r\n              <vnext-link\r\n                [href]=\"Spa_HeaderFooter_PrimaryClientLogo_Url[0].href\"\r\n                [tag]=\"\r\n                  siteLogoTag && Spa_HeaderFooter_PrimaryClientLogo_Url[0].tag ? siteLogoTag : Spa_HeaderFooter_PrimaryClientLogo_Url[0].tag\r\n                \"\r\n                [linkTarget]=\"Spa_HeaderFooter_PrimaryClientLogo_Url[0].target\"\r\n                [onClickAction]=\"\r\n                  Spa_Site_SiteType !== siteType.CONSUMER\r\n                    ? logoutMember\r\n                    : submitLogoAction.bind(this, Spa_HeaderFooter_PrimaryClientLogo_Url, siteLogoTag)\r\n                \"\r\n                [isLinkButton]=\"Spa_Site_SiteType === siteType.BROKER\"\r\n                [role]=\"linkRoles.LINK\"\r\n              >\r\n                <div tag-image-body>\r\n                  <img class=\"{{ logoClass }}\" [alt]=\"Spa_HeaderFooter_PrimaryLogo_Alt_Text\" [src]=\"primaryLogo\" />\r\n                </div>\r\n                <div href-image-body>\r\n                  <img class=\"{{ logoClass }}\" [alt]=\"Spa_HeaderFooter_PrimaryLogo_Alt_Text\" [src]=\"primaryLogo\" />\r\n                </div>\r\n              </vnext-link>\r\n            </ng-container>\r\n          </ng-template>\r\n          <ng-template #showPrimaryClientLogo>\r\n            <div>\r\n              <img class=\"{{ logoClass }}\" [alt]=\"getPrimaryAltText()\" [src]=\"getPrimaryLogo()\" />\r\n            </div>\r\n          </ng-template>\r\n          <vnext-link\r\n            *ngIf=\"\r\n              Spa_HeaderFooter_PrimaryClientLogo_Url?.length &&\r\n              !Spa_HeaderFooter_PrimaryClientLogo_Url[0].tag &&\r\n              !Spa_HeaderFooter_PrimaryClientLogo_Url[0].href &&\r\n              !(Spa_HeaderFooter_PrimaryClientLogo_UsePlanLogo && showPlanLogo)\r\n            \"\r\n            [tag]=\"siteLogoTag ? siteLogoTag : pageTags.HOME\"\r\n            [linkTarget]=\"Spa_HeaderFooter_PrimaryClientLogo_Url[0].target\"\r\n            [onClickAction]=\"\r\n              Spa_Site_SiteType === siteType.CONSUMER\r\n                ? submitLogoAction.bind(this, Spa_HeaderFooter_PrimaryClientLogo_Url, siteLogoTag)\r\n                : null\r\n            \"\r\n          >\r\n            <div tag-image-body>\r\n              <img class=\"{{ logoClass }}\" [alt]=\"Spa_HeaderFooter_PrimaryLogo_Alt_Text\" [src]=\"primaryLogo\" />\r\n            </div>\r\n          </vnext-link>\r\n        </div>\r\n\r\n        <div class=\"col-md-5 logo-header secondary-logo\" *ngIf=\"secondaryLogo\">\r\n          <ng-container *ngIf=\"Spa_Site_MedicareGroup_Enabled; else showDefaultSecondaryLogo\">\r\n            <vnext-link\r\n              [href]=\"medicareGroupPlanConfig?.headerFooterSecondaryClientLogo?.href\"\r\n              [tag]=\"medicareGroupPlanConfig?.headerFooterSecondaryClientLogo?.tag\"\r\n              [queryParams]=\"medicareGroupQueryParams\"\r\n              [linkTarget]=\"medicareGroupPlanConfig?.headerFooterSecondaryClientLogo?.target\"\r\n              [role]=\"linkRoles.LINK\"\r\n            >\r\n              <div tag-image-body>\r\n                <img\r\n                  class=\"{{ logoClass }}\"\r\n                  [alt]=\"medicareGroupPlanConfig?.headerFooterSecondaryClientLogo?.alternateText\"\r\n                  [src]=\"secondaryLogo\"\r\n                />\r\n              </div>\r\n              <div href-image-body>\r\n                <img\r\n                  class=\"{{ logoClass }}\"\r\n                  [alt]=\"medicareGroupPlanConfig?.headerFooterSecondaryClientLogo?.alternateText\"\r\n                  [src]=\"secondaryLogo\"\r\n                />\r\n              </div>\r\n            </vnext-link>\r\n          </ng-container>\r\n          <ng-template #showDefaultSecondaryLogo>\r\n            <ng-container\r\n              *ngIf=\"\r\n                Spa_HeaderFooter_SecondaryClientLogo_Url && Spa_HeaderFooter_SecondaryClientLogo_Url.length;\r\n                else showSecondaryClientLogo\r\n              \"\r\n            >\r\n              <vnext-link\r\n                [tag]=\"\r\n                  siteLogoTag && Spa_HeaderFooter_SecondaryClientLogo_Url[0]?.tag\r\n                    ? siteLogoTag\r\n                    : Spa_HeaderFooter_SecondaryClientLogo_Url[0].tag\r\n                \"\r\n                [href]=\"Spa_HeaderFooter_SecondaryClientLogo_Url[0].href\"\r\n                [linkTarget]=\"Spa_HeaderFooter_SecondaryClientLogo_Url[0].target\"\r\n                [onClickAction]=\"\r\n                  Spa_Site_SiteType === siteType.CONSUMER\r\n                    ? submitLogoAction.bind(this, Spa_HeaderFooter_SecondaryClientLogo_Url, siteLogoTag)\r\n                    : null\r\n                \"\r\n              >\r\n                <div tag-image-body>\r\n                  <img class=\"{{ logoClass }}\" [alt]=\"Spa_HeaderFooter_SecondaryLogo_Alt_Text\" [src]=\"secondaryLogo\" />\r\n                </div>\r\n                <div href-image-body>\r\n                  <img class=\"{{ logoClass }}\" [alt]=\"Spa_HeaderFooter_SecondaryLogo_Alt_Text\" [src]=\"secondaryLogo\" />\r\n                </div>\r\n              </vnext-link>\r\n            </ng-container>\r\n          </ng-template>\r\n\r\n          <ng-template #showSecondaryClientLogo>\r\n            <div>\r\n              <img class=\"{{ logoClass }}\" [alt]=\"Spa_HeaderFooter_SecondaryLogo_Alt_Text\" [src]=\"secondaryLogo\" />\r\n            </div>\r\n          </ng-template>\r\n          <vnext-link\r\n            *ngIf=\"\r\n              Spa_HeaderFooter_SecondaryClientLogo_Url &&\r\n              Spa_HeaderFooter_SecondaryClientLogo_Url.length &&\r\n              !Spa_HeaderFooter_SecondaryClientLogo_Url[0].href &&\r\n              !Spa_HeaderFooter_SecondaryClientLogo_Url[0].tag\r\n            \"\r\n            [tag]=\"siteLogoTag ? siteLogoTag : pageTags.HOME\"\r\n            [linkTarget]=\"Spa_HeaderFooter_SecondaryClientLogo_Url[0].target\"\r\n            [onClickAction]=\"\r\n              Spa_Site_SiteType === siteType.CONSUMER\r\n                ? submitLogoAction.bind(this, Spa_HeaderFooter_SecondaryClientLogo_Url, siteLogoTag)\r\n                : null\r\n            \"\r\n          >\r\n            <div tag-image-body>\r\n              <img class=\"{{ logoClass }}\" [alt]=\"Spa_HeaderFooter_SecondaryLogo_Alt_Text\" [src]=\"secondaryLogo\" />\r\n            </div>\r\n          </vnext-link>\r\n        </div>\r\n      </div>\r\n\r\n      <div *ngIf=\"isMobile\" class=\"d-block d-sm-none header-menu mr-1\">\r\n        <vnext-header-menu-dropdown\r\n          [isRetention]=\"isRetentionView\"\r\n          [menuTitle]=\"Spa_HeaderFooter_MenuTitle\"\r\n          [links]=\"Spa_HeaderFooter_SubHeaderLinks\"\r\n          [isProfileSearchEnabled]=\"Spa_Site_Profile_Enabled\"\r\n          [isPPCSite]=\"isPPCSite\"\r\n          [brokerText]=\"Spa_HeaderFooter_Broker\"\r\n          [agentLoggedIn]=\"isAgentLoggedIn\"\r\n          [agentData]=\"agentData\"\r\n          [brokerInfoEnabled]=\"Spa_Site_Broker_Info_Enabled && showAgentHeader\"\r\n          [isUserLoggedIn]=\"isUserLoggedIn\"\r\n          [isShoppingCartEnabled]=\"Spa_ShoppingCart_Enabled\"\r\n          [primaryLoggedIn]=\"primaryLoggedIn\"\r\n          [currentLanguageLabelText]=\"Spa_HeaderFooter_Language_Label_Text\"\r\n          [locale]=\"locale\"\r\n          [hideContactUsLink]=\"Spa_HeaderFooter_HideContactUs_Link\"\r\n          [closeText]=\"Spa_Site_Close\"\r\n          [motionPointEnabled]=\"MotionPoint_WidgetEnabled\"\r\n          [cartText]=\"Spa_Site_Cart_Text\"\r\n          [showPrintLink]=\"Spa_HeaderFooter_Print_Display\"\r\n          [speakWithAgentContactInfo]=\"Spa_SpeakWithAgent_ContactInfo_Text\"\r\n          [speakWithAgentEnabled]=\"Spa_Site_SpeakWithAgent_Enabled\"\r\n          [speakWithAgentHeader]=\"Spa_SpeakWithAgent_Header_Text\"\r\n          [uniqueCode]=\"uniqueCode\"\r\n          [displayUniqueCode]=\"displayUniqueCode\"\r\n          [uniqueCodeText]=\"Spa_SpeakWithAgent_UniqueCodeDescription_Text\"\r\n          [showPlanYearBadge]=\"isPlanYearBadgeEnabled\"\r\n          [planYear]=\"badgePlanYear\"\r\n          [weglotMultiLanguageEnabled]=\"Spa_Weglot_MultiLanguage_Enabled\"\r\n          [isMobile]=\"isMobile\"\r\n        >\r\n        </vnext-header-menu-dropdown>\r\n      </div>\r\n      <ng-container *ngIf=\"(isRetentionView && primaryLoggedIn) || !isRetentionView\">\r\n        <div *ngIf=\"Spa_Site_Login_Widget_Enabled !== false\" class=\"d-block d-sm-none\">\r\n          <vnext-login-container></vnext-login-container>\r\n        </div>\r\n      </ng-container>\r\n      <div class=\"header-links d-none d-sm-flex options align-items-center justify-content-end\">\r\n        <div class=\"d-flex flex-column justify-content-between align-items-center\">\r\n          <div [ngClass]=\"{ 'sub-header-margin': !agentData }\" class=\"row sub-header-alignment\">\r\n            <div class=\"sub-header\">\r\n              <vnext-sub-header\r\n                class=\"d-none d-sm-block\"\r\n                [linkContainerClass]=\"'sub-header-container-header'\"\r\n                [links]=\"Spa_HeaderFooter_SubHeaderLinks\"\r\n                [currentLanguageLabelText]=\"Spa_HeaderFooter_Language_Label_Text\"\r\n                [isFocusSkipToContent]=\"true\"\r\n                [hideContactUsLink]=\"Spa_HeaderFooter_HideContactUs_Link\"\r\n                [motionPointEnabled]=\"MotionPoint_WidgetEnabled\"\r\n                [showPrintLink]=\"Spa_HeaderFooter_Print_Display\"\r\n                [loginWidgetEnabled]=\"Spa_Site_Login_Widget_Enabled\"\r\n                [isPPCSite]=\"isPPCSite\"\r\n                [showPlanYearBadge]=\"isPlanYearBadgeEnabled\"\r\n                [planYear]=\"badgePlanYear\"\r\n                [weglotMultiLanguageEnabled]=\"Spa_Weglot_MultiLanguage_Enabled\"\r\n              >\r\n              </vnext-sub-header>\r\n            </div>\r\n          </div>\r\n          <div class=\"row {{ alignmentClass }}\">\r\n            <ng-container *ngIf=\"(isRetentionView && primaryLoggedIn) || !isRetentionView\">\r\n              <ng-template #speakWithAgentSection>\r\n                <ng-container *ngIf=\"!isPPCSite && Spa_Site_SpeakWithAgent_Enabled\">\r\n                  <vnext-speak-with-agent\r\n                    [headerText]=\"Spa_SpeakWithAgent_Header_Text\"\r\n                    [linkText]=\"Spa_SpeakWithAgent_Link_Text\"\r\n                    [contactInfo]=\"Spa_SpeakWithAgent_ContactInfo_Text\"\r\n                    [uniqueCode]=\"uniqueCode\"\r\n                    [uniqueCodeText]=\"Spa_SpeakWithAgent_UniqueCodeDescription_Text\"\r\n                    [displayUniqueCode]=\"displayUniqueCode\"\r\n                    [closeText]=\"Spa_Site_Close\"\r\n                  ></vnext-speak-with-agent>\r\n                </ng-container>\r\n              </ng-template>\r\n              <!-- broker -->\r\n              <div\r\n                *ngIf=\"Spa_Site_Broker_Info_Enabled && showAgentHeader && !isPPCSite; else speakWithAgentSection\"\r\n                class=\"row d-none d-sm-flex mt-1\"\r\n              >\r\n                <vnext-agent-container\r\n                  [brokerText]=\"Spa_HeaderFooter_Broker\"\r\n                  [agentData]=\"agentData\"\r\n                  *ngIf=\"agentData || Spa_HeaderFooter_Broker; else speakWithAgentSection\"\r\n                  [locale]=\"locale\"\r\n                  [closeText]=\"Spa_Site_Close\"\r\n                  [uniqueCodeText]=\"Spa_SpeakWithAgent_UniqueCodeDescription_Text\"\r\n                  [uniqueCode]=\"uniqueCode\"\r\n                  [displayUniqueCode]=\"displayUniqueCode\"\r\n                  [isAgentProfilePictureEnabled]=\"Spa_Agent_Profile_Picture_Upload_Enabled\"\r\n                  [weglotMultiLanguageEnabled]=\"Spa_Weglot_MultiLanguage_Enabled\"\r\n                  [isMobile]=\"isMobile\"\r\n                ></vnext-agent-container>\r\n              </div>\r\n              <!-- shopping cart-->\r\n              <div\r\n                *ngIf=\"Spa_ShoppingCart_Enabled && !isPPCSite\"\r\n                class=\"ml-4 ml-sm-3 ml-md-4 pl-3\"\r\n                [ngClass]=\"{\r\n                  'pl-3': !agentData,\r\n                  'pl-2': agentData\r\n                }\"\r\n              >\r\n                <vnext-shopping-cart-icon [label]=\"Spa_Site_Cart_Text\"></vnext-shopping-cart-icon>\r\n              </div>\r\n              <!-- profile navigation bar -->\r\n              <div *ngIf=\"Spa_Site_Profile_Enabled && isPPCSite\" class=\"profile-section\">\r\n                <vnext-profile-navigation-bar></vnext-profile-navigation-bar>\r\n              </div>\r\n              <!-- login -->\r\n              <div *ngIf=\"!isPPCSite && Spa_Site_Login_Widget_Enabled !== false\" class=\"mt-1 ml-4 ml-sm-3 ml-md-4\">\r\n                <vnext-login-container></vnext-login-container>\r\n              </div>\r\n            </ng-container>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <vnext-call-recording-sticky-box\r\n      [isPPCSite]=\"isPPCSite\"\r\n      [shoppingRecordingEnabled]=\"Spa_Site_AgentCallRecordingShopping_Enabled\"\r\n      [shoppingRecordingCallBeneficiaryEnabled]=\"Spa_Site_AgentCallRecordingShopping_CallBeneficiary_Enabled\"\r\n      [shoppingRecordingStickyEnabled]=\"Spa_Site_AgentCallRecordingShopping_Sticky_Enabled\"\r\n      [iconClass]=\"Spa_AgentCallInProgressAcceptCall_Icon\"\r\n      [endCallIconClass]=\"Spa_AgentCallEndCall_Icon\"\r\n      [callRecordingText]=\"Spa_CallRecording_StartRecording_Text\"\r\n      [callInProgressText]=\"Spa_AgentCallInProgressAcceptCall_Title\"\r\n      [endCallText]=\"Spa_AgentCallEndCall_Title\"\r\n      [callEndedText]=\"Spa_AgentCallEnded_Title\"\r\n    ></vnext-call-recording-sticky-box>\r\n  </header>\r\n  <header *ngIf=\"type === 'basic'\">\r\n    <div class=\"container d-flex justify-content-center\">\r\n      <div></div>\r\n      <ng-container *ngIf=\"primaryLogo\">\r\n        <vnext-link\r\n          *ngIf=\"\r\n            Spa_HeaderFooter_PrimaryClientLogo_Url?.length && !(Spa_HeaderFooter_PrimaryClientLogo_UsePlanLogo && showPlanLogo);\r\n            else showBasicPrimaryClientLogo\r\n          \"\r\n          [href]=\"Spa_HeaderFooter_PrimaryClientLogo_Url[0].href\"\r\n          [tag]=\"Spa_HeaderFooter_PrimaryClientLogo_Url[0].tag\"\r\n          [linkTarget]=\"Spa_HeaderFooter_PrimaryClientLogo_Url[0].target\"\r\n        >\r\n          <div tag-image-body>\r\n            <img\r\n              class=\"can-click {{ logoClass }} basic-primary-logo mt-2 mb-2\"\r\n              [alt]=\"Spa_HeaderFooter_PrimaryLogo_Alt_Text\"\r\n              [src]=\"primaryLogo\"\r\n            />\r\n          </div>\r\n          <div href-image-body>\r\n            <img class=\"can-click {{ logoClass }} mt-2 mb-2\" [alt]=\"Spa_HeaderFooter_PrimaryLogo_Alt_Text\" [src]=\"primaryLogo\" />\r\n          </div>\r\n        </vnext-link>\r\n        <ng-template #showBasicPrimaryClientLogo>\r\n          <div>\r\n            <img class=\"{{ logoClass }} mt-2 mb-2\" [alt]=\"getPrimaryAltText()\" [src]=\"getPrimaryLogo()\" />\r\n          </div>\r\n        </ng-template>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"secondaryLogo\">\r\n        <vnext-link\r\n          *ngIf=\"\r\n            Spa_HeaderFooter_SecondaryClientLogo_Url && Spa_HeaderFooter_SecondaryClientLogo_Url.length;\r\n            else showBasicSecondaryClientLogo\r\n          \"\r\n          [href]=\"Spa_HeaderFooter_SecondaryClientLogo_Url[0].href\"\r\n          [tag]=\"Spa_HeaderFooter_SecondaryClientLogo_Url[0].tag\"\r\n          [linkTarget]=\"Spa_HeaderFooter_SecondaryClientLogo_Url[0].target\"\r\n        >\r\n          <div tag-image-body>\r\n            <img class=\"can-click {{ logoClass }} mt-2\" [alt]=\"Spa_HeaderFooter_SecondaryLogo_Alt_Text\" [src]=\"secondaryLogo\" />\r\n          </div>\r\n          <div href-image-body>\r\n            <img class=\"can-click {{ logoClass }} mt-2\" [alt]=\"Spa_HeaderFooter_SecondaryLogo_Alt_Text\" [src]=\"secondaryLogo\" />\r\n          </div>\r\n        </vnext-link>\r\n        <ng-template #showBasicSecondaryClientLogo>\r\n          <div>\r\n            <img class=\"can-click {{ logoClass }} mt-2\" [alt]=\"Spa_HeaderFooter_SecondaryLogo_Alt_Text\" [src]=\"secondaryLogo\" />\r\n          </div>\r\n        </ng-template>\r\n      </ng-container>\r\n      <div></div>\r\n    </div>\r\n  </header>\r\n  <!-- soa header layout -->\r\n  <header *ngIf=\"type === 'soa' || type === 'shareprescription'\">\r\n    <div>\r\n      <vnext-sub-header\r\n        *ngIf=\"type === 'shareprescription'\"\r\n        class=\"d-none d-md-block\"\r\n        [linkContainerClass]=\"'sub-header-container-header'\"\r\n        [links]=\"Spa_HeaderFooter_SubHeaderLinks\"\r\n        [currentLanguageLabelText]=\"Spa_HeaderFooter_Language_Label_Text\"\r\n        [hideContactUsLink]=\"Spa_HeaderFooter_HideContactUs_Link\"\r\n        [motionPointEnabled]=\"MotionPoint_WidgetEnabled\"\r\n        [showPrintLink]=\"Spa_HeaderFooter_Print_Display\"\r\n        [loginWidgetEnabled]=\"Spa_Site_Login_Widget_Enabled\"\r\n        [isPPCSite]=\"isPPCSite\"\r\n        [weglotMultiLanguageEnabled]=\"Spa_Weglot_MultiLanguage_Enabled\"\r\n      >\r\n      </vnext-sub-header>\r\n    </div>\r\n    <div class=\"container d-flex justify-content-between align-items-center align-items-md-end pt-1\">\r\n      <div>\r\n        <div class=\"my-auto\">\r\n          <img class=\"header-primary-logo basic-primary-logo\" *ngIf=\"primaryLogo\" [src]=\"getPrimaryLogo()\" [alt]=\"getPrimaryAltText()\" />\r\n          <img class=\"header-primary-logo\" *ngIf=\"secondaryLogo\" [src]=\"secondaryLogo\" [alt]=\"Spa_HeaderFooter_SecondaryLogo_Alt_Text\" />\r\n        </div>\r\n      </div>\r\n      <div class=\"justify-content-end my-auto\" *ngIf=\"Spa_Site_Broker_Info_Enabled && isBrokerInfoEnabled\">\r\n        <ng-container *ngIf=\"type === 'soa' && isMobile; else sharedPrescription\">\r\n          <div ngbDropdown #headerMenuDropdown=\"ngbDropdown\" class=\"dropdown-container\" placement=\"bottom-right\" ngbDropdownAnchor>\r\n            <button\r\n              class=\"menu-button btn p-0 Spa_Style_Paragraph\"\r\n              id=\"dropdownMenuButton\"\r\n              (click)=\"toggleDropdown(headerMenuDropdown, $event)\"\r\n              [attr.aria-expanded]=\"headerMenuDropdown.isOpen()\"\r\n            >\r\n              <i class=\"fas fa-bars\"></i>\r\n              <span class=\"pl-1\">{{ Spa_HeaderFooter_MenuTitle }} </span>\r\n            </button>\r\n\r\n            <div ngbDropdownMenu aria-labelledby=\"dropdownMenuButton\" class=\"menu pl-2 pb-0\">\r\n              <div class=\"arrow\"></div>\r\n              <div>\r\n                <span\r\n                  class=\"soa-header-close can-click\"\r\n                  (click)=\"headerMenuDropdown.close()\"\r\n                  tabindex=\"0\"\r\n                  role=\"button\"\r\n                  (keyup.enter)=\"headerMenuDropdown.close()\"\r\n                >\r\n                  <span class=\"sr-only\">Close</span>\r\n                  <i class=\"fa fa-times Spa_Style_Primary_Color\"></i>\r\n                </span>\r\n              </div>\r\n              <div class=\"agent-info Spa_Style_Primary_Color px-2\">\r\n                <div class=\"agent-name Spa_Style_Larger_Font pt-3\">{{ agentName }}</div>\r\n                <div class=\"agent-phone Spa_Style_Small_Font pt-2\">{{ agentPhone | phone : locale.slice(3) }}</div>\r\n                <div class=\"agent-email Spa_Style_Small_Font pt-2\">{{ agentEmail }}</div>\r\n              </div>\r\n              <vnext-locale-picker\r\n                *ngIf=\"!MotionPoint_WidgetEnabled\"\r\n                class=\"col-12\"\r\n                [headerDropdown]=\"true\"\r\n                [link]=\"languageLink\"\r\n                [currentLanguageLabelText]=\"Spa_HeaderFooter_Language_Label_Text\"\r\n                [showLastBorder]=\"false\"\r\n                [weglotMultiLanguageEnabled]=\"Spa_Weglot_MultiLanguage_Enabled\"\r\n              >\r\n              </vnext-locale-picker>\r\n            </div>\r\n          </div>\r\n        </ng-container>\r\n        <ng-template #sharedPrescription>\r\n          <vnext-agent-container\r\n            [brokerText]=\"Spa_HeaderFooter_Broker\"\r\n            [isLoggedIn]=\"false\"\r\n            [agentData]=\"agentData\"\r\n            [locale]=\"locale\"\r\n            [closeText]=\"Spa_Site_Close\"\r\n            [agentHeaderLocalePickerEnabled]=\"agentHeaderLocalePickerEnabled\"\r\n            [currentLanguageLabelText]=\"Spa_HeaderFooter_Language_Label_Text\"\r\n            [languageLink]=\"languageLink\"\r\n            [motionPointEnabled]=\"MotionPoint_WidgetEnabled\"\r\n            [weglotMultiLanguageEnabled]=\"Spa_Weglot_MultiLanguage_Enabled\"\r\n            [isMobile]=\"isMobile\"\r\n          >\r\n          </vnext-agent-container\r\n        ></ng-template>\r\n      </div>\r\n    </div>\r\n  </header>\r\n</ng-container>\r\n<ng-container *ngIf=\"type === 'default' && isTalkingPointsEnabled && !isMobile\">\r\n  <vnext-talking-point-sidenav\r\n    [talkingPoints]=\"filteredTalkingPoints\"\r\n    [currentPath]=\"currentPath\"\r\n    [talkingPointsTitle]=\"Spa_Site_DisplayTalkingPoints_Title\"\r\n    [dropdownDefaultText]=\"Spa_Site_TalkingPoints_Dropdown_Default_Text\"\r\n    [isSideNavOpen]=\"Spa_Site_DisplayTalkingPoints_By_Default\"\r\n  ></vnext-talking-point-sidenav>\r\n</ng-container>\r\n", styles: ["header{box-shadow:-4px 4px 3px 0 var(--static-Spa_Style_Accent1);z-index:900;box-sizing:border-box;position:relative}.nav-bar{display:flex;justify-content:space-between;flex-direction:row;align-items:center!important}.nav-bar>*{flex:1}.options{display:flex;flex-direction:row;justify-content:flex-end}.options div{text-align:center}.options div:last-of-type{margin-right:0}.header-menu{padding-left:24px}.logo-wrapper{max-width:350px;flex-wrap:nowrap}.logo-wrapper-margin-left{margin-left:-5px}.sub-header-margin{margin-bottom:8px}.primary-logo,.primary-logo-broker{padding:6px}.basic-primary-logo{margin-right:10px}.secondary-logo{padding:6px 0 6px 12px}.header-logo,.primary-logo,.secondary-logo{max-width:290px;max-height:80px;display:flex;align-items:center;-ms-flex:1 0 auto}.header-primary-logo,.header-primary-logo-broker{max-width:350px;max-height:80px}.header-logo-broker,.primary-logo-broker{max-width:220px;max-height:80px;display:flex;align-items:center;-ms-flex:1 0 auto}.header-links{margin:auto 0}.profile-section{min-width:300px}.sub-header-alignment{margin-left:auto}.unique-code-text{white-space:break-spaces}@media print{.sub-header-alignment,.sub-header-container-alignment{margin-left:auto;margin-right:0}}@media (min-width: 1024px){.sub-header-broker-alignment{margin-top:8px}.sub-header-alignment{margin-left:auto}.sub-header-container-alignment{margin-left:auto;margin-right:0;align-items:center}}@media (min-width: 810px) and (max-width: 1024px){.sub-header-alignment{margin-left:auto}.sub-header-container-alignment{margin-left:auto;margin-right:0}.header-logo{max-height:80px;max-width:275px}.header-logo-broker,.primary-logo-broker{max-width:227px;max-height:80px}.profile-section{min-width:291px}}@media (min-width: 768px) and (max-width: 809.98px){.header-logo{max-height:80px;max-width:165px}.header-logo-broker,.primary-logo-broker{max-width:131px;max-height:80px}.profile-section{min-width:270px}.header-primary-logo-broker{max-width:270px;max-height:80px}}@media (max-width: 767.98px){.nav-bar{align-items:center!important}.nav-bar div{text-align:right}.nav-bar div:first-child{text-align:left}.header-logo,.primary-logo,.secondary-logo{max-height:80px;max-width:170px}.header-logo-broker,.primary-logo-broker{max-height:80px;max-width:145px}.logo-wrapper{flex-wrap:wrap}.profile-section{min-width:280px}.header-primary-logo{max-width:235px;max-height:80px}.header-primary-logo-broker{max-width:245px;max-height:80px}.sub-header-margin{margin-bottom:0}.sub-header-alignment,.sub-header-container-alignment{margin-left:auto;margin-right:0}}@media (min-width: 576px) and (max-width: 767.98px){.nav-bar{align-items:center!important}.header-links{flex:1 1 auto!important}.sub-header-alignment{align-self:flex-end;margin-left:-20%;margin-right:0}}@media screen and (max-width: 575.98px){.nav-bar .logo-wrapper{flex-basis:40%}.header-primary-logo{max-width:100%}}.dropdown-container{position:static}.arrow{left:93%;top:-8px;position:absolute;width:1rem;height:1.5rem}.arrow:after{top:-1.5rem;border-width:0 1.5rem 1.5rem;position:absolute;content:\"\";border-color:transparent transparent white;border-style:solid}.dropdown-menu .arrow:after,.dropdown-menu .arrow:before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.dropdown-menu .arrow:after{top:1px;border-width:0 .5rem .5rem;border-bottom-color:#fff}.dropdown-menu .arrow:before{top:0;border-width:0 .5rem .5rem;border-bottom-color:#00000040}.soa-header-close{position:absolute;right:15px}.agent-name{word-wrap:break-word;white-space:break-spaces;overflow-wrap:break-word}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.NavigationService }, { type: i1.LoginService }, { type: i1.SiteService }, { type: ProfileFacade }, { type: i1.LocaleService }, { type: i1.NavigationUtilityService }, { type: i1.NavigationContext }, { type: i1.ShoppingCartService }, { type: PlanFacade }, { type: i1.MemberSessionService }, { type: SpeakWithAgentFacade }, { type: AnalyticsService }, { type: i1.AgentService }, { type: i1.ShoppingRecordingContextService }, { type: i1.TwilioDeviceService }, { type: i1.DeactivationGuardService }, { type: i1.PlanYearResourceService }, { type: i1.EnrollmentFormService }, { type: i2$1.ActivatedRoute }]; }, { showAgentHeader$: [], session$: [], headerType: [{
            type: Input
        }], isBrokerInfoEnabled: [{
            type: Input
        }], primaryLogo: [{
            type: Input
        }], primaryLogoUrl: [{
            type: Input
        }], secondaryLogo: [{
            type: Input
        }], secondaryLogoUrl: [{
            type: Input
        }], broker: [{
            type: Input
        }], Spa_Site_SiteType: [], Spa_ShoppingCart_Enabled: [], Spa_Site_Login_Widget_Enabled: [], Spa_Site_Broker_Info_Enabled: [], Spa_Site_Profile_Enabled: [], Spa_Site_Cart_Text: [], Spa_HeaderFooter_PrimaryClientLogo: [], Spa_HeaderFooter_SecondaryClientLogo: [], Spa_HeaderFooter_PrimaryClientLogo_Url: [], Spa_HeaderFooter_SecondaryClientLogo_Url: [], Spa_HeaderFooter_MenuTitle: [], Spa_HeaderFooter_Broker: [], Spa_HeaderFooter_SubHeaderLinks: [], Spa_HeaderFooter_PrimaryLogo_Alt_Text: [], Spa_HeaderFooter_SecondaryLogo_Alt_Text: [], Spa_HeaderFooter_PrimaryClientLogo_UsePlanLogo: [], Spa_HeaderFooter_HideContactUs_Link: [], Spa_AgentReports_Header_Text: [], Spa_HeaderFooter_Language_Label_Text: [], Spa_Site_Show_Header: [], Spa_Site_Header_Type: [], Spa_Site_Close: [], MotionPoint_WidgetEnabled: [], Spa_HeaderFooter_Print_Display: [], Spa_HeaderFooter_Language_Display: [], Spa_Site_SpeakWithAgent_Enabled: [], Spa_SpeakWithAgent_Link_Text: [], Spa_SpeakWithAgent_Header_Text: [], Spa_SpeakWithAgent_ContactInfo_Text: [], Spa_SpeakWithAgent_ShowUniqueCode_Enabled: [], Spa_SpeakWithAgent_UniqueCodeDescription_Text: [], Spa_LoginWidget_Username_Text: [], Spa_LoginWidget_Password_Text: [], Spa_LoginWidget_Login_Header_Text: [], Spa_LoginWidget_Login_Title_Text: [], Spa_LoginWidget_Login_Submit_Text: [], Spa_Login_Error_Message: [], Spa_LoginWidget_Logout_Text: [], Spa_LoginWidget_Create_Account_Display: [], Spa_LoginWidget_Create_Account_Label_Text: [], Spa_LoginWidget_Create_Account_Button_Text: [], Spa_LoginWidget_LoginToAccount_Text: [], Spa_LoginWidget_LoginToAccount_ClickableText: [], Spa_LoginWidget_AccountOverview_Text: [], Spa_Site_Agent_AccountOverview_Enabled: [], Spa_Site_ErrorKeyword_Text: [], Spa_Site_AgentReports_Enabled: [], Spa_Site_AgentReports_AdminOnly_Enabled: [], Spa_Consumer_AccountOverview_Header_Text: [], Spa_Site_CustomerMemberPortalIntegration_Enabled: [], Spa_Login_ForgotPasswordEmailSent_Text: [], Spa_Login_ForgotPasswordCheckEmail_Text: [], Spa_Login_ForgotPasswordInstructions_Text: [], Spa_Login_ForgotPasswordUserNameRequired_Error: [], Spa_Login_ForgotPasswordInvalidUserName_Error: [], Spa_Profile_Username_Label: [], Spa_Login_ForgotPasswordSendEmail_Text: [], Spa_Login_ForgotPasswordHeader_Text: [], Spa_Login_ForgotPasswordEmailFailed_Error: [], Spa_Login_ForgotPasswordLink_Enabled: [], Spa_Login_ForgotPasswordLink_Text: [], Spa_Agent_Profile_Picture_Upload_Enabled: [], Spa_Login_ForgotUsernameLink_Enabled: [], Spa_Login_ForgotUsernameLink_Text: [], Spa_Login_EmailLabel_Text: [], Spa_Login_FirstNameLabel_Text: [], Spa_Login_InvalidUserEmailCombination_Error: [], Spa_Login_FirstNameRequired_Error: [], Spa_Login_EmailRequired_Error: [], Spa_Login_ForgotUsernameHeader_Text: [], Spa_Login_ForgotUsernameInstructions_Text: [], Spa_Login_ForgotUsernameCheckEmail_Text: [], Spa_Site_Consumer_AccountOverview_Enabled: [], Spa_Site_AgentCallRecordingShopping_Enabled: [], Spa_Site_AgentCallRecordingShopping_CallBeneficiary_Enabled: [], Spa_AgentCallInProgressAcceptCall_Icon: [], Spa_AgentCallEndCall_Icon: [], Spa_CallRecording_StartRecording_Text: [], Spa_AgentCallInProgressAcceptCall_Title: [], Spa_AgentCallEndCall_Title: [], Spa_AgentCallEnded_Title: [], Spa_Site_AgentCallRecordingShopping_Sticky_Enabled: [], Spa_Site_MedicareGroup_Enabled: [], isMobile$: [], Spa_Site_DisplayTalkingPoints_Shopping_Enabled: [], Spa_Site_DisplayTalkingPoints_Enrollment_Enabled: [], Spa_Site_DisplayTalkingPoints_By_Default: [], Spa_Site_DisplayTalkingPoints_Title: [], Spa_Site_TalkingPoints_Dropdown_Default_Text: [], Spa_Weglot_MultiLanguage_Enabled: [], getFormattedLogo: [], getLogoClass: [], getLogoWrapperClass: [], getAlignmentClass: [] }); })();

function ForgotPasswordComponent_h2_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.Spa_Agent_PasswordReset_Header, " ");
} }
function ForgotPasswordComponent_ng_container_6_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.Spa_Agent_PasswordReset_Description, " ");
} }
function ForgotPasswordComponent_ng_container_6_div_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r7.Spa_Agent_SendPasswordResetEmail_Error);
} }
function ForgotPasswordComponent_ng_container_6_div_3_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate(ctx_r9.Spa_Agent_UsernameRequired_Error);
} }
function ForgotPasswordComponent_ng_container_6_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "i", 20);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtemplate(3, ForgotPasswordComponent_ng_container_6_div_3_ng_container_3_Template, 2, 1, "ng-container", 6);
    i0.ɵɵtemplate(4, ForgotPasswordComponent_ng_container_6_div_3_ng_template_4_Template, 1, 1, "ng-template", null, 21, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r8 = i0.ɵɵreference(5);
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r5.forgotPasswordForm.get("userName").errors.emailFailed)("ngIfElse", _r8);
} }
function ForgotPasswordComponent_ng_container_6_button_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.Spa_Site_SendEmailButton_Text, " ");
} }
const _c0$2Y = function (a0) { return { "has-error": a0 }; };
function ForgotPasswordComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ForgotPasswordComponent_ng_container_6_p_1_Template, 2, 1, "p", 9);
    i0.ɵɵelementStart(2, "label", 10);
    i0.ɵɵtemplate(3, ForgotPasswordComponent_ng_container_6_div_3_Template, 6, 2, "div", 11);
    i0.ɵɵelementStart(4, "div")(5, "span", 12);
    i0.ɵɵtext(6, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 13);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "input", 14);
    i0.ɵɵlistener("keyup.enter", function ForgotPasswordComponent_ng_container_6_Template_input_keyup_enter_9_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.submitEmailForPasswordReset()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, ForgotPasswordComponent_ng_container_6_button_10_Template, 2, 1, "button", 15);
    i0.ɵɵelementStart(11, "div", 16)(12, "vnext-inner-text-link", 17);
    i0.ɵɵlistener("innerTextClicked", function ForgotPasswordComponent_ng_container_6_Template_vnext_inner_text_link_innerTextClicked_12_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.navToAgentLogin()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_PasswordReset_Description");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.fieldCanShowErrors("userName"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r1.Spa_Agent_Username_Label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0$2Y, ctx_r1.forgotPasswordForm.get("userName").errors && ctx_r1.submitted));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_SendEmailButton_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("outerText", ctx_r1.Spa_LoginWidget_LoginToAccount_Text)("innerText", ctx_r1.Spa_LoginWidget_LoginToAccount_ClickableText);
} }
function ForgotPasswordComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "p", 23);
    i0.ɵɵelement(3, "i", 24);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 25);
    i0.ɵɵlistener("click", function ForgotPasswordComponent_ng_template_7_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.navToAgentLogin()); });
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.Spa_Agent_PasswordResetEmailAttempted_Text);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r3.Spa_Agent_PasswordResetEmailSent_Text, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.Spa_LoginWidget_Login_Header_Text, " ");
} }
let ForgotPasswordComponent = class ForgotPasswordComponent extends ConfigurableWidget {
    constructor(passwordResetEmailService, navigationService, analyticsService, cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, passwordResetService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.passwordResetEmailService = passwordResetEmailService;
        this.navigationService = navigationService;
        this.analyticsService = analyticsService;
        this.passwordResetService = passwordResetService;
        this.Spa_Agent_UsernameRequired_Error = 'Please provide a valid username';
        this.Spa_Agent_Username_Label = 'Username';
        this.Spa_LoginWidget_LoginToAccount_Text = 'Or login to your account';
        this.Spa_LoginWidget_Login_Header_Text = 'Login';
        this.Spa_LoginWidget_LoginToAccount_ClickableText = 'login';
        this.Spa_Agent_PasswordResetEmailAttempted_Text = 'Check your email to reset your password. If you do not receive an email, try again or contact your administrator.';
        this.Spa_Agent_PasswordResetEmailSent_Text = 'An email has been sent.';
        this.Spa_Agent_SendPasswordResetEmail_Error = 'Email not sent. Try again later.';
        this.Spa_HeaderFooter_PrimaryClientLogo = '';
        this.Spa_HeaderFooter_PrimaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_HeaderFooter_SecondaryClientLogo = '';
        this.Spa_HeaderFooter_SecondaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_Agent_PasswordReset_Header = 'Reset your password';
        this.Spa_Agent_PasswordReset_Description = 'Enter your username and then check your email to continue to reset your password. Contact your administrator if you need assistance.';
        this.Spa_Site_SendEmailButton_Text = 'Send email';
        this.emailSuccess = false;
        this.emailAddress = '';
        this.submitted = false;
    }
    fieldCanShowErrors(fieldName) {
        const control = this.forgotPasswordForm.get(fieldName);
        return control.errors && control.touched;
    }
    ngOnInit() {
        super.ngOnInit();
        this.forgotPasswordForm = new UntypedFormGroup({ userName: new UntypedFormControl('', [Validators.required]) }, { updateOn: 'submit' });
    }
    async submitEmailForPasswordReset() {
        this.submitted = true;
        this.forgotPasswordForm.markAllAsTouched();
        if (this.forgotPasswordForm.status === 'VALID') {
            const userName = `${this.forgotPasswordForm.get('userName').value}`.trim();
            const recoveryHashReturn = await this.passwordResetService
                .generateRecoveryHash(userName, ResetHashRequestType.USER_NAME, PasswordResetUserType.AGENT)
                .catch(error => {
                this.forgotPasswordForm.get('userName').setErrors({
                    invalidUsername: true
                });
            });
            if (recoveryHashReturn) {
                this.emailAddress = recoveryHashReturn.emailAddress;
                let sendPasswordEmailReturn = false;
                await this.sendPasswordResetEmail(recoveryHashReturn.resetHash, userName)
                    .then(() => {
                    sendPasswordEmailReturn = true;
                })
                    .catch(error => {
                    this.forgotPasswordForm.get('userName').setErrors({
                        emailFailed: true
                    });
                });
                if (sendPasswordEmailReturn) {
                    this.emailSuccess = true;
                }
            }
            this.cdr.markForCheck();
        }
    }
    async sendPasswordResetEmail(resetHash, username) {
        return this.passwordResetEmailService.sendPasswordResetEmail(resetHash, [this.emailAddress], username);
    }
    navToAgentLogin() {
        this.navigationService.navigateByPageTag(PageTags.AGENT_LOGIN);
    }
};
ForgotPasswordComponent.ɵfac = function ForgotPasswordComponent_Factory(t) { return new (t || ForgotPasswordComponent)(i0.ɵɵdirectiveInject(i1.PasswordResetEmailService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.PasswordResetService)); };
ForgotPasswordComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ForgotPasswordComponent, selectors: [["vnext-forgot-password"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 9, vars: 10, consts: [[3, "headerType", "primaryLogo", "primaryLogoUrl", "secondaryLogo", "secondaryLogoUrl"], ["vnextGoogleTagManager", "", 1, "forgot-password-container", "container", 3, "saveDefaultValues"], [1, "row"], [1, "col-xs-12", "col-md-6", "col-lg-4", "offset-xs-0", "offset-md-3", "offset-lg-4"], ["class", "password-reset-header", 4, "liveEditProp"], ["disableKeyDownSubmit", "", 1, "forgot-password-form", "px-2", 3, "formGroup", "ngSubmit"], [4, "ngIf", "ngIfElse"], ["resetPasswordInstructions", ""], [1, "password-reset-header"], ["class", "Spa_Style_ToolTip px-0", 4, "liveEditProp"], ["for", "userName", 1, "px-0", "col-12"], ["class", "error-container", 4, "ngIf"], [1, "input-error-asterisk"], [1, "Spa_Style_Label", "input-label-text"], ["id", "userName", "type", "text", "formControlName", "userName", "maxlength", "255", 1, "col-12", 3, "ngClass", "keyup.enter"], ["type", "submit", "class", "btn Spa_Style_PrimaryButton col-12", 4, "liveEditProp"], [1, "text-center"], [1, "", 3, "outerText", "innerText", "innerTextClicked"], [1, "Spa_Style_ToolTip", "px-0"], [1, "error-container"], ["aria-hidden", "true", 1, "fa", "fa-exclamation-circle"], ["invalidNameError", ""], ["type", "submit", 1, "btn", "Spa_Style_PrimaryButton", "col-12"], [1, "email-success", "text-center"], ["aria-hidden", "true", 1, "fas", "fa-check-circle"], ["type", "button", 1, "btn", "Spa_Style_PrimaryButton", "col-12", 3, "click"]], template: function ForgotPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "vnext-dynamic-header", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3);
        i0.ɵɵtemplate(4, ForgotPasswordComponent_h2_4_Template, 2, 1, "h2", 4);
        i0.ɵɵelementStart(5, "form", 5);
        i0.ɵɵlistener("ngSubmit", function ForgotPasswordComponent_Template_form_ngSubmit_5_listener() { return ctx.submitEmailForPasswordReset(); });
        i0.ɵɵtemplate(6, ForgotPasswordComponent_ng_container_6_Template, 13, 9, "ng-container", 6);
        i0.ɵɵtemplate(7, ForgotPasswordComponent_ng_template_7_Template, 7, 3, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(8);
        i0.ɵɵproperty("headerType", "basic")("primaryLogo", ctx.Spa_HeaderFooter_PrimaryClientLogo)("primaryLogoUrl", ctx.Spa_HeaderFooter_PrimaryClientLogo_Url)("secondaryLogo", ctx.Spa_HeaderFooter_SecondaryClientLogo)("secondaryLogoUrl", ctx.Spa_HeaderFooter_SecondaryClientLogo_Url);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("saveDefaultValues", ctx.analyticsService.isDefaultTagToUpdate);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "Spa_Agent_PasswordReset_Header");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.forgotPasswordForm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.emailSuccess)("ngIfElse", _r2);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.MaxLengthValidator, i4.FormGroupDirective, i4.FormControlName, InnerTextLinkComponent, LiveEditPropDirective, FormInputSubmitDirective, GoogleTagManagerDirective, IconAriaAttributesDirective, DynamicHeaderComponent], styles: [".btn[_ngcontent-%COMP%]{margin-bottom:15px}.password-reset-header[_ngcontent-%COMP%]{margin-top:60px;text-align:center}.forgot-password-container[_ngcontent-%COMP%]{margin-top:30px}.email-success[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text);white-space:pre-wrap}.email-success[_ngcontent-%COMP%] > .fa-check-circle[_ngcontent-%COMP%]{margin-right:5px}button[_ngcontent-%COMP%]{margin-top:30px}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], ForgotPasswordComponent.prototype, "Spa_Agent_UsernameRequired_Error", void 0);
__decorate([
    GlobalResource()
], ForgotPasswordComponent.prototype, "Spa_Agent_Username_Label", void 0);
__decorate([
    GlobalResource()
], ForgotPasswordComponent.prototype, "Spa_LoginWidget_LoginToAccount_Text", void 0);
__decorate([
    GlobalResource()
], ForgotPasswordComponent.prototype, "Spa_LoginWidget_Login_Header_Text", void 0);
__decorate([
    GlobalResource()
], ForgotPasswordComponent.prototype, "Spa_LoginWidget_LoginToAccount_ClickableText", void 0);
__decorate([
    GlobalResource()
], ForgotPasswordComponent.prototype, "Spa_Agent_PasswordResetEmailAttempted_Text", void 0);
__decorate([
    GlobalResource()
], ForgotPasswordComponent.prototype, "Spa_Agent_PasswordResetEmailSent_Text", void 0);
__decorate([
    GlobalResource()
], ForgotPasswordComponent.prototype, "Spa_Agent_SendPasswordResetEmail_Error", void 0);
__decorate([
    GlobalResource()
], ForgotPasswordComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo", void 0);
__decorate([
    GlobalResource()
], ForgotPasswordComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo_Url", void 0);
__decorate([
    GlobalResource()
], ForgotPasswordComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo", void 0);
__decorate([
    GlobalResource()
], ForgotPasswordComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo_Url", void 0);
__decorate([
    PlatformProp('live-edit')
], ForgotPasswordComponent.prototype, "Spa_Agent_PasswordReset_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], ForgotPasswordComponent.prototype, "Spa_Agent_PasswordReset_Description", void 0);
__decorate([
    PlatformProp('live-edit')
], ForgotPasswordComponent.prototype, "Spa_Site_SendEmailButton_Text", void 0);
__decorate([
    LiveEditInactive()
], ForgotPasswordComponent.prototype, "submitEmailForPasswordReset", null);
__decorate([
    LiveEditInactive()
], ForgotPasswordComponent.prototype, "navToAgentLogin", null);
ForgotPasswordComponent = __decorate([
    PlatformWidget
], ForgotPasswordComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ForgotPasswordComponent, [{
        type: Component,
        args: [{ selector: 'vnext-forgot-password', providers: [WidgetService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-dynamic-header\r\n  [headerType]=\"'basic'\"\r\n  [primaryLogo]=\"Spa_HeaderFooter_PrimaryClientLogo\"\r\n  [primaryLogoUrl]=\"Spa_HeaderFooter_PrimaryClientLogo_Url\"\r\n  [secondaryLogo]=\"Spa_HeaderFooter_SecondaryClientLogo\"\r\n  [secondaryLogoUrl]=\"Spa_HeaderFooter_SecondaryClientLogo_Url\"\r\n>\r\n</vnext-dynamic-header>\r\n<div class=\"forgot-password-container container\" vnextGoogleTagManager [saveDefaultValues]=\"analyticsService.isDefaultTagToUpdate\">\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12 col-md-6 col-lg-4 offset-xs-0 offset-md-3 offset-lg-4\">\r\n      <h2 *liveEditProp=\"'Spa_Agent_PasswordReset_Header'\" class=\"password-reset-header\">\r\n        {{ Spa_Agent_PasswordReset_Header }}\r\n      </h2>\r\n\r\n      <form\r\n        class=\"forgot-password-form px-2\"\r\n        disableKeyDownSubmit\r\n        [formGroup]=\"forgotPasswordForm\"\r\n        (ngSubmit)=\"submitEmailForPasswordReset()\"\r\n      >\r\n        <ng-container *ngIf=\"!emailSuccess; else resetPasswordInstructions\">\r\n          <p *liveEditProp=\"'Spa_Agent_PasswordReset_Description'\" class=\"Spa_Style_ToolTip px-0\">\r\n            {{ Spa_Agent_PasswordReset_Description }}\r\n          </p>\r\n          <label class=\"px-0 col-12\" for=\"userName\">\r\n            <div class=\"error-container\" *ngIf=\"fieldCanShowErrors('userName')\">\r\n              <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span>\r\n                <ng-container *ngIf=\"forgotPasswordForm.get('userName').errors.emailFailed; else invalidNameError\">{{\r\n                  Spa_Agent_SendPasswordResetEmail_Error\r\n                }}</ng-container>\r\n                <ng-template #invalidNameError>{{ Spa_Agent_UsernameRequired_Error }}</ng-template>\r\n              </span>\r\n            </div>\r\n            <div>\r\n              <span class=\"input-error-asterisk\">*</span\r\n              ><span class=\"Spa_Style_Label input-label-text\">{{ Spa_Agent_Username_Label }}</span>\r\n            </div>\r\n\r\n            <input\r\n              id=\"userName\"\r\n              type=\"text\"\r\n              class=\"col-12\"\r\n              formControlName=\"userName\"\r\n              maxlength=\"255\"\r\n              [ngClass]=\"{ 'has-error': forgotPasswordForm.get('userName').errors && submitted }\"\r\n              (keyup.enter)=\"submitEmailForPasswordReset()\"\r\n            />\r\n          </label>\r\n\r\n          <button type=\"submit\" *liveEditProp=\"'Spa_Site_SendEmailButton_Text'\" class=\"btn Spa_Style_PrimaryButton col-12\">\r\n            {{ Spa_Site_SendEmailButton_Text }}\r\n          </button>\r\n\r\n          <div class=\"text-center\">\r\n            <vnext-inner-text-link\r\n              class=\"\"\r\n              [outerText]=\"Spa_LoginWidget_LoginToAccount_Text\"\r\n              [innerText]=\"Spa_LoginWidget_LoginToAccount_ClickableText\"\r\n              (innerTextClicked)=\"navToAgentLogin()\"\r\n            >\r\n            </vnext-inner-text-link>\r\n          </div>\r\n        </ng-container>\r\n        <ng-template #resetPasswordInstructions>\r\n          <p class=\"Spa_Style_ToolTip px-0\">{{ Spa_Agent_PasswordResetEmailAttempted_Text }}</p>\r\n          <p class=\"email-success text-center\">\r\n            <i class=\"fas fa-check-circle\" aria-hidden=\"true\"></i>{{ Spa_Agent_PasswordResetEmailSent_Text }}\r\n          </p>\r\n          <button type=\"button\" class=\"btn Spa_Style_PrimaryButton col-12\" (click)=\"navToAgentLogin()\">\r\n            {{ Spa_LoginWidget_Login_Header_Text }}\r\n          </button>\r\n        </ng-template>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".btn{margin-bottom:15px}.password-reset-header{margin-top:60px;text-align:center}.forgot-password-container{margin-top:30px}.email-success{color:var(--static-Spa_Style_Cost_Text);white-space:pre-wrap}.email-success>.fa-check-circle{margin-right:5px}button{margin-top:30px}\n"] }]
    }], function () { return [{ type: i1.PasswordResetEmailService }, { type: i1.NavigationService }, { type: AnalyticsService }, { type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.PasswordResetService }]; }, { Spa_Agent_UsernameRequired_Error: [], Spa_Agent_Username_Label: [], Spa_LoginWidget_LoginToAccount_Text: [], Spa_LoginWidget_Login_Header_Text: [], Spa_LoginWidget_LoginToAccount_ClickableText: [], Spa_Agent_PasswordResetEmailAttempted_Text: [], Spa_Agent_PasswordResetEmailSent_Text: [], Spa_Agent_SendPasswordResetEmail_Error: [], Spa_HeaderFooter_PrimaryClientLogo: [], Spa_HeaderFooter_PrimaryClientLogo_Url: [], Spa_HeaderFooter_SecondaryClientLogo: [], Spa_HeaderFooter_SecondaryClientLogo_Url: [], Spa_Agent_PasswordReset_Header: [], Spa_Agent_PasswordReset_Description: [], Spa_Site_SendEmailButton_Text: [], submitEmailForPasswordReset: [], navToAgentLogin: [] }); })();

function ForgotUsernameComponent_h2_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.Spa_Agent_ForgotUsername_Page_Header, " ");
} }
function ForgotUsernameComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p", 10);
    i0.ɵɵelement(4, "i", 11);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 12);
    i0.ɵɵlistener("click", function ForgotUsernameComponent_ng_container_6_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.navToAgentLogin()); });
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.Spa_Agent_UsernameEmailAttempted_Text);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r1.Spa_Agent_UsernameEmailSent_Text, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.Spa_LoginWidget_Login_Header_Text);
} }
function ForgotUsernameComponent_ng_template_7_p_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.Spa_Agent_ForgotUsername_Description, " ");
} }
function ForgotUsernameComponent_ng_template_7_div_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r9.Spa_Agent_SendUsernameEmail_Error);
} }
function ForgotUsernameComponent_ng_template_7_div_2_ng_template_4_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.Spa_Agent_EmailNotLocated_Error, " ");
} }
function ForgotUsernameComponent_ng_template_7_div_2_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ForgotUsernameComponent_ng_template_7_div_2_ng_template_4_ng_container_0_Template, 2, 1, "ng-container", 6);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r12 = i0.ɵɵreference(7);
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r11.forgotUsernameForm.get("emailAddress").errors.emailAddressNotLocated)("ngIfElse", _r12);
} }
function ForgotUsernameComponent_ng_template_7_div_2_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate(ctx_r13.Spa_Agent_EmailRequired_Error);
} }
function ForgotUsernameComponent_ng_template_7_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelement(1, "i", 23);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtemplate(3, ForgotUsernameComponent_ng_template_7_div_2_ng_container_3_Template, 2, 1, "ng-container", 6);
    i0.ɵɵtemplate(4, ForgotUsernameComponent_ng_template_7_div_2_ng_template_4_Template, 1, 2, "ng-template", null, 24, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(6, ForgotUsernameComponent_ng_template_7_div_2_ng_template_6_Template, 1, 1, "ng-template", null, 25, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r10 = i0.ɵɵreference(5);
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r7.forgotUsernameForm.get("emailAddress").errors.emailFailed)("ngIfElse", _r10);
} }
function ForgotUsernameComponent_ng_template_7_button_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.Spa_Site_SendEmailButton_Text, " ");
} }
const _c0$2X = function (a0) { return { "has-error": a0 }; };
function ForgotUsernameComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, ForgotUsernameComponent_ng_template_7_p_0_Template, 2, 1, "p", 13);
    i0.ɵɵelementStart(1, "label", 14);
    i0.ɵɵtemplate(2, ForgotUsernameComponent_ng_template_7_div_2_Template, 8, 2, "div", 15);
    i0.ɵɵelementStart(3, "div")(4, "span", 16);
    i0.ɵɵtext(5, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 17);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "input", 18);
    i0.ɵɵlistener("keyup.enter", function ForgotUsernameComponent_ng_template_7_Template_input_keyup_enter_8_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.submitEmailForUsername()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(9, ForgotUsernameComponent_ng_template_7_button_9_Template, 2, 1, "button", 19);
    i0.ɵɵelementStart(10, "div", 20)(11, "vnext-inner-text-link", 21);
    i0.ɵɵlistener("innerTextClicked", function ForgotUsernameComponent_ng_template_7_Template_vnext_inner_text_link_innerTextClicked_11_listener() { i0.ɵɵrestoreView(_r16); const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.navToAgentLogin()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_ForgotUsername_Description");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.errorsFlag);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r3.Spa_Agent_EmailAddress_Label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0$2X, ctx_r3.forgotUsernameForm.get("emailAddress").errors && ctx_r3.submitted));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_SendEmailButton_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("outerText", ctx_r3.Spa_LoginWidget_LoginToAccount_Text)("innerText", ctx_r3.Spa_LoginWidget_LoginToAccount_ClickableText);
} }
let ForgotUsernameComponent = class ForgotUsernameComponent extends ConfigurableWidget {
    constructor(navigationService, cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, configResourceService, navigationUtilityService, store, emailService, passwordResetService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.navigationService = navigationService;
        this.configResourceService = configResourceService;
        this.navigationUtilityService = navigationUtilityService;
        this.store = store;
        this.emailService = emailService;
        this.passwordResetService = passwordResetService;
        this.Spa_Agent_EmailRequired_Error = 'Please provide a valid email address';
        this.Spa_Agent_EmailAddress_Label = 'Email address';
        this.Spa_LoginWidget_LoginToAccount_Text = 'Or login to your account';
        this.Spa_LoginWidget_Login_Header_Text = 'Login';
        this.Spa_LoginWidget_LoginToAccount_ClickableText = 'login';
        this.Spa_Agent_UsernameEmailAttempted_Text = 'Your username has been sent. Check your email. If you do not receive an email, try again or contact your administrator.';
        this.Spa_Agent_UsernameEmailSent_Text = 'An email has been sent.';
        this.Spa_Agent_EmailNotLocated_Error = 'We are unable to perform this action at this time. Please re-enter your email or contact your administrator.';
        this.Spa_Agent_SendUsernameEmail_Error = 'Email not sent. Try again later.';
        this.Spa_HeaderFooter_PrimaryClientLogo = '';
        this.Spa_HeaderFooter_PrimaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_HeaderFooter_SecondaryClientLogo = '';
        this.Spa_HeaderFooter_SecondaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_Agent_ForgotUsername_Page_Header = 'Forgot username';
        this.Spa_Agent_ForgotUsername_Description = 'Enter your email address below. Your username will be sent to your email.';
        this.Spa_Site_SendEmailButton_Text = 'Send email';
        this.emailSuccess = false;
        this.emailAddress = '';
        this.submitted = false;
        this.errorsFlag = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.forgotUsernameForm = new UntypedFormGroup({ emailAddress: new UntypedFormControl('', [Validators.required, Validators.email, Validators.maxLength(255)]) }, { updateOn: 'submit' });
    }
    async submitEmailForUsername() {
        this.submitted = true;
        this.forgotUsernameForm.markAllAsTouched();
        if (this.forgotUsernameForm.status === 'VALID') {
            const emailAddress = `${this.forgotUsernameForm.get('emailAddress').value}`.trim();
            const recoveryHashReturn = await this.passwordResetService
                .generateRecoveryHash(emailAddress, ResetHashRequestType.EMAIL_ADDRESS, PasswordResetUserType.AGENT)
                .catch(error => {
                this.forgotUsernameForm.get('emailAddress').setErrors({
                    emailAddressNotLocated: true
                });
            });
            // Can't use recoveryHasReturn?.emailAddress due to the type of the promise technically being void | GenerateResteHashReturnModel
            // property emailAddress does not exist on an object of type void. !!void === false though, so it exists after the &&
            if (recoveryHashReturn && recoveryHashReturn.emailAddress) {
                this.emailAddress = recoveryHashReturn.emailAddress;
                const userName = recoveryHashReturn.userName;
                await this.sendUsernameInfoEmail([this.emailAddress], userName)
                    .then(() => {
                    this.emailSuccess = true;
                })
                    .catch(error => {
                    this.forgotUsernameForm.get('emailAddress').setErrors({
                        emailFailed: true
                    });
                });
            }
            this.cdr.markForCheck();
        }
        else {
            this.forgotUsernameForm.get('emailAddress').setErrors({
                invalidEmailAddress: true
            });
        }
        const control = this.forgotUsernameForm.get('emailAddress');
        this.errorsFlag = control.errors && control.touched;
    }
    navToAgentLogin() {
        this.navigationService.navigateByPageTag(PageTags.AGENT_LOGIN);
    }
    async sendUsernameInfoEmail(to, userName) {
        const subject = this.configResourceService.getProcessedResourceValue('Spa_Agent_ForgotUsername_Subject', this.widgetName, 'Username');
        const baseUrlValue = this.store.selectSnapshot(AppConfigState.defaultUrl);
        const buttonColorValue = this.emailService.getPrimaryButtonColor();
        const data = [
            {
                key: 'primaryButtonColor',
                value: buttonColorValue
            },
            { key: 'baseUrl', value: baseUrlValue },
            {
                key: 'loginLink',
                value: `${baseUrlValue}/${this.navigationUtilityService.constructHref(PageTags.AGENT_LOGIN)}`
            },
            {
                key: 'buttonColorStroke',
                value: AppThemeConfig.adjustColor(buttonColorValue, -50, true)
            },
            {
                key: 'userName',
                value: `${userName}`
            }
        ];
        return this.emailService.sendEmail(EmailNames.AGENT_FORGOT_USERNAME, to, subject, data);
    }
};
ForgotUsernameComponent.ɵfac = function ForgotUsernameComponent_Factory(t) { return new (t || ForgotUsernameComponent)(i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.EmailService), i0.ɵɵdirectiveInject(i1.PasswordResetService)); };
ForgotUsernameComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ForgotUsernameComponent, selectors: [["vnext-forgot-username"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 9, vars: 9, consts: [[3, "headerType", "primaryLogo", "primaryLogoUrl", "secondaryLogo", "secondaryLogoUrl"], ["vnextGoogleTagManager", "", 1, "forgot-username-container", "container"], [1, "row"], [1, "col-xs-12", "col-md-6", "col-lg-4", "offset-xs-0", "offset-md-3", "offset-lg-4"], ["class", "forgot-username-header", 4, "liveEditProp"], ["disableKeyDownSubmit", "", 1, "px-2", 3, "formGroup", "ngSubmit"], [4, "ngIf", "ngIfElse"], ["stayOnPage", ""], [1, "forgot-username-header"], [1, "Spa_Style_ToolTip", "px-0"], [1, "email-success", "text-center"], ["aria-hidden", "true", 1, "fas", "fa-check-circle"], [1, "btn", "Spa_Style_PrimaryButton", "col-12", 3, "click"], ["class", "Spa_Style_ToolTip px-0", 4, "liveEditProp"], ["for", "emailAddress", 1, "px-0", "col-12"], ["class", "error-container", 4, "ngIf"], [1, "input-error-asterisk"], [1, "Spa_Style_Label", "input-label-text"], ["id", "emailAddress", "type", "email", "formControlName", "emailAddress", "maxlength", "255", 1, "col-12", 3, "ngClass", "keyup.enter"], ["type", "submit", "class", "btn Spa_Style_PrimaryButton col-12", 4, "liveEditProp"], [1, "text-center"], [1, "", 3, "outerText", "innerText", "innerTextClicked"], [1, "error-container"], ["aria-hidden", "true", 1, "fa", "fa-exclamation-circle"], ["emailError", ""], ["invalidEmailError", ""], ["type", "submit", 1, "btn", "Spa_Style_PrimaryButton", "col-12"]], template: function ForgotUsernameComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "vnext-dynamic-header", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3);
        i0.ɵɵtemplate(4, ForgotUsernameComponent_h2_4_Template, 2, 1, "h2", 4);
        i0.ɵɵelementStart(5, "form", 5);
        i0.ɵɵlistener("ngSubmit", function ForgotUsernameComponent_Template_form_ngSubmit_5_listener() { return ctx.submitEmailForUsername(); });
        i0.ɵɵtemplate(6, ForgotUsernameComponent_ng_container_6_Template, 8, 3, "ng-container", 6);
        i0.ɵɵtemplate(7, ForgotUsernameComponent_ng_template_7_Template, 12, 9, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(8);
        i0.ɵɵproperty("headerType", "basic")("primaryLogo", ctx.Spa_HeaderFooter_PrimaryClientLogo)("primaryLogoUrl", ctx.Spa_HeaderFooter_PrimaryClientLogo_Url)("secondaryLogo", ctx.Spa_HeaderFooter_SecondaryClientLogo)("secondaryLogoUrl", ctx.Spa_HeaderFooter_SecondaryClientLogo_Url);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("liveEditProp", "Spa_Agent_ForgotUsername_Page_Header");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.forgotUsernameForm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.emailSuccess)("ngIfElse", _r2);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.MaxLengthValidator, i4.FormGroupDirective, i4.FormControlName, InnerTextLinkComponent, LiveEditPropDirective, FormInputSubmitDirective, GoogleTagManagerDirective, IconAriaAttributesDirective, DynamicHeaderComponent], styles: [".btn[_ngcontent-%COMP%]{margin-bottom:15px}.forgot-username-header[_ngcontent-%COMP%]{margin-top:60px;text-align:center}.forgot-username-container[_ngcontent-%COMP%]{margin-top:30px}.email-success[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text);white-space:pre-wrap}.email-success[_ngcontent-%COMP%] > .fa-check-circle[_ngcontent-%COMP%]{margin-right:5px}button[_ngcontent-%COMP%]{margin-top:30px}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], ForgotUsernameComponent.prototype, "Spa_Agent_EmailRequired_Error", void 0);
__decorate([
    GlobalResource()
], ForgotUsernameComponent.prototype, "Spa_Agent_EmailAddress_Label", void 0);
__decorate([
    GlobalResource()
], ForgotUsernameComponent.prototype, "Spa_LoginWidget_LoginToAccount_Text", void 0);
__decorate([
    GlobalResource()
], ForgotUsernameComponent.prototype, "Spa_LoginWidget_Login_Header_Text", void 0);
__decorate([
    GlobalResource()
], ForgotUsernameComponent.prototype, "Spa_LoginWidget_LoginToAccount_ClickableText", void 0);
__decorate([
    GlobalResource()
], ForgotUsernameComponent.prototype, "Spa_Agent_UsernameEmailAttempted_Text", void 0);
__decorate([
    GlobalResource()
], ForgotUsernameComponent.prototype, "Spa_Agent_UsernameEmailSent_Text", void 0);
__decorate([
    GlobalResource()
], ForgotUsernameComponent.prototype, "Spa_Agent_EmailNotLocated_Error", void 0);
__decorate([
    GlobalResource()
], ForgotUsernameComponent.prototype, "Spa_Agent_SendUsernameEmail_Error", void 0);
__decorate([
    GlobalResource()
], ForgotUsernameComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo", void 0);
__decorate([
    GlobalResource()
], ForgotUsernameComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo_Url", void 0);
__decorate([
    GlobalResource()
], ForgotUsernameComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo", void 0);
__decorate([
    GlobalResource()
], ForgotUsernameComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo_Url", void 0);
__decorate([
    PlatformProp('live-edit')
], ForgotUsernameComponent.prototype, "Spa_Agent_ForgotUsername_Page_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], ForgotUsernameComponent.prototype, "Spa_Agent_ForgotUsername_Description", void 0);
__decorate([
    PlatformProp('live-edit')
], ForgotUsernameComponent.prototype, "Spa_Site_SendEmailButton_Text", void 0);
__decorate([
    LiveEditInactive()
], ForgotUsernameComponent.prototype, "submitEmailForUsername", null);
__decorate([
    LiveEditInactive()
], ForgotUsernameComponent.prototype, "navToAgentLogin", null);
ForgotUsernameComponent = __decorate([
    PlatformWidget
], ForgotUsernameComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ForgotUsernameComponent, [{
        type: Component,
        args: [{ selector: 'vnext-forgot-username', providers: [WidgetService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-dynamic-header\r\n  [headerType]=\"'basic'\"\r\n  [primaryLogo]=\"Spa_HeaderFooter_PrimaryClientLogo\"\r\n  [primaryLogoUrl]=\"Spa_HeaderFooter_PrimaryClientLogo_Url\"\r\n  [secondaryLogo]=\"Spa_HeaderFooter_SecondaryClientLogo\"\r\n  [secondaryLogoUrl]=\"Spa_HeaderFooter_SecondaryClientLogo_Url\"\r\n>\r\n</vnext-dynamic-header>\r\n<div class=\"forgot-username-container container\" vnextGoogleTagManager>\r\n  <div class=\"row\">\r\n    <div class=\"col-xs-12 col-md-6 col-lg-4 offset-xs-0 offset-md-3 offset-lg-4\">\r\n      <h2 *liveEditProp=\"'Spa_Agent_ForgotUsername_Page_Header'\" class=\"forgot-username-header\">\r\n        {{ Spa_Agent_ForgotUsername_Page_Header }}\r\n      </h2>\r\n\r\n      <form class=\"px-2\" disableKeyDownSubmit [formGroup]=\"forgotUsernameForm\" (ngSubmit)=\"submitEmailForUsername()\">\r\n        <ng-container *ngIf=\"emailSuccess; else stayOnPage\">\r\n          <p class=\"Spa_Style_ToolTip px-0\">{{ Spa_Agent_UsernameEmailAttempted_Text }}</p>\r\n          <p class=\"email-success text-center\">\r\n            <i class=\"fas fa-check-circle\" aria-hidden=\"true\"></i>{{ Spa_Agent_UsernameEmailSent_Text }}\r\n          </p>\r\n          <button class=\"btn Spa_Style_PrimaryButton col-12\" (click)=\"navToAgentLogin()\">{{ Spa_LoginWidget_Login_Header_Text }}</button>\r\n        </ng-container>\r\n        <ng-template #stayOnPage>\r\n          <p *liveEditProp=\"'Spa_Agent_ForgotUsername_Description'\" class=\"Spa_Style_ToolTip px-0\">\r\n            {{ Spa_Agent_ForgotUsername_Description }}\r\n          </p>\r\n          <label class=\"px-0 col-12\" for=\"emailAddress\">\r\n            <div class=\"error-container\" *ngIf=\"errorsFlag\">\r\n              <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span>\r\n                <ng-container *ngIf=\"forgotUsernameForm.get('emailAddress').errors.emailFailed; else emailError\">{{\r\n                  Spa_Agent_SendUsernameEmail_Error\r\n                }}</ng-container>\r\n                <ng-template #emailError>\r\n                  <ng-container *ngIf=\"forgotUsernameForm.get('emailAddress').errors.emailAddressNotLocated; else invalidEmailError\">\r\n                    {{ Spa_Agent_EmailNotLocated_Error }}\r\n                  </ng-container>\r\n                </ng-template>\r\n                <ng-template #invalidEmailError>{{ Spa_Agent_EmailRequired_Error }}</ng-template>\r\n              </span>\r\n            </div>\r\n            <div>\r\n              <span class=\"input-error-asterisk\">*</span\r\n              ><span class=\"Spa_Style_Label input-label-text\">{{ Spa_Agent_EmailAddress_Label }}</span>\r\n            </div>\r\n\r\n            <input\r\n              id=\"emailAddress\"\r\n              type=\"email\"\r\n              class=\"col-12\"\r\n              formControlName=\"emailAddress\"\r\n              maxlength=\"255\"\r\n              [ngClass]=\"{ 'has-error': forgotUsernameForm.get('emailAddress').errors && submitted }\"\r\n              (keyup.enter)=\"submitEmailForUsername()\"\r\n            />\r\n          </label>\r\n\r\n          <button type=\"submit\" *liveEditProp=\"'Spa_Site_SendEmailButton_Text'\" class=\"btn Spa_Style_PrimaryButton col-12\">\r\n            {{ Spa_Site_SendEmailButton_Text }}\r\n          </button>\r\n\r\n          <div class=\"text-center\">\r\n            <vnext-inner-text-link\r\n              class=\"\"\r\n              [outerText]=\"Spa_LoginWidget_LoginToAccount_Text\"\r\n              [innerText]=\"Spa_LoginWidget_LoginToAccount_ClickableText\"\r\n              (innerTextClicked)=\"navToAgentLogin()\"\r\n            >\r\n            </vnext-inner-text-link>\r\n          </div>\r\n        </ng-template>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".btn{margin-bottom:15px}.forgot-username-header{margin-top:60px;text-align:center}.forgot-username-container{margin-top:30px}.email-success{color:var(--static-Spa_Style_Cost_Text);white-space:pre-wrap}.email-success>.fa-check-circle{margin-right:5px}button{margin-top:30px}\n"] }]
    }], function () { return [{ type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.ConfigResourceService }, { type: i1.NavigationUtilityService }, { type: i2.Store }, { type: i1.EmailService }, { type: i1.PasswordResetService }]; }, { Spa_Agent_EmailRequired_Error: [], Spa_Agent_EmailAddress_Label: [], Spa_LoginWidget_LoginToAccount_Text: [], Spa_LoginWidget_Login_Header_Text: [], Spa_LoginWidget_LoginToAccount_ClickableText: [], Spa_Agent_UsernameEmailAttempted_Text: [], Spa_Agent_UsernameEmailSent_Text: [], Spa_Agent_EmailNotLocated_Error: [], Spa_Agent_SendUsernameEmail_Error: [], Spa_HeaderFooter_PrimaryClientLogo: [], Spa_HeaderFooter_PrimaryClientLogo_Url: [], Spa_HeaderFooter_SecondaryClientLogo: [], Spa_HeaderFooter_SecondaryClientLogo_Url: [], Spa_Agent_ForgotUsername_Page_Header: [], Spa_Agent_ForgotUsername_Description: [], Spa_Site_SendEmailButton_Text: [], submitEmailForUsername: [], navToAgentLogin: [] }); })();

class AgentNoteDetailComponent {
}
AgentNoteDetailComponent.ɵfac = function AgentNoteDetailComponent_Factory(t) { return new (t || AgentNoteDetailComponent)(); };
AgentNoteDetailComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentNoteDetailComponent, selectors: [["vnext-agent-note-detail"]], inputs: { description: "description", agentName: "agentName", namePrefix: "namePrefix", createdWhen: "createdWhen", createdLabel: "createdLabel" }, decls: 7, vars: 8, consts: [[1, "note-item"], [1, "Spa_Style_Note", "mb-4"], ["navigationAdapter", "", 1, "Spa_Style_Paragraph", "mb-0", "no-translate-block", 3, "innerHTML"], [1, "Spa_Style_Note", "mb-0", "no-translate-block"]], template: function AgentNoteDetailComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "p", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(3, "p", 2);
        i0.ɵɵpipe(4, "safe");
        i0.ɵɵelementStart(5, "p", 3);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate2("", ctx.createdLabel, " ", ctx.createdWhen, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 5, ctx.description, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate2("", ctx.namePrefix, " ", ctx.agentName, " ");
    } }, dependencies: [NavigationAdapterDirective, SafePipe], styles: [".note-item[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Gray2);padding:12px 0;word-wrap:break-word}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentNoteDetailComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-note-detail', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"note-item\">\r\n  <p class=\"Spa_Style_Note mb-4\">{{ createdLabel }} {{ createdWhen }} </p>\r\n  <p [innerHTML]=\"description | safe: 'html'\" navigationAdapter class=\"Spa_Style_Paragraph mb-0 no-translate-block\"></p>\r\n  <p class=\"Spa_Style_Note mb-0 no-translate-block\">{{ namePrefix }} {{ agentName }} </p>\r\n</div>", styles: [".note-item{border-bottom:1px solid var(--static-Spa_Style_Gray2);padding:12px 0;word-wrap:break-word}\n"] }]
    }], null, { description: [{
            type: Input
        }], agentName: [{
            type: Input
        }], namePrefix: [{
            type: Input
        }], createdWhen: [{
            type: Input
        }], createdLabel: [{
            type: Input
        }] }); })();

function AgentNoteComponent_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.agentNoteEmptyNoteText, " ");
} }
function AgentNoteComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-agent-note-detail", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const notes_r2 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("description", notes_r2.description)("agentName", notes_r2.agentName)("namePrefix", ctx_r1.agentNoteAgentNamePreFixLabel)("createdWhen", ctx_r1.formatDate(notes_r2.createdWhen))("createdLabel", ctx_r1.agentNoteCreatedLabel);
} }
class AgentNoteComponent {
    constructor(analyticsService) {
        this.analyticsService = analyticsService;
        this.openNoteModal = new EventEmitter();
    }
    formatDate(date) {
        // API data in Pacific Time (PT). Just need to format as MM/DD/YYYY
        return date ? DateUtilities.getFormattedDateTime(new Date(date), DateUtilities.defaultFormat) : '';
    }
    showModal(event) {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PROFILE_ADD_NOTE);
        event.preventDefault();
        this.openNoteModal.emit();
    }
}
AgentNoteComponent.ɵfac = function AgentNoteComponent_Factory(t) { return new (t || AgentNoteComponent)(i0.ɵɵdirectiveInject(AnalyticsService)); };
AgentNoteComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentNoteComponent, selectors: [["vnext-agent-note"]], inputs: { noteText: "noteText", agentNoteHeader: "agentNoteHeader", agentNoteEmptyNoteText: "agentNoteEmptyNoteText", agentNoteAddNoteLink: "agentNoteAddNoteLink", agentNoteAddNoteLinkEnabled: "agentNoteAddNoteLinkEnabled", agentNoteCreatedLabel: "agentNoteCreatedLabel", agentNoteAgentNamePreFixLabel: "agentNoteAgentNamePreFixLabel", memberAgentNotes: "memberAgentNotes" }, outputs: { openNoteModal: "openNoteModal" }, decls: 11, vars: 8, consts: [[1, "mb-2", "mb-sm-2", "px-2", "noteContainer"], [1, "note-header"], [1, "Spa_Style_H2"], [1, "noteContent"], ["class", "Spa_Style_Note noteEmptyContent", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["tabindex", "0", 1, "noteLink", "Spa_Style_Link", "can-click", "mt-2", 3, "click", "keyup.enter"], ["aria-hidden", "true", 1, "fas", "fa-plus-circle", "mr-1"], [1, "Spa_Style_Note", "noteEmptyContent"], [3, "description", "agentName", "namePrefix", "createdWhen", "createdLabel"]], template: function AgentNoteComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h2", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtemplate(5, AgentNoteComponent_p_5_Template, 2, 1, "p", 4);
        i0.ɵɵtemplate(6, AgentNoteComponent_div_6_Template, 2, 5, "div", 5);
        i0.ɵɵpipe(7, "orderBy");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵlistener("click", function AgentNoteComponent_Template_div_click_8_listener($event) { return ctx.showModal($event); })("keyup.enter", function AgentNoteComponent_Template_div_keyup_enter_8_listener($event) { return ctx.showModal($event); });
        i0.ɵɵelement(9, "span", 7);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.agentNoteHeader);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.memberAgentNotes == null ? null : ctx.memberAgentNotes.length) === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(7, 4, ctx.memberAgentNotes, "createdWhen", true));
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1("", ctx.agentNoteAddNoteLink, " ");
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, AgentNoteDetailComponent, OrderPipe], styles: [".note-header[_ngcontent-%COMP%]{padding-top:30px;border-bottom:2px solid var(--static-Spa_Style_Gray2)}.noteEmptyContent[_ngcontent-%COMP%]{text-align:center;margin-top:12px;padding-bottom:12px;border-bottom:1px solid var(--static-Spa_Style_Gray2)}.noteContent[_ngcontent-%COMP%]{text-align:left}.noteLink[_ngcontent-%COMP%]{text-align:right}.noteLink[_ngcontent-%COMP%]:focus{padding-right:5px;padding-left:5px;margin-right:-5px;margin-left:-5px;border-radius:5px}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], AgentNoteComponent.prototype, "showModal", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentNoteComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-note', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"mb-2 mb-sm-2 px-2 noteContainer\">\r\n  <div class=\"note-header\">\r\n    <h2 class=\"Spa_Style_H2\">{{ agentNoteHeader }}</h2>\r\n  </div>\r\n  <div class=\"noteContent\">\r\n    <p *ngIf=\"memberAgentNotes?.length === 0\" class=\"Spa_Style_Note noteEmptyContent\">\r\n      {{ agentNoteEmptyNoteText }}\r\n    </p>\r\n    <div *ngFor=\"let notes of memberAgentNotes | orderBy : 'createdWhen' : true\">\r\n      <vnext-agent-note-detail\r\n        [description]=\"notes.description\"\r\n        [agentName]=\"notes.agentName\"\r\n        [namePrefix]=\"agentNoteAgentNamePreFixLabel\"\r\n        [createdWhen]=\"formatDate(notes.createdWhen)\"\r\n        [createdLabel]=\"agentNoteCreatedLabel\"\r\n      >\r\n      </vnext-agent-note-detail>\r\n    </div>\r\n  </div>\r\n  <div class=\"noteLink Spa_Style_Link can-click mt-2\" tabindex=\"0\" (click)=\"showModal($event)\" (keyup.enter)=\"showModal($event)\">\r\n    <span class=\"fas fa-plus-circle mr-1\" aria-hidden=\"true\"></span>{{ agentNoteAddNoteLink }}\r\n  </div>\r\n</div>\r\n", styles: [".note-header{padding-top:30px;border-bottom:2px solid var(--static-Spa_Style_Gray2)}.noteEmptyContent{text-align:center;margin-top:12px;padding-bottom:12px;border-bottom:1px solid var(--static-Spa_Style_Gray2)}.noteContent{text-align:left}.noteLink{text-align:right}.noteLink:focus{padding-right:5px;padding-left:5px;margin-right:-5px;margin-left:-5px;border-radius:5px}\n"] }]
    }], function () { return [{ type: AnalyticsService }]; }, { noteText: [{
            type: Input
        }], agentNoteHeader: [{
            type: Input
        }], agentNoteEmptyNoteText: [{
            type: Input
        }], agentNoteAddNoteLink: [{
            type: Input
        }], agentNoteAddNoteLinkEnabled: [{
            type: Input
        }], agentNoteCreatedLabel: [{
            type: Input
        }], agentNoteAgentNamePreFixLabel: [{
            type: Input
        }], memberAgentNotes: [{
            type: Input
        }], openNoteModal: [{
            type: Output
        }], showModal: [] }); })();

function AgentOfRecordComponent_ng_container_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "vnext-agent-profile-picture", 8);
    i0.ɵɵelementStart(2, "div", 9);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("broker", ctx_r1.agentOfRecord == null ? null : ctx_r1.agentOfRecord.agentData == null ? null : ctx_r1.agentOfRecord.agentData.data)("isViewOnly", true)("agentProfilePictureUrl", ctx_r1.agentOfRecord == null ? null : ctx_r1.agentOfRecord.agentData == null ? null : ctx_r1.agentOfRecord.agentData.data == null ? null : ctx_r1.agentOfRecord.agentData.data.agentPictureURL);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", ctx_r1.agentOfRecord == null ? null : ctx_r1.agentOfRecord.agentData == null ? null : ctx_r1.agentOfRecord.agentData.data == null ? null : ctx_r1.agentOfRecord.agentData.data.firstName, " ", ctx_r1.agentOfRecord == null ? null : ctx_r1.agentOfRecord.agentData == null ? null : ctx_r1.agentOfRecord.agentData.data == null ? null : ctx_r1.agentOfRecord.agentData.data.lastName, " ");
} }
function AgentOfRecordComponent_ng_container_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "i", 11);
    i0.ɵɵelementStart(2, "span", 12);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.agentOfRecordUnassignedText);
} }
function AgentOfRecordComponent_ng_container_3_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵlistener("click", function AgentOfRecordComponent_ng_container_3_div_4_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.showModal()); })("keyup.enter", function AgentOfRecordComponent_ng_container_3_div_4_Template_div_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r6 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r6.showModal()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.agentOfRecordReassignText, " ");
} }
function AgentOfRecordComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵtemplate(2, AgentOfRecordComponent_ng_container_3_div_2_Template, 4, 5, "div", 4);
    i0.ɵɵtemplate(3, AgentOfRecordComponent_ng_container_3_div_3_Template, 4, 1, "div", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, AgentOfRecordComponent_ng_container_3_div_4_Template, 2, 1, "div", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.agentOfRecord == null ? null : ctx_r0.agentOfRecord.agentData == null ? null : ctx_r0.agentOfRecord.agentData.data);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(ctx_r0.agentOfRecord == null ? null : ctx_r0.agentOfRecord.agentData == null ? null : ctx_r0.agentOfRecord.agentData.data));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isAgentAdmin || ctx_r0.isProfileAdmin);
} }
class AgentOfRecordComponent {
    constructor(modalService, analyticsService) {
        this.modalService = modalService;
        this.analyticsService = analyticsService;
    }
    showModal() {
        this.setAnalyticsEvent();
        const modalRef = this.modalService.open(AgentOfRecordModalComponent, { centered: true });
    }
    setAnalyticsEvent() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PROFILE_AGENT_REASSIGN_OPEN_MODAL);
    }
}
AgentOfRecordComponent.ɵfac = function AgentOfRecordComponent_Factory(t) { return new (t || AgentOfRecordComponent)(i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(AnalyticsService)); };
AgentOfRecordComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentOfRecordComponent, selectors: [["vnext-agent-of-record"]], inputs: { agentOfRecord: "agentOfRecord", agentOfRecordHeaderLabel: "agentOfRecordHeaderLabel", agentOfRecordReassignText: "agentOfRecordReassignText", agentOfRecordUnassignedText: "agentOfRecordUnassignedText", isAgentAdmin: "isAgentAdmin", isProfileAdmin: "isProfileAdmin" }, decls: 4, vars: 2, consts: [[1, "mb-2", "mb-sm-2", "px-2", "agent-container"], [1, "Spa_Style_H2", "agent-header"], [4, "ngIf"], [1, "agent-content", "text-left"], ["class", "agent-name-container", 4, "ngIf"], ["class", "unassigned", 4, "ngIf"], ["class", "Spa_Style_Link can-click text-right", "tabindex", "0", 3, "click", "keyup.enter", 4, "ngIf"], [1, "agent-name-container"], [3, "broker", "isViewOnly", "agentProfilePictureUrl"], [1, "ml-2", "agent-name", "Spa_Style_Paragraph", "no-translate-block"], [1, "unassigned"], ["aria-hidden", "true", 1, "fa", "fa-user", "mr-2", "Spa_Style_Accent1_Color"], [1, "Spa_Style_Paragraph"], ["tabindex", "0", 1, "Spa_Style_Link", "can-click", "text-right", 3, "click", "keyup.enter"]], template: function AgentOfRecordComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "h2", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, AgentOfRecordComponent_ng_container_3_Template, 5, 3, "ng-container", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.agentOfRecordHeaderLabel);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.agentOfRecord == null ? null : ctx.agentOfRecord.loaded);
    } }, dependencies: [i1$2.NgIf, IconAriaAttributesDirective, AgentProfilePictureComponent], styles: [".agent-container[_ngcontent-%COMP%]{min-height:146px}.agent-header[_ngcontent-%COMP%]{padding-top:30px;border-bottom:2px solid var(--static-Spa_Style_Gray2);padding-bottom:.5rem}.agent-name-container[_ngcontent-%COMP%]{padding-bottom:20px;display:flex;align-items:start}.agent-name[_ngcontent-%COMP%]{word-wrap:break-word;min-width:148px;margin:auto}.unassigned[_ngcontent-%COMP%]{padding-bottom:20px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentOfRecordComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-of-record', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"mb-2 mb-sm-2 px-2 agent-container\">\r\n  <h2 class=\"Spa_Style_H2 agent-header\">{{ agentOfRecordHeaderLabel }}</h2>\r\n  <ng-container *ngIf=\"agentOfRecord?.loaded\">\r\n    <div class=\"agent-content text-left\">\r\n      <div *ngIf=\"agentOfRecord?.agentData?.data\" class=\"agent-name-container\">\r\n        <vnext-agent-profile-picture\r\n          [broker]=\"agentOfRecord?.agentData?.data\"\r\n          [isViewOnly]=\"true\"\r\n          [agentProfilePictureUrl]=\"agentOfRecord?.agentData?.data?.agentPictureURL\"\r\n        ></vnext-agent-profile-picture>\r\n        <div class=\"ml-2 agent-name Spa_Style_Paragraph no-translate-block\">\r\n          {{ agentOfRecord?.agentData?.data?.firstName }} {{ agentOfRecord?.agentData?.data?.lastName }}\r\n        </div>\r\n      </div>\r\n\r\n      <div *ngIf=\"!agentOfRecord?.agentData?.data\" class=\"unassigned\">\r\n        <i class=\"fa fa-user mr-2 Spa_Style_Accent1_Color\" aria-hidden=\"true\"></i>\r\n        <span class=\"Spa_Style_Paragraph\">{{ agentOfRecordUnassignedText }}</span>\r\n      </div>\r\n    </div>\r\n    <div\r\n      *ngIf=\"isAgentAdmin || isProfileAdmin\"\r\n      class=\"Spa_Style_Link can-click text-right\"\r\n      tabindex=\"0\"\r\n      (click)=\"showModal()\"\r\n      (keyup.enter)=\"showModal()\"\r\n    >\r\n      {{ agentOfRecordReassignText }}\r\n    </div>\r\n  </ng-container>\r\n</div>\r\n", styles: [".agent-container{min-height:146px}.agent-header{padding-top:30px;border-bottom:2px solid var(--static-Spa_Style_Gray2);padding-bottom:.5rem}.agent-name-container{padding-bottom:20px;display:flex;align-items:start}.agent-name{word-wrap:break-word;min-width:148px;margin:auto}.unassigned{padding-bottom:20px}\n"] }]
    }], function () { return [{ type: i1$1.NgbModal }, { type: AnalyticsService }]; }, { agentOfRecord: [{
            type: Input
        }], agentOfRecordHeaderLabel: [{
            type: Input
        }], agentOfRecordReassignText: [{
            type: Input
        }], agentOfRecordUnassignedText: [{
            type: Input
        }], isAgentAdmin: [{
            type: Input
        }], isProfileAdmin: [{
            type: Input
        }] }); })();

function AgentProgressTrackerComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "span", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r0.transferCodeLabelText, " :");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.memberProgressInfo.transferCode);
} }
function AgentProgressTrackerComponent_div_4_div_1_vnext_progress_status_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-progress-status", 9);
    i0.ɵɵlistener("redirectRouteEvent", function AgentProgressTrackerComponent_div_4_div_1_vnext_progress_status_1_Template_vnext_progress_status_redirectRouteEvent_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r5.redirectRouteEvent.emit($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const event_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("progressStatus", event_r3)("isProfilePage", ctx_r4.isProfilePage)("prescriptionsEnabled", ctx_r4.prescriptionsEnabled)("pharmacyEnabled", ctx_r4.pharmacyEnabled)("providersEnabled", ctx_r4.providersEnabled);
} }
function AgentProgressTrackerComponent_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AgentProgressTrackerComponent_div_4_div_1_vnext_progress_status_1_Template, 1, 5, "vnext-progress-status", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const event_r3 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", event_r3.enabled);
} }
function AgentProgressTrackerComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, AgentProgressTrackerComponent_div_4_div_1_Template, 2, 1, "div", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.memberProgressEventTypes)("ngForTrackBy", ctx_r1.trackByProgressEvent);
} }
class AgentProgressTrackerComponent {
    constructor() {
        this.isMemberProgressVisible = false;
        this.isProfilePage = true;
        this.redirectRouteEvent = new EventEmitter();
        this.memberProgressEventTypes = [];
    }
    ngOnChanges(changes) {
        const { memberProgressInfo, progressEvent } = changes;
        if ((memberProgressInfo && !_isEqual(memberProgressInfo.currentValue, memberProgressInfo.previousValue)) ||
            (progressEvent && !_isEqual(progressEvent.currentValue, progressEvent.previousValue))) {
            this.setProfileStatuses();
        }
    }
    setProfileStatuses() {
        this.memberProgressEventTypes = [];
        this.memberProgressEventTypes = this.progressEvent.map(event => {
            const statusDetail = this.memberProgressInfo?.memberProgressList?.find(progress => event.value === progress.statusEventId);
            return { ...event, modifiedWhen: statusDetail?.modifiedWhen || '' };
        });
    }
    trackByProgressEvent(index, progressEvent) {
        return progressEvent.value;
    }
}
AgentProgressTrackerComponent.ɵfac = function AgentProgressTrackerComponent_Factory(t) { return new (t || AgentProgressTrackerComponent)(); };
AgentProgressTrackerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentProgressTrackerComponent, selectors: [["vnext-agent-progress-tracker"]], inputs: { isMemberProgressVisible: "isMemberProgressVisible", memberProgressTitle: "memberProgressTitle", progressEvent: "progressEvent", memberProgressInfo: "memberProgressInfo", transferCodeLabelText: "transferCodeLabelText", isTransferCodeEnabled: "isTransferCodeEnabled", isProfilePage: "isProfilePage", prescriptionsEnabled: "prescriptionsEnabled", pharmacyEnabled: "pharmacyEnabled", providersEnabled: "providersEnabled" }, outputs: { redirectRouteEvent: "redirectRouteEvent" }, features: [i0.ɵɵNgOnChangesFeature], decls: 5, vars: 3, consts: [[1, "mb-2", "mb-sm-2", "px-2", "tracker-container"], [1, "Spa_Style_H2", "tracker-header"], ["class", "py-2", 4, "ngIf"], ["class", "col-12 align-self-start align-self-md-center pb-2 pb-md-0 member-card-div px-4", 4, "ngIf"], [1, "py-2"], [1, "Spa_Style_Bold_Weight", "pr-1"], [1, "col-12", "align-self-start", "align-self-md-center", "pb-2", "pb-md-0", "member-card-div", "px-4"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "progressStatus", "isProfilePage", "prescriptionsEnabled", "pharmacyEnabled", "providersEnabled", "redirectRouteEvent", 4, "ngIf"], [3, "progressStatus", "isProfilePage", "prescriptionsEnabled", "pharmacyEnabled", "providersEnabled", "redirectRouteEvent"]], template: function AgentProgressTrackerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "h2", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, AgentProgressTrackerComponent_div_3_Template, 5, 2, "div", 2);
        i0.ɵɵtemplate(4, AgentProgressTrackerComponent_div_4_Template, 2, 2, "div", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.memberProgressTitle);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.memberProgressInfo == null ? null : ctx.memberProgressInfo.transferCode) && ctx.isTransferCodeEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isMemberProgressVisible);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, ProgressStatusComponent], styles: [".tracker-container[_ngcontent-%COMP%]{min-height:146px}.tracker-header[_ngcontent-%COMP%]{padding-top:30px;border-bottom:2px solid var(--static-Spa_Style_Gray2);padding-bottom:8px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentProgressTrackerComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-progress-tracker', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"mb-2 mb-sm-2 px-2 tracker-container\">\r\n  <h2 class=\"Spa_Style_H2 tracker-header\">{{ memberProgressTitle }}</h2>\r\n\r\n  <div *ngIf=\"memberProgressInfo?.transferCode && isTransferCodeEnabled\" class=\"py-2\">\r\n    <span class=\"Spa_Style_Bold_Weight pr-1\">{{ transferCodeLabelText }} :</span> <span>{{ memberProgressInfo.transferCode }}</span>\r\n  </div>\r\n\r\n  <div *ngIf=\"isMemberProgressVisible\" class=\"col-12 align-self-start align-self-md-center pb-2 pb-md-0 member-card-div px-4\">\r\n    <div *ngFor=\"let event of memberProgressEventTypes; trackBy: trackByProgressEvent\">\r\n      <vnext-progress-status\r\n        *ngIf=\"event.enabled\"\r\n        [progressStatus]=\"event\"\r\n        [isProfilePage]=\"isProfilePage\"\r\n        [prescriptionsEnabled]=\"prescriptionsEnabled\"\r\n        [pharmacyEnabled]=\"pharmacyEnabled\"\r\n        [providersEnabled]=\"providersEnabled\"\r\n        (redirectRouteEvent)=\"redirectRouteEvent.emit($event)\"\r\n      ></vnext-progress-status>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".tracker-container{min-height:146px}.tracker-header{padding-top:30px;border-bottom:2px solid var(--static-Spa_Style_Gray2);padding-bottom:8px}\n"] }]
    }], null, { isMemberProgressVisible: [{
            type: Input
        }], memberProgressTitle: [{
            type: Input
        }], progressEvent: [{
            type: Input
        }], memberProgressInfo: [{
            type: Input
        }], transferCodeLabelText: [{
            type: Input
        }], isTransferCodeEnabled: [{
            type: Input
        }], isProfilePage: [{
            type: Input
        }], prescriptionsEnabled: [{
            type: Input
        }], pharmacyEnabled: [{
            type: Input
        }], providersEnabled: [{
            type: Input
        }], redirectRouteEvent: [{
            type: Output
        }] }); })();

class AgentRetirefloDetailComponent {
}
AgentRetirefloDetailComponent.ɵfac = function AgentRetirefloDetailComponent_Factory(t) { return new (t || AgentRetirefloDetailComponent)(); };
AgentRetirefloDetailComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentRetirefloDetailComponent, selectors: [["venxt-agent-retireflo-detail"]], inputs: { description: "description" }, decls: 4, vars: 4, consts: [[1, "retireFlo-item"], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "pr-1"], ["navigationAdapter", "", 1, "Spa_Style_Paragraph", "mb-0", "no-translate-block", 3, "innerHTML"]], template: function AgentRetirefloDetailComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "i", 1)(2, "span", 2);
        i0.ɵɵpipe(3, "safe");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(3, 1, ctx.description, "html"), i0.ɵɵsanitizeHtml);
    } }, dependencies: [NavigationAdapterDirective, IconAriaAttributesDirective, SafePipe], styles: [".retireFlo-item[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Gray2);padding:12px 0;word-wrap:break-word}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentRetirefloDetailComponent, [{
        type: Component,
        args: [{ selector: 'venxt-agent-retireflo-detail', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"retireFlo-item\">\r\n  <i class=\"fas fa-check-circle pr-1\" aria-hidden=\"true\"></i>\r\n  <span [innerHTML]=\"description | safe : 'html'\" navigationAdapter class=\"Spa_Style_Paragraph mb-0 no-translate-block\"></span>\r\n</div>\r\n", styles: [".retireFlo-item{border-bottom:1px solid var(--static-Spa_Style_Gray2);padding:12px 0;word-wrap:break-word}\n"] }]
    }], null, { description: [{
            type: Input
        }] }); })();

function AgentRetireFloComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "span", 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div")(4, "button", 5);
    i0.ɵɵlistener("click", function AgentRetireFloComponent_div_4_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.agentRetireFloSignUp()); });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.agentRetireFloSignUpContentText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.agentRetireFloSignUpButtonText, " ");
} }
function AgentRetireFloComponent_div_5_p_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.agentRetireFloEmptyText, " ");
} }
function AgentRetireFloComponent_div_5_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "venxt-agent-retireflo-detail", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const retireflo_r6 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("description", retireflo_r6.description);
} }
function AgentRetireFloComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 6);
    i0.ɵɵtemplate(2, AgentRetireFloComponent_div_5_p_2_Template, 2, 1, "p", 7);
    i0.ɵɵtemplate(3, AgentRetireFloComponent_div_5_div_3_Template, 2, 1, "div", 8);
    i0.ɵɵpipe(4, "orderBy");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 9)(6, "button", 10);
    i0.ɵɵlistener("click", function AgentRetireFloComponent_div_5_Template_button_click_6_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.showModal($event)); })("keyup.enter", function AgentRetireFloComponent_div_5_Template_button_keyup_enter_6_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.showModal($event)); });
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r1.memberAgentNotes == null ? null : ctx_r1.memberAgentNotes.length) === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(4, 3, ctx_r1.memberAgentNotes, "createdWhen", true));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.agentRetireFloSendServeyButtonText, " ");
} }
class AgentRetireFloComponent {
    constructor(modalService, configResourceService) {
        this.modalService = modalService;
        this.configResourceService = configResourceService;
        this.agentHasRetireFlo = false;
        this.agentRetireFloHeaderLabel = 'RetireFlo';
        this.openSendRetireFloModal = new EventEmitter();
        this.agentRetireFloEmptyText = 'You have no RetireFlo Survey for this profile';
    }
    showModal(event) {
        event.preventDefault();
        this.openSendRetireFloModal.emit();
    }
    formatDate(date) {
        return date ? DateUtilities.getFormattedDateTime(new Date(date), DateUtilities.defaultFormat) : '';
    }
    agentRetireFloSignUp() {
        const agentRetireFloModal = this.modalService.open(AgentRetireFloSignupModalComponent, { centered: true });
        agentRetireFloModal.componentInstance.title = this.configResourceService.getProcessedResourceValue('Spa_RetireFlo_SignUpModalHeader_Text', null, 'RetireFlo SignUp');
        agentRetireFloModal.componentInstance.contenttext = this.configResourceService.getProcessedResourceValue('Spa_RetireFlo_SignUpModalContent_Text', null, '');
        agentRetireFloModal.componentInstance.cancelButton = this.configResourceService.getProcessedResourceValue('Spa_Site_Cancel', null, 'cancel');
        agentRetireFloModal.componentInstance.confirmButton = this.configResourceService.getProcessedResourceValue('Spa_RetireFlo_SignUpModal_ContinueButton_Text', null, 'SignUp');
        agentRetireFloModal.componentInstance.primaryLogo = this.configResourceService.getProcessedResourceValue('Spa_RetireFlo_SignUpModalLogo_URL', null, '');
        agentRetireFloModal.componentInstance.signUpURL = this.configResourceService.getProcessedResourceValue('Spa_RetireFlo_SignUp_URL', null, '');
        agentRetireFloModal.componentInstance.primaryLogoAltText = this.configResourceService.getProcessedResourceValue('Spa_Header_PrimaryLogo_Alt_Text', null, '[[Spa_ClientName]] logo');
    }
}
AgentRetireFloComponent.ɵfac = function AgentRetireFloComponent_Factory(t) { return new (t || AgentRetireFloComponent)(i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(i1.ConfigResourceService)); };
AgentRetireFloComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentRetireFloComponent, selectors: [["vnext-agent-retire-flo"]], inputs: { agentHasRetireFlo: "agentHasRetireFlo", agentRetireFloHeaderLabel: "agentRetireFloHeaderLabel", agentRetireFloSignUpContentText: "agentRetireFloSignUpContentText", agentRetireFloSignUpButtonText: "agentRetireFloSignUpButtonText", agentRetireFloSendServeyButtonText: "agentRetireFloSendServeyButtonText", memberAgentNotes: "memberAgentNotes" }, outputs: { openSendRetireFloModal: "openSendRetireFloModal" }, decls: 6, vars: 3, consts: [[1, "mb-2", "mb-sm-2", "px-2", "agent-container"], [1, "Spa_Style_H2", "agent-header"], ["class", "agent-content text-left", 4, "ngIf"], [1, "agent-content", "text-left"], [1, "Spa_Style_Paragraph"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "mr-auto", "mt-2", 3, "click"], [1, "retirefloContent"], ["class", "Spa_Style_Note retireFlo-Empty-Content", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "send-survey-button", "mt-2"], [1, "btn", "Spa_Style_SecondaryButton", 3, "click", "keyup.enter"], [1, "Spa_Style_Note", "retireFlo-Empty-Content"], [3, "description"]], template: function AgentRetireFloComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "h2", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerStart(3);
        i0.ɵɵtemplate(4, AgentRetireFloComponent_div_4_Template, 6, 2, "div", 2);
        i0.ɵɵtemplate(5, AgentRetireFloComponent_div_5_Template, 8, 7, "div", 2);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.agentRetireFloHeaderLabel);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.agentHasRetireFlo);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.agentHasRetireFlo);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, AgentRetirefloDetailComponent, OrderPipe], styles: [".agent-container[_ngcontent-%COMP%]{min-height:146px}.agent-header[_ngcontent-%COMP%]{padding-top:30px;border-bottom:2px solid var(--static-Spa_Style_Gray2);padding-bottom:.5rem}.send-survey-button[_ngcontent-%COMP%]{margin-top:.5rem!important;text-align:right}.retireFlo-Empty-Content[_ngcontent-%COMP%]{text-align:center;margin-top:12px;padding-bottom:12px;border-bottom:1px solid var(--static-Spa_Style_Gray2)}.retirefloContent[_ngcontent-%COMP%]{text-align:left}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], AgentRetireFloComponent.prototype, "showModal", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentRetireFloComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-retire-flo', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"mb-2 mb-sm-2 px-2 agent-container\">\r\n  <h2 class=\"Spa_Style_H2 agent-header\">{{ agentRetireFloHeaderLabel }}</h2>\r\n  <ng-container>\r\n    <div *ngIf=\"!agentHasRetireFlo\" class=\"agent-content text-left\">\r\n      <span class=\"Spa_Style_Paragraph\">{{ agentRetireFloSignUpContentText }}</span>\r\n      <div>\r\n        <button type=\"button\" (click)=\"agentRetireFloSignUp()\" class=\"btn Spa_Style_SecondaryButton mr-auto mt-2\">\r\n          {{ agentRetireFloSignUpButtonText }}\r\n        </button>\r\n      </div>\r\n    </div>\r\n\r\n    <div *ngIf=\"agentHasRetireFlo\" class=\"agent-content text-left\">\r\n      <div class=\"retirefloContent\">\r\n        <p *ngIf=\"memberAgentNotes?.length === 0\" class=\"Spa_Style_Note retireFlo-Empty-Content\">\r\n          {{ agentRetireFloEmptyText }}\r\n        </p>\r\n        <div *ngFor=\"let retireflo of memberAgentNotes | orderBy : 'createdWhen' : true\">\r\n          <venxt-agent-retireflo-detail [description]=\"retireflo.description\"> </venxt-agent-retireflo-detail>\r\n        </div>\r\n      </div>\r\n      <div class=\"send-survey-button mt-2\">\r\n        <button class=\"btn Spa_Style_SecondaryButton\" (click)=\"showModal($event)\" (keyup.enter)=\"showModal($event)\">\r\n          {{ agentRetireFloSendServeyButtonText }}\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n</div>\r\n", styles: [".agent-container{min-height:146px}.agent-header{padding-top:30px;border-bottom:2px solid var(--static-Spa_Style_Gray2);padding-bottom:.5rem}.send-survey-button{margin-top:.5rem!important;text-align:right}.retireFlo-Empty-Content{text-align:center;margin-top:12px;padding-bottom:12px;border-bottom:1px solid var(--static-Spa_Style_Gray2)}.retirefloContent{text-align:left}\n"] }]
    }], function () { return [{ type: i1$1.NgbModal }, { type: i1.ConfigResourceService }]; }, { agentHasRetireFlo: [{
            type: Input
        }], agentRetireFloHeaderLabel: [{
            type: Input
        }], agentRetireFloSignUpContentText: [{
            type: Input
        }], agentRetireFloSignUpButtonText: [{
            type: Input
        }], agentRetireFloSendServeyButtonText: [{
            type: Input
        }], memberAgentNotes: [{
            type: Input
        }], openSendRetireFloModal: [{
            type: Output
        }], showModal: [] }); })();

function SendSoaModalComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.modalPromptText);
} }
function SendSoaModalComponent_div_7_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r5.emailRequiredError);
} }
function SendSoaModalComponent_div_7_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.emailInvalidError);
} }
function SendSoaModalComponent_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "i", 20);
    i0.ɵɵtemplate(2, SendSoaModalComponent_div_7_div_1_span_2_Template, 2, 1, "span", 21);
    i0.ɵɵtemplate(3, SendSoaModalComponent_div_7_div_1_span_3_Template, 2, 1, "span", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.getFieldErrors("emailAddress").required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.getFieldErrors("emailAddress").email);
} }
function SendSoaModalComponent_div_7_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "label", 23)(2, "input", 24);
    i0.ɵɵlistener("click", function SendSoaModalComponent_div_7_div_2_Template_input_click_2_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.toggleEmailCheckBox()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.modalEmailCheckboxLabelText, " ");
} }
function SendSoaModalComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, SendSoaModalComponent_div_7_div_1_Template, 4, 2, "div", 14);
    i0.ɵɵtemplate(2, SendSoaModalComponent_div_7_div_2_Template, 4, 1, "div", 15);
    i0.ɵɵelementStart(3, "div", 12)(4, "label", 16)(5, "span", 17);
    i0.ɵɵtext(6, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "input", 18);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.fieldHasError("emailAddress"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showCheckBoxes);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r1.modalEmailLabelText);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-describedby", ctx_r1.fieldHasError("emailAddress") ? "emailAddressError" : null);
} }
function SendSoaModalComponent_div_8_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r11.phoneRequiredError);
} }
function SendSoaModalComponent_div_8_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r12.phoneInvalidError);
} }
function SendSoaModalComponent_div_8_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelement(1, "i", 20);
    i0.ɵɵtemplate(2, SendSoaModalComponent_div_8_div_1_span_2_Template, 2, 1, "span", 21);
    i0.ɵɵtemplate(3, SendSoaModalComponent_div_8_div_1_span_3_Template, 2, 1, "span", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r9.getFieldErrors("phone").required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.getFieldErrors("phone").pattern);
} }
function SendSoaModalComponent_div_8_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "label", 30)(2, "input", 31);
    i0.ɵɵlistener("click", function SendSoaModalComponent_div_8_div_2_Template_input_click_2_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.togglePhoneCheckBox()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.modalPhoneCheckboxLabelText, " ");
} }
const _c0$2W = function (a0) { return { "mt-3": a0 }; };
function SendSoaModalComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, SendSoaModalComponent_div_8_div_1_Template, 4, 2, "div", 26);
    i0.ɵɵtemplate(2, SendSoaModalComponent_div_8_div_2_Template, 4, 1, "div", 15);
    i0.ɵɵelementStart(3, "div", 12)(4, "label", 27)(5, "span", 17);
    i0.ɵɵtext(6, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "input", 28);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0$2W, ctx_r2.showEmail));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.fieldHasError("phone"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.showCheckBoxes);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r2.modalPhoneLabelText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("maxLength", ctx_r2.phoneMask.length)("mask", ctx_r2.phoneMask);
    i0.ɵɵattribute("aria-describedby", ctx_r2.fieldHasError("phone") ? "phoneError" : null);
} }
class SendSoaModalComponent {
    constructor(activeModal, store, cdr, profileService) {
        this.activeModal = activeModal;
        this.store = store;
        this.cdr = cdr;
        this.profileService = profileService;
        this.memberRegistrationFields = [];
        this.hasCheckboxRequiredError = false;
        this.phoneMask = '(000) 000-0000';
    }
    ngOnInit() {
        this.initializeForm();
    }
    closeSendSOAModal() {
        this.activeModal.dismiss();
        if (this.cancelAction) {
            this.cancelAction();
        }
    }
    onSendSOA() {
        // Validate at least email or phone checkbox is checked
        if (this.showCheckBoxes) {
            const phoneCheckbox = this.sendSOAFormGroup.controls.phoneCheckbox;
            const emailCheckbox = this.sendSOAFormGroup.controls.emailAddressCheckbox;
            if (!phoneCheckbox.value && !emailCheckbox.value) {
                this.hasCheckboxRequiredError = true;
                return;
            }
            if (emailCheckbox.value && this.hasRequiredErrors('emailAddress')) {
                this.sendSOAFormGroup.get('emailAddress').markAsTouched({ onlySelf: true });
            }
            if (phoneCheckbox.value && this.hasRequiredErrors('phone')) {
                this.sendSOAFormGroup.get('phone').markAsTouched({ onlySelf: true });
            }
            this.hasCheckboxRequiredError = false;
        }
        if (this.sendSOAFormGroup.valid) {
            const emailAddressCheckbox = this.sendSOAFormGroup.get('emailAddressCheckbox').value;
            const emailAddress = emailAddressCheckbox ? this.sendSOAFormGroup.get('emailAddress').value : null;
            const emailAddressIsDirty = this.sendSOAFormGroup.get('emailAddress').dirty;
            const phoneCheckbox = this.sendSOAFormGroup.get('phoneCheckbox').value;
            const phone = phoneCheckbox ? this.sendSOAFormGroup.get('phone').value : null;
            const phoneIsDirty = this.sendSOAFormGroup.get('phone').dirty;
            const formData = {
                emailAddressIsDirty,
                emailAddress,
                phoneIsDirty,
                phone
            };
            this.activeModal.close(formData);
        }
    }
    getFieldErrors(fieldName) {
        const control = this.sendSOAFormGroup.get(fieldName);
        return control.errors || {};
    }
    hasRequiredErrors(fieldName) {
        const errors = this.getFieldErrors(fieldName);
        return !!errors.required || !!errors.pattern;
    }
    fieldHasError(fieldName) {
        const control = this.sendSOAFormGroup.get(fieldName);
        return !control.valid && control.touched && !control.disabled;
    }
    isFieldRequired(fieldName) {
        const fieldByName = this.memberRegistrationFields.find(field => field.keyName === fieldName);
        return fieldByName && fieldByName.required;
    }
    toggleEmailCheckBox() {
        const emailCheckbox = this.sendSOAFormGroup.controls.emailAddressCheckbox;
        const email = this.sendSOAFormGroup.controls.emailAddress;
        if (emailCheckbox.value) {
            this.hasCheckboxRequiredError = false;
        }
        const updatedCheckboxValue = !emailCheckbox.value;
        emailCheckbox.setValue(updatedCheckboxValue);
        if (updatedCheckboxValue) {
            email.enable();
        }
        else {
            email.disable();
        }
        this.cdr.markForCheck();
    }
    togglePhoneCheckBox() {
        const phoneCheckbox = this.sendSOAFormGroup.controls.phoneCheckbox;
        const phone = this.sendSOAFormGroup.controls.phone;
        if (phoneCheckbox.value) {
            this.hasCheckboxRequiredError = false;
        }
        const updatedCheckboxValue = !phoneCheckbox.value;
        phoneCheckbox.setValue(updatedCheckboxValue);
        if (updatedCheckboxValue) {
            phone.enable();
        }
        else {
            phone.disable();
        }
    }
    isPhoneFieldEnabled(isPhoneCheckboxChecked) {
        // If showPhone is set we know that we are on the send enrollment and not quick quote path.
        if (this.showPhone) {
            return isPhoneCheckboxChecked;
        }
        return this.isFieldRequired('phone');
    }
    initializeForm() {
        const memberProfileData = this.store.selectSnapshot(MemberState.session);
        this.showCheckBoxes = this.showEmail && this.showPhone;
        const profileEmailAddress = this.profileService.hasMemberProfile() ? memberProfileData.profile.emailAddress : null;
        const profilePhone = this.profileService.getPrimaryPhoneNumber(memberProfileData);
        const defaultEmailAddress = profileEmailAddress;
        const defaultPhone = profilePhone;
        this.sendSOAFormGroup = new UntypedFormGroup({
            emailAddress: new UntypedFormControl({ value: defaultEmailAddress, disabled: !this.quoteLinkEmailOnlyEnabled }, [
                Validators.required,
                Validators.email
            ]),
            emailAddressCheckbox: new UntypedFormControl({ value: this.quoteLinkEmailOnlyEnabled, disabled: this.quoteLinkEmailOnlyEnabled }),
            phone: new UntypedFormControl({
                value: defaultPhone,
                disabled: !this.isPhoneFieldEnabled(this.authCodeTextOnlyEnabled)
            }, [Validators.pattern(RegexPattern.US_TELEPHONE), Validators.required, Validators.maxLength(this.phoneMask.length)]),
            phoneCheckbox: new UntypedFormControl({ value: this.authCodeTextOnlyEnabled, disabled: this.authCodeTextOnlyEnabled })
        }, { updateOn: 'blur' });
    }
}
SendSoaModalComponent.ɵfac = function SendSoaModalComponent_Factory(t) { return new (t || SendSoaModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.ProfileService)); };
SendSoaModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SendSoaModalComponent, selectors: [["ng-component"]], decls: 14, vars: 8, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [3, "formGroup"], [1, "form-group", "modal-body"], [1, "mt-0"], [1, "Spa_Style_H2"], ["class", "row mb-3", 4, "ngIf"], ["class", "row align-items-center no-gutters", 4, "ngIf"], ["class", "row align-items-center no-gutters", 3, "ngClass", 4, "ngIf"], [1, "modal-footer", "justify-content-start"], ["type", "button", 1, "btn", "mr-auto", "Spa_Style_SecondaryButton", 3, "click"], ["type", "submit", 1, "btn", "Spa_Style_PrimaryButton", 3, "click"], [1, "row", "mb-3"], [1, "col"], [1, "row", "align-items-center", "no-gutters"], ["id", "emailAddressError", "class", "error-container col-12", "role", "alert", 4, "ngIf"], ["class", "col-2 mr-1 Spa_Style_Paragraph", 4, "ngIf"], ["for", "emailAddress", 1, "Spa_Style_Label"], ["aria-hidden", "true", 1, "input-error-asterisk"], ["id", "emailAddress", "aria-required", "true", "ngbAutofocus", "", "type", "email", "formControlName", "emailAddress", 1, "form-control"], ["id", "emailAddressError", "role", "alert", 1, "error-container", "col-12"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], [4, "ngIf"], [1, "col-2", "mr-1", "Spa_Style_Paragraph"], ["for", "emailAddressCheckbox"], ["id", "emailAddressCheckbox", "type", "checkbox", "formControlName", "emailAddressCheckbox", 3, "click"], [1, "row", "align-items-center", "no-gutters", 3, "ngClass"], ["id", "phoneError", "class", "error-container col-12", "role", "alert", 4, "ngIf"], ["for", "phone", 1, "Spa_Style_Label"], ["id", "phone", "aria-required", "true", "ngbAutofocus", "", "type", "text", "formControlName", "phone", 1, "form-control", 3, "maxLength", "mask"], ["id", "phoneError", "role", "alert", 1, "error-container", "col-12"], ["for", "phoneCheckbox"], ["id", "phoneCheckbox", "type", "checkbox", "formControlName", "phoneCheckbox", 3, "click"]], template: function SendSoaModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function SendSoaModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.closeSendSOAModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "form", 1)(2, "div", 2)(3, "div", 3)(4, "h2", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(6, SendSoaModalComponent_div_6_Template, 3, 1, "div", 5);
        i0.ɵɵtemplate(7, SendSoaModalComponent_div_7_Template, 9, 4, "div", 6);
        i0.ɵɵtemplate(8, SendSoaModalComponent_div_8_Template, 9, 9, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 8)(10, "button", 9);
        i0.ɵɵlistener("click", function SendSoaModalComponent_Template_button_click_10_listener() { return ctx.closeSendSOAModal(); });
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 10);
        i0.ɵɵlistener("click", function SendSoaModalComponent_Template_button_click_12_listener() { return ctx.onSendSOA(); });
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.modalTitleText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.sendSOAFormGroup);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.sendSOAHeader, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.modalPromptText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showEmail);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showPhone);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.modalCancelText, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.modalSendButtonText, " ");
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.CheckboxControlValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, ModalHeaderComponent, IconAriaAttributesDirective, i8.MaskDirective], styles: [".modal-body[_ngcontent-%COMP%]{max-height:70vh;overflow-y:auto;margin-bottom:0}.form-control[_ngcontent-%COMP%]:disabled{color:var(--static-Spa_Style_Accent1)}@media (max-width: 992px){.modal-body[_ngcontent-%COMP%]{max-height:none}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SendSoaModalComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"modalTitleText\" (modalTitleCancelAction)=\"closeSendSOAModal()\"></vnext-widget-modal-header>\r\n\r\n<form [formGroup]=\"sendSOAFormGroup\">\r\n  <div class=\"form-group modal-body\">\r\n    <div class=\"mt-0\">\r\n      <h2 class=\"Spa_Style_H2\">\r\n        {{ sendSOAHeader }}\r\n      </h2>\r\n    </div>\r\n    <div class=\"row mb-3\" *ngIf=\"modalPromptText\">\r\n      <div class=\"col\">{{ modalPromptText }}</div>\r\n    </div>\r\n\r\n    <div *ngIf=\"showEmail\" class=\"row align-items-center no-gutters\">\r\n      <div id=\"emailAddressError\" *ngIf=\"fieldHasError('emailAddress')\" class=\"error-container col-12\" role=\"alert\">\r\n        <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n        <span *ngIf=\"getFieldErrors('emailAddress').required\">{{ emailRequiredError }}</span>\r\n        <span *ngIf=\"getFieldErrors('emailAddress').email\">{{ emailInvalidError }}</span>\r\n      </div>\r\n      <div *ngIf=\"showCheckBoxes\" class=\"col-2 mr-1 Spa_Style_Paragraph\">\r\n        <label for=\"emailAddressCheckbox\">\r\n          <input id=\"emailAddressCheckbox\" type=\"checkbox\" formControlName=\"emailAddressCheckbox\" (click)=\"toggleEmailCheckBox()\" />\r\n          {{ modalEmailCheckboxLabelText }}\r\n        </label>\r\n      </div>\r\n      <div class=\"col\">\r\n        <label class=\"Spa_Style_Label\" for=\"emailAddress\">\r\n          <span class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>{{ modalEmailLabelText }}</label\r\n        >\r\n        <input\r\n          id=\"emailAddress\"\r\n          aria-required=\"true\"\r\n          ngbAutofocus\r\n          type=\"email\"\r\n          class=\"form-control\"\r\n          formControlName=\"emailAddress\"\r\n          [attr.aria-describedby]=\"fieldHasError('emailAddress') ? 'emailAddressError' : null\"\r\n        />\r\n      </div>\r\n    </div>\r\n    <div *ngIf=\"showPhone\" class=\"row align-items-center no-gutters\" [ngClass]=\"{ 'mt-3': showEmail }\">\r\n      <div id=\"phoneError\" *ngIf=\"fieldHasError('phone')\" class=\"error-container col-12\" role=\"alert\">\r\n        <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n        <span *ngIf=\"getFieldErrors('phone').required\">{{ phoneRequiredError }}</span>\r\n        <span *ngIf=\"getFieldErrors('phone').pattern\">{{ phoneInvalidError }}</span>\r\n      </div>\r\n      <div *ngIf=\"showCheckBoxes\" class=\"col-2 mr-1 Spa_Style_Paragraph\">\r\n        <label for=\"phoneCheckbox\">\r\n          <input id=\"phoneCheckbox\" type=\"checkbox\" formControlName=\"phoneCheckbox\" (click)=\"togglePhoneCheckBox()\" />\r\n          {{ modalPhoneCheckboxLabelText }}\r\n        </label>\r\n      </div>\r\n      <div class=\"col\">\r\n        <label class=\"Spa_Style_Label\" for=\"phone\">\r\n          <span class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>{{ modalPhoneLabelText }}</label\r\n        >\r\n        <input\r\n          id=\"phone\"\r\n          aria-required=\"true\"\r\n          ngbAutofocus\r\n          type=\"text\"\r\n          class=\"form-control\"\r\n          formControlName=\"phone\"\r\n          [attr.aria-describedby]=\"fieldHasError('phone') ? 'phoneError' : null\"\r\n          [maxLength]=\"phoneMask.length\"\r\n          [mask]=\"phoneMask\"\r\n        />\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"modal-footer justify-content-start\">\r\n    <button type=\"button\" class=\"btn mr-auto Spa_Style_SecondaryButton\" (click)=\"closeSendSOAModal()\">\r\n      {{ modalCancelText }}\r\n    </button>\r\n    <button type=\"submit\" (click)=\"onSendSOA()\" class=\"btn Spa_Style_PrimaryButton\">\r\n      {{ modalSendButtonText }}\r\n    </button>\r\n  </div>\r\n</form>\r\n", styles: [".modal-body{max-height:70vh;overflow-y:auto;margin-bottom:0}.form-control:disabled{color:var(--static-Spa_Style_Accent1)}@media (max-width: 992px){.modal-body{max-height:none}}\n"] }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i2.Store }, { type: i0.ChangeDetectorRef }, { type: i1.ProfileService }]; }, null); })();

function SOAFollowUpModalComponent_vnext_link_6_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 9);
    i0.ɵɵlistener("click", function SOAFollowUpModalComponent_vnext_link_6_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.viewMemberProfile()); })("keyup.Enter", function SOAFollowUpModalComponent_vnext_link_6_Template_vnext_link_keyup_Enter_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.viewMemberProfile()); });
    i0.ɵɵelementStart(1, "span", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelement(3, "i", 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("alwaysUnderlined", false);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.modalViewMemberLink, "");
} }
function SOAFollowUpModalComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "vnext-followup-task", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("taskType", ctx_r1.taskType)("followUpTaskText", ctx_r1.followUpTaskText);
} }
function SOAFollowUpModalComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 14);
    i0.ɵɵlistener("click", function SOAFollowUpModalComponent_ng_container_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.closeSoaFollowUpModal()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.modalCloseText, " ");
} }
function SOAFollowUpModalComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function SOAFollowUpModalComponent_ng_template_10_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.closeSoaFollowUpModal()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.modalCancelText, " ");
} }
class SOAFollowUpModalComponent {
    constructor(activeModal, configResourceService) {
        this.activeModal = activeModal;
        this.configResourceService = configResourceService;
        this.taskType = NoteActionType.SOATask;
    }
    ngOnInit() {
        this.isAddFollowUpTaskEnabled = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_AddFollowUp_Enabled', null, false);
        if (this.isAddFollowUpTaskEnabled) {
            this.loadFollowUpTaskAttributes();
        }
    }
    loadFollowUpTaskAttributes(widgetName) {
        this.followUpTaskText = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_FollowUp_SOA_Text', widgetName, 'Follow up on Scope of Appointment');
        this.modalCloseText = this.configResourceService.getProcessedResourceValue('Spa_Site_Close', null, 'Close');
    }
    closeSoaFollowUpModal() {
        this.activeModal.dismiss();
        if (this.cancelAction) {
            this.cancelAction();
        }
    }
    viewMemberProfile() {
        this.activeModal.close();
    }
}
SOAFollowUpModalComponent.ɵfac = function SOAFollowUpModalComponent_Factory(t) { return new (t || SOAFollowUpModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i1.ConfigResourceService)); };
SOAFollowUpModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SOAFollowUpModalComponent, selectors: [["ng-component"]], decls: 12, vars: 7, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "px-3", "mt-3", "mb-0"], [1, "mb-1"], [3, "title", "type"], ["ngbAutofocus", "", "class", "d-inline-block mb-0", 3, "alwaysUnderlined", "click", "keyup.Enter", 4, "ngIf"], ["class", "mb-4", 4, "ngIf"], [1, "modal-footer", "justify-content-start"], [4, "ngIf", "ngIfElse"], ["showCancelButton", ""], ["ngbAutofocus", "", 1, "d-inline-block", "mb-0", 3, "alwaysUnderlined", "click", "keyup.Enter"], ["link-body", ""], [1, "fas", "fa-angle-right", "ml-1"], [1, "mb-4"], [3, "taskType", "followUpTaskText"], ["type", "button", 1, "btn", "mr-auto", "Spa_Style_SecondaryButton", 3, "click"]], template: function SOAFollowUpModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div")(1, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function SOAFollowUpModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_1_listener() { return ctx.closeSoaFollowUpModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerStart(2);
        i0.ɵɵelementStart(3, "div", 1)(4, "div", 2);
        i0.ɵɵelement(5, "vnext-notice", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, SOAFollowUpModalComponent_vnext_link_6_Template, 4, 2, "vnext-link", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerEnd();
        i0.ɵɵtemplate(7, SOAFollowUpModalComponent_div_7_Template, 2, 2, "div", 5);
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵtemplate(9, SOAFollowUpModalComponent_ng_container_9_Template, 3, 1, "ng-container", 7);
        i0.ɵɵtemplate(10, SOAFollowUpModalComponent_ng_template_10_Template, 2, 1, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(11);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("modalTitleText", ctx.modalTitleText);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("title", ctx.modalSentConfirmationText)("type", "success");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showViewMemberLink);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isAddFollowUpTaskEnabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isAddFollowUpTaskEnabled)("ngIfElse", _r3);
    } }, dependencies: [i1$2.NgIf, LinkComponent, FollowUpTaskComponent, NoticeComponent, ModalHeaderComponent, IconAriaAttributesDirective], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SOAFollowUpModalComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<div>\r\n  <vnext-widget-modal-header\r\n    [modalTitleText]=\"modalTitleText\"\r\n    (modalTitleCancelAction)=\"closeSoaFollowUpModal()\"\r\n  ></vnext-widget-modal-header>\r\n\r\n  <ng-container>\r\n    <div class=\"px-3 mt-3 mb-0\">\r\n      <div class=\"mb-1\">\r\n        <vnext-notice [title]=\"modalSentConfirmationText\" [type]=\"'success'\"></vnext-notice>\r\n      </div>\r\n      <vnext-link\r\n        *ngIf=\"showViewMemberLink\"\r\n        ngbAutofocus\r\n        (click)=\"viewMemberProfile()\"\r\n        (keyup.Enter)=\"viewMemberProfile()\"\r\n        class=\"d-inline-block mb-0\"\r\n        [alwaysUnderlined]=\"false\"\r\n        ><span link-body> {{ modalViewMemberLink }}<i class=\"fas fa-angle-right ml-1\"></i></span>\r\n      </vnext-link>\r\n    </div>\r\n  </ng-container>\r\n  <div *ngIf=\"isAddFollowUpTaskEnabled\" class=\"mb-4\">\r\n    <vnext-followup-task [taskType]=\"taskType\" [followUpTaskText]=\"followUpTaskText\"></vnext-followup-task>\r\n  </div>\r\n  <div class=\"modal-footer justify-content-start\">\r\n    <ng-container *ngIf=\"isAddFollowUpTaskEnabled; else showCancelButton\">\r\n      <button type=\"button\" class=\"btn mr-auto Spa_Style_SecondaryButton\" (click)=\"closeSoaFollowUpModal()\">\r\n        {{ modalCloseText }}\r\n      </button>\r\n    </ng-container>\r\n    <ng-template #showCancelButton>\r\n      <button type=\"button\" class=\"btn mr-auto Spa_Style_SecondaryButton\" (click)=\"closeSoaFollowUpModal()\">\r\n        {{ modalCancelText }}\r\n      </button>\r\n    </ng-template>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i1.ConfigResourceService }]; }, null); })();

class SOAFacade {
    constructor(modalService, injector, store, emailService, memberSessionService, soaService, configResourceService, navigationUtilityService, agentNoteFacade, messagesService, phoneService, profileService, weglotService, formValidationService, agentService, phoneUtilityService, analyticsService, siteService, agentPermissionsService, agentSearchFacade, spinnerService, externalErrorLoggingService, enrollmentFormService, quoteService, passParamService, lockedSiteService, demographicService, utilityFunctionService, ipUtilityService, planYearResourceService, twilioService) {
        this.modalService = modalService;
        this.injector = injector;
        this.store = store;
        this.emailService = emailService;
        this.memberSessionService = memberSessionService;
        this.soaService = soaService;
        this.configResourceService = configResourceService;
        this.navigationUtilityService = navigationUtilityService;
        this.agentNoteFacade = agentNoteFacade;
        this.messagesService = messagesService;
        this.phoneService = phoneService;
        this.profileService = profileService;
        this.weglotService = weglotService;
        this.formValidationService = formValidationService;
        this.agentService = agentService;
        this.phoneUtilityService = phoneUtilityService;
        this.analyticsService = analyticsService;
        this.siteService = siteService;
        this.agentPermissionsService = agentPermissionsService;
        this.agentSearchFacade = agentSearchFacade;
        this.spinnerService = spinnerService;
        this.externalErrorLoggingService = externalErrorLoggingService;
        this.enrollmentFormService = enrollmentFormService;
        this.quoteService = quoteService;
        this.passParamService = passParamService;
        this.lockedSiteService = lockedSiteService;
        this.demographicService = demographicService;
        this.utilityFunctionService = utilityFunctionService;
        this.ipUtilityService = ipUtilityService;
        this.planYearResourceService = planYearResourceService;
        this.twilioService = twilioService;
        this.soaPlanTypeUniqueName = this.configResourceService.getProcessedResourceValue('soaPlanType_UniqueName', null, 'SOAPlanType');
        this.soaBeneficiaryConfirmationCodeUniqueName = this.configResourceService.getProcessedResourceValue('soaBeneficiaryConfirmationCode_UniqueName', null, 'SOABeneficiaryConfirmationCode');
        this.spaQuoteLinkEmailOnlyEnabled = this.configResourceService.getProcessedResourceValue('SPA_QuoteLink_EmailOnly_Enabled', null, true);
        this.soaFormId = this.configResourceService.getProcessedResourceValue('Spa_SOA_FormID', null, null);
        this.soaFormByPhoneId = this.configResourceService.getProcessedResourceValue('Spa_SOA_FormByPhone_ID', null, null);
        this.isNextGenSOAEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_SOA_NextGen_Enabled', null, false);
        this.consumerSOAActivityTypes = [
            SOAActivityType.STARTED_TEXT,
            SOAActivityType.STARTED_EMAIL,
            SOAActivityType.PARTIAL
        ];
    }
    isConsumerSOAActivity(soaActivity) {
        return this.consumerSOAActivityTypes.includes(soaActivity.type);
    }
    getSOAFormRoute() {
        return this.navigationUtilityService.constructHref(PageTags.SOA_FORM);
    }
    getNextGenSOAFormLoading$(transactionId) {
        return this.store.select(SOAState.nextGenSOAFormLoading(transactionId));
    }
    getNextGenSOAFormLoaded$(transactionId) {
        return this.store.select(SOAState.nextGenSOAFormLoaded(transactionId));
    }
    setNextGenSOAFormLoading$(enrollmentKey, loading) {
        return this.store.dispatch(new SetNextGenSOAFormLoading(enrollmentKey, loading));
    }
    getNextGenSOAPrefillData$(transactionId) {
        return this.store.select(SOAState.nextGenTransactionPrefillData(transactionId));
    }
    getSOAFormAnswer(name, transactionId) {
        return this.store.selectSnapshot(SOAState.answer(transactionId, name))?.value ?? '';
    }
    getMemberProfileHomePhone$() {
        return this.store.select(ProfileState.homePhone);
    }
    getMemberProfileCellPhone$() {
        return this.store.select(ProfileState.cellPhone);
    }
    getMemberName() {
        return this.store.selectSnapshot(ProfileState.fullName);
    }
    getMember() {
        return this.store.selectSnapshot(ProfileState);
    }
    getAgent() {
        return this.store.selectSnapshot(AgentState);
    }
    getSoaPlanTypeListFromAnswer(soaPlanType) {
        return SOAState.getSoaPlanTypeListFromAnswer(soaPlanType);
    }
    getAgentContactInfo$() {
        return combineLatest(this.agentEmailAddress$, this.agentFullName$, this.agentHours$, this.agentPhoneNumber$).pipe(map(([agentEmailAddress, agentFullName, agentHours, agentPhoneNumber]) => ({
            agentEmailAddress,
            agentFullName,
            agentHours,
            agentPhoneNumber
        })));
    }
    getSOAActivities$(isAdmin = false) {
        return this.soaService.getSOAActivities$(this.soaPlanTypeUniqueName, this.soaBeneficiaryConfirmationCodeUniqueName, isAdmin);
    }
    getSOAActivity$(transactionId, isAdmin = false) {
        return this.soaService.getSOAActivity$(transactionId, this.soaPlanTypeUniqueName, this.soaBeneficiaryConfirmationCodeUniqueName, isAdmin);
    }
    sendConsumerEmail$(to, subject, inputs) {
        return this.emailService.sendEmail$(EmailNames.SOA_CONSUMER, to, subject, inputs);
    }
    sendAgentEmail$(subject, inputs) {
        const agentEmail = this.store.selectSnapshot(AgentState.emailAddress);
        return this.emailService.sendEmail$(EmailNames.SOA_AGENT, [agentEmail], subject, inputs);
    }
    sendConsumerText$(phone, soaUrl, widgetName) {
        return from(this.sendScopeOfAppointmentText(phone, soaUrl, widgetName));
    }
    async sendScopeOfAppointmentText(phone, soaUrl, widgetName) {
        const e164PhoneNumber = this.phoneService.getE164PhoneNumber(phone);
        const shortUrl = await this.getShortUrl(soaUrl);
        return await this.sendConsumerSOAText(e164PhoneNumber, shortUrl, widgetName);
    }
    async updateMemberPhoneData(phone, phoneType = PhoneNumberType.BOTH) {
        await this.profileService.updateMemberPhoneData(phone, phoneType);
    }
    async updateMemberEmail(email) {
        const apiMemberStateModel = {
            profile: {
                emailAddress: email
            }
        };
        await this.memberSessionService.updateMemberProfile(apiMemberStateModel);
    }
    startSOATransaction$(soaTransactionType = [SOATransactionEventType.EMAIL]) {
        const clientName = this.configResourceService.getProcessedResourceValue('ClientName', null, null);
        const isSOAByAgentByPhone = soaTransactionType.includes(SOATransactionEventType.BY_PHONE);
        const soaFormId = isSOAByAgentByPhone
            ? this.configResourceService.getProcessedResourceValue('Spa_SOA_FormByPhone_ID', null, null)
            : this.configResourceService.getProcessedResourceValue('Spa_SOA_FormID', null, null);
        const sessionId = this.memberSessionService.getMemberSessionId();
        const agentGuid = this.agentService.getAgentInContextGuid();
        const isText = soaTransactionType.includes(SOATransactionEventType.TEXT);
        const isSOAByAgent = soaTransactionType.includes(SOATransactionEventType.IN_PERSON);
        return this.soaService.startSOATransaction$({ sessionId, soaFormId, agentGuid, clientName, isText, isSOAByAgent, isSOAByAgentByPhone });
    }
    async startNextGenSOATransaction(formId, formVersion, formVersionId, soaTransactionTypes = [SOATransactionEventType.EMAIL]) {
        const isSOAByAgentByPhone = soaTransactionTypes.includes(SOATransactionEventType.BY_PHONE);
        const isText = soaTransactionTypes.includes(SOATransactionEventType.TEXT);
        const isSOAByAgent = soaTransactionTypes.includes(SOATransactionEventType.IN_PERSON);
        const partnerId = this.passParamService.getPartnerId() || this.configResourceService.getProcessedResourceValue('PartnerID');
        const sourceId = this.passParamService.getSourceId() || this.configResourceService.getProcessedResourceValue('SourceID');
        const destinationAppId = this.configResourceService.getProcessedResourceValue('AppID');
        const isTestingSite = this.configResourceService.getProcessedResourceValue('Spa_Site_IsTestSite', null, false);
        // We are disabling these because the backend wants these in this format
        /* eslint-disable @typescript-eslint/naming-convention */
        const ClientName = this.configResourceService.getProcessedResourceValue('ClientName', null, null);
        const Spa_SOA_RequireAuthCode_Enabled = this.configResourceService.getProcessedResourceValue('Spa_SOA_RequireAuthCode_Enabled', null, false);
        const Spa_SendEnrollment_Retain_Form_Answers = this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_Retain_Form_Answers', null, false);
        const Spa_Site_SiteType = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType', null, SiteType.CONSUMER);
        /* eslint-enable @typescript-eslint/naming-convention */
        const userType = this.configResourceService.getProcessedResourceValue('UserType', null, '');
        const memberSession = this.memberSessionService.getMemberSession();
        const apiProfileStateModel = { ...memberSession.profile };
        const updatedProfileModel = this.profileService.prepareProfileStateForAPI(apiProfileStateModel);
        const [createdIPAddress] = await Promise.all([
            this.ipUtilityService.getClientIP(),
            this.demographicService.conditionallyFetchCounties(memberSession.demographic.zip, memberSession.demographic.fips)
        ]);
        const countyName = this.demographicService.getSelectedCounty()?.countyName ?? '';
        const apiMemberStateModel = {
            sessionId: memberSession.sessionId,
            ssoValue: memberSession.ssoValue,
            memberId: memberSession.memberID,
            profile: { authRepData: {}, ...updatedProfileModel },
            // getting countyName from counties plus selectedFips
            // this assumes counties is loaded and if its not we will not find a countyName
            demographic: { ...memberSession.demographic, countyName },
            enrollments: memberSession.enrollments
        };
        const deepLinkingParams = this.enrollmentFormService.getNextGenDeepLinkingParams();
        const quoteId = this.quoteService.getBeneficiaryQuoteId();
        const agent = this.enrollmentFormService.getAgentRequestData();
        const isSiteLive = this.lockedSiteService.isSiteLive();
        const isReviewSite = this.lockedSiteService.isReviewSite(window.location.hostname);
        const medigapAnswers = this.memberSessionService.getMemberMedigapAnswers();
        const humanaCustomClientPartnerId = this.configResourceService.getProcessedResourceValue('HumanaCustomClientPartnerId');
        const humanaCustomClientPartnerName = this.configResourceService.getProcessedResourceValue('HumanaCustomClientPartnerName');
        const humanaCustomClientPartnerIdentifier = this.configResourceService.getProcessedResourceValue('HumanaCustomClientPartnerIdentifier');
        const coverageEventType = this.getSOACoverageEventType(soaTransactionTypes?.[0]);
        try {
            const isPurl = this.agentService.isPurl();
            const transaction = await this.soaService
                .startNextGenSOATransaction$({
                ...(agent && { agent }),
                ...(quoteId && { quoteId }),
                coverageEventType,
                enrollmentSettings: {},
                session: { ...apiMemberStateModel, ...(medigapAnswers && { medigapAnswers }) },
                site: {
                    isSiteLive,
                    isReviewSite,
                    createdIPAddress,
                    partnerId,
                    destinationAppId,
                    isTestingSite
                },
                configurations: {
                    sourceId,
                    Spa_SendEnrollment_Retain_Form_Answers,
                    Spa_Site_SiteType,
                    userType,
                    humanaCustomClientPartnerId,
                    humanaCustomClientPartnerName,
                    humanaCustomClientPartnerIdentifier,
                    ClientName,
                    Spa_SOA_RequireAuthCode_Enabled
                },
                soaEnrollmentData: {
                    formId,
                    formVersion,
                    formVersionId,
                    isSOAEnrollment: true,
                    isText,
                    isSOAByAgent,
                    isSOAByAgentByPhone
                },
                isPurl,
                currentDate: this.utilityFunctionService.getCurrentDate(DateUtilities.defaultFormat),
                hasValidCompletedSOA: this.soaService.hasValidCompletedSOA(),
                ...(Object.keys(deepLinkingParams).length && { deepLinkingParams }),
                isMedigap: false
            })
                .pipe(switchMap(nextGenSOAEnrollmentResponse => this.soaService.mapToSOATransactionResponse$({ nextGenSOAEnrollmentResponse })))
                .toPromise();
            this.enrollmentFormService.setFormVersionIdFromEnrollmentSettings(formVersionId);
            return transaction;
        }
        catch (error) {
            return await Promise.reject(error);
        }
    }
    startNextGenSOATransaction$(formId, formVersion, formVersionId, soaTransactionTypes = [SOATransactionEventType.EMAIL]) {
        return from(this.startNextGenSOATransaction(formId, formVersion, formVersionId, soaTransactionTypes));
    }
    completeNextGenSOATransaction$(transactionId) {
        const sessionId = this.memberSessionService.getMemberSessionId();
        const isSiteLive = this.lockedSiteService.isSiteLive();
        const isLockedSite = this.lockedSiteService.isReviewSite(window.location.hostname);
        const partnerId = this.passParamService.getPartnerId() || this.configResourceService.getProcessedResourceValue('PartnerID');
        const sourceId = this.passParamService.getSourceId() || this.configResourceService.getProcessedResourceValue('SourceID');
        const siteId = this.enrollmentFormService.getSiteId();
        // const clientId = this.memberSessionService.getClientId();
        const appId = this.configResourceService.getProcessedResourceValue('AppID', null, 0);
        const isActive = !isLockedSite && isSiteLive; // from generic form transaction... TODO: follow up on if
        const confirmationSettings = this.enrollmentFormService.createConfirmationSettings(null, EnrollmentFormType.LONG);
        const zipCode = this.getSOAFormAnswer('ApplicantZip', transactionId) || this.memberSessionService.getZipCode();
        const countyFIPS = this.getSOAFormAnswer('ApplicantCounty', transactionId) || this.memberSessionService.getFipsCode();
        // this is typically pushed to the profiles primary address when updated in enrollment but we will just
        // grab it from the form itself
        const enrollmentState = this.getSOAFormAnswer('ApplicantState', transactionId);
        const planYear = this.planYearResourceService.getSelectedPlanYear();
        const hideAgentData = this.store.selectSnapshot(UiState.hidePdfAgentData);
        const callRecordingCode = this.twilioService.getOpenConnectionCallRecordingCode();
        // const sourceSiteId = this.quoteService.getSourceSiteId();
        // const langId = LocaleService.LOCALE_ALIAS_ID[currentLocale];
        // this is correct or not
        const nextGenEnrollmentRequest = {
            planId: null,
            sessionId,
            completeEnrollmentSiteId: siteId,
            completeEnrollmentAppId: appId,
            zipCode,
            countyFIPS,
            ...(enrollmentState && { state: enrollmentState }),
            isMedigap: false,
            originalAppId: appId,
            destinationAppId: appId,
            sourceId,
            // DRXAgentId: string;
            partnerId,
            // GroupConfirmationNumber: string;
            isActive,
            encryptionTypeId: 0,
            confirmationSettings,
            // effectiveDate: string;
            // isSep: boolean,
            isComplete: true,
            langId: 1,
            planYear,
            hideAgentData,
            callRecordingCode,
            isSOAEnrollment: true
            // groupConfirmationNumber: string,
            // sourceSiteId
        };
        return this.soaService.completeNextGenSOATransaction$(nextGenEnrollmentRequest, transactionId);
    }
    async completeNextGenSOATransaction(transactionId) {
        await this.completeNextGenSOATransaction$(transactionId).toPromise();
    }
    async uploadDocument(document, ownerId) {
        return await this.soaService.uploadDocument(document, ownerId);
    }
    getDocumentList$(ownerId) {
        return this.soaService.getDocumentList$(ownerId);
    }
    async downloadDocument(documentId, ownerId) {
        return await this.soaService.downloadDocument(documentId, ownerId);
    }
    fetchSOATransactions$() {
        return this.soaService.fetchSOATransactions$();
    }
    fetchSOAActivities$() {
        return this.fetchSOATransactions$().pipe(switchMap(() => this.getSOAActivities$()));
    }
    fetchFormVersionInfo$(formId) {
        return this.soaService
            .fetchFormVersionInfo$(formId)
            .pipe(filter(formVersionInfo => !!formVersionInfo?.formId && !!formVersionInfo?.formVersion && !!formVersionInfo?.formVersionId));
    }
    addSOAEmailNote(email) {
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        const agentName = this.store.selectSnapshot(AgentState.fullName);
        const createdWhen = this.store.selectSnapshot(SOAState.createdWhen);
        this.agentNoteFacade.addSOAByEmailNote(email, agentName, agentGuid, createdWhen);
    }
    addSOATextNote(phoneNumber) {
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        const agentName = this.store.selectSnapshot(AgentState.fullName);
        const createdWhen = this.store.selectSnapshot(SOAState.createdWhen);
        this.agentNoteFacade.addSOAByTextNote(agentName, agentGuid, phoneNumber, createdWhen);
    }
    rehydrateSOATransactions$(fetchSession = false, includeAgentCallHistory = false) {
        if (fetchSession) {
            const sessionId = this.memberSessionService.getMemberSessionId();
            return this.memberSessionService
                .fetchMemberSession$({ sessionId, includeSOA: true, includeAgentCallHistory })
                .pipe(switchMap(() => this.soaService.fetchSOATransactions$()));
        }
        else {
            return this.soaService.fetchSOATransactions$();
        }
    }
    getPrimaryButtonColor() {
        return this.configResourceService.getProcessedResourceValue('Spa_Style_PrimaryButton', null, AppThemeConfig.getColorValueByKey(ColorResourceKeys.ACCENT4));
    }
    isSOACompleted(type) {
        return [SOAActivityType.COMPLETED, SOAActivityType.COMPLETED_IN_PERSON, SOAActivityType.COMPLETED_BY_PHONE].includes(type);
    }
    async generateBase64PDF(transactionId) {
        return await this.soaService.generateBase64PDF(transactionId);
    }
    latestStartedActivity(soaActivities, soaActivityType) {
        const allActivities = soaActivities?.length ? soaActivities : [];
        const startedActivities = allActivities.length && soaActivityType ? soaActivities.filter(activity => activity.type === soaActivityType) : allActivities;
        const initialValue = { type: soaActivityType ?? null, date: '' };
        const latestActivity = startedActivities.reduce((latest, index) => (index.date > latest.date ? index : latest), initialValue);
        return latestActivity;
    }
    async getShortUrl(url) {
        return await this.messagesService.getShortUrl$(url).toPromise();
    }
    getActivityMessage(activity, memberName, memberPhone) {
        let message;
        switch (activity.type) {
            case SOAActivityType.STARTED_EMAIL:
                message = this.configResourceService.getProcessedResourceValue('Spa_SOA_Activity_StartedText', null, 'Email sent to <soaEmail> on <soaDate>');
                break;
            case SOAActivityType.STARTED_TEXT:
                message = this.configResourceService.getProcessedResourceValue('Spa_SOA_Activity_TextSentText', null, 'Text sent to <phone> on <soaDate>');
                break;
            case SOAActivityType.STARTED_IN_PERSON:
                message = this.configResourceService.getProcessedResourceValue('Spa_SOA_Agent_Activity_StartedText', null, 'SOA started on <soaDate>');
                break;
            case SOAActivityType.STARTED_BY_PHONE:
                message = this.configResourceService.getProcessedResourceValue('Spa_SOA_Agent_ActivityStartedByPhone_Text', null, 'SOA started by phone on <soaDate>');
                break;
            case SOAActivityType.UPLOADED_FILE:
                message = this.configResourceService.getProcessedResourceValue('Spa_SOA_Activity_UploadedFile_Text', null, 'Uploaded <soaDate>');
                break;
            case SOAActivityType.PARTIAL:
                message = this.configResourceService.getProcessedResourceValue('Spa_SOA_Activity_PartialText', null, 'Completed by <soaMemberName> on <soaDate>');
                break;
            case SOAActivityType.COMPLETED:
                message = this.configResourceService.getProcessedResourceValue('Spa_SOAActivity_Completed_Text', null, 'Completed <soaDate>');
                break;
            case SOAActivityType.PARTIAL_IN_PERSON:
                message = this.configResourceService.getProcessedResourceValue('Spa_SOA_Agent_Activity_PartialText', null, 'Completed by agent with <soaMemberName> on <soaDate>');
                break;
            case SOAActivityType.PARTIAL_BY_PHONE:
                message = this.configResourceService.getProcessedResourceValue('Spa_SOA_Agent_ActivityPartialByPhone_Text', null, 'Completed by agent by phone with <soaMemberName> on <soaDate>');
                break;
            case SOAActivityType.COMPLETED_IN_PERSON:
                message = this.configResourceService.getProcessedResourceValue('Spa_SOA_Agent_Activity_CompletedText', null, 'Completed in-person <soaDate>');
                break;
            case SOAActivityType.COMPLETED_BY_PHONE:
                message = this.configResourceService.getProcessedResourceValue('Spa_SOA_Agent_ActivityCompletedByPhone_Text', null, 'Completed by phone <soaDate>');
                break;
            default:
                message = '';
        }
        return this.replaceTextReplacementVariables(message, activity, memberPhone, memberName);
    }
    getMemberProfilePhone$() {
        return combineLatest([this.getMemberProfileHomePhone$(), this.getMemberProfileCellPhone$()]).pipe(map(([homePhone, cellPhone]) => {
            const phone = cellPhone || homePhone;
            return phone;
        }));
    }
    showSOAModal(widgetName) {
        const soaModalTitleText = this.configResourceService.getProcessedResourceValue('Spa_SOAModal_Title_Text', widgetName, 'Send SOA');
        const soaModalHeaderText = this.configResourceService
            .getProcessedResourceValue('Spa_SOAModal_Header_Text', widgetName, 'Send SOA to <firstname> <lastname>')
            .replace('<firstname>', this.profileService.getFirstName())
            .replace('<lastname>', this.profileService.getLastName());
        const soaModalInstructionalText = this.configResourceService.getProcessedResourceValue('Spa_SOAModal_Instructional_Text', widgetName, 'How would you like to send the SOA to the beneficiary?');
        const soaModalSendButtonText = this.configResourceService.getProcessedResourceValue('Spa_SOAModal_Send_Button_Text', widgetName, 'Send SOA');
        const soaModalCancelButtonText = this.configResourceService.getProcessedResourceValue('Spa_SOAModal_Cancel_Button_Text', widgetName, 'Cancel');
        const authCodeTextOnlyEnabled = this.configResourceService.getProcessedResourceValue('SPA_AuthCode_TextOnly_Enabled', widgetName, false);
        const quoteLinkEmailOnlyEnabled = this.configResourceService.getProcessedResourceValue('SPA_QuoteLink_EmailOnly_Enabled', widgetName, false);
        const emailLabelText = this.configResourceService.getProcessedResourceValue('Spa_SOAModal_Email_Label_Text', widgetName, 'Email address');
        const emailCheckBoxLabelText = this.configResourceService.getProcessedResourceValue('Spa_SOAModal_Email_CheckBox_Text', widgetName, 'Email');
        const phoneLabelText = this.configResourceService.getProcessedResourceValue('Spa_SOAModal_Phone_Label_Text', widgetName, 'Phone');
        const phoneCheckBoxLabelText = this.configResourceService.getProcessedResourceValue('Spa_SOAModal_Phone_CheckBox_Text', widgetName, 'Text');
        const soaAuthCodeEnabled = this.configResourceService.getProcessedResourceValue('SPA_SOA_RequireAuthCode_Enabled', widgetName, false);
        const memberRegistrationFields = this.getMemberRegistrationFields(widgetName);
        const sendSOAModal = this.modalService.open(SendSoaModalComponent, { centered: true, injector: this.injector });
        sendSOAModal.componentInstance.modalTitleText = soaModalTitleText;
        sendSOAModal.componentInstance.modalCancelText = soaModalCancelButtonText;
        sendSOAModal.componentInstance.modalSendButtonText = soaModalSendButtonText;
        sendSOAModal.componentInstance.sendSOAHeader = soaModalHeaderText;
        sendSOAModal.componentInstance.modalPromptText = soaModalInstructionalText;
        sendSOAModal.componentInstance.memberRegistrationFields = memberRegistrationFields;
        sendSOAModal.componentInstance.authCodeTextOnlyEnabled = soaAuthCodeEnabled ? true : authCodeTextOnlyEnabled;
        sendSOAModal.componentInstance.quoteLinkEmailOnlyEnabled = quoteLinkEmailOnlyEnabled;
        sendSOAModal.componentInstance.showPhone = true;
        sendSOAModal.componentInstance.showEmail = true;
        sendSOAModal.componentInstance.modalEmailLabelText = emailLabelText;
        sendSOAModal.componentInstance.modalEmailCheckboxLabelText = emailCheckBoxLabelText;
        sendSOAModal.componentInstance.modalPhoneLabelText = phoneLabelText;
        sendSOAModal.componentInstance.modalPhoneCheckboxLabelText = phoneCheckBoxLabelText;
        sendSOAModal.componentInstance.emailRequiredError = this.formValidationService.errorMessages.requiredEmail();
        sendSOAModal.componentInstance.emailInvalidError = this.formValidationService.errorMessages.invalidEmail();
        sendSOAModal.componentInstance.phoneRequiredError = this.formValidationService.errorMessages.requiredPhone();
        sendSOAModal.componentInstance.phoneInvalidError = this.formValidationService.errorMessages.invalidPhone();
        sendSOAModal.result
            .then(formData => {
            this.sendSOA(formData, widgetName);
        })
            .catch(() => { });
    }
    sendSOA(soaForm, widgetName) {
        this.spinnerService.show(SpinnerEvent.SUBMITTED_FORM_LOADING);
        this.sendSOAEmailAndText$(soaForm, widgetName)
            .pipe(take(1))
            .toPromise()
            .then(result => {
            this.spinnerService.hide(SpinnerEvent.SUBMITTED_FORM_LOADING);
            this.showSOAFollowUp(result, widgetName);
        })
            .catch(error => {
            this.externalErrorLoggingService.log(error);
        });
    }
    showSOAFollowUp(sendSOAResult, widgetName) {
        const isAddFollowUpTaskEnabled = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_AddFollowUp_Enabled', widgetName, false);
        if (isAddFollowUpTaskEnabled) {
            const soaActivityType = [];
            if (sendSOAResult.emailSendResult) {
                soaActivityType.push(SOAActivityType.STARTED_EMAIL);
                this.tagsToUpdate(DataLayerEvent.CLICK_SOA_EMAIL_FORM, sendSOAResult.transactionGuid);
            }
            if (sendSOAResult.textSendResult) {
                soaActivityType.push(SOAActivityType.STARTED_TEXT);
                this.tagsToUpdate(DataLayerEvent.CLICK_SOA_TEXT_FORM, sendSOAResult.transactionGuid);
            }
            this.showSOAFollowUpModal(soaActivityType, widgetName);
        }
    }
    getSelectedSOAFormId(selectedSOATransactionTypes) {
        return selectedSOATransactionTypes?.includes(SOATransactionEventType.BY_PHONE) ? this.soaFormByPhoneId : this.soaFormId;
    }
    sendSOAEmailAndText$(soaForm, widgetName) {
        const soaTransactionEventType = [];
        if (soaForm?.emailAddressIsDirty && soaForm?.emailAddress) {
            this.updateMemberEmail(soaForm.emailAddress);
        }
        if (soaForm?.phoneIsDirty && soaForm?.phone) {
            const phoneNumbersMatch = this.profileService.getArePhoneNumbersEqual();
            this.updateMemberPhoneData(soaForm.phone, phoneNumbersMatch ? PhoneNumberType.BOTH : PhoneNumberType.MOBILE);
        }
        const to = soaForm.emailAddress;
        const subject = this.configResourceService.getProcessedResourceValue('Spa_SOA_ConsumerEmail_Subject', widgetName, 'Scope of Appointment form');
        if (soaForm?.emailAddress) {
            soaTransactionEventType.push(SOATransactionEventType.EMAIL);
        }
        if (soaForm?.phone) {
            soaTransactionEventType.push(SOATransactionEventType.TEXT);
        }
        let startSOATransaction$;
        if (this.isNextGenSOAEnabled) {
            const selectedFormId = this.getSelectedSOAFormId(soaTransactionEventType);
            startSOATransaction$ = this.fetchFormVersionInfo$(selectedFormId).pipe(switchMap(formVersionInfo => this.startNextGenSOATransaction$(formVersionInfo.formId, formVersionInfo.formVersion, formVersionInfo.formVersionId, soaTransactionEventType)));
        }
        else {
            startSOATransaction$ = this.startSOATransaction$(soaTransactionEventType);
        }
        return startSOATransaction$.pipe(switchMap(transactionData => {
            return forkJoin([of(transactionData), this.getAgentContactInfo$().pipe(take(1)), from(this.agentService.getAgentPictureIcon())]);
        }), switchMap(([transactionData, agentInfo, agentPictureURL]) => {
            const queryString = transactionData?.soaQueryStringEncrypted;
            const transactionGuid = transactionData?.newEnrollmentTransactionGuid;
            const authCode = transactionData?.authCode;
            const emailInputs = this.emailInputs(agentInfo, agentPictureURL);
            return this.getConsumerShortUrl$(queryString, transactionGuid).pipe(map(consumerEmailShortUrl => ({ consumerEmailShortUrl, emailInputs, transactionGuid, queryString, authCode })));
        }), switchMap(({ consumerEmailShortUrl, emailInputs, transactionGuid, queryString, authCode }) => {
            const emailObservable$ = soaForm?.emailAddress
                ? this.sendEmail$(to, subject, consumerEmailShortUrl, emailInputs, transactionGuid, authCode)
                : of(null);
            const phoneObservable$ = soaForm?.phone ? this.sendText$(queryString, transactionGuid, authCode) : of(null);
            return forkJoin([emailObservable$, phoneObservable$]).pipe(map(([emailResult, phoneResult]) => ({
                emailSendResult: emailResult,
                textSendResult: phoneResult,
                transactionGuid
            })));
        }), take(1));
    }
    sendEmail$(to, subject, consumerEmailShortUrl, emailInputs, transactionGuid, authCode) {
        emailInputs.push({ key: 'consumerEmailLinkUrl', value: consumerEmailShortUrl });
        this.addSOAEmailNote(to);
        return this.sendConsumerEmail$([to], subject, emailInputs).pipe(map(emailSendResult => ({ emailSendResult, transactionGuid })));
    }
    async sendText$(queryString, transactionGuid, authCode) {
        const memberPhoneNumber = await this.getMemberProfilePhone$().pipe(take(1)).toPromise();
        this.addSOATextNote(memberPhoneNumber);
        const soaUrl = this.getSOAUrlForConsumer(queryString, transactionGuid, SendAppVia.TEXT);
        const soaAuthCodeEnabled = this.configResourceService.getProcessedResourceValue('Spa_SOA_RequireAuthCode_Enabled', null, false);
        if (soaAuthCodeEnabled) {
            const message = this.configResourceService.getProcessedResourceValue('Spa_SOA_TextMessage_AuthCodeText', null, 'Use this authorization code to access your enrollment: <authCode>');
            this.agentService.sendAuthCodeText(memberPhoneNumber, authCode, message);
        }
        if (!this.spaQuoteLinkEmailOnlyEnabled) {
            return combineLatest([this.sendConsumerText$(memberPhoneNumber, soaUrl), of(transactionGuid)]);
        }
    }
    getSOAModalCancel() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Close', null, 'Close');
    }
    async showSOAFollowUpModal(soaActivityType, widgetName) {
        const soaModalTitle = this.configResourceService.getProcessedResourceValue('Spa_SOAFollowUpModal_Title_Text', widgetName, 'Scope of Appointment sent');
        const soaCloseText = this.configResourceService.getProcessedResourceValue('Spa_Site_Close', null, 'Close');
        const isAdmin = this.agentPermissionsService.isAgentAdmin();
        const memberPhoneNumber = await this.getMemberProfilePhone$().pipe(take(1)).toPromise();
        const soaActivities = await this.getSOAActivities$(isAdmin).pipe(take(1)).toPromise();
        const confirmationModal = this.modalService.open(SOAFollowUpModalComponent, { centered: true });
        confirmationModal.componentInstance.modalTitleText = soaModalTitle;
        confirmationModal.componentInstance.modalSentConfirmationText = this.getConfirmationText(soaActivities, soaActivityType, memberPhoneNumber);
        confirmationModal.componentInstance.modalViewMemberLink = this.getViewMemberLink();
        confirmationModal.componentInstance.modalCancelText = soaCloseText;
        // create new session on cancel if profile has been updated
        confirmationModal.componentInstance.cancelAction = this.confirmationModalCancelAction.bind(this);
        confirmationModal.componentInstance.showViewMemberLink = this.profileService.getShowViewMemberLink();
        confirmationModal.result
            .then(async () => {
            this.agentSearchFacade.navigateByPageTag(PageTags.ADD_NEW_PROFILE);
        })
            .catch(error => {
            this.externalErrorLoggingService.log(error);
        });
    }
    confirmationModalCancelAction() {
        // Create a new member session if we have updated the store for an email address but if no
        // member profile exists.
        const isNewMemberSessionNeeded = !this.profileService.hasMemberProfile() && this.store.selectSnapshot(ProfileState.emailAddress);
        if (isNewMemberSessionNeeded) {
            this.memberSessionService.createMemberSession$().toPromise();
        }
    }
    getConfirmationText(soaActivities, soaActivityType, memberPhoneNumber) {
        const emailSentText = this.configResourceService.getProcessedResourceValue('Spa_SOA_Activity_StartedText', null, 'Email sent to <soaEmail> on <soaDate>');
        const textSentText = this.configResourceService.getProcessedResourceValue('Spa_SOA_Activity_TextSentText', null, 'Text sent to <phone> on <soaDate>');
        let confirmationTextMessage = '';
        if (soaActivityType.includes(SOAActivityType.STARTED_EMAIL)) {
            const emailMessage = this.replaceTextReplacementVariables(emailSentText, this.latestStartedActivity(soaActivities, SOAActivityType.STARTED_EMAIL), memberPhoneNumber);
            confirmationTextMessage += emailMessage; // Add email message
        }
        if (soaActivityType.includes(SOAActivityType.STARTED_TEXT)) {
            if (confirmationTextMessage !== '') {
                confirmationTextMessage += ', ';
            }
            const phoneMessage = this.replaceTextReplacementVariables(textSentText, this.latestStartedActivity(soaActivities, SOAActivityType.STARTED_TEXT), memberPhoneNumber);
            confirmationTextMessage += phoneMessage; // Add phone message
        }
        return confirmationTextMessage;
    }
    getViewMemberLink(widgetName) {
        const isCreateProfileEnabled = this.configResourceService.getProcessedResourceValue('Spa_Quote_CreateProfile_Enabled', widgetName, this.siteService.isPPCSite());
        const createProfileLink = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_CreateProfile_Link_Text', widgetName, 'Create a profile');
        const viewMemberLink = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_ViewMemberProfile_Link_Text', widgetName, `View 's profile`);
        if (this.profileService.hasMemberProfile() || isCreateProfileEnabled) {
            const fullName = this.profileService.getMemberFullName();
            return this.profileService.getViewLinkText(viewMemberLink, fullName);
        }
        else {
            return createProfileLink;
        }
    }
    getConsumerShortUrl$(queryString, transactionGuid) {
        const consumerEmailLinkUrl = this.getSOAUrlForConsumer(queryString, transactionGuid, SendAppVia.EMAIL);
        return this.messagesService.getShortUrl$(consumerEmailLinkUrl);
    }
    getSOACoverageEventType(soaTransactionType = SOATransactionEventType.EMAIL) {
        const soaCoverageEventTypeMapping = {
            // Complete SOA form in-person (agent)
            [SOATransactionEventType.IN_PERSON]: CoverageEventType.SOAAgent,
            // Complete SOA form by phone (agent)
            [SOATransactionEventType.BY_PHONE]: CoverageEventType.SOAAgent_Phone,
            // Send SOA via text (beneficiary)
            [SOATransactionEventType.TEXT]: CoverageEventType.SOAText,
            // Send SOA via email (beneficiary)
            [SOATransactionEventType.EMAIL]: CoverageEventType.SOA
        };
        return soaCoverageEventTypeMapping[soaTransactionType] ?? CoverageEventType.SOA;
    }
    getSOAUrlForConsumer(query, transactionGuid, sendingMedium) {
        const isSOADisplayAuthorizationPageEnabled = this.configResourceService.getProcessedResourceValue('SPA_SOA_DisplayAuthorizationPage_Enabled', null, false);
        const baseUrl = this.siteService.getSiteBaseUrl();
        const baseConsumerSiteUrl = this.siteService.getBaseConsumerSiteUrl();
        const soaFormPageUrl = this.navigationUtilityService.addHrefToUrl(baseUrl, PageTags.SOA_FORM, query);
        const soaAuthorizationPageUrl = this.navigationUtilityService.addHrefToUrl(baseConsumerSiteUrl, PageTags.BENEFICIARY_LOGIN, query);
        let url = soaFormPageUrl;
        if (isSOADisplayAuthorizationPageEnabled) {
            const soaFormBasePageUrl = this.navigationUtilityService.addHrefToUrl(baseUrl, PageTags.SOA_FORM);
            url = `${soaAuthorizationPageUrl}&soaFormUrl=${soaFormBasePageUrl}`;
        }
        const consumerEmailLinkUrl = new URL(url);
        consumerEmailLinkUrl.searchParams.set(UTMParameter.UTM_SOURCE, UTMValue.UTM_SOURCE_PLAN_COMPARE);
        consumerEmailLinkUrl.searchParams.set(UTMParameter.UTM_CAMPAIGN, UTMValue.UTM_CAMPAIGN_SOA);
        consumerEmailLinkUrl.searchParams.set(UTMParameter.UTM_CONTENT, transactionGuid);
        if (sendingMedium === SendAppVia.EMAIL) {
            consumerEmailLinkUrl.searchParams.set(UTMParameter.UTM_MEDIUM, UTMValue.UTM_MEDIUM_EMAIL);
        }
        else if (sendingMedium === SendAppVia.TEXT) {
            consumerEmailLinkUrl.searchParams.set(UTMParameter.UTM_MEDIUM, UTMValue.UTM_MEDIUM_SMS);
        }
        consumerEmailLinkUrl.searchParams.set('CultureCode', this.weglotService.getCurrentWeglotLocaleOrDefault());
        return consumerEmailLinkUrl.href;
    }
    emailInputs(agentInfo, agentPictureURL) {
        const agentEmail = agentInfo.agentEmailAddress ? agentInfo.agentEmailAddress : '';
        const agentName = agentInfo.agentFullName;
        const agentHours = agentInfo.agentHours ? agentInfo.agentHours : '';
        const agentPhoneNumber = this.phoneUtilityService.formatPhoneNumberWithExtension(agentInfo.agentPhoneNumber, this.agentService.getAgentExtension());
        const agentPhoneAndHours = agentHours && agentPhoneNumber ? `${agentHours} | ${agentPhoneNumber}` : agentHours + agentPhoneNumber;
        return [
            { key: 'agentName', value: agentName },
            { key: 'agentNPN', value: this.agentService.getAgentNPN() },
            { key: 'agentEmail', value: agentEmail },
            { key: 'agentPhoneAndHours', value: agentPhoneAndHours },
            { key: 'primaryButtonColor', value: this.getPrimaryButtonColor() },
            { key: 'agentPictureURL', value: agentPictureURL },
            { key: 'californiaLicenseNumber', value: this.agentService.getCaliforniaLicenseNumber() }
        ];
    }
    tagsToUpdate(event, transactionGuid) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: event,
            [DataLayerGlobalVariable.SOA_ID]: transactionGuid
        };
    }
    async createSOASession(authInfo, agentGuid, isSecurityDOBEnabled, dateOfBirth) {
        return await this.soaService.createSOASession(authInfo, agentGuid, isSecurityDOBEnabled, dateOfBirth);
    }
    getMemberRegistrationFields(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_MemberRegistration_Resource_Content', widgetName, [
            {
                keyName: 'firstName',
                labelText: 'First Name',
                display: true,
                required: true,
                requiredText: 'First name is required'
            },
            {
                keyName: 'lastName',
                labelText: 'Last name',
                display: true,
                required: true,
                requiredText: 'Last name is required'
            },
            {
                keyName: 'dateOfBirth',
                labelText: 'Date of birth',
                display: true,
                required: false,
                requiredText: 'Date of birth is required'
            },
            {
                keyName: 'email',
                labelText: 'Email address',
                display: true,
                required: false,
                requiredText: 'Email address is required'
            },
            {
                keyName: 'phone',
                labelText: 'Phone number',
                display: true,
                required: false,
                requiredText: 'Phone is required'
            },
            {
                keyName: 'address1',
                labelText: 'Address 1',
                display: true,
                required: false,
                requiredText: 'Address 1 is required'
            },
            {
                keyName: 'address2',
                labelText: 'Address 2',
                display: true,
                required: false,
                requiredText: 'Address 2 is required'
            },
            {
                keyName: 'city',
                labelText: 'City',
                display: true,
                required: false,
                requiredText: 'City is required'
            },
            {
                keyName: 'state',
                labelText: 'State',
                display: true,
                required: false,
                requiredText: 'State is required'
            },
            {
                keyName: 'zip',
                labelText: 'ZIP',
                display: true,
                required: true,
                requiredText: 'ZIP is required'
            },
            {
                keyName: 'county',
                labelText: 'County',
                display: false,
                required: false,
                requiredText: 'County is required'
            },
            {
                keyName: 'crm',
                labelText: 'CRM ID',
                display: true,
                required: false,
                requiredText: 'CRM ID is required'
            },
            {
                keyName: 'authRepFirstName',
                labelText: 'First name',
                display: true,
                required: false,
                requiredText: 'First name is required'
            },
            {
                keyName: 'authRepLastName',
                labelText: 'Last name',
                display: true,
                required: false,
                requiredText: 'Last name is required'
            },
            {
                keyName: 'authRepEmail',
                labelText: 'Email',
                display: true,
                required: false,
                requiredText: 'Email is required'
            },
            {
                keyName: 'authRepPhone',
                labelText: 'Phone number',
                display: true,
                required: false,
                requiredText: 'Phone number is required'
            },
            {
                keyName: 'authRepAddress1',
                labelText: 'Address line 1',
                display: true,
                required: false,
                requiredText: 'Address line 1 is required'
            },
            {
                keyName: 'authRepAddress2',
                labelText: 'Address line 2',
                display: true,
                required: false,
                requiredText: 'Address line 2 is required'
            },
            {
                keyName: 'authRepCity',
                labelText: 'City',
                display: true,
                required: false,
                requiredText: 'City is required'
            },
            {
                keyName: 'authRepState',
                labelText: 'State',
                display: true,
                required: false,
                requiredText: 'State is required'
            },
            {
                keyName: 'authRepZip',
                labelText: 'Zip',
                display: true,
                required: false,
                requiredText: 'Zip is required'
            },
            {
                keyName: 'authRepRelationship',
                labelText: 'Relationship to beneficiary',
                display: true,
                required: false,
                requiredText: 'Relationship is required'
            },
            {
                keyName: 'customField1',
                labelText: '[Primary care provider]',
                display: true,
                required: false,
                requiredText: 'Custom field 1 is required'
            },
            {
                keyName: 'customField2',
                labelText: '[Custom 2]',
                display: true,
                required: false,
                requiredText: 'Custom field 2 is required'
            },
            {
                keyName: 'customField3',
                labelText: '[Custom 3]',
                display: true,
                required: false,
                requiredText: 'Custom field 3 is required'
            },
            {
                keyName: 'customField4',
                labelText: '[Custom 4]',
                display: true,
                required: false,
                requiredText: 'Custom field 4 is required'
            },
            {
                keyName: 'customField5',
                labelText: '[Custom 5]',
                display: true,
                required: false,
                requiredText: 'Custom field 5 is required'
            }
        ]);
    }
    replaceTextReplacementVariables(message, activity, memberPhone, memberName) {
        const soaEmail = activity.email ? activity.email : '';
        const soaDate = activity.date ? activity.date : '';
        const soaDateInMMddyyyy = soaDate ? DateUtilities.getFormattedPTDate(new Date(soaDate), DateUtilities.defaultFormat) : ''; // Convert soaDate from UTC to Pacific Time (PT)
        return message
            .replace('<soaMemberName>', memberName)
            .replace('<soaEmail>', soaEmail)
            .replace('<phone>', this.getFormattedPhoneNumber(memberPhone))
            .replace('<soaDate>', soaDateInMMddyyyy);
    }
    getFormattedPhoneNumber(phone) {
        return phone && phone.length === 10 ? `(${phone.substring(0, 3)}) ${phone.substring(3, 6)}-${phone.substring(6, 10)}` : '';
    }
    async sendConsumerSOAText(phone, url, widgetName) {
        let textMessage = `${this.getSOATextMessageContent(widgetName)}\n`;
        const weglotMultiLanguageEnabled = this.configResourceService.getProcessedResourceValue('Spa_Weglot_MultiLanguage_Enabled', null, false);
        if (weglotMultiLanguageEnabled) {
            textMessage = await this.weglotService.getTranslatedText$(textMessage).toPromise();
        }
        textMessage = textMessage ? `${textMessage}${url}` : '';
        return await this.messagesService.sendText$(phone, textMessage).toPromise();
    }
    getSOATextMessageContent(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_SOAConsumer_TextMessageText', widgetName, 'Click to complete your Scope of Appointment.');
    }
}
SOAFacade.ɵfac = function SOAFacade_Factory(t) { return new (t || SOAFacade)(i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.EmailService), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(i1.SOAService), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.NavigationUtilityService), i0.ɵɵinject(AgentNoteFacade), i0.ɵɵinject(i1.MessagesService), i0.ɵɵinject(i1.PhoneUtilityService), i0.ɵɵinject(i1.ProfileService), i0.ɵɵinject(i1.WeglotService), i0.ɵɵinject(i1.FormValidationService), i0.ɵɵinject(i1.AgentService), i0.ɵɵinject(i1.PhoneUtilityService), i0.ɵɵinject(AnalyticsService), i0.ɵɵinject(i1.SiteService), i0.ɵɵinject(i1.AgentPermissionsService), i0.ɵɵinject(AgentSearchFacade), i0.ɵɵinject(i1.SpinnerService), i0.ɵɵinject(i1.ExternalErrorLoggingService), i0.ɵɵinject(i1.EnrollmentFormService), i0.ɵɵinject(i1.QuoteService), i0.ɵɵinject(i1.PassParameterService), i0.ɵɵinject(i1.LockedSiteService), i0.ɵɵinject(i1.DemographicService), i0.ɵɵinject(i1.UtilityFunctionService), i0.ɵɵinject(i1.IPUtilityService), i0.ɵɵinject(i1.PlanYearResourceService), i0.ɵɵinject(i1.TwilioDeviceService)); };
SOAFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SOAFacade, factory: SOAFacade.ɵfac, providedIn: 'root' });
__decorate([
    Select(AgentState.fullName)
], SOAFacade.prototype, "agentFullName$", void 0);
__decorate([
    Select(AgentState.emailAddress)
], SOAFacade.prototype, "agentEmailAddress$", void 0);
__decorate([
    Select(AgentState.phoneNumber)
], SOAFacade.prototype, "agentPhoneNumber$", void 0);
__decorate([
    Select(AgentState.hours)
], SOAFacade.prototype, "agentHours$", void 0);
__decorate([
    Select(AgentState.agentGuid)
], SOAFacade.prototype, "agentGuid$", void 0);
__decorate([
    Select(SOAState.loading)
], SOAFacade.prototype, "isLoading$", void 0);
__decorate([
    Select(ProfileState.emailAddress)
], SOAFacade.prototype, "memberEmail$", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SOAFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1$1.NgbModal }, { type: i0.Injector }, { type: i2.Store }, { type: i1.EmailService }, { type: i1.MemberSessionService }, { type: i1.SOAService }, { type: i1.ConfigResourceService }, { type: i1.NavigationUtilityService }, { type: AgentNoteFacade }, { type: i1.MessagesService }, { type: i1.PhoneUtilityService }, { type: i1.ProfileService }, { type: i1.WeglotService }, { type: i1.FormValidationService }, { type: i1.AgentService }, { type: i1.PhoneUtilityService }, { type: AnalyticsService }, { type: i1.SiteService }, { type: i1.AgentPermissionsService }, { type: AgentSearchFacade }, { type: i1.SpinnerService }, { type: i1.ExternalErrorLoggingService }, { type: i1.EnrollmentFormService }, { type: i1.QuoteService }, { type: i1.PassParameterService }, { type: i1.LockedSiteService }, { type: i1.DemographicService }, { type: i1.UtilityFunctionService }, { type: i1.IPUtilityService }, { type: i1.PlanYearResourceService }, { type: i1.TwilioDeviceService }]; }, { agentFullName$: [], agentEmailAddress$: [], agentPhoneNumber$: [], agentHours$: [], agentGuid$: [], isLoading$: [], memberEmail$: [] }); })();

function AgentSOAComponent_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.agentSOAEmptyText, " ");
} }
const _c0$2V = function (a0, a1) { return { "finished-activity": a0, "Spa_Style_Gray4_Color": a1 }; };
function AgentSOAComponent_p_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 7);
    i0.ɵɵelement(1, "i", 8);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c0$2V, ctx_r1.soaActivity.type === ctx_r1.soaActivityType.COMPLETED || ctx_r1.soaActivity.type === ctx_r1.soaActivityType.UPLOADED_FILE || ctx_r1.soaActivity.type === ctx_r1.soaActivityType.COMPLETED_IN_PERSON || ctx_r1.soaActivity.type === ctx_r1.soaActivityType.COMPLETED_BY_PHONE, ctx_r1.soaActivity.type === ctx_r1.soaActivityType.PARTIAL || ctx_r1.soaActivity.type === ctx_r1.soaActivityType.STARTED_TEXT || ctx_r1.soaActivity.type === ctx_r1.soaActivityType.STARTED_EMAIL || ctx_r1.soaActivity.type === ctx_r1.soaActivityType.STARTED_IN_PERSON || ctx_r1.soaActivity.type === ctx_r1.soaActivityType.STARTED_BY_PHONE || ctx_r1.soaActivity.type === ctx_r1.soaActivityType.PARTIAL_IN_PERSON || ctx_r1.soaActivity.type === ctx_r1.soaActivityType.PARTIAL_BY_PHONE));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.message);
} }
class AgentSOAComponent {
    constructor(soaFacade) {
        this.soaFacade = soaFacade;
        this.soaActivityType = SOAActivityType;
    }
    ngOnChanges(changes) {
        const { soaActivity, memberName, memberPhone } = changes;
        if (this.soaActivity &&
            this.memberName &&
            (!_isEqual(soaActivity?.previousValue, soaActivity?.currentValue) ||
                memberName?.previousValue !== memberName?.currentValue ||
                memberPhone?.previousValue !== memberPhone?.currentValue)) {
            this.message = this.soaFacade.getActivityMessage(this.soaActivity, this.memberName, this.memberPhone);
        }
    }
    formatDate(date) {
        // API data in Pacific Time (PT). Just need to format as MM/DD/YYYY
        return date ? DateUtilities.getFormattedDateTime(new Date(date), DateUtilities.defaultFormat) : '';
    }
}
AgentSOAComponent.ɵfac = function AgentSOAComponent_Factory(t) { return new (t || AgentSOAComponent)(i0.ɵɵdirectiveInject(SOAFacade)); };
AgentSOAComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentSOAComponent, selectors: [["vnext-agent-soa"]], inputs: { agentSOAHeader: "agentSOAHeader", agentSOAEmptyText: "agentSOAEmptyText", soaActivity: "soaActivity", memberName: "memberName", memberPhone: "memberPhone" }, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 3, consts: [[1, "mb-2", "mb-sm-2", "px-2", "soaContainer"], [1, "soa-header"], [1, "Spa_Style_H2"], [1, "text-left"], ["class", "Spa_Style_Note soaEmptyContent", 4, "ngIf"], ["class", "soa-item Spa_Style_Paragraph", 3, "ngClass", 4, "ngIf"], [1, "Spa_Style_Note", "soaEmptyContent"], [1, "soa-item", "Spa_Style_Paragraph", 3, "ngClass"], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "pr-1"]], template: function AgentSOAComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h2", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtemplate(5, AgentSOAComponent_p_5_Template, 2, 1, "p", 4);
        i0.ɵɵtemplate(6, AgentSOAComponent_p_6_Template, 4, 5, "p", 5);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.agentSOAHeader);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !(ctx.soaActivity == null ? null : ctx.soaActivity.type));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.soaActivity == null ? null : ctx.soaActivity.type);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, IconAriaAttributesDirective], styles: [".soa-header[_ngcontent-%COMP%]{padding-top:30px;border-bottom:2px solid var(--static-Spa_Style_Gray2)}.soaEmptyContent[_ngcontent-%COMP%]{text-align:center;margin-top:12px;padding-bottom:12px}.finished-activity[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text)}.soa-item[_ngcontent-%COMP%]{padding-top:12px;padding-bottom:12px;word-wrap:break-word}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentSOAComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-soa', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"mb-2 mb-sm-2 px-2 soaContainer\">\r\n  <div class=\"soa-header\">\r\n    <h2 class=\"Spa_Style_H2\">{{ agentSOAHeader }}</h2>\r\n  </div>\r\n  <div class=\"text-left\">\r\n    <p *ngIf=\"!soaActivity?.type\" class=\"Spa_Style_Note soaEmptyContent\">\r\n      {{ agentSOAEmptyText }}\r\n    </p>\r\n\r\n    <p\r\n      *ngIf=\"soaActivity?.type\"\r\n      class=\"soa-item Spa_Style_Paragraph\"\r\n      [ngClass]=\"{\r\n        'finished-activity':\r\n          soaActivity.type === soaActivityType.COMPLETED ||\r\n          soaActivity.type === soaActivityType.UPLOADED_FILE ||\r\n          soaActivity.type === soaActivityType.COMPLETED_IN_PERSON ||\r\n          soaActivity.type === soaActivityType.COMPLETED_BY_PHONE,\r\n        'Spa_Style_Gray4_Color':\r\n          soaActivity.type === soaActivityType.PARTIAL ||\r\n          soaActivity.type === soaActivityType.STARTED_TEXT ||\r\n          soaActivity.type === soaActivityType.STARTED_EMAIL ||\r\n          soaActivity.type === soaActivityType.STARTED_IN_PERSON ||\r\n          soaActivity.type === soaActivityType.STARTED_BY_PHONE ||\r\n          soaActivity.type === soaActivityType.PARTIAL_IN_PERSON ||\r\n          soaActivity.type === soaActivityType.PARTIAL_BY_PHONE\r\n      }\"\r\n    >\r\n      <i class=\"fas fa-check-circle pr-1\" aria-hidden=\"true\"></i>\r\n      <span>{{ message }}</span>\r\n    </p>\r\n  </div>\r\n</div>\r\n", styles: [".soa-header{padding-top:30px;border-bottom:2px solid var(--static-Spa_Style_Gray2)}.soaEmptyContent{text-align:center;margin-top:12px;padding-bottom:12px}.finished-activity{color:var(--static-Spa_Style_Cost_Text)}.soa-item{padding-top:12px;padding-bottom:12px;word-wrap:break-word}\n"] }]
    }], function () { return [{ type: SOAFacade }]; }, { agentSOAHeader: [{
            type: Input
        }], agentSOAEmptyText: [{
            type: Input
        }], soaActivity: [{
            type: Input
        }], memberName: [{
            type: Input
        }], memberPhone: [{
            type: Input
        }] }); })();

function AgentTaskDetailComponent_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", ctx_r0.dueLabel, " ", ctx_r0.scheduledDate, "");
} }
function AgentTaskDetailComponent_p_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", ctx_r1.completedLabel, " ", ctx_r1.completedWhen, "");
} }
const _c0$2U = function (a0) { return { "line-through": a0 }; };
class AgentTaskDetailComponent {
    constructor() {
        this.onTaskStatusChanged = new EventEmitter();
    }
    changeTaskStatus(memberAgentNoteID) {
        if (this.completedWhen) {
            this.onTaskStatusChanged.emit({ memberAgentNoteID, status: MemberAgentTaskStatus.COMPLETE, noteActionType: this.noteActionType });
        }
        else {
            this.onTaskStatusChanged.emit({ memberAgentNoteID, status: MemberAgentTaskStatus.OPEN, noteActionType: this.noteActionType });
        }
    }
}
AgentTaskDetailComponent.ɵfac = function AgentTaskDetailComponent_Factory(t) { return new (t || AgentTaskDetailComponent)(); };
AgentTaskDetailComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentTaskDetailComponent, selectors: [["vnext-agent-task-detail"]], inputs: { description: "description", agentName: "agentName", namePrefix: "namePrefix", createdWhen: "createdWhen", scheduledDate: "scheduledDate", completedWhen: "completedWhen", dueLabel: "dueLabel", completedLabel: "completedLabel", memberAgentNoteID: "memberAgentNoteID", noteActionType: "noteActionType" }, outputs: { onTaskStatusChanged: "onTaskStatusChanged" }, decls: 8, vars: 9, consts: [[1, "task-item"], ["class", "Spa_Style_Note Spa_Style_Accent2_Color mb-4", 4, "ngIf"], ["class", "Spa_Style_Note mb-4 completed-task", 4, "ngIf"], ["id", "descriptionId", 1, "Spa_Style_Paragraph", "mb-0", "no-translate-block", 3, "ngClass"], ["id", "chkCompleted", "type", "checkbox", "aria-labelledby", "descriptionId", 3, "checked", "change"], [1, "Spa_Style_Note", "mb-0", "no-translate-block"], [1, "Spa_Style_Note", "Spa_Style_Accent2_Color", "mb-4"], [1, "Spa_Style_Note", "mb-4", "completed-task"]], template: function AgentTaskDetailComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, AgentTaskDetailComponent_p_1_Template, 2, 2, "p", 1);
        i0.ɵɵtemplate(2, AgentTaskDetailComponent_p_2_Template, 2, 2, "p", 2);
        i0.ɵɵelementStart(3, "p", 3)(4, "input", 4);
        i0.ɵɵlistener("change", function AgentTaskDetailComponent_Template_input_change_4_listener() { return ctx.changeTaskStatus(ctx.memberAgentNoteID); });
        i0.ɵɵelementEnd();
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "p", 5);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.completedWhen);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.completedWhen);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0$2U, ctx.completedWhen));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("checked", ctx.completedWhen);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.description, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate2("", ctx.namePrefix, " ", ctx.agentName, "");
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf], styles: [".task-item[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Gray2);padding:12px 0;word-wrap:break-word}.line-through[_ngcontent-%COMP%]{text-decoration:line-through}.completed-task[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentTaskDetailComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-task-detail', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"task-item\">\r\n  <p class=\"Spa_Style_Note Spa_Style_Accent2_Color mb-4\" *ngIf=\"!completedWhen\">{{ dueLabel }} {{ scheduledDate }}</p>\r\n  <p class=\"Spa_Style_Note mb-4 completed-task\" *ngIf=\"completedWhen\">{{ completedLabel }} {{ completedWhen }}</p>\r\n  <p id=\"descriptionId\" class=\"Spa_Style_Paragraph mb-0 no-translate-block\" [ngClass]=\"{ 'line-through': completedWhen }\">\r\n    <input\r\n      id=\"chkCompleted\"\r\n      type=\"checkbox\"\r\n      aria-labelledby=\"descriptionId\"\r\n      [checked]=\"completedWhen\"\r\n      (change)=\"changeTaskStatus(memberAgentNoteID)\"\r\n    />\r\n    {{ description }}\r\n  </p>\r\n  <p class=\"Spa_Style_Note mb-0 no-translate-block\">{{ namePrefix }} {{ agentName }}</p>\r\n</div>\r\n", styles: [".task-item{border-bottom:1px solid var(--static-Spa_Style_Gray2);padding:12px 0;word-wrap:break-word}.line-through{text-decoration:line-through}.completed-task{color:var(--static-Spa_Style_Cost_Text)}\n"] }]
    }], null, { description: [{
            type: Input
        }], agentName: [{
            type: Input
        }], namePrefix: [{
            type: Input
        }], createdWhen: [{
            type: Input
        }], scheduledDate: [{
            type: Input
        }], completedWhen: [{
            type: Input
        }], dueLabel: [{
            type: Input
        }], completedLabel: [{
            type: Input
        }], memberAgentNoteID: [{
            type: Input
        }], noteActionType: [{
            type: Input
        }], onTaskStatusChanged: [{
            type: Output
        }] }); })();

function AgentTaskComponent_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.agentTaskEmptyTaskText, " ");
} }
function AgentTaskComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-agent-task-detail", 9);
    i0.ɵɵlistener("onTaskStatusChanged", function AgentTaskComponent_div_6_Template_vnext_agent_task_detail_onTaskStatusChanged_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.changeTaskStatus($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const task_r2 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("description", task_r2.description)("agentName", task_r2.agentName)("dueLabel", ctx_r1.agentTaskDueLabel)("completedLabel", ctx_r1.agentTaskCompleteLabel)("memberAgentNoteID", task_r2.memberAgentNoteID)("noteActionType", task_r2.agentNoteActionType)("namePrefix", ctx_r1.agentTaskAgentNamePreFixLabel)("createdWhen", ctx_r1.formatDate(task_r2.createdWhen))("scheduledDate", ctx_r1.formatDate(task_r2.scheduledDate))("completedWhen", ctx_r1.formatDate(task_r2.completedWhen));
} }
class AgentTaskComponent {
    constructor(analyticsService, agentTaskFacade) {
        this.analyticsService = analyticsService;
        this.agentTaskFacade = agentTaskFacade;
        this.openTaskModal = new EventEmitter();
        this.onTaskStatusChanged = new EventEmitter();
    }
    formatDate(date) {
        // API data in Pacific Time (PT). Just need to format as MM/DD/YYYY
        return date ? DateUtilities.getFormattedDateTime(new Date(date), DateUtilities.defaultFormat) : '';
    }
    showModal(event) {
        event.preventDefault();
        this.openTaskModal.emit();
    }
    changeTaskStatus(memberAgentNoteResponse) {
        this.onTaskStatusChanged.emit({
            memberAgentNoteID: memberAgentNoteResponse.memberAgentNoteID,
            status: memberAgentNoteResponse.status,
            noteActionType: memberAgentNoteResponse.noteActionType
        });
        if (memberAgentNoteResponse.status !== MemberAgentTaskStatus.COMPLETE) {
            this.updateTags(memberAgentNoteResponse.noteActionType);
        }
    }
    updateTags(noteActionType) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PROFILE_TASK_COMPLETE,
            [DataLayerGlobalVariable.PROFILE_TASK_TYPE]: this.agentTaskFacade.getAgentTaskName(noteActionType)
        };
    }
}
AgentTaskComponent.ɵfac = function AgentTaskComponent_Factory(t) { return new (t || AgentTaskComponent)(i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(AgentTaskFacade)); };
AgentTaskComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentTaskComponent, selectors: [["vnext-agent-task"]], inputs: { taskText: "taskText", agentTaskHeader: "agentTaskHeader", agentTaskEmptyTaskText: "agentTaskEmptyTaskText", agentTaskAddTaskLink: "agentTaskAddTaskLink", agentTaskDueLabel: "agentTaskDueLabel", agentTaskCompleteLabel: "agentTaskCompleteLabel", agentTaskAgentNamePreFixLabel: "agentTaskAgentNamePreFixLabel", memberAgentTasks: "memberAgentTasks" }, outputs: { openTaskModal: "openTaskModal", onTaskStatusChanged: "onTaskStatusChanged" }, decls: 10, vars: 4, consts: [[1, "mb-2", "mb-sm-2", "px-2", "task-container"], [1, "task-header"], [1, "Spa_Style_H2"], [1, "task-content"], ["class", "Spa_Style_Note task-empty-content", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["tabindex", "0", 1, "task-link", "Spa_Style_Link", "can-click", "mt-2", 3, "click", "keyup.enter"], ["aria-hidden", "true", 1, "fas", "fa-plus-circle", "mr-1"], [1, "Spa_Style_Note", "task-empty-content"], [3, "description", "agentName", "dueLabel", "completedLabel", "memberAgentNoteID", "noteActionType", "namePrefix", "createdWhen", "scheduledDate", "completedWhen", "onTaskStatusChanged"]], template: function AgentTaskComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h2", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtemplate(5, AgentTaskComponent_p_5_Template, 2, 1, "p", 4);
        i0.ɵɵtemplate(6, AgentTaskComponent_div_6_Template, 2, 10, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵlistener("click", function AgentTaskComponent_Template_div_click_7_listener($event) { return ctx.showModal($event); })("keyup.enter", function AgentTaskComponent_Template_div_keyup_enter_7_listener($event) { return ctx.showModal($event); });
        i0.ɵɵelement(8, "span", 7);
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.agentTaskHeader);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.memberAgentTasks == null ? null : ctx.memberAgentTasks.length) === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.memberAgentTasks);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1("", ctx.agentTaskAddTaskLink, " ");
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, AgentTaskDetailComponent], styles: [".task-header[_ngcontent-%COMP%]{border-bottom:2px solid var(--static-Spa_Style_Gray2)}.task-empty-content[_ngcontent-%COMP%]{text-align:center;margin-top:12px;padding-bottom:12px;border-bottom:1px solid var(--static-Spa_Style_Gray2)}.task-content[_ngcontent-%COMP%]{text-align:left}.task-link[_ngcontent-%COMP%]{text-align:right;margin-top:-10px}.task-link[_ngcontent-%COMP%]:focus{padding-right:5px;padding-left:5px;margin-right:-5px;margin-left:-5px;border-radius:5px}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], AgentTaskComponent.prototype, "showModal", null);
__decorate([
    LiveEditInactive()
], AgentTaskComponent.prototype, "changeTaskStatus", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentTaskComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-task', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"mb-2 mb-sm-2 px-2 task-container\">\r\n  <div class=\"task-header\">\r\n    <h2 class=\"Spa_Style_H2\">{{ agentTaskHeader }}</h2>\r\n  </div>\r\n  <div class=\"task-content\">\r\n    <p *ngIf=\"memberAgentTasks?.length === 0\" class=\"Spa_Style_Note task-empty-content\">\r\n      {{ agentTaskEmptyTaskText }}\r\n    </p>\r\n    <div *ngFor=\"let task of memberAgentTasks\">\r\n      <vnext-agent-task-detail\r\n        [description]=\"task.description\"\r\n        [agentName]=\"task.agentName\"\r\n        [dueLabel]=\"agentTaskDueLabel\"\r\n        [completedLabel]=\"agentTaskCompleteLabel\"\r\n        [memberAgentNoteID]=\"task.memberAgentNoteID\"\r\n        [noteActionType]=\"task.agentNoteActionType\"\r\n        [namePrefix]=\"agentTaskAgentNamePreFixLabel\"\r\n        [createdWhen]=\"formatDate(task.createdWhen)\"\r\n        [scheduledDate]=\"formatDate(task.scheduledDate)\"\r\n        [completedWhen]=\"formatDate(task.completedWhen)\"\r\n        (onTaskStatusChanged)=\"changeTaskStatus($event)\"\r\n      >\r\n      </vnext-agent-task-detail>\r\n    </div>\r\n  </div>\r\n  <div class=\"task-link Spa_Style_Link can-click mt-2\" tabindex=\"0\" (click)=\"showModal($event)\" (keyup.enter)=\"showModal($event)\">\r\n    <span class=\"fas fa-plus-circle mr-1\" aria-hidden=\"true\"></span>{{ agentTaskAddTaskLink }}\r\n  </div>\r\n</div>\r\n", styles: [".task-header{border-bottom:2px solid var(--static-Spa_Style_Gray2)}.task-empty-content{text-align:center;margin-top:12px;padding-bottom:12px;border-bottom:1px solid var(--static-Spa_Style_Gray2)}.task-content{text-align:left}.task-link{text-align:right;margin-top:-10px}.task-link:focus{padding-right:5px;padding-left:5px;margin-right:-5px;margin-left:-5px;border-radius:5px}\n"] }]
    }], function () { return [{ type: AnalyticsService }, { type: AgentTaskFacade }]; }, { taskText: [{
            type: Input
        }], agentTaskHeader: [{
            type: Input
        }], agentTaskEmptyTaskText: [{
            type: Input
        }], agentTaskAddTaskLink: [{
            type: Input
        }], agentTaskDueLabel: [{
            type: Input
        }], agentTaskCompleteLabel: [{
            type: Input
        }], agentTaskAgentNamePreFixLabel: [{
            type: Input
        }], memberAgentTasks: [{
            type: Input
        }], openTaskModal: [{
            type: Output
        }], onTaskStatusChanged: [{
            type: Output
        }], showModal: [], changeTaskStatus: [] }); })();

var InputControlType$1;
(function (InputControlType) {
    InputControlType["TOGGLE"] = "toggle";
    InputControlType["INPUT"] = "input";
    InputControlType["DROPDOWN"] = "dropdown";
    InputControlType["PASSWORD"] = "password";
    InputControlType["TEXT"] = "text";
    InputControlType["DATE_PICKER"] = "datepicker";
    InputControlType["BUTTON"] = "button";
})(InputControlType$1 || (InputControlType$1 = {}));

function ActiveSellingPermissionsComponent_ng_container_1_th_16_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "th", 16);
    i0.ɵɵlistener("sort", function ActiveSellingPermissionsComponent_ng_container_1_th_16_Template_th_sort_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.onSort($event)); });
    i0.ɵɵelementStart(1, "span", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.producerIdHeader);
} }
function ActiveSellingPermissionsComponent_ng_container_1_th_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "th", 17);
} }
function ActiveSellingPermissionsComponent_ng_container_1_tr_19_div_10_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.noSNPText, " ");
} }
function ActiveSellingPermissionsComponent_ng_container_1_tr_19_div_10_ng_template_2_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const snpType_r18 = ctx.$implicit;
    const isLast_r19 = ctx.last;
    const ctx_r17 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r17.getSNPLabel(snpType_r18), "", isLast_r19 ? "" : ", ", " ");
} }
function ActiveSellingPermissionsComponent_ng_container_1_tr_19_div_10_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ActiveSellingPermissionsComponent_ng_container_1_tr_19_div_10_ng_template_2_span_0_Template, 2, 2, "span", 27);
} if (rf & 2) {
    const sellingPermission_r9 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngForOf", sellingPermission_r9.snpTypes);
} }
function ActiveSellingPermissionsComponent_ng_container_1_tr_19_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, ActiveSellingPermissionsComponent_ng_container_1_tr_19_div_10_span_1_Template, 2, 1, "span", 1);
    i0.ɵɵtemplate(2, ActiveSellingPermissionsComponent_ng_container_1_tr_19_div_10_ng_template_2_Template, 1, 1, "ng-template", null, 26, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r15 = i0.ɵɵreference(3);
    const sellingPermission_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (sellingPermission_r9.snpTypes == null ? null : sellingPermission_r9.snpTypes.length) === 0)("ngIfElse", _r15);
} }
function ActiveSellingPermissionsComponent_ng_container_1_tr_19_td_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 28)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const sellingPermission_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(sellingPermission_r9.producerId);
} }
function ActiveSellingPermissionsComponent_ng_container_1_tr_19_td_15_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 29)(1, "span", 30);
    i0.ɵɵlistener("click", function ActiveSellingPermissionsComponent_ng_container_1_tr_19_td_15_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r24); const i_r10 = i0.ɵɵnextContext().index; const ctx_r23 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r23.removeRow(ctx_r23.pageStartIndex + i_r10)); });
    i0.ɵɵelement(2, "i", 31);
    i0.ɵɵelementStart(3, "span", 32);
    i0.ɵɵtext(4, "Remove");
    i0.ɵɵelementEnd()()();
} }
function ActiveSellingPermissionsComponent_ng_container_1_tr_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 18)(1, "td", 19)(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "td", 20)(5, "div");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "td", 19)(8, "div");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, ActiveSellingPermissionsComponent_ng_container_1_tr_19_div_10_Template, 4, 2, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td", 22)(12, "div");
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(14, ActiveSellingPermissionsComponent_ng_container_1_tr_19_td_14_Template, 3, 1, "td", 23);
    i0.ɵɵtemplate(15, ActiveSellingPermissionsComponent_ng_container_1_tr_19_td_15_Template, 5, 0, "td", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sellingPermission_r9 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r5.carrierNames[sellingPermission_r9.carrierId]);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(sellingPermission_r9.stateName);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r5.getPlanTypeName(sellingPermission_r9.planTypeId));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", sellingPermission_r9.planTypeId === ctx_r5.planType.MAPD);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r5.getPlanYearText(sellingPermission_r9));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.enableProducerIdColumn);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.showRemoveCol);
} }
function ActiveSellingPermissionsComponent_ng_container_1_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.mappedCarriersText);
} }
const _c0$2T = function (a0) { return { "hide-pagination": a0 }; };
function ActiveSellingPermissionsComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "table", 3)(2, "thead")(3, "tr", 4)(4, "th", 5);
    i0.ɵɵlistener("sort", function ActiveSellingPermissionsComponent_ng_container_1_Template_th_sort_4_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r26.onSort($event)); });
    i0.ɵɵelementStart(5, "span", 6);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "th", 7);
    i0.ɵɵlistener("sort", function ActiveSellingPermissionsComponent_ng_container_1_Template_th_sort_7_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r28 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r28.onSort($event)); });
    i0.ɵɵelementStart(8, "span", 6);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "th", 8);
    i0.ɵɵlistener("sort", function ActiveSellingPermissionsComponent_ng_container_1_Template_th_sort_10_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r29 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r29.onSort($event)); });
    i0.ɵɵelementStart(11, "span", 6);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "th", 9);
    i0.ɵɵlistener("sort", function ActiveSellingPermissionsComponent_ng_container_1_Template_th_sort_13_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r30 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r30.onSort($event)); });
    i0.ɵɵelementStart(14, "span", 6);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(16, ActiveSellingPermissionsComponent_ng_container_1_th_16_Template, 3, 1, "th", 10);
    i0.ɵɵtemplate(17, ActiveSellingPermissionsComponent_ng_container_1_th_17_Template, 1, 0, "th", 11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "tbody");
    i0.ɵɵtemplate(19, ActiveSellingPermissionsComponent_ng_container_1_tr_19_Template, 16, 7, "tr", 12);
    i0.ɵɵpipe(20, "slice");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(21, ActiveSellingPermissionsComponent_ng_container_1_div_21_Template, 2, 1, "div", 13);
    i0.ɵɵelementStart(22, "div", 14)(23, "vnext-pagination", 15);
    i0.ɵɵlistener("updatePagination", function ActiveSellingPermissionsComponent_ng_container_1_Template_vnext_pagination_updatePagination_23_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r31 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r31.updateAgentDetails($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.carrierHeader);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.stateHeader);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.planTypeHeader);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.planYearHeader);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.enableProducerIdColumn);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showRemoveCol);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(20, 13, ctx_r0.formattedAgentPermissions, ctx_r0.pageStartIndex, ctx_r0.pageEndIndex));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.nonMappedPermissionPresent);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c0$2T, !ctx_r0.paginationEnabled || ctx_r0.itemsPerPage >= (ctx_r0.formattedAgentPermissions == null ? null : ctx_r0.formattedAgentPermissions.length)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pagination", ctx_r0.formattedAgentPermissions)("defaultStartItem", ctx_r0.defaultStartItem)("itemsPerPage", ctx_r0.itemsPerPage)("paginationText", ctx_r0.paginationText);
} }
function ActiveSellingPermissionsComponent_ng_template_2_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r35.noPermissionsAfterFiltersTitle, " ");
} }
function ActiveSellingPermissionsComponent_ng_template_2_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r36.noPermissionsAfterFiltersBody, " ");
} }
function ActiveSellingPermissionsComponent_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵtemplate(1, ActiveSellingPermissionsComponent_ng_template_2_div_0_div_1_Template, 2, 1, "div", 37);
    i0.ɵɵtemplate(2, ActiveSellingPermissionsComponent_ng_template_2_div_0_div_2_Template, 2, 1, "div", 38);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_NoPermissionsAfterFilters_Title");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_NoPermissionsAfterFilters_Body");
} }
function ActiveSellingPermissionsComponent_ng_template_2_ng_template_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r37.noPermissionsTitle, " ");
} }
function ActiveSellingPermissionsComponent_ng_template_2_ng_template_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r38.noPermissionsBody, " ");
} }
function ActiveSellingPermissionsComponent_ng_template_2_ng_template_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r39.mappedCarriersText);
} }
function ActiveSellingPermissionsComponent_ng_template_2_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelement(1, "div", 41)(2, "i", 42);
    i0.ɵɵtemplate(3, ActiveSellingPermissionsComponent_ng_template_2_ng_template_1_div_3_Template, 2, 1, "div", 37);
    i0.ɵɵtemplate(4, ActiveSellingPermissionsComponent_ng_template_2_ng_template_1_div_4_Template, 2, 1, "div", 38);
    i0.ɵɵtemplate(5, ActiveSellingPermissionsComponent_ng_template_2_ng_template_1_div_5_Template, 2, 1, "div", 43);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r34.noPermissionsIcon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_NoPermissions_Title");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_NoPermissions_Body");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r34.nonMappedPermissionPresent);
} }
function ActiveSellingPermissionsComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ActiveSellingPermissionsComponent_ng_template_2_div_0_Template, 3, 2, "div", 34);
    i0.ɵɵtemplate(1, ActiveSellingPermissionsComponent_ng_template_2_ng_template_1_Template, 6, 4, "ng-template", null, 35, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r33 = i0.ɵɵreference(2);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.hasAnyASPFilters)("ngIfElse", _r33);
} }
class ActiveSellingPermissionsComponent {
    constructor(cdr, agentService, snpService, aspFilterService, planYearResourceService) {
        this.cdr = cdr;
        this.agentService = agentService;
        this.snpService = snpService;
        this.aspFilterService = aspFilterService;
        this.planYearResourceService = planYearResourceService;
        this.enableProducerIdColumn = false;
        this.subscriptions = new Subscription();
        this.defaultStartItem = 1;
        this.pageIndex = 1;
        this.carrierNames = [];
        this.planType = PlanType;
        this.nonMappedPermissionPresent = false; // shows message in permissions list when carrier is not mapped to the site
    }
    get pageStartIndex() {
        if (this.hasAnyASPFilters) {
            if (this.formattedAgentPermissions?.length > this.pageSize) {
                return (this.pageIndex - 1) * this.pageSize;
            }
            return 0;
        }
        return (this.pageIndex - 1) * this.pageSize;
    }
    get pageEndIndex() {
        return (this.pageIndex - 1) * this.pageSize + this.pageSize;
    }
    onSort({ column, direction }) {
        this.headers.forEach(header => {
            if (header.sortable !== column) {
                header.direction = '';
            }
        });
        if (direction === '') {
            this.updateAgentSellingPermissions();
        }
        else {
            this.formattedAgentPermissions = [...this.formattedAgentPermissions].sort((a, b) => {
                const res = compare(a[column], b[column]);
                return direction === 'asc' ? res : -res;
            });
        }
        this.cdr.markForCheck();
    }
    ngOnInit() {
        this.updateAgentSellingPermissions();
        this.subscriptions.add(this.aspFilterService.getHasAnyASPFilters$().subscribe(hasAnyASPFilters => {
            this.hasAnyASPFilters = hasAnyASPFilters;
            this.cdr.markForCheck();
        }));
        this.pageSize = this.paginationEnabled ? this.itemsPerPage : this.agentSellingPermissions?.length;
        this.cdr.markForCheck();
    }
    ngOnChanges(changes) {
        if (changes?.carriers?.currentValue !== changes?.carriers?.previousValue && changes?.carriers?.currentValue?.length) {
            this.updateCarrierNames(changes.carriers.currentValue);
            this.updateAgentSellingPermissions();
        }
        if (changes?.agentSellingPermissions?.currentValue !== changes?.agentSellingPermissions?.previousValue) {
            this.updateAgentSellingPermissions();
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    updateCarrierNames(carriers) {
        const newNames = [];
        carriers.forEach(carrier => {
            newNames[carrier.carrierID] = carrier.name;
        });
        this.carrierNames = newNames;
    }
    updateAgentSellingPermissions() {
        this.formattedAgentPermissions = [];
        if (this.agentSellingPermissions?.length) {
            this.agentSellingPermissions.forEach(permission => {
                const newPermission = { ...permission };
                if (this.carrierNames.length) {
                    newPermission.carrierName = this.carrierNames[newPermission.carrierId];
                }
                newPermission.planTypeAbbrev = this.getPlanTypeName(newPermission.planTypeId);
                if (this.planYearResourceService.isPermissionAllowed(newPermission)) {
                    this.formattedAgentPermissions.push(newPermission);
                }
            });
        }
        this.findUnmappedPermissions();
        this.filterUnmappedPermission();
        this.formattedAgentPermissions.sort((a, b) => (a.carrierName > b.carrierName ? 1 : -1));
    }
    filterUnmappedPermission() {
        this.formattedAgentPermissions = this.formattedAgentPermissions.filter(sellingPermission => this.carrierNames[sellingPermission.carrierId]);
    }
    findUnmappedPermissions() {
        this.nonMappedPermissionPresent = !!this.formattedAgentPermissions.find(sellingPermission => !this.carrierNames[sellingPermission.carrierId]);
    }
    updateAgentDetails(pagination) {
        this.defaultStartItem = pagination.defaultStartItem;
        this.pageSize = this.paginationEnabled ? pagination.pageSize : this.formattedAgentPermissions?.length;
        this.pageIndex = pagination.defaultStartItem;
    }
    removeRow(index) {
        const permission = this.formattedAgentPermissions[index];
        this.agentService.removeAgentSellingPermission(this.agentData.agentGuid, permission);
    }
    getSNPLabel(snpType) {
        return this.snpService.getSNPAbbreviation(snpType);
    }
    getPlanTypeName(planTypeId) {
        if (planTypeId === PlanType.MEDIGAP) {
            return this.medSupAbbrev;
        }
        else if (planTypeId === PlanType.ALL_ANCILLARY) {
            return this.ancillaryAbbrev;
        }
        return PlansUtilityService.getPlanTypeName(planTypeId);
    }
    getPlanYearText(permission) {
        return permission.planTypeId !== PlanType.MEDIGAP && permission.planYear ? `${permission.planYear}` : this.notApplicableText;
    }
}
ActiveSellingPermissionsComponent.ɵfac = function ActiveSellingPermissionsComponent_Factory(t) { return new (t || ActiveSellingPermissionsComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(i1.SNPService), i0.ɵɵdirectiveInject(i1.ASPFilterService), i0.ɵɵdirectiveInject(i1.PlanYearResourceService)); };
ActiveSellingPermissionsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ActiveSellingPermissionsComponent, selectors: [["vnext-active-selling-permissions"]], viewQuery: function ActiveSellingPermissionsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(NgbdSortableHeaderDirective, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headers = _t);
    } }, inputs: { agentData: "agentData", carriers: "carriers", headerText: "headerText", carrierHeader: "carrierHeader", stateHeader: "stateHeader", planTypeHeader: "planTypeHeader", planYearHeader: "planYearHeader", producerIdHeader: "producerIdHeader", agentSellingPermissions: "agentSellingPermissions", itemsPerPage: "itemsPerPage", paginationText: "paginationText", paginationEnabled: "paginationEnabled", enableProducerIdColumn: "enableProducerIdColumn", noPermissionsTitle: "noPermissionsTitle", noPermissionsBody: "noPermissionsBody", noPermissionsIcon: "noPermissionsIcon", noPermissionsAfterFiltersTitle: "noPermissionsAfterFiltersTitle", noPermissionsAfterFiltersBody: "noPermissionsAfterFiltersBody", medSupAbbrev: "medSupAbbrev", ancillaryAbbrev: "ancillaryAbbrev", mappedCarriersText: "mappedCarriersText", noSNPText: "noSNPText", notApplicableText: "notApplicableText", showRemoveCol: "showRemoveCol" }, features: [i0.ɵɵNgOnChangesFeature], decls: 4, vars: 2, consts: [[1, "row", "mt-4"], [4, "ngIf", "ngIfElse"], ["noPermissions", ""], [1, "active-selling-permissions-table", "table"], [1, "d-flex", "Spa_Style_Bold_Weight", "Spa_Style_Primary_Color"], ["scope", "col", "sortable", "carrierName", 1, "col", 3, "sort"], [1, "wrap-header-text"], ["scope", "col", "sortable", "stateName", 1, "col", 3, "sort"], ["scope", "col", "sortable", "planTypeAbbrev", 1, "col", 3, "sort"], ["scope", "col", "sortable", "planYear", 1, "col", "d-none", "d-md-flex", 3, "sort"], ["scope", "col", "class", "col d-none d-lg-flex", "sortable", "producerId", 3, "sort", 4, "ngIf"], ["scope", "col", "class", "col-1", 4, "ngIf"], ["class", "d-flex Spa_Style_Primary_Color", 4, "ngFor", "ngForOf"], ["class", "w-100 Spa_Style_Small_Font text-center", 4, "ngIf"], [1, "pagination-wrapper", 3, "ngClass"], [3, "pagination", "defaultStartItem", "itemsPerPage", "paginationText", "updatePagination"], ["scope", "col", "sortable", "producerId", 1, "col", "d-none", "d-lg-flex", 3, "sort"], ["scope", "col", 1, "col-1"], [1, "d-flex", "Spa_Style_Primary_Color"], [1, "col"], [1, "col", "no-translate-block"], ["class", "Spa_Style_Note", 4, "ngIf"], [1, "col", "d-none", "d-md-block"], ["class", "col d-none d-lg-block", 4, "ngIf"], ["class", "col-1 text-right", 4, "ngIf"], [1, "Spa_Style_Note"], ["snpLabel", ""], [4, "ngFor", "ngForOf"], [1, "col", "d-none", "d-lg-block"], [1, "col-1", "text-right"], [1, "Spa_Style_Bold_Weight", "remove-row-button", 3, "click"], [1, "fas", "fa-times", "Spa_Style_Primary_Color"], [1, "sr-only"], [1, "w-100", "Spa_Style_Small_Font", "text-center"], ["class", "w-100 d-flex flex-column no-permissions-section Spa_Style_Primary_Color", 4, "ngIf", "ngIfElse"], ["noFilters", ""], [1, "w-100", "d-flex", "flex-column", "no-permissions-section", "Spa_Style_Primary_Color"], ["class", "no-permissions-title Spa_Style_Large_Font font-weight-bold", 4, "liveEditProp"], ["class", "no-permissions-message Spa_Style_Paragraph mb-2", 4, "liveEditProp"], [1, "no-permissions-title", "Spa_Style_Large_Font", "font-weight-bold"], [1, "no-permissions-message", "Spa_Style_Paragraph", "mb-2"], [1, "no-permissions-seperator", "mb-5"], ["aria-hidden", "true", 1, "no-permissions-icon", 3, "ngClass"], ["class", "w-100 Spa_Style_Small_Font mt-4 text-center", 4, "ngIf"], [1, "w-100", "Spa_Style_Small_Font", "mt-4", "text-center"]], template: function ActiveSellingPermissionsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, ActiveSellingPermissionsComponent_ng_container_1_Template, 24, 19, "ng-container", 1);
        i0.ɵɵtemplate(2, ActiveSellingPermissionsComponent_ng_template_2_Template, 3, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(3);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.formattedAgentPermissions == null ? null : ctx.formattedAgentPermissions.length)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, PaginationComponent, LiveEditPropDirective, IconAriaAttributesDirective, NgbdSortableHeaderDirective, i1$2.SlicePipe], styles: [".pagination-wrapper[_ngcontent-%COMP%]{text-align:right;display:block;width:100%}.active-selling-permissions-table[_ngcontent-%COMP%]   th[sortable][_ngcontent-%COMP%]{cursor:pointer}.active-selling-permissions-table[_ngcontent-%COMP%]   th[sortable][_ngcontent-%COMP%]:after, .active-selling-permissions-table[_ngcontent-%COMP%]   th[sortable].asc[_ngcontent-%COMP%]:after, .active-selling-permissions-table[_ngcontent-%COMP%]   th[sortable].desc[_ngcontent-%COMP%]:after{content:\"\\f0de\";display:block;background:none;display:inline-block;margin-left:5px;font-family:\"Font Awesome 5 Pro\"}.active-selling-permissions-table[_ngcontent-%COMP%]   th[sortable][_ngcontent-%COMP%]:after{content:\"\\f0dc\"}.active-selling-permissions-table[_ngcontent-%COMP%]   th[sortable].asc[_ngcontent-%COMP%]:after{content:\"\\f0dd\"}.active-selling-permissions-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{display:flex;align-items:flex-end}.table.active-selling-permissions-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .table.active-selling-permissions-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{float:left;word-wrap:break-word;word-break:break-all}th[_ngcontent-%COMP%], td[_ngcontent-%COMP%]{border-left:none;border-right:none;border-top:none}.wrap-header-text[_ngcontent-%COMP%]{width:100%;display:inline-block;word-wrap:break-word;word-break:break-word}.column-flex[_ngcontent-%COMP%]{flex:0 0 13em}.remove-row-button[_ngcontent-%COMP%]{cursor:pointer}.no-permissions-section[_ngcontent-%COMP%]{text-align:center}.no-permissions-seperator[_ngcontent-%COMP%]{width:100%;border-top:2px solid var(--static-Spa_Style_Accent1)}.no-permissions-icon[_ngcontent-%COMP%]{font-size:72px;color:var(--static-Spa_Style_Gray2)}.no-permissions-title[_ngcontent-%COMP%]{margin-top:30px}.no-permissions-message[_ngcontent-%COMP%]{line-height:28px}.hide-pagination[_ngcontent-%COMP%]{display:none}@media (max-width: 767px){.pagination-wrapper[_ngcontent-%COMP%]{text-align:left}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ActiveSellingPermissionsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-active-selling-permissions', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row mt-4\">\r\n  <ng-container *ngIf=\"formattedAgentPermissions?.length; else noPermissions\">\r\n    <table class=\"active-selling-permissions-table table\">\r\n      <thead>\r\n        <tr class=\"d-flex Spa_Style_Bold_Weight Spa_Style_Primary_Color\">\r\n          <th scope=\"col\" class=\"col\" sortable=\"carrierName\" (sort)=\"onSort($event)\">\r\n            <span class=\"wrap-header-text\">{{ carrierHeader }}</span>\r\n          </th>\r\n          <th scope=\"col\" class=\"col\" sortable=\"stateName\" (sort)=\"onSort($event)\">\r\n            <span class=\"wrap-header-text\">{{ stateHeader }}</span>\r\n          </th>\r\n          <th scope=\"col\" class=\"col\" sortable=\"planTypeAbbrev\" (sort)=\"onSort($event)\">\r\n            <span class=\"wrap-header-text\">{{ planTypeHeader }}</span>\r\n          </th>\r\n          <th scope=\"col\" class=\"col d-none d-md-flex\" sortable=\"planYear\" (sort)=\"onSort($event)\">\r\n            <span class=\"wrap-header-text\">{{ planYearHeader }}</span>\r\n          </th>\r\n          <th scope=\"col\" *ngIf=\"enableProducerIdColumn\" class=\"col d-none d-lg-flex\" sortable=\"producerId\" (sort)=\"onSort($event)\">\r\n            <span class=\"wrap-header-text\">{{ producerIdHeader }}</span>\r\n          </th>\r\n          <th scope=\"col\" class=\"col-1\" *ngIf=\"showRemoveCol\"></th>\r\n        </tr>\r\n      </thead>\r\n      <tbody>\r\n        <tr\r\n          *ngFor=\"let sellingPermission of formattedAgentPermissions | slice : pageStartIndex : pageEndIndex; index as i\"\r\n          class=\"d-flex Spa_Style_Primary_Color\"\r\n        >\r\n          <td class=\"col\">\r\n            <div>{{ carrierNames[sellingPermission.carrierId] }}</div>\r\n          </td>\r\n          <td class=\"col no-translate-block\">\r\n            <div>{{ sellingPermission.stateName }}</div>\r\n          </td>\r\n          <td class=\"col\">\r\n            <div>{{ getPlanTypeName(sellingPermission.planTypeId) }}</div>\r\n            <div class=\"Spa_Style_Note\" *ngIf=\"sellingPermission.planTypeId === planType.MAPD\">\r\n              <span *ngIf=\"sellingPermission.snpTypes?.length === 0; else snpLabel\">\r\n                {{ noSNPText }}\r\n              </span>\r\n              <ng-template #snpLabel>\r\n                <span *ngFor=\"let snpType of sellingPermission.snpTypes; let isLast = last\">\r\n                  {{ getSNPLabel(snpType) }}{{ isLast ? '' : ', ' }}\r\n                </span>\r\n              </ng-template>\r\n            </div>\r\n          </td>\r\n          <td class=\"col d-none d-md-block\">\r\n            <div>{{ getPlanYearText(sellingPermission) }}</div>\r\n          </td>\r\n          <td *ngIf=\"enableProducerIdColumn\" class=\"col d-none d-lg-block\">\r\n            <div>{{ sellingPermission.producerId }}</div>\r\n          </td>\r\n          <td class=\"col-1 text-right\" *ngIf=\"showRemoveCol\">\r\n            <span class=\"Spa_Style_Bold_Weight remove-row-button\" (click)=\"removeRow(pageStartIndex + i)\">\r\n              <i class=\"fas fa-times Spa_Style_Primary_Color\"></i>\r\n              <span class=\"sr-only\">Remove</span>\r\n            </span>\r\n          </td>\r\n        </tr>\r\n      </tbody>\r\n    </table>\r\n\r\n    <div class=\"w-100 Spa_Style_Small_Font text-center\" *ngIf=\"nonMappedPermissionPresent\">{{ mappedCarriersText }}</div>\r\n\r\n    <div\r\n      class=\"pagination-wrapper\"\r\n      [ngClass]=\"{ 'hide-pagination': !paginationEnabled || itemsPerPage >= formattedAgentPermissions?.length }\"\r\n    >\r\n      <vnext-pagination\r\n        [pagination]=\"formattedAgentPermissions\"\r\n        [defaultStartItem]=\"defaultStartItem\"\r\n        [itemsPerPage]=\"itemsPerPage\"\r\n        [paginationText]=\"paginationText\"\r\n        (updatePagination)=\"updateAgentDetails($event)\"\r\n      ></vnext-pagination></div\r\n  ></ng-container>\r\n  <ng-template #noPermissions>\r\n    <div *ngIf=\"hasAnyASPFilters; else noFilters\" class=\"w-100 d-flex flex-column no-permissions-section Spa_Style_Primary_Color\">\r\n      <div class=\"no-permissions-title Spa_Style_Large_Font font-weight-bold\" *liveEditProp=\"'Spa_Agent_NoPermissionsAfterFilters_Title'\">\r\n        {{ noPermissionsAfterFiltersTitle }}\r\n      </div>\r\n      <div class=\"no-permissions-message Spa_Style_Paragraph mb-2\" *liveEditProp=\"'Spa_Agent_NoPermissionsAfterFilters_Body'\">\r\n        {{ noPermissionsAfterFiltersBody }}\r\n      </div>\r\n    </div>\r\n    <ng-template #noFilters>\r\n      <div class=\"w-100 d-flex flex-column no-permissions-section Spa_Style_Primary_Color\">\r\n        <div class=\"no-permissions-seperator mb-5\"></div>\r\n        <i class=\"no-permissions-icon\" [ngClass]=\"noPermissionsIcon\" aria-hidden=\"true\"></i>\r\n        <div class=\"no-permissions-title Spa_Style_Large_Font font-weight-bold\" *liveEditProp=\"'Spa_Agent_NoPermissions_Title'\">\r\n          {{ noPermissionsTitle }}\r\n        </div>\r\n        <div class=\"no-permissions-message Spa_Style_Paragraph mb-2\" *liveEditProp=\"'Spa_Agent_NoPermissions_Body'\">\r\n          {{ noPermissionsBody }}\r\n        </div>\r\n        <div class=\"w-100 Spa_Style_Small_Font mt-4 text-center\" *ngIf=\"nonMappedPermissionPresent\">{{ mappedCarriersText }}</div>\r\n      </div>\r\n    </ng-template>\r\n  </ng-template>\r\n</div>\r\n", styles: [".pagination-wrapper{text-align:right;display:block;width:100%}.active-selling-permissions-table th[sortable]{cursor:pointer}.active-selling-permissions-table th[sortable]:after,.active-selling-permissions-table th[sortable].asc:after,.active-selling-permissions-table th[sortable].desc:after{content:\"\\f0de\";display:block;background:none;display:inline-block;margin-left:5px;font-family:\"Font Awesome 5 Pro\"}.active-selling-permissions-table th[sortable]:after{content:\"\\f0dc\"}.active-selling-permissions-table th[sortable].asc:after{content:\"\\f0dd\"}.active-selling-permissions-table th{display:flex;align-items:flex-end}.table.active-selling-permissions-table td,.table.active-selling-permissions-table th{float:left;word-wrap:break-word;word-break:break-all}th,td{border-left:none;border-right:none;border-top:none}.wrap-header-text{width:100%;display:inline-block;word-wrap:break-word;word-break:break-word}.column-flex{flex:0 0 13em}.remove-row-button{cursor:pointer}.no-permissions-section{text-align:center}.no-permissions-seperator{width:100%;border-top:2px solid var(--static-Spa_Style_Accent1)}.no-permissions-icon{font-size:72px;color:var(--static-Spa_Style_Gray2)}.no-permissions-title{margin-top:30px}.no-permissions-message{line-height:28px}.hide-pagination{display:none}@media (max-width: 767px){.pagination-wrapper{text-align:left}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.AgentService }, { type: i1.SNPService }, { type: i1.ASPFilterService }, { type: i1.PlanYearResourceService }]; }, { agentData: [{
            type: Input
        }], carriers: [{
            type: Input
        }], headerText: [{
            type: Input
        }], carrierHeader: [{
            type: Input
        }], stateHeader: [{
            type: Input
        }], planTypeHeader: [{
            type: Input
        }], planYearHeader: [{
            type: Input
        }], producerIdHeader: [{
            type: Input
        }], agentSellingPermissions: [{
            type: Input
        }], itemsPerPage: [{
            type: Input
        }], paginationText: [{
            type: Input
        }], paginationEnabled: [{
            type: Input
        }], enableProducerIdColumn: [{
            type: Input
        }], noPermissionsTitle: [{
            type: Input
        }], noPermissionsBody: [{
            type: Input
        }], noPermissionsIcon: [{
            type: Input
        }], noPermissionsAfterFiltersTitle: [{
            type: Input
        }], noPermissionsAfterFiltersBody: [{
            type: Input
        }], medSupAbbrev: [{
            type: Input
        }], ancillaryAbbrev: [{
            type: Input
        }], mappedCarriersText: [{
            type: Input
        }], noSNPText: [{
            type: Input
        }], notApplicableText: [{
            type: Input
        }], showRemoveCol: [{
            type: Input
        }], headers: [{
            type: ViewChildren,
            args: [NgbdSortableHeaderDirective]
        }] }); })();

function CheckboxDropdownComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "vnext-link", 11);
    i0.ɵɵlistener("click", function CheckboxDropdownComponent_div_6_Template_vnext_link_click_2_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.clearAll()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", ctx_r0.clearAllText)("alwaysUnderlined", true);
} }
function CheckboxDropdownComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "input", 13);
    i0.ɵɵlistener("click", function CheckboxDropdownComponent_div_7_Template_input_click_1_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.toggleAll()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("checked", ctx_r1.options.length === ctx_r1.selectedItems.length);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.selectAllText, " ");
} }
function CheckboxDropdownComponent_label_9_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 14)(1, "input", 15);
    i0.ɵɵlistener("click", function CheckboxDropdownComponent_label_9_Template_input_click_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r10); const option_r7 = restoredCtx.$implicit; const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.checkboxChange($event.target.checked, option_r7.value)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r7 = ctx.$implicit;
    const i_r8 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("for", "option-" + ctx_r2.fieldId + "-" + i_r8)("disabled", ctx_r2.disabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", "option-" + ctx_r2.fieldId + "-" + i_r8)("checked", ctx_r2.selectedItemsIndex(option_r7));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", option_r7.label, " ");
} }
const _c0$2S = function (a0, a1) { return { "has-error": a0, "disable-input": a1 }; };
const _c1$1v = function (a0, a1) { return { "can-click": a0, "d-none": a1 }; };
class CheckboxDropdownComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.ariaLabelledById = null;
        this.onSelect = new EventEmitter();
        this.selectedItems = [];
        this.onChanged = (items) => { };
        this.onTouched = () => { };
    }
    ngOnChanges(changes) {
        const { locale } = changes;
        if (locale && !locale.firstChange && locale.currentValue !== locale.previousValue) {
            this.setDisplayValue();
        }
    }
    ngOnInit() {
        this.setDisplayValue();
    }
    registerOnChange(fn) {
        this.onChanged = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    writeValue(value) {
        if (value && Array.isArray(value)) {
            this.selectedItems = value;
        }
        else {
            this.selectedItems = [];
        }
        this.setDisplayValue();
    }
    checkboxChange(checked, option) {
        if (checked) {
            this.selectedItems.push(option);
        }
        else {
            this.selectedItems = this.selectedItems.filter(item => item !== option);
        }
        this.selectItems();
    }
    toggleAll() {
        this.selectedItems = this.options.length === this.selectedItems.length ? [] : this.options.map(item => item.value);
        this.selectItems();
    }
    selectedItemsIndex(option) {
        return this.selectedItems.findIndex(item => item === option.value) >= 0;
    }
    clearAll() {
        this.selectedItems = [];
        this.selectItems();
    }
    getDisplayValue() {
        return this.selectedItemsDisplayTransform ? this.selectedItemsDisplayTransform(this.selectedItems) : null;
    }
    setDisplayValue() {
        this.displayValue = this.getDisplayValue();
        this.cdr.detectChanges();
    }
    selectItems() {
        this.setDisplayValue();
        this.onChanged(this.selectedItems);
        this.onSelect.emit(this.selectedItems);
    }
}
CheckboxDropdownComponent.ɵfac = function CheckboxDropdownComponent_Factory(t) { return new (t || CheckboxDropdownComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
CheckboxDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CheckboxDropdownComponent, selectors: [["vnext-checkbox-dropdown"]], inputs: { selectAllText: "selectAllText", hasError: "hasError", options: "options", placeholder: "placeholder", clearAllText: "clearAllText", submitted: "submitted", selectedItemsDisplayTransform: "selectedItemsDisplayTransform", disabled: "disabled", locale: "locale", ariaLabelledById: "ariaLabelledById", fieldId: "fieldId" }, outputs: { onSelect: "onSelect" }, features: [i0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => CheckboxDropdownComponent),
                multi: true
            }
        ]), i0.ɵɵNgOnChangesFeature], decls: 11, vars: 20, consts: [["placement", "bottom-left", "ngbDropdown", "", 1, "checkbox-dropdown", 3, "autoClose"], ["ngbDropdownToggle", "", "type", "text", 1, "form-control", "can-click", "checkbox-dropdown-input", 3, "placeholder", "ngClass", "readonly", "disabled", "value"], ["ngbDropdownToggle", "", 1, "fas", "fa-angle-down", "icon-in-input", "float-right", 3, "ngClass"], [1, "sr-only"], ["ngbDropdownMenu", ""], ["class", "d-flex justify-content-end", 4, "ngIf"], ["id", "selectAllLabelId", "class", "ml-2 can-click", 4, "ngIf"], [1, "mt-2"], ["ngbDropdownItem", "", "class", "can-click Spa_Style_Small_Font d-flex", 3, "for", "disabled", 4, "ngFor", "ngForOf"], [1, "d-flex", "justify-content-end"], [1, "mr-3"], [3, "title", "alwaysUnderlined", "click"], ["id", "selectAllLabelId", 1, "ml-2", "can-click"], ["type", "checkbox", "role", "checkbox", "aria-labelledby", "selectAllLabelId", 3, "checked", "click"], ["ngbDropdownItem", "", 1, "can-click", "Spa_Style_Small_Font", "d-flex", 3, "for", "disabled"], ["type", "checkbox", "role", "checkbox", 1, "checkbox", "mr-1", 3, "id", "checked", "click"]], template: function CheckboxDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "input", 1)(2, "i", 2);
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵtext(4, "Expand menu");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵtemplate(6, CheckboxDropdownComponent_div_6_Template, 3, 2, "div", 5);
        i0.ɵɵtemplate(7, CheckboxDropdownComponent_div_7_Template, 3, 2, "div", 6);
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵtemplate(9, CheckboxDropdownComponent_label_9_Template, 3, 5, "label", 8);
        i0.ɵɵpipe(10, "orderBy");
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵproperty("autoClose", "outside");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("placeholder", ctx.placeholder)("ngClass", i0.ɵɵpureFunction2(14, _c0$2S, ctx.hasError && ctx.submitted, ctx.disabled))("readonly", ctx.disabled)("disabled", ctx.disabled)("value", ctx.displayValue);
        i0.ɵɵattribute("aria-labelledby", ctx.ariaLabelledById);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(17, _c1$1v, !ctx.disabled, ctx.disabled));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.clearAllText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectAllText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(10, 11, ctx.options, "label"));
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem, OrderPipe], styles: [".clear-all-container[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{width:-moz-fit-content;width:fit-content}.icon-in-input[_ngcontent-%COMP%]{position:absolute;top:8px;left:calc(100% - 15px)}.disable-input[_ngcontent-%COMP%]{cursor:default}.checkbox[_ngcontent-%COMP%]{cursor:pointer}.checkbox-dropdown-input[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Primary)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckboxDropdownComponent, [{
        type: Component,
        args: [{ selector: 'vnext-checkbox-dropdown', providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => CheckboxDropdownComponent),
                        multi: true
                    }
                ], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div placement=\"bottom-left\" [autoClose]=\"'outside'\" class=\"checkbox-dropdown\" ngbDropdown>\r\n  <input\r\n    ngbDropdownToggle\r\n    type=\"text\"\r\n    class=\"form-control can-click checkbox-dropdown-input\"\r\n    [attr.aria-labelledby]=\"ariaLabelledById\"\r\n    [placeholder]=\"placeholder\"\r\n    [ngClass]=\"{ 'has-error': hasError && submitted, 'disable-input': disabled }\"\r\n    [readonly]=\"disabled\"\r\n    [disabled]=\"disabled\"\r\n    [value]=\"displayValue\"\r\n  />\r\n  <i class=\"fas fa-angle-down icon-in-input float-right\" ngbDropdownToggle [ngClass]=\"{ 'can-click': !disabled, 'd-none': disabled }\"></i>\r\n  <span class=\"sr-only\">Expand menu</span>\r\n  <div ngbDropdownMenu>\r\n    <div *ngIf=\"clearAllText\" class=\"d-flex justify-content-end\">\r\n      <div class=\"mr-3\">\r\n        <vnext-link [title]=\"clearAllText\" (click)=\"clearAll()\" [alwaysUnderlined]=\"true\"></vnext-link>\r\n      </div>\r\n    </div>\r\n    <div *ngIf=\"selectAllText\" id=\"selectAllLabelId\" class=\"ml-2 can-click\">\r\n      <input\r\n        type=\"checkbox\"\r\n        role=\"checkbox\"\r\n        aria-labelledby=\"selectAllLabelId\"\r\n        (click)=\"toggleAll()\"\r\n        [checked]=\"this.options.length === this.selectedItems.length\"\r\n      />\r\n      {{ selectAllText }}\r\n    </div>\r\n    <div class=\"mt-2\">\r\n      <label\r\n        *ngFor=\"let option of options | orderBy : 'label'; let i = index\"\r\n        ngbDropdownItem\r\n        class=\"can-click Spa_Style_Small_Font d-flex\"\r\n        [for]=\"'option-' + fieldId + '-' + i\"\r\n        [disabled]=\"disabled\"\r\n      >\r\n        <input\r\n          class=\"checkbox mr-1\"\r\n          type=\"checkbox\"\r\n          role=\"checkbox\"\r\n          [id]=\"'option-' + fieldId + '-' + i\"\r\n          [checked]=\"selectedItemsIndex(option)\"\r\n          (click)=\"checkboxChange($event.target.checked, option.value)\"\r\n        />\r\n        {{ option.label }}\r\n      </label>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".clear-all-container div{width:-moz-fit-content;width:fit-content}.icon-in-input{position:absolute;top:8px;left:calc(100% - 15px)}.disable-input{cursor:default}.checkbox{cursor:pointer}.checkbox-dropdown-input{color:var(--static-Spa_Style_Primary)}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { selectAllText: [{
            type: Input
        }], hasError: [{
            type: Input
        }], options: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], clearAllText: [{
            type: Input
        }], submitted: [{
            type: Input
        }], selectedItemsDisplayTransform: [{
            type: Input
        }], disabled: [{
            type: Input
        }], locale: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], fieldId: [{
            type: Input
        }], onSelect: [{
            type: Output
        }] }); })();

function AddAgentSellingPermissionsComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelement(1, "i", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.permissionTypeError, " ");
} }
function AddAgentSellingPermissionsComponent_div_12_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelement(1, "i", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.permissionPlanYearError, " ");
} }
const _c0$2R = function (a0) { return { Spa_Style_ErrorText: a0 }; };
function AddAgentSellingPermissionsComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, AddAgentSellingPermissionsComponent_div_12_div_1_Template, 3, 1, "div", 4);
    i0.ɵɵelementStart(2, "div")(3, "label", 31)(4, "span", 6);
    i0.ɵɵtext(5, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "vnext-toggle-select", 32);
    i0.ɵɵlistener("optionSelected", function AddAgentSellingPermissionsComponent_div_12_Template_vnext_toggle_select_optionSelected_7_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.onOptionSelect($event, ctx_r9.planYearFormName)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.submitted && ctx_r1.formErrors(ctx_r1.planYearFormName));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0$2R, ctx_r1.submitted && ctx_r1.formErrors(ctx_r1.planYearFormName)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.planYearHeader, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("items", ctx_r1.medicarePlanYearSelectionJsonItems)("buttonHeight", "36px")("selectedValue", ctx_r1.selectedYear)("largerText", true)("limitButtonWidth", true)("limitButtonWidthClass", "flex-wrap");
} }
function AddAgentSellingPermissionsComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelement(1, "i", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.permissionCarrierError, " ");
} }
function AddAgentSellingPermissionsComponent_div_28_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵlistener("click", function AddAgentSellingPermissionsComponent_div_28_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r13); const carrier_r11 = restoredCtx.$implicit; const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.selectCarrier(carrier_r11.label)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const carrier_r11 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", carrier_r11.label, " ");
} }
function AddAgentSellingPermissionsComponent_div_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelement(1, "i", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.permissionStatesError, " ");
} }
function AddAgentSellingPermissionsComponent_div_39_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelement(1, "i", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.permissionPlanTypeError, " ");
} }
function AddAgentSellingPermissionsComponent_div_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, AddAgentSellingPermissionsComponent_div_39_div_1_Template, 3, 1, "div", 4);
    i0.ɵɵelementStart(2, "div")(3, "label", 34)(4, "span", 6);
    i0.ɵɵtext(5, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 20);
    i0.ɵɵelement(8, "vnext-checkbox-dropdown", 35);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.submitted && ctx_r5.formErrors(ctx_r5.planTypeFormName));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c0$2R, ctx_r5.submitted && ctx_r5.formErrors(ctx_r5.planTypeFormName)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.planTypeHeader, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("selectAllText", ctx_r5.allPlanTypesOption)("formControlName", ctx_r5.planTypeFormName)("hasError", ctx_r5.formErrors(ctx_r5.planTypeFormName))("options", ctx_r5.planTypeControl)("placeholder", ctx_r5.planTypeInputPlaceholder)("submitted", ctx_r5.submitted)("fieldId", ctx_r5.planTypeFormName);
} }
function AddAgentSellingPermissionsComponent_div_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelement(1, "i", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.permissionProducerIDError, " ");
} }
function AddAgentSellingPermissionsComponent_div_48_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div")(2, "label", 36);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 20);
    i0.ɵɵelement(5, "vnext-checkbox-dropdown", 37);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$2R, ctx_r7.submitted && ctx_r7.formErrors(ctx_r7.snpFormName)));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.snpHeader, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("selectAllText", ctx_r7.allSnpOption)("formControlName", ctx_r7.snpFormName)("options", ctx_r7.snpControl)("placeholder", ctx_r7.snpInputPlaceholder)("submitted", ctx_r7.submitted)("fieldId", ctx_r7.snpFormName);
} }
const _c1$1u = function (a0) { return { Spa_Style_ErrorTextr: a0 }; };
const _c2$X = function (a0) { return { "has-error": a0 }; };
class AddAgentSellingPermissionsComponent {
    constructor(agentService, accountOverviewFacade, snpService) {
        this.agentService = agentService;
        this.accountOverviewFacade = accountOverviewFacade;
        this.snpService = snpService;
        this.closePopover = new EventEmitter();
        this.openPopover = new EventEmitter();
        this.errorMessages = [];
        this.planTypes = [PlanTypeAbbreviation.MA, PlanTypeAbbreviation.PDP, PlanTypeAbbreviation.MAPD];
        this.carrierControl = [];
        this.statesControl = [];
        this.planTypeControl = [];
        this.snpControl = [];
        this.permissionType = AccountAddPermissionsInputs.ADD_PERMISSION_TYPE;
        this.planYearFormName = AccountAddPermissionsInputs.ADD_PLAN_YEAR;
        this.carrierFormName = AccountAddPermissionsInputs.ADD_CARRIER;
        this.stateFormName = AccountAddPermissionsInputs.ADD_STATES;
        this.planTypeFormName = AccountAddPermissionsInputs.ADD_PLAN_TYPE;
        this.producerIdName = AccountAddPermissionsInputs.ADD_PRODUCER_ID;
        this.snpFormName = AccountAddPermissionsInputs.ADD_SNP;
        this.stateInputPlaceholder = '';
        this.planTypeInputPlaceholder = '';
        this.snpInputPlaceholder = '';
        this.producerIdNamePattern = FormValidationService.nonAlphaNumericPatternWithSpace;
        this.isMAPDSelected = false;
        this.isPlanTypePredefined = false;
        this.submitted = false;
        this.selectedValue = '';
    }
    ngOnInit() {
        this.setPlaceholders();
        this.newPermissionFormGroup = new UntypedFormGroup({
            [this.permissionType]: new UntypedFormControl(true, [Validators.required]),
            [this.planYearFormName]: new UntypedFormControl([], [Validators.required]),
            [this.carrierFormName]: new UntypedFormControl(''),
            [this.stateFormName]: new UntypedFormControl([]),
            [this.planTypeFormName]: new UntypedFormControl([]),
            [this.producerIdName]: new UntypedFormControl(''),
            [this.snpFormName]: new UntypedFormControl([])
        });
        this.newPermissionFormGroup.get(this.planTypeFormName).valueChanges.subscribe((values) => {
            const mapdIndex = this.planTypes.indexOf(PlanTypeAbbreviation.MAPD);
            this.isMAPDSelected = values?.indexOf(mapdIndex) >= 0;
        });
        const producerIdForm = this.newPermissionFormGroup.get(this.producerIdName);
        producerIdForm.valueChanges.subscribe((val) => {
            producerIdForm.setValue(val.replace(this.producerIdNamePattern, ''), { emitEvent: false });
        });
        this.setDropdownPlaceHolderOnChange(this.stateFormName, 'stateInputPlaceholder', 'editStatesText', 'selectStatesText');
        this.setDropdownPlaceHolderOnChange(this.planTypeFormName, 'planTypeInputPlaceholder', 'editPlanTypesText', 'selectPlanTypesText');
        this.setDropdownPlaceHolderOnChange(this.snpFormName, 'snpInputPlaceholder', 'editSnpText', 'selectSnpText');
        this.setValidationRequirement(this.carrierFormName, this.listOfFieldValidations[AccountAddPermissionsInputs.ADD_CARRIER].isRequired);
        this.setValidationRequirement(this.stateFormName, this.listOfFieldValidations[AccountAddPermissionsInputs.ADD_STATES].isRequired);
        this.setValidationRequirement(this.planTypeFormName, this.listOfFieldValidations[AccountAddPermissionsInputs.ADD_PLAN_TYPE].isRequired);
        this.setValidationRequirement(this.producerIdName, this.listOfFieldValidations[AccountAddPermissionsInputs.ADD_PRODUCER_ID].isRequired);
    }
    ngOnChanges(changes) {
        if (changes.carriers?.currentValue && !_isEqual(changes.carriers?.previousValue, changes.carriers?.currentValue)) {
            this.mapValues();
        }
        if (this.newPermissionFormGroup) {
            if (changes.editStatesText && changes.selectStatesText) {
                this.setDropdownPlaceHolder(this.newPermissionFormGroup.get(this.stateFormName).value, 'stateInputPlaceholder', changes.editStatesText.currentValue, changes.selectStatesText.currentValue);
            }
            if (changes.editPlanTypesText && changes.selectPlanTypesText) {
                this.setDropdownPlaceHolder(this.newPermissionFormGroup.get(this.planTypeFormName).value, 'planTypeInputPlaceholder', changes.editPlanTypesText.currentValue, changes.selectPlanTypesText.currentValue);
            }
            if (changes.editSnpText && changes.selectSnpText) {
                this.setDropdownPlaceHolder(this.newPermissionFormGroup.get(this.snpFormName).value, 'snpInputPlaceholder', changes.editSnpText.currentValue, changes.selectSnpText.currentValue);
            }
        }
    }
    setPlaceholders() {
        this.stateInputPlaceholder = this.selectStatesText;
        this.planTypeInputPlaceholder = this.selectPlanTypesText;
        this.snpInputPlaceholder = this.selectSnpText;
    }
    setDropdownPlaceHolderOnChange(form, placeholder, editText, selectText) {
        this.newPermissionFormGroup.get(form).valueChanges.subscribe((val) => {
            this.setDropdownPlaceHolder(val, placeholder, this[editText], this[selectText]);
        });
    }
    setDropdownPlaceHolder(values, placeholder, editText, selectText) {
        this[placeholder] = values?.length ? editText : selectText;
    }
    setValidationRequirement(formKey, required) {
        if (required) {
            this.newPermissionFormGroup.get(formKey).setValidators([Validators.required]);
        }
        else {
            this.newPermissionFormGroup.get(formKey).clearValidators();
        }
        this.newPermissionFormGroup.get(formKey).updateValueAndValidity();
    }
    formErrors(formKey) {
        return this.newPermissionFormGroup.get(formKey).errors;
    }
    onOptionSelect(toggleEvent, optionType) {
        if (toggleEvent.event.type === 'click') {
            let type = AccountAddPermissionsInputs.ADD_PLAN_YEAR;
            if (optionType === AccountAddPermissionsInputs.ADD_PERMISSION_TYPE) {
                type = AccountAddPermissionsInputs.ADD_PERMISSION_TYPE;
                this.isPlanTypePredefined = PREDEFINED_PERMISSION_PLAN.includes(toggleEvent.data.value);
                if (this.isPlanTypePredefined) {
                    this.predefinedPlan = toggleEvent.data.value;
                }
                this.changeFieldRequirement(this.isPlanTypePredefined);
            }
            else {
                this.selectedYear = toggleEvent.data.value;
            }
            const optionControl = this.newPermissionFormGroup.get(type);
            optionControl.setValue(toggleEvent.data.value);
        }
    }
    changeFieldRequirement(isPlanTypePredefined) {
        this.setValidationRequirement(this.planYearFormName, !isPlanTypePredefined);
        this.setValidationRequirement(this.planTypeFormName, !isPlanTypePredefined);
    }
    selectCarrier(carrier) {
        this.newPermissionFormGroup.get(this.carrierFormName).setValue(carrier);
    }
    mapValues() {
        const baseCheckBoxGroupItem = {
            disabled: false,
            initiallyChecked: false
        };
        this.carrierControl = this.carriers.map(carrier => ({ label: carrier.longName, value: carrier.carrierID, ...baseCheckBoxGroupItem }));
        this.statesControl = DemographicStates.map(state => ({ label: state.StateName, value: state.StateAbbrev, ...baseCheckBoxGroupItem }));
        this.planTypeControl = this.planTypes.map(planType => ({ label: planType, value: PlanType[planType], ...baseCheckBoxGroupItem }));
        this.snpControl = SNP_BASE_VALUES.map(snpValue => {
            const value = snpValue;
            const label = this.snpService.getSNPAbbreviation(snpValue);
            return { label, value, ...baseCheckBoxGroupItem };
        });
    }
    checkDuplicatedPermission(permission) {
        const { [AccountAddPermissionsInputs.ADD_CARRIER]: carrier, [AccountAddPermissionsInputs.ADD_STATES]: states, [AccountAddPermissionsInputs.ADD_PLAN_TYPE]: planTypes, [AccountAddPermissionsInputs.ADD_PLAN_YEAR]: planYear } = permission;
        return this.permissions.find(item => item.carrierId === carrier &&
            states.indexOf(item.stateAbbrev) >= 0 &&
            planTypes.indexOf(item.planTypeId) >= 0 &&
            `${item.planYear}` === `${planYear}`);
    }
    submitForm() {
        this.submitted = true;
        const form = this.newPermissionFormGroup.getRawValue();
        const carrier = form[this.carrierFormName];
        const { [this.permissionType]: permissionType, ...submittedForm } = form;
        const carrierId = this.carriers.find(item => item.longName === carrier)?.carrierID;
        const planYear = this.setPlanYear(form[this.planYearFormName]);
        const permission = {
            ...submittedForm,
            [this.planYearFormName]: planYear,
            [this.planTypeFormName]: this.isPlanTypePredefined ? [this.predefinedPlan] : submittedForm[this.planTypeFormName],
            [this.snpFormName]: this.isPlanTypePredefined ? [] : submittedForm[this.snpFormName],
            [this.carrierFormName]: carrierId
        };
        if (this.newPermissionFormGroup.valid) {
            if (this.checkDuplicatedPermission(permission)) {
                this.accountOverviewFacade.showDuplicatedPermissionModal(this.agentGuid, permission);
            }
            else {
                this.updateAgentSellingPermissions(permission);
            }
        }
    }
    updateAgentSellingPermissions(permission) {
        this.agentService.updateAgentSellingPermissions(this.agentGuid, permission);
    }
    close() {
        this.closePopover.emit();
    }
    setPlanYear(planYearValue) {
        if (this.isPlanTypePredefined) {
            return null;
        }
        if (this.medicarePlanYearSelectionJsonItems?.length) {
            return planYearValue;
        }
        this.setValidationRequirement(this.planYearFormName, false);
        return this.defaultPlanYear;
    }
}
AddAgentSellingPermissionsComponent.ɵfac = function AddAgentSellingPermissionsComponent_Factory(t) { return new (t || AddAgentSellingPermissionsComponent)(i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(AccountOverviewFacade), i0.ɵɵdirectiveInject(i1.SNPService)); };
AddAgentSellingPermissionsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AddAgentSellingPermissionsComponent, selectors: [["vnext-add-agent-selling-permissions"]], inputs: { agentGuid: "agentGuid", permissions: "permissions", sellingPermissionFormLink: "sellingPermissionFormLink", carriers: "carriers", permissionTypeError: "permissionTypeError", permissionPlanYearError: "permissionPlanYearError", permissionCarrierError: "permissionCarrierError", permissionStatesError: "permissionStatesError", permissionPlanTypeError: "permissionPlanTypeError", permissionProducerIDError: "permissionProducerIDError", permissionTypeHeader: "permissionTypeHeader", permissionMedicareToggleOptions: "permissionMedicareToggleOptions", medicarePlanYearSelectionJsonItems: "medicarePlanYearSelectionJsonItems", defaultPlanYear: "defaultPlanYear", planYearHeader: "planYearHeader", carrierHeader: "carrierHeader", statesHeader: "statesHeader", planTypeHeader: "planTypeHeader", snpHeader: "snpHeader", producerIdHeader: "producerIdHeader", permissionButton: "permissionButton", allStatesOption: "allStatesOption", allPlanTypesOption: "allPlanTypesOption", allSnpOption: "allSnpOption", selectCarrierText: "selectCarrierText", selectStatesText: "selectStatesText", editStatesText: "editStatesText", selectPlanTypesText: "selectPlanTypesText", editPlanTypesText: "editPlanTypesText", selectSnpText: "selectSnpText", editSnpText: "editSnpText", listOfFieldValidations: "listOfFieldValidations", clearAllText: "clearAllText" }, outputs: { closePopover: "closePopover", openPopover: "openPopover" }, features: [i0.ɵɵNgOnChangesFeature], decls: 53, vars: 55, consts: [[1, "Spa_Style_Primary_Color", "container", "form-group", 3, "formGroup"], [1, "row"], [1, "fal", "fa-times", "font-weight-bold", "can-click", "col-lg-1", "d-lg-none", "d-xl-none", 3, "click"], [1, "col-lg-6", "input-container", "toggle"], ["class", "Spa_Style_ErrorText", "role", "alert", 4, "ngIf"], [1, "Spa_Style_Small_Font", "Spa_Style_Semi_Bold_Weight", "text-break", 3, "ngClass"], [1, "input-error-asterisk"], [3, "items", "buttonHeight", "largerText", "selectFirstItemAsDefaultActiveValue", "limitButtonWidth", "limitButtonWidthClass", "optionSelected"], [1, "col-lg-5"], ["class", "input-container toggle", 4, "ngIf"], [1, "fal", "fa-times", "font-weight-bold", "can-click", "col-lg-1", "d-none", "d-lg-block", 3, "click"], [1, "input-container", "col-lg-3"], ["for", "carrierFormName", 1, "Spa_Style_Small_Font", "Spa_Style_Semi_Bold_Weight", 3, "ngClass"], ["ngbDropdown", "", 1, "position-relative"], ["ngbDropdownToggle", "", "readonly", "", "id", "carrierFormName", "type", "text", "tabindex", "0", 1, "form-control", "can-click", "no-translate-block", 3, "placeholder", "formControlName", "ngClass"], ["ngbDropdownToggle", "", 1, "fas", "fa-angle-down", "icon-in-input", "can-click", "float-right"], [1, "sr-only"], ["ngbDropdownMenu", ""], ["class", "Spa_Style_Small_Font no-translate-block", "ngbDropdownItem", "", 3, "click", 4, "ngFor", "ngForOf"], ["id", "statesLabelId", 1, "Spa_Style_Small_Font", "Spa_Style_Semi_Bold_Weight", 3, "ngClass"], [1, "position-relative"], ["ariaLabelledById", "statesLabelId", 3, "selectAllText", "formControlName", "hasError", "options", "clearAllText", "placeholder", "submitted", "fieldId"], ["class", "input-container col-lg-3", 4, "ngIf"], [1, "Spa_Style_Small_Font", "Spa_Style_Semi_Bold_Weight", 3, "for", "ngClass"], ["type", "text", "maxlength", "50", 1, "Spa_Style_Smaller_Font", "form-control", 3, "id", "ngClass", "formControlName"], [1, "row", "justify-content-end"], [1, "col-lg-3"], ["type", "submit", 1, "btn", "col-lg-12", "Spa_Style_PrimaryButton", 3, "click"], ["role", "alert", 1, "Spa_Style_ErrorText"], ["aria-hidden", "true", 1, "fa", "fa-exclamation-circle", "mr-1"], [1, "input-container", "toggle"], [1, "Spa_Style_Small_Font", "Spa_Style_Semi_Bold_Weight", 3, "ngClass"], [3, "items", "buttonHeight", "selectedValue", "largerText", "limitButtonWidth", "limitButtonWidthClass", "optionSelected"], ["ngbDropdownItem", "", 1, "Spa_Style_Small_Font", "no-translate-block", 3, "click"], ["id", "planTypeLabelId", 1, "Spa_Style_Small_Font", "Spa_Style_Semi_Bold_Weight", 3, "ngClass"], ["ariaLabelledById", "planTypeLabelId", 3, "selectAllText", "formControlName", "hasError", "options", "placeholder", "submitted", "fieldId"], ["id", "snpLabelId", 1, "Spa_Style_Small_Font", "Spa_Style_Semi_Bold_Weight", 3, "ngClass"], ["ariaLabelledById", "snpLabelId", 3, "selectAllText", "formControlName", "options", "placeholder", "submitted", "fieldId"]], template: function AddAgentSellingPermissionsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "i", 2);
        i0.ɵɵlistener("click", function AddAgentSellingPermissionsComponent_Template_i_click_2_listener() { return ctx.close(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, AddAgentSellingPermissionsComponent_div_4_Template, 3, 1, "div", 4);
        i0.ɵɵelementStart(5, "div")(6, "label", 5)(7, "span", 6);
        i0.ɵɵtext(8, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "vnext-toggle-select", 7);
        i0.ɵɵlistener("optionSelected", function AddAgentSellingPermissionsComponent_Template_vnext_toggle_select_optionSelected_10_listener($event) { return ctx.onOptionSelect($event, ctx.permissionType); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵtemplate(12, AddAgentSellingPermissionsComponent_div_12_Template, 8, 11, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "i", 10);
        i0.ɵɵlistener("click", function AddAgentSellingPermissionsComponent_Template_i_click_13_listener() { return ctx.close(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(14, "div", 1)(15, "div", 11);
        i0.ɵɵtemplate(16, AddAgentSellingPermissionsComponent_div_16_Template, 3, 1, "div", 4);
        i0.ɵɵelementStart(17, "div")(18, "label", 12)(19, "span", 6);
        i0.ɵɵtext(20, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 13);
        i0.ɵɵelement(23, "input", 14)(24, "i", 15);
        i0.ɵɵelementStart(25, "span", 16);
        i0.ɵɵtext(26, "Expand menu");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "div", 17);
        i0.ɵɵtemplate(28, AddAgentSellingPermissionsComponent_div_28_Template, 2, 1, "div", 18);
        i0.ɵɵpipe(29, "orderBy");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(30, "div", 11);
        i0.ɵɵtemplate(31, AddAgentSellingPermissionsComponent_div_31_Template, 3, 1, "div", 4);
        i0.ɵɵelementStart(32, "div")(33, "label", 19)(34, "span", 6);
        i0.ɵɵtext(35, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(36);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(37, "div", 20);
        i0.ɵɵelement(38, "vnext-checkbox-dropdown", 21);
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(39, AddAgentSellingPermissionsComponent_div_39_Template, 9, 12, "div", 22);
        i0.ɵɵelementStart(40, "div", 11);
        i0.ɵɵtemplate(41, AddAgentSellingPermissionsComponent_div_41_Template, 3, 1, "div", 4);
        i0.ɵɵelementStart(42, "div")(43, "label", 23)(44, "span", 6);
        i0.ɵɵtext(45, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(46);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(47, "input", 24);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(48, AddAgentSellingPermissionsComponent_div_48_Template, 6, 10, "div", 22);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(49, "div", 25)(50, "div", 26)(51, "button", 27);
        i0.ɵɵlistener("click", function AddAgentSellingPermissionsComponent_Template_button_click_51_listener() { return ctx.submitForm(); });
        i0.ɵɵtext(52);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.newPermissionFormGroup);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.submitted && ctx.formErrors(ctx.permissionType));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(43, _c0$2R, ctx.submitted && ctx.formErrors(ctx.permissionType)));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.permissionTypeHeader, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("items", ctx.permissionMedicareToggleOptions)("buttonHeight", "36px")("largerText", true)("selectFirstItemAsDefaultActiveValue", true)("limitButtonWidth", true)("limitButtonWidthClass", "flex-wrap");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isPlanTypePredefined && (ctx.medicarePlanYearSelectionJsonItems == null ? null : ctx.medicarePlanYearSelectionJsonItems.length));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.submitted && ctx.formErrors(ctx.carrierFormName));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(45, _c1$1u, ctx.submitted && ctx.formErrors(ctx.carrierFormName)));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.carrierHeader, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("placeholder", ctx.selectCarrierText)("formControlName", ctx.carrierFormName)("ngClass", i0.ɵɵpureFunction1(47, _c2$X, ctx.submitted && ctx.formErrors(ctx.carrierFormName)));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(29, 40, ctx.carrierControl, "label"));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.submitted && ctx.formErrors(ctx.stateFormName));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(49, _c0$2R, ctx.submitted && ctx.formErrors(ctx.stateFormName)));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.statesHeader, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("selectAllText", ctx.allStatesOption)("formControlName", ctx.stateFormName)("hasError", ctx.formErrors(ctx.stateFormName))("options", ctx.statesControl)("clearAllText", ctx.clearAllText)("placeholder", ctx.stateInputPlaceholder)("submitted", ctx.submitted)("fieldId", ctx.stateFormName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isPlanTypePredefined);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.submitted && ctx.formErrors(ctx.producerIdName));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("for", ctx.producerIdName)("ngClass", i0.ɵɵpureFunction1(51, _c0$2R, ctx.submitted && ctx.formErrors(ctx.producerIdName)));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.producerIdHeader, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("id", ctx.producerIdName)("ngClass", i0.ɵɵpureFunction1(53, _c2$X, ctx.submitted && ctx.formErrors(ctx.producerIdName)))("formControlName", ctx.producerIdName);
        i0.ɵɵattribute("aria-labelledby", ctx.producerIdName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isMAPDSelected && !ctx.isPlanTypePredefined);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.permissionButton, " ");
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.MaxLengthValidator, i4.FormGroupDirective, i4.FormControlName, ToggleSelectComponent, IconAriaAttributesDirective, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem, CheckboxDropdownComponent, OrderPipe], styles: ["i.fal.fa-times[_ngcontent-%COMP%]{text-align:right}.row[_ngcontent-%COMP%]{margin-top:15px}.icon-in-input[_ngcontent-%COMP%]{position:absolute;top:8px;left:calc(100% - 15px)}.close-button-container[_ngcontent-%COMP%]{position:absolute;top:0;right:0}.input-container[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;flex-direction:column;height:90px}.container[_ngcontent-%COMP%]{padding-left:0;padding-right:0}@media (max-width: 576px){.input-container.toggle[_ngcontent-%COMP%]{height:max-content}.input-container.toggle[_ngcontent-%COMP%]:last-child{margin-top:16px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddAgentSellingPermissionsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-add-agent-selling-permissions', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"Spa_Style_Primary_Color container form-group\" [formGroup]=\"newPermissionFormGroup\">\r\n  <div class=\"row\">\r\n    <i class=\"fal fa-times font-weight-bold can-click col-lg-1 d-lg-none d-xl-none\" (click)=\"close()\"></i>\r\n    <div class=\"col-lg-6 input-container toggle\">\r\n      <div class=\"Spa_Style_ErrorText\" *ngIf=\"submitted && formErrors(permissionType)\" role=\"alert\">\r\n        <i aria-hidden=\"true\" class=\"fa fa-exclamation-circle mr-1\"></i>\r\n        {{ permissionTypeError }}\r\n      </div>\r\n      <div>\r\n        <label\r\n          class=\"Spa_Style_Small_Font Spa_Style_Semi_Bold_Weight text-break\"\r\n          [ngClass]=\"{ Spa_Style_ErrorText: submitted && formErrors(permissionType) }\"\r\n        >\r\n          <span class=\"input-error-asterisk\">*</span> {{ permissionTypeHeader }}\r\n        </label>\r\n        <vnext-toggle-select\r\n          [items]=\"permissionMedicareToggleOptions\"\r\n          [buttonHeight]=\"'36px'\"\r\n          (optionSelected)=\"onOptionSelect($event, permissionType)\"\r\n          [largerText]=\"true\"\r\n          [selectFirstItemAsDefaultActiveValue]=\"true\"\r\n          [limitButtonWidth]=\"true\"\r\n          [limitButtonWidthClass]=\"'flex-wrap'\"\r\n        >\r\n        </vnext-toggle-select>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"col-lg-5\">\r\n      <div *ngIf=\"!isPlanTypePredefined && medicarePlanYearSelectionJsonItems?.length\" class=\"input-container toggle\">\r\n        <div class=\"Spa_Style_ErrorText\" *ngIf=\"submitted && formErrors(planYearFormName)\" role=\"alert\">\r\n          <i aria-hidden=\"true\" class=\"fa fa-exclamation-circle mr-1\"></i>\r\n          {{ permissionPlanYearError }}\r\n        </div>\r\n        <div>\r\n          <label\r\n            class=\"Spa_Style_Small_Font Spa_Style_Semi_Bold_Weight\"\r\n            [ngClass]=\"{ Spa_Style_ErrorText: submitted && formErrors(planYearFormName) }\"\r\n          >\r\n            <span class=\"input-error-asterisk\">*</span> {{ planYearHeader }}\r\n          </label>\r\n          <vnext-toggle-select\r\n            [items]=\"medicarePlanYearSelectionJsonItems\"\r\n            [buttonHeight]=\"'36px'\"\r\n            (optionSelected)=\"onOptionSelect($event, planYearFormName)\"\r\n            [selectedValue]=\"selectedYear\"\r\n            [largerText]=\"true\"\r\n            [limitButtonWidth]=\"true\"\r\n            [limitButtonWidthClass]=\"'flex-wrap'\"\r\n          >\r\n          </vnext-toggle-select>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <i class=\"fal fa-times font-weight-bold can-click col-lg-1 d-none d-lg-block\" (click)=\"close()\"></i>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"input-container col-lg-3\">\r\n      <div class=\"Spa_Style_ErrorText\" *ngIf=\"submitted && formErrors(carrierFormName)\" role=\"alert\">\r\n        <i aria-hidden=\"true\" class=\"fa fa-exclamation-circle mr-1\"></i>\r\n        {{ permissionCarrierError }}\r\n      </div>\r\n      <div>\r\n        <label\r\n          class=\"Spa_Style_Small_Font Spa_Style_Semi_Bold_Weight\"\r\n          for=\"carrierFormName\"\r\n          [ngClass]=\"{ Spa_Style_ErrorTextr: submitted && formErrors(carrierFormName) }\"\r\n        >\r\n          <span class=\"input-error-asterisk\">*</span> {{ carrierHeader }}\r\n        </label>\r\n        <div class=\"position-relative\" ngbDropdown>\r\n          <input\r\n            ngbDropdownToggle\r\n            readonly\r\n            id=\"carrierFormName\"\r\n            type=\"text\"\r\n            tabindex=\"0\"\r\n            class=\"form-control can-click no-translate-block\"\r\n            [placeholder]=\"selectCarrierText\"\r\n            [formControlName]=\"carrierFormName\"\r\n            [ngClass]=\"{ 'has-error': submitted && formErrors(carrierFormName) }\"\r\n          />\r\n          <i class=\"fas fa-angle-down icon-in-input can-click float-right\" ngbDropdownToggle></i>\r\n          <span class=\"sr-only\">Expand menu</span>\r\n          <div ngbDropdownMenu>\r\n            <div\r\n              *ngFor=\"let carrier of carrierControl | orderBy : 'label'\"\r\n              class=\"Spa_Style_Small_Font no-translate-block\"\r\n              (click)=\"selectCarrier(carrier.label)\"\r\n              ngbDropdownItem\r\n            >\r\n              {{ carrier.label }}\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"input-container col-lg-3\">\r\n      <div class=\"Spa_Style_ErrorText\" *ngIf=\"submitted && formErrors(stateFormName)\" role=\"alert\">\r\n        <i aria-hidden=\"true\" class=\"fa fa-exclamation-circle mr-1\"></i>\r\n        {{ permissionStatesError }}\r\n      </div>\r\n      <div>\r\n        <label\r\n          id=\"statesLabelId\"\r\n          class=\"Spa_Style_Small_Font Spa_Style_Semi_Bold_Weight\"\r\n          [ngClass]=\"{ Spa_Style_ErrorText: submitted && formErrors(stateFormName) }\"\r\n        >\r\n          <span class=\"input-error-asterisk\">*</span> {{ statesHeader }}\r\n        </label>\r\n        <div class=\"position-relative\">\r\n          <vnext-checkbox-dropdown\r\n            ariaLabelledById=\"statesLabelId\"\r\n            [selectAllText]=\"allStatesOption\"\r\n            [formControlName]=\"stateFormName\"\r\n            [hasError]=\"formErrors(stateFormName)\"\r\n            [options]=\"statesControl\"\r\n            [clearAllText]=\"clearAllText\"\r\n            [placeholder]=\"stateInputPlaceholder\"\r\n            [submitted]=\"submitted\"\r\n            [fieldId]=\"stateFormName\"\r\n          ></vnext-checkbox-dropdown>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"input-container col-lg-3\" *ngIf=\"!isPlanTypePredefined\">\r\n      <div class=\"Spa_Style_ErrorText\" *ngIf=\"submitted && formErrors(planTypeFormName)\" role=\"alert\">\r\n        <i aria-hidden=\"true\" class=\"fa fa-exclamation-circle mr-1\"></i>\r\n        {{ permissionPlanTypeError }}\r\n      </div>\r\n      <div>\r\n        <label\r\n          id=\"planTypeLabelId\"\r\n          class=\"Spa_Style_Small_Font Spa_Style_Semi_Bold_Weight\"\r\n          [ngClass]=\"{ Spa_Style_ErrorText: submitted && formErrors(planTypeFormName) }\"\r\n        >\r\n          <span class=\"input-error-asterisk\">*</span> {{ planTypeHeader }}\r\n        </label>\r\n        <div class=\"position-relative\">\r\n          <vnext-checkbox-dropdown\r\n            ariaLabelledById=\"planTypeLabelId\"\r\n            [selectAllText]=\"allPlanTypesOption\"\r\n            [formControlName]=\"planTypeFormName\"\r\n            [hasError]=\"formErrors(planTypeFormName)\"\r\n            [options]=\"planTypeControl\"\r\n            [placeholder]=\"planTypeInputPlaceholder\"\r\n            [submitted]=\"submitted\"\r\n            [fieldId]=\"planTypeFormName\"\r\n          ></vnext-checkbox-dropdown>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"input-container col-lg-3\">\r\n      <div class=\"Spa_Style_ErrorText\" *ngIf=\"submitted && formErrors(producerIdName)\" role=\"alert\">\r\n        <i aria-hidden=\"true\" class=\"fa fa-exclamation-circle mr-1\"></i>\r\n        {{ permissionProducerIDError }}\r\n      </div>\r\n      <div>\r\n        <label\r\n          class=\"Spa_Style_Small_Font Spa_Style_Semi_Bold_Weight\"\r\n          [for]=\"producerIdName\"\r\n          [ngClass]=\"{ Spa_Style_ErrorText: submitted && formErrors(producerIdName) }\"\r\n        >\r\n          <span class=\"input-error-asterisk\">*</span> {{ producerIdHeader }}\r\n        </label>\r\n        <input\r\n          type=\"text\"\r\n          maxlength=\"50\"\r\n          class=\"Spa_Style_Smaller_Font form-control\"\r\n          [id]=\"producerIdName\"\r\n          [ngClass]=\"{ 'has-error': submitted && formErrors(producerIdName) }\"\r\n          [formControlName]=\"producerIdName\"\r\n          [attr.aria-labelledby]=\"producerIdName\"\r\n        />\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"input-container col-lg-3\" *ngIf=\"isMAPDSelected && !isPlanTypePredefined\">\r\n      <div>\r\n        <label\r\n          id=\"snpLabelId\"\r\n          class=\"Spa_Style_Small_Font Spa_Style_Semi_Bold_Weight\"\r\n          [ngClass]=\"{ Spa_Style_ErrorText: submitted && formErrors(snpFormName) }\"\r\n        >\r\n          {{ snpHeader }}\r\n        </label>\r\n        <div class=\"position-relative\">\r\n          <vnext-checkbox-dropdown\r\n            ariaLabelledById=\"snpLabelId\"\r\n            [selectAllText]=\"allSnpOption\"\r\n            [formControlName]=\"snpFormName\"\r\n            [options]=\"snpControl\"\r\n            [placeholder]=\"snpInputPlaceholder\"\r\n            [submitted]=\"submitted\"\r\n            [fieldId]=\"snpFormName\"\r\n          ></vnext-checkbox-dropdown>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row justify-content-end\">\r\n    <div class=\"col-lg-3\">\r\n      <button class=\"btn col-lg-12 Spa_Style_PrimaryButton\" type=\"submit\" (click)=\"submitForm()\">\r\n        {{ permissionButton }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: ["i.fal.fa-times{text-align:right}.row{margin-top:15px}.icon-in-input{position:absolute;top:8px;left:calc(100% - 15px)}.close-button-container{position:absolute;top:0;right:0}.input-container{display:flex;justify-content:flex-end;flex-direction:column;height:90px}.container{padding-left:0;padding-right:0}@media (max-width: 576px){.input-container.toggle{height:max-content}.input-container.toggle:last-child{margin-top:16px}}\n"] }]
    }], function () { return [{ type: i1.AgentService }, { type: AccountOverviewFacade }, { type: i1.SNPService }]; }, { agentGuid: [{
            type: Input
        }], permissions: [{
            type: Input
        }], sellingPermissionFormLink: [{
            type: Input
        }], carriers: [{
            type: Input
        }], permissionTypeError: [{
            type: Input
        }], permissionPlanYearError: [{
            type: Input
        }], permissionCarrierError: [{
            type: Input
        }], permissionStatesError: [{
            type: Input
        }], permissionPlanTypeError: [{
            type: Input
        }], permissionProducerIDError: [{
            type: Input
        }], permissionTypeHeader: [{
            type: Input
        }], permissionMedicareToggleOptions: [{
            type: Input
        }], medicarePlanYearSelectionJsonItems: [{
            type: Input
        }], defaultPlanYear: [{
            type: Input
        }], planYearHeader: [{
            type: Input
        }], carrierHeader: [{
            type: Input
        }], statesHeader: [{
            type: Input
        }], planTypeHeader: [{
            type: Input
        }], snpHeader: [{
            type: Input
        }], producerIdHeader: [{
            type: Input
        }], permissionButton: [{
            type: Input
        }], allStatesOption: [{
            type: Input
        }], allPlanTypesOption: [{
            type: Input
        }], allSnpOption: [{
            type: Input
        }], selectCarrierText: [{
            type: Input
        }], selectStatesText: [{
            type: Input
        }], editStatesText: [{
            type: Input
        }], selectPlanTypesText: [{
            type: Input
        }], editPlanTypesText: [{
            type: Input
        }], selectSnpText: [{
            type: Input
        }], editSnpText: [{
            type: Input
        }], listOfFieldValidations: [{
            type: Input
        }], clearAllText: [{
            type: Input
        }], closePopover: [{
            type: Output
        }], openPopover: [{
            type: Output
        }] }); })();

function FilterSellingPermissionsComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "vnext-checkbox-group", 13);
    i0.ɵɵlistener("change", function FilterSellingPermissionsComponent_div_23_Template_vnext_checkbox_group_change_3_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onFilterSelected(ctx_r1.planYearControlName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.planYearHeader);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r0.planYearControlName);
    i0.ɵɵproperty("items", ctx_r0.planYearFilterControls)("enableNoteStyle", false)("customClass", "no-left-offset")("parentId", ctx_r0.checkboxId);
} }
class FilterSellingPermissionsComponent {
    constructor(aspFilterService, cdr, clearInputService, localeService) {
        this.aspFilterService = aspFilterService;
        this.cdr = cdr;
        this.clearInputService = clearInputService;
        this.localeService = localeService;
        this.closePopover = new EventEmitter();
        this.checkboxId = 'filterPermissionsCheckboxes';
        this.subscriptions = [];
    }
    close() {
        this.closePopover.emit(false);
    }
    ngOnInit() {
        this.filterForm = this.aspFilterService.getFilterForm();
        this.filterFormTypes = this.aspFilterService.getFilterFormTypes();
        this.initControls();
        this.carrierFilterControls$ = this.aspFilterService.getASPCarrierFilterControls$().pipe(map((carriers) => {
            return carriers.sort((x, y) => {
                return x.label.localeCompare(y.label);
            });
        }));
        this.stateFilterControls = this.aspFilterService.getASPStateFilterControls();
        this.planTypeFilterControls = this.aspFilterService.getASPPlanTypeFilterControls();
        this.planYearFilterControls = this.aspFilterService.getASPPlanYearFilterControls();
        this.snpTypeFilterControls = this.aspFilterService.getASPSNPFilterControls();
        this.subscriptions = [
            this.localeService.getCurrentLocale$().subscribe(locale => {
                this.initControls();
                this.cdr.markForCheck();
            })
        ];
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    initControls() {
        this.carrierControlName = this.aspFilterService.getASPCarrierControlName();
        this.stateControlName = this.aspFilterService.getASPStateFilterControlName();
        this.planTypeControlName = this.aspFilterService.getASPPlanTypeFilterControlName();
        this.planYearControlName = this.aspFilterService.getASPPlanYearFilterControlName();
        this.snpTypeControlName = this.aspFilterService.getASPSNPFilterControlName();
    }
    onFilterSelected(controlName) {
        // selected filter is every value for that checkbox group
        let selectedFilter = this.filterForm.value[controlName];
        if (controlName === this.planYearControlName) {
            selectedFilter = selectedFilter.map(value => parseInt(`${value}`, 0));
        }
        if (selectedFilter?.length > 0) {
            let defaultValue; // intentionally here and blank to remain undefined for default filter behavior
            let comparator = selectedFilter.length > 1 ? ComparatorType.IN : ComparatorType.EQUAL;
            if (controlName === this.snpTypeControlName) {
                comparator = ComparatorType.IN_ARRAY;
                defaultValue = false;
            }
            this.aspFilterService.addFilterToASPFilterGroups(new Filter({
                key: this.filterFormTypes[controlName],
                values: selectedFilter,
                comparator,
                defaultReturnValue: defaultValue
            }));
        }
        else {
            this.aspFilterService.clearASPFilterWithKey(this.filterFormTypes[controlName]);
        }
    }
    clearAllFilters() {
        this.aspFilterService.clearASPFilterGroupFilter();
        this.filterForm.reset();
        this.clearInputService.clearInputById(this.checkboxId);
        this.cdr.markForCheck();
    }
    viewPermissions() {
        this.closePopover.emit(true);
    }
}
FilterSellingPermissionsComponent.ɵfac = function FilterSellingPermissionsComponent_Factory(t) { return new (t || FilterSellingPermissionsComponent)(i0.ɵɵdirectiveInject(i1.ASPFilterService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.InputResetContextService), i0.ɵɵdirectiveInject(i1.LocaleService)); };
FilterSellingPermissionsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FilterSellingPermissionsComponent, selectors: [["vnext-filter-selling-permissions"]], inputs: { applyText: "applyText", planYearHeader: "planYearHeader", carrierHeader: "carrierHeader", statesHeader: "statesHeader", planTypeHeader: "planTypeHeader", clearAllText: "clearAllText", viewPermissionsText: "viewPermissionsText", yearSelectionEnabled: "yearSelectionEnabled" }, outputs: { closePopover: "closePopover" }, decls: 27, vars: 33, consts: [[1, "filter-selling-permissions"], [1, "clear-all-container", "d-flex", "mb-3", "justify-content-end"], [1, "clear-all-link", "pr-5"], [3, "title", "alwaysUnderlined", "click"], [1, "close-button", "can-click", "Spa_Style_Primary_Color", 3, "click"], [1, "fa", "fa-times"], [3, "formGroup"], [1, "row"], [1, "col-6", "col-md-3"], [1, "Spa_Style_Primary_Color", "Spa_Style_Bold_Weight", "pb-2"], [1, "plan-filter-items", 3, "items", "formControlName", "enableNoteStyle", "customClass", "scrollable", "parentId", "noTranslateBlock", "change"], [1, "plan-filter-items", 3, "items", "formControlName", "enableNoteStyle", "customClass", "scrollable", "parentId", "change"], [1, "col-6", "col-md-3", "pt-3", "pt-md-0"], [1, "plan-filter-items", 3, "items", "formControlName", "enableNoteStyle", "customClass", "parentId", "change"], [1, "snp-section", "ml-2"], ["class", "col-6 col-md-3 pt-3 pt-md-0", 4, "ngIf"], [1, "view-button-container", "d-flex", "justify-content-end"], [1, "btn", "Spa_Style_PrimaryButton", 3, "click"]], template: function FilterSellingPermissionsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "vnext-link", 3);
        i0.ɵɵlistener("click", function FilterSellingPermissionsComponent_Template_vnext_link_click_3_listener() { return ctx.clearAllFilters(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵlistener("click", function FilterSellingPermissionsComponent_Template_div_click_4_listener() { return ctx.close(); });
        i0.ɵɵelement(5, "i", 5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "form", 6)(7, "div", 7)(8, "div", 8)(9, "div", 9);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "vnext-checkbox-group", 10);
        i0.ɵɵlistener("change", function FilterSellingPermissionsComponent_Template_vnext_checkbox_group_change_11_listener() { return ctx.onFilterSelected(ctx.carrierControlName); });
        i0.ɵɵpipe(12, "async");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "div", 8)(14, "div", 9);
        i0.ɵɵtext(15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "vnext-checkbox-group", 11);
        i0.ɵɵlistener("change", function FilterSellingPermissionsComponent_Template_vnext_checkbox_group_change_16_listener() { return ctx.onFilterSelected(ctx.stateControlName); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(17, "div", 12)(18, "div", 9);
        i0.ɵɵtext(19);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "vnext-checkbox-group", 13);
        i0.ɵɵlistener("change", function FilterSellingPermissionsComponent_Template_vnext_checkbox_group_change_20_listener() { return ctx.onFilterSelected(ctx.planTypeControlName); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div", 14)(22, "vnext-checkbox-group", 13);
        i0.ɵɵlistener("change", function FilterSellingPermissionsComponent_Template_vnext_checkbox_group_change_22_listener() { return ctx.onFilterSelected(ctx.snpTypeControlName); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(23, FilterSellingPermissionsComponent_div_23_Template, 4, 6, "div", 15);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(24, "div", 16)(25, "button", 17);
        i0.ɵɵlistener("click", function FilterSellingPermissionsComponent_Template_button_click_25_listener() { return ctx.viewPermissions(); });
        i0.ɵɵtext(26);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("title", ctx.clearAllText)("alwaysUnderlined", true);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("formGroup", ctx.filterForm);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.carrierHeader);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("formControlName", ctx.carrierControlName);
        i0.ɵɵproperty("items", i0.ɵɵpipeBind1(12, 31, ctx.carrierFilterControls$))("enableNoteStyle", false)("customClass", "no-left-offset")("scrollable", true)("parentId", ctx.checkboxId)("noTranslateBlock", true);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.statesHeader);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("formControlName", ctx.stateControlName);
        i0.ɵɵproperty("items", ctx.stateFilterControls)("enableNoteStyle", false)("customClass", "no-left-offset")("scrollable", true)("parentId", ctx.checkboxId);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.planTypeHeader);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("formControlName", ctx.planTypeControlName);
        i0.ɵɵproperty("items", ctx.planTypeFilterControls)("enableNoteStyle", false)("customClass", "no-left-offset")("parentId", ctx.checkboxId);
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate("formControlName", ctx.snpTypeControlName);
        i0.ɵɵproperty("items", ctx.snpTypeFilterControls)("enableNoteStyle", false)("customClass", "no-left-offset")("parentId", ctx.checkboxId);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.yearSelectionEnabled);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.viewPermissionsText);
    } }, dependencies: [i1$2.NgIf, i4.ɵNgNoValidate, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, CheckboxGroupComponent, LinkComponent, IconAriaAttributesDirective, i1$2.AsyncPipe], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterSellingPermissionsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-filter-selling-permissions', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"filter-selling-permissions\">\r\n  <div class=\"clear-all-container d-flex mb-3 justify-content-end\">\r\n    <div class=\"clear-all-link pr-5\">\r\n      <vnext-link [title]=\"clearAllText\" [alwaysUnderlined]=\"true\" (click)=\"clearAllFilters()\"></vnext-link>\r\n    </div>\r\n    <div class=\"close-button can-click Spa_Style_Primary_Color\" (click)=\"close()\"><i class=\"fa fa-times\"></i></div>\r\n  </div>\r\n  <form [formGroup]=\"filterForm\">\r\n    <div class=\"row\">\r\n      <div class=\"col-6 col-md-3\">\r\n        <div class=\"Spa_Style_Primary_Color Spa_Style_Bold_Weight pb-2\">{{ carrierHeader }}</div>\r\n        <vnext-checkbox-group\r\n          [items]=\"carrierFilterControls$ | async\"\r\n          class=\"plan-filter-items\"\r\n          (change)=\"onFilterSelected(carrierControlName)\"\r\n          formControlName=\"{{ carrierControlName }}\"\r\n          [enableNoteStyle]=\"false\"\r\n          [customClass]=\"'no-left-offset'\"\r\n          [scrollable]=\"true\"\r\n          [parentId]=\"checkboxId\"\r\n          [noTranslateBlock]=\"true\"\r\n        >\r\n        </vnext-checkbox-group>\r\n      </div>\r\n      <div class=\"col-6 col-md-3\">\r\n        <div class=\"Spa_Style_Primary_Color Spa_Style_Bold_Weight pb-2\">{{ statesHeader }}</div>\r\n        <vnext-checkbox-group\r\n          [items]=\"stateFilterControls\"\r\n          class=\"plan-filter-items\"\r\n          (change)=\"onFilterSelected(stateControlName)\"\r\n          formControlName=\"{{ stateControlName }}\"\r\n          [enableNoteStyle]=\"false\"\r\n          [customClass]=\"'no-left-offset'\"\r\n          [scrollable]=\"true\"\r\n          [parentId]=\"checkboxId\"\r\n        >\r\n        </vnext-checkbox-group>\r\n      </div>\r\n      <div class=\"col-6 col-md-3 pt-3 pt-md-0\">\r\n        <div class=\"Spa_Style_Primary_Color Spa_Style_Bold_Weight pb-2\">{{ planTypeHeader }}</div>\r\n        <vnext-checkbox-group\r\n          [items]=\"planTypeFilterControls\"\r\n          class=\"plan-filter-items\"\r\n          (change)=\"onFilterSelected(planTypeControlName)\"\r\n          formControlName=\"{{ planTypeControlName }}\"\r\n          [enableNoteStyle]=\"false\"\r\n          [customClass]=\"'no-left-offset'\"\r\n          [parentId]=\"checkboxId\"\r\n        >\r\n        </vnext-checkbox-group>\r\n        <div class=\"snp-section ml-2\">\r\n          <vnext-checkbox-group\r\n            [items]=\"snpTypeFilterControls\"\r\n            class=\"plan-filter-items\"\r\n            (change)=\"onFilterSelected(snpTypeControlName)\"\r\n            formControlName=\"{{ snpTypeControlName }}\"\r\n            [enableNoteStyle]=\"false\"\r\n            [customClass]=\"'no-left-offset'\"\r\n            [parentId]=\"checkboxId\"\r\n          >\r\n          </vnext-checkbox-group>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-6 col-md-3 pt-3 pt-md-0\" *ngIf=\"yearSelectionEnabled\">\r\n        <div class=\"Spa_Style_Primary_Color Spa_Style_Bold_Weight pb-2\">{{ planYearHeader }}</div>\r\n        <vnext-checkbox-group\r\n          [items]=\"planYearFilterControls\"\r\n          class=\"plan-filter-items\"\r\n          (change)=\"onFilterSelected(planYearControlName)\"\r\n          formControlName=\"{{ planYearControlName }}\"\r\n          [enableNoteStyle]=\"false\"\r\n          [customClass]=\"'no-left-offset'\"\r\n          [parentId]=\"checkboxId\"\r\n        >\r\n        </vnext-checkbox-group>\r\n      </div>\r\n    </div>\r\n  </form>\r\n  <div class=\"view-button-container d-flex justify-content-end\">\r\n    <button class=\"btn Spa_Style_PrimaryButton\" (click)=\"viewPermissions()\">{{ viewPermissionsText }}</button>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: i1.ASPFilterService }, { type: i0.ChangeDetectorRef }, { type: i1.InputResetContextService }, { type: i1.LocaleService }]; }, { closePopover: [{
            type: Output
        }], applyText: [{
            type: Input
        }], planYearHeader: [{
            type: Input
        }], carrierHeader: [{
            type: Input
        }], statesHeader: [{
            type: Input
        }], planTypeHeader: [{
            type: Input
        }], clearAllText: [{
            type: Input
        }], viewPermissionsText: [{
            type: Input
        }], yearSelectionEnabled: [{
            type: Input
        }] }); })();

function AgentRoleSelectorComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵlistener("click", function AgentRoleSelectorComponent_div_0_div_6_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r4); const role_r2 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.selectRole(role_r2)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const role_r2 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", role_r2.key, " ");
} }
const _c0$2Q = function (a0) { return { "has-error": a0 }; };
function AgentRoleSelectorComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "input", 2);
    i0.ɵɵlistener("ngModelChange", function AgentRoleSelectorComponent_div_0_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.selectedValue = $event); })("keydown", function AgentRoleSelectorComponent_div_0_Template_input_keydown_1_listener($event) { return $event.preventDefault(); })("blur", function AgentRoleSelectorComponent_div_0_Template_input_blur_1_listener() { i0.ɵɵrestoreView(_r6); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.updateForm()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "i", 3);
    i0.ɵɵelementStart(3, "span", 4);
    i0.ɵɵtext(4, "Expand menu");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 5);
    i0.ɵɵtemplate(6, AgentRoleSelectorComponent_div_0_div_6_Template, 2, 1, "div", 6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("", ctx_r0.customClass, " form-control can-click");
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r0.placeholderDefaultValue);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$2Q, ctx_r0.formControl.errors && (ctx_r0.formSubmitted || ctx_r0.formControl.touched)))("ngModel", ctx_r0.selectedValue);
    i0.ɵɵattribute("aria-labelledby", ctx_r0.ariaLabelledById);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r0.roles);
} }
class AgentRoleSelectorComponent {
    constructor(accountOverviewFacade, localeService, cdr) {
        this.accountOverviewFacade = accountOverviewFacade;
        this.localeService = localeService;
        this.cdr = cdr;
        this.formSubmitted = false;
        this.subscriptions = new Subscription();
    }
    set control(control) {
        this.formControl = control;
        if (control.value) {
            this.selectedValue = '';
        }
    }
    ngOnInit() {
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe({
            next: () => {
                this.roles = this.getRoleDescriptions();
                this.cdr.markForCheck();
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    selectRole(role) {
        if (role && this.formControl) {
            this.selectedValue = role.key;
            this.formControl.setValue(role.key);
        }
        else {
            this.selectedValue = '';
        }
    }
    updateForm() {
        this.formControl.markAsTouched();
    }
    getRoleDescriptions() {
        const roleDescriptionSortKey = 'key';
        let roles = this.accountOverviewFacade.getRoleDescriptions();
        if (this.formControl.value && !roles.some(({ key }) => key === this.formControl.value)) {
            const missingRoleDescription = this.accountOverviewFacade.getRoleDescription(this.formControl.value);
            roles = [...roles, missingRoleDescription];
        }
        return this.accountOverviewFacade.sortRoleDescriptions(roleDescriptionSortKey, roles);
    }
}
AgentRoleSelectorComponent.ɵfac = function AgentRoleSelectorComponent_Factory(t) { return new (t || AgentRoleSelectorComponent)(i0.ɵɵdirectiveInject(AccountOverviewFacade), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
AgentRoleSelectorComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentRoleSelectorComponent, selectors: [["vnext-agent-role-selector"]], inputs: { placeholderDefaultValue: "placeholderDefaultValue", formSubmitted: "formSubmitted", customClass: "customClass", ariaLabelledById: "ariaLabelledById", control: "control" }, decls: 1, vars: 1, consts: [["class", "position-relative", "ngbDropdown", "", 4, "ngIf"], ["ngbDropdown", "", 1, "position-relative"], ["type", "text", "tabindex", "0", "autocomplete", "new-text", "ngbDropdownToggle", "", 3, "placeholder", "ngClass", "ngModel", "ngModelChange", "keydown", "blur"], ["ngbDropdownToggle", "", 1, "fas", "fa-angle-down", "icon-in-input", "can-click", "float-right"], [1, "sr-only"], ["ngbDropdownMenu", ""], ["class", "Spa_Style_Small_Font", "ngbDropdownItem", "", 3, "click", 4, "ngFor", "ngForOf"], ["ngbDropdownItem", "", 1, "Spa_Style_Small_Font", 3, "click"]], template: function AgentRoleSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, AgentRoleSelectorComponent_div_0_Template, 7, 10, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.formControl);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem], styles: [".button-container[_ngcontent-%COMP%]{max-width:84px}.icon-in-input[_ngcontent-%COMP%]{position:absolute;top:8px;left:calc(100% - 15px)}input[_ngcontent-%COMP%]{height:36px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentRoleSelectorComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-role-selector', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"position-relative\" ngbDropdown *ngIf=\"formControl\">\r\n  <input\r\n    type=\"text\"\r\n    tabindex=\"0\"\r\n    autocomplete=\"new-text\"\r\n    ngbDropdownToggle\r\n    placeholder=\"{{ placeholderDefaultValue }}\"\r\n    class=\"{{ customClass }} form-control can-click\"\r\n    [attr.aria-labelledby]=\"ariaLabelledById\"\r\n    [ngClass]=\"{ 'has-error': formControl.errors && (formSubmitted || formControl.touched) }\"\r\n    [(ngModel)]=\"selectedValue\"\r\n    (keydown)=\"$event.preventDefault()\"\r\n    (blur)=\"updateForm()\"\r\n  />\r\n  <i class=\"fas fa-angle-down icon-in-input can-click float-right\" ngbDropdownToggle></i>\r\n  <span class=\"sr-only\">Expand menu</span>\r\n  <div ngbDropdownMenu>\r\n    <div *ngFor=\"let role of roles\" (click)=\"selectRole(role)\" class=\"Spa_Style_Small_Font\" ngbDropdownItem>\r\n      {{ role.key }}\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".button-container{max-width:84px}.icon-in-input{position:absolute;top:8px;left:calc(100% - 15px)}input{height:36px}\n"] }]
    }], function () { return [{ type: AccountOverviewFacade }, { type: i1.LocaleService }, { type: i0.ChangeDetectorRef }]; }, { placeholderDefaultValue: [{
            type: Input
        }], formSubmitted: [{
            type: Input
        }], customClass: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], control: [{
            type: Input
        }] }); })();

const _c0$2P = ["uploadInput"];
function AgentProfileUploadComponent_h2_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.agentProfilePictureHeader, "\n");
} }
function AgentProfileUploadComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.agentProfilePictureContent, " ");
} }
function AgentProfileUploadComponent_div_9_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵelementStart(2, "span", 18);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const error_r5 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(error_r5);
} }
function AgentProfileUploadComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, AgentProfileUploadComponent_div_9_div_1_Template, 4, 1, "div", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.fileUploadErrors);
} }
class AgentProfileUploadComponent {
    constructor(analyticsService) {
        this.analyticsService = analyticsService;
        this.filechange = new EventEmitter();
    }
    openUpload() {
        this.uploadInput.nativeElement.click();
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_AGENT_PICTURE_UPLOAD
        };
    }
    onFileChange(files) {
        this.filechange.emit(files);
    }
}
AgentProfileUploadComponent.ɵfac = function AgentProfileUploadComponent_Factory(t) { return new (t || AgentProfileUploadComponent)(i0.ɵɵdirectiveInject(AnalyticsService)); };
AgentProfileUploadComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentProfileUploadComponent, selectors: [["vnext-agent-profile-upload"]], viewQuery: function AgentProfileUploadComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$2P, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.uploadInput = _t.first);
    } }, inputs: { agentData: "agentData", agentGuid: "agentGuid", agentProfilePictureUrl: "agentProfilePictureUrl", agentProfilePictureHeader: "agentProfilePictureHeader", agentProfilePictureHeaderPropName: "agentProfilePictureHeaderPropName", agentProfilePictureContent: "agentProfilePictureContent", agentProfilePictureContentPropName: "agentProfilePictureContentPropName", agentProfilePictureInstruction: "agentProfilePictureInstruction", agentProfilePictureUploadText: "agentProfilePictureUploadText", fileUploadErrors: "fileUploadErrors", isFullWidthUploadContainer: "isFullWidthUploadContainer" }, outputs: { filechange: "filechange" }, decls: 14, vars: 13, consts: [["class", "Spa_Style_H2 mt-2", 4, "liveEditProp"], [1, "pl-3", "pr-3"], [1, "row", "profile-text"], [1, "col-12", "pl-0", "pr-3", 3, "ngClass"], ["class", "Spa_Style_Paragraph mb-3", 4, "liveEditProp"], [1, "Spa_Style_Note", "mt-1", "mt-md-5", "mb-3"], [1, "col-12", "text-center", "p-0", 3, "ngClass"], [3, "broker", "isUpload", "agentProfilePictureUrl"], ["class", "warn-color col-12 my-2 p-0 text-md-left", 4, "ngIf"], ["hidden", "", "type", "file", "accept", ".jpeg,.jpg,.gif,.png", 3, "change"], ["uploadInput", ""], [1, "link-wrapper", "upload-link-wrapper", "mt-2"], [3, "title", "additionalIcon", "makeInlineBlock", "click", "keyup.enter"], [1, "Spa_Style_H2", "mt-2"], [1, "Spa_Style_Paragraph", "mb-3"], [1, "warn-color", "col-12", "my-2", "p-0", "text-md-left"], [4, "ngFor", "ngForOf"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-triangle", "mr-2", "error-icon"], [1, "error-message"]], template: function AgentProfileUploadComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, AgentProfileUploadComponent_h2_0_Template, 2, 1, "h2", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3);
        i0.ɵɵtemplate(4, AgentProfileUploadComponent_div_4_Template, 2, 1, "div", 4);
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵelement(8, "vnext-agent-profile-picture", 7);
        i0.ɵɵtemplate(9, AgentProfileUploadComponent_div_9_Template, 2, 1, "div", 8);
        i0.ɵɵelementStart(10, "input", 9, 10);
        i0.ɵɵlistener("change", function AgentProfileUploadComponent_Template_input_change_10_listener($event) { return ctx.onFileChange($event.target.files); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 11)(13, "vnext-link", 12);
        i0.ɵɵlistener("click", function AgentProfileUploadComponent_Template_vnext_link_click_13_listener() { return ctx.openUpload(); })("keyup.enter", function AgentProfileUploadComponent_Template_vnext_link_keyup_enter_13_listener() { return ctx.openUpload(); });
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("liveEditProp", ctx.agentProfilePictureHeaderPropName);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", ctx.isFullWidthUploadContainer ? "col-md-9" : "col-md-6 col-lg-7");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", ctx.agentProfilePictureContentPropName);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.agentProfilePictureInstruction, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.isFullWidthUploadContainer ? "col-md-3" : "col-md-6 col-lg-5");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("broker", ctx.agentData)("isUpload", true)("agentProfilePictureUrl", ctx.agentProfilePictureUrl);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fileUploadErrors == null ? null : ctx.fileUploadErrors.length);
        i0.ɵɵadvance(1);
        i0.ɵɵattribute("aria-label", ctx.agentProfilePictureUploadText);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("title", ctx.agentProfilePictureUploadText)("additionalIcon", "fas fa-upload")("makeInlineBlock", true);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, LiveEditPropDirective, IconAriaAttributesDirective, AgentProfilePictureComponent], encapsulation: 2, changeDetection: 0 });
__decorate([
    LiveEditInactive()
], AgentProfileUploadComponent.prototype, "openUpload", null);
__decorate([
    LiveEditInactive()
], AgentProfileUploadComponent.prototype, "onFileChange", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentProfileUploadComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-profile-upload', changeDetection: ChangeDetectionStrategy.OnPush, template: "<h2 class=\"Spa_Style_H2 mt-2\" *liveEditProp=\"agentProfilePictureHeaderPropName\">\r\n  {{ agentProfilePictureHeader }}\r\n</h2>\r\n<div class=\"pl-3 pr-3\">\r\n  <div class=\"row profile-text\">\r\n    <div class=\"col-12 pl-0 pr-3\" [ngClass]=\"isFullWidthUploadContainer ? 'col-md-9' : 'col-md-6 col-lg-7'\">\r\n      <div class=\"Spa_Style_Paragraph mb-3\" *liveEditProp=\"agentProfilePictureContentPropName\">\r\n        {{ agentProfilePictureContent }}\r\n      </div>\r\n      <div class=\"Spa_Style_Note mt-1 mt-md-5 mb-3\">\r\n        {{ agentProfilePictureInstruction }}\r\n      </div>\r\n    </div>\r\n    <div class=\"col-12 text-center p-0\" [ngClass]=\"isFullWidthUploadContainer ? 'col-md-3' : 'col-md-6 col-lg-5'\">\r\n      <vnext-agent-profile-picture\r\n        [broker]=\"agentData\"\r\n        [isUpload]=\"true\"\r\n        [agentProfilePictureUrl]=\"agentProfilePictureUrl\"\r\n      ></vnext-agent-profile-picture>\r\n      <div class=\"warn-color col-12 my-2 p-0 text-md-left\" *ngIf=\"fileUploadErrors?.length\">\r\n        <div *ngFor=\"let error of fileUploadErrors\">\r\n          <i class=\"fas fa-exclamation-triangle mr-2 error-icon\" aria-hidden=\"true\"></i>\r\n          <span class=\"error-message\">{{ error }}</span>\r\n        </div>\r\n      </div>\r\n      <input\r\n        #uploadInput\r\n        hidden\r\n        type=\"file\"\r\n        accept=\".jpeg,.jpg,.gif,.png\"\r\n        [attr.aria-label]=\"agentProfilePictureUploadText\"\r\n        (change)=\"onFileChange($event.target.files)\"\r\n      />\r\n      <div class=\"link-wrapper upload-link-wrapper mt-2\">\r\n        <vnext-link\r\n          [title]=\"agentProfilePictureUploadText\"\r\n          [additionalIcon]=\"'fas fa-upload'\"\r\n          [makeInlineBlock]=\"true\"\r\n          (click)=\"openUpload()\"\r\n          (keyup.enter)=\"openUpload()\"\r\n        ></vnext-link>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: AnalyticsService }]; }, { agentData: [{
            type: Input
        }], agentGuid: [{
            type: Input
        }], agentProfilePictureUrl: [{
            type: Input
        }], agentProfilePictureHeader: [{
            type: Input
        }], agentProfilePictureHeaderPropName: [{
            type: Input
        }], agentProfilePictureContent: [{
            type: Input
        }], agentProfilePictureContentPropName: [{
            type: Input
        }], agentProfilePictureInstruction: [{
            type: Input
        }], agentProfilePictureUploadText: [{
            type: Input
        }], fileUploadErrors: [{
            type: Input
        }], isFullWidthUploadContainer: [{
            type: Input
        }], filechange: [{
            type: Output
        }], uploadInput: [{
            type: ViewChild,
            args: ['uploadInput']
        }], openUpload: [], onFileChange: [] }); })();

const _c0$2O = ["medSupDate"];
const _c1$1t = function (a0) { return { "has-error": a0 }; };
function MedSupDateComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "input", 4, 5);
    i0.ɵɵlistener("dateSelect", function MedSupDateComponent_ng_container_3_Template_input_dateSelect_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.onDateSelection($event)); })("select", function MedSupDateComponent_ng_container_3_Template_input_select_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onDateSelection($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 6);
    i0.ɵɵlistener("click", function MedSupDateComponent_ng_container_3_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r4); const _r2 = i0.ɵɵreference(2); return i0.ɵɵresetView(_r2.toggle()); });
    i0.ɵɵelement(4, "i", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("minDate", ctx_r1.datePickerMinDate)("maxDate", ctx_r1.datePickerMaxDate)("ngClass", i0.ɵɵpureFunction1(5, _c1$1t, ctx_r1.hasError));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.isReadOnly);
    i0.ɵɵattribute("aria-label", ctx_r1.datePickerButtonLabelText ? ctx_r1.datePickerButtonLabelText : null);
} }
const _c2$W = function (a0) { return { "w-100": a0 }; };
const _c3$F = function (a0, a1) { return { "has-error": a0, "Spa_Style_Gray4_Color readonly": a1 }; };
class MedSupDateComponent {
    constructor() {
        this.sendDate = new EventEmitter();
        this.showDatePicker = false;
        this.hasError = false;
        this.fullWidth = false;
        this.isReadOnly = false;
        this.dirty = false;
        // TODO: format will most likely be configurable in the future
        this.defaultFormat = 'mm/dd/yyyy';
        this.maskFormat = this.defaultFormat.replace(/\w/g, '0');
        this.eventListeners = [];
    }
    ngOnInit() {
        this.value = this.getDate();
        if (this.value) {
            this.dirty = true;
            this.validateDateAndEmit();
        }
    }
    ngOnDestroy() {
        this.eventListeners.forEach(eventListener => {
            // detach our listeners
            eventListener();
        });
    }
    getDate() {
        if (this.defaultValue) {
            // We must take into account date time formats such as "6/1/2020 12:00:00 AM"
            // in addition to the default MM/DD/YYYY format, i.e. 06/01/2020.
            return DateUtilities.getFormattedDate(new Date(this.defaultValue.split(' ')[0]));
        }
        return '';
    }
    onKeyDownEmitDate($event) {
        const isTabEvent = $event && $event.keyCode === 9;
        if (isTabEvent) {
            this.emitDate();
        }
    }
    validateDateAndEmit() {
        if (this.value && this.value.length === this.defaultFormat.length) {
            this.emitDate();
        }
    }
    emitDate() {
        this.dirty = true;
        if (this.value && this.value.length !== this.defaultFormat.length) {
            this.sendDate.emit('');
        }
        else {
            this.sendDate.emit(this.value);
        }
    }
    onDateSelection(event) {
        const month = event.month.toString().length === 1 ? `0${event.month}` : event.month.toString();
        const day = event.day.toString().length === 1 ? `0${event.day}` : event.day.toString();
        this.value = `${month}/${day}/${event.year}`;
        this.emitDate();
    }
}
MedSupDateComponent.ɵfac = function MedSupDateComponent_Factory(t) { return new (t || MedSupDateComponent)(); };
MedSupDateComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedSupDateComponent, selectors: [["vnext-med-sup-date"]], viewQuery: function MedSupDateComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$2O, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupDate = _t.first);
    } }, inputs: { defaultValue: "defaultValue", showDatePicker: "showDatePicker", datePickerMinDate: "datePickerMinDate", datePickerMaxDate: "datePickerMaxDate", hasError: "hasError", fullWidth: "fullWidth", datePickerButtonLabelText: "datePickerButtonLabelText", ariaDescribedById: "ariaDescribedById", ariaLabelledById: "ariaLabelledById", isReadOnly: "isReadOnly", customClass: "customClass" }, outputs: { sendDate: "sendDate" }, decls: 4, vars: 18, consts: [[1, "date-input", 3, "ngClass"], ["type", "text", "inputmode", "numeric", "autocomplete", "off", "maxlength", "10", "aria-required", "true", 3, "placeholder", "mask", "dropSpecialCharacters", "ngClass", "readonly", "ngModel", "ngModelChange", "keyup.enter", "keydown", "blur"], ["medSupDate", ""], [4, "ngIf"], ["type", "text", "aria-hidden", "true", "tabindex", "-1", "ngbDatepicker", "", 1, "date-picker-input", "float-left", "p-0", 3, "minDate", "maxDate", "ngClass", "dateSelect", "select"], ["datePickerInput", "ngbDatepicker"], [1, "btn", "btn-calendar", 3, "disabled", "click"], ["aria-hidden", "true", "role", "presentation", 1, "fas", "fa-calendar-alt"]], template: function MedSupDateComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "input", 1, 2);
        i0.ɵɵlistener("ngModelChange", function MedSupDateComponent_Template_input_ngModelChange_1_listener($event) { return ctx.value = $event; })("keyup.enter", function MedSupDateComponent_Template_input_keyup_enter_1_listener() { return ctx.showDatePicker ? ctx.validateDateAndEmit() : ctx.emitDate(); })("keydown", function MedSupDateComponent_Template_input_keydown_1_listener($event) { return ctx.showDatePicker ? ctx.onKeyDownEmitDate($event) : null; })("blur", function MedSupDateComponent_Template_input_blur_1_listener() { return ctx.showDatePicker ? ctx.validateDateAndEmit() : ctx.emitDate(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, MedSupDateComponent_ng_container_3_Template, 5, 7, "ng-container", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c2$W, ctx.fullWidth));
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("", ctx.customClass, " med-sup-number-input");
        i0.ɵɵpropertyInterpolate("placeholder", ctx.defaultFormat);
        i0.ɵɵpropertyInterpolate("mask", ctx.maskFormat);
        i0.ɵɵproperty("dropSpecialCharacters", false)("ngClass", i0.ɵɵpureFunction2(15, _c3$F, ctx.hasError && !ctx.isReadOnly, ctx.isReadOnly))("readonly", ctx.isReadOnly)("ngModel", ctx.value);
        i0.ɵɵattribute("aria-describedby", ctx.ariaDescribedById ? ctx.ariaDescribedById : null)("aria-labelledby", ctx.ariaLabelledById ? ctx.ariaLabelledById : null);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showDatePicker);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.DefaultValueAccessor, i4.NgControlStatus, i4.MaxLengthValidator, i4.NgModel, IconAriaAttributesDirective, i1$1.NgbInputDatepicker, i8.MaskDirective], styles: ["label[_ngcontent-%COMP%]{margin-bottom:0}input[_ngcontent-%COMP%]{width:100%}.med-sup-number-input[_ngcontent-%COMP%], .date-input[_ngcontent-%COMP%]{position:relative}.date-picker-input[_ngcontent-%COMP%]{color:transparent;border:transparent;height:0}.btn-calendar[_ngcontent-%COMP%]{position:absolute;right:0;top:0}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupDateComponent, [{
        type: Component,
        args: [{ selector: 'vnext-med-sup-date', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"date-input\" [ngClass]=\"{ 'w-100': fullWidth }\">\r\n  <input\r\n    #medSupDate\r\n    type=\"text\"\r\n    class=\"{{ customClass }} med-sup-number-input\"\r\n    inputmode=\"numeric\"\r\n    autocomplete=\"off\"\r\n    placeholder=\"{{ defaultFormat }}\"\r\n    mask=\"{{ maskFormat }}\"\r\n    maxlength=\"10\"\r\n    aria-required=\"true\"\r\n    [attr.aria-describedby]=\"ariaDescribedById ? ariaDescribedById : null\"\r\n    [attr.aria-labelledby]=\"ariaLabelledById ? ariaLabelledById : null\"\r\n    [dropSpecialCharacters]=\"false\"\r\n    [ngClass]=\"{ 'has-error': hasError && !isReadOnly, 'Spa_Style_Gray4_Color readonly': isReadOnly }\"\r\n    [readonly]=\"isReadOnly\"\r\n    [(ngModel)]=\"value\"\r\n    (keyup.enter)=\"showDatePicker ? validateDateAndEmit() : emitDate()\"\r\n    (keydown)=\"showDatePicker ? onKeyDownEmitDate($event) : null\"\r\n    (blur)=\"showDatePicker ? validateDateAndEmit() : emitDate()\"\r\n  />\r\n  <ng-container *ngIf=\"showDatePicker\">\r\n    <input\r\n      #datePickerInput=\"ngbDatepicker\"\r\n      type=\"text\"\r\n      aria-hidden=\"true\"\r\n      class=\"date-picker-input float-left p-0\"\r\n      tabindex=\"-1\"\r\n      ngbDatepicker\r\n      [minDate]=\"datePickerMinDate\"\r\n      [maxDate]=\"datePickerMaxDate\"\r\n      [ngClass]=\"{ 'has-error': hasError }\"\r\n      (dateSelect)=\"onDateSelection($event)\"\r\n      (select)=\"onDateSelection($event)\"\r\n    />\r\n    <button\r\n      class=\"btn btn-calendar\"\r\n      [attr.aria-label]=\"datePickerButtonLabelText ? datePickerButtonLabelText : null\"\r\n      [disabled]=\"isReadOnly\"\r\n      (click)=\"datePickerInput.toggle()\"\r\n    >\r\n      <i aria-hidden=\"true\" role=\"presentation\" class=\"fas fa-calendar-alt\"></i>\r\n    </button>\r\n  </ng-container>\r\n</div>\r\n", styles: ["label{margin-bottom:0}input{width:100%}.med-sup-number-input,.date-input{position:relative}.date-picker-input{color:transparent;border:transparent;height:0}.btn-calendar{position:absolute;right:0;top:0}\n"] }]
    }], null, { medSupDate: [{
            type: ViewChild,
            args: ['medSupDate', { static: true }]
        }], sendDate: [{
            type: Output
        }], defaultValue: [{
            type: Input
        }], showDatePicker: [{
            type: Input
        }], datePickerMinDate: [{
            type: Input
        }], datePickerMaxDate: [{
            type: Input
        }], hasError: [{
            type: Input
        }], fullWidth: [{
            type: Input
        }], datePickerButtonLabelText: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], isReadOnly: [{
            type: Input
        }], customClass: [{
            type: Input
        }] }); })();

const _c0$2N = ["permissionPopover"];
const _c1$1s = ["filterPopover"];
const _c2$V = ["copiedInfoText"];
const _c3$E = ["sellingPermissionsTable"];
function AccountOverviewComponent_ng_container_1_h1_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r22.Spa_Agent_AddAgent_Header_Text, " ");
} }
function AccountOverviewComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AccountOverviewComponent_ng_container_1_h1_1_Template, 2, 1, "h1", 26);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_AddAgent_Header_Text");
} }
function AccountOverviewComponent_ng_template_2_h1_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r23.Spa_Agent_AccountOverview_Header_Text, " ");
} }
function AccountOverviewComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, AccountOverviewComponent_ng_template_2_h1_0_Template, 2, 1, "h1", 26);
} if (rf & 2) {
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_AccountOverview_Header_Text");
} }
function AccountOverviewComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 28);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r3.Spa_Site_PageSubHeader_Text ? i0.ɵɵpipeBind2(1, 1, ctx_r3.Spa_Site_PageSubHeader_Text, "html") : "", i0.ɵɵsanitizeHtml);
} }
function AccountOverviewComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-notice", 29);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r4.Spa_Member_Profile_ErrorMessages_TitleText)("messages", ctx_r4.errorBannerList)("type", "error");
} }
function AccountOverviewComponent_div_9_h2_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 36);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r24.Spa_Agent_AccountOverview_ShoppingLink_Header_Text, " ");
} }
function AccountOverviewComponent_div_9_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r25.Spa_Agent_AccountOverview_ShoppingLink_Content_Text, " ");
} }
function AccountOverviewComponent_div_9_button_3_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r31.Spa_Agent_AccountOverview_CopyLink_Text, "");
} }
const _c4$n = function (a0) { return { "mt-4": a0 }; };
function AccountOverviewComponent_div_9_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 38, 39);
    i0.ɵɵlistener("click", function AccountOverviewComponent_div_9_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r33); const ctx_r32 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r32.copyPurl(true)); })("keyup.enter", function AccountOverviewComponent_div_9_button_3_Template_button_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r33); const _r30 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r30.toggle()); });
    i0.ɵɵtemplate(2, AccountOverviewComponent_div_9_button_3_span_2_Template, 2, 1, "span", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c4$n, ctx_r26.Spa_Agent_Profile_Picture_Upload_Enabled))("ngbPopover", ctx_r26.getCopiedInfoTextTooltipName())("autoClose", "outside");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_AccountOverview_CopyLink_Text");
} }
function AccountOverviewComponent_div_9_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 41)(1, "vnext-link", 42, 39);
    i0.ɵɵlistener("click", function AccountOverviewComponent_div_9_div_5_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r36.copyPurl(false)); })("keyup.enter", function AccountOverviewComponent_div_9_div_5_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r37); const _r35 = i0.ɵɵreference(2); return i0.ɵɵresetView(_r35.toggle()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r27.Spa_Agent_AccountOverview_CopyDualPlanYearLink_Text)("alwaysUnderlined", true)("ngbPopover", ctx_r27.getCopiedInfoTextTooltipName())("autoClose", "outside");
} }
function AccountOverviewComponent_div_9_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 43);
    i0.ɵɵelement(1, "i", 44);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r29.Spa_Agent_AccountOverview_CopiedInfo_Text, " ");
} }
function AccountOverviewComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, AccountOverviewComponent_div_9_h2_1_Template, 2, 1, "h2", 31);
    i0.ɵɵtemplate(2, AccountOverviewComponent_div_9_div_2_Template, 2, 1, "div", 32);
    i0.ɵɵtemplate(3, AccountOverviewComponent_div_9_button_3_Template, 3, 6, "button", 33);
    i0.ɵɵelement(4, "br");
    i0.ɵɵtemplate(5, AccountOverviewComponent_div_9_div_5_Template, 3, 4, "div", 34);
    i0.ɵɵtemplate(6, AccountOverviewComponent_div_9_ng_template_6_Template, 3, 1, "ng-template", null, 35, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_AccountOverview_ShoppingLink_Header_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_AccountOverview_ShoppingLink_Content_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !!ctx_r5.currentPlanYearPurl && ctx_r5.agentHasPermissionForCurrentPlanYearPurl);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.isDualPlanYearPurlEnabled && !!ctx_r5.dualPlanYearPurl && ctx_r5.agentHasPermissionForDualPlanYearPurl);
} }
function AccountOverviewComponent_div_10_h2_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 36);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r39.Spa_Agent_AccountOverview_RetireFlo_Header_Text, " ");
} }
function AccountOverviewComponent_div_10_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r40.Spa_Agent_AccountOverview_RetireFlo_Content_Text, " ");
} }
function AccountOverviewComponent_div_10_ng_container_3_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r43.Spa_Agent_AccountOverview_RetireFlo_LogIn_ButtonText, "");
} }
function AccountOverviewComponent_div_10_ng_container_3_ng_container_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r45.Spa_Agent_AccountOverview_RetireFlo_PURL_DescriptionText, " ");
} }
function AccountOverviewComponent_div_10_ng_container_3_ng_container_3_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r47.Spa_Agent_AccountOverview_RetireFlo_PURL_ButtonText, "");
} }
function AccountOverviewComponent_div_10_ng_container_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 47);
    i0.ɵɵtemplate(2, AccountOverviewComponent_div_10_ng_container_3_ng_container_3_div_2_Template, 2, 1, "div", 32);
    i0.ɵɵelementStart(3, "button", 48, 39);
    i0.ɵɵlistener("click", function AccountOverviewComponent_div_10_ng_container_3_ng_container_3_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r49); const ctx_r48 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r48.copyRetireFloPurl()); })("keyup.enter", function AccountOverviewComponent_div_10_ng_container_3_ng_container_3_Template_button_keyup_enter_3_listener() { i0.ɵɵrestoreView(_r49); const _r46 = i0.ɵɵreference(4); return i0.ɵɵresetView(_r46.toggle()); });
    i0.ɵɵtemplate(5, AccountOverviewComponent_div_10_ng_container_3_ng_container_3_span_5_Template, 2, 1, "span", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_AccountOverview_RetireFlo_PURL_DescriptionText");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngbPopover", ctx_r44.getCopiedInfoTextTooltipName())("autoClose", "outside");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_AccountOverview_RetireFlo_PURL_ButtonText");
} }
function AccountOverviewComponent_div_10_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r52 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 46);
    i0.ɵɵlistener("click", function AccountOverviewComponent_div_10_ng_container_3_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r52); const ctx_r51 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r51.loginToRetireFlo()); });
    i0.ɵɵtemplate(2, AccountOverviewComponent_div_10_ng_container_3_span_2_Template, 2, 1, "span", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, AccountOverviewComponent_div_10_ng_container_3_ng_container_3_Template, 6, 4, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_AccountOverview_RetireFlo_LogIn_ButtonText");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r41.Spa_Agent_AccountOverview_RetireFlo_PURL_Enabled);
} }
function AccountOverviewComponent_div_10_button_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r53.Spa_Agent_AccountOverview_RetireFlo_SignUp_ButtonText, "");
} }
function AccountOverviewComponent_div_10_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 49);
    i0.ɵɵlistener("click", function AccountOverviewComponent_div_10_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r55); const ctx_r54 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r54.retireFloSignUpModal()); });
    i0.ɵɵtemplate(1, AccountOverviewComponent_div_10_button_4_span_1_Template, 2, 1, "span", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c4$n, ctx_r42.Spa_RetireFlo_Enabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_AccountOverview_RetireFlo_SignUp_ButtonText");
} }
function AccountOverviewComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, AccountOverviewComponent_div_10_h2_1_Template, 2, 1, "h2", 31);
    i0.ɵɵtemplate(2, AccountOverviewComponent_div_10_div_2_Template, 2, 1, "div", 32);
    i0.ɵɵtemplate(3, AccountOverviewComponent_div_10_ng_container_3_Template, 4, 2, "ng-container", 6);
    i0.ɵɵtemplate(4, AccountOverviewComponent_div_10_button_4_Template, 2, 4, "button", 45);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_AccountOverview_RetireFlo_Header_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_AccountOverview_RetireFlo_Content_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.agentHasRetireFlo);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.agentHasRetireFlo);
} }
function AccountOverviewComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 50)(1, "vnext-agent-profile-upload", 51);
    i0.ɵɵlistener("filechange", function AccountOverviewComponent_div_11_Template_vnext_agent_profile_upload_filechange_1_listener($event) { i0.ɵɵrestoreView(_r57); const ctx_r56 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r56.fileChange($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("agentData", ctx_r7.agentData)("agentProfilePictureUrl", ctx_r7.agentData == null ? null : ctx_r7.agentData.agentPictureURL)("agentGuid", ctx_r7.agentData == null ? null : ctx_r7.agentData.agentGuid)("fileUploadErrors", ctx_r7.fileUploadErrors)("agentProfilePictureHeader", ctx_r7.Spa_Agent_Profile_Picture_Header)("agentProfilePictureHeaderPropName", "Spa_Agent_Profile_Picture_Header")("agentProfilePictureContent", ctx_r7.Spa_Agent_Profile_Picture_Content)("agentProfilePictureContentPropName", "Spa_Agent_Profile_Picture_Content")("agentProfilePictureInstruction", ctx_r7.Spa_Agent_Profile_Picture_Instruction_Text)("agentProfilePictureUploadText", ctx_r7.Spa_Site_UploadLink_Text)("isFullWidthUploadContainer", !ctx_r7.Spa_Agent_AccountOverview_Purl_Enabled);
} }
function AccountOverviewComponent_h2_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 52);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.Spa_Agent_AccountOverview_PersonalHeader_Text, " ");
} }
function AccountOverviewComponent_form_14_ng_container_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 63);
    i0.ɵɵelement(2, "i", 64);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r59 = i0.ɵɵnextContext().$implicit;
    const ctx_r60 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r60.getPersonalError(control_r59.keyName), " ");
} }
const _c5$e = function (a0) { return { "error-color": a0 }; };
function AccountOverviewComponent_form_14_ng_container_2_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 65);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const control_r59 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("id", control_r59.keyName + "LabelId")("ngClass", i0.ɵɵpureFunction1(2, _c5$e, !control_r59.disabled));
} }
const _c6$d = function (a0, a1) { return { "has-error": a0, "Spa_Style_Gray4_Color readonly": a1 }; };
function AccountOverviewComponent_form_14_ng_container_2_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "input", 66);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r59 = i0.ɵɵnextContext().$implicit;
    const ctx_r62 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("type", ctx_r62.getType(control_r59.keyName))("ngClass", i0.ɵɵpureFunction2(8, _c6$d, (ctx_r62.personalFormGroup.controls[control_r59.keyName] == null ? null : ctx_r62.personalFormGroup.controls[control_r59.keyName].errors) && ctx_r62.submitted && ((ctx_r62.personalFormGroup.controls[control_r59.keyName] == null ? null : ctx_r62.personalFormGroup.controls[control_r59.keyName].touched) || (ctx_r62.personalFormGroup.controls[control_r59.keyName] == null ? null : ctx_r62.personalFormGroup.controls[control_r59.keyName].dirty)), control_r59.disabled))("ngClass", control_r59.class)("formControlName", control_r59.keyName)("readonly", control_r59.disabled)("mask", ctx_r62.getMask(control_r59.keyName))("validation", ctx_r62.getValidation(control_r59.keyName));
    i0.ɵɵattribute("aria-labelledby", control_r59.keyName + "LabelId");
} }
function AccountOverviewComponent_form_14_ng_container_2_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-state-selector-input", 67);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r59 = i0.ɵɵnextContext().$implicit;
    const ctx_r63 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("customClass", "Spa_Style_Small_Font Spa_Style_Primary_Color")("control", ctx_r63.getPersonalFormControl(control_r59.keyName))("formSubmitted", ctx_r63.submitted)("height", "36px")("isReadOnly", control_r59.disabled)("ariaLabelledById", control_r59.keyName + "LabelId");
} }
function AccountOverviewComponent_form_14_ng_container_2_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 68);
} }
const _c7$a = function (a0, a1, a2) { return { Spa_Style_Primary_Color: a0, Spa_Style_Gray4_Color: a1, Spa_Style_ErrorText: a2 }; };
function AccountOverviewComponent_form_14_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 56)(2, "div", 57)(3, "div", 58);
    i0.ɵɵtemplate(4, AccountOverviewComponent_form_14_ng_container_2_ng_container_4_Template, 4, 1, "ng-container", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 59)(6, "label", 60);
    i0.ɵɵtemplate(7, AccountOverviewComponent_form_14_ng_container_2_span_7_Template, 2, 4, "span", 61);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(9, AccountOverviewComponent_form_14_ng_container_2_ng_container_9_Template, 2, 11, "ng-container", 6);
    i0.ɵɵtemplate(10, AccountOverviewComponent_form_14_ng_container_2_ng_container_10_Template, 2, 6, "ng-container", 6);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(11, AccountOverviewComponent_form_14_ng_container_2_div_11_Template, 1, 0, "div", 62);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r59 = ctx.$implicit;
    const ctx_r58 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r58.agentPersonalAccountFormByLayoutClassNames[control_r59.keyName]);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (ctx_r58.personalFormGroup.controls[control_r59.keyName] == null ? null : ctx_r58.personalFormGroup.controls[control_r59.keyName].errors) && (ctx_r58.personalFormGroup.controls[control_r59.keyName] == null ? null : ctx_r58.personalFormGroup.controls[control_r59.keyName].enabled) && ctx_r58.submitted && ((ctx_r58.personalFormGroup.controls[control_r59.keyName] == null ? null : ctx_r58.personalFormGroup.controls[control_r59.keyName].touched) || (ctx_r58.personalFormGroup.controls[control_r59.keyName] == null ? null : ctx_r58.personalFormGroup.controls[control_r59.keyName].dirty)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(8, _c7$a, ctx_r58.personalFormGroup.controls[control_r59.keyName] == null ? null : ctx_r58.personalFormGroup.controls[control_r59.keyName].enabled, control_r59.disabled, (ctx_r58.personalFormGroup.controls[control_r59.keyName] == null ? null : ctx_r58.personalFormGroup.controls[control_r59.keyName].errors) && ctx_r58.submitted && ((ctx_r58.personalFormGroup.controls[control_r59.keyName] == null ? null : ctx_r58.personalFormGroup.controls[control_r59.keyName].touched) || (ctx_r58.personalFormGroup.controls[control_r59.keyName] == null ? null : ctx_r58.personalFormGroup.controls[control_r59.keyName].dirty))));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.personalControlIsRequired(control_r59.keyName) || ctx_r58.submitted && (ctx_r58.personalFormGroup.controls[control_r59.keyName] == null ? null : ctx_r58.personalFormGroup.controls[control_r59.keyName].errors));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", control_r59.labelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.getControlType(control_r59.keyName) === "input");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", control_r59.keyName === ctx_r58.accountOverviewInputs.STATE);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r58.breakRowLayout[control_r59.keyName]);
} }
function AccountOverviewComponent_form_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "form", 53)(1, "div", 54);
    i0.ɵɵtemplate(2, AccountOverviewComponent_form_14_ng_container_2_Template, 12, 12, "ng-container", 55);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r9.personalFormGroup);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r9.agentPersonalAccountForm)("ngForTrackBy", ctx_r9.trackIndex);
} }
function AccountOverviewComponent_ng_container_15_h2_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 74);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r69 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r69.Spa_Agent_AccountOverview_ManageMySubscriptionHeader_Text, " ");
} }
function AccountOverviewComponent_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AccountOverviewComponent_ng_container_15_h2_1_Template, 2, 1, "h2", 13);
    i0.ɵɵelementStart(2, "div", 69)(3, "div", 70);
    i0.ɵɵelement(4, "div", 71);
    i0.ɵɵpipe(5, "safe");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 72);
    i0.ɵɵelement(7, "vnext-link", 73);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_AccountOverview_PersonalHeader_Text");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(5, 6, ctx_r10.Spa_Agent_AccountOverview_ManageMySubscription_Html, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("href", ctx_r10.Spa_Agent_AccountOverview_ManageMySubscription_Url)("title", ctx_r10.Spa_Agent_AccountOverview_ManageMySubscription_Link_Text)("makeInlineBlock", true)("linkTarget", ctx_r10.targetType.BLANK);
} }
function AccountOverviewComponent_h2_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 74);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r11.Spa_Agent_AccountOverview_AccountHeader_Text, " ");
} }
function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 63);
    i0.ɵɵelement(2, "i", 64);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r72 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r74 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r74.getAccountError(control_r72.keyName), "");
} }
function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_template_3_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 63);
    i0.ɵɵelement(1, "i", 64);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const control_r72 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r94 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r94.getAccountValidationError(control_r72.keyName), "");
} }
function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, AccountOverviewComponent_form_17_div_2_ng_container_1_ng_template_3_span_0_Template, 3, 1, "span", 82);
} if (rf & 2) {
    const control_r72 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r76 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r76.getAccountValidationError(control_r72.keyName));
} }
function AccountOverviewComponent_form_17_div_2_ng_container_1_label_6_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 65);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const control_r72 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("id", control_r72.keyName + "LabelId")("ngClass", i0.ɵɵpureFunction1(2, _c5$e, !control_r72.disabled));
} }
function AccountOverviewComponent_form_17_div_2_ng_container_1_label_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 83);
    i0.ɵɵtemplate(1, AccountOverviewComponent_form_17_div_2_ng_container_1_label_6_span_1_Template, 2, 4, "span", 61);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const control_r72 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r77 = i0.ɵɵnextContext(2);
    let tmp_0_0;
    let tmp_1_0;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(3, _c7$a, (tmp_0_0 = ctx_r77.getAccountFormControl(control_r72.keyName)) == null ? null : tmp_0_0.enabled, !((tmp_0_0 = ctx_r77.getAccountFormControl(control_r72.keyName)) == null ? null : tmp_0_0.enabled), ctx_r77.hasError(control_r72.keyName) || ctx_r77.getAccountValidationError(control_r72.keyName)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r77.accountControlIsRequired(control_r72.keyName) || ctx_r77.submitted && ((tmp_1_0 = ctx_r77.getAccountFormControl(control_r72.keyName)) == null ? null : tmp_1_0.errors));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", control_r72.labelText, " ");
} }
const _c8$7 = function (a0) { return { "has-error": a0 }; };
function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "input", 84);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r72 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r78 = i0.ɵɵnextContext(2);
    let tmp_1_0;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("type", ctx_r78.getType(control_r72.keyName))("ngClass", i0.ɵɵpureFunction1(4, _c8$7, ctx_r78.submitted && ((tmp_1_0 = ctx_r78.getAccountFormControl(control_r72.keyName)) == null ? null : tmp_1_0.errors) && ((tmp_1_0 = ctx_r78.getAccountFormControl(control_r72.keyName)) == null ? null : tmp_1_0.touched)))("formControlName", control_r72.keyName);
    i0.ɵɵattribute("aria-labelledby", control_r72.keyName + "LabelId");
} }
function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r102 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-agency-name-selector-input", 85);
    i0.ɵɵlistener("emitAgencyId", function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_8_Template_vnext_agency_name_selector_input_emitAgencyId_1_listener($event) { i0.ɵɵrestoreView(_r102); const ctx_r101 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r101.setAgencyIdField($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r72 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r79 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("control", ctx_r79.getAccountFormControl(control_r72.keyName))("agencyItems", ctx_r79.agencyItems)("agencyID", ctx_r79.userAgencyId)("formSubmitted", ctx_r79.submitted)("height", "36px")("isReadOnly", ctx_r79.isAgencyNameDisabled)("noneAvailableLabel", ctx_r79.Spa_Site_None_Available_Text)("ariaLabelledById", control_r72.keyName + "LabelId");
} }
function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r105 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 86);
    i0.ɵɵlistener("click", function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r105); const ctx_r104 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r104.changeSiteAccess()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r80 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r80.siteAccessButtonText, " ");
} }
function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    const _r107 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-toggle-select", 87);
    i0.ɵɵlistener("optionSelected", function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_10_Template_vnext_toggle_select_optionSelected_1_listener($event) { i0.ɵɵrestoreView(_r107); const ctx_r106 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r106.onSelectAccountStatus($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r72 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r81 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("items", ctx_r81.accountStatusItems)("buttonHeight", "36px")("selectedValue", ctx_r81.getAccountStatusDefaultValue())("largerText", true)("ariaLabelledById", control_r72.keyName + "LabelId");
} }
function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    const _r110 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-toggle-select", 88);
    i0.ɵɵlistener("optionSelected", function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_11_Template_vnext_toggle_select_optionSelected_1_listener($event) { i0.ɵɵrestoreView(_r110); const ctx_r109 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r109.onSelectASP($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r72 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r82 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("items", ctx_r82.aspItems)("buttonHeight", "36px")("selectedValue", ctx_r82.getASPRequiredDefaultValue())("largerText", true)("isReadOnly", ctx_r82.getASPDisabled())("ariaLabelledById", control_r72.keyName + "LabelId");
} }
function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-agent-role-selector", 89);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r72 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r83 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("customClass", "Spa_Style_Small_Font Spa_Style_Primary_Color")("control", ctx_r83.getAccountFormControl(control_r72.keyName))("formSubmitted", ctx_r83.submitted)("placeholderDefaultValue", ctx_r83.getRoleDefaultValue())("ariaLabelledById", control_r72.keyName + "LabelId");
} }
function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    const _r114 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-toggle-select", 90);
    i0.ɵɵlistener("optionSelected", function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_13_Template_vnext_toggle_select_optionSelected_1_listener($event) { i0.ɵɵrestoreView(_r114); const ctx_r113 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r113.onSelectProfileAdmin($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r72 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r84 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("items", ctx_r84.profileAdminOptions)("buttonHeight", "36px")("largerText", true)("isReadOnly", ctx_r84.getProfileAdminDisabled())("selectedValue", ctx_r84.getProfileAdminRequiredDefaultValue())("ariaLabelledById", control_r72.keyName + "LabelId");
} }
function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    const _r117 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-toggle-select", 88);
    i0.ɵɵlistener("optionSelected", function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_14_Template_vnext_toggle_select_optionSelected_1_listener($event) { i0.ɵɵrestoreView(_r117); const ctx_r116 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r116.onSelectAllowAccessToAllPlanYears($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r72 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r85 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("items", ctx_r85.allowAccessToAllPlanYearsOptions)("buttonHeight", "36px")("selectedValue", ctx_r85.getAllowAccessToAllPlanYearsRequiredDefaultValue())("largerText", true)("isReadOnly", ctx_r85.getAllowAccessToAllPlanYearsDisabled())("ariaLabelledById", control_r72.keyName + "LabelId");
} }
function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    const _r120 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-checkbox-dropdown", 91);
    i0.ɵɵlistener("onSelect", function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_15_Template_vnext_checkbox_dropdown_onSelect_1_listener($event) { i0.ɵɵrestoreView(_r120); const ctx_r119 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r119.updatePlanYear($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r72 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r86 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControlName", control_r72.keyName)("options", ctx_r86.Spa_Agent_AccountOverview_AgentPlanYear_Json)("placeholder", ctx_r86.Spa_Agent_AccountOverview_AgentPlanYear_Placeholder)("selectedItemsDisplayTransform", ctx_r86.selectedItemsDisplayTransform)("submitted", ctx_r86.submitted)("disabled", ctx_r86.getAgentPlanYearsDisabled())("locale", ctx_r86.locale)("ariaLabelledById", control_r72.keyName + "LabelId")("fieldId", control_r72.keyName);
} }
function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    const _r123 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-med-sup-date", 92);
    i0.ɵɵlistener("sendDate", function AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_16_Template_vnext_med_sup_date_sendDate_1_listener($event) { i0.ɵɵrestoreView(_r123); const ctx_r122 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r122.setSelectedDate($event)); });
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r72 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r87 = i0.ɵɵnextContext(2);
    let tmp_5_0;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("customClass", "Spa_Style_Small_Font Spa_Style_Primary_Color")("defaultValue", i0.ɵɵpipeBind2(2, 7, ctx_r87.getDefaultDateValue(), "MM/dd/yyyy"))("showDatePicker", true)("fullWidth", true)("isReadOnly", control_r72.disabled)("hasError", ctx_r87.submitted && !((tmp_5_0 = ctx_r87.getAccountFormControl(control_r72.keyName)) == null ? null : tmp_5_0.valid) && ((tmp_5_0 = ctx_r87.getAccountFormControl(control_r72.keyName)) == null ? null : tmp_5_0.touched))("ariaLabelledById", control_r72.keyName + "LabelId");
} }
function AccountOverviewComponent_form_17_div_2_ng_container_1_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 93);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r88 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r88.Spa_Agent_Password_Description, " ");
} }
function AccountOverviewComponent_form_17_div_2_ng_container_1_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 93);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r89 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r89.roleDescription, " ");
} }
function AccountOverviewComponent_form_17_div_2_ng_container_1_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 93);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r90 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r90.siteAccessDescription, " ");
} }
function AccountOverviewComponent_form_17_div_2_ng_container_1_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 93);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r91 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r91.Spa_Agent_AccountOverview_AllowAccess_AgentPlanYear_Description, " ");
} }
function AccountOverviewComponent_form_17_div_2_ng_container_1_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 93);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r92 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r92.Spa_Agent_AccountOverview_AgentPlanYear_Description, " ");
} }
function AccountOverviewComponent_form_17_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 58);
    i0.ɵɵtemplate(2, AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_2_Template, 4, 1, "ng-container", 1);
    i0.ɵɵtemplate(3, AccountOverviewComponent_form_17_div_2_ng_container_1_ng_template_3_Template, 1, 1, "ng-template", null, 79, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 59);
    i0.ɵɵtemplate(6, AccountOverviewComponent_form_17_div_2_ng_container_1_label_6_Template, 3, 7, "label", 80);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_7_Template, 2, 6, "ng-container", 6);
    i0.ɵɵtemplate(8, AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_8_Template, 2, 8, "ng-container", 6);
    i0.ɵɵtemplate(9, AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_9_Template, 3, 1, "ng-container", 6);
    i0.ɵɵtemplate(10, AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_10_Template, 2, 5, "ng-container", 6);
    i0.ɵɵtemplate(11, AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_11_Template, 2, 6, "ng-container", 6);
    i0.ɵɵtemplate(12, AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_12_Template, 2, 5, "ng-container", 6);
    i0.ɵɵtemplate(13, AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_13_Template, 2, 6, "ng-container", 6);
    i0.ɵɵtemplate(14, AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_14_Template, 2, 6, "ng-container", 6);
    i0.ɵɵtemplate(15, AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_15_Template, 2, 9, "ng-container", 6);
    i0.ɵɵtemplate(16, AccountOverviewComponent_form_17_div_2_ng_container_1_ng_container_16_Template, 3, 10, "ng-container", 6);
    i0.ɵɵtemplate(17, AccountOverviewComponent_form_17_div_2_ng_container_1_div_17_Template, 2, 1, "div", 81);
    i0.ɵɵtemplate(18, AccountOverviewComponent_form_17_div_2_ng_container_1_div_18_Template, 2, 1, "div", 81);
    i0.ɵɵtemplate(19, AccountOverviewComponent_form_17_div_2_ng_container_1_div_19_Template, 2, 1, "div", 81);
    i0.ɵɵtemplate(20, AccountOverviewComponent_form_17_div_2_ng_container_1_div_20_Template, 2, 1, "div", 81);
    i0.ɵɵtemplate(21, AccountOverviewComponent_form_17_div_2_ng_container_1_div_21_Template, 2, 1, "div", 81);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r75 = i0.ɵɵreference(4);
    const control_r72 = i0.ɵɵnextContext().$implicit;
    const ctx_r73 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r73.submitted && ctx_r73.hasError(control_r72.keyName))("ngIfElse", _r75);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r73.accountControlIsDisplayed(control_r72.keyName));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r73.getControlType(control_r72.keyName) === "input");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r73.AgencyHierarchy_Enabled && control_r72.keyName === ctx_r73.accountOverviewInputs.AGENT_AGENCY_NAME);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", control_r72.keyName === ctx_r73.accountOverviewInputs.SITE_ACCESS && (ctx_r73.Spa_Agent_Show_New_Agent || ctx_r73.isAdminUser));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", control_r72.keyName === ctx_r73.accountOverviewInputs.ACCOUNT_STATUS && (ctx_r73.Spa_Agent_Show_New_Agent || ctx_r73.isAdminUser));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", control_r72.keyName === ctx_r73.accountOverviewInputs.ASP_REQUIRED);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", control_r72.keyName === ctx_r73.accountOverviewInputs.AGENT_PERMISSION_LEVEL && (ctx_r73.Spa_Agent_Show_New_Agent || ctx_r73.isAdminUser));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", control_r72.keyName === ctx_r73.accountOverviewInputs.PROFILE_ADMIN);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r73.Spa_Agent_AccountOverview_AgentPlanYear_Display && control_r72.keyName === ctx_r73.accountOverviewInputs.ASP_ALLOW_ACCESS_TO_ALL_PLAN_YEARS);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r73.Spa_Agent_AccountOverview_AgentPlanYear_Display && !ctx_r73.allowAccessToAllPlanYears && control_r72.keyName === ctx_r73.accountOverviewInputs.ASP_AGENT_PLAN_YEARS);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", control_r72.keyName === ctx_r73.accountOverviewInputs.AGENT_EXPIRATION_DATE);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", control_r72.keyName === ctx_r73.accountOverviewInputs.AGENT_PASSWORD && (ctx_r73.Spa_Agent_Show_New_Agent || ctx_r73.isAdminUser));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", control_r72.keyName === ctx_r73.accountOverviewInputs.AGENT_PERMISSION_LEVEL);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", control_r72.keyName === ctx_r73.accountOverviewInputs.SITE_ACCESS && (ctx_r73.Spa_Agent_Show_New_Agent || ctx_r73.isAdminUser));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r73.Spa_Agent_AccountOverview_AgentPlanYear_Display && control_r72.keyName === ctx_r73.accountOverviewInputs.ASP_ALLOW_ACCESS_TO_ALL_PLAN_YEARS);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r73.Spa_Agent_AccountOverview_AgentPlanYear_Display && !ctx_r73.allowAccessToAllPlanYears && control_r72.keyName === ctx_r73.accountOverviewInputs.ASP_AGENT_PLAN_YEARS);
} }
function AccountOverviewComponent_form_17_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 78);
    i0.ɵɵtemplate(1, AccountOverviewComponent_form_17_div_2_ng_container_1_Template, 22, 18, "ng-container", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const control_r72 = ctx.$implicit;
    const ctx_r70 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r70.getAccountFormControl(control_r72.keyName));
} }
function AccountOverviewComponent_form_17_div_3_label_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 99);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r126 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r126.Spa_Agent_AccountOverview_AgenciesHeader_Text, " ");
} }
function AccountOverviewComponent_form_17_div_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 100);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r127 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r127.Spa_Agent_AccountOverview_AgenciesInstructional_Text, " ");
} }
function AccountOverviewComponent_form_17_div_3_ng_container_4_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 103)(1, "div", 104);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const agency_r132 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", agency_r132.agencyName);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(agency_r132.agencyName);
} }
function AccountOverviewComponent_form_17_div_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 101);
    i0.ɵɵtemplate(2, AccountOverviewComponent_form_17_div_3_ng_container_4_div_2_Template, 3, 2, "div", 102);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r128 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r128.selectedUserAgencies);
} }
function AccountOverviewComponent_form_17_div_3_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 105)(1, "div", 106);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 107);
    i0.ɵɵpipe(4, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r130 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r130.Spa_Agent_No_Agency_Header_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 2, ctx_r130.Spa_Agent_No_Agency_Sub_Header_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function AccountOverviewComponent_form_17_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 94)(1, "div", 95);
    i0.ɵɵtemplate(2, AccountOverviewComponent_form_17_div_3_label_2_Template, 2, 1, "label", 96);
    i0.ɵɵtemplate(3, AccountOverviewComponent_form_17_div_3_div_3_Template, 2, 1, "div", 97);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, AccountOverviewComponent_form_17_div_3_ng_container_4_Template, 3, 1, "ng-container", 1);
    i0.ɵɵtemplate(5, AccountOverviewComponent_form_17_div_3_ng_template_5_Template, 5, 5, "ng-template", null, 98, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r129 = i0.ɵɵreference(6);
    const ctx_r71 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_AccountOverview_AgenciesHeader_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_AccountOverview_AgenciesInstructional_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r71.selectedUserAgencies == null ? null : ctx_r71.selectedUserAgencies.length)("ngIfElse", _r129);
} }
function AccountOverviewComponent_form_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "form", 75)(1, "div", 54);
    i0.ɵɵtemplate(2, AccountOverviewComponent_form_17_div_2_Template, 2, 1, "div", 76);
    i0.ɵɵtemplate(3, AccountOverviewComponent_form_17_div_3_Template, 7, 4, "div", 77);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r12.accountFormGroup);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r12.agentAccountForm)("ngForTrackBy", ctx_r12.trackIndex);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.AgencyHierarchy_Enabled && !ctx_r12.Spa_Agent_Show_New_Agent);
} }
function AccountOverviewComponent_vnext_status_button_21_Template(rf, ctx) { if (rf & 1) {
    const _r134 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-status-button", 108);
    i0.ɵɵlistener("click", function AccountOverviewComponent_vnext_status_button_21_Template_vnext_status_button_click_0_listener() { i0.ɵɵrestoreView(_r134); const ctx_r133 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r133.saveAgentInfo()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵproperty("buttonText", ctx_r13.Spa_Agent_AccountOverview_Button_Text)("buttonClass", "Spa_Style_PrimaryButton")("tooltipMessageError", ctx_r13.Spa_Agent_AccountOverview_TooltipError_Text)("tooltipMessageSuccess", ctx_r13.Spa_Agent_AccountOverview_TooltipSuccess_Text);
} }
function AccountOverviewComponent_div_22_h2_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 114, 115);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r135 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r135.Spa_Site_ActiveSellingPermissions_Text, " ");
} }
function AccountOverviewComponent_div_22_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r142 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 116)(1, "vnext-link", 117);
    i0.ɵɵlistener("click", function AccountOverviewComponent_div_22_div_4_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r142); const ctx_r141 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r141.openAddPermissionsPopover()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r136 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r136.Spa_Agent_Add_Permission_Link_Text)("additionalIcon", "fas fa-plus-circle");
} }
function AccountOverviewComponent_div_22_vnext_link_6_Template(rf, ctx) { if (rf & 1) {
    const _r144 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 117);
    i0.ɵɵlistener("click", function AccountOverviewComponent_div_22_vnext_link_6_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r144); const ctx_r143 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r143.openFilterPermissionsPopover()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r137 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r137.Spa_Filter_Header_Text)("additionalIcon", "fas fa-filter");
} }
function AccountOverviewComponent_div_22_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-link", 118);
} if (rf & 2) {
    const ctx_r139 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r139.Spa_Filter_Header_Text)("additionalIcon", "fas fa-filter")("disabled", true);
} }
function AccountOverviewComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, AccountOverviewComponent_div_22_h2_1_Template, 3, 1, "h2", 109);
    i0.ɵɵelementStart(2, "div", 54)(3, "div", 110);
    i0.ɵɵtemplate(4, AccountOverviewComponent_div_22_div_4_Template, 2, 2, "div", 111);
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵtemplate(6, AccountOverviewComponent_div_22_vnext_link_6_Template, 1, 2, "vnext-link", 112);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵtemplate(8, AccountOverviewComponent_div_22_ng_template_8_Template, 1, 3, "ng-template", null, 113, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const _r138 = i0.ɵɵreference(9);
    const ctx_r14 = i0.ɵɵnextContext();
    let tmp_2_0;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_ActiveSellingPermissions_Text");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r14.showAddPermissionsLink && ctx_r14.isAdminUser);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (tmp_2_0 = i0.ɵɵpipeBind1(7, 4, ctx_r14.agentSellingPermissions$)) == null ? null : tmp_2_0.length)("ngIfElse", _r138);
} }
function AccountOverviewComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 119, 120);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r19 = i0.ɵɵreference(30);
    i0.ɵɵproperty("ngbPopover", _r19)("autoClose", false);
} }
function AccountOverviewComponent_ng_template_27_Template(rf, ctx) { if (rf & 1) {
    const _r147 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-filter-selling-permissions", 121);
    i0.ɵɵlistener("closePopover", function AccountOverviewComponent_ng_template_27_Template_vnext_filter_selling_permissions_closePopover_0_listener($event) { i0.ɵɵrestoreView(_r147); const ctx_r146 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r146.filterPermissionsPopoverClosed($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵproperty("planYearHeader", ctx_r18.Spa_Agent_Permission_Plan_Year_Header)("carrierHeader", ctx_r18.Spa_Agent_Permission_Carries_Header)("statesHeader", ctx_r18.Spa_Agent_Permission_States_Header)("planTypeHeader", ctx_r18.Spa_Agent_Permission_Plan_Type_Header)("clearAllText", ctx_r18.Spa_Site_ClearAll_Text)("applyText", ctx_r18.Spa_PlanFilters_Modal_Apply_Button)("viewPermissionsText", ctx_r18.Spa_Agent_ViewPermissions_Text)("yearSelectionEnabled", ctx_r18.Spa_Agent_Permission_Year_Selection_Enabled);
} }
function AccountOverviewComponent_ng_template_29_Template(rf, ctx) { if (rf & 1) {
    const _r149 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-add-agent-selling-permissions", 122);
    i0.ɵɵlistener("closePopover", function AccountOverviewComponent_ng_template_29_Template_vnext_add_agent_selling_permissions_closePopover_0_listener() { i0.ɵɵrestoreView(_r149); const ctx_r148 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r148.addPermissionsPopoverClosed()); })("openPopover", function AccountOverviewComponent_ng_template_29_Template_vnext_add_agent_selling_permissions_openPopover_0_listener() { i0.ɵɵrestoreView(_r149); const ctx_r150 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r150.openAddPermissionsPopover()); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext();
    i0.ɵɵproperty("agentGuid", ctx_r20.agentData.agentGuid)("sellingPermissionFormLink", ctx_r20.Spa_Agent_Add_Permission_Link_Text)("carriers", i0.ɵɵpipeBind1(1, 33, ctx_r20.carriers$))("permissions", i0.ɵɵpipeBind1(2, 35, ctx_r20.agentSellingPermissions$))("permissionTypeHeader", ctx_r20.Spa_Agent_Permission_Type_Header)("permissionTypeError", ctx_r20.Spa_Agent_Permission_PermissionType_Error)("permissionPlanYearError", ctx_r20.Spa_Agent_Permission_Plan_Year_Selection_Error)("permissionCarrierError", ctx_r20.Spa_Agent_Permission_Carrier_Selection_Error)("permissionStatesError", ctx_r20.Spa_Agent_Permission_State_Selection_Error)("permissionPlanTypeError", ctx_r20.Spa_Agent_Permission_Plan_Type_Error)("permissionProducerIDError", ctx_r20.Spa_Agent_Permission_Producer_Id_Error)("permissionMedicareToggleOptions", ctx_r20.permissionMedicareToggleOptions)("medicarePlanYearSelectionJsonItems", ctx_r20.medicarePlanYearSelectionJsonItems)("defaultPlanYear", ctx_r20.planYear)("planYearHeader", ctx_r20.Spa_Agent_Permission_Plan_Year_Header)("carrierHeader", ctx_r20.Spa_Agent_Permission_Carries_Header)("statesHeader", ctx_r20.Spa_Agent_Permission_States_Header)("planTypeHeader", ctx_r20.Spa_Agent_Permission_Plan_Type_Header)("snpHeader", ctx_r20.Spa_Agent_Permission_SNP_Header)("producerIdHeader", ctx_r20.Spa_Agent_Permission_Producer_Id_Header)("permissionButton", ctx_r20.Spa_Agent_Add_Permission_Button_Text)("allStatesOption", ctx_r20.Spa_Agent_Permission_All_States_Option)("allPlanTypesOption", ctx_r20.Spa_Agent_Permission_All_Plan_Type_Option)("allSnpOption", ctx_r20.Spa_Agent_Permission_All_SNP_Option)("selectCarrierText", ctx_r20.Spa_Agent_Permission_Select_Carrier_Text)("selectStatesText", ctx_r20.Spa_Agent_Permission_Select_State_Text)("editStatesText", ctx_r20.Spa_Agent_Permission_Edit_State_Text)("selectPlanTypesText", ctx_r20.Spa_Agent_Permission_Select_Plan_Type_Text)("editPlanTypesText", ctx_r20.Spa_Agent_Permission_Edit_Plan_Type_Text)("selectSnpText", ctx_r20.Spa_Agent_Permission_Select_SNP_Text)("editSnpText", ctx_r20.Spa_Agent_Permission_Edit_SNP_Text)("listOfFieldValidations", ctx_r20.Spa_Agent_Permission_Field_Validations)("clearAllText", ctx_r20.Spa_Filter_Clear_All);
} }
function AccountOverviewComponent_div_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "vnext-active-selling-permissions", 123);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("agentData", ctx_r21.agentData)("carriers", i0.ɵɵpipeBind1(2, 24, ctx_r21.carriers$))("headerText", ctx_r21.Spa_Site_ActiveSellingPermissions_Text)("carrierHeader", ctx_r21.Spa_Agent_Permission_Carries_Header)("stateHeader", ctx_r21.Spa_Agent_Permission_States_Header)("planTypeHeader", ctx_r21.Spa_Agent_Permission_Plan_Type_Header)("planYearHeader", ctx_r21.Spa_Agent_Permission_Plan_Year_Header)("producerIdHeader", ctx_r21.Spa_Agent_Permission_Producer_Id_Header)("agentSellingPermissions", i0.ɵɵpipeBind1(3, 26, ctx_r21.filteredAgentSellingPermissions$))("itemsPerPage", ctx_r21.Spa_Site_Pagination_ItemsPerPage)("paginationText", ctx_r21.Spa_Site_Pagination_View_Text)("paginationEnabled", ctx_r21.Spa_PharmacySearch_Pagination_Enabled)("enableProducerIdColumn", ctx_r21.Spa_Agent_AccountOverview_ProducerId_Enabled)("noPermissionsTitle", ctx_r21.Spa_Agent_NoPermissions_Title)("noPermissionsBody", ctx_r21.Spa_Agent_NoPermissions_Body)("noPermissionsIcon", ctx_r21.Spa_Agent_NoPermissions_Icon)("noPermissionsAfterFiltersTitle", ctx_r21.Spa_Agent_NoPermissionsAfterFilters_Title)("noPermissionsAfterFiltersBody", ctx_r21.Spa_Agent_NoPermissionsAfterFilters_Body)("medSupAbbrev", ctx_r21.Spa_Agent_MedSupAbbreviation_Label)("ancillaryAbbrev", ctx_r21.Spa_Site_Ancillary_Text)("mappedCarriersText", ctx_r21.Spa_Site_ActiveSellingPermissions_Mapped_Carriers_Text)("noSNPText", ctx_r21.Spa_Agent_NoSNP_Label)("notApplicableText", ctx_r21.Spa_Site_NotApplicable_Text)("showRemoveCol", ctx_r21.Spa_Agent_ActiveSellingPermissions_AddRemove_Enabled && ctx_r21.isAdminUser);
} }
let AccountOverviewComponent = class AccountOverviewComponent extends ConfigurableWidget {
    constructor(agentService, cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, deactivationGuardService, formValidationService, modalService, accountOverviewFacade, store, unsavedModalContext, agentPermissionsService, navigationService, router, analyticsService, element, spinnerService, activatedRoute, aspFilterService, localeService, planYearResourceService, siteService, injector, configResourceService, agentRetireFloFacade) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.agentService = agentService;
        this.deactivationGuardService = deactivationGuardService;
        this.formValidationService = formValidationService;
        this.modalService = modalService;
        this.accountOverviewFacade = accountOverviewFacade;
        this.store = store;
        this.unsavedModalContext = unsavedModalContext;
        this.agentPermissionsService = agentPermissionsService;
        this.navigationService = navigationService;
        this.router = router;
        this.analyticsService = analyticsService;
        this.element = element;
        this.spinnerService = spinnerService;
        this.activatedRoute = activatedRoute;
        this.aspFilterService = aspFilterService;
        this.localeService = localeService;
        this.planYearResourceService = planYearResourceService;
        this.siteService = siteService;
        this.injector = injector;
        this.configResourceService = configResourceService;
        this.agentRetireFloFacade = agentRetireFloFacade;
        this.Spa_Agent_AccountOverview_Enabled = true;
        this.Spa_Agent_AccountOverview_Header_Text = 'Account overview';
        this.Spa_Agent_AccountOverview_PersonalHeader_Text = 'Personal information';
        this.Spa_Agent_AccountOverview_AccountHeader_Text = 'Account information';
        this.Spa_Agent_AccountOverview_Button_Text = 'Save';
        this.Spa_Agent_AccountOverview_TooltipError_Text = 'Try again';
        this.Spa_Agent_AccountOverview_TooltipSuccess_Text = 'Saved';
        this.Spa_Agent_AccountOverview_Purl_Enabled = true;
        this.Spa_Agent_AccountOverview_ShoppingLink_Header_Text = 'My shopping link';
        this.Spa_Agent_AccountOverview_ShoppingLink_Content_Text = "Send your personalized link to the client to get them started with shopping for plans. Don't worry, you will get credit if the consumer enrolls in any of these plans.";
        this.Spa_Agent_AccountOverview_CopyLink_Text = 'Copy 2023 link';
        this.Spa_Agent_AccountOverview_CopiedInfo_Text = 'Copied';
        this.Spa_Site_PageSubHeader_Text = '';
        this.Spa_Agent_AddAgent_Header_Text = 'New agent account';
        this.Spa_Site_ActiveSellingPermissions_Text = 'Active selling permissions';
        this.Spa_Agent_AccountOverview_AgenciesHeader_Text = 'Agencies';
        this.Spa_Agent_AccountOverview_AgenciesInstructional_Text = 'This user is associated with and has access to the following agencies.';
        this.Spa_RetireFlo_Enabled = false;
        this.Spa_Agent_RetireFlo_LogIn_URL = '';
        this.Spa_RetireFlo_SignUp_URL = '';
        this.Spa_Agent_AccountOverview_RetireFlo_SignUp_ButtonText = 'Sign Up';
        this.Spa_Agent_AccountOverview_RetireFlo_LogIn_ButtonText = 'Log In';
        this.Spa_Agent_AccountOverview_RetireFlo_Header_Text = 'Retire Flo';
        this.Spa_Agent_AccountOverview_RetireFlo_Content_Text = 'Retireflo is a partner that allows you to send prospects and existing beneficiaries intake forms that can expedite the onboarding process and help keep their information in the ConnectureDRX system up to date.  Click the button below to login or create a new account with RetireFlo.';
        this.Spa_Site_ActiveSellingPermissions_Mapped_Carriers_Text = 'Note: Selling permissions are displayed only for carriers mapped to the site.';
        this.Spa_Site_Carrier_Header = 'Carrier';
        this.Spa_Site_State_Header = 'State';
        this.Spa_Site_PlanType_Header = 'Plan Type';
        this.Spa_Site_Pagination_ItemsPerPage = 10;
        this.Spa_PharmacySearch_Pagination_Enabled = false;
        this.Spa_Agent_ActiveSellingPermissions_Enabled = true;
        this.Spa_Agent_ActiveSellingPermissions_Link_Enabled = true;
        this.Spa_Site_Pagination_View_Text = 'Viewing <startPageItem> - <endPageItem> of <totalPages>';
        this.Spa_Agent_Revoke_SiteAccess_Text = 'Revoke Access';
        this.Spa_Agent_Grant_SiteAccess_Text = 'Grant access';
        this.Spa_Agent_Revoke_SiteAccess_Description = 'This user has access to the site.';
        this.Spa_Agent_Grant_SiteAccess_Description = 'This user does not have access to this site.';
        this.Spa_Agent_Password_Description = 'Must contain at least 8 characters with 1 number and 1 capital letter.';
        this.Spa_AgentSearch_ActiveStatus_Text = 'Active';
        this.Spa_AgentSearch_InactiveStatus_Text = 'Inactive';
        this.Spa_Agent_Add_Permission_Link_Text = 'Add selling permissions';
        this.Spa_Agent_Permission_Type_Header = 'What type of permission are you adding?';
        this.Spa_Agent_Permission_Medicare_Text = 'Medicare';
        this.Spa_Agent_Permission_Medicare_Supplement_Text = 'Medicare Supplement';
        this.Spa_Site_Ancillary_Text = 'Ancillary';
        this.Spa_Agent_Permission_Plan_Year_Header = 'Plan year';
        this.Spa_Agent_Permission_Current_Year_Header = 'Current year';
        this.Spa_Agent_Permission_Next_Year_Header = 'Next plan year';
        this.Spa_Agent_Permission_Carries_Header = 'Carrier';
        this.Spa_Agent_Permission_States_Header = 'States';
        this.Spa_Agent_Permission_Plan_Type_Header = 'Plan type';
        this.Spa_Agent_Permission_SNP_Header = 'SNP';
        this.Spa_Agent_Permission_Producer_Id_Header = 'Producer ID';
        this.Spa_Agent_Add_Permission_Button_Text = 'Add permissions';
        this.Spa_Filter_Clear_All = 'Clear all';
        this.Spa_Agent_Permission_Select_Carrier_Text = 'Select carrier';
        this.Spa_Agent_Permission_Select_State_Text = 'Select state(s)';
        this.Spa_Agent_Permission_Edit_State_Text = 'Edit state(s)';
        this.Spa_Agent_Permission_Select_Plan_Type_Text = 'Select plan type(s)';
        this.Spa_Agent_Permission_Edit_Plan_Type_Text = 'Edit plan type(s)';
        this.Spa_Agent_Permission_Select_SNP_Text = 'Select SNPs';
        this.Spa_Agent_Permission_Edit_SNP_Text = 'Edit SNPs';
        this.Spa_Agent_Permission_Field_Validations = {
            [AccountAddPermissionsInputs.ADD_CARRIER]: { isRequired: true },
            [AccountAddPermissionsInputs.ADD_STATES]: { isRequired: true },
            [AccountAddPermissionsInputs.ADD_PLAN_TYPE]: { isRequired: true },
            [AccountAddPermissionsInputs.ADD_PRODUCER_ID]: { isRequired: true }
        };
        this.Spa_Agent_Permission_Is_State_Required = true;
        this.Spa_Agent_Permission_Is_PlanType_Required = true;
        this.Spa_Agent_Permission_Is_Producer_Id_Required = true;
        this.Spa_Agent_Permission_All_States_Option = 'All states';
        this.Spa_Agent_Permission_All_Plan_Type_Option = 'All plan types';
        this.Spa_Agent_Permission_All_SNP_Option = 'All SNPs';
        this.Spa_Agent_Permission_PermissionType_Error = 'Please select permission type';
        this.Spa_Agent_Permission_Plan_Year_Selection_Error = 'Please select plan year';
        this.Spa_Agent_Permission_Carrier_Selection_Error = 'Please select carrier';
        this.Spa_Agent_Permission_State_Selection_Error = 'Please select state(s)';
        this.Spa_Agent_Permission_Plan_Type_Error = 'Please select plan type';
        this.Spa_Agent_Permission_Producer_Id_Error = 'Please provide producer id';
        this.Spa_Agent_Permission_Year_Selection_Enabled = false;
        this.Spa_Agent_Show_New_Agent = false;
        this.Spa_Member_Profile_ErrorMessages_TitleText = 'Correct the following error(s) on the form, then submit again';
        this.Spa_Site_New_Agent_ResetPasswordRequired = true;
        this.Spa_Agent_ViewAgentProfile_AccountForm = this.accountOverviewFacade.agentViewAccountFormConfig;
        this.Spa_Agent_Create_AccountForm = this.accountOverviewFacade.defaultAgentAccountFormConfig;
        this.Spa_Agent_AccountOverview_AccountForm = this.accountOverviewFacade.defaultAccountFormConfig;
        this.Spa_Agent_AccountOverview_PersonalForm = this.accountOverviewFacade.personalFormConfig;
        this.Spa_Agent_Create_PersonalForm = this.accountOverviewFacade.agentPersonalFormConfig;
        this.Spa_Agent_ViewAgentProfile_PersonalForm = this.accountOverviewFacade.agentViewPersonalFormConfig;
        this.Spa_Agent_Profile_Picture_Upload_Enabled = true;
        this.Spa_Agent_ASPRequiredYes_Text = 'Yes';
        this.Spa_Agent_ASPRequiredNo_Text = 'No';
        this.Spa_Agent_AccountOverview_ASPRequired_Text = 'Selling permissions required';
        this.Spa_Agent_AccountOverview_ProducerId_Enabled = false;
        this.Spa_Agent_NoPermissions_Title = 'No permissions added';
        this.Spa_Agent_NoPermissions_Body = 'Add selling permissions above for this agent.';
        this.Spa_Agent_ProducerId_Text = 'ProducerID';
        this.Spa_Agent_PlanYear_Text = 'Plan year';
        this.Spa_Agent_NoPermissions_Icon = 'fa fa-list-ul';
        this.Spa_Site_UploadLink_Text = 'Upload';
        this.Spa_Agent_Profile_Picture_Header = 'My picture';
        this.Spa_Agent_Profile_Picture_Content = 'This image will be used on the consumer shopping site and email signatures.';
        this.Spa_Agent_AccountOverview_RetireFlo_PURL_ButtonText = 'Copy link with RetireFlo';
        this.Spa_Agent_AccountOverview_RetireFlo_PURL_DescriptionText = 'Send this link to new members to complete a RetireFlo Survey. Upon completion of the survey, a new profile will be created.';
        this.Spa_Agent_Profile_Picture_Instruction_Text = 'Please upload a .gif, .png, or .jpg, less than 5 MB.';
        this.Spa_Filter_Header_Text = 'Filters';
        this.Spa_Site_ClearAll_Text = 'Clear all';
        this.Spa_PlanFilters_Modal_Apply_Button = 'Apply';
        this.Spa_Agent_MedSupAbbreviation_Label = 'Med Supp';
        this.Spa_Agent_NoSNP_Label = 'No SNP';
        this.Spa_Site_NotApplicable_Text = 'N/A';
        this.Spa_Agent_NoPermissionsAfterFilters_Title = 'No results';
        this.Spa_Agent_NoPermissionsAfterFilters_Body = 'Please remove some or clear all of your filters to view results';
        this.Spa_Agent_ActiveSellingPermissions_AddRemove_Enabled = true;
        this.Spa_Agent_ViewPermissions_Text = 'View Permissions';
        this.AgencyHierarchy_Enabled = false;
        this.Spa_Agent_No_Agency_Header_Text = 'No agencies available';
        this.Spa_Agent_No_Agency_Sub_Header_Text = "<p>Update the user's assigned agency to associate them with and grant access to agencies.</p>";
        this.Spa_Site_None_Available_Text = 'None available';
        this.Spa_Agent_AccountOverview_Purl_DualPlanYear_Enabled = false;
        this.Spa_ConsumerSiteID_Enabled = false;
        this.Spa_Agent_Permission_PlanYearSelectionJson_Enabled = false;
        this.Spa_Agent_Permission_PlanYearSelection_Json = [];
        this.Spa_Agent_AccountOverview_CopyDualPlanYearLink_Text = 'Copy 2022 link';
        this.Spa_Agent_AccountOverview_AgentPlanYear_Display_Admin = false;
        this.Spa_Agent_AccountOverview_AgentPlanYear_Display = false;
        this.Spa_Agent_AccountOverview_AgentPlanYear_Required = true;
        this.Spa_Agent_AccountOverview_AgentPlanYear_Placeholder = 'Select plan year(s)';
        this.Spa_Agent_AccountOverview_AgentPlanYear_Edit_Placeholder = 'Edit Plan Year(s)';
        this.Spa_Agent_AccountOverview_AgentPlanYear_Json = [
            {
                label: `${this.planYearResourceService.getCurrentPlanYear()}`,
                value: this.planYearResourceService.getCurrentPlanYear(),
                disabled: false,
                initiallyChecked: false
            },
            {
                label: `${this.planYearResourceService.getDualPlanYear()}`,
                value: this.planYearResourceService.getDualPlanYear(),
                disabled: false,
                initiallyChecked: false
            }
        ];
        this.Spa_Agent_AccountOverview_AllowAccess_AgentPlanYear_Description = 'May view plans for all available plan year(s)';
        this.Spa_Agent_AccountOverview_AgentPlanYear_Description = 'May view plans for year(s) selected';
        this.Spa_Agent_ProfileAdminFlag_Enabled = false;
        this.Spa_Site_Yes = 'Yes';
        this.Spa_Site_No = 'No';
        this.Spa_RetireFlo_SignUpModal_ContinueButton_Text = 'Continue to RetireFlo';
        this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Cancel = 'Cancel';
        this.Spa_RetireFlo_SignUpModalHeader_Text = 'RetireFlo sign up';
        this.Spa_RetireFlo_SignUpModalContent_Text = 'TBD, pending conversation with RetireFlo about what needs to be collected on our side and language';
        this.Spa_RetireFlo_SignUpModalLogo_URL = 'RetireFlow Logo URL';
        this.Spa_Agent_AccountOverview_ManageMySubscription_Enabled = false;
        this.Spa_Agent_AccountOverview_ManageMySubscriptionHeader_Text = 'Manage my subscription';
        this.Spa_Agent_AccountOverview_ManageMySubscription_Html = 'To update your payment information or to unsubscribe from PlanCompare for Agents, please click the link below.';
        this.Spa_Agent_AccountOverview_ManageMySubscription_Link_Text = 'Manage my subscription';
        this.Spa_Agent_AccountOverview_ManageMySubscription_Url = '';
        this.Spa_Agent_AccountOverview_RetireFlo_PURL_Enabled = false;
        this.submitted = false;
        this.defaultStartItem = 1;
        this.pageIndex = 1;
        this.accountOverviewInputs = AccountOverviewInputs;
        this.defaultValue = DEFAULT_DATE;
        this.isUserNameAlreadyExists = false;
        this.subscriptions = new Subscription();
        this.setFocus = false;
        this.fileUploadErrors = [];
        this.showAddPermissionsLink = false;
        this.showPermissionTable = false;
        this.permissionMedicareToggleOptions = [];
        this.permissionMedicareSupplementToggleOptions = [];
        this.permissionFormVisible = false;
        this.filterFormVisible = false;
        this.permissionPopoverOpen = false;
        this.filterPopoverOpen = false;
        this.agentPlanYears = [];
        this.agentHasPermissionForCurrentPlanYearPurl = false;
        this.agentHasPermissionForDualPlanYearPurl = false;
        this.medicarePlanYearSelectionJsonItems = [];
        this.agentHasRetireFlo = false;
        this.targetType = TargetType;
        this.selectedItemsDisplayTransform = (items) => {
            if (items.length) {
                if (items.length <= 2) {
                    return this.commaConcatenate(items);
                }
                return this.Spa_Agent_AccountOverview_AgentPlanYear_Edit_Placeholder;
            }
            return null;
        };
    }
    openAddPermissionsPopover() {
        if (this.permissionPopover) {
            if (this.filterPopover) {
                this.filterPopoverOpen = false;
                this.filterPopover.close();
            }
            this.permissionPopoverOpen = !this.permissionPopoverOpen;
            this.permissionPopoverOpen ? this.permissionPopover.open() : this.permissionPopover.close();
        }
    }
    openFilterPermissionsPopover() {
        if (this.filterPopover) {
            if (this.permissionPopover) {
                this.permissionPopoverOpen = false;
                this.permissionPopover.close();
            }
            this.filterPopoverOpen = !this.filterPopoverOpen;
            this.filterPopoverOpen ? this.filterPopover.open() : this.filterPopover.close();
        }
    }
    addPermissionsPopoverClosed() {
        if (this.permissionPopover) {
            this.permissionPopoverOpen = false;
            this.permissionPopover.close();
        }
    }
    filterPermissionsPopoverClosed(scrollTableIntoView) {
        if (this.filterPopover) {
            this.filterPopoverOpen = false;
            this.filterPopover.close();
            if (scrollTableIntoView) {
                this.sellingPermissionsTable.nativeElement.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }
    preProcessProperties() {
        this.permissionMedicareToggleOptions = [
            { display: this.Spa_Agent_Permission_Medicare_Text, value: false },
            { display: this.Spa_Agent_Permission_Medicare_Supplement_Text, value: PlanType.MEDIGAP },
            { display: this.Spa_Site_Ancillary_Text, value: PlanType.ALL_ANCILLARY }
        ];
        this.planYear = this.planYearResourceService.getSelectedPlanYear() || dayjs().format('YYYY');
        this.medicarePlanYearSelectionJsonItems = this.Spa_Agent_Permission_PlanYearSelectionJson_Enabled
            ? this.Spa_Agent_Permission_PlanYearSelection_Json
            : [];
        this.setAccessText(this.accountFormGroup ? this.accountFormGroup.value[AccountOverviewInputs.SITE_ACCESS] : true);
        this.accountStatusItems = [
            { display: this.Spa_AgentSearch_ActiveStatus_Text, value: true },
            { display: this.Spa_AgentSearch_InactiveStatus_Text, value: false }
        ];
        this.aspItems = [
            { display: this.Spa_Agent_ASPRequiredYes_Text, value: true },
            { display: this.Spa_Agent_ASPRequiredNo_Text, value: false }
        ];
        this.allowAccessToAllPlanYearsOptions = [
            { display: this.Spa_Agent_ASPRequiredYes_Text, value: true },
            { display: this.Spa_Agent_ASPRequiredNo_Text, value: false }
        ];
        this.profileAdminOptions = [
            { display: this.Spa_Site_Yes, value: true },
            { display: this.Spa_Site_No, value: false }
        ];
        this.isAdminUser = this.agentPermissionsService.isAdmin();
        if (this.isAdminUser) {
            if (this.Spa_Agent_Show_New_Agent) {
                this.agentPersonalAccountForm = this.Spa_Agent_Create_PersonalForm;
                this.agentAccountForm = this.Spa_Agent_Create_AccountForm;
            }
            else {
                this.agentPersonalAccountForm = this.Spa_Agent_ViewAgentProfile_PersonalForm;
                this.agentAccountForm = this.Spa_Agent_ViewAgentProfile_AccountForm;
            }
        }
        else {
            this.agentPersonalAccountForm = this.Spa_Agent_AccountOverview_PersonalForm;
            this.agentAccountForm = this.Spa_Agent_AccountOverview_AccountForm;
        }
        this.agentPersonalAccountFormByKeyName = this.agentPersonalAccountForm.reduce((personalAccountInputConfigByKey, personalAccountInputConfig) => ({
            ...personalAccountInputConfigByKey,
            [personalAccountInputConfig.keyName]: personalAccountInputConfig
        }), {});
        this.agentPersonalAccountFormByLayoutClassNames = this.getAgentPersonalAccountFormByLayoutClassNames(this.agentPersonalAccountForm, this.agentPersonalAccountFormByKeyName);
        this.agentPersonalAccountForm = this.agentPersonalAccountForm.map(personalAccountInputConfig => ({
            ...personalAccountInputConfig,
            class: [
                this.accountOverviewInputs.AGENT_PHONE_EXTENSION,
                this.accountOverviewInputs.ZIP,
                this.accountOverviewInputs.AGENT_PHONE
            ].includes(personalAccountInputConfig.keyName)
                ? 'reduced-width-1'
                : 'w-100'
        }));
        this.breakRowLayout = this.agentPersonalAccountForm.reduce((breakRowRecord, personalAccountInputConfig) => ({
            ...breakRowRecord,
            [personalAccountInputConfig.keyName]: [
                this.accountOverviewInputs.AGENT_PHONE_EXTENSION,
                this.accountOverviewInputs.AGENT_LAST_NAME
            ].includes(personalAccountInputConfig.keyName)
        }), {});
    }
    setAccessText(hasAccess) {
        if (hasAccess) {
            this.siteAccessButtonText = this.Spa_Agent_Revoke_SiteAccess_Text;
            this.siteAccessDescription = this.Spa_Agent_Revoke_SiteAccess_Description;
        }
        else {
            this.siteAccessButtonText = this.Spa_Agent_Grant_SiteAccess_Text;
            this.siteAccessDescription = this.Spa_Agent_Grant_SiteAccess_Description;
        }
    }
    async ngOnInit() {
        super.ngOnInit();
        this.fetchRetireFloStatus();
        this.isDualPlanYearPurlEnabled = this.planYearResourceService.getIsDualPlanYearPurlEnabled();
        this.agentPlanYears = this.agentService.getAgentPlanYears().map(yearAsNumber => `${yearAsNumber}`);
        this.agentSellingPermissions$ = this.store.select(AgentState.agentSellingPermissions);
        const includeAncillary = this.accountOverviewFacade.getIsAncillaryPlansEnabled();
        this.carriers$ = this.agentService.fetchCarriers$(includeAncillary);
        this.deactivationGuardService.addDeactivationGuard({
            canDeactivate: this.showUnsavedChangesModal.bind(this)
        });
        this.aspFilterService.initFilterForm();
        this.aspFilterService.initControls(includeAncillary);
        this.initializeAccountOverview();
        this.subscriptions.add(this.unsavedModalContext.getUnsavedChangesModalContext$().subscribe(display => {
            if (display) {
                if (!this.accountFormGroup.pristine || !this.personalFormGroup.pristine) {
                    this.showUnsavedChangesModal(true);
                }
                else {
                    this.resetProfile();
                }
            }
        }));
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe(locale => {
            this.locale = locale;
            this.aspFilterService.initControls(includeAncillary);
            this.filterPermissionsPopoverClosed(false);
            this.cdr.markForCheck();
        }));
        if (this.Spa_Agent_AccountOverview_AgentPlanYear_Display) {
            const agentPlanYearSubscription = this.accountFormGroup
                .get(AccountOverviewInputs.ASP_ALLOW_ACCESS_TO_ALL_PLAN_YEARS)
                ?.valueChanges.subscribe(value => {
                const allowAccessToAllPlanYears = value !== null && value !== undefined ? !!value : true;
                this.allowAccessToAllPlanYears = allowAccessToAllPlanYears;
                this.updateAccountFormAgentPlanYearValidators(allowAccessToAllPlanYears);
                if (allowAccessToAllPlanYears) {
                    this.updatePlanYear(null);
                }
                this.cdr.markForCheck();
            });
            if (agentPlanYearSubscription) {
                this.subscriptions.add(agentPlanYearSubscription);
            }
        }
        if (this.AgencyHierarchy_Enabled) {
            this.userAgencyId = this.agentData?.agencyID;
            this.agencyItems = this.accountOverviewFacade.getFilteredAgencies();
            this.isAgencyNameDisabled = this.getAgencyNameDisabled();
            this.disableAgencyID();
        }
        this.aspFilterService.setASPFilterGroup();
        this.updateAgentPurlPermissions();
        this.subscriptions.add(this.planYearResourceService.getSelectedPlanYear$().subscribe({
            next: selectedPlanYear => {
                this.planYear = selectedPlanYear;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.agentService
            .getAgentHasRetireFlo$()
            .pipe(distinctUntilChanged())
            .subscribe(agentHasRetireFlo => {
            this.agentHasRetireFlo = agentHasRetireFlo;
            if (this.agentHasRetireFlo) {
                this.getRetireFloPurl();
            }
            this.cdr.markForCheck();
        }));
        this.cdr.markForCheck();
    }
    ngAfterViewChecked() {
        if (this.setFocus && (this.setFocusOnFirstElement(this.personalFormGroup) || this.setFocusOnFirstElement(this.accountFormGroup))) {
            this.setFocus = false;
        }
    }
    ngAfterViewInit() {
        this.updateAccountFormAgentPlanYearValidators(this.allowAccessToAllPlanYears);
        if (this.Spa_Agent_ActiveSellingPermissions_Enabled) {
            this.loadAgentSellingPermissions();
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.accountOverviewFacade.isViewAgentProfileEnabled = false;
        this.subscriptions.unsubscribe();
    }
    async loadAgentSellingPermissions() {
        await this.agentService.getAgentSellingPermissions(this.agentData?.agentGuid, null, true);
        this.watchPermissionsChange();
        this.filteredAgentSellingPermissions$ = this.aspFilterService.getASPByFilterGroup$();
    }
    watchPermissionsChange() {
        this.subscriptions.add(this.agentSellingPermissions$.pipe(distinctUntilKeyChanged('length')).subscribe({
            next: data => {
                if (!data?.length && this.showAddPermissionsLink && this.isAdminUser) {
                    this.openAddPermissionsPopover();
                }
            }
        }));
    }
    initializeAccountOverview() {
        const currentPage = this.store.selectSnapshot(AppConfigState.page(this.router.url));
        const pageTags = currentPage?.tags;
        if (pageTags?.length) {
            this.accountOverviewFacade.isViewAgentProfileEnabled =
                this.accountOverviewFacade.isViewOtherAgentPage(pageTags) && !this.accountOverviewFacade.isSelectedAgentSameAsLoggedInAgent();
            this.initializeAgentData();
            const isAgentAdmin = this.agentPermissionsService.isAdmin();
            const createNewAgentForm = isAgentAdmin && this.Spa_Agent_Show_New_Agent;
            this.allowAccessToAllPlanYears = this.defaultAllowAccessToAllPlanYears(this.agentData.agentPlanYear, createNewAgentForm);
            if (isAgentAdmin) {
                if (this.Spa_Agent_Show_New_Agent) {
                    this.initializeCreateNewAgentForm();
                }
                else {
                    this.initializeAdminAgentForm();
                }
            }
            else {
                this.initializeNonAdminAgentForm();
            }
            this.setAllowAccessToAllPlanYearsFormControl(this.allowAccessToAllPlanYears);
            this.setPlanYearsFormControl(this.agentData.agentPlanYear, createNewAgentForm);
            this.showPermissionTable = !this.accountOverviewFacade.isCreateAgentPage(pageTags) && this.Spa_Agent_ActiveSellingPermissions_Enabled;
            this.showAddPermissionsLink = this.showPermissionTable && this.Spa_Agent_ActiveSellingPermissions_Link_Enabled;
            this.subscriptions.add(combineLatest([
                this.accountFormGroup.get(AccountOverviewInputs.AGENT_PERMISSION_LEVEL).valueChanges,
                this.localeService.getCurrentLocale$()
            ])
                .pipe(map(([userRole, locale]) => {
                const roleDescription = this.accountOverviewFacade.getRoleDescription(userRole);
                const description = roleDescription?.value ?? '';
                return description;
            }))
                .subscribe({
                next: (description) => {
                    this.roleDescription = description;
                    this.cdr.markForCheck();
                }
            }));
            this.subscriptions.add(combineLatest([this.personalFormGroup.valueChanges, this.accountFormGroup.valueChanges, this.localeService.getCurrentLocale$()])
                .pipe(map(() => {
                const personalFormGroup = this.personalFormGroup;
                const accountFormGroup = this.accountFormGroup;
                return this.accountOverviewFacade.getErrorBannerList(personalFormGroup, accountFormGroup, this.Spa_Agent_Show_New_Agent);
            }))
                .subscribe({
                next: (errorBannerList) => {
                    this.errorBannerList = errorBannerList;
                    this.cdr.markForCheck();
                }
            }));
            // We enable/disable the form fields in order to trigger the 'valueChanges' event according to documentation
            this.personalFormGroup.enable({ emitEvent: true });
            const agentPermissionLevelControl = this.accountFormGroup.get(AccountOverviewInputs.AGENT_PERMISSION_LEVEL);
            if (isAgentAdmin) {
                agentPermissionLevelControl?.enable({ emitEvent: true });
            }
            else {
                agentPermissionLevelControl?.disable({ emitEvent: true });
            }
        }
    }
    resetProfile() {
        this.accountFormGroup.reset();
        this.personalFormGroup.reset();
        location.reload();
        return true;
    }
    async showUnsavedChangesModal(resetProfile) {
        // To prevent any un-expected stuck spinner event at moment to shows up the modal
        this.spinnerService.reset();
        if (this.accountFormGroup.pristine && this.personalFormGroup.pristine) {
            return await Promise.resolve(true);
        }
        else {
            const modalTitle = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_LeavingPageModal_Title', null, 'Unsaved changes');
            const modalPrompt = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_LeavingPageModal_Message', null, 'Are you sure you want to leave without saving your changes');
            const modalCancel = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_LeavingPageModal_CancelButton', null, 'Stay on page');
            const modalLeave = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_LeavingPageModal_LeaveButton', null, 'Leave page');
            const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true });
            confirmationModal.componentInstance.title = modalTitle;
            confirmationModal.componentInstance.prompt = modalPrompt;
            confirmationModal.componentInstance.cancelButton = modalCancel;
            confirmationModal.componentInstance.confirmButton = modalLeave;
            return await confirmationModal.result
                .then(() => {
                this.spinnerService.show(SpinnerEvent.NAVIGATION);
                return resetProfile ? this.resetProfile() : true;
            })
                .catch(() => false);
        }
    }
    changeSiteAccess() {
        const agentSiteAccess = !this.accountFormGroup.value[AccountOverviewInputs.SITE_ACCESS];
        const siteAccessControl = this.accountFormGroup.get(AccountOverviewInputs.SITE_ACCESS);
        siteAccessControl.setValue(agentSiteAccess);
        this.setAccessText(agentSiteAccess);
    }
    getCopiedInfoTextTooltipName() {
        return this.copiedInfoText;
    }
    getMask(controlName) {
        if (controlName === AccountOverviewInputs.AGENT_PHONE) {
            return FormValidationService.phoneMask;
        }
        else if (controlName === AccountOverviewInputs.AGENT_PHONE_EXTENSION) {
            return FormValidationService.phoneExtensionMask;
        }
    }
    getValidation(controlName) {
        if (controlName === AccountOverviewInputs.AGENT_PHONE_EXTENSION) {
            return false;
        }
        return true;
    }
    getType(controlName) {
        if (controlName === AccountOverviewInputs.AGENT_PASSWORD && !this.Spa_Agent_Show_New_Agent) {
            return InputControlType$1.PASSWORD;
        }
        return InputControlType$1.TEXT;
    }
    getControlType(controlName) {
        if (controlName === AccountOverviewInputs.STATE || controlName === AccountOverviewInputs.ASP_AGENT_PLAN_YEARS) {
            return InputControlType$1.DROPDOWN;
        }
        else if (controlName === AccountOverviewInputs.ASP_REQUIRED ||
            controlName === AccountOverviewInputs.ASP_ALLOW_ACCESS_TO_ALL_PLAN_YEARS ||
            controlName === AccountOverviewInputs.PROFILE_ADMIN) {
            return InputControlType$1.TOGGLE;
        }
        else if (this.Spa_Agent_Show_New_Agent || this.isAdminUser) {
            if (controlName === AccountOverviewInputs.SITE_ACCESS) {
                return InputControlType$1.BUTTON;
            }
            if (controlName === AccountOverviewInputs.ACCOUNT_STATUS) {
                return InputControlType$1.TOGGLE;
            }
            if (controlName === AccountOverviewInputs.AGENT_EXPIRATION_DATE) {
                return InputControlType$1.DATE_PICKER;
            }
            if (controlName === AccountOverviewInputs.AGENT_PERMISSION_LEVEL) {
                return InputControlType$1.DROPDOWN;
            }
        }
        if (this.AgencyHierarchy_Enabled && controlName === this.accountOverviewInputs.AGENT_AGENCY_NAME) {
            return InputControlType$1.DROPDOWN;
        }
        return InputControlType$1.INPUT;
    }
    getPersonalFormControl(controlName) {
        return this.personalFormGroup.get(controlName);
    }
    getAccountFormControl(controlName) {
        return this.accountFormGroup.get(controlName);
    }
    getPersonalError(controlName) {
        return this.accountOverviewFacade.getPersonalErrorMessage(controlName);
    }
    getAccountError(controlName) {
        return this.accountOverviewFacade.getAccountErrorMessage(controlName);
    }
    // https://stackoverflow.com/questions/53557690/angular-formcontrol-check-if-required
    // only way to check if a form control is required.
    personalControlIsRequired(controlName) {
        const control = this.getPersonalFormControl(controlName);
        if (!control.validator) {
            return false;
        }
        const validator = control.validator({});
        return validator?.required;
    }
    accountControlIsRequired(controlName) {
        const control = this.accountFormGroup.get(controlName);
        if (!control.validator) {
            return false;
        }
        const validator = control.validator({});
        return validator?.required;
    }
    accountControlIsDisplayed(controlName) {
        if (controlName === AccountOverviewInputs.ASP_AGENT_PLAN_YEARS) {
            return this.allowAccessToAllPlanYears !== null && this.allowAccessToAllPlanYears !== undefined
                ? !this.allowAccessToAllPlanYears
                : false;
        }
        return true;
    }
    trackIndex(index) {
        return index;
    }
    onSelectAccountStatus(event) {
        const accountStatusControl = this.accountFormGroup.get(AccountOverviewInputs.ACCOUNT_STATUS);
        accountStatusControl.setValue(event.data.value);
    }
    onSelectASP(event) {
        const aspControl = this.accountFormGroup.get(AccountOverviewInputs.ASP_REQUIRED);
        aspControl.setValue(event.data.value);
    }
    onSelectAllowAccessToAllPlanYears(event) {
        this.setAllowAccessToAllPlanYearsFormControl(event.data.value);
    }
    setAllowAccessToAllPlanYearsFormControl(allowAccess) {
        const allowAccessControl = this.accountFormGroup?.get(AccountOverviewInputs.ASP_ALLOW_ACCESS_TO_ALL_PLAN_YEARS);
        if (allowAccessControl) {
            allowAccessControl?.setValue(allowAccess);
            this.cdr.markForCheck();
        }
    }
    onSelectProfileAdmin(event) {
        this.setProfileAdminFormControl(event.data.value);
    }
    setProfileAdminFormControl(isProfileAdmin) {
        const profileAdminControl = this.accountFormGroup?.get(AccountOverviewInputs.PROFILE_ADMIN);
        if (profileAdminControl) {
            profileAdminControl?.setValue(isProfileAdmin);
            this.cdr.markForCheck();
        }
    }
    setPlanYearsFormControl(planYear, newAgent = false) {
        const planYearControl = this.accountFormGroup?.get(AccountOverviewInputs.ASP_AGENT_PLAN_YEARS);
        if (planYearControl) {
            const availablePlanYears = this.getAvailablePlanYears(planYear);
            const planYears = !newAgent && availablePlanYears ? availablePlanYears.map(availablePlanYear => +availablePlanYear) : [];
            planYearControl?.setValue(planYears);
            this.cdr.markForCheck();
        }
    }
    getAccountStatusDefaultValue() {
        if (this.isAdminUser) {
            return this.accountOverviewFacade.isViewAgentProfileEnabled
                ? !!this.accountOverviewFacade.viewAgentProfileData?.isActive
                : this.store.selectSnapshot(AgentState.isActive);
        }
        return true;
    }
    getASPRequiredDefaultValue() {
        return this.Spa_Agent_Show_New_Agent ? null : this.accountFormGroup.get(AccountOverviewInputs.ASP_REQUIRED).value;
    }
    getASPDisabled() {
        return this.accountFormGroup.controls[AccountOverviewInputs.ASP_REQUIRED].disabled;
    }
    getAllowAccessToAllPlanYearsDisabled() {
        return this.accountFormGroup.controls[AccountOverviewInputs.ASP_ALLOW_ACCESS_TO_ALL_PLAN_YEARS].disabled;
    }
    getAgentPlanYearsDisabled() {
        return this.accountFormGroup.controls[AccountOverviewInputs.ASP_AGENT_PLAN_YEARS].disabled;
    }
    getAllowAccessToAllPlanYearsRequiredDefaultValue() {
        const value = this.accountFormGroup.get(AccountOverviewInputs.ASP_ALLOW_ACCESS_TO_ALL_PLAN_YEARS).value;
        if (value !== null && value !== undefined) {
            return value;
        }
        // TODO: need to get value from the data that is returned
        return true;
    }
    getProfileAdminDisabled() {
        const profileAdminControl = this.accountFormGroup.controls[AccountOverviewInputs.PROFILE_ADMIN];
        const isProfileAdminDisabled = profileAdminControl.disabled || !this.isAdminUser;
        if (isProfileAdminDisabled && profileAdminControl.enabled) {
            profileAdminControl.disable();
        }
        return isProfileAdminDisabled;
    }
    getProfileAdminRequiredDefaultValue() {
        return this.accountFormGroup.get(AccountOverviewInputs.PROFILE_ADMIN).value;
    }
    getDefaultDateValue() {
        if (this.isAdminUser) {
            if (this.Spa_Agent_Show_New_Agent) {
                return this.defaultValue;
            }
            if (this.accountOverviewFacade.isViewAgentProfileEnabled && this.accountOverviewFacade.viewAgentProfileData) {
                if (!this.accountOverviewFacade.viewAgentProfileData.expirationDate) {
                    this.accountFormGroup.patchValue({
                        [AccountOverviewInputs.AGENT_EXPIRATION_DATE]: this.defaultValue
                    });
                    this.accountFormGroup.controls[AccountOverviewInputs.AGENT_EXPIRATION_DATE].markAsTouched();
                    this.accountOverviewFacade.viewAgentProfileData.expirationDate = this.defaultValue;
                }
                return DateUtilities.getFormattedDateTime(new Date(this.accountOverviewFacade.viewAgentProfileData.expirationDate.slice(0, 19)), DateUtilities.defaultFormat);
            }
            if (this.agentService.getAgentExpirationDate()) {
                return DateUtilities.getFormattedDateTime(new Date(this.agentService.getAgentExpirationDate().slice(0, 19)), DateUtilities.defaultFormat);
            }
        }
        return null;
    }
    getRoleDefaultValue() {
        if (this.isAdminUser) {
            if (this.Spa_Agent_Show_New_Agent) {
                return 'Select';
            }
            return this.accountOverviewFacade.isViewAgentProfileEnabled
                ? this.accountOverviewFacade.viewAgentProfileData?.agentRole
                : this.store.selectSnapshot(AgentState.agentRole);
        }
    }
    setSelectedDate(selectedDate) {
        if (selectedDate) {
            this.accountFormGroup.patchValue({
                [AccountOverviewInputs.AGENT_EXPIRATION_DATE]: new Date(`${selectedDate} UTC`).toISOString().slice(0, 19)
            });
        }
        else {
            this.accountFormGroup.patchValue({ [AccountOverviewInputs.AGENT_EXPIRATION_DATE]: null });
        }
        this.accountFormGroup.controls[AccountOverviewInputs.AGENT_EXPIRATION_DATE].markAsTouched();
    }
    saveAgentInfo() {
        // TODO: save AgentPlanYear
        this.submitted = true;
        this.isUserNameAlreadyExists = false;
        if (this.personalFormGroup.status !== 'INVALID' && this.accountFormGroup.status !== 'INVALID') {
            // isAgencyNameDisabled and isAgencyIdDisabled flags are used to get form current disable status for "Agency name" & "Agency ID",
            // On disable then marking these control to enable to pass the value of the control to payload and then setting back to there original
            // status on next and error call backs on update to make the view in sync as for "Agency name" & "Agency ID" are must to pass in
            // payload.
            let isAgencyNameDisabled;
            let isAgencyIdDisabled;
            // Check for null/undefined on Agency name control.
            if (this.accountFormGroup.controls[AccountOverviewInputs.AGENT_AGENCY_NAME]) {
                isAgencyNameDisabled = this.accountFormGroup.controls[AccountOverviewInputs.AGENT_AGENCY_NAME].disabled;
            }
            // Check for null/undefined on Agency ID control.
            if (this.accountFormGroup.controls[AccountOverviewInputs.AGENT_AGENCY_ID]) {
                isAgencyIdDisabled = this.accountFormGroup.controls[AccountOverviewInputs.AGENT_AGENCY_ID].disabled;
            }
            if (isAgencyNameDisabled) {
                this.accountFormGroup.controls[AccountOverviewInputs.AGENT_AGENCY_NAME].enable();
            }
            if (isAgencyIdDisabled) {
                this.accountFormGroup.controls[AccountOverviewInputs.AGENT_AGENCY_ID].enable();
            }
            const personalFormValues = this.personalFormGroup.value;
            const accountFormValues = this.accountFormGroup.value;
            if (this.Spa_Agent_Show_New_Agent && accountFormValues[AccountOverviewInputs.AGENT_USERNAME]) {
                // TODO:
                this.createNewAgentProfile(personalFormValues, accountFormValues);
            }
            else {
                this.accountFormGroup.controls[AccountOverviewInputs.AGENT_USERNAME].enable();
                if (this.isAdminUser) {
                    const agentGuid = this.accountOverviewFacade.isViewAgentProfileEnabled
                        ? this.accountOverviewFacade.viewAgentProfileData?.agentGuid
                        : this.store.selectSnapshot(AgentState.agentGuid);
                    const loginAgentGuid = this.store.selectSnapshot(AgentState.agentGuid);
                    // TODO:
                    this.updateViewedAgentProfile(agentGuid, personalFormValues, accountFormValues, loginAgentGuid, isAgencyNameDisabled, isAgencyIdDisabled);
                }
                else {
                    // TODO:
                    this.updateAgentProfile(personalFormValues, accountFormValues);
                }
            }
        }
        else {
            this.setFocus = true;
        }
    }
    getAccountValidationError(controlName) {
        if (controlName === AccountOverviewInputs.AGENT_USERNAME && this.isUserNameAlreadyExists) {
            return this.formValidationService.errorMessages.alreadyExistUsername();
        }
    }
    hasError(controlName) {
        const accountFormControlName = this.getAccountFormControl(controlName);
        return !!(accountFormControlName?.errors &&
            accountFormControlName.enabled &&
            (accountFormControlName.touched || accountFormControlName.dirty || this.submitted));
    }
    // Reference - https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript#30810322 - To copy text to clipboard.
    copyPurl(getCurrentPlanYearPurl) {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, getCurrentPlanYearPurl ? DataLayerEvent.CLICK_BPML_COPY_LINK : DataLayerEvent.CLICK_BPML_COPY_LINK_DUAL_PLAN_YEAR);
        const purl = getCurrentPlanYearPurl ? this.currentPlanYearPurl : this.dualPlanYearPurl;
        this.accountOverviewFacade.copyPurl(purl);
    }
    copyRetireFloPurl() {
        this.accountOverviewFacade.copyRetireFloPurl(this.retireFloPurl);
    }
    getRetireFloPurl() {
        const getRetireFloPurl = this.accountOverviewFacade.getRetireFloPurl({
            userName: this.agentData.userName,
            baseUrl: this.accountOverviewFacade.getConsumerSiteBaseUrl(),
            encode: true,
            redirectPageTag: PageTags.RETIRE_FLO_SURVEY
        });
        getRetireFloPurl.then(retireFloPurl => {
            this.retireFloPurl = retireFloPurl;
            this.cdr.markForCheck();
        });
    }
    updatePlanYear(agentPlanYears) {
        const agentPlanYearControl = this.accountFormGroup.get(AccountOverviewInputs.ASP_AGENT_PLAN_YEARS);
        if (agentPlanYearControl) {
            agentPlanYearControl.setValue(agentPlanYears);
        }
    }
    async fileChange(files) {
        this.fileUploadErrors = this.accountOverviewFacade.fileChange(files);
        if (this.fileUploadErrors && this.fileUploadErrors.length > 0) {
            this.cdr.markForCheck();
            return;
        }
        if (!this.agentData?.agentGuid) {
            return;
        }
        await this.accountOverviewFacade.uploadAgentProfile(files.item(0), this.agentData.agentGuid);
        this.agentService
            .fetchAgent$(this.agentData.agentGuid, this.agentService.getAgentInContextGuid())
            .pipe(take(1))
            .subscribe({
            next: (fetchedData) => {
                this.agentData = fetchedData.data;
                if (this.agentData) {
                    this.accountOverviewFacade.updateAgentProfilePicture(this.agentData.agentPictureURL);
                    this.accountOverviewFacade.setSelectedAgentGuid(this.agentData.agentGuid);
                }
                this.cdr.markForCheck();
            }
        });
    }
    setAgencyIdField(agencyID = '') {
        this.accountFormGroup?.get(this.accountOverviewInputs.AGENT_AGENCY_ID)?.setValue(agencyID);
    }
    preparePlanYearsForAPI(allowAccessToAllPlanYears, planYearsToSave = []) {
        // TODO: get from store or agentData
        if (!allowAccessToAllPlanYears) {
            const apiPlanYears = this.agentData.agentPlanYear;
            // prior to saving we need to get the existing plan years originally returned from the api
            // but not displayed because they were not found in the Spa_Agent_AccountOverview_AgentPlanYear_Json
            const getUnavailablePlanYears = this.getUnavailablePlanYears(apiPlanYears);
            return this.commaConcatenate([...new Set([...planYearsToSave, ...getUnavailablePlanYears])]);
        }
        return '';
    }
    getAvailablePlanYears(agentPlanYear) {
        if (agentPlanYear) {
            const availableAgentPlanYears = this.getAvailableAgentPlanYears();
            const planYears = agentPlanYear.split(',')?.map(planYear => +planYear);
            return planYears.filter(planYear => availableAgentPlanYears.includes(planYear));
        }
        return [];
    }
    // plan years that are saved for an agent but unavailable due to the
    // configuration of Spa_Agent_AccountOverview_AgentPlanYear_Json
    getUnavailablePlanYears(apiPlanYears) {
        if (apiPlanYears) {
            const availableAgentPlanYears = this.getAvailableAgentPlanYears();
            const planYears = apiPlanYears.split(',')?.map(planYear => +planYear);
            return planYears.filter(planYear => !availableAgentPlanYears.includes(planYear));
        }
        return [];
    }
    getAvailableAgentPlanYears() {
        return this.Spa_Agent_AccountOverview_AgentPlanYear_Json?.map(planYearJson => +planYearJson.value) ?? [];
    }
    commaConcatenate(items) {
        const commaSeperatedItems = items?.sort()?.join(',');
        return commaSeperatedItems?.length ? commaSeperatedItems : '';
    }
    updateAccountFormAgentPlanYearValidators(allowAccess) {
        const agentPlanYearsControl = this.accountFormGroup?.get(AccountOverviewInputs.ASP_AGENT_PLAN_YEARS);
        if (agentPlanYearsControl) {
            if (allowAccess) {
                // don't need to require plan years if we are allow access to all plan years
                agentPlanYearsControl?.clearValidators();
            }
            else {
                // if allow access is required and we have no selected allow access to all years then plan years is also required
                const isControlRequired = this.accountControlIsRequired(AccountOverviewInputs.ASP_ALLOW_ACCESS_TO_ALL_PLAN_YEARS);
                if (isControlRequired) {
                    agentPlanYearsControl?.setValidators([Validators.required]);
                }
            }
            agentPlanYearsControl.updateValueAndValidity();
        }
    }
    updateAgentProfile(personalFormValues, accountFormValues) {
        const partialAgent = {
            // personal
            firstName: personalFormValues[AccountOverviewInputs.AGENT_FIRST_NAME],
            lastName: personalFormValues[AccountOverviewInputs.AGENT_LAST_NAME],
            emailAddress: personalFormValues[AccountOverviewInputs.AGENT_EMAIL],
            phoneNumber: personalFormValues[AccountOverviewInputs.AGENT_PHONE],
            ext: personalFormValues[AccountOverviewInputs.AGENT_PHONE_EXTENSION],
            address1: personalFormValues[AccountOverviewInputs.AGENT_ADDRESS1],
            city: personalFormValues[AccountOverviewInputs.CITY],
            zip: personalFormValues[AccountOverviewInputs.ZIP],
            state: personalFormValues[AccountOverviewInputs.STATE],
            // account
            userName: accountFormValues[AccountOverviewInputs.AGENT_USERNAME],
            npn: accountFormValues[AccountOverviewInputs.AGENT_NPN],
            agentID: accountFormValues[AccountOverviewInputs.AGENT_ID],
            // cant change your own permission level, but I'm assuming this will be possible for admins later
            // agentUserPermissions: accountFormValues[AccountOverviewInputs.AGENT_PERMISSION_LEVEL]
            agencyName: accountFormValues[AccountOverviewInputs.AGENT_AGENCY_NAME],
            isActive: accountFormValues[AccountOverviewInputs.AGENT_FLAG],
            aspRequired: accountFormValues[AccountOverviewInputs.ASP_REQUIRED],
            isProfileAdmin: accountFormValues[AccountOverviewInputs.PROFILE_ADMIN],
            agentPlanYear: this.preparePlanYearsForAPI(accountFormValues[AccountOverviewInputs.ASP_ALLOW_ACCESS_TO_ALL_PLAN_YEARS], accountFormValues[AccountOverviewInputs.ASP_AGENT_PLAN_YEARS]),
            // TODO: SPA-????? Eventually update this to not be static to California
            licenses: [{ state: 'CA', license: accountFormValues[AccountOverviewInputs.LICENSE_NUMBER] }]
        };
        this.accountOverviewFacade
            .updateAgent$(partialAgent)
            .pipe(take(1))
            .subscribe({
            next: () => {
                this.accountFormGroup.controls[AccountOverviewInputs.AGENT_USERNAME].disable();
                this.submitted = false;
                this.accountFormGroup.markAsPristine();
                this.personalFormGroup.markAsPristine();
                this.showMessageOnSuccess();
            },
            error: () => {
                this.accountFormGroup.controls[AccountOverviewInputs.AGENT_USERNAME].disable();
                this.submitted = false;
                this.showMessageOnError();
            }
        });
    }
    showMessageOnError() {
        this.saveButton.showErrorMessage();
        this.saveButton.closeTooltip(TOOLTIP_TIMEOUT);
        this.cdr.markForCheck();
    }
    showMessageOnSuccess() {
        this.saveButton.showSuccessMessage();
        this.saveButton.closeTooltip(TOOLTIP_TIMEOUT);
        this.cdr.markForCheck();
    }
    updateViewedAgentProfile(agentGuid, personalFormValues, accountFormValues, loginAgentGuid, isAgencyNameDisabled, isAgencyIdDisabled) {
        const partialAgent = {
            // personal
            firstName: personalFormValues[AccountOverviewInputs.AGENT_FIRST_NAME],
            lastName: personalFormValues[AccountOverviewInputs.AGENT_LAST_NAME],
            emailAddress: personalFormValues[AccountOverviewInputs.AGENT_EMAIL],
            phoneNumber: personalFormValues[AccountOverviewInputs.AGENT_PHONE],
            ext: personalFormValues[AccountOverviewInputs.AGENT_PHONE_EXTENSION],
            address1: personalFormValues[AccountOverviewInputs.AGENT_ADDRESS1],
            city: personalFormValues[AccountOverviewInputs.CITY],
            zip: personalFormValues[AccountOverviewInputs.ZIP],
            state: personalFormValues[AccountOverviewInputs.STATE],
            // account
            userName: accountFormValues[AccountOverviewInputs.AGENT_USERNAME],
            npn: accountFormValues[AccountOverviewInputs.AGENT_NPN],
            agentID: accountFormValues[AccountOverviewInputs.AGENT_ID],
            agencyName: accountFormValues[AccountOverviewInputs.AGENT_AGENCY_NAME],
            isActive: accountFormValues[AccountOverviewInputs.ACCOUNT_STATUS],
            agencyID: accountFormValues[AccountOverviewInputs.AGENT_AGENCY_ID],
            expirationDate: this.getEndOfDate(accountFormValues[AccountOverviewInputs.AGENT_EXPIRATION_DATE]),
            siteAccess: accountFormValues[AccountOverviewInputs.SITE_ACCESS],
            agentRole: accountFormValues[AccountOverviewInputs.AGENT_PERMISSION_LEVEL],
            isProfileAdmin: accountFormValues[AccountOverviewInputs.PROFILE_ADMIN],
            fsr: accountFormValues[AccountOverviewInputs.FSR],
            aspRequired: this.accountFormGroup?.get(AccountOverviewInputs.ASP_REQUIRED)?.value,
            agentPlanYear: this.preparePlanYearsForAPI(accountFormValues[AccountOverviewInputs.ASP_ALLOW_ACCESS_TO_ALL_PLAN_YEARS], accountFormValues[AccountOverviewInputs.ASP_AGENT_PLAN_YEARS]),
            // TODO: SPA-????? Eventually update this to not be static to California
            licenses: [{ state: 'CA', license: accountFormValues[AccountOverviewInputs.LICENSE_NUMBER] }]
        };
        this.accountOverviewFacade
            .updateViewedAgent$(agentGuid, partialAgent, loginAgentGuid)
            .pipe(take(1))
            .subscribe({
            next: (agentData) => {
                this.handleControlStatusOnUpdate(isAgencyNameDisabled, isAgencyIdDisabled);
                this.accountFormGroup.markAsPristine();
                this.personalFormGroup.markAsPristine();
                if (agentData?.data) {
                    this.updateAgentDataAndProfile(agentData.data);
                    this.updateViewedAgencies(agentData.data.agentGuid);
                }
                else {
                    const loggedInAgentData = this.store.selectSnapshot(AgentState.agentData);
                    this.updateAgentDataAndProfile(loggedInAgentData?.data);
                    this.updateViewedAgencies(loggedInAgentData?.data?.agentGuid);
                }
                this.showMessageOnSuccess();
            },
            error: () => {
                this.handleControlStatusOnUpdate(isAgencyNameDisabled, isAgencyIdDisabled);
                this.showMessageOnError();
            }
        });
    }
    getEndOfDate(date) {
        return DateUtilities.getEndOfDate(date);
    }
    createNewAgentProfile(personalFormValues, accountFormValues) {
        const partialAgent = {
            // personal
            firstName: personalFormValues[AccountOverviewInputs.AGENT_FIRST_NAME],
            lastName: personalFormValues[AccountOverviewInputs.AGENT_LAST_NAME],
            emailAddress: personalFormValues[AccountOverviewInputs.AGENT_EMAIL],
            phoneNumber: personalFormValues[AccountOverviewInputs.AGENT_PHONE],
            ext: personalFormValues[AccountOverviewInputs.AGENT_PHONE_EXTENSION],
            address1: personalFormValues[AccountOverviewInputs.AGENT_ADDRESS1],
            city: personalFormValues[AccountOverviewInputs.CITY],
            zip: personalFormValues[AccountOverviewInputs.ZIP],
            state: personalFormValues[AccountOverviewInputs.STATE],
            // account
            userName: accountFormValues[AccountOverviewInputs.AGENT_USERNAME],
            userPassword: accountFormValues[AccountOverviewInputs.AGENT_PASSWORD],
            npn: accountFormValues[AccountOverviewInputs.AGENT_NPN],
            agentID: accountFormValues[AccountOverviewInputs.AGENT_ID],
            agentRole: accountFormValues[AccountOverviewInputs.AGENT_PERMISSION_LEVEL],
            isProfileAdmin: accountFormValues[AccountOverviewInputs.PROFILE_ADMIN],
            expirationDate: this.getEndOfDate(accountFormValues[AccountOverviewInputs.AGENT_EXPIRATION_DATE]),
            siteAccess: accountFormValues[AccountOverviewInputs.SITE_ACCESS],
            isActive: accountFormValues[AccountOverviewInputs.ACCOUNT_STATUS],
            agencyName: accountFormValues[AccountOverviewInputs.AGENT_AGENCY_NAME],
            agencyID: accountFormValues[AccountOverviewInputs.AGENT_AGENCY_ID],
            fsr: accountFormValues[AccountOverviewInputs.FSR],
            aspRequired: this.accountFormGroup?.get(AccountOverviewInputs.ASP_REQUIRED)?.value,
            agentPlanYear: this.preparePlanYearsForAPI(accountFormValues[AccountOverviewInputs.ASP_ALLOW_ACCESS_TO_ALL_PLAN_YEARS], accountFormValues[AccountOverviewInputs.ASP_AGENT_PLAN_YEARS]),
            // TODO: SPA-????? Eventually update this to not be static to California
            licenses: [{ state: 'CA', license: accountFormValues[AccountOverviewInputs.LICENSE_NUMBER] }],
            resetPasswordRequired: this.Spa_Site_New_Agent_ResetPasswordRequired
        };
        this.accountOverviewFacade
            .createAgent$(partialAgent)
            .pipe(take(1))
            .subscribe({
            next: agentData => {
                if (agentData) {
                    this.accountFormGroup.controls[AccountOverviewInputs.AGENT_USERNAME].disable();
                    this.accountFormGroup.controls[AccountOverviewInputs.AGENT_PASSWORD].disable();
                    this.submitted = false;
                    this.accountFormGroup.markAsPristine();
                    this.personalFormGroup.markAsPristine();
                    this.saveButton.showSuccessMessage();
                    this.saveButton.closeTooltip(TOOLTIP_TIMEOUT);
                    this.viewNewAgentProfile(agentData.data);
                    this.cdr.markForCheck();
                }
                else {
                    this.showMessageOnError();
                }
            },
            error: res => {
                if (res.error && res.error.Status === HttpStatusCode.BAD_REQUEST && res.error.Detail === NEW_AGENT_EXCEPTION_DETAIL) {
                    this.isUserNameAlreadyExists = true;
                }
                this.showMessageOnError();
            }
        });
    }
    handleControlStatusOnUpdate(isAgencyNameDisabled, isAgencyIdDisabled) {
        this.accountFormGroup.controls[AccountOverviewInputs.AGENT_USERNAME].disable();
        if (isAgencyNameDisabled) {
            this.accountFormGroup.controls[AccountOverviewInputs.AGENT_AGENCY_NAME].disable();
        }
        if (isAgencyIdDisabled) {
            this.accountFormGroup.controls[AccountOverviewInputs.AGENT_AGENCY_ID].disable();
        }
        this.submitted = false;
    }
    setFocusOnFirstElement(formGroup) {
        for (const key of Object.keys(formGroup.controls)) {
            if (formGroup.controls[key].invalid) {
                const invalidControl = this.element.nativeElement.querySelector('.has-error');
                if (invalidControl) {
                    invalidControl.focus();
                    return true;
                }
            }
        }
        return false;
    }
    updateAgentDataAndProfile(agentData) {
        this.agentData = agentData;
    }
    initializeCreateNewAgentForm() {
        this.accountOverviewFacade.logoutNonAdminAgent();
        this.personalFormGroup = this.accountOverviewFacade.getAgentPersonalFormGroup();
        this.accountFormGroup = this.accountOverviewFacade.getAgentAccountFormGroup();
    }
    initializeAdminAgentForm() {
        this.personalFormGroup = this.accountOverviewFacade.getAgentViewPersonalFormGroup();
        this.accountFormGroup = this.accountOverviewFacade.getAgentViewAccountFormGroup();
        this.accountOverviewFacade.isViewAgentProfileEnabled
            ? this.setAccessText(!!this.accountOverviewFacade.viewAgentProfileData?.siteAccess)
            : this.setAccessText(this.store.selectSnapshot(AgentState.siteAccess));
    }
    initializeNonAdminAgentForm() {
        this.personalFormGroup = this.accountOverviewFacade.getPersonalFormGroup();
        // TODO: maybe add disabled here since its not being passed down
        this.accountFormGroup = this.accountOverviewFacade.getAccountFormGroup();
    }
    initializeAgentData() {
        let selectedUserAgencies = [];
        if (this.accountOverviewFacade.isViewAgentProfileEnabled) {
            const defaultAgent = null;
            const defaultAgencies = [];
            const resolverData = this.activatedRoute.snapshot.data;
            const agentInfo = resolverData?.[ACCOUNT_OVERVIEW];
            const agentData = agentInfo?.agent || defaultAgent;
            const agencies = agentInfo?.agencies || defaultAgencies;
            this.accountOverviewFacade.viewAgentProfileData = agentData;
            this.agentData = agentData;
            selectedUserAgencies = agencies;
        }
        else {
            this.agentData = this.accountOverviewFacade.getAgentData();
            selectedUserAgencies = this.agentService.getAgencies();
        }
        this.selectedUserAgencies = this.accountOverviewFacade.sortAgenciesByName(selectedUserAgencies);
        if (this.Spa_Agent_AccountOverview_Purl_Enabled) {
            const getCurrentPlanYearPurlRequest = this.accountOverviewFacade.getPurl({
                userName: this.agentData.userName,
                baseUrl: this.accountOverviewFacade.getSiteBaseUrl(),
                encode: false,
                ...(this.Spa_ConsumerSiteID_Enabled && { selectedStaticPurlYear: AgentStaticPurlYear.PLAN_YEAR })
            });
            if (this.isDualPlanYearPurlEnabled) {
                const getPurlRequests = [
                    getCurrentPlanYearPurlRequest,
                    this.accountOverviewFacade.getPurl({
                        userName: this.agentData.userName,
                        baseUrl: this.accountOverviewFacade.getConsumerSiteBaseUrl(true),
                        encode: false
                    })
                ];
                Promise.all(getPurlRequests).then(([currentPlanYearPurl, dualPlanYearPurl]) => {
                    this.currentPlanYearPurl = currentPlanYearPurl;
                    this.dualPlanYearPurl = dualPlanYearPurl;
                    this.cdr.markForCheck();
                });
            }
            else {
                getCurrentPlanYearPurlRequest.then(currentPlanYearPurl => {
                    this.currentPlanYearPurl = currentPlanYearPurl;
                    this.cdr.markForCheck();
                });
            }
        }
    }
    viewNewAgentProfile(agent) {
        this.accountOverviewFacade.setSelectedAgentGuid(agent?.agentGuid);
        this.navigationService.navigateByPageTag(PageTags.AGENT_VIEW_PROFILE);
    }
    updateViewedAgencies(agentGuid) {
        if (agentGuid) {
            this.agentService
                .fetchAgenciesForSelectedUser$(agentGuid)
                .pipe(take(1))
                .subscribe({
                next: agencies => {
                    this.selectedUserAgencies = this.accountOverviewFacade.sortAgenciesByName(agencies);
                    this.cdr.markForCheck();
                }
            });
        }
    }
    getAgencyNameDisabled() {
        return this.accountFormGroup?.controls[AccountOverviewInputs.AGENT_AGENCY_NAME]?.disabled;
    }
    disableAgencyID() {
        this.accountFormGroup?.controls[AccountOverviewInputs.AGENT_AGENCY_ID]?.disable();
    }
    updateAgentPurlPermissions() {
        if (this.agentPlanYears.length === 0) {
            this.agentHasPermissionForCurrentPlanYearPurl = true;
            this.agentHasPermissionForDualPlanYearPurl = this.isDualPlanYearPurlEnabled;
        }
        else {
            const currentPlanYear = `${this.planYearResourceService.getCurrentPlanYear()}`;
            this.agentHasPermissionForCurrentPlanYearPurl = this.agentPlanYears.includes(currentPlanYear);
            if (this.isDualPlanYearPurlEnabled) {
                const secondaryPlanYear = `${this.planYearResourceService.getDualPlanYear()}`;
                this.agentHasPermissionForDualPlanYearPurl = this.agentPlanYears.includes(secondaryPlanYear);
            }
        }
    }
    defaultAllowAccessToAllPlanYears(agentPlanYear, newAgent = false) {
        return newAgent || !agentPlanYear;
    }
    getAgentPersonalAccountFormByLayoutClassNames(accountForm, accountFormByKeyName) {
        return accountForm.reduce((classesNames, personalAccountInputConfig) => {
            const { keyName } = personalAccountInputConfig;
            if (keyName === AccountOverviewInputs.AGENT_PHONE &&
                accountFormByKeyName[AccountOverviewInputs.AGENT_PHONE_EXTENSION]?.display &&
                accountFormByKeyName[AccountOverviewInputs.AGENT_PHONE]?.display) {
                return {
                    ...classesNames,
                    [AccountOverviewInputs.AGENT_PHONE]: 'col-md-4'
                };
            }
            if (keyName === AccountOverviewInputs.AGENT_PHONE_EXTENSION &&
                accountFormByKeyName[AccountOverviewInputs.AGENT_PHONE_EXTENSION]?.display &&
                accountFormByKeyName[AccountOverviewInputs.AGENT_PHONE]?.display) {
                return {
                    ...classesNames,
                    [AccountOverviewInputs.AGENT_PHONE_EXTENSION]: 'col-md-2'
                };
            }
            return {
                ...classesNames,
                [keyName]: 'col-md-6'
            };
        }, {});
    }
    fetchRetireFloStatus() {
        this.activatedRoute.queryParams.subscribe({
            next: params => {
                if (params?.checkRetireFloStatus) {
                    this.agentService.fetchRetireFloStatus();
                }
            }
        });
    }
    loginToRetireFlo() {
        const baseUrl = `${this.Spa_Agent_RetireFlo_LogIn_URL}`;
        this.agentRetireFloFacade.navigateToRetireFloSignUpOrLogin(baseUrl, false);
    }
    retireFloSignUpModal() {
        const options = {
            ariaLabelledBy: this.Spa_RetireFlo_SignUpModalHeader_Text,
            centered: true,
            injector: this.injector
        };
        const retireflo = this.modalService.open(AgentRetireFloSignupModalComponent, options);
        retireflo.componentInstance.title = this.Spa_RetireFlo_SignUpModalHeader_Text;
        retireflo.componentInstance.contenttext = this.Spa_RetireFlo_SignUpModalContent_Text;
        retireflo.componentInstance.cancelButton = this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Cancel;
        retireflo.componentInstance.confirmButton = this.Spa_RetireFlo_SignUpModal_ContinueButton_Text;
        retireflo.componentInstance.primaryLogo = this.Spa_RetireFlo_SignUpModalLogo_URL;
        retireflo.componentInstance.signUpURL = this.Spa_RetireFlo_SignUp_URL;
        retireflo.componentInstance.primaryLogoAltText = this.configResourceService.getProcessedResourceValue('Spa_Header_PrimaryLogo_Alt_Text', null, '[[Spa_ClientName]] logo');
    }
};
AccountOverviewComponent.ɵfac = function AccountOverviewComponent_Factory(t) { return new (t || AccountOverviewComponent)(i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.DeactivationGuardService), i0.ɵɵdirectiveInject(i1.FormValidationService), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(AccountOverviewFacade), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.UnsavedModalContext), i0.ɵɵdirectiveInject(i1.AgentPermissionsService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i1.ASPFilterService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.PlanYearResourceService), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(AgentRetireFloFacade)); };
AccountOverviewComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AccountOverviewComponent, selectors: [["vnext-account-overview"]], viewQuery: function AccountOverviewComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$2N, 5);
        i0.ɵɵviewQuery(_c1$1s, 5);
        i0.ɵɵviewQuery(_c2$V, 5);
        i0.ɵɵviewQuery(_c3$E, 5);
        i0.ɵɵviewQuery(StatusButtonComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.permissionPopover = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterPopover = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.copiedInfoText = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sellingPermissionsTable = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.saveButton = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService, InputResetContextService]), i0.ɵɵInheritDefinitionFeature], decls: 32, vars: 19, consts: [["vnextGoogleTagManager", "", 1, "mx-auto", "container", 3, "saveDefaultValues"], [4, "ngIf", "ngIfElse"], ["accountOverviewHeader", ""], [1, "col-12", "mt-4"], ["navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [1, "col-12"], [4, "ngIf"], [1, "d-flex", "flex-column", "flex-md-row", "justify-content-md-between", "mt-3", "mb-5", "account-overview-agent-section-wrapper"], ["class", "mt-2 p-md-4 p-lg-4 px-3 pt-0 pb-3 rounded Spa_Style_Gray1_Background account-overview-agent-section", 4, "ngIf"], ["class", "mt-2 py-md-4 px-md-4 px-3 pt-1 pt-md-0 pb-3 rounded Spa_Style_Gray1_Background account-overview-agent-section", 4, "ngIf"], [1, "container"], ["class", "Spa_Style_H2 row mt-3 px-0", 4, "liveEditProp"], ["class", "row pb-4 align-items-end", 3, "formGroup", 4, "ngIf"], ["class", "Spa_Style_H2 row mt-5 px-0", 4, "liveEditProp"], ["class", "row pt-1 pb-4 mb-5", 3, "formGroup", 4, "ngIf"], [1, "mb-2", "container"], [1, "d-flex", "justify-content-end", "row"], [1, "button-container"], [3, "buttonText", "buttonClass", "tooltipMessageError", "tooltipMessageSuccess", "click", 4, "liveEditProp"], ["class", "container", 4, "ngIf"], [1, "w-100", "popover-container", "px-1"], ["class", "addContainer", "placement", "bottom-right", "popoverClass", "add-permission-popover", 3, "ngbPopover", "autoClose", 4, "ngIf"], ["placement", "bottom-right", "popoverClass", "filter-permission-popover", 1, "filterContainer", 3, "ngbPopover", "autoClose"], ["filterPopover", "ngbPopover"], ["filterPopoverTemplate", ""], ["permissionPopoverTemplate", ""], ["class", "col-12 text-center Spa_Style_H1 mt-4 mb-0", 4, "liveEditProp"], [1, "col-12", "text-center", "Spa_Style_H1", "mt-4", "mb-0"], ["navigationAdapter", "", 3, "innerHtml"], [1, "search-agent-notice", 3, "title", "messages", "type"], [1, "mt-2", "p-md-4", "p-lg-4", "px-3", "pt-0", "pb-3", "rounded", "Spa_Style_Gray1_Background", "account-overview-agent-section"], ["class", "Spa_Style_H2 mt-2", 4, "liveEditProp"], ["class", "Spa_Style_Paragraph mb-3", 4, "liveEditProp"], ["class", "btn Spa_Style_SecondaryButton col-xs-12 col-md-auto col-lg-auto", "placement", "top", "popoverClass", "logout-popover", 3, "ngClass", "ngbPopover", "autoClose", "click", "keyup.enter", 4, "ngIf"], ["class", "secondary-unique-code mt-3 d-inline-block", 4, "ngIf"], ["copiedInfoText", ""], [1, "Spa_Style_H2", "mt-2"], [1, "Spa_Style_Paragraph", "mb-3"], ["placement", "top", "popoverClass", "logout-popover", 1, "btn", "Spa_Style_SecondaryButton", "col-xs-12", "col-md-auto", "col-lg-auto", 3, "ngClass", "ngbPopover", "autoClose", "click", "keyup.enter"], ["copiedInfoPopover", "ngbPopover"], [4, "liveEditProp"], [1, "secondary-unique-code", "mt-3", "d-inline-block"], ["placement", "top", "popoverClass", "logout-popover", 1, "Spa_Style_Link", 3, "title", "alwaysUnderlined", "ngbPopover", "autoClose", "click", "keyup.enter"], [1, "copied-info-text"], ["aria-hidden", "true", 1, "fas", "fa-check-circle"], ["class", "btn Spa_Style_SecondaryButton col-xs-12 col-md-auto col-lg-auto", 3, "ngClass", "click", 4, "ngIf"], [1, "btn", "Spa_Style_SecondaryButton", "col-xs-12", "col-md-auto", "col-lg-auto", 3, "click"], [1, "seperator", "my-3"], ["placement", "top", "popoverClass", "logout-popover", 1, "btn", "Spa_Style_SecondaryButton", "col-xs-12", "col-md-auto", "col-lg-auto", 3, "ngbPopover", "autoClose", "click", "keyup.enter"], [1, "btn", "Spa_Style_SecondaryButton", "col-xs-12", "col-md-auto", "col-lg-auto", 3, "ngClass", "click"], [1, "mt-2", "py-md-4", "px-md-4", "px-3", "pt-1", "pt-md-0", "pb-3", "rounded", "Spa_Style_Gray1_Background", "account-overview-agent-section"], [3, "agentData", "agentProfilePictureUrl", "agentGuid", "fileUploadErrors", "agentProfilePictureHeader", "agentProfilePictureHeaderPropName", "agentProfilePictureContent", "agentProfilePictureContentPropName", "agentProfilePictureInstruction", "agentProfilePictureUploadText", "isFullWidthUploadContainer", "filechange"], [1, "Spa_Style_H2", "row", "mt-3", "px-0"], [1, "row", "pb-4", "align-items-end", 3, "formGroup"], [1, "row"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "col-lg-3", "col-12", 3, "ngClass"], [1, "w-100", "d-flex", "flex-column"], [1, "error-container", "pt-2"], [1, "label-wrapper"], [1, "Spa_Style_Small_Font", "Spa_Style_Bold_Weight", 3, "ngClass"], ["class", "input-asterisk", 3, "id", "ngClass", 4, "ngIf"], ["class", "break", 4, "ngIf"], [1, "Spa_Style_ErrorText", "align-bottom"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], [1, "input-asterisk", 3, "id", "ngClass"], ["tabindex", "0", 1, "Spa_Style_Small_Font", "Spa_Style_Primary_Color", "form-control", 3, "type", "ngClass", "formControlName", "readonly", "mask", "validation"], [3, "customClass", "control", "formSubmitted", "height", "isReadOnly", "ariaLabelledById"], [1, "break"], [1, "subscription-section", "row", "pt-1", "pb-4", "mb-5"], [1, "pt-4", "w-100"], [3, "innerHTML"], [1, "pt-4", "pb-1"], [1, "Spa_Style_Link", 3, "href", "title", "makeInlineBlock", "linkTarget"], [1, "Spa_Style_H2", "row", "mt-5", "px-0"], [1, "row", "pt-1", "pb-4", "mb-5", 3, "formGroup"], ["class", "col-lg-3 col-md-6 col-12", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "container mt-5", 4, "ngIf"], [1, "col-lg-3", "col-md-6", "col-12"], ["showValidationError", ""], ["class", "Spa_Style_Small_Font Spa_Style_Semi_Bold_Weight", 3, "ngClass", 4, "ngIf"], ["class", "Spa_Style_Smaller_Font Spa_Style_Gray4_Color", 4, "ngIf"], ["class", "Spa_Style_ErrorText align-bottom", 4, "ngIf"], [1, "Spa_Style_Small_Font", "Spa_Style_Semi_Bold_Weight", 3, "ngClass"], ["tabindex", "0", "autocomplete", "off", 1, "Spa_Style_Small_Font", "Spa_Style_Primary_Color", "form-control", 3, "type", "ngClass", "formControlName"], [3, "control", "agencyItems", "agencyID", "formSubmitted", "height", "isReadOnly", "noneAvailableLabel", "ariaLabelledById", "emitAgencyId"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "w-100", 3, "click"], [3, "items", "buttonHeight", "selectedValue", "largerText", "ariaLabelledById", "optionSelected"], [3, "items", "buttonHeight", "selectedValue", "largerText", "isReadOnly", "ariaLabelledById", "optionSelected"], [3, "customClass", "control", "formSubmitted", "placeholderDefaultValue", "ariaLabelledById"], [3, "items", "buttonHeight", "largerText", "isReadOnly", "selectedValue", "ariaLabelledById", "optionSelected"], [3, "formControlName", "options", "placeholder", "selectedItemsDisplayTransform", "submitted", "disabled", "locale", "ariaLabelledById", "fieldId", "onSelect"], [1, "d-flex", "reduced-width-1", 3, "customClass", "defaultValue", "showDatePicker", "fullWidth", "isReadOnly", "hasError", "ariaLabelledById", "sendDate"], [1, "Spa_Style_Smaller_Font", "Spa_Style_Gray4_Color"], [1, "container", "mt-5"], [1, "agencies-list-header"], ["class", "Spa_Style_Small_Font Spa_Style_Semi_Bold_Weight Spa_Style_Primary_Color", 4, "liveEditProp"], ["class", "Spa_Style_Smaller_Font Spa_Style_Gray4_Color mb-2", 4, "liveEditProp"], ["showNoAgencyText", ""], [1, "Spa_Style_Small_Font", "Spa_Style_Semi_Bold_Weight", "Spa_Style_Primary_Color"], [1, "Spa_Style_Smaller_Font", "Spa_Style_Gray4_Color", "mb-2"], [1, "row", "pt-4", "pl-2"], ["class", "col-3 mb-2", 4, "ngFor", "ngForOf"], [1, "col-3", "mb-2"], [1, "agency-name", "no-translate-block", 3, "title"], [1, "col-md-12", "no-agency-text"], [1, "Spa_Style_Large_Font", "font-weight-bold"], [1, "Spa_Style_H5", 3, "innerHTML"], [3, "buttonText", "buttonClass", "tooltipMessageError", "tooltipMessageSuccess", "click"], ["class", "Spa_Style_H2 row mt-4 px-0", 4, "liveEditProp"], [1, "w-100", "d-flex", "justify-content-end"], ["class", "mr-3", 4, "ngIf"], [3, "title", "additionalIcon", "click", 4, "ngIf", "ngIfElse"], ["disabledFiltersLink", ""], [1, "Spa_Style_H2", "row", "mt-4", "px-0"], ["sellingPermissionsTable", ""], [1, "mr-3"], [3, "title", "additionalIcon", "click"], [3, "title", "additionalIcon", "disabled"], ["placement", "bottom-right", "popoverClass", "add-permission-popover", 1, "addContainer", 3, "ngbPopover", "autoClose"], ["permissionPopover", "ngbPopover"], [3, "planYearHeader", "carrierHeader", "statesHeader", "planTypeHeader", "clearAllText", "applyText", "viewPermissionsText", "yearSelectionEnabled", "closePopover"], [3, "agentGuid", "sellingPermissionFormLink", "carriers", "permissions", "permissionTypeHeader", "permissionTypeError", "permissionPlanYearError", "permissionCarrierError", "permissionStatesError", "permissionPlanTypeError", "permissionProducerIDError", "permissionMedicareToggleOptions", "medicarePlanYearSelectionJsonItems", "defaultPlanYear", "planYearHeader", "carrierHeader", "statesHeader", "planTypeHeader", "snpHeader", "producerIdHeader", "permissionButton", "allStatesOption", "allPlanTypesOption", "allSnpOption", "selectCarrierText", "selectStatesText", "editStatesText", "selectPlanTypesText", "editPlanTypesText", "selectSnpText", "editSnpText", "listOfFieldValidations", "clearAllText", "closePopover", "openPopover"], [3, "agentData", "carriers", "headerText", "carrierHeader", "stateHeader", "planTypeHeader", "planYearHeader", "producerIdHeader", "agentSellingPermissions", "itemsPerPage", "paginationText", "paginationEnabled", "enableProducerIdColumn", "noPermissionsTitle", "noPermissionsBody", "noPermissionsIcon", "noPermissionsAfterFiltersTitle", "noPermissionsAfterFiltersBody", "medSupAbbrev", "ancillaryAbbrev", "mappedCarriersText", "noSNPText", "notApplicableText", "showRemoveCol"]], template: function AccountOverviewComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, AccountOverviewComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        i0.ɵɵtemplate(2, AccountOverviewComponent_ng_template_2_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtemplate(5, AccountOverviewComponent_div_5_Template, 2, 4, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵtemplate(7, AccountOverviewComponent_ng_container_7_Template, 2, 3, "ng-container", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵtemplate(9, AccountOverviewComponent_div_9_Template, 8, 4, "div", 8);
        i0.ɵɵtemplate(10, AccountOverviewComponent_div_10_Template, 5, 4, "div", 8);
        i0.ɵɵtemplate(11, AccountOverviewComponent_div_11_Template, 2, 11, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 10);
        i0.ɵɵtemplate(13, AccountOverviewComponent_h2_13_Template, 2, 1, "h2", 11);
        i0.ɵɵtemplate(14, AccountOverviewComponent_form_14_Template, 3, 3, "form", 12);
        i0.ɵɵtemplate(15, AccountOverviewComponent_ng_container_15_Template, 8, 9, "ng-container", 6);
        i0.ɵɵtemplate(16, AccountOverviewComponent_h2_16_Template, 2, 1, "h2", 13);
        i0.ɵɵtemplate(17, AccountOverviewComponent_form_17_Template, 4, 4, "form", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 15)(19, "div", 16)(20, "div", 17);
        i0.ɵɵtemplate(21, AccountOverviewComponent_vnext_status_button_21_Template, 1, 4, "vnext-status-button", 18);
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(22, AccountOverviewComponent_div_22_Template, 10, 6, "div", 19);
        i0.ɵɵelementStart(23, "div", 20);
        i0.ɵɵtemplate(24, AccountOverviewComponent_div_24_Template, 2, 2, "div", 21);
        i0.ɵɵelement(25, "div", 22, 23);
        i0.ɵɵtemplate(27, AccountOverviewComponent_ng_template_27_Template, 1, 8, "ng-template", null, 24, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(29, AccountOverviewComponent_ng_template_29_Template, 3, 37, "ng-template", null, 25, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(31, AccountOverviewComponent_div_31_Template, 4, 28, "div", 19);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(3);
        const _r17 = i0.ɵɵreference(28);
        i0.ɵɵproperty("saveDefaultValues", true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Agent_Show_New_Agent)("ngIfElse", _r1);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_PageSubHeader_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.submitted && (ctx.errorBannerList == null ? null : ctx.errorBannerList.length));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.Spa_Agent_AccountOverview_Purl_Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_RetireFlo_Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Agent_Profile_Picture_Upload_Enabled && ctx.agentData);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_Agent_AccountOverview_PersonalHeader_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.personalFormGroup);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Agent_AccountOverview_ManageMySubscription_Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_Agent_AccountOverview_AccountHeader_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.accountFormGroup);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("liveEditProp", "Spa_Agent_AccountOverview_Button_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showPermissionTable);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isAdminUser);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngbPopover", _r17)("autoClose", false);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.showPermissionTable);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, LinkComponent, ToggleSelectComponent, StatusButtonComponent, StateSelectorInputComponent, AgencyNameSelectorInputComponent, NoticeComponent, NavigationAdapterDirective, LiveEditPropDirective, GoogleTagManagerDirective, IconAriaAttributesDirective, i1$1.NgbPopover, i8.MaskDirective, ActiveSellingPermissionsComponent, AddAgentSellingPermissionsComponent, FilterSellingPermissionsComponent, CheckboxDropdownComponent, AgentRoleSelectorComponent, AgentProfileUploadComponent, MedSupDateComponent, i1$2.AsyncPipe, i1$2.DatePipe, SafePipe], styles: ["input.form-control[_ngcontent-%COMP%], button.btn[_ngcontent-%COMP%]{height:36px}form[_ngcontent-%COMP%]{min-height:200px;border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px;padding:0 18px}.error-container[_ngcontent-%COMP%]{min-height:40px;max-height:40px;line-height:1}.error-container[_ngcontent-%COMP%]:empty{display:none}.copied-info-text[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text)}.account-overview-agent-section-wrapper[_ngcontent-%COMP%]{gap:16px}.account-overview-agent-section[_ngcontent-%COMP%]{flex:1 1 0px}.agencies-list-header[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.agency-name[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.no-agency-text[_ngcontent-%COMP%]{margin-top:38px;text-align:center;line-height:28px}.label-wrapper[_ngcontent-%COMP%]{min-height:50px;display:flex;align-items:flex-end}.seperator[_ngcontent-%COMP%]{width:100%;border-top:2px solid var(--static-Spa_Style_Accent1)}@media (min-width: 320px){.reduced-width-1[_ngcontent-%COMP%]{width:100%}}@media (min-width: 768px){.error-icon[_ngcontent-%COMP%]{display:inline-block;width:10%;vertical-align:top}.error-message[_ngcontent-%COMP%]{display:inline-block;width:84%}}@media (max-width: 767.9px){.account-overview-agent-section[_ngcontent-%COMP%]{width:100%}.profile-text[_ngcontent-%COMP%]{margin-right:-20px;margin-left:-20px}}@media (max-width: 1200px){.profile-text[_ngcontent-%COMP%]{margin-right:-20px;margin-left:-20px}}@media (min-width: 991.9px){.reduced-width-1[_ngcontent-%COMP%]{width:50%}}.asp-popover-container[_ngcontent-%COMP%]{border:1px solid black}.break[_ngcontent-%COMP%]{flex-basis:100%;height:0}.subscription-section[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px;padding:0 18px}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_Enabled", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_PersonalHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_AccountHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_Button_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_TooltipError_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_TooltipSuccess_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_Purl_Enabled", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_ShoppingLink_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_ShoppingLink_Content_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_CopyLink_Text", void 0);
__decorate([
    PlatformProp()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_CopiedInfo_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountOverviewComponent.prototype, "Spa_Site_PageSubHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountOverviewComponent.prototype, "Spa_Agent_AddAgent_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountOverviewComponent.prototype, "Spa_Site_ActiveSellingPermissions_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_AgenciesHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_AgenciesInstructional_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_RetireFlo_Enabled", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_RetireFlo_LogIn_URL", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_RetireFlo_SignUp_URL", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_RetireFlo_SignUp_ButtonText", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_RetireFlo_LogIn_ButtonText", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_RetireFlo_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_RetireFlo_Content_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Site_ActiveSellingPermissions_Mapped_Carriers_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Site_Carrier_Header", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Site_State_Header", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Site_PlanType_Header", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Site_Pagination_ItemsPerPage", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_PharmacySearch_Pagination_Enabled", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_ActiveSellingPermissions_Enabled", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_ActiveSellingPermissions_Link_Enabled", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Site_Pagination_View_Text", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_Agent_Revoke_SiteAccess_Text", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_Agent_Grant_SiteAccess_Text", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_Agent_Revoke_SiteAccess_Description", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_Agent_Grant_SiteAccess_Description", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Password_Description", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_AgentSearch_ActiveStatus_Text", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_AgentSearch_InactiveStatus_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Add_Permission_Link_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Type_Header", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Medicare_Text", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Medicare_Supplement_Text", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_Site_Ancillary_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Plan_Year_Header", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Current_Year_Header", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Next_Year_Header", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Carries_Header", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_States_Header", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Plan_Type_Header", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_SNP_Header", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Producer_Id_Header", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Add_Permission_Button_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Filter_Clear_All", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Select_Carrier_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Select_State_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Edit_State_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Select_Plan_Type_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Edit_Plan_Type_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Select_SNP_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Edit_SNP_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Field_Validations", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Is_State_Required", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Is_PlanType_Required", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Is_Producer_Id_Required", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_All_States_Option", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_All_Plan_Type_Option", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_All_SNP_Option", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_PermissionType_Error", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Plan_Year_Selection_Error", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Carrier_Selection_Error", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_State_Selection_Error", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Plan_Type_Error", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Producer_Id_Error", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_Year_Selection_Enabled", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_Agent_Show_New_Agent", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Member_Profile_ErrorMessages_TitleText", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Site_New_Agent_ResetPasswordRequired", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_Agent_ViewAgentProfile_AccountForm", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_Agent_Create_AccountForm", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_AccountForm", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_PersonalForm", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_Agent_Create_PersonalForm", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_Agent_ViewAgentProfile_PersonalForm", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_Profile_Picture_Upload_Enabled", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_Agent_ASPRequiredYes_Text", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_Agent_ASPRequiredNo_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_ASPRequired_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_ProducerId_Enabled", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_NoPermissions_Title", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_NoPermissions_Body", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_ProducerId_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_PlanYear_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_NoPermissions_Icon", void 0);
__decorate([
    PlatformProp()
], AccountOverviewComponent.prototype, "Spa_Site_UploadLink_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountOverviewComponent.prototype, "Spa_Agent_Profile_Picture_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountOverviewComponent.prototype, "Spa_Agent_Profile_Picture_Content", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_RetireFlo_PURL_ButtonText", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_RetireFlo_PURL_DescriptionText", void 0);
__decorate([
    PlatformProp()
], AccountOverviewComponent.prototype, "Spa_Agent_Profile_Picture_Instruction_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Filter_Header_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Site_ClearAll_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_PlanFilters_Modal_Apply_Button", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_MedSupAbbreviation_Label", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_NoSNP_Label", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Site_NotApplicable_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_NoPermissionsAfterFilters_Title", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_NoPermissionsAfterFilters_Body", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_ActiveSellingPermissions_AddRemove_Enabled", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_ViewPermissions_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "AgencyHierarchy_Enabled", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_No_Agency_Header_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_No_Agency_Sub_Header_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Site_None_Available_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_Purl_DualPlanYear_Enabled", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_ConsumerSiteID_Enabled", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_PlanYearSelectionJson_Enabled", void 0);
__decorate([
    GlobalResource(true)
], AccountOverviewComponent.prototype, "Spa_Agent_Permission_PlanYearSelection_Json", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_CopyDualPlanYearLink_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_AgentPlanYear_Display_Admin", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_AgentPlanYear_Display", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_AgentPlanYear_Required", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_AgentPlanYear_Placeholder", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_AgentPlanYear_Edit_Placeholder", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_AgentPlanYear_Json", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_AllowAccess_AgentPlanYear_Description", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_AgentPlanYear_Description", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_ProfileAdminFlag_Enabled", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Site_Yes", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Site_No", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_RetireFlo_SignUpModal_ContinueButton_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_EnrollmentConfirmation_EmailConfirmationModal_Cancel", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_RetireFlo_SignUpModalHeader_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_RetireFlo_SignUpModalContent_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_RetireFlo_SignUpModalLogo_URL", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_ManageMySubscription_Enabled", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_ManageMySubscriptionHeader_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_ManageMySubscription_Html", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_ManageMySubscription_Link_Text", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_ManageMySubscription_Url", void 0);
__decorate([
    GlobalResource()
], AccountOverviewComponent.prototype, "Spa_Agent_AccountOverview_RetireFlo_PURL_Enabled", void 0);
__decorate([
    LiveEditInactive()
], AccountOverviewComponent.prototype, "changeSiteAccess", null);
__decorate([
    LiveEditInactive()
], AccountOverviewComponent.prototype, "getCopiedInfoTextTooltipName", null);
__decorate([
    LiveEditInactive()
], AccountOverviewComponent.prototype, "saveAgentInfo", null);
__decorate([
    LiveEditInactive()
], AccountOverviewComponent.prototype, "copyPurl", null);
__decorate([
    LiveEditInactive()
], AccountOverviewComponent.prototype, "copyRetireFloPurl", null);
__decorate([
    LiveEditInactive()
], AccountOverviewComponent.prototype, "fileChange", null);
AccountOverviewComponent = __decorate([
    PlatformWidget
], AccountOverviewComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccountOverviewComponent, [{
        type: Component,
        args: [{ selector: 'vnext-account-overview', providers: [WidgetService, InputResetContextService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"mx-auto container\" vnextGoogleTagManager [saveDefaultValues]=\"true\">\r\n  <ng-container *ngIf=\"Spa_Agent_Show_New_Agent; else accountOverviewHeader\">\r\n    <h1 *liveEditProp=\"'Spa_Agent_AddAgent_Header_Text'\" class=\"col-12 text-center Spa_Style_H1 mt-4 mb-0\">\r\n      {{ Spa_Agent_AddAgent_Header_Text }}\r\n    </h1>\r\n  </ng-container>\r\n  <ng-template #accountOverviewHeader>\r\n    <h1 *liveEditProp=\"'Spa_Agent_AccountOverview_Header_Text'\" class=\"col-12 text-center Spa_Style_H1 mt-4 mb-0\">\r\n      {{ Spa_Agent_AccountOverview_Header_Text }}\r\n    </h1>\r\n  </ng-template>\r\n  <div class=\"col-12 mt-4\">\r\n    <div\r\n      *liveEditProp=\"'Spa_Site_PageSubHeader_Text'\"\r\n      [innerHtml]=\"Spa_Site_PageSubHeader_Text ? (Spa_Site_PageSubHeader_Text | safe : 'html') : ''\"\r\n      navigationAdapter\r\n    ></div>\r\n  </div>\r\n  <div class=\"col-12\">\r\n    <ng-container *ngIf=\"submitted && errorBannerList?.length\">\r\n      <vnext-notice\r\n        [title]=\"Spa_Member_Profile_ErrorMessages_TitleText\"\r\n        [messages]=\"errorBannerList\"\r\n        [type]=\"'error'\"\r\n        class=\"search-agent-notice\"\r\n      ></vnext-notice>\r\n    </ng-container>\r\n  </div>\r\n  <div class=\"d-flex flex-column flex-md-row justify-content-md-between mt-3 mb-5 account-overview-agent-section-wrapper\">\r\n    <div\r\n      class=\"mt-2 p-md-4 p-lg-4 px-3 pt-0 pb-3 rounded Spa_Style_Gray1_Background account-overview-agent-section\"\r\n      *ngIf=\"Spa_Agent_AccountOverview_Purl_Enabled\"\r\n    >\r\n      <h2 class=\"Spa_Style_H2 mt-2\" *liveEditProp=\"'Spa_Agent_AccountOverview_ShoppingLink_Header_Text'\">\r\n        {{ Spa_Agent_AccountOverview_ShoppingLink_Header_Text }}\r\n      </h2>\r\n      <div class=\"Spa_Style_Paragraph mb-3\" *liveEditProp=\"'Spa_Agent_AccountOverview_ShoppingLink_Content_Text'\">\r\n        {{ Spa_Agent_AccountOverview_ShoppingLink_Content_Text }}\r\n      </div>\r\n      <button\r\n        *ngIf=\"!!currentPlanYearPurl && agentHasPermissionForCurrentPlanYearPurl\"\r\n        class=\"btn Spa_Style_SecondaryButton col-xs-12 col-md-auto col-lg-auto\"\r\n        [ngClass]=\"{ 'mt-4': Spa_Agent_Profile_Picture_Upload_Enabled }\"\r\n        (click)=\"copyPurl(true)\"\r\n        placement=\"top\"\r\n        [ngbPopover]=\"getCopiedInfoTextTooltipName()\"\r\n        [autoClose]=\"'outside'\"\r\n        #copiedInfoPopover=\"ngbPopover\"\r\n        popoverClass=\"logout-popover\"\r\n        (keyup.enter)=\"copiedInfoPopover.toggle()\"\r\n      >\r\n        <span *liveEditProp=\"'Spa_Agent_AccountOverview_CopyLink_Text'\"> {{ Spa_Agent_AccountOverview_CopyLink_Text }}</span>\r\n      </button>\r\n      <br />\r\n      <div\r\n        *ngIf=\"isDualPlanYearPurlEnabled && !!dualPlanYearPurl && agentHasPermissionForDualPlanYearPurl\"\r\n        class=\"secondary-unique-code mt-3 d-inline-block\"\r\n      >\r\n        <vnext-link\r\n          class=\"Spa_Style_Link\"\r\n          (click)=\"copyPurl(false)\"\r\n          [title]=\"Spa_Agent_AccountOverview_CopyDualPlanYearLink_Text\"\r\n          [alwaysUnderlined]=\"true\"\r\n          placement=\"top\"\r\n          [ngbPopover]=\"getCopiedInfoTextTooltipName()\"\r\n          [autoClose]=\"'outside'\"\r\n          #copiedInfoPopover=\"ngbPopover\"\r\n          popoverClass=\"logout-popover\"\r\n          (keyup.enter)=\"copiedInfoPopover.toggle()\"\r\n        ></vnext-link>\r\n      </div>\r\n      <ng-template #copiedInfoText>\r\n        <span class=\"copied-info-text\">\r\n          <i class=\"fas fa-check-circle\" aria-hidden=\"true\"></i>\r\n          {{ Spa_Agent_AccountOverview_CopiedInfo_Text }}\r\n        </span>\r\n      </ng-template>\r\n    </div>\r\n\r\n    <!--RetroFlo Start-->\r\n    <div\r\n      *ngIf=\"Spa_RetireFlo_Enabled\"\r\n      class=\"mt-2 p-md-4 p-lg-4 px-3 pt-0 pb-3 rounded Spa_Style_Gray1_Background account-overview-agent-section\"\r\n    >\r\n      <h2 class=\"Spa_Style_H2 mt-2\" *liveEditProp=\"'Spa_Agent_AccountOverview_RetireFlo_Header_Text'\">\r\n        {{ Spa_Agent_AccountOverview_RetireFlo_Header_Text }}\r\n      </h2>\r\n      <div class=\"Spa_Style_Paragraph mb-3\" *liveEditProp=\"'Spa_Agent_AccountOverview_RetireFlo_Content_Text'\">\r\n        {{ Spa_Agent_AccountOverview_RetireFlo_Content_Text }}\r\n      </div>\r\n\r\n      <ng-container *ngIf=\"agentHasRetireFlo\">\r\n        <button class=\"btn Spa_Style_SecondaryButton col-xs-12 col-md-auto col-lg-auto\" (click)=\"loginToRetireFlo()\">\r\n          <span *liveEditProp=\"'Spa_Agent_AccountOverview_RetireFlo_LogIn_ButtonText'\">\r\n            {{ Spa_Agent_AccountOverview_RetireFlo_LogIn_ButtonText }}</span\r\n          >\r\n        </button>\r\n        <ng-container *ngIf=\"Spa_Agent_AccountOverview_RetireFlo_PURL_Enabled\">\r\n          <div class=\"seperator my-3\"></div>\r\n          <div class=\"Spa_Style_Paragraph mb-3\" *liveEditProp=\"'Spa_Agent_AccountOverview_RetireFlo_PURL_DescriptionText'\">\r\n            {{ Spa_Agent_AccountOverview_RetireFlo_PURL_DescriptionText }}\r\n          </div>\r\n          <button\r\n            class=\"btn Spa_Style_SecondaryButton col-xs-12 col-md-auto col-lg-auto\"\r\n            (click)=\"copyRetireFloPurl()\"\r\n            placement=\"top\"\r\n            [ngbPopover]=\"getCopiedInfoTextTooltipName()\"\r\n            [autoClose]=\"'outside'\"\r\n            #copiedInfoPopover=\"ngbPopover\"\r\n            popoverClass=\"logout-popover\"\r\n            (keyup.enter)=\"copiedInfoPopover.toggle()\"\r\n          >\r\n            <span *liveEditProp=\"'Spa_Agent_AccountOverview_RetireFlo_PURL_ButtonText'\">\r\n              {{ Spa_Agent_AccountOverview_RetireFlo_PURL_ButtonText }}</span\r\n            >\r\n          </button>\r\n        </ng-container>\r\n      </ng-container>\r\n      <button\r\n        *ngIf=\"!agentHasRetireFlo\"\r\n        class=\"btn Spa_Style_SecondaryButton col-xs-12 col-md-auto col-lg-auto\"\r\n        [ngClass]=\"{ 'mt-4': Spa_RetireFlo_Enabled }\"\r\n        (click)=\"retireFloSignUpModal()\"\r\n      >\r\n        <span *liveEditProp=\"'Spa_Agent_AccountOverview_RetireFlo_SignUp_ButtonText'\">\r\n          {{ Spa_Agent_AccountOverview_RetireFlo_SignUp_ButtonText }}</span\r\n        >\r\n      </button>\r\n    </div>\r\n    <!--RetroFlo End-->\r\n\r\n    <div\r\n      class=\"mt-2 py-md-4 px-md-4 px-3 pt-1 pt-md-0 pb-3 rounded Spa_Style_Gray1_Background account-overview-agent-section\"\r\n      *ngIf=\"Spa_Agent_Profile_Picture_Upload_Enabled && agentData\"\r\n    >\r\n      <vnext-agent-profile-upload\r\n        [agentData]=\"agentData\"\r\n        [agentProfilePictureUrl]=\"agentData?.agentPictureURL\"\r\n        [agentGuid]=\"agentData?.agentGuid\"\r\n        [fileUploadErrors]=\"fileUploadErrors\"\r\n        [agentProfilePictureHeader]=\"Spa_Agent_Profile_Picture_Header\"\r\n        [agentProfilePictureHeaderPropName]=\"'Spa_Agent_Profile_Picture_Header'\"\r\n        [agentProfilePictureContent]=\"Spa_Agent_Profile_Picture_Content\"\r\n        [agentProfilePictureContentPropName]=\"'Spa_Agent_Profile_Picture_Content'\"\r\n        [agentProfilePictureInstruction]=\"Spa_Agent_Profile_Picture_Instruction_Text\"\r\n        [agentProfilePictureUploadText]=\"Spa_Site_UploadLink_Text\"\r\n        [isFullWidthUploadContainer]=\"!Spa_Agent_AccountOverview_Purl_Enabled\"\r\n        (filechange)=\"fileChange($event)\"\r\n      ></vnext-agent-profile-upload>\r\n    </div>\r\n  </div>\r\n  <div class=\"container\">\r\n    <h2 *liveEditProp=\"'Spa_Agent_AccountOverview_PersonalHeader_Text'\" class=\"Spa_Style_H2 row mt-3 px-0\">\r\n      {{ Spa_Agent_AccountOverview_PersonalHeader_Text }}\r\n    </h2>\r\n    <form *ngIf=\"personalFormGroup\" class=\"row pb-4 align-items-end\" [formGroup]=\"personalFormGroup\">\r\n      <div class=\"row\">\r\n        <ng-container *ngFor=\"let control of agentPersonalAccountForm; trackBy: trackIndex\">\r\n          <div [ngClass]=\"agentPersonalAccountFormByLayoutClassNames[control.keyName]\" class=\"col-lg-3 col-12\">\r\n            <div class=\"w-100 d-flex flex-column\">\r\n              <div class=\"error-container pt-2\">\r\n                <ng-container\r\n                  *ngIf=\"\r\n                    personalFormGroup.controls[control.keyName]?.errors &&\r\n                    personalFormGroup.controls[control.keyName]?.enabled &&\r\n                    submitted &&\r\n                    (personalFormGroup.controls[control.keyName]?.touched || personalFormGroup.controls[control.keyName]?.dirty)\r\n                  \"\r\n                >\r\n                  <span class=\"Spa_Style_ErrorText align-bottom\">\r\n                    <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n                    {{ getPersonalError(control.keyName) }}\r\n                  </span>\r\n                </ng-container>\r\n              </div>\r\n              <div class=\"label-wrapper\">\r\n                <label\r\n                  class=\"Spa_Style_Small_Font Spa_Style_Bold_Weight\"\r\n                  [ngClass]=\"{\r\n                    Spa_Style_Primary_Color: personalFormGroup.controls[control.keyName]?.enabled,\r\n                    Spa_Style_Gray4_Color: control.disabled,\r\n                    Spa_Style_ErrorText:\r\n                      personalFormGroup.controls[control.keyName]?.errors &&\r\n                      submitted &&\r\n                      (personalFormGroup.controls[control.keyName]?.touched || personalFormGroup.controls[control.keyName]?.dirty)\r\n                  }\"\r\n                >\r\n                  <span\r\n                    *ngIf=\"personalControlIsRequired(control.keyName) || (submitted && personalFormGroup.controls[control.keyName]?.errors)\"\r\n                    class=\"input-asterisk\"\r\n                    [id]=\"control.keyName + 'LabelId'\"\r\n                    [ngClass]=\"{ 'error-color': !control.disabled }\"\r\n                    >*</span\r\n                  >{{ control.labelText }}\r\n                </label>\r\n              </div>\r\n              <!-- is a standard input -->\r\n              <ng-container *ngIf=\"getControlType(control.keyName) === 'input'\">\r\n                <input\r\n                  class=\"Spa_Style_Small_Font Spa_Style_Primary_Color form-control\"\r\n                  tabindex=\"0\"\r\n                  [attr.aria-labelledby]=\"control.keyName + 'LabelId'\"\r\n                  [type]=\"getType(control.keyName)\"\r\n                  [ngClass]=\"{\r\n                    'has-error':\r\n                      personalFormGroup.controls[control.keyName]?.errors &&\r\n                      submitted &&\r\n                      (personalFormGroup.controls[control.keyName]?.touched || personalFormGroup.controls[control.keyName]?.dirty),\r\n                    'Spa_Style_Gray4_Color readonly': control.disabled\r\n                  }\"\r\n                  [ngClass]=\"control.class\"\r\n                  [formControlName]=\"control.keyName\"\r\n                  [readonly]=\"control.disabled\"\r\n                  [mask]=\"getMask(control.keyName)\"\r\n                  [validation]=\"getValidation(control.keyName)\"\r\n                />\r\n              </ng-container>\r\n              <!-- is a dropdown -->\r\n              <ng-container *ngIf=\"control.keyName === accountOverviewInputs.STATE\">\r\n                <vnext-state-selector-input\r\n                  [customClass]=\"'Spa_Style_Small_Font Spa_Style_Primary_Color'\"\r\n                  [control]=\"getPersonalFormControl(control.keyName)\"\r\n                  [formSubmitted]=\"submitted\"\r\n                  [height]=\"'36px'\"\r\n                  [isReadOnly]=\"control.disabled\"\r\n                  [ariaLabelledById]=\"control.keyName + 'LabelId'\"\r\n                >\r\n                </vnext-state-selector-input>\r\n              </ng-container>\r\n            </div>\r\n          </div>\r\n          <div *ngIf=\"breakRowLayout[control.keyName]\" class=\"break\"></div>\r\n        </ng-container>\r\n      </div>\r\n    </form>\r\n    <ng-container *ngIf=\"Spa_Agent_AccountOverview_ManageMySubscription_Enabled\">\r\n      <h2 *liveEditProp=\"'Spa_Agent_AccountOverview_PersonalHeader_Text'\" class=\"Spa_Style_H2 row mt-5 px-0\">\r\n        {{ Spa_Agent_AccountOverview_ManageMySubscriptionHeader_Text }}\r\n      </h2>\r\n      <div class=\"subscription-section row pt-1 pb-4 mb-5\">\r\n        <div class=\"pt-4 w-100\">\r\n          <div [innerHTML]=\"Spa_Agent_AccountOverview_ManageMySubscription_Html | safe : 'html'\"></div>\r\n        </div>\r\n        <div class=\"pt-4 pb-1\">\r\n          <vnext-link\r\n            [href]=\"Spa_Agent_AccountOverview_ManageMySubscription_Url\"\r\n            [title]=\"Spa_Agent_AccountOverview_ManageMySubscription_Link_Text\"\r\n            [makeInlineBlock]=\"true\"\r\n            class=\"Spa_Style_Link\"\r\n            [linkTarget]=\"targetType.BLANK\"\r\n          >\r\n          </vnext-link>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n    <h2 *liveEditProp=\"'Spa_Agent_AccountOverview_AccountHeader_Text'\" class=\"Spa_Style_H2 row mt-5 px-0\">\r\n      {{ Spa_Agent_AccountOverview_AccountHeader_Text }}\r\n    </h2>\r\n    <form *ngIf=\"accountFormGroup\" class=\"row pt-1 pb-4 mb-5\" [formGroup]=\"accountFormGroup\">\r\n      <div class=\"row\">\r\n        <div *ngFor=\"let control of agentAccountForm; trackBy: trackIndex\" class=\"col-lg-3 col-md-6 col-12\">\r\n          <ng-container *ngIf=\"getAccountFormControl(control.keyName)\">\r\n            <div class=\"error-container pt-2\">\r\n              <ng-container *ngIf=\"submitted && hasError(control.keyName); else showValidationError\">\r\n                <span class=\"Spa_Style_ErrorText align-bottom\"\r\n                  ><i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i> {{ getAccountError(control.keyName) }}</span\r\n                >\r\n              </ng-container>\r\n              <ng-template #showValidationError>\r\n                <span class=\"Spa_Style_ErrorText align-bottom\" *ngIf=\"getAccountValidationError(control.keyName)\"\r\n                  ><i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i> {{ getAccountValidationError(control.keyName) }}</span\r\n                >\r\n              </ng-template>\r\n            </div>\r\n            <div class=\"label-wrapper\">\r\n              <label\r\n                *ngIf=\"accountControlIsDisplayed(control.keyName)\"\r\n                class=\"Spa_Style_Small_Font Spa_Style_Semi_Bold_Weight\"\r\n                [ngClass]=\"{\r\n                  Spa_Style_Primary_Color: getAccountFormControl(control.keyName)?.enabled,\r\n                  Spa_Style_Gray4_Color: !getAccountFormControl(control.keyName)?.enabled,\r\n                  Spa_Style_ErrorText: hasError(control.keyName) || getAccountValidationError(control.keyName)\r\n                }\"\r\n              >\r\n                <span\r\n                  *ngIf=\"accountControlIsRequired(control.keyName) || (submitted && getAccountFormControl(control.keyName)?.errors)\"\r\n                  class=\"input-asterisk\"\r\n                  [id]=\"control.keyName + 'LabelId'\"\r\n                  [ngClass]=\"{ 'error-color': !control.disabled }\"\r\n                  >*</span\r\n                >{{ control.labelText }}\r\n              </label>\r\n            </div>\r\n            <ng-container *ngIf=\"getControlType(control.keyName) === 'input'\">\r\n              <input\r\n                class=\"Spa_Style_Small_Font Spa_Style_Primary_Color form-control\"\r\n                tabindex=\"0\"\r\n                autocomplete=\"off\"\r\n                [attr.aria-labelledby]=\"control.keyName + 'LabelId'\"\r\n                [type]=\"getType(control.keyName)\"\r\n                [ngClass]=\"{\r\n                  'has-error':\r\n                    submitted && getAccountFormControl(control.keyName)?.errors && getAccountFormControl(control.keyName)?.touched\r\n                }\"\r\n                [formControlName]=\"control.keyName\"\r\n              />\r\n            </ng-container>\r\n            <ng-container *ngIf=\"AgencyHierarchy_Enabled && control.keyName === accountOverviewInputs.AGENT_AGENCY_NAME\">\r\n              <vnext-agency-name-selector-input\r\n                [control]=\"getAccountFormControl(control.keyName)\"\r\n                [agencyItems]=\"agencyItems\"\r\n                [agencyID]=\"userAgencyId\"\r\n                (emitAgencyId)=\"setAgencyIdField($event)\"\r\n                [formSubmitted]=\"submitted\"\r\n                [height]=\"'36px'\"\r\n                [isReadOnly]=\"isAgencyNameDisabled\"\r\n                [noneAvailableLabel]=\"Spa_Site_None_Available_Text\"\r\n                [ariaLabelledById]=\"control.keyName + 'LabelId'\"\r\n              >\r\n              </vnext-agency-name-selector-input>\r\n            </ng-container>\r\n            <ng-container *ngIf=\"control.keyName === accountOverviewInputs.SITE_ACCESS && (Spa_Agent_Show_New_Agent || isAdminUser)\">\r\n              <button type=\"button\" class=\"btn Spa_Style_SecondaryButton w-100\" (click)=\"changeSiteAccess()\">\r\n                {{ siteAccessButtonText }}\r\n              </button>\r\n            </ng-container>\r\n            <ng-container *ngIf=\"control.keyName === accountOverviewInputs.ACCOUNT_STATUS && (Spa_Agent_Show_New_Agent || isAdminUser)\">\r\n              <vnext-toggle-select\r\n                [items]=\"accountStatusItems\"\r\n                [buttonHeight]=\"'36px'\"\r\n                (optionSelected)=\"onSelectAccountStatus($event)\"\r\n                [selectedValue]=\"getAccountStatusDefaultValue()\"\r\n                [largerText]=\"true\"\r\n                [ariaLabelledById]=\"control.keyName + 'LabelId'\"\r\n              >\r\n              </vnext-toggle-select>\r\n            </ng-container>\r\n            <ng-container *ngIf=\"control.keyName === accountOverviewInputs.ASP_REQUIRED\">\r\n              <vnext-toggle-select\r\n                [items]=\"aspItems\"\r\n                [buttonHeight]=\"'36px'\"\r\n                (optionSelected)=\"onSelectASP($event)\"\r\n                [selectedValue]=\"getASPRequiredDefaultValue()\"\r\n                [largerText]=\"true\"\r\n                [isReadOnly]=\"getASPDisabled()\"\r\n                [ariaLabelledById]=\"control.keyName + 'LabelId'\"\r\n              >\r\n              </vnext-toggle-select>\r\n            </ng-container>\r\n            <ng-container\r\n              *ngIf=\"control.keyName === accountOverviewInputs.AGENT_PERMISSION_LEVEL && (Spa_Agent_Show_New_Agent || isAdminUser)\"\r\n            >\r\n              <vnext-agent-role-selector\r\n                [customClass]=\"'Spa_Style_Small_Font Spa_Style_Primary_Color'\"\r\n                [control]=\"getAccountFormControl(control.keyName)\"\r\n                [formSubmitted]=\"submitted\"\r\n                [placeholderDefaultValue]=\"getRoleDefaultValue()\"\r\n                [ariaLabelledById]=\"control.keyName + 'LabelId'\"\r\n              ></vnext-agent-role-selector>\r\n            </ng-container>\r\n            <ng-container *ngIf=\"control.keyName === accountOverviewInputs.PROFILE_ADMIN\">\r\n              <vnext-toggle-select\r\n                [items]=\"profileAdminOptions\"\r\n                [buttonHeight]=\"'36px'\"\r\n                [largerText]=\"true\"\r\n                [isReadOnly]=\"getProfileAdminDisabled()\"\r\n                [selectedValue]=\"getProfileAdminRequiredDefaultValue()\"\r\n                [ariaLabelledById]=\"control.keyName + 'LabelId'\"\r\n                (optionSelected)=\"onSelectProfileAdmin($event)\"\r\n              >\r\n              </vnext-toggle-select>\r\n            </ng-container>\r\n            <ng-container\r\n              *ngIf=\"\r\n                Spa_Agent_AccountOverview_AgentPlanYear_Display &&\r\n                control.keyName === accountOverviewInputs.ASP_ALLOW_ACCESS_TO_ALL_PLAN_YEARS\r\n              \"\r\n            >\r\n              <vnext-toggle-select\r\n                [items]=\"allowAccessToAllPlanYearsOptions\"\r\n                [buttonHeight]=\"'36px'\"\r\n                [selectedValue]=\"getAllowAccessToAllPlanYearsRequiredDefaultValue()\"\r\n                [largerText]=\"true\"\r\n                [isReadOnly]=\"getAllowAccessToAllPlanYearsDisabled()\"\r\n                [ariaLabelledById]=\"control.keyName + 'LabelId'\"\r\n                (optionSelected)=\"onSelectAllowAccessToAllPlanYears($event)\"\r\n              >\r\n              </vnext-toggle-select>\r\n            </ng-container>\r\n            <ng-container\r\n              *ngIf=\"\r\n                Spa_Agent_AccountOverview_AgentPlanYear_Display &&\r\n                !allowAccessToAllPlanYears &&\r\n                control.keyName === accountOverviewInputs.ASP_AGENT_PLAN_YEARS\r\n              \"\r\n            >\r\n              <vnext-checkbox-dropdown\r\n                [formControlName]=\"control.keyName\"\r\n                [options]=\"Spa_Agent_AccountOverview_AgentPlanYear_Json\"\r\n                [placeholder]=\"Spa_Agent_AccountOverview_AgentPlanYear_Placeholder\"\r\n                [selectedItemsDisplayTransform]=\"selectedItemsDisplayTransform\"\r\n                [submitted]=\"submitted\"\r\n                [disabled]=\"getAgentPlanYearsDisabled()\"\r\n                [locale]=\"locale\"\r\n                [ariaLabelledById]=\"control.keyName + 'LabelId'\"\r\n                [fieldId]=\"control.keyName\"\r\n                (onSelect)=\"updatePlanYear($event)\"\r\n              ></vnext-checkbox-dropdown>\r\n            </ng-container>\r\n            <ng-container *ngIf=\"control.keyName === accountOverviewInputs.AGENT_EXPIRATION_DATE\">\r\n              <vnext-med-sup-date\r\n                class=\"d-flex reduced-width-1\"\r\n                [customClass]=\"'Spa_Style_Small_Font Spa_Style_Primary_Color'\"\r\n                (sendDate)=\"setSelectedDate($event)\"\r\n                [defaultValue]=\"getDefaultDateValue() | date : 'MM/dd/yyyy'\"\r\n                [showDatePicker]=\"true\"\r\n                [fullWidth]=\"true\"\r\n                [isReadOnly]=\"control.disabled\"\r\n                [hasError]=\"submitted && !getAccountFormControl(control.keyName)?.valid && getAccountFormControl(control.keyName)?.touched\"\r\n                [ariaLabelledById]=\"control.keyName + 'LabelId'\"\r\n              >\r\n              </vnext-med-sup-date>\r\n            </ng-container>\r\n            <div\r\n              *ngIf=\"control.keyName === accountOverviewInputs.AGENT_PASSWORD && (Spa_Agent_Show_New_Agent || isAdminUser)\"\r\n              class=\"Spa_Style_Smaller_Font Spa_Style_Gray4_Color\"\r\n            >\r\n              {{ Spa_Agent_Password_Description }}\r\n            </div>\r\n            <div\r\n              *ngIf=\"control.keyName === accountOverviewInputs.AGENT_PERMISSION_LEVEL\"\r\n              class=\"Spa_Style_Smaller_Font Spa_Style_Gray4_Color\"\r\n            >\r\n              {{ roleDescription }}\r\n            </div>\r\n            <div\r\n              *ngIf=\"control.keyName === accountOverviewInputs.SITE_ACCESS && (Spa_Agent_Show_New_Agent || isAdminUser)\"\r\n              class=\"Spa_Style_Smaller_Font Spa_Style_Gray4_Color\"\r\n            >\r\n              {{ siteAccessDescription }}\r\n            </div>\r\n\r\n            <div\r\n              *ngIf=\"\r\n                Spa_Agent_AccountOverview_AgentPlanYear_Display &&\r\n                control.keyName === accountOverviewInputs.ASP_ALLOW_ACCESS_TO_ALL_PLAN_YEARS\r\n              \"\r\n              class=\"Spa_Style_Smaller_Font Spa_Style_Gray4_Color\"\r\n            >\r\n              {{ Spa_Agent_AccountOverview_AllowAccess_AgentPlanYear_Description }}\r\n            </div>\r\n            <div\r\n              *ngIf=\"\r\n                Spa_Agent_AccountOverview_AgentPlanYear_Display &&\r\n                !allowAccessToAllPlanYears &&\r\n                control.keyName === accountOverviewInputs.ASP_AGENT_PLAN_YEARS\r\n              \"\r\n              class=\"Spa_Style_Smaller_Font Spa_Style_Gray4_Color\"\r\n            >\r\n              {{ Spa_Agent_AccountOverview_AgentPlanYear_Description }}\r\n            </div>\r\n          </ng-container>\r\n        </div>\r\n        <div class=\"container mt-5\" *ngIf=\"AgencyHierarchy_Enabled && !Spa_Agent_Show_New_Agent\">\r\n          <div class=\"agencies-list-header\">\r\n            <label\r\n              class=\"Spa_Style_Small_Font Spa_Style_Semi_Bold_Weight Spa_Style_Primary_Color\"\r\n              *liveEditProp=\"'Spa_Agent_AccountOverview_AgenciesHeader_Text'\"\r\n              >{{ Spa_Agent_AccountOverview_AgenciesHeader_Text }}\r\n            </label>\r\n            <div\r\n              class=\"Spa_Style_Smaller_Font Spa_Style_Gray4_Color mb-2\"\r\n              *liveEditProp=\"'Spa_Agent_AccountOverview_AgenciesInstructional_Text'\"\r\n            >\r\n              {{ Spa_Agent_AccountOverview_AgenciesInstructional_Text }}\r\n            </div>\r\n          </div>\r\n          <ng-container *ngIf=\"selectedUserAgencies?.length; else showNoAgencyText\">\r\n            <div class=\"row pt-4 pl-2\">\r\n              <div class=\"col-3 mb-2\" *ngFor=\"let agency of selectedUserAgencies\">\r\n                <div class=\"agency-name no-translate-block\" [title]=\"agency.agencyName\">{{ agency.agencyName }}</div>\r\n              </div>\r\n            </div>\r\n          </ng-container>\r\n          <ng-template #showNoAgencyText>\r\n            <div class=\"col-md-12 no-agency-text\">\r\n              <div class=\"Spa_Style_Large_Font font-weight-bold\">{{ Spa_Agent_No_Agency_Header_Text }}</div>\r\n              <div class=\"Spa_Style_H5\" [innerHTML]=\"Spa_Agent_No_Agency_Sub_Header_Text | safe : 'html'\"></div>\r\n            </div>\r\n          </ng-template>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </div>\r\n  <div class=\"mb-2 container\">\r\n    <div class=\"d-flex justify-content-end row\">\r\n      <div class=\"button-container\">\r\n        <vnext-status-button\r\n          [buttonText]=\"Spa_Agent_AccountOverview_Button_Text\"\r\n          [buttonClass]=\"'Spa_Style_PrimaryButton'\"\r\n          [tooltipMessageError]=\"Spa_Agent_AccountOverview_TooltipError_Text\"\r\n          [tooltipMessageSuccess]=\"Spa_Agent_AccountOverview_TooltipSuccess_Text\"\r\n          (click)=\"saveAgentInfo()\"\r\n          *liveEditProp=\"'Spa_Agent_AccountOverview_Button_Text'\"\r\n        >\r\n        </vnext-status-button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"container\" *ngIf=\"showPermissionTable\">\r\n    <h2 #sellingPermissionsTable *liveEditProp=\"'Spa_Site_ActiveSellingPermissions_Text'\" class=\"Spa_Style_H2 row mt-4 px-0\">\r\n      {{ Spa_Site_ActiveSellingPermissions_Text }}\r\n    </h2>\r\n    <div class=\"row\">\r\n      <div class=\"w-100 d-flex justify-content-end\">\r\n        <div class=\"mr-3\" *ngIf=\"showAddPermissionsLink && isAdminUser\">\r\n          <vnext-link\r\n            [title]=\"Spa_Agent_Add_Permission_Link_Text\"\r\n            (click)=\"openAddPermissionsPopover()\"\r\n            [additionalIcon]=\"'fas fa-plus-circle'\"\r\n          >\r\n          </vnext-link>\r\n        </div>\r\n        <div>\r\n          <vnext-link\r\n            *ngIf=\"(agentSellingPermissions$ | async)?.length; else disabledFiltersLink\"\r\n            [title]=\"Spa_Filter_Header_Text\"\r\n            (click)=\"openFilterPermissionsPopover()\"\r\n            [additionalIcon]=\"'fas fa-filter'\"\r\n          >\r\n          </vnext-link>\r\n          <ng-template #disabledFiltersLink>\r\n            <vnext-link [title]=\"Spa_Filter_Header_Text\" [additionalIcon]=\"'fas fa-filter'\" [disabled]=\"true\"> </vnext-link>\r\n          </ng-template>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"w-100 popover-container px-1\">\r\n    <div\r\n      *ngIf=\"isAdminUser\"\r\n      class=\"addContainer\"\r\n      [ngbPopover]=\"permissionPopoverTemplate\"\r\n      #permissionPopover=\"ngbPopover\"\r\n      [autoClose]=\"false\"\r\n      placement=\"bottom-right\"\r\n      popoverClass=\"add-permission-popover\"\r\n    ></div>\r\n    <div\r\n      class=\"filterContainer\"\r\n      [ngbPopover]=\"filterPopoverTemplate\"\r\n      #filterPopover=\"ngbPopover\"\r\n      [autoClose]=\"false\"\r\n      placement=\"bottom-right\"\r\n      popoverClass=\"filter-permission-popover\"\r\n    ></div>\r\n    <ng-template #filterPopoverTemplate>\r\n      <vnext-filter-selling-permissions\r\n        (closePopover)=\"filterPermissionsPopoverClosed($event)\"\r\n        [planYearHeader]=\"Spa_Agent_Permission_Plan_Year_Header\"\r\n        [carrierHeader]=\"Spa_Agent_Permission_Carries_Header\"\r\n        [statesHeader]=\"Spa_Agent_Permission_States_Header\"\r\n        [planTypeHeader]=\"Spa_Agent_Permission_Plan_Type_Header\"\r\n        [clearAllText]=\"Spa_Site_ClearAll_Text\"\r\n        [applyText]=\"Spa_PlanFilters_Modal_Apply_Button\"\r\n        [viewPermissionsText]=\"Spa_Agent_ViewPermissions_Text\"\r\n        [yearSelectionEnabled]=\"Spa_Agent_Permission_Year_Selection_Enabled\"\r\n      ></vnext-filter-selling-permissions>\r\n    </ng-template>\r\n    <ng-template #permissionPopoverTemplate>\r\n      <vnext-add-agent-selling-permissions\r\n        (closePopover)=\"addPermissionsPopoverClosed()\"\r\n        (openPopover)=\"openAddPermissionsPopover()\"\r\n        [agentGuid]=\"agentData.agentGuid\"\r\n        [sellingPermissionFormLink]=\"Spa_Agent_Add_Permission_Link_Text\"\r\n        [carriers]=\"carriers$ | async\"\r\n        [permissions]=\"agentSellingPermissions$ | async\"\r\n        [permissionTypeHeader]=\"Spa_Agent_Permission_Type_Header\"\r\n        [permissionTypeError]=\"Spa_Agent_Permission_PermissionType_Error\"\r\n        [permissionPlanYearError]=\"Spa_Agent_Permission_Plan_Year_Selection_Error\"\r\n        [permissionCarrierError]=\"Spa_Agent_Permission_Carrier_Selection_Error\"\r\n        [permissionStatesError]=\"Spa_Agent_Permission_State_Selection_Error\"\r\n        [permissionPlanTypeError]=\"Spa_Agent_Permission_Plan_Type_Error\"\r\n        [permissionProducerIDError]=\"Spa_Agent_Permission_Producer_Id_Error\"\r\n        [permissionMedicareToggleOptions]=\"permissionMedicareToggleOptions\"\r\n        [medicarePlanYearSelectionJsonItems]=\"medicarePlanYearSelectionJsonItems\"\r\n        [defaultPlanYear]=\"planYear\"\r\n        [planYearHeader]=\"Spa_Agent_Permission_Plan_Year_Header\"\r\n        [carrierHeader]=\"Spa_Agent_Permission_Carries_Header\"\r\n        [statesHeader]=\"Spa_Agent_Permission_States_Header\"\r\n        [planTypeHeader]=\"Spa_Agent_Permission_Plan_Type_Header\"\r\n        [snpHeader]=\"Spa_Agent_Permission_SNP_Header\"\r\n        [producerIdHeader]=\"Spa_Agent_Permission_Producer_Id_Header\"\r\n        [permissionButton]=\"Spa_Agent_Add_Permission_Button_Text\"\r\n        [allStatesOption]=\"Spa_Agent_Permission_All_States_Option\"\r\n        [allPlanTypesOption]=\"Spa_Agent_Permission_All_Plan_Type_Option\"\r\n        [allSnpOption]=\"Spa_Agent_Permission_All_SNP_Option\"\r\n        [selectCarrierText]=\"Spa_Agent_Permission_Select_Carrier_Text\"\r\n        [selectStatesText]=\"Spa_Agent_Permission_Select_State_Text\"\r\n        [editStatesText]=\"Spa_Agent_Permission_Edit_State_Text\"\r\n        [selectPlanTypesText]=\"Spa_Agent_Permission_Select_Plan_Type_Text\"\r\n        [editPlanTypesText]=\"Spa_Agent_Permission_Edit_Plan_Type_Text\"\r\n        [selectSnpText]=\"Spa_Agent_Permission_Select_SNP_Text\"\r\n        [editSnpText]=\"Spa_Agent_Permission_Edit_SNP_Text\"\r\n        [listOfFieldValidations]=\"Spa_Agent_Permission_Field_Validations\"\r\n        [clearAllText]=\"Spa_Filter_Clear_All\"\r\n      ></vnext-add-agent-selling-permissions>\r\n    </ng-template>\r\n  </div>\r\n  <div class=\"container\" *ngIf=\"showPermissionTable\">\r\n    <vnext-active-selling-permissions\r\n      [agentData]=\"agentData\"\r\n      [carriers]=\"carriers$ | async\"\r\n      [headerText]=\"Spa_Site_ActiveSellingPermissions_Text\"\r\n      [carrierHeader]=\"Spa_Agent_Permission_Carries_Header\"\r\n      [stateHeader]=\"Spa_Agent_Permission_States_Header\"\r\n      [planTypeHeader]=\"Spa_Agent_Permission_Plan_Type_Header\"\r\n      [planYearHeader]=\"Spa_Agent_Permission_Plan_Year_Header\"\r\n      [producerIdHeader]=\"Spa_Agent_Permission_Producer_Id_Header\"\r\n      [agentSellingPermissions]=\"filteredAgentSellingPermissions$ | async\"\r\n      [itemsPerPage]=\"Spa_Site_Pagination_ItemsPerPage\"\r\n      [paginationText]=\"Spa_Site_Pagination_View_Text\"\r\n      [paginationEnabled]=\"Spa_PharmacySearch_Pagination_Enabled\"\r\n      [enableProducerIdColumn]=\"Spa_Agent_AccountOverview_ProducerId_Enabled\"\r\n      [noPermissionsTitle]=\"Spa_Agent_NoPermissions_Title\"\r\n      [noPermissionsBody]=\"Spa_Agent_NoPermissions_Body\"\r\n      [noPermissionsIcon]=\"Spa_Agent_NoPermissions_Icon\"\r\n      [noPermissionsAfterFiltersTitle]=\"Spa_Agent_NoPermissionsAfterFilters_Title\"\r\n      [noPermissionsAfterFiltersBody]=\"Spa_Agent_NoPermissionsAfterFilters_Body\"\r\n      [medSupAbbrev]=\"Spa_Agent_MedSupAbbreviation_Label\"\r\n      [ancillaryAbbrev]=\"Spa_Site_Ancillary_Text\"\r\n      [mappedCarriersText]=\"Spa_Site_ActiveSellingPermissions_Mapped_Carriers_Text\"\r\n      [noSNPText]=\"Spa_Agent_NoSNP_Label\"\r\n      [notApplicableText]=\"Spa_Site_NotApplicable_Text\"\r\n      [showRemoveCol]=\"Spa_Agent_ActiveSellingPermissions_AddRemove_Enabled && isAdminUser\"\r\n    ></vnext-active-selling-permissions>\r\n  </div>\r\n</div>\r\n", styles: ["input.form-control,button.btn{height:36px}form{min-height:200px;border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px;padding:0 18px}.error-container{min-height:40px;max-height:40px;line-height:1}.error-container:empty{display:none}.copied-info-text{color:var(--static-Spa_Style_Cost_Text)}.account-overview-agent-section-wrapper{gap:16px}.account-overview-agent-section{flex:1 1 0px}.agencies-list-header{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.agency-name{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.no-agency-text{margin-top:38px;text-align:center;line-height:28px}.label-wrapper{min-height:50px;display:flex;align-items:flex-end}.seperator{width:100%;border-top:2px solid var(--static-Spa_Style_Accent1)}@media (min-width: 320px){.reduced-width-1{width:100%}}@media (min-width: 768px){.error-icon{display:inline-block;width:10%;vertical-align:top}.error-message{display:inline-block;width:84%}}@media (max-width: 767.9px){.account-overview-agent-section{width:100%}.profile-text{margin-right:-20px;margin-left:-20px}}@media (max-width: 1200px){.profile-text{margin-right:-20px;margin-left:-20px}}@media (min-width: 991.9px){.reduced-width-1{width:50%}}.asp-popover-container{border:1px solid black}.break{flex-basis:100%;height:0}.subscription-section{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px;padding:0 18px}\n"] }]
    }], function () { return [{ type: i1.AgentService }, { type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.DeactivationGuardService }, { type: i1.FormValidationService }, { type: i1$1.NgbModal }, { type: AccountOverviewFacade }, { type: i2.Store }, { type: i1.UnsavedModalContext }, { type: i1.AgentPermissionsService }, { type: i1.NavigationService }, { type: i2$1.Router }, { type: AnalyticsService }, { type: i0.ElementRef }, { type: i1.SpinnerService }, { type: i2$1.ActivatedRoute }, { type: i1.ASPFilterService }, { type: i1.LocaleService }, { type: i1.PlanYearResourceService }, { type: i1.SiteService }, { type: i0.Injector }, { type: i1.ConfigResourceService }, { type: AgentRetireFloFacade }]; }, { permissionPopover: [{
            type: ViewChild,
            args: ['permissionPopover']
        }], filterPopover: [{
            type: ViewChild,
            args: ['filterPopover']
        }], copiedInfoText: [{
            type: ViewChild,
            args: ['copiedInfoText']
        }], sellingPermissionsTable: [{
            type: ViewChild,
            args: ['sellingPermissionsTable']
        }], saveButton: [{
            type: ViewChild,
            args: [StatusButtonComponent]
        }], Spa_Agent_AccountOverview_Enabled: [], Spa_Agent_AccountOverview_Header_Text: [], Spa_Agent_AccountOverview_PersonalHeader_Text: [], Spa_Agent_AccountOverview_AccountHeader_Text: [], Spa_Agent_AccountOverview_Button_Text: [], Spa_Agent_AccountOverview_TooltipError_Text: [], Spa_Agent_AccountOverview_TooltipSuccess_Text: [], Spa_Agent_AccountOverview_Purl_Enabled: [], Spa_Agent_AccountOverview_ShoppingLink_Header_Text: [], Spa_Agent_AccountOverview_ShoppingLink_Content_Text: [], Spa_Agent_AccountOverview_CopyLink_Text: [], Spa_Agent_AccountOverview_CopiedInfo_Text: [], Spa_Site_PageSubHeader_Text: [], Spa_Agent_AddAgent_Header_Text: [], Spa_Site_ActiveSellingPermissions_Text: [], Spa_Agent_AccountOverview_AgenciesHeader_Text: [], Spa_Agent_AccountOverview_AgenciesInstructional_Text: [], Spa_RetireFlo_Enabled: [], Spa_Agent_RetireFlo_LogIn_URL: [], Spa_RetireFlo_SignUp_URL: [], Spa_Agent_AccountOverview_RetireFlo_SignUp_ButtonText: [], Spa_Agent_AccountOverview_RetireFlo_LogIn_ButtonText: [], Spa_Agent_AccountOverview_RetireFlo_Header_Text: [], Spa_Agent_AccountOverview_RetireFlo_Content_Text: [], Spa_Site_ActiveSellingPermissions_Mapped_Carriers_Text: [], Spa_Site_Carrier_Header: [], Spa_Site_State_Header: [], Spa_Site_PlanType_Header: [], Spa_Site_Pagination_ItemsPerPage: [], Spa_PharmacySearch_Pagination_Enabled: [], Spa_Agent_ActiveSellingPermissions_Enabled: [], Spa_Agent_ActiveSellingPermissions_Link_Enabled: [], Spa_Site_Pagination_View_Text: [], Spa_Agent_Revoke_SiteAccess_Text: [], Spa_Agent_Grant_SiteAccess_Text: [], Spa_Agent_Revoke_SiteAccess_Description: [], Spa_Agent_Grant_SiteAccess_Description: [], Spa_Agent_Password_Description: [], Spa_AgentSearch_ActiveStatus_Text: [], Spa_AgentSearch_InactiveStatus_Text: [], Spa_Agent_Add_Permission_Link_Text: [], Spa_Agent_Permission_Type_Header: [], Spa_Agent_Permission_Medicare_Text: [], Spa_Agent_Permission_Medicare_Supplement_Text: [], Spa_Site_Ancillary_Text: [], Spa_Agent_Permission_Plan_Year_Header: [], Spa_Agent_Permission_Current_Year_Header: [], Spa_Agent_Permission_Next_Year_Header: [], Spa_Agent_Permission_Carries_Header: [], Spa_Agent_Permission_States_Header: [], Spa_Agent_Permission_Plan_Type_Header: [], Spa_Agent_Permission_SNP_Header: [], Spa_Agent_Permission_Producer_Id_Header: [], Spa_Agent_Add_Permission_Button_Text: [], Spa_Filter_Clear_All: [], Spa_Agent_Permission_Select_Carrier_Text: [], Spa_Agent_Permission_Select_State_Text: [], Spa_Agent_Permission_Edit_State_Text: [], Spa_Agent_Permission_Select_Plan_Type_Text: [], Spa_Agent_Permission_Edit_Plan_Type_Text: [], Spa_Agent_Permission_Select_SNP_Text: [], Spa_Agent_Permission_Edit_SNP_Text: [], Spa_Agent_Permission_Field_Validations: [], Spa_Agent_Permission_Is_State_Required: [], Spa_Agent_Permission_Is_PlanType_Required: [], Spa_Agent_Permission_Is_Producer_Id_Required: [], Spa_Agent_Permission_All_States_Option: [], Spa_Agent_Permission_All_Plan_Type_Option: [], Spa_Agent_Permission_All_SNP_Option: [], Spa_Agent_Permission_PermissionType_Error: [], Spa_Agent_Permission_Plan_Year_Selection_Error: [], Spa_Agent_Permission_Carrier_Selection_Error: [], Spa_Agent_Permission_State_Selection_Error: [], Spa_Agent_Permission_Plan_Type_Error: [], Spa_Agent_Permission_Producer_Id_Error: [], Spa_Agent_Permission_Year_Selection_Enabled: [], Spa_Agent_Show_New_Agent: [], Spa_Member_Profile_ErrorMessages_TitleText: [], Spa_Site_New_Agent_ResetPasswordRequired: [], Spa_Agent_ViewAgentProfile_AccountForm: [], Spa_Agent_Create_AccountForm: [], Spa_Agent_AccountOverview_AccountForm: [], Spa_Agent_AccountOverview_PersonalForm: [], Spa_Agent_Create_PersonalForm: [], Spa_Agent_ViewAgentProfile_PersonalForm: [], Spa_Agent_Profile_Picture_Upload_Enabled: [], Spa_Agent_ASPRequiredYes_Text: [], Spa_Agent_ASPRequiredNo_Text: [], Spa_Agent_AccountOverview_ASPRequired_Text: [], Spa_Agent_AccountOverview_ProducerId_Enabled: [], Spa_Agent_NoPermissions_Title: [], Spa_Agent_NoPermissions_Body: [], Spa_Agent_ProducerId_Text: [], Spa_Agent_PlanYear_Text: [], Spa_Agent_NoPermissions_Icon: [], Spa_Site_UploadLink_Text: [], Spa_Agent_Profile_Picture_Header: [], Spa_Agent_Profile_Picture_Content: [], Spa_Agent_AccountOverview_RetireFlo_PURL_ButtonText: [], Spa_Agent_AccountOverview_RetireFlo_PURL_DescriptionText: [], Spa_Agent_Profile_Picture_Instruction_Text: [], Spa_Filter_Header_Text: [], Spa_Site_ClearAll_Text: [], Spa_PlanFilters_Modal_Apply_Button: [], Spa_Agent_MedSupAbbreviation_Label: [], Spa_Agent_NoSNP_Label: [], Spa_Site_NotApplicable_Text: [], Spa_Agent_NoPermissionsAfterFilters_Title: [], Spa_Agent_NoPermissionsAfterFilters_Body: [], Spa_Agent_ActiveSellingPermissions_AddRemove_Enabled: [], Spa_Agent_ViewPermissions_Text: [], AgencyHierarchy_Enabled: [], Spa_Agent_No_Agency_Header_Text: [], Spa_Agent_No_Agency_Sub_Header_Text: [], Spa_Site_None_Available_Text: [], Spa_Agent_AccountOverview_Purl_DualPlanYear_Enabled: [], Spa_ConsumerSiteID_Enabled: [], Spa_Agent_Permission_PlanYearSelectionJson_Enabled: [], Spa_Agent_Permission_PlanYearSelection_Json: [], Spa_Agent_AccountOverview_CopyDualPlanYearLink_Text: [], Spa_Agent_AccountOverview_AgentPlanYear_Display_Admin: [], Spa_Agent_AccountOverview_AgentPlanYear_Display: [], Spa_Agent_AccountOverview_AgentPlanYear_Required: [], Spa_Agent_AccountOverview_AgentPlanYear_Placeholder: [], Spa_Agent_AccountOverview_AgentPlanYear_Edit_Placeholder: [], Spa_Agent_AccountOverview_AgentPlanYear_Json: [], Spa_Agent_AccountOverview_AllowAccess_AgentPlanYear_Description: [], Spa_Agent_AccountOverview_AgentPlanYear_Description: [], Spa_Agent_ProfileAdminFlag_Enabled: [], Spa_Site_Yes: [], Spa_Site_No: [], Spa_RetireFlo_SignUpModal_ContinueButton_Text: [], Spa_EnrollmentConfirmation_EmailConfirmationModal_Cancel: [], Spa_RetireFlo_SignUpModalHeader_Text: [], Spa_RetireFlo_SignUpModalContent_Text: [], Spa_RetireFlo_SignUpModalLogo_URL: [], Spa_Agent_AccountOverview_ManageMySubscription_Enabled: [], Spa_Agent_AccountOverview_ManageMySubscriptionHeader_Text: [], Spa_Agent_AccountOverview_ManageMySubscription_Html: [], Spa_Agent_AccountOverview_ManageMySubscription_Link_Text: [], Spa_Agent_AccountOverview_ManageMySubscription_Url: [], Spa_Agent_AccountOverview_RetireFlo_PURL_Enabled: [], changeSiteAccess: [], getCopiedInfoTextTooltipName: [], saveAgentInfo: [], copyPurl: [], copyRetireFloPurl: [], fileChange: [] }); })();

function AgentSearchResultComponent_ng_container_1_h2_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 5)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.searchResultHeaderText);
} }
function AgentSearchResultComponent_ng_container_1_div_3_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const agentResult_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(agentResult_r5 == null ? null : agentResult_r5.organizations[(agentResult_r5 == null ? null : agentResult_r5.organizations.length) - 1] == null ? null : agentResult_r5.organizations[(agentResult_r5 == null ? null : agentResult_r5.organizations.length) - 1].name);
} }
function AgentSearchResultComponent_ng_container_1_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7)(2, "vnext-link", 8);
    i0.ɵɵlistener("click", function AgentSearchResultComponent_ng_container_1_div_3_Template_vnext_link_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const agentResult_r5 = restoredCtx.$implicit; const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8.onNavigateToAgentProfile(agentResult_r5)); })("keyup.Enter", function AgentSearchResultComponent_ng_container_1_div_3_Template_vnext_link_keyup_Enter_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const agentResult_r5 = restoredCtx.$implicit; const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.onNavigateToAgentProfile(agentResult_r5)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div")(4, "span", 9);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(6, "div", 10);
    i0.ɵɵelement(7, "i", 11);
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 7);
    i0.ɵɵtemplate(11, AgentSearchResultComponent_ng_container_1_div_3_span_11_Template, 2, 1, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 10)(13, "span");
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const agentResult_r5 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("title", "", agentResult_r5 == null ? null : agentResult_r5.firstName, " ", agentResult_r5 == null ? null : agentResult_r5.lastName, "");
    i0.ɵɵproperty("alwaysUnderlined", true);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(agentResult_r5 == null ? null : agentResult_r5.userName);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("pr-2 fas fa-circle ", (agentResult_r5 == null ? null : agentResult_r5.isActive) ? ctx_r4.activeStatusColor : ctx_r4.inactiveStatusColor, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((agentResult_r5 == null ? null : agentResult_r5.isActive) ? ctx_r4.activeStatusText : ctx_r4.inactiveStatusText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", agentResult_r5 == null ? null : agentResult_r5.organizations[(agentResult_r5 == null ? null : agentResult_r5.organizations.length) - 1] == null ? null : agentResult_r5.organizations[(agentResult_r5 == null ? null : agentResult_r5.organizations.length) - 1].isOrgActive);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate((agentResult_r5 == null ? null : agentResult_r5.siteAccess) ? ctx_r4.siteAccessText : ctx_r4.noSiteAccessText);
} }
function AgentSearchResultComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AgentSearchResultComponent_ng_container_1_h2_1_Template, 3, 1, "h2", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵlistener("scrolled", function AgentSearchResultComponent_ng_container_1_Template_div_scrolled_2_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.onScrollDown()); });
    i0.ɵɵtemplate(3, AgentSearchResultComponent_ng_container_1_div_3_Template, 15, 10, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_AgentSearchResult_Header_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("infiniteScrollDistance", 2)("infiniteScrollThrottle", 50);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.visibleAgents);
} }
function AgentSearchResultComponent_ng_container_2_ng_container_1_h6_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r15.noSearchResultText);
} }
function AgentSearchResultComponent_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 14)(2, "div");
    i0.ɵɵtemplate(3, AgentSearchResultComponent_ng_container_2_ng_container_1_h6_3_Template, 3, 1, "h6", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 16)(5, "button", 17);
    i0.ɵɵlistener("click", function AgentSearchResultComponent_ng_container_2_ng_container_1_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r16.onNavigateByTag(ctx_r16.pageTags.ADD_NEW_AGENT)); });
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", "Spa_AgentSearch_NoResult_Text");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r13.createNewProfileButtonText);
} }
function AgentSearchResultComponent_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-warning-message-many-results-agent-search", 18);
    i0.ɵɵlistener("clearSearch", function AgentSearchResultComponent_ng_container_2_ng_container_2_Template_vnext_warning_message_many_results_agent_search_clearSearch_1_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r18.onNavigateByTag(ctx_r18.pageTags.AGENT_SEARCH)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("timeoutMessageText", ctx_r14.timeoutMessageText)("searchAgainButtonText", ctx_r14.searchAgainButtonText);
} }
function AgentSearchResultComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AgentSearchResultComponent_ng_container_2_ng_container_1_Template, 8, 2, "ng-container", 0);
    i0.ɵɵtemplate(2, AgentSearchResultComponent_ng_container_2_ng_container_2_Template, 2, 2, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.agentProfileSearchResult === ctx_r1.memberSearchResultModel.NO_RESULTS);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.searchTimeoutMessageEnabled && ctx_r1.agentProfileSearchResult === ctx_r1.memberSearchResultModel.NO_RESULTS_TIMEOUT);
} }
function AgentSearchResultComponent_div_3_vnext_link_3_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 22);
    i0.ɵɵlistener("click", function AgentSearchResultComponent_div_3_vnext_link_3_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r21.onNavigateByTag(ctx_r21.pageTags.AGENT_SEARCH)); })("keyup.Enter", function AgentSearchResultComponent_div_3_vnext_link_3_Template_vnext_link_keyup_Enter_0_listener() { i0.ɵɵrestoreView(_r22); const ctx_r23 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r23.onNavigateByTag(ctx_r23.pageTags.AGENT_SEARCH)); });
    i0.ɵɵelementStart(1, "span", 23);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r20.searchAgainLinkText);
} }
function AgentSearchResultComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "span", 20);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, AgentSearchResultComponent_div_3_vnext_link_3_Template, 3, 1, "vnext-link", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.searchAgainOrText, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_AgentSearch_SearchAgain_Link_Text");
} }
class AgentSearchResultComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.memberSearchResultModel = AgentSearchResult;
        this.navigateByTag = new EventEmitter();
        this.navigateToAgentProfile = new EventEmitter();
        this.subscriptions = new Subscription();
        this.pageTags = PageTags;
        this.skipAgentsBy = 20;
        this._visibleAgentIndex$ = new BehaviorSubject(this.skipAgentsBy);
        this.visibleAgentIndex$ = this._visibleAgentIndex$.asObservable();
        this._searchResults$ = new BehaviorSubject([]);
    }
    ngOnInit() {
        this.subscriptions.add(combineLatest([this.getAgentResults$(), this.visibleAgentIndex$]).subscribe({
            next: ([agentResults, visibleAgentIndex]) => {
                this.visibleAgents = agentResults?.slice(0, visibleAgentIndex) ?? [];
                this.cdr.markForCheck();
            }
        }));
    }
    ngOnChanges(changes) {
        const { agentSearchResult } = changes;
        if (agentSearchResult && !_isEqual(agentSearchResult.previousValue, agentSearchResult.currentValue)) {
            this.setAgentResults(this.agentSearchResult);
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    setAgentResults(agentSearchResults) {
        this._searchResults$.next(agentSearchResults);
    }
    getAgentResults$() {
        return this._searchResults$.asObservable();
    }
    onNavigateByTag(pageTag) {
        this.navigateByTag.emit(pageTag);
    }
    onNavigateToAgentProfile(agent) {
        this.navigateToAgentProfile.emit(agent);
    }
    onScrollDown() {
        this.visibleAgentIndex$.pipe(take(1)).subscribe(visibleAgentIndex => {
            if (this.agentSearchResult?.length > visibleAgentIndex) {
                this._visibleAgentIndex$.next(visibleAgentIndex + this.skipAgentsBy);
            }
        });
    }
}
AgentSearchResultComponent.ɵfac = function AgentSearchResultComponent_Factory(t) { return new (t || AgentSearchResultComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
AgentSearchResultComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentSearchResultComponent, selectors: [["vnext-agent-search-result"]], inputs: { noSearchResultText: "noSearchResultText", searchAgainLinkText: "searchAgainLinkText", createNewProfileButtonText: "createNewProfileButtonText", searchResultHeaderText: "searchResultHeaderText", agentSearchResult: "agentSearchResult", agentProfileSearchResult: "agentProfileSearchResult", searchAgainOrText: "searchAgainOrText", activeStatusText: "activeStatusText", activeStatusColor: "activeStatusColor", inactiveStatusText: "inactiveStatusText", inactiveStatusColor: "inactiveStatusColor", siteAccessText: "siteAccessText", noSiteAccessText: "noSiteAccessText", searchTimeoutMessageEnabled: "searchTimeoutMessageEnabled", timeoutMessageText: "timeoutMessageText", searchAgainButtonText: "searchAgainButtonText" }, outputs: { navigateByTag: "navigateByTag", navigateToAgentProfile: "navigateToAgentProfile" }, features: [i0.ɵɵNgOnChangesFeature], decls: 4, vars: 3, consts: [[4, "ngIf"], ["class", "d-flex align-items-center justify-content-center m-0 mt-2", 4, "ngIf"], ["class", "Spa_Style_Larger_Font mb-4 mt-5", 4, "liveEditProp"], ["infiniteScroll", "", "aria-live", "polite", "aria-atomic", "true", 3, "infiniteScrollDistance", "infiniteScrollThrottle", "scrolled"], ["class", "row mx-0 d-flex result-card Spa_Style_Smaller_Font Spa_Style_Paragraph mb-3", 4, "ngFor", "ngForOf"], [1, "Spa_Style_Larger_Font", "mb-4", "mt-5"], [1, "row", "mx-0", "d-flex", "result-card", "Spa_Style_Smaller_Font", "Spa_Style_Paragraph", "mb-3"], [1, "col-lg-3", "col-12", "mb-1", "col-md-6"], [1, "text-content-wrap", "no-translate-block", 3, "alwaysUnderlined", "title", "click", "keyup.Enter"], [1, "text-content-wrap", "mt-1", "no-translate-block"], [1, "col-lg-3", "col-12", "mb-1", "col-md-6", "no-translate-block"], ["aria-hidden", "true"], ["class", "text-content-wrap no-translate-block", 4, "ngIf"], [1, "text-content-wrap", "no-translate-block"], [1, "text-center", "no-result-wrapper", "mb-3"], [4, "liveEditProp"], ["continue-button", ""], [1, "btn", "Spa_Style_PrimaryButton", "col-xs-12", "col-md-auto", 3, "click"], [3, "timeoutMessageText", "searchAgainButtonText", "clearSearch"], [1, "d-flex", "align-items-center", "justify-content-center", "m-0", "mt-2"], [1, "mr-1", "d-inline-block"], ["class", "Spa_Style_Small_Font Spa_Style_Paragraph", 3, "click", "keyup.Enter", 4, "liveEditProp"], [1, "Spa_Style_Small_Font", "Spa_Style_Paragraph", 3, "click", "keyup.Enter"], ["link-body", ""]], template: function AgentSearchResultComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, AgentSearchResultComponent_ng_container_1_Template, 4, 4, "ng-container", 0);
        i0.ɵɵtemplate(2, AgentSearchResultComponent_ng_container_2_Template, 3, 2, "ng-container", 0);
        i0.ɵɵtemplate(3, AgentSearchResultComponent_div_3_Template, 4, 2, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.visibleAgents == null ? null : ctx.visibleAgents.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !(ctx.visibleAgents == null ? null : ctx.visibleAgents.length));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.agentProfileSearchResult !== ctx.memberSearchResultModel.NO_RESULTS_TIMEOUT);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, LinkComponent, WarningMessageManyResultsAgentSearchComponent, LiveEditPropDirective, i2$2.InfiniteScrollDirective], styles: [".result-card[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between;padding:15px 5px;border-width:1px;border-style:solid;border-radius:4px;border-color:var(--static-Spa_Style_Accent1)}.text-content-wrap[_ngcontent-%COMP%]{white-space:normal;word-wrap:break-word}.no-result-wrapper[_ngcontent-%COMP%]{margin-top:100px}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], AgentSearchResultComponent.prototype, "onNavigateByTag", null);
__decorate([
    LiveEditInactive()
], AgentSearchResultComponent.prototype, "onNavigateToAgentProfile", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentSearchResultComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-search-result', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div>\r\n  <ng-container *ngIf=\"visibleAgents?.length\">\r\n    <h2 *liveEditProp=\"'Spa_AgentSearchResult_Header_Text'\" class=\"Spa_Style_Larger_Font mb-4 mt-5\">\r\n      <span>{{ searchResultHeaderText }}</span>\r\n    </h2>\r\n    <div\r\n      infiniteScroll\r\n      [infiniteScrollDistance]=\"2\"\r\n      [infiniteScrollThrottle]=\"50\"\r\n      (scrolled)=\"onScrollDown()\"\r\n      aria-live=\"polite\"\r\n      aria-atomic=\"true\"\r\n    >\r\n      <div *ngFor=\"let agentResult of visibleAgents\" class=\"row mx-0 d-flex result-card Spa_Style_Smaller_Font Spa_Style_Paragraph mb-3\">\r\n        <div class=\"col-lg-3 col-12 mb-1 col-md-6\">\r\n          <vnext-link\r\n            class=\"text-content-wrap no-translate-block\"\r\n            (click)=\"onNavigateToAgentProfile(agentResult)\"\r\n            (keyup.Enter)=\"onNavigateToAgentProfile(agentResult)\"\r\n            [alwaysUnderlined]=\"true\"\r\n            title=\"{{ agentResult?.firstName }} {{ agentResult?.lastName }}\"\r\n          >\r\n          </vnext-link>\r\n          <div>\r\n            <span class=\"text-content-wrap mt-1 no-translate-block\">{{ agentResult?.userName }}</span>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-lg-3 col-12 mb-1 col-md-6 no-translate-block\">\r\n          <i class=\"pr-2 fas fa-circle {{ agentResult?.isActive ? activeStatusColor : inactiveStatusColor }}\" aria-hidden=\"true\"></i>\r\n          <span>{{ agentResult?.isActive ? activeStatusText : inactiveStatusText }}</span>\r\n        </div>\r\n        <div class=\"col-lg-3 col-12 mb-1 col-md-6\">\r\n          <span *ngIf=\"(agentResult?.organizations)[agentResult?.organizations.length - 1]?.isOrgActive\" class=\"text-content-wrap no-translate-block\">{{\r\n            (agentResult?.organizations)[agentResult?.organizations.length - 1]?.name\r\n          }}</span>\r\n        </div>\r\n        <div class=\"col-lg-3 col-12 mb-1 col-md-6 no-translate-block\">\r\n          <span>{{ agentResult?.siteAccess ? siteAccessText : noSiteAccessText }}</span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"!visibleAgents?.length\">\r\n    <ng-container *ngIf=\"agentProfileSearchResult === memberSearchResultModel.NO_RESULTS\">\r\n      <div class=\"text-center no-result-wrapper mb-3\">\r\n        <div>\r\n          <h6 *liveEditProp=\"'Spa_AgentSearch_NoResult_Text'\">\r\n            <span>{{ noSearchResultText }}</span>\r\n          </h6>\r\n        </div>\r\n        <div continue-button>\r\n          <button class=\"btn Spa_Style_PrimaryButton col-xs-12 col-md-auto\" (click)=\"onNavigateByTag(pageTags.ADD_NEW_AGENT)\">\r\n            <span>{{ createNewProfileButtonText }}</span>\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"searchTimeoutMessageEnabled && agentProfileSearchResult === memberSearchResultModel.NO_RESULTS_TIMEOUT\">\r\n      <vnext-warning-message-many-results-agent-search\r\n        [timeoutMessageText]=\"timeoutMessageText\"\r\n        [searchAgainButtonText]=\"searchAgainButtonText\"\r\n        (clearSearch)=\"onNavigateByTag(pageTags.AGENT_SEARCH)\"\r\n      >\r\n      </vnext-warning-message-many-results-agent-search>\r\n    </ng-container>\r\n  </ng-container>\r\n\r\n  <div\r\n    *ngIf=\"agentProfileSearchResult !== memberSearchResultModel.NO_RESULTS_TIMEOUT\"\r\n    class=\"d-flex align-items-center justify-content-center m-0 mt-2\"\r\n  >\r\n    <span class=\"mr-1 d-inline-block\"> {{ searchAgainOrText }}</span>\r\n    <vnext-link\r\n      *liveEditProp=\"'Spa_AgentSearch_SearchAgain_Link_Text'\"\r\n      class=\"Spa_Style_Small_Font Spa_Style_Paragraph\"\r\n      (click)=\"onNavigateByTag(pageTags.AGENT_SEARCH)\"\r\n      (keyup.Enter)=\"onNavigateByTag(pageTags.AGENT_SEARCH)\"\r\n      ><span link-body>{{ searchAgainLinkText }}</span>\r\n    </vnext-link>\r\n  </div>\r\n</div>\r\n", styles: [".result-card{display:flex;align-items:center;justify-content:space-between;padding:15px 5px;border-width:1px;border-style:solid;border-radius:4px;border-color:var(--static-Spa_Style_Accent1)}.text-content-wrap{white-space:normal;word-wrap:break-word}.no-result-wrapper{margin-top:100px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { noSearchResultText: [{
            type: Input
        }], searchAgainLinkText: [{
            type: Input
        }], createNewProfileButtonText: [{
            type: Input
        }], searchResultHeaderText: [{
            type: Input
        }], agentSearchResult: [{
            type: Input
        }], agentProfileSearchResult: [{
            type: Input
        }], searchAgainOrText: [{
            type: Input
        }], activeStatusText: [{
            type: Input
        }], activeStatusColor: [{
            type: Input
        }], inactiveStatusText: [{
            type: Input
        }], inactiveStatusColor: [{
            type: Input
        }], siteAccessText: [{
            type: Input
        }], noSiteAccessText: [{
            type: Input
        }], searchTimeoutMessageEnabled: [{
            type: Input
        }], timeoutMessageText: [{
            type: Input
        }], searchAgainButtonText: [{
            type: Input
        }], navigateByTag: [{
            type: Output
        }], navigateToAgentProfile: [{
            type: Output
        }], onNavigateByTag: [], onNavigateToAgentProfile: [] }); })();

const _c0$2M = ["searchInput"];
function AgentProfileSearchComponent_h1_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 7)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.Spa_SearchAgent_Header_Title);
} }
function AgentProfileSearchComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r1.Spa_Site_PageSubHeader_Text ? i0.ɵɵpipeBind2(1, 1, ctx_r1.Spa_Site_PageSubHeader_Text, "html") : "", i0.ɵɵsanitizeHtml);
} }
function AgentProfileSearchComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "div", 8);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", ctx_r2.Spa_Agent_Search_SearchResult_Information_Text ? i0.ɵɵpipeBind2(2, 1, ctx_r2.Spa_Agent_Search_SearchResult_Information_Text, "html") : "", i0.ɵɵsanitizeHtml);
} }
function AgentProfileSearchComponent_div_6_form_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelement(2, "vnext-notice", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", ctx_r7.Spa_ProfileSearch_ErrorMessages_Text)("type", "error");
} }
function AgentProfileSearchComponent_div_6_form_1_div_3_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 22);
    i0.ɵɵelement(2, "i", 23);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r9 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.getAgentSearchError(control_r9), " ");
} }
const _c1$1r = function (a0) { return { "has-error": a0 }; };
function AgentProfileSearchComponent_div_6_form_1_div_3_ng_container_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "input", 24, 25);
    i0.ɵɵlistener("keyup.enter", function AgentProfileSearchComponent_div_6_form_1_div_3_ng_container_1_ng_container_6_Template_input_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r18.searchAgentProfile()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r9 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r13 = i0.ɵɵnextContext(3);
    let tmp_2_0;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", control_r9)("formControlName", control_r9)("ngClass", i0.ɵɵpureFunction1(3, _c1$1r, ((tmp_2_0 = ctx_r13.getAgentSearchFormControl(control_r9)) == null ? null : tmp_2_0.errors) && ctx_r13.submitted));
} }
function AgentProfileSearchComponent_div_6_form_1_div_3_ng_container_1_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-agency-name-selector-input", 26);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r9 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("ariaLabelledById", "label_id_", control_r9, "");
    i0.ɵɵproperty("control", ctx_r14.getAgentSearchFormControl(control_r9))("agencyItems", ctx_r14.agencyItems)("formSubmitted", ctx_r14.submitted)("height", "36px")("noneAvailableLabel", ctx_r14.Spa_Site_None_Available_Text);
} }
function AgentProfileSearchComponent_div_6_form_1_div_3_ng_container_1_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-toggle-select", 27);
    i0.ɵɵlistener("optionSelected", function AgentProfileSearchComponent_div_6_form_1_div_3_ng_container_1_ng_container_8_Template_vnext_toggle_select_optionSelected_1_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r22.onOptionSelect($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r9 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("ariaLabelledById", "label_id_", control_r9, "");
    i0.ɵɵproperty("items", ctx_r15.accountStatus)("buttonHeight", "36px")("selectedValue", ctx_r15.hasAccountStatusSelection())("verticalGrow", false)("lightBackground", false)("darkenOnHover", false)("largerText", true);
} }
const _c2$U = function (a0, a1) { return { Spa_Style_Primary_Color: a0, error: a1 }; };
const _c3$D = function (a0) { return { "error-color": a0 }; };
function AgentProfileSearchComponent_div_6_form_1_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 19);
    i0.ɵɵtemplate(2, AgentProfileSearchComponent_div_6_form_1_div_3_ng_container_1_ng_container_2_Template, 4, 1, "ng-container", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 20)(4, "span", 21);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, AgentProfileSearchComponent_div_6_form_1_div_3_ng_container_1_ng_container_6_Template, 3, 5, "ng-container", 6);
    i0.ɵɵtemplate(7, AgentProfileSearchComponent_div_6_form_1_div_3_ng_container_1_ng_container_7_Template, 2, 6, "ng-container", 6);
    i0.ɵɵtemplate(8, AgentProfileSearchComponent_div_6_form_1_div_3_ng_container_1_ng_container_8_Template, 2, 8, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r11 = i0.ɵɵnextContext(3);
    let tmp_0_0;
    let tmp_3_0;
    let tmp_4_0;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ((tmp_0_0 = ctx_r11.getAgentSearchFormControl(control_r9)) == null ? null : tmp_0_0.errors) && ctx_r11.submitted && ((tmp_0_0 = ctx_r11.getAgentSearchFormControl(control_r9)) == null ? null : tmp_0_0.enabled));
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "label_id_", control_r9, "");
    i0.ɵɵproperty("for", control_r9)("ngClass", i0.ɵɵpureFunction2(9, _c2$U, (tmp_3_0 = ctx_r11.getAgentSearchFormControl(control_r9)) == null ? null : tmp_3_0.enabled, ((tmp_3_0 = ctx_r11.getAgentSearchFormControl(control_r9)) == null ? null : tmp_3_0.errors) && ctx_r11.submitted));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c3$D, ((tmp_4_0 = ctx_r11.getAgentSearchFormControl(control_r9)) == null ? null : tmp_4_0.errors) && ctx_r11.submitted));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r11.getAgentSearchLabelText(control_r9));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.getControlType(control_r9) === "input");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.AgencyHierarchy_Enabled && control_r9 === ctx_r11.accountOverviewInputs.AGENT_AGENCY_NAME);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", control_r9 === ctx_r11.accountOverviewInputs.AGENT_FLAG);
} }
function AgentProfileSearchComponent_div_6_form_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, AgentProfileSearchComponent_div_6_form_1_div_3_ng_container_1_Template, 9, 14, "ng-container", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const control_r9 = ctx.$implicit;
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.getAgentSearchFormControl(control_r9));
} }
function AgentProfileSearchComponent_div_6_form_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "form", 14)(1, "div", 15);
    i0.ɵɵtemplate(2, AgentProfileSearchComponent_div_6_form_1_ng_container_2_Template, 3, 2, "ng-container", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, AgentProfileSearchComponent_div_6_form_1_div_3_Template, 2, 1, "div", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r5.agentSearchFormGroup);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.submitted && ctx_r5.isSearchCriteriaEmpty());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r5.agentSearchControlNames);
} }
function AgentProfileSearchComponent_div_6_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function AgentProfileSearchComponent_div_6_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r26.searchAgentProfile()); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r6.Spa_SearchProfiles_Button_Text);
} }
function AgentProfileSearchComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AgentProfileSearchComponent_div_6_form_1_Template, 4, 3, "form", 9);
    i0.ɵɵelementStart(2, "div", 10)(3, "vnext-navigation-banner", 11)(4, "div", 12);
    i0.ɵɵtemplate(5, AgentProfileSearchComponent_div_6_button_5_Template, 3, 1, "button", 13);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.agentSearchFormGroup);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("liveEditProp", "Spa_SearchProfiles_Button_Text");
} }
function AgentProfileSearchComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-agent-search-result", 29);
    i0.ɵɵlistener("navigateByTag", function AgentProfileSearchComponent_ng_container_7_Template_vnext_agent_search_result_navigateByTag_1_listener($event) { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r28.navigateByPageTag($event)); })("navigateToAgentProfile", function AgentProfileSearchComponent_ng_container_7_Template_vnext_agent_search_result_navigateToAgentProfile_1_listener($event) { i0.ɵɵrestoreView(_r29); const ctx_r30 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r30.viewAgentProfile($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("agentSearchResult", ctx_r4.agentSearchData)("agentProfileSearchResult", ctx_r4.agentProfileSearchResult)("searchTimeoutMessageEnabled", ctx_r4.Spa_Site_Search_Timeout_Message_Enabled)("noSearchResultText", ctx_r4.Spa_AgentSearch_NoResult_Text)("searchAgainLinkText", ctx_r4.Spa_AgentSearch_SearchAgain_Link_Text)("createNewProfileButtonText", ctx_r4.Spa_AgentSearch_CreateNewProfile_Button_Text)("searchResultHeaderText", ctx_r4.Spa_AgentSearchResult_Header_Text)("searchAgainOrText", ctx_r4.Spa_AgentSearch_SearchAgainOr_Text)("activeStatusText", ctx_r4.Spa_AgentSearch_ActiveStatus_Text)("activeStatusColor", ctx_r4.Spa_AgentSearch_ActiveStatus_Color)("inactiveStatusText", ctx_r4.Spa_AgentSearch_InactiveStatus_Text)("inactiveStatusColor", ctx_r4.Spa_AgentSearch_InactiveStatus_Color)("siteAccessText", ctx_r4.Spa_AgentSearch_SiteAccess_Text)("noSiteAccessText", ctx_r4.Spa_AgentSearch_NoSiteAccess_Text)("timeoutMessageText", ctx_r4.Spa_Site_Search_Timeout_Message_Text)("searchAgainButtonText", ctx_r4.Spa_Site_Search_SearchAgain_Button_Text);
} }
var ControlType;
(function (ControlType) {
    ControlType["TOGGLE_TYPE"] = "toggle";
    ControlType["INPUT_TYPE"] = "input";
    ControlType["DROPDOWN"] = "dropdown";
})(ControlType || (ControlType = {}));
let AgentProfileSearchComponent = class AgentProfileSearchComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, accountOverviewFacade, navigationService, agentSearchFacade, profileFacade, analyticsService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.accountOverviewFacade = accountOverviewFacade;
        this.navigationService = navigationService;
        this.agentSearchFacade = agentSearchFacade;
        this.profileFacade = profileFacade;
        this.analyticsService = analyticsService;
        this.Spa_SearchProfiles_Button_Text = 'Search profiles';
        this.Spa_AgentSearch_NoResult_Text = 'There are no results for the profile you searched.';
        this.Spa_AgentSearch_SearchAgain_Link_Text = 'Search again';
        this.Spa_AgentSearchResult_Header_Text = 'Search results';
        this.Spa_SearchAgent_Header_Title = 'Search agents';
        this.Spa_Site_PageSubHeader_Text = '';
        this.Spa_Agent_Search_SearchResult_Information_Text = '';
        this.Spa_ProfileSearch_ErrorMessages_Text = 'Please provide at least one search criteria.';
        this.Spa_AgentSearch_SearchAgainOr_Text = 'or';
        this.Spa_AgentSearch_ActiveStatus_Text = 'Active';
        this.Spa_AgentSearch_InactiveStatus_Text = 'Inactive';
        this.Spa_AgentSearch_ActiveStatus_Color = 'Spa_Style_Accent5_Color';
        this.Spa_AgentSearch_InactiveStatus_Color = 'Spa_Style_Accent1_Color';
        this.Spa_AgentSearch_SiteAccess_Text = 'Site access';
        this.Spa_AgentSearch_NoSiteAccess_Text = 'No site access';
        this.SPA_AgentProfile_AccountStatus_Items = [
            { display: this.Spa_AgentSearch_ActiveStatus_Text, value: true },
            { display: this.Spa_AgentSearch_InactiveStatus_Text, value: false }
        ];
        this.Spa_AgentSearch_CreateNewProfile_Button_Text = 'Create a new profile';
        this.AgencyHierarchy_Enabled = false;
        this.Spa_Site_None_Available_Text = 'None available';
        this.Spa_Profile_Search_Show_AgentUserName = true;
        this.Spa_Site_Search_Timeout_Message_Enabled = false;
        this.Spa_Site_Search_Timeout_Seconds = 30;
        this.Spa_Site_Search_Timeout_Message_Text = `
    <div class="d-flex justify-content-center col-12">
      <div class="Spa_Style_Paragraph Spa_Style_Large_Font font-weight-bold mx-auto no-search-result-text">
        Too many results
      </div>
    </div>

    <div class="d-flex justify-content-center col-12 mt-2">
      <div class="Spa_Style_Paragraph Spa_Style_Regular_Font mx-auto no-search-result-text">
        Please specify additional search criteria to return results
      </div>
    </div>
  `;
        this.Spa_Site_Search_SearchAgain_Button_Text = 'Refine Search';
        this.submitted = false;
        this.accountOverviewInputs = AccountOverviewInputs;
        this.accountStatus = [];
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        super.ngOnInit();
        this.agentSearchFormGroup = this.accountOverviewFacade.getAgentSearchFormGroup();
        if (this.AgencyHierarchy_Enabled) {
            this.agencyItems = this.accountOverviewFacade.getFilteredAgencies();
        }
        if (this.Spa_Site_Search_Timeout_Message_Enabled) {
            this.searchTimeoutMilliSeconds = DateUtilities.secondsToMilliseconds(this.Spa_Site_Search_Timeout_Seconds);
        }
        this.subscriptions.add(this.profileFacade.isAgentSearch$.subscribe(isSearchResult => {
            this.isSearchResult = isSearchResult;
            this.agentSearchFormGroup.reset();
            this.submitted = false;
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.accountOverviewFacade.getAgentSearchResult$().subscribe(agentSearchResult => {
            this.agentProfileSearchResult = agentSearchResult;
            this.cdr.markForCheck();
        }));
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
    preProcessProperties() {
        this.accountStatus = this.SPA_AgentProfile_AccountStatus_Items;
    }
    isSearchCriteriaEmpty() {
        const agentSearchFormValues = this.agentSearchFormGroup.value;
        return (!agentSearchFormValues[AccountOverviewInputs.AGENT_FIRST_NAME] &&
            !agentSearchFormValues[AccountOverviewInputs.AGENT_LAST_NAME] &&
            !agentSearchFormValues[AccountOverviewInputs.AGENT_USERNAME] &&
            !agentSearchFormValues[AccountOverviewInputs.AGENT_AGENCY_NAME] &&
            !agentSearchFormValues[AccountOverviewInputs.AGENT_NPN] &&
            (agentSearchFormValues[AccountOverviewInputs.AGENT_FLAG] === undefined ||
                agentSearchFormValues[AccountOverviewInputs.AGENT_FLAG] === null));
    }
    navigateByPageTag(pageTag) {
        this.submitted = false;
        this.profileFacade.agentSearchNavigationClicked(false);
        this.agentSearchFormGroup.reset();
        this.navigationService.navigateByPageTag(pageTag);
    }
    viewAgentProfile(agentData) {
        if (agentData) {
            this.accountOverviewFacade.setSelectedAgentGuid(agentData.userId);
            this.agentSearchFacade.navigateByPageTag(PageTags.AGENT_VIEW_PROFILE);
        }
    }
    onOptionSelect(event) {
        this.agentSearchFormGroup.patchValue({ [AccountOverviewInputs.AGENT_FLAG]: event.data.value });
    }
    hasAccountStatusSelection() {
        const agentSearchFormValues = this.agentSearchFormGroup.value;
        if (!(agentSearchFormValues[AccountOverviewInputs.AGENT_FLAG] === undefined)) {
            return agentSearchFormValues[AccountOverviewInputs.AGENT_FLAG];
        }
    }
    get agentSearchControlNames() {
        return Object.keys(this.agentSearchFormGroup.getRawValue()).map(control => control);
    }
    getAgentSearchLabelText(controlName) {
        return this.accountOverviewFacade.agentSearchFormConfig.find(input => input.keyName === controlName).labelText;
    }
    getAgentSearchFormControl(controlName) {
        return this.agentSearchFormGroup.get(controlName);
    }
    getAgentSearchError(controlName) {
        return this.accountOverviewFacade.getAgentSearchErrorMessage(controlName);
    }
    getControlType(controlName) {
        return controlName === AccountOverviewInputs.AGENT_FLAG
            ? ControlType.TOGGLE_TYPE
            : controlName === AccountOverviewInputs.AGENT_AGENCY_NAME && this.AgencyHierarchy_Enabled
                ? ControlType.DROPDOWN
                : ControlType.INPUT_TYPE;
    }
    searchAgentProfile() {
        const agentSearchFields = this.profileFacade.getSearchFields(this.agentSearchFormGroup.value);
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_AGENT_SEARCH,
            [DataLayerGlobalVariable.AGENT_SEARCH_FIELDS]: agentSearchFields
        };
        this.submitted = true;
        if (!this.isSearchCriteriaEmpty() && this.agentSearchFormGroup.status !== 'INVALID') {
            this.configurableWidgetService.spinnerService.show(SpinnerEvent.SUBMITTED_FORM_LOADING);
            const agentSearchFormValues = this.agentSearchFormGroup.value;
            this.accountOverviewFacade
                .searchAgents$({
                firstName: agentSearchFormValues[AccountOverviewInputs.AGENT_FIRST_NAME],
                lastName: agentSearchFormValues[AccountOverviewInputs.AGENT_LAST_NAME],
                userName: agentSearchFormValues[AccountOverviewInputs.AGENT_USERNAME],
                agencyName: agentSearchFormValues[AccountOverviewInputs.AGENT_AGENCY_NAME],
                npn: agentSearchFormValues[AccountOverviewInputs.AGENT_NPN],
                isActive: agentSearchFormValues[AccountOverviewInputs.AGENT_FLAG]
            }, this.searchTimeoutMilliSeconds)
                .pipe(take(1))
                .subscribe({
                next: data => {
                    this.agentSearchData = data?.data ?? [];
                    if (!!this.agentSearchData?.length) {
                        this.accountOverviewFacade.setAgentSearchResult(AgentSearchResult.RESULTS);
                    }
                    else {
                        this.accountOverviewFacade.setAgentSearchResult(AgentSearchResult.NO_RESULTS);
                    }
                    this.hasSubmittedSearchAgentsForm();
                    this.cdr.markForCheck();
                },
                error: error => {
                    if (error?.name === TIMEOUT_ERROR) {
                        this.accountOverviewFacade.setAgentSearchResult(AgentSearchResult.NO_RESULTS_TIMEOUT);
                    }
                    else {
                        this.accountOverviewFacade.setAgentSearchResult(AgentSearchResult.NO_RESULTS);
                    }
                    this.hasSubmittedSearchAgentsForm();
                }
            });
        }
        else if (this.searchInputs) {
            this.cdr.markForCheck();
        }
    }
    hasSubmittedSearchAgentsForm() {
        this.configurableWidgetService.spinnerService.hide(SpinnerEvent.SUBMITTED_FORM_LOADING);
        this.profileFacade.agentSearchNavigationClicked(true);
    }
};
AgentProfileSearchComponent.ɵfac = function AgentProfileSearchComponent_Factory(t) { return new (t || AgentProfileSearchComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(AccountOverviewFacade), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(AgentSearchFacade), i0.ɵɵdirectiveInject(ProfileFacade), i0.ɵɵdirectiveInject(AnalyticsService)); };
AgentProfileSearchComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentProfileSearchComponent, selectors: [["vnext-agent-profile-search"]], viewQuery: function AgentProfileSearchComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$2M, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchInputs = _t);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService, InputResetContextService]), i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 6, consts: [["vnextGoogleTagManager", "", 1, "mx-auto", "container", 3, "saveDefaultValues"], [1, "py-3"], ["class", "col-12 text-center Spa_Style_H1 mt-4 mb-0", 4, "liveEditProp"], [1, "col-12", "mt-4"], ["navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["class", "col-12 mt-4", 4, "ngIf"], [4, "ngIf"], [1, "col-12", "text-center", "Spa_Style_H1", "mt-4", "mb-0"], ["navigationAdapter", "", 3, "innerHtml"], ["class", "row pt-4 pb-0 mt-3", 3, "formGroup", 4, "ngIf"], [1, "row"], [1, "col-md-12", "col-xs-12"], ["continue-button", ""], ["class", "btn Spa_Style_PrimaryButton col-xs-12 col-md-auto", 3, "click", 4, "liveEditProp"], [1, "row", "pt-4", "pb-0", "mt-3", 3, "formGroup"], [1, "col-12"], ["class", "col-lg-4 col-md-6 col-12", 4, "ngFor", "ngForOf"], [1, "search-agent-notice", 3, "title", "type"], [1, "col-lg-4", "col-md-6", "col-12"], [1, "error-container", "pt-2", "Spa_Style_Smaller_Font", "align-bottom", "text-nowrap"], [1, "Spa_Style_Label", 3, "for", "id", "ngClass"], [3, "ngClass"], [1, "error", "align-bottom"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], ["type", "text", "tabindex", "0", 1, "form-control", 3, "id", "formControlName", "ngClass", "keyup.enter"], ["searchInput", ""], [3, "ariaLabelledById", "control", "agencyItems", "formSubmitted", "height", "noneAvailableLabel"], [3, "ariaLabelledById", "items", "buttonHeight", "selectedValue", "verticalGrow", "lightBackground", "darkenOnHover", "largerText", "optionSelected"], [1, "btn", "Spa_Style_PrimaryButton", "col-xs-12", "col-md-auto", 3, "click"], [3, "agentSearchResult", "agentProfileSearchResult", "searchTimeoutMessageEnabled", "noSearchResultText", "searchAgainLinkText", "createNewProfileButtonText", "searchResultHeaderText", "searchAgainOrText", "activeStatusText", "activeStatusColor", "inactiveStatusText", "inactiveStatusColor", "siteAccessText", "noSiteAccessText", "timeoutMessageText", "searchAgainButtonText", "navigateByTag", "navigateToAgentProfile"]], template: function AgentProfileSearchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, AgentProfileSearchComponent_h1_2_Template, 3, 1, "h1", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, AgentProfileSearchComponent_div_4_Template, 2, 4, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, AgentProfileSearchComponent_div_5_Template, 3, 4, "div", 5);
        i0.ɵɵtemplate(6, AgentProfileSearchComponent_div_6_Template, 6, 2, "div", 6);
        i0.ɵɵtemplate(7, AgentProfileSearchComponent_ng_container_7_Template, 2, 16, "ng-container", 6);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("saveDefaultValues", true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_SearchAgent_Header_Title");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_PageSubHeader_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSearchResult);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isSearchResult);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSearchResult);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, NavigationBannerComponent, ToggleSelectComponent, AgencyNameSelectorInputComponent, NoticeComponent, NavigationAdapterDirective, LiveEditPropDirective, GoogleTagManagerDirective, IconAriaAttributesDirective, AgentSearchResultComponent, SafePipe], encapsulation: 2, changeDetection: 0 });
__decorate([
    PlatformProp('live-edit')
], AgentProfileSearchComponent.prototype, "Spa_SearchProfiles_Button_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentProfileSearchComponent.prototype, "Spa_AgentSearch_NoResult_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentProfileSearchComponent.prototype, "Spa_AgentSearch_SearchAgain_Link_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentProfileSearchComponent.prototype, "Spa_AgentSearchResult_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentProfileSearchComponent.prototype, "Spa_SearchAgent_Header_Title", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentProfileSearchComponent.prototype, "Spa_Site_PageSubHeader_Text", void 0);
__decorate([
    GlobalResource()
], AgentProfileSearchComponent.prototype, "Spa_Agent_Search_SearchResult_Information_Text", void 0);
__decorate([
    GlobalResource()
], AgentProfileSearchComponent.prototype, "Spa_ProfileSearch_ErrorMessages_Text", void 0);
__decorate([
    GlobalResource()
], AgentProfileSearchComponent.prototype, "Spa_AgentSearch_SearchAgainOr_Text", void 0);
__decorate([
    GlobalResource()
], AgentProfileSearchComponent.prototype, "Spa_AgentSearch_ActiveStatus_Text", void 0);
__decorate([
    GlobalResource()
], AgentProfileSearchComponent.prototype, "Spa_AgentSearch_InactiveStatus_Text", void 0);
__decorate([
    GlobalResource()
], AgentProfileSearchComponent.prototype, "Spa_AgentSearch_ActiveStatus_Color", void 0);
__decorate([
    GlobalResource()
], AgentProfileSearchComponent.prototype, "Spa_AgentSearch_InactiveStatus_Color", void 0);
__decorate([
    GlobalResource()
], AgentProfileSearchComponent.prototype, "Spa_AgentSearch_SiteAccess_Text", void 0);
__decorate([
    GlobalResource()
], AgentProfileSearchComponent.prototype, "Spa_AgentSearch_NoSiteAccess_Text", void 0);
__decorate([
    GlobalResource(true)
], AgentProfileSearchComponent.prototype, "SPA_AgentProfile_AccountStatus_Items", void 0);
__decorate([
    GlobalResource()
], AgentProfileSearchComponent.prototype, "Spa_AgentSearch_CreateNewProfile_Button_Text", void 0);
__decorate([
    GlobalResource()
], AgentProfileSearchComponent.prototype, "AgencyHierarchy_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentProfileSearchComponent.prototype, "Spa_Site_None_Available_Text", void 0);
__decorate([
    GlobalResource()
], AgentProfileSearchComponent.prototype, "Spa_Profile_Search_Show_AgentUserName", void 0);
__decorate([
    GlobalResource()
], AgentProfileSearchComponent.prototype, "Spa_Site_Search_Timeout_Message_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentProfileSearchComponent.prototype, "Spa_Site_Search_Timeout_Seconds", void 0);
__decorate([
    PlatformProp()
], AgentProfileSearchComponent.prototype, "Spa_Site_Search_Timeout_Message_Text", void 0);
__decorate([
    GlobalResource()
], AgentProfileSearchComponent.prototype, "Spa_Site_Search_SearchAgain_Button_Text", void 0);
__decorate([
    LiveEditInactive()
], AgentProfileSearchComponent.prototype, "searchAgentProfile", null);
AgentProfileSearchComponent = __decorate([
    PlatformWidget
], AgentProfileSearchComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentProfileSearchComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-profile-search', providers: [WidgetService, InputResetContextService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"mx-auto container\" vnextGoogleTagManager [saveDefaultValues]=\"true\">\r\n  <div class=\"py-3\">\r\n    <h1 *liveEditProp=\"'Spa_SearchAgent_Header_Title'\" class=\"col-12 text-center Spa_Style_H1 mt-4 mb-0\">\r\n      <span>{{ Spa_SearchAgent_Header_Title }}</span>\r\n    </h1>\r\n    <div class=\"col-12 mt-4\">\r\n      <div\r\n        *liveEditProp=\"'Spa_Site_PageSubHeader_Text'\"\r\n        [innerHtml]=\"Spa_Site_PageSubHeader_Text ? (Spa_Site_PageSubHeader_Text | safe : 'html') : ''\"\r\n        navigationAdapter\r\n      ></div>\r\n    </div>\r\n    <div *ngIf=\"isSearchResult\" class=\"col-12 mt-4\">\r\n      <div\r\n        [innerHtml]=\"Spa_Agent_Search_SearchResult_Information_Text ? (Spa_Agent_Search_SearchResult_Information_Text | safe : 'html') : ''\"\r\n        navigationAdapter\r\n      ></div>\r\n    </div>\r\n    <div *ngIf=\"!isSearchResult\">\r\n      <form *ngIf=\"agentSearchFormGroup\" class=\"row pt-4 pb-0 mt-3\" [formGroup]=\"agentSearchFormGroup\">\r\n        <div class=\"col-12\">\r\n          <ng-container *ngIf=\"submitted && isSearchCriteriaEmpty()\">\r\n            <div>\r\n              <vnext-notice [title]=\"Spa_ProfileSearch_ErrorMessages_Text\" [type]=\"'error'\" class=\"search-agent-notice\"> </vnext-notice>\r\n            </div>\r\n          </ng-container>\r\n        </div>\r\n        <div *ngFor=\"let control of agentSearchControlNames; i as index\" class=\"col-lg-4 col-md-6 col-12\">\r\n          <ng-container *ngIf=\"getAgentSearchFormControl(control)\">\r\n            <div class=\"error-container pt-2 Spa_Style_Smaller_Font align-bottom text-nowrap\">\r\n              <ng-container *ngIf=\"getAgentSearchFormControl(control)?.errors && submitted && getAgentSearchFormControl(control)?.enabled\">\r\n                <span class=\"error align-bottom\">\r\n                  <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i> {{ getAgentSearchError(control) }}\r\n                </span>\r\n              </ng-container>\r\n            </div>\r\n            <label\r\n              class=\"Spa_Style_Label\"\r\n              [for]=\"control\"\r\n              id=\"label_id_{{ control }}\"\r\n              [ngClass]=\"{\r\n                Spa_Style_Primary_Color: getAgentSearchFormControl(control)?.enabled,\r\n                error: getAgentSearchFormControl(control)?.errors && submitted\r\n              }\"\r\n            >\r\n              <span [ngClass]=\"{ 'error-color': getAgentSearchFormControl(control)?.errors && submitted }\">{{\r\n                getAgentSearchLabelText(control)\r\n              }}</span>\r\n            </label>\r\n            <ng-container *ngIf=\"getControlType(control) === 'input'\">\r\n              <input\r\n                #searchInput\r\n                type=\"text\"\r\n                class=\"Spa_Style_Smaller_Font\"\r\n                tabindex=\"0\"\r\n                class=\"form-control\"\r\n                [id]=\"control\"\r\n                [formControlName]=\"control\"\r\n                [ngClass]=\"{ 'has-error': getAgentSearchFormControl(control)?.errors && submitted }\"\r\n                (keyup.enter)=\"searchAgentProfile()\"\r\n              />\r\n            </ng-container>\r\n            <ng-container *ngIf=\"AgencyHierarchy_Enabled && control === accountOverviewInputs.AGENT_AGENCY_NAME\">\r\n              <vnext-agency-name-selector-input\r\n                ariaLabelledById=\"label_id_{{ control }}\"\r\n                [control]=\"getAgentSearchFormControl(control)\"\r\n                [agencyItems]=\"agencyItems\"\r\n                [formSubmitted]=\"submitted\"\r\n                [height]=\"'36px'\"\r\n                [noneAvailableLabel]=\"Spa_Site_None_Available_Text\"\r\n              >\r\n              </vnext-agency-name-selector-input>\r\n            </ng-container>\r\n            <ng-container *ngIf=\"control === accountOverviewInputs.AGENT_FLAG\">\r\n              <vnext-toggle-select\r\n                ariaLabelledById=\"label_id_{{ control }}\"\r\n                [items]=\"accountStatus\"\r\n                [buttonHeight]=\"'36px'\"\r\n                (optionSelected)=\"onOptionSelect($event)\"\r\n                [selectedValue]=\"hasAccountStatusSelection()\"\r\n                [verticalGrow]=\"false\"\r\n                [lightBackground]=\"false\"\r\n                [darkenOnHover]=\"false\"\r\n                [largerText]=\"true\"\r\n              >\r\n              </vnext-toggle-select>\r\n            </ng-container>\r\n          </ng-container>\r\n        </div>\r\n      </form>\r\n      <div class=\"row\">\r\n        <vnext-navigation-banner class=\"col-md-12 col-xs-12\">\r\n          <div continue-button>\r\n            <button\r\n              class=\"btn Spa_Style_PrimaryButton col-xs-12 col-md-auto\"\r\n              *liveEditProp=\"'Spa_SearchProfiles_Button_Text'\"\r\n              (click)=\"searchAgentProfile()\"\r\n            >\r\n              <span>{{ Spa_SearchProfiles_Button_Text }}</span>\r\n            </button>\r\n          </div>\r\n        </vnext-navigation-banner>\r\n      </div>\r\n    </div>\r\n    <ng-container *ngIf=\"isSearchResult\">\r\n      <vnext-agent-search-result\r\n        [agentSearchResult]=\"agentSearchData\"\r\n        [agentProfileSearchResult]=\"agentProfileSearchResult\"\r\n        [searchTimeoutMessageEnabled]=\"Spa_Site_Search_Timeout_Message_Enabled\"\r\n        [noSearchResultText]=\"Spa_AgentSearch_NoResult_Text\"\r\n        [searchAgainLinkText]=\"Spa_AgentSearch_SearchAgain_Link_Text\"\r\n        [createNewProfileButtonText]=\"Spa_AgentSearch_CreateNewProfile_Button_Text\"\r\n        [searchResultHeaderText]=\"Spa_AgentSearchResult_Header_Text\"\r\n        [searchAgainOrText]=\"Spa_AgentSearch_SearchAgainOr_Text\"\r\n        [activeStatusText]=\"Spa_AgentSearch_ActiveStatus_Text\"\r\n        [activeStatusColor]=\"Spa_AgentSearch_ActiveStatus_Color\"\r\n        [inactiveStatusText]=\"Spa_AgentSearch_InactiveStatus_Text\"\r\n        [inactiveStatusColor]=\"Spa_AgentSearch_InactiveStatus_Color\"\r\n        [siteAccessText]=\"Spa_AgentSearch_SiteAccess_Text\"\r\n        [noSiteAccessText]=\"Spa_AgentSearch_NoSiteAccess_Text\"\r\n        [timeoutMessageText]=\"Spa_Site_Search_Timeout_Message_Text\"\r\n        [searchAgainButtonText]=\"Spa_Site_Search_SearchAgain_Button_Text\"\r\n        (navigateByTag)=\"navigateByPageTag($event)\"\r\n        (navigateToAgentProfile)=\"viewAgentProfile($event)\"\r\n      ></vnext-agent-search-result>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: AccountOverviewFacade }, { type: i1.NavigationService }, { type: AgentSearchFacade }, { type: ProfileFacade }, { type: AnalyticsService }]; }, { Spa_SearchProfiles_Button_Text: [], Spa_AgentSearch_NoResult_Text: [], Spa_AgentSearch_SearchAgain_Link_Text: [], Spa_AgentSearchResult_Header_Text: [], Spa_SearchAgent_Header_Title: [], Spa_Site_PageSubHeader_Text: [], Spa_Agent_Search_SearchResult_Information_Text: [], Spa_ProfileSearch_ErrorMessages_Text: [], Spa_AgentSearch_SearchAgainOr_Text: [], Spa_AgentSearch_ActiveStatus_Text: [], Spa_AgentSearch_InactiveStatus_Text: [], Spa_AgentSearch_ActiveStatus_Color: [], Spa_AgentSearch_InactiveStatus_Color: [], Spa_AgentSearch_SiteAccess_Text: [], Spa_AgentSearch_NoSiteAccess_Text: [], SPA_AgentProfile_AccountStatus_Items: [], Spa_AgentSearch_CreateNewProfile_Button_Text: [], AgencyHierarchy_Enabled: [], Spa_Site_None_Available_Text: [], Spa_Profile_Search_Show_AgentUserName: [], Spa_Site_Search_Timeout_Message_Enabled: [], Spa_Site_Search_Timeout_Seconds: [], Spa_Site_Search_Timeout_Message_Text: [], Spa_Site_Search_SearchAgain_Button_Text: [], searchInputs: [{
            type: ViewChildren,
            args: ['searchInput']
        }], searchAgentProfile: [] }); })();

class SortOption {
}

function TransferCodeSearchComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.labelText);
} }
class TransferCodeSearchComponent {
    constructor() {
        this.labelText = 'Spa_Agent_Search_TransferCodeFieldLabel_Text';
        this.labelResourceName = 'Spa_Agent_Search_TransferCodeFieldLabel_Text';
        this.seperatorText = 'Spa_Agent_Search_UniqueCodeSeperator_Text';
        this.onTransferCodeFieldBlur = new EventEmitter();
        this.transferCodeSearchForm = new UntypedFormGroup({});
        this.transferCodeSearchFieldName = 'transferCodeSearchField';
    }
    ngOnInit() {
        this.transferCodeSearchForm = new UntypedFormGroup({
            [this.transferCodeSearchFieldName]: new UntypedFormControl('', { updateOn: 'change' })
        });
    }
    emitValue() {
        const transferCodeField = this.transferCodeSearchForm.get(this.transferCodeSearchFieldName);
        this.onTransferCodeFieldBlur.emit(transferCodeField.value);
    }
    clearField() {
        const transferCodeField = this.transferCodeSearchForm.get(this.transferCodeSearchFieldName);
        if (transferCodeField) {
            transferCodeField.setValue('');
        }
    }
}
TransferCodeSearchComponent.ɵfac = function TransferCodeSearchComponent_Factory(t) { return new (t || TransferCodeSearchComponent)(); };
TransferCodeSearchComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TransferCodeSearchComponent, selectors: [["vnext-transfer-code-search"]], inputs: { labelText: "labelText", labelResourceName: "labelResourceName", seperatorText: "seperatorText" }, outputs: { onTransferCodeFieldBlur: "onTransferCodeFieldBlur" }, decls: 8, vars: 3, consts: [[1, "transfer-code-search"], [3, "formGroup"], ["for", "transferCodeSearchField", 1, "Spa_Style_Small_Font", "Spa_Style_Bold_Weight", "Spa_Style_Primary_Color", "pt-0", "text-nowrap", "mt-2"], [4, "liveEditProp"], ["id", "transferCodeSearchField", "type", "text", "tabindex", "0", "formControlName", "transferCodeSearchField", 1, "form-control", "mb-2", "personal-code-field", "col-md-3", "col-xs-12", 3, "blur", "keyup.enter"], ["searchInput", ""], [1, "hr-text", "mb-3"]], template: function TransferCodeSearchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "form", 1)(2, "label", 2);
        i0.ɵɵtemplate(3, TransferCodeSearchComponent_span_3_Template, 2, 1, "span", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "input", 4, 5);
        i0.ɵɵlistener("blur", function TransferCodeSearchComponent_Template_input_blur_4_listener() { return ctx.emitValue(); })("keyup.enter", function TransferCodeSearchComponent_Template_input_keyup_enter_4_listener() { return ctx.emitValue(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.transferCodeSearchForm);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", ctx.labelResourceName);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.seperatorText, " ");
    } }, dependencies: [i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, LiveEditPropDirective], styles: [".hr-text[_ngcontent-%COMP%]{overflow:hidden;text-align:center}.hr-text[_ngcontent-%COMP%]:before, .hr-text[_ngcontent-%COMP%]:after{background-color:var(--static-Spa_Style_Gray4);content:\"\";display:inline-block;height:1px;position:relative;vertical-align:middle;width:50%}.hr-text[_ngcontent-%COMP%]:before{right:.5em;margin-left:-50%}.hr-text[_ngcontent-%COMP%]:after{left:.5em;margin-right:-50%}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TransferCodeSearchComponent, [{
        type: Component,
        args: [{ selector: 'vnext-transfer-code-search', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"transfer-code-search\">\r\n  <form [formGroup]=\"transferCodeSearchForm\">\r\n    <label for=\"transferCodeSearchField\" class=\"Spa_Style_Small_Font Spa_Style_Bold_Weight Spa_Style_Primary_Color pt-0 text-nowrap mt-2\"\r\n      ><span *liveEditProp=\"labelResourceName\">{{ labelText }}</span></label\r\n    >\r\n    <input\r\n      #searchInput\r\n      id=\"transferCodeSearchField\"\r\n      type=\"text\"\r\n      tabindex=\"0\"\r\n      formControlName=\"transferCodeSearchField\"\r\n      class=\"form-control mb-2 personal-code-field col-md-3 col-xs-12\"\r\n      (blur)=\"emitValue()\"\r\n      (keyup.enter)=\"emitValue()\"\r\n    />\r\n  </form>\r\n  <div class=\"hr-text mb-3\">\r\n    {{ seperatorText }}\r\n  </div>\r\n</div>\r\n", styles: [".hr-text{overflow:hidden;text-align:center}.hr-text:before,.hr-text:after{background-color:var(--static-Spa_Style_Gray4);content:\"\";display:inline-block;height:1px;position:relative;vertical-align:middle;width:50%}.hr-text:before{right:.5em;margin-left:-50%}.hr-text:after{left:.5em;margin-right:-50%}\n"] }]
    }], null, { labelText: [{
            type: Input
        }], labelResourceName: [{
            type: Input
        }], seperatorText: [{
            type: Input
        }], onTransferCodeFieldBlur: [{
            type: Output
        }] }); })();

function UniqueCodeSearchComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.descriptionText, " ");
} }
function UniqueCodeSearchComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.labelText);
} }
class UniqueCodeSearchComponent {
    constructor() {
        this.labelText = 'Spa_Agent_Search_UniqueCodeFieldLabel_Text';
        this.labelResourceName = 'Spa_Agent_Search_UniqueCodeFieldLabel_Text';
        this.descriptionText = 'Spa_Agent_Search_UniqueCodeDescription_Text';
        this.descriptionResourceName = 'Spa_Agent_Search_UniqueCodeDescription_Text';
        this.seperatorText = 'Spa_Agent_Search_UniqueCodeSeperator_Text';
        this.onUniqueCodeFieldBlur = new EventEmitter();
        this.uniqueCodeSearchForm = new UntypedFormGroup({});
        this.uniqueCodeSearchFieldName = 'uniqueCodeSearchField';
    }
    ngOnInit() {
        this.uniqueCodeSearchForm = new UntypedFormGroup({ [this.uniqueCodeSearchFieldName]: new UntypedFormControl('', { updateOn: 'change' }) });
    }
    emitValue() {
        const uniqueCodeField = this.uniqueCodeSearchForm.get(this.uniqueCodeSearchFieldName);
        this.onUniqueCodeFieldBlur.emit(uniqueCodeField.value);
    }
    clearField() {
        const uniqueCodeField = this.uniqueCodeSearchForm.get(this.uniqueCodeSearchFieldName);
        if (uniqueCodeField) {
            uniqueCodeField.setValue('');
        }
    }
}
UniqueCodeSearchComponent.ɵfac = function UniqueCodeSearchComponent_Factory(t) { return new (t || UniqueCodeSearchComponent)(); };
UniqueCodeSearchComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UniqueCodeSearchComponent, selectors: [["vnext-unique-code-search"]], inputs: { labelText: "labelText", labelResourceName: "labelResourceName", descriptionText: "descriptionText", descriptionResourceName: "descriptionResourceName", seperatorText: "seperatorText" }, outputs: { onUniqueCodeFieldBlur: "onUniqueCodeFieldBlur" }, decls: 9, vars: 4, consts: [[1, "unique-code-search"], [1, "hr-text", "mb-3"], ["class", "Spa_Style_Primary_Color", 4, "liveEditProp"], [3, "formGroup"], ["for", "uniqueCodeSearchField", 1, "Spa_Style_Small_Font", "Spa_Style_Bold_Weight", "Spa_Style_Primary_Color", "pt-0", "text-nowrap", "mt-2"], [4, "liveEditProp"], ["id", "uniqueCodeSearchField", "type", "text", "tabindex", "0", "formControlName", "uniqueCodeSearchField", 1, "form-control", "mb-2", "personal-code-field", "col-md-3", "col-xs-12", 3, "blur", "keyup.enter"], ["searchInput", ""], [1, "Spa_Style_Primary_Color"]], template: function UniqueCodeSearchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, UniqueCodeSearchComponent_div_3_Template, 2, 1, "div", 2);
        i0.ɵɵelementStart(4, "form", 3)(5, "label", 4);
        i0.ɵɵtemplate(6, UniqueCodeSearchComponent_span_6_Template, 2, 1, "span", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "input", 6, 7);
        i0.ɵɵlistener("blur", function UniqueCodeSearchComponent_Template_input_blur_7_listener() { return ctx.emitValue(); })("keyup.enter", function UniqueCodeSearchComponent_Template_input_keyup_enter_7_listener() { return ctx.emitValue(); });
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.seperatorText, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", ctx.descriptionResourceName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.uniqueCodeSearchForm);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", ctx.labelResourceName);
    } }, dependencies: [i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, LiveEditPropDirective], styles: [".hr-text[_ngcontent-%COMP%]{overflow:hidden;text-align:center}.hr-text[_ngcontent-%COMP%]:before, .hr-text[_ngcontent-%COMP%]:after{background-color:var(--static-Spa_Style_Gray4);content:\"\";display:inline-block;height:1px;position:relative;vertical-align:middle;width:50%}.hr-text[_ngcontent-%COMP%]:before{right:.5em;margin-left:-50%}.hr-text[_ngcontent-%COMP%]:after{left:.5em;margin-right:-50%}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UniqueCodeSearchComponent, [{
        type: Component,
        args: [{ selector: 'vnext-unique-code-search', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"unique-code-search\">\r\n  <div class=\"hr-text mb-3\">\r\n    {{ seperatorText }}\r\n  </div>\r\n  <div class=\"Spa_Style_Primary_Color\" *liveEditProp=\"descriptionResourceName\">\r\n    {{ descriptionText }}\r\n  </div>\r\n  <form [formGroup]=\"uniqueCodeSearchForm\">\r\n    <label for=\"uniqueCodeSearchField\" class=\"Spa_Style_Small_Font Spa_Style_Bold_Weight Spa_Style_Primary_Color pt-0 text-nowrap mt-2\"\r\n      ><span *liveEditProp=\"labelResourceName\">{{ labelText }}</span></label\r\n    >\r\n    <input\r\n      #searchInput\r\n      id=\"uniqueCodeSearchField\"\r\n      type=\"text\"\r\n      tabindex=\"0\"\r\n      formControlName=\"uniqueCodeSearchField\"\r\n      class=\"form-control mb-2 personal-code-field col-md-3 col-xs-12\"\r\n      (blur)=\"emitValue()\"\r\n      (keyup.enter)=\"emitValue()\"\r\n    />\r\n  </form>\r\n</div>\r\n", styles: [".hr-text{overflow:hidden;text-align:center}.hr-text:before,.hr-text:after{background-color:var(--static-Spa_Style_Gray4);content:\"\";display:inline-block;height:1px;position:relative;vertical-align:middle;width:50%}.hr-text:before{right:.5em;margin-left:-50%}.hr-text:after{left:.5em;margin-right:-50%}\n"] }]
    }], null, { labelText: [{
            type: Input
        }], labelResourceName: [{
            type: Input
        }], descriptionText: [{
            type: Input
        }], descriptionResourceName: [{
            type: Input
        }], seperatorText: [{
            type: Input
        }], onUniqueCodeFieldBlur: [{
            type: Output
        }] }); })();

const _c0$2L = ["topOfPageForHeaderText"];
const _c1$1q = ["topOfPage"];
const _c2$T = ["searchInput"];
function AgentSearchComponent_h1_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 8, 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.Spa_Agent_Search_Header_Text, " ");
} }
function AgentSearchComponent_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", ctx_r7.Spa_Site_PageSubHeader_Text ? i0.ɵɵpipeBind2(1, 1, ctx_r7.Spa_Site_PageSubHeader_Text, "html") : "", i0.ɵɵsanitizeHtml);
} }
function AgentSearchComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, AgentSearchComponent_div_3_div_1_Template, 2, 4, "div", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_PageSubHeader_Text");
} }
function AgentSearchComponent_div_4_ng_container_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r11.Spa_Agent_Search_ResultsHeader_Text, " ");
} }
function AgentSearchComponent_div_4_ng_container_1_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 33)(1, "vnext-link", 34);
    i0.ɵɵlistener("click", function AgentSearchComponent_div_4_ng_container_1_div_5_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r17.downloadResults()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r12.Spa_Site_DownloadLink_Text)("alwaysUnderlined", true)("linkTarget", "_blank")("additionalIcon", ctx_r12.Spa_Site_Download_Icon)("iconColor", ctx_r12.Spa_Style_Primary_Link);
} }
function AgentSearchComponent_div_4_ng_container_1_h4_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h4", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.Spa_Agent_Search_SortHeader_Text, " ");
} }
function AgentSearchComponent_div_4_ng_container_1_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵlistener("click", function AgentSearchComponent_div_4_ng_container_1_div_14_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r21); const sort_r19 = restoredCtx.$implicit; const ctx_r20 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r20.changeSort(sort_r19)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sort_r19 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", sort_r19.label, " ");
} }
function AgentSearchComponent_div_4_ng_container_1_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 37)(2, "vnext-member-result-card", 38);
    i0.ɵɵlistener("linkClick", function AgentSearchComponent_div_4_ng_container_1_ng_container_16_Template_vnext_member_result_card_linkClick_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r24); const member_r22 = restoredCtx.$implicit; const ctx_r23 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r23.viewMember(member_r22)); })("redirectRouteEvent", function AgentSearchComponent_div_4_ng_container_1_ng_container_16_Template_vnext_member_result_card_redirectRouteEvent_2_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r24); const member_r22 = restoredCtx.$implicit; const ctx_r25 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r25.navigateToSelectedRoute($event, member_r22)); });
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const member_r22 = ctx.$implicit;
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("locale", i0.ɵɵpipeBind1(3, 18, ctx_r15.agentSearchFacade.getCurrentLocale$()))("updated", ctx_r15.Spa_Agent_Search_Updated_Text)("member", member_r22)("isAdminUser", ctx_r15.isAdminUser)("agencyHierarchyEnabled", ctx_r15.AgencyHierarchy_Enabled)("showAgentDetails", ctx_r15.showAgentDetails)("isMemberProgressEnabled", ctx_r15.Spa_Profile_Member_Progress_Enabled)("isMemberProgressVisible", ctx_r15.Spa_Profile_Member_Progress_Visible)("memberProgressEvents", ctx_r15.Spa_Profile_Member_Progress_Event_Types)("transferCodeLabelText", ctx_r15.Spa_Site_TransferCode_Label_Text)("isTransferCodeEnabled", ctx_r15.Spa_Site_TransferCode_Enabled)("isSearchByTransferCode", ctx_r15.Spa_Agent_Search_SearchByTransferCode_Enabled && !!ctx_r15.transferCodeValue)("viewProgressLinkText", ctx_r15.Spa_AgentSearch_ViewMemberProgressLink_Text)("searchShowAgentUserName", ctx_r15.Spa_Profile_Search_Show_AgentUserName)("isProfilePage", false)("prescriptionsEnabled", ctx_r15.Spa_Site_Prescriptions_Enabled)("pharmacyEnabled", ctx_r15.Spa_Site_Pharmacy_Enabled)("providersEnabled", ctx_r15.Spa_Site_Providers_Enabled);
} }
function AgentSearchComponent_div_4_ng_container_1_span_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.Spa_Agent_Search_Or_Text, " ");
} }
function AgentSearchComponent_div_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 15);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementStart(3, "div", 16);
    i0.ɵɵtemplate(4, AgentSearchComponent_div_4_ng_container_1_div_4_Template, 2, 1, "div", 17);
    i0.ɵɵtemplate(5, AgentSearchComponent_div_4_ng_container_1_div_5_Template, 2, 5, "div", 18);
    i0.ɵɵelementStart(6, "div", 19);
    i0.ɵɵtemplate(7, AgentSearchComponent_div_4_ng_container_1_h4_7_Template, 2, 1, "h4", 20);
    i0.ɵɵelementStart(8, "div", 21)(9, "input", 22);
    i0.ɵɵlistener("keydown", function AgentSearchComponent_div_4_ng_container_1_Template_input_keydown_9_listener($event) { return $event.preventDefault(); })("ngModelChange", function AgentSearchComponent_div_4_ng_container_1_Template_input_ngModelChange_9_listener() { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r27.sortOption); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "i", 23);
    i0.ɵɵelementStart(11, "span", 24);
    i0.ɵɵtext(12, "Expand menu");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 25);
    i0.ɵɵtemplate(14, AgentSearchComponent_div_4_ng_container_1_div_14_Template, 2, 1, "div", 26);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(15, "div", 27);
    i0.ɵɵlistener("scrolled", function AgentSearchComponent_div_4_ng_container_1_Template_div_scrolled_15_listener() { i0.ɵɵrestoreView(_r28); const ctx_r29 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r29.onScrollDown()); });
    i0.ɵɵtemplate(16, AgentSearchComponent_div_4_ng_container_1_ng_container_16_Template, 4, 20, "ng-container", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 29);
    i0.ɵɵtemplate(18, AgentSearchComponent_div_4_ng_container_1_span_18_Template, 2, 1, "span", 30);
    i0.ɵɵelementStart(19, "vnext-link", 31);
    i0.ɵɵlistener("click", function AgentSearchComponent_div_4_ng_container_1_Template_vnext_link_click_19_listener() { i0.ɵɵrestoreView(_r28); const ctx_r30 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r30.clearSearch()); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", ctx_r8.Spa_Profile_Search_SearchResult_Information_Text ? i0.ɵɵpipeBind2(2, 14, ctx_r8.Spa_Profile_Search_SearchResult_Information_Text, "html") : "", i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_Search_ResultsHeader_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.Spa_Agent_Search_DownloadCsv_Enabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_Search_SortHeader_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r8.sortOption.label);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r8.sortOptions);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("infiniteScrollDistance", 2)("infiniteScrollThrottle", 50);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r8.visibleMembers)("ngForTrackBy", ctx_r8.trackByMemberId);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_Search_Or_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("keyNameForLiveEdit", "Spa_Agent_Search_Search_Again_Text")("title", ctx_r8.Spa_Agent_Search_SearchAgain_Text)("alwaysUnderlined", true);
} }
function AgentSearchComponent_div_4_ng_template_2_ng_container_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r33.Spa_Agent_Search_NoResults_Text, " ");
} }
function AgentSearchComponent_div_4_ng_template_2_ng_container_0_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 45);
    i0.ɵɵlistener("click", function AgentSearchComponent_div_4_ng_template_2_ng_container_0_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r36.createMember()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r34.Spa_Agent_Search_CreateProfileButton_Text, " ");
} }
function AgentSearchComponent_div_4_ng_template_2_ng_container_0_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r35.Spa_Agent_Search_Or_Text, " ");
} }
function AgentSearchComponent_div_4_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 39)(2, "div", 40);
    i0.ɵɵtemplate(3, AgentSearchComponent_div_4_ng_template_2_ng_container_0_div_3_Template, 2, 1, "div", 41);
    i0.ɵɵelementStart(4, "div", 42);
    i0.ɵɵtemplate(5, AgentSearchComponent_div_4_ng_template_2_ng_container_0_button_5_Template, 2, 1, "button", 43);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 29);
    i0.ɵɵtemplate(7, AgentSearchComponent_div_4_ng_template_2_ng_container_0_span_7_Template, 2, 1, "span", 30);
    i0.ɵɵelementStart(8, "vnext-link", 31);
    i0.ɵɵlistener("click", function AgentSearchComponent_div_4_ng_template_2_ng_container_0_Template_vnext_link_click_8_listener() { i0.ɵɵrestoreView(_r39); const ctx_r38 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r38.clearSearch()); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_Search_NoResults_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_Search_CreateProfileButton_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_Search_Or_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("keyNameForLiveEdit", "Spa_Agent_Search_SearchAgain_Text")("title", ctx_r31.Spa_Agent_Search_SearchAgain_Text)("alwaysUnderlined", true);
} }
function AgentSearchComponent_div_4_ng_template_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-warning-message-many-results-agent-search", 46);
    i0.ɵɵlistener("clearSearch", function AgentSearchComponent_div_4_ng_template_2_ng_container_1_Template_vnext_warning_message_many_results_agent_search_clearSearch_1_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r40.clearSearch()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("timeoutMessageText", ctx_r32.Spa_Site_Search_Timeout_Message_Text)("searchAgainButtonText", ctx_r32.Spa_Site_Search_SearchAgain_Button_Text);
} }
function AgentSearchComponent_div_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, AgentSearchComponent_div_4_ng_template_2_ng_container_0_Template, 9, 6, "ng-container", 4);
    i0.ɵɵtemplate(1, AgentSearchComponent_div_4_ng_template_2_ng_container_1_Template, 2, 2, "ng-container", 4);
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", !ctx_r10.searchResults || ctx_r10.searchResults === ctx_r10.memberSearchResultModel.NO_RESULTS);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.Spa_Site_Search_Timeout_Message_Enabled && ctx_r10.searchResults === ctx_r10.memberSearchResultModel.NO_RESULTS_TIMEOUT);
} }
function AgentSearchComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AgentSearchComponent_div_4_ng_container_1_Template, 20, 17, "ng-container", 13);
    i0.ɵɵtemplate(2, AgentSearchComponent_div_4_ng_template_2_Template, 2, 2, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r9 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.members.length)("ngIfElse", _r9);
} }
function AgentSearchComponent_div_7_vnext_notice_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice", 49);
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r42.Spa_Member_Profile_ErrorMessages_TitleText)("messages", ctx_r42.errorMessages)("type", "error");
} }
function AgentSearchComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵtemplate(1, AgentSearchComponent_div_7_vnext_notice_1_Template, 1, 3, "vnext-notice", 48);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.errorMessages.length);
} }
function AgentSearchComponent_ng_container_8_form_1_vnext_transfer_code_search_2_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-transfer-code-search", 59);
    i0.ɵɵlistener("onTransferCodeFieldBlur", function AgentSearchComponent_ng_container_8_form_1_vnext_transfer_code_search_2_Template_vnext_transfer_code_search_onTransferCodeFieldBlur_0_listener($event) { i0.ɵɵrestoreView(_r49); const ctx_r48 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r48.updateTransferCode($event)); })("keyup.enter", function AgentSearchComponent_ng_container_8_form_1_vnext_transfer_code_search_2_Template_vnext_transfer_code_search_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r49); const ctx_r50 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r50.search()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("labelText", ctx_r44.Spa_Agent_Search_TransferCodeFieldLabel_Text)("labelResourceName", "Spa_Agent_Search_TransferCodeFieldLabel_Text")("seperatorText", ctx_r44.Spa_Agent_Search_UniqueCodeSeperator_Text);
} }
function AgentSearchComponent_ng_container_8_form_1_ng_container_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 69);
} }
const _c3$C = function (a0) { return { "text-nowrap pt-3": a0 }; };
function AgentSearchComponent_ng_container_8_form_1_ng_container_3_ng_container_5_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 71);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵelement(2, "i", 72);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const control_r51 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r61 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c3$C, control_r51.keyName !== ctx_r61.beneficiaryInput.DOB && control_r51.keyName !== ctx_r61.beneficiaryInput.PHONE && (control_r51.keyName !== ctx_r61.beneficiaryInput.APPLICATION_START_DATE && control_r51.keyName !== ctx_r61.beneficiaryInput.APPLICATION_END_DATE || i0.ɵɵpipeBind1(1, 2, ctx_r61.isDesktop$))));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", control_r51.error, "");
} }
function AgentSearchComponent_ng_container_8_form_1_ng_container_3_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AgentSearchComponent_ng_container_8_form_1_ng_container_3_ng_container_5_span_1_Template, 4, 6, "span", 70);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r51 = i0.ɵɵnextContext().$implicit;
    const ctx_r54 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r54.getSearchControl(control_r51.keyName).errors);
} }
function AgentSearchComponent_ng_container_8_form_1_ng_container_3_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function AgentSearchComponent_ng_container_8_form_1_ng_container_3_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const control_r51 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(control_r51.labelText);
} }
function AgentSearchComponent_ng_container_8_form_1_ng_container_3_ng_template_10_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const control_r51 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(control_r51.labelText);
} }
function AgentSearchComponent_ng_container_8_form_1_ng_container_3_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, AgentSearchComponent_ng_container_8_form_1_ng_container_3_ng_template_10_span_0_Template, 2, 1, "span", 30);
} if (rf & 2) {
    const control_r51 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("liveEditProp", control_r51.labelKey);
} }
const _c4$m = function (a0) { return { "error-container-first-row": a0 }; };
const _c5$d = function (a0) { return { error: a0 }; };
const _c6$c = function (a0) { return { "has-error": a0 }; };
function AgentSearchComponent_ng_container_8_form_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r69 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 60);
    i0.ɵɵtemplate(2, AgentSearchComponent_ng_container_8_form_1_ng_container_3_div_2_Template, 1, 0, "div", 61);
    i0.ɵɵelementStart(3, "div")(4, "div", 62);
    i0.ɵɵtemplate(5, AgentSearchComponent_ng_container_8_form_1_ng_container_3_ng_container_5_Template, 2, 1, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "label", 63);
    i0.ɵɵtemplate(7, AgentSearchComponent_ng_container_8_form_1_ng_container_3_ng_container_7_Template, 1, 0, "ng-container", 64);
    i0.ɵɵtemplate(8, AgentSearchComponent_ng_container_8_form_1_ng_container_3_ng_template_8_Template, 2, 1, "ng-template", null, 65, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(10, AgentSearchComponent_ng_container_8_form_1_ng_container_3_ng_template_10_Template, 1, 1, "ng-template", null, 66, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "input", 67, 68);
    i0.ɵɵlistener("blur", function AgentSearchComponent_ng_container_8_form_1_ng_container_3_Template_input_blur_12_listener() { i0.ɵɵrestoreView(_r69); const ctx_r68 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r68.validateForm()); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r51 = ctx.$implicit;
    const _r56 = i0.ɵɵreference(9);
    const _r58 = i0.ɵɵreference(11);
    const ctx_r45 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(control_r51.class);
    i0.ɵɵproperty("formGroup", ctx_r45.searchFG);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", control_r51.keyName === ctx_r45.beneficiaryInput.APPLICATION_START_DATE);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c4$m, control_r51.keyName === ctx_r45.beneficiaryInput.DOB || control_r51.keyName === ctx_r45.beneficiaryInput.PHONE));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r45.formState === ctx_r45.formMembersAgentStateModel.SUBMITTED);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", control_r51.keyName)("ngClass", i0.ɵɵpureFunction1(20, _c5$d, ctx_r45.formState === ctx_r45.formMembersAgentStateModel.SUBMITTED && ctx_r45.getSearchControl(control_r51.keyName).errors));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", control_r51.keyName === ctx_r45.beneficiaryInput.APPLICATION_START_DATE || control_r51.keyName === ctx_r45.beneficiaryInput.APPLICATION_END_DATE || control_r51.keyName === ctx_r45.beneficiaryInput.MBI || control_r51.keyName === ctx_r45.beneficiaryInput.AGENT_USER_NAME)("ngIfThen", _r58)("ngIfElse", _r56);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("id", control_r51.keyName)("ngClass", i0.ɵɵpureFunction1(22, _c6$c, ctx_r45.formState === ctx_r45.formMembersAgentStateModel.SUBMITTED && ctx_r45.getSearchControl(control_r51.keyName).errors))("dropSpecialCharacters", control_r51.keyName === ctx_r45.beneficiaryInput.PHONE)("formControlName", control_r51.keyName)("mask", control_r51.mask);
    i0.ɵɵattribute("aria-labelledby", control_r51.keyName);
} }
function AgentSearchComponent_ng_container_8_form_1_vnext_unique_code_search_5_Template(rf, ctx) { if (rf & 1) {
    const _r71 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-unique-code-search", 73);
    i0.ɵɵlistener("onUniqueCodeFieldBlur", function AgentSearchComponent_ng_container_8_form_1_vnext_unique_code_search_5_Template_vnext_unique_code_search_onUniqueCodeFieldBlur_0_listener($event) { i0.ɵɵrestoreView(_r71); const ctx_r70 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r70.updateUniqueCode($event)); })("keyup.enter", function AgentSearchComponent_ng_container_8_form_1_vnext_unique_code_search_5_Template_vnext_unique_code_search_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r71); const ctx_r72 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r72.search()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("labelText", ctx_r46.Spa_Agent_Search_UniqueCodeFieldLabel_Text)("labelResourceName", "Spa_Agent_Search_UniqueCodeFieldLabel_Text")("descriptionText", ctx_r46.Spa_Agent_Search_UniqueCodeDescription_Text)("descriptionResourceName", "Spa_Agent_Search_UniqueCodeDescription_Text")("seperatorText", ctx_r46.Spa_Agent_Search_UniqueCodeSeperator_Text);
} }
function AgentSearchComponent_ng_container_8_form_1_vnext_status_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r74 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-status-button", 74);
    i0.ɵɵlistener("click", function AgentSearchComponent_ng_container_8_form_1_vnext_status_button_9_Template_vnext_status_button_click_0_listener() { i0.ɵɵrestoreView(_r74); const ctx_r73 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r73.search()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("buttonClass", "Spa_Style_PrimaryButton")("buttonText", ctx_r47.Spa_Agent_Search_Button_Text);
} }
function AgentSearchComponent_ng_container_8_form_1_Template(rf, ctx) { if (rf & 1) {
    const _r76 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 51);
    i0.ɵɵlistener("ngSubmit", function AgentSearchComponent_ng_container_8_form_1_Template_form_ngSubmit_0_listener() { i0.ɵɵrestoreView(_r76); const ctx_r75 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r75.search()); });
    i0.ɵɵelementStart(1, "div", 52);
    i0.ɵɵtemplate(2, AgentSearchComponent_ng_container_8_form_1_vnext_transfer_code_search_2_Template, 1, 3, "vnext-transfer-code-search", 53);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, AgentSearchComponent_ng_container_8_form_1_ng_container_3_Template, 14, 24, "ng-container", 28);
    i0.ɵɵelementStart(4, "div", 52);
    i0.ɵɵtemplate(5, AgentSearchComponent_ng_container_8_form_1_vnext_unique_code_search_5_Template, 1, 5, "vnext-unique-code-search", 54);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "vnext-navigation-banner", 55)(7, "div", 56)(8, "div", 57);
    i0.ɵɵtemplate(9, AgentSearchComponent_ng_container_8_form_1_vnext_status_button_9_Template, 1, 2, "vnext-status-button", 58);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r43.searchFG);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r43.Spa_Agent_Search_SearchByTransferCode_Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r43.agentSearchFacade.getProfileSearchForm(ctx_r43.widgetId))("ngForTrackBy", ctx_r43.trackIndex);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r43.Spa_Agent_Search_SearchByUniqueCode_Enabled);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_Search_Button_Text");
} }
function AgentSearchComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AgentSearchComponent_ng_container_8_form_1_Template, 10, 6, "form", 50);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.searchFG);
} }
const AGENT_SEARCH_RESULTS_FILENAME = 'Search-Results.csv';
const AGENT_SEARCH_RESULTS_FILE_EXTENSION = 'text/csv';
// JSON Fields For CSV
const AGENT_SEARCH_RESULTS_FILE_COLUMN_FIELDS = [
    'firstName',
    'lastName',
    'address1',
    'address2',
    'city',
    'state',
    'zip',
    'homePhone',
    'primaryEmailAddress',
    'carrierStatus',
    'profileDate',
    'agentUserName',
    'agentFirstName',
    'agentLastName'
];
// CSV File Header
const AGENT_SEARCH_RESULTS_FILE_COLUMN_HEADINGS = [
    'First Name',
    'Last Name',
    'Address1',
    'Address2',
    'City',
    'State',
    'Zip',
    'Home Phone',
    'Primary Email Address',
    'Carrier Status',
    'Last Updated Date',
    'Agent Username',
    'Agent First Name',
    'Agent Last Name'
];
var FormMembersAgentState;
(function (FormMembersAgentState) {
    FormMembersAgentState["SUBMITTED"] = "submitted";
    FormMembersAgentState["COMPLETE"] = "complete";
    FormMembersAgentState["UNTOUCHED"] = "untouched";
})(FormMembersAgentState || (FormMembersAgentState = {}));
let AgentSearchComponent = class AgentSearchComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, widgetService, zoneService, agentSearchFacade, orderPipe, profileFacade, agentPermissionsService, analyticsService, profileService, liveEditStateContext, fileUtilityService, agentCallRecordingFacade, shoppingRecordingContextService, twilioService, deactivationGuardService, memberSessionService, soaFacade) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.agentSearchFacade = agentSearchFacade;
        this.orderPipe = orderPipe;
        this.profileFacade = profileFacade;
        this.agentPermissionsService = agentPermissionsService;
        this.analyticsService = analyticsService;
        this.profileService = profileService;
        this.liveEditStateContext = liveEditStateContext;
        this.fileUtilityService = fileUtilityService;
        this.agentCallRecordingFacade = agentCallRecordingFacade;
        this.shoppingRecordingContextService = shoppingRecordingContextService;
        this.twilioService = twilioService;
        this.deactivationGuardService = deactivationGuardService;
        this.memberSessionService = memberSessionService;
        this.soaFacade = soaFacade;
        this.Spa_Agent_Search_Header_Text = 'Search beneficiaries';
        this.Spa_Agent_Search_Button_Text = 'Search profiles';
        this.Spa_Agent_Search_StartDate_Text = 'Application start date';
        this.Spa_Agent_Search_EndDate_Text = 'Application end date';
        this.Spa_Agent_Search_MBI_Text = 'MBI';
        this.Spa_Agent_Search_AgentUserName_Text = 'Agent Username';
        this.Spa_Agent_Search_Updated_Text = 'updated';
        this.Spa_Agent_Search_NoResults_Text = 'There are no results for the profile you searched, but you may create a new profile with that information';
        this.Spa_Agent_Search_CreateProfileButton_Text = 'Create a new profile';
        this.Spa_Agent_Search_ResultsHeader_Text = 'Search results';
        this.Spa_Agent_Search_SearchAgain_Text = 'search again';
        this.Spa_Agent_Search_Or_Text = 'or';
        this.Spa_Agent_Search_SortHeader_Text = 'Sort';
        this.Spa_Member_Profile_ErrorMessages_TitleText = 'Correct the following error(s) on the form, then submit again';
        this.Spa_Site_PageSubHeader_Text = '';
        this.Spa_Profile_Search_SearchResult_Information_Text = 'An applicant has completed the SOA and/or enrollment. A registrant has not completed the SOA or enrollment.';
        this.Spa_Agent_Search_SearchByUniqueCode_Enabled = false;
        this.Spa_Agent_Search_UniqueCodeSeperator_Text = 'OR';
        this.Spa_Agent_Search_UniqueCodeDescription_Text = 'Enter a beneficiaries personal code they mentioned when they contacted you so you can pick up where they left off. We will take you to view plans with their information they already entered.';
        this.Spa_Agent_Search_UniqueCodeFieldLabel_Text = 'Personal Code';
        this.Spa_ProfileSearch_ErrorMessages_Text = 'Please provide at least one search criteria.';
        this.Spa_Site_Download_Icon = 'fas fa-download';
        this.Spa_Style_Primary_Link = '#016C86';
        this.Spa_Site_DownloadLink_Text = ' Download results';
        this.Spa_Agent_Search_DownloadCsv_Enabled = true;
        // Format for this key is different than normal due to being created and used by the API team
        this.AgencyHierarchy_Enabled = false;
        this.Spa_Profile_Search_Show_AgentUserName = true;
        this.Spa_Site_Search_Timeout_Message_Enabled = false;
        this.Spa_Site_Search_Timeout_Seconds = 30;
        this.Spa_Site_Search_Timeout_Message_Text = `
    <div class="d-flex justify-content-center col-12">
      <div class="Spa_Style_Paragraph Spa_Style_Large_Font font-weight-bold mx-auto no-search-result-text">
        Too many results
      </div>
    </div>

    <div class="d-flex justify-content-center col-12 mt-2">
      <div class="Spa_Style_Paragraph Spa_Style_Regular_Font mx-auto no-search-result-text">
        Please specify additional search criteria to return results
      </div>
    </div>
  `;
        this.Spa_Agent_Search_TransferCodeFieldLabel_Text = 'Transfer code';
        this.Spa_Site_Search_SearchAgain_Button_Text = 'Refine Search';
        this.Spa_Agent_Search_SearchByTransferCode_Enabled = false;
        this.Spa_Profile_Member_Progress_Enabled = false;
        this.Spa_Profile_Member_Progress_Visible = false;
        this.Spa_Site_TransferCode_Label_Text = 'Transfer code';
        this.Spa_AgentSearch_ViewMemberProgressLink_Text = 'View progress';
        this.Spa_Site_TransferCode_Enabled = false;
        this.Spa_Site_Prescriptions_Enabled = true;
        this.Spa_Site_Pharmacy_Enabled = true;
        this.Spa_Site_Providers_Enabled = true;
        this.Spa_Profile_Member_Progress_Event_Types = [
            {
                name: 'Profile Created',
                value: 1,
                enabled: true
            },
            {
                name: 'Providers Updated',
                value: 2,
                enabled: true
            },
            {
                name: 'Prescriptions Updated',
                value: 3,
                enabled: true
            },
            {
                name: 'Pharmacies Updated',
                value: 4,
                enabled: true
            },
            {
                name: 'Quote Sent',
                value: 5,
                enabled: true
            },
            {
                name: 'Plan in Cart',
                value: 6,
                enabled: true
            },
            {
                name: 'Send to Beneficiary',
                value: 7,
                enabled: true
            },
            {
                name: 'Enrollment Started',
                value: 8,
                enabled: true
            },
            {
                name: 'Enrollment Completed',
                value: 9,
                enabled: true
            }
        ];
        this.searchFG = new UntypedFormGroup({});
        this.members = [];
        this.formState = FormMembersAgentState.UNTOUCHED;
        this.formMembersAgentStateModel = FormMembersAgentState;
        this.PageTags = PageTags;
        this.sortOptions = [];
        this.isAdminUser = false;
        this.showAgentDetails = false;
        this.beneficiaryInput = BeneficiaryInput;
        this.uniqueCodeValue = '';
        this.transferCodeValue = '';
        this.redirectRoute = PageTags.MEMBER_PROFILE_PAGE;
        this.memberSearchResultModel = AgentSearchResult;
        this.skipMembersBy = 20;
        this.sortOption$ = new BehaviorSubject(new SortOption());
        this._visibleMemberIndex$ = new BehaviorSubject(this.skipMembersBy);
        this.visibleMemberIndex$ = this._visibleMemberIndex$.asObservable();
        this.errorMessages$ = new BehaviorSubject([]);
        this.subscriptions = new Subscription();
        this.viewMemberSubject$ = new Subject();
    }
    get searchControlNames() {
        return Object.entries(this.searchFG.getRawValue()).map(control => control[0]);
    }
    get isDesktop$() {
        return this.agentSearchFacade.isDesktop$;
    }
    get formIsChanged() {
        return this.searchFG.dirty && this.searchFG.valid;
    }
    get members$() {
        return combineLatest([this.agentSearchFacade.getMembers$(), this.sortOption$]).pipe(map(([members, sortOption]) => {
            if (!members || members.length === 0) {
                return [];
            }
            this.sortOption = sortOption;
            const sortValue = sortOption.value;
            return this.orderPipe.transform(members, [sortValue, this.sortOptions[0].value], sortValue === 'profileDate' ? true : null, true);
        }));
    }
    getErrorMessages() {
        const errors = this.searchControlNames
            .filter(controlName => this.getSearchControl(controlName).errors)
            .map(controlName => {
            const controlConfig = this.getSearchConfig(controlName);
            return { message: `${controlConfig.labelText}: ${controlConfig.error}` };
        }) || [];
        if (!this.hasEnteredValues()) {
            errors.push({ message: this.Spa_ProfileSearch_ErrorMessages_Text });
        }
        return errors;
    }
    ngOnInit() {
        super.ngOnInit();
        this.errorMessages$.pipe(debounceTime(40), distinctUntilChanged()).subscribe({
            next: errorMessages => {
                this.errorMessages = errorMessages;
                this.cdr.markForCheck();
            }
        });
        if (this.Spa_Site_Search_Timeout_Message_Enabled) {
            this.searchTimeoutSeconds = DateUtilities.secondsToMilliseconds(this.Spa_Site_Search_Timeout_Seconds);
        }
        this.sortOptions = this.agentSearchFacade.getSortOptions(this.widgetId);
        // will always default to be last name so grabbing the first option is fine
        this.sortOption$.next(this.sortOptions[0]);
        const agentRole = this.agentPermissionsService.getAgentRole();
        this.isAdminUser = this.agentPermissionsService.isAdmin(agentRole);
        this.showAgentDetails = this.agentPermissionsService.hasBasicRole(agentRole);
        if (!this.isAdminUser && !this.showAgentDetails) {
            this.sortOptions = this.sortOptions.filter(sortOption => sortOption.value !== 'agentLastName');
        }
        this.searchFG = this.agentSearchFacade.getSearchFG(this.widgetId);
        this.processSSOParams();
        const values = this.searchFG.value;
        const memberData = {
            firstName: values.firstName,
            lastName: values.lastName,
            phoneNumber: values.phoneNumber,
            emailAddress: values.emailAddress,
            dateOfBirth: values.dateOfBirth
        };
        this.profileService.setSearchCriteria(memberData);
        this.subscriptions.add(this.profileFacade.isBeneficiarySearch$.subscribe({
            next: isBeneficiarySearchNavigationClicked => {
                if (!isBeneficiarySearchNavigationClicked) {
                    this.clearSearch();
                }
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.liveEditStateContext.currentLiveEditState$.subscribe({
            next: liveEditState => {
                if (liveEditState) {
                    this.formState = liveEditState.name === 'No profile found' ? FormMembersAgentState.COMPLETE : FormMembersAgentState.UNTOUCHED;
                    this.cdr.markForCheck();
                }
            }
        }));
        this.subscriptions.add(this.onViewMember$().subscribe({
            next: () => {
                this.setInitialMemberDemographics();
                this.handleOnViewMember();
            }
        }));
        this.subscriptions.add(combineLatest([this.members$, this.visibleMemberIndex$]).subscribe({
            next: ([members, visibleMemberIndex]) => {
                this.visibleMembers = members.slice(0, visibleMemberIndex);
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.members$.subscribe({
            next: members => {
                this.members = members;
                if (this.topOfPageForHeaderText) {
                    this.topOfPageForHeaderText.nativeElement.scrollIntoView(true);
                }
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.agentSearchFacade.memberSearchResult$().subscribe({
            next: searchResults => {
                this.searchResults = searchResults;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.currentLocale$.subscribe({
            next: () => {
                this.sortOptions = this.agentSearchFacade.getSortOptions(this.widgetId);
                if (this.sortOptions?.length) {
                    const activeSortOption = this.sortOptions.findIndex((newSortOption) => newSortOption.value === this.sortOption?.value);
                    if (activeSortOption > 0) {
                        this.sortOption$.next(this.sortOptions[activeSortOption]);
                    }
                    else {
                        this.sortOption$.next(this.sortOptions[0]);
                    }
                }
                this.cdr.markForCheck();
            }
        }));
    }
    tagsToUpdate() {
        return {
            [DataLayerGlobalVariable.PROFILE_PROGRESS_TRACKER_ISPRESENT]: this.Spa_Profile_Member_Progress_Enabled
                ? GOOGLE_ANALYTICS_YES
                : GOOGLE_ANALYTICS_NO,
            [DataLayerGlobalVariable.PROFILE_SEARCH_TRANSFER_CODE_ISPRESENT]: this.Spa_Agent_Search_SearchByTransferCode_Enabled
                ? GOOGLE_ANALYTICS_YES
                : GOOGLE_ANALYTICS_NO
        };
    }
    changeSort(newValue) {
        this.sortOption$.next(newValue);
    }
    onScrollDown() {
        this.visibleMemberIndex$.pipe(take(1)).subscribe({
            next: visibleMemberIndex => {
                if (this.members?.length > visibleMemberIndex) {
                    this._visibleMemberIndex$.next(visibleMemberIndex + this.skipMembersBy);
                }
            }
        });
    }
    downloadResults() {
        if (this.members.length) {
            // Reorder Json response for specific fields
            const formatData = JSON.parse(JSON.stringify(this.members, AGENT_SEARCH_RESULTS_FILE_COLUMN_FIELDS));
            const contentType = AGENT_SEARCH_RESULTS_FILE_EXTENSION;
            // download file data and header names
            const dataURI = `${this.fileUtilityService.convertToCsv(formatData, AGENT_SEARCH_RESULTS_FILE_COLUMN_HEADINGS)}`;
            const fileName = AGENT_SEARCH_RESULTS_FILENAME;
            this.fileUtilityService.downloadFile(dataURI, fileName, contentType);
            this.updateGoogleDataLayerTags();
        }
    }
    updateGoogleDataLayerTags() {
        const googleDataLayerTags = this.analyticsService.googleDataLayerTags;
        const previousDownloadCount = googleDataLayerTags[DataLayerGlobalVariable.REPORT_DOWNLOAD_COUNT];
        let downloadCount = 1;
        if (previousDownloadCount) {
            downloadCount = downloadCount + parseInt(previousDownloadCount, 10);
        }
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_REPORT_DOWNLOAD,
            [DataLayerGlobalVariable.REPORT_DOWNLOAD_COUNT]: `${downloadCount}`
        };
    }
    getSearchControl(controlName) {
        return this.searchFG.get(controlName);
    }
    getSearchConfig(controlName) {
        return this.agentSearchFacade.getSearchFormConfig(this.widgetId).find(config => config.keyName === controlName);
    }
    clearSearch() {
        this.formState = FormMembersAgentState.UNTOUCHED;
        this.searchFG = this.agentSearchFacade.getSearchFG(this.widgetId);
        this.agentSearchFacade.clearSearch();
        this.clearUniqueCode();
        this.clearTransferCode();
    }
    trackIndex(index) {
        return index;
    }
    validateForm() {
        if (this.formState === FormMembersAgentState.SUBMITTED) {
            this.errorMessages$.next(this.getErrorMessages());
        }
    }
    async search() {
        this.formState = FormMembersAgentState.SUBMITTED;
        if (this.transferCodeValue) {
            this.searchByTransferCode(this.transferCodeValue);
        }
        else if (this.uniqueCodeValue) {
            this.searchByUniqueCode(this.uniqueCodeValue);
        }
        else {
            this.searchByMemberParameters();
        }
    }
    navigateByPageTag(pageTag) {
        this.agentSearchFacade.navigateByPageTag(pageTag);
    }
    viewMember(member) {
        const callRecordingInProgress = this.twilioService.isShoppingCallRecordingInProgress();
        if (callRecordingInProgress) {
            this.shoppingRecordingContextService.displayEndCallConfirmationModal();
        }
        // We check the Deactivation guards manually to run additional operations before starting the navigation
        // This could help in cases where we have to clear the member's session only after checking all Deactivation guards
        this.deactivationGuardService.canDeactivate().then(canDeactivate => {
            if (canDeactivate) {
                this.viewMemberSubject$.next(member);
            }
        });
    }
    navigateToSelectedRoute(route, member) {
        this.redirectRoute = route;
        this.viewMember(member);
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.agentSearchFacade.clearSearch();
        this.subscriptions.unsubscribe();
    }
    createMember() {
        this.clearUniqueCode();
        this.clearTransferCode();
        this.agentSearchFacade.navigateByPageTag(PageTags.ADD_NEW_PROFILE);
    }
    updateUniqueCode(uniqueCode) {
        this.uniqueCodeValue = uniqueCode;
    }
    updateTransferCode(transferCode) {
        this.transferCodeValue = transferCode;
    }
    trackByMemberId(index, memberSearchEntry) {
        return memberSearchEntry.memberID;
    }
    displayNoSearchResults(error) {
        this.formState = FormMembersAgentState.COMPLETE;
        if (error?.name === TIMEOUT_ERROR) {
            this.agentSearchFacade.setMemberSearchResult(AgentSearchResult.NO_RESULTS_TIMEOUT);
        }
        else {
            this.agentSearchFacade.setMemberSearchResult(AgentSearchResult.NO_RESULTS);
        }
        this.cdr.markForCheck();
    }
    completeAgentSearch() {
        this.formState = FormMembersAgentState.COMPLETE;
        if (this.saveButton) {
            this.saveButton.toggleSpinner();
        }
    }
    updateUniqueCodeTag(uniqueCode) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.MEMBER_ASSIST_CODE]: uniqueCode
        };
    }
    updateTransferCodeTag(transferCode) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.PROFILE_SEARCHBY_TRANSFER_CODE]: transferCode
        };
    }
    searchByTransferCode(transferCode) {
        const transferCodeSearchField = this.transferCodeSearchForm.transferCodeSearchFieldName;
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PROFILE_SEARCH,
            [DataLayerGlobalVariable.PROFILE_SEARCH_FIELDS]: transferCodeSearchField
        };
        if (this.saveButton) {
            this.saveButton.toggleSpinner();
        }
        this.updateTransferCodeTag(transferCode);
        const prepValuesForApi = {};
        prepValuesForApi.transferCode = transferCode;
        prepValuesForApi.viewAll = true;
        this.agentSearchFacade
            .searchMembers$(prepValuesForApi, this.searchTimeoutSeconds)
            .pipe(take(1))
            .subscribe({
            next: memberSearch => {
                if (!!memberSearch?.length) {
                    this.agentSearchFacade.setMemberSearchResult(AgentSearchResult.RESULTS);
                }
                else {
                    this.displayNoSearchResults();
                }
                this.agentSearchFacade.setMemberSearchOnStore(memberSearch);
                this.formState = FormMembersAgentState.COMPLETE;
                this.cdr.markForCheck();
            },
            error: error => {
                this.displayNoSearchResults(error);
            },
            complete: () => {
                this.completeAgentSearch();
            }
        });
    }
    searchByUniqueCode(uniqueCode) {
        if (this.saveButton) {
            this.saveButton.toggleSpinner();
        }
        this.agentSearchFacade
            .getSessionByUniqueCode$(uniqueCode)
            .pipe(map(newSessionData => newSessionData?.sessionId), switchMap(fullSessionId => (fullSessionId ? this.agentSearchFacade.loadSessionFromUniqueCode$(fullSessionId) : of(null))), take(1))
            .subscribe({
            next: () => {
                const sessionHasValues = this.agentSearchFacade.hasSessionValues();
                if (sessionHasValues) {
                    this.updateUniqueCodeTag(uniqueCode);
                    this.navigateByPageTag(PageTags.PLAN_LIST);
                }
                else {
                    this.displayNoSearchResults();
                }
                this.formState = FormMembersAgentState.COMPLETE;
            },
            error: error => {
                this.displayNoSearchResults(error);
            },
            complete: () => {
                this.completeAgentSearch();
            }
        });
    }
    async searchByMemberParameters() {
        let profileSearchFields = this.profileFacade.getSearchFields(this.searchFG.value);
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PROFILE_SEARCH,
            [DataLayerGlobalVariable.PROFILE_SEARCH_FIELDS]: profileSearchFields
        };
        // This is weird. But there is a situation in IE11 where the click event is being cancelled when
        // we have an error in the error notice and then we are blurring by directly clicking the search
        // button. In order to combat this quirk so the user experience is better in IE11 we are creating
        // a subject to manage the error messages with a debounceTime so the click event has enough time to
        // fire its logic and check for errors even when the blur event would force a page render. I don't
        // necessarily like this but you can blame IE11.
        this.errorMessages$.next(this.getErrorMessages());
        const errorMessages = await this.errorMessages$.pipe(take(1)).toPromise();
        if (errorMessages.length) {
            // don't let them search if there are errors
            if (this.searchInputs) {
            }
            this.scrollToErrors();
            return;
        }
        if (this.saveButton) {
            this.saveButton.toggleSpinner();
        }
        const values = this.searchFG.value;
        const prepValuesForApi = {};
        Object.entries(values).forEach(([key, value]) => {
            if (value) {
                profileSearchFields = `${key}|${profileSearchFields}`;
            }
            if (key === this.beneficiaryInput.DOB ||
                key === this.beneficiaryInput.APPLICATION_START_DATE ||
                key === this.beneficiaryInput.APPLICATION_END_DATE) {
                if (value) {
                    prepValuesForApi[key] = DateUtilities.convertToDateString(value);
                }
            }
            else if (value) {
                prepValuesForApi[key] = value.toString().trim();
            }
        });
        this.agentSearchFacade
            .searchMembers$(prepValuesForApi, this.searchTimeoutSeconds)
            .pipe(take(1))
            .subscribe({
            next: memberSearch => {
                if (!!memberSearch?.length) {
                    this.agentSearchFacade.setMemberSearchResult(AgentSearchResult.RESULTS);
                }
                else {
                    this.displayNoSearchResults();
                }
                this.agentSearchFacade.setMemberSearchOnStore(memberSearch);
                this.formState = FormMembersAgentState.COMPLETE;
                this.cdr.markForCheck();
            },
            error: error => {
                this.displayNoSearchResults(error);
            },
            complete: () => {
                this.completeAgentSearch();
            }
        });
        this.searchFG.updateValueAndValidity();
        const metaData = {
            firstName: values.firstName,
            lastName: values.lastName,
            phoneNumber: values.phoneNumber,
            emailAddress: values.emailAddress,
            dateOfBirth: values.dateOfBirth
        };
        this.profileService.setSearchCriteria(metaData);
    }
    clearUniqueCode() {
        if (this.uniqueSearchForm) {
            this.uniqueSearchForm.clearField();
        }
        this.uniqueCodeValue = '';
    }
    clearTransferCode() {
        if (this.transferCodeSearchForm) {
            this.transferCodeSearchForm.clearField();
        }
        this.transferCodeValue = '';
    }
    hasEnteredValues() {
        return Object.entries(this.searchFG.value).some(([key, value]) => value !== null && value !== '');
    }
    scrollToErrors() {
        this.topOfPage.first.nativeElement.scrollIntoView({ block: 'end', inline: 'nearest', behavior: 'smooth' });
    }
    processSSOParams() {
        const { ssoParams } = window.history.state;
        if (ssoParams) {
            this.searchFG.patchValue({
                lastName: ssoParams.BeneLastName,
                firstName: ssoParams.BeneFirstName,
                emailAddress: ssoParams.BeneEmail,
                phoneNumber: ssoParams.BenePhone,
                dateOfBirth: PassParameterUtilities.resolveDate(ssoParams.BeneBirthDate, false, undefined, 'MM/DD/YYYY')
            });
            this.searchFG.markAsTouched();
            if (ssoParams.ReqType === 'S') {
                this.search();
            }
        }
    }
    onViewMember$() {
        const options = {
            includeEnrollmentHistory: true,
            includeSOA: true,
            includeAgentCallHistory: this.agentPermissionsService.isAdmin() && this.agentCallRecordingFacade.isDisplayRecordingLinkEnabled()
        };
        return this.viewMemberSubject$.pipe(exhaustMap((member) => this.agentSearchFacade.selectMember$(member.memberID, options)), switchMap(() => {
            return this.soaFacade.fetchSOATransactions$();
        }));
    }
    setInitialMemberDemographics() {
        const sessionId = this.memberSessionService.getMemberSessionId();
        this.memberSessionService.setInitialMemberDemographics(sessionId);
    }
    handleOnViewMember() {
        // We skip the next canDeactivate() check triggered automatically by the navigation because we already checked it manually
        this.deactivationGuardService.setDeactivationGuardStatus(DeactivationGuardStatus.SKIP_NEXT_CAN_DEACTIVATE_CHECK);
        if (this.redirectRoute == PageTags.MEMBER_PROFILE_PAGE) {
            this.agentSearchFacade.navigateByPageTag(PageTags.MEMBER_PROFILE_PAGE);
            this.agentSearchFacade.setCurrentMemberProfilePageTag(PageTags.MEMBER_PROFILE_PAGE);
            this.profileFacade.beneficiarySearchNavigationClicked(true);
        }
        else {
            this.updateMemberDetailsAndNavigate(this.redirectRoute);
        }
    }
    updateMemberDetailsAndNavigate(redirectRoute) {
        this.memberSessionService.updateSelectedMemberDetails();
        this.agentSearchFacade.navigateByPageTag(redirectRoute);
        this.profileFacade.beneficiarySearchNavigationClicked(true);
    }
};
AgentSearchComponent.ɵfac = function AgentSearchComponent_Factory(t) { return new (t || AgentSearchComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(AgentSearchFacade), i0.ɵɵdirectiveInject(OrderPipe), i0.ɵɵdirectiveInject(ProfileFacade), i0.ɵɵdirectiveInject(i1.AgentPermissionsService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.ProfileService), i0.ɵɵdirectiveInject(i1.LiveEditStateContext), i0.ɵɵdirectiveInject(i1.FileDownloadUtilityService), i0.ɵɵdirectiveInject(AgentCallRecordingFacade), i0.ɵɵdirectiveInject(i1.ShoppingRecordingContextService), i0.ɵɵdirectiveInject(i1.TwilioDeviceService), i0.ɵɵdirectiveInject(i1.DeactivationGuardService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(SOAFacade)); };
AgentSearchComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentSearchComponent, selectors: [["vnext-agent-search"]], viewQuery: function AgentSearchComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(StatusButtonComponent, 5);
        i0.ɵɵviewQuery(_c0$2L, 5);
        i0.ɵɵviewQuery(UniqueCodeSearchComponent, 5);
        i0.ɵɵviewQuery(TransferCodeSearchComponent, 5);
        i0.ɵɵviewQuery(_c1$1q, 5);
        i0.ɵɵviewQuery(_c2$T, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.saveButton = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.topOfPageForHeaderText = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.uniqueSearchForm = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.transferCodeSearchForm = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.topOfPage = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchInputs = _t);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService, OrderPipe]), i0.ɵɵInheritDefinitionFeature], decls: 9, vars: 7, consts: [["vnextGoogleTagManager", "", 1, "mx-auto", "px-0", "container", 3, "tagsToUpdate", "saveDefaultValues"], [1, "px-3"], ["class", "col-12 text-center Spa_Style_H1 mt-4 mb-0 search-beneficiary-text", 4, "liveEditProp"], ["class", "col-12 mt-4", 4, "ngIf"], [4, "ngIf"], [1, "pt-3", "mt-5"], ["topOfPage", ""], ["class", "error-banner-container", 4, "ngIf"], [1, "col-12", "text-center", "Spa_Style_H1", "mt-4", "mb-0", "search-beneficiary-text"], ["topOfPageForHeaderText", ""], [1, "col-12", "mt-4"], ["navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["navigationAdapter", "", 3, "innerHtml"], [4, "ngIf", "ngIfElse"], ["showNoSearchResult", ""], ["navigationAdapter", "", 1, "mt-4", "col-12", 3, "innerHtml"], [1, "mt-5", "py-3"], ["class", "Spa_Style_Paragraph Spa_Style_Larger_Font", 4, "liveEditProp"], ["class", "col-6 col-sm-6 col-md-4 px-0 float-left download-text", 4, "ngIf"], [1, "col-6", "col-sm-6", "col-md-4", "ml-md-auto", "ml-sm-auto", "px-0"], ["id", "sortHeaderId", "class", "Spa_Style_H4", 4, "liveEditProp"], ["ngbDropdown", "", 1, "position-relative"], ["ngbDropdownToggle", "", "tabindex", "0", "type", "text", "autocomplete", "new-text", "placeholder", "", "aria-labelledby", "sortHeaderId", 1, "form-control", "can-click", "dropdown", 3, "ngModel", "keydown", "ngModelChange"], ["ngbDropdownToggle", "", 1, "fas", "fa-angle-down", "icon-in-input", "can-click", "float-right"], [1, "sr-only"], ["ngbDropdownMenu", ""], ["ngbDropdownItem", "", "class", "can-click", 3, "click", 4, "ngFor", "ngForOf"], ["infiniteScroll", "", "aria-live", "polite", "aria-atomic", "true", 3, "infiniteScrollDistance", "infiniteScrollThrottle", "scrolled"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "Spa_Style_Paragraph", "mx-auto", "mt-3", "d-flex", "justify-content-center"], [4, "liveEditProp"], [1, "pl-2", 3, "keyNameForLiveEdit", "title", "alwaysUnderlined", "click"], [1, "Spa_Style_Paragraph", "Spa_Style_Larger_Font"], [1, "col-6", "col-sm-6", "col-md-4", "px-0", "float-left", "download-text"], [1, "pl-2", "link", 3, "title", "alwaysUnderlined", "linkTarget", "additionalIcon", "iconColor", "click"], ["id", "sortHeaderId", 1, "Spa_Style_H4"], ["ngbDropdownItem", "", 1, "can-click", 3, "click"], [1, "my-3"], [3, "locale", "updated", "member", "isAdminUser", "agencyHierarchyEnabled", "showAgentDetails", "isMemberProgressEnabled", "isMemberProgressVisible", "memberProgressEvents", "transferCodeLabelText", "isTransferCodeEnabled", "isSearchByTransferCode", "viewProgressLinkText", "searchShowAgentUserName", "isProfilePage", "prescriptionsEnabled", "pharmacyEnabled", "providersEnabled", "linkClick", "redirectRouteEvent"], [1, "row", "flex-column", "pt-3", "mt-5"], [1, "mx-auto", "justify-content-center"], ["class", "Spa_Style_Paragraph Spa_Style_Regular_Font mx-auto no-search-result-text", 4, "liveEditProp"], [1, "mx-auto", "text-center"], ["class", "btn Spa_Style_PrimaryButton mt-2 mx-auto", 3, "click", 4, "liveEditProp"], [1, "Spa_Style_Paragraph", "Spa_Style_Regular_Font", "mx-auto", "no-search-result-text"], [1, "btn", "Spa_Style_PrimaryButton", "mt-2", "mx-auto", 3, "click"], [3, "timeoutMessageText", "searchAgainButtonText", "clearSearch"], [1, "error-banner-container"], [3, "title", "messages", "type", 4, "ngIf"], [3, "title", "messages", "type"], ["disableKeyDownSubmit", "", "class", "row px-0 pb-4", 3, "formGroup", "ngSubmit", 4, "ngIf"], ["disableKeyDownSubmit", "", 1, "row", "px-0", "pb-4", 3, "formGroup", "ngSubmit"], [1, "col-12"], ["class", "pt-5", 3, "labelText", "labelResourceName", "seperatorText", "onTransferCodeFieldBlur", "keyup.enter", 4, "ngIf"], ["class", "pt-5", 3, "labelText", "labelResourceName", "descriptionText", "descriptionResourceName", "seperatorText", "onUniqueCodeFieldBlur", "keyup.enter", 4, "ngIf"], [2, "width", "100%"], ["continue-button", "", 1, "d-flex", "justify-content-end"], [1, "button-container"], [3, "buttonClass", "buttonText", "click", 4, "liveEditProp"], [1, "pt-5", 3, "labelText", "labelResourceName", "seperatorText", "onTransferCodeFieldBlur", "keyup.enter"], [3, "formGroup"], ["class", "w-100", 4, "ngIf"], [1, "error-container", "d-flex", "align-self-end", 3, "ngClass"], [1, "Spa_Style_Small_Font", "Spa_Style_Bold_Weight", "Spa_Style_Primary_Color", "pt-0", "text-nowrap", "mt-2", 3, "for", "ngClass"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["defaultLabel", ""], ["liveEditLabel", ""], ["type", "text", "tabindex", "0", 1, "form-control", "mb-2", 3, "id", "ngClass", "dropSpecialCharacters", "formControlName", "mask", "blur"], ["searchInput", ""], [1, "w-100"], ["class", "error Spa_Style_Small_Font", 3, "ngClass", 4, "ngIf"], [1, "error", "Spa_Style_Small_Font", 3, "ngClass"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], [1, "pt-5", 3, "labelText", "labelResourceName", "descriptionText", "descriptionResourceName", "seperatorText", "onUniqueCodeFieldBlur", "keyup.enter"], [3, "buttonClass", "buttonText", "click"]], template: function AgentSearchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, AgentSearchComponent_h1_2_Template, 3, 1, "h1", 2);
        i0.ɵɵtemplate(3, AgentSearchComponent_div_3_Template, 2, 1, "div", 3);
        i0.ɵɵtemplate(4, AgentSearchComponent_div_4_Template, 4, 2, "div", 4);
        i0.ɵɵelementStart(5, "div", 5, 6);
        i0.ɵɵtemplate(7, AgentSearchComponent_div_7_Template, 2, 1, "div", 7);
        i0.ɵɵtemplate(8, AgentSearchComponent_ng_container_8_Template, 2, 1, "ng-container", 4);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵproperty("tagsToUpdate", ctx.tagsToUpdate())("saveDefaultValues", true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_Agent_Search_Header_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.formState !== ctx.formMembersAgentStateModel.COMPLETE);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.formState === ctx.formMembersAgentStateModel.COMPLETE);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.formState === ctx.formMembersAgentStateModel.SUBMITTED);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.formState !== ctx.formMembersAgentStateModel.COMPLETE);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.NgModel, i4.FormGroupDirective, i4.FormControlName, NavigationBannerComponent, LinkComponent, StatusButtonComponent, WarningMessageManyResultsAgentSearchComponent, NoticeComponent, NavigationAdapterDirective, LiveEditPropDirective, FormInputSubmitDirective, GoogleTagManagerDirective, IconAriaAttributesDirective, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem, i8.MaskDirective, i2$2.InfiniteScrollDirective, MemberResultCardComponent, UniqueCodeSearchComponent, TransferCodeSearchComponent, i1$2.AsyncPipe, SafePipe], styles: [".error[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent2);vertical-align:bottom}.error-container-first-row[_ngcontent-%COMP%]{min-height:35px;max-height:35px;line-height:15px}.error-container[_ngcontent-%COMP%]{min-height:35px;max-height:35px}.button-container[_ngcontent-%COMP%]{min-width:150px}.icon-in-input[_ngcontent-%COMP%]{position:absolute;top:8px;left:calc(100% - 15px)}input.dropdown[_ngcontent-%COMP%]{height:30px}.dropdown[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{width:100%;padding:0;margin-top:0}.dropdown-menu[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]{padding:6px 10px;white-space:normal}.download-text[_ngcontent-%COMP%]{margin-top:8px}@media (min-width: 768px){.offset-lg-right-2[_ngcontent-%COMP%]{margin-right:16.66666667%}}@media (max-width: 768px){.search-beneficiary-text[_ngcontent-%COMP%]{font-size:35px!important}.download-text[_ngcontent-%COMP%]{padding-bottom:24px;margin-top:auto}}"], changeDetection: 0 });
__decorate([
    PlatformProp('live-edit')
], AgentSearchComponent.prototype, "Spa_Agent_Search_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentSearchComponent.prototype, "Spa_Agent_Search_Button_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentSearchComponent.prototype, "Spa_Agent_Search_StartDate_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentSearchComponent.prototype, "Spa_Agent_Search_EndDate_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentSearchComponent.prototype, "Spa_Agent_Search_MBI_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentSearchComponent.prototype, "Spa_Agent_Search_AgentUserName_Text", void 0);
__decorate([
    PlatformProp()
], AgentSearchComponent.prototype, "Spa_Agent_Search_Updated_Text", void 0);
__decorate([
    PlatformProp()
], AgentSearchComponent.prototype, "Spa_Agent_Search_NoResults_Text", void 0);
__decorate([
    PlatformProp()
], AgentSearchComponent.prototype, "Spa_Agent_Search_CreateProfileButton_Text", void 0);
__decorate([
    PlatformProp()
], AgentSearchComponent.prototype, "Spa_Agent_Search_ResultsHeader_Text", void 0);
__decorate([
    PlatformProp()
], AgentSearchComponent.prototype, "Spa_Agent_Search_SearchAgain_Text", void 0);
__decorate([
    PlatformProp()
], AgentSearchComponent.prototype, "Spa_Agent_Search_Or_Text", void 0);
__decorate([
    PlatformProp()
], AgentSearchComponent.prototype, "Spa_Agent_Search_SortHeader_Text", void 0);
__decorate([
    PlatformProp()
], AgentSearchComponent.prototype, "Spa_Member_Profile_ErrorMessages_TitleText", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentSearchComponent.prototype, "Spa_Site_PageSubHeader_Text", void 0);
__decorate([
    GlobalResource()
], AgentSearchComponent.prototype, "Spa_Profile_Search_SearchResult_Information_Text", void 0);
__decorate([
    PlatformProp()
], AgentSearchComponent.prototype, "Spa_Agent_Search_SearchByUniqueCode_Enabled", void 0);
__decorate([
    PlatformProp()
], AgentSearchComponent.prototype, "Spa_Agent_Search_UniqueCodeSeperator_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentSearchComponent.prototype, "Spa_Agent_Search_UniqueCodeDescription_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentSearchComponent.prototype, "Spa_Agent_Search_UniqueCodeFieldLabel_Text", void 0);
__decorate([
    GlobalResource()
], AgentSearchComponent.prototype, "Spa_ProfileSearch_ErrorMessages_Text", void 0);
__decorate([
    GlobalResource()
], AgentSearchComponent.prototype, "Spa_Site_Download_Icon", void 0);
__decorate([
    GlobalResource()
], AgentSearchComponent.prototype, "Spa_Style_Primary_Link", void 0);
__decorate([
    PlatformProp()
], AgentSearchComponent.prototype, "Spa_Site_DownloadLink_Text", void 0);
__decorate([
    PlatformProp()
], AgentSearchComponent.prototype, "Spa_Agent_Search_DownloadCsv_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentSearchComponent.prototype, "AgencyHierarchy_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentSearchComponent.prototype, "Spa_Profile_Search_Show_AgentUserName", void 0);
__decorate([
    GlobalResource()
], AgentSearchComponent.prototype, "Spa_Site_Search_Timeout_Message_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentSearchComponent.prototype, "Spa_Site_Search_Timeout_Seconds", void 0);
__decorate([
    PlatformProp()
], AgentSearchComponent.prototype, "Spa_Site_Search_Timeout_Message_Text", void 0);
__decorate([
    GlobalResource()
], AgentSearchComponent.prototype, "Spa_Agent_Search_TransferCodeFieldLabel_Text", void 0);
__decorate([
    GlobalResource()
], AgentSearchComponent.prototype, "Spa_Site_Search_SearchAgain_Button_Text", void 0);
__decorate([
    GlobalResource()
], AgentSearchComponent.prototype, "Spa_Agent_Search_SearchByTransferCode_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentSearchComponent.prototype, "Spa_Profile_Member_Progress_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentSearchComponent.prototype, "Spa_Profile_Member_Progress_Visible", void 0);
__decorate([
    GlobalResource()
], AgentSearchComponent.prototype, "Spa_Site_TransferCode_Label_Text", void 0);
__decorate([
    GlobalResource()
], AgentSearchComponent.prototype, "Spa_AgentSearch_ViewMemberProgressLink_Text", void 0);
__decorate([
    GlobalResource()
], AgentSearchComponent.prototype, "Spa_Site_TransferCode_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentSearchComponent.prototype, "Spa_Site_Prescriptions_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentSearchComponent.prototype, "Spa_Site_Pharmacy_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentSearchComponent.prototype, "Spa_Site_Providers_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentSearchComponent.prototype, "Spa_Profile_Member_Progress_Event_Types", void 0);
__decorate([
    LiveEditInactive()
], AgentSearchComponent.prototype, "clearSearch", null);
__decorate([
    LiveEditInactive()
], AgentSearchComponent.prototype, "search", null);
__decorate([
    LiveEditInactive()
], AgentSearchComponent.prototype, "navigateByPageTag", null);
__decorate([
    LiveEditInactive()
], AgentSearchComponent.prototype, "viewMember", null);
AgentSearchComponent = __decorate([
    PlatformWidget
], AgentSearchComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentSearchComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-search', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService, OrderPipe], template: "<div class=\"mx-auto px-0 container\" vnextGoogleTagManager [tagsToUpdate]=\"tagsToUpdate()\" [saveDefaultValues]=\"true\">\r\n  <div class=\"px-3\">\r\n    <h1\r\n      #topOfPageForHeaderText\r\n      class=\"col-12 text-center Spa_Style_H1 mt-4 mb-0 search-beneficiary-text\"\r\n      *liveEditProp=\"'Spa_Agent_Search_Header_Text'\"\r\n    >\r\n      {{ Spa_Agent_Search_Header_Text }}\r\n    </h1>\r\n    <div *ngIf=\"formState !== formMembersAgentStateModel.COMPLETE\" class=\"col-12 mt-4\">\r\n      <div\r\n        *liveEditProp=\"'Spa_Site_PageSubHeader_Text'\"\r\n        [innerHtml]=\"Spa_Site_PageSubHeader_Text ? (Spa_Site_PageSubHeader_Text | safe : 'html') : ''\"\r\n        navigationAdapter\r\n      ></div>\r\n    </div>\r\n\r\n    <div *ngIf=\"formState === formMembersAgentStateModel.COMPLETE\">\r\n      <ng-container *ngIf=\"members.length; else showNoSearchResult\">\r\n        <div\r\n          class=\"mt-4 col-12\"\r\n          [innerHtml]=\"\r\n            Spa_Profile_Search_SearchResult_Information_Text ? (Spa_Profile_Search_SearchResult_Information_Text | safe : 'html') : ''\r\n          \"\r\n          navigationAdapter\r\n        ></div>\r\n\r\n        <div class=\"mt-5 py-3\">\r\n          <div class=\"Spa_Style_Paragraph Spa_Style_Larger_Font\" *liveEditProp=\"'Spa_Agent_Search_ResultsHeader_Text'\">\r\n            {{ Spa_Agent_Search_ResultsHeader_Text }}\r\n          </div>\r\n          <div class=\"col-6 col-sm-6 col-md-4 px-0 float-left download-text\" *ngIf=\"Spa_Agent_Search_DownloadCsv_Enabled\">\r\n            <vnext-link\r\n              class=\"pl-2 link\"\r\n              (click)=\"downloadResults()\"\r\n              [title]=\"Spa_Site_DownloadLink_Text\"\r\n              [alwaysUnderlined]=\"true\"\r\n              [linkTarget]=\"'_blank'\"\r\n              [additionalIcon]=\"Spa_Site_Download_Icon\"\r\n              [iconColor]=\"Spa_Style_Primary_Link\"\r\n            ></vnext-link>\r\n          </div>\r\n          <div class=\"col-6 col-sm-6 col-md-4 ml-md-auto ml-sm-auto px-0\">\r\n            <h4 id=\"sortHeaderId\" class=\"Spa_Style_H4\" *liveEditProp=\"'Spa_Agent_Search_SortHeader_Text'\">\r\n              {{ Spa_Agent_Search_SortHeader_Text }}\r\n            </h4>\r\n            <div class=\"position-relative\" ngbDropdown>\r\n              <input\r\n                ngbDropdownToggle\r\n                tabindex=\"0\"\r\n                type=\"text\"\r\n                autocomplete=\"new-text\"\r\n                placeholder=\"\"\r\n                class=\"form-control can-click dropdown\"\r\n                aria-labelledby=\"sortHeaderId\"\r\n                [ngModel]=\"sortOption.label\"\r\n                (keydown)=\"$event.preventDefault()\"\r\n                (ngModelChange)=\"(sortOption)\"\r\n              />\r\n              <i class=\"fas fa-angle-down icon-in-input can-click float-right\" ngbDropdownToggle></i>\r\n              <span class=\"sr-only\">Expand menu</span>\r\n              <div ngbDropdownMenu>\r\n                <div *ngFor=\"let sort of sortOptions\" (click)=\"changeSort(sort)\" ngbDropdownItem class=\"can-click\">\r\n                  {{ sort.label }}\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <div\r\n            infiniteScroll\r\n            [infiniteScrollDistance]=\"2\"\r\n            [infiniteScrollThrottle]=\"50\"\r\n            (scrolled)=\"onScrollDown()\"\r\n            aria-live=\"polite\"\r\n            aria-atomic=\"true\"\r\n          >\r\n            <ng-container *ngFor=\"let member of visibleMembers; trackBy: trackByMemberId\">\r\n              <div class=\"my-3\">\r\n                <vnext-member-result-card\r\n                  [locale]=\"agentSearchFacade.getCurrentLocale$() | async\"\r\n                  [updated]=\"Spa_Agent_Search_Updated_Text\"\r\n                  [member]=\"member\"\r\n                  [isAdminUser]=\"isAdminUser\"\r\n                  [agencyHierarchyEnabled]=\"AgencyHierarchy_Enabled\"\r\n                  [showAgentDetails]=\"showAgentDetails\"\r\n                  [isMemberProgressEnabled]=\"Spa_Profile_Member_Progress_Enabled\"\r\n                  [isMemberProgressVisible]=\"Spa_Profile_Member_Progress_Visible\"\r\n                  [memberProgressEvents]=\"Spa_Profile_Member_Progress_Event_Types\"\r\n                  [transferCodeLabelText]=\"Spa_Site_TransferCode_Label_Text\"\r\n                  [isTransferCodeEnabled]=\"Spa_Site_TransferCode_Enabled\"\r\n                  [isSearchByTransferCode]=\"Spa_Agent_Search_SearchByTransferCode_Enabled && !!transferCodeValue\"\r\n                  [viewProgressLinkText]=\"Spa_AgentSearch_ViewMemberProgressLink_Text\"\r\n                  [searchShowAgentUserName]=\"Spa_Profile_Search_Show_AgentUserName\"\r\n                  [isProfilePage]=\"false\"\r\n                  [prescriptionsEnabled]=\"Spa_Site_Prescriptions_Enabled\"\r\n                  [pharmacyEnabled]=\"Spa_Site_Pharmacy_Enabled\"\r\n                  [providersEnabled]=\"Spa_Site_Providers_Enabled\"\r\n                  (linkClick)=\"viewMember(member)\"\r\n                  (redirectRouteEvent)=\"navigateToSelectedRoute($event, member)\"\r\n                ></vnext-member-result-card>\r\n              </div>\r\n            </ng-container>\r\n          </div>\r\n          <div class=\"Spa_Style_Paragraph mx-auto mt-3 d-flex justify-content-center\">\r\n            <span *liveEditProp=\"'Spa_Agent_Search_Or_Text'\">\r\n              {{ Spa_Agent_Search_Or_Text }}\r\n            </span>\r\n            <vnext-link\r\n              class=\"pl-2\"\r\n              (click)=\"clearSearch()\"\r\n              [keyNameForLiveEdit]=\"'Spa_Agent_Search_Search_Again_Text'\"\r\n              [title]=\"Spa_Agent_Search_SearchAgain_Text\"\r\n              [alwaysUnderlined]=\"true\"\r\n            ></vnext-link>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n\r\n      <ng-template #showNoSearchResult>\r\n        <ng-container *ngIf=\"!searchResults || searchResults === memberSearchResultModel.NO_RESULTS\">\r\n          <div class=\"row flex-column pt-3 mt-5\">\r\n            <div class=\"mx-auto justify-content-center\">\r\n              <div\r\n                class=\"Spa_Style_Paragraph Spa_Style_Regular_Font mx-auto no-search-result-text\"\r\n                *liveEditProp=\"'Spa_Agent_Search_NoResults_Text'\"\r\n              >\r\n                {{ Spa_Agent_Search_NoResults_Text }}\r\n              </div>\r\n              <div class=\"mx-auto text-center\">\r\n                <button\r\n                  class=\"btn Spa_Style_PrimaryButton mt-2 mx-auto\"\r\n                  (click)=\"createMember()\"\r\n                  *liveEditProp=\"'Spa_Agent_Search_CreateProfileButton_Text'\"\r\n                >\r\n                  {{ Spa_Agent_Search_CreateProfileButton_Text }}\r\n                </button>\r\n              </div>\r\n            </div>\r\n            <div class=\"Spa_Style_Paragraph mx-auto mt-3 d-flex justify-content-center\">\r\n              <span *liveEditProp=\"'Spa_Agent_Search_Or_Text'\">\r\n                {{ Spa_Agent_Search_Or_Text }}\r\n              </span>\r\n              <vnext-link\r\n                class=\"pl-2\"\r\n                (click)=\"clearSearch()\"\r\n                [keyNameForLiveEdit]=\"'Spa_Agent_Search_SearchAgain_Text'\"\r\n                [title]=\"Spa_Agent_Search_SearchAgain_Text\"\r\n                [alwaysUnderlined]=\"true\"\r\n              ></vnext-link>\r\n            </div>\r\n          </div>\r\n        </ng-container>\r\n\r\n        <ng-container *ngIf=\"Spa_Site_Search_Timeout_Message_Enabled && searchResults === memberSearchResultModel.NO_RESULTS_TIMEOUT\">\r\n          <vnext-warning-message-many-results-agent-search\r\n            [timeoutMessageText]=\"Spa_Site_Search_Timeout_Message_Text\"\r\n            [searchAgainButtonText]=\"Spa_Site_Search_SearchAgain_Button_Text\"\r\n            (clearSearch)=\"clearSearch()\"\r\n          >\r\n          </vnext-warning-message-many-results-agent-search>\r\n        </ng-container>\r\n      </ng-template>\r\n    </div>\r\n    <div class=\"pt-3 mt-5\" #topOfPage>\r\n      <div class=\"error-banner-container\" *ngIf=\"formState === formMembersAgentStateModel.SUBMITTED\">\r\n        <vnext-notice\r\n          [title]=\"Spa_Member_Profile_ErrorMessages_TitleText\"\r\n          [messages]=\"errorMessages\"\r\n          [type]=\"'error'\"\r\n          *ngIf=\"errorMessages.length\"\r\n        >\r\n        </vnext-notice>\r\n      </div>\r\n      <ng-container *ngIf=\"formState !== formMembersAgentStateModel.COMPLETE\">\r\n        <form *ngIf=\"searchFG\" disableKeyDownSubmit class=\"row px-0 pb-4\" [formGroup]=\"searchFG\" (ngSubmit)=\"search()\">\r\n          <div class=\"col-12\">\r\n            <vnext-transfer-code-search\r\n              *ngIf=\"Spa_Agent_Search_SearchByTransferCode_Enabled\"\r\n              [labelText]=\"Spa_Agent_Search_TransferCodeFieldLabel_Text\"\r\n              [labelResourceName]=\"'Spa_Agent_Search_TransferCodeFieldLabel_Text'\"\r\n              [seperatorText]=\"Spa_Agent_Search_UniqueCodeSeperator_Text\"\r\n              (onTransferCodeFieldBlur)=\"updateTransferCode($event)\"\r\n              (keyup.enter)=\"search()\"\r\n              class=\"pt-5\"\r\n            >\r\n            </vnext-transfer-code-search>\r\n          </div>\r\n          <ng-container *ngFor=\"let control of agentSearchFacade.getProfileSearchForm(widgetId); let i = index; trackBy: trackIndex\">\r\n            <div [formGroup]=\"searchFG\" class=\"{{ control.class }}\">\r\n              <div *ngIf=\"control.keyName === beneficiaryInput.APPLICATION_START_DATE\" class=\"w-100\"></div>\r\n              <div>\r\n                <div\r\n                  class=\"error-container d-flex align-self-end\"\r\n                  [ngClass]=\"{\r\n                    'error-container-first-row': control.keyName === beneficiaryInput.DOB || control.keyName === beneficiaryInput.PHONE\r\n                  }\"\r\n                >\r\n                  <ng-container *ngIf=\"formState === formMembersAgentStateModel.SUBMITTED\">\r\n                    <span\r\n                      class=\"error Spa_Style_Small_Font\"\r\n                      [ngClass]=\"{\r\n                        'text-nowrap pt-3':\r\n                          control.keyName !== beneficiaryInput.DOB &&\r\n                          control.keyName !== beneficiaryInput.PHONE &&\r\n                          ((control.keyName !== beneficiaryInput.APPLICATION_START_DATE &&\r\n                            control.keyName !== beneficiaryInput.APPLICATION_END_DATE) ||\r\n                            (isDesktop$ | async))\r\n                      }\"\r\n                      *ngIf=\"getSearchControl(control.keyName).errors\"\r\n                      ><i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i> {{ control.error }}</span\r\n                    >\r\n                  </ng-container>\r\n                </div>\r\n                <label\r\n                  class=\"Spa_Style_Small_Font Spa_Style_Bold_Weight Spa_Style_Primary_Color pt-0 text-nowrap mt-2\"\r\n                  [for]=\"control.keyName\"\r\n                  [ngClass]=\"{\r\n                    error: formState === formMembersAgentStateModel.SUBMITTED && getSearchControl(control.keyName).errors\r\n                  }\"\r\n                >\r\n                  <ng-container\r\n                    *ngIf=\"\r\n                      control.keyName === beneficiaryInput.APPLICATION_START_DATE ||\r\n                        control.keyName === beneficiaryInput.APPLICATION_END_DATE ||\r\n                        control.keyName === beneficiaryInput.MBI ||\r\n                        control.keyName === beneficiaryInput.AGENT_USER_NAME;\r\n                      then liveEditLabel;\r\n                      else defaultLabel\r\n                    \"\r\n                  >\r\n                  </ng-container>\r\n                  <ng-template #defaultLabel>\r\n                    <span>{{ control.labelText }}</span>\r\n                  </ng-template>\r\n                  <ng-template #liveEditLabel>\r\n                    <span *liveEditProp=\"control.labelKey\">{{ control.labelText }}</span>\r\n                  </ng-template>\r\n                </label>\r\n                <input\r\n                  #searchInput\r\n                  type=\"text\"\r\n                  tabindex=\"0\"\r\n                  class=\"form-control mb-2\"\r\n                  [id]=\"control.keyName\"\r\n                  [attr.aria-labelledby]=\"control.keyName\"\r\n                  [ngClass]=\"{\r\n                    'has-error': formState === formMembersAgentStateModel.SUBMITTED && getSearchControl(control.keyName).errors\r\n                  }\"\r\n                  [dropSpecialCharacters]=\"control.keyName === beneficiaryInput.PHONE\"\r\n                  [formControlName]=\"control.keyName\"\r\n                  [mask]=\"control.mask\"\r\n                  (blur)=\"validateForm()\"\r\n                />\r\n              </div>\r\n            </div>\r\n          </ng-container>\r\n          <div class=\"col-12\">\r\n            <vnext-unique-code-search\r\n              *ngIf=\"Spa_Agent_Search_SearchByUniqueCode_Enabled\"\r\n              [labelText]=\"Spa_Agent_Search_UniqueCodeFieldLabel_Text\"\r\n              [labelResourceName]=\"'Spa_Agent_Search_UniqueCodeFieldLabel_Text'\"\r\n              [descriptionText]=\"Spa_Agent_Search_UniqueCodeDescription_Text\"\r\n              [descriptionResourceName]=\"'Spa_Agent_Search_UniqueCodeDescription_Text'\"\r\n              [seperatorText]=\"Spa_Agent_Search_UniqueCodeSeperator_Text\"\r\n              (onUniqueCodeFieldBlur)=\"updateUniqueCode($event)\"\r\n              (keyup.enter)=\"search()\"\r\n              class=\"pt-5\"\r\n            >\r\n            </vnext-unique-code-search>\r\n          </div>\r\n          <vnext-navigation-banner style=\"width: 100%\">\r\n            <div class=\"d-flex justify-content-end\" continue-button>\r\n              <div class=\"button-container\">\r\n                <vnext-status-button\r\n                  [buttonClass]=\"'Spa_Style_PrimaryButton'\"\r\n                  [buttonText]=\"Spa_Agent_Search_Button_Text\"\r\n                  (click)=\"search()\"\r\n                  *liveEditProp=\"'Spa_Agent_Search_Button_Text'\"\r\n                >\r\n                </vnext-status-button>\r\n              </div>\r\n            </div>\r\n          </vnext-navigation-banner>\r\n        </form>\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".error{color:var(--static-Spa_Style_Accent2);vertical-align:bottom}.error-container-first-row{min-height:35px;max-height:35px;line-height:15px}.error-container{min-height:35px;max-height:35px}.button-container{min-width:150px}.icon-in-input{position:absolute;top:8px;left:calc(100% - 15px)}input.dropdown{height:30px}.dropdown .dropdown-menu{width:100%;padding:0;margin-top:0}.dropdown-menu .dropdown-item{padding:6px 10px;white-space:normal}.download-text{margin-top:8px}@media (min-width: 768px){.offset-lg-right-2{margin-right:16.66666667%}}@media (max-width: 768px){.search-beneficiary-text{font-size:35px!important}.download-text{padding-bottom:24px;margin-top:auto}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: WidgetService }, { type: ZoneService }, { type: AgentSearchFacade }, { type: OrderPipe }, { type: ProfileFacade }, { type: i1.AgentPermissionsService }, { type: AnalyticsService }, { type: i1.ProfileService }, { type: i1.LiveEditStateContext }, { type: i1.FileDownloadUtilityService }, { type: AgentCallRecordingFacade }, { type: i1.ShoppingRecordingContextService }, { type: i1.TwilioDeviceService }, { type: i1.DeactivationGuardService }, { type: i1.MemberSessionService }, { type: SOAFacade }]; }, { Spa_Agent_Search_Header_Text: [], Spa_Agent_Search_Button_Text: [], Spa_Agent_Search_StartDate_Text: [], Spa_Agent_Search_EndDate_Text: [], Spa_Agent_Search_MBI_Text: [], Spa_Agent_Search_AgentUserName_Text: [], Spa_Agent_Search_Updated_Text: [], Spa_Agent_Search_NoResults_Text: [], Spa_Agent_Search_CreateProfileButton_Text: [], Spa_Agent_Search_ResultsHeader_Text: [], Spa_Agent_Search_SearchAgain_Text: [], Spa_Agent_Search_Or_Text: [], Spa_Agent_Search_SortHeader_Text: [], Spa_Member_Profile_ErrorMessages_TitleText: [], Spa_Site_PageSubHeader_Text: [], Spa_Profile_Search_SearchResult_Information_Text: [], Spa_Agent_Search_SearchByUniqueCode_Enabled: [], Spa_Agent_Search_UniqueCodeSeperator_Text: [], Spa_Agent_Search_UniqueCodeDescription_Text: [], Spa_Agent_Search_UniqueCodeFieldLabel_Text: [], Spa_ProfileSearch_ErrorMessages_Text: [], Spa_Site_Download_Icon: [], Spa_Style_Primary_Link: [], Spa_Site_DownloadLink_Text: [], Spa_Agent_Search_DownloadCsv_Enabled: [], AgencyHierarchy_Enabled: [], Spa_Profile_Search_Show_AgentUserName: [], Spa_Site_Search_Timeout_Message_Enabled: [], Spa_Site_Search_Timeout_Seconds: [], Spa_Site_Search_Timeout_Message_Text: [], Spa_Agent_Search_TransferCodeFieldLabel_Text: [], Spa_Site_Search_SearchAgain_Button_Text: [], Spa_Agent_Search_SearchByTransferCode_Enabled: [], Spa_Profile_Member_Progress_Enabled: [], Spa_Profile_Member_Progress_Visible: [], Spa_Site_TransferCode_Label_Text: [], Spa_AgentSearch_ViewMemberProgressLink_Text: [], Spa_Site_TransferCode_Enabled: [], Spa_Site_Prescriptions_Enabled: [], Spa_Site_Pharmacy_Enabled: [], Spa_Site_Providers_Enabled: [], Spa_Profile_Member_Progress_Event_Types: [], saveButton: [{
            type: ViewChild,
            args: [StatusButtonComponent]
        }], topOfPage: [{
            type: ViewChildren,
            args: ['topOfPage']
        }], topOfPageForHeaderText: [{
            type: ViewChild,
            args: ['topOfPageForHeaderText']
        }], searchInputs: [{
            type: ViewChildren,
            args: ['searchInput']
        }], uniqueSearchForm: [{
            type: ViewChild,
            args: [UniqueCodeSearchComponent]
        }], transferCodeSearchForm: [{
            type: ViewChild,
            args: [TransferCodeSearchComponent]
        }], clearSearch: [], search: [], navigateByPageTag: [], viewMember: [] }); })();

let GoogleTagManagerComponent = class GoogleTagManagerComponent extends ConfigurableWidget {
    constructor() {
        super(...arguments);
        this.Spa_GTM_Save_Default_Values_Enabled = false;
    }
};
GoogleTagManagerComponent.ɵfac = /*@__PURE__*/ function () { let ɵGoogleTagManagerComponent_BaseFactory; return function GoogleTagManagerComponent_Factory(t) { return (ɵGoogleTagManagerComponent_BaseFactory || (ɵGoogleTagManagerComponent_BaseFactory = i0.ɵɵgetInheritedFactory(GoogleTagManagerComponent)))(t || GoogleTagManagerComponent); }; }();
GoogleTagManagerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GoogleTagManagerComponent, selectors: [["vnext-google-tag-manager"]], features: [i0.ɵɵProvidersFeature([WidgetService] // provides widget data to components down the tree
        ), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["vnextGoogleTagManager", "", 3, "saveDefaultValues"]], template: function GoogleTagManagerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("saveDefaultValues", ctx.Spa_GTM_Save_Default_Values_Enabled);
    } }, dependencies: [GoogleTagManagerDirective], encapsulation: 2, changeDetection: 0 });
__decorate([
    PlatformProp()
], GoogleTagManagerComponent.prototype, "Spa_GTM_Save_Default_Values_Enabled", void 0);
GoogleTagManagerComponent = __decorate([
    PlatformWidget
], GoogleTagManagerComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GoogleTagManagerComponent, [{
        type: Component,
        args: [{ selector: 'vnext-google-tag-manager', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService] // provides widget data to components down the tree
                , template: "<div vnextGoogleTagManager [saveDefaultValues]=\"Spa_GTM_Save_Default_Values_Enabled\"></div>\r\n" }]
    }], null, { Spa_GTM_Save_Default_Values_Enabled: [] }); })();

function HtmlComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 1);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r0.RawHtml_JavaScript, "html"), i0.ɵɵsanitizeHtml);
} }
let HtmlComponent = class HtmlComponent extends ConfigurableWidget {
    constructor() {
        super(...arguments);
        this.ContainerClass = 'container';
    }
};
HtmlComponent.ɵfac = /*@__PURE__*/ function () { let ɵHtmlComponent_BaseFactory; return function HtmlComponent_Factory(t) { return (ɵHtmlComponent_BaseFactory || (ɵHtmlComponent_BaseFactory = i0.ɵɵgetInheritedFactory(HtmlComponent)))(t || HtmlComponent); }; }();
HtmlComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HtmlComponent, selectors: [["vnext-widget-html"]], features: [i0.ɵɵProvidersFeature([WidgetService] // provides widget data to components down the tree
        ), i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 4, consts: [["navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], ["navigationAdapter", "", 3, "innerHTML"]], template: function HtmlComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, HtmlComponent_span_1_Template, 2, 4, "span", 0);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassMap(ctx.ContainerClass);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "RawHtml_JavaScript");
    } }, dependencies: [NavigationAdapterDirective, LiveEditPropDirective, SafePipe], encapsulation: 2, changeDetection: 0 });
__decorate([
    PlatformProp('live-edit')
], HtmlComponent.prototype, "RawHtml_JavaScript", void 0);
__decorate([
    PlatformProp()
], HtmlComponent.prototype, "ContainerClass", void 0);
HtmlComponent = __decorate([
    PlatformWidget
], HtmlComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HtmlComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-html', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService] // provides widget data to components down the tree
                , template: "<div class=\"{{ ContainerClass }}\">\r\n  <span *liveEditProp=\"'RawHtml_JavaScript'\" [innerHTML]=\"RawHtml_JavaScript | safe: 'html'\" navigationAdapter></span>\r\n</div>\r\n" }]
    }], null, { RawHtml_JavaScript: [], ContainerClass: [] }); })();

let ImageComponent = class ImageComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, imageService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.imageService = imageService;
    }
    preProcessProperties() {
        this.fullSrc = this.imageService.resolveFullImagePath(this.ImageSource);
    }
};
ImageComponent.ɵfac = function ImageComponent_Factory(t) { return new (t || ImageComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.ImageService)); };
ImageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ImageComponent, selectors: [["vnext-widget-image"]], features: [i0.ɵɵProvidersFeature([WidgetService] // provides widget data to components down the tree
        ), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 4, consts: [[3, "src"]], template: function ImageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "img", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("src", ctx.fullSrc, i0.ɵɵsanitizeUrl);
        i0.ɵɵattribute("alt", ctx.alt)("height", ctx.height)("width", ctx.width);
    } }, encapsulation: 2, changeDetection: 0 });
__decorate([
    PlatformProp(null, true)
], ImageComponent.prototype, "ImageSource", void 0);
__decorate([
    PlatformProp()
], ImageComponent.prototype, "alt", void 0);
__decorate([
    PlatformProp()
], ImageComponent.prototype, "height", void 0);
__decorate([
    PlatformProp()
], ImageComponent.prototype, "width", void 0);
ImageComponent = __decorate([
    PlatformWidget
], ImageComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImageComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-image', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService] // provides widget data to components down the tree
                , template: "<img [src]=\"fullSrc\" [attr.alt]=\"alt\" [attr.height]=\"height\" [attr.width]=\"width\">\r\n\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.ImageService }]; }, { ImageSource: [], alt: [], height: [], width: [] }); })();

const _c0$2K = ["scriptContainer"];
let ScriptComponent = class ScriptComponent extends ConfigurableWidget {
    ngOnInit() {
        super.ngOnInit();
        this.processScripts();
    }
    injectScriptBySrc(script) {
        const containerRoot = this.scriptContainer.element.nativeElement;
        const scriptElement = document.createElement('script');
        Array.from(script.attributes).forEach(attr => {
            scriptElement[attr.name] = attr.value;
        });
        scriptElement.type = 'text/javascript';
        containerRoot.parentNode.append(scriptElement, containerRoot);
    }
    injectScriptText(script) {
        const containerRoot = this.scriptContainer.element.nativeElement;
        const scriptElement = document.createElement('script');
        scriptElement.async = false;
        Array.from(script.attributes).forEach(attr => {
            scriptElement[attr.name] = attr.value;
        });
        scriptElement.type = 'text/javascript';
        scriptElement.innerHTML = script.innerText;
        containerRoot.parentNode.append(scriptElement, containerRoot);
    }
    processScripts() {
        this.scriptContainer.element.nativeElement.textContent = '';
        if (this.Spa_Script_Text) {
            const domparser = new DOMParser();
            const document = domparser.parseFromString(this.Spa_Script_Text, 'text/html');
            if (document.scripts && document.scripts.length) {
                Array.from(document.scripts).forEach(script => {
                    const scriptSrc = script.src;
                    if (scriptSrc) {
                        this.injectScriptBySrc(script);
                    }
                    else {
                        const scriptInnerText = script.innerText;
                        if (scriptInnerText) {
                            this.injectScriptText(script);
                        }
                    }
                });
            }
        }
    }
};
ScriptComponent.ɵfac = /*@__PURE__*/ function () { let ɵScriptComponent_BaseFactory; return function ScriptComponent_Factory(t) { return (ɵScriptComponent_BaseFactory || (ɵScriptComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ScriptComponent)))(t || ScriptComponent); }; }();
ScriptComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ScriptComponent, selectors: [["vnext-widget-script"]], viewQuery: function ScriptComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$2K, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scriptContainer = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 0, consts: [["scriptContainer", ""]], template: function ScriptComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementContainer(0, null, 0);
    } }, encapsulation: 2, changeDetection: 0 });
__decorate([
    PlatformProp()
], ScriptComponent.prototype, "Spa_Script_Text", void 0);
ScriptComponent = __decorate([
    PlatformWidget
], ScriptComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ScriptComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-script', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<ng-container #scriptContainer></ng-container>" }]
    }], null, { scriptContainer: [{
            type: ViewChild,
            args: ['scriptContainer', { read: ViewContainerRef, static: true }]
        }], Spa_Script_Text: [] }); })();

function StarRatingComponent_div_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "h4");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.Spa_StarRating_Tooltip_Title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.Spa_StarRating_Tooltip_Text);
} }
const _c0$2J = function (a0) { return { "ml-0": a0 }; };
function StarRatingComponent_div_0_button_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 9, 10)(2, "span", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 12);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(3);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$2J, ctx_r3.newPlanCardDesignEnabled))("ngbTooltip", _r1)("placement", ctx_r3.Spa_Site_DisplayTalkingPoints_Shopping_Enabled ? "left" : "top");
    i0.ɵɵattribute("aria-label", ctx_r3.wcagStarText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.starRatingDefaultText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.Spa_StarRating_Label_Text);
} }
const _c1$1p = function (a0, a1) { return { "Spa_Style_Accent1_Color": a0, "medicare-rating-star": a1 }; };
function StarRatingComponent_div_0_button_5_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c1$1p, ctx_r13.isNotLicensed, !ctx_r13.isNotLicensed));
} }
function StarRatingComponent_div_0_button_5_ng_container_2_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c1$1p, ctx_r16.isNotLicensed, !ctx_r16.isNotLicensed));
} }
function StarRatingComponent_div_0_button_5_ng_container_2_ng_template_2_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 22);
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c1$1p, ctx_r18.isNotLicensed, !ctx_r18.isNotLicensed));
} }
function StarRatingComponent_div_0_button_5_ng_container_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, StarRatingComponent_div_0_button_5_ng_container_2_ng_template_2_ng_container_0_Template, 2, 4, "ng-container", 17);
    i0.ɵɵtemplate(1, StarRatingComponent_div_0_button_5_ng_container_2_ng_template_2_ng_template_1_Template, 1, 4, "ng-template", null, 20, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r17 = i0.ɵɵreference(2);
    const i_r12 = i0.ɵɵnextContext().index;
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", i_r12 === ctx_r15.fullStars && ctx_r15.hasHalfStar)("ngIfElse", _r17);
} }
function StarRatingComponent_div_0_button_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, StarRatingComponent_div_0_button_5_ng_container_2_ng_container_1_Template, 2, 4, "ng-container", 17);
    i0.ɵɵtemplate(2, StarRatingComponent_div_0_button_5_ng_container_2_ng_template_2_Template, 3, 2, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r12 = ctx.index;
    const _r14 = i0.ɵɵreference(3);
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r12 < ctx_r10.fullStars)("ngIfElse", _r14);
} }
const _c2$S = function (a0) { return { "nextgen-rating": a0 }; };
const _c3$B = function (a0) { return { Spa_Style_Accent1_Color: a0 }; };
function StarRatingComponent_div_0_button_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 13, 14);
    i0.ɵɵtemplate(2, StarRatingComponent_div_0_button_5_ng_container_2_Template, 4, 2, "ng-container", 15);
    i0.ɵɵelementStart(3, "span", 16);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(3);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c2$S, ctx_r4.newPlanCardDesignEnabled))("ngbTooltip", _r1)("placement", ctx_r4.Spa_Site_DisplayTalkingPoints_Shopping_Enabled ? "left" : "top");
    i0.ɵɵattribute("aria-label", ctx_r4.wcagStarText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r4.starMaxArray);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c3$B, ctx_r4.isNotLicensed));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r4.Spa_StarRating_Label_Text);
} }
function StarRatingComponent_div_0_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "h4");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r6.Spa_Site_Low_Performance_Plan_Tooltip_Title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r6.Spa_Site_Low_Performance_Plan_Tooltip_Text);
} }
function StarRatingComponent_div_0_button_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 23, 24);
    i0.ɵɵelement(2, "img", 25);
    i0.ɵɵelementStart(3, "span", 26);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(7);
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngbTooltip", _r5)("placement", ctx_r7.Spa_Site_DisplayTalkingPoints_Shopping_Enabled ? "left" : "top");
    i0.ɵɵattribute("aria-label", ctx_r7.lowPerformingWcagStarText);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("alt", ctx_r7.Spa_Site_Low_Performance_Indicator_Text);
    i0.ɵɵproperty("src", ctx_r7.lowPerformanceIndicatorLogo, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r7.Spa_Site_Low_Performance_Indicator_Text);
} }
const _c4$l = function (a0) { return { "ml-n2": a0 }; };
function StarRatingComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtemplate(2, StarRatingComponent_div_0_ng_template_2_Template, 5, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, StarRatingComponent_div_0_button_4_Template, 6, 8, "button", 4);
    i0.ɵɵtemplate(5, StarRatingComponent_div_0_button_5_Template, 5, 11, "button", 5);
    i0.ɵɵtemplate(6, StarRatingComponent_div_0_ng_template_6_Template, 5, 2, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(8, StarRatingComponent_div_0_button_8_Template, 5, 6, "button", 7);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c4$l, ctx_r0.newPlanCardDesignEnabled));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.starRating === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.starRating && ctx_r0.starRating !== 0);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (ctx_r0.starRating || ctx_r0.starRating === 0) && ctx_r0.showLowPerformanceIndicator);
} }
class StarRatingComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, imageService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.imageService = imageService;
        this.isMobile = false;
        this.newPlanCardDesignEnabled = false;
        this.Spa_StarRating_Enabled = true;
        this.Spa_StarRating_Tooltip_Title = 'Medicare Plan Rating';
        this.Spa_StarRating_Tooltip_Text = 'Medicare evaluates plans using up to 53 different criteria, and creates this single summary Star Rating score that makes it easy for you to compare plans based on quality and performance. Ratings are assessed each year, so they may change from one year to the next.';
        this.Spa_StarRating_Default_Text = 'Not available';
        this.Spa_StarRating_Label_Text = 'Star rating';
        this.Spa_StarRating_Alternate_Text = 'Medicare plan rating representing {starRating} out of 5 stars';
        this.Spa_Site_Low_Performance_Indicator_Text = 'Low performing plan';
        this.Spa_Site_Tooltip_Text = 'Tooltip:';
        this.Spa_Site_Low_Performance_Plan_Tooltip_Title = 'Low performing plan';
        this.Spa_Site_Low_Performance_Plan_Tooltip_Text = 'Member satisfaction surveys, plans, and health care providers all affect the performance star rating. This plan got a low star rating from Medicare for at least the past three years.';
        this.Spa_Site_DisplayTalkingPoints_Shopping_Enabled = false;
        this.starMaxArray = Array.from(Array(5));
    }
    ngOnInit() {
        super.ngOnInit();
        this.updateAccessibilityText();
    }
    preProcessProperties() {
        this.updateAccessibilityText();
    }
    get starRating() {
        return this._starRating;
    }
    set starRating(starRating) {
        this._starRating = starRating;
        this.fullStars = Math.trunc(starRating);
        this.hasHalfStar = !!(starRating - Math.floor(starRating));
    }
    get starRatingAlternateText() {
        if (!this.ratingValueDescription || this.starRating === 0) {
            return this.Spa_StarRating_Default_Text;
        }
        return this.Spa_StarRating_Alternate_Text ? this.Spa_StarRating_Alternate_Text.replace('{starRating}', `${this.starRating}`) : '';
    }
    get starRatingDefaultText() {
        return this.ratingValueDescription ? this.ratingValueDescription : this.Spa_StarRating_Default_Text;
    }
    get lowPerformanceIndicatorLogo() {
        const imageSource = 'IPC40_TemplateImages/CommonImages/icons/low_performing_plan.png';
        return this.imageService.resolveFullImagePath(imageSource);
    }
    closeStarRatingTooltip(tooltip) {
        if (tooltip.isOpen()) {
            tooltip.close();
        }
    }
    updateAccessibilityText() {
        this.wcagStarText = `${this.starRatingAlternateText} ${this.Spa_Site_Tooltip_Text} ${this.Spa_StarRating_Tooltip_Title} ${this.Spa_StarRating_Tooltip_Text}`;
        this.lowPerformingWcagStarText = `${this.starRatingAlternateText} ${this.Spa_Site_Tooltip_Text} ${this.Spa_Site_Low_Performance_Plan_Tooltip_Title} ${this.Spa_Site_Low_Performance_Plan_Tooltip_Text}`;
    }
}
StarRatingComponent.ɵfac = function StarRatingComponent_Factory(t) { return new (t || StarRatingComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.ImageService)); };
StarRatingComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StarRatingComponent, selectors: [["vnext-star-rating"]], inputs: { ratingValueDescription: "ratingValueDescription", showLowPerformanceIndicator: "showLowPerformanceIndicator", isMobile: "isMobile", isNotLicensed: "isNotLicensed", newPlanCardDesignEnabled: "newPlanCardDesignEnabled", starRating: "starRating" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "ngClass", 4, "ngIf"], [3, "ngClass"], [1, "d-inline", "w-auto"], ["myTooltip", ""], ["class", "action-button stars d-inline w-auto", "tabindex", "0", "tooltipClass", "star-ratings-tooltip", "role", "tooltip", 3, "ngClass", "ngbTooltip", "placement", 4, "ngIf"], ["class", "action-button plan_rating Spa_Style_Paragraph", "tabindex", "0", "tooltipClass", "star-ratings-tooltip", "role", "tooltip", 3, "ngClass", "ngbTooltip", "placement", 4, "ngIf"], ["lowPerformingPlanTooltip", ""], ["class", "action-button Spa_Style_Note low-performing-plan", "tabindex", "0", "tooltipClass", "star-ratings-tooltip", "role", "tooltip", 3, "ngbTooltip", "placement", 4, "ngIf"], [1, "Spa_Style_ToolTip"], ["tabindex", "0", "tooltipClass", "star-ratings-tooltip", "role", "tooltip", 1, "action-button", "stars", "d-inline", "w-auto", 3, "ngClass", "ngbTooltip", "placement"], ["noRatingTooltip", "ngbTooltip"], [1, "plan_rating", "Spa_Style_Note", "mx-2"], [1, "Spa_Style_Note", "underline", "mx-3", "whitespace-nowrap"], ["tabindex", "0", "tooltipClass", "star-ratings-tooltip", "role", "tooltip", 1, "action-button", "plan_rating", "Spa_Style_Paragraph", 3, "ngClass", "ngbTooltip", "placement"], ["starRatingTooltip", "ngbTooltip"], [4, "ngFor", "ngForOf"], [1, "mx-2", "Spa_Style_Note", "underline", "whitespace-nowrap", 3, "ngClass"], [4, "ngIf", "ngIfElse"], ["elseStars", ""], ["aria-hidden", "true", 1, "fas", "fa-star", 3, "ngClass"], ["emptyStars", ""], ["aria-hidden", "true", 1, "fas", "fa-star-half-alt", 3, "ngClass"], ["aria-hidden", "true", 1, "far", "fa-star", 3, "ngClass"], ["tabindex", "0", "tooltipClass", "star-ratings-tooltip", "role", "tooltip", 1, "action-button", "Spa_Style_Note", "low-performing-plan", 3, "ngbTooltip", "placement"], ["lowPerformingTooltip", "ngbTooltip"], ["aria-hidden", "true", 1, "low-performing-indicator-logo", 3, "src", "alt"], [1, "pl-1", "underline"]], template: function StarRatingComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, StarRatingComponent_div_0_Template, 9, 6, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.Spa_StarRating_Enabled);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, IconAriaAttributesDirective, i1$1.NgbTooltip], styles: [".plan_rating[_ngcontent-%COMP%]:focus, .low-performing-plan[_ngcontent-%COMP%]:focus{box-shadow:0 0 5px #0009;border-radius:5px}.low-performing-plan[_ngcontent-%COMP%]{display:inline-block;margin-top:5px}.low-performing-plan[_ngcontent-%COMP%]:focus{padding:5px;margin:-5px}.medicare-rating-star[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Warn_Darker)}.low-performing-indicator-logo[_ngcontent-%COMP%]{width:20px;height:20px}.plan_rating[_ngcontent-%COMP%]{margin-right:15px;margin-left:15px;display:inline-block}.plan_rating[_ngcontent-%COMP%]:focus{padding:5px;margin:-5px 10px}.plan_rating.nextgen-rating[_ngcontent-%COMP%]{margin-left:7px}.plan_rating.nextgen-rating[_ngcontent-%COMP%]:focus{margin-left:2px}.underline[_ngcontent-%COMP%]{text-decoration:underline}.whitespace-nowrap[_ngcontent-%COMP%]{white-space:nowrap}.rating-tooltip-cancel[_ngcontent-%COMP%]{position:absolute;top:0;right:0;cursor:pointer;color:var(--static-Spa_Style_Primary);height:20px;width:20px;text-align:center;margin-top:10px;margin-right:10px}@media (max-width: 575.98px){.plan_rating[_ngcontent-%COMP%]{max-width:calc(100% - 30px)}.plan_rating[_ngcontent-%COMP%]   .Spa_Style_Note[_ngcontent-%COMP%]{display:block;margin-left:0!important;margin-right:0!important;text-align:center;white-space:normal}}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], StarRatingComponent.prototype, "Spa_StarRating_Enabled", void 0);
__decorate([
    GlobalResource(true)
], StarRatingComponent.prototype, "Spa_StarRating_Tooltip_Title", void 0);
__decorate([
    GlobalResource(true)
], StarRatingComponent.prototype, "Spa_StarRating_Tooltip_Text", void 0);
__decorate([
    GlobalResource(true)
], StarRatingComponent.prototype, "Spa_StarRating_Default_Text", void 0);
__decorate([
    GlobalResource()
], StarRatingComponent.prototype, "Spa_StarRating_Label_Text", void 0);
__decorate([
    GlobalResource(true)
], StarRatingComponent.prototype, "Spa_StarRating_Alternate_Text", void 0);
__decorate([
    GlobalResource()
], StarRatingComponent.prototype, "Spa_Site_Low_Performance_Indicator_Text", void 0);
__decorate([
    GlobalResource(true)
], StarRatingComponent.prototype, "Spa_Site_Tooltip_Text", void 0);
__decorate([
    GlobalResource(true)
], StarRatingComponent.prototype, "Spa_Site_Low_Performance_Plan_Tooltip_Title", void 0);
__decorate([
    GlobalResource(true)
], StarRatingComponent.prototype, "Spa_Site_Low_Performance_Plan_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], StarRatingComponent.prototype, "Spa_Site_DisplayTalkingPoints_Shopping_Enabled", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StarRatingComponent, [{
        type: Component,
        args: [{ selector: 'vnext-star-rating', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"Spa_StarRating_Enabled\" [ngClass]=\"{ 'ml-n2': newPlanCardDesignEnabled }\">\r\n  <div class=\"d-inline w-auto\">\r\n    <ng-template #myTooltip>\r\n      <div class=\"Spa_Style_ToolTip\">\r\n        <h4>{{ Spa_StarRating_Tooltip_Title }}</h4>\r\n        <div>{{ Spa_StarRating_Tooltip_Text }}</div>\r\n      </div>\r\n    </ng-template>\r\n    <button\r\n      *ngIf=\"starRating === 0\"\r\n      class=\"action-button stars d-inline w-auto\"\r\n      [ngClass]=\"{ 'ml-0': newPlanCardDesignEnabled }\"\r\n      tabindex=\"0\"\r\n      [ngbTooltip]=\"myTooltip\"\r\n      #noRatingTooltip=\"ngbTooltip\"\r\n      [placement]=\"Spa_Site_DisplayTalkingPoints_Shopping_Enabled ? 'left' : 'top'\"\r\n      tooltipClass=\"star-ratings-tooltip\"\r\n      [attr.aria-label]=\"wcagStarText\"\r\n      role=\"tooltip\"\r\n    >\r\n      <span class=\"plan_rating Spa_Style_Note mx-2\">{{ starRatingDefaultText }}</span>\r\n      <span class=\"Spa_Style_Note underline mx-3 whitespace-nowrap\">{{ Spa_StarRating_Label_Text }}</span>\r\n    </button>\r\n    <button\r\n      class=\"action-button plan_rating Spa_Style_Paragraph\"\r\n      *ngIf=\"starRating && starRating !== 0\"\r\n      [ngClass]=\"{ 'nextgen-rating': newPlanCardDesignEnabled }\"\r\n      tabindex=\"0\"\r\n      [ngbTooltip]=\"myTooltip\"\r\n      #starRatingTooltip=\"ngbTooltip\"\r\n      [placement]=\"Spa_Site_DisplayTalkingPoints_Shopping_Enabled ? 'left' : 'top'\"\r\n      tooltipClass=\"star-ratings-tooltip\"\r\n      [attr.aria-label]=\"wcagStarText\"\r\n      role=\"tooltip\"\r\n    >\r\n      <ng-container *ngFor=\"let star of starMaxArray; index as i\">\r\n        <ng-container *ngIf=\"i < fullStars; else elseStars\">\r\n          <i\r\n            class=\"fas fa-star\"\r\n            [ngClass]=\"{ 'Spa_Style_Accent1_Color': isNotLicensed, 'medicare-rating-star': !isNotLicensed }\"\r\n            aria-hidden=\"true\"\r\n          ></i>\r\n        </ng-container>\r\n        <ng-template #elseStars>\r\n          <ng-container *ngIf=\"i === fullStars && hasHalfStar; else emptyStars\">\r\n            <i\r\n              class=\"fas fa-star-half-alt\"\r\n              [ngClass]=\"{ 'Spa_Style_Accent1_Color': isNotLicensed, 'medicare-rating-star': !isNotLicensed }\"\r\n              aria-hidden=\"true\"\r\n            ></i>\r\n          </ng-container>\r\n          <ng-template #emptyStars>\r\n            <i\r\n              class=\"far fa-star\"\r\n              [ngClass]=\"{ 'Spa_Style_Accent1_Color': isNotLicensed, 'medicare-rating-star': !isNotLicensed }\"\r\n              aria-hidden=\"true\"\r\n            ></i>\r\n          </ng-template>\r\n        </ng-template>\r\n      </ng-container>\r\n      <span class=\"mx-2 Spa_Style_Note underline whitespace-nowrap\" [ngClass]=\"{ Spa_Style_Accent1_Color: isNotLicensed }\">{{\r\n        Spa_StarRating_Label_Text\r\n      }}</span>\r\n    </button>\r\n    <ng-template #lowPerformingPlanTooltip>\r\n      <div class=\"Spa_Style_ToolTip\">\r\n        <h4>{{ Spa_Site_Low_Performance_Plan_Tooltip_Title }}</h4>\r\n        <div>{{ Spa_Site_Low_Performance_Plan_Tooltip_Text }}</div>\r\n      </div>\r\n    </ng-template>\r\n    <button\r\n      *ngIf=\"(starRating || starRating === 0) && showLowPerformanceIndicator\"\r\n      class=\"action-button Spa_Style_Note low-performing-plan\"\r\n      tabindex=\"0\"\r\n      [ngbTooltip]=\"lowPerformingPlanTooltip\"\r\n      #lowPerformingTooltip=\"ngbTooltip\"\r\n      [placement]=\"Spa_Site_DisplayTalkingPoints_Shopping_Enabled ? 'left' : 'top'\"\r\n      tooltipClass=\"star-ratings-tooltip\"\r\n      [attr.aria-label]=\"lowPerformingWcagStarText\"\r\n      role=\"tooltip\"\r\n    >\r\n      <img\r\n        [src]=\"lowPerformanceIndicatorLogo\"\r\n        alt=\"{{ Spa_Site_Low_Performance_Indicator_Text }}\"\r\n        class=\"low-performing-indicator-logo\"\r\n        aria-hidden=\"true\"\r\n      />\r\n      <span class=\"pl-1 underline\">{{ Spa_Site_Low_Performance_Indicator_Text }}</span>\r\n    </button>\r\n  </div>\r\n</div>\r\n", styles: [".plan_rating:focus,.low-performing-plan:focus{box-shadow:0 0 5px #0009;border-radius:5px}.low-performing-plan{display:inline-block;margin-top:5px}.low-performing-plan:focus{padding:5px;margin:-5px}.medicare-rating-star{color:var(--static-Spa_Style_Warn_Darker)}.low-performing-indicator-logo{width:20px;height:20px}.plan_rating{margin-right:15px;margin-left:15px;display:inline-block}.plan_rating:focus{padding:5px;margin:-5px 10px}.plan_rating.nextgen-rating{margin-left:7px}.plan_rating.nextgen-rating:focus{margin-left:2px}.underline{text-decoration:underline}.whitespace-nowrap{white-space:nowrap}.rating-tooltip-cancel{position:absolute;top:0;right:0;cursor:pointer;color:var(--static-Spa_Style_Primary);height:20px;width:20px;text-align:center;margin-top:10px;margin-right:10px}@media (max-width: 575.98px){.plan_rating{max-width:calc(100% - 30px)}.plan_rating .Spa_Style_Note{display:block;margin-left:0!important;margin-right:0!important;text-align:center;white-space:normal}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.ImageService }]; }, { ratingValueDescription: [{
            type: Input
        }], showLowPerformanceIndicator: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], isNotLicensed: [{
            type: Input
        }], newPlanCardDesignEnabled: [{
            type: Input
        }], Spa_StarRating_Enabled: [], Spa_StarRating_Tooltip_Title: [], Spa_StarRating_Tooltip_Text: [], Spa_StarRating_Default_Text: [], Spa_StarRating_Label_Text: [], Spa_StarRating_Alternate_Text: [], Spa_Site_Low_Performance_Indicator_Text: [], Spa_Site_Tooltip_Text: [], Spa_Site_Low_Performance_Plan_Tooltip_Title: [], Spa_Site_Low_Performance_Plan_Tooltip_Text: [], Spa_Site_DisplayTalkingPoints_Shopping_Enabled: [], starRating: [{
            type: Input
        }] }); })();

function TextComponent_p_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.Text);
} }
let TextComponent = class TextComponent extends ConfigurableWidget {
};
TextComponent.ɵfac = /*@__PURE__*/ function () { let ɵTextComponent_BaseFactory; return function TextComponent_Factory(t) { return (ɵTextComponent_BaseFactory || (ɵTextComponent_BaseFactory = i0.ɵɵgetInheritedFactory(TextComponent)))(t || TextComponent); }; }();
TextComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TextComponent, selectors: [["vnext-widget-text"]], features: [i0.ɵɵProvidersFeature([WidgetService] // provides widget data to components down the tree
        ), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "liveEditProp"]], template: function TextComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, TextComponent_p_0_Template, 2, 1, "p", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("liveEditProp", "Text");
    } }, dependencies: [LiveEditPropDirective], encapsulation: 2, changeDetection: 0 });
__decorate([
    PlatformProp('live-edit')
], TextComponent.prototype, "Text", void 0);
TextComponent = __decorate([
    PlatformWidget
], TextComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-text', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService] // provides widget data to components down the tree
                , template: "<p *liveEditProp=\"'Text'\">{{Text}}</p>" }]
    }], null, { Text: [] }); })();

var HtmlHeadingTags;
(function (HtmlHeadingTags) {
    HtmlHeadingTags["H1"] = "h1";
    HtmlHeadingTags["H2"] = "h2";
    HtmlHeadingTags["H3"] = "h3";
    HtmlHeadingTags["H4"] = "h4";
    HtmlHeadingTags["H5"] = "h5";
    HtmlHeadingTags["H6"] = "h6";
})(HtmlHeadingTags || (HtmlHeadingTags = {}));

function TitleComponent_div_0_h1_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.Text);
} }
const _c0$2I = function (a0, a1) { return { Spa_Style_H2: a0, Spa_Style_H2_Light: a1 }; };
function TitleComponent_div_0_h2_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c0$2I, !ctx_r2.useLightFontWeight, ctx_r2.useLightFontWeight));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.Text, " ");
} }
function TitleComponent_div_0_h3_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.Text);
} }
const _c1$1o = function (a0, a1) { return { Spa_Style_H4: a0, Spa_Style_H4_Light: a1 }; };
function TitleComponent_div_0_h4_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h4", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c1$1o, !ctx_r4.useLightFontWeight, ctx_r4.useLightFontWeight));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.Text, " ");
} }
const _c2$R = function (a0, a1) { return { Spa_Style_H5: a0, Spa_Style_H5_Light: a1 }; };
function TitleComponent_div_0_h5_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c2$R, !ctx_r5.useLightFontWeight, ctx_r5.useLightFontWeight));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.Text, " ");
} }
const _c3$A = function (a0, a1) { return { Spa_Style_H6: a0, Spa_Style_H6_Light: a1 }; };
function TitleComponent_div_0_h6_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c3$A, !ctx_r6.useLightFontWeight, ctx_r6.useLightFontWeight));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.Text, " ");
} }
const _c4$k = function (a0) { return { centerText: a0 }; };
function TitleComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, TitleComponent_div_0_h1_1_Template, 2, 1, "h1", 2);
    i0.ɵɵtemplate(2, TitleComponent_div_0_h2_2_Template, 2, 5, "h2", 3);
    i0.ɵɵtemplate(3, TitleComponent_div_0_h3_3_Template, 2, 1, "h3", 4);
    i0.ɵɵtemplate(4, TitleComponent_div_0_h4_4_Template, 2, 5, "h4", 3);
    i0.ɵɵtemplate(5, TitleComponent_div_0_h5_5_Template, 2, 5, "h5", 3);
    i0.ɵɵtemplate(6, TitleComponent_div_0_h6_6_Template, 2, 5, "h6", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", ctx_r0.headingTag)("ngClass", i0.ɵɵpureFunction1(8, _c4$k, ctx_r0.centerText));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.htmlHeadingTags.H1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.htmlHeadingTags.H2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.htmlHeadingTags.H3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.htmlHeadingTags.H4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.htmlHeadingTags.H5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.htmlHeadingTags.H6);
} }
let TitleComponent = class TitleComponent extends ConfigurableWidget {
    constructor() {
        super(...arguments);
        this.headingTag = HtmlHeadingTags.H1;
        // @PlatformProp() paddingTop: string;  // NOTE: Left here in case requested in the future
        // @PlatformProp() paddingBottom: string;
        this.centerText = true;
        this.useLightFontWeight = false;
        this.htmlHeadingTags = HtmlHeadingTags;
    }
};
TitleComponent.ɵfac = /*@__PURE__*/ function () { let ɵTitleComponent_BaseFactory; return function TitleComponent_Factory(t) { return (ɵTitleComponent_BaseFactory || (ɵTitleComponent_BaseFactory = i0.ɵɵgetInheritedFactory(TitleComponent)))(t || TitleComponent); }; }();
TitleComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TitleComponent, selectors: [["vnext-widget-title"]], features: [i0.ɵɵProvidersFeature([WidgetService] // provides widget data to components down the tree
        ), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "ngSwitch", "ngClass", 4, "liveEditProp"], [3, "ngSwitch", "ngClass"], ["class", "Spa_Style_H1", 4, "ngSwitchCase"], [3, "ngClass", 4, "ngSwitchCase"], ["class", "Spa_Style_H3", 4, "ngSwitchCase"], [1, "Spa_Style_H1"], [3, "ngClass"], [1, "Spa_Style_H3"]], template: function TitleComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, TitleComponent_div_0_Template, 7, 10, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("liveEditProp", "Text");
    } }, dependencies: [i1$2.NgClass, i1$2.NgSwitch, i1$2.NgSwitchCase, LiveEditPropDirective], styles: ["div[_ngcontent-%COMP%]{padding:40px 0}div.centerText[_ngcontent-%COMP%]{margin:0 auto}.centerText[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%], .centerText[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%], .centerText[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%], .centerText[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%], .centerText[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%], .centerText[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{text-align:center}"], changeDetection: 0 });
__decorate([
    PlatformProp('live-edit')
], TitleComponent.prototype, "Text", void 0);
__decorate([
    PlatformProp()
], TitleComponent.prototype, "headingTag", void 0);
__decorate([
    PlatformProp()
], TitleComponent.prototype, "centerText", void 0);
__decorate([
    PlatformProp()
], TitleComponent.prototype, "useLightFontWeight", void 0);
TitleComponent = __decorate([
    PlatformWidget
], TitleComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TitleComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-title', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService] // provides widget data to components down the tree
                , template: "<div *liveEditProp=\"'Text'\" [ngSwitch]=\"headingTag\" [ngClass]=\"{ centerText: centerText }\">\r\n  <h1 *ngSwitchCase=\"htmlHeadingTags.H1\" class=\"Spa_Style_H1\">{{ Text }}</h1>\r\n  <h2 *ngSwitchCase=\"htmlHeadingTags.H2\" [ngClass]=\"{ Spa_Style_H2: !useLightFontWeight, Spa_Style_H2_Light: useLightFontWeight }\">\r\n    {{ Text }}\r\n  </h2>\r\n  <h3 *ngSwitchCase=\"htmlHeadingTags.H3\" class=\"Spa_Style_H3\">{{ Text }}</h3>\r\n  <h4 *ngSwitchCase=\"htmlHeadingTags.H4\" [ngClass]=\"{ Spa_Style_H4: !useLightFontWeight, Spa_Style_H4_Light: useLightFontWeight }\">\r\n    {{ Text }}\r\n  </h4>\r\n  <h5 *ngSwitchCase=\"htmlHeadingTags.H5\" [ngClass]=\"{ Spa_Style_H5: !useLightFontWeight, Spa_Style_H5_Light: useLightFontWeight }\">\r\n    {{ Text }}\r\n  </h5>\r\n  <h6 *ngSwitchCase=\"htmlHeadingTags.H6\" [ngClass]=\"{ Spa_Style_H6: !useLightFontWeight, Spa_Style_H6_Light: useLightFontWeight }\">\r\n    {{ Text }}\r\n  </h6>\r\n</div>\r\n", styles: ["div{padding:40px 0}div.centerText{margin:0 auto}.centerText h1,.centerText h2,.centerText h3,.centerText h4,.centerText h5,.centerText h6{text-align:center}\n"] }]
    }], null, { Text: [], headingTag: [], centerText: [], useLightFontWeight: [] }); })();

class QuoteFacade {
    constructor(store, plansService, memberSessionService, demographicHttpService, guidedHelpService, configResourceService, navigationService, sortService, planCompareService, responsiveLayoutService, loginService, enrollmentHistoryService, agentService, quoteService, planFacade, quoteSessionService, planCompareApiService, drugsService, enrollmentFormService) {
        this.store = store;
        this.plansService = plansService;
        this.memberSessionService = memberSessionService;
        this.demographicHttpService = demographicHttpService;
        this.guidedHelpService = guidedHelpService;
        this.configResourceService = configResourceService;
        this.navigationService = navigationService;
        this.sortService = sortService;
        this.planCompareService = planCompareService;
        this.responsiveLayoutService = responsiveLayoutService;
        this.loginService = loginService;
        this.enrollmentHistoryService = enrollmentHistoryService;
        this.agentService = agentService;
        this.quoteService = quoteService;
        this.planFacade = planFacade;
        this.quoteSessionService = quoteSessionService;
        this.planCompareApiService = planCompareApiService;
        this.drugsService = drugsService;
        this.enrollmentFormService = enrollmentFormService;
        this.sortPrimaryKey = SortPrimaryKey;
        this.sort = {
            primaryKey: this.sortPrimaryKey.IS_CURRENT_YEAR_PLAN,
            dataKey: SortLabels.TOTAL_ESTIMATED_COST,
            secondaryDataKey: SortLabels.PLAN_NAME,
            dataKeyType: DataKeyType.NUMERIC,
            sortType: SortType.ASCENDING,
            displayName: this.getPlanListSortByEstimatedCostLabel(),
            display: true,
            sortTransformer: this.getTotalEstimatedCost.bind(this)
        };
        this.medigapSort = {
            primaryKey: this.sortPrimaryKey.IS_CURRENT_YEAR_PLAN,
            dataKey: SortLabels.MEDICAL_PREMIUM,
            secondaryDataKey: SortLabels.PLAN_NAME,
            dataKeyType: DataKeyType.NUMERIC,
            sortType: SortType.DESCENDING,
            displayName: this.getPlanListSortByPlanPremiumLabel(),
            display: true,
            sortTransformer: this.plansService.getTotalPremium.bind(this.plansService)
        };
        this.goToLastPage = true;
        this.comparatorType = ComparatorType;
    }
    get quoteGroups$() {
        return this.store.select(PlansState.quoteGroups);
    }
    initActiveTab() {
        const tabs = this.getTabsData();
        let defaultTab = tabs.find(tab => tab.defaultActive);
        if (!defaultTab) {
            defaultTab = tabs.find(tab => tab.secondaryDefaultActive);
        }
        if (defaultTab) {
            this.tabs = defaultTab;
            if (defaultTab?.filters?.[0]?.values?.length) {
                this.setActiveTab(defaultTab.filters[0].values[0]);
            }
        }
    }
    fetchPlans(planType) {
        const demographicsOptions = this.plansService.createPlansDemographicsOptionsWithDefaults();
        const currentYearPlanId = '';
        const searchOptions = this.plansService.createPlansSearchOptionsWithDefaults(planType ? { planType: `${planType}` } : undefined);
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        const drugs = this.drugsService.mapCabinetToDosage();
        const pharmacies = this.plansService.getSelectedAPIPharmacyInfo();
        const planTypes = PlansUtilityService.splitBitWise(searchOptions?.planType ? +searchOptions?.planType : 0);
        const hasUnloadedPlanTypes = !!this.plansService.getUnloadedPlanTypes(planTypes)?.length;
        // Only get counts if we have unloaded plan types that aren't part of the current fetchPlans request
        searchOptions.planCount = hasUnloadedPlanTypes;
        this.plansService.fetchPlansByOptionsAndSave({
            demographicsOptions,
            searchOptions,
            medigapAnswers: this.plansService.getMergedMedigapAnswers(),
            drugs,
            pharmacies,
            currentYearPlanId,
            agentGuid
        });
    }
    getCounty$() {
        return this.memberSessionService
            .getMemberSession$()
            .pipe(map((memberData) => this.demographicHttpService
            .retrieveCounties$(memberData.demographic.zip)
            .pipe(map((counties) => counties.find(county => county.countyFIPS === memberData.demographic.fips)))))
            .pipe(mergeMap(plans$ => plans$));
    }
    checkActiveTabTypeExists() {
        this.activeTabType$
            .pipe(take(1), map(tabType => !!tabType), defaultIfEmpty(false))
            .subscribe({
            next: isTabExist => {
                if (!isTabExist) {
                    this.initActiveTab();
                }
            }
        });
    }
    setCompareGroup() {
        this.getTabsData().forEach(tab => {
            if (tab?.filters?.[0]?.values?.length) {
                this.planCompareService.setCompareGroup(new CompareGroup(FilterKeyType.PLAN_TYPE_SHORT, tab.filters[0].values));
            }
        });
    }
    setSortGroup() {
        this.getTabsData().forEach(tab => {
            let defaultSort = this.sort;
            if (tab?.filters?.[0]?.values?.length) {
                if (tab.filters[0].values[0] === PlanTypeAbbreviation.MEDIGAP) {
                    defaultSort = this.medigapSort;
                }
                this.sortService.setSortGroup(new SortGroup(FilterKeyType.PLAN_TYPE_SHORT, tab.filters[0].values, this.comparatorType.EQUAL, new Sort(defaultSort.primaryKey, defaultSort.dataKey, defaultSort.secondaryDataKey, defaultSort.dataKeyType, defaultSort.sortType, defaultSort.displayName, defaultSort.display, defaultSort.sortTransformer, defaultSort.secondarySortType)));
            }
        });
    }
    setActiveTab(activeTabType) {
        if (activeTabType) {
            this.quoteService.setActiveTab(activeTabType);
        }
    }
    setDefaultTab() {
        if (this.tabs?.filters?.[0]?.values?.length) {
            this.store.dispatch(new SetDefaultTab(this.tabs.filters[0].values[0]));
        }
    }
    getTabsData() {
        const tabData = this.configResourceService.getProcessedResourceValue('Spa_PlanList_Tabs_Data');
        return tabData.map((tab, index) => new FilterTab(tab, index));
    }
    clearSortGroupSort() {
        const sortGroup = this.tabs.sortGroup;
        this.sortService.clearSortGroupSort(sortGroup);
    }
    getAgeGroups() {
        const ageGroupLabel = this.guidedHelpService.ageGroups.find(ageGroup => ageGroup.value === this.store.selectSnapshot(DemographicState.ageRange));
        if (ageGroupLabel) {
            return ageGroupLabel.label;
        }
    }
    getDefaultTab() {
        const tabData = this.getTabsData();
        const defaultTabType = this.store.selectSnapshot(PlansState.defaultTabType);
        if (defaultTabType && tabData?.length) {
            return tabData.find(tab => tab?.filters?.[0]?.values?.[0] === defaultTabType);
        }
        return {};
    }
    redirectGuidedHelpPages() {
        this.guidedHelpService.goToFirstLink();
    }
    getQuotedPlans$() {
        if (EnvironmentService.getEnvironment().liveedit) {
            return this.getLiveEditQuotedPlans$();
        }
        return combineLatest(this.defaultTabType$, this.quoteGroups$, this.plans$).pipe(map(([defaultTabType, quoteGroups, availablePlans]) => {
            if (defaultTabType) {
                const selectedQuoteGroup = quoteGroups.filter(group => group.groupKey.values[0] === defaultTabType);
                if (selectedQuoteGroup?.[0]?.items?.length) {
                    const quotedPlans = selectedQuoteGroup[0].items;
                    const quotePlansAvailableForAgentBasedOnPermission = availablePlans.filter(availablePlan => quotedPlans.some(quotePlan => quotePlan.id === availablePlan.id));
                    if (quotePlansAvailableForAgentBasedOnPermission.length === quotedPlans.length) {
                        return this.getSortedPlansWithMaximumPlansToDisplay(quotePlansAvailableForAgentBasedOnPermission);
                    }
                    return [];
                }
                return [];
            }
            return [];
        }));
    }
    getBeneficiaryQuoteId() {
        return this.quoteService.getBeneficiaryQuoteId();
    }
    getLiveEditQuotedPlans$() {
        let statePlans = this.store.selectSnapshot(PlansState.getPlansByPlanType(PlanTypeAbbreviation.MAPD));
        if (!statePlans.length) {
            const defaultTab = this.configResourceService.getProcessedResourceValue('Spa_PlanList_Tabs_Data').find(tab => tab.defaultActive);
            if (defaultTab?.tabTypes?.length) {
                statePlans = this.store.selectSnapshot(PlansState.getPlansByPlanType(defaultTab.tabTypes[0]));
            }
        }
        if (statePlans.length) {
            return of(this.getSortedPlansWithMaximumPlansToDisplay(statePlans));
        }
        return of([]);
    }
    getSortedPlansWithMaximumPlansToDisplay(plans) {
        const maximumPlanCountToDisplay = 3;
        const defaultSort = plans?.[0]?.planTypeAbbreviation === PlanTypeAbbreviation.MEDIGAP ? this.medigapSort : this.sort;
        const sortedPlans = SortUtilities.sort(plans, defaultSort);
        return sortedPlans.slice(0, maximumPlanCountToDisplay);
    }
    navigateToPlanDetailsPage(plan) {
        this.navigationService.navigateByPageTag(PageTags.PLAN_DETAILS, {
            queryParams: { id: plan.id }
        });
    }
    updatePlansOnCompareGroupAndNavigate(plans) {
        const defaultTabType = this.store.selectSnapshot(PlansState.defaultTabType);
        this.setActiveTab(defaultTabType);
        this.clearSortGroupSort();
        combineLatest([this.responsiveLayoutService.isCompact$, this.responsiveLayoutService.isMedium$])
            .pipe(map(([isMobile, isMedium]) => isMobile || isMedium), take(1))
            .subscribe({
            next: isMobileOrMediumDevice => {
                const defaultTab = this.getDefaultTab();
                if (defaultTab?.compareGroup?.length) {
                    const compareGroup = defaultTab.compareGroup[0];
                    const planCompareDesktopLimit = this.configResourceService.getProcessedResourceValue('Spa_PlanCard_CompareLimit_Desktop', null, 3);
                    const planCompareMobileLimit = this.configResourceService.getProcessedResourceValue('Spa_PlanCard_CompareLimit_Mobile', null, 2);
                    let totalPlansToCompare = planCompareDesktopLimit;
                    if (isMobileOrMediumDevice) {
                        totalPlansToCompare = planCompareMobileLimit;
                    }
                    this.planCompareService.removeAllPlansFromCompareGroup([compareGroup]);
                    const plansToCompare = plans?.slice(0, totalPlansToCompare);
                    if (plansToCompare?.length) {
                        const selectedPlan = plansToCompare[0];
                        if (selectedPlan) {
                            this.planCompareService.setPlanComparePlanType(selectedPlan.planTypeAbbreviation);
                        }
                        this.planCompareService.addPlansToCompareGroup([compareGroup], plansToCompare);
                    }
                    this.navigationService.navigateByPageTag(PageTags.PLAN_COMPARISON);
                }
            }
        });
    }
    shopAllPlans() {
        if (this.tabs?.filters?.[0]?.values?.length) {
            this.setActiveTab(this.tabs.filters[0].values[0]);
        }
        this.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
    }
    logOut() {
        this.loginService.logout(this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType', null, 'consumer'));
    }
    getTotalEstimatedCost(plans) {
        if (!plans?.length) {
            return 0;
        }
        const selectedPharmacy = this.store.selectSnapshot(PharmacyState.selectedPharmacy);
        return this.planFacade.getTotalEstimatedCost(plans[0], selectedPharmacy);
    }
    getProviders$() {
        return this.store.select(ProviderState.selectedProviders);
    }
    async redirectToQuotedEnrollments(planIds, isConsumerSite = false, storageId, transactionGuid, isBLAMSite, overrideAsShortForm) {
        if (isConsumerSite && transactionGuid) {
            await this.enrollmentHistoryService.handleCompletedEnrollments(planIds, this.navigationService.navigateByPageTag.bind(this.navigationService, PageTags.ENROLLMENT_CONFIRMATION), this.navigationService.navigateByPageTag.bind(this.navigationService, PageTags.ENROLLMENT, {
                queryParams: { goToLastPage: this.goToLastPage },
                state: { fetchTransactionFromGuid: true, transactionGuid, ...(overrideAsShortForm && { overrideAsShortForm }) }
            }));
        }
        else if (storageId) {
            // TODO: marked for removal but added for SPA-10987 and cannot be removed until we have figured out
            // the information needed to diagnose the root cause of this issue
            if (isBLAMSite) {
                console.error(`BLAM site using storageId for beneficiary. isConsumerSite: ${isConsumerSite} tid: ${transactionGuid}`);
            }
            await this.enrollmentHistoryService.handleCompletedEnrollments(planIds, this.navigationService.navigateByPageTag.bind(this.navigationService, PageTags.ENROLLMENT_CONFIRMATION), this.planCompareApiService.startEnrollment.bind(this.planCompareApiService, planIds[0], storageId, true));
        }
        else {
            // TODO: marked for removal but added for SPA-10987 and cannot be removed until we have figured out
            // the information needed to diagnose the root cause of this issue
            if (isBLAMSite) {
                console.error(`BLAM site not fetching transaction from guid. isConsumerSite: ${isConsumerSite} tid: ${transactionGuid}`);
            }
            const enrollmentPlan = await this.enrollmentFormService.fetchEnrollingPlan(planIds[0]);
            if (enrollmentPlan?.enrollViaSTBOnly) {
                this.goToLastPage = false;
            }
            await this.enrollmentHistoryService.handleCompletedEnrollments(planIds, this.navigationService.navigateByPageTag.bind(this.navigationService, PageTags.ENROLLMENT_CONFIRMATION), this.navigationService.navigateByPageTag.bind(this.navigationService, PageTags.ENROLLMENT, {
                queryParams: { goToLastPage: this.goToLastPage },
                ...(overrideAsShortForm ? { state: { overrideAsShortForm } } : {})
            }));
        }
    }
    async handleAgentNoPlanPermission(quotedPlanIds) {
        if (quotedPlanIds?.length) {
            await this.agentService.banAgentFromSession();
            this.quoteService.clearBeneficiaryAgent();
            await this.memberSessionService.updateCart(quotedPlanIds);
        }
    }
    async getInfoForQuote(quoteId, agentGuid, quoteType) {
        return await this.quoteService.getInfoForQuote(quoteId, agentGuid, quoteType);
    }
    async createQuoteSession(pinInfo, quoteId, agentGuid, quoteType, showCurrentMonthMedigapQuote, omitPlansRequest, rehydratePlansFromCart, isSecurityDOBEnabled, dateOfBirth) {
        return await this.quoteSessionService.createQuoteSession(pinInfo, quoteId, agentGuid, quoteType, showCurrentMonthMedigapQuote, omitPlansRequest, rehydratePlansFromCart, isSecurityDOBEnabled, dateOfBirth);
    }
    getPlanListSortByEstimatedCostLabel(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanDetails_TotalEstimatedCost_Text', widgetName, 'Total estimated cost');
    }
    getPlanListSortByPlanPremiumLabel(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanList_Sort_Text_Premium', widgetName, 'Plan Premium (Low to High)');
    }
    updateQuoteVideoURL(videoURL) {
        this.quoteService.updateQuoteVideoURL(videoURL);
    }
    getAgentGuid() {
        return this.quoteService.getAgentGuid();
    }
    getSsoName() {
        return this.quoteService.getSsoName();
    }
    getQuickQuoteGuid() {
        return this.quoteService.getQuickQuoteGuid();
    }
    getSourceSiteId() {
        return this.quoteService.getSourceSiteId();
    }
    getQuoteVideoURL() {
        return this.quoteService.getQuoteVideoURL();
    }
    getShowMeetWithAgentSection() {
        return this.store.selectSnapshot(UiState.showMeetWithAgentSection);
    }
    getShowAgentProfilePicture() {
        return this.store.selectSnapshot(UiState.showAgentProfilePicture);
    }
    getHidePdfAgentData() {
        return this.store.selectSnapshot(UiState.hidePdfAgentData);
    }
    getBrokerData$() {
        return this.quoteService.getBrokerData$();
    }
    updateSelectedFormType(enrollmentFormType, planId) {
        this.quoteService.updateSelectedFormType(enrollmentFormType, planId);
    }
}
QuoteFacade.ɵfac = function QuoteFacade_Factory(t) { return new (t || QuoteFacade)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.PlansService), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(i1.DemographicHttpService), i0.ɵɵinject(i1.GuidedHelpService), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.NavigationService), i0.ɵɵinject(i1.SortService), i0.ɵɵinject(i1.PlanCompareService), i0.ɵɵinject(i1.ResponsiveLayoutService), i0.ɵɵinject(i1.LoginService), i0.ɵɵinject(i1.EnrollmentHistoryService), i0.ɵɵinject(i1.AgentService), i0.ɵɵinject(i1.QuoteService), i0.ɵɵinject(PlanFacade), i0.ɵɵinject(i1.QuoteSessionService), i0.ɵɵinject(i1.PlanCompareApiService), i0.ɵɵinject(i1.DrugsService), i0.ɵɵinject(i1.EnrollmentFormService)); };
QuoteFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: QuoteFacade, factory: QuoteFacade.ɵfac, providedIn: 'root' });
__decorate([
    Select(PlansState.plans)
], QuoteFacade.prototype, "plans$", void 0);
__decorate([
    Select(PlansState.defaultTabType)
], QuoteFacade.prototype, "defaultTabType$", void 0);
__decorate([
    Select(PlansState.activeTabType)
], QuoteFacade.prototype, "activeTabType$", void 0);
__decorate([
    LiveEditInactive()
], QuoteFacade.prototype, "redirectGuidedHelpPages", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QuoteFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i2.Store }, { type: i1.PlansService }, { type: i1.MemberSessionService }, { type: i1.DemographicHttpService }, { type: i1.GuidedHelpService }, { type: i1.ConfigResourceService }, { type: i1.NavigationService }, { type: i1.SortService }, { type: i1.PlanCompareService }, { type: i1.ResponsiveLayoutService }, { type: i1.LoginService }, { type: i1.EnrollmentHistoryService }, { type: i1.AgentService }, { type: i1.QuoteService }, { type: PlanFacade }, { type: i1.QuoteSessionService }, { type: i1.PlanCompareApiService }, { type: i1.DrugsService }, { type: i1.EnrollmentFormService }]; }, { plans$: [], defaultTabType$: [], activeTabType$: [], redirectGuidedHelpPages: [] }); })();

class SoaFormFacade {
    constructor(enrollmentFormService, route, ssoHttpService, loginService, soaHttpService, soaService, sessionHttpService, store, agentService, lockedSiteService, twilioService, planYearResourceService, localeService, configResourceService) {
        this.enrollmentFormService = enrollmentFormService;
        this.route = route;
        this.ssoHttpService = ssoHttpService;
        this.loginService = loginService;
        this.soaHttpService = soaHttpService;
        this.soaService = soaService;
        this.sessionHttpService = sessionHttpService;
        this.store = store;
        this.agentService = agentService;
        this.lockedSiteService = lockedSiteService;
        this.twilioService = twilioService;
        this.planYearResourceService = planYearResourceService;
        this.localeService = localeService;
        this.configResourceService = configResourceService;
        this.currentLocale = this.localeService.getCurrentLocale();
        this.langID = LocaleService.LOCALE_ALIAS_ID[this.currentLocale];
        this._soaPageName$ = new BehaviorSubject(null);
        this.soaPageName$ = this._soaPageName$.asObservable();
        this.soaBeneficiaryConfirmationCodeUniqueName = this.configResourceService.getProcessedResourceValue('soaBeneficiaryConfirmationCode_UniqueName', null, 'SOABeneficiaryConfirmationCode');
        const soaFormCompletionFields = this.configResourceService.getProcessedResourceValue('Spa_SOA_Form_PageCompletion_Field', null, {
            [SOAFormPage.CONSUMER]: 'BeneficiaryAuthorization',
            [SOAFormPage.AGENT]: 'AgentAttestation'
        });
        this.agentFormCompletionField = soaFormCompletionFields[SOAFormPage.AGENT];
        this.memberFormCompletionField = soaFormCompletionFields[SOAFormPage.CONSUMER];
    }
    getSSOSOA$() {
        return this.route.queryParams.pipe(map(params => {
            const encryptedValuesFromURL = {
                EncryptedQueryString: params.qs,
                ValidateSignature: true,
                haKeyVer: params.haKeyVer,
                tpKeyVer: params.tpKeyVer,
                sigid: params.sigid,
                sig: params.sig,
                bitlen: params.bitlen
            };
            return encryptedValuesFromURL;
        }), switchMap(encryptedValuesFromURL => this.getDecrypt$(encryptedValuesFromURL)), switchMap((ssoValues) => {
            this.sso = ssoValues;
            this.setActivePage(ssoValues.pageName);
            const ssoAgentGuid = ssoValues.agentGuid;
            if (ssoAgentGuid) {
                return this.agentService.fetchAgent$(ssoAgentGuid, ssoAgentGuid).pipe(switchMap((agentData) => this.agentService.updateAgent$(agentData)), map(() => ssoValues));
            }
            return of(ssoValues);
        }), switchMap((ssoValues) => from(this.loginService.loginSSOMember(ssoValues, {
            fetchCreatingAgent: false,
            includePlanData: false,
            includeSOA: true,
            firstTimeLogin: true
        })).pipe(map(() => ssoValues))));
    }
    getFormTransaction$() {
        return this.getSSOSOA$().pipe(tap(() => {
            const customInternalResource = this.enrollmentFormService.getCustomInternalResource();
            const customInternal = this.enrollmentFormService.prepareCustomInternalForBean(customInternalResource, null);
            this.enrollmentFormService.setCustomInternalToSessionStorage(customInternal);
        }));
    }
    updateSOABeneficiaryConfirmationCodeAnswer(answers) {
        const soaAnswers = _cloneDeep(answers);
        const soaBeneficiaryConfirmationCode = this.getSOABeneficiaryConfirmationCode();
        const lowerCaseSOABeneficiaryConfirmationCodeUniqueName = this.soaBeneficiaryConfirmationCodeUniqueName.toLowerCase();
        const soaBeneficiaryConfirmationCodeAnswer = soaAnswers.find(answer => answer.name.toLowerCase() === lowerCaseSOABeneficiaryConfirmationCodeUniqueName);
        if (soaBeneficiaryConfirmationCodeAnswer) {
            soaBeneficiaryConfirmationCodeAnswer.value = soaBeneficiaryConfirmationCode;
            return soaAnswers;
        }
        return [...soaAnswers, new Answer(this.soaBeneficiaryConfirmationCodeUniqueName, soaBeneficiaryConfirmationCode)];
    }
    getDecrypt$(encryptedValuesFromURL) {
        return this.ssoHttpService.decrypt$(encryptedValuesFromURL);
    }
    getAgentInContextGuid$() {
        return this.agentService.getAgentInContextGuid$();
    }
    getSOABeneficiaryConfirmationCode() {
        return this.sso?.soaBeneficiaryConfirmationCode ?? '';
    }
    getFormInfo$(tid) {
        return this.soaHttpService.getFormInfo$(tid);
    }
    getFormPage$(tid, pageName) {
        return this.soaHttpService.getFormPage$(tid, pageName, this.localeService.getCurrentLocale(), this.planYearResourceService.getSelectedPlanYear());
    }
    getSOATransactionSID() {
        return this.sso?.transactionSID ? this.sso.transactionSID : null;
    }
    getSOAPageName() {
        // eslint-disable-next-line rxjs/no-subject-value
        return this._soaPageName$.getValue();
    }
    getSOAPageName$() {
        return this.soaPageName$;
    }
    setActivePage(pageName) {
        this._soaPageName$.next(pageName);
    }
    getSOAUserType() {
        return this.sso?.userType ?? null;
    }
    hasValidCompletedSOA() {
        return this.soaService.hasValidCompletedSOA();
    }
    // there is no semantic indicator for determining if a page in an SOA form
    // is consumer, agent or otherwise so we must look for the presence of specific
    // fields to infer the type of page we are dealing with
    getInferredFormPage(answers) {
        if (this.hasMemberFormCompletionField(answers)) {
            return SOAFormPage.CONSUMER;
        }
        else if (this.hasAgentFormCompletionField(answers)) {
            return SOAFormPage.AGENT;
        }
        return SOAFormPage.OTHER;
    }
    isAgentPageComplete(transactionSID) {
        const answers = this.soaService.getSOATransactionAnswers(transactionSID);
        return this.hasAgentFormCompletionField(answers);
    }
    isMemberPageComplete(transactionSID) {
        const answers = this.soaService.getSOATransactionAnswers(transactionSID);
        return this.hasMemberFormCompletionField(answers);
    }
    allFormPagesComplete(transactionSID) {
        return this.isAgentPageComplete(transactionSID) && this.isMemberPageComplete(transactionSID);
    }
    submitForm$(tid, enrollmentRequest, updateTransactionAnswers) {
        return this.soaHttpService.completeTransaction$(tid, {
            ...enrollmentRequest,
            langID: this.langID,
            validations: []
        });
    }
    updateSOATransactionAnswers$(tid, answers) {
        return this.store.dispatch(new UpdateSOATransactionAnswers(tid, answers));
    }
    finishForm$(tid, enrollmentSettings) {
        const sessionId = this.store.selectSnapshot(state => state.application.member.sessionId);
        const isSiteLive = this.lockedSiteService.isSiteLive();
        const isReviewSite = this.lockedSiteService.isReviewSite(window.location.hostname);
        const callRecordingCode = this.twilioService.getOpenConnectionCallRecordingCode();
        return this.soaHttpService.finishTransaction$(sessionId, tid, enrollmentSettings, this.planYearResourceService.getSelectedPlanYear(), this.enrollmentFormService.getExternalEnrollmentSettings(), isSiteLive, isReviewSite, callRecordingCode);
    }
    updateMember$(member) {
        const sessionId = this.store.selectSnapshot(state => state.application.member.sessionId);
        return this.sessionHttpService.updateSession$(sessionId, member);
    }
    getSOAPersonalizedVideoURL(soaTransactionSID) {
        const memberEnrollments = this.store.selectSnapshot(MemberState.memberEnrollments);
        let personalizedVideoURL = '';
        if (memberEnrollments?.length) {
            const enrollment = memberEnrollments.find(enroll => enroll.transactionSID === soaTransactionSID);
            personalizedVideoURL = enrollment?.videoURL || '';
        }
        return personalizedVideoURL;
    }
    hasAgentFormCompletionField(answers) {
        return !!answers?.find(answer => answer.name === this.agentFormCompletionField)?.value;
    }
    hasMemberFormCompletionField(answers) {
        return !!answers?.find(answer => answer.name === this.memberFormCompletionField)?.value;
    }
}
SoaFormFacade.ɵfac = function SoaFormFacade_Factory(t) { return new (t || SoaFormFacade)(i0.ɵɵinject(i1.EnrollmentFormService), i0.ɵɵinject(i2$1.ActivatedRoute), i0.ɵɵinject(i1.SSOHttpService), i0.ɵɵinject(i1.LoginService), i0.ɵɵinject(i1.SOAHttpService), i0.ɵɵinject(i1.SOAService), i0.ɵɵinject(i1.MemberSessionHttpService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.AgentService), i0.ɵɵinject(i1.LockedSiteService), i0.ɵɵinject(i1.TwilioDeviceService), i0.ɵɵinject(i1.PlanYearResourceService), i0.ɵɵinject(i1.LocaleService), i0.ɵɵinject(i1.ConfigResourceService)); };
SoaFormFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SoaFormFacade, factory: SoaFormFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SoaFormFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.EnrollmentFormService }, { type: i2$1.ActivatedRoute }, { type: i1.SSOHttpService }, { type: i1.LoginService }, { type: i1.SOAHttpService }, { type: i1.SOAService }, { type: i1.MemberSessionHttpService }, { type: i2.Store }, { type: i1.AgentService }, { type: i1.LockedSiteService }, { type: i1.TwilioDeviceService }, { type: i1.PlanYearResourceService }, { type: i1.LocaleService }, { type: i1.ConfigResourceService }]; }, null); })();

function BeneficiaryComponent_ng_container_8_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-agent-profile-picture", 31);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const broker_r14 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("broker", broker_r14)("agentProfilePictureUrl", broker_r14.agentPictureURL);
} }
function BeneficiaryComponent_ng_container_8_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, BeneficiaryComponent_ng_container_8_div_1_ng_container_1_Template, 2, 2, "ng-container", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const brokerData_r12 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", brokerData_r12.data);
} }
function BeneficiaryComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, BeneficiaryComponent_ng_container_8_div_1_Template, 2, 1, "div", 29);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r0.brokerData$));
} }
function BeneficiaryComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 32);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r1.Spa_Beneficiary_Introduction_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function BeneficiaryComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelement(1, "i", 34);
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.Spa_Site_ErrorKeyword_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r2.Spa_Beneficiary_AuthorizationCode_Error_Text, " ");
} }
const _c0$2H = function (a0) { return { "label-invalid": a0 }; };
function BeneficiaryComponent_span_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$2H, ctx_r3.getCodeStatus()));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.Spa_Beneficiary_AuthorizationCode_Text);
} }
function BeneficiaryComponent_div_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.Spa_Beneficiary_AuthorizationCode_Hint_Text, " ");
} }
function BeneficiaryComponent_div_28_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵelement(1, "i", 34);
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r15.Spa_Site_ErrorKeyword_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r15.Spa_Security_DOB_Error_Text, " ");
} }
function BeneficiaryComponent_div_28_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelement(1, "i", 34);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.dobError, " ");
} }
function BeneficiaryComponent_div_28_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$2H, (ctx_r17.beneficiaryAuthorizationForm.controls.dateOfBirth == null ? null : ctx_r17.beneficiaryAuthorizationForm.controls.dateOfBirth.invalid) && ctx_r17.formSubmitted));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r17.Spa_Security_DOB_Label);
} }
function BeneficiaryComponent_div_28_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r18.Spa_Security_DOB_Instructional_Text, " ");
} }
const _c1$1n = function (a0) { return { error: a0 }; };
const _c2$Q = function (a0) { return { "error-border": a0 }; };
function BeneficiaryComponent_div_28_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 13);
    i0.ɵɵtemplate(2, BeneficiaryComponent_div_28_div_2_Template, 5, 2, "div", 38);
    i0.ɵɵtemplate(3, BeneficiaryComponent_div_28_div_3_Template, 3, 1, "div", 39);
    i0.ɵɵelementStart(4, "div", 15)(5, "div")(6, "label", 40)(7, "span", 17);
    i0.ɵɵtext(8, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, BeneficiaryComponent_div_28_span_9_Template, 2, 4, "span", 18);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 6)(11, "div", 19)(12, "div", 20)(13, "input", 41);
    i0.ɵɵlistener("blur", function BeneficiaryComponent_div_28_Template_input_blur_13_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r19.getDateValidation(ctx_r19.beneficiaryAuthorizationForm.controls.dateOfBirth == null ? null : ctx_r19.beneficiaryAuthorizationForm.controls.dateOfBirth.value)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(14, BeneficiaryComponent_div_28_div_14_Template, 2, 1, "div", 22);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r5.isValidBeneficiaryDateOfBirth && ctx_r5.isValidDateOfBirth && ctx_r5.formSubmitted);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r5.isValidDateOfBirth && ctx_r5.dobError && ctx_r5.formSubmitted);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c1$1n, (ctx_r5.beneficiaryAuthorizationForm.controls.dateOfBirth == null ? null : ctx_r5.beneficiaryAuthorizationForm.controls.dateOfBirth.invalid) && ctx_r5.formSubmitted));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Security_DOB_Label");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("placeholder", ctx_r5.dateFormat)("mask", ctx_r5.dateMaskFormat)("dropSpecialCharacters", false)("ngClass", i0.ɵɵpureFunction1(11, _c2$Q, (ctx_r5.beneficiaryAuthorizationForm.controls.dateOfBirth == null ? null : ctx_r5.beneficiaryAuthorizationForm.controls.dateOfBirth.invalid) && ctx_r5.formSubmitted));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Security_DOB_Instructional_Text");
} }
function BeneficiaryComponent_div_29_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵelement(1, "i", 34);
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r21.Spa_Site_ErrorKeyword_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r21.Spa_Beneficiary_Disclaimer_Error_Text, " ");
} }
function BeneficiaryComponent_div_29_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 52);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r22.Spa_Beneficiary_Disclaimer_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function BeneficiaryComponent_div_29_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 53);
    i0.ɵɵelement(1, "vnext-link", 54);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r23.Spa_Beneficiary_ViewDetails_Link_Text)("keyNameForLiveEdit", "Spa_Beneficiary_ViewDetails_Link_Text")("alwaysUnderlined", true)("href", ctx_r23.Spa_Beneficiary_ViewDetails_Link_Url[0].href)("tag", ctx_r23.Spa_Beneficiary_ViewDetails_Link_Url[0].tag)("linkTarget", ctx_r23.Spa_Beneficiary_ViewDetails_Link_Url[0].target)("customClass", "Spa_Style_LinkOnDarkBackgrounds");
} }
function BeneficiaryComponent_div_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵtemplate(1, BeneficiaryComponent_div_29_div_1_Template, 5, 2, "div", 45);
    i0.ɵɵelementContainerStart(2);
    i0.ɵɵelementStart(3, "div", 7)(4, "label", 46);
    i0.ɵɵelement(5, "input", 47);
    i0.ɵɵelementStart(6, "span", 48);
    i0.ɵɵtext(7, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, BeneficiaryComponent_div_29_span_8_Template, 2, 4, "span", 49);
    i0.ɵɵtemplate(9, BeneficiaryComponent_div_29_span_9_Template, 2, 7, "span", 50);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.getDisclaimerStatus());
    i0.ɵɵadvance(4);
    i0.ɵɵattribute("aria-checked", ctx_r6.beneficiaryAuthorizationForm && ctx_r6.beneficiaryAuthorizationForm.controls && ctx_r6.beneficiaryAuthorizationForm.controls.agreeToDisclaimer ? ctx_r6.beneficiaryAuthorizationForm.controls.agreeToDisclaimer.valid : "false");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c1$1n, ctx_r6.getDisclaimerStatus()));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Beneficiary_Disclaimer_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.Spa_Beneficiary_ViewDetails_Link_Enabled);
} }
function BeneficiaryComponent_button_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 55);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.Spa_Beneficiary_ViewQuote_Button_Text, " ");
} }
function BeneficiaryComponent_div_32_div_1_h2_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 64);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r25.agentDetailsMeetText$));
} }
function BeneficiaryComponent_div_32_div_1_div_6_ng_container_3_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 68)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate1("href", "tel: ", ctx_r29.brokerData == null ? null : ctx_r29.brokerData.data == null ? null : ctx_r29.brokerData.data.phoneNumber, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("aria-label", (ctx_r29.brokerData == null ? null : ctx_r29.brokerData.data == null ? null : ctx_r29.brokerData.data.agencyName) + ": " + (ctx_r29.brokerData == null ? null : ctx_r29.brokerData.data == null ? null : ctx_r29.brokerData.data.phoneNumber));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r29.agentDetailsPhoneNumber, " ");
} }
function BeneficiaryComponent_div_32_div_1_div_6_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, BeneficiaryComponent_div_32_div_1_div_6_ng_container_3_a_1_Template, 3, 3, "a", 67);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Beneficiary_AgentDetails_Content");
} }
function BeneficiaryComponent_div_32_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 65)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, BeneficiaryComponent_div_32_div_1_div_6_ng_container_3_Template, 2, 1, "ng-container", 66);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(3);
    const _r9 = i0.ɵɵreference(34);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r26.agentDetailsCallText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r26.isMobile)("ngIfElse", _r9);
} }
function BeneficiaryComponent_div_32_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 69);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(3);
    let tmp_0_0;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", (tmp_0_0 = i0.ɵɵpipeBind1(2, 1, ctx_r27.brokerData$)) == null ? null : tmp_0_0.data.emailAddress, " ");
} }
function BeneficiaryComponent_div_32_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 57)(2, "div", 58);
    i0.ɵɵelement(3, "i", 59);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 60);
    i0.ɵɵtemplate(5, BeneficiaryComponent_div_32_div_1_h2_5_Template, 3, 3, "h2", 61);
    i0.ɵɵtemplate(6, BeneficiaryComponent_div_32_div_1_div_6_Template, 4, 3, "div", 62);
    i0.ɵɵtemplate(7, BeneficiaryComponent_div_32_div_1_div_7_Template, 3, 3, "div", 63);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    let tmp_2_0;
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("liveEditProp", "Spa_Beneficiary_AgentDetails_Intro_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r24.brokerData == null ? null : ctx_r24.brokerData.data == null ? null : ctx_r24.brokerData.data.phoneNumber);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_2_0 = i0.ɵɵpipeBind1(8, 3, ctx_r24.brokerData$)) == null ? null : tmp_2_0.data.emailAddress);
} }
function BeneficiaryComponent_div_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵtemplate(1, BeneficiaryComponent_div_32_div_1_Template, 9, 5, "div", 23);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    let tmp_0_0;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_0_0 = i0.ɵɵpipeBind1(2, 1, ctx_r8.brokerData$)) == null ? null : tmp_0_0.data);
} }
function BeneficiaryComponent_ng_template_33_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r30.agentDetailsPhoneNumber, " ");
} }
function BeneficiaryComponent_ng_template_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, BeneficiaryComponent_ng_template_33_div_0_Template, 3, 1, "div", 70);
} if (rf & 2) {
    i0.ɵɵproperty("liveEditProp", "Spa_Beneficiary_AgentDetails_Content");
} }
const _c3$z = function (a0) { return { "background-image": a0 }; };
const _c4$j = function (a0) { return { " col-md-8 col-lg-9": a0 }; };
let BeneficiaryComponent = class BeneficiaryComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, navigationService, activatedRoute, quoteService, imageService, quoteFacade, siteService, spinnerService, enrollmentFormService, planCompareApiService, phoneService, analyticsService, localeService, navigationUtilityService, configResourceService, soaFormFacade, soaFacade, agentService, responsiveLayoutService, store) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.navigationService = navigationService;
        this.activatedRoute = activatedRoute;
        this.quoteService = quoteService;
        this.imageService = imageService;
        this.quoteFacade = quoteFacade;
        this.siteService = siteService;
        this.spinnerService = spinnerService;
        this.enrollmentFormService = enrollmentFormService;
        this.planCompareApiService = planCompareApiService;
        this.phoneService = phoneService;
        this.analyticsService = analyticsService;
        this.localeService = localeService;
        this.navigationUtilityService = navigationUtilityService;
        this.configResourceService = configResourceService;
        this.soaFormFacade = soaFormFacade;
        this.soaFacade = soaFacade;
        this.agentService = agentService;
        this.responsiveLayoutService = responsiveLayoutService;
        this.store = store;
        this.Spa_Site_SiteType = SiteType.CONSUMER;
        this.Spa_Beneficiary_AuthorizationPage_Background_Url = 'phoenix/assets/images/couple_dog.jpg';
        this.Spa_Beneficiary_AuthorizationPage_Background_MobileUrl = 'phoenix/assets/images/couple_dog_mobile.jpg';
        this.Spa_Beneficiary_AuthorizationPage_Enabled = true;
        this.Spa_Beneficiary_DisclaimerSection_Enabled = false;
        this.Spa_Beneficiary_ViewDetails_Link_Enabled = true;
        this.Spa_Beneficiary_ViewDetails_Link_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_Beneficiary_AuthorizationCode_Error_Text = 'Please provide valid authorization code';
        this.Spa_Beneficiary_Disclaimer_Error_Text = 'Please check the box to continue';
        this.Spa_Site_EnableQuoteSummary = true;
        this.Spa_Site_ErrorKeyword_Text = 'Error:';
        this.Spa_Site_Is_BLAM = false;
        this.Spa_Site_Loader_Message_Json = [];
        this.Spa_Agency_Consumer_Resource_Sharing_Enabled = false;
        this.Spa_AgencyContact_Consumer_Resource_Sharing_Enabled = false;
        this.Spa_Beneficiary_Greeting_Text = 'Hi <ssoName>,';
        this.Spa_Beneficiary_ViewDetails_Link_Text = 'View details';
        this.Spa_Beneficiary_Disclaimer_Text = '<strong> I agree to using my personal information </strong> to provide recommendations of related products.';
        this.Spa_Beneficiary_Introduction_Text = 'Please enter the authorization code you received to view the plan information we discussed.';
        this.Spa_Beneficiary_AuthorizationCode_Text = 'Authorization code';
        this.Spa_Beneficiary_AuthorizationCode_Hint_Text = 'The authorization code was sent to your mail';
        this.Spa_Beneficiary_ViewQuote_Button_Text = 'View quote';
        this.Spa_Beneficiary_AgentDetails_Intro_Text = 'Meet with <firstName> <lastName>';
        this.Spa_Beneficiary_AgentDetails_Content = 'Call <firstName> to make an appointment. <phoneNumber>';
        this.Spa_Security_DOB_Enabled = false;
        this.Spa_Security_DOB_Label = 'Date of birth';
        this.Spa_Security_DOB_Instructional_Text = 'Please input your date of birth';
        this.Spa_Security_DOB_Error_Text = 'Date of birth does not match. Please contact your Medicare agent for assistance.';
        this.formSubmitted = false;
        this.ssoName = '';
        this.isDisclaimerValid = false;
        this.isNotAuthorized = false;
        this.checkFocus = false;
        this.accessType = '';
        this.isShortForm = false;
        this.quotedPlanIds = [];
        this.transactionGuid = '';
        this.storageId = '';
        this.sourceSiteId = '';
        this.showMeetWithAgentSection = true;
        this.showAgentProfilePicture = false;
        this.hidePdfAgentData = false;
        this.soaFormAuthorization = false;
        this.isValidDateOfBirth = false;
        this.isValidBeneficiaryDateOfBirth = false;
        this.isValid = false;
        this.isMobile = false;
        this.subscriptions = [];
    }
    async ngOnInit() {
        super.ngOnInit();
        this.brokerData$ = this.quoteFacade.getBrokerData$();
        if (!this.Spa_Beneficiary_AuthorizationPage_Enabled) {
            this.siteService.setConsumerSiteType(ConsumerSiteType.ANONYMOUS);
            this.navigationService.navigateByPageTag(PageTags.HOME);
        }
        else {
            this.loaderText = this.getBeneficiaryLoaderText();
            this.siteService.setConsumerSiteType(ConsumerSiteType.QUOTING);
            this.subscriptions.push(this.activatedRoute.queryParams.subscribe({
                next: params => {
                    if (params && Object.keys(params).length) {
                        if (params.qs && params.soaFormUrl) {
                            this.initSOAFormAuthorization(params);
                        }
                        else {
                            this.setValuesFromDecryptedData(params);
                        }
                    }
                }
            }));
            this.subscriptions.push(this.responsiveLayoutService.isCompact$.subscribe({ next: isMobile => (this.isMobile = isMobile) }));
            this.subscriptions.push(combineLatest([this.localeService.getCurrentLocale$(), this.brokerData$]).subscribe({
                next: ([locale, brokerData]) => {
                    if (brokerData?.data) {
                        this.brokerData = brokerData;
                        const agentPhoneNumberFormatted = this.phoneService.formatPhoneNumberWithExtension(brokerData.data.phoneNumber, brokerData.data.ext);
                        const indexOfPhoneNumberText = this.Spa_Beneficiary_AgentDetails_Content.indexOf('<phoneNumber>');
                        this.agentDetailsCallText = this.Spa_Beneficiary_AgentDetails_Content.substring(0, indexOfPhoneNumberText).replace('<firstName>', brokerData.data.firstName);
                        this.agentDetailsPhoneNumber = this.Spa_Beneficiary_AgentDetails_Content.substring(indexOfPhoneNumberText).replace('<phoneNumber>', agentPhoneNumberFormatted);
                    }
                    this.cdr.markForCheck();
                }
            }));
            if (this.quoteType === QuoteType.PCAPIENROLLMENTQUOTE) {
                this.setPCApiValues();
            }
            if (this.ssoName || this.agentId || this.quoteId || this.quickQuoteGuid) {
                this.quoteService.setBeneficiaryQuoteDetails(this.ssoName, this.agentId, this.quoteId, this.quickQuoteGuid, this.showMeetWithAgentSection, this.showAgentProfilePicture, this.hidePdfAgentData, this.sourceSiteId);
            }
            else {
                this.ssoName = this.quoteFacade.getSsoName();
                this.agentId = this.quoteFacade.getAgentGuid();
                this.quoteId = this.quoteFacade.getBeneficiaryQuoteId();
                this.quickQuoteGuid = this.quoteFacade.getQuickQuoteGuid();
                this.showMeetWithAgentSection = this.quoteFacade.getShowMeetWithAgentSection();
                this.showAgentProfilePicture = this.quoteFacade.getShowAgentProfilePicture();
                this.hidePdfAgentData = this.quoteFacade.getHidePdfAgentData();
                this.sourceSiteId = this.quoteFacade.getSourceSiteId();
            }
            if (this.Spa_Agency_Consumer_Resource_Sharing_Enabled &&
                this.Spa_AgencyContact_Consumer_Resource_Sharing_Enabled &&
                this.quoteId &&
                this.sourceSiteId) {
                this.configResourceService
                    .fetchContactResource$(this.quoteId, this.sourceSiteId)
                    .pipe(take(1))
                    .subscribe({
                    next: sharedResources => {
                        if (sharedResources) {
                            this.configResourceService.updateConfigResource(sharedResources.resourceBundle);
                            this.configResourceService.setContactInfoConfig(sharedResources);
                            this.cdr.markForCheck();
                        }
                    }
                });
            }
            this.beneficiaryAuthorizationForm = new UntypedFormGroup({
                authorizationCode: new UntypedFormControl('', [Validators.required, Validators.minLength(4)]),
                dateOfBirth: new UntypedFormControl('', [Validators.required]),
                agreeToDisclaimer: new UntypedFormControl('', Validators.required)
            });
            if (!this.soaFormAuthorization) {
                const quoteInfo = await this.quoteFacade.getInfoForQuote(this.quoteId, this.agentId, this.quoteType === QuoteType.PCAPIENROLLMENTQUOTE ? this.quoteType : null);
                if (quoteInfo) {
                    this.quotedPlanIds = quoteInfo.planIds;
                    this.updateMemberIdTag(quoteInfo.memberId);
                    this.quoteService.setQuotePlanIds(this.quotedPlanIds);
                    // TODO: This may need to be updated as/if we get more video urls from this particular endpoint.
                    // Especially if they come from SmartVx, we will need to figure out which video is which.
                    const quoteUrl = quoteInfo.quoteExtraData?.videoData?.[0]?.videoURL;
                    if (quoteUrl) {
                        this.quoteFacade.updateQuoteVideoURL(quoteUrl);
                    }
                }
            }
        }
        this.noDateError = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Member_Profile_NoBirthDateError_Text', null, 'Please provide a valid date of birth');
        this.futureDateError = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Member_Profile_FutureBirthDateError_Text', null, 'Please provide a date of birth in the past');
        this.outOfRangeError = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Member_Profile_BirthDateOutOfRangeError_Text', null, 'The date of birth is too far in the past');
        this.maxAge = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Member_Profile_Maximum_Age', null, 105);
        this.dateFormat = this.getDateFormat();
        this.dateMaskFormat = this.getDateMaskFormat();
        this.cdr.markForCheck();
    }
    initSOAFormAuthorization(params) {
        this.soaFormAuthorization = true;
        const encryptedValuesFromURL = {
            EncryptedQueryString: params.qs,
            ValidateSignature: true,
            haKeyVer: params.haKeyVer,
            tpKeyVer: params.tpKeyVer,
            sigid: params.sigid,
            sig: params.sig,
            bitlen: params.bitlen
        };
        this.soaFormUrl = params.soaFormUrl;
        const queryParams = new URLSearchParams(params);
        this.queryParams = queryParams.toString();
        this.handleDecryption(encryptedValuesFromURL).then(decryptedData => {
            this.setValuesFromDecryptedData(decryptedData);
            this.getSOAAgent();
            this.cdr.markForCheck();
        });
    }
    getSOAAgent() {
        this.subscriptions.push(this.agentService.fetchAgent$(this.agentId, this.agentId).subscribe({
            next: (agentData) => {
                this.agentService.updateAgent$(agentData);
            }
        }));
    }
    getQuoteType(params) {
        switch (params.quoteType) {
            case 'QUICKQUOTE':
                return QuoteType.QUICKQUOTE;
            case 'ENROLLMENTQUOTE':
                return QuoteType.ENROLLMENTQUOTE;
            case 'PCAPIENROLLMENTQUOTE':
                return QuoteType.PCAPIENROLLMENTQUOTE;
            default:
                return undefined;
        }
    }
    setPCApiValues() {
        this.planCompareApiService.markAsRedirectedFromPlanCompareApi();
        this.planCompareApiService.setStorageId(this.storageId);
    }
    ngAfterViewChecked() {
        if (this.checkFocus) {
            const firstInvalidRetentionLoginInput = document.querySelector('input.ng-invalid');
            const firstInvalidElement = firstInvalidRetentionLoginInput;
            if (firstInvalidElement) {
                firstInvalidElement.focus();
            }
            this.checkFocus = false;
        }
    }
    getDisclaimerStatus() {
        if (this.formSubmitted) {
            return this.beneficiaryAuthorizationForm.controls.agreeToDisclaimer?.invalid;
        }
    }
    getCodeStatus() {
        if (this.formSubmitted) {
            return this.beneficiaryAuthorizationForm.controls.authorizationCode?.invalid;
        }
    }
    getDateFormat() {
        return DateUtilities.defaultFormat;
    }
    getDateMaskFormat() {
        return this.getDateFormat().replace(/\w/g, '0');
    }
    getDateValidation(date) {
        if (!date || date.length < 10) {
            this.setDateOfBirthInvalid(true, this.noDateError);
            return false;
        }
        if (!DateUtilities.isValidDate(date)) {
            this.setDateOfBirthInvalid(true, this.noDateError);
            return false;
        }
        if (DateUtilities.dateIsInFuture(date)) {
            this.setDateOfBirthInvalid(true, this.futureDateError);
            return false;
        }
        if (!DateUtilities.dateIsInPastYearRange(date, this.maxAge)) {
            this.setDateOfBirthInvalid(true, this.outOfRangeError);
            return false;
        }
        this.setDateOfBirthInvalid(false, '');
        return true;
    }
    setDateOfBirthInvalid(invalid, error) {
        this.dobError = error; // consider moving this to a more appropriate place if needed
        const dateOfBirthControl = this.beneficiaryAuthorizationForm.get('dateOfBirth');
        dateOfBirthControl.setErrors(invalid ? { invalid: true } : null);
    }
    async redirectOnSuccess() {
        this.isNotAuthorized = false;
        if (this.accessType === BeneficiaryRedirectTypes.ENROLLMENT) {
            this.spinnerService.show(SpinnerEvent.NAVIGATE_TO_ENROLLMENT);
            this.siteService.setConsumerSiteType(ConsumerSiteType.ANONYMOUS);
            if (this.quoteType === QuoteType.PCAPIENROLLMENTQUOTE) {
                // if no transactionGuid then get it from the member enrollments by planId
                this.setTransactionGuid(this.planId);
                const isConsumerSite = !this.siteService.isPPCSite();
                await this.quoteFacade.redirectToQuotedEnrollments(this.quotedPlanIds, isConsumerSite, 
                // TODO: after the root cause for SPA-10987 is discovered we can remove this from its uses from beneficiary component
                // Note storageId is still needed when we initialize in the pc api service just no longer associates the beneficiary
                // session data with the member... transactionId does that now... leaving it in as a diagnostic tool for now however
                this.storageId, this.transactionGuid, this.Spa_Site_Is_BLAM, this.isShortForm);
            }
            else {
                // TODO: marked for removal but added for SPA-10987 and cannot be removed until we have figured out
                // the information needed to diagnose the root cause of this issue
                if (this.Spa_Site_Is_BLAM) {
                    console.error(`PCAPIENROLLMENTQUOTE required for BLAM site but quoteType is ${this.quoteType}.`);
                }
                const isConsumerSite = !this.siteService.isPPCSite();
                await this.quoteFacade.redirectToQuotedEnrollments(this.quotedPlanIds, isConsumerSite, undefined, this.transactionGuid, undefined, this.isShortForm);
            }
            this.spinnerService.hide(SpinnerEvent.NAVIGATE_TO_ENROLLMENT);
        }
        else {
            this.navigationService.navigateByPageTag(PageTags.QUOTE_SUMMARY, this.planType ? { queryParams: { planType: `${this.planType}` } } : undefined);
        }
    }
    redirectOnSuccessToSOAForm() {
        const url = `${this.soaFormUrl}?${this.queryParams}`;
        window.location.href = url;
    }
    get backgroundImageURL() {
        return `url( ${this.imageService.resolveFullImagePath(this.Spa_Beneficiary_AuthorizationPage_Background_Url)} )`;
    }
    get mobileBackgroundImageURL() {
        return `url( ${this.imageService.resolveFullImagePath(this.Spa_Beneficiary_AuthorizationPage_Background_MobileUrl)} )`;
    }
    get agentDetailsMeetText$() {
        return this.brokerData$.pipe(map(brokerData => {
            if (brokerData?.data) {
                return this.Spa_Beneficiary_AgentDetails_Intro_Text.replace('<firstName>', brokerData.data.firstName).replace('<lastName>', brokerData.data.lastName);
            }
            return '';
        }));
    }
    getAgentGreetingText() {
        this.agentGreetingText = this.Spa_Beneficiary_Greeting_Text.replace('<ssoName>', this.ssoName);
    }
    async submitForm() {
        this.isValid = false;
        this.isNotAuthorized = false;
        this.isValidBeneficiaryDateOfBirth = true;
        const isAuthorizationCodeInvalid = this.beneficiaryAuthorizationForm.controls.authorizationCode?.invalid;
        this.isDisclaimerValid = this.beneficiaryAuthorizationForm.controls.agreeToDisclaimer?.valid;
        this.isValidDateOfBirth =
            !this.Spa_Security_DOB_Enabled || this.getDateValidation(this.beneficiaryAuthorizationForm.controls.dateOfBirth?.value);
        this.isBeneficiaryFormValid(isAuthorizationCodeInvalid);
        this.formSubmitted = true;
        const dateOfBirthControl = this.beneficiaryAuthorizationForm?.value?.dateOfBirth;
        const dateOfBirth = this.Spa_Security_DOB_Enabled && dateOfBirthControl ? dateOfBirthControl : '';
        if (this.isValid && this.isValidDateOfBirth && this.Spa_Site_EnableQuoteSummary && !this.soaFormAuthorization) {
            this.spinnerService.show(SpinnerEvent.BENEFICIARY_FORM_SUBMIT, undefined, this.loaderText);
            const authCode = this.beneficiaryAuthorizationForm?.value?.authorizationCode;
            const authInfo = {
                auth1: this.quickQuoteGuid,
                auth2: authCode
            };
            const showCurrentMonthMedigapQuote = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_MedSupForm_ShowCurrentMonthInEffectiveDateDropdown_Flag', null, false);
            this.quoteFacade
                .createQuoteSession(authInfo, this.quoteId, this.agentId, this.quoteType === QuoteType.PCAPIENROLLMENTQUOTE ? this.quoteType : null, showCurrentMonthMedigapQuote, true, true, this.Spa_Security_DOB_Enabled, dateOfBirth)
                .then(() => {
                this.redirectOnSuccess();
            })
                .catch(async (error) => {
                this.handleError(error);
            })
                .finally(() => {
                this.spinnerService.hide(SpinnerEvent.BENEFICIARY_FORM_SUBMIT);
            });
        }
        else if (this.isValidDateOfBirth && this.soaFormAuthorization) {
            this.spinnerService.show(SpinnerEvent.BENEFICIARY_FORM_SUBMIT);
            const authCode = this.beneficiaryAuthorizationForm.value.authorizationCode;
            const authInfo = {
                auth1: this.soaGuid,
                auth2: authCode
            };
            this.soaFacade
                .createSOASession(authInfo, this.agentId, this.Spa_Security_DOB_Enabled, dateOfBirth)
                .then(() => {
                this.redirectOnSuccessToSOAForm();
            })
                .catch(async (error) => {
                this.handleError(error);
            })
                .finally(() => {
                this.spinnerService.hide(SpinnerEvent.BENEFICIARY_FORM_SUBMIT);
            });
        }
        else if (!this.Spa_Site_EnableQuoteSummary && !this.soaFormAuthorization) {
            this.siteService.setConsumerSiteType(ConsumerSiteType.ANONYMOUS);
            this.quoteService.resetBeneficiaryQuoteDetails();
            this.quoteFacade.logOut();
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }
    isBeneficiaryFormValid(isAuthorizationCodeInvalid) {
        // if disclaimer is not enabled and invalid disclaimer no need to show validation
        if (!isAuthorizationCodeInvalid && !this.Spa_Beneficiary_DisclaimerSection_Enabled && !this.isDisclaimerValid) {
            this.isValid = true;
        }
        // do not authentication/intiate request if pin/dob or disclaimer is invalid (if enabled)
        if (!isAuthorizationCodeInvalid && this.Spa_Beneficiary_DisclaimerSection_Enabled && this.isDisclaimerValid) {
            this.isValid = true;
        }
        if (isAuthorizationCodeInvalid || (!this.isDisclaimerValid && this.Spa_Beneficiary_DisclaimerSection_Enabled)) {
            this.checkFocus = true;
        }
    }
    async handleError(error) {
        const errorBody = error?.error;
        if (errorBody?.Status === HttpStatusCode.NOT_FOUND && errorBody?.Title === AgentSellingPermissionError.NO_ASP_ALP_TITLE) {
            // NO_ASP_ALP occurs when agent has ALP/ASP and no plans are returned. If any plans returned, exception will not be thrown.
            // We only want to pass planIds for send enrollment,
            // otherwise the quoted plan will show in quote summary and there will be no agent in session
            const enrollPlanIds = this.accessType === BeneficiaryRedirectTypes.ENROLLMENT ? this.quotedPlanIds : null;
            await this.quoteFacade.handleAgentNoPlanPermission(enrollPlanIds).then(() => {
                this.redirectOnSuccess();
            });
        }
        else if (errorBody?.Status === HttpStatusCode.UNAUTHORIZED && errorBody?.Title === AuthPageErrorTitle.INVALID_AUTH_CODE) {
            this.setInvalidAuthCodeError();
        }
        else if (errorBody?.Status === HttpStatusCode.UNAUTHORIZED && errorBody?.Title === AuthPageErrorTitle.INVALID_DOB) {
            this.setInvalidDateOfBirthError();
        }
        else {
            this.setInvalidAuthCodeError();
        }
    }
    setInvalidAuthCodeError() {
        this.isNotAuthorized = true;
        const firstInvalidRetentionLoginInput = document.querySelector('#beneficiary_authorization_code');
        const firstInvalidElement = firstInvalidRetentionLoginInput;
        firstInvalidElement.focus();
        this.cdr.markForCheck();
    }
    setInvalidDateOfBirthError() {
        this.isValidBeneficiaryDateOfBirth = false;
        const firstInvalidRetentionLoginInput = document.querySelector('#date_of_birth');
        const firstInvalidElement = firstInvalidRetentionLoginInput;
        firstInvalidElement.focus();
        this.cdr.markForCheck();
    }
    updateMemberIdTag(memberId) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.MEMBER_ID]: memberId
        };
    }
    setTransactionGuid(planId) {
        if (planId && !this.transactionGuid) {
            this.transactionGuid = this.enrollmentFormService.getTransactionGuidFromPartialEnrollment(planId);
        }
    }
    getBeneficiaryLoaderText() {
        return this.navigationUtilityService.getLoaderTextByPageTag(this.Spa_Site_Loader_Message_Json, PageTags.QUOTE_SUMMARY);
    }
    async handleDecryption(encryptedValuesFromURL) {
        return await this.soaFormFacade.getDecrypt$(encryptedValuesFromURL).toPromise();
    }
    setValuesFromDecryptedData(params) {
        if (params.planId) {
            this.enrollmentFormService.setActiveEnrollmentKey(params.planId);
        }
        this.planId = params.planId;
        this.planType = params.planType;
        this.ssoName = params.SSOName ?? params.ssoName;
        this.agentId = params.AgentGuid ?? params.agentGuid;
        this.quoteId = params.quoteId;
        this.quickQuoteGuid = params.QuickQuoteGuid;
        this.accessType = params.accessType;
        this.isShortForm = params?.shortForm?.toLowerCase() === 'true';
        this.showMeetWithAgentSection = params.showMeetWithAgent !== 'false';
        this.showAgentProfilePicture = params.showAgentProfilePicture !== 'false';
        this.hidePdfAgentData = params.hidePdfAgentData === 'true';
        this.quoteType = this.getQuoteType(params);
        this.transactionGuid = params.transactionGuid;
        this.storageId = this.quoteType === QuoteType.PCAPIENROLLMENTQUOTE ? params.storageId : '';
        this.sourceSiteId = params.SourceSiteId;
        this.soaGuid = params.soaGuid;
        this.getAgentGreetingText();
    }
};
BeneficiaryComponent.ɵfac = function BeneficiaryComponent_Factory(t) { return new (t || BeneficiaryComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i1.QuoteService), i0.ɵɵdirectiveInject(i1.ImageService), i0.ɵɵdirectiveInject(QuoteFacade), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(i1.PlanCompareApiService), i0.ɵɵdirectiveInject(i1.PhoneUtilityService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(SoaFormFacade), i0.ɵɵdirectiveInject(SOAFacade), i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService), i0.ɵɵdirectiveInject(i2.Store)); };
BeneficiaryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BeneficiaryComponent, selectors: [["vnext-beneficiary"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 35, vars: 27, consts: [["vnextGoogleTagManager", "", 1, "p-0", "Spa_Style_Banner_Background", 3, "saveDefaultValues"], [1, "container", "banner", "d-none", "d-sm-block"], [1, "beneficiary-banner-img", 3, "ngStyle"], [1, "container", "banner", "banner-mobile", "d-sm-none"], [1, "beneficiary-banner-img", "beneficiary-banner-img-mobile", 3, "ngStyle"], [1, "Spa_Style_Accent6_Background", "Spa_Style_Secondary_Text_Color", "quote-login-wrapper"], [1, "container"], [1, "row"], [4, "ngIf"], [1, "col-12", 3, "ngClass"], [1, "pt-3", "Spa_Style_H1", "Spa_Style_Secondary_Text_Color"], ["class", "Spa_Style_Primary pt-2", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["disableKeyDownSubmit", "", 3, "formGroup", "ngSubmit"], [1, "col-xs-12", "col-md-8"], ["id", "authorizationCodeFieldError", "role", "alert", "class", "error mt-2", 4, "ngIf"], [1, "form-group", "mt-2", "mb-2"], ["for", "beneficiary_authorization_code", 1, "Spa_Style_Secondary_Text_Color"], [1, "Spa_Style_Bold_Weight", 3, "ngClass"], ["class", "ml-1 Spa_Style_Small_Font Spa_Style_Bold_Weight", 3, "ngClass", 4, "liveEditProp"], [1, "row", "align-items-center"], [1, "col-md-6", "col-lg-3", "pl-0"], ["id", "beneficiary_authorization_code", "name", "authorizationCode", "type", "text", "formControlName", "authorizationCode", "autocomplete", "off", "required", "", "aria-describedby", "authorizationCodeFieldError", "aria-required", "true", 1, "authorization-code", 3, "ngClass"], ["class", "col-md-6 col-lg-9 pt-md-0 pt-2 mw-100 Spa_Style_Smaller_Font Spa_Style_Primary", 4, "liveEditProp"], ["class", "row", 4, "ngIf"], ["class", "form-group mt-1 mb-1", 4, "ngIf"], [1, "pt-2", "pb-3"], ["type", "submit", "class", "btn Spa_Style_PrimaryButton Spa_Style_Bold_Weight", 4, "liveEditProp"], ["class", "container pt-2", 4, "ngIf"], ["showPhoneOnDesktop", ""], ["class", "col-12 col-md-4 col-lg-3 agent-profile-container", 4, "ngIf"], [1, "col-12", "col-md-4", "col-lg-3", "agent-profile-container"], [3, "broker", "agentProfilePictureUrl"], ["navigationAdapter", "", 1, "Spa_Style_Primary", "pt-2", 3, "innerHtml"], ["id", "authorizationCodeFieldError", "role", "alert", 1, "error", "mt-2"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle", "mr-1"], [1, "sr-only"], [1, "ml-1", "Spa_Style_Small_Font", "Spa_Style_Bold_Weight", 3, "ngClass"], [1, "col-md-6", "col-lg-9", "pt-md-0", "pt-2", "mw-100", "Spa_Style_Smaller_Font", "Spa_Style_Primary"], ["id", "dateOfBirthFieldError", "role", "alert", "class", "error mt-2", 4, "ngIf"], ["role", "alert", "class", "error mt-2", 4, "ngIf"], ["for", "date_of_birth", 1, "Spa_Style_Secondary_Text_Color"], ["id", "date_of_birth", "name", "dateOfBirth", "type", "text", "inputmode", "numeric", "autocomplete", "off", "required", "", "aria-describedby", "dateOfBirthFieldError", "aria-required", "true", "formControlName", "dateOfBirth", 1, "date-of-birth", 3, "placeholder", "mask", "dropSpecialCharacters", "ngClass", "blur"], ["id", "dateOfBirthFieldError", "role", "alert", 1, "error", "mt-2"], ["role", "alert", 1, "error", "mt-2"], [1, "form-group", "mt-1", "mb-1"], ["role", "alert", "class", "error", "id", "agreeToDisclaimerFieldError", 4, "ngIf"], ["for", "beneficiary_disclaimer", 1, "Spa_Style_Secondary_Text_Color", "col-md-12"], ["id", "beneficiary_disclaimer", "type", "checkbox", "tabindex", "0", "name", "agreeToDisclaimer", "formControlName", "agreeToDisclaimer", "required", "", "aria-describedby", "agreeToDisclaimerFieldError", "role", "checkbox"], [1, "ml-1", "Spa_Style_Bold_Weight", 3, "ngClass"], ["class", "Spa_Style_Smaller_Font d-inline mr-2", "navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], ["class", "d-inline-block", 4, "ngIf"], ["role", "alert", "id", "agreeToDisclaimerFieldError", 1, "error"], ["navigationAdapter", "", 1, "Spa_Style_Smaller_Font", "d-inline", "mr-2", 3, "innerHTML"], [1, "d-inline-block"], [3, "title", "keyNameForLiveEdit", "alwaysUnderlined", "href", "tag", "linkTarget", "customClass"], ["type", "submit", 1, "btn", "Spa_Style_PrimaryButton", "Spa_Style_Bold_Weight"], [1, "container", "pt-2"], [1, "col-12", "col-md-2", "col-lg-1", "mt-5", "text-center"], [1, "calendar-icon", "Spa_Style_Accent2", "Spa_Style_Largest_Font", "Spa_Style_Accent3_Border", "Spa_Style_Accent3_Color"], ["aria-hidden", "true", 1, "fas", "fa-calendar-alt"], [1, "col-12", "col-md-10", "col-lg-11", "mt-5"], ["class", "Spa_Style_H2", 4, "liveEditProp"], ["class", "Spa_Style_Smaller_Font", 4, "ngIf"], ["class", "Spa_Style_Smaller_Font no-translate-block", 4, "ngIf"], [1, "Spa_Style_H2"], [1, "Spa_Style_Smaller_Font"], [4, "ngIf", "ngIfElse"], ["class", "Spa_Style_Primary_Link_Color text-underline", 3, "href", 4, "liveEditProp"], [1, "Spa_Style_Primary_Link_Color", "text-underline", 3, "href"], [1, "Spa_Style_Smaller_Font", "no-translate-block"], [4, "liveEditProp"]], template: function BeneficiaryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵelement(2, "div", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelement(4, "div", 4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div", 5)(6, "div", 6)(7, "div", 7);
        i0.ɵɵtemplate(8, BeneficiaryComponent_ng_container_8_Template, 3, 3, "ng-container", 8);
        i0.ɵɵelementStart(9, "div", 9)(10, "h1", 10);
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, BeneficiaryComponent_div_12_Template, 2, 4, "div", 11);
        i0.ɵɵelementStart(13, "form", 12);
        i0.ɵɵlistener("ngSubmit", function BeneficiaryComponent_Template_form_ngSubmit_13_listener() { return ctx.submitForm(); });
        i0.ɵɵelementStart(14, "div", 7)(15, "div", 13);
        i0.ɵɵtemplate(16, BeneficiaryComponent_div_16_Template, 5, 2, "div", 14);
        i0.ɵɵelementStart(17, "div", 15)(18, "div")(19, "label", 16)(20, "span", 17);
        i0.ɵɵtext(21, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(22, BeneficiaryComponent_span_22_Template, 2, 4, "span", 18);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(23, "div", 6)(24, "div", 19)(25, "div", 20);
        i0.ɵɵelement(26, "input", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(27, BeneficiaryComponent_div_27_Template, 2, 1, "div", 22);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵtemplate(28, BeneficiaryComponent_div_28_Template, 15, 13, "div", 23);
        i0.ɵɵtemplate(29, BeneficiaryComponent_div_29_Template, 10, 7, "div", 24);
        i0.ɵɵelementStart(30, "div", 25);
        i0.ɵɵtemplate(31, BeneficiaryComponent_button_31_Template, 2, 1, "button", 26);
        i0.ɵɵelementEnd()()()()()();
        i0.ɵɵtemplate(32, BeneficiaryComponent_div_32_Template, 3, 3, "div", 27);
        i0.ɵɵtemplate(33, BeneficiaryComponent_ng_template_33_Template, 1, 1, "ng-template", null, 28, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵproperty("saveDefaultValues", true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(17, _c3$z, ctx.backgroundImageURL));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(19, _c3$z, ctx.mobileBackgroundImageURL));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.showAgentProfilePicture);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(21, _c4$j, ctx.showAgentProfilePicture));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.agentGreetingText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_Beneficiary_Introduction_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.beneficiaryAuthorizationForm);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isNotAuthorized || (ctx.beneficiaryAuthorizationForm.controls.authorizationCode == null ? null : ctx.beneficiaryAuthorizationForm.controls.authorizationCode.invalid) && ctx.formSubmitted);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(23, _c1$1n, (ctx.beneficiaryAuthorizationForm.controls.authorizationCode == null ? null : ctx.beneficiaryAuthorizationForm.controls.authorizationCode.invalid) && ctx.formSubmitted));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_Beneficiary_AuthorizationCode_Text");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(25, _c2$Q, (ctx.beneficiaryAuthorizationForm.controls.authorizationCode == null ? null : ctx.beneficiaryAuthorizationForm.controls.authorizationCode.invalid) && ctx.formSubmitted));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_Beneficiary_AuthorizationCode_Hint_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Security_DOB_Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Beneficiary_DisclaimerSection_Enabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_Beneficiary_ViewQuote_Button_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showMeetWithAgentSection);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$2.NgStyle, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.CheckboxControlValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.RequiredValidator, i4.CheckboxRequiredValidator, i4.FormGroupDirective, i4.FormControlName, LinkComponent, NavigationAdapterDirective, LiveEditPropDirective, FormInputSubmitDirective, GoogleTagManagerDirective, IconAriaAttributesDirective, i8.MaskDirective, AgentProfilePictureComponent, i1$2.AsyncPipe, SafePipe], styles: [".banner[_ngcontent-%COMP%]{width:100%;max-width:1400px;height:450px;margin:0 auto;padding:0;position:relative;background-color:var(--static-Spa_Style_Gray1)}.banner-mobile[_ngcontent-%COMP%]{height:300px}.beneficiary-banner-img[_ngcontent-%COMP%]{position:absolute;left:0;top:0;width:100%;height:100%;background-repeat:no-repeat;background-size:cover;background-position:left center;background-color:var(--static-Spa_Style_Gray1)}.beneficiary-banner-img-mobile[_ngcontent-%COMP%]{background-position:center}.beneficiary-banner-img[_ngcontent-%COMP%]:after, .beneficiary-banner-img[_ngcontent-%COMP%]:before{content:\"\";position:absolute;height:450px;width:500px}.beneficiary-banner-img[_ngcontent-%COMP%]:after{left:-340px;background:linear-gradient(90deg,var(--static-Spa_Style_Gray1) 0%,var(--static-Spa_Style_Gray1) 76%,rgba(0,0,0,0) 100%)}.beneficiary-banner-img[_ngcontent-%COMP%]:before{right:-340px;background:linear-gradient(270deg,var(--static-Spa_Style_Gray1) 0%,var(--static-Spa_Style_Gray1) 76%,rgba(0,0,0,0) 100%)}@media (min-width: 576px){.beneficiary-banner-img[_ngcontent-%COMP%]{background-position-x:center}}@media (min-width: 768px){.beneficiary-banner-img[_ngcontent-%COMP%]{background-position-x:-350px}}@media (min-width: 992px){.beneficiary-banner-img[_ngcontent-%COMP%]{background-position-x:-150px}}@media (min-width: 1201px){.beneficiary-banner-img[_ngcontent-%COMP%]{background-position-x:left}}@media (max-width: 1399.98px){.beneficiary-banner-img[_ngcontent-%COMP%]:after, .beneficiary-banner-img[_ngcontent-%COMP%]:before{display:none}}.authorization-code[_ngcontent-%COMP%], .date-of-birth[_ngcontent-%COMP%]{width:120px}.calendar-icon[_ngcontent-%COMP%]{border-radius:48px;border:solid 1px var(--static-Spa_Style_Accent3);padding:6px 11px;display:inline;text-align:center}.error[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Error_On_Dark)}.error-border[_ngcontent-%COMP%]{border:2px solid var(--static-Spa_Style_Error_On_Dark)}.agent-profile-container[_ngcontent-%COMP%]{position:relative;height:170px}@media (max-width: 767.9px){.agent-profile-container[_ngcontent-%COMP%]{height:110px}}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], BeneficiaryComponent.prototype, "Spa_Site_SiteType", void 0);
__decorate([
    GlobalResource()
], BeneficiaryComponent.prototype, "Spa_Beneficiary_AuthorizationPage_Background_Url", void 0);
__decorate([
    GlobalResource()
], BeneficiaryComponent.prototype, "Spa_Beneficiary_AuthorizationPage_Background_MobileUrl", void 0);
__decorate([
    GlobalResource()
], BeneficiaryComponent.prototype, "Spa_Beneficiary_AuthorizationPage_Enabled", void 0);
__decorate([
    GlobalResource()
], BeneficiaryComponent.prototype, "Spa_Beneficiary_DisclaimerSection_Enabled", void 0);
__decorate([
    GlobalResource()
], BeneficiaryComponent.prototype, "Spa_Beneficiary_ViewDetails_Link_Enabled", void 0);
__decorate([
    GlobalResource()
], BeneficiaryComponent.prototype, "Spa_Beneficiary_ViewDetails_Link_Url", void 0);
__decorate([
    GlobalResource()
], BeneficiaryComponent.prototype, "Spa_Beneficiary_AuthorizationCode_Error_Text", void 0);
__decorate([
    GlobalResource()
], BeneficiaryComponent.prototype, "Spa_Beneficiary_Disclaimer_Error_Text", void 0);
__decorate([
    GlobalResource()
], BeneficiaryComponent.prototype, "Spa_Site_EnableQuoteSummary", void 0);
__decorate([
    GlobalResource()
], BeneficiaryComponent.prototype, "Spa_Site_ErrorKeyword_Text", void 0);
__decorate([
    GlobalResource()
], BeneficiaryComponent.prototype, "Spa_Site_Is_BLAM", void 0);
__decorate([
    GlobalResource()
], BeneficiaryComponent.prototype, "Spa_Site_Loader_Message_Json", void 0);
__decorate([
    GlobalResource()
], BeneficiaryComponent.prototype, "Spa_Agency_Consumer_Resource_Sharing_Enabled", void 0);
__decorate([
    GlobalResource()
], BeneficiaryComponent.prototype, "Spa_AgencyContact_Consumer_Resource_Sharing_Enabled", void 0);
__decorate([
    PlatformProp()
], BeneficiaryComponent.prototype, "Spa_Beneficiary_Greeting_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], BeneficiaryComponent.prototype, "Spa_Beneficiary_ViewDetails_Link_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], BeneficiaryComponent.prototype, "Spa_Beneficiary_Disclaimer_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], BeneficiaryComponent.prototype, "Spa_Beneficiary_Introduction_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], BeneficiaryComponent.prototype, "Spa_Beneficiary_AuthorizationCode_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], BeneficiaryComponent.prototype, "Spa_Beneficiary_AuthorizationCode_Hint_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], BeneficiaryComponent.prototype, "Spa_Beneficiary_ViewQuote_Button_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], BeneficiaryComponent.prototype, "Spa_Beneficiary_AgentDetails_Intro_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], BeneficiaryComponent.prototype, "Spa_Beneficiary_AgentDetails_Content", void 0);
__decorate([
    GlobalResource()
], BeneficiaryComponent.prototype, "Spa_Security_DOB_Enabled", void 0);
__decorate([
    GlobalResource()
], BeneficiaryComponent.prototype, "Spa_Security_DOB_Label", void 0);
__decorate([
    GlobalResource()
], BeneficiaryComponent.prototype, "Spa_Security_DOB_Instructional_Text", void 0);
__decorate([
    GlobalResource()
], BeneficiaryComponent.prototype, "Spa_Security_DOB_Error_Text", void 0);
__decorate([
    LiveEditInactive()
], BeneficiaryComponent.prototype, "redirectOnSuccess", null);
__decorate([
    LiveEditInactive()
], BeneficiaryComponent.prototype, "submitForm", null);
BeneficiaryComponent = __decorate([
    PlatformWidget
], BeneficiaryComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BeneficiaryComponent, [{
        type: Component,
        args: [{ selector: 'vnext-beneficiary', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"p-0 Spa_Style_Banner_Background\" vnextGoogleTagManager [saveDefaultValues]=\"true\">\r\n  <div class=\"container banner d-none d-sm-block\">\r\n    <div class=\"beneficiary-banner-img\" [ngStyle]=\"{ 'background-image': backgroundImageURL }\"></div>\r\n  </div>\r\n  <div class=\"container banner banner-mobile d-sm-none\">\r\n    <div class=\"beneficiary-banner-img beneficiary-banner-img-mobile\" [ngStyle]=\"{ 'background-image': mobileBackgroundImageURL }\"></div>\r\n  </div>\r\n</div>\r\n<div class=\"Spa_Style_Accent6_Background Spa_Style_Secondary_Text_Color quote-login-wrapper\">\r\n  <div class=\"container\">\r\n    <div class=\"row\">\r\n      <ng-container *ngIf=\"showAgentProfilePicture\">\r\n        <div class=\"col-12 col-md-4 col-lg-3 agent-profile-container\" *ngIf=\"brokerData$ | async as brokerData\">\r\n          <ng-container *ngIf=\"brokerData.data as broker\">\r\n            <vnext-agent-profile-picture [broker]=\"broker\" [agentProfilePictureUrl]=\"broker.agentPictureURL\"></vnext-agent-profile-picture>\r\n          </ng-container>\r\n        </div>\r\n      </ng-container>\r\n      <div class=\"col-12\" [ngClass]=\"{ ' col-md-8 col-lg-9': showAgentProfilePicture }\">\r\n        <h1 class=\"pt-3 Spa_Style_H1 Spa_Style_Secondary_Text_Color\">{{ agentGreetingText }}</h1>\r\n        <div\r\n          class=\"Spa_Style_Primary pt-2\"\r\n          *liveEditProp=\"'Spa_Beneficiary_Introduction_Text'\"\r\n          [innerHtml]=\"Spa_Beneficiary_Introduction_Text | safe : 'html'\"\r\n          navigationAdapter\r\n        ></div>\r\n        <form disableKeyDownSubmit [formGroup]=\"beneficiaryAuthorizationForm\" (ngSubmit)=\"submitForm()\">\r\n          <div class=\"row\">\r\n            <div class=\"col-xs-12 col-md-8\">\r\n              <div\r\n                id=\"authorizationCodeFieldError\"\r\n                role=\"alert\"\r\n                *ngIf=\"isNotAuthorized || (this.beneficiaryAuthorizationForm.controls.authorizationCode?.invalid && formSubmitted)\"\r\n                class=\"error mt-2\"\r\n              >\r\n                <i class=\"fas fa-exclamation-circle mr-1\" aria-hidden=\"true\"></i>\r\n                <span class=\"sr-only\">{{ Spa_Site_ErrorKeyword_Text }}</span\r\n                >{{ Spa_Beneficiary_AuthorizationCode_Error_Text }}\r\n              </div>\r\n              <div class=\"form-group mt-2 mb-2\">\r\n                <div>\r\n                  <label for=\"beneficiary_authorization_code\" class=\"Spa_Style_Secondary_Text_Color\">\r\n                    <span\r\n                      [ngClass]=\"{ error: this.beneficiaryAuthorizationForm.controls.authorizationCode?.invalid && formSubmitted }\"\r\n                      class=\"Spa_Style_Bold_Weight\"\r\n                      >*</span\r\n                    >\r\n                    <span\r\n                      *liveEditProp=\"'Spa_Beneficiary_AuthorizationCode_Text'\"\r\n                      class=\"ml-1 Spa_Style_Small_Font Spa_Style_Bold_Weight\"\r\n                      [ngClass]=\"{ 'label-invalid': getCodeStatus() }\"\r\n                      >{{ Spa_Beneficiary_AuthorizationCode_Text }}</span\r\n                    >\r\n                  </label>\r\n                </div>\r\n                <div class=\"container\">\r\n                  <div class=\"row align-items-center\">\r\n                    <div class=\"col-md-6 col-lg-3 pl-0\">\r\n                      <input\r\n                        id=\"beneficiary_authorization_code\"\r\n                        name=\"authorizationCode\"\r\n                        type=\"text\"\r\n                        formControlName=\"authorizationCode\"\r\n                        class=\"authorization-code\"\r\n                        autocomplete=\"off\"\r\n                        required\r\n                        aria-describedby=\"authorizationCodeFieldError\"\r\n                        aria-required=\"true\"\r\n                        [ngClass]=\"{\r\n                          'error-border': this.beneficiaryAuthorizationForm.controls.authorizationCode?.invalid && formSubmitted\r\n                        }\"\r\n                      />\r\n                    </div>\r\n                    <div\r\n                      *liveEditProp=\"'Spa_Beneficiary_AuthorizationCode_Hint_Text'\"\r\n                      class=\"col-md-6 col-lg-9 pt-md-0 pt-2 mw-100 Spa_Style_Smaller_Font Spa_Style_Primary\"\r\n                    >\r\n                      {{ Spa_Beneficiary_AuthorizationCode_Hint_Text }}\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <!--Date Of Birth-->\r\n          <div *ngIf=\"Spa_Security_DOB_Enabled\" class=\"row\">\r\n            <div class=\"col-xs-12 col-md-8\">\r\n              <div\r\n                *ngIf=\"!isValidBeneficiaryDateOfBirth && isValidDateOfBirth && formSubmitted\"\r\n                id=\"dateOfBirthFieldError\"\r\n                role=\"alert\"\r\n                class=\"error mt-2\"\r\n              >\r\n                <i class=\"fas fa-exclamation-circle mr-1\" aria-hidden=\"true\"></i>\r\n                <span class=\"sr-only\">{{ Spa_Site_ErrorKeyword_Text }}</span\r\n                >{{ Spa_Security_DOB_Error_Text }}\r\n              </div>\r\n              <div *ngIf=\"!isValidDateOfBirth && dobError && formSubmitted\" role=\"alert\" class=\"error mt-2\">\r\n                <i class=\"fas fa-exclamation-circle mr-1\" aria-hidden=\"true\"></i>\r\n                {{ dobError }}\r\n              </div>\r\n\r\n              <div class=\"form-group mt-2 mb-2\">\r\n                <div>\r\n                  <label for=\"date_of_birth\" class=\"Spa_Style_Secondary_Text_Color\">\r\n                    <span\r\n                      [ngClass]=\"{ error: this.beneficiaryAuthorizationForm.controls.dateOfBirth?.invalid && formSubmitted }\"\r\n                      class=\"Spa_Style_Bold_Weight\"\r\n                      >*</span\r\n                    >\r\n                    <span\r\n                      *liveEditProp=\"'Spa_Security_DOB_Label'\"\r\n                      class=\"ml-1 Spa_Style_Small_Font Spa_Style_Bold_Weight\"\r\n                      [ngClass]=\"{ 'label-invalid': beneficiaryAuthorizationForm.controls.dateOfBirth?.invalid && formSubmitted }\"\r\n                      >{{ Spa_Security_DOB_Label }}</span\r\n                    >\r\n                  </label>\r\n                </div>\r\n                <div class=\"container\">\r\n                  <div class=\"row align-items-center\">\r\n                    <div class=\"col-md-6 col-lg-3 pl-0\">\r\n                      <input\r\n                        id=\"date_of_birth\"\r\n                        name=\"dateOfBirth\"\r\n                        type=\"text\"\r\n                        class=\"date-of-birth\"\r\n                        inputmode=\"numeric\"\r\n                        autocomplete=\"off\"\r\n                        required\r\n                        aria-describedby=\"dateOfBirthFieldError\"\r\n                        aria-required=\"true\"\r\n                        [placeholder]=\"dateFormat\"\r\n                        [mask]=\"dateMaskFormat\"\r\n                        formControlName=\"dateOfBirth\"\r\n                        [dropSpecialCharacters]=\"false\"\r\n                        [ngClass]=\"{\r\n                          'error-border': beneficiaryAuthorizationForm.controls.dateOfBirth?.invalid && formSubmitted\r\n                        }\"\r\n                        (blur)=\"getDateValidation(beneficiaryAuthorizationForm.controls.dateOfBirth?.value)\"\r\n                      />\r\n                    </div>\r\n                    <div\r\n                      *liveEditProp=\"'Spa_Security_DOB_Instructional_Text'\"\r\n                      class=\"col-md-6 col-lg-9 pt-md-0 pt-2 mw-100 Spa_Style_Smaller_Font Spa_Style_Primary\"\r\n                    >\r\n                      {{ Spa_Security_DOB_Instructional_Text }}\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <!--Disclaimer-->\r\n          <div class=\"form-group mt-1 mb-1\" *ngIf=\"Spa_Beneficiary_DisclaimerSection_Enabled\">\r\n            <div role=\"alert\" *ngIf=\"getDisclaimerStatus()\" class=\"error\" id=\"agreeToDisclaimerFieldError\">\r\n              <i class=\"fas fa-exclamation-circle mr-1\" aria-hidden=\"true\"></i>\r\n              <span class=\"sr-only\">{{ Spa_Site_ErrorKeyword_Text }}</span> {{ Spa_Beneficiary_Disclaimer_Error_Text }}\r\n            </div>\r\n            <ng-container>\r\n              <div class=\"row\">\r\n                <label for=\"beneficiary_disclaimer\" class=\"Spa_Style_Secondary_Text_Color col-md-12\">\r\n                  <input\r\n                    id=\"beneficiary_disclaimer\"\r\n                    type=\"checkbox\"\r\n                    tabindex=\"0\"\r\n                    name=\"agreeToDisclaimer\"\r\n                    formControlName=\"agreeToDisclaimer\"\r\n                    required\r\n                    aria-describedby=\"agreeToDisclaimerFieldError\"\r\n                    role=\"checkbox\"\r\n                    [attr.aria-checked]=\"\r\n                      beneficiaryAuthorizationForm &&\r\n                      beneficiaryAuthorizationForm.controls &&\r\n                      beneficiaryAuthorizationForm.controls.agreeToDisclaimer\r\n                        ? beneficiaryAuthorizationForm.controls.agreeToDisclaimer.valid\r\n                        : 'false'\r\n                    \"\r\n                  />\r\n                  <span class=\"ml-1 Spa_Style_Bold_Weight\" [ngClass]=\"{ error: getDisclaimerStatus() }\">*</span>\r\n                  <span\r\n                    class=\"Spa_Style_Smaller_Font d-inline mr-2\"\r\n                    *liveEditProp=\"'Spa_Beneficiary_Disclaimer_Text'\"\r\n                    [innerHTML]=\"Spa_Beneficiary_Disclaimer_Text | safe : 'html'\"\r\n                    navigationAdapter\r\n                  ></span>\r\n                  <span class=\"d-inline-block\" *ngIf=\"Spa_Beneficiary_ViewDetails_Link_Enabled\">\r\n                    <vnext-link\r\n                      [title]=\"Spa_Beneficiary_ViewDetails_Link_Text\"\r\n                      [keyNameForLiveEdit]=\"'Spa_Beneficiary_ViewDetails_Link_Text'\"\r\n                      [alwaysUnderlined]=\"true\"\r\n                      [href]=\"Spa_Beneficiary_ViewDetails_Link_Url[0].href\"\r\n                      [tag]=\"Spa_Beneficiary_ViewDetails_Link_Url[0].tag\"\r\n                      [linkTarget]=\"Spa_Beneficiary_ViewDetails_Link_Url[0].target\"\r\n                      [customClass]=\"'Spa_Style_LinkOnDarkBackgrounds'\"\r\n                    >\r\n                    </vnext-link>\r\n                  </span>\r\n                </label>\r\n              </div>\r\n            </ng-container>\r\n          </div>\r\n          <div class=\"pt-2 pb-3\">\r\n            <button\r\n              type=\"submit\"\r\n              *liveEditProp=\"'Spa_Beneficiary_ViewQuote_Button_Text'\"\r\n              class=\"btn Spa_Style_PrimaryButton Spa_Style_Bold_Weight\"\r\n            >\r\n              {{ Spa_Beneficiary_ViewQuote_Button_Text }}\r\n            </button>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"container pt-2\" *ngIf=\"showMeetWithAgentSection\">\r\n  <div class=\"row\" *ngIf=\"(brokerData$ | async)?.data\">\r\n    <div class=\"col-12 col-md-2 col-lg-1 mt-5 text-center\">\r\n      <div class=\"calendar-icon Spa_Style_Accent2 Spa_Style_Largest_Font Spa_Style_Accent3_Border Spa_Style_Accent3_Color\">\r\n        <i class=\"fas fa-calendar-alt\" aria-hidden=\"true\"></i>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"col-12 col-md-10 col-lg-11 mt-5\">\r\n      <h2 class=\"Spa_Style_H2\" *liveEditProp=\"'Spa_Beneficiary_AgentDetails_Intro_Text'\">{{ agentDetailsMeetText$ | async }}</h2>\r\n      <div class=\"Spa_Style_Smaller_Font\" *ngIf=\"brokerData?.data?.phoneNumber\">\r\n        <span>\r\n          {{ agentDetailsCallText }}\r\n        </span>\r\n        <ng-container *ngIf=\"isMobile; else showPhoneOnDesktop\">\r\n          <a\r\n            href=\"tel: {{ brokerData?.data?.phoneNumber }}\"\r\n            *liveEditProp=\"'Spa_Beneficiary_AgentDetails_Content'\"\r\n            class=\"Spa_Style_Primary_Link_Color text-underline\"\r\n            [attr.aria-label]=\"brokerData?.data?.agencyName + ': ' + brokerData?.data?.phoneNumber\"\r\n          >\r\n            <span>\r\n              {{ agentDetailsPhoneNumber }}\r\n            </span>\r\n          </a>\r\n        </ng-container>\r\n      </div>\r\n      <div class=\"Spa_Style_Smaller_Font no-translate-block\" *ngIf=\"(brokerData$ | async)?.data.emailAddress\">\r\n        {{ (brokerData$ | async)?.data.emailAddress }}\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<ng-template #showPhoneOnDesktop>\r\n  <div *liveEditProp=\"'Spa_Beneficiary_AgentDetails_Content'\">\r\n    <span>\r\n      {{ agentDetailsPhoneNumber }}\r\n    </span>\r\n  </div>\r\n</ng-template>\r\n", styles: [".banner{width:100%;max-width:1400px;height:450px;margin:0 auto;padding:0;position:relative;background-color:var(--static-Spa_Style_Gray1)}.banner-mobile{height:300px}.beneficiary-banner-img{position:absolute;left:0;top:0;width:100%;height:100%;background-repeat:no-repeat;background-size:cover;background-position:left center;background-color:var(--static-Spa_Style_Gray1)}.beneficiary-banner-img-mobile{background-position:center}.beneficiary-banner-img:after,.beneficiary-banner-img:before{content:\"\";position:absolute;height:450px;width:500px}.beneficiary-banner-img:after{left:-340px;background:linear-gradient(90deg,var(--static-Spa_Style_Gray1) 0%,var(--static-Spa_Style_Gray1) 76%,rgba(0,0,0,0) 100%)}.beneficiary-banner-img:before{right:-340px;background:linear-gradient(270deg,var(--static-Spa_Style_Gray1) 0%,var(--static-Spa_Style_Gray1) 76%,rgba(0,0,0,0) 100%)}@media (min-width: 576px){.beneficiary-banner-img{background-position-x:center}}@media (min-width: 768px){.beneficiary-banner-img{background-position-x:-350px}}@media (min-width: 992px){.beneficiary-banner-img{background-position-x:-150px}}@media (min-width: 1201px){.beneficiary-banner-img{background-position-x:left}}@media (max-width: 1399.98px){.beneficiary-banner-img:after,.beneficiary-banner-img:before{display:none}}.authorization-code,.date-of-birth{width:120px}.calendar-icon{border-radius:48px;border:solid 1px var(--static-Spa_Style_Accent3);padding:6px 11px;display:inline;text-align:center}.error{color:var(--static-Spa_Style_Error_On_Dark)}.error-border{border:2px solid var(--static-Spa_Style_Error_On_Dark)}.agent-profile-container{position:relative;height:170px}@media (max-width: 767.9px){.agent-profile-container{height:110px}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.NavigationService }, { type: i2$1.ActivatedRoute }, { type: i1.QuoteService }, { type: i1.ImageService }, { type: QuoteFacade }, { type: i1.SiteService }, { type: i1.SpinnerService }, { type: i1.EnrollmentFormService }, { type: i1.PlanCompareApiService }, { type: i1.PhoneUtilityService }, { type: AnalyticsService }, { type: i1.LocaleService }, { type: i1.NavigationUtilityService }, { type: i1.ConfigResourceService }, { type: SoaFormFacade }, { type: SOAFacade }, { type: i1.AgentService }, { type: i1.ResponsiveLayoutService }, { type: i2.Store }]; }, { Spa_Site_SiteType: [], Spa_Beneficiary_AuthorizationPage_Background_Url: [], Spa_Beneficiary_AuthorizationPage_Background_MobileUrl: [], Spa_Beneficiary_AuthorizationPage_Enabled: [], Spa_Beneficiary_DisclaimerSection_Enabled: [], Spa_Beneficiary_ViewDetails_Link_Enabled: [], Spa_Beneficiary_ViewDetails_Link_Url: [], Spa_Beneficiary_AuthorizationCode_Error_Text: [], Spa_Beneficiary_Disclaimer_Error_Text: [], Spa_Site_EnableQuoteSummary: [], Spa_Site_ErrorKeyword_Text: [], Spa_Site_Is_BLAM: [], Spa_Site_Loader_Message_Json: [], Spa_Agency_Consumer_Resource_Sharing_Enabled: [], Spa_AgencyContact_Consumer_Resource_Sharing_Enabled: [], Spa_Beneficiary_Greeting_Text: [], Spa_Beneficiary_ViewDetails_Link_Text: [], Spa_Beneficiary_Disclaimer_Text: [], Spa_Beneficiary_Introduction_Text: [], Spa_Beneficiary_AuthorizationCode_Text: [], Spa_Beneficiary_AuthorizationCode_Hint_Text: [], Spa_Beneficiary_ViewQuote_Button_Text: [], Spa_Beneficiary_AgentDetails_Intro_Text: [], Spa_Beneficiary_AgentDetails_Content: [], Spa_Security_DOB_Enabled: [], Spa_Security_DOB_Label: [], Spa_Security_DOB_Instructional_Text: [], Spa_Security_DOB_Error_Text: [], redirectOnSuccess: [], submitForm: [] }); })();

class PlanCardBaseComponent {
    // init a PlanCardComponent instance
    // TODO: need to declare the control data from resources as private static class data shared by all instances)
    constructor(navigationService, planFacade, demographicService, riderFacade, planCompareService, responsiveLayoutService, planCardFacade, quoteService, analyticsService, localeService, cdr, planDetailsFacade, guidedHelpService) {
        this.navigationService = navigationService;
        this.planFacade = planFacade;
        this.demographicService = demographicService;
        this.riderFacade = riderFacade;
        this.planCompareService = planCompareService;
        this.responsiveLayoutService = responsiveLayoutService;
        this.planCardFacade = planCardFacade;
        this.quoteService = quoteService;
        this.analyticsService = analyticsService;
        this.localeService = localeService;
        this.cdr = cdr;
        this.planDetailsFacade = planDetailsFacade;
        this.guidedHelpService = guidedHelpService;
        this.Spa_Site_ShowDrugAlternatives_Enabled = false;
        this.Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled = false;
        this.showStarRating = true;
        this.showPreferenceScore = false;
        this.CSNPEnabled = false;
        this.DSNPEnabled = false;
        this.ISNPEnabled = false;
        this.CSNPText = '';
        this.DSNPText = '';
        this.ISNPText = '';
        this.medicineCabinet = [];
        this.showAddToCartForAncillaryPlans = true;
        this.showAncillaryIcons = false;
        this.loaderIconEnabled = false;
        this.Spa_PlanCard_SupplementalBenefits_Enabled = false;
        this.Spa_PlanCard_SupplementalBenefits_List = [];
        this.showRatingMethod = false;
        this.Spa_RatingMethod_AttainedAge_Tooltip_Text = '';
        this.Spa_RatingMethod_IssueAge_Tooltip_Text = '';
        this.Spa_RatingMethod_CommunityRated_Tooltip_Text = '';
        this.showPlanYear = false;
        this.enableDSNPCodes = false;
        this.newPlanCardDesignEnabled = false;
        this.planBenefitHighlightItems = [];
        this.waiverStateRiderTooltips = [];
        this.isNonCommissionableFlagCheckEnabled = false;
        this.quoteClicked = new EventEmitter();
        this.quoteGroupChanged = new EventEmitter();
        this.showComboToolTip = false;
        this.isAddToQuoteAvailable = false;
        this.translatedDSNPCodes = '';
        this.defaultPlanLabelCustomClass = 'col-5 col-sm-4 col-lg-3';
        this.notLicensedPlanLabelCustomClass = 'col-5 col-sm-4';
        this.medSupPaymentMethodEnum = MedSupPaymentMethod;
        this.planTypeAbbreviation = PlanTypeAbbreviation;
        this.showMedSupAddOnCoverageText = false;
        this.planType = PlanType;
        this.planSubType = PlanSubTypes;
        this.isDentalPlan = false;
        this.isVisionPlan = false;
        this.isHospitalCare = false;
        this.isAncillary = false;
        this.displayLinkBorder = false;
        this.isClientDefinedPlanOption = false;
        this.planDetailsButtonClass = '';
        this.hideCompareBox = false;
        this.disabledTypesForPlanCompare = [PlanTypeAbbreviation.HC, PlanTypeAbbreviation.DENTAL, PlanTypeAbbreviation.VISION];
        this.linkRoles = LinkRoles;
        this.showPreferences = true;
        this.subscriptions = new Subscription();
    }
    // split out the benefit identifiers for each plan type from the associated resource
    ngOnInit() {
        this.riderDisplayMap = {
            [PlanTypeAbbreviation.MA]: this.Spa_PlanCard_ShowRidersOnMACards,
            [PlanTypeAbbreviation.MAPD]: this.Spa_PlanCard_ShowRidersOnMAPDCards,
            [PlanTypeAbbreviation.PDP]: this.Spa_PlanCard_ShowRidersOnPDPCards,
            [PlanTypeAbbreviation.MEDIGAP]: this.Spa_PlanCard_ShowRidersOnMEDIGAPCards,
            [PlanTypeAbbreviation.DENTAL]: this.Spa_PlanCard_ShowRidersOnDentalCards,
            [PlanTypeAbbreviation.VISION]: this.Spa_PlanCard_ShowRidersOnVisionCards,
            [PlanTypeAbbreviation.HC]: this.Spa_PlanCard_ShowRidersOnHCCards
        };
        const selectedCounty = this.demographicService.getSelectedCounty();
        if (selectedCounty) {
            this.showMedSupAddOnCoverageText = this.demographicService.isWaiverStateWithoutRiderCategories(selectedCounty.state);
        }
        if (this.selectedCompareGroup) {
            this.currentGroup = this.compareGroups.filter(group => group.groupKey.values[0] === this.selectedCompareGroup.groupKey.values[0]);
        }
        this.subscriptions.add(combineLatest([this.responsiveLayoutService.isCompact$, this.responsiveLayoutService.isMedium$]).subscribe(([isCompact, isMedium]) => {
            this.isMobile = isCompact;
            this.isMedium = isMedium;
            this.addToQuoteWarningTooltip = { body: this.getQuoteWarningTooltip() };
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe(() => {
            this.premiumLabel = this.planFacade.getPremiumLabel();
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.planFacade.hasPremium$(this.plan).subscribe(hasPremium => {
            this.hasPremium = hasPremium;
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.guidedHelpService.getMedicineCabinet$().subscribe({
            next: medicines => {
                this.drugCount = medicines.length;
                this.cdr.markForCheck();
            }
        }));
        this.showComboToolTip =
            !this.showAncillaryIcons &&
                (this.plan.planSubType === PlanSubTypes.DentalVision ||
                    this.plan.planSubType === PlanSubTypes.DentalVisionHearing ||
                    this.plan.planSubType === PlanSubTypes.VisionDental ||
                    this.plan.planSubType === PlanSubTypes.VisionDentalHearing ||
                    this.plan.planSubType === PlanSubTypes.VisionHearing);
        this.customClass = this.isNotLicensedToSell ? this.notLicensedPlanLabelCustomClass : this.defaultPlanLabelCustomClass;
        this.drugCount = this.medicineCabinet.length;
        this.compareWarningTooltip = this.getCompareWarningTooltip();
        this.altPlanImgText = this.planCardFacade.getAltImgText(this.plan);
        this.isShoppingTalkingPointEnabled = this.planCardFacade.isShoppingTalkingPointEnabled();
    }
    ngOnChanges(changes) {
        const { plan, isMailOrderSelected, selectedPharmacy, selectedProviders, providerDetails, providersInNetworkText, providersNoDataText, pcpInNetworkText, pcpOutOfNetworkText, noProviderNetworkAccessText } = changes;
        if (plan && !_isEqual(plan.previousValue, plan.currentValue)) {
            this.displayLinkBorder = this.planFacade.canDisplayLinkBorder(plan.currentValue, this.displayOptionLabels);
            this.isClientDefinedPlanOption = this.planFacade.displayAsClientDefinedOption(plan.currentValue, this.displayOptionLabels);
            this.planLogo = this.planFacade.getPlanLogoUrl(this.plan);
            this.showPlanLogo = this.showLogo();
            this.pharmacyCoverageText = this.planCardFacade.getPharmacyCoverageText(this.plan, this.Spa_PlanCard_Pharmacy_Covered_Text);
            this.isAddToQuoteAvailable = this.planFacade.isAddToQuoteAvailable(this.plan.planTypeAbbreviation, this.plan, this.isRetentionSummaryPage);
            this.hideCompareBox =
                this.hideCompareBoxOverride !== undefined
                    ? this.hideCompareBoxOverride
                    : this.disabledTypesForPlanCompare.includes(plan.currentValue.planTypeAbbreviation);
            this.isHospitalCare = this.plan.planType === PlanType.HC;
            if (this.isHospitalCare) {
                this.planTotalPremium = this.planDetailsFacade.getTotalPremiumBySelectedRiders(this.plan);
            }
            else {
                this.planTotalPremium = this.planFacade.getTotalPremium([this.plan]);
            }
            if (this.snpPremiumRangeEnabled) {
                this.planPremiumInitialRange = this.planFacade.getPlanPremiumRange(this.plan, this.planTotalPremium);
            }
            this.isDentalPlan = this.plan.planType === PlanType.DENTAL;
            this.isVisionPlan = this.plan.planType === PlanType.VISION;
            this.isAncillary = this.isHospitalCare || this.isDentalPlan || this.isVisionPlan;
            this.addToCartEnabled = this.planFacade.isAddToCartAvailableForPlan(this.plan);
            this.planDetailsButtonClass = this.getPlanDetailsButtonClass();
            this.fullPlanId = this.planFacade.getFormattedFullPlanId(this.plan);
            this.updateAnnualCost();
            if (this.enableDSNPCodes) {
                this.translatedDSNPCodes = this.planFacade.getDSNPCodesAsTranslatedString(this.plan);
            }
        }
        if ((isMailOrderSelected?.currentValue !== undefined && isMailOrderSelected?.currentValue !== isMailOrderSelected?.previousValue) ||
            (selectedPharmacy?.currentValue && selectedPharmacy?.currentValue !== selectedPharmacy?.previousValue)) {
            this.updateAnnualCost();
        }
        if ((plan && !_isEqual(plan.previousValue, plan.currentValue)) ||
            (selectedProviders && !_isEqual(selectedProviders.previousValue, selectedProviders.currentValue)) ||
            (providerDetails && !_isEqual(providerDetails.previousValue, providerDetails.currentValue)) ||
            (providersInNetworkText && providersInNetworkText.previousValue !== providersInNetworkText.currentValue) ||
            (providersNoDataText && providersNoDataText.previousValue !== providersNoDataText.currentValue) ||
            (pcpInNetworkText && pcpInNetworkText.previousValue !== pcpInNetworkText.currentValue) ||
            (pcpOutOfNetworkText && pcpOutOfNetworkText.previousValue !== pcpOutOfNetworkText.currentValue) ||
            (noProviderNetworkAccessText && noProviderNetworkAccessText.previousValue !== noProviderNetworkAccessText.currentValue)) {
            if (this.plan && this.selectedProviders && this.providerDetails) {
                const canSellPlan = this.planFacade.canSellPlan(this.plan);
                this.planCardTile = {
                    plan: this.plan,
                    showProviderInNetworkOnOtherLocation: this.planCardFacade.getIsProviderInNetworkOnOtherLocation(this.plan.id, this.selectedProviders, this.providerDetails, this.plan.showProviderSearch, canSellPlan),
                    providersCoveredText: this.planCardFacade.getProviderCoveredText(this.plan.id, this.selectedProviders, this.providerDetails, this.providersInNetworkText, this.providersNoDataText, this.noProviderNetworkAccessText, this.plan.showProviderSearch, canSellPlan),
                    providerPcpText: this.planCardFacade.getProviderPcpText(this.plan.id, this.selectedProviders, this.providerDetails, this.pcpInNetworkText, this.pcpOutOfNetworkText, this.plan.showProviderSearch, canSellPlan)
                };
            }
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    updateAnnualCost() {
        this.planCardFacade
            .getAnnualCost$(this.plan, this.isMailOrderSelected)
            .pipe(take(1))
            .subscribe(value => {
            this.annualCost = value;
        });
    }
    getCoveredDrugsCount() {
        return this.planCardFacade.getCoveredDrugsCount(this.plan);
    }
    viewPlanDetailsPage(detailsPlan, isComparePlan = false) {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, isComparePlan ? DataLayerEvent.CLICK_PLANS_COMPARE : DataLayerEvent.CLICK_PLANS_VIEW_DETAILS);
        this.navigationService.navigateByPageTag(PageTags.PLAN_DETAILS, {
            queryParams: { id: detailsPlan.id }
        });
    }
    quoteClick() {
        this.planFacade.tagsToUpdate(DataLayerEvent.CLICK_PLANS_GET_QUOTE, this.plan.id, this.plan.planTypeAbbreviation, null, this.planFacade.isVbcAgreementExists(this.plan));
        this.quoteClicked.emit();
    }
    showRiderSection() {
        return (this.plan &&
            this.Spa_ShoppingCart_Enabled &&
            this.Spa_Site_ShowRidersOnPlanCards &&
            !this.Spa_Site_ShowPremiumAsAnnual &&
            this.riderDisplayMap[this.plan.planTypeAbbreviation] &&
            !!this.plan?.riders?.length &&
            (!this.plan.isNextYearPlan || this.plan.isPlanRolloverTerminated) &&
            !this.plan.isCurrentYearPlan);
    }
    showDrugCoverage(totalDrugsInCabinet) {
        // check that the we have the flag set and we have drugs in cabinet.
        // if no drugs in cabinet do not display section.
        return this.displayDrugsCovered && totalDrugsInCabinet !== 0;
    }
    getDrugCoverageText(totalDrugsInCabinet, plan) {
        // allow drug coverage text to be translatable.
        return this.planCardFacade.getDrugCoverageText(totalDrugsInCabinet, this.Spa_PlanCard_Drug_Covered_Text, plan, this.isMailOrderSelected);
    }
    isSelectedToCompare(plan) {
        if (!this.currentGroup) {
            return false;
        }
        this.currentGroup = this.compareGroups.filter(group => group.groupKey.values[0] === this.selectedCompareGroup.groupKey.values[0]);
        if (!this.currentGroup || this.currentGroup.length === 0) {
            return false;
        }
        const selectedPlans = this.currentGroup[0].items;
        if (!selectedPlans || selectedPlans.length === 0) {
            return false;
        }
        return selectedPlans.some(selectedPlan => selectedPlan.id === plan.id);
    }
    // event cannot have a type of Event as for some reason currentTarget is an EventTarget that does not have a property of checked
    // even though it is there in the console inspector.
    updatePlanToCompareGroup(plan, event, compareTooltip) {
        if (!this.currentGroup) {
            return;
        }
        const selectedPlans = this.getCurrentSelectedPlans();
        if (event.currentTarget.checked) {
            if (this.canAddPlanToCompare(selectedPlans)) {
                this.planCompareService.addPlanToCompareGroup([this.selectedCompareGroup], plan);
            }
            else {
                event.currentTarget.checked = false;
                compareTooltip.open();
            }
        }
        else {
            this.planCompareService.removePlanFromCompareGroup([this.selectedCompareGroup], plan);
        }
    }
    addPlanToHospitalIndemnityCompareGroup(plan, compareTooltip) {
        if (this.currentGroup) {
            const selectedPlans = this.getCurrentSelectedPlans();
            if (this.canAddPlanToCompare(selectedPlans)) {
                this.planCompareService.addPlanToCompareGroup([this.selectedCompareGroup], plan);
                this.quoteGroupChanged.emit();
            }
            else {
                compareTooltip.open();
            }
        }
    }
    removePlanToHospitalIndemnityCompareGroup(selectedCompareGroup, plan) {
        this.planCompareService.removePlanFromCompareGroup([selectedCompareGroup], plan);
        this.quoteGroupChanged.emit();
    }
    comparePlans(event, plan) {
        event.preventDefault();
        const selectedPlans = this.currentGroup[0].items;
        if (selectedPlans && selectedPlans.length === 1) {
            this.viewPlanDetailsPage(plan, true);
        }
        else {
            const planType = ANCILLARY_PLANS.includes(this.activeTabType) ? this.activeTabType : plan.planTypeAbbreviation;
            this.planCompareService.setPlanComparePlanType(planType);
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_COMPARE);
            this.navigationService.navigateByPageTag(PageTags.PLAN_COMPARISON);
        }
    }
    canAddPlanToCompare(selectedPlans) {
        return (selectedPlans &&
            (((this.isMobile || this.isMedium) && selectedPlans.length < this.Spa_PlanCard_CompareLimit_Mobile) ||
                (!this.isMobile && !this.isMedium && selectedPlans.length < this.Spa_PlanCard_CompareLimit_Desktop)));
    }
    addPlanToQuote(plan, addToQuoteTooltip) {
        addToQuoteTooltip.close();
        if (this.selectedQuoteGroup) {
            const filteredQuoteGroup = this.quoteGroups.filter(group => group.groupKey.values[0] === this.selectedQuoteGroup.groupKey.values[0]);
            if (filteredQuoteGroup && filteredQuoteGroup.length > 0 && filteredQuoteGroup[0].items.length < this.addToQuoteLimit) {
                this.quoteService.addPlanToQuoteGroup([this.selectedQuoteGroup], plan);
            }
            else {
                addToQuoteTooltip.open();
            }
        }
    }
    isPlanAddedToQuote(plan) {
        return this.plansSelectedToQuote.some(selectedPlan => selectedPlan.id === plan.id);
    }
    showPlanCoveragePreferences() {
        return !this.isNotLicensedToSell;
    }
    handleMissingImage(event) {
        event.target.className = '';
    }
    // Something about these requirements ended up not working with ngClass, so the logic was moved to here to help the template
    // and also be able to avoid some certain limits of ngClass
    getPlanDetailsButtonClass() {
        if (!(!this.addToCartEnabled && !this.isHospitalCare) &&
            !(!this.addToCartEnabled && this.isHospitalCare && !this.isAddToQuoteAvailable)) {
            return 's1 col-3 pl-md-0 pr-0 d-none d-md-block';
        }
        if (this.isHospitalCare && !this.isAddToQuoteAvailable && !this.addToCartEnabled) {
            return 's2 col-4';
        }
        if (!this.addToCartEnabled && !this.isHospitalCare) {
            return 's3 col-4 offset-3';
        }
        return '';
    }
    showSnpRangeModal() {
        this.planCardFacade.showSnpRangeModal();
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_SNP_PLAN_EXTRA_HELP_OPEN_MODAL_EVENT);
    }
    toggleViewAll() {
        this.showPreferences = !this.showPreferences;
    }
    getCurrentSelectedPlans() {
        this.currentGroup = this.compareGroups.filter(group => group.groupKey.values[0] === this.selectedCompareGroup.groupKey.values[0]);
        const selectedPlans = this.currentGroup[0]?.items || [];
        return selectedPlans;
    }
    getQuoteWarningTooltip() {
        return this.isMobile || this.isMedium
            ? this.Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip?.body?.replace('<quoteLimit>', this.Spa_PlanList_AddToQuote_Limit_Mobile.toString())
            : this.Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip?.body?.replace('<quoteLimit>', this.Spa_PlanList_AddToQuote_Limit.toString());
    }
    getCompareWarningTooltip() {
        return this.isMobile || this.isMedium
            ? this.Spa_PlanCard_CompareWarning_Tooltip?.replace('<compareLimit>', this.Spa_PlanCard_CompareLimit_Mobile.toString())
            : this.Spa_PlanCard_CompareWarning_Tooltip?.replace('<compareLimit>', this.Spa_PlanCard_CompareLimit_Desktop.toString());
    }
    showLogo() {
        if (ANCILLARY_PLANS.includes(this.activeTabType) || this.activeTabType === PlanTypeAbbreviation.HC) {
            return this.planLogo && this.Spa_Site_Show_AncillaryPlanLogo;
        }
        if (MEDICARE_PLAN_TYPES.includes(this.activeTabType) || this.activeTabType === PlanTypeAbbreviation.MEDIGAP) {
            return this.planLogo && this.Spa_Site_Show_PlanLogo;
        }
        return false;
    }
}
PlanCardBaseComponent.ɵfac = function PlanCardBaseComponent_Factory(t) { return new (t || PlanCardBaseComponent)(i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.DemographicService), i0.ɵɵdirectiveInject(RiderFacade), i0.ɵɵdirectiveInject(i1.PlanCompareService), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService), i0.ɵɵdirectiveInject(PlanCardFacade), i0.ɵɵdirectiveInject(i1.QuoteService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlanDetailsFacade), i0.ɵɵdirectiveInject(i1.GuidedHelpService)); };
PlanCardBaseComponent.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: PlanCardBaseComponent, inputs: { plan: "plan", activeTabType: "activeTabType", selectedCompareGroup: "selectedCompareGroup", compareGroups: "compareGroups", planBenefits: "planBenefits", displayDrugsCovered: "displayDrugsCovered", planPreferences: "planPreferences", hideCompareBoxOverride: "hideCompareBoxOverride", isRetentionSummaryPage: "isRetentionSummaryPage", currentPlanText: "currentPlanText", nextYearPlanText: "nextYearPlanText", bestMatchText: "bestMatchText", bestMatchIcon: "bestMatchIcon", bestMatchPlanId: "bestMatchPlanId", bestMatchTooltip: "bestMatchTooltip", selectedQuoteGroup: "selectedQuoteGroup", quoteGroups: "quoteGroups", addToQuoteLimit: "addToQuoteLimit", noCostAvailableText: "noCostAvailableText", isRetentionView: "isRetentionView", isQuotingSite: "isQuotingSite", nonLicensedPlanText: "nonLicensedPlanText", nonLicensedMessageText: "nonLicensedMessageText", includeNonLicensedPlans: "includeNonLicensedPlans", isNotLicensedToSell: "isNotLicensedToSell", planLogoSize: "planLogoSize", Spa_Site_ShowRiderIcons: "Spa_Site_ShowRiderIcons", Spa_Site_Dental_Rider_Display_Text: "Spa_Site_Dental_Rider_Display_Text", Spa_Site_Vision_Rider_Display_Text: "Spa_Site_Vision_Rider_Display_Text", Spa_Site_Hearing_Rider_Display_Text: "Spa_Site_Hearing_Rider_Display_Text", Spa_PlanCard_DentalAddOnCoverage_Text: "Spa_PlanCard_DentalAddOnCoverage_Text", Spa_PlanCard_HearingAddOnCoverage_Text: "Spa_PlanCard_HearingAddOnCoverage_Text", Spa_PlanCard_VisionAddOnCoverage_Text: "Spa_PlanCard_VisionAddOnCoverage_Text", Spa_PlanCard_AddOnCoverage_Text: "Spa_PlanCard_AddOnCoverage_Text", Spa_PlanCard_AddToCompare_Text: "Spa_PlanCard_AddToCompare_Text", Spa_Site_ShowRidersOnPlanCards: "Spa_Site_ShowRidersOnPlanCards", Spa_ShoppingCart_Enabled: "Spa_ShoppingCart_Enabled", Spa_PlanCard_PlanDetails_ButtonText: "Spa_PlanCard_PlanDetails_ButtonText", Spa_Site_Show_PlanLogo: "Spa_Site_Show_PlanLogo", Spa_Site_Show_AncillaryPlanLogo: "Spa_Site_Show_AncillaryPlanLogo", Spa_PlanCard_QuoteLinkName_Text: "Spa_PlanCard_QuoteLinkName_Text", Spa_PlanCard_PlanType_Text: "Spa_PlanCard_PlanType_Text", Spa_PlanCard_ShowRidersOnMACards: "Spa_PlanCard_ShowRidersOnMACards", Spa_PlanCard_ShowRidersOnPDPCards: "Spa_PlanCard_ShowRidersOnPDPCards", Spa_PlanCard_ShowRidersOnMAPDCards: "Spa_PlanCard_ShowRidersOnMAPDCards", Spa_PlanCard_ShowRidersOnMEDIGAPCards: "Spa_PlanCard_ShowRidersOnMEDIGAPCards", Spa_PlanCard_ShowRidersOnDentalCards: "Spa_PlanCard_ShowRidersOnDentalCards", Spa_PlanCard_ShowRidersOnVisionCards: "Spa_PlanCard_ShowRidersOnVisionCards", Spa_PlanCard_ShowRidersOnHCCards: "Spa_PlanCard_ShowRidersOnHCCards", Spa_Site_ShowPremiumAsAnnual: "Spa_Site_ShowPremiumAsAnnual", Spa_PlanCard_AddOnCoverageInCart_Text: "Spa_PlanCard_AddOnCoverageInCart_Text", Spa_PlanCard_AddOnCoverageTooltip_Body: "Spa_PlanCard_AddOnCoverageTooltip_Body", Spa_Site_NotApplicable_Text: "Spa_Site_NotApplicable_Text", Spa_PlanDetails_Non_Covered_Text: "Spa_PlanDetails_Non_Covered_Text", Spa_Site_Pharmacy_Text: "Spa_Site_Pharmacy_Text", Spa_PlanCard_Pharmacy_Covered_Text: "Spa_PlanCard_Pharmacy_Covered_Text", Spa_Site_Prescriptions_Text: "Spa_Site_Prescriptions_Text", Spa_PlanCard_Drug_Covered_Text: "Spa_PlanCard_Drug_Covered_Text", Spa_PlanCard_CompareNow_Text: "Spa_PlanCard_CompareNow_Text", Spa_PlanCard_CompareWarning_Tooltip: "Spa_PlanCard_CompareWarning_Tooltip", Spa_PlanCard_CompareLimit_Desktop: "Spa_PlanCard_CompareLimit_Desktop", Spa_PlanCard_CompareLimit_Mobile: "Spa_PlanCard_CompareLimit_Mobile", Spa_PlanCard_Total_Estimated_Cost_Tooltip: "Spa_PlanCard_Total_Estimated_Cost_Tooltip", Spa_Site_TotalEstimatedCost_Enabled: "Spa_Site_TotalEstimatedCost_Enabled", Spa_PlanCard_TotalEstimatedAnnualCost_Text: "Spa_PlanCard_TotalEstimatedAnnualCost_Text", Spa_PlanCard_TotalEstimatedCost_Text: "Spa_PlanCard_TotalEstimatedCost_Text", Spa_PlanCard_AddToQuote_Text: "Spa_PlanCard_AddToQuote_Text", Spa_PlanCard_RemoveFromQuote_Text: "Spa_PlanCard_RemoveFromQuote_Text", Spa_PlanCard_AddToQuote_Warning_Tooltip: "Spa_PlanCard_AddToQuote_Warning_Tooltip", Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip: "Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip", Spa_PlanList_AddToQuote_Limit: "Spa_PlanList_AddToQuote_Limit", Spa_PlanList_AddToQuote_Limit_Mobile: "Spa_PlanList_AddToQuote_Limit_Mobile", Spa_Site_MedigapPlanType_Enabled: "Spa_Site_MedigapPlanType_Enabled", Spa_Site_AddToCompare_Enabled: "Spa_Site_AddToCompare_Enabled", Spa_Site_PlanViewDetails_Enabled: "Spa_Site_PlanViewDetails_Enabled", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text", Spa_Site_ComboPlanLabel_Text: "Spa_Site_ComboPlanLabel_Text", Spa_Site_ComboPlanTooltip_Text: "Spa_Site_ComboPlanTooltip_Text", Spa_Site_ShowDrugAlternatives_Enabled: "Spa_Site_ShowDrugAlternatives_Enabled", Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled: "Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled", Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text: "Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text", Spa_PlanCard_ShowDrugAlternatives_Nudge_Text: "Spa_PlanCard_ShowDrugAlternatives_Nudge_Text", Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon: "Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon", queuePosition: "queuePosition", plansSelectedToQuote: "plansSelectedToQuote", viewCostTooltipHeaderText: "viewCostTooltipHeaderText", viewCostTooltipHeaderContent: "viewCostTooltipHeaderContent", inNetworkPreferredText: "inNetworkPreferredText", inNetworkStandardText: "inNetworkStandardText", outOfNetworkText: "outOfNetworkText", selectedPharmacy: "selectedPharmacy", isMailOrderSelected: "isMailOrderSelected", mailOrderText: "mailOrderText", selectedProviders: "selectedProviders", providerDetails: "providerDetails", providersInNetworkText: "providersInNetworkText", pcpInNetworkText: "pcpInNetworkText", pcpOutOfNetworkText: "pcpOutOfNetworkText", providersNoDataText: "providersNoDataText", isProviderEnabled: "isProviderEnabled", showStarRating: "showStarRating", showPreferenceScore: "showPreferenceScore", CSNPEnabled: "CSNPEnabled", DSNPEnabled: "DSNPEnabled", ISNPEnabled: "ISNPEnabled", CSNPText: "CSNPText", DSNPText: "DSNPText", ISNPText: "ISNPText", SNPText: "SNPText", noProviderNetworkAccessText: "noProviderNetworkAccessText", viewDetailsDescriptionText: "viewDetailsDescriptionText", medSupPaymentMethod: "medSupPaymentMethod", nonMonthlyRateText: "nonMonthlyRateText", medSupPaymentMethodDisplayText: "medSupPaymentMethodDisplayText", showNonMonthlyRateText: "showNonMonthlyRateText", optionOneText: "optionOneText", optionTwoText: "optionTwoText", displayOptionLabels: "displayOptionLabels", hidePlanCardLabel: "hidePlanCardLabel", monthlyPremiumText: "monthlyPremiumText", moreBenefitsInstructionText: "moreBenefitsInstructionText", basePlanOptionText: "basePlanOptionText", totalCostEffectiveDate: "totalCostEffectiveDate", medicineCabinet: "medicineCabinet", memberHasOptionsDefined: "memberHasOptionsDefined", planCardPreferenceDetailedEnabled: "planCardPreferenceDetailedEnabled", showAddToCartForAncillaryPlans: "showAddToCartForAncillaryPlans", showAncillaryIcons: "showAncillaryIcons", loaderIconEnabled: "loaderIconEnabled", hideLinkText: "hideLinkText", viewAllLinkText: "viewAllLinkText", Spa_PlanCard_SupplementalBenefits_Enabled: "Spa_PlanCard_SupplementalBenefits_Enabled", Spa_PlanCard_SupplementalBenefits_List: "Spa_PlanCard_SupplementalBenefits_List", editLinkText: "editLinkText", showRatingMethod: "showRatingMethod", Spa_RatingMethod_AttainedAge_Tooltip_Text: "Spa_RatingMethod_AttainedAge_Tooltip_Text", Spa_RatingMethod_IssueAge_Tooltip_Text: "Spa_RatingMethod_IssueAge_Tooltip_Text", Spa_RatingMethod_CommunityRated_Tooltip_Text: "Spa_RatingMethod_CommunityRated_Tooltip_Text", providerOneOrMoreOutOfNetworkText: "providerOneOrMoreOutOfNetworkText", providerInNetworkOnOtherLocationsTooltipText: "providerInNetworkOnOtherLocationsTooltipText", providerShowPartialIndicatorEnabled: "providerShowPartialIndicatorEnabled", planFeesEnabled: "planFeesEnabled", planFeesTooltipText: "planFeesTooltipText", planFeesIncludedInPremiumTooltipText: "planFeesIncludedInPremiumTooltipText", planFeesNotIncludedInPremiumTooltipText: "planFeesNotIncludedInPremiumTooltipText", showAvailableRateFactorsEnabled: "showAvailableRateFactorsEnabled", personalizedQuoteLabelText: "personalizedQuoteLabelText", availableRateFactorsData: "availableRateFactorsData", snpPremiumRangeEnabled: "snpPremiumRangeEnabled", showPlanId: "showPlanId", snpRangeLinkText: "snpRangeLinkText", showPlanYear: "showPlanYear", planIdText: "planIdText", enableDSNPCodes: "enableDSNPCodes", availableText: "availableText", unavailableText: "unavailableText", viewProvidersButtonText: "viewProvidersButtonText", viewPrescriptionsButtonText: "viewPrescriptionsButtonText", supplementalBenefitsHighlightText: "supplementalBenefitsHighlightText", preferencesText: "preferencesText", viewMoreDetailsText: "viewMoreDetailsText", hideDetailsText: "hideDetailsText", newPlanCardDesignEnabled: "newPlanCardDesignEnabled", viewAllPlanDetailsText: "viewAllPlanDetailsText", shareThisPlanText: "shareThisPlanText", viewCostDetailsText: "viewCostDetailsText", closeText: "closeText", planBenefitHighlightItems: "planBenefitHighlightItems", addOnCoverageHeaderText: "addOnCoverageHeaderText", planBenefitHighlightsHeaderText: "planBenefitHighlightsHeaderText", showRiderDetails: "showRiderDetails", hideRiderDetailsText: "hideRiderDetailsText", showRiderDetailsText: "showRiderDetailsText", riderIsIncludedText: "riderIsIncludedText", waiverStateRiderTooltips: "waiverStateRiderTooltips", costMA: "costMA", costMAPD: "costMAPD", costMEDIGAP: "costMEDIGAP", costPDP: "costPDP", costDENTAL: "costDENTAL", costVISION: "costVISION", isVbcAgreementEnabled: "isVbcAgreementEnabled", vbcAgreementLabel: "vbcAgreementLabel", vbcAgreementTooltip: "vbcAgreementTooltip", nonCommissionableText: "nonCommissionableText", isNonCommissionableFlagCheckEnabled: "isNonCommissionableFlagCheckEnabled" }, outputs: { quoteClicked: "quoteClicked", quoteGroupChanged: "quoteGroupChanged" }, features: [i0.ɵɵNgOnChangesFeature] });
__decorate([
    LiveEditInactive()
], PlanCardBaseComponent.prototype, "viewPlanDetailsPage", null);
__decorate([
    LiveEditInactive()
], PlanCardBaseComponent.prototype, "quoteClick", null);
__decorate([
    LiveEditInactive()
], PlanCardBaseComponent.prototype, "comparePlans", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCardBaseComponent, [{
        type: Directive
    }], function () { return [{ type: i1.NavigationService }, { type: PlanFacade }, { type: i1.DemographicService }, { type: RiderFacade }, { type: i1.PlanCompareService }, { type: i1.ResponsiveLayoutService }, { type: PlanCardFacade }, { type: i1.QuoteService }, { type: AnalyticsService }, { type: i1.LocaleService }, { type: i0.ChangeDetectorRef }, { type: PlanDetailsFacade }, { type: i1.GuidedHelpService }]; }, { plan: [{
            type: Input
        }], activeTabType: [{
            type: Input
        }], selectedCompareGroup: [{
            type: Input
        }], compareGroups: [{
            type: Input
        }], planBenefits: [{
            type: Input
        }], displayDrugsCovered: [{
            type: Input
        }], planPreferences: [{
            type: Input
        }], hideCompareBoxOverride: [{
            type: Input
        }], isRetentionSummaryPage: [{
            type: Input
        }], currentPlanText: [{
            type: Input
        }], nextYearPlanText: [{
            type: Input
        }], bestMatchText: [{
            type: Input
        }], bestMatchIcon: [{
            type: Input
        }], bestMatchPlanId: [{
            type: Input
        }], bestMatchTooltip: [{
            type: Input
        }], selectedQuoteGroup: [{
            type: Input
        }], quoteGroups: [{
            type: Input
        }], addToQuoteLimit: [{
            type: Input
        }], noCostAvailableText: [{
            type: Input
        }], isRetentionView: [{
            type: Input
        }], isQuotingSite: [{
            type: Input
        }], nonLicensedPlanText: [{
            type: Input
        }], nonLicensedMessageText: [{
            type: Input
        }], includeNonLicensedPlans: [{
            type: Input
        }], isNotLicensedToSell: [{
            type: Input
        }], planLogoSize: [{
            type: Input
        }], Spa_Site_ShowRiderIcons: [{
            type: Input
        }], Spa_Site_Dental_Rider_Display_Text: [{
            type: Input
        }], Spa_Site_Vision_Rider_Display_Text: [{
            type: Input
        }], Spa_Site_Hearing_Rider_Display_Text: [{
            type: Input
        }], Spa_PlanCard_DentalAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_HearingAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_VisionAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_AddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_AddToCompare_Text: [{
            type: Input
        }], Spa_Site_ShowRidersOnPlanCards: [{
            type: Input
        }], Spa_ShoppingCart_Enabled: [{
            type: Input
        }], Spa_PlanCard_PlanDetails_ButtonText: [{
            type: Input
        }], Spa_Site_Show_PlanLogo: [{
            type: Input
        }], Spa_Site_Show_AncillaryPlanLogo: [{
            type: Input
        }], Spa_PlanCard_QuoteLinkName_Text: [{
            type: Input
        }], Spa_PlanCard_PlanType_Text: [{
            type: Input
        }], Spa_PlanCard_ShowRidersOnMACards: [{
            type: Input
        }], Spa_PlanCard_ShowRidersOnPDPCards: [{
            type: Input
        }], Spa_PlanCard_ShowRidersOnMAPDCards: [{
            type: Input
        }], Spa_PlanCard_ShowRidersOnMEDIGAPCards: [{
            type: Input
        }], Spa_PlanCard_ShowRidersOnDentalCards: [{
            type: Input
        }], Spa_PlanCard_ShowRidersOnVisionCards: [{
            type: Input
        }], Spa_PlanCard_ShowRidersOnHCCards: [{
            type: Input
        }], Spa_Site_ShowPremiumAsAnnual: [{
            type: Input
        }], Spa_PlanCard_AddOnCoverageInCart_Text: [{
            type: Input
        }], Spa_PlanCard_AddOnCoverageTooltip_Body: [{
            type: Input
        }], Spa_Site_NotApplicable_Text: [{
            type: Input
        }], Spa_PlanDetails_Non_Covered_Text: [{
            type: Input
        }], Spa_Site_Pharmacy_Text: [{
            type: Input
        }], Spa_PlanCard_Pharmacy_Covered_Text: [{
            type: Input
        }], Spa_Site_Prescriptions_Text: [{
            type: Input
        }], Spa_PlanCard_Drug_Covered_Text: [{
            type: Input
        }], Spa_PlanCard_CompareNow_Text: [{
            type: Input
        }], Spa_PlanCard_CompareWarning_Tooltip: [{
            type: Input
        }], Spa_PlanCard_CompareLimit_Desktop: [{
            type: Input
        }], Spa_PlanCard_CompareLimit_Mobile: [{
            type: Input
        }], Spa_PlanCard_Total_Estimated_Cost_Tooltip: [{
            type: Input
        }], Spa_Site_TotalEstimatedCost_Enabled: [{
            type: Input
        }], Spa_PlanCard_TotalEstimatedAnnualCost_Text: [{
            type: Input
        }], Spa_PlanCard_TotalEstimatedCost_Text: [{
            type: Input
        }], Spa_PlanCard_AddToQuote_Text: [{
            type: Input
        }], Spa_PlanCard_RemoveFromQuote_Text: [{
            type: Input
        }], Spa_PlanCard_AddToQuote_Warning_Tooltip: [{
            type: Input
        }], Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip: [{
            type: Input
        }], Spa_PlanList_AddToQuote_Limit: [{
            type: Input
        }], Spa_PlanList_AddToQuote_Limit_Mobile: [{
            type: Input
        }], Spa_Site_MedigapPlanType_Enabled: [{
            type: Input
        }], Spa_Site_AddToCompare_Enabled: [{
            type: Input
        }], Spa_Site_PlanViewDetails_Enabled: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }], Spa_Site_ComboPlanLabel_Text: [{
            type: Input
        }], Spa_Site_ComboPlanTooltip_Text: [{
            type: Input
        }], Spa_Site_ShowDrugAlternatives_Enabled: [{
            type: Input
        }], Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled: [{
            type: Input
        }], Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text: [{
            type: Input
        }], Spa_PlanCard_ShowDrugAlternatives_Nudge_Text: [{
            type: Input
        }], Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon: [{
            type: Input
        }], queuePosition: [{
            type: Input
        }], plansSelectedToQuote: [{
            type: Input
        }], viewCostTooltipHeaderText: [{
            type: Input
        }], viewCostTooltipHeaderContent: [{
            type: Input
        }], inNetworkPreferredText: [{
            type: Input
        }], inNetworkStandardText: [{
            type: Input
        }], outOfNetworkText: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], isMailOrderSelected: [{
            type: Input
        }], mailOrderText: [{
            type: Input
        }], selectedProviders: [{
            type: Input
        }], providerDetails: [{
            type: Input
        }], providersInNetworkText: [{
            type: Input
        }], pcpInNetworkText: [{
            type: Input
        }], pcpOutOfNetworkText: [{
            type: Input
        }], providersNoDataText: [{
            type: Input
        }], isProviderEnabled: [{
            type: Input
        }], showStarRating: [{
            type: Input
        }], showPreferenceScore: [{
            type: Input
        }], CSNPEnabled: [{
            type: Input
        }], DSNPEnabled: [{
            type: Input
        }], ISNPEnabled: [{
            type: Input
        }], CSNPText: [{
            type: Input
        }], DSNPText: [{
            type: Input
        }], ISNPText: [{
            type: Input
        }], SNPText: [{
            type: Input
        }], noProviderNetworkAccessText: [{
            type: Input
        }], viewDetailsDescriptionText: [{
            type: Input
        }], medSupPaymentMethod: [{
            type: Input
        }], nonMonthlyRateText: [{
            type: Input
        }], medSupPaymentMethodDisplayText: [{
            type: Input
        }], showNonMonthlyRateText: [{
            type: Input
        }], optionOneText: [{
            type: Input
        }], optionTwoText: [{
            type: Input
        }], displayOptionLabels: [{
            type: Input
        }], hidePlanCardLabel: [{
            type: Input
        }], monthlyPremiumText: [{
            type: Input
        }], moreBenefitsInstructionText: [{
            type: Input
        }], basePlanOptionText: [{
            type: Input
        }], totalCostEffectiveDate: [{
            type: Input
        }], medicineCabinet: [{
            type: Input
        }], memberHasOptionsDefined: [{
            type: Input
        }], planCardPreferenceDetailedEnabled: [{
            type: Input
        }], showAddToCartForAncillaryPlans: [{
            type: Input
        }], showAncillaryIcons: [{
            type: Input
        }], loaderIconEnabled: [{
            type: Input
        }], hideLinkText: [{
            type: Input
        }], viewAllLinkText: [{
            type: Input
        }], Spa_PlanCard_SupplementalBenefits_Enabled: [{
            type: Input
        }], Spa_PlanCard_SupplementalBenefits_List: [{
            type: Input
        }], editLinkText: [{
            type: Input
        }], showRatingMethod: [{
            type: Input
        }], Spa_RatingMethod_AttainedAge_Tooltip_Text: [{
            type: Input
        }], Spa_RatingMethod_IssueAge_Tooltip_Text: [{
            type: Input
        }], Spa_RatingMethod_CommunityRated_Tooltip_Text: [{
            type: Input
        }], providerOneOrMoreOutOfNetworkText: [{
            type: Input
        }], providerInNetworkOnOtherLocationsTooltipText: [{
            type: Input
        }], providerShowPartialIndicatorEnabled: [{
            type: Input
        }], planFeesEnabled: [{
            type: Input
        }], planFeesTooltipText: [{
            type: Input
        }], planFeesIncludedInPremiumTooltipText: [{
            type: Input
        }], planFeesNotIncludedInPremiumTooltipText: [{
            type: Input
        }], showAvailableRateFactorsEnabled: [{
            type: Input
        }], personalizedQuoteLabelText: [{
            type: Input
        }], availableRateFactorsData: [{
            type: Input
        }], snpPremiumRangeEnabled: [{
            type: Input
        }], showPlanId: [{
            type: Input
        }], snpRangeLinkText: [{
            type: Input
        }], showPlanYear: [{
            type: Input
        }], planIdText: [{
            type: Input
        }], enableDSNPCodes: [{
            type: Input
        }], availableText: [{
            type: Input
        }], unavailableText: [{
            type: Input
        }], viewProvidersButtonText: [{
            type: Input
        }], viewPrescriptionsButtonText: [{
            type: Input
        }], supplementalBenefitsHighlightText: [{
            type: Input
        }], preferencesText: [{
            type: Input
        }], viewMoreDetailsText: [{
            type: Input
        }], hideDetailsText: [{
            type: Input
        }], newPlanCardDesignEnabled: [{
            type: Input
        }], viewAllPlanDetailsText: [{
            type: Input
        }], shareThisPlanText: [{
            type: Input
        }], viewCostDetailsText: [{
            type: Input
        }], closeText: [{
            type: Input
        }], planBenefitHighlightItems: [{
            type: Input
        }], addOnCoverageHeaderText: [{
            type: Input
        }], planBenefitHighlightsHeaderText: [{
            type: Input
        }], showRiderDetails: [{
            type: Input
        }], hideRiderDetailsText: [{
            type: Input
        }], showRiderDetailsText: [{
            type: Input
        }], riderIsIncludedText: [{
            type: Input
        }], waiverStateRiderTooltips: [{
            type: Input
        }], costMA: [{
            type: Input
        }], costMAPD: [{
            type: Input
        }], costMEDIGAP: [{
            type: Input
        }], costPDP: [{
            type: Input
        }], costDENTAL: [{
            type: Input
        }], costVISION: [{
            type: Input
        }], isVbcAgreementEnabled: [{
            type: Input
        }], vbcAgreementLabel: [{
            type: Input
        }], vbcAgreementTooltip: [{
            type: Input
        }], nonCommissionableText: [{
            type: Input
        }], isNonCommissionableFlagCheckEnabled: [{
            type: Input
        }], quoteClicked: [{
            type: Output
        }], quoteGroupChanged: [{
            type: Output
        }], viewPlanDetailsPage: [], quoteClick: [], comparePlans: [] }); })();

const _c0$2G = function (a0, a1) { return { Spa_Style_Primary_Color: a0, Spa_Style_Gray4_Color: a1 }; };
const _c1$1m = function (a0, a1) { return { "fa-check": a0, "fa-times-circle": a1 }; };
function PlanCardRateFactorStatusComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "i", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c0$2G, ctx_r0.rateFactorStatus === ctx_r0.rateFactorsStatus.ANSWERED_AND_APPLIED_TO_PREMIUM, ctx_r0.rateFactorStatus === ctx_r0.rateFactorsStatus.ANSWERED_BUT_NOT_APPLIED_TO_PREMIUM));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c1$1m, ctx_r0.rateFactorStatus === ctx_r0.rateFactorsStatus.ANSWERED_AND_APPLIED_TO_PREMIUM, ctx_r0.rateFactorStatus === ctx_r0.rateFactorsStatus.ANSWERED_BUT_NOT_APPLIED_TO_PREMIUM));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.rateFactorsDisplayName, "\n");
} }
class PlanCardRateFactorStatusComponent {
    constructor() {
        this.rateFactorsStatus = RateFactorsStatus;
    }
}
PlanCardRateFactorStatusComponent.ɵfac = function PlanCardRateFactorStatusComponent_Factory(t) { return new (t || PlanCardRateFactorStatusComponent)(); };
PlanCardRateFactorStatusComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCardRateFactorStatusComponent, selectors: [["vnext-widget-plan-card-rate-factor-status"]], inputs: { rateFactorStatus: "rateFactorStatus", rateFactorsDisplayName: "rateFactorsDisplayName" }, decls: 1, vars: 1, consts: [["class", "d-flex flex-row align-items-center text-nowrap px-2", 3, "ngClass", 4, "ngIf"], [1, "d-flex", "flex-row", "align-items-center", "text-nowrap", "px-2", 3, "ngClass"], [1, "pr-2", "fas", 3, "ngClass"]], template: function PlanCardRateFactorStatusComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanCardRateFactorStatusComponent_div_0_Template, 3, 9, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.rateFactorStatus !== ctx.rateFactorsStatus.APPLICABLE);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, IconAriaAttributesDirective], styles: [".fa-check[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCardRateFactorStatusComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-card-rate-factor-status', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  *ngIf=\"rateFactorStatus !== rateFactorsStatus.APPLICABLE\"\r\n  class=\"d-flex flex-row align-items-center text-nowrap px-2\"\r\n  [ngClass]=\"{\r\n    Spa_Style_Primary_Color: rateFactorStatus === rateFactorsStatus.ANSWERED_AND_APPLIED_TO_PREMIUM,\r\n    Spa_Style_Gray4_Color: rateFactorStatus === rateFactorsStatus.ANSWERED_BUT_NOT_APPLIED_TO_PREMIUM\r\n  }\"\r\n>\r\n  <i\r\n    class=\"pr-2 fas\"\r\n    [ngClass]=\"{\r\n      'fa-check': rateFactorStatus === rateFactorsStatus.ANSWERED_AND_APPLIED_TO_PREMIUM,\r\n      'fa-times-circle': rateFactorStatus === rateFactorsStatus.ANSWERED_BUT_NOT_APPLIED_TO_PREMIUM\r\n    }\"\r\n  ></i>\r\n  {{ rateFactorsDisplayName }}\r\n</div>\r\n", styles: [".fa-check{color:var(--static-Spa_Style_Cost_Text)}\n"] }]
    }], null, { rateFactorStatus: [{
            type: Input
        }], rateFactorsDisplayName: [{
            type: Input
        }] }); })();

function PlanCardRateFactorsStatusesComponent_div_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-widget-plan-card-rate-factor-status", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const planCardRateFactorStatus_r3 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("rateFactorStatus", planCardRateFactorStatus_r3.status)("rateFactorsDisplayName", planCardRateFactorStatus_r3.displayName);
} }
function PlanCardRateFactorsStatusesComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵtemplate(4, PlanCardRateFactorsStatusesComponent_div_0_ng_container_4_Template, 2, 2, "ng-container", 5);
    i0.ɵɵpipe(5, "orderBy");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.personalizedQuoteLabelText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(5, 3, ctx_r0.planCardRateFactorsStatus, "ordinal"))("ngForTrackBy", ctx_r0.trackByQuestionKey);
} }
function PlanCardRateFactorsStatusesComponent_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li", 10);
    i0.ɵɵelement(2, "vnext-widget-plan-card-rate-factor-status", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const planCardRateFactorStatus_r5 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("rateFactorStatus", planCardRateFactorStatus_r5.status)("rateFactorsDisplayName", planCardRateFactorStatus_r5.displayName);
} }
function PlanCardRateFactorsStatusesComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "h3", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ul", 9);
    i0.ɵɵtemplate(4, PlanCardRateFactorsStatusesComponent_div_1_ng_container_4_Template, 3, 2, "ng-container", 5);
    i0.ɵɵpipe(5, "orderBy");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.personalizedQuoteLabelText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(5, 3, ctx_r1.planCardRateFactorsStatus, "ordinal"))("ngForTrackBy", ctx_r1.trackByQuestionKey);
} }
class PlanCardRateFactorsStatusesComponent {
    constructor() {
        this.newPlanCardDesignEnabled = false;
        this.planCardRateFactorsStatus = [];
    }
    ngOnChanges(changes) {
        const { rateFactorsStatus, availableRateFactorsData } = changes;
        if ((rateFactorsStatus && !_isEqual(rateFactorsStatus.previousValue, rateFactorsStatus.currentValue)) ||
            (availableRateFactorsData && !_isEqual(availableRateFactorsData.previousValue, availableRateFactorsData.currentValue))) {
            if (this.rateFactorsStatus?.length && this.availableRateFactorsData?.length) {
                this.planCardRateFactorsStatus = this.getAvailablePlanCardRateFactorsStatus(this.rateFactorsStatus, this.availableRateFactorsData);
            }
        }
    }
    getAvailablePlanCardRateFactorsStatus(rateFactorsStatus, availableRateFactorsData) {
        return rateFactorsStatus.reduce((availableStatuses, rateFactorStatus) => {
            const availableRateFactorData = availableRateFactorsData.find(availableRateFactor => availableRateFactor.display && availableRateFactor.key === rateFactorStatus.questionKey);
            if (availableRateFactorData && ANSWERED_RATE_FACTOR_STATUSES.includes(rateFactorStatus.status)) {
                availableStatuses.push({
                    key: rateFactorStatus.questionKey,
                    status: rateFactorStatus.status,
                    displayName: availableRateFactorData.displayName,
                    ordinal: availableRateFactorData.ordinal
                });
            }
            return availableStatuses;
        }, []);
    }
    trackByQuestionKey(index, planCardRateFactorStatus) {
        return planCardRateFactorStatus.key;
    }
}
PlanCardRateFactorsStatusesComponent.ɵfac = function PlanCardRateFactorsStatusesComponent_Factory(t) { return new (t || PlanCardRateFactorsStatusesComponent)(); };
PlanCardRateFactorsStatusesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCardRateFactorsStatusesComponent, selectors: [["vnext-widget-plan-card-rate-factors-statuses"]], inputs: { rateFactorsStatus: "rateFactorsStatus", availableRateFactorsData: "availableRateFactorsData", personalizedQuoteLabelText: "personalizedQuoteLabelText", newPlanCardDesignEnabled: "newPlanCardDesignEnabled" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [["class", "rate-factor-statuses-section d-flex flex-column flex-md-row py-3 pr-3 pb-1 pl-3 m-0", 4, "ngIf"], ["class", "plan-card-extended-details-personalized-quote mt-4", 4, "ngIf"], [1, "rate-factor-statuses-section", "d-flex", "flex-column", "flex-md-row", "py-3", "pr-3", "pb-1", "pl-3", "m-0"], [1, "Spa_Style_Paragraph", "Spa_Style_Bold_Weight", "text-nowrap"], [1, "d-flex", "flex-row", "flex-wrap", "pl-0", "pt-2", "pt-md-0", "pl-md-2"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "rateFactorStatus", "rateFactorsDisplayName"], [1, "plan-card-extended-details-personalized-quote", "mt-4"], [1, "Spa_Style_H2"], [1, "plan-card-highlights-list", "list-inline", "mb-0", "ml-n2"], [1, "Spa_Style_Small_Font"]], template: function PlanCardRateFactorsStatusesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanCardRateFactorsStatusesComponent_div_0_Template, 6, 6, "div", 0);
        i0.ɵɵtemplate(1, PlanCardRateFactorsStatusesComponent_div_1_Template, 6, 6, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", (ctx.planCardRateFactorsStatus == null ? null : ctx.planCardRateFactorsStatus.length) && !ctx.newPlanCardDesignEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.planCardRateFactorsStatus == null ? null : ctx.planCardRateFactorsStatus.length) && ctx.newPlanCardDesignEnabled);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, PlanCardRateFactorStatusComponent, OrderPipe], styles: [".rate-factor-statuses-section[_ngcontent-%COMP%]{border-bottom-left-radius:4px;border-bottom-right-radius:4px;background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}.plan-card-highlights-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{display:inline-block}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCardRateFactorsStatusesComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-card-rate-factors-statuses', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  *ngIf=\"planCardRateFactorsStatus?.length && !newPlanCardDesignEnabled\"\r\n  class=\"rate-factor-statuses-section d-flex flex-column flex-md-row py-3 pr-3 pb-1 pl-3 m-0\"\r\n>\r\n  <div class=\"Spa_Style_Paragraph Spa_Style_Bold_Weight text-nowrap\">{{ personalizedQuoteLabelText }}</div>\r\n  <div class=\"d-flex flex-row flex-wrap pl-0 pt-2 pt-md-0 pl-md-2\">\r\n    <ng-container *ngFor=\"let planCardRateFactorStatus of planCardRateFactorsStatus | orderBy : 'ordinal'; trackBy: trackByQuestionKey\">\r\n      <vnext-widget-plan-card-rate-factor-status\r\n        [rateFactorStatus]=\"planCardRateFactorStatus.status\"\r\n        [rateFactorsDisplayName]=\"planCardRateFactorStatus.displayName\"\r\n      ></vnext-widget-plan-card-rate-factor-status>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n\r\n<div *ngIf=\"planCardRateFactorsStatus?.length && newPlanCardDesignEnabled\" class=\"plan-card-extended-details-personalized-quote mt-4\">\r\n  <h3 class=\"Spa_Style_H2\">{{ personalizedQuoteLabelText }}</h3>\r\n  <ul class=\"plan-card-highlights-list list-inline mb-0 ml-n2\">\r\n    <ng-container *ngFor=\"let planCardRateFactorStatus of planCardRateFactorsStatus | orderBy : 'ordinal'; trackBy: trackByQuestionKey\">\r\n      <li class=\"Spa_Style_Small_Font\">\r\n        <vnext-widget-plan-card-rate-factor-status\r\n          [rateFactorStatus]=\"planCardRateFactorStatus.status\"\r\n          [rateFactorsDisplayName]=\"planCardRateFactorStatus.displayName\"\r\n        ></vnext-widget-plan-card-rate-factor-status>\r\n      </li>\r\n    </ng-container>\r\n  </ul>\r\n</div>\r\n", styles: [".rate-factor-statuses-section{border-bottom-left-radius:4px;border-bottom-right-radius:4px;background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}.plan-card-highlights-list>li{display:inline-block}\n"] }]
    }], null, { rateFactorsStatus: [{
            type: Input
        }], availableRateFactorsData: [{
            type: Input
        }], personalizedQuoteLabelText: [{
            type: Input
        }], newPlanCardDesignEnabled: [{
            type: Input
        }] }); })();

function PlanRiderDetailsComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function PlanRiderDetailsComponent_ng_container_0_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 6);
    i0.ɵɵelementStart(3, "span", 7);
    i0.ɵɵtext(4, "Collapse");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.hideRiderDetailsText);
} }
function PlanRiderDetailsComponent_ng_container_0_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 8);
    i0.ɵɵelementStart(3, "span", 7);
    i0.ɵɵtext(4, "Expand");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r5.showRiderDetailsText);
} }
function PlanRiderDetailsComponent_ng_container_0_br_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "br");
} }
function PlanRiderDetailsComponent_ng_container_0_ul_9_li_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-link", 13);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const riderDetails_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("href", riderDetails_r9.value)("title", riderDetails_r9.linkName)("makeInlineBlock", true)("customClass", "Spa_Style_Primary_Link")("linkTarget", ctx_r10.targetType.BLANK);
} }
function PlanRiderDetailsComponent_ng_container_0_ul_9_li_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 14);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const riderDetails_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, riderDetails_r9.value, "html"), i0.ɵɵsanitizeHtml);
} }
function PlanRiderDetailsComponent_ng_container_0_ul_9_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "p", 10);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, PlanRiderDetailsComponent_ng_container_0_ul_9_li_1_ng_container_3_Template, 2, 5, "ng-container", 11);
    i0.ɵɵtemplate(4, PlanRiderDetailsComponent_ng_container_0_ul_9_li_1_ng_template_4_Template, 2, 4, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const riderDetails_r9 = ctx.$implicit;
    const _r11 = i0.ɵɵreference(5);
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", riderDetails_r9.name, ": ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", riderDetails_r9.valueTypeID === ctx_r8.planBenefitValueTypes.LINK)("ngIfElse", _r11);
} }
function PlanRiderDetailsComponent_ng_container_0_ul_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul");
    i0.ɵɵtemplate(1, PlanRiderDetailsComponent_ng_container_0_ul_9_li_1_Template, 6, 3, "li", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r7.rider.extendedPlanDetails[0].sectionDetails);
} }
const _c0$2F = function (a0, a1) { return { "float-right": a0, "show-hide-details": a1 }; };
const _c1$1l = function (a0) { return { "new-plan-card-enabled": a0 }; };
function PlanRiderDetailsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 1);
    i0.ɵɵlistener("click", function PlanRiderDetailsComponent_ng_container_0_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.toggleRiderDetails()); })("keyup.enter", function PlanRiderDetailsComponent_ng_container_0_Template_span_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r16); const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.toggleRiderDetails()); });
    i0.ɵɵtemplate(2, PlanRiderDetailsComponent_ng_container_0_ng_container_2_Template, 1, 0, "ng-container", 2);
    i0.ɵɵtemplate(3, PlanRiderDetailsComponent_ng_container_0_ng_template_3_Template, 5, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(5, PlanRiderDetailsComponent_ng_container_0_ng_template_5_Template, 5, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 5);
    i0.ɵɵtemplate(8, PlanRiderDetailsComponent_ng_container_0_br_8_Template, 1, 0, "br", 0);
    i0.ɵɵtemplate(9, PlanRiderDetailsComponent_ng_container_0_ul_9_Template, 2, 1, "ul", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r2 = i0.ɵɵreference(4);
    const _r4 = i0.ɵɵreference(6);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(10, _c0$2F, ctx_r0.alignRiderDetailsTextToRight, !ctx_r0.newPlanCardDesignEnabled));
    i0.ɵɵattribute("aria-label", ctx_r0.isOpen ? ctx_r0.hideRiderDetailsText : ctx_r0.showRiderDetailsText)("aria-expanded", ctx_r0.isOpen)("role", ctx_r0.linkRoles.BUTTON);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isOpen)("ngIfThen", _r2)("ngIfElse", _r4);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c1$1l, ctx_r0.newPlanCardDesignEnabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showLineBreak || ctx_r0.isOpen);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isOpen);
} }
class PlanRiderDetailsComponent {
    constructor() {
        this.showLineBreak = true;
        this.alignRiderDetailsTextToRight = true;
        this.newPlanCardDesignEnabled = false;
        this.clickViewDetails = new EventEmitter();
        this.isOpen = false;
        this.linkRoles = LinkRoles;
        this.planBenefitValueTypes = PlanBenefitValueType;
        this.targetType = TargetType;
    }
    toggleRiderDetails() {
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
            this.clickViewDetails.emit(this.rider);
        }
    }
}
PlanRiderDetailsComponent.ɵfac = function PlanRiderDetailsComponent_Factory(t) { return new (t || PlanRiderDetailsComponent)(); };
PlanRiderDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanRiderDetailsComponent, selectors: [["vnext-plan-rider-details"]], inputs: { rider: "rider", showLineBreak: "showLineBreak", showRiderDetails: "showRiderDetails", hideRiderDetailsText: "hideRiderDetailsText", showRiderDetailsText: "showRiderDetailsText", alignRiderDetailsTextToRight: "alignRiderDetailsTextToRight", newPlanCardDesignEnabled: "newPlanCardDesignEnabled" }, outputs: { clickViewDetails: "clickViewDetails" }, decls: 1, vars: 1, consts: [[4, "ngIf"], ["tabindex", "0", 1, "Spa_Style_Link", "link", "can-click", "focus-text", 3, "ngClass", "click", "keyup.enter"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["hideDetails", ""], ["viewDetails", ""], [3, "ngClass"], [1, "ml-1", "fas", "fa-angle-up"], [1, "sr-only"], [1, "ml-1", "fas", "fa-angle-down"], [4, "ngFor", "ngForOf"], [1, "Spa_Style_Paragraph", "rider-details", "d-inline"], [4, "ngIf", "ngIfElse"], ["defaultValue", ""], [3, "href", "title", "makeInlineBlock", "customClass", "linkTarget"], [3, "innerHtml"]], template: function PlanRiderDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanRiderDetailsComponent_ng_container_0_Template, 10, 15, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showRiderDetails && (ctx.rider.extendedPlanDetails[0] == null ? null : ctx.rider.extendedPlanDetails[0].sectionDetails.length));
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, IconAriaAttributesDirective, SafePipe], styles: [".show-hide-details[_ngcontent-%COMP%], .rider-details[_ngcontent-%COMP%]{margin-right:15px}.show-hide-details[_ngcontent-%COMP%]:focus, .rider-details[_ngcontent-%COMP%]:focus{margin-right:10px}.new-plan-card-enabled[_ngcontent-%COMP%]{margin-top:-20px}.new-plan-card-enabled[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{margin-top:16px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanRiderDetailsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-rider-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"showRiderDetails && rider.extendedPlanDetails[0]?.sectionDetails.length\">\r\n  <span\r\n    class=\"Spa_Style_Link link can-click focus-text\"\r\n    [ngClass]=\"{ 'float-right': alignRiderDetailsTextToRight, 'show-hide-details': !newPlanCardDesignEnabled }\"\r\n    (click)=\"toggleRiderDetails()\"\r\n    (keyup.enter)=\"toggleRiderDetails()\"\r\n    [attr.aria-label]=\"isOpen ? hideRiderDetailsText : showRiderDetailsText\"\r\n    tabindex=\"0\"\r\n    [attr.aria-expanded]=\"isOpen\"\r\n    [attr.role]=\"linkRoles.BUTTON\"\r\n  >\r\n    <ng-container *ngIf=\"isOpen; then hideDetails; else viewDetails\"></ng-container>\r\n    <ng-template #hideDetails>\r\n      <span>{{ hideRiderDetailsText }}<i class=\"ml-1 fas fa-angle-up\"></i><span class=\"sr-only\">Collapse</span></span>\r\n    </ng-template>\r\n    <ng-template #viewDetails>\r\n      <span>{{ showRiderDetailsText }}<i class=\"ml-1 fas fa-angle-down\"></i><span class=\"sr-only\">Expand</span></span>\r\n    </ng-template>\r\n  </span>\r\n\r\n  <div [ngClass]=\"{ 'new-plan-card-enabled': newPlanCardDesignEnabled }\">\r\n    <br *ngIf=\"showLineBreak || isOpen\" />\r\n    <ul *ngIf=\"isOpen\">\r\n      <li *ngFor=\"let riderDetails of rider.extendedPlanDetails[0].sectionDetails\">\r\n        <p class=\"Spa_Style_Paragraph rider-details d-inline\">\r\n          {{ riderDetails.name }}: \r\n          <ng-container *ngIf=\"riderDetails.valueTypeID === planBenefitValueTypes.LINK ; else defaultValue\">\r\n            <vnext-link\r\n              [href]=\"riderDetails.value\"\r\n              [title]=\"riderDetails.linkName\"\r\n              [makeInlineBlock]=\"true\"\r\n              [customClass]=\"'Spa_Style_Primary_Link'\"\r\n              [linkTarget]=\"targetType.BLANK\"\r\n            >\r\n            </vnext-link>\r\n          </ng-container>\r\n          <ng-template #defaultValue>\r\n            <span [innerHtml]=\"riderDetails.value | safe: 'html'\"></span>\r\n          </ng-template>\r\n        </p>\r\n      </li>\r\n    </ul>\r\n  </div>\r\n</ng-container>\r\n", styles: [".show-hide-details,.rider-details{margin-right:15px}.show-hide-details:focus,.rider-details:focus{margin-right:10px}.new-plan-card-enabled{margin-top:-20px}.new-plan-card-enabled ul{margin-top:16px}\n"] }]
    }], null, { rider: [{
            type: Input
        }], showLineBreak: [{
            type: Input
        }], showRiderDetails: [{
            type: Input
        }], hideRiderDetailsText: [{
            type: Input
        }], showRiderDetailsText: [{
            type: Input
        }], alignRiderDetailsTextToRight: [{
            type: Input
        }], newPlanCardDesignEnabled: [{
            type: Input
        }], clickViewDetails: [{
            type: Output
        }] }); })();

function PlanDefaultCostComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "customCurrency");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind4(2, 2, ctx_r0.costValue, "USD", "symbol", ctx_r0.currencyFormat), " ", ctx_r0.costDuration, "\n");
} }
function PlanDefaultCostComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "currency");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind4(1, 2, ctx_r2.costValue, "USD", "symbol", ctx_r2.currencyFormat), " ", ctx_r2.costDuration, " ");
} }
class PlanDefaultCostComponent {
    constructor(cdr, planDetailsFacade) {
        this.cdr = cdr;
        this.planDetailsFacade = planDetailsFacade;
        this.newPlanCardDesignEnabled = false;
        this.planDetailsCostLabels = PlanDetailsCostLabels;
        this.costValue = 0;
        this.currencyFormat = '1.0-0';
        this.subscription = new Subscription();
    }
    ngOnChanges(changes) {
        const { cost, isMailOrderSelected, plan } = changes;
        if ((cost && !_isEqual(cost.previousValue, cost.currentValue)) ||
            (isMailOrderSelected && isMailOrderSelected.previousValue !== isMailOrderSelected.currentValue) ||
            (plan && !_isEqual(plan.previousValue, plan.currentValue))) {
            this.updateCostValue();
        }
    }
    updateCostValue() {
        if (this.cost?.title) {
            //unsubscribe from any existing subscription to prevent memory leaks
            this.subscription.unsubscribe();
            this.subscription = this.getCostValue$(this.cost.title).subscribe(value => {
                this.costValue = value;
                this.currencyFormat = this.getCurrencyFormat(this.cost.title);
                this.cdr.markForCheck();
            });
        }
    }
    getCostValue$(label) {
        return this.planDetailsFacade.getCostValue$(this.plan, label, this.isMailOrderSelected);
    }
    getCurrencyFormat(label) {
        return this.planDetailsCostLabels.PREMIUM === label ? '1.2-2' : '1.0-0';
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
PlanDefaultCostComponent.ɵfac = function PlanDefaultCostComponent_Factory(t) { return new (t || PlanDefaultCostComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlanDetailsFacade)); };
PlanDefaultCostComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanDefaultCostComponent, selectors: [["vnext-plan-default-cost"]], inputs: { cost: "cost", isMailOrderSelected: "isMailOrderSelected", plan: "plan", costDuration: "costDuration", newPlanCardDesignEnabled: "newPlanCardDesignEnabled" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["defaultCurrencyFormat", ""]], template: function PlanDefaultCostComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanDefaultCostComponent_ng_container_0_Template, 3, 7, "ng-container", 0);
        i0.ɵɵtemplate(1, PlanDefaultCostComponent_ng_template_1_Template, 2, 7, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.newPlanCardDesignEnabled)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgIf, i1$2.CurrencyPipe, CustomCurrencyPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanDefaultCostComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-default-cost', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"newPlanCardDesignEnabled; else defaultCurrencyFormat\">\r\n  {{ costValue | customCurrency : 'USD' : 'symbol' : currencyFormat }} {{ costDuration }}\r\n</ng-container>\r\n<ng-template #defaultCurrencyFormat> {{ costValue | currency : 'USD' : 'symbol' : currencyFormat }} {{ costDuration }} </ng-template>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: PlanDetailsFacade }]; }, { cost: [{
            type: Input
        }], isMailOrderSelected: [{
            type: Input
        }], plan: [{
            type: Input
        }], costDuration: [{
            type: Input
        }], newPlanCardDesignEnabled: [{
            type: Input
        }] }); })();

function NextgenPlanSubDetailsComponent_div_0_div_5_div_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function NextgenPlanSubDetailsComponent_div_0_div_5_div_5_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelement(1, "i", 19);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.riderIsIncludedText, " ");
} }
function NextgenPlanSubDetailsComponent_div_0_div_5_div_5_ng_template_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rider_r5 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(rider_r5.planName);
} }
function NextgenPlanSubDetailsComponent_div_0_div_5_div_5_ng_template_4_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "customCurrency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rider_r5 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, rider_r5.calculatedPremium));
} }
function NextgenPlanSubDetailsComponent_div_0_div_5_div_5_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtemplate(1, NextgenPlanSubDetailsComponent_div_0_div_5_div_5_ng_template_4_div_1_Template, 2, 1, "div", 21);
    i0.ɵɵtemplate(2, NextgenPlanSubDetailsComponent_div_0_div_5_div_5_ng_template_4_div_2_Template, 3, 3, "div", 22);
    i0.ɵɵelement(3, "vnext-plan-rider-details", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rider_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", rider_r5.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", rider_r5.calculatedPremium);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("rider", rider_r5)("showRiderDetails", ctx_r11.showRiderDetails)("hideRiderDetailsText", ctx_r11.hideRiderDetailsText)("showRiderDetailsText", ctx_r11.showRiderDetailsText)("newPlanCardDesignEnabled", ctx_r11.newPlanCardDesignEnabled);
} }
const _c0$2E = function (a0) { return { "mt-3": a0 }; };
function NextgenPlanSubDetailsComponent_div_0_div_5_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, NextgenPlanSubDetailsComponent_div_0_div_5_div_5_ng_container_1_Template, 1, 0, "ng-container", 15);
    i0.ɵɵtemplate(2, NextgenPlanSubDetailsComponent_div_0_div_5_div_5_ng_template_2_Template, 3, 1, "ng-template", null, 16, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, NextgenPlanSubDetailsComponent_div_0_div_5_div_5_ng_template_4_Template, 4, 7, "ng-template", null, 17, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rider_r5 = ctx.$implicit;
    const i_r6 = ctx.index;
    const _r8 = i0.ɵɵreference(3);
    const _r10 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$2E, i_r6 > 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", rider_r5.isRequiredRider)("ngIfThen", _r8)("ngIfElse", _r10);
} }
function NextgenPlanSubDetailsComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "span", 10)(2, "span", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 12);
    i0.ɵɵtemplate(5, NextgenPlanSubDetailsComponent_div_0_div_5_div_5_Template, 6, 6, "div", 13);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const riderCategory_r3 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(riderCategory_r3 == null ? null : riderCategory_r3.label);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", riderCategory_r3.riders)("ngForTrackBy", ctx_r2.trackByIndex);
} }
function NextgenPlanSubDetailsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "h3", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 6)(4, "div", 7);
    i0.ɵɵtemplate(5, NextgenPlanSubDetailsComponent_div_0_div_5_Template, 6, 3, "div", 8);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.addOnCoverageHeaderText);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r0.riderCategories)("ngForTrackBy", ctx_r0.trackByIndex);
} }
function NextgenPlanSubDetailsComponent_div_1_div_5_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 28);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const extendedDetails_r19 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, extendedDetails_r19.value, "html"), i0.ɵɵsanitizeHtml);
} }
function NextgenPlanSubDetailsComponent_div_1_div_5_vnext_link_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-link", 29);
} if (rf & 2) {
    const extendedDetails_r19 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("title", extendedDetails_r19.linkName)("href", extendedDetails_r19.value)("alwaysUnderlined", true)("linkTarget", "_blank")("customClass", "Spa_Style_Link width-fit-content");
} }
function NextgenPlanSubDetailsComponent_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "span", 10)(2, "span", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 12)(5, "div", 20)(6, "div", 25);
    i0.ɵɵtemplate(7, NextgenPlanSubDetailsComponent_div_1_div_5_span_7_Template, 2, 4, "span", 26);
    i0.ɵɵtemplate(8, NextgenPlanSubDetailsComponent_div_1_div_5_vnext_link_8_Template, 1, 5, "vnext-link", 27);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const extendedDetails_r19 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(extendedDetails_r19.name);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !extendedDetails_r19.linkName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", extendedDetails_r19.linkName);
} }
function NextgenPlanSubDetailsComponent_div_1_ng_container_6_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 31);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r24.costEffectiveDate);
} }
function NextgenPlanSubDetailsComponent_div_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 9)(2, "span", 10)(3, "span", 11);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 30)(6, "span", 31);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, NextgenPlanSubDetailsComponent_div_1_ng_container_6_span_8_Template, 2, 1, "span", 32);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 12)(10, "div", 20)(11, "div", 25);
    i0.ɵɵelement(12, "vnext-plan-default-cost", 33);
    i0.ɵɵelementStart(13, "vnext-link", 34);
    i0.ɵɵlistener("click", function NextgenPlanSubDetailsComponent_div_1_ng_container_6_Template_vnext_link_click_13_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r25.onViewCostDetails()); })("keyup.enter", function NextgenPlanSubDetailsComponent_div_1_ng_container_6_Template_vnext_link_keyup_enter_13_listener() { i0.ɵɵrestoreView(_r26); const ctx_r27 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r27.onViewCostDetails()); });
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r18.costDetailLabel);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r18.costDetailSubText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.costEffectiveDate);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("newPlanCardDesignEnabled", ctx_r18.newPlanCardDesignEnabled)("cost", ctx_r18.costDetail)("isMailOrderSelected", ctx_r18.isMailOrderSelected)("plan", ctx_r18.detailedPlan)("costDuration", ctx_r18.isTotalEstimatedCostAnnually ? ctx_r18.costDetail.duration : ctx_r18.costDetail.duration2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("makeInlineBlock", true)("role", ctx_r18.linkRoles.LINK)("customClass", "Spa_Style_Link float-right")("title", ctx_r18.viewCostDetailsText);
} }
function NextgenPlanSubDetailsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "h3", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 6)(4, "div", 7);
    i0.ɵɵtemplate(5, NextgenPlanSubDetailsComponent_div_1_div_5_Template, 9, 3, "div", 8);
    i0.ɵɵtemplate(6, NextgenPlanSubDetailsComponent_div_1_ng_container_6_Template, 14, 12, "ng-container", 22);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.planBenefitHighlightsHeaderText);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.filteredExtendedPlanDetails)("ngForTrackBy", ctx_r1.trackByIndex);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.displayTotalEstimatedCost);
} }
class NextgenPlanSubDetailsComponent {
    constructor(planDetailsFacade, planFacade) {
        this.planDetailsFacade = planDetailsFacade;
        this.planFacade = planFacade;
        this.newPlanCardDesignEnabled = true;
        this.planBenefitHighlightItems = [];
        this.riderCategories = [];
        this.filteredExtendedPlanDetails = [];
        this.displayTotalEstimatedCost = false;
        this.viewAllPlanDetailsClicked = new EventEmitter();
        this.viewCostDetailsClicked = new EventEmitter();
        this.linkRoles = LinkRoles;
        this.isTotalEstimatedCostAnnually = false;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.subscriptions.add(this.planFacade.isTotalEstimatedCostAnnually$().subscribe(value => {
            this.isTotalEstimatedCostAnnually = value;
        }));
    }
    ngOnChanges(changes) {
        const { detailedPlan, viewDetailsDescriptionText, riderCategories } = changes;
        if ((detailedPlan && !_isEqual(detailedPlan.previousValue, detailedPlan.currentValue)) ||
            (viewDetailsDescriptionText && viewDetailsDescriptionText.previousValue !== viewDetailsDescriptionText.currentValue)) {
            this.getViewAllPlanDetailsAriaLabelText();
        }
        if (riderCategories && !_isEqual(riderCategories.previousValue, riderCategories.currentValue)) {
            this.updateRiderCategoriesWithPremiums();
        }
    }
    getViewAllPlanDetailsAriaLabelText() {
        this.viewAllPlanDetailsAriaLabelText = `${this.viewDetailsDescriptionText} ${this.detailedPlan?.planName || ''}`;
    }
    updateRiderCategoriesWithPremiums() {
        this.riderCategories = this.riderCategories.map(category => ({
            ...category,
            riders: category.riders.map(rider => {
                return {
                    ...rider,
                    calculatedPremium: this.getRiderMedicalPremium(rider)
                };
            })
        }));
    }
    getRiderMedicalPremium(rider) {
        const premium = this.planDetailsFacade.getRiderMedicalPremium(rider);
        if (premium === undefined || isNaN(premium)) {
            return null;
        }
        return premium;
    }
    onViewAllPlanDetails() {
        this.viewAllPlanDetailsClicked.emit();
    }
    onViewCostDetails() {
        this.viewCostDetailsClicked.emit();
    }
    trackByIndex(index) {
        return index;
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
NextgenPlanSubDetailsComponent.ɵfac = function NextgenPlanSubDetailsComponent_Factory(t) { return new (t || NextgenPlanSubDetailsComponent)(i0.ɵɵdirectiveInject(PlanDetailsFacade), i0.ɵɵdirectiveInject(PlanFacade)); };
NextgenPlanSubDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NextgenPlanSubDetailsComponent, selectors: [["vnext-nextgen-plan-sub-details"]], inputs: { newPlanCardDesignEnabled: "newPlanCardDesignEnabled", detailedPlan: "detailedPlan", viewAllPlanDetailsText: "viewAllPlanDetailsText", viewCostDetailsText: "viewCostDetailsText", planBenefitHighlightItems: "planBenefitHighlightItems", riderCategories: "riderCategories", filteredExtendedPlanDetails: "filteredExtendedPlanDetails", addOnCoverageHeaderText: "addOnCoverageHeaderText", planBenefitHighlightsHeaderText: "planBenefitHighlightsHeaderText", viewDetailsDescriptionText: "viewDetailsDescriptionText", showRiderDetails: "showRiderDetails", hideRiderDetailsText: "hideRiderDetailsText", showRiderDetailsText: "showRiderDetailsText", riderIsIncludedText: "riderIsIncludedText", displayTotalEstimatedCost: "displayTotalEstimatedCost", costDetail: "costDetail", costDetailLabel: "costDetailLabel", costDetailSubText: "costDetailSubText", costEffectiveDate: "costEffectiveDate", isMailOrderSelected: "isMailOrderSelected" }, outputs: { viewAllPlanDetailsClicked: "viewAllPlanDetailsClicked", viewCostDetailsClicked: "viewCostDetailsClicked" }, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 7, consts: [["class", "plan-card-extended-details-table-container mt-4", 4, "ngIf"], [1, "text-center"], [3, "isLinkButton", "customClass", "ariaLabel", "title", "click", "keyup.enter"], ["link-body", ""], [1, "plan-card-extended-details-table-container", "mt-4"], [1, "Spa_Style_H2"], ["role", "table", 1, "benefit-details", "benefit-details-table"], ["role", "rowgroup"], ["class", "row mx-0", "role", "row", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["role", "row", 1, "row", "mx-0"], ["role", "rowheader", 1, "col-md-4", "m-0", "plan-details-section-left", "Spa_Style_H5", "gray1-static"], [1, "Spa_Style_Primary_Color"], ["role", "cell", 1, "col-md-8", "plan-details-section-right"], [3, "ngClass", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "ngClass"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["requiredRider", ""], ["normalRider", ""], [1, "Spa_Style_H4"], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "included-icon", "Spa_Style_CheckmarksAndPreferredInNetwork"], [1, "Spa_Style_Bold_Weight", "Spa_Style_Primary_Color"], ["class", "Spa_Style_Paragraph pb-2 no-translate-block", 4, "ngIf"], [4, "ngIf"], [3, "rider", "showRiderDetails", "hideRiderDetailsText", "showRiderDetailsText", "newPlanCardDesignEnabled"], [1, "Spa_Style_Paragraph", "pb-2", "no-translate-block"], [1, "d-flex", "justify-content-between"], ["navigationAdapter", "", 3, "innerHTML", 4, "ngIf"], ["class", "Spa_Style_Link", 3, "title", "href", "alwaysUnderlined", "linkTarget", "customClass", 4, "ngIf"], ["navigationAdapter", "", 3, "innerHTML"], [1, "Spa_Style_Link", 3, "title", "href", "alwaysUnderlined", "linkTarget", "customClass"], [1, "Spa_Style_Smaller_Font", "pt-1", "d-inline-block"], [1, "Spa_Style_Gray4_Color", "d-inline", "mr-1"], ["class", "Spa_Style_Gray4_Color d-inline mr-1", 4, "ngIf"], [3, "newPlanCardDesignEnabled", "cost", "isMailOrderSelected", "plan", "costDuration"], [3, "makeInlineBlock", "role", "customClass", "title", "click", "keyup.enter"]], template: function NextgenPlanSubDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, NextgenPlanSubDetailsComponent_div_0_Template, 6, 3, "div", 0);
        i0.ɵɵtemplate(1, NextgenPlanSubDetailsComponent_div_1_Template, 7, 4, "div", 0);
        i0.ɵɵelementStart(2, "div", 1)(3, "vnext-link", 2);
        i0.ɵɵlistener("click", function NextgenPlanSubDetailsComponent_Template_vnext_link_click_3_listener() { return ctx.onViewAllPlanDetails(); })("keyup.enter", function NextgenPlanSubDetailsComponent_Template_vnext_link_keyup_enter_3_listener() { return ctx.onViewAllPlanDetails(); });
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementContainerStart(5);
        i0.ɵɵtext(6);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.riderCategories == null ? null : ctx.riderCategories.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.filteredExtendedPlanDetails == null ? null : ctx.filteredExtendedPlanDetails.length) || ctx.displayTotalEstimatedCost);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("isLinkButton", true)("customClass", "btn-reset Spa_Style_Link Spa_Style_Regular_Font Spa_Style_Semi_Bold_Weight d-inline-block mt-4")("ariaLabel", ctx.viewAllPlanDetailsAriaLabelText)("title", ctx.viewAllPlanDetailsAriaLabelText);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.viewAllPlanDetailsText, "");
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, NavigationAdapterDirective, IconAriaAttributesDirective, PlanRiderDetailsComponent, PlanDefaultCostComponent, SafePipe, CustomCurrencyPipe], styles: [".benefit-details-table[_ngcontent-%COMP%]{margin:0 -16px;border-top:1px solid var(--static-Spa_Style_Accent1)}.plan-details-section-left[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:15px 10px 15px 16px}.plan-details-section-right[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-width:0 0 1px;padding:15px 16px 15px 10px}.included-icon[_ngcontent-%COMP%]{font-family:\"Font Awesome 5 Pro\"}@media (max-width: 767.98px){.plan-details-section-left[_ngcontent-%COMP%]{border-bottom:0;border-right:0;padding-bottom:0}.plan-details-section-right[_ngcontent-%COMP%]{padding-left:15px;padding-top:5px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NextgenPlanSubDetailsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-nextgen-plan-sub-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"plan-card-extended-details-table-container mt-4\" *ngIf=\"riderCategories?.length\">\r\n  <h3 class=\"Spa_Style_H2\">{{ addOnCoverageHeaderText }}</h3>\r\n  <div role=\"table\" class=\"benefit-details benefit-details-table\">\r\n    <div role=\"rowgroup\">\r\n      <div class=\"row mx-0\" role=\"row\" *ngFor=\"let riderCategory of riderCategories; trackBy: trackByIndex\">\r\n        <span role=\"rowheader\" class=\"col-md-4 m-0 plan-details-section-left Spa_Style_H5 gray1-static\">\r\n          <span class=\"Spa_Style_Primary_Color\">{{ riderCategory?.label }}</span>\r\n        </span>\r\n\r\n        <div role=\"cell\" class=\"col-md-8 plan-details-section-right\">\r\n          <div *ngFor=\"let rider of riderCategory.riders; let i = index; trackBy: trackByIndex\" [ngClass]=\"{ 'mt-3': i > 0 }\">\r\n            <ng-container *ngIf=\"rider.isRequiredRider; then requiredRider; else normalRider\"></ng-container>\r\n\r\n            <ng-template #requiredRider>\r\n              <div class=\"Spa_Style_H4\">\r\n                <i class=\"fas fa-check-circle included-icon Spa_Style_CheckmarksAndPreferredInNetwork\" aria-hidden=\"true\"></i>\r\n                {{ riderIsIncludedText }}\r\n              </div>\r\n            </ng-template>\r\n\r\n            <ng-template #normalRider>\r\n              <div class=\"Spa_Style_Bold_Weight Spa_Style_Primary_Color\">\r\n                <div class=\"Spa_Style_Paragraph pb-2 no-translate-block\" *ngIf=\"rider.planName\">{{ rider.planName }}</div>\r\n                <div *ngIf=\"rider.calculatedPremium\">{{ rider.calculatedPremium | customCurrency }}</div>\r\n                <vnext-plan-rider-details\r\n                  [rider]=\"rider\"\r\n                  [showRiderDetails]=\"showRiderDetails\"\r\n                  [hideRiderDetailsText]=\"hideRiderDetailsText\"\r\n                  [showRiderDetailsText]=\"showRiderDetailsText\"\r\n                  [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n                ></vnext-plan-rider-details>\r\n              </div>\r\n            </ng-template>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"plan-card-extended-details-table-container mt-4\" *ngIf=\"filteredExtendedPlanDetails?.length || displayTotalEstimatedCost\">\r\n  <h3 class=\"Spa_Style_H2\">{{ planBenefitHighlightsHeaderText }}</h3>\r\n  <div role=\"table\" class=\"benefit-details benefit-details-table\">\r\n    <div role=\"rowgroup\">\r\n      <div class=\"row mx-0\" role=\"row\" *ngFor=\"let extendedDetails of filteredExtendedPlanDetails; trackBy: trackByIndex\">\r\n        <span role=\"rowheader\" class=\"col-md-4 m-0 plan-details-section-left Spa_Style_H5 gray1-static\">\r\n          <span class=\"Spa_Style_Primary_Color\">{{ extendedDetails.name }}</span>\r\n        </span>\r\n\r\n        <div role=\"cell\" class=\"col-md-8 plan-details-section-right\">\r\n          <div class=\"Spa_Style_Bold_Weight Spa_Style_Primary_Color\">\r\n            <div class=\"d-flex justify-content-between\">\r\n              <span *ngIf=\"!extendedDetails.linkName\" [innerHTML]=\"extendedDetails.value | safe : 'html'\" navigationAdapter></span>\r\n              <vnext-link\r\n                *ngIf=\"extendedDetails.linkName\"\r\n                [title]=\"extendedDetails.linkName\"\r\n                [href]=\"extendedDetails.value\"\r\n                [alwaysUnderlined]=\"true\"\r\n                class=\"Spa_Style_Link\"\r\n                [linkTarget]=\"'_blank'\"\r\n                [customClass]=\"'Spa_Style_Link width-fit-content'\"\r\n              >\r\n              </vnext-link>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <ng-container *ngIf=\"displayTotalEstimatedCost\">\r\n        <div class=\"row mx-0\" role=\"row\">\r\n          <span role=\"rowheader\" class=\"col-md-4 m-0 plan-details-section-left Spa_Style_H5 gray1-static\">\r\n            <span class=\"Spa_Style_Primary_Color\">{{ costDetailLabel }}</span>\r\n            <span class=\"Spa_Style_Smaller_Font pt-1 d-inline-block\">\r\n              <span class=\"Spa_Style_Gray4_Color d-inline mr-1\">{{ costDetailSubText }}</span>\r\n              <span *ngIf=\"costEffectiveDate\" class=\"Spa_Style_Gray4_Color d-inline mr-1\">{{ costEffectiveDate }}</span>\r\n            </span>\r\n          </span>\r\n\r\n          <div role=\"cell\" class=\"col-md-8 plan-details-section-right\">\r\n            <div class=\"Spa_Style_Bold_Weight Spa_Style_Primary_Color\">\r\n              <div class=\"d-flex justify-content-between\">\r\n                <vnext-plan-default-cost\r\n                  [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n                  [cost]=\"costDetail\"\r\n                  [isMailOrderSelected]=\"isMailOrderSelected\"\r\n                  [plan]=\"detailedPlan\"\r\n                  [costDuration]=\"isTotalEstimatedCostAnnually ? costDetail.duration : costDetail.duration2\"\r\n                ></vnext-plan-default-cost>\r\n                <vnext-link\r\n                  [makeInlineBlock]=\"true\"\r\n                  [role]=\"linkRoles.LINK\"\r\n                  (click)=\"onViewCostDetails()\"\r\n                  (keyup.enter)=\"onViewCostDetails()\"\r\n                  [customClass]=\"'Spa_Style_Link float-right'\"\r\n                  [title]=\"viewCostDetailsText\"\r\n                >\r\n                </vnext-link>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"text-center\">\r\n  <vnext-link\r\n    [isLinkButton]=\"true\"\r\n    (click)=\"onViewAllPlanDetails()\"\r\n    (keyup.enter)=\"onViewAllPlanDetails()\"\r\n    [customClass]=\"'btn-reset Spa_Style_Link Spa_Style_Regular_Font Spa_Style_Semi_Bold_Weight d-inline-block mt-4'\"\r\n    [ariaLabel]=\"viewAllPlanDetailsAriaLabelText\"\r\n    [title]=\"viewAllPlanDetailsAriaLabelText\"\r\n  >\r\n    <div link-body>\r\n      <ng-container> {{ viewAllPlanDetailsText }}</ng-container>\r\n    </div>\r\n  </vnext-link>\r\n</div>\r\n", styles: [".benefit-details-table{margin:0 -16px;border-top:1px solid var(--static-Spa_Style_Accent1)}.plan-details-section-left{border-right:1px solid var(--static-Spa_Style_Accent1);border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:15px 10px 15px 16px}.plan-details-section-right{border:1px solid var(--static-Spa_Style_Accent1);border-width:0 0 1px;padding:15px 16px 15px 10px}.included-icon{font-family:\"Font Awesome 5 Pro\"}@media (max-width: 767.98px){.plan-details-section-left{border-bottom:0;border-right:0;padding-bottom:0}.plan-details-section-right{padding-left:15px;padding-top:5px}}\n"] }]
    }], function () { return [{ type: PlanDetailsFacade }, { type: PlanFacade }]; }, { newPlanCardDesignEnabled: [{
            type: Input
        }], detailedPlan: [{
            type: Input
        }], viewAllPlanDetailsText: [{
            type: Input
        }], viewCostDetailsText: [{
            type: Input
        }], planBenefitHighlightItems: [{
            type: Input
        }], riderCategories: [{
            type: Input
        }], filteredExtendedPlanDetails: [{
            type: Input
        }], addOnCoverageHeaderText: [{
            type: Input
        }], planBenefitHighlightsHeaderText: [{
            type: Input
        }], viewDetailsDescriptionText: [{
            type: Input
        }], showRiderDetails: [{
            type: Input
        }], hideRiderDetailsText: [{
            type: Input
        }], showRiderDetailsText: [{
            type: Input
        }], riderIsIncludedText: [{
            type: Input
        }], displayTotalEstimatedCost: [{
            type: Input
        }], costDetail: [{
            type: Input
        }], costDetailLabel: [{
            type: Input
        }], costDetailSubText: [{
            type: Input
        }], costEffectiveDate: [{
            type: Input
        }], isMailOrderSelected: [{
            type: Input
        }], viewAllPlanDetailsClicked: [{
            type: Output
        }], viewCostDetailsClicked: [{
            type: Output
        }] }); })();

function NextgenPlanCardDetailExpandableComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-star-rating", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isMobile", ctx_r0.isMobile)("newPlanCardDesignEnabled", ctx_r0.newPlanCardDesignEnabled)("starRating", ctx_r0.plan == null ? null : ctx_r0.plan.planRating)("ratingValueDescription", ctx_r0.plan == null ? null : ctx_r0.plan.planRatingValueDescription)("showLowPerformanceIndicator", ctx_r0.plan == null ? null : ctx_r0.plan.isLowPerformingPlan)("isNotLicensed", ctx_r0.isNotLicensedToSell);
} }
function NextgenPlanCardDetailExpandableComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "span", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r1.planIdText, ":");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.fullPlanId);
} }
function NextgenPlanCardDetailExpandableComponent_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-widget-plan-card-rate-factors-statuses", 14);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("newPlanCardDesignEnabled", ctx_r2.newPlanCardDesignEnabled)("rateFactorsStatus", ctx_r2.plan.rateFactorsStatuses)("availableRateFactorsData", ctx_r2.availableRateFactorsData)("personalizedQuoteLabelText", ctx_r2.personalizedQuoteLabelText);
} }
class NextgenPlanCardDetailExpandableComponent {
    constructor(cdr, store, plansService, planDetailsFacade, pharmacyFacade, planFacade, navigationService, analyticsService) {
        this.cdr = cdr;
        this.store = store;
        this.plansService = plansService;
        this.planDetailsFacade = planDetailsFacade;
        this.pharmacyFacade = pharmacyFacade;
        this.planFacade = planFacade;
        this.navigationService = navigationService;
        this.analyticsService = analyticsService;
        this.newPlanCardDesignEnabled = true;
        this.planBenefitHighlightItems = [];
        this.waiverStateRiderTooltips = [];
        this.closeDetailCardClicked = new EventEmitter();
        this.planType = PlanType;
        this.planDetailsCostLabels = PlanDetailsCostLabels;
        this.riderCategories = [];
        this.extendedPlanDetails = [];
        this.filteredExtendedPlanDetails = [];
        this.displayTotalEstimatedCost = false;
        this.totalEstimatedCost = false;
        this.subscriptions = new Subscription();
    }
    ngOnChanges(changes) {
        const { plan } = changes;
        if (plan && !this.detailedPlan && !_isEqual(plan.previousValue, plan.currentValue)) {
            this.fetchPlan(this.plan);
        }
    }
    viewPlanDetailsPage(plan, activeTabTotalEstimatedCost = false) {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_VIEW_DETAILS);
        if (activeTabTotalEstimatedCost) {
            this.store.dispatch(new SetActiveTabTotalCost(true));
        }
        this.navigationService.navigateByPageTag(PageTags.PLAN_DETAILS, {
            queryParams: { id: plan.id }
        });
    }
    closePlanDetail() {
        this.closeDetailCardClicked.emit();
    }
    async fetchPlan(plan) {
        if (plan) {
            const updatedPlan = await this.plansService.fetchPlanDetails(plan);
            this.updatePlanWithDetails(updatedPlan);
            this.cdr.markForCheck();
        }
    }
    updatePlanWithDetails(detailedPlan) {
        if (detailedPlan) {
            this.planDetailsFacade.updatePayloadWithDetailedPlan(detailedPlan);
            this.detailedPlan = this.plansService.getPlan(detailedPlan.id);
            this.isHCPlan = this.detailedPlan.planType === this.planType.HC;
            this.riderCategories = this.generateRiderCategories(this.detailedPlan);
            this.isMailOrderSelected = this.pharmacyFacade.getIsMailOrderSelected();
            this.selectedPharmacy = this.pharmacyFacade.getSelectedPharmacy();
            this.extendedPlanDetails = this.planDetailsFacade.getExtendedPlanDetails(this.detailedPlan, this.selectedPharmacy, this.isMailOrderSelected);
            this.filterPlanBenefitHighlights();
            this.filterCostDetail();
        }
    }
    filterPlanBenefitHighlights() {
        if (this?.planBenefitHighlightItems !== undefined && this?.planBenefitHighlightItems !== null) {
            this.filteredExtendedPlanDetails = this.extendedPlanDetails.reduce((acc, currentSection) => {
                const matchingDetails = currentSection.sectionDetails.filter((subSectionDetail) => subSectionDetail.isOutOfNetwork === false &&
                    this.planBenefitHighlightItems.some(highlightItem => highlightItem.name === subSectionDetail.name));
                return [...acc, ...matchingDetails];
            }, []);
        }
    }
    filterCostDetail() {
        const planTypeCostMap = {
            [this.planType.MAPD]: this.costMAPD,
            [this.planType.MA]: this.costMA,
            [this.planType.PDP]: this.costPDP,
            [this.planType.MEDIGAP]: this.costMEDIGAP,
            [this.planType.DENTAL]: this.costDENTAL,
            [this.planType.VISION]: this.costVISION
        };
        const costs = planTypeCostMap[this.detailedPlan.planType];
        if (costs) {
            this.costDetail = costs.find(cost => cost.title === PlanDetailsCostLabels.TOTAL_ESTIMATED_COST);
        }
        if (this.costDetail) {
            if (this?.planBenefitHighlightItems !== undefined && this?.planBenefitHighlightItems !== null) {
                this.totalEstimatedCost = this.planBenefitHighlightItems.some(highlightItem => highlightItem.name === this.costDetail?.label || highlightItem.name === this.costDetail?.label2);
            }
            this.displayTotalEstimatedCost = !!this.totalEstimatedCost && this.filteredExtendedPlanDetails?.length <= 2;
            this.costDetailLabel = this.planFacade.isTotalEstimatedCostAnnually() ? this.costDetail?.label : this.costDetail?.label2;
            this.costDetailSubText = this.getCostSubText(this.costDetail);
            this.costEffectiveDate = this.getCostEffectiveDate();
        }
    }
    getRidersWithMatchingCategory(category, riderCategoryKey) {
        return this.planDetailsFacade.getRidersWithMatchingCategory(category, this.detailedPlan, riderCategoryKey);
    }
    getRiderMedicalPremium(rider) {
        const premium = this.planDetailsFacade.getRiderMedicalPremium(rider);
        if (premium === undefined || isNaN(premium)) {
            return null;
        }
        return premium;
    }
    getCostEffectiveDate() {
        const displayDate = !this.planFacade.isLastMonthOfYear() && !!this.planFacade.getTotalEstimatedCostEffectiveDate();
        return displayDate ? `(${this.planFacade.getTotalEstimatedCostEffectiveDate()})` : '';
    }
    getRiderIcon(riderSubType) {
        return this.planDetailsFacade.getRiderIcon(riderSubType);
    }
    getRidersByCategory(riderCategory) {
        return this.planDetailsFacade.getRidersByCategory(riderCategory, this.detailedPlan);
    }
    getRiderLabel(riderSubType) {
        return this.planDetailsFacade.getRiderLabel(riderSubType);
    }
    isWaiverStateRider(category) {
        return this.planDetailsFacade.isWaiverStateRider(category, this.detailedPlan);
    }
    getCostSubText(planCostDetails) {
        return this.planFacade.getCostSubText(planCostDetails, this.plan, this.selectedPharmacy);
    }
    waiverTooltip(riderSubType) {
        // if it is not a medicare rider sub type AND it has a tooltip value defined
        if (this.isWaiverStateRider(riderSubType) && this.waiverStateRiderTooltips.some(tooltip => tooltip.id === riderSubType)) {
            return this.waiverStateRiderTooltips.find(tooltip => tooltip.id === riderSubType).body;
        }
        return '';
    }
    generateRiderCategories(planDetail) {
        return this.planDetailsFacade
            .getRiderCategories(planDetail)
            .map(riderCategory => {
            const riderSortProperty = 'calculatedMedicalPremium';
            const riderMatchingProperty = this.isHCPlan ? 'planTypeDescription' : 'planSubType';
            const riders = this.planFacade
                .sortRiders(this.getRidersWithMatchingCategory(riderCategory, riderMatchingProperty), riderSortProperty)
                .filter(rider => this.getRiderMedicalPremium(rider) !== 0);
            const riderBenefitCategory = {
                riderGroupKey: riderCategory,
                icon: this.getRiderIcon(riderCategory),
                label: this.getRiderLabel(riderCategory),
                waiverTooltip: !this.isHCPlan ? this.waiverTooltip(riderCategory) : '',
                waiverStateRider: !this.isHCPlan ? this.isWaiverStateRider(riderCategory) : false,
                selectable: true,
                riders,
                selectedRider: null
            };
            return riderBenefitCategory;
        })
            .filter(category => category.riders?.length);
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
NextgenPlanCardDetailExpandableComponent.ɵfac = function NextgenPlanCardDetailExpandableComponent_Factory(t) { return new (t || NextgenPlanCardDetailExpandableComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(PlanDetailsFacade), i0.ɵɵdirectiveInject(PharmacyFacade), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(AnalyticsService)); };
NextgenPlanCardDetailExpandableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NextgenPlanCardDetailExpandableComponent, selectors: [["vnext-nextgen-plan-card-detail-expandable"]], inputs: { plan: "plan", newPlanCardDesignEnabled: "newPlanCardDesignEnabled", isNotLicensedToSell: "isNotLicensedToSell", isMobile: "isMobile", showStarRating: "showStarRating", showPlanId: "showPlanId", fullPlanId: "fullPlanId", planIdText: "planIdText", viewAllPlanDetailsText: "viewAllPlanDetailsText", shareThisPlanText: "shareThisPlanText", viewCostDetailsText: "viewCostDetailsText", closeText: "closeText", planBenefitHighlightItems: "planBenefitHighlightItems", costMA: "costMA", costMAPD: "costMAPD", costMEDIGAP: "costMEDIGAP", costPDP: "costPDP", costDENTAL: "costDENTAL", costVISION: "costVISION", viewDetailsDescriptionText: "viewDetailsDescriptionText", addOnCoverageHeaderText: "addOnCoverageHeaderText", planBenefitHighlightsHeaderText: "planBenefitHighlightsHeaderText", showRiderDetails: "showRiderDetails", hideRiderDetailsText: "hideRiderDetailsText", showRiderDetailsText: "showRiderDetailsText", riderIsIncludedText: "riderIsIncludedText", waiverStateRiderTooltips: "waiverStateRiderTooltips", showAvailableRateFactorsEnabled: "showAvailableRateFactorsEnabled", availableRateFactorsData: "availableRateFactorsData", personalizedQuoteLabelText: "personalizedQuoteLabelText" }, outputs: { closeDetailCardClicked: "closeDetailCardClicked" }, features: [i0.ɵɵNgOnChangesFeature], decls: 15, vars: 27, consts: [[1, "plan-card-extended-details", "Spa_Style_Gray1_Background"], ["type", "button", 1, "plan-card-extended-details-close", "close", "fas", "fa-times", 3, "click"], [1, "sr-only", "no-translate-block"], [1, "plan-card-extended-details-top"], [1, "plan-card-extended-details-highlights"], [4, "ngIf"], ["class", "Spa_Style_Note mt-1", 4, "ngIf"], [1, "plan-card-extended-details-actions"], [1, "plan-card-extended-details-buttons"], [1, "mt-1", "can-click", "btn", "Spa_Style_TertiaryButton", 3, "click"], [3, "detailedPlan", "newPlanCardDesignEnabled", "viewAllPlanDetailsText", "viewCostDetailsText", "planBenefitHighlightItems", "addOnCoverageHeaderText", "planBenefitHighlightsHeaderText", "viewDetailsDescriptionText", "showRiderDetails", "hideRiderDetailsText", "showRiderDetailsText", "riderIsIncludedText", "riderCategories", "filteredExtendedPlanDetails", "isMailOrderSelected", "displayTotalEstimatedCost", "costDetail", "costDetailLabel", "costDetailSubText", "costEffectiveDate", "viewAllPlanDetailsClicked", "viewCostDetailsClicked"], [3, "isMobile", "newPlanCardDesignEnabled", "starRating", "ratingValueDescription", "showLowPerformanceIndicator", "isNotLicensed"], [1, "Spa_Style_Note", "mt-1"], [1, "mr-1"], [3, "newPlanCardDesignEnabled", "rateFactorsStatus", "availableRateFactorsData", "personalizedQuoteLabelText"]], template: function NextgenPlanCardDetailExpandableComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
        i0.ɵɵlistener("click", function NextgenPlanCardDetailExpandableComponent_Template_button_click_1_listener() { return ctx.closePlanDetail(); });
        i0.ɵɵelementStart(2, "span", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 3)(5, "div", 4);
        i0.ɵɵtemplate(6, NextgenPlanCardDetailExpandableComponent_ng_container_6_Template, 2, 6, "ng-container", 5);
        i0.ɵɵtemplate(7, NextgenPlanCardDetailExpandableComponent_div_7_Template, 5, 2, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 7)(9, "div", 8)(10, "button", 9);
        i0.ɵɵlistener("click", function NextgenPlanCardDetailExpandableComponent_Template_button_click_10_listener() { return ctx.viewPlanDetailsPage(ctx.plan); });
        i0.ɵɵelementStart(11, "span");
        i0.ɵɵtext(12);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵtemplate(13, NextgenPlanCardDetailExpandableComponent_ng_container_13_Template, 2, 4, "ng-container", 5);
        i0.ɵɵelementStart(14, "vnext-nextgen-plan-sub-details", 10);
        i0.ɵɵlistener("viewAllPlanDetailsClicked", function NextgenPlanCardDetailExpandableComponent_Template_vnext_nextgen_plan_sub_details_viewAllPlanDetailsClicked_14_listener() { return ctx.viewPlanDetailsPage(ctx.plan); })("viewCostDetailsClicked", function NextgenPlanCardDetailExpandableComponent_Template_vnext_nextgen_plan_sub_details_viewCostDetailsClicked_14_listener() { return ctx.viewPlanDetailsPage(ctx.plan, true); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate2("", ctx.closeText, " ", ctx.plan == null ? null : ctx.plan.planName, "");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.showStarRating);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showPlanId && ctx.fullPlanId);
        i0.ɵɵadvance(3);
        i0.ɵɵattribute("aria-label", (ctx.plan == null ? null : ctx.plan.planName) + ": " + ctx.viewAllPlanDetailsText);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.viewAllPlanDetailsText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showAvailableRateFactorsEnabled && ctx.plan.planType === ctx.planType.MEDIGAP && (ctx.plan.rateFactorsStatuses == null ? null : ctx.plan.rateFactorsStatuses.length));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("detailedPlan", ctx.detailedPlan)("newPlanCardDesignEnabled", ctx.newPlanCardDesignEnabled)("viewAllPlanDetailsText", ctx.viewAllPlanDetailsText)("viewCostDetailsText", ctx.viewCostDetailsText)("planBenefitHighlightItems", ctx.planBenefitHighlightItems)("addOnCoverageHeaderText", ctx.addOnCoverageHeaderText)("planBenefitHighlightsHeaderText", ctx.planBenefitHighlightsHeaderText)("viewDetailsDescriptionText", ctx.viewDetailsDescriptionText)("showRiderDetails", ctx.showRiderDetails)("hideRiderDetailsText", ctx.hideRiderDetailsText)("showRiderDetailsText", ctx.showRiderDetailsText)("riderIsIncludedText", ctx.riderIsIncludedText)("riderCategories", ctx.riderCategories)("filteredExtendedPlanDetails", ctx.filteredExtendedPlanDetails)("isMailOrderSelected", ctx.isMailOrderSelected)("displayTotalEstimatedCost", ctx.displayTotalEstimatedCost)("costDetail", ctx.costDetail)("costDetailLabel", ctx.costDetailLabel)("costDetailSubText", ctx.costDetailSubText)("costEffectiveDate", ctx.costEffectiveDate);
    } }, dependencies: [i1$2.NgIf, PlanCardRateFactorsStatusesComponent, NextgenPlanSubDetailsComponent, StarRatingComponent], styles: [".plan-card-extended-details[_ngcontent-%COMP%]{border-top:1px solid var(--static-Spa_Style_Accent1);padding:16px;border-radius:0 0 3px 3px;position:relative}.plan-card-extended-details-top[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.plan-card-extended-details-actions[_ngcontent-%COMP%]{display:flex;justify-content:space-between;padding-right:25px}.benefit-details-table[_ngcontent-%COMP%]{margin:0 -16px;border-top:1px solid var(--static-Spa_Style_Accent1)}button.plan-card-extended-details-close[_ngcontent-%COMP%]{font-size:1rem;opacity:1;position:absolute;right:15px;top:15px}@media (max-width: 767.98px){.plan-card-extended-details-top[_ngcontent-%COMP%]{display:block}.plan-card-extended-details-actions[_ngcontent-%COMP%]{margin-top:10px}}@media (max-width: 575.98px){.plan-card-extended-details-actions[_ngcontent-%COMP%]{display:block;padding-right:0}.plan-card-extended-details-buttons[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]{margin-bottom:10px;width:100%}.plan-card-extended-details-buttons[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]:last-child{margin-bottom:0}}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], NextgenPlanCardDetailExpandableComponent.prototype, "viewPlanDetailsPage", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NextgenPlanCardDetailExpandableComponent, [{
        type: Component,
        args: [{ selector: 'vnext-nextgen-plan-card-detail-expandable', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"plan-card-extended-details Spa_Style_Gray1_Background\">\r\n  <button type=\"button\" class=\"plan-card-extended-details-close close fas fa-times\" (click)=\"closePlanDetail()\">\r\n    <span class=\"sr-only no-translate-block\">{{ closeText }} {{ plan?.planName }}</span>\r\n  </button>\r\n  <div class=\"plan-card-extended-details-top\">\r\n    <div class=\"plan-card-extended-details-highlights\">\r\n      <ng-container *ngIf=\"showStarRating\">\r\n        <vnext-star-rating\r\n          [isMobile]=\"isMobile\"\r\n          [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n          [starRating]=\"plan?.planRating\"\r\n          [ratingValueDescription]=\"plan?.planRatingValueDescription\"\r\n          [showLowPerformanceIndicator]=\"plan?.isLowPerformingPlan\"\r\n          [isNotLicensed]=\"isNotLicensedToSell\"\r\n        ></vnext-star-rating>\r\n      </ng-container>\r\n\r\n      <div *ngIf=\"showPlanId && fullPlanId\" class=\"Spa_Style_Note mt-1\">\r\n        <span class=\"mr-1\">{{ planIdText }}:</span><span>{{ fullPlanId }}</span>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"plan-card-extended-details-actions\">\r\n      <div class=\"plan-card-extended-details-buttons\">\r\n        <button\r\n          class=\"mt-1 can-click btn Spa_Style_TertiaryButton\"\r\n          (click)=\"viewPlanDetailsPage(plan)\"\r\n          [attr.aria-label]=\"plan?.planName + ': ' + viewAllPlanDetailsText\"\r\n        >\r\n          <span>{{ viewAllPlanDetailsText }}</span>\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <ng-container *ngIf=\"showAvailableRateFactorsEnabled && plan.planType === planType.MEDIGAP && plan.rateFactorsStatuses?.length\">\r\n    <vnext-widget-plan-card-rate-factors-statuses\r\n      [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n      [rateFactorsStatus]=\"plan.rateFactorsStatuses\"\r\n      [availableRateFactorsData]=\"availableRateFactorsData\"\r\n      [personalizedQuoteLabelText]=\"personalizedQuoteLabelText\"\r\n    ></vnext-widget-plan-card-rate-factors-statuses>\r\n  </ng-container>\r\n\r\n  <vnext-nextgen-plan-sub-details\r\n    [detailedPlan]=\"detailedPlan\"\r\n    [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n    [viewAllPlanDetailsText]=\"viewAllPlanDetailsText\"\r\n    [viewCostDetailsText]=\"viewCostDetailsText\"\r\n    [planBenefitHighlightItems]=\"planBenefitHighlightItems\"\r\n    [addOnCoverageHeaderText]=\"addOnCoverageHeaderText\"\r\n    [planBenefitHighlightsHeaderText]=\"planBenefitHighlightsHeaderText\"\r\n    [viewDetailsDescriptionText]=\"viewDetailsDescriptionText\"\r\n    [showRiderDetails]=\"showRiderDetails\"\r\n    [hideRiderDetailsText]=\"hideRiderDetailsText\"\r\n    [showRiderDetailsText]=\"showRiderDetailsText\"\r\n    [riderIsIncludedText]=\"riderIsIncludedText\"\r\n    [riderCategories]=\"riderCategories\"\r\n    [filteredExtendedPlanDetails]=\"filteredExtendedPlanDetails\"\r\n    [isMailOrderSelected]=\"isMailOrderSelected\"\r\n    [displayTotalEstimatedCost]=\"displayTotalEstimatedCost\"\r\n    [costDetail]=\"costDetail\"\r\n    [costDetailLabel]=\"costDetailLabel\"\r\n    [costDetailSubText]=\"costDetailSubText\"\r\n    [costEffectiveDate]=\"costEffectiveDate\"\r\n    (viewAllPlanDetailsClicked)=\"viewPlanDetailsPage(plan)\"\r\n    (viewCostDetailsClicked)=\"viewPlanDetailsPage(plan, true)\"\r\n  >\r\n  </vnext-nextgen-plan-sub-details>\r\n</div>\r\n", styles: [".plan-card-extended-details{border-top:1px solid var(--static-Spa_Style_Accent1);padding:16px;border-radius:0 0 3px 3px;position:relative}.plan-card-extended-details-top{display:flex;justify-content:space-between}.plan-card-extended-details-actions{display:flex;justify-content:space-between;padding-right:25px}.benefit-details-table{margin:0 -16px;border-top:1px solid var(--static-Spa_Style_Accent1)}button.plan-card-extended-details-close{font-size:1rem;opacity:1;position:absolute;right:15px;top:15px}@media (max-width: 767.98px){.plan-card-extended-details-top{display:block}.plan-card-extended-details-actions{margin-top:10px}}@media (max-width: 575.98px){.plan-card-extended-details-actions{display:block;padding-right:0}.plan-card-extended-details-buttons>button{margin-bottom:10px;width:100%}.plan-card-extended-details-buttons>button:last-child{margin-bottom:0}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i2.Store }, { type: i1.PlansService }, { type: PlanDetailsFacade }, { type: PharmacyFacade }, { type: PlanFacade }, { type: i1.NavigationService }, { type: AnalyticsService }]; }, { plan: [{
            type: Input
        }], newPlanCardDesignEnabled: [{
            type: Input
        }], isNotLicensedToSell: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], showStarRating: [{
            type: Input
        }], showPlanId: [{
            type: Input
        }], fullPlanId: [{
            type: Input
        }], planIdText: [{
            type: Input
        }], viewAllPlanDetailsText: [{
            type: Input
        }], shareThisPlanText: [{
            type: Input
        }], viewCostDetailsText: [{
            type: Input
        }], closeText: [{
            type: Input
        }], planBenefitHighlightItems: [{
            type: Input
        }], costMA: [{
            type: Input
        }], costMAPD: [{
            type: Input
        }], costMEDIGAP: [{
            type: Input
        }], costPDP: [{
            type: Input
        }], costDENTAL: [{
            type: Input
        }], costVISION: [{
            type: Input
        }], viewDetailsDescriptionText: [{
            type: Input
        }], addOnCoverageHeaderText: [{
            type: Input
        }], planBenefitHighlightsHeaderText: [{
            type: Input
        }], showRiderDetails: [{
            type: Input
        }], hideRiderDetailsText: [{
            type: Input
        }], showRiderDetailsText: [{
            type: Input
        }], riderIsIncludedText: [{
            type: Input
        }], waiverStateRiderTooltips: [{
            type: Input
        }], showAvailableRateFactorsEnabled: [{
            type: Input
        }], availableRateFactorsData: [{
            type: Input
        }], personalizedQuoteLabelText: [{
            type: Input
        }], closeDetailCardClicked: [{
            type: Output
        }], viewPlanDetailsPage: [] }); })();

function ShoppingCartButtonComponent_ng_container_0_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.Spa_Site_PlanNotAvailableForNextYear_Text, " ");
} }
function ShoppingCartButtonComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵtemplate(2, ShoppingCartButtonComponent_ng_container_0_ng_container_1_div_2_Template, 2, 1, "div", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.showPlanNotAvailableForNextYearText);
} }
function ShoppingCartButtonComponent_ng_container_0_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 7);
    i0.ɵɵlistener("click", function ShoppingCartButtonComponent_ng_container_0_ng_template_2_ng_container_0_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r10.planFacade.viewEnrollmentConfirmation(ctx_r10.plan)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("title", "", ctx_r9.plan == null ? null : ctx_r9.plan.planName, ": ", ctx_r9.Spa_Site_Keep_This_Plan_Button_Text, "");
    i0.ɵɵattribute("aria-label", (ctx_r9.plan == null ? null : ctx_r9.plan.planName) + ": " + ctx_r9.Spa_Site_Keep_This_Plan_Button_Text)("role", ctx_r9.linkRoles.LINK);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.Spa_Site_Keep_This_Plan_Button_Text, " ");
} }
function ShoppingCartButtonComponent_ng_container_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ShoppingCartButtonComponent_ng_container_0_ng_template_2_ng_container_0_Template, 3, 5, "ng-container", 0);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r6 = i0.ɵɵreference(5);
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r5.plan.isNextYearPlan && !ctx_r5.plan.isPlanRolloverTerminated && !ctx_r5.isClientDefinedPlanOption)("ngIfElse", _r6);
} }
const _c0$2D = function (a0, a1) { return { "p-1 Spa_Style_Small_Font": a0, "mb-3": a1 }; };
function ShoppingCartButtonComponent_ng_container_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8, 9);
    i0.ɵɵlistener("click", function ShoppingCartButtonComponent_ng_container_0_ng_template_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r14); const _r12 = i0.ɵɵreference(1); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.selectPlan(_r12)); })("blur", function ShoppingCartButtonComponent_ng_container_0_ng_template_4_Template_button_blur_0_listener() { i0.ɵɵrestoreView(_r14); const _r12 = i0.ɵɵreference(1); const ctx_r15 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r15.cartFacade.closeTooltip(_r12)); });
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c0$2D, ctx_r7.isComparePage, ctx_r7.newPlanCardDesignEnabled))("ngbTooltip", ctx_r7.Spa_Site_EnrollerButton_Tooltip_Text)("disabled", !i0.ɵɵpipeBind1(2, 6, ctx_r7.canClickEnrollmentButton$));
    i0.ɵɵattribute("aria-label", (ctx_r7.plan == null ? null : ctx_r7.plan.planName) + ": " + ctx_r7.buttonText)("role", ctx_r7.linkRoles.LINK);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.buttonText, " ");
} }
function ShoppingCartButtonComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ShoppingCartButtonComponent_ng_container_0_ng_container_1_Template, 3, 1, "ng-container", 0);
    i0.ɵɵtemplate(2, ShoppingCartButtonComponent_ng_container_0_ng_template_2_Template, 1, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, ShoppingCartButtonComponent_ng_container_0_ng_template_4_Template, 4, 11, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r4 = i0.ɵɵreference(3);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.plan.isCurrentYearPlan)("ngIfElse", _r4);
} }
function ShoppingCartButtonComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.Spa_PlanCard_NotLicensed_Text);
} }
class ShoppingCartButtonComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, medSupService, demographicService, shopingCartService, cartFacade, planFacade, loginFacade, planListFacade, siteService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.medSupService = medSupService;
        this.demographicService = demographicService;
        this.shopingCartService = shopingCartService;
        this.cartFacade = cartFacade;
        this.planFacade = planFacade;
        this.loginFacade = loginFacade;
        this.planListFacade = planListFacade;
        this.siteService = siteService;
        this.newPlanCardDesignEnabled = false;
        this.subscriptions = new Subscription();
        this.cartIsEnabled = true;
        this.isClientDefinedPlanOption = false;
        this.showPlanNotAvailableForNextYearText = true;
        this.linkRoles = LinkRoles;
        this.Spa_Enrollment_BeneficiaryCutoffByMonth = true;
        this.Spa_Site_EnrollerButton_Tooltip_Text = `You don't have permission to take this action.`;
        this.Spa_PlanCard_NotLicensed_Text = 'Not licensed to sell/quote';
        this.Spa_Site_Keep_This_Plan_Button_Text = 'Keep this plan';
        this.Spa_Retention_ClientDefinedPlanOptions_Enabled = false;
        this.Spa_Site_PlanNotAvailableForNextYear_Text = 'Plan not available next year';
    }
    ngOnInit() {
        super.ngOnInit();
        this.cartIsEnabled = this.shopingCartService.isCartEnabled();
        this.isClientDefinedPlanOption = this.planFacade.displayAsClientDefinedOption(this.plan, this.Spa_Retention_ClientDefinedPlanOptions_Enabled);
        this.subscriptions.add(this.planListFacade.getShowPlanNotAvailableForNextYearText$().subscribe(showText => {
            this.showPlanNotAvailableForNextYearText = showText;
        }));
    }
    get buttonText() {
        return this.cartIsEnabled ? this.Spa_ShoppingCart_AddToCart_Text : this.Spa_ShoppingCart_Enroll_Text;
    }
    get canClickEnrollmentButton$() {
        if (!this.cartIsEnabled && this.plan.enrollViaSTBOnly && !this.siteService.isPPCSite()) {
            return of(false);
        }
        return this.medSupService.allowEnrollment$(this.plan);
    }
    selectPlan(toolTip) {
        // A HIP plan needs to have its default benefit selected regardless of if we go to cart or straight to enrollment
        if (this.plan.planTypeAbbreviation === PlanTypeAbbreviation.HC) {
            this.cartFacade.selectHIPDefaultBenefit(this.plan);
        }
        // If cart is enabled, check agent enroll permissions from cart instead of plan list page
        if (this.cartIsEnabled) {
            this.cartFacade.selectAndValidatePlan(this.plan, this.widgetName);
        }
        else if (this.loginFacade.checkToPromptMemberPortalLogin()) {
            // For member portal
            this.loginFacade.showExternalLoginPrompt();
        }
        else {
            const fips = this.demographicService.getSelectedFipsCode();
            const effectiveDate = this.cartFacade.getAgentPlanPermissionEffectiveDate(this.plan.planType);
            this.cartFacade.selectPlanAndEnroll(this.plan, effectiveDate, fips, toolTip, this.widgetName);
        }
    }
}
ShoppingCartButtonComponent.ɵfac = function ShoppingCartButtonComponent_Factory(t) { return new (t || ShoppingCartButtonComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.MedSupService), i0.ɵɵdirectiveInject(i1.DemographicService), i0.ɵɵdirectiveInject(i1.ShoppingCartService), i0.ɵɵdirectiveInject(CartFacade), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(LoginFacade), i0.ɵɵdirectiveInject(PlanListFacadeService), i0.ɵɵdirectiveInject(i1.SiteService)); };
ShoppingCartButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ShoppingCartButtonComponent, selectors: [["vnext-shopping-cart-button"]], inputs: { newPlanCardDesignEnabled: "newPlanCardDesignEnabled", plan: "plan", isComparePage: "isComparePage", queuePosition: "queuePosition" }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["cantSell", ""], ["keepThisPlan", ""], ["addToCart", ""], [1, "not-available-text-container"], ["class", "Spa_Style_Paragraph text-center not-available-text", 4, "ngIf"], [1, "Spa_Style_Paragraph", "text-center", "not-available-text"], [1, "btn", "btn-block", "mt-2", "mt-sm-0", "text-center", "Spa_Style_PrimaryButton", 3, "title", "click"], ["type", "button", "triggers", "manual", 1, "btn", "btn-block", "Spa_Style_PrimaryButton", "px-1", 3, "ngClass", "ngbTooltip", "disabled", "click", "blur"], ["tooltip", "ngbTooltip"], [1, "cant-sell-text", "Spa_Style_Small_Font", "text-center", "align-items-center", "justify-content-center", "d-flex"]], template: function ShoppingCartButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ShoppingCartButtonComponent_ng_container_0_Template, 6, 2, "ng-container", 0);
        i0.ɵɵtemplate(1, ShoppingCartButtonComponent_ng_template_1_Template, 3, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.planFacade.canSellPlan(ctx.plan))("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$1.NgbTooltip, i1$2.AsyncPipe], styles: [".cant-sell-text[_ngcontent-%COMP%]{min-height:31px}.not-available-text-container[_ngcontent-%COMP%]{min-height:38px;display:flex;align-items:center}.not-available-text[_ngcontent-%COMP%]{width:100%}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], ShoppingCartButtonComponent.prototype, "Spa_ShoppingCart_AddToCart_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartButtonComponent.prototype, "Spa_ShoppingCart_Enroll_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartButtonComponent.prototype, "Spa_Enrollment_BeneficiaryCutoffByMonth", void 0);
__decorate([
    GlobalResource()
], ShoppingCartButtonComponent.prototype, "Spa_Site_EnrollerButton_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartButtonComponent.prototype, "Spa_PlanCard_NotLicensed_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartButtonComponent.prototype, "Spa_Site_Keep_This_Plan_Button_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartButtonComponent.prototype, "Spa_Retention_ClientDefinedPlanOptions_Enabled", void 0);
__decorate([
    GlobalResource()
], ShoppingCartButtonComponent.prototype, "Spa_Site_PlanNotAvailableForNextYear_Text", void 0);
__decorate([
    LiveEditInactive()
], ShoppingCartButtonComponent.prototype, "selectPlan", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShoppingCartButtonComponent, [{
        type: Component,
        args: [{ selector: 'vnext-shopping-cart-button', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<ng-container *ngIf=\"planFacade.canSellPlan(plan); else cantSell\">\r\n  <ng-container *ngIf=\"plan.isCurrentYearPlan; else keepThisPlan\">\r\n    <div class=\"not-available-text-container\">\r\n      <div *ngIf=\"showPlanNotAvailableForNextYearText\" class=\"Spa_Style_Paragraph text-center not-available-text\">\r\n        {{ Spa_Site_PlanNotAvailableForNextYear_Text }}\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n  <ng-template #keepThisPlan>\r\n    <ng-container *ngIf=\"plan.isNextYearPlan && !plan.isPlanRolloverTerminated && !isClientDefinedPlanOption; else addToCart\">\r\n      <button\r\n        class=\"btn btn-block mt-2 mt-sm-0 text-center Spa_Style_PrimaryButton\"\r\n        (click)=\"planFacade.viewEnrollmentConfirmation(plan)\"\r\n        title=\"{{ plan?.planName }}: {{ Spa_Site_Keep_This_Plan_Button_Text }}\"\r\n        [attr.aria-label]=\"plan?.planName + ': ' + Spa_Site_Keep_This_Plan_Button_Text\"\r\n        [attr.role]=\"linkRoles.LINK\"\r\n      >\r\n        {{ Spa_Site_Keep_This_Plan_Button_Text }}\r\n      </button>\r\n    </ng-container>\r\n  </ng-template>\r\n  <ng-template #addToCart>\r\n    <button\r\n      type=\"button\"\r\n      (click)=\"selectPlan(tooltip)\"\r\n      (blur)=\"cartFacade.closeTooltip(tooltip)\"\r\n      class=\"btn btn-block Spa_Style_PrimaryButton px-1\"\r\n      [ngClass]=\"{ 'p-1 Spa_Style_Small_Font': isComparePage, 'mb-3': newPlanCardDesignEnabled }\"\r\n      [ngbTooltip]=\"Spa_Site_EnrollerButton_Tooltip_Text\"\r\n      [disabled]=\"!(canClickEnrollmentButton$ | async)\"\r\n      #tooltip=\"ngbTooltip\"\r\n      triggers=\"manual\"\r\n      [attr.aria-label]=\"plan?.planName + ': ' + buttonText\"\r\n      [attr.role]=\"linkRoles.LINK\"\r\n    >\r\n      {{ buttonText }}\r\n    </button>\r\n  </ng-template>\r\n</ng-container>\r\n<ng-template #cantSell>\r\n  <div class=\"cant-sell-text Spa_Style_Small_Font text-center align-items-center justify-content-center d-flex\">\r\n    <span>{{ Spa_PlanCard_NotLicensed_Text }}</span>\r\n  </div>\r\n</ng-template>\r\n", styles: [".cant-sell-text{min-height:31px}.not-available-text-container{min-height:38px;display:flex;align-items:center}.not-available-text{width:100%}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.MedSupService }, { type: i1.DemographicService }, { type: i1.ShoppingCartService }, { type: CartFacade }, { type: PlanFacade }, { type: LoginFacade }, { type: PlanListFacadeService }, { type: i1.SiteService }]; }, { newPlanCardDesignEnabled: [{
            type: Input
        }], plan: [{
            type: Input
        }], isComparePage: [{
            type: Input
        }], queuePosition: [{
            type: Input
        }], Spa_ShoppingCart_AddToCart_Text: [], Spa_ShoppingCart_Enroll_Text: [], Spa_Enrollment_BeneficiaryCutoffByMonth: [], Spa_Site_EnrollerButton_Tooltip_Text: [], Spa_PlanCard_NotLicensed_Text: [], Spa_Site_Keep_This_Plan_Button_Text: [], Spa_Retention_ClientDefinedPlanOptions_Enabled: [], Spa_Site_PlanNotAvailableForNextYear_Text: [], selectPlan: [] }); })();

function PlanBenefitsComponent_ul_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li", 4)(2, "div", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const benefit_r3 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(benefit_r3.label);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.getBenefitValue(benefit_r3.title));
} }
function PlanBenefitsComponent_ul_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 2);
    i0.ɵɵtemplate(1, PlanBenefitsComponent_ul_0_ng_container_1_Template, 6, 2, "ng-container", 3);
    i0.ɵɵpipe(2, "orderBy");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(2, 1, ctx_r0.filteredPlanBenefits, "order"));
} }
const _c0$2C = function (a0) { return { "text-md-center": a0 }; };
const _c1$1k = function (a0, a1, a2) { return { "float-sm-none": a0, "col-8 pl-0": a1, "Spa_Style_Gray4_Color": a2 }; };
const _c2$P = function (a0, a1) { return { "float-sm-none mt-1": a0, "Spa_Style_Gray4_Color": a1 }; };
function PlanBenefitsComponent_ul_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li", 8)(2, "div", 9);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 10);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const benefit_r5 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0$2C, !ctx_r4.isTileDisplay));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(7, _c1$1k, ctx_r4.filteredPlanBenefits.length <= 2 && !ctx_r4.isTileDisplay, ctx_r4.isTileDisplay, ctx_r4.isNotLicensedToSell));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", benefit_r5.label, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c2$P, ctx_r4.filteredPlanBenefits.length <= 2 && !ctx_r4.isTileDisplay, ctx_r4.isNotLicensedToSell));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.getBenefitValue(benefit_r5.title), " ");
} }
const _c3$y = function (a0) { return { "flex-sm-row justify-content-sm-around plan-benefits-row-list": a0 }; };
function PlanBenefitsComponent_ul_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 7);
    i0.ɵɵtemplate(1, PlanBenefitsComponent_ul_1_ng_container_1_Template, 6, 14, "ng-container", 3);
    i0.ɵɵpipe(2, "orderBy");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c3$y, ctx_r1.filteredPlanBenefits && ctx_r1.filteredPlanBenefits.length <= 2 && !ctx_r1.isTileDisplay));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(2, 2, ctx_r1.filteredPlanBenefits, "order"));
} }
class PlanBenefitsComponent {
    constructor(guidedHelpService, planFacade) {
        this.guidedHelpService = guidedHelpService;
        this.planFacade = planFacade;
        this.newPlanCardDesignEnabled = false;
        this.planPreferenceLabels = PlanPreferenceLabels;
        this.healthCostEnabled = true;
    }
    ngOnInit() {
        this.healthCostEnabled = this.guidedHelpService.getProcessedResourceValue('Spa_Site_HealthCosts_Enabled', true);
        this.filteredPlanBenefits = !this.healthCostEnabled
            ? this.planFacade.removeHealthCostFromBenefits(this.planBenefits)
            : this.planBenefits;
    }
    ngOnChanges(changes) {
        if (!this.healthCostEnabled &&
            changes.planBenefits &&
            changes.planBenefits.currentValue &&
            changes.planBenefits.currentValue !== changes.planBenefits.previousValue) {
            this.filteredPlanBenefits = this.planFacade.removeHealthCostFromBenefits(this.planBenefits);
        }
    }
    getBenefitValue(benefitPropName) {
        // if this is not a known property return an empty string so we don't
        // display N/A without a benefit label
        let planBenefitValue;
        if (this.plan) {
            planBenefitValue = this.getPlanBenefitValueFromAnnualCost(benefitPropName);
            if (typeof planBenefitValue === 'undefined' || planBenefitValue === null) {
                return this.planBenefitNoValueLabel;
            }
            if (typeof planBenefitValue === 'number') {
                const locale = 'en-US';
                const currencyCode = 'USD';
                const digitsInfo = '1.0-0';
                return formatCurrency(planBenefitValue, locale, getCurrencySymbol(currencyCode, 'wide'), currencyCode, digitsInfo);
            }
            return planBenefitValue;
        }
        return '';
    }
    getPlanBenefitValueFromAnnualCost(benefitPropName) {
        if (benefitPropName === this.planPreferenceLabels.TOTAL_DRUG_COSTS && this.annualCost && this.annualCost.totalAnnualDrugCostShare) {
            return this.annualCost.totalAnnualDrugCostShare;
        }
        if (benefitPropName === this.planPreferenceLabels.HEALTH_COSTS && this.annualCost && this.annualCost.totalAnnualMedicalCostShare) {
            return this.annualCost.totalAnnualMedicalCostShare;
        }
        if (benefitPropName === this.planPreferenceLabels.TOTAL_ESTIMATED_COST && this.annualCost && this.annualCost.totalEstimatedCost) {
            return this.annualCost.totalEstimatedCost;
        }
        const value = Number(this.plan[benefitPropName]);
        return !isNaN(value) ? value : 0;
    }
}
PlanBenefitsComponent.ɵfac = function PlanBenefitsComponent_Factory(t) { return new (t || PlanBenefitsComponent)(i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(PlanFacade)); };
PlanBenefitsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanBenefitsComponent, selectors: [["vnext-plan-benefits"]], inputs: { newPlanCardDesignEnabled: "newPlanCardDesignEnabled", plan: "plan", planBenefits: "planBenefits", planBenefitNoValueLabel: "planBenefitNoValueLabel", isTileDisplay: "isTileDisplay", isNotLicensedToSell: "isNotLicensedToSell", annualCost: "annualCost" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [["class", "list-inline d-flex flex-column plan-benefits-column-list mb-1 flex-sm-row plan-benefits-row-list", 4, "ngIf"], ["class", "list-inline d-flex flex-column plan-benefits-column-list mb-1", 3, "ngClass", 4, "ngIf"], [1, "list-inline", "d-flex", "flex-column", "plan-benefits-column-list", "mb-1", "flex-sm-row", "plan-benefits-row-list"], [4, "ngFor", "ngForOf"], [1, "text-left", "h5", "plan-benefits-items", "focus-text", "no-border"], [1, "Spa_Style_Regular_Font", "float-left", "float-sm-none"], [1, "Spa_Style_Large_Font", "Spa_Style_Semi_Bold_Weight", "float-right", "float-sm-none", "mt-1"], [1, "list-inline", "d-flex", "flex-column", "plan-benefits-column-list", "mb-1", 3, "ngClass"], [1, "text-left", "h5", "plan-benefits-items", "focus-text", 3, "ngClass"], [1, "Spa_Style_Paragraph", "float-left", 3, "ngClass"], [1, "Spa_Style_H3", "float-right", 3, "ngClass"]], template: function PlanBenefitsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanBenefitsComponent_ul_0_Template, 3, 4, "ul", 0);
        i0.ɵɵtemplate(1, PlanBenefitsComponent_ul_1_Template, 3, 7, "ul", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.newPlanCardDesignEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.newPlanCardDesignEnabled);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, OrderPipe], styles: [".plan-card[_ngcontent-%COMP%]{border-width:1px;border-style:solid;border-top-right-radius:4px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;padding:8px 0 0}.plan-card.plan-card-border[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent1);border-top-left-radius:4px}.plan-card[_ngcontent-%COMP%]   .image-responsive[_ngcontent-%COMP%]{padding-right:0;max-width:100%;text-align:center}.score-display[_ngcontent-%COMP%]{color:red}.monthly-premium-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;height:100%;align-items:center;justify-content:center}.plan-premium[_ngcontent-%COMP%]{line-height:17px;margin-bottom:5px}.plan-benefits-column-list[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;list-style:none;padding:0}.plan-benefits-column-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child, .plan-benefits-column-list.plan-benefits-row-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-bottom:0;margin-bottom:16px}.coverage[_ngcontent-%COMP%]{border-radius:14px;text-align:center;padding:4px}.coverage[_ngcontent-%COMP%]   .fas[_ngcontent-%COMP%]{height:17px;width:18px}.plan-benefits-items[_ngcontent-%COMP%]:focus, .plan_monthly_premium[_ngcontent-%COMP%]:focus, .monthly-premium-container[_ngcontent-%COMP%]:focus, .coverage[_ngcontent-%COMP%]:focus{box-shadow:none;outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:0 0 5px var(--static-Spa_Style_Black);border-radius:5px}.tooltip-icon[_ngcontent-%COMP%]{font-size:12px;padding-right:10px;background-color:transparent;font-family:\"Font Awesome 5 Pro\"}.plan-benefits[_ngcontent-%COMP%]{margin-bottom:16px}.current-plan-text[_ngcontent-%COMP%], .next-year-plan-text[_ngcontent-%COMP%]{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.plan-name[_ngcontent-%COMP%]:focus{border-radius:5px}.card-sub-header-details[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;align-items:baseline}.non-monthly-payment-text[_ngcontent-%COMP%]{font-size:13px;font-family:montserratregular}@media (max-width: 479.98px){.plan-benefits-column-list.plan-benefits-row-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list.plan-benefits-row-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child{border-bottom:0}}.plan-benefits-items[_ngcontent-%COMP%]{flex-basis:33.3333%;flex-grow:0}@media (max-width: 575.98px){.plan-benefits-list-value-container[_ngcontent-%COMP%]{float:right;display:flex;flex-direction:column;align-items:flex-end}.plan-benefits[_ngcontent-%COMP%]{margin-bottom:0}}.no-border[_ngcontent-%COMP%]{border:none!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanBenefitsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-benefits', template: "<!--NEW DESIGN-->\r\n<ul\r\n  *ngIf=\"newPlanCardDesignEnabled\"\r\n  class=\"list-inline d-flex flex-column plan-benefits-column-list mb-1 flex-sm-row plan-benefits-row-list\"\r\n>\r\n  <ng-container *ngFor=\"let benefit of filteredPlanBenefits | orderBy : 'order'\">\r\n    <li class=\"text-left h5 plan-benefits-items focus-text no-border\">\r\n      <div class=\"Spa_Style_Regular_Font float-left float-sm-none\">{{ benefit.label }}</div>\r\n      <div class=\"Spa_Style_Large_Font Spa_Style_Semi_Bold_Weight float-right float-sm-none mt-1\">{{ getBenefitValue(benefit.title) }}</div>\r\n    </li>\r\n  </ng-container>\r\n</ul>\r\n\r\n<!--OLD DESIGN-->\r\n<ul\r\n  *ngIf=\"!newPlanCardDesignEnabled\"\r\n  class=\"list-inline d-flex flex-column plan-benefits-column-list mb-1\"\r\n  [ngClass]=\"{\r\n    'flex-sm-row justify-content-sm-around plan-benefits-row-list':\r\n      filteredPlanBenefits && filteredPlanBenefits.length <= 2 && !isTileDisplay\r\n  }\"\r\n>\r\n  <ng-container *ngFor=\"let benefit of filteredPlanBenefits | orderBy : 'order'\">\r\n    <li class=\"text-left h5 plan-benefits-items focus-text\" [ngClass]=\"{ 'text-md-center': !isTileDisplay }\">\r\n      <div\r\n        class=\"Spa_Style_Paragraph float-left\"\r\n        [ngClass]=\"{\r\n          'float-sm-none': filteredPlanBenefits.length <= 2 && !isTileDisplay,\r\n          'col-8 pl-0': isTileDisplay,\r\n          'Spa_Style_Gray4_Color': isNotLicensedToSell\r\n        }\"\r\n      >\r\n        {{ benefit.label }}\r\n      </div>\r\n      <div\r\n        class=\"Spa_Style_H3 float-right\"\r\n        [ngClass]=\"{\r\n          'float-sm-none mt-1': filteredPlanBenefits.length <= 2 && !isTileDisplay,\r\n          'Spa_Style_Gray4_Color': isNotLicensedToSell\r\n        }\"\r\n      >\r\n        {{ getBenefitValue(benefit.title) }}\r\n      </div>\r\n    </li>\r\n  </ng-container>\r\n</ul>\r\n", styles: [".plan-card{border-width:1px;border-style:solid;border-top-right-radius:4px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;padding:8px 0 0}.plan-card.plan-card-border{border-color:var(--static-Spa_Style_Accent1);border-top-left-radius:4px}.plan-card .image-responsive{padding-right:0;max-width:100%;text-align:center}.score-display{color:red}.monthly-premium-container{display:flex;flex-direction:column;height:100%;align-items:center;justify-content:center}.plan-premium{line-height:17px;margin-bottom:5px}.plan-benefits-column-list{display:flex;flex-wrap:wrap;list-style:none;padding:0}.plan-benefits-column-list li{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list li:last-child,.plan-benefits-column-list.plan-benefits-row-list li{border-bottom:0;margin-bottom:16px}.coverage{border-radius:14px;text-align:center;padding:4px}.coverage .fas{height:17px;width:18px}.plan-benefits-items:focus,.plan_monthly_premium:focus,.monthly-premium-container:focus,.coverage:focus{box-shadow:none;outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:0 0 5px var(--static-Spa_Style_Black);border-radius:5px}.tooltip-icon{font-size:12px;padding-right:10px;background-color:transparent;font-family:\"Font Awesome 5 Pro\"}.plan-benefits{margin-bottom:16px}.current-plan-text,.next-year-plan-text{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.plan-name:focus{border-radius:5px}.card-sub-header-details{display:flex;flex-wrap:wrap;align-items:baseline}.non-monthly-payment-text{font-size:13px;font-family:montserratregular}@media (max-width: 479.98px){.plan-benefits-column-list.plan-benefits-row-list li{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list.plan-benefits-row-list li:last-child{border-bottom:0}}.plan-benefits-items{flex-basis:33.3333%;flex-grow:0}@media (max-width: 575.98px){.plan-benefits-list-value-container{float:right;display:flex;flex-direction:column;align-items:flex-end}.plan-benefits{margin-bottom:0}}.no-border{border:none!important}\n"] }]
    }], function () { return [{ type: i1.GuidedHelpService }, { type: PlanFacade }]; }, { newPlanCardDesignEnabled: [{
            type: Input
        }], plan: [{
            type: Input
        }], planBenefits: [{
            type: Input
        }], planBenefitNoValueLabel: [{
            type: Input
        }], isTileDisplay: [{
            type: Input
        }], isNotLicensedToSell: [{
            type: Input
        }], annualCost: [{
            type: Input
        }] }); })();

class PlanCardBestMatchComponent {
}
PlanCardBestMatchComponent.ɵfac = function PlanCardBestMatchComponent_Factory(t) { return new (t || PlanCardBestMatchComponent)(); };
PlanCardBestMatchComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCardBestMatchComponent, selectors: [["vnext-widget-plan-card-best-match"]], inputs: { plan: "plan", bestMatchText: "bestMatchText", customClass: "customClass", bestMatchIcon: "bestMatchIcon", bestMatchTooltip: "bestMatchTooltip" }, decls: 4, vars: 12, consts: [[3, "header", "body", "customClass", "autoClose", "triggers"], ["aria-hidden", "true"], [1, "Spa_Style_Paragraph", "Spa_Style_Secondary_Text_Color", "underline", "best-match-text", "pl-1"]], template: function PlanCardBestMatchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-configurable-tooltip", 0);
        i0.ɵɵelement(1, "i", 1);
        i0.ɵɵelementStart(2, "span", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵclassMapInterpolate1("", ctx.customClass, " Spa_Style_Accent6_Background py-1 text-center px-1 best-match-plan-text");
        i0.ɵɵproperty("header", ctx.bestMatchText)("body", ctx.bestMatchTooltip)("customClass", ctx.customClass)("autoClose", "outside")("triggers", "clicks");
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("", ctx.bestMatchIcon, " Spa_Style_Secondary_Text_Color mr-1");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.bestMatchText, " ");
    } }, dependencies: [ConfigurableTooltipComponent], styles: [".best-match-plan-text[_ngcontent-%COMP%]{border-top-left-radius:5px;border-top-right-radius:5px;font-size:14px}.best-match-plan-text[_ngcontent-%COMP%]   .best-match-text[_ngcontent-%COMP%]{font-family:montserrat_semibold}.best-match-plan-text[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:14px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCardBestMatchComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-card-best-match', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-configurable-tooltip\r\n  [header]=\"bestMatchText\"\r\n  [body]=\"bestMatchTooltip\"\r\n  [customClass]=\"customClass\"\r\n  [autoClose]=\"'outside'\"\r\n  [triggers]=\"'clicks'\"\r\n  class=\"{{ customClass }} Spa_Style_Accent6_Background py-1 text-center px-1 best-match-plan-text\"\r\n>\r\n  <i aria-hidden=\"true\" class=\"{{bestMatchIcon}} Spa_Style_Secondary_Text_Color mr-1\"></i>\r\n  <span \r\n    class=\"Spa_Style_Paragraph Spa_Style_Secondary_Text_Color underline best-match-text pl-1\"\r\n  >\r\n    {{ bestMatchText}}\r\n  </span>\r\n</vnext-configurable-tooltip>", styles: [".best-match-plan-text{border-top-left-radius:5px;border-top-right-radius:5px;font-size:14px}.best-match-plan-text .best-match-text{font-family:montserrat_semibold}.best-match-plan-text i{font-size:14px}\n"] }]
    }], null, { plan: [{
            type: Input
        }], bestMatchText: [{
            type: Input
        }], customClass: [{
            type: Input
        }], bestMatchIcon: [{
            type: Input
        }], bestMatchTooltip: [{
            type: Input
        }] }); })();

const _c0$2B = function (a0, a1, a2) { return { "Spa_Style_Paragraph": a0, "flex-md-row": a1, "bg-transparent": a2 }; };
const _c1$1j = function (a0) { return { "col-md-9": a0 }; };
const _c2$O = function (a0) { return { "col-md-3 order-md-1": a0 }; };
const _c3$x = function (a0) { return { "order-md-2": a0 }; };
function PlanFeesComponent_ul_0_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 4)(1, "div", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 6);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "currency");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const planFee_r4 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(12, _c0$2B, !ctx_r3.isPlanFeesTooltip, !ctx_r3.isComparePage, !ctx_r3.isPlanFeesTooltip && ctx_r3.isComparePage));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c1$1j, !ctx_r3.isComparePage));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", planFee_r4.type + " - " + planFee_r4.label, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c2$O, !ctx_r3.isComparePage));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind4(5, 7, planFee_r4.amount, "USD", "symbol", "1.2-2"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c3$x, !ctx_r3.isComparePage));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", planFee_r4.isIncludedInMonthlyPremium ? ctx_r3.planFeesIncludedInPremiumTooltipText : ctx_r3.planFeesNotIncludedInPremiumTooltipText, " ");
} }
const _c4$i = function (a0) { return { "tooltip-content": a0 }; };
function PlanFeesComponent_ul_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 2);
    i0.ɵɵtemplate(1, PlanFeesComponent_ul_0_li_1_Template, 8, 22, "li", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c4$i, ctx_r0.isPlanFeesTooltip));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.planFees)("ngForTrackBy", ctx_r0.trackByLabelTypeAndAmount);
} }
function PlanFeesComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("Spa_Style_Paragraph ", ctx_r2.notApplicableTextCustomClass, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.notApplicableText, " ");
} }
class PlanFeesComponent {
    constructor() {
        this.notApplicableTextCustomClass = '';
    }
    trackByLabelTypeAndAmount(index, planFee) {
        return `${planFee.label}-${planFee.type}-${planFee.amount}`;
    }
}
PlanFeesComponent.ɵfac = function PlanFeesComponent_Factory(t) { return new (t || PlanFeesComponent)(); };
PlanFeesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanFeesComponent, selectors: [["vnext-widget-plan-fees"]], inputs: { planFees: "planFees", isPlanFeesTooltip: "isPlanFeesTooltip", isComparePage: "isComparePage", planFeesIncludedInPremiumTooltipText: "planFeesIncludedInPremiumTooltipText", planFeesNotIncludedInPremiumTooltipText: "planFeesNotIncludedInPremiumTooltipText", notApplicableText: "notApplicableText", notApplicableTextCustomClass: "notApplicableTextCustomClass" }, decls: 3, vars: 2, consts: [["class", "plan-fees", 3, "ngClass", 4, "ngIf", "ngIfElse"], ["notApplicable", ""], [1, "plan-fees", 3, "ngClass"], ["class", "row flex-column px-0 mx-0 Spa_Style_ToolTip", 3, "ngClass", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "row", "flex-column", "px-0", "mx-0", "Spa_Style_ToolTip", 3, "ngClass"], [1, "col-12", "order-0", "px-0", 3, "ngClass"], [1, "col-12", "order-2", "text-right", "px-0", 3, "ngClass"], [1, "col-12", "order-1", "px-0", "Spa_Style_Note", 3, "ngClass"]], template: function PlanFeesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanFeesComponent_ul_0_Template, 2, 5, "ul", 0);
        i0.ɵɵtemplate(1, PlanFeesComponent_ng_template_1_Template, 2, 4, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.planFees == null ? null : ctx.planFees.length)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.CurrencyPipe], styles: [".plan-fees[_ngcontent-%COMP%]{list-style:none;padding:0;margin:0}.plan-fees[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:not(:last-child){border-bottom:1px solid var(--static-Spa_Style_Gray2)}.tooltip-content[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:first-child{padding-top:25px}.tooltip-content[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child{padding-bottom:0}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanFeesComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-fees', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ul *ngIf=\"planFees?.length; else notApplicable\" class=\"plan-fees\" [ngClass]=\"{ 'tooltip-content': isPlanFeesTooltip }\">\r\n  <li\r\n    *ngFor=\"let planFee of planFees; trackBy: trackByLabelTypeAndAmount\"\r\n    class=\"row flex-column px-0 mx-0 Spa_Style_ToolTip\"\r\n    [ngClass]=\"{\r\n      'Spa_Style_Paragraph': !isPlanFeesTooltip,\r\n      'flex-md-row': !isComparePage,\r\n      'bg-transparent': !isPlanFeesTooltip && isComparePage\r\n    }\"\r\n  >\r\n    <div class=\"col-12 order-0 px-0\" [ngClass]=\"{ 'col-md-9': !isComparePage }\">\r\n      {{ planFee.type + ' - ' + planFee.label }}\r\n    </div>\r\n    <div class=\"col-12 order-2 text-right px-0\" [ngClass]=\"{ 'col-md-3 order-md-1': !isComparePage }\">\r\n      {{ planFee.amount | currency : 'USD' : 'symbol' : '1.2-2' }}\r\n    </div>\r\n    <div class=\"col-12 order-1 px-0 Spa_Style_Note\" [ngClass]=\"{ 'order-md-2': !isComparePage }\">\r\n      {{ planFee.isIncludedInMonthlyPremium ? planFeesIncludedInPremiumTooltipText : planFeesNotIncludedInPremiumTooltipText }}\r\n    </div>\r\n  </li>\r\n</ul>\r\n\r\n<ng-template #notApplicable>\r\n  <div class=\"Spa_Style_Paragraph {{ notApplicableTextCustomClass }}\">\r\n    {{ notApplicableText }}\r\n  </div>\r\n</ng-template>\r\n", styles: [".plan-fees{list-style:none;padding:0;margin:0}.plan-fees li:not(:last-child){border-bottom:1px solid var(--static-Spa_Style_Gray2)}.tooltip-content li:first-child{padding-top:25px}.tooltip-content li:last-child{padding-bottom:0}\n"] }]
    }], null, { planFees: [{
            type: Input
        }], isPlanFeesTooltip: [{
            type: Input
        }], isComparePage: [{
            type: Input
        }], planFeesIncludedInPremiumTooltipText: [{
            type: Input
        }], planFeesNotIncludedInPremiumTooltipText: [{
            type: Input
        }], notApplicableText: [{
            type: Input
        }], notApplicableTextCustomClass: [{
            type: Input
        }] }); })();

function PlanFeesTooltipComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "a", 7);
    i0.ɵɵlistener("click", function PlanFeesTooltipComponent_ng_template_10_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); const _r0 = i0.ɵɵreference(7); return i0.ɵɵresetView(ctx_r3.closePlanFeesTooltip(_r0)); })("keyup.enter", function PlanFeesTooltipComponent_ng_template_10_Template_a_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); const _r0 = i0.ɵɵreference(7); return i0.ɵɵresetView(ctx_r5.closePlanFeesTooltip(_r0)); });
    i0.ɵɵelementStart(2, "span", 8);
    i0.ɵɵtext(3, "Close");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "i", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "vnext-widget-plan-fees", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("planFees", ctx_r2.planFees)("isPlanFeesTooltip", true)("planFeesIncludedInPremiumTooltipText", ctx_r2.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r2.planFeesNotIncludedInPremiumTooltipText);
} }
class PlanFeesTooltipComponent {
    constructor() {
        this.customClass = '';
        this.totalPremiumCustomClass = '';
        this.tooltipCustomClass = '';
        this.tooltipPlacement = 'bottom-right';
        this.tooltipContainer = 'body';
        this.isTooltipOpen = false;
    }
    openPlanFeesTooltip(tooltip) {
        if (tooltip?.isOpen() === false) {
            tooltip.open();
            this.isTooltipOpen = true;
        }
    }
    closePlanFeesTooltip(tooltip) {
        if (tooltip?.isOpen()) {
            tooltip.close();
            this.isTooltipOpen = false;
        }
    }
}
PlanFeesTooltipComponent.ɵfac = function PlanFeesTooltipComponent_Factory(t) { return new (t || PlanFeesTooltipComponent)(); };
PlanFeesTooltipComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanFeesTooltipComponent, selectors: [["vnext-widget-plan-fees-tooltip"]], inputs: { planFees: "planFees", planTotalPremium: "planTotalPremium", planFeesTooltipText: "planFeesTooltipText", planFeesIncludedInPremiumTooltipText: "planFeesIncludedInPremiumTooltipText", planFeesNotIncludedInPremiumTooltipText: "planFeesNotIncludedInPremiumTooltipText", customClass: "customClass", totalPremiumCustomClass: "totalPremiumCustomClass", tooltipCustomClass: "tooltipCustomClass", tooltipPlacement: "tooltipPlacement", tooltipContainer: "tooltipContainer" }, decls: 12, vars: 18, consts: [[1, "plan-fees-tooltip-wrapper"], [1, "plan-fees-tooltip-button-wrapper"], ["tabindex", "0", "autoClose", "outside", "triggers", "manual", 1, "action-button", "Spa_Style_Paragraph", 3, "ngbTooltip", "placement", "container", "tooltipClass", "click"], ["planFeesTooltip", "ngbTooltip"], [1, "Spa_Style_Primary_Color", "Spa_Style_Smaller_Font", "underline", "whitespace-nowrap"], ["planFeesTemplate", ""], [1, "position-relative"], ["role", "button", "tabindex", "0", 1, "can-click", "Spa_Style_Primary_Color", "plan-fees-tooltip-close", 3, "click", "keyup.enter"], [1, "sr-only"], [1, "fas", "fa-times"], [3, "planFees", "isPlanFeesTooltip", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText"]], template: function PlanFeesTooltipComponent_Template(rf, ctx) { if (rf & 1) {
        const _r6 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div")(1, "div");
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "currency");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 0)(5, "div", 1)(6, "button", 2, 3);
        i0.ɵɵlistener("click", function PlanFeesTooltipComponent_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r6); const _r0 = i0.ɵɵreference(7); return i0.ɵɵresetView(ctx.openPlanFeesTooltip(_r0)); });
        i0.ɵɵelementStart(8, "span", 4);
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵtemplate(10, PlanFeesTooltipComponent_ng_template_10_Template, 6, 4, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(11);
        i0.ɵɵclassMapInterpolate1("plan-fees-container ", ctx.customClass, "");
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("d-inline-block Spa_Style_CostPremiumSmall total-premium ", ctx.totalPremiumCustomClass, "");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind4(3, 13, ctx.planTotalPremium, "USD", "symbol", "1.2-2"), " ");
        i0.ɵɵadvance(4);
        i0.ɵɵpropertyInterpolate1("tooltipClass", "plan-fees-tooltip ", ctx.tooltipCustomClass, "");
        i0.ɵɵproperty("ngbTooltip", _r1)("placement", ctx.tooltipPlacement)("container", ctx.tooltipContainer);
        i0.ɵɵattribute("aria-label", ctx.planFeesTooltipText);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.planFeesTooltipText);
    } }, dependencies: [IconAriaAttributesDirective, i1$1.NgbTooltip, PlanFeesComponent, i1$2.CurrencyPipe], styles: [".plan-fees-container[_ngcontent-%COMP%]{display:block}.plan-fees-tooltip-wrapper[_ngcontent-%COMP%]{display:inline-block;position:relative;height:20px}.plan-fees-tooltip-button-wrapper[_ngcontent-%COMP%]{position:absolute;left:5px}.underline[_ngcontent-%COMP%]{text-decoration:underline}.plan-fees-tooltip-close[_ngcontent-%COMP%]{position:absolute;top:0;right:0;cursor:pointer;width:20px;text-align:center;height:20px;margin-top:-5px;margin-right:-5px}.plan-fees-container.stacked-content[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:right;text-align:right}.plan-fees-container.inline-block-layout[_ngcontent-%COMP%]   .total-premium[_ngcontent-%COMP%]{vertical-align:middle}.plan-fees-container.stacked-content[_ngcontent-%COMP%]   .plan-fees-tooltip-button-wrapper[_ngcontent-%COMP%], .plan-fees-container.inline-block-layout[_ngcontent-%COMP%]   .plan-fees-tooltip-button-wrapper[_ngcontent-%COMP%]{position:unset;left:unset;text-align:right}.plan-fees-container.inline-block-layout[_ngcontent-%COMP%]   .plan-fees-tooltip-button-wrapper[_ngcontent-%COMP%]{margin-left:5px}@media (max-width: 575.98px){.plan-fees-container.stacked-xs-content[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:right;text-align:right}.plan-fees-container.inline-block-xs-layout[_ngcontent-%COMP%]   .total-premium[_ngcontent-%COMP%]{vertical-align:middle}.plan-fees-container.stacked-xs-content[_ngcontent-%COMP%]   .plan-fees-tooltip-button-wrapper[_ngcontent-%COMP%], .plan-fees-container.inline-block-xs-layout[_ngcontent-%COMP%]   .plan-fees-tooltip-button-wrapper[_ngcontent-%COMP%]{position:unset;left:unset;text-align:right}.plan-fees-container.inline-block-xs-layout[_ngcontent-%COMP%]   .plan-fees-tooltip-button-wrapper[_ngcontent-%COMP%]{margin-left:5px}}@media (min-width: 576px) and (max-width: 767.98px){.plan-fees-container.stacked-sm-content[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:right;text-align:right}.plan-fees-container.inline-block-sm-layout[_ngcontent-%COMP%]   .total-premium[_ngcontent-%COMP%]{vertical-align:middle}.plan-fees-container.stacked-sm-content[_ngcontent-%COMP%]   .plan-fees-tooltip-button-wrapper[_ngcontent-%COMP%], .plan-fees-container.inline-block-sm-layout[_ngcontent-%COMP%]   .plan-fees-tooltip-button-wrapper[_ngcontent-%COMP%]{position:unset;left:unset;text-align:right}.plan-fees-container.inline-block-sm-layout[_ngcontent-%COMP%]   .plan-fees-tooltip-button-wrapper[_ngcontent-%COMP%]{margin-left:5px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanFeesTooltipComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-fees-tooltip', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"plan-fees-container {{ customClass }}\">\r\n  <div class=\"d-inline-block Spa_Style_CostPremiumSmall total-premium {{ totalPremiumCustomClass }}\">\r\n    {{ planTotalPremium | currency : 'USD' : 'symbol' : '1.2-2' }}\r\n  </div>\r\n\r\n  <div class=\"plan-fees-tooltip-wrapper\">\r\n    <div class=\"plan-fees-tooltip-button-wrapper\">\r\n      <button\r\n        class=\"action-button Spa_Style_Paragraph\"\r\n        tabindex=\"0\"\r\n        [ngbTooltip]=\"planFeesTemplate\"\r\n        [placement]=\"tooltipPlacement\"\r\n        autoClose=\"outside\"\r\n        triggers=\"manual\"\r\n        [container]=\"tooltipContainer\"\r\n        (click)=\"openPlanFeesTooltip(planFeesTooltip)\"\r\n        #planFeesTooltip=\"ngbTooltip\"\r\n        tooltipClass=\"plan-fees-tooltip {{ tooltipCustomClass }}\"\r\n        [attr.aria-label]=\"planFeesTooltipText\"\r\n      >\r\n        <span class=\"Spa_Style_Primary_Color Spa_Style_Smaller_Font underline whitespace-nowrap\">{{ planFeesTooltipText }}</span>\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<ng-template #planFeesTemplate>\r\n  <div class=\"position-relative\">\r\n    <a\r\n      role=\"button\"\r\n      (click)=\"closePlanFeesTooltip(planFeesTooltip)\"\r\n      tabindex=\"0\"\r\n      (keyup.enter)=\"closePlanFeesTooltip(planFeesTooltip)\"\r\n      class=\"can-click Spa_Style_Primary_Color plan-fees-tooltip-close\"\r\n    >\r\n      <span class=\"sr-only\">Close</span>\r\n      <i class=\"fas fa-times\"></i>\r\n    </a>\r\n\r\n    <vnext-widget-plan-fees\r\n      [planFees]=\"planFees\"\r\n      [isPlanFeesTooltip]=\"true\"\r\n      [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n      [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n    ></vnext-widget-plan-fees>\r\n  </div>\r\n</ng-template>\r\n", styles: [".plan-fees-container{display:block}.plan-fees-tooltip-wrapper{display:inline-block;position:relative;height:20px}.plan-fees-tooltip-button-wrapper{position:absolute;left:5px}.underline{text-decoration:underline}.plan-fees-tooltip-close{position:absolute;top:0;right:0;cursor:pointer;width:20px;text-align:center;height:20px;margin-top:-5px;margin-right:-5px}.plan-fees-container.stacked-content{display:flex;flex-direction:column;justify-content:right;text-align:right}.plan-fees-container.inline-block-layout .total-premium{vertical-align:middle}.plan-fees-container.stacked-content .plan-fees-tooltip-button-wrapper,.plan-fees-container.inline-block-layout .plan-fees-tooltip-button-wrapper{position:unset;left:unset;text-align:right}.plan-fees-container.inline-block-layout .plan-fees-tooltip-button-wrapper{margin-left:5px}@media (max-width: 575.98px){.plan-fees-container.stacked-xs-content{display:flex;flex-direction:column;justify-content:right;text-align:right}.plan-fees-container.inline-block-xs-layout .total-premium{vertical-align:middle}.plan-fees-container.stacked-xs-content .plan-fees-tooltip-button-wrapper,.plan-fees-container.inline-block-xs-layout .plan-fees-tooltip-button-wrapper{position:unset;left:unset;text-align:right}.plan-fees-container.inline-block-xs-layout .plan-fees-tooltip-button-wrapper{margin-left:5px}}@media (min-width: 576px) and (max-width: 767.98px){.plan-fees-container.stacked-sm-content{display:flex;flex-direction:column;justify-content:right;text-align:right}.plan-fees-container.inline-block-sm-layout .total-premium{vertical-align:middle}.plan-fees-container.stacked-sm-content .plan-fees-tooltip-button-wrapper,.plan-fees-container.inline-block-sm-layout .plan-fees-tooltip-button-wrapper{position:unset;left:unset;text-align:right}.plan-fees-container.inline-block-sm-layout .plan-fees-tooltip-button-wrapper{margin-left:5px}}\n"] }]
    }], null, { planFees: [{
            type: Input
        }], planTotalPremium: [{
            type: Input
        }], planFeesTooltipText: [{
            type: Input
        }], planFeesIncludedInPremiumTooltipText: [{
            type: Input
        }], planFeesNotIncludedInPremiumTooltipText: [{
            type: Input
        }], customClass: [{
            type: Input
        }], totalPremiumCustomClass: [{
            type: Input
        }], tooltipCustomClass: [{
            type: Input
        }], tooltipPlacement: [{
            type: Input
        }], tooltipContainer: [{
            type: Input
        }] }); })();

class DrugDetailsFacade {
    constructor(planDetailsFacade, drugsService, pharmacyService) {
        this.planDetailsFacade = planDetailsFacade;
        this.drugsService = drugsService;
        this.pharmacyService = pharmacyService;
    }
    getCoveredDrugsByTier(availableTiers, cabinetDosages, formularyInfo) {
        if (availableTiers) {
            return availableTiers.map(tier => {
                const dosagesInTier = formularyInfo.filter((status) => status.tierNumber === tier.tierNumber);
                const drugCostDetails = this.getDrugCostDetails(dosagesInTier, cabinetDosages);
                const coveredDrugPlanTier = {
                    hasDrugs: this.hasDrugsInTier(drugCostDetails),
                    tierDescription: tier.description,
                    tierId: tier.tierNumber,
                    drugCostDetails
                };
                return coveredDrugPlanTier;
            });
        }
    }
    hasDrugsInTier(drugCostDetails) {
        return drugCostDetails && drugCostDetails.length > 0;
    }
    getDrugCostDetails(dosagesInTier, cabinetDosages) {
        return cabinetDosages
            .filter(dosage => dosagesInTier.map(p => p.ndc).includes(dosage.ndc))
            .map(drug => this.createDrugCostDetails(dosagesInTier.find(status => status.ndc === drug.ndc), drug));
    }
    createDrugCostDetails(formularyStatus, dosage) {
        return dosage
            ? {
                dosageId: dosage.dosageId,
                dosage,
                ndc: dosage.ndc,
                formularyStatus
            }
            : null;
    }
    getCoveredPlanTiers(plan, pharmacyType = PharmacyType.Retail) {
        const planTier = plan && plan.planTiers && plan.planTiers.find(t => t.pharmacyType === pharmacyType);
        if (planTier) {
            return planTier.tierInformation;
        }
        return [];
    }
    getNonCoveredDrugCostDetails(availablePlanTiers, cabinetDosages, formularyInfo) {
        // All drugs with tier ids not in the available plan tiers are not covered, including drugs of tier 0.
        if (availablePlanTiers) {
            const coveredDrugTiers = availablePlanTiers.map(tier => tier.tierNumber);
            const dosagesInTier = formularyInfo.filter(status => !coveredDrugTiers.includes(status.tierNumber));
            return this.getDrugCostDetails(dosagesInTier, cabinetDosages);
        }
    }
    getPlanRetailDrugCoverage(pharmacy, plan) {
        let planRetailDrugCoverage = plan.planRetailDrugCoverageMultiPharmacy;
        if (pharmacy && planRetailDrugCoverage && planRetailDrugCoverage.length) {
            planRetailDrugCoverage = planRetailDrugCoverage.filter(retailDrugCoverage => retailDrugCoverage.pharmacyNABP === pharmacy.nabp);
        }
        return planRetailDrugCoverage;
    }
    planHasDrugAlternatives(planDrugCoverage) {
        return planDrugCoverage?.some(drugCoverage => drugCoverage?.hasAlternatives) ?? false;
    }
    drugHasAlternatives(drugDosageId, planDrugCoverage) {
        return planDrugCoverage?.find(drugCoverage => drugCoverage?.drugDosageID === drugDosageId)?.hasAlternatives ?? false;
    }
    calculateDosage(isMailOrder, dosage, packageId, drugFrequencyList, defaultFrequencyLabel, drugForm) {
        const dosePackageOptions = this.drugsService.getCalculatedDosePackageOptions(dosage, packageId, drugFrequencyList, defaultFrequencyLabel, drugForm, isMailOrder);
        return this.drugsService.getDosePackageText(dosePackageOptions);
    }
    getDrugCoverageForPrices(isMailOrder, planMailOrderDrugCoverage, planRetailDrugCoverageMultiPharmacy, selectedPharmacy, cabinet) {
        if (isMailOrder) {
            return this.getPhaseDrugsByNationalCode(planMailOrderDrugCoverage, cabinet);
        }
        return selectedPharmacy && planRetailDrugCoverageMultiPharmacy
            ? this.getPhaseDrugsByNationalCode(this.getRetailDrugCoverageBySelectedPharmacy(planRetailDrugCoverageMultiPharmacy, selectedPharmacy), cabinet)
            : this.getPhaseDrugsByNationalCode(planRetailDrugCoverageMultiPharmacy, cabinet);
    }
    getRetailDrugCoverageBySelectedPharmacy(planRetailDrugCoverage, selectedPharmacy) {
        return planRetailDrugCoverage.filter(retailDrugCoverage => retailDrugCoverage.pharmacyNABP === selectedPharmacy.nabp);
    }
    getPlanAttributeMapWithDrugAlternatives(plans, selectedPharmacy, medicineCabinet, isMailOrderSelected) {
        const planAttributeMap = {};
        for (const plan of plans) {
            const pharmacy = this.planDetailsFacade.getPharmacyDetailsBasedOnPlan(plan, selectedPharmacy);
            for (const medicine of medicineCabinet) {
                const nonMailOrderDrugHasAlternativesRetailDrug = !isMailOrderSelected &&
                    this.drugHasAlternatives(medicine.dosageID, plan.planRetailDrugCoverageMultiPharmacy) &&
                    this.pharmacyService.isPharmacyInNetworkForDrugAlternatives(pharmacy);
                const mailOrderHasDrugAlternativesOnCabinet = isMailOrderSelected && this.drugHasAlternatives(medicine.dosageID, plan?.planMailOrderDrugCoverage);
                const showDrugAlternatives = PLANS_WITH_ALTERNATIVE_DRUGS.includes(plan.planTypeAbbreviation) &&
                    (nonMailOrderDrugHasAlternativesRetailDrug || mailOrderHasDrugAlternativesOnCabinet);
                planAttributeMap[plan.id] = {
                    ...planAttributeMap[plan.id],
                    [medicine.dosageID]: {
                        showDrugAlternatives
                    }
                };
            }
        }
        return planAttributeMap;
    }
    getDrugSearchFrequencyList(drugSearchFrequencyList) {
        return this.drugsService.getDrugSearchFrequencyList(drugSearchFrequencyList);
    }
    getMedicalCondition$(cabinet$, plan$, isMailOrder$) {
        return combineLatest([cabinet$, plan$, isMailOrder$]).pipe(distinctUntilChanged(_isEqual), filter(([cabinet, plan]) => !!cabinet && !!plan), switchMap(([cabinet, plan, isMailOrder]) => this.drugsService
            .getMedicineCabinetConditionId$(cabinet.dosage.dosageId)
            .pipe(map(selectedMedicalConditionId => [cabinet, plan, isMailOrder, selectedMedicalConditionId]))), map(([cabinet, plan, isMailOrder, selectedMedicalConditionId]) => {
            const drugCoverage = isMailOrder ? plan.planMailOrderDrugCoverage : plan.planRetailDrugCoverageMultiPharmacy;
            return this.getMedicalCondition(drugCoverage, cabinet.dosageID, selectedMedicalConditionId);
        }));
    }
    getMedicalCondition(drugCoverage, dosageID, conditionId) {
        return this.drugsService.getMedicalCondition(drugCoverage, dosageID, conditionId);
    }
    getMedicalConditions(drugCoverage, dosageID) {
        return this.drugsService.getMedicalConditions(drugCoverage, dosageID);
    }
    getDefaultMedicalCondition(conditions) {
        return this.drugsService.getDefaultMedicalCondition(conditions);
    }
    saveMedicalCondition(medicalConditionId, dosageId) {
        this.drugsService.saveMedicalCondition(medicalConditionId, dosageId);
    }
    getPhaseDrugsByNationalCode(drugCoverage, cabinet) {
        return drugCoverage?.find(coverage => coverage.ndc === cabinet.dosage.ndc);
    }
}
DrugDetailsFacade.ɵfac = function DrugDetailsFacade_Factory(t) { return new (t || DrugDetailsFacade)(i0.ɵɵinject(PlanDetailsFacade), i0.ɵɵinject(i1.DrugsService), i0.ɵɵinject(i1.PharmacyService)); };
DrugDetailsFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DrugDetailsFacade, factory: DrugDetailsFacade.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], DrugDetailsFacade.prototype, "planHasDrugAlternatives", null);
__decorate([
    Memoize()
], DrugDetailsFacade.prototype, "drugHasAlternatives", null);
__decorate([
    Memoize()
], DrugDetailsFacade.prototype, "getPhaseDrugsByNationalCode", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugDetailsFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: PlanDetailsFacade }, { type: i1.DrugsService }, { type: i1.PharmacyService }]; }, { planHasDrugAlternatives: [], drugHasAlternatives: [], getPhaseDrugsByNationalCode: [] }); })();

class PlanCoveragePreferencesBaseComponent {
    constructor(navigationService, guidedHelpService, planFacade, drugDetailsFacade, cdr, localeService, pharmacyService, providerService, analyticsService, store, planCardFacade) {
        this.navigationService = navigationService;
        this.guidedHelpService = guidedHelpService;
        this.planFacade = planFacade;
        this.drugDetailsFacade = drugDetailsFacade;
        this.cdr = cdr;
        this.localeService = localeService;
        this.pharmacyService = pharmacyService;
        this.providerService = providerService;
        this.analyticsService = analyticsService;
        this.store = store;
        this.planCardFacade = planCardFacade;
        this.newPlanCardDesignEnabled = false;
        this.viewCostTooltipHeaderText = '';
        this.viewCostTooltipHeaderContent = '';
        this.planCardPreferenceDetailedEnabled = true;
        this.loaderIconEnabled = false;
        this.showProviderInNetworkOnOtherLocation = false;
        this.preferencesBannerEnabled = this.guidedHelpService.getProcessedResourceValue('Spa_PreferenceBanner_Enabled', false);
        this.providerInfoEnabled = this.guidedHelpService.getProcessedResourceValue('Spa_Site_Providers_Enabled', false);
        this.pharmacyEnabled = this.guidedHelpService.getProcessedResourceValue('Spa_Site_Pharmacy_Enabled', true);
        this.planCoverageHideLinkText = this.guidedHelpService.getProcessedResourceValue('Spa_Site_Hide_Text', 'Hide');
        this.planCoverageViewAllLinkText = this.guidedHelpService.getProcessedResourceValue('Spa_Site_ViewAll_Text', 'View all');
        this.providerLoadingText = this.guidedHelpService.getProcessedResourceValue('Spa_Site_Provider_Loading_Text', 'Loading...');
        this.pharmacyLoadingText = this.guidedHelpService.getProcessedResourceValue('Spa_Site_Pharmacy_Loading_Text', 'Loading...');
        this.healthCostEnabled = this.guidedHelpService.getProcessedResourceValue('Spa_Site_HealthCosts_Enabled', true);
        this.addLinkText = this.guidedHelpService.getProcessedResourceValue('Spa_GuidedHelp_PlanList_AddLink_Text', 'Add');
        this.guidedHelpGetStartedText = this.guidedHelpService.getProcessedResourceValue('Spa_Site_GetStarted_Text', 'Get Started');
        this.isNonCommissionableFlagCheckEnabled = this.guidedHelpService.getProcessedResourceValue('Spa_PlanDetails_NonCommissionable_FlagCheck_Enabled', false);
        this.prescriptionLoadingText = this.guidedHelpService.getProcessedResourceValue('Spa_Site_Prescription_Loading_Text', 'Loading...');
        this.providerInNetworkText = this.guidedHelpService.getProcessedResourceValue('Spa_PlanCard_Providers_InNetwork_Location_Text', 'View in network locations');
        this.isZelisIntegrationEnabled = this.guidedHelpService.getProcessedResourceValue('Spa_Site_ZelisIntegration_Enabled', false);
        this.pageTags = PageTags;
        this.planType = PlanType;
        this.planPreferenceLabels = PlanPreferenceLabels;
        this.subscriptions = new Subscription();
        this.coveredDrugDosageIds = [];
        this.canSellPlan = true;
        this.showProviderLoading = false;
        this.plansLoading = false;
        this.isMobile = false;
        this.showProviderCoverageLink = false;
        this.hasVbcAgreement = false;
        this.spinnerSizeSmall = SpinnerSize.SMALL;
    }
    ngOnInit() {
        this.providerDetailedEnabled = this.isProviderDetailEnabled();
        this.initialPharmacyData = this.pharmacyService.getPharmacyData();
        this.filteredPlanPreferences = !this.healthCostEnabled
            ? this.planFacade.removeHealthCostFromBenefits(this.planPreferences)
            : this.planPreferences;
        this.updateEffectiveDateText();
        this.subscriptions.add(this.pharmacyService.getPharmacyData$().subscribe({
            next: (pharmacyData) => {
                if (!_isEqual(this.initialPharmacyData, pharmacyData)) {
                    this.pharmacy = this.getPharmacy();
                }
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.planFacade.arePlansLoading$().subscribe({
            next: (loading) => {
                this.plansLoading = loading;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.planFacade.isTotalEstimatedCostAnnually$().subscribe({
            next: (isTotalCostAnnual) => {
                this.isTotalCostAnnual = isTotalCostAnnual;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe({
            next: locale => {
                this.updateEffectiveDateText();
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.providerService.getProviderLoading$().subscribe({
            next: (showLoading) => {
                this.showProviderLoading = showLoading;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.isMobile$.subscribe({
            next: (isMobile) => {
                this.isMobile = isMobile;
                this.cdr.markForCheck();
            }
        }));
    }
    // eslint-disable-next-line complexity
    ngOnChanges(changes) {
        const { plan, selectedProviders, addedPharmacy, medicineCabinet, isEnabledShowDrugAlternatives, showNudgeDrugAlternatives, providerDetails } = changes;
        const isPlanDataEqual = _isEqual(plan?.currentValue, plan?.previousValue);
        if (!this.healthCostEnabled &&
            changes.planPreference &&
            changes.planPreferences.currentValue &&
            changes.planPreferences.currentValue !== changes.planPreferences.previousValue) {
            this.filteredPlanPreferences = this.planFacade.removeHealthCostFromBenefits(this.planPreferences);
        }
        if (changes.totalCostEffectiveDate?.currentValue &&
            changes.totalCostEffectiveDate?.currentValue !== changes.totalCostEffectiveDate?.previousValue) {
            this.updateEffectiveDateText();
        }
        if (!isPlanDataEqual) {
            this.canSellPlan = this.planFacade.canSellPlan(this.plan);
            this.hasVbcAgreement = this.isVbcAgreementEnabled && this.planFacade.isVbcAgreementExists(this.plan);
        }
        if (this.haveDrugAlternativesChanged({
            isPlanDataEqual,
            addedPharmacyEqual: addedPharmacy?.currentValue && addedPharmacy?.currentValue !== addedPharmacy?.previousValue,
            isEnabledShowDrugAlternativesEqual: isEnabledShowDrugAlternatives?.currentValue !== isEnabledShowDrugAlternatives?.previousValue,
            showNudgeDrugAlternativesEqual: showNudgeDrugAlternatives?.currentValue !== showNudgeDrugAlternatives?.previousValue,
            medicineCabinetEqual: medicineCabinet?.currentValue && medicineCabinet?.currentValue !== medicineCabinet?.previousValue
        })) {
            this.pharmacy = this.getPharmacy();
            const areNonCoveredDrugsInCabinet = this.notExistsCoveredDrugs(this.pharmacy, this.plan);
            const areSomeNonCoveredDrugsAlternatives = this.hasDrugAlternativesInCabinet(this.plan?.planRetailDrugCoverageMultiPharmacy, this.medicineCabinet);
            const mailOrderHasDrugAlternativesOnCabinet = this.isMailOrderSelected && this.hasDrugAlternativesInCabinet(this.plan?.planMailOrderDrugCoverage, this.medicineCabinet);
            const nonMailOrderHasDrugAlternatives = areNonCoveredDrugsInCabinet &&
                areSomeNonCoveredDrugsAlternatives &&
                !this.isMailOrderSelected &&
                !!this.medicineCabinet?.length &&
                this.pharmacyService.isPharmacyInNetworkForDrugAlternatives(this.pharmacy);
            this.showOffFormularyDrugAlternativesTooltip =
                this.isEnabledShowDrugAlternatives &&
                    this.showNudgeDrugAlternatives &&
                    (mailOrderHasDrugAlternativesOnCabinet || nonMailOrderHasDrugAlternatives);
        }
        if (!isPlanDataEqual ||
            (providerDetails && !_isEqual(providerDetails.currentValue, providerDetails.previousValue)) ||
            (selectedProviders && !_isEqual(selectedProviders.previousValue, selectedProviders.currentValue))) {
            this.showProviderCoverageLink = this.getShowProviderCoverageLink();
        }
        if (!isPlanDataEqual || !_isEqual(changes.showMailOrderLabel?.currentValue, changes.showMailOrderLabel?.previousValue)) {
            this.coveredDrugDosageIds = this.planFacade.getCoveredDrugDosageIds(this.plan, this.showMailOrderLabel);
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    get hasVisitedGuidedHelp() {
        return this.guidedHelpService.getHasVisited();
    }
    get isMobile$() {
        return this.guidedHelpService.isMobile$;
    }
    get guidedHelpEnabled() {
        return this.guidedHelpService.guidedHelpEnabled;
    }
    get showDrugSection() {
        return this.plan && this.plan.planRetailDrugCoverageMultiPharmacy.length !== 0;
    }
    get showPharmacySection() {
        return this.addedPharmacy && this.pharmacyEnabled && this.plan && this.plan.planType !== PlanType.MA;
    }
    get showHealthSection() {
        if (!this.filteredPlanPreferences || !Array.isArray(this.filteredPlanPreferences)) {
            return false;
        }
        return !!this.filteredPlanPreferences.find(health => health.title === PlanPreferenceLabels.HEALTH_COSTS);
    }
    get showPreferenceSeparator() {
        if (this.hasVisitedGuidedHelp && this.guidedHelpEnabled && this.isTotalEstimatedCostEnabled) {
            return (this.showDrugSection ||
                this.showPharmacySection ||
                this.showHealthSection ||
                !!this.providersCoveredText ||
                (this.medicineCabinet && this.medicineCabinet.length > 0));
        }
        return false;
    }
    get showPreferences() {
        if (!this.isTotalEstimatedCostEnabled) {
            if (this.plan && this.plan.planType !== PlanType.MA) {
                return this.showPharmacySection || (this.showDrugCoverage && this.showDrugSection);
            }
        }
        if (this.isTotalEstimatedCostEnabled) {
            return true;
        }
        return false;
    }
    updateEffectiveDateText() {
        this.showEffectiveDateText = !this.planFacade.isLastMonthOfYear();
        this.effectiveDateText = this.planFacade.getTotalEstimatedCostEffectiveDate();
    }
    gotoFirstGuidedHelpLink() {
        this.guidedHelpService.goToFirstLink();
    }
    showPreferencesSection(label) {
        let showPreferences;
        if (label === this.planPreferenceLabels.PROVIDERS) {
            showPreferences = !!(this.providersCoveredText || this.providerPcpText);
        }
        else if (label === this.planPreferenceLabels.PRESCRIPTIONS) {
            showPreferences = this.showDrugCoverage;
        }
        else if (label === this.planPreferenceLabels.PHARMACY) {
            if (this.addedPharmacy) {
                showPreferences = this.pharmacyEnabled;
            }
            else {
                showPreferences = false;
            }
        }
        else if (label === this.planPreferenceLabels.TOTAL_DRUG_COSTS && this.isTotalEstimatedCostEnabled) {
            if (this.plan && this.plan.planRetailDrugCoverageMultiPharmacy.length !== 0) {
                showPreferences = true;
            }
            else {
                showPreferences = false;
            }
        }
        else if (label === this.planPreferenceLabels.HEALTH_COSTS && this.isTotalEstimatedCostEnabled) {
            showPreferences = true;
        }
        return showPreferences;
    }
    getPharmacy() {
        const pharmacies = this.pharmacyService.getAPIPharmacyInfoForPlan(this.plan?.id);
        if (pharmacies?.length && this.addedPharmacy) {
            return pharmacies.find(pharmacyCoverage => pharmacyCoverage && pharmacyCoverage.nabp === this.addedPharmacy.nabp);
        }
        return {};
    }
    getPreferencesCost(label) {
        if (label === this.planPreferenceLabels.TOTAL_DRUG_COSTS && this.annualCost?.totalAnnualDrugCostShare) {
            return this.annualCost.totalAnnualDrugCostShare;
        }
        if (label === this.planPreferenceLabels.HEALTH_COSTS && this.annualCost?.totalAnnualMedicalCostShare) {
            return this.annualCost.totalAnnualMedicalCostShare;
        }
        return 0;
    }
    getBootstrapClass() {
        if (this.planCardPreferenceDetailedEnabled) {
            if (this.isTileDisplay || this.compareTwoPlans) {
                return 'col-12';
            }
            return 'col-12 col-md-12 pl-md-0 pr-md-0';
        }
        if (this.isTileDisplay) {
            return 'col-12';
        }
        if (this.compareTwoPlans) {
            return 'col-6';
        }
        return 'col-12 col-md-4 pl-md-1 pr-md-0';
    }
    isTotalEstimatedCostAvailable() {
        return this.annualCost && typeof this.annualCost.totalEstimatedCost === 'number';
    }
    onDrugAlternativesNudgeClick() {
        this.planCardFacade.drugAlternativesNudge(this.plan);
    }
    onClick(pageTag) {
        return () => {
            if (pageTag === PageTags.GUIDED_HELP_PRESCRIPTIONS) {
                this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_DRUGS);
            }
            else if (pageTag === PageTags.GUIDED_HELP_PHARMACY_SEARCH) {
                this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_PHARMACY);
            }
            else if (pageTag === PageTags.GUIDED_HELP_PROVIDER_SEARCH) {
                this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_PROVIDER);
            }
        };
    }
    isProviderDetailEnabled() {
        return this.providerInfoEnabled && this.planCardPreferenceDetailedEnabled && this.canSellPlan && this.plan?.showProviderSearch;
    }
    notExistsCoveredDrugs(pharmacy, plan) {
        // All drugs with tier ids not in the available plan tiers are not covered, including drugs of tier 0.
        const availablePlanTiers = this.drugDetailsFacade.getCoveredPlanTiers(this.plan);
        const formularyInfo = this.drugDetailsFacade.getPlanRetailDrugCoverage(pharmacy, plan);
        const coveredDrugTiers = availablePlanTiers.map(tier => tier.tierNumber);
        return pharmacy?.pharmacyId ? !!formularyInfo.filter(status => !coveredDrugTiers.includes(status.tierNumber)).length : true;
    }
    hasDrugAlternativesInCabinet(planDrugCoverage, medicineCabinet) {
        return (this.drugDetailsFacade.planHasDrugAlternatives(planDrugCoverage) &&
            !!medicineCabinet?.some(cabinet => !!planDrugCoverage.find((drugCoverage) => drugCoverage.drugDosageID === cabinet.dosageID)));
    }
    haveDrugAlternativesChanged(changesValidation) {
        const { isPlanDataEqual, addedPharmacyEqual, isEnabledShowDrugAlternativesEqual, showNudgeDrugAlternativesEqual, medicineCabinetEqual } = changesValidation;
        return (!isPlanDataEqual ||
            !addedPharmacyEqual ||
            !isEnabledShowDrugAlternativesEqual ||
            showNudgeDrugAlternativesEqual ||
            medicineCabinetEqual);
    }
    getShowProviderCoverageLink() {
        return (this.providerInfoEnabled &&
            this.canSellPlan &&
            !!this.plan?.showProviderSearch &&
            !!this.selectedProviders?.length &&
            // On Zelis, /Networks will only return In-network provider addresses.
            // If all selected providers are out-of-network and there are no other in-network addresses available, we still want to show the provider coverage link.
            // Therefore, we skip the provider details info validation when Zelis integration is enabled
            (this.isZelisIntegrationEnabled || !!this.providerService.getProviderDetailInfo(this.plan?.id, this.providerDetails)?.length));
    }
}
PlanCoveragePreferencesBaseComponent.ɵfac = function PlanCoveragePreferencesBaseComponent_Factory(t) { return new (t || PlanCoveragePreferencesBaseComponent)(i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(DrugDetailsFacade), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.PharmacyService), i0.ɵɵdirectiveInject(i1.ProviderService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(PlanCardFacade)); };
PlanCoveragePreferencesBaseComponent.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: PlanCoveragePreferencesBaseComponent, inputs: { newPlanCardDesignEnabled: "newPlanCardDesignEnabled", pharmacyNotCoveredText: "pharmacyNotCoveredText", plan: "plan", pharmacyText: "pharmacyText", pharmacyCoveredText: "pharmacyCoveredText", addedPharmacy: "addedPharmacy", showDrugCoverage: "showDrugCoverage", drugCoverageText: "drugCoverageText", prescriptionsText: "prescriptionsText", planPreferences: "planPreferences", totalEstimatedAnnualCostText: "totalEstimatedAnnualCostText", totalEstimatedCostText: "totalEstimatedCostText", totalEstimatedCostTooltip: "totalEstimatedCostTooltip", isTileDisplay: "isTileDisplay", isRetention: "isRetention", isTotalEstimatedCostEnabled: "isTotalEstimatedCostEnabled", compareTwoPlans: "compareTwoPlans", isQuoting: "isQuoting", noCostAvailableText: "noCostAvailableText", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text", medicineCabinet: "medicineCabinet", viewCostTooltipHeaderText: "viewCostTooltipHeaderText", viewCostTooltipHeaderContent: "viewCostTooltipHeaderContent", inNetworkPreferredText: "inNetworkPreferredText", inNetworkStandardText: "inNetworkStandardText", outOfNetworkText: "outOfNetworkText", annualCost: "annualCost", showMailOrderLabel: "showMailOrderLabel", mailOrderText: "mailOrderText", providersCoveredText: "providersCoveredText", providerPcpText: "providerPcpText", totalCostEffectiveDate: "totalCostEffectiveDate", isEnabledShowDrugAlternatives: "isEnabledShowDrugAlternatives", showNudgeDrugAlternatives: "showNudgeDrugAlternatives", drugAlternativesTooltipText: "drugAlternativesTooltipText", drugAlternativesIndicatorIcon: "drugAlternativesIndicatorIcon", nudgeDrugAlternativesLabelText: "nudgeDrugAlternativesLabelText", isMailOrderSelected: "isMailOrderSelected", selectedProviders: "selectedProviders", planCardPreferenceDetailedEnabled: "planCardPreferenceDetailedEnabled", providerDetails: "providerDetails", loaderIconEnabled: "loaderIconEnabled", editLinkText: "editLinkText", providerOneOrMoreOutOfNetworkText: "providerOneOrMoreOutOfNetworkText", providerInNetworkOnOtherLocationsTooltipText: "providerInNetworkOnOtherLocationsTooltipText", providerShowPartialIndicatorEnabled: "providerShowPartialIndicatorEnabled", showProviderInNetworkOnOtherLocation: "showProviderInNetworkOnOtherLocation", viewProvidersButtonText: "viewProvidersButtonText", viewPrescriptionsButtonText: "viewPrescriptionsButtonText", isVbcAgreementEnabled: "isVbcAgreementEnabled", vbcAgreementLabel: "vbcAgreementLabel", vbcAgreementTooltip: "vbcAgreementTooltip" }, features: [i0.ɵɵNgOnChangesFeature] });
__decorate([
    Memoize()
], PlanCoveragePreferencesBaseComponent.prototype, "hasDrugAlternativesInCabinet", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCoveragePreferencesBaseComponent, [{
        type: Directive
    }], function () { return [{ type: i1.NavigationService }, { type: i1.GuidedHelpService }, { type: PlanFacade }, { type: DrugDetailsFacade }, { type: i0.ChangeDetectorRef }, { type: i1.LocaleService }, { type: i1.PharmacyService }, { type: i1.ProviderService }, { type: AnalyticsService }, { type: i2.Store }, { type: PlanCardFacade }]; }, { newPlanCardDesignEnabled: [{
            type: Input
        }], pharmacyNotCoveredText: [{
            type: Input
        }], plan: [{
            type: Input
        }], pharmacyText: [{
            type: Input
        }], pharmacyCoveredText: [{
            type: Input
        }], addedPharmacy: [{
            type: Input
        }], showDrugCoverage: [{
            type: Input
        }], drugCoverageText: [{
            type: Input
        }], prescriptionsText: [{
            type: Input
        }], planPreferences: [{
            type: Input
        }], totalEstimatedAnnualCostText: [{
            type: Input
        }], totalEstimatedCostText: [{
            type: Input
        }], totalEstimatedCostTooltip: [{
            type: Input
        }], isTileDisplay: [{
            type: Input
        }], isRetention: [{
            type: Input
        }], isTotalEstimatedCostEnabled: [{
            type: Input
        }], compareTwoPlans: [{
            type: Input
        }], isQuoting: [{
            type: Input
        }], noCostAvailableText: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }], medicineCabinet: [{
            type: Input
        }], viewCostTooltipHeaderText: [{
            type: Input
        }], viewCostTooltipHeaderContent: [{
            type: Input
        }], inNetworkPreferredText: [{
            type: Input
        }], inNetworkStandardText: [{
            type: Input
        }], outOfNetworkText: [{
            type: Input
        }], annualCost: [{
            type: Input
        }], showMailOrderLabel: [{
            type: Input
        }], mailOrderText: [{
            type: Input
        }], providersCoveredText: [{
            type: Input
        }], providerPcpText: [{
            type: Input
        }], totalCostEffectiveDate: [{
            type: Input
        }], isEnabledShowDrugAlternatives: [{
            type: Input
        }], showNudgeDrugAlternatives: [{
            type: Input
        }], drugAlternativesTooltipText: [{
            type: Input
        }], drugAlternativesIndicatorIcon: [{
            type: Input
        }], nudgeDrugAlternativesLabelText: [{
            type: Input
        }], isMailOrderSelected: [{
            type: Input
        }], selectedProviders: [{
            type: Input
        }], planCardPreferenceDetailedEnabled: [{
            type: Input
        }], providerDetails: [{
            type: Input
        }], loaderIconEnabled: [{
            type: Input
        }], editLinkText: [{
            type: Input
        }], providerOneOrMoreOutOfNetworkText: [{
            type: Input
        }], providerInNetworkOnOtherLocationsTooltipText: [{
            type: Input
        }], providerShowPartialIndicatorEnabled: [{
            type: Input
        }], showProviderInNetworkOnOtherLocation: [{
            type: Input
        }], viewProvidersButtonText: [{
            type: Input
        }], viewPrescriptionsButtonText: [{
            type: Input
        }], isVbcAgreementEnabled: [{
            type: Input
        }], vbcAgreementLabel: [{
            type: Input
        }], vbcAgreementTooltip: [{
            type: Input
        }], hasDrugAlternativesInCabinet: [] }); })();

function PlanDrugAlternativesIndicatorComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "div", 8);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 1, ctx_r1.drugAlternativesTooltipText, "html"), i0.ɵɵsanitizeHtml);
} }
class PlanDrugAlternativesIndicatorComponent {
    constructor() {
        this.drugAlternativesNudgeClick = new EventEmitter();
    }
    onDrugAlternativesNudgeClick() {
        this.drugAlternativesNudgeClick.emit();
    }
}
PlanDrugAlternativesIndicatorComponent.ɵfac = function PlanDrugAlternativesIndicatorComponent_Factory(t) { return new (t || PlanDrugAlternativesIndicatorComponent)(); };
PlanDrugAlternativesIndicatorComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanDrugAlternativesIndicatorComponent, selectors: [["vnext-plan-drug-alternatives-indicator"]], inputs: { drugAlternativesTooltipText: "drugAlternativesTooltipText", nudgeDrugAlternativesLabelText: "nudgeDrugAlternativesLabelText", drugAlternativesIndicatorIcon: "drugAlternativesIndicatorIcon", isMobile: "isMobile" }, outputs: { drugAlternativesNudgeClick: "drugAlternativesNudgeClick" }, decls: 9, vars: 6, consts: [[1, "Spa_Style_Link"], ["nudgeDrugAlternativesTooltip", ""], ["tooltipClass", "nudge-drug-alternatives-tooltip", 1, "action-button", "Spa_Style_Link", 3, "ngbTooltip", "disableTooltip", "click"], ["drugAlternativesTooltip", "ngbTooltip"], [1, "d-flex", "flex-row", "align-items-center"], ["aria-hidden", "true"], [1, "text-left", "text-underline"], [1, "Spa_Style_ToolTip", "p-0"], [3, "innerHTML"]], template: function PlanDrugAlternativesIndicatorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, PlanDrugAlternativesIndicatorComponent_ng_template_1_Template, 3, 4, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(3, "button", 2, 3);
        i0.ɵɵlistener("click", function PlanDrugAlternativesIndicatorComponent_Template_button_click_3_listener() { return ctx.onDrugAlternativesNudgeClick(); });
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelement(6, "i", 5);
        i0.ɵɵelementStart(7, "span", 6);
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(2);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngbTooltip", _r0)("disableTooltip", ctx.isMobile);
        i0.ɵɵadvance(3);
        i0.ɵɵclassMapInterpolate1("", ctx.drugAlternativesIndicatorIcon, " save-on-prescriptions-icon");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.nudgeDrugAlternativesLabelText, " ");
    } }, dependencies: [i1$1.NgbTooltip, SafePipe], styles: [".save-on-prescriptions-icon[_ngcontent-%COMP%]{margin-right:10px}.action-button[_ngcontent-%COMP%], .action-button[_ngcontent-%COMP%]:hover{text-decoration:none}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanDrugAlternativesIndicatorComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-drug-alternatives-indicator', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"Spa_Style_Link\">\r\n  <ng-template #nudgeDrugAlternativesTooltip>\r\n    <div class=\"Spa_Style_ToolTip p-0\">\r\n      <div [innerHTML]=\"drugAlternativesTooltipText | safe: 'html'\"></div>\r\n    </div>\r\n  </ng-template>\r\n\r\n  <button\r\n    class=\"action-button Spa_Style_Link\"\r\n    #drugAlternativesTooltip=\"ngbTooltip\"\r\n    [ngbTooltip]=\"nudgeDrugAlternativesTooltip\"\r\n    [disableTooltip]=\"isMobile\"\r\n    tooltipClass=\"nudge-drug-alternatives-tooltip\"\r\n    (click)=\"onDrugAlternativesNudgeClick()\"\r\n  >\r\n    <div class=\"d-flex flex-row align-items-center\">\r\n      <i class=\"{{ drugAlternativesIndicatorIcon }} save-on-prescriptions-icon\" aria-hidden=\"true\"></i>\r\n      <span class=\"text-left text-underline\">\r\n        {{ nudgeDrugAlternativesLabelText }}\r\n      </span>\r\n    </div>\r\n  </button>\r\n</div>\r\n", styles: [".save-on-prescriptions-icon{margin-right:10px}.action-button,.action-button:hover{text-decoration:none}\n"] }]
    }], null, { drugAlternativesTooltipText: [{
            type: Input
        }], nudgeDrugAlternativesLabelText: [{
            type: Input
        }], drugAlternativesIndicatorIcon: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], drugAlternativesNudgeClick: [{
            type: Output
        }] }); })();

const _c0$2A = function (a0) { return { "Spa_Style_Paragraph pl-4": a0 }; };
class PlanPreferenceTextComponent {
    constructor() {
        this.newPlanCardDesignEnabled = false;
    }
    ngOnChanges(changes) {
        if (this.preferenceTitle &&
            (changes.preferenceTitle?.currentValue !== changes.preferenceTitle?.previousValue ||
                changes.drugCoverageText?.currentValue !== changes.drugCoverageText?.previousValue ||
                changes.pharmacyCoveredText?.currentValue !== changes.pharmacyCoveredText?.previousValue ||
                changes.pharmacyNotCoveredText?.currentValue !== changes.pharmacyNotCoveredText?.previousValue ||
                changes.pharmacy?.currentValue?.isInNetwork !== changes.pharmacy?.previousValue?.isInNetwork)) {
            this.preferenceValue = this.getPreferencesValue(this.preferenceTitle);
        }
    }
    getPreferencesValue(value) {
        let preferencesValue;
        if (value === PlanPreferenceLabels.PRESCRIPTIONS) {
            preferencesValue = this.drugCoverageText;
        }
        else if (value === PlanPreferenceLabels.PHARMACY) {
            if (this.pharmacy && this.pharmacy.isInNetwork) {
                preferencesValue = this.pharmacyCoveredText;
            }
            else {
                preferencesValue = this.pharmacyNotCoveredText;
            }
        }
        return preferencesValue;
    }
}
PlanPreferenceTextComponent.ɵfac = function PlanPreferenceTextComponent_Factory(t) { return new (t || PlanPreferenceTextComponent)(); };
PlanPreferenceTextComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanPreferenceTextComponent, selectors: [["vnext-plan-preference-text"]], inputs: { newPlanCardDesignEnabled: "newPlanCardDesignEnabled", preferenceTitle: "preferenceTitle", drugCoverageText: "drugCoverageText", pharmacy: "pharmacy", pharmacyCoveredText: "pharmacyCoveredText", pharmacyNotCoveredText: "pharmacyNotCoveredText" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 4, consts: [[3, "ngClass"]], template: function PlanPreferenceTextComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$2A, !ctx.newPlanCardDesignEnabled));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.preferenceValue, "\n");
    } }, dependencies: [i1$2.NgClass], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanPreferenceTextComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-preference-text', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div [ngClass]=\"{ 'Spa_Style_Paragraph pl-4': !newPlanCardDesignEnabled }\">\r\n  {{ preferenceValue }}\r\n</div>\r\n" }]
    }], null, { newPlanCardDesignEnabled: [{
            type: Input
        }], preferenceTitle: [{
            type: Input
        }], drugCoverageText: [{
            type: Input
        }], pharmacy: [{
            type: Input
        }], pharmacyCoveredText: [{
            type: Input
        }], pharmacyNotCoveredText: [{
            type: Input
        }] }); })();

function PlanCoverageProvidersLabelComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.providerInNetworkOnOtherLocationsTooltipText);
} }
function PlanCoverageProvidersLabelComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function PlanCoverageProvidersLabelComponent_ng_template_3_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 7, 8);
    i0.ɵɵelement(3, "i", 9);
    i0.ɵɵelementStart(4, "span", 10);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "titlecase");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngbTooltip", _r0);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 2, ctx_r7.provider.displayName));
} }
const _c0$2z = function (a0, a1, a2) { return { "Spa_Style_Primary_Color": a0, "Spa_Style_Gray4_Color": a1, "partial-indicator-text": a2 }; };
const _c1$1i = function (a0, a1, a2) { return { "fa-check text-success": a0, "fa-times-circle": a1, "fa-exclamation-triangle": a2 }; };
function PlanCoverageProvidersLabelComponent_ng_template_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelement(1, "i", 12);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "titlecase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(5, _c0$2z, ctx_r9.providerCovered == null ? null : ctx_r9.providerCovered.inNetwork, !(ctx_r9.providerCovered == null ? null : ctx_r9.providerCovered.inNetwork) && !ctx_r9.isProviderInNetworkOnOtherLocation, !(ctx_r9.providerCovered == null ? null : ctx_r9.providerCovered.inNetwork) && ctx_r9.isProviderInNetworkOnOtherLocation));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(9, _c1$1i, ctx_r9.providerCovered == null ? null : ctx_r9.providerCovered.inNetwork, !(ctx_r9.providerCovered == null ? null : ctx_r9.providerCovered.inNetwork) && !ctx_r9.isProviderInNetworkOnOtherLocation, !(ctx_r9.providerCovered == null ? null : ctx_r9.providerCovered.inNetwork) && ctx_r9.isProviderInNetworkOnOtherLocation));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, ctx_r9.provider.displayName), " ");
} }
function PlanCoverageProvidersLabelComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanCoverageProvidersLabelComponent_ng_template_3_ng_container_0_Template, 7, 4, "ng-container", 5);
    i0.ɵɵtemplate(1, PlanCoverageProvidersLabelComponent_ng_template_3_ng_template_1_Template, 4, 13, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r8 = i0.ɵɵreference(2);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !(ctx_r4.providerCovered == null ? null : ctx_r4.providerCovered.inNetwork) && ctx_r4.isProviderInNetworkOnOtherLocation && ctx_r4.providerInNetworkOnOtherLocationsTooltipText)("ngIfElse", _r8);
} }
function PlanCoverageProvidersLabelComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelement(1, "i", 11);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "titlecase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", (ctx_r6.providerCovered == null ? null : ctx_r6.providerCovered.inNetwork) ? "Spa_Style_Primary_Color" : "Spa_Style_Gray4_Color");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", (ctx_r6.providerCovered == null ? null : ctx_r6.providerCovered.inNetwork) ? "fas fa-check text-success" : "fas fa-times-circle");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, ctx_r6.provider.displayName), " ");
} }
class PlanCoverageProvidersLabelComponent {
    constructor(planFacade) {
        this.planFacade = planFacade;
    }
    ngOnChanges(changes) {
        if (!_isEqual(changes.provider?.previousValue, changes.provider?.currentValue) ||
            !_isEqual(changes.providerDetails?.previousValue, changes.providerDetails?.currentValue)) {
            this.providerCovered = this.getProviderCovered(this.provider);
            this.isProviderInNetworkOnOtherLocation =
                this.providerInfoEnabled && this.planFacade.isProviderLocationInNetwork(this.planId, this.providerDetails, this.provider);
        }
    }
    getProviderCovered(provider) {
        return this.planFacade.getSelectedProviderDetails(this.planId, this.providerDetails, provider);
    }
}
PlanCoverageProvidersLabelComponent.ɵfac = function PlanCoverageProvidersLabelComponent_Factory(t) { return new (t || PlanCoverageProvidersLabelComponent)(i0.ɵɵdirectiveInject(PlanFacade)); };
PlanCoverageProvidersLabelComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCoverageProvidersLabelComponent, selectors: [["vnext-plan-coverage-providers-label"]], inputs: { provider: "provider", providerDetails: "providerDetails", planId: "planId", providerInfoEnabled: "providerInfoEnabled", providerInNetworkOnOtherLocationsTooltipText: "providerInNetworkOnOtherLocationsTooltipText", providerShowPartialIndicatorEnabled: "providerShowPartialIndicatorEnabled" }, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 3, consts: [["inNetworkOnOtherLocationTooltip", ""], [4, "ngIf", "ngIfThen", "ngIfElse"], ["showPartialIndicator", ""], ["hidePartialIndicator", ""], [1, "Spa_Style_ToolTip"], [4, "ngIf", "ngIfElse"], ["showTextBlock", ""], ["tabindex", "0", "tooltipClass", "star-ratings-tooltip", "role", "tooltip", 1, "action-button", "Spa_Style_Paragraph", "mr-1", 3, "ngbTooltip"], ["inNetworkTooltip", "ngbTooltip"], [1, "fas", "fa-exclamation-triangle", "partial-indicator-text", "mr-1"], [1, "partial-indicator-text", "underline", "whitespace-nowrap"], [3, "ngClass"], [1, "fas", 3, "ngClass"]], template: function PlanCoverageProvidersLabelComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanCoverageProvidersLabelComponent_ng_template_0_Template, 3, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(2, PlanCoverageProvidersLabelComponent_ng_container_2_Template, 1, 0, "ng-container", 1);
        i0.ɵɵtemplate(3, PlanCoverageProvidersLabelComponent_ng_template_3_Template, 3, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(5, PlanCoverageProvidersLabelComponent_ng_template_5_Template, 4, 5, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(4);
        const _r5 = i0.ɵɵreference(6);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.providerShowPartialIndicatorEnabled)("ngIfThen", _r3)("ngIfElse", _r5);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, IconAriaAttributesDirective, i1$1.NgbTooltip, i1$2.TitleCasePipe], styles: [".partial-indicator-text[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Warn_on_Blue)}.underline[_ngcontent-%COMP%]{text-decoration:underline}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCoverageProvidersLabelComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-coverage-providers-label', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-template #inNetworkOnOtherLocationTooltip>\r\n  <div class=\"Spa_Style_ToolTip\">\r\n    <div>{{ providerInNetworkOnOtherLocationsTooltipText }}</div>\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-container *ngIf=\"providerShowPartialIndicatorEnabled; then showPartialIndicator; else hidePartialIndicator\"> </ng-container>\r\n\r\n<ng-template #showPartialIndicator>\r\n  <ng-container\r\n    *ngIf=\"\r\n      !providerCovered?.inNetwork && isProviderInNetworkOnOtherLocation && providerInNetworkOnOtherLocationsTooltipText;\r\n      else showTextBlock\r\n    \"\r\n  >\r\n    <button\r\n      class=\"action-button Spa_Style_Paragraph mr-1\"\r\n      tabindex=\"0\"\r\n      [ngbTooltip]=\"inNetworkOnOtherLocationTooltip\"\r\n      #inNetworkTooltip=\"ngbTooltip\"\r\n      tooltipClass=\"star-ratings-tooltip\"\r\n      role=\"tooltip\"\r\n    >\r\n      <i class=\"fas fa-exclamation-triangle partial-indicator-text mr-1\"></i\r\n      ><span class=\"partial-indicator-text underline whitespace-nowrap\">{{ provider.displayName | titlecase }}</span>\r\n    </button>\r\n  </ng-container>\r\n\r\n  <ng-template #showTextBlock>\r\n    <div\r\n      [ngClass]=\"{\r\n        'Spa_Style_Primary_Color': providerCovered?.inNetwork,\r\n        'Spa_Style_Gray4_Color': !providerCovered?.inNetwork && !isProviderInNetworkOnOtherLocation,\r\n        'partial-indicator-text': !providerCovered?.inNetwork && isProviderInNetworkOnOtherLocation\r\n      }\"\r\n    >\r\n      <i\r\n        class=\"fas\"\r\n        [ngClass]=\"{\r\n          'fa-check text-success': providerCovered?.inNetwork,\r\n          'fa-times-circle': !providerCovered?.inNetwork && !isProviderInNetworkOnOtherLocation,\r\n          'fa-exclamation-triangle': !providerCovered?.inNetwork && isProviderInNetworkOnOtherLocation\r\n        }\"\r\n      ></i>\r\n      {{ provider.displayName | titlecase }}\r\n    </div>\r\n  </ng-template>\r\n</ng-template>\r\n\r\n<ng-template #hidePartialIndicator>\r\n  <div [ngClass]=\"providerCovered?.inNetwork ? 'Spa_Style_Primary_Color' : 'Spa_Style_Gray4_Color'\">\r\n    <i [ngClass]=\"providerCovered?.inNetwork ? 'fas fa-check text-success' : 'fas fa-times-circle'\"></i>\r\n    {{ provider.displayName | titlecase }}\r\n  </div>\r\n</ng-template>\r\n", styles: [".partial-indicator-text{color:var(--static-Spa_Style_Warn_on_Blue)}.underline{text-decoration:underline}\n"] }]
    }], function () { return [{ type: PlanFacade }]; }, { provider: [{
            type: Input
        }], providerDetails: [{
            type: Input
        }], planId: [{
            type: Input
        }], providerInfoEnabled: [{
            type: Input
        }], providerInNetworkOnOtherLocationsTooltipText: [{
            type: Input
        }], providerShowPartialIndicatorEnabled: [{
            type: Input
        }] }); })();

function PlanCoverageProvidersComponent_div_0_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 10);
    i0.ɵɵelementStart(3, "span", 11);
    i0.ɵɵtext(4, "Collapse");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.planCoverageHideLinkText, "");
} }
function PlanCoverageProvidersComponent_div_0_div_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵelement(1, "i", 12);
    i0.ɵɵelementStart(2, "span", 11);
    i0.ɵɵtext(3, "Expand");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.planCoverageViewAllLinkText, "");
} }
function PlanCoverageProvidersComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "vnext-link", 6);
    i0.ɵɵlistener("click", function PlanCoverageProvidersComponent_div_0_div_1_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r9.toggleViewAll()); })("keyup.enter", function PlanCoverageProvidersComponent_div_0_div_1_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.toggleViewAll()); });
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵtemplate(3, PlanCoverageProvidersComponent_div_0_div_1_ng_container_3_Template, 5, 1, "ng-container", 8);
    i0.ɵɵtemplate(4, PlanCoverageProvidersComponent_div_0_div_1_ng_template_4_Template, 4, 1, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const _r7 = i0.ɵɵreference(5);
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("makeInlineBlock", true)("keyNameForLiveEdit", "Spa_Site_Hide_Text")("ariaLabel", ctx_r4.showAllProvidersLabels ? ctx_r4.planCoverageViewAllLinkText : ctx_r4.planCoverageHideLinkText)("role", ctx_r4.linkRoles.BUTTON);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.showAllProvidersLabels)("ngIfElse", _r7);
} }
function PlanCoverageProvidersComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelement(1, "vnext-plan-coverage-providers-label", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const provider_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("provider", provider_r2)("providerDetails", ctx_r5.providerDetails)("planId", ctx_r5.plan.id)("providerInfoEnabled", ctx_r5.providerInfoEnabled)("providerInNetworkOnOtherLocationsTooltipText", ctx_r5.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r5.providerShowPartialIndicatorEnabled);
} }
function PlanCoverageProvidersComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PlanCoverageProvidersComponent_div_0_div_1_Template, 6, 6, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵtemplate(3, PlanCoverageProvidersComponent_div_0_div_3_Template, 2, 6, "div", 4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const index_r3 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", index_r3 === 5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", index_r3 < 5 || ctx_r0.showAllProvidersLabels);
} }
function PlanCoverageProvidersComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "vnext-link", 16);
    i0.ɵɵlistener("click", function PlanCoverageProvidersComponent_div_2_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.planCardFacade.showProvidersInfo(ctx_r13.plan)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r1.providerInNetworkText)("keyNameForLiveEdit", "Spa_PlanCard_Providers_InNetwork_Location_Text");
} }
class PlanCoverageProvidersComponent {
    constructor(cdr, planCardFacade) {
        this.cdr = cdr;
        this.planCardFacade = planCardFacade;
        this.showAllProvidersLabels = false;
        this.linkRoles = LinkRoles;
    }
    providerTrackBy(index, provider) {
        return provider.id;
    }
    toggleViewAll() {
        this.showAllProvidersLabels = !this.showAllProvidersLabels;
        this.cdr.detectChanges();
    }
}
PlanCoverageProvidersComponent.ɵfac = function PlanCoverageProvidersComponent_Factory(t) { return new (t || PlanCoverageProvidersComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlanCardFacade)); };
PlanCoverageProvidersComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCoverageProvidersComponent, selectors: [["vnext-plan-coverage-providers"]], inputs: { providers: "providers", planCoverageHideLinkText: "planCoverageHideLinkText", planCoverageViewAllLinkText: "planCoverageViewAllLinkText", providerDetails: "providerDetails", plan: "plan", providerInNetworkText: "providerInNetworkText", providerInfoEnabled: "providerInfoEnabled", providerInNetworkOnOtherLocationsTooltipText: "providerInNetworkOnOtherLocationsTooltipText", providerShowPartialIndicatorEnabled: "providerShowPartialIndicatorEnabled" }, decls: 3, vars: 8, consts: [[4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "float-right", 4, "ngIf"], ["class", "mb-1 clear-both", 4, "ngIf"], [1, "float-left"], ["class", "Spa_Style_Small_Font mb-2 pr-1", 4, "ngIf"], [1, "mb-1", "clear-both"], [3, "makeInlineBlock", "keyNameForLiveEdit", "ariaLabel", "role", "click", "keyup.enter"], ["link-body", "", 1, "pl-2"], [4, "ngIf", "ngIfElse"], ["hideAllProviders", ""], [1, "ml-1", "fas", "fa-angle-up"], [1, "sr-only"], [1, "ml-1", "fas", "fa-angle-down"], [1, "Spa_Style_Small_Font", "mb-2", "pr-1"], [3, "provider", "providerDetails", "planId", "providerInfoEnabled", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled"], [1, "float-right"], [3, "title", "keyNameForLiveEdit", "click"]], template: function PlanCoverageProvidersComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanCoverageProvidersComponent_div_0_Template, 4, 2, "div", 0);
        i0.ɵɵpipe(1, "orderBy");
        i0.ɵɵtemplate(2, PlanCoverageProvidersComponent_div_2_Template, 2, 2, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind4(1, 3, ctx.providers, "labelName", false, true))("ngForTrackBy", ctx.providerTrackBy);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.providerInfoEnabled);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, LinkComponent, IconAriaAttributesDirective, PlanCoverageProvidersLabelComponent, OrderPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCoverageProvidersComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-coverage-providers', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngFor=\"let provider of providers | orderBy : 'labelName' : false : true; index as index; trackBy: providerTrackBy\">\r\n  <div *ngIf=\"index === 5\" class=\"mb-1 clear-both\">\r\n    <vnext-link\r\n      [makeInlineBlock]=\"true\"\r\n      [keyNameForLiveEdit]=\"'Spa_Site_Hide_Text'\"\r\n      [ariaLabel]=\"showAllProvidersLabels ? planCoverageViewAllLinkText : planCoverageHideLinkText\"\r\n      [role]=\"linkRoles.BUTTON\"\r\n      (click)=\"toggleViewAll()\"\r\n      (keyup.enter)=\"toggleViewAll()\"\r\n    >\r\n      <div class=\"pl-2\" link-body>\r\n        <ng-container *ngIf=\"showAllProvidersLabels; else hideAllProviders\">\r\n          {{ planCoverageHideLinkText }}<i class=\"ml-1 fas fa-angle-up\"></i><span class=\"sr-only\">Collapse</span>\r\n        </ng-container>\r\n        <ng-template #hideAllProviders> {{ planCoverageViewAllLinkText }}<i class=\"ml-1 fas fa-angle-down\"></i><span class=\"sr-only\">Expand</span> </ng-template>\r\n      </div>\r\n    </vnext-link>\r\n  </div>\r\n  <div class=\"float-left\">\r\n    <div class=\"Spa_Style_Small_Font mb-2 pr-1\" *ngIf=\"index < 5 || showAllProvidersLabels\">\r\n      <vnext-plan-coverage-providers-label\r\n        [provider]=\"provider\"\r\n        [providerDetails]=\"providerDetails\"\r\n        [planId]=\"plan.id\"\r\n        [providerInfoEnabled]=\"providerInfoEnabled\"\r\n        [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n        [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n      ></vnext-plan-coverage-providers-label>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"float-right\" *ngIf=\"providerInfoEnabled\">\r\n  <vnext-link\r\n    (click)=\"planCardFacade.showProvidersInfo(plan)\"\r\n    [title]=\"providerInNetworkText\"\r\n    [keyNameForLiveEdit]=\"'Spa_PlanCard_Providers_InNetwork_Location_Text'\"\r\n  ></vnext-link>\r\n</div>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: PlanCardFacade }]; }, { providers: [{
            type: Input
        }], planCoverageHideLinkText: [{
            type: Input
        }], planCoverageViewAllLinkText: [{
            type: Input
        }], providerDetails: [{
            type: Input
        }], plan: [{
            type: Input
        }], providerInNetworkText: [{
            type: Input
        }], providerInfoEnabled: [{
            type: Input
        }], providerInNetworkOnOtherLocationsTooltipText: [{
            type: Input
        }], providerShowPartialIndicatorEnabled: [{
            type: Input
        }] }); })();

class PlanCoveragePrescriptionsLabelComponent {
    constructor() {
        this.drugCovered = false;
    }
    ngOnChanges(changes) {
        if (changes.dosageID?.previousValue !== changes.dosageID?.currentValue ||
            !_isEqual(changes.coveredDrugDosageIds?.previousValue, changes.coveredDrugDosageIds?.currentValue)) {
            this.drugCovered = this.isDrugCovered(this.dosageID);
        }
    }
    isDrugCovered(drugDoseId) {
        return !!this.coveredDrugDosageIds?.includes(drugDoseId);
    }
}
PlanCoveragePrescriptionsLabelComponent.ɵfac = function PlanCoveragePrescriptionsLabelComponent_Factory(t) { return new (t || PlanCoveragePrescriptionsLabelComponent)(); };
PlanCoveragePrescriptionsLabelComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCoveragePrescriptionsLabelComponent, selectors: [["vnext-plan-coverage-prescriptions-label"]], inputs: { dosageID: "dosageID", coveredDrugDosageIds: "coveredDrugDosageIds", displayLabelMaxWidth: "displayLabelMaxWidth", labelName: "labelName" }, features: [i0.ɵɵNgOnChangesFeature], decls: 4, vars: 6, consts: [[1, "no-translate-block", 3, "ngClass"], [3, "ngClass"]], template: function PlanCoveragePrescriptionsLabelComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "i", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "trimText");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", ctx.drugCovered ? "Spa_Style_Primary_Color" : "Spa_Style_Gray4_Color");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.drugCovered ? "fas fa-check text-success" : "fas fa-times-circle");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 3, ctx.labelName, ctx.displayLabelMaxWidth), "\n");
    } }, dependencies: [i1$2.NgClass, TrimTextPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCoveragePrescriptionsLabelComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-coverage-prescriptions-label', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"no-translate-block\" [ngClass]=\"drugCovered ?'Spa_Style_Primary_Color': 'Spa_Style_Gray4_Color'\">\r\n  <i [ngClass]=\"drugCovered ? 'fas fa-check text-success' : 'fas fa-times-circle'\"></i>\r\n  {{ labelName | trimText: displayLabelMaxWidth }}\r\n</div>\r\n" }]
    }], null, { dosageID: [{
            type: Input
        }], coveredDrugDosageIds: [{
            type: Input
        }], displayLabelMaxWidth: [{
            type: Input
        }], labelName: [{
            type: Input
        }] }); })();

function PlanCoveragePrescriptionsComponent_div_0_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 12);
    i0.ɵɵelementStart(3, "span", 13);
    i0.ɵɵtext(4, "Collapse");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.planCoverageHideLinkText, "");
} }
function PlanCoveragePrescriptionsComponent_div_0_div_1_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵelement(1, "i", 14);
    i0.ɵɵelementStart(2, "span", 13);
    i0.ɵɵtext(3, "Expand");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.planCoverageViewAllLinkText, "");
} }
function PlanCoveragePrescriptionsComponent_div_0_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "vnext-plan-drug-alternatives-indicator", 16);
    i0.ɵɵlistener("drugAlternativesNudgeClick", function PlanCoveragePrescriptionsComponent_div_0_div_1_div_7_Template_vnext_plan_drug_alternatives_indicator_drugAlternativesNudgeClick_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r10.onDrugAlternativesNudgeClick()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("drugAlternativesTooltipText", ctx_r9.drugAlternativesTooltipText)("nudgeDrugAlternativesLabelText", ctx_r9.nudgeDrugAlternativesLabelText)("drugAlternativesIndicatorIcon", ctx_r9.drugAlternativesIndicatorIcon)("isMobile", ctx_r9.isMobile);
} }
function PlanCoveragePrescriptionsComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "vnext-link", 7);
    i0.ɵɵlistener("click", function PlanCoveragePrescriptionsComponent_div_0_div_1_Template_vnext_link_click_2_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r12.toggleViewAll()); })("keyup.enter", function PlanCoveragePrescriptionsComponent_div_0_div_1_Template_vnext_link_keyup_enter_2_listener() { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r14.toggleViewAll()); });
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtemplate(4, PlanCoveragePrescriptionsComponent_div_0_div_1_ng_container_4_Template, 5, 1, "ng-container", 9);
    i0.ɵɵtemplate(5, PlanCoveragePrescriptionsComponent_div_0_div_1_ng_template_5_Template, 4, 1, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, PlanCoveragePrescriptionsComponent_div_0_div_1_div_7_Template, 2, 4, "div", 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r7 = i0.ɵɵreference(6);
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("makeInlineBlock", true)("keyNameForLiveEdit", "Spa_Site_Hide_Text")("ariaLabel", ctx_r4.showAllMedicineLabels ? ctx_r4.planCoverageViewAllLinkText : ctx_r4.planCoverageHideLinkText)("role", ctx_r4.linkRoles.BUTTON);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.showAllMedicineLabels)("ngIfElse", _r7);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r4.showOffFormularyDrugAlternativesTooltip);
} }
function PlanCoveragePrescriptionsComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "vnext-plan-coverage-prescriptions-label", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const medicine_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("dosageID", medicine_r2.dosageID)("coveredDrugDosageIds", ctx_r5.coveredDrugDosageIds)("displayLabelMaxWidth", ctx_r5.displayLabelMaxWidth)("labelName", medicine_r2.labelName);
} }
function PlanCoveragePrescriptionsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PlanCoveragePrescriptionsComponent_div_0_div_1_Template, 8, 7, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵtemplate(3, PlanCoveragePrescriptionsComponent_div_0_div_3_Template, 2, 4, "div", 4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const index_r3 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", index_r3 === 5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", index_r3 < 5 || ctx_r0.showAllMedicineLabels);
} }
function PlanCoveragePrescriptionsComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19)(1, "vnext-plan-drug-alternatives-indicator", 16);
    i0.ɵɵlistener("drugAlternativesNudgeClick", function PlanCoveragePrescriptionsComponent_div_2_Template_vnext_plan_drug_alternatives_indicator_drugAlternativesNudgeClick_1_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.onDrugAlternativesNudgeClick()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("drugAlternativesTooltipText", ctx_r1.drugAlternativesTooltipText)("nudgeDrugAlternativesLabelText", ctx_r1.nudgeDrugAlternativesLabelText)("drugAlternativesIndicatorIcon", ctx_r1.drugAlternativesIndicatorIcon)("isMobile", ctx_r1.isMobile);
} }
class PlanCoveragePrescriptionsComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.showOffFormularyDrugAlternativesTooltip = false;
        this.drugAlternativesNudgeClick = new EventEmitter();
        this.showAllMedicineLabels = false;
        this.displayLabelMaxWidth = 17;
        this.linkRoles = LinkRoles;
    }
    drugTrackBy(index, medicine) {
        return medicine.dosageID;
    }
    toggleViewAll() {
        this.showAllMedicineLabels = !this.showAllMedicineLabels;
        this.cdr.detectChanges();
    }
    onDrugAlternativesNudgeClick() {
        this.drugAlternativesNudgeClick.emit();
    }
}
PlanCoveragePrescriptionsComponent.ɵfac = function PlanCoveragePrescriptionsComponent_Factory(t) { return new (t || PlanCoveragePrescriptionsComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
PlanCoveragePrescriptionsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCoveragePrescriptionsComponent, selectors: [["vnext-plan-coverage-prescriptions"]], inputs: { medicineCabinet: "medicineCabinet", planCoverageHideLinkText: "planCoverageHideLinkText", planCoverageViewAllLinkText: "planCoverageViewAllLinkText", coveredDrugDosageIds: "coveredDrugDosageIds", drugAlternativesTooltipText: "drugAlternativesTooltipText", nudgeDrugAlternativesLabelText: "nudgeDrugAlternativesLabelText", drugAlternativesIndicatorIcon: "drugAlternativesIndicatorIcon", showOffFormularyDrugAlternativesTooltip: "showOffFormularyDrugAlternativesTooltip", isMobile: "isMobile" }, outputs: { drugAlternativesNudgeClick: "drugAlternativesNudgeClick" }, decls: 3, vars: 8, consts: [[4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "mt-1 pl-1 clear-both", 4, "ngIf"], ["class", "mb-1 clear-both", 4, "ngIf"], [1, "float-left"], ["class", "Spa_Style_Small_Font mb-2 pr-1", 4, "ngIf"], [1, "mb-1", "clear-both"], [1, "d-flex", "flex-column", "flex-lg-row", "justify-content-lg-between", "align-items-lg-center"], [3, "makeInlineBlock", "keyNameForLiveEdit", "ariaLabel", "role", "click", "keyup.enter"], ["link-body", "", 1, "pl-2"], [4, "ngIf", "ngIfElse"], ["hideAllMedicines", ""], ["class", "mt-1 mt-lg-0 pl-2", 4, "ngIf"], [1, "ml-1", "fas", "fa-angle-up"], [1, "sr-only"], [1, "ml-1", "fas", "fa-angle-down"], [1, "mt-1", "mt-lg-0", "pl-2"], [3, "drugAlternativesTooltipText", "nudgeDrugAlternativesLabelText", "drugAlternativesIndicatorIcon", "isMobile", "drugAlternativesNudgeClick"], [1, "Spa_Style_Small_Font", "mb-2", "pr-1"], [3, "dosageID", "coveredDrugDosageIds", "displayLabelMaxWidth", "labelName"], [1, "mt-1", "pl-1", "clear-both"]], template: function PlanCoveragePrescriptionsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanCoveragePrescriptionsComponent_div_0_Template, 4, 2, "div", 0);
        i0.ɵɵpipe(1, "orderBy");
        i0.ɵɵtemplate(2, PlanCoveragePrescriptionsComponent_div_2_Template, 2, 4, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind4(1, 3, ctx.medicineCabinet, "labelName", false, true))("ngForTrackBy", ctx.drugTrackBy);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showOffFormularyDrugAlternativesTooltip && ctx.medicineCabinet.length <= 5);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, LinkComponent, IconAriaAttributesDirective, PlanDrugAlternativesIndicatorComponent, PlanCoveragePrescriptionsLabelComponent, OrderPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCoveragePrescriptionsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-coverage-prescriptions', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngFor=\"let medicine of medicineCabinet | orderBy: 'labelName':false:true; index as index; trackBy: drugTrackBy\">\r\n  <div *ngIf=\"index === 5\" class=\"mb-1 clear-both\">\r\n    <div class=\"d-flex flex-column flex-lg-row justify-content-lg-between align-items-lg-center\">\r\n      <vnext-link\r\n        [makeInlineBlock]=\"true\"\r\n        [keyNameForLiveEdit]=\"'Spa_Site_Hide_Text'\"\r\n        [ariaLabel]=\"showAllMedicineLabels ? planCoverageViewAllLinkText : planCoverageHideLinkText\"\r\n        [role]=\"linkRoles.BUTTON\"\r\n        (click)=\"toggleViewAll()\"\r\n        (keyup.enter)=\"toggleViewAll()\"\r\n      >\r\n        <div class=\"pl-2\" link-body>\r\n          <ng-container *ngIf=\"showAllMedicineLabels; else hideAllMedicines\">\r\n            {{ planCoverageHideLinkText }}<i class=\"ml-1 fas fa-angle-up\"></i><span class=\"sr-only\">Collapse</span>\r\n          </ng-container>\r\n          <ng-template #hideAllMedicines> {{ planCoverageViewAllLinkText }}<i class=\"ml-1 fas fa-angle-down\"></i><span class=\"sr-only\">Expand</span> </ng-template>\r\n        </div>\r\n      </vnext-link>\r\n\r\n      <div class=\"mt-1 mt-lg-0 pl-2\" *ngIf=\"showOffFormularyDrugAlternativesTooltip\">\r\n        <vnext-plan-drug-alternatives-indicator\r\n          [drugAlternativesTooltipText]=\"drugAlternativesTooltipText\"\r\n          [nudgeDrugAlternativesLabelText]=\"nudgeDrugAlternativesLabelText\"\r\n          [drugAlternativesIndicatorIcon]=\"drugAlternativesIndicatorIcon\"\r\n          [isMobile]=\"isMobile\"\r\n          (drugAlternativesNudgeClick)=\"onDrugAlternativesNudgeClick()\"\r\n        ></vnext-plan-drug-alternatives-indicator>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"float-left\">\r\n    <div class=\"Spa_Style_Small_Font mb-2 pr-1\" *ngIf=\"index < 5 || showAllMedicineLabels\">\r\n      <vnext-plan-coverage-prescriptions-label\r\n        [dosageID]=\"medicine.dosageID\"\r\n        [coveredDrugDosageIds]=\"coveredDrugDosageIds\"\r\n        [displayLabelMaxWidth]=\"displayLabelMaxWidth\"\r\n        [labelName]=\"medicine.labelName\"\r\n      ></vnext-plan-coverage-prescriptions-label>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"mt-1 pl-1 clear-both\" *ngIf=\"showOffFormularyDrugAlternativesTooltip && medicineCabinet.length <= 5\">\r\n  <vnext-plan-drug-alternatives-indicator\r\n    [drugAlternativesTooltipText]=\"drugAlternativesTooltipText\"\r\n    [nudgeDrugAlternativesLabelText]=\"nudgeDrugAlternativesLabelText\"\r\n    [drugAlternativesIndicatorIcon]=\"drugAlternativesIndicatorIcon\"\r\n    [isMobile]=\"isMobile\"\r\n    (drugAlternativesNudgeClick)=\"onDrugAlternativesNudgeClick()\"\r\n  ></vnext-plan-drug-alternatives-indicator>\r\n</div>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { medicineCabinet: [{
            type: Input
        }], planCoverageHideLinkText: [{
            type: Input
        }], planCoverageViewAllLinkText: [{
            type: Input
        }], coveredDrugDosageIds: [{
            type: Input
        }], drugAlternativesTooltipText: [{
            type: Input
        }], nudgeDrugAlternativesLabelText: [{
            type: Input
        }], drugAlternativesIndicatorIcon: [{
            type: Input
        }], showOffFormularyDrugAlternativesTooltip: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], drugAlternativesNudgeClick: [{
            type: Output
        }] }); })();

function LegacyPlanCoveragePreferencesComponent_div_0_div_2_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind4(2, 1, ctx_r4.annualCost.totalEstimatedCost, "USD", "symbol", "1.0-0"), " ");
} }
function LegacyPlanCoveragePreferencesComponent_div_0_div_2_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.noCostAvailableText, " ");
} }
function LegacyPlanCoveragePreferencesComponent_div_0_div_2_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.effectiveDateText, " ");
} }
const _c0$2y = function (a0, a1) { return { "col-12 p-0 p-md-2 text-center order-first": a0, "col-5 col-md-3 p-2 order-last pr-md-0": a1 }; };
function LegacyPlanCoveragePreferencesComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 8)(2, "div", 9)(3, "div", 10)(4, "vnext-tooltip", 11)(5, "u");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "div", 12);
    i0.ɵɵtemplate(8, LegacyPlanCoveragePreferencesComponent_div_0_div_2_ng_container_8_Template, 3, 6, "ng-container", 13);
    i0.ɵɵtemplate(9, LegacyPlanCoveragePreferencesComponent_div_0_div_2_ng_template_9_Template, 1, 1, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, LegacyPlanCoveragePreferencesComponent_div_0_div_2_div_11_Template, 2, 1, "div", 15);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const _r5 = i0.ɵɵreference(10);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c0$2y, ctx_r1.isMobile || ctx_r1.isTileDisplay, !ctx_r1.isMobile && !ctx_r1.isTileDisplay));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("header", ctx_r1.totalEstimatedCostTooltip.header)("body", ctx_r1.totalEstimatedCostTooltip.body)("customClass", "Spa_Style_Regular_Weight")("Spa_Site_Tooltip_Text", ctx_r1.Spa_Site_Tooltip_Text);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.isTotalCostAnnual ? ctx_r1.totalEstimatedAnnualCostText : ctx_r1.totalEstimatedCostText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isTotalEstimatedCostAvailable())("ngIfElse", _r5);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.showEffectiveDateText);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-value-based-care-agreement", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("customClass", "pl-1 pt-2")("vbcAgreementLabel", ctx_r10.vbcAgreementLabel)("vbcAgreementTooltip", ctx_r10.vbcAgreementTooltip)("Spa_Site_Tooltip_Text", ctx_r10.Spa_Site_Tooltip_Text);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_container_1_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r27.pharmacy == null ? null : ctx_r27.pharmacy.name, " ");
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_container_1_ng_container_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r28.mailOrderText, " ");
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-tooltip", 11);
    i0.ɵɵtemplate(2, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_container_1_ng_container_1_div_2_Template, 2, 1, "div", 26);
    i0.ɵɵtemplate(3, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_container_1_ng_container_1_div_3_Template, 2, 1, "div", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("header", ctx_r23.viewCostTooltipHeaderText)("body", ctx_r23.viewCostTooltipHeaderContent)("customClass", "Spa_Style_Regular_Weight ml-4")("Spa_Site_Tooltip_Text", ctx_r23.Spa_Site_Tooltip_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r23.showMailOrderLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r23.showMailOrderLabel);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_container_1_ng_container_2_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(9);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r32.inNetworkPreferredText);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_container_1_ng_container_2_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(9);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r34.inNetworkStandardText);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_container_1_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_container_1_ng_container_2_ng_container_1_ng_container_1_Template, 3, 1, "ng-container", 13);
    i0.ɵɵtemplate(2, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_container_1_ng_container_2_ng_container_1_ng_template_2_Template, 2, 1, "ng-template", null, 31, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r33 = i0.ɵɵreference(3);
    const ctx_r29 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r29.pharmacy == null ? null : ctx_r29.pharmacy.isPreferred)("ngIfElse", _r33);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_container_1_ng_container_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r31.outOfNetworkText);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_container_1_ng_container_2_ng_container_1_Template, 4, 2, "ng-container", 13);
    i0.ɵɵtemplate(2, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_container_1_ng_container_2_ng_template_2_Template, 2, 1, "ng-template", null, 30, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r30 = i0.ɵɵreference(3);
    const ctx_r24 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r24.pharmacy == null ? null : ctx_r24.pharmacy.isInNetwork)("ngIfElse", _r30);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_container_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r26.pharmacyNotCoveredText, " ");
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_container_1_ng_container_1_Template, 4, 6, "ng-container", 13);
    i0.ɵɵtemplate(2, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_container_1_ng_container_2_Template, 4, 2, "ng-container", 21);
    i0.ɵɵtemplate(3, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_container_1_ng_template_3_Template, 2, 1, "ng-template", null, 25, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r25 = i0.ɵɵreference(4);
    const ctx_r20 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r20.pharmacy)("ngIfElse", _r25);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r20.showMailOrderLabel && ctx_r20.pharmacy);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-loader-placeholder", 34);
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("loaderIconEnabled", ctx_r22.loaderIconEnabled)("spinnerSize", ctx_r22.spinnerSizeSmall)("loaderText", ctx_r22.pharmacyLoadingText)("loaderTextCustomClasses", "Spa_Style_Note pl-4");
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_container_1_Template, 5, 3, "ng-container", 13);
    i0.ɵɵtemplate(2, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_ng_template_2_Template, 1, 4, "ng-template", null, 24, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r21 = i0.ɵɵreference(3);
    const ctx_r15 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r15.plansLoading)("ngIfElse", _r21);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 35);
    i0.ɵɵelement(2, "vnext-plan-preference-text", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const preferences_r8 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("preferenceTitle", preferences_r8.title)("drugCoverageText", ctx_r16.drugCoverageText)("pharmacy", ctx_r16.pharmacy)("pharmacyCoveredText", ctx_r16.pharmacyCoveredText)("pharmacyNotCoveredText", ctx_r16.pharmacyNotCoveredText);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 37);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r17.pharmacyNotCoveredText, " ");
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 39);
    i0.ɵɵelement(2, "vnext-plan-coverage-providers", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("providers", ctx_r36.selectedProviders)("planCoverageHideLinkText", ctx_r36.planCoverageHideLinkText)("planCoverageViewAllLinkText", ctx_r36.planCoverageViewAllLinkText)("providerDetails", ctx_r36.providerDetails)("plan", ctx_r36.plan)("providerInNetworkText", ctx_r36.providerInNetworkText)("providerInfoEnabled", ctx_r36.providerInfoEnabled)("providerInNetworkOnOtherLocationsTooltipText", ctx_r36.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r36.providerShowPartialIndicatorEnabled);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_4_ng_template_2_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 45)(1, "vnext-link", 46);
    i0.ɵɵlistener("click", function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_4_ng_template_2_div_0_div_1_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r47); const ctx_r46 = i0.ɵɵnextContext(8); return i0.ɵɵresetView(ctx_r46.planCardFacade.showProvidersInfo(ctx_r46.plan)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r41.providersCoveredText);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_4_ng_template_2_div_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 47);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(8);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r43.providersCoveredText, "html"), i0.ɵɵsanitizeHtml);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_4_ng_template_2_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵelement(1, "i", 49);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r44.providerOneOrMoreOutOfNetworkText);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_4_ng_template_2_div_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-value-based-care-agreement", 23);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("customClass", "pl-4")("vbcAgreementLabel", ctx_r45.vbcAgreementLabel)("vbcAgreementTooltip", ctx_r45.vbcAgreementTooltip)("Spa_Site_Tooltip_Text", ctx_r45.Spa_Site_Tooltip_Text);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_4_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_4_ng_template_2_div_0_div_1_Template, 2, 1, "div", 41);
    i0.ɵɵtemplate(2, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_4_ng_template_2_div_0_ng_template_2_Template, 2, 4, "ng-template", null, 42, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_4_ng_template_2_div_0_div_4_Template, 4, 1, "div", 43);
    i0.ɵɵelementStart(5, "div", 44);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_4_ng_template_2_div_0_ng_container_7_Template, 2, 4, "ng-container", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r42 = i0.ɵɵreference(3);
    const ctx_r39 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r39.showProviderCoverageLink)("ngIfElse", _r42);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r39.showProviderInNetworkOnOtherLocation && ctx_r39.providerShowPartialIndicatorEnabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r39.providerPcpText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r39.hasVbcAgreement);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_4_ng_template_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-loader-placeholder", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("loaderIconEnabled", ctx_r40.loaderIconEnabled)("spinnerSize", ctx_r40.spinnerSizeSmall)("loaderText", ctx_r40.providerLoadingText)("loaderTextCustomClasses", "Spa_Style_Note pl-4");
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_4_ng_template_2_div_0_Template, 8, 5, "div", 21);
    i0.ɵɵtemplate(1, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_4_ng_template_2_div_1_Template, 2, 4, "div", 21);
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("ngIf", !ctx_r38.showProviderLoading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r38.showProviderLoading);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_4_ng_container_1_Template, 3, 9, "ng-container", 13);
    i0.ɵɵtemplate(2, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_4_ng_template_2_Template, 2, 2, "ng-template", null, 38, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r37 = i0.ɵɵreference(3);
    const ctx_r18 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.providerDetailedEnabled && !ctx_r18.showProviderLoading && ctx_r18.selectedProviders.length > 0)("ngIfElse", _r37);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r52 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 52)(1, "div", 45)(2, "vnext-plan-coverage-prescriptions", 53);
    i0.ɵɵlistener("drugAlternativesNudgeClick", function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_5_div_1_Template_vnext_plan_coverage_prescriptions_drugAlternativesNudgeClick_2_listener() { i0.ɵɵrestoreView(_r52); const ctx_r51 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r51.onDrugAlternativesNudgeClick()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("medicineCabinet", ctx_r48.medicineCabinet)("planCoverageHideLinkText", ctx_r48.planCoverageHideLinkText)("planCoverageViewAllLinkText", ctx_r48.planCoverageViewAllLinkText)("coveredDrugDosageIds", ctx_r48.coveredDrugDosageIds)("nudgeDrugAlternativesLabelText", ctx_r48.nudgeDrugAlternativesLabelText)("drugAlternativesTooltipText", ctx_r48.drugAlternativesTooltipText)("drugAlternativesIndicatorIcon", ctx_r48.drugAlternativesIndicatorIcon)("showOffFormularyDrugAlternativesTooltip", ctx_r48.showOffFormularyDrugAlternativesTooltip)("isMobile", ctx_r48.isMobile);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_5_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-plan-preference-text", 36);
} if (rf & 2) {
    const preferences_r8 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r50 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("preferenceTitle", preferences_r8.title)("drugCoverageText", ctx_r50.drugCoverageText)("pharmacy", ctx_r50.pharmacy)("pharmacyCoveredText", ctx_r50.pharmacyCoveredText)("pharmacyNotCoveredText", ctx_r50.pharmacyNotCoveredText);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_5_div_1_Template, 3, 9, "div", 50);
    i0.ɵɵtemplate(2, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_5_ng_template_2_Template, 1, 5, "ng-template", null, 51, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r49 = i0.ɵɵreference(3);
    const ctx_r19 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.planCardPreferenceDetailedEnabled)("ngIfElse", _r49);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_1_Template, 4, 2, "ng-container", 21);
    i0.ɵɵtemplate(2, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_2_Template, 3, 5, "ng-container", 21);
    i0.ɵɵtemplate(3, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_3_Template, 3, 1, "ng-container", 21);
    i0.ɵɵtemplate(4, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_4_Template, 4, 2, "ng-container", 21);
    i0.ɵɵtemplate(5, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_ng_container_5_Template, 4, 2, "ng-container", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const preferences_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", preferences_r8.title === ctx_r11.planPreferenceLabels.PHARMACY);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", preferences_r8.title !== ctx_r11.planPreferenceLabels.PHARMACY && preferences_r8.title !== ctx_r11.planPreferenceLabels.PROVIDERS && preferences_r8.title !== ctx_r11.planPreferenceLabels.PRESCRIPTIONS);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", preferences_r8.title === ctx_r11.planPreferenceLabels.PHARMACY && ctx_r11.showMailOrderLabel && !ctx_r11.plan.hasMailDrugBenefits);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", preferences_r8.title === ctx_r11.planPreferenceLabels.PROVIDERS);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", preferences_r8.title === ctx_r11.planPreferenceLabels.PRESCRIPTIONS);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const preferences_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind4(2, 1, ctx_r13.getPreferencesCost(preferences_r8.title), "USD", "symbol", "1.0-0"), " ");
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_div_11_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 54)(2, "vnext-plan-drug-alternatives-indicator", 55);
    i0.ɵɵlistener("drugAlternativesNudgeClick", function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_div_11_div_1_Template_vnext_plan_drug_alternatives_indicator_drugAlternativesNudgeClick_2_listener() { i0.ɵɵrestoreView(_r58); const ctx_r57 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r57.onDrugAlternativesNudgeClick()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r56 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("drugAlternativesTooltipText", ctx_r56.drugAlternativesTooltipText)("nudgeDrugAlternativesLabelText", ctx_r56.nudgeDrugAlternativesLabelText)("drugAlternativesIndicatorIcon", ctx_r56.drugAlternativesIndicatorIcon)("isMobile", ctx_r56.isMobile);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_div_11_div_1_Template, 3, 4, "div", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const preferences_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", preferences_r8.title === ctx_r14.planPreferenceLabels.PRESCRIPTIONS && ctx_r14.showOffFormularyDrugAlternativesTooltip);
} }
const _c1$1h = function (a0, a1) { return { "row": a0, "mr-2": a1 }; };
const _c2$N = function (a0, a1) { return { "col-md-4 col-xs-12": a0, "col-12": a1 }; };
const _c3$w = function (a0, a1, a2, a3, a4) { return { Spa_Style_ProvidersIcon: a0, Spa_Style_PharmacyIcon: a1, Spa_Style_PrescriptionsIcon: a2, Spa_Style_CostIcon: a3, Spa_Style_HealthIcon: a4 }; };
const _c4$h = function (a0, a1) { return { "col-md-8 col-xs-12 pl-xs-4": a0, "col-12": a1 }; };
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 5)(2, "div", 19);
    i0.ɵɵelement(3, "span", 20);
    i0.ɵɵelementStart(4, "strong");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_div_6_Template, 2, 4, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 5);
    i0.ɵɵtemplate(8, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_container_8_Template, 6, 5, "ng-container", 13);
    i0.ɵɵtemplate(9, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_ng_template_9_Template, 3, 6, "ng-template", null, 22, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(11, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_div_11_Template, 2, 1, "div", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r12 = i0.ɵɵreference(10);
    const preferences_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r9.getBootstrapClass());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(10, _c1$1h, ctx_r9.planCardPreferenceDetailedEnabled, !ctx_r9.isTileDisplay && !ctx_r9.compareTwoPlans && ctx_r9.planCardPreferenceDetailedEnabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(13, _c2$N, !ctx_r9.isTileDisplay && !ctx_r9.compareTwoPlans && ctx_r9.planCardPreferenceDetailedEnabled, (ctx_r9.isTileDisplay || ctx_r9.compareTwoPlans) && ctx_r9.planCardPreferenceDetailedEnabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction5(16, _c3$w, preferences_r8.title === ctx_r9.planPreferenceLabels.PROVIDERS, preferences_r8.title === ctx_r9.planPreferenceLabels.PHARMACY, preferences_r8.title === ctx_r9.planPreferenceLabels.PRESCRIPTIONS, preferences_r8.title === ctx_r9.planPreferenceLabels.TOTAL_DRUG_COSTS, preferences_r8.title === ctx_r9.planPreferenceLabels.HEALTH_COSTS));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", preferences_r8.label, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.hasVbcAgreement && preferences_r8.title === ctx_r9.planPreferenceLabels.PROVIDERS && ctx_r9.providerDetailedEnabled && !ctx_r9.showProviderLoading && ctx_r9.selectedProviders.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(22, _c4$h, !ctx_r9.isTileDisplay && !ctx_r9.compareTwoPlans && ctx_r9.planCardPreferenceDetailedEnabled, (ctx_r9.isTileDisplay || ctx_r9.compareTwoPlans) && ctx_r9.planCardPreferenceDetailedEnabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", preferences_r8.title === ctx_r9.planPreferenceLabels.PHARMACY || preferences_r8.title === ctx_r9.planPreferenceLabels.PRESCRIPTIONS || preferences_r8.title === ctx_r9.planPreferenceLabels.PROVIDERS)("ngIfElse", _r12);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r9.planCardPreferenceDetailedEnabled);
} }
function LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_div_1_Template, 12, 25, "div", 17);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const preferences_r8 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.hasVisitedGuidedHelp && ctx_r2.guidedHelpEnabled && ctx_r2.showPreferencesSection(preferences_r8.title));
} }
function LegacyPlanCoveragePreferencesComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 56)(1, "vnext-link", 57);
    i0.ɵɵlistener("click", function LegacyPlanCoveragePreferencesComponent_div_0_div_8_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r62); const ctx_r61 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r61.gotoFirstGuidedHelpLink()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r3.editLinkText)("keyNameForLiveEdit", "Spa_GuidedHelp_PlanCard_EditLink_Text");
} }
const _c5$c = function (a0, a1) { return { "col-md-9 px-2 pl-md-2 pr-md-0": a0, "px-3": a1 }; };
const _c6$b = function (a0, a1, a2) { return { "pl-1": a0, "cost-horizontal-separator": a1, "cost-vertical-separator": a2 }; };
const _c7$9 = function (a0, a1) { return { "row mr-0": a0, "cost-horizontal-separator": a1 }; };
function LegacyPlanCoveragePreferencesComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtemplate(2, LegacyPlanCoveragePreferencesComponent_div_0_div_2_Template, 12, 12, "div", 3);
    i0.ɵɵelementStart(3, "div", 4)(4, "div", 5)(5, "div", 5);
    i0.ɵɵtemplate(6, LegacyPlanCoveragePreferencesComponent_div_0_ng_container_6_Template, 2, 1, "ng-container", 6);
    i0.ɵɵpipe(7, "orderBy");
    i0.ɵɵtemplate(8, LegacyPlanCoveragePreferencesComponent_div_0_div_8_Template, 2, 2, "div", 7);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isTotalEstimatedCostEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c5$c, !ctx_r0.isTileDisplay, ctx_r0.isTileDisplay));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(12, _c6$b, !ctx_r0.isMobile && !ctx_r0.isTileDisplay, ctx_r0.isMobile && !ctx_r0.isTileDisplay && ctx_r0.showPreferenceSeparator, !ctx_r0.isMobile && !ctx_r0.isTileDisplay && ctx_r0.showPreferenceSeparator));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(16, _c7$9, !ctx_r0.isMobile, ctx_r0.isTileDisplay && ctx_r0.showPreferenceSeparator));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(7, 6, ctx_r0.filteredPlanPreferences, "order"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isMobile);
} }
class LegacyPlanCoveragePreferencesComponent extends PlanCoveragePreferencesBaseComponent {
    constructor(navigationService, guidedHelpService, planFacade, drugDetailsFacade, cdr, localeService, pharmacyService, providerService, analyticsService, store, planCardFacade) {
        super(navigationService, guidedHelpService, planFacade, drugDetailsFacade, cdr, localeService, pharmacyService, providerService, analyticsService, store, planCardFacade);
        this.navigationService = navigationService;
        this.guidedHelpService = guidedHelpService;
        this.planFacade = planFacade;
        this.drugDetailsFacade = drugDetailsFacade;
        this.cdr = cdr;
        this.localeService = localeService;
        this.pharmacyService = pharmacyService;
        this.providerService = providerService;
        this.analyticsService = analyticsService;
        this.store = store;
        this.planCardFacade = planCardFacade;
    }
}
LegacyPlanCoveragePreferencesComponent.ɵfac = function LegacyPlanCoveragePreferencesComponent_Factory(t) { return new (t || LegacyPlanCoveragePreferencesComponent)(i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(DrugDetailsFacade), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.PharmacyService), i0.ɵɵdirectiveInject(i1.ProviderService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(PlanCardFacade)); };
LegacyPlanCoveragePreferencesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LegacyPlanCoveragePreferencesComponent, selectors: [["vnext-legacy-plan-coverage-preferences"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "preferences-section preference-element", 4, "ngIf"], [1, "preferences-section", "preference-element"], [1, "row", "py-2", "cover-section"], [3, "ngClass", 4, "ngIf"], [1, "col-12", 3, "ngClass"], [3, "ngClass"], [4, "ngFor", "ngForOf"], ["class", "col-12 col-md-3 pr-2 py-2 pl-0", 4, "ngIf"], [1, "row"], [1, "col-12", "text-center"], [1, "Spa_Style_Paragraph"], [3, "header", "body", "customClass", "Spa_Site_Tooltip_Text"], [1, "Spa_Style_CostPremiumSmall"], [4, "ngIf", "ngIfElse"], ["notAvailable", ""], ["class", "Spa_Style_Primary_Color Spa_Style_Small_Font", 4, "ngIf"], [1, "Spa_Style_Primary_Color", "Spa_Style_Small_Font"], ["class", "py-2 pl-0 pr-2", 3, "ngClass", 4, "ngIf"], [1, "py-2", "pl-0", "pr-2", 3, "ngClass"], [1, "Spa_Style_Small_Font", "preference-icon", 3, "ngClass"], ["aria-hidden", "true", 3, "ngClass"], [4, "ngIf"], ["showCost", ""], [3, "customClass", "vbcAgreementLabel", "vbcAgreementTooltip", "Spa_Site_Tooltip_Text"], ["plansLoadingPlaceholder", ""], ["showNotCovered", ""], ["class", "underline text-left Spa_Style_Paragraph no-translate-block", 4, "ngIf"], ["class", "Spa_Style_Primary_Color Spa_Style_Small_Font text-left", 4, "ngIf"], [1, "underline", "text-left", "Spa_Style_Paragraph", "no-translate-block"], [1, "Spa_Style_Primary_Color", "Spa_Style_Small_Font", "text-left"], ["outOfNetworkPharmacy", ""], ["standardPharmacy", ""], [1, "Spa_Style_Note", "text-left", "pl-4"], [1, "text-left", "Spa_Style_Paragraph", "pl-4"], [3, "loaderIconEnabled", "spinnerSize", "loaderText", "loaderTextCustomClasses"], [1, "Spa_Style_Paragraph", "pl-4"], [3, "preferenceTitle", "drugCoverageText", "pharmacy", "pharmacyCoveredText", "pharmacyNotCoveredText"], [1, "Spa_Style_Primary_Color", "Spa_Style_Small_Font", "pl-4"], ["showProviderText", ""], [1, "col-12", "pl-4"], [3, "providers", "planCoverageHideLinkText", "planCoverageViewAllLinkText", "providerDetails", "plan", "providerInNetworkText", "providerInfoEnabled", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled"], ["class", "pl-4", 4, "ngIf", "ngIfElse"], ["showProvidersCoveredText", ""], ["class", "Spa_Style_Small_Font partial-indicator-text pl-4", 4, "ngIf"], [1, "Spa_Style_Note", "pl-4"], [1, "pl-4"], [3, "title", "click"], ["navigationAdapter", "", 1, "pl-4", 3, "innerHTML"], [1, "Spa_Style_Small_Font", "partial-indicator-text", "pl-4"], [1, "fas", "fa-exclamation-triangle", "mr-1"], ["class", "d-flex flex-column", 4, "ngIf", "ngIfElse"], ["showPrescriptionsText", ""], [1, "d-flex", "flex-column"], [3, "medicineCabinet", "planCoverageHideLinkText", "planCoverageViewAllLinkText", "coveredDrugDosageIds", "nudgeDrugAlternativesLabelText", "drugAlternativesTooltipText", "drugAlternativesIndicatorIcon", "showOffFormularyDrugAlternativesTooltip", "isMobile", "drugAlternativesNudgeClick"], [1, "mt-2"], [3, "drugAlternativesTooltipText", "nudgeDrugAlternativesLabelText", "drugAlternativesIndicatorIcon", "isMobile", "drugAlternativesNudgeClick"], [1, "col-12", "col-md-3", "pr-2", "py-2", "pl-0"], [3, "title", "keyNameForLiveEdit", "click"]], template: function LegacyPlanCoveragePreferencesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LegacyPlanCoveragePreferencesComponent_div_0_Template, 9, 19, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.newPlanCardDesignEnabled && (ctx.hasVisitedGuidedHelp && ctx.showPreferences || ctx.isTotalEstimatedCostEnabled && (ctx.isRetention || ctx.isQuoting)));
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, TooltipComponent, LoaderPlaceholderComponent, ValueBasedCareAgreementComponent, NavigationAdapterDirective, IconAriaAttributesDirective, PlanDrugAlternativesIndicatorComponent, PlanPreferenceTextComponent, PlanCoverageProvidersComponent, PlanCoveragePrescriptionsComponent, i1$2.CurrencyPipe, SafePipe, OrderPipe], styles: [".plan-card[_ngcontent-%COMP%]{border-width:1px;border-style:solid;border-top-right-radius:4px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;padding:8px 0 0}.plan-card.plan-card-border[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent1);border-top-left-radius:4px}.plan-card[_ngcontent-%COMP%]   .image-responsive[_ngcontent-%COMP%]{padding-right:0;max-width:100%;text-align:center}.score-display[_ngcontent-%COMP%]{color:red}.monthly-premium-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;height:100%;align-items:center;justify-content:center}.plan-premium[_ngcontent-%COMP%]{line-height:17px;margin-bottom:5px}.plan-benefits-column-list[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;list-style:none;padding:0}.plan-benefits-column-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child, .plan-benefits-column-list.plan-benefits-row-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-bottom:0;margin-bottom:16px}.coverage[_ngcontent-%COMP%]{border-radius:14px;text-align:center;padding:4px}.coverage[_ngcontent-%COMP%]   .fas[_ngcontent-%COMP%]{height:17px;width:18px}.plan-benefits-items[_ngcontent-%COMP%]:focus, .plan_monthly_premium[_ngcontent-%COMP%]:focus, .monthly-premium-container[_ngcontent-%COMP%]:focus, .coverage[_ngcontent-%COMP%]:focus{box-shadow:none;outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:0 0 5px var(--static-Spa_Style_Black);border-radius:5px}.tooltip-icon[_ngcontent-%COMP%]{font-size:12px;padding-right:10px;background-color:transparent;font-family:\"Font Awesome 5 Pro\"}.plan-benefits[_ngcontent-%COMP%]{margin-bottom:16px}.current-plan-text[_ngcontent-%COMP%], .next-year-plan-text[_ngcontent-%COMP%]{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.plan-name[_ngcontent-%COMP%]:focus{border-radius:5px}.card-sub-header-details[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;align-items:baseline}.non-monthly-payment-text[_ngcontent-%COMP%]{font-size:13px;font-family:montserratregular}@media (max-width: 479.98px){.plan-benefits-column-list.plan-benefits-row-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list.plan-benefits-row-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child{border-bottom:0}}.plan-benefits-items[_ngcontent-%COMP%]{flex-basis:33.3333%;flex-grow:0}@media (max-width: 575.98px){.plan-benefits-list-value-container[_ngcontent-%COMP%]{float:right;display:flex;flex-direction:column;align-items:flex-end}.plan-benefits[_ngcontent-%COMP%]{margin-bottom:0}}.no-border[_ngcontent-%COMP%]{border:none!important}", ".cover-section[_ngcontent-%COMP%]{margin-right:1px;margin-left:1px}.preferences-section[_ngcontent-%COMP%]{padding:10px 0 0}.cost-horizontal-separator[_ngcontent-%COMP%]{border-top:1px solid var(--static-Spa_Style_Accent1);height:auto}.cost-vertical-separator[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);height:100%;max-height:100%}.preference-icon[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{width:15px;display:inline-block;text-align:right;margin-right:5px}.underline[_ngcontent-%COMP%]{text-decoration:underline}.partial-indicator-text[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Warn_on_Blue)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LegacyPlanCoveragePreferencesComponent, [{
        type: Component,
        args: [{ selector: 'vnext-legacy-plan-coverage-preferences', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  class=\"preferences-section preference-element\"\r\n  *ngIf=\"\r\n    !newPlanCardDesignEnabled && ((hasVisitedGuidedHelp && showPreferences) || (isTotalEstimatedCostEnabled && (isRetention || isQuoting)))\r\n  \"\r\n>\r\n  <div class=\"row py-2 cover-section\">\r\n    <div\r\n      *ngIf=\"isTotalEstimatedCostEnabled\"\r\n      [ngClass]=\"{\r\n        'col-12 p-0 p-md-2 text-center order-first': isMobile || isTileDisplay,\r\n        'col-5 col-md-3 p-2 order-last pr-md-0': !isMobile && !isTileDisplay\r\n      }\"\r\n    >\r\n      <div class=\"row\">\r\n        <div class=\"col-12 text-center\">\r\n          <div class=\"Spa_Style_Paragraph\">\r\n            <vnext-tooltip\r\n              [header]=\"totalEstimatedCostTooltip.header\"\r\n              [body]=\"totalEstimatedCostTooltip.body\"\r\n              [customClass]=\"'Spa_Style_Regular_Weight'\"\r\n              [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n            >\r\n              <u> {{ isTotalCostAnnual ? totalEstimatedAnnualCostText : totalEstimatedCostText }} </u>\r\n            </vnext-tooltip>\r\n          </div>\r\n          <div class=\"Spa_Style_CostPremiumSmall\">\r\n            <ng-container *ngIf=\"isTotalEstimatedCostAvailable(); else notAvailable\">\r\n              {{ annualCost.totalEstimatedCost | currency : 'USD' : 'symbol' : '1.0-0' }}\r\n            </ng-container>\r\n            <ng-template #notAvailable>\r\n              {{ noCostAvailableText }}\r\n            </ng-template>\r\n          </div>\r\n          <div class=\"Spa_Style_Primary_Color Spa_Style_Small_Font\" *ngIf=\"showEffectiveDateText\">\r\n            {{ effectiveDateText }}\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-12\" [ngClass]=\"{ 'col-md-9 px-2 pl-md-2 pr-md-0': !isTileDisplay, 'px-3': isTileDisplay }\">\r\n      <div\r\n        [ngClass]=\"{\r\n          'pl-1': !isMobile && !isTileDisplay,\r\n          'cost-horizontal-separator': isMobile && !isTileDisplay && showPreferenceSeparator,\r\n          'cost-vertical-separator': !isMobile && !isTileDisplay && showPreferenceSeparator\r\n        }\"\r\n      >\r\n        <div\r\n          [ngClass]=\"{\r\n            'row mr-0': !isMobile,\r\n            'cost-horizontal-separator': isTileDisplay && showPreferenceSeparator\r\n          }\"\r\n        >\r\n          <ng-container *ngFor=\"let preferences of filteredPlanPreferences | orderBy : 'order'\">\r\n            <div\r\n              class=\"py-2 pl-0 pr-2\"\r\n              [ngClass]=\"getBootstrapClass()\"\r\n              *ngIf=\"hasVisitedGuidedHelp && guidedHelpEnabled && showPreferencesSection(preferences.title)\"\r\n            >\r\n              <div\r\n                [ngClass]=\"{\r\n                  'row': planCardPreferenceDetailedEnabled,\r\n                  'mr-2': !isTileDisplay && !compareTwoPlans && planCardPreferenceDetailedEnabled\r\n                }\"\r\n              >\r\n                <div\r\n                  class=\"Spa_Style_Small_Font preference-icon\"\r\n                  [ngClass]=\"{\r\n                    'col-md-4 col-xs-12': !isTileDisplay && !compareTwoPlans && planCardPreferenceDetailedEnabled,\r\n                    'col-12': (isTileDisplay || compareTwoPlans) && planCardPreferenceDetailedEnabled\r\n                  }\"\r\n                >\r\n                  <span\r\n                    [ngClass]=\"{\r\n                      Spa_Style_ProvidersIcon: preferences.title === planPreferenceLabels.PROVIDERS,\r\n                      Spa_Style_PharmacyIcon: preferences.title === planPreferenceLabels.PHARMACY,\r\n                      Spa_Style_PrescriptionsIcon: preferences.title === planPreferenceLabels.PRESCRIPTIONS,\r\n                      Spa_Style_CostIcon: preferences.title === planPreferenceLabels.TOTAL_DRUG_COSTS,\r\n                      Spa_Style_HealthIcon: preferences.title === planPreferenceLabels.HEALTH_COSTS\r\n                    }\"\r\n                    aria-hidden=\"true\"\r\n                  ></span>\r\n                  <strong> {{ preferences.label }}</strong>\r\n                  <div\r\n                    *ngIf=\"\r\n                      hasVbcAgreement &&\r\n                      preferences.title === planPreferenceLabels.PROVIDERS &&\r\n                      providerDetailedEnabled &&\r\n                      !showProviderLoading &&\r\n                      selectedProviders.length > 0\r\n                    \"\r\n                  >\r\n                    <vnext-value-based-care-agreement\r\n                      [customClass]=\"'pl-1 pt-2'\"\r\n                      [vbcAgreementLabel]=\"vbcAgreementLabel\"\r\n                      [vbcAgreementTooltip]=\"vbcAgreementTooltip\"\r\n                      [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                    ></vnext-value-based-care-agreement>\r\n                  </div>\r\n                </div>\r\n                <div\r\n                  [ngClass]=\"{\r\n                    'col-md-8 col-xs-12 pl-xs-4': !isTileDisplay && !compareTwoPlans && planCardPreferenceDetailedEnabled,\r\n                    'col-12': (isTileDisplay || compareTwoPlans) && planCardPreferenceDetailedEnabled\r\n                  }\"\r\n                >\r\n                  <ng-container\r\n                    *ngIf=\"\r\n                      preferences.title === planPreferenceLabels.PHARMACY ||\r\n                        preferences.title === planPreferenceLabels.PRESCRIPTIONS ||\r\n                        preferences.title === planPreferenceLabels.PROVIDERS;\r\n                      else showCost\r\n                    \"\r\n                  >\r\n                    <ng-container *ngIf=\"preferences.title === planPreferenceLabels.PHARMACY\">\r\n                      <ng-container *ngIf=\"!plansLoading; else plansLoadingPlaceholder\">\r\n                        <ng-container *ngIf=\"pharmacy; else showNotCovered\">\r\n                          <vnext-tooltip\r\n                            [header]=\"viewCostTooltipHeaderText\"\r\n                            [body]=\"viewCostTooltipHeaderContent\"\r\n                            [customClass]=\"'Spa_Style_Regular_Weight ml-4'\"\r\n                            [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                          >\r\n                            <div class=\"underline text-left Spa_Style_Paragraph no-translate-block\" *ngIf=\"!showMailOrderLabel\">\r\n                              {{ pharmacy?.name }}\r\n                            </div>\r\n                            <div class=\"Spa_Style_Primary_Color Spa_Style_Small_Font text-left\" *ngIf=\"showMailOrderLabel\">\r\n                              {{ mailOrderText }}\r\n                            </div>\r\n                          </vnext-tooltip>\r\n                        </ng-container>\r\n                        <ng-container *ngIf=\"!showMailOrderLabel && pharmacy\">\r\n                          <ng-container *ngIf=\"pharmacy?.isInNetwork; else outOfNetworkPharmacy\">\r\n                            <ng-container *ngIf=\"pharmacy?.isPreferred; else standardPharmacy\">\r\n                              <div class=\"Spa_Style_Note text-left pl-4\">{{ inNetworkPreferredText }}</div>\r\n                            </ng-container>\r\n                            <ng-template #standardPharmacy>\r\n                              <div class=\"Spa_Style_Note text-left pl-4\">{{ inNetworkStandardText }}</div>\r\n                            </ng-template>\r\n                          </ng-container>\r\n                          <ng-template #outOfNetworkPharmacy>\r\n                            <div class=\"Spa_Style_Note text-left pl-4\">{{ outOfNetworkText }}</div>\r\n                          </ng-template>\r\n                        </ng-container>\r\n                        <ng-template #showNotCovered>\r\n                          <div class=\"text-left Spa_Style_Paragraph pl-4\">\r\n                            {{ pharmacyNotCoveredText }}\r\n                          </div>\r\n                        </ng-template>\r\n                      </ng-container>\r\n                      <ng-template #plansLoadingPlaceholder>\r\n                        <vnext-loader-placeholder\r\n                          [loaderIconEnabled]=\"loaderIconEnabled\"\r\n                          [spinnerSize]=\"spinnerSizeSmall\"\r\n                          [loaderText]=\"pharmacyLoadingText\"\r\n                          [loaderTextCustomClasses]=\"'Spa_Style_Note pl-4'\"\r\n                        >\r\n                        </vnext-loader-placeholder>\r\n                      </ng-template>\r\n                    </ng-container>\r\n                    <ng-container\r\n                      *ngIf=\"\r\n                        preferences.title !== planPreferenceLabels.PHARMACY &&\r\n                        preferences.title !== planPreferenceLabels.PROVIDERS &&\r\n                        preferences.title !== planPreferenceLabels.PRESCRIPTIONS\r\n                      \"\r\n                    >\r\n                      <div class=\"Spa_Style_Paragraph pl-4\">\r\n                        <vnext-plan-preference-text\r\n                          [preferenceTitle]=\"preferences.title\"\r\n                          [drugCoverageText]=\"drugCoverageText\"\r\n                          [pharmacy]=\"pharmacy\"\r\n                          [pharmacyCoveredText]=\"pharmacyCoveredText\"\r\n                          [pharmacyNotCoveredText]=\"pharmacyNotCoveredText\"\r\n                        >\r\n                        </vnext-plan-preference-text>\r\n                      </div>\r\n                    </ng-container>\r\n                    <ng-container\r\n                      *ngIf=\"preferences.title === planPreferenceLabels.PHARMACY && showMailOrderLabel && !plan.hasMailDrugBenefits\"\r\n                    >\r\n                      <div class=\"Spa_Style_Primary_Color Spa_Style_Small_Font pl-4\">\r\n                        {{ pharmacyNotCoveredText }}\r\n                      </div>\r\n                    </ng-container>\r\n                    <ng-container *ngIf=\"preferences.title === planPreferenceLabels.PROVIDERS\">\r\n                      <ng-container\r\n                        *ngIf=\"providerDetailedEnabled && !showProviderLoading && selectedProviders.length > 0; else showProviderText\"\r\n                      >\r\n                        <div class=\"col-12 pl-4\">\r\n                          <vnext-plan-coverage-providers\r\n                            [providers]=\"selectedProviders\"\r\n                            [planCoverageHideLinkText]=\"planCoverageHideLinkText\"\r\n                            [planCoverageViewAllLinkText]=\"planCoverageViewAllLinkText\"\r\n                            [providerDetails]=\"providerDetails\"\r\n                            [plan]=\"plan\"\r\n                            [providerInNetworkText]=\"providerInNetworkText\"\r\n                            [providerInfoEnabled]=\"providerInfoEnabled\"\r\n                            [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n                            [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n                          >\r\n                          </vnext-plan-coverage-providers>\r\n                        </div>\r\n                      </ng-container>\r\n                      <ng-template #showProviderText>\r\n                        <div *ngIf=\"!showProviderLoading\">\r\n                          <div *ngIf=\"showProviderCoverageLink; else showProvidersCoveredText\" class=\"pl-4\">\r\n                            <vnext-link (click)=\"planCardFacade.showProvidersInfo(plan)\" [title]=\"providersCoveredText\"></vnext-link>\r\n                          </div>\r\n                          <ng-template #showProvidersCoveredText>\r\n                            <div class=\"pl-4\" [innerHTML]=\"providersCoveredText | safe : 'html'\" navigationAdapter></div>\r\n                          </ng-template>\r\n                          <div\r\n                            class=\"Spa_Style_Small_Font partial-indicator-text pl-4\"\r\n                            *ngIf=\"showProviderInNetworkOnOtherLocation && providerShowPartialIndicatorEnabled\"\r\n                          >\r\n                            <i class=\"fas fa-exclamation-triangle mr-1\"></i><span>{{ providerOneOrMoreOutOfNetworkText }}</span>\r\n                          </div>\r\n                          <div class=\"Spa_Style_Note pl-4\">{{ providerPcpText }}</div>\r\n                          <ng-container *ngIf=\"hasVbcAgreement\">\r\n                            <vnext-value-based-care-agreement\r\n                              [customClass]=\"'pl-4'\"\r\n                              [vbcAgreementLabel]=\"vbcAgreementLabel\"\r\n                              [vbcAgreementTooltip]=\"vbcAgreementTooltip\"\r\n                              [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                            ></vnext-value-based-care-agreement>\r\n                          </ng-container>\r\n                        </div>\r\n                        <div *ngIf=\"showProviderLoading\">\r\n                          <vnext-loader-placeholder\r\n                            [loaderIconEnabled]=\"loaderIconEnabled\"\r\n                            [spinnerSize]=\"spinnerSizeSmall\"\r\n                            [loaderText]=\"providerLoadingText\"\r\n                            [loaderTextCustomClasses]=\"'Spa_Style_Note pl-4'\"\r\n                          >\r\n                          </vnext-loader-placeholder>\r\n                        </div>\r\n                      </ng-template>\r\n                    </ng-container>\r\n                    <ng-container *ngIf=\"preferences.title === planPreferenceLabels.PRESCRIPTIONS\">\r\n                      <div class=\"d-flex flex-column\" *ngIf=\"planCardPreferenceDetailedEnabled; else showPrescriptionsText\">\r\n                        <div class=\"pl-4\">\r\n                          <vnext-plan-coverage-prescriptions\r\n                            [medicineCabinet]=\"medicineCabinet\"\r\n                            [planCoverageHideLinkText]=\"planCoverageHideLinkText\"\r\n                            [planCoverageViewAllLinkText]=\"planCoverageViewAllLinkText\"\r\n                            [coveredDrugDosageIds]=\"coveredDrugDosageIds\"\r\n                            [nudgeDrugAlternativesLabelText]=\"nudgeDrugAlternativesLabelText\"\r\n                            [drugAlternativesTooltipText]=\"drugAlternativesTooltipText\"\r\n                            [drugAlternativesIndicatorIcon]=\"drugAlternativesIndicatorIcon\"\r\n                            [showOffFormularyDrugAlternativesTooltip]=\"showOffFormularyDrugAlternativesTooltip\"\r\n                            [isMobile]=\"isMobile\"\r\n                            (drugAlternativesNudgeClick)=\"onDrugAlternativesNudgeClick()\"\r\n                          >\r\n                          </vnext-plan-coverage-prescriptions>\r\n                        </div>\r\n                      </div>\r\n                      <ng-template #showPrescriptionsText>\r\n                        <vnext-plan-preference-text\r\n                          [preferenceTitle]=\"preferences.title\"\r\n                          [drugCoverageText]=\"drugCoverageText\"\r\n                          [pharmacy]=\"pharmacy\"\r\n                          [pharmacyCoveredText]=\"pharmacyCoveredText\"\r\n                          [pharmacyNotCoveredText]=\"pharmacyNotCoveredText\"\r\n                        >\r\n                        </vnext-plan-preference-text>\r\n                      </ng-template>\r\n                    </ng-container>\r\n                  </ng-container>\r\n                  <ng-template #showCost>\r\n                    <div class=\"Spa_Style_Primary_Color Spa_Style_Small_Font pl-4\">\r\n                      {{ getPreferencesCost(preferences.title) | currency : 'USD' : 'symbol' : '1.0-0' }}\r\n                    </div>\r\n                  </ng-template>\r\n                </div>\r\n              </div>\r\n\r\n              <div *ngIf=\"!planCardPreferenceDetailedEnabled\">\r\n                <div *ngIf=\"preferences.title === planPreferenceLabels.PRESCRIPTIONS && showOffFormularyDrugAlternativesTooltip\">\r\n                  <div class=\"mt-2\">\r\n                    <vnext-plan-drug-alternatives-indicator\r\n                      [drugAlternativesTooltipText]=\"drugAlternativesTooltipText\"\r\n                      [nudgeDrugAlternativesLabelText]=\"nudgeDrugAlternativesLabelText\"\r\n                      [drugAlternativesIndicatorIcon]=\"drugAlternativesIndicatorIcon\"\r\n                      [isMobile]=\"isMobile\"\r\n                      (drugAlternativesNudgeClick)=\"onDrugAlternativesNudgeClick()\"\r\n                    ></vnext-plan-drug-alternatives-indicator>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </ng-container>\r\n          <div *ngIf=\"isMobile\" class=\"col-12 col-md-3 pr-2 py-2 pl-0\">\r\n            <vnext-link\r\n              (click)=\"gotoFirstGuidedHelpLink()\"\r\n              [title]=\"editLinkText\"\r\n              [keyNameForLiveEdit]=\"'Spa_GuidedHelp_PlanCard_EditLink_Text'\"\r\n            ></vnext-link>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".plan-card{border-width:1px;border-style:solid;border-top-right-radius:4px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;padding:8px 0 0}.plan-card.plan-card-border{border-color:var(--static-Spa_Style_Accent1);border-top-left-radius:4px}.plan-card .image-responsive{padding-right:0;max-width:100%;text-align:center}.score-display{color:red}.monthly-premium-container{display:flex;flex-direction:column;height:100%;align-items:center;justify-content:center}.plan-premium{line-height:17px;margin-bottom:5px}.plan-benefits-column-list{display:flex;flex-wrap:wrap;list-style:none;padding:0}.plan-benefits-column-list li{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list li:last-child,.plan-benefits-column-list.plan-benefits-row-list li{border-bottom:0;margin-bottom:16px}.coverage{border-radius:14px;text-align:center;padding:4px}.coverage .fas{height:17px;width:18px}.plan-benefits-items:focus,.plan_monthly_premium:focus,.monthly-premium-container:focus,.coverage:focus{box-shadow:none;outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:0 0 5px var(--static-Spa_Style_Black);border-radius:5px}.tooltip-icon{font-size:12px;padding-right:10px;background-color:transparent;font-family:\"Font Awesome 5 Pro\"}.plan-benefits{margin-bottom:16px}.current-plan-text,.next-year-plan-text{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.plan-name:focus{border-radius:5px}.card-sub-header-details{display:flex;flex-wrap:wrap;align-items:baseline}.non-monthly-payment-text{font-size:13px;font-family:montserratregular}@media (max-width: 479.98px){.plan-benefits-column-list.plan-benefits-row-list li{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list.plan-benefits-row-list li:last-child{border-bottom:0}}.plan-benefits-items{flex-basis:33.3333%;flex-grow:0}@media (max-width: 575.98px){.plan-benefits-list-value-container{float:right;display:flex;flex-direction:column;align-items:flex-end}.plan-benefits{margin-bottom:0}}.no-border{border:none!important}\n", ".cover-section{margin-right:1px;margin-left:1px}.preferences-section{padding:10px 0 0}.cost-horizontal-separator{border-top:1px solid var(--static-Spa_Style_Accent1);height:auto}.cost-vertical-separator{border-right:1px solid var(--static-Spa_Style_Accent1);height:100%;max-height:100%}.preference-icon>span{width:15px;display:inline-block;text-align:right;margin-right:5px}.underline{text-decoration:underline}.partial-indicator-text{color:var(--static-Spa_Style_Warn_on_Blue)}\n"] }]
    }], function () { return [{ type: i1.NavigationService }, { type: i1.GuidedHelpService }, { type: PlanFacade }, { type: DrugDetailsFacade }, { type: i0.ChangeDetectorRef }, { type: i1.LocaleService }, { type: i1.PharmacyService }, { type: i1.ProviderService }, { type: AnalyticsService }, { type: i2.Store }, { type: PlanCardFacade }]; }, null); })();

function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-loader-placeholder", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("loaderIconEnabled", ctx_r9.loaderIconEnabled)("spinnerSize", ctx_r9.spinnerSizeSmall)("loaderText", ctx_r9.providerLoadingText)("loaderTextCustomClasses", "Spa_Style_Note pl-4");
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_1_div_2_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "div", 15);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementStart(3, "div", 16);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 17)(6, "vnext-link", 18);
    i0.ɵɵlistener("click", function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_1_div_2_div_3_div_1_Template_vnext_link_click_6_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(7); return i0.ɵɵresetView(ctx_r19.planCardFacade.showProvidersInfo(ctx_r19.plan)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 5, ctx_r14.providersCoveredText, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r14.providerPcpText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("customClass", "Spa_Style_Link mt-sm-1")("title", ctx_r14.viewProvidersButtonText)("makeInlineBlock", true);
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_1_div_2_div_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(7);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r16.providersCoveredText, "html"), i0.ɵɵsanitizeHtml);
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_1_div_2_div_3_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "i", 20);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r17.providerOneOrMoreOutOfNetworkText);
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_1_div_2_div_3_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-value-based-care-agreement", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("customClass", "pt-1")("vbcAgreementLabel", ctx_r18.vbcAgreementLabel)("vbcAgreementTooltip", ctx_r18.vbcAgreementTooltip)("Spa_Site_Tooltip_Text", ctx_r18.Spa_Site_Tooltip_Text);
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_1_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_1_div_2_div_3_div_1_Template, 7, 8, "div", 3);
    i0.ɵɵtemplate(2, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_1_div_2_div_3_ng_template_2_Template, 2, 4, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_1_div_2_div_3_div_4_Template, 4, 1, "div", 14);
    i0.ɵɵtemplate(5, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_1_div_2_div_3_ng_container_5_Template, 2, 4, "ng-container", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r15 = i0.ɵɵreference(3);
    const ctx_r11 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.showProviderCoverageLink)("ngIfElse", _r15);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r11.showProviderInNetworkOnOtherLocation && ctx_r11.providerShowPartialIndicatorEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.hasVbcAgreement);
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_1_div_2_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "button", 23);
    i0.ɵɵlistener("click", function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_1_div_2_ng_template_4_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r21.onAddNewPreferences(ctx_r21.pageTags.GUIDED_HELP_PROVIDER_SEARCH)); });
    i0.ɵɵelement(2, "i", 24);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("title", ctx_r13.addLinkText + " " + ctx_r13.guidedHelpGetStartedText);
    i0.ɵɵattribute("aria-label", ctx_r13.addLinkText + " " + ctx_r13.guidedHelpGetStartedText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r13.addLinkText, " ");
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_1_div_2_div_3_Template, 6, 4, "div", 10);
    i0.ɵɵtemplate(4, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_1_div_2_ng_template_4_Template, 4, 3, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r12 = i0.ɵɵreference(5);
    const preferences_r2 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(preferences_r2.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.showPreferencesSection(preferences_r2.title))("ngIfElse", _r12);
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 6);
    i0.ɵɵtemplate(1, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_1_div_1_Template, 2, 4, "div", 7);
    i0.ɵɵtemplate(2, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_1_div_2_Template, 6, 3, "div", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.showProviderLoading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.showProviderLoading);
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_2_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 16);
    i0.ɵɵelement(2, "vnext-plan-preference-text", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "vnext-link", 18);
    i0.ɵɵlistener("click", function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_2_div_3_Template_vnext_link_click_3_listener() { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r27.showProvidersInfoModal()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const preferences_r2 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("newPlanCardDesignEnabled", ctx_r24.newPlanCardDesignEnabled)("preferenceTitle", preferences_r2.title)("drugCoverageText", ctx_r24.drugCoverageText)("pharmacy", ctx_r24.pharmacy)("pharmacyCoveredText", ctx_r24.pharmacyCoveredText)("pharmacyNotCoveredText", ctx_r24.pharmacyNotCoveredText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("customClass", "Spa_Style_Link mt-sm-1")("title", ctx_r24.viewPrescriptionsButtonText)("makeInlineBlock", true);
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_2_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "button", 23);
    i0.ɵɵlistener("click", function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_2_ng_template_4_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r30.onAddNewPreferences(ctx_r30.pageTags.GUIDED_HELP_PRESCRIPTIONS)); });
    i0.ɵɵelement(2, "i", 24);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("title", ctx_r26.addLinkText + " " + ctx_r26.guidedHelpGetStartedText);
    i0.ɵɵattribute("aria-label", ctx_r26.addLinkText + " " + ctx_r26.guidedHelpGetStartedText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r26.addLinkText, " ");
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 6)(1, "div", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_2_div_3_Template, 4, 9, "div", 10);
    i0.ɵɵtemplate(4, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_2_ng_template_4_Template, 4, 3, "ng-template", null, 25, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r25 = i0.ɵɵreference(5);
    const preferences_r2 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(preferences_r2.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.showPreferencesSection(preferences_r2.title))("ngIfElse", _r25);
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r44.pharmacy == null ? null : ctx_r44.pharmacy.name, " ");
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_ng_container_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r45.mailOrderText, " ");
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-tooltip", 30);
    i0.ɵɵtemplate(2, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_ng_container_1_div_2_Template, 2, 1, "div", 31);
    i0.ɵɵtemplate(3, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_ng_container_1_div_3_Template, 2, 1, "div", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("header", ctx_r39.viewCostTooltipHeaderText)("body", ctx_r39.viewCostTooltipHeaderContent)("customClass", "text-left")("Spa_Site_Tooltip_Text", ctx_r39.Spa_Site_Tooltip_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r39.showMailOrderLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r39.showMailOrderLabel);
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_ng_container_2_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 37);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(9);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r49.inNetworkPreferredText);
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_ng_container_2_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r51 = i0.ɵɵnextContext(9);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r51.inNetworkStandardText);
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_ng_container_2_ng_container_1_ng_container_1_Template, 3, 1, "ng-container", 3);
    i0.ɵɵtemplate(2, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_ng_container_2_ng_container_1_ng_template_2_Template, 2, 1, "ng-template", null, 36, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r50 = i0.ɵɵreference(3);
    const ctx_r46 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r46.pharmacy == null ? null : ctx_r46.pharmacy.isPreferred)("ngIfElse", _r50);
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_ng_container_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r48.outOfNetworkText);
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_ng_container_2_ng_container_1_Template, 4, 2, "ng-container", 3);
    i0.ɵɵtemplate(2, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_ng_container_2_ng_template_2_Template, 2, 1, "ng-template", null, 35, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r47 = i0.ɵɵreference(3);
    const ctx_r40 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r40.pharmacy == null ? null : ctx_r40.pharmacy.isInNetwork)("ngIfElse", _r47);
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r42.pharmacyNotCoveredText, " ");
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 37);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r43.pharmacyNotCoveredText, " ");
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_ng_container_1_Template, 4, 6, "ng-container", 3);
    i0.ɵɵtemplate(2, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_ng_container_2_Template, 4, 2, "ng-container", 7);
    i0.ɵɵtemplate(3, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_ng_template_3_Template, 2, 1, "ng-template", null, 29, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(5, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_ng_container_5_Template, 3, 1, "ng-container", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r41 = i0.ɵɵreference(4);
    const ctx_r36 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r36.pharmacy)("ngIfElse", _r41);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r36.showMailOrderLabel && ctx_r36.pharmacy);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r36.showMailOrderLabel && !ctx_r36.plan.hasMailDrugBenefits);
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r53 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "button", 23);
    i0.ɵɵlistener("click", function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_ng_template_4_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r53); const ctx_r52 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r52.onAddNewPreferences(ctx_r52.pageTags.GUIDED_HELP_PHARMACY_SEARCH)); });
    i0.ɵɵelement(2, "i", 24);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("title", ctx_r38.addLinkText + " " + ctx_r38.guidedHelpGetStartedText);
    i0.ɵɵattribute("aria-label", ctx_r38.addLinkText + " " + ctx_r38.guidedHelpGetStartedText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r38.addLinkText, " ");
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_div_3_Template, 6, 4, "div", 10);
    i0.ɵɵtemplate(4, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_ng_template_4_Template, 4, 3, "ng-template", null, 28, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r37 = i0.ɵɵreference(5);
    const preferences_r2 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r33 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(preferences_r2.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r33.showPreferencesSection(preferences_r2.title))("ngIfElse", _r37);
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-loader-placeholder", 8);
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("loaderIconEnabled", ctx_r35.loaderIconEnabled)("spinnerSize", ctx_r35.spinnerSizeSmall)("loaderText", ctx_r35.pharmacyLoadingText)("loaderTextCustomClasses", "Spa_Style_Note pl-4");
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 6);
    i0.ɵɵtemplate(1, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_container_1_Template, 6, 3, "ng-container", 3);
    i0.ɵɵtemplate(2, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_ng_template_2_Template, 1, 4, "ng-template", null, 27, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r34 = i0.ɵɵreference(3);
    const ctx_r8 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r8.plansLoading)("ngIfElse", _r34);
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_1_Template, 3, 2, "li", 5);
    i0.ɵɵtemplate(2, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_2_Template, 6, 3, "li", 5);
    i0.ɵɵtemplate(3, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_li_3_Template, 4, 2, "li", 5);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const preferences_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", preferences_r2.title === ctx_r3.planPreferenceLabels.PROVIDERS && ctx_r3.guidedHelpEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", preferences_r2.title === ctx_r3.planPreferenceLabels.PRESCRIPTIONS && ctx_r3.guidedHelpEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", preferences_r2.title === ctx_r3.planPreferenceLabels.PHARMACY && ctx_r3.guidedHelpEnabled);
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 6)(1, "div", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 12)(4, "div", 16);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "currency");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const preferences_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(preferences_r2.label);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind4(6, 2, ctx_r5.getPreferencesCost(preferences_r2.title), "USD", "symbol", "1.0-0"), " ");
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_container_1_Template, 4, 3, "ng-container", 3);
    i0.ɵɵtemplate(2, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_ng_template_2_Template, 7, 7, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const preferences_r2 = ctx.$implicit;
    const _r4 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", preferences_r2.title === ctx_r1.planPreferenceLabels.PHARMACY || preferences_r2.title === ctx_r1.planPreferenceLabels.PRESCRIPTIONS || preferences_r2.title === ctx_r1.planPreferenceLabels.PROVIDERS)("ngIfElse", _r4);
} }
function NextgenPlanCoveragePreferencesComponent_ul_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 1);
    i0.ɵɵtemplate(1, NextgenPlanCoveragePreferencesComponent_ul_0_ng_container_1_Template, 4, 2, "ng-container", 2);
    i0.ɵɵpipe(2, "orderBy");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(2, 1, ctx_r0.filteredPlanPreferences, "order"));
} }
class NextgenPlanCoveragePreferencesComponent extends PlanCoveragePreferencesBaseComponent {
    constructor(navigationService, guidedHelpService, planFacade, drugDetailsFacade, cdr, localeService, pharmacyService, providerService, analyticsService, store, planCardFacade, guidedHelpModalContextService) {
        super(navigationService, guidedHelpService, planFacade, drugDetailsFacade, cdr, localeService, pharmacyService, providerService, analyticsService, store, planCardFacade);
        this.navigationService = navigationService;
        this.guidedHelpService = guidedHelpService;
        this.planFacade = planFacade;
        this.drugDetailsFacade = drugDetailsFacade;
        this.cdr = cdr;
        this.localeService = localeService;
        this.pharmacyService = pharmacyService;
        this.providerService = providerService;
        this.analyticsService = analyticsService;
        this.store = store;
        this.planCardFacade = planCardFacade;
        this.guidedHelpModalContextService = guidedHelpModalContextService;
    }
    showProvidersInfoModal() {
        this.planCardFacade.showPrescriptionInfo(this.plan, this.medicineCabinet, this.coveredDrugDosageIds, this.showOffFormularyDrugAlternativesTooltip, this.isMobile);
    }
    onAddNewPreferences(pageTag) {
        super.onClick(pageTag);
        if (this.preferencesBannerEnabled) {
            this.guidedHelpModalContextService.openGuidedHelpModal(pageTag);
        }
        else {
            this.navigationService.navigateByPageTag(pageTag);
        }
    }
}
NextgenPlanCoveragePreferencesComponent.ɵfac = function NextgenPlanCoveragePreferencesComponent_Factory(t) { return new (t || NextgenPlanCoveragePreferencesComponent)(i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(DrugDetailsFacade), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.PharmacyService), i0.ɵɵdirectiveInject(i1.ProviderService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(PlanCardFacade), i0.ɵɵdirectiveInject(i1.GuidedHelpModalContextService)); };
NextgenPlanCoveragePreferencesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NextgenPlanCoveragePreferencesComponent, selectors: [["vnext-nextgen-plan-coverage-preferences"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "list-inline d-flex flex-column plan-benefits-column-list mb-1 flex-sm-row plan-benefits-row-list", 4, "ngIf"], [1, "list-inline", "d-flex", "flex-column", "plan-benefits-column-list", "mb-1", "flex-sm-row", "plan-benefits-row-list"], [4, "ngFor", "ngForOf"], [4, "ngIf", "ngIfElse"], ["showCost", ""], ["class", "text-left h5 plan-benefits-items focus-text", 4, "ngIf"], [1, "text-left", "h5", "plan-benefits-items", "focus-text"], [4, "ngIf"], [3, "loaderIconEnabled", "spinnerSize", "loaderText", "loaderTextCustomClasses"], [1, "Spa_Style_Regular_Font", "float-left", "float-sm-none", "mr-3", "mb-1", "mr-sm-0", "mb-sm-0"], ["class", "plan-benefits-list-value-container", 4, "ngIf", "ngIfElse"], ["addProvider", ""], [1, "plan-benefits-list-value-container"], ["showProvidersCoveredText", ""], ["class", "Spa_Style_Small_Font partial-indicator-text mt-sm-2", 4, "ngIf"], ["navigationAdapter", "", 1, "Spa_Style_Large_Font", "Spa_Style_Semi_Bold_Weight", "float-right", "float-sm-none", "mt-sm-1", 3, "innerHTML"], [1, "Spa_Style_Large_Font", "Spa_Style_Semi_Bold_Weight", "float-right", "float-sm-none", "mt-sm-1"], [1, "view-providers-link"], [3, "customClass", "title", "makeInlineBlock", "click"], [1, "Spa_Style_Small_Font", "partial-indicator-text", "mt-sm-2"], [1, "fas", "fa-exclamation-triangle", "mr-1"], [3, "customClass", "vbcAgreementLabel", "vbcAgreementTooltip", "Spa_Site_Tooltip_Text"], [1, "plan-benefits-list-value-container", "mt-sm-1"], ["tabindex", "0", 1, "link", "Spa_Style_Link", "action-button", 3, "title", "click"], [1, "fas", "fa-plus-circle", "mr-1"], ["addPrescription", ""], [3, "newPlanCardDesignEnabled", "preferenceTitle", "drugCoverageText", "pharmacy", "pharmacyCoveredText", "pharmacyNotCoveredText"], ["plansLoadingPlaceholder", ""], ["addPharmacy", ""], ["showNotCovered", ""], [3, "header", "body", "customClass", "Spa_Site_Tooltip_Text"], ["class", "Spa_Style_Large_Font Spa_Style_Semi_Bold_Weight float-right float-sm-none no-translate-block", 4, "ngIf"], ["class", "Spa_Style_Large_Font Spa_Style_Semi_Bold_Weight float-right float-sm-none", 4, "ngIf"], [1, "Spa_Style_Large_Font", "Spa_Style_Semi_Bold_Weight", "float-right", "float-sm-none", "no-translate-block"], [1, "Spa_Style_Large_Font", "Spa_Style_Semi_Bold_Weight", "float-right", "float-sm-none"], ["outOfNetworkPharmacy", ""], ["standardPharmacy", ""], [1, "Spa_Style_Note", "mt-sm-1", "pl-1"]], template: function NextgenPlanCoveragePreferencesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, NextgenPlanCoveragePreferencesComponent_ul_0_Template, 3, 4, "ul", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.newPlanCardDesignEnabled && (ctx.showPreferences || ctx.isTotalEstimatedCostEnabled && (ctx.isRetention || ctx.isQuoting)));
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, LinkComponent, TooltipComponent, LoaderPlaceholderComponent, ValueBasedCareAgreementComponent, NavigationAdapterDirective, IconAriaAttributesDirective, PlanPreferenceTextComponent, i1$2.CurrencyPipe, SafePipe, OrderPipe], styles: [".plan-benefits-column-list.plan-benefits-row-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-bottom:none!important}@media (max-width: 575.98px){.view-providers-link[_ngcontent-%COMP%]{text-align:right}}", ".plan-card[_ngcontent-%COMP%]{border-width:1px;border-style:solid;border-top-right-radius:4px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;padding:8px 0 0}.plan-card.plan-card-border[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent1);border-top-left-radius:4px}.plan-card[_ngcontent-%COMP%]   .image-responsive[_ngcontent-%COMP%]{padding-right:0;max-width:100%;text-align:center}.score-display[_ngcontent-%COMP%]{color:red}.monthly-premium-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;height:100%;align-items:center;justify-content:center}.plan-premium[_ngcontent-%COMP%]{line-height:17px;margin-bottom:5px}.plan-benefits-column-list[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;list-style:none;padding:0}.plan-benefits-column-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child, .plan-benefits-column-list.plan-benefits-row-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-bottom:0;margin-bottom:16px}.coverage[_ngcontent-%COMP%]{border-radius:14px;text-align:center;padding:4px}.coverage[_ngcontent-%COMP%]   .fas[_ngcontent-%COMP%]{height:17px;width:18px}.plan-benefits-items[_ngcontent-%COMP%]:focus, .plan_monthly_premium[_ngcontent-%COMP%]:focus, .monthly-premium-container[_ngcontent-%COMP%]:focus, .coverage[_ngcontent-%COMP%]:focus{box-shadow:none;outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:0 0 5px var(--static-Spa_Style_Black);border-radius:5px}.tooltip-icon[_ngcontent-%COMP%]{font-size:12px;padding-right:10px;background-color:transparent;font-family:\"Font Awesome 5 Pro\"}.plan-benefits[_ngcontent-%COMP%]{margin-bottom:16px}.current-plan-text[_ngcontent-%COMP%], .next-year-plan-text[_ngcontent-%COMP%]{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.plan-name[_ngcontent-%COMP%]:focus{border-radius:5px}.card-sub-header-details[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;align-items:baseline}.non-monthly-payment-text[_ngcontent-%COMP%]{font-size:13px;font-family:montserratregular}@media (max-width: 479.98px){.plan-benefits-column-list.plan-benefits-row-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list.plan-benefits-row-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child{border-bottom:0}}.plan-benefits-items[_ngcontent-%COMP%]{flex-basis:33.3333%;flex-grow:0}@media (max-width: 575.98px){.plan-benefits-list-value-container[_ngcontent-%COMP%]{float:right;display:flex;flex-direction:column;align-items:flex-end}.plan-benefits[_ngcontent-%COMP%]{margin-bottom:0}}.no-border[_ngcontent-%COMP%]{border:none!important}", ".cover-section[_ngcontent-%COMP%]{margin-right:1px;margin-left:1px}.preferences-section[_ngcontent-%COMP%]{padding:10px 0 0}.cost-horizontal-separator[_ngcontent-%COMP%]{border-top:1px solid var(--static-Spa_Style_Accent1);height:auto}.cost-vertical-separator[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);height:100%;max-height:100%}.preference-icon[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{width:15px;display:inline-block;text-align:right;margin-right:5px}.underline[_ngcontent-%COMP%]{text-decoration:underline}.partial-indicator-text[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Warn_on_Blue)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NextgenPlanCoveragePreferencesComponent, [{
        type: Component,
        args: [{ selector: 'vnext-nextgen-plan-coverage-preferences', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ul\r\n  *ngIf=\"newPlanCardDesignEnabled && (showPreferences || (isTotalEstimatedCostEnabled && (isRetention || isQuoting)))\"\r\n  class=\"list-inline d-flex flex-column plan-benefits-column-list mb-1 flex-sm-row plan-benefits-row-list\"\r\n>\r\n  <ng-container *ngFor=\"let preferences of filteredPlanPreferences | orderBy : 'order'\">\r\n    <ng-container\r\n      *ngIf=\"\r\n        preferences.title === planPreferenceLabels.PHARMACY ||\r\n          preferences.title === planPreferenceLabels.PRESCRIPTIONS ||\r\n          preferences.title === planPreferenceLabels.PROVIDERS;\r\n        else showCost\r\n      \"\r\n    >\r\n      <li\r\n        *ngIf=\"preferences.title === planPreferenceLabels.PROVIDERS && guidedHelpEnabled\"\r\n        class=\"text-left h5 plan-benefits-items focus-text\"\r\n      >\r\n        <div *ngIf=\"showProviderLoading\">\r\n          <vnext-loader-placeholder\r\n            [loaderIconEnabled]=\"loaderIconEnabled\"\r\n            [spinnerSize]=\"spinnerSizeSmall\"\r\n            [loaderText]=\"providerLoadingText\"\r\n            [loaderTextCustomClasses]=\"'Spa_Style_Note pl-4'\"\r\n          >\r\n          </vnext-loader-placeholder>\r\n        </div>\r\n        <div *ngIf=\"!showProviderLoading\">\r\n          <div class=\"Spa_Style_Regular_Font float-left float-sm-none mr-3 mb-1 mr-sm-0 mb-sm-0\">{{ preferences.label }}</div>\r\n          <div class=\"plan-benefits-list-value-container\" *ngIf=\"showPreferencesSection(preferences.title); else addProvider\">\r\n            <div *ngIf=\"showProviderCoverageLink; else showProvidersCoveredText\">\r\n              <div\r\n                class=\"Spa_Style_Large_Font Spa_Style_Semi_Bold_Weight float-right float-sm-none mt-sm-1\"\r\n                [innerHTML]=\"providersCoveredText | safe : 'html'\"\r\n                navigationAdapter\r\n              ></div>\r\n              <div class=\"Spa_Style_Large_Font Spa_Style_Semi_Bold_Weight float-right float-sm-none mt-sm-1\">{{ providerPcpText }}</div>\r\n              <div class=\"view-providers-link\">\r\n                <vnext-link\r\n                  [customClass]=\"'Spa_Style_Link mt-sm-1'\"\r\n                  (click)=\"planCardFacade.showProvidersInfo(plan)\"\r\n                  [title]=\"viewProvidersButtonText\"\r\n                  [makeInlineBlock]=\"true\"\r\n                ></vnext-link>\r\n              </div>\r\n            </div>\r\n            <ng-template #showProvidersCoveredText>\r\n              <div\r\n                class=\"Spa_Style_Large_Font Spa_Style_Semi_Bold_Weight float-right float-sm-none mt-sm-1\"\r\n                [innerHTML]=\"providersCoveredText | safe : 'html'\"\r\n                navigationAdapter\r\n              ></div>\r\n            </ng-template>\r\n            <div\r\n              class=\"Spa_Style_Small_Font partial-indicator-text mt-sm-2\"\r\n              *ngIf=\"showProviderInNetworkOnOtherLocation && providerShowPartialIndicatorEnabled\"\r\n            >\r\n              <i class=\"fas fa-exclamation-triangle mr-1\"></i><span>{{ providerOneOrMoreOutOfNetworkText }}</span>\r\n            </div>\r\n            <ng-container *ngIf=\"hasVbcAgreement\">\r\n              <vnext-value-based-care-agreement\r\n                [customClass]=\"'pt-1'\"\r\n                [vbcAgreementLabel]=\"vbcAgreementLabel\"\r\n                [vbcAgreementTooltip]=\"vbcAgreementTooltip\"\r\n                [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n              ></vnext-value-based-care-agreement>\r\n            </ng-container>\r\n          </div>\r\n          <ng-template #addProvider>\r\n            <div class=\"plan-benefits-list-value-container mt-sm-1\">\r\n              <button\r\n                class=\"link Spa_Style_Link action-button\"\r\n                tabindex=\"0\"\r\n                title=\"{{ addLinkText + ' ' + guidedHelpGetStartedText }}\"\r\n                (click)=\"onAddNewPreferences(pageTags.GUIDED_HELP_PROVIDER_SEARCH)\"\r\n                [attr.aria-label]=\"addLinkText + ' ' + guidedHelpGetStartedText\"\r\n              >\r\n                <i class=\"fas fa-plus-circle mr-1\"></i>{{ addLinkText }}\r\n              </button>\r\n            </div>\r\n          </ng-template>\r\n        </div>\r\n      </li>\r\n      <li\r\n        *ngIf=\"preferences.title === planPreferenceLabels.PRESCRIPTIONS && guidedHelpEnabled\"\r\n        class=\"text-left h5 plan-benefits-items focus-text\"\r\n      >\r\n        <div class=\"Spa_Style_Regular_Font float-left float-sm-none mr-3 mb-1 mr-sm-0 mb-sm-0\">{{ preferences.label }}</div>\r\n        <div class=\"plan-benefits-list-value-container\" *ngIf=\"showPreferencesSection(preferences.title); else addPrescription\">\r\n          <div class=\"Spa_Style_Large_Font Spa_Style_Semi_Bold_Weight float-right float-sm-none mt-sm-1\">\r\n            <vnext-plan-preference-text\r\n              [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n              [preferenceTitle]=\"preferences.title\"\r\n              [drugCoverageText]=\"drugCoverageText\"\r\n              [pharmacy]=\"pharmacy\"\r\n              [pharmacyCoveredText]=\"pharmacyCoveredText\"\r\n              [pharmacyNotCoveredText]=\"pharmacyNotCoveredText\"\r\n            >\r\n            </vnext-plan-preference-text>\r\n          </div>\r\n          <vnext-link\r\n            [customClass]=\"'Spa_Style_Link mt-sm-1'\"\r\n            (click)=\"showProvidersInfoModal()\"\r\n            [title]=\"viewPrescriptionsButtonText\"\r\n            [makeInlineBlock]=\"true\"\r\n          ></vnext-link>\r\n        </div>\r\n        <ng-template #addPrescription>\r\n          <div class=\"plan-benefits-list-value-container mt-sm-1\">\r\n            <button\r\n              class=\"link Spa_Style_Link action-button\"\r\n              tabindex=\"0\"\r\n              title=\"{{ addLinkText + ' ' + guidedHelpGetStartedText }}\"\r\n              (click)=\"onAddNewPreferences(pageTags.GUIDED_HELP_PRESCRIPTIONS)\"\r\n              [attr.aria-label]=\"addLinkText + ' ' + guidedHelpGetStartedText\"\r\n            >\r\n              <i class=\"fas fa-plus-circle mr-1\"></i>{{ addLinkText }}\r\n            </button>\r\n          </div>\r\n        </ng-template>\r\n      </li>\r\n      <li\r\n        *ngIf=\"preferences.title === planPreferenceLabels.PHARMACY && guidedHelpEnabled\"\r\n        class=\"text-left h5 plan-benefits-items focus-text\"\r\n      >\r\n        <ng-container *ngIf=\"!plansLoading; else plansLoadingPlaceholder\">\r\n          <div class=\"Spa_Style_Regular_Font float-left float-sm-none mr-3 mb-1 mr-sm-0 mb-sm-0\">{{ preferences.label }}</div>\r\n          <div class=\"plan-benefits-list-value-container\" *ngIf=\"showPreferencesSection(preferences.title); else addPharmacy\">\r\n            <ng-container *ngIf=\"pharmacy; else showNotCovered\">\r\n              <vnext-tooltip\r\n                [header]=\"viewCostTooltipHeaderText\"\r\n                [body]=\"viewCostTooltipHeaderContent\"\r\n                [customClass]=\"'text-left'\"\r\n                [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n              >\r\n                <div\r\n                  class=\"Spa_Style_Large_Font Spa_Style_Semi_Bold_Weight float-right float-sm-none no-translate-block\"\r\n                  *ngIf=\"!showMailOrderLabel\"\r\n                >\r\n                  {{ pharmacy?.name }}\r\n                </div>\r\n                <div class=\"Spa_Style_Large_Font Spa_Style_Semi_Bold_Weight float-right float-sm-none\" *ngIf=\"showMailOrderLabel\">\r\n                  {{ mailOrderText }}\r\n                </div>\r\n              </vnext-tooltip>\r\n            </ng-container>\r\n            <ng-container *ngIf=\"!showMailOrderLabel && pharmacy\">\r\n              <ng-container *ngIf=\"pharmacy?.isInNetwork; else outOfNetworkPharmacy\">\r\n                <ng-container *ngIf=\"pharmacy?.isPreferred; else standardPharmacy\">\r\n                  <div class=\"Spa_Style_Note mt-sm-1 pl-1\">{{ inNetworkPreferredText }}</div>\r\n                </ng-container>\r\n                <ng-template #standardPharmacy>\r\n                  <div class=\"Spa_Style_Note mt-sm-1 pl-1\">{{ inNetworkStandardText }}</div>\r\n                </ng-template>\r\n              </ng-container>\r\n              <ng-template #outOfNetworkPharmacy>\r\n                <div class=\"Spa_Style_Note mt-sm-1 pl-1\">{{ outOfNetworkText }}</div>\r\n              </ng-template>\r\n            </ng-container>\r\n            <ng-template #showNotCovered>\r\n              <div class=\"Spa_Style_Note mt-sm-1 pl-1\">\r\n                {{ pharmacyNotCoveredText }}\r\n              </div>\r\n            </ng-template>\r\n            <ng-container *ngIf=\"showMailOrderLabel && !plan.hasMailDrugBenefits\">\r\n              <div class=\"Spa_Style_Note mt-sm-1 pl-1\">\r\n                {{ pharmacyNotCoveredText }}\r\n              </div>\r\n            </ng-container>\r\n          </div>\r\n          <ng-template #addPharmacy>\r\n            <div class=\"plan-benefits-list-value-container mt-sm-1\">\r\n              <button\r\n                class=\"link Spa_Style_Link action-button\"\r\n                tabindex=\"0\"\r\n                title=\"{{ addLinkText + ' ' + guidedHelpGetStartedText }}\"\r\n                (click)=\"onAddNewPreferences(pageTags.GUIDED_HELP_PHARMACY_SEARCH)\"\r\n                [attr.aria-label]=\"addLinkText + ' ' + guidedHelpGetStartedText\"\r\n              >\r\n                <i class=\"fas fa-plus-circle mr-1\"></i>{{ addLinkText }}\r\n              </button>\r\n            </div>\r\n          </ng-template>\r\n        </ng-container>\r\n        <ng-template #plansLoadingPlaceholder>\r\n          <vnext-loader-placeholder\r\n            [loaderIconEnabled]=\"loaderIconEnabled\"\r\n            [spinnerSize]=\"spinnerSizeSmall\"\r\n            [loaderText]=\"pharmacyLoadingText\"\r\n            [loaderTextCustomClasses]=\"'Spa_Style_Note pl-4'\"\r\n          >\r\n          </vnext-loader-placeholder>\r\n        </ng-template>\r\n      </li>\r\n    </ng-container>\r\n    <ng-template #showCost>\r\n      <li class=\"text-left h5 plan-benefits-items focus-text\">\r\n        <div class=\"Spa_Style_Regular_Font float-left float-sm-none mr-3 mb-1 mr-sm-0 mb-sm-0\">{{ preferences.label }}</div>\r\n        <div class=\"plan-benefits-list-value-container\">\r\n          <div class=\"Spa_Style_Large_Font Spa_Style_Semi_Bold_Weight float-right float-sm-none mt-sm-1\">\r\n            {{ getPreferencesCost(preferences.title) | currency : 'USD' : 'symbol' : '1.0-0' }}\r\n          </div>\r\n        </div>\r\n      </li>\r\n    </ng-template>\r\n  </ng-container>\r\n</ul>\r\n", styles: [".plan-benefits-column-list.plan-benefits-row-list li{border-bottom:none!important}@media (max-width: 575.98px){.view-providers-link{text-align:right}}\n", ".plan-card{border-width:1px;border-style:solid;border-top-right-radius:4px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;padding:8px 0 0}.plan-card.plan-card-border{border-color:var(--static-Spa_Style_Accent1);border-top-left-radius:4px}.plan-card .image-responsive{padding-right:0;max-width:100%;text-align:center}.score-display{color:red}.monthly-premium-container{display:flex;flex-direction:column;height:100%;align-items:center;justify-content:center}.plan-premium{line-height:17px;margin-bottom:5px}.plan-benefits-column-list{display:flex;flex-wrap:wrap;list-style:none;padding:0}.plan-benefits-column-list li{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list li:last-child,.plan-benefits-column-list.plan-benefits-row-list li{border-bottom:0;margin-bottom:16px}.coverage{border-radius:14px;text-align:center;padding:4px}.coverage .fas{height:17px;width:18px}.plan-benefits-items:focus,.plan_monthly_premium:focus,.monthly-premium-container:focus,.coverage:focus{box-shadow:none;outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:0 0 5px var(--static-Spa_Style_Black);border-radius:5px}.tooltip-icon{font-size:12px;padding-right:10px;background-color:transparent;font-family:\"Font Awesome 5 Pro\"}.plan-benefits{margin-bottom:16px}.current-plan-text,.next-year-plan-text{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.plan-name:focus{border-radius:5px}.card-sub-header-details{display:flex;flex-wrap:wrap;align-items:baseline}.non-monthly-payment-text{font-size:13px;font-family:montserratregular}@media (max-width: 479.98px){.plan-benefits-column-list.plan-benefits-row-list li{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list.plan-benefits-row-list li:last-child{border-bottom:0}}.plan-benefits-items{flex-basis:33.3333%;flex-grow:0}@media (max-width: 575.98px){.plan-benefits-list-value-container{float:right;display:flex;flex-direction:column;align-items:flex-end}.plan-benefits{margin-bottom:0}}.no-border{border:none!important}\n", ".cover-section{margin-right:1px;margin-left:1px}.preferences-section{padding:10px 0 0}.cost-horizontal-separator{border-top:1px solid var(--static-Spa_Style_Accent1);height:auto}.cost-vertical-separator{border-right:1px solid var(--static-Spa_Style_Accent1);height:100%;max-height:100%}.preference-icon>span{width:15px;display:inline-block;text-align:right;margin-right:5px}.underline{text-decoration:underline}.partial-indicator-text{color:var(--static-Spa_Style_Warn_on_Blue)}\n"] }]
    }], function () { return [{ type: i1.NavigationService }, { type: i1.GuidedHelpService }, { type: PlanFacade }, { type: DrugDetailsFacade }, { type: i0.ChangeDetectorRef }, { type: i1.LocaleService }, { type: i1.PharmacyService }, { type: i1.ProviderService }, { type: AnalyticsService }, { type: i2.Store }, { type: PlanCardFacade }, { type: i1.GuidedHelpModalContextService }]; }, null); })();

function PlanCoveragePreferencesComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-nextgen-plan-coverage-preferences", 2);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("newPlanCardDesignEnabled", ctx_r0.newPlanCardDesignEnabled)("pharmacyNotCoveredText", ctx_r0.pharmacyNotCoveredText)("plan", ctx_r0.plan)("pharmacyText", ctx_r0.pharmacyText)("pharmacyCoveredText", ctx_r0.pharmacyCoveredText)("addedPharmacy", ctx_r0.addedPharmacy)("showDrugCoverage", ctx_r0.showDrugCoverage)("drugCoverageText", ctx_r0.drugCoverageText)("prescriptionsText", ctx_r0.prescriptionsText)("planPreferences", ctx_r0.planPreferences)("totalEstimatedAnnualCostText", ctx_r0.totalEstimatedAnnualCostText)("totalEstimatedCostText", ctx_r0.totalEstimatedCostText)("totalEstimatedCostTooltip", ctx_r0.totalEstimatedCostTooltip)("isTileDisplay", ctx_r0.isTileDisplay)("isRetention", ctx_r0.isRetention)("isTotalEstimatedCostEnabled", ctx_r0.isTotalEstimatedCostEnabled)("compareTwoPlans", ctx_r0.compareTwoPlans)("isQuoting", ctx_r0.isQuoting)("noCostAvailableText", ctx_r0.noCostAvailableText)("Spa_Site_Tooltip_Text", ctx_r0.Spa_Site_Tooltip_Text)("medicineCabinet", ctx_r0.medicineCabinet)("viewCostTooltipHeaderText", ctx_r0.viewCostTooltipHeaderText)("viewCostTooltipHeaderContent", ctx_r0.viewCostTooltipHeaderContent)("inNetworkPreferredText", ctx_r0.inNetworkPreferredText)("inNetworkStandardText", ctx_r0.inNetworkStandardText)("outOfNetworkText", ctx_r0.outOfNetworkText)("annualCost", ctx_r0.annualCost)("showMailOrderLabel", ctx_r0.showMailOrderLabel)("mailOrderText", ctx_r0.mailOrderText)("providersCoveredText", ctx_r0.providersCoveredText)("providerPcpText", ctx_r0.providerPcpText)("totalCostEffectiveDate", ctx_r0.totalCostEffectiveDate)("isEnabledShowDrugAlternatives", ctx_r0.isEnabledShowDrugAlternatives)("showNudgeDrugAlternatives", ctx_r0.showNudgeDrugAlternatives)("drugAlternativesTooltipText", ctx_r0.drugAlternativesTooltipText)("drugAlternativesIndicatorIcon", ctx_r0.drugAlternativesIndicatorIcon)("nudgeDrugAlternativesLabelText", ctx_r0.nudgeDrugAlternativesLabelText)("isMailOrderSelected", ctx_r0.isMailOrderSelected)("selectedProviders", ctx_r0.selectedProviders)("planCardPreferenceDetailedEnabled", ctx_r0.planCardPreferenceDetailedEnabled)("providerDetails", ctx_r0.providerDetails)("loaderIconEnabled", ctx_r0.loaderIconEnabled)("editLinkText", ctx_r0.editLinkText)("providerOneOrMoreOutOfNetworkText", ctx_r0.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r0.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r0.providerShowPartialIndicatorEnabled)("showProviderInNetworkOnOtherLocation", ctx_r0.showProviderInNetworkOnOtherLocation)("viewProvidersButtonText", ctx_r0.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r0.viewPrescriptionsButtonText)("isVbcAgreementEnabled", ctx_r0.isVbcAgreementEnabled)("vbcAgreementLabel", ctx_r0.vbcAgreementLabel)("vbcAgreementTooltip", ctx_r0.vbcAgreementTooltip);
} }
function PlanCoveragePreferencesComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-legacy-plan-coverage-preferences", 2);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("newPlanCardDesignEnabled", ctx_r2.newPlanCardDesignEnabled)("pharmacyNotCoveredText", ctx_r2.pharmacyNotCoveredText)("plan", ctx_r2.plan)("pharmacyText", ctx_r2.pharmacyText)("pharmacyCoveredText", ctx_r2.pharmacyCoveredText)("addedPharmacy", ctx_r2.addedPharmacy)("showDrugCoverage", ctx_r2.showDrugCoverage)("drugCoverageText", ctx_r2.drugCoverageText)("prescriptionsText", ctx_r2.prescriptionsText)("planPreferences", ctx_r2.planPreferences)("totalEstimatedAnnualCostText", ctx_r2.totalEstimatedAnnualCostText)("totalEstimatedCostText", ctx_r2.totalEstimatedCostText)("totalEstimatedCostTooltip", ctx_r2.totalEstimatedCostTooltip)("isTileDisplay", ctx_r2.isTileDisplay)("isRetention", ctx_r2.isRetention)("isTotalEstimatedCostEnabled", ctx_r2.isTotalEstimatedCostEnabled)("compareTwoPlans", ctx_r2.compareTwoPlans)("isQuoting", ctx_r2.isQuoting)("noCostAvailableText", ctx_r2.noCostAvailableText)("Spa_Site_Tooltip_Text", ctx_r2.Spa_Site_Tooltip_Text)("medicineCabinet", ctx_r2.medicineCabinet)("viewCostTooltipHeaderText", ctx_r2.viewCostTooltipHeaderText)("viewCostTooltipHeaderContent", ctx_r2.viewCostTooltipHeaderContent)("inNetworkPreferredText", ctx_r2.inNetworkPreferredText)("inNetworkStandardText", ctx_r2.inNetworkStandardText)("outOfNetworkText", ctx_r2.outOfNetworkText)("annualCost", ctx_r2.annualCost)("showMailOrderLabel", ctx_r2.showMailOrderLabel)("mailOrderText", ctx_r2.mailOrderText)("providersCoveredText", ctx_r2.providersCoveredText)("providerPcpText", ctx_r2.providerPcpText)("totalCostEffectiveDate", ctx_r2.totalCostEffectiveDate)("isEnabledShowDrugAlternatives", ctx_r2.isEnabledShowDrugAlternatives)("showNudgeDrugAlternatives", ctx_r2.showNudgeDrugAlternatives)("drugAlternativesTooltipText", ctx_r2.drugAlternativesTooltipText)("drugAlternativesIndicatorIcon", ctx_r2.drugAlternativesIndicatorIcon)("nudgeDrugAlternativesLabelText", ctx_r2.nudgeDrugAlternativesLabelText)("isMailOrderSelected", ctx_r2.isMailOrderSelected)("selectedProviders", ctx_r2.selectedProviders)("planCardPreferenceDetailedEnabled", ctx_r2.planCardPreferenceDetailedEnabled)("providerDetails", ctx_r2.providerDetails)("loaderIconEnabled", ctx_r2.loaderIconEnabled)("editLinkText", ctx_r2.editLinkText)("providerOneOrMoreOutOfNetworkText", ctx_r2.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r2.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r2.providerShowPartialIndicatorEnabled)("showProviderInNetworkOnOtherLocation", ctx_r2.showProviderInNetworkOnOtherLocation)("viewProvidersButtonText", ctx_r2.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r2.viewPrescriptionsButtonText)("isVbcAgreementEnabled", ctx_r2.isVbcAgreementEnabled)("vbcAgreementLabel", ctx_r2.vbcAgreementLabel)("vbcAgreementTooltip", ctx_r2.vbcAgreementTooltip);
} }
class PlanCoveragePreferencesComponent {
    constructor() {
        // TODO Refactor this to use guided help links instead of passing inputs down.
        this.newPlanCardDesignEnabled = false;
        this.viewCostTooltipHeaderText = '';
        this.viewCostTooltipHeaderContent = '';
        this.planCardPreferenceDetailedEnabled = true;
        this.loaderIconEnabled = false;
        this.showProviderInNetworkOnOtherLocation = false;
    }
}
PlanCoveragePreferencesComponent.ɵfac = function PlanCoveragePreferencesComponent_Factory(t) { return new (t || PlanCoveragePreferencesComponent)(); };
PlanCoveragePreferencesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCoveragePreferencesComponent, selectors: [["vnext-plan-coverage-preferences"]], inputs: { newPlanCardDesignEnabled: "newPlanCardDesignEnabled", pharmacyNotCoveredText: "pharmacyNotCoveredText", plan: "plan", pharmacyText: "pharmacyText", pharmacyCoveredText: "pharmacyCoveredText", addedPharmacy: "addedPharmacy", showDrugCoverage: "showDrugCoverage", drugCoverageText: "drugCoverageText", prescriptionsText: "prescriptionsText", planPreferences: "planPreferences", totalEstimatedAnnualCostText: "totalEstimatedAnnualCostText", totalEstimatedCostText: "totalEstimatedCostText", totalEstimatedCostTooltip: "totalEstimatedCostTooltip", isTileDisplay: "isTileDisplay", isRetention: "isRetention", isTotalEstimatedCostEnabled: "isTotalEstimatedCostEnabled", compareTwoPlans: "compareTwoPlans", isQuoting: "isQuoting", noCostAvailableText: "noCostAvailableText", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text", medicineCabinet: "medicineCabinet", viewCostTooltipHeaderText: "viewCostTooltipHeaderText", viewCostTooltipHeaderContent: "viewCostTooltipHeaderContent", inNetworkPreferredText: "inNetworkPreferredText", inNetworkStandardText: "inNetworkStandardText", outOfNetworkText: "outOfNetworkText", annualCost: "annualCost", showMailOrderLabel: "showMailOrderLabel", mailOrderText: "mailOrderText", providersCoveredText: "providersCoveredText", providerPcpText: "providerPcpText", totalCostEffectiveDate: "totalCostEffectiveDate", isEnabledShowDrugAlternatives: "isEnabledShowDrugAlternatives", showNudgeDrugAlternatives: "showNudgeDrugAlternatives", drugAlternativesTooltipText: "drugAlternativesTooltipText", drugAlternativesIndicatorIcon: "drugAlternativesIndicatorIcon", nudgeDrugAlternativesLabelText: "nudgeDrugAlternativesLabelText", isMailOrderSelected: "isMailOrderSelected", selectedProviders: "selectedProviders", planCardPreferenceDetailedEnabled: "planCardPreferenceDetailedEnabled", providerDetails: "providerDetails", loaderIconEnabled: "loaderIconEnabled", editLinkText: "editLinkText", providerOneOrMoreOutOfNetworkText: "providerOneOrMoreOutOfNetworkText", providerInNetworkOnOtherLocationsTooltipText: "providerInNetworkOnOtherLocationsTooltipText", providerShowPartialIndicatorEnabled: "providerShowPartialIndicatorEnabled", showProviderInNetworkOnOtherLocation: "showProviderInNetworkOnOtherLocation", viewProvidersButtonText: "viewProvidersButtonText", viewPrescriptionsButtonText: "viewPrescriptionsButtonText", isVbcAgreementEnabled: "isVbcAgreementEnabled", vbcAgreementLabel: "vbcAgreementLabel", vbcAgreementTooltip: "vbcAgreementTooltip" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["legacyPlanCoveragePreferences", ""], [3, "newPlanCardDesignEnabled", "pharmacyNotCoveredText", "plan", "pharmacyText", "pharmacyCoveredText", "addedPharmacy", "showDrugCoverage", "drugCoverageText", "prescriptionsText", "planPreferences", "totalEstimatedAnnualCostText", "totalEstimatedCostText", "totalEstimatedCostTooltip", "isTileDisplay", "isRetention", "isTotalEstimatedCostEnabled", "compareTwoPlans", "isQuoting", "noCostAvailableText", "Spa_Site_Tooltip_Text", "medicineCabinet", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "annualCost", "showMailOrderLabel", "mailOrderText", "providersCoveredText", "providerPcpText", "totalCostEffectiveDate", "isEnabledShowDrugAlternatives", "showNudgeDrugAlternatives", "drugAlternativesTooltipText", "drugAlternativesIndicatorIcon", "nudgeDrugAlternativesLabelText", "isMailOrderSelected", "selectedProviders", "planCardPreferenceDetailedEnabled", "providerDetails", "loaderIconEnabled", "editLinkText", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "showProviderInNetworkOnOtherLocation", "viewProvidersButtonText", "viewPrescriptionsButtonText", "isVbcAgreementEnabled", "vbcAgreementLabel", "vbcAgreementTooltip"]], template: function PlanCoveragePreferencesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanCoveragePreferencesComponent_ng_container_0_Template, 2, 52, "ng-container", 0);
        i0.ɵɵtemplate(1, PlanCoveragePreferencesComponent_ng_template_1_Template, 1, 52, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.newPlanCardDesignEnabled)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgIf, LegacyPlanCoveragePreferencesComponent, NextgenPlanCoveragePreferencesComponent], styles: [".cover-section[_ngcontent-%COMP%]{margin-right:1px;margin-left:1px}.preferences-section[_ngcontent-%COMP%]{padding:10px 0 0}.cost-horizontal-separator[_ngcontent-%COMP%]{border-top:1px solid var(--static-Spa_Style_Accent1);height:auto}.cost-vertical-separator[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);height:100%;max-height:100%}.preference-icon[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{width:15px;display:inline-block;text-align:right;margin-right:5px}.underline[_ngcontent-%COMP%]{text-decoration:underline}.partial-indicator-text[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Warn_on_Blue)}", ".plan-card[_ngcontent-%COMP%]{border-width:1px;border-style:solid;border-top-right-radius:4px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;padding:8px 0 0}.plan-card.plan-card-border[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent1);border-top-left-radius:4px}.plan-card[_ngcontent-%COMP%]   .image-responsive[_ngcontent-%COMP%]{padding-right:0;max-width:100%;text-align:center}.score-display[_ngcontent-%COMP%]{color:red}.monthly-premium-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;height:100%;align-items:center;justify-content:center}.plan-premium[_ngcontent-%COMP%]{line-height:17px;margin-bottom:5px}.plan-benefits-column-list[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;list-style:none;padding:0}.plan-benefits-column-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child, .plan-benefits-column-list.plan-benefits-row-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-bottom:0;margin-bottom:16px}.coverage[_ngcontent-%COMP%]{border-radius:14px;text-align:center;padding:4px}.coverage[_ngcontent-%COMP%]   .fas[_ngcontent-%COMP%]{height:17px;width:18px}.plan-benefits-items[_ngcontent-%COMP%]:focus, .plan_monthly_premium[_ngcontent-%COMP%]:focus, .monthly-premium-container[_ngcontent-%COMP%]:focus, .coverage[_ngcontent-%COMP%]:focus{box-shadow:none;outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:0 0 5px var(--static-Spa_Style_Black);border-radius:5px}.tooltip-icon[_ngcontent-%COMP%]{font-size:12px;padding-right:10px;background-color:transparent;font-family:\"Font Awesome 5 Pro\"}.plan-benefits[_ngcontent-%COMP%]{margin-bottom:16px}.current-plan-text[_ngcontent-%COMP%], .next-year-plan-text[_ngcontent-%COMP%]{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.plan-name[_ngcontent-%COMP%]:focus{border-radius:5px}.card-sub-header-details[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;align-items:baseline}.non-monthly-payment-text[_ngcontent-%COMP%]{font-size:13px;font-family:montserratregular}@media (max-width: 479.98px){.plan-benefits-column-list.plan-benefits-row-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list.plan-benefits-row-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child{border-bottom:0}}.plan-benefits-items[_ngcontent-%COMP%]{flex-basis:33.3333%;flex-grow:0}@media (max-width: 575.98px){.plan-benefits-list-value-container[_ngcontent-%COMP%]{float:right;display:flex;flex-direction:column;align-items:flex-end}.plan-benefits[_ngcontent-%COMP%]{margin-bottom:0}}.no-border[_ngcontent-%COMP%]{border:none!important}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCoveragePreferencesComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-coverage-preferences', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"newPlanCardDesignEnabled; else legacyPlanCoveragePreferences\">\r\n  <vnext-nextgen-plan-coverage-preferences\r\n    [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n    [pharmacyNotCoveredText]=\"pharmacyNotCoveredText\"\r\n    [plan]=\"plan\"\r\n    [pharmacyText]=\"pharmacyText\"\r\n    [pharmacyCoveredText]=\"pharmacyCoveredText\"\r\n    [addedPharmacy]=\"addedPharmacy\"\r\n    [showDrugCoverage]=\"showDrugCoverage\"\r\n    [drugCoverageText]=\"drugCoverageText\"\r\n    [prescriptionsText]=\"prescriptionsText\"\r\n    [planPreferences]=\"planPreferences\"\r\n    [totalEstimatedAnnualCostText]=\"totalEstimatedAnnualCostText\"\r\n    [totalEstimatedCostText]=\"totalEstimatedCostText\"\r\n    [totalEstimatedCostTooltip]=\"totalEstimatedCostTooltip\"\r\n    [isTileDisplay]=\"isTileDisplay\"\r\n    [isRetention]=\"isRetention\"\r\n    [isTotalEstimatedCostEnabled]=\"isTotalEstimatedCostEnabled\"\r\n    [compareTwoPlans]=\"compareTwoPlans\"\r\n    [isQuoting]=\"isQuoting\"\r\n    [noCostAvailableText]=\"noCostAvailableText\"\r\n    [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n    [medicineCabinet]=\"medicineCabinet\"\r\n    [viewCostTooltipHeaderText]=\"viewCostTooltipHeaderText\"\r\n    [viewCostTooltipHeaderContent]=\"viewCostTooltipHeaderContent\"\r\n    [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n    [inNetworkStandardText]=\"inNetworkStandardText\"\r\n    [outOfNetworkText]=\"outOfNetworkText\"\r\n    [annualCost]=\"annualCost\"\r\n    [showMailOrderLabel]=\"showMailOrderLabel\"\r\n    [mailOrderText]=\"mailOrderText\"\r\n    [providersCoveredText]=\"providersCoveredText\"\r\n    [providerPcpText]=\"providerPcpText\"\r\n    [totalCostEffectiveDate]=\"totalCostEffectiveDate\"\r\n    [isEnabledShowDrugAlternatives]=\"isEnabledShowDrugAlternatives\"\r\n    [showNudgeDrugAlternatives]=\"showNudgeDrugAlternatives\"\r\n    [drugAlternativesTooltipText]=\"drugAlternativesTooltipText\"\r\n    [drugAlternativesIndicatorIcon]=\"drugAlternativesIndicatorIcon\"\r\n    [nudgeDrugAlternativesLabelText]=\"nudgeDrugAlternativesLabelText\"\r\n    [isMailOrderSelected]=\"isMailOrderSelected\"\r\n    [selectedProviders]=\"selectedProviders\"\r\n    [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n    [providerDetails]=\"providerDetails\"\r\n    [loaderIconEnabled]=\"loaderIconEnabled\"\r\n    [editLinkText]=\"editLinkText\"\r\n    [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n    [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n    [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n    [showProviderInNetworkOnOtherLocation]=\"showProviderInNetworkOnOtherLocation\"\r\n    [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n    [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n    [isVbcAgreementEnabled]=\"isVbcAgreementEnabled\"\r\n    [vbcAgreementLabel]=\"vbcAgreementLabel\"\r\n    [vbcAgreementTooltip]=\"vbcAgreementTooltip\"\r\n  >\r\n  </vnext-nextgen-plan-coverage-preferences>\r\n</ng-container>\r\n<ng-template #legacyPlanCoveragePreferences>\r\n  <vnext-legacy-plan-coverage-preferences\r\n    [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n    [pharmacyNotCoveredText]=\"pharmacyNotCoveredText\"\r\n    [plan]=\"plan\"\r\n    [pharmacyText]=\"pharmacyText\"\r\n    [pharmacyCoveredText]=\"pharmacyCoveredText\"\r\n    [addedPharmacy]=\"addedPharmacy\"\r\n    [showDrugCoverage]=\"showDrugCoverage\"\r\n    [drugCoverageText]=\"drugCoverageText\"\r\n    [prescriptionsText]=\"prescriptionsText\"\r\n    [planPreferences]=\"planPreferences\"\r\n    [totalEstimatedAnnualCostText]=\"totalEstimatedAnnualCostText\"\r\n    [totalEstimatedCostText]=\"totalEstimatedCostText\"\r\n    [totalEstimatedCostTooltip]=\"totalEstimatedCostTooltip\"\r\n    [isTileDisplay]=\"isTileDisplay\"\r\n    [isRetention]=\"isRetention\"\r\n    [isTotalEstimatedCostEnabled]=\"isTotalEstimatedCostEnabled\"\r\n    [compareTwoPlans]=\"compareTwoPlans\"\r\n    [isQuoting]=\"isQuoting\"\r\n    [noCostAvailableText]=\"noCostAvailableText\"\r\n    [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n    [medicineCabinet]=\"medicineCabinet\"\r\n    [viewCostTooltipHeaderText]=\"viewCostTooltipHeaderText\"\r\n    [viewCostTooltipHeaderContent]=\"viewCostTooltipHeaderContent\"\r\n    [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n    [inNetworkStandardText]=\"inNetworkStandardText\"\r\n    [outOfNetworkText]=\"outOfNetworkText\"\r\n    [annualCost]=\"annualCost\"\r\n    [showMailOrderLabel]=\"showMailOrderLabel\"\r\n    [mailOrderText]=\"mailOrderText\"\r\n    [providersCoveredText]=\"providersCoveredText\"\r\n    [providerPcpText]=\"providerPcpText\"\r\n    [totalCostEffectiveDate]=\"totalCostEffectiveDate\"\r\n    [isEnabledShowDrugAlternatives]=\"isEnabledShowDrugAlternatives\"\r\n    [showNudgeDrugAlternatives]=\"showNudgeDrugAlternatives\"\r\n    [drugAlternativesTooltipText]=\"drugAlternativesTooltipText\"\r\n    [drugAlternativesIndicatorIcon]=\"drugAlternativesIndicatorIcon\"\r\n    [nudgeDrugAlternativesLabelText]=\"nudgeDrugAlternativesLabelText\"\r\n    [isMailOrderSelected]=\"isMailOrderSelected\"\r\n    [selectedProviders]=\"selectedProviders\"\r\n    [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n    [providerDetails]=\"providerDetails\"\r\n    [loaderIconEnabled]=\"loaderIconEnabled\"\r\n    [editLinkText]=\"editLinkText\"\r\n    [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n    [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n    [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n    [showProviderInNetworkOnOtherLocation]=\"showProviderInNetworkOnOtherLocation\"\r\n    [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n    [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n    [isVbcAgreementEnabled]=\"isVbcAgreementEnabled\"\r\n    [vbcAgreementLabel]=\"vbcAgreementLabel\"\r\n    [vbcAgreementTooltip]=\"vbcAgreementTooltip\"\r\n  >\r\n  </vnext-legacy-plan-coverage-preferences>\r\n</ng-template>\r\n", styles: [".cover-section{margin-right:1px;margin-left:1px}.preferences-section{padding:10px 0 0}.cost-horizontal-separator{border-top:1px solid var(--static-Spa_Style_Accent1);height:auto}.cost-vertical-separator{border-right:1px solid var(--static-Spa_Style_Accent1);height:100%;max-height:100%}.preference-icon>span{width:15px;display:inline-block;text-align:right;margin-right:5px}.underline{text-decoration:underline}.partial-indicator-text{color:var(--static-Spa_Style_Warn_on_Blue)}\n", ".plan-card{border-width:1px;border-style:solid;border-top-right-radius:4px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;padding:8px 0 0}.plan-card.plan-card-border{border-color:var(--static-Spa_Style_Accent1);border-top-left-radius:4px}.plan-card .image-responsive{padding-right:0;max-width:100%;text-align:center}.score-display{color:red}.monthly-premium-container{display:flex;flex-direction:column;height:100%;align-items:center;justify-content:center}.plan-premium{line-height:17px;margin-bottom:5px}.plan-benefits-column-list{display:flex;flex-wrap:wrap;list-style:none;padding:0}.plan-benefits-column-list li{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list li:last-child,.plan-benefits-column-list.plan-benefits-row-list li{border-bottom:0;margin-bottom:16px}.coverage{border-radius:14px;text-align:center;padding:4px}.coverage .fas{height:17px;width:18px}.plan-benefits-items:focus,.plan_monthly_premium:focus,.monthly-premium-container:focus,.coverage:focus{box-shadow:none;outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:0 0 5px var(--static-Spa_Style_Black);border-radius:5px}.tooltip-icon{font-size:12px;padding-right:10px;background-color:transparent;font-family:\"Font Awesome 5 Pro\"}.plan-benefits{margin-bottom:16px}.current-plan-text,.next-year-plan-text{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.plan-name:focus{border-radius:5px}.card-sub-header-details{display:flex;flex-wrap:wrap;align-items:baseline}.non-monthly-payment-text{font-size:13px;font-family:montserratregular}@media (max-width: 479.98px){.plan-benefits-column-list.plan-benefits-row-list li{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list.plan-benefits-row-list li:last-child{border-bottom:0}}.plan-benefits-items{flex-basis:33.3333%;flex-grow:0}@media (max-width: 575.98px){.plan-benefits-list-value-container{float:right;display:flex;flex-direction:column;align-items:flex-end}.plan-benefits{margin-bottom:0}}.no-border{border:none!important}\n"] }]
    }], null, { newPlanCardDesignEnabled: [{
            type: Input
        }], pharmacyNotCoveredText: [{
            type: Input
        }], plan: [{
            type: Input
        }], pharmacyText: [{
            type: Input
        }], pharmacyCoveredText: [{
            type: Input
        }], addedPharmacy: [{
            type: Input
        }], showDrugCoverage: [{
            type: Input
        }], drugCoverageText: [{
            type: Input
        }], prescriptionsText: [{
            type: Input
        }], planPreferences: [{
            type: Input
        }], totalEstimatedAnnualCostText: [{
            type: Input
        }], totalEstimatedCostText: [{
            type: Input
        }], totalEstimatedCostTooltip: [{
            type: Input
        }], isTileDisplay: [{
            type: Input
        }], isRetention: [{
            type: Input
        }], isTotalEstimatedCostEnabled: [{
            type: Input
        }], compareTwoPlans: [{
            type: Input
        }], isQuoting: [{
            type: Input
        }], noCostAvailableText: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }], medicineCabinet: [{
            type: Input
        }], viewCostTooltipHeaderText: [{
            type: Input
        }], viewCostTooltipHeaderContent: [{
            type: Input
        }], inNetworkPreferredText: [{
            type: Input
        }], inNetworkStandardText: [{
            type: Input
        }], outOfNetworkText: [{
            type: Input
        }], annualCost: [{
            type: Input
        }], showMailOrderLabel: [{
            type: Input
        }], mailOrderText: [{
            type: Input
        }], providersCoveredText: [{
            type: Input
        }], providerPcpText: [{
            type: Input
        }], totalCostEffectiveDate: [{
            type: Input
        }], isEnabledShowDrugAlternatives: [{
            type: Input
        }], showNudgeDrugAlternatives: [{
            type: Input
        }], drugAlternativesTooltipText: [{
            type: Input
        }], drugAlternativesIndicatorIcon: [{
            type: Input
        }], nudgeDrugAlternativesLabelText: [{
            type: Input
        }], isMailOrderSelected: [{
            type: Input
        }], selectedProviders: [{
            type: Input
        }], planCardPreferenceDetailedEnabled: [{
            type: Input
        }], providerDetails: [{
            type: Input
        }], loaderIconEnabled: [{
            type: Input
        }], editLinkText: [{
            type: Input
        }], providerOneOrMoreOutOfNetworkText: [{
            type: Input
        }], providerInNetworkOnOtherLocationsTooltipText: [{
            type: Input
        }], providerShowPartialIndicatorEnabled: [{
            type: Input
        }], showProviderInNetworkOnOtherLocation: [{
            type: Input
        }], viewProvidersButtonText: [{
            type: Input
        }], viewPrescriptionsButtonText: [{
            type: Input
        }], isVbcAgreementEnabled: [{
            type: Input
        }], vbcAgreementLabel: [{
            type: Input
        }], vbcAgreementTooltip: [{
            type: Input
        }] }); })();

function PlanCardSupplementalBenefitLabelComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "i", 3);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "titlecase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.isBenefitIncluded ? "Spa_Style_Primary_Color" : "Spa_Style_Gray4_Color");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r0.isBenefitIncluded ? "fas fa-check currency" : "fas fa-times-circle");
    i0.ɵɵattribute("aria-label", ctx_r0.isBenefitIncluded ? ctx_r0.availableText : ctx_r0.unavailableText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, ctx_r0.benefitName), "\n");
} }
function PlanCardSupplementalBenefitLabelComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "i", 3);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "titlecase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.isBenefitIncluded ? "Spa_Style_Primary_Color" : "Spa_Style_Gray4_Color");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r1.isBenefitIncluded ? "fas fa-check currency" : "fas fa-times-circle");
    i0.ɵɵattribute("aria-label", ctx_r1.isBenefitIncluded ? ctx_r1.availableText : ctx_r1.unavailableText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, ctx_r1.benefitName), "\n");
} }
class PlanCardSupplementalBenefitLabelComponent {
    constructor() {
        this.newPlanCardDesignEnabled = false;
        this.isBenefitIncluded = false;
    }
    ngOnChanges(changes) {
        const { benefitMedCategoryId, planBenefits } = changes;
        if ((benefitMedCategoryId && benefitMedCategoryId.previousValue !== benefitMedCategoryId.currentValue) ||
            (planBenefits && !_isEqual(planBenefits.previousValue, planBenefits.currentValue))) {
            this.isBenefitIncluded = this.getIsBenefitIncluded(this.benefitMedCategoryId, this.planBenefits);
        }
    }
    getIsBenefitIncluded(benefitMedCategoryId, planBenefits) {
        if (benefitMedCategoryId !== undefined && benefitMedCategoryId !== null && planBenefits?.length) {
            return planBenefits.some(planBenefit => planBenefit.benefitID === benefitMedCategoryId &&
                planBenefit.isCovered &&
                planBenefit.type.toLowerCase() === BenefitNetworkStatus.IN_NETWORK.toLowerCase());
        }
        return false;
    }
}
PlanCardSupplementalBenefitLabelComponent.ɵfac = function PlanCardSupplementalBenefitLabelComponent_Factory(t) { return new (t || PlanCardSupplementalBenefitLabelComponent)(); };
PlanCardSupplementalBenefitLabelComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCardSupplementalBenefitLabelComponent, selectors: [["vnext-plan-card-supplemental-benefit-label"]], inputs: { benefitName: "benefitName", benefitMedCategoryId: "benefitMedCategoryId", planBenefits: "planBenefits", newPlanCardDesignEnabled: "newPlanCardDesignEnabled", availableText: "availableText", unavailableText: "unavailableText" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [["class", "pr-2 Spa_Style_Small_Font Spa_Style_Note", 3, "ngClass", 4, "ngIf"], ["class", "pr-2", 3, "ngClass", 4, "ngIf"], [1, "pr-2", "Spa_Style_Small_Font", "Spa_Style_Note", 3, "ngClass"], ["role", "img", 3, "ngClass"], [1, "pr-2", 3, "ngClass"]], template: function PlanCardSupplementalBenefitLabelComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanCardSupplementalBenefitLabelComponent_div_0_Template, 4, 6, "div", 0);
        i0.ɵɵtemplate(1, PlanCardSupplementalBenefitLabelComponent_div_1_Template, 4, 6, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.newPlanCardDesignEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.newPlanCardDesignEnabled);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$2.TitleCasePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCardSupplementalBenefitLabelComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-card-supplemental-benefit-label', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  *ngIf=\"newPlanCardDesignEnabled\"\r\n  [ngClass]=\"isBenefitIncluded ? 'Spa_Style_Primary_Color' : 'Spa_Style_Gray4_Color'\"\r\n  class=\"pr-2 Spa_Style_Small_Font Spa_Style_Note\"\r\n>\r\n  <i\r\n    [ngClass]=\"isBenefitIncluded ? 'fas fa-check currency' : 'fas fa-times-circle'\"\r\n    role=\"img\"\r\n    [attr.aria-label]=\"isBenefitIncluded ? availableText : unavailableText\"\r\n  ></i>\r\n  {{ benefitName | titlecase }}\r\n</div>\r\n\r\n<div *ngIf=\"!newPlanCardDesignEnabled\" [ngClass]=\"isBenefitIncluded ? 'Spa_Style_Primary_Color' : 'Spa_Style_Gray4_Color'\" class=\"pr-2\">\r\n  <i\r\n    [ngClass]=\"isBenefitIncluded ? 'fas fa-check currency' : 'fas fa-times-circle'\"\r\n    role=\"img\"\r\n    [attr.aria-label]=\"isBenefitIncluded ? availableText : unavailableText\"\r\n  ></i>\r\n  {{ benefitName | titlecase }}\r\n</div>\r\n" }]
    }], null, { benefitName: [{
            type: Input
        }], benefitMedCategoryId: [{
            type: Input
        }], planBenefits: [{
            type: Input
        }], newPlanCardDesignEnabled: [{
            type: Input
        }], availableText: [{
            type: Input
        }], unavailableText: [{
            type: Input
        }] }); })();

function PlanCardSupplementalBenefitsComponent_div_0_ng_container_4_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 8);
    i0.ɵɵelement(1, "vnext-plan-card-supplemental-benefit-label", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const benefit_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("benefitName", benefit_r4.name)("benefitMedCategoryId", benefit_r4.medCategoryId)("planBenefits", ctx_r6.planBenefits)("availableText", ctx_r6.availableText)("unavailableText", ctx_r6.unavailableText);
} }
function PlanCardSupplementalBenefitsComponent_div_0_ng_container_4_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 8);
    i0.ɵɵelement(1, "vnext-plan-card-supplemental-benefit-label", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const benefit_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("benefitName", benefit_r4.name)("benefitMedCategoryId", benefit_r4.medCategoryId)("planBenefits", ctx_r7.planBenefits)("availableText", ctx_r7.availableText)("unavailableText", ctx_r7.unavailableText);
} }
function PlanCardSupplementalBenefitsComponent_div_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanCardSupplementalBenefitsComponent_div_0_ng_container_4_li_1_Template, 2, 5, "li", 7);
    i0.ɵɵtemplate(2, PlanCardSupplementalBenefitsComponent_div_0_ng_container_4_li_2_Template, 2, 5, "li", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const index_r5 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isMobile && (index_r5 < 10 || ctx_r2.showAllBenefitsLabels));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isMobile && (index_r5 < 5 || ctx_r2.showAllBenefitsLabels));
} }
function PlanCardSupplementalBenefitsComponent_div_0_li_5_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 14);
    i0.ɵɵelementStart(3, "span", 15);
    i0.ɵɵtext(4, "Collapse");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.hideLinkText, "");
} }
function PlanCardSupplementalBenefitsComponent_div_0_li_5_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵelement(1, "i", 16);
    i0.ɵɵelementStart(2, "span", 15);
    i0.ɵɵtext(3, "Expand");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.viewAllLinkText, "");
} }
function PlanCardSupplementalBenefitsComponent_div_0_li_5_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "vnext-link", 10);
    i0.ɵɵlistener("click", function PlanCardSupplementalBenefitsComponent_div_0_li_5_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.toggleViewAll()); })("keyup.enter", function PlanCardSupplementalBenefitsComponent_div_0_li_5_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r15.toggleViewAll()); });
    i0.ɵɵelementStart(2, "div", 11);
    i0.ɵɵtemplate(3, PlanCardSupplementalBenefitsComponent_div_0_li_5_ng_container_3_Template, 5, 1, "ng-container", 12);
    i0.ɵɵtemplate(4, PlanCardSupplementalBenefitsComponent_div_0_li_5_ng_template_4_Template, 4, 1, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const _r11 = i0.ɵɵreference(5);
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("makeInlineBlock", true)("keyNameForLiveEdit", "Spa_Site_Hide_Text")("role", ctx_r3.linkRoles.BUTTON);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.showAllBenefitsLabels)("ngIfElse", _r11);
} }
function PlanCardSupplementalBenefitsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ul", 4);
    i0.ɵɵtemplate(4, PlanCardSupplementalBenefitsComponent_div_0_ng_container_4_Template, 3, 2, "ng-container", 5);
    i0.ɵɵtemplate(5, PlanCardSupplementalBenefitsComponent_div_0_li_5_Template, 6, 5, "li", 6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.supplementalBenefitsHighlightText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.supplementalBenefits)("ngForTrackBy", ctx_r0.benefitsTrackBy);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isMobile && (ctx_r0.supplementalBenefits == null ? null : ctx_r0.supplementalBenefits.length) > 10 || ctx_r0.isMobile && (ctx_r0.supplementalBenefits == null ? null : ctx_r0.supplementalBenefits.length) > 5);
} }
function PlanCardSupplementalBenefitsComponent_div_1_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-card-supplemental-benefit-label", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const benefit_r20 = i0.ɵɵnextContext().$implicit;
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("benefitName", benefit_r20.name)("benefitMedCategoryId", benefit_r20.medCategoryId)("planBenefits", ctx_r22.planBenefits)("availableText", ctx_r22.availableText)("unavailableText", ctx_r22.unavailableText);
} }
function PlanCardSupplementalBenefitsComponent_div_1_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-card-supplemental-benefit-label", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const benefit_r20 = i0.ɵɵnextContext().$implicit;
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("benefitName", benefit_r20.name)("benefitMedCategoryId", benefit_r20.medCategoryId)("planBenefits", ctx_r23.planBenefits)("availableText", ctx_r23.availableText)("unavailableText", ctx_r23.unavailableText);
} }
function PlanCardSupplementalBenefitsComponent_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtemplate(1, PlanCardSupplementalBenefitsComponent_div_1_div_3_div_1_Template, 2, 5, "div", 6);
    i0.ɵɵtemplate(2, PlanCardSupplementalBenefitsComponent_div_1_div_3_div_2_Template, 2, 5, "div", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const index_r21 = ctx.index;
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r16.isMobile);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.isMobile && (index_r21 < 2 || ctx_r16.showAllBenefitsLabels));
} }
function PlanCardSupplementalBenefitsComponent_div_1_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 14);
    i0.ɵɵelementStart(3, "span", 15);
    i0.ɵɵtext(4, "Collapse");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r17.hideLinkText, "");
} }
function PlanCardSupplementalBenefitsComponent_div_1_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵelement(1, "i", 16);
    i0.ɵɵelementStart(2, "span", 15);
    i0.ɵɵtext(3, "Expand");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r19.viewAllLinkText, "");
} }
const _c0$2x = function (a0) { return { "hide-extra-benefits": a0 }; };
function PlanCardSupplementalBenefitsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17)(1, "div", 18)(2, "div", 19);
    i0.ɵɵtemplate(3, PlanCardSupplementalBenefitsComponent_div_1_div_3_Template, 3, 2, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 21)(5, "vnext-link", 10);
    i0.ɵɵlistener("click", function PlanCardSupplementalBenefitsComponent_div_1_Template_vnext_link_click_5_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r26.toggleViewAll()); })("keyup.enter", function PlanCardSupplementalBenefitsComponent_div_1_Template_vnext_link_keyup_enter_5_listener() { i0.ɵɵrestoreView(_r27); const ctx_r28 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r28.toggleViewAll()); });
    i0.ɵɵelementStart(6, "div", 11);
    i0.ɵɵtemplate(7, PlanCardSupplementalBenefitsComponent_div_1_ng_container_7_Template, 5, 1, "ng-container", 12);
    i0.ɵɵtemplate(8, PlanCardSupplementalBenefitsComponent_div_1_ng_template_8_Template, 4, 1, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const _r18 = i0.ɵɵreference(9);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0$2x, !ctx_r1.showAllBenefitsLabels));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.supplementalBenefits)("ngForTrackBy", ctx_r1.benefitsTrackBy);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("makeInlineBlock", true)("keyNameForLiveEdit", "Spa_Site_Hide_Text")("role", ctx_r1.linkRoles.BUTTON);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showAllBenefitsLabels)("ngIfElse", _r18);
} }
class PlanCardSupplementalBenefitsComponent {
    constructor() {
        this.newPlanCardDesignEnabled = false;
        this.supplementalBenefits = [];
        this.isMobile = false;
        this.showAllBenefitsLabels = false;
        this.linkRoles = LinkRoles;
    }
    benefitsTrackBy(index, benefit) {
        return benefit.medCategoryId;
    }
    toggleViewAll() {
        this.showAllBenefitsLabels = !this.showAllBenefitsLabels;
    }
}
PlanCardSupplementalBenefitsComponent.ɵfac = function PlanCardSupplementalBenefitsComponent_Factory(t) { return new (t || PlanCardSupplementalBenefitsComponent)(); };
PlanCardSupplementalBenefitsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCardSupplementalBenefitsComponent, selectors: [["vnext-plan-card-supplemental-benefits"]], inputs: { newPlanCardDesignEnabled: "newPlanCardDesignEnabled", supplementalBenefits: "supplementalBenefits", planBenefits: "planBenefits", isMobile: "isMobile", hideLinkText: "hideLinkText", viewAllLinkText: "viewAllLinkText", availableText: "availableText", unavailableText: "unavailableText", supplementalBenefitsHighlightText: "supplementalBenefitsHighlightText" }, decls: 2, vars: 2, consts: [["class", "my-3 d-flex flex-col-xs-only", 4, "ngIf"], ["class", "horizontal-separator mt-2 pt-2", 4, "ngIf"], [1, "my-3", "d-flex", "flex-col-xs-only"], [1, "Spa_Style_Regular_Font", "mr-4", "mb-1", "mb-sm-0"], [1, "plan-card-highlights-list", "list-inline", "mb-0"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [4, "ngIf"], ["class", "Spa_Style_Small_Font", 4, "ngIf"], [1, "Spa_Style_Small_Font"], [3, "benefitName", "benefitMedCategoryId", "planBenefits", "availableText", "unavailableText"], [3, "makeInlineBlock", "keyNameForLiveEdit", "role", "click", "keyup.enter"], ["link-body", "", 1, "pl-2"], [4, "ngIf", "ngIfElse"], ["hideExtraBenefits", ""], [1, "ml-1", "fas", "fa-angle-up"], [1, "sr-only"], [1, "ml-1", "fas", "fa-angle-down"], [1, "horizontal-separator", "mt-2", "pt-2"], [1, "row", "m-0"], [1, "col-10", "px-0", "row", "m-0", 3, "ngClass"], ["class", "Spa_Style_Small_Font my-1", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "mt-1"], [1, "Spa_Style_Small_Font", "my-1"]], template: function PlanCardSupplementalBenefitsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanCardSupplementalBenefitsComponent_div_0_Template, 6, 4, "div", 0);
        i0.ɵɵtemplate(1, PlanCardSupplementalBenefitsComponent_div_1_Template, 10, 10, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.newPlanCardDesignEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.newPlanCardDesignEnabled);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, IconAriaAttributesDirective, PlanCardSupplementalBenefitLabelComponent], styles: [".horizontal-separator[_ngcontent-%COMP%]{border-top:1px solid var(--static-Spa_Style_Accent1)}.hide-extra-benefits[_ngcontent-%COMP%]{height:31px;overflow-y:hidden}.plan-card-highlights-list[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{display:inline-block}@media (max-width: 575.98px){.flex-col-xs-only[_ngcontent-%COMP%]{flex-direction:column}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCardSupplementalBenefitsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-card-supplemental-benefits', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"my-3 d-flex flex-col-xs-only\" *ngIf=\"newPlanCardDesignEnabled\">\r\n  <div class=\"Spa_Style_Regular_Font mr-4 mb-1 mb-sm-0\">{{ supplementalBenefitsHighlightText }}</div>\r\n  <ul class=\"plan-card-highlights-list list-inline mb-0\">\r\n    <ng-container *ngFor=\"let benefit of supplementalBenefits; index as index; trackBy: benefitsTrackBy\">\r\n      <li *ngIf=\"!isMobile && (index < 10 || showAllBenefitsLabels)\" class=\"Spa_Style_Small_Font\">\r\n        <vnext-plan-card-supplemental-benefit-label\r\n          [benefitName]=\"benefit.name\"\r\n          [benefitMedCategoryId]=\"benefit.medCategoryId\"\r\n          [planBenefits]=\"planBenefits\"\r\n          [availableText]=\"availableText\"\r\n          [unavailableText]=\"unavailableText\"\r\n        ></vnext-plan-card-supplemental-benefit-label>\r\n      </li>\r\n      <li *ngIf=\"isMobile && (index < 5 || showAllBenefitsLabels)\" class=\"Spa_Style_Small_Font\">\r\n        <vnext-plan-card-supplemental-benefit-label\r\n          [benefitName]=\"benefit.name\"\r\n          [benefitMedCategoryId]=\"benefit.medCategoryId\"\r\n          [planBenefits]=\"planBenefits\"\r\n          [availableText]=\"availableText\"\r\n          [unavailableText]=\"unavailableText\"\r\n        ></vnext-plan-card-supplemental-benefit-label>\r\n      </li>\r\n    </ng-container>\r\n    <li *ngIf=\"(!isMobile && supplementalBenefits?.length > 10) || (isMobile && supplementalBenefits?.length > 5)\">\r\n      <vnext-link\r\n        [makeInlineBlock]=\"true\"\r\n        [keyNameForLiveEdit]=\"'Spa_Site_Hide_Text'\"\r\n        [role]=\"linkRoles.BUTTON\"\r\n        (click)=\"toggleViewAll()\"\r\n        (keyup.enter)=\"toggleViewAll()\"\r\n      >\r\n        <div class=\"pl-2\" link-body>\r\n          <ng-container *ngIf=\"showAllBenefitsLabels; else hideExtraBenefits\">\r\n            {{ hideLinkText }}<i class=\"ml-1 fas fa-angle-up\"></i><span class=\"sr-only\">Collapse</span>\r\n          </ng-container>\r\n          <ng-template #hideExtraBenefits> {{ viewAllLinkText }}<i class=\"ml-1 fas fa-angle-down\"></i><span class=\"sr-only\">Expand</span> </ng-template>\r\n        </div>\r\n      </vnext-link>\r\n    </li>\r\n  </ul>\r\n</div>\r\n\r\n<div class=\"horizontal-separator mt-2 pt-2\" *ngIf=\"!newPlanCardDesignEnabled\">\r\n  <div class=\"row m-0\">\r\n    <div class=\"col-10 px-0 row m-0\" [ngClass]=\"{ 'hide-extra-benefits': !showAllBenefitsLabels }\">\r\n      <div class=\"Spa_Style_Small_Font my-1\" *ngFor=\"let benefit of supplementalBenefits; index as index; trackBy: benefitsTrackBy\">\r\n        <div *ngIf=\"!isMobile\">\r\n          <vnext-plan-card-supplemental-benefit-label\r\n            [benefitName]=\"benefit.name\"\r\n            [benefitMedCategoryId]=\"benefit.medCategoryId\"\r\n            [planBenefits]=\"planBenefits\"\r\n            [availableText]=\"availableText\"\r\n            [unavailableText]=\"unavailableText\"\r\n          ></vnext-plan-card-supplemental-benefit-label>\r\n        </div>\r\n        <div *ngIf=\"isMobile && (index < 2 || showAllBenefitsLabels)\">\r\n          <vnext-plan-card-supplemental-benefit-label\r\n            [benefitName]=\"benefit.name\"\r\n            [benefitMedCategoryId]=\"benefit.medCategoryId\"\r\n            [planBenefits]=\"planBenefits\"\r\n            [availableText]=\"availableText\"\r\n            [unavailableText]=\"unavailableText\"\r\n          ></vnext-plan-card-supplemental-benefit-label>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"mt-1\">\r\n      <vnext-link\r\n        [makeInlineBlock]=\"true\"\r\n        [keyNameForLiveEdit]=\"'Spa_Site_Hide_Text'\"\r\n        [role]=\"linkRoles.BUTTON\"\r\n        (click)=\"toggleViewAll()\"\r\n        (keyup.enter)=\"toggleViewAll()\"\r\n      >\r\n        <div class=\"pl-2\" link-body>\r\n          <ng-container *ngIf=\"showAllBenefitsLabels; else hideExtraBenefits\">\r\n            {{ hideLinkText }}<i class=\"ml-1 fas fa-angle-up\"></i><span class=\"sr-only\">Collapse</span>\r\n          </ng-container>\r\n          <ng-template #hideExtraBenefits> {{ viewAllLinkText }}<i class=\"ml-1 fas fa-angle-down\"></i><span class=\"sr-only\">Expand</span> </ng-template>\r\n        </div>\r\n      </vnext-link>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".horizontal-separator{border-top:1px solid var(--static-Spa_Style_Accent1)}.hide-extra-benefits{height:31px;overflow-y:hidden}.plan-card-highlights-list>li{display:inline-block}@media (max-width: 575.98px){.flex-col-xs-only{flex-direction:column}}\n"] }]
    }], null, { newPlanCardDesignEnabled: [{
            type: Input
        }], supplementalBenefits: [{
            type: Input
        }], planBenefits: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], hideLinkText: [{
            type: Input
        }], viewAllLinkText: [{
            type: Input
        }], availableText: [{
            type: Input
        }], unavailableText: [{
            type: Input
        }], supplementalBenefitsHighlightText: [{
            type: Input
        }] }); })();

function PlanCardLabelComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("", ctx_r10.customClass, " h-100 py-1 text-center Spa_Style_Gray4_Color Spa_Style_Gray1_Background Spa_Style_Semi_Bold_Weight not-licensed-plan-text");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.notLicensedPlanText, " ");
} }
function PlanCardLabelComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanCardLabelComponent_ng_container_0_div_1_Template, 2, 4, "div", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.notLicensedPlanText);
} }
function PlanCardLabelComponent_ng_template_1_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("", ctx_r12.customClass, " h-100 Spa_Style_Accent6_Background py-1 text-center px-1 current-plan-text");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.updatedCurrentYearPlanText, " ");
} }
function PlanCardLabelComponent_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanCardLabelComponent_ng_template_1_ng_container_0_div_1_Template, 2, 4, "div", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.updatedCurrentYearPlanText);
} }
function PlanCardLabelComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanCardLabelComponent_ng_template_1_ng_container_0_Template, 2, 1, "ng-container", 0);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵproperty("ngIf", ctx_r2.plan.isCurrentYearPlan)("ngIfElse", _r3);
} }
function PlanCardLabelComponent_ng_template_3_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("", ctx_r14.customClass, " h-100 Spa_Style_Primary_Link_Background py-1 text-center px-1 primary-link-text");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.optionOneText, " ");
} }
function PlanCardLabelComponent_ng_template_3_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanCardLabelComponent_ng_template_3_ng_container_0_div_1_Template, 2, 4, "div", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.optionOneText);
} }
function PlanCardLabelComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanCardLabelComponent_ng_template_3_ng_container_0_Template, 2, 1, "ng-container", 0);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(6);
    i0.ɵɵproperty("ngIf", ctx_r4.displayOptionLabels && ctx_r4.plan.modifiedNextYearPlanOrdinal === 1)("ngIfElse", _r5);
} }
function PlanCardLabelComponent_ng_template_5_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("", ctx_r16.customClass, " h-100 Spa_Style_Primary_Link_Background py-1 text-center px-1 primary-link-text");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.optionTwoText, " ");
} }
function PlanCardLabelComponent_ng_template_5_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanCardLabelComponent_ng_template_5_ng_container_0_div_1_Template, 2, 4, "div", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.optionTwoText);
} }
function PlanCardLabelComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanCardLabelComponent_ng_template_5_ng_container_0_Template, 2, 1, "ng-container", 0);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    const _r7 = i0.ɵɵreference(8);
    i0.ɵɵproperty("ngIf", ctx_r6.displayOptionLabels && ctx_r6.plan.modifiedNextYearPlanOrdinal === 2)("ngIfElse", _r7);
} }
function PlanCardLabelComponent_ng_template_7_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("", ctx_r18.customClass, " h-100 Spa_Style_Primary_Link_Background py-1 text-center px-1 primary-link-text");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r18.updatedNextYearPlanText, " ");
} }
function PlanCardLabelComponent_ng_template_7_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanCardLabelComponent_ng_template_7_ng_container_0_div_1_Template, 2, 4, "div", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.updatedNextYearPlanText);
} }
function PlanCardLabelComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanCardLabelComponent_ng_template_7_ng_container_0_Template, 2, 1, "ng-container", 5);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r8.plan.isNextYearPlan && !ctx_r8.plan.isPlanRolloverTerminated && !ctx_r8.disableNextYearDisplay);
} }
function PlanCardLabelComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("", ctx_r9.customClass, " h-100 py-1 Spa_Style_Gray4_Color Spa_Style_Semi_Bold_Weight Spa_Style_Gray1_Background px-1 not-licensed-plan-text");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.nonCommissionableText, " ");
} }
class PlanCardLabelComponent {
    constructor(planYearResourceService, cdr) {
        this.planYearResourceService = planYearResourceService;
        this.cdr = cdr;
        this.disableNextYearDisplay = false;
        this.isNonCommissionableFlagCheckEnabled = false;
        this.subscriptions = new Subscription();
        this.planYear = null;
        this.isNonCommissionFlagEnabled = false;
    }
    ngOnInit() {
        if (this.planYearResourceService.getIsDualPlanYearSite()) {
            this.subscriptions.add(this.planYearResourceService.getSelectedPlanYear$().subscribe({
                next: planYear => {
                    this.planYear = parseInt(planYear, 10);
                    this.updateYearPlanText(this.planYear);
                }
            }));
        }
        else {
            this.updateYearPlanText(this.planYear);
        }
    }
    ngOnChanges(changes) {
        const { plan, currentPlanText, nextYearPlanText, isNonCommissionableFlagCheckEnabled } = changes;
        if (currentPlanText?.currentValue !== currentPlanText?.previousValue ||
            nextYearPlanText?.currentValue !== nextYearPlanText?.previousValue) {
            this.updateYearPlanText(this.planYear);
        }
        if (isNonCommissionableFlagCheckEnabled?.currentValue !== isNonCommissionableFlagCheckEnabled?.previousValue ||
            (plan && !_isEqual(plan.previousValue, plan.currentValue))) {
            this.isNonCommissionFlagEnabled = !PlansUtilityService.isPlanCommissionable(this.plan, this.isNonCommissionableFlagCheckEnabled);
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    updateYearPlanText(planYear) {
        if (planYear !== null) {
            this.updatedCurrentYearPlanText = this.currentPlanText.replace('<planYear>', `${planYear - 1}`);
            this.updatedNextYearPlanText = this.nextYearPlanText.replace('<planYear>', `${planYear}`);
        }
        else {
            // We still need to update the local variables like this if the resources updated for something like a locale change
            // In this scenario where planYear is never updated from null, we're on single plan year site, so the resources
            // should not have a text replacement needed to be performed
            this.updatedCurrentYearPlanText = this.currentPlanText;
            this.updatedNextYearPlanText = this.nextYearPlanText;
        }
        this.cdr.markForCheck();
    }
}
PlanCardLabelComponent.ɵfac = function PlanCardLabelComponent_Factory(t) { return new (t || PlanCardLabelComponent)(i0.ɵɵdirectiveInject(i1.PlanYearResourceService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
PlanCardLabelComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCardLabelComponent, selectors: [["vnext-widget-plan-card-label"]], inputs: { plan: "plan", currentPlanText: "currentPlanText", nextYearPlanText: "nextYearPlanText", notLicensedPlanText: "notLicensedPlanText", customClass: "customClass", includeNonLicensedPlans: "includeNonLicensedPlans", optionOneText: "optionOneText", optionTwoText: "optionTwoText", displayOptionLabels: "displayOptionLabels", disableNextYearDisplay: "disableNextYearDisplay", nonCommissionableText: "nonCommissionableText", isNonCommissionableFlagCheckEnabled: "isNonCommissionableFlagCheckEnabled" }, features: [i0.ɵɵNgOnChangesFeature], decls: 10, vars: 3, consts: [[4, "ngIf", "ngIfElse"], ["currentYearPlan", ""], ["optionLabelOne", ""], ["optionLabelTwo", ""], ["nextYearPlan", ""], [4, "ngIf"], [3, "class", 4, "ngIf"]], template: function PlanCardLabelComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanCardLabelComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
        i0.ɵɵtemplate(1, PlanCardLabelComponent_ng_template_1_Template, 1, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(3, PlanCardLabelComponent_ng_template_3_Template, 1, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(5, PlanCardLabelComponent_ng_template_5_Template, 1, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(7, PlanCardLabelComponent_ng_template_7_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(9, PlanCardLabelComponent_ng_container_9_Template, 3, 4, "ng-container", 5);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.plan.isNonPermissionedPlan && !ctx.plan.isPUF && ctx.includeNonLicensedPlans)("ngIfElse", _r1);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngIf", ctx.isNonCommissionFlagEnabled);
    } }, dependencies: [i1$2.NgIf], styles: [".current-plan-text[_ngcontent-%COMP%], .primary-link-text[_ngcontent-%COMP%]{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.not-licensed-plan-text[_ngcontent-%COMP%]{border-top-left-radius:5px;border-top-right-radius:5px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCardLabelComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-card-label', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"plan.isNonPermissionedPlan && !plan.isPUF && includeNonLicensedPlans; else currentYearPlan\">\r\n  <div\r\n    *ngIf=\"notLicensedPlanText\"\r\n    class=\"{{\r\n      customClass\r\n    }} h-100 py-1 text-center Spa_Style_Gray4_Color Spa_Style_Gray1_Background Spa_Style_Semi_Bold_Weight not-licensed-plan-text\"\r\n  >\r\n    {{ notLicensedPlanText }}\r\n  </div>\r\n</ng-container>\r\n\r\n<ng-template #currentYearPlan>\r\n  <ng-container *ngIf=\"plan.isCurrentYearPlan; else optionLabelOne\">\r\n    <div\r\n      *ngIf=\"updatedCurrentYearPlanText\"\r\n      class=\"{{ customClass }} h-100 Spa_Style_Accent6_Background py-1 text-center px-1 current-plan-text\"\r\n    >\r\n      {{ updatedCurrentYearPlanText }}\r\n    </div>\r\n  </ng-container>\r\n</ng-template>\r\n\r\n<ng-template #optionLabelOne>\r\n  <ng-container *ngIf=\"displayOptionLabels && plan.modifiedNextYearPlanOrdinal === 1; else optionLabelTwo\">\r\n    <div *ngIf=\"optionOneText\" class=\"{{ customClass }} h-100 Spa_Style_Primary_Link_Background py-1 text-center px-1 primary-link-text\">\r\n      {{ optionOneText }}\r\n    </div>\r\n  </ng-container>\r\n</ng-template>\r\n\r\n<ng-template #optionLabelTwo>\r\n  <ng-container *ngIf=\"displayOptionLabels && plan.modifiedNextYearPlanOrdinal === 2; else nextYearPlan\">\r\n    <div *ngIf=\"optionTwoText\" class=\"{{ customClass }} h-100 Spa_Style_Primary_Link_Background py-1 text-center px-1 primary-link-text\">\r\n      {{ optionTwoText }}\r\n    </div>\r\n  </ng-container>\r\n</ng-template>\r\n\r\n<ng-template #nextYearPlan>\r\n  <ng-container *ngIf=\"plan.isNextYearPlan && !plan.isPlanRolloverTerminated && !disableNextYearDisplay\">\r\n    <div\r\n      *ngIf=\"updatedNextYearPlanText\"\r\n      class=\"{{ customClass }} h-100 Spa_Style_Primary_Link_Background py-1 text-center px-1 primary-link-text\"\r\n    >\r\n      {{ updatedNextYearPlanText }}\r\n    </div>\r\n  </ng-container>\r\n</ng-template>\r\n\r\n<ng-container *ngIf=\"isNonCommissionFlagEnabled\">\r\n  <div\r\n    class=\"{{\r\n      customClass\r\n    }} h-100 py-1 Spa_Style_Gray4_Color Spa_Style_Semi_Bold_Weight Spa_Style_Gray1_Background px-1 not-licensed-plan-text\"\r\n  >\r\n    {{ nonCommissionableText }}\r\n  </div>\r\n</ng-container>\r\n", styles: [".current-plan-text,.primary-link-text{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.not-licensed-plan-text{border-top-left-radius:5px;border-top-right-radius:5px}\n"] }]
    }], function () { return [{ type: i1.PlanYearResourceService }, { type: i0.ChangeDetectorRef }]; }, { plan: [{
            type: Input
        }], currentPlanText: [{
            type: Input
        }], nextYearPlanText: [{
            type: Input
        }], notLicensedPlanText: [{
            type: Input
        }], customClass: [{
            type: Input
        }], includeNonLicensedPlans: [{
            type: Input
        }], optionOneText: [{
            type: Input
        }], optionTwoText: [{
            type: Input
        }], displayOptionLabels: [{
            type: Input
        }], disableNextYearDisplay: [{
            type: Input
        }], nonCommissionableText: [{
            type: Input
        }], isNonCommissionableFlagCheckEnabled: [{
            type: Input
        }] }); })();

const _c0$2w = function (a0) { return { "mb-3": a0 }; };
function PlanQuoteButtonComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4, 5);
    i0.ɵɵlistener("click", function PlanQuoteButtonComponent_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const _r4 = i0.ɵɵreference(1); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.addPlanToQuote(ctx_r5.plan, _r4)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(3);
    i0.ɵɵpropertyInterpolate2("title", "", ctx_r0.plan == null ? null : ctx_r0.plan.planName, ": ", ctx_r0.addToQuoteButtonText, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$2w, ctx_r0.newPlanCardDesignEnabled))("ngbTooltip", _r1);
    i0.ɵɵattribute("aria-label", (ctx_r0.plan == null ? null : ctx_r0.plan.planName) + ": " + ctx_r0.addToQuoteButtonText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.addToQuoteButtonText, " ");
} }
function PlanQuoteButtonComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 6);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r2.addToQuoteWarningTooltip.body, "html"), i0.ɵɵsanitizeHtml);
} }
function PlanQuoteButtonComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function PlanQuoteButtonComponent_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.onRemovePlanFromQuoteGroup(ctx_r7.plan)); })("keyup.enter", function PlanQuoteButtonComponent_button_4_Template_button_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.onRemovePlanFromQuoteGroup(ctx_r9.plan)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate2("title", "", ctx_r3.plan == null ? null : ctx_r3.plan.planName, ": ", ctx_r3.removeFromQuoteButtonText, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0$2w, ctx_r3.newPlanCardDesignEnabled));
    i0.ɵɵattribute("aria-label", (ctx_r3.plan == null ? null : ctx_r3.plan.planName) + ": " + ctx_r3.addToQuoteButtonText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.removeFromQuoteButtonText, " ");
} }
const _c1$1g = function (a0) { return { "col-12": a0 }; };
class PlanQuoteButtonComponent {
    constructor(analyticsService, planFacade) {
        this.analyticsService = analyticsService;
        this.planFacade = planFacade;
        this.newPlanCardDesignEnabled = false;
        this.addToQuote = new EventEmitter();
        this.removePlanFromQuoteGroup = new EventEmitter();
    }
    addPlanToQuote(plan, addToQuoteTooltip) {
        this.planFacade.tagsToUpdate(DataLayerEvent.CLICK_PLANS_ADD_TO_QUOTE, plan.id, plan.planTypeAbbreviation, null, this.planFacade.isVbcAgreementExists(plan));
        this.addToQuote.emit({ plan, addToQuoteTooltip });
    }
    onRemovePlanFromQuoteGroup(plan) {
        this.removePlanFromQuoteGroup.emit({ selectedQuoteGroup: this.selectedQuoteGroup, plan });
    }
}
PlanQuoteButtonComponent.ɵfac = function PlanQuoteButtonComponent_Factory(t) { return new (t || PlanQuoteButtonComponent)(i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(PlanFacade)); };
PlanQuoteButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanQuoteButtonComponent, selectors: [["vnext-widget-plan-quote-button"]], inputs: { newPlanCardDesignEnabled: "newPlanCardDesignEnabled", plan: "plan", addToQuoteButtonText: "addToQuoteButtonText", removeFromQuoteButtonText: "removeFromQuoteButtonText", addToQuoteWarningTooltip: "addToQuoteWarningTooltip", selectedQuoteGroup: "selectedQuoteGroup", isPlanAddedToQuote: "isPlanAddedToQuote" }, outputs: { addToQuote: "addToQuote", removePlanFromQuoteGroup: "removePlanFromQuoteGroup" }, decls: 5, vars: 5, consts: [[3, "ngClass"], ["class", "btn btn-block mt-2 mt-sm-0 text-center Spa_Style_SecondaryButton", "placement", "top-left left-top", "tooltipClass", "add-to-quote-warning-tooltip", "triggers", "manual", 3, "ngClass", "ngbTooltip", "title", "click", 4, "ngIf"], ["addToQuoteTooltipContent", ""], ["class", "btn btn-block mt-2 mt-sm-0 text-center Spa_Style_SecondaryButton", "placement", "top-left left-top", "triggers", "manual", 3, "ngClass", "title", "click", "keyup.enter", 4, "ngIf"], ["placement", "top-left left-top", "tooltipClass", "add-to-quote-warning-tooltip", "triggers", "manual", 1, "btn", "btn-block", "mt-2", "mt-sm-0", "text-center", "Spa_Style_SecondaryButton", 3, "ngClass", "ngbTooltip", "title", "click"], ["addToQuoteTooltip", "ngbTooltip"], ["navigationAdapter", "", 3, "innerHtml"], ["placement", "top-left left-top", "triggers", "manual", 1, "btn", "btn-block", "mt-2", "mt-sm-0", "text-center", "Spa_Style_SecondaryButton", 3, "ngClass", "title", "click", "keyup.enter"]], template: function PlanQuoteButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, PlanQuoteButtonComponent_button_1_Template, 3, 8, "button", 1);
        i0.ɵɵtemplate(2, PlanQuoteButtonComponent_ng_template_2_Template, 2, 4, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(4, PlanQuoteButtonComponent_button_4_Template, 2, 7, "button", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1$1g, !ctx.newPlanCardDesignEnabled));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isPlanAddedToQuote);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isPlanAddedToQuote);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, NavigationAdapterDirective, i1$1.NgbTooltip, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanQuoteButtonComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-quote-button', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div [ngClass]=\"{ 'col-12': !newPlanCardDesignEnabled }\">\r\n  <button\r\n    *ngIf=\"!isPlanAddedToQuote\"\r\n    class=\"btn btn-block mt-2 mt-sm-0 text-center Spa_Style_SecondaryButton\"\r\n    [ngClass]=\"{ 'mb-3': newPlanCardDesignEnabled }\"\r\n    [ngbTooltip]=\"addToQuoteTooltipContent\"\r\n    #addToQuoteTooltip=\"ngbTooltip\"\r\n    placement=\"top-left left-top\"\r\n    tooltipClass=\"add-to-quote-warning-tooltip\"\r\n    (click)=\"addPlanToQuote(plan, addToQuoteTooltip)\"\r\n    triggers=\"manual\"\r\n    title=\"{{ plan?.planName }}: {{ addToQuoteButtonText }}\"\r\n    [attr.aria-label]=\"plan?.planName + ': ' + addToQuoteButtonText\"\r\n  >\r\n    {{ addToQuoteButtonText }}\r\n  </button>\r\n  <ng-template #addToQuoteTooltipContent>\r\n    <div [innerHtml]=\"addToQuoteWarningTooltip.body | safe : 'html'\" navigationAdapter></div>\r\n  </ng-template>\r\n  <button\r\n    *ngIf=\"isPlanAddedToQuote\"\r\n    class=\"btn btn-block mt-2 mt-sm-0 text-center Spa_Style_SecondaryButton\"\r\n    [ngClass]=\"{ 'mb-3': newPlanCardDesignEnabled }\"\r\n    placement=\"top-left left-top\"\r\n    (click)=\"onRemovePlanFromQuoteGroup(plan)\"\r\n    (keyup.enter)=\"onRemovePlanFromQuoteGroup(plan)\"\r\n    triggers=\"manual\"\r\n    title=\"{{ plan?.planName }}: {{ removeFromQuoteButtonText }}\"\r\n    [attr.aria-label]=\"plan?.planName + ': ' + addToQuoteButtonText\"\r\n  >\r\n    {{ removeFromQuoteButtonText }}\r\n  </button>\r\n</div>\r\n" }]
    }], function () { return [{ type: AnalyticsService }, { type: PlanFacade }]; }, { newPlanCardDesignEnabled: [{
            type: Input
        }], plan: [{
            type: Input
        }], addToQuoteButtonText: [{
            type: Input
        }], removeFromQuoteButtonText: [{
            type: Input
        }], addToQuoteWarningTooltip: [{
            type: Input
        }], selectedQuoteGroup: [{
            type: Input
        }], isPlanAddedToQuote: [{
            type: Input
        }], addToQuote: [{
            type: Output
        }], removePlanFromQuoteGroup: [{
            type: Output
        }] }); })();

function PlanSNPIndicatorComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngbTooltip", (ctx_r0.toolTipText == null ? null : ctx_r0.toolTipText.length) ? _r1 : null)("ngClass", (ctx_r0.toolTipText == null ? null : ctx_r0.toolTipText.length) ? "text-underline can-click" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.indicatorText, " ");
} }
function PlanSNPIndicatorComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r2.toolTipText, "html"), i0.ɵɵsanitizeHtml);
} }
const _c0$2v = function (a0) { return { "ml-n1": a0 }; };
class PlanSNPIndicatorComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.newPlanCardDesignEnabled = false;
        this.CSNPEnabled = true;
        this.DSNPEnabled = true;
        this.DSNPCodes = [];
        this.ISNPEnabled = true;
        this.CSNPText = '';
        this.CSNPLabel = 'CSNP';
        this.DSNPText = '';
        this.DSNPLabel = 'DSNP';
        this.ISNPText = '';
        this.ISNPLabel = 'ISNP';
        this.SNPText = '<snpType> Plan';
        this.showIndicator = false;
        this.toolTipText = '';
        this.indicatorText = '';
    }
    ngOnChanges(changes) {
        this.updateIndicator();
    }
    updateIndicator() {
        if (this.SNPType === SNPBaseType.dSNP) {
            this.showIndicator = this.DSNPEnabled;
            this.indicatorText = this.SNPText.replace('<snpType>', this.DSNPLabel);
            if (this.DSNPCodes?.length) {
                this.toolTipText = '';
                this.indicatorText += ': ' + this.DSNPCodes;
            }
            else {
                this.toolTipText = this.DSNPText; // TODO: this is never pushed down?
            }
        }
        else if (this.SNPType === SNPBaseType.iSNP) {
            this.showIndicator = this.ISNPEnabled;
            this.toolTipText = this.ISNPText;
            this.indicatorText = this.SNPText.replace('<snpType>', this.ISNPLabel);
        }
        else if (this.SNPType === SNPBaseType.cSNP) {
            this.showIndicator = this.CSNPEnabled;
            this.toolTipText = this.CSNPText;
            this.indicatorText = this.SNPText.replace('<snpType>', this.CSNPLabel);
        }
        else {
            this.showIndicator = false;
        }
        this.cdr.markForCheck();
    }
}
PlanSNPIndicatorComponent.ɵfac = function PlanSNPIndicatorComponent_Factory(t) { return new (t || PlanSNPIndicatorComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
PlanSNPIndicatorComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanSNPIndicatorComponent, selectors: [["vnext-plan-SNP-Indicator"]], inputs: { newPlanCardDesignEnabled: "newPlanCardDesignEnabled", SNPType: "SNPType", CSNPEnabled: "CSNPEnabled", DSNPEnabled: "DSNPEnabled", DSNPCodes: "DSNPCodes", ISNPEnabled: "ISNPEnabled", CSNPText: "CSNPText", CSNPLabel: "CSNPLabel", DSNPText: "DSNPText", DSNPLabel: "DSNPLabel", ISNPText: "ISNPText", ISNPLabel: "ISNPLabel", SNPText: "SNPText" }, features: [i0.ɵɵNgOnChangesFeature], decls: 4, vars: 4, consts: [[3, "ngClass"], ["tabindex", "0", "class", "Spa_Style_Note p-1", "tooltipClass", "snp-indicator-tooltip", 3, "ngbTooltip", "ngClass", 4, "ngIf"], ["SNPIndicatorToolTip", ""], ["tabindex", "0", "tooltipClass", "snp-indicator-tooltip", 1, "Spa_Style_Note", "p-1", 3, "ngbTooltip", "ngClass"], [1, "Spa_Style_ToolTip", 3, "innerHtml"]], template: function PlanSNPIndicatorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, PlanSNPIndicatorComponent_span_1_Template, 2, 3, "span", 1);
        i0.ɵɵtemplate(2, PlanSNPIndicatorComponent_ng_template_2_Template, 2, 4, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$2v, ctx.newPlanCardDesignEnabled));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showIndicator);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$1.NgbTooltip, SafePipe], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanSNPIndicatorComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-SNP-Indicator', template: "<div [ngClass]=\"{ 'ml-n1': newPlanCardDesignEnabled }\">\r\n  <span\r\n    *ngIf=\"showIndicator\"\r\n    tabindex=\"0\"\r\n    class=\"Spa_Style_Note p-1\"\r\n    [ngbTooltip]=\"toolTipText?.length ? SNPIndicatorToolTip : null\"\r\n    tooltipClass=\"snp-indicator-tooltip\"\r\n    [ngClass]=\"toolTipText?.length ? 'text-underline can-click' : ''\"\r\n  >\r\n    {{ indicatorText }}\r\n  </span>\r\n  <ng-template #SNPIndicatorToolTip>\r\n    <div [innerHtml]=\"toolTipText | safe : 'html'\" class=\"Spa_Style_ToolTip\"></div>\r\n  </ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { newPlanCardDesignEnabled: [{
            type: Input
        }], SNPType: [{
            type: Input
        }], CSNPEnabled: [{
            type: Input
        }], DSNPEnabled: [{
            type: Input
        }], DSNPCodes: [{
            type: Input
        }], ISNPEnabled: [{
            type: Input
        }], CSNPText: [{
            type: Input
        }], CSNPLabel: [{
            type: Input
        }], DSNPText: [{
            type: Input
        }], DSNPLabel: [{
            type: Input
        }], ISNPText: [{
            type: Input
        }], ISNPLabel: [{
            type: Input
        }], SNPText: [{
            type: Input
        }] }); })();

function PlanRatingMethodComponent_div_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "h4");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.ratingMethodText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.toolTipText);
} }
function PlanRatingMethodComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "button", 6, 7)(3, "span", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(2);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngbTooltip", _r1);
    i0.ɵɵattribute("aria-label", ctx_r3.wcagRatingMethodText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.ratingMethodText);
} }
function PlanRatingMethodComponent_div_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r5.ratingMethodText);
} }
function PlanRatingMethodComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PlanRatingMethodComponent_div_0_ng_template_1_Template, 5, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(3, PlanRatingMethodComponent_div_0_div_3_Template, 5, 3, "div", 2);
    i0.ɵɵtemplate(4, PlanRatingMethodComponent_div_0_ng_template_4_Template, 2, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r4 = i0.ɵɵreference(5);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.toolTipText)("ngIfElse", _r4);
} }
class PlanRatingMethodComponent {
    constructor() {
        this.planExtraData = [];
    }
    ngOnChanges(changes) {
        this.updateTooltipText();
    }
    updateTooltipText() {
        this.ratingMethod = this.planExtraData?.find(planExtraData => planExtraData.name === PlanExtraDataKey.RATING_METHOD);
        if (!this.ratingMethod) {
            return;
        }
        this.ratingMethodText = this.ratingMethod.value;
        switch (this.ratingMethod.value) {
            case MedSupPlanRatingMethod.ATTAINED_AGE:
                this.toolTipText = this.Spa_RatingMethod_AttainedAge_Tooltip_Text;
                break;
            case MedSupPlanRatingMethod.ISSUE_AGE:
                this.toolTipText = this.Spa_RatingMethod_IssueAge_Tooltip_Text;
                break;
            case MedSupPlanRatingMethod.COMMUNITY_RATED:
                this.toolTipText = this.Spa_RatingMethod_CommunityRated_Tooltip_Text;
                break;
        }
        this.wcagRatingMethodText = `${this.ratingMethodText} ${this.Spa_Site_Tooltip_Text} ${this.toolTipText}`;
    }
}
PlanRatingMethodComponent.ɵfac = function PlanRatingMethodComponent_Factory(t) { return new (t || PlanRatingMethodComponent)(); };
PlanRatingMethodComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanRatingMethodComponent, selectors: [["vnext-plan-rating-method"]], inputs: { planExtraData: "planExtraData", Spa_RatingMethod_AttainedAge_Tooltip_Text: "Spa_RatingMethod_AttainedAge_Tooltip_Text", Spa_RatingMethod_IssueAge_Tooltip_Text: "Spa_RatingMethod_IssueAge_Tooltip_Text", Spa_RatingMethod_CommunityRated_Tooltip_Text: "Spa_RatingMethod_CommunityRated_Tooltip_Text", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["myTooltip", ""], ["class", "d-inline w-auto", 4, "ngIf", "ngIfElse"], ["hideTooltip", ""], [1, "Spa_Style_ToolTip"], [1, "d-inline", "w-auto"], ["tabindex", "0", "tooltipClass", "star-ratings-tooltip", "role", "tooltip", 1, "action-button", "plan_rating", "Spa_Style_Paragraph", 3, "ngbTooltip"], ["ratingMethodTooltip", "ngbTooltip"], [1, "Spa_Style_Smaller_Font", "underline", "whitespace-nowrap"], [1, "plan_rating", "Spa_Style_Paragraph", "Spa_Style_Smaller_Font", "whitespace-nowrap"]], template: function PlanRatingMethodComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanRatingMethodComponent_div_0_Template, 6, 2, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.ratingMethod);
    } }, dependencies: [i1$2.NgIf, i1$1.NgbTooltip], styles: [".underline[_ngcontent-%COMP%]{text-decoration:underline}.whitespace-nowrap[_ngcontent-%COMP%]{white-space:nowrap}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanRatingMethodComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-rating-method', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"ratingMethod\">\r\n  <ng-template #myTooltip>\r\n    <div class=\"Spa_Style_ToolTip\">\r\n      <h4>{{ ratingMethodText }}</h4>\r\n      <div>{{ toolTipText }}</div>\r\n    </div>\r\n  </ng-template>\r\n  <div class=\"d-inline w-auto\" *ngIf=\"toolTipText; else hideTooltip\">\r\n    <button\r\n      class=\"action-button plan_rating Spa_Style_Paragraph\"\r\n      tabindex=\"0\"\r\n      [ngbTooltip]=\"myTooltip\"\r\n      #ratingMethodTooltip=\"ngbTooltip\"\r\n      tooltipClass=\"star-ratings-tooltip\"\r\n      [attr.aria-label]=\"wcagRatingMethodText\"\r\n      role=\"tooltip\"\r\n    >\r\n      <span class=\"Spa_Style_Smaller_Font underline whitespace-nowrap\">{{ ratingMethodText }}</span>\r\n    </button>\r\n  </div>\r\n  <ng-template #hideTooltip>\r\n      <span class=\"plan_rating Spa_Style_Paragraph Spa_Style_Smaller_Font whitespace-nowrap\">{{ ratingMethodText }}</span>\r\n  </ng-template>\r\n</div>\r\n", styles: [".underline{text-decoration:underline}.whitespace-nowrap{white-space:nowrap}\n"] }]
    }], null, { planExtraData: [{
            type: Input
        }], Spa_RatingMethod_AttainedAge_Tooltip_Text: [{
            type: Input
        }], Spa_RatingMethod_IssueAge_Tooltip_Text: [{
            type: Input
        }], Spa_RatingMethod_CommunityRated_Tooltip_Text: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }] }); })();

class PlanLogoComponent {
}
PlanLogoComponent.ɵfac = function PlanLogoComponent_Factory(t) { return new (t || PlanLogoComponent)(); };
PlanLogoComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanLogoComponent, selectors: [["vnext-plan-logo"]], inputs: { classNames: "classNames", imageSrc: "imageSrc", alternateText: "alternateText", planLogoSize: "planLogoSize" }, decls: 1, vars: 6, consts: [[3, "alt", "src", "ngClass"]], template: function PlanLogoComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "img", 0);
    } if (rf & 2) {
        i0.ɵɵclassMap(ctx.classNames);
        i0.ɵɵpropertyInterpolate("alt", ctx.alternateText);
        i0.ɵɵpropertyInterpolate("src", ctx.imageSrc, i0.ɵɵsanitizeUrl);
        i0.ɵɵproperty("ngClass", ctx.planLogoSize === "medium" ? "logo-dimension" : "generic-logo-dimension");
    } }, dependencies: [i1$2.NgClass], styles: [".logo[_ngcontent-%COMP%]{margin-bottom:20px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanLogoComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-logo', changeDetection: ChangeDetectionStrategy.OnPush, template: "<img\r\n  alt=\"{{ alternateText }}\"\r\n  src=\"{{ imageSrc }}\"\r\n  class=\"{{ classNames }}\"\r\n  [ngClass]=\"planLogoSize === 'medium' ? 'logo-dimension' : 'generic-logo-dimension'\"\r\n/>\r\n", styles: [".logo{margin-bottom:20px}\n"] }]
    }], null, { classNames: [{
            type: Input
        }], imageSrc: [{
            type: Input
        }], alternateText: [{
            type: Input
        }], planLogoSize: [{
            type: Input
        }] }); })();

function NextgenPlanCardComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵelement(2, "vnext-widget-plan-card-label", 4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("plan", ctx_r0.plan)("customClass", ctx_r0.customClass)("currentPlanText", ctx_r0.currentPlanText)("nextYearPlanText", ctx_r0.nextYearPlanText)("notLicensedPlanText", ctx_r0.nonLicensedPlanText)("includeNonLicensedPlans", ctx_r0.includeNonLicensedPlans)("optionOneText", ctx_r0.optionOneText)("optionTwoText", ctx_r0.optionTwoText)("displayOptionLabels", ctx_r0.displayOptionLabels)("disableNextYearDisplay", ctx_r0.memberHasOptionsDefined && ctx_r0.displayOptionLabels)("nonCommissionableText", ctx_r0.nonCommissionableText)("isNonCommissionableFlagCheckEnabled", ctx_r0.isNonCommissionableFlagCheckEnabled);
} }
function NextgenPlanCardComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵelement(2, "vnext-widget-plan-card-best-match", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("customClass", ctx_r1.customClass)("plan", ctx_r1.plan)("bestMatchText", ctx_r1.bestMatchText)("bestMatchIcon", ctx_r1.bestMatchIcon)("bestMatchTooltip", ctx_r1.bestMatchTooltip);
} }
function NextgenPlanCardComponent_div_2_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27)(1, "div", 28);
    i0.ɵɵelement(2, "vnext-plan-logo", 29);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("alternateText", ctx_r3.altPlanImgText)("imageSrc", ctx_r3.planLogo)("classNames", "plan-logo")("planLogoSize", ctx_r3.planLogoSize);
} }
function NextgenPlanCardComponent_div_2_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelement(1, "vnext-plan-rating-method", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("planExtraData", ctx_r4.plan.extraData)("Spa_Site_Tooltip_Text", ctx_r4.Spa_Site_Tooltip_Text)("Spa_RatingMethod_AttainedAge_Tooltip_Text", ctx_r4.Spa_RatingMethod_AttainedAge_Tooltip_Text)("Spa_RatingMethod_IssueAge_Tooltip_Text", ctx_r4.Spa_RatingMethod_IssueAge_Tooltip_Text)("Spa_RatingMethod_CommunityRated_Tooltip_Text", ctx_r4.Spa_RatingMethod_CommunityRated_Tooltip_Text);
} }
function NextgenPlanCardComponent_div_2_ng_container_15_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-benefits", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("newPlanCardDesignEnabled", ctx_r18.newPlanCardDesignEnabled)("plan", ctx_r18.plan)("annualCost", ctx_r18.annualCost)("planBenefits", ctx_r18.planBenefits)("planBenefitNoValueLabel", ctx_r18.Spa_Site_NotApplicable_Text)("isNotLicensedToSell", ctx_r18.isNotLicensedToSell);
} }
function NextgenPlanCardComponent_div_2_ng_container_15_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-benefits", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("newPlanCardDesignEnabled", ctx_r19.newPlanCardDesignEnabled)("plan", ctx_r19.plan)("annualCost", ctx_r19.annualCost)("planBenefits", ctx_r19.planBenefits)("planBenefitNoValueLabel", ctx_r19.Spa_Site_NotApplicable_Text)("isNotLicensedToSell", ctx_r19.isNotLicensedToSell);
} }
function NextgenPlanCardComponent_div_2_ng_container_15_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-benefits", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("newPlanCardDesignEnabled", ctx_r20.newPlanCardDesignEnabled)("plan", ctx_r20.plan)("annualCost", ctx_r20.annualCost)("planBenefits", ctx_r20.planBenefits)("planBenefitNoValueLabel", ctx_r20.Spa_Site_NotApplicable_Text)("isNotLicensedToSell", ctx_r20.isNotLicensedToSell);
} }
function NextgenPlanCardComponent_div_2_ng_container_15_ng_container_5_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-benefits", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("newPlanCardDesignEnabled", ctx_r25.newPlanCardDesignEnabled)("plan", ctx_r25.plan)("annualCost", ctx_r25.annualCost)("planBenefits", ctx_r25.planBenefits)("planBenefitNoValueLabel", ctx_r25.Spa_Site_NotApplicable_Text)("isNotLicensedToSell", ctx_r25.isNotLicensedToSell);
} }
function NextgenPlanCardComponent_div_2_ng_container_15_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NextgenPlanCardComponent_div_2_ng_container_15_ng_container_5_div_1_Template, 2, 6, "div", 15);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.activeTabType === ctx_r21.planTypeAbbreviation.DENTAL);
} }
function NextgenPlanCardComponent_div_2_ng_container_15_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-benefits", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("newPlanCardDesignEnabled", ctx_r26.newPlanCardDesignEnabled)("plan", ctx_r26.plan)("annualCost", ctx_r26.annualCost)("planBenefits", ctx_r26.planBenefits)("planBenefitNoValueLabel", ctx_r26.Spa_Site_NotApplicable_Text)("isNotLicensedToSell", ctx_r26.isNotLicensedToSell);
} }
function NextgenPlanCardComponent_div_2_ng_container_15_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NextgenPlanCardComponent_div_2_ng_container_15_ng_container_6_div_1_Template, 2, 6, "div", 15);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r22.activeTabType === ctx_r22.planTypeAbbreviation.HC);
} }
function NextgenPlanCardComponent_div_2_ng_container_15_ng_container_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-benefits", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("newPlanCardDesignEnabled", ctx_r27.newPlanCardDesignEnabled)("plan", ctx_r27.plan)("annualCost", ctx_r27.annualCost)("planBenefits", ctx_r27.planBenefits)("planBenefitNoValueLabel", ctx_r27.Spa_Site_NotApplicable_Text)("isNotLicensedToSell", ctx_r27.isNotLicensedToSell);
} }
function NextgenPlanCardComponent_div_2_ng_container_15_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NextgenPlanCardComponent_div_2_ng_container_15_ng_container_7_div_1_Template, 2, 6, "div", 15);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r23.activeTabType === ctx_r23.planTypeAbbreviation.DENTAL);
} }
const _c0$2u = function (a0) { return { Spa_Style_Gray4_Color: a0 }; };
function NextgenPlanCardComponent_div_2_ng_container_15_ng_container_8_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36)(1, "div", 37);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 38);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$2u, ctx_r28.isNotLicensedToSell));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r28.Spa_PlanCard_PlanType_Text, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$2u, ctx_r28.isNotLicensedToSell));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r28.plan.planSubType, " ");
} }
function NextgenPlanCardComponent_div_2_ng_container_15_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NextgenPlanCardComponent_div_2_ng_container_15_ng_container_8_div_1_Template, 5, 8, "div", 35);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r24.planType.MEDIGAP);
} }
function NextgenPlanCardComponent_div_2_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵtemplate(2, NextgenPlanCardComponent_div_2_ng_container_15_div_2_Template, 2, 6, "div", 33);
    i0.ɵɵtemplate(3, NextgenPlanCardComponent_div_2_ng_container_15_div_3_Template, 2, 6, "div", 33);
    i0.ɵɵtemplate(4, NextgenPlanCardComponent_div_2_ng_container_15_div_4_Template, 2, 6, "div", 33);
    i0.ɵɵtemplate(5, NextgenPlanCardComponent_div_2_ng_container_15_ng_container_5_Template, 2, 1, "ng-container", 33);
    i0.ɵɵtemplate(6, NextgenPlanCardComponent_div_2_ng_container_15_ng_container_6_Template, 2, 1, "ng-container", 33);
    i0.ɵɵtemplate(7, NextgenPlanCardComponent_div_2_ng_container_15_ng_container_7_Template, 2, 1, "ng-container", 33);
    i0.ɵɵtemplate(8, NextgenPlanCardComponent_div_2_ng_container_15_ng_container_8_Template, 2, 1, "ng-container", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r5.plan.planType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r5.planType.MAPD);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r5.planType.MA);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r5.planType.PDP);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r5.planType.DENTAL);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r5.planType.HC);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r5.planType.VISION);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.Spa_Site_MedigapPlanType_Enabled);
} }
function NextgenPlanCardComponent_div_2_ng_container_16_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 44);
    i0.ɵɵelementStart(3, "span", 45);
    i0.ɵɵtext(4, "Collapse");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r29.preferencesText, "");
} }
function NextgenPlanCardComponent_div_2_ng_container_16_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵelement(1, "i", 46);
    i0.ɵɵelementStart(2, "span", 45);
    i0.ɵɵtext(3, "Expand");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r31.preferencesText, "");
} }
function NextgenPlanCardComponent_div_2_ng_container_16_div_8_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-coverage-preferences", 47);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("newPlanCardDesignEnabled", ctx_r35.newPlanCardDesignEnabled)("pharmacyNotCoveredText", ctx_r35.Spa_PlanDetails_Non_Covered_Text)("plan", ctx_r35.plan)("prescriptionsText", ctx_r35.Spa_Site_Prescriptions_Text)("pharmacyText", ctx_r35.Spa_Site_Pharmacy_Text)("pharmacyCoveredText", ctx_r35.pharmacyCoverageText)("addedPharmacy", ctx_r35.selectedPharmacy)("drugCoverageText", ctx_r35.getDrugCoverageText(ctx_r35.drugCount, ctx_r35.plan))("showDrugCoverage", ctx_r35.showDrugCoverage(ctx_r35.drugCount))("planPreferences", ctx_r35.planPreferences)("totalEstimatedAnnualCostText", ctx_r35.Spa_PlanCard_TotalEstimatedAnnualCost_Text)("totalEstimatedCostText", ctx_r35.Spa_PlanCard_TotalEstimatedCost_Text)("totalEstimatedCostTooltip", ctx_r35.Spa_PlanCard_Total_Estimated_Cost_Tooltip)("isTotalEstimatedCostEnabled", ctx_r35.Spa_Site_TotalEstimatedCost_Enabled)("isEnabledShowDrugAlternatives", ctx_r35.Spa_Site_ShowDrugAlternatives_Enabled)("showNudgeDrugAlternatives", ctx_r35.Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled)("drugAlternativesTooltipText", ctx_r35.Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text)("nudgeDrugAlternativesLabelText", ctx_r35.Spa_PlanCard_ShowDrugAlternatives_Nudge_Text)("drugAlternativesIndicatorIcon", ctx_r35.Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon)("isRetention", ctx_r35.isRetentionView)("isQuoting", ctx_r35.isQuotingSite)("noCostAvailableText", ctx_r35.noCostAvailableText)("Spa_Site_Tooltip_Text", ctx_r35.Spa_Site_Tooltip_Text)("viewCostTooltipHeaderText", ctx_r35.viewCostTooltipHeaderText)("viewCostTooltipHeaderContent", ctx_r35.viewCostTooltipHeaderContent)("inNetworkPreferredText", ctx_r35.inNetworkPreferredText)("inNetworkStandardText", ctx_r35.inNetworkStandardText)("outOfNetworkText", ctx_r35.outOfNetworkText)("annualCost", ctx_r35.annualCost)("showMailOrderLabel", ctx_r35.isMailOrderSelected)("isMailOrderSelected", ctx_r35.isMailOrderSelected)("medicineCabinet", ctx_r35.medicineCabinet)("mailOrderText", ctx_r35.mailOrderText)("totalCostEffectiveDate", ctx_r35.totalCostEffectiveDate)("selectedProviders", ctx_r35.selectedProviders)("planCardPreferenceDetailedEnabled", ctx_r35.planCardPreferenceDetailedEnabled)("providerDetails", ctx_r35.providerDetails)("showProviderInNetworkOnOtherLocation", ctx_r35.planCardTile == null ? null : ctx_r35.planCardTile.showProviderInNetworkOnOtherLocation)("providersCoveredText", ctx_r35.planCardTile == null ? null : ctx_r35.planCardTile.providersCoveredText)("providerPcpText", ctx_r35.planCardTile == null ? null : ctx_r35.planCardTile.providerPcpText)("loaderIconEnabled", ctx_r35.loaderIconEnabled)("editLinkText", ctx_r35.editLinkText)("providerOneOrMoreOutOfNetworkText", ctx_r35.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r35.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r35.providerShowPartialIndicatorEnabled)("viewProvidersButtonText", ctx_r35.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r35.viewPrescriptionsButtonText)("isVbcAgreementEnabled", ctx_r35.isVbcAgreementEnabled)("vbcAgreementLabel", ctx_r35.vbcAgreementLabel)("vbcAgreementTooltip", ctx_r35.vbcAgreementTooltip);
} }
function NextgenPlanCardComponent_div_2_ng_container_16_div_8_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-card-supplemental-benefits", 48);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("newPlanCardDesignEnabled", ctx_r36.newPlanCardDesignEnabled)("supplementalBenefits", ctx_r36.Spa_PlanCard_SupplementalBenefits_List)("planBenefits", ctx_r36.plan.planDataFields)("hideLinkText", ctx_r36.hideLinkText)("viewAllLinkText", ctx_r36.viewAllLinkText)("isMobile", ctx_r36.isMobile)("availableText", ctx_r36.availableText)("unavailableText", ctx_r36.unavailableText)("supplementalBenefitsHighlightText", ctx_r36.supplementalBenefitsHighlightText);
} }
function NextgenPlanCardComponent_div_2_ng_container_16_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, NextgenPlanCardComponent_div_2_ng_container_16_div_8_div_1_Template, 2, 50, "div", 15);
    i0.ɵɵtemplate(2, NextgenPlanCardComponent_div_2_ng_container_16_div_8_div_2_Template, 2, 9, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r32.showPreferences || !ctx_r32.isMobile);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r32.Spa_PlanCard_SupplementalBenefits_Enabled);
} }
function NextgenPlanCardComponent_div_2_ng_container_16_div_9_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-coverage-preferences", 49);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("newPlanCardDesignEnabled", ctx_r37.newPlanCardDesignEnabled)("pharmacyNotCoveredText", ctx_r37.Spa_PlanDetails_Non_Covered_Text)("plan", ctx_r37.plan)("prescriptionsText", ctx_r37.Spa_Site_Prescriptions_Text)("pharmacyText", ctx_r37.Spa_Site_Pharmacy_Text)("pharmacyCoveredText", ctx_r37.pharmacyCoverageText)("addedPharmacy", ctx_r37.selectedPharmacy)("drugCoverageText", ctx_r37.getDrugCoverageText(ctx_r37.drugCount, ctx_r37.plan))("showDrugCoverage", ctx_r37.showDrugCoverage(ctx_r37.drugCount))("planPreferences", ctx_r37.planPreferences)("totalEstimatedAnnualCostText", ctx_r37.Spa_PlanCard_TotalEstimatedAnnualCost_Text)("totalEstimatedCostText", ctx_r37.Spa_PlanCard_TotalEstimatedCost_Text)("totalEstimatedCostTooltip", ctx_r37.Spa_PlanCard_Total_Estimated_Cost_Tooltip)("isTotalEstimatedCostEnabled", ctx_r37.Spa_Site_TotalEstimatedCost_Enabled)("isEnabledShowDrugAlternatives", ctx_r37.Spa_Site_ShowDrugAlternatives_Enabled)("showNudgeDrugAlternatives", ctx_r37.Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled)("drugAlternativesTooltipText", ctx_r37.Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text)("nudgeDrugAlternativesLabelText", ctx_r37.Spa_PlanCard_ShowDrugAlternatives_Nudge_Text)("drugAlternativesIndicatorIcon", ctx_r37.Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon)("isRetention", ctx_r37.isRetentionView)("isQuoting", ctx_r37.isQuotingSite)("noCostAvailableText", ctx_r37.noCostAvailableText)("Spa_Site_Tooltip_Text", ctx_r37.Spa_Site_Tooltip_Text)("inNetworkPreferredText", ctx_r37.inNetworkPreferredText)("inNetworkStandardText", ctx_r37.inNetworkStandardText)("outOfNetworkText", ctx_r37.outOfNetworkText)("annualCost", ctx_r37.annualCost)("medicineCabinet", ctx_r37.medicineCabinet)("totalCostEffectiveDate", ctx_r37.totalCostEffectiveDate)("selectedProviders", ctx_r37.selectedProviders)("planCardPreferenceDetailedEnabled", ctx_r37.planCardPreferenceDetailedEnabled)("providerDetails", ctx_r37.providerDetails)("showProviderInNetworkOnOtherLocation", ctx_r37.planCardTile == null ? null : ctx_r37.planCardTile.showProviderInNetworkOnOtherLocation)("providersCoveredText", ctx_r37.planCardTile == null ? null : ctx_r37.planCardTile.providersCoveredText)("providerPcpText", ctx_r37.planCardTile == null ? null : ctx_r37.planCardTile.providerPcpText)("loaderIconEnabled", ctx_r37.loaderIconEnabled)("editLinkText", ctx_r37.editLinkText)("providerOneOrMoreOutOfNetworkText", ctx_r37.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r37.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r37.providerShowPartialIndicatorEnabled)("viewProvidersButtonText", ctx_r37.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r37.viewPrescriptionsButtonText)("isVbcAgreementEnabled", ctx_r37.isVbcAgreementEnabled)("vbcAgreementLabel", ctx_r37.vbcAgreementLabel)("vbcAgreementTooltip", ctx_r37.vbcAgreementTooltip);
} }
function NextgenPlanCardComponent_div_2_ng_container_16_div_9_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-card-supplemental-benefits", 48);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("newPlanCardDesignEnabled", ctx_r38.newPlanCardDesignEnabled)("supplementalBenefits", ctx_r38.Spa_PlanCard_SupplementalBenefits_List)("planBenefits", ctx_r38.plan.planDataFields)("hideLinkText", ctx_r38.hideLinkText)("viewAllLinkText", ctx_r38.viewAllLinkText)("isMobile", ctx_r38.isMobile)("availableText", ctx_r38.availableText)("unavailableText", ctx_r38.unavailableText)("supplementalBenefitsHighlightText", ctx_r38.supplementalBenefitsHighlightText);
} }
function NextgenPlanCardComponent_div_2_ng_container_16_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, NextgenPlanCardComponent_div_2_ng_container_16_div_9_div_1_Template, 2, 45, "div", 15);
    i0.ɵɵtemplate(2, NextgenPlanCardComponent_div_2_ng_container_16_div_9_div_2_Template, 2, 9, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r33.showPreferences || !ctx_r33.isMobile);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r33.Spa_PlanCard_SupplementalBenefits_Enabled);
} }
function NextgenPlanCardComponent_div_2_ng_container_16_div_10_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-coverage-preferences", 50);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("newPlanCardDesignEnabled", ctx_r39.newPlanCardDesignEnabled)("pharmacyNotCoveredText", ctx_r39.Spa_PlanDetails_Non_Covered_Text)("plan", ctx_r39.plan)("prescriptionsText", ctx_r39.Spa_Site_Prescriptions_Text)("pharmacyText", ctx_r39.Spa_Site_Pharmacy_Text)("pharmacyCoveredText", ctx_r39.pharmacyCoverageText)("addedPharmacy", ctx_r39.selectedPharmacy)("drugCoverageText", ctx_r39.getDrugCoverageText(ctx_r39.drugCount, ctx_r39.plan))("showDrugCoverage", ctx_r39.showDrugCoverage(ctx_r39.drugCount))("planPreferences", ctx_r39.planPreferences)("totalEstimatedAnnualCostText", ctx_r39.Spa_PlanCard_TotalEstimatedAnnualCost_Text)("totalEstimatedCostText", ctx_r39.Spa_PlanCard_TotalEstimatedCost_Text)("totalEstimatedCostTooltip", ctx_r39.Spa_PlanCard_Total_Estimated_Cost_Tooltip)("isTotalEstimatedCostEnabled", ctx_r39.Spa_Site_TotalEstimatedCost_Enabled)("isEnabledShowDrugAlternatives", ctx_r39.Spa_Site_ShowDrugAlternatives_Enabled)("showNudgeDrugAlternatives", ctx_r39.Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled)("drugAlternativesTooltipText", ctx_r39.Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text)("nudgeDrugAlternativesLabelText", ctx_r39.Spa_PlanCard_ShowDrugAlternatives_Nudge_Text)("drugAlternativesIndicatorIcon", ctx_r39.Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon)("isRetention", ctx_r39.isRetentionView)("isQuoting", ctx_r39.isQuotingSite)("noCostAvailableText", ctx_r39.noCostAvailableText)("Spa_Site_Tooltip_Text", ctx_r39.Spa_Site_Tooltip_Text)("viewCostTooltipHeaderText", ctx_r39.viewCostTooltipHeaderText)("viewCostTooltipHeaderContent", ctx_r39.viewCostTooltipHeaderContent)("inNetworkPreferredText", ctx_r39.inNetworkPreferredText)("inNetworkStandardText", ctx_r39.inNetworkStandardText)("outOfNetworkText", ctx_r39.outOfNetworkText)("annualCost", ctx_r39.annualCost)("showMailOrderLabel", ctx_r39.isMailOrderSelected)("isMailOrderSelected", ctx_r39.isMailOrderSelected)("medicineCabinet", ctx_r39.medicineCabinet)("mailOrderText", ctx_r39.mailOrderText)("totalCostEffectiveDate", ctx_r39.totalCostEffectiveDate)("selectedProviders", ctx_r39.selectedProviders)("planCardPreferenceDetailedEnabled", ctx_r39.planCardPreferenceDetailedEnabled)("providerDetails", ctx_r39.providerDetails)("loaderIconEnabled", ctx_r39.loaderIconEnabled)("editLinkText", ctx_r39.editLinkText)("providerOneOrMoreOutOfNetworkText", ctx_r39.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r39.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r39.providerShowPartialIndicatorEnabled)("viewProvidersButtonText", ctx_r39.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r39.viewPrescriptionsButtonText)("isVbcAgreementEnabled", ctx_r39.isVbcAgreementEnabled)("vbcAgreementLabel", ctx_r39.vbcAgreementLabel)("vbcAgreementTooltip", ctx_r39.vbcAgreementTooltip);
} }
function NextgenPlanCardComponent_div_2_ng_container_16_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, NextgenPlanCardComponent_div_2_ng_container_16_div_10_div_1_Template, 2, 47, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r34.showPreferences || !ctx_r34.isMobile);
} }
function NextgenPlanCardComponent_div_2_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 39)(2, "vnext-link", 40);
    i0.ɵɵlistener("click", function NextgenPlanCardComponent_div_2_ng_container_16_Template_vnext_link_click_2_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r40.toggleViewAll()); })("keyup.enter", function NextgenPlanCardComponent_div_2_ng_container_16_Template_vnext_link_keyup_enter_2_listener() { i0.ɵɵrestoreView(_r41); const ctx_r42 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r42.toggleViewAll()); });
    i0.ɵɵelementStart(3, "div", 41);
    i0.ɵɵtemplate(4, NextgenPlanCardComponent_div_2_ng_container_16_ng_container_4_Template, 5, 1, "ng-container", 16);
    i0.ɵɵtemplate(5, NextgenPlanCardComponent_div_2_ng_container_16_ng_template_5_Template, 4, 1, "ng-template", null, 42, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 43);
    i0.ɵɵtemplate(8, NextgenPlanCardComponent_div_2_ng_container_16_div_8_Template, 3, 2, "div", 33);
    i0.ɵɵtemplate(9, NextgenPlanCardComponent_div_2_ng_container_16_div_9_Template, 3, 2, "div", 33);
    i0.ɵɵtemplate(10, NextgenPlanCardComponent_div_2_ng_container_16_div_10_Template, 2, 1, "div", 33);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r30 = i0.ɵɵreference(6);
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("role", ctx_r6.linkRoles.BUTTON)("customClass", "Spa_Style_Link Spa_Style_Regular_Font Spa_Style_Semi_Bold_Weight mb-4 d-block d-sm-none");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r6.showPreferences)("ngIfElse", _r30);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngSwitch", ctx_r6.plan.planType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.planType.MAPD);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.planType.MA);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.planType.PDP);
} }
function NextgenPlanCardComponent_div_2_ng_template_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 2)(2, "div", 51);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.nonLicensedMessageText, " ");
} }
function NextgenPlanCardComponent_div_2_ng_container_21_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 58);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r45.compareWarningTooltip, "html"), i0.ɵɵsanitizeHtml);
} }
function NextgenPlanCardComponent_div_2_ng_container_21_ng_container_7_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r49.Spa_PlanCard_AddToCompare_Text);
} }
function NextgenPlanCardComponent_div_2_ng_container_21_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NextgenPlanCardComponent_div_2_ng_container_21_ng_container_7_span_1_Template, 2, 1, "span", 59);
    i0.ɵɵelementStart(2, "span", 60);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_PlanCard_AddToCompare_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r46.plan.planName);
} }
function NextgenPlanCardComponent_div_2_ng_container_21_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 61);
    i0.ɵɵlistener("keyup.enter", function NextgenPlanCardComponent_div_2_ng_container_21_ng_template_8_Template_vnext_link_keyup_enter_0_listener($event) { i0.ɵɵrestoreView(_r51); const ctx_r50 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r50.comparePlans($event, ctx_r50.plan)); })("click", function NextgenPlanCardComponent_div_2_ng_container_21_ng_template_8_Template_vnext_link_click_0_listener($event) { i0.ɵɵrestoreView(_r51); const ctx_r52 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r52.comparePlans($event, ctx_r52.plan)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("title", ctx_r48.Spa_PlanCard_CompareNow_Text)("makeInlineBlock", true)("alwaysUnderlined", true);
} }
function NextgenPlanCardComponent_div_2_ng_container_21_Template(rf, ctx) { if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 52)(2, "label", 53)(3, "input", 54, 55);
    i0.ɵɵlistener("change", function NextgenPlanCardComponent_div_2_ng_container_21_Template_input_change_3_listener($event) { i0.ɵɵrestoreView(_r54); const _r43 = i0.ɵɵreference(4); const ctx_r53 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r53.updatePlanToCompareGroup(ctx_r53.plan, $event, _r43)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, NextgenPlanCardComponent_div_2_ng_container_21_ng_template_5_Template, 2, 4, "ng-template", null, 56, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(7, NextgenPlanCardComponent_div_2_ng_container_21_ng_container_7_Template, 4, 2, "ng-container", 16);
    i0.ɵɵtemplate(8, NextgenPlanCardComponent_div_2_ng_container_21_ng_template_8_Template, 1, 3, "ng-template", null, 57, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r44 = i0.ɵɵreference(6);
    const _r47 = i0.ɵɵreference(9);
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("for", "Compare_", ctx_r9.plan.id, "");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "Compare_", ctx_r9.plan.id, "");
    i0.ɵɵpropertyInterpolate("value", ctx_r9.plan.id);
    i0.ɵɵproperty("ngbTooltip", _r44)("checked", ctx_r9.isSelectedToCompare(ctx_r9.plan));
    i0.ɵɵattribute("aria-checked", ctx_r9.isSelectedToCompare(ctx_r9.plan))("aria-label", ctx_r9.isSelectedToCompare(ctx_r9.plan) ? ctx_r9.Spa_PlanCard_CompareNow_Text : ctx_r9.Spa_PlanCard_AddToCompare_Text + " " + ctx_r9.plan.planName);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r9.isSelectedToCompare(ctx_r9.plan))("ngIfElse", _r47);
} }
function NextgenPlanCardComponent_div_2_vnext_link_25_Template(rf, ctx) { if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 62);
    i0.ɵɵlistener("click", function NextgenPlanCardComponent_div_2_vnext_link_25_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r56); const ctx_r55 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r55.quoteClick()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r10.Spa_PlanCard_QuoteLinkName_Text);
} }
function NextgenPlanCardComponent_div_2_ng_template_26_ng_container_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r63 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r63.planPremiumInitialRange);
} }
function NextgenPlanCardComponent_div_2_ng_template_26_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NextgenPlanCardComponent_div_2_ng_template_26_ng_container_1_span_1_Template, 2, 1, "span", 15);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "customCurrency");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r57 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r57.snpPremiumRangeEnabled && ctx_r57.planPremiumInitialRange);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind4(3, 2, ctx_r57.planTotalPremium, "USD", "symbol", "1.2-2"), " ");
} }
function NextgenPlanCardComponent_div_2_ng_template_26_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r65 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-link", 66);
    i0.ɵɵlistener("click", function NextgenPlanCardComponent_div_2_ng_template_26_div_2_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r65); const ctx_r64 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r64.showSnpRangeModal()); })("keyup.enter", function NextgenPlanCardComponent_div_2_ng_template_26_div_2_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r65); const ctx_r66 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r66.showSnpRangeModal()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r58 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r58.snpRangeLinkText)("alwaysUnderlined", true);
} }
function NextgenPlanCardComponent_div_2_ng_template_26_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-plan-fees-tooltip", 67);
} if (rf & 2) {
    const ctx_r60 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("planFees", ctx_r60.plan.fees)("planTotalPremium", ctx_r60.planTotalPremium)("planFeesTooltipText", ctx_r60.planFeesTooltipText)("planFeesIncludedInPremiumTooltipText", ctx_r60.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r60.planFeesNotIncludedInPremiumTooltipText)("tooltipCustomClass", "inline-block-sm-layout");
} }
function NextgenPlanCardComponent_div_2_ng_template_26_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 68);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r61 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r61.monthlyPremiumText);
} }
function NextgenPlanCardComponent_div_2_ng_template_26_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 70);
    i0.ɵɵelement(1, "i", 71);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r67 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$2u, ctx_r67.isNotLicensedToSell));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r67.nonMonthlyRateText.replace("<paymentMethod>", ctx_r67.medSupPaymentMethodDisplayText[ctx_r67.medSupPaymentMethod]), " ");
} }
function NextgenPlanCardComponent_div_2_ng_template_26_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NextgenPlanCardComponent_div_2_ng_template_26_ng_container_6_div_1_Template, 3, 4, "div", 69);
    i0.ɵɵpipe(2, "rateFactorApplied");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r62 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r62.medSupPaymentMethod && ctx_r62.medSupPaymentMethod !== ctx_r62.medSupPaymentMethodEnum.MONTHLY && ctx_r62.nonMonthlyRateText && ctx_r62.medSupPaymentMethodDisplayText && !ctx_r62.Spa_Site_ShowPremiumAsAnnual && ctx_r62.showNonMonthlyRateText && ctx_r62.plan.rateFactors));
} }
function NextgenPlanCardComponent_div_2_ng_template_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 63);
    i0.ɵɵtemplate(1, NextgenPlanCardComponent_div_2_ng_template_26_ng_container_1_Template, 4, 7, "ng-container", 16);
    i0.ɵɵtemplate(2, NextgenPlanCardComponent_div_2_ng_template_26_div_2_Template, 2, 2, "div", 15);
    i0.ɵɵtemplate(3, NextgenPlanCardComponent_div_2_ng_template_26_ng_template_3_Template, 1, 6, "ng-template", null, 64, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, NextgenPlanCardComponent_div_2_ng_template_26_span_5_Template, 2, 1, "span", 65);
    i0.ɵɵtemplate(6, NextgenPlanCardComponent_div_2_ng_template_26_ng_container_6_Template, 3, 3, "ng-container", 15);
} if (rf & 2) {
    const _r59 = i0.ɵɵreference(4);
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$2u, ctx_r12.isNotLicensedToSell));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r12.planFeesEnabled || !(ctx_r12.plan.fees == null ? null : ctx_r12.plan.fees.length))("ngIfElse", _r59);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.snpPremiumRangeEnabled && ctx_r12.planPremiumInitialRange);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r12.isHospitalCare);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.plan.planType === ctx_r12.planType.MEDIGAP);
} }
function NextgenPlanCardComponent_div_2_vnext_shopping_cart_button_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-shopping-cart-button", 72);
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("plan", ctx_r13.plan)("newPlanCardDesignEnabled", true);
} }
const _c1$1f = function (a0) { return { "mt-2 btn1 mb-3": a0 }; };
function NextgenPlanCardComponent_div_2_ng_container_30_Template(rf, ctx) { if (rf & 1) {
    const _r69 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-widget-plan-quote-button", 73);
    i0.ɵɵlistener("addToQuote", function NextgenPlanCardComponent_div_2_ng_container_30_Template_vnext_widget_plan_quote_button_addToQuote_1_listener($event) { i0.ɵɵrestoreView(_r69); const ctx_r68 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r68.addPlanToHospitalIndemnityCompareGroup($event.plan, $event.addToQuoteTooltip)); })("removePlanFromQuoteGroup", function NextgenPlanCardComponent_div_2_ng_container_30_Template_vnext_widget_plan_quote_button_removePlanFromQuoteGroup_1_listener($event) { i0.ɵɵrestoreView(_r69); const ctx_r70 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r70.removePlanToHospitalIndemnityCompareGroup($event.selectedQuoteGroup, $event.plan)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c1$1f, ctx_r14.addToCartEnabled))("newPlanCardDesignEnabled", ctx_r14.newPlanCardDesignEnabled)("plan", ctx_r14.plan)("addToQuoteButtonText", ctx_r14.Spa_PlanCard_AddToQuote_Text)("removeFromQuoteButtonText", ctx_r14.Spa_PlanCard_RemoveFromQuote_Text)("addToQuoteWarningTooltip", ctx_r14.addToQuoteWarningTooltip)("selectedQuoteGroup", ctx_r14.selectedCompareGroup)("isPlanAddedToQuote", ctx_r14.isSelectedToCompare(ctx_r14.plan));
} }
const _c2$M = function (a0) { return { "mt-2 btn2 mb-3": a0 }; };
function NextgenPlanCardComponent_div_2_div_31_Template(rf, ctx) { if (rf & 1) {
    const _r72 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-widget-plan-quote-button", 73);
    i0.ɵɵlistener("addToQuote", function NextgenPlanCardComponent_div_2_div_31_Template_vnext_widget_plan_quote_button_addToQuote_1_listener($event) { i0.ɵɵrestoreView(_r72); const ctx_r71 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r71.addPlanToQuote($event.plan, $event.addToQuoteTooltip)); })("removePlanFromQuoteGroup", function NextgenPlanCardComponent_div_2_div_31_Template_vnext_widget_plan_quote_button_removePlanFromQuoteGroup_1_listener($event) { i0.ɵɵrestoreView(_r72); const ctx_r73 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r73.planFacade.removePlanFromQuoteGroup($event.selectedQuoteGroup, $event.plan)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c2$M, ctx_r15.addToCartEnabled))("newPlanCardDesignEnabled", ctx_r15.newPlanCardDesignEnabled)("plan", ctx_r15.plan)("addToQuoteButtonText", ctx_r15.Spa_PlanCard_AddToQuote_Text)("removeFromQuoteButtonText", ctx_r15.Spa_PlanCard_RemoveFromQuote_Text)("addToQuoteWarningTooltip", ctx_r15.Spa_PlanCard_AddToQuote_Warning_Tooltip)("selectedQuoteGroup", ctx_r15.selectedQuoteGroup)("isPlanAddedToQuote", ctx_r15.isPlanAddedToQuote(ctx_r15.plan));
} }
function NextgenPlanCardComponent_div_2_div_32_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 77);
    i0.ɵɵelementStart(3, "span", 45);
    i0.ɵɵtext(4, "Collapse");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r74 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r74.hideDetailsText);
} }
function NextgenPlanCardComponent_div_2_div_32_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵelement(1, "i", 78);
    i0.ɵɵelementStart(2, "span", 45);
    i0.ɵɵtext(3, "Expand");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r76 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate(ctx_r76.viewMoreDetailsText);
} }
function NextgenPlanCardComponent_div_2_div_32_Template(rf, ctx) { if (rf & 1) {
    const _r78 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 74)(1, "vnext-link", 75);
    i0.ɵɵlistener("click", function NextgenPlanCardComponent_div_2_div_32_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r78); const ctx_r77 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r77.showPlanDetailToggle()); })("keyup.enter", function NextgenPlanCardComponent_div_2_div_32_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r78); const ctx_r79 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r79.showPlanDetailToggle()); });
    i0.ɵɵelementStart(2, "div", 41);
    i0.ɵɵtemplate(3, NextgenPlanCardComponent_div_2_div_32_ng_container_3_Template, 5, 1, "ng-container", 16);
    i0.ɵɵtemplate(4, NextgenPlanCardComponent_div_2_div_32_ng_template_4_Template, 4, 1, "ng-template", null, 76, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const _r75 = i0.ɵɵreference(5);
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isLinkButton", true)("customClass", "btn-reset Spa_Style_Link Spa_Style_Regular_Font Spa_Style_Semi_Bold_Weight d-inline-block mt-4")("ariaLabel", ctx_r16.viewAllPlanDetailsAriaLabelText)("title", ctx_r16.viewAllPlanDetailsAriaLabelText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r16.showPlanDetailCard)("ngIfElse", _r75);
} }
const _c3$v = function (a0) { return { "d-none": a0 }; };
function NextgenPlanCardComponent_div_2_ng_container_33_Template(rf, ctx) { if (rf & 1) {
    const _r81 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-nextgen-plan-card-detail-expandable", 79);
    i0.ɵɵlistener("closeDetailCardClicked", function NextgenPlanCardComponent_div_2_ng_container_33_Template_vnext_nextgen_plan_card_detail_expandable_closeDetailCardClicked_1_listener() { i0.ɵɵrestoreView(_r81); const ctx_r80 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r80.showPlanDetailToggle(false)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(31, _c3$v, !ctx_r17.showPlanDetailCard))("plan", ctx_r17.plan)("newPlanCardDesignEnabled", ctx_r17.newPlanCardDesignEnabled)("isNotLicensedToSell", ctx_r17.isNotLicensedToSell)("isMobile", ctx_r17.isMobile)("showStarRating", ctx_r17.showStarRating)("showPlanId", ctx_r17.showPlanId)("fullPlanId", ctx_r17.fullPlanId)("planIdText", ctx_r17.planIdText)("viewAllPlanDetailsText", ctx_r17.viewAllPlanDetailsText)("shareThisPlanText", ctx_r17.shareThisPlanText)("viewCostDetailsText", ctx_r17.viewCostDetailsText)("closeText", ctx_r17.closeText)("planBenefitHighlightItems", ctx_r17.planBenefitHighlightItems)("addOnCoverageHeaderText", ctx_r17.addOnCoverageHeaderText)("planBenefitHighlightsHeaderText", ctx_r17.planBenefitHighlightsHeaderText)("showRiderDetails", ctx_r17.showRiderDetails)("showRiderDetailsText", ctx_r17.showRiderDetailsText)("hideRiderDetailsText", ctx_r17.hideRiderDetailsText)("riderIsIncludedText", ctx_r17.riderIsIncludedText)("waiverStateRiderTooltips", ctx_r17.waiverStateRiderTooltips)("costMA", ctx_r17.costMA)("costMAPD", ctx_r17.costMAPD)("costPDP", ctx_r17.costPDP)("costMEDIGAP", ctx_r17.costMEDIGAP)("costDENTAL", ctx_r17.costDENTAL)("costVISION", ctx_r17.costVISION)("viewDetailsDescriptionText", ctx_r17.viewDetailsDescriptionText)("showAvailableRateFactorsEnabled", ctx_r17.showAvailableRateFactorsEnabled)("availableRateFactorsData", ctx_r17.availableRateFactorsData)("personalizedQuoteLabelText", ctx_r17.personalizedQuoteLabelText);
} }
function NextgenPlanCardComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 2)(2, "div", 7)(3, "div", 8)(4, "header", 9)(5, "div", 2);
    i0.ɵɵtemplate(6, NextgenPlanCardComponent_div_2_div_6_Template, 3, 4, "div", 10);
    i0.ɵɵelementStart(7, "div", 7)(8, "h2", 11)(9, "span");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(11, NextgenPlanCardComponent_div_2_div_11_Template, 2, 5, "div", 12);
    i0.ɵɵelement(12, "vnext-plan-SNP-Indicator", 13);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(13, "div")(14, "div", 14);
    i0.ɵɵtemplate(15, NextgenPlanCardComponent_div_2_ng_container_15_Template, 9, 8, "ng-container", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, NextgenPlanCardComponent_div_2_ng_container_16_Template, 11, 8, "ng-container", 16);
    i0.ɵɵtemplate(17, NextgenPlanCardComponent_div_2_ng_template_17_Template, 4, 1, "ng-template", null, 17, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(19, "div", 18)(20, "div", 19);
    i0.ɵɵtemplate(21, NextgenPlanCardComponent_div_2_ng_container_21_Template, 10, 9, "ng-container", 15);
    i0.ɵɵelementStart(22, "div", 20)(23, "div", 21);
    i0.ɵɵtext(24);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(25, NextgenPlanCardComponent_div_2_vnext_link_25_Template, 1, 1, "vnext-link", 22);
    i0.ɵɵtemplate(26, NextgenPlanCardComponent_div_2_ng_template_26_Template, 7, 8, "ng-template", null, 23, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 24);
    i0.ɵɵtemplate(29, NextgenPlanCardComponent_div_2_vnext_shopping_cart_button_29_Template, 1, 2, "vnext-shopping-cart-button", 25);
    i0.ɵɵtemplate(30, NextgenPlanCardComponent_div_2_ng_container_30_Template, 2, 10, "ng-container", 15);
    i0.ɵɵtemplate(31, NextgenPlanCardComponent_div_2_div_31_Template, 2, 10, "div", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(32, NextgenPlanCardComponent_div_2_div_32_Template, 6, 6, "div", 26);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(33, NextgenPlanCardComponent_div_2_ng_container_33_Template, 2, 33, "ng-container", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r7 = i0.ɵɵreference(18);
    const _r11 = i0.ɵɵreference(27);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "PlanCard_", ctx_r2.plan.id, "");
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r2.showPlanLogo);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r2.plan.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.showRatingMethod);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("newPlanCardDesignEnabled", ctx_r2.newPlanCardDesignEnabled)("SNPType", ctx_r2.plan.snpType)("CSNPEnabled", ctx_r2.CSNPEnabled)("DSNPEnabled", ctx_r2.DSNPEnabled)("ISNPEnabled", ctx_r2.ISNPEnabled)("CSNPText", ctx_r2.CSNPText)("DSNPText", ctx_r2.DSNPText)("ISNPText", ctx_r2.ISNPText)("SNPText", ctx_r2.SNPText)("DSNPCodes", ctx_r2.translatedDSNPCodes);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.annualCost);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.annualCost && ctx_r2.showPlanCoveragePreferences())("ngIfElse", _r7);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r2.Spa_Site_AddToCompare_Enabled && !ctx_r2.hideCompareBox);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(27, _c0$2u, ctx_r2.isNotLicensedToSell));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.premiumLabel, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.hasPremium)("ngIfElse", _r11);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r2.hasPremium && ctx_r2.addToCartEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isHospitalCare);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isAncillary && ctx_r2.isAddToQuoteAvailable);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.Spa_Site_PlanViewDetails_Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isPlanDetailCardInitialized);
} }
class NextgenPlanCardComponent extends PlanCardBaseComponent {
    constructor(navigationService, planFacade, demographicService, riderFacade, planCompareService, responsiveLayoutService, planCardFacade, quoteService, analyticsService, localeService, cdr, planDetailsFacade, guidedHelpService) {
        super(navigationService, planFacade, demographicService, riderFacade, planCompareService, responsiveLayoutService, planCardFacade, quoteService, analyticsService, localeService, cdr, planDetailsFacade, guidedHelpService);
        this.navigationService = navigationService;
        this.planFacade = planFacade;
        this.demographicService = demographicService;
        this.riderFacade = riderFacade;
        this.planCompareService = planCompareService;
        this.responsiveLayoutService = responsiveLayoutService;
        this.planCardFacade = planCardFacade;
        this.quoteService = quoteService;
        this.analyticsService = analyticsService;
        this.localeService = localeService;
        this.cdr = cdr;
        this.planDetailsFacade = planDetailsFacade;
        this.guidedHelpService = guidedHelpService;
        this.showPlanDetailCard = false;
        this.isPlanDetailCardInitialized = false;
    }
    ngOnChanges(changes) {
        super.ngOnChanges(changes);
        const { plan, viewDetailsDescriptionText } = changes;
        if ((plan && !_isEqual(plan.previousValue, plan.currentValue)) ||
            (viewDetailsDescriptionText && viewDetailsDescriptionText.previousValue !== viewDetailsDescriptionText.currentValue)) {
            this.getViewAllPlanDetailsAriaLabelText();
        }
    }
    showPlanDetailToggle(show) {
        const shouldShow = show !== undefined ? show : !this.showPlanDetailCard;
        if (shouldShow && !this.isPlanDetailCardInitialized) {
            this.isPlanDetailCardInitialized = true;
        }
        this.showPlanDetailCard = shouldShow;
        this.cdr.markForCheck();
    }
    getViewAllPlanDetailsAriaLabelText() {
        this.viewAllPlanDetailsAriaLabelText = `${this.plan?.planName || ''} ${this.viewDetailsDescriptionText}`;
    }
}
NextgenPlanCardComponent.ɵfac = function NextgenPlanCardComponent_Factory(t) { return new (t || NextgenPlanCardComponent)(i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.DemographicService), i0.ɵɵdirectiveInject(RiderFacade), i0.ɵɵdirectiveInject(i1.PlanCompareService), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService), i0.ɵɵdirectiveInject(PlanCardFacade), i0.ɵɵdirectiveInject(i1.QuoteService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlanDetailsFacade), i0.ɵɵdirectiveInject(i1.GuidedHelpService)); };
NextgenPlanCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NextgenPlanCardComponent, selectors: [["vnext-nextgen-plan-card"]], features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 3, vars: 3, consts: [["class", "row", 4, "ngIf"], ["class", "plan-card mb-3 plan-card-border plan-card-modern pt-0", 3, "id", 4, "ngIf"], [1, "row"], [1, "col-12"], [3, "plan", "customClass", "currentPlanText", "nextYearPlanText", "notLicensedPlanText", "includeNonLicensedPlans", "optionOneText", "optionTwoText", "displayOptionLabels", "disableNextYearDisplay", "nonCommissionableText", "isNonCommissionableFlagCheckEnabled"], [3, "customClass", "plan", "bestMatchText", "bestMatchIcon", "bestMatchTooltip"], [1, "plan-card", "mb-3", "plan-card-border", "plan-card-modern", "pt-0", 3, "id"], [1, "col-12", "col-md-8"], [1, "pt-3", "pb-1", "pl-3", "pr-3", "pr-sm-0"], [1, "mb-3"], ["class", "col-12 col-md-4 mb-3 mb-md-0", "vnextHideMissingImage", "", 4, "ngIf"], [1, "Spa_Style_Regular_Font", "my-0", "plan-name", "no-translate-block"], ["class", "card-sub-header-details", 4, "ngIf"], [3, "newPlanCardDesignEnabled", "SNPType", "CSNPEnabled", "DSNPEnabled", "ISNPEnabled", "CSNPText", "DSNPText", "ISNPText", "SNPText", "DSNPCodes"], [1, "plan-benefits"], [4, "ngIf"], [4, "ngIf", "ngIfElse"], ["notLicensedToSell", ""], [1, "col-12", "col-md-4", "pl-md-0"], [1, "plan-card-action-area", "Spa_Style_Gray1_Background"], [1, "monthly-premium-container"], [1, "Spa_Style_Regular_Font", "plan-premium", "mb-0", 3, "ngClass"], ["class", "mt-1", 3, "title", "click", 4, "ngIf", "ngIfElse"], ["showPremium", ""], [1, "plan-card-buttons-container"], [3, "plan", "newPlanCardDesignEnabled", 4, "ngIf"], ["class", "plan-card-expand-details-btn", 4, "ngIf"], ["vnextHideMissingImage", "", 1, "col-12", "col-md-4", "mb-3", "mb-md-0"], [1, "plan-card-logo"], [3, "alternateText", "imageSrc", "classNames", "planLogoSize"], [1, "card-sub-header-details"], [3, "planExtraData", "Spa_Site_Tooltip_Text", "Spa_RatingMethod_AttainedAge_Tooltip_Text", "Spa_RatingMethod_IssueAge_Tooltip_Text", "Spa_RatingMethod_CommunityRated_Tooltip_Text"], [1, "plan-benefits", 3, "ngSwitch"], [4, "ngSwitchCase"], [3, "newPlanCardDesignEnabled", "plan", "annualCost", "planBenefits", "planBenefitNoValueLabel", "isNotLicensedToSell"], ["class", "row justify-content-between px-3 flex-sm-column offset-sm-4", 4, "ngSwitchCase"], [1, "row", "justify-content-between", "px-3", "flex-sm-column", "offset-sm-4"], [1, "Spa_Style_Paragraph", "mx-sm-auto", 3, "ngClass"], [1, "Spa_Style_H3", "mx-sm-auto", 3, "ngClass"], [1, "plan-preferences"], [3, "role", "customClass", "click", "keyup.enter"], ["link-body", ""], ["hidePreferences", ""], [3, "ngSwitch"], [1, "ml-1", "fas", "fa-angle-up"], [1, "sr-only"], [1, "ml-1", "fas", "fa-angle-down"], [3, "newPlanCardDesignEnabled", "pharmacyNotCoveredText", "plan", "prescriptionsText", "pharmacyText", "pharmacyCoveredText", "addedPharmacy", "drugCoverageText", "showDrugCoverage", "planPreferences", "totalEstimatedAnnualCostText", "totalEstimatedCostText", "totalEstimatedCostTooltip", "isTotalEstimatedCostEnabled", "isEnabledShowDrugAlternatives", "showNudgeDrugAlternatives", "drugAlternativesTooltipText", "nudgeDrugAlternativesLabelText", "drugAlternativesIndicatorIcon", "isRetention", "isQuoting", "noCostAvailableText", "Spa_Site_Tooltip_Text", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "annualCost", "showMailOrderLabel", "isMailOrderSelected", "medicineCabinet", "mailOrderText", "totalCostEffectiveDate", "selectedProviders", "planCardPreferenceDetailedEnabled", "providerDetails", "showProviderInNetworkOnOtherLocation", "providersCoveredText", "providerPcpText", "loaderIconEnabled", "editLinkText", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "viewProvidersButtonText", "viewPrescriptionsButtonText", "isVbcAgreementEnabled", "vbcAgreementLabel", "vbcAgreementTooltip"], [3, "newPlanCardDesignEnabled", "supplementalBenefits", "planBenefits", "hideLinkText", "viewAllLinkText", "isMobile", "availableText", "unavailableText", "supplementalBenefitsHighlightText"], [3, "newPlanCardDesignEnabled", "pharmacyNotCoveredText", "plan", "prescriptionsText", "pharmacyText", "pharmacyCoveredText", "addedPharmacy", "drugCoverageText", "showDrugCoverage", "planPreferences", "totalEstimatedAnnualCostText", "totalEstimatedCostText", "totalEstimatedCostTooltip", "isTotalEstimatedCostEnabled", "isEnabledShowDrugAlternatives", "showNudgeDrugAlternatives", "drugAlternativesTooltipText", "nudgeDrugAlternativesLabelText", "drugAlternativesIndicatorIcon", "isRetention", "isQuoting", "noCostAvailableText", "Spa_Site_Tooltip_Text", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "annualCost", "medicineCabinet", "totalCostEffectiveDate", "selectedProviders", "planCardPreferenceDetailedEnabled", "providerDetails", "showProviderInNetworkOnOtherLocation", "providersCoveredText", "providerPcpText", "loaderIconEnabled", "editLinkText", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "viewProvidersButtonText", "viewPrescriptionsButtonText", "isVbcAgreementEnabled", "vbcAgreementLabel", "vbcAgreementTooltip"], [3, "newPlanCardDesignEnabled", "pharmacyNotCoveredText", "plan", "prescriptionsText", "pharmacyText", "pharmacyCoveredText", "addedPharmacy", "drugCoverageText", "showDrugCoverage", "planPreferences", "totalEstimatedAnnualCostText", "totalEstimatedCostText", "totalEstimatedCostTooltip", "isTotalEstimatedCostEnabled", "isEnabledShowDrugAlternatives", "showNudgeDrugAlternatives", "drugAlternativesTooltipText", "nudgeDrugAlternativesLabelText", "drugAlternativesIndicatorIcon", "isRetention", "isQuoting", "noCostAvailableText", "Spa_Site_Tooltip_Text", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "annualCost", "showMailOrderLabel", "isMailOrderSelected", "medicineCabinet", "mailOrderText", "totalCostEffectiveDate", "selectedProviders", "planCardPreferenceDetailedEnabled", "providerDetails", "loaderIconEnabled", "editLinkText", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "viewProvidersButtonText", "viewPrescriptionsButtonText", "isVbcAgreementEnabled", "vbcAgreementLabel", "vbcAgreementTooltip"], [1, "Spa_Style_Primary_Color", "Spa_Style_Paragraph", "px-3", "py-1"], [1, "checkbox", "plan-compare-checkbox", "Spa_Style_Paragraph"], [1, "mb-0", "can-click", "btn", "Spa_Style_TertiaryButton", "w-100", 3, "for"], ["type", "checkbox", "triggers", "manual", "placement", "top-left left-top", "tooltipClass", "compare-warning-tooltip", "role", "checkbox", 1, "can-click", "mr-2", 3, "id", "value", "ngbTooltip", "checked", "change"], ["compareTooltip", "ngbTooltip"], ["compareTooltipContent", ""], ["isSelectedForCompare", ""], ["navigationAdapter", "", 3, "innerHtml"], [4, "liveEditProp"], [1, "hidden-off-screen", "no-translate-block"], ["tabindex", "0", 1, "can-click", 3, "title", "makeInlineBlock", "alwaysUnderlined", "keyup.enter", "click"], [1, "mt-1", 3, "title", "click"], [1, "Spa_Style_CostPremiumSmall", 3, "ngClass"], ["showPremiumWithFees", ""], ["class", "Spa_Style_Note", 4, "ngIf"], [3, "title", "alwaysUnderlined", "click", "keyup.enter"], [3, "planFees", "planTotalPremium", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "tooltipCustomClass"], [1, "Spa_Style_Note"], ["class", "Spa_Style_CostPremiumSmall non-monthly-payment-text", 3, "ngClass", 4, "ngIf"], [1, "Spa_Style_CostPremiumSmall", "non-monthly-payment-text", 3, "ngClass"], [1, "fas", "fa-tag"], [3, "plan", "newPlanCardDesignEnabled"], [1, "p-0", 3, "ngClass", "newPlanCardDesignEnabled", "plan", "addToQuoteButtonText", "removeFromQuoteButtonText", "addToQuoteWarningTooltip", "selectedQuoteGroup", "isPlanAddedToQuote", "addToQuote", "removePlanFromQuoteGroup"], [1, "plan-card-expand-details-btn"], [3, "isLinkButton", "customClass", "ariaLabel", "title", "click", "keyup.enter"], ["hideViewMoreDetailsText", ""], ["aria-hidden", "true", 1, "fas", "fa-angle-up", "fas", "pl-2"], ["aria-hidden", "true", 1, "fas", "fa-angle-down", "pl-2"], [3, "ngClass", "plan", "newPlanCardDesignEnabled", "isNotLicensedToSell", "isMobile", "showStarRating", "showPlanId", "fullPlanId", "planIdText", "viewAllPlanDetailsText", "shareThisPlanText", "viewCostDetailsText", "closeText", "planBenefitHighlightItems", "addOnCoverageHeaderText", "planBenefitHighlightsHeaderText", "showRiderDetails", "showRiderDetailsText", "hideRiderDetailsText", "riderIsIncludedText", "waiverStateRiderTooltips", "costMA", "costMAPD", "costPDP", "costMEDIGAP", "costDENTAL", "costVISION", "viewDetailsDescriptionText", "showAvailableRateFactorsEnabled", "availableRateFactorsData", "personalizedQuoteLabelText", "closeDetailCardClicked"]], template: function NextgenPlanCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, NextgenPlanCardComponent_div_0_Template, 3, 12, "div", 0);
        i0.ɵɵtemplate(1, NextgenPlanCardComponent_div_1_Template, 3, 5, "div", 0);
        i0.ɵɵtemplate(2, NextgenPlanCardComponent_div_2_Template, 34, 29, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.hidePlanCardLabel);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.plan.id === ctx.bestMatchPlanId);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.newPlanCardDesignEnabled);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, LinkComponent, NavigationAdapterDirective, LiveEditPropDirective, IconAriaAttributesDirective, HideMissingImageDirective, i1$1.NgbTooltip, NextgenPlanCardDetailExpandableComponent, ShoppingCartButtonComponent, PlanBenefitsComponent, PlanCardBestMatchComponent, PlanFeesTooltipComponent, PlanCoveragePreferencesComponent, PlanCardSupplementalBenefitsComponent, PlanCardLabelComponent, PlanQuoteButtonComponent, PlanSNPIndicatorComponent, PlanRatingMethodComponent, PlanLogoComponent, SafePipe, RateFactorAppliedPipe, CustomCurrencyPipe], styles: [".plan-card-action-area[_ngcontent-%COMP%]{height:100%;text-align:center;padding:16px 0 48px;position:relative}.plan-card-logo-img[_ngcontent-%COMP%]{max-height:100px;max-width:100%}.plan-card-logo[_ngcontent-%COMP%]{width:100%}.plan-compare-checkbox[_ngcontent-%COMP%]{margin:0 16px}.plan-card-buttons-container[_ngcontent-%COMP%]{margin:16px 16px 0}.plan-card-modern[_ngcontent-%COMP%]   .monthly-premium-container[_ngcontent-%COMP%]{height:auto;margin-top:48px}.plan-card-expand-details-btn[_ngcontent-%COMP%]{position:absolute;bottom:16px;width:100%;text-align:center}", ".plan-card[_ngcontent-%COMP%]{border-width:1px;border-style:solid;border-top-right-radius:4px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;padding:8px 0 0}.plan-card.plan-card-border[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent1);border-top-left-radius:4px}.plan-card[_ngcontent-%COMP%]   .image-responsive[_ngcontent-%COMP%]{padding-right:0;max-width:100%;text-align:center}.score-display[_ngcontent-%COMP%]{color:red}.monthly-premium-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;height:100%;align-items:center;justify-content:center}.plan-premium[_ngcontent-%COMP%]{line-height:17px;margin-bottom:5px}.plan-benefits-column-list[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;list-style:none;padding:0}.plan-benefits-column-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child, .plan-benefits-column-list.plan-benefits-row-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-bottom:0;margin-bottom:16px}.coverage[_ngcontent-%COMP%]{border-radius:14px;text-align:center;padding:4px}.coverage[_ngcontent-%COMP%]   .fas[_ngcontent-%COMP%]{height:17px;width:18px}.plan-benefits-items[_ngcontent-%COMP%]:focus, .plan_monthly_premium[_ngcontent-%COMP%]:focus, .monthly-premium-container[_ngcontent-%COMP%]:focus, .coverage[_ngcontent-%COMP%]:focus{box-shadow:none;outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:0 0 5px var(--static-Spa_Style_Black);border-radius:5px}.tooltip-icon[_ngcontent-%COMP%]{font-size:12px;padding-right:10px;background-color:transparent;font-family:\"Font Awesome 5 Pro\"}.plan-benefits[_ngcontent-%COMP%]{margin-bottom:16px}.current-plan-text[_ngcontent-%COMP%], .next-year-plan-text[_ngcontent-%COMP%]{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.plan-name[_ngcontent-%COMP%]:focus{border-radius:5px}.card-sub-header-details[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;align-items:baseline}.non-monthly-payment-text[_ngcontent-%COMP%]{font-size:13px;font-family:montserratregular}@media (max-width: 479.98px){.plan-benefits-column-list.plan-benefits-row-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list.plan-benefits-row-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child{border-bottom:0}}.plan-benefits-items[_ngcontent-%COMP%]{flex-basis:33.3333%;flex-grow:0}@media (max-width: 575.98px){.plan-benefits-list-value-container[_ngcontent-%COMP%]{float:right;display:flex;flex-direction:column;align-items:flex-end}.plan-benefits[_ngcontent-%COMP%]{margin-bottom:0}}.no-border[_ngcontent-%COMP%]{border:none!important}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NextgenPlanCardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-nextgen-plan-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"!hidePlanCardLabel\" class=\"row\">\r\n  <div class=\"col-12\">\r\n    <vnext-widget-plan-card-label\r\n      [plan]=\"plan\"\r\n      [customClass]=\"customClass\"\r\n      [currentPlanText]=\"currentPlanText\"\r\n      [nextYearPlanText]=\"nextYearPlanText\"\r\n      [notLicensedPlanText]=\"nonLicensedPlanText\"\r\n      [includeNonLicensedPlans]=\"includeNonLicensedPlans\"\r\n      [optionOneText]=\"optionOneText\"\r\n      [optionTwoText]=\"optionTwoText\"\r\n      [displayOptionLabels]=\"displayOptionLabels\"\r\n      [disableNextYearDisplay]=\"memberHasOptionsDefined && displayOptionLabels\"\r\n      [nonCommissionableText]=\"nonCommissionableText\"\r\n      [isNonCommissionableFlagCheckEnabled]=\"isNonCommissionableFlagCheckEnabled\"\r\n    ></vnext-widget-plan-card-label>\r\n  </div>\r\n</div>\r\n<div class=\"row\" *ngIf=\"plan.id === bestMatchPlanId\">\r\n  <div class=\"col-12\">\r\n    <vnext-widget-plan-card-best-match\r\n      [customClass]=\"customClass\"\r\n      [plan]=\"plan\"\r\n      [bestMatchText]=\"bestMatchText\"\r\n      [bestMatchIcon]=\"bestMatchIcon\"\r\n      [bestMatchTooltip]=\"bestMatchTooltip\"\r\n    >\r\n    </vnext-widget-plan-card-best-match>\r\n  </div>\r\n</div>\r\n\r\n<!---NEW PLAN CARD START-->\r\n<div *ngIf=\"newPlanCardDesignEnabled\" class=\"plan-card mb-3 plan-card-border plan-card-modern pt-0\" id=\"PlanCard_{{ plan.id }}\">\r\n  <div class=\"row\">\r\n    <div class=\"col-12 col-md-8\">\r\n      <div class=\"pt-3 pb-1 pl-3 pr-3 pr-sm-0\">\r\n        <header class=\"mb-3\">\r\n          <div class=\"row\">\r\n            <div class=\"col-12 col-md-4 mb-3 mb-md-0\" *ngIf=\"showPlanLogo\" vnextHideMissingImage>\r\n              <div class=\"plan-card-logo\">\r\n                <vnext-plan-logo\r\n                  [alternateText]=\"altPlanImgText\"\r\n                  [imageSrc]=\"planLogo\"\r\n                  [classNames]=\"'plan-logo'\"\r\n                  [planLogoSize]=\"planLogoSize\"\r\n                ></vnext-plan-logo>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-12 col-md-8\">\r\n              <h2 class=\"Spa_Style_Regular_Font my-0 plan-name no-translate-block\">\r\n                <span>{{ plan.planName }}</span>\r\n              </h2>\r\n              <div class=\"card-sub-header-details\" *ngIf=\"showRatingMethod\">\r\n                <vnext-plan-rating-method\r\n                  [planExtraData]=\"plan.extraData\"\r\n                  [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                  [Spa_RatingMethod_AttainedAge_Tooltip_Text]=\"Spa_RatingMethod_AttainedAge_Tooltip_Text\"\r\n                  [Spa_RatingMethod_IssueAge_Tooltip_Text]=\"Spa_RatingMethod_IssueAge_Tooltip_Text\"\r\n                  [Spa_RatingMethod_CommunityRated_Tooltip_Text]=\"Spa_RatingMethod_CommunityRated_Tooltip_Text\"\r\n                ></vnext-plan-rating-method>\r\n              </div>\r\n              <vnext-plan-SNP-Indicator\r\n                [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n                [SNPType]=\"plan.snpType\"\r\n                [CSNPEnabled]=\"CSNPEnabled\"\r\n                [DSNPEnabled]=\"DSNPEnabled\"\r\n                [ISNPEnabled]=\"ISNPEnabled\"\r\n                [CSNPText]=\"CSNPText\"\r\n                [DSNPText]=\"DSNPText\"\r\n                [ISNPText]=\"ISNPText\"\r\n                [SNPText]=\"SNPText\"\r\n                [DSNPCodes]=\"translatedDSNPCodes\"\r\n              ></vnext-plan-SNP-Indicator>\r\n            </div>\r\n          </div>\r\n        </header>\r\n        <div>\r\n          <div class=\"plan-benefits\">\r\n            <ng-container *ngIf=\"annualCost\">\r\n              <div [ngSwitch]=\"plan.planType\" class=\"plan-benefits\">\r\n                <!-- Checking for MAPD PlanType -->\r\n                <div *ngSwitchCase=\"planType.MAPD\">\r\n                  <vnext-plan-benefits\r\n                    [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n                    [plan]=\"plan\"\r\n                    [annualCost]=\"annualCost\"\r\n                    [planBenefits]=\"planBenefits\"\r\n                    [planBenefitNoValueLabel]=\"Spa_Site_NotApplicable_Text\"\r\n                    [isNotLicensedToSell]=\"isNotLicensedToSell\"\r\n                  >\r\n                  </vnext-plan-benefits>\r\n                </div>\r\n                <!-- Checking for MA PlanType -->\r\n                <div *ngSwitchCase=\"planType.MA\">\r\n                  <vnext-plan-benefits\r\n                    [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n                    [plan]=\"plan\"\r\n                    [annualCost]=\"annualCost\"\r\n                    [planBenefits]=\"planBenefits\"\r\n                    [planBenefitNoValueLabel]=\"Spa_Site_NotApplicable_Text\"\r\n                    [isNotLicensedToSell]=\"isNotLicensedToSell\"\r\n                  >\r\n                  </vnext-plan-benefits>\r\n                </div>\r\n                <!-- Checking for PDP PlanType -->\r\n                <div *ngSwitchCase=\"planType.PDP\">\r\n                  <vnext-plan-benefits\r\n                    [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n                    [plan]=\"plan\"\r\n                    [annualCost]=\"annualCost\"\r\n                    [planBenefits]=\"planBenefits\"\r\n                    [planBenefitNoValueLabel]=\"Spa_Site_NotApplicable_Text\"\r\n                    [isNotLicensedToSell]=\"isNotLicensedToSell\"\r\n                  >\r\n                  </vnext-plan-benefits>\r\n                </div>\r\n                <!-- Checking for DENTAL PlanType -->\r\n                <ng-container *ngSwitchCase=\"planType.DENTAL\">\r\n                  <div *ngIf=\"activeTabType === planTypeAbbreviation.DENTAL\">\r\n                    <vnext-plan-benefits\r\n                      [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n                      [plan]=\"plan\"\r\n                      [annualCost]=\"annualCost\"\r\n                      [planBenefits]=\"planBenefits\"\r\n                      [planBenefitNoValueLabel]=\"Spa_Site_NotApplicable_Text\"\r\n                      [isNotLicensedToSell]=\"isNotLicensedToSell\"\r\n                    >\r\n                    </vnext-plan-benefits>\r\n                  </div>\r\n                </ng-container>\r\n                <!-- Checking for HC PlanType -->\r\n                <ng-container *ngSwitchCase=\"planType.HC\">\r\n                  <div *ngIf=\"activeTabType === planTypeAbbreviation.HC\">\r\n                    <vnext-plan-benefits\r\n                      [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n                      [plan]=\"plan\"\r\n                      [annualCost]=\"annualCost\"\r\n                      [planBenefits]=\"planBenefits\"\r\n                      [planBenefitNoValueLabel]=\"Spa_Site_NotApplicable_Text\"\r\n                      [isNotLicensedToSell]=\"isNotLicensedToSell\"\r\n                    >\r\n                    </vnext-plan-benefits>\r\n                  </div>\r\n                </ng-container>\r\n                <!-- Checking for VISION PlanType -->\r\n                <ng-container *ngSwitchCase=\"planType.VISION\">\r\n                  <div *ngIf=\"activeTabType === planTypeAbbreviation.DENTAL\">\r\n                    <vnext-plan-benefits\r\n                      [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n                      [plan]=\"plan\"\r\n                      [annualCost]=\"annualCost\"\r\n                      [planBenefits]=\"planBenefits\"\r\n                      [planBenefitNoValueLabel]=\"Spa_Site_NotApplicable_Text\"\r\n                      [isNotLicensedToSell]=\"isNotLicensedToSell\"\r\n                    >\r\n                    </vnext-plan-benefits>\r\n                  </div>\r\n                </ng-container>\r\n                <ng-container *ngIf=\"Spa_Site_MedigapPlanType_Enabled\">\r\n                  <div *ngSwitchCase=\"planType.MEDIGAP\" class=\"row justify-content-between px-3 flex-sm-column offset-sm-4\">\r\n                    <div class=\"Spa_Style_Paragraph mx-sm-auto\" [ngClass]=\"{ Spa_Style_Gray4_Color: isNotLicensedToSell }\">\r\n                      {{ Spa_PlanCard_PlanType_Text }}\r\n                    </div>\r\n                    <div class=\"Spa_Style_H3 mx-sm-auto\" [ngClass]=\"{ Spa_Style_Gray4_Color: isNotLicensedToSell }\">\r\n                      {{ plan.planSubType }}\r\n                    </div>\r\n                  </div>\r\n                </ng-container>\r\n              </div>\r\n            </ng-container>\r\n          </div>\r\n          <ng-container *ngIf=\"annualCost && showPlanCoveragePreferences(); else notLicensedToSell\">\r\n            <div class=\"plan-preferences\">\r\n              <vnext-link\r\n                [role]=\"linkRoles.BUTTON\"\r\n                [customClass]=\"'Spa_Style_Link Spa_Style_Regular_Font Spa_Style_Semi_Bold_Weight mb-4 d-block d-sm-none'\"\r\n                (click)=\"toggleViewAll()\"\r\n                (keyup.enter)=\"toggleViewAll()\"\r\n              >\r\n                <div link-body>\r\n                  <ng-container *ngIf=\"showPreferences; else hidePreferences\">\r\n                    {{ preferencesText }}<i class=\"ml-1 fas fa-angle-up\"></i><span class=\"sr-only\">Collapse</span>\r\n                  </ng-container>\r\n                  <ng-template #hidePreferences>\r\n                    {{ preferencesText }}<i class=\"ml-1 fas fa-angle-down\"></i><span class=\"sr-only\">Expand</span>\r\n                  </ng-template>\r\n                </div>\r\n              </vnext-link>\r\n\r\n              <div [ngSwitch]=\"plan.planType\">\r\n                <!-- Checking for MAPD PlanType -->\r\n                <div *ngSwitchCase=\"planType.MAPD\">\r\n                  <div *ngIf=\"showPreferences || !isMobile\">\r\n                    <vnext-plan-coverage-preferences\r\n                      [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n                      [pharmacyNotCoveredText]=\"Spa_PlanDetails_Non_Covered_Text\"\r\n                      [plan]=\"plan\"\r\n                      [prescriptionsText]=\"Spa_Site_Prescriptions_Text\"\r\n                      [pharmacyText]=\"Spa_Site_Pharmacy_Text\"\r\n                      [pharmacyCoveredText]=\"pharmacyCoverageText\"\r\n                      [addedPharmacy]=\"selectedPharmacy\"\r\n                      [drugCoverageText]=\"getDrugCoverageText(drugCount, plan)\"\r\n                      [showDrugCoverage]=\"showDrugCoverage(drugCount)\"\r\n                      [planPreferences]=\"planPreferences\"\r\n                      [totalEstimatedAnnualCostText]=\"Spa_PlanCard_TotalEstimatedAnnualCost_Text\"\r\n                      [totalEstimatedCostText]=\"Spa_PlanCard_TotalEstimatedCost_Text\"\r\n                      [totalEstimatedCostTooltip]=\"Spa_PlanCard_Total_Estimated_Cost_Tooltip\"\r\n                      [isTotalEstimatedCostEnabled]=\"Spa_Site_TotalEstimatedCost_Enabled\"\r\n                      [isEnabledShowDrugAlternatives]=\"Spa_Site_ShowDrugAlternatives_Enabled\"\r\n                      [showNudgeDrugAlternatives]=\"Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled\"\r\n                      [drugAlternativesTooltipText]=\"Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text\"\r\n                      [nudgeDrugAlternativesLabelText]=\"Spa_PlanCard_ShowDrugAlternatives_Nudge_Text\"\r\n                      [drugAlternativesIndicatorIcon]=\"Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon\"\r\n                      [isRetention]=\"isRetentionView\"\r\n                      [isQuoting]=\"isQuotingSite\"\r\n                      [noCostAvailableText]=\"noCostAvailableText\"\r\n                      [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                      [viewCostTooltipHeaderText]=\"viewCostTooltipHeaderText\"\r\n                      [viewCostTooltipHeaderContent]=\"viewCostTooltipHeaderContent\"\r\n                      [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n                      [inNetworkStandardText]=\"inNetworkStandardText\"\r\n                      [outOfNetworkText]=\"outOfNetworkText\"\r\n                      [annualCost]=\"annualCost\"\r\n                      [showMailOrderLabel]=\"isMailOrderSelected\"\r\n                      [isMailOrderSelected]=\"isMailOrderSelected\"\r\n                      [medicineCabinet]=\"medicineCabinet\"\r\n                      [mailOrderText]=\"mailOrderText\"\r\n                      [totalCostEffectiveDate]=\"totalCostEffectiveDate\"\r\n                      [selectedProviders]=\"selectedProviders\"\r\n                      [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n                      [providerDetails]=\"providerDetails\"\r\n                      [showProviderInNetworkOnOtherLocation]=\"planCardTile?.showProviderInNetworkOnOtherLocation\"\r\n                      [providersCoveredText]=\"planCardTile?.providersCoveredText\"\r\n                      [providerPcpText]=\"planCardTile?.providerPcpText\"\r\n                      [loaderIconEnabled]=\"loaderIconEnabled\"\r\n                      [editLinkText]=\"editLinkText\"\r\n                      [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n                      [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n                      [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n                      [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n                      [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n                      [isVbcAgreementEnabled]=\"isVbcAgreementEnabled\"\r\n                      [vbcAgreementLabel]=\"vbcAgreementLabel\"\r\n                      [vbcAgreementTooltip]=\"vbcAgreementTooltip\"\r\n                    ></vnext-plan-coverage-preferences>\r\n                  </div>\r\n                  <div *ngIf=\"Spa_PlanCard_SupplementalBenefits_Enabled\">\r\n                    <vnext-plan-card-supplemental-benefits\r\n                      [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n                      [supplementalBenefits]=\"Spa_PlanCard_SupplementalBenefits_List\"\r\n                      [planBenefits]=\"plan.planDataFields\"\r\n                      [hideLinkText]=\"hideLinkText\"\r\n                      [viewAllLinkText]=\"viewAllLinkText\"\r\n                      [isMobile]=\"isMobile\"\r\n                      [availableText]=\"availableText\"\r\n                      [unavailableText]=\"unavailableText\"\r\n                      [supplementalBenefitsHighlightText]=\"supplementalBenefitsHighlightText\"\r\n                    ></vnext-plan-card-supplemental-benefits>\r\n                  </div>\r\n                </div>\r\n                <!-- Checking for MA PlanType -->\r\n                <div *ngSwitchCase=\"planType.MA\">\r\n                  <div *ngIf=\"showPreferences || !isMobile\">\r\n                    <vnext-plan-coverage-preferences\r\n                      [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n                      [pharmacyNotCoveredText]=\"Spa_PlanDetails_Non_Covered_Text\"\r\n                      [plan]=\"plan\"\r\n                      [prescriptionsText]=\"Spa_Site_Prescriptions_Text\"\r\n                      [pharmacyText]=\"Spa_Site_Pharmacy_Text\"\r\n                      [pharmacyCoveredText]=\"pharmacyCoverageText\"\r\n                      [addedPharmacy]=\"selectedPharmacy\"\r\n                      [drugCoverageText]=\"getDrugCoverageText(drugCount, plan)\"\r\n                      [showDrugCoverage]=\"showDrugCoverage(drugCount)\"\r\n                      [planPreferences]=\"planPreferences\"\r\n                      [totalEstimatedAnnualCostText]=\"Spa_PlanCard_TotalEstimatedAnnualCost_Text\"\r\n                      [totalEstimatedCostText]=\"Spa_PlanCard_TotalEstimatedCost_Text\"\r\n                      [totalEstimatedCostTooltip]=\"Spa_PlanCard_Total_Estimated_Cost_Tooltip\"\r\n                      [isTotalEstimatedCostEnabled]=\"Spa_Site_TotalEstimatedCost_Enabled\"\r\n                      [isEnabledShowDrugAlternatives]=\"Spa_Site_ShowDrugAlternatives_Enabled\"\r\n                      [showNudgeDrugAlternatives]=\"Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled\"\r\n                      [drugAlternativesTooltipText]=\"Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text\"\r\n                      [nudgeDrugAlternativesLabelText]=\"Spa_PlanCard_ShowDrugAlternatives_Nudge_Text\"\r\n                      [drugAlternativesIndicatorIcon]=\"Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon\"\r\n                      [isRetention]=\"isRetentionView\"\r\n                      [isQuoting]=\"isQuotingSite\"\r\n                      [noCostAvailableText]=\"noCostAvailableText\"\r\n                      [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                      [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n                      [inNetworkStandardText]=\"inNetworkStandardText\"\r\n                      [outOfNetworkText]=\"outOfNetworkText\"\r\n                      [annualCost]=\"annualCost\"\r\n                      [medicineCabinet]=\"medicineCabinet\"\r\n                      [totalCostEffectiveDate]=\"totalCostEffectiveDate\"\r\n                      [selectedProviders]=\"selectedProviders\"\r\n                      [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n                      [providerDetails]=\"providerDetails\"\r\n                      [showProviderInNetworkOnOtherLocation]=\"planCardTile?.showProviderInNetworkOnOtherLocation\"\r\n                      [providersCoveredText]=\"planCardTile?.providersCoveredText\"\r\n                      [providerPcpText]=\"planCardTile?.providerPcpText\"\r\n                      [loaderIconEnabled]=\"loaderIconEnabled\"\r\n                      [editLinkText]=\"editLinkText\"\r\n                      [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n                      [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n                      [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n                      [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n                      [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n                      [isVbcAgreementEnabled]=\"isVbcAgreementEnabled\"\r\n                      [vbcAgreementLabel]=\"vbcAgreementLabel\"\r\n                      [vbcAgreementTooltip]=\"vbcAgreementTooltip\"\r\n                    ></vnext-plan-coverage-preferences>\r\n                  </div>\r\n                  <div *ngIf=\"Spa_PlanCard_SupplementalBenefits_Enabled\">\r\n                    <vnext-plan-card-supplemental-benefits\r\n                      [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n                      [supplementalBenefits]=\"Spa_PlanCard_SupplementalBenefits_List\"\r\n                      [planBenefits]=\"plan.planDataFields\"\r\n                      [hideLinkText]=\"hideLinkText\"\r\n                      [viewAllLinkText]=\"viewAllLinkText\"\r\n                      [isMobile]=\"isMobile\"\r\n                      [availableText]=\"availableText\"\r\n                      [unavailableText]=\"unavailableText\"\r\n                      [supplementalBenefitsHighlightText]=\"supplementalBenefitsHighlightText\"\r\n                    ></vnext-plan-card-supplemental-benefits>\r\n                  </div>\r\n                </div>\r\n                <!-- Checking for PDP PlanType -->\r\n                <div *ngSwitchCase=\"planType.PDP\">\r\n                  <div *ngIf=\"showPreferences || !isMobile\">\r\n                    <vnext-plan-coverage-preferences\r\n                      [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n                      [pharmacyNotCoveredText]=\"Spa_PlanDetails_Non_Covered_Text\"\r\n                      [plan]=\"plan\"\r\n                      [prescriptionsText]=\"Spa_Site_Prescriptions_Text\"\r\n                      [pharmacyText]=\"Spa_Site_Pharmacy_Text\"\r\n                      [pharmacyCoveredText]=\"pharmacyCoverageText\"\r\n                      [addedPharmacy]=\"selectedPharmacy\"\r\n                      [drugCoverageText]=\"getDrugCoverageText(drugCount, plan)\"\r\n                      [showDrugCoverage]=\"showDrugCoverage(drugCount)\"\r\n                      [planPreferences]=\"planPreferences\"\r\n                      [totalEstimatedAnnualCostText]=\"Spa_PlanCard_TotalEstimatedAnnualCost_Text\"\r\n                      [totalEstimatedCostText]=\"Spa_PlanCard_TotalEstimatedCost_Text\"\r\n                      [totalEstimatedCostTooltip]=\"Spa_PlanCard_Total_Estimated_Cost_Tooltip\"\r\n                      [isTotalEstimatedCostEnabled]=\"Spa_Site_TotalEstimatedCost_Enabled\"\r\n                      [isEnabledShowDrugAlternatives]=\"Spa_Site_ShowDrugAlternatives_Enabled\"\r\n                      [showNudgeDrugAlternatives]=\"Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled\"\r\n                      [drugAlternativesTooltipText]=\"Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text\"\r\n                      [nudgeDrugAlternativesLabelText]=\"Spa_PlanCard_ShowDrugAlternatives_Nudge_Text\"\r\n                      [drugAlternativesIndicatorIcon]=\"Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon\"\r\n                      [isRetention]=\"isRetentionView\"\r\n                      [isQuoting]=\"isQuotingSite\"\r\n                      [noCostAvailableText]=\"noCostAvailableText\"\r\n                      [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                      [viewCostTooltipHeaderText]=\"viewCostTooltipHeaderText\"\r\n                      [viewCostTooltipHeaderContent]=\"viewCostTooltipHeaderContent\"\r\n                      [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n                      [inNetworkStandardText]=\"inNetworkStandardText\"\r\n                      [outOfNetworkText]=\"outOfNetworkText\"\r\n                      [annualCost]=\"annualCost\"\r\n                      [showMailOrderLabel]=\"isMailOrderSelected\"\r\n                      [isMailOrderSelected]=\"isMailOrderSelected\"\r\n                      [medicineCabinet]=\"medicineCabinet\"\r\n                      [mailOrderText]=\"mailOrderText\"\r\n                      [totalCostEffectiveDate]=\"totalCostEffectiveDate\"\r\n                      [selectedProviders]=\"selectedProviders\"\r\n                      [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n                      [providerDetails]=\"providerDetails\"\r\n                      [loaderIconEnabled]=\"loaderIconEnabled\"\r\n                      [editLinkText]=\"editLinkText\"\r\n                      [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n                      [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n                      [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n                      [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n                      [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n                      [isVbcAgreementEnabled]=\"isVbcAgreementEnabled\"\r\n                      [vbcAgreementLabel]=\"vbcAgreementLabel\"\r\n                      [vbcAgreementTooltip]=\"vbcAgreementTooltip\"\r\n                    ></vnext-plan-coverage-preferences>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </ng-container>\r\n          <ng-template #notLicensedToSell>\r\n            <div>\r\n              <div class=\"row\">\r\n                <div class=\"Spa_Style_Primary_Color Spa_Style_Paragraph px-3 py-1\">\r\n                  {{ nonLicensedMessageText }}\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </ng-template>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-12 col-md-4 pl-md-0\">\r\n      <div class=\"plan-card-action-area Spa_Style_Gray1_Background\">\r\n        <ng-container *ngIf=\"Spa_Site_AddToCompare_Enabled && !hideCompareBox\">\r\n          <div class=\"checkbox plan-compare-checkbox Spa_Style_Paragraph\">\r\n            <label for=\"Compare_{{ plan.id }}\" class=\"mb-0 can-click btn Spa_Style_TertiaryButton w-100\">\r\n              <input\r\n                #compareTooltip=\"ngbTooltip\"\r\n                id=\"Compare_{{ plan.id }}\"\r\n                type=\"checkbox\"\r\n                class=\"can-click mr-2\"\r\n                triggers=\"manual\"\r\n                placement=\"top-left left-top\"\r\n                tooltipClass=\"compare-warning-tooltip\"\r\n                value=\"{{ plan.id }}\"\r\n                role=\"checkbox\"\r\n                [ngbTooltip]=\"compareTooltipContent\"\r\n                [attr.aria-checked]=\"isSelectedToCompare(plan)\"\r\n                [attr.aria-label]=\"\r\n                  isSelectedToCompare(plan) ? Spa_PlanCard_CompareNow_Text : Spa_PlanCard_AddToCompare_Text + ' ' + plan.planName\r\n                \"\r\n                [checked]=\"isSelectedToCompare(plan)\"\r\n                (change)=\"updatePlanToCompareGroup(plan, $event, compareTooltip)\"\r\n              />\r\n              <ng-template #compareTooltipContent>\r\n                <div [innerHtml]=\"compareWarningTooltip | safe : 'html'\" navigationAdapter></div>\r\n              </ng-template>\r\n              <ng-container *ngIf=\"!isSelectedToCompare(plan); else isSelectedForCompare\"\r\n                ><span *liveEditProp=\"'Spa_PlanCard_AddToCompare_Text'\">{{ Spa_PlanCard_AddToCompare_Text }}</span>\r\n                <span class=\"hidden-off-screen no-translate-block\">{{ plan.planName }}</span></ng-container\r\n              >\r\n              <ng-template #isSelectedForCompare>\r\n                <vnext-link\r\n                  [title]=\"Spa_PlanCard_CompareNow_Text\"\r\n                  [makeInlineBlock]=\"true\"\r\n                  [alwaysUnderlined]=\"true\"\r\n                  (keyup.enter)=\"comparePlans($event, plan)\"\r\n                  (click)=\"comparePlans($event, plan)\"\r\n                  tabindex=\"0\"\r\n                  class=\"can-click\"\r\n                ></vnext-link>\r\n              </ng-template>\r\n            </label>\r\n          </div>\r\n        </ng-container>\r\n\r\n        <div class=\"monthly-premium-container\">\r\n          <div class=\"Spa_Style_Regular_Font plan-premium mb-0\" [ngClass]=\"{ Spa_Style_Gray4_Color: isNotLicensedToSell }\">\r\n            {{ premiumLabel }}\r\n          </div>\r\n          <vnext-link\r\n            [title]=\"Spa_PlanCard_QuoteLinkName_Text\"\r\n            class=\"mt-1\"\r\n            (click)=\"quoteClick()\"\r\n            *ngIf=\"!hasPremium; else showPremium\"\r\n          ></vnext-link>\r\n          <ng-template #showPremium>\r\n            <div class=\"Spa_Style_CostPremiumSmall\" [ngClass]=\"{ Spa_Style_Gray4_Color: isNotLicensedToSell }\">\r\n              <ng-container *ngIf=\"!planFeesEnabled || !plan.fees?.length; else showPremiumWithFees\">\r\n                <span *ngIf=\"snpPremiumRangeEnabled && planPremiumInitialRange\">{{ planPremiumInitialRange }}</span\r\n                >{{ planTotalPremium | customCurrency : 'USD' : 'symbol' : '1.2-2' }}\r\n              </ng-container>\r\n              <div *ngIf=\"snpPremiumRangeEnabled && planPremiumInitialRange\">\r\n                <vnext-link\r\n                  [title]=\"snpRangeLinkText\"\r\n                  [alwaysUnderlined]=\"true\"\r\n                  (click)=\"showSnpRangeModal()\"\r\n                  (keyup.enter)=\"showSnpRangeModal()\"\r\n                ></vnext-link>\r\n              </div>\r\n\r\n              <ng-template #showPremiumWithFees>\r\n                <vnext-widget-plan-fees-tooltip\r\n                  [planFees]=\"plan.fees\"\r\n                  [planTotalPremium]=\"planTotalPremium\"\r\n                  [planFeesTooltipText]=\"planFeesTooltipText\"\r\n                  [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n                  [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n                  [tooltipCustomClass]=\"'inline-block-sm-layout'\"\r\n                ></vnext-widget-plan-fees-tooltip>\r\n              </ng-template>\r\n            </div>\r\n            <span *ngIf=\"isHospitalCare\" class=\"Spa_Style_Note\">{{ monthlyPremiumText }}</span>\r\n            <ng-container *ngIf=\"plan.planType === planType.MEDIGAP\">\r\n              <div\r\n                class=\"Spa_Style_CostPremiumSmall non-monthly-payment-text\"\r\n                [ngClass]=\"{ Spa_Style_Gray4_Color: isNotLicensedToSell }\"\r\n                *ngIf=\"\r\n                  medSupPaymentMethod &&\r\n                    medSupPaymentMethod !== medSupPaymentMethodEnum.MONTHLY &&\r\n                    nonMonthlyRateText &&\r\n                    medSupPaymentMethodDisplayText &&\r\n                    !Spa_Site_ShowPremiumAsAnnual &&\r\n                    showNonMonthlyRateText &&\r\n                    plan.rateFactors | rateFactorApplied\r\n                \"\r\n              >\r\n                <i class=\"fas fa-tag\"></i>\r\n                {{ nonMonthlyRateText.replace('&lt;paymentMethod&gt;', medSupPaymentMethodDisplayText[medSupPaymentMethod]) }}\r\n              </div>\r\n            </ng-container>\r\n          </ng-template>\r\n        </div>\r\n\r\n        <div class=\"plan-card-buttons-container\">\r\n          <vnext-shopping-cart-button *ngIf=\"hasPremium && addToCartEnabled\" [plan]=\"plan\" [newPlanCardDesignEnabled]=\"true\">\r\n          </vnext-shopping-cart-button>\r\n\r\n          <ng-container *ngIf=\"isHospitalCare\">\r\n            <vnext-widget-plan-quote-button\r\n              class=\"p-0\"\r\n              [ngClass]=\"{ 'mt-2 btn1 mb-3': addToCartEnabled }\"\r\n              [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n              [plan]=\"plan\"\r\n              [addToQuoteButtonText]=\"Spa_PlanCard_AddToQuote_Text\"\r\n              [removeFromQuoteButtonText]=\"Spa_PlanCard_RemoveFromQuote_Text\"\r\n              [addToQuoteWarningTooltip]=\"addToQuoteWarningTooltip\"\r\n              [selectedQuoteGroup]=\"selectedCompareGroup\"\r\n              [isPlanAddedToQuote]=\"isSelectedToCompare(plan)\"\r\n              (addToQuote)=\"addPlanToHospitalIndemnityCompareGroup($event.plan, $event.addToQuoteTooltip)\"\r\n              (removePlanFromQuoteGroup)=\"removePlanToHospitalIndemnityCompareGroup($event.selectedQuoteGroup, $event.plan)\"\r\n            ></vnext-widget-plan-quote-button>\r\n          </ng-container>\r\n\r\n          <div *ngIf=\"!isAncillary && isAddToQuoteAvailable\">\r\n            <vnext-widget-plan-quote-button\r\n              class=\"p-0\"\r\n              [ngClass]=\"{ 'mt-2 btn2 mb-3': addToCartEnabled }\"\r\n              [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n              [plan]=\"plan\"\r\n              [addToQuoteButtonText]=\"Spa_PlanCard_AddToQuote_Text\"\r\n              [removeFromQuoteButtonText]=\"Spa_PlanCard_RemoveFromQuote_Text\"\r\n              [addToQuoteWarningTooltip]=\"Spa_PlanCard_AddToQuote_Warning_Tooltip\"\r\n              [selectedQuoteGroup]=\"selectedQuoteGroup\"\r\n              [isPlanAddedToQuote]=\"isPlanAddedToQuote(plan)\"\r\n              (addToQuote)=\"addPlanToQuote($event.plan, $event.addToQuoteTooltip)\"\r\n              (removePlanFromQuoteGroup)=\"planFacade.removePlanFromQuoteGroup($event.selectedQuoteGroup, $event.plan)\"\r\n            ></vnext-widget-plan-quote-button>\r\n          </div>\r\n        </div>\r\n\r\n        <div *ngIf=\"Spa_Site_PlanViewDetails_Enabled\" class=\"plan-card-expand-details-btn\">\r\n          <vnext-link\r\n            [isLinkButton]=\"true\"\r\n            (click)=\"showPlanDetailToggle()\"\r\n            (keyup.enter)=\"showPlanDetailToggle()\"\r\n            [customClass]=\"'btn-reset Spa_Style_Link Spa_Style_Regular_Font Spa_Style_Semi_Bold_Weight d-inline-block mt-4'\"\r\n            [ariaLabel]=\"viewAllPlanDetailsAriaLabelText\"\r\n            [title]=\"viewAllPlanDetailsAriaLabelText\"\r\n          >\r\n            <div link-body>\r\n              <ng-container *ngIf=\"showPlanDetailCard; else hideViewMoreDetailsText\"\r\n                >{{ hideDetailsText }}<i aria-hidden=\"true\" class=\"fas fa-angle-up fas pl-2\"></i><span class=\"sr-only\">Collapse</span>\r\n              </ng-container>\r\n              <ng-template #hideViewMoreDetailsText\r\n                >{{ viewMoreDetailsText }}<i aria-hidden=\"true\" class=\"fas fa-angle-down pl-2\"></i><span class=\"sr-only\">Expand</span>\r\n              </ng-template>\r\n            </div>\r\n          </vnext-link>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <ng-container *ngIf=\"isPlanDetailCardInitialized\">\r\n    <vnext-nextgen-plan-card-detail-expandable\r\n      [ngClass]=\"{ 'd-none': !showPlanDetailCard }\"\r\n      [plan]=\"plan\"\r\n      [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n      [isNotLicensedToSell]=\"isNotLicensedToSell\"\r\n      [isMobile]=\"isMobile\"\r\n      [showStarRating]=\"showStarRating\"\r\n      [showPlanId]=\"showPlanId\"\r\n      [fullPlanId]=\"fullPlanId\"\r\n      [planIdText]=\"planIdText\"\r\n      [viewAllPlanDetailsText]=\"viewAllPlanDetailsText\"\r\n      [shareThisPlanText]=\"shareThisPlanText\"\r\n      [viewCostDetailsText]=\"viewCostDetailsText\"\r\n      [closeText]=\"closeText\"\r\n      [planBenefitHighlightItems]=\"planBenefitHighlightItems\"\r\n      [addOnCoverageHeaderText]=\"addOnCoverageHeaderText\"\r\n      [planBenefitHighlightsHeaderText]=\"planBenefitHighlightsHeaderText\"\r\n      [showRiderDetails]=\"showRiderDetails\"\r\n      [showRiderDetailsText]=\"showRiderDetailsText\"\r\n      [hideRiderDetailsText]=\"hideRiderDetailsText\"\r\n      [riderIsIncludedText]=\"riderIsIncludedText\"\r\n      [waiverStateRiderTooltips]=\"waiverStateRiderTooltips\"\r\n      [costMA]=\"costMA\"\r\n      [costMAPD]=\"costMAPD\"\r\n      [costPDP]=\"costPDP\"\r\n      [costMEDIGAP]=\"costMEDIGAP\"\r\n      [costDENTAL]=\"costDENTAL\"\r\n      [costVISION]=\"costVISION\"\r\n      [viewDetailsDescriptionText]=\"viewDetailsDescriptionText\"\r\n      [showAvailableRateFactorsEnabled]=\"showAvailableRateFactorsEnabled\"\r\n      [availableRateFactorsData]=\"availableRateFactorsData\"\r\n      [personalizedQuoteLabelText]=\"personalizedQuoteLabelText\"\r\n      (closeDetailCardClicked)=\"showPlanDetailToggle(false)\"\r\n    >\r\n    </vnext-nextgen-plan-card-detail-expandable>\r\n  </ng-container>\r\n</div>\r\n\r\n<!---NEW PLAN CARD END-->\r\n", styles: [".plan-card-action-area{height:100%;text-align:center;padding:16px 0 48px;position:relative}.plan-card-logo-img{max-height:100px;max-width:100%}.plan-card-logo{width:100%}.plan-compare-checkbox{margin:0 16px}.plan-card-buttons-container{margin:16px 16px 0}.plan-card-modern .monthly-premium-container{height:auto;margin-top:48px}.plan-card-expand-details-btn{position:absolute;bottom:16px;width:100%;text-align:center}\n", ".plan-card{border-width:1px;border-style:solid;border-top-right-radius:4px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;padding:8px 0 0}.plan-card.plan-card-border{border-color:var(--static-Spa_Style_Accent1);border-top-left-radius:4px}.plan-card .image-responsive{padding-right:0;max-width:100%;text-align:center}.score-display{color:red}.monthly-premium-container{display:flex;flex-direction:column;height:100%;align-items:center;justify-content:center}.plan-premium{line-height:17px;margin-bottom:5px}.plan-benefits-column-list{display:flex;flex-wrap:wrap;list-style:none;padding:0}.plan-benefits-column-list li{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list li:last-child,.plan-benefits-column-list.plan-benefits-row-list li{border-bottom:0;margin-bottom:16px}.coverage{border-radius:14px;text-align:center;padding:4px}.coverage .fas{height:17px;width:18px}.plan-benefits-items:focus,.plan_monthly_premium:focus,.monthly-premium-container:focus,.coverage:focus{box-shadow:none;outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:0 0 5px var(--static-Spa_Style_Black);border-radius:5px}.tooltip-icon{font-size:12px;padding-right:10px;background-color:transparent;font-family:\"Font Awesome 5 Pro\"}.plan-benefits{margin-bottom:16px}.current-plan-text,.next-year-plan-text{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.plan-name:focus{border-radius:5px}.card-sub-header-details{display:flex;flex-wrap:wrap;align-items:baseline}.non-monthly-payment-text{font-size:13px;font-family:montserratregular}@media (max-width: 479.98px){.plan-benefits-column-list.plan-benefits-row-list li{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list.plan-benefits-row-list li:last-child{border-bottom:0}}.plan-benefits-items{flex-basis:33.3333%;flex-grow:0}@media (max-width: 575.98px){.plan-benefits-list-value-container{float:right;display:flex;flex-direction:column;align-items:flex-end}.plan-benefits{margin-bottom:0}}.no-border{border:none!important}\n"] }]
    }], function () { return [{ type: i1.NavigationService }, { type: PlanFacade }, { type: i1.DemographicService }, { type: RiderFacade }, { type: i1.PlanCompareService }, { type: i1.ResponsiveLayoutService }, { type: PlanCardFacade }, { type: i1.QuoteService }, { type: AnalyticsService }, { type: i1.LocaleService }, { type: i0.ChangeDetectorRef }, { type: PlanDetailsFacade }, { type: i1.GuidedHelpService }]; }, null); })();

const _c0$2t = ["dentalTooltip"];
const _c1$1e = ["visionTooltip"];
const _c2$L = ["hearingTooltip"];
const _c3$u = function (a0) { return { "col-md-auto": a0 }; };
const _c4$g = function (a0, a1) { return { prewrap: a0, Spa_Style_Gray4_Color: a1 }; };
function RiderCardComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "p", 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c3$u, ctx_r2.isTileDisplay));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c4$g, ctx_r2.isAddOnCoverageTextIsMultiLine, ctx_r2.isNotLicensed));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.Spa_PlanCard_AddOnCoverage_Text, " ");
} }
const _c5$b = function (a0, a1) { return { "Spa_Style_Accent1_Color": a0, "mr-3": a1 }; };
function RiderCardComponent_div_0_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15, 16);
    i0.ɵɵlistener("focus", function RiderCardComponent_div_0_button_4_Template_button_focus_0_listener() { i0.ɵɵrestoreView(_r14); const _r12 = i0.ɵɵreference(1); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.onRiderTooltipFocus(_r12)); })("blur", function RiderCardComponent_div_0_button_4_Template_button_blur_0_listener() { i0.ɵɵrestoreView(_r14); const _r12 = i0.ɵɵreference(1); const ctx_r15 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r15.onRiderTooltipBlur(_r12)); })("mouseenter", function RiderCardComponent_div_0_button_4_Template_button_mouseenter_0_listener() { i0.ɵɵrestoreView(_r14); const _r12 = i0.ɵɵreference(1); const ctx_r16 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r16.onRiderTooltipMouseEnter(_r12)); })("mouseleave", function RiderCardComponent_div_0_button_4_Template_button_mouseleave_0_listener() { i0.ɵɵrestoreView(_r14); const _r12 = i0.ɵɵreference(1); const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.onRiderTooltipMouseLeave(_r12)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(8);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngbTooltip", _r4)("ngClass", i0.ɵɵpureFunction2(3, _c5$b, ctx_r3.isNotLicensed, ctx_r3.isPlanTypeMode));
    i0.ɵɵattribute("aria-label", ctx_r3.Spa_Site_Tooltip_Text + " " + ctx_r3.Spa_PlanCard_DentalAddOnCoverage_Text);
} }
function RiderCardComponent_div_0_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r5.Spa_Site_Dental_Rider_Display_Text);
} }
const _c6$a = function (a0, a1) { return { "Spa_Style_Accent1_Color": a0, "pr-3": a1 }; };
function RiderCardComponent_div_0_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18, 19);
    i0.ɵɵlistener("focus", function RiderCardComponent_div_0_button_9_Template_button_focus_0_listener() { i0.ɵɵrestoreView(_r20); const _r18 = i0.ɵɵreference(1); const ctx_r19 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r19.onRiderTooltipFocus(_r18)); })("blur", function RiderCardComponent_div_0_button_9_Template_button_blur_0_listener() { i0.ɵɵrestoreView(_r20); const _r18 = i0.ɵɵreference(1); const ctx_r21 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r21.onRiderTooltipBlur(_r18)); })("mouseenter", function RiderCardComponent_div_0_button_9_Template_button_mouseenter_0_listener() { i0.ɵɵrestoreView(_r20); const _r18 = i0.ɵɵreference(1); const ctx_r22 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r22.onRiderTooltipMouseEnter(_r18)); })("mouseleave", function RiderCardComponent_div_0_button_9_Template_button_mouseleave_0_listener() { i0.ɵɵrestoreView(_r20); const _r18 = i0.ɵɵreference(1); const ctx_r23 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r23.onRiderTooltipMouseLeave(_r18)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r7 = i0.ɵɵreference(13);
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngbTooltip", _r7)("ngClass", i0.ɵɵpureFunction2(3, _c6$a, ctx_r6.isNotLicensed, ctx_r6.isPlanTypeMode));
    i0.ɵɵattribute("aria-label", ctx_r6.Spa_Site_Tooltip_Text + " " + ctx_r6.Spa_PlanCard_VisionAddOnCoverage_Text);
} }
function RiderCardComponent_div_0_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r8.Spa_Site_Vision_Rider_Display_Text);
} }
const _c7$8 = function (a0) { return { Spa_Style_Accent1_Color: a0 }; };
function RiderCardComponent_div_0_button_14_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20, 21);
    i0.ɵɵlistener("focus", function RiderCardComponent_div_0_button_14_Template_button_focus_0_listener() { i0.ɵɵrestoreView(_r26); const _r24 = i0.ɵɵreference(1); const ctx_r25 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r25.onRiderTooltipFocus(_r24)); })("blur", function RiderCardComponent_div_0_button_14_Template_button_blur_0_listener() { i0.ɵɵrestoreView(_r26); const _r24 = i0.ɵɵreference(1); const ctx_r27 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r27.onRiderTooltipBlur(_r24)); })("mouseenter", function RiderCardComponent_div_0_button_14_Template_button_mouseenter_0_listener() { i0.ɵɵrestoreView(_r26); const _r24 = i0.ɵɵreference(1); const ctx_r28 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r28.onRiderTooltipMouseEnter(_r24)); })("mouseleave", function RiderCardComponent_div_0_button_14_Template_button_mouseleave_0_listener() { i0.ɵɵrestoreView(_r26); const _r24 = i0.ɵɵreference(1); const ctx_r29 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r29.onRiderTooltipMouseLeave(_r24)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r10 = i0.ɵɵreference(18);
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngbTooltip", _r10)("ngClass", i0.ɵɵpureFunction1(3, _c7$8, ctx_r9.isNotLicensed));
    i0.ɵɵattribute("aria-label", ctx_r9.Spa_Site_Tooltip_Text + " " + ctx_r9.Spa_PlanCard_HearingAddOnCoverage_Text);
} }
function RiderCardComponent_div_0_ng_template_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r11.Spa_Site_Hearing_Rider_Display_Text);
} }
function RiderCardComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtemplate(2, RiderCardComponent_div_0_div_2_Template, 3, 8, "div", 4);
    i0.ɵɵelementStart(3, "div", 5);
    i0.ɵɵtemplate(4, RiderCardComponent_div_0_button_4_Template, 2, 6, "button", 6);
    i0.ɵɵelementStart(5, "span", 7);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, RiderCardComponent_div_0_ng_template_7_Template, 2, 1, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(9, RiderCardComponent_div_0_button_9_Template, 2, 6, "button", 9);
    i0.ɵɵelementStart(10, "span", 7);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, RiderCardComponent_div_0_ng_template_12_Template, 2, 1, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(14, RiderCardComponent_div_0_button_14_Template, 2, 5, "button", 11);
    i0.ɵɵelementStart(15, "span", 7);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, RiderCardComponent_div_0_ng_template_17_Template, 2, 1, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showAddOnCoverageText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("className", ctx_r0.riderIconsClassName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isDentalIconVisible);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r0.Spa_Site_Tooltip_Text, " ", ctx_r0.Spa_PlanCard_DentalAddOnCoverage_Text, "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.isVisionIconVisible);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r0.Spa_Site_Tooltip_Text, " ", ctx_r0.Spa_PlanCard_VisionAddOnCoverage_Text, "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.isHearingIconVisible);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r0.Spa_Site_Tooltip_Text, " ", ctx_r0.Spa_PlanCard_HearingAddOnCoverage_Text, "");
} }
const _c8$6 = function (a0) { return { Spa_Style_Gray4_Color: a0 }; };
function RiderCardComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 22)(2, "div", 23)(3, "p", 24);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(5, "div", 22)(6, "div", 23)(7, "p", 24);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c8$6, ctx_r1.isNotLicensed));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.Spa_PlanCard_AddOnCoverage_Text, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c8$6, ctx_r1.isNotLicensed));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.availableRidersText);
} }
class RiderCardComponent {
    constructor(planFacade, responsiveLayoutService) {
        this.planFacade = planFacade;
        this.responsiveLayoutService = responsiveLayoutService;
        // Plan type mode determines if we are displaying the icons based off of the plan's sub type, or if we are using the rider categories
        this.isPlanTypeMode = false;
        this.showAncillaryIcons = false;
        this.showAddOnCoverageText = true;
        this.DENTAL_PLANS = DENTAL_PLANS;
        this.VISION_PLANS = VISION_PLANS;
        this.HEARING_PLANS = HEARING_PLANS;
        this.riderIconsClassName = '';
        // for cleaning up our subscriptions when this component goes out of scope
        this.destroy$ = new Subject();
    }
    get availableRidersText() {
        const availableRiders = [];
        if (this.riderCategories.includes(this.riderSubTypes.Dental)) {
            availableRiders.push(this.Spa_Site_Dental_Rider_Display_Text);
        }
        if (this.riderCategories.includes(this.riderSubTypes.Vision)) {
            availableRiders.push(this.Spa_Site_Vision_Rider_Display_Text);
        }
        if (this.riderCategories.includes(this.riderSubTypes.Hearing)) {
            availableRiders.push(this.Spa_Site_Hearing_Rider_Display_Text);
        }
        return availableRiders.join(', ').trim();
    }
    onRiderTooltipMouseEnter(tooltip) {
        if (!this.isMobile) {
            this.closeOpenTooltips();
            tooltip.open();
        }
    }
    onRiderTooltipMouseLeave(tooltip) {
        if (!this.isMobile) {
            tooltip.close();
        }
    }
    // if we are focusing the tooltip via a non-click event then open it
    // regardless of if we are in mobile or desktop
    onRiderTooltipFocus(tooltip) {
        // if we tab into focus always show the tooltip
        if (this.eventKey === 9) {
            this.closeOpenTooltips();
            tooltip.open();
            // if we click into focus and we are in a mobile view then toggle tooltip accordingly
        }
        else if (this.isMobile) {
            if (tooltip.isOpen()) {
                tooltip.close();
            }
            else {
                this.closeOpenTooltips();
                tooltip.open();
            }
        }
    }
    // close tooltip on blur if we are tabbing off of it
    onRiderTooltipBlur(tooltip) {
        if (this.eventKey === 9) {
            tooltip.close();
        }
    }
    // split out the benefit identifiers for each plan type from the associated resource
    ngOnInit() {
        // we need to track what key gave us focus since we have different requirements
        // for focusing on tab and focusing on click
        this.keyDown = fromEvent(document, 'keydown')
            .pipe(pluck('keyCode'), takeUntil(this.destroy$))
            .subscribe(keyCode => {
            this.eventKey = keyCode;
        });
        this.keyUp = fromEvent(document, 'keyup')
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
            this.eventKey = null;
        });
        this.responsiveLayoutService.isCompact$.pipe(takeUntil(this.destroy$)).subscribe(isCompact => (this.isMobile = isCompact));
        this.riderSubTypes = RiderSubTypes;
        this.isAddOnCoverageTextIsMultiLine = this.Spa_PlanCard_AddOnCoverage_Text.indexOf('\n') > 0;
    }
    ngOnDestroy() {
        this.destroy$.next(true);
    }
    ngOnChanges(changes) {
        const { isPlanTypeMode, isTileDisplay, riderCategories, plan } = changes;
        const currentValueForPlanChange = plan?.currentValue;
        const previousValueForPlanChange = plan?.previousValue;
        if (isPlanTypeMode && isPlanTypeMode?.currentValue !== isPlanTypeMode?.previousValue) {
            this.setRiderIconsClassName();
            this.updateIconsVisibility();
        }
        else if (isTileDisplay && isTileDisplay?.currentValue !== isTileDisplay.previousValue) {
            this.setRiderIconsClassName();
        }
        else if ((riderCategories && riderCategories?.currentValue !== riderCategories.previousValue) ||
            (plan && currentValueForPlanChange?.planTypeDescription !== previousValueForPlanChange?.planTypeDescription)) {
            this.updateIconsVisibility();
        }
    }
    setRiderIconsClassName() {
        let className = 'p-0 riderIcons';
        if (!this.isPlanTypeMode) {
            className += ' col-4 justify-content-between';
            className += this.isTileDisplay ? ' col-md-6 text-right' : ' col-lg-3';
        }
        this.riderIconsClassName = className;
    }
    updateIconsVisibility() {
        this.isHearingIconVisible = this.isPlanTypeMode ? HEARING_PLANS.includes(this.plan.planTypeDescription) : this.riderCategories.includes(this.riderSubTypes?.Hearing);
        this.isVisionIconVisible = this.isPlanTypeMode ? VISION_PLANS.includes(this.plan.planTypeDescription) : this.riderCategories.includes(this.riderSubTypes?.Vision);
        this.isDentalIconVisible = this.isPlanTypeMode ? DENTAL_PLANS.includes(this.plan.planTypeDescription) : this.riderCategories.includes(this.riderSubTypes?.Dental);
    }
    // if we tab into a tooltip and then click on another we may end up with multiple
    // open tooltips so we are going to close them all before running certain events
    closeOpenTooltips() {
        if (this.dentalTooltip) {
            this.dentalTooltip.close();
        }
        if (this.visionTooltip) {
            this.visionTooltip.close();
        }
        if (this.hearingTooltip) {
            this.hearingTooltip.close();
        }
    }
}
RiderCardComponent.ɵfac = function RiderCardComponent_Factory(t) { return new (t || RiderCardComponent)(i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService)); };
RiderCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RiderCardComponent, selectors: [["vnext-rider-card"]], viewQuery: function RiderCardComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$2t, 5);
        i0.ɵɵviewQuery(_c1$1e, 5);
        i0.ɵɵviewQuery(_c2$L, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dentalTooltip = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.visionTooltip = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.hearingTooltip = _t.first);
    } }, inputs: { isTileDisplay: "isTileDisplay", isNotLicensed: "isNotLicensed", riderCategories: "riderCategories", Spa_Site_ShowRiderIcons: "Spa_Site_ShowRiderIcons", Spa_Site_Dental_Rider_Display_Text: "Spa_Site_Dental_Rider_Display_Text", Spa_Site_Vision_Rider_Display_Text: "Spa_Site_Vision_Rider_Display_Text", Spa_Site_Hearing_Rider_Display_Text: "Spa_Site_Hearing_Rider_Display_Text", Spa_PlanCard_DentalAddOnCoverage_Text: "Spa_PlanCard_DentalAddOnCoverage_Text", Spa_PlanCard_HearingAddOnCoverage_Text: "Spa_PlanCard_HearingAddOnCoverage_Text", Spa_PlanCard_VisionAddOnCoverage_Text: "Spa_PlanCard_VisionAddOnCoverage_Text", Spa_PlanCard_AddOnCoverage_Text: "Spa_PlanCard_AddOnCoverage_Text", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text", isPlanTypeMode: "isPlanTypeMode", plan: "plan", showAncillaryIcons: "showAncillaryIcons", showAddOnCoverageText: "showAddOnCoverageText" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [["class", "container", 4, "ngIf"], [4, "ngIf"], [1, "container"], [1, "row", "align-items-baseline"], ["class", "col-8 mr-auto col-lg-auto mr-md-0 p-0", "id", "add-on-coverage-text", 3, "ngClass", 4, "ngIf"], [3, "className"], ["tooltipClass", "ancillary-tooltip", "tabindex", "0", "triggers", "manual", "class", "action-button mb-1 fas Spa_Style_DentalRiderIcon Spa_Style_Primary_Link_Color p-2", 3, "ngbTooltip", "ngClass", "focus", "blur", "mouseenter", "mouseleave", 4, "ngIf"], ["aria-hidden", "true", 1, "hidden-off-screen"], ["dentalRiderTooltip", ""], ["tooltipClass", "ancillary-tooltip", "tabindex", "0", "triggers", "manual", "class", "action-button mb-1 fas Spa_Style_VisionRiderIcon Spa_Style_Primary_Link_Color p-2", 3, "ngbTooltip", "ngClass", "focus", "blur", "mouseenter", "mouseleave", 4, "ngIf"], ["visionRiderTooltip", ""], ["tooltipClass", "ancillary-tooltip", "tabindex", "0", "triggers", "manual", "class", "action-button mb-1 fas Spa_Style_HearingRiderIcon Spa_Style_Primary_Link_Color p-2", 3, "ngbTooltip", "ngClass", "focus", "blur", "mouseenter", "mouseleave", 4, "ngIf"], ["hearingRiderTooltip", ""], ["id", "add-on-coverage-text", 1, "col-8", "mr-auto", "col-lg-auto", "mr-md-0", "p-0", 3, "ngClass"], [1, "Spa_Style_Note", "mb-0", 3, "ngClass"], ["tooltipClass", "ancillary-tooltip", "tabindex", "0", "triggers", "manual", 1, "action-button", "mb-1", "fas", "Spa_Style_DentalRiderIcon", "Spa_Style_Primary_Link_Color", "p-2", 3, "ngbTooltip", "ngClass", "focus", "blur", "mouseenter", "mouseleave"], ["dentalTooltip", "ngbTooltip"], [1, "text-center"], ["tooltipClass", "ancillary-tooltip", "tabindex", "0", "triggers", "manual", 1, "action-button", "mb-1", "fas", "Spa_Style_VisionRiderIcon", "Spa_Style_Primary_Link_Color", "p-2", 3, "ngbTooltip", "ngClass", "focus", "blur", "mouseenter", "mouseleave"], ["visionTooltip", "ngbTooltip"], ["tooltipClass", "ancillary-tooltip", "tabindex", "0", "triggers", "manual", 1, "action-button", "mb-1", "fas", "Spa_Style_HearingRiderIcon", "Spa_Style_Primary_Link_Color", "p-2", 3, "ngbTooltip", "ngClass", "focus", "blur", "mouseenter", "mouseleave"], ["hearingTooltip", "ngbTooltip"], [1, "row"], [1, "col", "mr-auto"], [1, "Spa_Style_Paragraph", 3, "ngClass"]], template: function RiderCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, RiderCardComponent_div_0_Template, 19, 11, "div", 0);
        i0.ɵɵtemplate(1, RiderCardComponent_ng_container_1_Template, 9, 8, "ng-container", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.isPlanTypeMode ? ctx.showAncillaryIcons : ctx.Spa_Site_ShowRiderIcons);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.Spa_Site_ShowRiderIcons);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$1.NgbTooltip], styles: [".riderIcons[_ngcontent-%COMP%]{display:flex;justify-content:space-between!important;max-width:82px;flex:1;margin-left:14px}.riderIcons[_ngcontent-%COMP%]   i.fas[_ngcontent-%COMP%]{height:24px;width:24px;text-align:center}.riderIcons[_ngcontent-%COMP%]   i.fas[_ngcontent-%COMP%]:before{vertical-align:sub}.prewrap[_ngcontent-%COMP%]{white-space:pre-wrap}@media (min-width: 576px){#add-on-coverage-text[_ngcontent-%COMP%]{max-width:220px}}@media (max-width: 575px){.riderIcons[_ngcontent-%COMP%]{margin-right:-5px;max-width:120px}.row[_ngcontent-%COMP%]{padding-right:-20px;padding-left:-20px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RiderCardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-rider-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"isPlanTypeMode ? showAncillaryIcons : Spa_Site_ShowRiderIcons\" class=\"container\">\r\n  <div class=\"row align-items-baseline\">\r\n    <div\r\n      *ngIf=\"showAddOnCoverageText\"\r\n      class=\"col-8 mr-auto col-lg-auto mr-md-0 p-0\"\r\n      [ngClass]=\"{ 'col-md-auto': isTileDisplay }\"\r\n      id=\"add-on-coverage-text\"\r\n    >\r\n      <p class=\"Spa_Style_Note mb-0\" [ngClass]=\"{ prewrap: isAddOnCoverageTextIsMultiLine, Spa_Style_Gray4_Color: isNotLicensed }\">\r\n        {{ Spa_PlanCard_AddOnCoverage_Text }}\r\n      </p>\r\n    </div>\r\n    <div [className]=\"riderIconsClassName\">\r\n      <button\r\n        *ngIf=\"isDentalIconVisible\"\r\n        [ngbTooltip]=\"dentalRiderTooltip\"\r\n        tooltipClass=\"ancillary-tooltip\"\r\n        tabindex=\"0\"\r\n        triggers=\"manual\"\r\n        #dentalTooltip=\"ngbTooltip\"\r\n        (focus)=\"onRiderTooltipFocus(dentalTooltip)\"\r\n        (blur)=\"onRiderTooltipBlur(dentalTooltip)\"\r\n        (mouseenter)=\"onRiderTooltipMouseEnter(dentalTooltip)\"\r\n        (mouseleave)=\"onRiderTooltipMouseLeave(dentalTooltip)\"\r\n        class=\"action-button mb-1 fas Spa_Style_DentalRiderIcon Spa_Style_Primary_Link_Color p-2\"\r\n        [ngClass]=\"{ 'Spa_Style_Accent1_Color': isNotLicensed, 'mr-3': isPlanTypeMode }\"\r\n        [attr.aria-label]=\"Spa_Site_Tooltip_Text + ' ' + Spa_PlanCard_DentalAddOnCoverage_Text\"\r\n      ></button>\r\n      <span class=\"hidden-off-screen\" aria-hidden=\"true\">{{ Spa_Site_Tooltip_Text }} {{ Spa_PlanCard_DentalAddOnCoverage_Text }}</span>\r\n      <ng-template #dentalRiderTooltip>\r\n        <div class=\"text-center\">{{ Spa_Site_Dental_Rider_Display_Text }}</div>\r\n      </ng-template>\r\n      <button\r\n        *ngIf=\"isVisionIconVisible\"\r\n        [ngbTooltip]=\"visionRiderTooltip\"\r\n        tooltipClass=\"ancillary-tooltip\"\r\n        tabindex=\"0\"\r\n        triggers=\"manual\"\r\n        #visionTooltip=\"ngbTooltip\"\r\n        (focus)=\"onRiderTooltipFocus(visionTooltip)\"\r\n        (blur)=\"onRiderTooltipBlur(visionTooltip)\"\r\n        (mouseenter)=\"onRiderTooltipMouseEnter(visionTooltip)\"\r\n        (mouseleave)=\"onRiderTooltipMouseLeave(visionTooltip)\"\r\n        class=\"action-button mb-1 fas Spa_Style_VisionRiderIcon Spa_Style_Primary_Link_Color p-2\"\r\n        [ngClass]=\"{ 'Spa_Style_Accent1_Color': isNotLicensed, 'pr-3': isPlanTypeMode }\"\r\n        [attr.aria-label]=\"Spa_Site_Tooltip_Text + ' ' + Spa_PlanCard_VisionAddOnCoverage_Text\"\r\n      ></button>\r\n      <span class=\"hidden-off-screen\" aria-hidden=\"true\">{{ Spa_Site_Tooltip_Text }} {{ Spa_PlanCard_VisionAddOnCoverage_Text }}</span>\r\n      <ng-template #visionRiderTooltip>\r\n        <div class=\"text-center\">{{ Spa_Site_Vision_Rider_Display_Text }}</div>\r\n      </ng-template>\r\n      <button\r\n        *ngIf=\"isHearingIconVisible\"\r\n        [ngbTooltip]=\"hearingRiderTooltip\"\r\n        tooltipClass=\"ancillary-tooltip\"\r\n        tabindex=\"0\"\r\n        triggers=\"manual\"\r\n        #hearingTooltip=\"ngbTooltip\"\r\n        (focus)=\"onRiderTooltipFocus(hearingTooltip)\"\r\n        (blur)=\"onRiderTooltipBlur(hearingTooltip)\"\r\n        (mouseenter)=\"onRiderTooltipMouseEnter(hearingTooltip)\"\r\n        (mouseleave)=\"onRiderTooltipMouseLeave(hearingTooltip)\"\r\n        class=\"action-button mb-1 fas Spa_Style_HearingRiderIcon Spa_Style_Primary_Link_Color p-2\"\r\n        [ngClass]=\"{ Spa_Style_Accent1_Color: isNotLicensed }\"\r\n        [attr.aria-label]=\"Spa_Site_Tooltip_Text + ' ' + Spa_PlanCard_HearingAddOnCoverage_Text\"\r\n      ></button>\r\n      <span class=\"hidden-off-screen\" aria-hidden=\"true\">{{ Spa_Site_Tooltip_Text }} {{ Spa_PlanCard_HearingAddOnCoverage_Text }}</span>\r\n      <ng-template #hearingRiderTooltip>\r\n        <div class=\"text-center\">{{ Spa_Site_Hearing_Rider_Display_Text }}</div>\r\n      </ng-template>\r\n    </div>\r\n  </div>\r\n</div>\r\n<ng-container *ngIf=\"!Spa_Site_ShowRiderIcons\">\r\n  <div class=\"row\">\r\n    <div class=\"col mr-auto\">\r\n      <p class=\"Spa_Style_Paragraph\" [ngClass]=\"{ Spa_Style_Gray4_Color: isNotLicensed }\">\r\n        {{ Spa_PlanCard_AddOnCoverage_Text }}\r\n      </p>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col mr-auto\">\r\n      <p class=\"Spa_Style_Paragraph\" [ngClass]=\"{ Spa_Style_Gray4_Color: isNotLicensed }\">{{ availableRidersText }}</p>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n", styles: [".riderIcons{display:flex;justify-content:space-between!important;max-width:82px;flex:1;margin-left:14px}.riderIcons i.fas{height:24px;width:24px;text-align:center}.riderIcons i.fas:before{vertical-align:sub}.prewrap{white-space:pre-wrap}@media (min-width: 576px){#add-on-coverage-text{max-width:220px}}@media (max-width: 575px){.riderIcons{margin-right:-5px;max-width:120px}.row{padding-right:-20px;padding-left:-20px}}\n"] }]
    }], function () { return [{ type: PlanFacade }, { type: i1.ResponsiveLayoutService }]; }, { isTileDisplay: [{
            type: Input
        }], isNotLicensed: [{
            type: Input
        }], riderCategories: [{
            type: Input
        }], Spa_Site_ShowRiderIcons: [{
            type: Input
        }], Spa_Site_Dental_Rider_Display_Text: [{
            type: Input
        }], Spa_Site_Vision_Rider_Display_Text: [{
            type: Input
        }], Spa_Site_Hearing_Rider_Display_Text: [{
            type: Input
        }], Spa_PlanCard_DentalAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_HearingAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_VisionAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_AddOnCoverage_Text: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }], isPlanTypeMode: [{
            type: Input
        }], plan: [{
            type: Input
        }], showAncillaryIcons: [{
            type: Input
        }], showAddOnCoverageText: [{
            type: Input
        }], dentalTooltip: [{
            type: ViewChild,
            args: ['dentalTooltip']
        }], visionTooltip: [{
            type: ViewChild,
            args: ['visionTooltip']
        }], hearingTooltip: [{
            type: ViewChild,
            args: ['hearingTooltip']
        }] }); })();

function PlanCardRidersComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function PlanCardRidersComponent_ng_template_1_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 6);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r6.addOnCoverageTooltipBody, "html"), i0.ɵɵsanitizeHtml);
} }
function PlanCardRidersComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanCardRidersComponent_ng_template_1_ng_template_0_Template, 2, 4, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(2, "p", 4);
    i0.ɵɵelement(3, "i", 5);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r5 = i0.ɵɵreference(1);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngbTooltip", _r5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r2.addOnCoverageInCartText, " ");
} }
function PlanCardRidersComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-rider-card", 7);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("riderCategories", ctx_r4.planRiderCategories)("isNotLicensed", ctx_r4.isNotLicensedToSell)("Spa_Site_ShowRiderIcons", ctx_r4.Spa_Site_ShowRiderIcons)("Spa_Site_Dental_Rider_Display_Text", ctx_r4.Spa_Site_Dental_Rider_Display_Text)("Spa_Site_Vision_Rider_Display_Text", ctx_r4.Spa_Site_Vision_Rider_Display_Text)("Spa_Site_Hearing_Rider_Display_Text", ctx_r4.Spa_Site_Hearing_Rider_Display_Text)("Spa_PlanCard_DentalAddOnCoverage_Text", ctx_r4.Spa_PlanCard_DentalAddOnCoverage_Text)("Spa_PlanCard_HearingAddOnCoverage_Text", ctx_r4.Spa_PlanCard_HearingAddOnCoverage_Text)("Spa_PlanCard_VisionAddOnCoverage_Text", ctx_r4.Spa_PlanCard_VisionAddOnCoverage_Text)("Spa_PlanCard_AddOnCoverage_Text", ctx_r4.Spa_PlanCard_AddOnCoverage_Text)("Spa_Site_Tooltip_Text", ctx_r4.Spa_Site_Tooltip_Text)("showAncillaryIcons", ctx_r4.showAncillaryIcons)("isPlanTypeMode", ctx_r4.isPlanTypeMode);
} }
class PlanCardRidersComponent {
    constructor() {
        this.isPlanTypeMode = false;
        this.planType = PlanType;
    }
}
PlanCardRidersComponent.ɵfac = function PlanCardRidersComponent_Factory(t) { return new (t || PlanCardRidersComponent)(); };
PlanCardRidersComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCardRidersComponent, selectors: [["vnext-plan-card-riders"]], inputs: { selectedPlanType: "selectedPlanType", showMedSupAddOnCoverageText: "showMedSupAddOnCoverageText", addOnCoverageTooltipBody: "addOnCoverageTooltipBody", addOnCoverageInCartText: "addOnCoverageInCartText", planRiderCategories: "planRiderCategories", isNotLicensedToSell: "isNotLicensedToSell", Spa_Site_ShowRiderIcons: "Spa_Site_ShowRiderIcons", Spa_Site_Dental_Rider_Display_Text: "Spa_Site_Dental_Rider_Display_Text", Spa_Site_Vision_Rider_Display_Text: "Spa_Site_Vision_Rider_Display_Text", Spa_Site_Hearing_Rider_Display_Text: "Spa_Site_Hearing_Rider_Display_Text", Spa_PlanCard_DentalAddOnCoverage_Text: "Spa_PlanCard_DentalAddOnCoverage_Text", Spa_PlanCard_HearingAddOnCoverage_Text: "Spa_PlanCard_HearingAddOnCoverage_Text", Spa_PlanCard_VisionAddOnCoverage_Text: "Spa_PlanCard_VisionAddOnCoverage_Text", Spa_PlanCard_AddOnCoverage_Text: "Spa_PlanCard_AddOnCoverage_Text", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text", showAncillaryIcons: "showAncillaryIcons", isPlanTypeMode: "isPlanTypeMode" }, decls: 5, vars: 3, consts: [[4, "ngIf", "ngIfThen", "ngIfElse"], ["medSupAddOnCoverage", ""], ["otherCoverage", ""], ["addOnCoverageTooltip", ""], [1, "Spa_Style_Paragraph", "can-click", 3, "ngbTooltip"], ["aria-hidden", "true", 1, "fas", "fa-plus-circle", "pr-2", "Spa_Style_Primary_Link_Color", "tooltip-icon"], ["navigationAdapter", "", 1, "Spa_Style_ToolTip", 3, "innerHTML"], [3, "riderCategories", "isNotLicensed", "Spa_Site_ShowRiderIcons", "Spa_Site_Dental_Rider_Display_Text", "Spa_Site_Vision_Rider_Display_Text", "Spa_Site_Hearing_Rider_Display_Text", "Spa_PlanCard_DentalAddOnCoverage_Text", "Spa_PlanCard_HearingAddOnCoverage_Text", "Spa_PlanCard_VisionAddOnCoverage_Text", "Spa_PlanCard_AddOnCoverage_Text", "Spa_Site_Tooltip_Text", "showAncillaryIcons", "isPlanTypeMode"]], template: function PlanCardRidersComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanCardRidersComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        i0.ɵɵtemplate(1, PlanCardRidersComponent_ng_template_1_Template, 5, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(3, PlanCardRidersComponent_ng_template_3_Template, 1, 13, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        const _r3 = i0.ɵɵreference(4);
        i0.ɵɵproperty("ngIf", ctx.selectedPlanType === ctx.planType.MEDIGAP && ctx.showMedSupAddOnCoverageText)("ngIfThen", _r1)("ngIfElse", _r3);
    } }, dependencies: [i1$2.NgIf, NavigationAdapterDirective, IconAriaAttributesDirective, i1$1.NgbTooltip, RiderCardComponent, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCardRidersComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-card-riders', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"selectedPlanType === planType.MEDIGAP && showMedSupAddOnCoverageText; then medSupAddOnCoverage; else otherCoverage\">\r\n</ng-container>\r\n<ng-template #medSupAddOnCoverage>\r\n  <ng-template #addOnCoverageTooltip>\r\n    <div [innerHTML]=\"addOnCoverageTooltipBody | safe: 'html'\" class=\"Spa_Style_ToolTip\" navigationAdapter></div>\r\n  </ng-template>\r\n  <p class=\"Spa_Style_Paragraph can-click\" [ngbTooltip]=\"addOnCoverageTooltip\">\r\n    <i class=\"fas fa-plus-circle pr-2 Spa_Style_Primary_Link_Color tooltip-icon\" aria-hidden=\"true\"></i>{{ addOnCoverageInCartText }}\r\n  </p>\r\n</ng-template>\r\n<ng-template #otherCoverage>\r\n  <vnext-rider-card\r\n    [riderCategories]=\"planRiderCategories\"\r\n    [isNotLicensed]=\"isNotLicensedToSell\"\r\n    [Spa_Site_ShowRiderIcons]=\"Spa_Site_ShowRiderIcons\"\r\n    [Spa_Site_Dental_Rider_Display_Text]=\"Spa_Site_Dental_Rider_Display_Text\"\r\n    [Spa_Site_Vision_Rider_Display_Text]=\"Spa_Site_Vision_Rider_Display_Text\"\r\n    [Spa_Site_Hearing_Rider_Display_Text]=\"Spa_Site_Hearing_Rider_Display_Text\"\r\n    [Spa_PlanCard_DentalAddOnCoverage_Text]=\"Spa_PlanCard_DentalAddOnCoverage_Text\"\r\n    [Spa_PlanCard_HearingAddOnCoverage_Text]=\"Spa_PlanCard_HearingAddOnCoverage_Text\"\r\n    [Spa_PlanCard_VisionAddOnCoverage_Text]=\"Spa_PlanCard_VisionAddOnCoverage_Text\"\r\n    [Spa_PlanCard_AddOnCoverage_Text]=\"Spa_PlanCard_AddOnCoverage_Text\"\r\n    [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n    [showAncillaryIcons]=\"showAncillaryIcons\"\r\n    [isPlanTypeMode]=\"isPlanTypeMode\"\r\n  ></vnext-rider-card>\r\n</ng-template>\r\n" }]
    }], null, { selectedPlanType: [{
            type: Input
        }], showMedSupAddOnCoverageText: [{
            type: Input
        }], addOnCoverageTooltipBody: [{
            type: Input
        }], addOnCoverageInCartText: [{
            type: Input
        }], planRiderCategories: [{
            type: Input
        }], isNotLicensedToSell: [{
            type: Input
        }], Spa_Site_ShowRiderIcons: [{
            type: Input
        }], Spa_Site_Dental_Rider_Display_Text: [{
            type: Input
        }], Spa_Site_Vision_Rider_Display_Text: [{
            type: Input
        }], Spa_Site_Hearing_Rider_Display_Text: [{
            type: Input
        }], Spa_PlanCard_DentalAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_HearingAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_VisionAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_AddOnCoverage_Text: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }], showAncillaryIcons: [{
            type: Input
        }], isPlanTypeMode: [{
            type: Input
        }] }); })();

function LegacyPlanCardComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵelement(2, "vnext-widget-plan-card-label", 4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("plan", ctx_r0.plan)("customClass", ctx_r0.customClass)("currentPlanText", ctx_r0.currentPlanText)("nextYearPlanText", ctx_r0.nextYearPlanText)("notLicensedPlanText", ctx_r0.nonLicensedPlanText)("includeNonLicensedPlans", ctx_r0.includeNonLicensedPlans)("optionOneText", ctx_r0.optionOneText)("optionTwoText", ctx_r0.optionTwoText)("displayOptionLabels", ctx_r0.displayOptionLabels)("nonCommissionableText", ctx_r0.nonCommissionableText)("isNonCommissionableFlagCheckEnabled", ctx_r0.isNonCommissionableFlagCheckEnabled)("disableNextYearDisplay", ctx_r0.memberHasOptionsDefined && ctx_r0.displayOptionLabels);
} }
function LegacyPlanCardComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵelement(2, "vnext-widget-plan-card-best-match", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("customClass", ctx_r1.customClass)("plan", ctx_r1.plan)("bestMatchText", ctx_r1.bestMatchText)("bestMatchIcon", ctx_r1.bestMatchIcon)("bestMatchTooltip", ctx_r1.bestMatchTooltip);
} }
function LegacyPlanCardComponent_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45)(1, "div", 46);
    i0.ɵɵelement(2, "vnext-plan-logo", 47);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("alternateText", ctx_r3.altPlanImgText)("imageSrc", ctx_r3.planLogo)("classNames", "plan-logo")("planLogoSize", ctx_r3.planLogoSize);
} }
function LegacyPlanCardComponent_div_2_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 48);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r5.Spa_Site_ComboPlanTooltip_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function LegacyPlanCardComponent_div_2_ng_container_8_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r35.plan.carrierName, " ");
} }
function LegacyPlanCardComponent_div_2_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LegacyPlanCardComponent_div_2_ng_container_8_span_1_Template, 2, 1, "span", 17);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.showPlanLogo);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r6.plan.planName);
} }
function LegacyPlanCardComponent_div_2_ng_template_9_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 50);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 50);
    i0.ɵɵelement(4, "vnext-rider-card", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r36.plan.planName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("riderCategories", ctx_r36.riderFacade.getRiderCategories(ctx_r36.plan.riders))("isNotLicensed", ctx_r36.isNotLicensedToSell)("Spa_Site_ShowRiderIcons", ctx_r36.Spa_Site_ShowRiderIcons)("Spa_Site_Dental_Rider_Display_Text", ctx_r36.Spa_Site_Dental_Rider_Display_Text)("Spa_Site_Vision_Rider_Display_Text", ctx_r36.Spa_Site_Vision_Rider_Display_Text)("Spa_Site_Hearing_Rider_Display_Text", ctx_r36.Spa_Site_Hearing_Rider_Display_Text)("Spa_PlanCard_DentalAddOnCoverage_Text", ctx_r36.Spa_PlanCard_DentalAddOnCoverage_Text)("Spa_PlanCard_HearingAddOnCoverage_Text", ctx_r36.Spa_PlanCard_HearingAddOnCoverage_Text)("Spa_PlanCard_VisionAddOnCoverage_Text", ctx_r36.Spa_PlanCard_VisionAddOnCoverage_Text)("Spa_PlanCard_AddOnCoverage_Text", ctx_r36.Spa_PlanCard_AddOnCoverage_Text)("Spa_Site_Tooltip_Text", ctx_r36.Spa_Site_Tooltip_Text)("showAncillaryIcons", ctx_r36.showAncillaryIcons)("isPlanTypeMode", true)("plan", ctx_r36.plan)("showAddOnCoverageText", false);
} }
function LegacyPlanCardComponent_div_2_ng_template_9_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r38.plan.planName, " ");
} }
function LegacyPlanCardComponent_div_2_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, LegacyPlanCardComponent_div_2_ng_template_9_ng_container_0_Template, 5, 16, "ng-container", 13);
    i0.ɵɵtemplate(1, LegacyPlanCardComponent_div_2_ng_template_9_ng_template_1_Template, 2, 1, "ng-template", null, 49, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r37 = i0.ɵɵreference(2);
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", (ctx_r8.isDentalPlan || ctx_r8.isVisionPlan) && ctx_r8.showAncillaryIcons)("ngIfElse", _r37);
} }
function LegacyPlanCardComponent_div_2_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 52);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "u", 53);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(6);
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngbTooltip", _r4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", " ", " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r9.Spa_Site_ComboPlanLabel_Text);
} }
function LegacyPlanCardComponent_div_2_div_13_vnext_plan_year_badge_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-plan-year-badge", 55);
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("planYear", ctx_r39.planCardTile == null ? null : ctx_r39.planCardTile.plan == null ? null : ctx_r39.planCardTile.plan.planYear);
} }
function LegacyPlanCardComponent_div_2_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, LegacyPlanCardComponent_div_2_div_13_vnext_plan_year_badge_1_Template, 1, 1, "vnext-plan-year-badge", 54);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.planCardTile == null ? null : ctx_r10.planCardTile.plan == null ? null : ctx_r10.planCardTile.plan.planYear);
} }
function LegacyPlanCardComponent_div_2_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56)(1, "span", 57);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r11.planIdText, ":");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r11.fullPlanId);
} }
function LegacyPlanCardComponent_div_2_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 58);
    i0.ɵɵelement(1, "vnext-plan-rating-method", 59);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("planExtraData", ctx_r12.plan.extraData)("Spa_Site_Tooltip_Text", ctx_r12.Spa_Site_Tooltip_Text)("Spa_RatingMethod_AttainedAge_Tooltip_Text", ctx_r12.Spa_RatingMethod_AttainedAge_Tooltip_Text)("Spa_RatingMethod_IssueAge_Tooltip_Text", ctx_r12.Spa_RatingMethod_IssueAge_Tooltip_Text)("Spa_RatingMethod_CommunityRated_Tooltip_Text", ctx_r12.Spa_RatingMethod_CommunityRated_Tooltip_Text);
} }
function LegacyPlanCardComponent_div_2_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 58);
    i0.ɵɵelement(1, "vnext-star-rating", 60)(2, "vnext-plan-SNP-Indicator", 61);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isMobile", ctx_r13.isMobile)("starRating", ctx_r13.plan.planRating)("ratingValueDescription", ctx_r13.plan.planRatingValueDescription)("showLowPerformanceIndicator", ctx_r13.plan.isLowPerformingPlan)("isNotLicensed", ctx_r13.isNotLicensedToSell);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("SNPType", ctx_r13.plan.snpType)("CSNPEnabled", ctx_r13.CSNPEnabled)("DSNPEnabled", ctx_r13.DSNPEnabled)("ISNPEnabled", ctx_r13.ISNPEnabled)("CSNPText", ctx_r13.CSNPText)("DSNPText", ctx_r13.DSNPText)("ISNPText", ctx_r13.ISNPText)("SNPText", ctx_r13.SNPText)("DSNPCodes", ctx_r13.translatedDSNPCodes);
} }
const _c0$2s = function (a0, a1) { return { "Spa_Style_Gray4_Color": a0, "score-display": a1 }; };
function LegacyPlanCardComponent_div_2_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 62)(1, "div", 63);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c0$2s, ctx_r14.isNotLicensedToSell, !ctx_r14.isNotLicensedToSell));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" Score: ", ctx_r14.plan == null ? null : ctx_r14.plan.score == null ? null : ctx_r14.plan.score.toFixed(2), " ");
} }
function LegacyPlanCardComponent_div_2_div_18_ng_container_1_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 71);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r43.compareWarningTooltip, "html"), i0.ɵɵsanitizeHtml);
} }
function LegacyPlanCardComponent_div_2_div_18_ng_container_1_ng_container_7_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r47.Spa_PlanCard_AddToCompare_Text);
} }
function LegacyPlanCardComponent_div_2_div_18_ng_container_1_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LegacyPlanCardComponent_div_2_div_18_ng_container_1_ng_container_7_span_1_Template, 2, 1, "span", 72);
    i0.ɵɵelementStart(2, "span", 73);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_PlanCard_AddToCompare_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r44.plan.planName);
} }
function LegacyPlanCardComponent_div_2_div_18_ng_container_1_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 74);
    i0.ɵɵlistener("keyup.enter", function LegacyPlanCardComponent_div_2_div_18_ng_container_1_ng_template_8_Template_vnext_link_keyup_enter_0_listener($event) { i0.ɵɵrestoreView(_r49); const ctx_r48 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r48.comparePlans($event, ctx_r48.plan)); })("click", function LegacyPlanCardComponent_div_2_div_18_ng_container_1_ng_template_8_Template_vnext_link_click_0_listener($event) { i0.ɵɵrestoreView(_r49); const ctx_r50 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r50.comparePlans($event, ctx_r50.plan)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("title", ctx_r46.Spa_PlanCard_CompareNow_Text)("makeInlineBlock", true)("alwaysUnderlined", true);
} }
function LegacyPlanCardComponent_div_2_div_18_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r52 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 65)(2, "label", 66)(3, "input", 67, 68);
    i0.ɵɵlistener("change", function LegacyPlanCardComponent_div_2_div_18_ng_container_1_Template_input_change_3_listener($event) { i0.ɵɵrestoreView(_r52); const _r41 = i0.ɵɵreference(4); const ctx_r51 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r51.updatePlanToCompareGroup(ctx_r51.plan, $event, _r41)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, LegacyPlanCardComponent_div_2_div_18_ng_container_1_ng_template_5_Template, 2, 4, "ng-template", null, 69, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(7, LegacyPlanCardComponent_div_2_div_18_ng_container_1_ng_container_7_Template, 4, 2, "ng-container", 13);
    i0.ɵɵtemplate(8, LegacyPlanCardComponent_div_2_div_18_ng_container_1_ng_template_8_Template, 1, 3, "ng-template", null, 70, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r42 = i0.ɵɵreference(6);
    const _r45 = i0.ɵɵreference(9);
    const ctx_r40 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("for", "Compare_", ctx_r40.plan.id, "");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "Compare_", ctx_r40.plan.id, "");
    i0.ɵɵpropertyInterpolate("value", ctx_r40.plan.id);
    i0.ɵɵproperty("ngbTooltip", _r42)("placement", ctx_r40.isShoppingTalkingPointEnabled ? "left" : "top-left left-top")("checked", ctx_r40.isSelectedToCompare(ctx_r40.plan));
    i0.ɵɵattribute("aria-checked", ctx_r40.isSelectedToCompare(ctx_r40.plan))("aria-label", ctx_r40.isSelectedToCompare(ctx_r40.plan) ? ctx_r40.Spa_PlanCard_CompareNow_Text : ctx_r40.Spa_PlanCard_AddToCompare_Text + " " + ctx_r40.plan.planName);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r40.isSelectedToCompare(ctx_r40.plan))("ngIfElse", _r45);
} }
const _c1$1d = function (a0, a1) { return { "col-sm-4": a0, "col-sm-5 col-lg-4": a1 }; };
function LegacyPlanCardComponent_div_2_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 64);
    i0.ɵɵtemplate(1, LegacyPlanCardComponent_div_2_div_18_ng_container_1_Template, 10, 10, "ng-container", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c1$1d, ctx_r15.showPlanLogo, !ctx_r15.showPlanLogo));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r15.hideCompareBox);
} }
function LegacyPlanCardComponent_div_2_vnext_link_25_Template(rf, ctx) { if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 75);
    i0.ɵɵlistener("click", function LegacyPlanCardComponent_div_2_vnext_link_25_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r54); const ctx_r53 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r53.quoteClick()); })("keyup.enter", function LegacyPlanCardComponent_div_2_vnext_link_25_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r54); const ctx_r55 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r55.quoteClick()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r16.Spa_PlanCard_QuoteLinkName_Text);
} }
function LegacyPlanCardComponent_div_2_ng_template_26_ng_container_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r62 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r62.planPremiumInitialRange);
} }
function LegacyPlanCardComponent_div_2_ng_template_26_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LegacyPlanCardComponent_div_2_ng_template_26_ng_container_1_span_1_Template, 2, 1, "span", 17);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "currency");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r56 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r56.snpPremiumRangeEnabled && ctx_r56.planPremiumInitialRange);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind4(3, 2, ctx_r56.planTotalPremium, "USD", "symbol", "1.2-2"), " ");
} }
function LegacyPlanCardComponent_div_2_ng_template_26_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r64 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-link", 78);
    i0.ɵɵlistener("click", function LegacyPlanCardComponent_div_2_ng_template_26_div_2_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r64); const ctx_r63 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r63.showSnpRangeModal()); })("keyup.enter", function LegacyPlanCardComponent_div_2_ng_template_26_div_2_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r64); const ctx_r65 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r65.showSnpRangeModal()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r57 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r57.snpRangeLinkText)("alwaysUnderlined", true);
} }
function LegacyPlanCardComponent_div_2_ng_template_26_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-plan-fees-tooltip", 79);
} if (rf & 2) {
    const ctx_r59 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("planFees", ctx_r59.plan.fees)("planTotalPremium", ctx_r59.planTotalPremium)("planFeesTooltipText", ctx_r59.planFeesTooltipText)("planFeesIncludedInPremiumTooltipText", ctx_r59.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r59.planFeesNotIncludedInPremiumTooltipText)("tooltipCustomClass", "inline-block-sm-layout");
} }
function LegacyPlanCardComponent_div_2_ng_template_26_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 80);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r60 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r60.monthlyPremiumText);
} }
const _c2$K = function (a0) { return { Spa_Style_Gray4_Color: a0 }; };
function LegacyPlanCardComponent_div_2_ng_template_26_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 82);
    i0.ɵɵelement(1, "i", 83);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r66 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c2$K, ctx_r66.isNotLicensedToSell));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r66.nonMonthlyRateText.replace("<paymentMethod>", ctx_r66.medSupPaymentMethodDisplayText[ctx_r66.medSupPaymentMethod]), " ");
} }
function LegacyPlanCardComponent_div_2_ng_template_26_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LegacyPlanCardComponent_div_2_ng_template_26_ng_container_6_div_1_Template, 3, 4, "div", 81);
    i0.ɵɵpipe(2, "rateFactorApplied");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r61 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r61.medSupPaymentMethod && ctx_r61.medSupPaymentMethod !== ctx_r61.medSupPaymentMethodEnum.MONTHLY && ctx_r61.nonMonthlyRateText && ctx_r61.medSupPaymentMethodDisplayText && !ctx_r61.Spa_Site_ShowPremiumAsAnnual && ctx_r61.showNonMonthlyRateText && ctx_r61.plan.rateFactors));
} }
function LegacyPlanCardComponent_div_2_ng_template_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 63);
    i0.ɵɵtemplate(1, LegacyPlanCardComponent_div_2_ng_template_26_ng_container_1_Template, 4, 7, "ng-container", 13);
    i0.ɵɵtemplate(2, LegacyPlanCardComponent_div_2_ng_template_26_div_2_Template, 2, 2, "div", 17);
    i0.ɵɵtemplate(3, LegacyPlanCardComponent_div_2_ng_template_26_ng_template_3_Template, 1, 6, "ng-template", null, 76, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, LegacyPlanCardComponent_div_2_ng_template_26_span_5_Template, 2, 1, "span", 77);
    i0.ɵɵtemplate(6, LegacyPlanCardComponent_div_2_ng_template_26_ng_container_6_Template, 3, 3, "ng-container", 17);
} if (rf & 2) {
    const _r58 = i0.ɵɵreference(4);
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c2$K, ctx_r18.isNotLicensedToSell));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r18.planFeesEnabled || !(ctx_r18.plan.fees == null ? null : ctx_r18.plan.fees.length))("ngIfElse", _r58);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.snpPremiumRangeEnabled && ctx_r18.planPremiumInitialRange);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r18.isHospitalCare);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.plan.planType === ctx_r18.planType.MEDIGAP);
} }
function LegacyPlanCardComponent_div_2_button_30_Template(rf, ctx) { if (rf & 1) {
    const _r68 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 84);
    i0.ɵɵlistener("click", function LegacyPlanCardComponent_div_2_button_30_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r68); const ctx_r67 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r67.viewPlanDetailsPage(ctx_r67.plan)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate2("title", "", ctx_r19.viewDetailsDescriptionText, " ", ctx_r19.plan.planName, "");
    i0.ɵɵattribute("aria-label", ctx_r19.viewDetailsDescriptionText + ctx_r19.plan.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r19.Spa_PlanCard_PlanDetails_ButtonText, " ");
} }
const _c3$t = function (a0, a1) { return { "col pl-1": a0, "col-12 mt-2": a1 }; };
function LegacyPlanCardComponent_div_2_vnext_shopping_cart_button_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-shopping-cart-button", 85);
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c3$t, !ctx_r20.isRetentionSummaryPage, ctx_r20.isRetentionSummaryPage))("plan", ctx_r20.plan);
} }
const _c4$f = function (a0) { return { "mt-2 btn1": a0 }; };
function LegacyPlanCardComponent_div_2_ng_container_32_Template(rf, ctx) { if (rf & 1) {
    const _r70 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-widget-plan-quote-button", 86);
    i0.ɵɵlistener("addToQuote", function LegacyPlanCardComponent_div_2_ng_container_32_Template_vnext_widget_plan_quote_button_addToQuote_1_listener($event) { i0.ɵɵrestoreView(_r70); const ctx_r69 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r69.addPlanToHospitalIndemnityCompareGroup($event.plan, $event.addToQuoteTooltip)); })("removePlanFromQuoteGroup", function LegacyPlanCardComponent_div_2_ng_container_32_Template_vnext_widget_plan_quote_button_removePlanFromQuoteGroup_1_listener($event) { i0.ɵɵrestoreView(_r70); const ctx_r71 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r71.removePlanToHospitalIndemnityCompareGroup($event.selectedQuoteGroup, $event.plan)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c4$f, ctx_r21.addToCartEnabled))("plan", ctx_r21.plan)("addToQuoteButtonText", ctx_r21.Spa_PlanCard_AddToQuote_Text)("removeFromQuoteButtonText", ctx_r21.Spa_PlanCard_RemoveFromQuote_Text)("addToQuoteWarningTooltip", ctx_r21.addToQuoteWarningTooltip)("selectedQuoteGroup", ctx_r21.selectedCompareGroup)("isPlanAddedToQuote", ctx_r21.isSelectedToCompare(ctx_r21.plan));
} }
const _c5$a = function (a0) { return { "mt-2 btn2": a0 }; };
function LegacyPlanCardComponent_div_2_div_33_Template(rf, ctx) { if (rf & 1) {
    const _r73 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 87)(1, "vnext-widget-plan-quote-button", 88);
    i0.ɵɵlistener("addToQuote", function LegacyPlanCardComponent_div_2_div_33_Template_vnext_widget_plan_quote_button_addToQuote_1_listener($event) { i0.ɵɵrestoreView(_r73); const ctx_r72 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r72.addPlanToQuote($event.plan, $event.addToQuoteTooltip)); })("removePlanFromQuoteGroup", function LegacyPlanCardComponent_div_2_div_33_Template_vnext_widget_plan_quote_button_removePlanFromQuoteGroup_1_listener($event) { i0.ɵɵrestoreView(_r73); const ctx_r74 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r74.planFacade.removePlanFromQuoteGroup($event.selectedQuoteGroup, $event.plan)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c5$a, ctx_r22.addToCartEnabled))("plan", ctx_r22.plan)("addToQuoteButtonText", ctx_r22.Spa_PlanCard_AddToQuote_Text)("removeFromQuoteButtonText", ctx_r22.Spa_PlanCard_RemoveFromQuote_Text)("addToQuoteWarningTooltip", ctx_r22.Spa_PlanCard_AddToQuote_Warning_Tooltip)("selectedQuoteGroup", ctx_r22.selectedQuoteGroup)("isPlanAddedToQuote", ctx_r22.isPlanAddedToQuote(ctx_r22.plan));
} }
function LegacyPlanCardComponent_div_2_ng_container_37_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-benefits", 91);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r75 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", ctx_r75.plan)("annualCost", ctx_r75.annualCost)("planBenefits", ctx_r75.planBenefits)("planBenefitNoValueLabel", ctx_r75.Spa_Site_NotApplicable_Text)("isNotLicensedToSell", ctx_r75.isNotLicensedToSell);
} }
function LegacyPlanCardComponent_div_2_ng_container_37_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-benefits", 91);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r76 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", ctx_r76.plan)("annualCost", ctx_r76.annualCost)("planBenefits", ctx_r76.planBenefits)("planBenefitNoValueLabel", ctx_r76.Spa_Site_NotApplicable_Text)("isNotLicensedToSell", ctx_r76.isNotLicensedToSell);
} }
function LegacyPlanCardComponent_div_2_ng_container_37_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-benefits", 91);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r77 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", ctx_r77.plan)("annualCost", ctx_r77.annualCost)("planBenefits", ctx_r77.planBenefits)("planBenefitNoValueLabel", ctx_r77.Spa_Site_NotApplicable_Text)("isNotLicensedToSell", ctx_r77.isNotLicensedToSell);
} }
function LegacyPlanCardComponent_div_2_ng_container_37_ng_container_5_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-benefits", 91);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r81 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", ctx_r81.plan)("annualCost", ctx_r81.annualCost)("planBenefits", ctx_r81.planBenefits)("planBenefitNoValueLabel", ctx_r81.Spa_Site_NotApplicable_Text)("isNotLicensedToSell", ctx_r81.isNotLicensedToSell);
} }
function LegacyPlanCardComponent_div_2_ng_container_37_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LegacyPlanCardComponent_div_2_ng_container_37_ng_container_5_div_1_Template, 2, 5, "div", 17);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r78 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r78.activeTabType === ctx_r78.planTypeAbbreviation.DENTAL);
} }
function LegacyPlanCardComponent_div_2_ng_container_37_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-benefits", 91);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r82 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", ctx_r82.plan)("annualCost", ctx_r82.annualCost)("planBenefits", ctx_r82.planBenefits)("planBenefitNoValueLabel", ctx_r82.Spa_Site_NotApplicable_Text)("isNotLicensedToSell", ctx_r82.isNotLicensedToSell);
} }
function LegacyPlanCardComponent_div_2_ng_container_37_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LegacyPlanCardComponent_div_2_ng_container_37_ng_container_6_div_1_Template, 2, 5, "div", 17);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r79 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r79.activeTabType === ctx_r79.planTypeAbbreviation.DENTAL);
} }
function LegacyPlanCardComponent_div_2_ng_container_37_ng_container_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 93)(1, "div", 94);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 95);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r83 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c2$K, ctx_r83.isNotLicensedToSell));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r83.Spa_PlanCard_PlanType_Text, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c2$K, ctx_r83.isNotLicensedToSell));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r83.plan.planSubType, " ");
} }
function LegacyPlanCardComponent_div_2_ng_container_37_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LegacyPlanCardComponent_div_2_ng_container_37_ng_container_7_div_1_Template, 5, 8, "div", 92);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r80 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r80.planType.MEDIGAP);
} }
function LegacyPlanCardComponent_div_2_ng_container_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 89);
    i0.ɵɵtemplate(2, LegacyPlanCardComponent_div_2_ng_container_37_div_2_Template, 2, 5, "div", 90);
    i0.ɵɵtemplate(3, LegacyPlanCardComponent_div_2_ng_container_37_div_3_Template, 2, 5, "div", 90);
    i0.ɵɵtemplate(4, LegacyPlanCardComponent_div_2_ng_container_37_div_4_Template, 2, 5, "div", 90);
    i0.ɵɵtemplate(5, LegacyPlanCardComponent_div_2_ng_container_37_ng_container_5_Template, 2, 1, "ng-container", 90);
    i0.ɵɵtemplate(6, LegacyPlanCardComponent_div_2_ng_container_37_ng_container_6_Template, 2, 1, "ng-container", 90);
    i0.ɵɵtemplate(7, LegacyPlanCardComponent_div_2_ng_container_37_ng_container_7_Template, 2, 1, "ng-container", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r23.plan.planType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r23.planType.MAPD);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r23.planType.MA);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r23.planType.PDP);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r23.planType.DENTAL);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r23.planType.VISION);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r23.Spa_Site_MedigapPlanType_Enabled);
} }
function LegacyPlanCardComponent_div_2_vnext_link_42_Template(rf, ctx) { if (rf & 1) {
    const _r85 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 96);
    i0.ɵɵlistener("click", function LegacyPlanCardComponent_div_2_vnext_link_42_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r85); const ctx_r84 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r84.quoteClick()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r24.Spa_PlanCard_QuoteLinkName_Text);
} }
function LegacyPlanCardComponent_div_2_div_45_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 97);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r25.moreBenefitsInstructionText, " ");
} }
function LegacyPlanCardComponent_div_2_div_46_vnext_plan_card_riders_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-plan-card-riders", 100);
} if (rf & 2) {
    const ctx_r86 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("selectedPlanType", ctx_r86.plan.planType)("showMedSupAddOnCoverageText", ctx_r86.showMedSupAddOnCoverageText)("addOnCoverageTooltipBody", ctx_r86.Spa_PlanCard_AddOnCoverageTooltip_Body)("addOnCoverageInCartText", ctx_r86.Spa_PlanCard_AddOnCoverageInCart_Text)("planRiderCategories", ctx_r86.riderFacade.getRiderCategories(ctx_r86.plan.riders))("Spa_Site_ShowRiderIcons", ctx_r86.Spa_Site_ShowRiderIcons)("Spa_Site_Dental_Rider_Display_Text", ctx_r86.Spa_Site_Dental_Rider_Display_Text)("Spa_Site_Vision_Rider_Display_Text", ctx_r86.Spa_Site_Vision_Rider_Display_Text)("Spa_Site_Hearing_Rider_Display_Text", ctx_r86.Spa_Site_Hearing_Rider_Display_Text)("Spa_PlanCard_DentalAddOnCoverage_Text", ctx_r86.Spa_PlanCard_DentalAddOnCoverage_Text)("Spa_PlanCard_HearingAddOnCoverage_Text", ctx_r86.Spa_PlanCard_HearingAddOnCoverage_Text)("Spa_PlanCard_VisionAddOnCoverage_Text", ctx_r86.Spa_PlanCard_VisionAddOnCoverage_Text)("Spa_PlanCard_AddOnCoverage_Text", ctx_r86.Spa_PlanCard_AddOnCoverage_Text)("Spa_Site_Tooltip_Text", ctx_r86.Spa_Site_Tooltip_Text)("isNotLicensedToSell", ctx_r86.isNotLicensedToSell);
} }
function LegacyPlanCardComponent_div_2_div_46_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 98);
    i0.ɵɵtemplate(1, LegacyPlanCardComponent_div_2_div_46_vnext_plan_card_riders_1_Template, 1, 15, "vnext-plan-card-riders", 99);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r26.showRiderSection());
} }
function LegacyPlanCardComponent_div_2_ng_container_47_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r91 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 104);
    i0.ɵɵlistener("click", function LegacyPlanCardComponent_div_2_ng_container_47_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r91); const ctx_r90 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r90.viewPlanDetailsPage(ctx_r90.plan)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r87 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("title", "", ctx_r87.viewDetailsDescriptionText, " ", ctx_r87.plan.planName, "");
    i0.ɵɵattribute("aria-label", ctx_r87.viewDetailsDescriptionText + ctx_r87.plan.planName)("role", ctx_r87.linkRoles.LINK);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r87.Spa_PlanCard_PlanDetails_ButtonText, " ");
} }
function LegacyPlanCardComponent_div_2_ng_container_47_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 105);
    i0.ɵɵelement(1, "vnext-shopping-cart-button", 106);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r88 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", ctx_r88.plan)("queuePosition", ctx_r88.queuePosition);
} }
const _c6$9 = function (a0) { return { "mt-2 btn3": a0 }; };
function LegacyPlanCardComponent_div_2_ng_container_47_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r93 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-widget-plan-quote-button", 107);
    i0.ɵɵlistener("addToQuote", function LegacyPlanCardComponent_div_2_ng_container_47_ng_container_4_Template_vnext_widget_plan_quote_button_addToQuote_1_listener($event) { i0.ɵɵrestoreView(_r93); const ctx_r92 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r92.addPlanToHospitalIndemnityCompareGroup($event.plan, $event.addToQuoteTooltip)); })("removePlanFromQuoteGroup", function LegacyPlanCardComponent_div_2_ng_container_47_ng_container_4_Template_vnext_widget_plan_quote_button_removePlanFromQuoteGroup_1_listener($event) { i0.ɵɵrestoreView(_r93); const ctx_r94 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r94.removePlanToHospitalIndemnityCompareGroup($event.selectedQuoteGroup, $event.plan)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r89 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c6$9, ctx_r89.addToCartEnabled))("plan", ctx_r89.plan)("addToQuoteButtonText", ctx_r89.Spa_PlanCard_AddToQuote_Text)("removeFromQuoteButtonText", ctx_r89.Spa_PlanCard_RemoveFromQuote_Text)("addToQuoteWarningTooltip", ctx_r89.addToQuoteWarningTooltip)("selectedQuoteGroup", ctx_r89.selectedCompareGroup)("isPlanAddedToQuote", ctx_r89.isSelectedToCompare(ctx_r89.plan));
} }
function LegacyPlanCardComponent_div_2_ng_container_47_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 101);
    i0.ɵɵtemplate(2, LegacyPlanCardComponent_div_2_ng_container_47_button_2_Template, 2, 5, "button", 102);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, LegacyPlanCardComponent_div_2_ng_container_47_div_3_Template, 2, 2, "div", 103);
    i0.ɵɵtemplate(4, LegacyPlanCardComponent_div_2_ng_container_47_ng_container_4_Template, 2, 9, "ng-container", 17);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("className", ctx_r27.planDetailsButtonClass);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r27.Spa_Site_PlanViewDetails_Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r27.addToCartEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r27.isHospitalCare && ctx_r27.isAddToQuoteAvailable);
} }
function LegacyPlanCardComponent_div_2_ng_template_48_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r97 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 104);
    i0.ɵɵlistener("click", function LegacyPlanCardComponent_div_2_ng_template_48_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r97); const ctx_r96 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r96.viewPlanDetailsPage(ctx_r96.plan)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r95 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate2("title", "", ctx_r95.viewDetailsDescriptionText, " ", ctx_r95.plan.planName, "");
    i0.ɵɵattribute("aria-label", ctx_r95.viewDetailsDescriptionText + ctx_r95.plan.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r95.Spa_PlanCard_PlanDetails_ButtonText, " ");
} }
function LegacyPlanCardComponent_div_2_ng_template_48_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 108);
    i0.ɵɵtemplate(1, LegacyPlanCardComponent_div_2_ng_template_48_button_1_Template, 2, 4, "button", 102);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r29.Spa_Site_PlanViewDetails_Enabled);
} }
function LegacyPlanCardComponent_div_2_div_50_vnext_plan_card_riders_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-plan-card-riders", 100);
} if (rf & 2) {
    const ctx_r98 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("selectedPlanType", ctx_r98.plan.planType)("showMedSupAddOnCoverageText", ctx_r98.showMedSupAddOnCoverageText)("addOnCoverageTooltipBody", ctx_r98.Spa_PlanCard_AddOnCoverageTooltip_Body)("addOnCoverageInCartText", ctx_r98.Spa_PlanCard_AddOnCoverageInCart_Text)("planRiderCategories", ctx_r98.riderFacade.getRiderCategories(ctx_r98.plan.riders))("Spa_Site_ShowRiderIcons", ctx_r98.Spa_Site_ShowRiderIcons)("Spa_Site_Dental_Rider_Display_Text", ctx_r98.Spa_Site_Dental_Rider_Display_Text)("Spa_Site_Vision_Rider_Display_Text", ctx_r98.Spa_Site_Vision_Rider_Display_Text)("Spa_Site_Hearing_Rider_Display_Text", ctx_r98.Spa_Site_Hearing_Rider_Display_Text)("Spa_PlanCard_DentalAddOnCoverage_Text", ctx_r98.Spa_PlanCard_DentalAddOnCoverage_Text)("Spa_PlanCard_HearingAddOnCoverage_Text", ctx_r98.Spa_PlanCard_HearingAddOnCoverage_Text)("Spa_PlanCard_VisionAddOnCoverage_Text", ctx_r98.Spa_PlanCard_VisionAddOnCoverage_Text)("Spa_PlanCard_AddOnCoverage_Text", ctx_r98.Spa_PlanCard_AddOnCoverage_Text)("Spa_Site_Tooltip_Text", ctx_r98.Spa_Site_Tooltip_Text)("isNotLicensedToSell", ctx_r98.isNotLicensedToSell);
} }
const _c7$7 = function (a0) { return { "mt-2 btn4": a0 }; };
function LegacyPlanCardComponent_div_2_div_50_Template(rf, ctx) { if (rf & 1) {
    const _r100 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 109)(1, "div", 110);
    i0.ɵɵtemplate(2, LegacyPlanCardComponent_div_2_div_50_vnext_plan_card_riders_2_Template, 1, 15, "vnext-plan-card-riders", 99);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "vnext-widget-plan-quote-button", 107);
    i0.ɵɵlistener("addToQuote", function LegacyPlanCardComponent_div_2_div_50_Template_vnext_widget_plan_quote_button_addToQuote_3_listener($event) { i0.ɵɵrestoreView(_r100); const ctx_r99 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r99.addPlanToQuote($event.plan, $event.addToQuoteTooltip)); })("removePlanFromQuoteGroup", function LegacyPlanCardComponent_div_2_div_50_Template_vnext_widget_plan_quote_button_removePlanFromQuoteGroup_3_listener($event) { i0.ɵɵrestoreView(_r100); const ctx_r101 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r101.planFacade.removePlanFromQuoteGroup($event.selectedQuoteGroup, $event.plan)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r30.showRiderSection());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c7$7, ctx_r30.addToCartEnabled))("plan", ctx_r30.plan)("addToQuoteButtonText", ctx_r30.Spa_PlanCard_AddToQuote_Text)("removeFromQuoteButtonText", ctx_r30.Spa_PlanCard_RemoveFromQuote_Text)("addToQuoteWarningTooltip", ctx_r30.Spa_PlanCard_AddToQuote_Warning_Tooltip)("selectedQuoteGroup", ctx_r30.selectedQuoteGroup)("isPlanAddedToQuote", ctx_r30.isPlanAddedToQuote(ctx_r30.plan));
} }
function LegacyPlanCardComponent_div_2_ng_container_51_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-card-supplemental-benefits", 114);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r105 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("supplementalBenefits", ctx_r105.Spa_PlanCard_SupplementalBenefits_List)("planBenefits", ctx_r105.plan.planDataFields)("hideLinkText", ctx_r105.hideLinkText)("viewAllLinkText", ctx_r105.viewAllLinkText)("isMobile", ctx_r105.isMobile)("availableText", ctx_r105.availableText)("unavailableText", ctx_r105.unavailableText)("supplementalBenefitsHighlightText", ctx_r105.supplementalBenefitsHighlightText);
} }
function LegacyPlanCardComponent_div_2_ng_container_51_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 112);
    i0.ɵɵelement(1, "vnext-plan-coverage-preferences", 113);
    i0.ɵɵtemplate(2, LegacyPlanCardComponent_div_2_ng_container_51_div_2_div_2_Template, 2, 8, "div", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r102 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pharmacyNotCoveredText", ctx_r102.Spa_PlanDetails_Non_Covered_Text)("plan", ctx_r102.plan)("prescriptionsText", ctx_r102.Spa_Site_Prescriptions_Text)("pharmacyText", ctx_r102.Spa_Site_Pharmacy_Text)("pharmacyCoveredText", ctx_r102.pharmacyCoverageText)("addedPharmacy", ctx_r102.selectedPharmacy)("drugCoverageText", ctx_r102.getDrugCoverageText(ctx_r102.drugCount, ctx_r102.plan))("showDrugCoverage", ctx_r102.showDrugCoverage(ctx_r102.drugCount))("planPreferences", ctx_r102.planPreferences)("totalEstimatedAnnualCostText", ctx_r102.Spa_PlanCard_TotalEstimatedAnnualCost_Text)("totalEstimatedCostText", ctx_r102.Spa_PlanCard_TotalEstimatedCost_Text)("totalEstimatedCostTooltip", ctx_r102.Spa_PlanCard_Total_Estimated_Cost_Tooltip)("isTotalEstimatedCostEnabled", ctx_r102.Spa_Site_TotalEstimatedCost_Enabled)("isEnabledShowDrugAlternatives", ctx_r102.Spa_Site_ShowDrugAlternatives_Enabled)("showNudgeDrugAlternatives", ctx_r102.Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled)("drugAlternativesTooltipText", ctx_r102.Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text)("nudgeDrugAlternativesLabelText", ctx_r102.Spa_PlanCard_ShowDrugAlternatives_Nudge_Text)("drugAlternativesIndicatorIcon", ctx_r102.Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon)("isRetention", ctx_r102.isRetentionView)("isQuoting", ctx_r102.isQuotingSite)("noCostAvailableText", ctx_r102.noCostAvailableText)("Spa_Site_Tooltip_Text", ctx_r102.Spa_Site_Tooltip_Text)("viewCostTooltipHeaderText", ctx_r102.viewCostTooltipHeaderText)("viewCostTooltipHeaderContent", ctx_r102.viewCostTooltipHeaderContent)("inNetworkPreferredText", ctx_r102.inNetworkPreferredText)("inNetworkStandardText", ctx_r102.inNetworkStandardText)("outOfNetworkText", ctx_r102.outOfNetworkText)("annualCost", ctx_r102.annualCost)("showMailOrderLabel", ctx_r102.isMailOrderSelected)("isMailOrderSelected", ctx_r102.isMailOrderSelected)("medicineCabinet", ctx_r102.medicineCabinet)("mailOrderText", ctx_r102.mailOrderText)("totalCostEffectiveDate", ctx_r102.totalCostEffectiveDate)("selectedProviders", ctx_r102.selectedProviders)("planCardPreferenceDetailedEnabled", ctx_r102.planCardPreferenceDetailedEnabled)("providerDetails", ctx_r102.providerDetails)("showProviderInNetworkOnOtherLocation", ctx_r102.planCardTile == null ? null : ctx_r102.planCardTile.showProviderInNetworkOnOtherLocation)("providersCoveredText", ctx_r102.planCardTile == null ? null : ctx_r102.planCardTile.providersCoveredText)("providerPcpText", ctx_r102.planCardTile == null ? null : ctx_r102.planCardTile.providerPcpText)("loaderIconEnabled", ctx_r102.loaderIconEnabled)("editLinkText", ctx_r102.editLinkText)("providerOneOrMoreOutOfNetworkText", ctx_r102.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r102.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r102.providerShowPartialIndicatorEnabled)("viewProvidersButtonText", ctx_r102.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r102.viewPrescriptionsButtonText)("isVbcAgreementEnabled", ctx_r102.isVbcAgreementEnabled)("vbcAgreementLabel", ctx_r102.vbcAgreementLabel)("vbcAgreementTooltip", ctx_r102.vbcAgreementTooltip);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r102.Spa_PlanCard_SupplementalBenefits_Enabled);
} }
function LegacyPlanCardComponent_div_2_ng_container_51_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-card-supplemental-benefits", 114);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r106 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("supplementalBenefits", ctx_r106.Spa_PlanCard_SupplementalBenefits_List)("planBenefits", ctx_r106.plan.planDataFields)("hideLinkText", ctx_r106.hideLinkText)("viewAllLinkText", ctx_r106.viewAllLinkText)("isMobile", ctx_r106.isMobile)("availableText", ctx_r106.availableText)("unavailableText", ctx_r106.unavailableText)("supplementalBenefitsHighlightText", ctx_r106.supplementalBenefitsHighlightText);
} }
function LegacyPlanCardComponent_div_2_ng_container_51_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 112);
    i0.ɵɵelement(1, "vnext-plan-coverage-preferences", 115);
    i0.ɵɵtemplate(2, LegacyPlanCardComponent_div_2_ng_container_51_div_3_div_2_Template, 2, 8, "div", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r103 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pharmacyNotCoveredText", ctx_r103.Spa_PlanDetails_Non_Covered_Text)("plan", ctx_r103.plan)("prescriptionsText", ctx_r103.Spa_Site_Prescriptions_Text)("pharmacyText", ctx_r103.Spa_Site_Pharmacy_Text)("pharmacyCoveredText", ctx_r103.pharmacyCoverageText)("addedPharmacy", ctx_r103.selectedPharmacy)("drugCoverageText", ctx_r103.getDrugCoverageText(ctx_r103.drugCount, ctx_r103.plan))("showDrugCoverage", ctx_r103.showDrugCoverage(ctx_r103.drugCount))("planPreferences", ctx_r103.planPreferences)("totalEstimatedAnnualCostText", ctx_r103.Spa_PlanCard_TotalEstimatedAnnualCost_Text)("totalEstimatedCostText", ctx_r103.Spa_PlanCard_TotalEstimatedCost_Text)("totalEstimatedCostTooltip", ctx_r103.Spa_PlanCard_Total_Estimated_Cost_Tooltip)("isTotalEstimatedCostEnabled", ctx_r103.Spa_Site_TotalEstimatedCost_Enabled)("isEnabledShowDrugAlternatives", ctx_r103.Spa_Site_ShowDrugAlternatives_Enabled)("showNudgeDrugAlternatives", ctx_r103.Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled)("drugAlternativesTooltipText", ctx_r103.Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text)("nudgeDrugAlternativesLabelText", ctx_r103.Spa_PlanCard_ShowDrugAlternatives_Nudge_Text)("drugAlternativesIndicatorIcon", ctx_r103.Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon)("isRetention", ctx_r103.isRetentionView)("isQuoting", ctx_r103.isQuotingSite)("noCostAvailableText", ctx_r103.noCostAvailableText)("Spa_Site_Tooltip_Text", ctx_r103.Spa_Site_Tooltip_Text)("inNetworkPreferredText", ctx_r103.inNetworkPreferredText)("inNetworkStandardText", ctx_r103.inNetworkStandardText)("outOfNetworkText", ctx_r103.outOfNetworkText)("annualCost", ctx_r103.annualCost)("medicineCabinet", ctx_r103.medicineCabinet)("totalCostEffectiveDate", ctx_r103.totalCostEffectiveDate)("selectedProviders", ctx_r103.selectedProviders)("planCardPreferenceDetailedEnabled", ctx_r103.planCardPreferenceDetailedEnabled)("providerDetails", ctx_r103.providerDetails)("showProviderInNetworkOnOtherLocation", ctx_r103.planCardTile == null ? null : ctx_r103.planCardTile.showProviderInNetworkOnOtherLocation)("providersCoveredText", ctx_r103.planCardTile == null ? null : ctx_r103.planCardTile.providersCoveredText)("providerPcpText", ctx_r103.planCardTile == null ? null : ctx_r103.planCardTile.providerPcpText)("loaderIconEnabled", ctx_r103.loaderIconEnabled)("editLinkText", ctx_r103.editLinkText)("providerOneOrMoreOutOfNetworkText", ctx_r103.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r103.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r103.providerShowPartialIndicatorEnabled)("viewProvidersButtonText", ctx_r103.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r103.viewPrescriptionsButtonText)("isVbcAgreementEnabled", ctx_r103.isVbcAgreementEnabled)("vbcAgreementLabel", ctx_r103.vbcAgreementLabel)("vbcAgreementTooltip", ctx_r103.vbcAgreementTooltip);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r103.Spa_PlanCard_SupplementalBenefits_Enabled);
} }
function LegacyPlanCardComponent_div_2_ng_container_51_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 112);
    i0.ɵɵelement(1, "vnext-plan-coverage-preferences", 116);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r104 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pharmacyNotCoveredText", ctx_r104.Spa_PlanDetails_Non_Covered_Text)("plan", ctx_r104.plan)("prescriptionsText", ctx_r104.Spa_Site_Prescriptions_Text)("pharmacyText", ctx_r104.Spa_Site_Pharmacy_Text)("pharmacyCoveredText", ctx_r104.pharmacyCoverageText)("addedPharmacy", ctx_r104.selectedPharmacy)("drugCoverageText", ctx_r104.getDrugCoverageText(ctx_r104.drugCount, ctx_r104.plan))("showDrugCoverage", ctx_r104.showDrugCoverage(ctx_r104.drugCount))("planPreferences", ctx_r104.planPreferences)("totalEstimatedAnnualCostText", ctx_r104.Spa_PlanCard_TotalEstimatedAnnualCost_Text)("totalEstimatedCostText", ctx_r104.Spa_PlanCard_TotalEstimatedCost_Text)("totalEstimatedCostTooltip", ctx_r104.Spa_PlanCard_Total_Estimated_Cost_Tooltip)("isTotalEstimatedCostEnabled", ctx_r104.Spa_Site_TotalEstimatedCost_Enabled)("isEnabledShowDrugAlternatives", ctx_r104.Spa_Site_ShowDrugAlternatives_Enabled)("showNudgeDrugAlternatives", ctx_r104.Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled)("drugAlternativesTooltipText", ctx_r104.Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text)("nudgeDrugAlternativesLabelText", ctx_r104.Spa_PlanCard_ShowDrugAlternatives_Nudge_Text)("drugAlternativesIndicatorIcon", ctx_r104.Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon)("isRetention", ctx_r104.isRetentionView)("isQuoting", ctx_r104.isQuotingSite)("noCostAvailableText", ctx_r104.noCostAvailableText)("Spa_Site_Tooltip_Text", ctx_r104.Spa_Site_Tooltip_Text)("viewCostTooltipHeaderText", ctx_r104.viewCostTooltipHeaderText)("viewCostTooltipHeaderContent", ctx_r104.viewCostTooltipHeaderContent)("inNetworkPreferredText", ctx_r104.inNetworkPreferredText)("inNetworkStandardText", ctx_r104.inNetworkStandardText)("outOfNetworkText", ctx_r104.outOfNetworkText)("annualCost", ctx_r104.annualCost)("showMailOrderLabel", ctx_r104.isMailOrderSelected)("isMailOrderSelected", ctx_r104.isMailOrderSelected)("medicineCabinet", ctx_r104.medicineCabinet)("mailOrderText", ctx_r104.mailOrderText)("totalCostEffectiveDate", ctx_r104.totalCostEffectiveDate)("selectedProviders", ctx_r104.selectedProviders)("planCardPreferenceDetailedEnabled", ctx_r104.planCardPreferenceDetailedEnabled)("providerDetails", ctx_r104.providerDetails)("loaderIconEnabled", ctx_r104.loaderIconEnabled)("editLinkText", ctx_r104.editLinkText)("providerOneOrMoreOutOfNetworkText", ctx_r104.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r104.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r104.providerShowPartialIndicatorEnabled)("viewProvidersButtonText", ctx_r104.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r104.viewPrescriptionsButtonText)("isVbcAgreementEnabled", ctx_r104.isVbcAgreementEnabled)("vbcAgreementLabel", ctx_r104.vbcAgreementLabel)("vbcAgreementTooltip", ctx_r104.vbcAgreementTooltip);
} }
function LegacyPlanCardComponent_div_2_ng_container_51_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵtemplate(2, LegacyPlanCardComponent_div_2_ng_container_51_div_2_Template, 3, 50, "div", 111);
    i0.ɵɵtemplate(3, LegacyPlanCardComponent_div_2_ng_container_51_div_3_Template, 3, 45, "div", 111);
    i0.ɵɵtemplate(4, LegacyPlanCardComponent_div_2_ng_container_51_div_4_Template, 2, 46, "div", 111);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r31.plan.planType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r31.planType.MAPD);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r31.planType.MA);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r31.planType.PDP);
} }
function LegacyPlanCardComponent_div_2_ng_container_52_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-widget-plan-card-rate-factors-statuses", 117);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("rateFactorsStatus", ctx_r32.plan.rateFactorsStatuses)("availableRateFactorsData", ctx_r32.availableRateFactorsData)("personalizedQuoteLabelText", ctx_r32.personalizedQuoteLabelText);
} }
function LegacyPlanCardComponent_div_2_ng_template_53_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 118)(2, "div", 119);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r34.nonLicensedMessageText, " ");
} }
const _c8$5 = function (a0, a1, a2) { return { "Spa_Style_Accent6_Border": a0, "Spa_Style_Primary_Link_Border": a1, "plan-card-border": a2 }; };
const _c9$2 = function (a0, a1) { return { "col-sm-7 col-lg-8": a0, "col-sm": a1 }; };
const _c10$2 = function (a0, a1, a2) { return { "col": a0, "col-12": a1, "pr-sm-3 offset-sm-4": a2 }; };
function LegacyPlanCardComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7)(2, "header", 8);
    i0.ɵɵtemplate(3, LegacyPlanCardComponent_div_2_div_3_Template, 3, 4, "div", 9);
    i0.ɵɵelementStart(4, "div", 10);
    i0.ɵɵtemplate(5, LegacyPlanCardComponent_div_2_ng_template_5_Template, 2, 4, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(7, "h2", 12);
    i0.ɵɵtemplate(8, LegacyPlanCardComponent_div_2_ng_container_8_Template, 4, 2, "ng-container", 13);
    i0.ɵɵtemplate(9, LegacyPlanCardComponent_div_2_ng_template_9_Template, 3, 2, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainer(11, 15);
    i0.ɵɵtemplate(12, LegacyPlanCardComponent_div_2_span_12_Template, 4, 3, "span", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, LegacyPlanCardComponent_div_2_div_13_Template, 2, 1, "div", 17);
    i0.ɵɵtemplate(14, LegacyPlanCardComponent_div_2_div_14_Template, 5, 2, "div", 18);
    i0.ɵɵtemplate(15, LegacyPlanCardComponent_div_2_div_15_Template, 2, 5, "div", 19);
    i0.ɵɵtemplate(16, LegacyPlanCardComponent_div_2_div_16_Template, 3, 14, "div", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, LegacyPlanCardComponent_div_2_div_17_Template, 3, 5, "div", 20);
    i0.ɵɵtemplate(18, LegacyPlanCardComponent_div_2_div_18_Template, 2, 5, "div", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div")(20, "div", 22)(21, "div", 2)(22, "div", 23)(23, "div", 24);
    i0.ɵɵtext(24);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(25, LegacyPlanCardComponent_div_2_vnext_link_25_Template, 1, 1, "vnext-link", 25);
    i0.ɵɵtemplate(26, LegacyPlanCardComponent_div_2_ng_template_26_Template, 7, 8, "ng-template", null, 26, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(28, "div", 27)(29, "div", 28);
    i0.ɵɵtemplate(30, LegacyPlanCardComponent_div_2_button_30_Template, 2, 4, "button", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(31, LegacyPlanCardComponent_div_2_vnext_shopping_cart_button_31_Template, 1, 5, "vnext-shopping-cart-button", 30);
    i0.ɵɵtemplate(32, LegacyPlanCardComponent_div_2_ng_container_32_Template, 2, 9, "ng-container", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(33, LegacyPlanCardComponent_div_2_div_33_Template, 2, 9, "div", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 32)(35, "div", 2)(36, "div", 33);
    i0.ɵɵtemplate(37, LegacyPlanCardComponent_div_2_ng_container_37_Template, 8, 7, "ng-container", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "div", 34)(39, "div", 35)(40, "div", 36);
    i0.ɵɵtext(41);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(42, LegacyPlanCardComponent_div_2_vnext_link_42_Template, 1, 1, "vnext-link", 37);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementStart(43, "div", 38)(44, "div", 39);
    i0.ɵɵtemplate(45, LegacyPlanCardComponent_div_2_div_45_Template, 2, 1, "div", 40);
    i0.ɵɵtemplate(46, LegacyPlanCardComponent_div_2_div_46_Template, 2, 1, "div", 41);
    i0.ɵɵtemplate(47, LegacyPlanCardComponent_div_2_ng_container_47_Template, 5, 4, "ng-container", 13);
    i0.ɵɵtemplate(48, LegacyPlanCardComponent_div_2_ng_template_48_Template, 2, 1, "ng-template", null, 42, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(50, LegacyPlanCardComponent_div_2_div_50_Template, 4, 10, "div", 43);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(51, LegacyPlanCardComponent_div_2_ng_container_51_Template, 5, 4, "ng-container", 13);
    i0.ɵɵtemplate(52, LegacyPlanCardComponent_div_2_ng_container_52_Template, 2, 3, "ng-container", 17);
    i0.ɵɵtemplate(53, LegacyPlanCardComponent_div_2_ng_template_53_Template, 4, 1, "ng-template", null, 44, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r7 = i0.ɵɵreference(10);
    const _r17 = i0.ɵɵreference(27);
    const _r28 = i0.ɵɵreference(49);
    const _r33 = i0.ɵɵreference(54);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("id", "PlanCard_", ctx_r2.plan.id, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(37, _c8$5, ctx_r2.plan.isCurrentYearPlan, ctx_r2.displayLinkBorder, !ctx_r2.plan.isCurrentYearPlan && (!ctx_r2.plan.isNextYearPlan || ctx_r2.plan.isPlanRolloverTerminated)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.showPlanLogo);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(41, _c9$2, !ctx_r2.showPlanLogo, ctx_r2.showPlanLogo));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(44, _c2$K, ctx_r2.isNotLicensedToSell));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isHospitalCare)("ngIfElse", _r7);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngSwitch", ctx_r2.plan.planTypeAbbreviation);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.showComboToolTip);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.showPlanYear);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.showPlanId && ctx_r2.fullPlanId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.showRatingMethod);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.showStarRating);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.showPreferenceScore);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.Spa_Site_AddToCompare_Enabled);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(46, _c2$K, ctx_r2.isNotLicensedToSell));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.premiumLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.hasPremium)("ngIfElse", _r17);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(48, _c10$2, !ctx_r2.isRetentionSummaryPage, ctx_r2.isRetentionSummaryPage, ctx_r2.isDentalPlan));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.Spa_Site_PlanViewDetails_Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.hasPremium && ctx_r2.addToCartEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isHospitalCare);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isAncillary && ctx_r2.isAddToQuoteAvailable);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r2.annualCost);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(52, _c2$K, ctx_r2.isNotLicensedToSell));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.premiumLabel, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.hasPremium)("ngIfElse", _r17);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.isHospitalCare);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isHospitalCare && (!ctx_r2.isAddToQuoteAvailable || ctx_r2.isDentalPlan || ctx_r2.isVisionPlan));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.hasPremium)("ngIfElse", _r28);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.isAddToQuoteAvailable && !ctx_r2.isAncillary);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.annualCost && ctx_r2.showPlanCoveragePreferences())("ngIfElse", _r33);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.showAvailableRateFactorsEnabled && ctx_r2.plan.planType === ctx_r2.planType.MEDIGAP && (ctx_r2.plan.rateFactorsStatuses == null ? null : ctx_r2.plan.rateFactorsStatuses.length));
} }
class LegacyPlanCardComponent extends PlanCardBaseComponent {
    constructor(navigationService, planFacade, demographicService, riderFacade, planCompareService, responsiveLayoutService, planCardFacade, quoteService, analyticsService, localeService, cdr, planDetailsFacade, guidedHelpService) {
        super(navigationService, planFacade, demographicService, riderFacade, planCompareService, responsiveLayoutService, planCardFacade, quoteService, analyticsService, localeService, cdr, planDetailsFacade, guidedHelpService);
        this.navigationService = navigationService;
        this.planFacade = planFacade;
        this.demographicService = demographicService;
        this.riderFacade = riderFacade;
        this.planCompareService = planCompareService;
        this.responsiveLayoutService = responsiveLayoutService;
        this.planCardFacade = planCardFacade;
        this.quoteService = quoteService;
        this.analyticsService = analyticsService;
        this.localeService = localeService;
        this.cdr = cdr;
        this.planDetailsFacade = planDetailsFacade;
        this.guidedHelpService = guidedHelpService;
    }
}
LegacyPlanCardComponent.ɵfac = function LegacyPlanCardComponent_Factory(t) { return new (t || LegacyPlanCardComponent)(i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.DemographicService), i0.ɵɵdirectiveInject(RiderFacade), i0.ɵɵdirectiveInject(i1.PlanCompareService), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService), i0.ɵɵdirectiveInject(PlanCardFacade), i0.ɵɵdirectiveInject(i1.QuoteService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlanDetailsFacade), i0.ɵɵdirectiveInject(i1.GuidedHelpService)); };
LegacyPlanCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LegacyPlanCardComponent, selectors: [["vnext-legacy-plan-card"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 3, consts: [["class", "row", 4, "ngIf"], ["class", "plan-card mb-3", 3, "id", "ngClass", 4, "ngIf"], [1, "row"], [1, "col-12"], [3, "plan", "customClass", "currentPlanText", "nextYearPlanText", "notLicensedPlanText", "includeNonLicensedPlans", "optionOneText", "optionTwoText", "displayOptionLabels", "nonCommissionableText", "isNonCommissionableFlagCheckEnabled", "disableNextYearDisplay"], [3, "customClass", "plan", "bestMatchText", "bestMatchIcon", "bestMatchTooltip"], [1, "plan-card", "mb-3", 3, "id", "ngClass"], [1, "pt-3", "pr-3", "pb-1", "pl-3"], [1, "row", "mb-3"], ["class", "col-4 col-sm-3 pb-2 order-1", "vnextHideMissingImage", "", 4, "ngIf"], [1, "col-12", "order-3", "order-sm-2", 3, "ngClass"], ["comboPlanToolTip", ""], [1, "Spa_Style_H4", "my-0", "plan-name", "no-translate-block", 3, "ngClass"], [4, "ngIf", "ngIfElse"], ["dentalVisionPlanName", ""], [3, "ngSwitch"], ["class", "Spa_Style_Note", "tooltipClass", "combo-plan-tooltip", 3, "ngbTooltip", 4, "ngIf"], [4, "ngIf"], ["class", "Spa_Style_Paragraph mt-1", 4, "ngIf"], ["class", "card-sub-header-details", 4, "ngIf"], ["class", "col order-4", 4, "ngIf"], ["class", "col order-2 order-sm-3", 3, "ngClass", 4, "ngIf"], [1, "p-0", "d-sm-none", "mb-3"], [1, "col-12", "mb-4", "text-center", "plan-monthly-premium"], [1, "Spa_Style_Paragraph", 3, "ngClass"], [3, "title", "click", "keyup.enter", 4, "ngIf", "ngIfElse"], ["showPremium", ""], [1, "row", "justify-content-around"], [3, "ngClass"], ["class", "btn Spa_Style_SecondaryButton btn-block px-1", 3, "title", "click", 4, "ngIf"], [3, "ngClass", "plan", 4, "ngIf"], ["class", "row pt-2", 4, "ngIf"], [1, "p-0"], [1, "col-12", "col-sm-7", "col-md-8"], [1, "col-sm-5", "col-md-4", "text-center", "mb-4", "d-none", "d-sm-block"], [1, "monthly-premium-container"], [1, "Spa_Style_Paragraph", "plan-premium", "mb-0", 3, "ngClass"], [3, "title", "click", 4, "ngIf", "ngIfElse"], [1, "p-0", "pb-1"], [1, "row", "justify-content-end", "align-items-center"], ["class", "col-12 col-sm-5 Spa_Style_Note d-flex justify-content-start justify-content-sm-end", 4, "ngIf"], ["class", "pr-md-3 pr-sm-0 col-sm-5", 4, "ngIf"], ["planDetailsOnlyButton", ""], ["class", "row align-items-sm-center pt-sm-1", 4, "ngIf"], ["notLicensedToSell", ""], ["vnextHideMissingImage", "", 1, "col-4", "col-sm-3", "pb-2", "order-1"], [1, "image-responsive"], [3, "alternateText", "imageSrc", "classNames", "planLogoSize"], [1, "Spa_Style_ToolTip", 3, "innerHtml"], ["normalPlanName", ""], [1, "d-inline-block"], [3, "riderCategories", "isNotLicensed", "Spa_Site_ShowRiderIcons", "Spa_Site_Dental_Rider_Display_Text", "Spa_Site_Vision_Rider_Display_Text", "Spa_Site_Hearing_Rider_Display_Text", "Spa_PlanCard_DentalAddOnCoverage_Text", "Spa_PlanCard_HearingAddOnCoverage_Text", "Spa_PlanCard_VisionAddOnCoverage_Text", "Spa_PlanCard_AddOnCoverage_Text", "Spa_Site_Tooltip_Text", "showAncillaryIcons", "isPlanTypeMode", "plan", "showAddOnCoverageText"], ["tooltipClass", "combo-plan-tooltip", 1, "Spa_Style_Note", 3, "ngbTooltip"], [1, "text-nowrap"], [3, "planYear", 4, "ngIf"], [3, "planYear"], [1, "Spa_Style_Paragraph", "mt-1"], [1, "mr-1"], [1, "card-sub-header-details"], [3, "planExtraData", "Spa_Site_Tooltip_Text", "Spa_RatingMethod_AttainedAge_Tooltip_Text", "Spa_RatingMethod_IssueAge_Tooltip_Text", "Spa_RatingMethod_CommunityRated_Tooltip_Text"], [3, "isMobile", "starRating", "ratingValueDescription", "showLowPerformanceIndicator", "isNotLicensed"], [3, "SNPType", "CSNPEnabled", "DSNPEnabled", "ISNPEnabled", "CSNPText", "DSNPText", "ISNPText", "SNPText", "DSNPCodes"], [1, "col", "order-4"], [1, "Spa_Style_CostPremiumSmall", 3, "ngClass"], [1, "col", "order-2", "order-sm-3", 3, "ngClass"], [1, "checkbox", "float-right", "Spa_Style_Paragraph", "d-flex", "align-items-center"], [1, "mb-0", "can-click", "float-right", 3, "for"], ["type", "checkbox", "triggers", "manual", "tooltipClass", "compare-warning-tooltip", "role", "checkbox", 1, "can-click", "mr-2", 3, "id", "value", "ngbTooltip", "placement", "checked", "change"], ["compareTooltip", "ngbTooltip"], ["compareTooltipContent", ""], ["isSelectedForCompare", ""], ["navigationAdapter", "", 3, "innerHtml"], [4, "liveEditProp"], [1, "hidden-off-screen", "no-translate-block"], ["tabindex", "0", 1, "can-click", 3, "title", "makeInlineBlock", "alwaysUnderlined", "keyup.enter", "click"], [3, "title", "click", "keyup.enter"], ["showPremiumWithFees", ""], ["class", "Spa_Style_Note", 4, "ngIf"], [3, "title", "alwaysUnderlined", "click", "keyup.enter"], [3, "planFees", "planTotalPremium", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "tooltipCustomClass"], [1, "Spa_Style_Note"], ["class", "Spa_Style_CostPremiumSmall non-monthly-payment-text", 3, "ngClass", 4, "ngIf"], [1, "Spa_Style_CostPremiumSmall", "non-monthly-payment-text", 3, "ngClass"], [1, "fas", "fa-tag"], [1, "btn", "Spa_Style_SecondaryButton", "btn-block", "px-1", 3, "title", "click"], [3, "ngClass", "plan"], [1, "col-12", "p-0", "d-block", "d-sm-none", 3, "ngClass", "plan", "addToQuoteButtonText", "removeFromQuoteButtonText", "addToQuoteWarningTooltip", "selectedQuoteGroup", "isPlanAddedToQuote", "addToQuote", "removePlanFromQuoteGroup"], [1, "row", "pt-2"], [1, "col-12", "p-0", 3, "ngClass", "plan", "addToQuoteButtonText", "removeFromQuoteButtonText", "addToQuoteWarningTooltip", "selectedQuoteGroup", "isPlanAddedToQuote", "addToQuote", "removePlanFromQuoteGroup"], [1, "plan-benefits", 3, "ngSwitch"], [4, "ngSwitchCase"], [3, "plan", "annualCost", "planBenefits", "planBenefitNoValueLabel", "isNotLicensedToSell"], ["class", "row justify-content-between px-3 flex-sm-column offset-sm-4", 4, "ngSwitchCase"], [1, "row", "justify-content-between", "px-3", "flex-sm-column", "offset-sm-4"], [1, "Spa_Style_Paragraph", "mx-sm-auto", 3, "ngClass"], [1, "Spa_Style_H3", "mx-sm-auto", 3, "ngClass"], [3, "title", "click"], [1, "col-12", "col-sm-5", "Spa_Style_Note", "d-flex", "justify-content-start", "justify-content-sm-end"], [1, "pr-md-3", "pr-sm-0", "col-sm-5"], [3, "selectedPlanType", "showMedSupAddOnCoverageText", "addOnCoverageTooltipBody", "addOnCoverageInCartText", "planRiderCategories", "Spa_Site_ShowRiderIcons", "Spa_Site_Dental_Rider_Display_Text", "Spa_Site_Vision_Rider_Display_Text", "Spa_Site_Hearing_Rider_Display_Text", "Spa_PlanCard_DentalAddOnCoverage_Text", "Spa_PlanCard_HearingAddOnCoverage_Text", "Spa_PlanCard_VisionAddOnCoverage_Text", "Spa_PlanCard_AddOnCoverage_Text", "Spa_Site_Tooltip_Text", "isNotLicensedToSell", 4, "ngIf"], [3, "selectedPlanType", "showMedSupAddOnCoverageText", "addOnCoverageTooltipBody", "addOnCoverageInCartText", "planRiderCategories", "Spa_Site_ShowRiderIcons", "Spa_Site_Dental_Rider_Display_Text", "Spa_Site_Vision_Rider_Display_Text", "Spa_Site_Hearing_Rider_Display_Text", "Spa_PlanCard_DentalAddOnCoverage_Text", "Spa_PlanCard_HearingAddOnCoverage_Text", "Spa_PlanCard_VisionAddOnCoverage_Text", "Spa_PlanCard_AddOnCoverage_Text", "Spa_Site_Tooltip_Text", "isNotLicensedToSell"], [1, "d-none", "d-sm-block", 3, "className"], ["class", "btn btn-block Spa_Style_SecondaryButton", 3, "title", "click", 4, "ngIf"], ["class", "col-4 d-none d-sm-block", 4, "ngIf"], [1, "btn", "btn-block", "Spa_Style_SecondaryButton", 3, "title", "click"], [1, "col-4", "d-none", "d-sm-block"], [3, "plan", "queuePosition"], [1, "col-4", "p-0", "d-none", "d-sm-block", 3, "ngClass", "plan", "addToQuoteButtonText", "removeFromQuoteButtonText", "addToQuoteWarningTooltip", "selectedQuoteGroup", "isPlanAddedToQuote", "addToQuote", "removePlanFromQuoteGroup"], [1, "d-none", "d-sm-block", "col-4", "offset-3"], [1, "row", "align-items-sm-center", "pt-sm-1"], [1, "col-12", "col-sm-8"], ["class", "Spa_Style_Toggle_Background px-2", 4, "ngSwitchCase"], [1, "Spa_Style_Toggle_Background", "px-2"], [3, "pharmacyNotCoveredText", "plan", "prescriptionsText", "pharmacyText", "pharmacyCoveredText", "addedPharmacy", "drugCoverageText", "showDrugCoverage", "planPreferences", "totalEstimatedAnnualCostText", "totalEstimatedCostText", "totalEstimatedCostTooltip", "isTotalEstimatedCostEnabled", "isEnabledShowDrugAlternatives", "showNudgeDrugAlternatives", "drugAlternativesTooltipText", "nudgeDrugAlternativesLabelText", "drugAlternativesIndicatorIcon", "isRetention", "isQuoting", "noCostAvailableText", "Spa_Site_Tooltip_Text", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "annualCost", "showMailOrderLabel", "isMailOrderSelected", "medicineCabinet", "mailOrderText", "totalCostEffectiveDate", "selectedProviders", "planCardPreferenceDetailedEnabled", "providerDetails", "showProviderInNetworkOnOtherLocation", "providersCoveredText", "providerPcpText", "loaderIconEnabled", "editLinkText", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "viewProvidersButtonText", "viewPrescriptionsButtonText", "isVbcAgreementEnabled", "vbcAgreementLabel", "vbcAgreementTooltip"], [3, "supplementalBenefits", "planBenefits", "hideLinkText", "viewAllLinkText", "isMobile", "availableText", "unavailableText", "supplementalBenefitsHighlightText"], [3, "pharmacyNotCoveredText", "plan", "prescriptionsText", "pharmacyText", "pharmacyCoveredText", "addedPharmacy", "drugCoverageText", "showDrugCoverage", "planPreferences", "totalEstimatedAnnualCostText", "totalEstimatedCostText", "totalEstimatedCostTooltip", "isTotalEstimatedCostEnabled", "isEnabledShowDrugAlternatives", "showNudgeDrugAlternatives", "drugAlternativesTooltipText", "nudgeDrugAlternativesLabelText", "drugAlternativesIndicatorIcon", "isRetention", "isQuoting", "noCostAvailableText", "Spa_Site_Tooltip_Text", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "annualCost", "medicineCabinet", "totalCostEffectiveDate", "selectedProviders", "planCardPreferenceDetailedEnabled", "providerDetails", "showProviderInNetworkOnOtherLocation", "providersCoveredText", "providerPcpText", "loaderIconEnabled", "editLinkText", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "viewProvidersButtonText", "viewPrescriptionsButtonText", "isVbcAgreementEnabled", "vbcAgreementLabel", "vbcAgreementTooltip"], [3, "pharmacyNotCoveredText", "plan", "prescriptionsText", "pharmacyText", "pharmacyCoveredText", "addedPharmacy", "drugCoverageText", "showDrugCoverage", "planPreferences", "totalEstimatedAnnualCostText", "totalEstimatedCostText", "totalEstimatedCostTooltip", "isTotalEstimatedCostEnabled", "isEnabledShowDrugAlternatives", "showNudgeDrugAlternatives", "drugAlternativesTooltipText", "nudgeDrugAlternativesLabelText", "drugAlternativesIndicatorIcon", "isRetention", "isQuoting", "noCostAvailableText", "Spa_Site_Tooltip_Text", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "annualCost", "showMailOrderLabel", "isMailOrderSelected", "medicineCabinet", "mailOrderText", "totalCostEffectiveDate", "selectedProviders", "planCardPreferenceDetailedEnabled", "providerDetails", "loaderIconEnabled", "editLinkText", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "viewProvidersButtonText", "viewPrescriptionsButtonText", "isVbcAgreementEnabled", "vbcAgreementLabel", "vbcAgreementTooltip"], [3, "rateFactorsStatus", "availableRateFactorsData", "personalizedQuoteLabelText"], [1, "row", "p-3"], [1, "Spa_Style_Primary_Color", "Spa_Style_Paragraph", "px-3", "py-1"]], template: function LegacyPlanCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LegacyPlanCardComponent_div_0_Template, 3, 12, "div", 0);
        i0.ɵɵtemplate(1, LegacyPlanCardComponent_div_1_Template, 3, 5, "div", 0);
        i0.ɵɵtemplate(2, LegacyPlanCardComponent_div_2_Template, 55, 54, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.hidePlanCardLabel);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.plan.id === ctx.bestMatchPlanId);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.newPlanCardDesignEnabled && !(ctx.plan.planType === ctx.planType.MAPD || ctx.plan.planType === ctx.planType.MA || ctx.plan.planType === ctx.planType.PDP || ctx.plan.planType === ctx.planType.MEDIGAP) || !ctx.newPlanCardDesignEnabled);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, LinkComponent, PlanYearBadgeComponent, NavigationAdapterDirective, LiveEditPropDirective, IconAriaAttributesDirective, HideMissingImageDirective, i1$1.NgbTooltip, PlanCardRateFactorsStatusesComponent, RiderCardComponent, StarRatingComponent, ShoppingCartButtonComponent, PlanBenefitsComponent, PlanCardBestMatchComponent, PlanFeesTooltipComponent, PlanCoveragePreferencesComponent, PlanCardSupplementalBenefitsComponent, PlanCardLabelComponent, PlanQuoteButtonComponent, PlanCardRidersComponent, PlanSNPIndicatorComponent, PlanRatingMethodComponent, PlanLogoComponent, i1$2.CurrencyPipe, SafePipe, RateFactorAppliedPipe], styles: [".plan-card[_ngcontent-%COMP%]{border-width:1px;border-style:solid;border-top-right-radius:4px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;padding:8px 0 0}.plan-card.plan-card-border[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent1);border-top-left-radius:4px}.plan-card[_ngcontent-%COMP%]   .image-responsive[_ngcontent-%COMP%]{padding-right:0;max-width:100%;text-align:center}.score-display[_ngcontent-%COMP%]{color:red}.monthly-premium-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;height:100%;align-items:center;justify-content:center}.plan-premium[_ngcontent-%COMP%]{line-height:17px;margin-bottom:5px}.plan-benefits-column-list[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;list-style:none;padding:0}.plan-benefits-column-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child, .plan-benefits-column-list.plan-benefits-row-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-bottom:0;margin-bottom:16px}.coverage[_ngcontent-%COMP%]{border-radius:14px;text-align:center;padding:4px}.coverage[_ngcontent-%COMP%]   .fas[_ngcontent-%COMP%]{height:17px;width:18px}.plan-benefits-items[_ngcontent-%COMP%]:focus, .plan_monthly_premium[_ngcontent-%COMP%]:focus, .monthly-premium-container[_ngcontent-%COMP%]:focus, .coverage[_ngcontent-%COMP%]:focus{box-shadow:none;outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:0 0 5px var(--static-Spa_Style_Black);border-radius:5px}.tooltip-icon[_ngcontent-%COMP%]{font-size:12px;padding-right:10px;background-color:transparent;font-family:\"Font Awesome 5 Pro\"}.plan-benefits[_ngcontent-%COMP%]{margin-bottom:16px}.current-plan-text[_ngcontent-%COMP%], .next-year-plan-text[_ngcontent-%COMP%]{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.plan-name[_ngcontent-%COMP%]:focus{border-radius:5px}.card-sub-header-details[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;align-items:baseline}.non-monthly-payment-text[_ngcontent-%COMP%]{font-size:13px;font-family:montserratregular}@media (max-width: 479.98px){.plan-benefits-column-list.plan-benefits-row-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list.plan-benefits-row-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child{border-bottom:0}}.plan-benefits-items[_ngcontent-%COMP%]{flex-basis:33.3333%;flex-grow:0}@media (max-width: 575.98px){.plan-benefits-list-value-container[_ngcontent-%COMP%]{float:right;display:flex;flex-direction:column;align-items:flex-end}.plan-benefits[_ngcontent-%COMP%]{margin-bottom:0}}.no-border[_ngcontent-%COMP%]{border:none!important}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LegacyPlanCardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-legacy-plan-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"!hidePlanCardLabel\" class=\"row\">\r\n  <div class=\"col-12\">\r\n    <vnext-widget-plan-card-label\r\n      [plan]=\"plan\"\r\n      [customClass]=\"customClass\"\r\n      [currentPlanText]=\"currentPlanText\"\r\n      [nextYearPlanText]=\"nextYearPlanText\"\r\n      [notLicensedPlanText]=\"nonLicensedPlanText\"\r\n      [includeNonLicensedPlans]=\"includeNonLicensedPlans\"\r\n      [optionOneText]=\"optionOneText\"\r\n      [optionTwoText]=\"optionTwoText\"\r\n      [displayOptionLabels]=\"displayOptionLabels\"\r\n      [nonCommissionableText]=\"nonCommissionableText\"\r\n      [isNonCommissionableFlagCheckEnabled]=\"isNonCommissionableFlagCheckEnabled\"\r\n      [disableNextYearDisplay]=\"memberHasOptionsDefined && displayOptionLabels\"\r\n    ></vnext-widget-plan-card-label>\r\n  </div>\r\n</div>\r\n<div class=\"row\" *ngIf=\"plan.id === bestMatchPlanId\">\r\n  <div class=\"col-12\">\r\n    <vnext-widget-plan-card-best-match\r\n      [customClass]=\"customClass\"\r\n      [plan]=\"plan\"\r\n      [bestMatchText]=\"bestMatchText\"\r\n      [bestMatchIcon]=\"bestMatchIcon\"\r\n      [bestMatchTooltip]=\"bestMatchTooltip\"\r\n    >\r\n    </vnext-widget-plan-card-best-match>\r\n  </div>\r\n</div>\r\n\r\n<!--OLD PLAN CARD START-->\r\n<div\r\n  *ngIf=\"\r\n    (newPlanCardDesignEnabled &&\r\n      !(\r\n        plan.planType === planType.MAPD ||\r\n        plan.planType === planType.MA ||\r\n        plan.planType === planType.PDP ||\r\n        plan.planType === planType.MEDIGAP\r\n      )) ||\r\n    !newPlanCardDesignEnabled\r\n  \"\r\n  class=\"plan-card mb-3\"\r\n  id=\"PlanCard_{{ plan.id }}\"\r\n  [ngClass]=\"{\r\n    'Spa_Style_Accent6_Border': plan.isCurrentYearPlan,\r\n    'Spa_Style_Primary_Link_Border': displayLinkBorder,\r\n    'plan-card-border': !plan.isCurrentYearPlan && (!plan.isNextYearPlan || plan.isPlanRolloverTerminated)\r\n  }\"\r\n>\r\n  <div class=\"pt-3 pr-3 pb-1 pl-3\">\r\n    <header class=\"row mb-3\">\r\n      <div class=\"col-4 col-sm-3 pb-2 order-1\" *ngIf=\"showPlanLogo\" vnextHideMissingImage>\r\n        <div class=\"image-responsive\">\r\n          <vnext-plan-logo\r\n            [alternateText]=\"altPlanImgText\"\r\n            [imageSrc]=\"planLogo\"\r\n            [classNames]=\"'plan-logo'\"\r\n            [planLogoSize]=\"planLogoSize\"\r\n          ></vnext-plan-logo>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-12 order-3 order-sm-2\" [ngClass]=\"{ 'col-sm-7 col-lg-8': !showPlanLogo, 'col-sm': showPlanLogo }\">\r\n        <ng-template #comboPlanToolTip>\r\n          <div [innerHtml]=\"Spa_Site_ComboPlanTooltip_Text | safe : 'html'\" class=\"Spa_Style_ToolTip\"></div>\r\n        </ng-template>\r\n        <h2 class=\"Spa_Style_H4 my-0 plan-name no-translate-block\" [ngClass]=\"{ Spa_Style_Gray4_Color: isNotLicensedToSell }\">\r\n          <ng-container *ngIf=\"isHospitalCare; else dentalVisionPlanName\">\r\n            <span *ngIf=\"!showPlanLogo\">{{ plan.carrierName }} </span><span>{{ plan.planName }}</span>\r\n          </ng-container>\r\n          <ng-template #dentalVisionPlanName>\r\n            <ng-container *ngIf=\"(isDentalPlan || isVisionPlan) && showAncillaryIcons; else normalPlanName\">\r\n              <div class=\"d-inline-block\">\r\n                {{ plan.planName }}\r\n              </div>\r\n              <div class=\"d-inline-block\">\r\n                <vnext-rider-card\r\n                  [riderCategories]=\"riderFacade.getRiderCategories(plan.riders)\"\r\n                  [isNotLicensed]=\"isNotLicensedToSell\"\r\n                  [Spa_Site_ShowRiderIcons]=\"Spa_Site_ShowRiderIcons\"\r\n                  [Spa_Site_Dental_Rider_Display_Text]=\"Spa_Site_Dental_Rider_Display_Text\"\r\n                  [Spa_Site_Vision_Rider_Display_Text]=\"Spa_Site_Vision_Rider_Display_Text\"\r\n                  [Spa_Site_Hearing_Rider_Display_Text]=\"Spa_Site_Hearing_Rider_Display_Text\"\r\n                  [Spa_PlanCard_DentalAddOnCoverage_Text]=\"Spa_PlanCard_DentalAddOnCoverage_Text\"\r\n                  [Spa_PlanCard_HearingAddOnCoverage_Text]=\"Spa_PlanCard_HearingAddOnCoverage_Text\"\r\n                  [Spa_PlanCard_VisionAddOnCoverage_Text]=\"Spa_PlanCard_VisionAddOnCoverage_Text\"\r\n                  [Spa_PlanCard_AddOnCoverage_Text]=\"Spa_PlanCard_AddOnCoverage_Text\"\r\n                  [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                  [showAncillaryIcons]=\"showAncillaryIcons\"\r\n                  [isPlanTypeMode]=\"true\"\r\n                  [plan]=\"plan\"\r\n                  [showAddOnCoverageText]=\"false\"\r\n                ></vnext-rider-card>\r\n              </div>\r\n            </ng-container>\r\n            <ng-template #normalPlanName\r\n              ><span> {{ plan.planName }} </span></ng-template\r\n            >\r\n          </ng-template>\r\n\r\n          <ng-container [ngSwitch]=\"plan.planTypeAbbreviation\"> </ng-container>\r\n\r\n          <span class=\"Spa_Style_Note\" *ngIf=\"showComboToolTip\" [ngbTooltip]=\"comboPlanToolTip\" tooltipClass=\"combo-plan-tooltip\">\r\n            {{ ' ' }}\r\n            <u class=\"text-nowrap\">{{ Spa_Site_ComboPlanLabel_Text }}</u>\r\n          </span>\r\n        </h2>\r\n        <div *ngIf=\"showPlanYear\">\r\n          <vnext-plan-year-badge *ngIf=\"planCardTile?.plan?.planYear\" [planYear]=\"planCardTile?.plan?.planYear\"></vnext-plan-year-badge>\r\n        </div>\r\n        <div *ngIf=\"showPlanId && fullPlanId\" class=\"Spa_Style_Paragraph mt-1\">\r\n          <span class=\"mr-1\">{{ planIdText }}:</span><span>{{ fullPlanId }}</span>\r\n        </div>\r\n        <div class=\"card-sub-header-details\" *ngIf=\"showRatingMethod\">\r\n          <vnext-plan-rating-method\r\n            [planExtraData]=\"plan.extraData\"\r\n            [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n            [Spa_RatingMethod_AttainedAge_Tooltip_Text]=\"Spa_RatingMethod_AttainedAge_Tooltip_Text\"\r\n            [Spa_RatingMethod_IssueAge_Tooltip_Text]=\"Spa_RatingMethod_IssueAge_Tooltip_Text\"\r\n            [Spa_RatingMethod_CommunityRated_Tooltip_Text]=\"Spa_RatingMethod_CommunityRated_Tooltip_Text\"\r\n          ></vnext-plan-rating-method>\r\n        </div>\r\n        <div class=\"card-sub-header-details\" *ngIf=\"showStarRating\">\r\n          <vnext-star-rating\r\n            [isMobile]=\"isMobile\"\r\n            [starRating]=\"plan.planRating\"\r\n            [ratingValueDescription]=\"plan.planRatingValueDescription\"\r\n            [showLowPerformanceIndicator]=\"plan.isLowPerformingPlan\"\r\n            [isNotLicensed]=\"isNotLicensedToSell\"\r\n          ></vnext-star-rating>\r\n          <vnext-plan-SNP-Indicator\r\n            [SNPType]=\"plan.snpType\"\r\n            [CSNPEnabled]=\"CSNPEnabled\"\r\n            [DSNPEnabled]=\"DSNPEnabled\"\r\n            [ISNPEnabled]=\"ISNPEnabled\"\r\n            [CSNPText]=\"CSNPText\"\r\n            [DSNPText]=\"DSNPText\"\r\n            [ISNPText]=\"ISNPText\"\r\n            [SNPText]=\"SNPText\"\r\n            [DSNPCodes]=\"translatedDSNPCodes\"\r\n          ></vnext-plan-SNP-Indicator>\r\n        </div>\r\n      </div>\r\n      <div class=\"col order-4\" *ngIf=\"showPreferenceScore\">\r\n        <div\r\n          class=\"Spa_Style_CostPremiumSmall\"\r\n          [ngClass]=\"{ 'Spa_Style_Gray4_Color': isNotLicensedToSell, 'score-display': !isNotLicensedToSell }\"\r\n        >\r\n          Score: {{ plan?.score?.toFixed(2) }}\r\n        </div>\r\n      </div>\r\n      <div\r\n        *ngIf=\"Spa_Site_AddToCompare_Enabled\"\r\n        class=\"col order-2 order-sm-3\"\r\n        [ngClass]=\"{ 'col-sm-4': showPlanLogo, 'col-sm-5 col-lg-4': !showPlanLogo }\"\r\n      >\r\n        <ng-container *ngIf=\"!hideCompareBox\">\r\n          <div class=\"checkbox float-right Spa_Style_Paragraph d-flex align-items-center\">\r\n            <label for=\"Compare_{{ plan.id }}\" class=\"mb-0 can-click float-right\">\r\n              <input\r\n                #compareTooltip=\"ngbTooltip\"\r\n                id=\"Compare_{{ plan.id }}\"\r\n                type=\"checkbox\"\r\n                class=\"can-click mr-2\"\r\n                triggers=\"manual\"\r\n                tooltipClass=\"compare-warning-tooltip\"\r\n                value=\"{{ plan.id }}\"\r\n                role=\"checkbox\"\r\n                [ngbTooltip]=\"compareTooltipContent\"\r\n                [placement]=\"isShoppingTalkingPointEnabled ? 'left' : 'top-left left-top'\"\r\n                [attr.aria-checked]=\"isSelectedToCompare(plan)\"\r\n                [attr.aria-label]=\"\r\n                  isSelectedToCompare(plan) ? Spa_PlanCard_CompareNow_Text : Spa_PlanCard_AddToCompare_Text + ' ' + plan.planName\r\n                \"\r\n                [checked]=\"isSelectedToCompare(plan)\"\r\n                (change)=\"updatePlanToCompareGroup(plan, $event, compareTooltip)\"\r\n              />\r\n              <ng-template #compareTooltipContent>\r\n                <div [innerHtml]=\"compareWarningTooltip | safe : 'html'\" navigationAdapter></div>\r\n              </ng-template>\r\n              <ng-container *ngIf=\"!isSelectedToCompare(plan); else isSelectedForCompare\"\r\n                ><span *liveEditProp=\"'Spa_PlanCard_AddToCompare_Text'\">{{ Spa_PlanCard_AddToCompare_Text }}</span>\r\n                <span class=\"hidden-off-screen no-translate-block\">{{ plan.planName }}</span></ng-container\r\n              >\r\n              <ng-template #isSelectedForCompare>\r\n                <vnext-link\r\n                  [title]=\"Spa_PlanCard_CompareNow_Text\"\r\n                  [makeInlineBlock]=\"true\"\r\n                  [alwaysUnderlined]=\"true\"\r\n                  (keyup.enter)=\"comparePlans($event, plan)\"\r\n                  (click)=\"comparePlans($event, plan)\"\r\n                  tabindex=\"0\"\r\n                  class=\"can-click\"\r\n                ></vnext-link>\r\n              </ng-template>\r\n            </label>\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n    </header>\r\n    <div>\r\n      <div class=\"p-0 d-sm-none mb-3\">\r\n        <div class=\"row\">\r\n          <div class=\"col-12 mb-4 text-center plan-monthly-premium\">\r\n            <div class=\"Spa_Style_Paragraph\" [ngClass]=\"{ Spa_Style_Gray4_Color: isNotLicensedToSell }\">{{ premiumLabel }}</div>\r\n            <vnext-link\r\n              [title]=\"Spa_PlanCard_QuoteLinkName_Text\"\r\n              (click)=\"quoteClick()\"\r\n              (keyup.enter)=\"quoteClick()\"\r\n              *ngIf=\"!hasPremium; else showPremium\"\r\n            ></vnext-link>\r\n            <ng-template #showPremium>\r\n              <div class=\"Spa_Style_CostPremiumSmall\" [ngClass]=\"{ Spa_Style_Gray4_Color: isNotLicensedToSell }\">\r\n                <ng-container *ngIf=\"!planFeesEnabled || !plan.fees?.length; else showPremiumWithFees\">\r\n                  <span *ngIf=\"snpPremiumRangeEnabled && planPremiumInitialRange\">{{ planPremiumInitialRange }}</span\r\n                  >{{ planTotalPremium | currency : 'USD' : 'symbol' : '1.2-2' }}\r\n                </ng-container>\r\n                <div *ngIf=\"snpPremiumRangeEnabled && planPremiumInitialRange\">\r\n                  <vnext-link\r\n                    [title]=\"snpRangeLinkText\"\r\n                    [alwaysUnderlined]=\"true\"\r\n                    (click)=\"showSnpRangeModal()\"\r\n                    (keyup.enter)=\"showSnpRangeModal()\"\r\n                  ></vnext-link>\r\n                </div>\r\n\r\n                <ng-template #showPremiumWithFees>\r\n                  <vnext-widget-plan-fees-tooltip\r\n                    [planFees]=\"plan.fees\"\r\n                    [planTotalPremium]=\"planTotalPremium\"\r\n                    [planFeesTooltipText]=\"planFeesTooltipText\"\r\n                    [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n                    [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n                    [tooltipCustomClass]=\"'inline-block-sm-layout'\"\r\n                  ></vnext-widget-plan-fees-tooltip>\r\n                </ng-template>\r\n              </div>\r\n              <span *ngIf=\"isHospitalCare\" class=\"Spa_Style_Note\">{{ monthlyPremiumText }}</span>\r\n              <ng-container *ngIf=\"plan.planType === planType.MEDIGAP\">\r\n                <div\r\n                  class=\"Spa_Style_CostPremiumSmall non-monthly-payment-text\"\r\n                  [ngClass]=\"{ Spa_Style_Gray4_Color: isNotLicensedToSell }\"\r\n                  *ngIf=\"\r\n                    medSupPaymentMethod &&\r\n                      medSupPaymentMethod !== medSupPaymentMethodEnum.MONTHLY &&\r\n                      nonMonthlyRateText &&\r\n                      medSupPaymentMethodDisplayText &&\r\n                      !Spa_Site_ShowPremiumAsAnnual &&\r\n                      showNonMonthlyRateText &&\r\n                      plan.rateFactors | rateFactorApplied\r\n                  \"\r\n                >\r\n                  <i class=\"fas fa-tag\"></i>\r\n                  {{ nonMonthlyRateText.replace('&lt;paymentMethod&gt;', medSupPaymentMethodDisplayText[medSupPaymentMethod]) }}\r\n                </div>\r\n              </ng-container>\r\n            </ng-template>\r\n          </div>\r\n        </div>\r\n        <div class=\"row justify-content-around\">\r\n          <div\r\n            [ngClass]=\"{\r\n              'col': !isRetentionSummaryPage,\r\n              'col-12': isRetentionSummaryPage,\r\n              'pr-sm-3 offset-sm-4': isDentalPlan\r\n            }\"\r\n          >\r\n            <button\r\n              class=\"btn Spa_Style_SecondaryButton btn-block px-1\"\r\n              title=\"{{ viewDetailsDescriptionText }} {{ plan.planName }}\"\r\n              (click)=\"viewPlanDetailsPage(plan)\"\r\n              *ngIf=\"Spa_Site_PlanViewDetails_Enabled\"\r\n              [attr.aria-label]=\"viewDetailsDescriptionText + plan.planName\"\r\n            >\r\n              {{ Spa_PlanCard_PlanDetails_ButtonText }}\r\n            </button>\r\n          </div>\r\n          <vnext-shopping-cart-button\r\n            *ngIf=\"hasPremium && addToCartEnabled\"\r\n            [ngClass]=\"{ 'col pl-1': !isRetentionSummaryPage, 'col-12 mt-2': isRetentionSummaryPage }\"\r\n            [plan]=\"plan\"\r\n          >\r\n          </vnext-shopping-cart-button>\r\n          <ng-container *ngIf=\"isHospitalCare\">\r\n            <vnext-widget-plan-quote-button\r\n              class=\"col-12 p-0 d-block d-sm-none\"\r\n              [ngClass]=\"{ 'mt-2 btn1': addToCartEnabled }\"\r\n              [plan]=\"plan\"\r\n              [addToQuoteButtonText]=\"Spa_PlanCard_AddToQuote_Text\"\r\n              [removeFromQuoteButtonText]=\"Spa_PlanCard_RemoveFromQuote_Text\"\r\n              [addToQuoteWarningTooltip]=\"addToQuoteWarningTooltip\"\r\n              [selectedQuoteGroup]=\"selectedCompareGroup\"\r\n              [isPlanAddedToQuote]=\"isSelectedToCompare(plan)\"\r\n              (addToQuote)=\"addPlanToHospitalIndemnityCompareGroup($event.plan, $event.addToQuoteTooltip)\"\r\n              (removePlanFromQuoteGroup)=\"removePlanToHospitalIndemnityCompareGroup($event.selectedQuoteGroup, $event.plan)\"\r\n            ></vnext-widget-plan-quote-button>\r\n          </ng-container>\r\n        </div>\r\n        <div class=\"row pt-2\" *ngIf=\"!isAncillary && isAddToQuoteAvailable\">\r\n          <vnext-widget-plan-quote-button\r\n            class=\"col-12 p-0\"\r\n            [ngClass]=\"{ 'mt-2 btn2': addToCartEnabled }\"\r\n            [plan]=\"plan\"\r\n            [addToQuoteButtonText]=\"Spa_PlanCard_AddToQuote_Text\"\r\n            [removeFromQuoteButtonText]=\"Spa_PlanCard_RemoveFromQuote_Text\"\r\n            [addToQuoteWarningTooltip]=\"Spa_PlanCard_AddToQuote_Warning_Tooltip\"\r\n            [selectedQuoteGroup]=\"selectedQuoteGroup\"\r\n            [isPlanAddedToQuote]=\"isPlanAddedToQuote(plan)\"\r\n            (addToQuote)=\"addPlanToQuote($event.plan, $event.addToQuoteTooltip)\"\r\n            (removePlanFromQuoteGroup)=\"planFacade.removePlanFromQuoteGroup($event.selectedQuoteGroup, $event.plan)\"\r\n          ></vnext-widget-plan-quote-button>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"p-0\">\r\n        <div class=\"row\">\r\n          <div class=\"col-12 col-sm-7 col-md-8\">\r\n            <ng-container *ngIf=\"annualCost\">\r\n              <div [ngSwitch]=\"plan.planType\" class=\"plan-benefits\">\r\n                <!-- Checking for MAPD PlanType -->\r\n                <div *ngSwitchCase=\"planType.MAPD\">\r\n                  <vnext-plan-benefits\r\n                    [plan]=\"plan\"\r\n                    [annualCost]=\"annualCost\"\r\n                    [planBenefits]=\"planBenefits\"\r\n                    [planBenefitNoValueLabel]=\"Spa_Site_NotApplicable_Text\"\r\n                    [isNotLicensedToSell]=\"isNotLicensedToSell\"\r\n                  >\r\n                  </vnext-plan-benefits>\r\n                </div>\r\n                <!-- Checking for MA PlanType -->\r\n                <div *ngSwitchCase=\"planType.MA\">\r\n                  <vnext-plan-benefits\r\n                    [plan]=\"plan\"\r\n                    [annualCost]=\"annualCost\"\r\n                    [planBenefits]=\"planBenefits\"\r\n                    [planBenefitNoValueLabel]=\"Spa_Site_NotApplicable_Text\"\r\n                    [isNotLicensedToSell]=\"isNotLicensedToSell\"\r\n                  >\r\n                  </vnext-plan-benefits>\r\n                </div>\r\n                <!-- Checking for PDP PlanType -->\r\n                <div *ngSwitchCase=\"planType.PDP\">\r\n                  <vnext-plan-benefits\r\n                    [plan]=\"plan\"\r\n                    [annualCost]=\"annualCost\"\r\n                    [planBenefits]=\"planBenefits\"\r\n                    [planBenefitNoValueLabel]=\"Spa_Site_NotApplicable_Text\"\r\n                    [isNotLicensedToSell]=\"isNotLicensedToSell\"\r\n                  >\r\n                  </vnext-plan-benefits>\r\n                </div>\r\n                <!-- Checking for DENTAL PlanType -->\r\n                <ng-container *ngSwitchCase=\"planType.DENTAL\">\r\n                  <div *ngIf=\"activeTabType === planTypeAbbreviation.DENTAL\">\r\n                    <vnext-plan-benefits\r\n                      [plan]=\"plan\"\r\n                      [annualCost]=\"annualCost\"\r\n                      [planBenefits]=\"planBenefits\"\r\n                      [planBenefitNoValueLabel]=\"Spa_Site_NotApplicable_Text\"\r\n                      [isNotLicensedToSell]=\"isNotLicensedToSell\"\r\n                    >\r\n                    </vnext-plan-benefits>\r\n                  </div>\r\n                </ng-container>\r\n                <!-- Checking for VISION PlanType -->\r\n                <ng-container *ngSwitchCase=\"planType.VISION\">\r\n                  <div *ngIf=\"activeTabType === planTypeAbbreviation.DENTAL\">\r\n                    <vnext-plan-benefits\r\n                      [plan]=\"plan\"\r\n                      [annualCost]=\"annualCost\"\r\n                      [planBenefits]=\"planBenefits\"\r\n                      [planBenefitNoValueLabel]=\"Spa_Site_NotApplicable_Text\"\r\n                      [isNotLicensedToSell]=\"isNotLicensedToSell\"\r\n                    >\r\n                    </vnext-plan-benefits>\r\n                  </div>\r\n                </ng-container>\r\n                <ng-container *ngIf=\"Spa_Site_MedigapPlanType_Enabled\">\r\n                  <div *ngSwitchCase=\"planType.MEDIGAP\" class=\"row justify-content-between px-3 flex-sm-column offset-sm-4\">\r\n                    <div class=\"Spa_Style_Paragraph mx-sm-auto\" [ngClass]=\"{ Spa_Style_Gray4_Color: isNotLicensedToSell }\">\r\n                      {{ Spa_PlanCard_PlanType_Text }}\r\n                    </div>\r\n                    <div class=\"Spa_Style_H3 mx-sm-auto\" [ngClass]=\"{ Spa_Style_Gray4_Color: isNotLicensedToSell }\">\r\n                      {{ plan.planSubType }}\r\n                    </div>\r\n                  </div>\r\n                </ng-container>\r\n              </div>\r\n            </ng-container>\r\n          </div>\r\n          <div class=\"col-sm-5 col-md-4 text-center mb-4 d-none d-sm-block\">\r\n            <div class=\"monthly-premium-container\">\r\n              <div class=\"Spa_Style_Paragraph plan-premium mb-0\" [ngClass]=\"{ Spa_Style_Gray4_Color: isNotLicensedToSell }\">\r\n                {{ premiumLabel }}\r\n              </div>\r\n              <vnext-link\r\n                [title]=\"Spa_PlanCard_QuoteLinkName_Text\"\r\n                (click)=\"quoteClick()\"\r\n                *ngIf=\"!hasPremium; else showPremium\"\r\n              ></vnext-link>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"p-0 pb-1\">\r\n      <div class=\"row justify-content-end align-items-center\">\r\n        <div class=\"col-12 col-sm-5 Spa_Style_Note d-flex justify-content-start justify-content-sm-end\" *ngIf=\"isHospitalCare\">\r\n          {{ moreBenefitsInstructionText }}\r\n        </div>\r\n\r\n        <div class=\"pr-md-3 pr-sm-0 col-sm-5\" *ngIf=\"!isHospitalCare && (!isAddToQuoteAvailable || isDentalPlan || isVisionPlan)\">\r\n          <vnext-plan-card-riders\r\n            [selectedPlanType]=\"plan.planType\"\r\n            *ngIf=\"showRiderSection()\"\r\n            [showMedSupAddOnCoverageText]=\"showMedSupAddOnCoverageText\"\r\n            [addOnCoverageTooltipBody]=\"Spa_PlanCard_AddOnCoverageTooltip_Body\"\r\n            [addOnCoverageInCartText]=\"Spa_PlanCard_AddOnCoverageInCart_Text\"\r\n            [planRiderCategories]=\"riderFacade.getRiderCategories(plan.riders)\"\r\n            [Spa_Site_ShowRiderIcons]=\"Spa_Site_ShowRiderIcons\"\r\n            [Spa_Site_Dental_Rider_Display_Text]=\"Spa_Site_Dental_Rider_Display_Text\"\r\n            [Spa_Site_Vision_Rider_Display_Text]=\"Spa_Site_Vision_Rider_Display_Text\"\r\n            [Spa_Site_Hearing_Rider_Display_Text]=\"Spa_Site_Hearing_Rider_Display_Text\"\r\n            [Spa_PlanCard_DentalAddOnCoverage_Text]=\"Spa_PlanCard_DentalAddOnCoverage_Text\"\r\n            [Spa_PlanCard_HearingAddOnCoverage_Text]=\"Spa_PlanCard_HearingAddOnCoverage_Text\"\r\n            [Spa_PlanCard_VisionAddOnCoverage_Text]=\"Spa_PlanCard_VisionAddOnCoverage_Text\"\r\n            [Spa_PlanCard_AddOnCoverage_Text]=\"Spa_PlanCard_AddOnCoverage_Text\"\r\n            [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n            [isNotLicensedToSell]=\"isNotLicensedToSell\"\r\n          ></vnext-plan-card-riders>\r\n        </div>\r\n\r\n        <ng-container *ngIf=\"hasPremium; else planDetailsOnlyButton\">\r\n          <div class=\"d-none d-sm-block\" [className]=\"planDetailsButtonClass\">\r\n            <button\r\n              class=\"btn btn-block Spa_Style_SecondaryButton\"\r\n              title=\"{{ viewDetailsDescriptionText }} {{ plan.planName }}\"\r\n              (click)=\"viewPlanDetailsPage(plan)\"\r\n              *ngIf=\"Spa_Site_PlanViewDetails_Enabled\"\r\n              [attr.aria-label]=\"viewDetailsDescriptionText + plan.planName\"\r\n              [attr.role]=\"linkRoles.LINK\"\r\n            >\r\n              {{ Spa_PlanCard_PlanDetails_ButtonText }}\r\n            </button>\r\n          </div>\r\n          <div *ngIf=\"addToCartEnabled\" class=\"col-4 d-none d-sm-block\">\r\n            <vnext-shopping-cart-button [plan]=\"plan\" [queuePosition]=\"queuePosition\"> </vnext-shopping-cart-button>\r\n          </div>\r\n\r\n          <ng-container *ngIf=\"isHospitalCare && isAddToQuoteAvailable\">\r\n            <vnext-widget-plan-quote-button\r\n              class=\"col-4 p-0 d-none d-sm-block\"\r\n              [ngClass]=\"{ 'mt-2 btn3': addToCartEnabled }\"\r\n              [plan]=\"plan\"\r\n              [addToQuoteButtonText]=\"Spa_PlanCard_AddToQuote_Text\"\r\n              [removeFromQuoteButtonText]=\"Spa_PlanCard_RemoveFromQuote_Text\"\r\n              [addToQuoteWarningTooltip]=\"addToQuoteWarningTooltip\"\r\n              [selectedQuoteGroup]=\"selectedCompareGroup\"\r\n              [isPlanAddedToQuote]=\"isSelectedToCompare(plan)\"\r\n              (addToQuote)=\"addPlanToHospitalIndemnityCompareGroup($event.plan, $event.addToQuoteTooltip)\"\r\n              (removePlanFromQuoteGroup)=\"removePlanToHospitalIndemnityCompareGroup($event.selectedQuoteGroup, $event.plan)\"\r\n            ></vnext-widget-plan-quote-button>\r\n          </ng-container>\r\n        </ng-container>\r\n\r\n        <ng-template #planDetailsOnlyButton>\r\n          <div class=\"d-none d-sm-block col-4 offset-3\">\r\n            <button\r\n              class=\"btn btn-block Spa_Style_SecondaryButton\"\r\n              title=\"{{ viewDetailsDescriptionText }} {{ plan.planName }}\"\r\n              (click)=\"viewPlanDetailsPage(plan)\"\r\n              *ngIf=\"Spa_Site_PlanViewDetails_Enabled\"\r\n              [attr.aria-label]=\"viewDetailsDescriptionText + plan.planName\"\r\n            >\r\n              {{ Spa_PlanCard_PlanDetails_ButtonText }}\r\n            </button>\r\n          </div>\r\n        </ng-template>\r\n      </div>\r\n\r\n      <div class=\"row align-items-sm-center pt-sm-1\" *ngIf=\"isAddToQuoteAvailable && !isAncillary\">\r\n        <div class=\"col-12 col-sm-8\">\r\n          <vnext-plan-card-riders\r\n            [selectedPlanType]=\"plan.planType\"\r\n            *ngIf=\"showRiderSection()\"\r\n            [showMedSupAddOnCoverageText]=\"showMedSupAddOnCoverageText\"\r\n            [addOnCoverageTooltipBody]=\"Spa_PlanCard_AddOnCoverageTooltip_Body\"\r\n            [addOnCoverageInCartText]=\"Spa_PlanCard_AddOnCoverageInCart_Text\"\r\n            [planRiderCategories]=\"riderFacade.getRiderCategories(plan.riders)\"\r\n            [Spa_Site_ShowRiderIcons]=\"Spa_Site_ShowRiderIcons\"\r\n            [Spa_Site_Dental_Rider_Display_Text]=\"Spa_Site_Dental_Rider_Display_Text\"\r\n            [Spa_Site_Vision_Rider_Display_Text]=\"Spa_Site_Vision_Rider_Display_Text\"\r\n            [Spa_Site_Hearing_Rider_Display_Text]=\"Spa_Site_Hearing_Rider_Display_Text\"\r\n            [Spa_PlanCard_DentalAddOnCoverage_Text]=\"Spa_PlanCard_DentalAddOnCoverage_Text\"\r\n            [Spa_PlanCard_HearingAddOnCoverage_Text]=\"Spa_PlanCard_HearingAddOnCoverage_Text\"\r\n            [Spa_PlanCard_VisionAddOnCoverage_Text]=\"Spa_PlanCard_VisionAddOnCoverage_Text\"\r\n            [Spa_PlanCard_AddOnCoverage_Text]=\"Spa_PlanCard_AddOnCoverage_Text\"\r\n            [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n            [isNotLicensedToSell]=\"isNotLicensedToSell\"\r\n          ></vnext-plan-card-riders>\r\n        </div>\r\n        <vnext-widget-plan-quote-button\r\n          class=\"col-4 p-0 d-none d-sm-block\"\r\n          [ngClass]=\"{ 'mt-2 btn4': addToCartEnabled }\"\r\n          [plan]=\"plan\"\r\n          [addToQuoteButtonText]=\"Spa_PlanCard_AddToQuote_Text\"\r\n          [removeFromQuoteButtonText]=\"Spa_PlanCard_RemoveFromQuote_Text\"\r\n          [addToQuoteWarningTooltip]=\"Spa_PlanCard_AddToQuote_Warning_Tooltip\"\r\n          [selectedQuoteGroup]=\"selectedQuoteGroup\"\r\n          [isPlanAddedToQuote]=\"isPlanAddedToQuote(plan)\"\r\n          (addToQuote)=\"addPlanToQuote($event.plan, $event.addToQuoteTooltip)\"\r\n          (removePlanFromQuoteGroup)=\"planFacade.removePlanFromQuoteGroup($event.selectedQuoteGroup, $event.plan)\"\r\n        ></vnext-widget-plan-quote-button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <ng-container *ngIf=\"annualCost && showPlanCoveragePreferences(); else notLicensedToSell\">\r\n    <div [ngSwitch]=\"plan.planType\">\r\n      <!-- Checking for MAPD PlanType -->\r\n      <div *ngSwitchCase=\"planType.MAPD\" class=\"Spa_Style_Toggle_Background px-2\">\r\n        <vnext-plan-coverage-preferences\r\n          [pharmacyNotCoveredText]=\"Spa_PlanDetails_Non_Covered_Text\"\r\n          [plan]=\"plan\"\r\n          [prescriptionsText]=\"Spa_Site_Prescriptions_Text\"\r\n          [pharmacyText]=\"Spa_Site_Pharmacy_Text\"\r\n          [pharmacyCoveredText]=\"pharmacyCoverageText\"\r\n          [addedPharmacy]=\"selectedPharmacy\"\r\n          [drugCoverageText]=\"getDrugCoverageText(drugCount, plan)\"\r\n          [showDrugCoverage]=\"showDrugCoverage(drugCount)\"\r\n          [planPreferences]=\"planPreferences\"\r\n          [totalEstimatedAnnualCostText]=\"Spa_PlanCard_TotalEstimatedAnnualCost_Text\"\r\n          [totalEstimatedCostText]=\"Spa_PlanCard_TotalEstimatedCost_Text\"\r\n          [totalEstimatedCostTooltip]=\"Spa_PlanCard_Total_Estimated_Cost_Tooltip\"\r\n          [isTotalEstimatedCostEnabled]=\"Spa_Site_TotalEstimatedCost_Enabled\"\r\n          [isEnabledShowDrugAlternatives]=\"Spa_Site_ShowDrugAlternatives_Enabled\"\r\n          [showNudgeDrugAlternatives]=\"Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled\"\r\n          [drugAlternativesTooltipText]=\"Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text\"\r\n          [nudgeDrugAlternativesLabelText]=\"Spa_PlanCard_ShowDrugAlternatives_Nudge_Text\"\r\n          [drugAlternativesIndicatorIcon]=\"Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon\"\r\n          [isRetention]=\"isRetentionView\"\r\n          [isQuoting]=\"isQuotingSite\"\r\n          [noCostAvailableText]=\"noCostAvailableText\"\r\n          [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n          [viewCostTooltipHeaderText]=\"viewCostTooltipHeaderText\"\r\n          [viewCostTooltipHeaderContent]=\"viewCostTooltipHeaderContent\"\r\n          [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n          [inNetworkStandardText]=\"inNetworkStandardText\"\r\n          [outOfNetworkText]=\"outOfNetworkText\"\r\n          [annualCost]=\"annualCost\"\r\n          [showMailOrderLabel]=\"isMailOrderSelected\"\r\n          [isMailOrderSelected]=\"isMailOrderSelected\"\r\n          [medicineCabinet]=\"medicineCabinet\"\r\n          [mailOrderText]=\"mailOrderText\"\r\n          [totalCostEffectiveDate]=\"totalCostEffectiveDate\"\r\n          [selectedProviders]=\"selectedProviders\"\r\n          [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n          [providerDetails]=\"providerDetails\"\r\n          [showProviderInNetworkOnOtherLocation]=\"planCardTile?.showProviderInNetworkOnOtherLocation\"\r\n          [providersCoveredText]=\"planCardTile?.providersCoveredText\"\r\n          [providerPcpText]=\"planCardTile?.providerPcpText\"\r\n          [loaderIconEnabled]=\"loaderIconEnabled\"\r\n          [editLinkText]=\"editLinkText\"\r\n          [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n          [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n          [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n          [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n          [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n          [isVbcAgreementEnabled]=\"isVbcAgreementEnabled\"\r\n          [vbcAgreementLabel]=\"vbcAgreementLabel\"\r\n          [vbcAgreementTooltip]=\"vbcAgreementTooltip\"\r\n        ></vnext-plan-coverage-preferences>\r\n        <div *ngIf=\"Spa_PlanCard_SupplementalBenefits_Enabled\">\r\n          <vnext-plan-card-supplemental-benefits\r\n            [supplementalBenefits]=\"Spa_PlanCard_SupplementalBenefits_List\"\r\n            [planBenefits]=\"plan.planDataFields\"\r\n            [hideLinkText]=\"hideLinkText\"\r\n            [viewAllLinkText]=\"viewAllLinkText\"\r\n            [isMobile]=\"isMobile\"\r\n            [availableText]=\"availableText\"\r\n            [unavailableText]=\"unavailableText\"\r\n            [supplementalBenefitsHighlightText]=\"supplementalBenefitsHighlightText\"\r\n          ></vnext-plan-card-supplemental-benefits>\r\n        </div>\r\n      </div>\r\n      <!-- Checking for MA PlanType -->\r\n      <div *ngSwitchCase=\"planType.MA\" class=\"Spa_Style_Toggle_Background px-2\">\r\n        <vnext-plan-coverage-preferences\r\n          [pharmacyNotCoveredText]=\"Spa_PlanDetails_Non_Covered_Text\"\r\n          [plan]=\"plan\"\r\n          [prescriptionsText]=\"Spa_Site_Prescriptions_Text\"\r\n          [pharmacyText]=\"Spa_Site_Pharmacy_Text\"\r\n          [pharmacyCoveredText]=\"pharmacyCoverageText\"\r\n          [addedPharmacy]=\"selectedPharmacy\"\r\n          [drugCoverageText]=\"getDrugCoverageText(drugCount, plan)\"\r\n          [showDrugCoverage]=\"showDrugCoverage(drugCount)\"\r\n          [planPreferences]=\"planPreferences\"\r\n          [totalEstimatedAnnualCostText]=\"Spa_PlanCard_TotalEstimatedAnnualCost_Text\"\r\n          [totalEstimatedCostText]=\"Spa_PlanCard_TotalEstimatedCost_Text\"\r\n          [totalEstimatedCostTooltip]=\"Spa_PlanCard_Total_Estimated_Cost_Tooltip\"\r\n          [isTotalEstimatedCostEnabled]=\"Spa_Site_TotalEstimatedCost_Enabled\"\r\n          [isEnabledShowDrugAlternatives]=\"Spa_Site_ShowDrugAlternatives_Enabled\"\r\n          [showNudgeDrugAlternatives]=\"Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled\"\r\n          [drugAlternativesTooltipText]=\"Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text\"\r\n          [nudgeDrugAlternativesLabelText]=\"Spa_PlanCard_ShowDrugAlternatives_Nudge_Text\"\r\n          [drugAlternativesIndicatorIcon]=\"Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon\"\r\n          [isRetention]=\"isRetentionView\"\r\n          [isQuoting]=\"isQuotingSite\"\r\n          [noCostAvailableText]=\"noCostAvailableText\"\r\n          [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n          [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n          [inNetworkStandardText]=\"inNetworkStandardText\"\r\n          [outOfNetworkText]=\"outOfNetworkText\"\r\n          [annualCost]=\"annualCost\"\r\n          [medicineCabinet]=\"medicineCabinet\"\r\n          [totalCostEffectiveDate]=\"totalCostEffectiveDate\"\r\n          [selectedProviders]=\"selectedProviders\"\r\n          [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n          [providerDetails]=\"providerDetails\"\r\n          [showProviderInNetworkOnOtherLocation]=\"planCardTile?.showProviderInNetworkOnOtherLocation\"\r\n          [providersCoveredText]=\"planCardTile?.providersCoveredText\"\r\n          [providerPcpText]=\"planCardTile?.providerPcpText\"\r\n          [loaderIconEnabled]=\"loaderIconEnabled\"\r\n          [editLinkText]=\"editLinkText\"\r\n          [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n          [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n          [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n          [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n          [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n          [isVbcAgreementEnabled]=\"isVbcAgreementEnabled\"\r\n          [vbcAgreementLabel]=\"vbcAgreementLabel\"\r\n          [vbcAgreementTooltip]=\"vbcAgreementTooltip\"\r\n        ></vnext-plan-coverage-preferences>\r\n        <div *ngIf=\"Spa_PlanCard_SupplementalBenefits_Enabled\">\r\n          <vnext-plan-card-supplemental-benefits\r\n            [supplementalBenefits]=\"Spa_PlanCard_SupplementalBenefits_List\"\r\n            [planBenefits]=\"plan.planDataFields\"\r\n            [hideLinkText]=\"hideLinkText\"\r\n            [viewAllLinkText]=\"viewAllLinkText\"\r\n            [isMobile]=\"isMobile\"\r\n            [availableText]=\"availableText\"\r\n            [unavailableText]=\"unavailableText\"\r\n            [supplementalBenefitsHighlightText]=\"supplementalBenefitsHighlightText\"\r\n          ></vnext-plan-card-supplemental-benefits>\r\n        </div>\r\n      </div>\r\n      <!-- Checking for PDP PlanType -->\r\n      <div *ngSwitchCase=\"planType.PDP\" class=\"Spa_Style_Toggle_Background px-2\">\r\n        <vnext-plan-coverage-preferences\r\n          [pharmacyNotCoveredText]=\"Spa_PlanDetails_Non_Covered_Text\"\r\n          [plan]=\"plan\"\r\n          [prescriptionsText]=\"Spa_Site_Prescriptions_Text\"\r\n          [pharmacyText]=\"Spa_Site_Pharmacy_Text\"\r\n          [pharmacyCoveredText]=\"pharmacyCoverageText\"\r\n          [addedPharmacy]=\"selectedPharmacy\"\r\n          [drugCoverageText]=\"getDrugCoverageText(drugCount, plan)\"\r\n          [showDrugCoverage]=\"showDrugCoverage(drugCount)\"\r\n          [planPreferences]=\"planPreferences\"\r\n          [totalEstimatedAnnualCostText]=\"Spa_PlanCard_TotalEstimatedAnnualCost_Text\"\r\n          [totalEstimatedCostText]=\"Spa_PlanCard_TotalEstimatedCost_Text\"\r\n          [totalEstimatedCostTooltip]=\"Spa_PlanCard_Total_Estimated_Cost_Tooltip\"\r\n          [isTotalEstimatedCostEnabled]=\"Spa_Site_TotalEstimatedCost_Enabled\"\r\n          [isEnabledShowDrugAlternatives]=\"Spa_Site_ShowDrugAlternatives_Enabled\"\r\n          [showNudgeDrugAlternatives]=\"Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled\"\r\n          [drugAlternativesTooltipText]=\"Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text\"\r\n          [nudgeDrugAlternativesLabelText]=\"Spa_PlanCard_ShowDrugAlternatives_Nudge_Text\"\r\n          [drugAlternativesIndicatorIcon]=\"Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon\"\r\n          [isRetention]=\"isRetentionView\"\r\n          [isQuoting]=\"isQuotingSite\"\r\n          [noCostAvailableText]=\"noCostAvailableText\"\r\n          [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n          [viewCostTooltipHeaderText]=\"viewCostTooltipHeaderText\"\r\n          [viewCostTooltipHeaderContent]=\"viewCostTooltipHeaderContent\"\r\n          [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n          [inNetworkStandardText]=\"inNetworkStandardText\"\r\n          [outOfNetworkText]=\"outOfNetworkText\"\r\n          [annualCost]=\"annualCost\"\r\n          [showMailOrderLabel]=\"isMailOrderSelected\"\r\n          [isMailOrderSelected]=\"isMailOrderSelected\"\r\n          [medicineCabinet]=\"medicineCabinet\"\r\n          [mailOrderText]=\"mailOrderText\"\r\n          [totalCostEffectiveDate]=\"totalCostEffectiveDate\"\r\n          [selectedProviders]=\"selectedProviders\"\r\n          [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n          [providerDetails]=\"providerDetails\"\r\n          [loaderIconEnabled]=\"loaderIconEnabled\"\r\n          [editLinkText]=\"editLinkText\"\r\n          [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n          [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n          [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n          [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n          [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n          [isVbcAgreementEnabled]=\"isVbcAgreementEnabled\"\r\n          [vbcAgreementLabel]=\"vbcAgreementLabel\"\r\n          [vbcAgreementTooltip]=\"vbcAgreementTooltip\"\r\n        ></vnext-plan-coverage-preferences>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"showAvailableRateFactorsEnabled && plan.planType === planType.MEDIGAP && plan.rateFactorsStatuses?.length\">\r\n    <vnext-widget-plan-card-rate-factors-statuses\r\n      [rateFactorsStatus]=\"plan.rateFactorsStatuses\"\r\n      [availableRateFactorsData]=\"availableRateFactorsData\"\r\n      [personalizedQuoteLabelText]=\"personalizedQuoteLabelText\"\r\n    ></vnext-widget-plan-card-rate-factors-statuses>\r\n  </ng-container>\r\n\r\n  <ng-template #notLicensedToSell>\r\n    <div>\r\n      <div class=\"row p-3\">\r\n        <div class=\"Spa_Style_Primary_Color Spa_Style_Paragraph px-3 py-1\">\r\n          {{ nonLicensedMessageText }}\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n<!--OLD PLAN CARD END-->\r\n", styles: [".plan-card{border-width:1px;border-style:solid;border-top-right-radius:4px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;padding:8px 0 0}.plan-card.plan-card-border{border-color:var(--static-Spa_Style_Accent1);border-top-left-radius:4px}.plan-card .image-responsive{padding-right:0;max-width:100%;text-align:center}.score-display{color:red}.monthly-premium-container{display:flex;flex-direction:column;height:100%;align-items:center;justify-content:center}.plan-premium{line-height:17px;margin-bottom:5px}.plan-benefits-column-list{display:flex;flex-wrap:wrap;list-style:none;padding:0}.plan-benefits-column-list li{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list li:last-child,.plan-benefits-column-list.plan-benefits-row-list li{border-bottom:0;margin-bottom:16px}.coverage{border-radius:14px;text-align:center;padding:4px}.coverage .fas{height:17px;width:18px}.plan-benefits-items:focus,.plan_monthly_premium:focus,.monthly-premium-container:focus,.coverage:focus{box-shadow:none;outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:0 0 5px var(--static-Spa_Style_Black);border-radius:5px}.tooltip-icon{font-size:12px;padding-right:10px;background-color:transparent;font-family:\"Font Awesome 5 Pro\"}.plan-benefits{margin-bottom:16px}.current-plan-text,.next-year-plan-text{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.plan-name:focus{border-radius:5px}.card-sub-header-details{display:flex;flex-wrap:wrap;align-items:baseline}.non-monthly-payment-text{font-size:13px;font-family:montserratregular}@media (max-width: 479.98px){.plan-benefits-column-list.plan-benefits-row-list li{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.plan-benefits-column-list.plan-benefits-row-list li:last-child{border-bottom:0}}.plan-benefits-items{flex-basis:33.3333%;flex-grow:0}@media (max-width: 575.98px){.plan-benefits-list-value-container{float:right;display:flex;flex-direction:column;align-items:flex-end}.plan-benefits{margin-bottom:0}}.no-border{border:none!important}\n"] }]
    }], function () { return [{ type: i1.NavigationService }, { type: PlanFacade }, { type: i1.DemographicService }, { type: RiderFacade }, { type: i1.PlanCompareService }, { type: i1.ResponsiveLayoutService }, { type: PlanCardFacade }, { type: i1.QuoteService }, { type: AnalyticsService }, { type: i1.LocaleService }, { type: i0.ChangeDetectorRef }, { type: PlanDetailsFacade }, { type: i1.GuidedHelpService }]; }, null); })();

function PlanCardComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-nextgen-plan-card", 2);
    i0.ɵɵlistener("quoteClicked", function PlanCardComponent_ng_container_0_Template_vnext_nextgen_plan_card_quoteClicked_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.onQuoteClicked()); })("quoteGroupChanged", function PlanCardComponent_ng_container_0_Template_vnext_nextgen_plan_card_quoteGroupChanged_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onQuoteGroupChanged()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", ctx_r0.plan)("activeTabType", ctx_r0.activeTabType)("selectedCompareGroup", ctx_r0.selectedCompareGroup)("compareGroups", ctx_r0.compareGroups)("planBenefits", ctx_r0.planBenefits)("displayDrugsCovered", ctx_r0.displayDrugsCovered)("planPreferences", ctx_r0.planPreferences)("hideCompareBoxOverride", ctx_r0.hideCompareBoxOverride)("isRetentionSummaryPage", ctx_r0.isRetentionSummaryPage)("currentPlanText", ctx_r0.currentPlanText)("nextYearPlanText", ctx_r0.nextYearPlanText)("bestMatchText", ctx_r0.bestMatchText)("bestMatchIcon", ctx_r0.bestMatchIcon)("bestMatchPlanId", ctx_r0.bestMatchPlanId)("bestMatchTooltip", ctx_r0.bestMatchTooltip)("selectedQuoteGroup", ctx_r0.selectedQuoteGroup)("quoteGroups", ctx_r0.quoteGroups)("addToQuoteLimit", ctx_r0.addToQuoteLimit)("noCostAvailableText", ctx_r0.noCostAvailableText)("isRetentionView", ctx_r0.isRetentionView)("isQuotingSite", ctx_r0.isQuotingSite)("nonLicensedPlanText", ctx_r0.nonLicensedPlanText)("nonLicensedMessageText", ctx_r0.nonLicensedMessageText)("includeNonLicensedPlans", ctx_r0.includeNonLicensedPlans)("isNotLicensedToSell", ctx_r0.isNotLicensedToSell)("planLogoSize", ctx_r0.planLogoSize)("Spa_Site_ShowRiderIcons", ctx_r0.Spa_Site_ShowRiderIcons)("Spa_Site_Dental_Rider_Display_Text", ctx_r0.Spa_Site_Dental_Rider_Display_Text)("Spa_Site_Vision_Rider_Display_Text", ctx_r0.Spa_Site_Vision_Rider_Display_Text)("Spa_Site_Hearing_Rider_Display_Text", ctx_r0.Spa_Site_Hearing_Rider_Display_Text)("Spa_PlanCard_DentalAddOnCoverage_Text", ctx_r0.Spa_PlanCard_DentalAddOnCoverage_Text)("Spa_PlanCard_HearingAddOnCoverage_Text", ctx_r0.Spa_PlanCard_HearingAddOnCoverage_Text)("Spa_PlanCard_VisionAddOnCoverage_Text", ctx_r0.Spa_PlanCard_VisionAddOnCoverage_Text)("Spa_PlanCard_AddOnCoverage_Text", ctx_r0.Spa_PlanCard_AddOnCoverage_Text)("Spa_PlanCard_AddToCompare_Text", ctx_r0.Spa_PlanCard_AddToCompare_Text)("Spa_Site_ShowRidersOnPlanCards", ctx_r0.Spa_Site_ShowRidersOnPlanCards)("Spa_ShoppingCart_Enabled", ctx_r0.Spa_ShoppingCart_Enabled)("Spa_PlanCard_PlanDetails_ButtonText", ctx_r0.Spa_PlanCard_PlanDetails_ButtonText)("Spa_Site_Show_PlanLogo", ctx_r0.Spa_Site_Show_PlanLogo)("Spa_Site_Show_AncillaryPlanLogo", ctx_r0.Spa_Site_Show_AncillaryPlanLogo)("Spa_PlanCard_QuoteLinkName_Text", ctx_r0.Spa_PlanCard_QuoteLinkName_Text)("Spa_PlanCard_PlanType_Text", ctx_r0.Spa_PlanCard_PlanType_Text)("Spa_PlanCard_ShowRidersOnMACards", ctx_r0.Spa_PlanCard_ShowRidersOnMACards)("Spa_PlanCard_ShowRidersOnPDPCards", ctx_r0.Spa_PlanCard_ShowRidersOnPDPCards)("Spa_PlanCard_ShowRidersOnMAPDCards", ctx_r0.Spa_PlanCard_ShowRidersOnMAPDCards)("Spa_PlanCard_ShowRidersOnMEDIGAPCards", ctx_r0.Spa_PlanCard_ShowRidersOnMEDIGAPCards)("Spa_PlanCard_ShowRidersOnDentalCards", ctx_r0.Spa_PlanCard_ShowRidersOnDentalCards)("Spa_PlanCard_ShowRidersOnVisionCards", ctx_r0.Spa_PlanCard_ShowRidersOnVisionCards)("Spa_PlanCard_ShowRidersOnHCCards", ctx_r0.Spa_PlanCard_ShowRidersOnHCCards)("Spa_Site_ShowPremiumAsAnnual", ctx_r0.Spa_Site_ShowPremiumAsAnnual)("Spa_PlanCard_AddOnCoverageInCart_Text", ctx_r0.Spa_PlanCard_AddOnCoverageInCart_Text)("Spa_PlanCard_AddOnCoverageTooltip_Body", ctx_r0.Spa_PlanCard_AddOnCoverageTooltip_Body)("Spa_Site_NotApplicable_Text", ctx_r0.Spa_Site_NotApplicable_Text)("Spa_PlanDetails_Non_Covered_Text", ctx_r0.Spa_PlanDetails_Non_Covered_Text)("Spa_Site_Pharmacy_Text", ctx_r0.Spa_Site_Pharmacy_Text)("Spa_PlanCard_Pharmacy_Covered_Text", ctx_r0.Spa_PlanCard_Pharmacy_Covered_Text)("Spa_Site_Prescriptions_Text", ctx_r0.Spa_Site_Prescriptions_Text)("Spa_PlanCard_Drug_Covered_Text", ctx_r0.Spa_PlanCard_Drug_Covered_Text)("Spa_PlanCard_CompareNow_Text", ctx_r0.Spa_PlanCard_CompareNow_Text)("Spa_PlanCard_CompareWarning_Tooltip", ctx_r0.Spa_PlanCard_CompareWarning_Tooltip)("Spa_PlanCard_CompareLimit_Desktop", ctx_r0.Spa_PlanCard_CompareLimit_Desktop)("Spa_PlanCard_CompareLimit_Mobile", ctx_r0.Spa_PlanCard_CompareLimit_Mobile)("Spa_PlanCard_Total_Estimated_Cost_Tooltip", ctx_r0.Spa_PlanCard_Total_Estimated_Cost_Tooltip)("Spa_Site_TotalEstimatedCost_Enabled", ctx_r0.Spa_Site_TotalEstimatedCost_Enabled)("Spa_PlanCard_TotalEstimatedAnnualCost_Text", ctx_r0.Spa_PlanCard_TotalEstimatedAnnualCost_Text)("Spa_PlanCard_TotalEstimatedCost_Text", ctx_r0.Spa_PlanCard_TotalEstimatedCost_Text)("Spa_PlanCard_AddToQuote_Text", ctx_r0.Spa_PlanCard_AddToQuote_Text)("Spa_PlanCard_RemoveFromQuote_Text", ctx_r0.Spa_PlanCard_RemoveFromQuote_Text)("Spa_PlanCard_AddToQuote_Warning_Tooltip", ctx_r0.Spa_PlanCard_AddToQuote_Warning_Tooltip)("Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip", ctx_r0.Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip)("Spa_PlanList_AddToQuote_Limit", ctx_r0.Spa_PlanList_AddToQuote_Limit)("Spa_PlanList_AddToQuote_Limit_Mobile", ctx_r0.Spa_PlanList_AddToQuote_Limit_Mobile)("Spa_Site_MedigapPlanType_Enabled", ctx_r0.Spa_Site_MedigapPlanType_Enabled)("Spa_Site_AddToCompare_Enabled", ctx_r0.Spa_Site_AddToCompare_Enabled)("Spa_Site_PlanViewDetails_Enabled", ctx_r0.Spa_Site_PlanViewDetails_Enabled)("Spa_Site_Tooltip_Text", ctx_r0.Spa_Site_Tooltip_Text)("Spa_Site_ComboPlanLabel_Text", ctx_r0.Spa_Site_ComboPlanLabel_Text)("Spa_Site_ComboPlanTooltip_Text", ctx_r0.Spa_Site_ComboPlanTooltip_Text)("Spa_Site_ShowDrugAlternatives_Enabled", ctx_r0.Spa_Site_ShowDrugAlternatives_Enabled)("Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled", ctx_r0.Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled)("Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text", ctx_r0.Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text)("Spa_PlanCard_ShowDrugAlternatives_Nudge_Text", ctx_r0.Spa_PlanCard_ShowDrugAlternatives_Nudge_Text)("Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon", ctx_r0.Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon)("queuePosition", ctx_r0.queuePosition)("plansSelectedToQuote", ctx_r0.plansSelectedToQuote)("viewCostTooltipHeaderText", ctx_r0.viewCostTooltipHeaderText)("viewCostTooltipHeaderContent", ctx_r0.viewCostTooltipHeaderContent)("inNetworkPreferredText", ctx_r0.inNetworkPreferredText)("inNetworkStandardText", ctx_r0.inNetworkStandardText)("outOfNetworkText", ctx_r0.outOfNetworkText)("selectedPharmacy", ctx_r0.selectedPharmacy)("isMailOrderSelected", ctx_r0.isMailOrderSelected)("mailOrderText", ctx_r0.mailOrderText)("selectedProviders", ctx_r0.selectedProviders)("providerDetails", ctx_r0.providerDetails)("providersInNetworkText", ctx_r0.providersInNetworkText)("pcpInNetworkText", ctx_r0.pcpInNetworkText)("pcpOutOfNetworkText", ctx_r0.pcpOutOfNetworkText)("providersNoDataText", ctx_r0.providersNoDataText)("isProviderEnabled", ctx_r0.isProviderEnabled)("showStarRating", ctx_r0.showStarRating)("showPreferenceScore", ctx_r0.showPreferenceScore)("CSNPEnabled", ctx_r0.CSNPEnabled)("DSNPEnabled", ctx_r0.DSNPEnabled)("ISNPEnabled", ctx_r0.ISNPEnabled)("CSNPText", ctx_r0.CSNPText)("DSNPText", ctx_r0.DSNPText)("ISNPText", ctx_r0.ISNPText)("SNPText", ctx_r0.SNPText)("noProviderNetworkAccessText", ctx_r0.noProviderNetworkAccessText)("viewDetailsDescriptionText", ctx_r0.viewDetailsDescriptionText)("medSupPaymentMethod", ctx_r0.medSupPaymentMethod)("nonMonthlyRateText", ctx_r0.nonMonthlyRateText)("medSupPaymentMethodDisplayText", ctx_r0.medSupPaymentMethodDisplayText)("showNonMonthlyRateText", ctx_r0.showNonMonthlyRateText)("optionOneText", ctx_r0.optionOneText)("optionTwoText", ctx_r0.optionTwoText)("displayOptionLabels", ctx_r0.displayOptionLabels)("nonCommissionableText", ctx_r0.nonCommissionableText)("isNonCommissionableFlagCheckEnabled", ctx_r0.isNonCommissionableFlagCheckEnabled)("hidePlanCardLabel", ctx_r0.hidePlanCardLabel)("monthlyPremiumText", ctx_r0.monthlyPremiumText)("moreBenefitsInstructionText", ctx_r0.moreBenefitsInstructionText)("basePlanOptionText", ctx_r0.basePlanOptionText)("totalCostEffectiveDate", ctx_r0.totalCostEffectiveDate)("medicineCabinet", ctx_r0.medicineCabinet)("memberHasOptionsDefined", ctx_r0.memberHasOptionsDefined)("planCardPreferenceDetailedEnabled", ctx_r0.planCardPreferenceDetailedEnabled)("showAddToCartForAncillaryPlans", ctx_r0.showAddToCartForAncillaryPlans)("showAncillaryIcons", ctx_r0.showAncillaryIcons)("loaderIconEnabled", ctx_r0.loaderIconEnabled)("hideLinkText", ctx_r0.hideLinkText)("viewAllLinkText", ctx_r0.viewAllLinkText)("Spa_PlanCard_SupplementalBenefits_Enabled", ctx_r0.Spa_PlanCard_SupplementalBenefits_Enabled)("Spa_PlanCard_SupplementalBenefits_List", ctx_r0.Spa_PlanCard_SupplementalBenefits_List)("editLinkText", ctx_r0.editLinkText)("showRatingMethod", ctx_r0.showRatingMethod)("Spa_RatingMethod_AttainedAge_Tooltip_Text", ctx_r0.Spa_RatingMethod_AttainedAge_Tooltip_Text)("Spa_RatingMethod_IssueAge_Tooltip_Text", ctx_r0.Spa_RatingMethod_IssueAge_Tooltip_Text)("Spa_RatingMethod_CommunityRated_Tooltip_Text", ctx_r0.Spa_RatingMethod_CommunityRated_Tooltip_Text)("providerOneOrMoreOutOfNetworkText", ctx_r0.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r0.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r0.providerShowPartialIndicatorEnabled)("planFeesEnabled", ctx_r0.planFeesEnabled)("planFeesTooltipText", ctx_r0.planFeesTooltipText)("planFeesIncludedInPremiumTooltipText", ctx_r0.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r0.planFeesNotIncludedInPremiumTooltipText)("showAvailableRateFactorsEnabled", ctx_r0.showAvailableRateFactorsEnabled)("personalizedQuoteLabelText", ctx_r0.personalizedQuoteLabelText)("availableRateFactorsData", ctx_r0.availableRateFactorsData)("snpPremiumRangeEnabled", ctx_r0.snpPremiumRangeEnabled)("showPlanId", ctx_r0.showPlanId)("snpRangeLinkText", ctx_r0.snpRangeLinkText)("showPlanYear", ctx_r0.showPlanYear)("planIdText", ctx_r0.planIdText)("enableDSNPCodes", ctx_r0.enableDSNPCodes)("availableText", ctx_r0.availableText)("unavailableText", ctx_r0.unavailableText)("viewProvidersButtonText", ctx_r0.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r0.viewPrescriptionsButtonText)("supplementalBenefitsHighlightText", ctx_r0.supplementalBenefitsHighlightText)("preferencesText", ctx_r0.preferencesText)("viewMoreDetailsText", ctx_r0.viewMoreDetailsText)("hideDetailsText", ctx_r0.hideDetailsText)("newPlanCardDesignEnabled", ctx_r0.newPlanCardDesignEnabled)("viewAllPlanDetailsText", ctx_r0.viewAllPlanDetailsText)("shareThisPlanText", ctx_r0.shareThisPlanText)("viewCostDetailsText", ctx_r0.viewCostDetailsText)("closeText", ctx_r0.closeText)("planBenefitHighlightItems", ctx_r0.planBenefitHighlightItems)("addOnCoverageHeaderText", ctx_r0.Spa_PlanCard_AddOnCoverage_Text)("planBenefitHighlightsHeaderText", ctx_r0.planBenefitHighlightsHeaderText)("showRiderDetails", ctx_r0.showRiderDetails)("showRiderDetailsText", ctx_r0.showRiderDetailsText)("hideRiderDetailsText", ctx_r0.hideRiderDetailsText)("riderIsIncludedText", ctx_r0.riderIsIncludedText)("waiverStateRiderTooltips", ctx_r0.waiverStateRiderTooltips)("costMA", ctx_r0.costMA)("costMAPD", ctx_r0.costMAPD)("costPDP", ctx_r0.costPDP)("costMEDIGAP", ctx_r0.costMEDIGAP)("costDENTAL", ctx_r0.costDENTAL)("costVISION", ctx_r0.costVISION)("isVbcAgreementEnabled", ctx_r0.isVbcAgreementEnabled)("vbcAgreementLabel", ctx_r0.vbcAgreementLabel)("vbcAgreementTooltip", ctx_r0.vbcAgreementTooltip);
} }
function PlanCardComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-legacy-plan-card", 2);
    i0.ɵɵlistener("quoteClicked", function PlanCardComponent_ng_template_1_Template_vnext_legacy_plan_card_quoteClicked_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.onQuoteClicked()); })("quoteGroupChanged", function PlanCardComponent_ng_template_1_Template_vnext_legacy_plan_card_quoteGroupChanged_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.onQuoteGroupChanged()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("plan", ctx_r2.plan)("activeTabType", ctx_r2.activeTabType)("selectedCompareGroup", ctx_r2.selectedCompareGroup)("compareGroups", ctx_r2.compareGroups)("planBenefits", ctx_r2.planBenefits)("displayDrugsCovered", ctx_r2.displayDrugsCovered)("planPreferences", ctx_r2.planPreferences)("hideCompareBoxOverride", ctx_r2.hideCompareBoxOverride)("isRetentionSummaryPage", ctx_r2.isRetentionSummaryPage)("currentPlanText", ctx_r2.currentPlanText)("nextYearPlanText", ctx_r2.nextYearPlanText)("bestMatchText", ctx_r2.bestMatchText)("bestMatchIcon", ctx_r2.bestMatchIcon)("bestMatchPlanId", ctx_r2.bestMatchPlanId)("bestMatchTooltip", ctx_r2.bestMatchTooltip)("selectedQuoteGroup", ctx_r2.selectedQuoteGroup)("quoteGroups", ctx_r2.quoteGroups)("addToQuoteLimit", ctx_r2.addToQuoteLimit)("noCostAvailableText", ctx_r2.noCostAvailableText)("isRetentionView", ctx_r2.isRetentionView)("isQuotingSite", ctx_r2.isQuotingSite)("nonLicensedPlanText", ctx_r2.nonLicensedPlanText)("nonLicensedMessageText", ctx_r2.nonLicensedMessageText)("includeNonLicensedPlans", ctx_r2.includeNonLicensedPlans)("isNotLicensedToSell", ctx_r2.isNotLicensedToSell)("planLogoSize", ctx_r2.planLogoSize)("Spa_Site_ShowRiderIcons", ctx_r2.Spa_Site_ShowRiderIcons)("Spa_Site_Dental_Rider_Display_Text", ctx_r2.Spa_Site_Dental_Rider_Display_Text)("Spa_Site_Vision_Rider_Display_Text", ctx_r2.Spa_Site_Vision_Rider_Display_Text)("Spa_Site_Hearing_Rider_Display_Text", ctx_r2.Spa_Site_Hearing_Rider_Display_Text)("Spa_PlanCard_DentalAddOnCoverage_Text", ctx_r2.Spa_PlanCard_DentalAddOnCoverage_Text)("Spa_PlanCard_HearingAddOnCoverage_Text", ctx_r2.Spa_PlanCard_HearingAddOnCoverage_Text)("Spa_PlanCard_VisionAddOnCoverage_Text", ctx_r2.Spa_PlanCard_VisionAddOnCoverage_Text)("Spa_PlanCard_AddOnCoverage_Text", ctx_r2.Spa_PlanCard_AddOnCoverage_Text)("Spa_PlanCard_AddToCompare_Text", ctx_r2.Spa_PlanCard_AddToCompare_Text)("Spa_Site_ShowRidersOnPlanCards", ctx_r2.Spa_Site_ShowRidersOnPlanCards)("Spa_ShoppingCart_Enabled", ctx_r2.Spa_ShoppingCart_Enabled)("Spa_PlanCard_PlanDetails_ButtonText", ctx_r2.Spa_PlanCard_PlanDetails_ButtonText)("Spa_Site_Show_PlanLogo", ctx_r2.Spa_Site_Show_PlanLogo)("Spa_Site_Show_AncillaryPlanLogo", ctx_r2.Spa_Site_Show_AncillaryPlanLogo)("Spa_PlanCard_QuoteLinkName_Text", ctx_r2.Spa_PlanCard_QuoteLinkName_Text)("Spa_PlanCard_PlanType_Text", ctx_r2.Spa_PlanCard_PlanType_Text)("Spa_PlanCard_ShowRidersOnMACards", ctx_r2.Spa_PlanCard_ShowRidersOnMACards)("Spa_PlanCard_ShowRidersOnPDPCards", ctx_r2.Spa_PlanCard_ShowRidersOnPDPCards)("Spa_PlanCard_ShowRidersOnMAPDCards", ctx_r2.Spa_PlanCard_ShowRidersOnMAPDCards)("Spa_PlanCard_ShowRidersOnMEDIGAPCards", ctx_r2.Spa_PlanCard_ShowRidersOnMEDIGAPCards)("Spa_PlanCard_ShowRidersOnDentalCards", ctx_r2.Spa_PlanCard_ShowRidersOnDentalCards)("Spa_PlanCard_ShowRidersOnVisionCards", ctx_r2.Spa_PlanCard_ShowRidersOnVisionCards)("Spa_PlanCard_ShowRidersOnHCCards", ctx_r2.Spa_PlanCard_ShowRidersOnHCCards)("Spa_Site_ShowPremiumAsAnnual", ctx_r2.Spa_Site_ShowPremiumAsAnnual)("Spa_PlanCard_AddOnCoverageInCart_Text", ctx_r2.Spa_PlanCard_AddOnCoverageInCart_Text)("Spa_PlanCard_AddOnCoverageTooltip_Body", ctx_r2.Spa_PlanCard_AddOnCoverageTooltip_Body)("Spa_Site_NotApplicable_Text", ctx_r2.Spa_Site_NotApplicable_Text)("Spa_PlanDetails_Non_Covered_Text", ctx_r2.Spa_PlanDetails_Non_Covered_Text)("Spa_Site_Pharmacy_Text", ctx_r2.Spa_Site_Pharmacy_Text)("Spa_PlanCard_Pharmacy_Covered_Text", ctx_r2.Spa_PlanCard_Pharmacy_Covered_Text)("Spa_Site_Prescriptions_Text", ctx_r2.Spa_Site_Prescriptions_Text)("Spa_PlanCard_Drug_Covered_Text", ctx_r2.Spa_PlanCard_Drug_Covered_Text)("Spa_PlanCard_CompareNow_Text", ctx_r2.Spa_PlanCard_CompareNow_Text)("Spa_PlanCard_CompareWarning_Tooltip", ctx_r2.Spa_PlanCard_CompareWarning_Tooltip)("Spa_PlanCard_CompareLimit_Desktop", ctx_r2.Spa_PlanCard_CompareLimit_Desktop)("Spa_PlanCard_CompareLimit_Mobile", ctx_r2.Spa_PlanCard_CompareLimit_Mobile)("Spa_PlanCard_Total_Estimated_Cost_Tooltip", ctx_r2.Spa_PlanCard_Total_Estimated_Cost_Tooltip)("Spa_Site_TotalEstimatedCost_Enabled", ctx_r2.Spa_Site_TotalEstimatedCost_Enabled)("Spa_PlanCard_TotalEstimatedAnnualCost_Text", ctx_r2.Spa_PlanCard_TotalEstimatedAnnualCost_Text)("Spa_PlanCard_TotalEstimatedCost_Text", ctx_r2.Spa_PlanCard_TotalEstimatedCost_Text)("Spa_PlanCard_AddToQuote_Text", ctx_r2.Spa_PlanCard_AddToQuote_Text)("Spa_PlanCard_RemoveFromQuote_Text", ctx_r2.Spa_PlanCard_RemoveFromQuote_Text)("Spa_PlanCard_AddToQuote_Warning_Tooltip", ctx_r2.Spa_PlanCard_AddToQuote_Warning_Tooltip)("Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip", ctx_r2.Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip)("Spa_PlanList_AddToQuote_Limit", ctx_r2.Spa_PlanList_AddToQuote_Limit)("Spa_PlanList_AddToQuote_Limit_Mobile", ctx_r2.Spa_PlanList_AddToQuote_Limit_Mobile)("Spa_Site_MedigapPlanType_Enabled", ctx_r2.Spa_Site_MedigapPlanType_Enabled)("Spa_Site_AddToCompare_Enabled", ctx_r2.Spa_Site_AddToCompare_Enabled)("Spa_Site_PlanViewDetails_Enabled", ctx_r2.Spa_Site_PlanViewDetails_Enabled)("Spa_Site_Tooltip_Text", ctx_r2.Spa_Site_Tooltip_Text)("Spa_Site_ComboPlanLabel_Text", ctx_r2.Spa_Site_ComboPlanLabel_Text)("Spa_Site_ComboPlanTooltip_Text", ctx_r2.Spa_Site_ComboPlanTooltip_Text)("Spa_Site_ShowDrugAlternatives_Enabled", ctx_r2.Spa_Site_ShowDrugAlternatives_Enabled)("Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled", ctx_r2.Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled)("Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text", ctx_r2.Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text)("Spa_PlanCard_ShowDrugAlternatives_Nudge_Text", ctx_r2.Spa_PlanCard_ShowDrugAlternatives_Nudge_Text)("Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon", ctx_r2.Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon)("queuePosition", ctx_r2.queuePosition)("plansSelectedToQuote", ctx_r2.plansSelectedToQuote)("viewCostTooltipHeaderText", ctx_r2.viewCostTooltipHeaderText)("viewCostTooltipHeaderContent", ctx_r2.viewCostTooltipHeaderContent)("inNetworkPreferredText", ctx_r2.inNetworkPreferredText)("inNetworkStandardText", ctx_r2.inNetworkStandardText)("outOfNetworkText", ctx_r2.outOfNetworkText)("selectedPharmacy", ctx_r2.selectedPharmacy)("isMailOrderSelected", ctx_r2.isMailOrderSelected)("mailOrderText", ctx_r2.mailOrderText)("selectedProviders", ctx_r2.selectedProviders)("providerDetails", ctx_r2.providerDetails)("providersInNetworkText", ctx_r2.providersInNetworkText)("pcpInNetworkText", ctx_r2.pcpInNetworkText)("pcpOutOfNetworkText", ctx_r2.pcpOutOfNetworkText)("providersNoDataText", ctx_r2.providersNoDataText)("isProviderEnabled", ctx_r2.isProviderEnabled)("showStarRating", ctx_r2.showStarRating)("showPreferenceScore", ctx_r2.showPreferenceScore)("CSNPEnabled", ctx_r2.CSNPEnabled)("DSNPEnabled", ctx_r2.DSNPEnabled)("ISNPEnabled", ctx_r2.ISNPEnabled)("CSNPText", ctx_r2.CSNPText)("DSNPText", ctx_r2.DSNPText)("ISNPText", ctx_r2.ISNPText)("SNPText", ctx_r2.SNPText)("noProviderNetworkAccessText", ctx_r2.noProviderNetworkAccessText)("viewDetailsDescriptionText", ctx_r2.viewDetailsDescriptionText)("medSupPaymentMethod", ctx_r2.medSupPaymentMethod)("nonMonthlyRateText", ctx_r2.nonMonthlyRateText)("medSupPaymentMethodDisplayText", ctx_r2.medSupPaymentMethodDisplayText)("showNonMonthlyRateText", ctx_r2.showNonMonthlyRateText)("optionOneText", ctx_r2.optionOneText)("optionTwoText", ctx_r2.optionTwoText)("displayOptionLabels", ctx_r2.displayOptionLabels)("nonCommissionableText", ctx_r2.nonCommissionableText)("isNonCommissionableFlagCheckEnabled", ctx_r2.isNonCommissionableFlagCheckEnabled)("hidePlanCardLabel", ctx_r2.hidePlanCardLabel)("monthlyPremiumText", ctx_r2.monthlyPremiumText)("moreBenefitsInstructionText", ctx_r2.moreBenefitsInstructionText)("basePlanOptionText", ctx_r2.basePlanOptionText)("totalCostEffectiveDate", ctx_r2.totalCostEffectiveDate)("medicineCabinet", ctx_r2.medicineCabinet)("memberHasOptionsDefined", ctx_r2.memberHasOptionsDefined)("planCardPreferenceDetailedEnabled", ctx_r2.planCardPreferenceDetailedEnabled)("showAddToCartForAncillaryPlans", ctx_r2.showAddToCartForAncillaryPlans)("showAncillaryIcons", ctx_r2.showAncillaryIcons)("loaderIconEnabled", ctx_r2.loaderIconEnabled)("hideLinkText", ctx_r2.hideLinkText)("viewAllLinkText", ctx_r2.viewAllLinkText)("Spa_PlanCard_SupplementalBenefits_Enabled", ctx_r2.Spa_PlanCard_SupplementalBenefits_Enabled)("Spa_PlanCard_SupplementalBenefits_List", ctx_r2.Spa_PlanCard_SupplementalBenefits_List)("editLinkText", ctx_r2.editLinkText)("showRatingMethod", ctx_r2.showRatingMethod)("Spa_RatingMethod_AttainedAge_Tooltip_Text", ctx_r2.Spa_RatingMethod_AttainedAge_Tooltip_Text)("Spa_RatingMethod_IssueAge_Tooltip_Text", ctx_r2.Spa_RatingMethod_IssueAge_Tooltip_Text)("Spa_RatingMethod_CommunityRated_Tooltip_Text", ctx_r2.Spa_RatingMethod_CommunityRated_Tooltip_Text)("providerOneOrMoreOutOfNetworkText", ctx_r2.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r2.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r2.providerShowPartialIndicatorEnabled)("planFeesEnabled", ctx_r2.planFeesEnabled)("planFeesTooltipText", ctx_r2.planFeesTooltipText)("planFeesIncludedInPremiumTooltipText", ctx_r2.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r2.planFeesNotIncludedInPremiumTooltipText)("showAvailableRateFactorsEnabled", ctx_r2.showAvailableRateFactorsEnabled)("personalizedQuoteLabelText", ctx_r2.personalizedQuoteLabelText)("availableRateFactorsData", ctx_r2.availableRateFactorsData)("snpPremiumRangeEnabled", ctx_r2.snpPremiumRangeEnabled)("showPlanId", ctx_r2.showPlanId)("snpRangeLinkText", ctx_r2.snpRangeLinkText)("showPlanYear", ctx_r2.showPlanYear)("planIdText", ctx_r2.planIdText)("enableDSNPCodes", ctx_r2.enableDSNPCodes)("availableText", ctx_r2.availableText)("unavailableText", ctx_r2.unavailableText)("viewProvidersButtonText", ctx_r2.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r2.viewPrescriptionsButtonText)("supplementalBenefitsHighlightText", ctx_r2.supplementalBenefitsHighlightText)("preferencesText", ctx_r2.preferencesText)("viewMoreDetailsText", ctx_r2.viewMoreDetailsText)("hideDetailsText", ctx_r2.hideDetailsText)("newPlanCardDesignEnabled", ctx_r2.newPlanCardDesignEnabled)("viewAllPlanDetailsText", ctx_r2.viewAllPlanDetailsText)("shareThisPlanText", ctx_r2.shareThisPlanText)("viewCostDetailsText", ctx_r2.viewCostDetailsText)("closeText", ctx_r2.closeText)("planBenefitHighlightItems", ctx_r2.planBenefitHighlightItems)("addOnCoverageHeaderText", ctx_r2.Spa_PlanCard_AddOnCoverage_Text)("planBenefitHighlightsHeaderText", ctx_r2.planBenefitHighlightsHeaderText)("showRiderDetails", ctx_r2.showRiderDetails)("showRiderDetailsText", ctx_r2.showRiderDetailsText)("hideRiderDetailsText", ctx_r2.hideRiderDetailsText)("riderIsIncludedText", ctx_r2.riderIsIncludedText)("waiverStateRiderTooltips", ctx_r2.waiverStateRiderTooltips)("costMA", ctx_r2.costMA)("costMAPD", ctx_r2.costMAPD)("costPDP", ctx_r2.costPDP)("costMEDIGAP", ctx_r2.costMEDIGAP)("costDENTAL", ctx_r2.costDENTAL)("costVISION", ctx_r2.costVISION)("isVbcAgreementEnabled", ctx_r2.isVbcAgreementEnabled)("vbcAgreementLabel", ctx_r2.vbcAgreementLabel)("vbcAgreementTooltip", ctx_r2.vbcAgreementTooltip)("nonCommissionableText", ctx_r2.nonCommissionableText)("isNonCommissionableFlagCheckEnabled", ctx_r2.isNonCommissionableFlagCheckEnabled);
} }
class PlanCardComponent {
    constructor() {
        this.Spa_Site_ShowDrugAlternatives_Enabled = false;
        this.Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled = false;
        this.showStarRating = true;
        this.showPreferenceScore = false;
        this.CSNPEnabled = false;
        this.DSNPEnabled = false;
        this.ISNPEnabled = false;
        this.CSNPText = '';
        this.DSNPText = '';
        this.ISNPText = '';
        this.SNPText = '<snpType> Plan';
        this.viewDetailsDescriptionText = 'Press Enter to view plan details of ';
        this.medicineCabinet = [];
        this.showAddToCartForAncillaryPlans = true;
        this.showAncillaryIcons = false;
        this.loaderIconEnabled = false;
        this.Spa_PlanCard_SupplementalBenefits_Enabled = false;
        this.Spa_PlanCard_SupplementalBenefits_List = [];
        this.showRatingMethod = false;
        this.Spa_RatingMethod_AttainedAge_Tooltip_Text = '';
        this.Spa_RatingMethod_IssueAge_Tooltip_Text = '';
        this.Spa_RatingMethod_CommunityRated_Tooltip_Text = '';
        this.showPlanYear = false;
        this.enableDSNPCodes = false;
        this.newPlanCardDesignEnabled = false;
        this.planBenefitHighlightItems = [];
        this.waiverStateRiderTooltips = [];
        this.isNonCommissionableFlagCheckEnabled = false;
        this.quoteClicked = new EventEmitter();
        this.quoteGroupChanged = new EventEmitter();
    }
    onQuoteClicked() {
        this.quoteClicked.emit();
    }
    onQuoteGroupChanged() {
        this.quoteGroupChanged.emit();
    }
}
PlanCardComponent.ɵfac = function PlanCardComponent_Factory(t) { return new (t || PlanCardComponent)(); };
PlanCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCardComponent, selectors: [["vnext-widget-plan-card"]], inputs: { plan: "plan", activeTabType: "activeTabType", selectedCompareGroup: "selectedCompareGroup", compareGroups: "compareGroups", planBenefits: "planBenefits", displayDrugsCovered: "displayDrugsCovered", planPreferences: "planPreferences", hideCompareBoxOverride: "hideCompareBoxOverride", isRetentionSummaryPage: "isRetentionSummaryPage", currentPlanText: "currentPlanText", nextYearPlanText: "nextYearPlanText", bestMatchText: "bestMatchText", bestMatchIcon: "bestMatchIcon", bestMatchPlanId: "bestMatchPlanId", bestMatchTooltip: "bestMatchTooltip", selectedQuoteGroup: "selectedQuoteGroup", quoteGroups: "quoteGroups", addToQuoteLimit: "addToQuoteLimit", noCostAvailableText: "noCostAvailableText", isRetentionView: "isRetentionView", isQuotingSite: "isQuotingSite", nonLicensedPlanText: "nonLicensedPlanText", nonLicensedMessageText: "nonLicensedMessageText", includeNonLicensedPlans: "includeNonLicensedPlans", isNotLicensedToSell: "isNotLicensedToSell", planLogoSize: "planLogoSize", Spa_Site_ShowRiderIcons: "Spa_Site_ShowRiderIcons", Spa_Site_Dental_Rider_Display_Text: "Spa_Site_Dental_Rider_Display_Text", Spa_Site_Vision_Rider_Display_Text: "Spa_Site_Vision_Rider_Display_Text", Spa_Site_Hearing_Rider_Display_Text: "Spa_Site_Hearing_Rider_Display_Text", Spa_PlanCard_DentalAddOnCoverage_Text: "Spa_PlanCard_DentalAddOnCoverage_Text", Spa_PlanCard_HearingAddOnCoverage_Text: "Spa_PlanCard_HearingAddOnCoverage_Text", Spa_PlanCard_VisionAddOnCoverage_Text: "Spa_PlanCard_VisionAddOnCoverage_Text", Spa_PlanCard_AddOnCoverage_Text: "Spa_PlanCard_AddOnCoverage_Text", Spa_PlanCard_AddToCompare_Text: "Spa_PlanCard_AddToCompare_Text", Spa_Site_ShowRidersOnPlanCards: "Spa_Site_ShowRidersOnPlanCards", Spa_ShoppingCart_Enabled: "Spa_ShoppingCart_Enabled", Spa_PlanCard_PlanDetails_ButtonText: "Spa_PlanCard_PlanDetails_ButtonText", Spa_Site_Show_PlanLogo: "Spa_Site_Show_PlanLogo", Spa_Site_Show_AncillaryPlanLogo: "Spa_Site_Show_AncillaryPlanLogo", Spa_PlanCard_QuoteLinkName_Text: "Spa_PlanCard_QuoteLinkName_Text", Spa_PlanCard_PlanType_Text: "Spa_PlanCard_PlanType_Text", Spa_PlanCard_ShowRidersOnMACards: "Spa_PlanCard_ShowRidersOnMACards", Spa_PlanCard_ShowRidersOnPDPCards: "Spa_PlanCard_ShowRidersOnPDPCards", Spa_PlanCard_ShowRidersOnMAPDCards: "Spa_PlanCard_ShowRidersOnMAPDCards", Spa_PlanCard_ShowRidersOnMEDIGAPCards: "Spa_PlanCard_ShowRidersOnMEDIGAPCards", Spa_PlanCard_ShowRidersOnDentalCards: "Spa_PlanCard_ShowRidersOnDentalCards", Spa_PlanCard_ShowRidersOnVisionCards: "Spa_PlanCard_ShowRidersOnVisionCards", Spa_PlanCard_ShowRidersOnHCCards: "Spa_PlanCard_ShowRidersOnHCCards", Spa_Site_ShowPremiumAsAnnual: "Spa_Site_ShowPremiumAsAnnual", Spa_PlanCard_AddOnCoverageInCart_Text: "Spa_PlanCard_AddOnCoverageInCart_Text", Spa_PlanCard_AddOnCoverageTooltip_Body: "Spa_PlanCard_AddOnCoverageTooltip_Body", Spa_Site_NotApplicable_Text: "Spa_Site_NotApplicable_Text", Spa_PlanDetails_Non_Covered_Text: "Spa_PlanDetails_Non_Covered_Text", Spa_Site_Pharmacy_Text: "Spa_Site_Pharmacy_Text", Spa_PlanCard_Pharmacy_Covered_Text: "Spa_PlanCard_Pharmacy_Covered_Text", Spa_Site_Prescriptions_Text: "Spa_Site_Prescriptions_Text", Spa_PlanCard_Drug_Covered_Text: "Spa_PlanCard_Drug_Covered_Text", Spa_PlanCard_CompareNow_Text: "Spa_PlanCard_CompareNow_Text", Spa_PlanCard_CompareWarning_Tooltip: "Spa_PlanCard_CompareWarning_Tooltip", Spa_PlanCard_CompareLimit_Desktop: "Spa_PlanCard_CompareLimit_Desktop", Spa_PlanCard_CompareLimit_Mobile: "Spa_PlanCard_CompareLimit_Mobile", Spa_PlanCard_Total_Estimated_Cost_Tooltip: "Spa_PlanCard_Total_Estimated_Cost_Tooltip", Spa_Site_TotalEstimatedCost_Enabled: "Spa_Site_TotalEstimatedCost_Enabled", Spa_PlanCard_TotalEstimatedAnnualCost_Text: "Spa_PlanCard_TotalEstimatedAnnualCost_Text", Spa_PlanCard_TotalEstimatedCost_Text: "Spa_PlanCard_TotalEstimatedCost_Text", Spa_PlanCard_AddToQuote_Text: "Spa_PlanCard_AddToQuote_Text", Spa_PlanCard_RemoveFromQuote_Text: "Spa_PlanCard_RemoveFromQuote_Text", Spa_PlanCard_AddToQuote_Warning_Tooltip: "Spa_PlanCard_AddToQuote_Warning_Tooltip", Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip: "Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip", Spa_PlanList_AddToQuote_Limit: "Spa_PlanList_AddToQuote_Limit", Spa_PlanList_AddToQuote_Limit_Mobile: "Spa_PlanList_AddToQuote_Limit_Mobile", Spa_Site_MedigapPlanType_Enabled: "Spa_Site_MedigapPlanType_Enabled", Spa_Site_AddToCompare_Enabled: "Spa_Site_AddToCompare_Enabled", Spa_Site_PlanViewDetails_Enabled: "Spa_Site_PlanViewDetails_Enabled", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text", Spa_Site_ComboPlanLabel_Text: "Spa_Site_ComboPlanLabel_Text", Spa_Site_ComboPlanTooltip_Text: "Spa_Site_ComboPlanTooltip_Text", Spa_Site_ShowDrugAlternatives_Enabled: "Spa_Site_ShowDrugAlternatives_Enabled", Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled: "Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled", Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text: "Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text", Spa_PlanCard_ShowDrugAlternatives_Nudge_Text: "Spa_PlanCard_ShowDrugAlternatives_Nudge_Text", Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon: "Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon", queuePosition: "queuePosition", plansSelectedToQuote: "plansSelectedToQuote", viewCostTooltipHeaderText: "viewCostTooltipHeaderText", viewCostTooltipHeaderContent: "viewCostTooltipHeaderContent", inNetworkPreferredText: "inNetworkPreferredText", inNetworkStandardText: "inNetworkStandardText", outOfNetworkText: "outOfNetworkText", selectedPharmacy: "selectedPharmacy", isMailOrderSelected: "isMailOrderSelected", mailOrderText: "mailOrderText", selectedProviders: "selectedProviders", providerDetails: "providerDetails", providersInNetworkText: "providersInNetworkText", pcpInNetworkText: "pcpInNetworkText", pcpOutOfNetworkText: "pcpOutOfNetworkText", providersNoDataText: "providersNoDataText", isProviderEnabled: "isProviderEnabled", showStarRating: "showStarRating", showPreferenceScore: "showPreferenceScore", CSNPEnabled: "CSNPEnabled", DSNPEnabled: "DSNPEnabled", ISNPEnabled: "ISNPEnabled", CSNPText: "CSNPText", DSNPText: "DSNPText", ISNPText: "ISNPText", SNPText: "SNPText", noProviderNetworkAccessText: "noProviderNetworkAccessText", viewDetailsDescriptionText: "viewDetailsDescriptionText", medSupPaymentMethod: "medSupPaymentMethod", nonMonthlyRateText: "nonMonthlyRateText", medSupPaymentMethodDisplayText: "medSupPaymentMethodDisplayText", showNonMonthlyRateText: "showNonMonthlyRateText", optionOneText: "optionOneText", optionTwoText: "optionTwoText", displayOptionLabels: "displayOptionLabels", hidePlanCardLabel: "hidePlanCardLabel", monthlyPremiumText: "monthlyPremiumText", moreBenefitsInstructionText: "moreBenefitsInstructionText", basePlanOptionText: "basePlanOptionText", totalCostEffectiveDate: "totalCostEffectiveDate", medicineCabinet: "medicineCabinet", memberHasOptionsDefined: "memberHasOptionsDefined", planCardPreferenceDetailedEnabled: "planCardPreferenceDetailedEnabled", showAddToCartForAncillaryPlans: "showAddToCartForAncillaryPlans", showAncillaryIcons: "showAncillaryIcons", loaderIconEnabled: "loaderIconEnabled", hideLinkText: "hideLinkText", viewAllLinkText: "viewAllLinkText", Spa_PlanCard_SupplementalBenefits_Enabled: "Spa_PlanCard_SupplementalBenefits_Enabled", Spa_PlanCard_SupplementalBenefits_List: "Spa_PlanCard_SupplementalBenefits_List", editLinkText: "editLinkText", showRatingMethod: "showRatingMethod", Spa_RatingMethod_AttainedAge_Tooltip_Text: "Spa_RatingMethod_AttainedAge_Tooltip_Text", Spa_RatingMethod_IssueAge_Tooltip_Text: "Spa_RatingMethod_IssueAge_Tooltip_Text", Spa_RatingMethod_CommunityRated_Tooltip_Text: "Spa_RatingMethod_CommunityRated_Tooltip_Text", providerOneOrMoreOutOfNetworkText: "providerOneOrMoreOutOfNetworkText", providerInNetworkOnOtherLocationsTooltipText: "providerInNetworkOnOtherLocationsTooltipText", providerShowPartialIndicatorEnabled: "providerShowPartialIndicatorEnabled", planFeesEnabled: "planFeesEnabled", planFeesTooltipText: "planFeesTooltipText", planFeesIncludedInPremiumTooltipText: "planFeesIncludedInPremiumTooltipText", planFeesNotIncludedInPremiumTooltipText: "planFeesNotIncludedInPremiumTooltipText", showAvailableRateFactorsEnabled: "showAvailableRateFactorsEnabled", personalizedQuoteLabelText: "personalizedQuoteLabelText", availableRateFactorsData: "availableRateFactorsData", snpPremiumRangeEnabled: "snpPremiumRangeEnabled", showPlanId: "showPlanId", snpRangeLinkText: "snpRangeLinkText", showPlanYear: "showPlanYear", planIdText: "planIdText", enableDSNPCodes: "enableDSNPCodes", availableText: "availableText", unavailableText: "unavailableText", viewProvidersButtonText: "viewProvidersButtonText", viewPrescriptionsButtonText: "viewPrescriptionsButtonText", supplementalBenefitsHighlightText: "supplementalBenefitsHighlightText", preferencesText: "preferencesText", viewMoreDetailsText: "viewMoreDetailsText", hideDetailsText: "hideDetailsText", newPlanCardDesignEnabled: "newPlanCardDesignEnabled", viewAllPlanDetailsText: "viewAllPlanDetailsText", shareThisPlanText: "shareThisPlanText", viewCostDetailsText: "viewCostDetailsText", closeText: "closeText", planBenefitHighlightItems: "planBenefitHighlightItems", planBenefitHighlightsHeaderText: "planBenefitHighlightsHeaderText", showRiderDetails: "showRiderDetails", hideRiderDetailsText: "hideRiderDetailsText", showRiderDetailsText: "showRiderDetailsText", riderIsIncludedText: "riderIsIncludedText", waiverStateRiderTooltips: "waiverStateRiderTooltips", costMA: "costMA", costMAPD: "costMAPD", costMEDIGAP: "costMEDIGAP", costPDP: "costPDP", costDENTAL: "costDENTAL", costVISION: "costVISION", isVbcAgreementEnabled: "isVbcAgreementEnabled", vbcAgreementLabel: "vbcAgreementLabel", vbcAgreementTooltip: "vbcAgreementTooltip", nonCommissionableText: "nonCommissionableText", isNonCommissionableFlagCheckEnabled: "isNonCommissionableFlagCheckEnabled" }, outputs: { quoteClicked: "quoteClicked", quoteGroupChanged: "quoteGroupChanged" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["legacyPlanCard", ""], [3, "plan", "activeTabType", "selectedCompareGroup", "compareGroups", "planBenefits", "displayDrugsCovered", "planPreferences", "hideCompareBoxOverride", "isRetentionSummaryPage", "currentPlanText", "nextYearPlanText", "bestMatchText", "bestMatchIcon", "bestMatchPlanId", "bestMatchTooltip", "selectedQuoteGroup", "quoteGroups", "addToQuoteLimit", "noCostAvailableText", "isRetentionView", "isQuotingSite", "nonLicensedPlanText", "nonLicensedMessageText", "includeNonLicensedPlans", "isNotLicensedToSell", "planLogoSize", "Spa_Site_ShowRiderIcons", "Spa_Site_Dental_Rider_Display_Text", "Spa_Site_Vision_Rider_Display_Text", "Spa_Site_Hearing_Rider_Display_Text", "Spa_PlanCard_DentalAddOnCoverage_Text", "Spa_PlanCard_HearingAddOnCoverage_Text", "Spa_PlanCard_VisionAddOnCoverage_Text", "Spa_PlanCard_AddOnCoverage_Text", "Spa_PlanCard_AddToCompare_Text", "Spa_Site_ShowRidersOnPlanCards", "Spa_ShoppingCart_Enabled", "Spa_PlanCard_PlanDetails_ButtonText", "Spa_Site_Show_PlanLogo", "Spa_Site_Show_AncillaryPlanLogo", "Spa_PlanCard_QuoteLinkName_Text", "Spa_PlanCard_PlanType_Text", "Spa_PlanCard_ShowRidersOnMACards", "Spa_PlanCard_ShowRidersOnPDPCards", "Spa_PlanCard_ShowRidersOnMAPDCards", "Spa_PlanCard_ShowRidersOnMEDIGAPCards", "Spa_PlanCard_ShowRidersOnDentalCards", "Spa_PlanCard_ShowRidersOnVisionCards", "Spa_PlanCard_ShowRidersOnHCCards", "Spa_Site_ShowPremiumAsAnnual", "Spa_PlanCard_AddOnCoverageInCart_Text", "Spa_PlanCard_AddOnCoverageTooltip_Body", "Spa_Site_NotApplicable_Text", "Spa_PlanDetails_Non_Covered_Text", "Spa_Site_Pharmacy_Text", "Spa_PlanCard_Pharmacy_Covered_Text", "Spa_Site_Prescriptions_Text", "Spa_PlanCard_Drug_Covered_Text", "Spa_PlanCard_CompareNow_Text", "Spa_PlanCard_CompareWarning_Tooltip", "Spa_PlanCard_CompareLimit_Desktop", "Spa_PlanCard_CompareLimit_Mobile", "Spa_PlanCard_Total_Estimated_Cost_Tooltip", "Spa_Site_TotalEstimatedCost_Enabled", "Spa_PlanCard_TotalEstimatedAnnualCost_Text", "Spa_PlanCard_TotalEstimatedCost_Text", "Spa_PlanCard_AddToQuote_Text", "Spa_PlanCard_RemoveFromQuote_Text", "Spa_PlanCard_AddToQuote_Warning_Tooltip", "Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip", "Spa_PlanList_AddToQuote_Limit", "Spa_PlanList_AddToQuote_Limit_Mobile", "Spa_Site_MedigapPlanType_Enabled", "Spa_Site_AddToCompare_Enabled", "Spa_Site_PlanViewDetails_Enabled", "Spa_Site_Tooltip_Text", "Spa_Site_ComboPlanLabel_Text", "Spa_Site_ComboPlanTooltip_Text", "Spa_Site_ShowDrugAlternatives_Enabled", "Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled", "Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text", "Spa_PlanCard_ShowDrugAlternatives_Nudge_Text", "Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon", "queuePosition", "plansSelectedToQuote", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "selectedPharmacy", "isMailOrderSelected", "mailOrderText", "selectedProviders", "providerDetails", "providersInNetworkText", "pcpInNetworkText", "pcpOutOfNetworkText", "providersNoDataText", "isProviderEnabled", "showStarRating", "showPreferenceScore", "CSNPEnabled", "DSNPEnabled", "ISNPEnabled", "CSNPText", "DSNPText", "ISNPText", "SNPText", "noProviderNetworkAccessText", "viewDetailsDescriptionText", "medSupPaymentMethod", "nonMonthlyRateText", "medSupPaymentMethodDisplayText", "showNonMonthlyRateText", "optionOneText", "optionTwoText", "displayOptionLabels", "nonCommissionableText", "isNonCommissionableFlagCheckEnabled", "hidePlanCardLabel", "monthlyPremiumText", "moreBenefitsInstructionText", "basePlanOptionText", "totalCostEffectiveDate", "medicineCabinet", "memberHasOptionsDefined", "planCardPreferenceDetailedEnabled", "showAddToCartForAncillaryPlans", "showAncillaryIcons", "loaderIconEnabled", "hideLinkText", "viewAllLinkText", "Spa_PlanCard_SupplementalBenefits_Enabled", "Spa_PlanCard_SupplementalBenefits_List", "editLinkText", "showRatingMethod", "Spa_RatingMethod_AttainedAge_Tooltip_Text", "Spa_RatingMethod_IssueAge_Tooltip_Text", "Spa_RatingMethod_CommunityRated_Tooltip_Text", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "showAvailableRateFactorsEnabled", "personalizedQuoteLabelText", "availableRateFactorsData", "snpPremiumRangeEnabled", "showPlanId", "snpRangeLinkText", "showPlanYear", "planIdText", "enableDSNPCodes", "availableText", "unavailableText", "viewProvidersButtonText", "viewPrescriptionsButtonText", "supplementalBenefitsHighlightText", "preferencesText", "viewMoreDetailsText", "hideDetailsText", "newPlanCardDesignEnabled", "viewAllPlanDetailsText", "shareThisPlanText", "viewCostDetailsText", "closeText", "planBenefitHighlightItems", "addOnCoverageHeaderText", "planBenefitHighlightsHeaderText", "showRiderDetails", "showRiderDetailsText", "hideRiderDetailsText", "riderIsIncludedText", "waiverStateRiderTooltips", "costMA", "costMAPD", "costPDP", "costMEDIGAP", "costDENTAL", "costVISION", "isVbcAgreementEnabled", "vbcAgreementLabel", "vbcAgreementTooltip", "quoteClicked", "quoteGroupChanged"]], template: function PlanCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanCardComponent_ng_container_0_Template, 2, 186, "ng-container", 0);
        i0.ɵɵtemplate(1, PlanCardComponent_ng_template_1_Template, 1, 188, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.newPlanCardDesignEnabled)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgIf, NextgenPlanCardComponent, LegacyPlanCardComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"newPlanCardDesignEnabled; else legacyPlanCard\">\r\n  <vnext-nextgen-plan-card\r\n    [plan]=\"plan\"\r\n    [activeTabType]=\"activeTabType\"\r\n    [selectedCompareGroup]=\"selectedCompareGroup\"\r\n    [compareGroups]=\"compareGroups\"\r\n    [planBenefits]=\"planBenefits\"\r\n    [displayDrugsCovered]=\"displayDrugsCovered\"\r\n    [planPreferences]=\"planPreferences\"\r\n    [hideCompareBoxOverride]=\"hideCompareBoxOverride\"\r\n    [isRetentionSummaryPage]=\"isRetentionSummaryPage\"\r\n    [currentPlanText]=\"currentPlanText\"\r\n    [nextYearPlanText]=\"nextYearPlanText\"\r\n    [bestMatchText]=\"bestMatchText\"\r\n    [bestMatchIcon]=\"bestMatchIcon\"\r\n    [bestMatchPlanId]=\"bestMatchPlanId\"\r\n    [bestMatchTooltip]=\"bestMatchTooltip\"\r\n    [selectedQuoteGroup]=\"selectedQuoteGroup\"\r\n    [quoteGroups]=\"quoteGroups\"\r\n    [addToQuoteLimit]=\"addToQuoteLimit\"\r\n    [noCostAvailableText]=\"noCostAvailableText\"\r\n    [isRetentionView]=\"isRetentionView\"\r\n    [isQuotingSite]=\"isQuotingSite\"\r\n    [nonLicensedPlanText]=\"nonLicensedPlanText\"\r\n    [nonLicensedMessageText]=\"nonLicensedMessageText\"\r\n    [includeNonLicensedPlans]=\"includeNonLicensedPlans\"\r\n    [isNotLicensedToSell]=\"isNotLicensedToSell\"\r\n    [planLogoSize]=\"planLogoSize\"\r\n    [Spa_Site_ShowRiderIcons]=\"Spa_Site_ShowRiderIcons\"\r\n    [Spa_Site_Dental_Rider_Display_Text]=\"Spa_Site_Dental_Rider_Display_Text\"\r\n    [Spa_Site_Vision_Rider_Display_Text]=\"Spa_Site_Vision_Rider_Display_Text\"\r\n    [Spa_Site_Hearing_Rider_Display_Text]=\"Spa_Site_Hearing_Rider_Display_Text\"\r\n    [Spa_PlanCard_DentalAddOnCoverage_Text]=\"Spa_PlanCard_DentalAddOnCoverage_Text\"\r\n    [Spa_PlanCard_HearingAddOnCoverage_Text]=\"Spa_PlanCard_HearingAddOnCoverage_Text\"\r\n    [Spa_PlanCard_VisionAddOnCoverage_Text]=\"Spa_PlanCard_VisionAddOnCoverage_Text\"\r\n    [Spa_PlanCard_AddOnCoverage_Text]=\"Spa_PlanCard_AddOnCoverage_Text\"\r\n    [Spa_PlanCard_AddToCompare_Text]=\"Spa_PlanCard_AddToCompare_Text\"\r\n    [Spa_Site_ShowRidersOnPlanCards]=\"Spa_Site_ShowRidersOnPlanCards\"\r\n    [Spa_ShoppingCart_Enabled]=\"Spa_ShoppingCart_Enabled\"\r\n    [Spa_PlanCard_PlanDetails_ButtonText]=\"Spa_PlanCard_PlanDetails_ButtonText\"\r\n    [Spa_Site_Show_PlanLogo]=\"Spa_Site_Show_PlanLogo\"\r\n    [Spa_Site_Show_AncillaryPlanLogo]=\"Spa_Site_Show_AncillaryPlanLogo\"\r\n    [Spa_PlanCard_QuoteLinkName_Text]=\"Spa_PlanCard_QuoteLinkName_Text\"\r\n    [Spa_PlanCard_PlanType_Text]=\"Spa_PlanCard_PlanType_Text\"\r\n    [Spa_PlanCard_ShowRidersOnMACards]=\"Spa_PlanCard_ShowRidersOnMACards\"\r\n    [Spa_PlanCard_ShowRidersOnPDPCards]=\"Spa_PlanCard_ShowRidersOnPDPCards\"\r\n    [Spa_PlanCard_ShowRidersOnMAPDCards]=\"Spa_PlanCard_ShowRidersOnMAPDCards\"\r\n    [Spa_PlanCard_ShowRidersOnMEDIGAPCards]=\"Spa_PlanCard_ShowRidersOnMEDIGAPCards\"\r\n    [Spa_PlanCard_ShowRidersOnDentalCards]=\"Spa_PlanCard_ShowRidersOnDentalCards\"\r\n    [Spa_PlanCard_ShowRidersOnVisionCards]=\"Spa_PlanCard_ShowRidersOnVisionCards\"\r\n    [Spa_PlanCard_ShowRidersOnHCCards]=\"Spa_PlanCard_ShowRidersOnHCCards\"\r\n    [Spa_Site_ShowPremiumAsAnnual]=\"Spa_Site_ShowPremiumAsAnnual\"\r\n    [Spa_PlanCard_AddOnCoverageInCart_Text]=\"Spa_PlanCard_AddOnCoverageInCart_Text\"\r\n    [Spa_PlanCard_AddOnCoverageTooltip_Body]=\"Spa_PlanCard_AddOnCoverageTooltip_Body\"\r\n    [Spa_Site_NotApplicable_Text]=\"Spa_Site_NotApplicable_Text\"\r\n    [Spa_PlanDetails_Non_Covered_Text]=\"Spa_PlanDetails_Non_Covered_Text\"\r\n    [Spa_Site_Pharmacy_Text]=\"Spa_Site_Pharmacy_Text\"\r\n    [Spa_PlanCard_Pharmacy_Covered_Text]=\"Spa_PlanCard_Pharmacy_Covered_Text\"\r\n    [Spa_Site_Prescriptions_Text]=\"Spa_Site_Prescriptions_Text\"\r\n    [Spa_PlanCard_Drug_Covered_Text]=\"Spa_PlanCard_Drug_Covered_Text\"\r\n    [Spa_PlanCard_CompareNow_Text]=\"Spa_PlanCard_CompareNow_Text\"\r\n    [Spa_PlanCard_CompareWarning_Tooltip]=\"Spa_PlanCard_CompareWarning_Tooltip\"\r\n    [Spa_PlanCard_CompareLimit_Desktop]=\"Spa_PlanCard_CompareLimit_Desktop\"\r\n    [Spa_PlanCard_CompareLimit_Mobile]=\"Spa_PlanCard_CompareLimit_Mobile\"\r\n    [Spa_PlanCard_Total_Estimated_Cost_Tooltip]=\"Spa_PlanCard_Total_Estimated_Cost_Tooltip\"\r\n    [Spa_Site_TotalEstimatedCost_Enabled]=\"Spa_Site_TotalEstimatedCost_Enabled\"\r\n    [Spa_PlanCard_TotalEstimatedAnnualCost_Text]=\"Spa_PlanCard_TotalEstimatedAnnualCost_Text\"\r\n    [Spa_PlanCard_TotalEstimatedCost_Text]=\"Spa_PlanCard_TotalEstimatedCost_Text\"\r\n    [Spa_PlanCard_AddToQuote_Text]=\"Spa_PlanCard_AddToQuote_Text\"\r\n    [Spa_PlanCard_RemoveFromQuote_Text]=\"Spa_PlanCard_RemoveFromQuote_Text\"\r\n    [Spa_PlanCard_AddToQuote_Warning_Tooltip]=\"Spa_PlanCard_AddToQuote_Warning_Tooltip\"\r\n    [Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip]=\"Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip\"\r\n    [Spa_PlanList_AddToQuote_Limit]=\"Spa_PlanList_AddToQuote_Limit\"\r\n    [Spa_PlanList_AddToQuote_Limit_Mobile]=\"Spa_PlanList_AddToQuote_Limit_Mobile\"\r\n    [Spa_Site_MedigapPlanType_Enabled]=\"Spa_Site_MedigapPlanType_Enabled\"\r\n    [Spa_Site_AddToCompare_Enabled]=\"Spa_Site_AddToCompare_Enabled\"\r\n    [Spa_Site_PlanViewDetails_Enabled]=\"Spa_Site_PlanViewDetails_Enabled\"\r\n    [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n    [Spa_Site_ComboPlanLabel_Text]=\"Spa_Site_ComboPlanLabel_Text\"\r\n    [Spa_Site_ComboPlanTooltip_Text]=\"Spa_Site_ComboPlanTooltip_Text\"\r\n    [Spa_Site_ShowDrugAlternatives_Enabled]=\"Spa_Site_ShowDrugAlternatives_Enabled\"\r\n    [Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled]=\"Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled\"\r\n    [Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text]=\"Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text\"\r\n    [Spa_PlanCard_ShowDrugAlternatives_Nudge_Text]=\"Spa_PlanCard_ShowDrugAlternatives_Nudge_Text\"\r\n    [Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon]=\"Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon\"\r\n    [queuePosition]=\"queuePosition\"\r\n    [plansSelectedToQuote]=\"plansSelectedToQuote\"\r\n    [viewCostTooltipHeaderText]=\"viewCostTooltipHeaderText\"\r\n    [viewCostTooltipHeaderContent]=\"viewCostTooltipHeaderContent\"\r\n    [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n    [inNetworkStandardText]=\"inNetworkStandardText\"\r\n    [outOfNetworkText]=\"outOfNetworkText\"\r\n    [selectedPharmacy]=\"selectedPharmacy\"\r\n    [isMailOrderSelected]=\"isMailOrderSelected\"\r\n    [mailOrderText]=\"mailOrderText\"\r\n    [selectedProviders]=\"selectedProviders\"\r\n    [providerDetails]=\"providerDetails\"\r\n    [providersInNetworkText]=\"providersInNetworkText\"\r\n    [pcpInNetworkText]=\"pcpInNetworkText\"\r\n    [pcpOutOfNetworkText]=\"pcpOutOfNetworkText\"\r\n    [providersNoDataText]=\"providersNoDataText\"\r\n    [isProviderEnabled]=\"isProviderEnabled\"\r\n    [showStarRating]=\"showStarRating\"\r\n    [showPreferenceScore]=\"showPreferenceScore\"\r\n    [CSNPEnabled]=\"CSNPEnabled\"\r\n    [DSNPEnabled]=\"DSNPEnabled\"\r\n    [ISNPEnabled]=\"ISNPEnabled\"\r\n    [CSNPText]=\"CSNPText\"\r\n    [DSNPText]=\"DSNPText\"\r\n    [ISNPText]=\"ISNPText\"\r\n    [SNPText]=\"SNPText\"\r\n    [noProviderNetworkAccessText]=\"noProviderNetworkAccessText\"\r\n    [viewDetailsDescriptionText]=\"viewDetailsDescriptionText\"\r\n    [medSupPaymentMethod]=\"medSupPaymentMethod\"\r\n    [nonMonthlyRateText]=\"nonMonthlyRateText\"\r\n    [medSupPaymentMethodDisplayText]=\"medSupPaymentMethodDisplayText\"\r\n    [showNonMonthlyRateText]=\"showNonMonthlyRateText\"\r\n    [optionOneText]=\"optionOneText\"\r\n    [optionTwoText]=\"optionTwoText\"\r\n    [displayOptionLabels]=\"displayOptionLabels\"\r\n    [nonCommissionableText]=\"nonCommissionableText\"\r\n    [isNonCommissionableFlagCheckEnabled]=\"isNonCommissionableFlagCheckEnabled\"\r\n    [hidePlanCardLabel]=\"hidePlanCardLabel\"\r\n    [monthlyPremiumText]=\"monthlyPremiumText\"\r\n    [moreBenefitsInstructionText]=\"moreBenefitsInstructionText\"\r\n    [basePlanOptionText]=\"basePlanOptionText\"\r\n    [totalCostEffectiveDate]=\"totalCostEffectiveDate\"\r\n    [medicineCabinet]=\"medicineCabinet\"\r\n    [memberHasOptionsDefined]=\"memberHasOptionsDefined\"\r\n    [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n    [showAddToCartForAncillaryPlans]=\"showAddToCartForAncillaryPlans\"\r\n    [showAncillaryIcons]=\"showAncillaryIcons\"\r\n    [loaderIconEnabled]=\"loaderIconEnabled\"\r\n    [hideLinkText]=\"hideLinkText\"\r\n    [viewAllLinkText]=\"viewAllLinkText\"\r\n    [Spa_PlanCard_SupplementalBenefits_Enabled]=\"Spa_PlanCard_SupplementalBenefits_Enabled\"\r\n    [Spa_PlanCard_SupplementalBenefits_List]=\"Spa_PlanCard_SupplementalBenefits_List\"\r\n    [editLinkText]=\"editLinkText\"\r\n    [showRatingMethod]=\"showRatingMethod\"\r\n    [Spa_RatingMethod_AttainedAge_Tooltip_Text]=\"Spa_RatingMethod_AttainedAge_Tooltip_Text\"\r\n    [Spa_RatingMethod_IssueAge_Tooltip_Text]=\"Spa_RatingMethod_IssueAge_Tooltip_Text\"\r\n    [Spa_RatingMethod_CommunityRated_Tooltip_Text]=\"Spa_RatingMethod_CommunityRated_Tooltip_Text\"\r\n    [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n    [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n    [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n    [planFeesEnabled]=\"planFeesEnabled\"\r\n    [planFeesTooltipText]=\"planFeesTooltipText\"\r\n    [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n    [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n    [showAvailableRateFactorsEnabled]=\"showAvailableRateFactorsEnabled\"\r\n    [personalizedQuoteLabelText]=\"personalizedQuoteLabelText\"\r\n    [availableRateFactorsData]=\"availableRateFactorsData\"\r\n    [snpPremiumRangeEnabled]=\"snpPremiumRangeEnabled\"\r\n    [showPlanId]=\"showPlanId\"\r\n    [snpRangeLinkText]=\"snpRangeLinkText\"\r\n    [showPlanYear]=\"showPlanYear\"\r\n    [planIdText]=\"planIdText\"\r\n    [enableDSNPCodes]=\"enableDSNPCodes\"\r\n    [availableText]=\"availableText\"\r\n    [unavailableText]=\"unavailableText\"\r\n    [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n    [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n    [supplementalBenefitsHighlightText]=\"supplementalBenefitsHighlightText\"\r\n    [preferencesText]=\"preferencesText\"\r\n    [viewMoreDetailsText]=\"viewMoreDetailsText\"\r\n    [hideDetailsText]=\"hideDetailsText\"\r\n    [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n    [viewAllPlanDetailsText]=\"viewAllPlanDetailsText\"\r\n    [shareThisPlanText]=\"shareThisPlanText\"\r\n    [viewCostDetailsText]=\"viewCostDetailsText\"\r\n    [closeText]=\"closeText\"\r\n    [planBenefitHighlightItems]=\"planBenefitHighlightItems\"\r\n    [addOnCoverageHeaderText]=\"Spa_PlanCard_AddOnCoverage_Text\"\r\n    [planBenefitHighlightsHeaderText]=\"planBenefitHighlightsHeaderText\"\r\n    [showRiderDetails]=\"showRiderDetails\"\r\n    [showRiderDetailsText]=\"showRiderDetailsText\"\r\n    [hideRiderDetailsText]=\"hideRiderDetailsText\"\r\n    [riderIsIncludedText]=\"riderIsIncludedText\"\r\n    [waiverStateRiderTooltips]=\"waiverStateRiderTooltips\"\r\n    [costMA]=\"costMA\"\r\n    [costMAPD]=\"costMAPD\"\r\n    [costPDP]=\"costPDP\"\r\n    [costMEDIGAP]=\"costMEDIGAP\"\r\n    [costDENTAL]=\"costDENTAL\"\r\n    [costVISION]=\"costVISION\"\r\n    [isVbcAgreementEnabled]=\"isVbcAgreementEnabled\"\r\n    [vbcAgreementLabel]=\"vbcAgreementLabel\"\r\n    [vbcAgreementTooltip]=\"vbcAgreementTooltip\"\r\n    (quoteClicked)=\"onQuoteClicked()\"\r\n    (quoteGroupChanged)=\"onQuoteGroupChanged()\"\r\n  >\r\n  </vnext-nextgen-plan-card>\r\n</ng-container>\r\n\r\n<ng-template #legacyPlanCard>\r\n  <vnext-legacy-plan-card\r\n    [plan]=\"plan\"\r\n    [activeTabType]=\"activeTabType\"\r\n    [selectedCompareGroup]=\"selectedCompareGroup\"\r\n    [compareGroups]=\"compareGroups\"\r\n    [planBenefits]=\"planBenefits\"\r\n    [displayDrugsCovered]=\"displayDrugsCovered\"\r\n    [planPreferences]=\"planPreferences\"\r\n    [hideCompareBoxOverride]=\"hideCompareBoxOverride\"\r\n    [isRetentionSummaryPage]=\"isRetentionSummaryPage\"\r\n    [currentPlanText]=\"currentPlanText\"\r\n    [nextYearPlanText]=\"nextYearPlanText\"\r\n    [bestMatchText]=\"bestMatchText\"\r\n    [bestMatchIcon]=\"bestMatchIcon\"\r\n    [bestMatchPlanId]=\"bestMatchPlanId\"\r\n    [bestMatchTooltip]=\"bestMatchTooltip\"\r\n    [selectedQuoteGroup]=\"selectedQuoteGroup\"\r\n    [quoteGroups]=\"quoteGroups\"\r\n    [addToQuoteLimit]=\"addToQuoteLimit\"\r\n    [noCostAvailableText]=\"noCostAvailableText\"\r\n    [isRetentionView]=\"isRetentionView\"\r\n    [isQuotingSite]=\"isQuotingSite\"\r\n    [nonLicensedPlanText]=\"nonLicensedPlanText\"\r\n    [nonLicensedMessageText]=\"nonLicensedMessageText\"\r\n    [includeNonLicensedPlans]=\"includeNonLicensedPlans\"\r\n    [isNotLicensedToSell]=\"isNotLicensedToSell\"\r\n    [planLogoSize]=\"planLogoSize\"\r\n    [Spa_Site_ShowRiderIcons]=\"Spa_Site_ShowRiderIcons\"\r\n    [Spa_Site_Dental_Rider_Display_Text]=\"Spa_Site_Dental_Rider_Display_Text\"\r\n    [Spa_Site_Vision_Rider_Display_Text]=\"Spa_Site_Vision_Rider_Display_Text\"\r\n    [Spa_Site_Hearing_Rider_Display_Text]=\"Spa_Site_Hearing_Rider_Display_Text\"\r\n    [Spa_PlanCard_DentalAddOnCoverage_Text]=\"Spa_PlanCard_DentalAddOnCoverage_Text\"\r\n    [Spa_PlanCard_HearingAddOnCoverage_Text]=\"Spa_PlanCard_HearingAddOnCoverage_Text\"\r\n    [Spa_PlanCard_VisionAddOnCoverage_Text]=\"Spa_PlanCard_VisionAddOnCoverage_Text\"\r\n    [Spa_PlanCard_AddOnCoverage_Text]=\"Spa_PlanCard_AddOnCoverage_Text\"\r\n    [Spa_PlanCard_AddToCompare_Text]=\"Spa_PlanCard_AddToCompare_Text\"\r\n    [Spa_Site_ShowRidersOnPlanCards]=\"Spa_Site_ShowRidersOnPlanCards\"\r\n    [Spa_ShoppingCart_Enabled]=\"Spa_ShoppingCart_Enabled\"\r\n    [Spa_PlanCard_PlanDetails_ButtonText]=\"Spa_PlanCard_PlanDetails_ButtonText\"\r\n    [Spa_Site_Show_PlanLogo]=\"Spa_Site_Show_PlanLogo\"\r\n    [Spa_Site_Show_AncillaryPlanLogo]=\"Spa_Site_Show_AncillaryPlanLogo\"\r\n    [Spa_PlanCard_QuoteLinkName_Text]=\"Spa_PlanCard_QuoteLinkName_Text\"\r\n    [Spa_PlanCard_PlanType_Text]=\"Spa_PlanCard_PlanType_Text\"\r\n    [Spa_PlanCard_ShowRidersOnMACards]=\"Spa_PlanCard_ShowRidersOnMACards\"\r\n    [Spa_PlanCard_ShowRidersOnPDPCards]=\"Spa_PlanCard_ShowRidersOnPDPCards\"\r\n    [Spa_PlanCard_ShowRidersOnMAPDCards]=\"Spa_PlanCard_ShowRidersOnMAPDCards\"\r\n    [Spa_PlanCard_ShowRidersOnMEDIGAPCards]=\"Spa_PlanCard_ShowRidersOnMEDIGAPCards\"\r\n    [Spa_PlanCard_ShowRidersOnDentalCards]=\"Spa_PlanCard_ShowRidersOnDentalCards\"\r\n    [Spa_PlanCard_ShowRidersOnVisionCards]=\"Spa_PlanCard_ShowRidersOnVisionCards\"\r\n    [Spa_PlanCard_ShowRidersOnHCCards]=\"Spa_PlanCard_ShowRidersOnHCCards\"\r\n    [Spa_Site_ShowPremiumAsAnnual]=\"Spa_Site_ShowPremiumAsAnnual\"\r\n    [Spa_PlanCard_AddOnCoverageInCart_Text]=\"Spa_PlanCard_AddOnCoverageInCart_Text\"\r\n    [Spa_PlanCard_AddOnCoverageTooltip_Body]=\"Spa_PlanCard_AddOnCoverageTooltip_Body\"\r\n    [Spa_Site_NotApplicable_Text]=\"Spa_Site_NotApplicable_Text\"\r\n    [Spa_PlanDetails_Non_Covered_Text]=\"Spa_PlanDetails_Non_Covered_Text\"\r\n    [Spa_Site_Pharmacy_Text]=\"Spa_Site_Pharmacy_Text\"\r\n    [Spa_PlanCard_Pharmacy_Covered_Text]=\"Spa_PlanCard_Pharmacy_Covered_Text\"\r\n    [Spa_Site_Prescriptions_Text]=\"Spa_Site_Prescriptions_Text\"\r\n    [Spa_PlanCard_Drug_Covered_Text]=\"Spa_PlanCard_Drug_Covered_Text\"\r\n    [Spa_PlanCard_CompareNow_Text]=\"Spa_PlanCard_CompareNow_Text\"\r\n    [Spa_PlanCard_CompareWarning_Tooltip]=\"Spa_PlanCard_CompareWarning_Tooltip\"\r\n    [Spa_PlanCard_CompareLimit_Desktop]=\"Spa_PlanCard_CompareLimit_Desktop\"\r\n    [Spa_PlanCard_CompareLimit_Mobile]=\"Spa_PlanCard_CompareLimit_Mobile\"\r\n    [Spa_PlanCard_Total_Estimated_Cost_Tooltip]=\"Spa_PlanCard_Total_Estimated_Cost_Tooltip\"\r\n    [Spa_Site_TotalEstimatedCost_Enabled]=\"Spa_Site_TotalEstimatedCost_Enabled\"\r\n    [Spa_PlanCard_TotalEstimatedAnnualCost_Text]=\"Spa_PlanCard_TotalEstimatedAnnualCost_Text\"\r\n    [Spa_PlanCard_TotalEstimatedCost_Text]=\"Spa_PlanCard_TotalEstimatedCost_Text\"\r\n    [Spa_PlanCard_AddToQuote_Text]=\"Spa_PlanCard_AddToQuote_Text\"\r\n    [Spa_PlanCard_RemoveFromQuote_Text]=\"Spa_PlanCard_RemoveFromQuote_Text\"\r\n    [Spa_PlanCard_AddToQuote_Warning_Tooltip]=\"Spa_PlanCard_AddToQuote_Warning_Tooltip\"\r\n    [Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip]=\"Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip\"\r\n    [Spa_PlanList_AddToQuote_Limit]=\"Spa_PlanList_AddToQuote_Limit\"\r\n    [Spa_PlanList_AddToQuote_Limit_Mobile]=\"Spa_PlanList_AddToQuote_Limit_Mobile\"\r\n    [Spa_Site_MedigapPlanType_Enabled]=\"Spa_Site_MedigapPlanType_Enabled\"\r\n    [Spa_Site_AddToCompare_Enabled]=\"Spa_Site_AddToCompare_Enabled\"\r\n    [Spa_Site_PlanViewDetails_Enabled]=\"Spa_Site_PlanViewDetails_Enabled\"\r\n    [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n    [Spa_Site_ComboPlanLabel_Text]=\"Spa_Site_ComboPlanLabel_Text\"\r\n    [Spa_Site_ComboPlanTooltip_Text]=\"Spa_Site_ComboPlanTooltip_Text\"\r\n    [Spa_Site_ShowDrugAlternatives_Enabled]=\"Spa_Site_ShowDrugAlternatives_Enabled\"\r\n    [Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled]=\"Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled\"\r\n    [Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text]=\"Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text\"\r\n    [Spa_PlanCard_ShowDrugAlternatives_Nudge_Text]=\"Spa_PlanCard_ShowDrugAlternatives_Nudge_Text\"\r\n    [Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon]=\"Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon\"\r\n    [queuePosition]=\"queuePosition\"\r\n    [plansSelectedToQuote]=\"plansSelectedToQuote\"\r\n    [viewCostTooltipHeaderText]=\"viewCostTooltipHeaderText\"\r\n    [viewCostTooltipHeaderContent]=\"viewCostTooltipHeaderContent\"\r\n    [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n    [inNetworkStandardText]=\"inNetworkStandardText\"\r\n    [outOfNetworkText]=\"outOfNetworkText\"\r\n    [selectedPharmacy]=\"selectedPharmacy\"\r\n    [isMailOrderSelected]=\"isMailOrderSelected\"\r\n    [mailOrderText]=\"mailOrderText\"\r\n    [selectedProviders]=\"selectedProviders\"\r\n    [providerDetails]=\"providerDetails\"\r\n    [providersInNetworkText]=\"providersInNetworkText\"\r\n    [pcpInNetworkText]=\"pcpInNetworkText\"\r\n    [pcpOutOfNetworkText]=\"pcpOutOfNetworkText\"\r\n    [providersNoDataText]=\"providersNoDataText\"\r\n    [isProviderEnabled]=\"isProviderEnabled\"\r\n    [showStarRating]=\"showStarRating\"\r\n    [showPreferenceScore]=\"showPreferenceScore\"\r\n    [CSNPEnabled]=\"CSNPEnabled\"\r\n    [DSNPEnabled]=\"DSNPEnabled\"\r\n    [ISNPEnabled]=\"ISNPEnabled\"\r\n    [CSNPText]=\"CSNPText\"\r\n    [DSNPText]=\"DSNPText\"\r\n    [ISNPText]=\"ISNPText\"\r\n    [SNPText]=\"SNPText\"\r\n    [noProviderNetworkAccessText]=\"noProviderNetworkAccessText\"\r\n    [viewDetailsDescriptionText]=\"viewDetailsDescriptionText\"\r\n    [medSupPaymentMethod]=\"medSupPaymentMethod\"\r\n    [nonMonthlyRateText]=\"nonMonthlyRateText\"\r\n    [medSupPaymentMethodDisplayText]=\"medSupPaymentMethodDisplayText\"\r\n    [showNonMonthlyRateText]=\"showNonMonthlyRateText\"\r\n    [optionOneText]=\"optionOneText\"\r\n    [optionTwoText]=\"optionTwoText\"\r\n    [displayOptionLabels]=\"displayOptionLabels\"\r\n    [nonCommissionableText]=\"nonCommissionableText\"\r\n    [isNonCommissionableFlagCheckEnabled]=\"isNonCommissionableFlagCheckEnabled\"\r\n    [hidePlanCardLabel]=\"hidePlanCardLabel\"\r\n    [monthlyPremiumText]=\"monthlyPremiumText\"\r\n    [moreBenefitsInstructionText]=\"moreBenefitsInstructionText\"\r\n    [basePlanOptionText]=\"basePlanOptionText\"\r\n    [totalCostEffectiveDate]=\"totalCostEffectiveDate\"\r\n    [medicineCabinet]=\"medicineCabinet\"\r\n    [memberHasOptionsDefined]=\"memberHasOptionsDefined\"\r\n    [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n    [showAddToCartForAncillaryPlans]=\"showAddToCartForAncillaryPlans\"\r\n    [showAncillaryIcons]=\"showAncillaryIcons\"\r\n    [loaderIconEnabled]=\"loaderIconEnabled\"\r\n    [hideLinkText]=\"hideLinkText\"\r\n    [viewAllLinkText]=\"viewAllLinkText\"\r\n    [Spa_PlanCard_SupplementalBenefits_Enabled]=\"Spa_PlanCard_SupplementalBenefits_Enabled\"\r\n    [Spa_PlanCard_SupplementalBenefits_List]=\"Spa_PlanCard_SupplementalBenefits_List\"\r\n    [editLinkText]=\"editLinkText\"\r\n    [showRatingMethod]=\"showRatingMethod\"\r\n    [Spa_RatingMethod_AttainedAge_Tooltip_Text]=\"Spa_RatingMethod_AttainedAge_Tooltip_Text\"\r\n    [Spa_RatingMethod_IssueAge_Tooltip_Text]=\"Spa_RatingMethod_IssueAge_Tooltip_Text\"\r\n    [Spa_RatingMethod_CommunityRated_Tooltip_Text]=\"Spa_RatingMethod_CommunityRated_Tooltip_Text\"\r\n    [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n    [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n    [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n    [planFeesEnabled]=\"planFeesEnabled\"\r\n    [planFeesTooltipText]=\"planFeesTooltipText\"\r\n    [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n    [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n    [showAvailableRateFactorsEnabled]=\"showAvailableRateFactorsEnabled\"\r\n    [personalizedQuoteLabelText]=\"personalizedQuoteLabelText\"\r\n    [availableRateFactorsData]=\"availableRateFactorsData\"\r\n    [snpPremiumRangeEnabled]=\"snpPremiumRangeEnabled\"\r\n    [showPlanId]=\"showPlanId\"\r\n    [snpRangeLinkText]=\"snpRangeLinkText\"\r\n    [showPlanYear]=\"showPlanYear\"\r\n    [planIdText]=\"planIdText\"\r\n    [enableDSNPCodes]=\"enableDSNPCodes\"\r\n    [availableText]=\"availableText\"\r\n    [unavailableText]=\"unavailableText\"\r\n    [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n    [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n    [supplementalBenefitsHighlightText]=\"supplementalBenefitsHighlightText\"\r\n    [preferencesText]=\"preferencesText\"\r\n    [viewMoreDetailsText]=\"viewMoreDetailsText\"\r\n    [hideDetailsText]=\"hideDetailsText\"\r\n    [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n    [viewAllPlanDetailsText]=\"viewAllPlanDetailsText\"\r\n    [shareThisPlanText]=\"shareThisPlanText\"\r\n    [viewCostDetailsText]=\"viewCostDetailsText\"\r\n    [closeText]=\"closeText\"\r\n    [planBenefitHighlightItems]=\"planBenefitHighlightItems\"\r\n    [addOnCoverageHeaderText]=\"Spa_PlanCard_AddOnCoverage_Text\"\r\n    [planBenefitHighlightsHeaderText]=\"planBenefitHighlightsHeaderText\"\r\n    [showRiderDetails]=\"showRiderDetails\"\r\n    [showRiderDetailsText]=\"showRiderDetailsText\"\r\n    [hideRiderDetailsText]=\"hideRiderDetailsText\"\r\n    [riderIsIncludedText]=\"riderIsIncludedText\"\r\n    [waiverStateRiderTooltips]=\"waiverStateRiderTooltips\"\r\n    [costMA]=\"costMA\"\r\n    [costMAPD]=\"costMAPD\"\r\n    [costPDP]=\"costPDP\"\r\n    [costMEDIGAP]=\"costMEDIGAP\"\r\n    [costDENTAL]=\"costDENTAL\"\r\n    [costVISION]=\"costVISION\"\r\n    [isVbcAgreementEnabled]=\"isVbcAgreementEnabled\"\r\n    [vbcAgreementLabel]=\"vbcAgreementLabel\"\r\n    [vbcAgreementTooltip]=\"vbcAgreementTooltip\"\r\n    (quoteClicked)=\"onQuoteClicked()\"\r\n    (quoteGroupChanged)=\"onQuoteGroupChanged()\"\r\n    [nonCommissionableText]=\"nonCommissionableText\"\r\n    [isNonCommissionableFlagCheckEnabled]=\"isNonCommissionableFlagCheckEnabled\"\r\n  >\r\n  </vnext-legacy-plan-card>\r\n</ng-template>\r\n" }]
    }], null, { plan: [{
            type: Input
        }], activeTabType: [{
            type: Input
        }], selectedCompareGroup: [{
            type: Input
        }], compareGroups: [{
            type: Input
        }], planBenefits: [{
            type: Input
        }], displayDrugsCovered: [{
            type: Input
        }], planPreferences: [{
            type: Input
        }], hideCompareBoxOverride: [{
            type: Input
        }], isRetentionSummaryPage: [{
            type: Input
        }], currentPlanText: [{
            type: Input
        }], nextYearPlanText: [{
            type: Input
        }], bestMatchText: [{
            type: Input
        }], bestMatchIcon: [{
            type: Input
        }], bestMatchPlanId: [{
            type: Input
        }], bestMatchTooltip: [{
            type: Input
        }], selectedQuoteGroup: [{
            type: Input
        }], quoteGroups: [{
            type: Input
        }], addToQuoteLimit: [{
            type: Input
        }], noCostAvailableText: [{
            type: Input
        }], isRetentionView: [{
            type: Input
        }], isQuotingSite: [{
            type: Input
        }], nonLicensedPlanText: [{
            type: Input
        }], nonLicensedMessageText: [{
            type: Input
        }], includeNonLicensedPlans: [{
            type: Input
        }], isNotLicensedToSell: [{
            type: Input
        }], planLogoSize: [{
            type: Input
        }], Spa_Site_ShowRiderIcons: [{
            type: Input
        }], Spa_Site_Dental_Rider_Display_Text: [{
            type: Input
        }], Spa_Site_Vision_Rider_Display_Text: [{
            type: Input
        }], Spa_Site_Hearing_Rider_Display_Text: [{
            type: Input
        }], Spa_PlanCard_DentalAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_HearingAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_VisionAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_AddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_AddToCompare_Text: [{
            type: Input
        }], Spa_Site_ShowRidersOnPlanCards: [{
            type: Input
        }], Spa_ShoppingCart_Enabled: [{
            type: Input
        }], Spa_PlanCard_PlanDetails_ButtonText: [{
            type: Input
        }], Spa_Site_Show_PlanLogo: [{
            type: Input
        }], Spa_Site_Show_AncillaryPlanLogo: [{
            type: Input
        }], Spa_PlanCard_QuoteLinkName_Text: [{
            type: Input
        }], Spa_PlanCard_PlanType_Text: [{
            type: Input
        }], Spa_PlanCard_ShowRidersOnMACards: [{
            type: Input
        }], Spa_PlanCard_ShowRidersOnPDPCards: [{
            type: Input
        }], Spa_PlanCard_ShowRidersOnMAPDCards: [{
            type: Input
        }], Spa_PlanCard_ShowRidersOnMEDIGAPCards: [{
            type: Input
        }], Spa_PlanCard_ShowRidersOnDentalCards: [{
            type: Input
        }], Spa_PlanCard_ShowRidersOnVisionCards: [{
            type: Input
        }], Spa_PlanCard_ShowRidersOnHCCards: [{
            type: Input
        }], Spa_Site_ShowPremiumAsAnnual: [{
            type: Input
        }], Spa_PlanCard_AddOnCoverageInCart_Text: [{
            type: Input
        }], Spa_PlanCard_AddOnCoverageTooltip_Body: [{
            type: Input
        }], Spa_Site_NotApplicable_Text: [{
            type: Input
        }], Spa_PlanDetails_Non_Covered_Text: [{
            type: Input
        }], Spa_Site_Pharmacy_Text: [{
            type: Input
        }], Spa_PlanCard_Pharmacy_Covered_Text: [{
            type: Input
        }], Spa_Site_Prescriptions_Text: [{
            type: Input
        }], Spa_PlanCard_Drug_Covered_Text: [{
            type: Input
        }], Spa_PlanCard_CompareNow_Text: [{
            type: Input
        }], Spa_PlanCard_CompareWarning_Tooltip: [{
            type: Input
        }], Spa_PlanCard_CompareLimit_Desktop: [{
            type: Input
        }], Spa_PlanCard_CompareLimit_Mobile: [{
            type: Input
        }], Spa_PlanCard_Total_Estimated_Cost_Tooltip: [{
            type: Input
        }], Spa_Site_TotalEstimatedCost_Enabled: [{
            type: Input
        }], Spa_PlanCard_TotalEstimatedAnnualCost_Text: [{
            type: Input
        }], Spa_PlanCard_TotalEstimatedCost_Text: [{
            type: Input
        }], Spa_PlanCard_AddToQuote_Text: [{
            type: Input
        }], Spa_PlanCard_RemoveFromQuote_Text: [{
            type: Input
        }], Spa_PlanCard_AddToQuote_Warning_Tooltip: [{
            type: Input
        }], Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip: [{
            type: Input
        }], Spa_PlanList_AddToQuote_Limit: [{
            type: Input
        }], Spa_PlanList_AddToQuote_Limit_Mobile: [{
            type: Input
        }], Spa_Site_MedigapPlanType_Enabled: [{
            type: Input
        }], Spa_Site_AddToCompare_Enabled: [{
            type: Input
        }], Spa_Site_PlanViewDetails_Enabled: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }], Spa_Site_ComboPlanLabel_Text: [{
            type: Input
        }], Spa_Site_ComboPlanTooltip_Text: [{
            type: Input
        }], Spa_Site_ShowDrugAlternatives_Enabled: [{
            type: Input
        }], Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled: [{
            type: Input
        }], Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text: [{
            type: Input
        }], Spa_PlanCard_ShowDrugAlternatives_Nudge_Text: [{
            type: Input
        }], Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon: [{
            type: Input
        }], queuePosition: [{
            type: Input
        }], plansSelectedToQuote: [{
            type: Input
        }], viewCostTooltipHeaderText: [{
            type: Input
        }], viewCostTooltipHeaderContent: [{
            type: Input
        }], inNetworkPreferredText: [{
            type: Input
        }], inNetworkStandardText: [{
            type: Input
        }], outOfNetworkText: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], isMailOrderSelected: [{
            type: Input
        }], mailOrderText: [{
            type: Input
        }], selectedProviders: [{
            type: Input
        }], providerDetails: [{
            type: Input
        }], providersInNetworkText: [{
            type: Input
        }], pcpInNetworkText: [{
            type: Input
        }], pcpOutOfNetworkText: [{
            type: Input
        }], providersNoDataText: [{
            type: Input
        }], isProviderEnabled: [{
            type: Input
        }], showStarRating: [{
            type: Input
        }], showPreferenceScore: [{
            type: Input
        }], CSNPEnabled: [{
            type: Input
        }], DSNPEnabled: [{
            type: Input
        }], ISNPEnabled: [{
            type: Input
        }], CSNPText: [{
            type: Input
        }], DSNPText: [{
            type: Input
        }], ISNPText: [{
            type: Input
        }], SNPText: [{
            type: Input
        }], noProviderNetworkAccessText: [{
            type: Input
        }], viewDetailsDescriptionText: [{
            type: Input
        }], medSupPaymentMethod: [{
            type: Input
        }], nonMonthlyRateText: [{
            type: Input
        }], medSupPaymentMethodDisplayText: [{
            type: Input
        }], showNonMonthlyRateText: [{
            type: Input
        }], optionOneText: [{
            type: Input
        }], optionTwoText: [{
            type: Input
        }], displayOptionLabels: [{
            type: Input
        }], hidePlanCardLabel: [{
            type: Input
        }], monthlyPremiumText: [{
            type: Input
        }], moreBenefitsInstructionText: [{
            type: Input
        }], basePlanOptionText: [{
            type: Input
        }], totalCostEffectiveDate: [{
            type: Input
        }], medicineCabinet: [{
            type: Input
        }], memberHasOptionsDefined: [{
            type: Input
        }], planCardPreferenceDetailedEnabled: [{
            type: Input
        }], showAddToCartForAncillaryPlans: [{
            type: Input
        }], showAncillaryIcons: [{
            type: Input
        }], loaderIconEnabled: [{
            type: Input
        }], hideLinkText: [{
            type: Input
        }], viewAllLinkText: [{
            type: Input
        }], Spa_PlanCard_SupplementalBenefits_Enabled: [{
            type: Input
        }], Spa_PlanCard_SupplementalBenefits_List: [{
            type: Input
        }], editLinkText: [{
            type: Input
        }], showRatingMethod: [{
            type: Input
        }], Spa_RatingMethod_AttainedAge_Tooltip_Text: [{
            type: Input
        }], Spa_RatingMethod_IssueAge_Tooltip_Text: [{
            type: Input
        }], Spa_RatingMethod_CommunityRated_Tooltip_Text: [{
            type: Input
        }], providerOneOrMoreOutOfNetworkText: [{
            type: Input
        }], providerInNetworkOnOtherLocationsTooltipText: [{
            type: Input
        }], providerShowPartialIndicatorEnabled: [{
            type: Input
        }], planFeesEnabled: [{
            type: Input
        }], planFeesTooltipText: [{
            type: Input
        }], planFeesIncludedInPremiumTooltipText: [{
            type: Input
        }], planFeesNotIncludedInPremiumTooltipText: [{
            type: Input
        }], showAvailableRateFactorsEnabled: [{
            type: Input
        }], personalizedQuoteLabelText: [{
            type: Input
        }], availableRateFactorsData: [{
            type: Input
        }], snpPremiumRangeEnabled: [{
            type: Input
        }], showPlanId: [{
            type: Input
        }], snpRangeLinkText: [{
            type: Input
        }], showPlanYear: [{
            type: Input
        }], planIdText: [{
            type: Input
        }], enableDSNPCodes: [{
            type: Input
        }], availableText: [{
            type: Input
        }], unavailableText: [{
            type: Input
        }], viewProvidersButtonText: [{
            type: Input
        }], viewPrescriptionsButtonText: [{
            type: Input
        }], supplementalBenefitsHighlightText: [{
            type: Input
        }], preferencesText: [{
            type: Input
        }], viewMoreDetailsText: [{
            type: Input
        }], hideDetailsText: [{
            type: Input
        }], newPlanCardDesignEnabled: [{
            type: Input
        }], viewAllPlanDetailsText: [{
            type: Input
        }], shareThisPlanText: [{
            type: Input
        }], viewCostDetailsText: [{
            type: Input
        }], closeText: [{
            type: Input
        }], planBenefitHighlightItems: [{
            type: Input
        }], planBenefitHighlightsHeaderText: [{
            type: Input
        }], showRiderDetails: [{
            type: Input
        }], hideRiderDetailsText: [{
            type: Input
        }], showRiderDetailsText: [{
            type: Input
        }], riderIsIncludedText: [{
            type: Input
        }], waiverStateRiderTooltips: [{
            type: Input
        }], costMA: [{
            type: Input
        }], costMAPD: [{
            type: Input
        }], costMEDIGAP: [{
            type: Input
        }], costPDP: [{
            type: Input
        }], costDENTAL: [{
            type: Input
        }], costVISION: [{
            type: Input
        }], isVbcAgreementEnabled: [{
            type: Input
        }], vbcAgreementLabel: [{
            type: Input
        }], vbcAgreementTooltip: [{
            type: Input
        }], nonCommissionableText: [{
            type: Input
        }], isNonCommissionableFlagCheckEnabled: [{
            type: Input
        }], quoteClicked: [{
            type: Output
        }], quoteGroupChanged: [{
            type: Output
        }] }); })();

const _c0$2r = ["coveragePreferences"];
const _c1$1c = ["starRating"];
const _c2$J = ["planName"];
function PlanCardTileComponent_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelement(1, "vnext-widget-plan-card-label", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", planCardTile_r1 == null ? null : planCardTile_r1.plan)("customClass", "col-7")("currentPlanText", ctx_r4.currentPlanText)("nextYearPlanText", ctx_r4.nextYearPlanText)("optionOneText", ctx_r4.optionOneText)("optionTwoText", ctx_r4.optionTwoText)("displayOptionLabels", ctx_r4.displayOptionLabels)("disableNextYearDisplay", ctx_r4.memberHasOptionsDefined && ctx_r4.displayOptionLabels)("nonCommissionableText", ctx_r4.nonCommissionableText)("isNonCommissionableFlagCheckEnabled", ctx_r4.isNonCommissionableFlagCheckEnabled);
} }
function PlanCardTileComponent_div_2_vnext_plan_logo_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-plan-logo", 32);
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("alternateText", planCardTile_r1 == null ? null : planCardTile_r1.plan.logo2Description)("imageSrc", ctx_r5.planFacade.getPlanLogoUrl(planCardTile_r1 == null ? null : planCardTile_r1.plan))("classNames", "plan-logo")("planLogoSize", ctx_r5.planLogoSize);
} }
function PlanCardTileComponent_div_2_div_10_vnext_plan_year_badge_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-plan-year-badge", 35);
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("planYear", planCardTile_r1 == null ? null : planCardTile_r1.plan == null ? null : planCardTile_r1.plan.planYear);
} }
function PlanCardTileComponent_div_2_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵtemplate(1, PlanCardTileComponent_div_2_div_10_vnext_plan_year_badge_1_Template, 1, 1, "vnext-plan-year-badge", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", planCardTile_r1 == null ? null : planCardTile_r1.plan == null ? null : planCardTile_r1.plan.planYear);
} }
function PlanCardTileComponent_div_2_vnext_link_17_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 36);
    i0.ɵɵlistener("click", function PlanCardTileComponent_div_2_vnext_link_17_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r27); const planCardTile_r1 = i0.ɵɵnextContext().$implicit; const ctx_r25 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r25.quoteClick(planCardTile_r1 == null ? null : planCardTile_r1.plan)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r9.planCardQuoteLinkText);
} }
function PlanCardTileComponent_div_2_ng_template_18_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind4(2, 1, planCardTile_r1 == null ? null : planCardTile_r1.planTotalPremium, "USD", "symbol", "1.2-2"), " ");
} }
function PlanCardTileComponent_div_2_ng_template_18_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-plan-fees-tooltip", 40);
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(2);
    const planCardTile_r1 = ctx_r32.$implicit;
    const isFirstPlan_r2 = ctx_r32.first;
    const isLastPlan_r3 = ctx_r32.last;
    const ctx_r30 = i0.ɵɵnextContext();
    i0.ɵɵproperty("planFees", planCardTile_r1 == null ? null : planCardTile_r1.plan.fees)("planTotalPremium", planCardTile_r1 == null ? null : planCardTile_r1.planTotalPremium)("planFeesTooltipText", ctx_r30.planFeesTooltipText)("planFeesIncludedInPremiumTooltipText", ctx_r30.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r30.planFeesNotIncludedInPremiumTooltipText)("tooltipPlacement", isFirstPlan_r2 ? "bottom-left" : isLastPlan_r3 ? "bottom-right" : "bottom-right bottom-left")("tooltipCustomClass", isFirstPlan_r2 || isLastPlan_r3 ? "inline-block-xs-layout inline-block-sm-layout" : "");
} }
function PlanCardTileComponent_div_2_ng_template_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanCardTileComponent_div_2_ng_template_18_div_0_Template, 3, 6, "div", 37);
    i0.ɵɵtemplate(1, PlanCardTileComponent_div_2_ng_template_18_ng_template_1_Template, 1, 7, "ng-template", null, 38, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r29 = i0.ɵɵreference(2);
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r11.planFeesEnabled || !(planCardTile_r1 == null ? null : planCardTile_r1.plan.fees == null ? null : planCardTile_r1.plan.fees.length))("ngIfElse", _r29);
} }
function PlanCardTileComponent_div_2_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵelement(1, "vnext-shopping-cart-button", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", planCardTile_r1 == null ? null : planCardTile_r1.plan);
} }
function PlanCardTileComponent_div_2_ng_container_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-plan-benefits", 43);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", planCardTile_r1 == null ? null : planCardTile_r1.plan)("isTileDisplay", ctx_r13.plans.length > 1)("planBenefits", ctx_r13.planBenefits)("planBenefitNoValueLabel", ctx_r13.planBenefitNoValueLabel)("annualCost", i0.ɵɵpipeBind1(2, 5, ctx_r13.planCardFacade.getAnnualCost$(planCardTile_r1 == null ? null : planCardTile_r1.plan)));
} }
function PlanCardTileComponent_div_2_ng_container_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 44);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 45);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r14.planTypeText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(planCardTile_r1 == null ? null : planCardTile_r1.plan.planSubType);
} }
function PlanCardTileComponent_div_2_ng_container_28_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function PlanCardTileComponent_div_2_ng_container_28_ng_template_2_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 52);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r43.addOnCoverageTooltipBody, "html"), i0.ɵɵsanitizeHtml);
} }
function PlanCardTileComponent_div_2_ng_container_28_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanCardTileComponent_div_2_ng_container_28_ng_template_2_ng_template_0_Template, 2, 4, "ng-template", null, 49, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(2, "p", 50);
    i0.ɵɵelement(3, "i", 51);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r42 = i0.ɵɵreference(1);
    const ctx_r39 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngbTooltip", _r42);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r39.addOnCoverageText, " ");
} }
function PlanCardTileComponent_div_2_ng_container_28_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 53);
    i0.ɵɵelement(1, "vnext-rider-card", 54);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r41 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("riderCategories", ctx_r41.riderFacade.getRiderCategories(planCardTile_r1 == null ? null : planCardTile_r1.plan.riders))("isTileDisplay", true)("Spa_Site_ShowRiderIcons", ctx_r41.Spa_Site_ShowRiderIcons)("Spa_Site_Dental_Rider_Display_Text", ctx_r41.Spa_Site_Dental_Rider_Display_Text)("Spa_Site_Vision_Rider_Display_Text", ctx_r41.Spa_Site_Vision_Rider_Display_Text)("Spa_Site_Hearing_Rider_Display_Text", ctx_r41.Spa_Site_Hearing_Rider_Display_Text)("Spa_PlanCard_DentalAddOnCoverage_Text", ctx_r41.Spa_PlanCard_DentalAddOnCoverage_Text)("Spa_PlanCard_HearingAddOnCoverage_Text", ctx_r41.Spa_PlanCard_HearingAddOnCoverage_Text)("Spa_PlanCard_VisionAddOnCoverage_Text", ctx_r41.Spa_PlanCard_VisionAddOnCoverage_Text)("Spa_PlanCard_AddOnCoverage_Text", ctx_r41.Spa_PlanCard_AddOnCoverage_Text)("Spa_Site_Tooltip_Text", ctx_r41.Spa_Site_Tooltip_Text);
} }
function PlanCardTileComponent_div_2_ng_container_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanCardTileComponent_div_2_ng_container_28_ng_container_1_Template, 1, 0, "ng-container", 46);
    i0.ɵɵtemplate(2, PlanCardTileComponent_div_2_ng_container_28_ng_template_2_Template, 5, 2, "ng-template", null, 47, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, PlanCardTileComponent_div_2_ng_container_28_ng_template_4_Template, 2, 11, "ng-template", null, 48, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r38 = i0.ɵɵreference(3);
    const _r40 = i0.ɵɵreference(5);
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r15 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (planCardTile_r1 == null ? null : planCardTile_r1.plan.planType) === ctx_r15.planType.MEDIGAP && ctx_r15.planCardFacade.showMedSupAddOnCoverageText())("ngIfThen", _r38)("ngIfElse", _r40);
} }
function PlanCardTileComponent_div_2_div_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-coverage-preferences", 55);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r17 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pharmacyNotCoveredText", ctx_r17.planDetailsNonCoveredText)("plan", planCardTile_r1 == null ? null : planCardTile_r1.plan)("prescriptionsText", ctx_r17.prescriptionText)("pharmacyText", ctx_r17.pharmacyText)("pharmacyCoveredText", ctx_r17.planCardFacade.getPharmacyCoverageText(planCardTile_r1 == null ? null : planCardTile_r1.plan, ctx_r17.pharmacyCoveredText))("addedPharmacy", i0.ɵɵpipeBind1(2, 40, ctx_r17.planCardFacade.getSelectedPharmacy$()))("drugCoverageText", ctx_r17.planCardFacade.getDrugCoverageText(i0.ɵɵpipeBind1(3, 42, ctx_r17.planCardFacade.getDrugsCount$()), ctx_r17.drugCoveredText, planCardTile_r1 == null ? null : planCardTile_r1.plan))("showDrugCoverage", ctx_r17.planCardFacade.showDrugCoverage(ctx_r17.displayDrugsCovered, i0.ɵɵpipeBind1(4, 44, ctx_r17.planCardFacade.getDrugsCount$())))("planPreferences", ctx_r17.planPreferences)("isTotalEstimatedCostEnabled", ctx_r17.isTotalEstimatedCostEnabled)("isRetention", ctx_r17.isRetention)("isQuoting", ctx_r17.isQuoting)("totalEstimatedAnnualCostText", ctx_r17.totalEstimatedAnnualCostText)("totalEstimatedCostText", ctx_r17.totalEstimatedCostText)("totalEstimatedCostTooltip", ctx_r17.totalEstimatedCostTooltip)("isTileDisplay", true)("noCostAvailableText", ctx_r17.noCostAvailableText)("Spa_Site_Tooltip_Text", ctx_r17.Spa_Site_Tooltip_Text)("medicineCabinet", ctx_r17.medicineCabinet)("annualCost", i0.ɵɵpipeBind1(5, 46, ctx_r17.planCardFacade.getAnnualCost$(planCardTile_r1 == null ? null : planCardTile_r1.plan, ctx_r17.isMailOrderSelected)))("inNetworkPreferredText", ctx_r17.inNetworkPreferredText)("showMailOrderLabel", ctx_r17.isMailOrderSelected)("inNetworkStandardText", ctx_r17.inNetworkStandardText)("outOfNetworkText", ctx_r17.outOfNetworkText)("viewCostTooltipHeaderText", ctx_r17.viewCostTooltipHeaderText)("viewCostTooltipHeaderContent", ctx_r17.viewCostTooltipHeaderContent)("mailOrderText", ctx_r17.mailOrderText)("selectedProviders", ctx_r17.selectedProviders)("planCardPreferenceDetailedEnabled", ctx_r17.planCardPreferenceDetailedEnabled)("providerDetails", ctx_r17.providerDetails)("showProviderInNetworkOnOtherLocation", planCardTile_r1 == null ? null : planCardTile_r1.showProviderInNetworkOnOtherLocation)("providersCoveredText", planCardTile_r1 == null ? null : planCardTile_r1.providersCoveredText)("providerPcpText", planCardTile_r1 == null ? null : planCardTile_r1.providerPcpText)("loaderIconEnabled", ctx_r17.loaderIconEnabled)("editLinkText", ctx_r17.editLinkText)("providerOneOrMoreOutOfNetworkText", ctx_r17.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r17.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r17.providerShowPartialIndicatorEnabled)("viewProvidersButtonText", ctx_r17.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r17.viewPrescriptionsButtonText);
} }
function PlanCardTileComponent_div_2_div_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-coverage-preferences", 56);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pharmacyNotCoveredText", ctx_r18.planDetailsNonCoveredText)("plan", planCardTile_r1 == null ? null : planCardTile_r1.plan)("prescriptionsText", ctx_r18.prescriptionText)("pharmacyText", ctx_r18.pharmacyText)("pharmacyCoveredText", ctx_r18.planCardFacade.getPharmacyCoverageText(planCardTile_r1 == null ? null : planCardTile_r1.plan, ctx_r18.pharmacyCoveredText))("addedPharmacy", i0.ɵɵpipeBind1(2, 33, ctx_r18.planCardFacade.getSelectedPharmacy$()))("drugCoverageText", ctx_r18.planCardFacade.getDrugCoverageText(i0.ɵɵpipeBind1(3, 35, ctx_r18.planCardFacade.getDrugsCount$()), ctx_r18.drugCoveredText, planCardTile_r1 == null ? null : planCardTile_r1.plan))("showDrugCoverage", ctx_r18.planCardFacade.showDrugCoverage(ctx_r18.displayDrugsCovered, i0.ɵɵpipeBind1(4, 37, ctx_r18.planCardFacade.getDrugsCount$())))("planPreferences", ctx_r18.planPreferences)("isTotalEstimatedCostEnabled", ctx_r18.isTotalEstimatedCostEnabled)("isRetention", ctx_r18.isRetention)("isQuoting", ctx_r18.isQuoting)("totalEstimatedAnnualCostText", ctx_r18.totalEstimatedAnnualCostText)("medicineCabinet", ctx_r18.medicineCabinet)("totalEstimatedCostText", ctx_r18.totalEstimatedCostText)("totalEstimatedCostTooltip", ctx_r18.totalEstimatedCostTooltip)("isTileDisplay", true)("noCostAvailableText", ctx_r18.noCostAvailableText)("Spa_Site_Tooltip_Text", ctx_r18.Spa_Site_Tooltip_Text)("annualCost", i0.ɵɵpipeBind1(5, 39, ctx_r18.planCardFacade.getAnnualCost$(planCardTile_r1 == null ? null : planCardTile_r1.plan)))("selectedProviders", ctx_r18.selectedProviders)("planCardPreferenceDetailedEnabled", ctx_r18.planCardPreferenceDetailedEnabled)("providerDetails", ctx_r18.providerDetails)("showProviderInNetworkOnOtherLocation", planCardTile_r1 == null ? null : planCardTile_r1.showProviderInNetworkOnOtherLocation)("providersCoveredText", planCardTile_r1 == null ? null : planCardTile_r1.providersCoveredText)("providerPcpText", planCardTile_r1 == null ? null : planCardTile_r1.providerPcpText)("loaderIconEnabled", ctx_r18.loaderIconEnabled)("editLinkText", ctx_r18.editLinkText)("providerOneOrMoreOutOfNetworkText", ctx_r18.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r18.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r18.providerShowPartialIndicatorEnabled)("viewProvidersButtonText", ctx_r18.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r18.viewPrescriptionsButtonText);
} }
function PlanCardTileComponent_div_2_div_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-coverage-preferences", 57);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r19 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pharmacyNotCoveredText", ctx_r19.planDetailsNonCoveredText)("plan", planCardTile_r1 == null ? null : planCardTile_r1.plan)("prescriptionsText", ctx_r19.prescriptionText)("pharmacyText", ctx_r19.pharmacyText)("pharmacyCoveredText", ctx_r19.planCardFacade.getPharmacyCoverageText(planCardTile_r1 == null ? null : planCardTile_r1.plan, ctx_r19.pharmacyCoveredText))("addedPharmacy", i0.ɵɵpipeBind1(2, 37, ctx_r19.planCardFacade.getSelectedPharmacy$()))("drugCoverageText", ctx_r19.planCardFacade.getDrugCoverageText(i0.ɵɵpipeBind1(3, 39, ctx_r19.planCardFacade.getDrugsCount$()), ctx_r19.drugCoveredText, planCardTile_r1 == null ? null : planCardTile_r1.plan))("showDrugCoverage", ctx_r19.planCardFacade.showDrugCoverage(ctx_r19.displayDrugsCovered, i0.ɵɵpipeBind1(4, 41, ctx_r19.planCardFacade.getDrugsCount$())))("planPreferences", ctx_r19.planPreferences)("isTotalEstimatedCostEnabled", ctx_r19.isTotalEstimatedCostEnabled)("isRetention", ctx_r19.isRetention)("isQuoting", ctx_r19.isQuoting)("totalEstimatedAnnualCostText", ctx_r19.totalEstimatedAnnualCostText)("totalEstimatedCostText", ctx_r19.totalEstimatedCostText)("totalEstimatedCostTooltip", ctx_r19.totalEstimatedCostTooltip)("isTileDisplay", true)("noCostAvailableText", ctx_r19.noCostAvailableText)("Spa_Site_Tooltip_Text", ctx_r19.Spa_Site_Tooltip_Text)("annualCost", i0.ɵɵpipeBind1(5, 43, ctx_r19.planCardFacade.getAnnualCost$(planCardTile_r1 == null ? null : planCardTile_r1.plan, ctx_r19.isMailOrderSelected)))("medicineCabinet", ctx_r19.medicineCabinet)("inNetworkPreferredText", ctx_r19.inNetworkPreferredText)("showMailOrderLabel", ctx_r19.isMailOrderSelected)("inNetworkStandardText", ctx_r19.inNetworkStandardText)("outOfNetworkText", ctx_r19.outOfNetworkText)("viewCostTooltipHeaderText", ctx_r19.viewCostTooltipHeaderText)("viewCostTooltipHeaderContent", ctx_r19.viewCostTooltipHeaderContent)("mailOrderText", ctx_r19.mailOrderText)("selectedProviders", ctx_r19.selectedProviders)("planCardPreferenceDetailedEnabled", ctx_r19.planCardPreferenceDetailedEnabled)("providerDetails", ctx_r19.providerDetails)("loaderIconEnabled", ctx_r19.loaderIconEnabled)("editLinkText", ctx_r19.editLinkText)("providerOneOrMoreOutOfNetworkText", ctx_r19.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r19.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r19.providerShowPartialIndicatorEnabled)("viewProvidersButtonText", ctx_r19.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r19.viewPrescriptionsButtonText);
} }
const _c3$s = function (a0, a1, a2) { return { "current-plan-card Spa_Style_Accent6_Border": a0, "plan-card-basic-border": a1, "next-year-plan-card Spa_Style_Primary_Link_Border": a2 }; };
function PlanCardTileComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, PlanCardTileComponent_div_2_div_1_Template, 2, 10, "div", 4);
    i0.ɵɵelementStart(2, "div", 5)(3, "div", 6);
    i0.ɵɵtemplate(4, PlanCardTileComponent_div_2_vnext_plan_logo_4_Template, 1, 4, "vnext-plan-logo", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 8)(6, "div", 9, 10)(8, "h4", 11);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, PlanCardTileComponent_div_2_div_10_Template, 2, 1, "div", 12);
    i0.ɵɵelementStart(11, "div", 13, 14);
    i0.ɵɵelement(13, "vnext-star-rating", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 16)(15, "div", 17);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, PlanCardTileComponent_div_2_vnext_link_17_Template, 1, 1, "vnext-link", 18);
    i0.ɵɵtemplate(18, PlanCardTileComponent_div_2_ng_template_18_Template, 3, 2, "ng-template", null, 19, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 20)(21, "button", 21);
    i0.ɵɵlistener("click", function PlanCardTileComponent_div_2_Template_button_click_21_listener() { const restoredCtx = i0.ɵɵrestoreView(_r50); const planCardTile_r1 = restoredCtx.$implicit; const ctx_r49 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r49.viewPlanDetailsPage(planCardTile_r1 == null ? null : planCardTile_r1.plan)); });
    i0.ɵɵtext(22);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(23, PlanCardTileComponent_div_2_div_23_Template, 2, 1, "div", 22);
    i0.ɵɵelementStart(24, "div", 23);
    i0.ɵɵtemplate(25, PlanCardTileComponent_div_2_ng_container_25_Template, 3, 7, "ng-container", 24);
    i0.ɵɵtemplate(26, PlanCardTileComponent_div_2_ng_container_26_Template, 5, 2, "ng-container", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 25);
    i0.ɵɵtemplate(28, PlanCardTileComponent_div_2_ng_container_28_Template, 6, 3, "ng-container", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 26)(30, "div", 27, 28);
    i0.ɵɵtemplate(32, PlanCardTileComponent_div_2_div_32_Template, 6, 48, "div", 29);
    i0.ɵɵtemplate(33, PlanCardTileComponent_div_2_div_33_Template, 6, 41, "div", 29);
    i0.ɵɵtemplate(34, PlanCardTileComponent_div_2_div_34_Template, 6, 45, "div", 29);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const planCardTile_r1 = ctx.$implicit;
    const _r10 = i0.ɵɵreference(19);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.hidePlanCardLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(22, _c3$s, !ctx_r0.hidePlanCardLabel && (planCardTile_r1 == null ? null : planCardTile_r1.plan.isCurrentYearPlan), ctx_r0.hidePlanCardLabel || !(planCardTile_r1 == null ? null : planCardTile_r1.plan.isCurrentYearPlan) && !ctx_r0.extraPlanFields[planCardTile_r1 == null ? null : planCardTile_r1.plan.id].displayLinkBorder, !ctx_r0.hidePlanCardLabel && ctx_r0.extraPlanFields[planCardTile_r1 == null ? null : planCardTile_r1.plan.id].displayLinkBorder));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showPlanLogo && ctx_r0.planFacade.getPlanLogoUrl(planCardTile_r1 == null ? null : planCardTile_r1.plan));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(planCardTile_r1 == null ? null : planCardTile_r1.plan.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showPlanYear);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("starRating", planCardTile_r1 == null ? null : planCardTile_r1.plan.planRating)("ratingValueDescription", planCardTile_r1 == null ? null : planCardTile_r1.plan.planRatingValueDescription)("showLowPerformanceIndicator", planCardTile_r1 == null ? null : planCardTile_r1.plan.isLowPerformingPlan);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.planFacade.getPremiumLabel());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(ctx_r0.extraPlanFields[planCardTile_r1 == null ? null : planCardTile_r1.plan.id] == null ? null : ctx_r0.extraPlanFields[planCardTile_r1 == null ? null : planCardTile_r1.plan.id].hasPremium))("ngIfElse", _r10);
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate2("title", "", ctx_r0.viewDetailsDescriptionText, " ", planCardTile_r1 == null ? null : planCardTile_r1.plan.planName, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.planDetailsButtonText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.extraPlanFields[planCardTile_r1 == null ? null : planCardTile_r1.plan.id] == null ? null : ctx_r0.extraPlanFields[planCardTile_r1 == null ? null : planCardTile_r1.plan.id].hasPremium);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (planCardTile_r1 == null ? null : planCardTile_r1.plan.planType) === ctx_r0.planType.MAPD || (planCardTile_r1 == null ? null : planCardTile_r1.plan.planType) === ctx_r0.planType.MA || (planCardTile_r1 == null ? null : planCardTile_r1.plan.planType) === ctx_r0.planType.PDP);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (planCardTile_r1 == null ? null : planCardTile_r1.plan.planType) === ctx_r0.planType.MEDIGAP);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.planCardFacade.showRiderSection(planCardTile_r1 == null ? null : planCardTile_r1.plan, ctx_r0.shoppingCartEnabled, ctx_r0.showRidersOnPlanCards, ctx_r0.showPremiumAsAnnual, ctx_r0.riderDisplayMap));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", planCardTile_r1 == null ? null : planCardTile_r1.plan.planType);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.planType.MAPD);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.planType.MA);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.planType.PDP);
} }
class PlanCardTileComponent {
    constructor(cartFacade, planFacade, riderFacade, planCardFacade, navigationService, analyticsService) {
        this.cartFacade = cartFacade;
        this.planFacade = planFacade;
        this.riderFacade = riderFacade;
        this.planCardFacade = planCardFacade;
        this.navigationService = navigationService;
        this.analyticsService = analyticsService;
        this.viewDetailsDescriptionText = 'Press Enter to view plan details of ';
        this.isNonCommissionableFlagCheckEnabled = false;
        this.showPlanYear = false;
        this.quoteClicked = new EventEmitter();
        this.viewPlanDetails = new EventEmitter();
        this.planType = PlanType;
        this.maxPlanLogoHeight = 0;
        this.maxPlanNameHeight = 0;
        this.maxPlanRatingsHeight = 0;
        this.planPreferencesSectionPadding = 20;
        this.extraPlanFields = {};
        this.memberHasOptionsDefined = false;
        this.planCardTiles = [];
    }
    ngOnChanges(changes) {
        const oldPlans = changes.plans?.previousValue;
        const newPlans = changes.plans?.currentValue;
        if (!_isEqual(oldPlans, newPlans)) {
            this.memberHasOptionsDefined = this.planFacade.memberHasOptionsDefined();
            if (newPlans?.length) {
                this.extraPlanFields = {};
                newPlans.forEach(plan => {
                    this.planFacade
                        .hasPremium$(plan)
                        .pipe(take(1))
                        .subscribe(hasPremium => {
                        this.extraPlanFields[plan.id] = {
                            displayLinkBorder: this.planFacade.canDisplayLinkBorder(plan, this.displayOptionLabels),
                            hasPremium
                        };
                    });
                });
            }
        }
        const { plans, selectedProviders, providerDetails, providersInNetworkText, providersNoDataText, pcpInNetworkText, pcpOutOfNetworkText } = changes;
        if ((plans && !_isEqual(plans.previousValue, plans.currentValue)) ||
            (selectedProviders && !_isEqual(selectedProviders.previousValue, selectedProviders.currentValue)) ||
            (providerDetails && !_isEqual(providerDetails.previousValue, providerDetails.currentValue)) ||
            (providersInNetworkText && providersInNetworkText.previousValue !== providersInNetworkText.currentValue) ||
            (providersNoDataText && providersNoDataText.previousValue !== providersNoDataText.currentValue) ||
            (pcpInNetworkText && pcpInNetworkText.previousValue !== pcpInNetworkText.currentValue) ||
            (pcpOutOfNetworkText && pcpOutOfNetworkText.previousValue !== pcpOutOfNetworkText.currentValue)) {
            if (this.plans) {
                this.planCardTiles = this.plans.map(plan => {
                    const canSellPlan = this.planFacade.canSellPlan(plan);
                    return {
                        plan,
                        planTotalPremium: this.planFacade.getTotalPremium([plan]),
                        showProviderInNetworkOnOtherLocation: this.planCardFacade.getIsProviderInNetworkOnOtherLocation(plan.id, this.selectedProviders, this.providerDetails, plan.showProviderSearch, canSellPlan),
                        providersCoveredText: this.planCardFacade.getProviderCoveredText(plan.id, this.selectedProviders, this.providerDetails, this.providersInNetworkText, this.providersNoDataText, '', plan.showProviderSearch, canSellPlan),
                        providerPcpText: this.planCardFacade.getProviderPcpText(plan.id, this.selectedProviders, this.providerDetails, this.pcpInNetworkText, this.pcpOutOfNetworkText, plan.showProviderSearch, canSellPlan)
                    };
                });
            }
        }
    }
    ngAfterViewChecked() {
        this.maxPlanNameHeight = this.planCardFacade.calculateMaxSectionHeight(this.planNames, this.maxPlanNameHeight);
        this.maxPlanRatingsHeight = this.planCardFacade.calculateMaxSectionHeight(this.starRatings, this.maxPlanRatingsHeight);
        this.planCardFacade.setPrefHeight(this.coveragePreferences, 'preference-element');
    }
    quoteClick(plan) {
        this.planFacade.tagsToUpdate(DataLayerEvent.CLICK_PLANS_GET_QUOTE, plan.id, plan.planTypeAbbreviation, null, this.planFacade.isVbcAgreementExists(plan));
        this.quoteClicked.emit();
    }
    viewPlanDetailsPage(plan) {
        if (this.isRetention) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_VIEW_DETAILS);
        }
        this.viewPlanDetails.emit(plan);
    }
}
PlanCardTileComponent.ɵfac = function PlanCardTileComponent_Factory(t) { return new (t || PlanCardTileComponent)(i0.ɵɵdirectiveInject(CartFacade), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(RiderFacade), i0.ɵɵdirectiveInject(PlanCardFacade), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(AnalyticsService)); };
PlanCardTileComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCardTileComponent, selectors: [["vnext-widget-plan-card-tile"]], viewQuery: function PlanCardTileComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$2r, 5);
        i0.ɵɵviewQuery(_c1$1c, 5);
        i0.ɵɵviewQuery(_c2$J, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.coveragePreferences = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.starRatings = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.planNames = _t);
    } }, inputs: { plans: "plans", showPlanLogo: "showPlanLogo", planDetailsButtonText: "planDetailsButtonText", planBenefitNoValueLabel: "planBenefitNoValueLabel", planTypeText: "planTypeText", addOnCoverageText: "addOnCoverageText", addOnCoverageTooltipBody: "addOnCoverageTooltipBody", planDetailsNonCoveredText: "planDetailsNonCoveredText", prescriptionText: "prescriptionText", pharmacyText: "pharmacyText", isTotalEstimatedCostEnabled: "isTotalEstimatedCostEnabled", isRetention: "isRetention", totalEstimatedAnnualCostText: "totalEstimatedAnnualCostText", totalEstimatedCostText: "totalEstimatedCostText", totalEstimatedCostTooltip: "totalEstimatedCostTooltip", planCardQuoteLinkText: "planCardQuoteLinkText", planPreferences: "planPreferences", planBenefits: "planBenefits", shoppingCartEnabled: "shoppingCartEnabled", showRidersOnPlanCards: "showRidersOnPlanCards", showPremiumAsAnnual: "showPremiumAsAnnual", riderDisplayMap: "riderDisplayMap", drugCoveredText: "drugCoveredText", pharmacyCoveredText: "pharmacyCoveredText", displayDrugsCovered: "displayDrugsCovered", currentPlanText: "currentPlanText", nextYearPlanText: "nextYearPlanText", isQuoting: "isQuoting", noCostAvailableText: "noCostAvailableText", inNetworkPreferredText: "inNetworkPreferredText", inNetworkStandardText: "inNetworkStandardText", outOfNetworkText: "outOfNetworkText", isMailOrderSelected: "isMailOrderSelected", viewCostTooltipHeaderText: "viewCostTooltipHeaderText", viewCostTooltipHeaderContent: "viewCostTooltipHeaderContent", mailOrderText: "mailOrderText", providersInNetworkText: "providersInNetworkText", pcpInNetworkText: "pcpInNetworkText", pcpOutOfNetworkText: "pcpOutOfNetworkText", providersNoDataText: "providersNoDataText", isProviderEnabled: "isProviderEnabled", selectedProviders: "selectedProviders", providerDetails: "providerDetails", Spa_Site_ShowRiderIcons: "Spa_Site_ShowRiderIcons", Spa_Site_Dental_Rider_Display_Text: "Spa_Site_Dental_Rider_Display_Text", Spa_Site_Vision_Rider_Display_Text: "Spa_Site_Vision_Rider_Display_Text", Spa_Site_Hearing_Rider_Display_Text: "Spa_Site_Hearing_Rider_Display_Text", Spa_PlanCard_DentalAddOnCoverage_Text: "Spa_PlanCard_DentalAddOnCoverage_Text", Spa_PlanCard_HearingAddOnCoverage_Text: "Spa_PlanCard_HearingAddOnCoverage_Text", Spa_PlanCard_VisionAddOnCoverage_Text: "Spa_PlanCard_VisionAddOnCoverage_Text", Spa_PlanCard_AddOnCoverage_Text: "Spa_PlanCard_AddOnCoverage_Text", Spa_Site_MedigapPlanType_Enabled: "Spa_Site_MedigapPlanType_Enabled", Spa_Site_AddToCompare_Enabled: "Spa_Site_AddToCompare_Enabled", Spa_Site_PlanViewDetails_Enabled: "Spa_Site_PlanViewDetails_Enabled", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text", viewDetailsDescriptionText: "viewDetailsDescriptionText", optionOneText: "optionOneText", optionTwoText: "optionTwoText", displayOptionLabels: "displayOptionLabels", nonCommissionableText: "nonCommissionableText", isNonCommissionableFlagCheckEnabled: "isNonCommissionableFlagCheckEnabled", hidePlanCardLabel: "hidePlanCardLabel", medicineCabinet: "medicineCabinet", planCardPreferenceDetailedEnabled: "planCardPreferenceDetailedEnabled", planLogoSize: "planLogoSize", loaderIconEnabled: "loaderIconEnabled", editLinkText: "editLinkText", providerOneOrMoreOutOfNetworkText: "providerOneOrMoreOutOfNetworkText", providerInNetworkOnOtherLocationsTooltipText: "providerInNetworkOnOtherLocationsTooltipText", providerShowPartialIndicatorEnabled: "providerShowPartialIndicatorEnabled", planFeesEnabled: "planFeesEnabled", planFeesTooltipText: "planFeesTooltipText", planFeesIncludedInPremiumTooltipText: "planFeesIncludedInPremiumTooltipText", planFeesNotIncludedInPremiumTooltipText: "planFeesNotIncludedInPremiumTooltipText", showPlanYear: "showPlanYear", viewProvidersButtonText: "viewProvidersButtonText", viewPrescriptionsButtonText: "viewPrescriptionsButtonText" }, outputs: { quoteClicked: "quoteClicked", viewPlanDetails: "viewPlanDetails" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 1, consts: [[1, "container"], [1, "row", "plan-card", "mb-3"], ["class", "col px-0 plan-card-column", 4, "ngFor", "ngForOf"], [1, "col", "px-0", "plan-card-column"], ["class", "p-0 plan-card-label-height", 4, "ngIf"], [1, "plan-card-border", "d-flex", "flex-column", "flex-grow-1", 3, "ngClass"], [1, "py-2", "px-3", "plan-card-section"], [3, "alternateText", "imageSrc", "classNames", "planLogoSize", 4, "ngIf"], [1, "d-flex", "flex-column"], [1, "pb-1", "px-3", "no-translate-block"], ["planName", ""], [1, "Spa_Style_H4", "my-0"], ["class", "px-3", 4, "ngIf"], [1, "pb-2", "pt-1", "text-center", "px-3"], ["starRating", ""], [3, "starRating", "ratingValueDescription", "showLowPerformanceIndicator"], [1, "pb-3", "text-center", "plan-monthly-premium", "px-3"], [1, "Spa_Style_Paragraph"], [3, "title", "click", 4, "ngIf", "ngIfElse"], ["showPremium", ""], [1, "pb-1", "px-3"], [1, "btn", "Spa_Style_SecondaryButton", "btn-block", 3, "title", "click"], ["class", "px-3 pb-3", 4, "ngIf"], [1, "px-3", "plan-card-section"], [4, "ngIf"], [1, "pr-md-3", "pr-sm-0", "plan-card-section", "riders-section-height"], [1, "px-0", "plan-card-section", 3, "ngSwitch"], [1, "Spa_Style_Toggle_Background"], ["coveragePreferences", ""], [4, "ngSwitchCase"], [1, "p-0", "plan-card-label-height"], [3, "plan", "customClass", "currentPlanText", "nextYearPlanText", "optionOneText", "optionTwoText", "displayOptionLabels", "disableNextYearDisplay", "nonCommissionableText", "isNonCommissionableFlagCheckEnabled"], [3, "alternateText", "imageSrc", "classNames", "planLogoSize"], [1, "px-3"], [3, "planYear", 4, "ngIf"], [3, "planYear"], [3, "title", "click"], ["class", "Spa_Style_CostPremiumSmall", 4, "ngIf", "ngIfElse"], ["showPremiumWithFees", ""], [1, "Spa_Style_CostPremiumSmall"], [1, "ml-3", 3, "planFees", "planTotalPremium", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "tooltipPlacement", "tooltipCustomClass"], [1, "px-3", "pb-3"], [3, "plan"], [3, "plan", "isTileDisplay", "planBenefits", "planBenefitNoValueLabel", "annualCost"], [1, "Spa_Style_Paragraph", "col-6"], [1, "Spa_Style_H3", "col-6", "text-right"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["medSupAddOnCoverage", ""], ["otherCoverage", ""], ["addOnCoverageTooltip", ""], [1, "Spa_Style_Paragraph", "can-click", 3, "ngbTooltip"], ["aria-hidden", "true", 1, "fas", "fa-plus-circle", "Spa_Style_InfoBarAndIconColor", "tooltip-icon"], ["navigationAdapter", "", 1, "Spa_Style_ToolTip", 3, "innerHTML"], [1, "plan-card-rider-margin"], [3, "riderCategories", "isTileDisplay", "Spa_Site_ShowRiderIcons", "Spa_Site_Dental_Rider_Display_Text", "Spa_Site_Vision_Rider_Display_Text", "Spa_Site_Hearing_Rider_Display_Text", "Spa_PlanCard_DentalAddOnCoverage_Text", "Spa_PlanCard_HearingAddOnCoverage_Text", "Spa_PlanCard_VisionAddOnCoverage_Text", "Spa_PlanCard_AddOnCoverage_Text", "Spa_Site_Tooltip_Text"], [3, "pharmacyNotCoveredText", "plan", "prescriptionsText", "pharmacyText", "pharmacyCoveredText", "addedPharmacy", "drugCoverageText", "showDrugCoverage", "planPreferences", "isTotalEstimatedCostEnabled", "isRetention", "isQuoting", "totalEstimatedAnnualCostText", "totalEstimatedCostText", "totalEstimatedCostTooltip", "isTileDisplay", "noCostAvailableText", "Spa_Site_Tooltip_Text", "medicineCabinet", "annualCost", "inNetworkPreferredText", "showMailOrderLabel", "inNetworkStandardText", "outOfNetworkText", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "mailOrderText", "selectedProviders", "planCardPreferenceDetailedEnabled", "providerDetails", "showProviderInNetworkOnOtherLocation", "providersCoveredText", "providerPcpText", "loaderIconEnabled", "editLinkText", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "viewProvidersButtonText", "viewPrescriptionsButtonText"], [3, "pharmacyNotCoveredText", "plan", "prescriptionsText", "pharmacyText", "pharmacyCoveredText", "addedPharmacy", "drugCoverageText", "showDrugCoverage", "planPreferences", "isTotalEstimatedCostEnabled", "isRetention", "isQuoting", "totalEstimatedAnnualCostText", "medicineCabinet", "totalEstimatedCostText", "totalEstimatedCostTooltip", "isTileDisplay", "noCostAvailableText", "Spa_Site_Tooltip_Text", "annualCost", "selectedProviders", "planCardPreferenceDetailedEnabled", "providerDetails", "showProviderInNetworkOnOtherLocation", "providersCoveredText", "providerPcpText", "loaderIconEnabled", "editLinkText", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "viewProvidersButtonText", "viewPrescriptionsButtonText"], [3, "pharmacyNotCoveredText", "plan", "prescriptionsText", "pharmacyText", "pharmacyCoveredText", "addedPharmacy", "drugCoverageText", "showDrugCoverage", "planPreferences", "isTotalEstimatedCostEnabled", "isRetention", "isQuoting", "totalEstimatedAnnualCostText", "totalEstimatedCostText", "totalEstimatedCostTooltip", "isTileDisplay", "noCostAvailableText", "Spa_Site_Tooltip_Text", "annualCost", "medicineCabinet", "inNetworkPreferredText", "showMailOrderLabel", "inNetworkStandardText", "outOfNetworkText", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "mailOrderText", "selectedProviders", "planCardPreferenceDetailedEnabled", "providerDetails", "loaderIconEnabled", "editLinkText", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "viewProvidersButtonText", "viewPrescriptionsButtonText"]], template: function PlanCardTileComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, PlanCardTileComponent_div_2_Template, 35, 26, "div", 2);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.planCardTiles);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, LinkComponent, PlanYearBadgeComponent, NavigationAdapterDirective, IconAriaAttributesDirective, i1$1.NgbTooltip, RiderCardComponent, StarRatingComponent, ShoppingCartButtonComponent, PlanBenefitsComponent, PlanFeesTooltipComponent, PlanCoveragePreferencesComponent, PlanCardLabelComponent, PlanLogoComponent, i1$2.AsyncPipe, i1$2.CurrencyPipe, SafePipe], styles: [".plan-card-border[_ngcontent-%COMP%]{border-style:solid;border-width:2px}.plan-card-basic-border[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent1)}.plan-card-column[_ngcontent-%COMP%]{display:flex;flex-flow:column}.plan-card-column[_ngcontent-%COMP%]:first-child   .plan-card-border[_ngcontent-%COMP%]{border-bottom-left-radius:5px}.plan-card-column[_ngcontent-%COMP%]:last-child   .plan-card-border[_ngcontent-%COMP%]{border-top-right-radius:5px;border-bottom-right-radius:5px}.plan-card-section[_ngcontent-%COMP%]{display:flex;align-items:stretch;flex-direction:column;flex-grow:1}.not-available-text[_ngcontent-%COMP%]{height:54px}.riders-section-height[_ngcontent-%COMP%]{min-height:30px}.current-plan-text[_ngcontent-%COMP%], .next-year-plan-text[_ngcontent-%COMP%]{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.plan-card-label-height[_ngcontent-%COMP%]{min-height:28px;margin-bottom:-1px}.plan-card-rider-margin[_ngcontent-%COMP%]{margin-left:17px}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], PlanCardTileComponent.prototype, "quoteClick", null);
__decorate([
    LiveEditInactive()
], PlanCardTileComponent.prototype, "viewPlanDetailsPage", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCardTileComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-card-tile', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container\">\r\n  <div class=\"row plan-card mb-3\">\r\n    <div *ngFor=\"let planCardTile of planCardTiles; first as isFirstPlan; last as isLastPlan\" class=\"col px-0 plan-card-column\">\r\n      <div *ngIf=\"!hidePlanCardLabel\" class=\"p-0 plan-card-label-height\">\r\n        <vnext-widget-plan-card-label\r\n          [plan]=\"planCardTile?.plan\"\r\n          [customClass]=\"'col-7'\"\r\n          [currentPlanText]=\"currentPlanText\"\r\n          [nextYearPlanText]=\"nextYearPlanText\"\r\n          [optionOneText]=\"optionOneText\"\r\n          [optionTwoText]=\"optionTwoText\"\r\n          [displayOptionLabels]=\"displayOptionLabels\"\r\n          [disableNextYearDisplay]=\"memberHasOptionsDefined && displayOptionLabels\"\r\n          [nonCommissionableText]=\"nonCommissionableText\"\r\n          [isNonCommissionableFlagCheckEnabled]=\"isNonCommissionableFlagCheckEnabled\"\r\n        ></vnext-widget-plan-card-label>\r\n      </div>\r\n      <div\r\n        class=\"plan-card-border d-flex flex-column flex-grow-1\"\r\n        [ngClass]=\"{\r\n          'current-plan-card Spa_Style_Accent6_Border': !hidePlanCardLabel && planCardTile?.plan.isCurrentYearPlan,\r\n          'plan-card-basic-border':\r\n            hidePlanCardLabel || (!planCardTile?.plan.isCurrentYearPlan && !extraPlanFields[planCardTile?.plan.id].displayLinkBorder),\r\n          'next-year-plan-card Spa_Style_Primary_Link_Border':\r\n            !hidePlanCardLabel && extraPlanFields[planCardTile?.plan.id].displayLinkBorder\r\n        }\"\r\n      >\r\n        <div class=\"py-2 px-3 plan-card-section\">\r\n          <vnext-plan-logo\r\n            *ngIf=\"showPlanLogo && planFacade.getPlanLogoUrl(planCardTile?.plan)\"\r\n            [alternateText]=\"planCardTile?.plan.logo2Description\"\r\n            [imageSrc]=\"planFacade.getPlanLogoUrl(planCardTile?.plan)\"\r\n            [classNames]=\"'plan-logo'\"\r\n            [planLogoSize]=\"planLogoSize\"\r\n          ></vnext-plan-logo>\r\n        </div>\r\n        <div class=\"d-flex flex-column\">\r\n          <div #planName class=\"pb-1 px-3 no-translate-block\">\r\n            <h4 class=\"Spa_Style_H4 my-0\">{{ planCardTile?.plan.planName }}</h4>\r\n          </div>\r\n          <div class=\"px-3\" *ngIf=\"showPlanYear\">\r\n            <vnext-plan-year-badge *ngIf=\"planCardTile?.plan?.planYear\" [planYear]=\"planCardTile?.plan?.planYear\"></vnext-plan-year-badge>\r\n          </div>\r\n          <div #starRating class=\"pb-2 pt-1 text-center px-3\">\r\n            <vnext-star-rating\r\n              [starRating]=\"planCardTile?.plan.planRating\"\r\n              [ratingValueDescription]=\"planCardTile?.plan.planRatingValueDescription\"\r\n              [showLowPerformanceIndicator]=\"planCardTile?.plan.isLowPerformingPlan\"\r\n            ></vnext-star-rating>\r\n          </div>\r\n          <div class=\"pb-3 text-center plan-monthly-premium px-3\">\r\n            <div class=\"Spa_Style_Paragraph\">{{ planFacade.getPremiumLabel() }}</div>\r\n            <vnext-link\r\n              [title]=\"planCardQuoteLinkText\"\r\n              (click)=\"quoteClick(planCardTile?.plan)\"\r\n              *ngIf=\"!extraPlanFields[planCardTile?.plan.id]?.hasPremium; else showPremium\"\r\n            ></vnext-link>\r\n            <ng-template #showPremium>\r\n              <div\r\n                *ngIf=\"!planFeesEnabled || !planCardTile?.plan.fees?.length; else showPremiumWithFees\"\r\n                class=\"Spa_Style_CostPremiumSmall\"\r\n              >\r\n                {{ planCardTile?.planTotalPremium | currency : 'USD' : 'symbol' : '1.2-2' }}\r\n              </div>\r\n\r\n              <ng-template #showPremiumWithFees>\r\n                <vnext-widget-plan-fees-tooltip\r\n                  class=\"ml-3\"\r\n                  [planFees]=\"planCardTile?.plan.fees\"\r\n                  [planTotalPremium]=\"planCardTile?.planTotalPremium\"\r\n                  [planFeesTooltipText]=\"planFeesTooltipText\"\r\n                  [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n                  [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n                  [tooltipPlacement]=\"isFirstPlan ? 'bottom-left' : isLastPlan ? 'bottom-right' : 'bottom-right bottom-left'\"\r\n                  [tooltipCustomClass]=\"isFirstPlan || isLastPlan ? 'inline-block-xs-layout inline-block-sm-layout' : ''\"\r\n                ></vnext-widget-plan-fees-tooltip>\r\n              </ng-template>\r\n            </ng-template>\r\n          </div>\r\n          <div class=\"pb-1 px-3\">\r\n            <button\r\n              class=\"btn Spa_Style_SecondaryButton btn-block\"\r\n              title=\"{{ viewDetailsDescriptionText }} {{ planCardTile?.plan.planName }}\"\r\n              (click)=\"viewPlanDetailsPage(planCardTile?.plan)\"\r\n            >\r\n              {{ planDetailsButtonText }}\r\n            </button>\r\n          </div>\r\n\r\n          <div *ngIf=\"extraPlanFields[planCardTile?.plan.id]?.hasPremium\" class=\"px-3 pb-3\">\r\n            <vnext-shopping-cart-button [plan]=\"planCardTile?.plan\"> </vnext-shopping-cart-button>\r\n          </div>\r\n          <div class=\"px-3 plan-card-section\">\r\n            <ng-container\r\n              *ngIf=\"\r\n                planCardTile?.plan.planType === planType.MAPD ||\r\n                planCardTile?.plan.planType === planType.MA ||\r\n                planCardTile?.plan.planType === planType.PDP\r\n              \"\r\n            >\r\n              <vnext-plan-benefits\r\n                [plan]=\"planCardTile?.plan\"\r\n                [isTileDisplay]=\"plans.length > 1\"\r\n                [planBenefits]=\"planBenefits\"\r\n                [planBenefitNoValueLabel]=\"planBenefitNoValueLabel\"\r\n                [annualCost]=\"planCardFacade.getAnnualCost$(planCardTile?.plan) | async\"\r\n              >\r\n              </vnext-plan-benefits\r\n            ></ng-container>\r\n            <ng-container *ngIf=\"planCardTile?.plan.planType === planType.MEDIGAP\">\r\n              <div class=\"Spa_Style_Paragraph col-6\">{{ planTypeText }}</div>\r\n              <div class=\"Spa_Style_H3 col-6 text-right\">{{ planCardTile?.plan.planSubType }}</div>\r\n            </ng-container>\r\n          </div>\r\n          <div class=\"pr-md-3 pr-sm-0 plan-card-section riders-section-height\">\r\n            <ng-container\r\n              *ngIf=\"\r\n                planCardFacade.showRiderSection(\r\n                  planCardTile?.plan,\r\n                  shoppingCartEnabled,\r\n                  showRidersOnPlanCards,\r\n                  showPremiumAsAnnual,\r\n                  riderDisplayMap\r\n                )\r\n              \"\r\n            >\r\n              <ng-container\r\n                *ngIf=\"\r\n                  planCardTile?.plan.planType === planType.MEDIGAP && planCardFacade.showMedSupAddOnCoverageText();\r\n                  then medSupAddOnCoverage;\r\n                  else otherCoverage\r\n                \"\r\n              >\r\n              </ng-container>\r\n              <ng-template #medSupAddOnCoverage>\r\n                <ng-template #addOnCoverageTooltip>\r\n                  <div [innerHTML]=\"addOnCoverageTooltipBody | safe : 'html'\" class=\"Spa_Style_ToolTip\" navigationAdapter></div>\r\n                </ng-template>\r\n                <p class=\"Spa_Style_Paragraph can-click\" [ngbTooltip]=\"addOnCoverageTooltip\">\r\n                  <i class=\"fas fa-plus-circle Spa_Style_InfoBarAndIconColor tooltip-icon\" aria-hidden=\"true\"></i>{{ addOnCoverageText }}\r\n                </p>\r\n              </ng-template>\r\n              <ng-template #otherCoverage>\r\n                <div class=\"plan-card-rider-margin\">\r\n                  <vnext-rider-card\r\n                    [riderCategories]=\"riderFacade.getRiderCategories(planCardTile?.plan.riders)\"\r\n                    [isTileDisplay]=\"true\"\r\n                    [Spa_Site_ShowRiderIcons]=\"Spa_Site_ShowRiderIcons\"\r\n                    [Spa_Site_Dental_Rider_Display_Text]=\"Spa_Site_Dental_Rider_Display_Text\"\r\n                    [Spa_Site_Vision_Rider_Display_Text]=\"Spa_Site_Vision_Rider_Display_Text\"\r\n                    [Spa_Site_Hearing_Rider_Display_Text]=\"Spa_Site_Hearing_Rider_Display_Text\"\r\n                    [Spa_PlanCard_DentalAddOnCoverage_Text]=\"Spa_PlanCard_DentalAddOnCoverage_Text\"\r\n                    [Spa_PlanCard_HearingAddOnCoverage_Text]=\"Spa_PlanCard_HearingAddOnCoverage_Text\"\r\n                    [Spa_PlanCard_VisionAddOnCoverage_Text]=\"Spa_PlanCard_VisionAddOnCoverage_Text\"\r\n                    [Spa_PlanCard_AddOnCoverage_Text]=\"Spa_PlanCard_AddOnCoverage_Text\"\r\n                    [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                  >\r\n                  </vnext-rider-card>\r\n                </div>\r\n              </ng-template>\r\n            </ng-container>\r\n          </div>\r\n          <div class=\"px-0 plan-card-section\" [ngSwitch]=\"planCardTile?.plan.planType\">\r\n            <div #coveragePreferences class=\"Spa_Style_Toggle_Background\">\r\n              <div *ngSwitchCase=\"planType.MAPD\">\r\n                <vnext-plan-coverage-preferences\r\n                  [pharmacyNotCoveredText]=\"planDetailsNonCoveredText\"\r\n                  [plan]=\"planCardTile?.plan\"\r\n                  [prescriptionsText]=\"prescriptionText\"\r\n                  [pharmacyText]=\"pharmacyText\"\r\n                  [pharmacyCoveredText]=\"planCardFacade.getPharmacyCoverageText(planCardTile?.plan, pharmacyCoveredText)\"\r\n                  [addedPharmacy]=\"planCardFacade.getSelectedPharmacy$() | async\"\r\n                  [drugCoverageText]=\"\r\n                    planCardFacade.getDrugCoverageText(planCardFacade.getDrugsCount$() | async, drugCoveredText, planCardTile?.plan)\r\n                  \"\r\n                  [showDrugCoverage]=\"planCardFacade.showDrugCoverage(displayDrugsCovered, planCardFacade.getDrugsCount$() | async)\"\r\n                  [planPreferences]=\"planPreferences\"\r\n                  [isTotalEstimatedCostEnabled]=\"isTotalEstimatedCostEnabled\"\r\n                  [isRetention]=\"isRetention\"\r\n                  [isQuoting]=\"isQuoting\"\r\n                  [totalEstimatedAnnualCostText]=\"totalEstimatedAnnualCostText\"\r\n                  [totalEstimatedCostText]=\"totalEstimatedCostText\"\r\n                  [totalEstimatedCostTooltip]=\"totalEstimatedCostTooltip\"\r\n                  [isTileDisplay]=\"true\"\r\n                  [noCostAvailableText]=\"noCostAvailableText\"\r\n                  [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                  [medicineCabinet]=\"medicineCabinet\"\r\n                  [annualCost]=\"planCardFacade.getAnnualCost$(planCardTile?.plan, isMailOrderSelected) | async\"\r\n                  [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n                  [showMailOrderLabel]=\"isMailOrderSelected\"\r\n                  [inNetworkStandardText]=\"inNetworkStandardText\"\r\n                  [outOfNetworkText]=\"outOfNetworkText\"\r\n                  [viewCostTooltipHeaderText]=\"viewCostTooltipHeaderText\"\r\n                  [viewCostTooltipHeaderContent]=\"viewCostTooltipHeaderContent\"\r\n                  [mailOrderText]=\"mailOrderText\"\r\n                  [selectedProviders]=\"selectedProviders\"\r\n                  [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n                  [providerDetails]=\"providerDetails\"\r\n                  [showProviderInNetworkOnOtherLocation]=\"planCardTile?.showProviderInNetworkOnOtherLocation\"\r\n                  [providersCoveredText]=\"planCardTile?.providersCoveredText\"\r\n                  [providerPcpText]=\"planCardTile?.providerPcpText\"\r\n                  [loaderIconEnabled]=\"loaderIconEnabled\"\r\n                  [editLinkText]=\"editLinkText\"\r\n                  [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n                  [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n                  [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n                  [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n                  [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n                ></vnext-plan-coverage-preferences>\r\n              </div>\r\n              <div *ngSwitchCase=\"planType.MA\">\r\n                <vnext-plan-coverage-preferences\r\n                  [pharmacyNotCoveredText]=\"planDetailsNonCoveredText\"\r\n                  [plan]=\"planCardTile?.plan\"\r\n                  [prescriptionsText]=\"prescriptionText\"\r\n                  [pharmacyText]=\"pharmacyText\"\r\n                  [pharmacyCoveredText]=\"planCardFacade.getPharmacyCoverageText(planCardTile?.plan, pharmacyCoveredText)\"\r\n                  [addedPharmacy]=\"planCardFacade.getSelectedPharmacy$() | async\"\r\n                  [drugCoverageText]=\"\r\n                    planCardFacade.getDrugCoverageText(planCardFacade.getDrugsCount$() | async, drugCoveredText, planCardTile?.plan)\r\n                  \"\r\n                  [showDrugCoverage]=\"planCardFacade.showDrugCoverage(displayDrugsCovered, planCardFacade.getDrugsCount$() | async)\"\r\n                  [planPreferences]=\"planPreferences\"\r\n                  [isTotalEstimatedCostEnabled]=\"isTotalEstimatedCostEnabled\"\r\n                  [isRetention]=\"isRetention\"\r\n                  [isQuoting]=\"isQuoting\"\r\n                  [totalEstimatedAnnualCostText]=\"totalEstimatedAnnualCostText\"\r\n                  [medicineCabinet]=\"medicineCabinet\"\r\n                  [totalEstimatedCostText]=\"totalEstimatedCostText\"\r\n                  [totalEstimatedCostTooltip]=\"totalEstimatedCostTooltip\"\r\n                  [isTileDisplay]=\"true\"\r\n                  [noCostAvailableText]=\"noCostAvailableText\"\r\n                  [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                  [annualCost]=\"planCardFacade.getAnnualCost$(planCardTile?.plan) | async\"\r\n                  [selectedProviders]=\"selectedProviders\"\r\n                  [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n                  [providerDetails]=\"providerDetails\"\r\n                  [showProviderInNetworkOnOtherLocation]=\"planCardTile?.showProviderInNetworkOnOtherLocation\"\r\n                  [providersCoveredText]=\"planCardTile?.providersCoveredText\"\r\n                  [providerPcpText]=\"planCardTile?.providerPcpText\"\r\n                  [loaderIconEnabled]=\"loaderIconEnabled\"\r\n                  [editLinkText]=\"editLinkText\"\r\n                  [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n                  [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n                  [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n                  [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n                  [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n                ></vnext-plan-coverage-preferences>\r\n              </div>\r\n              <div *ngSwitchCase=\"planType.PDP\">\r\n                <vnext-plan-coverage-preferences\r\n                  [pharmacyNotCoveredText]=\"planDetailsNonCoveredText\"\r\n                  [plan]=\"planCardTile?.plan\"\r\n                  [prescriptionsText]=\"prescriptionText\"\r\n                  [pharmacyText]=\"pharmacyText\"\r\n                  [pharmacyCoveredText]=\"planCardFacade.getPharmacyCoverageText(planCardTile?.plan, pharmacyCoveredText)\"\r\n                  [addedPharmacy]=\"planCardFacade.getSelectedPharmacy$() | async\"\r\n                  [drugCoverageText]=\"\r\n                    planCardFacade.getDrugCoverageText(planCardFacade.getDrugsCount$() | async, drugCoveredText, planCardTile?.plan)\r\n                  \"\r\n                  [showDrugCoverage]=\"planCardFacade.showDrugCoverage(displayDrugsCovered, planCardFacade.getDrugsCount$() | async)\"\r\n                  [planPreferences]=\"planPreferences\"\r\n                  [isTotalEstimatedCostEnabled]=\"isTotalEstimatedCostEnabled\"\r\n                  [isRetention]=\"isRetention\"\r\n                  [isQuoting]=\"isQuoting\"\r\n                  [totalEstimatedAnnualCostText]=\"totalEstimatedAnnualCostText\"\r\n                  [totalEstimatedCostText]=\"totalEstimatedCostText\"\r\n                  [totalEstimatedCostTooltip]=\"totalEstimatedCostTooltip\"\r\n                  [isTileDisplay]=\"true\"\r\n                  [noCostAvailableText]=\"noCostAvailableText\"\r\n                  [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                  [annualCost]=\"planCardFacade.getAnnualCost$(planCardTile?.plan, isMailOrderSelected) | async\"\r\n                  [medicineCabinet]=\"medicineCabinet\"\r\n                  [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n                  [showMailOrderLabel]=\"isMailOrderSelected\"\r\n                  [inNetworkStandardText]=\"inNetworkStandardText\"\r\n                  [outOfNetworkText]=\"outOfNetworkText\"\r\n                  [viewCostTooltipHeaderText]=\"viewCostTooltipHeaderText\"\r\n                  [viewCostTooltipHeaderContent]=\"viewCostTooltipHeaderContent\"\r\n                  [mailOrderText]=\"mailOrderText\"\r\n                  [selectedProviders]=\"selectedProviders\"\r\n                  [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n                  [providerDetails]=\"providerDetails\"\r\n                  [loaderIconEnabled]=\"loaderIconEnabled\"\r\n                  [editLinkText]=\"editLinkText\"\r\n                  [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n                  [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n                  [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n                  [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n                  [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n                ></vnext-plan-coverage-preferences>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".plan-card-border{border-style:solid;border-width:2px}.plan-card-basic-border{border-color:var(--static-Spa_Style_Accent1)}.plan-card-column{display:flex;flex-flow:column}.plan-card-column:first-child .plan-card-border{border-bottom-left-radius:5px}.plan-card-column:last-child .plan-card-border{border-top-right-radius:5px;border-bottom-right-radius:5px}.plan-card-section{display:flex;align-items:stretch;flex-direction:column;flex-grow:1}.not-available-text{height:54px}.riders-section-height{min-height:30px}.current-plan-text,.next-year-plan-text{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.plan-card-label-height{min-height:28px;margin-bottom:-1px}.plan-card-rider-margin{margin-left:17px}\n"] }]
    }], function () { return [{ type: CartFacade }, { type: PlanFacade }, { type: RiderFacade }, { type: PlanCardFacade }, { type: i1.NavigationService }, { type: AnalyticsService }]; }, { coveragePreferences: [{
            type: ViewChildren,
            args: ['coveragePreferences']
        }], starRatings: [{
            type: ViewChildren,
            args: ['starRating']
        }], planNames: [{
            type: ViewChildren,
            args: ['planName']
        }], plans: [{
            type: Input
        }], showPlanLogo: [{
            type: Input
        }], planDetailsButtonText: [{
            type: Input
        }], planBenefitNoValueLabel: [{
            type: Input
        }], planTypeText: [{
            type: Input
        }], addOnCoverageText: [{
            type: Input
        }], addOnCoverageTooltipBody: [{
            type: Input
        }], planDetailsNonCoveredText: [{
            type: Input
        }], prescriptionText: [{
            type: Input
        }], pharmacyText: [{
            type: Input
        }], isTotalEstimatedCostEnabled: [{
            type: Input
        }], isRetention: [{
            type: Input
        }], totalEstimatedAnnualCostText: [{
            type: Input
        }], totalEstimatedCostText: [{
            type: Input
        }], totalEstimatedCostTooltip: [{
            type: Input
        }], planCardQuoteLinkText: [{
            type: Input
        }], planPreferences: [{
            type: Input
        }], planBenefits: [{
            type: Input
        }], shoppingCartEnabled: [{
            type: Input
        }], showRidersOnPlanCards: [{
            type: Input
        }], showPremiumAsAnnual: [{
            type: Input
        }], riderDisplayMap: [{
            type: Input
        }], drugCoveredText: [{
            type: Input
        }], pharmacyCoveredText: [{
            type: Input
        }], displayDrugsCovered: [{
            type: Input
        }], currentPlanText: [{
            type: Input
        }], nextYearPlanText: [{
            type: Input
        }], isQuoting: [{
            type: Input
        }], noCostAvailableText: [{
            type: Input
        }], inNetworkPreferredText: [{
            type: Input
        }], inNetworkStandardText: [{
            type: Input
        }], outOfNetworkText: [{
            type: Input
        }], isMailOrderSelected: [{
            type: Input
        }], viewCostTooltipHeaderText: [{
            type: Input
        }], viewCostTooltipHeaderContent: [{
            type: Input
        }], mailOrderText: [{
            type: Input
        }], providersInNetworkText: [{
            type: Input
        }], pcpInNetworkText: [{
            type: Input
        }], pcpOutOfNetworkText: [{
            type: Input
        }], providersNoDataText: [{
            type: Input
        }], isProviderEnabled: [{
            type: Input
        }], selectedProviders: [{
            type: Input
        }], providerDetails: [{
            type: Input
        }], Spa_Site_ShowRiderIcons: [{
            type: Input
        }], Spa_Site_Dental_Rider_Display_Text: [{
            type: Input
        }], Spa_Site_Vision_Rider_Display_Text: [{
            type: Input
        }], Spa_Site_Hearing_Rider_Display_Text: [{
            type: Input
        }], Spa_PlanCard_DentalAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_HearingAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_VisionAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_AddOnCoverage_Text: [{
            type: Input
        }], Spa_Site_MedigapPlanType_Enabled: [{
            type: Input
        }], Spa_Site_AddToCompare_Enabled: [{
            type: Input
        }], Spa_Site_PlanViewDetails_Enabled: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }], viewDetailsDescriptionText: [{
            type: Input
        }], optionOneText: [{
            type: Input
        }], optionTwoText: [{
            type: Input
        }], displayOptionLabels: [{
            type: Input
        }], nonCommissionableText: [{
            type: Input
        }], isNonCommissionableFlagCheckEnabled: [{
            type: Input
        }], hidePlanCardLabel: [{
            type: Input
        }], medicineCabinet: [{
            type: Input
        }], planCardPreferenceDetailedEnabled: [{
            type: Input
        }], planLogoSize: [{
            type: Input
        }], loaderIconEnabled: [{
            type: Input
        }], editLinkText: [{
            type: Input
        }], providerOneOrMoreOutOfNetworkText: [{
            type: Input
        }], providerInNetworkOnOtherLocationsTooltipText: [{
            type: Input
        }], providerShowPartialIndicatorEnabled: [{
            type: Input
        }], planFeesEnabled: [{
            type: Input
        }], planFeesTooltipText: [{
            type: Input
        }], planFeesIncludedInPremiumTooltipText: [{
            type: Input
        }], planFeesNotIncludedInPremiumTooltipText: [{
            type: Input
        }], showPlanYear: [{
            type: Input
        }], viewProvidersButtonText: [{
            type: Input
        }], viewPrescriptionsButtonText: [{
            type: Input
        }], quoteClicked: [{
            type: Output
        }], viewPlanDetails: [{
            type: Output
        }], quoteClick: [], viewPlanDetailsPage: [] }); })();

const _c0$2q = ["coveragePreferences"];
const _c1$1b = ["starRating"];
const _c2$I = ["planName"];
function PlanCardTileTwoComponent_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵelement(1, "vnext-widget-plan-card-label", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", planCardTile_r1 == null ? null : planCardTile_r1.plan)("customClass", "col-7 col-lg-5")("currentPlanText", ctx_r4.currentPlanText)("nextYearPlanText", ctx_r4.nextYearPlanText)("optionOneText", ctx_r4.optionOneText)("optionTwoText", ctx_r4.optionTwoText)("displayOptionLabels", ctx_r4.displayOptionLabels)("disableNextYearDisplay", ctx_r4.memberHasOptionsDefined && ctx_r4.displayOptionLabels)("nonCommissionableText", ctx_r4.nonCommissionableText)("isNonCommissionableFlagCheckEnabled", ctx_r4.isNonCommissionableFlagCheckEnabled);
} }
function PlanCardTileTwoComponent_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34)(1, "div", 35);
    i0.ɵɵelement(2, "vnext-plan-logo", 36);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("alternateText", planCardTile_r1 == null ? null : planCardTile_r1.plan.logo2Description)("imageSrc", ctx_r5.planFacade.getPlanLogoUrl(planCardTile_r1 == null ? null : planCardTile_r1.plan))("classNames", "plan-logo")("planLogoSize", ctx_r5.planLogoSize);
} }
function PlanCardTileTwoComponent_div_2_div_10_vnext_plan_year_badge_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-plan-year-badge", 38);
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("planYear", planCardTile_r1 == null ? null : planCardTile_r1.plan == null ? null : planCardTile_r1.plan.planYear);
} }
function PlanCardTileTwoComponent_div_2_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PlanCardTileTwoComponent_div_2_div_10_vnext_plan_year_badge_1_Template, 1, 1, "vnext-plan-year-badge", 37);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", planCardTile_r1 == null ? null : planCardTile_r1.plan == null ? null : planCardTile_r1.plan.planYear);
} }
function PlanCardTileTwoComponent_div_2_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵelement(1, "vnext-plan-benefits", 40);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", planCardTile_r1 == null ? null : planCardTile_r1.plan)("isTileDisplay", ctx_r9.plans.length > 1)("planBenefits", ctx_r9.planBenefits)("planBenefitNoValueLabel", ctx_r9.planBenefitNoValueLabel)("annualCost", i0.ɵɵpipeBind1(2, 5, ctx_r9.planCardFacade.getAnnualCost$(planCardTile_r1 == null ? null : planCardTile_r1.plan)));
} }
function PlanCardTileTwoComponent_div_2_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41)(1, "div", 42);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 43);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r10.planTypeText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(planCardTile_r1 == null ? null : planCardTile_r1.plan.planSubType);
} }
function PlanCardTileTwoComponent_div_2_vnext_link_23_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 44);
    i0.ɵɵlistener("click", function PlanCardTileTwoComponent_div_2_vnext_link_23_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r29); const planCardTile_r1 = i0.ɵɵnextContext().$implicit; const ctx_r27 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r27.quoteClick(planCardTile_r1 == null ? null : planCardTile_r1.plan)); })("keyup.enter", function PlanCardTileTwoComponent_div_2_vnext_link_23_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r29); const planCardTile_r1 = i0.ɵɵnextContext().$implicit; const ctx_r30 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r30.quoteClick(planCardTile_r1 == null ? null : planCardTile_r1.plan)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r11.planCardQuoteLinkText);
} }
function PlanCardTileTwoComponent_div_2_ng_template_24_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind4(2, 1, planCardTile_r1 == null ? null : planCardTile_r1.planTotalPremium, "USD", "symbol", "1.2-2"), " ");
} }
function PlanCardTileTwoComponent_div_2_ng_template_24_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-plan-fees-tooltip", 48);
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(2);
    const planCardTile_r1 = ctx_r36.$implicit;
    const isFirstPlan_r2 = ctx_r36.first;
    const isLastPlan_r3 = ctx_r36.last;
    const ctx_r34 = i0.ɵɵnextContext();
    i0.ɵɵproperty("planFees", planCardTile_r1 == null ? null : planCardTile_r1.plan.fees)("planTotalPremium", planCardTile_r1 == null ? null : planCardTile_r1.planTotalPremium)("planFeesTooltipText", ctx_r34.planFeesTooltipText)("planFeesIncludedInPremiumTooltipText", ctx_r34.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r34.planFeesNotIncludedInPremiumTooltipText)("tooltipPlacement", isFirstPlan_r2 ? "bottom-left" : isLastPlan_r3 ? "bottom-right" : "bottom-right bottom-left")("tooltipCustomClass", isFirstPlan_r2 || isLastPlan_r3 ? "inline-block-xs-layout inline-block-sm-layout" : "");
} }
function PlanCardTileTwoComponent_div_2_ng_template_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanCardTileTwoComponent_div_2_ng_template_24_div_0_Template, 3, 6, "div", 45);
    i0.ɵɵtemplate(1, PlanCardTileTwoComponent_div_2_ng_template_24_ng_template_1_Template, 1, 7, "ng-template", null, 46, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r33 = i0.ɵɵreference(2);
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r13.planFeesEnabled || !(planCardTile_r1 == null ? null : planCardTile_r1.plan.fees == null ? null : planCardTile_r1.plan.fees.length))("ngIfElse", _r33);
} }
function PlanCardTileTwoComponent_div_2_ng_container_29_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function PlanCardTileTwoComponent_div_2_ng_container_29_ng_template_2_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 55);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r44.addOnCoverageTooltipBody, "html"), i0.ɵɵsanitizeHtml);
} }
function PlanCardTileTwoComponent_div_2_ng_container_29_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanCardTileTwoComponent_div_2_ng_container_29_ng_template_2_ng_template_0_Template, 2, 4, "ng-template", null, 52, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(2, "p", 53);
    i0.ɵɵelement(3, "i", 54);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r43 = i0.ɵɵreference(1);
    const ctx_r40 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngbTooltip", _r43);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r40.addOnCoverageText, " ");
} }
function PlanCardTileTwoComponent_div_2_ng_container_29_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-rider-card", 56);
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r42 = i0.ɵɵnextContext();
    i0.ɵɵproperty("riderCategories", ctx_r42.riderFacade.getRiderCategories(planCardTile_r1 == null ? null : planCardTile_r1.plan.riders))("isTileDisplay", true)("Spa_Site_ShowRiderIcons", ctx_r42.Spa_Site_ShowRiderIcons)("Spa_Site_Dental_Rider_Display_Text", ctx_r42.Spa_Site_Dental_Rider_Display_Text)("Spa_Site_Vision_Rider_Display_Text", ctx_r42.Spa_Site_Vision_Rider_Display_Text)("Spa_Site_Hearing_Rider_Display_Text", ctx_r42.Spa_Site_Hearing_Rider_Display_Text)("Spa_PlanCard_DentalAddOnCoverage_Text", ctx_r42.Spa_PlanCard_DentalAddOnCoverage_Text)("Spa_PlanCard_HearingAddOnCoverage_Text", ctx_r42.Spa_PlanCard_HearingAddOnCoverage_Text)("Spa_PlanCard_VisionAddOnCoverage_Text", ctx_r42.Spa_PlanCard_VisionAddOnCoverage_Text)("Spa_PlanCard_AddOnCoverage_Text", ctx_r42.Spa_PlanCard_AddOnCoverage_Text)("Spa_Site_Tooltip_Text", ctx_r42.Spa_Site_Tooltip_Text);
} }
function PlanCardTileTwoComponent_div_2_ng_container_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanCardTileTwoComponent_div_2_ng_container_29_ng_container_1_Template, 1, 0, "ng-container", 49);
    i0.ɵɵtemplate(2, PlanCardTileTwoComponent_div_2_ng_container_29_ng_template_2_Template, 5, 2, "ng-template", null, 50, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, PlanCardTileTwoComponent_div_2_ng_container_29_ng_template_4_Template, 1, 11, "ng-template", null, 51, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r39 = i0.ɵɵreference(3);
    const _r41 = i0.ɵɵreference(5);
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (planCardTile_r1 == null ? null : planCardTile_r1.plan.planType) === ctx_r14.planType.MEDIGAP && ctx_r14.planCardFacade.showMedSupAddOnCoverageText())("ngIfThen", _r39)("ngIfElse", _r41);
} }
function PlanCardTileTwoComponent_div_2_vnext_shopping_cart_button_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-shopping-cart-button", 57);
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("plan", planCardTile_r1 == null ? null : planCardTile_r1.plan);
} }
function PlanCardTileTwoComponent_div_2_div_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-coverage-preferences", 58);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r17 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pharmacyNotCoveredText", ctx_r17.planDetailsNonCoveredText)("plan", planCardTile_r1 == null ? null : planCardTile_r1.plan)("prescriptionsText", ctx_r17.prescriptionText)("pharmacyText", ctx_r17.pharmacyText)("pharmacyCoveredText", ctx_r17.planCardFacade.getPharmacyCoverageText(planCardTile_r1 == null ? null : planCardTile_r1.plan, ctx_r17.pharmacyCoveredText))("addedPharmacy", i0.ɵɵpipeBind1(2, 40, ctx_r17.planCardFacade.getSelectedPharmacy$()))("drugCoverageText", ctx_r17.planCardFacade.getDrugCoverageText(i0.ɵɵpipeBind1(3, 42, ctx_r17.planCardFacade.getDrugsCount$()), ctx_r17.drugCoveredText, planCardTile_r1 == null ? null : planCardTile_r1.plan))("showDrugCoverage", ctx_r17.planCardFacade.showDrugCoverage(ctx_r17.displayDrugsCovered, i0.ɵɵpipeBind1(4, 44, ctx_r17.planCardFacade.getDrugsCount$())))("planPreferences", ctx_r17.planPreferences)("isTotalEstimatedCostEnabled", ctx_r17.isTotalEstimatedCostEnabled)("isRetention", ctx_r17.isRetention)("isQuoting", ctx_r17.isQuoting)("totalEstimatedAnnualCostText", ctx_r17.totalEstimatedAnnualCostText)("totalEstimatedCostText", ctx_r17.totalEstimatedCostText)("totalEstimatedCostTooltip", ctx_r17.totalEstimatedCostTooltip)("compareTwoPlans", true)("noCostAvailableText", ctx_r17.noCostAvailableText)("Spa_Site_Tooltip_Text", ctx_r17.Spa_Site_Tooltip_Text)("annualCost", i0.ɵɵpipeBind1(5, 46, ctx_r17.planCardFacade.getAnnualCost$(planCardTile_r1 == null ? null : planCardTile_r1.plan, ctx_r17.isMailOrderSelected)))("inNetworkPreferredText", ctx_r17.inNetworkPreferredText)("inNetworkStandardText", ctx_r17.inNetworkStandardText)("outOfNetworkText", ctx_r17.outOfNetworkText)("showMailOrderLabel", ctx_r17.isMailOrderSelected)("viewCostTooltipHeaderText", ctx_r17.viewCostTooltipHeaderText)("viewCostTooltipHeaderContent", ctx_r17.viewCostTooltipHeaderContent)("mailOrderText", ctx_r17.mailOrderText)("medicineCabinet", ctx_r17.medicineCabinet)("selectedProviders", ctx_r17.selectedProviders)("planCardPreferenceDetailedEnabled", ctx_r17.planCardPreferenceDetailedEnabled)("providerDetails", ctx_r17.providerDetails)("showProviderInNetworkOnOtherLocation", planCardTile_r1 == null ? null : planCardTile_r1.showProviderInNetworkOnOtherLocation)("providersCoveredText", planCardTile_r1 == null ? null : planCardTile_r1.providersCoveredText)("providerPcpText", planCardTile_r1 == null ? null : planCardTile_r1.providerPcpText)("loaderIconEnabled", ctx_r17.loaderIconEnabled)("editLinkText", ctx_r17.editLinkText)("providerOneOrMoreOutOfNetworkText", ctx_r17.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r17.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r17.providerShowPartialIndicatorEnabled)("viewProvidersButtonText", ctx_r17.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r17.viewPrescriptionsButtonText);
} }
function PlanCardTileTwoComponent_div_2_div_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-coverage-preferences", 59);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pharmacyNotCoveredText", ctx_r18.planDetailsNonCoveredText)("plan", planCardTile_r1 == null ? null : planCardTile_r1.plan)("prescriptionsText", ctx_r18.prescriptionText)("pharmacyText", ctx_r18.pharmacyText)("pharmacyCoveredText", ctx_r18.planCardFacade.getPharmacyCoverageText(planCardTile_r1 == null ? null : planCardTile_r1.plan, ctx_r18.pharmacyCoveredText))("addedPharmacy", i0.ɵɵpipeBind1(2, 33, ctx_r18.planCardFacade.getSelectedPharmacy$()))("drugCoverageText", ctx_r18.planCardFacade.getDrugCoverageText(i0.ɵɵpipeBind1(3, 35, ctx_r18.planCardFacade.getDrugsCount$()), ctx_r18.drugCoveredText, planCardTile_r1 == null ? null : planCardTile_r1.plan))("showDrugCoverage", ctx_r18.planCardFacade.showDrugCoverage(ctx_r18.displayDrugsCovered, i0.ɵɵpipeBind1(4, 37, ctx_r18.planCardFacade.getDrugsCount$())))("planPreferences", ctx_r18.planPreferences)("isTotalEstimatedCostEnabled", ctx_r18.isTotalEstimatedCostEnabled)("isRetention", ctx_r18.isRetention)("isQuoting", ctx_r18.isQuoting)("totalEstimatedAnnualCostText", ctx_r18.totalEstimatedAnnualCostText)("totalEstimatedCostText", ctx_r18.totalEstimatedCostText)("totalEstimatedCostTooltip", ctx_r18.totalEstimatedCostTooltip)("medicineCabinet", ctx_r18.medicineCabinet)("compareTwoPlans", true)("noCostAvailableText", ctx_r18.noCostAvailableText)("Spa_Site_Tooltip_Text", ctx_r18.Spa_Site_Tooltip_Text)("annualCost", i0.ɵɵpipeBind1(5, 39, ctx_r18.planCardFacade.getAnnualCost$(planCardTile_r1 == null ? null : planCardTile_r1.plan)))("selectedProviders", ctx_r18.selectedProviders)("planCardPreferenceDetailedEnabled", ctx_r18.planCardPreferenceDetailedEnabled)("providerDetails", ctx_r18.providerDetails)("showProviderInNetworkOnOtherLocation", planCardTile_r1 == null ? null : planCardTile_r1.showProviderInNetworkOnOtherLocation)("providersCoveredText", planCardTile_r1 == null ? null : planCardTile_r1.providersCoveredText)("providerPcpText", planCardTile_r1 == null ? null : planCardTile_r1.providerPcpText)("loaderIconEnabled", ctx_r18.loaderIconEnabled)("editLinkText", ctx_r18.editLinkText)("providerOneOrMoreOutOfNetworkText", ctx_r18.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r18.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r18.providerShowPartialIndicatorEnabled)("viewProvidersButtonText", ctx_r18.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r18.viewPrescriptionsButtonText);
} }
function PlanCardTileTwoComponent_div_2_div_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-coverage-preferences", 60);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const planCardTile_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r19 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pharmacyNotCoveredText", ctx_r19.planDetailsNonCoveredText)("plan", planCardTile_r1 == null ? null : planCardTile_r1.plan)("prescriptionsText", ctx_r19.prescriptionText)("pharmacyText", ctx_r19.pharmacyText)("pharmacyCoveredText", ctx_r19.planCardFacade.getPharmacyCoverageText(planCardTile_r1 == null ? null : planCardTile_r1.plan, ctx_r19.pharmacyCoveredText))("addedPharmacy", i0.ɵɵpipeBind1(2, 37, ctx_r19.planCardFacade.getSelectedPharmacy$()))("drugCoverageText", ctx_r19.planCardFacade.getDrugCoverageText(i0.ɵɵpipeBind1(3, 39, ctx_r19.planCardFacade.getDrugsCount$()), ctx_r19.drugCoveredText, planCardTile_r1 == null ? null : planCardTile_r1.plan))("showDrugCoverage", ctx_r19.planCardFacade.showDrugCoverage(ctx_r19.displayDrugsCovered, i0.ɵɵpipeBind1(4, 41, ctx_r19.planCardFacade.getDrugsCount$())))("planPreferences", ctx_r19.planPreferences)("isTotalEstimatedCostEnabled", ctx_r19.isTotalEstimatedCostEnabled)("isRetention", ctx_r19.isRetention)("isQuoting", ctx_r19.isQuoting)("totalEstimatedAnnualCostText", ctx_r19.totalEstimatedAnnualCostText)("totalEstimatedCostText", ctx_r19.totalEstimatedCostText)("totalEstimatedCostTooltip", ctx_r19.totalEstimatedCostTooltip)("compareTwoPlans", true)("noCostAvailableText", ctx_r19.noCostAvailableText)("Spa_Site_Tooltip_Text", ctx_r19.Spa_Site_Tooltip_Text)("annualCost", i0.ɵɵpipeBind1(5, 43, ctx_r19.planCardFacade.getAnnualCost$(planCardTile_r1 == null ? null : planCardTile_r1.plan, ctx_r19.isMailOrderSelected)))("inNetworkPreferredText", ctx_r19.inNetworkPreferredText)("inNetworkStandardText", ctx_r19.inNetworkStandardText)("medicineCabinet", ctx_r19.medicineCabinet)("outOfNetworkText", ctx_r19.outOfNetworkText)("showMailOrderLabel", ctx_r19.isMailOrderSelected)("viewCostTooltipHeaderText", ctx_r19.viewCostTooltipHeaderText)("viewCostTooltipHeaderContent", ctx_r19.viewCostTooltipHeaderContent)("mailOrderText", ctx_r19.mailOrderText)("selectedProviders", ctx_r19.selectedProviders)("planCardPreferenceDetailedEnabled", ctx_r19.planCardPreferenceDetailedEnabled)("providerDetails", ctx_r19.providerDetails)("loaderIconEnabled", ctx_r19.loaderIconEnabled)("editLinkText", ctx_r19.editLinkText)("providerOneOrMoreOutOfNetworkText", ctx_r19.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r19.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r19.providerShowPartialIndicatorEnabled)("viewProvidersButtonText", ctx_r19.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r19.viewPrescriptionsButtonText);
} }
const _c3$r = function (a0, a1, a2) { return { "current-plan-card Spa_Style_Accent6_Border": a0, "plan-card-basic-border": a1, "next-year-plan-card Spa_Style_Primary_Link_Border": a2 }; };
function PlanCardTileTwoComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r52 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, PlanCardTileTwoComponent_div_2_div_1_Template, 2, 10, "div", 4);
    i0.ɵɵelementStart(2, "div", 5)(3, "div", 6);
    i0.ɵɵtemplate(4, PlanCardTileTwoComponent_div_2_div_4_Template, 3, 4, "div", 7);
    i0.ɵɵelementStart(5, "div", 8)(6, "div", 9, 10)(8, "h4", 11);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, PlanCardTileTwoComponent_div_2_div_10_Template, 2, 1, "div", 12);
    i0.ɵɵelementStart(11, "div", 13, 14);
    i0.ɵɵelement(13, "vnext-star-rating", 15);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(14, "div", 16)(15, "div", 17)(16, "div", 18);
    i0.ɵɵtemplate(17, PlanCardTileTwoComponent_div_2_div_17_Template, 3, 7, "div", 19);
    i0.ɵɵtemplate(18, PlanCardTileTwoComponent_div_2_div_18_Template, 5, 2, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 21)(20, "div", 22)(21, "div", 23);
    i0.ɵɵtext(22);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(23, PlanCardTileTwoComponent_div_2_vnext_link_23_Template, 1, 1, "vnext-link", 24);
    i0.ɵɵtemplate(24, PlanCardTileTwoComponent_div_2_ng_template_24_Template, 3, 2, "ng-template", null, 25, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(26, "div", 16)(27, "div", 17)(28, "div", 26);
    i0.ɵɵtemplate(29, PlanCardTileTwoComponent_div_2_ng_container_29_Template, 6, 3, "ng-container", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 26)(31, "button", 27);
    i0.ɵɵlistener("click", function PlanCardTileTwoComponent_div_2_Template_button_click_31_listener() { const restoredCtx = i0.ɵɵrestoreView(_r52); const planCardTile_r1 = restoredCtx.$implicit; const ctx_r51 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r51.viewPlanDetailsPage(planCardTile_r1 == null ? null : planCardTile_r1.plan)); });
    i0.ɵɵtext(32);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(33, PlanCardTileTwoComponent_div_2_vnext_shopping_cart_button_33_Template, 1, 1, "vnext-shopping-cart-button", 28);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(34, "div", 29, 30);
    i0.ɵɵtemplate(36, PlanCardTileTwoComponent_div_2_div_36_Template, 6, 48, "div", 31);
    i0.ɵɵtemplate(37, PlanCardTileTwoComponent_div_2_div_37_Template, 6, 41, "div", 31);
    i0.ɵɵtemplate(38, PlanCardTileTwoComponent_div_2_div_38_Template, 6, 45, "div", 31);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const planCardTile_r1 = ctx.$implicit;
    const _r12 = i0.ɵɵreference(25);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.hidePlanCardLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(23, _c3$r, !ctx_r0.hidePlanCardLabel && (planCardTile_r1 == null ? null : planCardTile_r1.plan.isCurrentYearPlan), ctx_r0.hidePlanCardLabel || !(planCardTile_r1 == null ? null : planCardTile_r1.plan.isCurrentYearPlan) && !ctx_r0.extraPlanFields[planCardTile_r1 == null ? null : planCardTile_r1.plan.id].displayLinkBorder, !ctx_r0.hidePlanCardLabel && ctx_r0.extraPlanFields[planCardTile_r1 == null ? null : planCardTile_r1.plan.id].displayLinkBorder));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showPlanLogo && ctx_r0.planFacade.getPlanLogoUrl(planCardTile_r1 == null ? null : planCardTile_r1.plan));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(planCardTile_r1 == null ? null : planCardTile_r1.plan.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showPlanYear);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("starRating", planCardTile_r1 == null ? null : planCardTile_r1.plan.planRating)("ratingValueDescription", planCardTile_r1 == null ? null : planCardTile_r1.plan.planRatingValueDescription)("showLowPerformanceIndicator", planCardTile_r1 == null ? null : planCardTile_r1.plan.isLowPerformingPlan);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", (planCardTile_r1 == null ? null : planCardTile_r1.plan.planType) === ctx_r0.planType.MAPD || (planCardTile_r1 == null ? null : planCardTile_r1.plan.planType) === ctx_r0.planType.MA || (planCardTile_r1 == null ? null : planCardTile_r1.plan.planType) === ctx_r0.planType.PDP);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (planCardTile_r1 == null ? null : planCardTile_r1.plan.planType) === ctx_r0.planType.MEDIGAP);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.planFacade.getPremiumLabel());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(ctx_r0.extraPlanFields[planCardTile_r1 == null ? null : planCardTile_r1.plan.id] == null ? null : ctx_r0.extraPlanFields[planCardTile_r1 == null ? null : planCardTile_r1.plan.id].hasPremium))("ngIfElse", _r12);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r0.planCardFacade.showRiderSection(planCardTile_r1 == null ? null : planCardTile_r1.plan, ctx_r0.shoppingCartEnabled, ctx_r0.showRidersOnPlanCards, ctx_r0.showPremiumAsAnnual, ctx_r0.riderDisplayMap));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate2("title", "", planCardTile_r1 == null ? null : planCardTile_r1.plan.planName, ": ", ctx_r0.viewDetailsDescriptionText, "");
    i0.ɵɵattribute("aria-label", (planCardTile_r1 == null ? null : planCardTile_r1.plan.planName) + ": " + ctx_r0.viewDetailsDescriptionText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.planDetailsButtonText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.extraPlanFields[planCardTile_r1 == null ? null : planCardTile_r1.plan.id] == null ? null : ctx_r0.extraPlanFields[planCardTile_r1 == null ? null : planCardTile_r1.plan.id].hasPremium);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", planCardTile_r1 == null ? null : planCardTile_r1.plan.planType);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.planType.MAPD);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.planType.MA);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.planType.PDP);
} }
class PlanCardTileTwoComponent {
    constructor(planFacade, riderFacade, planCardFacade) {
        this.planFacade = planFacade;
        this.riderFacade = riderFacade;
        this.planCardFacade = planCardFacade;
        this.isNonCommissionableFlagCheckEnabled = false;
        this.showPlanYear = false;
        this.quoteClicked = new EventEmitter();
        this.viewPlanDetails = new EventEmitter();
        this.maxPlanLogoHeight = 0;
        this.maxPlanNameHeight = 0;
        this.maxPlanRatingsHeight = 0;
        this.planType = PlanType;
        this.extraPlanFields = {};
        this.memberHasOptionsDefined = false;
        this.planCardTiles = [];
    }
    ngOnChanges(changes) {
        const oldPlans = changes.plans?.previousValue;
        const newPlans = changes.plans?.currentValue;
        if (!_isEqual(oldPlans, newPlans)) {
            this.memberHasOptionsDefined = this.planFacade.memberHasOptionsDefined();
            if (newPlans?.length) {
                this.extraPlanFields = {};
                newPlans.forEach(plan => {
                    this.planFacade
                        .hasPremium$(plan)
                        .pipe(take(1))
                        .subscribe(hasPremium => {
                        this.extraPlanFields[plan.id] = {
                            displayLinkBorder: this.planFacade.canDisplayLinkBorder(plan, this.displayOptionLabels),
                            hasPremium
                        };
                    });
                });
            }
        }
        const { plans, selectedProviders, providerDetails, providersInNetworkText, providersNoDataText, pcpInNetworkText, pcpOutOfNetworkText } = changes;
        if ((plans && !_isEqual(plans.previousValue, plans.currentValue)) ||
            (selectedProviders && !_isEqual(selectedProviders.previousValue, selectedProviders.currentValue)) ||
            (providerDetails && !_isEqual(providerDetails.previousValue, providerDetails.currentValue)) ||
            (providersInNetworkText && providersInNetworkText.previousValue !== providersInNetworkText.currentValue) ||
            (providersNoDataText && providersNoDataText.previousValue !== providersNoDataText.currentValue) ||
            (pcpInNetworkText && pcpInNetworkText.previousValue !== pcpInNetworkText.currentValue) ||
            (pcpOutOfNetworkText && pcpOutOfNetworkText.previousValue !== pcpOutOfNetworkText.currentValue)) {
            if (this.plans) {
                this.planCardTiles = this.plans.map(plan => {
                    const canSellPlan = this.planFacade.canSellPlan(plan);
                    return {
                        plan,
                        planTotalPremium: this.planFacade.getTotalPremium([plan]),
                        showProviderInNetworkOnOtherLocation: this.planCardFacade.getIsProviderInNetworkOnOtherLocation(plan.id, this.selectedProviders, this.providerDetails, plan.showProviderSearch, canSellPlan),
                        providersCoveredText: this.planCardFacade.getProviderCoveredText(plan.id, this.selectedProviders, this.providerDetails, this.providersInNetworkText, this.providersNoDataText, '', plan.showProviderSearch, canSellPlan),
                        providerPcpText: this.planCardFacade.getProviderPcpText(plan.id, this.selectedProviders, this.providerDetails, this.pcpInNetworkText, this.pcpOutOfNetworkText, plan.showProviderSearch, canSellPlan)
                    };
                });
            }
        }
    }
    ngAfterViewChecked() {
        this.maxPlanNameHeight = this.planCardFacade.calculateMaxSectionHeight(this.planNames, this.maxPlanNameHeight);
        this.maxPlanRatingsHeight = this.planCardFacade.calculateMaxSectionHeight(this.starRatings, this.maxPlanRatingsHeight);
        this.planCardFacade.setPrefHeight(this.coveragePreferences, 'preference-element');
    }
    quoteClick(plan) {
        this.planFacade.tagsToUpdate(DataLayerEvent.CLICK_PLANS_GET_QUOTE, plan.id, plan.planTypeAbbreviation, null, this.planFacade.isVbcAgreementExists(plan));
        this.quoteClicked.emit();
    }
    viewPlanDetailsPage(plan) {
        this.viewPlanDetails.emit(plan);
    }
}
PlanCardTileTwoComponent.ɵfac = function PlanCardTileTwoComponent_Factory(t) { return new (t || PlanCardTileTwoComponent)(i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(RiderFacade), i0.ɵɵdirectiveInject(PlanCardFacade)); };
PlanCardTileTwoComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCardTileTwoComponent, selectors: [["vnext-plan-card-two-tiles"]], viewQuery: function PlanCardTileTwoComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$2q, 5);
        i0.ɵɵviewQuery(_c1$1b, 5);
        i0.ɵɵviewQuery(_c2$I, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.coveragePreferences = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.starRatings = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.planNames = _t);
    } }, inputs: { plans: "plans", showPlanLogo: "showPlanLogo", planDetailsButtonText: "planDetailsButtonText", planBenefitNoValueLabel: "planBenefitNoValueLabel", planTypeText: "planTypeText", addOnCoverageText: "addOnCoverageText", addOnCoverageTooltipBody: "addOnCoverageTooltipBody", planDetailsNonCoveredText: "planDetailsNonCoveredText", prescriptionText: "prescriptionText", pharmacyText: "pharmacyText", isTotalEstimatedCostEnabled: "isTotalEstimatedCostEnabled", isRetention: "isRetention", totalEstimatedAnnualCostText: "totalEstimatedAnnualCostText", totalEstimatedCostText: "totalEstimatedCostText", totalEstimatedCostTooltip: "totalEstimatedCostTooltip", planCardQuoteLinkText: "planCardQuoteLinkText", planPreferences: "planPreferences", planBenefits: "planBenefits", shoppingCartEnabled: "shoppingCartEnabled", showRidersOnPlanCards: "showRidersOnPlanCards", showPremiumAsAnnual: "showPremiumAsAnnual", riderDisplayMap: "riderDisplayMap", drugCoveredText: "drugCoveredText", pharmacyCoveredText: "pharmacyCoveredText", displayDrugsCovered: "displayDrugsCovered", customClass: "customClass", currentPlanText: "currentPlanText", nextYearPlanText: "nextYearPlanText", isQuoting: "isQuoting", noCostAvailableText: "noCostAvailableText", inNetworkPreferredText: "inNetworkPreferredText", inNetworkStandardText: "inNetworkStandardText", outOfNetworkText: "outOfNetworkText", isMailOrderSelected: "isMailOrderSelected", viewCostTooltipHeaderText: "viewCostTooltipHeaderText", viewCostTooltipHeaderContent: "viewCostTooltipHeaderContent", mailOrderText: "mailOrderText", providersInNetworkText: "providersInNetworkText", pcpInNetworkText: "pcpInNetworkText", pcpOutOfNetworkText: "pcpOutOfNetworkText", providersNoDataText: "providersNoDataText", isProviderEnabled: "isProviderEnabled", selectedProviders: "selectedProviders", providerDetails: "providerDetails", Spa_Site_ShowRiderIcons: "Spa_Site_ShowRiderIcons", Spa_Site_Dental_Rider_Display_Text: "Spa_Site_Dental_Rider_Display_Text", Spa_Site_Vision_Rider_Display_Text: "Spa_Site_Vision_Rider_Display_Text", Spa_Site_Hearing_Rider_Display_Text: "Spa_Site_Hearing_Rider_Display_Text", Spa_PlanCard_DentalAddOnCoverage_Text: "Spa_PlanCard_DentalAddOnCoverage_Text", Spa_PlanCard_HearingAddOnCoverage_Text: "Spa_PlanCard_HearingAddOnCoverage_Text", Spa_PlanCard_VisionAddOnCoverage_Text: "Spa_PlanCard_VisionAddOnCoverage_Text", Spa_PlanCard_AddOnCoverage_Text: "Spa_PlanCard_AddOnCoverage_Text", Spa_Site_MedigapPlanType_Enabled: "Spa_Site_MedigapPlanType_Enabled", Spa_Site_AddToCompare_Enabled: "Spa_Site_AddToCompare_Enabled", Spa_Site_PlanViewDetails_Enabled: "Spa_Site_PlanViewDetails_Enabled", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text", viewDetailsDescriptionText: "viewDetailsDescriptionText", optionOneText: "optionOneText", optionTwoText: "optionTwoText", displayOptionLabels: "displayOptionLabels", nonCommissionableText: "nonCommissionableText", isNonCommissionableFlagCheckEnabled: "isNonCommissionableFlagCheckEnabled", hidePlanCardLabel: "hidePlanCardLabel", medicineCabinet: "medicineCabinet", planCardPreferenceDetailedEnabled: "planCardPreferenceDetailedEnabled", planLogoSize: "planLogoSize", loaderIconEnabled: "loaderIconEnabled", editLinkText: "editLinkText", providerOneOrMoreOutOfNetworkText: "providerOneOrMoreOutOfNetworkText", providerInNetworkOnOtherLocationsTooltipText: "providerInNetworkOnOtherLocationsTooltipText", providerShowPartialIndicatorEnabled: "providerShowPartialIndicatorEnabled", planFeesEnabled: "planFeesEnabled", planFeesTooltipText: "planFeesTooltipText", planFeesIncludedInPremiumTooltipText: "planFeesIncludedInPremiumTooltipText", planFeesNotIncludedInPremiumTooltipText: "planFeesNotIncludedInPremiumTooltipText", showPlanYear: "showPlanYear", viewProvidersButtonText: "viewProvidersButtonText", viewPrescriptionsButtonText: "viewPrescriptionsButtonText" }, outputs: { quoteClicked: "quoteClicked", viewPlanDetails: "viewPlanDetails" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 1, consts: [[1, "container"], [1, "row", "plan-card", "mb-3"], ["class", "col px-0 plan-card-column", 4, "ngFor", "ngForOf"], [1, "col", "px-0", "plan-card-column"], ["class", "p-0 plan-card-label-height", 4, "ngIf"], [1, "plan-card-border", "plan-card-section", 3, "ngClass"], [1, "row", "px-3", "pt-3"], ["class", "col-4 pb-2", 4, "ngIf"], [1, "col-12"], [1, "no-translate-block"], ["planName", ""], [1, "Spa_Style_H4", "my-0"], [4, "ngIf"], [1, "star-rating-container"], ["starRating", ""], [3, "starRating", "ratingValueDescription", "showLowPerformanceIndicator"], [1, "px-3"], [1, "row"], [1, "col-12", "col-sm-7", "col-md-8"], ["class", "plan-benefits", 4, "ngIf"], ["class", "row pt-2 plan-benefits", 4, "ngIf"], [1, "col-sm-5", "col-md-4", "text-center", "mb-4"], [1, "monthly-premium-container"], [1, "Spa_Style_Paragraph"], [3, "title", "click", "keyup.enter", 4, "ngIf", "ngIfElse"], ["showPremium", ""], [1, "col-4"], [1, "btn", "Spa_Style_SecondaryButton", "btn-block", "px-1", 3, "title", "click"], ["class", "col-4 px-3 pb-3", 3, "plan", 4, "ngIf"], [1, "plan-card-bottom-border", "px-0", "Spa_Style_Toggle_Background", 3, "ngSwitch"], ["coveragePreferences", ""], [4, "ngSwitchCase"], [1, "p-0", "plan-card-label-height"], [3, "plan", "customClass", "currentPlanText", "nextYearPlanText", "optionOneText", "optionTwoText", "displayOptionLabels", "disableNextYearDisplay", "nonCommissionableText", "isNonCommissionableFlagCheckEnabled"], [1, "col-4", "pb-2"], [1, "image-responsive"], [3, "alternateText", "imageSrc", "classNames", "planLogoSize"], [3, "planYear", 4, "ngIf"], [3, "planYear"], [1, "plan-benefits"], [3, "plan", "isTileDisplay", "planBenefits", "planBenefitNoValueLabel", "annualCost"], [1, "row", "pt-2", "plan-benefits"], [1, "Spa_Style_Paragraph", "col-6"], [1, "Spa_Style_H3", "col-6", "text-right"], [3, "title", "click", "keyup.enter"], ["class", "Spa_Style_CostPremiumSmall", 4, "ngIf", "ngIfElse"], ["showPremiumWithFees", ""], [1, "Spa_Style_CostPremiumSmall"], [1, "ml-3", 3, "planFees", "planTotalPremium", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "tooltipPlacement", "tooltipCustomClass"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["medSupAddOnCoverage", ""], ["otherCoverage", ""], ["addOnCoverageTooltip", ""], [1, "Spa_Style_Paragraph", "can-click", 3, "ngbTooltip"], ["aria-hidden", "true", 1, "fas", "fa-plus-circle", "Spa_Style_InfoBarAndIconColor", "tooltip-icon"], ["navigationAdapter", "", 1, "Spa_Style_ToolTip", 3, "innerHTML"], [3, "riderCategories", "isTileDisplay", "Spa_Site_ShowRiderIcons", "Spa_Site_Dental_Rider_Display_Text", "Spa_Site_Vision_Rider_Display_Text", "Spa_Site_Hearing_Rider_Display_Text", "Spa_PlanCard_DentalAddOnCoverage_Text", "Spa_PlanCard_HearingAddOnCoverage_Text", "Spa_PlanCard_VisionAddOnCoverage_Text", "Spa_PlanCard_AddOnCoverage_Text", "Spa_Site_Tooltip_Text"], [1, "col-4", "px-3", "pb-3", 3, "plan"], [3, "pharmacyNotCoveredText", "plan", "prescriptionsText", "pharmacyText", "pharmacyCoveredText", "addedPharmacy", "drugCoverageText", "showDrugCoverage", "planPreferences", "isTotalEstimatedCostEnabled", "isRetention", "isQuoting", "totalEstimatedAnnualCostText", "totalEstimatedCostText", "totalEstimatedCostTooltip", "compareTwoPlans", "noCostAvailableText", "Spa_Site_Tooltip_Text", "annualCost", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "showMailOrderLabel", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "mailOrderText", "medicineCabinet", "selectedProviders", "planCardPreferenceDetailedEnabled", "providerDetails", "showProviderInNetworkOnOtherLocation", "providersCoveredText", "providerPcpText", "loaderIconEnabled", "editLinkText", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "viewProvidersButtonText", "viewPrescriptionsButtonText"], [3, "pharmacyNotCoveredText", "plan", "prescriptionsText", "pharmacyText", "pharmacyCoveredText", "addedPharmacy", "drugCoverageText", "showDrugCoverage", "planPreferences", "isTotalEstimatedCostEnabled", "isRetention", "isQuoting", "totalEstimatedAnnualCostText", "totalEstimatedCostText", "totalEstimatedCostTooltip", "medicineCabinet", "compareTwoPlans", "noCostAvailableText", "Spa_Site_Tooltip_Text", "annualCost", "selectedProviders", "planCardPreferenceDetailedEnabled", "providerDetails", "showProviderInNetworkOnOtherLocation", "providersCoveredText", "providerPcpText", "loaderIconEnabled", "editLinkText", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "viewProvidersButtonText", "viewPrescriptionsButtonText"], [3, "pharmacyNotCoveredText", "plan", "prescriptionsText", "pharmacyText", "pharmacyCoveredText", "addedPharmacy", "drugCoverageText", "showDrugCoverage", "planPreferences", "isTotalEstimatedCostEnabled", "isRetention", "isQuoting", "totalEstimatedAnnualCostText", "totalEstimatedCostText", "totalEstimatedCostTooltip", "compareTwoPlans", "noCostAvailableText", "Spa_Site_Tooltip_Text", "annualCost", "inNetworkPreferredText", "inNetworkStandardText", "medicineCabinet", "outOfNetworkText", "showMailOrderLabel", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "mailOrderText", "selectedProviders", "planCardPreferenceDetailedEnabled", "providerDetails", "loaderIconEnabled", "editLinkText", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "viewProvidersButtonText", "viewPrescriptionsButtonText"]], template: function PlanCardTileTwoComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, PlanCardTileTwoComponent_div_2_Template, 39, 27, "div", 2);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.planCardTiles);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, LinkComponent, PlanYearBadgeComponent, NavigationAdapterDirective, IconAriaAttributesDirective, i1$1.NgbTooltip, RiderCardComponent, StarRatingComponent, ShoppingCartButtonComponent, PlanBenefitsComponent, PlanFeesTooltipComponent, PlanCoveragePreferencesComponent, PlanCardLabelComponent, PlanLogoComponent, i1$2.AsyncPipe, i1$2.CurrencyPipe, SafePipe], styles: [".plan-card-border[_ngcontent-%COMP%]{border-style:solid;border-width:2px}.plan-card-basic-border[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent1)}.plan-card-column[_ngcontent-%COMP%]:first-child   .plan-card-border[_ngcontent-%COMP%]{border-bottom-left-radius:5px}.plan-card-column[_ngcontent-%COMP%]:last-child   .plan-card-border[_ngcontent-%COMP%]{border-top-right-radius:5px;border-bottom-right-radius:5px}.current-plan-text[_ngcontent-%COMP%], .next-year-plan-text[_ngcontent-%COMP%]{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.plan-card-column[_ngcontent-%COMP%]{display:flex;flex-flow:column}.plan-card-section[_ngcontent-%COMP%]{display:flex;align-items:stretch;flex-direction:column;justify-content:end;flex-grow:1}.plan-card-label-height[_ngcontent-%COMP%]{min-height:28px;border-left:none}.star-rating-container[_ngcontent-%COMP%]{min-height:50px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCardTileTwoComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-card-two-tiles', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container\">\r\n  <div class=\"row plan-card mb-3\">\r\n    <div *ngFor=\"let planCardTile of planCardTiles; first as isFirstPlan; last as isLastPlan\" class=\"col px-0 plan-card-column\">\r\n      <div *ngIf=\"!hidePlanCardLabel\" class=\"p-0 plan-card-label-height\">\r\n        <vnext-widget-plan-card-label\r\n          [plan]=\"planCardTile?.plan\"\r\n          [customClass]=\"'col-7 col-lg-5'\"\r\n          [currentPlanText]=\"currentPlanText\"\r\n          [nextYearPlanText]=\"nextYearPlanText\"\r\n          [optionOneText]=\"optionOneText\"\r\n          [optionTwoText]=\"optionTwoText\"\r\n          [displayOptionLabels]=\"displayOptionLabels\"\r\n          [disableNextYearDisplay]=\"memberHasOptionsDefined && displayOptionLabels\"\r\n          [nonCommissionableText]=\"nonCommissionableText\"\r\n          [isNonCommissionableFlagCheckEnabled]=\"isNonCommissionableFlagCheckEnabled\"\r\n        ></vnext-widget-plan-card-label>\r\n      </div>\r\n      <div\r\n        class=\"plan-card-border plan-card-section\"\r\n        [ngClass]=\"{\r\n          'current-plan-card Spa_Style_Accent6_Border': !hidePlanCardLabel && planCardTile?.plan.isCurrentYearPlan,\r\n          'plan-card-basic-border':\r\n            hidePlanCardLabel || (!planCardTile?.plan.isCurrentYearPlan && !extraPlanFields[planCardTile?.plan.id].displayLinkBorder),\r\n          'next-year-plan-card Spa_Style_Primary_Link_Border':\r\n            !hidePlanCardLabel && extraPlanFields[planCardTile?.plan.id].displayLinkBorder\r\n        }\"\r\n      >\r\n        <div class=\"row px-3 pt-3\">\r\n          <div class=\"col-4 pb-2\" *ngIf=\"showPlanLogo && planFacade.getPlanLogoUrl(planCardTile?.plan)\">\r\n            <div class=\"image-responsive\">\r\n              <vnext-plan-logo\r\n                [alternateText]=\"planCardTile?.plan.logo2Description\"\r\n                [imageSrc]=\"planFacade.getPlanLogoUrl(planCardTile?.plan)\"\r\n                [classNames]=\"'plan-logo'\"\r\n                [planLogoSize]=\"planLogoSize\"\r\n              ></vnext-plan-logo>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-12\">\r\n            <div #planName class=\"no-translate-block\">\r\n              <h4 class=\"Spa_Style_H4 my-0\">{{ planCardTile?.plan.planName }}</h4>\r\n            </div>\r\n            <div *ngIf=\"showPlanYear\">\r\n              <vnext-plan-year-badge *ngIf=\"planCardTile?.plan?.planYear\" [planYear]=\"planCardTile?.plan?.planYear\"></vnext-plan-year-badge>\r\n            </div>\r\n            <div #starRating class=\"star-rating-container\">\r\n              <vnext-star-rating\r\n                [starRating]=\"planCardTile?.plan.planRating\"\r\n                [ratingValueDescription]=\"planCardTile?.plan.planRatingValueDescription\"\r\n                [showLowPerformanceIndicator]=\"planCardTile?.plan.isLowPerformingPlan\"\r\n              ></vnext-star-rating>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"px-3\">\r\n          <div class=\"row\">\r\n            <div class=\"col-12 col-sm-7 col-md-8\">\r\n              <div\r\n                *ngIf=\"\r\n                  planCardTile?.plan.planType === planType.MAPD ||\r\n                  planCardTile?.plan.planType === planType.MA ||\r\n                  planCardTile?.plan.planType === planType.PDP\r\n                \"\r\n                class=\"plan-benefits\"\r\n              >\r\n                <vnext-plan-benefits\r\n                  [plan]=\"planCardTile?.plan\"\r\n                  [isTileDisplay]=\"plans.length > 1\"\r\n                  [planBenefits]=\"planBenefits\"\r\n                  [planBenefitNoValueLabel]=\"planBenefitNoValueLabel\"\r\n                  [annualCost]=\"planCardFacade.getAnnualCost$(planCardTile?.plan) | async\"\r\n                >\r\n                </vnext-plan-benefits>\r\n              </div>\r\n              <div *ngIf=\"planCardTile?.plan.planType === planType.MEDIGAP\" class=\"row pt-2 plan-benefits\">\r\n                <div class=\"Spa_Style_Paragraph col-6\">{{ planTypeText }}</div>\r\n                <div class=\"Spa_Style_H3 col-6 text-right\">{{ planCardTile?.plan.planSubType }}</div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-5 col-md-4 text-center mb-4\">\r\n              <div class=\"monthly-premium-container\">\r\n                <div class=\"Spa_Style_Paragraph\">{{ planFacade.getPremiumLabel() }}</div>\r\n                <vnext-link\r\n                  [title]=\"planCardQuoteLinkText\"\r\n                  (click)=\"quoteClick(planCardTile?.plan)\"\r\n                  (keyup.enter)=\"quoteClick(planCardTile?.plan)\"\r\n                  *ngIf=\"!extraPlanFields[planCardTile?.plan.id]?.hasPremium; else showPremium\"\r\n                ></vnext-link>\r\n                <ng-template #showPremium>\r\n                  <div\r\n                    *ngIf=\"!planFeesEnabled || !planCardTile?.plan.fees?.length; else showPremiumWithFees\"\r\n                    class=\"Spa_Style_CostPremiumSmall\"\r\n                  >\r\n                    {{ planCardTile?.planTotalPremium | currency : 'USD' : 'symbol' : '1.2-2' }}\r\n                  </div>\r\n\r\n                  <ng-template #showPremiumWithFees>\r\n                    <vnext-widget-plan-fees-tooltip\r\n                      class=\"ml-3\"\r\n                      [planFees]=\"planCardTile?.plan.fees\"\r\n                      [planTotalPremium]=\"planCardTile?.planTotalPremium\"\r\n                      [planFeesTooltipText]=\"planFeesTooltipText\"\r\n                      [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n                      [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n                      [tooltipPlacement]=\"isFirstPlan ? 'bottom-left' : isLastPlan ? 'bottom-right' : 'bottom-right bottom-left'\"\r\n                      [tooltipCustomClass]=\"isFirstPlan || isLastPlan ? 'inline-block-xs-layout inline-block-sm-layout' : ''\"\r\n                    ></vnext-widget-plan-fees-tooltip>\r\n                  </ng-template>\r\n                </ng-template>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"px-3\">\r\n          <div class=\"row\">\r\n            <div class=\"col-4\">\r\n              <ng-container\r\n                *ngIf=\"\r\n                  planCardFacade.showRiderSection(\r\n                    planCardTile?.plan,\r\n                    shoppingCartEnabled,\r\n                    showRidersOnPlanCards,\r\n                    showPremiumAsAnnual,\r\n                    riderDisplayMap\r\n                  )\r\n                \"\r\n              >\r\n                <ng-container\r\n                  *ngIf=\"\r\n                    planCardTile?.plan.planType === planType.MEDIGAP && planCardFacade.showMedSupAddOnCoverageText();\r\n                    then medSupAddOnCoverage;\r\n                    else otherCoverage\r\n                  \"\r\n                >\r\n                </ng-container>\r\n                <ng-template #medSupAddOnCoverage>\r\n                  <ng-template #addOnCoverageTooltip>\r\n                    <div [innerHTML]=\"addOnCoverageTooltipBody | safe : 'html'\" class=\"Spa_Style_ToolTip\" navigationAdapter></div>\r\n                  </ng-template>\r\n                  <p class=\"Spa_Style_Paragraph can-click\" [ngbTooltip]=\"addOnCoverageTooltip\">\r\n                    <i class=\"fas fa-plus-circle Spa_Style_InfoBarAndIconColor tooltip-icon\" aria-hidden=\"true\"></i>{{ addOnCoverageText }}\r\n                  </p>\r\n                </ng-template>\r\n                <ng-template #otherCoverage>\r\n                  <vnext-rider-card\r\n                    [riderCategories]=\"riderFacade.getRiderCategories(planCardTile?.plan.riders)\"\r\n                    [isTileDisplay]=\"true\"\r\n                    [Spa_Site_ShowRiderIcons]=\"Spa_Site_ShowRiderIcons\"\r\n                    [Spa_Site_Dental_Rider_Display_Text]=\"Spa_Site_Dental_Rider_Display_Text\"\r\n                    [Spa_Site_Vision_Rider_Display_Text]=\"Spa_Site_Vision_Rider_Display_Text\"\r\n                    [Spa_Site_Hearing_Rider_Display_Text]=\"Spa_Site_Hearing_Rider_Display_Text\"\r\n                    [Spa_PlanCard_DentalAddOnCoverage_Text]=\"Spa_PlanCard_DentalAddOnCoverage_Text\"\r\n                    [Spa_PlanCard_HearingAddOnCoverage_Text]=\"Spa_PlanCard_HearingAddOnCoverage_Text\"\r\n                    [Spa_PlanCard_VisionAddOnCoverage_Text]=\"Spa_PlanCard_VisionAddOnCoverage_Text\"\r\n                    [Spa_PlanCard_AddOnCoverage_Text]=\"Spa_PlanCard_AddOnCoverage_Text\"\r\n                    [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                  >\r\n                  </vnext-rider-card>\r\n                </ng-template>\r\n              </ng-container>\r\n            </div>\r\n            <div class=\"col-4\">\r\n              <button\r\n                class=\"btn Spa_Style_SecondaryButton btn-block px-1\"\r\n                title=\"{{ planCardTile?.plan.planName }}: {{ viewDetailsDescriptionText }}\"\r\n                (click)=\"viewPlanDetailsPage(planCardTile?.plan)\"\r\n                [attr.aria-label]=\"planCardTile?.plan.planName + ': ' + viewDetailsDescriptionText\"\r\n              >\r\n                {{ planDetailsButtonText }}\r\n              </button>\r\n            </div>\r\n            <vnext-shopping-cart-button\r\n              class=\"col-4 px-3 pb-3\"\r\n              *ngIf=\"extraPlanFields[planCardTile?.plan.id]?.hasPremium\"\r\n              [plan]=\"planCardTile?.plan\"\r\n            >\r\n            </vnext-shopping-cart-button>\r\n          </div>\r\n        </div>\r\n        <div #coveragePreferences class=\"plan-card-bottom-border px-0 Spa_Style_Toggle_Background\" [ngSwitch]=\"planCardTile?.plan.planType\">\r\n          <div *ngSwitchCase=\"planType.MAPD\">\r\n            <vnext-plan-coverage-preferences\r\n              [pharmacyNotCoveredText]=\"planDetailsNonCoveredText\"\r\n              [plan]=\"planCardTile?.plan\"\r\n              [prescriptionsText]=\"prescriptionText\"\r\n              [pharmacyText]=\"pharmacyText\"\r\n              [pharmacyCoveredText]=\"planCardFacade.getPharmacyCoverageText(planCardTile?.plan, pharmacyCoveredText)\"\r\n              [addedPharmacy]=\"planCardFacade.getSelectedPharmacy$() | async\"\r\n              [drugCoverageText]=\"\r\n                planCardFacade.getDrugCoverageText(planCardFacade.getDrugsCount$() | async, drugCoveredText, planCardTile?.plan)\r\n              \"\r\n              [showDrugCoverage]=\"planCardFacade.showDrugCoverage(displayDrugsCovered, planCardFacade.getDrugsCount$() | async)\"\r\n              [planPreferences]=\"planPreferences\"\r\n              [isTotalEstimatedCostEnabled]=\"isTotalEstimatedCostEnabled\"\r\n              [isRetention]=\"isRetention\"\r\n              [isQuoting]=\"isQuoting\"\r\n              [totalEstimatedAnnualCostText]=\"totalEstimatedAnnualCostText\"\r\n              [totalEstimatedCostText]=\"totalEstimatedCostText\"\r\n              [totalEstimatedCostTooltip]=\"totalEstimatedCostTooltip\"\r\n              [compareTwoPlans]=\"true\"\r\n              [noCostAvailableText]=\"noCostAvailableText\"\r\n              [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n              [annualCost]=\"planCardFacade.getAnnualCost$(planCardTile?.plan, isMailOrderSelected) | async\"\r\n              [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n              [inNetworkStandardText]=\"inNetworkStandardText\"\r\n              [outOfNetworkText]=\"outOfNetworkText\"\r\n              [showMailOrderLabel]=\"isMailOrderSelected\"\r\n              [viewCostTooltipHeaderText]=\"viewCostTooltipHeaderText\"\r\n              [viewCostTooltipHeaderContent]=\"viewCostTooltipHeaderContent\"\r\n              [mailOrderText]=\"mailOrderText\"\r\n              [medicineCabinet]=\"medicineCabinet\"\r\n              [selectedProviders]=\"selectedProviders\"\r\n              [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n              [providerDetails]=\"providerDetails\"\r\n              [showProviderInNetworkOnOtherLocation]=\"planCardTile?.showProviderInNetworkOnOtherLocation\"\r\n              [providersCoveredText]=\"planCardTile?.providersCoveredText\"\r\n              [providerPcpText]=\"planCardTile?.providerPcpText\"\r\n              [loaderIconEnabled]=\"loaderIconEnabled\"\r\n              [editLinkText]=\"editLinkText\"\r\n              [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n              [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n              [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n              [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n              [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n            ></vnext-plan-coverage-preferences>\r\n          </div>\r\n          <div *ngSwitchCase=\"planType.MA\">\r\n            <vnext-plan-coverage-preferences\r\n              [pharmacyNotCoveredText]=\"planDetailsNonCoveredText\"\r\n              [plan]=\"planCardTile?.plan\"\r\n              [prescriptionsText]=\"prescriptionText\"\r\n              [pharmacyText]=\"pharmacyText\"\r\n              [pharmacyCoveredText]=\"planCardFacade.getPharmacyCoverageText(planCardTile?.plan, pharmacyCoveredText)\"\r\n              [addedPharmacy]=\"planCardFacade.getSelectedPharmacy$() | async\"\r\n              [drugCoverageText]=\"\r\n                planCardFacade.getDrugCoverageText(planCardFacade.getDrugsCount$() | async, drugCoveredText, planCardTile?.plan)\r\n              \"\r\n              [showDrugCoverage]=\"planCardFacade.showDrugCoverage(displayDrugsCovered, planCardFacade.getDrugsCount$() | async)\"\r\n              [planPreferences]=\"planPreferences\"\r\n              [isTotalEstimatedCostEnabled]=\"isTotalEstimatedCostEnabled\"\r\n              [isRetention]=\"isRetention\"\r\n              [isQuoting]=\"isQuoting\"\r\n              [totalEstimatedAnnualCostText]=\"totalEstimatedAnnualCostText\"\r\n              [totalEstimatedCostText]=\"totalEstimatedCostText\"\r\n              [totalEstimatedCostTooltip]=\"totalEstimatedCostTooltip\"\r\n              [medicineCabinet]=\"medicineCabinet\"\r\n              [compareTwoPlans]=\"true\"\r\n              [noCostAvailableText]=\"noCostAvailableText\"\r\n              [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n              [annualCost]=\"planCardFacade.getAnnualCost$(planCardTile?.plan) | async\"\r\n              [selectedProviders]=\"selectedProviders\"\r\n              [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n              [providerDetails]=\"providerDetails\"\r\n              [showProviderInNetworkOnOtherLocation]=\"planCardTile?.showProviderInNetworkOnOtherLocation\"\r\n              [providersCoveredText]=\"planCardTile?.providersCoveredText\"\r\n              [providerPcpText]=\"planCardTile?.providerPcpText\"\r\n              [loaderIconEnabled]=\"loaderIconEnabled\"\r\n              [editLinkText]=\"editLinkText\"\r\n              [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n              [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n              [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n              [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n              [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n            ></vnext-plan-coverage-preferences>\r\n          </div>\r\n          <div *ngSwitchCase=\"planType.PDP\">\r\n            <vnext-plan-coverage-preferences\r\n              [pharmacyNotCoveredText]=\"planDetailsNonCoveredText\"\r\n              [plan]=\"planCardTile?.plan\"\r\n              [prescriptionsText]=\"prescriptionText\"\r\n              [pharmacyText]=\"pharmacyText\"\r\n              [pharmacyCoveredText]=\"planCardFacade.getPharmacyCoverageText(planCardTile?.plan, pharmacyCoveredText)\"\r\n              [addedPharmacy]=\"planCardFacade.getSelectedPharmacy$() | async\"\r\n              [drugCoverageText]=\"\r\n                planCardFacade.getDrugCoverageText(planCardFacade.getDrugsCount$() | async, drugCoveredText, planCardTile?.plan)\r\n              \"\r\n              [showDrugCoverage]=\"planCardFacade.showDrugCoverage(displayDrugsCovered, planCardFacade.getDrugsCount$() | async)\"\r\n              [planPreferences]=\"planPreferences\"\r\n              [isTotalEstimatedCostEnabled]=\"isTotalEstimatedCostEnabled\"\r\n              [isRetention]=\"isRetention\"\r\n              [isQuoting]=\"isQuoting\"\r\n              [totalEstimatedAnnualCostText]=\"totalEstimatedAnnualCostText\"\r\n              [totalEstimatedCostText]=\"totalEstimatedCostText\"\r\n              [totalEstimatedCostTooltip]=\"totalEstimatedCostTooltip\"\r\n              [compareTwoPlans]=\"true\"\r\n              [noCostAvailableText]=\"noCostAvailableText\"\r\n              [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n              [annualCost]=\"planCardFacade.getAnnualCost$(planCardTile?.plan, isMailOrderSelected) | async\"\r\n              [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n              [inNetworkStandardText]=\"inNetworkStandardText\"\r\n              [medicineCabinet]=\"medicineCabinet\"\r\n              [outOfNetworkText]=\"outOfNetworkText\"\r\n              [showMailOrderLabel]=\"isMailOrderSelected\"\r\n              [viewCostTooltipHeaderText]=\"viewCostTooltipHeaderText\"\r\n              [viewCostTooltipHeaderContent]=\"viewCostTooltipHeaderContent\"\r\n              [mailOrderText]=\"mailOrderText\"\r\n              [selectedProviders]=\"selectedProviders\"\r\n              [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n              [providerDetails]=\"providerDetails\"\r\n              [loaderIconEnabled]=\"loaderIconEnabled\"\r\n              [editLinkText]=\"editLinkText\"\r\n              [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n              [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n              [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n              [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n              [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n            ></vnext-plan-coverage-preferences>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".plan-card-border{border-style:solid;border-width:2px}.plan-card-basic-border{border-color:var(--static-Spa_Style_Accent1)}.plan-card-column:first-child .plan-card-border{border-bottom-left-radius:5px}.plan-card-column:last-child .plan-card-border{border-top-right-radius:5px;border-bottom-right-radius:5px}.current-plan-text,.next-year-plan-text{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.plan-card-column{display:flex;flex-flow:column}.plan-card-section{display:flex;align-items:stretch;flex-direction:column;justify-content:end;flex-grow:1}.plan-card-label-height{min-height:28px;border-left:none}.star-rating-container{min-height:50px}\n"] }]
    }], function () { return [{ type: PlanFacade }, { type: RiderFacade }, { type: PlanCardFacade }]; }, { coveragePreferences: [{
            type: ViewChildren,
            args: ['coveragePreferences']
        }], starRatings: [{
            type: ViewChildren,
            args: ['starRating']
        }], planNames: [{
            type: ViewChildren,
            args: ['planName']
        }], plans: [{
            type: Input
        }], showPlanLogo: [{
            type: Input
        }], planDetailsButtonText: [{
            type: Input
        }], planBenefitNoValueLabel: [{
            type: Input
        }], planTypeText: [{
            type: Input
        }], addOnCoverageText: [{
            type: Input
        }], addOnCoverageTooltipBody: [{
            type: Input
        }], planDetailsNonCoveredText: [{
            type: Input
        }], prescriptionText: [{
            type: Input
        }], pharmacyText: [{
            type: Input
        }], isTotalEstimatedCostEnabled: [{
            type: Input
        }], isRetention: [{
            type: Input
        }], totalEstimatedAnnualCostText: [{
            type: Input
        }], totalEstimatedCostText: [{
            type: Input
        }], totalEstimatedCostTooltip: [{
            type: Input
        }], planCardQuoteLinkText: [{
            type: Input
        }], planPreferences: [{
            type: Input
        }], planBenefits: [{
            type: Input
        }], shoppingCartEnabled: [{
            type: Input
        }], showRidersOnPlanCards: [{
            type: Input
        }], showPremiumAsAnnual: [{
            type: Input
        }], riderDisplayMap: [{
            type: Input
        }], drugCoveredText: [{
            type: Input
        }], pharmacyCoveredText: [{
            type: Input
        }], displayDrugsCovered: [{
            type: Input
        }], customClass: [{
            type: Input
        }], currentPlanText: [{
            type: Input
        }], nextYearPlanText: [{
            type: Input
        }], isQuoting: [{
            type: Input
        }], noCostAvailableText: [{
            type: Input
        }], inNetworkPreferredText: [{
            type: Input
        }], inNetworkStandardText: [{
            type: Input
        }], outOfNetworkText: [{
            type: Input
        }], isMailOrderSelected: [{
            type: Input
        }], viewCostTooltipHeaderText: [{
            type: Input
        }], viewCostTooltipHeaderContent: [{
            type: Input
        }], mailOrderText: [{
            type: Input
        }], providersInNetworkText: [{
            type: Input
        }], pcpInNetworkText: [{
            type: Input
        }], pcpOutOfNetworkText: [{
            type: Input
        }], providersNoDataText: [{
            type: Input
        }], isProviderEnabled: [{
            type: Input
        }], selectedProviders: [{
            type: Input
        }], providerDetails: [{
            type: Input
        }], Spa_Site_ShowRiderIcons: [{
            type: Input
        }], Spa_Site_Dental_Rider_Display_Text: [{
            type: Input
        }], Spa_Site_Vision_Rider_Display_Text: [{
            type: Input
        }], Spa_Site_Hearing_Rider_Display_Text: [{
            type: Input
        }], Spa_PlanCard_DentalAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_HearingAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_VisionAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_AddOnCoverage_Text: [{
            type: Input
        }], Spa_Site_MedigapPlanType_Enabled: [{
            type: Input
        }], Spa_Site_AddToCompare_Enabled: [{
            type: Input
        }], Spa_Site_PlanViewDetails_Enabled: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }], viewDetailsDescriptionText: [{
            type: Input
        }], optionOneText: [{
            type: Input
        }], optionTwoText: [{
            type: Input
        }], displayOptionLabels: [{
            type: Input
        }], nonCommissionableText: [{
            type: Input
        }], isNonCommissionableFlagCheckEnabled: [{
            type: Input
        }], hidePlanCardLabel: [{
            type: Input
        }], medicineCabinet: [{
            type: Input
        }], planCardPreferenceDetailedEnabled: [{
            type: Input
        }], planLogoSize: [{
            type: Input
        }], loaderIconEnabled: [{
            type: Input
        }], editLinkText: [{
            type: Input
        }], providerOneOrMoreOutOfNetworkText: [{
            type: Input
        }], providerInNetworkOnOtherLocationsTooltipText: [{
            type: Input
        }], providerShowPartialIndicatorEnabled: [{
            type: Input
        }], planFeesEnabled: [{
            type: Input
        }], planFeesTooltipText: [{
            type: Input
        }], planFeesIncludedInPremiumTooltipText: [{
            type: Input
        }], planFeesNotIncludedInPremiumTooltipText: [{
            type: Input
        }], showPlanYear: [{
            type: Input
        }], viewProvidersButtonText: [{
            type: Input
        }], viewPrescriptionsButtonText: [{
            type: Input
        }], quoteClicked: [{
            type: Output
        }], viewPlanDetails: [{
            type: Output
        }] }); })();

function QuotePlanCardComponent_h2_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h2", 6);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r0.pickPlanText, "html"), i0.ɵɵsanitizeHtml);
} }
function QuotePlanCardComponent_ng_container_3_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "vnext-widget-plan-card", 11);
    i0.ɵɵlistener("quoteClicked", function QuotePlanCardComponent_ng_container_3_div_3_Template_vnext_widget_plan_card_quoteClicked_2_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8.quoteClick()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const plan_r7 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("plan", plan_r7)("planBenefits", ctx_r6.benefits)("isRetentionSummaryPage", true)("displayDrugsCovered", ctx_r6.displayDrugsCovered)("displayOptionLabels", ctx_r6.displayOptionLabels)("hidePlanCardLabel", ctx_r6.hidePlanCardLabel)("planPreferences", ctx_r6.benefitPreferences)("hideCompareBoxOverride", true)("currentPlanText", ctx_r6.currentPlanText)("nextYearPlanText", ctx_r6.nextYearPlanText)("isQuotingSite", ctx_r6.isQuoting)("Spa_Site_ShowRiderIcons", ctx_r6.Spa_Site_ShowRiderIcons)("Spa_Site_Dental_Rider_Display_Text", ctx_r6.Spa_Site_Dental_Rider_Display_Text)("Spa_Site_Vision_Rider_Display_Text", ctx_r6.Spa_Site_Vision_Rider_Display_Text)("Spa_Site_Hearing_Rider_Display_Text", ctx_r6.Spa_Site_Hearing_Rider_Display_Text)("Spa_PlanCard_DentalAddOnCoverage_Text", ctx_r6.Spa_PlanCard_DentalAddOnCoverage_Text)("Spa_PlanCard_HearingAddOnCoverage_Text", ctx_r6.Spa_PlanCard_HearingAddOnCoverage_Text)("Spa_PlanCard_VisionAddOnCoverage_Text", ctx_r6.Spa_PlanCard_VisionAddOnCoverage_Text)("Spa_PlanCard_AddOnCoverage_Text", ctx_r6.Spa_PlanCard_AddOnCoverage_Text)("Spa_PlanCard_Pharmacy_Covered_Text", ctx_r6.pharmacyCoveredText)("Spa_PlanCard_Drug_Covered_Text", ctx_r6.drugCoveredText)("Spa_Site_Show_PlanLogo", ctx_r6.showPlanLogo)("Spa_PlanCard_TotalEstimatedAnnualCost_Text", ctx_r6.totalEstimatedAnnualCostText)("Spa_PlanCard_TotalEstimatedCost_Text", ctx_r6.totalEstimatedCostText)("Spa_PlanCard_Total_Estimated_Cost_Tooltip", ctx_r6.totalEstimatedCostTooltip)("Spa_Site_TotalEstimatedCost_Enabled", ctx_r6.isTotalEstimatedCostEnabled)("Spa_Site_ShowRidersOnPlanCards", ctx_r6.showRidersOnPlanCards)("Spa_Site_ShowPremiumAsAnnual", ctx_r6.showPremiumAsAnnual)("Spa_PlanCard_PlanDetails_ButtonText", ctx_r6.planDetailsButtonText)("Spa_PlanCard_PlanType_Text", ctx_r6.planTypeText)("Spa_PlanCard_AddOnCoverageInCart_Text", ctx_r6.addOnCoverageText)("Spa_PlanCard_AddOnCoverageTooltip_Body", ctx_r6.addOnCoverageTooltip)("Spa_PlanCard_QuoteLinkName_Text", ctx_r6.planCardQuoteLinkText)("Spa_PlanDetails_Non_Covered_Text", ctx_r6.planDetailsNonCoveredText)("Spa_Site_Prescriptions_Text", ctx_r6.prescriptionText)("Spa_Site_Pharmacy_Text", ctx_r6.pharmacyText)("Spa_ShoppingCart_Enabled", ctx_r6.shoppingCartEnabled)("Spa_Site_NotApplicable_Text", ctx_r6.planBenefitNoValueLabel)("Spa_Site_MedigapPlanType_Enabled", ctx_r6.Spa_Site_MedigapPlanType_Enabled)("Spa_Site_AddToCompare_Enabled", ctx_r6.Spa_Site_AddToCompare_Enabled)("Spa_Site_PlanViewDetails_Enabled", ctx_r6.Spa_Site_PlanViewDetails_Enabled)("Spa_PlanCard_ShowRidersOnMACards", ctx_r6.riderDisplayMap.MA)("Spa_PlanCard_ShowRidersOnPDPCards", ctx_r6.riderDisplayMap.PDP)("Spa_PlanCard_ShowRidersOnMAPDCards", ctx_r6.riderDisplayMap.MAPD)("Spa_PlanCard_ShowRidersOnMEDIGAPCards", ctx_r6.riderDisplayMap.MEDIGAP)("Spa_Site_Tooltip_Text", ctx_r6.Spa_Site_Tooltip_Text)("selectedPharmacy", ctx_r6.selectedPharmacy)("inNetworkPreferredText", ctx_r6.inNetworkPreferredText)("inNetworkStandardText", ctx_r6.inNetworkStandardText)("outOfNetworkText", ctx_r6.outOfNetworkText)("isMailOrderSelected", ctx_r6.isMailOrderSelected)("viewCostTooltipHeaderText", ctx_r6.viewCostTooltipHeaderText)("viewCostTooltipHeaderContent", ctx_r6.viewCostTooltipHeaderContent)("mailOrderText", ctx_r6.mailOrderText)("providersInNetworkText", ctx_r6.providersInNetworkText)("pcpInNetworkText", ctx_r6.pcpInNetworkText)("pcpOutOfNetworkText", ctx_r6.pcpOutOfNetworkText)("providersNoDataText", ctx_r6.providersNoDataText)("isProviderEnabled", ctx_r6.isProviderEnabled)("selectedProviders", ctx_r6.selectedProviders)("providerDetails", ctx_r6.providerDetails)("medicineCabinet", ctx_r6.medicineCabinet)("planCardPreferenceDetailedEnabled", ctx_r6.planCardPreferenceDetailedEnabled)("planLogoSize", ctx_r6.planLogoSize)("editLinkText", ctx_r6.editLinkText)("providerOneOrMoreOutOfNetworkText", ctx_r6.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r6.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r6.providerShowPartialIndicatorEnabled)("planFeesEnabled", ctx_r6.planFeesEnabled)("planFeesTooltipText", ctx_r6.planFeesTooltipText)("planFeesIncludedInPremiumTooltipText", ctx_r6.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r6.planFeesNotIncludedInPremiumTooltipText)("showPlanId", ctx_r6.showPlanId)("showPlanYear", ctx_r6.showPlanYear)("planIdText", ctx_r6.planIdText)("availableText", ctx_r6.availableText)("unavailableText", ctx_r6.unavailableText)("viewProvidersButtonText", ctx_r6.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r6.viewPrescriptionsButtonText)("supplementalBenefitsHighlightText", ctx_r6.supplementalBenefitsHighlightText)("preferencesText", ctx_r6.preferencesText)("viewMoreDetailsText", ctx_r6.viewMoreDetailsText)("hideDetailsText", ctx_r6.hideDetailsText)("newPlanCardDesignEnabled", ctx_r6.newPlanCardDesignEnabled)("viewAllPlanDetailsText", ctx_r6.viewAllPlanDetailsText)("shareThisPlanText", ctx_r6.shareThisPlanText)("viewCostDetailsText", ctx_r6.viewCostDetailsText)("closeText", ctx_r6.closeText)("planBenefitHighlightItems", ctx_r6.planBenefitHighlightItems)("planBenefitHighlightsHeaderText", ctx_r6.planBenefitHighlightsHeaderText)("showRiderDetails", ctx_r6.showRiderDetails)("showRiderDetailsText", ctx_r6.showRiderDetailsText)("hideRiderDetailsText", ctx_r6.hideRiderDetailsText)("riderIsIncludedText", ctx_r6.riderIsIncludedText)("waiverStateRiderTooltips", ctx_r6.waiverStateRiderTooltips)("costMA", ctx_r6.costMA)("costMAPD", ctx_r6.costMAPD)("costPDP", ctx_r6.costPDP)("costMEDIGAP", ctx_r6.costMEDIGAP)("costDENTAL", ctx_r6.costDENTAL)("costVISION", ctx_r6.costVISION);
} }
function QuotePlanCardComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 7)(2, "div", 0);
    i0.ɵɵtemplate(3, QuotePlanCardComponent_ng_container_3_div_3_Template, 3, 101, "div", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.plans)("ngForTrackBy", ctx_r1.trackByPlanId);
} }
function QuotePlanCardComponent_ng_template_4_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 10)(2, "vnext-widget-plan-card-tile", 12);
    i0.ɵɵlistener("quoteClicked", function QuotePlanCardComponent_ng_template_4_ng_container_0_Template_vnext_widget_plan_card_tile_quoteClicked_2_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.quoteClick()); })("viewPlanDetails", function QuotePlanCardComponent_ng_template_4_ng_container_0_Template_vnext_widget_plan_card_tile_viewPlanDetails_2_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.viewPlanDetailsPage($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("plans", ctx_r10.plans)("planCardQuoteLinkText", ctx_r10.planCardQuoteLinkText)("planDetailsButtonText", ctx_r10.planDetailsButtonText)("planTypeText", ctx_r10.planTypeText)("addOnCoverageText", ctx_r10.addOnCoverageText)("addOnCoverageTooltipBody", ctx_r10.addOnCoverageTooltip)("planDetailsNonCoveredText", ctx_r10.planDetailsNonCoveredText)("prescriptionText", ctx_r10.prescriptionText)("pharmacyText", ctx_r10.pharmacyText)("isTotalEstimatedCostEnabled", ctx_r10.isTotalEstimatedCostEnabled)("totalEstimatedAnnualCostText", ctx_r10.totalEstimatedAnnualCostText)("totalEstimatedCostText", ctx_r10.totalEstimatedCostText)("totalEstimatedCostTooltip", ctx_r10.totalEstimatedCostTooltip)("showPlanLogo", ctx_r10.showPlanLogo)("planBenefits", ctx_r10.benefits)("planPreferences", ctx_r10.benefitPreferences)("showRidersOnPlanCards", ctx_r10.showRidersOnPlanCards)("showPremiumAsAnnual", ctx_r10.showPremiumAsAnnual)("riderDisplayMap", ctx_r10.riderDisplayMap)("shoppingCartEnabled", ctx_r10.shoppingCartEnabled)("drugCoveredText", ctx_r10.drugCoveredText)("pharmacyCoveredText", ctx_r10.pharmacyCoveredText)("displayDrugsCovered", ctx_r10.displayDrugsCovered)("displayOptionLabels", ctx_r10.displayOptionLabels)("hidePlanCardLabel", ctx_r10.hidePlanCardLabel)("planBenefitNoValueLabel", ctx_r10.planBenefitNoValueLabel)("currentPlanText", ctx_r10.currentPlanText)("nextYearPlanText", ctx_r10.nextYearPlanText)("isQuoting", ctx_r10.isQuoting)("Spa_Site_ShowRiderIcons", ctx_r10.Spa_Site_ShowRiderIcons)("Spa_Site_Dental_Rider_Display_Text", ctx_r10.Spa_Site_Dental_Rider_Display_Text)("Spa_Site_Vision_Rider_Display_Text", ctx_r10.Spa_Site_Vision_Rider_Display_Text)("Spa_Site_Hearing_Rider_Display_Text", ctx_r10.Spa_Site_Hearing_Rider_Display_Text)("Spa_PlanCard_DentalAddOnCoverage_Text", ctx_r10.Spa_PlanCard_DentalAddOnCoverage_Text)("Spa_PlanCard_HearingAddOnCoverage_Text", ctx_r10.Spa_PlanCard_HearingAddOnCoverage_Text)("Spa_PlanCard_VisionAddOnCoverage_Text", ctx_r10.Spa_PlanCard_VisionAddOnCoverage_Text)("Spa_PlanCard_AddOnCoverage_Text", ctx_r10.Spa_PlanCard_AddOnCoverage_Text)("Spa_Site_MedigapPlanType_Enabled", ctx_r10.Spa_Site_MedigapPlanType_Enabled)("Spa_Site_AddToCompare_Enabled", ctx_r10.Spa_Site_AddToCompare_Enabled)("Spa_Site_PlanViewDetails_Enabled", ctx_r10.Spa_Site_PlanViewDetails_Enabled)("Spa_Site_Tooltip_Text", ctx_r10.Spa_Site_Tooltip_Text)("inNetworkPreferredText", ctx_r10.inNetworkPreferredText)("inNetworkStandardText", ctx_r10.inNetworkStandardText)("outOfNetworkText", ctx_r10.outOfNetworkText)("isMailOrderSelected", ctx_r10.isMailOrderSelected)("viewCostTooltipHeaderText", ctx_r10.viewCostTooltipHeaderText)("viewCostTooltipHeaderContent", ctx_r10.viewCostTooltipHeaderContent)("mailOrderText", ctx_r10.mailOrderText)("providersInNetworkText", ctx_r10.providersInNetworkText)("pcpInNetworkText", ctx_r10.pcpInNetworkText)("pcpOutOfNetworkText", ctx_r10.pcpOutOfNetworkText)("providersNoDataText", ctx_r10.providersNoDataText)("isProviderEnabled", ctx_r10.isProviderEnabled)("selectedProviders", ctx_r10.selectedProviders)("providerDetails", ctx_r10.providerDetails)("medicineCabinet", ctx_r10.medicineCabinet)("planCardPreferenceDetailedEnabled", ctx_r10.planCardPreferenceDetailedEnabled)("planLogoSize", ctx_r10.planLogoSize)("loaderIconEnabled", ctx_r10.loaderIconEnabled)("editLinkText", ctx_r10.editLinkText)("providerOneOrMoreOutOfNetworkText", ctx_r10.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r10.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r10.providerShowPartialIndicatorEnabled)("planFeesEnabled", ctx_r10.planFeesEnabled)("planFeesTooltipText", ctx_r10.planFeesTooltipText)("planFeesIncludedInPremiumTooltipText", ctx_r10.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r10.planFeesNotIncludedInPremiumTooltipText)("showPlanYear", ctx_r10.showPlanYear)("viewProvidersButtonText", ctx_r10.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r10.viewPrescriptionsButtonText);
} }
function QuotePlanCardComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, QuotePlanCardComponent_ng_template_4_ng_container_0_Template, 3, 70, "ng-container", 3);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngIf", ctx_r3.plans.length === 3)("ngIfElse", _r4);
} }
function QuotePlanCardComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "vnext-plan-card-two-tiles", 13);
    i0.ɵɵlistener("quoteClicked", function QuotePlanCardComponent_ng_template_6_Template_vnext_plan_card_two_tiles_quoteClicked_1_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.quoteClick()); })("viewPlanDetails", function QuotePlanCardComponent_ng_template_6_Template_vnext_plan_card_two_tiles_viewPlanDetails_1_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.viewPlanDetailsPage($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plans", ctx_r5.plans)("planCardQuoteLinkText", ctx_r5.planCardQuoteLinkText)("planDetailsButtonText", ctx_r5.planDetailsButtonText)("planTypeText", ctx_r5.planTypeText)("addOnCoverageText", ctx_r5.addOnCoverageText)("addOnCoverageTooltipBody", ctx_r5.addOnCoverageTooltip)("planDetailsNonCoveredText", ctx_r5.planDetailsNonCoveredText)("prescriptionText", ctx_r5.prescriptionText)("pharmacyText", ctx_r5.pharmacyText)("isTotalEstimatedCostEnabled", ctx_r5.isTotalEstimatedCostEnabled)("totalEstimatedAnnualCostText", ctx_r5.totalEstimatedAnnualCostText)("totalEstimatedCostText", ctx_r5.totalEstimatedCostText)("totalEstimatedCostTooltip", ctx_r5.totalEstimatedCostTooltip)("showPlanLogo", ctx_r5.showPlanLogo)("planBenefits", ctx_r5.benefits)("planPreferences", ctx_r5.benefitPreferences)("showRidersOnPlanCards", ctx_r5.showRidersOnPlanCards)("showPremiumAsAnnual", ctx_r5.showPremiumAsAnnual)("riderDisplayMap", ctx_r5.riderDisplayMap)("shoppingCartEnabled", ctx_r5.shoppingCartEnabled)("drugCoveredText", ctx_r5.drugCoveredText)("pharmacyCoveredText", ctx_r5.pharmacyCoveredText)("displayDrugsCovered", ctx_r5.displayDrugsCovered)("displayOptionLabels", ctx_r5.displayOptionLabels)("hidePlanCardLabel", ctx_r5.hidePlanCardLabel)("planBenefitNoValueLabel", ctx_r5.planBenefitNoValueLabel)("currentPlanText", ctx_r5.currentPlanText)("nextYearPlanText", ctx_r5.nextYearPlanText)("isQuoting", ctx_r5.isQuoting)("Spa_Site_ShowRiderIcons", ctx_r5.Spa_Site_ShowRiderIcons)("Spa_Site_Dental_Rider_Display_Text", ctx_r5.Spa_Site_Dental_Rider_Display_Text)("Spa_Site_Vision_Rider_Display_Text", ctx_r5.Spa_Site_Vision_Rider_Display_Text)("Spa_Site_Hearing_Rider_Display_Text", ctx_r5.Spa_Site_Hearing_Rider_Display_Text)("Spa_PlanCard_DentalAddOnCoverage_Text", ctx_r5.Spa_PlanCard_DentalAddOnCoverage_Text)("Spa_PlanCard_HearingAddOnCoverage_Text", ctx_r5.Spa_PlanCard_HearingAddOnCoverage_Text)("Spa_PlanCard_VisionAddOnCoverage_Text", ctx_r5.Spa_PlanCard_VisionAddOnCoverage_Text)("Spa_PlanCard_AddOnCoverage_Text", ctx_r5.Spa_PlanCard_AddOnCoverage_Text)("Spa_Site_MedigapPlanType_Enabled", ctx_r5.Spa_Site_MedigapPlanType_Enabled)("Spa_Site_AddToCompare_Enabled", ctx_r5.Spa_Site_AddToCompare_Enabled)("Spa_Site_PlanViewDetails_Enabled", ctx_r5.Spa_Site_PlanViewDetails_Enabled)("Spa_Site_Tooltip_Text", ctx_r5.Spa_Site_Tooltip_Text)("inNetworkPreferredText", ctx_r5.inNetworkPreferredText)("inNetworkStandardText", ctx_r5.inNetworkStandardText)("outOfNetworkText", ctx_r5.outOfNetworkText)("isMailOrderSelected", ctx_r5.isMailOrderSelected)("viewCostTooltipHeaderText", ctx_r5.viewCostTooltipHeaderText)("viewCostTooltipHeaderContent", ctx_r5.viewCostTooltipHeaderContent)("mailOrderText", ctx_r5.mailOrderText)("providersInNetworkText", ctx_r5.providersInNetworkText)("pcpInNetworkText", ctx_r5.pcpInNetworkText)("pcpOutOfNetworkText", ctx_r5.pcpOutOfNetworkText)("providersNoDataText", ctx_r5.providersNoDataText)("isProviderEnabled", ctx_r5.isProviderEnabled)("selectedProviders", ctx_r5.selectedProviders)("providerDetails", ctx_r5.providerDetails)("viewDetailsDescriptionText", ctx_r5.viewDetailsDescriptionText)("medicineCabinet", ctx_r5.medicineCabinet)("planCardPreferenceDetailedEnabled", ctx_r5.planCardPreferenceDetailedEnabled)("planLogoSize", ctx_r5.planLogoSize)("loaderIconEnabled", ctx_r5.loaderIconEnabled)("editLinkText", ctx_r5.editLinkText)("providerOneOrMoreOutOfNetworkText", ctx_r5.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r5.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r5.providerShowPartialIndicatorEnabled)("planFeesEnabled", ctx_r5.planFeesEnabled)("planFeesTooltipText", ctx_r5.planFeesTooltipText)("planFeesIncludedInPremiumTooltipText", ctx_r5.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r5.planFeesNotIncludedInPremiumTooltipText)("showPlanYear", ctx_r5.showPlanYear)("viewProvidersButtonText", ctx_r5.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r5.viewPrescriptionsButtonText);
} }
class QuotePlanCardComponent {
    constructor() {
        this.showPlanYear = false;
        this.newPlanCardDesignEnabled = false;
        this.planBenefitHighlightItems = [];
        this.waiverStateRiderTooltips = [];
        this.quoteClicked = new EventEmitter();
        this.viewPlanDetails = new EventEmitter();
    }
    quoteClick() {
        this.quoteClicked.emit();
    }
    viewPlanDetailsPage(plan) {
        this.viewPlanDetails.emit(plan);
    }
    trackByPlanId(index, plan) {
        return plan.id;
    }
}
QuotePlanCardComponent.ɵfac = function QuotePlanCardComponent_Factory(t) { return new (t || QuotePlanCardComponent)(); };
QuotePlanCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: QuotePlanCardComponent, selectors: [["vnext-widget-quote-plan-card"]], inputs: { plans: "plans", pickPlanText: "pickPlanText", PlanStep: "PlanStep", planCardQuoteLinkText: "planCardQuoteLinkText", showPlanLogo: "showPlanLogo", planDetailsButtonText: "planDetailsButtonText", planBenefitNoValueLabel: "planBenefitNoValueLabel", planTypeText: "planTypeText", addOnCoverageText: "addOnCoverageText", addOnCoverageTooltip: "addOnCoverageTooltip", planDetailsNonCoveredText: "planDetailsNonCoveredText", prescriptionText: "prescriptionText", pharmacyText: "pharmacyText", isTotalEstimatedCostEnabled: "isTotalEstimatedCostEnabled", totalEstimatedAnnualCostText: "totalEstimatedAnnualCostText", totalEstimatedCostText: "totalEstimatedCostText", totalEstimatedCostTooltip: "totalEstimatedCostTooltip", showRidersOnPlanCards: "showRidersOnPlanCards", showPremiumAsAnnual: "showPremiumAsAnnual", riderDisplayMap: "riderDisplayMap", shoppingCartEnabled: "shoppingCartEnabled", drugCoveredText: "drugCoveredText", displayOptionLabels: "displayOptionLabels", hidePlanCardLabel: "hidePlanCardLabel", pharmacyCoveredText: "pharmacyCoveredText", displayDrugsCovered: "displayDrugsCovered", benefits: "benefits", benefitPreferences: "benefitPreferences", currentPlanText: "currentPlanText", isMobile: "isMobile", nextYearPlanText: "nextYearPlanText", isQuoting: "isQuoting", selectedPharmacy: "selectedPharmacy", inNetworkPreferredText: "inNetworkPreferredText", inNetworkStandardText: "inNetworkStandardText", outOfNetworkText: "outOfNetworkText", isMailOrderSelected: "isMailOrderSelected", viewCostTooltipHeaderText: "viewCostTooltipHeaderText", viewCostTooltipHeaderContent: "viewCostTooltipHeaderContent", mailOrderText: "mailOrderText", providersInNetworkText: "providersInNetworkText", pcpInNetworkText: "pcpInNetworkText", pcpOutOfNetworkText: "pcpOutOfNetworkText", providersNoDataText: "providersNoDataText", isProviderEnabled: "isProviderEnabled", selectedProviders: "selectedProviders", providerDetails: "providerDetails", Spa_Site_ShowRiderIcons: "Spa_Site_ShowRiderIcons", Spa_Site_Dental_Rider_Display_Text: "Spa_Site_Dental_Rider_Display_Text", Spa_Site_Vision_Rider_Display_Text: "Spa_Site_Vision_Rider_Display_Text", Spa_Site_Hearing_Rider_Display_Text: "Spa_Site_Hearing_Rider_Display_Text", Spa_PlanCard_DentalAddOnCoverage_Text: "Spa_PlanCard_DentalAddOnCoverage_Text", Spa_PlanCard_HearingAddOnCoverage_Text: "Spa_PlanCard_HearingAddOnCoverage_Text", Spa_PlanCard_VisionAddOnCoverage_Text: "Spa_PlanCard_VisionAddOnCoverage_Text", Spa_PlanCard_AddOnCoverage_Text: "Spa_PlanCard_AddOnCoverage_Text", Spa_Site_MedigapPlanType_Enabled: "Spa_Site_MedigapPlanType_Enabled", Spa_Site_AddToCompare_Enabled: "Spa_Site_AddToCompare_Enabled", Spa_Site_PlanViewDetails_Enabled: "Spa_Site_PlanViewDetails_Enabled", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text", viewDetailsDescriptionText: "viewDetailsDescriptionText", medicineCabinet: "medicineCabinet", planCardPreferenceDetailedEnabled: "planCardPreferenceDetailedEnabled", planLogoSize: "planLogoSize", loaderIconEnabled: "loaderIconEnabled", editLinkText: "editLinkText", providerOneOrMoreOutOfNetworkText: "providerOneOrMoreOutOfNetworkText", providerInNetworkOnOtherLocationsTooltipText: "providerInNetworkOnOtherLocationsTooltipText", providerShowPartialIndicatorEnabled: "providerShowPartialIndicatorEnabled", planFeesEnabled: "planFeesEnabled", planFeesTooltipText: "planFeesTooltipText", planFeesIncludedInPremiumTooltipText: "planFeesIncludedInPremiumTooltipText", planFeesNotIncludedInPremiumTooltipText: "planFeesNotIncludedInPremiumTooltipText", showPlanId: "showPlanId", showPlanYear: "showPlanYear", planIdText: "planIdText", availableText: "availableText", unavailableText: "unavailableText", viewProvidersButtonText: "viewProvidersButtonText", viewPrescriptionsButtonText: "viewPrescriptionsButtonText", supplementalBenefitsHighlightText: "supplementalBenefitsHighlightText", preferencesText: "preferencesText", viewMoreDetailsText: "viewMoreDetailsText", hideDetailsText: "hideDetailsText", newPlanCardDesignEnabled: "newPlanCardDesignEnabled", viewAllPlanDetailsText: "viewAllPlanDetailsText", shareThisPlanText: "shareThisPlanText", viewCostDetailsText: "viewCostDetailsText", closeText: "closeText", planBenefitHighlightItems: "planBenefitHighlightItems", planBenefitHighlightsHeaderText: "planBenefitHighlightsHeaderText", showRiderDetails: "showRiderDetails", hideRiderDetailsText: "hideRiderDetailsText", showRiderDetailsText: "showRiderDetailsText", riderIsIncludedText: "riderIsIncludedText", waiverStateRiderTooltips: "waiverStateRiderTooltips", costMA: "costMA", costMAPD: "costMAPD", costMEDIGAP: "costMEDIGAP", costPDP: "costPDP", costDENTAL: "costDENTAL", costVISION: "costVISION" }, outputs: { quoteClicked: "quoteClicked", viewPlanDetails: "viewPlanDetails" }, decls: 8, vars: 3, consts: [[1, "container"], [1, "row", "mt-3"], ["class", "col-12 my-2 Spa_Style_Large_Font", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [4, "ngIf", "ngIfElse"], ["threeTiles", ""], ["twoTiles", ""], ["navigationAdapter", "", 1, "col-12", "my-2", "Spa_Style_Large_Font", 3, "innerHtml"], [1, "col-12", "px-0"], ["class", "row", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "row"], [1, "col-12"], [3, "plan", "planBenefits", "isRetentionSummaryPage", "displayDrugsCovered", "displayOptionLabels", "hidePlanCardLabel", "planPreferences", "hideCompareBoxOverride", "currentPlanText", "nextYearPlanText", "isQuotingSite", "Spa_Site_ShowRiderIcons", "Spa_Site_Dental_Rider_Display_Text", "Spa_Site_Vision_Rider_Display_Text", "Spa_Site_Hearing_Rider_Display_Text", "Spa_PlanCard_DentalAddOnCoverage_Text", "Spa_PlanCard_HearingAddOnCoverage_Text", "Spa_PlanCard_VisionAddOnCoverage_Text", "Spa_PlanCard_AddOnCoverage_Text", "Spa_PlanCard_Pharmacy_Covered_Text", "Spa_PlanCard_Drug_Covered_Text", "Spa_Site_Show_PlanLogo", "Spa_PlanCard_TotalEstimatedAnnualCost_Text", "Spa_PlanCard_TotalEstimatedCost_Text", "Spa_PlanCard_Total_Estimated_Cost_Tooltip", "Spa_Site_TotalEstimatedCost_Enabled", "Spa_Site_ShowRidersOnPlanCards", "Spa_Site_ShowPremiumAsAnnual", "Spa_PlanCard_PlanDetails_ButtonText", "Spa_PlanCard_PlanType_Text", "Spa_PlanCard_AddOnCoverageInCart_Text", "Spa_PlanCard_AddOnCoverageTooltip_Body", "Spa_PlanCard_QuoteLinkName_Text", "Spa_PlanDetails_Non_Covered_Text", "Spa_Site_Prescriptions_Text", "Spa_Site_Pharmacy_Text", "Spa_ShoppingCart_Enabled", "Spa_Site_NotApplicable_Text", "Spa_Site_MedigapPlanType_Enabled", "Spa_Site_AddToCompare_Enabled", "Spa_Site_PlanViewDetails_Enabled", "Spa_PlanCard_ShowRidersOnMACards", "Spa_PlanCard_ShowRidersOnPDPCards", "Spa_PlanCard_ShowRidersOnMAPDCards", "Spa_PlanCard_ShowRidersOnMEDIGAPCards", "Spa_Site_Tooltip_Text", "selectedPharmacy", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "isMailOrderSelected", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "mailOrderText", "providersInNetworkText", "pcpInNetworkText", "pcpOutOfNetworkText", "providersNoDataText", "isProviderEnabled", "selectedProviders", "providerDetails", "medicineCabinet", "planCardPreferenceDetailedEnabled", "planLogoSize", "editLinkText", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "showPlanId", "showPlanYear", "planIdText", "availableText", "unavailableText", "viewProvidersButtonText", "viewPrescriptionsButtonText", "supplementalBenefitsHighlightText", "preferencesText", "viewMoreDetailsText", "hideDetailsText", "newPlanCardDesignEnabled", "viewAllPlanDetailsText", "shareThisPlanText", "viewCostDetailsText", "closeText", "planBenefitHighlightItems", "planBenefitHighlightsHeaderText", "showRiderDetails", "showRiderDetailsText", "hideRiderDetailsText", "riderIsIncludedText", "waiverStateRiderTooltips", "costMA", "costMAPD", "costPDP", "costMEDIGAP", "costDENTAL", "costVISION", "quoteClicked"], [3, "plans", "planCardQuoteLinkText", "planDetailsButtonText", "planTypeText", "addOnCoverageText", "addOnCoverageTooltipBody", "planDetailsNonCoveredText", "prescriptionText", "pharmacyText", "isTotalEstimatedCostEnabled", "totalEstimatedAnnualCostText", "totalEstimatedCostText", "totalEstimatedCostTooltip", "showPlanLogo", "planBenefits", "planPreferences", "showRidersOnPlanCards", "showPremiumAsAnnual", "riderDisplayMap", "shoppingCartEnabled", "drugCoveredText", "pharmacyCoveredText", "displayDrugsCovered", "displayOptionLabels", "hidePlanCardLabel", "planBenefitNoValueLabel", "currentPlanText", "nextYearPlanText", "isQuoting", "Spa_Site_ShowRiderIcons", "Spa_Site_Dental_Rider_Display_Text", "Spa_Site_Vision_Rider_Display_Text", "Spa_Site_Hearing_Rider_Display_Text", "Spa_PlanCard_DentalAddOnCoverage_Text", "Spa_PlanCard_HearingAddOnCoverage_Text", "Spa_PlanCard_VisionAddOnCoverage_Text", "Spa_PlanCard_AddOnCoverage_Text", "Spa_Site_MedigapPlanType_Enabled", "Spa_Site_AddToCompare_Enabled", "Spa_Site_PlanViewDetails_Enabled", "Spa_Site_Tooltip_Text", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "isMailOrderSelected", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "mailOrderText", "providersInNetworkText", "pcpInNetworkText", "pcpOutOfNetworkText", "providersNoDataText", "isProviderEnabled", "selectedProviders", "providerDetails", "medicineCabinet", "planCardPreferenceDetailedEnabled", "planLogoSize", "loaderIconEnabled", "editLinkText", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "showPlanYear", "viewProvidersButtonText", "viewPrescriptionsButtonText", "quoteClicked", "viewPlanDetails"], [3, "plans", "planCardQuoteLinkText", "planDetailsButtonText", "planTypeText", "addOnCoverageText", "addOnCoverageTooltipBody", "planDetailsNonCoveredText", "prescriptionText", "pharmacyText", "isTotalEstimatedCostEnabled", "totalEstimatedAnnualCostText", "totalEstimatedCostText", "totalEstimatedCostTooltip", "showPlanLogo", "planBenefits", "planPreferences", "showRidersOnPlanCards", "showPremiumAsAnnual", "riderDisplayMap", "shoppingCartEnabled", "drugCoveredText", "pharmacyCoveredText", "displayDrugsCovered", "displayOptionLabels", "hidePlanCardLabel", "planBenefitNoValueLabel", "currentPlanText", "nextYearPlanText", "isQuoting", "Spa_Site_ShowRiderIcons", "Spa_Site_Dental_Rider_Display_Text", "Spa_Site_Vision_Rider_Display_Text", "Spa_Site_Hearing_Rider_Display_Text", "Spa_PlanCard_DentalAddOnCoverage_Text", "Spa_PlanCard_HearingAddOnCoverage_Text", "Spa_PlanCard_VisionAddOnCoverage_Text", "Spa_PlanCard_AddOnCoverage_Text", "Spa_Site_MedigapPlanType_Enabled", "Spa_Site_AddToCompare_Enabled", "Spa_Site_PlanViewDetails_Enabled", "Spa_Site_Tooltip_Text", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "isMailOrderSelected", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "mailOrderText", "providersInNetworkText", "pcpInNetworkText", "pcpOutOfNetworkText", "providersNoDataText", "isProviderEnabled", "selectedProviders", "providerDetails", "viewDetailsDescriptionText", "medicineCabinet", "planCardPreferenceDetailedEnabled", "planLogoSize", "loaderIconEnabled", "editLinkText", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "showPlanYear", "viewProvidersButtonText", "viewPrescriptionsButtonText", "quoteClicked", "viewPlanDetails"]], template: function QuotePlanCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, QuotePlanCardComponent_h2_2_Template, 2, 4, "h2", 2);
        i0.ɵɵtemplate(3, QuotePlanCardComponent_ng_container_3_Template, 4, 2, "ng-container", 3);
        i0.ɵɵtemplate(4, QuotePlanCardComponent_ng_template_4_Template, 1, 2, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(6, QuotePlanCardComponent_ng_template_6_Template, 2, 71, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(5);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_QuoteSummary_PickPlan_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isMobile || ctx.plans.length === 1)("ngIfElse", _r2);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, NavigationAdapterDirective, LiveEditPropDirective, PlanCardComponent, PlanCardTileComponent, PlanCardTileTwoComponent, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QuotePlanCardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-quote-plan-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container\">\r\n  <div class=\"row mt-3\">\r\n    <h2\r\n      class=\"col-12 my-2 Spa_Style_Large_Font\"\r\n      *liveEditProp=\"'Spa_QuoteSummary_PickPlan_Text'\"\r\n      [innerHtml]=\"pickPlanText | safe : 'html'\"\r\n      navigationAdapter\r\n    ></h2>\r\n    <ng-container *ngIf=\"isMobile || plans.length === 1; else threeTiles\">\r\n      <div class=\"col-12 px-0\">\r\n        <div class=\"container\">\r\n          <div class=\"row\" *ngFor=\"let plan of plans; trackBy: trackByPlanId\">\r\n            <div class=\"col-12\">\r\n              <vnext-widget-plan-card\r\n                [plan]=\"plan\"\r\n                [planBenefits]=\"benefits\"\r\n                [isRetentionSummaryPage]=\"true\"\r\n                [displayDrugsCovered]=\"displayDrugsCovered\"\r\n                [displayOptionLabels]=\"displayOptionLabels\"\r\n                [hidePlanCardLabel]=\"hidePlanCardLabel\"\r\n                [planPreferences]=\"benefitPreferences\"\r\n                [hideCompareBoxOverride]=\"true\"\r\n                [currentPlanText]=\"currentPlanText\"\r\n                [nextYearPlanText]=\"nextYearPlanText\"\r\n                [isQuotingSite]=\"isQuoting\"\r\n                (quoteClicked)=\"quoteClick()\"\r\n                [Spa_Site_ShowRiderIcons]=\"Spa_Site_ShowRiderIcons\"\r\n                [Spa_Site_Dental_Rider_Display_Text]=\"Spa_Site_Dental_Rider_Display_Text\"\r\n                [Spa_Site_Vision_Rider_Display_Text]=\"Spa_Site_Vision_Rider_Display_Text\"\r\n                [Spa_Site_Hearing_Rider_Display_Text]=\"Spa_Site_Hearing_Rider_Display_Text\"\r\n                [Spa_PlanCard_DentalAddOnCoverage_Text]=\"Spa_PlanCard_DentalAddOnCoverage_Text\"\r\n                [Spa_PlanCard_HearingAddOnCoverage_Text]=\"Spa_PlanCard_HearingAddOnCoverage_Text\"\r\n                [Spa_PlanCard_VisionAddOnCoverage_Text]=\"Spa_PlanCard_VisionAddOnCoverage_Text\"\r\n                [Spa_PlanCard_AddOnCoverage_Text]=\"Spa_PlanCard_AddOnCoverage_Text\"\r\n                [Spa_PlanCard_Pharmacy_Covered_Text]=\"pharmacyCoveredText\"\r\n                [Spa_PlanCard_Drug_Covered_Text]=\"drugCoveredText\"\r\n                [Spa_Site_Show_PlanLogo]=\"showPlanLogo\"\r\n                [Spa_PlanCard_TotalEstimatedAnnualCost_Text]=\"totalEstimatedAnnualCostText\"\r\n                [Spa_PlanCard_TotalEstimatedCost_Text]=\"totalEstimatedCostText\"\r\n                [Spa_PlanCard_Total_Estimated_Cost_Tooltip]=\"totalEstimatedCostTooltip\"\r\n                [Spa_Site_TotalEstimatedCost_Enabled]=\"isTotalEstimatedCostEnabled\"\r\n                [Spa_Site_ShowRidersOnPlanCards]=\"showRidersOnPlanCards\"\r\n                [Spa_Site_ShowPremiumAsAnnual]=\"showPremiumAsAnnual\"\r\n                [Spa_PlanCard_PlanDetails_ButtonText]=\"planDetailsButtonText\"\r\n                [Spa_PlanCard_PlanType_Text]=\"planTypeText\"\r\n                [Spa_PlanCard_AddOnCoverageInCart_Text]=\"addOnCoverageText\"\r\n                [Spa_PlanCard_AddOnCoverageTooltip_Body]=\"addOnCoverageTooltip\"\r\n                [Spa_PlanCard_QuoteLinkName_Text]=\"planCardQuoteLinkText\"\r\n                [Spa_PlanDetails_Non_Covered_Text]=\"planDetailsNonCoveredText\"\r\n                [Spa_Site_Prescriptions_Text]=\"prescriptionText\"\r\n                [Spa_Site_Pharmacy_Text]=\"pharmacyText\"\r\n                [Spa_ShoppingCart_Enabled]=\"shoppingCartEnabled\"\r\n                [Spa_Site_NotApplicable_Text]=\"planBenefitNoValueLabel\"\r\n                [Spa_Site_MedigapPlanType_Enabled]=\"Spa_Site_MedigapPlanType_Enabled\"\r\n                [Spa_Site_AddToCompare_Enabled]=\"Spa_Site_AddToCompare_Enabled\"\r\n                [Spa_Site_PlanViewDetails_Enabled]=\"Spa_Site_PlanViewDetails_Enabled\"\r\n                [Spa_PlanCard_ShowRidersOnMACards]=\"riderDisplayMap.MA\"\r\n                [Spa_PlanCard_ShowRidersOnPDPCards]=\"riderDisplayMap.PDP\"\r\n                [Spa_PlanCard_ShowRidersOnMAPDCards]=\"riderDisplayMap.MAPD\"\r\n                [Spa_PlanCard_ShowRidersOnMEDIGAPCards]=\"riderDisplayMap.MEDIGAP\"\r\n                [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                [selectedPharmacy]=\"selectedPharmacy\"\r\n                [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n                [inNetworkStandardText]=\"inNetworkStandardText\"\r\n                [outOfNetworkText]=\"outOfNetworkText\"\r\n                [isMailOrderSelected]=\"isMailOrderSelected\"\r\n                [viewCostTooltipHeaderText]=\"viewCostTooltipHeaderText\"\r\n                [viewCostTooltipHeaderContent]=\"viewCostTooltipHeaderContent\"\r\n                [mailOrderText]=\"mailOrderText\"\r\n                [providersInNetworkText]=\"providersInNetworkText\"\r\n                [pcpInNetworkText]=\"pcpInNetworkText\"\r\n                [pcpOutOfNetworkText]=\"pcpOutOfNetworkText\"\r\n                [providersNoDataText]=\"providersNoDataText\"\r\n                [isProviderEnabled]=\"isProviderEnabled\"\r\n                [selectedProviders]=\"selectedProviders\"\r\n                [providerDetails]=\"providerDetails\"\r\n                [medicineCabinet]=\"medicineCabinet\"\r\n                [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n                [planLogoSize]=\"planLogoSize\"\r\n                [editLinkText]=\"editLinkText\"\r\n                [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n                [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n                [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n                [planFeesEnabled]=\"planFeesEnabled\"\r\n                [planFeesTooltipText]=\"planFeesTooltipText\"\r\n                [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n                [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n                [showPlanId]=\"showPlanId\"\r\n                [showPlanYear]=\"showPlanYear\"\r\n                [planIdText]=\"planIdText\"\r\n                [availableText]=\"availableText\"\r\n                [unavailableText]=\"unavailableText\"\r\n                [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n                [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n                [supplementalBenefitsHighlightText]=\"supplementalBenefitsHighlightText\"\r\n                [preferencesText]=\"preferencesText\"\r\n                [viewMoreDetailsText]=\"viewMoreDetailsText\"\r\n                [hideDetailsText]=\"hideDetailsText\"\r\n                [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n                [viewAllPlanDetailsText]=\"viewAllPlanDetailsText\"\r\n                [shareThisPlanText]=\"shareThisPlanText\"\r\n                [viewCostDetailsText]=\"viewCostDetailsText\"\r\n                [closeText]=\"closeText\"\r\n                [planBenefitHighlightItems]=\"planBenefitHighlightItems\"\r\n                [planBenefitHighlightsHeaderText]=\"planBenefitHighlightsHeaderText\"\r\n                [showRiderDetails]=\"showRiderDetails\"\r\n                [showRiderDetailsText]=\"showRiderDetailsText\"\r\n                [hideRiderDetailsText]=\"hideRiderDetailsText\"\r\n                [riderIsIncludedText]=\"riderIsIncludedText\"\r\n                [waiverStateRiderTooltips]=\"waiverStateRiderTooltips\"\r\n                [costMA]=\"costMA\"\r\n                [costMAPD]=\"costMAPD\"\r\n                [costPDP]=\"costPDP\"\r\n                [costMEDIGAP]=\"costMEDIGAP\"\r\n                [costDENTAL]=\"costDENTAL\"\r\n                [costVISION]=\"costVISION\"\r\n              ></vnext-widget-plan-card>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n    <ng-template #threeTiles>\r\n      <ng-container *ngIf=\"plans.length === 3; else twoTiles\">\r\n        <div class=\"col-12\">\r\n          <vnext-widget-plan-card-tile\r\n            [plans]=\"plans\"\r\n            [planCardQuoteLinkText]=\"planCardQuoteLinkText\"\r\n            [planDetailsButtonText]=\"planDetailsButtonText\"\r\n            [planTypeText]=\"planTypeText\"\r\n            [addOnCoverageText]=\"addOnCoverageText\"\r\n            [addOnCoverageTooltipBody]=\"addOnCoverageTooltip\"\r\n            [planDetailsNonCoveredText]=\"planDetailsNonCoveredText\"\r\n            [prescriptionText]=\"prescriptionText\"\r\n            [pharmacyText]=\"pharmacyText\"\r\n            [isTotalEstimatedCostEnabled]=\"isTotalEstimatedCostEnabled\"\r\n            [totalEstimatedAnnualCostText]=\"totalEstimatedAnnualCostText\"\r\n            [totalEstimatedCostText]=\"totalEstimatedCostText\"\r\n            [totalEstimatedCostTooltip]=\"totalEstimatedCostTooltip\"\r\n            [showPlanLogo]=\"showPlanLogo\"\r\n            [planBenefits]=\"benefits\"\r\n            [planPreferences]=\"benefitPreferences\"\r\n            [showRidersOnPlanCards]=\"showRidersOnPlanCards\"\r\n            [showPremiumAsAnnual]=\"showPremiumAsAnnual\"\r\n            [riderDisplayMap]=\"riderDisplayMap\"\r\n            [shoppingCartEnabled]=\"shoppingCartEnabled\"\r\n            [drugCoveredText]=\"drugCoveredText\"\r\n            [pharmacyCoveredText]=\"pharmacyCoveredText\"\r\n            [displayDrugsCovered]=\"displayDrugsCovered\"\r\n            [displayOptionLabels]=\"displayOptionLabels\"\r\n            [hidePlanCardLabel]=\"hidePlanCardLabel\"\r\n            [planBenefitNoValueLabel]=\"planBenefitNoValueLabel\"\r\n            [currentPlanText]=\"currentPlanText\"\r\n            [nextYearPlanText]=\"nextYearPlanText\"\r\n            [isQuoting]=\"isQuoting\"\r\n            (quoteClicked)=\"quoteClick()\"\r\n            (viewPlanDetails)=\"viewPlanDetailsPage($event)\"\r\n            [Spa_Site_ShowRiderIcons]=\"Spa_Site_ShowRiderIcons\"\r\n            [Spa_Site_Dental_Rider_Display_Text]=\"Spa_Site_Dental_Rider_Display_Text\"\r\n            [Spa_Site_Vision_Rider_Display_Text]=\"Spa_Site_Vision_Rider_Display_Text\"\r\n            [Spa_Site_Hearing_Rider_Display_Text]=\"Spa_Site_Hearing_Rider_Display_Text\"\r\n            [Spa_PlanCard_DentalAddOnCoverage_Text]=\"Spa_PlanCard_DentalAddOnCoverage_Text\"\r\n            [Spa_PlanCard_HearingAddOnCoverage_Text]=\"Spa_PlanCard_HearingAddOnCoverage_Text\"\r\n            [Spa_PlanCard_VisionAddOnCoverage_Text]=\"Spa_PlanCard_VisionAddOnCoverage_Text\"\r\n            [Spa_PlanCard_AddOnCoverage_Text]=\"Spa_PlanCard_AddOnCoverage_Text\"\r\n            [Spa_Site_MedigapPlanType_Enabled]=\"Spa_Site_MedigapPlanType_Enabled\"\r\n            [Spa_Site_AddToCompare_Enabled]=\"Spa_Site_AddToCompare_Enabled\"\r\n            [Spa_Site_PlanViewDetails_Enabled]=\"Spa_Site_PlanViewDetails_Enabled\"\r\n            [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n            [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n            [inNetworkStandardText]=\"inNetworkStandardText\"\r\n            [outOfNetworkText]=\"outOfNetworkText\"\r\n            [isMailOrderSelected]=\"isMailOrderSelected\"\r\n            [viewCostTooltipHeaderText]=\"viewCostTooltipHeaderText\"\r\n            [viewCostTooltipHeaderContent]=\"viewCostTooltipHeaderContent\"\r\n            [mailOrderText]=\"mailOrderText\"\r\n            [providersInNetworkText]=\"providersInNetworkText\"\r\n            [pcpInNetworkText]=\"pcpInNetworkText\"\r\n            [pcpOutOfNetworkText]=\"pcpOutOfNetworkText\"\r\n            [providersNoDataText]=\"providersNoDataText\"\r\n            [isProviderEnabled]=\"isProviderEnabled\"\r\n            [selectedProviders]=\"selectedProviders\"\r\n            [providerDetails]=\"providerDetails\"\r\n            [medicineCabinet]=\"medicineCabinet\"\r\n            [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n            [planLogoSize]=\"planLogoSize\"\r\n            [loaderIconEnabled]=\"loaderIconEnabled\"\r\n            [editLinkText]=\"editLinkText\"\r\n            [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n            [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n            [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n            [planFeesEnabled]=\"planFeesEnabled\"\r\n            [planFeesTooltipText]=\"planFeesTooltipText\"\r\n            [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n            [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n            [showPlanYear]=\"showPlanYear\"\r\n            [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n            [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n          ></vnext-widget-plan-card-tile>\r\n        </div>\r\n      </ng-container>\r\n    </ng-template>\r\n    <ng-template #twoTiles>\r\n      <div class=\"col-12\">\r\n        <vnext-plan-card-two-tiles\r\n          [plans]=\"plans\"\r\n          [planCardQuoteLinkText]=\"planCardQuoteLinkText\"\r\n          [planDetailsButtonText]=\"planDetailsButtonText\"\r\n          [planTypeText]=\"planTypeText\"\r\n          [addOnCoverageText]=\"addOnCoverageText\"\r\n          [addOnCoverageTooltipBody]=\"addOnCoverageTooltip\"\r\n          [planDetailsNonCoveredText]=\"planDetailsNonCoveredText\"\r\n          [prescriptionText]=\"prescriptionText\"\r\n          [pharmacyText]=\"pharmacyText\"\r\n          [isTotalEstimatedCostEnabled]=\"isTotalEstimatedCostEnabled\"\r\n          [totalEstimatedAnnualCostText]=\"totalEstimatedAnnualCostText\"\r\n          [totalEstimatedCostText]=\"totalEstimatedCostText\"\r\n          [totalEstimatedCostTooltip]=\"totalEstimatedCostTooltip\"\r\n          [showPlanLogo]=\"showPlanLogo\"\r\n          [planBenefits]=\"benefits\"\r\n          [planPreferences]=\"benefitPreferences\"\r\n          [showRidersOnPlanCards]=\"showRidersOnPlanCards\"\r\n          [showPremiumAsAnnual]=\"showPremiumAsAnnual\"\r\n          [riderDisplayMap]=\"riderDisplayMap\"\r\n          [shoppingCartEnabled]=\"shoppingCartEnabled\"\r\n          [drugCoveredText]=\"drugCoveredText\"\r\n          [pharmacyCoveredText]=\"pharmacyCoveredText\"\r\n          [displayDrugsCovered]=\"displayDrugsCovered\"\r\n          [displayOptionLabels]=\"displayOptionLabels\"\r\n          [hidePlanCardLabel]=\"hidePlanCardLabel\"\r\n          [planBenefitNoValueLabel]=\"planBenefitNoValueLabel\"\r\n          [currentPlanText]=\"currentPlanText\"\r\n          [nextYearPlanText]=\"nextYearPlanText\"\r\n          [isQuoting]=\"isQuoting\"\r\n          (quoteClicked)=\"quoteClick()\"\r\n          (viewPlanDetails)=\"viewPlanDetailsPage($event)\"\r\n          [Spa_Site_ShowRiderIcons]=\"Spa_Site_ShowRiderIcons\"\r\n          [Spa_Site_Dental_Rider_Display_Text]=\"Spa_Site_Dental_Rider_Display_Text\"\r\n          [Spa_Site_Vision_Rider_Display_Text]=\"Spa_Site_Vision_Rider_Display_Text\"\r\n          [Spa_Site_Hearing_Rider_Display_Text]=\"Spa_Site_Hearing_Rider_Display_Text\"\r\n          [Spa_PlanCard_DentalAddOnCoverage_Text]=\"Spa_PlanCard_DentalAddOnCoverage_Text\"\r\n          [Spa_PlanCard_HearingAddOnCoverage_Text]=\"Spa_PlanCard_HearingAddOnCoverage_Text\"\r\n          [Spa_PlanCard_VisionAddOnCoverage_Text]=\"Spa_PlanCard_VisionAddOnCoverage_Text\"\r\n          [Spa_PlanCard_AddOnCoverage_Text]=\"Spa_PlanCard_AddOnCoverage_Text\"\r\n          [Spa_Site_MedigapPlanType_Enabled]=\"Spa_Site_MedigapPlanType_Enabled\"\r\n          [Spa_Site_AddToCompare_Enabled]=\"Spa_Site_AddToCompare_Enabled\"\r\n          [Spa_Site_PlanViewDetails_Enabled]=\"Spa_Site_PlanViewDetails_Enabled\"\r\n          [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n          [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n          [inNetworkStandardText]=\"inNetworkStandardText\"\r\n          [outOfNetworkText]=\"outOfNetworkText\"\r\n          [isMailOrderSelected]=\"isMailOrderSelected\"\r\n          [viewCostTooltipHeaderText]=\"viewCostTooltipHeaderText\"\r\n          [viewCostTooltipHeaderContent]=\"viewCostTooltipHeaderContent\"\r\n          [mailOrderText]=\"mailOrderText\"\r\n          [providersInNetworkText]=\"providersInNetworkText\"\r\n          [pcpInNetworkText]=\"pcpInNetworkText\"\r\n          [pcpOutOfNetworkText]=\"pcpOutOfNetworkText\"\r\n          [providersNoDataText]=\"providersNoDataText\"\r\n          [isProviderEnabled]=\"isProviderEnabled\"\r\n          [selectedProviders]=\"selectedProviders\"\r\n          [providerDetails]=\"providerDetails\"\r\n          [viewDetailsDescriptionText]=\"viewDetailsDescriptionText\"\r\n          [medicineCabinet]=\"medicineCabinet\"\r\n          [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n          [planLogoSize]=\"planLogoSize\"\r\n          [loaderIconEnabled]=\"loaderIconEnabled\"\r\n          [editLinkText]=\"editLinkText\"\r\n          [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n          [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n          [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n          [planFeesEnabled]=\"planFeesEnabled\"\r\n          [planFeesTooltipText]=\"planFeesTooltipText\"\r\n          [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n          [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n          [showPlanYear]=\"showPlanYear\"\r\n          [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n          [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n        ></vnext-plan-card-two-tiles>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n</div>\r\n" }]
    }], null, { plans: [{
            type: Input
        }], pickPlanText: [{
            type: Input
        }], PlanStep: [{
            type: Input
        }], planCardQuoteLinkText: [{
            type: Input
        }], showPlanLogo: [{
            type: Input
        }], planDetailsButtonText: [{
            type: Input
        }], planBenefitNoValueLabel: [{
            type: Input
        }], planTypeText: [{
            type: Input
        }], addOnCoverageText: [{
            type: Input
        }], addOnCoverageTooltip: [{
            type: Input
        }], planDetailsNonCoveredText: [{
            type: Input
        }], prescriptionText: [{
            type: Input
        }], pharmacyText: [{
            type: Input
        }], isTotalEstimatedCostEnabled: [{
            type: Input
        }], totalEstimatedAnnualCostText: [{
            type: Input
        }], totalEstimatedCostText: [{
            type: Input
        }], totalEstimatedCostTooltip: [{
            type: Input
        }], showRidersOnPlanCards: [{
            type: Input
        }], showPremiumAsAnnual: [{
            type: Input
        }], riderDisplayMap: [{
            type: Input
        }], shoppingCartEnabled: [{
            type: Input
        }], drugCoveredText: [{
            type: Input
        }], displayOptionLabels: [{
            type: Input
        }], hidePlanCardLabel: [{
            type: Input
        }], pharmacyCoveredText: [{
            type: Input
        }], displayDrugsCovered: [{
            type: Input
        }], benefits: [{
            type: Input
        }], benefitPreferences: [{
            type: Input
        }], currentPlanText: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], nextYearPlanText: [{
            type: Input
        }], isQuoting: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], inNetworkPreferredText: [{
            type: Input
        }], inNetworkStandardText: [{
            type: Input
        }], outOfNetworkText: [{
            type: Input
        }], isMailOrderSelected: [{
            type: Input
        }], viewCostTooltipHeaderText: [{
            type: Input
        }], viewCostTooltipHeaderContent: [{
            type: Input
        }], mailOrderText: [{
            type: Input
        }], providersInNetworkText: [{
            type: Input
        }], pcpInNetworkText: [{
            type: Input
        }], pcpOutOfNetworkText: [{
            type: Input
        }], providersNoDataText: [{
            type: Input
        }], isProviderEnabled: [{
            type: Input
        }], selectedProviders: [{
            type: Input
        }], providerDetails: [{
            type: Input
        }], Spa_Site_ShowRiderIcons: [{
            type: Input
        }], Spa_Site_Dental_Rider_Display_Text: [{
            type: Input
        }], Spa_Site_Vision_Rider_Display_Text: [{
            type: Input
        }], Spa_Site_Hearing_Rider_Display_Text: [{
            type: Input
        }], Spa_PlanCard_DentalAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_HearingAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_VisionAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_AddOnCoverage_Text: [{
            type: Input
        }], Spa_Site_MedigapPlanType_Enabled: [{
            type: Input
        }], Spa_Site_AddToCompare_Enabled: [{
            type: Input
        }], Spa_Site_PlanViewDetails_Enabled: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }], viewDetailsDescriptionText: [{
            type: Input
        }], medicineCabinet: [{
            type: Input
        }], planCardPreferenceDetailedEnabled: [{
            type: Input
        }], planLogoSize: [{
            type: Input
        }], loaderIconEnabled: [{
            type: Input
        }], editLinkText: [{
            type: Input
        }], providerOneOrMoreOutOfNetworkText: [{
            type: Input
        }], providerInNetworkOnOtherLocationsTooltipText: [{
            type: Input
        }], providerShowPartialIndicatorEnabled: [{
            type: Input
        }], planFeesEnabled: [{
            type: Input
        }], planFeesTooltipText: [{
            type: Input
        }], planFeesIncludedInPremiumTooltipText: [{
            type: Input
        }], planFeesNotIncludedInPremiumTooltipText: [{
            type: Input
        }], showPlanId: [{
            type: Input
        }], showPlanYear: [{
            type: Input
        }], planIdText: [{
            type: Input
        }], availableText: [{
            type: Input
        }], unavailableText: [{
            type: Input
        }], viewProvidersButtonText: [{
            type: Input
        }], viewPrescriptionsButtonText: [{
            type: Input
        }], supplementalBenefitsHighlightText: [{
            type: Input
        }], preferencesText: [{
            type: Input
        }], viewMoreDetailsText: [{
            type: Input
        }], hideDetailsText: [{
            type: Input
        }], newPlanCardDesignEnabled: [{
            type: Input
        }], viewAllPlanDetailsText: [{
            type: Input
        }], shareThisPlanText: [{
            type: Input
        }], viewCostDetailsText: [{
            type: Input
        }], closeText: [{
            type: Input
        }], planBenefitHighlightItems: [{
            type: Input
        }], planBenefitHighlightsHeaderText: [{
            type: Input
        }], showRiderDetails: [{
            type: Input
        }], hideRiderDetailsText: [{
            type: Input
        }], showRiderDetailsText: [{
            type: Input
        }], riderIsIncludedText: [{
            type: Input
        }], waiverStateRiderTooltips: [{
            type: Input
        }], costMA: [{
            type: Input
        }], costMAPD: [{
            type: Input
        }], costMEDIGAP: [{
            type: Input
        }], costPDP: [{
            type: Input
        }], costDENTAL: [{
            type: Input
        }], costVISION: [{
            type: Input
        }], quoteClicked: [{
            type: Output
        }], viewPlanDetails: [{
            type: Output
        }] }); })();

function QualifiedHelpSummaryComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "vnext-link", 6);
    i0.ɵɵlistener("click", function QualifiedHelpSummaryComponent_span_4_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.onClick()); });
    i0.ɵɵelementStart(2, "div", 7);
    i0.ɵɵelement(3, "i", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ariaLabel", ctx_r0.preferencesEditText + " " + ctx_r0.qualifiedHelpText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.preferencesEditText, "");
} }
function QualifiedHelpSummaryComponent_ul_5_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, ":");
    i0.ɵɵelementContainerEnd();
} }
function QualifiedHelpSummaryComponent_ul_5_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "%");
    i0.ɵɵelementEnd();
} }
function QualifiedHelpSummaryComponent_ul_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 9)(1, "li");
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, QualifiedHelpSummaryComponent_ul_5_ng_container_3_Template, 2, 0, "ng-container", 3);
    i0.ɵɵtext(4);
    i0.ɵɵtemplate(5, QualifiedHelpSummaryComponent_ul_5_span_5_Template, 2, 0, "span", 3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.subsidySelected, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.subsidySelected && ctx_r1.subsidyPercentage);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.subsidyPercentage, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.subsidyPercentage);
} }
function QualifiedHelpSummaryComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-link", 10)(1, "div", 11);
    i0.ɵɵelement(2, "i", 12);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tag", ctx_r3.pageTags.GUIDED_HELP_GETTING_STARTED)("ariaLabel", ctx_r3.addLinkText + " " + ctx_r3.qualifiedHelpText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.addLinkText);
} }
class QualifiedHelpSummaryComponent {
    constructor() {
        this.analyticsEvent = new EventEmitter();
        this.pageTags = PageTags;
    }
    onClick() {
        this.analyticsEvent.emit();
    }
}
QualifiedHelpSummaryComponent.ɵfac = function QualifiedHelpSummaryComponent_Factory(t) { return new (t || QualifiedHelpSummaryComponent)(); };
QualifiedHelpSummaryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: QualifiedHelpSummaryComponent, selectors: [["vnext-summary-qualified-help"]], inputs: { qualifiedHelpText: "qualifiedHelpText", subsidySelected: "subsidySelected", subsidyPercentage: "subsidyPercentage", addLinkText: "addLinkText", preferencesEditText: "preferencesEditText", tag: "tag" }, outputs: { analyticsEvent: "analyticsEvent" }, decls: 8, vars: 4, consts: [["aria-hidden", "true", 1, "fas", "Spa_Style_GettingStartedIcon", "Spa_Style_Larger_Font"], [1, "Spa_Style_Regular_Font", "Spa_Style_Semi_Bold_Weight", "my-1", "pr-2"], [1, "Spa_Style_Regular_Font"], [4, "ngIf"], ["class", "Spa_Style_Small_Font pl-3", 4, "ngIf", "ngIfElse"], ["showAddLink", ""], [1, "float-right", 3, "ariaLabel", "click"], ["link-body", ""], ["aria-hidden", "true", 1, "pt-1", "pr-2"], [1, "Spa_Style_Small_Font", "pl-3"], [3, "tag", "ariaLabel"], ["tag-image-body", "", 1, "pl-2"], ["aria-hidden", "true", 1, "fas", "fa-plus-circle", "mr-1"]], template: function QualifiedHelpSummaryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "i", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "h3", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, QualifiedHelpSummaryComponent_span_4_Template, 5, 2, "span", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, QualifiedHelpSummaryComponent_ul_5_Template, 6, 4, "ul", 4);
        i0.ɵɵtemplate(6, QualifiedHelpSummaryComponent_ng_template_6_Template, 4, 3, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(7);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.qualifiedHelpText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.subsidySelected && ctx.preferencesEditText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.subsidySelected)("ngIfElse", _r2);
    } }, dependencies: [i1$2.NgIf, LinkComponent, IconAriaAttributesDirective], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QualifiedHelpSummaryComponent, [{
        type: Component,
        args: [{ selector: 'vnext-summary-qualified-help', changeDetection: ChangeDetectionStrategy.OnPush, template: "<i class=\"fas Spa_Style_GettingStartedIcon Spa_Style_Larger_Font\" aria-hidden=\"true\"></i>\r\n<div class=\"Spa_Style_Regular_Font Spa_Style_Semi_Bold_Weight my-1 pr-2\">\r\n  <h3 class=\"Spa_Style_Regular_Font\">{{ qualifiedHelpText }}</h3>\r\n  <span *ngIf=\"subsidySelected && preferencesEditText\">\r\n    <vnext-link (click)=\"onClick()\" class=\"float-right\" [ariaLabel]=\"preferencesEditText + ' ' + qualifiedHelpText\">\r\n      <div link-body><i class=\"pt-1 pr-2\" aria-hidden=\"true\"></i> {{ preferencesEditText }}</div>\r\n    </vnext-link>\r\n  </span>\r\n</div>\r\n<ul class=\"Spa_Style_Small_Font pl-3\" *ngIf=\"subsidySelected; else showAddLink\">\r\n  <li>\r\n    {{ subsidySelected }}<ng-container *ngIf=\"subsidySelected && subsidyPercentage\">:</ng-container>\r\n    {{ subsidyPercentage }}\r\n    <span *ngIf=\"subsidyPercentage\">%</span>\r\n  </li>\r\n</ul>\r\n<ng-template #showAddLink>\r\n  <vnext-link [tag]=\"pageTags.GUIDED_HELP_GETTING_STARTED\" [ariaLabel]=\"addLinkText + ' ' + qualifiedHelpText\">\r\n    <div class=\"pl-2\" tag-image-body><i class=\"fas fa-plus-circle mr-1\" aria-hidden=\"true\"></i>{{ addLinkText }}</div>\r\n  </vnext-link>\r\n</ng-template>\r\n" }]
    }], null, { qualifiedHelpText: [{
            type: Input
        }], subsidySelected: [{
            type: Input
        }], subsidyPercentage: [{
            type: Input
        }], addLinkText: [{
            type: Input
        }], preferencesEditText: [{
            type: Input
        }], tag: [{
            type: Input
        }], analyticsEvent: [{
            type: Output
        }] }); })();

function QuoteSummaryPreferencesComponent_div_1_h2_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h2", 11);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r1.addPreferencesText, "html"), i0.ɵɵsanitizeHtml);
} }
function QuoteSummaryPreferencesComponent_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "vnext-summary-qualified-help", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("qualifiedHelpText", ctx_r2.qualifiedHelpText)("subsidySelected", ctx_r2.subsidySelected)("subsidyPercentage", ctx_r2.subsidyPercentage)("addLinkText", ctx_r2.addLinkText);
} }
function QuoteSummaryPreferencesComponent_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "i", 14);
    i0.ɵɵelementStart(2, "div", 15);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "ul", 16)(5, "li");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "li");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.healthText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.selectedHealthStatus);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.ageRange);
} }
function QuoteSummaryPreferencesComponent_div_1_div_6_vnext_link_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-link", 21)(1, "div", 22);
    i0.ɵɵelement(2, "i", 23);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("tag", ctx_r6.pageTags.GUIDED_HELP_PRESCRIPTIONS);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r6.addLinkText);
} }
function QuoteSummaryPreferencesComponent_div_1_div_6_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26)(1, "vnext-link", 27);
    i0.ɵɵlistener("click", function QuoteSummaryPreferencesComponent_div_1_div_6_div_5_div_1_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r12.showAllMedicineLabels = !ctx_r12.showAllMedicineLabels); })("keyup.enter", function QuoteSummaryPreferencesComponent_div_1_div_6_div_5_div_1_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r14.showAllMedicineLabels = !ctx_r14.showAllMedicineLabels); });
    i0.ɵɵelementStart(2, "div", 28);
    i0.ɵɵtext(3);
    i0.ɵɵelement(4, "i");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("makeInlineBlock", true)("keyNameForLiveEdit", "Spa_GuidedHelp_HideMedicineLink_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r10.linkText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r10.icon);
} }
function QuoteSummaryPreferencesComponent_div_1_div_6_div_5_li_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const medicine_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", medicine_r8.drugDetails.drugName, " ");
} }
function QuoteSummaryPreferencesComponent_div_1_div_6_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, QuoteSummaryPreferencesComponent_div_1_div_6_div_5_div_1_Template, 5, 6, "div", 24);
    i0.ɵɵelementStart(2, "ul", 25);
    i0.ɵɵtemplate(3, QuoteSummaryPreferencesComponent_div_1_div_6_div_5_li_3_Template, 2, 1, "li", 1);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const index_r9 = ctx.index;
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", index_r9 === ctx_r7.maxDrugVisibleCount);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", index_r9 < ctx_r7.maxDrugVisibleCount || ctx_r7.showAllMedicineLabels);
} }
function QuoteSummaryPreferencesComponent_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "i", 18);
    i0.ɵɵelementStart(2, "div", 15);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, QuoteSummaryPreferencesComponent_div_1_div_6_vnext_link_4_Template, 4, 2, "vnext-link", 19);
    i0.ɵɵtemplate(5, QuoteSummaryPreferencesComponent_div_1_div_6_div_5_Template, 4, 2, "div", 20);
    i0.ɵɵpipe(6, "orderBy");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r4.prescriptionsText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.medicineCabinet.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind4(6, 3, ctx_r4.medicineCabinet, "drugDetails.drugName", false, true));
} }
function QuoteSummaryPreferencesComponent_div_1_div_7_vnext_link_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-link", 21)(1, "div", 22);
    i0.ɵɵelement(2, "i", 23);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("tag", ctx_r16.pageTags.GUIDED_HELP_PHARMACY_SEARCH);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r16.addLinkText);
} }
function QuoteSummaryPreferencesComponent_div_1_div_7_ng_container_5_div_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", ctx_r22.primaryPharmacyIndicatorText, ")");
} }
function QuoteSummaryPreferencesComponent_div_1_div_7_ng_container_5_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33)(1, "li")(2, "span", 34);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, QuoteSummaryPreferencesComponent_div_1_div_7_ng_container_5_div_2_span_4_Template, 2, 1, "span", 1);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const selectedPharmacy_r21 = ctx.$implicit;
    const ctx_r20 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r20.displayLabel(selectedPharmacy_r21.name));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", selectedPharmacy_r21.pharmacyId === ctx_r20.primaryPharmacy.pharmacyId);
} }
function QuoteSummaryPreferencesComponent_div_1_div_7_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ul", 16);
    i0.ɵɵtemplate(2, QuoteSummaryPreferencesComponent_div_1_div_7_ng_container_5_div_2_Template, 5, 2, "div", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r17.selectedPharmacies);
} }
function QuoteSummaryPreferencesComponent_div_1_div_7_ng_template_6_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 35)(2, "span", 34);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r23.displayLabel(ctx_r23.selectedPharmacy.name));
} }
function QuoteSummaryPreferencesComponent_div_1_div_7_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, QuoteSummaryPreferencesComponent_div_1_div_7_ng_template_6_ng_container_0_Template, 4, 1, "ng-container", 1);
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r19.selectedPharmacy);
} }
function QuoteSummaryPreferencesComponent_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "i", 29);
    i0.ɵɵelementStart(2, "div", 15);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, QuoteSummaryPreferencesComponent_div_1_div_7_vnext_link_4_Template, 4, 2, "vnext-link", 19);
    i0.ɵɵtemplate(5, QuoteSummaryPreferencesComponent_div_1_div_7_ng_container_5_Template, 3, 1, "ng-container", 30);
    i0.ɵɵtemplate(6, QuoteSummaryPreferencesComponent_div_1_div_7_ng_template_6_Template, 1, 1, "ng-template", null, 31, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r18 = i0.ɵɵreference(7);
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r5.pharmacyText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r5.selectedPharmacy);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.multiPharmacyEnabled)("ngIfElse", _r18);
} }
function QuoteSummaryPreferencesComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 2);
    i0.ɵɵtemplate(2, QuoteSummaryPreferencesComponent_div_1_h2_2_Template, 2, 4, "h2", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵtemplate(4, QuoteSummaryPreferencesComponent_div_1_div_4_Template, 2, 4, "div", 5);
    i0.ɵɵtemplate(5, QuoteSummaryPreferencesComponent_div_1_div_5_Template, 9, 3, "div", 5);
    i0.ɵɵtemplate(6, QuoteSummaryPreferencesComponent_div_1_div_6_Template, 7, 8, "div", 6);
    i0.ɵɵtemplate(7, QuoteSummaryPreferencesComponent_div_1_div_7_Template, 8, 4, "div", 5);
    i0.ɵɵelementStart(8, "div", 7)(9, "vnext-link", 8);
    i0.ɵɵlistener("click", function QuoteSummaryPreferencesComponent_div_1_Template_vnext_link_click_9_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r24.quoteFacade.redirectGuidedHelpPages()); })("keyup.enter", function QuoteSummaryPreferencesComponent_div_1_Template_vnext_link_keyup_enter_9_listener() { i0.ɵɵrestoreView(_r25); const ctx_r26 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r26.quoteFacade.redirectGuidedHelpPages()); });
    i0.ɵɵelementStart(10, "div", 9);
    i0.ɵɵelement(11, "i", 10);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Summary_AddPreferences_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showSubsidyAccordion);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.healthEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.prescriptionsEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.pharmacyEnabled);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", ctx_r0.preferencesEditDescription);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.preferencesEditText, "");
} }
class QuoteSummaryPreferencesComponent {
    constructor(guidedHelpService, quoteFacade) {
        this.guidedHelpService = guidedHelpService;
        this.quoteFacade = quoteFacade;
        this.showAllMedicineLabels = false;
        this.pageTags = PageTags;
        this.maxDrugVisibleCount = 5;
    }
    get icon() {
        return `fas ${this.showAllMedicineLabels ? 'fa-angle-up' : ' fa-angle-down'}`;
    }
    get linkText() {
        return this.showAllMedicineLabels ? this.guidedHelpHideMedicineLinkText : this.guidedHelpViewMedicineLinkText;
    }
    displayLabel(label) {
        return label.length > 17 ? `${label.substr(0, 14)}...` : label;
    }
}
QuoteSummaryPreferencesComponent.ɵfac = function QuoteSummaryPreferencesComponent_Factory(t) { return new (t || QuoteSummaryPreferencesComponent)(i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(QuoteFacade)); };
QuoteSummaryPreferencesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: QuoteSummaryPreferencesComponent, selectors: [["vnext-quote-summary-preferences"]], inputs: { addPreferencesText: "addPreferencesText", healthText: "healthText", qualifiedHelpText: "qualifiedHelpText", prescriptionsText: "prescriptionsText", pharmacyText: "pharmacyText", guidedHelpHideMedicineLinkText: "guidedHelpHideMedicineLinkText", guidedHelpViewMedicineLinkText: "guidedHelpViewMedicineLinkText", guidedHelpEnabled: "guidedHelpEnabled", getStartedEnabled: "getStartedEnabled", healthEnabled: "healthEnabled", showSubsidyAccordion: "showSubsidyAccordion", prescriptionsEnabled: "prescriptionsEnabled", pharmacyEnabled: "pharmacyEnabled", selectedPharmacy: "selectedPharmacy", medicineCabinet: "medicineCabinet", preferencesEditText: "preferencesEditText", addLinkText: "addLinkText", selectedHealthStatus: "selectedHealthStatus", subsidySelected: "subsidySelected", subsidyPercentage: "subsidyPercentage", ageRange: "ageRange", preferencesEditDescription: "preferencesEditDescription", selectedPharmacies: "selectedPharmacies", multiPharmacyEnabled: "multiPharmacyEnabled", primaryPharmacy: "primaryPharmacy", primaryPharmacyIndicatorText: "primaryPharmacyIndicatorText" }, decls: 2, vars: 1, consts: [[1, "container"], [4, "ngIf"], [1, "row", "mt-2", "mx-0", "mb-1"], ["class", "pt-3 Spa_Style_Large_Font", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [1, "row", "my-2", "mx-0", "rounded", "preferences-wrapper"], ["class", "col-xs-12 col-md-6 col-lg-3 align-self-start", 4, "ngIf"], ["class", "col-xs-12 col-md-6 col-lg-3 align-self-start mb-3", 4, "ngIf"], [1, "d-flex", "align-self-start", "edit-link"], [1, "float-right", 3, "click", "keyup.enter"], ["link-body", ""], ["aria-hidden", "true", 1, "fas", "fa-edit", "pt-1"], ["navigationAdapter", "", 1, "pt-3", "Spa_Style_Large_Font", 3, "innerHtml"], [1, "col-xs-12", "col-md-6", "col-lg-3", "align-self-start"], [3, "qualifiedHelpText", "subsidySelected", "subsidyPercentage", "addLinkText"], ["aria-hidden", "true", 1, "fas", "Spa_Style_HealthIcon", "Spa_Style_Larger_Font"], [1, "Spa_Style_Regular_Font", "Spa_Style_Semi_Bold_Weight"], [1, "Spa_Style_Small_Font", "pl-4"], [1, "col-xs-12", "col-md-6", "col-lg-3", "align-self-start", "mb-3"], ["aria-hidden", "true", 1, "fas", "Spa_Style_PrescriptionsIcon", "Spa_Style_Larger_Font"], [3, "tag", 4, "ngIf"], [4, "ngFor", "ngForOf"], [3, "tag"], ["tag-image-body", "", 1, "pl-2"], ["aria-hidden", "true", 1, "fas", "fa-plus-circle", "mr-1"], ["class", "mb-1", 4, "ngIf"], [1, "Spa_Style_Small_Font", "pl-4", "mb-1", "no-translate-block"], [1, "mb-1"], [3, "makeInlineBlock", "keyNameForLiveEdit", "click", "keyup.enter"], ["link-body", "", 1, "pl-2"], ["aria-hidden", "true", 1, "fas", "Spa_Style_PharmacyIcon", "Spa_Style_Larger_Font"], [4, "ngIf", "ngIfElse"], ["pharmacyDetail", ""], ["class", "Spa_Style_Small_Font mb-1", 4, "ngFor", "ngForOf"], [1, "Spa_Style_Small_Font", "mb-1"], [1, "no-translate-block"], [1, "Spa_Style_Small_Font", "Spa_Style_Gray4_Color", "mb-2", "pl-2"]], template: function QuoteSummaryPreferencesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, QuoteSummaryPreferencesComponent_div_1_Template, 13, 7, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.guidedHelpEnabled);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, LinkComponent, NavigationAdapterDirective, LiveEditPropDirective, IconAriaAttributesDirective, QualifiedHelpSummaryComponent, SafePipe, OrderPipe], styles: [".preferences-wrapper[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);padding:20px 0;align-items:center;position:relative}.edit-link[_ngcontent-%COMP%]{position:absolute;right:20px;top:10px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QuoteSummaryPreferencesComponent, [{
        type: Component,
        args: [{ selector: 'vnext-quote-summary-preferences', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container\">\r\n  <div *ngIf=\"guidedHelpEnabled\">\r\n    <div class=\"row mt-2 mx-0 mb-1\">\r\n      <h2\r\n        class=\"pt-3 Spa_Style_Large_Font\"\r\n        *liveEditProp=\"'Spa_Summary_AddPreferences_Text'\"\r\n        [innerHtml]=\"addPreferencesText | safe : 'html'\"\r\n        navigationAdapter\r\n      ></h2>\r\n    </div>\r\n\r\n    <div class=\"row my-2 mx-0 rounded preferences-wrapper\">\r\n      <div class=\"col-xs-12 col-md-6 col-lg-3 align-self-start\" *ngIf=\"showSubsidyAccordion\">\r\n        <vnext-summary-qualified-help\r\n          [qualifiedHelpText]=\"qualifiedHelpText\"\r\n          [subsidySelected]=\"subsidySelected\"\r\n          [subsidyPercentage]=\"subsidyPercentage\"\r\n          [addLinkText]=\"addLinkText\"\r\n        >\r\n        </vnext-summary-qualified-help>\r\n      </div>\r\n\r\n      <div class=\"col-xs-12 col-md-6 col-lg-3 align-self-start\" *ngIf=\"healthEnabled\">\r\n        <i class=\"fas Spa_Style_HealthIcon Spa_Style_Larger_Font\" aria-hidden=\"true\"></i>\r\n        <div class=\"Spa_Style_Regular_Font Spa_Style_Semi_Bold_Weight\">{{ healthText }}</div>\r\n        <ul class=\"Spa_Style_Small_Font pl-4\">\r\n          <li>{{ selectedHealthStatus }}</li>\r\n          <li>{{ ageRange }}</li>\r\n        </ul>\r\n      </div>\r\n\r\n      <div class=\"col-xs-12 col-md-6 col-lg-3 align-self-start mb-3\" *ngIf=\"prescriptionsEnabled\">\r\n        <i class=\"fas Spa_Style_PrescriptionsIcon Spa_Style_Larger_Font\" aria-hidden=\"true\"></i>\r\n        <div class=\"Spa_Style_Regular_Font Spa_Style_Semi_Bold_Weight\">{{ prescriptionsText }}</div>\r\n        <vnext-link *ngIf=\"medicineCabinet.length === 0\" [tag]=\"pageTags.GUIDED_HELP_PRESCRIPTIONS\">\r\n          <div class=\"pl-2\" tag-image-body><i class=\"fas fa-plus-circle mr-1\" aria-hidden=\"true\"></i>{{ addLinkText }}</div>\r\n        </vnext-link>\r\n        <div *ngFor=\"let medicine of medicineCabinet | orderBy : 'drugDetails.drugName' : false : true; index as index\">\r\n          <div *ngIf=\"index === maxDrugVisibleCount\" class=\"mb-1\">\r\n            <vnext-link\r\n              [makeInlineBlock]=\"true\"\r\n              [keyNameForLiveEdit]=\"'Spa_GuidedHelp_HideMedicineLink_Text'\"\r\n              (click)=\"showAllMedicineLabels = !showAllMedicineLabels\"\r\n              (keyup.enter)=\"showAllMedicineLabels = !showAllMedicineLabels\"\r\n            >\r\n              <div class=\"pl-2\" link-body>{{ linkText }} <i class=\"{{ icon }}\"></i></div>\r\n            </vnext-link>\r\n          </div>\r\n          <ul class=\"Spa_Style_Small_Font pl-4 mb-1 no-translate-block\">\r\n            <li *ngIf=\"index < maxDrugVisibleCount || showAllMedicineLabels\">\r\n              {{ medicine.drugDetails.drugName }}\r\n            </li>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"col-xs-12 col-md-6 col-lg-3 align-self-start\" *ngIf=\"pharmacyEnabled\">\r\n        <i class=\"fas Spa_Style_PharmacyIcon Spa_Style_Larger_Font\" aria-hidden=\"true\"></i>\r\n        <div class=\"Spa_Style_Regular_Font Spa_Style_Semi_Bold_Weight\">{{ pharmacyText }}</div>\r\n        <vnext-link *ngIf=\"!selectedPharmacy\" [tag]=\"pageTags.GUIDED_HELP_PHARMACY_SEARCH\">\r\n          <div class=\"pl-2\" tag-image-body><i class=\"fas fa-plus-circle mr-1\" aria-hidden=\"true\"></i>{{ addLinkText }}</div>\r\n        </vnext-link>\r\n        <ng-container *ngIf=\"multiPharmacyEnabled; else pharmacyDetail\">\r\n          <ul class=\"Spa_Style_Small_Font pl-4\"> \r\n            <div class=\"Spa_Style_Small_Font mb-1\" *ngFor=\"let selectedPharmacy of selectedPharmacies\">\r\n              <li>\r\n                <span class=\"no-translate-block\">{{ displayLabel(selectedPharmacy.name) }}</span>\r\n                <span *ngIf=\"selectedPharmacy.pharmacyId === primaryPharmacy.pharmacyId\">({{ primaryPharmacyIndicatorText }})</span>\r\n              </li>\r\n            </div>\r\n          </ul>\r\n        </ng-container>\r\n        <ng-template #pharmacyDetail>\r\n          <ng-container *ngIf=\"selectedPharmacy\">\r\n            <div class=\"Spa_Style_Small_Font Spa_Style_Gray4_Color mb-2 pl-2\">\r\n              <span class=\"no-translate-block\">{{ displayLabel(selectedPharmacy.name) }}</span>\r\n            </div>\r\n          </ng-container>\r\n        </ng-template>\r\n      </div>\r\n\r\n      <div class=\"d-flex align-self-start edit-link\">\r\n        <vnext-link\r\n          (click)=\"quoteFacade.redirectGuidedHelpPages()\"\r\n          (keyup.enter)=\"quoteFacade.redirectGuidedHelpPages()\"\r\n          class=\"float-right\"\r\n          [attr.aria-label]=\"preferencesEditDescription\"\r\n        >\r\n          <div link-body><i class=\"fas fa-edit pt-1\" aria-hidden=\"true\"></i> {{ preferencesEditText }}</div>\r\n        </vnext-link>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".preferences-wrapper{border:1px solid var(--static-Spa_Style_Accent1);padding:20px 0;align-items:center;position:relative}.edit-link{position:absolute;right:20px;top:10px}\n"] }]
    }], function () { return [{ type: i1.GuidedHelpService }, { type: QuoteFacade }]; }, { addPreferencesText: [{
            type: Input
        }], healthText: [{
            type: Input
        }], qualifiedHelpText: [{
            type: Input
        }], prescriptionsText: [{
            type: Input
        }], pharmacyText: [{
            type: Input
        }], guidedHelpHideMedicineLinkText: [{
            type: Input
        }], guidedHelpViewMedicineLinkText: [{
            type: Input
        }], guidedHelpEnabled: [{
            type: Input
        }], getStartedEnabled: [{
            type: Input
        }], healthEnabled: [{
            type: Input
        }], showSubsidyAccordion: [{
            type: Input
        }], prescriptionsEnabled: [{
            type: Input
        }], pharmacyEnabled: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], medicineCabinet: [{
            type: Input
        }], preferencesEditText: [{
            type: Input
        }], addLinkText: [{
            type: Input
        }], selectedHealthStatus: [{
            type: Input
        }], subsidySelected: [{
            type: Input
        }], subsidyPercentage: [{
            type: Input
        }], ageRange: [{
            type: Input
        }], preferencesEditDescription: [{
            type: Input
        }], selectedPharmacies: [{
            type: Input
        }], multiPharmacyEnabled: [{
            type: Input
        }], primaryPharmacy: [{
            type: Input
        }], primaryPharmacyIndicatorText: [{
            type: Input
        }] }); })();

function QuoteUserInfoComponent_h2_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h2", 16);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r0.personalDetailsHeaderText, "html"), i0.ɵɵsanitizeHtml);
} }
function QuoteUserInfoComponent_ng_container_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.zip);
} }
function QuoteUserInfoComponent_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.zip);
} }
function QuoteUserInfoComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r4.countyLabel);
} }
function QuoteUserInfoComponent_ng_container_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, ",");
    i0.ɵɵelementContainerEnd();
} }
function QuoteUserInfoComponent_div_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "h3", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "h4", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.userEmailLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.memberData == null ? null : ctx_r6.memberData.profile == null ? null : ctx_r6.memberData.profile.emailAddress, " ");
} }
class QuoteUserInfoComponent {
    constructor() {
        this.editZipCodeClicked = new EventEmitter();
    }
    editZipCode() {
        this.editZipCodeClicked.emit();
    }
    ngOnChanges(changes) {
        const { memberData } = changes;
        memberData;
        if (memberData?.currentValue && !_isEqual(memberData.currentValue?.profile?.addresses, memberData.previousValue?.profile?.addresses)) {
            const address = this.memberData?.profile?.addresses?.find(address => address.isPrimaryAddress);
            this.zip = address?.zip ?? '';
        }
    }
}
QuoteUserInfoComponent.ɵfac = function QuoteUserInfoComponent_Factory(t) { return new (t || QuoteUserInfoComponent)(); };
QuoteUserInfoComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: QuoteUserInfoComponent, selectors: [["vnext-widget-quote-user-info"]], inputs: { personalDetailsHeaderText: "personalDetailsHeaderText", userNameLabel: "userNameLabel", userZipcodeLabel: "userZipcodeLabel", userEmailLabel: "userEmailLabel", memberData: "memberData", userZipcodeEditLabel: "userZipcodeEditLabel", selectedCounty: "selectedCounty", userZipcodeEditDescripion: "userZipcodeEditDescripion", countyLabel: "countyLabel", showCountyLabel: "showCountyLabel" }, outputs: { editZipCodeClicked: "editZipCodeClicked" }, features: [i0.ɵɵNgOnChangesFeature], decls: 28, vars: 14, consts: [[1, "container"], [1, "row", "mt-3"], [1, "col-12"], ["class", "Spa_Style_H2", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [1, "row", "user-details-container", "rounded"], [1, "col-xs-12", "col-md-6", "col-lg-3"], [1, "Spa_Style_Smaller_Font", "Spa_Style_Semi_Bold_Weight", "mb-1"], [1, "Spa_Style_Smaller_Font", "no-translate-block"], [1, "quote-edit-link", "Spa_Style_Link", "action-button", "d-inline", "ml-3", 3, "click"], [1, "Spa_Style_Smaller_Font"], [4, "ngIf", "ngIfElse"], ["inlineLabel", ""], ["class", "Spa_Style_Note d-block", 4, "ngIf"], [1, "no-translate-block"], [4, "ngIf"], ["class", "col-xs-12 col-md-6 col-lg-3 no-translate-block", 4, "ngIf"], ["navigationAdapter", "", 1, "Spa_Style_H2", 3, "innerHtml"], [1, "mb-2"], [1, "Spa_Style_Note", "d-block"], [1, "col-xs-12", "col-md-6", "col-lg-3", "no-translate-block"]], template: function QuoteUserInfoComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, QuoteUserInfoComponent_h2_3_Template, 2, 4, "h2", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2)(5, "div", 0)(6, "div", 4)(7, "div", 5)(8, "h3", 6);
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "h4", 7);
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(12, "div", 5)(13, "h3", 6);
        i0.ɵɵtext(14);
        i0.ɵɵelementStart(15, "span")(16, "button", 8);
        i0.ɵɵlistener("click", function QuoteUserInfoComponent_Template_button_click_16_listener() { return ctx.editZipCode(); });
        i0.ɵɵtext(17);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(18, "h4", 9);
        i0.ɵɵtemplate(19, QuoteUserInfoComponent_ng_container_19_Template, 3, 1, "ng-container", 10);
        i0.ɵɵtemplate(20, QuoteUserInfoComponent_ng_template_20_Template, 2, 1, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(22, QuoteUserInfoComponent_div_22_Template, 2, 1, "div", 12);
        i0.ɵɵelementStart(23, "span", 13);
        i0.ɵɵtext(24);
        i0.ɵɵtemplate(25, QuoteUserInfoComponent_ng_container_25_Template, 2, 0, "ng-container", 14);
        i0.ɵɵtext(26);
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(27, QuoteUserInfoComponent_div_27_Template, 5, 2, "div", 15);
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(21);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "Spa_QuoteUserInfo_PersonalDetailsHeader_Text");
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", ctx.userNameLabel, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate2("", ctx.memberData == null ? null : ctx.memberData.profile == null ? null : ctx.memberData.profile.firstName, " ", ctx.memberData == null ? null : ctx.memberData.profile == null ? null : ctx.memberData.profile.lastName, "");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.userZipcodeLabel, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵattribute("aria-label", ctx.userZipcodeEditDescripion);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.userZipcodeEditLabel, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showCountyLabel)("ngIfElse", _r2);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.showCountyLabel);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.selectedCounty == null ? null : ctx.selectedCounty.countyName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.selectedCounty == null ? null : ctx.selectedCounty.countyName) && (ctx.selectedCounty == null ? null : ctx.selectedCounty.state));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.selectedCounty == null ? null : ctx.selectedCounty.state, "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.memberData == null ? null : ctx.memberData.profile == null ? null : ctx.memberData.profile.emailAddress);
    } }, dependencies: [i1$2.NgIf, NavigationAdapterDirective, LiveEditPropDirective, SafePipe], styles: [".user-details-container[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);padding:15px 0}.quote-edit-link[_ngcontent-%COMP%]{cursor:pointer;display:inline-block;text-decoration:underline}@media (max-width: 992px){.user-details-container[_ngcontent-%COMP%]{height:auto;padding:15px 0}}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], QuoteUserInfoComponent.prototype, "editZipCode", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QuoteUserInfoComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-quote-user-info', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container\">\r\n  <div class=\"row mt-3\">\r\n    <div class=\"col-12\">\r\n      <h2\r\n        *liveEditProp=\"'Spa_QuoteUserInfo_PersonalDetailsHeader_Text'\"\r\n        class=\"Spa_Style_H2\"\r\n        [innerHtml]=\"personalDetailsHeaderText | safe : 'html'\"\r\n        navigationAdapter\r\n      ></h2>\r\n    </div>\r\n    <div class=\"col-12\">\r\n      <div class=\"container\">\r\n        <div class=\"row user-details-container rounded\">\r\n          <div class=\"col-xs-12 col-md-6 col-lg-3\">\r\n            <h3 class=\"Spa_Style_Smaller_Font Spa_Style_Semi_Bold_Weight mb-1\">\r\n              {{ userNameLabel }}\r\n            </h3>\r\n            <h4 class=\"Spa_Style_Smaller_Font no-translate-block\">{{ memberData?.profile?.firstName }} {{ memberData?.profile?.lastName }}</h4>\r\n          </div>\r\n          <div class=\"col-xs-12 col-md-6 col-lg-3\">\r\n            <h3 class=\"Spa_Style_Smaller_Font Spa_Style_Semi_Bold_Weight mb-1\">\r\n              {{ userZipcodeLabel }}\r\n              <span>\r\n                <button\r\n                  (click)=\"editZipCode()\"\r\n                  [attr.aria-label]=\"userZipcodeEditDescripion\"\r\n                  class=\"quote-edit-link Spa_Style_Link action-button d-inline ml-3\"\r\n                >\r\n                  {{ userZipcodeEditLabel }}\r\n                </button>\r\n              </span>\r\n            </h3>\r\n            <h4 class=\"Spa_Style_Smaller_Font \">\r\n              <ng-container *ngIf=\"showCountyLabel; else inlineLabel\">\r\n                <div class=\"mb-2\">{{ zip }}</div>\r\n              </ng-container>\r\n              <ng-template #inlineLabel>\r\n                <span>{{ zip }}</span>\r\n              </ng-template>\r\n              <div *ngIf=\"showCountyLabel\" class=\"Spa_Style_Note d-block\">{{ countyLabel }}</div>\r\n              <span class=\"no-translate-block\">{{ selectedCounty?.countyName }}<ng-container *ngIf=\"selectedCounty?.countyName && selectedCounty?.state\">,</ng-container>\r\n              {{ selectedCounty?.state }}</span>\r\n            </h4>\r\n          </div>\r\n          <div class=\"col-xs-12 col-md-6 col-lg-3 no-translate-block\" *ngIf=\"memberData?.profile?.emailAddress\">\r\n            <h3 class=\"Spa_Style_Smaller_Font Spa_Style_Semi_Bold_Weight mb-1\">\r\n              {{ userEmailLabel }}\r\n            </h3>\r\n            <h4 class=\"Spa_Style_Smaller_Font no-translate-block\">\r\n              {{ memberData?.profile?.emailAddress }}\r\n            </h4>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".user-details-container{border:1px solid var(--static-Spa_Style_Accent1);padding:15px 0}.quote-edit-link{cursor:pointer;display:inline-block;text-decoration:underline}@media (max-width: 992px){.user-details-container{height:auto;padding:15px 0}}\n"] }]
    }], null, { personalDetailsHeaderText: [{
            type: Input
        }], userNameLabel: [{
            type: Input
        }], userZipcodeLabel: [{
            type: Input
        }], userEmailLabel: [{
            type: Input
        }], memberData: [{
            type: Input
        }], userZipcodeEditLabel: [{
            type: Input
        }], selectedCounty: [{
            type: Input
        }], userZipcodeEditDescripion: [{
            type: Input
        }], countyLabel: [{
            type: Input
        }], showCountyLabel: [{
            type: Input
        }], editZipCodeClicked: [{
            type: Output
        }], editZipCode: [] }); })();

function QuoteWelcomeComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 11)(2, "div", 12)(3, "vnext-personalized-video", 13);
    i0.ɵɵlistener("handleCallToAction", function QuoteWelcomeComponent_ng_container_2_Template_vnext_personalized_video_handleCallToAction_3_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.handleCallToAction.emit($event)); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("iframeTitle", ctx_r0.quoteVideoFrameTitle)("videoURL", ctx_r0.quoteVideoURL);
} }
const _c0$2p = function (a0) { return { "background-image": a0 }; };
function QuoteWelcomeComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 14);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c0$2p, ctx_r2.fullImagePath));
} }
function QuoteWelcomeComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.greetingText + " ");
} }
function QuoteWelcomeComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r4.memberData == null ? null : ctx_r4.memberData.profile == null ? null : ctx_r4.memberData.profile.firstName, ",");
} }
class QuoteWelcomeComponent {
    constructor() {
        this.handleCallToAction = new EventEmitter();
    }
}
QuoteWelcomeComponent.ɵfac = function QuoteWelcomeComponent_Factory(t) { return new (t || QuoteWelcomeComponent)(); };
QuoteWelcomeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: QuoteWelcomeComponent, selectors: [["vnext-widget-quote-welcome"]], inputs: { fullImagePath: "fullImagePath", fullImageMobilePath: "fullImageMobilePath", greetingText: "greetingText", memberData: "memberData", memberQuoteMessage: "memberQuoteMessage", displayQuoteVideo: "displayQuoteVideo", quoteVideoURL: "quoteVideoURL", quoteVideoFrameTitle: "quoteVideoFrameTitle" }, outputs: { handleCallToAction: "handleCallToAction" }, decls: 13, vars: 5, consts: [[1, "Spa_Style_Banner_Background"], [1, "container", "p-0"], [4, "ngIf", "ngIfElse"], ["noVideo", ""], [1, "container"], [1, "mt-4"], [1, "Spa_Style_H1"], [4, "liveEditProp"], ["class", "no-translate-block", 4, "ngIf"], [1, "mb-5"], [1, "Spa_Style_Paragraph"], [1, "quote-banner-video", "d-flex", "justify-content-center"], [1, "personalized-video-wrapper"], [3, "iframeTitle", "videoURL", "handleCallToAction"], [1, "quote-banner-img", 3, "ngStyle"], [1, "no-translate-block"]], template: function QuoteWelcomeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, QuoteWelcomeComponent_ng_container_2_Template, 4, 2, "ng-container", 2);
        i0.ɵɵtemplate(3, QuoteWelcomeComponent_ng_template_3_Template, 1, 3, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div", 4)(6, "div", 5)(7, "h1", 6);
        i0.ɵɵtemplate(8, QuoteWelcomeComponent_span_8_Template, 2, 1, "span", 7);
        i0.ɵɵtemplate(9, QuoteWelcomeComponent_span_9_Template, 2, 1, "span", 8);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "div", 9)(11, "p", 10);
        i0.ɵɵtext(12);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(4);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.displayQuoteVideo && ctx.quoteVideoURL)("ngIfElse", _r1);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_QuoteWelcome_Greeting_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.memberData == null ? null : ctx.memberData.profile == null ? null : ctx.memberData.profile.firstName);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.memberQuoteMessage, " ");
    } }, dependencies: [i1$2.NgIf, i1$2.NgStyle, LiveEditPropDirective, PersonalizedVideoComponent], styles: [".container[_ngcontent-%COMP%]{position:relative}.quote-banner-img[_ngcontent-%COMP%]{width:100%;max-width:1400px;height:450px;background-position:center;background-repeat:no-repeat;background-size:cover;background-color:var(--static-Spa_Style_Gray1)}.quote-banner-img[_ngcontent-%COMP%]:after, .quote-banner-img[_ngcontent-%COMP%]:before{content:\"\";position:absolute;height:450px;width:500px}.quote-banner-img[_ngcontent-%COMP%]:after{left:-380px;background:linear-gradient(90deg,var(--static-Spa_Style_Gray1) 0%,var(--static-Spa_Style_Gray1) 76%,rgba(0,0,0,0) 100%)}.quote-banner-img[_ngcontent-%COMP%]:before{right:-380px;background:linear-gradient(270deg,var(--static-Spa_Style_Gray1) 0%,var(--static-Spa_Style_Gray1) 76%,rgba(0,0,0,0) 100%)}.quote-banner-video[_ngcontent-%COMP%]{height:350px;background-size:cover;padding-top:25px;padding-bottom:25px}.personalized-video-wrapper[_ngcontent-%COMP%]{width:533.33px}@media (min-width: 1200px){.quote-banner-img[_ngcontent-%COMP%]{background-position-y:-50px}}@media (max-width: 1399.98px){.quote-banner-img[_ngcontent-%COMP%]:after, .quote-banner-img[_ngcontent-%COMP%]:before{display:none}}@media (max-width: 991.98px){.quote-banner-video[_ngcontent-%COMP%]{height:200px;padding-top:0;padding-bottom:0}.personalized-video-wrapper[_ngcontent-%COMP%]{width:100%}}@media (max-width: 575.98px){.quote-banner-img[_ngcontent-%COMP%]{background-position-y:top;height:300px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QuoteWelcomeComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-quote-welcome', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"Spa_Style_Banner_Background\">\r\n  <div class=\"container p-0\">\r\n    <ng-container *ngIf=\"displayQuoteVideo && quoteVideoURL; else noVideo\">\r\n      <div class=\"quote-banner-video d-flex justify-content-center\">\r\n        <div class=\"personalized-video-wrapper\">\r\n          <vnext-personalized-video\r\n            (handleCallToAction)=\"handleCallToAction.emit($event)\"\r\n            [iframeTitle]=\"quoteVideoFrameTitle\"\r\n            [videoURL]=\"quoteVideoURL\"\r\n          ></vnext-personalized-video>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n    <ng-template #noVideo>\r\n      <div class=\"quote-banner-img\" [ngStyle]=\"{ 'background-image': fullImagePath }\"></div>\r\n    </ng-template>\r\n  </div>\r\n</div>\r\n<div class=\"container\">\r\n  <div class=\"mt-4\">\r\n    <h1 class=\"Spa_Style_H1\">\r\n      <span *liveEditProp=\"'Spa_Site_QuoteWelcome_Greeting_Text'\">{{ greetingText + ' ' }}</span>\r\n      <span *ngIf=\"memberData?.profile?.firstName\" class=\"no-translate-block\">{{ memberData?.profile?.firstName }},</span>\r\n    </h1>\r\n  </div>\r\n  <div class=\"mb-5\">\r\n    <p class=\"Spa_Style_Paragraph\">\r\n      {{ memberQuoteMessage }}\r\n    </p>\r\n  </div>\r\n</div>\r\n", styles: [".container{position:relative}.quote-banner-img{width:100%;max-width:1400px;height:450px;background-position:center;background-repeat:no-repeat;background-size:cover;background-color:var(--static-Spa_Style_Gray1)}.quote-banner-img:after,.quote-banner-img:before{content:\"\";position:absolute;height:450px;width:500px}.quote-banner-img:after{left:-380px;background:linear-gradient(90deg,var(--static-Spa_Style_Gray1) 0%,var(--static-Spa_Style_Gray1) 76%,rgba(0,0,0,0) 100%)}.quote-banner-img:before{right:-380px;background:linear-gradient(270deg,var(--static-Spa_Style_Gray1) 0%,var(--static-Spa_Style_Gray1) 76%,rgba(0,0,0,0) 100%)}.quote-banner-video{height:350px;background-size:cover;padding-top:25px;padding-bottom:25px}.personalized-video-wrapper{width:533.33px}@media (min-width: 1200px){.quote-banner-img{background-position-y:-50px}}@media (max-width: 1399.98px){.quote-banner-img:after,.quote-banner-img:before{display:none}}@media (max-width: 991.98px){.quote-banner-video{height:200px;padding-top:0;padding-bottom:0}.personalized-video-wrapper{width:100%}}@media (max-width: 575.98px){.quote-banner-img{background-position-y:top;height:300px}}\n"] }]
    }], null, { fullImagePath: [{
            type: Input
        }], fullImageMobilePath: [{
            type: Input
        }], greetingText: [{
            type: Input
        }], memberData: [{
            type: Input
        }], memberQuoteMessage: [{
            type: Input
        }], displayQuoteVideo: [{
            type: Input
        }], quoteVideoURL: [{
            type: Input
        }], quoteVideoFrameTitle: [{
            type: Input
        }], handleCallToAction: [{
            type: Output
        }] }); })();

function SummaryCoverageTypesComponent_ng_container_1_h2_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h2", 6);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r4.pickPlanLabel, "html"), i0.ɵɵsanitizeHtml);
} }
function SummaryCoverageTypesComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 4);
    i0.ɵɵtemplate(1, SummaryCoverageTypesComponent_ng_container_1_h2_1_Template, 2, 4, "h2", 5);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", ctx_r0.isQuotingSite ? "Spa_QuoteSummary_PickPlan_Text" : "Spa_Retention_PickPlan_Text");
} }
function SummaryCoverageTypesComponent_ng_template_2_h2_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h2", 6);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r5.shopsAllCoverageText, "html"), i0.ɵɵsanitizeHtml);
} }
function SummaryCoverageTypesComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SummaryCoverageTypesComponent_ng_template_2_h2_0_Template, 2, 4, "h2", 5);
} if (rf & 2) {
    i0.ɵɵproperty("liveEditProp", "Spa_Site_ShopAllCoverage_Text");
} }
function SummaryCoverageTypesComponent_div_4_ng_container_6_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 17);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const planTile_r6 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, planTile_r6.planTabEducationalText, "html"), i0.ɵɵsanitizeHtml);
} }
function SummaryCoverageTypesComponent_div_4_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SummaryCoverageTypesComponent_div_4_ng_container_6_span_1_Template, 2, 4, "span", 16);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const planTile_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", ctx_r7.getEducationalTextResource(planTile_r6.tabTypes[0]));
} }
function SummaryCoverageTypesComponent_div_4_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-link", 18);
    i0.ɵɵlistener("click", function SummaryCoverageTypesComponent_div_4_ng_container_8_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r16); const planTile_r6 = i0.ɵɵnextContext().$implicit; const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.goToPlanTypes(planTile_r6.tabTypes[0])); })("keyup.enter", function SummaryCoverageTypesComponent_div_4_ng_container_8_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r16); const planTile_r6 = i0.ɵɵnextContext().$implicit; const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.goToPlanTypes(planTile_r6.tabTypes[0])); });
    i0.ɵɵelementStart(2, "span", 19);
    i0.ɵɵtext(3);
    i0.ɵɵelement(4, "i", 20);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const planTile_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isLinkButton", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(planTile_r6.linkText);
} }
function SummaryCoverageTypesComponent_div_4_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.notAvailableText, " ");
} }
function SummaryCoverageTypesComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8)(2, "h3", 9);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 10)(5, "div", 11);
    i0.ɵɵtemplate(6, SummaryCoverageTypesComponent_div_4_ng_container_6_Template, 2, 1, "ng-container", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 13);
    i0.ɵɵtemplate(8, SummaryCoverageTypesComponent_div_4_ng_container_8_Template, 5, 2, "ng-container", 14);
    i0.ɵɵtemplate(9, SummaryCoverageTypesComponent_div_4_ng_template_9_Template, 1, 1, "ng-template", null, 15, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const planTile_r6 = ctx.$implicit;
    const _r9 = i0.ɵɵreference(10);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", planTile_r6.title, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r3.planTabEducationalTextShow);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.planCounts && ctx_r3.planCounts[ctx_r3.planType[planTile_r6.tabTypes[0]]] > 0)("ngIfElse", _r9);
} }
class SummaryCoverageTypesComponent {
    constructor(store, navigationService, plansService) {
        this.store = store;
        this.navigationService = navigationService;
        this.plansService = plansService;
        this.planTiles = [];
        this.filteredPlans = [];
        this.planTabEducationalTextShow = true;
        this.planType = PlanType;
        this.pageTags = PageTags;
    }
    goToPlanTypes(tabType) {
        this.store.dispatch(new SetActiveTab(tabType));
        // Set override flag to false so we land on the active tab set above
        this.plansService.setOverrideActiveTab(false);
        this.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
    }
    getEducationalTextResource(tabType) {
        if (tabType !== PlanTypeAbbreviation.MEDIGAP) {
            return `Spa_PlanList_Tab_Educational_Text_${tabType}`;
        }
    }
}
SummaryCoverageTypesComponent.ɵfac = function SummaryCoverageTypesComponent_Factory(t) { return new (t || SummaryCoverageTypesComponent)(i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.PlansService)); };
SummaryCoverageTypesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SummaryCoverageTypesComponent, selectors: [["vnext-summary-coverage-types"]], inputs: { shopsAllCoverageText: "shopsAllCoverageText", pickPlanLabel: "pickPlanLabel", planTiles: "planTiles", planCounts: "planCounts", filteredPlans: "filteredPlans", notAvailableText: "notAvailableText", isQuotingSite: "isQuotingSite", planTabEducationalTextShow: "planTabEducationalTextShow" }, decls: 5, vars: 3, consts: [[1, "container"], ["class", "row mt-2 mx-0 mb-1", 4, "ngIf", "ngIfElse"], ["shopsAllCoverage", ""], ["class", "mt-2 mb-3 mx-0 rounded coverage-types-wrapper Spa_Style_Small_Font", 4, "ngFor", "ngForOf"], [1, "row", "mt-2", "mx-0", "mb-1"], ["class", "pt-3 Spa_Style_Large_Font", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["navigationAdapter", "", 1, "pt-3", "Spa_Style_Large_Font", 3, "innerHtml"], [1, "mt-2", "mb-3", "mx-0", "rounded", "coverage-types-wrapper", "Spa_Style_Small_Font"], [1, "row"], [1, "col-12", "Spa_Style_Bold_Weight"], [1, "row", "mt-1"], [1, "col-lg-8", "col-12"], [4, "ngIf"], [1, "col-lg-4", "col-12", "text-lg-right", "mt-1"], [4, "ngIf", "ngIfElse"], ["linkText", ""], ["navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["navigationAdapter", "", 3, "innerHtml"], [3, "isLinkButton", "click", "keyup.enter"], ["link-body", ""], ["aria-hidden", "true", 1, "fas", "fa-angle-right", "ml-1"]], template: function SummaryCoverageTypesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, SummaryCoverageTypesComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        i0.ɵɵtemplate(2, SummaryCoverageTypesComponent_ng_template_2_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(4, SummaryCoverageTypesComponent_div_4_Template, 11, 4, "div", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(3);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.filteredPlans || ctx.filteredPlans.length === 0)("ngIfElse", _r1);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.planTiles);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, LinkComponent, NavigationAdapterDirective, LiveEditPropDirective, IconAriaAttributesDirective, SafePipe], styles: [".coverage-types-wrapper[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);padding:15px}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], SummaryCoverageTypesComponent.prototype, "goToPlanTypes", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SummaryCoverageTypesComponent, [{
        type: Component,
        args: [{ selector: 'vnext-summary-coverage-types', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container\">\r\n  <ng-container class=\"row mt-2 mx-0 mb-1\" *ngIf=\"!filteredPlans || filteredPlans.length === 0; else shopsAllCoverage\">\r\n    <h2\r\n      class=\"pt-3 Spa_Style_Large_Font\"\r\n      *liveEditProp=\"isQuotingSite ? 'Spa_QuoteSummary_PickPlan_Text' : 'Spa_Retention_PickPlan_Text'\"\r\n      [innerHtml]=\"pickPlanLabel | safe : 'html'\"\r\n      navigationAdapter\r\n    ></h2>\r\n  </ng-container>\r\n  <ng-template #shopsAllCoverage>\r\n    <h2\r\n      class=\"pt-3 Spa_Style_Large_Font\"\r\n      *liveEditProp=\"'Spa_Site_ShopAllCoverage_Text'\"\r\n      [innerHtml]=\"shopsAllCoverageText | safe : 'html'\"\r\n      navigationAdapter\r\n    ></h2>\r\n  </ng-template>\r\n  <div class=\"mt-2 mb-3 mx-0 rounded coverage-types-wrapper Spa_Style_Small_Font\" *ngFor=\"let planTile of planTiles\">\r\n    <div class=\"row\">\r\n      <h3 class=\"col-12 Spa_Style_Bold_Weight\">\r\n        {{ planTile.title }}\r\n      </h3>\r\n    </div>\r\n    <div class=\"row mt-1\">\r\n      <div class=\"col-lg-8 col-12\">\r\n        <ng-container *ngIf=\"planTabEducationalTextShow\">\r\n          <span\r\n            *liveEditProp=\"getEducationalTextResource(planTile.tabTypes[0])\"\r\n            [innerHtml]=\"planTile.planTabEducationalText | safe : 'html'\"\r\n            navigationAdapter\r\n          ></span>\r\n        </ng-container>\r\n      </div>\r\n\r\n      <div class=\"col-lg-4 col-12 text-lg-right mt-1\">\r\n        <ng-container *ngIf=\"planCounts && planCounts[planType[planTile.tabTypes[0]]] > 0; else linkText\">\r\n          <vnext-link\r\n            (click)=\"goToPlanTypes(planTile.tabTypes[0])\"\r\n            (keyup.enter)=\"goToPlanTypes(planTile.tabTypes[0])\"\r\n            [isLinkButton]=\"true\"\r\n          >\r\n            <span link-body>{{ planTile.linkText }}<i class=\"fas fa-angle-right ml-1\" aria-hidden=\"true\"></i></span>\r\n          </vnext-link>\r\n        </ng-container>\r\n        <ng-template #linkText>\r\n          {{ notAvailableText }}\r\n        </ng-template>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".coverage-types-wrapper{border:1px solid var(--static-Spa_Style_Accent1);padding:15px}\n"] }]
    }], function () { return [{ type: i2.Store }, { type: i1.NavigationService }, { type: i1.PlansService }]; }, { shopsAllCoverageText: [{
            type: Input
        }], pickPlanLabel: [{
            type: Input
        }], planTiles: [{
            type: Input
        }], planCounts: [{
            type: Input
        }], filteredPlans: [{
            type: Input
        }], notAvailableText: [{
            type: Input
        }], isQuotingSite: [{
            type: Input
        }], planTabEducationalTextShow: [{
            type: Input
        }], goToPlanTypes: [] }); })();

function SummaryPreferencesProviderComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "vnext-link", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("tag", ctx_r0.tag)("alwaysUnderlined", true)("title", ctx_r0.preferencesEditText)("onClickAction", ctx_r0.onClick())("ariaLabel", ctx_r0.preferencesEditText + " " + ctx_r0.providersText)("role", ctx_r0.linkRoles.LINK);
} }
function SummaryPreferencesProviderComponent_vnext_link_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-link", 8)(1, "div", 9);
    i0.ɵɵelement(2, "i", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tag", ctx_r1.tag)("ariaLabel", ctx_r1.addLinkText + " " + ctx_r1.providersText)("onClickAction", ctx_r1.onClick());
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.addLinkText);
} }
function SummaryPreferencesProviderComponent_div_6_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r7.guidedHelpHideLinkText);
} }
function SummaryPreferencesProviderComponent_div_6_div_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate(ctx_r9.guidedHelpViewAllLinkText);
} }
function SummaryPreferencesProviderComponent_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "vnext-link", 15);
    i0.ɵɵlistener("click", function SummaryPreferencesProviderComponent_div_6_div_1_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.showAllProviderLabels = !ctx_r10.showAllProviderLabels); });
    i0.ɵɵelementStart(2, "div", 16);
    i0.ɵɵtemplate(3, SummaryPreferencesProviderComponent_div_6_div_1_ng_container_3_Template, 2, 1, "ng-container", 17);
    i0.ɵɵtemplate(4, SummaryPreferencesProviderComponent_div_6_div_1_ng_template_4_Template, 1, 1, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(6, "i", 19);
    i0.ɵɵelementStart(7, "span", 20);
    i0.ɵɵtext(8, "Expand/Collapse");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const _r8 = i0.ɵɵreference(5);
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("keyNameForLiveEdit", "Spa_GuidedHelp_HideMedicineLink_Text")("makeInlineBlock", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.showAllProviderLabels)("ngIfElse", _r8);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r5.showAllProviderLabels ? "fa-angle-up" : "fa-angle-down");
} }
function SummaryPreferencesProviderComponent_div_6_li_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("(", ctx_r12.pcpText, ")");
} }
function SummaryPreferencesProviderComponent_div_6_li_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li")(1, "span", 21);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, SummaryPreferencesProviderComponent_div_6_li_3_ng_container_4_Template, 3, 1, "ng-container", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const provider_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, provider_r3.displayName));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", provider_r3.isPrimary);
} }
function SummaryPreferencesProviderComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SummaryPreferencesProviderComponent_div_6_div_1_Template, 9, 5, "div", 11);
    i0.ɵɵelementStart(2, "ul", 12);
    i0.ɵɵtemplate(3, SummaryPreferencesProviderComponent_div_6_li_3_Template, 5, 4, "li", 13);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const index_r4 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", index_r4 === ctx_r2.maxProviderVisibleCount);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", index_r4 < ctx_r2.maxProviderVisibleCount || ctx_r2.showAllProviderLabels);
} }
class SummaryPreferencesProviderComponent {
    constructor() {
        this.analyticsEvent = new EventEmitter();
        this.showAllProviderLabels = false;
        this.linkRoles = LinkRoles;
        this.maxProviderVisibleCount = 5;
    }
    onClick() {
        return () => {
            this.analyticsEvent.emit();
        };
    }
}
SummaryPreferencesProviderComponent.ɵfac = function SummaryPreferencesProviderComponent_Factory(t) { return new (t || SummaryPreferencesProviderComponent)(); };
SummaryPreferencesProviderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SummaryPreferencesProviderComponent, selectors: [["vnext-summary-preferences-provider"]], inputs: { addLinkText: "addLinkText", preferencesEditText: "preferencesEditText", providers: "providers", providersText: "providersText", pcpText: "pcpText", tag: "tag", guidedHelpHideLinkText: "guidedHelpHideLinkText", guidedHelpViewAllLinkText: "guidedHelpViewAllLinkText" }, outputs: { analyticsEvent: "analyticsEvent" }, decls: 7, vars: 4, consts: [["aria-hidden", "true", 1, "fas", "Spa_Style_ProvidersIcon", "Spa_Style_Larger_Font"], [1, "Spa_Style_Regular_Font", "Spa_Style_Semi_Bold_Weight", "d-flex", "justify-content-between", "my-1", "pr-3"], [1, "Spa_Style_Regular_Font", "p-0"], ["class", "pl-1", 4, "ngIf"], [3, "tag", "ariaLabel", "onClickAction", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "pl-1"], [3, "tag", "alwaysUnderlined", "title", "onClickAction", "ariaLabel", "role"], [3, "tag", "ariaLabel", "onClickAction"], ["tag-image-body", "", 1, "pl-2"], ["aria-hidden", "true", 1, "fas", "fa-plus-circle", "mr-1"], ["class", "mb-1", 4, "ngIf"], [1, "Spa_Style_Paragraph", "pl-3", "mb-1"], [4, "ngIf"], [1, "mb-1"], [3, "keyNameForLiveEdit", "makeInlineBlock", "click"], ["link-body", "", 1, "pl-0"], [4, "ngIf", "ngIfElse"], ["showViewAll", ""], [1, "fas", "ml-1", 3, "ngClass"], [1, "sr-only"], [1, "no-translate-block"]], template: function SummaryPreferencesProviderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "i", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "h3", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, SummaryPreferencesProviderComponent_div_4_Template, 2, 6, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, SummaryPreferencesProviderComponent_vnext_link_5_Template, 4, 4, "vnext-link", 4);
        i0.ɵɵtemplate(6, SummaryPreferencesProviderComponent_div_6_Template, 4, 2, "div", 5);
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.providersText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.providers == null ? null : ctx.providers.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.providers || ctx.providers.length === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.providers);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, IconAriaAttributesDirective, i1$2.TitleCasePipe], styles: [".preferences-wrapper[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);padding:20px 0;align-items:center;position:relative}.edit-link[_ngcontent-%COMP%]{position:absolute;right:20px;top:10px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SummaryPreferencesProviderComponent, [{
        type: Component,
        args: [{ selector: 'vnext-summary-preferences-provider', changeDetection: ChangeDetectionStrategy.OnPush, template: "<i class=\"fas Spa_Style_ProvidersIcon Spa_Style_Larger_Font\" aria-hidden=\"true\"></i>\r\n<div class=\"Spa_Style_Regular_Font Spa_Style_Semi_Bold_Weight d-flex justify-content-between my-1 pr-3\">\r\n  <h3 class=\"Spa_Style_Regular_Font p-0\">{{ providersText }}</h3>\r\n  <div class=\"pl-1\" *ngIf=\"providers?.length\">\r\n    <vnext-link\r\n      [tag]=\"tag\"\r\n      [alwaysUnderlined]=\"true\"\r\n      [title]=\"preferencesEditText\"\r\n      [onClickAction]=\"onClick()\"\r\n      [ariaLabel]=\"preferencesEditText + ' ' + providersText\"\r\n      [role]=\"linkRoles.LINK\"\r\n    >\r\n    </vnext-link>\r\n  </div>\r\n</div>\r\n<vnext-link\r\n  *ngIf=\"!providers || providers.length === 0\"\r\n  [tag]=\"tag\"\r\n  [ariaLabel]=\"addLinkText + ' ' + providersText\"\r\n  [onClickAction]=\"onClick()\"\r\n>\r\n  <div class=\"pl-2\" tag-image-body><i class=\"fas fa-plus-circle mr-1\" aria-hidden=\"true\"></i>{{ addLinkText }}</div>\r\n</vnext-link>\r\n<div *ngFor=\"let provider of providers; index as index\">\r\n  <div *ngIf=\"index === maxProviderVisibleCount\" class=\"mb-1\">\r\n    <vnext-link\r\n      [keyNameForLiveEdit]=\"'Spa_GuidedHelp_HideMedicineLink_Text'\"\r\n      [makeInlineBlock]=\"true\"\r\n      (click)=\"showAllProviderLabels = !showAllProviderLabels\"\r\n    >\r\n      <div class=\"pl-0\" link-body>\r\n        <ng-container *ngIf=\"showAllProviderLabels; else showViewAll\">{{ guidedHelpHideLinkText }}</ng-container\r\n        ><ng-template #showViewAll>{{ guidedHelpViewAllLinkText }}</ng-template>\r\n        <i class=\"fas ml-1\" [ngClass]=\"showAllProviderLabels ? 'fa-angle-up' : 'fa-angle-down'\"></i>\r\n        <span class=\"sr-only\">Expand/Collapse</span>\r\n      </div>\r\n    </vnext-link>\r\n  </div>\r\n  <ul class=\"Spa_Style_Paragraph pl-3 mb-1\">\r\n    <li *ngIf=\"index < maxProviderVisibleCount || showAllProviderLabels\">\r\n      <span class=\"no-translate-block\">{{ provider.displayName | titlecase }}</span>\r\n      <ng-container *ngIf=\"provider.isPrimary\"\r\n        ><span>({{ pcpText }})</span></ng-container\r\n      >\r\n    </li>\r\n  </ul>\r\n</div>\r\n", styles: [".preferences-wrapper{border:1px solid var(--static-Spa_Style_Accent1);padding:20px 0;align-items:center;position:relative}.edit-link{position:absolute;right:20px;top:10px}\n"] }]
    }], null, { addLinkText: [{
            type: Input
        }], preferencesEditText: [{
            type: Input
        }], providers: [{
            type: Input
        }], providersText: [{
            type: Input
        }], pcpText: [{
            type: Input
        }], tag: [{
            type: Input
        }], guidedHelpHideLinkText: [{
            type: Input
        }], guidedHelpViewAllLinkText: [{
            type: Input
        }], analyticsEvent: [{
            type: Output
        }] }); })();

function SummaryPreferencesComponent_div_1_h2_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h2", 11);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r1.addPreferencesText, "html"), i0.ɵɵsanitizeHtml);
} }
const _c0$2o = function (a0) { return { invisible: a0 }; };
function SummaryPreferencesComponent_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵlistener("click", function SummaryPreferencesComponent_div_1_div_5_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r12); const preferencePointer_r10 = restoredCtx.$implicit; const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.scroll(ctx_r11.preferenceDirection.LEFT, preferencePointer_r10 - 1)); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$2o, ctx_r2.hideMobileNavigation || i0.ɵɵpipeBind1(1, 2, ctx_r2.hideLeftPreferenceNavigationButton$)));
    i0.ɵɵattribute("aria-label", "Previous");
} }
function SummaryPreferencesComponent_div_1_li_11_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 13)(1, "div", 14)(2, "vnext-summary-qualified-help", 15);
    i0.ɵɵlistener("analyticsEvent", function SummaryPreferencesComponent_div_1_li_11_Template_vnext_summary_qualified_help_analyticsEvent_2_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.redirectGuidedHelpPages(ctx_r13.pageTags.GUIDED_HELP_GETTING_STARTED)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("qualifiedHelpText", ctx_r3.qualifiedHelpText)("subsidySelected", ctx_r3.subsidySelected)("subsidyPercentage", ctx_r3.subsidyPercentage)("addLinkText", ctx_r3.addLinkText)("tag", ctx_r3.pageTags.GUIDED_HELP_GETTING_STARTED)("preferencesEditText", ctx_r3.preferencesEditText);
} }
function SummaryPreferencesComponent_div_1_li_12_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 13)(1, "div", 14);
    i0.ɵɵelement(2, "i", 16);
    i0.ɵɵelementStart(3, "div", 17)(4, "h3", 18);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span")(7, "vnext-link", 19);
    i0.ɵɵlistener("click", function SummaryPreferencesComponent_div_1_li_12_Template_vnext_link_click_7_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r15.redirectGuidedHelpPages(ctx_r15.pageTags.GUIDED_HELP_HEALTH)); })("keyup.enter", function SummaryPreferencesComponent_div_1_li_12_Template_vnext_link_keyup_enter_7_listener() { i0.ɵɵrestoreView(_r16); const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.redirectGuidedHelpPages(ctx_r17.pageTags.GUIDED_HELP_HEALTH)); });
    i0.ɵɵelementStart(8, "div", 20);
    i0.ɵɵelement(9, "i", 21);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(11, "ul", 22)(12, "li");
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "li");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r4.healthText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("role", ctx_r4.linkRoles.LINK)("ariaLabel", ctx_r4.preferencesEditText + " " + ctx_r4.healthText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.preferencesEditText, "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r4.selectedHealthStatus);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.ageRange);
} }
function SummaryPreferencesComponent_div_1_li_13_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 13)(1, "div", 23)(2, "vnext-summary-preferences-provider", 24);
    i0.ɵɵlistener("analyticsEvent", function SummaryPreferencesComponent_div_1_li_13_Template_vnext_summary_preferences_provider_analyticsEvent_2_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r18.redirectGuidedHelpPages(ctx_r18.pageTags.GUIDED_HELP_PROVIDER_SEARCH)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pcpText", ctx_r5.pcpText)("guidedHelpHideLinkText", ctx_r5.guidedHelpHideLinkText)("guidedHelpViewAllLinkText", ctx_r5.guidedHelpViewAllLinkText)("tag", ctx_r5.pageTags.GUIDED_HELP_PROVIDER_SEARCH)("addLinkText", ctx_r5.addLinkText)("providers", ctx_r5.providers)("providersText", ctx_r5.providersText)("preferencesEditText", ctx_r5.preferencesEditText);
} }
function SummaryPreferencesComponent_div_1_li_14_vnext_link_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-link", 29)(1, "div", 30);
    i0.ɵɵelement(2, "i", 31);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("tag", ctx_r20.pageTags.GUIDED_HELP_PRESCRIPTIONS)("ariaLabel", ctx_r20.addLinkText + " " + ctx_r20.prescriptionsText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r20.addLinkText);
} }
function SummaryPreferencesComponent_div_1_li_14_div_12_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34)(1, "vnext-link", 35);
    i0.ɵɵlistener("click", function SummaryPreferencesComponent_div_1_li_14_div_12_div_1_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r26.showAllMedicineLabels = !ctx_r26.showAllMedicineLabels); });
    i0.ɵɵelementStart(2, "div", 36);
    i0.ɵɵtext(3);
    i0.ɵɵelement(4, "i");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("keyNameForLiveEdit", "Spa_GuidedHelp_HideMedicineLink_Text")("makeInlineBlock", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r24.getLinkText(ctx_r24.showAllMedicineLabels), " ");
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r24.getIcon(ctx_r24.showAllMedicineLabels));
} }
function SummaryPreferencesComponent_div_1_li_14_div_12_li_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const medicine_r22 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", medicine_r22.drugDetails.drugName, " ");
} }
function SummaryPreferencesComponent_div_1_li_14_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SummaryPreferencesComponent_div_1_li_14_div_12_div_1_Template, 5, 6, "div", 32);
    i0.ɵɵelementStart(2, "ul", 33);
    i0.ɵɵtemplate(3, SummaryPreferencesComponent_div_1_li_14_div_12_li_3_Template, 2, 1, "li", 1);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const index_r23 = ctx.index;
    const ctx_r21 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", index_r23 === ctx_r21.maxDrugVisibleCount);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", index_r23 < ctx_r21.maxDrugVisibleCount || ctx_r21.showAllMedicineLabels);
} }
function SummaryPreferencesComponent_div_1_li_14_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 13)(1, "div", 23);
    i0.ɵɵelement(2, "i", 25);
    i0.ɵɵelementStart(3, "div", 26)(4, "h3", 18);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span")(7, "vnext-link", 19);
    i0.ɵɵlistener("click", function SummaryPreferencesComponent_div_1_li_14_Template_vnext_link_click_7_listener() { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r29.redirectGuidedHelpPages(ctx_r29.pageTags.GUIDED_HELP_PRESCRIPTIONS)); })("keyup.enter", function SummaryPreferencesComponent_div_1_li_14_Template_vnext_link_keyup_enter_7_listener() { i0.ɵɵrestoreView(_r30); const ctx_r31 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r31.redirectGuidedHelpPages(ctx_r31.pageTags.GUIDED_HELP_PRESCRIPTIONS)); });
    i0.ɵɵelementStart(8, "div", 20);
    i0.ɵɵelement(9, "i", 21);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵtemplate(11, SummaryPreferencesComponent_div_1_li_14_vnext_link_11_Template, 4, 3, "vnext-link", 27);
    i0.ɵɵtemplate(12, SummaryPreferencesComponent_div_1_li_14_div_12_Template, 4, 2, "div", 28);
    i0.ɵɵpipe(13, "orderBy");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r6.prescriptionsText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("role", ctx_r6.linkRoles.LINK)("ariaLabel", ctx_r6.preferencesEditText + " " + ctx_r6.prescriptionsText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.preferencesEditText, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.medicineCabinet || ctx_r6.medicineCabinet.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind4(13, 6, ctx_r6.medicineCabinet, "drugDetails.drugName", false, true));
} }
function SummaryPreferencesComponent_div_1_li_15_vnext_link_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-link", 29)(1, "div", 30);
    i0.ɵɵelement(2, "i", 31);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("tag", ctx_r32.pageTags.GUIDED_HELP_PHARMACY_SEARCH)("ariaLabel", ctx_r32.addLinkText + " " + ctx_r32.pharmacyText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r32.addLinkText);
} }
function SummaryPreferencesComponent_div_1_li_15_ng_container_12_div_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", ctx_r38.primaryPharmacyIndicatorText, ")");
} }
function SummaryPreferencesComponent_div_1_li_15_ng_container_12_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41)(1, "li")(2, "span", 42);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, SummaryPreferencesComponent_div_1_li_15_ng_container_12_div_2_span_4_Template, 2, 1, "span", 1);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const selectedPharmacy_r37 = ctx.$implicit;
    const ctx_r36 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(selectedPharmacy_r37.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", selectedPharmacy_r37.pharmacyId === ctx_r36.primaryPharmacy.pharmacyId && ctx_r36.selectedPharmacies.length > 1);
} }
function SummaryPreferencesComponent_div_1_li_15_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ul", 22);
    i0.ɵɵtemplate(2, SummaryPreferencesComponent_div_1_li_15_ng_container_12_div_2_Template, 5, 2, "div", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r33.selectedPharmacies);
} }
function SummaryPreferencesComponent_div_1_li_15_ng_template_13_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 43)(2, "span", 42);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r39.selectedPharmacy.name);
} }
function SummaryPreferencesComponent_div_1_li_15_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SummaryPreferencesComponent_div_1_li_15_ng_template_13_ng_container_0_Template, 4, 1, "ng-container", 1);
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r35.selectedPharmacy);
} }
function SummaryPreferencesComponent_div_1_li_15_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 13)(1, "div", 14);
    i0.ɵɵelement(2, "i", 37);
    i0.ɵɵelementStart(3, "div", 26)(4, "h3", 18);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span")(7, "vnext-link", 19);
    i0.ɵɵlistener("click", function SummaryPreferencesComponent_div_1_li_15_Template_vnext_link_click_7_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r40.redirectGuidedHelpPages(ctx_r40.pageTags.GUIDED_HELP_PHARMACY_SEARCH)); })("keyup.enter", function SummaryPreferencesComponent_div_1_li_15_Template_vnext_link_keyup_enter_7_listener() { i0.ɵɵrestoreView(_r41); const ctx_r42 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r42.redirectGuidedHelpPages(ctx_r42.pageTags.GUIDED_HELP_PHARMACY_SEARCH)); });
    i0.ɵɵelementStart(8, "div", 20);
    i0.ɵɵelement(9, "i", 21);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵtemplate(11, SummaryPreferencesComponent_div_1_li_15_vnext_link_11_Template, 4, 3, "vnext-link", 27);
    i0.ɵɵtemplate(12, SummaryPreferencesComponent_div_1_li_15_ng_container_12_Template, 3, 1, "ng-container", 38);
    i0.ɵɵtemplate(13, SummaryPreferencesComponent_div_1_li_15_ng_template_13_Template, 1, 1, "ng-template", null, 39, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r34 = i0.ɵɵreference(14);
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r7.pharmacyText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("role", ctx_r7.linkRoles.LINK)("ariaLabel", ctx_r7.preferencesEditText + " " + ctx_r7.pharmacyText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.preferencesEditText, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r7.selectedPharmacy);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.multiPharmacyEnabled)("ngIfElse", _r34);
} }
function SummaryPreferencesComponent_div_1_li_16_vnext_link_7_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 19);
    i0.ɵɵlistener("click", function SummaryPreferencesComponent_div_1_li_16_vnext_link_7_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r47); const ctx_r46 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r46.redirectGuidedHelpPages(ctx_r46.pageTags.GUIDED_HELP_OTHER_PREFERENCES)); })("keyup.enter", function SummaryPreferencesComponent_div_1_li_16_vnext_link_7_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r47); const ctx_r48 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r48.redirectGuidedHelpPages(ctx_r48.pageTags.GUIDED_HELP_OTHER_PREFERENCES)); });
    i0.ɵɵelementStart(1, "div", 20);
    i0.ɵɵelement(2, "i", 21);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("role", ctx_r43.linkRoles.LINK)("ariaLabel", ctx_r43.preferencesEditText + " " + ctx_r43.otherPreferencesText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r43.preferencesEditText, "");
} }
function SummaryPreferencesComponent_div_1_li_16_vnext_link_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-link", 29)(1, "div", 30);
    i0.ɵɵelement(2, "i", 31);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("tag", ctx_r44.pageTags.GUIDED_HELP_OTHER_PREFERENCES)("ariaLabel", ctx_r44.addLinkText + " " + ctx_r44.otherPreferencesText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r44.addLinkText);
} }
function SummaryPreferencesComponent_div_1_li_16_ul_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 22)(1, "div", 41)(2, "li");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r45.guidedHelpOtherPreferencesMessageText, " ");
} }
function SummaryPreferencesComponent_div_1_li_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 13)(1, "div", 14);
    i0.ɵɵelement(2, "i", 44);
    i0.ɵɵelementStart(3, "div", 45)(4, "h3", 18);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtemplate(7, SummaryPreferencesComponent_div_1_li_16_vnext_link_7_Template, 4, 3, "vnext-link", 46);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, SummaryPreferencesComponent_div_1_li_16_vnext_link_8_Template, 4, 3, "vnext-link", 27);
    i0.ɵɵtemplate(9, SummaryPreferencesComponent_div_1_li_16_ul_9_Template, 4, 1, "ul", 47);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r8.otherPreferencesText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r8.hasSelectedOtherPreferences());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r8.hasSelectedOtherPreferences());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.hasSelectedOtherPreferences());
} }
function SummaryPreferencesComponent_div_1_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵlistener("click", function SummaryPreferencesComponent_div_1_div_17_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r51); const preferencePointer_r49 = restoredCtx.$implicit; const ctx_r50 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r50.scroll(ctx_r50.preferenceDirection.RIGHT, preferencePointer_r49 + 1)); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$2o, ctx_r9.hideMobileNavigation || i0.ɵɵpipeBind1(1, 2, ctx_r9.hideRightPreferenceNavigationButton$)));
    i0.ɵɵattribute("aria-label", "Next");
} }
const _c1$1a = function (a0) { return { "left-gradient": a0 }; };
const _c2$H = function (a0) { return { "right-gradient": a0 }; };
function SummaryPreferencesComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 2);
    i0.ɵɵtemplate(2, SummaryPreferencesComponent_div_1_h2_2_Template, 2, 4, "h2", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 4)(4, "nav", 5);
    i0.ɵɵtemplate(5, SummaryPreferencesComponent_div_1_div_5_Template, 2, 6, "div", 6);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementStart(7, "div", 7);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementStart(9, "ul", 8);
    i0.ɵɵpipe(10, "async");
    i0.ɵɵtemplate(11, SummaryPreferencesComponent_div_1_li_11_Template, 3, 6, "li", 9);
    i0.ɵɵtemplate(12, SummaryPreferencesComponent_div_1_li_12_Template, 16, 6, "li", 9);
    i0.ɵɵtemplate(13, SummaryPreferencesComponent_div_1_li_13_Template, 3, 8, "li", 9);
    i0.ɵɵtemplate(14, SummaryPreferencesComponent_div_1_li_14_Template, 14, 11, "li", 9);
    i0.ɵɵtemplate(15, SummaryPreferencesComponent_div_1_li_15_Template, 15, 7, "li", 9);
    i0.ɵɵtemplate(16, SummaryPreferencesComponent_div_1_li_16_Template, 10, 4, "li", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(17, SummaryPreferencesComponent_div_1_div_17_Template, 2, 6, "div", 10);
    i0.ɵɵpipe(18, "async");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Summary_AddPreferences_Text");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(6, 11, ctx_r0.preferencePointer$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c1$1a, !i0.ɵɵpipeBind1(8, 13, ctx_r0.hideLeftPreferenceNavigationButton$)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(21, _c2$H, !i0.ɵɵpipeBind1(10, 15, ctx_r0.hideRightPreferenceNavigationButton$)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showSubsidyAccordion);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.healthEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.providersEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.prescriptionsEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.pharmacyEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.otherPreferencesEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(18, 17, ctx_r0.preferencePointer$));
} }
class SummaryPreferencesComponent {
    constructor(guidedHelpService, responsiveLayoutService, cdr, analyticsService, navigationService, store) {
        this.guidedHelpService = guidedHelpService;
        this.responsiveLayoutService = responsiveLayoutService;
        this.cdr = cdr;
        this.analyticsService = analyticsService;
        this.navigationService = navigationService;
        this.store = store;
        this.showAllMedicineLabels = false;
        this.pageTags = PageTags;
        this.maxDrugVisibleCount = 5;
        this.minPreferencesForDesktopNavigation = 5;
        this.minPreferencesForMobileNavigation = 2;
        this.minPreferencesForTabletNavigation = 3;
        this.numberOfPreferencesForDesktop = 4;
        this.numberOfPreferencesForMobile = 1;
        this.numberOfPreferencesForTablet = 2;
        this.preferencePointer$ = new Subject();
        this.preferenceDirection = PreferenceDirection;
        this.linkRoles = LinkRoles;
    }
    ngOnInit() {
        this.ageRange = this.getAgeGroups();
        this.totalPreferencesCount = this.getTotalNumberOfPreferences();
        this.subscriptions = [
            combineLatest(this.responsiveLayoutService.isCompact$, this.responsiveLayoutService.isMedium$).subscribe(([isCompact, isMedium]) => {
                if (isCompact && this.totalPreferencesCount < this.minPreferencesForMobileNavigation) {
                    this.hideMobileNavigation = true;
                }
                const preferenceViewType = this.getPreferenceViewType(isCompact, isMedium);
                this.initialPreferencesCount = this.getInitialPreferencePointerValue(preferenceViewType);
            })
        ];
        this.preferencePointer$ = new BehaviorSubject(this.initialPreferencesCount);
        this.hideRightPreferenceNavigationButton$ = combineLatest(this.responsiveLayoutService.isCompact$, this.responsiveLayoutService.isMedium$, this.preferencePointer$).pipe(map(([isCompact, isMedium, preferencePointer]) => {
            const preferenceViewType = this.getPreferenceViewType(isCompact, isMedium);
            const minPreferencesForNavigation = this.getMinPreferencesForNavigation(preferenceViewType);
            return preferencePointer === this.totalPreferencesCount || this.totalPreferencesCount < minPreferencesForNavigation;
        }));
        this.hideLeftPreferenceNavigationButton$ = combineLatest(this.responsiveLayoutService.isCompact$, this.responsiveLayoutService.isMedium$, this.preferencePointer$).pipe(map(([isCompact, isMedium, preferencePointer]) => {
            const preferenceViewType = this.getPreferenceViewType(isCompact, isMedium);
            const initialPreferencePointerValue = this.getInitialPreferencePointerValue(preferenceViewType);
            const minPreferencesForNavigation = this.getMinPreferencesForNavigation(preferenceViewType);
            return this.totalPreferencesCount < minPreferencesForNavigation || preferencePointer === initialPreferencePointerValue;
        }));
        this.cdr.markForCheck();
    }
    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
    getAgeGroups() {
        const ageGroup = this.guidedHelpService.ageGroups.find(ageGroup => ageGroup.value === this.store.selectSnapshot(DemographicState.ageRange));
        if (ageGroup) {
            return ageGroup.label;
        }
        return this.defaultAge ? this.guidedHelpService.ageGroups.find(ageGroup => ageGroup.value === this.defaultAge).label : '';
    }
    redirectGuidedHelpPages(pageTags) {
        if (pageTags) {
            if (this.isRetention) {
                this.updateAnalytics(pageTags);
            }
            else if (pageTags === PageTags.GUIDED_HELP_PHARMACY_SEARCH) {
                this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_PHARMACY);
            }
            this.navigationService.navigateByPageTag(pageTags);
        }
        else {
            this.guidedHelpService.goToFirstLink();
        }
    }
    hasSelectedOtherPreferences() {
        return this.store.selectSnapshot(PreferencesState.hasPreferences);
    }
    getIcon(showAllLabels) {
        return `fas ${showAllLabels ? 'fa-angle-up' : ' fa-angle-down'}`;
    }
    getLinkText(showAllLabels) {
        return showAllLabels ? this.guidedHelpHideLinkText : this.guidedHelpViewAllLinkText;
    }
    scroll(preferenceDirection, pointer) {
        const listWrapper = document.getElementById('summary-preference-scrollbar-items');
        this.preferencePointer$.next(pointer);
        if (listWrapper) {
            const scrollDistance = listWrapper.scrollLeft;
            const width = preferenceDirection === PreferenceDirection.LEFT
                ? scrollDistance - listWrapper.firstElementChild.clientWidth
                : scrollDistance + listWrapper.firstElementChild.clientWidth;
            if (listWrapper.scrollTo) {
                // Need to run this in a setTimeout to make sure it gets moved to the end of the execution.
                // Only needed because of Safari Mobile. We could remove it as Safari evolves or we drop support for older versions.
                // this.cdr.detectChanges(); was tested too and it made the scrolling work but without the smoothness.
                setTimeout(() => {
                    listWrapper.scrollTo({ left: width, behavior: 'smooth' });
                });
            }
            else {
                listWrapper.scrollLeft = width;
            }
        }
    }
    updateAnalytics(pageTags) {
        switch (pageTags) {
            case PageTags.GUIDED_HELP_GETTING_STARTED:
            case PageTags.GUIDED_HELP_HEALTH:
                this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_HOME_GET_STARTED);
                break;
            case PageTags.GUIDED_HELP_PROVIDER_SEARCH:
                this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_PROVIDER);
                break;
            case PageTags.GUIDED_HELP_PRESCRIPTIONS:
                this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PREFERENCES_ADD_DRUG);
                break;
            case PageTags.GUIDED_HELP_PHARMACY_SEARCH:
                this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_PHARMACY);
                break;
            case PageTags.GUIDED_HELP_OTHER_PREFERENCES:
                this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_OTHER_PREFERENCES);
                break;
            default:
                this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_EDIT_PREFERENCES);
                break;
        }
    }
    getInitialPreferencePointerValue(preferenceViewType) {
        switch (preferenceViewType) {
            case PreferenceViewType.MOBILE:
                return this.numberOfPreferencesForMobile;
            case PreferenceViewType.TABLET:
                return this.numberOfPreferencesForTablet;
            default:
                return this.numberOfPreferencesForDesktop;
        }
    }
    getMinPreferencesForNavigation(preferenceViewType) {
        switch (preferenceViewType) {
            case PreferenceViewType.MOBILE:
                return this.minPreferencesForMobileNavigation;
            case PreferenceViewType.TABLET:
                return this.minPreferencesForTabletNavigation;
            default:
                return this.minPreferencesForDesktopNavigation;
        }
    }
    getPreferenceViewType(isCompact, isMedium) {
        if (isCompact) {
            return PreferenceViewType.MOBILE;
        }
        if (isMedium) {
            return PreferenceViewType.TABLET;
        }
        else {
            return PreferenceViewType.DESKTOP;
        }
    }
    getTotalNumberOfPreferences() {
        return [
            this.showSubsidyAccordion,
            this.healthEnabled,
            this.providersEnabled,
            this.prescriptionsEnabled,
            this.pharmacyEnabled,
            this.otherPreferencesEnabled
        ].filter(Boolean).length;
    }
}
SummaryPreferencesComponent.ɵfac = function SummaryPreferencesComponent_Factory(t) { return new (t || SummaryPreferencesComponent)(i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i2.Store)); };
SummaryPreferencesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SummaryPreferencesComponent, selectors: [["vnext-summary-preferences"]], inputs: { addPreferencesText: "addPreferencesText", healthText: "healthText", qualifiedHelpText: "qualifiedHelpText", prescriptionsText: "prescriptionsText", pharmacyText: "pharmacyText", guidedHelpHideLinkText: "guidedHelpHideLinkText", guidedHelpViewAllLinkText: "guidedHelpViewAllLinkText", guidedHelpEnabled: "guidedHelpEnabled", getStartedEnabled: "getStartedEnabled", healthEnabled: "healthEnabled", showSubsidyAccordion: "showSubsidyAccordion", prescriptionsEnabled: "prescriptionsEnabled", pharmacyEnabled: "pharmacyEnabled", selectedPharmacy: "selectedPharmacy", medicineCabinet: "medicineCabinet", preferencesEditText: "preferencesEditText", addLinkText: "addLinkText", selectedHealthStatus: "selectedHealthStatus", subsidySelected: "subsidySelected", subsidyPercentage: "subsidyPercentage", isRetention: "isRetention", preferencesEditDescription: "preferencesEditDescription", selectedPharmacies: "selectedPharmacies", multiPharmacyEnabled: "multiPharmacyEnabled", primaryPharmacy: "primaryPharmacy", primaryPharmacyIndicatorText: "primaryPharmacyIndicatorText", providersEnabled: "providersEnabled", providers: "providers", providersText: "providersText", pcpText: "pcpText", defaultAge: "defaultAge", otherPreferencesEnabled: "otherPreferencesEnabled", otherPreferencesText: "otherPreferencesText", guidedHelpOtherPreferencesMessageText: "guidedHelpOtherPreferencesMessageText" }, decls: 2, vars: 1, consts: [[1, "container"], [4, "ngIf"], [1, "row", "mt-2", "mx-0", "mb-1"], ["class", "pt-3 Spa_Style_Large_Font", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [1, "my-2", "mx-0", "preferences-wrapper"], [1, "d-flex", "justify-content-center"], ["role", "button", "tabIndex", "0", "class", "fal fa-chevron-left float-left control Spa_Style_Gray1_Background align-items-center justify-content-center", 3, "ngClass", "click", 4, "ngIf"], [1, "items-wrapper", 3, "ngClass"], ["id", "summary-preference-scrollbar-items", 3, "ngClass"], ["class", "px-3 col-12 col-md-6 col-lg-3", 4, "ngIf"], ["tabindex", "0", "role", "button", "class", "fal fa-chevron-right float-right Spa_Style_Gray1_Background control justify-content-center align-items-center", 3, "ngClass", "click", 4, "ngIf"], ["navigationAdapter", "", 1, "pt-3", "Spa_Style_Large_Font", 3, "innerHtml"], ["role", "button", "tabIndex", "0", 1, "fal", "fa-chevron-left", "float-left", "control", "Spa_Style_Gray1_Background", "align-items-center", "justify-content-center", 3, "ngClass", "click"], [1, "px-3", "col-12", "col-md-6", "col-lg-3"], [1, "preference-content"], [3, "qualifiedHelpText", "subsidySelected", "subsidyPercentage", "addLinkText", "tag", "preferencesEditText", "analyticsEvent"], ["aria-hidden", "true", 1, "fas", "Spa_Style_HealthIcon", "Spa_Style_Larger_Font"], [1, "Spa_Style_Regular_Font", "Spa_Style_Semi_Bold_Weight", "my-1", "pr-5"], [1, "Spa_Style_Regular_Font"], [1, "float-right", 3, "role", "ariaLabel", "click", "keyup.enter"], ["link-body", ""], ["aria-hidden", "true", 1, "pt-1", "pr-2"], [1, "Spa_Style_Small_Font", "pl-3"], [1, "preference-content", "mb-3"], [3, "pcpText", "guidedHelpHideLinkText", "guidedHelpViewAllLinkText", "tag", "addLinkText", "providers", "providersText", "preferencesEditText", "analyticsEvent"], ["aria-hidden", "true", 1, "fas", "Spa_Style_PrescriptionsIcon", "Spa_Style_Larger_Font"], [1, "Spa_Style_Regular_Font", "Spa_Style_Semi_Bold_Weight", "my-1", "pr-4"], [3, "tag", "ariaLabel", 4, "ngIf"], [4, "ngFor", "ngForOf"], [3, "tag", "ariaLabel"], ["tag-image-body", "", 1, "pl-2"], ["aria-hidden", "true", 1, "fas", "fa-plus-circle", "mr-1"], ["class", "mb-1", 4, "ngIf"], [1, "Spa_Style_Small_Font", "pl-3", "mb-1", "no-translate-block"], [1, "mb-1"], [3, "keyNameForLiveEdit", "makeInlineBlock", "click"], ["link-body", "", 1, "pl-2"], ["aria-hidden", "true", 1, "fas", "Spa_Style_PharmacyIcon", "Spa_Style_Larger_Font"], [4, "ngIf", "ngIfElse"], ["pharmacyDetail", ""], ["class", "Spa_Style_Small_Font mb-1", 4, "ngFor", "ngForOf"], [1, "Spa_Style_Small_Font", "mb-1"], [1, "no-translate-block"], [1, "Spa_Style_Small_Font", "mb-2", "pl-0"], ["aria-hidden", "true", 1, "fas", "Spa_Style_OtherPreferencesIcon", "Spa_Style_Larger_Font"], [1, "Spa_Style_Regular_Font", "Spa_Style_Semi_Bold_Weight", "my-1", "pr-2"], ["class", "float-right", 3, "role", "ariaLabel", "click", "keyup.enter", 4, "ngIf"], ["class", "Spa_Style_Small_Font pl-3", 4, "ngIf"], ["tabindex", "0", "role", "button", 1, "fal", "fa-chevron-right", "float-right", "Spa_Style_Gray1_Background", "control", "justify-content-center", "align-items-center", 3, "ngClass", "click"]], template: function SummaryPreferencesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, SummaryPreferencesComponent_div_1_Template, 19, 23, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.guidedHelpEnabled);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, NavigationAdapterDirective, LiveEditPropDirective, IconAriaAttributesDirective, QualifiedHelpSummaryComponent, SummaryPreferencesProviderComponent, i1$2.AsyncPipe, SafePipe, OrderPipe], styles: [".preferences-wrapper[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);align-items:center;position:relative}.edit-link[_ngcontent-%COMP%]{position:absolute;right:20px;top:10px}#summary-preference-scrollbar-items[_ngcontent-%COMP%]{display:flex;overflow-x:hidden;padding-left:10px}.control[_ngcontent-%COMP%]{width:40px;font-size:32px;display:flex}.items-wrapper[_ngcontent-%COMP%]{width:calc(100% - 80px);padding:20px 0}#summary-preference-scrollbar-items[_ngcontent-%COMP%]::-webkit-scrollbar{display:none}.scrollbar[_ngcontent-%COMP%]{display:none}.items-wrapper[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{list-style-type:none}.preference-content[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{list-style-type:disc;word-wrap:break-word}[_nghost-%COMP%]     .preference-content ul, .preference-content[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{list-style-type:disc}@media (min-width: 992px){.left-gradient[_ngcontent-%COMP%]{-webkit-mask-image:linear-gradient(to left,black 92%,transparent 100%);mask-image:linear-gradient(to left,black 92%,transparent 100%)}.right-gradient[_ngcontent-%COMP%]{-webkit-mask-image:linear-gradient(to right,black 92%,transparent 100%);mask-image:linear-gradient(to right,black 92%,transparent 100%)}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SummaryPreferencesComponent, [{
        type: Component,
        args: [{ selector: 'vnext-summary-preferences', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container\">\r\n  <div *ngIf=\"guidedHelpEnabled\">\r\n    <div class=\"row mt-2 mx-0 mb-1\">\r\n      <h2\r\n        class=\"pt-3 Spa_Style_Large_Font\"\r\n        *liveEditProp=\"'Spa_Summary_AddPreferences_Text'\"\r\n        [innerHtml]=\"addPreferencesText | safe : 'html'\"\r\n        navigationAdapter\r\n      ></h2>\r\n    </div>\r\n    <div class=\"my-2 mx-0 preferences-wrapper\">\r\n      <nav class=\"d-flex justify-content-center\">\r\n        <div\r\n          *ngIf=\"preferencePointer$ | async; let preferencePointer\"\r\n          [ngClass]=\"{\r\n            invisible: hideMobileNavigation || (hideLeftPreferenceNavigationButton$ | async)\r\n          }\"\r\n          [attr.aria-label]=\"'Previous'\"\r\n          role=\"button\"\r\n          tabIndex=\"0\"\r\n          class=\"fal fa-chevron-left float-left control Spa_Style_Gray1_Background align-items-center justify-content-center\"\r\n          (click)=\"scroll(preferenceDirection.LEFT, preferencePointer - 1)\"\r\n        ></div>\r\n        <div\r\n          class=\"items-wrapper\"\r\n          [ngClass]=\"{\r\n            'left-gradient': !(hideLeftPreferenceNavigationButton$ | async)\r\n          }\"\r\n        >\r\n          <ul id=\"summary-preference-scrollbar-items\" [ngClass]=\"{ 'right-gradient': !(hideRightPreferenceNavigationButton$ | async) }\">\r\n            <li *ngIf=\"showSubsidyAccordion\" class=\"px-3 col-12 col-md-6 col-lg-3\">\r\n              <div class=\"preference-content\">\r\n                <vnext-summary-qualified-help\r\n                  [qualifiedHelpText]=\"qualifiedHelpText\"\r\n                  [subsidySelected]=\"subsidySelected\"\r\n                  [subsidyPercentage]=\"subsidyPercentage\"\r\n                  [addLinkText]=\"addLinkText\"\r\n                  [tag]=\"pageTags.GUIDED_HELP_GETTING_STARTED\"\r\n                  [preferencesEditText]=\"preferencesEditText\"\r\n                  (analyticsEvent)=\"redirectGuidedHelpPages(pageTags.GUIDED_HELP_GETTING_STARTED)\"\r\n                >\r\n                </vnext-summary-qualified-help>\r\n              </div>\r\n            </li>\r\n            <li *ngIf=\"healthEnabled\" class=\"px-3 col-12 col-md-6 col-lg-3\">\r\n              <div class=\"preference-content\">\r\n                <i class=\"fas Spa_Style_HealthIcon Spa_Style_Larger_Font\" aria-hidden=\"true\"></i>\r\n                <div class=\"Spa_Style_Regular_Font Spa_Style_Semi_Bold_Weight my-1 pr-5\">\r\n                  <h3 class=\"Spa_Style_Regular_Font\">{{ healthText }}</h3>\r\n                  <span>\r\n                    <vnext-link\r\n                      (click)=\"redirectGuidedHelpPages(pageTags.GUIDED_HELP_HEALTH)\"\r\n                      (keyup.enter)=\"redirectGuidedHelpPages(pageTags.GUIDED_HELP_HEALTH)\"\r\n                      class=\"float-right\"\r\n                      [role]=\"linkRoles.LINK\"\r\n                      [ariaLabel]=\"preferencesEditText + ' ' + healthText\"\r\n                    >\r\n                      <div link-body><i class=\"pt-1 pr-2\" aria-hidden=\"true\"></i> {{ preferencesEditText }}</div>\r\n                    </vnext-link>\r\n                  </span>\r\n                </div>\r\n                <ul class=\"Spa_Style_Small_Font pl-3\">\r\n                  <li>{{ selectedHealthStatus }}</li>\r\n                  <li>{{ ageRange }}</li>\r\n                </ul>\r\n              </div>\r\n            </li>\r\n            <li *ngIf=\"providersEnabled\" class=\"px-3 col-12 col-md-6 col-lg-3\">\r\n              <div class=\"preference-content mb-3\">\r\n                <vnext-summary-preferences-provider\r\n                  [pcpText]=\"pcpText\"\r\n                  [guidedHelpHideLinkText]=\"guidedHelpHideLinkText\"\r\n                  [guidedHelpViewAllLinkText]=\"guidedHelpViewAllLinkText\"\r\n                  [tag]=\"pageTags.GUIDED_HELP_PROVIDER_SEARCH\"\r\n                  [addLinkText]=\"addLinkText\"\r\n                  [providers]=\"providers\"\r\n                  [providersText]=\"providersText\"\r\n                  [preferencesEditText]=\"preferencesEditText\"\r\n                  (analyticsEvent)=\"redirectGuidedHelpPages(pageTags.GUIDED_HELP_PROVIDER_SEARCH)\"\r\n                ></vnext-summary-preferences-provider>\r\n              </div>\r\n            </li>\r\n            <li *ngIf=\"prescriptionsEnabled\" class=\"px-3 col-12 col-md-6 col-lg-3\">\r\n              <div class=\"preference-content mb-3\">\r\n                <i class=\"fas Spa_Style_PrescriptionsIcon Spa_Style_Larger_Font\" aria-hidden=\"true\"></i>\r\n                <div class=\"Spa_Style_Regular_Font Spa_Style_Semi_Bold_Weight my-1 pr-4\">\r\n                  <h3 class=\"Spa_Style_Regular_Font\">{{ prescriptionsText }}</h3>\r\n                  <span>\r\n                    <vnext-link\r\n                      (click)=\"redirectGuidedHelpPages(pageTags.GUIDED_HELP_PRESCRIPTIONS)\"\r\n                      (keyup.enter)=\"redirectGuidedHelpPages(pageTags.GUIDED_HELP_PRESCRIPTIONS)\"\r\n                      class=\"float-right\"\r\n                      [role]=\"linkRoles.LINK\"\r\n                      [ariaLabel]=\"preferencesEditText + ' ' + prescriptionsText\"\r\n                    >\r\n                      <div link-body><i class=\"pt-1 pr-2\" aria-hidden=\"true\"></i> {{ preferencesEditText }}</div>\r\n                    </vnext-link>\r\n                  </span>\r\n                </div>\r\n                <vnext-link\r\n                  *ngIf=\"!medicineCabinet || medicineCabinet.length === 0\"\r\n                  [tag]=\"pageTags.GUIDED_HELP_PRESCRIPTIONS\"\r\n                  [ariaLabel]=\"addLinkText + ' ' + prescriptionsText\"\r\n                >\r\n                  <div class=\"pl-2\" tag-image-body><i class=\"fas fa-plus-circle mr-1\" aria-hidden=\"true\"></i>{{ addLinkText }}</div>\r\n                </vnext-link>\r\n                <div *ngFor=\"let medicine of medicineCabinet | orderBy : 'drugDetails.drugName' : false : true; index as index\">\r\n                  <div *ngIf=\"index === maxDrugVisibleCount\" class=\"mb-1\">\r\n                    <vnext-link\r\n                      [keyNameForLiveEdit]=\"'Spa_GuidedHelp_HideMedicineLink_Text'\"\r\n                      [makeInlineBlock]=\"true\"\r\n                      (click)=\"showAllMedicineLabels = !showAllMedicineLabels\"\r\n                    >\r\n                      <div class=\"pl-2\" link-body>\r\n                        {{ getLinkText(showAllMedicineLabels) }} <i class=\"{{ getIcon(showAllMedicineLabels) }}\"></i>\r\n                      </div>\r\n                    </vnext-link>\r\n                  </div>\r\n                  <ul class=\"Spa_Style_Small_Font pl-3 mb-1 no-translate-block\">\r\n                    <li *ngIf=\"index < maxDrugVisibleCount || showAllMedicineLabels\">\r\n                      {{ medicine.drugDetails.drugName }}\r\n                    </li>\r\n                  </ul>\r\n                </div>\r\n              </div>\r\n            </li>\r\n            <li *ngIf=\"pharmacyEnabled\" class=\"px-3 col-12 col-md-6 col-lg-3\">\r\n              <div class=\"preference-content\">\r\n                <i class=\"fas Spa_Style_PharmacyIcon Spa_Style_Larger_Font\" aria-hidden=\"true\"></i>\r\n                <div class=\"Spa_Style_Regular_Font Spa_Style_Semi_Bold_Weight my-1 pr-4\">\r\n                  <h3 class=\"Spa_Style_Regular_Font\">{{ pharmacyText }}</h3>\r\n                  <span>\r\n                    <vnext-link\r\n                      (click)=\"redirectGuidedHelpPages(pageTags.GUIDED_HELP_PHARMACY_SEARCH)\"\r\n                      (keyup.enter)=\"redirectGuidedHelpPages(pageTags.GUIDED_HELP_PHARMACY_SEARCH)\"\r\n                      class=\"float-right\"\r\n                      [role]=\"linkRoles.LINK\"\r\n                      [ariaLabel]=\"preferencesEditText + ' ' + pharmacyText\"\r\n                    >\r\n                      <div link-body><i class=\"pt-1 pr-2\" aria-hidden=\"true\"></i> {{ preferencesEditText }}</div>\r\n                    </vnext-link>\r\n                  </span>\r\n                </div>\r\n                <vnext-link\r\n                  *ngIf=\"!selectedPharmacy\"\r\n                  [tag]=\"pageTags.GUIDED_HELP_PHARMACY_SEARCH\"\r\n                  [ariaLabel]=\"addLinkText + ' ' + pharmacyText\"\r\n                >\r\n                  <div class=\"pl-2\" tag-image-body><i class=\"fas fa-plus-circle mr-1\" aria-hidden=\"true\"></i>{{ addLinkText }}</div>\r\n                </vnext-link>\r\n                <ng-container *ngIf=\"multiPharmacyEnabled; else pharmacyDetail\">\r\n                  <ul class=\"Spa_Style_Small_Font pl-3\">\r\n                    <div class=\"Spa_Style_Small_Font mb-1\" *ngFor=\"let selectedPharmacy of selectedPharmacies\">\r\n                      <li>\r\n                        <span class=\"no-translate-block\">{{ selectedPharmacy.name }}</span>\r\n                        <span *ngIf=\"selectedPharmacy.pharmacyId === primaryPharmacy.pharmacyId && selectedPharmacies.length > 1\"\r\n                          >({{ primaryPharmacyIndicatorText }})</span\r\n                        >\r\n                      </li>\r\n                    </div>\r\n                  </ul>\r\n                </ng-container>\r\n                <ng-template #pharmacyDetail>\r\n                  <ng-container *ngIf=\"selectedPharmacy\">\r\n                    <div class=\"Spa_Style_Small_Font mb-2 pl-0\">\r\n                      <span class=\"no-translate-block\">{{ selectedPharmacy.name }}</span>\r\n                    </div>\r\n                  </ng-container>\r\n                </ng-template>\r\n              </div>\r\n            </li>\r\n            <li *ngIf=\"otherPreferencesEnabled\" class=\"px-3 col-12 col-md-6 col-lg-3\">\r\n              <div class=\"preference-content\">\r\n                <i class=\"fas Spa_Style_OtherPreferencesIcon Spa_Style_Larger_Font\" aria-hidden=\"true\"></i>\r\n                <div class=\"Spa_Style_Regular_Font Spa_Style_Semi_Bold_Weight my-1 pr-2\">\r\n                  <h3 class=\"Spa_Style_Regular_Font\">{{ otherPreferencesText }}</h3>\r\n                  <span>\r\n                    <vnext-link\r\n                      *ngIf=\"hasSelectedOtherPreferences()\"\r\n                      (click)=\"redirectGuidedHelpPages(pageTags.GUIDED_HELP_OTHER_PREFERENCES)\"\r\n                      (keyup.enter)=\"redirectGuidedHelpPages(pageTags.GUIDED_HELP_OTHER_PREFERENCES)\"\r\n                      class=\"float-right\"\r\n                      [role]=\"linkRoles.LINK\"\r\n                      [ariaLabel]=\"preferencesEditText + ' ' + otherPreferencesText\"\r\n                    >\r\n                      <div link-body><i class=\"pt-1 pr-2\" aria-hidden=\"true\"></i> {{ preferencesEditText }}</div>\r\n                    </vnext-link>\r\n                  </span>\r\n                </div>\r\n                <vnext-link\r\n                  *ngIf=\"!hasSelectedOtherPreferences()\"\r\n                  [tag]=\"pageTags.GUIDED_HELP_OTHER_PREFERENCES\"\r\n                  [ariaLabel]=\"addLinkText + ' ' + otherPreferencesText\"\r\n                >\r\n                  <div class=\"pl-2\" tag-image-body><i class=\"fas fa-plus-circle mr-1\" aria-hidden=\"true\"></i>{{ addLinkText }}</div>\r\n                </vnext-link>\r\n                <ul class=\"Spa_Style_Small_Font pl-3\" *ngIf=\"hasSelectedOtherPreferences()\">\r\n                  <div class=\"Spa_Style_Small_Font mb-1\">\r\n                    <li>\r\n                      {{ guidedHelpOtherPreferencesMessageText }}\r\n                    </li>\r\n                  </div>\r\n                </ul>\r\n              </div>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n        <div\r\n          *ngIf=\"preferencePointer$ | async; let preferencePointer\"\r\n          [ngClass]=\"{\r\n            invisible: hideMobileNavigation || (hideRightPreferenceNavigationButton$ | async)\r\n          }\"\r\n          [attr.aria-label]=\"'Next'\"\r\n          tabindex=\"0\"\r\n          role=\"button\"\r\n          class=\"fal fa-chevron-right float-right Spa_Style_Gray1_Background control justify-content-center align-items-center\"\r\n          (click)=\"scroll(preferenceDirection.RIGHT, preferencePointer + 1)\"\r\n        ></div>\r\n      </nav>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".preferences-wrapper{border:1px solid var(--static-Spa_Style_Accent1);align-items:center;position:relative}.edit-link{position:absolute;right:20px;top:10px}#summary-preference-scrollbar-items{display:flex;overflow-x:hidden;padding-left:10px}.control{width:40px;font-size:32px;display:flex}.items-wrapper{width:calc(100% - 80px);padding:20px 0}#summary-preference-scrollbar-items::-webkit-scrollbar{display:none}.scrollbar{display:none}.items-wrapper ul{list-style-type:none}.preference-content ul{list-style-type:disc;word-wrap:break-word}:host >>> .preference-content ul,.preference-content ul{list-style-type:disc}@media (min-width: 992px){.left-gradient{-webkit-mask-image:linear-gradient(to left,black 92%,transparent 100%);mask-image:linear-gradient(to left,black 92%,transparent 100%)}.right-gradient{-webkit-mask-image:linear-gradient(to right,black 92%,transparent 100%);mask-image:linear-gradient(to right,black 92%,transparent 100%)}}\n"] }]
    }], function () { return [{ type: i1.GuidedHelpService }, { type: i1.ResponsiveLayoutService }, { type: i0.ChangeDetectorRef }, { type: AnalyticsService }, { type: i1.NavigationService }, { type: i2.Store }]; }, { addPreferencesText: [{
            type: Input
        }], healthText: [{
            type: Input
        }], qualifiedHelpText: [{
            type: Input
        }], prescriptionsText: [{
            type: Input
        }], pharmacyText: [{
            type: Input
        }], guidedHelpHideLinkText: [{
            type: Input
        }], guidedHelpViewAllLinkText: [{
            type: Input
        }], guidedHelpEnabled: [{
            type: Input
        }], getStartedEnabled: [{
            type: Input
        }], healthEnabled: [{
            type: Input
        }], showSubsidyAccordion: [{
            type: Input
        }], prescriptionsEnabled: [{
            type: Input
        }], pharmacyEnabled: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], medicineCabinet: [{
            type: Input
        }], preferencesEditText: [{
            type: Input
        }], addLinkText: [{
            type: Input
        }], selectedHealthStatus: [{
            type: Input
        }], subsidySelected: [{
            type: Input
        }], subsidyPercentage: [{
            type: Input
        }], isRetention: [{
            type: Input
        }], preferencesEditDescription: [{
            type: Input
        }], selectedPharmacies: [{
            type: Input
        }], multiPharmacyEnabled: [{
            type: Input
        }], primaryPharmacy: [{
            type: Input
        }], primaryPharmacyIndicatorText: [{
            type: Input
        }], providersEnabled: [{
            type: Input
        }], providers: [{
            type: Input
        }], providersText: [{
            type: Input
        }], pcpText: [{
            type: Input
        }], defaultAge: [{
            type: Input
        }], otherPreferencesEnabled: [{
            type: Input
        }], otherPreferencesText: [{
            type: Input
        }], guidedHelpOtherPreferencesMessageText: [{
            type: Input
        }] }); })();

function SummaryButtonsComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "button", 6);
    i0.ɵɵlistener("click", function SummaryButtonsComponent_div_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onComparePlansSelected()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.compareThesePlansButtonText, " ");
} }
class SummaryButtonsComponent {
    constructor() {
        this.shopForPlansSelected = new EventEmitter();
        this.comparePlansSelected = new EventEmitter();
    }
    onShopForPlan() {
        this.shopForPlansSelected.emit();
    }
    onComparePlansSelected() {
        this.comparePlansSelected.emit();
    }
}
SummaryButtonsComponent.ɵfac = function SummaryButtonsComponent_Factory(t) { return new (t || SummaryButtonsComponent)(); };
SummaryButtonsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SummaryButtonsComponent, selectors: [["vnext-summary-buttons"]], inputs: { filteredPlans: "filteredPlans", compareThesePlansButtonText: "compareThesePlansButtonText", shopAllPlansButtonText: "shopAllPlansButtonText" }, outputs: { shopForPlansSelected: "shopForPlansSelected", comparePlansSelected: "comparePlansSelected" }, decls: 6, vars: 2, consts: [[1, "container"], [1, "row", "justify-content-sm-end"], ["class", "col-12 col-sm-5 col-md-4 col-lg-3 pr-sm-0", 4, "ngIf"], [1, "col-12", "col-sm-6", "col-md-4", "col-lg-3", "mt-2", "mt-sm-0"], [1, "btn", "Spa_Style_PrimaryButton", "btn-block", 3, "click"], [1, "col-12", "col-sm-5", "col-md-4", "col-lg-3", "pr-sm-0"], [1, "btn", "Spa_Style_SecondaryButton", "btn-block", 3, "click"]], template: function SummaryButtonsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, SummaryButtonsComponent_div_2_Template, 3, 1, "div", 2);
        i0.ɵɵelementStart(3, "div", 3)(4, "button", 4);
        i0.ɵɵlistener("click", function SummaryButtonsComponent_Template_button_click_4_listener() { return ctx.onShopForPlan(); });
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.filteredPlans == null ? null : ctx.filteredPlans.length) > 1);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.shopAllPlansButtonText, " ");
    } }, dependencies: [i1$2.NgIf], encapsulation: 2, changeDetection: 0 });
__decorate([
    LiveEditInactive()
], SummaryButtonsComponent.prototype, "onShopForPlan", null);
__decorate([
    LiveEditInactive()
], SummaryButtonsComponent.prototype, "onComparePlansSelected", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SummaryButtonsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-summary-buttons', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container\">\r\n  <div class=\"row justify-content-sm-end\">\r\n    <div class=\"col-12 col-sm-5 col-md-4 col-lg-3 pr-sm-0\" *ngIf=\"filteredPlans?.length > 1\">\r\n      <button class=\"btn Spa_Style_SecondaryButton btn-block\" (click)=\"onComparePlansSelected()\">\r\n        {{ compareThesePlansButtonText }}\r\n      </button>\r\n    </div>\r\n    <div class=\"col-12 col-sm-6 col-md-4 col-lg-3 mt-2 mt-sm-0\">\r\n      <button class=\"btn Spa_Style_PrimaryButton btn-block\" (click)=\"onShopForPlan()\">\r\n        {{ shopAllPlansButtonText }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n" }]
    }], null, { filteredPlans: [{
            type: Input
        }], compareThesePlansButtonText: [{
            type: Input
        }], shopAllPlansButtonText: [{
            type: Input
        }], shopForPlansSelected: [{
            type: Output
        }], comparePlansSelected: [{
            type: Output
        }], onShopForPlan: [], onComparePlansSelected: [] }); })();

function QuoteSummaryComponent_vnext_widget_quote_plan_card_7_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-widget-quote-plan-card", 7);
    i0.ɵɵlistener("quoteClicked", function QuoteSummaryComponent_vnext_widget_quote_plan_card_7_Template_vnext_widget_quote_plan_card_quoteClicked_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.planFacade.updateMedSupFormOpen(true)); })("viewPlanDetails", function QuoteSummaryComponent_vnext_widget_quote_plan_card_7_Template_vnext_widget_quote_plan_card_viewPlanDetails_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.quoteFacade.navigateToPlanDetailsPage($event)); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    let tmp_25_0;
    let tmp_26_0;
    i0.ɵɵproperty("plans", ctx_r0.filteredPlans)("PlanStep", ctx_r0.Spa_QuoteSummary_PickPlan_Text)("pickPlanText", ctx_r0.Spa_QuoteSummary_PickPlan_Text)("planCardQuoteLinkText", ctx_r0.Spa_PlanCard_QuoteLinkName_Text)("planDetailsButtonText", ctx_r0.Spa_PlanCard_PlanDetails_ButtonText)("planBenefitNoValueLabel", ctx_r0.Spa_Site_NotApplicable_Text)("planTypeText", ctx_r0.Spa_PlanCard_PlanType_Text)("addOnCoverageText", ctx_r0.Spa_PlanCard_AddOnCoverageInCart_Text)("addOnCoverageTooltip", ctx_r0.Spa_PlanCard_AddOnCoverageTooltip_Body)("planDetailsNonCoveredText", ctx_r0.Spa_PlanDetails_Non_Covered_Text)("prescriptionText", ctx_r0.Spa_Site_Prescriptions_Text)("pharmacyText", ctx_r0.Spa_Site_Pharmacy_Text)("isTotalEstimatedCostEnabled", ctx_r0.Spa_Site_TotalEstimatedCost_Enabled)("totalEstimatedAnnualCostText", ctx_r0.Spa_PlanCard_TotalEstimatedAnnualCost_Text)("totalEstimatedCostText", ctx_r0.Spa_PlanCard_TotalEstimatedCost_Text)("totalEstimatedCostTooltip", ctx_r0.Spa_PlanCard_Total_Estimated_Cost_Tooltip)("showPlanLogo", ctx_r0.Spa_Site_Show_PlanLogo)("showRidersOnPlanCards", ctx_r0.Spa_Site_ShowRidersOnPlanCards)("showPremiumAsAnnual", ctx_r0.Spa_Site_ShowPremiumAsAnnual)("riderDisplayMap", ctx_r0.riderDisplayMap)("shoppingCartEnabled", ctx_r0.Spa_ShoppingCart_Enabled)("drugCoveredText", ctx_r0.Spa_PlanCard_Drug_Covered_Text)("hidePlanCardLabel", true)("pharmacyCoveredText", ctx_r0.Spa_PlanCard_Pharmacy_Covered_Text)("displayDrugsCovered", ctx_r0.Spa_PlanList_DisplayDrugsCovered)("benefits", (tmp_25_0 = ctx_r0.quoteFacade.getDefaultTab()) == null ? null : tmp_25_0.benefits)("benefitPreferences", (tmp_26_0 = ctx_r0.quoteFacade.getDefaultTab()) == null ? null : tmp_26_0.benefitPreferences)("currentPlanText", ctx_r0.Spa_Site_Current_Plan_Text)("isMobile", i0.ɵɵpipeBind1(1, 100, ctx_r0.isMobile$))("nextYearPlanText", ctx_r0.Spa_Site_Next_Year_Plan_Text)("isQuoting", ctx_r0.isQuotingSite)("Spa_Site_ShowRiderIcons", ctx_r0.Spa_Site_ShowRiderIcons)("Spa_Site_Dental_Rider_Display_Text", ctx_r0.Spa_Site_Dental_Rider_Display_Text)("Spa_Site_Vision_Rider_Display_Text", ctx_r0.Spa_Site_Vision_Rider_Display_Text)("Spa_Site_Hearing_Rider_Display_Text", ctx_r0.Spa_Site_Hearing_Rider_Display_Text)("Spa_PlanCard_DentalAddOnCoverage_Text", ctx_r0.Spa_PlanCard_DentalAddOnCoverage_Text)("Spa_PlanCard_HearingAddOnCoverage_Text", ctx_r0.Spa_PlanCard_HearingAddOnCoverage_Text)("Spa_PlanCard_VisionAddOnCoverage_Text", ctx_r0.Spa_PlanCard_VisionAddOnCoverage_Text)("Spa_PlanCard_AddOnCoverage_Text", ctx_r0.Spa_PlanCard_AddOnCoverage_Text)("Spa_Site_MedigapPlanType_Enabled", ctx_r0.Spa_Site_MedigapPlanType_Enabled)("Spa_Site_AddToCompare_Enabled", ctx_r0.Spa_Site_AddToCompare_Enabled)("Spa_Site_PlanViewDetails_Enabled", ctx_r0.Spa_Site_PlanViewDetails_Enabled)("Spa_Site_Tooltip_Text", ctx_r0.Spa_Site_Tooltip_Text)("selectedPharmacy", ctx_r0.selectedPharmacy)("inNetworkPreferredText", ctx_r0.Spa_PlanList_Pharmacy_InNetwork_Preferred_Pricing_Text)("inNetworkStandardText", ctx_r0.Spa_PlanList_Pharmacy_InNetwork_Standard_Pricing_Text)("outOfNetworkText", ctx_r0.Spa_PlanList_Pharmacy_OutOfNetwork_Pricing_Text)("isMailOrderSelected", i0.ɵɵpipeBind1(2, 102, ctx_r0.pharmacyFacade.mailOrder$))("viewCostTooltipHeaderText", ctx_r0.Spa_PlanList_ViewCost_Header_Text)("viewCostTooltipHeaderContent", ctx_r0.Spa_PlanList_ViewCost_Header_Content)("mailOrderText", ctx_r0.Spa_PlanList_MailOrder_Text)("providersInNetworkText", ctx_r0.Spa_PlanCard_Providers_InNetwork_Text)("pcpInNetworkText", ctx_r0.Spa_Site_Pcp_InNetwork_Text)("pcpOutOfNetworkText", ctx_r0.Spa_Site_Pcp_OutOfNetwork_Text)("providersNoDataText", ctx_r0.Spa_Providers_No_Data_Exist_Text)("isProviderEnabled", ctx_r0.Spa_Site_Providers_Enabled)("selectedProviders", ctx_r0.providers)("providerDetails", i0.ɵɵpipeBind1(3, 104, ctx_r0.providerDetails$))("viewDetailsDescriptionText", ctx_r0.Spa_Site_ViewDetailsLink_Description_Text)("medicineCabinet", ctx_r0.medicineCabinet)("planCardPreferenceDetailedEnabled", ctx_r0.Spa_PlanCard_Preferences_Detailed_Enabled)("planLogoSize", ctx_r0.Spa_Site_PlanLogo_Size)("loaderIconEnabled", ctx_r0.Spa_Site_Loader_Updated_Icon_Enabled)("editLinkText", ctx_r0.editLinkText)("providerOneOrMoreOutOfNetworkText", ctx_r0.Spa_PlanCard_Providers_OneOrMore_OutOfNetwork_Text)("providerInNetworkOnOtherLocationsTooltipText", ctx_r0.Spa_Providers_InNetwork_OnOtherLocations_Tooltip_Text)("providerShowPartialIndicatorEnabled", ctx_r0.Spa_Provider_ShowPartialIndicator_Enabled)("planFeesEnabled", ctx_r0.Spa_Site_PlanFees_Enabled)("planFeesTooltipText", ctx_r0.Spa_PlanFees_Tooltip_Text)("planFeesIncludedInPremiumTooltipText", ctx_r0.Spa_PlanFees_IncludedInPremium_Tooltip_Text)("planFeesNotIncludedInPremiumTooltipText", ctx_r0.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text)("showPlanId", ctx_r0.Spa_PlanCard_Show_PlanId_Enabled)("showPlanYear", ctx_r0.Spa_PlanCard_PlanYearBadge_Enabled)("planIdText", ctx_r0.Spa_PlanCard_PlanId_Text)("availableText", ctx_r0.Spa_Site_Available_Text)("unavailableText", ctx_r0.Spa_Site_NotAvailable_Text)("viewProvidersButtonText", ctx_r0.Spa_PlanCard_Providers_ViewButton_Text)("viewPrescriptionsButtonText", ctx_r0.Spa_PlanCard_Prescriptions_ViewButton_Text)("supplementalBenefitsHighlightText", ctx_r0.Spa_PlanCard_SupplementalBenefitsHighlight_Text)("preferencesText", ctx_r0.Spa_Plan_Details_Preferences_Text)("viewMoreDetailsText", ctx_r0.Spa_PlanCard_ViewMoreDetails_ButtonText)("hideDetailsText", ctx_r0.Spa_PlanCard_HideDetails_ButtonText)("newPlanCardDesignEnabled", ctx_r0.Spa_PlanCard_NewDesign_Enabled)("viewAllPlanDetailsText", ctx_r0.Spa_PlanCard_ViewAllPlanDetails_ButtonText)("shareThisPlanText", ctx_r0.Spa_PlanCard_ShareThisPlan_ButtonText)("viewCostDetailsText", ctx_r0.Spa_PlanCard_ViewCostDetails_ButtonText)("closeText", ctx_r0.Spa_Site_Close)("planBenefitHighlightItems", ctx_r0.Spa_PlanCard_PlanBenefitHighlight_Items)("planBenefitHighlightsHeaderText", ctx_r0.Spa_PlanCard_PlanBenefitHighlights_Text)("showRiderDetails", ctx_r0.Spa_Site_RiderDetails_Show)("showRiderDetailsText", ctx_r0.Spa_Plan_Details_ViewRiderDetails_Text)("hideRiderDetailsText", ctx_r0.Spa_Plan_Details_HideRiderDetails_Text)("riderIsIncludedText", ctx_r0.Spa_ShoppingCart_IncludedRider_Text)("waiverStateRiderTooltips", ctx_r0.Spa_Plan_Details_WaiverStateRider_Tooltips)("costMA", ctx_r0.Spa_Plandetails_Costs_MA)("costMAPD", ctx_r0.Spa_Plandetails_Costs_MAPD)("costPDP", ctx_r0.Spa_Plandetails_Costs_PDP)("costMEDIGAP", ctx_r0.Spa_Plandetails_Costs_MEDIGAP)("costDENTAL", ctx_r0.Spa_PlanDetails_Costs_DENTAL)("costVISION", ctx_r0.Spa_PlanDetails_Costs_VISION);
} }
function QuoteSummaryComponent_div_8_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 10);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r6.Spa_Site_Provider_Disclaimer, "html"), i0.ɵɵsanitizeHtml);
} }
function QuoteSummaryComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, QuoteSummaryComponent_div_8_p_1_Template, 2, 4, "p", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_Provider_Disclaimer");
} }
function QuoteSummaryComponent_vnext_summary_buttons_9_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-summary-buttons", 11);
    i0.ɵɵlistener("comparePlansSelected", function QuoteSummaryComponent_vnext_summary_buttons_9_Template_vnext_summary_buttons_comparePlansSelected_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.quoteFacade.updatePlansOnCompareGroupAndNavigate(ctx_r7.filteredPlans)); })("shopForPlansSelected", function QuoteSummaryComponent_vnext_summary_buttons_9_Template_vnext_summary_buttons_shopForPlansSelected_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.quoteFacade.shopAllPlans()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("filteredPlans", ctx_r2.filteredPlans)("shopAllPlansButtonText", ctx_r2.Spa_Site_Shop_All_Plans_Button_Text)("compareThesePlansButtonText", ctx_r2.Spa_Quote_CompareThesePlans_Button_Text);
} }
let QuoteSummaryComponent = class QuoteSummaryComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, memberSessionService, imageService, guidedHelpService, quoteFacade, planFacade, injector, modalService, retentionFacade, responsiveLayoutService, plansService, siteService, quoteService, localeService, pharmacyFacade, store, activatedRoute, analyticsService, configResourceService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.memberSessionService = memberSessionService;
        this.imageService = imageService;
        this.guidedHelpService = guidedHelpService;
        this.quoteFacade = quoteFacade;
        this.planFacade = planFacade;
        this.injector = injector;
        this.modalService = modalService;
        this.retentionFacade = retentionFacade;
        this.responsiveLayoutService = responsiveLayoutService;
        this.plansService = plansService;
        this.siteService = siteService;
        this.quoteService = quoteService;
        this.localeService = localeService;
        this.pharmacyFacade = pharmacyFacade;
        this.store = store;
        this.activatedRoute = activatedRoute;
        this.analyticsService = analyticsService;
        this.configResourceService = configResourceService;
        this.Spa_Site_QuoteWelcome_Background_Url = 'phoenix/assets/images/couple_dog.jpg';
        this.Spa_Site_QuoteWelcome_Background_MobileUrl = 'phoenix/assets/images/couple_dog_mobile.jpg';
        this.Spa_Site_Health_Text = 'Health';
        this.Spa_Site_QualifiedHelp_Text = 'Qualified help';
        this.Spa_Site_Prescriptions_Text = 'Prescriptions';
        this.Spa_Site_Pharmacy_Text = 'Pharmacy';
        this.Spa_Site_Hide_Text = 'Hide';
        this.Spa_Site_ViewAll_Text = 'View more';
        this.Spa_Site_Preferences_Edit_Text = 'Edit';
        this.Spa_GuidedHelp_PlanList_AddLink_Text = 'Add';
        this.Spa_GuidedHelp_Enabled = true;
        this.Spa_Site_GetStarted_Enabled = true;
        this.Spa_Site_Health_Enabled = true;
        this.Spa_GettingStarted_ShowSubsidyAccordion_Flag = true;
        this.Spa_Site_Prescriptions_Enabled = true;
        this.Spa_Site_Pharmacy_Enabled = true;
        this.Spa_Site_QuoteUserInfo_Name_Label = 'Name';
        this.Spa_Site_QuoteUserInfo_ZipCode_Label = 'ZIP code';
        this.Spa_Site_QuoteUserInfo_Email_Label = 'Email address';
        this.Spa_Site_QuoteUserInfo_Zipcode_Edit_Label = 'Edit';
        this.Spa_PlanCard_QuoteLinkName_Text = 'Get a personalized quote';
        this.Spa_PlanCard_PlanDetails_ButtonText = 'Plan details';
        this.Spa_PlanCard_PlanType_Text = 'Plan Type';
        this.Spa_PlanCard_AddOnCoverageInCart_Text = 'Add-on coverage available in cart';
        this.Spa_PlanCard_AddOnCoverageTooltip_Body = `<span>Available add-on coverage</span><br/>
  <span> To learn more about the add-on coverage available for this plan, either go to plan details or add this plan to your cart.</span>`;
        this.Spa_PlanDetails_Non_Covered_Text = 'Not Covered';
        this.Spa_Site_TotalEstimatedCost_Enabled = true;
        this.Spa_PlanCard_TotalEstimatedAnnualCost_Text = 'Total est. annual cost';
        this.Spa_PlanCard_TotalEstimatedCost_Text = 'Total est. cost';
        this.Spa_PersonalizedVideo_QuoteSummary_FrameTitle = 'Review your plan costs, and how to proceed with enrolling or contacting an agent';
        this.Spa_PlanCard_Total_Estimated_Cost_Tooltip = {
            header: 'Total estimated annual cost',
            body: 'Your total estimated annual cost is based on the plans yearly premium, your drug costs, and your health status and age.'
        };
        this.Spa_PlanCard_Drug_Covered_Text = '<coveredDrugCount> of <totalDrugCount> covered';
        this.Spa_PlanCard_Pharmacy_Covered_Text = '<coveredPharmacies> of <totalPharamcies> covered';
        this.Spa_Site_Current_Plan_Text = 'Current Plan';
        this.Spa_Site_Show_PlanLogo = true;
        this.Spa_Site_ShowRidersOnPlanCards = true;
        this.Spa_Site_ShowPremiumAsAnnual = false;
        this.Spa_Site_ShowRiderIcons = true;
        this.Spa_Site_Dental_Rider_Display_Text = 'Dental';
        this.Spa_Site_Vision_Rider_Display_Text = 'Vision';
        this.Spa_Site_Hearing_Rider_Display_Text = 'Hearing';
        this.Spa_PlanCard_DentalAddOnCoverage_Text = 'Dental Included';
        this.Spa_PlanCard_HearingAddOnCoverage_Text = 'Hearing Included';
        this.Spa_PlanCard_VisionAddOnCoverage_Text = 'Vision Included';
        this.Spa_PlanCard_AddOnCoverage_Text = 'Add-on coverage';
        this.Spa_PlanCard_ShowRidersOnMACards = true;
        this.Spa_PlanCard_ShowRidersOnPDPCards = true;
        this.Spa_PlanCard_ShowRidersOnMAPDCards = true;
        this.Spa_PlanCard_ShowRidersOnMEDIGAPCards = true;
        this.Spa_ShoppingCart_Enabled = true;
        this.Spa_Site_Next_Year_Plan_Text = `Next year's plan`;
        this.Spa_Site_PlanNotAvailableForNextYear_Text = 'Plan not available next year';
        this.Spa_Site_Keep_This_Plan_Button_Text = 'Keep this plan';
        this.Spa_Site_Shop_All_Plans_Button_Text = 'Shop all available plans';
        this.Spa_Quote_CompareThesePlans_Button_Text = 'Compare these plans';
        this.Spa_Quote_NotAvailable_Text = 'Not available';
        this.Spa_Site_NotApplicable_Text = 'N/A';
        this.Spa_Site_EnableQuoteSummary = true;
        this.Spa_Site_Preferences_Edit_Description = 'Edit Preferences';
        this.Spa_Site_UserInfo_Zipcode_Edit_Description = 'Edit Zipcode';
        this.Spa_Site_MedigapPlanType_Enabled = true;
        this.Spa_Site_AddToCompare_Enabled = true;
        this.Spa_Site_PlanViewDetails_Enabled = true;
        this.Spa_Site_Providers_Enabled = false;
        this.Spa_Site_Providers_Text = 'Providers';
        this.Spa_Site_Pcp_Text = 'PCP';
        this.Spa_PlanCard_Providers_InNetwork_Text = '<inNetwork> of <totalProviders> In-network';
        this.Spa_Site_Pcp_InNetwork_Text = 'PCP In-network';
        this.Spa_Site_Pcp_OutOfNetwork_Text = 'PCP Out-of-network';
        this.Spa_Providers_No_Data_Exist_Text = 'No provider data for this carrier';
        this.Spa_ZipCodeInput_CountyLabel_Text = 'County';
        this.Spa_ZipCodeInput_CountyLabel_Enabled = false;
        // Format for these keys is different than normal due to being created and used by the API team
        this.Spa_PersonalizedVideo_Enabled = false;
        this.Spa_PersonalizedVideo_Quote_Enabled = false;
        this.Spa_QuoteUserInfo_PersonalDetailsHeader_Text = 'Review your information';
        this.Spa_Summary_AddPreferences_Text = 'Add your preferences (Optional)';
        this.Spa_QuoteSummary_PickPlan_Text = 'Pick a plan';
        this.Spa_Site_ShopAllCoverage_Text = 'Shop all coverage types';
        this.Spa_Site_QuoteWelcome_Greeting_Text = 'Hi';
        this.Spa_Site_Provider_Disclaimer = 'Note: Double check the provider directory in case the data is outdated. You may access the provider directory from the plan details.';
        this.Spa_PlanList_DisplayDrugsCovered = true;
        this.Spa_Plan_Tab_Educational_Text_Show = true;
        this.Spa_Site_Tooltip_Text = 'Tooltip:';
        this.Spa_Site_Multi_Pharmacy_Enabled = false;
        this.Spa_Site_PrimaryPharmacy_Indicator_Text = 'primary';
        this.Spa_PlanList_Pharmacy_InNetwork_Preferred_Pricing_Text = 'Preferred In-network';
        this.Spa_PlanList_Pharmacy_InNetwork_Standard_Pricing_Text = 'Standard In-network';
        this.Spa_PlanList_Pharmacy_OutOfNetwork_Pricing_Text = 'Out of network';
        this.Spa_PlanList_ViewCost_Header_Text = 'View costs for other pharmacies';
        this.Spa_PlanList_ViewCost_Header_Content = 'Switch your pharmacy to the left of plans to view costs of other pharmacies';
        this.Spa_PlanList_MailOrder_Text = 'Mail order';
        this.Spa_GuidedHelp_Health_AgeDefault_Number = GuidedHelpAgeSelection.MEMBER_AGE_65_69;
        this.Spa_Site_OtherPreferences_Text = 'Other preferences';
        this.Spa_Site_OtherPreferences_Enabled = false;
        this.Spa_GuidedHelp_ReviewOtherPreferences_Text = 'Review and edit your other preferences.';
        this.Spa_Site_ViewDetailsLink_Description_Text = 'Press Enter to view plan details of ';
        this.Spa_PlanCard_Preferences_Detailed_Enabled = true;
        this.Spa_Site_PlanLogo_Size = 'small';
        this.Spa_Site_Provider_ShowAllInNetworkLocations_Enabled = false;
        this.Spa_Site_Loader_Updated_Icon_Enabled = false;
        this.Spa_PlanCard_Providers_OneOrMore_OutOfNetwork_Text = 'One or more locations are out of network';
        this.Spa_Providers_InNetwork_OnOtherLocations_Tooltip_Text = 'Selected location is out-of-network, however in-network locations are available.';
        this.Spa_Provider_ShowPartialIndicator_Enabled = false;
        this.Spa_Site_PlanFees_Enabled = false;
        this.Spa_PlanFees_Tooltip_Text = 'Fees';
        this.Spa_PlanFees_IncludedInPremium_Tooltip_Text = 'Included in premium';
        this.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text = 'Not included in premium';
        this.Spa_PlanCard_Show_PlanId_Enabled = false;
        this.Spa_PlanCard_PlanYearBadge_Enabled = false;
        this.Spa_PlanCard_PlanId_Text = 'Plan ID';
        this.Spa_Site_Available_Text = 'Available';
        this.Spa_Site_NotAvailable_Text = 'Not Available';
        this.Spa_PlanCard_Providers_ViewButton_Text = 'View providers';
        this.Spa_PlanCard_Prescriptions_ViewButton_Text = 'View prescriptions';
        this.Spa_PlanCard_SupplementalBenefitsHighlight_Text = 'Highlights';
        this.Spa_Plan_Details_Preferences_Text = 'Preferences';
        this.Spa_PlanCard_ViewMoreDetails_ButtonText = 'View more details';
        this.Spa_PlanCard_HideDetails_ButtonText = 'Hide details';
        this.Spa_PlanCard_NewDesign_Enabled = false;
        this.Spa_PlanCard_ViewAllPlanDetails_ButtonText = 'View all plan details';
        this.Spa_PlanCard_ShareThisPlan_ButtonText = 'Share this plan';
        this.Spa_PlanCard_ViewCostDetails_ButtonText = 'View cost details';
        this.Spa_Site_Close = 'Close';
        this.Spa_PlanCard_PlanBenefitHighlight_Items = [
            {
                name: 'Specialist Office Visit'
            },
            {
                name: 'Inpatient Hospital Care'
            },
            {
                name: 'Total est. cost'
            }
        ];
        this.Spa_PlanCard_PlanBenefitHighlights_Text = 'Plan benefit highlights';
        this.Spa_Site_RiderDetails_Show = false;
        this.Spa_Plan_Details_ViewRiderDetails_Text = 'View details';
        this.Spa_Plan_Details_HideRiderDetails_Text = 'Hide details';
        this.Spa_ShoppingCart_IncludedRider_Text = 'Included';
        this.Spa_Plan_Details_WaiverStateRider_Tooltips = [
            {
                id: 'Combined Rider',
                body: 'This optional plan benefit is a combination of riders for one price.'
            },
            {
                id: 'Part A Deductible',
                body: `"Part A Deductible" covers the amount that you must pay for inpatient hospital stays before Medicare begins to pay.`
            },
            {
                id: 'Part B Deductible',
                body: `"Part B Deductible" covers the amount that you must pay for Medicare-approved
           Part B medical services before Medicare Part B begins to pay.`
            },
            {
                id: 'Part B Excess',
                body: `"Part B Excess Charges" covers the  difference between the Medicare eligible charge and the amount charged by
          the provider which shall be no greater than the actual charge or the limited charge allowed by Medicare, whichever is less.`
            },
            {
                id: 'Preventive Care',
                body: `"Preventive Care"  pays up to $120 a year for covered preventive screening
           test and services and an annual physical examination.`
            },
            {
                id: 'Usual and Customary Fees',
                body: `"Usual and Customary Charges Fees" covers the difference between the Medicare eligible charge and the amount charged by
           the provider which shall be no greater than the actual charge or the limited charge allowed by Medicare, whichever is less.`
            },
            {
                id: 'Part B Excess Charges',
                body: `Part B Excess Charges" covers the  difference between the Medicare eligible charge
        and the amount charged by the provider which shall be no greater than the actual charge or
        the limited charge allowed by Medicare, whichever is less.`
            },
            {
                id: 'Additional Home Health Care',
                body: ` "Additional Home Health" extends home care visits up to 365 visits per policy year.`
            },
            {
                id: 'Foreign Travel Emergency',
                body: ` "Foreign Travel Emergency" covers at least 80% of eligible expenses associated with emergency
          medical care received outside the U.S.A. beginning the first 60 days of a trip up to a
          lifetime maximum of $50,000 (after a  deductible of $250).`
            },
            {
                id: 'Co-Pay Rider',
                body: ` "Co-Pay Rider" pays the Part B coinsurance subject to a copayment or coinsurance of no more
          than $20 per office visit and no more than $50 per emergency room visit that is in
          addition to the Medicare Part B medical deductible  and in addition to out-pocket maximums.`
            },
            {
                id: '50% Part A Deductible',
                body: `"50% of Part A Deductible" pays 50% of the inpatient deductible for qualifying hospital stays.`
            },
            {
                id: 'Part B Copayment or Coinsurance',
                body: `"Part B Copayment or Coinsurance" covers the amount you must pay as your share of the cost for medical services.
          Copayment is usually a set amount whereas coinsurance is a percentage.`
            }
        ];
        this.Spa_Plandetails_Costs_MAPD = [
            {
                title: PlanDetailsCostLabels.DRUG_COST,
                subText: 'Based on <totalDrugs> drugs',
                label: 'Annually Est Drug Cost',
                label2: 'Est Drug Cost',
                duration: 'annually',
                duration2: 'partial annually'
            },
            {
                title: PlanDetailsCostLabels.HEALTH_COST,
                subText: 'Estimated medical costs based on age <ageRange> and <healthStatus>.',
                label: 'Annually Health Cost',
                label2: 'Health Cost',
                duration: 'annually',
                duration2: 'partial annually'
            },
            {
                title: PlanDetailsCostLabels.TOTAL_ESTIMATED_COST,
                subText: 'Based on medical and drug costs.',
                label: 'Total est annual cost',
                label2: 'Total est cost',
                duration: 'annually',
                duration2: 'partial annually'
            }
        ];
        this.Spa_Plandetails_Costs_MA = [
            {
                title: PlanDetailsCostLabels.HEALTH_COST,
                subText: 'Estimated medical costs based on age <ageRange> and <healthStatus>.',
                label: 'Annually Health Cost',
                label2: 'Health Cost',
                duration: 'annually',
                duration2: 'partial annually'
            },
            {
                title: PlanDetailsCostLabels.TOTAL_ESTIMATED_COST,
                subText: 'Based on medical and drug costs.',
                label: 'Total est annual cost',
                label2: 'Total est cost',
                duration: 'annually',
                duration2: 'partial annually'
            }
        ];
        this.Spa_Plandetails_Costs_MEDIGAP = [
            {
                title: PlanDetailsCostLabels.HEALTH_COST,
                subText: 'Estimated medical costs based on age <ageRange> and <healthStatus>.',
                label: 'Health Cost',
                duration: 'annually'
            },
            {
                title: PlanDetailsCostLabels.TOTAL_ESTIMATED_COST,
                subText: 'Based on medical costs.',
                label: 'Total est annual cost',
                duration: 'annually'
            }
        ];
        this.Spa_Plandetails_Costs_PDP = [
            {
                title: PlanDetailsCostLabels.DRUG_COST,
                subText: 'Based on <totalDrugs> drugs',
                label: 'Annually Est Drug Cost',
                label2: 'Est Drug Cost',
                duration: 'annually',
                duration2: 'partial annually'
            },
            {
                title: PlanDetailsCostLabels.TOTAL_ESTIMATED_COST,
                subText: 'Based on medical and drug costs.',
                label: 'Total est annual cost',
                label2: 'Total est cost',
                duration: 'annually',
                duration2: 'partial annually'
            }
        ];
        this.Spa_PlanDetails_Costs_DENTAL = [
            {
                title: PlanDetailsCostLabels.PLAN_FEES,
                label: 'Fees',
                subText: '',
                duration: ''
            }
        ];
        this.Spa_PlanDetails_Costs_VISION = [
            {
                title: PlanDetailsCostLabels.PLAN_FEES,
                label: 'Fees',
                subText: '',
                duration: ''
            }
        ];
        this.subscriptions = new Subscription();
        this.tabs = [];
        this.otherPreferences = [];
        this.medicineCabinet = [];
        this.filteredPlans = [];
        this.quoteVideoURL = '';
        this.componentInitializing = false;
        this.rehydratePlanDetailInfo = true;
    }
    async ngOnInit() {
        super.ngOnInit();
        this.editLinkText = this.getEditLinkText();
        this.queryParams$ = this.activatedRoute.queryParams;
        this.initializationPlanType$ = this.queryParams$.pipe(map(params => (params.planType ? +params.planType : undefined)));
        this.plansByType$ = this.initializationPlanType$.pipe(switchMap(planType => planType ? this.plansService.getPlansByType$([planType]) : this.plansService.getAllPlans$()));
        this.loading$ = this.initializationPlanType$.pipe(switchMap(planType => this.plansService.getPlansStateIsLoading$(planType)));
        this.componentInitializing = true;
        if (!this.Spa_Site_EnableQuoteSummary) {
            this.siteService.setConsumerSiteType(ConsumerSiteType.ANONYMOUS);
            this.quoteService.resetBeneficiaryQuoteDetails();
            this.quoteFacade.logOut();
        }
        this.isQuotingSite$ = this.siteService.isQuotingSite$();
        await this.planFacade.addEffectiveDateInMemberSession();
        this.initializationPlanType$.pipe(take(1)).subscribe({
            next: (planType) => {
                if (this.plansService.getArePlansDirty(planType)) {
                    this.quoteFacade.fetchPlans(planType);
                }
            }
        });
        this.subscriptions.add(this.plansService.getPlanCounts$().subscribe({
            next: planCounts => {
                this.planCounts = planCounts;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.plansByType$.subscribe({
            next: plans => {
                const quoteId = this.store.selectSnapshot(QuoteBeneficiaryState.getQuoteId);
                const agentId = this.store.selectSnapshot(QuoteBeneficiaryState.getAgentGuid);
                this.quoteService.getInfoForQuote(quoteId, agentId).then(quoteInfo => {
                    const quotedPlanIds = quoteInfo.planIds;
                    this.memberSessionService.quotePlans(plans, quotedPlanIds, this.rehydratePlanDetailInfo);
                    if (this.rehydratePlanDetailInfo && plans.length) {
                        this.rehydratePlanDetailInfo = false;
                    }
                });
            }
        }));
        this.quoteVideoURL = this.quoteFacade.getQuoteVideoURL();
        this.quoteFacade.setCompareGroup();
        this.quoteFacade.setSortGroup();
        this.quoteFacade.checkActiveTabTypeExists();
        this.memberData$ = this.memberSessionService.getMemberSession$();
        this.medicineCabinet$ = this.guidedHelpService.getMedicineCabinet$();
        this.subsidyPercentage = this.planFacade.getSubsidyPercentage();
        this.selectedCounty$ = this.quoteFacade.getCounty$();
        this.memberQuoteMessage$ = this.getMemberQuoteMessage$();
        this.isMobile$ = this.responsiveLayoutService.isCompact$;
        this.selectedPharmacy$ = this.guidedHelpService.getSelectedPharmacy$();
        this.primaryPharmacy$ = this.guidedHelpService.getPrimaryPharmacy$();
        this.selectedPharmacies$ = this.guidedHelpService.getSelectedPharmacies$();
        this.filteredPlans$ = this.quoteFacade.getQuotedPlans$();
        this.providers$ = this.retentionFacade.getProviders$();
        this.riderDisplayMap = {
            [PlanTypeAbbreviation.MA]: this.Spa_PlanCard_ShowRidersOnMACards,
            [PlanTypeAbbreviation.MAPD]: this.Spa_PlanCard_ShowRidersOnMAPDCards,
            [PlanTypeAbbreviation.PDP]: this.Spa_PlanCard_ShowRidersOnPDPCards,
            [PlanTypeAbbreviation.MEDIGAP]: this.Spa_PlanCard_ShowRidersOnMEDIGAPCards
        };
        this.providerDetails$ = this.filteredPlans$.pipe(mergeMap(plans => {
            if (plans?.length && this.Spa_Site_Providers_Enabled) {
                return this.retentionFacade.fetchProvidersDetails$(plans, this.Spa_Site_Provider_ShowAllInNetworkLocations_Enabled);
            }
            return of({});
        }));
        this.subscriptions.add(this.loading$.subscribe({
            next: loading => {
                loading
                    ? this.configurableWidgetService.spinnerService.show(SpinnerEvent.PLANS_LOADING)
                    : this.configurableWidgetService.spinnerService.hide(SpinnerEvent.PLANS_LOADING);
            }
        }));
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe({
            next: () => {
                // This prevents an additional fetch plan call when locale is subscribed
                // Plans are already fetched above when plans are dirty or from SessionService.updateCart() when navigating from authorization page
                if (!this.componentInitializing) {
                    this.quoteFacade.fetchPlans();
                    this.filteredPlans$ = this.quoteFacade.getQuotedPlans$();
                }
                this.editLinkText = this.getEditLinkText();
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.medicineCabinet$.subscribe({
            next: medicines => {
                this.medicineCabinet = medicines;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.memberData$.subscribe({
            next: memberData => {
                this.memberData = memberData;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.filteredPlans$.subscribe({
            next: filteredPlans => {
                this.filteredPlans = filteredPlans;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.isQuotingSite$.subscribe({
            next: isQuotingSite => {
                this.isQuotingSite = isQuotingSite;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.selectedPharmacy$.subscribe({
            next: selectedPharmacy => {
                this.selectedPharmacy = selectedPharmacy;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.providers$.subscribe({
            next: providers => {
                this.providers = providers;
                this.cdr.markForCheck();
            }
        }));
        this.componentInitializing = false;
    }
    preProcessProperties() {
        // We are whitelisting all globalresources and platformprops here to preserve the exact
        // functionality. Since this is clearly looking to update every time anything changes.
        // TODO: possibly move the resources used here in to the component so we can narrow down
        // our whitelist in scope
        this.tabs = this.retentionFacade.getTabDetails();
        this.selectedHealthStatus = this.planFacade.healthStatusLabel;
        this.ageGroup = this.quoteFacade.getAgeGroups();
        this.subsidySelected = this.planFacade.getSubsidySelected();
    }
    getMemberQuoteMessage$() {
        return this.memberSessionService.getMemberQuoteHistory$().pipe(map((memberQuoteHistory) => {
            const quoteHistory = memberQuoteHistory.filter(quote => quote.quoteId === this.quoteFacade.getBeneficiaryQuoteId());
            if (quoteHistory?.length) {
                return quoteHistory[0].message;
            }
            return '';
        }));
    }
    get backgroundImageURL() {
        return `url( ${this.imageService.resolveFullImagePath(this.Spa_Site_QuoteWelcome_Background_Url)} )`;
    }
    get mobileBackgroundImageURL() {
        return `url( ${this.imageService.resolveFullImagePath(this.Spa_Site_QuoteWelcome_Background_MobileUrl)} )`;
    }
    editZipCode() {
        const options = {
            ariaLabelledBy: 'modalHeaderTitle',
            centered: true,
            injector: this.injector
        };
        const zipCodeModalComponent = this.modalService.open(ZipCodeModalComponent, options);
        zipCodeModalComponent.componentInstance.redirectToSummary = true;
        zipCodeModalComponent.componentInstance.isProfileZip = false;
        zipCodeModalComponent.result
            .then(() => {
            this.selectedCounty$ = this.quoteFacade.getCounty$();
            this.quoteFacade.fetchPlans();
        })
            .catch(() => {
            // eat the error to prevent a console error
        });
        this.cdr.markForCheck();
    }
    getTagsToUpdate() {
        const memberData = this.memberSessionService.getMemberSession();
        const selectedPharmacies = this.pharmacyFacade.getSelectedNABPPharmacies();
        const personalizedVideoIsPresent = this.isPersonalizedVideoEnabled() ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO;
        return {
            [DataLayerGlobalVariable.MEMBER_ID]: memberData.memberID,
            [DataLayerGlobalVariable.SELECTED_PHARMACY]: selectedPharmacies,
            [DataLayerGlobalVariable.PERSONALIZED_VIDEO_IS_PRESENT]: personalizedVideoIsPresent
        };
    }
    handleCallToAction(event) {
        const eventData = event?.data ? JSON.parse(event.data) : {};
        if (eventData.event === SmartVXEventType.GUIDED_HELP) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PERSONALIZED_VIDEO_PLANS_ADD_PREFERENCES);
        }
        else if (eventData.event === SmartVXEventType.VIEW_DETAILS && eventData.id) {
            const plan = this.plansService.getPlan(eventData.id);
            this.planFacade.tagsToUpdate(DataLayerEvent.CLICK_PERSONALIZED_VIDEO_PLANS_VIEW_DETAILS, plan.id, plan.planTypeAbbreviation, plan.carrierName);
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
    isPersonalizedVideoEnabled() {
        return this.Spa_PersonalizedVideo_Enabled && this.Spa_PersonalizedVideo_Quote_Enabled && !!this.quoteFacade.getQuoteVideoURL();
    }
    getEditLinkText() {
        return this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_PlanCard_EditLink_Text', null, 'Edit preferences');
    }
};
QuoteSummaryComponent.ɵfac = function QuoteSummaryComponent_Factory(t) { return new (t || QuoteSummaryComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.ImageService), i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(QuoteFacade), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(RetentionFacade), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(i1.QuoteService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(PharmacyFacade), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.ConfigResourceService)); };
QuoteSummaryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: QuoteSummaryComponent, selectors: [["vnext-quote-summary"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 11, vars: 72, consts: [["vnextGoogleTagManager", "", 3, "greetingText", "memberData", "memberQuoteMessage", "fullImagePath", "fullImageMobilePath", "tagsToUpdate", "saveDefaultValues", "displayQuoteVideo", "quoteVideoURL", "quoteVideoFrameTitle", "handleCallToAction"], [3, "personalDetailsHeaderText", "userNameLabel", "userZipcodeLabel", "userEmailLabel", "memberData", "userZipcodeEditLabel", "selectedCounty", "userZipcodeEditDescripion", "countyLabel", "showCountyLabel", "editZipCodeClicked"], [3, "addPreferencesText", "healthText", "qualifiedHelpText", "prescriptionsText", "pharmacyText", "guidedHelpHideLinkText", "guidedHelpViewAllLinkText", "guidedHelpEnabled", "getStartedEnabled", "healthEnabled", "showSubsidyAccordion", "prescriptionsEnabled", "pharmacyEnabled", "selectedPharmacy", "medicineCabinet", "preferencesEditText", "addLinkText", "selectedHealthStatus", "subsidySelected", "subsidyPercentage", "preferencesEditDescription", "selectedPharmacies", "multiPharmacyEnabled", "primaryPharmacy", "primaryPharmacyIndicatorText", "providersEnabled", "providers", "providersText", "pcpText", "defaultAge", "otherPreferencesEnabled", "otherPreferencesText", "guidedHelpOtherPreferencesMessageText"], [3, "plans", "PlanStep", "pickPlanText", "planCardQuoteLinkText", "planDetailsButtonText", "planBenefitNoValueLabel", "planTypeText", "addOnCoverageText", "addOnCoverageTooltip", "planDetailsNonCoveredText", "prescriptionText", "pharmacyText", "isTotalEstimatedCostEnabled", "totalEstimatedAnnualCostText", "totalEstimatedCostText", "totalEstimatedCostTooltip", "showPlanLogo", "showRidersOnPlanCards", "showPremiumAsAnnual", "riderDisplayMap", "shoppingCartEnabled", "drugCoveredText", "hidePlanCardLabel", "pharmacyCoveredText", "displayDrugsCovered", "benefits", "benefitPreferences", "currentPlanText", "isMobile", "nextYearPlanText", "isQuoting", "Spa_Site_ShowRiderIcons", "Spa_Site_Dental_Rider_Display_Text", "Spa_Site_Vision_Rider_Display_Text", "Spa_Site_Hearing_Rider_Display_Text", "Spa_PlanCard_DentalAddOnCoverage_Text", "Spa_PlanCard_HearingAddOnCoverage_Text", "Spa_PlanCard_VisionAddOnCoverage_Text", "Spa_PlanCard_AddOnCoverage_Text", "Spa_Site_MedigapPlanType_Enabled", "Spa_Site_AddToCompare_Enabled", "Spa_Site_PlanViewDetails_Enabled", "Spa_Site_Tooltip_Text", "selectedPharmacy", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "isMailOrderSelected", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "mailOrderText", "providersInNetworkText", "pcpInNetworkText", "pcpOutOfNetworkText", "providersNoDataText", "isProviderEnabled", "selectedProviders", "providerDetails", "viewDetailsDescriptionText", "medicineCabinet", "planCardPreferenceDetailedEnabled", "planLogoSize", "loaderIconEnabled", "editLinkText", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "showPlanId", "showPlanYear", "planIdText", "availableText", "unavailableText", "viewProvidersButtonText", "viewPrescriptionsButtonText", "supplementalBenefitsHighlightText", "preferencesText", "viewMoreDetailsText", "hideDetailsText", "newPlanCardDesignEnabled", "viewAllPlanDetailsText", "shareThisPlanText", "viewCostDetailsText", "closeText", "planBenefitHighlightItems", "planBenefitHighlightsHeaderText", "showRiderDetails", "showRiderDetailsText", "hideRiderDetailsText", "riderIsIncludedText", "waiverStateRiderTooltips", "costMA", "costMAPD", "costPDP", "costMEDIGAP", "costDENTAL", "costVISION", "quoteClicked", "viewPlanDetails", 4, "ngIf"], ["class", "container", 4, "ngIf"], [3, "filteredPlans", "shopAllPlansButtonText", "compareThesePlansButtonText", "comparePlansSelected", "shopForPlansSelected", 4, "ngIf"], [3, "planTiles", "shopsAllCoverageText", "planCounts", "pickPlanLabel", "filteredPlans", "notAvailableText", "isQuotingSite", "planTabEducationalTextShow"], [3, "plans", "PlanStep", "pickPlanText", "planCardQuoteLinkText", "planDetailsButtonText", "planBenefitNoValueLabel", "planTypeText", "addOnCoverageText", "addOnCoverageTooltip", "planDetailsNonCoveredText", "prescriptionText", "pharmacyText", "isTotalEstimatedCostEnabled", "totalEstimatedAnnualCostText", "totalEstimatedCostText", "totalEstimatedCostTooltip", "showPlanLogo", "showRidersOnPlanCards", "showPremiumAsAnnual", "riderDisplayMap", "shoppingCartEnabled", "drugCoveredText", "hidePlanCardLabel", "pharmacyCoveredText", "displayDrugsCovered", "benefits", "benefitPreferences", "currentPlanText", "isMobile", "nextYearPlanText", "isQuoting", "Spa_Site_ShowRiderIcons", "Spa_Site_Dental_Rider_Display_Text", "Spa_Site_Vision_Rider_Display_Text", "Spa_Site_Hearing_Rider_Display_Text", "Spa_PlanCard_DentalAddOnCoverage_Text", "Spa_PlanCard_HearingAddOnCoverage_Text", "Spa_PlanCard_VisionAddOnCoverage_Text", "Spa_PlanCard_AddOnCoverage_Text", "Spa_Site_MedigapPlanType_Enabled", "Spa_Site_AddToCompare_Enabled", "Spa_Site_PlanViewDetails_Enabled", "Spa_Site_Tooltip_Text", "selectedPharmacy", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "isMailOrderSelected", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "mailOrderText", "providersInNetworkText", "pcpInNetworkText", "pcpOutOfNetworkText", "providersNoDataText", "isProviderEnabled", "selectedProviders", "providerDetails", "viewDetailsDescriptionText", "medicineCabinet", "planCardPreferenceDetailedEnabled", "planLogoSize", "loaderIconEnabled", "editLinkText", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "showPlanId", "showPlanYear", "planIdText", "availableText", "unavailableText", "viewProvidersButtonText", "viewPrescriptionsButtonText", "supplementalBenefitsHighlightText", "preferencesText", "viewMoreDetailsText", "hideDetailsText", "newPlanCardDesignEnabled", "viewAllPlanDetailsText", "shareThisPlanText", "viewCostDetailsText", "closeText", "planBenefitHighlightItems", "planBenefitHighlightsHeaderText", "showRiderDetails", "showRiderDetailsText", "hideRiderDetailsText", "riderIsIncludedText", "waiverStateRiderTooltips", "costMA", "costMAPD", "costPDP", "costMEDIGAP", "costDENTAL", "costVISION", "quoteClicked", "viewPlanDetails"], [1, "container"], ["class", "Spa_Style_Note", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["navigationAdapter", "", 1, "Spa_Style_Note", 3, "innerHtml"], [3, "filteredPlans", "shopAllPlansButtonText", "compareThesePlansButtonText", "comparePlansSelected", "shopForPlansSelected"]], template: function QuoteSummaryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-quote-welcome", 0);
        i0.ɵɵlistener("handleCallToAction", function QuoteSummaryComponent_Template_vnext_widget_quote_welcome_handleCallToAction_0_listener($event) { return ctx.handleCallToAction($event); });
        i0.ɵɵpipe(1, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "vnext-widget-quote-user-info", 1);
        i0.ɵɵlistener("editZipCodeClicked", function QuoteSummaryComponent_Template_vnext_widget_quote_user_info_editZipCodeClicked_2_listener() { return ctx.editZipCode(); });
        i0.ɵɵpipe(3, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(4, "vnext-summary-preferences", 2);
        i0.ɵɵpipe(5, "async");
        i0.ɵɵpipe(6, "async");
        i0.ɵɵtemplate(7, QuoteSummaryComponent_vnext_widget_quote_plan_card_7_Template, 4, 106, "vnext-widget-quote-plan-card", 3);
        i0.ɵɵtemplate(8, QuoteSummaryComponent_div_8_Template, 2, 1, "div", 4);
        i0.ɵɵtemplate(9, QuoteSummaryComponent_vnext_summary_buttons_9_Template, 1, 3, "vnext-summary-buttons", 5);
        i0.ɵɵelement(10, "vnext-summary-coverage-types", 6);
    } if (rf & 2) {
        i0.ɵɵproperty("greetingText", ctx.Spa_Site_QuoteWelcome_Greeting_Text)("memberData", ctx.memberData)("memberQuoteMessage", i0.ɵɵpipeBind1(1, 64, ctx.memberQuoteMessage$))("fullImagePath", ctx.backgroundImageURL)("fullImageMobilePath", ctx.mobileBackgroundImageURL)("tagsToUpdate", ctx.getTagsToUpdate())("saveDefaultValues", true)("displayQuoteVideo", ctx.Spa_PersonalizedVideo_Enabled && ctx.Spa_PersonalizedVideo_Quote_Enabled)("quoteVideoURL", ctx.quoteVideoURL)("quoteVideoFrameTitle", ctx.Spa_PersonalizedVideo_QuoteSummary_FrameTitle);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("personalDetailsHeaderText", ctx.Spa_QuoteUserInfo_PersonalDetailsHeader_Text)("userNameLabel", ctx.Spa_Site_QuoteUserInfo_Name_Label)("userZipcodeLabel", ctx.Spa_Site_QuoteUserInfo_ZipCode_Label)("userEmailLabel", ctx.Spa_Site_QuoteUserInfo_Email_Label)("memberData", ctx.memberData)("userZipcodeEditLabel", ctx.Spa_Site_QuoteUserInfo_Zipcode_Edit_Label)("selectedCounty", i0.ɵɵpipeBind1(3, 66, ctx.selectedCounty$))("userZipcodeEditDescripion", ctx.Spa_Site_UserInfo_Zipcode_Edit_Description)("countyLabel", ctx.Spa_ZipCodeInput_CountyLabel_Text)("showCountyLabel", ctx.Spa_ZipCodeInput_CountyLabel_Enabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("addPreferencesText", ctx.Spa_Summary_AddPreferences_Text)("healthText", ctx.Spa_Site_Health_Text)("qualifiedHelpText", ctx.Spa_Site_QualifiedHelp_Text)("prescriptionsText", ctx.Spa_Site_Prescriptions_Text)("pharmacyText", ctx.Spa_Site_Pharmacy_Text)("guidedHelpHideLinkText", ctx.Spa_Site_Hide_Text)("guidedHelpViewAllLinkText", ctx.Spa_Site_ViewAll_Text)("guidedHelpEnabled", ctx.Spa_GuidedHelp_Enabled)("getStartedEnabled", ctx.Spa_Site_GetStarted_Enabled)("healthEnabled", ctx.Spa_Site_Health_Enabled)("showSubsidyAccordion", ctx.Spa_GettingStarted_ShowSubsidyAccordion_Flag)("prescriptionsEnabled", ctx.Spa_Site_Prescriptions_Enabled)("pharmacyEnabled", ctx.Spa_Site_Pharmacy_Enabled)("selectedPharmacy", ctx.selectedPharmacy)("medicineCabinet", ctx.medicineCabinet)("preferencesEditText", ctx.Spa_Site_Preferences_Edit_Text)("addLinkText", ctx.Spa_GuidedHelp_PlanList_AddLink_Text)("selectedHealthStatus", ctx.selectedHealthStatus)("subsidySelected", ctx.subsidySelected)("subsidyPercentage", ctx.subsidyPercentage)("preferencesEditDescription", ctx.Spa_Site_Preferences_Edit_Description)("selectedPharmacies", i0.ɵɵpipeBind1(5, 68, ctx.selectedPharmacies$))("multiPharmacyEnabled", ctx.Spa_Site_Multi_Pharmacy_Enabled)("primaryPharmacy", i0.ɵɵpipeBind1(6, 70, ctx.primaryPharmacy$))("primaryPharmacyIndicatorText", ctx.Spa_Site_PrimaryPharmacy_Indicator_Text)("providersEnabled", ctx.Spa_Site_Providers_Enabled)("providers", ctx.providers)("providersText", ctx.Spa_Site_Providers_Text)("pcpText", ctx.Spa_Site_Pcp_Text)("defaultAge", ctx.Spa_GuidedHelp_Health_AgeDefault_Number)("otherPreferencesEnabled", ctx.Spa_Site_OtherPreferences_Enabled)("otherPreferencesText", ctx.Spa_Site_OtherPreferences_Text)("guidedHelpOtherPreferencesMessageText", ctx.Spa_GuidedHelp_ReviewOtherPreferences_Text);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.filteredPlans == null ? null : ctx.filteredPlans.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Site_Providers_Enabled && (ctx.filteredPlans == null ? null : ctx.filteredPlans.length));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.filteredPlans == null ? null : ctx.filteredPlans.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("planTiles", ctx.tabs)("shopsAllCoverageText", ctx.Spa_Site_ShopAllCoverage_Text)("planCounts", ctx.planCounts)("pickPlanLabel", ctx.Spa_QuoteSummary_PickPlan_Text)("filteredPlans", ctx.filteredPlans)("notAvailableText", ctx.Spa_Quote_NotAvailable_Text)("isQuotingSite", ctx.isQuotingSite)("planTabEducationalTextShow", ctx.Spa_Plan_Tab_Educational_Text_Show);
    } }, dependencies: [i1$2.NgIf, NavigationAdapterDirective, LiveEditPropDirective, GoogleTagManagerDirective, SummaryCoverageTypesComponent, QuoteUserInfoComponent, QuoteWelcomeComponent, SummaryPreferencesComponent, QuotePlanCardComponent, SummaryButtonsComponent, i1$2.AsyncPipe, SafePipe], changeDetection: 0 });
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_QuoteWelcome_Background_Url", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_QuoteWelcome_Background_MobileUrl", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Health_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_QualifiedHelp_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Prescriptions_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Pharmacy_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Hide_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_ViewAll_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Preferences_Edit_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_GuidedHelp_PlanList_AddLink_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_GuidedHelp_Enabled", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_GetStarted_Enabled", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Health_Enabled", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_GettingStarted_ShowSubsidyAccordion_Flag", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Prescriptions_Enabled", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Pharmacy_Enabled", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_QuoteUserInfo_Name_Label", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_QuoteUserInfo_ZipCode_Label", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_QuoteUserInfo_Email_Label", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_QuoteUserInfo_Zipcode_Edit_Label", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanCard_QuoteLinkName_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanCard_PlanDetails_ButtonText", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanCard_PlanType_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanCard_AddOnCoverageInCart_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanCard_AddOnCoverageTooltip_Body", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanDetails_Non_Covered_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_TotalEstimatedCost_Enabled", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanCard_TotalEstimatedAnnualCost_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanCard_TotalEstimatedCost_Text", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PersonalizedVideo_QuoteSummary_FrameTitle", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanCard_Total_Estimated_Cost_Tooltip", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanCard_Drug_Covered_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanCard_Pharmacy_Covered_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Current_Plan_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Show_PlanLogo", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_ShowRidersOnPlanCards", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_ShowPremiumAsAnnual", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_ShowRiderIcons", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Dental_Rider_Display_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Vision_Rider_Display_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Hearing_Rider_Display_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanCard_DentalAddOnCoverage_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanCard_HearingAddOnCoverage_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanCard_VisionAddOnCoverage_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanCard_AddOnCoverage_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanCard_ShowRidersOnMACards", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanCard_ShowRidersOnPDPCards", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanCard_ShowRidersOnMAPDCards", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanCard_ShowRidersOnMEDIGAPCards", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_ShoppingCart_Enabled", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Next_Year_Plan_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_PlanNotAvailableForNextYear_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Keep_This_Plan_Button_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Shop_All_Plans_Button_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Quote_CompareThesePlans_Button_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Quote_NotAvailable_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_NotApplicable_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_EnableQuoteSummary", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Preferences_Edit_Description", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_UserInfo_Zipcode_Edit_Description", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_MedigapPlanType_Enabled", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_AddToCompare_Enabled", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_PlanViewDetails_Enabled", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Providers_Enabled", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Providers_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Pcp_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanCard_Providers_InNetwork_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Pcp_InNetwork_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Pcp_OutOfNetwork_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Providers_No_Data_Exist_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Enabled", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PersonalizedVideo_Enabled", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PersonalizedVideo_Quote_Enabled", void 0);
__decorate([
    PlatformProp('live-edit', true)
], QuoteSummaryComponent.prototype, "Spa_QuoteUserInfo_PersonalDetailsHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], QuoteSummaryComponent.prototype, "Spa_Summary_AddPreferences_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], QuoteSummaryComponent.prototype, "Spa_QuoteSummary_PickPlan_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], QuoteSummaryComponent.prototype, "Spa_Site_ShopAllCoverage_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], QuoteSummaryComponent.prototype, "Spa_Site_QuoteWelcome_Greeting_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], QuoteSummaryComponent.prototype, "Spa_Site_Provider_Disclaimer", void 0);
__decorate([
    PlatformProp(null, true)
], QuoteSummaryComponent.prototype, "Spa_PlanList_DisplayDrugsCovered", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Plan_Tab_Educational_Text_Show", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Tooltip_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Multi_Pharmacy_Enabled", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_PrimaryPharmacy_Indicator_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanList_Pharmacy_InNetwork_Preferred_Pricing_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanList_Pharmacy_InNetwork_Standard_Pricing_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanList_Pharmacy_OutOfNetwork_Pricing_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanList_ViewCost_Header_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanList_ViewCost_Header_Content", void 0);
__decorate([
    PlatformProp(null, true)
], QuoteSummaryComponent.prototype, "Spa_PlanList_MailOrder_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_GuidedHelp_Health_AgeDefault_Number", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_OtherPreferences_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_OtherPreferences_Enabled", void 0);
__decorate([
    PlatformProp('live-edit', true)
], QuoteSummaryComponent.prototype, "Spa_GuidedHelp_ReviewOtherPreferences_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_ViewDetailsLink_Description_Text", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_PlanCard_Preferences_Detailed_Enabled", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_PlanLogo_Size", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Provider_ShowAllInNetworkLocations_Enabled", void 0);
__decorate([
    GlobalResource(true)
], QuoteSummaryComponent.prototype, "Spa_Site_Loader_Updated_Icon_Enabled", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PlanCard_Providers_OneOrMore_OutOfNetwork_Text", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_Providers_InNetwork_OnOtherLocations_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_Provider_ShowPartialIndicator_Enabled", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_Site_PlanFees_Enabled", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PlanFees_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PlanFees_IncludedInPremium_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PlanCard_Show_PlanId_Enabled", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PlanCard_PlanYearBadge_Enabled", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PlanCard_PlanId_Text", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_Site_Available_Text", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_Site_NotAvailable_Text", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PlanCard_Providers_ViewButton_Text", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PlanCard_Prescriptions_ViewButton_Text", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PlanCard_SupplementalBenefitsHighlight_Text", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_Plan_Details_Preferences_Text", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PlanCard_ViewMoreDetails_ButtonText", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PlanCard_HideDetails_ButtonText", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PlanCard_NewDesign_Enabled", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PlanCard_ViewAllPlanDetails_ButtonText", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PlanCard_ShareThisPlan_ButtonText", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PlanCard_ViewCostDetails_ButtonText", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_Site_Close", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PlanCard_PlanBenefitHighlight_Items", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PlanCard_PlanBenefitHighlights_Text", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_Site_RiderDetails_Show", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_Plan_Details_ViewRiderDetails_Text", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_Plan_Details_HideRiderDetails_Text", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_ShoppingCart_IncludedRider_Text", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_Plan_Details_WaiverStateRider_Tooltips", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_Plandetails_Costs_MAPD", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_Plandetails_Costs_MA", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_Plandetails_Costs_MEDIGAP", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_Plandetails_Costs_PDP", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PlanDetails_Costs_DENTAL", void 0);
__decorate([
    GlobalResource()
], QuoteSummaryComponent.prototype, "Spa_PlanDetails_Costs_VISION", void 0);
QuoteSummaryComponent = __decorate([
    PlatformWidget
], QuoteSummaryComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QuoteSummaryComponent, [{
        type: Component,
        args: [{ selector: 'vnext-quote-summary', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<vnext-widget-quote-welcome\r\n  vnextGoogleTagManager\r\n  [greetingText]=\"Spa_Site_QuoteWelcome_Greeting_Text\"\r\n  [memberData]=\"memberData\"\r\n  [memberQuoteMessage]=\"memberQuoteMessage$ | async\"\r\n  [fullImagePath]=\"backgroundImageURL\"\r\n  [fullImageMobilePath]=\"mobileBackgroundImageURL\"\r\n  [tagsToUpdate]=\"getTagsToUpdate()\"\r\n  [saveDefaultValues]=\"true\"\r\n  [displayQuoteVideo]=\"Spa_PersonalizedVideo_Enabled && Spa_PersonalizedVideo_Quote_Enabled\"\r\n  [quoteVideoURL]=\"quoteVideoURL\"\r\n  [quoteVideoFrameTitle]=\"Spa_PersonalizedVideo_QuoteSummary_FrameTitle\"\r\n  (handleCallToAction)=\"handleCallToAction($event)\"\r\n></vnext-widget-quote-welcome>\r\n\r\n<vnext-widget-quote-user-info\r\n  [personalDetailsHeaderText]=\"Spa_QuoteUserInfo_PersonalDetailsHeader_Text\"\r\n  [userNameLabel]=\"Spa_Site_QuoteUserInfo_Name_Label\"\r\n  [userZipcodeLabel]=\"Spa_Site_QuoteUserInfo_ZipCode_Label\"\r\n  [userEmailLabel]=\"Spa_Site_QuoteUserInfo_Email_Label\"\r\n  [memberData]=\"memberData\"\r\n  [userZipcodeEditLabel]=\"Spa_Site_QuoteUserInfo_Zipcode_Edit_Label\"\r\n  [selectedCounty]=\"selectedCounty$ | async\"\r\n  (editZipCodeClicked)=\"editZipCode()\"\r\n  [userZipcodeEditDescripion]=\"Spa_Site_UserInfo_Zipcode_Edit_Description\"\r\n  [countyLabel]=\"Spa_ZipCodeInput_CountyLabel_Text\"\r\n  [showCountyLabel]=\"Spa_ZipCodeInput_CountyLabel_Enabled\"\r\n>\r\n</vnext-widget-quote-user-info>\r\n\r\n<vnext-summary-preferences\r\n  [addPreferencesText]=\"Spa_Summary_AddPreferences_Text\"\r\n  [healthText]=\"Spa_Site_Health_Text\"\r\n  [qualifiedHelpText]=\"Spa_Site_QualifiedHelp_Text\"\r\n  [prescriptionsText]=\"Spa_Site_Prescriptions_Text\"\r\n  [pharmacyText]=\"Spa_Site_Pharmacy_Text\"\r\n  [guidedHelpHideLinkText]=\"Spa_Site_Hide_Text\"\r\n  [guidedHelpViewAllLinkText]=\"Spa_Site_ViewAll_Text\"\r\n  [guidedHelpEnabled]=\"Spa_GuidedHelp_Enabled\"\r\n  [getStartedEnabled]=\"Spa_Site_GetStarted_Enabled\"\r\n  [healthEnabled]=\"Spa_Site_Health_Enabled\"\r\n  [showSubsidyAccordion]=\"Spa_GettingStarted_ShowSubsidyAccordion_Flag\"\r\n  [prescriptionsEnabled]=\"Spa_Site_Prescriptions_Enabled\"\r\n  [pharmacyEnabled]=\"Spa_Site_Pharmacy_Enabled\"\r\n  [selectedPharmacy]=\"selectedPharmacy\"\r\n  [medicineCabinet]=\"medicineCabinet\"\r\n  [preferencesEditText]=\"Spa_Site_Preferences_Edit_Text\"\r\n  [addLinkText]=\"Spa_GuidedHelp_PlanList_AddLink_Text\"\r\n  [selectedHealthStatus]=\"selectedHealthStatus\"\r\n  [subsidySelected]=\"subsidySelected\"\r\n  [subsidyPercentage]=\"subsidyPercentage\"\r\n  [preferencesEditDescription]=\"Spa_Site_Preferences_Edit_Description\"\r\n  [selectedPharmacies]=\"selectedPharmacies$ | async\"\r\n  [multiPharmacyEnabled]=\"Spa_Site_Multi_Pharmacy_Enabled\"\r\n  [primaryPharmacy]=\"primaryPharmacy$ | async\"\r\n  [primaryPharmacyIndicatorText]=\"Spa_Site_PrimaryPharmacy_Indicator_Text\"\r\n  [providersEnabled]=\"Spa_Site_Providers_Enabled\"\r\n  [providers]=\"providers\"\r\n  [providersText]=\"Spa_Site_Providers_Text\"\r\n  [pcpText]=\"Spa_Site_Pcp_Text\"\r\n  [defaultAge]=\"Spa_GuidedHelp_Health_AgeDefault_Number\"\r\n  [otherPreferencesEnabled]=\"Spa_Site_OtherPreferences_Enabled\"\r\n  [otherPreferencesText]=\"Spa_Site_OtherPreferences_Text\"\r\n  [guidedHelpOtherPreferencesMessageText]=\"Spa_GuidedHelp_ReviewOtherPreferences_Text\"\r\n></vnext-summary-preferences>\r\n\r\n<vnext-widget-quote-plan-card\r\n  *ngIf=\"filteredPlans?.length\"\r\n  [plans]=\"filteredPlans\"\r\n  [PlanStep]=\"Spa_QuoteSummary_PickPlan_Text\"\r\n  [pickPlanText]=\"Spa_QuoteSummary_PickPlan_Text\"\r\n  [planCardQuoteLinkText]=\"Spa_PlanCard_QuoteLinkName_Text\"\r\n  [planDetailsButtonText]=\"Spa_PlanCard_PlanDetails_ButtonText\"\r\n  [planBenefitNoValueLabel]=\"Spa_Site_NotApplicable_Text\"\r\n  [planTypeText]=\"Spa_PlanCard_PlanType_Text\"\r\n  [addOnCoverageText]=\"Spa_PlanCard_AddOnCoverageInCart_Text\"\r\n  [addOnCoverageTooltip]=\"Spa_PlanCard_AddOnCoverageTooltip_Body\"\r\n  [planDetailsNonCoveredText]=\"Spa_PlanDetails_Non_Covered_Text\"\r\n  [prescriptionText]=\"Spa_Site_Prescriptions_Text\"\r\n  [pharmacyText]=\"Spa_Site_Pharmacy_Text\"\r\n  [isTotalEstimatedCostEnabled]=\"Spa_Site_TotalEstimatedCost_Enabled\"\r\n  [totalEstimatedAnnualCostText]=\"Spa_PlanCard_TotalEstimatedAnnualCost_Text\"\r\n  [totalEstimatedCostText]=\"Spa_PlanCard_TotalEstimatedCost_Text\"\r\n  [totalEstimatedCostTooltip]=\"Spa_PlanCard_Total_Estimated_Cost_Tooltip\"\r\n  [showPlanLogo]=\"Spa_Site_Show_PlanLogo\"\r\n  [showRidersOnPlanCards]=\"Spa_Site_ShowRidersOnPlanCards\"\r\n  [showPremiumAsAnnual]=\"Spa_Site_ShowPremiumAsAnnual\"\r\n  [riderDisplayMap]=\"riderDisplayMap\"\r\n  [shoppingCartEnabled]=\"Spa_ShoppingCart_Enabled\"\r\n  [drugCoveredText]=\"Spa_PlanCard_Drug_Covered_Text\"\r\n  [hidePlanCardLabel]=\"true\"\r\n  [pharmacyCoveredText]=\"Spa_PlanCard_Pharmacy_Covered_Text\"\r\n  [displayDrugsCovered]=\"Spa_PlanList_DisplayDrugsCovered\"\r\n  [benefits]=\"quoteFacade.getDefaultTab()?.benefits\"\r\n  [benefitPreferences]=\"quoteFacade.getDefaultTab()?.benefitPreferences\"\r\n  [currentPlanText]=\"Spa_Site_Current_Plan_Text\"\r\n  [isMobile]=\"isMobile$ | async\"\r\n  [nextYearPlanText]=\"Spa_Site_Next_Year_Plan_Text\"\r\n  [isQuoting]=\"isQuotingSite\"\r\n  (quoteClicked)=\"planFacade.updateMedSupFormOpen(true)\"\r\n  (viewPlanDetails)=\"quoteFacade.navigateToPlanDetailsPage($event)\"\r\n  [Spa_Site_ShowRiderIcons]=\"Spa_Site_ShowRiderIcons\"\r\n  [Spa_Site_Dental_Rider_Display_Text]=\"Spa_Site_Dental_Rider_Display_Text\"\r\n  [Spa_Site_Vision_Rider_Display_Text]=\"Spa_Site_Vision_Rider_Display_Text\"\r\n  [Spa_Site_Hearing_Rider_Display_Text]=\"Spa_Site_Hearing_Rider_Display_Text\"\r\n  [Spa_PlanCard_DentalAddOnCoverage_Text]=\"Spa_PlanCard_DentalAddOnCoverage_Text\"\r\n  [Spa_PlanCard_HearingAddOnCoverage_Text]=\"Spa_PlanCard_HearingAddOnCoverage_Text\"\r\n  [Spa_PlanCard_VisionAddOnCoverage_Text]=\"Spa_PlanCard_VisionAddOnCoverage_Text\"\r\n  [Spa_PlanCard_AddOnCoverage_Text]=\"Spa_PlanCard_AddOnCoverage_Text\"\r\n  [Spa_Site_MedigapPlanType_Enabled]=\"Spa_Site_MedigapPlanType_Enabled\"\r\n  [Spa_Site_AddToCompare_Enabled]=\"Spa_Site_AddToCompare_Enabled\"\r\n  [Spa_Site_PlanViewDetails_Enabled]=\"Spa_Site_PlanViewDetails_Enabled\"\r\n  [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n  [selectedPharmacy]=\"selectedPharmacy\"\r\n  [inNetworkPreferredText]=\"Spa_PlanList_Pharmacy_InNetwork_Preferred_Pricing_Text\"\r\n  [inNetworkStandardText]=\"Spa_PlanList_Pharmacy_InNetwork_Standard_Pricing_Text\"\r\n  [outOfNetworkText]=\"Spa_PlanList_Pharmacy_OutOfNetwork_Pricing_Text\"\r\n  [isMailOrderSelected]=\"pharmacyFacade.mailOrder$ | async\"\r\n  [viewCostTooltipHeaderText]=\"Spa_PlanList_ViewCost_Header_Text\"\r\n  [viewCostTooltipHeaderContent]=\"Spa_PlanList_ViewCost_Header_Content\"\r\n  [mailOrderText]=\"Spa_PlanList_MailOrder_Text\"\r\n  [providersInNetworkText]=\"Spa_PlanCard_Providers_InNetwork_Text\"\r\n  [pcpInNetworkText]=\"Spa_Site_Pcp_InNetwork_Text\"\r\n  [pcpOutOfNetworkText]=\"Spa_Site_Pcp_OutOfNetwork_Text\"\r\n  [providersNoDataText]=\"Spa_Providers_No_Data_Exist_Text\"\r\n  [isProviderEnabled]=\"Spa_Site_Providers_Enabled\"\r\n  [selectedProviders]=\"providers\"\r\n  [providerDetails]=\"providerDetails$ | async\"\r\n  [viewDetailsDescriptionText]=\"Spa_Site_ViewDetailsLink_Description_Text\"\r\n  [medicineCabinet]=\"medicineCabinet\"\r\n  [planCardPreferenceDetailedEnabled]=\"Spa_PlanCard_Preferences_Detailed_Enabled\"\r\n  [planLogoSize]=\"Spa_Site_PlanLogo_Size\"\r\n  [loaderIconEnabled]=\"Spa_Site_Loader_Updated_Icon_Enabled\"\r\n  [editLinkText]=\"editLinkText\"\r\n  [providerOneOrMoreOutOfNetworkText]=\"Spa_PlanCard_Providers_OneOrMore_OutOfNetwork_Text\"\r\n  [providerInNetworkOnOtherLocationsTooltipText]=\"Spa_Providers_InNetwork_OnOtherLocations_Tooltip_Text\"\r\n  [providerShowPartialIndicatorEnabled]=\"Spa_Provider_ShowPartialIndicator_Enabled\"\r\n  [planFeesEnabled]=\"Spa_Site_PlanFees_Enabled\"\r\n  [planFeesTooltipText]=\"Spa_PlanFees_Tooltip_Text\"\r\n  [planFeesIncludedInPremiumTooltipText]=\"Spa_PlanFees_IncludedInPremium_Tooltip_Text\"\r\n  [planFeesNotIncludedInPremiumTooltipText]=\"Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text\"\r\n  [showPlanId]=\"Spa_PlanCard_Show_PlanId_Enabled\"\r\n  [showPlanYear]=\"Spa_PlanCard_PlanYearBadge_Enabled\"\r\n  [planIdText]=\"Spa_PlanCard_PlanId_Text\"\r\n  [availableText]=\"Spa_Site_Available_Text\"\r\n  [unavailableText]=\"Spa_Site_NotAvailable_Text\"\r\n  [viewProvidersButtonText]=\"Spa_PlanCard_Providers_ViewButton_Text\"\r\n  [viewPrescriptionsButtonText]=\"Spa_PlanCard_Prescriptions_ViewButton_Text\"\r\n  [supplementalBenefitsHighlightText]=\"Spa_PlanCard_SupplementalBenefitsHighlight_Text\"\r\n  [preferencesText]=\"Spa_Plan_Details_Preferences_Text\"\r\n  [viewMoreDetailsText]=\"Spa_PlanCard_ViewMoreDetails_ButtonText\"\r\n  [hideDetailsText]=\"Spa_PlanCard_HideDetails_ButtonText\"\r\n  [newPlanCardDesignEnabled]=\"Spa_PlanCard_NewDesign_Enabled\"\r\n  [viewAllPlanDetailsText]=\"Spa_PlanCard_ViewAllPlanDetails_ButtonText\"\r\n  [shareThisPlanText]=\"Spa_PlanCard_ShareThisPlan_ButtonText\"\r\n  [viewCostDetailsText]=\"Spa_PlanCard_ViewCostDetails_ButtonText\"\r\n  [closeText]=\"Spa_Site_Close\"\r\n  [planBenefitHighlightItems]=\"Spa_PlanCard_PlanBenefitHighlight_Items\"\r\n  [planBenefitHighlightsHeaderText]=\"Spa_PlanCard_PlanBenefitHighlights_Text\"\r\n  [showRiderDetails]=\"Spa_Site_RiderDetails_Show\"\r\n  [showRiderDetailsText]=\"Spa_Plan_Details_ViewRiderDetails_Text\"\r\n  [hideRiderDetailsText]=\"Spa_Plan_Details_HideRiderDetails_Text\"\r\n  [riderIsIncludedText]=\"Spa_ShoppingCart_IncludedRider_Text\"\r\n  [waiverStateRiderTooltips]=\"Spa_Plan_Details_WaiverStateRider_Tooltips\"\r\n  [costMA]=\"Spa_Plandetails_Costs_MA\"\r\n  [costMAPD]=\"Spa_Plandetails_Costs_MAPD\"\r\n  [costPDP]=\"Spa_Plandetails_Costs_PDP\"\r\n  [costMEDIGAP]=\"Spa_Plandetails_Costs_MEDIGAP\"\r\n  [costDENTAL]=\"Spa_PlanDetails_Costs_DENTAL\"\r\n  [costVISION]=\"Spa_PlanDetails_Costs_VISION\"\r\n>\r\n</vnext-widget-quote-plan-card>\r\n<div class=\"container\" *ngIf=\"Spa_Site_Providers_Enabled && filteredPlans?.length\">\r\n  <p\r\n    class=\"Spa_Style_Note\"\r\n    *liveEditProp=\"'Spa_Site_Provider_Disclaimer'\"\r\n    [innerHtml]=\"Spa_Site_Provider_Disclaimer | safe : 'html'\"\r\n    navigationAdapter\r\n  ></p>\r\n</div>\r\n<vnext-summary-buttons\r\n  *ngIf=\"filteredPlans?.length\"\r\n  [filteredPlans]=\"filteredPlans\"\r\n  [shopAllPlansButtonText]=\"Spa_Site_Shop_All_Plans_Button_Text\"\r\n  [compareThesePlansButtonText]=\"Spa_Quote_CompareThesePlans_Button_Text\"\r\n  (comparePlansSelected)=\"quoteFacade.updatePlansOnCompareGroupAndNavigate(filteredPlans)\"\r\n  (shopForPlansSelected)=\"quoteFacade.shopAllPlans()\"\r\n></vnext-summary-buttons>\r\n\r\n<vnext-summary-coverage-types\r\n  [planTiles]=\"tabs\"\r\n  [shopsAllCoverageText]=\"Spa_Site_ShopAllCoverage_Text\"\r\n  [planCounts]=\"planCounts\"\r\n  [pickPlanLabel]=\"Spa_QuoteSummary_PickPlan_Text\"\r\n  [filteredPlans]=\"filteredPlans\"\r\n  [notAvailableText]=\"Spa_Quote_NotAvailable_Text\"\r\n  [isQuotingSite]=\"isQuotingSite\"\r\n  [planTabEducationalTextShow]=\"Spa_Plan_Tab_Educational_Text_Show\"\r\n>\r\n</vnext-summary-coverage-types>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.MemberSessionService }, { type: i1.ImageService }, { type: i1.GuidedHelpService }, { type: QuoteFacade }, { type: PlanFacade }, { type: i0.Injector }, { type: i1$1.NgbModal }, { type: RetentionFacade }, { type: i1.ResponsiveLayoutService }, { type: i1.PlansService }, { type: i1.SiteService }, { type: i1.QuoteService }, { type: i1.LocaleService }, { type: PharmacyFacade }, { type: i2.Store }, { type: i2$1.ActivatedRoute }, { type: AnalyticsService }, { type: i1.ConfigResourceService }]; }, { Spa_Site_QuoteWelcome_Background_Url: [], Spa_Site_QuoteWelcome_Background_MobileUrl: [], Spa_Site_Health_Text: [], Spa_Site_QualifiedHelp_Text: [], Spa_Site_Prescriptions_Text: [], Spa_Site_Pharmacy_Text: [], Spa_Site_Hide_Text: [], Spa_Site_ViewAll_Text: [], Spa_Site_Preferences_Edit_Text: [], Spa_GuidedHelp_PlanList_AddLink_Text: [], Spa_GuidedHelp_Enabled: [], Spa_Site_GetStarted_Enabled: [], Spa_Site_Health_Enabled: [], Spa_GettingStarted_ShowSubsidyAccordion_Flag: [], Spa_Site_Prescriptions_Enabled: [], Spa_Site_Pharmacy_Enabled: [], Spa_Site_QuoteUserInfo_Name_Label: [], Spa_Site_QuoteUserInfo_ZipCode_Label: [], Spa_Site_QuoteUserInfo_Email_Label: [], Spa_Site_QuoteUserInfo_Zipcode_Edit_Label: [], Spa_PlanCard_QuoteLinkName_Text: [], Spa_PlanCard_PlanDetails_ButtonText: [], Spa_PlanCard_PlanType_Text: [], Spa_PlanCard_AddOnCoverageInCart_Text: [], Spa_PlanCard_AddOnCoverageTooltip_Body: [], Spa_PlanDetails_Non_Covered_Text: [], Spa_Site_TotalEstimatedCost_Enabled: [], Spa_PlanCard_TotalEstimatedAnnualCost_Text: [], Spa_PlanCard_TotalEstimatedCost_Text: [], Spa_PersonalizedVideo_QuoteSummary_FrameTitle: [], Spa_PlanCard_Total_Estimated_Cost_Tooltip: [], Spa_PlanCard_Drug_Covered_Text: [], Spa_PlanCard_Pharmacy_Covered_Text: [], Spa_Site_Current_Plan_Text: [], Spa_Site_Show_PlanLogo: [], Spa_Site_ShowRidersOnPlanCards: [], Spa_Site_ShowPremiumAsAnnual: [], Spa_Site_ShowRiderIcons: [], Spa_Site_Dental_Rider_Display_Text: [], Spa_Site_Vision_Rider_Display_Text: [], Spa_Site_Hearing_Rider_Display_Text: [], Spa_PlanCard_DentalAddOnCoverage_Text: [], Spa_PlanCard_HearingAddOnCoverage_Text: [], Spa_PlanCard_VisionAddOnCoverage_Text: [], Spa_PlanCard_AddOnCoverage_Text: [], Spa_PlanCard_ShowRidersOnMACards: [], Spa_PlanCard_ShowRidersOnPDPCards: [], Spa_PlanCard_ShowRidersOnMAPDCards: [], Spa_PlanCard_ShowRidersOnMEDIGAPCards: [], Spa_ShoppingCart_Enabled: [], Spa_Site_Next_Year_Plan_Text: [], Spa_Site_PlanNotAvailableForNextYear_Text: [], Spa_Site_Keep_This_Plan_Button_Text: [], Spa_Site_Shop_All_Plans_Button_Text: [], Spa_Quote_CompareThesePlans_Button_Text: [], Spa_Quote_NotAvailable_Text: [], Spa_Site_NotApplicable_Text: [], Spa_Site_EnableQuoteSummary: [], Spa_Site_Preferences_Edit_Description: [], Spa_Site_UserInfo_Zipcode_Edit_Description: [], Spa_Site_MedigapPlanType_Enabled: [], Spa_Site_AddToCompare_Enabled: [], Spa_Site_PlanViewDetails_Enabled: [], Spa_Site_Providers_Enabled: [], Spa_Site_Providers_Text: [], Spa_Site_Pcp_Text: [], Spa_PlanCard_Providers_InNetwork_Text: [], Spa_Site_Pcp_InNetwork_Text: [], Spa_Site_Pcp_OutOfNetwork_Text: [], Spa_Providers_No_Data_Exist_Text: [], Spa_ZipCodeInput_CountyLabel_Text: [], Spa_ZipCodeInput_CountyLabel_Enabled: [], Spa_PersonalizedVideo_Enabled: [], Spa_PersonalizedVideo_Quote_Enabled: [], Spa_QuoteUserInfo_PersonalDetailsHeader_Text: [], Spa_Summary_AddPreferences_Text: [], Spa_QuoteSummary_PickPlan_Text: [], Spa_Site_ShopAllCoverage_Text: [], Spa_Site_QuoteWelcome_Greeting_Text: [], Spa_Site_Provider_Disclaimer: [], Spa_PlanList_DisplayDrugsCovered: [], Spa_Plan_Tab_Educational_Text_Show: [], Spa_Site_Tooltip_Text: [], Spa_Site_Multi_Pharmacy_Enabled: [], Spa_Site_PrimaryPharmacy_Indicator_Text: [], Spa_PlanList_Pharmacy_InNetwork_Preferred_Pricing_Text: [], Spa_PlanList_Pharmacy_InNetwork_Standard_Pricing_Text: [], Spa_PlanList_Pharmacy_OutOfNetwork_Pricing_Text: [], Spa_PlanList_ViewCost_Header_Text: [], Spa_PlanList_ViewCost_Header_Content: [], Spa_PlanList_MailOrder_Text: [], Spa_GuidedHelp_Health_AgeDefault_Number: [], Spa_Site_OtherPreferences_Text: [], Spa_Site_OtherPreferences_Enabled: [], Spa_GuidedHelp_ReviewOtherPreferences_Text: [], Spa_Site_ViewDetailsLink_Description_Text: [], Spa_PlanCard_Preferences_Detailed_Enabled: [], Spa_Site_PlanLogo_Size: [], Spa_Site_Provider_ShowAllInNetworkLocations_Enabled: [], Spa_Site_Loader_Updated_Icon_Enabled: [], Spa_PlanCard_Providers_OneOrMore_OutOfNetwork_Text: [], Spa_Providers_InNetwork_OnOtherLocations_Tooltip_Text: [], Spa_Provider_ShowPartialIndicator_Enabled: [], Spa_Site_PlanFees_Enabled: [], Spa_PlanFees_Tooltip_Text: [], Spa_PlanFees_IncludedInPremium_Tooltip_Text: [], Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text: [], Spa_PlanCard_Show_PlanId_Enabled: [], Spa_PlanCard_PlanYearBadge_Enabled: [], Spa_PlanCard_PlanId_Text: [], Spa_Site_Available_Text: [], Spa_Site_NotAvailable_Text: [], Spa_PlanCard_Providers_ViewButton_Text: [], Spa_PlanCard_Prescriptions_ViewButton_Text: [], Spa_PlanCard_SupplementalBenefitsHighlight_Text: [], Spa_Plan_Details_Preferences_Text: [], Spa_PlanCard_ViewMoreDetails_ButtonText: [], Spa_PlanCard_HideDetails_ButtonText: [], Spa_PlanCard_NewDesign_Enabled: [], Spa_PlanCard_ViewAllPlanDetails_ButtonText: [], Spa_PlanCard_ShareThisPlan_ButtonText: [], Spa_PlanCard_ViewCostDetails_ButtonText: [], Spa_Site_Close: [], Spa_PlanCard_PlanBenefitHighlight_Items: [], Spa_PlanCard_PlanBenefitHighlights_Text: [], Spa_Site_RiderDetails_Show: [], Spa_Plan_Details_ViewRiderDetails_Text: [], Spa_Plan_Details_HideRiderDetails_Text: [], Spa_ShoppingCart_IncludedRider_Text: [], Spa_Plan_Details_WaiverStateRider_Tooltips: [], Spa_Plandetails_Costs_MAPD: [], Spa_Plandetails_Costs_MA: [], Spa_Plandetails_Costs_MEDIGAP: [], Spa_Plandetails_Costs_PDP: [], Spa_PlanDetails_Costs_DENTAL: [], Spa_PlanDetails_Costs_VISION: [] }); })();

function BlueButtonFollowUpModalComponent_vnext_link_6_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 9);
    i0.ɵɵlistener("click", function BlueButtonFollowUpModalComponent_vnext_link_6_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.viewMemberProfile()); })("keyup.Enter", function BlueButtonFollowUpModalComponent_vnext_link_6_Template_vnext_link_keyup_Enter_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.viewMemberProfile()); });
    i0.ɵɵelementStart(1, "span", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelement(3, "i", 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("alwaysUnderlined", false);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.modalViewMemberLink, "");
} }
function BlueButtonFollowUpModalComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "vnext-followup-task", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("taskType", ctx_r1.taskType)("followUpTaskText", ctx_r1.followUpTaskText);
} }
function BlueButtonFollowUpModalComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 14);
    i0.ɵɵlistener("click", function BlueButtonFollowUpModalComponent_ng_container_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.closeBlueButtonFollowUpModal()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.modalCloseText, " ");
} }
function BlueButtonFollowUpModalComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function BlueButtonFollowUpModalComponent_ng_template_10_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.closeBlueButtonFollowUpModal()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.modalCancelText, " ");
} }
class BlueButtonFollowUpModalComponent {
    constructor(activeModal, configResourceService) {
        this.activeModal = activeModal;
        this.configResourceService = configResourceService;
        this.taskType = NoteActionType.BlueButtonTask;
    }
    ngOnInit() {
        this.isAddFollowUpTaskEnabled = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_AddFollowUp_Enabled', null, false);
        if (this.isAddFollowUpTaskEnabled) {
            this.loadFollowUpTaskAttributes();
        }
    }
    closeBlueButtonFollowUpModal() {
        this.activeModal.dismiss();
        if (this.cancelAction) {
            this.cancelAction();
        }
    }
    viewMemberProfile() {
        this.activeModal.close();
    }
    loadFollowUpTaskAttributes(widgetName) {
        this.followUpTaskText = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_FollowUp_BlueButton_Text', widgetName, 'Follow up on MyMedicare.gov invitation');
        this.modalCloseText = this.configResourceService.getProcessedResourceValue('Spa_Site_Close', null, 'Close');
    }
}
BlueButtonFollowUpModalComponent.ɵfac = function BlueButtonFollowUpModalComponent_Factory(t) { return new (t || BlueButtonFollowUpModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i1.ConfigResourceService)); };
BlueButtonFollowUpModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BlueButtonFollowUpModalComponent, selectors: [["ng-component"]], decls: 12, vars: 7, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "px-3", "mt-3", "mb-0"], [1, "mb-1"], [3, "title", "type"], ["ngbAutofocus", "", "class", "d-inline-block mb-0", 3, "alwaysUnderlined", "click", "keyup.Enter", 4, "ngIf"], ["class", "mb-4", 4, "ngIf"], [1, "modal-footer", "justify-content-start"], [4, "ngIf", "ngIfElse"], ["showCancelButton", ""], ["ngbAutofocus", "", 1, "d-inline-block", "mb-0", 3, "alwaysUnderlined", "click", "keyup.Enter"], ["link-body", ""], [1, "fas", "fa-angle-right", "ml-1"], [1, "mb-4"], [3, "taskType", "followUpTaskText"], ["type", "button", 1, "btn", "mr-auto", "Spa_Style_SecondaryButton", 3, "click"]], template: function BlueButtonFollowUpModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div")(1, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function BlueButtonFollowUpModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_1_listener() { return ctx.closeBlueButtonFollowUpModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerStart(2);
        i0.ɵɵelementStart(3, "div", 1)(4, "div", 2);
        i0.ɵɵelement(5, "vnext-notice", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, BlueButtonFollowUpModalComponent_vnext_link_6_Template, 4, 2, "vnext-link", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerEnd();
        i0.ɵɵtemplate(7, BlueButtonFollowUpModalComponent_div_7_Template, 2, 2, "div", 5);
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵtemplate(9, BlueButtonFollowUpModalComponent_ng_container_9_Template, 3, 1, "ng-container", 7);
        i0.ɵɵtemplate(10, BlueButtonFollowUpModalComponent_ng_template_10_Template, 2, 1, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(11);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("modalTitleText", ctx.modalTitleText);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("title", ctx.modalSentConfirmationText)("type", "success");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showViewMemberLink);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isAddFollowUpTaskEnabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isAddFollowUpTaskEnabled)("ngIfElse", _r3);
    } }, dependencies: [i1$2.NgIf, LinkComponent, FollowUpTaskComponent, NoticeComponent, ModalHeaderComponent, IconAriaAttributesDirective], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BlueButtonFollowUpModalComponent, [{
        type: Component,
        args: [{ changeDetection: ChangeDetectionStrategy.OnPush, template: "<div>\r\n  <vnext-widget-modal-header\r\n    [modalTitleText]=\"modalTitleText\"\r\n    (modalTitleCancelAction)=\"closeBlueButtonFollowUpModal()\"\r\n  ></vnext-widget-modal-header>\r\n\r\n  <ng-container>\r\n    <div class=\"px-3 mt-3 mb-0\">\r\n      <div class=\"mb-1\">\r\n        <vnext-notice [title]=\"modalSentConfirmationText\" [type]=\"'success'\"></vnext-notice>\r\n      </div>\r\n      <vnext-link\r\n        *ngIf=\"showViewMemberLink\"\r\n        ngbAutofocus\r\n        (click)=\"viewMemberProfile()\"\r\n        (keyup.Enter)=\"viewMemberProfile()\"\r\n        class=\"d-inline-block mb-0\"\r\n        [alwaysUnderlined]=\"false\"\r\n        ><span link-body> {{ modalViewMemberLink }}<i class=\"fas fa-angle-right ml-1\"></i></span>\r\n      </vnext-link>\r\n    </div>\r\n  </ng-container>\r\n  <div *ngIf=\"isAddFollowUpTaskEnabled\" class=\"mb-4\">\r\n    <vnext-followup-task [taskType]=\"taskType\" [followUpTaskText]=\"followUpTaskText\"></vnext-followup-task>\r\n  </div>\r\n  <div class=\"modal-footer justify-content-start\">\r\n    <ng-container *ngIf=\"isAddFollowUpTaskEnabled; else showCancelButton\">\r\n      <button type=\"button\" class=\"btn mr-auto Spa_Style_SecondaryButton\" (click)=\"closeBlueButtonFollowUpModal()\">\r\n        {{ modalCloseText }}\r\n      </button>\r\n    </ng-container>\r\n    <ng-template #showCancelButton>\r\n      <button type=\"button\" class=\"btn mr-auto Spa_Style_SecondaryButton\" (click)=\"closeBlueButtonFollowUpModal()\">\r\n        {{ modalCancelText }}\r\n      </button>\r\n    </ng-template>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i1.ConfigResourceService }]; }, null); })();

class BlueButtonFacade {
    constructor(configResourceService, router, store, modalService, injector, sessionService, emailService, siteService, agentService, analyticsService, messagesService, phoneService, guidedHelpModalContextService) {
        this.configResourceService = configResourceService;
        this.router = router;
        this.store = store;
        this.modalService = modalService;
        this.injector = injector;
        this.sessionService = sessionService;
        this.emailService = emailService;
        this.siteService = siteService;
        this.agentService = agentService;
        this.analyticsService = analyticsService;
        this.messagesService = messagesService;
        this.phoneService = phoneService;
        this.guidedHelpModalContextService = guidedHelpModalContextService;
        this.isImportPrescriptionRefreshEvent = false;
        this._isAgentImportData$ = new BehaviorSubject(false);
        this.isAgentImportData$ = this._isAgentImportData$.asObservable();
    }
    isImportLatestPrescriptionClicked(isImportLatestPrescriptionClicked) {
        this.isImportPrescriptionRefreshEvent = true;
        this._isAgentImportData$.next(isImportLatestPrescriptionClicked);
    }
    getBlueButtonMedicareUrl(widgetName) {
        const medicareSiteUrl = this.configResourceService.getProcessedResourceValue('Spa_Site_BlueButton_Sandbox_Url', widgetName, 'https://sandbox.bluebutton.cms.gov/v1/o/authorize/');
        const clientId = this.configResourceService.getProcessedResourceValue('SPA_BlueButton_ClientID', widgetName, 'QhmUv7maXPYHmYLq8dI36I0NXEsi0wnusgAh0t17');
        const redirectUri = this.configResourceService.getProcessedResourceValue('Spa_Site_BlueButton_RedirectUri', widgetName, 'https://dev.destinationrx.com/hub/relay');
        const currentUrl = window.location.href.replace(this.router.url, '');
        const sharePrescriptionPage = this.store.selectSnapshot(AppConfigState.hrefByTag(PageTags.SHARE_PRESCRIPTIONS));
        let state = `${currentUrl}/${sharePrescriptionPage || PageTags.SHARE_PRESCRIPTIONS}`;
        if (this.isPPCSite()) {
            const memberSession = this.sessionService.getMemberSession();
            state += `?AgentGuid=${this.store.selectSnapshot(AgentState.agentGuid)}&MemberID=${memberSession.memberID}`;
        }
        let params = new HttpParams();
        params = params.append('client_id', clientId);
        params = params.append('response_type', 'code');
        params = params.append('state', state);
        params = params.append('redirect_uri', redirectUri);
        return `${medicareSiteUrl}?${params.toString()}`;
    }
    openBlueButtonModal(modalHeaderText, modalContent, widgetName, isPreferenceBannerEnabled) {
        const cancelButtonText = this.configResourceService.getProcessedResourceValue('Spa_Site_Cancel', widgetName, 'Cancel');
        const continueButtonText = this.configResourceService.getProcessedResourceValue('Spa_Site_Continue', widgetName, 'Continue');
        const blueButtonSiteUrl = this.getBlueButtonMedicareUrl(widgetName);
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_BLUEBUTTON_MODAL_OPEN);
        const blueButtonModal = this.modalService.open(HtmlConfirmationModalComponent, { centered: true, injector: this.injector });
        blueButtonModal.componentInstance.modalHeader = modalHeaderText;
        blueButtonModal.componentInstance.modalContent = modalContent;
        blueButtonModal.componentInstance.cancelButton = cancelButtonText;
        blueButtonModal.componentInstance.confirmButton = continueButtonText;
        blueButtonModal.componentInstance.confirmAction = () => {
            sessionStorage.setItem('isNavigating', 'true');
        };
        if (isPreferenceBannerEnabled) {
            blueButtonModal.componentInstance.cancelAction = () => {
                this.guidedHelpModalContextService.openGuidedHelpModal(PageTags.GUIDED_HELP_PRESCRIPTIONS);
            };
        }
        blueButtonModal.result
            .then(() => {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_BLUEBUTTON_MODAL_CONFIRM_LEAVE);
            window.location.href = blueButtonSiteUrl;
        })
            .catch(() => {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_BLUEBUTTON_MODAL_CANCEL);
        });
    }
    isPPCSite() {
        return this.siteService.isPPCSite(this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType', null, SiteType.CONSUMER));
    }
    async sendEmailToBeneficiary(emailAddress, widgetName) {
        const emailSubject = this.configResourceService.getProcessedResourceValue('Spa_BlueButton_ConnectToMymedicare_EmailSubject_Text', widgetName, 'Connect to MyMedicare.gov to share your prescriptions');
        const agentFooterData = await this.agentService.getAgentEmailFooterData();
        const agentEmailAddress = this.store.selectSnapshot(AgentState.emailAddress);
        const myMedicareUrl = this.getBlueButtonMedicareUrl();
        const myMedicareShortUrl = await this.messagesService.getShortUrl(myMedicareUrl);
        const agentFormatedPhonenumber = this.phoneService.formatPhoneNumberWithExtension(this.agentService.getAgentPhone(), this.agentService.getAgentExtension());
        const inputs = [
            { key: 'connectToMyMedicareUrl', value: myMedicareShortUrl },
            { key: 'agentName', value: this.store.selectSnapshot(AgentState.fullName) },
            { key: 'agentPhone', value: agentFormatedPhonenumber },
            { key: 'agentEmail', value: agentEmailAddress || '' },
            { key: 'agentPictureURL', value: agentFooterData.agentPictureURL },
            { key: 'agentNPN', value: this.agentService.getAgentNPN() },
            { key: 'californiaLicenseNumber', value: this.agentService.getCaliforniaLicenseNumber() }
        ];
        await this.emailService.sendEmail(EmailNames.CONNECT_TO_MYMEDICARE, [emailAddress], emailSubject, inputs);
    }
    async updateMemberEmailAndStatus(emailAddress) {
        const memberSession = this.sessionService.getMemberSession();
        const apiMemberStateModel = {
            agentGuid: this.store.selectSnapshot(AgentState.agentGuid),
            memberID: memberSession ? memberSession.memberID : '',
            profile: {
                emailAddress
            },
            blueButtonInfo: {
                status: BlueButtonStatus.NEW,
                updateDate: DateUtilities.getFormattedPTDate(new Date(), DateUtilities.defaultDateTimeISOFormat) // Send Pacific Time (PT) to API
            }
        };
        await this.sessionService.updateMemberProfile(apiMemberStateModel);
    }
    isAgentLoggedIn() {
        return this.agentService.isAgentLoggedIn();
    }
    getEmailStatus(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_BlueButton_SendEmail_WaitingStatus_Text', widgetName, 'Waiting for access');
    }
    getEmailSentToText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_BlueButton_EmailSentToStatus_Text', widgetName, `Email sent to {{[member.profile.emailAddress]}} on`);
    }
    addSendBlueButtonEmailNote(emailAddress, widgetName) {
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        const agentName = this.store.selectSnapshot(AgentState.fullName);
        const date = DateUtilities.getFormattedDate(new Date(), DateUtilities.defaultDateTimeISOFormat);
        const description = `${this.configResourceService.getProcessedResourceValue('Spa_BlueButton_EmailSentToBeneficiary_Note', widgetName, `MyMedicare.gov email sent to`)} ${emailAddress}`;
        const note = {
            userAgentGUID: agentGuid,
            agentNoteActionType: NoteActionType.Note,
            description,
            agentName,
            createdWhen: date
        };
        this.sessionService.addMemberNoteByAgent(note);
    }
}
BlueButtonFacade.ɵfac = function BlueButtonFacade_Factory(t) { return new (t || BlueButtonFacade)(i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(i1.EmailService), i0.ɵɵinject(i1.SiteService), i0.ɵɵinject(i1.AgentService), i0.ɵɵinject(AnalyticsService), i0.ɵɵinject(i1.MessagesService), i0.ɵɵinject(i1.PhoneUtilityService), i0.ɵɵinject(i1.GuidedHelpModalContextService)); };
BlueButtonFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BlueButtonFacade, factory: BlueButtonFacade.ɵfac, providedIn: 'root' });
__decorate([
    Select(MedicineCabinetState.medicineCabinet)
], BlueButtonFacade.prototype, "medicineCabinet$", void 0);
__decorate([
    Select(AgentState.isLoggedIn)
], BlueButtonFacade.prototype, "agentLoggedIn$", void 0);
__decorate([
    Select(BlueButtonMedicineCabinetState.blueButtonMedicineCabinet)
], BlueButtonFacade.prototype, "blueButtonCabinet$", void 0);
__decorate([
    LiveEditInactive()
], BlueButtonFacade.prototype, "openBlueButtonModal", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BlueButtonFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: i2$1.Router }, { type: i2.Store }, { type: i1$1.NgbModal }, { type: i0.Injector }, { type: i1.MemberSessionService }, { type: i1.EmailService }, { type: i1.SiteService }, { type: i1.AgentService }, { type: AnalyticsService }, { type: i1.MessagesService }, { type: i1.PhoneUtilityService }, { type: i1.GuidedHelpModalContextService }]; }, { medicineCabinet$: [], agentLoggedIn$: [], blueButtonCabinet$: [], openBlueButtonModal: [] }); })();

class SharePrescriptionFacade {
    constructor(configResourceService, siteService, store, memberSessionService, blueButtonService, agentService) {
        this.configResourceService = configResourceService;
        this.siteService = siteService;
        this.store = store;
        this.memberSessionService = memberSessionService;
        this.blueButtonService = blueButtonService;
        this.agentService = agentService;
    }
    isPPCSite() {
        return this.siteService.isPPCSite(this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType', null, SiteType.CONSUMER));
    }
    async generateMemberSession(memberId) {
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        if (agentGuid && memberId) {
            await this.memberSessionService.selectMemberForAgent$(agentGuid, memberId).toPromise();
        }
    }
    isAgentLoggedIn() {
        return this.agentService.isAgentLoggedIn();
    }
    async updateMemberAndAddNote(widgetName) {
        const apiMemberStateModel = {
            blueButtonInfo: {
                status: BlueButtonStatus.DENIED,
                updateDate: DateUtilities.getFormattedDate(new Date(), DateUtilities.defaultDateTimeISOFormat)
            }
        };
        await this.memberSessionService.updateMemberProfile(apiMemberStateModel);
        if (this.isPPCSite()) {
            const description = this.configResourceService.getProcessedResourceValue('Spa_BlueButton_SharedPrescription_Denied_Note', widgetName, `System notification: {{[member.profile.firstName]}} denied access to prescriptions from MyMedicare.gov. Initiated by:`);
            this.blueButtonService.addBlueButtonSharedPrescriptionNote(description);
            this.blueButtonService.sendEmailToAgent();
        }
        this.setBlueButtonLoading(false);
    }
    setBlueButtonLoading(isBlueButtonLoads) {
        this.store.dispatch(new SetBlueButtonCabinetLoading(isBlueButtonLoads));
    }
    updateClaimStatus(isClaimUpdated) {
        this.store.dispatch(new UpdateBlueButtonCabinetClaimStatus(isClaimUpdated));
    }
    isLiveEdit() {
        if (EnvironmentService.getEnvironment().liveedit) {
            return true;
        }
        return false;
    }
}
SharePrescriptionFacade.ɵfac = function SharePrescriptionFacade_Factory(t) { return new (t || SharePrescriptionFacade)(i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.SiteService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(i1.BlueButtonService), i0.ɵɵinject(i1.AgentService)); };
SharePrescriptionFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SharePrescriptionFacade, factory: SharePrescriptionFacade.ɵfac, providedIn: 'root' });
__decorate([
    Select(BlueButtonMedicineCabinetState.blueButtonFetchPrescriptionError)
], SharePrescriptionFacade.prototype, "blueButtonFetchPrescriptionError$", void 0);
__decorate([
    Select(BlueButtonMedicineCabinetState.blueButtonLoading)
], SharePrescriptionFacade.prototype, "blueButtonLoading$", void 0);
__decorate([
    Select(MemberState.blueButtonInfo)
], SharePrescriptionFacade.prototype, "blueButtonInfo$", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SharePrescriptionFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: i1.SiteService }, { type: i2.Store }, { type: i1.MemberSessionService }, { type: i1.BlueButtonService }, { type: i1.AgentService }]; }, { blueButtonFetchPrescriptionError$: [], blueButtonLoading$: [], blueButtonInfo$: [] }); })();

function BlueButtonComponent_ng_template_2_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "button", 11);
    i0.ɵɵlistener("click", function BlueButtonComponent_ng_template_2_div_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.importLatestPrescriptions()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.blueButtonImportLatestPrescriptionButtonText, " ");
} }
function BlueButtonComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 0);
    i0.ɵɵtemplate(2, BlueButtonComponent_ng_template_2_div_2_Template, 3, 1, "div", 5);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementStart(4, "div", 6)(5, "div", 7);
    i0.ɵɵelement(6, "i", 8);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 9);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "async");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    let tmp_0_0;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ((tmp_0_0 = i0.ɵɵpipeBind1(3, 3, ctx_r1.blueButtonUpdateInfo$)) == null ? null : tmp_0_0.status) === ctx_r1.blueButtonStatus.SUCCESS);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.blueButtonSuccessText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(10, 5, ctx_r1.statusMessage$));
} }
function BlueButtonComponent_ng_container_4_ng_container_1_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.startAddingDrugText, " ");
} }
function BlueButtonComponent_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, BlueButtonComponent_ng_container_4_ng_container_1_p_1_Template, 2, 1, "p", 16);
    i0.ɵɵelementStart(2, "p", 17);
    i0.ɵɵelement(3, "span", 18);
    i0.ɵɵelementStart(4, "span", 19);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_BlueButton_StartAddDrug_Text");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r6.orText);
} }
function BlueButtonComponent_ng_container_4_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 21);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r7.blueButtonBeneficiaryEmailDetails);
} }
function BlueButtonComponent_ng_container_4_ng_template_6_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 23);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r15.connectToMyMedicareText, "html"), i0.ɵɵsanitizeHtml);
} }
function BlueButtonComponent_ng_container_4_ng_template_6_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, BlueButtonComponent_ng_container_4_ng_template_6_ng_container_0_div_1_Template, 2, 4, "div", 22);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_BlueButton_MyMedicare_Connect_Text");
} }
function BlueButtonComponent_ng_container_4_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, BlueButtonComponent_ng_container_4_ng_template_6_ng_container_0_Template, 2, 1, "ng-container", 12);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(1, 1, ctx_r9.isClaimUpdated$));
} }
function BlueButtonComponent_ng_container_4_ng_container_8_div_3_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r20.emailRequiredErrorText);
} }
function BlueButtonComponent_ng_container_4_ng_container_8_div_3_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r21.emailInvalidErrorText);
} }
function BlueButtonComponent_ng_container_4_ng_container_8_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelement(1, "i", 34);
    i0.ɵɵtemplate(2, BlueButtonComponent_ng_container_4_ng_container_8_div_3_span_2_Template, 2, 1, "span", 12);
    i0.ɵɵtemplate(3, BlueButtonComponent_ng_container_4_ng_container_8_div_3_span_3_Template, 2, 1, "span", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r16.getFieldErrors("emailAddress").required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.getFieldErrors("emailAddress").email);
} }
function BlueButtonComponent_ng_container_4_ng_container_8_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 35);
    i0.ɵɵlistener("click", function BlueButtonComponent_ng_container_4_ng_container_8_button_11_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r22.onSendEmail()); })("keyup.enter", function BlueButtonComponent_ng_container_4_ng_container_8_button_11_Template_button_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r23); const ctx_r24 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r24.onSendEmail()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r17.sendEmailButtonText, " ");
} }
function BlueButtonComponent_ng_container_4_ng_container_8_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36)(1, "div", 37);
    i0.ɵɵelement(2, "i", 38);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "span", 39);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r18.emailStatusText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r18.emailSentToText);
} }
function BlueButtonComponent_ng_container_4_ng_container_8_ng_container_13_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36)(1, "div", 37);
    i0.ɵɵelement(2, "i", 38)(3, "span", 40);
    i0.ɵɵpipe(4, "safe");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span", 41);
    i0.ɵɵpipe(6, "safe");
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 2, ctx_r27.blueButtonFacade.getEmailStatus(), "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(6, 5, i0.ɵɵpipeBind1(7, 8, ctx_r27.statusMessage$), "html"), i0.ɵɵsanitizeHtml);
} }
function BlueButtonComponent_ng_container_4_ng_container_8_ng_container_13_ng_container_1_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 37);
    i0.ɵɵelement(2, "i", 38)(3, "span", 40);
    i0.ɵɵpipe(4, "safe");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span", 41);
    i0.ɵɵpipe(6, "safe");
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 2, ctx_r30.blueButtonIssueLoadingText, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(6, 5, i0.ɵɵpipeBind1(7, 8, ctx_r30.statusMessage$), "html"), i0.ɵɵsanitizeHtml);
} }
function BlueButtonComponent_ng_container_4_ng_container_8_ng_container_13_ng_container_1_div_2_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵelement(1, "i", 38)(2, "span", 40);
    i0.ɵɵpipe(3, "safe");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 41);
    i0.ɵɵpipe(5, "safe");
    i0.ɵɵpipe(6, "async");
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(3, 2, ctx_r32.blueButtonErrorLoadingText, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(5, 5, i0.ɵɵpipeBind1(6, 8, ctx_r32.statusMessage$), "html"), i0.ɵɵsanitizeHtml);
} }
function BlueButtonComponent_ng_container_4_ng_container_8_ng_container_13_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵtemplate(1, BlueButtonComponent_ng_container_4_ng_container_8_ng_container_13_ng_container_1_div_2_ng_container_1_Template, 8, 10, "ng-container", 3);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, BlueButtonComponent_ng_container_4_ng_container_8_ng_container_13_ng_container_1_div_2_ng_template_3_Template, 7, 10, "ng-template", null, 42, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r31 = i0.ɵɵreference(4);
    const ctx_r28 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(2, 2, ctx_r28.blueButtonFacade.isAgentImportData$))("ngIfElse", _r31);
} }
function BlueButtonComponent_ng_container_4_ng_container_8_ng_container_13_ng_container_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36)(1, "div", 37);
    i0.ɵɵelement(2, "i", 38)(3, "span", 40);
    i0.ɵɵpipe(4, "safe");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span", 41);
    i0.ɵɵpipe(6, "safe");
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 2, ctx_r29.blueButtonBeneficiaryDeniedText, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(6, 5, i0.ɵɵpipeBind1(7, 8, ctx_r29.statusMessage$), "html"), i0.ɵɵsanitizeHtml);
} }
function BlueButtonComponent_ng_container_4_ng_container_8_ng_container_13_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, BlueButtonComponent_ng_container_4_ng_container_8_ng_container_13_ng_container_1_div_1_Template, 8, 10, "div", 32);
    i0.ɵɵtemplate(2, BlueButtonComponent_ng_container_4_ng_container_8_ng_container_13_ng_container_1_div_2_Template, 5, 4, "div", 32);
    i0.ɵɵtemplate(3, BlueButtonComponent_ng_container_4_ng_container_8_ng_container_13_ng_container_1_div_3_Template, 8, 10, "div", 32);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const blueButtonUpdateInfo_r26 = ctx.ngIf;
    const ctx_r25 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (blueButtonUpdateInfo_r26 == null ? null : blueButtonUpdateInfo_r26.status) === ctx_r25.blueButtonStatus.NEW);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (blueButtonUpdateInfo_r26 == null ? null : blueButtonUpdateInfo_r26.status) === ctx_r25.blueButtonStatus.ERROR && ctx_r25.blueButtonFacade.isAgentLoggedIn());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (blueButtonUpdateInfo_r26 == null ? null : blueButtonUpdateInfo_r26.status) === ctx_r25.blueButtonStatus.DENIED);
} }
function BlueButtonComponent_ng_container_4_ng_container_8_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, BlueButtonComponent_ng_container_4_ng_container_8_ng_container_13_ng_container_1_Template, 4, 3, "ng-container", 12);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r19.blueButtonUpdateInfo$));
} }
function BlueButtonComponent_ng_container_4_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "form", 24)(2, "div", 25);
    i0.ɵɵtemplate(3, BlueButtonComponent_ng_container_4_ng_container_8_div_3_Template, 4, 2, "div", 26);
    i0.ɵɵelementStart(4, "label", 27)(5, "span", 28);
    i0.ɵɵtext(6, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 0)(9, "div", 29)(10, "input", 30);
    i0.ɵɵlistener("focus", function BlueButtonComponent_ng_container_4_ng_container_8_Template_input_focus_10_listener() { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r33.setFocus("emailAddress")); })("blur", function BlueButtonComponent_ng_container_4_ng_container_8_Template_input_blur_10_listener() { i0.ɵɵrestoreView(_r34); const ctx_r35 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r35.removeFocus()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, BlueButtonComponent_ng_container_4_ng_container_8_button_11_Template, 2, 1, "button", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, BlueButtonComponent_ng_container_4_ng_container_8_div_12_Template, 7, 2, "div", 32);
    i0.ɵɵtemplate(13, BlueButtonComponent_ng_container_4_ng_container_8_ng_container_13_Template, 3, 3, "ng-container", 12);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r10.sendEmailFormGroup);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r10.fieldHasError("emailAddress"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r10.emailLabelText);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_SendEmailButton_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.emailStatusText && ctx_r10.emailSentToText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r10.emailSentToText && !ctx_r10.emailStatusText);
} }
function BlueButtonComponent_ng_container_4_ng_template_9_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 46);
    i0.ɵɵlistener("click", function BlueButtonComponent_ng_container_4_ng_template_9_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r40.openBlueButtonModal()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r36.myMedicareButtonText, " ");
} }
function BlueButtonComponent_ng_container_4_ng_template_9_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 47);
    i0.ɵɵelement(2, "i", 38);
    i0.ɵɵelementStart(3, "span", 48);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 49);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r37.blueButtonImportLatestPrescriptionErrorText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 2, ctx_r37.statusMessage$));
} }
function BlueButtonComponent_ng_container_4_ng_template_9_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 47);
    i0.ɵɵelement(2, "i", 38);
    i0.ɵɵelementStart(3, "span", 48);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r38.blueButtonClaimDataLoadingErrorText);
} }
function BlueButtonComponent_ng_container_4_ng_template_9_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 47);
    i0.ɵɵelement(2, "i", 38);
    i0.ɵɵelementStart(3, "span", 48);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r39.blueButtonAccessDeniedText);
} }
function BlueButtonComponent_ng_container_4_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 43);
    i0.ɵɵtemplate(2, BlueButtonComponent_ng_container_4_ng_template_9_button_2_Template, 2, 1, "button", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 45);
    i0.ɵɵtemplate(4, BlueButtonComponent_ng_container_4_ng_template_9_div_4_Template, 8, 4, "div", 12);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵpipe(7, "async");
    i0.ɵɵtemplate(8, BlueButtonComponent_ng_container_4_ng_template_9_div_8_Template, 5, 1, "div", 12);
    i0.ɵɵpipe(9, "async");
    i0.ɵɵpipe(10, "async");
    i0.ɵɵpipe(11, "async");
    i0.ɵɵtemplate(12, BlueButtonComponent_ng_container_4_ng_template_9_div_12_Template, 5, 1, "div", 12);
    i0.ɵɵpipe(13, "async");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    let tmp_1_0;
    let tmp_2_0;
    let tmp_3_0;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_BlueButton_MyMedicare_Button");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(5, 4, ctx_r12.sharePrescriptionFacade.blueButtonFetchPrescriptionError$) && i0.ɵɵpipeBind1(6, 6, ctx_r12.isClaimUpdated$) && ((tmp_1_0 = i0.ɵɵpipeBind1(7, 8, ctx_r12.blueButtonUpdateInfo$)) == null ? null : tmp_1_0.status) !== ctx_r12.blueButtonStatus.DENIED);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(9, 10, ctx_r12.sharePrescriptionFacade.blueButtonFetchPrescriptionError$) && ((tmp_2_0 = i0.ɵɵpipeBind1(10, 12, ctx_r12.blueButtonUpdateInfo$)) == null ? null : tmp_2_0.status) === ctx_r12.blueButtonStatus.ERROR && !i0.ɵɵpipeBind1(11, 14, ctx_r12.isClaimUpdated$));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ((tmp_3_0 = i0.ɵɵpipeBind1(13, 16, ctx_r12.blueButtonUpdateInfo$)) == null ? null : tmp_3_0.status) === ctx_r12.blueButtonStatus.DENIED);
} }
function BlueButtonComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, BlueButtonComponent_ng_container_4_ng_container_1_Template, 6, 2, "ng-container", 12);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵtemplate(4, BlueButtonComponent_ng_container_4_ng_container_4_Template, 3, 1, "ng-container", 3);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵtemplate(6, BlueButtonComponent_ng_container_4_ng_template_6_Template, 2, 3, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(8, BlueButtonComponent_ng_container_4_ng_container_8_Template, 14, 6, "ng-container", 3);
    i0.ɵɵtemplate(9, BlueButtonComponent_ng_container_4_ng_template_9_Template, 14, 18, "ng-template", null, 15, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r8 = i0.ɵɵreference(7);
    const _r11 = i0.ɵɵreference(10);
    const ctx_r2 = i0.ɵɵnextContext();
    let tmp_0_0;
    let tmp_1_0;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ((tmp_0_0 = i0.ɵɵpipeBind1(2, 5, ctx_r2.blueButtonFacade.medicineCabinet$)) == null ? null : tmp_0_0.length) === 0);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ((tmp_1_0 = i0.ɵɵpipeBind1(5, 7, ctx_r2.blueButtonUpdateInfo$)) == null ? null : tmp_1_0.status) === ctx_r2.blueButtonStatus.ERROR && ctx_r2.blueButtonFacade.isAgentLoggedIn())("ngIfElse", _r8);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r2.blueButtonFacade.isPPCSite())("ngIfElse", _r11);
} }
class BlueButtonComponent {
    constructor(blueButtonFacade, modalService, store, cdr, spinnerService, navigationService, drugsService, sharePrescriptionFacade, agentSearchFacade, analyticsService, configResourceService, siteService, profileService, guidedHelpModalContextService) {
        this.blueButtonFacade = blueButtonFacade;
        this.modalService = modalService;
        this.store = store;
        this.cdr = cdr;
        this.spinnerService = spinnerService;
        this.navigationService = navigationService;
        this.drugsService = drugsService;
        this.sharePrescriptionFacade = sharePrescriptionFacade;
        this.agentSearchFacade = agentSearchFacade;
        this.analyticsService = analyticsService;
        this.configResourceService = configResourceService;
        this.siteService = siteService;
        this.profileService = profileService;
        this.guidedHelpModalContextService = guidedHelpModalContextService;
        this.isPreferenceBannerEnabled = false;
        this.focusedControl = '';
        this.blueButtonStatus = BlueButtonStatus;
    }
    ngOnInit() {
        const memberProfileData = this.store.selectSnapshot(MemberState.session);
        this.sendEmailFormGroup = new UntypedFormGroup({
            emailAddress: new UntypedFormControl(memberProfileData.profile.emailAddress, [Validators.required, Validators.email])
        }, { updateOn: 'blur' });
        this.statusMessage$ = combineLatest(this.blueButtonUpdateInfo$, this.blueButtonMedicineCabinet$, this.isClaimUpdated$).pipe(map(([blueButtonInfo, blueButtonMedicineCabinet, isClaimUpdated]) => {
            let formattedDate = '';
            if (blueButtonInfo && blueButtonInfo.updateDate) {
                // updateDate in PST time. Just need to convert to MM/DD/YYYY
                formattedDate = DateUtilities.getFormattedDateTime(new Date(blueButtonInfo.updateDate), DateUtilities.defaultFormat);
            }
            let updatedText = '';
            if ((blueButtonMedicineCabinet && blueButtonMedicineCabinet.length) ||
                (blueButtonInfo && blueButtonInfo.status && blueButtonInfo.status === this.blueButtonStatus.SUCCESS) ||
                isClaimUpdated) {
                updatedText = this.blueButtonSuccessMessage;
            }
            else if (this.blueButtonFacade.isAgentLoggedIn() && blueButtonInfo.status === this.blueButtonStatus.ERROR) {
                updatedText = this.blueButtonDownloadText;
            }
            else {
                updatedText = this.blueButtonEmailSendText;
            }
            const lastUpdatedDate = formattedDate ? formattedDate : DateUtilities.getFormattedPTDate();
            return `${updatedText} ${lastUpdatedDate}`;
        }));
        this.isAddFollowUpTaskEnabled = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_AddFollowUp_Enabled', null, false);
    }
    importLatestPrescriptions() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_BLUEBUTTON_REFRESH_START);
        this.blueButtonFacade.isImportLatestPrescriptionClicked(true);
        this.store.dispatch(new SetBlueButtonCabinetLoading(true));
        this.store.dispatch(new ResetBlueButtonMedicineCabinet());
        this.navigationService.navigateByPageTag(PageTags.SHARE_PRESCRIPTIONS);
    }
    async onSendEmail() {
        if (this.sendEmailFormGroup.status !== 'INVALID') {
            this.spinnerService.show(SpinnerEvent.SEND_EMAIL_LOADING);
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_BLUEBUTTON_SENDEMAIL);
            const emailAddress = this.sendEmailFormGroup.get('emailAddress').value;
            await this.blueButtonFacade.updateMemberEmailAndStatus(emailAddress).then(() => { }, // No action here
            () => this.spinnerService.hide(SpinnerEvent.SEND_EMAIL_LOADING));
            this.blueButtonFacade.sendEmailToBeneficiary(emailAddress).then(() => {
                this.blueButtonFacade.addSendBlueButtonEmailNote(emailAddress);
                this.emailStatusText = this.blueButtonFacade.getEmailStatus();
                this.emailSentToText = `${this.blueButtonFacade.getEmailSentToText()} ${DateUtilities.getFormattedPTDate()}`;
                if (this.isAddFollowUpTaskEnabled && this.profileService.hasMemberProfile()) {
                    this.showBlueButtonFollowUpModal();
                }
                this.cdr.markForCheck();
                this.spinnerService.hide(SpinnerEvent.SEND_EMAIL_LOADING);
            }, () => this.spinnerService.hide(SpinnerEvent.SEND_EMAIL_LOADING));
        }
        else {
            this.fieldHasError('emailAddress');
        }
    }
    openBlueButtonModal() {
        this.drugsService.saveDrugList();
        if (this.isPreferenceBannerEnabled && this.modalService.hasOpenModals()) {
            this.modalService.dismissAll();
        }
        this.blueButtonFacade.openBlueButtonModal(this.blueButtonModalHeaderText, this.blueButtonModalContent, null, this.isPreferenceBannerEnabled);
    }
    showBlueButtonFollowUpModal() {
        if (this.isPreferenceBannerEnabled && this.modalService.hasOpenModals()) {
            this.modalService.dismissAll();
        }
        const confirmationModal = this.modalService.open(BlueButtonFollowUpModalComponent, { centered: true });
        confirmationModal.componentInstance.modalSentConfirmationText = this.emailSentToText;
        confirmationModal.componentInstance.modalTitleText = this.getBlueButtonModalTitle();
        confirmationModal.componentInstance.modalViewMemberLink = this.getViewMemberLink();
        confirmationModal.componentInstance.showViewMemberLink = this.profileService.getShowViewMemberLink();
        if (this.isPreferenceBannerEnabled) {
            confirmationModal.componentInstance.cancelAction = () => {
                this.guidedHelpModalContextService.openGuidedHelpModal(PageTags.GUIDED_HELP_PRESCRIPTIONS);
            };
        }
        confirmationModal.result
            .then(() => this.agentSearchFacade.navigateByPageTag(PageTags.ADD_NEW_PROFILE))
            .catch(() => {
            // eat the error to prevent a console error
        });
    }
    fieldHasError(fieldName) {
        const control = this.sendEmailFormGroup.get(fieldName);
        return !control.valid && control.touched && this.focusedControl !== fieldName;
    }
    getFieldErrors(fieldName) {
        const control = this.sendEmailFormGroup.get(fieldName);
        return control.errors || {};
    }
    getViewMemberLink(widgetName) {
        const isCreateProfileEnabled = this.configResourceService.getProcessedResourceValue('Spa_Quote_CreateProfile_Enabled', widgetName, this.siteService.isPPCSite());
        const createProfileLink = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_CreateProfile_Link_Text', widgetName, 'Create a profile');
        const viewMemberLink = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_ViewMemberProfile_Link_Text', widgetName, `View 's profile`);
        if (this.profileService.hasMemberProfile() || isCreateProfileEnabled) {
            const fullName = this.profileService.getMemberFullName();
            return this.profileService.getViewLinkText(viewMemberLink, fullName);
        }
        return createProfileLink;
    }
    getBlueButtonModalTitle() {
        return this.configResourceService.getProcessedResourceValue('Spa_AgentTask_FollowUp_BlueButton_Title', null, 'MyMedicare.gov invitation sent');
    }
    setFocus(controlName) {
        this.focusedControl = controlName;
    }
    removeFocus() {
        this.focusedControl = '';
    }
}
BlueButtonComponent.ɵfac = function BlueButtonComponent_Factory(t) { return new (t || BlueButtonComponent)(i0.ɵɵdirectiveInject(BlueButtonFacade), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.DrugsService), i0.ɵɵdirectiveInject(SharePrescriptionFacade), i0.ɵɵdirectiveInject(AgentSearchFacade), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(i1.ProfileService), i0.ɵɵdirectiveInject(i1.GuidedHelpModalContextService)); };
BlueButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BlueButtonComponent, selectors: [["vnext-blue-button"]], inputs: { startAddingDrugText: "startAddingDrugText", orText: "orText", connectToMyMedicareText: "connectToMyMedicareText", myMedicareButtonText: "myMedicareButtonText", emailLabelText: "emailLabelText", emailRequiredErrorText: "emailRequiredErrorText", emailInvalidErrorText: "emailInvalidErrorText", sendEmailButtonText: "sendEmailButtonText", blueButtonModalHeaderText: "blueButtonModalHeaderText", blueButtonModalContent: "blueButtonModalContent", blueButtonSuccessText: "blueButtonSuccessText", blueButtonDownloadText: "blueButtonDownloadText", blueButtonSuccessMessage: "blueButtonSuccessMessage", blueButtonEmailSendText: "blueButtonEmailSendText", blueButtonIssueLoadingText: "blueButtonIssueLoadingText", blueButtonBeneficiaryDeniedText: "blueButtonBeneficiaryDeniedText", blueButtonErrorLoadingText: "blueButtonErrorLoadingText", blueButtonBeneficiaryEmailDetails: "blueButtonBeneficiaryEmailDetails", blueButtonImportLatestPrescriptionButtonText: "blueButtonImportLatestPrescriptionButtonText", blueButtonImportLatestPrescriptionErrorText: "blueButtonImportLatestPrescriptionErrorText", blueButtonAccessDeniedText: "blueButtonAccessDeniedText", blueButtonClaimDataLoadingErrorText: "blueButtonClaimDataLoadingErrorText", isPreferenceBannerEnabled: "isPreferenceBannerEnabled" }, decls: 7, vars: 6, consts: [[1, "row"], [1, "col-12", "mt-3", "px-0"], ["successfulDownload", ""], [4, "ngIf", "ngIfElse"], [1, "Spa_Style_Toggle_Background", "px-3", "pt-3", "pb-3", "rounded", "Spa_Style_Paragraph", "Spa_Style_Smaller_Font"], ["class", "col-sm-5", 4, "ngIf"], [1, "col-sm-7"], [1, "row", "ml-2", "mt-2", "blue-button-success-text", "Spa_Style_Paragraph"], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "mr-1"], [1, "row", "ml-4", "Spa_Style_Paragraph"], [1, "col-sm-5"], [1, "btn", "Spa_Style_SecondaryButton", "mt-1", "w-100", 3, "click"], [4, "ngIf"], [1, "Spa_Style_Toggle_Background", "px-3", "pt-4", "pb-4", "rounded"], ["showBeneficiaryEmailDetails", ""], ["beneficiaryUserTemplate", ""], ["class", "Spa_Style_Primary_Color Spa_Style_Paragraph text-center", 4, "liveEditProp"], [1, "Spa_Style_Primary_Color", "Spa_Style_IntroParagraph_SemiBold", "text-center", "blue-button-or-text-wrapper", "mb-3"], [1, "horizontal-bar"], [1, "blue-button-or-text"], [1, "Spa_Style_Primary_Color", "Spa_Style_Paragraph", "text-center"], [1, "mb-2"], ["class", "mb-2", "navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], ["navigationAdapter", "", 1, "mb-2", 3, "innerHTML"], [3, "formGroup"], [1, "mt-0"], ["class", "error-container", 4, "ngIf"], ["for", "emailAddress", 1, "Spa_Style_Label"], [1, "input-error-asterisk"], [1, "col-lg-6", "pr-0", "pb-3"], ["id", "emailAddress", "tabindex", "0", "type", "email", "formControlName", "emailAddress", 1, "remove-right-round", "email-control-width", 3, "focus", "blur"], ["class", "btn send-btn Spa_Style_SecondaryButton px-2", "type", "submit", 3, "click", "keyup.enter", 4, "liveEditProp"], ["class", "Spa_Style_Paragraph Spa_Style_Smaller_Font col-lg-6", 4, "ngIf"], [1, "error-container"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], ["type", "submit", 1, "btn", "send-btn", "Spa_Style_SecondaryButton", "px-2", 3, "click", "keyup.enter"], [1, "Spa_Style_Paragraph", "Spa_Style_Smaller_Font", "col-lg-6"], [1, "Spa_Style_Accent4_Color"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-triangle", "mr-1"], [1, "ml-1", "pl-3", "float-left"], ["navigationAdapter", "", 3, "innerHTML"], ["navigationAdapter", "", 1, "ml-1", "pl-3", "float-left", 3, "innerHTML"], ["showUnableToLoadContent", ""], [1, "col-5", "mt-2"], ["class", "btn Spa_Style_SecondaryButton", 3, "click", 4, "liveEditProp"], [1, "col-lg-7", "col-12", "mt-2", "px-0"], [1, "btn", "Spa_Style_SecondaryButton", 3, "click"], [1, "row", "mt-2", "ml-lg-1", "mx-3", "Spa_Style_Accent4_Color", "rounded", "Spa_Style_Paragraph", "Spa_Style_Smaller_Font", "d-inline"], [1, "position-absolute", "mt-1"], [1, "row", "ml-4", "Spa_Style_Paragraph", "Spa_Style_Smaller_Font"]], template: function BlueButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, BlueButtonComponent_ng_template_2_Template, 11, 7, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(4, BlueButtonComponent_ng_container_4_Template, 11, 9, "ng-container", 3);
        i0.ɵɵpipe(5, "async");
        i0.ɵɵpipe(6, "async");
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(3);
        let tmp_0_0;
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ((tmp_0_0 = i0.ɵɵpipeBind1(5, 2, ctx.blueButtonMedicineCabinet$)) == null ? null : tmp_0_0.length) === 0 && ((tmp_0_0 = i0.ɵɵpipeBind1(6, 4, ctx.blueButtonUpdateInfo$)) == null ? null : tmp_0_0.status) !== ctx.blueButtonStatus.SUCCESS)("ngIfElse", _r0);
    } }, dependencies: [i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, NavigationAdapterDirective, LiveEditPropDirective, IconAriaAttributesDirective, i1$2.AsyncPipe, SafePipe], styles: [".blue-button-or-text-wrapper[_ngcontent-%COMP%]{position:relative}.blue-button-or-text[_ngcontent-%COMP%]{background:white;position:relative;padding:0 5px}.horizontal-bar[_ngcontent-%COMP%]{position:absolute;width:100%;top:45%;left:0;z-index:0;border-bottom:1px solid var(--static-Spa_Style_Accent1)}.remove-right-round[_ngcontent-%COMP%]{border-top-right-radius:0;border-bottom-right-radius:0}.send-btn[_ngcontent-%COMP%]{border-bottom-left-radius:0;border-top-left-radius:0;line-height:1.4;margin-top:-2px;margin-left:-1px}.email-control-width[_ngcontent-%COMP%]{width:220px}.blue-button-success-text[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text)}@media only screen and (min-width: 320px) and (max-width: 568px){.email-control-width[_ngcontent-%COMP%]{width:160px}}"], changeDetection: 0 });
__decorate([
    Select(BlueButtonMedicineCabinetState.blueButtonMedicineCabinet)
], BlueButtonComponent.prototype, "blueButtonMedicineCabinet$", void 0);
__decorate([
    Select(BlueButtonMedicineCabinetState.isClaimUpdated)
], BlueButtonComponent.prototype, "isClaimUpdated$", void 0);
__decorate([
    Select(MemberState.blueButtonInfo)
], BlueButtonComponent.prototype, "blueButtonUpdateInfo$", void 0);
__decorate([
    LiveEditInactive()
], BlueButtonComponent.prototype, "onSendEmail", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BlueButtonComponent, [{
        type: Component,
        args: [{ selector: 'vnext-blue-button', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row\">\r\n  <div class=\"col-12 mt-3 px-0\">\r\n    <ng-template #successfulDownload>\r\n      <div class=\"Spa_Style_Toggle_Background px-3 pt-3 pb-3 rounded Spa_Style_Paragraph Spa_Style_Smaller_Font\">\r\n        <div class=\"row\">\r\n          <div *ngIf=\"(blueButtonUpdateInfo$ | async)?.status === blueButtonStatus.SUCCESS\" class=\"col-sm-5\">\r\n            <button class=\"btn Spa_Style_SecondaryButton mt-1 w-100\" (click)=\"importLatestPrescriptions()\">\r\n              {{ blueButtonImportLatestPrescriptionButtonText }}\r\n            </button>\r\n          </div>\r\n          <div class=\"col-sm-7\">\r\n            <div class=\"row ml-2 mt-2 blue-button-success-text Spa_Style_Paragraph\">\r\n              <i class=\"fas fa-check-circle mr-1\" aria-hidden=\"true\"></i> {{ blueButtonSuccessText }}\r\n            </div>\r\n            <div class=\"row ml-4 Spa_Style_Paragraph\">{{ statusMessage$ | async }}</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </ng-template>\r\n    <ng-container\r\n      *ngIf=\"\r\n        (blueButtonMedicineCabinet$ | async)?.length === 0 && (blueButtonUpdateInfo$ | async)?.status !== blueButtonStatus.SUCCESS;\r\n        else successfulDownload\r\n      \"\r\n    >\r\n      <ng-container *ngIf=\"(blueButtonFacade.medicineCabinet$ | async)?.length === 0\">\r\n        <p class=\"Spa_Style_Primary_Color Spa_Style_Paragraph text-center\" *liveEditProp=\"'Spa_BlueButton_StartAddDrug_Text'\">\r\n          {{ startAddingDrugText }}\r\n        </p>\r\n        <p class=\"Spa_Style_Primary_Color Spa_Style_IntroParagraph_SemiBold text-center blue-button-or-text-wrapper mb-3\">\r\n          <span class=\"horizontal-bar\"></span>\r\n          <span class=\"blue-button-or-text\">{{ orText }}</span>\r\n        </p>\r\n      </ng-container>\r\n      <div class=\"Spa_Style_Toggle_Background px-3 pt-4 pb-4 rounded\">\r\n        <ng-container\r\n          *ngIf=\"\r\n            (blueButtonUpdateInfo$ | async)?.status === blueButtonStatus.ERROR && this.blueButtonFacade.isAgentLoggedIn();\r\n            else showBeneficiaryEmailDetails\r\n          \"\r\n        >\r\n          <div class=\"mb-2\">{{ blueButtonBeneficiaryEmailDetails }}</div>\r\n        </ng-container>\r\n        <ng-template #showBeneficiaryEmailDetails>\r\n          <ng-container *ngIf=\"!(isClaimUpdated$ | async)\">\r\n            <div\r\n              class=\"mb-2\"\r\n              [innerHTML]=\"connectToMyMedicareText | safe : 'html'\"\r\n              *liveEditProp=\"'Spa_BlueButton_MyMedicare_Connect_Text'\"\r\n              navigationAdapter\r\n            ></div>\r\n          </ng-container>\r\n        </ng-template>\r\n\r\n        <ng-container *ngIf=\"blueButtonFacade.isPPCSite(); else beneficiaryUserTemplate\">\r\n          <form [formGroup]=\"sendEmailFormGroup\">\r\n            <div class=\"mt-0\">\r\n              <div *ngIf=\"fieldHasError('emailAddress')\" class=\"error-container\">\r\n                <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n                <span *ngIf=\"getFieldErrors('emailAddress').required\">{{ emailRequiredErrorText }}</span>\r\n                <span *ngIf=\"getFieldErrors('emailAddress').email\">{{ emailInvalidErrorText }}</span>\r\n              </div>\r\n              <label class=\"Spa_Style_Label\" for=\"emailAddress\"><span class=\"input-error-asterisk\">*</span>{{ emailLabelText }}</label>\r\n              <div class=\"row\">\r\n                <div class=\"col-lg-6 pr-0 pb-3\">\r\n                  <input\r\n                    id=\"emailAddress\"\r\n                    class=\"remove-right-round email-control-width\"\r\n                    tabindex=\"0\"\r\n                    type=\"email\"\r\n                    formControlName=\"emailAddress\"\r\n                    (focus)=\"setFocus('emailAddress')\"\r\n                    (blur)=\"removeFocus()\"\r\n                  />\r\n                  <button\r\n                    class=\"btn send-btn Spa_Style_SecondaryButton px-2\"\r\n                    *liveEditProp=\"'Spa_Site_SendEmailButton_Text'\"\r\n                    type=\"submit\"\r\n                    (click)=\"onSendEmail()\"\r\n                    (keyup.enter)=\"onSendEmail()\"\r\n                  >\r\n                    {{ sendEmailButtonText }}\r\n                  </button>\r\n                </div>\r\n                <div *ngIf=\"emailStatusText && emailSentToText\" class=\"Spa_Style_Paragraph Spa_Style_Smaller_Font col-lg-6\">\r\n                  <div class=\"Spa_Style_Accent4_Color\">\r\n                    <i class=\"fas fa-exclamation-triangle mr-1\" aria-hidden=\"true\"></i><span>{{ emailStatusText }}</span>\r\n                  </div>\r\n                  <span class=\"ml-1 pl-3 float-left\">{{ emailSentToText }}</span>\r\n                </div>\r\n                <ng-container *ngIf=\"!emailSentToText && !emailStatusText\">\r\n                  <ng-container *ngIf=\"blueButtonUpdateInfo$ | async as blueButtonUpdateInfo\">\r\n                    <div\r\n                      *ngIf=\"blueButtonUpdateInfo?.status === blueButtonStatus.NEW\"\r\n                      class=\"Spa_Style_Paragraph Spa_Style_Smaller_Font col-lg-6\"\r\n                    >\r\n                      <div class=\"Spa_Style_Accent4_Color\">\r\n                        <i class=\"fas fa-exclamation-triangle mr-1\" aria-hidden=\"true\"></i\r\n                        ><span [innerHTML]=\"blueButtonFacade.getEmailStatus() | safe : 'html'\" navigationAdapter></span>\r\n                      </div>\r\n                      <span class=\"ml-1 pl-3 float-left\" [innerHTML]=\"statusMessage$ | async | safe : 'html'\" navigationAdapter></span>\r\n                    </div>\r\n                    <div\r\n                      *ngIf=\"blueButtonUpdateInfo?.status === blueButtonStatus.ERROR && this.blueButtonFacade.isAgentLoggedIn()\"\r\n                      class=\"Spa_Style_Paragraph Spa_Style_Smaller_Font col-lg-6\"\r\n                    >\r\n                      <ng-container *ngIf=\"!(blueButtonFacade.isAgentImportData$ | async); else showUnableToLoadContent\">\r\n                        <div class=\"Spa_Style_Accent4_Color\">\r\n                          <i class=\"fas fa-exclamation-triangle mr-1\" aria-hidden=\"true\"></i\r\n                          ><span [innerHTML]=\"blueButtonIssueLoadingText | safe : 'html'\" navigationAdapter></span>\r\n                        </div>\r\n                        <span class=\"ml-1 pl-3 float-left\" [innerHTML]=\"statusMessage$ | async | safe : 'html'\" navigationAdapter></span>\r\n                      </ng-container>\r\n                      <ng-template #showUnableToLoadContent>\r\n                        <div class=\"Spa_Style_Accent4_Color\">\r\n                          <i class=\"fas fa-exclamation-triangle mr-1\" aria-hidden=\"true\"></i\r\n                          ><span [innerHTML]=\"blueButtonErrorLoadingText | safe : 'html'\" navigationAdapter></span>\r\n                        </div>\r\n                        <span class=\"ml-1 pl-3 float-left\" [innerHTML]=\"statusMessage$ | async | safe : 'html'\" navigationAdapter></span>\r\n                      </ng-template>\r\n                    </div>\r\n                    <div\r\n                      *ngIf=\"blueButtonUpdateInfo?.status === blueButtonStatus.DENIED\"\r\n                      class=\"Spa_Style_Paragraph Spa_Style_Smaller_Font col-lg-6\"\r\n                    >\r\n                      <div class=\"Spa_Style_Accent4_Color\">\r\n                        <i class=\"fas fa-exclamation-triangle mr-1\" aria-hidden=\"true\"></i\r\n                        ><span [innerHTML]=\"blueButtonBeneficiaryDeniedText | safe : 'html'\" navigationAdapter></span>\r\n                      </div>\r\n                      <span class=\"ml-1 pl-3 float-left\" [innerHTML]=\"statusMessage$ | async | safe : 'html'\" navigationAdapter></span>\r\n                    </div>\r\n                  </ng-container>\r\n                </ng-container>\r\n              </div>\r\n            </div>\r\n          </form>\r\n        </ng-container>\r\n        <ng-template #beneficiaryUserTemplate>\r\n          <div class=\"row\">\r\n            <div class=\"col-5 mt-2\">\r\n              <button\r\n                class=\"btn Spa_Style_SecondaryButton\"\r\n                *liveEditProp=\"'Spa_BlueButton_MyMedicare_Button'\"\r\n                (click)=\"openBlueButtonModal()\"\r\n              >\r\n                {{ myMedicareButtonText }}\r\n              </button>\r\n            </div>\r\n            <div class=\"col-lg-7 col-12 mt-2 px-0\">\r\n              <div\r\n                *ngIf=\"\r\n                  (sharePrescriptionFacade.blueButtonFetchPrescriptionError$ | async) &&\r\n                  (isClaimUpdated$ | async) &&\r\n                  (blueButtonUpdateInfo$ | async)?.status !== blueButtonStatus.DENIED\r\n                \"\r\n              >\r\n                <div class=\"row mt-2 ml-lg-1 mx-3 Spa_Style_Accent4_Color rounded Spa_Style_Paragraph Spa_Style_Smaller_Font d-inline\">\r\n                  <i class=\"fas fa-exclamation-triangle mr-1\" aria-hidden=\"true\"></i\r\n                  ><span class=\"position-absolute mt-1\">{{ blueButtonImportLatestPrescriptionErrorText }}</span>\r\n                </div>\r\n                <div class=\"row ml-4 Spa_Style_Paragraph Spa_Style_Smaller_Font\">{{ statusMessage$ | async }}</div>\r\n              </div>\r\n              <div\r\n                *ngIf=\"\r\n                  (sharePrescriptionFacade.blueButtonFetchPrescriptionError$ | async) &&\r\n                  (blueButtonUpdateInfo$ | async)?.status === blueButtonStatus.ERROR &&\r\n                  !(isClaimUpdated$ | async)\r\n                \"\r\n              >\r\n                <div class=\"row mt-2 ml-lg-1 mx-3 Spa_Style_Accent4_Color rounded Spa_Style_Paragraph Spa_Style_Smaller_Font d-inline\">\r\n                  <i class=\"fas fa-exclamation-triangle mr-1\" aria-hidden=\"true\"></i\r\n                  ><span class=\"position-absolute mt-1\">{{ blueButtonClaimDataLoadingErrorText }}</span>\r\n                </div>\r\n              </div>\r\n              <div *ngIf=\"(blueButtonUpdateInfo$ | async)?.status === blueButtonStatus.DENIED\">\r\n                <div class=\"row mt-2 ml-lg-1 mx-3 Spa_Style_Accent4_Color rounded Spa_Style_Paragraph Spa_Style_Smaller_Font d-inline\">\r\n                  <i class=\"fas fa-exclamation-triangle mr-1\" aria-hidden=\"true\"></i\r\n                  ><span class=\"position-absolute mt-1\">{{ blueButtonAccessDeniedText }}</span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n      </div>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n", styles: [".blue-button-or-text-wrapper{position:relative}.blue-button-or-text{background:white;position:relative;padding:0 5px}.horizontal-bar{position:absolute;width:100%;top:45%;left:0;z-index:0;border-bottom:1px solid var(--static-Spa_Style_Accent1)}.remove-right-round{border-top-right-radius:0;border-bottom-right-radius:0}.send-btn{border-bottom-left-radius:0;border-top-left-radius:0;line-height:1.4;margin-top:-2px;margin-left:-1px}.email-control-width{width:220px}.blue-button-success-text{color:var(--static-Spa_Style_Cost_Text)}@media only screen and (min-width: 320px) and (max-width: 568px){.email-control-width{width:160px}}\n"] }]
    }], function () { return [{ type: BlueButtonFacade }, { type: i1$1.NgbModal }, { type: i2.Store }, { type: i0.ChangeDetectorRef }, { type: i1.SpinnerService }, { type: i1.NavigationService }, { type: i1.DrugsService }, { type: SharePrescriptionFacade }, { type: AgentSearchFacade }, { type: AnalyticsService }, { type: i1.ConfigResourceService }, { type: i1.SiteService }, { type: i1.ProfileService }, { type: i1.GuidedHelpModalContextService }]; }, { blueButtonMedicineCabinet$: [], isClaimUpdated$: [], blueButtonUpdateInfo$: [], startAddingDrugText: [{
            type: Input
        }], orText: [{
            type: Input
        }], connectToMyMedicareText: [{
            type: Input
        }], myMedicareButtonText: [{
            type: Input
        }], emailLabelText: [{
            type: Input
        }], emailRequiredErrorText: [{
            type: Input
        }], emailInvalidErrorText: [{
            type: Input
        }], sendEmailButtonText: [{
            type: Input
        }], blueButtonModalHeaderText: [{
            type: Input
        }], blueButtonModalContent: [{
            type: Input
        }], blueButtonSuccessText: [{
            type: Input
        }], blueButtonDownloadText: [{
            type: Input
        }], blueButtonSuccessMessage: [{
            type: Input
        }], blueButtonEmailSendText: [{
            type: Input
        }], blueButtonIssueLoadingText: [{
            type: Input
        }], blueButtonBeneficiaryDeniedText: [{
            type: Input
        }], blueButtonErrorLoadingText: [{
            type: Input
        }], blueButtonBeneficiaryEmailDetails: [{
            type: Input
        }], blueButtonImportLatestPrescriptionButtonText: [{
            type: Input
        }], blueButtonImportLatestPrescriptionErrorText: [{
            type: Input
        }], blueButtonAccessDeniedText: [{
            type: Input
        }], blueButtonClaimDataLoadingErrorText: [{
            type: Input
        }], isPreferenceBannerEnabled: [{
            type: Input
        }], onSendEmail: [] }); })();

const _c0$2n = function (a0) { return { "background-image": a0 }; };
const _c1$19 = ["*"];
class ImageBannerContainerComponent {
    constructor() {
        this.bodyText = '';
        this.headerText = '';
        this.imageMobileUrl = '';
        this.imageUrl = '';
        this.headerFooterPrimaryClientLogo = '';
        this.headerFooterSecondaryClientLogo = '';
    }
}
ImageBannerContainerComponent.ɵfac = function ImageBannerContainerComponent_Factory(t) { return new (t || ImageBannerContainerComponent)(); };
ImageBannerContainerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ImageBannerContainerComponent, selectors: [["vnext-image-banner-container"]], inputs: { bodyText: "bodyText", headerText: "headerText", imageMobileUrl: "imageMobileUrl", imageUrl: "imageUrl", headerFooterPrimaryClientLogo: "headerFooterPrimaryClientLogo", headerFooterPrimaryClientLogoUrl: "headerFooterPrimaryClientLogoUrl", headerFooterSecondaryClientLogo: "headerFooterSecondaryClientLogo", headerFooterSecondaryClientLogoUrl: "headerFooterSecondaryClientLogoUrl" }, ngContentSelectors: _c1$19, decls: 10, vars: 13, consts: [[3, "headerType", "primaryLogo", "primaryLogoUrl", "secondaryLogo", "secondaryLogoUrl"], [1, "header-image-container"], ["vnextGoogleTagManager", "", 1, "header-image", "d-none", "d-sm-block", 3, "ngStyle"], ["vnextGoogleTagManager", "", 1, "header-image", "header-image-mobile", "d-block", "d-sm-none", 3, "ngStyle"], [1, "container"], [1, "header-text"], [1, "body-text"]], template: function ImageBannerContainerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelement(0, "vnext-dynamic-header", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "div", 2)(3, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4)(5, "h2", 5);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "p", 6);
        i0.ɵɵprojection(8);
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("headerType", "basic")("primaryLogo", ctx.headerFooterPrimaryClientLogo)("primaryLogoUrl", ctx.headerFooterPrimaryClientLogoUrl)("secondaryLogo", ctx.headerFooterSecondaryClientLogo)("secondaryLogoUrl", ctx.headerFooterSecondaryClientLogoUrl);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(9, _c0$2n, "url(" + ctx.imageUrl + ")"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(11, _c0$2n, "url(" + ctx.imageMobileUrl + ")"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.headerText);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.bodyText, " ");
    } }, dependencies: [i1$2.NgStyle, GoogleTagManagerDirective, DynamicHeaderComponent], styles: [".header-text[_ngcontent-%COMP%]{margin-top:30px}.header-image-container[_ngcontent-%COMP%]{position:relative;overflow-x:hidden}.header-image[_ngcontent-%COMP%]{background-size:cover;background-color:var(--static-Spa_Style_Gray1);background-position:center;background-repeat:no-repeat;height:450px;max-width:1400px;margin:0 auto}.header-image-mobile[_ngcontent-%COMP%]{height:300px}.header-image[_ngcontent-%COMP%]:after, .header-image[_ngcontent-%COMP%]:before{content:\"\";position:absolute;height:450px;width:500px}.header-image[_ngcontent-%COMP%]:after{left:-340px;background:linear-gradient(90deg,var(--static-Spa_Style_Gray1) 0%,var(--static-Spa_Style_Gray1) 76%,rgba(0,0,0,0) 100%)}.header-image[_ngcontent-%COMP%]:before{right:-340px;background:linear-gradient(270deg,var(--static-Spa_Style_Gray1) 0%,var(--static-Spa_Style_Gray1) 76%,rgba(0,0,0,0) 100%)}@media (max-width: 1399.98px){.header-image[_ngcontent-%COMP%]:after, .header-image[_ngcontent-%COMP%]:before{display:none}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImageBannerContainerComponent, [{
        type: Component,
        args: [{ selector: 'vnext-image-banner-container', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-dynamic-header\r\n  [headerType]=\"'basic'\"\r\n  [primaryLogo]=\"headerFooterPrimaryClientLogo\"\r\n  [primaryLogoUrl]=\"headerFooterPrimaryClientLogoUrl\"\r\n  [secondaryLogo]=\"headerFooterSecondaryClientLogo\"\r\n  [secondaryLogoUrl]=\"headerFooterSecondaryClientLogoUrl\"\r\n>\r\n</vnext-dynamic-header>\r\n<div class=\"header-image-container\">\r\n  <div class=\"header-image d-none d-sm-block\" vnextGoogleTagManager [ngStyle]=\"{ 'background-image': 'url(' + imageUrl + ')' }\"></div>\r\n  <div\r\n    class=\"header-image header-image-mobile d-block d-sm-none\"\r\n    vnextGoogleTagManager\r\n    [ngStyle]=\"{ 'background-image': 'url(' + imageMobileUrl + ')' }\"\r\n  ></div>\r\n</div>\r\n<div class=\"container\">\r\n  <h2 class=\"header-text\">{{ headerText }}</h2>\r\n  <p class=\"body-text\">\r\n    <ng-content></ng-content>\r\n    {{ bodyText }}\r\n  </p>\r\n</div>\r\n", styles: [".header-text{margin-top:30px}.header-image-container{position:relative;overflow-x:hidden}.header-image{background-size:cover;background-color:var(--static-Spa_Style_Gray1);background-position:center;background-repeat:no-repeat;height:450px;max-width:1400px;margin:0 auto}.header-image-mobile{height:300px}.header-image:after,.header-image:before{content:\"\";position:absolute;height:450px;width:500px}.header-image:after{left:-340px;background:linear-gradient(90deg,var(--static-Spa_Style_Gray1) 0%,var(--static-Spa_Style_Gray1) 76%,rgba(0,0,0,0) 100%)}.header-image:before{right:-340px;background:linear-gradient(270deg,var(--static-Spa_Style_Gray1) 0%,var(--static-Spa_Style_Gray1) 76%,rgba(0,0,0,0) 100%)}@media (max-width: 1399.98px){.header-image:after,.header-image:before{display:none}}\n"] }]
    }], null, { bodyText: [{
            type: Input
        }], headerText: [{
            type: Input
        }], imageMobileUrl: [{
            type: Input
        }], imageUrl: [{
            type: Input
        }], headerFooterPrimaryClientLogo: [{
            type: Input
        }], headerFooterPrimaryClientLogoUrl: [{
            type: Input
        }], headerFooterSecondaryClientLogo: [{
            type: Input
        }], headerFooterSecondaryClientLogoUrl: [{
            type: Input
        }] }); })();

/**
 * LARGE WARNING
 * Do not use this component as is in a template. It has its own providers as it currently works outside of a template.
 * If you use this in a template without refactoring something, your providers will be overwritten and something will mess up.
 */
let BrowserDeniedComponent = class BrowserDeniedComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, imageService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.imageService = imageService;
        this.Spa_BrowserDenied_Header_Image = 'phoenix/assets/images/Browser_Denied_Banner.png';
        this.Spa_BrowserDenied_HeaderMobile_Image = 'phoenix/assets/images/Browser_Denied_Banner_Small.jpg';
        this.Spa_BrowserDenied_Header_Text = `This browser is not supported.`;
        this.Spa_BrowserDenied_Body_Text = `Please try another browser.`;
        this.Spa_HeaderFooter_PrimaryClientLogo = '';
        this.Spa_HeaderFooter_PrimaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_HeaderFooter_SecondaryClientLogo = '';
        this.Spa_HeaderFooter_SecondaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
    }
    preProcessProperties() {
        this.browserDeniedHeaderImageUrl = this.imageService.resolveFullImagePath(this.Spa_BrowserDenied_Header_Image);
        this.browserDeniedHeaderImageMobileUrl = this.imageService.resolveFullImagePath(this.Spa_BrowserDenied_HeaderMobile_Image);
    }
};
BrowserDeniedComponent.ɵfac = function BrowserDeniedComponent_Factory(t) { return new (t || BrowserDeniedComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.ImageService)); };
BrowserDeniedComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BrowserDeniedComponent, selectors: [["vnext-browser-denied"]], features: [i0.ɵɵProvidersFeature([WidgetService, WidgetValidationService, ZoneService]), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 8, consts: [[3, "imageUrl", "imageMobileUrl", "headerText", "bodyText", "headerFooterPrimaryClientLogo", "headerFooterPrimaryClientLogoUrl", "headerFooterSecondaryClientLogo", "headerFooterSecondaryClientLogoUrl"]], template: function BrowserDeniedComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "vnext-image-banner-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("imageUrl", ctx.browserDeniedHeaderImageUrl)("imageMobileUrl", ctx.browserDeniedHeaderImageMobileUrl)("headerText", ctx.Spa_BrowserDenied_Header_Text)("bodyText", ctx.Spa_BrowserDenied_Body_Text)("headerFooterPrimaryClientLogo", ctx.Spa_HeaderFooter_PrimaryClientLogo)("headerFooterPrimaryClientLogoUrl", ctx.Spa_HeaderFooter_PrimaryClientLogo_Url)("headerFooterSecondaryClientLogo", ctx.Spa_HeaderFooter_SecondaryClientLogo)("headerFooterSecondaryClientLogoUrl", ctx.Spa_HeaderFooter_SecondaryClientLogo_Url);
    } }, dependencies: [ImageBannerContainerComponent], encapsulation: 2, changeDetection: 0 });
__decorate([
    GlobalResource(true)
], BrowserDeniedComponent.prototype, "Spa_BrowserDenied_Header_Image", void 0);
__decorate([
    GlobalResource(true)
], BrowserDeniedComponent.prototype, "Spa_BrowserDenied_HeaderMobile_Image", void 0);
__decorate([
    GlobalResource()
], BrowserDeniedComponent.prototype, "Spa_BrowserDenied_Header_Text", void 0);
__decorate([
    GlobalResource()
], BrowserDeniedComponent.prototype, "Spa_BrowserDenied_Body_Text", void 0);
__decorate([
    GlobalResource()
], BrowserDeniedComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo", void 0);
__decorate([
    GlobalResource()
], BrowserDeniedComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo_Url", void 0);
__decorate([
    GlobalResource()
], BrowserDeniedComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo", void 0);
__decorate([
    GlobalResource()
], BrowserDeniedComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo_Url", void 0);
BrowserDeniedComponent = __decorate([
    PlatformWidget
], BrowserDeniedComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BrowserDeniedComponent, [{
        type: Component,
        args: [{ selector: 'vnext-browser-denied', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService, WidgetValidationService, ZoneService], template: "<vnext-image-banner-container\r\n  [imageUrl]=\"browserDeniedHeaderImageUrl\"\r\n  [imageMobileUrl]=\"browserDeniedHeaderImageMobileUrl\"\r\n  [headerText]=\"Spa_BrowserDenied_Header_Text\"\r\n  [bodyText]=\"Spa_BrowserDenied_Body_Text\"\r\n  [headerFooterPrimaryClientLogo]=\"Spa_HeaderFooter_PrimaryClientLogo\"\r\n  [headerFooterPrimaryClientLogoUrl]=\"Spa_HeaderFooter_PrimaryClientLogo_Url\"\r\n  [headerFooterSecondaryClientLogo]=\"Spa_HeaderFooter_SecondaryClientLogo\"\r\n  [headerFooterSecondaryClientLogoUrl]=\"Spa_HeaderFooter_SecondaryClientLogo_Url\"\r\n></vnext-image-banner-container>" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.ImageService }]; }, { Spa_BrowserDenied_Header_Image: [], Spa_BrowserDenied_HeaderMobile_Image: [], Spa_BrowserDenied_Header_Text: [], Spa_BrowserDenied_Body_Text: [], Spa_HeaderFooter_PrimaryClientLogo: [], Spa_HeaderFooter_PrimaryClientLogo_Url: [], Spa_HeaderFooter_SecondaryClientLogo: [], Spa_HeaderFooter_SecondaryClientLogo_Url: [] }); })();

const _c0$2m = ["tooltipController"];
function CopyPurlPlusComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "i", 7);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.purlToConsumerAccountErrorText);
} }
function CopyPurlPlusComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "i", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.copiedInfoText, " ");
} }
class CopyPurlPlusComponent {
    constructor() {
        this.memberEmail = '';
        this.memberCellPhone = '';
        this.onCopyClick = new EventEmitter();
        this.showConsumerAccountError = false;
    }
    ngOnChanges(changes) {
        const { memberEmail, memberCellPhone } = changes;
        if ((memberEmail && memberEmail.previousValue !== memberEmail.currentValue) ||
            (memberCellPhone && memberCellPhone.previousValue !== memberCellPhone.currentValue)) {
            this.validateEmailAndCellPhone();
        }
    }
    validateEmailAndCellPhone() {
        if (this.memberEmail || this.memberCellPhone) {
            this.showConsumerAccountError = false;
        }
    }
    copyPurl() {
        if (this.memberEmail || this.memberCellPhone) {
            this.showConsumerAccountError = false;
            this.onCopyClick.emit();
            this.ngbToolTip.open();
        }
        else {
            this.showConsumerAccountError = true;
            this.ngbToolTip.close();
        }
    }
}
CopyPurlPlusComponent.ɵfac = function CopyPurlPlusComponent_Factory(t) { return new (t || CopyPurlPlusComponent)(); };
CopyPurlPlusComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CopyPurlPlusComponent, selectors: [["vnext-copy-purl-plus"]], viewQuery: function CopyPurlPlusComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$2m, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ngbToolTip = _t.first);
    } }, inputs: { purlToConsumerAccountButtonText: "purlToConsumerAccountButtonText", purlToConsumerAccountErrorText: "purlToConsumerAccountErrorText", copiedInfoText: "copiedInfoText", memberEmail: "memberEmail", memberCellPhone: "memberCellPhone" }, outputs: { onCopyClick: "onCopyClick" }, features: [i0.ɵɵNgOnChangesFeature], decls: 8, vars: 3, consts: [[1, "mt-4"], ["class", "error-container w-100 mb-1 d-flex align-items-baseline", 4, "ngIf"], ["placement", "top", "triggers", "manual", 1, "btn", "Spa_Style_SecondaryButton", "col-xs-12", "col-md-auto", "col-lg-auto", "w-100", 3, "ngbTooltip", "click", "keyup.enter"], ["tooltipController", "ngbTooltip"], [1, "fas", "fa-copy", "mr-2"], ["tooltip", ""], [1, "error-container", "w-100", "mb-1", "d-flex", "align-items-baseline"], [1, "fas", "fa-exclamation-circle"], [1, "text-center", "success"], ["aria-hidden", "true", 1, "fas", "fa-check-circle"]], template: function CopyPurlPlusComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, CopyPurlPlusComponent_div_1_Template, 4, 1, "div", 1);
        i0.ɵɵelementStart(2, "button", 2, 3);
        i0.ɵɵlistener("click", function CopyPurlPlusComponent_Template_button_click_2_listener() { return ctx.copyPurl(); })("keyup.enter", function CopyPurlPlusComponent_Template_button_keyup_enter_2_listener() { return ctx.copyPurl(); });
        i0.ɵɵelement(4, "i", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, CopyPurlPlusComponent_ng_template_6_Template, 3, 1, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(7);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showConsumerAccountError);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngbTooltip", _r2);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1("", ctx.purlToConsumerAccountButtonText, " ");
    } }, dependencies: [i1$2.NgIf, IconAriaAttributesDirective, i1$1.NgbTooltip], styles: [".success[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CopyPurlPlusComponent, [{
        type: Component,
        args: [{ selector: 'vnext-copy-purl-plus', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"mt-4\">\r\n  <div *ngIf=\"showConsumerAccountError\" class=\"error-container w-100 mb-1 d-flex align-items-baseline\">\r\n    <i class=\"fas fa-exclamation-circle\"></i><span>{{ purlToConsumerAccountErrorText }}</span>\r\n  </div>\r\n  <button\r\n    class=\"btn Spa_Style_SecondaryButton col-xs-12 col-md-auto col-lg-auto w-100\"\r\n    (click)=\"copyPurl()\"\r\n    (keyup.enter)=\"copyPurl()\"\r\n    placement=\"top\"\r\n    [ngbTooltip]=\"tooltip\"\r\n    triggers=\"manual\"\r\n    #tooltipController=\"ngbTooltip\"\r\n  >\r\n    <i class=\"fas fa-copy mr-2\"></i>{{ purlToConsumerAccountButtonText }}\r\n  </button>\r\n  <ng-template #tooltip>\r\n    <div class=\"text-center success\">\r\n      <i class=\"fas fa-check-circle\" aria-hidden=\"true\"></i>\r\n      {{ copiedInfoText }}\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n", styles: [".success{color:var(--static-Spa_Style_Cost_Text)}\n"] }]
    }], null, { purlToConsumerAccountButtonText: [{
            type: Input
        }], purlToConsumerAccountErrorText: [{
            type: Input
        }], copiedInfoText: [{
            type: Input
        }], memberEmail: [{
            type: Input
        }], memberCellPhone: [{
            type: Input
        }], onCopyClick: [{
            type: Output
        }], ngbToolTip: [{
            type: ViewChild,
            args: ['tooltipController']
        }] }); })();

function DemographicComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 9)(2, "vnext-personalized-video", 10);
    i0.ɵɵlistener("handleCallToAction", function DemographicComponent_ng_container_2_Template_vnext_personalized_video_handleCallToAction_2_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.handleCallToAction($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("videoURL", ctx_r0.Spa_PersonalizedVideo_ConsumerHome_URL)("iframeTitle", ctx_r0.Spa_PersonalizedVideo_ConsumerHome_FrameTitle);
} }
const _c0$2l = function (a0) { return { "background-image": a0 }; };
function DemographicComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 11)(1, "div", 12);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(2, _c0$2l, "url(" + ctx_r2.Spa_Demographic_Background_UrlMobile + ")"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(4, _c0$2l, "url(" + ctx_r2.Spa_Demographic_Background_Url + ")"));
} }
function DemographicComponent_h1_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h1", 13);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r3.Spa_Demographic_MainHeader_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function DemographicComponent_p_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 14);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r4.Spa_Demographic_SecondaryHeader_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function DemographicComponent_ng_template_12_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function DemographicComponent_ng_template_12_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.viewPlansOnClick()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.Spa_Demographic_Button_Text, " ");
} }
function DemographicComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, DemographicComponent_ng_template_12_button_0_Template, 2, 1, "button", 15);
} if (rf & 2) {
    i0.ɵɵproperty("liveEditProp", "Spa_Demographic_Button_Text");
} }
const _c1$18 = function (a0) { return { "personalized-video-banner": a0 }; };
const _c2$G = function (a0) { return { "personalized-video-widget": a0 }; };
let DemographicComponent = class DemographicComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, configResourceService, demographicService, analyticsService, imageService, siteService, helpfulToolsService, store, router, memberSessionService, localeService, weglotService, ssoPopulatedFieldService, speakWithAgentFacade, guidedHelpService, planYearResourceService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.configResourceService = configResourceService;
        this.demographicService = demographicService;
        this.analyticsService = analyticsService;
        this.imageService = imageService;
        this.siteService = siteService;
        this.helpfulToolsService = helpfulToolsService;
        this.store = store;
        this.router = router;
        this.memberSessionService = memberSessionService;
        this.localeService = localeService;
        this.weglotService = weglotService;
        this.ssoPopulatedFieldService = ssoPopulatedFieldService;
        this.speakWithAgentFacade = speakWithAgentFacade;
        this.guidedHelpService = guidedHelpService;
        this.planYearResourceService = planYearResourceService;
        this.Spa_Demographic_Button_Text = 'View Plans';
        this.Spa_Demographic_MainHeader_Text = 'Get covered.';
        this.Spa_Demographic_SecondaryHeader_Text = 'Medicare made easy so you can get back to the things you love.';
        this.Spa_Demographic_Background_Url = 'phoenix/assets/images/making_pasta.jpg';
        this.Spa_Demographic_Background_UrlMobile = 'phoenix/assets/images/making_pasta_mobile.jpg';
        this.Spa_Demographic_Background_Color = '#f5f5f5';
        this.Spa_Site_ErrorKeyword_Text = 'Error:';
        this.Spa_ZipCodeInput_CountyLabel_Text = 'County';
        this.Spa_ZipCodeInput_CountyLabel_Enabled = false;
        this.Spa_Site_ZipCodeInput_EditCounty_Description = 'Edit County';
        this.Spa_Site_SiteType = 'consumer';
        this.AppID = 0;
        this.Spa_PersonalizedVideo_Enabled = false;
        this.Spa_PersonalizedVideo_ConsumerHome_Enabled = false;
        this.Spa_PersonalizedVideo_ConsumerHome_URL = '';
        this.Spa_PersonalizedVideo_ConsumerHome_FrameTitle = 'Review plan types available to you, what to expect when paying for services, and how to enter preferences to help estimate costs';
        this.zipCodeInputSelectedCountyEnabled = true;
        this.checkFocus = false;
        this.homePersonalizedVideoEnabled = false;
    }
    async viewPlansOnClick() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_HOME_VIEW_PLANS);
        // If we have errors set checkFocus to true and navigate.
        if (this.widgetValidationService.validate().length === 0) {
            const fips = this.demographicService.getSelectedFipsCode();
            const zip = this.demographicService.getSelectedZipCode();
            if (zip && fips) {
                this.demographicService.updateDemographicSession();
            }
        }
        else {
            this.checkFocus = true;
        }
        this.configurableWidgetService.navigationService.navigate({
            title: '',
            type: LinkType.INTERNAL,
            tag: PageTags.PLAN_LIST,
            validateWidgets: true
        });
    }
    ngOnInit() {
        super.ngOnInit();
        this.zipCode$ = this.demographicService.getSelectedZipCode$();
        this.fipsCode$ = this.demographicService.getSelectedFipsCode$();
        const selectedCountyEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_ZipCodeInput_SelectedCountyEnabled');
        this.zipCodeInputSelectedCountyEnabled = selectedCountyEnabled === null ? true : JSON.parse(selectedCountyEnabled);
        this.homePersonalizedVideoEnabled = this.isPersonalizedVideoEnabled();
        this.subscriptions = [
            this.loading$.subscribe({
                next: loading => {
                    loading
                        ? this.configurableWidgetService.spinnerService.show(SpinnerEvent.DEMOGRAPHICS_LOADING)
                        : this.configurableWidgetService.spinnerService.hide(SpinnerEvent.DEMOGRAPHICS_LOADING);
                }
            }),
            this.demographicService.getSessionLoadedStatus$().subscribe({
                next: loaded => {
                    if (!loaded) {
                        this.demographicService.updateDemographicSession();
                    }
                    else {
                        this.updateGoogleTags();
                    }
                }
            }),
            this.localeService.getCurrentLocale$().subscribe({
                next: () => {
                    this.zipCodeInputZipCodeError =
                        this.configResourceService.getProcessedResourceValue('Spa_Site_ZipCodeInput_ZipCodeError') || 'Zip code is invalid';
                    this.zipCodeInputCountyError =
                        this.configResourceService.getProcessedResourceValue('Spa_Site_ZipCodeInput_CountyError') || 'Please select your county';
                    this.zipCodeInputSelectCounty =
                        this.configResourceService.getProcessedResourceValue('Spa_Site_ZipCodeInput_SelectCounty') || 'Select county';
                    this.zipCodeInputZipCodeLabel =
                        this.configResourceService.getProcessedResourceValue('Spa_Site_ZipCodeInput_ZipCodeLabel') || 'Zip code';
                    this.zipCodeInputEditCounty = this.configResourceService.getProcessedResourceValue('Spa_Site_ZipCodeInput_EditCounty') || 'Edit';
                    this.cdr.markForCheck();
                }
            })
        ];
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.forEach(sub => {
            sub.unsubscribe();
        });
    }
    ngAfterViewChecked() {
        if (this.checkFocus) {
            const invalidZipFormInput = document.querySelector('input.has-error');
            const invalidZipFormInputFormElement = invalidZipFormInput;
            const invalidCountyFormInput = document.querySelector('.county-error .county-dropdown-item');
            const invalidCountyFormInputElement = invalidCountyFormInput;
            if (invalidZipFormInputFormElement) {
                invalidZipFormInputFormElement.focus();
            }
            if (invalidCountyFormInputElement) {
                invalidCountyFormInputElement.focus();
            }
            this.checkFocus = false;
        }
    }
    updateZip(zip) {
        this.demographicService.setZipCode(zip);
        this.updateHelpfulToolsDemographics();
    }
    updateFips(fips) {
        this.demographicService.setFipsCode(fips);
        this.updateHelpfulToolsDemographics();
    }
    handleCallToAction(event) {
        const eventData = event?.data ? JSON.parse(event.data) : {};
        if (eventData.event === SmartVXEventType.GUIDED_HELP) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PERSONALIZED_VIDEO_HOME_ENTER_PREFERENCES);
        }
        else if (eventData.event === SmartVXEventType.CONTACT_US) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PERSONALIZED_VIDEO_CONTACT_US);
        }
    }
    updateHelpfulToolsDemographics() {
        if (this.widgetValidationService.validate().length === 0) {
            const fips = this.demographicService.getSelectedFipsCode();
            const zip = this.demographicService.getSelectedZipCode();
            if (zip && fips) {
                this.helpfulToolsService.selectLocation(zip, fips);
            }
        }
    }
    async updateGoogleTags() {
        const isRetentionView = this.siteService.isRetentionView();
        if (isRetentionView) {
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
                [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE
            };
        }
        else {
            const siteType = this.Spa_Site_SiteType;
            const appId = this.AppID.toString();
            const googleDataLayerTagsToUpdate = {};
            const memberSession = this.memberSessionService.getMemberSession();
            const agentUserName = this.store.selectSnapshot(AgentState.userName);
            const userName = agentUserName || memberSession.userName;
            const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
            const agentIsProfileAdmin = this.store.selectSnapshot(AgentState.agentIsProfileAdmin);
            const providers = this.configurableWidgetService.store.selectSnapshot(ProviderState.selectedProviders);
            const isPPCSite = this.siteService.isPPCSite(siteType);
            const googleTagManagerNotApplicableText = this.analyticsService.getGoogleTagManagerNotApplicableText();
            if (agentGuid) {
                googleDataLayerTagsToUpdate[DataLayerGlobalVariable.AGENT_GUID] = agentGuid;
            }
            if (agentIsProfileAdmin) {
                googleDataLayerTagsToUpdate[DataLayerGlobalVariable.AGENT_IS_PROFILE_ADMIN] = agentIsProfileAdmin;
            }
            if (memberSession?.memberID) {
                googleDataLayerTagsToUpdate[DataLayerGlobalVariable.MEMBER_ID] = memberSession.memberID;
            }
            if (!isPPCSite) {
                googleDataLayerTagsToUpdate[DataLayerGlobalVariable.MEMBER_ASSIST_CODE] =
                    this.speakWithAgentFacade.getUniqueCode() || googleTagManagerNotApplicableText;
            }
            const externalMemberId = this.store.selectSnapshot(DeepLinkingParamsState.ssoValue);
            const externalReferenceId = this.store.selectSnapshot(DeepLinkingParamsState.pegi);
            const selectedCoverageType = this.store.selectSnapshot(GuidedHelpState.selectedCoverageType);
            const selectedSubsidy = this.store.selectSnapshot(DemographicState.subsidySelected);
            const selectedSubsidyPercent = this.store.selectSnapshot(DemographicState.subsidyPercent);
            const subsidyValue = selectedSubsidyPercent || selectedSubsidy;
            const drugsCount = this.store.selectSnapshot(MedicineCabinetState.medicineCabinet)?.length;
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.SITE_ID]: this.store.selectSnapshot(AppConfigState.shortSiteId),
                [DataLayerGlobalVariable.SITE_CHANNEL]: siteType,
                [DataLayerGlobalVariable.SITE_URL]: this.analyticsService.getBaseUrl(),
                [DataLayerGlobalVariable.EXTERNAL_MEMBER_ID]: externalMemberId || googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.EXTERNAL_REFERENCE_ID]: externalReferenceId || googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.LANGUAGE_ID]: this.weglotService.getCurrentWeglotLocaleOrDefault(),
                [DataLayerGlobalVariable.CLIENT_ID]: this.memberSessionService.getClientId(),
                [DataLayerGlobalVariable.CLIENT_GAID]: this.configResourceService.getProcessedResourceValue('GoogleAnalyticsClientPropertyID'),
                [DataLayerGlobalVariable.APP_SESSION_ID]: memberSession ? memberSession.sessionId : null,
                [DataLayerGlobalVariable.USER_NAME]: userName || null,
                [DataLayerGlobalVariable.USER_ID_METHOD]: this.memberSessionService.getAuthType(),
                [DataLayerGlobalVariable.COUNTY_FIPS]: memberSession.demographic.fips,
                [DataLayerGlobalVariable.ZIP]: memberSession.demographic.zip,
                [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
                [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE,
                [DataLayerGlobalVariable.APP_ID]: appId,
                [DataLayerGlobalVariable.MEMBER_PREF_HEALTH]: this.guidedHelpService.getMemberPreferencesHealthAnalyticsValue(this.store.selectSnapshot(DemographicState.healthStatus)),
                [DataLayerGlobalVariable.MEMBER_PREF_AGE]: this.guidedHelpService.getMemberPreferenceAgeAnalyticsValue(this.store.selectSnapshot(DemographicState.ageRange)),
                [DataLayerGlobalVariable.MEMBER_PREF_SUBSIDY]: this.getSubsidyAnalyticsValue(selectedCoverageType, subsidyValue),
                [DataLayerGlobalVariable.MEMBER_PREF_COVERAGE]: this.guidedHelpService.getMemberPreferenceCoverageAnalyticsValue(selectedCoverageType),
                [DataLayerGlobalVariable.DRUG_COUNT]: drugsCount ? `${drugsCount}` : NO_DRUGS_COUNT,
                [DataLayerGlobalVariable.PROVIDER_COUNT]: providers?.length ? providers.length.toString() : '0',
                [DataLayerGlobalVariable.PERSONALIZED_VIDEO_IS_PRESENT]: this.isPersonalizedVideoEnabled()
                    ? GOOGLE_ANALYTICS_YES
                    : GOOGLE_ANALYTICS_NO,
                [DataLayerGlobalVariable.SITE_PLAN_YEAR]: this.planYearResourceService.getSelectedPlanYear(),
                ...googleDataLayerTagsToUpdate
            };
        }
    }
    getSubsidyAnalyticsValue(selectedCoverageType, subsidyValue) {
        const coverageTypeAnalyticsValue = this.guidedHelpService.getMemberPreferenceCoverageAnalyticsValue(selectedCoverageType);
        return coverageTypeAnalyticsValue === 'MA' ? '' : this.guidedHelpService.getMemberPreferenceSubsidyAnalyticsValue(subsidyValue);
    }
    isPersonalizedVideoEnabled() {
        return !!(this.Spa_PersonalizedVideo_Enabled &&
            this.Spa_PersonalizedVideo_ConsumerHome_Enabled &&
            this.Spa_PersonalizedVideo_ConsumerHome_URL);
    }
};
DemographicComponent.ɵfac = function DemographicComponent_Factory(t) { return new (t || DemographicComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.DemographicService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.ImageService), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(HelpfulToolsService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.WeglotService), i0.ɵɵdirectiveInject(i1.SSOPopulatedFieldService), i0.ɵɵdirectiveInject(SpeakWithAgentFacade), i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(i1.PlanYearResourceService)); };
DemographicComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DemographicComponent, selectors: [["vnext-widget-demographic"]], features: [i0.ɵɵProvidersFeature([WidgetService] // provides widget data to components down the tree
        ), i0.ɵɵInheritDefinitionFeature], decls: 14, vars: 29, consts: [[1, "demographic-wrapper", "Spa_Style_Banner_Background"], [1, "banner", "container", 3, "ngClass"], [4, "ngIf", "ngIfElse"], ["backgroundImage", ""], [1, "demographic-widget", 3, "ngClass"], ["class", "Spa_Style_H1", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["class", "Spa_Style_Paragraph mb-0", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [3, "defaultZipCode", "defaultFipsCode", "selectedCountyEnabled", "zipCodeErrorText", "countyErrorText", "selectCountyText", "zipCodeText", "editCountyText", "searchButtonTemplate", "errorKeywordText", "isReadOnly", "countyLabel", "showCountyLabel", "zip", "fips", "onEnterClick"], ["zipcodeButton", ""], [1, "personalized-video-wrapper"], [3, "videoURL", "iframeTitle", "handleCallToAction"], [1, "background-img", "d-block", "d-md-none", 3, "ngStyle"], [1, "background-img", "mobile", "d-none", "d-md-block", 3, "ngStyle"], ["navigationAdapter", "", 1, "Spa_Style_H1", 3, "innerHtml"], ["navigationAdapter", "", 1, "Spa_Style_Paragraph", "mb-0", 3, "innerHtml"], ["class", "btn Spa_Style_PrimaryButton demographic-button", 3, "click", 4, "liveEditProp"], [1, "btn", "Spa_Style_PrimaryButton", "demographic-button", 3, "click"]], template: function DemographicComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, DemographicComponent_ng_container_2_Template, 3, 2, "ng-container", 2);
        i0.ɵɵtemplate(3, DemographicComponent_ng_template_3_Template, 2, 6, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵtemplate(6, DemographicComponent_h1_6_Template, 2, 4, "h1", 5);
        i0.ɵɵtemplate(7, DemographicComponent_p_7_Template, 2, 4, "p", 6);
        i0.ɵɵelementStart(8, "vnext-zip-code-input", 7);
        i0.ɵɵlistener("zip", function DemographicComponent_Template_vnext_zip_code_input_zip_8_listener($event) { return ctx.updateZip($event); })("fips", function DemographicComponent_Template_vnext_zip_code_input_fips_8_listener($event) { return ctx.updateFips($event); })("onEnterClick", function DemographicComponent_Template_vnext_zip_code_input_onEnterClick_8_listener() { return ctx.viewPlansOnClick(); });
        i0.ɵɵpipe(9, "async");
        i0.ɵɵpipe(10, "async");
        i0.ɵɵpipe(11, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, DemographicComponent_ng_template_12_Template, 1, 1, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(4);
        const _r5 = i0.ɵɵreference(13);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(25, _c1$18, ctx.homePersonalizedVideoEnabled));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.homePersonalizedVideoEnabled)("ngIfElse", _r1);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(27, _c2$G, ctx.homePersonalizedVideoEnabled));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_Demographic_MainHeader_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_Demographic_SecondaryHeader_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("defaultZipCode", i0.ɵɵpipeBind1(9, 19, ctx.zipCode$))("defaultFipsCode", i0.ɵɵpipeBind1(10, 21, ctx.fipsCode$))("selectedCountyEnabled", ctx.zipCodeInputSelectedCountyEnabled)("zipCodeErrorText", ctx.zipCodeInputZipCodeError)("countyErrorText", ctx.zipCodeInputCountyError)("selectCountyText", ctx.zipCodeInputSelectCounty)("zipCodeText", ctx.zipCodeInputZipCodeLabel)("editCountyText", ctx.zipCodeInputEditCounty)("searchButtonTemplate", _r5)("errorKeywordText", ctx.Spa_Site_ErrorKeyword_Text)("isReadOnly", i0.ɵɵpipeBind1(11, 23, ctx.ssoPopulatedFieldService.isFieldReadOnly$("Demographic.ZipCode")))("countyLabel", ctx.Spa_ZipCodeInput_CountyLabel_Text)("showCountyLabel", ctx.Spa_ZipCodeInput_CountyLabel_Enabled);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$2.NgStyle, ZipCodeInputComponent, NavigationAdapterDirective, LiveEditPropDirective, PersonalizedVideoComponent, i1$2.AsyncPipe, SafePipe], styles: [".banner[_ngcontent-%COMP%]{width:100%;height:auto;max-height:650px;min-height:450px;margin-top:0;padding-top:100px;position:relative}.background-img[_ngcontent-%COMP%]{position:absolute;left:0;top:0;width:100%;height:100%;background-repeat:no-repeat;background-size:cover;background-position:50% 50%}.demographic-widget[_ngcontent-%COMP%]{width:300px;position:relative}.demographic-button[_ngcontent-%COMP%]{border-bottom-left-radius:0;border-top-left-radius:0}.personalized-video-widget[_ngcontent-%COMP%]{padding-top:75px}.personalized-video-wrapper[_ngcontent-%COMP%]{width:533.33px;height:350px;background-size:cover;padding-top:25px;padding-bottom:25px}.personalized-video-banner[_ngcontent-%COMP%]{display:flex;flex-direction:row-reverse;justify-content:space-between;padding-top:0}.banner.personalized-video-banner[_ngcontent-%COMP%]{min-height:350px}@media (min-width: 768px) and (max-width: 1024px){.background-img-test[_ngcontent-%COMP%]{background-size:cover}.banner[_ngcontent-%COMP%]{height:600px;display:flex;flex-direction:column-reverse}.banner.personalized-video-banner[_ngcontent-%COMP%]{height:auto}.demographic-widget[_ngcontent-%COMP%]{padding-bottom:15px}.personalized-video-banner[_ngcontent-%COMP%]{flex-direction:column;max-height:850px;padding-left:0;padding-right:0}.personalized-video-wrapper[_ngcontent-%COMP%]{width:100%;height:100%;padding-top:0;padding-bottom:0}.personalized-video-widget[_ngcontent-%COMP%]{padding-top:0}.personalized-video-banner[_ngcontent-%COMP%]   .demographic-widget[_ngcontent-%COMP%]{padding-left:20px;padding-right:20px;margin-top:1.5rem}}@media (max-width: 768px){.background-img[_ngcontent-%COMP%]{background-position:top center;background-size:auto}.banner[_ngcontent-%COMP%]{height:600px;display:flex;flex-direction:column-reverse}.banner.personalized-video-banner[_ngcontent-%COMP%]{height:auto}.demographic-widget[_ngcontent-%COMP%]{width:100%;padding-bottom:15px}.personalized-video-wrapper[_ngcontent-%COMP%]{width:100%;height:100%;padding-top:0;padding-bottom:0}.personalized-video-banner[_ngcontent-%COMP%]{flex-direction:column;justify-content:initial;padding-left:0;padding-right:0}.personalized-video-widget[_ngcontent-%COMP%]{padding-top:0}.personalized-video-banner[_ngcontent-%COMP%]   .demographic-widget[_ngcontent-%COMP%]{padding-left:20px;padding-right:20px;margin-top:1.5rem}}"], changeDetection: 0 });
__decorate([
    Select(DemographicState.loading)
], DemographicComponent.prototype, "loading$", void 0);
__decorate([
    PlatformProp('live-edit')
], DemographicComponent.prototype, "Spa_Demographic_Button_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], DemographicComponent.prototype, "Spa_Demographic_MainHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], DemographicComponent.prototype, "Spa_Demographic_SecondaryHeader_Text", void 0);
__decorate([
    PlatformProp()
], DemographicComponent.prototype, "Spa_Demographic_Background_Url", void 0);
__decorate([
    PlatformProp()
], DemographicComponent.prototype, "Spa_Demographic_Background_UrlMobile", void 0);
__decorate([
    PlatformProp()
], DemographicComponent.prototype, "Spa_Demographic_Background_Color", void 0);
__decorate([
    GlobalResource()
], DemographicComponent.prototype, "Spa_Site_ErrorKeyword_Text", void 0);
__decorate([
    GlobalResource()
], DemographicComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Text", void 0);
__decorate([
    GlobalResource()
], DemographicComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Enabled", void 0);
__decorate([
    GlobalResource()
], DemographicComponent.prototype, "Spa_Site_ZipCodeInput_EditCounty_Description", void 0);
__decorate([
    GlobalResource()
], DemographicComponent.prototype, "Spa_Site_SiteType", void 0);
__decorate([
    GlobalResource()
], DemographicComponent.prototype, "AppID", void 0);
__decorate([
    GlobalResource()
], DemographicComponent.prototype, "Spa_PersonalizedVideo_Enabled", void 0);
__decorate([
    GlobalResource()
], DemographicComponent.prototype, "Spa_PersonalizedVideo_ConsumerHome_Enabled", void 0);
__decorate([
    GlobalResource()
], DemographicComponent.prototype, "Spa_PersonalizedVideo_ConsumerHome_URL", void 0);
__decorate([
    GlobalResource()
], DemographicComponent.prototype, "Spa_PersonalizedVideo_ConsumerHome_FrameTitle", void 0);
__decorate([
    LiveEditInactive()
], DemographicComponent.prototype, "viewPlansOnClick", null);
DemographicComponent = __decorate([
    PlatformWidget
], DemographicComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DemographicComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-demographic', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService] // provides widget data to components down the tree
                , template: "<div class=\"demographic-wrapper Spa_Style_Banner_Background\">\r\n  <div class=\"banner container\" [ngClass]=\"{ 'personalized-video-banner': homePersonalizedVideoEnabled }\">\r\n    <ng-container *ngIf=\"homePersonalizedVideoEnabled; else backgroundImage\">\r\n      <div class=\"personalized-video-wrapper\">\r\n        <vnext-personalized-video\r\n          [videoURL]=\"Spa_PersonalizedVideo_ConsumerHome_URL\"\r\n          [iframeTitle]=\"Spa_PersonalizedVideo_ConsumerHome_FrameTitle\"\r\n          (handleCallToAction)=\"handleCallToAction($event)\"\r\n        ></vnext-personalized-video>\r\n      </div>\r\n    </ng-container>\r\n    <ng-template #backgroundImage>\r\n      <div\r\n        class=\"background-img d-block d-md-none\"\r\n        [ngStyle]=\"{ 'background-image': 'url(' + Spa_Demographic_Background_UrlMobile + ')' }\"\r\n      ></div>\r\n      <div\r\n        class=\"background-img mobile d-none d-md-block\"\r\n        [ngStyle]=\"{ 'background-image': 'url(' + Spa_Demographic_Background_Url + ')' }\"\r\n      ></div>\r\n    </ng-template>\r\n    <div class=\"demographic-widget\" [ngClass]=\"{ 'personalized-video-widget': homePersonalizedVideoEnabled }\">\r\n      <h1\r\n        *liveEditProp=\"'Spa_Demographic_MainHeader_Text'\"\r\n        class=\"Spa_Style_H1\"\r\n        [innerHtml]=\"Spa_Demographic_MainHeader_Text | safe : 'html'\"\r\n        navigationAdapter\r\n      ></h1>\r\n      <p\r\n        *liveEditProp=\"'Spa_Demographic_SecondaryHeader_Text'\"\r\n        class=\"Spa_Style_Paragraph mb-0\"\r\n        [innerHtml]=\"Spa_Demographic_SecondaryHeader_Text | safe : 'html'\"\r\n        navigationAdapter\r\n      ></p>\r\n      <vnext-zip-code-input\r\n        [defaultZipCode]=\"zipCode$ | async\"\r\n        [defaultFipsCode]=\"fipsCode$ | async\"\r\n        [selectedCountyEnabled]=\"zipCodeInputSelectedCountyEnabled\"\r\n        [zipCodeErrorText]=\"zipCodeInputZipCodeError\"\r\n        [countyErrorText]=\"zipCodeInputCountyError\"\r\n        [selectCountyText]=\"zipCodeInputSelectCounty\"\r\n        [zipCodeText]=\"zipCodeInputZipCodeLabel\"\r\n        [editCountyText]=\"zipCodeInputEditCounty\"\r\n        [searchButtonTemplate]=\"zipcodeButton\"\r\n        (zip)=\"updateZip($event)\"\r\n        (fips)=\"updateFips($event)\"\r\n        [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n        [isReadOnly]=\"ssoPopulatedFieldService.isFieldReadOnly$('Demographic.ZipCode') | async\"\r\n        [countyLabel]=\"Spa_ZipCodeInput_CountyLabel_Text\"\r\n        [showCountyLabel]=\"Spa_ZipCodeInput_CountyLabel_Enabled\"\r\n        (onEnterClick)=\"viewPlansOnClick()\"\r\n      >\r\n      </vnext-zip-code-input>\r\n      <ng-template #zipcodeButton>\r\n        <button\r\n          *liveEditProp=\"'Spa_Demographic_Button_Text'\"\r\n          class=\"btn Spa_Style_PrimaryButton demographic-button\"\r\n          (click)=\"viewPlansOnClick()\"\r\n        >\r\n          {{ Spa_Demographic_Button_Text }}\r\n        </button>\r\n      </ng-template>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".banner{width:100%;height:auto;max-height:650px;min-height:450px;margin-top:0;padding-top:100px;position:relative}.background-img{position:absolute;left:0;top:0;width:100%;height:100%;background-repeat:no-repeat;background-size:cover;background-position:50% 50%}.demographic-widget{width:300px;position:relative}.demographic-button{border-bottom-left-radius:0;border-top-left-radius:0}.personalized-video-widget{padding-top:75px}.personalized-video-wrapper{width:533.33px;height:350px;background-size:cover;padding-top:25px;padding-bottom:25px}.personalized-video-banner{display:flex;flex-direction:row-reverse;justify-content:space-between;padding-top:0}.banner.personalized-video-banner{min-height:350px}@media (min-width: 768px) and (max-width: 1024px){.background-img-test{background-size:cover}.banner{height:600px;display:flex;flex-direction:column-reverse}.banner.personalized-video-banner{height:auto}.demographic-widget{padding-bottom:15px}.personalized-video-banner{flex-direction:column;max-height:850px;padding-left:0;padding-right:0}.personalized-video-wrapper{width:100%;height:100%;padding-top:0;padding-bottom:0}.personalized-video-widget{padding-top:0}.personalized-video-banner .demographic-widget{padding-left:20px;padding-right:20px;margin-top:1.5rem}}@media (max-width: 768px){.background-img{background-position:top center;background-size:auto}.banner{height:600px;display:flex;flex-direction:column-reverse}.banner.personalized-video-banner{height:auto}.demographic-widget{width:100%;padding-bottom:15px}.personalized-video-wrapper{width:100%;height:100%;padding-top:0;padding-bottom:0}.personalized-video-banner{flex-direction:column;justify-content:initial;padding-left:0;padding-right:0}.personalized-video-widget{padding-top:0}.personalized-video-banner .demographic-widget{padding-left:20px;padding-right:20px;margin-top:1.5rem}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.ConfigResourceService }, { type: i1.DemographicService }, { type: AnalyticsService }, { type: i1.ImageService }, { type: i1.SiteService }, { type: HelpfulToolsService }, { type: i2.Store }, { type: i2$1.Router }, { type: i1.MemberSessionService }, { type: i1.LocaleService }, { type: i1.WeglotService }, { type: i1.SSOPopulatedFieldService }, { type: SpeakWithAgentFacade }, { type: i1.GuidedHelpService }, { type: i1.PlanYearResourceService }]; }, { loading$: [], Spa_Demographic_Button_Text: [], Spa_Demographic_MainHeader_Text: [], Spa_Demographic_SecondaryHeader_Text: [], Spa_Demographic_Background_Url: [], Spa_Demographic_Background_UrlMobile: [], Spa_Demographic_Background_Color: [], Spa_Site_ErrorKeyword_Text: [], Spa_ZipCodeInput_CountyLabel_Text: [], Spa_ZipCodeInput_CountyLabel_Enabled: [], Spa_Site_ZipCodeInput_EditCounty_Description: [], Spa_Site_SiteType: [], AppID: [], Spa_PersonalizedVideo_Enabled: [], Spa_PersonalizedVideo_ConsumerHome_Enabled: [], Spa_PersonalizedVideo_ConsumerHome_URL: [], Spa_PersonalizedVideo_ConsumerHome_FrameTitle: [], viewPlansOnClick: [] }); })();

const _c0$2k = ["pageDisclaimer"];
function DisclaimerSectionComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 1, 2);
    i0.ɵɵpipe(2, "safe");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.disclaimerHtmlText ? i0.ɵɵpipeBind2(2, 1, ctx_r0.disclaimerHtmlText, "html") : "", i0.ɵɵsanitizeHtml);
} }
class DisclaimerSectionComponent {
    constructor(htmlUtilityService) {
        this.htmlUtilityService = htmlUtilityService;
    }
    set disclaimerText(value) {
        this._pageDisclaimerText = value ?
            this.htmlUtilityService.applyClassToElement(this.htmlUtilityService.convertStringToHtml(value), 'Spa_Style_Link', 'a').innerHTML : '';
    }
    get disclaimerHtmlText() {
        return this._pageDisclaimerText;
    }
}
DisclaimerSectionComponent.ɵfac = function DisclaimerSectionComponent_Factory(t) { return new (t || DisclaimerSectionComponent)(i0.ɵɵdirectiveInject(i1.HtmlUtilityService)); };
DisclaimerSectionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DisclaimerSectionComponent, selectors: [["vnext-disclaimer-section"]], viewQuery: function DisclaimerSectionComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$2k, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pageDisclaimer = _t.first);
    } }, inputs: { disclaimerText: "disclaimerText" }, decls: 1, vars: 1, consts: [["class", "Spa_Style_Note float-left", "navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], ["navigationAdapter", "", 1, "Spa_Style_Note", "float-left", 3, "innerHTML"], ["pageDisclaimer", ""]], template: function DisclaimerSectionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, DisclaimerSectionComponent_div_0_Template, 3, 4, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("liveEditProp", "Spa_Site_PageLevel_Disclaimer_Text");
    } }, dependencies: [NavigationAdapterDirective, LiveEditPropDirective, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DisclaimerSectionComponent, [{
        type: Component,
        args: [{ selector: 'vnext-disclaimer-section', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  #pageDisclaimer\r\n  class=\"Spa_Style_Note float-left\"\r\n  *liveEditProp=\"'Spa_Site_PageLevel_Disclaimer_Text'\"\r\n  [innerHTML]=\"disclaimerHtmlText ? (disclaimerHtmlText | safe: 'html') : ''\"\r\n  navigationAdapter\r\n></div>\r\n" }]
    }], function () { return [{ type: i1.HtmlUtilityService }]; }, { pageDisclaimer: [{
            type: ViewChild,
            args: ['pageDisclaimer']
        }], disclaimerText: [{
            type: Input
        }] }); })();

var FootnoteIndex;
(function (FootnoteIndex) {
    FootnoteIndex["COVERED_MEDICARE_FOOTNOTE"] = "A";
    FootnoteIndex["MAIL_ORDER_FOOTNOTE"] = "+";
    FootnoteIndex[FootnoteIndex["VACCINE_FOOTNOTE"] = 11] = "VACCINE_FOOTNOTE";
    FootnoteIndex[FootnoteIndex["NON_FORMULARY_FOOTNOTE"] = 15] = "NON_FORMULARY_FOOTNOTE";
    FootnoteIndex[FootnoteIndex["NON_COVERED_MEDICARE_FOOTNOTE"] = 4] = "NON_COVERED_MEDICARE_FOOTNOTE";
    FootnoteIndex[FootnoteIndex["LIMITED_DRUG_PHARMACY_FOOTNOTE"] = 9] = "LIMITED_DRUG_PHARMACY_FOOTNOTE";
    FootnoteIndex[FootnoteIndex["COVERAGE_BY_LAW_FOOTNOTE"] = 2] = "COVERAGE_BY_LAW_FOOTNOTE";
    FootnoteIndex[FootnoteIndex["HOME_INFUSION_FOOTNOTE"] = 12] = "HOME_INFUSION_FOOTNOTE";
    FootnoteIndex[FootnoteIndex["QUANTITY_LIMITATION_FOOTNOTE"] = 10] = "QUANTITY_LIMITATION_FOOTNOTE";
    FootnoteIndex[FootnoteIndex["ZERO_COST_SHARING_FOOTNOTE"] = 6] = "ZERO_COST_SHARING_FOOTNOTE";
    FootnoteIndex[FootnoteIndex["INSULIN_FOOTNOTE"] = 20] = "INSULIN_FOOTNOTE";
})(FootnoteIndex || (FootnoteIndex = {}));

class PharmacyContext {
    constructor(configResourceService, pharmacyFacade) {
        this.configResourceService = configResourceService;
        this.pharmacyFacade = pharmacyFacade;
    }
    getFootnoteIdsToShow$(plan, dosageId) {
        // get mail show mail order footnote aetna flag
        const showMailOrderFootnote = this.configResourceService.getProcessedResourceValue('Spa_Site_MailOrderFootnote_Enabled', null, false);
        // get mail order footnote display id, +
        const mailOrderFootnoteId = this.configResourceService.getProcessedResourceValue('Spa_Site_MailOrderFootnote_Index', null, '+');
        const showInsulinFootnote = this.configResourceService.getProcessedResourceValue('Spa_Site_InsulinFootnote_Enabled', null, true);
        const insulinFootNoteIndex = this.configResourceService.getProcessedResourceValue('Spa_Site_InsulinFootnote_Index', null, '20');
        return this.pharmacyFacade.mailOrder$.pipe(map(mailOrder => {
            let drugFootnotes = [];
            if (mailOrder) {
                let planMailOrderDrugCoverage = plan.planMailOrderDrugCoverage;
                if (dosageId) {
                    planMailOrderDrugCoverage = plan.planMailOrderDrugCoverage.filter(mailOrderCoverage => mailOrderCoverage.drugDosageID === dosageId);
                }
                drugFootnotes = _flatMap(planMailOrderDrugCoverage.map(mailOrderDrugCoverage => {
                    const drugFootnoteIds = this.fetchFootnotes(mailOrderDrugCoverage.drugFootNotes);
                    if (mailOrderDrugCoverage.isFormularyMailOrder && showMailOrderFootnote) {
                        drugFootnoteIds.push(mailOrderFootnoteId);
                    }
                    const partDFootnoteIds = this.fetchFootnotes(mailOrderDrugCoverage.partDFootNoteIDs.map(footnoteId => {
                        if (footnoteId !== FootnoteIndex.INSULIN_FOOTNOTE) {
                            return footnoteId.toString();
                        }
                        if (showInsulinFootnote) {
                            return insulinFootNoteIndex;
                        }
                    }));
                    return drugFootnoteIds.concat(partDFootnoteIds);
                }));
                return this.getSortedFootnotes(drugFootnotes.filter((footnotes, index) => drugFootnotes.indexOf(footnotes) === index));
            }
            // get the plan retail formulary status
            let planRetailDrugCoverage = plan.planRetailDrugCoverageMultiPharmacy || [];
            this.pharmacyFacade.getSelectedPharmacy$().pipe(map(pharmacy => {
                if (pharmacy && planRetailDrugCoverage && planRetailDrugCoverage.length) {
                    planRetailDrugCoverage = planRetailDrugCoverage.filter(retailDrugCoverage => retailDrugCoverage.pharmacyNABP === pharmacy.nabp);
                }
            }));
            // if we have a dosage, get all retail formulary status for a given dosage
            if (dosageId && planRetailDrugCoverage && planRetailDrugCoverage.length) {
                planRetailDrugCoverage = planRetailDrugCoverage.filter(retailDrugCoverage => retailDrugCoverage.drugDosageID === dosageId);
            }
            drugFootnotes = _flatMap(planRetailDrugCoverage.map(retailDrugCoverage => {
                // get list of footnote ids for dosage
                const drugFootnoteIds = this.fetchFootnotes(retailDrugCoverage.drugFootNotes);
                if (retailDrugCoverage.isFormularyMailOrder && showMailOrderFootnote) {
                    drugFootnoteIds.push(mailOrderFootnoteId);
                }
                const partDFootnoteIds = this.fetchFootnotes(retailDrugCoverage.partDFootNoteIDs.map(footnoteId => {
                    if (footnoteId !== FootnoteIndex.INSULIN_FOOTNOTE) {
                        return footnoteId.toString();
                    }
                    if (showInsulinFootnote) {
                        return insulinFootNoteIndex;
                    }
                }));
                return drugFootnoteIds.concat(partDFootnoteIds);
            }));
            const value = this.getSortedFootnotes(drugFootnotes.filter((footnotes, index) => drugFootnotes.indexOf(footnotes) === index));
            return value;
        }));
    }
    getSortedFootnotes(footnotes) {
        const integerFootnotes = footnotes.filter(footnote => !isNaN(footnote)).sort((firstValue, secondValue) => firstValue - secondValue);
        const specialCharacters = /[^A-Za-z0-9]/;
        const characterFootnotes = footnotes
            .filter(footnote => isNaN(footnote) && !specialCharacters.test(footnote))
            .sort((firstValue, secondValue) => firstValue.localeCompare(secondValue));
        const specialCharacterFootnotes = footnotes.filter(footnote => isNaN(footnote) && specialCharacters.test(footnote)).sort();
        return [...integerFootnotes, ...characterFootnotes, ...specialCharacterFootnotes];
    }
    fetchFootnotes(drugFootnotes) {
        return drugFootnotes.reduce((footnotes, footnote) => {
            if (!footnotes.some(id => id === footnote)) {
                footnotes.push(footnote);
            }
            return footnotes;
        }, []);
    }
    get isTotalCostByEffectiveDateEnabled() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_TotalCostByEffectiveDate_Enabled', null, false);
    }
}
PharmacyContext.ɵfac = function PharmacyContext_Factory(t) { return new (t || PharmacyContext)(i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(PharmacyFacade)); };
PharmacyContext.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PharmacyContext, factory: PharmacyContext.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PharmacyContext, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: PharmacyFacade }]; }, null); })();

function DrugFootNoteComponent_sup_0_ng_container_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const footnoteId_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(footnoteId_r2);
} }
function DrugFootNoteComponent_sup_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DrugFootNoteComponent_sup_0_ng_container_1_span_1_Template, 2, 1, "span", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const footnoteId_r2 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", footnoteId_r2 !== ctx_r1.footnoteAId);
} }
function DrugFootNoteComponent_sup_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sup", 1);
    i0.ɵɵtemplate(1, DrugFootNoteComponent_sup_0_ng_container_1_Template, 2, 1, "ng-container", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.footnoteIdsToShow);
} }
class DrugFootNoteComponent {
    constructor() {
        this.isFootnoteExist = false;
    }
    ngOnChanges(changes) {
        const { plan } = changes;
        if (plan && !_isEqual(plan.previousValue, plan.currentValue)) {
            this.isFootnoteExist = this.plan && this.plan.planType !== PlanType.MA;
        }
    }
}
DrugFootNoteComponent.ɵfac = function DrugFootNoteComponent_Factory(t) { return new (t || DrugFootNoteComponent)(); };
DrugFootNoteComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DrugFootNoteComponent, selectors: [["vnext-drug-footnote"]], inputs: { plan: "plan", footnoteAId: "footnoteAId", footnoteIdsToShow: "footnoteIdsToShow" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "Spa_Style_Note", 4, "ngIf"], [1, "Spa_Style_Note"], [4, "ngFor", "ngForOf"], ["class", "pr-1", 4, "ngIf"], [1, "pr-1"]], template: function DrugFootNoteComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, DrugFootNoteComponent_sup_0_Template, 2, 1, "sup", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.isFootnoteExist);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugFootNoteComponent, [{
        type: Component,
        args: [{ selector: 'vnext-drug-footnote', changeDetection: ChangeDetectionStrategy.OnPush, template: "<sup class=\"Spa_Style_Note\" *ngIf=\"isFootnoteExist\">\r\n  <ng-container *ngFor=\"let footnoteId of footnoteIdsToShow\">\r\n    <span class=\"pr-1\" *ngIf=\"footnoteId !== footnoteAId\">{{ footnoteId }}</span>\r\n  </ng-container>\r\n</sup>\r\n" }]
    }], null, { plan: [{
            type: Input
        }], footnoteAId: [{
            type: Input
        }], footnoteIdsToShow: [{
            type: Input
        }] }); })();

function DrugTypeComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.drugListCardBrandText, " ");
} }
function DrugTypeComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.drugListCardGenericText, " ");
} }
class DrugTypeComponent {
    constructor() {
        this.drugFlag = DrugFlag;
    }
}
DrugTypeComponent.ɵfac = function DrugTypeComponent_Factory(t) { return new (t || DrugTypeComponent)(); };
DrugTypeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DrugTypeComponent, selectors: [["vnext-drug-type"]], inputs: { dosage: "dosage", drugListCardBrandText: "drugListCardBrandText", drugListCardGenericText: "drugListCardGenericText" }, decls: 3, vars: 3, consts: [[3, "ngSwitch"], ["class", "Spa_Style_Smaller_Font Spa_Style_Gray4_Color", 4, "ngSwitchCase"], [1, "Spa_Style_Smaller_Font", "Spa_Style_Gray4_Color"]], template: function DrugTypeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementContainerStart(0, 0);
        i0.ɵɵtemplate(1, DrugTypeComponent_div_1_Template, 2, 1, "div", 1);
        i0.ɵɵtemplate(2, DrugTypeComponent_div_2_Template, 2, 1, "div", 1);
        i0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngSwitch", ctx.dosage == null ? null : ctx.dosage.drugFlag);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.drugFlag.Brand);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.drugFlag.Generic);
    } }, dependencies: [i1$2.NgSwitch, i1$2.NgSwitchCase], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugTypeComponent, [{
        type: Component,
        args: [{ selector: 'vnext-drug-type', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container [ngSwitch]=\"dosage?.drugFlag\">\r\n  <div *ngSwitchCase=\"drugFlag.Brand\" class=\"Spa_Style_Smaller_Font Spa_Style_Gray4_Color\">\r\n    {{ drugListCardBrandText }}\r\n  </div>\r\n\r\n  <div *ngSwitchCase=\"drugFlag.Generic\" class=\"Spa_Style_Smaller_Font Spa_Style_Gray4_Color\">\r\n    {{ drugListCardGenericText}}\r\n  </div>\r\n</ng-container>\r\n" }]
    }], null, { dosage: [{
            type: Input
        }], drugListCardBrandText: [{
            type: Input
        }], drugListCardGenericText: [{
            type: Input
        }] }); })();

function DrugListCardComponent_vnext_drug_footnote_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-drug-footnote", 19);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("plan", ctx_r0.plan)("footnoteAId", ctx_r0.footnoteAId)("footnoteIdsToShow", ctx_r0.footnoteIds);
} }
function DrugListCardComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20)(1, "button", 21);
    i0.ɵɵlistener("click", function DrugListCardComponent_div_11_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.onViewPossibleAlternativeDrugs(ctx_r6.cabinet)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.prescriptionsDrugAlternativesButtonText, " ");
} }
const _c0$2j = function (a0) { return { "col-md-4": a0 }; };
function DrugListCardComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "div", 23)(2, "vnext-link", 24);
    i0.ɵɵlistener("keyup.Space", function DrugListCardComponent_div_12_Template_vnext_link_keyup_Space_2_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.editDrug(ctx_r8.dosage.dosageId)); })("click", function DrugListCardComponent_div_12_Template_vnext_link_click_2_listener() { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.editDrug(ctx_r10.dosage.dosageId)); })("keyup.enter", function DrugListCardComponent_div_12_Template_vnext_link_keyup_enter_2_listener() { i0.ɵɵrestoreView(_r9); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.editDrug(ctx_r11.dosage.dosageId)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "i", 25);
    i0.ɵɵlistener("keyup.Space", function DrugListCardComponent_div_12_Template_i_keyup_Space_3_listener() { i0.ɵɵrestoreView(_r9); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.removeDrug(ctx_r12.dosage)); })("click", function DrugListCardComponent_div_12_Template_i_click_3_listener() { i0.ɵɵrestoreView(_r9); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.removeDrug(ctx_r13.dosage)); })("keyup.enter", function DrugListCardComponent_div_12_Template_i_keyup_enter_3_listener() { i0.ɵɵrestoreView(_r9); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.removeDrug(ctx_r14.dosage)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$2j, !ctx_r2.isDrugCostsTab));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", ctx_r2.Spa_DrugListCard_Edit_Text)("makeInlineBlock", true)("isLinkButton", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r2.Spa_DrugListCard_Delete_Text);
    i0.ɵɵattribute("aria-label", ctx_r2.Spa_DrugListCard_DeleteDrug_Text);
} }
function DrugListCardComponent_p_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 26);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r3.dosePackageQuantityFreq, i0.ɵɵsanitizeHtml);
} }
function DrugListCardComponent_ng_container_18_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵelement(2, "vnext-drug-type", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("dosage", ctx_r15.dosage)("drugListCardBrandText", ctx_r15.Spa_DrugListCard_Brand_Text)("drugListCardGenericText", ctx_r15.Spa_DrugListCard_Generic_Text);
} }
function DrugListCardComponent_ng_container_18_ng_template_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r18.Spa_DrugListCard_Brand_Text, " ");
} }
function DrugListCardComponent_ng_container_18_ng_template_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r20.Spa_DrugListCard_Generic_Text);
} }
function DrugListCardComponent_ng_container_18_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtemplate(1, DrugListCardComponent_ng_container_18_ng_template_2_ng_container_1_Template, 3, 1, "ng-container", 27);
    i0.ɵɵtemplate(2, DrugListCardComponent_ng_container_18_ng_template_2_ng_template_2_Template, 2, 1, "ng-template", null, 31, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r19 = i0.ɵɵreference(3);
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r17.isLowerCostGeneric)("ngIfElse", _r19);
} }
function DrugListCardComponent_ng_container_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DrugListCardComponent_ng_container_18_ng_container_1_Template, 3, 3, "ng-container", 27);
    i0.ɵɵtemplate(2, DrugListCardComponent_ng_container_18_ng_template_2_Template, 4, 2, "ng-template", null, 28, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r16 = i0.ɵɵreference(3);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.Spa_Drugs_UseCMSDrugFlag_Enabled)("ngIfElse", _r16);
} }
function DrugListCardComponent_div_19_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵelementStart(2, "p");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r21.Spa_DrugListCard_PlanCovered_Text);
} }
function DrugListCardComponent_div_19_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 36);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r23.Spa_DrugListCard_PlanNotCovered_Text);
} }
function DrugListCardComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵtemplate(1, DrugListCardComponent_div_19_ng_container_1_Template, 4, 1, "ng-container", 27);
    i0.ɵɵtemplate(2, DrugListCardComponent_div_19_ng_template_2_Template, 3, 1, "ng-template", null, 34, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r22 = i0.ɵɵreference(3);
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.isCovered)("ngIfElse", _r22);
} }
const _c1$17 = function (a0) { return { "col-md-8": a0 }; };
class DrugListCardComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, drugsService, drugDetailsFacade, pharmacyFacade, localeService, drugFrequencyFacade, pharmacyService, planFacade) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.cdr = cdr;
        this.widgetValidationService = widgetValidationService;
        this.configurableWidgetService = configurableWidgetService;
        this.zoneService = zoneService;
        this.widgetService = widgetService;
        this.drugsService = drugsService;
        this.drugDetailsFacade = drugDetailsFacade;
        this.pharmacyFacade = pharmacyFacade;
        this.localeService = localeService;
        this.drugFrequencyFacade = drugFrequencyFacade;
        this.pharmacyService = pharmacyService;
        this.planFacade = planFacade;
        this.Spa_DrugListCard_Edit_Text = 'Edit';
        this.Spa_DrugListCard_Delete_Text = 'Delete';
        this.Spa_DrugListCard_Brand_Text = 'Branded';
        this.Spa_DrugListCard_Generic_Text = 'Generic';
        this.Spa_DrugListCard_PlanCovered_Text = 'This drug is covered in this plan';
        this.Spa_DrugListCard_PlanNotCovered_Text = 'This drug is not covered in this plan';
        this.Spa_DrugListCard_DeleteDrug_Text = 'delete drug';
        this.Spa_Drugs_UseCMSDrugFlag_Enabled = true;
        this.Spa_DrugSearch_Frequency_List = [
            { label: "per month" /* FrequencyLabel.Month */, value: 30 /* FrequencyValue.Month */ },
            { label: "per two months" /* FrequencyLabel.TwoMonths */, value: 60 /* FrequencyValue.TwoMonths */ },
            { label: "per three months" /* FrequencyLabel.ThreeMonths */, value: 90 /* FrequencyValue.ThreeMonths */ },
            { label: "per six months" /* FrequencyLabel.SixMonths */, value: 180 /* FrequencyValue.SixMonths */ },
            { label: "per year" /* FrequencyLabel.PerYear */, value: 365 /* FrequencyValue.PerYear */ }
        ];
        this.isDrugCostsTab = false;
        this.showCoverageNudge = false;
        this.pageTag = PageTags.PLAN_DETAILS;
        this.prescriptionsDrugAlternativesButtonText = '';
        this.selectedPharmacy = null;
        this.isEnabledShowDrugAlternatives = false;
        this.pharmacies = [];
        this.footnoteIds = [];
        this.showDosePackageQuantityFrequency = true;
        this.viewPossibleAlternativeDrugs = new EventEmitter();
        this.drugFlag = DrugFlag;
        this.subscriptions = new Subscription();
        this.showOffFormularyDrugAlternativesButton = false;
    }
    ngOnInit() {
        super.ngOnInit();
        // Notes: Here we need to check for LCAs (Lower Cost Alternatives).
        // Nova provides a a commercial drug type indicator, drugType, e.g. Brand vs Generic.
        // If it is not Brand then we know that it is a LCA (lower cost generic)
        // The default setting is to allow for LCA status (brand/generic) to be shown.
        // This is set in the Spa_DrugListCard_Allow_LCA flag.
        this.dosage = this.cabinet.dosage;
        this.packageId = this.cabinet.packageId;
        this.isLowerCostGeneric = this.dosage && this.dosage.drugType !== DrugType.Brand;
        this.subscriptions.add(this.cabinet$.subscribe(cabinet => {
            const selectedDrug = cabinet.find(x => x.dosageID === this.dosage.dosageId);
            this.drugDetails = selectedDrug ? selectedDrug.drugDetails : null;
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(combineLatest([this.pharmacyFacade.mailOrder$, this.localeService.getCurrentLocale$()]).subscribe(([isMailOrder]) => {
            const drugSearchFrequencyList = this.getDrugSearchFrequencyList();
            this.dosePackageQuantityFreq = this.calculateDosage(isMailOrder, drugSearchFrequencyList);
            this.cdr.markForCheck();
        }));
    }
    ngOnChanges(changes) {
        const { plan, selectedPharmacy, cabinet, isEnabledShowDrugAlternatives, pageTag, isCovered, pharmacies, isMailOrderSelected } = changes;
        if (this.haveDrugAlternativesListCardChanged({
            plan,
            selectedPharmacy,
            cabinet,
            isEnabledShowDrugAlternatives,
            pageTag,
            isCovered,
            pharmacies,
            isMailOrderSelected
        })) {
            this.pharmacy = this.planFacade.getPharmacy(this.pharmacies, this.selectedPharmacy);
            const nonMailOrderHasDrugAlternativesOnCabinet = !this.isMailOrderSelected &&
                this.existsCabinetDrugAlternatives(this.plan?.planRetailDrugCoverageMultiPharmacy, this.cabinet) &&
                this.pharmacyService.isPharmacyInNetworkForDrugAlternatives(this.pharmacy);
            const mailOrderHasDrugAlternativesOnCabinet = this.isMailOrderSelected && this.existsCabinetDrugAlternatives(this.plan?.planMailOrderDrugCoverage, this.cabinet);
            this.showOffFormularyDrugAlternativesButton =
                this.isEnabledShowDrugAlternatives &&
                    this.pageTag === PageTags.PLAN_DETAILS &&
                    !this.isCovered &&
                    (nonMailOrderHasDrugAlternativesOnCabinet || mailOrderHasDrugAlternativesOnCabinet);
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
    editDrug(drugId) {
        // Open dosage section window for currently open drug.
        // Publish/broadcast to downstream subscribers
        this.drugsService.publishEditEvent(drugId);
    }
    removeDrug(dosage) {
        this.drugsService.removeDrug(dosage.dosageId);
        this.cdr.markForCheck();
    }
    keyDownEdit(dosageId, $event) {
        if ($event.code === 'Space') {
            this.editDrug(dosageId);
        }
    }
    onViewPossibleAlternativeDrugs(cabinetSelected) {
        this.viewPossibleAlternativeDrugs.emit(cabinetSelected);
    }
    calculateDosage(isMailOrder, drugSearchFrequencyList) {
        return this.drugDetailsFacade.calculateDosage(isMailOrder, this.dosage, this.packageId, drugSearchFrequencyList, this.drugsService.getFrequency(this.dosage.daysOfSupply), this.drugsService.getForm(this.dosage.labelName));
    }
    getDrugSearchFrequencyList() {
        return this.drugDetailsFacade.getDrugSearchFrequencyList(this.Spa_DrugSearch_Frequency_List);
    }
    existsCabinetDrugAlternatives(drugCoverage, cabinet) {
        return (this.drugDetailsFacade.planHasDrugAlternatives(drugCoverage) &&
            this.drugDetailsFacade.drugHasAlternatives(cabinet.dosageID, drugCoverage));
    }
    haveDrugAlternativesListCardChanged(changesValidation) {
        const { plan, selectedPharmacy, cabinet, isEnabledShowDrugAlternatives, pageTag, isCovered, pharmacies, isMailOrderSelected } = changesValidation;
        return ((plan && !_isEqual(plan.previousValue, plan.currentValue)) ||
            (selectedPharmacy && !_isEqual(selectedPharmacy.previousValue, selectedPharmacy.currentValue)) ||
            (cabinet && !_isEqual(cabinet.previousValue, cabinet.currentValue)) ||
            (isEnabledShowDrugAlternatives && isEnabledShowDrugAlternatives.currentValue !== isEnabledShowDrugAlternatives.previousValue) ||
            (pageTag && pageTag.currentValue !== pageTag.previousValue) ||
            (isCovered && isCovered.currentValue !== isCovered.previousValue) ||
            (pharmacies && pharmacies.currentValue !== pharmacies.previousValue) ||
            (isMailOrderSelected && isMailOrderSelected.currentValue !== isMailOrderSelected.previousValue));
    }
}
DrugListCardComponent.ɵfac = function DrugListCardComponent_Factory(t) { return new (t || DrugListCardComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.DrugsService), i0.ɵɵdirectiveInject(DrugDetailsFacade), i0.ɵɵdirectiveInject(PharmacyFacade), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.DrugFrequencyFacade), i0.ɵɵdirectiveInject(i1.PharmacyService), i0.ɵɵdirectiveInject(PlanFacade)); };
DrugListCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DrugListCardComponent, selectors: [["vnext-drug-list-card"]], inputs: { cabinet: "cabinet", isDrugCostsTab: "isDrugCostsTab", showGenericOption: "showGenericOption", plan: "plan", footnoteAId: "footnoteAId", isCovered: "isCovered", showCoverageNudge: "showCoverageNudge", pageTag: "pageTag", prescriptionsDrugAlternativesButtonText: "prescriptionsDrugAlternativesButtonText", selectedPharmacy: "selectedPharmacy", isEnabledShowDrugAlternatives: "isEnabledShowDrugAlternatives", pharmacies: "pharmacies", footnoteIds: "footnoteIds", showDosePackageQuantityFrequency: "showDosePackageQuantityFrequency", isMailOrderSelected: "isMailOrderSelected" }, outputs: { viewPossibleAlternativeDrugs: "viewPossibleAlternativeDrugs" }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 20, vars: 10, consts: [["role", "rowgroup", 1, "drug-card-panel-container"], ["role", "row", 1, "drug-card-panel"], ["role", "columnheader", "aria-colspan", "2"], [1, "drug-card-panel-header"], ["id", "drug-detail", 1, "row"], [1, "col-12", "dosage-label-order", "no-translate-block", 3, "ngClass"], [1, "row", "flex-column", "flex-lg-row", "justify-content-between"], [1, "col-12", "col-lg-8"], [1, "Spa_Style_Regular_Font", "mt-1", "Spa_Style_Primary_Color", "Spa_Style_Semi_Bold_Weight"], [3, "plan", "footnoteAId", "footnoteIdsToShow", 4, "ngIf"], ["class", "col-12 col-lg-4 d-flex justify-content-end", 4, "ngIf"], ["class", "col-12", 3, "ngClass", 4, "ngIf"], [1, "drug-card-panel-body"], [1, "row"], [1, "col-8"], ["class", "float-left Spa_Style_Paragraph", 3, "innerHTML", 4, "ngIf"], [1, "col-4"], [4, "ngIf"], ["class", "text-center col-12", 4, "ngIf"], [3, "plan", "footnoteAId", "footnoteIdsToShow"], [1, "col-12", "col-lg-4", "d-flex", "justify-content-end"], ["type", "button", 1, "btn", "d-block", "text-break", "Spa_Style_PrimaryButton", "Spa_Style_Small_Font", "px-2", "view-drug-alternatives-button", 3, "click"], [1, "col-12", 3, "ngClass"], [1, "float-right"], [1, "mr-2", 3, "title", "makeInlineBlock", "isLinkButton", "keyup.Space", "click", "keyup.enter"], ["role", "button", "tabindex", "0", 1, "fas", "fa-times", "ml-3", "can-click", 3, "title", "keyup.Space", "click", "keyup.enter"], [1, "float-left", "Spa_Style_Paragraph", 3, "innerHTML"], [4, "ngIf", "ngIfElse"], ["CMSDrugType", ""], [1, "d-flex", "justify-content-end"], [3, "dosage", "drugListCardBrandText", "drugListCardGenericText"], ["lowerCostGeneric", ""], [1, "Spa_Style_Smaller_Font", "Spa_Style_Gray4_Color"], [1, "text-center", "col-12"], ["noDrugCoverage", ""], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "drug-coverage-icon", "Spa_Style_Accent5_Color", "Spa_Style_Largest_Font"], ["aria-hidden", "true", 1, "fas", "fa-times-circle", "drug-coverage-icon", "Spa_Style_Accent1_Color", "Spa_Style_Largest_Font"]], template: function DrugListCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "header", 3)(4, "div", 4)(5, "div", 5)(6, "div", 6)(7, "div", 7)(8, "h3", 8);
        i0.ɵɵtext(9);
        i0.ɵɵtemplate(10, DrugListCardComponent_vnext_drug_footnote_10_Template, 1, 3, "vnext-drug-footnote", 9);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(11, DrugListCardComponent_div_11_Template, 3, 1, "div", 10);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(12, DrugListCardComponent_div_12_Template, 4, 8, "div", 11);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "div", 12)(14, "div", 13)(15, "div", 14);
        i0.ɵɵtemplate(16, DrugListCardComponent_p_16_Template, 1, 1, "p", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 16);
        i0.ɵɵtemplate(18, DrugListCardComponent_ng_container_18_Template, 4, 2, "ng-container", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(19, DrugListCardComponent_div_19_Template, 4, 2, "div", 18);
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c1$17, !ctx.isDrugCostsTab));
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.dosage.labelName, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isDrugCostsTab);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showOffFormularyDrugAlternativesButton);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isDrugCostsTab);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.showDosePackageQuantityFrequency);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showGenericOption);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showCoverageNudge && ctx.isCovered !== undefined && ctx.isCovered !== null);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, LinkComponent, IconAriaAttributesDirective, DrugFootNoteComponent, DrugTypeComponent], styles: [".drug-card-panel[_ngcontent-%COMP%]{background:white;border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px;box-shadow:none}.drug-card-panel-body[_ngcontent-%COMP%], .drug-card-panel-header[_ngcontent-%COMP%]{line-height:20px;vertical-align:top}.drug-card-panel-body[_ngcontent-%COMP%]{padding:2px 15px 7px}.drug-card-panel-header[_ngcontent-%COMP%]{padding:9px 15px 0}.drug-card-panel[_ngcontent-%COMP%]   .drug-card-panel-body[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-bottom:0}.drug-card-panel-container[_ngcontent-%COMP%]{margin-top:.75rem}.drug-coverage-icon[_ngcontent-%COMP%]{margin-bottom:15px;margin-top:15px}.drug-card-panel-header[_ngcontent-%COMP%]   i.fas[_ngcontent-%COMP%]{width:20px;height:20px;text-align:center}.drug-card-panel-header[_ngcontent-%COMP%]   i.fas[_ngcontent-%COMP%]:before{vertical-align:middle}.dosage-label-order[_ngcontent-%COMP%]{order:unset}@media (max-width: 767px){.dosage-label-order[_ngcontent-%COMP%]{order:2}}@media (max-width: 992px){.view-drug-alternatives-button[_ngcontent-%COMP%]{width:100%}}"], changeDetection: 0 });
__decorate([
    Select(MedicineCabinetState.medicineCabinet)
], DrugListCardComponent.prototype, "cabinet$", void 0);
__decorate([
    GlobalResource()
], DrugListCardComponent.prototype, "Spa_DrugListCard_Edit_Text", void 0);
__decorate([
    GlobalResource()
], DrugListCardComponent.prototype, "Spa_DrugListCard_Delete_Text", void 0);
__decorate([
    GlobalResource()
], DrugListCardComponent.prototype, "Spa_DrugListCard_Brand_Text", void 0);
__decorate([
    GlobalResource()
], DrugListCardComponent.prototype, "Spa_DrugListCard_Generic_Text", void 0);
__decorate([
    GlobalResource()
], DrugListCardComponent.prototype, "Spa_DrugListCard_PlanCovered_Text", void 0);
__decorate([
    GlobalResource()
], DrugListCardComponent.prototype, "Spa_DrugListCard_PlanNotCovered_Text", void 0);
__decorate([
    GlobalResource()
], DrugListCardComponent.prototype, "Spa_DrugListCard_DeleteDrug_Text", void 0);
__decorate([
    GlobalResource()
], DrugListCardComponent.prototype, "Spa_Drugs_UseCMSDrugFlag_Enabled", void 0);
__decorate([
    GlobalResource()
], DrugListCardComponent.prototype, "Spa_DrugSearch_Frequency_List", void 0);
__decorate([
    LiveEditInactive()
], DrugListCardComponent.prototype, "editDrug", null);
__decorate([
    LiveEditInactive()
], DrugListCardComponent.prototype, "removeDrug", null);
__decorate([
    Memoize()
], DrugListCardComponent.prototype, "existsCabinetDrugAlternatives", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugListCardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-drug-list-card', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"drug-card-panel-container\" role=\"rowgroup\">\r\n  <div class=\"drug-card-panel\" role=\"row\">\r\n    <div role=\"columnheader\" aria-colspan=\"2\">\r\n      <header class=\"drug-card-panel-header\">\r\n        <div class=\"row\" id=\"drug-detail\">\r\n          <div\r\n            [ngClass]=\"{\r\n              'col-md-8': !isDrugCostsTab\r\n            }\"\r\n            class=\"col-12 dosage-label-order no-translate-block\"\r\n          >\r\n            <div class=\"row flex-column flex-lg-row justify-content-between\">\r\n              <div class=\"col-12 col-lg-8\">\r\n                <h3 class=\"Spa_Style_Regular_Font mt-1 Spa_Style_Primary_Color Spa_Style_Semi_Bold_Weight\">\r\n                  {{ dosage.labelName }}\r\n                  <vnext-drug-footnote\r\n                    *ngIf=\"isDrugCostsTab\"\r\n                    [plan]=\"plan\"\r\n                    [footnoteAId]=\"footnoteAId\"\r\n                    [footnoteIdsToShow]=\"footnoteIds\"\r\n                  ></vnext-drug-footnote>\r\n                </h3>\r\n              </div>\r\n\r\n              <div class=\"col-12 col-lg-4 d-flex justify-content-end\" *ngIf=\"showOffFormularyDrugAlternativesButton\">\r\n                <button\r\n                  type=\"button\"\r\n                  class=\"btn d-block text-break Spa_Style_PrimaryButton Spa_Style_Small_Font px-2 view-drug-alternatives-button\"\r\n                  (click)=\"onViewPossibleAlternativeDrugs(cabinet)\"\r\n                >\r\n                  {{ prescriptionsDrugAlternativesButtonText }}\r\n                </button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div\r\n            [ngClass]=\"{\r\n              'col-md-4': !isDrugCostsTab\r\n            }\"\r\n            class=\"col-12\"\r\n            *ngIf=\"!isDrugCostsTab\"\r\n          >\r\n            <div class=\"float-right\">\r\n              <vnext-link\r\n                [title]=\"Spa_DrugListCard_Edit_Text\"\r\n                (keyup.Space)=\"editDrug(dosage.dosageId)\"\r\n                (click)=\"editDrug(dosage.dosageId)\"\r\n                (keyup.enter)=\"editDrug(dosage.dosageId)\"\r\n                class=\"mr-2\"\r\n                [makeInlineBlock]=\"true\"\r\n                [isLinkButton]=\"true\"\r\n              ></vnext-link>\r\n              <i\r\n                class=\"fas fa-times ml-3 can-click\"\r\n                (keyup.Space)=\"removeDrug(dosage)\"\r\n                (click)=\"removeDrug(dosage)\"\r\n                (keyup.enter)=\"removeDrug(dosage)\"\r\n                [title]=\"Spa_DrugListCard_Delete_Text\"\r\n                [attr.aria-label]=\"Spa_DrugListCard_DeleteDrug_Text\"\r\n                role=\"button\"\r\n                tabindex=\"0\"\r\n              ></i>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </header>\r\n      <div class=\"drug-card-panel-body\">\r\n        <div class=\"row\">\r\n          <!--Has a row with two columns-->\r\n          <div class=\"col-8\">\r\n            <p *ngIf=\"showDosePackageQuantityFrequency\" class=\"float-left Spa_Style_Paragraph\" [innerHTML]=\"dosePackageQuantityFreq\"></p>\r\n          </div>\r\n          <div class=\"col-4\">\r\n            <ng-container *ngIf=\"showGenericOption\">\r\n              <!--If generic option enabled display-->\r\n              <ng-container *ngIf=\"Spa_Drugs_UseCMSDrugFlag_Enabled; else CMSDrugType\">\r\n                <div class=\"d-flex justify-content-end\">\r\n                  <vnext-drug-type\r\n                    [dosage]=\"dosage\"\r\n                    [drugListCardBrandText]=\"Spa_DrugListCard_Brand_Text\"\r\n                    [drugListCardGenericText]=\"Spa_DrugListCard_Generic_Text\"\r\n                  >\r\n                  </vnext-drug-type>\r\n                </div>\r\n              </ng-container>\r\n\r\n              <ng-template #CMSDrugType>\r\n                <div class=\"float-right\">\r\n                  <ng-container *ngIf=\"!isLowerCostGeneric; else lowerCostGeneric\">\r\n                    <div class=\"Spa_Style_Smaller_Font Spa_Style_Gray4_Color\">\r\n                      {{ Spa_DrugListCard_Brand_Text }}\r\n                    </div>\r\n                  </ng-container>\r\n                  <ng-template #lowerCostGeneric>\r\n                    <div class=\"Spa_Style_Smaller_Font Spa_Style_Gray4_Color\">{{ Spa_DrugListCard_Generic_Text }}</div>\r\n                  </ng-template>\r\n                </div>\r\n              </ng-template>\r\n            </ng-container>\r\n          </div>\r\n          <div class=\"text-center col-12\" *ngIf=\"showCoverageNudge && isCovered !== undefined && isCovered !== null\">\r\n            <ng-container *ngIf=\"isCovered; else noDrugCoverage\">\r\n              <i class=\"fas fa-check-circle drug-coverage-icon Spa_Style_Accent5_Color Spa_Style_Largest_Font\" aria-hidden=\"true\"></i>\r\n              <p>{{ Spa_DrugListCard_PlanCovered_Text }}</p>\r\n            </ng-container>\r\n            <ng-template #noDrugCoverage>\r\n              <i class=\"fas fa-times-circle drug-coverage-icon Spa_Style_Accent1_Color Spa_Style_Largest_Font\" aria-hidden=\"true\"></i>\r\n              <p>{{ Spa_DrugListCard_PlanNotCovered_Text }}</p>\r\n            </ng-template>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".drug-card-panel{background:white;border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px;box-shadow:none}.drug-card-panel-body,.drug-card-panel-header{line-height:20px;vertical-align:top}.drug-card-panel-body{padding:2px 15px 7px}.drug-card-panel-header{padding:9px 15px 0}.drug-card-panel .drug-card-panel-body p{margin-bottom:0}.drug-card-panel-container{margin-top:.75rem}.drug-coverage-icon{margin-bottom:15px;margin-top:15px}.drug-card-panel-header i.fas{width:20px;height:20px;text-align:center}.drug-card-panel-header i.fas:before{vertical-align:middle}.dosage-label-order{order:unset}@media (max-width: 767px){.dosage-label-order{order:2}}@media (max-width: 992px){.view-drug-alternatives-button{width:100%}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.DrugsService }, { type: DrugDetailsFacade }, { type: PharmacyFacade }, { type: i1.LocaleService }, { type: i1.DrugFrequencyFacade }, { type: i1.PharmacyService }, { type: PlanFacade }]; }, { cabinet$: [], Spa_DrugListCard_Edit_Text: [], Spa_DrugListCard_Delete_Text: [], Spa_DrugListCard_Brand_Text: [], Spa_DrugListCard_Generic_Text: [], Spa_DrugListCard_PlanCovered_Text: [], Spa_DrugListCard_PlanNotCovered_Text: [], Spa_DrugListCard_DeleteDrug_Text: [], Spa_Drugs_UseCMSDrugFlag_Enabled: [], Spa_DrugSearch_Frequency_List: [], cabinet: [{
            type: Input
        }], isDrugCostsTab: [{
            type: Input
        }], showGenericOption: [{
            type: Input
        }], plan: [{
            type: Input
        }], footnoteAId: [{
            type: Input
        }], isCovered: [{
            type: Input
        }], showCoverageNudge: [{
            type: Input
        }], pageTag: [{
            type: Input
        }], prescriptionsDrugAlternativesButtonText: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], isEnabledShowDrugAlternatives: [{
            type: Input
        }], pharmacies: [{
            type: Input
        }], footnoteIds: [{
            type: Input
        }], showDosePackageQuantityFrequency: [{
            type: Input
        }], isMailOrderSelected: [{
            type: Input
        }], viewPossibleAlternativeDrugs: [{
            type: Output
        }], editDrug: [], removeDrug: [], existsCabinetDrugAlternatives: [] }); })();

function DrugRestrictionsComponent_sup_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sup", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.footnoteAId);
} }
class DrugRestrictionsComponent {
}
DrugRestrictionsComponent.ɵfac = function DrugRestrictionsComponent_Factory(t) { return new (t || DrugRestrictionsComponent)(); };
DrugRestrictionsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DrugRestrictionsComponent, selectors: [["vnext-drug-restrictions"]], inputs: { drugRestrictionHeaderText: "drugRestrictionHeaderText", priorAuthorizationTooltip: "priorAuthorizationTooltip", quantityLimitTooltip: "quantityLimitTooltip", stepTherapyTooltip: "stepTherapyTooltip", drugCostDetails: "drugCostDetails", drugRestrictionYesText: "drugRestrictionYesText", drugRestrictionNoText: "drugRestrictionNoText", quantityLimitsDaysText: "quantityLimitsDaysText", isFootnoteAIdAvailable: "isFootnoteAIdAvailable", footnoteAId: "footnoteAId", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text" }, decls: 24, vars: 23, consts: [[1, "drug-card-section"], ["role", "row", 1, "row"], ["role", "rowheader", 1, "col-12", "col-md-3", "drug-card-restriction-header", "Spa_Style_Smaller_Font"], ["role", "cell", 1, "col-12", "col-md-9", "d-md-inline-flex", "p-3", "tooltip-border"], [1, "restriction-wrapper", "mr-md-4"], [1, "restriction-tooltip", "float-left", "position-relative"], [3, "header", "body", "Spa_Site_Tooltip_Text", "ariaLabel", "customClass"], [1, "ml-2", "mt-1", "restriction-text", "Spa_Style_Smaller_Font"], ["class", "Spa_Style_Note footnoteid", 4, "ngIf"], [1, "ml-2", "mt-1", "restriction-text", "Spa_Style_Smaller_Font", "Spa_Style_Primary_Color", "can-click"], [1, "Spa_Style_Note", "footnoteid"]], template: function DrugRestrictionsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3)(5, "div", 4)(6, "div", 5)(7, "vnext-tooltip", 6);
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "span", 7);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(11, DrugRestrictionsComponent_sup_11_Template, 2, 1, "sup", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 4)(13, "div", 5)(14, "vnext-tooltip", 6);
        i0.ɵɵtext(15);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(16, "span", 9);
        i0.ɵɵtext(17);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(18, "div", 4)(19, "div", 5)(20, "vnext-tooltip", 6);
        i0.ɵɵtext(21);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(22, "span", 7);
        i0.ɵɵtext(23);
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.drugRestrictionHeaderText, " ");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("header", ctx.priorAuthorizationTooltip.tooltip.header)("body", ctx.priorAuthorizationTooltip.tooltip.body)("Spa_Site_Tooltip_Text", ctx.Spa_Site_Tooltip_Text)("ariaLabel", ctx.priorAuthorizationTooltip.label)("customClass", "Spa_Style_Accent6_Background Spa_Style_Secondary_Text_Color border-radius-12 px-2 py-1");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.priorAuthorizationTooltip.label, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.drugCostDetails.formularyStatus.hasPriorAuthorization ? ctx.drugRestrictionYesText : ctx.drugRestrictionNoText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isFootnoteAIdAvailable);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("header", ctx.quantityLimitTooltip.tooltip.header)("body", ctx.quantityLimitTooltip.tooltip.body)("Spa_Site_Tooltip_Text", ctx.Spa_Site_Tooltip_Text)("ariaLabel", ctx.quantityLimitTooltip.label)("customClass", "Spa_Style_Primary_Link_Background Spa_Style_Secondary_Text_Color border-radius-12 px-2 py-1");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.quantityLimitTooltip.label, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.drugCostDetails.formularyStatus.hasQuantityLimit ? ctx.drugCostDetails.formularyStatus.quantityLimitAmount + " / " + ctx.drugCostDetails.formularyStatus.quantityLimitDays + " " + ctx.quantityLimitsDaysText : ctx.drugRestrictionNoText);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("header", ctx.stepTherapyTooltip.tooltip.header)("body", ctx.stepTherapyTooltip.tooltip.body)("Spa_Site_Tooltip_Text", ctx.Spa_Site_Tooltip_Text)("ariaLabel", ctx.stepTherapyTooltip.label)("customClass", "Spa_Style_Accent2_Background Spa_Style_Secondary_Text_Color border-radius-12 px-2 py-1");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.stepTherapyTooltip.label, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.drugCostDetails.formularyStatus.hasStepTherapy ? ctx.drugRestrictionYesText : ctx.drugRestrictionNoText);
    } }, dependencies: [i1$2.NgIf, TooltipComponent], styles: [".drug-card-section[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);box-shadow:none;border-width:0 1px 1px 1px;padding-left:15px;padding-right:15px}.drug-card-restriction-header[_ngcontent-%COMP%]{display:flex;align-items:center;background-color:var(--static-Spa_Style_Gray1);border-right:1px solid var(--static-Spa_Style_Accent1);padding:15px;font-weight:700}.tooltip-label[_ngcontent-%COMP%]{width:30px;float:left;text-align:center;border-radius:25px;margin-top:3px}.restriction-text[_ngcontent-%COMP%]{display:inline-block}.footnoteid[_ngcontent-%COMP%]{margin-left:4px}@media (max-width: 992px){.drug-card-restriction-header[_ngcontent-%COMP%]:first-child{border-bottom:1px solid var(--static-Spa_Style_Accent1);border-right:none;justify-content:center}.tooltip-border[_ngcontent-%COMP%]{margin:0 auto;flex:none;width:auto}.restriction-tooltip[_ngcontent-%COMP%]{float:none;display:inline-block;vertical-align:middle}.restriction-wrapper[_ngcontent-%COMP%]{margin-bottom:10px}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugRestrictionsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-drug-restrictions', template: "<div class=\"drug-card-section\">\r\n  <div class=\"row\" role=\"row\">\r\n    <div role=\"rowheader\" class=\"col-12 col-md-3 drug-card-restriction-header Spa_Style_Smaller_Font\">\r\n      {{ drugRestrictionHeaderText }}\r\n    </div>\r\n    <div class=\"col-12 col-md-9 d-md-inline-flex p-3 tooltip-border\" role=\"cell\">\r\n      <div class=\"restriction-wrapper mr-md-4\">\r\n        <div class=\"restriction-tooltip float-left position-relative\">\r\n          <vnext-tooltip\r\n            [header]=\"priorAuthorizationTooltip.tooltip.header\"\r\n            [body]=\"priorAuthorizationTooltip.tooltip.body\"\r\n            [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n            [ariaLabel]=\"priorAuthorizationTooltip.label\"\r\n            [customClass]=\"'Spa_Style_Accent6_Background Spa_Style_Secondary_Text_Color border-radius-12 px-2 py-1'\"\r\n          >\r\n            {{ priorAuthorizationTooltip.label }}\r\n          </vnext-tooltip>\r\n        </div>\r\n        <span class=\"ml-2 mt-1 restriction-text Spa_Style_Smaller_Font\">{{\r\n          drugCostDetails.formularyStatus.hasPriorAuthorization ? drugRestrictionYesText : drugRestrictionNoText\r\n        }}</span>\r\n        <sup class=\"Spa_Style_Note footnoteid\" *ngIf=\"isFootnoteAIdAvailable\">{{ footnoteAId }}</sup>\r\n      </div>\r\n      <div class=\"restriction-wrapper mr-md-4\">\r\n        <div class=\"restriction-tooltip float-left position-relative\">\r\n          <vnext-tooltip\r\n            [header]=\"quantityLimitTooltip.tooltip.header\"\r\n            [body]=\"quantityLimitTooltip.tooltip.body\"\r\n            [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n            [ariaLabel]=\"quantityLimitTooltip.label\"\r\n            [customClass]=\"'Spa_Style_Primary_Link_Background Spa_Style_Secondary_Text_Color border-radius-12 px-2 py-1'\"\r\n          >\r\n            {{ quantityLimitTooltip.label }}\r\n          </vnext-tooltip>\r\n        </div>\r\n        <span class=\"ml-2 mt-1 restriction-text Spa_Style_Smaller_Font Spa_Style_Primary_Color can-click\">{{\r\n          drugCostDetails.formularyStatus.hasQuantityLimit\r\n            ? drugCostDetails.formularyStatus.quantityLimitAmount +\r\n              ' / ' +\r\n              drugCostDetails.formularyStatus.quantityLimitDays +\r\n              ' ' +\r\n              quantityLimitsDaysText\r\n            : drugRestrictionNoText\r\n        }}</span>\r\n      </div>\r\n      <div class=\"restriction-wrapper mr-md-4\">\r\n        <div class=\"restriction-tooltip float-left position-relative\">\r\n          <vnext-tooltip\r\n            [header]=\"stepTherapyTooltip.tooltip.header\"\r\n            [body]=\"stepTherapyTooltip.tooltip.body\"\r\n            [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n            [ariaLabel]=\"stepTherapyTooltip.label\"\r\n            [customClass]=\"'Spa_Style_Accent2_Background Spa_Style_Secondary_Text_Color border-radius-12 px-2 py-1'\"\r\n          >\r\n            {{ stepTherapyTooltip.label }}\r\n          </vnext-tooltip>\r\n        </div>\r\n        <span class=\"ml-2 mt-1 restriction-text Spa_Style_Smaller_Font\">{{\r\n          drugCostDetails.formularyStatus.hasStepTherapy ? drugRestrictionYesText : drugRestrictionNoText\r\n        }}</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".drug-card-section{border:1px solid var(--static-Spa_Style_Accent1);box-shadow:none;border-width:0 1px 1px 1px;padding-left:15px;padding-right:15px}.drug-card-restriction-header{display:flex;align-items:center;background-color:var(--static-Spa_Style_Gray1);border-right:1px solid var(--static-Spa_Style_Accent1);padding:15px;font-weight:700}.tooltip-label{width:30px;float:left;text-align:center;border-radius:25px;margin-top:3px}.restriction-text{display:inline-block}.footnoteid{margin-left:4px}@media (max-width: 992px){.drug-card-restriction-header:first-child{border-bottom:1px solid var(--static-Spa_Style_Accent1);border-right:none;justify-content:center}.tooltip-border{margin:0 auto;flex:none;width:auto}.restriction-tooltip{float:none;display:inline-block;vertical-align:middle}.restriction-wrapper{margin-bottom:10px}}\n"] }]
    }], null, { drugRestrictionHeaderText: [{
            type: Input
        }], priorAuthorizationTooltip: [{
            type: Input
        }], quantityLimitTooltip: [{
            type: Input
        }], stepTherapyTooltip: [{
            type: Input
        }], drugCostDetails: [{
            type: Input
        }], drugRestrictionYesText: [{
            type: Input
        }], drugRestrictionNoText: [{
            type: Input
        }], quantityLimitsDaysText: [{
            type: Input
        }], isFootnoteAIdAvailable: [{
            type: Input
        }], footnoteAId: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }] }); })();

function DrugCostsComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div")(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.Spa_DrugCosts_MailOrderCostTitle);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.Spa_DrugCosts_MailOrderCostMonthSupply);
} }
function DrugCostsComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.Spa_DrugCosts_RetailCostTitle);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.Spa_DrugCosts_RetailCostMonthSupply);
} }
function DrugCostsComponent_vnext_tooltip_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-tooltip", 13);
    i0.ɵɵelement(1, "i", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("body", ctx_r3.Spa_DrugCosts_RetailCostTooltipText)("Spa_Site_Tooltip_Text", ctx_r3.Spa_Site_Tooltip_Text)("ariaLabel", ctx_r3.moreInfoLabelText);
} }
function DrugCostsComponent_vnext_tooltip_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-tooltip", 13);
    i0.ɵɵelement(1, "i", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("body", ctx_r4.Spa_DrugCosts_BeforeGapTooltipText)("Spa_Site_Tooltip_Text", ctx_r4.Spa_Site_Tooltip_Text)("ariaLabel", ctx_r4.moreInfoLabelText);
} }
function DrugCostsComponent_div_26_vnext_tooltip_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-tooltip", 13);
    i0.ɵɵelement(1, "i", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("body", ctx_r7.Spa_DrugCosts_DuringGapTooltipText)("Spa_Site_Tooltip_Text", ctx_r7.Spa_Site_Tooltip_Text)("ariaLabel", ctx_r7.moreInfoLabelText);
} }
function DrugCostsComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8)(2, "span", 9);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, DrugCostsComponent_div_26_vnext_tooltip_4_Template, 2, 3, "vnext-tooltip", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 11)(6, "strong");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "currency");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r5.Spa_DrugCosts_DuringGapText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.Spa_DrugCosts_ShowTooltip);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind4(8, 3, ctx_r5.gapPrice, "USD", "symbol", "1.2-2"));
} }
function DrugCostsComponent_vnext_tooltip_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-tooltip", 13);
    i0.ɵɵelement(1, "i", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("body", ctx_r6.Spa_DrugCosts_AfterGapTooltipText)("Spa_Site_Tooltip_Text", ctx_r6.Spa_Site_Tooltip_Text)("ariaLabel", ctx_r6.moreInfoLabelText);
} }
let DrugCostsComponent = class DrugCostsComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, pharmacyFacade, drugDetailsFacade) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.pharmacyFacade = pharmacyFacade;
        this.drugDetailsFacade = drugDetailsFacade;
        this.subscriptions = [];
        this.Spa_DrugCosts_ShowTooltip = true;
        this.Spa_DrugCosts_RetailCostText = 'Retail Cost';
        this.Spa_DrugCosts_BeforeGapText = 'Before Gap';
        this.Spa_DrugCosts_DuringGapText = 'During Gap';
        this.Spa_DrugCosts_AfterGapText = 'After Gap';
        this.Spa_DrugCosts_RetailCostTitle = 'Retail cost';
        this.Spa_DrugCosts_RetailCostMonthSupply = '(1 month supply)';
        this.Spa_DrugCosts_MailOrderCostTitle = 'Mail order';
        this.Spa_DrugCosts_MailOrderCostMonthSupply = '(3 month supply)';
        this.Spa_DrugCosts_RetailCostTooltipText = `
  The full cost of the drug without coverage. Your copay is a portion of the retail cost`;
        this.Spa_DrugCosts_BeforeGapTooltipText = `
  Often called the 'Initial Coverage Phase' you will pay the plan's copays or coinsurance until a
 total drug cost of $4,020 is reached in 2020`;
        this.Spa_DrugCosts_DuringGapTooltipText = `
  Often called the 'Donut Hole Phase' you will pay the full cost of the drug until your total out of pocket costs reach $6,350 in 2020.`;
        this.Spa_DrugCosts_AfterGapTooltipText = `Often called the 'Catastrophic Phase' you will pay smaller monthly copays
  through the end of the calendar year once you have reached $6,350 in 2020 in out of pocket drug costs.`;
        this.Spa_Site_Tooltip_Text = 'Tooltip:';
        this.Spa_DrugCosts_RemoveDuringGap_Enabled = false;
        this.moreInfoLabelText = 'More info about Retail Cost';
    }
    ngOnInit() {
        super.ngOnInit();
        this.subscriptions = [
            this.pharmacyFacade.mailOrder$.subscribe({
                next: mailOrder => {
                    this.isMailOrder = mailOrder;
                    this.coverageStatus = this.drugDetailsFacade.getDrugCoverageForPrices(this.isMailOrder, this.plan.planMailOrderDrugCoverage, this.plan.planRetailDrugCoverageMultiPharmacy, this.selectedPharmacy, this.cabinet);
                    this.cdr.markForCheck();
                }
            })
        ];
    }
    get basePrice() {
        return this.coverageStatus && this.coverageStatus.basePrice ? this.coverageStatus.basePrice : 0;
    }
    get beforeGapPrice() {
        return this.coverageStatus && this.coverageStatus.beforeGapPrice ? this.coverageStatus.beforeGapPrice : 0;
    }
    get gapPrice() {
        return this.coverageStatus && this.coverageStatus.gapPrice ? this.coverageStatus.gapPrice : 0;
    }
    get afterGapPrice() {
        return this.coverageStatus && this.coverageStatus.afterGapPrice ? this.coverageStatus.afterGapPrice : 0;
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
};
DrugCostsComponent.ɵfac = function DrugCostsComponent_Factory(t) { return new (t || DrugCostsComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(PharmacyFacade), i0.ɵɵdirectiveInject(DrugDetailsFacade)); };
DrugCostsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DrugCostsComponent, selectors: [["vnext-drug-costs"]], inputs: { plan: "plan", cabinet: "cabinet", selectedPharmacy: "selectedPharmacy" }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 36, vars: 27, consts: [[1, "drug-costs-wrap"], ["role", "row", 1, "row"], ["role", "rowheader", 1, "col-12", "col-md-3", "cost-section-title", "Spa_Style_Smaller_Font"], [4, "ngIf", "ngIfElse"], ["isRetailOrder", ""], [1, "col-12", "col-md-9", "cost-section"], ["role", "cell", 1, "row", "phase-names-row"], [1, "col-12", "col-md-3"], [1, "phase-names"], [1, "phase-names-text", "Spa_Style_Smaller_Font"], [3, "body", "Spa_Site_Tooltip_Text", "ariaLabel", 4, "ngIf"], [1, "phase-names-cost", "float-right", "float-md-left"], ["class", "col-12 col-md-3", 4, "ngIf"], [3, "body", "Spa_Site_Tooltip_Text", "ariaLabel"], ["aria-hidden", "true", 1, "fas", "fa-question-circle", "icon-tooltip", "ml-1", "Spa_Style_Smaller_Font"]], template: function DrugCostsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, DrugCostsComponent_ng_container_3_Template, 6, 2, "ng-container", 3);
        i0.ɵɵtemplate(4, DrugCostsComponent_ng_template_4_Template, 5, 2, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5)(7, "div", 6)(8, "div", 7)(9, "div", 8)(10, "span", 9);
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, DrugCostsComponent_vnext_tooltip_12_Template, 2, 3, "vnext-tooltip", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 11)(14, "strong");
        i0.ɵɵtext(15);
        i0.ɵɵpipe(16, "currency");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(17, "div", 7)(18, "div", 8)(19, "span", 9);
        i0.ɵɵtext(20);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(21, DrugCostsComponent_vnext_tooltip_21_Template, 2, 3, "vnext-tooltip", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 11)(23, "strong");
        i0.ɵɵtext(24);
        i0.ɵɵpipe(25, "currency");
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(26, DrugCostsComponent_div_26_Template, 9, 8, "div", 12);
        i0.ɵɵelementStart(27, "div", 7)(28, "div", 8)(29, "span", 9);
        i0.ɵɵtext(30);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(31, DrugCostsComponent_vnext_tooltip_31_Template, 2, 3, "vnext-tooltip", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "div", 11)(33, "strong");
        i0.ɵɵtext(34);
        i0.ɵɵpipe(35, "currency");
        i0.ɵɵelementEnd()()()()()()();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(5);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isMailOrder)("ngIfElse", _r1);
        i0.ɵɵadvance(8);
        i0.ɵɵtextInterpolate(ctx.Spa_DrugCosts_RetailCostText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_DrugCosts_ShowTooltip);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind4(16, 12, ctx.basePrice, "USD", "symbol", "1.2-2"));
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.Spa_DrugCosts_BeforeGapText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_DrugCosts_ShowTooltip);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind4(25, 17, ctx.beforeGapPrice, "USD", "symbol", "1.2-2"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.Spa_DrugCosts_RemoveDuringGap_Enabled);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.Spa_DrugCosts_AfterGapText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_DrugCosts_ShowTooltip);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind4(35, 22, ctx.afterGapPrice, "USD", "symbol", "1.2-2"));
    } }, dependencies: [i1$2.NgIf, TooltipComponent, IconAriaAttributesDirective, i1$2.CurrencyPipe], styles: [".drug-card-section[_ngcontent-%COMP%]{background:white;border:1px solid var(--static-Spa_Style_Accent1);box-shadow:none}.drug-costs-wrap[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);padding-left:15px;padding-right:15px;margin:-1px 0 0}.cost-section-title[_ngcontent-%COMP%]{padding:15px;border-right:1px solid var(--static-Spa_Style_Accent1);background-color:var(--static-Spa_Style_Gray1);display:flex;align-items:center;font-family:montserratregular;color:var(--static-Spa_Style_Primary);font-weight:700}.cost-section[_ngcontent-%COMP%]{padding:15px}.phase-names-text[_ngcontent-%COMP%]{display:inline;align-items:center;font-family:montserratregular;color:var(--static-Spa_Style_Primary)}.icon-tooltip[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Gray4)}@media (max-width: 992px){.cost-section-title[_ngcontent-%COMP%]{text-align:center;border-right:none;border-bottom:1px solid var(--static-Spa_Style_Accent1);justify-content:center}.phase-names-cost[_ngcontent-%COMP%]{margin-bottom:10px}.phase-names[_ngcontent-%COMP%]{margin-bottom:10px;float:left;min-height:45px}.cost-section-title[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{display:inline-block;margin-right:5px}}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], DrugCostsComponent.prototype, "Spa_DrugCosts_ShowTooltip", void 0);
__decorate([
    GlobalResource()
], DrugCostsComponent.prototype, "Spa_DrugCosts_RetailCostText", void 0);
__decorate([
    GlobalResource()
], DrugCostsComponent.prototype, "Spa_DrugCosts_BeforeGapText", void 0);
__decorate([
    GlobalResource()
], DrugCostsComponent.prototype, "Spa_DrugCosts_DuringGapText", void 0);
__decorate([
    GlobalResource()
], DrugCostsComponent.prototype, "Spa_DrugCosts_AfterGapText", void 0);
__decorate([
    GlobalResource()
], DrugCostsComponent.prototype, "Spa_DrugCosts_RetailCostTitle", void 0);
__decorate([
    GlobalResource()
], DrugCostsComponent.prototype, "Spa_DrugCosts_RetailCostMonthSupply", void 0);
__decorate([
    GlobalResource()
], DrugCostsComponent.prototype, "Spa_DrugCosts_MailOrderCostTitle", void 0);
__decorate([
    GlobalResource()
], DrugCostsComponent.prototype, "Spa_DrugCosts_MailOrderCostMonthSupply", void 0);
__decorate([
    GlobalResource()
], DrugCostsComponent.prototype, "Spa_DrugCosts_RetailCostTooltipText", void 0);
__decorate([
    GlobalResource()
], DrugCostsComponent.prototype, "Spa_DrugCosts_BeforeGapTooltipText", void 0);
__decorate([
    GlobalResource()
], DrugCostsComponent.prototype, "Spa_DrugCosts_DuringGapTooltipText", void 0);
__decorate([
    GlobalResource()
], DrugCostsComponent.prototype, "Spa_DrugCosts_AfterGapTooltipText", void 0);
__decorate([
    GlobalResource()
], DrugCostsComponent.prototype, "Spa_Site_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], DrugCostsComponent.prototype, "Spa_DrugCosts_RemoveDuringGap_Enabled", void 0);
DrugCostsComponent = __decorate([
    PlatformWidget
], DrugCostsComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugCostsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-drug-costs', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"drug-costs-wrap\">\r\n  <div class=\"row\" role=\"row\">\r\n    <div role=\"rowheader\" class=\"col-12 col-md-3 cost-section-title Spa_Style_Smaller_Font\">\r\n      <ng-container *ngIf=\"isMailOrder; else isRetailOrder\">\r\n        <div>\r\n          <div>{{ Spa_DrugCosts_MailOrderCostTitle }}</div>\r\n          <div>{{ Spa_DrugCosts_MailOrderCostMonthSupply }}</div>\r\n        </div>\r\n      </ng-container>\r\n      <ng-template #isRetailOrder>\r\n        <div>\r\n          <div>{{ Spa_DrugCosts_RetailCostTitle }}</div>\r\n          <div>{{ Spa_DrugCosts_RetailCostMonthSupply }}</div>\r\n        </div>\r\n      </ng-template>\r\n    </div>\r\n    <div class=\"col-12 col-md-9 cost-section\">\r\n      <div class=\"row phase-names-row\" role=\"cell\">\r\n        <div class=\"col-12 col-md-3\">\r\n          <div class=\"phase-names\">\r\n            <span class=\"phase-names-text Spa_Style_Smaller_Font\">{{ Spa_DrugCosts_RetailCostText }}</span>\r\n            <vnext-tooltip\r\n              [body]=\"Spa_DrugCosts_RetailCostTooltipText\"\r\n              [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n              [ariaLabel]=\"moreInfoLabelText\"\r\n              *ngIf=\"Spa_DrugCosts_ShowTooltip\"\r\n            >\r\n              <i class=\"fas fa-question-circle icon-tooltip ml-1 Spa_Style_Smaller_Font\" aria-hidden=\"true\"></i>\r\n            </vnext-tooltip>\r\n          </div>\r\n          <div class=\"phase-names-cost float-right float-md-left\">\r\n            <strong>{{ basePrice | currency : 'USD' : 'symbol' : '1.2-2' }}</strong>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-12 col-md-3\">\r\n          <div class=\"phase-names\">\r\n            <span class=\"phase-names-text Spa_Style_Smaller_Font\">{{ Spa_DrugCosts_BeforeGapText }}</span>\r\n            <vnext-tooltip\r\n              [body]=\"Spa_DrugCosts_BeforeGapTooltipText\"\r\n              [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n              [ariaLabel]=\"moreInfoLabelText\"\r\n              *ngIf=\"Spa_DrugCosts_ShowTooltip\"\r\n            >\r\n              <i class=\"fas fa-question-circle icon-tooltip ml-1 Spa_Style_Smaller_Font\" aria-hidden=\"true\"></i>\r\n            </vnext-tooltip>\r\n          </div>\r\n          <div class=\"phase-names-cost float-right float-md-left\">\r\n            <strong>{{ beforeGapPrice | currency : 'USD' : 'symbol' : '1.2-2' }}</strong>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-12 col-md-3\" *ngIf=\"!Spa_DrugCosts_RemoveDuringGap_Enabled\">\r\n          <div class=\"phase-names\">\r\n            <span class=\"phase-names-text Spa_Style_Smaller_Font\">{{ Spa_DrugCosts_DuringGapText }}</span>\r\n            <vnext-tooltip\r\n              [body]=\"Spa_DrugCosts_DuringGapTooltipText\"\r\n              [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n              [ariaLabel]=\"moreInfoLabelText\"\r\n              *ngIf=\"Spa_DrugCosts_ShowTooltip\"\r\n            >\r\n              <i class=\"fas fa-question-circle icon-tooltip ml-1 Spa_Style_Smaller_Font\" aria-hidden=\"true\"></i>\r\n            </vnext-tooltip>\r\n          </div>\r\n          <div class=\"phase-names-cost float-right float-md-left\">\r\n            <strong>{{ gapPrice | currency : 'USD' : 'symbol' : '1.2-2' }}</strong>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-12 col-md-3\">\r\n          <div class=\"phase-names\">\r\n            <span class=\"phase-names-text Spa_Style_Smaller_Font\">{{ Spa_DrugCosts_AfterGapText }}</span>\r\n            <vnext-tooltip\r\n              [body]=\"Spa_DrugCosts_AfterGapTooltipText\"\r\n              [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n              [ariaLabel]=\"moreInfoLabelText\"\r\n              *ngIf=\"Spa_DrugCosts_ShowTooltip\"\r\n            >\r\n              <i class=\"fas fa-question-circle icon-tooltip ml-1 Spa_Style_Smaller_Font\" aria-hidden=\"true\"></i>\r\n            </vnext-tooltip>\r\n          </div>\r\n          <div class=\"phase-names-cost float-right float-md-left\">\r\n            <strong>{{ afterGapPrice | currency : 'USD' : 'symbol' : '1.2-2' }}</strong>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".drug-card-section{background:white;border:1px solid var(--static-Spa_Style_Accent1);box-shadow:none}.drug-costs-wrap{border:1px solid var(--static-Spa_Style_Accent1);padding-left:15px;padding-right:15px;margin:-1px 0 0}.cost-section-title{padding:15px;border-right:1px solid var(--static-Spa_Style_Accent1);background-color:var(--static-Spa_Style_Gray1);display:flex;align-items:center;font-family:montserratregular;color:var(--static-Spa_Style_Primary);font-weight:700}.cost-section{padding:15px}.phase-names-text{display:inline;align-items:center;font-family:montserratregular;color:var(--static-Spa_Style_Primary)}.icon-tooltip{color:var(--static-Spa_Style_Gray4)}@media (max-width: 992px){.cost-section-title{text-align:center;border-right:none;border-bottom:1px solid var(--static-Spa_Style_Accent1);justify-content:center}.phase-names-cost{margin-bottom:10px}.phase-names{margin-bottom:10px;float:left;min-height:45px}.cost-section-title div{display:inline-block;margin-right:5px}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: PharmacyFacade }, { type: DrugDetailsFacade }]; }, { plan: [{
            type: Input
        }], cabinet: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], Spa_DrugCosts_ShowTooltip: [], Spa_DrugCosts_RetailCostText: [], Spa_DrugCosts_BeforeGapText: [], Spa_DrugCosts_DuringGapText: [], Spa_DrugCosts_AfterGapText: [], Spa_DrugCosts_RetailCostTitle: [], Spa_DrugCosts_RetailCostMonthSupply: [], Spa_DrugCosts_MailOrderCostTitle: [], Spa_DrugCosts_MailOrderCostMonthSupply: [], Spa_DrugCosts_RetailCostTooltipText: [], Spa_DrugCosts_BeforeGapTooltipText: [], Spa_DrugCosts_DuringGapTooltipText: [], Spa_DrugCosts_AfterGapTooltipText: [], Spa_Site_Tooltip_Text: [], Spa_DrugCosts_RemoveDuringGap_Enabled: [] }); })();

function DrugCardComponent_div_0_vnext_drug_costs_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-drug-costs", 8);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("plan", ctx_r1.plan)("cabinet", ctx_r1.cabinetEntry)("selectedPharmacy", ctx_r1.selectedPharmacy);
} }
function DrugCardComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3)(3, "vnext-drug-list-card", 4);
    i0.ɵɵlistener("viewPossibleAlternativeDrugs", function DrugCardComponent_div_0_Template_vnext_drug_list_card_viewPossibleAlternativeDrugs_3_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onViewPossibleAlternativeDrugs($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 5);
    i0.ɵɵtemplate(5, DrugCardComponent_div_0_vnext_drug_costs_5_Template, 1, 3, "vnext-drug-costs", 6);
    i0.ɵɵelement(6, "vnext-drug-restrictions", 7);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("plan", ctx_r0.plan)("cabinet", ctx_r0.cabinetEntry)("footnoteAId", ctx_r0.footnoteAId)("isDrugCostsTab", ctx_r0.isDrugCostsTab)("showGenericOption", ctx_r0.showGenericOption)("isCovered", ctx_r0.isCovered)("showCoverageNudge", false)("prescriptionsDrugAlternativesButtonText", ctx_r0.prescriptionsDrugAlternativesButtonText)("selectedPharmacy", ctx_r0.selectedPharmacy)("isEnabledShowDrugAlternatives", ctx_r0.isEnabledShowDrugAlternatives)("pharmacies", ctx_r0.pharmacies)("footnoteIds", ctx_r0.footnoteIds)("isMailOrderSelected", ctx_r0.isMailOrderSelected)("showDosePackageQuantityFrequency", ctx_r0.showDosePackageQuantityFrequency);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showCosts);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isFootnoteAIdAvailable", ctx_r0.isFootnoteAIdAvailable)("drugCostDetails", ctx_r0.drugCostDetails)("drugRestrictionHeaderText", ctx_r0.Spa_Site_Drug_Restriction_HeaderText)("priorAuthorizationTooltip", ctx_r0.Spa_Site_Drug_Restriction_PriorAuthorizationTooltip)("quantityLimitTooltip", ctx_r0.Spa_Site_Drug_Restriction_QuantityLimitTooltip)("stepTherapyTooltip", ctx_r0.Spa_Site_Drug_Restriction_StepTherapyTooltip)("drugRestrictionYesText", ctx_r0.Spa_Site_Drug_Restriction_YesText)("drugRestrictionNoText", ctx_r0.Spa_Site_Drug_Restriction_NoText)("quantityLimitsDaysText", ctx_r0.Spa_Site_Drug_Restriction_Quantity_Limit_DaysText)("footnoteAId", ctx_r0.footnoteAId)("Spa_Site_Tooltip_Text", ctx_r0.Spa_Site_Tooltip_Text);
} }
let DrugCardComponent = class DrugCardComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, pharmacyContext) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.pharmacyContext = pharmacyContext;
        this.showCosts = true;
        this.prescriptionsDrugAlternativesButtonText = '';
        this.showDosePackageQuantityFrequency = true;
        this.isEnabledShowDrugAlternatives = false;
        this.pharmacies = [];
        this.viewPossibleAlternativeDrugs = new EventEmitter();
        this.Spa_Site_Drug_Restriction_HeaderText = 'Restrictions';
        this.Spa_Site_Drug_Restriction_PriorAuthorizationTooltip = {
            label: 'PA',
            tooltip: { header: 'Prior Authorization', body: 'Requires permission from your doctor before certain prescriptions can be filled.' }
        };
        this.Spa_Site_Drug_Restriction_QuantityLimitTooltip = {
            label: 'QL',
            tooltip: {
                header: 'Quantity Limits',
                body: 'Some plans restrict the amount of a drug that will be covered for a single copay or within a predefined period of time.'
            }
        };
        this.Spa_Site_Drug_Restriction_StepTherapyTooltip = {
            label: 'ST',
            tooltip: {
                header: 'Step Therapy',
                body: 'Some plans require that you try safe, effective, lower-cost drugs before the plan covers a more costly drug.'
            }
        };
        this.Spa_Site_Drug_Restriction_YesText = 'Yes';
        this.Spa_Site_Drug_Restriction_NoText = 'No';
        this.Spa_Site_Drug_Restriction_Quantity_Limit_DaysText = 'Days';
        this.Spa_Site_Tooltip_Text = 'Tooltip:';
        this.isDrugCostsTab = true; // The drug card component passes this flag to disable edit/delete actions on card
        this.planType = PlanType;
        this.footnoteAId = 'A';
        this.footnoteIds = [];
        this.isFootnoteAIdAvailable = false;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        super.ngOnInit();
        this.cabinetEntry = this.cabinetEntry ?? this.medicineCabinet.find(entry => entry.dosageID === this.drugCostDetails.dosageId);
        this.subscriptions.add(this.pharmacyContext.getFootnoteIdsToShow$(this.plan, this.cabinetEntry?.dosage?.dosageId).subscribe(footnoteIds => {
            this.footnoteIds = footnoteIds;
            this.isFootnoteAIdAvailable = footnoteIds.indexOf(this.footnoteAId) !== -1 && this.plan.planType !== this.planType.MA;
            this.cdr.markForCheck();
        }));
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
    onViewPossibleAlternativeDrugs(cabinet) {
        this.viewPossibleAlternativeDrugs.emit(cabinet);
    }
};
DrugCardComponent.ɵfac = function DrugCardComponent_Factory(t) { return new (t || DrugCardComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(PharmacyContext)); };
DrugCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DrugCardComponent, selectors: [["vnext-drug-card"]], inputs: { drugCostDetails: "drugCostDetails", medicineCabinet: "medicineCabinet", cabinetEntry: "cabinetEntry", plan: "plan", showGenericOption: "showGenericOption", isCovered: "isCovered", showCosts: "showCosts", selectedPharmacy: "selectedPharmacy", prescriptionsDrugAlternativesButtonText: "prescriptionsDrugAlternativesButtonText", showDosePackageQuantityFrequency: "showDosePackageQuantityFrequency", isEnabledShowDrugAlternatives: "isEnabledShowDrugAlternatives", pharmacies: "pharmacies", isMailOrderSelected: "isMailOrderSelected" }, outputs: { viewPossibleAlternativeDrugs: "viewPossibleAlternativeDrugs" }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "row mb-2", 4, "ngIf"], [1, "row", "mb-2"], [1, "col-12"], ["role", "table", 1, "mt-2"], [3, "plan", "cabinet", "footnoteAId", "isDrugCostsTab", "showGenericOption", "isCovered", "showCoverageNudge", "prescriptionsDrugAlternativesButtonText", "selectedPharmacy", "isEnabledShowDrugAlternatives", "pharmacies", "footnoteIds", "isMailOrderSelected", "showDosePackageQuantityFrequency", "viewPossibleAlternativeDrugs"], ["role", "rowgroup"], [3, "plan", "cabinet", "selectedPharmacy", 4, "ngIf"], [3, "isFootnoteAIdAvailable", "drugCostDetails", "drugRestrictionHeaderText", "priorAuthorizationTooltip", "quantityLimitTooltip", "stepTherapyTooltip", "drugRestrictionYesText", "drugRestrictionNoText", "quantityLimitsDaysText", "footnoteAId", "Spa_Site_Tooltip_Text"], [3, "plan", "cabinet", "selectedPharmacy"]], template: function DrugCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, DrugCardComponent_div_0_Template, 7, 26, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.cabinetEntry);
    } }, dependencies: [i1$2.NgIf, DrugListCardComponent, DrugRestrictionsComponent, DrugCostsComponent], encapsulation: 2, changeDetection: 0 });
__decorate([
    GlobalResource()
], DrugCardComponent.prototype, "Spa_Site_Drug_Restriction_HeaderText", void 0);
__decorate([
    GlobalResource()
], DrugCardComponent.prototype, "Spa_Site_Drug_Restriction_PriorAuthorizationTooltip", void 0);
__decorate([
    GlobalResource()
], DrugCardComponent.prototype, "Spa_Site_Drug_Restriction_QuantityLimitTooltip", void 0);
__decorate([
    GlobalResource()
], DrugCardComponent.prototype, "Spa_Site_Drug_Restriction_StepTherapyTooltip", void 0);
__decorate([
    GlobalResource()
], DrugCardComponent.prototype, "Spa_Site_Drug_Restriction_YesText", void 0);
__decorate([
    GlobalResource()
], DrugCardComponent.prototype, "Spa_Site_Drug_Restriction_NoText", void 0);
__decorate([
    GlobalResource()
], DrugCardComponent.prototype, "Spa_Site_Drug_Restriction_Quantity_Limit_DaysText", void 0);
__decorate([
    GlobalResource()
], DrugCardComponent.prototype, "Spa_Site_Tooltip_Text", void 0);
DrugCardComponent = __decorate([
    PlatformWidget
], DrugCardComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugCardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-drug-card', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"row mb-2\" *ngIf=\"cabinetEntry\">\r\n  <div class=\"col-12\">\r\n    <div class=\"mt-2\" role=\"table\">\r\n      <vnext-drug-list-card\r\n        [plan]=\"plan\"\r\n        [cabinet]=\"cabinetEntry\"\r\n        [footnoteAId]=\"footnoteAId\"\r\n        [isDrugCostsTab]=\"isDrugCostsTab\"\r\n        [showGenericOption]=\"showGenericOption\"\r\n        [isCovered]=\"isCovered\"\r\n        [showCoverageNudge]=\"false\"\r\n        [prescriptionsDrugAlternativesButtonText]=\"prescriptionsDrugAlternativesButtonText\"\r\n        [selectedPharmacy]=\"selectedPharmacy\"\r\n        [isEnabledShowDrugAlternatives]=\"isEnabledShowDrugAlternatives\"\r\n        [pharmacies]=\"pharmacies\"\r\n        [footnoteIds]=\"footnoteIds\"\r\n        [isMailOrderSelected]=\"isMailOrderSelected\"\r\n        [showDosePackageQuantityFrequency]=\"showDosePackageQuantityFrequency\"\r\n        (viewPossibleAlternativeDrugs)=\"onViewPossibleAlternativeDrugs($event)\"\r\n      >\r\n      </vnext-drug-list-card>\r\n      <div role=\"rowgroup\">\r\n        <vnext-drug-costs [plan]=\"plan\" [cabinet]=\"cabinetEntry\" *ngIf=\"showCosts\" [selectedPharmacy]=\"selectedPharmacy\"></vnext-drug-costs>\r\n        <vnext-drug-restrictions\r\n          [isFootnoteAIdAvailable]=\"isFootnoteAIdAvailable\"\r\n          [drugCostDetails]=\"drugCostDetails\"\r\n          [drugRestrictionHeaderText]=\"Spa_Site_Drug_Restriction_HeaderText\"\r\n          [priorAuthorizationTooltip]=\"Spa_Site_Drug_Restriction_PriorAuthorizationTooltip\"\r\n          [quantityLimitTooltip]=\"Spa_Site_Drug_Restriction_QuantityLimitTooltip\"\r\n          [stepTherapyTooltip]=\"Spa_Site_Drug_Restriction_StepTherapyTooltip\"\r\n          [drugRestrictionYesText]=\"Spa_Site_Drug_Restriction_YesText\"\r\n          [drugRestrictionNoText]=\"Spa_Site_Drug_Restriction_NoText\"\r\n          [quantityLimitsDaysText]=\"Spa_Site_Drug_Restriction_Quantity_Limit_DaysText\"\r\n          [footnoteAId]=\"footnoteAId\"\r\n          [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n        ></vnext-drug-restrictions>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: PharmacyContext }]; }, { drugCostDetails: [{
            type: Input
        }], medicineCabinet: [{
            type: Input
        }], cabinetEntry: [{
            type: Input
        }], plan: [{
            type: Input
        }], showGenericOption: [{
            type: Input
        }], isCovered: [{
            type: Input
        }], showCosts: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], prescriptionsDrugAlternativesButtonText: [{
            type: Input
        }], showDosePackageQuantityFrequency: [{
            type: Input
        }], isEnabledShowDrugAlternatives: [{
            type: Input
        }], pharmacies: [{
            type: Input
        }], isMailOrderSelected: [{
            type: Input
        }], viewPossibleAlternativeDrugs: [{
            type: Output
        }], Spa_Site_Drug_Restriction_HeaderText: [], Spa_Site_Drug_Restriction_PriorAuthorizationTooltip: [], Spa_Site_Drug_Restriction_QuantityLimitTooltip: [], Spa_Site_Drug_Restriction_StepTherapyTooltip: [], Spa_Site_Drug_Restriction_YesText: [], Spa_Site_Drug_Restriction_NoText: [], Spa_Site_Drug_Restriction_Quantity_Limit_DaysText: [], Spa_Site_Tooltip_Text: [] }); })();

function DrugCostDetailsComponent_ng_container_1_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "h3", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const tier_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(tier_r4.tierDescription);
} }
function DrugCostDetailsComponent_ng_container_1_ng_container_1_ng_container_2_vnext_drug_card_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-drug-card", 8);
} if (rf & 2) {
    const details_r11 = ctx.$implicit;
    const ctx_r10 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("drugCostDetails", details_r11)("medicineCabinet", ctx_r10.medicineCabinet)("plan", ctx_r10.plan)("showGenericOption", ctx_r10.showGenericOption)("showCosts", ctx_r10.showCosts)("selectedPharmacy", ctx_r10.selectedPharmacy)("isMailOrderSelected", ctx_r10.isMailOrderSelected)("isCovered", ctx_r10.isCovered);
} }
function DrugCostDetailsComponent_ng_container_1_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DrugCostDetailsComponent_ng_container_1_ng_container_1_ng_container_2_vnext_drug_card_1_Template, 1, 8, "vnext-drug-card", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tier_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", tier_r4.drugCostDetails);
} }
function DrugCostDetailsComponent_ng_container_1_ng_container_1_ng_template_3_div_0_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r14.noPrescriptionInTier);
} }
function DrugCostDetailsComponent_ng_container_1_ng_container_1_ng_template_3_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, DrugCostDetailsComponent_ng_container_1_ng_container_1_ng_template_3_div_0_p_1_Template, 2, 1, "p", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_PrescriptionsTab_NotInTier_Text");
} }
function DrugCostDetailsComponent_ng_container_1_ng_container_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, DrugCostDetailsComponent_ng_container_1_ng_container_1_ng_template_3_div_0_Template, 2, 1, "div", 9);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", !ctx_r8.isHelpfulToolsView);
} }
function DrugCostDetailsComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DrugCostDetailsComponent_ng_container_1_ng_container_1_div_1_Template, 3, 1, "div", 3);
    i0.ɵɵtemplate(2, DrugCostDetailsComponent_ng_container_1_ng_container_1_ng_container_2_Template, 2, 1, "ng-container", 0);
    i0.ɵɵtemplate(3, DrugCostDetailsComponent_ng_container_1_ng_container_1_ng_template_3_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tier_r4 = ctx.$implicit;
    const _r7 = i0.ɵɵreference(4);
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", tier_r4.hasDrugs && ctx_r3.isHelpfulToolsView || !ctx_r3.isHelpfulToolsView);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", tier_r4.hasDrugs)("ngIfElse", _r7);
} }
function DrugCostDetailsComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DrugCostDetailsComponent_ng_container_1_ng_container_1_Template, 5, 3, "ng-container", 2);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.coveredTiers);
} }
function DrugCostDetailsComponent_ng_template_2_vnext_drug_card_0_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-drug-card", 14);
    i0.ɵɵlistener("viewPossibleAlternativeDrugs", function DrugCostDetailsComponent_ng_template_2_vnext_drug_card_0_Template_vnext_drug_card_viewPossibleAlternativeDrugs_0_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.onViewPossibleAlternativeDrugs($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const details_r16 = ctx.$implicit;
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("drugCostDetails", details_r16)("medicineCabinet", ctx_r15.medicineCabinet)("plan", ctx_r15.plan)("showGenericOption", ctx_r15.showGenericOption)("showCosts", ctx_r15.showCosts)("selectedPharmacy", ctx_r15.selectedPharmacy)("isCovered", ctx_r15.isCovered)("isMailOrderSelected", ctx_r15.isMailOrderSelected)("prescriptionsDrugAlternativesButtonText", ctx_r15.prescriptionsDrugAlternativesButtonText)("isEnabledShowDrugAlternatives", ctx_r15.isEnabledShowDrugAlternatives)("pharmacies", ctx_r15.pharmacies);
} }
function DrugCostDetailsComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, DrugCostDetailsComponent_ng_template_2_vnext_drug_card_0_Template, 1, 11, "vnext-drug-card", 13);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", ctx_r2.nonCoveredDrugCostDetails);
} }
class DrugCostDetailsComponent extends ConfigurableWidget {
    constructor() {
        super(...arguments);
        this.prescriptionsDrugAlternativesButtonText = '';
        this.isEnabledShowDrugAlternatives = false;
        this.pharmacies = [];
        this.viewPossibleAlternativeDrugs = new EventEmitter();
    }
    onViewPossibleAlternativeDrugs(cabinet) {
        this.viewPossibleAlternativeDrugs.emit(cabinet);
    }
}
DrugCostDetailsComponent.ɵfac = /*@__PURE__*/ function () { let ɵDrugCostDetailsComponent_BaseFactory; return function DrugCostDetailsComponent_Factory(t) { return (ɵDrugCostDetailsComponent_BaseFactory || (ɵDrugCostDetailsComponent_BaseFactory = i0.ɵɵgetInheritedFactory(DrugCostDetailsComponent)))(t || DrugCostDetailsComponent); }; }();
DrugCostDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DrugCostDetailsComponent, selectors: [["vnext-drug-cost-details"]], inputs: { isCovered: "isCovered", noPrescriptionInTier: "noPrescriptionInTier", medicineCabinet: "medicineCabinet", coveredTiers: "coveredTiers", nonCoveredDrugCostDetails: "nonCoveredDrugCostDetails", plan: "plan", showGenericOption: "showGenericOption", showCosts: "showCosts", isHelpfulToolsView: "isHelpfulToolsView", selectedPharmacy: "selectedPharmacy", prescriptionsDrugAlternativesButtonText: "prescriptionsDrugAlternativesButtonText", isEnabledShowDrugAlternatives: "isEnabledShowDrugAlternatives", pharmacies: "pharmacies", isMailOrderSelected: "isMailOrderSelected" }, outputs: { viewPossibleAlternativeDrugs: "viewPossibleAlternativeDrugs" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["notCoveredSection", ""], [4, "ngFor", "ngForOf"], ["class", "ml-1 mt-3 pt-3", 4, "ngIf"], ["noDrugs", ""], [1, "ml-1", "mt-3", "pt-3"], [1, "Spa_Style_Large_Font", "Spa_Style_Bold_Weight", "Spa_Style_Primary_Color"], [3, "drugCostDetails", "medicineCabinet", "plan", "showGenericOption", "showCosts", "selectedPharmacy", "isMailOrderSelected", "isCovered", 4, "ngFor", "ngForOf"], [3, "drugCostDetails", "medicineCabinet", "plan", "showGenericOption", "showCosts", "selectedPharmacy", "isMailOrderSelected", "isCovered"], ["class", "mt-2 ml-1", 4, "ngIf"], [1, "mt-2", "ml-1"], ["class", "mt-1 ml-1 Spa_Style_Note", 4, "liveEditProp"], [1, "mt-1", "ml-1", "Spa_Style_Note"], [3, "drugCostDetails", "medicineCabinet", "plan", "showGenericOption", "showCosts", "selectedPharmacy", "isCovered", "isMailOrderSelected", "prescriptionsDrugAlternativesButtonText", "isEnabledShowDrugAlternatives", "pharmacies", "viewPossibleAlternativeDrugs", 4, "ngFor", "ngForOf"], [3, "drugCostDetails", "medicineCabinet", "plan", "showGenericOption", "showCosts", "selectedPharmacy", "isCovered", "isMailOrderSelected", "prescriptionsDrugAlternativesButtonText", "isEnabledShowDrugAlternatives", "pharmacies", "viewPossibleAlternativeDrugs"]], template: function DrugCostDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, DrugCostDetailsComponent_ng_container_1_Template, 2, 1, "ng-container", 0);
        i0.ɵɵtemplate(2, DrugCostDetailsComponent_ng_template_2_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(3);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isCovered)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, LiveEditPropDirective, DrugCardComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugCostDetailsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-drug-cost-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div>\r\n  <!--Display covered drugs by tier-->\r\n  <ng-container *ngIf=\"isCovered; else notCoveredSection\">\r\n    <!--for each tier, check if we have drugs and display them-->\r\n    <ng-container *ngFor=\"let tier of coveredTiers\">\r\n      <div class=\"ml-1 mt-3 pt-3\" *ngIf=\"(tier.hasDrugs && isHelpfulToolsView) || !isHelpfulToolsView\">\r\n        <h3 class=\"Spa_Style_Large_Font Spa_Style_Bold_Weight Spa_Style_Primary_Color\">{{ tier.tierDescription }}</h3>\r\n      </div>\r\n      <ng-container *ngIf=\"tier.hasDrugs; else noDrugs\">\r\n        <vnext-drug-card\r\n          *ngFor=\"let details of tier.drugCostDetails\"\r\n          [drugCostDetails]=\"details\"\r\n          [medicineCabinet]=\"medicineCabinet\"\r\n          [plan]=\"plan\"\r\n          [showGenericOption]=\"showGenericOption\"\r\n          [showCosts]=\"showCosts\"\r\n          [selectedPharmacy]=\"selectedPharmacy\"\r\n          [isMailOrderSelected]=\"isMailOrderSelected\"\r\n          [isCovered]=\"isCovered\"\r\n        ></vnext-drug-card>\r\n      </ng-container>\r\n      <ng-template #noDrugs>\r\n        <div class=\"mt-2 ml-1\" *ngIf=\"!isHelpfulToolsView\">\r\n          <p class=\"mt-1 ml-1 Spa_Style_Note\" *liveEditProp=\"'Spa_PrescriptionsTab_NotInTier_Text'\">{{ noPrescriptionInTier }}</p>\r\n        </div>\r\n      </ng-template>\r\n    </ng-container>\r\n    <!--if we have drugs, display them, else display resource value that we don't-->\r\n  </ng-container>\r\n  <ng-template #notCoveredSection>\r\n    <!--Display non-covered items-->\r\n    <vnext-drug-card\r\n      *ngFor=\"let details of nonCoveredDrugCostDetails\"\r\n      [drugCostDetails]=\"details\"\r\n      [medicineCabinet]=\"medicineCabinet\"\r\n      [plan]=\"plan\"\r\n      [showGenericOption]=\"showGenericOption\"\r\n      [showCosts]=\"showCosts\"\r\n      [selectedPharmacy]=\"selectedPharmacy\"\r\n      [isCovered]=\"isCovered\"\r\n      [isMailOrderSelected]=\"isMailOrderSelected\"\r\n      [prescriptionsDrugAlternativesButtonText]=\"prescriptionsDrugAlternativesButtonText\"\r\n      [isEnabledShowDrugAlternatives]=\"isEnabledShowDrugAlternatives\"\r\n      [pharmacies]=\"pharmacies\"\r\n      (viewPossibleAlternativeDrugs)=\"onViewPossibleAlternativeDrugs($event)\"\r\n    ></vnext-drug-card>\r\n  </ng-template>\r\n</div>\r\n" }]
    }], null, { isCovered: [{
            type: Input
        }], noPrescriptionInTier: [{
            type: Input
        }], medicineCabinet: [{
            type: Input
        }], coveredTiers: [{
            type: Input
        }], nonCoveredDrugCostDetails: [{
            type: Input
        }], plan: [{
            type: Input
        }], showGenericOption: [{
            type: Input
        }], showCosts: [{
            type: Input
        }], isHelpfulToolsView: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], prescriptionsDrugAlternativesButtonText: [{
            type: Input
        }], isEnabledShowDrugAlternatives: [{
            type: Input
        }], pharmacies: [{
            type: Input
        }], isMailOrderSelected: [{
            type: Input
        }], viewPossibleAlternativeDrugs: [{
            type: Output
        }] }); })();

function DrugDetailsFooterComponent_ng_container_0_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DrugDetailsFooterComponent_ng_container_0_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 10);
    i0.ɵɵlistener("click", function DrugDetailsFooterComponent_ng_container_0_div_1_div_3_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r14.showCoverage.emit()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.checkDrugCoverageButtonText, " ");
} }
function DrugDetailsFooterComponent_ng_container_0_div_1_div_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DrugDetailsFooterComponent_ng_container_0_div_1_div_4_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DrugDetailsFooterComponent_ng_container_0_div_1_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, DrugDetailsFooterComponent_ng_container_0_div_1_div_4_div_2_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(4);
    const _r5 = i0.ɵɵreference(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r5);
} }
function DrugDetailsFooterComponent_ng_container_0_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, DrugDetailsFooterComponent_ng_container_0_div_1_div_4_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵtemplate(2, DrugDetailsFooterComponent_ng_container_0_div_1_div_4_div_2_Template, 2, 1, "div", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.showOffFormularyDrugAlternativesButton);
} }
function DrugDetailsFooterComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, DrugDetailsFooterComponent_ng_container_0_div_1_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtemplate(3, DrugDetailsFooterComponent_ng_container_0_div_1_div_3_Template, 3, 1, "div", 6);
    i0.ɵɵtemplate(4, DrugDetailsFooterComponent_ng_container_0_div_1_div_4_Template, 3, 2, "div", 9);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    const _r7 = i0.ɵɵreference(8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r7);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r9.showDrugCoverageDetails);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.showDrugCoverageDetails);
} }
function DrugDetailsFooterComponent_ng_container_0_div_2_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DrugDetailsFooterComponent_ng_container_0_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, DrugDetailsFooterComponent_ng_container_0_div_2_div_1_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementStart(2, "button", 10);
    i0.ɵɵlistener("click", function DrugDetailsFooterComponent_ng_container_0_div_2_div_1_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r22.showCoverage.emit()); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    const _r7 = i0.ɵɵreference(8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r7);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r19.checkDrugCoverageButtonText, " ");
} }
function DrugDetailsFooterComponent_ng_container_0_div_2_div_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DrugDetailsFooterComponent_ng_container_0_div_2_div_2_div_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DrugDetailsFooterComponent_ng_container_0_div_2_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtemplate(1, DrugDetailsFooterComponent_ng_container_0_div_2_div_2_div_5_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(4);
    const _r5 = i0.ɵɵreference(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r5);
} }
function DrugDetailsFooterComponent_ng_container_0_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17)(1, "div", 18);
    i0.ɵɵtemplate(2, DrugDetailsFooterComponent_ng_container_0_div_2_div_2_ng_container_2_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵelement(4, "div", 19);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, DrugDetailsFooterComponent_ng_container_0_div_2_div_2_div_5_Template, 2, 1, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    const _r7 = i0.ɵɵreference(8);
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r7);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r20.showOffFormularyDrugAlternativesButton);
} }
function DrugDetailsFooterComponent_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, DrugDetailsFooterComponent_ng_container_0_div_2_div_1_Template, 4, 2, "div", 14);
    i0.ɵɵtemplate(2, DrugDetailsFooterComponent_ng_container_0_div_2_div_2_Template, 6, 3, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r10.showDrugCoverageDetails);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.showDrugCoverageDetails);
} }
function DrugDetailsFooterComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DrugDetailsFooterComponent_ng_container_0_div_1_Template, 5, 3, "div", 5);
    i0.ɵɵtemplate(2, DrugDetailsFooterComponent_ng_container_0_div_2_Template, 3, 2, "div", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isMobile);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isMobile);
} }
function DrugDetailsFooterComponent_ng_template_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function DrugDetailsFooterComponent_ng_template_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 24);
    i0.ɵɵlistener("click", function DrugDetailsFooterComponent_ng_template_1_ng_container_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r32); const ctx_r31 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r31.addDrug.emit()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "span", 25);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngbTooltip", ctx_r28.inCabinetErrorMessage);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r28.addButtonText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r28.inCabinetErrorMessage);
} }
function DrugDetailsFooterComponent_ng_template_1_ng_template_3_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 10);
    i0.ɵɵlistener("click", function DrugDetailsFooterComponent_ng_template_1_ng_template_3_ng_container_0_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r36.addDrug.emit()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r33.addButtonText);
} }
function DrugDetailsFooterComponent_ng_template_1_ng_template_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "span", 25);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngbTooltip", ctx_r35.cabinetLimitErrorMessage);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r35.addButtonText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r35.cabinetLimitErrorMessage);
} }
function DrugDetailsFooterComponent_ng_template_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, DrugDetailsFooterComponent_ng_template_1_ng_template_3_ng_container_0_Template, 3, 1, "ng-container", 0);
    i0.ɵɵtemplate(1, DrugDetailsFooterComponent_ng_template_1_ng_template_3_ng_template_1_Template, 4, 3, "ng-template", null, 26, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r34 = i0.ɵɵreference(2);
    const ctx_r30 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r30.drugCountInLimits)("ngIfElse", _r34);
} }
function DrugDetailsFooterComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtemplate(1, DrugDetailsFooterComponent_ng_template_1_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵtemplate(2, DrugDetailsFooterComponent_ng_template_1_ng_container_2_Template, 5, 3, "ng-container", 0);
    i0.ɵɵtemplate(3, DrugDetailsFooterComponent_ng_template_1_ng_template_3_Template, 3, 2, "ng-template", null, 23, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r29 = i0.ɵɵreference(4);
    const ctx_r2 = i0.ɵɵnextContext();
    const _r7 = i0.ɵɵreference(8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.inCabinet)("ngIfElse", _r29);
} }
function DrugDetailsFooterComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 28);
    i0.ɵɵlistener("click", function DrugDetailsFooterComponent_ng_template_3_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r39); const ctx_r38 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r38.hideCoverage.emit()); })("keyup.Space", function DrugDetailsFooterComponent_ng_template_3_Template_vnext_link_keyup_Space_0_listener() { i0.ɵɵrestoreView(_r39); const ctx_r40 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r40.hideCoverage.emit()); })("keyup.Enter", function DrugDetailsFooterComponent_ng_template_3_Template_vnext_link_keyup_Enter_0_listener() { i0.ɵɵrestoreView(_r39); const ctx_r41 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r41.hideCoverage.emit()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r4.editDrugText)("showArrow", "left");
} }
function DrugDetailsFooterComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 29);
    i0.ɵɵlistener("click", function DrugDetailsFooterComponent_ng_template_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r43); const ctx_r42 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r42.viewPossibleAlternativeDrugs.emit()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.prescriptionsDrugAlternativesButtonText, " ");
} }
function DrugDetailsFooterComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 30);
    i0.ɵɵlistener("click", function DrugDetailsFooterComponent_ng_template_7_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r45); const ctx_r44 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r44.cancel.emit()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r8.cancelButtonText);
} }
class DrugDetailsFooterComponent {
    constructor() {
        this.isMobile = false;
        this.addDrug = new EventEmitter();
        this.showCoverage = new EventEmitter();
        this.hideCoverage = new EventEmitter();
        this.viewPossibleAlternativeDrugs = new EventEmitter();
        this.cancel = new EventEmitter();
    }
}
DrugDetailsFooterComponent.ɵfac = function DrugDetailsFooterComponent_Factory(t) { return new (t || DrugDetailsFooterComponent)(); };
DrugDetailsFooterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DrugDetailsFooterComponent, selectors: [["vnext-drug-details-footer"]], inputs: { helpfulTools: "helpfulTools", inCabinet: "inCabinet", addButtonText: "addButtonText", inCabinetErrorMessage: "inCabinetErrorMessage", drugCountInLimits: "drugCountInLimits", cabinetLimitErrorMessage: "cabinetLimitErrorMessage", showDrugCoverageDetails: "showDrugCoverageDetails", checkDrugCoverageButtonText: "checkDrugCoverageButtonText", editDrugText: "editDrugText", cancelButtonText: "cancelButtonText", showOffFormularyDrugAlternativesButton: "showOffFormularyDrugAlternativesButton", prescriptionsDrugAlternativesButtonText: "prescriptionsDrugAlternativesButtonText", isMobile: "isMobile" }, outputs: { addDrug: "addDrug", showCoverage: "showCoverage", hideCoverage: "hideCoverage", viewPossibleAlternativeDrugs: "viewPossibleAlternativeDrugs", cancel: "cancel" }, decls: 9, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["actionButtons", ""], ["cancelCoverageButton", ""], ["viewPossibleAlternativeDrugsButton", ""], ["cancelButton", ""], ["class", "d-flex justify-content-sm-between", 4, "ngIf"], [4, "ngIf"], [1, "d-flex", "justify-content-sm-between"], [4, "ngTemplateOutlet"], ["class", "d-flex flex-row align-items-center", 4, "ngIf"], [1, "btn", "Spa_Style_PrimaryButton", 3, "click"], [1, "d-flex", "flex-row", "align-items-center"], ["class", "d-flex ml-2 justify-content-end", 4, "ngIf"], [1, "d-flex", "ml-2", "justify-content-end"], ["class", "d-flex flex-row justify-content-between", 4, "ngIf"], ["class", "d-flex flex-column", 4, "ngIf"], [1, "d-flex", "flex-row", "justify-content-between"], [1, "d-flex", "flex-column"], [1, "d-flex", "flex-row", "justify-content-between", "align-items-center"], [3, "ngTemplateOutlet"], ["class", "mt-2", 4, "ngIf"], [1, "mt-2"], [1, "d-flex", "justify-content-between"], ["notInCabinet", ""], ["triggers", "click:blur", "placement", "top-right", "tooltipClass", "drug-error-message", 1, "btn", "Spa_Style_PrimaryButton", 3, "ngbTooltip", "click"], [1, "sr-only"], ["informDisable", ""], ["triggers", "click:blur", "placement", "top-right", "tooltipClass", "drug-error-message", 1, "btn", "Spa_Style_PrimaryButton", 3, "ngbTooltip"], [3, "title", "showArrow", "click", "keyup.Space", "keyup.Enter"], ["type", "button", 1, "btn", "d-block", "text-break", "Spa_Style_PrimaryButton", "Spa_Style_Small_Font", "px-2", "w-100", 3, "click"], [1, "btn", "Spa_Style_SecondaryButton", 3, "click"]], template: function DrugDetailsFooterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, DrugDetailsFooterComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
        i0.ɵɵtemplate(1, DrugDetailsFooterComponent_ng_template_1_Template, 5, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(3, DrugDetailsFooterComponent_ng_template_3_Template, 1, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(5, DrugDetailsFooterComponent_ng_template_5_Template, 2, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(7, DrugDetailsFooterComponent_ng_template_7_Template, 2, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.helpfulTools)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgIf, i1$2.NgTemplateOutlet, LinkComponent, i1$1.NgbTooltip], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugDetailsFooterComponent, [{
        type: Component,
        args: [{ selector: 'vnext-drug-details-footer', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"helpfulTools; else actionButtons\">\r\n  <div *ngIf=\"!isMobile\" class=\"d-flex justify-content-sm-between\">\r\n    <ng-container *ngTemplateOutlet=\"cancelButton\"></ng-container>\r\n    <div>\r\n      <div *ngIf=\"!showDrugCoverageDetails\">\r\n        <button class=\"btn Spa_Style_PrimaryButton\" (click)=\"showCoverage.emit()\">\r\n          {{ checkDrugCoverageButtonText }}\r\n        </button>\r\n      </div>\r\n\r\n      <div *ngIf=\"showDrugCoverageDetails\" class=\"d-flex flex-row align-items-center\">\r\n        <ng-container *ngTemplateOutlet=\"cancelCoverageButton\"></ng-container>\r\n        <div *ngIf=\"showOffFormularyDrugAlternativesButton\" class=\"d-flex ml-2 justify-content-end\">\r\n          <ng-container *ngTemplateOutlet=\"viewPossibleAlternativeDrugsButton\"></ng-container>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"isMobile\">\r\n    <div *ngIf=\"!showDrugCoverageDetails\" class=\"d-flex flex-row justify-content-between\">\r\n      <ng-container *ngTemplateOutlet=\"cancelButton\"></ng-container>\r\n      <button class=\"btn Spa_Style_PrimaryButton\" (click)=\"showCoverage.emit()\">\r\n        {{ checkDrugCoverageButtonText }}\r\n      </button>\r\n    </div>\r\n\r\n    <div *ngIf=\"showDrugCoverageDetails\" class=\"d-flex flex-column\">\r\n      <div class=\"d-flex flex-row justify-content-between align-items-center\">\r\n        <ng-container *ngTemplateOutlet=\"cancelButton\"></ng-container>\r\n        <ng-container>\r\n          <div [ngTemplateOutlet]=\"cancelCoverageButton\"></div>\r\n        </ng-container>\r\n      </div>\r\n\r\n      <div *ngIf=\"showOffFormularyDrugAlternativesButton\" class=\"mt-2\">\r\n        <ng-container *ngTemplateOutlet=\"viewPossibleAlternativeDrugsButton\"></ng-container>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n\r\n<ng-template #actionButtons>\r\n  <div class=\"d-flex justify-content-between\">\r\n    <ng-container *ngTemplateOutlet=\"cancelButton\"></ng-container>\r\n    <ng-container *ngIf=\"inCabinet; else notInCabinet\">\r\n      <button\r\n        class=\"btn Spa_Style_PrimaryButton\"\r\n        [ngbTooltip]=\"inCabinetErrorMessage\"\r\n        triggers=\"click:blur\"\r\n        placement=\"top-right\"\r\n        tooltipClass=\"drug-error-message\"\r\n        (click)=\"addDrug.emit()\"\r\n      >\r\n        {{ addButtonText }} <span class=\"sr-only\">{{ inCabinetErrorMessage }}</span>\r\n      </button>\r\n    </ng-container>\r\n    <ng-template #notInCabinet>\r\n      <ng-container *ngIf=\"drugCountInLimits; else informDisable\">\r\n        <button class=\"btn Spa_Style_PrimaryButton\" (click)=\"addDrug.emit()\">{{ addButtonText }}</button>\r\n      </ng-container>\r\n      <ng-template #informDisable>\r\n        <button\r\n          class=\"btn Spa_Style_PrimaryButton\"\r\n          [ngbTooltip]=\"cabinetLimitErrorMessage\"\r\n          triggers=\"click:blur\"\r\n          placement=\"top-right\"\r\n          tooltipClass=\"drug-error-message\"\r\n        >\r\n          {{ addButtonText }} <span class=\"sr-only\">{{ cabinetLimitErrorMessage }}</span>\r\n        </button>\r\n      </ng-template>\r\n    </ng-template>\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #cancelCoverageButton>\r\n  <vnext-link\r\n    (click)=\"hideCoverage.emit()\"\r\n    (keyup.Space)=\"hideCoverage.emit()\"\r\n    (keyup.Enter)=\"hideCoverage.emit()\"\r\n    [title]=\"editDrugText\"\r\n    [showArrow]=\"'left'\"\r\n  ></vnext-link>\r\n</ng-template>\r\n\r\n<ng-template #viewPossibleAlternativeDrugsButton>\r\n  <button\r\n    type=\"button\"\r\n    class=\"btn d-block text-break Spa_Style_PrimaryButton Spa_Style_Small_Font px-2 w-100\"\r\n    (click)=\"viewPossibleAlternativeDrugs.emit()\"\r\n  >\r\n    {{ prescriptionsDrugAlternativesButtonText }}\r\n  </button>\r\n</ng-template>\r\n\r\n<ng-template #cancelButton>\r\n  <button class=\"btn Spa_Style_SecondaryButton\" (click)=\"cancel.emit()\">{{ cancelButtonText }}</button>\r\n</ng-template>\r\n" }]
    }], null, { helpfulTools: [{
            type: Input
        }], inCabinet: [{
            type: Input
        }], addButtonText: [{
            type: Input
        }], inCabinetErrorMessage: [{
            type: Input
        }], drugCountInLimits: [{
            type: Input
        }], cabinetLimitErrorMessage: [{
            type: Input
        }], showDrugCoverageDetails: [{
            type: Input
        }], checkDrugCoverageButtonText: [{
            type: Input
        }], editDrugText: [{
            type: Input
        }], cancelButtonText: [{
            type: Input
        }], showOffFormularyDrugAlternativesButton: [{
            type: Input
        }], prescriptionsDrugAlternativesButtonText: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], addDrug: [{
            type: Output
        }], showCoverage: [{
            type: Output
        }], hideCoverage: [{
            type: Output
        }], viewPossibleAlternativeDrugs: [{
            type: Output
        }], cancel: [{
            type: Output
        }] }); })();

var PrescriptionTabViewMode;
(function (PrescriptionTabViewMode) {
    PrescriptionTabViewMode["DEFAULT"] = "DEFAULT";
    PrescriptionTabViewMode["ALTERNATIVES_OFF_FORMULARY_DRUGS"] = "ALTERNATIVES_OFF_FORMULARY_DRUGS";
})(PrescriptionTabViewMode || (PrescriptionTabViewMode = {}));

const _c0$2i = ["dosages"];
const _c1$16 = function (a0, a1) { return { "Spa_Style_SecondaryButtonSelected Spa_Style_Primary_Link_Border Spa_Style_Bold_Weight": a0, "Spa_Style_SecondaryButton Spa_Style_Regular_Weight": a1 }; };
function DrugDosageComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2, 3);
    i0.ɵɵlistener("click", function DrugDosageComponent_div_1_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const dosage_r1 = restoredCtx.$implicit; const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.setDosage(dosage_r1)); })("keyup.arrowup", function DrugDosageComponent_div_1_Template_div_keyup_arrowup_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.setCheckedToPreviousItem(index_r2, $event)); })("keyup.arrowleft", function DrugDosageComponent_div_1_Template_div_keyup_arrowleft_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.setCheckedToPreviousItem(index_r2, $event)); })("keyup.arrowdown", function DrugDosageComponent_div_1_Template_div_keyup_arrowdown_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.setCheckedToNextItem(index_r2, $event)); })("keyup.arrowright", function DrugDosageComponent_div_1_Template_div_keyup_arrowright_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.setCheckedToNextItem(index_r2, $event)); })("keyup.enter", function DrugDosageComponent_div_1_Template_div_keyup_enter_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const dosage_r1 = restoredCtx.$implicit; const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.setDosage(dosage_r1)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const dosage_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c1$16, ctx_r0.activeDosageId === dosage_r1.dosageId, ctx_r0.activeDosageId !== dosage_r1.dosageId))("id", "dose-option-" + dosage_r1.dosageId);
    i0.ɵɵattribute("tabindex", ctx_r0.activeDosageId === dosage_r1.dosageId ? "0" : "-1")("aria-checked", ctx_r0.activeDosageId === dosage_r1.dosageId ? "true" : "false")("aria-label", dosage_r1.labelName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", dosage_r1.labelName, " ");
} }
class DrugDosageComponent {
    constructor() {
        this.setSelectedDosage = new EventEmitter();
        this.viewInitialized = false;
    }
    ngAfterViewInit() {
        const preselectedElement = this.dosageElements.find(element => element.nativeElement.id === `dose-option-${this.activeDosageId}`);
        if (preselectedElement) {
            preselectedElement.nativeElement.focus();
        }
        else if (this.dosageElements && this.dosageElements.first) {
            this.dosageElements.first.nativeElement.focus();
        }
        this.viewInitialized = true;
    }
    ngOnChanges(changes) {
        if (this.viewInitialized && this.isDrugChange(changes) && this.dosageElements && this.dosageElements.first) {
            this.dosageElements.first.nativeElement.focus();
        }
    }
    setDosage(dosage) {
        this.setSelectedDosage.emit({
            name: 'dosageId',
            value: dosage
        });
    }
    // Type guard to validate that the change is of type DrugDetails
    isDrugChange(simpleChanges) {
        return !!simpleChanges.dosages;
    }
    setCheckedToPreviousItem(currentIndex, $event) {
        $event.preventDefault();
        $event.stopPropagation();
        const maxIndex = this.dosageElements.length - 1;
        const previousIndex = currentIndex === 0 ? maxIndex : currentIndex - 1;
        this.setChecked(previousIndex);
    }
    setCheckedToNextItem(currentIndex, $event) {
        $event.preventDefault();
        $event.stopPropagation();
        const maxIndex = this.dosageElements.length - 1;
        const nextIndex = currentIndex === maxIndex ? 0 : currentIndex + 1;
        this.setChecked(nextIndex);
    }
    setChecked(targetIndex) {
        const optionElement = this.dosageElements.filter((_element, index) => index === targetIndex)[0];
        this.dosageElements.forEach(element => {
            element.nativeElement.setAttribute('aria-checked', 'false');
            element.nativeElement.setAttribute('tabindex', '-1');
        });
        optionElement.nativeElement.setAttribute('aria-checked', 'true');
        optionElement.nativeElement.setAttribute('tabindex', '0');
        optionElement.nativeElement.focus();
        optionElement.nativeElement.click();
    }
}
DrugDosageComponent.ɵfac = function DrugDosageComponent_Factory(t) { return new (t || DrugDosageComponent)(); };
DrugDosageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DrugDosageComponent, selectors: [["vnext-drug-dosage"]], viewQuery: function DrugDosageComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$2i, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dosageElements = _t);
    } }, inputs: { dosages: "dosages", activeDosageId: "activeDosageId", ariaLabelledById: "ariaLabelledById" }, outputs: { setSelectedDosage: "setSelectedDosage" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [["role", "radiogroup", 1, "toggle-container", "no-translate-block"], ["class", "toggle-option", "role", "radio", 3, "ngClass", "id", "click", "keyup.arrowup", "keyup.arrowleft", "keyup.arrowdown", "keyup.arrowright", "keyup.enter", 4, "ngFor", "ngForOf"], ["role", "radio", 1, "toggle-option", 3, "ngClass", "id", "click", "keyup.arrowup", "keyup.arrowleft", "keyup.arrowdown", "keyup.arrowright", "keyup.enter"], ["dosages", ""]], template: function DrugDosageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, DrugDosageComponent_div_1_Template, 3, 9, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵattribute("aria-labelledby", ctx.ariaLabelledById);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.dosages);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf], styles: [".toggle-option[_ngcontent-%COMP%]{overflow-wrap:break-word;align-items:left;justify-content:left;flex:1;border-width:1px;border-style:solid;padding:6px 5px;cursor:pointer}.toggle-option[_ngcontent-%COMP%]:first-of-type{border-top-left-radius:5px;border-top-right-radius:5px}.toggle-option[_ngcontent-%COMP%]:last-of-type{border-bottom-right-radius:5px;border-bottom-left-radius:5px}.toggle-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:focus{border-color:var(--static-Spa_Style_Primary_Link)}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], DrugDosageComponent.prototype, "setDosage", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugDosageComponent, [{
        type: Component,
        args: [{ selector: 'vnext-drug-dosage', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"toggle-container no-translate-block\" role=\"radiogroup\" [attr.aria-labelledby]=\"ariaLabelledById\">\r\n  <div\r\n    *ngFor=\"let dosage of dosages; index as index\"\r\n    #dosages\r\n    class=\"toggle-option\"\r\n    (click)=\"setDosage(dosage)\"\r\n    [ngClass]=\"{\r\n      'Spa_Style_SecondaryButtonSelected Spa_Style_Primary_Link_Border Spa_Style_Bold_Weight': activeDosageId === dosage.dosageId,\r\n      'Spa_Style_SecondaryButton Spa_Style_Regular_Weight': activeDosageId !== dosage.dosageId\r\n    }\"\r\n    [attr.tabindex]=\"activeDosageId === dosage.dosageId ? '0' : '-1'\"\r\n    role=\"radio\"\r\n    [id]=\"'dose-option-' + dosage.dosageId\"\r\n    [attr.aria-checked]=\"activeDosageId === dosage.dosageId ? 'true' : 'false'\"\r\n    [attr.aria-label]=\"dosage.labelName\"\r\n    (keyup.arrowup)=\"setCheckedToPreviousItem(index, $event)\"\r\n    (keyup.arrowleft)=\"setCheckedToPreviousItem(index, $event)\"\r\n    (keyup.arrowdown)=\"setCheckedToNextItem(index, $event)\"\r\n    (keyup.arrowright)=\"setCheckedToNextItem(index, $event)\"\r\n    (keyup.enter)=\"setDosage(dosage)\"\r\n  >\r\n    {{ dosage.labelName }}\r\n  </div>\r\n</div>\r\n", styles: [".toggle-option{overflow-wrap:break-word;align-items:left;justify-content:left;flex:1;border-width:1px;border-style:solid;padding:6px 5px;cursor:pointer}.toggle-option:first-of-type{border-top-left-radius:5px;border-top-right-radius:5px}.toggle-option:last-of-type{border-bottom-right-radius:5px;border-bottom-left-radius:5px}.toggle-container>div:focus{border-color:var(--static-Spa_Style_Primary_Link)}\n"] }]
    }], null, { dosageElements: [{
            type: ViewChildren,
            args: ['dosages']
        }], setSelectedDosage: [{
            type: Output
        }], dosages: [{
            type: Input
        }], activeDosageId: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], setDosage: [] }); })();

const _c0$2h = ["genericOption"];
const _c1$15 = function (a0, a1) { return { "Spa_Style_SecondaryButtonSelected Spa_Style_Primary_Link_Border Spa_Style_Bold_Weight": a0, "Spa_Style_SecondaryButton Spa_Style_Regular_Weight": a1 }; };
function DrugGenericEquivalentComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7, 8);
    i0.ɵɵlistener("click", function DrugGenericEquivalentComponent_div_7_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const option_r1 = restoredCtx.$implicit; const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.replaceBrandDrug(option_r1.value)); })("keyup.enter", function DrugGenericEquivalentComponent_div_7_Template_div_keyup_enter_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const option_r1 = restoredCtx.$implicit; const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.replaceBrandDrug(option_r1.value)); })("keyup.arrowup", function DrugGenericEquivalentComponent_div_7_Template_div_keyup_arrowup_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.setCheckedToPreviousItem(index_r2, $event)); })("keyup.arrowleft", function DrugGenericEquivalentComponent_div_7_Template_div_keyup_arrowleft_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.setCheckedToPreviousItem(index_r2, $event)); })("keyup.arrowdown", function DrugGenericEquivalentComponent_div_7_Template_div_keyup_arrowdown_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.setCheckedToNextItem(index_r2, $event)); })("keyup.arrowright", function DrugGenericEquivalentComponent_div_7_Template_div_keyup_arrowright_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.setCheckedToNextItem(index_r2, $event)); });
    i0.ɵɵelementStart(2, "span", 9);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const option_r1 = ctx.$implicit;
    const index_r2 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c1$15, ctx_r0.activeGenericOption === option_r1.value, ctx_r0.activeGenericOption !== option_r1.value));
    i0.ɵɵattribute("tabindex", ctx_r0.activeGenericOption === option_r1.value ? "0" : "-1")("aria-labelledby", "generic-option-" + index_r2)("aria-checked", ctx_r0.activeGenericOption === option_r1.value ? "true" : "false");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", "generic-option-" + index_r2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", option_r1.label, "");
} }
class DrugGenericEquivalentComponent {
    constructor() {
        this.replaceWithGenericDrug = new EventEmitter();
    }
    replaceBrandDrug(value) {
        this.replaceWithGenericDrug.emit(value);
    }
    setCheckedToPreviousItem(currentIndex, $event) {
        $event.preventDefault();
        const maxIndex = this.genericElements.length - 1;
        const previousIndex = currentIndex === 0 ? maxIndex : currentIndex - 1;
        this.setChecked(previousIndex);
    }
    setCheckedToNextItem(currentIndex, $event) {
        $event.preventDefault();
        const maxIndex = this.genericElements.length - 1;
        const nextIndex = currentIndex === maxIndex ? 0 : currentIndex + 1;
        this.setChecked(nextIndex);
    }
    setChecked(targetIndex) {
        const optionElement = this.genericElements.filter((_element, index) => index === targetIndex)[0];
        this.genericElements.forEach(element => {
            element.nativeElement.setAttribute('aria-checked', 'false');
            element.nativeElement.setAttribute('tabindex', '-1');
        });
        optionElement.nativeElement.setAttribute('aria-checked', 'true');
        optionElement.nativeElement.setAttribute('tabindex', '0');
        optionElement.nativeElement.focus();
        optionElement.nativeElement.click();
    }
}
DrugGenericEquivalentComponent.ɵfac = function DrugGenericEquivalentComponent_Factory(t) { return new (t || DrugGenericEquivalentComponent)(); };
DrugGenericEquivalentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DrugGenericEquivalentComponent, selectors: [["vnext-drug-generic-equivalent"]], viewQuery: function DrugGenericEquivalentComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$2h, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.genericElements = _t);
    } }, inputs: { activeGenericOption: "activeGenericOption", genericEquivalentQuestion: "genericEquivalentQuestion", genericOptions: "genericOptions", genericOptionIcon: "genericOptionIcon", genericOptionInfo: "genericOptionInfo" }, outputs: { replaceWithGenericDrug: "replaceWithGenericDrug" }, decls: 8, vars: 6, consts: [[1, "generic-equivalent-container", "mt-3"], ["id", "genericEquivalentQuestion", 1, "Spa_Style_Label", "mb-2", "mt-3"], ["aria-hidden", "true"], [1, "ml-2", 3, "innerHTML"], ["id", "genericOptionInfo", 1, "mt-2", "mb-3", "Spa_Style_Paragraph"], ["aria-labelledby", "genericEquivalentQuestion genericOptionInfo", "role", "radiogroup", 1, "toggle-container", "d-flex"], ["class", "toggle-option", "role", "radio", 3, "ngClass", "click", "keyup.enter", "keyup.arrowup", "keyup.arrowleft", "keyup.arrowdown", "keyup.arrowright", 4, "ngFor", "ngForOf"], ["role", "radio", 1, "toggle-option", 3, "ngClass", "click", "keyup.enter", "keyup.arrowup", "keyup.arrowleft", "keyup.arrowdown", "keyup.arrowright"], ["genericOption", ""], [3, "id"]], template: function DrugGenericEquivalentComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵelement(2, "i", 2)(3, "span", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵtemplate(7, DrugGenericEquivalentComponent_div_7_Template, 4, 9, "div", 6);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵclassMapInterpolate1("", ctx.genericOptionIcon, " tag-icon");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", ctx.genericEquivalentQuestion, i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.genericOptionInfo);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.genericOptions);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf], styles: [".generic-equivalent-container[_ngcontent-%COMP%]{border-top:1px solid var(--static-Spa_Style_Accent1)}.toggle-option[_ngcontent-%COMP%]{border-width:1px;border-style:solid;padding:5px 24px;cursor:pointer}.toggle-option[_ngcontent-%COMP%]:first-of-type{border-top-left-radius:5px;border-bottom-left-radius:5px}.toggle-option[_ngcontent-%COMP%]:last-of-type{border-top-right-radius:5px;border-bottom-right-radius:5px}.tag-icon[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text)}.toggle-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:focus{border-color:var(--static-Spa_Style_Primary_Link)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugGenericEquivalentComponent, [{
        type: Component,
        args: [{ selector: 'vnext-drug-generic-equivalent', template: "<div class=\"generic-equivalent-container mt-3\">\r\n  <div class=\"Spa_Style_Label mb-2 mt-3\" id=\"genericEquivalentQuestion\">\r\n    <i aria-hidden=\"true\" class=\"{{ genericOptionIcon }} tag-icon\"></i>\r\n    <span class=\"ml-2\" [innerHTML]=\"genericEquivalentQuestion\"></span>\r\n  </div>\r\n  <div id=\"genericOptionInfo\" class=\"mt-2 mb-3 Spa_Style_Paragraph\">{{ genericOptionInfo }}</div>\r\n  <div class=\"toggle-container d-flex\" aria-labelledby=\"genericEquivalentQuestion genericOptionInfo\" role=\"radiogroup\">\r\n    <div\r\n      *ngFor=\"let option of genericOptions; index as index\"\r\n      #genericOption\r\n      class=\"toggle-option\"\r\n      [ngClass]=\"{\r\n        'Spa_Style_SecondaryButtonSelected Spa_Style_Primary_Link_Border Spa_Style_Bold_Weight': activeGenericOption === option.value,\r\n        'Spa_Style_SecondaryButton Spa_Style_Regular_Weight': activeGenericOption !== option.value\r\n      }\"\r\n      [attr.tabindex]=\"activeGenericOption === option.value ? '0' : '-1'\"\r\n      role=\"radio\"\r\n      (click)=\"replaceBrandDrug(option.value)\"\r\n      (keyup.enter)=\"replaceBrandDrug(option.value)\"\r\n      (keyup.arrowup)=\"setCheckedToPreviousItem(index, $event)\"\r\n      (keyup.arrowleft)=\"setCheckedToPreviousItem(index, $event)\"\r\n      (keyup.arrowdown)=\"setCheckedToNextItem(index, $event)\"\r\n      (keyup.arrowright)=\"setCheckedToNextItem(index, $event)\"\r\n      [attr.aria-labelledby]=\"'generic-option-' + index\"\r\n      [attr.aria-checked]=\"activeGenericOption === option.value ? 'true' : 'false'\"\r\n    >\r\n      <span [id]=\"'generic-option-' + index\"> {{ option.label }}</span>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".generic-equivalent-container{border-top:1px solid var(--static-Spa_Style_Accent1)}.toggle-option{border-width:1px;border-style:solid;padding:5px 24px;cursor:pointer}.toggle-option:first-of-type{border-top-left-radius:5px;border-bottom-left-radius:5px}.toggle-option:last-of-type{border-top-right-radius:5px;border-bottom-right-radius:5px}.tag-icon{color:var(--static-Spa_Style_Cost_Text)}.toggle-container>div:focus{border-color:var(--static-Spa_Style_Primary_Link)}\n"] }]
    }], null, { genericElements: [{
            type: ViewChildren,
            args: ['genericOption']
        }], activeGenericOption: [{
            type: Input
        }], genericEquivalentQuestion: [{
            type: Input
        }], genericOptions: [{
            type: Input
        }], genericOptionIcon: [{
            type: Input
        }], genericOptionInfo: [{
            type: Input
        }], replaceWithGenericDrug: [{
            type: Output
        }] }); })();

const _c0$2g = ["packages"];
function DrugPackageComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3, 4);
    i0.ɵɵlistener("click", function DrugPackageComponent_div_4_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const value_r1 = restoredCtx.$implicit; const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.setPackage(value_r1)); })("keyup.enter", function DrugPackageComponent_div_4_Template_div_keyup_enter_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const value_r1 = restoredCtx.$implicit; const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.setPackage(value_r1)); })("keyup.arrowup", function DrugPackageComponent_div_4_Template_div_keyup_arrowup_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.setCheckedToPreviousItem(index_r2, $event)); })("keyup.arrowleft", function DrugPackageComponent_div_4_Template_div_keyup_arrowleft_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.setCheckedToPreviousItem(index_r2, $event)); })("keyup.arrowdown", function DrugPackageComponent_div_4_Template_div_keyup_arrowdown_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.setCheckedToNextItem(index_r2, $event)); })("keyup.arrowright", function DrugPackageComponent_div_4_Template_div_keyup_arrowright_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r5); const index_r2 = restoredCtx.index; const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.setCheckedToNextItem(index_r2, $event)); });
    i0.ɵɵelementStart(2, "span", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const value_r1 = ctx.$implicit;
    const index_r2 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.selectedPackageId === value_r1.packageId ? "Spa_Style_SecondaryButtonSelected Spa_Style_Primary_Link_Border Spa_Style_Bold_Weight" : "Spa_Style_SecondaryButton Spa_Style_Regular_Weight");
    i0.ɵɵattribute("tabindex", ctx_r0.selectedPackageId === value_r1.packageId ? "0" : "-1")("aria-checked", ctx_r0.selectedPackageId === value_r1.packageId ? "true" : "false")("aria-labelledby", "package-display-" + index_r2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", "package-display-" + index_r2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(value_r1.packageDisplayText);
} }
class DrugPackageComponent {
    constructor() {
        this.setSelectedPackage = new EventEmitter();
        this.setPackageNDC = new EventEmitter();
        this.setSelectedPackageUserQuantity = new EventEmitter();
    }
    setPackage(value) {
        this.setSelectedPackage.emit({
            name: 'selectedPackageId',
            value: value.packageId
        });
        this.setPackageNDC.emit({
            name: 'ndc',
            value: value.ndc
        });
        this.setSelectedPackageUserQuantity.emit({
            name: 'userQuantity',
            value: value.commonUserQuantity
        });
    }
    setCheckedToPreviousItem(currentIndex, $event) {
        const maxIndex = this.packageElements.length - 1;
        const previousIndex = currentIndex === 0 ? maxIndex : currentIndex - 1;
        this.setChecked(previousIndex);
    }
    setCheckedToNextItem(currentIndex, $event) {
        $event.preventDefault();
        const maxIndex = this.packageElements.length - 1;
        const nextIndex = currentIndex === maxIndex ? 0 : currentIndex + 1;
        this.setChecked(nextIndex);
    }
    setChecked(targetIndex) {
        const optionElement = this.packageElements.filter((_element, index) => index === targetIndex)[0];
        this.packageElements.forEach(element => {
            element.nativeElement.setAttribute('aria-checked', 'false');
            element.nativeElement.setAttribute('tabindex', '-1');
        });
        optionElement.nativeElement.setAttribute('aria-checked', 'true');
        optionElement.nativeElement.setAttribute('tabindex', '0');
        optionElement.nativeElement.focus();
        optionElement.nativeElement.click();
    }
}
DrugPackageComponent.ɵfac = function DrugPackageComponent_Factory(t) { return new (t || DrugPackageComponent)(); };
DrugPackageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DrugPackageComponent, selectors: [["vnext-drug-package"]], viewQuery: function DrugPackageComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$2g, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.packageElements = _t);
    } }, inputs: { packageList: "packageList", selectedPackageId: "selectedPackageId", packageHeader: "packageHeader" }, outputs: { setSelectedPackage: "setSelectedPackage", setPackageNDC: "setPackageNDC", setSelectedPackageUserQuantity: "setSelectedPackageUserQuantity" }, decls: 5, vars: 2, consts: [["id", "selectPackageSection", 1, "Spa_Style_Label", "mb-2", "mt-3"], ["aria-labelledby", "selectPackageSection", "role", "radiogroup", 1, "toggle-container", "no-translate-block"], ["class", "toggle-option", "role", "radio", 3, "ngClass", "click", "keyup.enter", "keyup.arrowup", "keyup.arrowleft", "keyup.arrowdown", "keyup.arrowright", 4, "ngFor", "ngForOf"], ["role", "radio", 1, "toggle-option", 3, "ngClass", "click", "keyup.enter", "keyup.arrowup", "keyup.arrowleft", "keyup.arrowdown", "keyup.arrowright"], ["packages", ""], [3, "id"]], template: function DrugPackageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div")(1, "div", 0);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 1);
        i0.ɵɵtemplate(4, DrugPackageComponent_div_4_Template, 4, 6, "div", 2);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.packageHeader);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.packageList);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf], styles: [".toggle-option[_ngcontent-%COMP%]{align-items:left;justify-content:left;flex:1;border-width:1px;border-style:solid;padding:6px 5px;cursor:pointer}.toggle-option[_ngcontent-%COMP%]:first-of-type{border-top-left-radius:5px;border-top-right-radius:5px}.toggle-option[_ngcontent-%COMP%]:last-of-type{border-bottom-right-radius:5px;border-bottom-left-radius:5px}.toggle-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:focus{border-color:var(--static-Spa_Style_Primary_Link)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugPackageComponent, [{
        type: Component,
        args: [{ selector: 'vnext-drug-package', template: "<div>\r\n  <div class=\"Spa_Style_Label mb-2 mt-3\" id=\"selectPackageSection\">{{ packageHeader }}</div>\r\n  <div class=\"toggle-container no-translate-block\" aria-labelledby=\"selectPackageSection\" role=\"radiogroup\">\r\n    <div\r\n      *ngFor=\"let value of packageList; index as index\"\r\n      #packages\r\n      class=\"toggle-option\"\r\n      (click)=\"setPackage(value)\"\r\n      [ngClass]=\"\r\n        selectedPackageId === value.packageId\r\n          ? 'Spa_Style_SecondaryButtonSelected Spa_Style_Primary_Link_Border Spa_Style_Bold_Weight'\r\n          : 'Spa_Style_SecondaryButton Spa_Style_Regular_Weight'\r\n      \"\r\n      [attr.tabindex]=\"selectedPackageId === value.packageId ? '0' : '-1'\"\r\n      [attr.aria-checked]=\"selectedPackageId === value.packageId ? 'true' : 'false'\"\r\n      role=\"radio\"\r\n      [attr.aria-labelledby]=\"'package-display-' + index\"\r\n      (keyup.enter)=\"setPackage(value)\"\r\n      (keyup.arrowup)=\"setCheckedToPreviousItem(index, $event)\"\r\n      (keyup.arrowleft)=\"setCheckedToPreviousItem(index, $event)\"\r\n      (keyup.arrowdown)=\"setCheckedToNextItem(index, $event)\"\r\n      (keyup.arrowright)=\"setCheckedToNextItem(index, $event)\"\r\n    >\r\n      <span [id]=\"'package-display-' + index\">{{ value.packageDisplayText }}</span>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".toggle-option{align-items:left;justify-content:left;flex:1;border-width:1px;border-style:solid;padding:6px 5px;cursor:pointer}.toggle-option:first-of-type{border-top-left-radius:5px;border-top-right-radius:5px}.toggle-option:last-of-type{border-bottom-right-radius:5px;border-bottom-left-radius:5px}.toggle-container>div:focus{border-color:var(--static-Spa_Style_Primary_Link)}\n"] }]
    }], null, { packageElements: [{
            type: ViewChildren,
            args: ['packages']
        }], packageList: [{
            type: Input
        }], selectedPackageId: [{
            type: Input
        }], packageHeader: [{
            type: Input
        }], setSelectedPackage: [{
            type: Output
        }], setPackageNDC: [{
            type: Output
        }], setSelectedPackageUserQuantity: [{
            type: Output
        }] }); })();

const _c0$2f = ["quantityRange"];
const _c1$14 = function (a0) { return { selected: a0 }; };
function DrugQuantityFrequencyComponent_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function DrugQuantityFrequencyComponent_button_13_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const frequency_r2 = restoredCtx.$implicit; const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.onFrequencySelected(frequency_r2)); })("keyup.enter", function DrugQuantityFrequencyComponent_button_13_Template_button_keyup_enter_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const frequency_r2 = restoredCtx.$implicit; const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.onFrequencySelected(frequency_r2)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const frequency_r2 = ctx.$implicit;
    const index_r3 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$14, ctx_r1.activeFrequency.label === frequency_r2.label));
    i0.ɵɵattribute("aria-selected", ctx_r1.activeFrequency.label === frequency_r2.label)("aria-posinset", index_r3 + 1)("aria-setsize", ctx_r1.frequencyList.length)("aria-label", frequency_r2.label);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", frequency_r2.label, " ");
} }
const _c2$F = function (a0) { return { "error-color error": a0 }; };
class DrugQuantityFrequencyComponent {
    constructor() {
        this.quantityRangeLabelText = 'Quantity range between 0 to 1000';
        this.setQuantityOrFrequency = new EventEmitter();
        this.quantityAriaLabelText = 'Prescription Quantity';
        this.frequencyAriaLabelText = 'Prescription Frequency';
        this.frequencyProps = 'daysOfSupply';
        this.quantityProps = 'userQuantity';
    }
    setQuantity($event) {
        this.setQuantityOrFrequency.emit({ name: this.quantityProps, value: $event.target.value });
    }
    onFrequencySelected(frequency) {
        this.setQuantityOrFrequency.emit({ name: this.frequencyProps, value: frequency.value });
    }
    ngAfterViewChecked() {
        if (!this.isQuantityValid && this.quantityRange && this.quantityRange.nativeElement) {
            this.quantityRange.nativeElement.textContent = '';
        }
    }
}
DrugQuantityFrequencyComponent.ɵfac = function DrugQuantityFrequencyComponent_Factory(t) { return new (t || DrugQuantityFrequencyComponent)(); };
DrugQuantityFrequencyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DrugQuantityFrequencyComponent, selectors: [["vnext-drug-quantity-frequency"]], viewQuery: function DrugQuantityFrequencyComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$2f, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.quantityRange = _t.first);
    } }, inputs: { frequencyList: "frequencyList", quantityAndFrequencyHeader: "quantityAndFrequencyHeader", isQuantityValid: "isQuantityValid", activeFrequency: "activeFrequency", activeQuantity: "activeQuantity", drugSearchFrequencyListBoxLabel: "drugSearchFrequencyListBoxLabel", quantityRangeLabelText: "quantityRangeLabelText" }, outputs: { setQuantityOrFrequency: "setQuantityOrFrequency" }, decls: 14, vars: 11, consts: [["id", "quantity-frequency-label", 1, "drug-details-header", "Spa_Style_Label", "mb-2"], ["id", "quantityrange", 1, "sr-only"], ["quantityRange", ""], [1, "d-flex", "flex-row", "justify-content-start"], ["type", "text", "inputmode", "numeric", "pattern", "[0-9]*", "autocomplete", "off", "digitOnly", "", "decimal", "true", "maxlength", "5", "aria-describedby", "quantityrange quantityFieldError", "aria-required", "true", 1, "col-3", "col-md-3", 3, "ngClass", "ngModel", "ngModelChange", "change"], ["ngbDropdown", "", "placement", "bottom-left", 1, "pl-3", "pl-md-2", "pl-lg-3", "col-9", "col-md-9"], ["id", "frequency", "aria-haspopup", "listbox", "ngbDropdownToggle", "", 1, "btn", "frequency-dropdown-button"], [1, "Spa_Style_Paragraph"], [1, "fa", "fa-angle-down", "float-right"], ["ngbDropdownMenu", "", "role", "listbox"], ["ngbDropdownItem", "", "class", "Spa_Style_Paragraph", "role", "option", "tabindex", "0", 3, "ngClass", "click", "keyup.enter", 4, "ngFor", "ngForOf"], ["ngbDropdownItem", "", "role", "option", "tabindex", "0", 1, "Spa_Style_Paragraph", 3, "ngClass", "click", "keyup.enter"]], template: function DrugQuantityFrequencyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementStart(2, "label", 1, 2);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div", 3)(6, "input", 4);
        i0.ɵɵlistener("ngModelChange", function DrugQuantityFrequencyComponent_Template_input_ngModelChange_6_listener($event) { return ctx.activeQuantity = $event; })("change", function DrugQuantityFrequencyComponent_Template_input_change_6_listener($event) { return ctx.setQuantity($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 5)(8, "button", 6)(9, "span", 7);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(11, "i", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 9);
        i0.ɵɵtemplate(13, DrugQuantityFrequencyComponent_button_13_Template, 2, 8, "button", 10);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.quantityAndFrequencyHeader, " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.quantityRangeLabelText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c2$F, !ctx.isQuantityValid))("ngModel", ctx.activeQuantity);
        i0.ɵɵattribute("aria-label", ctx.quantityAriaLabelText);
        i0.ɵɵadvance(2);
        i0.ɵɵattribute("aria-label", ctx.frequencyAriaLabelText);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.activeFrequency.label);
        i0.ɵɵadvance(2);
        i0.ɵɵattribute("aria-label", ctx.drugSearchFrequencyListBoxLabel);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.frequencyList);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i4.DefaultValueAccessor, i4.NgControlStatus, i4.MaxLengthValidator, i4.PatternValidator, i4.NgModel, IconAriaAttributesDirective, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem, i3.DigitOnlyDirective], styles: [".dropdown[_ngcontent-%COMP%]   .frequency-dropdown-button[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent1);width:100%;text-align:left;height:36px;padding:4px 8px}.frequency-dropdown-button[_ngcontent-%COMP%]   .fa[_ngcontent-%COMP%]{margin-top:5px}.dropdown[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{width:100%;padding:0;margin-top:0;border-color:var(--static-Spa_Style_Accent1)}.dropdown-menu[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]{padding:6px 10px 6px 22px}.dropdown-menu[_ngcontent-%COMP%]   .dropdown-item.active[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray2);color:var(--static-Spa_Style_Primary)}.dropdown-menu[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]:hover, .dropdown[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]:focus, .dropdown[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]:active{background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}.dropup[_ngcontent-%COMP%]   .dropdown-toggle[_ngcontent-%COMP%]:after{display:none}.dropdown-toggle[_ngcontent-%COMP%]:focus{border-color:var(--static-Spa_Style_Gray4)}.dropdown-item.selected[_ngcontent-%COMP%]:before{content:\"\\2713\";display:inline-block;color:var(--static-Spa_Style_Primary_Link);position:absolute;left:6px}input.error[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent2)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugQuantityFrequencyComponent, [{
        type: Component,
        args: [{ selector: 'vnext-drug-quantity-frequency', template: "<div id=\"quantity-frequency-label\" class=\"drug-details-header Spa_Style_Label mb-2\">\r\n  {{ quantityAndFrequencyHeader }}\r\n  <label #quantityRange id=\"quantityrange\" class=\"sr-only\">{{ quantityRangeLabelText }}</label>\r\n</div>\r\n<div class=\"d-flex flex-row justify-content-start\">\r\n  <input\r\n    type=\"text\"\r\n    class=\"col-3 col-md-3\"\r\n    inputmode=\"numeric\"\r\n    pattern=\"[0-9]*\"\r\n    autocomplete=\"off\"\r\n    digitOnly\r\n    decimal=\"true\"\r\n    maxlength=\"5\"\r\n    aria-describedby=\"quantityrange quantityFieldError\"\r\n    aria-required=\"true\"\r\n    [attr.aria-label]=\"quantityAriaLabelText\"\r\n    [ngClass]=\"{ 'error-color error': !isQuantityValid }\"\r\n    [(ngModel)]=\"activeQuantity\"\r\n    (change)=\"setQuantity($event)\"\r\n  />\r\n  <div ngbDropdown placement=\"bottom-left\" class=\"pl-3 pl-md-2 pl-lg-3 col-9 col-md-9\">\r\n    <button\r\n      class=\"btn frequency-dropdown-button\"\r\n      id=\"frequency\"\r\n      aria-haspopup=\"listbox\"\r\n      [attr.aria-label]=\"frequencyAriaLabelText\"\r\n      ngbDropdownToggle\r\n    >\r\n      <span class=\"Spa_Style_Paragraph\">{{ activeFrequency.label }}</span> <i class=\"fa fa-angle-down float-right\"></i>\r\n    </button>\r\n    <div ngbDropdownMenu [attr.aria-label]=\"drugSearchFrequencyListBoxLabel\" role=\"listbox\">\r\n      <button\r\n        ngbDropdownItem\r\n        *ngFor=\"let frequency of frequencyList; index as index\"\r\n        class=\"Spa_Style_Paragraph\"\r\n        [ngClass]=\"{ selected: activeFrequency.label === frequency.label }\"\r\n        (click)=\"onFrequencySelected(frequency)\"\r\n        (keyup.enter)=\"onFrequencySelected(frequency)\"\r\n        role=\"option\"\r\n        [attr.aria-selected]=\"activeFrequency.label === frequency.label\"\r\n        [attr.aria-posinset]=\"index + 1\"\r\n        [attr.aria-setsize]=\"frequencyList.length\"\r\n        tabindex=\"0\"\r\n        [attr.aria-label]=\"frequency.label\"\r\n      >\r\n        {{ frequency.label }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".dropdown .frequency-dropdown-button{border-color:var(--static-Spa_Style_Accent1);width:100%;text-align:left;height:36px;padding:4px 8px}.frequency-dropdown-button .fa{margin-top:5px}.dropdown .dropdown-menu{width:100%;padding:0;margin-top:0;border-color:var(--static-Spa_Style_Accent1)}.dropdown-menu .dropdown-item{padding:6px 10px 6px 22px}.dropdown-menu .dropdown-item.active{background-color:var(--static-Spa_Style_Gray2);color:var(--static-Spa_Style_Primary)}.dropdown-menu .dropdown-item:hover,.dropdown .dropdown-item:focus,.dropdown .dropdown-item:active{background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}.dropup .dropdown-toggle:after{display:none}.dropdown-toggle:focus{border-color:var(--static-Spa_Style_Gray4)}.dropdown-item.selected:before{content:\"\\2713\";display:inline-block;color:var(--static-Spa_Style_Primary_Link);position:absolute;left:6px}input.error{border-color:var(--static-Spa_Style_Accent2)}\n"] }]
    }], null, { frequencyList: [{
            type: Input
        }], quantityAndFrequencyHeader: [{
            type: Input
        }], isQuantityValid: [{
            type: Input
        }], activeFrequency: [{
            type: Input
        }], activeQuantity: [{
            type: Input
        }], drugSearchFrequencyListBoxLabel: [{
            type: Input
        }], quantityRangeLabelText: [{
            type: Input
        }], setQuantityOrFrequency: [{
            type: Output
        }], quantityRange: [{
            type: ViewChild,
            args: ['quantityRange']
        }] }); })();

function DrugDetailsComponent_ng_container_2_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17)(1, "span");
    i0.ɵɵelement(2, "i", 18);
    i0.ɵɵelementStart(3, "span", 19);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.errorKeywordText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r3.quantityErrorMessage, " ");
} }
function DrugDetailsComponent_ng_container_2_vnext_drug_package_14_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-drug-package", 20);
    i0.ɵɵlistener("setSelectedPackage", function DrugDetailsComponent_ng_container_2_vnext_drug_package_14_Template_vnext_drug_package_setSelectedPackage_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r6.updateDrugDetails($event)); })("setPackageNDC", function DrugDetailsComponent_ng_container_2_vnext_drug_package_14_Template_vnext_drug_package_setPackageNDC_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8.updatePackageNDC($event)); })("setSelectedPackageUserQuantity", function DrugDetailsComponent_ng_container_2_vnext_drug_package_14_Template_vnext_drug_package_setSelectedPackageUserQuantity_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r9 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r9.updateDrugDetails($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("packageList", ctx_r4.selectedDosage.packages)("selectedPackageId", ctx_r4.selectedDosage.selectedPackageId)("packageHeader", ctx_r4.packageHeader);
} }
function DrugDetailsComponent_ng_container_2_vnext_drug_generic_equivalent_15_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-drug-generic-equivalent", 21);
    i0.ɵɵlistener("replaceWithGenericDrug", function DrugDetailsComponent_ng_container_2_vnext_drug_generic_equivalent_15_Template_vnext_drug_generic_equivalent_replaceWithGenericDrug_0_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.replaceWithGenericDrug($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("genericEquivalentQuestion", ctx_r5.genericEquivalentQuestion)("activeGenericOption", ctx_r5.activeGenericOption)("genericOptions", ctx_r5.genericOptions)("genericOptionIcon", ctx_r5.genericOptionIcon)("genericOptionInfo", ctx_r5.genericOptionInfo);
} }
function DrugDetailsComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h2", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 8);
    i0.ɵɵtemplate(6, DrugDetailsComponent_ng_container_2_div_6_Template, 6, 2, "div", 9);
    i0.ɵɵelementStart(7, "div", 10)(8, "div", 11);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "vnext-drug-dosage", 12);
    i0.ɵɵlistener("setSelectedDosage", function DrugDetailsComponent_ng_container_2_Template_vnext_drug_dosage_setSelectedDosage_10_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.setDrugDosage($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 13)(12, "vnext-drug-quantity-frequency", 14);
    i0.ɵɵlistener("setQuantityOrFrequency", function DrugDetailsComponent_ng_container_2_Template_vnext_drug_quantity_frequency_setQuantityOrFrequency_12_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.updateDrugDetails($event)); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(13, "div");
    i0.ɵɵtemplate(14, DrugDetailsComponent_ng_container_2_vnext_drug_package_14_Template, 1, 3, "vnext-drug-package", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, DrugDetailsComponent_ng_container_2_vnext_drug_generic_equivalent_15_Template, 1, 5, "vnext-drug-generic-equivalent", 16);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.drugName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.contentSectionText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.isQuantityValid);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.dosageHeader);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("dosages", ctx_r0.dosages)("activeDosageId", ctx_r0.selectedDosage.dosageId)("ariaLabelledById", "dosageHeaderId");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("activeFrequency", ctx_r0.defaultFrequency)("activeQuantity", ctx_r0.selectedDosage.userQuantity)("frequencyList", ctx_r0.frequencyList)("quantityAndFrequencyHeader", ctx_r0.quantityAndFrequencyHeader)("isQuantityValid", ctx_r0.isQuantityValid)("drugSearchFrequencyListBoxLabel", ctx_r0.drugSearchFrequencyListBoxLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.selectedDosage.packages && ctx_r0.selectedDosage.packages.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.hasGenericDrug && ctx_r0.showGenericOption);
} }
function DrugDetailsComponent_ng_template_3_div_0_h2_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 25);
    i0.ɵɵelement(1, "i", 26);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r17.coveredPrescriptions, " ");
} }
const _c0$2e = function (a0) { return [a0]; };
function DrugDetailsComponent_ng_template_3_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div");
    i0.ɵɵtemplate(2, DrugDetailsComponent_ng_template_3_div_0_h2_2_Template, 3, 1, "h2", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "vnext-drug-cost-details", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_PrescriptionsTab_Covered_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("coveredTiers", ctx_r15.coveredTiers)("noPrescriptionInTier", ctx_r15.noPrescriptionInTier)("isCovered", true)("medicineCabinet", i0.ɵɵpureFunction1(9, _c0$2e, ctx_r15.helpfulToolsDrugDetails))("plan", ctx_r15.helpfulToolsPlanWithDetails)("showGenericOption", ctx_r15.showGenericOption)("showCosts", ctx_r15.showCosts)("isHelpfulToolsView", ctx_r15.isHelpfulToolsView);
} }
function DrugDetailsComponent_ng_template_3_div_1_h2_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 25);
    i0.ɵɵelement(1, "i", 28);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r18.nonCoveredPrescriptions, " ");
} }
function DrugDetailsComponent_ng_template_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div");
    i0.ɵɵtemplate(2, DrugDetailsComponent_ng_template_3_div_1_h2_2_Template, 3, 1, "h2", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "vnext-drug-cost-details", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_PrescriptionsTab_NonCovered_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("nonCoveredDrugCostDetails", ctx_r16.nonCoveredDrugCostDetails)("noPrescriptionInTier", ctx_r16.noPrescriptionInTier)("isCovered", false)("medicineCabinet", i0.ɵɵpureFunction1(9, _c0$2e, ctx_r16.helpfulToolsDrugDetails))("plan", ctx_r16.helpfulToolsPlanWithDetails)("showGenericOption", ctx_r16.showGenericOption)("showCosts", ctx_r16.showCosts)("isHelpfulToolsView", ctx_r16.isHelpfulToolsView);
} }
function DrugDetailsComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, DrugDetailsComponent_ng_template_3_div_0_Template, 4, 11, "div", 22);
    i0.ɵɵtemplate(1, DrugDetailsComponent_ng_template_3_div_1_Template, 4, 11, "div", 22);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.isCovered);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isCovered);
} }
const _c1$13 = function (a0) { return { "modal-detail-body": a0 }; };
class DrugDetailsComponent {
    constructor(drugsService, drugDetailsFacade, cdr, helpfulToolsContext, helpfulToolsService, analyticsService, pharmacyService, planDetailsFacade, navigationutilityService, navigationContext) {
        this.drugsService = drugsService;
        this.drugDetailsFacade = drugDetailsFacade;
        this.cdr = cdr;
        this.helpfulToolsContext = helpfulToolsContext;
        this.helpfulToolsService = helpfulToolsService;
        this.analyticsService = analyticsService;
        this.pharmacyService = pharmacyService;
        this.planDetailsFacade = planDetailsFacade;
        this.navigationutilityService = navigationutilityService;
        this.navigationContext = navigationContext;
        this.showCosts = true;
        this.helpfulTools = false;
        this.showDrugAlternativesEnabled = false;
        this.helpfulToolsShowDrugAlternativesNudgeEnabled = false;
        this.prescriptionTabView = PrescriptionTabViewMode.DEFAULT;
        this.isModalDrugDetail = false;
        this.swapWithDirectGeneric = false;
        this.showDrugCoverageDetails = false;
        this.helpfulToolsDrugHasCoverage = false;
        this.isHelpfulToolsView = false;
        this.checkFocus = false;
        this.isCovered = false;
        this.prescriptionTabViewMode = PrescriptionTabViewMode;
        this.showOffFormularyDrugAlternativesButton = false;
        this.updateIsQuantityValid = new EventEmitter();
        this.updateActiveGenericOption = new EventEmitter();
        this.updateFrequency = new EventEmitter();
        this.removeSelectedDrug = new EventEmitter();
        this.viewPossibleAlternativeDrugs = new EventEmitter(null);
        this.subscriptions = new Subscription();
        this.isEditing$ = new BehaviorSubject(null);
        this.medicineCabinetLimit$ = new BehaviorSubject(null);
        this.triggerPlanDetails$ = new BehaviorSubject(null);
    }
    ngOnInit() {
        this.isHelpfulToolsView = this.navigationutilityService.pageTagURLMatch(PageTags.HELPFUL_TOOLS_PHARMACYSEARCH, this.navigationContext.getUrl());
        this.subscriptions.add(
        // Subscribe to the latest updates from the store for the drug cabinet.
        this.cabinet$.subscribe(cabinet => {
            this.drugCabinet = cabinet;
            this.cdr.detectChanges();
        }));
        this.subscriptions.add(combineLatest([this.cabinet$, this.medicineCabinetLimit$, this.isEditing$])
            .pipe(filter(([medicineCabinet, medicineCabinetLimit]) => !!medicineCabinet && medicineCabinetLimit > 0))
            .subscribe(([medicineCabinet, medicineCabinetLimit, isEditing]) => {
            this.drugCountInLimits = this.isDrugCountInLimits(medicineCabinet, isEditing, medicineCabinetLimit);
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.triggerPlanDetails$
            .asObservable()
            .pipe(filter(cabinetEntry => !!cabinetEntry), distinctUntilChanged(_isEqual), switchMap(cabinetEntry => from(this.helpfulToolsService.getPlanDetails([cabinetEntry]))))
            .subscribe(planWithDetails => {
            this.helpfulToolsPlanWithDetails = planWithDetails;
            const availablePlanTiers = this.drugDetailsFacade.getCoveredPlanTiers(this.helpfulToolsPlanWithDetails);
            const formularyInfo = this.helpfulToolsPlanWithDetails.planRetailDrugCoverageMultiPharmacy;
            const dosage = this.helpfulToolsDrugDetails.dosage;
            const foundTierCoverage = this.drugDetailsFacade
                .getCoveredDrugsByTier(availablePlanTiers, [dosage], formularyInfo)
                .filter(tier => tier.hasDrugs);
            this.coveredTiers = this.drugDetailsFacade.getCoveredDrugsByTier(availablePlanTiers, [dosage], formularyInfo);
            this.isCovered = this.showCoveredPrescriptions(this.coveredTiers);
            this.checkingOffFormularyDrugAlternativesButton(this.helpfulToolsPlanWithDetails, this.helpfulToolsDrugDetails, this.isCovered);
            this.nonCoveredDrugCostDetails = this.drugDetailsFacade.getNonCoveredDrugCostDetails(availablePlanTiers, [dosage], formularyInfo);
            this.helpfulToolsDrugHasCoverage = !!foundTierCoverage.length;
            if (this.helpfulToolsDrugHasCoverage) {
                this.helpfulToolsDrugCostDetails = foundTierCoverage[0].drugCostDetails[0];
            }
            else {
                this.helpfulToolsDrugCostDetails = this.drugDetailsFacade.getNonCoveredDrugCostDetails(availablePlanTiers, [dosage], formularyInfo)[0];
            }
            this.helpfulToolsContext.setSelectedDrugDosageId(dosage.dosageId);
            this.showDrugCoverageDetails = true;
            this.cdr.detectChanges();
        }));
        this.inCabinet = false;
        this.initialSelection = { ...this.selectedDosage };
        if (!this.isEditing) {
            const hasGeneric = !!this.selectedDosage.genericDosageId;
            this.setCabinetStatusByDrugType(hasGeneric);
        }
        this.selectedUserQuantity = this.selectedDosage.userQuantity;
        this.selectedDoseLabelName = this.selectedDosage.labelName;
    }
    ngOnChanges(changes) {
        const { isEditing, medicineCabinetLimit } = changes;
        if (isEditing && isEditing.previousValue !== isEditing.currentValue) {
            this.isEditing$.next(this.isEditing);
        }
        if (medicineCabinetLimit && medicineCabinetLimit.previousValue !== medicineCabinetLimit.currentValue) {
            this.medicineCabinetLimit$.next(this.medicineCabinetLimit);
        }
    }
    ngAfterViewChecked() {
        if (this.checkFocus) {
            const quantityErrorField = document.querySelector('.error');
            const quantityErrorElement = quantityErrorField;
            if (quantityErrorElement) {
                quantityErrorElement.focus();
            }
            this.checkFocus = false;
        }
    }
    // For each dosage package changes which needs to be updated and new package is displayed
    setDrugDosage(emitData) {
        this.updateDrugDetails({ name: emitData.name, value: emitData.value.dosageId });
        this.updateDrugDetails({ name: 'ndc', value: emitData.value.ndc });
        this.selectedDosage.labelName = emitData ? emitData.value.labelName : this.selectedDosage.labelName;
        if (emitData.value?.genericDosageId) {
            this.updateDrugDetails({ name: 'genericDosageId', value: emitData.value.genericDosageId });
        }
        const packageList = emitData.value.packages;
        if (!packageList || packageList.length === 0) {
            this.selectedDosage.packages = [];
            this.selectedDosage.userQuantity =
                emitData.value.labelName === this.selectedDoseLabelName ? this.selectedUserQuantity : emitData.value.commonUserQuantity;
            this.updateDrugDetails({ name: 'selectedPackageId', value: '' });
            this.updateDrugDetails({ name: 'packages', value: [] });
            this.setCabinetStatusByDrugType(this.swapWithDirectGeneric, emitData.value);
            this.cdr.detectChanges();
            return;
        }
        // Note: Not exiting control if we have an empty package array.
        // Drugs have one or more dosages.  All dosages have zero or more packages. A dosage with zero
        // packages has an array of [], length 0.
        if (packageList.length === 0) {
            this.updateDrugDetails({ name: 'selectedPackageId', value: '' });
        }
        this.selectedDosage.packages = packageList;
        this.updateDrugDetails({ name: 'packages', value: packageList });
        const commonPackage = packageList.find(packageItem => packageItem.isCommonPackage);
        if (commonPackage) {
            this.selectedDosage.userQuantity =
                emitData.value.labelName === this.selectedDoseLabelName ? this.selectedUserQuantity : emitData.value.commonUserQuantity;
            this.updateDrugDetails({ name: 'selectedPackageId', value: commonPackage.packageId });
        }
        this.setCabinetStatusByDrugType(this.swapWithDirectGeneric, emitData.value);
        this.cdr.detectChanges();
    }
    updateDrugDetails(dosageProperty) {
        this.selectedDosage[dosageProperty.name] = dosageProperty.value;
        if (dosageProperty.name === 'userQuantity') {
            this.setCabinetStatusByDrugType(this.swapWithDirectGeneric);
        }
        if (dosageProperty.name === 'daysOfSupply') {
            this.setCabinetStatusByDrugType(this.swapWithDirectGeneric);
            const selectedFrequency = this.frequencyList.find(frequencyItem => dosageProperty.value <= frequencyItem.value);
            this.updateFrequency.emit(selectedFrequency);
        }
        this.cdr.detectChanges();
    }
    updatePackageNDC(dosageProperty) {
        this.selectedDosage.ndc = dosageProperty.value;
    }
    replaceWithGenericDrug(value) {
        this.updateActiveGenericOption.emit(value);
        if (value) {
            this.swapWithDirectGeneric = true;
        }
        else {
            this.swapWithDirectGeneric = false;
        }
        this.setCabinetStatusByDrugType(this.swapWithDirectGeneric);
    }
    createCabinetEntry(isGeneric) {
        if (isGeneric) {
            return this.drugsService.createCabinetEntry(this.getGenericAlternative(), this.drugDetails.genericDrug.drugID, this.drugDetails, true);
        }
        return this.drugsService.createCabinetEntry(this.selectedDosage, this.drugDetails.drugID, this.drugDetails, false);
    }
    showCoverage() {
        if (this.validateDrugQuantity()) {
            this.checkFocus = true;
        }
        else {
            this.helpfulToolsDrugDetails = this.createCabinetEntry(this.activeGenericOption);
            this.triggerPlanDetails$.next(this.helpfulToolsDrugDetails);
        }
    }
    hideCoverage() {
        this.showDrugCoverageDetails = false;
    }
    /**
     * Guard and deactivate if max number of drugs.
     * Currently not disabling button (adding disabled) to preserve
     * keyboard accessibility.
     */
    async addDrug() {
        if (this.validateDrugQuantity()) {
            this.checkFocus = true;
        }
        else {
            // Create the cabinet entry, taking generics into account.
            const cabinetEntry = this.createCabinetEntry(this.activeGenericOption);
            this.setAnalyticsForPreferencesAddDrug(cabinetEntry);
            if (cabinetEntry && cabinetEntry.isGenericAlternative && cabinetEntry.drugDetails?.genericDrug) {
                cabinetEntry.drugDetails = cabinetEntry.drugDetails.genericDrug;
            }
            // Check for generic/brand cost equivalents on addition
            this.setCabinetStatus(cabinetEntry.dosage);
            if (this.inCabinet) {
                this.cdr.detectChanges();
                return;
            }
            if (this.isEditing) {
                this.drugsService.editDrug(this.dosageToEdit, cabinetEntry);
            }
            else {
                this.drugsService.addDrug(cabinetEntry);
            }
            this.cdr.detectChanges();
            this.close(); // close drug dosage selection window
        }
    }
    validateQuantity() {
        const result = !!this.selectedDosage.userQuantity &&
            +this.selectedDosage.userQuantity > 0 &&
            +this.selectedDosage.userQuantity < +this.quantityMaxLimit;
        this.updateIsQuantityValid.emit(result);
        return result;
    }
    close() {
        this.removeSelectedDrug.emit();
    }
    ngOnDestroy() {
        if (this.editSubscription) {
            this.editSubscription.unsubscribe();
        }
        if (this.addSubscription) {
            this.addSubscription.unsubscribe();
        }
        this.subscriptions.unsubscribe();
    }
    onViewPossibleAlternativeDrugs() {
        this.setAnalyticsForViewDrugAlternatives(this.helpfulToolsPlanWithDetails, this.helpfulToolsDrugDetails);
        this.viewPossibleAlternativeDrugs.emit({
            plan: this.helpfulToolsPlanWithDetails,
            cabinet: this.helpfulToolsDrugDetails
        });
    }
    validateDrugQuantity() {
        this.isQuantityValid = this.validateQuantity();
        if (!this.drugCountInLimits || !this.isQuantityValid) {
            return true;
        }
        return false;
    }
    setCabinetStatusByDrugType(genericSelected, dosage) {
        if (genericSelected) {
            const genericDosage = this.getGenericAlternative();
            this.setCabinetStatus(genericDosage);
        }
        else {
            if (dosage) {
                this.setCabinetStatus(dosage);
            }
            else {
                this.setCabinetStatus(this.selectedDosage);
            }
        }
    }
    setCabinetStatus(dosage) {
        // check if in the cabinet, if so set InCabinet to true
        if (this.isDrugInMedicineCabinet(dosage)) {
            this.inCabinet = true;
        }
        else {
            // else set inCabinet to false
            this.inCabinet = false;
        }
    }
    isDrugInMedicineCabinet(entryToBeAdded) {
        const isBrand = !!entryToBeAdded.genericDosageId;
        const isSameDrugQtyFreq = this.isSameDrugInCabinet(entryToBeAdded);
        // Scenario: Adding a new drug to cabinet.
        if (!this.isEditing) {
            // Check if same dosage, quantity, and frequency in cabinet.
            if (isSameDrugQtyFreq) {
                return true;
            }
            // Brand is being added, check if it is already in the cabinet.
            if (isBrand) {
                if (this.isBrandInCabinet(entryToBeAdded)) {
                    // If in the cabinet, check if quantity/frequency/package is being changed
                    if (isSameDrugQtyFreq) {
                        return true;
                    }
                }
                return false;
            }
            // Generic is to be added, brand equivalent is allowed to be in cabinet.
            if (this.isGenericInCabinet(entryToBeAdded)) {
                if (isSameDrugQtyFreq) {
                    return true;
                }
            }
            return false;
        }
        // Scenario: Editing a drug in cabinet.
        if (isBrand) {
            return this.isBrandEditInCabinet(entryToBeAdded, isSameDrugQtyFreq);
        }
        return this.isGenericEditInCabinet(entryToBeAdded, isSameDrugQtyFreq);
    }
    isBrandEditInCabinet(entryToBeAdded, isSameDrugQtyFreq) {
        const brandInCabinet = this.isBrandInCabinet(entryToBeAdded);
        // if !isSameDrugQtyFreq then we are editing the quantity and/or frequency
        if (!isSameDrugQtyFreq) {
            if (brandInCabinet) {
                // but we must also check if the dosage is swapped to a value in cabinet.
                if (this.isDosageSwappedOnEdit(entryToBeAdded)) {
                    // show tooltip
                    return true;
                }
                return false;
            }
        }
        // Properly handle edits on drugs without edits.
        return this.isDrugEdited(entryToBeAdded, brandInCabinet);
    }
    isGenericEditInCabinet(entryToBeAdded, isSameDrugQtyFreq) {
        const genericInCabinet = this.isGenericInCabinet(entryToBeAdded);
        if (!isSameDrugQtyFreq) {
            if (genericInCabinet) {
                if (this.isDosageSwappedOnEdit(entryToBeAdded)) {
                    return true;
                }
                return false;
            }
            // brand in cabinet
            // if not swapped, then same dosage edit
            const isDosageSwapped = this.isDosageSwappedOnEdit(entryToBeAdded);
            if (isDosageSwapped) {
                if (this.swapWithDirectGeneric) {
                    return false;
                }
            }
        }
        return this.isDrugEdited(entryToBeAdded, genericInCabinet);
    }
    isSameDrugInCabinet(entryToBeAdded) {
        const cabinetEntry = this.drugCabinet.find(entry => entry.dosageID === entryToBeAdded.dosageId);
        // if drug is not in cabinet return false.
        if (!cabinetEntry) {
            return false;
        }
        const dosageInCabinet = cabinetEntry.dosage;
        // it is in cabinet check it's package+quantity+frequency
        const selectedQuantity = +this.selectedDosage.userQuantity;
        const isUserQuantityEqual = dosageInCabinet.userQuantity === selectedQuantity;
        const isDaysOfSupplyEqual = dosageInCabinet.daysOfSupply === this.selectedDosage.daysOfSupply;
        const isPackagesEqual = dosageInCabinet.selectedPackageId === this.selectedDosage.selectedPackageId;
        // check if entry to be added has packages, if it does check if package ids are the same
        const hasPackages = this.selectedDosage.packages && this.selectedDosage.packages.length > 0;
        if (hasPackages) {
            return isUserQuantityEqual && isDaysOfSupplyEqual && isPackagesEqual;
        }
        return isUserQuantityEqual && isDaysOfSupplyEqual;
    }
    // check if a drug is being edited with user performing no action
    // invoke after determining if we are editing drug quantity frequency/package information.
    isDrugEdited(entryEdited, isInCabinet) {
        if (isInCabinet) {
            if (!this.isDosageSwappedOnEdit(entryEdited)) {
                return false;
            }
            return true;
        }
        return this.swapWithDirectGeneric;
    }
    // check if initial dosage itself is changed when editing
    isDosageSwappedOnEdit(entryToBeAdded) {
        const isSameDosage = entryToBeAdded.dosageId === this.initialSelection.dosageId;
        return !isSameDosage;
    }
    // if brand drug is to be added we need to see if it is in cabinet
    isBrandInCabinet(entryToBeAdded) {
        const dosagesInCabinet = this.drugCabinet.map(entry => entry.dosage);
        // Get the brand dosage ids for the brand drugs in the cabinet and likewise check if included.
        const dosageIdsInCabinet = dosagesInCabinet
            .filter(dosage => (this.isUseCMSDrugFlagEnabled ? dosage.drugFlag === DrugFlag.Brand : dosage.drugType === DrugType.Brand))
            .map(dosage => dosage.dosageId);
        return dosageIdsInCabinet.includes(entryToBeAdded.dosageId);
    }
    // if generic drug is to be added we need to see if if it is in the cabinet
    isGenericInCabinet(entryToBeAdded) {
        const dosagesInCabinet = this.drugCabinet.map(entry => entry.dosage);
        // Get the generic dosage ids for the generic drugs in the cabinet and likewise check if included.
        const generics = dosagesInCabinet
            .filter(dosage => (this.isUseCMSDrugFlagEnabled ? dosage.drugFlag === DrugFlag.Generic : dosage.drugType === DrugType.Generic))
            .map(dosage => dosage.dosageId);
        return generics.includes(entryToBeAdded.dosageId);
    }
    getGenericAlternative() {
        if (this.drugDetails.hasGenericDrug && this.drugDetails.genericDrug) {
            const genericDosage = this.drugDetails.genericDrug.dosages.find(dosage => dosage.dosageId === this.selectedDosage.genericDosageId);
            if (!genericDosage) {
                return null;
            }
            genericDosage.userQuantity = this.selectedDosage.userQuantity;
            genericDosage.daysOfSupply = this.selectedDosage.daysOfSupply;
            if (genericDosage.packages.length >= 0) {
                const genericPackage = genericDosage.packages.find(dosagePackage => dosagePackage.isCommonPackage);
                if (genericPackage) {
                    genericDosage.selectedPackageId = genericPackage.packageId;
                }
            }
            return genericDosage;
        }
    }
    showCoveredPrescriptions(coveredDrugPlanTier) {
        if (!this.isHelpfulToolsView) {
            return true;
        }
        else {
            return coveredDrugPlanTier.some(planTier => planTier.hasDrugs);
        }
    }
    isDrugCountInLimits(drugCabinet, isEditing, medicineCabinetLimit) {
        // We can exclude the limit in the case of an edit
        if (!isEditing && drugCabinet && drugCabinet.length >= medicineCabinetLimit) {
            return false;
        }
        return true;
    }
    checkingOffFormularyDrugAlternativesButton(helpfulToolsPlan, helpfulToolsDrugDetails, isDrugCovered) {
        const planDrugCoverage = helpfulToolsPlan?.planRetailDrugCoverageMultiPharmacy;
        const hasDrugAlternativesOnCabinet = this.drugDetailsFacade.planHasDrugAlternatives(planDrugCoverage) &&
            this.drugDetailsFacade.drugHasAlternatives(helpfulToolsDrugDetails?.dosageID, planDrugCoverage);
        this.showOffFormularyDrugAlternativesButton =
            hasDrugAlternativesOnCabinet &&
                this.showDrugAlternativesEnabled &&
                this.helpfulToolsShowDrugAlternativesNudgeEnabled &&
                !isDrugCovered &&
                this.pharmacyService.isPharmacyInNetworkForDrugAlternatives(this.selectedPlanPharmacy);
    }
    setAnalyticsForPreferencesAddDrug(cabinetEntry) {
        const drugName = this.drugsService.getDrugNameForAnalytics(cabinetEntry);
        const drugType = this.drugsService.getDrugTypeForAnalytics(cabinetEntry);
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PREFERENCES_ADD_DRUG,
            [DataLayerGlobalVariable.DRUG_NAME]: drugName,
            [DataLayerGlobalVariable.DRUG_IS_BRANDED_OR_GENERIC]: drugType
        };
    }
    setAnalyticsForViewDrugAlternatives(plan, cabinetEntry) {
        this.analyticsService.googleDataLayerTags = this.planDetailsFacade.getViewDrugAlternativesTag(plan, cabinetEntry, this.pharmacyService.getIsMailOrderSelected(), true);
    }
}
DrugDetailsComponent.ɵfac = function DrugDetailsComponent_Factory(t) { return new (t || DrugDetailsComponent)(i0.ɵɵdirectiveInject(i1.DrugsService), i0.ɵɵdirectiveInject(DrugDetailsFacade), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(HelpfulToolsContextService), i0.ɵɵdirectiveInject(HelpfulToolsService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.PharmacyService), i0.ɵɵdirectiveInject(PlanDetailsFacade), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(i1.NavigationContext)); };
DrugDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DrugDetailsComponent, selectors: [["vnext-drug-details"]], inputs: { selectedDosage: "selectedDosage", drugDetails: "drugDetails", isQuantityValid: "isQuantityValid", activeGenericOption: "activeGenericOption", genericEquivalentQuestion: "genericEquivalentQuestion", defaultFrequency: "defaultFrequency", dosages: "dosages", drugName: "drugName", hasGenericDrug: "hasGenericDrug", dosageToEdit: "dosageToEdit", genericOptions: "genericOptions", genericOptionIcon: "genericOptionIcon", showGenericOption: "showGenericOption", genericOptionInfo: "genericOptionInfo", frequencyList: "frequencyList", contentSectionText: "contentSectionText", dosageHeader: "dosageHeader", packageHeader: "packageHeader", quantityAndFrequencyHeader: "quantityAndFrequencyHeader", addButtonText: "addButtonText", cancelButtonText: "cancelButtonText", quantityMaxLimit: "quantityMaxLimit", quantityErrorMessage: "quantityErrorMessage", medicineCabinetLimit: "medicineCabinetLimit", cabinetLimitErrorMessage: "cabinetLimitErrorMessage", inCabinetErrorMessage: "inCabinetErrorMessage", isEditing: "isEditing", checkDrugCoverageButtonText: "checkDrugCoverageButtonText", isUseCMSDrugFlagEnabled: "isUseCMSDrugFlagEnabled", isMobile: "isMobile", showCosts: "showCosts", helpfulTools: "helpfulTools", helpfulToolsPlan: "helpfulToolsPlan", errorKeywordText: "errorKeywordText", drugSearchFrequencyListBoxLabel: "drugSearchFrequencyListBoxLabel", nonCoveredPrescriptions: "nonCoveredPrescriptions", coveredPrescriptions: "coveredPrescriptions", noPrescriptionInTier: "noPrescriptionInTier", editDrugText: "editDrugText", showDrugAlternativesEnabled: "showDrugAlternativesEnabled", helpfulToolsShowDrugAlternativesNudgeEnabled: "helpfulToolsShowDrugAlternativesNudgeEnabled", prescriptionsDrugAlternativesButtonText: "prescriptionsDrugAlternativesButtonText", prescriptionTabView: "prescriptionTabView", cabinetForAlternatives: "cabinetForAlternatives", selectedPlanPharmacy: "selectedPlanPharmacy", isModalDrugDetail: "isModalDrugDetail" }, outputs: { updateIsQuantityValid: "updateIsQuantityValid", updateActiveGenericOption: "updateActiveGenericOption", updateFrequency: "updateFrequency", removeSelectedDrug: "removeSelectedDrug", viewPossibleAlternativeDrugs: "viewPossibleAlternativeDrugs" }, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 18, consts: [[1, "drug-details-container", "mb-2", 3, "ngClass"], [1, "drug-details-body"], [4, "ngIf", "ngIfElse"], ["drugCoverageDetails", ""], [1, "drug-details-footer", "w-100"], [3, "helpfulTools", "inCabinet", "addButtonText", "inCabinetErrorMessage", "drugCountInLimits", "cabinetLimitErrorMessage", "showDrugCoverageDetails", "checkDrugCoverageButtonText", "editDrugText", "cancelButtonText", "showOffFormularyDrugAlternativesButton", "prescriptionsDrugAlternativesButtonText", "isMobile", "addDrug", "showCoverage", "hideCoverage", "viewPossibleAlternativeDrugs", "cancel"], [1, "Spa_Style_H2", "no-translate-block"], [1, "Spa_Style_Paragraph", "mb-3", "mb-md-4", "mt-2"], [1, "row"], ["id", "quantityFieldError", "class", "col-12 col-md-6 col-lg-5 offset-md-6 offset-lg-7 pl-md-0 order-2 order-md-1 Spa_Style_ErrorBarAndIcon mb-1", 4, "ngIf"], [1, "col-12", "col-md-6", "col-lg-7", "mb-4", "order-1", "order-md-2"], ["id", "dosageHeaderId", 1, "Spa_Style_Label", "mb-2"], [3, "dosages", "activeDosageId", "ariaLabelledById", "setSelectedDosage"], [1, "col-12", "col-md-6", "col-lg-5", "pl-md-0", "order-3"], [3, "activeFrequency", "activeQuantity", "frequencyList", "quantityAndFrequencyHeader", "isQuantityValid", "drugSearchFrequencyListBoxLabel", "setQuantityOrFrequency"], [3, "packageList", "selectedPackageId", "packageHeader", "setSelectedPackage", "setPackageNDC", "setSelectedPackageUserQuantity", 4, "ngIf"], [3, "genericEquivalentQuestion", "activeGenericOption", "genericOptions", "genericOptionIcon", "genericOptionInfo", "replaceWithGenericDrug", 4, "ngIf"], ["id", "quantityFieldError", 1, "col-12", "col-md-6", "col-lg-5", "offset-md-6", "offset-lg-7", "pl-md-0", "order-2", "order-md-1", "Spa_Style_ErrorBarAndIcon", "mb-1"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], [1, "sr-only"], [3, "packageList", "selectedPackageId", "packageHeader", "setSelectedPackage", "setPackageNDC", "setSelectedPackageUserQuantity"], [3, "genericEquivalentQuestion", "activeGenericOption", "genericOptions", "genericOptionIcon", "genericOptionInfo", "replaceWithGenericDrug"], [4, "ngIf"], ["class", "Spa_Style_H2", 4, "liveEditProp"], [3, "coveredTiers", "noPrescriptionInTier", "isCovered", "medicineCabinet", "plan", "showGenericOption", "showCosts", "isHelpfulToolsView"], [1, "Spa_Style_H2"], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "covered-icon", "float-left", "mr-1"], [3, "nonCoveredDrugCostDetails", "noPrescriptionInTier", "isCovered", "medicineCabinet", "plan", "showGenericOption", "showCosts", "isHelpfulToolsView"], ["aria-hidden", "true", 1, "fas", "Spa_Style_NonCoveredPrescriptions_Icon", "float-left", "mr-1"]], template: function DrugDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, DrugDetailsComponent_ng_container_2_Template, 16, 15, "ng-container", 2);
        i0.ɵɵtemplate(3, DrugDetailsComponent_ng_template_3_Template, 2, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4)(6, "vnext-drug-details-footer", 5);
        i0.ɵɵlistener("addDrug", function DrugDetailsComponent_Template_vnext_drug_details_footer_addDrug_6_listener() { return ctx.addDrug(); })("showCoverage", function DrugDetailsComponent_Template_vnext_drug_details_footer_showCoverage_6_listener() { return ctx.showCoverage(); })("hideCoverage", function DrugDetailsComponent_Template_vnext_drug_details_footer_hideCoverage_6_listener() { return ctx.hideCoverage(); })("viewPossibleAlternativeDrugs", function DrugDetailsComponent_Template_vnext_drug_details_footer_viewPossibleAlternativeDrugs_6_listener() { return ctx.onViewPossibleAlternativeDrugs(); })("cancel", function DrugDetailsComponent_Template_vnext_drug_details_footer_cancel_6_listener() { return ctx.close(); });
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c1$13, ctx.isModalDrugDetail));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.showDrugCoverageDetails)("ngIfElse", _r1);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("helpfulTools", ctx.helpfulTools)("inCabinet", ctx.inCabinet)("addButtonText", ctx.addButtonText)("inCabinetErrorMessage", ctx.inCabinetErrorMessage)("drugCountInLimits", ctx.drugCountInLimits)("cabinetLimitErrorMessage", ctx.cabinetLimitErrorMessage)("showDrugCoverageDetails", ctx.showDrugCoverageDetails)("checkDrugCoverageButtonText", ctx.checkDrugCoverageButtonText)("editDrugText", ctx.editDrugText)("cancelButtonText", ctx.cancelButtonText)("showOffFormularyDrugAlternativesButton", ctx.showOffFormularyDrugAlternativesButton)("prescriptionsDrugAlternativesButtonText", ctx.prescriptionsDrugAlternativesButtonText)("isMobile", ctx.isMobile);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, LiveEditPropDirective, IconAriaAttributesDirective, DrugDetailsFooterComponent, DrugDosageComponent, DrugGenericEquivalentComponent, DrugPackageComponent, DrugQuantityFrequencyComponent, DrugCostDetailsComponent], styles: [".drug-details-container[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px}.drug-details-container.modal-detail-body[_ngcontent-%COMP%]{border:none}.drug-details-body[_ngcontent-%COMP%]{padding:10px 14px}.drug-details-container.modal-detail-body[_ngcontent-%COMP%]   .drug-details-body[_ngcontent-%COMP%]{padding:0}.drug-details-footer[_ngcontent-%COMP%]{border-top:1px solid var(--static-Spa_Style_Accent1);padding:8px 14px}.drug-details-container.modal-detail-body[_ngcontent-%COMP%]   .drug-details-footer[_ngcontent-%COMP%]{border:none;padding:30px 0 0}@media (max-width: 992px){.view-drug-alternatives-button[_ngcontent-%COMP%]{width:100%}}"], changeDetection: 0 });
__decorate([
    Select(MedicineCabinetState.medicineCabinet)
], DrugDetailsComponent.prototype, "cabinet$", void 0);
__decorate([
    LiveEditInactive()
], DrugDetailsComponent.prototype, "showCoverage", null);
__decorate([
    LiveEditInactive()
], DrugDetailsComponent.prototype, "hideCoverage", null);
__decorate([
    LiveEditInactive()
], DrugDetailsComponent.prototype, "addDrug", null);
__decorate([
    LiveEditInactive()
], DrugDetailsComponent.prototype, "close", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugDetailsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-drug-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"drug-details-container mb-2\" [ngClass]=\"{ 'modal-detail-body': isModalDrugDetail }\">\r\n  <div class=\"drug-details-body\">\r\n    <ng-container *ngIf=\"!showDrugCoverageDetails; else drugCoverageDetails\">\r\n      <h2 class=\"Spa_Style_H2 no-translate-block\">{{ drugName }}</h2>\r\n      <div class=\"Spa_Style_Paragraph mb-3 mb-md-4 mt-2\">{{ contentSectionText }}</div>\r\n      <div class=\"row\">\r\n        <div\r\n          id=\"quantityFieldError\"\r\n          class=\"col-12 col-md-6 col-lg-5 offset-md-6 offset-lg-7 pl-md-0 order-2 order-md-1 Spa_Style_ErrorBarAndIcon mb-1\"\r\n          *ngIf=\"!isQuantityValid\"\r\n        >\r\n          <span>\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span class=\"sr-only\"> {{ errorKeywordText }} </span>{{ quantityErrorMessage }}\r\n          </span>\r\n        </div>\r\n        <div class=\"col-12 col-md-6 col-lg-7 mb-4 order-1 order-md-2\">\r\n          <div class=\"Spa_Style_Label mb-2\" id=\"dosageHeaderId\">{{ dosageHeader }}</div>\r\n          <vnext-drug-dosage\r\n            [dosages]=\"dosages\"\r\n            [activeDosageId]=\"selectedDosage.dosageId\"\r\n            (setSelectedDosage)=\"setDrugDosage($event)\"\r\n            [ariaLabelledById]=\"'dosageHeaderId'\"\r\n          ></vnext-drug-dosage>\r\n        </div>\r\n        <!--Render drug quantity frequency component.-->\r\n        <div class=\"col-12 col-md-6 col-lg-5 pl-md-0 order-3\">\r\n          <vnext-drug-quantity-frequency\r\n            [activeFrequency]=\"defaultFrequency\"\r\n            [activeQuantity]=\"selectedDosage.userQuantity\"\r\n            [frequencyList]=\"frequencyList\"\r\n            [quantityAndFrequencyHeader]=\"quantityAndFrequencyHeader\"\r\n            [isQuantityValid]=\"isQuantityValid\"\r\n            (setQuantityOrFrequency)=\"updateDrugDetails($event)\"\r\n            [drugSearchFrequencyListBoxLabel]=\"drugSearchFrequencyListBoxLabel\"\r\n          ></vnext-drug-quantity-frequency>\r\n        </div>\r\n      </div>\r\n      <div>\r\n        <!--If drug and dosage has packages then render component-->\r\n        <vnext-drug-package\r\n          *ngIf=\"selectedDosage.packages && selectedDosage.packages.length > 0\"\r\n          [packageList]=\"selectedDosage.packages\"\r\n          [selectedPackageId]=\"selectedDosage.selectedPackageId\"\r\n          [packageHeader]=\"packageHeader\"\r\n          (setSelectedPackage)=\"updateDrugDetails($event)\"\r\n          (setPackageNDC)=\"updatePackageNDC($event)\"\r\n          (setSelectedPackageUserQuantity)=\"updateDrugDetails($event)\"\r\n        ></vnext-drug-package>\r\n      </div>\r\n      <vnext-drug-generic-equivalent\r\n        *ngIf=\"hasGenericDrug && showGenericOption\"\r\n        [genericEquivalentQuestion]=\"genericEquivalentQuestion\"\r\n        [activeGenericOption]=\"activeGenericOption\"\r\n        [genericOptions]=\"genericOptions\"\r\n        [genericOptionIcon]=\"genericOptionIcon\"\r\n        [genericOptionInfo]=\"genericOptionInfo\"\r\n        (replaceWithGenericDrug)=\"replaceWithGenericDrug($event)\"\r\n      ></vnext-drug-generic-equivalent>\r\n    </ng-container>\r\n\r\n    <ng-template #drugCoverageDetails>\r\n      <div *ngIf=\"isCovered\">\r\n        <div>\r\n          <h2 class=\"Spa_Style_H2\" *liveEditProp=\"'Spa_PrescriptionsTab_Covered_Text'\">\r\n            <i class=\"fas fa-check-circle covered-icon float-left mr-1\" aria-hidden=\"true\"></i>{{ coveredPrescriptions }}\r\n          </h2>\r\n        </div>\r\n        <!--Covered drugs section, no presciptions tag-->\r\n        <vnext-drug-cost-details\r\n          [coveredTiers]=\"coveredTiers\"\r\n          [noPrescriptionInTier]=\"noPrescriptionInTier\"\r\n          [isCovered]=\"true\"\r\n          [medicineCabinet]=\"[helpfulToolsDrugDetails]\"\r\n          [plan]=\"helpfulToolsPlanWithDetails\"\r\n          [showGenericOption]=\"showGenericOption\"\r\n          [showCosts]=\"showCosts\"\r\n          [isHelpfulToolsView]=\"isHelpfulToolsView\"\r\n        ></vnext-drug-cost-details>\r\n      </div>\r\n      <div *ngIf=\"!isCovered\">\r\n        <div>\r\n          <h2 class=\"Spa_Style_H2\" *liveEditProp=\"'Spa_PrescriptionsTab_NonCovered_Text'\">\r\n            <i class=\"fas Spa_Style_NonCoveredPrescriptions_Icon float-left mr-1\" aria-hidden=\"true\"></i>{{ nonCoveredPrescriptions }}\r\n          </h2>\r\n        </div>\r\n\r\n        <!--Nonovered drugs section (covered drugs), and no prescriptions tag-->\r\n        <vnext-drug-cost-details\r\n          [nonCoveredDrugCostDetails]=\"nonCoveredDrugCostDetails\"\r\n          [noPrescriptionInTier]=\"noPrescriptionInTier\"\r\n          [isCovered]=\"false\"\r\n          [medicineCabinet]=\"[helpfulToolsDrugDetails]\"\r\n          [plan]=\"helpfulToolsPlanWithDetails\"\r\n          [showGenericOption]=\"showGenericOption\"\r\n          [showCosts]=\"showCosts\"\r\n          [isHelpfulToolsView]=\"isHelpfulToolsView\"\r\n        ></vnext-drug-cost-details>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div class=\"drug-details-footer w-100\">\r\n    <vnext-drug-details-footer\r\n      [helpfulTools]=\"helpfulTools\"\r\n      [inCabinet]=\"inCabinet\"\r\n      [addButtonText]=\"addButtonText\"\r\n      [inCabinetErrorMessage]=\"inCabinetErrorMessage\"\r\n      [drugCountInLimits]=\"drugCountInLimits\"\r\n      [cabinetLimitErrorMessage]=\"cabinetLimitErrorMessage\"\r\n      [showDrugCoverageDetails]=\"showDrugCoverageDetails\"\r\n      [checkDrugCoverageButtonText]=\"checkDrugCoverageButtonText\"\r\n      [editDrugText]=\"editDrugText\"\r\n      [cancelButtonText]=\"cancelButtonText\"\r\n      [showOffFormularyDrugAlternativesButton]=\"showOffFormularyDrugAlternativesButton\"\r\n      [prescriptionsDrugAlternativesButtonText]=\"prescriptionsDrugAlternativesButtonText\"\r\n      [isMobile]=\"isMobile\"\r\n      (addDrug)=\"addDrug()\"\r\n      (showCoverage)=\"showCoverage()\"\r\n      (hideCoverage)=\"hideCoverage()\"\r\n      (viewPossibleAlternativeDrugs)=\"onViewPossibleAlternativeDrugs()\"\r\n      (cancel)=\"close()\"\r\n    >\r\n    </vnext-drug-details-footer>\r\n  </div>\r\n</div>\r\n", styles: [".drug-details-container{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px}.drug-details-container.modal-detail-body{border:none}.drug-details-body{padding:10px 14px}.drug-details-container.modal-detail-body .drug-details-body{padding:0}.drug-details-footer{border-top:1px solid var(--static-Spa_Style_Accent1);padding:8px 14px}.drug-details-container.modal-detail-body .drug-details-footer{border:none;padding:30px 0 0}@media (max-width: 992px){.view-drug-alternatives-button{width:100%}}\n"] }]
    }], function () { return [{ type: i1.DrugsService }, { type: DrugDetailsFacade }, { type: i0.ChangeDetectorRef }, { type: HelpfulToolsContextService }, { type: HelpfulToolsService }, { type: AnalyticsService }, { type: i1.PharmacyService }, { type: PlanDetailsFacade }, { type: i1.NavigationUtilityService }, { type: i1.NavigationContext }]; }, { cabinet$: [], selectedDosage: [{
            type: Input
        }], drugDetails: [{
            type: Input
        }], isQuantityValid: [{
            type: Input
        }], activeGenericOption: [{
            type: Input
        }], genericEquivalentQuestion: [{
            type: Input
        }], defaultFrequency: [{
            type: Input
        }], dosages: [{
            type: Input
        }], drugName: [{
            type: Input
        }], hasGenericDrug: [{
            type: Input
        }], dosageToEdit: [{
            type: Input
        }], genericOptions: [{
            type: Input
        }], genericOptionIcon: [{
            type: Input
        }], showGenericOption: [{
            type: Input
        }], genericOptionInfo: [{
            type: Input
        }], frequencyList: [{
            type: Input
        }], contentSectionText: [{
            type: Input
        }], dosageHeader: [{
            type: Input
        }], packageHeader: [{
            type: Input
        }], quantityAndFrequencyHeader: [{
            type: Input
        }], addButtonText: [{
            type: Input
        }], cancelButtonText: [{
            type: Input
        }], quantityMaxLimit: [{
            type: Input
        }], quantityErrorMessage: [{
            type: Input
        }], medicineCabinetLimit: [{
            type: Input
        }], cabinetLimitErrorMessage: [{
            type: Input
        }], inCabinetErrorMessage: [{
            type: Input
        }], isEditing: [{
            type: Input
        }], checkDrugCoverageButtonText: [{
            type: Input
        }], isUseCMSDrugFlagEnabled: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], showCosts: [{
            type: Input
        }], helpfulTools: [{
            type: Input
        }], helpfulToolsPlan: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], drugSearchFrequencyListBoxLabel: [{
            type: Input
        }], nonCoveredPrescriptions: [{
            type: Input
        }], coveredPrescriptions: [{
            type: Input
        }], noPrescriptionInTier: [{
            type: Input
        }], editDrugText: [{
            type: Input
        }], showDrugAlternativesEnabled: [{
            type: Input
        }], helpfulToolsShowDrugAlternativesNudgeEnabled: [{
            type: Input
        }], prescriptionsDrugAlternativesButtonText: [{
            type: Input
        }], prescriptionTabView: [{
            type: Input
        }], cabinetForAlternatives: [{
            type: Input
        }], selectedPlanPharmacy: [{
            type: Input
        }], isModalDrugDetail: [{
            type: Input
        }], updateIsQuantityValid: [{
            type: Output
        }], updateActiveGenericOption: [{
            type: Output
        }], updateFrequency: [{
            type: Output
        }], removeSelectedDrug: [{
            type: Output
        }], viewPossibleAlternativeDrugs: [{
            type: Output
        }], showCoverage: [], hideCoverage: [], addDrug: [], close: [] }); })();

function DrugListCardModalComponent_vnext_drug_footnote_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-drug-footnote", 18);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("plan", ctx_r0.plan)("footnoteAId", ctx_r0.footnoteAId)("footnoteIdsToShow", ctx_r0.footnoteIds);
} }
function DrugListCardModalComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19)(1, "button", 20);
    i0.ɵɵlistener("click", function DrugListCardModalComponent_div_10_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.onViewPossibleAlternativeDrugs(ctx_r6.cabinet)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.prescriptionsDrugAlternativesButtonText, " ");
} }
function DrugListCardModalComponent_p_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 21);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r2.dosePackageQuantityFreq, i0.ɵɵsanitizeHtml);
} }
function DrugListCardModalComponent_ng_container_14_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 24);
    i0.ɵɵelement(2, "vnext-drug-type", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("dosage", ctx_r8.dosage)("drugListCardBrandText", ctx_r8.Spa_DrugListCard_Brand_Text)("drugListCardGenericText", ctx_r8.Spa_DrugListCard_Generic_Text);
} }
function DrugListCardModalComponent_ng_container_14_ng_template_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 28);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r11.Spa_DrugListCard_Brand_Text, " ");
} }
function DrugListCardModalComponent_ng_container_14_ng_template_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r13.Spa_DrugListCard_Generic_Text);
} }
function DrugListCardModalComponent_ng_container_14_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtemplate(1, DrugListCardModalComponent_ng_container_14_ng_template_2_ng_container_1_Template, 3, 1, "ng-container", 22);
    i0.ɵɵtemplate(2, DrugListCardModalComponent_ng_container_14_ng_template_2_ng_template_2_Template, 2, 1, "ng-template", null, 27, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r12 = i0.ɵɵreference(3);
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r10.isLowerCostGeneric)("ngIfElse", _r12);
} }
function DrugListCardModalComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DrugListCardModalComponent_ng_container_14_ng_container_1_Template, 3, 3, "ng-container", 22);
    i0.ɵɵtemplate(2, DrugListCardModalComponent_ng_container_14_ng_template_2_Template, 4, 2, "ng-template", null, 23, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r9 = i0.ɵɵreference(3);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.Spa_Drugs_UseCMSDrugFlag_Enabled)("ngIfElse", _r9);
} }
function DrugListCardModalComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29)(1, "div", 26)(2, "vnext-link", 30);
    i0.ɵɵlistener("keyup.Space", function DrugListCardModalComponent_div_15_Template_vnext_link_keyup_Space_2_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.editDrug(ctx_r14.dosage.dosageId)); })("click", function DrugListCardModalComponent_div_15_Template_vnext_link_click_2_listener() { i0.ɵɵrestoreView(_r15); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.editDrug(ctx_r16.dosage.dosageId)); })("keyup.enter", function DrugListCardModalComponent_div_15_Template_vnext_link_keyup_enter_2_listener() { i0.ɵɵrestoreView(_r15); const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.editDrug(ctx_r17.dosage.dosageId)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "i", 31);
    i0.ɵɵlistener("keyup.Space", function DrugListCardModalComponent_div_15_Template_i_keyup_Space_3_listener() { i0.ɵɵrestoreView(_r15); const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.removeDrug(ctx_r18.dosage)); })("click", function DrugListCardModalComponent_div_15_Template_i_click_3_listener() { i0.ɵɵrestoreView(_r15); const ctx_r19 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r19.removeDrug(ctx_r19.dosage)); })("keyup.enter", function DrugListCardModalComponent_div_15_Template_i_keyup_enter_3_listener() { i0.ɵɵrestoreView(_r15); const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.removeDrug(ctx_r20.dosage)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", ctx_r4.Spa_DrugListCard_Edit_Text)("makeInlineBlock", true)("isLinkButton", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r4.Spa_DrugListCard_Delete_Text);
    i0.ɵɵattribute("aria-label", ctx_r4.Spa_DrugListCard_DeleteDrug_Text);
} }
function DrugListCardModalComponent_div_18_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 34);
    i0.ɵɵelementStart(2, "p");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r21.Spa_DrugListCard_PlanCovered_Text);
} }
function DrugListCardModalComponent_div_18_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 35);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r23.Spa_DrugListCard_PlanNotCovered_Text);
} }
function DrugListCardModalComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtemplate(1, DrugListCardModalComponent_div_18_ng_container_1_Template, 4, 1, "ng-container", 22);
    i0.ɵɵtemplate(2, DrugListCardModalComponent_div_18_ng_template_2_Template, 3, 1, "ng-template", null, 33, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r22 = i0.ɵɵreference(3);
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.isCovered)("ngIfElse", _r22);
} }
class DrugListCardModalComponent extends DrugListCardComponent {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, drugsService, drugDetailsFacade, pharmacyFacade, localeService, drugFrequencyFacade, pharmacyService, planFacade) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, drugsService, drugDetailsFacade, pharmacyFacade, localeService, drugFrequencyFacade, pharmacyService, planFacade);
        this.cdr = cdr;
        this.widgetValidationService = widgetValidationService;
        this.configurableWidgetService = configurableWidgetService;
        this.zoneService = zoneService;
        this.widgetService = widgetService;
        this.drugsService = drugsService;
        this.drugDetailsFacade = drugDetailsFacade;
        this.pharmacyFacade = pharmacyFacade;
        this.localeService = localeService;
        this.drugFrequencyFacade = drugFrequencyFacade;
        this.pharmacyService = pharmacyService;
        this.planFacade = planFacade;
    }
    ngOnInit() {
        super.ngOnInit();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
DrugListCardModalComponent.ɵfac = function DrugListCardModalComponent_Factory(t) { return new (t || DrugListCardModalComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.DrugsService), i0.ɵɵdirectiveInject(DrugDetailsFacade), i0.ɵɵdirectiveInject(PharmacyFacade), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.DrugFrequencyFacade), i0.ɵɵdirectiveInject(i1.PharmacyService), i0.ɵɵdirectiveInject(PlanFacade)); };
DrugListCardModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DrugListCardModalComponent, selectors: [["vnext-drug-list-card-modal"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 19, vars: 7, consts: [["role", "rowgroup", 1, "drug-card-panel-container"], ["role", "row", 1, "drug-card-panel"], ["role", "columnheader", "aria-colspan", "2"], [1, "drug-card-panel-header"], ["id", "drug-detail", 1, "row"], [1, "row", "w-100", "dosage-label-order", "no-translate-block"], [1, "col-6", "col-lg-4", "order-1", "order-lg-1"], [1, "Spa_Style_Regular_Font", "Spa_Style_Primary_Color", "Spa_Style_Semi_Bold_Weight"], [3, "plan", "footnoteAId", "footnoteIdsToShow", 4, "ngIf"], ["class", "col-6 col-lg-4 d-flex justify-content-end order-1 order-lg-1", 4, "ngIf"], [1, "col-6", "col-lg-4", "order-3", "order-lg-2"], ["class", "float-left Spa_Style_Paragraph", 3, "innerHTML", 4, "ngIf"], [1, "col-6", "col-lg-2", "order-2", "order-lg-3"], [4, "ngIf"], ["class", "col-6 col-lg-2 order-4 order-lg-4", 4, "ngIf"], [1, "drug-card-panel-body"], [1, "row"], ["class", "text-center col-12", 4, "ngIf"], [3, "plan", "footnoteAId", "footnoteIdsToShow"], [1, "col-6", "col-lg-4", "d-flex", "justify-content-end", "order-1", "order-lg-1"], ["type", "button", 1, "btn", "d-block", "text-break", "Spa_Style_PrimaryButton", "Spa_Style_Small_Font", "px-2", "view-drug-alternatives-button", 3, "click"], [1, "float-left", "Spa_Style_Paragraph", 3, "innerHTML"], [4, "ngIf", "ngIfElse"], ["CMSDrugType", ""], [1, "d-flex", "justify-content-end"], [3, "dosage", "drugListCardBrandText", "drugListCardGenericText"], [1, "float-right"], ["lowerCostGeneric", ""], [1, "Spa_Style_Smaller_Font", "Spa_Style_Gray4_Color"], [1, "col-6", "col-lg-2", "order-4", "order-lg-4"], [1, "mr-2", 3, "title", "makeInlineBlock", "isLinkButton", "keyup.Space", "click", "keyup.enter"], ["role", "button", "tabindex", "0", 1, "fas", "fa-times", "ml-3", "can-click", 3, "title", "keyup.Space", "click", "keyup.enter"], [1, "text-center", "col-12"], ["noDrugCoverage", ""], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "drug-coverage-icon", "Spa_Style_Accent5_Color", "Spa_Style_Largest_Font"], ["aria-hidden", "true", 1, "fas", "fa-times-circle", "drug-coverage-icon", "Spa_Style_Accent1_Color", "Spa_Style_Largest_Font"]], template: function DrugListCardModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "header", 3)(4, "div", 4)(5, "div", 5)(6, "div", 6)(7, "h3", 7);
        i0.ɵɵtext(8);
        i0.ɵɵtemplate(9, DrugListCardModalComponent_vnext_drug_footnote_9_Template, 1, 3, "vnext-drug-footnote", 8);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(10, DrugListCardModalComponent_div_10_Template, 3, 1, "div", 9);
        i0.ɵɵelementStart(11, "div", 10);
        i0.ɵɵtemplate(12, DrugListCardModalComponent_p_12_Template, 1, 1, "p", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 12);
        i0.ɵɵtemplate(14, DrugListCardModalComponent_ng_container_14_Template, 4, 2, "ng-container", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(15, DrugListCardModalComponent_div_15_Template, 4, 5, "div", 14);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(16, "div", 15)(17, "div", 16);
        i0.ɵɵtemplate(18, DrugListCardModalComponent_div_18_Template, 4, 2, "div", 17);
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(8);
        i0.ɵɵtextInterpolate1(" ", ctx.dosage.labelName, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isDrugCostsTab);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showOffFormularyDrugAlternativesButton);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showDosePackageQuantityFrequency);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showGenericOption);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isDrugCostsTab);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.showCoverageNudge && ctx.isCovered !== undefined && ctx.isCovered !== null);
    } }, dependencies: [i1$2.NgIf, LinkComponent, IconAriaAttributesDirective, DrugFootNoteComponent, DrugTypeComponent], styles: [".drug-card-panel[_ngcontent-%COMP%]{background:white;box-shadow:none}.drug-card-panel-body[_ngcontent-%COMP%], .drug-card-panel-header[_ngcontent-%COMP%]{line-height:20px;vertical-align:top}.drug-card-panel-body[_ngcontent-%COMP%]{padding:2px 15px 7px}.drug-card-panel-header[_ngcontent-%COMP%]{padding:9px 15px 0}.drug-card-panel[_ngcontent-%COMP%]   .drug-card-panel-body[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-bottom:0}.drug-card-panel-container[_ngcontent-%COMP%]{margin-top:.75rem}.drug-coverage-icon[_ngcontent-%COMP%]{margin-bottom:15px;margin-top:15px}.drug-card-panel-header[_ngcontent-%COMP%]   i.fas[_ngcontent-%COMP%]{width:20px;height:20px;text-align:center}.drug-card-panel-header[_ngcontent-%COMP%]   i.fas[_ngcontent-%COMP%]:before{vertical-align:middle}.dosage-label-order[_ngcontent-%COMP%]{order:unset}@media (max-width: 767px){.dosage-label-order[_ngcontent-%COMP%]{order:2}}@media (max-width: 992px){.view-drug-alternatives-button[_ngcontent-%COMP%]{width:100%}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugListCardModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-drug-list-card-modal', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"drug-card-panel-container\" role=\"rowgroup\">\r\n  <div class=\"drug-card-panel\" role=\"row\">\r\n    <div role=\"columnheader\" aria-colspan=\"2\">\r\n      <header class=\"drug-card-panel-header\">\r\n        <div class=\"row\" id=\"drug-detail\">\r\n          <div class=\"row w-100 dosage-label-order no-translate-block\">\r\n            <div class=\"col-6 col-lg-4 order-1 order-lg-1\">\r\n              <h3 class=\"Spa_Style_Regular_Font Spa_Style_Primary_Color Spa_Style_Semi_Bold_Weight\">\r\n                {{ dosage.labelName }}\r\n                <vnext-drug-footnote\r\n                  *ngIf=\"isDrugCostsTab\"\r\n                  [plan]=\"plan\"\r\n                  [footnoteAId]=\"footnoteAId\"\r\n                  [footnoteIdsToShow]=\"footnoteIds\"\r\n                ></vnext-drug-footnote>\r\n              </h3>\r\n            </div>\r\n\r\n            <div class=\"col-6 col-lg-4 d-flex justify-content-end order-1 order-lg-1\" *ngIf=\"showOffFormularyDrugAlternativesButton\">\r\n              <button\r\n                type=\"button\"\r\n                class=\"btn d-block text-break Spa_Style_PrimaryButton Spa_Style_Small_Font px-2 view-drug-alternatives-button\"\r\n                (click)=\"onViewPossibleAlternativeDrugs(cabinet)\"\r\n              >\r\n                {{ prescriptionsDrugAlternativesButtonText }}\r\n              </button>\r\n            </div>\r\n            <div class=\"col-6 col-lg-4 order-3 order-lg-2\">\r\n              <p *ngIf=\"showDosePackageQuantityFrequency\" class=\"float-left Spa_Style_Paragraph\" [innerHTML]=\"dosePackageQuantityFreq\"></p>\r\n            </div>\r\n            <div class=\"col-6 col-lg-2 order-2 order-lg-3\">\r\n              <ng-container *ngIf=\"showGenericOption\">\r\n                <!--If generic option enabled display-->\r\n                <ng-container *ngIf=\"Spa_Drugs_UseCMSDrugFlag_Enabled; else CMSDrugType\">\r\n                  <div class=\"d-flex justify-content-end\">\r\n                    <vnext-drug-type\r\n                      [dosage]=\"dosage\"\r\n                      [drugListCardBrandText]=\"Spa_DrugListCard_Brand_Text\"\r\n                      [drugListCardGenericText]=\"Spa_DrugListCard_Generic_Text\"\r\n                    >\r\n                    </vnext-drug-type>\r\n                  </div>\r\n                </ng-container>\r\n\r\n                <ng-template #CMSDrugType>\r\n                  <div class=\"float-right\">\r\n                    <ng-container *ngIf=\"!isLowerCostGeneric; else lowerCostGeneric\">\r\n                      <div class=\"Spa_Style_Smaller_Font Spa_Style_Gray4_Color\">\r\n                        {{ Spa_DrugListCard_Brand_Text }}\r\n                      </div>\r\n                    </ng-container>\r\n                    <ng-template #lowerCostGeneric>\r\n                      <div class=\"Spa_Style_Smaller_Font Spa_Style_Gray4_Color\">{{ Spa_DrugListCard_Generic_Text }}</div>\r\n                    </ng-template>\r\n                  </div>\r\n                </ng-template>\r\n              </ng-container>\r\n            </div>\r\n\r\n            <div class=\"col-6 col-lg-2 order-4 order-lg-4\" *ngIf=\"!isDrugCostsTab\">\r\n              <div class=\"float-right\">\r\n                <vnext-link\r\n                  [title]=\"Spa_DrugListCard_Edit_Text\"\r\n                  (keyup.Space)=\"editDrug(dosage.dosageId)\"\r\n                  (click)=\"editDrug(dosage.dosageId)\"\r\n                  (keyup.enter)=\"editDrug(dosage.dosageId)\"\r\n                  class=\"mr-2\"\r\n                  [makeInlineBlock]=\"true\"\r\n                  [isLinkButton]=\"true\"\r\n                ></vnext-link>\r\n                <i\r\n                  class=\"fas fa-times ml-3 can-click\"\r\n                  (keyup.Space)=\"removeDrug(dosage)\"\r\n                  (click)=\"removeDrug(dosage)\"\r\n                  (keyup.enter)=\"removeDrug(dosage)\"\r\n                  [title]=\"Spa_DrugListCard_Delete_Text\"\r\n                  [attr.aria-label]=\"Spa_DrugListCard_DeleteDrug_Text\"\r\n                  role=\"button\"\r\n                  tabindex=\"0\"\r\n                ></i>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </header>\r\n      <div class=\"drug-card-panel-body\">\r\n        <div class=\"row\">\r\n          <!--Has a row with two columns-->\r\n\r\n          <div class=\"text-center col-12\" *ngIf=\"showCoverageNudge && isCovered !== undefined && isCovered !== null\">\r\n            <ng-container *ngIf=\"isCovered; else noDrugCoverage\">\r\n              <i class=\"fas fa-check-circle drug-coverage-icon Spa_Style_Accent5_Color Spa_Style_Largest_Font\" aria-hidden=\"true\"></i>\r\n              <p>{{ Spa_DrugListCard_PlanCovered_Text }}</p>\r\n            </ng-container>\r\n            <ng-template #noDrugCoverage>\r\n              <i class=\"fas fa-times-circle drug-coverage-icon Spa_Style_Accent1_Color Spa_Style_Largest_Font\" aria-hidden=\"true\"></i>\r\n              <p>{{ Spa_DrugListCard_PlanNotCovered_Text }}</p>\r\n            </ng-template>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".drug-card-panel{background:white;box-shadow:none}.drug-card-panel-body,.drug-card-panel-header{line-height:20px;vertical-align:top}.drug-card-panel-body{padding:2px 15px 7px}.drug-card-panel-header{padding:9px 15px 0}.drug-card-panel .drug-card-panel-body p{margin-bottom:0}.drug-card-panel-container{margin-top:.75rem}.drug-coverage-icon{margin-bottom:15px;margin-top:15px}.drug-card-panel-header i.fas{width:20px;height:20px;text-align:center}.drug-card-panel-header i.fas:before{vertical-align:middle}.dosage-label-order{order:unset}@media (max-width: 767px){.dosage-label-order{order:2}}@media (max-width: 992px){.view-drug-alternatives-button{width:100%}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.DrugsService }, { type: DrugDetailsFacade }, { type: PharmacyFacade }, { type: i1.LocaleService }, { type: i1.DrugFrequencyFacade }, { type: i1.PharmacyService }, { type: PlanFacade }]; }, null); })();

function MedicineCabinetComponent_h2_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.medCabinetHeader);
} }
function MedicineCabinetComponent_vnext_drug_list_card_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-drug-list-card", 5);
} if (rf & 2) {
    const entry_r2 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cabinet", entry_r2)("showGenericOption", ctx_r1.showGenericOption)("showCoverageNudge", true)("pageTag", ctx_r1.pageTagsModel.GUIDED_HELP_PRESCRIPTIONS);
} }
let MedicineCabinetComponent = class MedicineCabinetComponent extends ConfigurableWidget {
    constructor() {
        super(...arguments);
        this.displayHeader = true;
        this.pageTagsModel = PageTags;
        this._visibleCabinetIndex$ = new BehaviorSubject(7);
        this.visibleCabinetIndex$ = this._visibleCabinetIndex$.asObservable();
    }
    ngOnInit() {
        super.ngOnInit();
        // Display all the dosages.  Each item in the cabinet (drug list) is a dosage.
        this.cabinetSubscription = combineLatest([this.cabinet$, this.visibleCabinetIndex$]).subscribe({
            next: ([cabinet, visibleCabinetIndex]) => {
                const sortedCabinet = [...cabinet].sort((a, b) => a.labelName.localeCompare(b.labelName));
                this.medicineCabinet = sortedCabinet;
                this.displayHeader = this.medicineCabinet.length > 0;
                this.visibleMedicineCabinet = sortedCabinet.slice(0, visibleCabinetIndex);
                this.cdr.markForCheck();
            }
        });
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        if (this.cabinetSubscription) {
            this.cabinetSubscription.unsubscribe();
        }
    }
    onScrollDown() {
        this.visibleCabinetIndex$.pipe(take(1)).subscribe({
            next: visibleCabinetIndex => {
                if (this.medicineCabinet.length > visibleCabinetIndex) {
                    this._visibleCabinetIndex$.next(visibleCabinetIndex + 5);
                }
            }
        });
    }
};
MedicineCabinetComponent.ɵfac = /*@__PURE__*/ function () { let ɵMedicineCabinetComponent_BaseFactory; return function MedicineCabinetComponent_Factory(t) { return (ɵMedicineCabinetComponent_BaseFactory || (ɵMedicineCabinetComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MedicineCabinetComponent)))(t || MedicineCabinetComponent); }; }();
MedicineCabinetComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedicineCabinetComponent, selectors: [["vnext-medicine-cabinet"]], inputs: { medCabinetHeader: "medCabinetHeader", showGenericOption: "showGenericOption" }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 4, consts: [[1, "row"], ["infiniteScroll", "", "aria-live", "polite", "aria-atomic", "true", 1, "col-12", "mt-2", "px-0", 3, "infiniteScrollDistance", "infiniteScrollThrottle", "scrolled"], ["class", "Spa_Style_H2", 4, "ngIf"], [3, "cabinet", "showGenericOption", "showCoverageNudge", "pageTag", 4, "ngFor", "ngForOf"], [1, "Spa_Style_H2"], [3, "cabinet", "showGenericOption", "showCoverageNudge", "pageTag"]], template: function MedicineCabinetComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵlistener("scrolled", function MedicineCabinetComponent_Template_div_scrolled_1_listener() { return ctx.onScrollDown(); });
        i0.ɵɵtemplate(2, MedicineCabinetComponent_h2_2_Template, 2, 1, "h2", 2);
        i0.ɵɵtemplate(3, MedicineCabinetComponent_vnext_drug_list_card_3_Template, 1, 4, "vnext-drug-list-card", 3);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("infiniteScrollDistance", 3)("infiniteScrollThrottle", 50);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.displayHeader);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.visibleMedicineCabinet);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, i2$2.InfiniteScrollDirective, DrugListCardComponent], changeDetection: 0 });
__decorate([
    Select(MedicineCabinetState.medicineCabinet)
], MedicineCabinetComponent.prototype, "cabinet$", void 0);
MedicineCabinetComponent = __decorate([
    PlatformWidget
], MedicineCabinetComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedicineCabinetComponent, [{
        type: Component,
        args: [{ selector: 'vnext-medicine-cabinet', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"row\">\r\n  <div\r\n    class=\"col-12 mt-2 px-0\"\r\n    infiniteScroll\r\n    [infiniteScrollDistance]=\"3\"\r\n    [infiniteScrollThrottle]=\"50\"\r\n    (scrolled)=\"onScrollDown()\"\r\n    aria-live=\"polite\"\r\n    aria-atomic=\"true\"\r\n  >\r\n    <h2 class=\"Spa_Style_H2\" *ngIf=\"displayHeader\">{{ medCabinetHeader }}</h2>\r\n    <!--For each drug, as listed in store-->\r\n    <vnext-drug-list-card\r\n      *ngFor=\"let entry of visibleMedicineCabinet\"\r\n      [cabinet]=\"entry\"\r\n      [showGenericOption]=\"showGenericOption\"\r\n      [showCoverageNudge]=\"true\"\r\n      [pageTag]=\"pageTagsModel.GUIDED_HELP_PRESCRIPTIONS\"\r\n    >\r\n    </vnext-drug-list-card>\r\n  </div>\r\n</div>\r\n" }]
    }], null, { cabinet$: [], medCabinetHeader: [{
            type: Input
        }], showGenericOption: [{
            type: Input
        }] }); })();

const _c0$2d = ["typeahead"];
const _c1$12 = ["drugSearchInput"];
function DrugSearchComponent_div_2_h1_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r7.prescriptionsText);
} }
function DrugSearchComponent_div_2_p_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 18);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r8.drugSearchIntroText, "html"), i0.ɵɵsanitizeHtml);
} }
function DrugSearchComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 13);
    i0.ɵɵelement(2, "i", 14);
    i0.ɵɵtemplate(3, DrugSearchComponent_div_2_h1_3_Template, 2, 1, "h1", 15);
    i0.ɵɵtemplate(4, DrugSearchComponent_div_2_p_4_Template, 2, 4, "p", 16);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_Prescriptions_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_DrugSearch_Intro_Text");
} }
function DrugSearchComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "ngb-highlight", 20);
} if (rf & 2) {
    const r_r9 = ctx.result;
    const t_r10 = ctx.term;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.drugSearchText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("result", r_r9.drugName)("term", t_r10);
} }
function DrugSearchComponent_input_7_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 21, 22);
    i0.ɵɵlistener("ngModelChange", function DrugSearchComponent_input_7_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.searchTerm = $event); })("selectItem", function DrugSearchComponent_input_7_Template_input_selectItem_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.selectItem($event)); })("click", function DrugSearchComponent_input_7_Template_input_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.clearSearchTerm()); })("keyup", function DrugSearchComponent_input_7_Template_input_keyup_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.scrollItemIntoView()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(6);
    i0.ɵɵproperty("placeholder", ctx_r3.placeholder)("ngbTypeahead", ctx_r3.suggestedDrugs)("resultTemplate", _r1)("inputFormatter", ctx_r3.drugAutocompleteformatter)("popupClass", ctx_r3.noTranslateBlockClass)("ngModel", ctx_r3.searchTerm);
    i0.ɵɵattribute("aria-label", ctx_r3.drugSearchPageHeaderText);
} }
function DrugSearchComponent_ng_container_11_vnext_drug_details_1_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-drug-details", 24);
    i0.ɵɵlistener("updateFrequency", function DrugSearchComponent_ng_container_11_vnext_drug_details_1_Template_vnext_drug_details_updateFrequency_0_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r19.updateFrequency($event)); })("updateIsQuantityValid", function DrugSearchComponent_ng_container_11_vnext_drug_details_1_Template_vnext_drug_details_updateIsQuantityValid_0_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r21 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r21.updateIsQuantityValid($event)); })("updateActiveGenericOption", function DrugSearchComponent_ng_container_11_vnext_drug_details_1_Template_vnext_drug_details_updateActiveGenericOption_0_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r22 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r22.updateActiveGenericOption($event)); })("removeSelectedDrug", function DrugSearchComponent_ng_container_11_vnext_drug_details_1_Template_vnext_drug_details_removeSelectedDrug_0_listener() { i0.ɵɵrestoreView(_r20); const ctx_r23 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r23.removeSelectedDrug()); })("viewPossibleAlternativeDrugs", function DrugSearchComponent_ng_container_11_vnext_drug_details_1_Template_vnext_drug_details_viewPossibleAlternativeDrugs_0_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r24 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r24.onViewPossibleAlternativeDrugs($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("isEditing", ctx_r18.isEditing)("drugName", ctx_r18.drugName)("drugDetails", ctx_r18.drugDetails)("selectedDosage", ctx_r18.drugDetails.commonDosage)("frequencyList", ctx_r18.frequencyList)("quantityAndFrequencyHeader", ctx_r18.quantityAndFrequencyHeader)("dosageHeader", ctx_r18.dosageHeader)("packageHeader", ctx_r18.packageHeader)("contentSectionText", ctx_r18.contentSectionText)("addButtonText", ctx_r18.addButtonText)("cancelButtonText", ctx_r18.cancelButtonText)("quantityMaxLimit", ctx_r18.quantityMaxLimit)("quantityErrorMessage", ctx_r18.quantityErrorMessage)("genericOptionIcon", ctx_r18.genericOptionIcon)("showGenericOption", ctx_r18.showGenericOption)("genericOptionInfo", ctx_r18.genericOptionInfo)("genericOptions", ctx_r18.genericOptions)("activeGenericOption", ctx_r18.activeGenericOption)("genericEquivalentQuestion", ctx_r18.genericEquivalentQuestion)("isQuantityValid", ctx_r18.isQuantityValid)("defaultFrequency", ctx_r18.defaultFrequency)("dosages", ctx_r18.dosages)("dosageToEdit", ctx_r18.dosageToEdit)("hasGenericDrug", ctx_r18.drugDetails.hasGenericDrug)("medicineCabinetLimit", ctx_r18.medicineCabinetLimit)("cabinetLimitErrorMessage", ctx_r18.cabinetLimitErrorMessage)("inCabinetErrorMessage", ctx_r18.inCabinetErrorMessage)("helpfulTools", ctx_r18.helpfulTools)("helpfulToolsPlan", ctx_r18.helpfulToolsPlan)("checkDrugCoverageButtonText", ctx_r18.checkDrugCoverageButtonText)("showCosts", !ctx_r18.showCosts)("errorKeywordText", ctx_r18.errorKeywordText)("drugSearchFrequencyListBoxLabel", ctx_r18.drugSearchFrequencyListBoxLabel)("nonCoveredPrescriptions", ctx_r18.nonCoveredPrescriptions)("coveredPrescriptions", ctx_r18.coveredPrescriptions)("noPrescriptionInTier", ctx_r18.noPrescriptionInTier)("editDrugText", ctx_r18.editDrugText)("isUseCMSDrugFlagEnabled", ctx_r18.isUseCMSDrugFlagEnabled)("showDrugAlternativesEnabled", ctx_r18.showDrugAlternativesEnabled)("helpfulToolsShowDrugAlternativesNudgeEnabled", ctx_r18.helpfulToolsShowDrugAlternativesNudgeEnabled)("cabinetForAlternatives", ctx_r18.cabinetForAlternatives)("selectedPlanPharmacy", ctx_r18.selectedPlanPharmacy)("prescriptionsDrugAlternativesButtonText", ctx_r18.prescriptionsDrugAlternativesButtonText)("isMobile", ctx_r18.isMobile);
} }
function DrugSearchComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DrugSearchComponent_ng_container_11_vnext_drug_details_1_Template, 1, 44, "vnext-drug-details", 23);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.drugDetails);
} }
function DrugSearchComponent_vnext_medicine_cabinet_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-medicine-cabinet", 25);
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("medCabinetHeader", ctx_r5.medCabinetHeader)("showGenericOption", ctx_r5.showGenericOption);
} }
function DrugSearchComponent_vnext_blue_button_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-blue-button", 26);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("startAddingDrugText", ctx_r6.blueButtonStartAddingDrugText)("orText", ctx_r6.orText)("connectToMyMedicareText", ctx_r6.blueButtonConnectToMyMedicareText)("myMedicareButtonText", ctx_r6.blueButtonMyMedicareButtonText)("emailLabelText", ctx_r6.emailLabelText)("emailRequiredErrorText", ctx_r6.emailRequiredErrorText)("emailInvalidErrorText", ctx_r6.emailInvalidErrorText)("sendEmailButtonText", ctx_r6.sendEmailButtonText)("blueButtonModalHeaderText", ctx_r6.blueButtonModalHeaderText)("blueButtonModalContent", ctx_r6.blueButtonModalContent)("blueButtonSuccessText", ctx_r6.blueButtonSuccessText)("blueButtonDownloadText", ctx_r6.blueButtonDownloadText)("blueButtonSuccessMessage", ctx_r6.blueButtonSuccessMessage)("blueButtonEmailSendText", ctx_r6.blueButtonEmailSendText)("blueButtonIssueLoadingText", ctx_r6.blueButtonIssueLoadingText)("blueButtonBeneficiaryDeniedText", ctx_r6.blueButtonBeneficiaryDeniedText)("blueButtonErrorLoadingText", ctx_r6.blueButtonErrorLoadingText)("blueButtonBeneficiaryEmailDetails", ctx_r6.blueButtonBeneficiaryEmailDetails)("blueButtonImportLatestPrescriptionButtonText", ctx_r6.blueButtonImportLatestPrescriptionButtonText)("blueButtonImportLatestPrescriptionErrorText", ctx_r6.blueButtonImportLatestPrescriptionErrorText)("blueButtonAccessDeniedText", ctx_r6.blueButtonAccessDeniedText)("blueButtonClaimDataLoadingErrorText", ctx_r6.blueButtonClaimDataLoadingErrorText);
} }
class DrugSearchComponent {
    constructor(cdr, drugsService, helpfulToolsService, helpfulToolsContext, deactivationService, renderer, autoCompleteService, createAccountContext, analyticsService) {
        this.cdr = cdr;
        this.drugsService = drugsService;
        this.helpfulToolsService = helpfulToolsService;
        this.helpfulToolsContext = helpfulToolsContext;
        this.deactivationService = deactivationService;
        this.renderer = renderer;
        this.autoCompleteService = autoCompleteService;
        this.createAccountContext = createAccountContext;
        this.analyticsService = analyticsService;
        this.helpfulTools = false;
        this.viewPossibleAlternativeDrugs = new EventEmitter();
        this.useDrugImageLink = false;
        this.isEditing = false;
        this.noTranslateBlockClass = 'no-translate-block';
        this.subscriptions = new Subscription();
        this.drugAutocompleteformatter = (drug) => drug.drugName;
        this.suggestedDrugs = (text$) => text$.pipe(this.autoCompleteService.autoComplete$(200, (drugText) => this.fetchDrugsFromAutoComplete$(drugText)));
    }
    onBeforeUnload() {
        // save drug list if tab is closed but do not show default prompt if navigating to BB
        // must use session storage.
        if (sessionStorage.getItem('isNavigating') === 'true') {
            sessionStorage.removeItem('isNavigating');
            return undefined;
        }
        this.drugsService.saveDrugList();
        return false;
    }
    ngAfterViewInit() {
        if (this.drugSearchInput) {
            this.renderer.removeAttribute(this.drugSearchInput.nativeElement, 'aria-multiline');
        }
    }
    ngOnInit() {
        // Subscribe to event broadcasts for edit drug dosage events.
        // The drugId from the event queue is the dosage to edit.
        this.subscriptions.add(this.cabinet$.subscribe(cabinet => {
            this.drugCabinet = cabinet;
            if (cabinet?.length) {
                this.createAccountContext.displayCreateAccountNudge();
            }
            else {
                this.createAccountContext.hideCreateAccountNudge();
            }
            this.updateDrugCountAnalytics(cabinet?.length);
            this.cdr.detectChanges();
        }));
        this.subscriptions.add(this.drugsService.editEvent$.subscribe(drugId => {
            this.isEditing = true;
            // A deep clone is necessary because we are making modifications to a store object and keeping those changes
            // in memory in this component until the user aborts or applies those changes in later actions.
            const cabinetEntry = _cloneDeep(this.drugCabinet.find(i => i.dosageID === drugId));
            this.dosageToEdit = cabinetEntry.dosageID;
            if (cabinetEntry) {
                this.activeGenericOption = false;
                this.drugDetails = cabinetEntry.drugDetails;
                this.drugName = cabinetEntry.drugDetails.drugName;
                this.dosages = cabinetEntry.drugDetails.dosages;
                this.defaultFrequency = this.frequencyList.find(frequencyItem => cabinetEntry.dosage.daysOfSupply <= frequencyItem.value);
                if (cabinetEntry.isGenericAlternative) {
                    if (cabinetEntry.drugDetails.genericDrug) {
                        this.drugDetails = cabinetEntry.drugDetails.genericDrug;
                        this.drugName = cabinetEntry.drugDetails.genericDrug.drugName;
                        this.dosages = cabinetEntry.drugDetails.genericDrug.dosages;
                    }
                }
                this.drugDetails.commonDosage = { ...cabinetEntry.dosage };
            }
            else {
                this.drugDetails = null;
            }
            this.isQuantityValid = true;
            this.cdr.detectChanges();
        }));
        this.deactivationService.addDeactivationGuard({
            canDeactivate: this.saveDrugList.bind(this)
        });
    }
    ngOnChanges(changes) {
        const { frequencyList } = changes;
        if (!!frequencyList && !_isEqual(frequencyList.previousValue, frequencyList.currentValue)) {
            this.updateDefaultFrequency(this.frequencyList);
        }
    }
    ngOnDestroy() {
        this.createAccountContext.hideCreateAccountNudge();
        this.subscriptions.unsubscribe();
    }
    async saveDrugList() {
        this.drugsService.saveDrugList();
        return await Promise.resolve(true);
    }
    updateDrugCountAnalytics(drugCount) {
        if (this.analyticsService.googleDataLayerTags[DataLayerGlobalVariable.DRUG_COUNT] !== `${drugCount || 0}`) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.DRUG_COUNT, `${drugCount || 0}`);
        }
    }
    fetchDrugsFromAutoComplete$(drugText) {
        if (drugText.length < 2) {
            return of([]);
        }
        return this.drugsService.fetchDrugs$(drugText, true, 10);
    }
    selectItem(event) {
        const selectedDrug = event.item;
        this.dosageToEdit = null;
        this.isEditing = false;
        this.drugDetails = null;
        // hiding prior drug footnotes if entering new drug search is in flight
        this.helpfulToolsContext.hideFormularyAndFootnotes();
        this.cdr.detectChanges();
        if (selectedDrug?.drugID) {
            this.drugsService.fetchDrugDetails(selectedDrug.drugID).then(data => {
                if (data) {
                    // A deep clone is necessary because we need to make modification on cache object on deeply nested properties.
                    // When we get data from cache object it return as a reference and doesnt allow us to change nested properties of object,
                    // so cloning that object as a new object would help us to change properties we want.
                    this.drugDetails = _cloneDeep(data);
                    this.isQuantityValid = true;
                    if (data.hasGenericDrug && this.showGenericOption) {
                        this.genericEquivalentQuestion = this.genericOptionQuestion
                            .replace('<genericDrugName>', `<span class='no-translate-block'>${data.genericDrug.drugName}</span>`)
                            .replace('<brandName>', `<span class='no-translate-block'>${data.drugName}</span>`);
                        this.activeGenericOption = this.genericOptionDefaultSelection;
                    }
                    else {
                        this.activeGenericOption = false;
                    }
                    this.clearSearchTerm();
                    this.drugName = this.drugDetails.drugName;
                    this.dosages = this.drugDetails.dosages;
                    this.defaultFrequency = this.getDefaultFrequency();
                    this.drugDetails.commonDosage.daysOfSupply = this.defaultFrequency.value;
                    if (this.helpfulTools) {
                        this.updateAndShowDrugFormularyAndFootnotes();
                    }
                    this.cdr.detectChanges();
                }
            });
        }
    }
    updateActiveGenericOption(option) {
        this.activeGenericOption = option;
        this.cdr.detectChanges();
    }
    updateIsQuantityValid(isValid) {
        this.isQuantityValid = isValid;
    }
    updateFrequency(frequency) {
        this.defaultFrequency = frequency;
    }
    clearSearchTerm() {
        this.searchTerm = '';
    }
    scrollItemIntoView() {
        this.autoCompleteService.scrollItemIntoView(this.typeahead);
        this.cdr.detectChanges();
    }
    getDefaultFrequency() {
        const commonFrequency = this.drugDetails.commonDosage.daysOfSupply;
        const emptyFrequency = {
            label: '',
            value: this.drugDetails.commonDosage.daysOfSupply
        };
        const frequency = this.frequencyList.some(frequencyItem => commonFrequency <= frequencyItem.value)
            ? this.frequencyList.find(frequencyItem => commonFrequency <= frequencyItem.value)
            : emptyFrequency;
        return frequency;
    }
    removeSelectedDrug() {
        if (this.helpfulTools) {
            this.helpfulToolsContext.hideFormularyAndFootnotes();
        }
        this.drugDetails = null;
        if (this.drugSearchInput) {
            this.drugSearchInput.nativeElement.focus();
        }
        this.cdr.detectChanges();
    }
    onViewPossibleAlternativeDrugs(drugWithPlan) {
        this.viewPossibleAlternativeDrugs.emit(drugWithPlan);
        this.scrollToTop();
        this.cdr.markForCheck();
    }
    updateDefaultFrequency(updatedList) {
        const updatedFrequency = updatedList?.find((frequency) => frequency.value === this.defaultFrequency?.value);
        if (updatedFrequency) {
            this.defaultFrequency = updatedFrequency;
        }
    }
    scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    createCabinetEntry() {
        return this.drugsService.createCabinetEntry(this.drugDetails.commonDosage, this.drugDetails.drugID, this.drugDetails, false);
    }
    async updateAndShowDrugFormularyAndFootnotes() {
        // create cabinet entry from default dosage selection, used to invoke plan service.
        const cabinetEntry = this.createCabinetEntry();
        // await the return of plan service call with formulary status information (formulary, footnote ids).
        await this.helpfulToolsService.getPlanDetails([cabinetEntry]);
        this.showFormularyAndFootnotesSection();
    }
    showFormularyAndFootnotesSection() {
        // set the dosage selected in context (dosage id), this is default common dosage.
        this.helpfulToolsContext.setSelectedDrugDosageId(this.drugDetails.commonDosage.dosageId);
        this.helpfulToolsContext.showFormularyAndFootnotes();
    }
}
DrugSearchComponent.ɵfac = function DrugSearchComponent_Factory(t) { return new (t || DrugSearchComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.DrugsService), i0.ɵɵdirectiveInject(HelpfulToolsService), i0.ɵɵdirectiveInject(HelpfulToolsContextService), i0.ɵɵdirectiveInject(i1.DeactivationGuardService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1.AutoCompleteService), i0.ɵɵdirectiveInject(CreateAccountContext), i0.ɵɵdirectiveInject(AnalyticsService)); };
DrugSearchComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DrugSearchComponent, selectors: [["vnext-widget-drug-search"]], viewQuery: function DrugSearchComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$2d, 5);
        i0.ɵɵviewQuery(_c1$12, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.typeahead = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.drugSearchInput = _t.first);
    } }, hostBindings: function DrugSearchComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("beforeunload", function DrugSearchComponent_beforeunload_HostBindingHandler() { return ctx.onBeforeUnload(); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { helpfulTools: "helpfulTools", helpfulToolsPlan: "helpfulToolsPlan", frequencyList: "frequencyList", contentSectionText: "contentSectionText", dosageHeader: "dosageHeader", quantityAndFrequencyHeader: "quantityAndFrequencyHeader", packageHeader: "packageHeader", addButtonText: "addButtonText", cancelButtonText: "cancelButtonText", quantityMaxLimit: "quantityMaxLimit", medicineCabinetLimit: "medicineCabinetLimit", cabinetLimitErrorMessage: "cabinetLimitErrorMessage", quantityErrorMessage: "quantityErrorMessage", placeholder: "placeholder", drugSearchText: "drugSearchText", drugsImage: "drugsImage", inCabinetErrorMessage: "inCabinetErrorMessage", medCabinetHeader: "medCabinetHeader", genericOptionIcon: "genericOptionIcon", showGenericOption: "showGenericOption", genericOptionQuestion: "genericOptionQuestion", genericOptionInfo: "genericOptionInfo", genericOptions: "genericOptions", checkDrugCoverageButtonText: "checkDrugCoverageButtonText", genericOptionDefaultSelection: "genericOptionDefaultSelection", showCosts: "showCosts", drugSearchIntroText: "drugSearchIntroText", drugSearchPageHeaderText: "drugSearchPageHeaderText", errorKeywordText: "errorKeywordText", drugSearchFrequencyListBoxLabel: "drugSearchFrequencyListBoxLabel", nonCoveredPrescriptions: "nonCoveredPrescriptions", coveredPrescriptions: "coveredPrescriptions", noPrescriptionInTier: "noPrescriptionInTier", prescriptionsText: "prescriptionsText", blueButtonStartAddingDrugText: "blueButtonStartAddingDrugText", orText: "orText", blueButtonConnectToMyMedicareText: "blueButtonConnectToMyMedicareText", blueButtonMyMedicareButtonText: "blueButtonMyMedicareButtonText", isBlueButtonEnabled: "isBlueButtonEnabled", emailLabelText: "emailLabelText", emailRequiredErrorText: "emailRequiredErrorText", emailInvalidErrorText: "emailInvalidErrorText", sendEmailButtonText: "sendEmailButtonText", blueButtonModalHeaderText: "blueButtonModalHeaderText", blueButtonModalContent: "blueButtonModalContent", blueButtonSuccessText: "blueButtonSuccessText", blueButtonDownloadText: "blueButtonDownloadText", blueButtonSuccessMessage: "blueButtonSuccessMessage", blueButtonEmailSendText: "blueButtonEmailSendText", blueButtonIssueLoadingText: "blueButtonIssueLoadingText", blueButtonBeneficiaryDeniedText: "blueButtonBeneficiaryDeniedText", blueButtonErrorLoadingText: "blueButtonErrorLoadingText", blueButtonBeneficiaryEmailDetails: "blueButtonBeneficiaryEmailDetails", blueButtonImportLatestPrescriptionButtonText: "blueButtonImportLatestPrescriptionButtonText", blueButtonImportLatestPrescriptionErrorText: "blueButtonImportLatestPrescriptionErrorText", blueButtonAccessDeniedText: "blueButtonAccessDeniedText", blueButtonClaimDataLoadingErrorText: "blueButtonClaimDataLoadingErrorText", isMemberSessionUpdated: "isMemberSessionUpdated", editDrugText: "editDrugText", isUseCMSDrugFlagEnabled: "isUseCMSDrugFlagEnabled", showDrugAlternativesEnabled: "showDrugAlternativesEnabled", helpfulToolsShowDrugAlternativesNudgeEnabled: "helpfulToolsShowDrugAlternativesNudgeEnabled", prescriptionsDrugAlternativesButtonText: "prescriptionsDrugAlternativesButtonText", cabinetForAlternatives: "cabinetForAlternatives", selectedPlanPharmacy: "selectedPlanPharmacy", isMobile: "isMobile" }, outputs: { viewPossibleAlternativeDrugs: "viewPossibleAlternativeDrugs" }, features: [i0.ɵɵNgOnChangesFeature], decls: 14, vars: 5, consts: [[1, "p-3"], ["aria-relevant", "text", 1, "row"], ["id", "drugsearch", "class", "col-12", 4, "ngIf"], [1, "inner-addon", "search-wrapper", "col-md-8", "col-12", "p-0", "drug-search-list"], ["aria-hidden", "true", 1, "fas", "fa-search"], ["drug", ""], ["type", "text", "class", "form-control drug-search-input", "placement", "bottom-left", 3, "placeholder", "ngbTypeahead", "resultTemplate", "inputFormatter", "popupClass", "ngModel", "ngModelChange", "selectItem", "click", "keyup", 4, "liveEditProp"], [1, "col-12", "p-0"], [1, "col-12"], [4, "ngIf"], [3, "medCabinetHeader", "showGenericOption", 4, "ngIf"], [3, "startAddingDrugText", "orText", "connectToMyMedicareText", "myMedicareButtonText", "emailLabelText", "emailRequiredErrorText", "emailInvalidErrorText", "sendEmailButtonText", "blueButtonModalHeaderText", "blueButtonModalContent", "blueButtonSuccessText", "blueButtonDownloadText", "blueButtonSuccessMessage", "blueButtonEmailSendText", "blueButtonIssueLoadingText", "blueButtonBeneficiaryDeniedText", "blueButtonErrorLoadingText", "blueButtonBeneficiaryEmailDetails", "blueButtonImportLatestPrescriptionButtonText", "blueButtonImportLatestPrescriptionErrorText", "blueButtonAccessDeniedText", "blueButtonClaimDataLoadingErrorText", 4, "ngIf"], ["id", "drugsearch", 1, "col-12"], [1, "text-center"], ["aria-hidden", "true", 1, "fas", "Spa_Style_PrescriptionsIcon", "prescription-drug-icon", "pl-2", "pl-md-0"], ["class", "Spa_Style_H1", 4, "liveEditProp"], ["class", "Spa_Style_IntroParagraph", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [1, "Spa_Style_H1"], ["navigationAdapter", "", 1, "Spa_Style_IntroParagraph", 3, "innerHtml"], ["for", "drugSearch", "id", "drugSearchLabel", "aria-live", "off", 1, "sr-only"], [1, "Spa_Style_H5", 3, "result", "term"], ["type", "text", "placement", "bottom-left", 1, "form-control", "drug-search-input", 3, "placeholder", "ngbTypeahead", "resultTemplate", "inputFormatter", "popupClass", "ngModel", "ngModelChange", "selectItem", "click", "keyup"], ["drugSearchInput", "", "typeahead", "ngbTypeahead"], [3, "isEditing", "drugName", "drugDetails", "selectedDosage", "frequencyList", "quantityAndFrequencyHeader", "dosageHeader", "packageHeader", "contentSectionText", "addButtonText", "cancelButtonText", "quantityMaxLimit", "quantityErrorMessage", "genericOptionIcon", "showGenericOption", "genericOptionInfo", "genericOptions", "activeGenericOption", "genericEquivalentQuestion", "isQuantityValid", "defaultFrequency", "dosages", "dosageToEdit", "hasGenericDrug", "medicineCabinetLimit", "cabinetLimitErrorMessage", "inCabinetErrorMessage", "helpfulTools", "helpfulToolsPlan", "checkDrugCoverageButtonText", "showCosts", "errorKeywordText", "drugSearchFrequencyListBoxLabel", "nonCoveredPrescriptions", "coveredPrescriptions", "noPrescriptionInTier", "editDrugText", "isUseCMSDrugFlagEnabled", "showDrugAlternativesEnabled", "helpfulToolsShowDrugAlternativesNudgeEnabled", "cabinetForAlternatives", "selectedPlanPharmacy", "prescriptionsDrugAlternativesButtonText", "isMobile", "updateFrequency", "updateIsQuantityValid", "updateActiveGenericOption", "removeSelectedDrug", "viewPossibleAlternativeDrugs", 4, "ngIf"], [3, "isEditing", "drugName", "drugDetails", "selectedDosage", "frequencyList", "quantityAndFrequencyHeader", "dosageHeader", "packageHeader", "contentSectionText", "addButtonText", "cancelButtonText", "quantityMaxLimit", "quantityErrorMessage", "genericOptionIcon", "showGenericOption", "genericOptionInfo", "genericOptions", "activeGenericOption", "genericEquivalentQuestion", "isQuantityValid", "defaultFrequency", "dosages", "dosageToEdit", "hasGenericDrug", "medicineCabinetLimit", "cabinetLimitErrorMessage", "inCabinetErrorMessage", "helpfulTools", "helpfulToolsPlan", "checkDrugCoverageButtonText", "showCosts", "errorKeywordText", "drugSearchFrequencyListBoxLabel", "nonCoveredPrescriptions", "coveredPrescriptions", "noPrescriptionInTier", "editDrugText", "isUseCMSDrugFlagEnabled", "showDrugAlternativesEnabled", "helpfulToolsShowDrugAlternativesNudgeEnabled", "cabinetForAlternatives", "selectedPlanPharmacy", "prescriptionsDrugAlternativesButtonText", "isMobile", "updateFrequency", "updateIsQuantityValid", "updateActiveGenericOption", "removeSelectedDrug", "viewPossibleAlternativeDrugs"], [3, "medCabinetHeader", "showGenericOption"], [3, "startAddingDrugText", "orText", "connectToMyMedicareText", "myMedicareButtonText", "emailLabelText", "emailRequiredErrorText", "emailInvalidErrorText", "sendEmailButtonText", "blueButtonModalHeaderText", "blueButtonModalContent", "blueButtonSuccessText", "blueButtonDownloadText", "blueButtonSuccessMessage", "blueButtonEmailSendText", "blueButtonIssueLoadingText", "blueButtonBeneficiaryDeniedText", "blueButtonErrorLoadingText", "blueButtonBeneficiaryEmailDetails", "blueButtonImportLatestPrescriptionButtonText", "blueButtonImportLatestPrescriptionErrorText", "blueButtonAccessDeniedText", "blueButtonClaimDataLoadingErrorText"]], template: function DrugSearchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, DrugSearchComponent_div_2_Template, 5, 2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelement(4, "i", 4);
        i0.ɵɵtemplate(5, DrugSearchComponent_ng_template_5_Template, 3, 3, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(7, DrugSearchComponent_input_7_Template, 3, 7, "input", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵelement(9, "vnext-selectrx-section");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 8);
        i0.ɵɵtemplate(11, DrugSearchComponent_ng_container_11_Template, 2, 1, "ng-container", 9);
        i0.ɵɵtemplate(12, DrugSearchComponent_vnext_medicine_cabinet_12_Template, 1, 2, "vnext-medicine-cabinet", 10);
        i0.ɵɵtemplate(13, DrugSearchComponent_vnext_blue_button_13_Template, 1, 22, "vnext-blue-button", 11);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.helpfulTools);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("liveEditProp", "Spa_DrugSearch_Hint_Text");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.drugDetails);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.helpfulTools && (!ctx.isBlueButtonEnabled || ctx.isMemberSessionUpdated));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.helpfulTools && ctx.isBlueButtonEnabled && ctx.isMemberSessionUpdated);
    } }, dependencies: [i1$2.NgIf, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, NavigationAdapterDirective, LiveEditPropDirective, IconAriaAttributesDirective, i1$1.NgbTypeahead, i1$1.NgbHighlight, DrugDetailsComponent, MedicineCabinetComponent, BlueButtonComponent, SelectRXSectionComponent, SafePipe], styles: [".search-wrapper[_ngcontent-%COMP%]{margin:0 auto 15px;position:relative}.search-wrapper.inner-addon[_ngcontent-%COMP%]   .fas[_ngcontent-%COMP%]{position:absolute;padding:8px 10px;pointer-events:none;right:0;top:3px;font-size:16px}.details-content[_ngcontent-%COMP%]   .search-wrapper.inner-addon[_ngcontent-%COMP%]   .fas[_ngcontent-%COMP%]{top:25px}.search-wrapper.inner-addon[_ngcontent-%COMP%]   .address[_ngcontent-%COMP%]   span.fas[_ngcontent-%COMP%]{top:0}.drug-search-input[_ngcontent-%COMP%]{width:100%;padding-right:30px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.drug-search-input[_ngcontent-%COMP%]::-ms-clear{display:none}.prescription-drug-icon[_ngcontent-%COMP%]{font-size:46px}"], changeDetection: 0 });
__decorate([
    Select(MedicineCabinetState.medicineCabinet)
], DrugSearchComponent.prototype, "cabinet$", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugSearchComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-drug-search', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"p-3\">\r\n  <div class=\"row\" aria-relevant=\"text\">\r\n    <div id=\"drugsearch\" class=\"col-12\" *ngIf=\"!helpfulTools\">\r\n      <div class=\"text-center\">\r\n        <i class=\"fas Spa_Style_PrescriptionsIcon prescription-drug-icon pl-2 pl-md-0\" aria-hidden=\"true\"></i>\r\n        <h1 class=\"Spa_Style_H1\" *liveEditProp=\"'Spa_Site_Prescriptions_Text'\">{{ prescriptionsText }}</h1>\r\n        <p\r\n          class=\"Spa_Style_IntroParagraph\"\r\n          *liveEditProp=\"'Spa_DrugSearch_Intro_Text'\"\r\n          [innerHtml]=\"drugSearchIntroText | safe : 'html'\"\r\n          navigationAdapter\r\n        ></p>\r\n      </div>\r\n    </div>\r\n    <div class=\"inner-addon search-wrapper col-md-8 col-12 p-0 drug-search-list\">\r\n      <i class=\"fas fa-search\" aria-hidden=\"true\"></i>\r\n      <ng-template #drug let-r=\"result\" let-t=\"term\">\r\n        <label class=\"sr-only\" for=\"drugSearch\" id=\"drugSearchLabel\" aria-live=\"off\">{{ drugSearchText }}</label>\r\n        <ngb-highlight class=\"Spa_Style_H5\" [result]=\"r.drugName\" [term]=\"t\"></ngb-highlight>\r\n      </ng-template>\r\n      <input\r\n        #drugSearchInput\r\n        #typeahead=\"ngbTypeahead\"\r\n        *liveEditProp=\"'Spa_DrugSearch_Hint_Text'\"\r\n        type=\"text\"\r\n        class=\"form-control drug-search-input\"\r\n        placement=\"bottom-left\"\r\n        [attr.aria-label]=\"drugSearchPageHeaderText\"\r\n        [placeholder]=\"placeholder\"\r\n        [ngbTypeahead]=\"suggestedDrugs\"\r\n        [resultTemplate]=\"drug\"\r\n        [inputFormatter]=\"drugAutocompleteformatter\"\r\n        [popupClass]=\"noTranslateBlockClass\"\r\n        [(ngModel)]=\"searchTerm\"\r\n        (selectItem)=\"selectItem($event)\"\r\n        (click)=\"clearSearchTerm()\"\r\n        (keyup)=\"scrollItemIntoView()\"\r\n      />\r\n    </div>\r\n\r\n    <div class=\"col-12 p-0\">\r\n      <vnext-selectrx-section></vnext-selectrx-section>\r\n    </div>\r\n\r\n    <div class=\"col-12\">\r\n      <ng-container *ngIf=\"drugDetails\">\r\n        <vnext-drug-details\r\n          *ngIf=\"drugDetails\"\r\n          [isEditing]=\"isEditing\"\r\n          [drugName]=\"drugName\"\r\n          [drugDetails]=\"drugDetails\"\r\n          [selectedDosage]=\"drugDetails.commonDosage\"\r\n          [frequencyList]=\"frequencyList\"\r\n          [quantityAndFrequencyHeader]=\"quantityAndFrequencyHeader\"\r\n          [dosageHeader]=\"dosageHeader\"\r\n          [packageHeader]=\"packageHeader\"\r\n          [contentSectionText]=\"contentSectionText\"\r\n          [addButtonText]=\"addButtonText\"\r\n          [cancelButtonText]=\"cancelButtonText\"\r\n          [quantityMaxLimit]=\"quantityMaxLimit\"\r\n          [quantityErrorMessage]=\"quantityErrorMessage\"\r\n          [genericOptionIcon]=\"genericOptionIcon\"\r\n          [showGenericOption]=\"showGenericOption\"\r\n          [genericOptionInfo]=\"genericOptionInfo\"\r\n          [genericOptions]=\"genericOptions\"\r\n          [activeGenericOption]=\"activeGenericOption\"\r\n          [genericEquivalentQuestion]=\"genericEquivalentQuestion\"\r\n          [isQuantityValid]=\"isQuantityValid\"\r\n          [defaultFrequency]=\"defaultFrequency\"\r\n          [dosages]=\"dosages\"\r\n          [dosageToEdit]=\"dosageToEdit\"\r\n          [hasGenericDrug]=\"drugDetails.hasGenericDrug\"\r\n          [medicineCabinetLimit]=\"medicineCabinetLimit\"\r\n          [cabinetLimitErrorMessage]=\"cabinetLimitErrorMessage\"\r\n          [inCabinetErrorMessage]=\"inCabinetErrorMessage\"\r\n          [helpfulTools]=\"helpfulTools\"\r\n          [helpfulToolsPlan]=\"helpfulToolsPlan\"\r\n          [checkDrugCoverageButtonText]=\"checkDrugCoverageButtonText\"\r\n          [showCosts]=\"!showCosts\"\r\n          (updateFrequency)=\"updateFrequency($event)\"\r\n          (updateIsQuantityValid)=\"updateIsQuantityValid($event)\"\r\n          (updateActiveGenericOption)=\"updateActiveGenericOption($event)\"\r\n          (removeSelectedDrug)=\"removeSelectedDrug()\"\r\n          [errorKeywordText]=\"errorKeywordText\"\r\n          [drugSearchFrequencyListBoxLabel]=\"drugSearchFrequencyListBoxLabel\"\r\n          [nonCoveredPrescriptions]=\"nonCoveredPrescriptions\"\r\n          [coveredPrescriptions]=\"coveredPrescriptions\"\r\n          [noPrescriptionInTier]=\"noPrescriptionInTier\"\r\n          [editDrugText]=\"editDrugText\"\r\n          [isUseCMSDrugFlagEnabled]=\"isUseCMSDrugFlagEnabled\"\r\n          [showDrugAlternativesEnabled]=\"showDrugAlternativesEnabled\"\r\n          [helpfulToolsShowDrugAlternativesNudgeEnabled]=\"helpfulToolsShowDrugAlternativesNudgeEnabled\"\r\n          [cabinetForAlternatives]=\"cabinetForAlternatives\"\r\n          [selectedPlanPharmacy]=\"selectedPlanPharmacy\"\r\n          [prescriptionsDrugAlternativesButtonText]=\"prescriptionsDrugAlternativesButtonText\"\r\n          [isMobile]=\"isMobile\"\r\n          (viewPossibleAlternativeDrugs)=\"onViewPossibleAlternativeDrugs($event)\"\r\n        >\r\n        </vnext-drug-details>\r\n      </ng-container>\r\n      <vnext-medicine-cabinet\r\n        *ngIf=\"!helpfulTools && (!isBlueButtonEnabled || isMemberSessionUpdated)\"\r\n        [medCabinetHeader]=\"medCabinetHeader\"\r\n        [showGenericOption]=\"showGenericOption\"\r\n      ></vnext-medicine-cabinet>\r\n      <vnext-blue-button\r\n        *ngIf=\"!helpfulTools && isBlueButtonEnabled && isMemberSessionUpdated\"\r\n        [startAddingDrugText]=\"blueButtonStartAddingDrugText\"\r\n        [orText]=\"orText\"\r\n        [connectToMyMedicareText]=\"blueButtonConnectToMyMedicareText\"\r\n        [myMedicareButtonText]=\"blueButtonMyMedicareButtonText\"\r\n        [emailLabelText]=\"emailLabelText\"\r\n        [emailRequiredErrorText]=\"emailRequiredErrorText\"\r\n        [emailInvalidErrorText]=\"emailInvalidErrorText\"\r\n        [sendEmailButtonText]=\"sendEmailButtonText\"\r\n        [blueButtonModalHeaderText]=\"blueButtonModalHeaderText\"\r\n        [blueButtonModalContent]=\"blueButtonModalContent\"\r\n        [blueButtonSuccessText]=\"blueButtonSuccessText\"\r\n        [blueButtonDownloadText]=\"blueButtonDownloadText\"\r\n        [blueButtonSuccessMessage]=\"blueButtonSuccessMessage\"\r\n        [blueButtonEmailSendText]=\"blueButtonEmailSendText\"\r\n        [blueButtonIssueLoadingText]=\"blueButtonIssueLoadingText\"\r\n        [blueButtonBeneficiaryDeniedText]=\"blueButtonBeneficiaryDeniedText\"\r\n        [blueButtonErrorLoadingText]=\"blueButtonErrorLoadingText\"\r\n        [blueButtonBeneficiaryEmailDetails]=\"blueButtonBeneficiaryEmailDetails\"\r\n        [blueButtonImportLatestPrescriptionButtonText]=\"blueButtonImportLatestPrescriptionButtonText\"\r\n        [blueButtonImportLatestPrescriptionErrorText]=\"blueButtonImportLatestPrescriptionErrorText\"\r\n        [blueButtonAccessDeniedText]=\"blueButtonAccessDeniedText\"\r\n        [blueButtonClaimDataLoadingErrorText]=\"blueButtonClaimDataLoadingErrorText\"\r\n      ></vnext-blue-button>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".search-wrapper{margin:0 auto 15px;position:relative}.search-wrapper.inner-addon .fas{position:absolute;padding:8px 10px;pointer-events:none;right:0;top:3px;font-size:16px}.details-content .search-wrapper.inner-addon .fas{top:25px}.search-wrapper.inner-addon .address span.fas{top:0}.drug-search-input{width:100%;padding-right:30px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.drug-search-input::-ms-clear{display:none}.prescription-drug-icon{font-size:46px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.DrugsService }, { type: HelpfulToolsService }, { type: HelpfulToolsContextService }, { type: i1.DeactivationGuardService }, { type: i0.Renderer2 }, { type: i1.AutoCompleteService }, { type: CreateAccountContext }, { type: AnalyticsService }]; }, { cabinet$: [], typeahead: [{
            type: ViewChild,
            args: ['typeahead']
        }], drugSearchInput: [{
            type: ViewChild,
            args: ['drugSearchInput']
        }], helpfulTools: [{
            type: Input
        }], helpfulToolsPlan: [{
            type: Input
        }], frequencyList: [{
            type: Input
        }], contentSectionText: [{
            type: Input
        }], dosageHeader: [{
            type: Input
        }], quantityAndFrequencyHeader: [{
            type: Input
        }], packageHeader: [{
            type: Input
        }], addButtonText: [{
            type: Input
        }], cancelButtonText: [{
            type: Input
        }], quantityMaxLimit: [{
            type: Input
        }], medicineCabinetLimit: [{
            type: Input
        }], cabinetLimitErrorMessage: [{
            type: Input
        }], quantityErrorMessage: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], drugSearchText: [{
            type: Input
        }], drugsImage: [{
            type: Input
        }], inCabinetErrorMessage: [{
            type: Input
        }], medCabinetHeader: [{
            type: Input
        }], genericOptionIcon: [{
            type: Input
        }], showGenericOption: [{
            type: Input
        }], genericOptionQuestion: [{
            type: Input
        }], genericOptionInfo: [{
            type: Input
        }], genericOptions: [{
            type: Input
        }], checkDrugCoverageButtonText: [{
            type: Input
        }], genericOptionDefaultSelection: [{
            type: Input
        }], showCosts: [{
            type: Input
        }], drugSearchIntroText: [{
            type: Input
        }], drugSearchPageHeaderText: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], drugSearchFrequencyListBoxLabel: [{
            type: Input
        }], nonCoveredPrescriptions: [{
            type: Input
        }], coveredPrescriptions: [{
            type: Input
        }], noPrescriptionInTier: [{
            type: Input
        }], prescriptionsText: [{
            type: Input
        }], blueButtonStartAddingDrugText: [{
            type: Input
        }], orText: [{
            type: Input
        }], blueButtonConnectToMyMedicareText: [{
            type: Input
        }], blueButtonMyMedicareButtonText: [{
            type: Input
        }], isBlueButtonEnabled: [{
            type: Input
        }], emailLabelText: [{
            type: Input
        }], emailRequiredErrorText: [{
            type: Input
        }], emailInvalidErrorText: [{
            type: Input
        }], sendEmailButtonText: [{
            type: Input
        }], blueButtonModalHeaderText: [{
            type: Input
        }], blueButtonModalContent: [{
            type: Input
        }], blueButtonSuccessText: [{
            type: Input
        }], blueButtonDownloadText: [{
            type: Input
        }], blueButtonSuccessMessage: [{
            type: Input
        }], blueButtonEmailSendText: [{
            type: Input
        }], blueButtonIssueLoadingText: [{
            type: Input
        }], blueButtonBeneficiaryDeniedText: [{
            type: Input
        }], blueButtonErrorLoadingText: [{
            type: Input
        }], blueButtonBeneficiaryEmailDetails: [{
            type: Input
        }], blueButtonImportLatestPrescriptionButtonText: [{
            type: Input
        }], blueButtonImportLatestPrescriptionErrorText: [{
            type: Input
        }], blueButtonAccessDeniedText: [{
            type: Input
        }], blueButtonClaimDataLoadingErrorText: [{
            type: Input
        }], isMemberSessionUpdated: [{
            type: Input
        }], editDrugText: [{
            type: Input
        }], isUseCMSDrugFlagEnabled: [{
            type: Input
        }], showDrugAlternativesEnabled: [{
            type: Input
        }], helpfulToolsShowDrugAlternativesNudgeEnabled: [{
            type: Input
        }], prescriptionsDrugAlternativesButtonText: [{
            type: Input
        }], cabinetForAlternatives: [{
            type: Input
        }], selectedPlanPharmacy: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], viewPossibleAlternativeDrugs: [{
            type: Output
        }], onBeforeUnload: [{
            type: HostListener,
            args: ['window:beforeunload']
        }] }); })();

function MedicineCabinetModalComponent_h2_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.medCabinetHeader);
} }
function MedicineCabinetModalComponent_vnext_drug_list_card_modal_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-drug-list-card-modal", 5);
} if (rf & 2) {
    const entry_r2 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cabinet", entry_r2)("showGenericOption", ctx_r1.showGenericOption)("showCoverageNudge", true)("pageTag", ctx_r1.pageTagsModel.GUIDED_HELP_PRESCRIPTIONS);
} }
let MedicineCabinetModalComponent = class MedicineCabinetModalComponent extends ConfigurableWidget {
    constructor() {
        super(...arguments);
        this.displayHeader = true;
        this.pageTagsModel = PageTags;
        this._visibleCabinetIndex$ = new BehaviorSubject(7);
        this.visibleCabinetIndex$ = this._visibleCabinetIndex$.asObservable();
    }
    ngOnInit() {
        super.ngOnInit();
        // Display all the dosages.  Each item in the cabinet (drug list) is a dosage.
        this.cabinetSubscription = combineLatest([this.cabinet$, this.visibleCabinetIndex$]).subscribe({
            next: ([cabinet, visibleCabinetIndex]) => {
                const sortedCabinet = [...cabinet].sort((a, b) => a.labelName.localeCompare(b.labelName));
                this.medicineCabinet = sortedCabinet;
                this.displayHeader = this.medicineCabinet.length > 0;
                this.visibleMedicineCabinet = sortedCabinet.slice(0, visibleCabinetIndex);
                this.cdr.markForCheck();
            }
        });
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        if (this.cabinetSubscription) {
            this.cabinetSubscription.unsubscribe();
        }
    }
    onScrollDown() {
        this.visibleCabinetIndex$.pipe(take(1)).subscribe({
            next: visibleCabinetIndex => {
                if (this.medicineCabinet.length > visibleCabinetIndex) {
                    this._visibleCabinetIndex$.next(visibleCabinetIndex + 5);
                }
            }
        });
    }
    trackByDrugId(index, medicineCabinet) {
        return `${medicineCabinet.drugId}-${medicineCabinet.dosageID}`;
    }
};
MedicineCabinetModalComponent.ɵfac = /*@__PURE__*/ function () { let ɵMedicineCabinetModalComponent_BaseFactory; return function MedicineCabinetModalComponent_Factory(t) { return (ɵMedicineCabinetModalComponent_BaseFactory || (ɵMedicineCabinetModalComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MedicineCabinetModalComponent)))(t || MedicineCabinetModalComponent); }; }();
MedicineCabinetModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedicineCabinetModalComponent, selectors: [["vnext-medicine-cabinet-modal"]], inputs: { medCabinetHeader: "medCabinetHeader", showGenericOption: "showGenericOption" }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 5, consts: [[1, "row"], ["infiniteScroll", "", "aria-live", "polite", "aria-atomic", "true", 1, "col-12", "mt-4", "px-0", 3, "infiniteScrollDistance", "infiniteScrollThrottle", "scrolled"], ["class", "Spa_Style_H2", 4, "ngIf"], [3, "cabinet", "showGenericOption", "showCoverageNudge", "pageTag", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "Spa_Style_H2"], [3, "cabinet", "showGenericOption", "showCoverageNudge", "pageTag"]], template: function MedicineCabinetModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵlistener("scrolled", function MedicineCabinetModalComponent_Template_div_scrolled_1_listener() { return ctx.onScrollDown(); });
        i0.ɵɵtemplate(2, MedicineCabinetModalComponent_h2_2_Template, 2, 1, "h2", 2);
        i0.ɵɵtemplate(3, MedicineCabinetModalComponent_vnext_drug_list_card_modal_3_Template, 1, 4, "vnext-drug-list-card-modal", 3);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("infiniteScrollDistance", 3)("infiniteScrollThrottle", 50);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.displayHeader);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.visibleMedicineCabinet)("ngForTrackBy", ctx.trackByDrugId);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, i2$2.InfiniteScrollDirective, DrugListCardModalComponent], encapsulation: 2, changeDetection: 0 });
__decorate([
    Select(MedicineCabinetState.medicineCabinet)
], MedicineCabinetModalComponent.prototype, "cabinet$", void 0);
MedicineCabinetModalComponent = __decorate([
    PlatformWidget
], MedicineCabinetModalComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedicineCabinetModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-medicine-cabinet-modal', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"row\">\r\n  <div\r\n    class=\"col-12 mt-4 px-0\"\r\n    infiniteScroll\r\n    [infiniteScrollDistance]=\"3\"\r\n    [infiniteScrollThrottle]=\"50\"\r\n    (scrolled)=\"onScrollDown()\"\r\n    aria-live=\"polite\"\r\n    aria-atomic=\"true\"\r\n  >\r\n    <h2 class=\"Spa_Style_H2\" *ngIf=\"displayHeader\">{{ medCabinetHeader }}</h2>\r\n    <!--For each drug, as listed in store-->\r\n    <vnext-drug-list-card-modal\r\n      *ngFor=\"let entry of visibleMedicineCabinet; trackBy: trackByDrugId\"\r\n      [cabinet]=\"entry\"\r\n      [showGenericOption]=\"showGenericOption\"\r\n      [showCoverageNudge]=\"true\"\r\n      [pageTag]=\"pageTagsModel.GUIDED_HELP_PRESCRIPTIONS\"\r\n    >\r\n    </vnext-drug-list-card-modal>\r\n  </div>\r\n</div>\r\n" }]
    }], null, { cabinet$: [], medCabinetHeader: [{
            type: Input
        }], showGenericOption: [{
            type: Input
        }] }); })();

function SharePrescriptionListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "i", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const drug_r1 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", drug_r1.labelName, "\n");
} }
class SharePrescriptionListComponent {
}
SharePrescriptionListComponent.ɵfac = function SharePrescriptionListComponent_Factory(t) { return new (t || SharePrescriptionListComponent)(); };
SharePrescriptionListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SharePrescriptionListComponent, selectors: [["vnext-share-prescription-list"]], inputs: { dosage: "dosage" }, decls: 1, vars: 1, consts: [["class", "col-sm-12 pt-2 Spa_Style_Large_Font", 4, "ngFor", "ngForOf"], [1, "col-sm-12", "pt-2", "Spa_Style_Large_Font"], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "mr-2", "blue-button-label"]], template: function SharePrescriptionListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SharePrescriptionListComponent_div_0_Template, 3, 1, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.dosage);
    } }, dependencies: [i1$2.NgForOf, IconAriaAttributesDirective], styles: [".blue-button-label[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SharePrescriptionListComponent, [{
        type: Component,
        args: [{ selector: 'vnext-share-prescription-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngFor=\"let drug of dosage\" class=\"col-sm-12 pt-2 Spa_Style_Large_Font\">\r\n  <i class=\"fas fa-check-circle mr-2 blue-button-label\" aria-hidden=\"true\"></i> {{ drug.labelName }}\r\n</div>\r\n", styles: [".blue-button-label{color:var(--static-Spa_Style_Cost_Text)}\n"] }]
    }], null, { dosage: [{
            type: Input
        }] }); })();

function SharePrescriptionComponent_div_1_h1_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.Spa_SharePrescription_HeaderText, " ");
} }
const _c0$2c = function (a0) { return { "pt-3": a0 }; };
function SharePrescriptionComponent_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 10);
    i0.ɵɵelement(4, "vnext-spinner", 11);
    i0.ɵɵelementStart(5, "p", 12);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.Spa_SharePrescription_LoadingDescription_Text, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r2.Spa_Site_Loader_Updated_Icon_Enabled ? "flex-column" : "flex-column-reverse");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("size", ctx_r2.spinnerSizeSmall);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0$2c, ctx_r2.Spa_Site_Loader_Updated_Icon_Enabled));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.Spa_SharePrescription_LoadingText, " ");
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_container_0_vnext_notice_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice", 21);
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("type", "warn")("messages", ctx_r9.beneficiaryErrorNotification)("warningCustomClass", "mb-0");
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_container_0_vnext_notice_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice", 21);
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("type", "warn")("messages", ctx_r10.beneficiaryDeniedNotification)("warningCustomClass", "mb-0");
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_container_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵelement(2, "div", 23);
    i0.ɵɵpipe(3, "safe");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(3, 1, ctx_r11.contactText, "html"), i0.ɵɵsanitizeHtml);
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_container_0_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelement(1, "div", 23);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 1, ctx_r13.Spa_SharePrescription_Error_BeneficiaryContact_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵtemplate(2, SharePrescriptionComponent_div_1_ng_template_5_ng_container_0_vnext_notice_2_Template, 1, 3, "vnext-notice", 16);
    i0.ɵɵtemplate(3, SharePrescriptionComponent_div_1_ng_template_5_ng_container_0_vnext_notice_3_Template, 1, 3, "vnext-notice", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 2)(5, "div", 3)(6, "div", 17);
    i0.ɵɵtemplate(7, SharePrescriptionComponent_div_1_ng_template_5_ng_container_0_ng_container_7_Template, 4, 4, "ng-container", 6);
    i0.ɵɵtemplate(8, SharePrescriptionComponent_div_1_ng_template_5_ng_container_0_ng_template_8_Template, 3, 4, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 19);
    i0.ɵɵelement(11, "img", 20);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r12 = i0.ɵɵreference(9);
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.blueButtonFetchPrescriptionError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.deniedAccess);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r5.sharePrescriptionFacade.isAgentLoggedIn())("ngIfElse", _r12);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("src", ctx_r5.Spa_SharePrescription_Tile_Image, i0.ɵɵsanitizeUrl)("alt", ctx_r5.Spa_Site_PrescriptionLogo_Alternate_text);
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_vnext_notice_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice", 33);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("type", "success")("messages", i0.ɵɵpipeBind1(1, 2, ctx_r16.blueButtonFacade.isAgentImportData$) ? ctx_r16.successfulImportNotification : ctx_r16.successNotification);
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_vnext_notice_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice", 33);
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("type", "success")("messages", ctx_r17.successWithNoPrescriptionNotification);
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_container_4_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 36);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(7);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r26.Spa_SharePrescription_ContinueReview_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_container_4_ng_container_1_div_1_Template, 2, 4, "div", 35);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_SharePrescription_ContinueReview_Text");
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_container_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 36);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r25.Spa_SharePrescription_NoClaimData_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_container_4_ng_container_1_Template, 2, 1, "ng-container", 6);
    i0.ɵɵtemplate(2, SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_container_4_ng_template_2_Template, 2, 4, "ng-template", null, 34, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r24 = i0.ɵɵreference(3);
    const blueButtonCabinet_r15 = i0.ɵɵnextContext().ngIf;
    const ctx_r18 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (blueButtonCabinet_r15 == null ? null : blueButtonCabinet_r15.length) !== 0 || ctx_r18.isLiveEdit)("ngIfElse", _r24);
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_container_7_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 23);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(7);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r31.Spa_SharePrescription_Success_AgentContact_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_container_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵtemplate(2, SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_container_7_ng_container_1_div_2_Template, 2, 4, "div", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_SharePrescription_Success_AgentContact_Text");
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_container_7_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelement(1, "div", 23);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 1, ctx_r30.Spa_SharePrescriptions_Success_BeneficiaryDetails_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_container_7_ng_container_1_Template, 3, 1, "ng-container", 6);
    i0.ɵɵtemplate(2, SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_container_7_ng_template_2_Template, 3, 4, "ng-template", null, 37, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r29 = i0.ɵɵreference(3);
    const ctx_r19 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r19.sharePrescriptionFacade.isAgentLoggedIn())("ngIfElse", _r29);
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_container_9_h2_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h2", 40);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r32.Spa_SharePrescription_Added_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_container_9_h2_1_Template, 2, 4, "h2", 39);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_SharePrescription_Added_Text");
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h2", 40);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r22.Spa_SharePrescription_No_Prescription_Found_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵtemplate(2, SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_vnext_notice_2_Template, 2, 4, "vnext-notice", 25);
    i0.ɵɵtemplate(3, SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_vnext_notice_3_Template, 1, 2, "vnext-notice", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_container_4_Template, 4, 2, "ng-container", 14);
    i0.ɵɵelementStart(5, "div", 26)(6, "div", 27);
    i0.ɵɵtemplate(7, SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_container_7_Template, 4, 2, "ng-container", 14);
    i0.ɵɵelementStart(8, "div", 28);
    i0.ɵɵtemplate(9, SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_container_9_Template, 2, 1, "ng-container", 6);
    i0.ɵɵtemplate(10, SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_ng_template_10_Template, 2, 4, "ng-template", null, 29, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 30);
    i0.ɵɵelementContainerStart(13);
    i0.ɵɵelement(14, "vnext-share-prescription-list", 31);
    i0.ɵɵpipe(15, "async");
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 32);
    i0.ɵɵelement(17, "img", 20);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const blueButtonCabinet_r15 = ctx.ngIf;
    const _r21 = i0.ɵɵreference(11);
    const ctx_r14 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (blueButtonCabinet_r15 == null ? null : blueButtonCabinet_r15.length) || ctx_r14.isLiveEdit);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (blueButtonCabinet_r15 == null ? null : blueButtonCabinet_r15.length) === 0 && !ctx_r14.isLiveEdit);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r14.sharePrescriptionFacade.isPPCSite());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r14.sharePrescriptionFacade.isPPCSite());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (blueButtonCabinet_r15 == null ? null : blueButtonCabinet_r15.length) || ctx_r14.isLiveEdit)("ngIfElse", _r21);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("dosage", i0.ɵɵpipeBind1(15, 9, ctx_r14.blueButtonCabinet$));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("src", ctx_r14.Spa_SharePrescription_Tile_Image, i0.ɵɵsanitizeUrl)("alt", ctx_r14.Spa_Site_PrescriptionLogo_Alternate_text);
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_ng_container_0_Template, 18, 11, "ng-container", 14);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx_r7.blueButtonCabinet$));
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_container_3_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 43);
    i0.ɵɵlistener("click", function SharePrescriptionComponent_div_1_ng_template_5_ng_container_3_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r34.continueToPrescriptions()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r33.Spa_SharePrescription_ContinueButton_Text, " ");
} }
function SharePrescriptionComponent_div_1_ng_template_5_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-navigation-banner", 41);
    i0.ɵɵtemplate(2, SharePrescriptionComponent_div_1_ng_template_5_ng_container_3_button_2_Template, 2, 1, "button", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_SharePrescription_ContinueButton_Text");
} }
function SharePrescriptionComponent_div_1_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SharePrescriptionComponent_div_1_ng_template_5_ng_container_0_Template, 12, 6, "ng-container", 6);
    i0.ɵɵtemplate(1, SharePrescriptionComponent_div_1_ng_template_5_ng_template_1_Template, 2, 3, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(3, SharePrescriptionComponent_div_1_ng_template_5_ng_container_3_Template, 3, 1, "ng-container", 14);
} if (rf & 2) {
    const _r6 = i0.ɵɵreference(2);
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r4.blueButtonFetchPrescriptionError || ctx_r4.deniedAccess)("ngIfElse", _r6);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r4.sharePrescriptionFacade.isPPCSite() || ctx_r4.sharePrescriptionFacade.isAgentLoggedIn());
} }
function SharePrescriptionComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4);
    i0.ɵɵtemplate(3, SharePrescriptionComponent_div_1_h1_3_Template, 2, 1, "h1", 5);
    i0.ɵɵtemplate(4, SharePrescriptionComponent_div_1_ng_container_4_Template, 7, 7, "ng-container", 6);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, SharePrescriptionComponent_div_1_ng_template_5_Template, 4, 3, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r3 = i0.ɵɵreference(6);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", "Spa_SharePrescription_HeaderText");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.blueButtonLoading && !ctx_r0.deniedAccess && !ctx_r0.isLiveEdit)("ngIfElse", _r3);
} }
let SharePrescriptionComponent = class SharePrescriptionComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, activatedRoute, agentTaskFacade, memberSessionService, navigationService, blueButtonService, sharePrescriptionFacade, analyticsService, blueButtonFacade) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.activatedRoute = activatedRoute;
        this.agentTaskFacade = agentTaskFacade;
        this.memberSessionService = memberSessionService;
        this.navigationService = navigationService;
        this.blueButtonService = blueButtonService;
        this.sharePrescriptionFacade = sharePrescriptionFacade;
        this.analyticsService = analyticsService;
        this.blueButtonFacade = blueButtonFacade;
        this.Spa_SharePrescription_Tile_Image = 'https://contentserver.qa.destinationrx.com/ContentServer/DRxProductContent/phoenix/assets/images/prescriptions.png';
        this.Spa_SharePrescription_HeaderText = 'Sharing your prescriptions';
        this.Spa_SharePrescription_ContinueButton_Text = 'Continue to Prescriptions';
        this.Spa_SharePrescription_SuccessText = `<h4 class="Spa_Style_H4 my-0" [innerHTML]="Spa_SharePrescription_SuccessText | safe: 'html'">Prescriptions shared successfully.</h4>`;
        this.Spa_SharePrescription_UpdatedText = `<div class="Spa_Style_Small_Font" [innerHTML]="Spa_SharePrescription_UpdatedText | safe: 'html'"> Prescriptions have been added to your list.</div>`;
        this.Spa_SharePrescription_LoadingText = 'Loading prescriptions...';
        this.Spa_SharePrescription_ContinueReview_Text = `We added your prescriptions. Continue to your list to review them.`;
        this.Spa_SharePrescription_NoClaimData_Text = 'No claims data was available. if you have questions, contact Mymedicare.gov or continue to your list to enter prescriptions manually.';
        this.Spa_SharePrescription_Added_Text = `Prescriptions added`;
        this.Spa_SharePrescription_Success_AgentContact_Text = `<h2 class="Spa_Style_H2 text-left">Contact your agent if you have questions.</h2>
  <div class="Spa_Style_Label mt-4">To discuss:</div><ul class="pl-3 mt-1 Spa_Style_Gray4_Color Spa_Style_Paragraph text-left"><li class="py-1">
  Which drugs you use the most often</li><li class="py-1">Which drugs you want to be covered by your plan.</li><li class="py-1">Total
  estimated costs and best fit plan based on the drugs you are taking</li></ul>`;
        this.Spa_SharePrescription_Error_AgentContact_Text = '<h2 class="Spa_Style_H2 text-left">Contact your agent if you have questions.</h2>';
        this.Spa_SharePrescription_Error_MedicareContact_Text = '<h2 class="Spa_Style_H2">If you have questions, contact Mymedicare.gov or continue to your list to enter prescriptions manually.</h2>';
        this.Spa_SharePrescription_Error_Message = `<h4 class="Spa_Style_H4 my-0">We are unable to share prescriptions.</h4>
  <div class="Spa_Style_Small_Font Spa_Style_Primary_Color Spa_Style_Regular_Weight">There was an issue loading
  prescriptions. Please try again later.</div>`;
        this.Spa_SharePrescription_Denied_Message = `<h4 class="Spa_Style_H4 my-0">Access denied. We
  are unable to load prescriptions.</h4><div class="Spa_Style_Small_Font Spa_Style_Primary_Color
  Spa_Style_Regular_Weight">Use the link in your email if you want to allow access.</div>`;
        this.Spa_SharePrescription_NoPrescriptionFound_Message = `<h4 class="Spa_Style_H4 my-0">Prescription shared successfully.</h4>
  <div class="Spa_Style_Small_Font Spa_Style_Primary_Color Spa_Style_Regular_Weight">No prescriptions found.</div>`;
        this.Spa_SharePrescription_ImportSuccess_Message = `<h4 class="Spa_Style_H4 my-0">Prescriptions shared successfully.</h4>
  <div class="Spa_Style_Small_Font Spa_Style_Primary_Color Spa_Style_Regular_Weight">Prescriptions have been added to your list.</div>`;
        this.Spa_SharePrescription_No_Prescription_Found_Text = 'No prescriptions found';
        this.Spa_SharePrescription_LoadingDescription_Text = 'We are in process of loading the prescriptions on file.This may take a few minutes.Please do not close this window until it finishes loading or information may be lost.';
        this.Spa_Site_Enable_BlueButton = true;
        this.Spa_HeaderFooter_Broker = 'Licensed Agent';
        this.Spa_HeaderFooter_PrimaryClientLogo = '';
        this.Spa_HeaderFooter_PrimaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_HeaderFooter_SecondaryClientLogo = '';
        this.Spa_HeaderFooter_SecondaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_SharePrescriptions_Success_BeneficiaryDetails_Text = `<div class="Spa_Style_Label mt-4">To discuss:</div></div><ul class="pl-3 mt-1 Spa_Style_Gray4_Color Spa_Style_Paragraph"><li class="py-1">
  Which drugs are used the most often</li><li class="py-1">Which drugs does the beneficiary want to be covered by their plan.</li><li class="py-1">Total
  estimated costs and best fit plan based on the drugs benefeciary is taking</li></ul>`;
        this.Spa_SharePrescription_Error_BeneficiaryContact_Text = `<h2 class="Spa_Style_H2">There was an issue connecting to the Beneficiary's account.Contact them by email to try again. </h2>`;
        this.Spa_SharePrescription_RecommendedCutOff_Days = 90;
        this.Spa_SharePrescription_OptionalCutOff_Months = 12;
        this.Spa_Site_PrescriptionLogo_Alternate_text = 'Prescription Logo';
        this.Spa_Site_Loader_Updated_Icon_Enabled = false;
        this.deniedAccess = false;
        this.blueButtonLoading = false;
        this.isLiveEdit = false;
        this.contactText = '';
        this.accessDenied = 'access_denied';
        this.spinnerSizeSmall = SpinnerSize.SMALL;
        this.subscriptions = new Subscription();
    }
    async ngOnInit() {
        super.ngOnInit();
        this.startTime = new Date().getTime();
        this.sharePrescriptionFacade.setBlueButtonLoading(true);
        this.isLiveEdit = this.sharePrescriptionFacade.isLiveEdit();
        this.blueButtonCabinet$ = this.blueButtonFacade.blueButtonCabinet$;
        if (!this.isLiveEdit) {
            this.blueButtonFetchPrescriptionError$ = this.sharePrescriptionFacade.blueButtonFetchPrescriptionError$;
            this.blueButtonLoading$ = this.sharePrescriptionFacade.blueButtonLoading$;
            let code = '';
            let memberId = '';
            this.activatedRoute.queryParams.subscribe(params => {
                if (params) {
                    if (params.bb_code) {
                        code = params.bb_code;
                    }
                    if (params.MemberID) {
                        memberId = params.MemberID;
                    }
                    if (params.bb_error && params.bb_error.toLowerCase() === this.accessDenied.toLowerCase()) {
                        this.deniedAccess = true;
                    }
                }
            });
            if (this.sharePrescriptionFacade.isPPCSite() && memberId) {
                await this.sharePrescriptionFacade.generateMemberSession(memberId);
            }
            const memberSession = this.memberSessionService.getMemberSession();
            if (!code && !this.deniedAccess) {
                this.sharePrescriptionFacade.updateClaimStatus(true);
                this.blueButtonService.fetchSharedDrugsAndAddToCabinet(memberSession.sessionId, {
                    recommendedCutOffDays: this.Spa_SharePrescription_RecommendedCutOff_Days,
                    optionalCutOffMonths: this.Spa_SharePrescription_OptionalCutOff_Months
                });
            }
            if (code && !this.deniedAccess) {
                this.blueButtonService.fetchSharedDrugsAndAddToCabinet(memberSession.sessionId, {
                    code,
                    recommendedCutOffDays: this.Spa_SharePrescription_RecommendedCutOff_Days,
                    optionalCutOffMonths: this.Spa_SharePrescription_OptionalCutOff_Months
                });
            }
            // For Broker Flow make sure the member session is generated before updating the member status
            if (this.deniedAccess) {
                this.sharePrescriptionFacade.updateMemberAndAddNote(this.widgetName);
            }
        }
        else {
            this.sharePrescriptionFacade.setBlueButtonLoading(false);
        }
        this.subscriptions.add(this.blueButtonFetchPrescriptionError$
            .pipe(switchMap(blueButtonError => {
            this.blueButtonFetchPrescriptionError = blueButtonError;
            if (!blueButtonError) {
                return combineLatest([this.blueButtonCabinet$, this.blueButtonLoading$]);
            }
            return of([null, false]);
        }))
            .subscribe(([blueButtonCabinet, blueButtonLoading]) => {
            if (!this.deniedAccess && blueButtonCabinet && blueButtonLoading === false) {
                this.agentTaskFacade.removeAssociatedTasksByType([NoteActionType.BlueButtonTask]);
                this.tagsToUpdate(BlueButtonReturnStatus.ALLOWED, blueButtonCabinet && blueButtonCabinet.length ? blueButtonCabinet.length.toString() : '0', this.getLoadTime());
            }
            this.cdr.markForCheck();
        }));
    }
    ngAfterViewInit() {
        this.subscriptions.add(this.blueButtonLoading$
            .pipe(switchMap(blueButtonLoading => {
            this.blueButtonLoading = blueButtonLoading;
            if (!blueButtonLoading) {
                return this.sharePrescriptionFacade.blueButtonInfo$;
            }
            return of(null);
        }))
            .subscribe(blueButtonInfo => {
            if (blueButtonInfo) {
                if (blueButtonInfo.status === BlueButtonStatus.DENIED) {
                    this.tagsToUpdate(BlueButtonReturnStatus.DECLINED, BlueButtonReturnStatus.DECLINED, this.getLoadTime());
                }
                else if (blueButtonInfo.status === BlueButtonStatus.ERROR) {
                    this.tagsToUpdate(BlueButtonReturnStatus.ERROR, BlueButtonReturnStatus.ERROR, this.getLoadTime());
                }
            }
            this.cdr.markForCheck();
        }));
    }
    preProcessProperties() {
        this.beneficiaryErrorNotification = [
            {
                message: `${this.Spa_SharePrescription_Error_Message}`,
                liveEditProp: ''
            }
        ];
        this.beneficiaryDeniedNotification = [
            {
                message: `${this.Spa_SharePrescription_Denied_Message}`,
                liveEditProp: ''
            }
        ];
        this.successWithNoPrescriptionNotification = [
            {
                message: `${this.Spa_SharePrescription_NoPrescriptionFound_Message}`,
                liveEditProp: ''
            }
        ];
        this.successNotification = [
            {
                message: this.Spa_SharePrescription_SuccessText,
                liveEditProp: `Spa_SharePrescription_SuccessText`
            },
            {
                message: this.Spa_SharePrescription_UpdatedText,
                liveEditProp: `Spa_SharePrescription_UpdatedText`
            }
        ];
        this.successfulImportNotification = [
            {
                message: `${this.Spa_SharePrescription_ImportSuccess_Message}`,
                liveEditProp: ''
            }
        ];
        if (this.sharePrescriptionFacade.isPPCSite()) {
            this.contactText = this.Spa_SharePrescription_Error_AgentContact_Text;
        }
        else {
            this.contactText = this.Spa_SharePrescription_Error_MedicareContact_Text;
        }
    }
    continueToPrescriptions() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_BLUEBUTTON_CONTINUE_TO_PRESCRIPTIONS);
        this.navigationService.navigateByPageTag(PageTags.GUIDED_HELP_PRESCRIPTIONS);
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
    getLoadTime() {
        return (new Date().getTime() - this.startTime).toString();
    }
    tagsToUpdate(status, drugCount, loadTime) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: this.blueButtonFacade.isImportPrescriptionRefreshEvent
                ? DataLayerEvent.CASE_BLUEBUTTON_REFRESH_COMPLETE
                : DataLayerEvent.CASE_BLUEBUTTON_RETURN,
            [DataLayerGlobalVariable.BLUEBUTTON_RETURN_STATUS]: status,
            [DataLayerGlobalVariable.BLUEBUTTON_RETURN_DRUG_COUNT]: drugCount,
            [DataLayerGlobalVariable.BLUEBUTTON_RETURN_LOADTIME]: loadTime
        };
    }
};
SharePrescriptionComponent.ɵfac = function SharePrescriptionComponent_Factory(t) { return new (t || SharePrescriptionComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(AgentTaskFacade), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.BlueButtonService), i0.ɵɵdirectiveInject(SharePrescriptionFacade), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(BlueButtonFacade)); };
SharePrescriptionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SharePrescriptionComponent, selectors: [["vnext-share-prescription"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [["vnextGoogleTagManager", "", 1, "mx-auto", "container", 3, "saveDefaultValues"], ["class", "container", 4, "ngIf"], [1, "container"], [1, "row"], [1, "col-md-12", "col-xs-12", "text-center"], ["class", "Spa_Style_H1 pt-4 pb-3 my-3", 4, "liveEditProp"], [4, "ngIf", "ngIfElse"], ["showPrescriptionPage", ""], [1, "Spa_Style_H1", "pt-4", "pb-3", "my-3"], [1, "Spa_Style_Paragraph", "Spa_Style_Regular_Font", "text-left", "mt-5", "pt-4", "mb-2"], [1, "d-flex", "align-items-center", "pt-5", 3, "ngClass"], [3, "size"], [1, "Spa_Style_Label", "text-center", 3, "ngClass"], ["prescriptionSharedSuccessfully", ""], [4, "ngIf"], [1, "pt-4"], [3, "type", "messages", "warningCustomClass", 4, "ngIf"], [1, "col-12", "col-md-7", "col-lg-8", "text-left", "py-3", "pl-0"], ["showBeneficiaryConnectError", ""], [1, "col-12", "col-md-5", "col-lg-4", "text-center", "text-md-right", "pt-md-3", "pb-2"], [1, "prescription-logo", 3, "src", "alt"], [3, "type", "messages", "warningCustomClass"], [1, "row", "m-1"], ["navigationAdapter", "", 3, "innerHTML"], [1, "row", "m-1", "text-left"], [3, "type", "messages", 4, "ngIf"], [1, "row", "mt-2"], [1, "col-12", "col-md-7", "col-lg-8", "mb-4"], [1, "row", "pt-3", "m-1"], ["showNoPrescriptionFound", ""], [1, "col-12", "text-left"], [3, "dosage"], [1, "col-12", "col-md-5", "col-lg-4", "text-center"], [3, "type", "messages"], ["showNoClaimsDataFound", ""], ["navigationAdapter", "", "class", "Spa_Style_Large_Font row text-left py-3 m-1", 3, "innerHTML", 4, "liveEditProp"], ["navigationAdapter", "", 1, "Spa_Style_Large_Font", "row", "text-left", "py-3", "m-1", 3, "innerHTML"], ["showBeneficiaryDetails", ""], ["navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], ["class", "Spa_Style_H2", "navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], ["navigationAdapter", "", 1, "Spa_Style_H2", 3, "innerHTML"], [1, "col-lg-9", "offset-md-3"], ["continue-button", "", "class", "btn btn Spa_Style_PrimaryButton width-full width-md-initial", 3, "click", 4, "liveEditProp"], ["continue-button", "", 1, "btn", "btn", "Spa_Style_PrimaryButton", "width-full", "width-md-initial", 3, "click"]], template: function SharePrescriptionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0);
        i0.ɵɵtemplate(1, SharePrescriptionComponent_div_1_Template, 7, 3, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("saveDefaultValues", true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Site_Enable_BlueButton);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, NavigationBannerComponent, SpinnerComponent, NoticeComponent, NavigationAdapterDirective, LiveEditPropDirective, GoogleTagManagerDirective, SharePrescriptionListComponent, i1$2.AsyncPipe, SafePipe], styles: [".prescription-logo[_ngcontent-%COMP%]{height:250px}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_Tile_Image", void 0);
__decorate([
    PlatformProp('live-edit')
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_HeaderText", void 0);
__decorate([
    PlatformProp('live-edit')
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_ContinueButton_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_SuccessText", void 0);
__decorate([
    PlatformProp('live-edit', true)
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_UpdatedText", void 0);
__decorate([
    GlobalResource()
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_LoadingText", void 0);
__decorate([
    PlatformProp('live-edit')
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_ContinueReview_Text", void 0);
__decorate([
    PlatformProp()
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_NoClaimData_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_Added_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_Success_AgentContact_Text", void 0);
__decorate([
    PlatformProp(null, true)
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_Error_AgentContact_Text", void 0);
__decorate([
    PlatformProp(null, true)
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_Error_MedicareContact_Text", void 0);
__decorate([
    PlatformProp(null, true)
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_Error_Message", void 0);
__decorate([
    PlatformProp(null, true)
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_Denied_Message", void 0);
__decorate([
    PlatformProp(null, true)
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_NoPrescriptionFound_Message", void 0);
__decorate([
    PlatformProp(null, true)
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_ImportSuccess_Message", void 0);
__decorate([
    PlatformProp()
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_No_Prescription_Found_Text", void 0);
__decorate([
    GlobalResource()
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_LoadingDescription_Text", void 0);
__decorate([
    GlobalResource()
], SharePrescriptionComponent.prototype, "Spa_Site_Enable_BlueButton", void 0);
__decorate([
    PlatformProp()
], SharePrescriptionComponent.prototype, "Spa_HeaderFooter_Broker", void 0);
__decorate([
    PlatformProp()
], SharePrescriptionComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo", void 0);
__decorate([
    PlatformProp()
], SharePrescriptionComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo_Url", void 0);
__decorate([
    PlatformProp()
], SharePrescriptionComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo", void 0);
__decorate([
    PlatformProp()
], SharePrescriptionComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo_Url", void 0);
__decorate([
    PlatformProp()
], SharePrescriptionComponent.prototype, "Spa_SharePrescriptions_Success_BeneficiaryDetails_Text", void 0);
__decorate([
    PlatformProp()
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_Error_BeneficiaryContact_Text", void 0);
__decorate([
    GlobalResource()
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_RecommendedCutOff_Days", void 0);
__decorate([
    GlobalResource()
], SharePrescriptionComponent.prototype, "Spa_SharePrescription_OptionalCutOff_Months", void 0);
__decorate([
    GlobalResource()
], SharePrescriptionComponent.prototype, "Spa_Site_PrescriptionLogo_Alternate_text", void 0);
__decorate([
    GlobalResource()
], SharePrescriptionComponent.prototype, "Spa_Site_Loader_Updated_Icon_Enabled", void 0);
__decorate([
    LiveEditInactive()
], SharePrescriptionComponent.prototype, "continueToPrescriptions", null);
SharePrescriptionComponent = __decorate([
    PlatformWidget
], SharePrescriptionComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SharePrescriptionComponent, [{
        type: Component,
        args: [{ selector: 'vnext-share-prescription', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"mx-auto container\" vnextGoogleTagManager [saveDefaultValues]=\"true\"></div>\r\n<div class=\"container\" *ngIf=\"Spa_Site_Enable_BlueButton\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12 col-xs-12 text-center\">\r\n      <h1 class=\"Spa_Style_H1 pt-4 pb-3 my-3\" *liveEditProp=\"'Spa_SharePrescription_HeaderText'\">\r\n        {{ Spa_SharePrescription_HeaderText }}\r\n      </h1>\r\n      <ng-container *ngIf=\"blueButtonLoading && !deniedAccess && !isLiveEdit; else showPrescriptionPage\">\r\n        <p class=\"Spa_Style_Paragraph Spa_Style_Regular_Font text-left mt-5 pt-4 mb-2\">\r\n          {{ Spa_SharePrescription_LoadingDescription_Text }}\r\n        </p>\r\n        <div\r\n          class=\"d-flex align-items-center pt-5\"\r\n          [ngClass]=\"Spa_Site_Loader_Updated_Icon_Enabled ? 'flex-column' : 'flex-column-reverse'\"\r\n        >\r\n          <vnext-spinner [size]=\"spinnerSizeSmall\"></vnext-spinner>\r\n          <p class=\"Spa_Style_Label text-center\" [ngClass]=\"{ 'pt-3': Spa_Site_Loader_Updated_Icon_Enabled }\">\r\n            {{ Spa_SharePrescription_LoadingText }}\r\n          </p>\r\n        </div>\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n  <ng-template #showPrescriptionPage>\r\n    <ng-container *ngIf=\"blueButtonFetchPrescriptionError || deniedAccess; else prescriptionSharedSuccessfully\">\r\n      <div class=\"pt-4\">\r\n        <vnext-notice\r\n          [type]=\"'warn'\"\r\n          [messages]=\"beneficiaryErrorNotification\"\r\n          [warningCustomClass]=\"'mb-0'\"\r\n          *ngIf=\"blueButtonFetchPrescriptionError\"\r\n        ></vnext-notice>\r\n        <vnext-notice\r\n          [type]=\"'warn'\"\r\n          [messages]=\"beneficiaryDeniedNotification\"\r\n          [warningCustomClass]=\"'mb-0'\"\r\n          *ngIf=\"deniedAccess\"\r\n        ></vnext-notice>\r\n      </div>\r\n      <div class=\"container\">\r\n        <div class=\"row\">\r\n          <div class=\"col-12 col-md-7 col-lg-8 text-left py-3 pl-0\">\r\n            <ng-container *ngIf=\"!sharePrescriptionFacade.isAgentLoggedIn(); else showBeneficiaryConnectError\">\r\n              <div class=\"row m-1\">\r\n                <div [innerHTML]=\"contactText | safe: 'html'\" navigationAdapter></div>\r\n              </div>\r\n            </ng-container>\r\n            <ng-template #showBeneficiaryConnectError>\r\n              <div class=\"row m-1 text-left\">\r\n                <div [innerHTML]=\"Spa_SharePrescription_Error_BeneficiaryContact_Text | safe: 'html'\" navigationAdapter></div>\r\n              </div>\r\n            </ng-template>\r\n          </div>\r\n          <div class=\"col-12 col-md-5 col-lg-4 text-center text-md-right pt-md-3 pb-2\">\r\n            <img class=\"prescription-logo\" [src]=\"Spa_SharePrescription_Tile_Image\" [alt]=\"Spa_Site_PrescriptionLogo_Alternate_text\" />\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n    <ng-template #prescriptionSharedSuccessfully>\r\n      <ng-container *ngIf=\"blueButtonCabinet$ | async as blueButtonCabinet\">\r\n        <div class=\"pt-4\">\r\n          <vnext-notice\r\n            [type]=\"'success'\"\r\n            [messages]=\"(blueButtonFacade.isAgentImportData$ | async) ? successfulImportNotification : successNotification\"\r\n            *ngIf=\"blueButtonCabinet?.length || isLiveEdit\"\r\n          ></vnext-notice>\r\n          <vnext-notice\r\n            [type]=\"'success'\"\r\n            [messages]=\"successWithNoPrescriptionNotification\"\r\n            *ngIf=\"blueButtonCabinet?.length === 0 && !isLiveEdit\"\r\n          ></vnext-notice>\r\n        </div>\r\n        <ng-container *ngIf=\"!sharePrescriptionFacade.isPPCSite()\">\r\n          <ng-container *ngIf=\"blueButtonCabinet?.length !== 0 || isLiveEdit; else showNoClaimsDataFound\">\r\n            <div\r\n              *liveEditProp=\"'Spa_SharePrescription_ContinueReview_Text'\"\r\n              [innerHTML]=\"Spa_SharePrescription_ContinueReview_Text | safe: 'html'\"\r\n              navigationAdapter\r\n              class=\"Spa_Style_Large_Font row text-left py-3 m-1\"\r\n            ></div>\r\n          </ng-container>\r\n          <ng-template #showNoClaimsDataFound>\r\n            <div\r\n              [innerHTML]=\"Spa_SharePrescription_NoClaimData_Text | safe: 'html'\"\r\n              navigationAdapter\r\n              class=\"Spa_Style_Large_Font row text-left py-3 m-1\"\r\n            ></div>\r\n          </ng-template>\r\n        </ng-container>\r\n        <div class=\"row mt-2\">\r\n          <div class=\"col-12 col-md-7 col-lg-8 mb-4\">\r\n            <ng-container *ngIf=\"sharePrescriptionFacade.isPPCSite()\">\r\n              <ng-container *ngIf=\"!sharePrescriptionFacade.isAgentLoggedIn(); else showBeneficiaryDetails\">\r\n                <div class=\"row m-1\">\r\n                  <div\r\n                    *liveEditProp=\"'Spa_SharePrescription_Success_AgentContact_Text'\"\r\n                    [innerHTML]=\"Spa_SharePrescription_Success_AgentContact_Text | safe: 'html'\"\r\n                    navigationAdapter\r\n                  ></div>\r\n                </div>\r\n              </ng-container>\r\n              <ng-template #showBeneficiaryDetails>\r\n                <div class=\"row m-1 text-left\">\r\n                  <div [innerHTML]=\"Spa_SharePrescriptions_Success_BeneficiaryDetails_Text | safe: 'html'\" navigationAdapter></div>\r\n                </div>\r\n              </ng-template>\r\n            </ng-container>\r\n            <div class=\"row pt-3 m-1\">\r\n              <ng-container *ngIf=\"blueButtonCabinet?.length || isLiveEdit; else showNoPrescriptionFound\">\r\n                <h2\r\n                  class=\"Spa_Style_H2\"\r\n                  *liveEditProp=\"'Spa_SharePrescription_Added_Text'\"\r\n                  [innerHTML]=\"Spa_SharePrescription_Added_Text | safe: 'html'\"\r\n                  navigationAdapter\r\n                ></h2>\r\n              </ng-container>\r\n              <ng-template #showNoPrescriptionFound>\r\n                <h2\r\n                  class=\"Spa_Style_H2\"\r\n                  [innerHTML]=\"Spa_SharePrescription_No_Prescription_Found_Text | safe: 'html'\"\r\n                  navigationAdapter\r\n                ></h2>\r\n              </ng-template>\r\n            </div>\r\n            <div class=\"col-12 text-left\">\r\n              <ng-container>\r\n                <vnext-share-prescription-list [dosage]=\"blueButtonCabinet$ | async\"> </vnext-share-prescription-list>\r\n              </ng-container>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-12 col-md-5 col-lg-4 text-center\">\r\n            <img class=\"prescription-logo\" [src]=\"Spa_SharePrescription_Tile_Image\" [alt]=\"Spa_Site_PrescriptionLogo_Alternate_text\" />\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n    </ng-template>\r\n    <ng-container *ngIf=\"!sharePrescriptionFacade.isPPCSite() || sharePrescriptionFacade.isAgentLoggedIn()\">\r\n      <vnext-navigation-banner class=\"col-lg-9 offset-md-3\">\r\n        <button\r\n          continue-button\r\n          class=\"btn btn Spa_Style_PrimaryButton width-full width-md-initial\"\r\n          (click)=\"continueToPrescriptions()\"\r\n          *liveEditProp=\"'Spa_SharePrescription_ContinueButton_Text'\"\r\n        >\r\n          {{ Spa_SharePrescription_ContinueButton_Text }}\r\n        </button>\r\n      </vnext-navigation-banner>\r\n    </ng-container>\r\n  </ng-template>\r\n</div>\r\n", styles: [".prescription-logo{height:250px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i2$1.ActivatedRoute }, { type: AgentTaskFacade }, { type: i1.MemberSessionService }, { type: i1.NavigationService }, { type: i1.BlueButtonService }, { type: SharePrescriptionFacade }, { type: AnalyticsService }, { type: BlueButtonFacade }]; }, { Spa_SharePrescription_Tile_Image: [], Spa_SharePrescription_HeaderText: [], Spa_SharePrescription_ContinueButton_Text: [], Spa_SharePrescription_SuccessText: [], Spa_SharePrescription_UpdatedText: [], Spa_SharePrescription_LoadingText: [], Spa_SharePrescription_ContinueReview_Text: [], Spa_SharePrescription_NoClaimData_Text: [], Spa_SharePrescription_Added_Text: [], Spa_SharePrescription_Success_AgentContact_Text: [], Spa_SharePrescription_Error_AgentContact_Text: [], Spa_SharePrescription_Error_MedicareContact_Text: [], Spa_SharePrescription_Error_Message: [], Spa_SharePrescription_Denied_Message: [], Spa_SharePrescription_NoPrescriptionFound_Message: [], Spa_SharePrescription_ImportSuccess_Message: [], Spa_SharePrescription_No_Prescription_Found_Text: [], Spa_SharePrescription_LoadingDescription_Text: [], Spa_Site_Enable_BlueButton: [], Spa_HeaderFooter_Broker: [], Spa_HeaderFooter_PrimaryClientLogo: [], Spa_HeaderFooter_PrimaryClientLogo_Url: [], Spa_HeaderFooter_SecondaryClientLogo: [], Spa_HeaderFooter_SecondaryClientLogo_Url: [], Spa_SharePrescriptions_Success_BeneficiaryDetails_Text: [], Spa_SharePrescription_Error_BeneficiaryContact_Text: [], Spa_SharePrescription_RecommendedCutOff_Days: [], Spa_SharePrescription_OptionalCutOff_Months: [], Spa_Site_PrescriptionLogo_Alternate_text: [], Spa_Site_Loader_Updated_Icon_Enabled: [], continueToPrescriptions: [] }); })();

// events created from the vNext context to be handled by FOAM
var CustomVNextEvents;
(function (CustomVNextEvents) {
    CustomVNextEvents["ENROLLMENT_NEXT"] = "vnextEnrollmentNextEvent";
    CustomVNextEvents["ENROLLMENT_BACK"] = "vnextEnrollmentBackEvent";
    CustomVNextEvents["SET_FORM_FIELD"] = "vnextSetFormFieldEvent";
})(CustomVNextEvents || (CustomVNextEvents = {}));
var NextGenEnrollmentEvents;
(function (NextGenEnrollmentEvents) {
    NextGenEnrollmentEvents["NAVIGATE_PREVIOUS_PAGE"] = "NextGenFormClientEvent_Navigate_To_Previous_Page";
    NextGenEnrollmentEvents["NAVIGATE_NEXT_PAGE"] = "NextGenFormClientEvent_Navigate_To_Next_Page";
    NextGenEnrollmentEvents["NAVIGATE_BY_PAGE_NAME"] = "NextGenFormClientEvent_Navigate_To_Page_By_Name";
    NextGenEnrollmentEvents["ADD_CUSTOM_ERROR_TO_QUESTION"] = "NextGenFormClientEvent_Add_Custom_Error_To_Question";
    NextGenEnrollmentEvents["REQUEST_PAGE_ERRORS"] = "NextGenFormClientEvent_Page_Errors_Request";
    NextGenEnrollmentEvents["REQUEST_PAGE_ERRORS_RESPONSE"] = "NextGenForm_Page_Errors_Response";
    NextGenEnrollmentEvents["REQUEST_FORM_ERRORS"] = "NextGenFormClientEvent_Form_Errors_Request";
    NextGenEnrollmentEvents["REQUEST_FORM_ERRORS_RESPONSE"] = "NextGenForm_Form_Errors_Response";
    NextGenEnrollmentEvents["COMPLETE_FORM"] = "NextGenForm_Form_Complete";
    NextGenEnrollmentEvents["FORM_RENDERED"] = "NextGenForm_Form_Rendered";
    NextGenEnrollmentEvents["SURVEY_BEFORE_VIEW_INITIALIZED"] = "NextGenForm_Before_Survey_View_Initialization";
    NextGenEnrollmentEvents["SURVEY_AFTER_VIEW_INITIALIZED"] = "NextGenForm_After_Survey_View_Initialization";
    NextGenEnrollmentEvents["SURVEY_AFTER_PAGE_RENDERED"] = "NextGenForm_On_After_Page_Rendered";
    NextGenEnrollmentEvents["RECEIVED_FOCUS"] = "NextGenForm_Question_Received_Focus";
    NextGenEnrollmentEvents["VALUE_CHANGED"] = "NextGenForm_Question_Value_Changed";
    NextGenEnrollmentEvents["SET_FORM_DATA"] = "NextGenFormClientEvent_Set_Form_Data";
    NextGenEnrollmentEvents["SET_PROPERTY_DATA"] = "NextGenFormClientEvent_Set_Property_Data";
    NextGenEnrollmentEvents["PROVIDER_SEARCH_NAVIGATION"] = "NextGenForm_Provider_Search_Navigation";
    NextGenEnrollmentEvents["FORM_INFO"] = "NextGenForm_Emit_FormInfo";
    NextGenEnrollmentEvents["PAGE_ERRORS"] = "NextGenForm_Emit_PageErrors";
    NextGenEnrollmentEvents["EDIT_ZIP_CODE"] = "NextGenForm_Edit_Link_Zip_Code_Event";
    NextGenEnrollmentEvents["EDIT_MEDSUP_RATE_FACTOR"] = "NextGenForm_Edit_MedSup_Rate_Factor_Event";
    NextGenEnrollmentEvents["UPLOAD_FILES"] = "NextGenForm_Upload_Files_Request";
    NextGenEnrollmentEvents["UPLOAD_FILES_RESPONSE"] = "NextGenForm_Upload_Files_Response";
    NextGenEnrollmentEvents["UPLOAD_FILES_ERROR_RESPONSE"] = "NextGenForm_Upload_Files_Error_Response";
    NextGenEnrollmentEvents["DELETE_UPLOADED_FILES"] = "NextGenForm_Delete_Uploaded_Files_Request";
    NextGenEnrollmentEvents["DELETE_UPLOADED_FILES_RESPONSE"] = "NextGenForm_Delete_Uploaded_Files_Response";
    NextGenEnrollmentEvents["DELETE_UPLOADED_FILES_ERROR_RESPONSE"] = "NextGenForm_Delete_Uploaded_Files_Error_Response";
    NextGenEnrollmentEvents["DOWNLOAD_FILE"] = "NextGenForm_Download_File_Request";
    NextGenEnrollmentEvents["ADDRESS_AUTOCOMPLETE_REQUEST"] = "NextGenForm_Address_Autocomplete_Request";
    NextGenEnrollmentEvents["ADDRESS_AUTOCOMPLETE_RESPONSE"] = "NextGenForm_Address_Autocomplete_Response";
    NextGenEnrollmentEvents["ADDRESS_AUTOCOMPLETE_ERROR_RESPONSE"] = "NextGenForm_Address_Autocomplete_Error_Response";
    NextGenEnrollmentEvents["UPDATE_QUESTION_VISIBILITY"] = "NextGenForm_Update_Question_Visibility";
    NextGenEnrollmentEvents["UPDATE_DYNAMIC_SCRIPTS"] = "NextGenForm_Update_Dynamic_Scripts";
    NextGenEnrollmentEvents["UPDATE_VIA_QUERY_PARAMS"] = "NextGenForm_Update_Via_Query_Params_Event";
    NextGenEnrollmentEvents["ENROLLMENT_GO_TO_PAGE"] = "NextGenForm_Enrollment_Go_To_Page";
    NextGenEnrollmentEvents["CLEAR_PREFILL_DATA"] = "NextGenForm_Clear_Prefill_Data";
    NextGenEnrollmentEvents["VALIDATE_GROUP"] = "NextGenForm_Validate_Group";
    NextGenEnrollmentEvents["VALIDATE_GROUP_RESPONSE"] = "NextGenForm_Validate_Group_Response";
})(NextGenEnrollmentEvents || (NextGenEnrollmentEvents = {}));
var EnrollmentFormKeys;
(function (EnrollmentFormKeys) {
    EnrollmentFormKeys["APPLICANT_ZIP"] = "ApplicantZip";
    EnrollmentFormKeys["APPLICANT_GENDER"] = "ApplicantGender";
    EnrollmentFormKeys["APPLICANT_MARITAL_STATUS"] = "ApplicantMaritalStatus";
    EnrollmentFormKeys["VOICE_SIGNATURE_COLLECTED"] = "VoiceSignatureCollected";
    EnrollmentFormKeys["VOICE_SIGNATURE_COLLECTED_DATETIME"] = "VoiceSignatureCollectedDateTime";
    EnrollmentFormKeys["PRE_ENROLLMENT_STATEMENTS_COLLECTED"] = "PreenrollmentStatementsCollected";
    EnrollmentFormKeys["SIGNATURE_CODE_AUTHORIZED"] = "SignatureCodeAuthorized";
    EnrollmentFormKeys["AUTH_CODE_SIGNATURE_DATE_TIME"] = "AuthCodeSignatureDateTime";
})(EnrollmentFormKeys || (EnrollmentFormKeys = {}));
var CustomFOAMEvents;
(function (CustomFOAMEvents) {
    CustomFOAMEvents["EDIT_LINK_EVENT"] = "SpaCustomEditLinkEvent";
    CustomFOAMEvents["ENROLLMENT_NEXT"] = "SpaEnrollmentNextEvent";
    CustomFOAMEvents["ENROLLMENT_BACK"] = "SpaEnrollmentBackEvent";
    CustomFOAMEvents["ENROLLMENT_GO_TO_PAGE"] = "SpaEnrollmentGoToPageEvent";
    CustomFOAMEvents["INPUT_BLUR"] = "SpaInputBlurEvent";
    CustomFOAMEvents["MISSING_ENROLLMENT_DATA"] = "SpaEnrollmentMissingDataEvent";
    CustomFOAMEvents["ENROLLMENT_PROVIDER_LINK_EVENT"] = "SpaProviderLinkEvent";
})(CustomFOAMEvents || (CustomFOAMEvents = {}));
var HumanaApiErrorTypes;
(function (HumanaApiErrorTypes) {
    HumanaApiErrorTypes["FIXABLE"] = "HUMANA_FIXABLE";
    HumanaApiErrorTypes["NON_FIXABLE"] = "HUMANA_NON_FIXABLE";
    HumanaApiErrorTypes["MAX_RETRY_ATTEMPTED"] = "HUMANA_MAX_RETRY_ATTEMPTED";
})(HumanaApiErrorTypes || (HumanaApiErrorTypes = {}));
var ExternalApiErrorTypes;
(function (ExternalApiErrorTypes) {
    ExternalApiErrorTypes["EXTERNAL_API_INTEGRATION_ERROR"] = "EXTERNAL_API_INTEGRATION_ERROR";
    ExternalApiErrorTypes["EXTERNAL_API_INTEGRATION_FIXABLE_ERROR"] = "EXTERNAL_API_INTEGRATION_FIXABLE_ERROR";
})(ExternalApiErrorTypes || (ExternalApiErrorTypes = {}));
var OtherApiErrorTypes;
(function (OtherApiErrorTypes) {
    OtherApiErrorTypes["POSTBACK_INVALID"] = "Invalid Confirmation PostBack Url";
    OtherApiErrorTypes["TRANSACTION_INACTIVE"] = "Transaction is not active";
    OtherApiErrorTypes["INVALID_OBJECT"] = "Object reference not set to an instance of an object.";
})(OtherApiErrorTypes || (OtherApiErrorTypes = {}));
class EnrollmentError {
}
class EnrollmentInnerError {
}
class EnrollmentErrorListItem {
}

class EnrollmentConfirmationService {
    constructor(store, plansService, enrollmentSettingsService, configResourceService, enrollmentFormService) {
        this.store = store;
        this.plansService = plansService;
        this.enrollmentSettingsService = enrollmentSettingsService;
        this.configResourceService = configResourceService;
        this.enrollmentFormService = enrollmentFormService;
    }
    setConfirmationVisited() {
        this.store.dispatch(new SetConfirmationVisited());
    }
    resetConfirmationState() {
        this.store.dispatch(new ResetConfirmationState());
    }
    reselectUnenrolledPlans(cartPlans, enrollment) {
        // Re-select unenrolled plans, if any, to check for more plans to enroll in(For Cross-sell)
        // in case shopping cart state was cleared when fetching member session return shopping cart data
        if (cartPlans) {
            cartPlans.forEach(cartPlan => {
                const planId = cartPlan.planId;
                if (planId !== enrollment?.planID) {
                    const plan = this.plansService.getPlan(planId);
                    const plansSelectedRiderIds = cartPlan.riders
                        .filter(rider => rider.isSelected || rider.isRequired)
                        .map(selectedRider => selectedRider.riderId);
                    const riders = PlansUtilityService.getRiderData(plan);
                    // create a default item for the shopping cart... the riders here are just
                    // for show as plansSelectedRiderIds will override these
                    const newItem = PlansUtilityService.createShoppingCartEntry(plan, riders);
                    this.store.dispatch(new InsertPlan(plan, newItem, plansSelectedRiderIds, false));
                }
            });
        }
    }
    // as per conversations with BA: This are the rules to display Continue Enrollment Button
    // Cart - If all of the plans have been enrolled in, there is no need to show the Continue applying button
    // on the Enrollment Confirmation page.
    // EXCEPTION - If there are plans in the cart that are external enrollment or message only, we should be showing
    // the Continue applying button on the Enrollment Confirmation page until those plans are physically removed from the Cart.
    // BOTTOM LINE, whenever there is a plan in the Cart with a Continue to apply button, show the Continue applying button
    // on the Enrollment Confirmation page.
    setMoreCoverageToEnroll(planIds, showIndividualEnrollmentButtons, enrollmentPlan, enrollments) {
        if (planIds?.length) {
            const allowEnrollingInSamePlan = this.configResourceService.getProcessedResourceValue('Spa_Enrollment_Allow_AlreadyEnrolled_Plans', null, false);
            if (enrollments?.length && !allowEnrollingInSamePlan) {
                return planIds.some(planId => !enrollments.find(enrollment => enrollment.planID === planId && enrollment.completedWhen));
            }
            const enrollmentSettings = this.store.selectSnapshot(MemberState.enrollmentSettings);
            const planId = this.enrollmentFormService.getActiveEnrollmentKey();
            const planHasNextGenForm = this.enrollmentFormService.planHasNextGenForm(planId);
            // TODO: QA should test scenarios surrounding this
            const enrollmentType = this.enrollmentSettingsService.getEnrollmentType(enrollmentSettings, planHasNextGenForm);
            if (enrollmentType === EnrollmentType$1.MESSAGE_ONLY || enrollmentType === EnrollmentType$1.EXTERNAL) {
                return true;
            }
            const isLastPlanInCartEnrollment = planIds.length === 1 && planIds[0] === enrollmentPlan.id;
            return showIndividualEnrollmentButtons || !isLastPlanInCartEnrollment;
        }
        return false;
    }
    removeEnrolledPlansFromShoppingCart() {
        const shoppingCart = this.store.selectSnapshot(ShoppingCartState.selectCartAPIState);
        const cartPlanIds = shoppingCart && shoppingCart.map(cartPlan => cartPlan.planId);
        const enrollments = cartPlanIds && this.getEnrollments(cartPlanIds);
        if (cartPlanIds) {
            cartPlanIds.forEach(planId => {
                const enrolledPlan = enrollments.find(enrollment => enrollment.planID === planId && enrollment.completedWhen);
                if (enrolledPlan) {
                    this.store.dispatch(new RemovePlan(planId));
                }
            });
        }
    }
    getEnrollments(planIds) {
        return this.store.selectSnapshot(MemberState.memberEnrollmentsByPlanIds(planIds));
    }
    getEnrollmentType(enrollmentSetting) {
        // Identify the enrollmentType based on the response from EnrollmentSettings call
        // !! not the BeanProvider call !!
        if (enrollmentSetting) {
            const { enrollMessage, enrollUrl, formId } = enrollmentSetting;
            // Plan set is misconfigured if no message, external url, or internal formId to proceed with
            if (enrollMessage || enrollUrl || formId) {
                // Still show bean message for internal and external
                if (formId) {
                    return EnrollmentType$1.INTERNAL;
                }
                else if ((!formId || formId === null) && enrollUrl) {
                    return EnrollmentType$1.EXTERNAL;
                }
                else if (!formId && enrollMessage) {
                    return EnrollmentType$1.MESSAGE_ONLY;
                }
            }
        }
        return null;
    }
}
EnrollmentConfirmationService.ɵfac = function EnrollmentConfirmationService_Factory(t) { return new (t || EnrollmentConfirmationService)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.PlansService), i0.ɵɵinject(i1.EnrollmentSettingsService), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.EnrollmentFormService)); };
EnrollmentConfirmationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EnrollmentConfirmationService, factory: EnrollmentConfirmationService.ɵfac, providedIn: 'root' });
__decorate([
    LiveEditInactive()
], EnrollmentConfirmationService.prototype, "removeEnrolledPlansFromShoppingCart", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentConfirmationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i2.Store }, { type: i1.PlansService }, { type: i1.EnrollmentSettingsService }, { type: i1.ConfigResourceService }, { type: i1.EnrollmentFormService }]; }, { removeEnrolledPlansFromShoppingCart: [] }); })();

class ShoppingCartContextService {
    constructor() {
        this.invalidEnrollmentPlans$ = new BehaviorSubject([]);
    }
    getInvalidEnrollmentPlans$() {
        return this.invalidEnrollmentPlans$.asObservable();
    }
    setIsValidForEnrollment(planId, isValid) {
        this.invalidEnrollmentPlans$.pipe(take(1)).subscribe(invalidEnrollmentPlans => {
            let updatedPlans = [];
            if (isValid) {
                updatedPlans = invalidEnrollmentPlans.filter(invalidPlanId => invalidPlanId !== planId);
            }
            else {
                const invalidEnrollmentPlan = invalidEnrollmentPlans.find(invalidPlanId => invalidPlanId === planId);
                updatedPlans = [...invalidEnrollmentPlans];
                if (!invalidEnrollmentPlan) {
                    updatedPlans.push(planId);
                }
            }
            this.invalidEnrollmentPlans$.next(updatedPlans);
        });
    }
    getIsValidForEnrollment$(planId) {
        return this.getInvalidEnrollmentPlans$().pipe(map(invalidEnrollmentPlans => !invalidEnrollmentPlans.includes(planId)));
    }
}
ShoppingCartContextService.ɵfac = function ShoppingCartContextService_Factory(t) { return new (t || ShoppingCartContextService)(); };
ShoppingCartContextService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ShoppingCartContextService, factory: ShoppingCartContextService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShoppingCartContextService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class ShoppingCartCrossSellFacade {
    constructor(configResourceService, demographicService, enrollmentFormService, cartFacade, navigationService, planFacade, plansService, shoppingCartContextService) {
        this.configResourceService = configResourceService;
        this.demographicService = demographicService;
        this.enrollmentFormService = enrollmentFormService;
        this.cartFacade = cartFacade;
        this.navigationService = navigationService;
        this.planFacade = planFacade;
        this.plansService = plansService;
        this.shoppingCartContextService = shoppingCartContextService;
    }
    async prepareAndEnroll(nextEnrollmentPlan, canSendToBeneficiary, toolTip) {
        // Prepare and Enroll in the plan
        const enrollingPlan = nextEnrollmentPlan;
        await this.setEnrollmentSettings(enrollingPlan, canSendToBeneficiary);
        const fips = this.demographicService.getSelectedFipsCode();
        const date = this.cartFacade.getAgentPlanPermissionEffectiveDate(enrollingPlan.planType);
        this.cartFacade.checkEnrollmentStatusAndAgentPermissions(enrollingPlan, date, fips, toolTip, this.enrollInPlan.bind(this));
    }
    async setEnrollmentSettings(enrollingPlan, canSendToBeneficiary) {
        const planEnrollmentSettings = await this.plansService.fetchAllPlanEnrollmentSettingsForCrossSell(enrollingPlan.id);
        const shortFormSettings = planEnrollmentSettings.filter(setting => setting.foamFormType === EnrollmentFormType.SHORT && setting.formId !== null);
        const longFormSettings = planEnrollmentSettings.filter(setting => setting.foamFormType === EnrollmentFormType.LONG && setting.formId !== null);
        if (this.showConsumerBrokerSelection(enrollingPlan, planEnrollmentSettings, canSendToBeneficiary)) {
            const userFormType = this.enrollmentFormService.getUserFormType(enrollingPlan.id);
            if (userFormType === null) {
                this.shoppingCartContextService.setIsValidForEnrollment(enrollingPlan.id, false);
            }
            else {
                // As long form is default we need to check if there is a matching long form for the selection
                // so as to not error out.  Per validation above userType must be set.
                this.validateMatchingLongForm(enrollingPlan.id, longFormSettings);
                // As short forms aren't usually given we need to check if there is one and
                // reset the default to long if there isn't one for the agent/form selection.
                this.validateMatchingShortForm(enrollingPlan.id, shortFormSettings);
            }
        }
    }
    showConsumerBrokerSelection(plan, planEnrollmentSettings, canSendToBeneficiary) {
        return (this.plansService.isConsumerBrokerSelectionAllowedForPlanType(plan) &&
            this.checkConsumerBrokerSelectionForPlan(plan, planEnrollmentSettings) &&
            this.getConsumerBrokerToggleEnabled() &&
            canSendToBeneficiary);
    }
    checkConsumerBrokerSelectionForPlan(plan, planEnrollmentSettings) {
        return plan && planEnrollmentSettings && this.enrollmentFormService.showAgentFormSelection(planEnrollmentSettings);
    }
    getConsumerBrokerToggleEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_ShoppingCart_ConsumerBroker_Toggle_Enabled', widgetName, true);
    }
    validateMatchingShortForm(planId, shortFormSettings) {
        this.enrollmentFormService.validateMatchingShortForm(planId, shortFormSettings);
    }
    validateMatchingLongForm(planId, longFormSettings) {
        this.enrollmentFormService.validateMatchingLongForm(planId, longFormSettings);
    }
    enrollInPlan(planId) {
        // Enroll in the second plan when both plans on Crosssell are MessageOnly
        // Or one plan is External and one plan is MessageOnly
        this.enrollmentFormService.setActiveEnrollmentKey(planId);
        const isMedSupEnrollment = this.cartFacade.isMedSupEnrollment(planId);
        if (isMedSupEnrollment) {
            this.enrollInMedSupPlan();
        }
        else {
            this.enrollInNonMedSupPlan();
        }
    }
    enrollInMedSupPlan() {
        if (this.isMedSupEnrollmentEnabled()) {
            if (this.isMedigapInterimPageEnabled()) {
                this.navigationService.navigateByPageTag(PageTags.MEDIGAP_INTERIM);
            }
            else {
                this.navigationService.navigateByPageTag(PageTags.ENROLLMENT);
            }
        }
    }
    enrollInNonMedSupPlan() {
        if (this.isEnrollmentEnabled()) {
            this.planFacade.enroll();
        }
    }
    isMedSupEnrollmentEnabled() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_MedSupEnrollment_Enabled', null, true);
    }
    isEnrollmentEnabled() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Enrollment_Enabled', null, true);
    }
    isMedigapInterimPageEnabled() {
        return this.configResourceService.getProcessedResourceValue('SPA_Site_Medigap_Enrollment_InterimPage_Enable', null, true);
    }
}
ShoppingCartCrossSellFacade.ɵfac = function ShoppingCartCrossSellFacade_Factory(t) { return new (t || ShoppingCartCrossSellFacade)(i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.DemographicService), i0.ɵɵinject(i1.EnrollmentFormService), i0.ɵɵinject(CartFacade), i0.ɵɵinject(i1.NavigationService), i0.ɵɵinject(PlanFacade), i0.ɵɵinject(i1.PlansService), i0.ɵɵinject(ShoppingCartContextService)); };
ShoppingCartCrossSellFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ShoppingCartCrossSellFacade, factory: ShoppingCartCrossSellFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShoppingCartCrossSellFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: i1.DemographicService }, { type: i1.EnrollmentFormService }, { type: CartFacade }, { type: i1.NavigationService }, { type: PlanFacade }, { type: i1.PlansService }, { type: ShoppingCartContextService }]; }, null); })();

class SendEnrollmentFacade {
    constructor(configResourceService, modalService, profileService, sendEnrollmentService, navigationService, formValidationService, siteService, phoneUtilityService, planFacade, shoppingCartService, enrollmentConfirmationService, enrollmentFormService, shoppingCartCrossSellFacade, store, cartFacade, memberSessionService, sendQuoteFacade, planCompareApiService) {
        this.configResourceService = configResourceService;
        this.modalService = modalService;
        this.profileService = profileService;
        this.sendEnrollmentService = sendEnrollmentService;
        this.navigationService = navigationService;
        this.formValidationService = formValidationService;
        this.siteService = siteService;
        this.phoneUtilityService = phoneUtilityService;
        this.planFacade = planFacade;
        this.shoppingCartService = shoppingCartService;
        this.enrollmentConfirmationService = enrollmentConfirmationService;
        this.enrollmentFormService = enrollmentFormService;
        this.shoppingCartCrossSellFacade = shoppingCartCrossSellFacade;
        this.store = store;
        this.cartFacade = cartFacade;
        this.memberSessionService = memberSessionService;
        this.sendQuoteFacade = sendQuoteFacade;
        this.planCompareApiService = planCompareApiService;
    }
    isSendApplicationEmailEnabled(widgetName) {
        const siteType = this.getSiteType();
        const sendApplicationEmailEnabled = this.getSendApplicationEmailButtonEnabled(widgetName);
        return this.siteService.isPPCSite(siteType) && sendApplicationEmailEnabled;
    }
    isSendApplicationTextMessageEnabled(widgetName) {
        const siteType = this.getSiteType();
        const sendApplicationTextMessageEnabled = this.getSendApplicationTextMessageButtonEnabled(widgetName);
        return this.siteService.isPPCSite(siteType) && sendApplicationTextMessageEnabled;
    }
    isRestrictProfessionalPlansEnabled(widgetName) {
        const siteType = this.getSiteType();
        const limitToProfessionalPlan = this.restrictProfessionalPlansFromSendApplication(widgetName);
        return this.siteService.isPPCSite(siteType) && limitToProfessionalPlan;
    }
    isSendApplicationEnabled() {
        return this.isSendApplicationEmailEnabled() || this.isSendApplicationTextMessageEnabled();
    }
    isPlanRestricted(plan) {
        return this.isRestrictProfessionalPlansEnabled() && this.planFacade.isPlanProfessionalOnly(plan);
    }
    canSendToBeneficiary(plan) {
        return plan && this.isSendApplicationEnabled() ? !this.isPlanRestricted(plan) : false;
    }
    canSendToBeneficiaryForPCApi(plan) {
        return plan && (this.getSendApplicationEmailButtonEnabled() || this.getSendApplicationTextMessageButtonEnabled());
    }
    getRestrictProfessionalPlansNoticeTitle(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_RestrictProfessionalPlans_Notice_Title', null, 'Professional enrollment only.');
    }
    getRestrictProfessionalPlansNoticeMessage(widgetName) {
        const prompt = this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_RestrictProfessionalPlans_Notice_Message', null, 'Plan not available to send to beneficiary to complete enrollment.');
        return [{ message: prompt, severity: NOTICE_TYPE.WARN }];
    }
    getRestrictProfessionalPlansNavBarMessage(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_RestrictProfessionalPlans_NavBar_Message', null, 'Professional enrollment only. Not available to send to beneficiary.');
    }
    getProfileEmail() {
        return this.profileService.getEmailAddress();
    }
    getProfilePhone() {
        return this.profileService.getHomePhone();
    }
    getShoppingCartPlans() {
        return this.shoppingCartService.getSelectedPlans();
    }
    showSendEnrollmentModal(widgetName) {
        const shoppingCartPlans = this.getShoppingCartPlans();
        const isRedirectedFromPlanCompareApi = this.isRedirectedFromPlanCompareApi();
        const isSendToBeneficiaryWithoutAgentForPlanCompareApi = this.isSendToBeneficiaryWithoutAgentForPlanCompareApi();
        const storageId = this.getPCApiStorageId();
        const modal = this.getSendEnrollmentModal(this.modalService.open(SendQuoteModalComponent, { centered: true }), shoppingCartPlans, isRedirectedFromPlanCompareApi, isSendToBeneficiaryWithoutAgentForPlanCompareApi, widgetName);
        const enrollingPlanId = this.enrollmentFormService.getActiveEnrollmentKey();
        const transactionGuid = this.store.selectSnapshot(EnrollmentState.transactionGUID(enrollingPlanId));
        modal.result.then(async (modalResults) => {
            const { emailAddress, phone, planDocuments } = modalResults;
            const authCode = await this.sendEnrollmentService.createQuoteAndSendApplication(enrollingPlanId, emailAddress, phone, planDocuments, isRedirectedFromPlanCompareApi, isSendToBeneficiaryWithoutAgentForPlanCompareApi, storageId, transactionGuid);
            const formattedPhone = this.phoneUtilityService.getNationalPhoneNumber(phone);
            const sessionId = this.store.selectSnapshot(MemberState.sessionId);
            if (sessionId) {
                this.sendQuoteFacade.sendQuoteStatus(sessionId, MemberProgressStatus.SEND_TO_BENEFICIARY);
            }
            this.showEmailSuccessModal(emailAddress, formattedPhone, authCode, isRedirectedFromPlanCompareApi, isSendToBeneficiaryWithoutAgentForPlanCompareApi);
        }, () => { });
    }
    async showEmailSuccessModal(email, phone, authCode, isRedirectedFromPlanCompareApi, isSendToBeneficiaryWithoutAgentForPlanCompareApi, widgetName) {
        const nextEnrollmentPlan = await this.getPlanToEnroll(isRedirectedFromPlanCompareApi);
        const successModal = this.getSuccessModal(this.modalService.open(EmailConfirmationSuccessModalComponent, { centered: true }), email, phone, authCode, nextEnrollmentPlan, isRedirectedFromPlanCompareApi, isSendToBeneficiaryWithoutAgentForPlanCompareApi, widgetName);
        successModal.result.then((event) => {
            if (event && event.eventType === ModalEventType.REDIRECT) {
                const pageTag = this.getRedirectPageTag();
                this.navigationService.navigateByPageTag(pageTag);
            }
            if (event && event.eventType === ModalEventType.CROSSSELL_APPLY && nextEnrollmentPlan) {
                this.continueApplyingAction(nextEnrollmentPlan);
            }
        }, () => { });
    }
    async getPlanToEnroll(isRedirectedFromPlanCompareApi = false) {
        if (!isRedirectedFromPlanCompareApi) {
            const planIds = this.store.selectSnapshot(ShoppingCartState.selectCartAPIState).map(cartPlan => cartPlan.planId);
            const sessionId = this.store.selectSnapshot(MemberState.session).sessionId;
            await this.memberSessionService.fetchMemberSession$({ sessionId, isEnrollmentHistoryIncluded: true }).toPromise();
            const enrollments = this.enrollmentConfirmationService.getEnrollments(planIds);
            const plans = this.shoppingCartService.getSelectedPlans();
            if (enrollments && plans) {
                return plans.find(plan => !enrollments.find(enrollment => enrollment.planID === plan.id));
            }
        }
        return null;
    }
    getSiteType() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType', null, SiteType.CONSUMER);
    }
    getSendApplicationEmailButtonEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_Email_Enabled', widgetName, true);
    }
    getSendApplicationTextMessageButtonEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_TextMessage_Enabled', widgetName, true);
    }
    restrictProfessionalPlansFromSendApplication(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_RestrictProfessionalPlans_Enabled', widgetName, false);
    }
    getTitle(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_Title', widgetName, 'Send enrollment');
    }
    getPrompt(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_Prompt', widgetName, 'How would the beneficiary like to receive the application to finish enrolling?');
    }
    getEmailPrompt(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_EmailAddress_Text', widgetName, 'Email Address');
    }
    getPhonePrompt(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_PhoneNumber_Text', widgetName, 'Phone Number');
    }
    getEmailCheckBoxPrompt(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_EmailCheckBox_Prompt', widgetName, 'Email');
    }
    getPhoneCheckBoxPrompt(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_PhoneCheckBox_Prompt', widgetName, 'Text');
    }
    getPhoneMask(widgetName) {
        return FormValidationService.phoneMask || '(000) 000-0000';
    }
    getCloseText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Close', widgetName, 'Close');
    }
    getCancelText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Cancel', widgetName, 'Cancel');
    }
    getSendApplicationText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_Continue', widgetName, 'Send application');
    }
    getCarbonCopyText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_CarbonCopy_Text', widgetName, 'CC you');
    }
    getAuthCodeTextOnlyEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('SPA_AuthCode_TextOnly_Enabled', widgetName, false);
    }
    getQuoteLinkEmailOnlyEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('SPA_QuoteLink_EmailOnly_Enabled', widgetName, false);
    }
    getSuccessMessage(email = '', phone = '', widgetName) {
        let message = '';
        if (email && !phone) {
            message = this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_SuccessMessage_EmailOnly', widgetName, 'The application was sent to <email>');
        }
        else if (!email && phone) {
            message = this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_SuccessMessage_PhoneOnly', widgetName, 'The application was sent to <phone>');
        }
        else if (email && phone) {
            message = this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_SuccessMessage_EmailAndPhone', widgetName, 'The application was sent to <email> and <phone>');
        }
        return message ? message.replace('<email>', email).replace('<phone>', phone) : '';
    }
    getSuccessAuthCodeMessage(authCode, widgetName) {
        const message = this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_SuccessMessage_AuthCodeMessage', widgetName, 'Authorization code: <b><authCode></b>');
        return message ? message.replace('<authCode>', authCode) : '';
    }
    getRedirectPageTag(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_SuccessMessage_RedirectPageTag', widgetName, PageTags.ADD_NEW_PROFILE);
    }
    getRedirectPageTagText(widgetName) {
        const message = this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_SuccessMessage_RedirectLinkText', widgetName, "View <memberFullName>'s profile");
        const memberFullName = this.profileService.getMemberFullName();
        return message ? message.replace('<memberFullName>', memberFullName) : '';
    }
    getEmailRequiredText(widgetName) {
        return this.formValidationService.errorMessages.requiredEmail() || 'Email address is required.';
    }
    getEmailInvalidText(widgetName) {
        return this.formValidationService.errorMessages.invalidEmail() || 'Format is invalid. Re-enter email address.';
    }
    getPhoneRequiredText(widgetName) {
        return this.formValidationService.errorMessages.requiredPhone() || 'Phone is required.';
    }
    getPhoneInvalidText(widgetName) {
        return this.formValidationService.errorMessages.minPhone() || 'Format is invalid. Re-enter phone number.';
    }
    getCheckBoxesRequiredText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_CheckBoxesRequired', widgetName, 'Select at least one option to send application.');
    }
    getSelectAllButtonText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_SelectAll_Text', widgetName, 'Select all');
    }
    getClearAllButtonText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_ClearAll_Text', widgetName, 'Clear all');
    }
    getPlansIncludeText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_PlansIncludedText', widgetName, 'Plan(s) included');
    }
    showPlanDocuments(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_ShowPlanDocuments', widgetName, true);
    }
    getSuccessModal(successModal, email, phone, authCode, nextEnrollmentPlan, isRedirectedFromPlanCompareApi, isSendToBeneficiaryWithoutAgentForPlanCompareApi, widgetName) {
        successModal.componentInstance.title = this.getTitle(widgetName);
        successModal.componentInstance.prompt = this.getSuccessMessage(email, phone, widgetName);
        successModal.componentInstance.closeButton = this.getCloseText(widgetName);
        successModal.componentInstance.subPrompt = this.getSuccessAuthCodeMessage(authCode, widgetName);
        if (!isRedirectedFromPlanCompareApi || !isSendToBeneficiaryWithoutAgentForPlanCompareApi) {
            successModal.componentInstance.redirectPrompt = this.getRedirectPageTagText(widgetName);
        }
        if (nextEnrollmentPlan) {
            const isMedSupEnrollment = this.cartFacade.isMedSupEnrollment(nextEnrollmentPlan.id);
            successModal.componentInstance.continueApplyingButton = this.getContinueApplyingText(widgetName);
            if (isMedSupEnrollment) {
                successModal.componentInstance.crossSellPrompt = this.getMedSupPlanText(widgetName);
            }
            else {
                successModal.componentInstance.crossSellPrompt = this.getPDPPlanText(widgetName);
            }
        }
        return successModal;
    }
    getContinueApplyingText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_ContinueApplying_Text', widgetName, 'Continue Applying');
    }
    getMedSupPlanText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_CrossSell_MedSupPlanText', widgetName, 'Two emails will be sent to the beneficiary to finish this enrollment.</br></br>You have a <b>Medicare Supplement</b> plan in your cart you still need to enroll in.  Click the button below to continue applying in the plan.');
    }
    getPDPPlanText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_CrossSell_PDPPlanText', widgetName, 'Two emails will be sent to the beneficiary to finish this enrollment.</br></br>You have a <b>Prescription Drug plan</b> in your cart you still need to enroll in.  Click the button below to continue applying in the plan.');
    }
    continueApplyingAction(nextEnrollmentPlan) {
        const canSendToBeneficiary = this.canSendToBeneficiary(nextEnrollmentPlan);
        this.shoppingCartCrossSellFacade.prepareAndEnroll(nextEnrollmentPlan, canSendToBeneficiary);
    }
    getSendEnrollmentModal(modal, plans, isRedirectedFromPlanCompareApi, isSendToBeneficiaryWithoutAgentForPlanCompareApi, widgetName) {
        const showEmail = this.getSendApplicationEmailButtonEnabled(widgetName);
        const showPhone = this.getSendApplicationTextMessageButtonEnabled(widgetName);
        if (isRedirectedFromPlanCompareApi && isSendToBeneficiaryWithoutAgentForPlanCompareApi) {
            modal.componentInstance.modalPromptText = showEmail && showPhone ? this.getPrompt(widgetName) : null;
        }
        else {
            modal.componentInstance.modalPromptText =
                this.isSendApplicationEmailEnabled() && this.isSendApplicationTextMessageEnabled() ? this.getPrompt(widgetName) : null;
        }
        const planPermissions = plans.reduce((selectedPlanPermissions, plan) => {
            selectedPlanPermissions[plan.id] = {
                hasPermission: true
            };
            return selectedPlanPermissions;
        }, {});
        modal.componentInstance.modalEmailLabelText = this.getEmailPrompt(widgetName);
        modal.componentInstance.modalPhoneLabelText = this.getPhonePrompt(widgetName);
        modal.componentInstance.modalEmailCheckboxLabelText = this.getEmailCheckBoxPrompt(widgetName);
        modal.componentInstance.modalPhoneCheckboxLabelText = this.getPhoneCheckBoxPrompt(widgetName);
        modal.componentInstance.phoneMask = this.getPhoneMask(widgetName);
        modal.componentInstance.showEmail = showEmail;
        modal.componentInstance.showPhone = showPhone;
        modal.componentInstance.showEmailAndPhoneCheckbox = showEmail && showPhone;
        modal.componentInstance.modalTitleText = this.getTitle(widgetName);
        modal.componentInstance.modalCancelText = this.getCancelText(widgetName);
        modal.componentInstance.modalSendEmailText = this.getSendApplicationText(widgetName);
        modal.componentInstance.emailRequiredError = this.getEmailRequiredText(widgetName);
        modal.componentInstance.emailInvalidError = this.getEmailInvalidText(widgetName);
        modal.componentInstance.phoneRequiredError = this.getPhoneRequiredText(widgetName);
        modal.componentInstance.phoneInvalidError = this.getPhoneInvalidText(widgetName);
        modal.componentInstance.checkBoxRequiredError = this.getCheckBoxesRequiredText(widgetName);
        modal.componentInstance.modalSelectAllButtonText = this.getSelectAllButtonText(widgetName);
        modal.componentInstance.modalSelectNoneButtonText = this.getClearAllButtonText(widgetName);
        modal.componentInstance.isCreateNewProfileEnabled = false;
        modal.componentInstance.authCodeTextOnlyEnabled = this.getAuthCodeTextOnlyEnabled(widgetName);
        modal.componentInstance.quoteLinkEmailOnlyEnabled = this.getQuoteLinkEmailOnlyEnabled(widgetName);
        const showPlanDocuments = this.showPlanDocuments(widgetName);
        if (showPlanDocuments) {
            modal.componentInstance.showPlanDocuments = showPlanDocuments;
            modal.componentInstance.plansIncluded = plans;
            modal.componentInstance.planPermissions = planPermissions;
            modal.componentInstance.modalPlansIncludedLabel = this.getPlansIncludeText(widgetName);
        }
        return modal;
    }
    isRedirectedFromPlanCompareApi() {
        return this.store.selectSnapshot(RuntimeState.isRedirectedFromPlanCompareApi);
    }
    isSendToBeneficiaryWithoutAgentForPlanCompareApi() {
        return this.store.selectSnapshot(RuntimeState.isSendToBeneficiaryWithoutAgentForPlanCompareApi);
    }
    getPCApiStorageId() {
        return this.store.selectSnapshot(RuntimeState.storageId);
    }
}
SendEnrollmentFacade.ɵfac = function SendEnrollmentFacade_Factory(t) { return new (t || SendEnrollmentFacade)(i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(i1.ProfileService), i0.ɵɵinject(i1.SendEnrollmentService), i0.ɵɵinject(i1.NavigationService), i0.ɵɵinject(i1.FormValidationService), i0.ɵɵinject(i1.SiteService), i0.ɵɵinject(i1.PhoneUtilityService), i0.ɵɵinject(PlanFacade), i0.ɵɵinject(i1.ShoppingCartService), i0.ɵɵinject(EnrollmentConfirmationService), i0.ɵɵinject(i1.EnrollmentFormService), i0.ɵɵinject(ShoppingCartCrossSellFacade), i0.ɵɵinject(i2.Store), i0.ɵɵinject(CartFacade), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(SendQuoteFacade), i0.ɵɵinject(i1.PlanCompareApiService)); };
SendEnrollmentFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SendEnrollmentFacade, factory: SendEnrollmentFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SendEnrollmentFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: i1$1.NgbModal }, { type: i1.ProfileService }, { type: i1.SendEnrollmentService }, { type: i1.NavigationService }, { type: i1.FormValidationService }, { type: i1.SiteService }, { type: i1.PhoneUtilityService }, { type: PlanFacade }, { type: i1.ShoppingCartService }, { type: EnrollmentConfirmationService }, { type: i1.EnrollmentFormService }, { type: ShoppingCartCrossSellFacade }, { type: i2.Store }, { type: CartFacade }, { type: i1.MemberSessionService }, { type: SendQuoteFacade }, { type: i1.PlanCompareApiService }]; }, null); })();

class FormRootService {
    constructor(navigationService, configResourceService, enrollmentFormService, modalService, demographicService, planYearResourceService, localeService, plansService, enrollmentFormErrorsContext, demographicHttpService, profileService, memberSessionService, store, profileCryptoService, millimanService, shoppingCartService) {
        this.navigationService = navigationService;
        this.configResourceService = configResourceService;
        this.enrollmentFormService = enrollmentFormService;
        this.modalService = modalService;
        this.demographicService = demographicService;
        this.planYearResourceService = planYearResourceService;
        this.localeService = localeService;
        this.plansService = plansService;
        this.enrollmentFormErrorsContext = enrollmentFormErrorsContext;
        this.demographicHttpService = demographicHttpService;
        this.profileService = profileService;
        this.memberSessionService = memberSessionService;
        this.store = store;
        this.profileCryptoService = profileCryptoService;
        this.millimanService = millimanService;
        this.shoppingCartService = shoppingCartService;
    }
    openMillimanErrorModal(widgetName) {
        const title = this.configResourceService.getProcessedResourceValue('Spa_Milliman_Failed_Title', widgetName, 'Unable to complete transaction');
        const closeText = this.configResourceService.getProcessedResourceValue('Spa_Milliman_Failed_Close', widgetName, 'Close');
        const prompt = this.configResourceService.getProcessedResourceValue('Spa_Milliman_Failed_Prompt', widgetName, 'We are unable to complete the transaction at this time. Please try again later.');
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true });
        confirmationModal.componentInstance.title = title;
        confirmationModal.componentInstance.prompt = prompt;
        confirmationModal.componentInstance.cancelButton = closeText;
        confirmationModal.componentInstance.singleButtonOnCenter = true;
        return confirmationModal;
    }
    async updateFormAnswers(pageIndex, answers, enrollingPlan, isRedirectedFromPlanCompareApi, updateCompleteAction) {
        const enrollingPlanId = enrollingPlan.id;
        if (pageIndex !== null && !isNaN(pageIndex) && answers) {
            const changedRateFactors = this.rateFactorsChanged(answers);
            let validPlan = true;
            // Since plan compare api session only last 30min, can be assumed that plan is valid
            if (changedRateFactors?.length && !isRedirectedFromPlanCompareApi) {
                this.enrollmentFormService.setFormPageLoading$(true, false, enrollingPlanId);
                const planValidationObject = await this.isCurrentPlanValid(answers, enrollingPlanId);
                validPlan = planValidationObject ? planValidationObject.isValid : false;
                this.enrollmentFormService.setFormPageLoading$(false, true, enrollingPlanId);
                if (!validPlan) {
                    this.showPlansValidationModal(planValidationObject).result.then(() => {
                        this.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
                    }, () => { });
                }
            }
            if (validPlan) {
                const updateTransactionRequest = EnrollmentTransactionRequest.createUpdateTransaction(pageIndex, answers, `${this.enrollmentFormService.getSelectedFormType(enrollingPlanId).valueOf()}`);
                this.enrollmentFormService
                    .updateFormTransaction$(updateTransactionRequest, enrollingPlanId)
                    .toPromise()
                    .then(() => {
                    updateCompleteAction();
                });
            }
        }
    }
    showPlansValidationModal(planValidationObject) {
        if (planValidationObject && !planValidationObject.isValid) {
            if (planValidationObject.invalidPlans?.length) {
                const error = planValidationObject.invalidPlans[0].message;
                if (error === PlanErrorMessage.NOT_AVAILABLE) {
                    return this.openPlansNotAvailableModal();
                }
                if (error === PlanErrorMessage.RATES_CHANGED) {
                    return this.openRatesHaveChangedModal();
                }
            }
        }
        return null;
    }
    async updateMemberProfileSession(answers) {
        const profile = this.createProfileStateModel(answers);
        const hasProfileUpdates = profile && Object.keys(profile).length && this.profileService.hasMemberProfileUpdates(profile);
        const hasZipOrFipsUpdates = this.profileService.hasZipOrFipsUpdates();
        if (hasProfileUpdates || hasZipOrFipsUpdates) {
            const sessionId = this.memberSessionService.getMemberSessionId();
            await this.profileService.updateProfileSession(sessionId, profile);
        }
    }
    // eslint-disable-next-line complexity
    createProfileStateModel(answers) {
        const firstName = this.getAnswerValue(answers, 'ApplicantFirstName');
        const lastName = this.getAnswerValue(answers, 'ApplicantLastName');
        const homePhone = this.getAnswerValue(answers, 'ApplicantPhone');
        const cellPhone = this.getAnswerValue(answers, 'ApplicantPhoneMobile');
        const middleInitial = this.getAnswerValue(answers, 'ApplicantMiddleInitial');
        const emailAddress = this.getAnswerValue(answers, 'ApplicantEmailAddress');
        const address1 = this.getAnswerValue(answers, 'ApplicantAddress1');
        const address2 = this.getAnswerValue(answers, 'ApplicantAddress2');
        const city = this.getAnswerValue(answers, 'ApplicantCity');
        const state = this.getAnswerValue(answers, 'ApplicantState');
        const zip = this.getAnswerValue(answers, 'ApplicantZip');
        // no county selection field in form, but it is safe to get it from demographics as it will update the profile
        const countyFips = this.demographicService.getSelectedFipsCode();
        const birthdate = this.getAnswerValue(answers, 'ApplicantBirthDate');
        const applicantGenderInput = this.getAnswerValue(answers, 'ApplicantGender');
        const hicn = this.getAnswerValue(answers, 'ApplicantHICN');
        let gender = null;
        if (applicantGenderInput !== null) {
            gender = this.profileService.getGenderCode(applicantGenderInput);
        }
        const maritalStatus = this.profileService.getMaritalStatusCode(this.getAnswerValue(answers, 'ApplicantMaritalStatus'));
        const profileHICNEncrypted = hicn && this.profileCryptoService.getEncryptedHICN(hicn);
        // checking for !== null here because '' is valid in the case we want to clear a field
        return {
            ...(firstName !== null && { firstName }),
            ...(middleInitial !== null && { middleInitial }),
            ...(lastName !== null && { lastName }),
            ...(emailAddress !== null && { emailAddress }),
            ...(homePhone !== null && { homePhone }),
            ...(cellPhone !== null && { cellPhone }),
            ...(birthdate !== null && { birthdate }),
            ...(gender !== null && { gender }),
            ...(maritalStatus !== null && { maritalStatus }),
            ...(hicn !== null && { hicn: profileHICNEncrypted?.encryptedHICN || '', hicnKeyValue: profileHICNEncrypted?.hicnKeyValue || '' }),
            ...(address1 !== null && {
                addresses: [
                    {
                        address1,
                        ...(address2 !== null && { address2 }),
                        ...(city !== null && { city }),
                        ...(state !== null && { state }),
                        ...(zip !== null && { zip }),
                        ...(countyFips !== null && { countyFips }),
                        isPrimaryAddress: true
                    }
                ]
            })
        };
    }
    getAnswerValue(answers, name) {
        const answer = this.getAnswer(answers, name);
        return answer ? answer.value : null;
    }
    updateEffectiveDatesPartAandB(answers) {
        if (this.getAnswer(answers, 'PartAEffectiveDate') || this.getAnswer(answers, 'PartBEffectiveDate')) {
            const effectiveDates = this.effectiveDatesStateModel(answers);
            if (effectiveDates?.partAEffectiveDate) {
                this.memberSessionService.setPartAEffectiveDate(effectiveDates.partAEffectiveDate);
            }
            if (effectiveDates?.partBEffectiveDate) {
                this.memberSessionService.setPartBEffectiveDate(effectiveDates.partBEffectiveDate);
            }
            const sessionId = this.memberSessionService.getMemberSessionId();
            this.store.dispatch(new UpdateMedigapAnswersSession(sessionId));
        }
    }
    effectiveDatesStateModel(answers) {
        const partAEffectiveDate = this.getAnswerValue(answers, 'PartAEffectiveDate');
        const partBEffectiveDate = this.getAnswerValue(answers, 'PartBEffectiveDate');
        return {
            ...(partAEffectiveDate !== null && { partAEffectiveDate }),
            ...(partBEffectiveDate !== null && { partBEffectiveDate })
        };
    }
    getAnswer(answers, name) {
        return answers.find(answer => answer.name === name);
    }
    // SPA-848 - plans not available modal
    openPlansNotAvailableModal() {
        return this.plansService.openBackToPlansModal(this.configResourceService.getProcessedResourceValue('Spa_Enrollment_Plans_Not_Available_Title') || 'Plan not available', this.configResourceService.getProcessedResourceValue('Spa_Enrollment_Plans_Not_Available_Prompt') ||
            'This plan is no longer available for your service area and will be removed from your cart. Please shop for another plan.', this.configResourceService.getProcessedResourceValue('Spa_Enrollment_Plans_Not_Available_Cancel_Text') || 'Cancel', this.configResourceService.getProcessedResourceValue('Spa_Enrollment_Plans_Not_Available_Go_Back_Text') || 'Back to plans');
    }
    // SPA-848 - rates have changes modal
    openRatesHaveChangedModal() {
        return this.plansService.openBackToPlansModal(this.configResourceService.getProcessedResourceValue('Spa_Enrollment_Rates_Changed_Title') || 'Your rates have changed', this.configResourceService.getProcessedResourceValue('Spa_Enrollment_Rates_Changed_Prompt') ||
            'Due to a change in your ZIP code, the rates have changed for your selected plan. You may accept the new premium rate or return to shopping to select a new plan.', this.configResourceService.getProcessedResourceValue('Spa_Enrollment_Rates_Changed_Cancel_Text') || 'Cancel', this.configResourceService.getProcessedResourceValue('Spa_Enrollment_Rates_Changed_Go_Back_Text') || 'Back to plans');
    }
    rateFactorsChanged(answers) {
        const changedRateFactors = [];
        // TODO: if answers? What about on first page load?
        const applicantZip = this.enrollmentFormService.findAnswer(answers, EnrollmentFormKeys.APPLICANT_ZIP);
        if (applicantZip && applicantZip !== this.demographicService.getSelectedZipCode()) {
            changedRateFactors.push(applicantZip);
        }
        return changedRateFactors;
    }
    async isCurrentPlanValid(answers, enrollingPlan) {
        // const plansToValidate = this.shoppingCartService.getSelectedPlan();
        const plansToValidate = enrollingPlan;
        const zipCode = this.enrollmentFormService.findAnswer(answers, EnrollmentFormKeys.APPLICANT_ZIP);
        const counties = await this.retrieveCounties(zipCode);
        // the plan is no longer valid if we can't find a matching fips or there are multiple fips to choose from
        if (!counties?.length || counties.length > 1) {
            return { isValid: false, invalidPlans: [{ plan: plansToValidate, message: PlanErrorMessage.NOT_AVAILABLE }] };
        }
        const year = this.planYearResourceService.getSelectedPlanYear();
        // const cultureCode = await this.currentLocale$.pipe(take(1)).toPromise();
        const cultureCode = this.localeService.getCurrentLocale();
        const planValidationObject = await this.plansService.validatePlans([plansToValidate], counties[0].countyFIPS, zipCode, year, cultureCode, this.plansService.getMergedMedigapAnswers());
        return planValidationObject;
    }
    processTransactionResponse(transaction, onSuccess) {
        if (transaction.status === EnrollmentTransactionStatus.SUCCESS || transaction.status === EnrollmentTransactionStatus.COMPLETED) {
            onSuccess();
        }
        else if (transaction.status === EnrollmentTransactionStatus.FAIL_COMPLETED && transaction.statusMessage) {
            this.addErrorsAndScroll({
                title: this.getEnrollmentErrorNoticeTitle(),
                messages: [{ message: transaction.statusMessage, severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER }]
            });
        }
        else {
            this.showServerErrors(transaction);
        }
    }
    processNextGenTransactionResponse(transaction, onSuccess) {
        const transactionResponse = transaction;
        const transactionStatus = transactionResponse?.status?.toUpperCase();
        if (transactionStatus === EnrollmentTransactionStatus.SUCCESS || transactionStatus === EnrollmentTransactionStatus.COMPLETED) {
            onSuccess();
        }
        else if (transactionStatus === EnrollmentTransactionStatus.FAIL_COMPLETED && transactionResponse.statusMessage) {
            this.addErrorsAndScroll({
                title: this.getEnrollmentErrorNoticeTitle(),
                messages: [{ message: transactionResponse.statusMessage, severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER }]
            });
        }
        else {
            // TODO: not sure how this will work right now... also may want to refactor the response a bit... not sure as both the start, update and complete responses differ
            this.showServerErrors(transaction);
        }
    }
    addErrorsAndScroll(errors) {
        this.enrollmentFormErrorsContext.addErrors(errors);
        this.enrollmentFormErrorsContext
            .observeForFormErrors$()
            .pipe(take(1))
            .subscribe({
            next: () => {
                this.enrollmentFormErrorsContext.scrollToErrors();
            }
        });
    }
    showServerErrors(transaction) {
        // server errors don't return types so we need to assign one so the notice displays
        const serverErrors = transaction.validations && {
            title: this.getEnrollmentErrorNoticeTitle(),
            messages: transaction.validations.map(validation => ({ severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER, ...validation }))
        };
        this.addErrorsAndScroll(serverErrors);
    }
    getEnrollmentErrorNoticeTitle(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_EnrollmentErrorNotice_Title', widgetName, 'Correct the following error(s) on the form, then submit again');
    }
    async retrieveCounties(zipCode) {
        try {
            const counties = await this.demographicHttpService.retrieveCounties(zipCode);
            return counties;
        }
        catch (error) {
            // We can eventually show an error as well but if no counties are returned they will get an error
            // and be asked to return back to shopping anyways
            // this.showFormErrors([{ message: 'Invalid zip code.' }]);
            return [];
        }
    }
    async processMillimanService(enrollingPlan, childForms) {
        const planId = enrollingPlan.id;
        this.millimanService.setInvokedPlanId(planId);
        const transaction = this.enrollmentFormService.getTransaction(planId);
        await this.millimanService.invokeMillimanService(this.memberSessionService.getMemberSessionId(), transaction.transactionSID, null);
        return await new Promise((resolve, reject) => {
            if (this.millimanService.getMillimanServiceError() !== null) {
                const modalRef = this.openMillimanErrorModal();
                resolve(modalRef);
            }
            else if (this.millimanService.hasMillimanTierChanged()) {
                const newTier = this.millimanService.getMillimanNewTier();
                const newPremium = this.millimanService.getMillimanNewPremium();
                if (newTier) {
                    this.millimanService.updateMillimanUWTierMedigapAnswer(newTier);
                }
                if (newPremium && planId) {
                    this.shoppingCartService.updateCartPlanPremium(planId, newPremium);
                    this.openMillimanRatesHaveChangedModal(newPremium);
                }
                resolve('');
            }
            else {
                reject(new Error(''));
                // TODO: is the maintaining the same functionality... this may not be correct so whoever develops
                // milliman needs to test this and make sure this is correct
                // this.formRootStrategyService.navigateToPage(enrollingPlan, childForms);
            }
        });
    }
    findFirstFocusableInput(answers, document) {
        if (answers?.length) {
            for (const answer of answers) {
                const inputElement = this.findFocusableInput(answer, document);
                if (inputElement) {
                    return inputElement;
                }
            }
        }
        return null;
    }
    convertEnrollmentCallbackMapToJSON() {
        // TODO: (Possibly) make this more generic, where we recursively iterate through XML, and pull out the text values for a node with
        // the specific name we want, ie passing in the resource value and the node name "key"
        // But I find it unlikely we're regularly going to need to be converting XML. With any other use cases we should probably just
        // Use a third party library.
        // This function may break if the structure of the resource ever changes, but the whole process with this across here, HOPE,
        // and the host layer is very complex. This resource was not originally defined for use in vnext libraries, so we need to get
        // more dirty to get it into the shape we need.
        // Example value: '<dictionary>\r\n  <key name="PROVID">PrimaryCarePhysicianID</key>\r\n  <key name="Provider_Name">PrimaryCarePhysician</key>\r\n</dictionary>'
        const resource = this.configResourceService.getProcessedResourceValue('Enrollment_Callback_ReMap', null, '');
        const nodes = new DOMParser().parseFromString(resource, 'text/xml')?.childNodes[0]?.childNodes;
        // The first childNodes will be <dictionary>, so we get the first one and then grab its children, which should be:
        // all the <key> nodes, which are just Elements and the bits that we actually want
        //  or "text" nodes, which are the various /r/n's that are included in the resource for some reason, which we can ignore
        const keyNodes = [];
        // keyNodes[0] (as an html object, not a string) = <key name="PROVID">PrimaryCarePhysicianID</key>
        nodes?.forEach(node => {
            // We've left it with this extra loop instead of a more involved reduce in order to help clarify what's going on with the
            // two different types of nodes and their typing.
            if (node.nodeName === 'key') {
                keyNodes.push(node);
            }
        });
        const xmlAsJSON = keyNodes?.reduce((acc, node) => {
            acc[node.attributes['name'].value] = node.textContent;
            return acc;
        }, {});
        return xmlAsJSON;
    }
    convertFormInputValuesToAnswers(inputValues) {
        // inputValues will be an object like { applicantFirstName: 'Andy', applicantBirthday: '01/01/1900'}
        return inputValues ? Object.entries(inputValues).map(([key, value]) => new Answer(key, value)) : [];
    }
    findFocusableInput(answer, document) {
        const answerName = answer?.name;
        if (answerName) {
            // nextgen-form-renderer
            const formElement = document.querySelector(`[data-name="${answerName}"]`);
            if (formElement) {
                const inputElement = formElement.querySelector('input');
                if (inputElement) {
                    return inputElement;
                }
            }
        }
        return null;
    }
    openMillimanRatesHaveChangedModal(newPremium) {
        let millimanRateChangePrompt = this.configResourceService.getProcessedResourceValue('Spa_Milliman_Rates_Changed_Prompt') ||
            `Based on the information you provided, your new rate is $<millimanNewPremium>. You may continue with this rate or shop for another plan.`;
        millimanRateChangePrompt = millimanRateChangePrompt.replace('<millimanNewPremium>', newPremium.toFixed(2));
        return this.openBackToPlansOrContinueModal(this.configResourceService.getProcessedResourceValue('Spa_Milliman_Rates_Changed_Title') || 'Your rates have changed', millimanRateChangePrompt, this.configResourceService.getProcessedResourceValue('Spa_Milliman_Rates_Changed_ShopAgain_Text') || 'Shop again', this.configResourceService.getProcessedResourceValue('Spa_Milliman_Rates_Changed_Continue_Text') || 'Continue', 
        // this.navigateToPage.bind(this)
        // TODO: need to call the strategie navigate method but we can't without a mediating context because that will cause
        // a circular reference so do that next, this is just a placeholder for now
        // TODO: reference strategy once all references to facade our out of the strategy
        this.enrollmentFormService.navigateTo.bind(this.enrollmentFormService));
    }
    openBackToPlansOrContinueModal(title, prompt, backToPlansText, continueText, confirmAction) {
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true, backdrop: 'static', keyboard: false });
        confirmationModal.componentInstance.title = title;
        confirmationModal.componentInstance.prompt = prompt;
        confirmationModal.componentInstance.cancelButton = backToPlansText;
        confirmationModal.componentInstance.confirmButton = continueText;
        confirmationModal.componentInstance.hideCloseButton = true;
        confirmationModal.componentInstance.cancelAction = () => {
            this.plansService.setOverrideActiveTab(false);
            this.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
        };
        if (confirmAction) {
            confirmationModal.componentInstance.confirmAction = confirmAction;
        }
        return confirmationModal;
    }
}
FormRootService.ɵfac = function FormRootService_Factory(t) { return new (t || FormRootService)(i0.ɵɵinject(i1.NavigationService), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.EnrollmentFormService), i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(i1.DemographicService), i0.ɵɵinject(i1.PlanYearResourceService), i0.ɵɵinject(i1.LocaleService), i0.ɵɵinject(i1.PlansService), i0.ɵɵinject(i1.EnrollmentFormErrorsContext), i0.ɵɵinject(i1.DemographicHttpService), i0.ɵɵinject(i1.ProfileService), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.ProfileCryptoService), i0.ɵɵinject(i1.MillimanService), i0.ɵɵinject(i1.ShoppingCartService)); };
FormRootService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FormRootService, factory: FormRootService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormRootService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.NavigationService }, { type: i1.ConfigResourceService }, { type: i1.EnrollmentFormService }, { type: i1$1.NgbModal }, { type: i1.DemographicService }, { type: i1.PlanYearResourceService }, { type: i1.LocaleService }, { type: i1.PlansService }, { type: i1.EnrollmentFormErrorsContext }, { type: i1.DemographicHttpService }, { type: i1.ProfileService }, { type: i1.MemberSessionService }, { type: i2.Store }, { type: i1.ProfileCryptoService }, { type: i1.MillimanService }, { type: i1.ShoppingCartService }]; }, null); })();

var CustomEventType;
(function (CustomEventType) {
    CustomEventType["ENROLLMENT_NEXT"] = "ENROLLMENT_NEXT";
    CustomEventType["ENROLLMENT_BACK"] = "ENROLLMENT_BACK";
    CustomEventType["SET_FORM_FIELD"] = "SET_FORM_FIELD";
    CustomEventType["ADD_PAGE_LEVEL_ERROR_TO_QUESTION"] = "ADD_PAGE_LEVEL_ERROR_TO_QUESTION";
    CustomEventType["UPLOAD_FILES_RESPONSE"] = "UPLOAD_FILES_RESPONSE";
    CustomEventType["UPLOAD_FILES_ERROR_RESPONSE"] = "UPLOAD_FILES_ERROR_RESPONSE";
    CustomEventType["DELETE_UPLOADED_FILES_RESPONSE"] = "DELETE_UPLOADED_FILES_RESPONSE";
    CustomEventType["DELETE_UPLOADED_FILES_ERROR_RESPONSE"] = "DELETE_UPLOADED_FILES_ERROR_RESPONSE";
    CustomEventType["ADDRESS_AUTOCOMPLETE_RESPONSE"] = "ADDRESS_AUTOCOMPLETE_RESPONSE";
    CustomEventType["ADDRESS_AUTOCOMPLETE_ERROR_RESPONSE"] = "ADDRESS_AUTOCOMPLETE_ERROR_RESPONSE";
    CustomEventType["UPDATE_DYNAMIC_SCRIPTS"] = "UPDATE_DYNAMIC_SCRIPTS";
    CustomEventType["VALIDATE_GROUP"] = "VALIDATE_GROUP";
    CustomEventType["VALIDATE_GROUP_RESPONSE"] = "VALIDATE_GROUP_RESPONSE";
})(CustomEventType || (CustomEventType = {}));

class HOPEBundleFormRootStrategy {
    constructor(enrollmentFormService, navigationContext, millimanService, enrollmentFormErrorsContext, store, router, navigationUtilityService, formRootService) {
        this.enrollmentFormService = enrollmentFormService;
        this.navigationContext = navigationContext;
        this.millimanService = millimanService;
        this.enrollmentFormErrorsContext = enrollmentFormErrorsContext;
        this.store = store;
        this.router = router;
        this.navigationUtilityService = navigationUtilityService;
        this.formRootService = formRootService;
    }
    getCurrentPageName() {
        return this.navigationContext.getUrlParams()?.pageName ?? '';
    }
    getCurrentIndex(enrollingPlanId) {
        const pageName = this.getCurrentPageName();
        return this.enrollmentFormService.getPageIndex(enrollingPlanId, pageName);
    }
    isFirstPage(pageName, enrollingPlanId) {
        return this.enrollmentFormService.getPageIndex(enrollingPlanId, pageName) === 0;
    }
    isLastPage(pageName, enrollingPlanId) {
        const formPages = this.enrollmentFormService.getFormPages(enrollingPlanId);
        return this.enrollmentFormService.getPageIndex(enrollingPlanId, pageName) === formPages.length - 1;
    }
    getFormPages(enrollingPlanId) {
        const HOPEFormPages = this.enrollmentFormService.getFormPages(enrollingPlanId);
        return this.mapToFormPageMetadata(HOPEFormPages);
    }
    getPageLevelValidators(pageIndex) {
        // Page-level validations are handled in HOPEBundle
        return [];
    }
    async runPageLevelValidations(answers, pageIndex) {
        // Page-level validations are handled in HOPEBundle
        return await Promise.resolve([]);
    }
    getCustomEventName(eventType) {
        switch (eventType) {
            case CustomEventType.ENROLLMENT_NEXT:
                return CustomVNextEvents.ENROLLMENT_NEXT;
            case CustomEventType.ENROLLMENT_BACK:
                return CustomVNextEvents.ENROLLMENT_BACK;
            case CustomEventType.SET_FORM_FIELD:
                return CustomVNextEvents.SET_FORM_FIELD;
            default:
        }
    }
    async saveFormAnswers(pageIndex, answers, enrollingPlan, isRedirectedFromPlanCompareApi, childForms) {
        const enrollingPlanId = enrollingPlan.id;
        await this.formRootService.updateFormAnswers(pageIndex, answers, enrollingPlan, isRedirectedFromPlanCompareApi, () => {
            this.formRootService.processTransactionResponse(this.enrollmentFormService.getTransaction(enrollingPlanId), () => {
                this.formRootService.updateMemberProfileSession(answers);
                this.formRootService.updateEffectiveDatesPartAandB(answers);
                this.enrollmentFormService.setPageComplete(pageIndex, enrollingPlanId);
                if (this.millimanService.isMillimanServiceEnabled() &&
                    this.getCurrentPageName() === this.millimanService.getMillimanServiceInvokePageName()) {
                    this.formRootService.processMillimanService(enrollingPlan);
                }
                else {
                    this.navigateToPage(enrollingPlan, childForms);
                }
            });
        });
    }
    navigateToPage(enrollingPlan, childForms) {
        const enrollingPlanId = enrollingPlan.id;
        const transaction = this.enrollmentFormService.getTransaction(enrollingPlanId);
        const currentIndex = this.getCurrentIndex();
        const navIndex = transaction?.pageIndex ? transaction.pageIndex : 0;
        const pagesSkipped = navIndex - currentIndex;
        // TODO: generic form as well?
        if (pagesSkipped === 1) {
            this.enrollmentFormService.setPageSkipped(navIndex, false, enrollingPlanId);
        }
        else if (pagesSkipped > 1) {
            for (let index = currentIndex + 1; index < navIndex; index++) {
                this.enrollmentFormService.setPageSkipped(index, true, enrollingPlanId);
            }
        }
        this.navigateTo(this.enrollmentFormService.getPageName(enrollingPlanId, navIndex), true, childForms, enrollingPlan);
    }
    navigateTo(pageName, setPageVisited = false, childForms, enrollingPlan) {
        const enrollingPlanId = enrollingPlan.id;
        // clear errors right away since if we have new errors they will show up when returned from the API
        this.enrollmentFormErrorsContext.clearFormErrors();
        // if we are navigating to the next page and the viewInitialized subject is persisting from the last page
        // then reset the subject to false so we hide the page as it loads
        if (childForms?.first) {
            childForms.first.viewInitialized$.next(false);
        }
        if (setPageVisited) {
            this.enrollmentFormService.setPageVisited(this.enrollmentFormService.getPageIndex(enrollingPlan.id, pageName), enrollingPlan.id);
        }
        const enrollmentPage = this.store.selectSnapshot(AppConfigState.hrefByTag(PageTags.ENROLLMENT));
        if (pageName) {
            const nextPageHtml = this.enrollmentFormService.getFormPageHtml(enrollingPlanId, pageName);
            const nextPageDirty = this.enrollmentFormService.getFormPageDirty(enrollingPlanId, pageName);
            if (!nextPageHtml || nextPageDirty) {
                this.enrollmentFormService
                    .fetchPageHtml$(this.enrollmentFormService.getPageIndex(enrollingPlanId, pageName), enrollingPlanId)
                    .toPromise()
                    .then(() => {
                    this.router.navigate([enrollmentPage, pageName]);
                    this.navigationUtilityService.setFocusToMainContent();
                });
            }
            else {
                this.router.navigate([enrollmentPage, pageName]);
                this.navigationUtilityService.setFocusToMainContent();
            }
        }
    }
    formHasQuestion(questionName, existingAnswerValue) {
        return existingAnswerValue !== null;
    }
    mapToFormPageMetadata(HOPEFormPages, enrollingPlanId) {
        return HOPEFormPages.map(hopeFormPage => ({
            index: hopeFormPage.pageIndex,
            pageName: hopeFormPage.pageName,
            visited: hopeFormPage.visited,
            completed: hopeFormPage.completed,
            skipped: hopeFormPage.skipped,
            friendlyName: hopeFormPage.friendlyName,
            active: this.getCurrentIndex(enrollingPlanId) === hopeFormPage.pageIndex,
            status: this.getCompletionStatus(hopeFormPage.completed, this.getCurrentIndex(enrollingPlanId) === hopeFormPage.pageIndex, hopeFormPage.skipped),
            validators: [] // Page-level validators are handled in HOPEBundle
        }));
    }
    // TODO: refactor this eventually because we re-use it two places
    getCompletionStatus(isComplete, isActive, isSkipped) {
        if (isActive) {
            return 'active';
        }
        if (isComplete) {
            return 'complete';
        }
        if (isSkipped) {
            return 'skipped';
        }
        return '';
    }
}
HOPEBundleFormRootStrategy.ɵfac = function HOPEBundleFormRootStrategy_Factory(t) { return new (t || HOPEBundleFormRootStrategy)(i0.ɵɵinject(i1.EnrollmentFormService), i0.ɵɵinject(i1.NavigationContext), i0.ɵɵinject(i1.MillimanService), i0.ɵɵinject(i1.EnrollmentFormErrorsContext), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(i1.NavigationUtilityService), i0.ɵɵinject(FormRootService)); };
HOPEBundleFormRootStrategy.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HOPEBundleFormRootStrategy, factory: HOPEBundleFormRootStrategy.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HOPEBundleFormRootStrategy, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.EnrollmentFormService }, { type: i1.NavigationContext }, { type: i1.MillimanService }, { type: i1.EnrollmentFormErrorsContext }, { type: i2.Store }, { type: i2$1.Router }, { type: i1.NavigationUtilityService }, { type: FormRootService }]; }, null); })();

class FormRootStrategyService {
    // injecting hopeBundle strategy by default
    constructor(hopeBundleFormRootStrategy, injector) {
        this.hopeBundleFormRootStrategy = hopeBundleFormRootStrategy;
        this.injector = injector;
        this.strategy = hopeBundleFormRootStrategy;
    }
    setStrategy(strategyType) {
        this.strategy = this.injector.get(strategyType);
    }
    getCurrentIndex(enrollingPlanId) {
        return this.strategy.getCurrentIndex(enrollingPlanId);
    }
    getCurrentPageName() {
        return this.strategy.getCurrentPageName();
    }
    isFirstPage(pageName, enrollingPlanId) {
        return this.strategy.isFirstPage(pageName, enrollingPlanId);
    }
    isLastPage(pageName, enrollingPlanId) {
        return this.strategy.isLastPage(pageName, enrollingPlanId);
    }
    getFormPages(enrollingPlanId) {
        return this.strategy.getFormPages(enrollingPlanId);
    }
    getPageLevelValidators(pageIndex) {
        return this.strategy.getPageLevelValidators(pageIndex);
    }
    async runPageLevelValidations(answers, pageIndex, isDSNPPlan = false) {
        return await this.strategy.runPageLevelValidations(answers, pageIndex, isDSNPPlan);
    }
    dispatchEvent(originatingElement, eventType, detail) {
        const customEventName = this.strategy.getCustomEventName(eventType);
        if (customEventName) {
            const eventInitDict = { bubbles: true };
            if (detail) {
                eventInitDict.detail = detail;
            }
            originatingElement.dispatchEvent(new CustomEvent(customEventName, eventInitDict));
        }
    }
    async saveFormAnswers(pageIndex, answers, enrollingPlan, isRedirectedFromPlanCompareApi, childForms) {
        await this.strategy.saveFormAnswers(pageIndex, answers, enrollingPlan, isRedirectedFromPlanCompareApi, childForms);
    }
    navigateTo(pageName, setPageVisited, childForms, enrollingPlan) {
        this.strategy.navigateTo(pageName, setPageVisited, childForms, enrollingPlan);
    }
    formHasQuestion(questionName, existingAnswerValue, nextGenQuestionNames) {
        return this.strategy.formHasQuestion(questionName, existingAnswerValue, nextGenQuestionNames);
    }
}
FormRootStrategyService.ɵfac = function FormRootStrategyService_Factory(t) { return new (t || FormRootStrategyService)(i0.ɵɵinject(HOPEBundleFormRootStrategy), i0.ɵɵinject(i0.Injector)); };
FormRootStrategyService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FormRootStrategyService, factory: FormRootStrategyService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormRootStrategyService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: HOPEBundleFormRootStrategy }, { type: i0.Injector }]; }, null); })();

class EnrollmentFormFacade {
    constructor(configResourceService, sendEnrollmentFacade, enrollmentFormService, store, cartFacade, globalFacade, enrollmentPostBackService, modalService, navigationService, demographicService, planYearResourceService, planFacade, localeService, plansService, demographicHttpService, enrollmentFormErrorsContext, millimanService, memberSessionService, profileService, profileCryptoService, formRootService, formRootStrategyService) {
        this.configResourceService = configResourceService;
        this.sendEnrollmentFacade = sendEnrollmentFacade;
        this.enrollmentFormService = enrollmentFormService;
        this.store = store;
        this.cartFacade = cartFacade;
        this.globalFacade = globalFacade;
        this.enrollmentPostBackService = enrollmentPostBackService;
        this.modalService = modalService;
        this.navigationService = navigationService;
        this.demographicService = demographicService;
        this.planYearResourceService = planYearResourceService;
        this.planFacade = planFacade;
        this.localeService = localeService;
        this.plansService = plansService;
        this.demographicHttpService = demographicHttpService;
        this.enrollmentFormErrorsContext = enrollmentFormErrorsContext;
        this.millimanService = millimanService;
        this.memberSessionService = memberSessionService;
        this.profileService = profileService;
        this.profileCryptoService = profileCryptoService;
        this.formRootService = formRootService;
        this.formRootStrategyService = formRootStrategyService;
    }
    getShoppingCartApplyButtonText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_ShoppingCart_ApplyButton_Text', widgetName, 'Continue to apply');
    }
    getSendEnrollmentApplicationButtonText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SendEnrollment_EnrollForm_Button_Text', widgetName, 'Send to beneficiary');
    }
    getEnrollmentPermissionDeniedTooltipText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_EnrollerButton_Tooltip_Text', widgetName, "You don't have permission to take this action.");
    }
    getPreviousText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Previous', widgetName, 'Previous');
    }
    getNextText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Next', widgetName, 'Next');
    }
    getSubmitText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Submit', widgetName, 'Submit');
    }
    getSaveText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Enrollment_SaveProgress_Text', widgetName, 'Save progress');
    }
    getContinueToVoiceSignatureText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Enrollment_ContinueToVoiceSignature_Text', widgetName, 'Continue to voice signature');
    }
    getVoiceSignatureCompletedText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Enrollment_VoiceSignatureCompleted_Text', widgetName, 'Signature recorded');
    }
    getContinueToAuthorizationCodeSignatureText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Enrollment_ContinueToAuthorizationCodeSignature_Text', widgetName, 'Continue to electronic signature');
    }
    getAuthorizationCodeSignatureCompletedText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Enrollment_AuthorizationCodeSignatureCompleted_Text', widgetName, 'Signature authorized');
    }
    getConsumerBrokerToggleEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_ShoppingCart_ConsumerBroker_Toggle_Enabled', widgetName, true);
    }
    canSendApplicationToBeneficiary(plan) {
        // const selectedPlan = this.cartFacade.getSelectedPlan();
        return this.sendEnrollmentFacade.canSendToBeneficiary(plan);
    }
    showSendEnrollmentModal() {
        this.sendEnrollmentFacade.showSendEnrollmentModal();
    }
    updateSelectedFormType$(formType = EnrollmentFormType.LONG, planId) {
        return this.enrollmentFormService.updateSelectedFormType$(formType, planId);
    }
    updateUserFormType$(userFormType, planId) {
        return this.enrollmentFormService.updateUserFormType$(userFormType, planId);
    }
    getSelectedFormType(planId) {
        return this.store.selectSnapshot(EnrollmentState.selectedFormType(planId));
    }
    getSelectedFormType$(planId) {
        return this.store.select(EnrollmentState.selectedFormType(planId));
    }
    getTransaction$(planId) {
        return this.store.select(EnrollmentState.transaction(planId));
    }
    getMemberEnrollment$(planId) {
        return this.store.select(MemberState.memberEnrollmentByPlanId(planId));
    }
    getEnrollDiplayMessages$(planId) {
        return this.enrollmentFormService.planHasNextGenForm$(planId).pipe(switchMap(planHasNextGenForm => {
            return planHasNextGenForm
                ? this.enrollmentFormService.getNextGenTransaction$(planId).pipe(map(transaction => transaction?.enrollDisplay))
                : this.getTransaction$(planId).pipe(map(transaction => transaction?.enrollDisplay));
        }), switchMap(enrollDisplay => {
            return combineLatest([of(enrollDisplay), this.getMemberEnrollment$(planId)]);
        }), map(([enrollDisplay, memberEnrollment]) => {
            if (enrollDisplay) {
                return this.getAgentEnrollDisplayMessages(Object.keys(enrollDisplay), enrollDisplay);
            }
            const memberEnrollmentEnrollDisplay = memberEnrollment?.enrollDisplay;
            if (memberEnrollmentEnrollDisplay) {
                return this.getAgentEnrollDisplayMessages(Object.keys(memberEnrollmentEnrollDisplay), memberEnrollmentEnrollDisplay);
            }
            return [];
        }));
    }
    getUserFormType(planId) {
        return this.store.selectSnapshot(EnrollmentState.selectedUserFormType(planId));
    }
    getUserFormType$(planId) {
        return this.enrollmentFormService.getUserFormType$(planId);
    }
    getUserType(planId) {
        return this.store.selectSnapshot(MemberState.memberEnrollmentByPlanId(planId))?.userType;
    }
    closeTooltip(tooltip, wait) {
        this.globalFacade.closeTooltip(tooltip, wait);
    }
    isPPCSite() {
        return this.cartFacade.isPPCSite();
    }
    getConfirmationPostBackEnabled() {
        return this.enrollmentPostBackService.getConfirmationPostBackEnabled();
    }
    getConfirmationPostBackUrl() {
        return this.enrollmentPostBackService.getConfirmationPostBackUrl();
    }
    isAgentFormType(planId) {
        const currentUserFormType = this.store.selectSnapshot(EnrollmentState.selectedUserFormType(planId));
        if (currentUserFormType === UserTypeKeys.CONSUMER) {
            return false;
        }
        return true;
    }
    validateMatchingShortForm(planId, shortFormSettings) {
        this.enrollmentFormService.validateMatchingShortForm(planId, shortFormSettings);
    }
    validateMatchingLongForm(planId, longFormSettings) {
        this.enrollmentFormService.validateMatchingLongForm(planId, longFormSettings);
    }
    getEnrollingPlanPremium(activePlanId) {
        const shoppingCartPlans = this.store.selectSnapshot(ShoppingCartState.selectCartAPIState) || [];
        const cartPlan = shoppingCartPlans.length && activePlanId ? shoppingCartPlans.find(plan => plan.planId === activePlanId) : null;
        return cartPlan?.premium ? cartPlan.premium.toFixed(2).toString() : '0';
    }
    showExternalEnrollmentErrorsModal(innerError) {
        const confirmationModal = this.modalService.open(HtmlConfirmationModalComponent, { centered: true });
        confirmationModal.componentInstance.modalHeader =
            this.configResourceService.getProcessedResourceValue('Spa_Humana_API_Error_Modal_Title') || 'Unable to process application';
        let modalContent = '';
        switch (innerError.Detail) {
            // This fall through is intentional, both cases intend to use the same key.
            case HumanaApiErrorTypes.FIXABLE:
            case ExternalApiErrorTypes.EXTERNAL_API_INTEGRATION_FIXABLE_ERROR:
                modalContent =
                    this.configResourceService.getProcessedResourceValue('Spa_Humana_API_Fixable_Errors_Body_Text') ||
                        '<p>The error(s) below must be corrected before the application can be submitted.</p>';
                break;
            case HumanaApiErrorTypes.NON_FIXABLE:
                modalContent =
                    this.configResourceService.getProcessedResourceValue('Spa_Humana_API_NonFixable_Errors_Body_Text') ||
                        '<p>We are unable to process your application at this time. Contact your administrator for assistance.</p>';
                break;
            case HumanaApiErrorTypes.MAX_RETRY_ATTEMPTED:
                modalContent =
                    this.configResourceService.getProcessedResourceValue('Spa_Humana_API_Submission_Failed_Body_Text') ||
                        '<p>We are unable to process your request at this time. Please try again later.</p>';
                break;
            case ExternalApiErrorTypes.EXTERNAL_API_INTEGRATION_ERROR:
                confirmationModal.componentInstance.modalHeader = this.configResourceService.getProcessedResourceValue('Spa_External_API_Integration_Error_Modal_Title', null, 'Unable to process your application');
                modalContent =
                    this.configResourceService.getProcessedResourceValue('Spa_External_API_Integration_Error_Body_Text') ||
                        '<p>We are unable to process your request at this time. Please try again later.</p>';
                break;
            default:
                break;
        }
        if (innerError?.ErrorList?.length) {
            modalContent += innerError.ErrorList.map(e => `<p>${e.ErrorDescription}</p>`).join('');
        }
        confirmationModal.componentInstance.modalContent = modalContent;
        confirmationModal.componentInstance.cancelButton = this.configResourceService.getProcessedResourceValue('Spa_Site_Close') || 'Close';
        return confirmationModal;
    }
    isRedirectedFromPlanCompareApi() {
        return this.enrollmentFormService.isRedirectedFromPlanCompareApi();
    }
    isSendToBeneficiaryWithoutAgentForPlanCompareApi() {
        return this.store.selectSnapshot(RuntimeState.isSendToBeneficiaryWithoutAgentForPlanCompareApi);
    }
    getUserTypeKey(siteType) {
        switch (siteType) {
            case SiteType.CONSUMER:
                return UserTypeKeys.CONSUMER;
            case SiteType.BROKER:
                return UserTypeKeys.BROKER;
            case SiteType.CALL_CENTER:
                return UserTypeKeys.CALLCENTER;
            default:
                return null;
        }
    }
    getLatestCompletedEnrollment(enrollmentKey, enrollments) {
        const allMatchingCompletedEnrollments = enrollments?.filter(enrollment => enrollment.planID === enrollmentKey && enrollment.completedWhen);
        if (allMatchingCompletedEnrollments?.length) {
            return allMatchingCompletedEnrollments.sort((a, b) => new Date(b.completedWhen).getTime() - new Date(a.completedWhen).getTime())[0];
        }
        return null;
    }
    getAgentEnrollDisplayMessages(enrollDisplayKeys, enrollDisplay) {
        const agentMsgs = enrollDisplayKeys.filter(key => key.includes('AgentMessage'));
        if (agentMsgs.length) {
            return agentMsgs.map(msgkey => enrollDisplay[msgkey]);
        }
        return [];
    }
}
EnrollmentFormFacade.ɵfac = function EnrollmentFormFacade_Factory(t) { return new (t || EnrollmentFormFacade)(i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(SendEnrollmentFacade), i0.ɵɵinject(i1.EnrollmentFormService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(CartFacade), i0.ɵɵinject(GlobalFacade), i0.ɵɵinject(i1.EnrollmentPostBackService), i0.ɵɵinject(i1$1.NgbModal), i0.ɵɵinject(i1.NavigationService), i0.ɵɵinject(i1.DemographicService), i0.ɵɵinject(i1.PlanYearResourceService), i0.ɵɵinject(PlanFacade), i0.ɵɵinject(i1.LocaleService), i0.ɵɵinject(i1.PlansService), i0.ɵɵinject(i1.DemographicHttpService), i0.ɵɵinject(i1.EnrollmentFormErrorsContext), i0.ɵɵinject(i1.MillimanService), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(i1.ProfileService), i0.ɵɵinject(i1.ProfileCryptoService), i0.ɵɵinject(FormRootService), i0.ɵɵinject(FormRootStrategyService)); };
EnrollmentFormFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EnrollmentFormFacade, factory: EnrollmentFormFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentFormFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: SendEnrollmentFacade }, { type: i1.EnrollmentFormService }, { type: i2.Store }, { type: CartFacade }, { type: GlobalFacade }, { type: i1.EnrollmentPostBackService }, { type: i1$1.NgbModal }, { type: i1.NavigationService }, { type: i1.DemographicService }, { type: i1.PlanYearResourceService }, { type: PlanFacade }, { type: i1.LocaleService }, { type: i1.PlansService }, { type: i1.DemographicHttpService }, { type: i1.EnrollmentFormErrorsContext }, { type: i1.MillimanService }, { type: i1.MemberSessionService }, { type: i1.ProfileService }, { type: i1.ProfileCryptoService }, { type: FormRootService }, { type: FormRootStrategyService }]; }, null); })();

function EnrollDisplayComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "span", 1);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r1 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 1, message_r1, "html"), i0.ɵɵsanitizeHtml);
} }
let EnrollDisplayComponent = class EnrollDisplayComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, enrollmentFormFacade, enrollmentFormService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.enrollmentFormFacade = enrollmentFormFacade;
        this.enrollmentFormService = enrollmentFormService;
        this.enrollDisplayMessages = [];
        this.subscriptions = [];
    }
    ngOnInit() {
        super.ngOnInit();
        const enrollingPlanId = this.enrollmentFormService.getActiveEnrollmentKey();
        this.subscriptions.push(this.enrollmentFormFacade.getEnrollDiplayMessages$(enrollingPlanId).subscribe(enrollDisplayMessages => {
            this.enrollDisplayMessages = enrollDisplayMessages;
            this.cdr.markForCheck();
        }));
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
};
EnrollDisplayComponent.ɵfac = function EnrollDisplayComponent_Factory(t) { return new (t || EnrollDisplayComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(EnrollmentFormFacade), i0.ɵɵdirectiveInject(i1.EnrollmentFormService)); };
EnrollDisplayComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EnrollDisplayComponent, selectors: [["vnext-enroll-display"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], [1, "Spa_Style_Note", 3, "innerHTML"]], template: function EnrollDisplayComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, EnrollDisplayComponent_div_0_Template, 3, 4, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.enrollDisplayMessages);
    } }, dependencies: [i1$2.NgForOf, SafePipe], encapsulation: 2, changeDetection: 0 });
EnrollDisplayComponent = __decorate([
    PlatformWidget
], EnrollDisplayComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollDisplayComponent, [{
        type: Component,
        args: [{ selector: 'vnext-enroll-display', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div *ngFor=\"let message of enrollDisplayMessages\">\r\n  <span class=\"Spa_Style_Note\"\r\n    [innerHTML]=\"message | safe:'html'\"\r\n  ></span>\r\n</div>" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: EnrollmentFormFacade }, { type: i1.EnrollmentFormService }]; }, null); })();

function AgentFormSelectionComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "i", 7);
    i0.ɵɵelementStart(2, "span", 8);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.errorKeyword);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r0.errorText, " ");
} }
class AgentFormSelectionComponent {
    constructor(enrollmentFacade, shoppingCartContextService) {
        this.enrollmentFacade = enrollmentFacade;
        this.shoppingCartContextService = shoppingCartContextService;
        this.userFormType = new EventEmitter();
        this.consumerFormDefault = false;
        this.brokerFormDefault = false;
    }
    ngOnInit() {
        this.items = [
            { display: this.consumerText, value: UserTypeKeys.CONSUMER },
            ...(!this.plan?.enrollViaSTBOnly ? [{ display: this.brokerText, value: UserTypeKeys.BROKER }] : [])
        ];
        if (this.consumerFormDefault) {
            this.defaultToggleValue = UserTypeKeys.CONSUMER;
        }
        // if by accident consumer and broker switches set, default to broker
        if (this.brokerFormDefault) {
            this.defaultToggleValue = UserTypeKeys.BROKER;
        }
        // if value exists in store from previous selection, set it.
        const previousSelection = this.enrollmentFacade.getUserFormType(this.plan.id);
        if (previousSelection) {
            this.defaultToggleValue = previousSelection;
        }
        if (this.defaultToggleValue) {
            this.setUserTypeFormSelection(this.defaultToggleValue);
        }
        this.isValidForEnrollment$ = this.shoppingCartContextService.getIsValidForEnrollment$(this.plan.id);
    }
    optionSelected(event) {
        this.setUserTypeFormSelection(event.data.value);
    }
    setUserTypeFormSelection(selection) {
        this.userFormType.emit(selection);
        // set isValidForEnrollment subject to true
        this.shoppingCartContextService.setIsValidForEnrollment(this.plan.id, true);
    }
}
AgentFormSelectionComponent.ɵfac = function AgentFormSelectionComponent_Factory(t) { return new (t || AgentFormSelectionComponent)(i0.ɵɵdirectiveInject(EnrollmentFormFacade), i0.ɵɵdirectiveInject(ShoppingCartContextService)); };
AgentFormSelectionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentFormSelectionComponent, selectors: [["vnext-agent-form-selection"]], inputs: { consumerFormDefault: "consumerFormDefault", brokerFormDefault: "brokerFormDefault", labelText: "labelText", consumerText: "consumerText", brokerText: "brokerText", plan: "plan", errorText: "errorText", errorKeyword: "errorKeyword" }, outputs: { userFormType: "userFormType" }, features: [i0.ɵɵProvidersFeature([WidgetService, InputResetContextService])], decls: 9, vars: 10, consts: [[1, "row"], ["class", "Spa_Style_Accent2_Color", "role", "alert", 4, "ngIf"], ["id", "brokerFormSelection", "aria-required", "true", 1, "px-0", "col-12", "Spa_Style_Label"], [1, "input-error-asterisk"], [1, "px-0", "pt-2", "col-sm-6", "col-lg-10"], [3, "items", "buttonHeight", "selectedValue", "largerText", "verticalGrow", "ariaLabelledById", "optionSelected"], ["role", "alert", 1, "Spa_Style_Accent2_Color"], ["aria-hidden", "true", 1, "fa", "fa-exclamation-circle", "mr-1"], [1, "sr-only"]], template: function AgentFormSelectionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, AgentFormSelectionComponent_div_1_Template, 5, 2, "div", 1);
        i0.ɵɵpipe(2, "async");
        i0.ɵɵelementStart(3, "div", 2)(4, "span", 3);
        i0.ɵɵtext(5, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 4)(8, "vnext-toggle-select", 5);
        i0.ɵɵlistener("optionSelected", function AgentFormSelectionComponent_Template_vnext_toggle_select_optionSelected_8_listener($event) { return ctx.optionSelected($event); });
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(2, 8, ctx.isValidForEnrollment$));
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1("", ctx.labelText, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("items", ctx.items)("buttonHeight", "36px")("selectedValue", ctx.defaultToggleValue ? ctx.defaultToggleValue : null)("largerText", true)("verticalGrow", true)("ariaLabelledById", "brokerFormSelection");
    } }, dependencies: [i1$2.NgIf, ToggleSelectComponent, IconAriaAttributesDirective, i1$2.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentFormSelectionComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-form-selection', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService, InputResetContextService], template: "<div class=\"row\">\r\n  <div class=\"Spa_Style_Accent2_Color\" *ngIf=\"!(isValidForEnrollment$ | async)\" role=\"alert\">\r\n    <i aria-hidden=\"true\" class=\"fa fa-exclamation-circle mr-1\"></i>\r\n    <span class=\"sr-only\">{{ errorKeyword }}</span\r\n    >{{ errorText }}\r\n  </div>\r\n  <div id=\"brokerFormSelection\" class=\"px-0 col-12 Spa_Style_Label\" aria-required=\"true\">\r\n    <span class=\"input-error-asterisk\">*</span>{{ labelText }}\r\n  </div>\r\n  <div class=\"px-0 pt-2 col-sm-6 col-lg-10\">\r\n    <vnext-toggle-select\r\n      [items]=\"items\"\r\n      [buttonHeight]=\"'36px'\"\r\n      [selectedValue]=\"defaultToggleValue ? defaultToggleValue : null\"\r\n      (optionSelected)=\"optionSelected($event)\"\r\n      [largerText]=\"true\"\r\n      [verticalGrow]=\"true\"\r\n      [ariaLabelledById]=\"'brokerFormSelection'\"\r\n    ></vnext-toggle-select>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: EnrollmentFormFacade }, { type: ShoppingCartContextService }]; }, { userFormType: [{
            type: Output
        }], consumerFormDefault: [{
            type: Input
        }], brokerFormDefault: [{
            type: Input
        }], labelText: [{
            type: Input
        }], consumerText: [{
            type: Input
        }], brokerText: [{
            type: Input
        }], plan: [{
            type: Input
        }], errorText: [{
            type: Input
        }], errorKeyword: [{
            type: Input
        }] }); })();

function EnrollmentCallRecordingActionsComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3)(2, "span", 4);
    i0.ɵɵelement(3, "i", 5);
    i0.ɵɵelementStart(4, "div", 6)(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 7);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "async");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.callEndedText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 2, ctx_r0.elapsedTimeText$));
} }
function EnrollmentCallRecordingActionsComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div")(2, "span", 4);
    i0.ɵɵelement(3, "i", 5);
    i0.ɵɵelementStart(4, "div", 6)(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 7);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "async");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(10, "div")(11, "a", 8);
    i0.ɵɵlistener("click", function EnrollmentCallRecordingActionsComponent_ng_container_3_Template_a_click_11_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.endCall()); });
    i0.ɵɵelementStart(12, "span", 9);
    i0.ɵɵelement(13, "i", 10);
    i0.ɵɵelementStart(14, "span");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("mb-4", !ctx_r1.isInline);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("mr-5", ctx_r1.isInline);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.callInProgressText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 7, ctx_r1.elapsedTimeText$));
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r1.endCallText);
} }
function EnrollmentCallRecordingActionsComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelement(1, "span", 12);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 1, ctx_r2.toStartNewRecordingText, "html"), i0.ɵɵsanitizeHtml);
} }
class EnrollmentCallRecordingActionsComponent {
    constructor(twilioService, cdr, analyticsService, agentCallRecordingFacade) {
        this.twilioService = twilioService;
        this.cdr = cdr;
        this.analyticsService = analyticsService;
        this.agentCallRecordingFacade = agentCallRecordingFacade;
        this.subscriptions = [];
    }
    ngOnInit() {
        this.elapsedTimeText$ = this.twilioService.getElapsedTimeText$();
        this.subscriptions.push(this.twilioService.getConnectionDisconnect$().subscribe(connection => {
            this.hasCallEnded = connection?.status() === Call.State.Closed;
            this.cdr.detectChanges();
            if (this.hasCallEnded && !this.hasCallEndedManually && !this.twilioService.isPreviousDeviceDestroyed) {
                this.analyticsService.googleDataLayerTags = {
                    [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CASE_CALL_RECORDING_CALL_END,
                    [DataLayerGlobalVariable.CALL_RECORDING_END_VIA]: CallRecordingEndVia.DISCONNECTED,
                    [DataLayerGlobalVariable.CALL_RECORDING_TRACKING_ID]: this.agentCallRecordingFacade.getTwilioCallTrackingId(),
                    [DataLayerGlobalVariable.CALL_RECORDING_DURATION]: `${this.twilioService.getCallDurationInSeconds()}`
                };
            }
            this.hasCallEndedManually = false;
        }));
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    endCall() {
        this.twilioService.hangup(true);
        this.hasCallEnded = true;
        this.hasCallEndedManually = true;
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CASE_CALL_RECORDING_CALL_END,
            [DataLayerGlobalVariable.CALL_RECORDING_END_VIA]: CallRecordingEndVia.END_BUTTON,
            [DataLayerGlobalVariable.CALL_RECORDING_TRACKING_ID]: this.agentCallRecordingFacade.getTwilioCallTrackingId(),
            [DataLayerGlobalVariable.CALL_RECORDING_DURATION]: `${this.twilioService.getCallDurationInSeconds()}`
        };
    }
}
EnrollmentCallRecordingActionsComponent.ɵfac = function EnrollmentCallRecordingActionsComponent_Factory(t) { return new (t || EnrollmentCallRecordingActionsComponent)(i0.ɵɵdirectiveInject(i1.TwilioDeviceService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(AgentCallRecordingFacade)); };
EnrollmentCallRecordingActionsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EnrollmentCallRecordingActionsComponent, selectors: [["vnext-call-recording-actions"]], inputs: { isInline: "isInline", callInProgressText: "callInProgressText", endCallText: "endCallText", callEndedText: "callEndedText", toStartNewRecordingText: "toStartNewRecordingText" }, decls: 5, vars: 5, consts: [[1, "pt-2", "pb-3"], [4, "ngIf"], ["class", "Spa_Style_Paragraph", 4, "ngIf"], [1, "mb-2"], [1, "d-flex"], ["aria-hidden", "true", 1, "fas", "fa-phone", "pr-1"], [1, "d-flex", "flex-column"], [1, "Spa_Style_Gray4_Color"], ["role", "button", 1, "end-call-button", 3, "click"], [1, "Spa_Style_Accent2_Color"], ["aria-hidden", "true", 1, "fas", "fa-phone-slash", "pr-1"], [1, "Spa_Style_Paragraph"], [3, "innerHTML"]], template: function EnrollmentCallRecordingActionsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div");
        i0.ɵɵtemplate(2, EnrollmentCallRecordingActionsComponent_ng_container_2_Template, 10, 4, "ng-container", 1);
        i0.ɵɵtemplate(3, EnrollmentCallRecordingActionsComponent_ng_container_3_Template, 16, 9, "ng-container", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, EnrollmentCallRecordingActionsComponent_div_4_Template, 3, 4, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("actions-inline", ctx.isInline);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasCallEnded);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.twilioService.connection && !ctx.hasCallEnded);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.twilioService.connection || ctx.hasCallEnded);
    } }, dependencies: [i1$2.NgIf, IconAriaAttributesDirective, i1$2.AsyncPipe, SafePipe], styles: [".actions-inline[_ngcontent-%COMP%]{display:flex}.end-call-button[_ngcontent-%COMP%]{cursor:pointer}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentCallRecordingActionsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-call-recording-actions', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"pt-2 pb-3\">\r\n  <div [class.actions-inline]=\"isInline\">\r\n    <ng-container *ngIf=\"hasCallEnded\">\r\n      <div class=\"mb-2\">\r\n        <span class=\"d-flex\">\r\n          <i aria-hidden=\"true\" class=\"fas fa-phone pr-1\"></i>\r\n          <div class=\"d-flex flex-column\">\r\n            <span>{{ callEndedText }}</span>\r\n            <div class=\"Spa_Style_Gray4_Color\">{{ elapsedTimeText$ | async }}</div>\r\n          </div>\r\n        </span>\r\n      </div>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"twilioService.connection && !hasCallEnded\">\r\n      <div [class.mb-4]=\"!isInline\">\r\n        <span class=\"d-flex\" [class.mr-5]=\"isInline\">\r\n          <i aria-hidden=\"true\" class=\"fas fa-phone pr-1\"></i>\r\n          <div class=\"d-flex flex-column\">\r\n            <span>{{ callInProgressText }}</span>\r\n            <div class=\"Spa_Style_Gray4_Color\">{{ elapsedTimeText$ | async }}</div>\r\n          </div>\r\n        </span>\r\n      </div>\r\n      <div>\r\n        <a role=\"button\" class=\"end-call-button\" (click)=\"endCall()\">\r\n          <span class=\"Spa_Style_Accent2_Color\">\r\n            <i aria-hidden=\"true\" class=\"fas fa-phone-slash pr-1\"></i>\r\n            <span>{{ endCallText }}</span>\r\n          </span>\r\n        </a>\r\n      </div>\r\n    </ng-container>\r\n  </div>\r\n  <div class=\"Spa_Style_Paragraph\" *ngIf=\"!twilioService.connection || hasCallEnded\">\r\n    <span [innerHTML]=\"toStartNewRecordingText | safe: 'html'\"></span>\r\n  </div>\r\n</div>\r\n", styles: [".actions-inline{display:flex}.end-call-button{cursor:pointer}\n"] }]
    }], function () { return [{ type: i1.TwilioDeviceService }, { type: i0.ChangeDetectorRef }, { type: AnalyticsService }, { type: AgentCallRecordingFacade }]; }, { isInline: [{
            type: Input
        }], callInProgressText: [{
            type: Input
        }], endCallText: [{
            type: Input
        }], callEndedText: [{
            type: Input
        }], toStartNewRecordingText: [{
            type: Input
        }] }); })();

function EnrollmentCallRecordingComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3)(3, "h4", 4);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelement(6, "vnext-call-recording-actions", 5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.Spa_AgentCallRecordingBox_Header);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("callInProgressText", ctx_r0.Spa_AgentCallInProgressAcceptCall_Title)("endCallText", ctx_r0.Spa_AgentCallEndCall_Title)("callEndedText", ctx_r0.Spa_AgentCallEnded_Title)("toStartNewRecordingText", ctx_r0.Spa_AgentCallRecordingBox_ToStartANewCallRecording);
} }
let EnrollmentCallRecordingComponent = class EnrollmentCallRecordingComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, twilioService, agentCallRecordingFacade, enrollmentFormFacade, cartFacade, shoppingCartService, enrollmentFormService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.twilioService = twilioService;
        this.agentCallRecordingFacade = agentCallRecordingFacade;
        this.enrollmentFormFacade = enrollmentFormFacade;
        this.cartFacade = cartFacade;
        this.shoppingCartService = shoppingCartService;
        this.enrollmentFormService = enrollmentFormService;
        this.Spa_AgentCallRecordingBox_Header = 'Call recording';
        this.Spa_AgentCallInProgressAcceptCall_Title = 'Call in progress';
        this.Spa_AgentCallEndCall_Title = 'End call';
        this.Spa_AgentCallEnded_Title = 'Call ended';
        this.Spa_AgentCallRecordingBox_ToStartANewCallRecording = 'To start a new recording, return to the cart.';
        this.isBrokerFormType = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.setAttributes();
    }
    setAttributes() {
        this.isAgentCallRecordingEnabled = this.agentCallRecordingFacade.isAgentCallRecordingEnabled();
        this.hasAgentCallRecordingBeenSkipped$ = this.twilioService.getHasSkippedTheCall$();
        this.isBrokerFormType = this.enrollmentFormFacade.getUserFormType(this.cartFacade.getSelectedPlan()?.id) !== UserTypeKeys.CONSUMER;
        const enrollingPlanId = this.enrollmentFormService.getActiveEnrollmentKey();
        this.isSingleCarrierSite = !this.shoppingCartService.isMultiCarrierSite();
        this.allowsCallRecordingOnMultiCarrierSite =
            !this.isSingleCarrierSite && this.shoppingCartService.allowsCallRecordingOnMultiCarrier(enrollingPlanId);
    }
};
EnrollmentCallRecordingComponent.ɵfac = function EnrollmentCallRecordingComponent_Factory(t) { return new (t || EnrollmentCallRecordingComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.TwilioDeviceService), i0.ɵɵdirectiveInject(AgentCallRecordingFacade), i0.ɵɵdirectiveInject(EnrollmentFormFacade), i0.ɵɵdirectiveInject(CartFacade), i0.ɵɵdirectiveInject(i1.ShoppingCartService), i0.ɵɵdirectiveInject(i1.EnrollmentFormService)); };
EnrollmentCallRecordingComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EnrollmentCallRecordingComponent, selectors: [["vnext-enrollment-call-recording"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 3, consts: [["class", "pl-3 pr-3 pl-md-2 pr-md-2", 4, "ngIf"], [1, "pl-3", "pr-3", "pl-md-2", "pr-md-2"], [1, "container-fluid", "call-recording-wrapper"], [1, "row", "call-recording-header", "Spa_Style_Bold_Weight"], [1, "Spa_Style_H4"], [3, "callInProgressText", "endCallText", "callEndedText", "toStartNewRecordingText"]], template: function EnrollmentCallRecordingComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, EnrollmentCallRecordingComponent_div_0_Template, 7, 5, "div", 0);
        i0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.isAgentCallRecordingEnabled && ctx.isBrokerFormType && (ctx.allowsCallRecordingOnMultiCarrierSite || ctx.isSingleCarrierSite) && !i0.ɵɵpipeBind1(1, 1, ctx.hasAgentCallRecordingBeenSkipped$));
    } }, dependencies: [i1$2.NgIf, EnrollmentCallRecordingActionsComponent, i1$2.AsyncPipe], styles: [".call-recording-wrapper[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px;margin-top:20px;background-color:#fff}.call-recording-header[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray1);border-top:none;padding-left:15px;padding-top:5px;padding-bottom:5px;justify-content:space-between;border-top-left-radius:5px;border-top-right-radius:5px}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], EnrollmentCallRecordingComponent.prototype, "Spa_AgentCallRecordingBox_Header", void 0);
__decorate([
    GlobalResource()
], EnrollmentCallRecordingComponent.prototype, "Spa_AgentCallInProgressAcceptCall_Title", void 0);
__decorate([
    GlobalResource()
], EnrollmentCallRecordingComponent.prototype, "Spa_AgentCallEndCall_Title", void 0);
__decorate([
    GlobalResource()
], EnrollmentCallRecordingComponent.prototype, "Spa_AgentCallEnded_Title", void 0);
__decorate([
    GlobalResource()
], EnrollmentCallRecordingComponent.prototype, "Spa_AgentCallRecordingBox_ToStartANewCallRecording", void 0);
EnrollmentCallRecordingComponent = __decorate([
    PlatformWidget
], EnrollmentCallRecordingComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentCallRecordingComponent, [{
        type: Component,
        args: [{ selector: 'vnext-enrollment-call-recording', providers: [WidgetService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  class=\"pl-3 pr-3 pl-md-2 pr-md-2\"\r\n  *ngIf=\"\r\n    isAgentCallRecordingEnabled &&\r\n    isBrokerFormType &&\r\n    (allowsCallRecordingOnMultiCarrierSite || isSingleCarrierSite) &&\r\n    !(hasAgentCallRecordingBeenSkipped$ | async)\r\n  \"\r\n>\r\n  <div class=\"container-fluid call-recording-wrapper\">\r\n    <div class=\"row call-recording-header Spa_Style_Bold_Weight\">\r\n      <h4 class=\"Spa_Style_H4\">{{ Spa_AgentCallRecordingBox_Header }}</h4>\r\n    </div>\r\n    <div>\r\n      <vnext-call-recording-actions\r\n        [callInProgressText]=\"Spa_AgentCallInProgressAcceptCall_Title\"\r\n        [endCallText]=\"Spa_AgentCallEndCall_Title\"\r\n        [callEndedText]=\"Spa_AgentCallEnded_Title\"\r\n        [toStartNewRecordingText]=\"Spa_AgentCallRecordingBox_ToStartANewCallRecording\"\r\n      ></vnext-call-recording-actions>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".call-recording-wrapper{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px;margin-top:20px;background-color:#fff}.call-recording-header{background-color:var(--static-Spa_Style_Gray1);border-top:none;padding-left:15px;padding-top:5px;padding-bottom:5px;justify-content:space-between;border-top-left-radius:5px;border-top-right-radius:5px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.TwilioDeviceService }, { type: AgentCallRecordingFacade }, { type: EnrollmentFormFacade }, { type: CartFacade }, { type: i1.ShoppingCartService }, { type: i1.EnrollmentFormService }]; }, { Spa_AgentCallRecordingBox_Header: [], Spa_AgentCallInProgressAcceptCall_Title: [], Spa_AgentCallEndCall_Title: [], Spa_AgentCallEnded_Title: [], Spa_AgentCallRecordingBox_ToStartANewCallRecording: [] }); })();

class ConfirmationAgentData {
}
class EnrollmentConfirmationFacade {
    constructor(store, agentService, sessionService, enrollmentFormService) {
        this.store = store;
        this.agentService = agentService;
        this.sessionService = sessionService;
        this.enrollmentFormService = enrollmentFormService;
    }
    getEffectiveDate() {
        return this.store.selectSnapshot(DemographicState.effectiveDate);
    }
    getBrokerData() {
        return {
            fullName: this.agentService.getBrokerFullName(),
            phone: this.agentService.getBrokerPhoneNumber(),
            email: this.agentService.getAgentEmailAddress(),
            agency: this.agentService.getBrokerAgencyName(),
            ext: this.agentService.getAgentExtension()
        };
    }
    getAgentGuid() {
        return this.agentService.getAgentInContextGuid();
    }
    downloadEnrollmentApplicationPDF(passedTransactionID, passedConfirmationNumber) {
        const enrollingPlanId = this.enrollmentFormService.getActiveEnrollmentKey();
        const planHasNextGenForm = this.enrollmentFormService.planHasNextGenForm(enrollingPlanId);
        const { transactionId, confirmationNumber } = this.getDownloadEnrollmentApplicationData(enrollingPlanId, planHasNextGenForm);
        let resolvedTransactionID = passedTransactionID;
        let resolvedConfirmationNumber = passedConfirmationNumber;
        if (!resolvedTransactionID || !resolvedConfirmationNumber) {
            if (transactionId && confirmationNumber) {
                resolvedTransactionID = transactionId;
                resolvedConfirmationNumber = confirmationNumber;
            }
            else {
                const enrollments = this.sessionService.getMemberSession().enrollments;
                const selectedPlans = this.store.selectSnapshot(ShoppingCartState.selectCartAPIState);
                if (enrollments && selectedPlans) {
                    const selectedEnrollment = enrollments.filter(enrollment => selectedPlans.some(plan => enrollment.planID === plan.planId));
                    if (selectedEnrollment?.length) {
                        resolvedTransactionID = selectedEnrollment[0].transactionSID;
                        resolvedConfirmationNumber = selectedEnrollment[0].confirmationNumber;
                    }
                }
            }
        }
        if (resolvedTransactionID && resolvedConfirmationNumber) {
            this.agentService.downloadEnrollmentApplicationPDF(resolvedTransactionID, resolvedConfirmationNumber, planHasNextGenForm);
        }
    }
    getDownloadEnrollmentApplicationData(enrollingPlanId, planHasNextGenForm) {
        const downloadApplicationData = { transactionId: '', confirmationNumber: '' };
        if (planHasNextGenForm) {
            const nextGenTransaction = this.enrollmentFormService.getNextGenTransaction(enrollingPlanId);
            downloadApplicationData.transactionId = nextGenTransaction.transactionGUID;
            downloadApplicationData.confirmationNumber = nextGenTransaction.confirmationNumber;
        }
        else {
            const hopeTransaction = this.enrollmentFormService.getTransaction(enrollingPlanId);
            downloadApplicationData.transactionId = hopeTransaction.transactionSID;
            downloadApplicationData.confirmationNumber = hopeTransaction.confirmationNumber;
        }
        return downloadApplicationData;
    }
}
EnrollmentConfirmationFacade.ɵfac = function EnrollmentConfirmationFacade_Factory(t) { return new (t || EnrollmentConfirmationFacade)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.AgentService), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(i1.EnrollmentFormService)); };
EnrollmentConfirmationFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EnrollmentConfirmationFacade, factory: EnrollmentConfirmationFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentConfirmationFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i2.Store }, { type: i1.AgentService }, { type: i1.MemberSessionService }, { type: i1.EnrollmentFormService }]; }, null); })();

function EnrollmentUnavailableComponent_h3_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.title, " ");
} }
function EnrollmentUnavailableComponent_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 6);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r1.message, "html"), i0.ɵɵsanitizeHtml);
} }
function EnrollmentUnavailableComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function EnrollmentUnavailableComponent_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.viewPlanDetails()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.button, " ");
} }
class EnrollmentUnavailableComponent {
    constructor(navigationService) {
        this.navigationService = navigationService;
    }
    viewPlanDetails() {
        this.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
    }
}
EnrollmentUnavailableComponent.ɵfac = function EnrollmentUnavailableComponent_Factory(t) { return new (t || EnrollmentUnavailableComponent)(i0.ɵɵdirectiveInject(i1.NavigationService)); };
EnrollmentUnavailableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EnrollmentUnavailableComponent, selectors: [["vnext-enrollment-unavailable"]], inputs: { button: "button", title: "title", message: "message" }, decls: 5, vars: 3, consts: [[1, "content"], ["aria-hidden", "true", 1, "fa", "fa-ban"], ["class", "Spa_Style_H3 mt-3", 4, "liveEditProp"], ["class", "message Spa_Style_Paragraph", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["class", "btn Spa_Style_PrimaryButton", 3, "click", 4, "liveEditProp"], [1, "Spa_Style_H3", "mt-3"], ["navigationAdapter", "", 1, "message", "Spa_Style_Paragraph", 3, "innerHtml"], [1, "btn", "Spa_Style_PrimaryButton", 3, "click"]], template: function EnrollmentUnavailableComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "i", 1);
        i0.ɵɵtemplate(2, EnrollmentUnavailableComponent_h3_2_Template, 2, 1, "h3", 2);
        i0.ɵɵtemplate(3, EnrollmentUnavailableComponent_p_3_Template, 2, 4, "p", 3);
        i0.ɵɵtemplate(4, EnrollmentUnavailableComponent_button_4_Template, 2, 1, "button", 4);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_ShoppingCart_EnrollmentUnavailable_Title");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_ShoppingCart_EnrollmentUnavailable_Message");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_ShoppingCart_EnrollmentUnavailable_Button");
    } }, dependencies: [NavigationAdapterDirective, LiveEditPropDirective, IconAriaAttributesDirective, SafePipe], styles: [".content[_ngcontent-%COMP%]{text-align:center;padding-top:120px}.content[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{font-size:48px;color:var(--static-Spa_Style_Accent1)}button[_ngcontent-%COMP%]{font-family:montserrat_bold}@media (max-width: 768px){.title[_ngcontent-%COMP%]{font-size:var(--Spa_Style_Large_Font)}.message[_ngcontent-%COMP%]{font-size:var(--Spa_Style_Regular_Font);text-align:left}button[_ngcontent-%COMP%]{font-family:montserratregular;width:100%}}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], EnrollmentUnavailableComponent.prototype, "viewPlanDetails", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentUnavailableComponent, [{
        type: Component,
        args: [{ selector: 'vnext-enrollment-unavailable', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"content\">\r\n  <i class=\"fa fa-ban\" aria-hidden=\"true\"></i>\r\n  <h3 class=\"Spa_Style_H3 mt-3\" *liveEditProp=\"'Spa_ShoppingCart_EnrollmentUnavailable_Title'\">\r\n    {{ title }}\r\n  </h3>\r\n  <p\r\n    class=\"message Spa_Style_Paragraph\"\r\n    *liveEditProp=\"'Spa_ShoppingCart_EnrollmentUnavailable_Message'\"\r\n    [innerHtml]=\"message | safe: 'html'\"\r\n    navigationAdapter\r\n  ></p>\r\n  <button class=\"btn Spa_Style_PrimaryButton\" *liveEditProp=\"'Spa_ShoppingCart_EnrollmentUnavailable_Button'\" (click)=\"viewPlanDetails()\">\r\n    {{ button }}\r\n  </button>\r\n</div>\r\n", styles: [".content{text-align:center;padding-top:120px}.content>i{font-size:48px;color:var(--static-Spa_Style_Accent1)}button{font-family:montserrat_bold}@media (max-width: 768px){.title{font-size:var(--Spa_Style_Large_Font)}.message{font-size:var(--Spa_Style_Regular_Font);text-align:left}button{font-family:montserratregular;width:100%}}\n"] }]
    }], function () { return [{ type: i1.NavigationService }]; }, { button: [{
            type: Input
        }], title: [{
            type: Input
        }], message: [{
            type: Input
        }], viewPlanDetails: [] }); })();

var DifferenceTypeToSubmitHRA;
(function (DifferenceTypeToSubmitHRA) {
    DifferenceTypeToSubmitHRA["REMAINING"] = "REMAINING";
    DifferenceTypeToSubmitHRA["PASSED"] = "PASSED";
})(DifferenceTypeToSubmitHRA || (DifferenceTypeToSubmitHRA = {}));

class HRAFormFacade {
    constructor(genericFormService, enrollmentFormService, configResourceService, globalFacade, localeService, navigationService, formRootService, store) {
        this.genericFormService = genericFormService;
        this.enrollmentFormService = enrollmentFormService;
        this.configResourceService = configResourceService;
        this.globalFacade = globalFacade;
        this.localeService = localeService;
        this.navigationService = navigationService;
        this.formRootService = formRootService;
        this.store = store;
    }
    getTransaction(formId) {
        return this.enrollmentFormService.getTransaction(formId);
    }
    getCurrentLocale$() {
        return this.localeService.getCurrentLocale$();
    }
    getFormLoading$(formId) {
        return this.enrollmentFormService.getFormLoading$(formId);
    }
    getPageInfos(formId) {
        return this.genericFormService.getPageInfos(formId);
    }
    getPageHtml(formId, pageName) {
        return this.enrollmentFormService.getFormPageHtml(formId, pageName);
    }
    getPageHtml$(formId, pageName) {
        return this.enrollmentFormService.getFormPageHtml$(formId, pageName);
    }
    getSubmitText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_HRAForm_SubmitButton_Text', widgetName, 'Submit');
    }
    getPreviousText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Previous', widgetName, 'Previous');
    }
    getNextText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_EnrollmentConfirmation_ContinueAssessment_Text', widgetName, 'Continue assessment');
    }
    getPageIndex(formId, pageName) {
        return this.genericFormService.getPageIndex(formId, pageName);
    }
    getPageName(formId, pageIndex) {
        return this.genericFormService.getPageName(formId, pageIndex);
    }
    getPageDirty(formId, pageName) {
        return this.enrollmentFormService.getFormPageDirty(formId, pageName);
    }
    setPageVisited(formId, pageName) {
        const pageIndex = this.getPageIndex(formId, pageName);
        this.enrollmentFormService.setPageVisited(pageIndex, formId);
    }
    setPageComplete(pageName, formId) {
        const pageIndex = this.getPageIndex(formId, pageName);
        this.enrollmentFormService.setPageComplete(pageIndex, formId);
    }
    setFormPageLoading$(loading, loaded, formId) {
        return this.enrollmentFormService.setFormPageLoading$(loading, loaded, formId);
    }
    fetchPageHtml$(formId, pageName, locale) {
        return this.genericFormService.fetchPageHtmlByName$(formId, pageName, locale);
    }
    closeTooltip(tooltip, wait) {
        this.globalFacade.closeTooltip(tooltip, wait);
    }
    getFormType(formId) {
        return this.enrollmentFormService.getSelectedFormType(formId).valueOf();
    }
    observeForNavigationEvent$() {
        return this.enrollmentFormService.observeForNavigationEvent$();
    }
    updateTransaction$(pageIndex, answers, formType, formId, locale) {
        const langId = locale ? LocaleService.LOCALE_ALIAS_ID[locale] : null;
        const updateTransactionRequest = EnrollmentTransactionRequest.createUpdateTransaction(pageIndex, answers, formType, langId);
        return this.genericFormService.updateTransaction$(updateTransactionRequest, formId);
    }
    completeEnrollment$(transactionAnswers, formId, widgetName) {
        return from(this.genericFormService.completeEnrollment(transactionAnswers, formId, true, widgetName));
    }
    getEnrollmentErrorNoticeTitle(widgetName) {
        return this.formRootService.getEnrollmentErrorNoticeTitle(widgetName);
    }
    fetchTransaction$(formId) {
        return this.genericFormService.fetchTransaction$(formId);
    }
    getHRAPlan() {
        return this.store.selectSnapshot(EnrollmentState.hraPlan);
    }
    getHRAPlanId() {
        return this.store.selectSnapshot(EnrollmentState.hraPlanId);
    }
    getRemainingDaysToSumbmitHRA(memberEnrollment, hraDaysLeft) {
        return this.getHRADaysDifference(memberEnrollment?.completedWhen, hraDaysLeft, DifferenceTypeToSubmitHRA.REMAINING);
    }
    getHRADaysDifference(enrollmentSubmittedDate, numberOfHRADays, differenceType) {
        if (!numberOfHRADays) {
            return 0;
        }
        let daysDifference = null;
        const submitHRATillDate = DateUtilities.addDays(enrollmentSubmittedDate, numberOfHRADays);
        if (differenceType === DifferenceTypeToSubmitHRA.REMAINING) {
            daysDifference = DateUtilities.getDaysDifference(DateUtilities.getFormattedCurrentDate(), submitHRATillDate, DaysDifferencePrecision.DATE_ONLY);
        }
        else {
            daysDifference = DateUtilities.getDaysDifference(enrollmentSubmittedDate, DateUtilities.getFormattedCurrentDate(), DaysDifferencePrecision.DATE_ONLY);
        }
        return daysDifference;
    }
}
HRAFormFacade.ɵfac = function HRAFormFacade_Factory(t) { return new (t || HRAFormFacade)(i0.ɵɵinject(i1.GenericFormService), i0.ɵɵinject(i1.EnrollmentFormService), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(GlobalFacade), i0.ɵɵinject(i1.LocaleService), i0.ɵɵinject(i1.NavigationService), i0.ɵɵinject(FormRootService), i0.ɵɵinject(i2.Store)); };
HRAFormFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HRAFormFacade, factory: HRAFormFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HRAFormFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.GenericFormService }, { type: i1.EnrollmentFormService }, { type: i1.ConfigResourceService }, { type: GlobalFacade }, { type: i1.LocaleService }, { type: i1.NavigationService }, { type: FormRootService }, { type: i2.Store }]; }, null); })();

function EnrollmentConfirmationHRASectionComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r1.nextStepsTitle, "html"), i0.ɵɵsanitizeHtml);
} }
function EnrollmentConfirmationHRASectionComponent_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 5);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r2.nextStepsBody, "html"), i0.ɵɵsanitizeHtml);
} }
function EnrollmentConfirmationHRASectionComponent_ng_container_0_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 5);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r6.hraAvailableAfterEnrollmentText, "html"), i0.ɵɵsanitizeHtml);
} }
function EnrollmentConfirmationHRASectionComponent_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EnrollmentConfirmationHRASectionComponent_ng_container_0_ng_container_3_div_1_Template, 2, 4, "div", 2);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentConfirmation_HRAAvailableAfterEnrollment_Text");
} }
function EnrollmentConfirmationHRASectionComponent_ng_container_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 6);
    i0.ɵɵelement(2, "i", 7);
    i0.ɵɵelementStart(3, "span", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r4.completeHRADaysLeftText);
} }
function EnrollmentConfirmationHRASectionComponent_ng_container_0_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function EnrollmentConfirmationHRASectionComponent_ng_container_0_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.navigateToHRA()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", !ctx_r5.originalEnrollmentConfirmationNumber || !ctx_r5.transactionGUID);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.hraButtonText, " ");
} }
function EnrollmentConfirmationHRASectionComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EnrollmentConfirmationHRASectionComponent_ng_container_0_div_1_Template, 2, 4, "div", 1);
    i0.ɵɵtemplate(2, EnrollmentConfirmationHRASectionComponent_ng_container_0_div_2_Template, 2, 4, "div", 2);
    i0.ɵɵtemplate(3, EnrollmentConfirmationHRASectionComponent_ng_container_0_ng_container_3_Template, 2, 1, "ng-container", 0);
    i0.ɵɵtemplate(4, EnrollmentConfirmationHRASectionComponent_ng_container_0_div_4_Template, 5, 1, "div", 0);
    i0.ɵɵtemplate(5, EnrollmentConfirmationHRASectionComponent_ng_container_0_button_5_Template, 2, 2, "button", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentConfirmation_NextStepsTitle_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentConfirmation_NextStepsBody_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isLiveEdit || ctx_r0.showHRADaysLeft);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showHRADaysLeft);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentConfirmation_HRAButton_Text");
} }
class EnrollmentConfirmationHRASectionComponent {
    constructor(confirmationService, memberSessionService, hraService, navigationService, siteService, hraFormFacade, modalService, plansService, spinnerService, analyticsService) {
        this.confirmationService = confirmationService;
        this.memberSessionService = memberSessionService;
        this.hraService = hraService;
        this.navigationService = navigationService;
        this.siteService = siteService;
        this.hraFormFacade = hraFormFacade;
        this.modalService = modalService;
        this.plansService = plansService;
        this.spinnerService = spinnerService;
        this.analyticsService = analyticsService;
        this.parseIntRadix = 10;
    }
    ngOnChanges(changes) {
        if (!this.isLiveEdit) {
            const { enrollmentPlan, hraEnabled, enrollmentSubmittedDate, hraDaysLeftText } = changes;
            if ((!enrollmentPlan?.firstChange && !_isEqual(enrollmentPlan?.previousValue, enrollmentPlan?.currentValue)) ||
                (!hraEnabled?.firstChange && hraEnabled?.previousValue !== hraEnabled?.currentValue) ||
                (!enrollmentSubmittedDate?.firstChange && enrollmentSubmittedDate?.previousValue !== enrollmentSubmittedDate?.currentValue) ||
                (!hraDaysLeftText?.firstChange && hraDaysLeftText?.previousValue !== hraDaysLeftText?.currentValue)) {
                this.initializeInstanceVariables();
            }
        }
    }
    ngOnInit() {
        if (this.isLiveEdit) {
            this.showHRASection = this.hraEnabled;
            this.planHRAType = PlanHRAType.INTERNAL;
            this.planHRAUserType = PlanHRAUserType.ALL;
        }
        else {
            this.initializeInstanceVariables();
        }
    }
    navigateToHRA() {
        if (this.redirectUrl) {
            this.openExternalHRAConfirmationModal(this.redirectUrl);
        }
        else {
            this.fetchHRAExternalLink();
        }
    }
    initializeInstanceVariables() {
        this.planHRAType = this.plansService.getExtraDataValueByName(this.enrollmentPlan, PlanExtraDataKey.HRA, PlanHRAType.NONE);
        const isPPCSite = this.siteService.isPPCSite();
        this.planHRAUserType = this.plansService.getExtraDataValueByName(this.enrollmentPlan, PlanExtraDataKey.HRA_USER_TYPE, PlanHRAUserType.NONE);
        this.showHRASection = this.hraEnabled && this.hraTypeMatchesSiteType(this.planHRAType, this.planHRAUserType);
        this.hraDaysLeft = this.remainingHRADays(this.enrollmentSubmittedDate, this.plansService.getExtraDataValueByName(this.enrollmentPlan, PlanExtraDataKey.HRA_COMPLETE_WITHIN_DAYS));
        if (this.hraDaysLeft) {
            this.completeHRADaysLeftText = this.hraDaysLeftText?.replace('<hraDaysLeft>', this.hraDaysLeft.toString());
        }
        this.showHRADaysLeft = isPPCSite && this.completeHRADaysLeftText && this.hraDaysLeft > 0;
    }
    fetchHRAExternalLink() {
        const sessionId = this.memberSessionService.getMemberSessionId();
        if (this.transactionGUID) {
            const extraDataHRAExternalURL = this.plansService.getExtraDataValueByName(this.enrollmentPlan, PlanExtraDataKey.HRA_EXTERNAL_URL);
            // after the enrollment completion, the event "enrollment.loading" is still registered, preventing to show subsequent spinner events
            // resetting the spinner fixes that
            this.spinnerService.reset();
            this.spinnerService.show(SpinnerEvent.EXTERNAL_HRA_LOADING);
            // doesn't require unsubscribe() because it is an HttpClient observable, it will be completed after the request is resolved
            this.hraService.fetchHRAExternalLink$(sessionId, this.enrollmentPlan.id, this.transactionGUID, extraDataHRAExternalURL).subscribe({
                next: (hraExternalResponse) => {
                    this.redirectUrl = hraExternalResponse?.redirectUrl ?? hraExternalResponse;
                    if (this.redirectUrl) {
                        this.openExternalHRAConfirmationModal(this.redirectUrl);
                    }
                    else {
                        this.navigateToInternalHRA(sessionId);
                    }
                    this.spinnerService.hide(SpinnerEvent.EXTERNAL_HRA_LOADING);
                },
                error: () => {
                    this.spinnerService.hide(SpinnerEvent.EXTERNAL_HRA_LOADING);
                }
            });
        }
        else {
            this.navigateToInternalHRA(sessionId);
        }
    }
    navigateToInternalHRA(sessionId) {
        this.logEnterFormEvent();
        this.confirmationService.resetConfirmationState();
        this.hraService.fetchFormIdAndNavigateToInternalHRA(this.enrollmentPlan, this.originalEnrollmentConfirmationNumber, sessionId, this.isPCApiEnrollment, this.transactionGUID);
    }
    openExternalHRAConfirmationModal(redirectUrl) {
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true });
        confirmationModal.componentInstance.title = this.modalTitleText;
        confirmationModal.componentInstance.prompt = this.modalBodyText;
        confirmationModal.componentInstance.cancelButton = this.modalCancelText;
        confirmationModal.componentInstance.confirmButton = this.modalContinueText;
        confirmationModal.componentInstance.confirmAction = () => {
            this.navigateToExternalHRA(redirectUrl);
        };
        return confirmationModal;
    }
    navigateToExternalHRA(redirectUrl) {
        this.logEnterFormEvent();
        const navigationLink = {
            type: LinkType.EXTERNAL,
            title: '',
            href: redirectUrl,
            target: this.openExternalInNewTab ? TargetType.BLANK : TargetType.SELF
        };
        this.navigationService.navigate(navigationLink);
    }
    hraTypeMatchesSiteType(planHRAType, planHRAUserType) {
        if (planHRAUserType === PlanHRAUserType.ALL) {
            return true;
        }
        if (!planHRAType || planHRAType === PlanHRAType.NONE) {
            return false;
        }
        let siteType = this.siteService.getSiteType();
        if (this.isPCApiEnrollment) {
            if (this.enrollmentHRAUserType?.toLocaleLowerCase() === UserTypes.BROKER) {
                siteType = SiteType.BROKER;
            }
            if (this.enrollmentHRAUserType?.toLocaleLowerCase() === UserTypes.CALLCENTER) {
                siteType = SiteType.CALL_CENTER;
            }
        }
        if (siteType === SiteType.CONSUMER) {
            return HRA_CONSUMER_TYPES.includes(planHRAUserType);
        }
        if (siteType === SiteType.BROKER) {
            return HRA_BROKER_TYPES.includes(planHRAUserType);
        }
        if (siteType === SiteType.CALL_CENTER) {
            return HRA_CALL_CENTER_TYPES.includes(planHRAUserType);
        }
        return false;
    }
    logEnterFormEvent() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_HRA_ENTER_FORM
        };
    }
    remainingHRADays(completedWhen, hraDaysLeft) {
        const hraDays = hraDaysLeft ? parseInt(hraDaysLeft, this.parseIntRadix) : 0;
        return this.hraFormFacade.getHRADaysDifference(completedWhen, hraDays, DifferenceTypeToSubmitHRA.REMAINING);
    }
}
EnrollmentConfirmationHRASectionComponent.ɵfac = function EnrollmentConfirmationHRASectionComponent_Factory(t) { return new (t || EnrollmentConfirmationHRASectionComponent)(i0.ɵɵdirectiveInject(EnrollmentConfirmationService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.HRAService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(HRAFormFacade), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(AnalyticsService)); };
EnrollmentConfirmationHRASectionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EnrollmentConfirmationHRASectionComponent, selectors: [["vnext-enrollment-confirmation-hra-section"]], inputs: { hraEnabled: "hraEnabled", nextStepsTitle: "nextStepsTitle", nextStepsBody: "nextStepsBody", hraButtonText: "hraButtonText", hraAvailableAfterEnrollmentText: "hraAvailableAfterEnrollmentText", enrollmentPlan: "enrollmentPlan", modalContinueText: "modalContinueText", modalCancelText: "modalCancelText", modalTitleText: "modalTitleText", modalBodyText: "modalBodyText", isLiveEdit: "isLiveEdit", transactionGUID: "transactionGUID", originalEnrollmentConfirmationNumber: "originalEnrollmentConfirmationNumber", enrollmentHRAUserType: "enrollmentHRAUserType", isPCApiEnrollment: "isPCApiEnrollment", openExternalInNewTab: "openExternalInNewTab", enrollmentSubmittedDate: "enrollmentSubmittedDate", hraDaysLeftText: "hraDaysLeftText" }, features: [i0.ɵɵProvidersFeature([]), i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["class", "Spa_Style_H2", 3, "innerHtml", 4, "liveEditProp"], ["class", "Spa_Style_Paragraph mb-3 mt-2", 3, "innerHtml", 4, "liveEditProp"], ["class", "btn Spa_Style_PrimaryButton", 3, "disabled", "click", 4, "liveEditProp"], [1, "Spa_Style_H2", 3, "innerHtml"], [1, "Spa_Style_Paragraph", "mb-3", "mt-2", 3, "innerHtml"], [1, "col-12", "col-lg-6", "d-flex", "flex-row", "align-items-center", "pl-0", "mb-3", "mt-2", "warn-container"], [1, "fas", "fa-exclamation-triangle"], [1, "ml-1", "mt-1", "Spa_Style_Paragraph"], [1, "btn", "Spa_Style_PrimaryButton", 3, "disabled", "click"]], template: function EnrollmentConfirmationHRASectionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, EnrollmentConfirmationHRASectionComponent_ng_container_0_Template, 6, 5, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showHRASection);
    } }, dependencies: [i1$2.NgIf, LiveEditPropDirective, IconAriaAttributesDirective, SafePipe], styles: [".warning-color[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent4)}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], EnrollmentConfirmationHRASectionComponent.prototype, "navigateToHRA", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentConfirmationHRASectionComponent, [{
        type: Component,
        args: [{ selector: 'vnext-enrollment-confirmation-hra-section', changeDetection: ChangeDetectionStrategy.OnPush, providers: [], template: "<ng-container *ngIf=\"showHRASection\">\r\n  <div\r\n    *liveEditProp=\"'Spa_EnrollmentConfirmation_NextStepsTitle_Text'\"\r\n    class=\"Spa_Style_H2\"\r\n    [innerHtml]=\"nextStepsTitle | safe : 'html'\"\r\n  ></div>\r\n\r\n  <div\r\n    *liveEditProp=\"'Spa_EnrollmentConfirmation_NextStepsBody_Text'\"\r\n    class=\"Spa_Style_Paragraph mb-3 mt-2\"\r\n    [innerHtml]=\"nextStepsBody | safe : 'html'\"\r\n  ></div>\r\n\r\n  <ng-container *ngIf=\"isLiveEdit || showHRADaysLeft\">\r\n    <div\r\n      *liveEditProp=\"'Spa_EnrollmentConfirmation_HRAAvailableAfterEnrollment_Text'\"\r\n      class=\"Spa_Style_Paragraph mb-3 mt-2\"\r\n      [innerHtml]=\"hraAvailableAfterEnrollmentText | safe : 'html'\"\r\n    ></div>\r\n  </ng-container>\r\n  <div *ngIf=\"showHRADaysLeft\">\r\n    <div class=\"col-12 col-lg-6 d-flex flex-row align-items-center pl-0 mb-3 mt-2 warn-container\">\r\n      <i class=\"fas fa-exclamation-triangle\"></i>\r\n      <span class=\"ml-1 mt-1 Spa_Style_Paragraph\">{{ completeHRADaysLeftText }}</span>\r\n    </div>\r\n  </div>\r\n\r\n  <button\r\n    *liveEditProp=\"'Spa_EnrollmentConfirmation_HRAButton_Text'\"\r\n    class=\"btn Spa_Style_PrimaryButton\"\r\n    [disabled]=\"!originalEnrollmentConfirmationNumber || !transactionGUID\"\r\n    (click)=\"navigateToHRA()\"\r\n  >\r\n    {{ hraButtonText }}\r\n  </button>\r\n</ng-container>\r\n", styles: [".warning-color{color:var(--static-Spa_Style_Accent4)}\n"] }]
    }], function () { return [{ type: EnrollmentConfirmationService }, { type: i1.MemberSessionService }, { type: i1.HRAService }, { type: i1.NavigationService }, { type: i1.SiteService }, { type: HRAFormFacade }, { type: i1$1.NgbModal }, { type: i1.PlansService }, { type: i1.SpinnerService }, { type: AnalyticsService }]; }, { hraEnabled: [{
            type: Input
        }], nextStepsTitle: [{
            type: Input
        }], nextStepsBody: [{
            type: Input
        }], hraButtonText: [{
            type: Input
        }], hraAvailableAfterEnrollmentText: [{
            type: Input
        }], enrollmentPlan: [{
            type: Input
        }], modalContinueText: [{
            type: Input
        }], modalCancelText: [{
            type: Input
        }], modalTitleText: [{
            type: Input
        }], modalBodyText: [{
            type: Input
        }], isLiveEdit: [{
            type: Input
        }], transactionGUID: [{
            type: Input
        }], originalEnrollmentConfirmationNumber: [{
            type: Input
        }], enrollmentHRAUserType: [{
            type: Input
        }], isPCApiEnrollment: [{
            type: Input
        }], openExternalInNewTab: [{
            type: Input
        }], enrollmentSubmittedDate: [{
            type: Input
        }], hraDaysLeftText: [{
            type: Input
        }], navigateToHRA: [] }); })();

function EnrollmentConfirmationVBCSectionComponent_div_0_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.messageText, " ");
} }
function EnrollmentConfirmationVBCSectionComponent_div_0_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function EnrollmentConfirmationVBCSectionComponent_div_0_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8.openExternalLink(ctx_r8.primaryButtonLink)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.primaryButtonText, " ");
} }
function EnrollmentConfirmationVBCSectionComponent_div_0_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function EnrollmentConfirmationVBCSectionComponent_div_0_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.openExternalLink(ctx_r10.secondaryButtonLink)); });
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.secondaryButtonText, " ");
} }
function EnrollmentConfirmationVBCSectionComponent_div_0_div_5_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 15)(2, "label", 16)(3, "input", 17);
    i0.ɵɵlistener("change", function EnrollmentConfirmationVBCSectionComponent_div_0_div_5_ng_container_4_Template_input_change_3_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r15.onVbcAttestationCheckboxChange()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 18);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(6, "div", 4)(7, "button", 19);
    i0.ɵɵlistener("click", function EnrollmentConfirmationVBCSectionComponent_div_0_div_5_ng_container_4_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r16); const ctx_r17 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r17.submit(true)); });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r12.confirmationAttestationText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r12.vbcAttestationCheckbox);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.submitButtonText, " ");
} }
function EnrollmentConfirmationVBCSectionComponent_div_0_div_5_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "span", 20);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 4)(4, "button", 21);
    i0.ɵɵlistener("click", function EnrollmentConfirmationVBCSectionComponent_div_0_div_5_ng_template_5_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r18.submit(false)); });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 2, ctx_r14.optOutConsentConfirmationAttestationText, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.optOutSubmitButtonText, " ");
} }
function EnrollmentConfirmationVBCSectionComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "hr");
    i0.ɵɵelementStart(2, "div", 12);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, EnrollmentConfirmationVBCSectionComponent_div_0_div_5_ng_container_4_Template, 9, 3, "ng-container", 13);
    i0.ɵɵtemplate(5, EnrollmentConfirmationVBCSectionComponent_div_0_div_5_ng_template_5_Template, 6, 5, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r13 = i0.ɵɵreference(6);
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.confirmationAttestationProviderText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.optInEnabled)("ngIfElse", _r13);
} }
function EnrollmentConfirmationVBCSectionComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 22);
    i0.ɵɵelement(2, "i", 23);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r7.confirmationSuccessText, " ");
} }
const _c0$2b = function (a0) { return { "mt-4": a0 }; };
function EnrollmentConfirmationVBCSectionComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, EnrollmentConfirmationVBCSectionComponent_div_0_p_1_Template, 2, 1, "p", 3);
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵtemplate(3, EnrollmentConfirmationVBCSectionComponent_div_0_button_3_Template, 2, 1, "button", 5);
    i0.ɵɵtemplate(4, EnrollmentConfirmationVBCSectionComponent_div_0_button_4_Template, 3, 1, "button", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, EnrollmentConfirmationVBCSectionComponent_div_0_div_5_Template, 7, 3, "div", 7);
    i0.ɵɵtemplate(6, EnrollmentConfirmationVBCSectionComponent_div_0_div_6_Template, 4, 1, "div", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0$2b, !ctx_r0.isEnrollmentDetail));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.messageText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.primaryButtonText && ctx_r0.primaryButtonLink);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.secondaryButtonText && ctx_r0.secondaryButtonLink);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.vbcConfirmationAttestationEnabled && !ctx_r0.vbcAttestationSubmitted);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.vbcConfirmationAttestationEnabled && ctx_r0.vbcAttestationSubmitted);
} }
function EnrollmentConfirmationVBCSectionComponent_ng_template_1_div_3_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 15)(2, "label", 16)(3, "input", 17);
    i0.ɵɵlistener("change", function EnrollmentConfirmationVBCSectionComponent_ng_template_1_div_3_ng_container_10_Template_input_change_3_listener() { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r28.onVbcAttestationCheckboxChange()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 33);
    i0.ɵɵpipe(5, "safe");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 4)(7, "button", 19);
    i0.ɵɵlistener("click", function EnrollmentConfirmationVBCSectionComponent_ng_template_1_div_3_ng_container_10_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r29); const ctx_r30 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r30.submit(true)); });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(5, 3, ctx_r25.confirmationAttestationText, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", !ctx_r25.vbcAttestationCheckbox);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r25.submitButtonText, " ");
} }
function EnrollmentConfirmationVBCSectionComponent_ng_template_1_div_3_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "span", 20);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 4)(4, "button", 21);
    i0.ɵɵlistener("click", function EnrollmentConfirmationVBCSectionComponent_ng_template_1_div_3_ng_template_11_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r32); const ctx_r31 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r31.submit(false)); });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 2, ctx_r27.optOutConsentConfirmationAttestationText, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r27.optOutSubmitButtonText, " ");
} }
function EnrollmentConfirmationVBCSectionComponent_ng_template_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 28)(2, "div", 29);
    i0.ɵɵelement(3, "span", 30);
    i0.ɵɵpipe(4, "safe");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 31);
    i0.ɵɵelement(7, "span", 30);
    i0.ɵɵpipe(8, "safe");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, EnrollmentConfirmationVBCSectionComponent_ng_template_1_div_3_ng_container_10_Template, 9, 6, "ng-container", 13);
    i0.ɵɵtemplate(11, EnrollmentConfirmationVBCSectionComponent_ng_template_1_div_3_ng_template_11_Template, 6, 5, "ng-template", null, 32, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r26 = i0.ɵɵreference(12);
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 6, ctx_r20.providerNameLabel, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r20.pcpName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(8, 9, ctx_r20.orgNameLabel, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r20.vbcOrgName, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r20.optInEnabled)("ngIfElse", _r26);
} }
function EnrollmentConfirmationVBCSectionComponent_ng_template_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 22);
    i0.ɵɵelement(2, "i", 23);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r21.confirmationSuccessText, " ");
} }
function EnrollmentConfirmationVBCSectionComponent_ng_template_1_p_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 20);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r22.messageText, "html"), i0.ɵɵsanitizeHtml);
} }
function EnrollmentConfirmationVBCSectionComponent_ng_template_1_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function EnrollmentConfirmationVBCSectionComponent_ng_template_1_button_10_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r33.openExternalLink(ctx_r33.primaryButtonLink)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r23.primaryButtonText, " ");
} }
function EnrollmentConfirmationVBCSectionComponent_ng_template_1_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function EnrollmentConfirmationVBCSectionComponent_ng_template_1_button_11_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r35.openExternalLink(ctx_r35.secondaryButtonLink)); });
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r24.secondaryButtonText, " ");
} }
const _c1$11 = function (a0) { return { "my-4": a0 }; };
function EnrollmentConfirmationVBCSectionComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24)(1, "div", 25);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, EnrollmentConfirmationVBCSectionComponent_ng_template_1_div_3_Template, 13, 12, "div", 7);
    i0.ɵɵtemplate(4, EnrollmentConfirmationVBCSectionComponent_ng_template_1_div_4_Template, 4, 1, "div", 7);
    i0.ɵɵelement(5, "hr");
    i0.ɵɵelementStart(6, "div", 26);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, EnrollmentConfirmationVBCSectionComponent_ng_template_1_p_8_Template, 2, 4, "p", 27);
    i0.ɵɵelementStart(9, "div", 4);
    i0.ɵɵtemplate(10, EnrollmentConfirmationVBCSectionComponent_ng_template_1_button_10_Template, 2, 1, "button", 5);
    i0.ɵɵtemplate(11, EnrollmentConfirmationVBCSectionComponent_ng_template_1_button_11_Template, 3, 1, "button", 6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c1$11, !ctx_r2.isEnrollmentDetail));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.vbcTitle, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.vbcConfirmationAttestationEnabled && !ctx_r2.vbcAttestationSubmitted);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.vbcConfirmationAttestationEnabled && ctx_r2.vbcAttestationSubmitted);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.nextStepLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.messageText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.primaryButtonText && ctx_r2.primaryButtonLink);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.secondaryButtonText && ctx_r2.secondaryButtonLink);
} }
class EnrollmentConfirmationVBCSectionComponent {
    constructor(navigationService, analyticsService) {
        this.navigationService = navigationService;
        this.analyticsService = analyticsService;
        this.isEnrollmentDetail = false;
        this.isDefaultView = true;
        this.optInEnabled = false;
        this.onVbcConfirmationAttestationSubmit = new EventEmitter();
        this.vbcAttestationCheckbox = false;
    }
    ngOnChanges(changes) {
        const { pcpName, vbcOrgName, vbcConfirmationAttestationProviderText, vbcConfirmationAttestationText, vbcOptOutConsentConfirmationAttestationText, optInConfirmationSuccessText, optOutConfirmationSuccessText, optInEnabled } = changes;
        if ((pcpName && pcpName.previousValue !== pcpName.currentValue) ||
            (vbcOrgName && vbcOrgName.previousValue !== vbcOrgName.currentValue) ||
            (vbcConfirmationAttestationProviderText &&
                vbcConfirmationAttestationProviderText.previousValue !== vbcConfirmationAttestationProviderText.currentValue) ||
            (vbcConfirmationAttestationText && vbcConfirmationAttestationText.previousValue !== vbcConfirmationAttestationText.currentValue) ||
            (vbcOptOutConsentConfirmationAttestationText &&
                vbcOptOutConsentConfirmationAttestationText.previousValue !== vbcOptOutConsentConfirmationAttestationText.currentValue) ||
            (optInConfirmationSuccessText && optInConfirmationSuccessText.previousValue !== optInConfirmationSuccessText.currentValue) ||
            (optOutConfirmationSuccessText && optOutConfirmationSuccessText.previousValue !== optOutConfirmationSuccessText.currentValue) ||
            (optInEnabled && optInEnabled.previousValue !== optInEnabled.currentValue)) {
            this.confirmationAttestationProviderText = this.vbcConfirmationAttestationProviderText
                .replace('<pcpName>', this.pcpName)
                .replace('<vbcOrgName>', this.vbcOrgName);
            this.confirmationAttestationText = this.vbcConfirmationAttestationText.replace('<vbcOrgName>', this.vbcOrgName);
            this.optOutConsentConfirmationAttestationText = this.vbcOptOutConsentConfirmationAttestationText.replace('<vbcOrgName>', this.vbcOrgName);
            this.optInConfirmationAttestationSuccessText = this.optInConfirmationSuccessText.replace('<vbcOrgName>', this.vbcOrgName);
            this.optOutConfirmationAttestationSuccessText = this.optOutConfirmationSuccessText.replace('<vbcOrgName>', this.vbcOrgName);
            this.confirmationSuccessText = this.optInEnabled
                ? this.optInConfirmationAttestationSuccessText
                : this.optOutConfirmationAttestationSuccessText;
        }
    }
    openExternalLink(redirectUrl) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: redirectUrl === this.primaryButtonLink
                ? DataLayerEvent.CLICK_VBC_ATTESTATION_SCHEDULE_APPT
                : DataLayerEvent.CLICK_VBC_ATTESTATION_TAKE_TOUR,
            [DataLayerGlobalVariable.VBC_ORG_NAME]: this.vbcOrgName ?? GOOGLE_ANALYTICS_NOT_APPLICABLE
        };
        const navigationLink = {
            type: LinkType.EXTERNAL,
            title: '',
            href: redirectUrl,
            target: TargetType.BLANK
        };
        this.navigationService.navigate(navigationLink);
    }
    onVbcAttestationCheckboxChange() {
        this.vbcAttestationCheckbox = !this.vbcAttestationCheckbox;
    }
    submit(optIn) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_VBC_ATTESTATION_SEND_INFO,
            [DataLayerGlobalVariable.VBC_ORG_NAME]: this.vbcOrgName ?? GOOGLE_ANALYTICS_NOT_APPLICABLE
        };
        this.onVbcConfirmationAttestationSubmit.emit({
            pcpName: this.pcpName,
            vbcOrgName: this.vbcOrgName,
            npi: this.npi,
            vbcid: this.vbcid,
            optin: optIn
        });
    }
}
EnrollmentConfirmationVBCSectionComponent.ɵfac = function EnrollmentConfirmationVBCSectionComponent_Factory(t) { return new (t || EnrollmentConfirmationVBCSectionComponent)(i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.GoogleTagManagerService)); };
EnrollmentConfirmationVBCSectionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EnrollmentConfirmationVBCSectionComponent, selectors: [["vnext-vbc-confirmation-section"]], inputs: { messageText: "messageText", primaryButtonText: "primaryButtonText", secondaryButtonText: "secondaryButtonText", primaryButtonLink: "primaryButtonLink", secondaryButtonLink: "secondaryButtonLink", isEnrollmentDetail: "isEnrollmentDetail", vbcAttestationSubmitted: "vbcAttestationSubmitted", vbcConfirmationAttestationEnabled: "vbcConfirmationAttestationEnabled", vbcConfirmationAttestationProviderText: "vbcConfirmationAttestationProviderText", vbcConfirmationAttestationText: "vbcConfirmationAttestationText", vbcOptOutConsentConfirmationAttestationText: "vbcOptOutConsentConfirmationAttestationText", optInConfirmationSuccessText: "optInConfirmationSuccessText", saveFailedErrorText: "saveFailedErrorText", submitButtonText: "submitButtonText", optOutSubmitButtonText: "optOutSubmitButtonText", pcpName: "pcpName", vbcOrgName: "vbcOrgName", npi: "npi", vbcid: "vbcid", vbcTitle: "vbcTitle", providerNameLabel: "providerNameLabel", orgNameLabel: "orgNameLabel", nextStepLabel: "nextStepLabel", isDefaultView: "isDefaultView", optInEnabled: "optInEnabled", optOutConfirmationSuccessText: "optOutConfirmationSuccessText" }, outputs: { onVbcConfirmationAttestationSubmit: "onVbcConfirmationAttestationSubmit" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 2, consts: [[3, "ngClass", 4, "ngIf", "ngIfElse"], ["updatedView", ""], [3, "ngClass"], ["class", "Spa_Style_Primary_Color", 4, "ngIf"], [1, "row", "align-items-center", "mx-0"], ["class", "btn Spa_Style_PrimaryButton mr-2", 3, "click", 4, "ngIf"], ["class", "btn Spa_Style_Link px-0", 3, "click", 4, "ngIf"], [4, "ngIf"], [1, "Spa_Style_Primary_Color"], [1, "btn", "Spa_Style_PrimaryButton", "mr-2", 3, "click"], [1, "btn", "Spa_Style_Link", "px-0", 3, "click"], [1, "fas", "fa-angle-right"], [1, "Spa_Style_Paragraph", "mb-3", "mt-2"], [4, "ngIf", "ngIfElse"], ["optOutConsentDefaultView", ""], [1, "Spa_Style_Paragraph", "mb-3", "mt-2", "confirmation-checkbox"], ["for", "confirmationCheckbox"], ["id", "confirmationCheckbox", "type", "checkbox", "tabindex", "0", 1, "mr-2", 3, "change"], [1, "label-text"], [1, "btn", "Spa_Style_SecondaryButton", "mr-2", 3, "disabled", "click"], [1, "Spa_Style_Primary_Color", 3, "innerHTML"], [1, "btn", "Spa_Style_SecondaryButton", "mr-2", 3, "click"], [1, "Spa_Style_Paragraph", "mb-3", "mt-2", "text-success", "d-flex", "align-items-baseline"], [1, "fas", "fa-check-circle", "mr-1"], [1, "vbc-container", "px-3", 3, "ngClass"], [1, "Spa_Style_H4"], [1, "Spa_Style_H4", "mb-2"], ["class", "Spa_Style_Primary_Color", 3, "innerHTML", 4, "ngIf"], [1, "row", "my-3"], [1, "col-12", "col-md-6"], [1, "Spa_Style_Bold_Weight", 3, "innerHTML"], [1, "col-12", "col-md-6", "text-right"], ["optOutConsent", ""], [1, "label-text", "Spa_Style_Bold_Weight", 3, "innerHTML"]], template: function EnrollmentConfirmationVBCSectionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, EnrollmentConfirmationVBCSectionComponent_div_0_Template, 7, 8, "div", 0);
        i0.ɵɵtemplate(1, EnrollmentConfirmationVBCSectionComponent_ng_template_1_Template, 12, 10, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.isDefaultView)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, IconAriaAttributesDirective, SafePipe], styles: [".confirmation-checkbox[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{display:flex;align-items:flex-start}.confirmation-checkbox[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{margin-top:1px;min-width:15px}.vbc-container[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Warn_Lighter);padding:15px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentConfirmationVBCSectionComponent, [{
        type: Component,
        args: [{ selector: 'vnext-vbc-confirmation-section', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"isDefaultView; else updatedView\" [ngClass]=\"{ 'mt-4': !isEnrollmentDetail }\">\r\n  <p *ngIf=\"messageText\" class=\"Spa_Style_Primary_Color\">\r\n    {{ messageText }}\r\n  </p>\r\n  <div class=\"row align-items-center mx-0\">\r\n    <button\r\n      *ngIf=\"primaryButtonText && primaryButtonLink\"\r\n      class=\"btn Spa_Style_PrimaryButton mr-2\"\r\n      (click)=\"openExternalLink(primaryButtonLink)\"\r\n    >\r\n      {{ primaryButtonText }}\r\n    </button>\r\n    <button\r\n      *ngIf=\"secondaryButtonText && secondaryButtonLink\"\r\n      class=\"btn Spa_Style_Link px-0\"\r\n      (click)=\"openExternalLink(secondaryButtonLink)\"\r\n    >\r\n      {{ secondaryButtonText }} <i class=\"fas fa-angle-right\"></i>\r\n    </button>\r\n  </div>\r\n\r\n  <div *ngIf=\"vbcConfirmationAttestationEnabled && !vbcAttestationSubmitted\">\r\n    <hr />\r\n    <div class=\"Spa_Style_Paragraph mb-3 mt-2\">\r\n      {{ confirmationAttestationProviderText }}\r\n    </div>\r\n\r\n    <ng-container *ngIf=\"optInEnabled; else optOutConsentDefaultView\">\r\n      <div class=\"Spa_Style_Paragraph mb-3 mt-2 confirmation-checkbox\">\r\n        <label for=\"confirmationCheckbox\">\r\n          <input id=\"confirmationCheckbox\" type=\"checkbox\" class=\"mr-2\" tabindex=\"0\" (change)=\"onVbcAttestationCheckboxChange()\" />\r\n          <span class=\"label-text\">{{ confirmationAttestationText }}</span>\r\n        </label>\r\n      </div>\r\n      <div class=\"row align-items-center mx-0\">\r\n        <button class=\"btn Spa_Style_SecondaryButton mr-2\" [disabled]=\"!vbcAttestationCheckbox\" (click)=\"submit(true)\">\r\n          {{ submitButtonText }}\r\n        </button>\r\n      </div>\r\n    </ng-container>\r\n    <ng-template #optOutConsentDefaultView>\r\n      <div class=\"Spa_Style_Paragraph mb-3 mt-2\">\r\n        <span class=\"Spa_Style_Primary_Color\" [innerHTML]=\"optOutConsentConfirmationAttestationText | safe : 'html'\"></span>\r\n      </div>\r\n      <div class=\"row align-items-center mx-0\">\r\n        <button class=\"btn Spa_Style_SecondaryButton mr-2\" (click)=\"submit(false)\">\r\n          {{ optOutSubmitButtonText }}\r\n        </button>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div *ngIf=\"vbcConfirmationAttestationEnabled && vbcAttestationSubmitted\">\r\n    <div class=\"Spa_Style_Paragraph mb-3 mt-2 text-success d-flex align-items-baseline\">\r\n      <i class=\"fas fa-check-circle mr-1\"></i>{{ confirmationSuccessText }}\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<!-- new -->\r\n<ng-template #updatedView>\r\n  <div class=\"vbc-container px-3\" [ngClass]=\"{ 'my-4': !isEnrollmentDetail }\">\r\n    <div class=\"Spa_Style_H4\">\r\n      {{ vbcTitle }}\r\n    </div>\r\n\r\n    <div *ngIf=\"vbcConfirmationAttestationEnabled && !vbcAttestationSubmitted\">\r\n      <div class=\"row my-3\">\r\n        <div class=\"col-12 col-md-6\">\r\n          <span class=\"Spa_Style_Bold_Weight\" [innerHTML]=\"providerNameLabel | safe : 'html'\"></span> {{ pcpName }}\r\n        </div>\r\n        <div class=\"col-12 col-md-6 text-right\">\r\n          <span class=\"Spa_Style_Bold_Weight\" [innerHTML]=\"orgNameLabel | safe : 'html'\"></span> {{ vbcOrgName }}\r\n        </div>\r\n      </div>\r\n\r\n      <ng-container *ngIf=\"optInEnabled; else optOutConsent\">\r\n        <div class=\"Spa_Style_Paragraph mb-3 mt-2 confirmation-checkbox\">\r\n          <label for=\"confirmationCheckbox\">\r\n            <input id=\"confirmationCheckbox\" type=\"checkbox\" class=\"mr-2\" tabindex=\"0\" (change)=\"onVbcAttestationCheckboxChange()\" />\r\n            <span class=\"label-text Spa_Style_Bold_Weight\" [innerHTML]=\"confirmationAttestationText | safe : 'html'\"></span>\r\n          </label>\r\n        </div>\r\n        <div class=\"row align-items-center mx-0\">\r\n          <button class=\"btn Spa_Style_SecondaryButton mr-2\" [disabled]=\"!vbcAttestationCheckbox\" (click)=\"submit(true)\">\r\n            {{ submitButtonText }}\r\n          </button>\r\n        </div>\r\n      </ng-container>\r\n\r\n      <ng-template #optOutConsent>\r\n        <div class=\"Spa_Style_Paragraph mb-3 mt-2\">\r\n          <span class=\"Spa_Style_Primary_Color\" [innerHTML]=\"optOutConsentConfirmationAttestationText | safe : 'html'\"></span>\r\n        </div>\r\n        <div class=\"row align-items-center mx-0\">\r\n          <button class=\"btn Spa_Style_SecondaryButton mr-2\" (click)=\"submit(false)\">\r\n            {{ optOutSubmitButtonText }}\r\n          </button>\r\n        </div>\r\n      </ng-template>\r\n    </div>\r\n\r\n    <div *ngIf=\"vbcConfirmationAttestationEnabled && vbcAttestationSubmitted\">\r\n      <div class=\"Spa_Style_Paragraph mb-3 mt-2 text-success d-flex align-items-baseline\">\r\n        <i class=\"fas fa-check-circle mr-1\"></i>{{ confirmationSuccessText }}\r\n      </div>\r\n    </div>\r\n\r\n    <hr />\r\n    <div class=\"Spa_Style_H4 mb-2\">{{ nextStepLabel }}</div>\r\n    <p *ngIf=\"messageText\" class=\"Spa_Style_Primary_Color\" [innerHTML]=\"messageText | safe : 'html'\"></p>\r\n    <div class=\"row align-items-center mx-0\">\r\n      <button\r\n        *ngIf=\"primaryButtonText && primaryButtonLink\"\r\n        class=\"btn Spa_Style_PrimaryButton mr-2\"\r\n        (click)=\"openExternalLink(primaryButtonLink)\"\r\n      >\r\n        {{ primaryButtonText }}\r\n      </button>\r\n      <button\r\n        *ngIf=\"secondaryButtonText && secondaryButtonLink\"\r\n        class=\"btn Spa_Style_Link px-0\"\r\n        (click)=\"openExternalLink(secondaryButtonLink)\"\r\n      >\r\n        {{ secondaryButtonText }} <i class=\"fas fa-angle-right\"></i>\r\n      </button>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n", styles: [".confirmation-checkbox label{display:flex;align-items:flex-start}.confirmation-checkbox input{margin-top:1px;min-width:15px}.vbc-container{background-color:var(--static-Spa_Style_Warn_Lighter);padding:15px}\n"] }]
    }], function () { return [{ type: i1.NavigationService }, { type: i1.GoogleTagManagerService }]; }, { messageText: [{
            type: Input
        }], primaryButtonText: [{
            type: Input
        }], secondaryButtonText: [{
            type: Input
        }], primaryButtonLink: [{
            type: Input
        }], secondaryButtonLink: [{
            type: Input
        }], isEnrollmentDetail: [{
            type: Input
        }], vbcAttestationSubmitted: [{
            type: Input
        }], vbcConfirmationAttestationEnabled: [{
            type: Input
        }], vbcConfirmationAttestationProviderText: [{
            type: Input
        }], vbcConfirmationAttestationText: [{
            type: Input
        }], vbcOptOutConsentConfirmationAttestationText: [{
            type: Input
        }], optInConfirmationSuccessText: [{
            type: Input
        }], saveFailedErrorText: [{
            type: Input
        }], submitButtonText: [{
            type: Input
        }], optOutSubmitButtonText: [{
            type: Input
        }], pcpName: [{
            type: Input
        }], vbcOrgName: [{
            type: Input
        }], npi: [{
            type: Input
        }], vbcid: [{
            type: Input
        }], vbcTitle: [{
            type: Input
        }], providerNameLabel: [{
            type: Input
        }], orgNameLabel: [{
            type: Input
        }], nextStepLabel: [{
            type: Input
        }], isDefaultView: [{
            type: Input
        }], optInEnabled: [{
            type: Input
        }], optOutConfirmationSuccessText: [{
            type: Input
        }], onVbcConfirmationAttestationSubmit: [{
            type: Output
        }] }); })();

const _c0$2a = ["emailConfirmationButton"];
const _c1$10 = ["benefitsForHIPPopover"];
function EnrollmentConfirmationComponent_div_0_h1_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.enrollmentConfirmationTitle, " ");
} }
function EnrollmentConfirmationComponent_div_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function EnrollmentConfirmationComponent_div_0_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 33)(2, "span", 34);
    i0.ɵɵelement(3, "i", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.Spa_Confirmation_All_Set_Confirmation_Message, " ");
} }
function EnrollmentConfirmationComponent_div_0_ng_template_7_ng_template_0_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r44.Spa_EnrollmentConfirmation_NoticeBox_Header);
} }
function EnrollmentConfirmationComponent_div_0_ng_template_7_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, EnrollmentConfirmationComponent_div_0_ng_template_7_ng_template_0_span_0_Template, 2, 1, "span", 42);
} if (rf & 2) {
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentConfirmation_NoticeBox_Header");
} }
function EnrollmentConfirmationComponent_div_0_ng_template_7_ng_template_2_p_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 44);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r45.Spa_EnrollmentConfirmation_NoticeBox_Body, " ");
} }
function EnrollmentConfirmationComponent_div_0_ng_template_7_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, EnrollmentConfirmationComponent_div_0_ng_template_7_ng_template_2_p_0_Template, 2, 1, "p", 43);
} if (rf & 2) {
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentConfirmation_NoticeBox_Body");
} }
function EnrollmentConfirmationComponent_div_0_ng_template_7_ng_template_4_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 46);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r46.Spa_EnrollmentConfirmation_CrossSell_NoticeBox_Header, "html"), i0.ɵɵsanitizeHtml);
} }
function EnrollmentConfirmationComponent_div_0_ng_template_7_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, EnrollmentConfirmationComponent_div_0_ng_template_7_ng_template_4_div_0_Template, 2, 4, "div", 45);
} if (rf & 2) {
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentConfirmation_CrossSell_NoticeBox_Header");
} }
function EnrollmentConfirmationComponent_div_0_ng_template_7_ng_template_6_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 46);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r47.Spa_EnrollmentConfirmation_CrossSell_NoticeBox_Body, "html"), i0.ɵɵsanitizeHtml);
} }
function EnrollmentConfirmationComponent_div_0_ng_template_7_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, EnrollmentConfirmationComponent_div_0_ng_template_7_ng_template_6_div_0_Template, 2, 4, "div", 45);
} if (rf & 2) {
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentConfirmation_CrossSell_NoticeBox_Body");
} }
function EnrollmentConfirmationComponent_div_0_ng_template_7_ng_template_8_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 46);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r48.Spa_EnrollmentConfirmation_CrossSell_CallInProgress_NoticeBox_Body, "html"), i0.ɵɵsanitizeHtml);
} }
function EnrollmentConfirmationComponent_div_0_ng_template_7_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, EnrollmentConfirmationComponent_div_0_ng_template_7_ng_template_8_div_0_Template, 2, 4, "div", 45);
} if (rf & 2) {
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentConfirmation_CrossSell_CallInProgress_NoticeBox_Body");
} }
function EnrollmentConfirmationComponent_div_0_ng_template_7_div_13_vnext_notice_2_Template(rf, ctx) { if (rf & 1) {
    const _r52 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-notice", 48);
    i0.ɵɵlistener("applyEvent", function EnrollmentConfirmationComponent_div_0_ng_template_7_div_13_vnext_notice_2_Template_vnext_notice_applyEvent_0_listener($event) { i0.ɵɵrestoreView(_r52); const ctx_r51 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r51.continueApplyingForCoverage($event)); })("closeTooltipEvent", function EnrollmentConfirmationComponent_div_0_ng_template_7_div_13_vnext_notice_2_Template_vnext_notice_closeTooltipEvent_0_listener($event) { i0.ɵɵrestoreView(_r52); const ctx_r53 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r53.closeEnrollmentTooltip($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r37 = i0.ɵɵreference(5);
    const _r39 = i0.ɵɵreference(7);
    const ctx_r49 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("type", "warn")("hasButton", true)("buttonText", ctx_r49.Spa_Confirmation_Continue_Applying_For_Coverage)("buttonAriaLabel", ctx_r49.Spa_Confirmation_ContinueApplyingForCoverageLabel_Text)("titleTemplate", _r37)("bodyTemplate", _r39)("toolTipText", ctx_r49.Spa_Site_EnrollerButton_Tooltip_Text)("keyNameForLiveEdit", "Spa_Confirmation_Continue_Applying_For_Coverage");
} }
function EnrollmentConfirmationComponent_div_0_ng_template_7_div_13_vnext_notice_3_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-notice", 48);
    i0.ɵɵlistener("applyEvent", function EnrollmentConfirmationComponent_div_0_ng_template_7_div_13_vnext_notice_3_Template_vnext_notice_applyEvent_0_listener($event) { i0.ɵɵrestoreView(_r55); const ctx_r54 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r54.continueApplyingForCoverage($event)); })("closeTooltipEvent", function EnrollmentConfirmationComponent_div_0_ng_template_7_div_13_vnext_notice_3_Template_vnext_notice_closeTooltipEvent_0_listener($event) { i0.ɵɵrestoreView(_r55); const ctx_r56 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r56.closeEnrollmentTooltip($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r37 = i0.ɵɵreference(5);
    const _r41 = i0.ɵɵreference(9);
    const ctx_r50 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("type", "warn")("hasButton", true)("buttonText", ctx_r50.Spa_Confirmation_Continue_Applying_For_Coverage)("buttonAriaLabel", ctx_r50.Spa_Confirmation_ContinueApplyingForCoverageLabel_Text)("titleTemplate", _r37)("bodyTemplate", _r41)("toolTipText", ctx_r50.Spa_Site_EnrollerButton_Tooltip_Text)("keyNameForLiveEdit", "Spa_Confirmation_Continue_Applying_For_Coverage");
} }
function EnrollmentConfirmationComponent_div_0_ng_template_7_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 28);
    i0.ɵɵtemplate(2, EnrollmentConfirmationComponent_div_0_ng_template_7_div_13_vnext_notice_2_Template, 1, 8, "vnext-notice", 47);
    i0.ɵɵtemplate(3, EnrollmentConfirmationComponent_div_0_ng_template_7_div_13_vnext_notice_3_Template, 1, 8, "vnext-notice", 47);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r43.isCallRecordingInProgress);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r43.isCallRecordingInProgress);
} }
function EnrollmentConfirmationComponent_div_0_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, EnrollmentConfirmationComponent_div_0_ng_template_7_ng_template_0_Template, 1, 1, "ng-template", null, 36, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(2, EnrollmentConfirmationComponent_div_0_ng_template_7_ng_template_2_Template, 1, 1, "ng-template", null, 37, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, EnrollmentConfirmationComponent_div_0_ng_template_7_ng_template_4_Template, 1, 1, "ng-template", null, 38, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(6, EnrollmentConfirmationComponent_div_0_ng_template_7_ng_template_6_Template, 1, 1, "ng-template", null, 39, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(8, EnrollmentConfirmationComponent_div_0_ng_template_7_ng_template_8_Template, 1, 1, "ng-template", null, 40, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(10, "div", 5)(11, "div", 28);
    i0.ɵɵelement(12, "vnext-notice", 41);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(13, EnrollmentConfirmationComponent_div_0_ng_template_7_div_13_Template, 4, 2, "div", 30);
    i0.ɵɵelementStart(14, "div", 5)(15, "div", 28);
    i0.ɵɵelement(16, "vnext-selectrx-section");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r33 = i0.ɵɵreference(1);
    const _r35 = i0.ɵɵreference(3);
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(12);
    i0.ɵɵproperty("titleTemplate", _r33)("bodyTemplate", _r35);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.moreCoverageToEnroll);
} }
function EnrollmentConfirmationComponent_div_0_button_10_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r58 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r58.Spa_Site_Email);
} }
function EnrollmentConfirmationComponent_div_0_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r60 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 49, 50);
    i0.ɵɵlistener("click", function EnrollmentConfirmationComponent_div_0_button_10_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r60); const ctx_r59 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r59.email()); });
    i0.ɵɵelement(2, "i", 51);
    i0.ɵɵtemplate(3, EnrollmentConfirmationComponent_div_0_button_10_span_3_Template, 2, 1, "span", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r11.Spa_Site_Email + ctx_r11.actionStringAppend);
    i0.ɵɵattribute("aria-label", ctx_r11.Spa_Site_Email + ctx_r11.actionStringAppend);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_Email");
} }
function EnrollmentConfirmationComponent_div_0_div_14_h2_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 54);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r61 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r61.Spa_EnrollmentConfirmation_WhatToExpect_Title, " ");
} }
function EnrollmentConfirmationComponent_div_0_div_14_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 55);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r62 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r62.Spa_EnrollmentConfirmation_WhatToExpect_Body, "html"), i0.ɵɵsanitizeHtml);
} }
function EnrollmentConfirmationComponent_div_0_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, EnrollmentConfirmationComponent_div_0_div_14_h2_1_Template, 2, 1, "h2", 52);
    i0.ɵɵtemplate(2, EnrollmentConfirmationComponent_div_0_div_14_span_2_Template, 2, 4, "span", 53);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentConfirmation_WhatToExpect_Title");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentConfirmation_WhatToExpect_Body");
} }
function EnrollmentConfirmationComponent_div_0_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 56);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r13.planPostEnrollmentConfirmationText, "html"), i0.ɵɵsanitizeHtml);
} }
function EnrollmentConfirmationComponent_div_0_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    const _r64 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-vbc-confirmation-section", 57);
    i0.ɵɵlistener("onVbcConfirmationAttestationSubmit", function EnrollmentConfirmationComponent_div_0_ng_container_16_Template_vnext_vbc_confirmation_section_onVbcConfirmationAttestationSubmit_1_listener($event) { i0.ɵɵrestoreView(_r64); const ctx_r63 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r63.updateVbcConfirmationAttestation($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("messageText", ctx_r14.valueBasedCareProvider == null ? null : ctx_r14.valueBasedCareProvider.confirmationMessageText)("primaryButtonText", ctx_r14.valueBasedCareProvider == null ? null : ctx_r14.valueBasedCareProvider.primaryButtonText)("secondaryButtonText", ctx_r14.valueBasedCareProvider == null ? null : ctx_r14.valueBasedCareProvider.secondaryButtonText)("primaryButtonLink", ctx_r14.valueBasedCareProvider == null ? null : ctx_r14.valueBasedCareProvider.primaryButtonURL)("secondaryButtonLink", ctx_r14.valueBasedCareProvider == null ? null : ctx_r14.valueBasedCareProvider.secondaryButtonURL)("vbcConfirmationAttestationEnabled", ctx_r14.Spa_ValueBasedCare_ConfirmationAttestation_Enabled)("pcpName", ctx_r14.valueBasedCareProvider == null ? null : ctx_r14.valueBasedCareProvider.pcpName)("vbcOrgName", ctx_r14.valueBasedCareProvider == null ? null : ctx_r14.valueBasedCareProvider.vbcOrgName)("vbcid", ctx_r14.valueBasedCareProvider == null ? null : ctx_r14.valueBasedCareProvider.vbcid)("npi", ctx_r14.valueBasedCareProvider == null ? null : ctx_r14.valueBasedCareProvider.npi)("optInEnabled", (ctx_r14.valueBasedCareProvider == null ? null : ctx_r14.valueBasedCareProvider.optin) !== false)("vbcConfirmationAttestationProviderText", ctx_r14.Spa_ValueBasedCare_ConfirmationAttestation_Provider_Text)("vbcConfirmationAttestationText", ctx_r14.Spa_ValueBasedCare_ConfirmationAttestation_Text)("vbcOptOutConsentConfirmationAttestationText", ctx_r14.Spa_ValueBasedCare_OptOutConsentConfirmationAttestation_Text)("optInConfirmationSuccessText", ctx_r14.Spa_ValueBasedCare_ConfirmationAttestationSuccess_Text)("saveFailedErrorText", ctx_r14.Spa_Save_Failed_ErrorText)("submitButtonText", ctx_r14.Spa_Site_Submit)("optOutSubmitButtonText", ctx_r14.Spa_ValueBasedCare_OptOutButton_Text)("optOutConfirmationSuccessText", ctx_r14.Spa_ValueBasedCare_OptOutConfirmationSuccess_Text)("vbcAttestationSubmitted", ctx_r14.vbcAttestationSubmitted)("vbcTitle", ctx_r14.Spa_ValueBasedCare_Confirmation_Title)("providerNameLabel", ctx_r14.Spa_ValueBasedCare_Confirmation_Provider_Name_Text)("orgNameLabel", ctx_r14.Spa_ValueBasedCare_Confirmation_Organization_Text)("nextStepLabel", ctx_r14.Spa_ValueBasedCare_Confirmation_Next_Step_Text)("isDefaultView", !ctx_r14.Spa_ValueBasedCare_Confirmation_UpdatedView_Enabled);
} }
function EnrollmentConfirmationComponent_div_0_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-enrollment-confirmation-hra-section", 58);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("hraEnabled", ctx_r15.Spa_Site_HRA_Enabled)("nextStepsTitle", ctx_r15.Spa_EnrollmentConfirmation_NextStepsTitle_Text)("nextStepsBody", ctx_r15.enrollmentConfirmationNextStepsText)("hraAvailableAfterEnrollmentText", ctx_r15.Spa_EnrollmentConfirmation_HRAAvailableAfterEnrollment_Text)("hraButtonText", ctx_r15.Spa_EnrollmentConfirmation_HRAButton_Text)("enrollmentPlan", ctx_r15.enrollmentPlan)("modalCancelText", ctx_r15.Spa_Site_Cancel)("modalContinueText", ctx_r15.Spa_Site_Continue)("modalTitleText", ctx_r15.Spa_EnrollmentConfirmation_ExternalHRATitle_Text)("modalBodyText", ctx_r15.Spa_EnrollmentConfirmation_ExternalHRABody_Text)("isLiveEdit", ctx_r15.isLiveEdit)("transactionGUID", ctx_r15.enrollmentTransactionGUID)("originalEnrollmentConfirmationNumber", ctx_r15.confirmationNumber)("enrollmentHRAUserType", ctx_r15.enrollmentHRAUserType)("isPCApiEnrollment", ctx_r15.isPCApiEnrollment)("openExternalInNewTab", ctx_r15.Spa_EnrollmentConfirmation_OpenExternalHRAInNewTab_Enabled)("enrollmentSubmittedDate", ctx_r15.enrollmentSubmittedDate)("hraDaysLeftText", ctx_r15.Spa_Site_CompleteHRA_DaysLeft_Text);
} }
function EnrollmentConfirmationComponent_div_0_ng_container_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function EnrollmentConfirmationComponent_div_0_ng_template_20_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "phone");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r65 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, ctx_r65.brokerPhoneNumber, ctx_r65.countryCode), " ");
} }
function EnrollmentConfirmationComponent_div_0_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59)(1, "div", 60);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, EnrollmentConfirmationComponent_div_0_ng_template_20_div_5_Template, 3, 4, "div", 2);
    i0.ɵɵelement(6, "vnext-link", 61);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r18.brokerData.fullName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r18.brokerData.agency);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.countryCode);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("href", "mailto:", ctx_r18.brokerData.email, "");
    i0.ɵɵproperty("title", ctx_r18.brokerData.email);
} }
function EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const carrier_r70 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", carrier_r70.carrierAddress.address1, " ");
} }
function EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const carrier_r70 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", carrier_r70.carrierAddress.city, ", ");
} }
function EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const carrier_r70 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", carrier_r70.carrierAddress.state, " ");
} }
function EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const carrier_r70 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", carrier_r70.carrierAddress.zip, " ");
} }
function EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_ng_template_12_span_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c2$E = function (a0, a1) { return { content: a0, name: a1 }; };
function EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_ng_template_12_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_ng_template_12_span_0_ng_container_3_Template, 1, 0, "ng-container", 66);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const carrier_r70 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵnextContext(2);
    const _r67 = i0.ɵɵreference(2);
    const ctx_r85 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r85.Spa_Enrollment_TTY_Members_Text, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r67)("ngTemplateOutletContext", i0.ɵɵpureFunction2(3, _c2$E, carrier_r70.phoneMemberTTY, carrier_r70.organizationName));
} }
function EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_ng_template_12_span_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_ng_template_12_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_ng_template_12_span_1_ng_container_3_Template, 1, 0, "ng-container", 66);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const carrier_r70 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵnextContext(2);
    const _r67 = i0.ɵɵreference(2);
    const ctx_r86 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r86.Spa_Enrollment_TTY_NonMembers_Text, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r67)("ngTemplateOutletContext", i0.ɵɵpureFunction2(3, _c2$E, carrier_r70.phoneNonMemberTTY, carrier_r70.organizationName));
} }
function EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_ng_template_12_span_0_Template, 4, 6, "span", 2);
    i0.ɵɵtemplate(1, EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_ng_template_12_span_1_Template, 4, 6, "span", 2);
} if (rf & 2) {
    const carrier_r70 = i0.ɵɵnextContext().ngIf;
    const ctx_r78 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngIf", ctx_r78.Spa_Enrollment_TTY_Members_Text_Enabled && carrier_r70.phoneMemberTTY);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r78.Spa_Enrollment_TTY_NonMembers_Text_Enabled && carrier_r70.phoneNonMemberTTY);
} }
function EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_ng_template_14_span_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_ng_template_14_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_ng_template_14_span_0_ng_container_3_Template, 1, 0, "ng-container", 66);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const carrier_r70 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵnextContext(2);
    const _r67 = i0.ɵɵreference(2);
    const ctx_r92 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r92.Spa_Enrollment_TTY_Text, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r67)("ngTemplateOutletContext", i0.ɵɵpureFunction2(3, _c2$E, ctx_r92.enrollmentPlan.planEnrollmentInfo.ttyPhone, carrier_r70.organizationName));
} }
function EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_ng_template_14_span_0_Template, 4, 6, "span", 2);
} if (rf & 2) {
    const ctx_r80 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("ngIf", ctx_r80.enrollmentPlan.planEnrollmentInfo && ctx_r80.enrollmentPlan.planEnrollmentInfo.ttyPhone);
} }
function EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 63);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 64);
    i0.ɵɵtemplate(4, EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_span_4_Template, 2, 1, "span", 2);
    i0.ɵɵtemplate(5, EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_span_5_Template, 2, 1, "span", 2);
    i0.ɵɵtemplate(6, EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_span_6_Template, 2, 1, "span", 2);
    i0.ɵɵtemplate(7, EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_span_7_Template, 2, 1, "span", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 65);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_ng_container_10_Template, 1, 0, "ng-container", 66);
    i0.ɵɵtemplate(11, EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_ng_container_11_Template, 1, 0, "ng-container", 8);
    i0.ɵɵtemplate(12, EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_ng_template_12_Template, 2, 2, "ng-template", null, 67, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(14, EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_ng_template_14_Template, 1, 1, "ng-template", null, 68, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(16, "vnext-link", 61);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const carrier_r70 = ctx.ngIf;
    const _r77 = i0.ɵɵreference(13);
    const _r79 = i0.ɵɵreference(15);
    i0.ɵɵnextContext(2);
    const _r67 = i0.ɵɵreference(2);
    const ctx_r69 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", carrier_r70.organizationName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", carrier_r70.carrierAddress.address1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", carrier_r70.carrierAddress.city);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", carrier_r70.carrierAddress.state);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", carrier_r70.carrierAddress.zip);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(carrier_r70.hours);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r67)("ngTemplateOutletContext", i0.ɵɵpureFunction2(13, _c2$E, carrier_r70.phone, carrier_r70.organizationName));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r69.enrollmentPlan.planType === ctx_r69.planType.MEDIGAP)("ngIfThen", _r77)("ngIfElse", _r79);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("href", carrier_r70.websiteURL)("title", carrier_r70.websiteURL);
} }
function EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_div_1_Template, 17, 16, "div", 2);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r66 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r66.enrollmentPlan.carrierInformation);
} }
function EnrollmentConfirmationComponent_div_0_ng_template_22_ng_template_1_ng_container_0_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 71);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "phone");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r101 = i0.ɵɵnextContext(2);
    const content_r95 = ctx_r101.content;
    const name_r96 = ctx_r101.name;
    const ctx_r98 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate1("href", "tel:", content_r95, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("aria-label", name_r96 + ": " + content_r95);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 3, content_r95, ctx_r98.countryCode), " ");
} }
function EnrollmentConfirmationComponent_div_0_ng_template_22_ng_template_1_ng_container_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "phone");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const content_r95 = i0.ɵɵnextContext(2).content;
    const ctx_r100 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, content_r95, ctx_r100.countryCode), " ");
} }
function EnrollmentConfirmationComponent_div_0_ng_template_22_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EnrollmentConfirmationComponent_div_0_ng_template_22_ng_template_1_ng_container_0_a_1_Template, 3, 6, "a", 69);
    i0.ɵɵtemplate(2, EnrollmentConfirmationComponent_div_0_ng_template_22_ng_template_1_ng_container_0_ng_template_2_Template, 3, 4, "ng-template", null, 70, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r99 = i0.ɵɵreference(3);
    const ctx_r97 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r97.isMobile)("ngIfElse", _r99);
} }
function EnrollmentConfirmationComponent_div_0_ng_template_22_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, EnrollmentConfirmationComponent_div_0_ng_template_22_ng_template_1_ng_container_0_Template, 4, 2, "ng-container", 2);
} if (rf & 2) {
    const ctx_r68 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r68.countryCode);
} }
function EnrollmentConfirmationComponent_div_0_ng_template_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, EnrollmentConfirmationComponent_div_0_ng_template_22_ng_container_0_Template, 2, 1, "ng-container", 2);
    i0.ɵɵtemplate(1, EnrollmentConfirmationComponent_div_0_ng_template_22_ng_template_1_Template, 1, 1, "ng-template", null, 62, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r20.enrollmentPlan);
} }
function EnrollmentConfirmationComponent_div_0_h2_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 72);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r21.Spa_EnrollmentConfirmation_ApplicationDetails_Label, " ");
} }
function EnrollmentConfirmationComponent_div_0_div_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 73);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r22.applicantName, " ");
} }
function EnrollmentConfirmationComponent_div_0_div_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 73);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r23.applicantAddress, " ");
} }
function EnrollmentConfirmationComponent_div_0_div_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate5(" ", ctx_r24.addresses[0].address1, " ", ctx_r24.addresses[0].address2, " ", ctx_r24.addresses[0].city, ", ", ctx_r24.addresses[0].state, " ", ctx_r24.addresses[0].zip, " ");
} }
function EnrollmentConfirmationComponent_div_0_div_35_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 73);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r103 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r103.Spa_EnrollmentConfirmation_ApplicationSubmitted_Label, " ");
} }
function EnrollmentConfirmationComponent_div_0_div_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, EnrollmentConfirmationComponent_div_0_div_35_div_1_Template, 2, 1, "div", 23);
    i0.ɵɵelementStart(2, "div", 74);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentConfirmation_ApplicationSubmitted_Label");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r25.submissionDate, " ");
} }
function EnrollmentConfirmationComponent_div_0_div_36_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 73);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r104 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r104.Spa_EnrollmentConfirmation_ApplicationId_Label, " ");
} }
function EnrollmentConfirmationComponent_div_0_div_36_Template(rf, ctx) { if (rf & 1) {
    const _r106 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 75);
    i0.ɵɵtemplate(1, EnrollmentConfirmationComponent_div_0_div_36_div_1_Template, 2, 1, "div", 23);
    i0.ɵɵelementStart(2, "div", 74);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "vnext-link", 76);
    i0.ɵɵlistener("click", function EnrollmentConfirmationComponent_div_0_div_36_Template_vnext_link_click_4_listener() { i0.ɵɵrestoreView(_r106); const ctx_r105 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r105.viewApplication()); })("keyup.enter", function EnrollmentConfirmationComponent_div_0_div_36_Template_vnext_link_keyup_enter_4_listener() { i0.ɵɵrestoreView(_r106); const ctx_r107 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r107.viewApplication()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentConfirmation_ApplicationId_Label");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r26.confirmationNumber, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("customClass", "action-button Spa_Style_Link d-inline")("additionalIcon", "fa fa-file-alt mr-2")("title", ctx_r26.Spa_Site_ViewApplication_Link_Text)("keyNameForLiveEdit", "Spa_Site_ViewApplication_Link_Text")("ariaLabel", ctx_r26.Spa_Site_ViewApplication_Link_Text)("isLinkButton", true);
} }
function EnrollmentConfirmationComponent_div_0_div_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 77)(1, "div", 73);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelement(4, "vnext-call-recording-actions", 78);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r27.Spa_AgentCallRecordingBox_Header, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("callInProgressText", ctx_r27.Spa_AgentCallRecordingBox_CallInProgress)("endCallText", ctx_r27.Spa_AgentCallRecordingBox_EndCall)("callEndedText", ctx_r27.Spa_AgentCallRecordingBox_CallEnded)("toStartNewRecordingText", ctx_r27.Spa_AgentCallRecordingBox_ToStartANewCallRecording)("isInline", true);
} }
function EnrollmentConfirmationComponent_div_0_h2_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 79);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r28.pendingCoverageHeader, " ");
} }
function EnrollmentConfirmationComponent_div_0_div_44_div_2_div_10_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r116 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r116.Spa_EnrollmentConfirmation_RequestedStartDate_Label, " ");
} }
function EnrollmentConfirmationComponent_div_0_div_44_div_2_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, EnrollmentConfirmationComponent_div_0_div_44_div_2_div_10_span_1_Template, 2, 1, "span", 42);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r110 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentConfirmation_RequestedStartDate_Label");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r110.effectiveDate, " ");
} }
function EnrollmentConfirmationComponent_div_0_div_44_div_2_ng_container_11_vnext_link_1_Template(rf, ctx) { if (rf & 1) {
    const _r120 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 93);
    i0.ɵɵlistener("click", function EnrollmentConfirmationComponent_div_0_div_44_div_2_ng_container_11_vnext_link_1_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r120); const plan_r109 = i0.ɵɵnextContext(2).$implicit; const ctx_r118 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r118.viewPlanDetails(plan_r109)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r117 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("title", ctx_r117.Spa_EnrollmentConfirmation_ViewPlanDetails_Label)("keyNameForLiveEdit", "Spa_EnrollmentConfirmation_ViewPlanDetails_Label")("additionalIcon", "fa fa-file-alt mr-2");
} }
function EnrollmentConfirmationComponent_div_0_div_44_div_2_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EnrollmentConfirmationComponent_div_0_div_44_div_2_ng_container_11_vnext_link_1_Template, 1, 3, "vnext-link", 92);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r111 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r111.Spa_EnrollmentConfirmation_ShowViewPlanDetailsLink_Flag);
} }
function EnrollmentConfirmationComponent_div_0_div_44_div_2_ng_container_12_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 96);
    i0.ɵɵelementStart(3, "span", 97);
    i0.ɵɵtext(4, "Expand");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r122 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r122.Spa_ShoppingCart_BenefitsSelection_Text);
} }
function EnrollmentConfirmationComponent_div_0_div_44_div_2_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    const _r125 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 94, 95);
    i0.ɵɵlistener("click", function EnrollmentConfirmationComponent_div_0_div_44_div_2_ng_container_12_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r125); const plan_r109 = i0.ɵɵnextContext().$implicit; const ctx_r123 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r123.showHospitalIndemnityBenefits(plan_r109)); })("keyup.enter", function EnrollmentConfirmationComponent_div_0_div_44_div_2_ng_container_12_Template_button_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r125); const plan_r109 = i0.ɵɵnextContext().$implicit; const ctx_r126 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r126.showHospitalIndemnityBenefits(plan_r109)); });
    i0.ɵɵtemplate(3, EnrollmentConfirmationComponent_div_0_div_44_div_2_ng_container_12_span_3_Template, 5, 1, "span", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(4);
    const _r3 = i0.ɵɵreference(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("autoClose", "outside")("ngbPopover", _r3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_ShoppingCart_BenefitsSelection_Text");
} }
function EnrollmentConfirmationComponent_div_0_div_44_div_2_span_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 98);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r113 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r113.planTotalPremium));
} }
function EnrollmentConfirmationComponent_div_0_div_44_div_2_ng_template_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-plan-fees-tooltip", 99);
} if (rf & 2) {
    const plan_r109 = i0.ɵɵnextContext().$implicit;
    const ctx_r115 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("planFees", plan_r109.fees)("planTotalPremium", ctx_r115.planTotalPremium)("planFeesTooltipText", ctx_r115.Spa_PlanFees_Tooltip_Text)("planFeesIncludedInPremiumTooltipText", ctx_r115.Spa_PlanFees_IncludedInPremium_Tooltip_Text)("planFeesNotIncludedInPremiumTooltipText", ctx_r115.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text)("customClass", "stacked-content")("tooltipCustomClass", "stacked-content");
} }
function EnrollmentConfirmationComponent_div_0_div_44_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 81)(1, "div", 82)(2, "h3", 83);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 84)(5, "div", 85);
    i0.ɵɵelement(6, "vnext-plan-logo", 86);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 87)(8, "h4", 88);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, EnrollmentConfirmationComponent_div_0_div_44_div_2_div_10_Template, 3, 2, "div", 2);
    i0.ɵɵtemplate(11, EnrollmentConfirmationComponent_div_0_div_44_div_2_ng_container_11_Template, 2, 1, "ng-container", 2);
    i0.ɵɵtemplate(12, EnrollmentConfirmationComponent_div_0_div_44_div_2_ng_container_12_Template, 4, 3, "ng-container", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 89)(14, "span");
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, EnrollmentConfirmationComponent_div_0_div_44_div_2_span_16_Template, 3, 3, "span", 90);
    i0.ɵɵtemplate(17, EnrollmentConfirmationComponent_div_0_div_44_div_2_ng_template_17_Template, 1, 7, "ng-template", null, 91, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const plan_r109 = ctx.$implicit;
    const _r114 = i0.ɵɵreference(18);
    const ctx_r108 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r108.getPlanDescription(plan_r109), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("alternateText", plan_r109.logo2Description)("imageSrc", ctx_r108.planFacade.getPlanLogoUrl(plan_r109))("classNames", "logo plan-logo")("planLogoSize", ctx_r108.Spa_Site_PlanLogo_Size);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(plan_r109.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", plan_r109.planType === ctx_r108.MED_SUP_PLAN_TYPE);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r108.Spa_Site_PlanViewDetails_Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r108.Spa_ShoppingCart_ShowHIPBenefits_Enabled && plan_r109.planTypeAbbreviation === ctx_r108.planTypeAbbreviation.HC);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r108.premiumLabel, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r108.Spa_Site_PlanFees_Enabled || !(plan_r109.fees == null ? null : plan_r109.fees.length))("ngIfElse", _r114);
} }
const _c3$q = function (a0) { return [a0]; };
function EnrollmentConfirmationComponent_div_0_div_44_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 28);
    i0.ɵɵtemplate(2, EnrollmentConfirmationComponent_div_0_div_44_div_2_Template, 19, 12, "div", 80);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction1(1, _c3$q, ctx_r29.enrollmentPlan));
} }
function EnrollmentConfirmationComponent_div_0_div_45_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 102)(1, "div", 103)(2, "div", 64);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 104);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "currency");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const rider_r130 = ctx.$implicit;
    const ctx_r129 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(rider_r130.planName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 2, ctx_r129.getRiderPremium(rider_r130)));
} }
function EnrollmentConfirmationComponent_div_0_div_45_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 100);
    i0.ɵɵtemplate(1, EnrollmentConfirmationComponent_div_0_div_45_div_1_Template, 7, 4, "div", 101);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r30.selectedRiders);
} }
function EnrollmentConfirmationComponent_div_0_ng_container_46_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-total-premium-banner", 105);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plans", i0.ɵɵpureFunction1(4, _c3$q, ctx_r31.enrollmentPlan))("riders", ctx_r31.selectedRiders)("customClass", "Spa_Style_Cost_Background")("bottomMargin", false);
} }
function EnrollmentConfirmationComponent_div_0_ng_container_48_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function EnrollmentConfirmationComponent_div_0_ng_container_48_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r137 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-navigation-banner")(1, "div", 108)(2, "button", 109);
    i0.ɵɵlistener("click", function EnrollmentConfirmationComponent_div_0_ng_container_48_ng_template_2_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r137); const ctx_r136 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r136.shopForSomeoneElse()); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r133 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r133.Spa_Confirmation_Shop_For_Someone_Else, " ");
} }
function EnrollmentConfirmationComponent_div_0_ng_container_48_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r140 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-navigation-banner")(1, "div", 108)(2, "button", 110, 111);
    i0.ɵɵlistener("click", function EnrollmentConfirmationComponent_div_0_ng_container_48_ng_template_4_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r140); const _r138 = i0.ɵɵreference(3); const ctx_r139 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r139.continueApplyingForCoverage(_r138)); })("blur", function EnrollmentConfirmationComponent_div_0_ng_container_48_ng_template_4_Template_button_blur_2_listener() { i0.ɵɵrestoreView(_r140); const _r138 = i0.ɵɵreference(3); const ctx_r141 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r141.closeEnrollmentTooltip(_r138)); });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r135 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngbTooltip", ctx_r135.Spa_Site_EnrollerButton_Tooltip_Text);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r135.Spa_Confirmation_Continue_Applying_For_Coverage, " ");
} }
function EnrollmentConfirmationComponent_div_0_ng_container_48_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EnrollmentConfirmationComponent_div_0_ng_container_48_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵtemplate(2, EnrollmentConfirmationComponent_div_0_ng_container_48_ng_template_2_Template, 4, 1, "ng-template", null, 106, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, EnrollmentConfirmationComponent_div_0_ng_container_48_ng_template_4_Template, 5, 2, "ng-template", null, 107, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r132 = i0.ɵɵreference(3);
    const _r134 = i0.ɵɵreference(5);
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r32.moreCoverageToEnroll)("ngIfThen", _r134)("ngIfElse", _r132);
} }
function EnrollmentConfirmationComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r143 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "div", 6);
    i0.ɵɵtemplate(3, EnrollmentConfirmationComponent_div_0_h1_3_Template, 2, 1, "h1", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, EnrollmentConfirmationComponent_div_0_ng_container_4_Template, 1, 0, "ng-container", 8);
    i0.ɵɵtemplate(5, EnrollmentConfirmationComponent_div_0_ng_template_5_Template, 5, 1, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(7, EnrollmentConfirmationComponent_div_0_ng_template_7_Template, 17, 3, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(9, "div", 11);
    i0.ɵɵtemplate(10, EnrollmentConfirmationComponent_div_0_button_10_Template, 4, 3, "button", 12);
    i0.ɵɵelementStart(11, "vnext-link", 13);
    i0.ɵɵlistener("click", function EnrollmentConfirmationComponent_div_0_Template_vnext_link_click_11_listener() { i0.ɵɵrestoreView(_r143); const ctx_r142 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r142.print()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 5)(13, "div", 14);
    i0.ɵɵtemplate(14, EnrollmentConfirmationComponent_div_0_div_14_Template, 3, 2, "div", 2);
    i0.ɵɵtemplate(15, EnrollmentConfirmationComponent_div_0_div_15_Template, 2, 4, "div", 15);
    i0.ɵɵtemplate(16, EnrollmentConfirmationComponent_div_0_ng_container_16_Template, 2, 25, "ng-container", 2);
    i0.ɵɵtemplate(17, EnrollmentConfirmationComponent_div_0_ng_container_17_Template, 2, 18, "ng-container", 2);
    i0.ɵɵelementStart(18, "div", 16);
    i0.ɵɵtemplate(19, EnrollmentConfirmationComponent_div_0_ng_container_19_Template, 1, 0, "ng-container", 8);
    i0.ɵɵtemplate(20, EnrollmentConfirmationComponent_div_0_ng_template_20_Template, 7, 5, "ng-template", null, 17, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(22, EnrollmentConfirmationComponent_div_0_ng_template_22_Template, 3, 1, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(24, "div", 19)(25, "div", 20);
    i0.ɵɵtemplate(26, EnrollmentConfirmationComponent_div_0_h2_26_Template, 2, 1, "h2", 21);
    i0.ɵɵelementStart(27, "div", 22)(28, "div");
    i0.ɵɵtemplate(29, EnrollmentConfirmationComponent_div_0_div_29_Template, 2, 1, "div", 23);
    i0.ɵɵelementStart(30, "div", 24);
    i0.ɵɵtext(31);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(32, "div");
    i0.ɵɵtemplate(33, EnrollmentConfirmationComponent_div_0_div_33_Template, 2, 1, "div", 23);
    i0.ɵɵtemplate(34, EnrollmentConfirmationComponent_div_0_div_34_Template, 2, 5, "div", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(35, EnrollmentConfirmationComponent_div_0_div_35_Template, 4, 2, "div", 2);
    i0.ɵɵtemplate(36, EnrollmentConfirmationComponent_div_0_div_36_Template, 5, 8, "div", 26);
    i0.ɵɵtemplate(37, EnrollmentConfirmationComponent_div_0_div_37_Template, 5, 6, "div", 27);
    i0.ɵɵpipe(38, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(39, "div");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(40, "div");
    i0.ɵɵelementStart(41, "div", 5)(42, "div", 28);
    i0.ɵɵtemplate(43, EnrollmentConfirmationComponent_div_0_h2_43_Template, 2, 1, "h2", 29);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(44, EnrollmentConfirmationComponent_div_0_div_44_Template, 3, 3, "div", 30);
    i0.ɵɵtemplate(45, EnrollmentConfirmationComponent_div_0_div_45_Template, 2, 1, "div", 31);
    i0.ɵɵtemplate(46, EnrollmentConfirmationComponent_div_0_ng_container_46_Template, 2, 6, "ng-container", 2);
    i0.ɵɵelementStart(47, "div");
    i0.ɵɵtemplate(48, EnrollmentConfirmationComponent_div_0_ng_container_48_Template, 6, 3, "ng-container", 2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r7 = i0.ɵɵreference(6);
    const _r9 = i0.ɵɵreference(8);
    const _r17 = i0.ɵɵreference(21);
    const _r19 = i0.ɵɵreference(23);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disableCommonEvent", true);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentConfirmation_ApplicationSubmitted_Title");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isNextYearPlan)("ngIfThen", _r7)("ngIfElse", _r9);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r0.Spa_EnrollmentConfirmation_ShowEmail_Flag || !ctx_r0.isNextYearPlan);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r0.Spa_Site_Print)("keyNameForLiveEdit", "Spa_Site_Print")("customClass", "action-button Spa_Style_Link d-inline")("additionalIcon", "fa fa-print")("ariaLabel", ctx_r0.Spa_Site_Print + ctx_r0.actionStringAppend)("isLinkButton", true);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0.isNextYearPlan);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.Spa_Site_PlanPostEnrollmentText_Enabled && ctx_r0.planPostEnrollmentConfirmationText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.Spa_ValueBasedCare_Confirmation_Enabled && ctx_r0.valueBasedCareProvider && ctx_r0.vbcWhitelisted);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.Spa_Site_HRA_Enabled && (!ctx_r0.hasAssociatedHRAEnrollment || ctx_r0.Spa_Enrollment_Allow_AlreadyEnrolled_Plans) || ctx_r0.isLiveEdit);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showBrokerFlag)("ngIfThen", _r17)("ngIfElse", _r19);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentConfirmation_ApplicationDetails_Label");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentConfirmation_MemberName_Label");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.fullName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentConfirmation_MemberAddress_Label");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.addresses && ctx_r0.addresses.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isNextYearPlan);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isNextYearPlan);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isAgentCallRecordingEnabled && ctx_r0.isBrokerFormType && (ctx_r0.allowsCallRecordingOnMultiCarrierSite || ctx_r0.isSingleCarrierSite) && !i0.ɵɵpipeBind1(38, 32, ctx_r0.hasAgentCallRecordingBeenSkipped$));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentConfirmation_PendingCoverage_Header");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.enrollmentPlan);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.Spa_Site_ShowPremiumAsAnnual && (ctx_r0.enrollmentPlan == null ? null : ctx_r0.enrollmentPlan.planTypeAbbreviation) !== ctx_r0.planTypeAbbreviation.HC);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.enrollmentPlan);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.Spa_RetentionLogin_ContinueWithoutPin_Link_Enabled && ctx_r0.isConsumerSite);
} }
function EnrollmentConfirmationComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r145 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 112);
    i0.ɵɵelement(1, "vnext-enrollment-unavailable", 113);
    i0.ɵɵelementStart(2, "div", 114)(3, "vnext-link", 115);
    i0.ɵɵlistener("click", function EnrollmentConfirmationComponent_div_1_Template_vnext_link_click_3_listener() { i0.ɵɵrestoreView(_r145); const ctx_r144 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r144.resetStatus()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r1.enrollmentUnavailableTitle)("button", ctx_r1.enrollmentUnavailableButton)("message", ctx_r1.medSupUnavailable ? ctx_r1.medSupUnavailableMessage : ctx_r1.enrollmentUnavailableMessage);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", ctx_r1.Spa_EnrollmentConfirmation_PreviousLink_Text)("showArrow", "left")("keyNameForLiveEdit", "Spa_EnrollmentConfirmation_PreviousLink_Text");
} }
function EnrollmentConfirmationComponent_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 117);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r146 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r146.Spa_EnrollmentConfirmation_Whatsnext, "html"), i0.ɵɵsanitizeHtml);
} }
function EnrollmentConfirmationComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EnrollmentConfirmationComponent_ng_container_2_div_1_Template, 2, 4, "div", 116);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentConfirmation_Whatsnext");
} }
function EnrollmentConfirmationComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r149 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-benefits-display", 118);
    i0.ɵɵlistener("closeButtonAction", function EnrollmentConfirmationComponent_ng_template_3_Template_vnext_benefits_display_closeButtonAction_0_listener() { i0.ɵɵrestoreView(_r149); const ctx_r148 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r148.closeHIPBenefitsPopover()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const benefitsData_r147 = ctx.selectedBenefitDetails;
    i0.ɵɵproperty("benefitsData", benefitsData_r147);
} }
let EnrollmentConfirmationComponent = class EnrollmentConfirmationComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, agentService, cartFacade, injector, modalService, planFacade, enrollmentFormService, enrollmentFormFacade, twilioService, riderFacade, enrollmentConfirmationFacade, memberSessionService, analyticsService, navigationService, siteService, store, configResourceService, jsonAnalyticsService, shoppingCartService, confirmationService, router, plansService, demographicService, shoppingCartContextService, liveEditStateContext, agentCallRecordingFacade, localeService, phoneService, planListFacade, retentionFacade, providerFacade) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.agentService = agentService;
        this.cartFacade = cartFacade;
        this.injector = injector;
        this.modalService = modalService;
        this.planFacade = planFacade;
        this.enrollmentFormService = enrollmentFormService;
        this.enrollmentFormFacade = enrollmentFormFacade;
        this.twilioService = twilioService;
        this.riderFacade = riderFacade;
        this.enrollmentConfirmationFacade = enrollmentConfirmationFacade;
        this.memberSessionService = memberSessionService;
        this.analyticsService = analyticsService;
        this.navigationService = navigationService;
        this.siteService = siteService;
        this.store = store;
        this.configResourceService = configResourceService;
        this.jsonAnalyticsService = jsonAnalyticsService;
        this.shoppingCartService = shoppingCartService;
        this.confirmationService = confirmationService;
        this.router = router;
        this.plansService = plansService;
        this.demographicService = demographicService;
        this.shoppingCartContextService = shoppingCartContextService;
        this.liveEditStateContext = liveEditStateContext;
        this.agentCallRecordingFacade = agentCallRecordingFacade;
        this.localeService = localeService;
        this.phoneService = phoneService;
        this.planListFacade = planListFacade;
        this.retentionFacade = retentionFacade;
        this.providerFacade = providerFacade;
        this.Spa_EnrollmentConfirmation_ShowBroker_Flag = false;
        this.Spa_EnrollmentConfirmation_ShowLogout_Button = false;
        this.Spa_EnrollmentConfirmation_Title = 'Confirmation';
        this.Spa_Confirmation_Applicant_Name_Label = 'Applicant Name';
        this.Spa_Confirmation_Applicant_Address_Label = 'Applicant Address';
        this.Spa_Confirmation_Pending_Coverage_Header = 'Your coverage';
        this.Spa_ContactUsModal_ContactUsLocations = [
            {
                address: '5500 N. 29 St, IW 03135',
                phoneNumber: '123-123-1234',
                hours: '9:00am - 5:00pm M-F',
                email: 'carrier@gmail.com'
            }
        ];
        this.Spa_EnrollmentConfirmation_ApplicationSubmitted_Title = 'Application submitted';
        this.Spa_EnrollmentConfirmation_NoticeBox_Header = 'Your application has been submitted and is pending approval.';
        this.Spa_EnrollmentConfirmation_NoticeBox_Body = 'This confirmation is not proof of membership.';
        this.Spa_Site_Email = 'Email';
        this.Spa_Site_Print = 'Print';
        this.Spa_EnrollmentConfirmation_WhatToExpect_Title = 'What to expect';
        this.Spa_EnrollmentConfirmation_ApplicationDetails_Label = 'Application Details';
        this.Spa_EnrollmentConfirmation_MemberName_Label = 'Member name';
        this.Spa_EnrollmentConfirmation_MemberAddress_Label = 'Member address';
        this.Spa_EnrollmentConfirmation_ApplicationSubmitted_Label = 'Submitted on';
        this.Spa_EnrollmentConfirmation_ApplicationId_Label = 'Application ID';
        this.Spa_Site_ViewApplication_Link_Text = 'View application';
        this.Spa_EnrollmentConfirmation_PendingCoverage_Header = 'Your pending coverage';
        this.Spa_EnrollmentConfirmation_RequestedStartDate_Label = 'Requested start date:';
        this.Spa_EnrollmentConfirmation_ViewPlanDetails_Label = 'View plan details';
        this.Spa_EnrollmentConfirmation_ViewAccountOverview_Label = 'View account overview';
        this.Spa_Confirmation_Shop_For_Someone_Else = 'Shop for someone else';
        this.Spa_Confirmation_Continue_Applying_For_Coverage = 'Continue Applying For Coverage';
        this.Spa_EnrollmentConfirmation_WhatToExpect_Body = `
  <ul >
    <li>We sent a copy of your confirmation to your email address</li>
    <li>You will be notified when your application is accepted and your coverage is effective.</li>
    <li>Your new insurance cards will be sent to you within 7 business days.</li>
  </ul>`;
        this.Spa_EnrollmentConfirmation_CrossSell_NoticeBox_Header = 'You have other coverage in your cart, you still need to enroll in.';
        this.Spa_EnrollmentConfirmation_CrossSell_NoticeBox_Body = 'Continue applying for coverage.';
        this.Spa_EnrollmentConfirmation_CrossSell_CallInProgress_NoticeBox_Body = 'Call recording will end once you begin applying for other coverage. Start a new recording from the cart.';
        this.Spa_EnrollmentConfirmation_PreviousLink_Text = 'Back to Confirmation Page';
        this.Spa_EnrollmentConfirmation_NextStepsTitle_Text = 'Next steps';
        this.Spa_EnrollmentConfirmation_NextStepsBody_Text = 'To better serve the needs of our beneficiaries, please complete the optional Health Risk Assessment. <callInProgress>';
        this.Spa_EnrollmentConfirmation_HRAAvailableAfterEnrollment_Text = 'The HRA may also be accessed in the enrollment history for this beneficiary and will only be available for a limited time.';
        this.Spa_EnrollmentConfirmation_CallInProgress_NextStepsBody_Text = 'If a call recording is in progress, the recording will end when you continue to the Health Risk Assessment form.';
        this.Spa_EnrollmentConfirmation_HRAButton_Text = 'Complete Health Risk Assessment';
        this.Spa_EnrollmentConfirmation_Whatsnext = "<strong>What's Next:</strong>\r\n<p>This confirmation number can be used to help track the online enrollment, " +
            'but it is not proof of membership. Please wait at least 10 days before calling the plan to ask about ' +
            'the status of your enrollment. Please keep this information in case you have any questions about your ' +
            'enrollment and need to contact your selected plan.</p>\r\n<p>If any of the required information on your ' +
            'enrollment form was missing or does not match your Medicare record, the plan may contact you to get the ' +
            "missing or correct information. This could delay the plan's ability to process your enrollment.</p>\r\n " +
            '<p>Here are some important things to expect when your coverage is first effective if the plan determines ' +
            'that your enrollment meets all of the Medicare requirements and is complete. This information is  ' +
            'important if you enrolled late in the month and you have not received a letter, or your membership card, ' +
            'by the day your coverage starts.</p>\r\n<ul type="disc">\r\n  <li>After the plan has processed your ' +
            'application, you should get a letter from the plan you joined. This may take several days. If you do not ' +
            'receive correspondence from the plan in about 10 calendar days, you should contact the plan to check on ' +
            'the status of the enrollment.</li>\r\n  <li>Enrollment can be effective as early as the first of the next ' +
            'month depending on your circumstances. The plan you have selected will inform you of your effective date ' +
            'of enrollment.</li>\r\n  <li>If you need to fill a prescription before you get your plan membership card, ' +
            'let your pharmacist know your plan name and show any of the following materials as proof of membership:</li>' +
            '\r\n    <ul type="circle"> \r\n      <li>Take your acknowledgement, welcome, or confirmation letter that ' +
            'you receive from the plan with you to the pharmacy.</br><strong>Please note: The confirmation number ' +
            'listed on this website cannot be used at your local pharmacy as proof of plan membership.</strong></li>\r\n' +
            "     <li>If you haven't gotten a letter yet, you might have a copy of an enrollment application signed by " +
            'a plan representative.</li>\r\n      <li>If you have both Medicare and Medicaid, you should bring proof of ' +
            'enrollment in both programs such as your Medicare and Medicaid cards, a copy of a Medicare Summary Notice, ' +
            'a recent Medicaid bill, or a copy of your current Medicaid award letter. If you qualify for extra help ' +
            '(the low-income subsidy) you can also bring proof that you qualify such as a copy of your yellow or green ' +
            'automatic enrollment letter from Medicare (if you automatically qualify) or your approval letter from ' +
            'Social Security (if you applied and qualify).</li>\r\n      <li>As a last resort, if you pay out of ' +
            'pocket for your prescription, save your receipts and work with your plan to be reimbursed.</li>\r\n ' +
            "</ul>\r\n  <li>If you have questions, call the plan's toll-free number.</li>\r\n</ul>";
        this.Spa_ShoppingCart_BenefitsSelection_Text = 'Benefit selections';
        this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Title = 'Email this confirmation';
        this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Prompt = 'To';
        this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Cancel = 'Cancel';
        this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Continue = 'Continue';
        this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Close = 'Close';
        this.Spa_EnrollmentConfirmation_EmailConfirmationModal_SuccessMessage = 'Your email has been sent to <email>';
        this.Spa_EnrollmentConfirmation_EmailConfirmationModal_EmailAddressRequired = 'Email address is required.';
        this.Spa_EnrollmentConfirmation_EmailConfirmationModal_EmailAddressInvalid = 'Format is invalid. Re-enter email address.';
        this.Spa_Confirmation_All_Set_Confirmation_Message = 'All set! you remained enrolled and no further action is needed.';
        this.Spa_Site_ShowPremiumAsAnnual = false;
        this.Spa_EnrollmentConfirmation_ShowViewPlanDetailsLink_Flag = true;
        this.Spa_EnrollmentConfirmation_ShowEmail_Flag = true;
        this.Spa_RetentionLogin_ContinueWithoutPin_Link_Enabled = true;
        this.Spa_Site_NotifyAgentOfEnrollment = true;
        this.Spa_EnrollmentConfirmation_SuccessLogo = 'https://i.imgur.com/YkORKj9.png'; // TODO is this used anywhere?
        this.Spa_EnrollmentConfirmation_BrokerInformational_Text = '';
        this.Spa_EnrollmentConfirmation_BrokerEmail_Subject = 'Enrollment Received';
        this.Spa_EnrollmentConfirmation_BrokerEmail_ConfirmationCode_Text = 'System generated confirmation code:';
        this.Spa_EnrollmentConfirmation_BrokerEmail_EnrolledInPlan_Text = 'enrolled in a plan';
        this.Spa_EnrollmentConfirmation_Success_Alt_Text = 'Enrollment confirmation success';
        this.Spa_Site_NotApplicable_Text = 'n/a';
        this.Spa_Site_PlanViewDetails_Enabled = true;
        this.Spa_StarRating_Default_Text = 'Not available';
        this.Spa_Enrollment_TTY_Text = 'TTY: ';
        this.Spa_Enrollment_TTY_Members_Text_Enabled = true;
        this.Spa_Enrollment_TTY_Members_Text = 'TTY Members: ';
        this.Spa_Enrollment_TTY_NonMembers_Text_Enabled = true;
        this.Spa_Enrollment_TTY_NonMembers_Text = 'TTY Non-Members: ';
        this.Spa_Site_EnrollerButton_Tooltip_Text = `You don't have permission to take this action.`;
        this.Spa_Site_Enrollment_Enabled = true;
        this.Spa_Site_MedSupEnrollment_Enabled = true;
        this.Spa_Site_DentalEnrollment_Enabled = false;
        this.Spa_Site_VisionEnrollment_Enabled = false;
        this.Spa_Site_HIPEnrollment_Enabled = false;
        this.SPA_Site_Medigap_Enrollment_InterimPage_Enable = true;
        this.Spa_Site_HRA_Enabled = false;
        this.Spa_Enrollment_Allow_AlreadyEnrolled_Plans = false;
        this.Spa_Site_Cancel = 'Cancel';
        this.Spa_Site_Continue = 'Continue';
        this.Spa_EnrollmentConfirmation_ExternalHRATitle_Text = 'You are about to leave the site';
        this.Spa_EnrollmentConfirmation_ExternalHRABody_Text = 'You will now be directed to an external site to complete the Health Risk Assessment.';
        this.Spa_EnrollmentConfirmation_ContinueAssessment_Text = 'Continue assessment';
        this.Spa_AgentCallRecordingBox_Header = 'Call recording';
        this.Spa_AgentCallRecordingBox_CallInProgress = 'Call in progress...';
        this.Spa_AgentCallRecordingBox_EndCall = 'End call';
        this.Spa_AgentCallRecordingBox_CallEnded = 'Call ended';
        this.Spa_AgentCallRecordingBox_ToStartANewCallRecording = 'To start a new recording, return to the cart.';
        this.Spa_EnrollmentConfirmation_OpenExternalHRAInNewTab_Enabled = false;
        this.Spa_Site_PlanLogo_Size = 'small';
        this.Spa_ShoppingCart_IndividualEnrollmentButtons_Enabled = false;
        this.Spa_Site_CompleteHRA_DaysLeft_Text = '<hraDaysLeft> days left to complete HRA';
        // disabled by default on the mini cart but enabled by default here per comment in SPA-13698
        this.Spa_ShoppingCart_ShowHIPBenefits_Enabled = true;
        this.Spa_ValueBasedCare_Confirmation_Enabled = false;
        this.Spa_Site_PlanFees_Enabled = false;
        this.Spa_PlanFees_Tooltip_Text = 'Fees';
        this.Spa_PlanFees_IncludedInPremium_Tooltip_Text = 'Included in premium';
        this.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text = 'Not included in premium';
        this.Spa_ValueBasedCare_ConfirmationAttestation_Enabled = false;
        this.Spa_ValueBasedCare_ConfirmationAttestation_Provider_Text = 'Primary Care Provider selected: <pcpName> and <vbcOrgName>';
        this.Spa_ValueBasedCare_ConfirmationAttestation_Text = 'By clicking submit, I am providing a one-time consent to share my information with <vbcOrgName> that is inclusive of this enrollment application.';
        this.Spa_ValueBasedCare_ConfirmationAttestationSuccess_Text = 'Your application information has been sent to <vbcOrgName>';
        this.Spa_Save_Failed_ErrorText = 'Server error. Please try again.';
        this.Spa_Site_Submit = 'Submit';
        this.Spa_Site_PlanPostEnrollmentText_Enabled = true;
        this.Spa_Confirmation_ContinueApplyingForCoverageLabel_Text = 'Continue with Applying for Coverage';
        this.Spa_ValueBasedCare_Confirmation_UpdatedView_Enabled = false;
        this.Spa_ValueBasedCare_Confirmation_Next_Step_Text = 'Next Step';
        this.Spa_ValueBasedCare_Confirmation_Organization_Text = 'Organization:';
        this.Spa_ValueBasedCare_Confirmation_Provider_Name_Text = 'Provider Name:';
        this.Spa_ValueBasedCare_Confirmation_Title = 'Your Value Based Care Provider';
        this.Spa_ValueBasedCare_OptOutConsentConfirmationAttestation_Text = 'By selecting a primary care physician who is affiliated with a Value Based Care organization, you are providing your one-time consent to share your information with <vbcOrgName> that is inclusive of this enrollment.<br />If you do not want to share your information, click the Opt-out button below.';
        this.Spa_ValueBasedCare_OptOutButton_Text = 'Opt-out';
        this.Spa_ValueBasedCare_OptOutConfirmationSuccess_Text = 'Your request to opt out has been processed. Your information will not be shared with <vbcOrgName>';
        this.planTotalPremium = 0;
        this.MED_SUP_PLAN_TYPE = 3;
        this.fullName = '';
        this.applicantName = '';
        this.applicantAddress = '';
        this.pendingCoverageHeader = '';
        this.selectedRiders = [];
        this.effectiveDate = '';
        this.submissionDate = '';
        this.confirmationNumber = '';
        this.planType = PlanType;
        this.moreCoverageToEnroll = false;
        this.showConsumerBrokerFormToggle = false;
        this.enrollmentUnavailable = false;
        this.medSupUnavailable = false;
        this.isLiveEdit = false;
        this.hasAssociatedHRAEnrollment = false;
        this.isCallRecordingInProgress = false;
        this.isBrokerFormType = false;
        this.isPCApiEnrollment = false;
        this.planTypeAbbreviation = PlanTypeAbbreviation;
        this.vbcAttestationSubmitted = false;
        this.linkRoles = LinkRoles;
        this.isMobile = false;
        this.actionStringAppend = ' this application confirmation';
        this.subscriptions = new Subscription();
    }
    preProcessProperties() {
        this.isConsumerSite = !this.siteService.isPPCSite(this.Spa_Site_SiteType);
        this.isRetentionView = this.siteService.isRetentionView();
        if (this.isConsumerSite || this.isRetentionView) {
            // A client defined plan will always have isNextYearPlan equal true, but should never be considered a next year plan for the sake
            // of enrollment confirmation, so we override that flag with isClientDefinedPlan.
            this.isNextYearPlan = this.configurableWidgetService.store
                .selectSnapshot(ShoppingCartState.selectedPlans)
                .some(nextYearPlan => !nextYearPlan.isClientDefinedPlan && nextYearPlan.isNextYearPlan && !nextYearPlan.isPlanRolloverTerminated);
            if (this.isNextYearPlan && this.isRetentionView) {
                this.enrollmentConfirmationTitle = this.Spa_EnrollmentConfirmation_Title;
                this.applicantName = this.Spa_Confirmation_Applicant_Name_Label;
                this.applicantAddress = this.Spa_Confirmation_Applicant_Address_Label;
                this.pendingCoverageHeader = this.Spa_Confirmation_Pending_Coverage_Header;
                if (this.memberSessionService.getMemberSessionId()) {
                    this.showLogoutButton = !this.Spa_EnrollmentConfirmation_ShowLogout_Button;
                    this.showBrokerFlag = !!this.enrollmentConfirmationFacade.getAgentGuid();
                }
            }
            else {
                this.enrollmentConfirmationTitle = this.Spa_EnrollmentConfirmation_ApplicationSubmitted_Title;
                this.applicantName = this.Spa_EnrollmentConfirmation_MemberName_Label;
                this.applicantAddress = this.Spa_EnrollmentConfirmation_MemberAddress_Label;
                this.showBrokerFlag = this.Spa_EnrollmentConfirmation_ShowBroker_Flag;
                this.pendingCoverageHeader = this.Spa_EnrollmentConfirmation_PendingCoverage_Header;
                this.showLogoutButton = this.Spa_EnrollmentConfirmation_ShowLogout_Button;
            }
        }
        else {
            this.enrollmentConfirmationTitle = this.Spa_EnrollmentConfirmation_ApplicationSubmitted_Title;
            this.applicantName = this.Spa_EnrollmentConfirmation_MemberName_Label;
            this.applicantAddress = this.Spa_EnrollmentConfirmation_MemberAddress_Label;
            this.navLink = {
                title: this.Spa_EnrollmentConfirmation_ViewAccountOverview_Label,
                type: LinkType.INTERNAL,
                tag: PageTags.PLAN_DETAILS,
                validateWidgets: true
            };
        }
    }
    viewApplication() {
        const transactionId = this.getEnrollmentTransactionId();
        if (transactionId && this.enrollment?.confirmationNumber) {
            this.agentService.downloadEnrollmentApplicationPDF(transactionId, this.enrollment.confirmationNumber, this.planHasNextGenForm);
        }
        else {
            this.enrollmentConfirmationFacade.downloadEnrollmentApplicationPDF();
        }
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_ENROLLMENT_VIEW_APPLICATION);
    }
    shopForSomeoneElse() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_ENROLLMENT_SHOPFORSOMEONEELSE);
        // SPA-14857 we don't logout via the route-auth for consumers anymore, which this button was relying on.
        // So now we'll just manually log out when we click this.
        this.memberSessionService.memberLogout();
        this.confirmationService.resetConfirmationState();
        this.navigationService.navigateByPageTag(PageTags.HOME);
    }
    viewPlanDetails(plan) {
        this.cartFacade.viewPlanDetails(plan);
    }
    getPlanDescription(plan) {
        return this.planFacade.getPlanDescription(plan, this.widgetService.widgetName);
    }
    async email() {
        const options = {
            ariaLabelledBy: 'modalHeaderTitle',
            centered: true,
            injector: this.injector
        };
        const emailModal = this.modalService.open(EmailConfirmationModalComponent, options);
        emailModal.componentInstance.title = this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Title;
        emailModal.componentInstance.emailPrompt = this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Prompt;
        emailModal.componentInstance.cancelButton = this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Cancel;
        emailModal.componentInstance.confirmButton = this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Continue;
        emailModal.componentInstance.emailAddressRequired = this.Spa_EnrollmentConfirmation_EmailConfirmationModal_EmailAddressRequired;
        emailModal.componentInstance.emailAddressInvalid = this.Spa_EnrollmentConfirmation_EmailConfirmationModal_EmailAddressInvalid;
        emailModal.result
            .then(async (email) => {
            if (email) {
                const enrollingPlanId = this.enrollmentFormService.getActiveEnrollmentKey();
                await this.enrollmentFormService.sendConsumerConfirmationEmail({
                    planId: enrollingPlanId,
                    email,
                    generatedUrlParameters: this.consumerAccountAcccessEmailUrlParameters
                });
                this.showEmailSuccessModal(email);
            }
        }, () => {
            this.setFocusToEmailConfirmationButton();
        })
            .catch(() => {
            this.setFocusToEmailConfirmationButton();
        });
    }
    setFocusToEmailConfirmationButton() {
        if (this.emailConfirmationButtonElement) {
            this.emailConfirmationButtonElement.nativeElement.focus();
        }
    }
    print() {
        window.print();
    }
    ngOnInit() {
        super.ngOnInit();
        // look for "completedEnrollmentSteps" in the navigation state to check if the user comes from completing the enrollment steps
        // router.getCurrentNavigation() returns null even inside the constructor because the value is already written in the history state
        const { completedEnrollmentSteps, enrollmentPlan } = history.state ?? {};
        const environment = EnvironmentService.getEnvironment();
        this.isLiveEdit = environment.liveedit;
        this.hasAgentCallRecordingBeenSkipped$ = this.twilioService.getHasSkippedTheCall$();
        this.isCallRecordingInProgress = this.twilioService.connection?.status() === Call.State.Open;
        this.isBrokerFormType = this.enrollmentFormFacade.getUserFormType(this.cartFacade.getSelectedPlan()?.id) !== UserTypeKeys.CONSUMER;
        const enrollingPlanId = this.isRetentionView
            ? this.getRetentionSitePlanId()
            : this.enrollmentFormService.getActiveEnrollmentKey();
        this.isSingleCarrierSite = !this.shoppingCartService.isMultiCarrierSite();
        this.allowsCallRecordingOnMultiCarrierSite =
            !this.isSingleCarrierSite && this.shoppingCartService.allowsCallRecordingOnMultiCarrier(enrollingPlanId);
        this.confirmationService.setConfirmationVisited();
        if (this.isRetentionView) {
            this.retentionPlans$ = this.retentionFacade.getPlans$();
            this.subscriptions.add(this.retentionPlans$.subscribe({
                next: plans => {
                    this.nextYearPlanId = this.retentionFacade.getNextYearPlanFromPlansList(plans)?.id;
                    this.option2PlanId = this.retentionFacade.getOption2PlanFromPlansList(plans)?.id;
                }
            }));
        }
        this.subscriptions.add(this.isMobile$.subscribe({
            next: isMobile => {
                this.isMobile = isMobile;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(combineLatest([
            this.enrollmentFormService.getFormLoading$(enrollingPlanId),
            this.enrollmentFormService.getConfirmationDataLoading$(enrollingPlanId)
        ])
            .pipe(map(([formLoading, confirmationDataLoading]) => formLoading || confirmationDataLoading), distinctUntilChanged())
            .subscribe({
            next: isEnrollmentFormLoading => {
                isEnrollmentFormLoading
                    ? this.configurableWidgetService.spinnerService.show(SpinnerEvent.ENROLLMENT_FORM_LOADING)
                    : this.configurableWidgetService.spinnerService.hide(SpinnerEvent.ENROLLMENT_FORM_LOADING);
            }
        }));
        this.subscriptions.add(this.liveEditStateContext.currentLiveEditState$.subscribe({
            next: liveEditState => {
                if (liveEditState) {
                    if (liveEditState.name === 'Enrollment Unavailable') {
                        this.handleLiveEditUpdateForUnavailableComponent();
                    }
                    this.cdr.markForCheck();
                }
            }
        }));
        this.subscriptions.add(this.liveEditStateContext.currentLiveEditState$.subscribe({
            next: liveEditState => {
                if (liveEditState) {
                    if (liveEditState.name === 'Cross Sell Enrollment Confirmation') {
                        this.handleLiveEditUpdateForCrossSell();
                    }
                    this.cdr.markForCheck();
                }
            }
        }));
        this.subscriptions.add(this.localeService.getCountryCode$.subscribe({
            next: countryCode => {
                if (countryCode) {
                    this.countryCode = countryCode;
                }
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe({
            next: locale => {
                this.currentLocale = locale;
                if (this.Spa_Site_PlanPostEnrollmentText_Enabled && this.planPostEnrollmentText) {
                    this.planPostEnrollmentConfirmationText = this.planPostEnrollmentText[locale] ?? '';
                }
                this.premiumLabel = this.planFacade.getPremiumLabel();
                this.cdr.markForCheck();
            }
        }));
        if (this.Spa_Site_PlanPostEnrollmentText_Enabled) {
            this.subscriptions.add(this.enrollmentFormService.getPlanPostEnrollmentData$().subscribe({
                next: (planPostEnrollment) => {
                    this.planPostEnrollmentText = planPostEnrollment?.postEnrollmentMessages?.confirmationPageText;
                    this.planPostEnrollmentConfirmationText = this.planPostEnrollmentText?.[this.currentLocale] ?? '';
                    this.cdr.markForCheck();
                }
            }));
        }
        this.subscriptions.add(this.enrollmentFormService.getConsumerAccessEmailUrlParameters$().subscribe({
            next: parameters => {
                if (parameters) {
                    this.consumerAccountAcccessEmailUrlParameters = parameters;
                }
            }
        }));
        if (enrollmentPlan?.id === enrollingPlanId) {
            this.enrollmentPlan = enrollmentPlan;
        }
        this.fullName = this.store.selectSnapshot(ProfileState.fullName);
        this.addresses = this.store.selectSnapshot(ProfileState.addresses);
        this.navLink = {
            title: this.Spa_EnrollmentConfirmation_ViewAccountOverview_Label,
            type: LinkType.INTERNAL,
            tag: PageTags.PLAN_DETAILS,
            validateWidgets: true
        };
        if (this.configResourceService.getProcessedResourceValue('JsonAnalytics_Enabled', null, false)) {
            this.updateJsonAnalyticsData();
        }
        this.isAgentCallRecordingEnabled = this.agentCallRecordingFacade.isAgentCallRecordingEnabled();
        this.enrollmentConfirmationNextStepsText = this.Spa_EnrollmentConfirmation_NextStepsBody_Text.replace('<callInProgress>', this.getHRANextStepsText());
        this.subscriptions.add(from(this.initializeEnrollmentConfirmationData(enrollingPlanId))
            .pipe(switchMap(() => {
            // if the user completed the enrollment steps, we can skip fetching the transaction data (already stored)
            // if not, then fetch the transaction data since we might not have it stored
            if (!completedEnrollmentSteps) {
                const transactionId = this.getEnrollmentTransactionId();
                if (transactionId) {
                    return this.planHasNextGenForm
                        ? this.enrollmentFormService.fetchNextGenTransaction$(this.store.selectSnapshot(MemberState.sessionId), enrollingPlanId, transactionId)
                        : this.enrollmentFormService.fetchTransaction$(enrollingPlanId, transactionId);
                }
            }
            return of(null);
        }), switchMap(() => {
            return this.providerFacade.fetchValueBasedCareConfirmation$(this.enrollmentPlan);
        }), switchMap(vbcProvider => {
            if (vbcProvider?.optin === false) {
                const vbcAttestation = {
                    pcpName: vbcProvider.pcpName,
                    vbcOrgName: vbcProvider.vbcOrgName,
                    npi: vbcProvider.npi,
                    vbcid: vbcProvider.vbcid,
                    optin: true
                };
                return from(this.updateVbcConfirmationAttestation(vbcAttestation, false)).pipe(tap(() => {
                    this.vbcAttestationSubmitted = false;
                    this.cdr.markForCheck();
                }), map(() => vbcProvider));
            }
            return of(vbcProvider);
        }))
            .subscribe({
            next: vbcProvider => {
                this.valueBasedCareProvider = vbcProvider;
                this.vbcWhitelisted = this.providerFacade.isWhitelistedVBC(this.valueBasedCareProvider?.vbcid);
                let hraUserType;
                let transactionId;
                if (this.planHasNextGenForm) {
                    const nextGenForm = this.enrollmentFormService.getNextGenTransaction(enrollingPlanId);
                    hraUserType = nextGenForm?.hraUserType;
                    transactionId = nextGenForm?.transactionGUID;
                }
                else {
                    const form = this.enrollmentFormService.getForm(enrollingPlanId);
                    hraUserType = form?.hraUserType;
                    transactionId = form?.transaction?.transactionGUID;
                }
                this.enrollmentHRAUserType = hraUserType;
                this.enrollmentTransactionGUID = transactionId;
                this.updateDataLayer();
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.enrollmentFormService.getIsPCApiEnrollment$(enrollingPlanId).subscribe({
            next: isPCApiEnrollment => {
                this.isPCApiEnrollment = isPCApiEnrollment || false;
                this.cdr.markForCheck();
            }
        }));
    }
    updateDataLayer() {
        const selectedNextYearPlan = this.store.selectSnapshot(ShoppingCartState.selectedPlans);
        if (this.enrollment || selectedNextYearPlan.length) {
            const googleTagManagerNotApplicableText = this.analyticsService.getGoogleTagManagerNotApplicableText();
            const externalMemberId = this.store.selectSnapshot(DeepLinkingParamsState.ssoValue);
            const externalReferenceId = this.store.selectSnapshot(DeepLinkingParamsState.pegi);
            const confirmationNumber = this.enrollment ? this.enrollment.confirmationNumber : this.Spa_Site_NotApplicable_Text;
            const monthlyPremium = this.enrollmentPlan ? this.enrollmentFormFacade.getEnrollingPlanPremium(this.enrollmentPlan.id) : '0';
            const isVbcAttestionPresent = this.Spa_ValueBasedCare_Confirmation_Enabled && this.valueBasedCareProvider && this.vbcWhitelisted;
            if (this.siteService.isRetentionView()) {
                this.analyticsService.googleDataLayerTags = {
                    [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE,
                    [DataLayerGlobalVariable.ENROLLMENT_CONFIRMATION_NUMBER]: confirmationNumber,
                    [DataLayerGlobalVariable.PLAN_ID_ENROLLED]: this.enrollmentPlan ? this.enrollmentPlan.id : selectedNextYearPlan[0]?.id,
                    [DataLayerGlobalVariable.PLAN_ID_NEXT_YEAR]: this.nextYearPlanId ?? googleTagManagerNotApplicableText,
                    [DataLayerGlobalVariable.PLAN_ID_NEXT_YEAR2]: this.option2PlanId ?? googleTagManagerNotApplicableText,
                    [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
                    [DataLayerGlobalVariable.PLAN_CARRIER]: this.enrollmentPlan?.carrierName,
                    [DataLayerGlobalVariable.PLAN_TYPE]: this.enrollmentPlan?.planTypeAbbreviation ?? googleTagManagerNotApplicableText,
                    [DataLayerGlobalVariable.PLAN_ID]: this.enrollmentPlan?.id ?? googleTagManagerNotApplicableText,
                    [DataLayerGlobalVariable.EXTERNAL_MEMBER_ID]: externalMemberId || googleTagManagerNotApplicableText,
                    [DataLayerGlobalVariable.EXTERNAL_REFERENCE_ID]: externalReferenceId || googleTagManagerNotApplicableText,
                    [DataLayerGlobalVariable.HRA_FORM_LINK_AVAILABLE]: this.getFormLinkAvailableText(),
                    [DataLayerGlobalVariable.PLAN_ID_BEST_MATCH]: this.planListFacade.getBestMatchPlanIdValueForAnalytics(),
                    [DataLayerGlobalVariable.PLAN_TYPE_BEST_MATCH]: this.planListFacade.getBestCoverageTabAbbreviationValueForAnalytics(),
                    [DataLayerGlobalVariable.ENROLLMENT_PLAN_COUNT]: `${this.shoppingCartService.getEnrollmentPlanCount()}`,
                    [DataLayerGlobalVariable.PLAN_NAME]: this.enrollmentPlan?.planName ?? googleTagManagerNotApplicableText,
                    [DataLayerGlobalVariable.PLAN_PREMIUM_MONTHLY]: monthlyPremium,
                    [DataLayerGlobalVariable.PLAN_PROVIDER_VBC_STATUS]: this.planFacade.isVbcAgreementExists(this.enrollmentPlan)
                        ? GOOGLE_ANALYTICS_YES
                        : GOOGLE_ANALYTICS_NO,
                    [DataLayerGlobalVariable.VBC_ATTESTATION_IS_PRESENT]: isVbcAttestionPresent ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO
                };
            }
            else {
                let tagsToUpdate = {
                    [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE,
                    [DataLayerGlobalVariable.ENROLLMENT_CONFIRMATION_NUMBER]: confirmationNumber,
                    [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
                    [DataLayerGlobalVariable.PLAN_CARRIER]: this.enrollmentPlan?.carrierName,
                    [DataLayerGlobalVariable.PLAN_TYPE]: this.enrollmentPlan?.planTypeAbbreviation ?? googleTagManagerNotApplicableText,
                    [DataLayerGlobalVariable.PLAN_ID]: this.enrollmentPlan?.id ?? googleTagManagerNotApplicableText,
                    [DataLayerGlobalVariable.EXTERNAL_MEMBER_ID]: externalMemberId || googleTagManagerNotApplicableText,
                    [DataLayerGlobalVariable.EXTERNAL_REFERENCE_ID]: externalReferenceId || googleTagManagerNotApplicableText,
                    [DataLayerGlobalVariable.HRA_FORM_LINK_AVAILABLE]: this.getFormLinkAvailableText(),
                    [DataLayerGlobalVariable.PLAN_ID_BEST_MATCH]: this.planListFacade.getBestMatchPlanIdValueForAnalytics(),
                    [DataLayerGlobalVariable.PLAN_TYPE_BEST_MATCH]: this.planListFacade.getBestCoverageTabAbbreviationValueForAnalytics(),
                    [DataLayerGlobalVariable.ENROLLMENT_PLAN_COUNT]: `${this.shoppingCartService.getEnrollmentPlanCount()}`,
                    [DataLayerGlobalVariable.PLAN_NAME]: this.enrollmentPlan?.planName ?? googleTagManagerNotApplicableText,
                    [DataLayerGlobalVariable.PLAN_PREMIUM_MONTHLY]: monthlyPremium,
                    [DataLayerGlobalVariable.PLAN_PROVIDER_VBC_STATUS]: this.planFacade.isVbcAgreementExists(this.enrollmentPlan)
                        ? GOOGLE_ANALYTICS_YES
                        : GOOGLE_ANALYTICS_NO,
                    [DataLayerGlobalVariable.VBC_ATTESTATION_IS_PRESENT]: isVbcAttestionPresent ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO
                };
                tagsToUpdate = this.enrollmentFormService.updateTagForEnrollmentMethod(tagsToUpdate, this.enrollmentPlan?.id);
                // We need both tags data-CrossSellEnrollment when we are in a cross sell enrollment
                // and data-CrossSell-ContinueEnrollment when the 'Continue enrollment' button is displayed
                tagsToUpdate = this.enrollmentFormService.updateTagForCrossSell(tagsToUpdate, this.moreCoverageToEnroll);
                this.analyticsService.googleDataLayerTags = tagsToUpdate;
            }
        }
    }
    getRiderPremium(rider) {
        return this.riderFacade.getRiderMedicalPremium(rider);
    }
    async continueApplyingForCoverage(toolTip) {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_ENROLLMENT_CROSS_SELL_CONTINUE_APPLYING);
        // If there is more plan to enroll, continue with the enrollment
        if (!this.Spa_ShoppingCart_IndividualEnrollmentButtons_Enabled) {
            this.confirmationService.removeEnrolledPlansFromShoppingCart();
        }
        // If agent call recording is enabled, hangup and go back to cart to start new call for remaining enrollment
        if (this.isAgentCallRecordingEnabled) {
            this.twilioService.hangup(true);
            this.navigationService.navigateByPageTag(PageTags.SHOPPING_CART);
        }
        else if (this.Spa_ShoppingCart_IndividualEnrollmentButtons_Enabled) {
            if (this.moreCoverageToEnroll) {
                // We don't want the user to be logged out in this scenario, so we need to reset the state
                // to keep a flag used for that to false
                this.confirmationService.resetConfirmationState();
            }
            this.navigationService.navigateByPageTag(PageTags.SHOPPING_CART);
        }
        else {
            const enrollingPlan = this.getNextPlanForEnrollment();
            await this.setEnrollmentSettings(enrollingPlan);
            const fips = this.demographicService.getSelectedFipsCode();
            const date = this.cartFacade.getAgentPlanPermissionEffectiveDate(enrollingPlan.planType);
            this.cartFacade.checkEnrollmentStatusAndAgentPermissions(enrollingPlan, date, fips, toolTip, this.enroll.bind(this));
        }
    }
    getNextPlanForEnrollment() {
        return this.shoppingCartService.getSelectedPlan();
    }
    async setEnrollmentSettings(enrollingPlan) {
        this.planEnrollmentSettings = await this.plansService.fetchAllPlanEnrollmentSettingsForCrossSell(enrollingPlan.id);
        this.shortFormSettings = this.planEnrollmentSettings.filter(setting => setting.foamFormType === EnrollmentFormType.SHORT && setting.formId !== null);
        this.longFormSettings = this.planEnrollmentSettings.filter(setting => setting.foamFormType === EnrollmentFormType.LONG && setting.formId !== null);
        if (this.showConsumerBrokerSelection(enrollingPlan)) {
            const userFormType = this.enrollmentFormFacade.getUserFormType(enrollingPlan.id);
            if (userFormType === null) {
                this.shoppingCartContextService.setIsValidForEnrollment(enrollingPlan.id, false);
            }
            else {
                // As long form is default we need to check if there is a matching long form for the selection
                // so as to not error out.  Per validation above userType must be set.
                this.enrollmentFormFacade.validateMatchingLongForm(enrollingPlan.id, this.longFormSettings);
                // As short forms aren't usually given we need to check if there is one and
                // reset the default to long if there isn't one for the agent/form selection.
                this.enrollmentFormFacade.validateMatchingShortForm(enrollingPlan.id, this.shortFormSettings);
            }
        }
    }
    showConsumerBrokerSelection(plan) {
        return (this.plansService.isConsumerBrokerSelectionAllowedForPlanType(plan) &&
            this.checkConsumerBrokerSelectionForPlan(plan) &&
            this.enrollmentFormFacade.getConsumerBrokerToggleEnabled() &&
            this.enrollmentFormFacade.canSendApplicationToBeneficiary(plan));
    }
    checkConsumerBrokerSelectionForPlan(plan) {
        return plan && this.planEnrollmentSettings && this.enrollmentFormService.showAgentFormSelection(this.planEnrollmentSettings);
    }
    enroll(planId) {
        this.initializeEnrollmentUnavailableComponent();
        this.enrollmentFormService.setActiveEnrollmentKey(planId);
        this.confirmationService.resetConfirmationState();
        const isMedSupEnrollment = this.cartFacade.isMedSupEnrollment(planId);
        if (isMedSupEnrollment) {
            this.enrollInMedSupPlan();
        }
        else {
            const planType = this.planFacade.getPlan(planId)?.planType;
            if (this.shoppingCartService.isEnrollmentEnabledByPlanType(planType)) {
                this.planFacade.enroll(this.widgetName);
            }
            else {
                this.enrollmentUnavailable = true;
            }
        }
    }
    resetStatus() {
        if (this.medSupUnavailable) {
            this.medSupUnavailable = false;
        }
        else {
            this.enrollmentUnavailable = false;
        }
    }
    closeEnrollmentTooltip(toolTip) {
        this.enrollmentFormFacade.closeTooltip(toolTip);
    }
    showHospitalIndemnityBenefits(plan) {
        this.cartFacade.showHospitalIndemnityBenefits(plan, this.benefitsForHIPPopover);
    }
    closeHIPBenefitsPopover() {
        this.benefitsForHIPPopover.close();
    }
    async updateVbcConfirmationAttestation(event, setVbcAttestationSubmitted = true) {
        const vbcSubmitted = await this.providerFacade.updateVbcAttestationConfirmation({
            ...event,
            confirmationNumber: this.enrollment.confirmationNumber
        });
        if (setVbcAttestationSubmitted) {
            this.vbcAttestationSubmitted = vbcSubmitted;
            this.cdr.markForCheck();
        }
    }
    ngAfterViewInit() {
        this.clearApiShoppingCart();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        if (!this.Spa_ShoppingCart_IndividualEnrollmentButtons_Enabled) {
            this.confirmationService.removeEnrolledPlansFromShoppingCart();
        }
        this.subscriptions.unsubscribe();
    }
    getRetentionSitePlanId() {
        const selectedPlans = this.shoppingCartService.getSelectedPlans();
        selectedPlans.find(nextYearPlan => nextYearPlan.isNextYearPlan && !nextYearPlan.isPlanRolloverTerminated && this.shoppingCartService.isMedicarePlan(nextYearPlan));
        return selectedPlans?.length ? selectedPlans[0].id : null;
    }
    getFormLinkAvailableText() {
        if (!this.Spa_Site_HRA_Enabled) {
            return 'no';
        }
        if (!this.hraPlanType || this.hraPlanType === PlanHRAType.NONE) {
            return 'no';
        }
        else {
            return `yes|${this.hraPlanType.toLowerCase()}`;
        }
    }
    handleLiveEditUpdateForCrossSell() {
        this.moreCoverageToEnroll = true;
    }
    handleLiveEditUpdateForUnavailableComponent() {
        this.initializeEnrollmentUnavailableComponent();
        if (!this.Spa_Site_Enrollment_Enabled) {
            this.enrollmentUnavailable = true;
        }
        else {
            if (!this.Spa_Site_MedSupEnrollment_Enabled) {
                this.medSupUnavailable = true;
            }
        }
    }
    initializeEnrollmentUnavailableComponent() {
        this.enrollmentUnavailableTitle = this.configResourceService.getProcessedResourceValue('Spa_ShoppingCart_EnrollmentUnavailable_Title', null, 'Enrollment is not currently available');
        this.enrollmentUnavailableButton = this.configResourceService.getProcessedResourceValue('Spa_ShoppingCart_EnrollmentUnavailable_Button', null, 'Close');
        this.medSupUnavailableMessage = this.shoppingCartService.getMedSupUnavailableMessage();
        this.enrollmentUnavailableMessage = this.shoppingCartService.getEnrollmentUnavailableMessage();
    }
    enrollInMedSupPlan() {
        if (this.Spa_Site_MedSupEnrollment_Enabled) {
            if (this.SPA_Site_Medigap_Enrollment_InterimPage_Enable) {
                this.navigationService.navigateByPageTag(PageTags.MEDIGAP_INTERIM);
            }
            else {
                this.planFacade.enroll(this.widgetName);
            }
        }
        else {
            this.medSupUnavailable = true;
        }
    }
    clearApiShoppingCart() {
        if (!this.Spa_ShoppingCart_IndividualEnrollmentButtons_Enabled) {
            const enrollmentKey = this.enrollmentFormService.getActiveEnrollmentKey();
            if (enrollmentKey) {
                this.shoppingCartService.removePlanFromAPI(enrollmentKey);
            }
        }
    }
    updateJsonAnalyticsData() {
        this.jsonAnalyticsService.setJsonAnalyticsTag(JsonAnalyticsGlobalVariable.PLAN_NAME, this.enrollmentPlan.planName);
        this.jsonAnalyticsService.setJsonAnalyticsTag(JsonAnalyticsGlobalVariable.PLAN_TYPE, this.enrollmentPlan.planTypeAbbreviation);
        this.jsonAnalyticsService.setJsonAnalyticsTag(JsonAnalyticsGlobalVariable.MONTHLY_PREMIUM, this.planFacade.getTotalPremium([this.enrollmentPlan], this.selectedRiders).toString());
        this.jsonAnalyticsService.setJsonAnalyticsTag(JsonAnalyticsGlobalVariable.ZIP_CODE, this.memberSessionService.getZipCode());
        if (this.enrollment) {
            this.jsonAnalyticsService.setJsonAnalyticsTag(JsonAnalyticsGlobalVariable.APPLICATION_DATE, DateUtilities.getDateFromUtc(this.enrollment.completedWhen));
            this.jsonAnalyticsService.setJsonAnalyticsTag(JsonAnalyticsGlobalVariable.REQUESTED_EFFECTIVE_DATE, this.getFormattedDate(this.enrollment.effectiveDate, DateUtilities.defaultFormat));
        }
        this.jsonAnalyticsService.setJsonAnalyticsTag(JsonAnalyticsGlobalVariable.CONFIRMATION_ID, this.confirmationNumber);
        this.jsonAnalyticsService.setJsonAnalyticsTag(JsonAnalyticsGlobalVariable.PLAN_STARS, this.enrollmentPlan?.planRating && this.enrollmentPlan.planRating !== 0
            ? this.enrollmentPlan.planRating.toString()
            : this.Spa_StarRating_Default_Text);
        this.jsonAnalyticsService.addToDataLayer();
    }
    async initializeEnrollmentConfirmationData(enrollingPlanId) {
        this.enrollmentFormService.setConfirmationDataLoading$(true, enrollingPlanId);
        if (this.showBrokerFlag) {
            this.brokerData = this.enrollmentConfirmationFacade.getBrokerData();
            this.brokerPhoneNumber = this.phoneService.parsePhoneNumberWithExtension(this.brokerData?.phone, this.brokerData?.ext);
        }
        this.effectiveDate = this.enrollmentConfirmationFacade.getEffectiveDate();
        // When dealing with fetchSession and the different ways we can get to confirmation, sometimes we can lose
        // where we normally store selectedPlans. We can still though get plans from the shopping cart
        // as we can't enroll in plans not in the cart (and we still use it when cart feature is disabled)
        const selectedNextYearPlan = this.store.selectSnapshot(ShoppingCartState.selectedPlans);
        const cartPlans = this.store.selectSnapshot(ShoppingCartState.selectCartAPIState).map(cartPlan => cartPlan);
        const planIds = cartPlans.map(cartPlan => cartPlan.planId);
        const sessionId = this.store.selectSnapshot(MemberState.session).sessionId;
        // Do not remove. Needed in case enrollment postback failed and need
        // to refresh member enrollments to get confirmation number/submit date
        await this.memberSessionService.fetchMemberSession$({ sessionId, isEnrollmentHistoryIncluded: true }).toPromise();
        const isActivePlanInCart = planIds.some(planId => planId === enrollingPlanId);
        if (!isActivePlanInCart) {
            // This scenario can happen when we are re-accessing the link from the email sent to beneficiary
            // to access the confirmation page after the application is submitted (when the plan is not in the cart anymore,
            // but we still need to pull in info like confirmation number etc for the confirmation page)
            planIds.push(enrollingPlanId);
        }
        const enrollments = this.confirmationService.getEnrollments(planIds);
        this.enrollment = this.enrollmentFormFacade.getLatestCompletedEnrollment(enrollingPlanId, enrollments);
        if (!this.enrollment && !selectedNextYearPlan.length) {
            return;
        }
        this.planHasNextGenForm = this.enrollment?.enrollSystemType === EnrollSystemType.NextGen;
        // Load enrolled plan again to bring the shopping cart to initial display state.
        if (this.enrollment) {
            this.hasAssociatedHRAEnrollment = this.enrollment.associatedHRAEnrollmentID !== undefined;
            this.enrollmentSubmittedDate = this.enrollment.completedWhen;
            if (this.enrollmentPlan?.planId !== this.enrollment.planID) {
                const isActivePlanSelected = selectedNextYearPlan.length && selectedNextYearPlan.find(selectedPlan => selectedPlan.id === this.enrollment.planID);
                this.enrollmentPlan = isActivePlanSelected || this.planFacade.getPlan(this.enrollment.planID);
                // Send to Beneficiary: if there's no plans data available in the store, then we have to request the plan details
                if (!this.enrollmentPlan) {
                    this.enrollmentPlan = await this.getEnrolledPlanDetails();
                }
            }
            this.hraPlanType = this.plansService.getExtraDataValueByName(this.enrollmentPlan, PlanExtraDataKey.HRA);
            this.submissionDate = DateUtilities.getDateFromUtc(this.enrollment.completedWhen, 'LL');
            this.confirmationNumber = this.enrollment.confirmationNumber;
            this.vbcAttestationSubmitted = await this.providerFacade.getVbcAttestationConfirmation(this.confirmationNumber);
            if (isActivePlanInCart) {
                // Re-select plan in case shopping cart state was cleared when fetching member session return shopping cart data
                this.store.dispatch(new SelectPlan(this.enrollmentPlan, false));
                if (this.enrollment.selectedRiderIDs) {
                    this.selectedRiders = this.enrollmentPlan.riders.filter(rider => this.enrollment.selectedRiderIDs.includes(rider.planID));
                    this.enrollment.selectedRiderIDs.forEach(riderId => this.store.dispatch(new SelectRider(riderId)));
                }
            }
        }
        else {
            // Retention case - we don't have enrollment for next year plans.
            this.enrollmentPlan = this.planFacade.getPlan(enrollingPlanId);
            if (isActivePlanInCart) {
                this.store.dispatch(new SelectPlan(this.enrollmentPlan, false));
            }
        }
        this.confirmationService.reselectUnenrolledPlans(cartPlans, this.enrollment);
        this.moreCoverageToEnroll = false;
        // Check for unenrolled plans in cart
        // Set moreCoverageToEnroll flag to true if there are unenrolled plans in cart.
        this.moreCoverageToEnroll = this.confirmationService.setMoreCoverageToEnroll(planIds, this.Spa_ShoppingCart_IndividualEnrollmentButtons_Enabled, this.enrollmentPlan, enrollments);
        this.planTotalPremium = this.planFacade.getTotalPremium([this.enrollmentPlan]);
        this.enrollmentFormService.setConfirmationDataLoading$(false, enrollingPlanId);
        this.cdr.markForCheck();
    }
    showEmailSuccessModal(email) {
        const emailSuccessModal = this.modalService.open(EmailConfirmationSuccessModalComponent, { centered: true });
        emailSuccessModal.componentInstance.title = this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Title;
        emailSuccessModal.componentInstance.prompt = this.Spa_EnrollmentConfirmation_EmailConfirmationModal_SuccessMessage.replace('<email>', email);
        emailSuccessModal.componentInstance.closeButton = this.Spa_EnrollmentConfirmation_EmailConfirmationModal_Close;
        emailSuccessModal.result
            .then(() => {
            this.setFocusToEmailConfirmationButton();
        }, () => {
            this.setFocusToEmailConfirmationButton();
        })
            .catch(() => {
            this.setFocusToEmailConfirmationButton();
        });
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_ENROLLMENT_EMAIL_CONFIRMATION);
    }
    getFormattedDate(date, format) {
        return DateUtilities.getFormattedDateTime(new Date(date), format);
    }
    getHRANextStepsText() {
        return this.isCallRecordingInProgress ? this.Spa_EnrollmentConfirmation_CallInProgress_NextStepsBody_Text : '';
    }
    async getEnrolledPlanDetails() {
        if (this.enrollment) {
            return await this.planFacade.getPlanByPlanID(this.enrollment.planID, this.enrollment.planTypeID);
        }
    }
    getEnrollmentTransactionId() {
        return this.planHasNextGenForm ? this.enrollment?.nativeTransactionID : this.enrollment?.transactionSID;
    }
};
EnrollmentConfirmationComponent.ɵfac = function EnrollmentConfirmationComponent_Factory(t) { return new (t || EnrollmentConfirmationComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(CartFacade), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(EnrollmentFormFacade), i0.ɵɵdirectiveInject(i1.TwilioDeviceService), i0.ɵɵdirectiveInject(RiderFacade), i0.ɵɵdirectiveInject(EnrollmentConfirmationFacade), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.JsonAnalyticsService), i0.ɵɵdirectiveInject(i1.ShoppingCartService), i0.ɵɵdirectiveInject(EnrollmentConfirmationService), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(i1.DemographicService), i0.ɵɵdirectiveInject(ShoppingCartContextService), i0.ɵɵdirectiveInject(i1.LiveEditStateContext), i0.ɵɵdirectiveInject(AgentCallRecordingFacade), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.PhoneUtilityService), i0.ɵɵdirectiveInject(PlanListFacadeService), i0.ɵɵdirectiveInject(RetentionFacade), i0.ɵɵdirectiveInject(ProviderFacade)); };
EnrollmentConfirmationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EnrollmentConfirmationComponent, selectors: [["vnext-enrollment-confirmation"]], viewQuery: function EnrollmentConfirmationComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$2a, 5);
        i0.ɵɵviewQuery(_c1$10, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.emailConfirmationButtonElement = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.benefitsForHIPPopover = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 3, consts: [["class", "container confirmation-page", "vnextGoogleTagManager", "", 3, "disableCommonEvent", 4, "ngIf"], ["class", "container", 4, "ngIf"], [4, "ngIf"], ["benefitsForHIPPopoverTemplate", ""], ["vnextGoogleTagManager", "", 1, "container", "confirmation-page", 3, "disableCommonEvent"], [1, "row"], [1, "col-12", "text-center"], ["class", "page-title Spa_Style_H1", 4, "liveEditProp"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["confirmationSection", ""], ["noConfirmationSection", ""], [1, "d-flex", "mb-2", "justify-content-end", "mb-3", "mt-3"], ["type", "button", "tabindex", "0", "class", "action-button Spa_Style_Link d-inline", 3, "title", "click", 4, "ngIf"], [1, "pl-2", 3, "title", "keyNameForLiveEdit", "customClass", "additionalIcon", "ariaLabel", "isLinkButton", "click"], [1, "col-12", "col-lg-8", "expect-section"], ["class", "Spa_Style_Paragraph mb-3 mt-2", 3, "innerHTML", 4, "ngIf"], [1, "contact-section"], ["broker", ""], ["carrier", ""], [1, "col-12", "col-lg-4"], [1, "application-details"], ["class", "application-details-title Spa_Style_H2 Spa_Style_Primary_Color Spa_Style_Bold_Weight", 4, "liveEditProp"], [1, "application-details-body"], ["class", "Spa_Style_Label", 4, "liveEditProp"], [1, "application-data", "Spa_Style_Paragraph", "no-translate-block"], ["class", "application-data Spa_Style_Paragraph no-translate-block", 4, "ngIf"], ["class", "application-id", 4, "ngIf"], ["class", "call-recording mt-3 mb-2", 4, "ngIf"], [1, "col-12"], ["class", "Spa_Style_H2 pending-coverage-title Spa_Style_Primary_Color Spa_Style_Bold_Weight", 4, "liveEditProp"], ["class", "row", 4, "ngIf"], ["class", "row mb-5", 4, "ngIf"], [1, "page-title", "Spa_Style_H1"], [1, "col-12", "Spa_Style_Cost_Background", "Spa_Style_Bold_Weight", "confirmation-message", "p-2", "mt-5"], [1, "Spa_Style_CostPremiumSmall", "pr-2", "pl-2"], ["aria-hidden", "true", 1, "fas", "fa-check-circle"], ["noticeTitle", ""], ["noticeBody", ""], ["crosssellNoticeTitle", ""], ["crosssellNoticeBody", ""], ["crosssellCallInProgressNoticeBody", ""], [3, "titleTemplate", "bodyTemplate"], [4, "liveEditProp"], ["class", "mb-0", 4, "liveEditProp"], [1, "mb-0"], [3, "innerHtml", 4, "liveEditProp"], [3, "innerHtml"], [3, "type", "hasButton", "buttonText", "buttonAriaLabel", "titleTemplate", "bodyTemplate", "toolTipText", "keyNameForLiveEdit", "applyEvent", "closeTooltipEvent", 4, "ngIf"], [3, "type", "hasButton", "buttonText", "buttonAriaLabel", "titleTemplate", "bodyTemplate", "toolTipText", "keyNameForLiveEdit", "applyEvent", "closeTooltipEvent"], ["type", "button", "tabindex", "0", 1, "action-button", "Spa_Style_Link", "d-inline", 3, "title", "click"], ["emailConfirmationButton", ""], [1, "fa", "fa-envelope", "pr-1"], ["class", "Spa_Style_H2", 4, "liveEditProp"], ["class", "Spa_Style_Paragraph", "navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], [1, "Spa_Style_H2"], ["navigationAdapter", "", 1, "Spa_Style_Paragraph", 3, "innerHTML"], [1, "Spa_Style_Paragraph", "mb-3", "mt-2", 3, "innerHTML"], [3, "messageText", "primaryButtonText", "secondaryButtonText", "primaryButtonLink", "secondaryButtonLink", "vbcConfirmationAttestationEnabled", "pcpName", "vbcOrgName", "vbcid", "npi", "optInEnabled", "vbcConfirmationAttestationProviderText", "vbcConfirmationAttestationText", "vbcOptOutConsentConfirmationAttestationText", "optInConfirmationSuccessText", "saveFailedErrorText", "submitButtonText", "optOutSubmitButtonText", "optOutConfirmationSuccessText", "vbcAttestationSubmitted", "vbcTitle", "providerNameLabel", "orgNameLabel", "nextStepLabel", "isDefaultView", "onVbcConfirmationAttestationSubmit"], [3, "hraEnabled", "nextStepsTitle", "nextStepsBody", "hraAvailableAfterEnrollmentText", "hraButtonText", "enrollmentPlan", "modalCancelText", "modalContinueText", "modalTitleText", "modalBodyText", "isLiveEdit", "transactionGUID", "originalEnrollmentConfirmationNumber", "enrollmentHRAUserType", "isPCApiEnrollment", "openExternalInNewTab", "enrollmentSubmittedDate", "hraDaysLeftText"], [1, "broker-details", "no-translate-block"], [1, "broker-name", "Spa_Style_H2"], [3, "href", "title"], ["phoneLinks", ""], [1, "Spa_Style_H4"], [1, "Spa_Style_Paragraph", "no-translate-block"], [1, "Spa_Style_Paragraph"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["medigapTTY", ""], ["otherTTY", ""], ["class", "Spa_Style_Paragraph", 3, "href", 4, "ngIf", "ngIfElse"], ["showPhoneOnDesktop", ""], [1, "Spa_Style_Paragraph", 3, "href"], [1, "application-details-title", "Spa_Style_H2", "Spa_Style_Primary_Color", "Spa_Style_Bold_Weight"], [1, "Spa_Style_Label"], [1, "application-data", "Spa_Style_Paragraph"], [1, "application-id"], [3, "customClass", "additionalIcon", "title", "keyNameForLiveEdit", "ariaLabel", "isLinkButton", "click", "keyup.enter"], [1, "call-recording", "mt-3", "mb-2"], [3, "callInProgressText", "endCallText", "callEndedText", "toStartNewRecordingText", "isInline"], [1, "Spa_Style_H2", "pending-coverage-title", "Spa_Style_Primary_Color", "Spa_Style_Bold_Weight"], ["class", "coverage-card", 4, "ngFor", "ngForOf"], [1, "coverage-card"], [1, "coverage-title"], [1, "Spa_Style_H3", "pt-2"], [1, "row", "coverage-body", "p-3"], [1, "col-xs-12", "col-xl-2"], [3, "alternateText", "imageSrc", "classNames", "planLogoSize"], [1, "col-xs-12", "col-md-9", "col-xl-7"], [1, "Spa_Style_H5", "no-translate-block"], [1, "col-xs-12", "col-md-3", "monthly-premium", "pr-0", "Spa_Style_Paragraph", "mb-3"], ["class", "Spa_Style_CostPremiumSmall", 4, "ngIf", "ngIfElse"], ["showPremiumWithFees", ""], ["class", "view-plans-link", 3, "title", "keyNameForLiveEdit", "additionalIcon", "click", 4, "ngIf"], [1, "view-plans-link", 3, "title", "keyNameForLiveEdit", "additionalIcon", "click"], ["type", "button", "placement", "bottom-left", "triggers", "manual", "popoverClass", "hip-benefits-popover", 1, "pr-2", "can-click", "action-button", "Spa_Style_Link", "d-inline", "view-benefits-button", 3, "autoClose", "ngbPopover", "click", "keyup.enter"], ["benefitsForHIPPopover", "ngbPopover"], [1, "ml-1", "fas", "fa-chevron-down"], [1, "sr-only"], [1, "Spa_Style_CostPremiumSmall"], [3, "planFees", "planTotalPremium", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "customClass", "tooltipCustomClass"], [1, "row", "mb-5"], ["class", "col-12 p-0", 4, "ngFor", "ngForOf"], [1, "col-12", "p-0"], [1, "rider-card", "coverage-card"], [1, "rider-amount"], [3, "plans", "riders", "customClass", "bottomMargin"], ["shop", ""], ["continueApplying", ""], ["continue-button", ""], [1, "btn", "Spa_Style_PrimaryButton", "w-100", 3, "click"], ["triggers", "manual", 1, "btn", "Spa_Style_PrimaryButton", 3, "ngbTooltip", "click", "blur"], ["enrollTooltip", "ngbTooltip"], [1, "container"], [3, "title", "button", "message"], [1, "d-flex", "justify-content-center", "pt-3"], [3, "title", "showArrow", "keyNameForLiveEdit", "click"], ["class", "container mt-4", 3, "innerHtml", 4, "liveEditProp"], [1, "container", "mt-4", 3, "innerHtml"], [3, "benefitsData", "closeButtonAction"]], template: function EnrollmentConfirmationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, EnrollmentConfirmationComponent_div_0_Template, 49, 34, "div", 0);
        i0.ɵɵtemplate(1, EnrollmentConfirmationComponent_div_1_Template, 4, 6, "div", 1);
        i0.ɵɵtemplate(2, EnrollmentConfirmationComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
        i0.ɵɵtemplate(3, EnrollmentConfirmationComponent_ng_template_3_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.enrollmentUnavailable && !ctx.medSupUnavailable);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.enrollmentUnavailable || ctx.medSupUnavailable);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.enrollment && ctx.confirmationNumber);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, i1$2.NgTemplateOutlet, TotalPremiumBannerComponent, NavigationBannerComponent, LinkComponent, NoticeComponent, NavigationAdapterDirective, LiveEditPropDirective, GoogleTagManagerDirective, IconAriaAttributesDirective, i1$1.NgbPopover, i1$1.NgbTooltip, EnrollmentCallRecordingActionsComponent, EnrollmentUnavailableComponent, PlanFeesTooltipComponent, SelectRXSectionComponent, EnrollmentConfirmationHRASectionComponent, EnrollmentConfirmationVBCSectionComponent, BenefitsDisplayComponent, PlanLogoComponent, i1$2.AsyncPipe, i1$2.CurrencyPipe, SafePipe, PhonePipe], styles: [".confirmation-page[_ngcontent-%COMP%]{font-size:14px}.page-title[_ngcontent-%COMP%]{margin-top:60px}.notice-banner[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Info_Lighter);border-left:5px solid var(--static-Spa_Style_Info_Light);border-radius:5px;box-shadow:inset 1px 0 #fff;margin-top:18px;margin-bottom:18px}.notice-body[_ngcontent-%COMP%]{display:flex;padding-top:12px}ul[_ngcontent-%COMP%]{padding-left:16px}.contact-section[_ngcontent-%COMP%]{margin-top:70px;margin-bottom:30px}.broker-name[_ngcontent-%COMP%]{font-family:marck_script_regular,cursive,Montserrat,Arial,Helvetica,sans-serif}.application-details[_ngcontent-%COMP%]{border-radius:5px;background-color:var(--static-Spa_Style_Gray1);padding:5px 15px 12px;margin-bottom:20px}.application-details-title[_ngcontent-%COMP%]{margin-top:10px;margin-bottom:30px}.application-label[_ngcontent-%COMP%]{font-family:montserrat_bold}.application-data[_ngcontent-%COMP%]{margin-bottom:12px;min-height:19px}.pending-coverage-title[_ngcontent-%COMP%]{margin-bottom:28px}.coverage-card[_ngcontent-%COMP%]{border-radius:5px;border:1px solid var(--static-Spa_Style_Accent1);margin-bottom:5px;padding-left:15px;padding-right:15px}.confirmation-message[_ngcontent-%COMP%]{border-left:6px solid var(--static-Spa_Style_Cost_Text);border-radius:5px}@media (max-width: 992px){.coverage-title[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Accent1)}}.summary-type[_ngcontent-%COMP%], .coverage-body[_ngcontent-%COMP%]{padding:10px}.logo[_ngcontent-%COMP%]{margin-bottom:20px}.summary-total[_ngcontent-%COMP%]{font-size:22px}.monthly-premium[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:flex-end}.view-plans-link[_ngcontent-%COMP%]{margin-top:10px}.rider-card[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between;align-items:center;padding:16px 10px}.rider-amount[_ngcontent-%COMP%]:before{content:\"\\f067\";font-size:12px;font-family:\"Font Awesome 5 Pro\";margin-right:5px;margin-top:1px}@media (max-width: 767.98px){.monthly-premium[_ngcontent-%COMP%]{flex-direction:row;align-items:center;justify-content:space-between}}"], changeDetection: 0 });
__decorate([
    PlatformProp(null, true)
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_ShowBroker_Flag", void 0);
__decorate([
    PlatformProp(null, true)
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_ShowLogout_Button", void 0);
__decorate([
    PlatformProp(null, true)
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_Title", void 0);
__decorate([
    PlatformProp(null, true)
], EnrollmentConfirmationComponent.prototype, "Spa_Confirmation_Applicant_Name_Label", void 0);
__decorate([
    PlatformProp(null, true)
], EnrollmentConfirmationComponent.prototype, "Spa_Confirmation_Applicant_Address_Label", void 0);
__decorate([
    PlatformProp(null, true)
], EnrollmentConfirmationComponent.prototype, "Spa_Confirmation_Pending_Coverage_Header", void 0);
__decorate([
    PlatformProp()
], EnrollmentConfirmationComponent.prototype, "Spa_ContactUsModal_ContactUsLocations", void 0);
__decorate([
    PlatformProp('live-edit', true)
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_ApplicationSubmitted_Title", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_NoticeBox_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_NoticeBox_Body", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_Site_Email", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_Site_Print", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_WhatToExpect_Title", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_ApplicationDetails_Label", void 0);
__decorate([
    PlatformProp('live-edit', true)
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_MemberName_Label", void 0);
__decorate([
    PlatformProp('live-edit', true)
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_MemberAddress_Label", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_ApplicationSubmitted_Label", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_ApplicationId_Label", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_Site_ViewApplication_Link_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_PendingCoverage_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_RequestedStartDate_Label", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_ViewPlanDetails_Label", void 0);
__decorate([
    PlatformProp('live-edit', true)
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_ViewAccountOverview_Label", void 0);
__decorate([
    PlatformProp('live-edit', true)
], EnrollmentConfirmationComponent.prototype, "Spa_Confirmation_Shop_For_Someone_Else", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_Confirmation_Continue_Applying_For_Coverage", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_WhatToExpect_Body", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_CrossSell_NoticeBox_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_CrossSell_NoticeBox_Body", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_CrossSell_CallInProgress_NoticeBox_Body", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_PreviousLink_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_NextStepsTitle_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_NextStepsBody_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_HRAAvailableAfterEnrollment_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_CallInProgress_NextStepsBody_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_HRAButton_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_Whatsnext", void 0);
__decorate([
    PlatformProp('live-edit')
], EnrollmentConfirmationComponent.prototype, "Spa_ShoppingCart_BenefitsSelection_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_EmailConfirmationModal_Title", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_EmailConfirmationModal_Prompt", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_EmailConfirmationModal_Cancel", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_EmailConfirmationModal_Continue", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_EmailConfirmationModal_Close", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_EmailConfirmationModal_SuccessMessage", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_EmailConfirmationModal_EmailAddressRequired", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_EmailConfirmationModal_EmailAddressInvalid", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Confirmation_All_Set_Confirmation_Message", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Site_ShowPremiumAsAnnual", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_ShowViewPlanDetailsLink_Flag", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_ShowEmail_Flag", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_RetentionLogin_ContinueWithoutPin_Link_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Site_NotifyAgentOfEnrollment", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_SuccessLogo", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_BrokerInformational_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_BrokerEmail_Subject", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_BrokerEmail_ConfirmationCode_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_BrokerEmail_EnrolledInPlan_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_Success_Alt_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Site_NotApplicable_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Site_PlanViewDetails_Enabled", void 0);
__decorate([
    GlobalResource(true)
], EnrollmentConfirmationComponent.prototype, "Spa_Site_SiteType", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_StarRating_Default_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Enrollment_TTY_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Enrollment_TTY_Members_Text_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Enrollment_TTY_Members_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Enrollment_TTY_NonMembers_Text_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Enrollment_TTY_NonMembers_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Site_EnrollerButton_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Site_Enrollment_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Site_MedSupEnrollment_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Site_DentalEnrollment_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Site_VisionEnrollment_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Site_HIPEnrollment_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "SPA_Site_Medigap_Enrollment_InterimPage_Enable", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Site_HRA_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Enrollment_Allow_AlreadyEnrolled_Plans", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Site_Cancel", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Site_Continue", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_ExternalHRATitle_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_ExternalHRABody_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_ContinueAssessment_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_AgentCallRecordingBox_Header", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_AgentCallRecordingBox_CallInProgress", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_AgentCallRecordingBox_EndCall", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_AgentCallRecordingBox_CallEnded", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_AgentCallRecordingBox_ToStartANewCallRecording", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_OpenExternalHRAInNewTab_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Site_PlanLogo_Size", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_ShoppingCart_IndividualEnrollmentButtons_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Site_CompleteHRA_DaysLeft_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_DentalApplicationSubmitted_Title", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_VisionApplicationSubmitted_Title", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_HIPApplicationSubmitted_Title", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_HRAConfirmation_ApplicationSubmitted_Title", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_DentalNoticeBox_Header", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_VisionNoticeBox_Header", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_HIPNoticeBox_Header", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_DentalNoticeBox_Body", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_VisionNoticeBox_Body", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_HIPNoticeBox_Body", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_DentalWhatToExpect_Title", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_VisionWhatToExpect_Title", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_EnrollmentConfirmation_HIPWhatToExpect_Title", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_ShoppingCart_ShowHIPBenefits_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_ValueBasedCare_Confirmation_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Site_PlanFees_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_PlanFees_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_PlanFees_IncludedInPremium_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_ValueBasedCare_ConfirmationAttestation_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_ValueBasedCare_ConfirmationAttestation_Provider_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_ValueBasedCare_ConfirmationAttestation_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_ValueBasedCare_ConfirmationAttestationSuccess_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Save_Failed_ErrorText", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Site_Submit", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Site_PlanPostEnrollmentText_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_Confirmation_ContinueApplyingForCoverageLabel_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_ValueBasedCare_Confirmation_UpdatedView_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_ValueBasedCare_Confirmation_Next_Step_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_ValueBasedCare_Confirmation_Organization_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_ValueBasedCare_Confirmation_Provider_Name_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_ValueBasedCare_Confirmation_Title", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_ValueBasedCare_OptOutConsentConfirmationAttestation_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_ValueBasedCare_OptOutButton_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentConfirmationComponent.prototype, "Spa_ValueBasedCare_OptOutConfirmationSuccess_Text", void 0);
__decorate([
    ResponsiveLayout(BreakPoint.COMPACT)
], EnrollmentConfirmationComponent.prototype, "isMobile$", void 0);
__decorate([
    LiveEditInactive()
], EnrollmentConfirmationComponent.prototype, "viewApplication", null);
__decorate([
    LiveEditInactive()
], EnrollmentConfirmationComponent.prototype, "shopForSomeoneElse", null);
__decorate([
    LiveEditInactive()
], EnrollmentConfirmationComponent.prototype, "viewPlanDetails", null);
__decorate([
    LiveEditInactive()
], EnrollmentConfirmationComponent.prototype, "email", null);
__decorate([
    LiveEditInactive()
], EnrollmentConfirmationComponent.prototype, "print", null);
__decorate([
    LiveEditInactive()
], EnrollmentConfirmationComponent.prototype, "continueApplyingForCoverage", null);
__decorate([
    LiveEditInactive()
], EnrollmentConfirmationComponent.prototype, "enroll", null);
__decorate([
    LiveEditInactive()
], EnrollmentConfirmationComponent.prototype, "resetStatus", null);
__decorate([
    LiveEditInactive()
], EnrollmentConfirmationComponent.prototype, "clearApiShoppingCart", null);
__decorate([
    LiveEditInactive(Promise.resolve())
], EnrollmentConfirmationComponent.prototype, "initializeEnrollmentConfirmationData", null);
EnrollmentConfirmationComponent = __decorate([
    PlatformWidget
], EnrollmentConfirmationComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentConfirmationComponent, [{
        type: Component,
        args: [{ selector: 'vnext-enrollment-confirmation', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div\r\n  class=\"container confirmation-page\"\r\n  vnextGoogleTagManager\r\n  [disableCommonEvent]=\"true\"\r\n  *ngIf=\"!enrollmentUnavailable && !medSupUnavailable\"\r\n>\r\n  <div class=\"row\">\r\n    <div class=\"col-12 text-center\">\r\n      <h1 class=\"page-title Spa_Style_H1\" *liveEditProp=\"'Spa_EnrollmentConfirmation_ApplicationSubmitted_Title'\">\r\n        {{ enrollmentConfirmationTitle }}\r\n      </h1>\r\n    </div>\r\n  </div>\r\n  <ng-container *ngIf=\"isNextYearPlan; then confirmationSection; else noConfirmationSection\"></ng-container>\r\n  <ng-template #confirmationSection>\r\n    <div class=\"row\">\r\n      <div class=\"col-12 Spa_Style_Cost_Background Spa_Style_Bold_Weight confirmation-message p-2 mt-5\">\r\n        <span class=\"Spa_Style_CostPremiumSmall pr-2 pl-2\"><i class=\"fas fa-check-circle\" aria-hidden=\"true\"></i></span>\r\n        {{ Spa_Confirmation_All_Set_Confirmation_Message }}\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template #noConfirmationSection>\r\n    <ng-template #noticeTitle>\r\n      <span *liveEditProp=\"'Spa_EnrollmentConfirmation_NoticeBox_Header'\">{{ Spa_EnrollmentConfirmation_NoticeBox_Header }}</span>\r\n    </ng-template>\r\n    <ng-template #noticeBody>\r\n      <p class=\"mb-0\" *liveEditProp=\"'Spa_EnrollmentConfirmation_NoticeBox_Body'\">\r\n        {{ Spa_EnrollmentConfirmation_NoticeBox_Body }}\r\n      </p>\r\n    </ng-template>\r\n    <ng-template #crosssellNoticeTitle>\r\n      <div\r\n        *liveEditProp=\"'Spa_EnrollmentConfirmation_CrossSell_NoticeBox_Header'\"\r\n        [innerHtml]=\"Spa_EnrollmentConfirmation_CrossSell_NoticeBox_Header | safe : 'html'\"\r\n      ></div>\r\n    </ng-template>\r\n    <ng-template #crosssellNoticeBody>\r\n      <div\r\n        *liveEditProp=\"'Spa_EnrollmentConfirmation_CrossSell_NoticeBox_Body'\"\r\n        [innerHtml]=\"Spa_EnrollmentConfirmation_CrossSell_NoticeBox_Body | safe : 'html'\"\r\n      ></div>\r\n    </ng-template>\r\n    <ng-template #crosssellCallInProgressNoticeBody>\r\n      <div\r\n        *liveEditProp=\"'Spa_EnrollmentConfirmation_CrossSell_CallInProgress_NoticeBox_Body'\"\r\n        [innerHtml]=\"Spa_EnrollmentConfirmation_CrossSell_CallInProgress_NoticeBox_Body | safe : 'html'\"\r\n      ></div>\r\n    </ng-template>\r\n    <div class=\"row\">\r\n      <div class=\"col-12\">\r\n        <vnext-notice [titleTemplate]=\"noticeTitle\" [bodyTemplate]=\"noticeBody\"></vnext-notice>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\" *ngIf=\"moreCoverageToEnroll\">\r\n      <div class=\"col-12\">\r\n        <vnext-notice\r\n          *ngIf=\"!isCallRecordingInProgress\"\r\n          [type]=\"'warn'\"\r\n          [hasButton]=\"true\"\r\n          [buttonText]=\"Spa_Confirmation_Continue_Applying_For_Coverage\"\r\n          [buttonAriaLabel]=\"Spa_Confirmation_ContinueApplyingForCoverageLabel_Text\"\r\n          [titleTemplate]=\"crosssellNoticeTitle\"\r\n          [bodyTemplate]=\"crosssellNoticeBody\"\r\n          [toolTipText]=\"Spa_Site_EnrollerButton_Tooltip_Text\"\r\n          (applyEvent)=\"continueApplyingForCoverage($event)\"\r\n          (closeTooltipEvent)=\"closeEnrollmentTooltip($event)\"\r\n          [keyNameForLiveEdit]=\"'Spa_Confirmation_Continue_Applying_For_Coverage'\"\r\n        ></vnext-notice>\r\n        <vnext-notice\r\n          *ngIf=\"isCallRecordingInProgress\"\r\n          [type]=\"'warn'\"\r\n          [hasButton]=\"true\"\r\n          [buttonText]=\"Spa_Confirmation_Continue_Applying_For_Coverage\"\r\n          [buttonAriaLabel]=\"Spa_Confirmation_ContinueApplyingForCoverageLabel_Text\"\r\n          [titleTemplate]=\"crosssellNoticeTitle\"\r\n          [bodyTemplate]=\"crosssellCallInProgressNoticeBody\"\r\n          [toolTipText]=\"Spa_Site_EnrollerButton_Tooltip_Text\"\r\n          (applyEvent)=\"continueApplyingForCoverage($event)\"\r\n          (closeTooltipEvent)=\"closeEnrollmentTooltip($event)\"\r\n          [keyNameForLiveEdit]=\"'Spa_Confirmation_Continue_Applying_For_Coverage'\"\r\n        ></vnext-notice>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-12\">\r\n        <vnext-selectrx-section></vnext-selectrx-section>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n\r\n  <div class=\"d-flex mb-2 justify-content-end mb-3 mt-3\">\r\n    <button\r\n      #emailConfirmationButton\r\n      type=\"button\"\r\n      tabindex=\"0\"\r\n      [attr.aria-label]=\"Spa_Site_Email + actionStringAppend\"\r\n      *ngIf=\"Spa_EnrollmentConfirmation_ShowEmail_Flag || !this.isNextYearPlan\"\r\n      class=\"action-button Spa_Style_Link d-inline\"\r\n      (click)=\"email()\"\r\n      [title]=\"Spa_Site_Email + actionStringAppend\"\r\n    >\r\n      <i class=\"fa fa-envelope pr-1\"></i>\r\n      <span *liveEditProp=\"'Spa_Site_Email'\">{{ Spa_Site_Email }}</span>\r\n    </button>\r\n\r\n    <vnext-link\r\n      [title]=\"Spa_Site_Print\"\r\n      class=\"pl-2\"\r\n      (click)=\"print()\"\r\n      [keyNameForLiveEdit]=\"'Spa_Site_Print'\"\r\n      [customClass]=\"'action-button Spa_Style_Link d-inline'\"\r\n      [additionalIcon]=\"'fa fa-print'\"\r\n      [ariaLabel]=\"Spa_Site_Print + actionStringAppend\"\r\n      [isLinkButton]=\"true\"\r\n    ></vnext-link>\r\n  </div>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-12 col-lg-8 expect-section\">\r\n      <div *ngIf=\"!isNextYearPlan\">\r\n        <h2 *liveEditProp=\"'Spa_EnrollmentConfirmation_WhatToExpect_Title'\" class=\"Spa_Style_H2\">\r\n          {{ Spa_EnrollmentConfirmation_WhatToExpect_Title }}\r\n        </h2>\r\n        <span\r\n          class=\"Spa_Style_Paragraph\"\r\n          *liveEditProp=\"'Spa_EnrollmentConfirmation_WhatToExpect_Body'\"\r\n          [innerHTML]=\"Spa_EnrollmentConfirmation_WhatToExpect_Body | safe : 'html'\"\r\n          navigationAdapter\r\n        ></span>\r\n      </div>\r\n      <div\r\n        *ngIf=\"Spa_Site_PlanPostEnrollmentText_Enabled && planPostEnrollmentConfirmationText\"\r\n        class=\"Spa_Style_Paragraph mb-3 mt-2\"\r\n        [innerHTML]=\"planPostEnrollmentConfirmationText | safe : 'html'\"\r\n      ></div>\r\n\r\n      <!-- value based care section start -->\r\n      <ng-container *ngIf=\"Spa_ValueBasedCare_Confirmation_Enabled && valueBasedCareProvider && vbcWhitelisted\">\r\n        <vnext-vbc-confirmation-section\r\n          [messageText]=\"valueBasedCareProvider?.confirmationMessageText\"\r\n          [primaryButtonText]=\"valueBasedCareProvider?.primaryButtonText\"\r\n          [secondaryButtonText]=\"valueBasedCareProvider?.secondaryButtonText\"\r\n          [primaryButtonLink]=\"valueBasedCareProvider?.primaryButtonURL\"\r\n          [secondaryButtonLink]=\"valueBasedCareProvider?.secondaryButtonURL\"\r\n          [vbcConfirmationAttestationEnabled]=\"Spa_ValueBasedCare_ConfirmationAttestation_Enabled\"\r\n          [pcpName]=\"valueBasedCareProvider?.pcpName\"\r\n          [vbcOrgName]=\"valueBasedCareProvider?.vbcOrgName\"\r\n          [vbcid]=\"valueBasedCareProvider?.vbcid\"\r\n          [npi]=\"valueBasedCareProvider?.npi\"\r\n          [optInEnabled]=\"valueBasedCareProvider?.optin !== false\"\r\n          [vbcConfirmationAttestationProviderText]=\"Spa_ValueBasedCare_ConfirmationAttestation_Provider_Text\"\r\n          [vbcConfirmationAttestationText]=\"Spa_ValueBasedCare_ConfirmationAttestation_Text\"\r\n          [vbcOptOutConsentConfirmationAttestationText]=\"Spa_ValueBasedCare_OptOutConsentConfirmationAttestation_Text\"\r\n          [optInConfirmationSuccessText]=\"Spa_ValueBasedCare_ConfirmationAttestationSuccess_Text\"\r\n          [saveFailedErrorText]=\"Spa_Save_Failed_ErrorText\"\r\n          [submitButtonText]=\"Spa_Site_Submit\"\r\n          [optOutSubmitButtonText]=\"Spa_ValueBasedCare_OptOutButton_Text\"\r\n          [optOutConfirmationSuccessText]=\"Spa_ValueBasedCare_OptOutConfirmationSuccess_Text\"\r\n          [vbcAttestationSubmitted]=\"vbcAttestationSubmitted\"\r\n          [vbcTitle]=\"Spa_ValueBasedCare_Confirmation_Title\"\r\n          [providerNameLabel]=\"Spa_ValueBasedCare_Confirmation_Provider_Name_Text\"\r\n          [orgNameLabel]=\"Spa_ValueBasedCare_Confirmation_Organization_Text\"\r\n          [nextStepLabel]=\"Spa_ValueBasedCare_Confirmation_Next_Step_Text\"\r\n          [isDefaultView]=\"!Spa_ValueBasedCare_Confirmation_UpdatedView_Enabled\"\r\n          (onVbcConfirmationAttestationSubmit)=\"updateVbcConfirmationAttestation($event)\"\r\n        ></vnext-vbc-confirmation-section>\r\n      </ng-container>\r\n      <!-- value based care section end -->\r\n      <ng-container\r\n        *ngIf=\"(Spa_Site_HRA_Enabled && (!hasAssociatedHRAEnrollment || Spa_Enrollment_Allow_AlreadyEnrolled_Plans)) || isLiveEdit\"\r\n      >\r\n        <vnext-enrollment-confirmation-hra-section\r\n          [hraEnabled]=\"Spa_Site_HRA_Enabled\"\r\n          [nextStepsTitle]=\"Spa_EnrollmentConfirmation_NextStepsTitle_Text\"\r\n          [nextStepsBody]=\"enrollmentConfirmationNextStepsText\"\r\n          [hraAvailableAfterEnrollmentText]=\"Spa_EnrollmentConfirmation_HRAAvailableAfterEnrollment_Text\"\r\n          [hraButtonText]=\"Spa_EnrollmentConfirmation_HRAButton_Text\"\r\n          [enrollmentPlan]=\"enrollmentPlan\"\r\n          [modalCancelText]=\"Spa_Site_Cancel\"\r\n          [modalContinueText]=\"Spa_Site_Continue\"\r\n          [modalTitleText]=\"Spa_EnrollmentConfirmation_ExternalHRATitle_Text\"\r\n          [modalBodyText]=\"Spa_EnrollmentConfirmation_ExternalHRABody_Text\"\r\n          [isLiveEdit]=\"isLiveEdit\"\r\n          [transactionGUID]=\"enrollmentTransactionGUID\"\r\n          [originalEnrollmentConfirmationNumber]=\"confirmationNumber\"\r\n          [enrollmentHRAUserType]=\"enrollmentHRAUserType\"\r\n          [isPCApiEnrollment]=\"isPCApiEnrollment\"\r\n          [openExternalInNewTab]=\"Spa_EnrollmentConfirmation_OpenExternalHRAInNewTab_Enabled\"\r\n          [enrollmentSubmittedDate]=\"enrollmentSubmittedDate\"\r\n          [hraDaysLeftText]=\"Spa_Site_CompleteHRA_DaysLeft_Text\"\r\n        ></vnext-enrollment-confirmation-hra-section>\r\n      </ng-container>\r\n      <div class=\"contact-section\">\r\n        <ng-container *ngIf=\"showBrokerFlag; then broker; else carrier\"></ng-container>\r\n        <ng-template #broker>\r\n          <div class=\"broker-details no-translate-block\">\r\n            <div class=\"broker-name Spa_Style_H2\">{{ brokerData.fullName }}</div>\r\n            <div>{{ brokerData.agency }}</div>\r\n            <div *ngIf=\"countryCode\">\r\n              {{ brokerPhoneNumber | phone : countryCode }}\r\n            </div>\r\n            <vnext-link href=\"mailto:{{ brokerData.email }}\" [title]=\"brokerData.email\"></vnext-link>\r\n          </div>\r\n        </ng-template>\r\n        <ng-template #carrier>\r\n          <ng-container *ngIf=\"enrollmentPlan\">\r\n            <div *ngIf=\"enrollmentPlan.carrierInformation as carrier\">\r\n              <div class=\"Spa_Style_H4\">\r\n                {{ carrier.organizationName }}\r\n              </div>\r\n              <div class=\"Spa_Style_Paragraph no-translate-block\">\r\n                <span *ngIf=\"carrier.carrierAddress.address1\">{{ carrier.carrierAddress.address1 }} </span>\r\n                <span *ngIf=\"carrier.carrierAddress.city\">{{ carrier.carrierAddress.city }}, </span>\r\n                <span *ngIf=\"carrier.carrierAddress.state\">{{ carrier.carrierAddress.state }} </span>\r\n                <span *ngIf=\"carrier.carrierAddress.zip\">{{ carrier.carrierAddress.zip }} </span>\r\n              </div>\r\n              <div class=\"Spa_Style_Paragraph\">{{ carrier.hours }}</div>\r\n              <ng-container *ngTemplateOutlet=\"phoneLinks; context: { content: carrier.phone, name: carrier.organizationName }\">\r\n              </ng-container>\r\n              <ng-container *ngIf=\"enrollmentPlan.planType === planType.MEDIGAP; then medigapTTY; else otherTTY\"></ng-container>\r\n              <ng-template #medigapTTY>\r\n                <span *ngIf=\"this.Spa_Enrollment_TTY_Members_Text_Enabled && carrier.phoneMemberTTY\">\r\n                  <span> {{ Spa_Enrollment_TTY_Members_Text }} </span>\r\n                  <ng-container\r\n                    *ngTemplateOutlet=\"phoneLinks; context: { content: carrier.phoneMemberTTY, name: carrier.organizationName }\"\r\n                  >\r\n                  </ng-container>\r\n                </span>\r\n                <span *ngIf=\"this.Spa_Enrollment_TTY_NonMembers_Text_Enabled && carrier.phoneNonMemberTTY\">\r\n                  <span> {{ Spa_Enrollment_TTY_NonMembers_Text }} </span>\r\n                  <ng-container\r\n                    *ngTemplateOutlet=\"phoneLinks; context: { content: carrier.phoneNonMemberTTY, name: carrier.organizationName }\"\r\n                  >\r\n                  </ng-container>\r\n                </span>\r\n              </ng-template>\r\n              <ng-template #otherTTY>\r\n                <span *ngIf=\"enrollmentPlan.planEnrollmentInfo && enrollmentPlan.planEnrollmentInfo.ttyPhone\">\r\n                  <span> {{ Spa_Enrollment_TTY_Text }} </span>\r\n                  <ng-container\r\n                    *ngTemplateOutlet=\"\r\n                      phoneLinks;\r\n                      context: { content: enrollmentPlan.planEnrollmentInfo.ttyPhone, name: carrier.organizationName }\r\n                    \"\r\n                  >\r\n                  </ng-container>\r\n                </span>\r\n              </ng-template>\r\n              <vnext-link [href]=\"carrier.websiteURL\" [title]=\"carrier.websiteURL\"></vnext-link>\r\n            </div>\r\n          </ng-container>\r\n          <ng-template #phoneLinks let-content=\"content\" let-name=\"name\">\r\n            <ng-container *ngIf=\"countryCode\">\r\n              <a\r\n                *ngIf=\"isMobile; else showPhoneOnDesktop\"\r\n                href=\"tel:{{ content }}\"\r\n                class=\"Spa_Style_Paragraph\"\r\n                [attr.aria-label]=\"name + ': ' + content\"\r\n              >\r\n                {{ content | phone : countryCode }}\r\n              </a>\r\n              <ng-template #showPhoneOnDesktop>\r\n                <div class=\"Spa_Style_Paragraph\">\r\n                  {{ content | phone : countryCode }}\r\n                </div>\r\n              </ng-template>\r\n            </ng-container>\r\n          </ng-template>\r\n        </ng-template>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-12 col-lg-4\">\r\n      <div class=\"application-details\">\r\n        <h2\r\n          class=\"application-details-title Spa_Style_H2 Spa_Style_Primary_Color Spa_Style_Bold_Weight\"\r\n          *liveEditProp=\"'Spa_EnrollmentConfirmation_ApplicationDetails_Label'\"\r\n        >\r\n          {{ Spa_EnrollmentConfirmation_ApplicationDetails_Label }}\r\n        </h2>\r\n        <div class=\"application-details-body\">\r\n          <div>\r\n            <div class=\"Spa_Style_Label\" *liveEditProp=\"'Spa_EnrollmentConfirmation_MemberName_Label'\">\r\n              {{ applicantName }}\r\n            </div>\r\n            <div class=\"application-data Spa_Style_Paragraph no-translate-block\">{{ fullName }}</div>\r\n          </div>\r\n          <div>\r\n            <div class=\"Spa_Style_Label\" *liveEditProp=\"'Spa_EnrollmentConfirmation_MemberAddress_Label'\">\r\n              {{ applicantAddress }}\r\n            </div>\r\n            <div class=\"application-data Spa_Style_Paragraph no-translate-block\" *ngIf=\"addresses && addresses.length\">\r\n              {{ addresses[0].address1 }}\r\n              {{ addresses[0].address2 }} {{ addresses[0].city }}, {{ addresses[0].state }}\r\n              {{ addresses[0].zip }}\r\n            </div>\r\n          </div>\r\n          <div *ngIf=\"!isNextYearPlan\">\r\n            <div class=\"Spa_Style_Label\" *liveEditProp=\"'Spa_EnrollmentConfirmation_ApplicationSubmitted_Label'\">\r\n              {{ Spa_EnrollmentConfirmation_ApplicationSubmitted_Label }}\r\n            </div>\r\n            <div class=\"application-data Spa_Style_Paragraph\">\r\n              {{ submissionDate }}\r\n            </div>\r\n          </div>\r\n          <div class=\"application-id\" *ngIf=\"!isNextYearPlan\">\r\n            <div class=\"Spa_Style_Label\" *liveEditProp=\"'Spa_EnrollmentConfirmation_ApplicationId_Label'\">\r\n              {{ Spa_EnrollmentConfirmation_ApplicationId_Label }}\r\n            </div>\r\n            <div class=\"application-data Spa_Style_Paragraph\">\r\n              {{ confirmationNumber }}\r\n            </div>\r\n            <vnext-link\r\n              (click)=\"viewApplication()\"\r\n              (keyup.enter)=\"viewApplication()\"\r\n              [customClass]=\"'action-button Spa_Style_Link d-inline'\"\r\n              [additionalIcon]=\"'fa fa-file-alt mr-2'\"\r\n              [title]=\"Spa_Site_ViewApplication_Link_Text\"\r\n              [keyNameForLiveEdit]=\"'Spa_Site_ViewApplication_Link_Text'\"\r\n              [ariaLabel]=\"Spa_Site_ViewApplication_Link_Text\"\r\n              [isLinkButton]=\"true\"\r\n            ></vnext-link>\r\n          </div>\r\n          <div\r\n            class=\"call-recording mt-3 mb-2\"\r\n            *ngIf=\"\r\n              isAgentCallRecordingEnabled &&\r\n              isBrokerFormType &&\r\n              (allowsCallRecordingOnMultiCarrierSite || isSingleCarrierSite) &&\r\n              !(hasAgentCallRecordingBeenSkipped$ | async)\r\n            \"\r\n          >\r\n            <div class=\"Spa_Style_Label\">\r\n              {{ Spa_AgentCallRecordingBox_Header }}\r\n            </div>\r\n            <div>\r\n              <vnext-call-recording-actions\r\n                [callInProgressText]=\"Spa_AgentCallRecordingBox_CallInProgress\"\r\n                [endCallText]=\"Spa_AgentCallRecordingBox_EndCall\"\r\n                [callEndedText]=\"Spa_AgentCallRecordingBox_CallEnded\"\r\n                [toStartNewRecordingText]=\"Spa_AgentCallRecordingBox_ToStartANewCallRecording\"\r\n                [isInline]=\"true\"\r\n              ></vnext-call-recording-actions>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div></div>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-12\">\r\n      <h2\r\n        class=\"Spa_Style_H2 pending-coverage-title Spa_Style_Primary_Color Spa_Style_Bold_Weight\"\r\n        *liveEditProp=\"'Spa_EnrollmentConfirmation_PendingCoverage_Header'\"\r\n      >\r\n        {{ pendingCoverageHeader }}\r\n      </h2>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\" *ngIf=\"enrollmentPlan\">\r\n    <div class=\"col-12\">\r\n      <div class=\"coverage-card\" *ngFor=\"let plan of [enrollmentPlan]\">\r\n        <div class=\"coverage-title\">\r\n          <h3 class=\"Spa_Style_H3 pt-2\">\r\n            {{ getPlanDescription(plan) }}\r\n          </h3>\r\n        </div>\r\n\r\n        <div class=\"row coverage-body p-3\">\r\n          <div class=\"col-xs-12 col-xl-2\">\r\n            <vnext-plan-logo\r\n              [alternateText]=\"plan.logo2Description\"\r\n              [imageSrc]=\"planFacade.getPlanLogoUrl(plan)\"\r\n              [classNames]=\"'logo plan-logo'\"\r\n              [planLogoSize]=\"Spa_Site_PlanLogo_Size\"\r\n            ></vnext-plan-logo>\r\n          </div>\r\n          <div class=\"col-xs-12 col-md-9 col-xl-7\">\r\n            <h4 class=\"Spa_Style_H5 no-translate-block\">{{ plan.planName }}</h4>\r\n            <div *ngIf=\"plan.planType === MED_SUP_PLAN_TYPE\">\r\n              <span *liveEditProp=\"'Spa_EnrollmentConfirmation_RequestedStartDate_Label'\">\r\n                {{ Spa_EnrollmentConfirmation_RequestedStartDate_Label }}\r\n              </span>\r\n              {{ effectiveDate }}\r\n            </div>\r\n            <ng-container *ngIf=\"Spa_Site_PlanViewDetails_Enabled\">\r\n              <vnext-link\r\n                *ngIf=\"Spa_EnrollmentConfirmation_ShowViewPlanDetailsLink_Flag\"\r\n                class=\"view-plans-link\"\r\n                [title]=\"Spa_EnrollmentConfirmation_ViewPlanDetails_Label\"\r\n                (click)=\"viewPlanDetails(plan)\"\r\n                [keyNameForLiveEdit]=\"'Spa_EnrollmentConfirmation_ViewPlanDetails_Label'\"\r\n                [additionalIcon]=\"'fa fa-file-alt mr-2'\"\r\n              ></vnext-link>\r\n            </ng-container>\r\n            <ng-container *ngIf=\"Spa_ShoppingCart_ShowHIPBenefits_Enabled && plan.planTypeAbbreviation === planTypeAbbreviation.HC\">\r\n              <button\r\n                type=\"button\"\r\n                class=\"pr-2 can-click action-button Spa_Style_Link d-inline view-benefits-button\"\r\n                (click)=\"showHospitalIndemnityBenefits(plan)\"\r\n                (keyup.enter)=\"showHospitalIndemnityBenefits(plan)\"\r\n                placement=\"bottom-left\"\r\n                triggers=\"manual\"\r\n                [autoClose]=\"'outside'\"\r\n                [ngbPopover]=\"benefitsForHIPPopoverTemplate\"\r\n                #benefitsForHIPPopover=\"ngbPopover\"\r\n                popoverClass=\"hip-benefits-popover\"\r\n              >\r\n                <span *liveEditProp=\"'Spa_ShoppingCart_BenefitsSelection_Text'\"\r\n                  >{{ Spa_ShoppingCart_BenefitsSelection_Text }}<i class=\"ml-1 fas fa-chevron-down\"></i\r\n                  ><span class=\"sr-only\">Expand</span></span\r\n                >\r\n              </button>\r\n            </ng-container>\r\n          </div>\r\n          <div class=\"col-xs-12 col-md-3 monthly-premium pr-0 Spa_Style_Paragraph mb-3\">\r\n            <span>\r\n              {{ premiumLabel }}\r\n            </span>\r\n            <span *ngIf=\"!Spa_Site_PlanFees_Enabled || !plan.fees?.length; else showPremiumWithFees\" class=\"Spa_Style_CostPremiumSmall\">{{\r\n              planTotalPremium | currency\r\n            }}</span>\r\n\r\n            <ng-template #showPremiumWithFees>\r\n              <vnext-widget-plan-fees-tooltip\r\n                [planFees]=\"plan.fees\"\r\n                [planTotalPremium]=\"planTotalPremium\"\r\n                [planFeesTooltipText]=\"Spa_PlanFees_Tooltip_Text\"\r\n                [planFeesIncludedInPremiumTooltipText]=\"Spa_PlanFees_IncludedInPremium_Tooltip_Text\"\r\n                [planFeesNotIncludedInPremiumTooltipText]=\"Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text\"\r\n                [customClass]=\"'stacked-content'\"\r\n                [tooltipCustomClass]=\"'stacked-content'\"\r\n              ></vnext-widget-plan-fees-tooltip>\r\n            </ng-template>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"!Spa_Site_ShowPremiumAsAnnual && enrollmentPlan?.planTypeAbbreviation !== planTypeAbbreviation.HC\" class=\"row mb-5\">\r\n    <div *ngFor=\"let rider of selectedRiders\" class=\"col-12 p-0\">\r\n      <div class=\"rider-card coverage-card\">\r\n        <div class=\"Spa_Style_Paragraph no-translate-block\">{{ rider.planName }}</div>\r\n        <div class=\"rider-amount\">{{ getRiderPremium(rider) | currency }}</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <ng-container *ngIf=\"enrollmentPlan\">\r\n    <vnext-total-premium-banner\r\n      [plans]=\"[enrollmentPlan]\"\r\n      [riders]=\"selectedRiders\"\r\n      [customClass]=\"'Spa_Style_Cost_Background'\"\r\n      [bottomMargin]=\"false\"\r\n    ></vnext-total-premium-banner>\r\n  </ng-container>\r\n  <div>\r\n    <ng-container *ngIf=\"Spa_RetentionLogin_ContinueWithoutPin_Link_Enabled && isConsumerSite\">\r\n      <ng-container *ngIf=\"moreCoverageToEnroll; then continueApplying; else shop\"></ng-container>\r\n      <ng-template #shop>\r\n        <vnext-navigation-banner>\r\n          <div continue-button>\r\n            <button class=\"btn Spa_Style_PrimaryButton w-100\" (click)=\"shopForSomeoneElse()\">\r\n              {{ Spa_Confirmation_Shop_For_Someone_Else }}\r\n            </button>\r\n          </div>\r\n        </vnext-navigation-banner>\r\n      </ng-template>\r\n      <ng-template #continueApplying>\r\n        <vnext-navigation-banner>\r\n          <div continue-button>\r\n            <button\r\n              class=\"btn Spa_Style_PrimaryButton\"\r\n              (click)=\"continueApplyingForCoverage(enrollTooltip)\"\r\n              triggers=\"manual\"\r\n              #enrollTooltip=\"ngbTooltip\"\r\n              [ngbTooltip]=\"Spa_Site_EnrollerButton_Tooltip_Text\"\r\n              (blur)=\"closeEnrollmentTooltip(enrollTooltip)\"\r\n            >\r\n              {{ Spa_Confirmation_Continue_Applying_For_Coverage }}\r\n            </button>\r\n          </div>\r\n        </vnext-navigation-banner>\r\n      </ng-template>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n<div class=\"container\" *ngIf=\"enrollmentUnavailable || medSupUnavailable\">\r\n  <vnext-enrollment-unavailable\r\n    [title]=\"enrollmentUnavailableTitle\"\r\n    [button]=\"enrollmentUnavailableButton\"\r\n    [message]=\"medSupUnavailable ? medSupUnavailableMessage : enrollmentUnavailableMessage\"\r\n  >\r\n  </vnext-enrollment-unavailable>\r\n  <div class=\"d-flex justify-content-center pt-3\">\r\n    <vnext-link\r\n      [title]=\"Spa_EnrollmentConfirmation_PreviousLink_Text\"\r\n      (click)=\"resetStatus()\"\r\n      [showArrow]=\"'left'\"\r\n      [keyNameForLiveEdit]=\"'Spa_EnrollmentConfirmation_PreviousLink_Text'\"\r\n    >\r\n    </vnext-link>\r\n  </div>\r\n</div>\r\n<ng-container *ngIf=\"enrollment && confirmationNumber\">\r\n  <div\r\n    class=\"container mt-4\"\r\n    *liveEditProp=\"'Spa_EnrollmentConfirmation_Whatsnext'\"\r\n    [innerHtml]=\"Spa_EnrollmentConfirmation_Whatsnext | safe : 'html'\"\r\n  ></div>\r\n</ng-container>\r\n\r\n<ng-template #benefitsForHIPPopoverTemplate let-benefitsData=\"selectedBenefitDetails\">\r\n  <vnext-benefits-display [benefitsData]=\"benefitsData\" (closeButtonAction)=\"closeHIPBenefitsPopover()\"></vnext-benefits-display>\r\n</ng-template>\r\n", styles: [".confirmation-page{font-size:14px}.page-title{margin-top:60px}.notice-banner{background-color:var(--static-Spa_Style_Info_Lighter);border-left:5px solid var(--static-Spa_Style_Info_Light);border-radius:5px;box-shadow:inset 1px 0 #fff;margin-top:18px;margin-bottom:18px}.notice-body{display:flex;padding-top:12px}ul{padding-left:16px}.contact-section{margin-top:70px;margin-bottom:30px}.broker-name{font-family:marck_script_regular,cursive,Montserrat,Arial,Helvetica,sans-serif}.application-details{border-radius:5px;background-color:var(--static-Spa_Style_Gray1);padding:5px 15px 12px;margin-bottom:20px}.application-details-title{margin-top:10px;margin-bottom:30px}.application-label{font-family:montserrat_bold}.application-data{margin-bottom:12px;min-height:19px}.pending-coverage-title{margin-bottom:28px}.coverage-card{border-radius:5px;border:1px solid var(--static-Spa_Style_Accent1);margin-bottom:5px;padding-left:15px;padding-right:15px}.confirmation-message{border-left:6px solid var(--static-Spa_Style_Cost_Text);border-radius:5px}@media (max-width: 992px){.coverage-title{border-bottom:1px solid var(--static-Spa_Style_Accent1)}}.summary-type,.coverage-body{padding:10px}.logo{margin-bottom:20px}.summary-total{font-size:22px}.monthly-premium{display:flex;flex-direction:column;align-items:flex-end}.view-plans-link{margin-top:10px}.rider-card{display:flex;flex-direction:row;justify-content:space-between;align-items:center;padding:16px 10px}.rider-amount:before{content:\"\\f067\";font-size:12px;font-family:\"Font Awesome 5 Pro\";margin-right:5px;margin-top:1px}@media (max-width: 767.98px){.monthly-premium{flex-direction:row;align-items:center;justify-content:space-between}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.AgentService }, { type: CartFacade }, { type: i0.Injector }, { type: i1$1.NgbModal }, { type: PlanFacade }, { type: i1.EnrollmentFormService }, { type: EnrollmentFormFacade }, { type: i1.TwilioDeviceService }, { type: RiderFacade }, { type: EnrollmentConfirmationFacade }, { type: i1.MemberSessionService }, { type: AnalyticsService }, { type: i1.NavigationService }, { type: i1.SiteService }, { type: i2.Store }, { type: i1.ConfigResourceService }, { type: i1.JsonAnalyticsService }, { type: i1.ShoppingCartService }, { type: EnrollmentConfirmationService }, { type: i2$1.Router }, { type: i1.PlansService }, { type: i1.DemographicService }, { type: ShoppingCartContextService }, { type: i1.LiveEditStateContext }, { type: AgentCallRecordingFacade }, { type: i1.LocaleService }, { type: i1.PhoneUtilityService }, { type: PlanListFacadeService }, { type: RetentionFacade }, { type: ProviderFacade }]; }, { emailConfirmationButtonElement: [{
            type: ViewChild,
            args: ['emailConfirmationButton']
        }], benefitsForHIPPopover: [{
            type: ViewChild,
            args: ['benefitsForHIPPopover']
        }], Spa_EnrollmentConfirmation_ShowBroker_Flag: [], Spa_EnrollmentConfirmation_ShowLogout_Button: [], Spa_EnrollmentConfirmation_Title: [], Spa_Confirmation_Applicant_Name_Label: [], Spa_Confirmation_Applicant_Address_Label: [], Spa_Confirmation_Pending_Coverage_Header: [], Spa_ContactUsModal_ContactUsLocations: [], Spa_EnrollmentConfirmation_ApplicationSubmitted_Title: [], Spa_EnrollmentConfirmation_NoticeBox_Header: [], Spa_EnrollmentConfirmation_NoticeBox_Body: [], Spa_Site_Email: [], Spa_Site_Print: [], Spa_EnrollmentConfirmation_WhatToExpect_Title: [], Spa_EnrollmentConfirmation_ApplicationDetails_Label: [], Spa_EnrollmentConfirmation_MemberName_Label: [], Spa_EnrollmentConfirmation_MemberAddress_Label: [], Spa_EnrollmentConfirmation_ApplicationSubmitted_Label: [], Spa_EnrollmentConfirmation_ApplicationId_Label: [], Spa_Site_ViewApplication_Link_Text: [], Spa_EnrollmentConfirmation_PendingCoverage_Header: [], Spa_EnrollmentConfirmation_RequestedStartDate_Label: [], Spa_EnrollmentConfirmation_ViewPlanDetails_Label: [], Spa_EnrollmentConfirmation_ViewAccountOverview_Label: [], Spa_Confirmation_Shop_For_Someone_Else: [], Spa_Confirmation_Continue_Applying_For_Coverage: [], Spa_EnrollmentConfirmation_WhatToExpect_Body: [], Spa_EnrollmentConfirmation_CrossSell_NoticeBox_Header: [], Spa_EnrollmentConfirmation_CrossSell_NoticeBox_Body: [], Spa_EnrollmentConfirmation_CrossSell_CallInProgress_NoticeBox_Body: [], Spa_EnrollmentConfirmation_PreviousLink_Text: [], Spa_EnrollmentConfirmation_NextStepsTitle_Text: [], Spa_EnrollmentConfirmation_NextStepsBody_Text: [], Spa_EnrollmentConfirmation_HRAAvailableAfterEnrollment_Text: [], Spa_EnrollmentConfirmation_CallInProgress_NextStepsBody_Text: [], Spa_EnrollmentConfirmation_HRAButton_Text: [], Spa_EnrollmentConfirmation_Whatsnext: [], Spa_ShoppingCart_BenefitsSelection_Text: [], Spa_EnrollmentConfirmation_EmailConfirmationModal_Title: [], Spa_EnrollmentConfirmation_EmailConfirmationModal_Prompt: [], Spa_EnrollmentConfirmation_EmailConfirmationModal_Cancel: [], Spa_EnrollmentConfirmation_EmailConfirmationModal_Continue: [], Spa_EnrollmentConfirmation_EmailConfirmationModal_Close: [], Spa_EnrollmentConfirmation_EmailConfirmationModal_SuccessMessage: [], Spa_EnrollmentConfirmation_EmailConfirmationModal_EmailAddressRequired: [], Spa_EnrollmentConfirmation_EmailConfirmationModal_EmailAddressInvalid: [], Spa_Confirmation_All_Set_Confirmation_Message: [], Spa_Site_ShowPremiumAsAnnual: [], Spa_EnrollmentConfirmation_ShowViewPlanDetailsLink_Flag: [], Spa_EnrollmentConfirmation_ShowEmail_Flag: [], Spa_RetentionLogin_ContinueWithoutPin_Link_Enabled: [], Spa_Site_NotifyAgentOfEnrollment: [], Spa_EnrollmentConfirmation_SuccessLogo: [], Spa_EnrollmentConfirmation_BrokerInformational_Text: [], Spa_EnrollmentConfirmation_BrokerEmail_Subject: [], Spa_EnrollmentConfirmation_BrokerEmail_ConfirmationCode_Text: [], Spa_EnrollmentConfirmation_BrokerEmail_EnrolledInPlan_Text: [], Spa_EnrollmentConfirmation_Success_Alt_Text: [], Spa_Site_NotApplicable_Text: [], Spa_Site_PlanViewDetails_Enabled: [], Spa_Site_SiteType: [], Spa_StarRating_Default_Text: [], Spa_Enrollment_TTY_Text: [], Spa_Enrollment_TTY_Members_Text_Enabled: [], Spa_Enrollment_TTY_Members_Text: [], Spa_Enrollment_TTY_NonMembers_Text_Enabled: [], Spa_Enrollment_TTY_NonMembers_Text: [], Spa_Site_EnrollerButton_Tooltip_Text: [], Spa_Site_Enrollment_Enabled: [], Spa_Site_MedSupEnrollment_Enabled: [], Spa_Site_DentalEnrollment_Enabled: [], Spa_Site_VisionEnrollment_Enabled: [], Spa_Site_HIPEnrollment_Enabled: [], SPA_Site_Medigap_Enrollment_InterimPage_Enable: [], Spa_Site_HRA_Enabled: [], Spa_Enrollment_Allow_AlreadyEnrolled_Plans: [], Spa_Site_Cancel: [], Spa_Site_Continue: [], Spa_EnrollmentConfirmation_ExternalHRATitle_Text: [], Spa_EnrollmentConfirmation_ExternalHRABody_Text: [], Spa_EnrollmentConfirmation_ContinueAssessment_Text: [], Spa_AgentCallRecordingBox_Header: [], Spa_AgentCallRecordingBox_CallInProgress: [], Spa_AgentCallRecordingBox_EndCall: [], Spa_AgentCallRecordingBox_CallEnded: [], Spa_AgentCallRecordingBox_ToStartANewCallRecording: [], Spa_EnrollmentConfirmation_OpenExternalHRAInNewTab_Enabled: [], Spa_Site_PlanLogo_Size: [], Spa_ShoppingCart_IndividualEnrollmentButtons_Enabled: [], Spa_Site_CompleteHRA_DaysLeft_Text: [], Spa_EnrollmentConfirmation_DentalApplicationSubmitted_Title: [], Spa_EnrollmentConfirmation_VisionApplicationSubmitted_Title: [], Spa_EnrollmentConfirmation_HIPApplicationSubmitted_Title: [], Spa_HRAConfirmation_ApplicationSubmitted_Title: [], Spa_EnrollmentConfirmation_DentalNoticeBox_Header: [], Spa_EnrollmentConfirmation_VisionNoticeBox_Header: [], Spa_EnrollmentConfirmation_HIPNoticeBox_Header: [], Spa_EnrollmentConfirmation_DentalNoticeBox_Body: [], Spa_EnrollmentConfirmation_VisionNoticeBox_Body: [], Spa_EnrollmentConfirmation_HIPNoticeBox_Body: [], Spa_EnrollmentConfirmation_DentalWhatToExpect_Title: [], Spa_EnrollmentConfirmation_VisionWhatToExpect_Title: [], Spa_EnrollmentConfirmation_HIPWhatToExpect_Title: [], Spa_ShoppingCart_ShowHIPBenefits_Enabled: [], Spa_ValueBasedCare_Confirmation_Enabled: [], Spa_Site_PlanFees_Enabled: [], Spa_PlanFees_Tooltip_Text: [], Spa_PlanFees_IncludedInPremium_Tooltip_Text: [], Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text: [], Spa_ValueBasedCare_ConfirmationAttestation_Enabled: [], Spa_ValueBasedCare_ConfirmationAttestation_Provider_Text: [], Spa_ValueBasedCare_ConfirmationAttestation_Text: [], Spa_ValueBasedCare_ConfirmationAttestationSuccess_Text: [], Spa_Save_Failed_ErrorText: [], Spa_Site_Submit: [], Spa_Site_PlanPostEnrollmentText_Enabled: [], Spa_Confirmation_ContinueApplyingForCoverageLabel_Text: [], Spa_ValueBasedCare_Confirmation_UpdatedView_Enabled: [], Spa_ValueBasedCare_Confirmation_Next_Step_Text: [], Spa_ValueBasedCare_Confirmation_Organization_Text: [], Spa_ValueBasedCare_Confirmation_Provider_Name_Text: [], Spa_ValueBasedCare_Confirmation_Title: [], Spa_ValueBasedCare_OptOutConsentConfirmationAttestation_Text: [], Spa_ValueBasedCare_OptOutButton_Text: [], Spa_ValueBasedCare_OptOutConfirmationSuccess_Text: [], isMobile$: [], viewApplication: [], shopForSomeoneElse: [], viewPlanDetails: [], email: [], print: [], continueApplyingForCoverage: [], enroll: [], resetStatus: [], clearApiShoppingCart: [], initializeEnrollmentConfirmationData: [] }); })();

class FormRendererComponent {
    constructor(elementRef, enrollmentFormService, activatedRoute, cdr) {
        this.elementRef = elementRef;
        this.enrollmentFormService = enrollmentFormService;
        this.activatedRoute = activatedRoute;
        this.cdr = cdr;
        this.environment = EnvironmentService.getEnvironment();
        // eslint-disable-next-line rxjs/no-exposed-subjects
        this.viewInitialized$ = new BehaviorSubject(false);
        // eslint-disable-next-line rxjs/no-exposed-subjects
        this.viewInitializing$ = new BehaviorSubject(false);
        // eslint-disable-next-line rxjs/no-exposed-subjects
        this.stylesApplied$ = new BehaviorSubject(false);
        this.formId = uuid();
    }
    // Initializing scripts for the particular form page.
    initializeView(isNextGenForm, formId, formVersionId, formVersion) {
        if (isNextGenForm) {
            this.stylesApplied$.next(false);
            this.viewInitialized$.next(false);
            this.viewInitializing$.next(true);
            this.injectNextGenDependencies(formId, formVersionId, formVersion);
        }
        else {
            this.injectLegacyDependencies();
        }
    }
    injectNextGenDependencies(formId, formVersionId, formVersion) {
        const formVersionIdSegment = this.getFormVersion(formVersionId);
        const isDraftVersion = formVersion?.toLowerCase() === 'draft';
        const formVersionNumber = isDraftVersion ? `${formVersionIdSegment}_draft` : formVersionIdSegment;
        this.injectScriptAndStyles(formId, formVersionNumber, false);
    }
    injectScriptAndStyles(formId, formVersionNumber, local = false) {
        const localStyles = `./assets/styles.css`;
        const localScript = `./assets/nextgenFormRenderer.js`;
        const normalStyles = `${this.environment.NEXTGEN_ENROLLMENT_ASSETS_URL}/${formId}/${formVersionNumber}/elements/styles.css`;
        const normalScript = `${this.environment.NEXTGEN_ENROLLMENT_ASSETS_URL}/${formId}/${formVersionNumber}/elements/nextgenformrenderer.js`;
        this.interpolateStylesByHref(local ? localStyles : normalStyles).then(() => {
            this.stylesApplied$.next(true);
        });
        this.injectScriptBySrc(local ? localScript : normalScript, () => {
            // let the parent know the view has been initialized
            // need to run this in a setTimeout to make sure it gets moved to the end of the execution
            // stack to be sure the web component javascript is available before render
            setTimeout(() => {
                this.viewInitialized$.next(true);
                this.viewInitializing$.next(false);
            });
        });
    }
    injectScriptVariables() {
        const activeEnrollmentKey = this.enrollmentFormService.getActiveEnrollmentKey();
        const transactionId = this.enrollmentFormService.getTransactionId(activeEnrollmentKey);
        const scriptVariables = 'var validationUrl = "' +
            this.environment.ENROLLMENT_FORM_BASE_URL +
            '/action/validation?validation=";' +
            'var dynamicValues = "' +
            this.environment.ENROLLMENT_FORM_BASE_URL +
            '/action/dynamicValues?type=";' +
            'var suggestionUrl = "' +
            this.environment.ENROLLMENT_FORM_BASE_URL +
            '/action/suggestions?type=";' +
            'var addressAutocompleteUrl  = "' +
            this.environment.WEB_SERVICE_BASE_URL +
            '/v1/address/autocomplete";' +
            'var uploadFilesUrl = "' +
            this.environment.ENROLLMENT_FORM_BASE_URL +
            '/action/transactions/' +
            transactionId +
            '/files/upload";' +
            'var uploadFilesNoAjaxUrl = "' +
            this.environment.ENROLLMENT_FORM_BASE_URL +
            '/action/transactions/' +
            transactionId +
            '/files/uploadNoAjax";' +
            'var deleteUploadedUrl = "' +
            this.environment.ENROLLMENT_FORM_BASE_URL +
            '/action/transactions/' +
            transactionId +
            '/files/delete?id=";' +
            'var downloadUploadedUrl = "' +
            this.environment.ENROLLMENT_FORM_BASE_URL +
            '/action/transactions/' +
            transactionId +
            '/files/download";';
        console.log('inject script variables ---> ' + scriptVariables);
        const formRoot = this.elementRef.nativeElement;
        const scriptElement = document.createElement('script');
        scriptElement.type = 'text/javascript';
        scriptElement.id = 'foam-script-variables';
        scriptElement.innerHTML = scriptVariables;
        scriptElement.async = false;
        // find old script to replace if there
        const currentScriptVariables = document.querySelector(`script[id='foam-script-variables']`);
        if (currentScriptVariables) {
            currentScriptVariables.parentNode.removeChild(currentScriptVariables);
        }
        formRoot.parentNode.append(scriptElement, formRoot); // TODO: IE11 polyfill
    }
    // load these any time the component is initialized but not every time the page changes
    loadPrerequisiteScripts() {
        this.injectStylesByHref(`${this.environment.ENROLLMENT_ASSETS_URL}/DFPalette.css`);
        this.injectStylesByHref(`${this.environment.ENROLLMENT_ASSETS_URL}/DFStyles.css`);
        this.injectScriptBySrc('https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js');
        this.injectScriptBySrc('https://cdnjs.cloudflare.com/ajax/libs/jquery-validate/1.17.0/jquery.validate.min.js');
        this.injectScriptBySrc('https://cdnjs.cloudflare.com/ajax/libs/jquery-validation-unobtrusive/3.2.11/jquery.validate.unobtrusive.min.js');
        // NOTE: Not an absolute requirement but should probably stay consistent with the version in node modules
        // TODO: the enrollment form can still use moment just not our project
        this.injectScriptBySrc('https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.24.0/moment.min.js');
        this.injectScriptBySrc('https://cdnjs.cloudflare.com/ajax/libs/moment-timezone/0.5.31/moment-timezone-with-data.min.js');
    }
    retrieveFormInputValues() {
        const formInputValues = {};
        const enrollmentForm = document.getElementById(this.formId);
        if (enrollmentForm) {
            const formInputs = enrollmentForm.getElementsByTagName('input');
            if (formInputs.length) {
                Array.from(formInputs).forEach((formInput) => {
                    // const currentTarget = event.target as HTMLInputElement;
                    // if radio we need to look for first with checked
                    if (formInput?.name &&
                        !formInput.disabled &&
                        (!formInput.className || !formInput.className.includes(FOAMHtmlDirectives.IGNORE_FIELD))) {
                        if (formInput.type === 'radio') {
                            if (formInput.checked) {
                                formInputValues[formInput.name] = formInput.value;
                            }
                        }
                        else if (formInput.type === 'checkbox') {
                            if (formInputValues[formInput.name]) {
                                formInputValues[formInput.name] += formInput.checked ? `,${formInput.value}` : '';
                            }
                            else {
                                formInputValues[formInput.name] = formInput.checked ? formInput.value : '';
                            }
                        }
                        else if (formInput.type === 'hidden') {
                            if (formInputValues[formInput.name]) {
                                formInputValues[formInput.name] += `,${formInput.value}`;
                            }
                            else {
                                formInputValues[formInput.name] = formInput.value;
                            }
                        }
                        else {
                            formInputValues[formInput.name] = formInput.value;
                        }
                    }
                });
            }
            const formSelects = enrollmentForm.getElementsByTagName('select');
            if (formSelects.length) {
                Array.from(formSelects).forEach((formSelect) => {
                    // const currentTarget = event.target as HTMLSelectElement;
                    if (formSelect?.name &&
                        formSelect.value !== '' &&
                        !formSelect.disabled &&
                        (!formSelect.className || !formSelect.className.includes(FOAMHtmlDirectives.IGNORE_FIELD))) {
                        formInputValues[formSelect.name] = formSelect.value;
                        // formInputValues.push({ name: formSelect.name, value: formSelect.value });
                    }
                });
            }
            const textAreaInputs = enrollmentForm.getElementsByTagName('textarea');
            if (textAreaInputs.length) {
                Array.from(textAreaInputs).forEach((textAreaInput) => {
                    if (textAreaInput?.name &&
                        !textAreaInput.disabled &&
                        (!textAreaInput.className || !textAreaInput.className.includes(FOAMHtmlDirectives.IGNORE_FIELD))) {
                        formInputValues[textAreaInput.name] = textAreaInput.value;
                    }
                });
            }
        }
        return formInputValues;
    }
    // Meant to be overridden
    retrieveAllFormInputValues() {
        return {};
    }
    injectScriptBySrc(src, onload) {
        console.log('inject script by src ---> ' + src);
        const formRoot = this.elementRef.nativeElement;
        const scriptElement = document.createElement('script');
        scriptElement.type = 'text/javascript';
        scriptElement.src = src;
        scriptElement.async = false; // was false
        if (onload) {
            scriptElement.onload = onload;
        }
        // find old script to replace if there
        const currentScript = document.querySelector(`script[src='${src}']`);
        if (currentScript) {
            currentScript.parentNode.removeChild(currentScript);
        }
        formRoot.parentNode.append(scriptElement, formRoot);
    }
    async interpolateStylesByHref(href) {
        const response = await fetch(href);
        const cssContent = await response.text();
        const formRoot = this.elementRef.nativeElement;
        const styleElement = document.createElement('style');
        styleElement.textContent = cssContent;
        styleElement.id = href;
        const currentStyle = document.querySelector(`style[id='${href}']`);
        if (currentStyle) {
            currentStyle.parentNode.removeChild(currentStyle);
        }
        formRoot.parentNode.prepend(styleElement, formRoot);
        return await new Promise(resolve => {
            let intervalCount = 0;
            const checkInterval = setInterval(() => {
                intervalCount++;
                const childElement = formRoot.querySelector('code#metadata');
                if (childElement) {
                    const computedStyle = window.getComputedStyle(childElement);
                    const textColor = computedStyle.getPropertyValue('color');
                    if (textColor === 'rgb(255, 255, 255)') {
                        clearInterval(checkInterval);
                        resolve(undefined);
                    }
                }
                if (intervalCount >= 15) {
                    clearInterval(checkInterval);
                    resolve(undefined);
                }
            }, 100);
        });
    }
    injectStylesByHref(href) {
        console.log('inject script by src ---> ' + href);
        const formRoot = this.elementRef.nativeElement;
        const linkElement = document.createElement('link');
        linkElement.rel = 'stylesheet';
        linkElement.type = 'text/css';
        linkElement.href = href;
        // find old style to replace if there
        const currentStyle = document.querySelector(`link[href='${href}']`);
        if (currentStyle) {
            currentStyle.parentNode.removeChild(currentStyle);
        }
        formRoot.parentNode.prepend(linkElement, formRoot);
    }
    parseEmbeddedScripts() {
        // force these scripts to be parsed
        // gathered from https://stackoverflow.com/questions/41547505/angular-2-how-to-execute-script-tag-from-innerhtml
        const scripts = this.elementRef.nativeElement.getElementsByTagName('script');
        const scriptsInitialLength = scripts.length;
        for (let i = 0; i < scriptsInitialLength; i++) {
            const script = scripts[i];
            const scriptCopy = document.createElement('script');
            scriptCopy.type = script.type ? script.type : 'text/javascript';
            if (script.innerHTML) {
                scriptCopy.innerHTML = script.innerHTML;
            }
            else if (script.src) {
                scriptCopy.src = script.src;
            }
            scriptCopy.async = false;
            script.parentNode.replaceChild(scriptCopy, script);
        }
    }
    injectLegacyDependencies() {
        this.parseEmbeddedScripts();
        this.injectScriptVariables();
        this.injectScriptBySrc(`${this.environment.ENROLLMENT_ASSETS_URL}/HOPEBundle.js`, () => {
            // let the parent know the view has been initialized
            // need to run this in a setTimeout to make sure it gets moved to the end of the execution
            // stack as the jQuery contained within the HOPEBundle.js will not finish before this iscalled
            setTimeout(() => {
                this.viewInitialized$.next(true);
            });
        });
    }
    getFormVersion(formVersionId) {
        return formVersionId.split('_').slice(2).join('_') || '';
    }
}

const _c0$29 = ["enrollmentFormHtml"];
const _c1$$ = function (a0) { return { "d-none": a0 }; };
class EnrollmentFormRendererComponent extends FormRendererComponent {
    constructor(elementRef, enrollmentFormService, activatedRoute, cdr, spinnerService, analyticsService, router, store, planListFacade, navigationUtilityService, shoppingCartService, enrollmentFormFacade, planFacade) {
        super(elementRef, enrollmentFormService, activatedRoute, cdr);
        this.elementRef = elementRef;
        this.enrollmentFormService = enrollmentFormService;
        this.activatedRoute = activatedRoute;
        this.cdr = cdr;
        this.spinnerService = spinnerService;
        this.analyticsService = analyticsService;
        this.router = router;
        this.store = store;
        this.planListFacade = planListFacade;
        this.navigationUtilityService = navigationUtilityService;
        this.shoppingCartService = shoppingCartService;
        this.enrollmentFormFacade = enrollmentFormFacade;
        this.planFacade = planFacade;
        this.formValueUpdate = new EventEmitter();
    }
    ngOnInit() {
        this.loadLegacyForm();
    }
    ngOnDestroy() {
        this.formPageLoadingSubscriber.unsubscribe();
        this.formPageHtmlSubscriber.unsubscribe();
    }
    loadLegacyForm() {
        this.loadPrerequisiteScripts();
        this.enrollmentRootPage = this.enrollmentFormService.getEnrollmentRootPage();
        this.enrollingPlanId = this.enrollmentFormService.getActiveEnrollmentKey();
        this.formPageLoadingSubscriber = this.activatedRoute.params
            .pipe(pluck('pageName'), switchMap(pageName => this.enrollmentFormService.getFormPageLoading$(this.enrollingPlanId, pageName)))
            .subscribe({
            next: loading => {
                if (loading) {
                    this.spinnerService.show(SpinnerEvent.ENROLLMENT_FORM_LOADING);
                }
                else {
                    this.spinnerService.hide(SpinnerEvent.ENROLLMENT_FORM_LOADING);
                    this.updateTags();
                }
            }
        });
        // to make this work with new different forms I added a check for default enrollment
        // if true do what we normally have done
        this.formPageHtmlSubscriber = this.activatedRoute.params
            .pipe(pluck('pageName'), switchMap(pageName => this.enrollmentFormService.getFormPageHtml$(this.enrollingPlanId, pageName)))
            .subscribe({
            next: pageHtml => {
                this.formHtml = pageHtml;
                this.cdr.markForCheck();
                // hacky way to wait until detectChanges completes
                // Angular doesn't have a way to wait for DOM changes to be done afaik
                if (pageHtml) {
                    setTimeout(() => {
                        this.initializeView(false);
                        // this.cdr.markForCheck();
                    });
                }
            }
        });
    }
    retrieveFormInputValues() {
        return super.retrieveFormInputValues();
    }
    updateTags() {
        const googleTagManagerNotApplicableText = this.analyticsService.getGoogleTagManagerNotApplicableText();
        const externalMemberId = this.store.selectSnapshot(DeepLinkingParamsState.ssoValue);
        const externalReferenceId = this.store.selectSnapshot(DeepLinkingParamsState.pegi);
        const enrollingPlan = this.enrollmentFormService.getSelectedPlan(this.enrollingPlanId);
        const planType = enrollingPlan ? enrollingPlan.planTypeAbbreviation : googleTagManagerNotApplicableText;
        if (this.analyticsService.googleDataLayerTags[DataLayerGlobalVariable.PAGE_PATH] !== this.router.url &&
            this.navigationUtilityService.normalizePath(this.router.url) !== this.navigationUtilityService.normalizePath(this.enrollmentRootPage)) {
            let tagsToUpdate = {
                [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE,
                [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
                [DataLayerGlobalVariable.PLAN_CARRIER]: enrollingPlan ? enrollingPlan?.carrierName : googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.PLAN_TYPE]: planType.toString(),
                [DataLayerGlobalVariable.PLAN_ID]: enrollingPlan ? enrollingPlan?.id : googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.EXTERNAL_MEMBER_ID]: externalMemberId || googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.EXTERNAL_REFERENCE_ID]: externalReferenceId || googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.PLAN_ID_BEST_MATCH]: this.planListFacade.getBestMatchPlanIdValueForAnalytics(),
                [DataLayerGlobalVariable.PLAN_TYPE_BEST_MATCH]: this.planListFacade.getBestCoverageTabAbbreviationValueForAnalytics(),
                [DataLayerGlobalVariable.ENROLLMENT_PLAN_COUNT]: `${this.shoppingCartService.getEnrollmentPlanCount()}`,
                [DataLayerGlobalVariable.PLAN_NAME]: enrollingPlan?.planName ?? googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.PLAN_PREMIUM_MONTHLY]: this.enrollmentFormFacade.getEnrollingPlanPremium(this.enrollingPlanId),
                [DataLayerGlobalVariable.PLAN_PROVIDER_VBC_STATUS]: this.planFacade.isVbcAgreementExists(enrollingPlan)
                    ? GOOGLE_ANALYTICS_YES
                    : GOOGLE_ANALYTICS_NO
            };
            tagsToUpdate = this.enrollmentFormService.updateTagForEnrollmentMethod(tagsToUpdate, this.enrollingPlanId);
            tagsToUpdate = this.enrollmentFormService.updateTagForCrossSell(tagsToUpdate);
            tagsToUpdate = this.analyticsService.getGlobalDataLayerTags(tagsToUpdate);
            this.analyticsService.googleDataLayerTags = tagsToUpdate;
        }
    }
}
EnrollmentFormRendererComponent.ɵfac = function EnrollmentFormRendererComponent_Factory(t) { return new (t || EnrollmentFormRendererComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(PlanListFacadeService), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(i1.ShoppingCartService), i0.ɵɵdirectiveInject(EnrollmentFormFacade), i0.ɵɵdirectiveInject(PlanFacade)); };
EnrollmentFormRendererComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EnrollmentFormRendererComponent, selectors: [["vnext-enrollment-form"]], viewQuery: function EnrollmentFormRendererComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$29, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.enrollmentFormHtml = _t.first);
    } }, outputs: { formValueUpdate: "formValueUpdate" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 10, consts: [[3, "ngClass"], ["navigationAdapter", "", 3, "id", "innerHTML"], ["enrollmentFormHtml", ""]], template: function EnrollmentFormRendererComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵelement(2, "form", 1, 2);
        i0.ɵɵpipe(4, "safe");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c1$$, i0.ɵɵpipeBind1(1, 3, ctx.viewInitialized$) === false));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("id", ctx.formId)("innerHTML", i0.ɵɵpipeBind2(4, 5, ctx.formHtml, "html"), i0.ɵɵsanitizeHtml);
    } }, dependencies: [i1$2.NgClass, i4.ɵNgNoValidate, i4.NgControlStatusGroup, i4.NgForm, NavigationAdapterDirective, i1$2.AsyncPipe, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentFormRendererComponent, [{
        type: Component,
        args: [{ selector: 'vnext-enrollment-form', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div [ngClass]=\"{ 'd-none': (viewInitialized$ | async) === false }\">\r\n  <form #enrollmentFormHtml [id]=\"formId\" [innerHTML]=\"formHtml | safe : 'html'\" navigationAdapter></form>\r\n</div>\r\n" }]
    }], function () { return [{ type: i0.ElementRef }, { type: i1.EnrollmentFormService }, { type: i2$1.ActivatedRoute }, { type: i0.ChangeDetectorRef }, { type: i1.SpinnerService }, { type: AnalyticsService }, { type: i2$1.Router }, { type: i2.Store }, { type: PlanListFacadeService }, { type: i1.NavigationUtilityService }, { type: i1.ShoppingCartService }, { type: EnrollmentFormFacade }, { type: PlanFacade }]; }, { enrollmentFormHtml: [{
            type: ViewChild,
            args: ['enrollmentFormHtml']
        }], formValueUpdate: [{
            type: Output
        }] }); })();

class NextGenSOAFormFacade {
    constructor(store, enrollmentFormService, localeService, formRootService, soaService, soaFormFacade, soaFacade) {
        this.store = store;
        this.enrollmentFormService = enrollmentFormService;
        this.localeService = localeService;
        this.formRootService = formRootService;
        this.soaService = soaService;
        this.soaFormFacade = soaFormFacade;
        this.soaFacade = soaFacade;
        this.formTitleSubject$ = new BehaviorSubject(null);
        this.formTitle$ = this.formTitleSubject$.asObservable().pipe(shareReplay(1));
    }
    isConsumerSOAActivity(soaActivity) {
        return this.soaFacade.isConsumerSOAActivity(soaActivity);
    }
    getSOATransaction$(transactionId) {
        return this.soaService.getSOATransaction$(transactionId);
    }
    getSOATransaction(transactionId) {
        return this.soaService.getSOATransaction(transactionId);
    }
    getSOAFormLoading$(transactionId) {
        return this.soaFacade.getNextGenSOAFormLoading$(transactionId);
    }
    getSOAFormLoaded$(transactionId) {
        return this.soaFacade.getNextGenSOAFormLoaded$(transactionId);
    }
    setSOAFormLoading$(transactionId, loading) {
        return this.soaFacade.setNextGenSOAFormLoading$(transactionId, loading);
    }
    getCurrentLocale$() {
        return this.localeService.getCurrentLocale$();
    }
    isSOAFormLoading$(formId) {
        return this.soaFacade.getNextGenSOAFormLoading$(formId);
    }
    isSOAFormLoaded$(formId) {
        return this.soaFacade.getNextGenSOAFormLoaded$(formId);
    }
    setFormLoading$(formId, loading) {
        return this.soaFacade.setNextGenSOAFormLoading$(formId, loading);
    }
    getNextGenSOAPrefillData$(transactionId) {
        return this.soaFacade.getNextGenSOAPrefillData$(transactionId);
    }
    formTitleObservable$() {
        return this.formTitle$;
    }
    setFormTitle(formTitle) {
        this.formTitleSubject$.next(formTitle);
    }
    getFormType(formId) {
        return this.enrollmentFormService.getSelectedFormType(formId).valueOf();
    }
    observeForNavigationEvent$() {
        return this.enrollmentFormService.observeForNavigationEvent$();
    }
    getEnrollmentErrorNoticeTitle(widgetName) {
        return this.formRootService.getEnrollmentErrorNoticeTitle(widgetName);
    }
    fetchTransaction$(sessionId, formId, transactionId) {
        return this.enrollmentFormService.fetchNextGenTransaction$(sessionId, formId, transactionId);
    }
    async validateEnrollment(payload, validationType) {
        return await this.enrollmentFormService.nextGenValidateEnrollment(payload, validationType);
    }
    async checkMemberEligibility(payload) {
        return await this.enrollmentFormService.nextGenCheckMemberEligibility(payload);
    }
    findFirstFocusableInput(answers, document) {
        return this.formRootService.findFirstFocusableInput(answers, document);
    }
    convertEnrollmentCallbackMapToJSON() {
        return this.formRootService.convertEnrollmentCallbackMapToJSON();
    }
    fetchFormVersionInfo$(formId) {
        return this.soaService.fetchFormVersionInfo$(formId);
    }
    getSelectedSOAFormId(soaTransactionType) {
        return this.soaFacade.getSelectedSOAFormId(soaTransactionType);
    }
    getSOAActivity$(transactionId, isAdmin = false) {
        return this.soaFacade.getSOAActivity$(transactionId, isAdmin);
    }
    startNextGenSOATransaction$(selectedFormId, soaTransactionTypes) {
        return this.soaFacade
            .fetchFormVersionInfo$(selectedFormId)
            .pipe(switchMap(formVersionInfo => this.soaFacade
            .startNextGenSOATransaction$(formVersionInfo.formId, formVersionInfo.formVersion, formVersionInfo.formVersionId, soaTransactionTypes)
            .pipe(map(soaTransactionResponse => [formVersionInfo, soaTransactionResponse]))));
    }
    updateNextGenSOATransaction$(answers, enrollmentKey) {
        return this.store.dispatch(new UpdateSOATransactionAnswers(enrollmentKey, undefined, this.enrollmentFormService.mapNextGenAnswersToMap(answers)));
    }
    completeNextGenSOATransaction$(transactionId) {
        return this.soaFacade.completeNextGenSOATransaction$(transactionId);
    }
    async completeNextGenSOATransaction(transactionId) {
        await this.soaFacade.completeNextGenSOATransaction(transactionId);
    }
    updateSOABeneficiaryConfirmationCodeAnswer(soaAnswers) {
        return this.soaFormFacade.updateSOABeneficiaryConfirmationCodeAnswer(soaAnswers);
    }
    allFormPagesComplete(transactionSID) {
        return this.soaFormFacade.allFormPagesComplete(transactionSID);
    }
    clearPrefillData(enrollmentKey, event, childForms) {
        const { mergedFieldsToUpdate, transactionFields } = this.enrollmentFormService.getFieldsToClearPrefillData(event, childForms);
        if (mergedFieldsToUpdate?.length && !_isEqual(mergedFieldsToUpdate, transactionFields)) {
            this.updateNextGenSOATransaction$(mergedFieldsToUpdate, enrollmentKey);
        }
    }
    async saveFormAnswers(transactionId, answers) {
        const nextGenAnswers = this.updateAnswerDateFormat(answers);
        await this.updateNextGenSOATransaction$(nextGenAnswers, transactionId).toPromise();
        this.formRootService.updateMemberProfileSession(nextGenAnswers);
        this.formRootService.updateEffectiveDatesPartAandB(nextGenAnswers);
    }
    updateAnswerDateFormat(answers) {
        answers?.forEach(answer => {
            if (DateUtilities.isValidFormat(answer.value, DateUtilities.defaultDateISOFormat)) {
                answer.value = DateUtilities.convertDateFormat(answer.value);
            }
        });
        return answers;
    }
}
NextGenSOAFormFacade.ɵfac = function NextGenSOAFormFacade_Factory(t) { return new (t || NextGenSOAFormFacade)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.EnrollmentFormService), i0.ɵɵinject(i1.LocaleService), i0.ɵɵinject(FormRootService), i0.ɵɵinject(i1.SOAService), i0.ɵɵinject(SoaFormFacade), i0.ɵɵinject(SOAFacade)); };
NextGenSOAFormFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NextGenSOAFormFacade, factory: NextGenSOAFormFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NextGenSOAFormFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i2.Store }, { type: i1.EnrollmentFormService }, { type: i1.LocaleService }, { type: FormRootService }, { type: i1.SOAService }, { type: SoaFormFacade }, { type: SOAFacade }]; }, null); })();

class NextGenSOAFormNavigationContext {
    constructor() {
        this.pageNameSubject$ = new BehaviorSubject(null);
        this.pageName$ = this.pageNameSubject$.asObservable().pipe(distinctUntilChanged(), shareReplay(1));
    }
    setPageName(pageName) {
        if (pageName) {
            this.pageNameSubject$.next(pageName);
        }
    }
    resetPageName() {
        this.pageNameSubject$.next(null);
    }
    getPageName$() {
        return this.pageName$;
    }
}
NextGenSOAFormNavigationContext.ɵfac = function NextGenSOAFormNavigationContext_Factory(t) { return new (t || NextGenSOAFormNavigationContext)(); };
NextGenSOAFormNavigationContext.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NextGenSOAFormNavigationContext, factory: NextGenSOAFormNavigationContext.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NextGenSOAFormNavigationContext, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

const _c0$28 = ["enrollmentFormHtml"];
const _c1$_ = function (a0) { return { "d-none": a0 }; };
class NextGenEnrollmentFormRendererComponent extends FormRendererComponent {
    constructor(elementRef, enrollmentFormService, activatedRoute, cdr, spinnerService, 
    // private readonly analyticsService: AnalyticsService,
    router, store, 
    // private readonly planListFacade: PlanListFacadeService,
    navigationUtilityService, navigationService, shoppingCartService, // private readonly enrollmentFormFacade: EnrollmentFormFacade
    configResourceService, analyticsService, enrollmentFormFacade, formRootStrategyService, quoteService, siteService, memberSessionService, formPagesMetadataContext, currencyPipe, utilityFunctionService, nextGenSOAFormFacade, nextGenSOAFormNavigationContext) {
        super(elementRef, enrollmentFormService, activatedRoute, cdr);
        this.elementRef = elementRef;
        this.enrollmentFormService = enrollmentFormService;
        this.activatedRoute = activatedRoute;
        this.cdr = cdr;
        this.spinnerService = spinnerService;
        this.router = router;
        this.store = store;
        this.navigationUtilityService = navigationUtilityService;
        this.navigationService = navigationService;
        this.shoppingCartService = shoppingCartService;
        this.configResourceService = configResourceService;
        this.analyticsService = analyticsService;
        this.enrollmentFormFacade = enrollmentFormFacade;
        this.formRootStrategyService = formRootStrategyService;
        this.quoteService = quoteService;
        this.siteService = siteService;
        this.memberSessionService = memberSessionService;
        this.formPagesMetadataContext = formPagesMetadataContext;
        this.currencyPipe = currencyPipe;
        this.utilityFunctionService = utilityFunctionService;
        this.nextGenSOAFormFacade = nextGenSOAFormFacade;
        this.nextGenSOAFormNavigationContext = nextGenSOAFormNavigationContext;
        this.formValueUpdate = new EventEmitter();
        this.isSOAForm = false;
        this.isAgentAdmin = false;
        this.surveyInitialized = false;
        this.ssoPopulatedFields = [];
        // Used for Send to Beneficiary flow
        this.isSendToBeneficiary = false;
        this.viewInitializedObservable$ = this.viewInitialized$.asObservable().pipe(distinctUntilChanged(), shareReplay(1));
        this.viewInitializingObservable$ = this.viewInitializing$.asObservable().pipe(distinctUntilChanged(), shareReplay(1));
        this.stylesAppliedObservable$ = this.stylesApplied$.asObservable().pipe(distinctUntilChanged(), shareReplay(1));
    }
    questionUpdated(event) {
        // TODO: Not actually using formAnswers right now
        const formAnswers = _get(event, 'detail.formAnswers');
        const currentPage = _get(event, 'detail.currentPage');
        const currentPageAnsweredFieldNames = Object.keys(currentPage?.getValue() ?? {});
        // For File Uploader components, we use calculated values to overwrite the list of uploaded files with a serialized string representation
        // We grab the current page answers from the incoming form answers instead of using the values from currentPage.getValue() because,
        // currentPage.getValue() doesn't include calculated values
        const currentPageAnswers = this.getCurrentPageAnswers(formAnswers, currentPageAnsweredFieldNames);
        this.currentPageAnswers = this.flattenObject(currentPageAnswers);
        this.allPageAnswers = this.flattenObject(formAnswers);
    }
    navigatedToNextPage(event) {
        const currentPageTitle = _get(event, 'detail.newCurrentPageTitle');
        this.updateTags(currentPageTitle);
    }
    ngOnChanges(changes) {
        const { formId, formVersion, formVersionId, soaTransactionId } = changes;
        if (this.isSOAForm &&
            ((formId && formId.previousValue !== formId.currentValue) ||
                (formVersion && formVersion.previousValue !== formVersion.currentValue) ||
                (formVersionId && formVersionId.previousValue !== formVersionId.currentValue) ||
                (soaTransactionId && soaTransactionId.previousValue !== soaTransactionId.currentValue))) {
            if (this.formId && this.formVersion && this.formVersionId && this.soaTransactionId) {
                this.initializeSOASubscriptions();
            }
        }
    }
    ngOnInit() {
        this.isAddressAutocompleteEnabled = this.configResourceService.getProcessedResourceValue('Spa_Enrollment_AddressAutoComplete_Enabled', null, true);
        this.ssoPopulatedFieldsReadonlyEnabled = this.configResourceService.getProcessedResourceValue('Spa_SSO_PopulatedFields_ReadOnly_Enabled', null, false);
        if (this.ssoPopulatedFieldsReadonlyEnabled) {
            const ssoPopulatedFieldsMappings = this.configResourceService.getProcessedResourceValue('Spa_SSO_PopulatedFields_FOAMMapping', null);
            this.ssoPopulatedFields = ssoPopulatedFieldsMappings ? Object.values(ssoPopulatedFieldsMappings) : [];
        }
        this.reviewSectionsCollapsedByDefault = this.configResourceService.getProcessedResourceValue('Spa_Enrollment_ReviewSectionsCollapsed', null, true);
        if (!this.isSOAForm) {
            this.initializeSubscriptions();
        }
    }
    initializeSubscriptions() {
        this.subscriptions?.unsubscribe();
        this.subscriptions = new Subscription();
        this.enrollingPlanId = this.enrollmentFormService.getActiveEnrollmentKey();
        this.formTransactionId$ = this.enrollmentFormService.getNextGenTransactionId$(this.enrollingPlanId); // TODO: not available on first load
        this.prefillData$ = this.enrollmentFormService.getNextGenPrefillData$(this.enrollingPlanId);
        this.nextgenEnrollmentSepReasons$ = this.enrollmentFormService.getNextGenEnrollmentSepReasons$(this.enrollingPlanId);
        this.formCanBeDisplayed$ = combineLatest([
            this.viewInitializedObservable$,
            this.enrollmentFormService.isNextGenFormLoaded$(this.enrollingPlanId),
            this.enrollmentFormService.isNextGenFormLoading$(this.enrollingPlanId),
            this.formTransactionId$
        ]).pipe(distinctUntilChanged(_isEqual), map(([isViewInitialized, loaded, loading, formTransactionId]) => isViewInitialized && loaded && !loading && !!formTransactionId), distinctUntilChanged(), shareReplay(1));
        this.pageName$ = this.activatedRoute.params.pipe(pluck('pageName'), distinctUntilChanged(), shareReplay(1));
        if (!this.siteService.isPPCSite()) {
            this.subscriptions.add(this.quoteService
                .getQuoteInfo$()
                .pipe(distinctUntilChanged(_isEqual))
                .subscribe({
                next: quoteInfo => {
                    this.isSendToBeneficiary = QUOTE_TYPES_FROM_SEND_TO_BENEFICIARY_FLOW.includes(quoteInfo?.quoteType);
                    this.cdr.markForCheck();
                }
            }));
        }
        this.subscriptions.add(this.pageName$.subscribe({
            next: pageName => {
                this.pageName = pageName;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.enrollmentFormService
            .getSelectedPlan$(this.enrollingPlanId)
            .pipe(distinctUntilChanged(_isEqual))
            .subscribe({
            next: enrollingPlan => {
                this.enrollingPlan = enrollingPlan;
                this.additionalTextReplacementVariables = this.getAdditionalTextReplacementVariables(this.enrollingPlan);
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.enrollmentFormService
            .isNextGenFormLoading$(this.enrollingPlanId)
            .pipe(distinctUntilChanged())
            .subscribe({
            next: loading => {
                loading
                    ? this.spinnerService.show(SpinnerEvent.ENROLLMENT_FORM_LOADING)
                    : this.spinnerService.hide(SpinnerEvent.ENROLLMENT_FORM_LOADING);
            }
        }));
        this.subscriptions.add(combineLatest([
            this.viewInitializedObservable$,
            this.enrollmentFormService.hasFormVersionIdChanged$(),
            this.enrollmentFormService.getIsPCApiEnrollment$(this.enrollingPlanId)
        ])
            .pipe(distinctUntilChanged(_isEqual))
            .subscribe({
            next: ([isViewInitialized, hasFormVersionIdChanged, isPCApiEnrollment]) => {
                if (hasFormVersionIdChanged && !isPCApiEnrollment) {
                    location.reload();
                }
                else {
                    isViewInitialized
                        ? this.spinnerService.hide(SpinnerEvent.ENROLLMENT_FORM_LOADING)
                        : this.spinnerService.show(SpinnerEvent.ENROLLMENT_FORM_LOADING);
                    this.isViewInitialized = isViewInitialized;
                    this.cdr.markForCheck();
                }
            }
        }));
        this.subscriptions.add(combineLatest([this.prefillData$, this.nextgenEnrollmentSepReasons$, this.formTransactionId$, this.formCanBeDisplayed$])
            .pipe(filter(([prefillData, nextgenEnrollmentSepReasons, formTransactionId, formCanBeDisplayed]) => formCanBeDisplayed), distinctUntilChanged(_isEqual))
            .subscribe({
            next: ([prefillData, nextgenEnrollmentSepReasons, formTransactionId]) => {
                const updatedPrefillData = _cloneDeep(prefillData);
                // If we received SEP Reasons, that means the plan's extra data "DisplaySEP" = "True".
                // However, if the flag "sepEnabled" is false (disabled on the SEP Management Tool), "DisplaySEP" should be updated in the prefill data
                if (nextgenEnrollmentSepReasons?.sepEnabled === false && updatedPrefillData) {
                    updatedPrefillData.displaySEP = 'False';
                }
                this.prefillData = this.mapToArray(updatedPrefillData);
                this.nextgenEnrollmentSepReasons = nextgenEnrollmentSepReasons;
                this.formPagesMetadataContext.setFormNavigationInitialized(true);
                this.transactionGUID = formTransactionId;
                this.cdr.detectChanges();
            }
        }));
        this.subscriptions.add(this.formPagesMetadataContext
            .getFormNavigationInitialized$()
            .pipe(distinctUntilChanged(_isEqual))
            .subscribe({
            next: formNavigationInitialized => {
                !formNavigationInitialized
                    ? this.spinnerService.show(SpinnerEvent.FORM_NAVIGATION_VIEW)
                    : this.spinnerService.hide(SpinnerEvent.FORM_NAVIGATION_VIEW);
                this.formNavigationInitialized = formNavigationInitialized;
            }
        }));
        this.subscriptions.add(combineLatest([
            this.enrollmentFormService.isNextGenFormLoaded$(this.enrollingPlanId),
            this.enrollmentFormService.isNextGenFormLoading$(this.enrollingPlanId)
        ])
            .pipe(distinctUntilChanged(_isEqual))
            .subscribe({
            next: ([transactionLoaded, transactionLoading]) => {
                this.loaded = transactionLoaded;
                this.loading = transactionLoading;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.stylesAppliedObservable$.pipe(distinctUntilChanged()).subscribe({
            next: stylesApplied => {
                if (stylesApplied) {
                    this.spinnerService.hide(SpinnerEvent.ENROLLMENT_FORM_LOADING);
                }
                else {
                    this.spinnerService.show(SpinnerEvent.ENROLLMENT_FORM_LOADING);
                }
                this.stylesApplied = stylesApplied;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(combineLatest([this.viewInitializedObservable$, this.viewInitializingObservable$])
            .pipe(distinctUntilChanged(_isEqual))
            .subscribe({
            next: ([isViewInitialized, isViewInitializing]) => {
                if (isViewInitialized) {
                    this.spinnerService.hide(SpinnerEvent.ENROLLMENT_FORM_LOADING);
                }
                else if (!isViewInitializing) {
                    this.spinnerService.show(SpinnerEvent.ENROLLMENT_FORM_LOADING);
                    if (this.formId && this.formVersion && this.formVersionId) {
                        this.initializeView(true, this.formId, this.formVersionId, this.formVersion);
                    }
                    else {
                        const selectedFormType = this.enrollmentFormService.getSelectedFormType(this.enrollingPlanId);
                        const userType = this.enrollmentFormService.getUserFormType(this.enrollingPlanId);
                        const planEnrollmentSettings = this.enrollmentFormService.getPlanEnrollmentSettingsByType(this.enrollingPlanId, selectedFormType, userType);
                        if (planEnrollmentSettings) {
                            this.initializeView(true, planEnrollmentSettings.formId, planEnrollmentSettings.formVersionId, planEnrollmentSettings.formVersion);
                        }
                        else {
                            this.navigationService.navigateTo404();
                        }
                    }
                }
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(combineLatest([this.enrollmentFormService.formTitleObservable$(), this.pageName$, this.formCanBeDisplayed$])
            .pipe(filter(([formTitle, pageName, formCanBeDisplayed]) => formCanBeDisplayed && !!formTitle && !!pageName), distinctUntilChanged(_isEqual))
            .subscribe({
            next: ([formTitle]) => {
                this.updateTags(formTitle);
                this.cdr.markForCheck();
            },
            error: error => {
                this.store.dispatch(new SetNextGenFormLoaded(this.enrollingPlanId, false));
                this.store.dispatch(new SetNextGenFormLoading(this.enrollingPlanId, false));
                throw error;
            }
        }));
    }
    initializeSOASubscriptions() {
        this.subscriptions?.unsubscribe();
        this.subscriptions = new Subscription();
        this.formTransactionId$ = of(this.soaTransactionId);
        this.prefillData$ = this.nextGenSOAFormFacade.getNextGenSOAPrefillData$(this.soaTransactionId);
        this.formCanBeDisplayed$ = combineLatest([
            this.viewInitializedObservable$,
            this.nextGenSOAFormFacade.isSOAFormLoaded$(this.soaTransactionId),
            this.nextGenSOAFormFacade.isSOAFormLoading$(this.soaTransactionId),
            this.formTransactionId$
        ]).pipe(distinctUntilChanged(_isEqual), map(([isViewInitialized, loaded, loading, formTransactionId]) => isViewInitialized && loaded && !loading && !!formTransactionId), distinctUntilChanged(), shareReplay(1));
        this.pageName$ = this.nextGenSOAFormNavigationContext.getPageName$();
        this.subscriptions.add(this.pageName$.subscribe({
            next: pageName => {
                this.pageName = pageName;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.nextGenSOAFormFacade
            .getSOAActivity$(this.soaTransactionId, this.isAgentAdmin)
            .pipe(distinctUntilChanged(_isEqual))
            .subscribe({
            next: soaActivity => {
                this.additionalTextReplacementVariables = this.getAdditionalSOATextReplacementVariables(soaActivity);
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.nextGenSOAFormFacade
            .isSOAFormLoading$(this.soaTransactionId)
            .pipe(distinctUntilChanged())
            .subscribe({
            next: loading => {
                loading ? this.spinnerService.show(SpinnerEvent.SOA_LOADING) : this.spinnerService.hide(SpinnerEvent.SOA_LOADING);
            }
        }));
        this.subscriptions.add(combineLatest([this.viewInitializedObservable$, this.enrollmentFormService.hasFormVersionIdChanged$()])
            .pipe(distinctUntilChanged(_isEqual))
            .subscribe({
            next: ([isViewInitialized, hasFormVersionIdChanged]) => {
                if (hasFormVersionIdChanged) {
                    location.reload();
                }
                else {
                    isViewInitialized ? this.spinnerService.hide(SpinnerEvent.SOA_LOADING) : this.spinnerService.show(SpinnerEvent.SOA_LOADING);
                    this.isViewInitialized = isViewInitialized;
                    this.cdr.markForCheck();
                }
            }
        }));
        this.subscriptions.add(combineLatest([this.prefillData$, this.formTransactionId$, this.formCanBeDisplayed$])
            .pipe(filter(([prefillData, formTransactionId, formCanBeDisplayed]) => formCanBeDisplayed), distinctUntilChanged(_isEqual))
            .subscribe({
            next: ([prefillData, formTransactionId]) => {
                const updatedPrefillData = _cloneDeep(prefillData);
                this.prefillData = this.mapToArray(updatedPrefillData);
                this.formPagesMetadataContext.setFormNavigationInitialized(true);
                this.transactionGUID = formTransactionId;
                this.cdr.detectChanges();
            }
        }));
        this.subscriptions.add(this.formPagesMetadataContext
            .getFormNavigationInitialized$()
            .pipe(distinctUntilChanged(_isEqual))
            .subscribe({
            next: formNavigationInitialized => {
                !formNavigationInitialized
                    ? this.spinnerService.show(SpinnerEvent.FORM_NAVIGATION_VIEW)
                    : this.spinnerService.hide(SpinnerEvent.FORM_NAVIGATION_VIEW);
                this.formNavigationInitialized = formNavigationInitialized;
            }
        }));
        this.subscriptions.add(combineLatest([
            this.nextGenSOAFormFacade.isSOAFormLoaded$(this.soaTransactionId),
            this.nextGenSOAFormFacade.isSOAFormLoading$(this.soaTransactionId)
        ])
            .pipe(distinctUntilChanged(_isEqual))
            .subscribe({
            next: ([transactionLoaded, transactionLoading]) => {
                this.loaded = transactionLoaded;
                this.loading = transactionLoading;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.stylesAppliedObservable$.pipe(distinctUntilChanged()).subscribe({
            next: stylesApplied => {
                if (stylesApplied) {
                    this.spinnerService.hide(SpinnerEvent.SOA_LOADING);
                }
                else {
                    this.spinnerService.show(SpinnerEvent.SOA_LOADING);
                }
                this.stylesApplied = stylesApplied;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(combineLatest([this.viewInitializedObservable$, this.viewInitializingObservable$])
            .pipe(distinctUntilChanged(_isEqual))
            .subscribe({
            next: ([isViewInitialized, isViewInitializing]) => {
                if (isViewInitialized) {
                    this.spinnerService.hide(SpinnerEvent.SOA_LOADING);
                }
                else if (!isViewInitializing) {
                    this.spinnerService.show(SpinnerEvent.SOA_LOADING);
                    this.initializeView(true, this.formId, this.formVersionId, this.formVersion);
                }
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(combineLatest([this.nextGenSOAFormFacade.formTitleObservable$(), this.pageName$, this.formCanBeDisplayed$])
            .pipe(filter(([formTitle, pageName, formCanBeDisplayed]) => formCanBeDisplayed && !!pageName && !!formTitle), distinctUntilChanged(_isEqual))
            .subscribe({
            next: ([formTitle]) => {
                this.updateTags(formTitle);
                this.cdr.markForCheck();
            },
            error: error => {
                this.store.dispatch([
                    new SetNextGenSOAFormLoaded(this.soaTransactionId, false),
                    new SetNextGenSOAFormLoading(this.soaTransactionId, false)
                ]);
                throw error;
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions?.unsubscribe();
    }
    mapToArray(prefillData) {
        return Object.entries(prefillData).map(([key, value]) => ({
            name: key,
            value
        }));
    }
    retrieveFormInputValues() {
        // get current page
        // grab current page values from subject
        return this.currentPageAnswers;
    }
    retrieveAllFormInputValues() {
        return this.allPageAnswers;
    }
    updateTags(formTitle) {
        const pagePath = this.router.url;
        if (this.analyticsService.googleDataLayerTags[DataLayerGlobalVariable.PAGE_PATH] !== pagePath) {
            const googleTagManagerNotApplicableText = this.analyticsService.getGoogleTagManagerNotApplicableText();
            const planType = this.enrollingPlan?.planTypeAbbreviation ?? googleTagManagerNotApplicableText;
            let tagsToUpdate = {
                [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE,
                [DataLayerGlobalVariable.PAGE_PATH]: pagePath,
                [DataLayerGlobalVariable.PLAN_TYPE]: planType.toString(),
                [DataLayerGlobalVariable.PLAN_NAME]: this.enrollingPlan?.planName ?? googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.PLAN_ID]: this.enrollingPlan?.id ?? googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.PLAN_CARRIER]: this.enrollingPlan?.carrierName ?? googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.PLAN_PREMIUM_MONTHLY]: this.enrollmentFormFacade.getEnrollingPlanPremium(this.enrollingPlanId),
                [DataLayerGlobalVariable.ENROLLMENT_PLAN_COUNT]: `${this.shoppingCartService.getEnrollmentPlanCount()}`,
                [DataLayerGlobalVariable.TRANSACTION_GUID]: this.transactionGUID ?? googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.ENROLLMENT_FORM_TYPE]: `${EnrollSystemType.NextGen}`,
                [DataLayerGlobalVariable.ENROLLMENT_FORM_NAME]: formTitle ?? googleTagManagerNotApplicableText
            };
            tagsToUpdate = this.enrollmentFormService.updateTagForEnrollmentMethod(tagsToUpdate, this.enrollingPlanId);
            tagsToUpdate = this.analyticsService.getGlobalDataLayerTags(tagsToUpdate);
            this.analyticsService.googleDataLayerTags = tagsToUpdate;
        }
    }
    getCurrentPageAnswers(formAnswers, currentPageAnsweredFieldNames) {
        return (currentPageAnsweredFieldNames?.reduce((selectedFormAnswers, answeredFieldName) => {
            if (formAnswers?.[answeredFieldName] !== undefined) {
                selectedFormAnswers[answeredFieldName] = formAnswers[answeredFieldName];
            }
            return selectedFormAnswers;
        }, {}) ?? {});
    }
    // The value we get out of sender.currentPage.getValue() is an object containing values of either single questions in a name:value format,
    // Or a template name, where the value is an object that then could possibly be another template, or single questions.
    // So in order to handle that we recurisvely go through any objects until all we have are name: value pairs and return that
    flattenObject(obj) {
        if (typeof obj === 'object') {
            let ret = {};
            Object.keys(obj).forEach(keyName => {
                const item = obj[keyName];
                // The item will either be a single value, an array of values, or an object of values, and those values may be objects
                if (typeof item === 'object' && !Array.isArray(item)) {
                    ret = { ...ret, ...this.flattenObject(item) };
                }
                else {
                    // if it's not an object, just add it
                    ret[keyName] = item;
                }
            });
            return ret;
        }
        else {
            return obj;
        }
    }
    getAdditionalTextReplacementVariables(enrollingPlan) {
        if (enrollingPlan) {
            const clientName = this.configResourceService.getProcessedResourceValue('Spa_ClientName', null, '');
            const carrierInformation = enrollingPlan.carrierInformation;
            const planYear = enrollingPlan.planYear;
            const planEffectiveDate = this.utilityFunctionService.getUtilityFunction('getSelectedPlanEffectiveDate')?.(planYear);
            const planPremiumMonthly = this.shoppingCartService.getShoppingCartPremium(enrollingPlan, []);
            return {
                ...(clientName && { ClientName: clientName }),
                ...(carrierInformation && {
                    CarrierName: carrierInformation.carrierName ?? '',
                    WebsiteURL: carrierInformation.websiteURL ?? ''
                }),
                ...(enrollingPlan.planMarketingName && { MarketingName: enrollingPlan.planMarketingName }),
                ...(planPremiumMonthly !== null &&
                    planPremiumMonthly !== undefined && {
                    PlanPremiumMonthly: this.currencyPipe.transform(planPremiumMonthly, 'USD', 'symbol', '1.2-2')
                }),
                ...(planEffectiveDate && { PlanEffectiveDate: planEffectiveDate }),
                ...(planYear && { PlanYear: planYear })
            };
        }
        return {};
    }
    getAdditionalSOATextReplacementVariables(soaActivity) {
        if (soaActivity) {
            const clientName = this.configResourceService.getProcessedResourceValue('Spa_ClientName', null, '');
            const planYear = soaActivity.planYear;
            return {
                ...(clientName && { ClientName: clientName }),
                ...(planYear && { PlanYear: planYear })
            };
        }
        return {};
    }
}
NextGenEnrollmentFormRendererComponent.ɵfac = function NextGenEnrollmentFormRendererComponent_Factory(t) { return new (t || NextGenEnrollmentFormRendererComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.ShoppingCartService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(EnrollmentFormFacade), i0.ɵɵdirectiveInject(FormRootStrategyService), i0.ɵɵdirectiveInject(i1.QuoteService), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.FormPagesMetadataContext), i0.ɵɵdirectiveInject(i1$2.CurrencyPipe), i0.ɵɵdirectiveInject(i1.UtilityFunctionService), i0.ɵɵdirectiveInject(NextGenSOAFormFacade), i0.ɵɵdirectiveInject(NextGenSOAFormNavigationContext)); };
NextGenEnrollmentFormRendererComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NextGenEnrollmentFormRendererComponent, selectors: [["nextgen-enrollment-form-renderer"]], viewQuery: function NextGenEnrollmentFormRendererComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$28, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.enrollmentFormHtml = _t.first);
    } }, hostBindings: function NextGenEnrollmentFormRendererComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("NextGenForm_Question_Form_Updated", function NextGenEnrollmentFormRendererComponent_NextGenForm_Question_Form_Updated_HostBindingHandler($event) { return ctx.questionUpdated($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_Navigate_To_Next_Page", function NextGenEnrollmentFormRendererComponent_NextGenForm_Navigate_To_Next_Page_HostBindingHandler($event) { return ctx.navigatedToNextPage($event); }, false, i0.ɵɵresolveDocument);
    } }, inputs: { formId: "formId", formVersion: "formVersion", formVersionId: "formVersionId", soaTransactionId: "soaTransactionId", isSOAForm: "isSOAForm", isAgentAdmin: "isAgentAdmin", surveyInitialized: "surveyInitialized" }, outputs: { formValueUpdate: "formValueUpdate" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 2, vars: 12, consts: [[3, "ngClass"], [3, "surveydata", "transactionguid", "isaddressautocompleteenabled", "ssopopulatedfields", "nextgenenrollmentsepreasons", "issendtobeneficiary", "reviewsectionscollapsedbydefault", "additionaltextreplacementvariables", "pagename"]], template: function NextGenEnrollmentFormRendererComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "nextgen-form-renderer", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c1$_, !ctx.isViewInitialized && ctx.loaded && !ctx.loading && !ctx.surveyInitialized && !ctx.formNavigationInitialized || !ctx.stylesApplied || !ctx.transactionGUID || !ctx.pageName));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("surveydata", ctx.prefillData)("transactionguid", ctx.transactionGUID)("isaddressautocompleteenabled", ctx.isAddressAutocompleteEnabled)("ssopopulatedfields", ctx.ssoPopulatedFields)("nextgenenrollmentsepreasons", ctx.nextgenEnrollmentSepReasons)("issendtobeneficiary", ctx.isSendToBeneficiary)("reviewsectionscollapsedbydefault", ctx.reviewSectionsCollapsedByDefault)("additionaltextreplacementvariables", ctx.additionalTextReplacementVariables)("pagename", ctx.pageName);
    } }, dependencies: [i1$2.NgClass], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NextGenEnrollmentFormRendererComponent, [{
        type: Component,
        args: [{ selector: 'nextgen-enrollment-form-renderer', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  [ngClass]=\"{\r\n    'd-none':\r\n      (!isViewInitialized && loaded && !loading && !surveyInitialized && !formNavigationInitialized) ||\r\n      !stylesApplied ||\r\n      !transactionGUID ||\r\n      !pageName\r\n  }\"\r\n>\r\n  <nextgen-form-renderer\r\n    [surveydata]=\"prefillData\"\r\n    [transactionguid]=\"transactionGUID\"\r\n    [isaddressautocompleteenabled]=\"isAddressAutocompleteEnabled\"\r\n    [ssopopulatedfields]=\"ssoPopulatedFields\"\r\n    [nextgenenrollmentsepreasons]=\"nextgenEnrollmentSepReasons\"\r\n    [issendtobeneficiary]=\"isSendToBeneficiary\"\r\n    [reviewsectionscollapsedbydefault]=\"reviewSectionsCollapsedByDefault\"\r\n    [additionaltextreplacementvariables]=\"additionalTextReplacementVariables\"\r\n    [pagename]=\"pageName\"\r\n  ></nextgen-form-renderer>\r\n</div>\r\n" }]
    }], function () { return [{ type: i0.ElementRef }, { type: i1.EnrollmentFormService }, { type: i2$1.ActivatedRoute }, { type: i0.ChangeDetectorRef }, { type: i1.SpinnerService }, { type: i2$1.Router }, { type: i2.Store }, { type: i1.NavigationUtilityService }, { type: i1.NavigationService }, { type: i1.ShoppingCartService }, { type: i1.ConfigResourceService }, { type: AnalyticsService }, { type: EnrollmentFormFacade }, { type: FormRootStrategyService }, { type: i1.QuoteService }, { type: i1.SiteService }, { type: i1.MemberSessionService }, { type: i1.FormPagesMetadataContext }, { type: i1$2.CurrencyPipe }, { type: i1.UtilityFunctionService }, { type: NextGenSOAFormFacade }, { type: NextGenSOAFormNavigationContext }]; }, { enrollmentFormHtml: [{
            type: ViewChild,
            args: ['enrollmentFormHtml']
        }], formValueUpdate: [{
            type: Output
        }], formId: [{
            type: Input
        }], formVersion: [{
            type: Input
        }], formVersionId: [{
            type: Input
        }], soaTransactionId: [{
            type: Input
        }], isSOAForm: [{
            type: Input
        }], isAgentAdmin: [{
            type: Input
        }], surveyInitialized: [{
            type: Input
        }], questionUpdated: [{
            type: HostListener,
            args: [`document:NextGenForm_Question_Form_Updated`, ['$event']]
        }], navigatedToNextPage: [{
            type: HostListener,
            args: [`document:NextGenForm_Navigate_To_Next_Page`, ['$event']]
        }] }); })();

function EnrollmentNavigationStepComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 7)(1, "i", 8);
    i0.ɵɵelementStart(2, "span", 9);
    i0.ɵɵtext(3, "Step status: complete");
    i0.ɵɵelementEnd();
} }
function EnrollmentNavigationStepComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 10);
    i0.ɵɵelementStart(1, "strong", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 9);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.stepNumber);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Step ", ctx_r1.stepNumber, ": Currently active");
} }
function EnrollmentNavigationStepComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 7);
    i0.ɵɵelementStart(1, "strong", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 9);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.stepNumber);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Step ", ctx_r2.stepNumber, ": Visitable");
} }
function EnrollmentNavigationStepComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 12);
    i0.ɵɵelementStart(1, "strong", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 9);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.stepNumber);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Step ", ctx_r3.stepNumber, ": Inactive");
} }
const _c0$27 = function (a0, a1, a2, a3, a4, a5, a6) { return { "clickable": a0, "first": a1, "last": a2, "complete-line-before": a3, "complete-line-after": a4, "line-before": a5, "line-after": a6 }; };
const _c1$Z = function (a0, a1) { return { Spa_Style_Primary_Link_Color: a0, Spa_Style_Gray4_Color: a1 }; };
class EnrollmentNavigationStepComponent {
    constructor() {
        this.offScreenText = '';
        this.selectStep = new EventEmitter();
    }
    ngOnChanges() {
        this.offScreenText = this.getCurrentText();
    }
    getCurrentText() {
        if (this.status === 'active') {
            return `${this.offScreenLabelStep} ${this.stepNumber}: ${this.label}` + ` ${this.offScreenLabelCurrent}`;
        }
        return `${this.offScreenLabelStep} ${this.stepNumber}: ${this.label}`;
    }
    clickStep(stepNumber) {
        this.selectStep.emit(stepNumber);
    }
}
EnrollmentNavigationStepComponent.ɵfac = function EnrollmentNavigationStepComponent_Factory(t) { return new (t || EnrollmentNavigationStepComponent)(); };
EnrollmentNavigationStepComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EnrollmentNavigationStepComponent, selectors: [["vnext-enrollment-navigation-step"]], inputs: { status: "status", label: "label", stepNumber: "stepNumber", totalSteps: "totalSteps", visited: "visited", nextVisited: "nextVisited", skipped: "skipped", nextSkipped: "nextSkipped", offScreenLabelStep: "offScreenLabelStep", offScreenLabelCurrent: "offScreenLabelCurrent" }, outputs: { selectStep: "selectStep" }, features: [i0.ɵɵNgOnChangesFeature], decls: 11, vars: 24, consts: [["role", "presentation", 3, "ngClass"], ["tabindex", "0", 1, "step-trigger", 3, "disabled", "click"], [1, "bs-stepper-circle"], [1, "fa-stack"], [3, "ngIf"], [1, "Spa_Style_Note"], [1, "bs-stepper-label", "d-none", "d-sm-block", 3, "ngClass"], [1, "fas", "fa-circle", "fa-stack-2x", "Spa_Style_Gray4_Color"], [1, "fa", "fa-check", "fa-stack-1x", "foreground"], [1, "sr-only"], [1, "fas", "fa-circle", "fa-stack-2x", "Spa_Style_Primary_Link_Color"], [1, "fa-stack-1x", "foreground", "d-none", "d-sm-block"], [1, "fal", "fa-circle", "fa-stack-2x", "background"]], template: function EnrollmentNavigationStepComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
        i0.ɵɵlistener("click", function EnrollmentNavigationStepComponent_Template_button_click_1_listener() { return ctx.clickStep(ctx.stepNumber); });
        i0.ɵɵelementStart(2, "div", 2)(3, "span", 3);
        i0.ɵɵtemplate(4, EnrollmentNavigationStepComponent_ng_template_4_Template, 4, 0, "ng-template", 4);
        i0.ɵɵtemplate(5, EnrollmentNavigationStepComponent_ng_template_5_Template, 5, 2, "ng-template", 4);
        i0.ɵɵtemplate(6, EnrollmentNavigationStepComponent_ng_template_6_Template, 5, 2, "ng-template", 4);
        i0.ɵɵtemplate(7, EnrollmentNavigationStepComponent_ng_template_7_Template, 5, 2, "ng-template", 4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "div", 5)(9, "div", 6);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵclassMapInterpolate1("step line ", ctx.status, "");
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction7(13, _c0$27, ctx.visited && ctx.status !== "active", ctx.stepNumber === 1, ctx.stepNumber === ctx.totalSteps, ctx.stepNumber > 1 && (ctx.status === "complete" || ctx.status === "active" || ctx.status === "skipped" || ctx.visited), ctx.nextVisited || ctx.nextSkipped, ctx.stepNumber > 1 && (!ctx.status || ctx.status === ""), ctx.stepNumber < ctx.totalSteps && !ctx.nextVisited || ctx.nextSkipped));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", ctx.status === "active" || ctx.status === "skipped" || !ctx.visited);
        i0.ɵɵattribute("aria-current", ctx.status === "active" ? "step" : null)("aria-label", ctx.offScreenText);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.status === "complete" || ctx.status === "skipped");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.status === "active");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (!ctx.status || ctx.status === "") && ctx.visited);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (!ctx.status || ctx.status === "") && !ctx.visited);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(21, _c1$Z, ctx.status === "active", ctx.status === "complete" || ctx.status === "visited" || ctx.status === "skipped"));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.label, " ");
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, IconAriaAttributesDirective], styles: [".step[_ngcontent-%COMP%]   .step-trigger[_ngcontent-%COMP%]{cursor:default}.step.clickable[_ngcontent-%COMP%]   .step-trigger[_ngcontent-%COMP%]{cursor:pointer}.bs-stepper-circle[_ngcontent-%COMP%]   .background[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent1)}.bs-stepper-circle[_ngcontent-%COMP%]   .foreground[_ngcontent-%COMP%], .step.clickable[_ngcontent-%COMP%]   .bs-stepper-circle[_ngcontent-%COMP%]   .background[_ngcontent-%COMP%], .step.complete[_ngcontent-%COMP%]   .bs-stepper-circle[_ngcontent-%COMP%], .step.complete[_ngcontent-%COMP%]   .bs-stepper-circle[_ngcontent-%COMP%]   .background[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Gray4)}.step.complete[_ngcontent-%COMP%]   .bs-stepper-circle[_ngcontent-%COMP%]   .foreground[_ngcontent-%COMP%], .step.clickable[_ngcontent-%COMP%]   .bs-stepper-circle[_ngcontent-%COMP%]   .foreground[_ngcontent-%COMP%], .step.active[_ngcontent-%COMP%]   .bs-stepper-circle[_ngcontent-%COMP%]   .foreground[_ngcontent-%COMP%], .step.skipped[_ngcontent-%COMP%]   .bs-stepper-circle[_ngcontent-%COMP%]   .foreground[_ngcontent-%COMP%]{color:#fff}.step.active[_ngcontent-%COMP%]   .bs-stepper-label[_ngcontent-%COMP%]{font-weight:650;font-family:montserrat_bold}.step.complete[_ngcontent-%COMP%]   .bs-stepper-label[_ngcontent-%COMP%]{font-weight:650}.bs-stepper-label[_ngcontent-%COMP%]{font-weight:400;font-size:14px;line-height:18px}.step[_ngcontent-%COMP%]{position:relative}.step-trigger[_ngcontent-%COMP%]{background-color:transparent;border:none;width:100%;height:auto}.step-trigger[_ngcontent-%COMP%]:focus{border-radius:5px}@media (min-width: 576px){.bs-stepper-circle[_ngcontent-%COMP%]{background-color:#fff;display:inline-flex;width:32px}.line[_ngcontent-%COMP%]:before, .line[_ngcontent-%COMP%]:after{border-top-width:2px;border-top-style:solid;border-color:var(--static-Spa_Style_Accent1);content:\"\";display:inline-block;height:0;position:absolute;top:16px;width:50%;z-index:-1}.line-before[_ngcontent-%COMP%]:before, .complete-line-before[_ngcontent-%COMP%]:before{left:0}.line-after[_ngcontent-%COMP%]:after, .complete-line-after[_ngcontent-%COMP%]:after{right:0}.complete-line-after[_ngcontent-%COMP%]:after, .complete-line-before[_ngcontent-%COMP%]:before{border-color:var(--static-Spa_Style_Gray4)}.line.first[_ngcontent-%COMP%]:before, .line.last[_ngcontent-%COMP%]:after{display:none}}@media (max-width: 575px){.step-trigger[_ngcontent-%COMP%]{font-size:7px}}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], EnrollmentNavigationStepComponent.prototype, "clickStep", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentNavigationStepComponent, [{
        type: Component,
        args: [{ selector: 'vnext-enrollment-navigation-step', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  class=\"step line {{ status }}\"\r\n  role=\"presentation\"\r\n  [ngClass]=\"{\r\n    'clickable': visited && status !== 'active',\r\n    'first': stepNumber === 1,\r\n    'last': stepNumber === totalSteps,\r\n    'complete-line-before': stepNumber > 1 && (status === 'complete' || status === 'active' || status === 'skipped' || visited),\r\n    'complete-line-after': nextVisited || nextSkipped,\r\n    'line-before': stepNumber > 1 && (!status || status === ''),\r\n    'line-after': (stepNumber < totalSteps && !nextVisited) || nextSkipped\r\n  }\"\r\n>\r\n  <button\r\n    class=\"step-trigger\"\r\n    [disabled]=\"status === 'active' || status === 'skipped' || !visited\"\r\n    (click)=\"clickStep(stepNumber)\"\r\n    [attr.aria-current]=\"status === 'active' ? 'step' : null\"\r\n    [attr.aria-label]=\"offScreenText\"\r\n    tabindex=\"0\"\r\n  >\r\n    <div class=\"bs-stepper-circle\">\r\n      <span class=\"fa-stack\">\r\n        <ng-template [ngIf]=\"status === 'complete' || status === 'skipped'\">\r\n          <i class=\"fas fa-circle fa-stack-2x Spa_Style_Gray4_Color\"></i>\r\n          <i class=\"fa fa-check fa-stack-1x foreground\"></i>\r\n          <span class=\"sr-only\">Step status: complete</span>\r\n        </ng-template>\r\n        <ng-template [ngIf]=\"status === 'active'\">\r\n          <i class=\"fas fa-circle fa-stack-2x Spa_Style_Primary_Link_Color\"></i>\r\n          <strong class=\"fa-stack-1x foreground d-none d-sm-block\">{{ stepNumber }}</strong>\r\n          <span class=\"sr-only\">Step {{ stepNumber}}: Currently active</span>\r\n        </ng-template>\r\n        <ng-template [ngIf]=\"(!status || status === '') && visited\">\r\n          <i class=\"fas fa-circle fa-stack-2x Spa_Style_Gray4_Color\"></i>\r\n          <strong class=\"fa-stack-1x foreground d-none d-sm-block\">{{ stepNumber }}</strong>\r\n          <span class=\"sr-only\">Step {{ stepNumber}}: Visitable</span>\r\n        </ng-template>\r\n        <ng-template [ngIf]=\"(!status || status === '') && !visited\">\r\n          <i class=\"fal fa-circle fa-stack-2x background\"></i>\r\n          <strong class=\"fa-stack-1x foreground d-none d-sm-block\">{{ stepNumber }}</strong>\r\n          <span class=\"sr-only\">Step {{ stepNumber}}: Inactive</span>\r\n        </ng-template>\r\n      </span>\r\n    </div>\r\n    <div class=\"Spa_Style_Note\">\r\n      <div\r\n        class=\"bs-stepper-label d-none d-sm-block\"\r\n        [ngClass]=\"{\r\n          Spa_Style_Primary_Link_Color: status === 'active',\r\n          Spa_Style_Gray4_Color: status === 'complete' || status === 'visited' || status === 'skipped'\r\n        }\"\r\n      >\r\n        {{ label }}\r\n      </div>\r\n    </div>\r\n  </button>\r\n</div>\r\n", styles: [".step .step-trigger{cursor:default}.step.clickable .step-trigger{cursor:pointer}.bs-stepper-circle .background{color:var(--static-Spa_Style_Accent1)}.bs-stepper-circle .foreground,.step.clickable .bs-stepper-circle .background,.step.complete .bs-stepper-circle,.step.complete .bs-stepper-circle .background{color:var(--static-Spa_Style_Gray4)}.step.complete .bs-stepper-circle .foreground,.step.clickable .bs-stepper-circle .foreground,.step.active .bs-stepper-circle .foreground,.step.skipped .bs-stepper-circle .foreground{color:#fff}.step.active .bs-stepper-label{font-weight:650;font-family:montserrat_bold}.step.complete .bs-stepper-label{font-weight:650}.bs-stepper-label{font-weight:400;font-size:14px;line-height:18px}.step{position:relative}.step-trigger{background-color:transparent;border:none;width:100%;height:auto}.step-trigger:focus{border-radius:5px}@media (min-width: 576px){.bs-stepper-circle{background-color:#fff;display:inline-flex;width:32px}.line:before,.line:after{border-top-width:2px;border-top-style:solid;border-color:var(--static-Spa_Style_Accent1);content:\"\";display:inline-block;height:0;position:absolute;top:16px;width:50%;z-index:-1}.line-before:before,.complete-line-before:before{left:0}.line-after:after,.complete-line-after:after{right:0}.complete-line-after:after,.complete-line-before:before{border-color:var(--static-Spa_Style_Gray4)}.line.first:before,.line.last:after{display:none}}@media (max-width: 575px){.step-trigger{font-size:7px}}\n"] }]
    }], null, { status: [{
            type: Input
        }], label: [{
            type: Input
        }], stepNumber: [{
            type: Input
        }], totalSteps: [{
            type: Input
        }], visited: [{
            type: Input
        }], nextVisited: [{
            type: Input
        }], skipped: [{
            type: Input
        }], nextSkipped: [{
            type: Input
        }], offScreenLabelStep: [{
            type: Input
        }], offScreenLabelCurrent: [{
            type: Input
        }], selectStep: [{
            type: Output
        }], clickStep: [] }); })();

function EnrollmentNavigationBarBaseComponent_div_0_div_1_vnext_enrollment_navigation_step_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-enrollment-navigation-step", 5);
    i0.ɵɵlistener("selectStep", function EnrollmentNavigationBarBaseComponent_div_0_div_1_vnext_enrollment_navigation_step_1_Template_vnext_enrollment_navigation_step_selectStep_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r5.navigateToStep($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const formPage_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("status", formPage_r3 == null ? null : formPage_r3.status)("visited", !!(formPage_r3 == null ? null : formPage_r3.visited))("nextVisited", !!(ctx_r2.formPageMetadata == null ? null : ctx_r2.formPageMetadata.pages[i_r4 + 1] == null ? null : ctx_r2.formPageMetadata.pages[i_r4 + 1].visited))("skipped", !!(formPage_r3 == null ? null : formPage_r3.skipped))("nextSkipped", !!(ctx_r2.formPageMetadata == null ? null : ctx_r2.formPageMetadata.pages[i_r4 + 1] == null ? null : ctx_r2.formPageMetadata.pages[i_r4 + 1].skipped))("label", formPage_r3 == null ? null : formPage_r3.friendlyName)("stepNumber", i_r4 + 1)("totalSteps", ctx_r2.formPageMetadata == null ? null : ctx_r2.formPageMetadata.pages == null ? null : ctx_r2.formPageMetadata.pages.length)("offScreenLabelStep", ctx_r2.offScreenStepLabel)("offScreenLabelCurrent", ctx_r2.offScreenStepCurrentLabel);
} }
function EnrollmentNavigationBarBaseComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, EnrollmentNavigationBarBaseComponent_div_0_div_1_vnext_enrollment_navigation_step_1_Template, 1, 10, "vnext-enrollment-navigation-step", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.formPageMetadata.pages);
} }
const _c0$26 = function (a0) { return { "enrollment-navigation-bar-wrapper": a0 }; };
function EnrollmentNavigationBarBaseComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, EnrollmentNavigationBarBaseComponent_div_0_div_1_Template, 2, 1, "div", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$26, ctx_r0.displayNavigationBarWrapper))("disableCommonEvent", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.formPageMetadata == null ? null : ctx_r0.formPageMetadata.pages == null ? null : ctx_r0.formPageMetadata.pages.length);
} }
class EnrollmentNavigationBarBaseComponent {
    ngOnChanges(changes) {
        const { formPageMetadata } = changes;
        if (formPageMetadata && !_isEqual(formPageMetadata.previousValue, formPageMetadata.currentValue)) {
            // TODO: what derived values do we need here? any?
        }
    }
}
EnrollmentNavigationBarBaseComponent.ɵfac = function EnrollmentNavigationBarBaseComponent_Factory(t) { return new (t || EnrollmentNavigationBarBaseComponent)(); };
EnrollmentNavigationBarBaseComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EnrollmentNavigationBarBaseComponent, selectors: [["vnext-enrollment-navigation-bar-base"]], inputs: { formPageMetadata: "formPageMetadata", navigateToStep: "navigateToStep", displayNavigationBarWrapper: "displayNavigationBarWrapper", offScreenStepLabel: "offScreenStepLabel", offScreenStepCurrentLabel: "offScreenStepCurrentLabel", displayNavigation: "displayNavigation" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "container", "vnextGoogleTagManager", "", 3, "ngClass", "disableCommonEvent", 4, "ngIf"], ["vnextGoogleTagManager", "", 1, "container", 3, "ngClass", "disableCommonEvent"], ["class", "enrollment-navigation-bar", 4, "ngIf"], [1, "enrollment-navigation-bar"], ["class", "navigation-step", "role", "presentation", 3, "status", "visited", "nextVisited", "skipped", "nextSkipped", "label", "stepNumber", "totalSteps", "offScreenLabelStep", "offScreenLabelCurrent", "selectStep", 4, "ngFor", "ngForOf"], ["role", "presentation", 1, "navigation-step", 3, "status", "visited", "nextVisited", "skipped", "nextSkipped", "label", "stepNumber", "totalSteps", "offScreenLabelStep", "offScreenLabelCurrent", "selectStep"]], template: function EnrollmentNavigationBarBaseComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, EnrollmentNavigationBarBaseComponent_div_0_Template, 2, 5, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.displayNavigation);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, GoogleTagManagerDirective, EnrollmentNavigationStepComponent], styles: [".enrollment-navigation-bar[_ngcontent-%COMP%]{margin-top:10px;position:relative;justify-content:center;display:flex}.enrollment-navigation-bar-wrapper[_ngcontent-%COMP%]{margin-top:52px}@media (min-width: 576px){.navigation-step[_ngcontent-%COMP%]{width:100%}}@media (max-width: 575px){.navigation-step[_ngcontent-%COMP%]{width:25px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentNavigationBarBaseComponent, [{
        type: Component,
        args: [{ selector: 'vnext-enrollment-navigation-bar-base', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  *ngIf=\"displayNavigation\"\r\n  class=\"container\"\r\n  [ngClass]=\"{ 'enrollment-navigation-bar-wrapper': displayNavigationBarWrapper }\"\r\n  vnextGoogleTagManager\r\n  [disableCommonEvent]=\"true\"\r\n>\r\n  <div class=\"enrollment-navigation-bar\" *ngIf=\"formPageMetadata?.pages?.length\">\r\n    <vnext-enrollment-navigation-step\r\n      *ngFor=\"let formPage of formPageMetadata.pages; index as i\"\r\n      [status]=\"formPage?.status\"\r\n      [visited]=\"!!formPage?.visited\"\r\n      [nextVisited]=\"!!formPageMetadata?.pages[i + 1]?.visited\"\r\n      [skipped]=\"!!formPage?.skipped\"\r\n      [nextSkipped]=\"!!formPageMetadata?.pages[i + 1]?.skipped\"\r\n      [label]=\"formPage?.friendlyName\"\r\n      [stepNumber]=\"i + 1\"\r\n      [totalSteps]=\"formPageMetadata?.pages?.length\"\r\n      (selectStep)=\"navigateToStep($event)\"\r\n      [offScreenLabelStep]=\"offScreenStepLabel\"\r\n      [offScreenLabelCurrent]=\"offScreenStepCurrentLabel\"\r\n      class=\"navigation-step\"\r\n      role=\"presentation\"\r\n    >\r\n    </vnext-enrollment-navigation-step>\r\n  </div>\r\n</div>\r\n", styles: [".enrollment-navigation-bar{margin-top:10px;position:relative;justify-content:center;display:flex}.enrollment-navigation-bar-wrapper{margin-top:52px}@media (min-width: 576px){.navigation-step{width:100%}}@media (max-width: 575px){.navigation-step{width:25px}}\n"] }]
    }], null, { formPageMetadata: [{
            type: Input
        }], navigateToStep: [{
            type: Input
        }], displayNavigationBarWrapper: [{
            type: Input
        }], offScreenStepLabel: [{
            type: Input
        }], offScreenStepCurrentLabel: [{
            type: Input
        }], displayNavigation: [{
            type: Input
        }] }); })();

function NextGenEnrollmentNavigationBarComponent_vnext_enrollment_navigation_bar_base_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-enrollment-navigation-bar-base", 1);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formPageMetadata", ctx_r0.formPageMetadata)("navigateToStep", ctx_r0.navigateToStep)("displayNavigationBarWrapper", ctx_r0.displayNavigationBarWrapper)("offScreenStepLabel", ctx_r0.offScreenStepLabel)("offScreenStepCurrentLabel", ctx_r0.offScreenStepCurrentLabel)("displayNavigation", ctx_r0.displayNavigation);
} }
class NextGenEnrollmentNavigationBarComponent {
    constructor(cdr, viewContainer, formPagesMetadataContext, enrollmentFormErrorsContext) {
        this.cdr = cdr;
        this.viewContainer = viewContainer;
        this.formPagesMetadataContext = formPagesMetadataContext;
        this.enrollmentFormErrorsContext = enrollmentFormErrorsContext;
        // @Input() formPageMetadata: FormPageMetadata[];
        // @Input() navigateToStep: (event) => void;
        this.displayNavigationBarWrapper = true;
        this.offScreenStepLabel = 'Step';
        this.offScreenStepCurrentLabel = '(Active Step)';
        this.displayNavigation = true;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.subscriptions.add(this.formPagesMetadataContext.getFormPagesMetadata$().subscribe({
            next: formPageMetadata => {
                this.formPageMetadata = formPageMetadata;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.formPagesMetadataContext.getFormNavigationInitialized$().subscribe({
            next: formNavigationInitialized => {
                this.formNavigationInitialized = formNavigationInitialized;
                this.cdr.markForCheck();
            }
        }));
        this.navigateToStep = (stepNumber) => {
            if (this.formPageMetadata) {
                const pageToNavigateTo = this.formPageMetadata.pages.find(page => page.index === stepNumber);
                const currentPage = this.formPageMetadata.pages.find(page => page.active);
                // if we are navigating to previous page, clear errors?
                if (pageToNavigateTo?.index < currentPage?.index) {
                    this.enrollmentFormErrorsContext.clearFormErrors();
                }
                const pageName = pageToNavigateTo?.pageName;
                this.viewContainer.element.nativeElement.dispatchEvent(new CustomEvent(NextGenEnrollmentEvents.NAVIGATE_BY_PAGE_NAME, { bubbles: true, detail: { name: pageName } }));
            }
        };
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
NextGenEnrollmentNavigationBarComponent.ɵfac = function NextGenEnrollmentNavigationBarComponent_Factory(t) { return new (t || NextGenEnrollmentNavigationBarComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i1.FormPagesMetadataContext), i0.ɵɵdirectiveInject(i1.EnrollmentFormErrorsContext)); };
NextGenEnrollmentNavigationBarComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NextGenEnrollmentNavigationBarComponent, selectors: [["nextgen-enrollment-navigation-bar"]], inputs: { displayNavigationBarWrapper: "displayNavigationBarWrapper", offScreenStepLabel: "offScreenStepLabel", offScreenStepCurrentLabel: "offScreenStepCurrentLabel", displayNavigation: "displayNavigation" }, decls: 1, vars: 1, consts: [[3, "formPageMetadata", "navigateToStep", "displayNavigationBarWrapper", "offScreenStepLabel", "offScreenStepCurrentLabel", "displayNavigation", 4, "ngIf"], [3, "formPageMetadata", "navigateToStep", "displayNavigationBarWrapper", "offScreenStepLabel", "offScreenStepCurrentLabel", "displayNavigation"]], template: function NextGenEnrollmentNavigationBarComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, NextGenEnrollmentNavigationBarComponent_vnext_enrollment_navigation_bar_base_0_Template, 1, 6, "vnext-enrollment-navigation-bar-base", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.formNavigationInitialized);
    } }, dependencies: [i1$2.NgIf, EnrollmentNavigationBarBaseComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NextGenEnrollmentNavigationBarComponent, [{
        type: Component,
        args: [{ selector: 'nextgen-enrollment-navigation-bar', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-enrollment-navigation-bar-base\r\n  *ngIf=\"formNavigationInitialized\"\r\n  [formPageMetadata]=\"formPageMetadata\"\r\n  [navigateToStep]=\"navigateToStep\"\r\n  [displayNavigationBarWrapper]=\"displayNavigationBarWrapper\"\r\n  [offScreenStepLabel]=\"offScreenStepLabel\"\r\n  [offScreenStepCurrentLabel]=\"offScreenStepCurrentLabel\"\r\n  [displayNavigation]=\"displayNavigation\"\r\n>\r\n</vnext-enrollment-navigation-bar-base>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ViewContainerRef }, { type: i1.FormPagesMetadataContext }, { type: i1.EnrollmentFormErrorsContext }]; }, { displayNavigationBarWrapper: [{
            type: Input
        }], offScreenStepLabel: [{
            type: Input
        }], offScreenStepCurrentLabel: [{
            type: Input
        }], displayNavigation: [{
            type: Input
        }] }); })();

function PlanCompareEnrollmentNavigationBarComponent_div_0_div_1_vnext_enrollment_navigation_step_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-enrollment-navigation-step", 5);
    i0.ɵɵlistener("selectStep", function PlanCompareEnrollmentNavigationBarComponent_div_0_div_1_vnext_enrollment_navigation_step_1_Template_vnext_enrollment_navigation_step_selectStep_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r6.navigateToStep($event)); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const formPage_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    const formPages_r2 = i0.ɵɵnextContext().ngIf;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("status", i0.ɵɵpipeBind1(1, 10, ctx_r3.getCompletionStatus$(i_r5)))("visited", i0.ɵɵpipeBind1(2, 12, ctx_r3.getVisitedStatus$(i_r5)))("nextVisited", i0.ɵɵpipeBind1(3, 14, ctx_r3.getVisitedStatus$(i_r5 + 1)))("skipped", i0.ɵɵpipeBind1(4, 16, ctx_r3.getCompletionStatus$(i_r5)) === "skipped")("nextSkipped", i0.ɵɵpipeBind1(5, 18, ctx_r3.getCompletionStatus$(i_r5 + 1)) === "skipped")("label", i0.ɵɵpipeBind1(6, 20, ctx_r3.getFriendlyName$(formPage_r4)))("stepNumber", i_r5 + 1)("totalSteps", formPages_r2.length)("offScreenLabelStep", ctx_r3.Spa_Site_Form_OffScreen_Step_Label)("offScreenLabelCurrent", ctx_r3.Spa_Site_Form_OffScreen_Current_Label);
} }
function PlanCompareEnrollmentNavigationBarComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, PlanCompareEnrollmentNavigationBarComponent_div_0_div_1_vnext_enrollment_navigation_step_1_Template, 7, 22, "vnext-enrollment-navigation-step", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const formPages_r2 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", formPages_r2);
} }
const _c0$25 = function (a0) { return { "enrollment-navigation-bar-wrapper": a0 }; };
function PlanCompareEnrollmentNavigationBarComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, PlanCompareEnrollmentNavigationBarComponent_div_0_div_1_Template, 2, 1, "div", 2);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0$25, ctx_r0.Spa_Site_AgentCallRecording_Enabled || ctx_r0.Spa_Site_AgentCallRecordingShopping_Enabled))("disableCommonEvent", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 3, ctx_r0.formPages$));
} }
class PlanCompareEnrollmentNavigationBarComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, store, activatedRoute, enrollmentFormService, analyticsService, router, localeService, planListFacade, enrollmentConfirmationService, cartFacade, shoppingCartService, navigationUtilityService, enrollmentFormFacade, planFacade) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.store = store;
        this.activatedRoute = activatedRoute;
        this.enrollmentFormService = enrollmentFormService;
        this.analyticsService = analyticsService;
        this.router = router;
        this.localeService = localeService;
        this.planListFacade = planListFacade;
        this.enrollmentConfirmationService = enrollmentConfirmationService;
        this.cartFacade = cartFacade;
        this.shoppingCartService = shoppingCartService;
        this.navigationUtilityService = navigationUtilityService;
        this.enrollmentFormFacade = enrollmentFormFacade;
        this.planFacade = planFacade;
        this.Spa_Site_Form_Navigation_Display = false;
        this.Spa_Site_Form_OffScreen_Step_Label = `Step`;
        this.Spa_Site_Form_OffScreen_Current_Label = `current`;
        this.Spa_Site_AgentCallRecording_Enabled = false;
        this.Spa_Site_AgentCallRecordingShopping_Enabled = true;
        this.Spa_NextGen_Enabled = false;
        this.planSettings = [];
    }
    ngAfterViewInit() {
        // Adding the selectedFormType check here because HRA forms require additional
        // logging for anayltics and this is forcing that event to be logged twice. Once
        // here and once in the actual hra form component. In the future we should remove
        // the updating of gtm tags from the nav bar component to the actual form components
        // themselves since they should have resided there to begin with.
        combineLatest([this.transaction$.pipe(filter(transaction => !!transaction)), this.selectedFormType$, this.planSettings$])
            .pipe(take(1))
            .subscribe(([transaction, selectedFormType, settings]) => {
            this.planSettings = [...this.planSettings, ...settings];
            // When agent completes enrollment we should already have this attributes set in place as they
            // were most likely set in shopping.cart.component
            // But on ContinueEnrollment in Send to beneficiary flow we will need to set them in this component
            this.setCrossSellPlanEnrollmentAttributes();
            if (transaction && selectedFormType !== EnrollmentFormType.HRA && this.planSettings.length) {
                this.updateTags(transaction);
            }
        });
    }
    ngOnInit() {
        super.ngOnInit();
        this.enrollmentRootPage = this.enrollmentFormService.getEnrollmentRootPage();
        const enrollingPlanId = this.enrollmentFormService.getActiveEnrollmentKey();
        this.formPages$ = this.store.select(EnrollmentState.formPages(enrollingPlanId));
        this.transaction$ = this.store.select(EnrollmentState.transaction(enrollingPlanId));
        this.selectedFormType$ = this.enrollmentFormService.getSelectedFormType$(enrollingPlanId);
        this.activePageName$ = this.activatedRoute.params.pipe(pluck('pageName'));
        this.planSettings$ = this.store.select(MemberState.enrollmentPlanSettings).pipe(take(1), switchMap(planSettings => {
            if (!planSettings?.length) {
                return this.cartFacade.getPlanEnrollmentSettingsForAllPlans$().pipe(take(1));
            }
            return of(planSettings);
        }));
        this.activePageIndex$ = combineLatest(this.formPages$, this.activePageName$).pipe(map(([formPages, activePageName]) => {
            const page = formPages.find(formPage => formPage.pageName === activePageName);
            if (page) {
                return page.pageIndex;
            }
        }));
    }
    async navigateToStep(stepNumber) {
        const enrollingPlanId = this.enrollmentFormService.getActiveEnrollmentKey();
        const pageName = this.enrollmentFormService.getPageName(enrollingPlanId, stepNumber - 1);
        if (await this.getVisitedStatus$(stepNumber - 1)
            .pipe(first())
            .toPromise()) {
            this.enrollmentFormService.navigateTo(pageName);
        }
    }
    getCompletionStatus$(currentIndex) {
        const isComplete$ = this.formPages$.pipe(map(formPages => formPages.find(formPage => formPage.pageIndex === currentIndex)), filter(formPage => !!formPage), map(formPage => formPage.completed));
        const isActive$ = this.activePageIndex$.pipe(map(activePageIndex => activePageIndex === currentIndex));
        const isSkipped$ = this.formPages$.pipe(map(formPages => formPages.find(formPage => formPage.pageIndex === currentIndex)), filter(formPage => !!formPage), map(formPage => formPage.skipped));
        return combineLatest(isComplete$, isActive$, isSkipped$).pipe(map(([isComplete, isActive, isSkipped]) => {
            if (isActive) {
                return 'active';
            }
            if (isComplete) {
                return 'complete';
            }
            if (isSkipped) {
                return 'skipped';
            }
            return '';
        }));
    }
    getVisitedStatus$(pageIndex) {
        return this.formPages$.pipe(map(formPages => formPages.find(formPage => formPage.pageIndex === pageIndex)), filter(formPage => !!formPage), map(formPage => formPage.visited));
    }
    getFriendlyName$(page) {
        return this.currentLocale$.pipe(map(locale => this.getFriendlyName(page, locale)));
    }
    getFriendlyName(page, locale) {
        if (this.localeService.isSpanishLocale(locale)) {
            const friendlyNameSpanish = page.friendlyNameSpanish;
            if (friendlyNameSpanish) {
                return friendlyNameSpanish;
            }
        }
        return page.friendlyName;
    }
    updateTags(transaction) {
        const enrollingPlanId = this.enrollmentFormService.getActiveEnrollmentKey();
        const googleTagManagerNotApplicableText = this.analyticsService.getGoogleTagManagerNotApplicableText();
        const googleDataLayerTags = this.analyticsService.googleDataLayerTags;
        const externalMemberId = this.store.selectSnapshot(DeepLinkingParamsState.ssoValue);
        const externalReferenceId = this.store.selectSnapshot(DeepLinkingParamsState.pegi);
        const enrollingPlan = this.enrollmentFormService.getSelectedPlan(enrollingPlanId);
        const planType = enrollingPlan ? enrollingPlan.planTypeAbbreviation : googleTagManagerNotApplicableText;
        if ((!googleDataLayerTags ||
            googleDataLayerTags[DataLayerGlobalVariable.TRANSACTION_GUID] !== transaction.transactionGUID ||
            googleDataLayerTags[DataLayerGlobalVariable.FORM_VERSION] !==
                EnrollmentFormTypeUtillity.toApiKeyName(this.store.selectSnapshot(EnrollmentState.selectedFormType(enrollingPlanId)))) &&
            this.analyticsService.googleDataLayerTags[DataLayerGlobalVariable.PAGE_PATH] !== this.router.url &&
            this.navigationUtilityService.normalizePath(this.router.url) !== this.navigationUtilityService.normalizePath(this.enrollmentRootPage)) {
            let tagsToUpdate = {
                [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE,
                [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
                [DataLayerGlobalVariable.TRANSACTION_GUID]: transaction.transactionGUID,
                [DataLayerGlobalVariable.EXTERNAL_MEMBER_ID]: externalMemberId ? externalMemberId : googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.EXTERNAL_REFERENCE_ID]: externalReferenceId ? externalReferenceId : googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.FORM_VERSION]: EnrollmentFormTypeUtillity.toApiKeyName(this.store.selectSnapshot(EnrollmentState.selectedFormType(enrollingPlanId))),
                [DataLayerGlobalVariable.PLAN_CARRIER]: enrollingPlan ? enrollingPlan.carrierName : googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.PLAN_TYPE]: planType.toString(),
                [DataLayerGlobalVariable.PLAN_ID]: enrollingPlan ? enrollingPlan.id : googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.PLAN_ID_BEST_MATCH]: this.planListFacade.getBestMatchPlanIdValueForAnalytics(),
                [DataLayerGlobalVariable.PLAN_TYPE_BEST_MATCH]: this.planListFacade.getBestCoverageTabAbbreviationValueForAnalytics(),
                [DataLayerGlobalVariable.ENROLLMENT_PLAN_COUNT]: `${this.shoppingCartService.getEnrollmentPlanCount()}`,
                [DataLayerGlobalVariable.PLAN_NAME]: enrollingPlan?.planName ?? googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.PLAN_PREMIUM_MONTHLY]: this.enrollmentFormFacade.getEnrollingPlanPremium(enrollingPlanId),
                [DataLayerGlobalVariable.PLAN_PROVIDER_VBC_STATUS]: this.planFacade.isVbcAgreementExists(enrollingPlan) ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO
            };
            tagsToUpdate = this.enrollmentFormService.updateTagForEnrollmentMethod(tagsToUpdate, enrollingPlanId);
            tagsToUpdate = this.enrollmentFormService.updateTagForCrossSell(tagsToUpdate);
            tagsToUpdate = this.analyticsService.getGlobalDataLayerTags(tagsToUpdate);
            this.analyticsService.googleDataLayerTags = tagsToUpdate;
        }
    }
    setCrossSellPlanEnrollmentAttributes() {
        const selectedPlans = this.store.selectSnapshot(ShoppingCartState.selectedPlans);
        const crossSellPlanEnrollmentAttributes = this.getCrossSellPlanEnrollmentAttributes(selectedPlans);
        const crossSellEnrollmentTypes = this.shoppingCartService.getEnrollmentTypeFlag(crossSellPlanEnrollmentAttributes);
        this.enrollmentFormService.setCrossSellEnrollmentTypes(crossSellEnrollmentTypes);
    }
    getCrossSellPlanEnrollmentAttributes(selectedPlans) {
        return selectedPlans?.map(plan => {
            const crossSellPlanEnrollmentAttribute = {
                planId: plan.id,
                enrollmentType: null,
                userFormType: null
            };
            const enrollmentSetting = this.planSettings?.find(planSetting => planSetting.planIds[0] === plan.id);
            const enrollType = this.enrollmentConfirmationService.getEnrollmentType(enrollmentSetting);
            if (enrollType) {
                crossSellPlanEnrollmentAttribute.enrollmentType = enrollType;
            }
            return crossSellPlanEnrollmentAttribute;
        });
    }
}
PlanCompareEnrollmentNavigationBarComponent.ɵfac = function PlanCompareEnrollmentNavigationBarComponent_Factory(t) { return new (t || PlanCompareEnrollmentNavigationBarComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(PlanListFacadeService), i0.ɵɵdirectiveInject(EnrollmentConfirmationService), i0.ɵɵdirectiveInject(CartFacade), i0.ɵɵdirectiveInject(i1.ShoppingCartService), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(EnrollmentFormFacade), i0.ɵɵdirectiveInject(PlanFacade)); };
PlanCompareEnrollmentNavigationBarComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCompareEnrollmentNavigationBarComponent, selectors: [["vnext-plancompare-enrollment-navigation-bar"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "container", "vnextGoogleTagManager", "", 3, "ngClass", "disableCommonEvent", 4, "ngIf"], ["vnextGoogleTagManager", "", 1, "container", 3, "ngClass", "disableCommonEvent"], ["class", "enrollment-navigation-bar", 4, "ngIf"], [1, "enrollment-navigation-bar"], ["class", "navigation-step", "role", "presentation", 3, "status", "visited", "nextVisited", "skipped", "nextSkipped", "label", "stepNumber", "totalSteps", "offScreenLabelStep", "offScreenLabelCurrent", "selectStep", 4, "ngFor", "ngForOf"], ["role", "presentation", 1, "navigation-step", 3, "status", "visited", "nextVisited", "skipped", "nextSkipped", "label", "stepNumber", "totalSteps", "offScreenLabelStep", "offScreenLabelCurrent", "selectStep"]], template: function PlanCompareEnrollmentNavigationBarComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanCompareEnrollmentNavigationBarComponent_div_0_Template, 3, 7, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.Spa_Site_Form_Navigation_Display);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, GoogleTagManagerDirective, EnrollmentNavigationStepComponent, i1$2.AsyncPipe], styles: [".enrollment-navigation-bar[_ngcontent-%COMP%]{margin-top:10px;position:relative;justify-content:center;display:flex}.enrollment-navigation-bar-wrapper[_ngcontent-%COMP%]{margin-top:52px}@media (min-width: 576px){.navigation-step[_ngcontent-%COMP%]{width:100%}}@media (max-width: 575px){.navigation-step[_ngcontent-%COMP%]{width:25px}}"] });
__decorate([
    GlobalResource()
], PlanCompareEnrollmentNavigationBarComponent.prototype, "Spa_Site_Form_Navigation_Display", void 0);
__decorate([
    GlobalResource()
], PlanCompareEnrollmentNavigationBarComponent.prototype, "Spa_Site_Form_OffScreen_Step_Label", void 0);
__decorate([
    GlobalResource()
], PlanCompareEnrollmentNavigationBarComponent.prototype, "Spa_Site_Form_OffScreen_Current_Label", void 0);
__decorate([
    GlobalResource()
], PlanCompareEnrollmentNavigationBarComponent.prototype, "Spa_Site_AgentCallRecording_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareEnrollmentNavigationBarComponent.prototype, "Spa_Site_AgentCallRecordingShopping_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareEnrollmentNavigationBarComponent.prototype, "Spa_NextGen_Enabled", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCompareEnrollmentNavigationBarComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plancompare-enrollment-navigation-bar', providers: [WidgetService], template: "<div\r\n  *ngIf=\"Spa_Site_Form_Navigation_Display\"\r\n  class=\"container\"\r\n  [ngClass]=\"{ 'enrollment-navigation-bar-wrapper': Spa_Site_AgentCallRecording_Enabled || Spa_Site_AgentCallRecordingShopping_Enabled }\"\r\n  vnextGoogleTagManager\r\n  [disableCommonEvent]=\"true\"\r\n>\r\n  <div class=\"enrollment-navigation-bar\" *ngIf=\"formPages$ | async as formPages\">\r\n    <vnext-enrollment-navigation-step\r\n      *ngFor=\"let formPage of formPages; index as i\"\r\n      [status]=\"getCompletionStatus$(i) | async\"\r\n      [visited]=\"getVisitedStatus$(i) | async\"\r\n      [nextVisited]=\"getVisitedStatus$(i + 1) | async\"\r\n      [skipped]=\"(getCompletionStatus$(i) | async) === 'skipped'\"\r\n      [nextSkipped]=\"(getCompletionStatus$(i + 1) | async) === 'skipped'\"\r\n      [label]=\"getFriendlyName$(formPage) | async\"\r\n      [stepNumber]=\"i + 1\"\r\n      [totalSteps]=\"formPages.length\"\r\n      (selectStep)=\"navigateToStep($event)\"\r\n      [offScreenLabelStep]=\"Spa_Site_Form_OffScreen_Step_Label\"\r\n      [offScreenLabelCurrent]=\"Spa_Site_Form_OffScreen_Current_Label\"\r\n      class=\"navigation-step\"\r\n      role=\"presentation\"\r\n    >\r\n    </vnext-enrollment-navigation-step>\r\n  </div>\r\n</div>\r\n", styles: [".enrollment-navigation-bar{margin-top:10px;position:relative;justify-content:center;display:flex}.enrollment-navigation-bar-wrapper{margin-top:52px}@media (min-width: 576px){.navigation-step{width:100%}}@media (max-width: 575px){.navigation-step{width:25px}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i2.Store }, { type: i2$1.ActivatedRoute }, { type: i1.EnrollmentFormService }, { type: AnalyticsService }, { type: i2$1.Router }, { type: i1.LocaleService }, { type: PlanListFacadeService }, { type: EnrollmentConfirmationService }, { type: CartFacade }, { type: i1.ShoppingCartService }, { type: i1.NavigationUtilityService }, { type: EnrollmentFormFacade }, { type: PlanFacade }]; }, { Spa_Site_Form_Navigation_Display: [], Spa_Site_Form_OffScreen_Step_Label: [], Spa_Site_Form_OffScreen_Current_Label: [], Spa_Site_AgentCallRecording_Enabled: [], Spa_Site_AgentCallRecordingShopping_Enabled: [], Spa_NextGen_Enabled: [] }); })();

function EnrollmentNavigationBarComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "nextgen-enrollment-navigation-bar");
    i0.ɵɵelementContainerEnd();
} }
function EnrollmentNavigationBarComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-plancompare-enrollment-navigation-bar");
    i0.ɵɵelementContainerEnd();
} }
let EnrollmentNavigationBarComponent = class EnrollmentNavigationBarComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, store, activatedRoute, enrollmentFormService, analyticsService, router, localeService, planListFacade, enrollmentConfirmationService, cartFacade, shoppingCartService, navigationUtilityService, enrollmentFormFacade) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.store = store;
        this.activatedRoute = activatedRoute;
        this.enrollmentFormService = enrollmentFormService;
        this.analyticsService = analyticsService;
        this.router = router;
        this.localeService = localeService;
        this.planListFacade = planListFacade;
        this.enrollmentConfirmationService = enrollmentConfirmationService;
        this.cartFacade = cartFacade;
        this.shoppingCartService = shoppingCartService;
        this.navigationUtilityService = navigationUtilityService;
        this.enrollmentFormFacade = enrollmentFormFacade;
        this.Spa_Site_Form_Navigation_Display = false;
        this.Spa_Site_Form_OffScreen_Step_Label = `Step`;
        this.Spa_Site_Form_OffScreen_Current_Label = `current`;
        this.Spa_Site_AgentCallRecording_Enabled = false;
        this.Spa_Site_AgentCallRecordingShopping_Enabled = true;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        super.ngOnInit();
        this.subscriptions.add(combineLatest([
            this.enrollmentFormService.planHasNextGenForm$(this.enrollmentFormService.getActiveEnrollmentKey()),
            this.enrollmentFormService.hasNextGenEnrollmentFormTransaction$(this.enrollmentFormService.getActiveEnrollmentKey())
        ])
            .pipe(map(([planHasNextGenForm, hasNextGenEnrollmentFormTransaction]) => planHasNextGenForm || hasNextGenEnrollmentFormTransaction), distinctUntilChanged())
            .subscribe({
            next: hasNextGenForm => {
                this.hasNextGenForm = hasNextGenForm;
                this.cdr.markForCheck();
            }
        }));
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
};
EnrollmentNavigationBarComponent.ɵfac = function EnrollmentNavigationBarComponent_Factory(t) { return new (t || EnrollmentNavigationBarComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(PlanListFacadeService), i0.ɵɵdirectiveInject(EnrollmentConfirmationService), i0.ɵɵdirectiveInject(CartFacade), i0.ɵɵdirectiveInject(i1.ShoppingCartService), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(EnrollmentFormFacade)); };
EnrollmentNavigationBarComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EnrollmentNavigationBarComponent, selectors: [["vnext-enrollment-navigation-bar"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [[4, "ngIf"]], template: function EnrollmentNavigationBarComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, EnrollmentNavigationBarComponent_ng_container_0_Template, 2, 0, "ng-container", 0);
        i0.ɵɵtemplate(1, EnrollmentNavigationBarComponent_ng_container_1_Template, 2, 0, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.hasNextGenForm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.hasNextGenForm);
    } }, dependencies: [i1$2.NgIf, NextGenEnrollmentNavigationBarComponent, PlanCompareEnrollmentNavigationBarComponent], styles: [".enrollment-navigation-bar[_ngcontent-%COMP%]{margin-top:10px;position:relative;justify-content:center;display:flex}.enrollment-navigation-bar-wrapper[_ngcontent-%COMP%]{margin-top:52px}@media (min-width: 576px){.navigation-step[_ngcontent-%COMP%]{width:100%}}@media (max-width: 575px){.navigation-step[_ngcontent-%COMP%]{width:25px}}"] });
__decorate([
    GlobalResource()
], EnrollmentNavigationBarComponent.prototype, "Spa_Site_Form_Navigation_Display", void 0);
__decorate([
    GlobalResource()
], EnrollmentNavigationBarComponent.prototype, "Spa_Site_Form_OffScreen_Step_Label", void 0);
__decorate([
    GlobalResource()
], EnrollmentNavigationBarComponent.prototype, "Spa_Site_Form_OffScreen_Current_Label", void 0);
__decorate([
    GlobalResource()
], EnrollmentNavigationBarComponent.prototype, "Spa_Site_AgentCallRecording_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentNavigationBarComponent.prototype, "Spa_Site_AgentCallRecordingShopping_Enabled", void 0);
EnrollmentNavigationBarComponent = __decorate([
    PlatformWidget
], EnrollmentNavigationBarComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentNavigationBarComponent, [{
        type: Component,
        args: [{ selector: 'vnext-enrollment-navigation-bar', providers: [WidgetService], template: "<ng-container *ngIf=\"hasNextGenForm\">\r\n  <nextgen-enrollment-navigation-bar> </nextgen-enrollment-navigation-bar>\r\n</ng-container>\r\n<ng-container *ngIf=\"!hasNextGenForm\">\r\n  <vnext-plancompare-enrollment-navigation-bar></vnext-plancompare-enrollment-navigation-bar>\r\n</ng-container>\r\n", styles: [".enrollment-navigation-bar{margin-top:10px;position:relative;justify-content:center;display:flex}.enrollment-navigation-bar-wrapper{margin-top:52px}@media (min-width: 576px){.navigation-step{width:100%}}@media (max-width: 575px){.navigation-step{width:25px}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i2.Store }, { type: i2$1.ActivatedRoute }, { type: i1.EnrollmentFormService }, { type: AnalyticsService }, { type: i2$1.Router }, { type: i1.LocaleService }, { type: PlanListFacadeService }, { type: EnrollmentConfirmationService }, { type: CartFacade }, { type: i1.ShoppingCartService }, { type: i1.NavigationUtilityService }, { type: EnrollmentFormFacade }]; }, { Spa_Site_Form_Navigation_Display: [], Spa_Site_Form_OffScreen_Step_Label: [], Spa_Site_Form_OffScreen_Current_Label: [], Spa_Site_AgentCallRecording_Enabled: [], Spa_Site_AgentCallRecordingShopping_Enabled: [] }); })();

let ExistingMemberCartComponent = class ExistingMemberCartComponent {
    constructor(enrollmentFacade) {
        this.enrollmentFacade = enrollmentFacade;
        this.yesText = 'Yes';
        this.noText = 'No';
        this.fullWidth = false;
    }
    ngOnInit() {
        this.defaultToggleValue = this.enrollmentFacade.getSelectedFormType(this.planId);
        this.setToggleItems(this.yesText, this.noText);
    }
    ngOnChanges(changes) {
        const yesText = changes.yesText;
        const noText = changes.noText;
        if ((yesText && !yesText.firstChange && yesText.currentValue !== yesText.previousValue) ||
            (noText && !noText.firstChange && noText.currentValue !== noText.previousValue)) {
            this.setToggleItems(this.yesText, this.noText);
        }
    }
    optionSelected(event) {
        this.enrollmentFacade.updateSelectedFormType$(event.data.value, this.planId);
    }
    setToggleItems(yesText, noText) {
        this.items = [
            { display: yesText, value: EnrollmentFormType.SHORT },
            { display: noText, value: EnrollmentFormType.LONG }
        ];
    }
};
ExistingMemberCartComponent.ɵfac = function ExistingMemberCartComponent_Factory(t) { return new (t || ExistingMemberCartComponent)(i0.ɵɵdirectiveInject(EnrollmentFormFacade)); };
ExistingMemberCartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExistingMemberCartComponent, selectors: [["vnext-existing-member-cart"]], inputs: { yesText: "yesText", noText: "noText", titleText: "titleText", bodyText: "bodyText", fullWidth: "fullWidth", planId: "planId" }, features: [i0.ɵɵProvidersFeature([WidgetService, InputResetContextService]), i0.ɵɵNgOnChangesFeature], decls: 9, vars: 7, consts: [[1, "row"], [1, "px-0", "col-12", "Spa_Style_Label"], [1, "input-error-asterisk"], [1, "px-0", "col-12", "Spa_Style_Small_Font", "Spa_Style_Primary_Color"], [1, "px-0", "pt-2", "col-xs-6", "col-3"], [3, "items", "selectedValue", "buttonHeight", "largerText", "fullWidth", "optionSelected"]], template: function ExistingMemberCartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "span", 2);
        i0.ɵɵtext(3, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 4)(8, "vnext-toggle-select", 5);
        i0.ɵɵlistener("optionSelected", function ExistingMemberCartComponent_Template_vnext_toggle_select_optionSelected_8_listener($event) { return ctx.optionSelected($event); });
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.titleText);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.bodyText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("items", ctx.items)("selectedValue", ctx.defaultToggleValue)("buttonHeight", "36px")("largerText", true)("fullWidth", ctx.fullWidth);
    } }, dependencies: [ToggleSelectComponent], changeDetection: 0 });
ExistingMemberCartComponent = __decorate([
    PlatformWidget
], ExistingMemberCartComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExistingMemberCartComponent, [{
        type: Component,
        args: [{ selector: 'vnext-existing-member-cart', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService, InputResetContextService], template: "<div class=\"row\">\r\n  <div class=\"px-0 col-12 Spa_Style_Label\"><span class=\"input-error-asterisk\">*</span>{{ titleText }}</div>\r\n  <div class=\"px-0 col-12 Spa_Style_Small_Font Spa_Style_Primary_Color\">{{ bodyText }}</div>\r\n  <div class=\"px-0 pt-2 col-xs-6 col-3\">\r\n    <vnext-toggle-select\r\n      [items]=\"items\"\r\n      [selectedValue]=\"defaultToggleValue\"\r\n      [buttonHeight]=\"'36px'\"\r\n      (optionSelected)=\"optionSelected($event)\"\r\n      [largerText]=\"true\"\r\n      [fullWidth]=\"fullWidth\"\r\n    ></vnext-toggle-select>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: EnrollmentFormFacade }]; }, { yesText: [{
            type: Input
        }], noText: [{
            type: Input
        }], titleText: [{
            type: Input
        }], bodyText: [{
            type: Input
        }], fullWidth: [{
            type: Input
        }], planId: [{
            type: Input
        }] }); })();

let ExistingMemberFormComponent = class ExistingMemberFormComponent {
    constructor(enrollmentFacade, enrollmentFormService, cdr, analyticsService, spinnerService) {
        this.enrollmentFacade = enrollmentFacade;
        this.enrollmentFormService = enrollmentFormService;
        this.cdr = cdr;
        this.analyticsService = analyticsService;
        this.spinnerService = spinnerService;
    }
    ngOnChanges() {
        // Note: we want to set the text any time any of our inputs change which is what we aren't
        // performing any check. If any other inputs get added we will want to only setText on the
        // fields being used in setText
        this.setText();
    }
    ngOnInit() {
        this.currentFormType = this.enrollmentFormService.getSelectedFormType(this.planId);
        this.setText();
    }
    async changeFormType() {
        try {
            this.spinnerService.show(SpinnerEvent.ENROLLMENT_LOADING);
            this.setGoogleDataLayerTags();
            this.currentFormType = this.currentFormType === EnrollmentFormType.LONG ? EnrollmentFormType.SHORT : EnrollmentFormType.LONG;
            await this.enrollmentFacade.updateSelectedFormType$(this.currentFormType, this.planId).toPromise();
            await this.enrollmentFormService.initializeEnrollment$(this.planId, 0, true, false, '', true);
            this.setText();
        }
        finally {
            this.spinnerService.hide(SpinnerEvent.ENROLLMENT_LOADING);
        }
    }
    setText() {
        if (this.currentFormType === EnrollmentFormType.LONG) {
            this.titleText = this.existingMemberTitleText;
            this.bodyText = this.existingMemberBodyText;
            this.buttonText = this.existingMemberButtonText;
        }
        else {
            this.titleText = this.newMemberTitleText;
            this.bodyText = this.newMemberBodyText;
            this.buttonText = this.newMemberButtonText;
        }
        this.cdr.markForCheck();
    }
    setGoogleDataLayerTags() {
        this.currentFormType === EnrollmentFormType.LONG
            ? this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_ENROLLMENT_FORM_SWITCH_TO_SHORT)
            : this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_ENROLLMENT_FORM_SWITCH_TO_LONG);
    }
};
ExistingMemberFormComponent.ɵfac = function ExistingMemberFormComponent_Factory(t) { return new (t || ExistingMemberFormComponent)(i0.ɵɵdirectiveInject(EnrollmentFormFacade), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.SpinnerService)); };
ExistingMemberFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ExistingMemberFormComponent, selectors: [["vnext-existing-member-form"]], inputs: { existingMemberTitleText: "existingMemberTitleText", existingMemberBodyText: "existingMemberBodyText", existingMemberButtonText: "existingMemberButtonText", newMemberTitleText: "newMemberTitleText", newMemberBodyText: "newMemberBodyText", newMemberButtonText: "newMemberButtonText", planId: "planId" }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵNgOnChangesFeature], decls: 9, vars: 3, consts: [[1, "prompt-wrapper", "py-2", "mt-4", "mx-3", "mb-2", "row", "Spa_Style_Gray1_Background"], [1, "col-12", "col-md-7"], [1, "Spa_Style_Semi_Bold_Weight"], [1, "Spa_Style_Small_Font"], [1, "col-12", "col-md-5", "text-md-right", "pr-0"], [1, "btn", "Spa_Style_SecondaryButton", 3, "click"]], template: function ExistingMemberFormComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "div", 4)(7, "button", 5);
        i0.ɵɵlistener("click", function ExistingMemberFormComponent_Template_button_click_7_listener() { return ctx.changeFormType(); });
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.titleText, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.bodyText);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.buttonText, " ");
    } }, styles: [".prompt-wrapper[_ngcontent-%COMP%]{border-radius:5px}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], ExistingMemberFormComponent.prototype, "changeFormType", null);
ExistingMemberFormComponent = __decorate([
    PlatformWidget
], ExistingMemberFormComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExistingMemberFormComponent, [{
        type: Component,
        args: [{ selector: 'vnext-existing-member-form', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"prompt-wrapper py-2 mt-4 mx-3 mb-2 row Spa_Style_Gray1_Background\">\r\n  <div class=\"col-12 col-md-7\">\r\n    <div class=\"Spa_Style_Semi_Bold_Weight\">\r\n      {{ titleText }}\r\n    </div>\r\n    <div class=\"Spa_Style_Small_Font\">{{ bodyText }}</div>\r\n  </div>\r\n  <div class=\"col-12 col-md-5 text-md-right pr-0\">\r\n    <button class=\"btn Spa_Style_SecondaryButton\" (click)=\"changeFormType()\">\r\n      {{ buttonText }}\r\n    </button>\r\n  </div>\r\n</div>\r\n", styles: [".prompt-wrapper{border-radius:5px}\n"] }]
    }], function () { return [{ type: EnrollmentFormFacade }, { type: i1.EnrollmentFormService }, { type: i0.ChangeDetectorRef }, { type: AnalyticsService }, { type: i1.SpinnerService }]; }, { existingMemberTitleText: [{
            type: Input
        }], existingMemberBodyText: [{
            type: Input
        }], existingMemberButtonText: [{
            type: Input
        }], newMemberTitleText: [{
            type: Input
        }], newMemberBodyText: [{
            type: Input
        }], newMemberButtonText: [{
            type: Input
        }], planId: [{
            type: Input
        }], changeFormType: [] }); })();

class NextGenBundleFormRootStrategy {
    constructor(formPagesMetadataContext, enrollmentFormService, formRootService, externalErrorLoggingService, eligibilityCheckValidatorContextService, groupValidatorContextService, router) {
        this.formPagesMetadataContext = formPagesMetadataContext;
        this.enrollmentFormService = enrollmentFormService;
        this.formRootService = formRootService;
        this.externalErrorLoggingService = externalErrorLoggingService;
        this.eligibilityCheckValidatorContextService = eligibilityCheckValidatorContextService;
        this.groupValidatorContextService = groupValidatorContextService;
        this.router = router;
        this.subscriptions = new Subscription();
        // Or getValue from the subject but that is not a great practice
        this.subscriptions.add(this.formPagesMetadataContext.getFormPagesMetadata$().subscribe({
            next: (formPageMetadata) => {
                this.formPageMetadata = formPageMetadata;
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    getCurrentPageName() {
        return this.getFormPages().find(page => page.active)?.pageName || '';
    }
    // TODO: return -1, 0 or undefined if page index is not found? this shouldn't happen but figure out
    // an intelligible fallback
    getCurrentIndex(enrollingPlanId) {
        return this.getFormPages().find(page => page.active)?.index || -1;
    }
    isFirstPage(pageName, enrollingPlanId) {
        const page = this.getPageByName(pageName);
        return page?.index === 1;
    }
    isLastPage(pageName, enrollingPlanId) {
        const page = this.getPageByName(pageName);
        return page?.index && page?.index === this.getVisibleFormPages()?.length;
    }
    getFormPages(enrollingPlanId) {
        return this.formPageMetadata?.pages ?? [];
    }
    getPageLevelValidators(pageIndex) {
        const selectedIndex = pageIndex ?? 1;
        return this.formPageMetadata?.pages?.find(page => page.index === selectedIndex)?.validators ?? [];
    }
    async runPageLevelValidations(answers, pageIndex, isDSNPPlan) {
        try {
            const pageLevelValidators = this.getPageLevelValidators(pageIndex);
            if (pageLevelValidators?.length) {
                return await Promise.all(pageLevelValidators.map(async (validator) => {
                    if (validator.getType() === PageLevelValidatorType.StateAndZip) {
                        return await validator.validate(answers);
                    }
                    else if (validator.getType() === PageLevelValidatorType.EligibilityCheck) {
                        const payload = this.getEligibilityCheckPayload(answers);
                        return await this.eligibilityCheckValidatorContextService.runEligibilityCheckValidator(validator, payload, isDSNPPlan);
                    }
                    else if (validator.getType() === PageLevelValidatorType.Group) {
                        return await this.groupValidatorContextService.runGroupValidator(validator);
                    }
                    return await validator.validate();
                }));
            }
        }
        catch (error) {
            this.externalErrorLoggingService.log(error);
        }
        return await Promise.resolve([]);
    }
    getCustomEventName(eventType) {
        switch (eventType) {
            case CustomEventType.ENROLLMENT_NEXT:
                return NextGenEnrollmentEvents.NAVIGATE_NEXT_PAGE;
            case CustomEventType.ENROLLMENT_BACK:
                return NextGenEnrollmentEvents.NAVIGATE_PREVIOUS_PAGE;
            case CustomEventType.SET_FORM_FIELD:
                return NextGenEnrollmentEvents.SET_FORM_DATA;
            case CustomEventType.ADD_PAGE_LEVEL_ERROR_TO_QUESTION:
                return NextGenEnrollmentEvents.ADD_CUSTOM_ERROR_TO_QUESTION;
            case CustomEventType.UPLOAD_FILES_RESPONSE:
                return NextGenEnrollmentEvents.UPLOAD_FILES_RESPONSE;
            case CustomEventType.UPLOAD_FILES_ERROR_RESPONSE:
                return NextGenEnrollmentEvents.UPLOAD_FILES_ERROR_RESPONSE;
            case CustomEventType.DELETE_UPLOADED_FILES_RESPONSE:
                return NextGenEnrollmentEvents.DELETE_UPLOADED_FILES_RESPONSE;
            case CustomEventType.DELETE_UPLOADED_FILES_ERROR_RESPONSE:
                return NextGenEnrollmentEvents.DELETE_UPLOADED_FILES_ERROR_RESPONSE;
            case CustomEventType.ADDRESS_AUTOCOMPLETE_RESPONSE:
                return NextGenEnrollmentEvents.ADDRESS_AUTOCOMPLETE_RESPONSE;
            case CustomEventType.ADDRESS_AUTOCOMPLETE_ERROR_RESPONSE:
                return NextGenEnrollmentEvents.ADDRESS_AUTOCOMPLETE_ERROR_RESPONSE;
            case CustomEventType.UPDATE_DYNAMIC_SCRIPTS:
                return NextGenEnrollmentEvents.UPDATE_DYNAMIC_SCRIPTS;
            case CustomEventType.VALIDATE_GROUP:
                return NextGenEnrollmentEvents.VALIDATE_GROUP;
            case CustomEventType.VALIDATE_GROUP_RESPONSE:
                return NextGenEnrollmentEvents.VALIDATE_GROUP_RESPONSE;
            default:
        }
    }
    async saveFormAnswers(pageIndex, answers, enrollingPlan, isRedirectedFromPlanCompareApi, childForms) {
        const nextGenAnswers = this.updateAnswerDateFormat(answers);
        if (nextGenAnswers?.length) {
            await this.enrollmentFormService.updateNextGenTransaction$(nextGenAnswers, enrollingPlan.id).toPromise();
            this.formRootService.updateMemberProfileSession(nextGenAnswers);
            this.formRootService.updateEffectiveDatesPartAandB(nextGenAnswers);
        }
    }
    navigateTo(pageName, setPageVisited = false, childForms, enrollingPlan) {
        const enrollmentPage = this.enrollmentFormService.getEnrollmentRootPage();
        if (enrollmentPage && pageName) {
            this.router.navigate([enrollmentPage, pageName]);
        }
    }
    navigateToPage(enrollingPlan, childForms) { }
    formHasQuestion(questionName, existingAnswerValue, nextGenQuestionNames) {
        return nextGenQuestionNames?.map(questionName => questionName.toLowerCase()).includes(questionName.toLowerCase());
    }
    getEligibilityCheckPayload(answers) {
        return (answers?.reduce((payload, answer) => {
            const { name, value } = answer;
            const mappedKey = EligibilityCheckFieldNamesMap[name];
            if (mappedKey && value) {
                if (EligibilityCheckDateFieldNamesMap[name]) {
                    payload[mappedKey] = DateUtilities.convertDateFormat(value);
                }
                else if (EligibilityCheckAdditionalFieldNamesMap[name]) {
                    const additionalParam = { [mappedKey]: value };
                    payload.additionalParams = Array.isArray(payload.additionalParams)
                        ? [...payload.additionalParams, additionalParam]
                        : [additionalParam];
                }
                else {
                    payload[mappedKey] = value;
                }
            }
            return payload;
        }, {}) ?? {});
    }
    getPageByName(pageName) {
        const pages = this.getFormPages();
        return pages.find(page => page.pageName === pageName);
    }
    updateAnswerDateFormat(answers) {
        answers.forEach(answer => {
            if (DateUtilities.isValidFormat(answer.value, DateUtilities.defaultDateISOFormat)) {
                answer.value = DateUtilities.convertDateFormat(answer.value);
            }
        });
        return answers;
    }
    getVisibleFormPages() {
        return this.formPageMetadata?.pages?.filter((page) => !page.skipped) ?? [];
    }
}
NextGenBundleFormRootStrategy.ɵfac = function NextGenBundleFormRootStrategy_Factory(t) { return new (t || NextGenBundleFormRootStrategy)(i0.ɵɵinject(i1.FormPagesMetadataContext), i0.ɵɵinject(i1.EnrollmentFormService), i0.ɵɵinject(FormRootService), i0.ɵɵinject(i1.ExternalErrorLoggingService), i0.ɵɵinject(i1.EligibilityCheckValidatorContextService), i0.ɵɵinject(i1.GroupValidatorContextService), i0.ɵɵinject(i2$1.Router)); };
NextGenBundleFormRootStrategy.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NextGenBundleFormRootStrategy, factory: NextGenBundleFormRootStrategy.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NextGenBundleFormRootStrategy, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.FormPagesMetadataContext }, { type: i1.EnrollmentFormService }, { type: FormRootService }, { type: i1.ExternalErrorLoggingService }, { type: i1.EligibilityCheckValidatorContextService }, { type: i1.GroupValidatorContextService }, { type: i2$1.Router }]; }, null); })();

const _c0$24 = ["enrollmentForm"];
function FormRootComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-existing-member-form", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("existingMemberTitleText", ctx_r3.Spa_Enrollment_ExistingMemberPromptTitle_Text)("existingMemberBodyText", ctx_r3.Spa_Enrollment_ExistingMemberPromptBody_Text)("existingMemberButtonText", ctx_r3.Spa_Enrollment_ExistingMemberPromptButton_Text)("newMemberTitleText", ctx_r3.Spa_Enrollment_NewMemberPromptTitle_Text)("newMemberBodyText", ctx_r3.Spa_Enrollment_NewMemberPromptBody_Text)("newMemberButtonText", ctx_r3.Spa_Enrollment_NewMemberPromptButton_Text)("planId", ctx_r3.enrollingPlanId);
} }
function FormRootComponent_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "nextgen-enrollment-form-renderer", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("surveyInitialized", ctx_r4.surveyInitialized);
} }
function FormRootComponent_ng_container_0_ng_container_4_vnext_enrollment_form_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-enrollment-form", null, 8);
} }
function FormRootComponent_ng_container_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormRootComponent_ng_container_0_ng_container_4_vnext_enrollment_form_1_Template, 2, 0, "vnext-enrollment-form", 2);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.pageName);
} }
function FormRootComponent_ng_container_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.sendEnrollmentFacade.getRestrictProfessionalPlansNavBarMessage(), " ");
} }
function FormRootComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormRootComponent_ng_container_0_ng_container_1_Template, 2, 7, "ng-container", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵtemplate(3, FormRootComponent_ng_container_0_ng_container_3_Template, 2, 1, "ng-container", 2);
    i0.ɵɵtemplate(4, FormRootComponent_ng_container_0_ng_container_4_Template, 2, 1, "ng-container", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, FormRootComponent_ng_container_0_div_5_Template, 2, 1, "div", 4);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementStart(7, "vnext-enrollment-form-navigation", 5);
    i0.ɵɵlistener("backEvent", function FormRootComponent_ng_container_0_Template_vnext_enrollment_form_navigation_backEvent_7_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.back()); })("nextEvent", function FormRootComponent_ng_container_0_Template_vnext_enrollment_form_navigation_nextEvent_7_listener() { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.next()); })("submitEvent", function FormRootComponent_ng_container_0_Template_vnext_enrollment_form_navigation_submitEvent_7_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.onSubmit($event)); })("showModalEvent", function FormRootComponent_ng_container_0_Template_vnext_enrollment_form_navigation_showModalEvent_7_listener() { i0.ɵɵrestoreView(_r10); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.showSendEnrollmentModal()); })("closeTooltipEvent", function FormRootComponent_ng_container_0_Template_vnext_enrollment_form_navigation_closeTooltipEvent_7_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.closeEnrollmentTooltip($event)); })("saveEvent", function FormRootComponent_ng_container_0_Template_vnext_enrollment_form_navigation_saveEvent_7_listener() { i0.ɵɵrestoreView(_r10); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.showCreateAccount()); })("continueToVoiceSignature", function FormRootComponent_ng_container_0_Template_vnext_enrollment_form_navigation_continueToVoiceSignature_7_listener() { i0.ɵɵrestoreView(_r10); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.continueToVoiceSignature()); })("continueToAuthorizationCodeSignature", function FormRootComponent_ng_container_0_Template_vnext_enrollment_form_navigation_continueToAuthorizationCodeSignature_7_listener() { i0.ɵɵrestoreView(_r10); const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.continueToAuthorizationCodeSignature()); });
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showExistingMemberForm);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.planHasNextGenForm);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.planHasNextGenForm);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.sendEnrollmentFacade.isPlanRestricted(i0.ɵɵpipeBind1(6, 23, ctx_r0.plan$)) && ctx_r0.showSubmit());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("showNext", ctx_r0.showNext())("showSubmit", ctx_r0.showSubmit())("showPrevious", ctx_r0.showBack())("showSendApplicationEmail", ctx_r0.showAgentSendToBeneficiaryEmail())("showContinueToVoiceSignatureText", ctx_r0.showContinueToVoiceSignatureText())("showContinueToAuthorizationCodeSignatureText", ctx_r0.showContinueToAuthorizationCodeSignatureText)("isVoiceSignatureComplete", ctx_r0.isVoiceSignatureComplete)("isAuthorizationCodeSignatureComplete", ctx_r0.isAuthorizationCodeSignatureComplete)("previousButtonText", ctx_r0.previousText)("nextButtonText", ctx_r0.nextText)("submitButtonText", ctx_r0.submitText)("sendApplicationButtonText", ctx_r0.sendEnrollmentApplicationButtonText)("enrollSubmitTooltipText", ctx_r0.enrollmentPermissionDeniedTooltipText)("continueToVoiceSignatureText", ctx_r0.continueToVoiceSignatureText)("voiceSignatureCompletedText", ctx_r0.voiceSignatureCompletedText)("continueToAuthorizationCodeText", ctx_r0.continueToAuthorizationCodeText)("authorizationCodeCompletedText", ctx_r0.authorizationCodeCompletedText)("showSave", i0.ɵɵpipeBind1(8, 25, ctx_r0.showSave$))("saveText", ctx_r0.saveText);
} }
function FormRootComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "i", 11)(2, "div", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r2.Spa_Enrollment_PlanNotInCartError_Html, i0.ɵɵsanitizeHtml);
} }
const VALIDATE_FORM_METHOD = 'ValidateForm';
let FormRootComponent = class FormRootComponent extends ConfigurableWidget {
    constructor(cdr, agentTaskFacade, widgetValidationService, configurableWidgetService, zoneService, widgetService, enrollFormFacade, sendEnrollmentFacade, siteService, enrollmentFormService, activatedRoute, viewContainer, modalService, demographicService, plansService, shoppingCartService, enrollmentFormErrorsContext, profileService, memberSessionService, cartFacade, localeService, millimanService, navigationUtilityService, planFacade, authService, spinnerService, helpfulToolsService, navigationService, enrollmentTransactionErrorsContext, createAccountContext, analyticsService, twilioService, agentCallRecordingFacade, externalErrorLoggingService, currencyPipe, formRootStrategyService, formPagesMetadataContext, formRootService, fileDownloadUtilityService, addressService, planYearResourceService, eligibilityCheckValidatorContextService, groupValidatorContextService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.cdr = cdr;
        this.agentTaskFacade = agentTaskFacade;
        this.widgetValidationService = widgetValidationService;
        this.configurableWidgetService = configurableWidgetService;
        this.zoneService = zoneService;
        this.widgetService = widgetService;
        this.enrollFormFacade = enrollFormFacade;
        this.sendEnrollmentFacade = sendEnrollmentFacade;
        this.siteService = siteService;
        this.enrollmentFormService = enrollmentFormService;
        this.activatedRoute = activatedRoute;
        this.viewContainer = viewContainer;
        this.modalService = modalService;
        this.demographicService = demographicService;
        this.plansService = plansService;
        this.shoppingCartService = shoppingCartService;
        this.enrollmentFormErrorsContext = enrollmentFormErrorsContext;
        this.profileService = profileService;
        this.memberSessionService = memberSessionService;
        this.cartFacade = cartFacade;
        this.localeService = localeService;
        this.millimanService = millimanService;
        this.navigationUtilityService = navigationUtilityService;
        this.planFacade = planFacade;
        this.authService = authService;
        this.spinnerService = spinnerService;
        this.helpfulToolsService = helpfulToolsService;
        this.navigationService = navigationService;
        this.enrollmentTransactionErrorsContext = enrollmentTransactionErrorsContext;
        this.createAccountContext = createAccountContext;
        this.analyticsService = analyticsService;
        this.twilioService = twilioService;
        this.agentCallRecordingFacade = agentCallRecordingFacade;
        this.externalErrorLoggingService = externalErrorLoggingService;
        this.currencyPipe = currencyPipe;
        this.formRootStrategyService = formRootStrategyService;
        this.formPagesMetadataContext = formPagesMetadataContext;
        this.formRootService = formRootService;
        this.fileDownloadUtilityService = fileDownloadUtilityService;
        this.addressService = addressService;
        this.planYearResourceService = planYearResourceService;
        this.eligibilityCheckValidatorContextService = eligibilityCheckValidatorContextService;
        this.groupValidatorContextService = groupValidatorContextService;
        this.Spa_Site_UnableToProcessErrorsTitle_Text = 'Unable to Process Application';
        this.Spa_Site_UnableToProcessErrorsMessage_Text = 'We are unable to process your application at this time. Contact your administrator for assistance.';
        this.Spa_Enrollment_ExistingMemberPromptTitle_Text = 'Existing Member?';
        this.Spa_Enrollment_ExistingMemberPromptBody_Text = 'If so, you are able to complete a shorter enrollment form.';
        this.Spa_Enrollment_ExistingMemberPromptButton_Text = 'Existing Member Form';
        this.Spa_Enrollment_NewMemberPromptTitle_Text = 'New member?';
        this.Spa_Enrollment_NewMemberPromptBody_Text = 'If so, you will need to complete a longer enrollment form.';
        this.Spa_Enrollment_NewMemberPromptButton_Text = 'New member form';
        this.Spa_Enrollment_ShowExistingMemberPromptOnEnrollment_Flag = false;
        this.Spa_Enrollment_PlanNotInCartError_Html = `<div class="Spa_Style_Large_Font font-weight-bold mb-3">Application not available</div>
    <div class="Spa_Style_Paragraph">
    <a href="{{url.fullurlbytag(PlanList)}}" target="_self"><u>Click here</u></a> to shop for other coverage or contact your Agent for assistance.
    </div>`;
        // Adding these simply so they show up in client configuration. May want to explore a way of
        // adding these to client configuration without having to add this annotation in the future.
        this.Spa_SendEnrollment_ContinueApplying_Text = 'Continue Applying';
        this.Spa_SendEnrollment_CrossSell_MedSupPlanText = 'Two emails will be sent to the beneficiary to finish this enrollment.</br></br>You have a <b>Medicare Supplement</b> plan in your cart you still need to enroll in.  Click the button below to continue applying in the plan.';
        this.Spa_SendEnrollment_CrossSell_PDPPlanText = 'Two emails will be sent to the beneficiary to finish this enrollment.</br></br>You have a <b>Prescription Drug plan</b> in your cart you still need to enroll in.  Click the button below to continue applying in the plan.';
        this.Spa_Enrollment_SaveProgress_Enabled = false;
        this.Spa_Site_Loader_Message_Json = [];
        this.Spa_Enrollment_ContinueToVoiceSignature_Enabled = false;
        this.Spa_PreEnrollmentStatements_Enrollment_Enabled = false;
        this.Spa_PreEnrollmentStatements_WhitelistedBenefits_JSON = [
            388, 9, 40, 25, 4, 6, 7, 14, 41, 5, 12, 13, 383, 16, 15, 384, 21, 10, 11, 37, 333, 376, 375, 55, 401, 378, 31, 377, 379, 380, 381, 382
        ];
        this.Spa_Site_TotalSiteCountsPPC_Enabled = false;
        this.Spa_PreEnrollmentStatements_ReturnFromModal_URL = '';
        this.Spa_Enrollment_ContinueToAuthorizationCodeSignature_Enabled = false;
        this.Spa_DynamicScript_Enabled = false;
        this.Spa_DynamicScript_Id_Text = 'Universal';
        this.Spa_DynamicScript_Defns_Json = [];
        this.checkFocus = false;
        this.showSave$ = of(false);
        this.showContinueToAuthorizationCodeSignatureText = false;
        this.nextGenFormQuestionNames = [];
        this.showExistingMemberForm = false;
        this.surveyInitialized = false;
        this.isRedirectedFromPlanCompareApi = false;
        this.isSendToBeneficiaryWithoutAgentForPlanCompareApi = false;
        this.isEnrollingDSNPPlan = false;
        this.enrollmentPostbackExceptionTitle = 'CompleteEnrollment successful. ConfirmationSummaryPostback exception.';
        this.subscriptions = new Subscription();
        this._requestSubmit$ = new Subject();
    }
    get childForms() {
        this._childForms = this.planHasNextGenForm ? this.nextGenChildForms : this.hopeChildForms;
        return this._childForms;
    }
    requestSubmit(tooltip) {
        this._requestSubmit$.next(tooltip);
    }
    onRequestSubmit$() {
        return this._requestSubmit$.asObservable();
    }
    onSurveyBeforeViewInitialized(event) {
        this.spinnerService.show(SpinnerEvent.INITIALIZE_SURVEY_VIEW);
    }
    onSurveyAfterViewInitialized(event) {
        this.surveyInitialized = true;
        this.spinnerService.hide(SpinnerEvent.INITIALIZE_SURVEY_VIEW);
    }
    onSurveyAfterPageRendered(event) {
        setTimeout(() => {
            const answers = _get(event, 'detail.answers');
            const inputElement = this.formRootService.findFirstFocusableInput(answers, document);
            if (inputElement) {
                inputElement.focus();
            }
        }, 0);
    }
    checkForQuestions(event) {
        const questionNames = _get(event, 'detail.questionNames');
        this.nextGenFormQuestionNames = questionNames ? [...questionNames] : [];
        // TODO: Sometimes the form is rendered before obtaining the enrolling plan
        this.hideProviderSearchQuestions();
        this.updateNextGenDynamicScripts();
    }
    clearFormErrors(event) {
        this.enrollmentFormErrorsContext.clearFormErrors();
    }
    editLinkClicked(event) {
        const editField = _get(event, 'detail.Name');
        this.handleEditLinkEvent(editField);
    }
    navigateNext(event) {
        const validateFOAMForm = _get(event, 'detail.SPA_Validate');
        // we should always validate unless SPA_Validate has been explicitly set to false
        this.next(validateFOAMForm !== false);
    }
    navigateBack(event) {
        this.continueToBack();
    }
    navigateToPageName(event) {
        const pageName = _get(event, 'detail.pageName');
        // Older versions of HOPEBundle pass back index. We only want to use this if no pageName is sent as that is the
        // more standard way to look up pages for navigation from the review page
        const pageIndex = _get(event, 'detail.pageIndex');
        this.enrollmentFormService
            .getVisitedStatus$(this.enrollingPlanId, pageName ? this.enrollmentFormService.getPageIndex(this.enrollingPlanId, pageName) : pageIndex)
            .pipe(take(1))
            .subscribe({
            next: pageHasBeenVisited => {
                if (pageHasBeenVisited) {
                    this.formRootStrategyService.navigateTo(pageName, false, this.childForms, this.enrollingPlan);
                }
            }
        });
    }
    onMissingEnrollmentData(event) {
        this.openEnrollmentErrorModal();
    }
    onInputBlur(event) {
        const validationErrors = Array.from(_get(event, 'detail.ValidationErrors') || []).map(formError => ({
            message: formError.message,
            severity: formError.severity,
            source: MESSAGE_SOURCE.CLIENT
        }));
        // get current errors from context
        this.enrollmentFormErrorsContext
            .observeForFormErrors$()
            .pipe(take(1))
            .subscribe({
            next: errors => {
                // not sure we will have many situations where we get server errors and client side errors
                // at the same time but if we do server errors should be placed above client side errors
                const serverErrors = errors?.messages?.filter(error => error.source === MESSAGE_SOURCE.SERVER);
                const updatedErrors = [...serverErrors, ...validationErrors];
                if (!_isEqual(errors, updatedErrors)) {
                    this.enrollmentFormErrorsContext.addErrors({
                        title: this.formRootService.getEnrollmentErrorNoticeTitle(),
                        messages: updatedErrors
                    });
                }
            }
        });
    }
    hopeOnClickProviderLink(event) {
        const providersEnabled = _get(event, 'detail.SpaSiteProvidersEnabled');
        const planShowProviderSearch = _get(event, 'detail.PlanShowProviderSearch');
        const planProviderURL = _get(event, 'detail.PlanProviderURL');
        this.navigateToProviderSearch({
            providersEnabled,
            plan: this.enrollingPlan,
            showProviderSearch: planShowProviderSearch ?? this.enrollingPlan.showProviderSearch,
            providerURL: planProviderURL ?? this.enrollingPlan.providerURL
        });
    }
    nextGenOnClickProviderLink(event) {
        const providerSearchHardcodedUrl = _get(event, 'detail.hardcodedUrl');
        const includeReturnUrl = _get(event, 'detail.includeReturnUrl');
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_ENROLLMENT_FIND_PROVIDER,
            [DataLayerGlobalVariable.FIND_PROVIDER_LINK_TYPE]: LinkType.EXTERNAL
        };
        if (providerSearchHardcodedUrl) {
            this.navigateToProviderSearch({ providerURL: this.addCallBackToProviderURL(providerSearchHardcodedUrl, includeReturnUrl) });
        }
        else {
            const providersEnabled = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_Providers_Enabled', this.widgetName, false);
            const providerURL = this.addCallBackToProviderURL(this.enrollingPlan.providerURL, includeReturnUrl);
            this.navigateToProviderSearch({
                providersEnabled,
                plan: this.enrollingPlan,
                showProviderSearch: this.enrollingPlan.showProviderSearch,
                providerURL
            });
        }
    }
    setFormPageInfo(event) {
        // There's also currently a pageCount val in here we aren't using
        const formInfo = _get(event, 'detail.formInfo');
        this.enrollmentFormService.setFormTitle(formInfo.formMetaData.formTitle);
        this.enrollmentFormService.updateCMSApprovalCode$(formInfo.cmsApprovalCode);
        this.formPagesMetadataContext.setFormPagesMetadata(formInfo, this.getPageLevelValidationConfigurations());
    }
    setFormPageErrors(event) {
        const pageErrors = _get(event, 'detail.pageErrors');
        const scroll = _get(event, 'detail.scroll');
        if (pageErrors?.length) {
            this.addErrorsAndScroll({
                title: this.formRootService.getEnrollmentErrorNoticeTitle(),
                messages: pageErrors.map(pageError => ({ message: pageError?.message, severity: 'error' }))
            }, scroll);
        }
        else {
            this.enrollmentFormErrorsContext.clearFormErrors();
        }
    }
    nextgenEditLinkClicked(event) {
        const editField = _get(event, 'detail.name');
        this.handleEditLinkEvent(editField, true);
    }
    async nextgenUploadFiles(event) {
        const payload = _get(event, 'detail');
        if (payload) {
            this.spinnerService.show(SpinnerEvent.ENROLLMENT_LOADING);
            try {
                const response = await this.enrollmentFormService.nextGenUploadFiles(payload);
                this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.UPLOAD_FILES_RESPONSE, response);
            }
            catch (error) {
                this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.UPLOAD_FILES_ERROR_RESPONSE, error);
            }
            finally {
                this.spinnerService.hide(SpinnerEvent.ENROLLMENT_LOADING);
            }
        }
    }
    async nextgenDeleteUploadedFile(event) {
        const payload = _get(event, 'detail');
        if (payload) {
            this.spinnerService.show(SpinnerEvent.ENROLLMENT_LOADING);
            try {
                // API returns 404 Not Found when the file was deleted already or does not exist
                // In those cases, we will consider the deletion as successful and remove the file from the File Uploader component's list
                const handleFileNotFoundError = async (error) => await (error?.status === 404 ? Promise.resolve({ success: true }) : Promise.reject(error));
                let response;
                if (Array.isArray(payload)) {
                    response = await Promise.all(payload.map(async (selectedPayload) => await this.enrollmentFormService.nextGenDeleteUploadedFile(selectedPayload).catch(handleFileNotFoundError)));
                }
                else {
                    response = await this.enrollmentFormService.nextGenDeleteUploadedFile(payload).catch(handleFileNotFoundError);
                }
                this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.DELETE_UPLOADED_FILES_RESPONSE, response);
            }
            catch (error) {
                this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.DELETE_UPLOADED_FILES_ERROR_RESPONSE, error);
            }
            finally {
                this.spinnerService.hide(SpinnerEvent.ENROLLMENT_LOADING);
            }
        }
    }
    async nextgenDownloadFile(event) {
        const uploadedFileContent = _get(event, 'detail');
        const transactionGUID = this.enrollmentFormService.getTransactionId(this.enrollingPlanId);
        if (uploadedFileContent?.fileId && transactionGUID) {
            const { fileId, name } = uploadedFileContent;
            this.spinnerService.show(SpinnerEvent.ENROLLMENT_LOADING);
            try {
                const fileData = await this.enrollmentFormService.nextGenDownloadFile(transactionGUID, fileId);
                if (fileData) {
                    this.fileDownloadUtilityService.downloadFile(fileData, name, fileData.type);
                }
            }
            finally {
                this.spinnerService.hide(SpinnerEvent.ENROLLMENT_LOADING);
            }
        }
    }
    async nextgenAutocompleteAddress(event) {
        const autocompletePayload = _get(event, 'detail');
        const { questionName, partial, zip, selected } = autocompletePayload;
        try {
            const addressList = await this.addressService.callAPIForData(partial, zip, selected);
            this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ADDRESS_AUTOCOMPLETE_RESPONSE, {
                questionName,
                addressList
            });
        }
        catch (error) {
            this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ADDRESS_AUTOCOMPLETE_ERROR_RESPONSE, { questionName, error });
        }
    }
    /**
     * This event gets fired by the PC1 - Spa.Net Host aka "Host layer" code, drx.enrollment.callback.js
     * If we need additional changes to when/how this is fired, we would need to work with John Stanely to update that.
     * That code then was originally designed to cooperate with the HOPE bundle code to update specific fields on the host layer side.
     * This event and its work is intended to move as much of the existing logic into a position for us to manipulate it freely here
     * instead of in other layers.
     */
    updateViAQueryParams(event) {
        // For now we don't want to do anything with this event for old gen forms
        if (this.planHasNextGenForm) {
            const xmlAsJSON = this.formRootService.convertEnrollmentCallbackMapToJSON();
            // xmlAsJSON should be an object such as {'Provider_Name':'"PrimaryCarePhysician"}
            // This maps the names we use in the queryParams to the values we actually use as field names.
            const queryParams = _get(event, 'detail');
            // queryParams should be an object such as {'Provider_Name':'BRUCE+W.+DENNIS'}
            const answers = [];
            Object.keys(queryParams).forEach(keyName => {
                const name = xmlAsJSON[keyName];
                if (name) {
                    const value = queryParams[keyName]?.replaceAll('+', ' ') ?? '';
                    answers.push({ name, value });
                }
            });
            this.updateFormAnswers(answers);
        }
    }
    nextGenQuestionValueChanged(event) {
        const questionName = _get(event, 'detail.name');
        const questionValue = _get(event, 'detail.value');
        this.eligibilityCheckValidatorContextService.verifyIfAnyEligibilityCheckFieldValueChanged(questionName, questionValue);
    }
    nextGenNavigateToPageName(event) {
        const pageName = _get(event, 'detail.pageName');
        if (pageName && (!this.pageName || this.pageName !== pageName)) {
            this.formRootStrategyService.navigateTo(pageName, false, this.childForms, this.enrollingPlan);
        }
    }
    async ngOnInit() {
        super.ngOnInit();
        // We are triggering nav events from the nav bar stepper so we need to make sure we are using the
        // appropriate navigate method here rather than just using the router. This is so we can make sure
        // to preload the appropriate html before navigating.
        this.enrollingPlanId = this.enrollmentFormService.getActiveEnrollmentKey();
        // even though we default to HOPEBundleFormRootStrategy, if we switch from a nextgen form to a HOPE form
        // we aren't updating this back to the appropriate strategy so we need to check and set both cases
        if (this.enrollmentFormService.planHasNextGenForm(this.enrollingPlanId)) {
            this.formRootStrategyService.setStrategy(NextGenBundleFormRootStrategy);
        }
        else {
            this.formRootStrategyService.setStrategy(HOPEBundleFormRootStrategy);
        }
        const isPPCSite = this.siteService.isPPCSite();
        if (this.enrollingPlanId) {
            this.enrollingPlan = this.shoppingCartService.getPlan(this.enrollingPlanId);
            this.userFormType = this.enrollmentFormService.getUserFormType(this.enrollingPlanId);
            // Setting the plan$ to actively enrolling plan
            this.plan$ = this.configurableWidgetService.store.select(ShoppingCartState.selectedPlanById(this.enrollingPlanId));
        }
        else {
            this.plan$ = this.configurableWidgetService.store.select(ShoppingCartState.selectedPlan);
        }
        this.subscriptions.add(fromEvent(document, `${NextGenEnrollmentEvents.CLEAR_PREFILL_DATA}`)
            .pipe(distinctUntilChanged((prev, curr) => {
            return !(prev.detail.timeStamp + 200 < curr.detail.timeStamp ||
                !_isEqual(prev.detail.clearedPrefillDataFields, curr.detail.clearedPrefillDataFields));
        }))
            .subscribe({
            next: event => {
                this.enrollmentFormService.clearPrefillData(this.enrollingPlanId, event, this.childForms);
            }
        }));
        this.subscriptions.add(this.plan$.subscribe({
            next: plan => {
                if (plan) {
                    this.enrollingPlan = plan;
                    this.enrollingPlanId = this.enrollingPlan.id;
                    this.isEnrollingDSNPPlan = plan.snpType === SNPBaseType.dSNP;
                    this.userFormType = this.enrollmentFormService.getUserFormType(this.enrollingPlanId);
                    this.cdr.markForCheck();
                }
            }
        }));
        this.subscriptions.add(this.plan$
            .pipe(skipWhile(plan => !plan), take(1))
            .subscribe({
            next: plan => {
                if (plan && !plan.documents?.length) {
                    // this.plansService.fetchAndUpdatePlanDetails(this.shoppingCartService.getSelectedPlan());
                    this.plansService.fetchAndUpdatePlanDetails(plan);
                }
            }
        }));
        // TODO: Does this apply to nextgen forms?
        this.planHasShortForm$ = this.plan$.pipe(distinctUntilChanged(_isEqual), switchMap(async (plan) => (plan ? await this.planFacade.getPlanHasShortForm(plan.id) : false)), distinctUntilChanged(), shareReplay(1));
        this.planHasNextGenForm$ = this.enrollmentFormService
            .planHasNextGenForm$(this.enrollingPlanId)
            .pipe(distinctUntilChanged(), shareReplay(1));
        this.isFormLoading$ = this.planHasNextGenForm$.pipe(switchMap(planHasNextGenForm => {
            const loadingFlags$ = [this.millimanService.getMillimanLoading$()];
            if (planHasNextGenForm) {
                loadingFlags$.push(this.enrollmentFormService.getNextGenFormLoading$(this.enrollingPlanId));
            }
            else {
                loadingFlags$.push(this.enrollmentFormService.getFormLoading$(this.enrollingPlanId), this.pageName$);
            }
            return combineLatest(loadingFlags$);
        }), map(([isMillimanLoading, isFormLoading, pageName]) => !!((pageName !== undefined && !pageName) || isFormLoading || isMillimanLoading)), distinctUntilChanged(), shareReplay(1));
        this.formHasPages$ = this.planHasNextGenForm$.pipe(switchMap(planHasNextGenForm => planHasNextGenForm ? this.nextGenFormPages$() : this.enrollmentFormService.getFormPages$(this.enrollingPlanId)), map(formPages => !!formPages?.length), distinctUntilChanged(), shareReplay(1));
        this.subscriptions.add(this.enrollmentFormService
            .observeForNavigationEvent$()
            .pipe(distinctUntilChanged())
            .subscribe({
            next: pageName => {
                this.formRootStrategyService.navigateTo(pageName, false, this.childForms, this.enrollingPlan);
            }
        }));
        this.pageName$ = this.activatedRoute.params.pipe(pluck('pageName'), distinctUntilChanged(), shareReplay(1));
        const environment = EnvironmentService.getEnvironment();
        if (!environment.liveedit) {
            this.observeForPageLoad();
            this.subscriptions.add(this.subscribeToSendBeneficiaryProfessionalOnlyNotice());
        }
        // TODO: will need to either modify or just add these ONLY if not a nextgen form
        this.subscriptions.add(this.pageName$.subscribe({
            next: pageName => {
                this.pageName = pageName;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.planHasNextGenForm$.subscribe({
            next: planHasNextGenForm => {
                this.planHasNextGenForm = planHasNextGenForm;
                this.cdr.markForCheck();
            }
        }));
        if (this.Spa_Enrollment_ShowExistingMemberPromptOnEnrollment_Flag) {
            this.subscriptions.add(combineLatest([this.planHasNextGenForm$, this.planHasShortForm$, this.isFormLoading$, this.formHasPages$])
                .pipe(skipWhile(([planHasNextGenForm, planHasShortForm, isFormLoading, formHasPages]) => isFormLoading || !formHasPages))
                .subscribe({
                next: ([planHasNextGenForm, planHasShortForm]) => {
                    const initialIndex = planHasNextGenForm ? 1 : 0;
                    this.showExistingMemberForm = planHasShortForm && this.getCurrentIndex() === initialIndex;
                    this.cdr.markForCheck();
                }
            }));
        }
        this.subscriptions.add(this.localeService
            .getCurrentLocale$()
            .pipe(switchMap(locale => this.pageName$.pipe(distinctUntilChanged(), 
        // The first emitted page name is null. We still want to emit that value in order to initialize the locale and the localized texts.
        // We will continue to take values until a page name is available.
        // We ensure to include the last emitted page name (when available) via the 2nd parameter in takeWhile() to clear any form errors.
        // HOPE only: Additionally, we mark the form pages as dirty and fetch the page HTML.
        takeWhile(pageName => !pageName, true), map(pageName => [locale, pageName]), withLatestFrom(this.planHasNextGenForm$))))
            .subscribe({
            next: ([[locale, pageName], planHasNextGenForm]) => {
                this.locale = locale;
                if (pageName) {
                    this.enrollmentFormErrorsContext.clearFormErrors();
                    if (!planHasNextGenForm) {
                        this.enrollmentFormService.setFormPagesDirty$(this.enrollingPlanId);
                        this.enrollmentFormService.fetchPageHtml$(this.getCurrentIndex(), this.enrollingPlanId, locale);
                    }
                }
                this.setLocalizedText();
            }
        }));
        this.isRedirectedFromPlanCompareApi = this.enrollFormFacade.isRedirectedFromPlanCompareApi();
        this.isSendToBeneficiaryWithoutAgentForPlanCompareApi = this.enrollFormFacade.isSendToBeneficiaryWithoutAgentForPlanCompareApi();
        this.subscriptions.add(this.enrollmentTransactionErrorsContext.enrollmentFormError$.subscribe({
            next: enrollmentFormError => {
                this.enrollmentFormError = enrollmentFormError;
                this.spinnerService.hide(SpinnerEvent.ENROLLMENT_FORM_LOADING);
                if (enrollmentFormError === EnrollmentFormErrors.PLAN_NOT_IN_CART) {
                    this.enrollmentFormErrorBody = this.Spa_Enrollment_PlanNotInCartError_Html;
                    this.cdr.markForCheck();
                }
            }
        }));
        this.subscriptions.add(this.onRequestSubmit$()
            .pipe(exhaustMap(tooltip => this.handleSubmit$(tooltip)))
            .subscribe({
            next: () => {
                this.cdr.markForCheck();
            }
        }));
        if (this.Spa_Enrollment_SaveProgress_Enabled && !isPPCSite) {
            this.showSave$ = combineLatest([this.memberSessionService.isMemberLoggedIn$(), this.formHasPages$]).pipe(map(([isMemberLoggedIn, formHasPages]) => !isMemberLoggedIn && formHasPages));
        }
        if (this.agentCallRecordingFacade.isAgentCallRecordingEnabled() ||
            this.agentCallRecordingFacade.isAgentCallRecordingShoppingEnabled()) {
            const agentCallRecordingAvailableData$ = this.planHasNextGenForm$.pipe(switchMap(planHasNextGenForm => {
                let isFormLoaded$;
                let isFormLoading$;
                if (planHasNextGenForm) {
                    isFormLoaded$ = this.enrollmentFormService.getNextGenFormLoaded$(this.enrollingPlanId);
                    isFormLoading$ = this.enrollmentFormService.getNextGenFormLoading$(this.enrollingPlanId);
                }
                else {
                    isFormLoaded$ = this.enrollmentFormService.getFormLoaded$(this.enrollingPlanId);
                    isFormLoading$ = this.enrollmentFormService.getFormLoading$(this.enrollingPlanId);
                }
                return combineLatest([
                    isFormLoaded$,
                    isFormLoading$,
                    this.enrollmentFormService.getEnrollmentAnswer$(RECORDING_AVAILABLE_FORM_ANSWER, this.enrollingPlanId),
                    this.enrollmentFormService.getTransactionGuid$(),
                    this.twilioService.getDeviceConnectStatus$()
                ]);
            }), distinctUntilChanged(_isEqual));
            this.subscriptions.add(agentCallRecordingAvailableData$
                .pipe(filter(([formLoaded, formLoading, recordingAvailable, transactionGuid, deviceConnectStatus]) => !!(formLoaded && !formLoading && deviceConnectStatus === Call.State.Open && transactionGuid)), delay(0), takeUntil(this.enrollmentFormService
                .getEnrollmentAnswer$(RECORDING_AVAILABLE_FORM_ANSWER, this.enrollingPlanId)
                .pipe(filter(value => !!value))))
                .subscribe({
                next: () => {
                    this.enrollmentFormService.updateFormTransactionAnswers(this.enrollingPlanId, [{ name: RECORDING_AVAILABLE_FORM_ANSWER, value: CallRecordingAvailability.AVAILABLE }], this.planHasNextGenForm);
                }
            }));
        }
    }
    observeForPageLoad() {
        this.subscriptions.add(this.isFormLoading$.subscribe({
            next: (isFormLoading) => {
                isFormLoading
                    ? this.spinnerService.show(SpinnerEvent.ENROLLMENT_FORM_LOADING)
                    : this.spinnerService.hide(SpinnerEvent.ENROLLMENT_FORM_LOADING);
            }
        }));
    }
    ngAfterViewInit() {
        if (this.childForms?.first?.viewInitialized$ &&
            !this.isSendToBeneficiaryFlow() &&
            (this.isVoiceSignatureEnabledForPlanType(this.enrollingPlan?.planType) ||
                this.isAuthorizationCodeSignatureEnabledForPlanType(this.enrollingPlan?.planType))) {
            this.subscriptions.add(this.childForms.first.viewInitialized$.subscribe({
                next: viewInitialized => {
                    if (this.Spa_Enrollment_ContinueToVoiceSignature_Enabled &&
                        this.isVoiceSignatureEnabledForPlanType(this.enrollingPlan.planType)) {
                        if (viewInitialized) {
                            const voiceSignatureCollectedAnswer = this.getAnswerByFormKey(EnrollmentFormKeys.VOICE_SIGNATURE_COLLECTED);
                            this.isVoiceSignatureComplete = voiceSignatureCollectedAnswer === true || voiceSignatureCollectedAnswer === 'true';
                            this.pageHasVoiceSignatureFields =
                                this.formHasQuestion(EnrollmentFormKeys.VOICE_SIGNATURE_COLLECTED) &&
                                    this.formHasQuestion(EnrollmentFormKeys.VOICE_SIGNATURE_COLLECTED_DATETIME);
                        }
                        else {
                            this.pageHasVoiceSignatureFields = false;
                            this.isVoiceSignatureComplete = false;
                        }
                    }
                    if (this.Spa_Enrollment_ContinueToAuthorizationCodeSignature_Enabled &&
                        this.isAuthorizationCodeSignatureEnabledForPlanType(this.enrollingPlan.planType)) {
                        this.configureAuthorizationCodeSignatureVariables(viewInitialized, this.pageName);
                    }
                    if (this.Spa_PreEnrollmentStatements_Enrollment_Enabled && viewInitialized) {
                        if (this.formHasQuestion(EnrollmentFormKeys.PRE_ENROLLMENT_STATEMENTS_COLLECTED) &&
                            this.isFirstPage(this.getCurrentPageName())) {
                            this.openPreEnrollmentStatementsModal();
                        }
                    }
                }
            }));
        }
    }
    ngAfterViewChecked() {
        if (this.checkFocus) {
            const formElement = document.getElementById(this.focusFieldID);
            if (formElement) {
                formElement.focus();
            }
            this.checkFocus = false;
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.enrollmentFormErrorsContext.clearFormErrors();
        this.subscriptions.unsubscribe();
        this.eligibilityCheckValidatorContextService.resetState();
    }
    getCurrentIndex() {
        return this.formRootStrategyService.getCurrentIndex(this.enrollingPlanId);
    }
    back() {
        this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ENROLLMENT_BACK);
        this.continueToBack();
    }
    continueToBack() {
        const pageIndex = this.getCurrentIndex();
        const pageNameByIndex = this.enrollmentFormService.getPageName(this.enrollingPlanId, pageIndex - 1);
        this.formRootStrategyService.navigateTo(pageNameByIndex, false, this.childForms, this.enrollingPlan);
    }
    retrieveFormAnswers(childForms) {
        const inputValues = childForms?.first?.retrieveFormInputValues();
        return this.formRootService.convertFormInputValuesToAnswers(inputValues);
    }
    retrieveAllFormAnswers(childForms) {
        const inputValues = childForms?.first?.retrieveAllFormInputValues();
        return this.formRootService.convertFormInputValuesToAnswers(inputValues);
    }
    getFOAMErrors(pageAnswers) {
        const validateFormMethod = window && window[VALIDATE_FORM_METHOD];
        // passing true in order to get error messages back rather than a pure boolean pass/fail result
        return validateFormMethod?.(true, pageAnswers) ?? [];
    }
    async next(validateFOAM) {
        if (this.planHasNextGenForm) {
            this.nextGenNextEvent();
        }
        else {
            this.hopeNextEvent(validateFOAM);
        }
    }
    hopeNextEvent(validateFOAM) {
        if (validateFOAM !== false) {
            const status = this.getFoamStatus();
            if (status.hasFOAMErrors) {
                this.handleFOAMErrors(status);
            }
            else {
                this.continueToNext();
            }
        }
        else {
            this.continueToNext();
        }
    }
    async nextGenNextEvent() {
        const nextGenPageErrors = await this.getNextGenPageErrors();
        if (nextGenPageErrors?.length) {
            this.addNextGenErrorsAndScroll(nextGenPageErrors);
        }
        else {
            this.continueToNext();
        }
    }
    async submit() {
        if (this.planHasNextGenForm) {
            const nextGenFormErrors = await this.getNextGenFormErrors();
            if (nextGenFormErrors?.length) {
                this.spinnerService.hide(SpinnerEvent.ENROLLMENT_LOADING);
                this.addNextGenErrorsAndScroll(nextGenFormErrors);
            }
            else {
                await this.nextGenSubmitEvent();
            }
        }
        else {
            this.hopeSubmitEvent();
        }
        // TODO: split the submit logic here... delegate to the strategy
    }
    async nextGenSubmitEvent() {
        if (!this.authService.isCurrentTokenValid()) {
            await this.authService.loadJWT();
        }
        const pageIndex = this.getCurrentIndex();
        const currentPageAnswers = this.retrieveFormAnswers(this.childForms);
        const allAnswers = this.retrieveAllFormAnswers(this.childForms);
        //
        const validationResults = await this.formRootStrategyService.runPageLevelValidations(allAnswers, pageIndex, this.isEnrollingDSNPPlan);
        const canContinueToSubmit = !!validationResults?.every(result => !!result?.isValid);
        if (canContinueToSubmit) {
            await this.formRootStrategyService.saveFormAnswers(pageIndex, currentPageAnswers, this.enrollingPlan, this.isRedirectedFromPlanCompareApi, this.childForms);
            try {
                await this.completeNextGenEnrollment(this.enrollingPlanId);
                // TODO: create custom complete event
                // this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ENROLLMENT_NEXT);
            }
            catch (error) {
                this.enrollmentFormService.setNextGenFormLoading$(this.enrollingPlanId, false);
                this.spinnerService.hide(SpinnerEvent.ENROLLMENT_LOADING);
                await this.handleCompleteEnrollmentErrors(error);
            }
        }
        else {
            const continueText = validationResults?.find(result => result?.type === PageLevelValidatorType.EligibilityCheck)?.continueText;
            this.addErrorsAndScroll({
                title: this.formRootService.getEnrollmentErrorNoticeTitle(),
                messages: this.formatPageLevelValidationErrors(validationResults),
                ...(continueText && { continueText })
            });
        }
        //
        // show spinner
        // validate page
        // loadjwt setuff again?
        // complete enrollment
        // dispatch a navigation event
        // hide spinner
        // TODO: complete enrollment for nextgen
    }
    async hopeSubmitEvent() {
        const authorizationCodeSignatureFOAMErrors = this.validateAuthorizationCodeSignature();
        const status = this.getFoamStatus(authorizationCodeSignatureFOAMErrors);
        if (status?.hasFOAMErrors) {
            this.spinnerService.hide(SpinnerEvent.ENROLLMENT_LOADING);
            this.handleFOAMErrors(status);
        }
        else {
            const answers = status?.FOAMAnswers ?? [];
            if (!this.authService.isCurrentTokenValid()) {
                await this.authService.loadJWT();
            }
            // dispatching an event to let the FOAM form know we are navigating
            this.viewContainer.element.nativeElement.dispatchEvent(new CustomEvent(CustomVNextEvents.ENROLLMENT_NEXT, { bubbles: true }));
            const pageIndex = this.getCurrentIndex();
            const updateTransactionRequest = EnrollmentTransactionRequest.createUpdateTransaction(pageIndex, answers, `${this.enrollmentFormService.getSelectedFormType(this.enrollingPlanId).valueOf()}`);
            await this.enrollmentFormService
                .updateFormTransaction$(updateTransactionRequest, this.enrollingPlanId)
                .toPromise()
                .then(() => {
                this.formRootService.processTransactionResponse(this.enrollmentFormService.getTransaction(this.enrollingPlanId), () => {
                    this.formRootService.updateMemberProfileSession(answers);
                    this.completeEnrollment(this.enrollingPlanId);
                });
            });
        }
    }
    handleSubmit$(tooltip) {
        return from(this.handleSubmit(tooltip));
    }
    onSubmit(tooltip) {
        this.requestSubmit(tooltip);
    }
    async handleSubmit(tooltip) {
        const loaderText = this.navigationUtilityService.getLoaderTextByPageTag(this.Spa_Site_Loader_Message_Json, PageTags.ENROLLMENT_CONFIRMATION);
        this.spinnerService.show(SpinnerEvent.ENROLLMENT_LOADING, undefined, loaderText);
        // Since plan compare api session only last 30min, can be assumed that agent has permission
        if (this.isRedirectedFromPlanCompareApi) {
            await this.submit();
        }
        else {
            const fips = this.demographicService.getSelectedFipsCode();
            const effectiveDate = this.cartFacade.getAgentPlanPermissionEffectiveDate(this.enrollingPlan.planType);
            await this.cartFacade.processAgentEnrollPermissions(this.enrollingPlan, effectiveDate, fips, tooltip, this.submit.bind(this));
        }
    }
    async completeNextGenEnrollment(planId) {
        await this.enrollmentFormService
            .completeNextGenEnrollment(planId)
            .then(() => {
            this.formRootService.processNextGenTransactionResponse(this.enrollmentFormService.getNextGenTransaction(planId), () => {
                const navigationExtras = {
                    state: {
                        // performance: if the user completed the enrollment steps, we can skip fetching the transaction data (already stored)
                        completedEnrollmentSteps: true,
                        // performance: load the plan's data earlier
                        enrollmentPlan: this.enrollingPlan
                    }
                };
                this.agentTaskFacade.removeAssociatedTasksByType([NoteActionType.EnrollmentTask, NoteActionType.QuoteTask]);
                this.configurableWidgetService.navigationService.navigateByPageTag(PageTags.ENROLLMENT_CONFIRMATION, navigationExtras);
            });
        })
            .catch(error => {
            throw error;
        })
            .finally(() => {
            this.spinnerService.hide(SpinnerEvent.ENROLLMENT_LOADING);
        });
    }
    completeEnrollment(planId) {
        this.enrollmentFormService
            .completeEnrollment(planId)
            .then(() => {
            this.formRootService.processTransactionResponse(this.enrollmentFormService.getTransaction(planId), () => {
                const navigationExtras = {
                    state: {
                        // performance: if the user completed the enrollment steps, we can skip fetching the transaction data (already stored)
                        completedEnrollmentSteps: true,
                        // performance: load the plan's data earlier
                        enrollmentPlan: this.enrollingPlan
                    }
                };
                this.spinnerService.hide(SpinnerEvent.ENROLLMENT_LOADING);
                this.agentTaskFacade.removeAssociatedTasksByType([NoteActionType.EnrollmentTask, NoteActionType.QuoteTask]);
                this.configurableWidgetService.navigationService.navigateByPageTag(PageTags.ENROLLMENT_CONFIRMATION, navigationExtras);
            });
        })
            .catch(async (error) => {
            this.enrollmentFormService.setFormPageLoading$(false, false, planId);
            this.spinnerService.hide(SpinnerEvent.ENROLLMENT_LOADING);
            await this.handleCompleteEnrollmentErrors(error);
        });
    }
    showBack() {
        const pageName = this.getCurrentPageName();
        return !this.isFirstPage(pageName);
    }
    showNext() {
        const pageName = this.getCurrentPageName();
        const formPages = this.getFormPages(this.enrollingPlanId);
        return formPages?.length && !this.isLastPage(pageName);
    }
    getFormPages(enrollingPlanId) {
        return this.formRootStrategyService.getFormPages(enrollingPlanId);
    }
    nextGenFormPages$() {
        return this.formPagesMetadataContext.getFormPagesMetadata$().pipe(map(formPagesMetadata => formPagesMetadata?.pages));
    }
    showSubmit() {
        const pageName = this.getCurrentPageName();
        return this.isLastPage(pageName) && this.showSubmitButtonForForm();
    }
    showContinueToVoiceSignatureText() {
        const pageName = this.getCurrentPageName();
        return (this.Spa_Enrollment_ContinueToVoiceSignature_Enabled &&
            this.pageHasVoiceSignatureFields &&
            !this.isSendToBeneficiaryFlow() &&
            this.isLastPage(pageName) &&
            this.isVoiceSignatureEnabledForPlanType(this.enrollingPlan.planType));
    }
    getShowContinueToAuthorizationCodeSignatureText(pageName) {
        return (this.Spa_Enrollment_ContinueToAuthorizationCodeSignature_Enabled &&
            this.pageHasAuthorizationCodeSignatureFields &&
            !this.isSendToBeneficiaryFlow() &&
            this.isLastPage(pageName) &&
            this.isAuthorizationCodeSignatureEnabledForPlanType(this.enrollingPlan.planType));
    }
    isSendToBeneficiaryFlow() {
        if (this.isRedirectedFromPlanCompareApi) {
            // For API, we also need to keep in mind that userType of consumer could get passed in. The modal should be hidden if that's the case.
            const userType = this.enrollFormFacade.getUserType(this.enrollingPlanId);
            // TODO: This depends on the API actually sending us back the userType, so we ignore this for the sake of other testing
            // Until SPA-18137 is done and/or we have userType available on the front end.
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const userTypeIsConsumer = !!userType && userType === EnrollmentUserType.CONSUMER;
            return this.isSendToBeneficiaryWithoutAgentForPlanCompareApi; // || userTypeIsConsumer;
        }
        else {
            // UserFormType is broken on API, but not on hosted sites, so we're free to use it here without worrying about if it undefined/null
            if (this.siteService.isPPCSite()) {
                // On a broker site, send to beneficiary means using the consumer form, so we can just check for that.
                return this.userFormType === UserTypeKeys.CONSUMER;
            }
            // On a consumer site, there is no such thing as send to beneficiary flow (or it's always that flow, depending on how you look at it)
            // The modals showing will simply be controlled by if the features are enabled or not, at another step.
            return false;
        }
    }
    isVoiceSignatureEnabledForPlanType(planType) {
        return PlansUtilityService.isSingleMedicareType(planType);
    }
    isAuthorizationCodeSignatureEnabledForPlanType(planType) {
        return PlansUtilityService.isSingleNonMedicareType(planType);
    }
    showSubmitButtonForForm() {
        // if agent site and is agent form, then show submit
        // if agent site and is consumer form, then show send to beneficiary and hide submit.
        // if consumer site and PC API With Send To Beneficiary, then show send to beneficiary and hide submit
        // if consumer site and Not PC API With Send To Beneficiary show submit
        const isAgentSite = this.siteService.isPPCSite();
        const isPCApiSendToBeneficiary = this.isRedirectedFromPlanCompareApi && this.isSendToBeneficiaryWithoutAgentForPlanCompareApi;
        return (!isAgentSite && !isPCApiSendToBeneficiary) || (isAgentSite && this.enrollFormFacade.isAgentFormType(this.enrollingPlanId));
    }
    showAgentSendToBeneficiaryEmail() {
        const pageName = this.getCurrentPageName();
        if (this.isRedirectedFromPlanCompareApi && this.isSendToBeneficiaryWithoutAgentForPlanCompareApi) {
            return this.isLastPage(pageName) && this.sendEnrollmentFacade.canSendToBeneficiaryForPCApi(this.enrollingPlan);
        }
        else {
            const canSendToBeneficiary = this.enrollFormFacade.canSendApplicationToBeneficiary(this.enrollingPlan);
            return this.isLastPage(pageName) && this.showAgentSendEnrollmentForForm(canSendToBeneficiary);
        }
    }
    showAgentSendEnrollmentForForm(canSendToBeneficiary) {
        // if agent site and is consumer form, then show send to beneficiary and hide submit.
        return (canSendToBeneficiary && // canSendToBeneficiary checks if agent site
            !this.enrollFormFacade.isAgentFormType(this.enrollingPlanId));
    }
    showSendEnrollmentModal() {
        this.enrollFormFacade.showSendEnrollmentModal();
    }
    closeEnrollmentTooltip(toolTip) {
        this.enrollFormFacade.closeTooltip(toolTip);
    }
    showCreateAccount() {
        const answers = this.retrieveFormAnswers(this.childForms);
        const firstName = answers.find(data => data.name === 'ApplicantFirstName')?.value || this.profileService.getFirstName();
        const lastName = answers.find(data => data.name === 'ApplicantLastName')?.value || this.profileService.getLastName();
        const email = answers.find(data => data.name === 'ApplicantEmailAddress')?.value || this.profileService.getEmailAddress();
        const createAccountFormData = {
            firstName,
            lastName,
            email
        };
        this.updateGoogleTagEvent(DataLayerEvent.CLICK_ENROLLMENT_SAVE_AND_EXIT);
        this.createAccountContext.isCreateAccountFromExternal(true);
        this.createAccountContext.openCreateAccount(createAccountFormData);
    }
    continueToVoiceSignature() {
        const status = this.getFoamStatus();
        if (status.hasFOAMErrors) {
            this.handleFOAMErrors(status);
        }
        else {
            this.openVoiceSignatureModal();
        }
    }
    continueToAuthorizationCodeSignature() {
        const status = this.getFoamStatus();
        if (status.hasFOAMErrors) {
            this.handleFOAMErrors(status);
        }
        else {
            this.openAuthorizationCodeSignatureModal();
        }
    }
    getFoamStatus(
    // When passed, considers additional FOAM errors in the next status check
    additionalFOAMErrors) {
        const FOAMAnswers = this.retrieveFormAnswers(this.childForms);
        const FOAMErrors = Array.isArray(additionalFOAMErrors)
            ? this.getFOAMErrors(FOAMAnswers).concat(additionalFOAMErrors)
            : this.getFOAMErrors(FOAMAnswers);
        const hasFOAMErrors = Array.isArray(FOAMErrors) && FOAMErrors.length > 0;
        return {
            FOAMAnswers,
            FOAMErrors,
            hasFOAMErrors,
            ...(hasFOAMErrors && { FOAMFocusFieldID: FOAMErrors[0].focusFieldID })
        };
    }
    handleFOAMErrors(status) {
        if (status?.hasFOAMErrors) {
            const { FOAMErrors, FOAMFocusFieldID } = status;
            this.addFOAMErrorsAndScroll(FOAMErrors);
            this.focusFieldID = FOAMFocusFieldID;
            this.checkFocus = true;
        }
    }
    configureAuthorizationCodeSignatureVariables(viewInitialized, pageName) {
        if (viewInitialized) {
            const signatureCodeAuthorized = this.getAnswerByFormKey(EnrollmentFormKeys.SIGNATURE_CODE_AUTHORIZED);
            const authCodeSignatureDateTime = this.getAnswerByFormKey(EnrollmentFormKeys.AUTH_CODE_SIGNATURE_DATE_TIME);
            this.pageHasAuthorizationCodeSignatureFields = signatureCodeAuthorized !== null && authCodeSignatureDateTime !== null;
            this.isAuthorizationCodeSignatureComplete = signatureCodeAuthorized === 'true';
        }
        else {
            this.pageHasAuthorizationCodeSignatureFields = false;
            this.isAuthorizationCodeSignatureComplete = false;
        }
        this.showContinueToAuthorizationCodeSignatureText = this.getShowContinueToAuthorizationCodeSignatureText(pageName);
    }
    openEnrollmentErrorModal() {
        const missingDataModal = this.modalService.open(ConfirmationModalComponent, { centered: true, backdrop: 'static', keyboard: false });
        missingDataModal.componentInstance.hideCloseButton = true;
        missingDataModal.componentInstance.title = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_Error_Modal_Title', this.widgetName, 'An error has occurred');
        missingDataModal.componentInstance.prompt = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_Error_Modal_Prompt', this.widgetName, 'We have encountered an issue, please try again.');
        missingDataModal.componentInstance.confirmButton = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_Continue', this.widgetName, 'Continue');
        missingDataModal.componentInstance.confirmAction = async () => {
            this.spinnerService.show(SpinnerEvent.BACK_TO_SHOPPING);
            await this.memberSessionService.updateCart();
            this.spinnerService.hide(SpinnerEvent.BACK_TO_SHOPPING);
            this.configurableWidgetService.navigationService.navigateByPageTag(PageTags.SHOPPING_CART);
        };
        return missingDataModal;
    }
    openEditFieldModal(fieldName, isNextGenForm) {
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true });
        confirmationModal.componentInstance.title = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Enrollment_Edit_FormField_Title', this.widgetName, 'Are you sure you want to leave this page?');
        confirmationModal.componentInstance.prompt = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Enrollment_Edit_FormField_Prompt', this.widgetName, 'You will be taken back to shopping to update this information.');
        confirmationModal.componentInstance.cancelButton = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_Cancel', this.widgetName, 'Cancel');
        confirmationModal.componentInstance.confirmButton = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_Continue', this.widgetName, 'Continue');
        const pageTag = this.getEditFieldPageTag(fieldName, isNextGenForm);
        confirmationModal.componentInstance.confirmAction = () => {
            if (pageTag === PageTags.PLAN_LIST_MEDSUP_FORM) {
                this.planFacade.navigateToMedSupForm();
            }
            else {
                this.configurableWidgetService.navigationService.navigateByPageTag(pageTag);
            }
        };
        return confirmationModal;
    }
    getEditFieldPageTag(fieldName, isNextGenForm) {
        return isNextGenForm ? this.getNextGenEditFieldPageTag(fieldName) : this.getHOPEEditFieldPageTag(fieldName);
    }
    getHOPEEditFieldPageTag(fieldName) {
        const customInternal = this.enrollmentFormService.getEnrollmentCustomInternal();
        const medSupLockFields = _get(customInternal, 'CustomInternal.FoamConfig.DFMedSupLockFields');
        const medSupLockField = medSupLockFields.find(lockField => lockField.FOAMField === fieldName);
        return medSupLockField?.redirectTag ? medSupLockField.redirectTag : PageTags.PLAN_LIST_MEDSUP_FORM;
    }
    getNextGenEditFieldPageTag(fieldName) {
        const medSupLockFields = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_MedSup_LockFields', undefined, []);
        const medSupLockField = medSupLockFields.find(lockField => lockField.fieldName === fieldName);
        return medSupLockField?.redirectTag ? medSupLockField.redirectTag : PageTags.PLAN_LIST_MEDSUP_FORM;
    }
    async continueToNext() {
        if (!this.authService.isCurrentTokenValid()) {
            await this.authService.loadJWT();
        }
        const pageIndex = this.getCurrentIndex();
        const currentPageAnswers = this.retrieveFormAnswers(this.childForms);
        this.saveMillimanHealthInformation(currentPageAnswers);
        try {
            const allAnswers = this.retrieveAllFormAnswers(this.childForms);
            this.spinnerService.show(SpinnerEvent.ENROLLMENT_LOADING);
            const validationResults = await this.formRootStrategyService.runPageLevelValidations(allAnswers, pageIndex, this.isEnrollingDSNPPlan);
            const canContinueToNextPage = !!validationResults?.every(result => !!result?.isValid);
            if (canContinueToNextPage) {
                await this.formRootStrategyService.saveFormAnswers(pageIndex, currentPageAnswers, this.enrollingPlan, this.isRedirectedFromPlanCompareApi, this.childForms);
                this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ENROLLMENT_NEXT);
            }
            else {
                const continueText = validationResults?.find(result => result?.type === PageLevelValidatorType.EligibilityCheck)?.continueText;
                this.addErrorsAndScroll({
                    title: this.formRootService.getEnrollmentErrorNoticeTitle(),
                    messages: this.formatPageLevelValidationErrors(validationResults),
                    ...(continueText && { continueText })
                });
            }
        }
        finally {
            this.spinnerService.hide(SpinnerEvent.ENROLLMENT_LOADING);
        }
    }
    formatPageLevelValidationErrors(validationResults) {
        return (validationResults?.reduce((noticeMessages, validationResult) => {
            if (!validationResult.isValid) {
                noticeMessages.push({
                    message: validationResult.errorMessage,
                    severity: validationResult.severity,
                    source: MESSAGE_SOURCE.CLIENT
                });
            }
            return noticeMessages;
        }, []) ?? []);
    }
    getPageLevelValidationConfigurations() {
        return {
            [PageLevelValidatorType.EligibilityCheck]: {
                asyncValidation: async (payload) => await this.enrollmentFormService.nextGenCheckMemberEligibility(payload),
                dispatchEvent: (details) => {
                    this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ADD_PAGE_LEVEL_ERROR_TO_QUESTION, details);
                }
            },
            [PageLevelValidatorType.StateAndZip]: {
                asyncValidation: async (payload, validationType) => await this.enrollmentFormService.nextGenValidateEnrollment(payload, validationType),
                dispatchEvent: (details) => {
                    this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ADD_PAGE_LEVEL_ERROR_TO_QUESTION, details);
                }
            },
            [PageLevelValidatorType.Group]: {
                asyncValidation: async (conditionExpression, errorMessage) => await this.groupValidatorContextService.nextGenValidateGroup(conditionExpression, this.viewContainer.element.nativeElement, NextGenEnrollmentEvents.VALIDATE_GROUP_RESPONSE, () => {
                    this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.VALIDATE_GROUP, {
                        validatorType: PageLevelValidatorType.Group,
                        expression: conditionExpression,
                        errorMessage
                    });
                }),
                dispatchEvent: (details) => {
                    this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ADD_PAGE_LEVEL_ERROR_TO_QUESTION, details);
                }
            }
        };
    }
    saveMillimanHealthInformation(answers) {
        const isMillimanEnabled = this.millimanService.isMillimanServiceEnabled();
        if (isMillimanEnabled) {
            const healthInformation = this.createMillimanHealthInformationStateModel(answers);
            if (healthInformation && Object.keys(healthInformation).length) {
                this.millimanService.updateMillimanHealthInformation(healthInformation);
            }
        }
    }
    createMillimanHealthInformationStateModel(answers) {
        let healthInformation = null;
        if (answers?.length) {
            const healthInformationUniqueNames = this.millimanService.getMedigapAnswersUniqueNames();
            if (healthInformationUniqueNames) {
                healthInformation = new MillimanHealthInformation();
                healthInformationUniqueNames.split(',').forEach(key => {
                    const answer = this.formRootService.getAnswerValue(answers, key);
                    if (answer) {
                        healthInformation[key] = answer;
                    }
                });
            }
        }
        return healthInformation;
    }
    addFOAMErrorsAndScroll(FOAMErrors) {
        this.addErrorsAndScroll({
            title: this.formRootService.getEnrollmentErrorNoticeTitle(),
            messages: FOAMErrors.map(formError => ({ message: formError.message, severity: formError.severity, source: MESSAGE_SOURCE.CLIENT }))
        });
    }
    addNextGenErrorsAndScroll(nextGenErrors) {
        this.addErrorsAndScroll({
            title: this.formRootService.getEnrollmentErrorNoticeTitle(),
            messages: nextGenErrors.map(pageError => ({
                message: pageError?.message,
                severity: NOTICE_TYPE.ERROR,
                source: MESSAGE_SOURCE.CLIENT
            }))
        });
    }
    addErrorsAndScroll(errors, scroll = true) {
        this.enrollmentFormErrorsContext.addErrors(errors);
        this.enrollmentFormErrorsContext
            .observeForFormErrors$()
            .pipe(take(1))
            .subscribe({
            next: () => {
                if (scroll) {
                    this.enrollmentFormErrorsContext.scrollToErrors();
                }
            }
        });
    }
    async handleCompleteEnrollmentErrors(error) {
        if (error) {
            let errorMessages = [];
            let title = this.formRootService.getEnrollmentErrorNoticeTitle();
            const errorStatus = error.status;
            const innerError = error.error;
            if (errorStatus && innerError) {
                const enrollmentPostBackEnabled = this.enrollFormFacade.getConfirmationPostBackEnabled();
                switch (errorStatus) {
                    case HttpStatusCode.BAD_REQUEST:
                        errorMessages = this.getCompleteEnrollmentBadRequestMessages(innerError);
                        if (Object.values(HumanaApiErrorTypes).includes(innerError.Detail) ||
                            Object.values(ExternalApiErrorTypes).includes(innerError.Detail)) {
                            this.enrollFormFacade.showExternalEnrollmentErrorsModal(innerError);
                        }
                        break;
                    case HttpStatusCode.INTERNAL_SERVER_ERROR:
                        if (enrollmentPostBackEnabled) {
                            errorMessages = await this.handleEnrollmentPostbackInternalServerError(innerError);
                        }
                        if (!errorMessages?.length) {
                            title = this.Spa_Site_UnableToProcessErrorsTitle_Text;
                            errorMessages = [
                                { message: this.Spa_Site_UnableToProcessErrorsMessage_Text, severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER }
                            ];
                        }
                        break;
                    default:
                        title = this.Spa_Site_UnableToProcessErrorsTitle_Text;
                        errorMessages = [
                            { message: this.Spa_Site_UnableToProcessErrorsMessage_Text, severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER }
                        ];
                }
            }
            let errors = {
                title,
                messages: errorMessages.length
                    ? errorMessages
                    : [{ message: error.message, severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER }]
            };
            // errors won't display if no severity is sent back
            // API should do this but we will code defensively here
            if (errorMessages.every(errorMessage => !errorMessage.severity)) {
                errorMessages = errorMessages.map(errorMessage => ({ ...errorMessage, severity: NOTICE_TYPE.ERROR }));
                errors = { ...errors, messages: errorMessages };
            }
            this.addErrorsAndScroll(errors);
        }
    }
    async handleEnrollmentPostbackInternalServerError(error) {
        if (error.Title === this.enrollmentPostbackExceptionTitle) {
            await this.handleFailedEnrollmentPostback();
        }
        else if (error.Detail === OtherApiErrorTypes.INVALID_OBJECT && !this.enrollFormFacade.getConfirmationPostBackUrl()) {
            return [{ message: OtherApiErrorTypes.POSTBACK_INVALID, severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER }];
        }
        return [];
    }
    async handleFailedEnrollmentPostback() {
        await this.enrollmentFormService.sendConfirmationEmails(this.enrollingPlanId);
        this.configurableWidgetService.navigationService.navigateByPageTag(PageTags.ENROLLMENT_CONFIRMATION);
    }
    getCompleteEnrollmentBadRequestMessages(error) {
        if (error) {
            if (error.AdditionalInfo) {
                const additionalInfo = error.AdditionalInfo;
                return Object.keys(additionalInfo).reduce((errors, errorKey) => {
                    const errorMessage = additionalInfo[errorKey];
                    if (errorMessage) {
                        errors.push({ message: errorMessage });
                    }
                    return errors;
                }, []);
            }
            else if (error.Detail === OtherApiErrorTypes.POSTBACK_INVALID || error.Detail === OtherApiErrorTypes.TRANSACTION_INACTIVE) {
                return [{ message: error.Detail, severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER }];
            }
        }
        return [];
    }
    subscribeToSendBeneficiaryProfessionalOnlyNotice() {
        return combineLatest([this.pageName$, this.plan$])
            .pipe(filter(([pageName, plan]) => this.isFirstPage(pageName) && this.sendEnrollmentFacade.isPlanRestricted(plan)))
            .subscribe({
            next: () => {
                this.addErrorsAndScroll({
                    title: this.sendEnrollmentFacade.getRestrictProfessionalPlansNoticeTitle(),
                    messages: this.sendEnrollmentFacade.getRestrictProfessionalPlansNoticeMessage()
                });
            }
        });
    }
    isFirstPage(pageName) {
        return this.formRootStrategyService.isFirstPage(pageName, this.enrollingPlanId);
    }
    isLastPage(pageName) {
        return this.formRootStrategyService.isLastPage(pageName, this.enrollingPlanId);
    }
    getCurrentPageName() {
        return this.formRootStrategyService.getCurrentPageName();
    }
    setLocalizedText() {
        this.previousText = this.enrollFormFacade.getPreviousText(this.widgetName);
        this.nextText = this.enrollFormFacade.getNextText(this.widgetName);
        this.submitText = this.enrollFormFacade.getSubmitText(this.widgetName);
        this.sendEnrollmentApplicationButtonText = this.enrollFormFacade.getSendEnrollmentApplicationButtonText(this.widgetName);
        this.enrollmentPermissionDeniedTooltipText = this.enrollFormFacade.getEnrollmentPermissionDeniedTooltipText(this.widgetName);
        this.saveText = this.enrollFormFacade.getSaveText(this.widgetName);
        this.continueToVoiceSignatureText = this.enrollFormFacade.getContinueToVoiceSignatureText(this.widgetName);
        this.voiceSignatureCompletedText = this.enrollFormFacade.getVoiceSignatureCompletedText(this.widgetName);
        this.continueToAuthorizationCodeText = this.enrollFormFacade.getContinueToAuthorizationCodeSignatureText(this.widgetName);
        this.authorizationCodeCompletedText = this.enrollFormFacade.getAuthorizationCodeSignatureCompletedText(this.widgetName);
    }
    updateGoogleTagEvent(event) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: event
        };
    }
    openVoiceSignatureModal() {
        const voiceSignatureModal = this.modalService.open(VoiceSignatureModalComponent, {
            centered: true,
            scrollable: true,
            windowClass: 'voice-signature-modal'
        });
        voiceSignatureModal.componentInstance.title = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Enrollment_VoiceSignatureModal_Title', this.widgetName, 'Voice signature');
        voiceSignatureModal.componentInstance.cancelButtonText = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_Cancel', this.widgetName, 'Cancel');
        voiceSignatureModal.componentInstance.continueButtonText =
            this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Enrollment_VoiceSignatureModal_ContinueApplying_Text', this.widgetName, 'Continue applying');
        voiceSignatureModal.componentInstance.requiredText = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Enrollment_VoiceSignatureModal_RequiredError_Text', this.widgetName, 'Required');
        voiceSignatureModal.componentInstance.headerInstructionalText =
            this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Enrollment_VoiceSignatureModal_HeaderInstructional_Text', this.widgetName, '<div class="pb-1">All fields are required</div><div class="pb-1">Select each box as the following is read to the beneficiary</div>');
        voiceSignatureModal.componentInstance.showPlanBenefitRadioOrCheckBox = false;
        const voiceSignatureSections = this.configurableWidgetService.configResourceService
            .getProcessedResourceValue('Spa_Enrollment_VoiceSignature_Questions_JSON', this.widgetName, [
            {
                sectionName: 'Enrollment',
                sectionHeader: '<h3 class="Spa_Style_H4"><span class="input-error-asterisk">*</span>Enrollment</h3>',
                statements: [
                    { value: 'You are enrolling using an electronic transaction that will be verified by electronic signature.' },
                    { value: 'This agreement to use an electronic transaction only applies to this enrollment.' },
                    {
                        value: 'You may request to cancel this electronic transaction agreement. If cancelled, paper enrollment forms will ' +
                            'be sent at no cost once I give my {{[_selectedPlans_.|activeEnrollmentKey|.planMarketingName]}} representative an address, phone number, and a contact name.'
                    },
                    { value: 'You may ask for a transcript copy of this recorded transaction.' },
                    {
                        value: 'If you are enrolling on someone else’s behalf, you agree that you are authorized under the laws of the state' +
                            ' where the individual resides, and that you have documentation of this authority. This documentation must be' +
                            ' made available to Medicare upon request.'
                    },
                    {
                        value: 'For more information contact {{[_selectedPlans_.|activeEnrollmentKey|.planMarketingName]}} at {{getenrollingcarrieraddress()}}. A digital copy of this agreement is electronically' +
                            ' stored and maintained by {{[_selectedPlans_.|activeEnrollmentKey|.planMarketingName]}}.'
                    },
                    {
                        value: ' In order to complete enrollment, we will review several important statements and ask for your agreement at the' +
                            ' end of our conversation. By completing this enrollment and agreeing at the end of this recording, you understand' +
                            ' and agree to all the statements provided to you.'
                    }
                ],
                instructionalText: '<span class="Spa_Style_Bold_Weight" style="color: var(--static-Spa_Style_Cost_Text)">If the applicant agrees:</span> The agent will state, <b>“Thank you. I will now read the second section.”</b>' +
                    ' If multiple applicants are listening to the recording, each must respond “yes” to continue with the enrollment' +
                    ' signature process. The agent will ask anyone who doesn’t respond,' +
                    ' <b>“[Mr./Ms.] do you understand and agree with all of the statements you’ve heard?”</b><br/><br/>' +
                    '<span class="Spa_Style_Bold_Weight" style="color: var(--static-Spa_Style_Cost_Text)">If the applicant does not agree or has questions:</span> The agent will answer the applicant’s questions and then' +
                    ' ask the following again, <b>“Do you understand and agree with all of the statements that you’ve heard?”</b>' +
                    ' until a ‘yes’ response is provided or the enrollment process is terminated.'
            },
            {
                sectionName: 'Plan Coverage',
                sectionHeader: '<h3 class="Spa_Style_H4"><span class="input-error-asterisk">*</span>Plan Coverage</h3>',
                statements: [
                    {
                        value: 'If you have employer or union healthcare coverage, you could lose it if you join {{[_selectedPlans_.|activeEnrollmentKey|.planMarketingName]}}.'
                    },
                    {
                        value: 'Read the communications your employer or union provides to you. If you have questions, visit their' +
                            ' website, or contact the office listed within their communications sent to you. If there is not' +
                            ' information on whom to contact, your benefits administrator may be able to help.'
                    },
                    {
                        value: 'If you already have a Medicare Advantage or Part D plan, it will end once you enroll with {{[_selectedPlans_.|activeEnrollmentKey|.planMarketingName]}}.' +
                            ' It is your responsibility to tell {{[_selectedPlans_.|activeEnrollmentKey|.planMarketingName]}} about any other prescription coverage you have now or that' +
                            ' you get in the future.'
                    },
                    {
                        value: 'Enrollment in this plan is usually for an entire year. Once you enroll, you can leave or change this plan' +
                            ' only at certain times of the year, such as October 15 through December 7, or under special circumstances.' +
                            ' You may need to send a request to {{[_selectedPlans_.|activeEnrollmentKey|.planMarketingName]}} to leave or change this plan.'
                    },
                    {
                        value: '{{[_selectedPlans_.|activeEnrollmentKey|.planMarketingName]}} provides plans for a specific service area. If you move to a new area, you will need to notify us' +
                            ' and find a plan in your new area.'
                    },
                    {
                        value: 'Once you’re a member, you have the right to appeal plan decisions if you disagree with any payments or services.'
                    },
                    {
                        value: '{{[_selectedPlans_.|activeEnrollmentKey|.planMarketingName]}} will mail you the plan’s Evidence of Coverage which includes rules you must follow to receive coverage' +
                            ' on this plan.'
                    },
                    {
                        value: 'Medicare doesn’t generally cover beneficiaries out of the country, except for limited coverage near U.S. borders.'
                    },
                    {
                        value: '{{[_selectedPlans_.|activeEnrollmentKey|.planMarketingName]}} will release your information to Medicare and other plans as necessary for treatment, payment, and healthcare' +
                            ' operations. This includes releasing your prescription drug event data to Medicare, who may release it for research and' +
                            ' other purposes that follow all applicable federal statutes and regulations.'
                    },
                    {
                        value: 'By joining this <enrollingPlanTypeName>, you acknowledge that {{[_selectedPlans_.|activeEnrollmentKey|.planMarketingName]}} will share your information with Medicare, who may' +
                            ' use it to track my enrollment, to make payments, and for other purposes allowed by Federal law that authorize the ' +
                            ' collection of this information. Your response is voluntary. However, failure to respond may affect enrollment in the plan.'
                    },
                    {
                        value: 'If you receive help from a sales agent, broker, or other person employed by or contracted with {{[_selectedPlans_.|activeEnrollmentKey|.planMarketingName]}}, he or she' +
                            ' may be paid compensation based on your enrollment in {{[_selectedPlans_.|activeEnrollmentKey|.planMarketingName]}}.'
                    },
                    {
                        value: 'Information you have given must be correct to the best of your knowledge. You may be disenrolled if you intentionally' +
                            '  provide false information.'
                    },
                    {
                        value: 'Out-of-network/non-contracted providers are under no obligation to treat Plan members, except in emergency situations.' +
                            ' Please call the Plan’s customer service number or see your Evidence of Coverage for more information, including the' +
                            ' cost-sharing that applies to out-of-network services.'
                    },
                    {
                        value: '{{[_selectedPlans_.|activeEnrollmentKey|.planMarketingName]}} is a Medicare Advantage/Medicare Part D organization with a Medicare contract. Enrollment in a {{[_selectedPlans_.|activeEnrollmentKey|.planMarketingName]}}' +
                            ' plan depends on contract renewal. You’ll need to keep Medicare Parts A and B.'
                    },
                    {
                        value: 'Do you understand and agree with all the statements you’ve heard so far?'
                    }
                ],
                instructionalText: '<span class="Spa_Style_Bold_Weight" style="color: var(--static-Spa_Style_Cost_Text)">If the applicant agrees:</span> <b>“Thank you. I will now read the final section.”</b><br/><br/>' +
                    '<span class="Spa_Style_Bold_Weight" style="color: var(--static-Spa_Style_Cost_Text)">If the applicant does not agree or has questions:</span> The agent will answer the applicant’s' +
                    'questions and then re-ask, <b>“Do you understand and agree with all of the statements that you’ve heard?”</b>' +
                    ' until a ‘yes’ response is given or the enrollment process is terminated.'
            },
            {
                sectionName: 'Confirmation',
                sectionHeader: '<h3 class="Spa_Style_H4"><span class="input-error-asterisk">*</span>Confirmation</h3>',
                statements: [
                    {
                        value: 'You understand that except for emergencies and urgent care situations, it may cost more for uncovered services' +
                            ' received outside the network. In-network providers or specialists may be limited in certain geographic areas.' +
                            ' If the network in your area doesn’t offer a select specialist, you may be allowed to go to a non-network provider' +
                            ' at the in-network rate. Be sure to contact non-network providers before being seen to make sure they accept assigned' +
                            ' Medicare and have agreed to accept payment from {{[_selectedPlans_.|activeEnrollmentKey|.planMarketingName]}}. If medically necessary, {{[_selectedPlans_.|activeEnrollmentKey|.planMarketingName]}} provides reimbursement' +
                            ' for all covered benefits, even if received out-of-network.'
                    },
                    {
                        value: 'People with limited incomes may qualify for extra help to pay for their prescription drug costs. If you are eligible,' +
                            ' Medicare could pay for 75 percent or more of your drug costs, including monthly prescription plan premiums, annual' +
                            ' deductibles, and coinsurance. Additionally, those who qualify will not be subject to the coverage gap or a late enrollment' +
                            ' penalty. For more information about this extra help, contact the Social Security Administration. If you qualify for extra' +
                            ' help, Medicare may pay for all or part of your plan premium. If Medicare pays only a portion of the premium, {{[_selectedPlans_.|activeEnrollmentKey|.planMarketingName]}}' +
                            ' will bill you for the amount that Medicare doesn’t cover.'
                    },
                    {
                        value: 'You may have to pay extra for prescription drug coverage if your income is above a certain limit. This is called Part D-Income' +
                            ' Related Monthly Adjustment Amount, also referred to as Part D IRMAA. If you are assessed a Part D IRMAA, you will be notified' +
                            ' by the Social Security Administration. You will be responsible for paying this extra amount in addition to your plan premium.' +
                            ' Either the amount will be withheld from your Social Security benefit, or you’ll be billed directly by Medicare or the Railroad' +
                            ' Retirement Board. Do NOT send {{[_selectedPlans_.|activeEnrollmentKey|.planMarketingName]}} your Part D IRMAA payment.'
                    },
                    {
                        value: '{{[_selectedPlans_.|activeEnrollmentKey|.planMarketingName]}} will send you a notice that will acknowledge receipt of your enrolment, inform you of your application’s status, and' +
                            ' let you know if any additional information is needed.'
                    },
                    {
                        value: 'Agreeing to sign your application by phone means you understand and agree to all statements heard in this recording.' +
                            ' You also understand how the plan we’ve discussed works, and the charges you’ll be responsible for.'
                    },
                    {
                        value: 'If you agree to complete your enrollment now, please state your name, your date of birth, and that you agree.'
                    }
                ],
                instructionalText: '<span class="Spa_Style_Bold_Weight" style="color: var(--static-Spa_Style_Cost_Text)">If the applicant agrees:</span> Thank the applicant and inform them that you are submitting the enrollment.<br/><br/>' +
                    '<span class="Spa_Style_Bold_Weight" style="color: var(--static-Spa_Style_Cost_Text)">If the applicant does not agree or has questions:</span> The agent will answer the applicant’s' +
                    'questions and then re-ask, <b>“Do you understand and agree with all of the statements that you’ve heard?”</b>' +
                    ' until a ‘yes’ response is given or the enrollment process is terminated.'
            }
        ])
            ?.map(section => {
            return {
                ...section,
                statements: section.statements.map(statement => ({
                    ...statement,
                    value: this.replaceStatementValuePlaceholders(statement.value)
                }))
            };
        }) ?? [];
        voiceSignatureModal.componentInstance.voiceSignatureSections = voiceSignatureSections;
        voiceSignatureModal.componentInstance.cancelAction = () => {
            voiceSignatureModal.close();
        };
        voiceSignatureModal.componentInstance.confirmAction = async (isVoiceSignatureComplete) => {
            if (isVoiceSignatureComplete) {
                const voiceSignatureAnswers = this.createVoiceSignatureAnswers();
                const transactionGUID = this.enrollmentFormService.getTransactionId(this.enrollingPlanId);
                if (transactionGUID) {
                    await Promise.all([
                        this.updateFormTransaction(this.getCurrentIndex(), voiceSignatureAnswers),
                        this.enrollmentFormService
                            .saveVoiceSignatureStatements$(this.memberSessionService.getMemberSessionId(), transactionGUID, voiceSignatureSections, this.locale)
                            .toPromise()
                    ]);
                    this.updateFormAnswers(voiceSignatureAnswers);
                    this.isVoiceSignatureComplete = true;
                    this.cdr.markForCheck();
                    // TODO: might be worth externally logging failures here AND if form field is not equal to isVoiceSignatureComplete
                }
                else {
                    this.externalErrorLoggingService.log(new Error('Unable to save voice signature. transactionGUID not found'));
                }
            }
            voiceSignatureModal.close();
            // TODO: set signature recorded flag is session storage? How will we handle page reloads? Might need to push the transaction
            // set the form field via custom event and set the enrollment preferences in this method
        };
        return voiceSignatureModal;
    }
    openAuthorizationCodeSignatureModal() {
        const urlToHIPAAForm = this.enrollingPlan?.documents?.find(document => document.name === HEALTH_INFORMATION_AUTHORIZATION_DOCUMENT_NAME)?.url ?? '';
        const authorizationCodeSignatureModal = this.modalService.open(AuthorizationCodeSignatureModalComponent, {
            centered: true,
            scrollable: true,
            windowClass: 'authorization-code-signature-modal'
        });
        authorizationCodeSignatureModal.componentInstance.title =
            this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Enrollment_AuthorizationCodeSignatureModal_Title', this.widgetName, 'Authorization Code Signature');
        authorizationCodeSignatureModal.componentInstance.cancelButtonText =
            this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_Cancel', this.widgetName, 'Cancel');
        authorizationCodeSignatureModal.componentInstance.continueButtonText =
            this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Enrollment_AuthorizationCodeSignatureModal_ContinueApplying_Text', this.widgetName, 'Continue applying');
        authorizationCodeSignatureModal.componentInstance.requiredText =
            this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Enrollment_AuthorizationCodeSignatureModal_RequiredError_Text', this.widgetName, 'Required');
        authorizationCodeSignatureModal.componentInstance.invalidEmailText =
            this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Enrollment_AuthorizationCodeSignature_InvalidEmailError_Text', this.widgetName, 'Please provide a valid email address');
        authorizationCodeSignatureModal.componentInstance.invalidPhoneText =
            this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Enrollment_AuthorizationCodeSignature_InvalidPhoneError_Text', this.widgetName, 'Please provide a valid phone number');
        authorizationCodeSignatureModal.componentInstance.invalidCodeText =
            this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Enrollment_AuthorizationCodeSignature_InvalidCodeError_Text', this.widgetName, 'Please enter a valid code');
        authorizationCodeSignatureModal.componentInstance.headerInstructionalText =
            this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Enrollment_AuthorizationCodeSignatureModal_HeaderInstructional_Text', this.widgetName, '');
        authorizationCodeSignatureModal.componentInstance.emailSubject =
            this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Enrollment_AuthorizationCodeSignature_Email_Subject', this.widgetName, 'Authorization code for your insurance application');
        const authorizationCodeSignatureSections = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Enrollment_AuthorizationCodeSignature_Questions_JSON', this.widgetName, [
            {
                sectionName: 'agent-instructions',
                sectionHeader: '<h3 class="Spa_Style_H4">Agent Instructions</h3>',
                displayStatementsAsList: true,
                statements: [
                    {
                        value: 'Read out the instructions to get the applicant’s permission to send a text or email with an authorization code:',
                        displaySubStatementsAsList: true,
                        subStatements: [
                            {
                                value: 'Do you agree to allow the carrier to send you, via automated text message or email, a one-time authorization code? Message and data rates may apply for text messages.'
                            }
                        ]
                    },
                    { value: 'Obtain verbal acknowledgement from each signer.' },
                    { value: 'Select Text or Email and Click the "Send Authorization Code" button.' },
                    {
                        value: 'Obtain Mobile number or email from the signers where the authorization code is to be sent along with a link to the Health Information Authorization form.'
                    },
                    {
                        value: 'Once the authorization code is received by the signers via text or email, have them read you the code which you will enter into the tool and click on "Verify Authorization Code".',
                        displaySubStatementsAsList: true,
                        subStatements: [
                            {
                                value: 'On successful validation of Authorization Code, click on I agree to Terms and Conditions checkbox and then click on "Apply Applicant Signature".'
                            }
                        ]
                    }
                ]
            },
            {
                sectionName: 'request-authorization-code-on',
                statements: [
                    {
                        inputType: 'radio',
                        radioOptions: ['text', 'email'],
                        name: 'request-authorization-code-on',
                        value: 'Request Authorization Code on'
                    }
                ]
            },
            {
                sectionName: 'send-authorization-code',
                statements: [
                    {
                        inputType: 'phone',
                        name: 'phone-number',
                        value: 'Phone Number',
                        buttonText: 'Send Authorization Code',
                        statementAction: 'send-authorization-code'
                    },
                    {
                        inputType: 'email',
                        name: 'email',
                        value: 'Email',
                        buttonText: 'Send Authorization Code',
                        statementAction: 'send-authorization-code'
                    }
                ]
            },
            {
                sectionName: 'verify-authorization-code',
                statements: [
                    {
                        inputType: 'text',
                        name: 'verify-authorization-code',
                        value: 'Authorization Code',
                        buttonText: 'Verify Authorization Code',
                        statementAction: 'verify-authorization-code'
                    }
                ]
            },
            {
                visible: false,
                sectionName: 'agree-to-terms-and-conditions-applicant',
                statements: [
                    {
                        inputType: 'checkbox',
                        name: 'agree-to-terms-and-conditions-applicant',
                        value: 'I agree to terms and conditions'
                    }
                ]
            },
            {
                visible: false,
                sectionName: 'agent-signature',
                sectionHeader: '<h3 class="Spa_Style_H4">Agent Signature</h3>',
                displayStatementsAsList: true,
                preInstructionalText: '<p>I certify that the applicant(s) have reviewed the completed application and have checked the boxes above and I agree that my electronic signature will be legally binding and enforceable as I had signed on paper and, understanding this, I agree to apply my electronic signature to:</p>',
                statements: [
                    { value: 'The Agent signature page of the application and overflow page, if applicable;' },
                    { value: 'The Replacement Notice form, if applicable; and' },
                    { value: 'The Agent request to split commissions page, if applicable' }
                ]
            },
            {
                visible: false,
                sectionName: 'agree-to-terms-and-conditions-agent',
                statements: [
                    {
                        inputType: 'checkbox',
                        name: 'agree-to-terms-and-conditions-agent',
                        value: 'I agree to terms and conditions'
                    }
                ]
            }
        ]);
        authorizationCodeSignatureModal.componentInstance.authorizationCodeSignatureSections = authorizationCodeSignatureSections;
        authorizationCodeSignatureModal.componentInstance.createProcessedTextMessage = async (phoneNumber) => {
            const shortUrlToHIPAAForm = await this.enrollmentFormService.getShortUrl(urlToHIPAAForm);
            const message = this.configurableWidgetService.configResourceService
                .getProcessedResourceValue('Spa_Enrollment_AuthorizationCodeSignature_TextMessage_Body', this.widgetName, 'Authorization code: [AuthCode]\r\nProvide this code to your agent to electronically sign your application and health authorization <linkToHIPAA>')
                .replace('<linkToHIPAA>', shortUrlToHIPAAForm);
            return {
                phoneNumber,
                message
            };
        };
        authorizationCodeSignatureModal.componentInstance.createProcessedEmail = async (emailTemplate, to, subject) => {
            const emailHeader = this.enrollmentFormService.getFormattedEmailHeader(this.widgetName);
            const agentData = this.enrollmentFormService.getAgentData();
            const shortUrlToHIPAAForm = await this.enrollmentFormService.getShortUrl(urlToHIPAAForm);
            const emailBody = this.configurableWidgetService.configResourceService
                .getProcessedResourceValue('Spa_Enrollment_AuthorizationCodeSignature_Email_Body', this.widgetName, 'By providing this authorization to your agent, you acknowledge your intent to apply for this insurance policy. You can access <a class="Spa_Style_Primary_Link Spa_Style_Bold_Weight text-underline" href="<linkToHIPAA>"><linkToHIPAA></a> document here. <br />\r\nNote: This email is from a licensed sales agent.<br/>\r\n')
                .replace(/<linkToHIPAA>/g, shortUrlToHIPAAForm);
            let agentFooterData;
            if (agentData?.data) {
                agentFooterData = this.enrollmentFormService.getCreditedAgentEmailFooterData(agentData.data);
            }
            else {
                agentFooterData = await this.enrollmentFormService.getAgentEmailFooterData();
            }
            const inputs = [
                { key: 'emailHeader', value: emailHeader },
                { key: 'emailBody', value: emailBody },
                { key: 'agentName', value: agentFooterData.agentName },
                { key: 'agencyName', value: agentFooterData.agencyName },
                { key: 'agentNPN', value: agentFooterData.agentNPN },
                { key: 'agentEmail', value: agentFooterData.agentEmail },
                { key: 'agentPhoneAndHours', value: agentFooterData.agentPhoneAndHours },
                { key: 'agentPictureURL', value: agentFooterData.agentPictureURL },
                { key: 'californiaLicenseNumber', value: agentFooterData.californiaLicenseNumber }
            ];
            return await this.enrollmentFormService.getProcessedEmail(emailTemplate, to, subject, inputs);
        };
        authorizationCodeSignatureModal.componentInstance.createAuthorizationCode = async (deliverySettings) => {
            const transactionGUID = this.enrollmentFormService.getTransactionId(this.enrollingPlanId);
            if (transactionGUID) {
                const sessionId = this.memberSessionService.getMemberSessionId();
                const agentGuid = this.memberSessionService.getAgentInContextGuid();
                return await this.memberSessionService
                    .createAuthorizationCode$(sessionId, agentGuid, transactionGUID, deliverySettings)
                    .toPromise();
            }
            else {
                this.externalErrorLoggingService.log(new Error('Unable to create the authorization code. transactionGUID not found'));
            }
        };
        authorizationCodeSignatureModal.componentInstance.validateAuthorizationCode = async (authCode) => {
            const transactionGUID = this.enrollmentFormService.getTransactionId(this.enrollingPlanId);
            if (transactionGUID) {
                const sessionId = this.memberSessionService.getMemberSessionId();
                const agentGuid = this.memberSessionService.getAgentInContextGuid();
                return await this.memberSessionService.validateAuthorizationCode$(sessionId, agentGuid, transactionGUID, authCode).toPromise();
            }
            else {
                this.externalErrorLoggingService.log(new Error('Unable to verify the authorization code. transactionGUID not found'));
            }
        };
        authorizationCodeSignatureModal.componentInstance.cancelAction = () => {
            authorizationCodeSignatureModal.close();
        };
        authorizationCodeSignatureModal.componentInstance.confirmAction = async (isAuthorizationCodeSignatureComplete) => {
            if (isAuthorizationCodeSignatureComplete) {
                const transactionGUID = this.enrollmentFormService.getTransactionId(this.enrollingPlanId);
                if (transactionGUID) {
                    const authorizationCodeSignatureAnswers = this.createAuthorizationCodeSignatureAnswers();
                    await this.updateFormTransaction(this.getCurrentIndex(), authorizationCodeSignatureAnswers);
                    this.updateFormAnswers(authorizationCodeSignatureAnswers);
                    this.isAuthorizationCodeSignatureComplete = isAuthorizationCodeSignatureComplete;
                    this.cdr.markForCheck();
                }
                else {
                    this.externalErrorLoggingService.log(new Error('Unable to save voice signature. transactionGUID not found'));
                }
            }
            authorizationCodeSignatureModal.close();
        };
        return authorizationCodeSignatureModal;
    }
    createVoiceSignatureAnswers() {
        const collectedAnswer = { name: EnrollmentFormKeys.VOICE_SIGNATURE_COLLECTED, value: true };
        const dateTimeAnswer = {
            name: EnrollmentFormKeys.VOICE_SIGNATURE_COLLECTED_DATETIME,
            value: DateUtilities.getFormattedDateTime()
        };
        return [collectedAnswer, dateTimeAnswer];
    }
    createAuthorizationCodeSignatureAnswers() {
        const collectedAnswer = { name: EnrollmentFormKeys.SIGNATURE_CODE_AUTHORIZED, value: true };
        const dateTimeAnswer = {
            name: EnrollmentFormKeys.AUTH_CODE_SIGNATURE_DATE_TIME,
            value: DateUtilities.getFormattedDateTime()
        };
        return [collectedAnswer, dateTimeAnswer];
    }
    validateAuthorizationCodeSignature() {
        if (this.getShowContinueToAuthorizationCodeSignatureText(this.pageName) && !this.isAuthorizationCodeSignatureComplete) {
            return [
                {
                    message: this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Enrollment_AuthorizationCodeSignature_RequiredError_Text', this.widgetName, 'Authentication code signature required before submission.'),
                    severity: NOTICE_TYPE.ERROR,
                    fieldName: EnrollmentFormKeys.SIGNATURE_CODE_AUTHORIZED,
                    // This is a hidden field. In this case, we just want to scroll up to where the notice with the error is displayed.
                    focusFieldID: ''
                }
            ];
        }
    }
    async updateFormTransaction(pageIndex, answers) {
        if (this.planHasNextGenForm) {
            return await this.enrollmentFormService.updateNextGenTransaction$(answers, this.enrollingPlanId).toPromise();
        }
        else {
            const updateTransactionRequest = EnrollmentTransactionRequest.createUpdateTransaction(pageIndex, answers, `${this.enrollmentFormService.getSelectedFormType(this.enrollingPlanId).valueOf()}`);
            return await this.enrollmentFormService.updateFormTransaction$(updateTransactionRequest, this.enrollingPlanId).toPromise();
        }
    }
    updateFormAnswers(signatureAnswers) {
        this.setFOAMFieldValues(signatureAnswers.map(answer => ({ name: answer.name, value: answer.value })));
    }
    setPreEnrollmentStatementsCollected() {
        this.setFOAMFieldValues([
            {
                name: EnrollmentFormKeys.PRE_ENROLLMENT_STATEMENTS_COLLECTED,
                value: true
            }
        ]);
    }
    setFOAMFieldValues(customEventFields) {
        this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.SET_FORM_FIELD, {
            fields: customEventFields
        });
    }
    async getNextGenPageErrors() {
        const element = this.viewContainer.element.nativeElement;
        return await new Promise((resolve, reject) => {
            const listener = (responseEvent) => {
                const responseData = responseEvent.detail.pageErrors;
                resolve(responseData);
            };
            element.addEventListener(NextGenEnrollmentEvents.REQUEST_PAGE_ERRORS_RESPONSE, listener, { once: true });
            const myCustomEvent = new CustomEvent(NextGenEnrollmentEvents.REQUEST_PAGE_ERRORS, { bubbles: true });
            element.dispatchEvent(myCustomEvent);
            setTimeout(() => {
                element.removeEventListener(NextGenEnrollmentEvents.REQUEST_PAGE_ERRORS_RESPONSE, listener);
                reject(new Error('Unable to retrieve errors from enrollment form'));
            }, 2000);
        });
    }
    async getNextGenFormErrors() {
        const element = this.viewContainer.element.nativeElement;
        return await new Promise((resolve, reject) => {
            const listener = (responseEvent) => {
                const responseData = responseEvent.detail.pageErrors;
                resolve(responseData);
            };
            element.addEventListener(NextGenEnrollmentEvents.REQUEST_FORM_ERRORS_RESPONSE, listener, { once: true });
            const myCustomEvent = new CustomEvent(NextGenEnrollmentEvents.REQUEST_FORM_ERRORS, { bubbles: true });
            element.dispatchEvent(myCustomEvent);
            setTimeout(() => {
                element.removeEventListener(NextGenEnrollmentEvents.REQUEST_FORM_ERRORS_RESPONSE, listener);
                reject(new Error('Unable to retrieve errors from enrollment form'));
            }, 2000);
        });
    }
    openPreEnrollmentStatementsModal() {
        // We currently actually want to always show the modal on load/refresh even if it's complete, but that is likely enough
        // to change, that I'll leave this here.
        // const preEnrollmentComplete: boolean = this.hasAnswerByFormKey(EnrollmentFormKeys.PRE_ENROLLMENT_STATEMENTS_COLLECTED);
        const voiceSignatureSections = this.configurableWidgetService.configResourceService
            .getProcessedResourceValue(`Spa_Enrollment_${this.enrollingPlan.planTypeAbbreviation}PreEnrollmentStatements_JSON`, this.widgetName, [])
            ?.map(section => {
            return {
                ...section,
                statements: section.statements.map(statement => ({
                    ...statement,
                    value: this.replaceStatementValuePlaceholders(statement.value)
                }))
            };
        }) ?? [];
        if (voiceSignatureSections?.length) {
            const preEnrollmentStatementsModal = this.modalService.open(VoiceSignatureModalComponent, {
                backdrop: 'static',
                centered: true,
                scrollable: true,
                windowClass: 'voice-signature-modal'
            });
            preEnrollmentStatementsModal.componentInstance.title = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_PreEnrollmentStatements_ModalHeader_Text', this.widgetName, 'Pre-enrollment Statements');
            preEnrollmentStatementsModal.componentInstance.cancelButtonText =
                this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_PreEnrollmentStatements_Return_Text', this.widgetName, 'Return');
            preEnrollmentStatementsModal.componentInstance.continueButtonText =
                this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_PreEnrollmentStatements_Continue_Text', this.widgetName, 'Continue applying');
            preEnrollmentStatementsModal.componentInstance.cancelButtonEnabled =
                this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_PreEnrollmentStatements_GoBackButton_Enabled', this.widgetName, true);
            preEnrollmentStatementsModal.componentInstance.cancelAction = () => {
                if (this.Spa_PreEnrollmentStatements_ReturnFromModal_URL) {
                    this.navigationService.navigate({
                        title: '',
                        href: this.Spa_PreEnrollmentStatements_ReturnFromModal_URL,
                        type: LinkType.EXTERNAL,
                        target: TargetType.SELF
                    });
                }
                else {
                    this.navigationService.navigateByPageTag(PageTags.SHOPPING_CART);
                    preEnrollmentStatementsModal.close();
                }
            };
            preEnrollmentStatementsModal.componentInstance.confirmAction = (formComplete) => {
                if (formComplete) {
                    this.setPreEnrollmentStatementsCollected();
                    preEnrollmentStatementsModal.close();
                }
            };
            preEnrollmentStatementsModal.componentInstance.requiredText =
                this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Enrollment_VoiceSignatureModal_RequiredError_Text', this.widgetName, 'Required');
            preEnrollmentStatementsModal.componentInstance.showPlanBenefitRadioOrCheckBox = true;
            const planBenefitsSection = voiceSignatureSections.find(section => section.containsPlanBenefitsTable);
            if (planBenefitsSection) {
                const outsideTableStatements = planBenefitsSection.statements;
                const planBenefitsData = this.enrollingPlan.planDataFields;
                // mapping the whitelist instead of filtering the data so we maintain the order in the white list
                const filteredPlanBenefitsData = this.Spa_PreEnrollmentStatements_WhitelistedBenefits_JSON.reduce((whitelistedBenefitsData, whitelistedBenefitId) => {
                    const whitelistedBenefitData = planBenefitsData?.find(benefit => benefit.benefitID === whitelistedBenefitId && benefit.isCovered === true);
                    if (whitelistedBenefitData?.type === 'In Network') {
                        whitelistedBenefitsData.push(whitelistedBenefitData);
                    }
                    return whitelistedBenefitsData;
                }, []);
                const selectedRiders = this.shoppingCartService.getSelectedPlanRiders(this.enrollingPlan.id);
                const planPremium = this.planFacade.getTotalPremium([this.enrollingPlan], selectedRiders);
                const tableMiscStatements = [
                    {
                        value: this.createPreEnrollmentStatementModalTableItemName(this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_PlanDetails_Costs_Premium', this.widgetName)),
                        planBenefitDetails: `${this.currencyPipe.transform(planPremium)}`
                    },
                    {
                        value: this.createPreEnrollmentStatementModalTableItemName(this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_PlanCard_Benefit_MedicalDeductible_Text', this.widgetName)),
                        planBenefitDetails: `${this.currencyPipe.transform(this.enrollingPlan.medicalDeductible)}`
                    },
                    {
                        value: this.createPreEnrollmentStatementModalTableItemName(this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_PreEnrollmentStatements_InNetWorkMaximumOutOfPocket_Text', this.widgetName)),
                        planBenefitDetails: `${this.currencyPipe.transform(this.enrollingPlan.maximumOutOfPocketCost)}`
                    }
                ];
                const tableBenefitsStatements = filteredPlanBenefitsData.map(filteredData => {
                    return {
                        value: this.createPreEnrollmentStatementModalTableItemName(filteredData.name),
                        planBenefitDetails: filteredData.description
                    };
                });
                planBenefitsSection.statements = [
                    ...tableMiscStatements,
                    ...tableBenefitsStatements,
                    ...this.createPreEnrollmentStatementModalPrescriptionItems()
                ];
                const documentsLink = this.createPreEnrollmentStatementsModalDocumentsLink();
                if (documentsLink) {
                    planBenefitsSection.statements.push(documentsLink);
                }
                planBenefitsSection.statements.push(...outsideTableStatements);
            }
            preEnrollmentStatementsModal.componentInstance.voiceSignatureSections = voiceSignatureSections;
        }
    }
    createPreEnrollmentStatementModalTableItemName(itemName = '') {
        const modifiedItemName = itemName.replace('///g', ' / ');
        return `<div class="d-flex">
    <div class='d-inline-block preEnrollment-item-name'>${modifiedItemName}</div></div>`;
    }
    createPreEnrollmentStatementModalPrescriptionItems() {
        const tablePrescriptionStatements = [
            {
                value: this.createPreEnrollmentStatementModalTableItemName(this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_PlanCard_Benefit_PharmacyDeductible_Text', this.widgetName)),
                planBenefitDetails: `${this.currencyPipe.transform(this.enrollingPlan.drugDeductible)}`
            },
            {
                value: this.createPreEnrollmentStatementModalTableItemName(this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_PlanCard_Benefit_InitialCoverageLimit_Text', this.widgetName)),
                planBenefitDetails: `${this.currencyPipe.transform(this.enrollingPlan.initialCoverageLimit)}`
            }
        ];
        const prescriptionHeaderExtendedDetails = this.enrollingPlan.extendedPlanDetails.filter(detail => detail.headerType === SectionHeaderType.TWO);
        prescriptionHeaderExtendedDetails.forEach(detail => {
            const sectionName = detail.name;
            let sectionHTML = '';
            detail.sectionDetails.forEach(section => {
                sectionHTML += `<div class='preEnrollment-prescription-item-wrapper'>
            <span class='preEnrollment-prescription-item-description'>${section.description}: </span>
            <span class='preEnrollment-prescription-item-value'>${section.value}</span>
            </div>`;
            });
            tablePrescriptionStatements.push({
                value: this.createPreEnrollmentStatementModalTableItemName(sectionName),
                planBenefitDetails: sectionHTML
            });
        });
        return tablePrescriptionStatements;
    }
    createPreEnrollmentStatementsModalDocumentsLink() {
        const documentLinks = [];
        const planSummaryOfBenefitsDocuments = this.enrollingPlan.documents.filter(document => {
            const typeMap = document.types?.map(documentType => documentType.name) ?? [];
            // Certain test plans could have no type object. Those will have to be devoid of links, but should not break the modal
            return typeMap.includes('SUMMARY_OF_BENEFITS') && !typeMap.includes('NON_ENGLISH');
        });
        planSummaryOfBenefitsDocuments?.forEach(document => {
            documentLinks.push({ name: document.linkName, url: document.url });
        });
        // TODO: add more links eventually?
        if (documentLinks.length) {
            let documentLinksHTML = '';
            documentLinks.forEach(link => {
                documentLinksHTML += `<div class='preEnrollment-link-item'><a target="_blank" href='${link.url}'>${link.name}</a></div>`;
            });
            return {
                value: this.createPreEnrollmentStatementModalTableItemName(this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_PlanCompare_PlanDocument_Text', this.widgetName)),
                planBenefitDetails: documentLinksHTML
            };
        }
    }
    // This is next gen/hope supported
    // But for next gen, this only gets us stuff that has been touched, while it can tell us if it exists for hope
    // Returns the answer's value, not an answer object
    getAnswerByFormKey(formKeyName) {
        const answers = this.retrieveFormAnswers(this.childForms);
        return this.enrollmentFormService.findAnswer(answers, formKeyName, null);
    }
    replaceStatementValuePlaceholders(value) {
        return value
            .replaceAll('<enrollingPlanTypeName>', this.plansService.getPlanTypeDescription(this.enrollingPlan.planTypeAbbreviation))
            .replaceAll('<planName>', this.enrollingPlan.planMarketingName ?? this.enrollingPlan.organizationName);
    }
    formHasQuestion(questionName) {
        const existingAnswerValue = this.getAnswerByFormKey(questionName);
        return this.formRootStrategyService.formHasQuestion(questionName, existingAnswerValue, this.nextGenFormQuestionNames);
    }
    handleEditLinkEvent(editField, isNextGenForm) {
        if (editField === EnrollmentFormKeys.APPLICANT_ZIP) {
            this.planFacade.openEditEnrollmentZipModal();
            this.updateGoogleTagEvent(DataLayerEvent.CLICK_ENROLLMENT_EDIT_ZIP);
        }
        else {
            this.openEditFieldModal(editField, isNextGenForm);
            // TODO: if we are making openEditFieldModal generic this data layer event will need to handle more than just state events
            this.updateGoogleTagEvent(DataLayerEvent.CLICK_ENROLLMENT_EDIT_STATE);
        }
    }
    navigateToProviderSearch(options) {
        const { providersEnabled, plan, showProviderSearch, providerURL } = options;
        if (providerURL?.length > 0) {
            this.navigationService.navigate({
                title: '',
                type: LinkType.EXTERNAL,
                href: providerURL
            });
        }
        else if (providersEnabled && showProviderSearch && plan) {
            this.helpfulToolsService.setCurrentTab(HelpfulToolsTabs.Providers);
            this.helpfulToolsService
                .setSelectedHelpfulToolsPlan$(plan)
                // Since we're going to a new tab, we need to wait for the session storage to update, not just the store
                // and so we need a delay 0 to wait for the optimizations made in VnextStorageEngine before navigation
                .pipe(take(1), delay(0))
                .subscribe({
                next: () => {
                    const href = this.navigationUtilityService.constructAbsoluteUrl(PageTags.HELPFUL_TOOLS_PHARMACYSEARCH);
                    this.navigationService.navigate({
                        title: '',
                        type: LinkType.EXTERNAL,
                        href
                    });
                }
            });
        }
    }
    hideProviderSearchQuestions() {
        const planHasProviderURL = this.enrollingPlan?.providerURL?.length > 0;
        const providersEnabled = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_Providers_Enabled', this.widgetName, false);
        const hideProviderSearchQuestions = !planHasProviderURL && !(providersEnabled && this.enrollingPlan?.showProviderSearch);
        if (hideProviderSearchQuestions) {
            this.viewContainer.element.nativeElement.dispatchEvent(new CustomEvent(NextGenEnrollmentEvents.UPDATE_QUESTION_VISIBILITY, {
                bubbles: true,
                detail: [
                    {
                        prop: 'type',
                        value: 'provider-search',
                        visibleIf: providerSearch => !!providerSearch?.getPropertyValue?.('hardcodedUrl')?.length
                    }
                ]
            }));
        }
    }
    addCallBackToProviderURL(originalProviderURL, includeReturnUrl) {
        if (originalProviderURL && includeReturnUrl) {
            const baseSPAUrl = window.location.href.split(PageTags.ENROLLMENT)[0]; // ie 'https://dualpybrokerhamza.qa.destinationrx.com/PC/Agent/'
            const callbackURL = 'a/aux/enrollment/callback/' + this.enrollingPlan.carrierId; // ie 'a/aux/enrollment/callback/372'
            const callbackQSParam = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Enrollment_Callback_QSParam', undefined, 'RETURN_URL');
            const existingQueryParams = originalProviderURL.indexOf('?') > 0;
            const fullQueryParams = `${existingQueryParams ? '&' : '?'}${callbackQSParam}=${baseSPAUrl}${callbackURL}`; // ie '?RETURN_URL=(the above stuff)
            return `${originalProviderURL}${fullQueryParams}`;
        }
        return originalProviderURL || '';
    }
    updateNextGenDynamicScripts() {
        if (this.Spa_DynamicScript_Enabled) {
            const filteredDefinitions = this.Spa_DynamicScript_Defns_Json.find(defns => defns.DynamicScriptId === this.Spa_DynamicScript_Id_Text &&
                defns.PlanYear === this.planYearResourceService.getCurrentPlanYear().toString())?.DynamicScriptTexts ?? [];
            this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.UPDATE_DYNAMIC_SCRIPTS, filteredDefinitions);
        }
    }
};
FormRootComponent.ɵfac = function FormRootComponent_Factory(t) { return new (t || FormRootComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(AgentTaskFacade), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(EnrollmentFormFacade), i0.ɵɵdirectiveInject(SendEnrollmentFacade), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(i1.DemographicService), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(i1.ShoppingCartService), i0.ɵɵdirectiveInject(i1.EnrollmentFormErrorsContext), i0.ɵɵdirectiveInject(i1.ProfileService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(CartFacade), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.MillimanService), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.AuthService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(HelpfulToolsService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.EnrollmentTransactionErrorsContext), i0.ɵɵdirectiveInject(CreateAccountContext), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.TwilioDeviceService), i0.ɵɵdirectiveInject(AgentCallRecordingFacade), i0.ɵɵdirectiveInject(i1.ExternalErrorLoggingService), i0.ɵɵdirectiveInject(i1$2.CurrencyPipe), i0.ɵɵdirectiveInject(FormRootStrategyService), i0.ɵɵdirectiveInject(i1.FormPagesMetadataContext), i0.ɵɵdirectiveInject(FormRootService), i0.ɵɵdirectiveInject(i1.FileDownloadUtilityService), i0.ɵɵdirectiveInject(i1.AddressService), i0.ɵɵdirectiveInject(i1.PlanYearResourceService), i0.ɵɵdirectiveInject(i1.EligibilityCheckValidatorContextService), i0.ɵɵdirectiveInject(i1.GroupValidatorContextService)); };
FormRootComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FormRootComponent, selectors: [["vnext-form-root"]], viewQuery: function FormRootComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$24, 5);
        i0.ɵɵviewQuery(EnrollmentFormRendererComponent, 5);
        i0.ɵɵviewQuery(NextGenEnrollmentFormRendererComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.enrollmentForm = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.hopeChildForms = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nextGenChildForms = _t);
    } }, hostBindings: function FormRootComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("NextGenForm_Before_Survey_View_Initialization", function FormRootComponent_NextGenForm_Before_Survey_View_Initialization_HostBindingHandler($event) { return ctx.onSurveyBeforeViewInitialized($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_After_Survey_View_Initialization", function FormRootComponent_NextGenForm_After_Survey_View_Initialization_HostBindingHandler($event) { return ctx.onSurveyAfterViewInitialized($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_On_After_Page_Rendered", function FormRootComponent_NextGenForm_On_After_Page_Rendered_HostBindingHandler($event) { return ctx.onSurveyAfterPageRendered($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_Form_Rendered", function FormRootComponent_NextGenForm_Form_Rendered_HostBindingHandler($event) { return ctx.checkForQuestions($event); }, false, i0.ɵɵresolveDocument)("NextGenFormClientEvent_Navigate_To_Previous_Page", function FormRootComponent_NextGenFormClientEvent_Navigate_To_Previous_Page_HostBindingHandler($event) { return ctx.clearFormErrors($event); }, false, i0.ɵɵresolveDocument)("SpaCustomEditLinkEvent", function FormRootComponent_SpaCustomEditLinkEvent_HostBindingHandler($event) { return ctx.editLinkClicked($event); })("SpaEnrollmentNextEvent", function FormRootComponent_SpaEnrollmentNextEvent_HostBindingHandler($event) { return ctx.navigateNext($event); }, false, i0.ɵɵresolveDocument)("SpaEnrollmentBackEvent", function FormRootComponent_SpaEnrollmentBackEvent_HostBindingHandler($event) { return ctx.navigateBack($event.target); }, false, i0.ɵɵresolveDocument)("SpaEnrollmentGoToPageEvent", function FormRootComponent_SpaEnrollmentGoToPageEvent_HostBindingHandler($event) { return ctx.navigateToPageName($event); }, false, i0.ɵɵresolveDocument)("SpaEnrollmentMissingDataEvent", function FormRootComponent_SpaEnrollmentMissingDataEvent_HostBindingHandler($event) { return ctx.onMissingEnrollmentData($event.target); }, false, i0.ɵɵresolveDocument)("SpaInputBlurEvent", function FormRootComponent_SpaInputBlurEvent_HostBindingHandler($event) { return ctx.onInputBlur($event); })("SpaProviderLinkEvent", function FormRootComponent_SpaProviderLinkEvent_HostBindingHandler($event) { return ctx.hopeOnClickProviderLink($event); })("NextGenForm_Provider_Search_Navigation", function FormRootComponent_NextGenForm_Provider_Search_Navigation_HostBindingHandler($event) { return ctx.nextGenOnClickProviderLink($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_Emit_FormInfo", function FormRootComponent_NextGenForm_Emit_FormInfo_HostBindingHandler($event) { return ctx.setFormPageInfo($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_Emit_PageErrors", function FormRootComponent_NextGenForm_Emit_PageErrors_HostBindingHandler($event) { return ctx.setFormPageErrors($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_Edit_MedSup_Rate_Factor_Event", function FormRootComponent_NextGenForm_Edit_MedSup_Rate_Factor_Event_HostBindingHandler($event) { return ctx.nextgenEditLinkClicked($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_Edit_Link_Zip_Code_Event", function FormRootComponent_NextGenForm_Edit_Link_Zip_Code_Event_HostBindingHandler($event) { return ctx.nextgenEditLinkClicked($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_Upload_Files_Request", function FormRootComponent_NextGenForm_Upload_Files_Request_HostBindingHandler($event) { return ctx.nextgenUploadFiles($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_Delete_Uploaded_Files_Request", function FormRootComponent_NextGenForm_Delete_Uploaded_Files_Request_HostBindingHandler($event) { return ctx.nextgenDeleteUploadedFile($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_Download_File_Request", function FormRootComponent_NextGenForm_Download_File_Request_HostBindingHandler($event) { return ctx.nextgenDownloadFile($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_Address_Autocomplete_Request", function FormRootComponent_NextGenForm_Address_Autocomplete_Request_HostBindingHandler($event) { return ctx.nextgenAutocompleteAddress($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_Update_Via_Query_Params_Event", function FormRootComponent_NextGenForm_Update_Via_Query_Params_Event_HostBindingHandler($event) { return ctx.updateViAQueryParams($event); })("NextGenForm_Question_Value_Changed", function FormRootComponent_NextGenForm_Question_Value_Changed_HostBindingHandler($event) { return ctx.nextGenQuestionValueChanged($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_Enrollment_Go_To_Page", function FormRootComponent_NextGenForm_Enrollment_Go_To_Page_HostBindingHandler($event) { return ctx.nextGenNavigateToPageName($event); }, false, i0.ɵɵresolveDocument);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["formErrorState", ""], [4, "ngIf"], [1, "px-3"], ["class", "Spa_Style_Paragraph text-center text-md-right", 4, "ngIf"], [3, "showNext", "showSubmit", "showPrevious", "showSendApplicationEmail", "showContinueToVoiceSignatureText", "showContinueToAuthorizationCodeSignatureText", "isVoiceSignatureComplete", "isAuthorizationCodeSignatureComplete", "previousButtonText", "nextButtonText", "submitButtonText", "sendApplicationButtonText", "enrollSubmitTooltipText", "continueToVoiceSignatureText", "voiceSignatureCompletedText", "continueToAuthorizationCodeText", "authorizationCodeCompletedText", "showSave", "saveText", "backEvent", "nextEvent", "submitEvent", "showModalEvent", "closeTooltipEvent", "saveEvent", "continueToVoiceSignature", "continueToAuthorizationCodeSignature"], [3, "existingMemberTitleText", "existingMemberBodyText", "existingMemberButtonText", "newMemberTitleText", "newMemberBodyText", "newMemberButtonText", "planId"], [3, "surveyInitialized"], ["enrollmentForm", ""], [1, "Spa_Style_Paragraph", "text-center", "text-md-right"], [1, "text-center", "mt-3", "Spa_Style_Primary_Color"], [1, "mb-3", "fas", "fa-ban", "icon", "Spa_Style_Accent1_Color", "error-state-icon"], [3, "innerHTML"]], template: function FormRootComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, FormRootComponent_ng_container_0_Template, 9, 27, "ng-container", 0);
        i0.ɵɵtemplate(1, FormRootComponent_ng_template_1_Template, 3, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", !ctx.enrollmentFormError)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgIf, EnrollmentFormNavigationComponent, IconAriaAttributesDirective, EnrollmentFormRendererComponent, NextGenEnrollmentFormRendererComponent, ExistingMemberFormComponent, i1$2.AsyncPipe], styles: [".error-state-icon[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Gray2);display:block;font-size:48px}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_Site_UnableToProcessErrorsTitle_Text", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_Site_UnableToProcessErrorsMessage_Text", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_Enrollment_ExistingMemberPromptTitle_Text", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_Enrollment_ExistingMemberPromptBody_Text", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_Enrollment_ExistingMemberPromptButton_Text", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_Enrollment_NewMemberPromptTitle_Text", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_Enrollment_NewMemberPromptBody_Text", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_Enrollment_NewMemberPromptButton_Text", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_Enrollment_ShowExistingMemberPromptOnEnrollment_Flag", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_Enrollment_PlanNotInCartError_Html", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_SendEnrollment_ContinueApplying_Text", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_SendEnrollment_CrossSell_MedSupPlanText", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_SendEnrollment_CrossSell_PDPPlanText", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_Enrollment_SaveProgress_Enabled", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_Site_Loader_Message_Json", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_Enrollment_ContinueToVoiceSignature_Enabled", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_PreEnrollmentStatements_Enrollment_Enabled", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_PreEnrollmentStatements_WhitelistedBenefits_JSON", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_Site_TotalSiteCountsPPC_Enabled", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_PreEnrollmentStatements_ReturnFromModal_URL", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_Enrollment_ContinueToAuthorizationCodeSignature_Enabled", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_DynamicScript_Enabled", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_DynamicScript_Id_Text", void 0);
__decorate([
    GlobalResource()
], FormRootComponent.prototype, "Spa_DynamicScript_Defns_Json", void 0);
__decorate([
    Memoize()
], FormRootComponent.prototype, "createPreEnrollmentStatementModalTableItemName", null);
FormRootComponent = __decorate([
    PlatformWidget
], FormRootComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormRootComponent, [{
        type: Component,
        args: [{ selector: 'vnext-form-root', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<ng-container *ngIf=\"!enrollmentFormError; else formErrorState\">\r\n  <ng-container *ngIf=\"showExistingMemberForm\">\r\n    <vnext-existing-member-form\r\n      [existingMemberTitleText]=\"Spa_Enrollment_ExistingMemberPromptTitle_Text\"\r\n      [existingMemberBodyText]=\"Spa_Enrollment_ExistingMemberPromptBody_Text\"\r\n      [existingMemberButtonText]=\"Spa_Enrollment_ExistingMemberPromptButton_Text\"\r\n      [newMemberTitleText]=\"Spa_Enrollment_NewMemberPromptTitle_Text\"\r\n      [newMemberBodyText]=\"Spa_Enrollment_NewMemberPromptBody_Text\"\r\n      [newMemberButtonText]=\"Spa_Enrollment_NewMemberPromptButton_Text\"\r\n      [planId]=\"enrollingPlanId\"\r\n    ></vnext-existing-member-form>\r\n  </ng-container>\r\n\r\n  <div class=\"px-3\">\r\n    <ng-container *ngIf=\"planHasNextGenForm\">\r\n      <nextgen-enrollment-form-renderer [surveyInitialized]=\"surveyInitialized\"></nextgen-enrollment-form-renderer>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"!planHasNextGenForm\">\r\n      <vnext-enrollment-form #enrollmentForm *ngIf=\"pageName\"> </vnext-enrollment-form>\r\n    </ng-container>\r\n  </div>\r\n  <!-- Send enrollment to beneficiary restricted message -->\r\n  <div *ngIf=\"sendEnrollmentFacade.isPlanRestricted(plan$ | async) && showSubmit()\" class=\"Spa_Style_Paragraph text-center text-md-right\">\r\n    {{ sendEnrollmentFacade.getRestrictProfessionalPlansNavBarMessage() }}\r\n  </div>\r\n  <vnext-enrollment-form-navigation\r\n    [showNext]=\"showNext()\"\r\n    [showSubmit]=\"showSubmit()\"\r\n    [showPrevious]=\"showBack()\"\r\n    [showSendApplicationEmail]=\"showAgentSendToBeneficiaryEmail()\"\r\n    [showContinueToVoiceSignatureText]=\"showContinueToVoiceSignatureText()\"\r\n    [showContinueToAuthorizationCodeSignatureText]=\"showContinueToAuthorizationCodeSignatureText\"\r\n    [isVoiceSignatureComplete]=\"isVoiceSignatureComplete\"\r\n    [isAuthorizationCodeSignatureComplete]=\"isAuthorizationCodeSignatureComplete\"\r\n    [previousButtonText]=\"previousText\"\r\n    [nextButtonText]=\"nextText\"\r\n    [submitButtonText]=\"submitText\"\r\n    [sendApplicationButtonText]=\"sendEnrollmentApplicationButtonText\"\r\n    [enrollSubmitTooltipText]=\"enrollmentPermissionDeniedTooltipText\"\r\n    [continueToVoiceSignatureText]=\"continueToVoiceSignatureText\"\r\n    [voiceSignatureCompletedText]=\"voiceSignatureCompletedText\"\r\n    [continueToAuthorizationCodeText]=\"continueToAuthorizationCodeText\"\r\n    [authorizationCodeCompletedText]=\"authorizationCodeCompletedText\"\r\n    [showSave]=\"showSave$ | async\"\r\n    [saveText]=\"saveText\"\r\n    (backEvent)=\"back()\"\r\n    (nextEvent)=\"next()\"\r\n    (submitEvent)=\"onSubmit($event)\"\r\n    (showModalEvent)=\"showSendEnrollmentModal()\"\r\n    (closeTooltipEvent)=\"closeEnrollmentTooltip($event)\"\r\n    (saveEvent)=\"showCreateAccount()\"\r\n    (continueToVoiceSignature)=\"continueToVoiceSignature()\"\r\n    (continueToAuthorizationCodeSignature)=\"continueToAuthorizationCodeSignature()\"\r\n  ></vnext-enrollment-form-navigation>\r\n</ng-container>\r\n<ng-template #formErrorState\r\n  ><div class=\"text-center mt-3 Spa_Style_Primary_Color\">\r\n    <i class=\"mb-3 fas fa-ban icon Spa_Style_Accent1_Color error-state-icon\"></i>\r\n    <div [innerHTML]=\"Spa_Enrollment_PlanNotInCartError_Html\"></div>\r\n  </div>\r\n</ng-template>\r\n", styles: [".error-state-icon{color:var(--static-Spa_Style_Gray2);display:block;font-size:48px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: AgentTaskFacade }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: EnrollmentFormFacade }, { type: SendEnrollmentFacade }, { type: i1.SiteService }, { type: i1.EnrollmentFormService }, { type: i2$1.ActivatedRoute }, { type: i0.ViewContainerRef }, { type: i1$1.NgbModal }, { type: i1.DemographicService }, { type: i1.PlansService }, { type: i1.ShoppingCartService }, { type: i1.EnrollmentFormErrorsContext }, { type: i1.ProfileService }, { type: i1.MemberSessionService }, { type: CartFacade }, { type: i1.LocaleService }, { type: i1.MillimanService }, { type: i1.NavigationUtilityService }, { type: PlanFacade }, { type: i1.AuthService }, { type: i1.SpinnerService }, { type: HelpfulToolsService }, { type: i1.NavigationService }, { type: i1.EnrollmentTransactionErrorsContext }, { type: CreateAccountContext }, { type: AnalyticsService }, { type: i1.TwilioDeviceService }, { type: AgentCallRecordingFacade }, { type: i1.ExternalErrorLoggingService }, { type: i1$2.CurrencyPipe }, { type: FormRootStrategyService }, { type: i1.FormPagesMetadataContext }, { type: FormRootService }, { type: i1.FileDownloadUtilityService }, { type: i1.AddressService }, { type: i1.PlanYearResourceService }, { type: i1.EligibilityCheckValidatorContextService }, { type: i1.GroupValidatorContextService }]; }, { hopeChildForms: [{
            type: ViewChildren,
            args: [EnrollmentFormRendererComponent]
        }], nextGenChildForms: [{
            type: ViewChildren,
            args: [NextGenEnrollmentFormRendererComponent]
        }], enrollmentForm: [{
            type: ViewChild,
            args: ['enrollmentForm']
        }], Spa_Site_UnableToProcessErrorsTitle_Text: [], Spa_Site_UnableToProcessErrorsMessage_Text: [], Spa_Enrollment_ExistingMemberPromptTitle_Text: [], Spa_Enrollment_ExistingMemberPromptBody_Text: [], Spa_Enrollment_ExistingMemberPromptButton_Text: [], Spa_Enrollment_NewMemberPromptTitle_Text: [], Spa_Enrollment_NewMemberPromptBody_Text: [], Spa_Enrollment_NewMemberPromptButton_Text: [], Spa_Enrollment_ShowExistingMemberPromptOnEnrollment_Flag: [], Spa_Enrollment_PlanNotInCartError_Html: [], Spa_SendEnrollment_ContinueApplying_Text: [], Spa_SendEnrollment_CrossSell_MedSupPlanText: [], Spa_SendEnrollment_CrossSell_PDPPlanText: [], Spa_Enrollment_SaveProgress_Enabled: [], Spa_Site_Loader_Message_Json: [], Spa_Enrollment_ContinueToVoiceSignature_Enabled: [], Spa_PreEnrollmentStatements_Enrollment_Enabled: [], Spa_PreEnrollmentStatements_WhitelistedBenefits_JSON: [], Spa_Site_TotalSiteCountsPPC_Enabled: [], Spa_PreEnrollmentStatements_ReturnFromModal_URL: [], Spa_Enrollment_ContinueToAuthorizationCodeSignature_Enabled: [], Spa_DynamicScript_Enabled: [], Spa_DynamicScript_Id_Text: [], Spa_DynamicScript_Defns_Json: [], onSurveyBeforeViewInitialized: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.SURVEY_BEFORE_VIEW_INITIALIZED}`, ['$event']]
        }], onSurveyAfterViewInitialized: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.SURVEY_AFTER_VIEW_INITIALIZED}`, ['$event']]
        }], onSurveyAfterPageRendered: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.SURVEY_AFTER_PAGE_RENDERED}`, ['$event']]
        }], checkForQuestions: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.FORM_RENDERED}`, ['$event']]
        }], clearFormErrors: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.NAVIGATE_PREVIOUS_PAGE}`, ['$event']]
        }], editLinkClicked: [{
            type: HostListener,
            args: [`${CustomFOAMEvents.EDIT_LINK_EVENT}`, ['$event']]
        }], navigateNext: [{
            type: HostListener,
            args: [`document:${CustomFOAMEvents.ENROLLMENT_NEXT}`, ['$event']]
        }], navigateBack: [{
            type: HostListener,
            args: [`document:${CustomFOAMEvents.ENROLLMENT_BACK}`, ['$event.target']]
        }], navigateToPageName: [{
            type: HostListener,
            args: [`document:${CustomFOAMEvents.ENROLLMENT_GO_TO_PAGE}`, ['$event']]
        }], onMissingEnrollmentData: [{
            type: HostListener,
            args: [`document:${CustomFOAMEvents.MISSING_ENROLLMENT_DATA}`, ['$event.target']]
        }], onInputBlur: [{
            type: HostListener,
            args: [`${CustomFOAMEvents.INPUT_BLUR}`, ['$event']]
        }], hopeOnClickProviderLink: [{
            type: HostListener,
            args: [`${CustomFOAMEvents.ENROLLMENT_PROVIDER_LINK_EVENT}`, ['$event']]
        }], nextGenOnClickProviderLink: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.PROVIDER_SEARCH_NAVIGATION}`, ['$event']]
        }], setFormPageInfo: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.FORM_INFO}`, ['$event']]
        }], setFormPageErrors: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.PAGE_ERRORS}`, ['$event']]
        }], nextgenEditLinkClicked: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.EDIT_MEDSUP_RATE_FACTOR}`, ['$event']]
        }, {
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.EDIT_ZIP_CODE}`, ['$event']]
        }], nextgenUploadFiles: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.UPLOAD_FILES}`, ['$event']]
        }], nextgenDeleteUploadedFile: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.DELETE_UPLOADED_FILES}`, ['$event']]
        }], nextgenDownloadFile: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.DOWNLOAD_FILE}`, ['$event']]
        }], nextgenAutocompleteAddress: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.ADDRESS_AUTOCOMPLETE_REQUEST}`, ['$event']]
        }], updateViAQueryParams: [{
            type: HostListener,
            args: [`${NextGenEnrollmentEvents.UPDATE_VIA_QUERY_PARAMS}`, ['$event']]
        }], nextGenQuestionValueChanged: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.VALUE_CHANGED}`, ['$event']]
        }], nextGenNavigateToPageName: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.ENROLLMENT_GO_TO_PAGE}`, ['$event']]
        }], createPreEnrollmentStatementModalTableItemName: [] }); })();

const collapsibleList = trigger('collapsibleListTrigger', [
    transition(
    // transforming from any state to shown, will play on page load
    '* => show', [
        query('.list-item-container', [
            // starting style state
            style({ height: '0px', opacity: 0 }),
            // plays animations in sequence with a 0ms delay between
            stagger(0, [
                // animation times matter, these aren't being ignored, but they also aren't being shown
                animate('0.0s ease-out', style({ height: '*' })),
                animate('0.0s ease-out', style({ opacity: 1 }))
            ])
        ])
    ], { params: { startHeight: 0 } }),
    transition(
    // trasnforming from show to hide state
    'show => hide', [
        query('.list-item-container', [
            stagger(0, [animate('0.25s ease-out', style({ opacity: 0 })), animate('0.5s ease-out', style({ height: '0px' }))])
        ])
    ], { params: { startHeight: 0 } }),
    // style state for when transition to hide is finished
    state('hide', style({ height: '0px', opacity: 0 }))
]);

function EnrollmentInformationComponent_div_14_ng_container_1_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-link", 14);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const document_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("href", document_r10.url)("alwaysUnderlined", true)("title", document_r10.linkName)("linkTarget", "_blank");
} }
function EnrollmentInformationComponent_div_14_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EnrollmentInformationComponent_div_14_ng_container_1_ng_container_1_ng_container_1_ng_container_1_Template, 2, 4, "ng-container", 10);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const document_r10 = ctx.$implicit;
    const ctx_r9 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.displayDocumentLink(document_r10));
} }
function EnrollmentInformationComponent_div_14_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EnrollmentInformationComponent_div_14_ng_container_1_ng_container_1_ng_container_1_Template, 2, 1, "ng-container", 13);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r8.plan.documents);
} }
function EnrollmentInformationComponent_div_14_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EnrollmentInformationComponent_div_14_ng_container_1_ng_container_1_Template, 2, 1, "ng-container", 10);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.plan.documents == null ? null : ctx_r7.plan.documents.length);
} }
function EnrollmentInformationComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, EnrollmentInformationComponent_div_14_ng_container_1_Template, 2, 1, "ng-container", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.plan);
} }
function EnrollmentInformationComponent_div_15_div_1_vnext_link_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-link", 17);
} if (rf & 2) {
    const link_r14 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("tag", link_r14.tag)("title", link_r14.title)("alwaysUnderlined", true)("linkTarget", "_blank");
} }
function EnrollmentInformationComponent_div_15_div_1_vnext_link_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-link", 18);
} if (rf & 2) {
    const link_r14 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", link_r14.href)("title", link_r14.title)("alwaysUnderlined", true)("linkTarget", "_blank");
} }
function EnrollmentInformationComponent_div_15_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, EnrollmentInformationComponent_div_15_div_1_vnext_link_1_Template, 1, 4, "vnext-link", 15);
    i0.ɵɵtemplate(2, EnrollmentInformationComponent_div_15_div_1_vnext_link_2_Template, 1, 4, "vnext-link", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r14 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", link_r14.tag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", link_r14.href);
} }
function EnrollmentInformationComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, EnrollmentInformationComponent_div_15_div_1_Template, 3, 2, "div", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.Spa_Enrollment_InformationLinks_Links);
} }
function EnrollmentInformationComponent_ng_container_16_ng_container_1_div_1_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c0$23 = function (a0, a1) { return { content: a0, name: a1 }; };
function EnrollmentInformationComponent_ng_container_16_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, EnrollmentInformationComponent_ng_container_16_ng_container_1_div_1_ng_container_9_Template, 1, 0, "ng-container", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const broker_r22 = ctx.ngIf;
    const ctx_r21 = i0.ɵɵnextContext(3);
    const _r5 = i0.ɵɵreference(20);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", broker_r22.firstName, " ", broker_r22.lastName, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(broker_r22.address1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(broker_r22.address2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3(" ", broker_r22.city, " ", broker_r22.state, " ", broker_r22.zip, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", i0.ɵɵpureFunction2(9, _c0$23, ctx_r21.agentPhoneNumber, broker_r22.fullName));
} }
function EnrollmentInformationComponent_ng_container_16_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EnrollmentInformationComponent_ng_container_16_ng_container_1_div_1_Template, 10, 12, "div", 11);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r19.Spa_Enrollment_OtherMethods_ShowBroker && ctx_r19.broker$));
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_ng_container_1_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r36.plan.carrierInformation.carrierAddress.city, ", ");
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_ng_container_1_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r37.plan.carrierInformation.carrierAddress.state, " ");
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_ng_container_1_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r38.plan.carrierInformation.carrierAddress.zip, " ");
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 30)(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵtemplate(9, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_ng_container_1_span_9_Template, 2, 1, "span", 10);
    i0.ɵɵtemplate(10, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_ng_container_1_span_10_Template, 2, 1, "span", 10);
    i0.ɵɵtemplate(11, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_ng_container_1_span_11_Template, 2, 1, "span", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r30.Spa_Enrollment_Address_Text);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r30.plan.carrierInformation.carrierAddress.address1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r30.plan.carrierInformation.carrierAddress.address2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r30.plan.carrierInformation.carrierAddress.city);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r30.plan.carrierInformation.carrierAddress.state);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r30.plan.carrierInformation.carrierAddress.zip);
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_div_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_div_2_ng_container_3_Template, 1, 0, "ng-container", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(5);
    const _r5 = i0.ɵɵreference(20);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r31.Spa_Enrollment_Phone_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", i0.ɵɵpureFunction2(3, _c0$23, ctx_r31.plan.carrierInformation.phone, ctx_r31.plan.organizationName));
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_div_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "phone");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, ctx_r40.plan.carrierInformation.fax, ctx_r40.countryCode), " ");
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_div_3_div_3_Template, 3, 4, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r32.Spa_Enrollment_Fax_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r32.countryCode);
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_div_4_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtemplate(4, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_div_4_ng_container_4_Template, 1, 0, "ng-container", 22);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(5);
    const _r5 = i0.ɵɵreference(20);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r33.Spa_Enrollment_TTY_Members_Text);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", i0.ɵɵpureFunction2(3, _c0$23, ctx_r33.plan.carrierInformation.phoneMemberTTY, ctx_r33.plan.organizationName));
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_div_5_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_div_5_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_div_5_div_3_ng_container_1_Template, 1, 0, "ng-container", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(6);
    const _r5 = i0.ɵɵreference(20);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c0$23, ctx_r42.plan.carrierInformation.phoneNonMemberTTY, ctx_r42.plan.organizationName));
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_div_5_div_3_Template, 2, 5, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r34.Spa_Enrollment_TTY_NonMembers_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r34.countryCode);
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r35.Spa_Enrollment_Hours_Text);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r35.plan.carrierInformation.hours);
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_ng_container_1_Template, 12, 6, "ng-container", 10);
    i0.ɵɵtemplate(2, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_div_2_Template, 4, 6, "div", 10);
    i0.ɵɵtemplate(3, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_div_3_Template, 4, 2, "div", 28);
    i0.ɵɵtemplate(4, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_div_4_Template, 5, 6, "div", 10);
    i0.ɵɵtemplate(5, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_div_5_Template, 4, 2, "div", 10);
    i0.ɵɵtemplate(6, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_div_6_Template, 5, 2, "div", 10);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r29.plan.carrierInformation.carrierAddress.address1 || ctx_r29.plan.carrierInformation.carrierAddress.address2 || ctx_r29.plan.carrierInformation.carrierAddress.city || ctx_r29.plan.carrierInformation.carrierAddress.state || ctx_r29.plan.carrierInformation.carrierAddress.zip);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r29.plan.carrierInformation.phone);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r29.plan.carrierInformation.fax);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r29.Spa_Enrollment_TTY_Members_Text_Enabled && ctx_r29.plan.carrierInformation.phoneMemberTTY);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r29.Spa_Enrollment_TTY_NonMembers_Text_Enabled && ctx_r29.plan.carrierInformation.phoneNonMemberTTY);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r29.plan.carrierInformation.hours);
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_ng_container_0_Template, 7, 6, "ng-container", 10);
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r26.plan.carrierInformation);
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_ng_container_1_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r50.plan.planEnrollmentInfo.city, ", ");
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_ng_container_1_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r51 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r51.plan.planEnrollmentInfo.state, " ");
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_ng_container_1_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r52.plan.planEnrollmentInfo.zip, " ");
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 30)(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵtemplate(9, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_ng_container_1_span_9_Template, 2, 1, "span", 10);
    i0.ɵɵtemplate(10, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_ng_container_1_span_10_Template, 2, 1, "span", 10);
    i0.ɵɵtemplate(11, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_ng_container_1_span_11_Template, 2, 1, "span", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r45.Spa_Enrollment_Address_Text);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r45.plan.planEnrollmentInfo.address1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r45.plan.planEnrollmentInfo.address2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r45.plan.planEnrollmentInfo.city);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r45.plan.planEnrollmentInfo.state);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r45.plan.planEnrollmentInfo.zip);
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_div_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_div_2_ng_container_3_Template, 1, 0, "ng-container", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(5);
    const _r5 = i0.ɵɵreference(20);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r46.Spa_Enrollment_Phone_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", i0.ɵɵpureFunction2(3, _c0$23, ctx_r46.plan.planEnrollmentInfo.businessPhone, ctx_r46.plan.organizationName));
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_div_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "phone");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, ctx_r54.plan.planEnrollmentInfo.fax, ctx_r54.countryCode), " ");
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_div_3_div_3_Template, 3, 4, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r47.Spa_Enrollment_Fax_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r47.countryCode);
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_div_4_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtemplate(4, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_div_4_ng_container_4_Template, 1, 0, "ng-container", 22);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(5);
    const _r5 = i0.ɵɵreference(20);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r48.Spa_Enrollment_TTY_Text);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", i0.ɵɵpureFunction2(3, _c0$23, ctx_r48.plan.planEnrollmentInfo.ttyPhone, ctx_r48.plan.organizationName));
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r49.Spa_Enrollment_Hours_Text);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r49.plan.planEnrollmentInfo.hours);
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_ng_container_1_Template, 12, 6, "ng-container", 10);
    i0.ɵɵtemplate(2, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_div_2_Template, 4, 6, "div", 10);
    i0.ɵɵtemplate(3, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_div_3_Template, 4, 2, "div", 28);
    i0.ɵɵtemplate(4, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_div_4_Template, 5, 6, "div", 10);
    i0.ɵɵtemplate(5, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_div_5_Template, 5, 2, "div", 10);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r44.plan.planEnrollmentInfo.address1 || ctx_r44.plan.planEnrollmentInfo.address2 || ctx_r44.plan.planEnrollmentInfo.city || ctx_r44.plan.planEnrollmentInfo.state || ctx_r44.plan.planEnrollmentInfo.zip);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r44.plan.planEnrollmentInfo.businessPhone);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r44.plan.planEnrollmentInfo.fax);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r44.plan.planEnrollmentInfo.ttyPhone);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r44.plan.planEnrollmentInfo.hours);
} }
function EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_ng_container_0_Template, 6, 5, "ng-container", 10);
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r28.plan.planEnrollmentInfo);
} }
function EnrollmentInformationComponent_ng_container_16_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23)(1, "div", 24);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, EnrollmentInformationComponent_ng_container_16_div_3_ng_container_3_Template, 1, 0, "ng-container", 25);
    i0.ɵɵtemplate(4, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_4_Template, 1, 1, "ng-template", null, 26, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(6, EnrollmentInformationComponent_ng_container_16_div_3_ng_template_6_Template, 1, 1, "ng-template", null, 27, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r25 = i0.ɵɵreference(5);
    const _r27 = i0.ɵɵreference(7);
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r20.plan.organizationName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r20.plan.planType === ctx_r20.planType.MEDIGAP)("ngIfThen", _r25)("ngIfElse", _r27);
} }
function EnrollmentInformationComponent_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EnrollmentInformationComponent_ng_container_16_ng_container_1_Template, 3, 3, "ng-container", 10);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, EnrollmentInformationComponent_ng_container_16_div_3_Template, 8, 4, "div", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r2.showAgentMiniCart$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.Spa_Enrollment_OtherMethods_ShowCarrier);
} }
function EnrollmentInformationComponent_div_17_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function EnrollmentInformationComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, EnrollmentInformationComponent_div_17_ng_container_9_Template, 1, 0, "ng-container", 22);
    i0.ɵɵelementStart(10, "div");
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(20);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.Spa_Site_ClientLocation.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.Spa_Site_ClientLocation.address1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.Spa_Site_ClientLocation.address2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3("", ctx_r3.Spa_Site_ClientLocation.city, ", ", ctx_r3.Spa_Site_ClientLocation.state, " ", ctx_r3.Spa_Site_ClientLocation.zipCode, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r5)("ngTemplateOutletContext", i0.ɵɵpureFunction2(9, _c0$23, ctx_r3.Spa_Site_ClientLocation.phoneNumber, ctx_r3.Spa_Site_ClientLocation.title));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.Spa_Site_ClientLocation.hours);
} }
function EnrollmentInformationComponent_18_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 31);
} if (rf & 2) {
    const ctx_r57 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerText", ctx_r57.bodyText(ctx_r57.plan.planName));
} }
function EnrollmentInformationComponent_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, EnrollmentInformationComponent_18_ng_template_0_Template, 1, 1, "ng-template");
} }
function EnrollmentInformationComponent_ng_template_19_ng_container_0_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 34);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "phone");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r64 = i0.ɵɵnextContext(2);
    const content_r58 = ctx_r64.content;
    const name_r59 = ctx_r64.name;
    const ctx_r61 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate1("href", "tel:", content_r58, "", i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("aria-label", name_r59 + ": " + content_r58);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 3, content_r58, ctx_r61.countryCode), " ");
} }
function EnrollmentInformationComponent_ng_template_19_ng_container_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "phone");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const content_r58 = i0.ɵɵnextContext(2).content;
    const ctx_r63 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, content_r58, ctx_r63.countryCode), " ");
} }
function EnrollmentInformationComponent_ng_template_19_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EnrollmentInformationComponent_ng_template_19_ng_container_0_a_1_Template, 3, 6, "a", 32);
    i0.ɵɵtemplate(2, EnrollmentInformationComponent_ng_template_19_ng_container_0_ng_template_2_Template, 3, 4, "ng-template", null, 33, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r62 = i0.ɵɵreference(3);
    const ctx_r60 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r60.isMobile)("ngIfElse", _r62);
} }
function EnrollmentInformationComponent_ng_template_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, EnrollmentInformationComponent_ng_template_19_ng_container_0_Template, 4, 2, "ng-container", 10);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r6.countryCode);
} }
const _c1$Y = function (a0, a1) { return { "fa-angle-up": a0, "fa-angle-down": a1 }; };
const _c2$D = function (a0) { return { invisible: a0 }; };
let EnrollmentInformationComponent = class EnrollmentInformationComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, enrollmentFormService, phoneService, localeService, shoppingCartService, plansService, spinnerService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.enrollmentFormService = enrollmentFormService;
        this.phoneService = phoneService;
        this.localeService = localeService;
        this.shoppingCartService = shoppingCartService;
        this.plansService = plansService;
        this.spinnerService = spinnerService;
        this.Spa_Enrollment_InformationPlanLink_Text = 'Summary of benefits';
        this.Spa_Enrollment_InformationPlanLink_Enabled = true;
        this.Spa_Enrollment_InformationLinks_Links = [];
        this.Spa_Enrollment_InformationLinks_Enabled = true;
        this.Spa_Enrollment_OtherMethodsHeader_Text = 'Other enrollment methods';
        this.Spa_Enrollment_OtherMethodsBody_Text = `Medicare beneficiaries may enroll in <plan>
   through the CMS Medicare Online Enrollment center located at www.medicare.gov`;
        this.Spa_Site_SingleCarrier = true;
        this.Spa_Site_SiteType = 'consumer';
        this.Spa_Enrollment_OtherMethods_ShowBroker = true;
        this.Spa_Enrollment_OtherMethods_ShowCarrier = true;
        this.Spa_Enrollment_OtherMethods_ShowBody = true;
        this.Spa_Enrollment_OtherMethods_ShowClient = false;
        this.Spa_Enrollment_InformationMenu_Text = 'Need help?';
        this.Spa_Enrollment_Address_Text = 'Address';
        this.Spa_Enrollment_Phone_Text = 'Phone';
        this.Spa_Enrollment_Fax_Text = 'Fax';
        this.Spa_Enrollment_TTY_Text = 'TTY';
        this.Spa_Enrollment_TTY_Members_Text_Enabled = true;
        this.Spa_Enrollment_TTY_Members_Text = 'TTY Members';
        this.Spa_Enrollment_TTY_NonMembers_Text_Enabled = true;
        this.Spa_Enrollment_TTY_NonMembers_Text = 'TTY Non-Members';
        this.Spa_Enrollment_Hours_Text = 'Hours';
        this.subscriptions = new Subscription();
        this.showInformation = true;
        this.enrollmentLinkIdentifier = 'DISPLAY_ON_ENROLLMENT';
        this.planType = PlanType;
        this.isMobile = false;
        this.collapseStringPrepend = "Collapse ";
        this.expandStringPrepend = "Expand ";
        this.sectionStringAppend = " section";
    }
    ngOnInit() {
        super.ngOnInit();
        const activeEnrollmentKey = this.enrollmentFormService.getActiveEnrollmentKey();
        this.subscriptions.add(this.configurableWidgetService.store.select(ShoppingCartState.selectedPlanById(activeEnrollmentKey)).subscribe({
            next: (plan) => {
                this.plan = plan;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.broker$.subscribe({
            next: broker => {
                this.agentPhoneNumber = this.phoneService.parsePhoneNumberWithExtension(broker?.phoneNumber, broker?.ext);
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.localeService.getCountryCode$.subscribe({
            next: countryCode => {
                if (countryCode) {
                    this.countryCode = countryCode;
                }
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.localeService
            .getCurrentLocale$()
            .pipe(skip(1))
            .subscribe({
            next: () => {
                this.shoppingCartService.rehydrateCartPlanInfo();
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.plansService.getPlansStateIsLoading$(this.plan?.planType).subscribe({
            next: loading => {
                loading ? this.spinnerService.show(SpinnerEvent.PLANS_LOADING) : this.spinnerService.hide(SpinnerEvent.PLANS_LOADING);
            }
        }));
        this.subscriptions.add(this.isMobile$.subscribe({
            next: isMobile => {
                this.isMobile = isMobile;
                this.cdr.markForCheck();
            }
        }));
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
    displayDocumentLink(planDocument) {
        return planDocument?.types && planDocument.types.findIndex(type => type.name === this.enrollmentLinkIdentifier) > -1;
    }
    bodyText(planName) {
        return this.Spa_Enrollment_OtherMethodsBody_Text
            ? this.Spa_Enrollment_OtherMethodsBody_Text.replace('<plan>', planName.toLowerCase())
            : '';
    }
};
EnrollmentInformationComponent.ɵfac = function EnrollmentInformationComponent_Factory(t) { return new (t || EnrollmentInformationComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(i1.PhoneUtilityService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.ShoppingCartService), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(i1.SpinnerService)); };
EnrollmentInformationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EnrollmentInformationComponent, selectors: [["vnext-enrollment-information"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 21, vars: 17, consts: [[1, "container", "pl-3", "pr-3"], ["role", "button", 1, "enrollment-information-header", "mt-2", "d-md-none", 3, "click", "keyup.enter"], [1, "Spa_Style_H4"], [1, "px-4", "toggle-cart-button", "d-md-none"], [1, "fa", 3, "ngClass"], [1, "sr-only"], [1, "animation-container", 3, "collapsibleList"], [1, "list-item-container", 3, "ngClass"], [1, "mt-3"], [1, "Spa_Style_Note"], [4, "ngIf"], ["class", "body mt-3 Spa_Style_Note no-translate-block", 4, "ngIf"], ["phoneLinks", ""], [4, "ngFor", "ngForOf"], [3, "href", "alwaysUnderlined", "title", "linkTarget"], [3, "tag", "title", "alwaysUnderlined", "linkTarget", 4, "ngIf"], [3, "href", "title", "alwaysUnderlined", "linkTarget", 4, "ngIf"], [3, "tag", "title", "alwaysUnderlined", "linkTarget"], [3, "href", "title", "alwaysUnderlined", "linkTarget"], ["class", "body mt-3 Spa_Style_Note", 4, "ngIf"], [1, "body", "mt-3", "Spa_Style_Note", "no-translate-block"], [1, "Spa_Style_H5_Note"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "body", "mt-3", "Spa_Style_Note"], [1, "Spa_Style_H5_Note", "mb-1"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["medigapCarrierInfo", ""], ["enrollCarrierInfo", ""], ["class", "Spa_Style_Note", 4, "ngIf"], [1, "Spa_Style_Bold_Weight"], [1, "no-translate-block"], [1, "mt-3", "Spa_Style_Note", "no-translate-block", 3, "innerText"], ["class", "Spa_Style_Primary_Link_Color text-underline", 3, "href", 4, "ngIf", "ngIfElse"], ["showPhoneOnDesktop", ""], [1, "Spa_Style_Primary_Link_Color", "text-underline", 3, "href"]], template: function EnrollmentInformationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵlistener("click", function EnrollmentInformationComponent_Template_div_click_1_listener() { return ctx.showInformation = !ctx.showInformation; })("keyup.enter", function EnrollmentInformationComponent_Template_div_keyup_enter_1_listener() { return ctx.showInformation = !ctx.showInformation; });
        i0.ɵɵelementStart(2, "div")(3, "h4", 2);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "span", 3);
        i0.ɵɵelement(6, "i", 4);
        i0.ɵɵelementStart(7, "span", 5);
        i0.ɵɵtext(8, "Expand/collapse section");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(9, "div", 6)(10, "div", 7)(11, "div", 8)(12, "div", 9);
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(14, EnrollmentInformationComponent_div_14_Template, 2, 1, "div", 10);
        i0.ɵɵtemplate(15, EnrollmentInformationComponent_div_15_Template, 2, 1, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(16, EnrollmentInformationComponent_ng_container_16_Template, 4, 4, "ng-container", 10);
        i0.ɵɵtemplate(17, EnrollmentInformationComponent_div_17_Template, 12, 12, "div", 11);
        i0.ɵɵtemplate(18, EnrollmentInformationComponent_18_Template, 1, 0, null, 10);
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(19, EnrollmentInformationComponent_ng_template_19_Template, 1, 1, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵattribute("aria-expanded", ctx.showInformation)("aria-label", (ctx.showInformation ? ctx.collapseStringPrepend : ctx.expandStringPrepend) + ctx.Spa_Enrollment_InformationMenu_Text + ctx.sectionStringAppend);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.Spa_Enrollment_InformationMenu_Text);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(12, _c1$Y, ctx.showInformation, !ctx.showInformation));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("collapsibleList", ctx.showInformation);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c2$D, ctx.isMobile && !ctx.showInformation));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.Spa_Enrollment_InformationInstructions_Text, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Enrollment_InformationPlanLink_Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Enrollment_InformationLinks_Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.plan);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Enrollment_OtherMethods_ShowClient);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Enrollment_OtherMethods_ShowBody && ctx.plan);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgTemplateOutlet, LinkComponent, IconAriaAttributesDirective, CollapsibleListAnimationDirective, i1$2.AsyncPipe, PhonePipe], styles: [".text[_ngcontent-%COMP%]{font-size:var(--Spa_Style_Small_Font)}.header[_ngcontent-%COMP%]{font-family:montserrat_semibold;font-size:var(--Spa_Style_Regular_Font)}.enrollment-information-header[_ngcontent-%COMP%]{padding-left:15px;padding-top:5px;padding-bottom:5px;display:flex;justify-content:space-between;border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px;background-color:var(--static-Spa_Style_Gray1)}.enrollment-information-header[_ngcontent-%COMP%]   div[_ngcontent-%COMP%], .enrollment-information-header[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:var(--Spa_Style_Regular_Font);color:var(--static-Spa_Style_Primary)}.toggle-cart-button[_ngcontent-%COMP%]{cursor:pointer}@media (min-width: 768px){.animation-container[_ngcontent-%COMP%]{opacity:1!important;height:initial!important}}"], data: { animation: [collapsibleList] }, changeDetection: 0 });
__decorate([
    Select(AgentState)
], EnrollmentInformationComponent.prototype, "broker$", void 0);
__decorate([
    Select(UiState.showAgentMiniCart)
], EnrollmentInformationComponent.prototype, "showAgentMiniCart$", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_InformationInstructions_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_InformationPlanLink_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_InformationPlanLink_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_InformationLinks_Links", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_InformationLinks_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_OtherMethodsHeader_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_OtherMethodsBody_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Site_SingleCarrier", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Site_SiteType", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Site_ClientLocation", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_OtherMethods_ShowBroker", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_OtherMethods_ShowCarrier", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_OtherMethods_ShowBody", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_OtherMethods_ShowClient", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_InformationMenu_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_Address_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_Phone_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_Fax_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_TTY_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_TTY_Members_Text_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_TTY_Members_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_TTY_NonMembers_Text_Enabled", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_TTY_NonMembers_Text", void 0);
__decorate([
    GlobalResource()
], EnrollmentInformationComponent.prototype, "Spa_Enrollment_Hours_Text", void 0);
__decorate([
    ResponsiveLayout(BreakPoint.COMPACT)
], EnrollmentInformationComponent.prototype, "isMobile$", void 0);
EnrollmentInformationComponent = __decorate([
    PlatformWidget
], EnrollmentInformationComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentInformationComponent, [{
        type: Component,
        args: [{ selector: 'vnext-enrollment-information', providers: [WidgetService], animations: [collapsibleList], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container pl-3 pr-3\">\r\n  <div\r\n    (click)=\"showInformation = !showInformation\"\r\n    (keyup.enter)=\"showInformation = !showInformation\"\r\n    [attr.aria-expanded]=\"showInformation\"\r\n    [attr.aria-label]=\"(showInformation ? collapseStringPrepend : expandStringPrepend) + Spa_Enrollment_InformationMenu_Text + sectionStringAppend\"\r\n    role=\"button\"\r\n    class=\"enrollment-information-header mt-2 d-md-none\"\r\n  >\r\n    <div>\r\n      <h4 class=\"Spa_Style_H4\">{{ Spa_Enrollment_InformationMenu_Text }}</h4>\r\n    </div>\r\n    <span class=\"px-4 toggle-cart-button d-md-none\">\r\n      <i class=\"fa\" [ngClass]=\"{ 'fa-angle-up': showInformation, 'fa-angle-down': !showInformation }\"></i>\r\n      <span class=\"sr-only\">Expand/collapse section</span>\r\n    </span>\r\n  </div>\r\n  <div [collapsibleList]=\"showInformation\" class=\"animation-container\">\r\n    <div [ngClass]=\"{ invisible: isMobile && !showInformation }\" class=\"list-item-container\">\r\n      <div class=\"mt-3\">\r\n        <div class=\"Spa_Style_Note\">\r\n          {{ Spa_Enrollment_InformationInstructions_Text }}\r\n        </div>\r\n        <div *ngIf=\"Spa_Enrollment_InformationPlanLink_Enabled\">\r\n          <ng-container *ngIf=\"plan\">\r\n            <ng-container *ngIf=\"plan.documents?.length\">\r\n              <ng-container *ngFor=\"let document of plan.documents\">\r\n                <ng-container *ngIf=\"displayDocumentLink(document)\">\r\n                  <vnext-link\r\n                    [href]=\"document.url\"\r\n                    [alwaysUnderlined]=\"true\"\r\n                    [title]=\"document.linkName\"\r\n                    [linkTarget]=\"'_blank'\"\r\n                  ></vnext-link>\r\n                </ng-container>\r\n              </ng-container>\r\n            </ng-container>\r\n          </ng-container>\r\n        </div>\r\n        <div *ngIf=\"Spa_Enrollment_InformationLinks_Enabled\">\r\n          <div *ngFor=\"let link of Spa_Enrollment_InformationLinks_Links\">\r\n            <vnext-link\r\n              *ngIf=\"link.tag\"\r\n              [tag]=\"link.tag\"\r\n              [title]=\"link.title\"\r\n              [alwaysUnderlined]=\"true\"\r\n              [linkTarget]=\"'_blank'\"\r\n            ></vnext-link>\r\n            <vnext-link\r\n              *ngIf=\"link.href\"\r\n              [href]=\"link.href\"\r\n              [title]=\"link.title\"\r\n              [alwaysUnderlined]=\"true\"\r\n              [linkTarget]=\"'_blank'\"\r\n            ></vnext-link>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <ng-container *ngIf=\"plan\">\r\n        <ng-container *ngIf=\"showAgentMiniCart$ | async\">\r\n          <div\r\n            *ngIf=\"Spa_Enrollment_OtherMethods_ShowBroker && broker$ | async as broker\"\r\n            class=\"body mt-3 Spa_Style_Note no-translate-block\"\r\n          >\r\n            <div class=\"Spa_Style_H5_Note\">{{ broker.firstName }} {{ broker.lastName }}</div>\r\n            <div>{{ broker.address1 }}</div>\r\n            <div>{{ broker.address2 }}</div>\r\n            <div>\r\n              {{ broker.city }}\r\n              {{ broker.state }}\r\n              {{ broker.zip }}\r\n            </div>\r\n            <ng-container *ngTemplateOutlet=\"phoneLinks; context: { content: agentPhoneNumber, name: broker.fullName }\"> </ng-container>\r\n          </div>\r\n        </ng-container>\r\n        <div class=\"body mt-3 Spa_Style_Note\" *ngIf=\"Spa_Enrollment_OtherMethods_ShowCarrier\">\r\n          <div class=\"Spa_Style_H5_Note mb-1\">{{ plan.organizationName }}</div>\r\n          <ng-container *ngIf=\"plan.planType === planType.MEDIGAP; then medigapCarrierInfo; else enrollCarrierInfo\"> </ng-container>\r\n          <ng-template #medigapCarrierInfo>\r\n            <ng-container *ngIf=\"plan.carrierInformation\">\r\n              <ng-container\r\n                *ngIf=\"\r\n                  plan.carrierInformation.carrierAddress.address1 ||\r\n                  plan.carrierInformation.carrierAddress.address2 ||\r\n                  plan.carrierInformation.carrierAddress.city ||\r\n                  plan.carrierInformation.carrierAddress.state ||\r\n                  plan.carrierInformation.carrierAddress.zip\r\n                \"\r\n              >\r\n                <div class=\"Spa_Style_Bold_Weight\">{{ Spa_Enrollment_Address_Text }}</div>\r\n                <div class=\"no-translate-block\">\r\n                  <div>{{ plan.carrierInformation.carrierAddress.address1 }}</div>\r\n                  <div>{{ plan.carrierInformation.carrierAddress.address2 }}</div>\r\n                  <div>\r\n                    <span *ngIf=\"plan.carrierInformation.carrierAddress.city\">{{ plan.carrierInformation.carrierAddress.city }}, </span>\r\n                    <span *ngIf=\"plan.carrierInformation.carrierAddress.state\">{{ plan.carrierInformation.carrierAddress.state }} </span>\r\n                    <span *ngIf=\"plan.carrierInformation.carrierAddress.zip\">{{ plan.carrierInformation.carrierAddress.zip }} </span>\r\n                  </div>\r\n                </div>\r\n              </ng-container>\r\n              <div *ngIf=\"plan.carrierInformation.phone\">\r\n                <div class=\"Spa_Style_Bold_Weight\">{{ Spa_Enrollment_Phone_Text }}</div>\r\n                <ng-container *ngTemplateOutlet=\"phoneLinks; context: { content: plan.carrierInformation.phone, name: plan.organizationName}\"> </ng-container>\r\n              </div>\r\n              <div *ngIf=\"plan.carrierInformation.fax\" class=\"Spa_Style_Note\">\r\n                <div class=\"Spa_Style_Bold_Weight\">{{ Spa_Enrollment_Fax_Text }}</div>\r\n                <div *ngIf=\"countryCode\">\r\n                  {{ plan.carrierInformation.fax | phone : countryCode }}\r\n                </div>\r\n              </div>\r\n              <div *ngIf=\"this.Spa_Enrollment_TTY_Members_Text_Enabled && plan.carrierInformation.phoneMemberTTY\">\r\n                <div class=\"Spa_Style_Bold_Weight\">{{ Spa_Enrollment_TTY_Members_Text }}</div>\r\n                <div>\r\n                  <ng-container *ngTemplateOutlet=\"phoneLinks; context: { content: plan.carrierInformation.phoneMemberTTY, name: plan.organizationName }\">\r\n                  </ng-container>\r\n                </div>\r\n              </div>\r\n              <div *ngIf=\"this.Spa_Enrollment_TTY_NonMembers_Text_Enabled && plan.carrierInformation.phoneNonMemberTTY\">\r\n                <div class=\"Spa_Style_Bold_Weight\">{{ Spa_Enrollment_TTY_NonMembers_Text }}</div>\r\n                <div *ngIf=\"countryCode\">\r\n                  <ng-container *ngTemplateOutlet=\"phoneLinks; context: { content: plan.carrierInformation.phoneNonMemberTTY, name: plan.organizationName }\">\r\n                  </ng-container>\r\n                </div>\r\n              </div>\r\n              <div *ngIf=\"plan.carrierInformation.hours\">\r\n                <div class=\"Spa_Style_Bold_Weight\">{{ Spa_Enrollment_Hours_Text }}</div>\r\n                <div>{{ plan.carrierInformation.hours }}</div>\r\n              </div>\r\n            </ng-container>\r\n          </ng-template>\r\n          <ng-template #enrollCarrierInfo>\r\n            <ng-container *ngIf=\"plan.planEnrollmentInfo\">\r\n              <ng-container\r\n                *ngIf=\"\r\n                  plan.planEnrollmentInfo.address1 ||\r\n                  plan.planEnrollmentInfo.address2 ||\r\n                  plan.planEnrollmentInfo.city ||\r\n                  plan.planEnrollmentInfo.state ||\r\n                  plan.planEnrollmentInfo.zip\r\n                \"\r\n              >\r\n                <div class=\"Spa_Style_Bold_Weight\">{{ Spa_Enrollment_Address_Text }}</div>\r\n                <div class=\"no-translate-block\">\r\n                  <div>{{ plan.planEnrollmentInfo.address1 }}</div>\r\n                  <div>{{ plan.planEnrollmentInfo.address2 }}</div>\r\n                  <div>\r\n                    <span *ngIf=\"plan.planEnrollmentInfo.city\">{{ plan.planEnrollmentInfo.city }}, </span>\r\n                    <span *ngIf=\"plan.planEnrollmentInfo.state\">{{ plan.planEnrollmentInfo.state }} </span>\r\n                    <span *ngIf=\"plan.planEnrollmentInfo.zip\">{{ plan.planEnrollmentInfo.zip }} </span>\r\n                  </div>\r\n                </div>\r\n              </ng-container>\r\n              <div *ngIf=\"plan.planEnrollmentInfo.businessPhone\">\r\n                <div class=\"Spa_Style_Bold_Weight\">{{ Spa_Enrollment_Phone_Text }}</div>\r\n                <ng-container *ngTemplateOutlet=\"phoneLinks; context: { content: plan.planEnrollmentInfo.businessPhone, name: plan.organizationName }\"> </ng-container>\r\n              </div>\r\n              <div *ngIf=\"plan.planEnrollmentInfo.fax\" class=\"Spa_Style_Note\">\r\n                <div class=\"Spa_Style_Bold_Weight\">{{ Spa_Enrollment_Fax_Text }}</div>\r\n                <div *ngIf=\"countryCode\">\r\n                  {{ plan.planEnrollmentInfo.fax | phone : countryCode }}\r\n                </div>\r\n              </div>\r\n              <div *ngIf=\"plan.planEnrollmentInfo.ttyPhone\">\r\n                <div class=\"Spa_Style_Bold_Weight\">{{ Spa_Enrollment_TTY_Text }}</div>\r\n                <div>\r\n                  <ng-container *ngTemplateOutlet=\"phoneLinks; context: { content: plan.planEnrollmentInfo.ttyPhone, name: plan.organizationName }\"> </ng-container>\r\n                </div>\r\n              </div>\r\n              <div *ngIf=\"plan.planEnrollmentInfo.hours\">\r\n                <div class=\"Spa_Style_Bold_Weight\">{{ Spa_Enrollment_Hours_Text }}</div>\r\n                <div>{{ plan.planEnrollmentInfo.hours }}</div>\r\n              </div>\r\n            </ng-container>\r\n          </ng-template>\r\n        </div>\r\n      </ng-container>\r\n      <div class=\"body mt-3 Spa_Style_Note no-translate-block\" *ngIf=\"Spa_Enrollment_OtherMethods_ShowClient\">\r\n        <div class=\"Spa_Style_H5_Note\">{{ Spa_Site_ClientLocation.title }}</div>\r\n        <div>{{ Spa_Site_ClientLocation.address1 }}</div>\r\n        <div>{{ Spa_Site_ClientLocation.address2 }}</div>\r\n        <div>{{ Spa_Site_ClientLocation.city }}, {{ Spa_Site_ClientLocation.state }} {{ Spa_Site_ClientLocation.zipCode }}</div>\r\n        <ng-container *ngTemplateOutlet=\"phoneLinks; context: { content: Spa_Site_ClientLocation.phoneNumber, name: Spa_Site_ClientLocation.title }\"> </ng-container>\r\n        <div>{{ Spa_Site_ClientLocation.hours }}</div>\r\n      </div>\r\n      <ng-template *ngIf=\"Spa_Enrollment_OtherMethods_ShowBody && plan\">\r\n        <div class=\"mt-3 Spa_Style_Note no-translate-block\" [innerText]=\"bodyText(plan.planName)\"></div>\r\n      </ng-template>\r\n    </div>\r\n  </div>\r\n</div>\r\n<ng-template #phoneLinks let-content=\"content\" let-name=\"name\">\r\n  <ng-container *ngIf=\"countryCode\">\r\n    <a *ngIf=\"isMobile; else showPhoneOnDesktop\" href=\"tel:{{ content }}\" class=\"Spa_Style_Primary_Link_Color text-underline\" [attr.aria-label]=\"name + ': ' + content\">\r\n      {{ content | phone : countryCode }}\r\n    </a>\r\n    <ng-template #showPhoneOnDesktop>\r\n      <div>\r\n        {{ content | phone : countryCode }}\r\n      </div>\r\n    </ng-template>\r\n  </ng-container>\r\n</ng-template>\r\n", styles: [".text{font-size:var(--Spa_Style_Small_Font)}.header{font-family:montserrat_semibold;font-size:var(--Spa_Style_Regular_Font)}.enrollment-information-header{padding-left:15px;padding-top:5px;padding-bottom:5px;display:flex;justify-content:space-between;border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px;background-color:var(--static-Spa_Style_Gray1)}.enrollment-information-header div,.enrollment-information-header div i{font-size:var(--Spa_Style_Regular_Font);color:var(--static-Spa_Style_Primary)}.toggle-cart-button{cursor:pointer}@media (min-width: 768px){.animation-container{opacity:1!important;height:initial!important}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.EnrollmentFormService }, { type: i1.PhoneUtilityService }, { type: i1.LocaleService }, { type: i1.ShoppingCartService }, { type: i1.PlansService }, { type: i1.SpinnerService }]; }, { broker$: [], showAgentMiniCart$: [], Spa_Enrollment_InformationInstructions_Text: [], Spa_Enrollment_InformationPlanLink_Text: [], Spa_Enrollment_InformationPlanLink_Enabled: [], Spa_Enrollment_InformationLinks_Links: [], Spa_Enrollment_InformationLinks_Enabled: [], Spa_Enrollment_OtherMethodsHeader_Text: [], Spa_Enrollment_OtherMethodsBody_Text: [], Spa_Site_SingleCarrier: [], Spa_Site_SiteType: [], Spa_Site_ClientLocation: [], Spa_Enrollment_OtherMethods_ShowBroker: [], Spa_Enrollment_OtherMethods_ShowCarrier: [], Spa_Enrollment_OtherMethods_ShowBody: [], Spa_Enrollment_OtherMethods_ShowClient: [], Spa_Enrollment_InformationMenu_Text: [], Spa_Enrollment_Address_Text: [], Spa_Enrollment_Phone_Text: [], Spa_Enrollment_Fax_Text: [], Spa_Enrollment_TTY_Text: [], Spa_Enrollment_TTY_Members_Text_Enabled: [], Spa_Enrollment_TTY_Members_Text: [], Spa_Enrollment_TTY_NonMembers_Text_Enabled: [], Spa_Enrollment_TTY_NonMembers_Text: [], Spa_Enrollment_Hours_Text: [], isMobile$: [] }); })();

class MedigapEnrollmentFacade {
    constructor(responsiveLayoutService, store) {
        this.responsiveLayoutService = responsiveLayoutService;
        this.store = store;
    }
    get isMobile$() {
        return this.responsiveLayoutService.isCompact$;
    }
    get isMedium$() {
        return this.responsiveLayoutService.isMedium$;
    }
    getSelectedMedigapPlans$() {
        return this.store
            .select(ShoppingCartState.selectedPlans)
            .pipe(map((plans) => plans.filter(plan => plan.planTypeAbbreviation === PlanTypeAbbreviation.MEDIGAP)));
    }
    getIsLoading$(planType) {
        return this.store.select(PlansState.loading(planType));
    }
    getIsEnrollmentSettingLoading$() {
        return this.store.select(MemberState.loading);
    }
}
MedigapEnrollmentFacade.ɵfac = function MedigapEnrollmentFacade_Factory(t) { return new (t || MedigapEnrollmentFacade)(i0.ɵɵinject(i1.ResponsiveLayoutService), i0.ɵɵinject(i2.Store)); };
MedigapEnrollmentFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MedigapEnrollmentFacade, factory: MedigapEnrollmentFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedigapEnrollmentFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.ResponsiveLayoutService }, { type: i2.Store }]; }, null); })();

function MedigapEnrollmentInterimComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 12);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r0.SPA_Medigap_Enrollment_InterimPage_Link_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function MedigapEnrollmentInterimComponent_ng_container_3_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "a", 15);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const document_r8 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("href", document_r8.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(document_r8.linkName);
} }
function MedigapEnrollmentInterimComponent_ng_container_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MedigapEnrollmentInterimComponent_ng_container_3_div_3_div_1_Template, 3, 2, "div", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", plan_r5.documents);
} }
function MedigapEnrollmentInterimComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h1", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, MedigapEnrollmentInterimComponent_ng_container_3_div_3_Template, 2, 1, "div", 14);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const plan_r5 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(plan_r5.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", plan_r5.documents && plan_r5.documents.length);
} }
function MedigapEnrollmentInterimComponent_p_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.SPA_Medigap_Enrollment_InterimPage_Information_Text, " ");
} }
function MedigapEnrollmentInterimComponent_label_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "label", 17);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r3.SPA_Medigap_Enrollment_InterimPage_Acknowledgement_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function MedigapEnrollmentInterimComponent_button_15_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function MedigapEnrollmentInterimComponent_button_15_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.onContinue()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r4.isAcknowledged);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.SPA_Medigap_Enrollment_InterimPage_Continue_Button_Text, " ");
} }
let MedigapEnrollmentInterimComponent = class MedigapEnrollmentInterimComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, planFacade, medigapEnrollmentFacade, store, spinnerService, enrollmentFormService, shoppingCartService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.planFacade = planFacade;
        this.medigapEnrollmentFacade = medigapEnrollmentFacade;
        this.store = store;
        this.spinnerService = spinnerService;
        this.enrollmentFormService = enrollmentFormService;
        this.shoppingCartService = shoppingCartService;
        this.SPA_Site_Medigap_Enrollment_InterimPage_Enable = true;
        this.SPA_Medigap_Enrollment_InterimPage_Link_Text = 'Each of these links contain important information about Medicare Supplement and this plan. </br> <a class=\'Spa_Style_Link always-underline\' target=\'_blank\' href=\'https://contentserver.destinationrx.com/ContentServer/DRxProductContent/PDFs/Medigap_Policy/2019MedigapPolicy.pdf\'>Choosing a Medigap Policy</a>';
        this.SPA_Medigap_Enrollment_InterimPage_Information_Text = 'Please be advised that if the information you provide on the enrollment form differs from the information you provided for a rate quote, then your premium may change.';
        this.SPA_Medigap_Enrollment_InterimPage_Acknowledgement_Text = '<strong> I acknowledge I have read the above documents </strong> and fully understand their contents.';
        this.SPA_Medigap_Enrollment_InterimPage_Continue_Button_Text = 'Continue';
        this.isAcknowledged = false;
        this.tagsToUpdate = {};
    }
    ngOnInit() {
        super.ngOnInit();
        this.plans$ = this.medigapEnrollmentFacade.getSelectedMedigapPlans$();
        this.loading$ = this.medigapEnrollmentFacade.getIsLoading$();
        this.enrollmentSettingLoading$ = this.medigapEnrollmentFacade.getIsEnrollmentSettingLoading$();
        this.subscriptions = [
            this.loading$.subscribe({
                next: loading => {
                    loading ? this.spinnerService.show(SpinnerEvent.PLANS_LOADING) : this.spinnerService.hide(SpinnerEvent.PLANS_LOADING);
                }
            }),
            this.enrollmentSettingLoading$.subscribe(loading => loading
                ? this.spinnerService.show(SpinnerEvent.NAVIGATE_TO_ENROLLMENT)
                : this.spinnerService.hide(SpinnerEvent.NAVIGATE_TO_ENROLLMENT))
        ];
        this.navLink = {
            title: this.SPA_Medigap_Enrollment_InterimPage_Continue_Button_Text,
            type: LinkType.INTERNAL,
            validateWidgets: true
        };
        this.updateTags();
    }
    onContinue() {
        this.planFacade.enroll(this.widgetName);
    }
    onChange(isChecked) {
        if (isChecked) {
            this.isAcknowledged = true;
        }
        else {
            this.isAcknowledged = false;
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        if (this.subscriptions) {
            this.subscriptions.forEach(sub => sub.unsubscribe());
        }
        this.spinnerService.reset();
    }
    updateTags() {
        this.tagsToUpdate = this.enrollmentFormService.updateTagForCrossSell(this.tagsToUpdate);
        this.tagsToUpdate = {
            ...this.tagsToUpdate,
            [DataLayerGlobalVariable.ENROLLMENT_PLAN_COUNT]: `${this.shoppingCartService.getEnrollmentPlanCount()}`
        };
    }
};
MedigapEnrollmentInterimComponent.ɵfac = function MedigapEnrollmentInterimComponent_Factory(t) { return new (t || MedigapEnrollmentInterimComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(MedigapEnrollmentFacade), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(i1.ShoppingCartService)); };
MedigapEnrollmentInterimComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedigapEnrollmentInterimComponent, selectors: [["vnext-medigap-enrollment-interim"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 16, vars: 12, consts: [["vnextGoogleTagManager", "", 1, "container", 3, "tagsToUpdate"], [1, "Spa_Style_Paragraph", "mt-5", "mb-3"], ["navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], [4, "ngFor", "ngForOf"], [1, "container", "Spa_Style_Gray1_Background", "medigap-enrollment-interim-informationText"], ["class", "Spa_Style_Paragraph", 4, "liveEditProp"], ["id", "chkAcknowledged", "type", "checkbox", 3, "change"], [1, "input-error-asterisk"], ["for", "chkAcknowledged", "class", "Spa_Style_Paragraph", "navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], [1, "col-lg-9", "offset-md-3", 3, "providedPrevious", "showPrevious"], ["continue-button", ""], ["class", "btn Spa_Style_PrimaryButton col-xs-12 col-md-auto continue-button", 3, "disabled", "click", 4, "liveEditProp"], ["navigationAdapter", "", 3, "innerHTML"], [1, "Spa_Style_H1", "medigap-enrollment-interim-title", "text-center", "no-translate-block"], [4, "ngIf"], ["navigationAdapter", "", 1, "Spa_Style_Link", "always-underline", 3, "href"], [1, "Spa_Style_Paragraph"], ["for", "chkAcknowledged", "navigationAdapter", "", 1, "Spa_Style_Paragraph", 3, "innerHTML"], [1, "btn", "Spa_Style_PrimaryButton", "col-xs-12", "col-md-auto", "continue-button", 3, "disabled", "click"]], template: function MedigapEnrollmentInterimComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "p", 1);
        i0.ɵɵtemplate(2, MedigapEnrollmentInterimComponent_span_2_Template, 2, 4, "span", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, MedigapEnrollmentInterimComponent_ng_container_3_Template, 4, 2, "ng-container", 3);
        i0.ɵɵpipe(4, "async");
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵtemplate(6, MedigapEnrollmentInterimComponent_p_6_Template, 2, 1, "p", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div")(8, "p")(9, "input", 6);
        i0.ɵɵlistener("change", function MedigapEnrollmentInterimComponent_Template_input_change_9_listener($event) { return ctx.onChange($event.target.checked); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "span", 7);
        i0.ɵɵtext(11, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, MedigapEnrollmentInterimComponent_label_12_Template, 2, 4, "label", 8);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "vnext-navigation-banner", 9)(14, "div", 10);
        i0.ɵɵtemplate(15, MedigapEnrollmentInterimComponent_button_15_Template, 2, 2, "button", 11);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵproperty("tagsToUpdate", ctx.tagsToUpdate);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "SPA_Medigap_Enrollment_InterimPage_Link_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(4, 10, ctx.plans$));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "SPA_Medigap_Enrollment_InterimPage_Information_Text");
        i0.ɵɵadvance(4);
        i0.ɵɵstyleProp("visibility", ctx.isAcknowledged ? "hidden" : "");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "SPA_Medigap_Enrollment_InterimPage_Acknowledgement_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("providedPrevious", false)("showPrevious", true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "SPA_Medigap_Enrollment_InterimPage_Continue_Button_Text");
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, NavigationBannerComponent, NavigationAdapterDirective, LiveEditPropDirective, GoogleTagManagerDirective, i1$2.AsyncPipe, SafePipe], styles: [".medigap-enrollment-interim-title[_ngcontent-%COMP%]{margin-bottom:30px}.medigap-enrollment-interim-informationText[_ngcontent-%COMP%]{margin-top:20px;margin-bottom:20px;padding-top:15px;padding-bottom:5px;border-radius:1px 5px 5px}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], MedigapEnrollmentInterimComponent.prototype, "SPA_Site_Medigap_Enrollment_InterimPage_Enable", void 0);
__decorate([
    PlatformProp('live-edit')
], MedigapEnrollmentInterimComponent.prototype, "SPA_Medigap_Enrollment_InterimPage_Link_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], MedigapEnrollmentInterimComponent.prototype, "SPA_Medigap_Enrollment_InterimPage_Information_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], MedigapEnrollmentInterimComponent.prototype, "SPA_Medigap_Enrollment_InterimPage_Acknowledgement_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], MedigapEnrollmentInterimComponent.prototype, "SPA_Medigap_Enrollment_InterimPage_Continue_Button_Text", void 0);
__decorate([
    LiveEditInactive()
], MedigapEnrollmentInterimComponent.prototype, "onContinue", null);
MedigapEnrollmentInterimComponent = __decorate([
    PlatformWidget
], MedigapEnrollmentInterimComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedigapEnrollmentInterimComponent, [{
        type: Component,
        args: [{ selector: 'vnext-medigap-enrollment-interim', providers: [WidgetService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container\" vnextGoogleTagManager [tagsToUpdate]=\"tagsToUpdate\">\r\n  <p class=\"Spa_Style_Paragraph mt-5 mb-3\">\r\n    <span\r\n      *liveEditProp=\"'SPA_Medigap_Enrollment_InterimPage_Link_Text'\"\r\n      [innerHTML]=\"SPA_Medigap_Enrollment_InterimPage_Link_Text | safe : 'html'\"\r\n      navigationAdapter\r\n    ></span>\r\n  </p>\r\n\r\n  <ng-container *ngFor=\"let plan of plans$ | async\">\r\n    <h1 class=\"Spa_Style_H1 medigap-enrollment-interim-title text-center no-translate-block\">{{ plan.planName }}</h1>\r\n    <div *ngIf=\"plan.documents && plan.documents.length\">\r\n      <div *ngFor=\"let document of plan.documents\">\r\n        <a class=\"Spa_Style_Link always-underline\" href=\"{{ document.url }}\" navigationAdapter>{{ document.linkName }}</a>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <div class=\"container Spa_Style_Gray1_Background medigap-enrollment-interim-informationText\">\r\n    <p class=\"Spa_Style_Paragraph\" *liveEditProp=\"'SPA_Medigap_Enrollment_InterimPage_Information_Text'\">\r\n      {{ SPA_Medigap_Enrollment_InterimPage_Information_Text }}\r\n    </p>\r\n  </div>\r\n  <div>\r\n    <p>\r\n      <input id=\"chkAcknowledged\" type=\"checkbox\" (change)=\"onChange($event.target.checked)\" />\r\n      <span [style.visibility]=\"isAcknowledged ? 'hidden' : ''\" class=\"input-error-asterisk\">*</span>\r\n      <label\r\n        *liveEditProp=\"'SPA_Medigap_Enrollment_InterimPage_Acknowledgement_Text'\"\r\n        for=\"chkAcknowledged\"\r\n        class=\"Spa_Style_Paragraph\"\r\n        [innerHTML]=\"SPA_Medigap_Enrollment_InterimPage_Acknowledgement_Text | safe : 'html'\"\r\n        navigationAdapter\r\n      ></label>\r\n    </p>\r\n  </div>\r\n  <vnext-navigation-banner class=\"col-lg-9 offset-md-3\" [providedPrevious]=\"false\" [showPrevious]=\"true\">\r\n    <div continue-button>\r\n      <button\r\n        class=\"btn Spa_Style_PrimaryButton col-xs-12 col-md-auto continue-button\"\r\n        (click)=\"onContinue()\"\r\n        [disabled]=\"!isAcknowledged\"\r\n        *liveEditProp=\"'SPA_Medigap_Enrollment_InterimPage_Continue_Button_Text'\"\r\n      >\r\n        {{ SPA_Medigap_Enrollment_InterimPage_Continue_Button_Text }}\r\n      </button>\r\n    </div>\r\n  </vnext-navigation-banner>\r\n</div>\r\n", styles: [".medigap-enrollment-interim-title{margin-bottom:30px}.medigap-enrollment-interim-informationText{margin-top:20px;margin-bottom:20px;padding-top:15px;padding-bottom:5px;border-radius:1px 5px 5px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: PlanFacade }, { type: MedigapEnrollmentFacade }, { type: i2.Store }, { type: i1.SpinnerService }, { type: i1.EnrollmentFormService }, { type: i1.ShoppingCartService }]; }, { SPA_Site_Medigap_Enrollment_InterimPage_Enable: [], SPA_Medigap_Enrollment_InterimPage_Link_Text: [], SPA_Medigap_Enrollment_InterimPage_Information_Text: [], SPA_Medigap_Enrollment_InterimPage_Acknowledgement_Text: [], SPA_Medigap_Enrollment_InterimPage_Continue_Button_Text: [], onContinue: [] }); })();

const _c0$22 = ["errorContainer"];
let EnrollmentNoticeComponent = class EnrollmentNoticeComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, enrollmentFormErrorsContext) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.cdr = cdr;
        this.widgetValidationService = widgetValidationService;
        this.configurableWidgetService = configurableWidgetService;
        this.zoneService = zoneService;
        this.widgetService = widgetService;
        this.enrollmentFormErrorsContext = enrollmentFormErrorsContext;
    }
    ngOnInit() {
        super.ngOnInit();
        this.formErrors$ = this.enrollmentFormErrorsContext.observeForFormErrors$();
        this.scrollTo$ = this.enrollmentFormErrorsContext.observeForScrollTo$().subscribe({
            next: () => {
                this.scrollToErrors();
            }
        });
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.scrollTo$.unsubscribe();
    }
    scrollToErrors() {
        this.errorContainer.first.nativeElement.scrollIntoView({ behavior: 'smooth' });
    }
};
EnrollmentNoticeComponent.ɵfac = function EnrollmentNoticeComponent_Factory(t) { return new (t || EnrollmentNoticeComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.EnrollmentFormErrorsContext)); };
EnrollmentNoticeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EnrollmentNoticeComponent, selectors: [["vnext-enrollment-notice"]], viewQuery: function EnrollmentNoticeComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$22, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.errorContainer = _t);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 3, consts: [[1, "enrollment-error-container", "px-3", "pr-md-2"], ["errorContainer", ""], [3, "notice"]], template: function EnrollmentNoticeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0, 1);
        i0.ɵɵelement(2, "vnext-notice-container", 2);
        i0.ɵɵpipe(3, "async");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("notice", i0.ɵɵpipeBind1(3, 1, ctx.formErrors$));
    } }, dependencies: [NoticeContainerComponent, i1$2.AsyncPipe], styles: [".enrollment-error-container[_ngcontent-%COMP%]{margin:20px -15px}"], changeDetection: 0 });
EnrollmentNoticeComponent = __decorate([
    PlatformWidget
], EnrollmentNoticeComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentNoticeComponent, [{
        type: Component,
        args: [{ selector: 'vnext-enrollment-notice', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div #errorContainer class=\"enrollment-error-container px-3 pr-md-2\">\r\n  <vnext-notice-container [notice]=\"formErrors$ | async\"></vnext-notice-container>\r\n</div>\r\n", styles: [".enrollment-error-container{margin:20px -15px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.EnrollmentFormErrorsContext }]; }, { errorContainer: [{
            type: ViewChildren,
            args: ['errorContainer']
        }] }); })();

function GenericFormConfirmationComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r0.Spa_GenericForm_ConfirmationMessage_Text, "html"), i0.ɵɵsanitizeHtml);
} }
let GenericFormConfirmationComponent = class GenericFormConfirmationComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, analyticsService, store, router, enrollmentFormService, genericFormService, enrollmentFormFacade) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.analyticsService = analyticsService;
        this.store = store;
        this.router = router;
        this.enrollmentFormService = enrollmentFormService;
        this.genericFormService = genericFormService;
        this.enrollmentFormFacade = enrollmentFormFacade;
        this.Spa_GenericForm_ConfirmationMessage_Text = '<br><center><h3>Your generic form is complete.</h3>\r\n<h5>Enrollment confirmation number: {{getConfirmationNumber()}}</h5></center>';
    }
    ngOnInit() {
        super.ngOnInit();
        this.updateDataLayer();
    }
    updateDataLayer() {
        const activeEnrollmentKey = this.enrollmentFormService.getActiveEnrollmentKey();
        const confirmationNumber = this.genericFormService.getConfirmationNumber(activeEnrollmentKey);
        const transaction = this.store.selectSnapshot(EnrollmentState.transaction(activeEnrollmentKey));
        const googleTagManagerNotApplicableText = this.analyticsService.getGoogleTagManagerNotApplicableText();
        const externalMemberId = this.store.selectSnapshot(DeepLinkingParamsState.ssoValue);
        const externalReferenceId = this.store.selectSnapshot(DeepLinkingParamsState.pegi);
        const enrollingPlan = this.enrollmentFormService.getSelectedPlan(activeEnrollmentKey);
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE,
            [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
            [DataLayerGlobalVariable.TRANSACTION_GUID]: transaction.transactionGUID,
            [DataLayerGlobalVariable.EXTERNAL_MEMBER_ID]: externalMemberId || googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.EXTERNAL_REFERENCE_ID]: externalReferenceId || googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.FORM_VERSION]: this.genericFormService.isAncillaryConfirmationPage()
                ? ANCILLARY_FORM_TYPE
                : EnrollmentFormTypeUtillity.toApiKeyName(EnrollmentFormType.LONG),
            [DataLayerGlobalVariable.PLAN_CARRIER]: googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.PLAN_TYPE]: googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.ENROLLMENT_CONFIRMATION_NUMBER]: confirmationNumber,
            [DataLayerGlobalVariable.PLAN_NAME]: enrollingPlan?.planName ?? googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.PLAN_PREMIUM_MONTHLY]: this.enrollmentFormFacade.getEnrollingPlanPremium(activeEnrollmentKey)
        };
    }
};
GenericFormConfirmationComponent.ɵfac = function GenericFormConfirmationComponent_Factory(t) { return new (t || GenericFormConfirmationComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(i1.GenericFormService), i0.ɵɵdirectiveInject(EnrollmentFormFacade)); };
GenericFormConfirmationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GenericFormConfirmationComponent, selectors: [["vnext-generic-form-confirmation"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 1, consts: [[1, "container", "confirmation-page"], [1, "row"], [1, "col-12", "text-center"], ["class", "page-title Spa_Style_H1 Spa_Style_Primary_Color Spa_Style_Bold_Weight", 3, "innerHTML", 4, "liveEditProp"], [1, "page-title", "Spa_Style_H1", "Spa_Style_Primary_Color", "Spa_Style_Bold_Weight", 3, "innerHTML"]], template: function GenericFormConfirmationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, GenericFormConfirmationComponent_div_3_Template, 2, 4, "div", 3);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "Spa_GenericForm_ConfirmationMessage_Text");
    } }, dependencies: [LiveEditPropDirective, SafePipe], styles: [".confirmation-page[_ngcontent-%COMP%]{font-size:14px}.page-title[_ngcontent-%COMP%]{margin-top:60px}"], changeDetection: 0 });
__decorate([
    PlatformProp('live-edit')
], GenericFormConfirmationComponent.prototype, "Spa_GenericForm_ConfirmationMessage_Text", void 0);
GenericFormConfirmationComponent = __decorate([
    PlatformWidget
], GenericFormConfirmationComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericFormConfirmationComponent, [{
        type: Component,
        args: [{ selector: 'vnext-generic-form-confirmation', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"container confirmation-page\">\r\n  <div class=\"row\">\r\n    <div class=\"col-12 text-center\">\r\n      <div\r\n        class=\"page-title Spa_Style_H1 Spa_Style_Primary_Color Spa_Style_Bold_Weight\"\r\n        *liveEditProp=\"'Spa_GenericForm_ConfirmationMessage_Text'\"\r\n        [innerHTML]=\"Spa_GenericForm_ConfirmationMessage_Text | safe: 'html'\"\r\n      ></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".confirmation-page{font-size:14px}.page-title{margin-top:60px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: AnalyticsService }, { type: i2.Store }, { type: i2$1.Router }, { type: i1.EnrollmentFormService }, { type: i1.GenericFormService }, { type: EnrollmentFormFacade }]; }, { Spa_GenericForm_ConfirmationMessage_Text: [] }); })();

const _c0$21 = ["genericFormHtml"];
function GenericFormRendererComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "form", 1, 2);
    i0.ɵɵpipe(3, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", ctx_r0.formId)("innerHTML", i0.ɵɵpipeBind2(3, 2, ctx_r0.formPageHtml, "html"), i0.ɵɵsanitizeHtml);
} }
class GenericFormRendererComponent extends FormRendererComponent {
    constructor(elementRef, enrollmentFormService, activatedRoute, cdr) {
        super(elementRef, enrollmentFormService, activatedRoute, cdr);
        this.elementRef = elementRef;
        this.enrollmentFormService = enrollmentFormService;
        this.activatedRoute = activatedRoute;
        this.cdr = cdr;
    }
    set formHtml(html) {
        this.formPageHtml = html;
        if (this.formPageHtml) {
            this.cdr.markForCheck();
            setTimeout(() => {
                this.loadPrerequisiteScripts();
                this.initializeView();
                this.viewInitialized$.next(true);
            });
        }
    }
}
GenericFormRendererComponent.ɵfac = function GenericFormRendererComponent_Factory(t) { return new (t || GenericFormRendererComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
GenericFormRendererComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GenericFormRendererComponent, selectors: [["vnext-generic-form-renderer"]], viewQuery: function GenericFormRendererComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$21, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.genericFormHtml = _t.first);
    } }, inputs: { formHtml: "formHtml" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["navigationAdapter", "", 3, "id", "innerHTML"], ["genericFormHtml", ""]], template: function GenericFormRendererComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, GenericFormRendererComponent_div_0_Template, 4, 5, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.formPageHtml);
    } }, dependencies: [i1$2.NgIf, i4.ɵNgNoValidate, i4.NgControlStatusGroup, i4.NgForm, NavigationAdapterDirective, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericFormRendererComponent, [{
        type: Component,
        args: [{ selector: 'vnext-generic-form-renderer', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"formPageHtml\">\r\n  <form #genericFormHtml [id]=\"formId\" [innerHTML]=\"formPageHtml | safe: 'html'\" navigationAdapter></form>\r\n</div>\r\n" }]
    }], function () { return [{ type: i0.ElementRef }, { type: i1.EnrollmentFormService }, { type: i2$1.ActivatedRoute }, { type: i0.ChangeDetectorRef }]; }, { genericFormHtml: [{
            type: ViewChild,
            args: ['genericFormHtml']
        }], formHtml: [{
            type: Input
        }] }); })();

class GenericFormFacade {
    constructor(genericFormService, enrollmentFormService, configResourceService, globalFacade, localeService, formRootService) {
        this.genericFormService = genericFormService;
        this.enrollmentFormService = enrollmentFormService;
        this.configResourceService = configResourceService;
        this.globalFacade = globalFacade;
        this.localeService = localeService;
        this.formRootService = formRootService;
    }
    getTransaction(formId) {
        return this.enrollmentFormService.getTransaction(formId);
    }
    getCurrentLocale$() {
        return this.localeService.getCurrentLocale$();
    }
    getFormLoading$(formId) {
        return this.enrollmentFormService.getFormLoading$(formId);
    }
    getPageInfos(formId) {
        return this.genericFormService.getPageInfos(formId);
    }
    getPageHtml(formId, pageName) {
        return this.enrollmentFormService.getFormPageHtml(formId, pageName);
    }
    getPageHtml$(formId, pageName) {
        return this.enrollmentFormService.getFormPageHtml$(formId, pageName);
    }
    getSubmitText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Submit', widgetName, 'Submit');
    }
    getPreviousText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Previous', widgetName, 'Previous');
    }
    getNextText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Next', widgetName, 'Next');
    }
    getPageIndex(formId, pageName) {
        return this.genericFormService.getPageIndex(formId, pageName);
    }
    getPageName(formId, pageIndex) {
        return this.genericFormService.getPageName(formId, pageIndex);
    }
    getPageDirty(formId, pageName) {
        return this.enrollmentFormService.getFormPageDirty(formId, pageName);
    }
    setPageVisited(formId, pageName) {
        const pageIndex = this.getPageIndex(formId, pageName);
        this.enrollmentFormService.setPageVisited(pageIndex, formId);
    }
    setPageComplete(pageName, formId) {
        const pageIndex = this.getPageIndex(formId, pageName);
        this.enrollmentFormService.setPageComplete(pageIndex, formId);
    }
    setFormPageLoading$(loading, loaded, formId) {
        return this.enrollmentFormService.setFormPageLoading$(loading, loaded, formId);
    }
    fetchPageHtml$(formId, pageName, locale) {
        return this.genericFormService.fetchPageHtmlByName$(formId, pageName, locale);
    }
    closeTooltip(tooltip, wait) {
        this.globalFacade.closeTooltip(tooltip, wait);
    }
    getFormType(formId) {
        return this.enrollmentFormService.getSelectedFormType(formId).valueOf();
    }
    getGenericFormBaseUrl() {
        return this.genericFormService.getGenericFormBaseUrl();
    }
    observeForNavigationEvent$() {
        return this.enrollmentFormService.observeForNavigationEvent$();
    }
    updateTransaction$(pageIndex, answers, formType, formId, locale) {
        const langId = locale ? LocaleService.LOCALE_ALIAS_ID[locale] : null;
        const updateTransactionRequest = EnrollmentTransactionRequest.createUpdateTransaction(pageIndex, answers, formType, langId);
        return this.genericFormService.updateTransaction$(updateTransactionRequest, formId);
    }
    completeEnrollment$(transactionAnswers, formId) {
        return from(this.genericFormService.completeEnrollment(transactionAnswers, formId));
    }
    getEnrollmentErrorNoticeTitle(widgetName) {
        return this.formRootService.getEnrollmentErrorNoticeTitle(widgetName);
    }
    fetchTransaction$(formId) {
        return this.genericFormService.fetchTransaction$(formId);
    }
}
GenericFormFacade.ɵfac = function GenericFormFacade_Factory(t) { return new (t || GenericFormFacade)(i0.ɵɵinject(i1.GenericFormService), i0.ɵɵinject(i1.EnrollmentFormService), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(GlobalFacade), i0.ɵɵinject(i1.LocaleService), i0.ɵɵinject(FormRootService)); };
GenericFormFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GenericFormFacade, factory: GenericFormFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericFormFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.GenericFormService }, { type: i1.EnrollmentFormService }, { type: i1.ConfigResourceService }, { type: GlobalFacade }, { type: i1.LocaleService }, { type: FormRootService }]; }, null); })();

const _c0$20 = ["genericForm"];
let GenericFormComponent = class GenericFormComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, spinnerService, genericFormFacade, router, activatedRoute, navigationutilityService, enrollmentFormErrorsContext, viewContainer, authService, enrollmentFormService, genericFormService, analyticsService, store, enrollmentFormFacade) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.spinnerService = spinnerService;
        this.genericFormFacade = genericFormFacade;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.navigationutilityService = navigationutilityService;
        this.enrollmentFormErrorsContext = enrollmentFormErrorsContext;
        this.viewContainer = viewContainer;
        this.authService = authService;
        this.enrollmentFormService = enrollmentFormService;
        this.genericFormService = genericFormService;
        this.analyticsService = analyticsService;
        this.store = store;
        this.enrollmentFormFacade = enrollmentFormFacade;
        this.subscriptions = [];
        this.checkFocus = false;
    }
    navigateNext(event) {
        const validateFOAMForm = _get(event, 'detail.SPA_Validate');
        // we should always validate unless SPA_Validate has been explicitly set to false
        this.next(validateFOAMForm !== false);
    }
    navigateBack(event) {
        this.back();
    }
    onInputBlur(event) {
        const validationErrors = Array.from(_get(event, 'detail.ValidationErrors') || []).map(formError => ({
            message: formError.message,
            severity: formError.severity,
            source: MESSAGE_SOURCE.CLIENT
        }));
        // get current errors from context
        this.enrollmentFormErrorsContext
            .observeForFormErrors$()
            .pipe(take(1))
            .subscribe(errors => {
            // not sure we will have many situations where we get server errors and client side errors
            // at the same time but if we do server errors should be placed above client side errors
            const serverErrors = errors && errors.messages && errors.messages.filter(error => error.source === MESSAGE_SOURCE.SERVER);
            const updatedErrors = [...serverErrors, ...validationErrors];
            if (!_isEqual(errors, updatedErrors)) {
                this.enrollmentFormErrorsContext.addErrors({
                    title: this.genericFormFacade.getEnrollmentErrorNoticeTitle(),
                    messages: updatedErrors
                });
            }
        });
    }
    ngAfterViewChecked() {
        if (this.checkFocus) {
            const formElement = document.getElementById(this.focusFieldID);
            if (formElement) {
                formElement.focus();
            }
            this.checkFocus = false;
        }
    }
    ngOnInit() {
        super.ngOnInit();
        this.environment = EnvironmentService.getEnvironment();
        this.pageName$ = this.activatedRoute.params.pipe(pluck('pageName'));
        this.enrollingFormId = this.enrollmentFormService.getActiveEnrollmentKey();
        this.initializeSubscriptions(this.environment.liveedit);
    }
    initializeSubscriptions(liveEdit = false) {
        if (liveEdit) {
            return;
        }
        // Subscripe to page html
        this.subscriptions.push(this.pageName$
            .pipe(tap(pageName => {
            this.genericFormFacade.setPageVisited(this.enrollingFormId, pageName);
        }), switchMap(pageName => this.genericFormFacade.getPageHtml$(this.enrollingFormId, pageName)))
            .subscribe(pageHtml => {
            this.pageHtml = pageHtml;
            this.cdr.markForCheck();
        }));
        // Subscribe to loading
        this.subscriptions.push(combineLatest([this.pageName$, this.genericFormFacade.getFormLoading$(this.enrollingFormId)]).subscribe(([pageName, formLoading]) => {
            if (!pageName || formLoading) {
                this.spinnerService.show(SpinnerEvent.GENERIC_FORM_LOADING);
            }
            else {
                this.spinnerService.hide(SpinnerEvent.GENERIC_FORM_LOADING);
                this.updateTags();
            }
        }));
        // Fetch page html if locale change
        this.subscriptions.push(this.genericFormFacade.getCurrentLocale$().subscribe(locale => {
            this.locale = locale;
            this.genericFormFacade.fetchPageHtml$(this.enrollingFormId, this.pageName, locale);
        }));
        // Subscribe to page change from navigation bar
        this.subscriptions.push(this.genericFormFacade.observeForNavigationEvent$().subscribe(pageName => {
            this.navigateTo(pageName);
        }));
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }
    back() {
        // Let HOPEBundle.js know we are going to previous page
        this.viewContainer.element.nativeElement.dispatchEvent(new CustomEvent(CustomVNextEvents.ENROLLMENT_BACK, { bubbles: true }));
        // Go back a page without updating transaction
        const currentPageIndex = this.currentPageIndex();
        const pageName = this.genericFormFacade.getPageName(this.enrollingFormId, currentPageIndex - 1);
        this.navigateTo(pageName);
    }
    async next(validateFOAM = true) {
        const FOAMErrors = this.getFOAMErrors();
        if (validateFOAM && Array.isArray(FOAMErrors) && FOAMErrors.length) {
            this.handleFOAMErrors(FOAMErrors);
        }
        else {
            if (!this.authService.isCurrentTokenValid()) {
                await this.authService.loadJWT();
            }
            // Let HOPEBundle.js know we are going to next page
            this.viewContainer.element.nativeElement.dispatchEvent(new CustomEvent(CustomVNextEvents.ENROLLMENT_NEXT, { bubbles: true }));
            // Update transaction and go next page if no API error
            this.handleUpdateTransaction(() => {
                const currentPageName = this.currentPageName();
                const nextPageName = this.genericFormFacade.getPageName(this.enrollingFormId, this.currentPageIndex() + 1);
                this.genericFormFacade.setPageComplete(currentPageName, this.enrollingFormId);
                this.navigateTo(nextPageName);
            });
        }
    }
    async submit() {
        const FOAMErrors = this.getFOAMErrors();
        if (Array.isArray(FOAMErrors) && FOAMErrors.length) {
            this.handleFOAMErrors(FOAMErrors);
        }
        else {
            this.configurableWidgetService.spinnerService.show(SpinnerEvent.SUBMITTED_FORM_LOADING);
            if (!this.authService.isCurrentTokenValid()) {
                await this.authService.loadJWT();
            }
            // Update transaction and go to redirect page if no API error
            this.handleUpdateTransaction(() => {
                const currentPageName = this.currentPageName();
                this.genericFormFacade.setPageComplete(currentPageName, this.enrollingFormId);
                this.completeEnrollment(this.enrollingFormId);
            });
        }
    }
    showNext() {
        return !this.isCurrentPageLastPage();
    }
    showBack() {
        return !this.isCurrentPageFirstPage();
    }
    showSubmit() {
        return this.isCurrentPageLastPage();
    }
    currentPageName() {
        return this.activatedRoute.snapshot.params.pageName;
    }
    currentPageIndex() {
        return this.genericFormFacade.getPageIndex(this.enrollingFormId, this.currentPageName());
    }
    navigateTo(pageName) {
        // clear errors right away since if we have new errors they will show up when returned from the API
        this.enrollmentFormErrorsContext.clearFormErrors();
        // if we are navigating to the next page and the viewInitialized subject is persisting from the last page
        // then reset the subject to false so we hide the page as it loads
        if (this.childForms && this.childForms.first) {
            this.childForms.first.viewInitialized$.next(false);
        }
        if (pageName) {
            const nextPageHtml = this.genericFormFacade.getPageHtml(this.enrollingFormId, pageName);
            const nextPageDirty = this.genericFormFacade.getPageDirty(this.enrollingFormId, pageName);
            if (!nextPageHtml || nextPageDirty) {
                this.genericFormFacade
                    .fetchPageHtml$(this.enrollingFormId, pageName)
                    .toPromise()
                    .then(() => {
                    this.navigateToPage(pageName);
                    this.navigationutilityService.setFocusToMainContent();
                });
            }
            else {
                this.navigateToPage(pageName);
                this.navigationutilityService.setFocusToMainContent();
            }
        }
    }
    retrieveFOAMAnswers() {
        const inputAnswers = this.childForms.first.retrieveFormInputValues();
        return Object.keys(inputAnswers).map(key => new Answer(key, inputAnswers[key]));
    }
    handleFOAMErrors(FOAMErrors) {
        this.addFOAMErrorsAndScroll(FOAMErrors);
        this.focusFieldID = FOAMErrors[0].focusFieldID;
        this.checkFocus = true;
    }
    getFOAMErrors() {
        const validateFormMethod = window && window[VALIDATE_FORM_METHOD];
        // passing true in order to get error messages back rather than a pure boolean pass/fail result
        return !validateFormMethod || validateFormMethod(true);
    }
    addFOAMErrorsAndScroll(FOAMErrors) {
        this.addErrorsAndScroll({
            title: this.genericFormFacade.getEnrollmentErrorNoticeTitle(),
            messages: FOAMErrors.map(formError => ({
                message: formError.message,
                severity: formError.severity,
                source: MESSAGE_SOURCE.CLIENT
            }))
        });
    }
    addErrorsAndScroll(errors) {
        this.enrollmentFormErrorsContext.addErrors(errors);
        this.enrollmentFormErrorsContext
            .observeForFormErrors$()
            .pipe(take(1))
            .subscribe(() => {
            this.enrollmentFormErrorsContext.scrollToErrors();
        });
    }
    handleUpdateTransaction(onSuccess) {
        const pageIndex = this.currentPageIndex();
        const answers = this.retrieveFOAMAnswers();
        const formType = this.genericFormFacade.getFormType(this.enrollingFormId).toString();
        this.genericFormFacade
            .updateTransaction$(pageIndex, answers, formType, this.enrollingFormId, this.locale)
            .toPromise()
            .then(() => {
            const transaction = this.genericFormFacade.getTransaction(this.enrollingFormId);
            this.processTransactionResponse(transaction, onSuccess);
        });
    }
    processTransactionResponse(transaction, onSuccess) {
        if (transaction.status === EnrollmentTransactionStatus.SUCCESS || transaction.status === EnrollmentTransactionStatus.COMPLETED) {
            onSuccess();
        }
        else if (transaction.status === EnrollmentTransactionStatus.FAIL_COMPLETED && transaction.statusMessage) {
            this.addErrorsAndScroll({
                title: this.genericFormFacade.getEnrollmentErrorNoticeTitle(),
                messages: [{ message: transaction.statusMessage, severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER }]
            });
        }
        else {
            this.showServerErrors(transaction);
        }
    }
    showServerErrors(transaction) {
        // server errors don't return types so we need to assign one so the notice displays
        const serverErrors = transaction.validations && {
            title: this.genericFormFacade.getEnrollmentErrorNoticeTitle(),
            messages: transaction.validations.map(validation => ({ severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER, ...validation }))
        };
        this.addErrorsAndScroll(serverErrors);
    }
    async completeEnrollment(formId) {
        await this.genericFormFacade.fetchTransaction$(formId).toPromise();
        const transactionAnswers = this.genericFormFacade.getTransaction(formId).answers;
        this.genericFormFacade
            .completeEnrollment$(transactionAnswers, formId)
            .toPromise()
            .then(() => {
            this.processTransactionResponse(this.genericFormFacade.getTransaction(formId), () => {
                this.configurableWidgetService.spinnerService.hide(SpinnerEvent.SUBMITTED_FORM_LOADING);
                this.configurableWidgetService.navigationService.navigateByPageTag(this.Spa_GenericForm_RedirectTag);
            });
        })
            .catch(error => {
            this.genericFormFacade.setFormPageLoading$(false, false, formId);
            this.configurableWidgetService.spinnerService.hide(SpinnerEvent.SUBMITTED_FORM_LOADING);
            if (error?.status === HttpStatusCode.BAD_REQUEST && error?.error?.AdditionalInfo) {
                const errorMessages = Object.keys(error.error.AdditionalInfo).reduce((errors, errorKey) => {
                    const errorMessage = error.error.AdditionalInfo[errorKey];
                    if (errorMessage) {
                        errors.push({ message: errorMessage });
                    }
                    return errors;
                }, []);
                this.addErrorsAndScroll({
                    title: this.genericFormFacade.getEnrollmentErrorNoticeTitle(),
                    messages: errorMessages.length
                        ? errorMessages
                        : [{ message: error.message, severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER }]
                });
            }
            else {
                this.addErrorsAndScroll({
                    title: this.genericFormFacade.getEnrollmentErrorNoticeTitle(),
                    messages: [{ message: error.message, severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER }]
                });
            }
        });
    }
    navigateToPage(pageName) {
        this.router.navigate([this.genericFormFacade.getGenericFormBaseUrl(), pageName]);
    }
    isCurrentPageFirstPage() {
        return this.currentPageIndex() === 0;
    }
    isCurrentPageLastPage() {
        const pageInfos = this.genericFormFacade.getPageInfos(this.enrollingFormId);
        const currentPageIndex = this.currentPageIndex();
        return pageInfos && currentPageIndex === pageInfos.length - 1;
    }
    updateTags() {
        if (this.analyticsService.googleDataLayerTags[DataLayerGlobalVariable.PAGE_PATH] !== this.router.url) {
            const activeEnrollmentKey = this.enrollmentFormService.getActiveEnrollmentKey();
            const transaction = this.store.selectSnapshot(EnrollmentState.transaction(activeEnrollmentKey));
            const googleTagManagerNotApplicableText = this.analyticsService.getGoogleTagManagerNotApplicableText();
            const externalMemberId = this.store.selectSnapshot(DeepLinkingParamsState.ssoValue);
            const externalReferenceId = this.store.selectSnapshot(DeepLinkingParamsState.pegi);
            const enrollingPlan = this.enrollmentFormService.getSelectedPlan(activeEnrollmentKey);
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE,
                [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
                [DataLayerGlobalVariable.TRANSACTION_GUID]: transaction.transactionGUID,
                [DataLayerGlobalVariable.EXTERNAL_MEMBER_ID]: externalMemberId || googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.EXTERNAL_REFERENCE_ID]: externalReferenceId || googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.FORM_VERSION]: this.genericFormService.isAncillaryFormPage()
                    ? ANCILLARY_FORM_TYPE
                    : EnrollmentFormTypeUtillity.toApiKeyName(EnrollmentFormType.LONG),
                [DataLayerGlobalVariable.PLAN_CARRIER]: googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.PLAN_TYPE]: googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.PLAN_NAME]: enrollingPlan?.planName ?? googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.PLAN_PREMIUM_MONTHLY]: this.enrollmentFormFacade.getEnrollingPlanPremium(activeEnrollmentKey)
            };
        }
    }
};
GenericFormComponent.ɵfac = function GenericFormComponent_Factory(t) { return new (t || GenericFormComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(GenericFormFacade), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(i1.EnrollmentFormErrorsContext), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i1.AuthService), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(i1.GenericFormService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(EnrollmentFormFacade)); };
GenericFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GenericFormComponent, selectors: [["vnext-generic-form"]], viewQuery: function GenericFormComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$20, 5);
        i0.ɵɵviewQuery(GenericFormRendererComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.enrollmentForm = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childForms = _t);
    } }, hostBindings: function GenericFormComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("SpaEnrollmentNextEvent", function GenericFormComponent_SpaEnrollmentNextEvent_HostBindingHandler($event) { return ctx.navigateNext($event.target); }, false, i0.ɵɵresolveDocument)("SpaEnrollmentBackEvent", function GenericFormComponent_SpaEnrollmentBackEvent_HostBindingHandler($event) { return ctx.navigateBack($event.target); }, false, i0.ɵɵresolveDocument)("SpaInputBlurEvent", function GenericFormComponent_SpaInputBlurEvent_HostBindingHandler($event) { return ctx.onInputBlur($event); });
    } }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 9, vars: 8, consts: [[1, "container"], [1, "row"], [1, "col-12"], [1, "col-12", 2, "margin", "0 20px"], [3, "formHtml"], ["genericForm", ""], [3, "showNext", "showSubmit", "showPrevious", "showSendApplicationEmail", "previousButtonText", "nextButtonText", "submitButtonText", "sendApplicationButtonText", "enrollSubmitTooltipText", "backEvent", "nextEvent", "submitEvent", "closeTooltipEvent"]], template: function GenericFormComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵelement(3, "vnext-enrollment-notice");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 1)(5, "div", 3);
        i0.ɵɵelement(6, "vnext-generic-form-renderer", 4, 5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "vnext-enrollment-form-navigation", 6);
        i0.ɵɵlistener("backEvent", function GenericFormComponent_Template_vnext_enrollment_form_navigation_backEvent_8_listener() { return ctx.back(); })("nextEvent", function GenericFormComponent_Template_vnext_enrollment_form_navigation_nextEvent_8_listener() { return ctx.next(); })("submitEvent", function GenericFormComponent_Template_vnext_enrollment_form_navigation_submitEvent_8_listener() { return ctx.submit(); })("closeTooltipEvent", function GenericFormComponent_Template_vnext_enrollment_form_navigation_closeTooltipEvent_8_listener($event) { return ctx.genericFormFacade.closeTooltip($event); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("formHtml", ctx.pageHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("showNext", ctx.showNext())("showSubmit", ctx.showSubmit())("showPrevious", ctx.showBack())("showSendApplicationEmail", false)("previousButtonText", ctx.genericFormFacade.getPreviousText())("nextButtonText", ctx.genericFormFacade.getNextText())("submitButtonText", ctx.genericFormFacade.getSubmitText());
    } }, dependencies: [EnrollmentFormNavigationComponent, EnrollmentNoticeComponent, GenericFormRendererComponent], encapsulation: 2, changeDetection: 0 });
__decorate([
    GlobalResource()
], GenericFormComponent.prototype, "Spa_GenericForm_CompletionEmailToAgent_EmailBody", void 0);
__decorate([
    GlobalResource()
], GenericFormComponent.prototype, "Spa_GenericForm_CompletionEmailToAgent_EmailHeader", void 0);
__decorate([
    GlobalResource()
], GenericFormComponent.prototype, "Spa_GenericForm_CompletionEmailToAgent_EmailSubHeader", void 0);
__decorate([
    GlobalResource()
], GenericFormComponent.prototype, "Spa_GenericForm_CompletionEmailToAgentActive", void 0);
__decorate([
    GlobalResource()
], GenericFormComponent.prototype, "Spa_GenericForm_CompletionEmailToAgentSubject", void 0);
__decorate([
    GlobalResource()
], GenericFormComponent.prototype, "Spa_GenericForm_CustomInternal_Json", void 0);
__decorate([
    GlobalResource()
], GenericFormComponent.prototype, "Spa_GenericForm_FormId", void 0);
__decorate([
    GlobalResource()
], GenericFormComponent.prototype, "Spa_GenericForm_RedirectTag", void 0);
GenericFormComponent = __decorate([
    PlatformWidget
], GenericFormComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericFormComponent, [{
        type: Component,
        args: [{ selector: 'vnext-generic-form', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-12\">\r\n      <vnext-enrollment-notice></vnext-enrollment-notice>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-12\" style=\"margin: 0 20px;\">\r\n      <vnext-generic-form-renderer [formHtml]=\"pageHtml\" #genericForm></vnext-generic-form-renderer>\r\n    </div>\r\n  </div>\r\n  <vnext-enrollment-form-navigation\r\n    (backEvent)=\"back()\"\r\n    (nextEvent)=\"next()\"\r\n    (submitEvent)=\"submit()\"\r\n    [showNext]=\"showNext()\"\r\n    [showSubmit]=\"showSubmit()\"\r\n    [showPrevious]=\"showBack()\"\r\n    [showSendApplicationEmail]=\"false\"\r\n    [previousButtonText]=\"genericFormFacade.getPreviousText()\"\r\n    [nextButtonText]=\"genericFormFacade.getNextText()\"\r\n    [submitButtonText]=\"genericFormFacade.getSubmitText()\"\r\n    [sendApplicationButtonText]=\"\"\r\n    [enrollSubmitTooltipText]=\"\"\r\n    (closeTooltipEvent)=\"genericFormFacade.closeTooltip($event)\"\r\n  ></vnext-enrollment-form-navigation>\r\n</div>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.SpinnerService }, { type: GenericFormFacade }, { type: i2$1.Router }, { type: i2$1.ActivatedRoute }, { type: i1.NavigationUtilityService }, { type: i1.EnrollmentFormErrorsContext }, { type: i0.ViewContainerRef }, { type: i1.AuthService }, { type: i1.EnrollmentFormService }, { type: i1.GenericFormService }, { type: AnalyticsService }, { type: i2.Store }, { type: EnrollmentFormFacade }]; }, { Spa_GenericForm_CompletionEmailToAgent_EmailBody: [], Spa_GenericForm_CompletionEmailToAgent_EmailHeader: [], Spa_GenericForm_CompletionEmailToAgent_EmailSubHeader: [], Spa_GenericForm_CompletionEmailToAgentActive: [], Spa_GenericForm_CompletionEmailToAgentSubject: [], Spa_GenericForm_CustomInternal_Json: [], Spa_GenericForm_FormId: [], Spa_GenericForm_RedirectTag: [], childForms: [{
            type: ViewChildren,
            args: [GenericFormRendererComponent]
        }], enrollmentForm: [{
            type: ViewChild,
            args: ['genericForm']
        }], navigateNext: [{
            type: HostListener,
            args: [`document:${CustomFOAMEvents.ENROLLMENT_NEXT}`, ['$event.target']]
        }], navigateBack: [{
            type: HostListener,
            args: [`document:${CustomFOAMEvents.ENROLLMENT_BACK}`, ['$event.target']]
        }], onInputBlur: [{
            type: HostListener,
            args: [`${CustomFOAMEvents.INPUT_BLUR}`, ['$event']]
        }] }); })();

function GroupMessageComponent_vnext_link_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-link", 3);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tag", ctx_r0.Spa_GroupMessage_ReturnToHome_Url[0].tag)("title", ctx_r0.Spa_GroupMessage_ReturnToHome_Url[0] == null ? null : ctx_r0.Spa_GroupMessage_ReturnToHome_Url[0].title)("linkTarget", ctx_r0.Spa_GroupMessage_ReturnToHome_Url[0] == null ? null : ctx_r0.Spa_GroupMessage_ReturnToHome_Url[0].target)("alwaysUnderlined", true)("makeInline", true)("role", ctx_r0.linkRoles.LINK);
} }
function GroupMessageComponent_vnext_link_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-link", 4);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("href", ctx_r1.Spa_GroupMessage_ReturnToHome_Url[0] == null ? null : ctx_r1.Spa_GroupMessage_ReturnToHome_Url[0].href)("title", ctx_r1.Spa_GroupMessage_ReturnToHome_Url[0] == null ? null : ctx_r1.Spa_GroupMessage_ReturnToHome_Url[0].title)("linkTarget", ctx_r1.Spa_GroupMessage_ReturnToHome_Url[0] == null ? null : ctx_r1.Spa_GroupMessage_ReturnToHome_Url[0].target)("alwaysUnderlined", true)("makeInline", true)("role", ctx_r1.linkRoles.LINK);
} }
/**
 * LARGE WARNING
 * Do not use this component as is in a template. It has its own providers as it currently works outside of a template.
 * If you use this in a template without refactoring something, your providers will be overwritten and something will mess up.
 */
let GroupMessageComponent = class GroupMessageComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, imageService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.imageService = imageService;
        this.Spa_GroupMessage_Header_Image = 'phoenix/assets/images/playing_chess.png';
        this.Spa_GroupMessage_Header_Image_Mobile = 'phoenix/assets/images/404_Mobile_Image.jpg';
        this.Spa_GroupMessage_Header_Text = `More Information Needed.`;
        this.Spa_GroupMessage_Body_Text = `to continue`;
        this.Spa_GroupMessage_ReturnToHome_Url = [
            { target: '_self', href: '', tag: 'Home', title: 'Please return to home' }
        ];
        this.Spa_HeaderFooter_PrimaryClientLogo = '';
        this.Spa_HeaderFooter_PrimaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home', title: '' }];
        this.Spa_HeaderFooter_SecondaryClientLogo = '';
        this.Spa_HeaderFooter_SecondaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home', title: '' }];
        this.linkRoles = LinkRoles;
    }
    preProcessProperties() {
        this.groupMessageHeaderImageUrl = this.imageService.resolveFullImagePath(this.Spa_GroupMessage_Header_Image);
        this.groupMessageHeaderImageMobileUrl = this.imageService.resolveFullImagePath(this.Spa_GroupMessage_Header_Image_Mobile);
    }
};
GroupMessageComponent.ɵfac = function GroupMessageComponent_Factory(t) { return new (t || GroupMessageComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.ImageService)); };
GroupMessageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GroupMessageComponent, selectors: [["vnext-group-message"]], features: [i0.ɵɵProvidersFeature([WidgetService, WidgetValidationService, ZoneService]), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 10, consts: [[3, "imageUrl", "imageMobileUrl", "headerText", "bodyText", "headerFooterPrimaryClientLogo", "headerFooterPrimaryClientLogoUrl", "headerFooterSecondaryClientLogo", "headerFooterSecondaryClientLogoUrl"], [3, "tag", "title", "linkTarget", "alwaysUnderlined", "makeInline", "role", 4, "ngIf"], [3, "href", "title", "linkTarget", "alwaysUnderlined", "makeInline", "role", 4, "ngIf"], [3, "tag", "title", "linkTarget", "alwaysUnderlined", "makeInline", "role"], [3, "href", "title", "linkTarget", "alwaysUnderlined", "makeInline", "role"]], template: function GroupMessageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-image-banner-container", 0);
        i0.ɵɵtemplate(1, GroupMessageComponent_vnext_link_1_Template, 1, 6, "vnext-link", 1);
        i0.ɵɵtemplate(2, GroupMessageComponent_vnext_link_2_Template, 1, 6, "vnext-link", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("imageUrl", ctx.groupMessageHeaderImageUrl)("imageMobileUrl", ctx.groupMessageHeaderImageMobileUrl)("headerText", ctx.Spa_GroupMessage_Header_Text)("bodyText", ctx.Spa_GroupMessage_Body_Text)("headerFooterPrimaryClientLogo", ctx.Spa_HeaderFooter_PrimaryClientLogo)("headerFooterPrimaryClientLogoUrl", ctx.Spa_HeaderFooter_PrimaryClientLogo_Url)("headerFooterSecondaryClientLogo", ctx.Spa_HeaderFooter_SecondaryClientLogo)("headerFooterSecondaryClientLogoUrl", ctx.Spa_HeaderFooter_SecondaryClientLogo_Url);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_GroupMessage_ReturnToHome_Url[0] == null ? null : ctx.Spa_GroupMessage_ReturnToHome_Url[0].tag);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_GroupMessage_ReturnToHome_Url[0] == null ? null : ctx.Spa_GroupMessage_ReturnToHome_Url[0].href);
    } }, dependencies: [i1$2.NgIf, LinkComponent, ImageBannerContainerComponent], encapsulation: 2, changeDetection: 0 });
__decorate([
    GlobalResource(true)
], GroupMessageComponent.prototype, "Spa_GroupMessage_Header_Image", void 0);
__decorate([
    GlobalResource(true)
], GroupMessageComponent.prototype, "Spa_GroupMessage_Header_Image_Mobile", void 0);
__decorate([
    GlobalResource()
], GroupMessageComponent.prototype, "Spa_GroupMessage_Header_Text", void 0);
__decorate([
    GlobalResource()
], GroupMessageComponent.prototype, "Spa_GroupMessage_Body_Text", void 0);
__decorate([
    GlobalResource()
], GroupMessageComponent.prototype, "Spa_GroupMessage_ReturnToHome_Url", void 0);
__decorate([
    GlobalResource()
], GroupMessageComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo", void 0);
__decorate([
    GlobalResource()
], GroupMessageComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo_Url", void 0);
__decorate([
    GlobalResource()
], GroupMessageComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo", void 0);
__decorate([
    GlobalResource()
], GroupMessageComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo_Url", void 0);
GroupMessageComponent = __decorate([
    PlatformWidget
], GroupMessageComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GroupMessageComponent, [{
        type: Component,
        args: [{ selector: 'vnext-group-message', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService, WidgetValidationService, ZoneService], template: "<vnext-image-banner-container\r\n  [imageUrl]=\"groupMessageHeaderImageUrl\"\r\n  [imageMobileUrl]=\"groupMessageHeaderImageMobileUrl\"\r\n  [headerText]=\"Spa_GroupMessage_Header_Text\"\r\n  [bodyText]=\"Spa_GroupMessage_Body_Text\"\r\n  [headerFooterPrimaryClientLogo]=\"Spa_HeaderFooter_PrimaryClientLogo\"\r\n  [headerFooterPrimaryClientLogoUrl]=\"Spa_HeaderFooter_PrimaryClientLogo_Url\"\r\n  [headerFooterSecondaryClientLogo]=\"Spa_HeaderFooter_SecondaryClientLogo\"\r\n  [headerFooterSecondaryClientLogoUrl]=\"Spa_HeaderFooter_SecondaryClientLogo_Url\"\r\n>\r\n  <vnext-link\r\n    *ngIf=\"Spa_GroupMessage_ReturnToHome_Url[0]?.tag\"\r\n    [tag]=\"Spa_GroupMessage_ReturnToHome_Url[0].tag\"\r\n    [title]=\"Spa_GroupMessage_ReturnToHome_Url[0]?.title\"\r\n    [linkTarget]=\"Spa_GroupMessage_ReturnToHome_Url[0]?.target\"\r\n    [alwaysUnderlined]=\"true\"\r\n    [makeInline]=\"true\"\r\n    [role]=\"linkRoles.LINK\"\r\n    ></vnext-link>\r\n    <vnext-link\r\n    *ngIf=\"Spa_GroupMessage_ReturnToHome_Url[0]?.href\"\r\n    [href]=\"Spa_GroupMessage_ReturnToHome_Url[0]?.href\"\r\n    [title]=\"Spa_GroupMessage_ReturnToHome_Url[0]?.title\"\r\n    [linkTarget]=\"Spa_GroupMessage_ReturnToHome_Url[0]?.target\"\r\n    [alwaysUnderlined]=\"true\"\r\n    [makeInline]=\"true\"\r\n    [role]=\"linkRoles.LINK\"\r\n    ></vnext-link>\r\n</vnext-image-banner-container>" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.ImageService }]; }, { Spa_GroupMessage_Header_Image: [], Spa_GroupMessage_Header_Image_Mobile: [], Spa_GroupMessage_Header_Text: [], Spa_GroupMessage_Body_Text: [], Spa_GroupMessage_ReturnToHome_Url: [], Spa_HeaderFooter_PrimaryClientLogo: [], Spa_HeaderFooter_PrimaryClientLogo_Url: [], Spa_HeaderFooter_SecondaryClientLogo: [], Spa_HeaderFooter_SecondaryClientLogo_Url: [] }); })();

function GuidedHelpBlockComponent_div_0_h2_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h2", 11);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r1.Spa_GuidedHelp_EnterPreference_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function GuidedHelpBlockComponent_div_0_p_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 12);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r2.Spa_GuidedHelp_EnterPreferenceBody_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function GuidedHelpBlockComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3);
    i0.ɵɵelement(3, "i", 4)(4, "i", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 6);
    i0.ɵɵtemplate(6, GuidedHelpBlockComponent_div_0_h2_6_Template, 2, 4, "h2", 7);
    i0.ɵɵtemplate(7, GuidedHelpBlockComponent_div_0_p_7_Template, 2, 4, "p", 8);
    i0.ɵɵelementStart(8, "div", 9)(9, "vnext-link", 10);
    i0.ɵɵlistener("click", function GuidedHelpBlockComponent_div_0_Template_vnext_link_click_9_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.onLinkClick()); })("keyup.enter", function GuidedHelpBlockComponent_div_0_Template_vnext_link_keyup_enter_9_listener() { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onLinkClick()); });
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("liveEditProp", "Spa_GuidedHelp_EnterPreference_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_GuidedHelp_EnterPreferenceBody_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", ctx_r0.Spa_GuidedHelp_EnterPreferenceLink_Text)("keyNameForLiveEdit", "Spa_GuidedHelp_EnterPreferenceLink_Text");
} }
let GuidedHelpBlockComponent = class GuidedHelpBlockComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, guidedHelpService, analyticsService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.guidedHelpService = guidedHelpService;
        this.analyticsService = analyticsService;
        this.Spa_GuidedHelp_Enabled = true;
        this.Spa_GuidedHelpBlock_Enabled = true;
        this.Spa_GuidedHelp_EnterPreference_Text = 'Enter your preferences';
        this.Spa_GuidedHelp_EnterPreferenceLink_Text = 'Enter your preferences';
        this.Spa_GuidedHelp_EnterPreferenceBody_Text = `You will be able to enter your doctors, prescriptions,
    and pharmacy to get a best match plan. We'll estimate out-of-pocket spending to help you find a plan that saves you money.`;
    }
    onLinkClick() {
        this.guidedHelpService.updateZipAndFipsForGuidedHelp();
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_HOME_ENTER_PREFERENCES);
        this.guidedHelpService.goToFirstLink();
    }
};
GuidedHelpBlockComponent.ɵfac = function GuidedHelpBlockComponent_Factory(t) { return new (t || GuidedHelpBlockComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(AnalyticsService)); };
GuidedHelpBlockComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GuidedHelpBlockComponent, selectors: [["vnext-guided-help-block"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "container", 4, "ngIf"], [1, "container"], [1, "row"], [1, "fa-stack", "fa-2x", "pl-0", "col-md-1", "col-12", "mb-3"], [1, "fal", "fa-circle", "fa-stack-2x", "Spa_Style_Accent4_Color"], [1, "fas", "Spa_Style_EditIcon", "fa-stack-1x", "Spa_Style_Accent4_Color"], [1, "col-md-11", "col-xs-12", "text-center", "text-md-left"], ["class", "Spa_Style_H2", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["class", "Spa_Style_Paragraph", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [1, "width-fit-content"], [3, "title", "keyNameForLiveEdit", "click", "keyup.enter"], ["navigationAdapter", "", 1, "Spa_Style_H2", 3, "innerHtml"], ["navigationAdapter", "", 1, "Spa_Style_Paragraph", 3, "innerHtml"]], template: function GuidedHelpBlockComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, GuidedHelpBlockComponent_div_0_Template, 10, 4, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.Spa_GuidedHelp_Enabled && ctx.Spa_GuidedHelpBlock_Enabled);
    } }, dependencies: [i1$2.NgIf, LinkComponent, NavigationAdapterDirective, LiveEditPropDirective, IconAriaAttributesDirective, SafePipe], styles: [".container[_ngcontent-%COMP%]{margin-top:80px;margin-bottom:80px}"] });
__decorate([
    GlobalResource()
], GuidedHelpBlockComponent.prototype, "Spa_GuidedHelp_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpBlockComponent.prototype, "Spa_GuidedHelpBlock_Enabled", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpBlockComponent.prototype, "Spa_GuidedHelp_EnterPreference_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpBlockComponent.prototype, "Spa_GuidedHelp_EnterPreferenceLink_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpBlockComponent.prototype, "Spa_GuidedHelp_EnterPreferenceBody_Text", void 0);
__decorate([
    LiveEditInactive()
], GuidedHelpBlockComponent.prototype, "onLinkClick", null);
GuidedHelpBlockComponent = __decorate([
    PlatformWidget
], GuidedHelpBlockComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuidedHelpBlockComponent, [{
        type: Component,
        args: [{ selector: 'vnext-guided-help-block', providers: [WidgetService], template: "<div class=\"container\" *ngIf=\"Spa_GuidedHelp_Enabled && Spa_GuidedHelpBlock_Enabled\">\r\n  <div class=\"row\">\r\n    <div class=\"fa-stack fa-2x pl-0 col-md-1 col-12 mb-3\">\r\n      <i class=\"fal fa-circle fa-stack-2x Spa_Style_Accent4_Color\"></i>\r\n      <i class=\"fas Spa_Style_EditIcon fa-stack-1x Spa_Style_Accent4_Color\"></i>\r\n    </div>\r\n    <div class=\"col-md-11 col-xs-12 text-center text-md-left\">\r\n      <h2\r\n        class=\"Spa_Style_H2\"\r\n        *liveEditProp=\"'Spa_GuidedHelp_EnterPreference_Text'\"\r\n        [innerHtml]=\"Spa_GuidedHelp_EnterPreference_Text | safe: 'html'\"\r\n        navigationAdapter\r\n      ></h2>\r\n      <p\r\n        class=\"Spa_Style_Paragraph\"\r\n        *liveEditProp=\"'Spa_GuidedHelp_EnterPreferenceBody_Text'\"\r\n        [innerHtml]=\"Spa_GuidedHelp_EnterPreferenceBody_Text | safe: 'html'\"\r\n        navigationAdapter\r\n      ></p>\r\n      <div class=\"width-fit-content\">\r\n        <vnext-link\r\n          [title]=\"Spa_GuidedHelp_EnterPreferenceLink_Text\"\r\n          [keyNameForLiveEdit]=\"'Spa_GuidedHelp_EnterPreferenceLink_Text'\"\r\n          (click)=\"onLinkClick()\"\r\n          (keyup.enter)=\"onLinkClick()\"\r\n        ></vnext-link>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".container{margin-top:80px;margin-bottom:80px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.GuidedHelpService }, { type: AnalyticsService }]; }, { Spa_GuidedHelp_Enabled: [], Spa_GuidedHelpBlock_Enabled: [], Spa_GuidedHelp_EnterPreference_Text: [], Spa_GuidedHelp_EnterPreferenceLink_Text: [], Spa_GuidedHelp_EnterPreferenceBody_Text: [], onLinkClick: [] }); })();

class GuidedHelpCoverageTypeComponent {
    constructor(guidedHelpService, cdr) {
        this.guidedHelpService = guidedHelpService;
        this.cdr = cdr;
        this.defaultCoverageTypes = [];
        this.coverageTypes = [];
        this.isMobileOrTablet = false;
        this.subscriptions = new Subscription();
    }
    ngOnChanges(changes) {
        const { defaultCoverageTypes } = changes;
        if (defaultCoverageTypes && !_isEqual(defaultCoverageTypes.currentValue, defaultCoverageTypes.previousValue)) {
            this.setCoverageTypes(this.isMobileOrTablet);
        }
    }
    ngOnInit() {
        this.subscriptions.add(combineLatest([this.guidedHelpService.isMedium$, this.guidedHelpService.isMobile$])
            .pipe(map(([isMedium, isMobile]) => isMedium || isMobile))
            .subscribe(isMobileOrTablet => {
            this.isMobileOrTablet = isMobileOrTablet;
            this.setCoverageTypes(isMobileOrTablet);
            this.cdr.markForCheck();
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    onOptionSelect(event) {
        const selectedCoverageType = event.data.value;
        this.guidedHelpService.selectCoverageType(selectedCoverageType, this.medicalOnlyDefault);
    }
    setCoverageTypes(useMobileIcons) {
        const medicalOnly = this.defaultCoverageTypes.find(coverageType => coverageType.key === CoverageType.MEDICAL_ONLY);
        const prescriptionDrug = this.defaultCoverageTypes.find(coverageType => coverageType.key === CoverageType.PRESCRIPTION_DRUG);
        const medicalAndPrescriptionDrug = this.defaultCoverageTypes.find(coverageType => coverageType.key === CoverageType.MEDICAL_AND_PRESCRIPTION_DRUG);
        const iDontKnow = this.defaultCoverageTypes.find(coverageType => coverageType.key === CoverageType.I_DONT_KNOW);
        const preCoverageTypes = [
            {
                display: `<div class="d-flex justify-content-xs-start justify-content-lg-center">
      <div class="col-2 pl-0 text-center my-auto"><i class="fas fa-plus Spa_Style_Accent2_Color ${useMobileIcons ? 'fa-lg' : ''}" aria-hidden="true"></i></div>
      <div class="my-auto ${useMobileIcons ? 'Spa_Style_Regular_Font pl-1' : ''}">
      ${medicalOnly?.title}
      </div>
      </div>
      `,
                value: CoverageType.MEDICAL_ONLY,
                visible: medicalOnly?.display,
                ordinal: medicalOnly?.ordinal
            },
            {
                display: `<div class="d-flex justify-content-xs-start justify-content-lg-center">
                  <div class="col-2 pl-0 text-center align-self-center">
                    <i class="fas Spa_Style_PrescriptionsIcon ${useMobileIcons ? 'fa-lg' : ''}" aria-hidden="true"></i>
                    </div>
                    <span class="my-auto ${useMobileIcons ? 'Spa_Style_Regular_Font pl-1' : ''}">
                    ${prescriptionDrug?.title}
                    </span>
                </div>`,
                value: CoverageType.PRESCRIPTION_DRUG,
                visible: prescriptionDrug?.display,
                ordinal: prescriptionDrug?.ordinal
            },
            {
                display: `<div class="d-flex justify-content-xs-start justify-content-lg-center">
                  <div class="d-flex col-2 pl-0 col-lg-2 justify-content-sm-center justify-content-lg-start align-self-center mt-n1">
                  <i class="fas fa-plus Spa_Style_Accent2_Color mt-2 pt-0 pt-md-1 ${useMobileIcons ? 'fa-lg' : ''}" aria-hidden="true"></i>
                  <i class="fas Spa_Style_PrescriptionsIcon mt-3 pt-0 pt-md-1 ${useMobileIcons ? 'fa-lg' : ''}" aria-hidden="true"></i>
                  </div>
                  <div class="my-auto text-left pl-lg-2 ${useMobileIcons ? 'Spa_Style_Regular_Font pl-1' : ''}">
                   ${medicalAndPrescriptionDrug?.title}</div>
                 </div>`,
                value: CoverageType.MEDICAL_AND_PRESCRIPTION_DRUG,
                visible: medicalAndPrescriptionDrug?.display,
                ordinal: medicalAndPrescriptionDrug?.ordinal
            },
            {
                display: `<div class="d-flex justify-content-xs-start justify-content-lg-center">
      <div class="col-2 pl-0 text-center align-self-center">
        <i class="fas Spa_Style_QuestionIcon ${useMobileIcons ? 'fa-lg' : ''}" aria-hidden="true"></i>
        </div>
        <div class="my-auto ${useMobileIcons ? 'Spa_Style_Regular_Font pl-1' : ''}">
      ${iDontKnow?.title}
      </div>`,
                value: CoverageType.I_DONT_KNOW,
                visible: iDontKnow?.display,
                ordinal: iDontKnow?.ordinal
            }
        ];
        this.coverageTypes = preCoverageTypes.filter(coverageType => !!coverageType.visible).sort((a, b) => a.ordinal - b.ordinal);
        const BUTTONS_WITH_LIMIT_WIDTH = 2;
        this.limitButtonWidth = this.coverageTypes.length <= BUTTONS_WITH_LIMIT_WIDTH;
    }
    coverageType() {
        return this.guidedHelpService.coverageType();
    }
}
GuidedHelpCoverageTypeComponent.ɵfac = function GuidedHelpCoverageTypeComponent_Factory(t) { return new (t || GuidedHelpCoverageTypeComponent)(i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
GuidedHelpCoverageTypeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GuidedHelpCoverageTypeComponent, selectors: [["vnext-guided-help-coverage-type"]], inputs: { optionalLabel: "optionalLabel", coverageTextQuestion: "coverageTextQuestion", medicalOnlyDefault: "medicalOnlyDefault", secondaryButtonTextColor: "secondaryButtonTextColor", defaultCoverageTypes: "defaultCoverageTypes" }, features: [i0.ɵɵProvidersFeature([InputResetContextService]), i0.ɵɵNgOnChangesFeature], decls: 7, vars: 10, consts: [[1, "mb-4"], ["id", "coverage-question-text", 1, "Spa_Style_H4"], ["id", "coverage-question-optional-text", 1, "Spa_Style_Gray4_Color"], [3, "selectedValue", "items", "verticalGrow", "ariaLabelledById", "toggleControlId", "secondaryButtonTextColor", "limitButtonWidth", "limitButtonWidthClass", "optionSelected"]], template: function GuidedHelpCoverageTypeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "p")(2, "span", 1);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "span", 2);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "vnext-toggle-select", 3);
        i0.ɵɵlistener("optionSelected", function GuidedHelpCoverageTypeComponent_Template_vnext_toggle_select_optionSelected_6_listener($event) { return ctx.onOptionSelect($event); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.coverageTextQuestion);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.optionalLabel, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("selectedValue", ctx.coverageType())("items", ctx.coverageTypes)("verticalGrow", ctx.isMobileOrTablet)("ariaLabelledById", "coverage-question-text coverage-question-optional-text")("toggleControlId", "guidedhelp-coverage")("secondaryButtonTextColor", ctx.secondaryButtonTextColor)("limitButtonWidth", ctx.limitButtonWidth)("limitButtonWidthClass", "col-12 col-lg-6 px-0");
    } }, dependencies: [ToggleSelectComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuidedHelpCoverageTypeComponent, [{
        type: Component,
        args: [{ selector: 'vnext-guided-help-coverage-type', providers: [InputResetContextService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"mb-4\">\r\n  <p>\r\n    <span class=\"Spa_Style_H4\" id=\"coverage-question-text\">{{ coverageTextQuestion }}</span>\r\n    <span class=\"Spa_Style_Gray4_Color\" id=\"coverage-question-optional-text\"> {{ optionalLabel }} </span>\r\n  </p>\r\n  <vnext-toggle-select\r\n    [selectedValue]=\"coverageType()\"\r\n    [items]=\"coverageTypes\"\r\n    [verticalGrow]=\"isMobileOrTablet\"\r\n    (optionSelected)=\"onOptionSelect($event)\"\r\n    [ariaLabelledById]=\"'coverage-question-text coverage-question-optional-text'\"\r\n    [toggleControlId]=\"'guidedhelp-coverage'\"\r\n    [secondaryButtonTextColor]=\"secondaryButtonTextColor\"\r\n    [limitButtonWidth]=\"limitButtonWidth\"\r\n    [limitButtonWidthClass]=\"'col-12 col-lg-6 px-0'\"\r\n  ></vnext-toggle-select>\r\n</div>\r\n" }]
    }], function () { return [{ type: i1.GuidedHelpService }, { type: i0.ChangeDetectorRef }]; }, { optionalLabel: [{
            type: Input
        }], coverageTextQuestion: [{
            type: Input
        }], medicalOnlyDefault: [{
            type: Input
        }], secondaryButtonTextColor: [{
            type: Input
        }], defaultCoverageTypes: [{
            type: Input
        }] }); })();

class GuidedHelpZipCodeComponent {
    constructor(widgetValidationService) {
        this.widgetValidationService = widgetValidationService;
        this.zipCodeIsReadOnly = false;
        this.roundRightBorder = true;
        this.zipCodeStyles = { roundInputRightBorder: true };
        this.setLocationAndDemographics = new EventEmitter();
    }
    ngOnInit() {
        this.zipCodeInputSelectedCountyEnabled = this.selectedCountyEnabled === null ? true : JSON.parse(this.selectedCountyEnabled);
    }
    updateZip(zip) {
        this.zip = zip;
        if (this.fips && this.zip && this.widgetValidationService.validate().length === 0) {
            this.setLocationAndDemographics.emit({ zip: this.zip, fips: this.fips });
        }
    }
    updateFips(fips) {
        this.fips = fips;
        if (this.fips && this.zip) {
            this.widgetValidationService.validate();
            this.setLocationAndDemographics.emit({ zip: this.zip, fips: this.fips });
        }
    }
}
GuidedHelpZipCodeComponent.ɵfac = function GuidedHelpZipCodeComponent_Factory(t) { return new (t || GuidedHelpZipCodeComponent)(i0.ɵɵdirectiveInject(i1.WidgetValidationService)); };
GuidedHelpZipCodeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GuidedHelpZipCodeComponent, selectors: [["vnext-guided-help-zip-code"]], inputs: { zipCodeInputZipCodeError: "zipCodeInputZipCodeError", zipCodeInputCountyError: "zipCodeInputCountyError", zipCodeInputSelectCounty: "zipCodeInputSelectCounty", zipCodeInputZipCodeLabel: "zipCodeInputZipCodeLabel", selectedCountyEnabled: "selectedCountyEnabled", zipCodeInputEditCounty: "zipCodeInputEditCounty", zipCodeIsReadOnly: "zipCodeIsReadOnly", errorKeywordText: "errorKeywordText", searchButtonTemplate: "searchButtonTemplate", roundRightBorder: "roundRightBorder", zipCodeStyles: "zipCodeStyles", countyLabel: "countyLabel", showCountyLabel: "showCountyLabel" }, outputs: { setLocationAndDemographics: "setLocationAndDemographics" }, decls: 2, vars: 12, consts: [[3, "selectedCountyEnabled", "zipCodeErrorText", "countyErrorText", "selectCountyText", "zipCodeText", "editCountyText", "customStyles", "errorKeywordText", "searchButtonTemplate", "isReadOnly", "countyLabel", "showCountyLabel", "fips", "zip"]], template: function GuidedHelpZipCodeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div")(1, "vnext-zip-code-input", 0);
        i0.ɵɵlistener("fips", function GuidedHelpZipCodeComponent_Template_vnext_zip_code_input_fips_1_listener($event) { return ctx.updateFips($event); })("zip", function GuidedHelpZipCodeComponent_Template_vnext_zip_code_input_zip_1_listener($event) { return ctx.updateZip($event); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("selectedCountyEnabled", ctx.zipCodeInputSelectedCountyEnabled)("zipCodeErrorText", ctx.zipCodeInputZipCodeError)("countyErrorText", ctx.zipCodeInputCountyError)("selectCountyText", ctx.zipCodeInputSelectCounty)("zipCodeText", ctx.zipCodeInputZipCodeLabel)("editCountyText", ctx.zipCodeInputEditCounty)("customStyles", ctx.zipCodeStyles)("errorKeywordText", ctx.errorKeywordText)("searchButtonTemplate", ctx.searchButtonTemplate)("isReadOnly", ctx.zipCodeIsReadOnly)("countyLabel", ctx.countyLabel)("showCountyLabel", ctx.showCountyLabel);
    } }, dependencies: [ZipCodeInputComponent], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuidedHelpZipCodeComponent, [{
        type: Component,
        args: [{ selector: 'vnext-guided-help-zip-code', template: "<div>\r\n  <vnext-zip-code-input\r\n    [selectedCountyEnabled]=\"zipCodeInputSelectedCountyEnabled\"\r\n    [zipCodeErrorText]=\"zipCodeInputZipCodeError\"\r\n    [countyErrorText]=\"zipCodeInputCountyError\"\r\n    [selectCountyText]=\"zipCodeInputSelectCounty\"\r\n    [zipCodeText]=\"zipCodeInputZipCodeLabel\"\r\n    [editCountyText]=\"zipCodeInputEditCounty\"\r\n    [customStyles]=\"zipCodeStyles\"\r\n    (fips)=\"updateFips($event)\"\r\n    (zip)=\"updateZip($event)\"\r\n    [errorKeywordText]=\"errorKeywordText\"\r\n    [searchButtonTemplate]=\"searchButtonTemplate\"\r\n    [isReadOnly]=\"zipCodeIsReadOnly\"\r\n    [countyLabel]=\"countyLabel\"\r\n    [showCountyLabel]=\"showCountyLabel\"\r\n  ></vnext-zip-code-input>\r\n</div>\r\n" }]
    }], function () { return [{ type: i1.WidgetValidationService }]; }, { zipCodeInputZipCodeError: [{
            type: Input
        }], zipCodeInputCountyError: [{
            type: Input
        }], zipCodeInputSelectCounty: [{
            type: Input
        }], zipCodeInputZipCodeLabel: [{
            type: Input
        }], selectedCountyEnabled: [{
            type: Input
        }], zipCodeInputEditCounty: [{
            type: Input
        }], zipCodeIsReadOnly: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], searchButtonTemplate: [{
            type: Input
        }], roundRightBorder: [{
            type: Input
        }], zipCodeStyles: [{
            type: Input
        }], countyLabel: [{
            type: Input
        }], showCountyLabel: [{
            type: Input
        }], setLocationAndDemographics: [{
            type: Output
        }] }); })();

function GuidedHelpGetStartedComponent_h1_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.getStartedText);
} }
function GuidedHelpGetStartedComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r1.spaPageSubHeader ? i0.ɵɵpipeBind2(1, 1, ctx_r1.spaPageSubHeader, "html") : "", i0.ɵɵsanitizeHtml);
} }
function GuidedHelpGetStartedComponent_p_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.zipCodeHintText);
} }
function GuidedHelpGetStartedComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-guided-help-coverage-type", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("optionalLabel", ctx_r3.optionalLabel)("coverageTextQuestion", ctx_r3.coverageTextQuestion)("medicalOnlyDefault", ctx_r3.medicalOnlyDefault)("secondaryButtonTextColor", ctx_r3.secondaryButtonTextColor)("defaultCoverageTypes", ctx_r3.defaultCoverageTypes);
} }
function GuidedHelpGetStartedComponent_div_9_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r5.accordionHeaderText);
} }
function GuidedHelpGetStartedComponent_div_9_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.optionalLabel);
} }
function GuidedHelpGetStartedComponent_div_9_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "span", 20);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r7.errorKeywordText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r7.subsidyError.message, " ");
} }
function GuidedHelpGetStartedComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "p");
    i0.ɵɵtemplate(2, GuidedHelpGetStartedComponent_div_9_span_2_Template, 2, 1, "span", 12);
    i0.ɵɵtemplate(3, GuidedHelpGetStartedComponent_div_9_span_3_Template, 2, 1, "span", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, GuidedHelpGetStartedComponent_div_9_div_4_Template, 4, 2, "div", 14);
    i0.ɵɵelementStart(5, "div", 15)(6, "vnext-accordion", 16);
    i0.ɵɵlistener("valueSelected", function GuidedHelpGetStartedComponent_div_9_Template_vnext_accordion_valueSelected_6_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.receiveValueFromSubsidyAccordion($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_GettingStarted_SubsidyHeader_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_GuidedHelp_OptionalLabel_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.subsidyError);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("items", ctx_r4.subsidyAccordionItems)("allowParentValues", true)("selectedParent", ctx_r4.selectedParentId)("selectedChild", ctx_r4.selectedChildId)("emitParentValueWhenNoChildrenSelected", true)("ariaDescribedById", ctx_r4.subsidyError ? "getStartedSubsidyError" : "")("ariaLabelledById", "extra-help-for-drugs-text extra-help-for-drugs-optional-text")("largerText", true)("isMobile", ctx_r4.isMobile)("buttonHeight", "36px")("secondaryButtonTextColor", ctx_r4.secondaryButtonTextColor);
} }
class GuidedHelpGetStartedComponent {
    // TODO  these services will have to be moved into guide service
    constructor(planFacade, configResourceService, demographicService, store, guidedHelpService, widgetValidationService, widgetService, localeService, cdr, helpfulToolsService, snpService) {
        this.planFacade = planFacade;
        this.configResourceService = configResourceService;
        this.demographicService = demographicService;
        this.store = store;
        this.guidedHelpService = guidedHelpService;
        this.widgetValidationService = widgetValidationService;
        this.widgetService = widgetService;
        this.localeService = localeService;
        this.cdr = cdr;
        this.helpfulToolsService = helpfulToolsService;
        this.snpService = snpService;
        this.enableDSNPDisplay = true;
        this.zipCodeIsReadOnly = false;
        this.coverageTypeEnabled = this.guidedHelpService.coverageTypeEnabled;
        this.coverageType = CoverageType;
        this.checkForCoverageTypeValid = false;
        this.checkForZipCodeInputValid = false;
        this.validateWidget = () => {
            const errors = [];
            this.checkForZipCodeInputValid = true;
            const baseError = {
                severity: 'error',
                widgetId: this.widgetService.widgetId,
                errorData: null
            };
            const coverageType = this.guidedHelpService.coverageType();
            if (this.showSubsidyAccordion) {
                // if the site is not configured to show the subsidy accordion, we don't need to bother validating anything related to it
                const subsidyPercent = this.store.selectSnapshot(DemographicState.subsidyPercent);
                const subsidySelected = this.store.selectSnapshot(DemographicState.subsidySelected);
                if (subsidySelected === 3 && subsidyPercent === null && coverageType !== CoverageType.MEDICAL_ONLY) {
                    const subsidyErrorText = this.configResourceService.getProcessedResourceValue('Spa_GettingStarted_SubsidyError_Text', null, 'Please select percentage of extra help received');
                    this.subsidyError = { ...baseError, message: subsidyErrorText, property: 'Subsidy accordion' };
                    errors.push(this.subsidyError);
                    this.checkForCoverageTypeValid = true;
                }
            }
            return errors;
        };
        this.validatorId = uuid();
    }
    ngOnInit() {
        const subsidyPercent = this.store.selectSnapshot(DemographicState.subsidyPercent);
        const subsidySelected = this.store.selectSnapshot(DemographicState.subsidySelected);
        this.secondaryButtonTextColor = this.helpfulToolsService.getSecondaryButtonTextColor();
        if (subsidyPercent) {
            this.selectedChildId = `${subsidyPercent}`;
            this.selectedParentId = `${subsidySelected}`;
        }
        else {
            this.selectedParentId = `${subsidySelected}`;
            this.selectedChildId = '';
        }
        this.widgetValidationService.addWidgetValidator({
            widgetId: this.widgetService.widgetId,
            validator: this.validateWidget,
            validatorId: this.validatorId
        });
        this.subscriptions = [
            this.localeService.getCurrentLocale$().subscribe(locale => {
                this.subsidyAccordionItems = this.planFacade.subsidyAccordionItems;
                this.cdr.markForCheck();
            })
        ];
    }
    ngAfterViewChecked() {
        if (this.checkForZipCodeInputValid) {
            const invalidZipFormInput = document.querySelector('input.has-error');
            const invalidZipFormInputElement = invalidZipFormInput;
            const invalidCountyFormInput = document.querySelector('.county-error .county-dropdown-item');
            const invalidCountyFormInputElement = invalidCountyFormInput;
            const acordionSelector = document.querySelector('.outer-accordion-button[id="3"]');
            const accordonNativeElenment = acordionSelector;
            if (invalidZipFormInputElement) {
                invalidZipFormInputElement.focus();
            }
            else if (invalidCountyFormInputElement) {
                invalidCountyFormInputElement.focus();
            }
            else if (this.checkForCoverageTypeValid && !invalidZipFormInputElement && !invalidCountyFormInputElement) {
                if (accordonNativeElenment) {
                    accordonNativeElenment.focus();
                }
            }
            this.checkForZipCodeInputValid = false;
            this.checkForCoverageTypeValid = false;
        }
    }
    showSubsidyContent() {
        return this.checkOnlySubsidy() || this.checkSubsidyWithCoverage();
    }
    checkOnlySubsidy() {
        return this.showSubsidyAccordion && !this.coverageTypeEnabled;
    }
    checkSubsidyWithCoverage() {
        const selectedCoverageType = this.guidedHelpService.coverageType();
        return (this.showSubsidyAccordion &&
            this.coverageTypeEnabled &&
            selectedCoverageType &&
            this.coverageType.MEDICAL_ONLY !== selectedCoverageType);
    }
    receiveValueFromSubsidyAccordion($event) {
        let idAsNumber = parseInt($event.id, 10);
        this.guidedHelpService.updateMemberPreferenceSubsidyAnalytics(idAsNumber);
        if (SubsidySelected.hasOwnProperty(idAsNumber)) {
            if (idAsNumber === SubsidySelected.DONT_KNOW) {
                idAsNumber = SubsidySelected.NONE;
            }
            this.store.dispatch(new SelectSubsidySelected(idAsNumber));
        }
        else {
            this.store.dispatch(new SelectSubsidyPercent(idAsNumber));
        }
        this.demographicService.updateDemographicSession();
        this.store.dispatch(new SetPlansDirty(true, [ALL_MEDICARE_PLAN_TYPE_VALUE]));
        this.subsidyError = null;
    }
    updateLocationAndDemographics(location) {
        const previousZip = this.demographicService.getSelectedZipCode();
        const previousFips = this.demographicService.getSelectedFipsCode();
        if (previousZip !== location.zip || previousFips !== location.fips) {
            this.guidedHelpService.selectZip(location.fips, location.zip);
            this.demographicService.updateDemographicSession();
            this.helpfulToolsService.selectLocation(location.zip, location.fips);
        }
    }
    get coverageType$() {
        return this.guidedHelpService.coverageType$();
    }
    get activeLink() {
        return this.guidedHelpService.links.find(link => link.status === 'selected');
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
        this.snpService.setDSNPTypesVisibilityOnMedicaidSubsidy(this.enableDSNPDisplay);
    }
}
GuidedHelpGetStartedComponent.ɵfac = function GuidedHelpGetStartedComponent_Factory(t) { return new (t || GuidedHelpGetStartedComponent)(i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.DemographicService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(HelpfulToolsService), i0.ɵɵdirectiveInject(i1.SNPService)); };
GuidedHelpGetStartedComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GuidedHelpGetStartedComponent, selectors: [["vnext-get-started"]], inputs: { optionalLabel: "optionalLabel", zipCodeHintText: "zipCodeHintText", zipCodeInputZipCodeError: "zipCodeInputZipCodeError", zipCodeInputCountyError: "zipCodeInputCountyError", zipCodeInputSelectCounty: "zipCodeInputSelectCounty", zipCodeInputZipCodeLabel: "zipCodeInputZipCodeLabel", selectedCountyEnabled: "selectedCountyEnabled", zipCodeInputEditCounty: "zipCodeInputEditCounty", errorKeywordText: "errorKeywordText", getStartedText: "getStartedText", coverageTextQuestion: "coverageTextQuestion", medicalOnlyDefault: "medicalOnlyDefault", spaPageSubHeader: "spaPageSubHeader", showSubsidyAccordion: "showSubsidyAccordion", accordionHeaderText: "accordionHeaderText", enableDSNPDisplay: "enableDSNPDisplay", zipCodeIsReadOnly: "zipCodeIsReadOnly", countyLabel: "countyLabel", showCountyLabel: "showCountyLabel", defaultCoverageTypes: "defaultCoverageTypes", isMobile: "isMobile" }, decls: 10, vars: 18, consts: [[1, "text-center"], ["aria-hidden", "true"], ["class", "Spa_Style_H1", 4, "liveEditProp"], [1, "mt-4"], ["navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [3, "zipCodeInputZipCodeError", "zipCodeInputCountyError", "zipCodeInputSelectCounty", "zipCodeInputZipCodeLabel", "selectedCountyEnabled", "zipCodeInputEditCounty", "errorKeywordText", "zipCodeIsReadOnly", "countyLabel", "showCountyLabel", "setLocationAndDemographics"], ["class", "Spa_Style_IntroParagraph mt-4", 4, "liveEditProp"], [4, "ngIf"], [1, "Spa_Style_H1"], ["navigationAdapter", "", 3, "innerHtml"], [1, "Spa_Style_IntroParagraph", "mt-4"], ["aria-live", "off", 3, "optionalLabel", "coverageTextQuestion", "medicalOnlyDefault", "secondaryButtonTextColor", "defaultCoverageTypes"], ["class", "Spa_Style_H4", "id", "extra-help-for-drugs-text", 4, "liveEditProp"], ["id", "extra-help-for-drugs-optional-text", 4, "liveEditProp"], ["class", "error-color", "id", "getStartedSubsidyError", 4, "ngIf"], [1, "getting-started-accordion-wrapper"], [3, "items", "allowParentValues", "selectedParent", "selectedChild", "emitParentValueWhenNoChildrenSelected", "ariaDescribedById", "ariaLabelledById", "largerText", "isMobile", "buttonHeight", "secondaryButtonTextColor", "valueSelected"], ["id", "extra-help-for-drugs-text", 1, "Spa_Style_H4"], ["id", "extra-help-for-drugs-optional-text"], ["id", "getStartedSubsidyError", 1, "error-color"], [1, "sr-only"]], template: function GuidedHelpGetStartedComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "i", 1);
        i0.ɵɵtemplate(2, GuidedHelpGetStartedComponent_h1_2_Template, 2, 1, "h1", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, GuidedHelpGetStartedComponent_div_4_Template, 2, 4, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div")(6, "vnext-guided-help-zip-code", 5);
        i0.ɵɵlistener("setLocationAndDemographics", function GuidedHelpGetStartedComponent_Template_vnext_guided_help_zip_code_setLocationAndDemographics_6_listener($event) { return ctx.updateLocationAndDemographics($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, GuidedHelpGetStartedComponent_p_7_Template, 2, 1, "p", 6);
        i0.ɵɵtemplate(8, GuidedHelpGetStartedComponent_div_8_Template, 2, 5, "div", 7);
        i0.ɵɵtemplate(9, GuidedHelpGetStartedComponent_div_9_Template, 7, 14, "div", 7);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("fas ", ctx.activeLink.iconClass, " pl-3 pl-md-0");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", ctx.activeLink.resourceKeyName);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_PageSubHeader_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("zipCodeInputZipCodeError", ctx.zipCodeInputZipCodeError)("zipCodeInputCountyError", ctx.zipCodeInputCountyError)("zipCodeInputSelectCounty", ctx.zipCodeInputSelectCounty)("zipCodeInputZipCodeLabel", ctx.zipCodeInputZipCodeLabel)("selectedCountyEnabled", ctx.selectedCountyEnabled)("zipCodeInputEditCounty", ctx.zipCodeInputEditCounty)("errorKeywordText", ctx.errorKeywordText)("zipCodeIsReadOnly", ctx.zipCodeIsReadOnly)("countyLabel", ctx.countyLabel)("showCountyLabel", ctx.showCountyLabel);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_GuidedHelp_GetStarted_ZipCode_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.coverageTypeEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showSubsidyContent());
    } }, dependencies: [i1$2.NgIf, NavigationAdapterDirective, LiveEditPropDirective, GuidedHelpCoverageTypeComponent, GuidedHelpZipCodeComponent, AccordionComponent, SafePipe], styles: [".getting-started-accordion-wrapper[_ngcontent-%COMP%]{margin-bottom:15px}.Spa_Style_GettingStartedIcon[_ngcontent-%COMP%]{font-size:46px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuidedHelpGetStartedComponent, [{
        type: Component,
        args: [{ selector: 'vnext-get-started', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"text-center\">\r\n  <i class=\"fas {{ activeLink.iconClass }} pl-3 pl-md-0\" aria-hidden=\"true\"></i>\r\n  <h1 class=\"Spa_Style_H1\" *liveEditProp=\"activeLink.resourceKeyName\">{{ getStartedText }}</h1>\r\n</div>\r\n<div class=\"mt-4\">\r\n  <div\r\n    *liveEditProp=\"'Spa_Site_PageSubHeader_Text'\"\r\n    [innerHtml]=\"spaPageSubHeader ? (spaPageSubHeader | safe : 'html') : ''\"\r\n    navigationAdapter\r\n  ></div>\r\n</div>\r\n\r\n<div>\r\n  <vnext-guided-help-zip-code\r\n    [zipCodeInputZipCodeError]=\"zipCodeInputZipCodeError\"\r\n    [zipCodeInputCountyError]=\"zipCodeInputCountyError\"\r\n    [zipCodeInputSelectCounty]=\"zipCodeInputSelectCounty\"\r\n    [zipCodeInputZipCodeLabel]=\"zipCodeInputZipCodeLabel\"\r\n    [selectedCountyEnabled]=\"selectedCountyEnabled\"\r\n    [zipCodeInputEditCounty]=\"zipCodeInputEditCounty\"\r\n    [errorKeywordText]=\"errorKeywordText\"\r\n    (setLocationAndDemographics)=\"updateLocationAndDemographics($event)\"\r\n    [zipCodeIsReadOnly]=\"zipCodeIsReadOnly\"\r\n    [countyLabel]=\"countyLabel\"\r\n    [showCountyLabel]=\"showCountyLabel\"\r\n  ></vnext-guided-help-zip-code>\r\n  <p class=\"Spa_Style_IntroParagraph mt-4\" *liveEditProp=\"'Spa_GuidedHelp_GetStarted_ZipCode_Text'\">{{ zipCodeHintText }}</p>\r\n\r\n  <div *ngIf=\"coverageTypeEnabled\">\r\n    <vnext-guided-help-coverage-type\r\n      [optionalLabel]=\"optionalLabel\"\r\n      [coverageTextQuestion]=\"coverageTextQuestion\"\r\n      [medicalOnlyDefault]=\"medicalOnlyDefault\"\r\n      aria-live=\"off\"\r\n      [secondaryButtonTextColor]=\"secondaryButtonTextColor\"\r\n      [defaultCoverageTypes]=\"defaultCoverageTypes\"\r\n    ></vnext-guided-help-coverage-type>\r\n  </div>\r\n  <div *ngIf=\"showSubsidyContent()\">\r\n    <p>\r\n      <span class=\"Spa_Style_H4\" *liveEditProp=\"'Spa_GettingStarted_SubsidyHeader_Text'\" id=\"extra-help-for-drugs-text\">{{\r\n        accordionHeaderText\r\n      }}</span>\r\n      <span *liveEditProp=\"'Spa_GuidedHelp_OptionalLabel_Text'\" id=\"extra-help-for-drugs-optional-text\">{{ optionalLabel }}</span>\r\n    </p>\r\n    <div class=\"error-color\" *ngIf=\"subsidyError\" id=\"getStartedSubsidyError\">\r\n      <span class=\"sr-only\">{{ errorKeywordText }}</span\r\n      >{{ subsidyError.message }}\r\n    </div>\r\n    <div class=\"getting-started-accordion-wrapper\">\r\n      <vnext-accordion\r\n        (valueSelected)=\"receiveValueFromSubsidyAccordion($event)\"\r\n        [items]=\"subsidyAccordionItems\"\r\n        [allowParentValues]=\"true\"\r\n        [selectedParent]=\"selectedParentId\"\r\n        [selectedChild]=\"selectedChildId\"\r\n        [emitParentValueWhenNoChildrenSelected]=\"true\"\r\n        [ariaDescribedById]=\"subsidyError ? 'getStartedSubsidyError' : ''\"\r\n        [ariaLabelledById]=\"'extra-help-for-drugs-text extra-help-for-drugs-optional-text'\"\r\n        [largerText]=\"true\"\r\n        [isMobile]=\"isMobile\"\r\n        [buttonHeight]=\"'36px'\"\r\n        [secondaryButtonTextColor]=\"secondaryButtonTextColor\"\r\n      ></vnext-accordion>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".getting-started-accordion-wrapper{margin-bottom:15px}.Spa_Style_GettingStartedIcon{font-size:46px}\n"] }]
    }], function () { return [{ type: PlanFacade }, { type: i1.ConfigResourceService }, { type: i1.DemographicService }, { type: i2.Store }, { type: i1.GuidedHelpService }, { type: i1.WidgetValidationService }, { type: WidgetService }, { type: i1.LocaleService }, { type: i0.ChangeDetectorRef }, { type: HelpfulToolsService }, { type: i1.SNPService }]; }, { optionalLabel: [{
            type: Input
        }], zipCodeHintText: [{
            type: Input
        }], zipCodeInputZipCodeError: [{
            type: Input
        }], zipCodeInputCountyError: [{
            type: Input
        }], zipCodeInputSelectCounty: [{
            type: Input
        }], zipCodeInputZipCodeLabel: [{
            type: Input
        }], selectedCountyEnabled: [{
            type: Input
        }], zipCodeInputEditCounty: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], getStartedText: [{
            type: Input
        }], coverageTextQuestion: [{
            type: Input
        }], medicalOnlyDefault: [{
            type: Input
        }], spaPageSubHeader: [{
            type: Input
        }], showSubsidyAccordion: [{
            type: Input
        }], accordionHeaderText: [{
            type: Input
        }], enableDSNPDisplay: [{
            type: Input
        }], zipCodeIsReadOnly: [{
            type: Input
        }], countyLabel: [{
            type: Input
        }], showCountyLabel: [{
            type: Input
        }], defaultCoverageTypes: [{
            type: Input
        }], isMobile: [{
            type: Input
        }] }); })();

function GuidedHelpNavigationTextComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("", ctx_r0.linkTextClass, " text-center");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.link.title);
} }
class GuidedHelpNavigationTextComponent {
    ngOnChanges(changes) {
        if (!_isEqual(changes?.link?.previousValue, changes?.link?.currentValue)) {
            this.statusText = this.getStatusText(this.link?.status);
            this.linkIcon = this.getIcon(this.link);
            this.linkIconColor = this.getIconColor(this.link);
            this.linkTextClass = this.getTextClass(this.link);
        }
    }
    getTextClass(link) {
        return {
            clean: 'Spa_Style_Gray4_Color',
            dirty: 'Spa_Style_Gray4_Color Spa_Style_Semi_Bold_Weight',
            selected: 'Spa_Style_H4'
        }[link.status];
    }
    getStatusText(status) {
        if (status === GuidedHelpLinkStatus.DIRTY) {
            return this.completedText;
        }
        else if (status === GuidedHelpLinkStatus.SELECTED) {
            return this.currentText;
        }
        return this.notVisitedText;
    }
    getIconColor(link) {
        return link.status === GuidedHelpLinkStatus.SELECTED ? link.selectedIconColor : 'Spa_Style_Gray4_Color';
    }
    getIcon(link) {
        return {
            selected: 'fas fa-circle',
            dirty: 'fas fa-check-circle',
            clean: 'fal fa-circle'
        }[link.status];
    }
}
GuidedHelpNavigationTextComponent.ɵfac = function GuidedHelpNavigationTextComponent_Factory(t) { return new (t || GuidedHelpNavigationTextComponent)(); };
GuidedHelpNavigationTextComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GuidedHelpNavigationTextComponent, selectors: [["vnext-guided-help-navigation-text"]], inputs: { link: "link", completedText: "completedText", notVisitedText: "notVisitedText", currentText: "currentText" }, features: [i0.ɵɵNgOnChangesFeature], decls: 4, vars: 6, consts: [[3, "class", 4, "liveEditProp"], [1, "hidden-off-screen"]], template: function GuidedHelpNavigationTextComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "i");
        i0.ɵɵtemplate(1, GuidedHelpNavigationTextComponent_span_1_Template, 2, 4, "span", 0);
        i0.ɵɵelementStart(2, "span", 1);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassMapInterpolate2("pr-2 ", ctx.linkIcon, " ", ctx.linkIconColor, "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", ctx.link.resourceKeyName);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(" " + ctx.statusText);
    } }, dependencies: [LiveEditPropDirective], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuidedHelpNavigationTextComponent, [{
        type: Component,
        args: [{ selector: 'vnext-guided-help-navigation-text', template: "<i class=\"pr-2 {{ linkIcon }} {{ linkIconColor }}\"></i>\r\n<span class=\"{{ linkTextClass }} text-center\" *liveEditProp=\"link.resourceKeyName\">{{ link.title }}</span>\r\n<span class=\"hidden-off-screen\">{{ ' ' + statusText }}</span>\r\n" }]
    }], null, { link: [{
            type: Input
        }], completedText: [{
            type: Input
        }], notVisitedText: [{
            type: Input
        }], currentText: [{
            type: Input
        }] }); })();

class GuidedHelpNavigationFacade {
    constructor(configResourceService, guidedHelpService) {
        this.configResourceService = configResourceService;
        this.guidedHelpService = guidedHelpService;
    }
    updateGuidedHelpResources() {
        const updatedLinks = this.guidedHelpService.links.map(link => {
            const _guideLink = {
                ...link,
                title: this.configResourceService.getProcessedResourceValue(link.resourceKeyName, null, link.title),
            };
            return _guideLink;
        });
        this.guidedHelpService.setNavigationLinks(updatedLinks);
    }
}
GuidedHelpNavigationFacade.ɵfac = function GuidedHelpNavigationFacade_Factory(t) { return new (t || GuidedHelpNavigationFacade)(i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.GuidedHelpService)); };
GuidedHelpNavigationFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GuidedHelpNavigationFacade, factory: GuidedHelpNavigationFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuidedHelpNavigationFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: i1.GuidedHelpService }]; }, null); })();

function GuidedHelpNavigationComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function GuidedHelpNavigationComponent_ng_template_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵlistener("click", function GuidedHelpNavigationComponent_ng_template_2_div_1_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const link_r7 = restoredCtx.$implicit; const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8.onNavigationLinkClick(link_r7)); })("keyup.enter", function GuidedHelpNavigationComponent_ng_template_2_div_1_Template_div_keyup_enter_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const link_r7 = restoredCtx.$implicit; const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.onNavigationLinkClick(link_r7)); });
    i0.ɵɵelement(1, "vnext-guided-help-navigation-text", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r7 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("guided-help-link py-2 pl-2 ", ctx_r5.getLinkClass(link_r7), "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("link", link_r7)("completedText", ctx_r5.completedText)("notVisitedText", ctx_r5.notVisitedText)("currentText", ctx_r5.currentText);
} }
function GuidedHelpNavigationComponent_ng_template_2_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function GuidedHelpNavigationComponent_ng_template_2_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.goToPlansLink()); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "i", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r6.goToLinkText);
} }
function GuidedHelpNavigationComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, GuidedHelpNavigationComponent_ng_template_2_div_1_Template, 2, 7, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵtemplate(3, GuidedHelpNavigationComponent_ng_template_2_button_3_Template, 4, 1, "button", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.getGuidedHelpLinks());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", ctx_r2.goToLinkKeyNamesForLiveEdit);
} }
function GuidedHelpNavigationComponent_ng_template_4_i_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 7);
    i0.ɵɵlistener("click", function GuidedHelpNavigationComponent_ng_template_4_i_1_Template_i_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r16); const link_r14 = restoredCtx.$implicit; const ctx_r15 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r15.onNavigationLinkClick(link_r14)); })("keyup.enter", function GuidedHelpNavigationComponent_ng_template_4_i_1_Template_i_keyup_enter_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r16); const link_r14 = restoredCtx.$implicit; const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.onNavigationLinkClick(link_r14)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r14 = ctx.$implicit;
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate2("pr-0 mobile-nav-icon can-click ", ctx_r13.getIcon(link_r14), " ", ctx_r13.getIconColor(link_r14), "");
    i0.ɵɵattribute("aria-current", ctx_r13.getLinkClass(link_r14) ? "step" : null)("aria-label", ctx_r13.getStepName(link_r14));
} }
function GuidedHelpNavigationComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, GuidedHelpNavigationComponent_ng_template_4_i_1_Template, 1, 6, "i", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.getGuidedHelpLinks());
} }
class GuidedHelpNavigationComponent {
    constructor(guidedHelpService, injector, modalService, analyticsService, widgetValidationService, guidedHelpNavigationFacade, localeService) {
        this.guidedHelpService = guidedHelpService;
        this.injector = injector;
        this.modalService = modalService;
        this.analyticsService = analyticsService;
        this.widgetValidationService = widgetValidationService;
        this.guidedHelpNavigationFacade = guidedHelpNavigationFacade;
        this.localeService = localeService;
        this.destroy$ = new Subject();
    }
    ngOnInit() {
        this.guidedHelpService.onPageLoad();
        this.currentLocale$ = this.localeService.getCurrentLocale$().pipe(takeUntil(this.destroy$));
        this.currentLocale$.subscribe(() => {
            this.guidedHelpNavigationFacade.updateGuidedHelpResources();
        });
    }
    getGuidedHelpLinks() {
        return this.guidedHelpService.links.filter(link => link.enabled);
    }
    getMobile$() {
        return this.guidedHelpService.isMobile$;
    }
    getIcon(link) {
        return {
            selected: 'fas fa-circle',
            dirty: 'fas fa-check-circle',
            clean: 'fal fa-circle'
        }[link.status];
    }
    getIconColor(link) {
        return link.status === GuidedHelpLinkStatus.SELECTED ? link.selectedIconColor : 'Spa_Style_Gray4_Color';
    }
    getTextClass(link) {
        return {
            clean: 'Spa_Style_Gray4_Color',
            dirty: 'Spa_Style_Gray4_Color Spa_Style_Semi_Bold_Weight',
            selected: 'Spa_Style_H4'
        }[link.status];
    }
    getLinkClass(link) {
        return link.status === GuidedHelpLinkStatus.SELECTED ? 'selected-container' : '';
    }
    getStepName(link) {
        let stepName = link.status === 'dirty' ? this.completedText : '';
        stepName = `${stepName} ${link.title}`;
        return stepName.trim();
    }
    onNavigationLinkClick(link) {
        this.guidedHelpService.navigateByPageTag(link.pageTag);
    }
    goToPlansLink() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PREFERENCES_GO_TO_PLANS);
        let selectedZip = this.guidedHelpService.getSelectedZipCode();
        if (!selectedZip) {
            // This modal needs to not fire the event to avoid conflicting with a subscription to it on the get started page
            const zipCodeModal = this.modalService.open(ZipCodeModalComponent, { centered: true, injector: this.injector });
            zipCodeModal.componentInstance.fireInputEnter = false;
            zipCodeModal.result
                .then(() => {
                selectedZip = this.guidedHelpService.getSelectedZipCode();
                if (selectedZip) {
                    this.navigateToPage();
                }
            })
                .catch(err => { });
        }
        else {
            if (this.widgetHasErrors()) {
                this.navigateToPage();
            }
        }
    }
    navigateToPage() {
        if (this.isRetentionView) {
            this.guidedHelpService.navigateByPageTag(this.guidedHelpService.getRetentionDefaultPageTag());
        }
        else if (this.isQuotingSite) {
            this.guidedHelpService.navigateByPageTag(PageTags.QUOTE_SUMMARY);
        }
        else {
            this.guidedHelpService.navigateByPageTag(PageTags.PLAN_LIST);
        }
    }
    ngOnDestroy() {
        this.destroy$.next(true);
    }
    widgetHasErrors() {
        return this.widgetValidationService.validate().length === 0;
    }
}
GuidedHelpNavigationComponent.ɵfac = function GuidedHelpNavigationComponent_Factory(t) { return new (t || GuidedHelpNavigationComponent)(i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(GuidedHelpNavigationFacade), i0.ɵɵdirectiveInject(i1.LocaleService)); };
GuidedHelpNavigationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GuidedHelpNavigationComponent, selectors: [["vnext-guided-help-navigation"]], inputs: { goToLinkText: "goToLinkText", isRetentionView: "isRetentionView", isQuotingSite: "isQuotingSite", goToLinkKeyNamesForLiveEdit: "goToLinkKeyNamesForLiveEdit", completedText: "completedText", notVisitedText: "notVisitedText", currentText: "currentText" }, decls: 6, vars: 5, consts: [[4, "ngIf", "ngIfThen", "ngIfElse"], ["standard", ""], ["compact", ""], [1, "guided-container", "d-flex", "flex-column", "justify-content-center", "pt-4"], ["tabindex", "0", "role", "link", 3, "class", "click", "keyup.enter", 4, "ngFor", "ngForOf"], [1, "pl-2", "pt-4"], ["type", "button", "class", "action-button Spa_Style_Link p-1", 3, "click", 4, "liveEditProp"], ["tabindex", "0", "role", "link", 3, "click", "keyup.enter"], [3, "link", "completedText", "notVisitedText", "currentText"], ["type", "button", 1, "action-button", "Spa_Style_Link", "p-1", 3, "click"], ["aria-hidden", "true", 1, "fa", "fa-angle-right", "pl-1"], [1, "d-flex", "justify-content-center", "pb-3"]], template: function GuidedHelpNavigationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, GuidedHelpNavigationComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵtemplate(2, GuidedHelpNavigationComponent_ng_template_2_Template, 4, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(4, GuidedHelpNavigationComponent_ng_template_4_Template, 2, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(3);
        const _r3 = i0.ɵɵreference(5);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 3, ctx.getMobile$()))("ngIfThen", _r3)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, LiveEditPropDirective, IconAriaAttributesDirective, GuidedHelpNavigationTextComponent, i1$2.AsyncPipe], styles: ["i[_ngcontent-%COMP%]{font-size:14px}.guided-container[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);margin-top:100px}.guided-help-link[_ngcontent-%COMP%]{cursor:pointer;border:1px solid transparent}.selected-container[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent1);border-right-color:#fff;border-top-left-radius:5px;border-bottom-left-radius:5px;width:calc(100% + 1px)}.mobile-nav-icon[_ngcontent-%COMP%]{margin-right:12px;margin-left:12px}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], GuidedHelpNavigationComponent.prototype, "onNavigationLinkClick", null);
__decorate([
    LiveEditInactive()
], GuidedHelpNavigationComponent.prototype, "goToPlansLink", null);
__decorate([
    LiveEditInactive()
], GuidedHelpNavigationComponent.prototype, "navigateToPage", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuidedHelpNavigationComponent, [{
        type: Component,
        args: [{ selector: 'vnext-guided-help-navigation', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"getMobile$() | async; then compact; else standard\"></ng-container>\r\n<ng-template #standard>\r\n  <div class=\"guided-container d-flex flex-column justify-content-center pt-4\">\r\n    <div\r\n      *ngFor=\"let link of getGuidedHelpLinks()\"\r\n      (click)=\"onNavigationLinkClick(link)\"\r\n      (keyup.enter)=\"onNavigationLinkClick(link)\"\r\n      class=\"guided-help-link py-2 pl-2 {{ getLinkClass(link) }}\"\r\n      tabindex=\"0\"\r\n      role=\"link\"\r\n    >\r\n      <vnext-guided-help-navigation-text\r\n        [link]=\"link\"\r\n        [completedText]=\"completedText\"\r\n        [notVisitedText]=\"notVisitedText\"\r\n        [currentText]=\"currentText\"\r\n      >\r\n      </vnext-guided-help-navigation-text>\r\n    </div>\r\n  </div>\r\n  <div class=\"pl-2 pt-4\">\r\n    <button type=\"button\" *liveEditProp=\"goToLinkKeyNamesForLiveEdit\" (click)=\"goToPlansLink()\" class=\"action-button Spa_Style_Link p-1\">\r\n      <span>{{ goToLinkText }}</span>\r\n      <i class=\"fa fa-angle-right pl-1\" aria-hidden=\"true\"></i>\r\n    </button>\r\n  </div>\r\n</ng-template>\r\n<ng-template #compact>\r\n  <div class=\"d-flex justify-content-center pb-3\">\r\n    <i\r\n      *ngFor=\"let link of getGuidedHelpLinks()\"\r\n      (click)=\"onNavigationLinkClick(link)\"\r\n      (keyup.enter)=\"onNavigationLinkClick(link)\"\r\n      class=\"pr-0 mobile-nav-icon can-click {{ getIcon(link) }} {{ getIconColor(link) }}\"\r\n      tabindex=\"0\"\r\n      [attr.aria-current]=\"getLinkClass(link) ? 'step' : null\"\r\n      [attr.aria-label]=\"getStepName(link)\"\r\n      role=\"link\"\r\n    >\r\n    </i>\r\n  </div>\r\n</ng-template>\r\n", styles: ["i{font-size:14px}.guided-container{border-right:1px solid var(--static-Spa_Style_Accent1);margin-top:100px}.guided-help-link{cursor:pointer;border:1px solid transparent}.selected-container{border-color:var(--static-Spa_Style_Accent1);border-right-color:#fff;border-top-left-radius:5px;border-bottom-left-radius:5px;width:calc(100% + 1px)}.mobile-nav-icon{margin-right:12px;margin-left:12px}\n"] }]
    }], function () { return [{ type: i1.GuidedHelpService }, { type: i0.Injector }, { type: i1$1.NgbModal }, { type: AnalyticsService }, { type: i1.WidgetValidationService }, { type: GuidedHelpNavigationFacade }, { type: i1.LocaleService }]; }, { goToLinkText: [{
            type: Input
        }], isRetentionView: [{
            type: Input
        }], isQuotingSite: [{
            type: Input
        }], goToLinkKeyNamesForLiveEdit: [{
            type: Input
        }], completedText: [{
            type: Input
        }], notVisitedText: [{
            type: Input
        }], currentText: [{
            type: Input
        }], onNavigationLinkClick: [], goToPlansLink: [], navigateToPage: [] }); })();

function GuidedHelpOtherPreferencesComponent_h1_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.preferencesText);
} }
function GuidedHelpOtherPreferencesComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 7);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r1.spaPageSubHeader ? i0.ɵɵpipeBind2(1, 1, ctx_r1.spaPageSubHeader, "html") : "", i0.ɵɵsanitizeHtml);
} }
function GuidedHelpOtherPreferencesComponent_ng_container_6_ng_template_4_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function GuidedHelpOtherPreferencesComponent_ng_container_6_ng_template_4_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r8.sendZip()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.enterZipText, " ");
} }
function GuidedHelpOtherPreferencesComponent_ng_container_6_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, GuidedHelpOtherPreferencesComponent_ng_container_6_ng_template_4_button_0_Template, 2, 1, "button", 12);
} if (rf & 2) {
    i0.ɵɵproperty("liveEditProp", "Spa_GuidedHelp_OtherPreferences_EnterZip_Text");
} }
const _c0$1$ = function () { return { roundInputRightBorder: false }; };
function GuidedHelpOtherPreferencesComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 8);
    i0.ɵɵelement(2, "span", 9);
    i0.ɵɵelementStart(3, "vnext-guided-help-zip-code", 10);
    i0.ɵɵlistener("setLocationAndDemographics", function GuidedHelpOtherPreferencesComponent_ng_container_6_Template_vnext_guided_help_zip_code_setLocationAndDemographics_3_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.updateLocationAndDemographics($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, GuidedHelpOtherPreferencesComponent_ng_container_6_ng_template_4_Template, 1, 1, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r5 = i0.ɵɵreference(5);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHtml", ctx_r2.provideZipText, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("zipCodeInputZipCodeError", ctx_r2.zipCodeInputZipCodeError)("zipCodeInputCountyError", ctx_r2.zipCodeInputCountyError)("zipCodeInputSelectCounty", ctx_r2.zipCodeInputSelectCounty)("zipCodeInputZipCodeLabel", ctx_r2.zipCodeInputZipCodeLabel)("selectedCountyEnabled", ctx_r2.selectedCountyEnabled)("zipCodeInputEditCounty", ctx_r2.zipCodeInputEditCounty)("errorKeywordText", ctx_r2.errorKeywordText)("searchButtonTemplate", _r5)("zipCodeStyles", i0.ɵɵpureFunction0(12, _c0$1$))("countyLabel", ctx_r2.countyLabel)("showCountyLabel", ctx_r2.showCountyLabel);
} }
function GuidedHelpOtherPreferencesComponent_ng_template_7_div_0_div_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-toggle-select", 20);
    i0.ɵɵlistener("optionSelected", function GuidedHelpOtherPreferencesComponent_ng_template_7_div_0_div_3_ng_container_3_Template_vnext_toggle_select_optionSelected_1_listener($event) { i0.ɵɵrestoreView(_r23); const index_r17 = i0.ɵɵnextContext().index; const ctx_r21 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r21.onToggleClick($event, index_r17)); });
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext();
    const index_r17 = ctx_r24.index;
    const question_r16 = ctx_r24.$implicit;
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("items", ctx_r18.getToggleItemsForCurrentPage()[index_r17])("verticalGrow", ctx_r18.questionShouldGrowVertically(index_r17) || i0.ɵɵpipeBind1(2, 6, ctx_r18.isMobile$))("darkenOnHover", true)("buttonHeight", "36px")("selectedValue", question_r16.selectedValues ? question_r16.selectedValues[0] : "")("focusFirstItem", true);
} }
const _c1$X = function () { return []; };
function GuidedHelpOtherPreferencesComponent_ng_template_7_div_0_div_3_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-toggle-multi-select", 21);
    i0.ɵɵlistener("optionSelected", function GuidedHelpOtherPreferencesComponent_ng_template_7_div_0_div_3_ng_template_4_Template_vnext_toggle_multi_select_optionSelected_0_listener($event) { i0.ɵɵrestoreView(_r27); const index_r17 = i0.ɵɵnextContext().index; const ctx_r25 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r25.onToggleClick($event, index_r17)); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext();
    const index_r17 = ctx_r28.index;
    const question_r16 = ctx_r28.$implicit;
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("items", ctx_r20.getToggleItemsForCurrentPage()[index_r17])("verticalGrow", ctx_r20.questionShouldGrowVertically(index_r17) || i0.ɵɵpipeBind1(1, 6, ctx_r20.isMobile$))("darkenOnHover", true)("buttonHeight", "36px")("selectedValues", question_r16.selectedValues ? question_r16.selectedValues : i0.ɵɵpureFunction0(8, _c1$X))("focusFirstItem", true);
} }
function GuidedHelpOtherPreferencesComponent_ng_template_7_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17)(1, "h2", 18);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GuidedHelpOtherPreferencesComponent_ng_template_7_div_0_div_3_ng_container_3_Template, 3, 8, "ng-container", 4);
    i0.ɵɵtemplate(4, GuidedHelpOtherPreferencesComponent_ng_template_7_div_0_div_3_ng_template_4_Template, 2, 9, "ng-template", null, 19, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r16 = ctx.$implicit;
    const _r19 = i0.ɵɵreference(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(question_r16.questionText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", question_r16.selectAmount === "single")("ngIfElse", _r19);
} }
function GuidedHelpOtherPreferencesComponent_ng_template_7_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 15);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GuidedHelpOtherPreferencesComponent_ng_template_7_div_0_div_3_Template, 6, 3, "div", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.getPageCountText(), " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r12.getQuestionsForCurrentPage());
} }
function GuidedHelpOtherPreferencesComponent_ng_template_7_ng_template_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 7);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHtml", ctx_r29.noQuestionsText ? i0.ɵɵpipeBind2(1, 1, ctx_r29.noQuestionsText, "html") : "", i0.ɵɵsanitizeHtml);
} }
function GuidedHelpOtherPreferencesComponent_ng_template_7_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtemplate(1, GuidedHelpOtherPreferencesComponent_ng_template_7_ng_template_1_div_1_Template, 2, 4, "div", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_GuidedHelp_OtherPreferences_NoQuestions_Text");
} }
function GuidedHelpOtherPreferencesComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, GuidedHelpOtherPreferencesComponent_ng_template_7_div_0_Template, 4, 2, "div", 4);
    i0.ɵɵtemplate(1, GuidedHelpOtherPreferencesComponent_ng_template_7_ng_template_1_Template, 2, 1, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r13 = i0.ɵɵreference(2);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r4.availablePages == null ? null : ctx_r4.availablePages.length)("ngIfElse", _r13);
} }
class GuidedHelpOtherPreferencesComponent {
    constructor(preferencesService, responsiveLayoutService, cdr, guidedHelpService, demographicService, helpfulToolsService, spinnerService, plansService, widgetValidationService, preferencesContextService, analyticsService, router, zipCodeContextService) {
        this.preferencesService = preferencesService;
        this.responsiveLayoutService = responsiveLayoutService;
        this.cdr = cdr;
        this.guidedHelpService = guidedHelpService;
        this.demographicService = demographicService;
        this.helpfulToolsService = helpfulToolsService;
        this.spinnerService = spinnerService;
        this.plansService = plansService;
        this.widgetValidationService = widgetValidationService;
        this.preferencesContextService = preferencesContextService;
        this.analyticsService = analyticsService;
        this.router = router;
        this.zipCodeContextService = zipCodeContextService;
        this.availablePages = [];
        this.showZipPrompt = false;
        this.selectedZip = '';
        this.selectedFips = '';
    }
    ngOnChanges(changes) {
        const currentPage = changes.currentPage;
        const availablePages = changes.availablePages;
        if (this.hasCurrentPageChanges(currentPage) || this.hasAvailablePagesChanges(availablePages)) {
            this.updateGoogleAnalytics();
        }
    }
    ngOnInit() {
        this.isMobile$ = this.responsiveLayoutService.isCompact$;
        this.subscriptions = [
            this.preferencesContextService.continue$().subscribe(() => {
                this.analyticsService.googleDataLayerTags = {
                    [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PREFERENCES_CONTINUE,
                    [DataLayerGlobalVariable.OTHER_PREFERENCES_RESPONDED_QUESTIONS]: this.getRespondedQuestionCategoryIds(this.currentPage)
                };
            }),
            this.zipCodeContextService.onZipCodeEnter$().subscribe(zipCode => {
                if (zipCode) {
                    this.sendZip();
                }
            })
        ];
        this.showZipPrompt = !this.demographicService.getSelectedFipsCode();
        const preferenceBenefitIds = this.preferencesService.getPreferenceQuestionAnswers();
        if (preferenceBenefitIds && preferenceBenefitIds.length) {
            this.setDefaultSelectedValues(preferenceBenefitIds);
        }
        this.cdr.markForCheck();
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
        this.preferencesService.setSNPVisibilityBySavedAnswers(this.getAllSelectedAnswers());
    }
    questionShouldGrowVertically(index) {
        const toggleItemText = this.getToggleItemsForCurrentPage()[index].map(item => item.display);
        return this.preferencesService.questionShouldGrowVertically(toggleItemText);
    }
    getQuestionsForPage(page) {
        return this.availablePages[page - 1].questions;
    }
    getToggleItemsForCurrentPage() {
        return this.getQuestionsForCurrentPage().map(question => question.options.map(option => ({ display: option.text, value: option.id })));
    }
    getQuestionsForCurrentPage() {
        return this.availablePages[this.currentPage - 1].questions;
    }
    onToggleClick(event, index) {
        // set question's selected values to value(s) from toggle event
        let values = [];
        if (event.data.values !== undefined) {
            values = event.data.values === null ? [] : event.data.values;
        }
        if (event.data.value !== undefined) {
            values = event.data.value === null ? [] : [event.data.value];
        }
        this.updateQuestionSelectedValues(index, values);
        this.savePreferenceQuestionAnswers();
    }
    savePreferenceQuestionAnswers() {
        this.guidedHelpService.dirtyGuidedHelpPlanTypes();
        this.preferencesService.savePreferenceQuestionAnswers(this.getAllSelectedAnswers());
    }
    getAllSelectedAnswers() {
        const items = [];
        this.availablePages.forEach(page => {
            page.questions.forEach(question => {
                if (question.selectedValues && question.selectedValues.length) {
                    question.selectedValues.forEach(selectedValue => {
                        items.push({ value: selectedValue, category: question.category });
                    });
                }
            });
        });
        return items;
    }
    setDefaultSelectedValues(allSelectedItems) {
        this.availablePages.forEach(page => {
            if (page.questions) {
                page.questions.forEach(question => {
                    const matchingItems = allSelectedItems.filter(selectedItem => selectedItem.key === question.category);
                    if (matchingItems && matchingItems.length) {
                        const matchingCategory = matchingItems[0];
                        question.selectedValues = [];
                        const questionIds = question.options.map(option => option.id);
                        questionIds.forEach(id => {
                            if (matchingCategory.values.includes(id) && matchingCategory.key === question.category) {
                                question.selectedValues.push(id);
                            }
                        });
                    }
                });
            }
        });
    }
    getPageCountText() {
        return this.pageCountText.replace('<currentPage>', `${this.currentPage}`).replace('<lastPage>', `${this.availablePages.length}`);
    }
    updateLocationAndDemographics(location) {
        this.selectedZip = location.zip;
        this.selectedFips = location.fips;
    }
    async updateQuestionPages() {
        this.spinnerService.show(SpinnerEvent.PLANS_LOADING);
        const medBenefits = await this.plansService.getMedBenefits();
        this.spinnerService.hide(SpinnerEvent.PLANS_LOADING);
        const coverageType = this.guidedHelpService.coverageType();
        const modifiedForBenefits = this.preferencesService.filterQuestionsByBenefits(medBenefits);
        const modifiedForCoverageType = this.preferencesService.filterQuestionsByCoverageType(modifiedForBenefits, coverageType);
        this.availablePages = this.preferencesService.filterMedsupQuestions(modifiedForCoverageType);
        this.preferencesContextService.updateQuestionPages(this.availablePages);
        this.showZipPrompt = false;
        this.updateGoogleAnalytics();
        this.cdr.markForCheck();
    }
    sendZip() {
        const validationErrors = this.widgetValidationService.validate();
        if (this.selectedZip && this.selectedFips && validationErrors.length === 0) {
            this.guidedHelpService.selectZip(this.selectedFips, this.selectedZip);
            this.demographicService.updateDemographicSession();
            this.helpfulToolsService.selectLocation(this.selectedZip, this.selectedFips);
            this.updateQuestionPages();
        }
    }
    updateQuestionSelectedValues(index, values) {
        const questions = this.getQuestionsForCurrentPage();
        if (questions && index >= 0 && index < questions.length && questions[index]) {
            questions[index].selectedValues = values;
        }
    }
    hasCurrentPageChanges(currentPage) {
        return currentPage && currentPage.currentValue !== currentPage.previousValue;
    }
    hasAvailablePagesChanges(availablePages) {
        return availablePages && !_isEqual(availablePages.currentValue, availablePages.previousValue);
    }
    getSelectedIds(pageNumber) {
        let selectedIds = [];
        const currentPage = this.availablePages[pageNumber - 1];
        if (currentPage) {
            const questions = currentPage.questions;
            if (questions) {
                questions.forEach(question => {
                    selectedIds = selectedIds.concat(question.selectedValues || []);
                });
            }
        }
        return selectedIds;
    }
    getPageQuestionIds(pageNumber) {
        let selectedIds = [];
        const currentPage = this.availablePages[pageNumber - 1];
        if (currentPage) {
            const questions = currentPage.questions;
            if (questions) {
                questions.forEach(question => {
                    if (question.options) {
                        selectedIds = selectedIds.concat(question.options.map(option => option.id));
                    }
                });
            }
        }
        return selectedIds;
    }
    /**
     * Question IDs should all consist of 3 digits, so an id like 7 would be listed as 007. Multiple question IDs
     * should be separated with a pipe (|). Example value: "007|040|384"
     */
    formatQuestionIds(questionIds = []) {
        return [...new Set(questionIds)].map(id => this.formatQuestionId(id)).join('|');
    }
    formatQuestionId(questionId) {
        const firstCharacter = questionId ? questionId.substring(0, 1) : '';
        const isNegative = firstCharacter === '-';
        const questionIdAbsoluteValue = `${Math.abs(+questionId)}`;
        return `${isNegative ? '-' : ''}` + `000${questionIdAbsoluteValue ? questionIdAbsoluteValue.trim() : ''}`.substr(-3);
    }
    getQuestionCategoryIds(pageNumber) {
        return this.formatQuestionIds(this.getPageQuestionIds(pageNumber));
    }
    getRespondedQuestionCategoryIds(pageNumber) {
        return this.formatQuestionIds(this.getSelectedIds(pageNumber));
    }
    updateGoogleAnalytics() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
            [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE,
            [DataLayerGlobalVariable.OTHER_PREFERENCES_PAGE_NUMBER]: `${this.currentPage}of${this.availablePages.length}`,
            [DataLayerGlobalVariable.OTHER_PREFERENCES_QUESTION_CATEGORY_IDS]: this.getQuestionCategoryIds(this.currentPage)
        };
    }
}
GuidedHelpOtherPreferencesComponent.ɵfac = function GuidedHelpOtherPreferencesComponent_Factory(t) { return new (t || GuidedHelpOtherPreferencesComponent)(i0.ɵɵdirectiveInject(i1.PreferencesService), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(i1.DemographicService), i0.ɵɵdirectiveInject(HelpfulToolsService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(i1.PreferencesContextService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(ZipCodeContextService)); };
GuidedHelpOtherPreferencesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GuidedHelpOtherPreferencesComponent, selectors: [["vnext-guided-help-other-preferences"]], inputs: { preferencesText: "preferencesText", spaPageSubHeader: "spaPageSubHeader", noQuestionsText: "noQuestionsText", availablePages: "availablePages", preferencesLink: "preferencesLink", currentPage: "currentPage", pageCountText: "pageCountText", enterZipText: "enterZipText", provideZipText: "provideZipText", zipCodeInputZipCodeError: "zipCodeInputZipCodeError", zipCodeInputCountyError: "zipCodeInputCountyError", zipCodeInputSelectCounty: "zipCodeInputSelectCounty", zipCodeInputZipCodeLabel: "zipCodeInputZipCodeLabel", selectedCountyEnabled: "selectedCountyEnabled", zipCodeInputEditCounty: "zipCodeInputEditCounty", errorKeywordText: "errorKeywordText", countyLabel: "countyLabel", showCountyLabel: "showCountyLabel" }, features: [i0.ɵɵProvidersFeature([InputResetContextService]), i0.ɵɵNgOnChangesFeature], decls: 9, vars: 7, consts: [[1, "text-center"], ["class", "Spa_Style_H1", 4, "liveEditProp"], [1, "col-12", "mt-4"], ["navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [4, "ngIf", "ngIfElse"], ["zipCodeProvided", ""], [1, "Spa_Style_H1"], ["navigationAdapter", "", 3, "innerHtml"], [1, "text-left"], [1, "Spa_Style_Paragraph", 3, "innerHtml"], [3, "zipCodeInputZipCodeError", "zipCodeInputCountyError", "zipCodeInputSelectCounty", "zipCodeInputZipCodeLabel", "selectedCountyEnabled", "zipCodeInputEditCounty", "errorKeywordText", "searchButtonTemplate", "zipCodeStyles", "countyLabel", "showCountyLabel", "setLocationAndDemographics"], ["zipConfirmButton", ""], ["class", "btn Spa_Style_SecondaryButton zip-button", 3, "click", 4, "liveEditProp"], [1, "btn", "Spa_Style_SecondaryButton", "zip-button", 3, "click"], ["noQuestions", ""], [1, "page-count", "Spa_Style_Primary_Color", "Spa_Style_Bold_Weight", "pb-4"], ["class", "question-container", 4, "ngFor", "ngForOf"], [1, "question-container"], [1, "question-header", "Spa_Style_Larger_Font"], ["multiSelect", ""], [3, "items", "verticalGrow", "darkenOnHover", "buttonHeight", "selectedValue", "focusFirstItem", "optionSelected"], [3, "items", "verticalGrow", "darkenOnHover", "buttonHeight", "selectedValues", "focusFirstItem", "optionSelected"], [1, "no-questions"]], template: function GuidedHelpOtherPreferencesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "i");
        i0.ɵɵtemplate(2, GuidedHelpOtherPreferencesComponent_h1_2_Template, 2, 1, "h1", 1);
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵtemplate(4, GuidedHelpOtherPreferencesComponent_div_4_Template, 2, 4, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div");
        i0.ɵɵtemplate(6, GuidedHelpOtherPreferencesComponent_ng_container_6_Template, 6, 13, "ng-container", 4);
        i0.ɵɵtemplate(7, GuidedHelpOtherPreferencesComponent_ng_template_7_Template, 3, 2, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(8);
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1(" fas ", ctx.preferencesLink.iconClass, "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", ctx.preferencesLink.resourceKeyName);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_PageSubHeader_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showZipPrompt)("ngIfElse", _r3);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, ToggleSelectComponent, ToggleMultiSelectComponent, NavigationAdapterDirective, LiveEditPropDirective, GuidedHelpZipCodeComponent, i1$2.AsyncPipe, SafePipe], styles: ["i[_ngcontent-%COMP%]{font-size:46px}.no-questions[_ngcontent-%COMP%]{white-space:pre-line;text-align:center;margin-top:140px;line-height:28px}.question-container[_ngcontent-%COMP%]{margin-bottom:24px}.question-header[_ngcontent-%COMP%]{text-align:left;margin-bottom:10px}.page-count[_ngcontent-%COMP%]{width:100%;text-align:right}.zip-button[_ngcontent-%COMP%]{border-bottom-left-radius:0;border-top-left-radius:0}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuidedHelpOtherPreferencesComponent, [{
        type: Component,
        args: [{ selector: 'vnext-guided-help-other-preferences', providers: [InputResetContextService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"text-center\">\r\n  <i class=\" fas {{ preferencesLink.iconClass }}\"></i>\r\n  <h1 class=\"Spa_Style_H1\" *liveEditProp=\"preferencesLink.resourceKeyName\">{{ preferencesText }}</h1>\r\n  <div class=\"col-12 mt-4\">\r\n    <div\r\n      *liveEditProp=\"'Spa_Site_PageSubHeader_Text'\"\r\n      [innerHtml]=\"spaPageSubHeader ? (spaPageSubHeader | safe: 'html') : ''\"\r\n      navigationAdapter\r\n    ></div>\r\n  </div>\r\n  <div>\r\n    <ng-container *ngIf=\"showZipPrompt; else zipCodeProvided\">\r\n      <div class=\"text-left\">\r\n        <span class=\"Spa_Style_Paragraph\" [innerHtml]=\"provideZipText\"></span>\r\n        <vnext-guided-help-zip-code\r\n          [zipCodeInputZipCodeError]=\"zipCodeInputZipCodeError\"\r\n          [zipCodeInputCountyError]=\"zipCodeInputCountyError\"\r\n          [zipCodeInputSelectCounty]=\"zipCodeInputSelectCounty\"\r\n          [zipCodeInputZipCodeLabel]=\"zipCodeInputZipCodeLabel\"\r\n          [selectedCountyEnabled]=\"selectedCountyEnabled\"\r\n          [zipCodeInputEditCounty]=\"zipCodeInputEditCounty\"\r\n          [errorKeywordText]=\"errorKeywordText\"\r\n          (setLocationAndDemographics)=\"updateLocationAndDemographics($event)\"\r\n          [searchButtonTemplate]=\"zipConfirmButton\"\r\n          [zipCodeStyles]=\"{ roundInputRightBorder: false }\"\r\n          [countyLabel]=\"countyLabel\"\r\n          [showCountyLabel]=\"showCountyLabel\"\r\n        ></vnext-guided-help-zip-code>\r\n        <ng-template #zipConfirmButton>\r\n          <button\r\n            *liveEditProp=\"'Spa_GuidedHelp_OtherPreferences_EnterZip_Text'\"\r\n            class=\"btn Spa_Style_SecondaryButton zip-button\"\r\n            (click)=\"sendZip()\"\r\n          >\r\n            {{ enterZipText }}\r\n          </button>\r\n        </ng-template>\r\n      </div>\r\n    </ng-container>\r\n    <ng-template #zipCodeProvided>\r\n      <div *ngIf=\"availablePages?.length; else noQuestions\">\r\n        <div class=\"page-count Spa_Style_Primary_Color Spa_Style_Bold_Weight pb-4\">\r\n          {{ getPageCountText() }}\r\n        </div>\r\n        <div class=\"question-container\" *ngFor=\"let question of getQuestionsForCurrentPage(); index as index\">\r\n          <h2 class=\"question-header Spa_Style_Larger_Font\">{{ question.questionText }}</h2>\r\n          <ng-container *ngIf=\"question.selectAmount === 'single'; else multiSelect\">\r\n            <vnext-toggle-select\r\n              [items]=\"getToggleItemsForCurrentPage()[index]\"\r\n              [verticalGrow]=\"questionShouldGrowVertically(index) || (isMobile$ | async)\"\r\n              [darkenOnHover]=\"true\"\r\n              [buttonHeight]=\"'36px'\"\r\n              (optionSelected)=\"onToggleClick($event, index)\"\r\n              [selectedValue]=\"question.selectedValues ? question.selectedValues[0] : ''\"\r\n              [focusFirstItem]=\"true\"\r\n            ></vnext-toggle-select>\r\n          </ng-container>\r\n          <ng-template #multiSelect>\r\n            <vnext-toggle-multi-select\r\n              [items]=\"getToggleItemsForCurrentPage()[index]\"\r\n              [verticalGrow]=\"questionShouldGrowVertically(index) || (isMobile$ | async)\"\r\n              [darkenOnHover]=\"true\"\r\n              [buttonHeight]=\"'36px'\"\r\n              (optionSelected)=\"onToggleClick($event, index)\"\r\n              [selectedValues]=\"question.selectedValues ? question.selectedValues : []\"\r\n              [focusFirstItem]=\"true\"\r\n            ></vnext-toggle-multi-select>\r\n          </ng-template>\r\n        </div>\r\n      </div>\r\n      <ng-template #noQuestions>\r\n        <div class=\"no-questions\">\r\n          <div\r\n            *liveEditProp=\"'Spa_GuidedHelp_OtherPreferences_NoQuestions_Text'\"\r\n            [innerHtml]=\"noQuestionsText ? (noQuestionsText | safe: 'html') : ''\"\r\n            navigationAdapter\r\n          ></div>\r\n        </div> </ng-template\r\n    ></ng-template>\r\n  </div>\r\n</div>\r\n", styles: ["i{font-size:46px}.no-questions{white-space:pre-line;text-align:center;margin-top:140px;line-height:28px}.question-container{margin-bottom:24px}.question-header{text-align:left;margin-bottom:10px}.page-count{width:100%;text-align:right}.zip-button{border-bottom-left-radius:0;border-top-left-radius:0}\n"] }]
    }], function () { return [{ type: i1.PreferencesService }, { type: i1.ResponsiveLayoutService }, { type: i0.ChangeDetectorRef }, { type: i1.GuidedHelpService }, { type: i1.DemographicService }, { type: HelpfulToolsService }, { type: i1.SpinnerService }, { type: i1.PlansService }, { type: i1.WidgetValidationService }, { type: i1.PreferencesContextService }, { type: AnalyticsService }, { type: i2$1.Router }, { type: ZipCodeContextService }]; }, { preferencesText: [{
            type: Input
        }], spaPageSubHeader: [{
            type: Input
        }], noQuestionsText: [{
            type: Input
        }], availablePages: [{
            type: Input
        }], preferencesLink: [{
            type: Input
        }], currentPage: [{
            type: Input
        }], pageCountText: [{
            type: Input
        }], enterZipText: [{
            type: Input
        }], provideZipText: [{
            type: Input
        }], zipCodeInputZipCodeError: [{
            type: Input
        }], zipCodeInputCountyError: [{
            type: Input
        }], zipCodeInputSelectCounty: [{
            type: Input
        }], zipCodeInputZipCodeLabel: [{
            type: Input
        }], selectedCountyEnabled: [{
            type: Input
        }], zipCodeInputEditCounty: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], countyLabel: [{
            type: Input
        }], showCountyLabel: [{
            type: Input
        }] }); })();

function GuidedHelpPlanListComponent_div_0_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r16.guidedHelpPreferenceText);
} }
function GuidedHelpPlanListComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GuidedHelpPlanListComponent_div_0_div_1_div_1_Template, 2, 1, "div", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_GuidedHelp_PreferenceInfo_Text");
} }
function GuidedHelpPlanListComponent_div_0_div_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 20);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const link_r17 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("fas ", link_r17.iconClass, " pr-md-2 pr-4 mr-4 mr-md-0 Spa_Style_Large_Font fixed-icon-size");
} }
function GuidedHelpPlanListComponent_div_0_div_3_ng_container_5_h3_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r33.guidedHelpGetStartedText, " ");
} }
function GuidedHelpPlanListComponent_div_0_div_3_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GuidedHelpPlanListComponent_div_0_div_3_ng_container_5_h3_1_Template, 2, 1, "h3", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const link_r17 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", link_r17.resourceKeyName);
} }
function GuidedHelpPlanListComponent_div_0_div_3_ng_container_6_h3_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r35.guidedHelpHealthText, " ");
} }
function GuidedHelpPlanListComponent_div_0_div_3_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GuidedHelpPlanListComponent_div_0_div_3_ng_container_6_h3_1_Template, 2, 1, "h3", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const link_r17 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", link_r17.resourceKeyName);
} }
function GuidedHelpPlanListComponent_div_0_div_3_ng_container_7_h3_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r37.guidedHelpProvidersText, " ");
} }
function GuidedHelpPlanListComponent_div_0_div_3_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GuidedHelpPlanListComponent_div_0_div_3_ng_container_7_h3_1_Template, 2, 1, "h3", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const link_r17 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", link_r17.resourceKeyName);
} }
function GuidedHelpPlanListComponent_div_0_div_3_ng_container_8_h3_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r39.guidedHelpPrescriptionsText, " ");
} }
function GuidedHelpPlanListComponent_div_0_div_3_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GuidedHelpPlanListComponent_div_0_div_3_ng_container_8_h3_1_Template, 2, 1, "h3", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const link_r17 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", link_r17.resourceKeyName);
} }
function GuidedHelpPlanListComponent_div_0_div_3_ng_container_9_h3_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r41.guidedHelpPharmacyText, " ");
} }
function GuidedHelpPlanListComponent_div_0_div_3_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GuidedHelpPlanListComponent_div_0_div_3_ng_container_9_h3_1_Template, 2, 1, "h3", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const link_r17 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", link_r17.resourceKeyName);
} }
function GuidedHelpPlanListComponent_div_0_div_3_ng_container_10_h3_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r43.guidedHelpOtherPreferencesText, " ");
} }
function GuidedHelpPlanListComponent_div_0_div_3_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GuidedHelpPlanListComponent_div_0_div_3_ng_container_10_h3_1_Template, 2, 1, "h3", 21);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const link_r17 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", link_r17.resourceKeyName);
} }
function GuidedHelpPlanListComponent_div_0_div_3_vnext_link_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-link", 23);
} if (rf & 2) {
    const link_r17 = i0.ɵɵnextContext().$implicit;
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r25.editLinkText)("tag", link_r17.pageTag)("ariaLabel", ctx_r25.editLinkText + " " + link_r17.ariaLabel)("onClickAction", ctx_r25.onClick(link_r17.pageTag));
} }
function GuidedHelpPlanListComponent_div_0_div_3_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function GuidedHelpPlanListComponent_div_0_div_3_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function GuidedHelpPlanListComponent_div_0_div_3_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function GuidedHelpPlanListComponent_div_0_div_3_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function GuidedHelpPlanListComponent_div_0_div_3_ng_container_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function GuidedHelpPlanListComponent_div_0_div_3_ng_container_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function GuidedHelpPlanListComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14)(2, "div", 15);
    i0.ɵɵtemplate(3, GuidedHelpPlanListComponent_div_0_div_3_ng_container_3_Template, 2, 3, "ng-container", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 16);
    i0.ɵɵtemplate(5, GuidedHelpPlanListComponent_div_0_div_3_ng_container_5_Template, 2, 1, "ng-container", 8);
    i0.ɵɵtemplate(6, GuidedHelpPlanListComponent_div_0_div_3_ng_container_6_Template, 2, 1, "ng-container", 8);
    i0.ɵɵtemplate(7, GuidedHelpPlanListComponent_div_0_div_3_ng_container_7_Template, 2, 1, "ng-container", 8);
    i0.ɵɵtemplate(8, GuidedHelpPlanListComponent_div_0_div_3_ng_container_8_Template, 2, 1, "ng-container", 8);
    i0.ɵɵtemplate(9, GuidedHelpPlanListComponent_div_0_div_3_ng_container_9_Template, 2, 1, "ng-container", 8);
    i0.ɵɵtemplate(10, GuidedHelpPlanListComponent_div_0_div_3_ng_container_10_Template, 2, 1, "ng-container", 8);
    i0.ɵɵtemplate(11, GuidedHelpPlanListComponent_div_0_div_3_vnext_link_11_Template, 1, 4, "vnext-link", 17);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 14)(13, "div", 18);
    i0.ɵɵtemplate(14, GuidedHelpPlanListComponent_div_0_div_3_ng_container_14_Template, 1, 0, "ng-container", 19);
    i0.ɵɵtemplate(15, GuidedHelpPlanListComponent_div_0_div_3_ng_container_15_Template, 1, 0, "ng-container", 19);
    i0.ɵɵtemplate(16, GuidedHelpPlanListComponent_div_0_div_3_ng_container_16_Template, 1, 0, "ng-container", 19);
    i0.ɵɵtemplate(17, GuidedHelpPlanListComponent_div_0_div_3_ng_container_17_Template, 1, 0, "ng-container", 19);
    i0.ɵɵtemplate(18, GuidedHelpPlanListComponent_div_0_div_3_ng_container_18_Template, 1, 0, "ng-container", 19);
    i0.ɵɵtemplate(19, GuidedHelpPlanListComponent_div_0_div_3_ng_container_19_Template, 1, 0, "ng-container", 19);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const link_r17 = ctx.$implicit;
    const ctx_r14 = i0.ɵɵnextContext(2);
    const _r1 = i0.ɵɵreference(3);
    const _r3 = i0.ɵɵreference(5);
    const _r5 = i0.ɵɵreference(7);
    const _r7 = i0.ɵɵreference(9);
    const _r9 = i0.ɵɵreference(11);
    const _r11 = i0.ɵɵreference(13);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", link_r17.pageTag != ctx_r14.pageTags.GUIDED_HELP_OTHER_PREFERENCES || ctx_r14.hasEnteredPreferences);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", link_r17.pageTag === ctx_r14.pageTags.GUIDED_HELP_GETTING_STARTED);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", link_r17.pageTag === ctx_r14.pageTags.GUIDED_HELP_HEALTH);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", link_r17.pageTag === ctx_r14.pageTags.GUIDED_HELP_PROVIDER_SEARCH);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", link_r17.pageTag === ctx_r14.pageTags.GUIDED_HELP_PRESCRIPTIONS);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", link_r17.pageTag === ctx_r14.pageTags.GUIDED_HELP_PHARMACY_SEARCH);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", link_r17.pageTag === ctx_r14.pageTags.GUIDED_HELP_OTHER_PREFERENCES && ctx_r14.hasEnteredPreferences);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", link_r17.showEditLink);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", link_r17.pageTag === ctx_r14.pageTags.GUIDED_HELP_GETTING_STARTED)("ngIfThen", _r1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", link_r17.pageTag === ctx_r14.pageTags.GUIDED_HELP_HEALTH)("ngIfThen", _r3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", link_r17.pageTag === ctx_r14.pageTags.GUIDED_HELP_PROVIDER_SEARCH)("ngIfThen", _r5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", link_r17.pageTag === ctx_r14.pageTags.GUIDED_HELP_PRESCRIPTIONS)("ngIfThen", _r7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", link_r17.pageTag === ctx_r14.pageTags.GUIDED_HELP_PHARMACY_SEARCH)("ngIfThen", _r9);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", link_r17.pageTag === ctx_r14.pageTags.GUIDED_HELP_OTHER_PREFERENCES)("ngIfThen", _r11);
} }
function GuidedHelpPlanListComponent_div_0_div_4_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function GuidedHelpPlanListComponent_div_0_div_4_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r48); const ctx_r47 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r47.onButtonClick()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r46.preferenceButtonText, " ");
} }
function GuidedHelpPlanListComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GuidedHelpPlanListComponent_div_0_div_4_button_1_Template, 2, 1, "button", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_AddPreferences");
} }
function GuidedHelpPlanListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, GuidedHelpPlanListComponent_div_0_div_1_Template, 2, 1, "div", 8);
    i0.ɵɵelementStart(2, "div", 9);
    i0.ɵɵtemplate(3, GuidedHelpPlanListComponent_div_0_div_3_Template, 20, 20, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, GuidedHelpPlanListComponent_div_0_div_4_Template, 2, 1, "div", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.hasEnteredPreferences);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.guidedHelpLinks);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.hasEnteredPreferences);
} }
function GuidedHelpPlanListComponent_ng_template_2_div_0_vnext_link_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-link", 30)(1, "div", 31);
    i0.ɵɵtext(2);
    i0.ɵɵelement(3, "i", 32);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("tag", ctx_r50.pageTags.GUIDED_HELP_GETTING_STARTED)("ariaLabel", ctx_r50.addLinkText + " " + ctx_r50.guidedHelpGetStartedText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r50.addLinkText);
} }
function GuidedHelpPlanListComponent_ng_template_2_div_0_div_5_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r52.subsidyAndPercentText);
} }
function GuidedHelpPlanListComponent_ng_template_2_div_0_div_5_li_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 36);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r53.medicaidCodeWithStateAndLastCheckedDateText, " ");
} }
function GuidedHelpPlanListComponent_ng_template_2_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33)(1, "ul", 34);
    i0.ɵɵtemplate(2, GuidedHelpPlanListComponent_ng_template_2_div_0_div_5_li_2_Template, 2, 1, "li", 8);
    i0.ɵɵtemplate(3, GuidedHelpPlanListComponent_ng_template_2_div_0_div_5_li_3_Template, 2, 1, "li", 35);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r51 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r51.subsidyAndPercentText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r51.medicaidEligibilityCheckEnabled && ctx_r51.isMedicaidEligible && ctx_r51.medicaidCodeWithStateAndLastCheckedDateText);
} }
function GuidedHelpPlanListComponent_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵtext(2, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 27);
    i0.ɵɵtemplate(4, GuidedHelpPlanListComponent_ng_template_2_div_0_vnext_link_4_Template, 4, 3, "vnext-link", 28);
    i0.ɵɵtemplate(5, GuidedHelpPlanListComponent_ng_template_2_div_0_div_5_Template, 4, 2, "div", 29);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r49.hasEnteredPreferences && !ctx_r49.subsidyAndPercentText ? "col-auto" : "col-11");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r49.hasEnteredPreferences && !ctx_r49.subsidyAndPercentText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r49.subsidyAndPercentText || ctx_r49.medicaidEligibilityCheckEnabled && ctx_r49.isMedicaidEligible);
} }
function GuidedHelpPlanListComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, GuidedHelpPlanListComponent_ng_template_2_div_0_Template, 6, 3, "div", 26);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.hasEnteredPreferences || ctx_r2.medicaidEligibilityCheckEnabled && ctx_r2.isMedicaidEligible);
} }
function GuidedHelpPlanListComponent_ng_template_4_div_0_vnext_link_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-link", 38)(1, "div", 31);
    i0.ɵɵtext(2);
    i0.ɵɵelement(3, "i", 32);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r55 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("tag", ctx_r55.pageTags.GUIDED_HELP_HEALTH)("ariaLabel", ctx_r55.addLinkText + " " + ctx_r55.guidedHelpHealthText)("onClickAction", ctx_r55.onClick(ctx_r55.pageTags.GUIDED_HELP_HEALTH));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r55.addLinkText);
} }
function GuidedHelpPlanListComponent_ng_template_4_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33)(1, "ul", 34)(2, "li");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "li");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r56 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r56.healthStatusText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r56.ageRangeText);
} }
function GuidedHelpPlanListComponent_ng_template_4_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵtext(2, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 27);
    i0.ɵɵtemplate(4, GuidedHelpPlanListComponent_ng_template_4_div_0_vnext_link_4_Template, 4, 4, "vnext-link", 37);
    i0.ɵɵtemplate(5, GuidedHelpPlanListComponent_ng_template_4_div_0_div_5_Template, 6, 2, "div", 29);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", !ctx_r54.isHealthStatusAdded ? "col-auto" : "col-11");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r54.isHealthStatusAdded);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r54.isHealthStatusAdded);
} }
function GuidedHelpPlanListComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, GuidedHelpPlanListComponent_ng_template_4_div_0_Template, 6, 3, "div", 26);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r4.hasEnteredPreferences);
} }
function GuidedHelpPlanListComponent_ng_template_6_div_0_vnext_link_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-link", 38)(1, "div", 31);
    i0.ɵɵtext(2);
    i0.ɵɵelement(3, "i", 32);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r58 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("tag", ctx_r58.pageTags.GUIDED_HELP_PROVIDER_SEARCH)("ariaLabel", ctx_r58.addLinkText + " " + ctx_r58.guidedHelpProvidersText)("onClickAction", ctx_r58.onClick(ctx_r58.pageTags.GUIDED_HELP_PROVIDER_SEARCH));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r58.addLinkText);
} }
function GuidedHelpPlanListComponent_ng_template_6_div_0_ng_container_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r65 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 42)(2, "vnext-link", 43);
    i0.ɵɵlistener("click", function GuidedHelpPlanListComponent_ng_template_6_div_0_ng_container_6_ng_container_1_Template_vnext_link_click_2_listener() { i0.ɵɵrestoreView(_r65); const ctx_r64 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r64.showAllSelectedProviders = !ctx_r64.showAllSelectedProviders); })("keyup.enter", function GuidedHelpPlanListComponent_ng_template_6_div_0_ng_container_6_ng_container_1_Template_vnext_link_keyup_enter_2_listener() { i0.ɵɵrestoreView(_r65); const ctx_r66 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r66.showAllSelectedProviders = !ctx_r66.showAllSelectedProviders); });
    i0.ɵɵelementStart(3, "div", 44);
    i0.ɵɵtext(4);
    i0.ɵɵelement(5, "i");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r62 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("makeInlineBlock", true)("keyNameForLiveEdit", "Spa_Site_Hide_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r62.getLinkText(ctx_r62.showAllSelectedProviders), " ");
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r62.getIcon(ctx_r62.showAllSelectedProviders));
} }
function GuidedHelpPlanListComponent_ng_template_6_div_0_ng_container_6_li_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r67 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", ctx_r67.pcpText, ")");
} }
function GuidedHelpPlanListComponent_ng_template_6_div_0_ng_container_6_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 45)(1, "span", 46);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, GuidedHelpPlanListComponent_ng_template_6_div_0_ng_container_6_li_2_span_4_Template, 2, 1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const selectedProvider_r60 = i0.ɵɵnextContext().$implicit;
    const ctx_r63 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, ctx_r63.displayLabel(selectedProvider_r60.displayName)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", selectedProvider_r60.isPrimary);
} }
function GuidedHelpPlanListComponent_ng_template_6_div_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GuidedHelpPlanListComponent_ng_template_6_div_0_ng_container_6_ng_container_1_Template, 6, 6, "ng-container", 8);
    i0.ɵɵtemplate(2, GuidedHelpPlanListComponent_ng_template_6_div_0_ng_container_6_li_2_Template, 5, 4, "li", 41);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const selectedProvider_r60 = ctx.$implicit;
    const index_r61 = ctx.index;
    const ctx_r59 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", index_r61 === 5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (index_r61 < 5 || ctx_r59.showAllSelectedProviders) && selectedProvider_r60.displayName);
} }
function GuidedHelpPlanListComponent_ng_template_6_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵtext(2, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 27);
    i0.ɵɵtemplate(4, GuidedHelpPlanListComponent_ng_template_6_div_0_vnext_link_4_Template, 4, 4, "vnext-link", 37);
    i0.ɵɵelementStart(5, "ul", 39);
    i0.ɵɵtemplate(6, GuidedHelpPlanListComponent_ng_template_6_div_0_ng_container_6_Template, 3, 2, "ng-container", 40);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r57 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", !ctx_r57.selectedProviders.length ? "col-auto" : "col-11");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r57.selectedProviders.length);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r57.selectedProviders);
} }
function GuidedHelpPlanListComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, GuidedHelpPlanListComponent_ng_template_6_div_0_Template, 7, 3, "div", 26);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r6.hasEnteredPreferences);
} }
function GuidedHelpPlanListComponent_ng_template_8_div_0_vnext_link_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-link", 38)(1, "div", 31);
    i0.ɵɵtext(2);
    i0.ɵɵelement(3, "i", 32);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r70 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("tag", ctx_r70.pageTags.GUIDED_HELP_PRESCRIPTIONS)("ariaLabel", ctx_r70.addLinkText + " " + ctx_r70.guidedHelpPrescriptionsText)("onClickAction", ctx_r70.onClick(ctx_r70.pageTags.GUIDED_HELP_PRESCRIPTIONS));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r70.addLinkText);
} }
function GuidedHelpPlanListComponent_ng_template_8_div_0_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r77 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 49)(1, "vnext-link", 43);
    i0.ɵɵlistener("click", function GuidedHelpPlanListComponent_ng_template_8_div_0_ng_container_6_div_1_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r77); const ctx_r76 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r76.showAllMedicineLabels = !ctx_r76.showAllMedicineLabels); })("keyup.enter", function GuidedHelpPlanListComponent_ng_template_8_div_0_ng_container_6_div_1_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r77); const ctx_r78 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r78.showAllMedicineLabels = !ctx_r78.showAllMedicineLabels); });
    i0.ɵɵelementStart(2, "div", 50);
    i0.ɵɵtext(3);
    i0.ɵɵelement(4, "i");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r74 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("makeInlineBlock", true)("keyNameForLiveEdit", "Spa_Site_Hide_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r74.getLinkText(ctx_r74.showAllMedicineLabels), " ");
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r74.getIcon(ctx_r74.showAllMedicineLabels));
} }
function GuidedHelpPlanListComponent_ng_template_8_div_0_ng_container_6_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 51);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const medicine_r72 = i0.ɵɵnextContext().$implicit;
    const ctx_r75 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r75.displayLabel(medicine_r72.labelName), " ");
} }
function GuidedHelpPlanListComponent_ng_template_8_div_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GuidedHelpPlanListComponent_ng_template_8_div_0_ng_container_6_div_1_Template, 5, 6, "div", 47);
    i0.ɵɵtemplate(2, GuidedHelpPlanListComponent_ng_template_8_div_0_ng_container_6_li_2_Template, 2, 1, "li", 48);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const index_r73 = ctx.index;
    const ctx_r71 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", index_r73 === 5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", index_r73 < 5 || ctx_r71.showAllMedicineLabels);
} }
function GuidedHelpPlanListComponent_ng_template_8_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵtext(2, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 27);
    i0.ɵɵtemplate(4, GuidedHelpPlanListComponent_ng_template_8_div_0_vnext_link_4_Template, 4, 4, "vnext-link", 37);
    i0.ɵɵelementStart(5, "ul", 39);
    i0.ɵɵtemplate(6, GuidedHelpPlanListComponent_ng_template_8_div_0_ng_container_6_Template, 3, 2, "ng-container", 40);
    i0.ɵɵpipe(7, "orderBy");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r69 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r69.medicineCabinet.length === 0 ? "col-auto" : "col-11");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r69.medicineCabinet.length === 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind4(7, 3, ctx_r69.medicineCabinet, "labelName", false, true));
} }
function GuidedHelpPlanListComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, GuidedHelpPlanListComponent_ng_template_8_div_0_Template, 8, 8, "div", 26);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r8.hasEnteredPreferences);
} }
function GuidedHelpPlanListComponent_ng_template_10_div_0_vnext_link_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-link", 38)(1, "div", 31);
    i0.ɵɵtext(2);
    i0.ɵɵelement(3, "i", 32);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r81 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("tag", ctx_r81.pageTags.GUIDED_HELP_PHARMACY_SEARCH)("ariaLabel", ctx_r81.addLinkText + " " + ctx_r81.guidedHelpPharmacyText)("onClickAction", ctx_r81.onClick(ctx_r81.pageTags.GUIDED_HELP_PHARMACY_SEARCH));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r81.addLinkText);
} }
function GuidedHelpPlanListComponent_ng_template_10_div_0_ng_container_6_li_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r87 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", ctx_r87.primaryPharmacyIndicatorText, ")");
} }
function GuidedHelpPlanListComponent_ng_template_10_div_0_ng_container_6_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 45)(1, "span", 46);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GuidedHelpPlanListComponent_ng_template_10_div_0_ng_container_6_li_1_span_3_Template, 2, 1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const selectedPharmacy_r86 = ctx.$implicit;
    const ctx_r85 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r85.displayLabel(selectedPharmacy_r86.name));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", selectedPharmacy_r86.pharmacyId === ctx_r85.primaryPharmacy.pharmacyId);
} }
function GuidedHelpPlanListComponent_ng_template_10_div_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GuidedHelpPlanListComponent_ng_template_10_div_0_ng_container_6_li_1_Template, 4, 2, "li", 54);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r82 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r82.selectedPharmacies);
} }
function GuidedHelpPlanListComponent_ng_template_10_div_0_ng_template_7_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li", 45)(2, "span", 46);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r88 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r88.displayLabel(ctx_r88.selectedPharmacy.name));
} }
function GuidedHelpPlanListComponent_ng_template_10_div_0_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, GuidedHelpPlanListComponent_ng_template_10_div_0_ng_template_7_ng_container_0_Template, 4, 1, "ng-container", 8);
} if (rf & 2) {
    const ctx_r84 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r84.selectedPharmacy);
} }
function GuidedHelpPlanListComponent_ng_template_10_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵtext(2, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 27);
    i0.ɵɵtemplate(4, GuidedHelpPlanListComponent_ng_template_10_div_0_vnext_link_4_Template, 4, 4, "vnext-link", 37);
    i0.ɵɵelementStart(5, "ul", 39);
    i0.ɵɵtemplate(6, GuidedHelpPlanListComponent_ng_template_10_div_0_ng_container_6_Template, 2, 1, "ng-container", 52);
    i0.ɵɵtemplate(7, GuidedHelpPlanListComponent_ng_template_10_div_0_ng_template_7_Template, 1, 1, "ng-template", null, 53, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const _r83 = i0.ɵɵreference(8);
    const ctx_r80 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", !ctx_r80.multiPharmacyEnabled && !ctx_r80.selectedPharmacy || ctx_r80.multiPharmacyEnabled && !ctx_r80.selectedPharmacies.length ? "col-auto" : "col-11");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r80.multiPharmacyEnabled && !ctx_r80.selectedPharmacy || ctx_r80.multiPharmacyEnabled && !ctx_r80.selectedPharmacies.length);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r80.multiPharmacyEnabled)("ngIfElse", _r83);
} }
function GuidedHelpPlanListComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, GuidedHelpPlanListComponent_ng_template_10_div_0_Template, 9, 4, "div", 26);
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r10.hasEnteredPreferences);
} }
function GuidedHelpPlanListComponent_ng_template_12_div_0_vnext_link_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-link", 38)(1, "div", 31);
    i0.ɵɵtext(2);
    i0.ɵɵelement(3, "i", 32);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r90 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("tag", ctx_r90.pageTags.GUIDED_HELP_OTHER_PREFERENCES)("ariaLabel", ctx_r90.addLinkText + " " + ctx_r90.guidedHelpOtherPreferencesText)("onClickAction", ctx_r90.logOtherPreferencesNavigation);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r90.addLinkText);
} }
function GuidedHelpPlanListComponent_ng_template_12_div_0_div_5_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r92 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r92.guidedHelpOtherPreferencesMessageText);
} }
function GuidedHelpPlanListComponent_ng_template_12_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33)(1, "ul", 34);
    i0.ɵɵtemplate(2, GuidedHelpPlanListComponent_ng_template_12_div_0_div_5_li_2_Template, 2, 1, "li", 55);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r91 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", ctx_r91.guidedHelpOtherPreferencesMessageKey);
} }
function GuidedHelpPlanListComponent_ng_template_12_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵtext(2, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 27);
    i0.ɵɵtemplate(4, GuidedHelpPlanListComponent_ng_template_12_div_0_vnext_link_4_Template, 4, 4, "vnext-link", 37);
    i0.ɵɵtemplate(5, GuidedHelpPlanListComponent_ng_template_12_div_0_div_5_Template, 3, 1, "div", 29);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r89 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", !ctx_r89.hasEnteredOtherPreferences() ? "col-auto" : "col-11");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r89.hasEnteredOtherPreferences());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r89.hasEnteredOtherPreferences());
} }
function GuidedHelpPlanListComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, GuidedHelpPlanListComponent_ng_template_12_div_0_Template, 6, 3, "div", 26);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r12.hasEnteredPreferences);
} }
class GuidedHelpPlanListComponent {
    constructor(guidedHelpService, cdr, analyticsService, localeService, store, profileService) {
        this.guidedHelpService = guidedHelpService;
        this.cdr = cdr;
        this.analyticsService = analyticsService;
        this.localeService = localeService;
        this.store = store;
        this.profileService = profileService;
        this.showAllMedicineLabels = false;
        this.pageTags = PageTags;
        this.subscriptions = new Subscription();
        this.showAllSelectedProviders = false;
        this.displayLabelMaxWidth = 17;
        this.guidedHelpLinks = [];
        this.isHealthStatusAdded = false;
        this.isMedicaidEligible = false;
        this.logOtherPreferencesNavigation = () => {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_OTHER_PREFERENCES);
        };
    }
    ngOnChanges(changes) {
        const { subsidyLabelText, medicaidCodeText } = changes;
        if (subsidyLabelText && subsidyLabelText.currentValue !== subsidyLabelText.previousValue) {
            this.subsidyAndPercentText = this.guidedHelpService.getSubsidyAndPercentText(this.subsidyLabelText);
        }
        if (this.medicaidEligibilityCheckEnabled && medicaidCodeText && medicaidCodeText.previousValue !== medicaidCodeText.currentValue) {
            const medicaidEligibilityLevel = this.profileService.getMedicaidEligibilityLevel();
            const medicaidStateSelection = this.profileService.getMedicaidStateSelection();
            const medicaidLastCheckedDate = this.profileService.getMedicaidLastCheckedDate();
            this.medicaidCodeWithStateAndLastCheckedDateText =
                this.medicaidCodeText
                    ?.replace('<medicaidCode>', medicaidEligibilityLevel)
                    ?.replace('<state>', medicaidStateSelection)
                    ?.replace('<checkedDate>', DateUtilities.getFormattedDateTime(new Date(medicaidLastCheckedDate), DateUtilities.defaultFormat)) ??
                    '';
        }
    }
    ngOnInit() {
        this.isMobile$ = this.guidedHelpService.isMobile$;
        this.guidedHelpService.setDefaultValuesForNavigationLinks();
        this.totalEstimatedCostEnabled = this.guidedHelpService.getProcessedResourceValue('Spa_Site_TotalEstimatedCost_Enabled', true);
        if (this.medicaidEligibilityCheckEnabled) {
            this.isMedicaidEligible = this.profileService.getIsMedicaidEligible();
        }
        this.subscriptions.add(this.guidedHelpService.getHasVisited$().subscribe({
            next: hasVisited => {
                this.hasEnteredPreferences = hasVisited;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.guidedHelpService.getMedicineCabinet$().subscribe({
            next: medicineCabinet => {
                this.medicineCabinet = medicineCabinet;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe({
            next: locale => {
                this.initializeTranslatableText();
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.guidedHelpService.getSelectedProviders$().subscribe({
            next: selectedProviders => {
                this.selectedProviders = selectedProviders;
                this.cdr.markForCheck();
            }
        }));
        if (this.multiPharmacyEnabled) {
            this.subscriptions.add(this.guidedHelpService.getSelectedPharmacies$().subscribe({
                next: selectedPharmacies => {
                    this.selectedPharmacies = selectedPharmacies;
                    this.cdr.markForCheck();
                }
            }));
            this.subscriptions.add(this.guidedHelpService.getPrimaryPharmacy$().subscribe({
                next: pharmacy => {
                    this.primaryPharmacy = pharmacy;
                    this.cdr.markForCheck();
                }
            }));
        }
        else {
            this.subscriptions.add(this.guidedHelpService.getSelectedPharmacy$().subscribe({
                next: selectedPharmacy => {
                    this.selectedPharmacy = selectedPharmacy;
                    this.cdr.markForCheck();
                }
            }));
        }
        this.subscriptions.add(this.guidedHelpService
            .getLinks$()
            .pipe(distinctUntilChanged(_isEqual), map(links => links?.reduce((selectedLinks, link) => {
            // Remove the health in preferences when total estimated cost is disabled.
            const showLink = this.totalEstimatedCostEnabled ? link.enabled : link.pageTag !== PageTags.GUIDED_HELP_HEALTH;
            if (showLink) {
                selectedLinks.push({ ...link, showEditLink: this.showEditLink(link), ariaLabel: this.getAriaLabel(link) });
            }
            return selectedLinks;
        }, []) ?? []))
            .subscribe({
            next: links => {
                this.guidedHelpLinks = links;
                this.cdr.markForCheck();
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    onButtonClick() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADDPREFERENCES);
        this.guidedHelpService.goToFirstLink();
    }
    /**
     * Only show part of the label if its too long oh and add some dots cause why not.
     */
    displayLabel(label) {
        return label.length > this.displayLabelMaxWidth ? `${label.substr(0, this.displayLabelMaxWidth - 3)}...` : label;
    }
    showEditLink(link) {
        if (link.pageTag === PageTags.GUIDED_HELP_GETTING_STARTED) {
            return this.subsidyAndPercentText ? true : false;
        }
        if (link.pageTag === PageTags.GUIDED_HELP_HEALTH) {
            return this.ageRangeText && this.healthStatusText ? true : false;
        }
        if (link.pageTag === PageTags.GUIDED_HELP_PRESCRIPTIONS) {
            return this.medicineCabinet.length > 0;
        }
        if (link.pageTag === PageTags.GUIDED_HELP_PHARMACY_SEARCH) {
            return ((!this.multiPharmacyEnabled && this.selectedPharmacy !== null) || (this.multiPharmacyEnabled && this.selectedPharmacies.length > 0));
        }
        if (link.pageTag === PageTags.GUIDED_HELP_PROVIDER_SEARCH) {
            return this.selectedProviders.length > 0;
        }
        if (link.pageTag === PageTags.GUIDED_HELP_OTHER_PREFERENCES) {
            return this.store.selectSnapshot(PreferencesState.hasPreferences);
        }
        return false;
    }
    getAriaLabel(link) {
        switch (link.pageTag) {
            case PageTags.GUIDED_HELP_GETTING_STARTED:
                return this.guidedHelpGetStartedText;
            case PageTags.GUIDED_HELP_HEALTH:
                return this.guidedHelpHealthText;
            case PageTags.GUIDED_HELP_PRESCRIPTIONS:
                return this.guidedHelpPrescriptionsText;
            case PageTags.GUIDED_HELP_PHARMACY_SEARCH:
                return this.guidedHelpPharmacyText;
            case PageTags.GUIDED_HELP_PROVIDER_SEARCH:
                return this.guidedHelpProvidersText;
            case PageTags.GUIDED_HELP_OTHER_PREFERENCES:
                return this.guidedHelpOtherPreferencesText;
            default:
                return '';
        }
    }
    getIcon(showAllLabels) {
        return `fas ${showAllLabels ? 'fa-angle-up' : ' fa-angle-down'}`;
    }
    getLinkText(showAllLabels) {
        return showAllLabels ? this.guidedHelpHideLinkText : this.guidedHelpViewAllLinkText;
    }
    onClick(pageTag) {
        return () => {
            if (pageTag === PageTags.GUIDED_HELP_PRESCRIPTIONS) {
                this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_DRUGS);
            }
            else if (pageTag === PageTags.GUIDED_HELP_PHARMACY_SEARCH) {
                this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_PHARMACY);
            }
            else if (pageTag === PageTags.GUIDED_HELP_PROVIDER_SEARCH) {
                this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_PROVIDER);
            }
            else if (pageTag === PageTags.GUIDED_HELP_HEALTH) {
                this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_HEALTH);
            }
            else if (pageTag === PageTags.GUIDED_HELP_OTHER_PREFERENCES) {
                this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_OTHER_PREFERENCES);
            }
        };
    }
    hasEnteredOtherPreferences() {
        return this.store.selectSnapshot(PreferencesState.hasPreferences);
    }
    initializeTranslatableText() {
        this.addLinkText = this.guidedHelpService.getProcessedResourceValue('Spa_GuidedHelp_PlanList_AddLink_Text', 'Add');
        this.editLinkText = this.guidedHelpService.getProcessedResourceValue('Spa_Site_Edit_Text', 'Edit');
        this.healthStatusText = this.guidedHelpService.getHealthStatusText();
        this.ageRangeText = this.guidedHelpService.getAgeRangeText();
        this.isHealthStatusAdded = !!(this.healthStatusText && this.ageRangeText);
    }
}
GuidedHelpPlanListComponent.ɵfac = function GuidedHelpPlanListComponent_Factory(t) { return new (t || GuidedHelpPlanListComponent)(i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.ProfileService)); };
GuidedHelpPlanListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GuidedHelpPlanListComponent, selectors: [["vnext-guided-help-tab"]], inputs: { guidedHelpPreferenceText: "guidedHelpPreferenceText", preferenceButtonText: "preferenceButtonText", guidedHelpHideLinkText: "guidedHelpHideLinkText", guidedHelpViewAllLinkText: "guidedHelpViewAllLinkText", guidedHelpGetStartedText: "guidedHelpGetStartedText", guidedHelpHealthText: "guidedHelpHealthText", guidedHelpPrescriptionsText: "guidedHelpPrescriptionsText", guidedHelpPharmacyText: "guidedHelpPharmacyText", guidedHelpOtherPreferencesText: "guidedHelpOtherPreferencesText", guidedHelpOtherPreferencesMessageText: "guidedHelpOtherPreferencesMessageText", guidedHelpOtherPreferencesMessageKey: "guidedHelpOtherPreferencesMessageKey", multiPharmacyEnabled: "multiPharmacyEnabled", primaryPharmacyIndicatorText: "primaryPharmacyIndicatorText", guidedHelpProvidersText: "guidedHelpProvidersText", pcpText: "pcpText", subsidyLabelText: "subsidyLabelText", medicaidEligibilityCheckEnabled: "medicaidEligibilityCheckEnabled", medicaidCodeText: "medicaidCodeText" }, features: [i0.ɵɵNgOnChangesFeature], decls: 14, vars: 3, consts: [["class", "d-flex flex-column p-3", 4, "ngIf"], ["getStarted", ""], ["health", ""], ["provider", ""], ["prescription", ""], ["pharmacy", ""], ["otherPreferences", ""], [1, "d-flex", "flex-column", "p-3"], [4, "ngIf"], [1, "d-flex", "d-md-block", "pt-2"], ["class", "pb-2", 4, "ngFor", "ngForOf"], ["class", "Spa_Style_Paragraph", 4, "liveEditProp"], [1, "Spa_Style_Paragraph"], [1, "pb-2"], [1, "row", "flex-nowrap"], [1, "col-1"], [1, "col-11"], ["class", "float-right pr-2", 3, "title", "tag", "ariaLabel", "onClickAction", 4, "ngIf"], [1, "col-12", "Spa_Style_Primary_Color"], [4, "ngIf", "ngIfThen"], ["aria-hidden", "true"], ["class", "Spa_Style_H4 mt-2 d-none d-md-inline", 4, "liveEditProp"], [1, "Spa_Style_H4", "mt-2", "d-none", "d-md-inline"], [1, "float-right", "pr-2", 3, "title", "tag", "ariaLabel", "onClickAction"], ["class", "Spa_Style_PrimaryButton btn w-100 my-2", 3, "click", 4, "liveEditProp"], [1, "Spa_Style_PrimaryButton", "btn", "w-100", "my-2", 3, "click"], ["class", "row flex-nowrap", 4, "ngIf"], [3, "ngClass"], [3, "tag", "ariaLabel", 4, "ngIf"], ["class", "Spa_Style_Small_Font mb-2 pl-3", 4, "ngIf"], [3, "tag", "ariaLabel"], ["tag-image-body", ""], [1, "fas", "fa-plus-circle", "ml-1"], [1, "Spa_Style_Small_Font", "mb-2", "pl-3"], [1, "p-0", "m-0"], ["class", "text-break", 4, "ngIf"], [1, "text-break"], [3, "tag", "ariaLabel", "onClickAction", 4, "ngIf"], [3, "tag", "ariaLabel", "onClickAction"], [1, "py-0", "pr-0", "pl-3", "m-0"], [4, "ngFor", "ngForOf"], ["class", "Spa_Style_Small_Font mb-2", 4, "ngIf"], [1, "mb-1", "view-hide-text"], [3, "makeInlineBlock", "keyNameForLiveEdit", "click", "keyup.enter"], ["link-body", "", 1, "pl-0"], [1, "Spa_Style_Small_Font", "mb-2"], [1, "no-translate-block"], ["class", "mb-1", 4, "ngIf"], ["class", "Spa_Style_Small_Font mb-2 no-translate-block", 4, "ngIf"], [1, "mb-1"], ["link-body", "", 1, ""], [1, "Spa_Style_Small_Font", "mb-2", "no-translate-block"], [4, "ngIf", "ngIfElse"], ["pharmacyDetail", ""], ["class", "Spa_Style_Small_Font mb-2", 4, "ngFor", "ngForOf"], [4, "liveEditProp"]], template: function GuidedHelpPlanListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, GuidedHelpPlanListComponent_div_0_Template, 5, 3, "div", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵtemplate(2, GuidedHelpPlanListComponent_ng_template_2_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(4, GuidedHelpPlanListComponent_ng_template_4_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(6, GuidedHelpPlanListComponent_ng_template_6_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(8, GuidedHelpPlanListComponent_ng_template_8_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(10, GuidedHelpPlanListComponent_ng_template_10_Template, 1, 1, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(12, GuidedHelpPlanListComponent_ng_template_12_Template, 1, 1, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.hasEnteredPreferences || !i0.ɵɵpipeBind1(1, 1, ctx.isMobile$));
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, LiveEditPropDirective, IconAriaAttributesDirective, i1$2.AsyncPipe, i1$2.TitleCasePipe, OrderPipe], styles: [".fixed-icon-size[_ngcontent-%COMP%]{min-width:25px;max-width:25px}.view-hide-text[_ngcontent-%COMP%]{margin-left:-16px}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], GuidedHelpPlanListComponent.prototype, "onButtonClick", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuidedHelpPlanListComponent, [{
        type: Component,
        args: [{ selector: 'vnext-guided-help-tab', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"!hasEnteredPreferences || !(isMobile$ | async)\" class=\"d-flex flex-column p-3\">\r\n  <div *ngIf=\"!hasEnteredPreferences\">\r\n    <div class=\"Spa_Style_Paragraph\" *liveEditProp=\"'Spa_GuidedHelp_PreferenceInfo_Text'\">{{ guidedHelpPreferenceText }}</div>\r\n  </div>\r\n  <div class=\"d-flex d-md-block pt-2\">\r\n    <div *ngFor=\"let link of guidedHelpLinks\" class=\"pb-2\">\r\n      <div class=\"row flex-nowrap\">\r\n        <div class=\"col-1\">\r\n          <ng-container *ngIf=\"link.pageTag != pageTags.GUIDED_HELP_OTHER_PREFERENCES || hasEnteredPreferences\">\r\n            <i class=\"fas {{ link.iconClass }} pr-md-2 pr-4 mr-4 mr-md-0 Spa_Style_Large_Font fixed-icon-size\" aria-hidden=\"true\"></i>\r\n          </ng-container>\r\n        </div>\r\n        <div class=\"col-11\">\r\n          <ng-container *ngIf=\"link.pageTag === pageTags.GUIDED_HELP_GETTING_STARTED\">\r\n            <h3 class=\"Spa_Style_H4 mt-2 d-none d-md-inline\" *liveEditProp=\"link.resourceKeyName\">\r\n              {{ guidedHelpGetStartedText }}\r\n            </h3>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"link.pageTag === pageTags.GUIDED_HELP_HEALTH\">\r\n            <h3 class=\"Spa_Style_H4 mt-2 d-none d-md-inline\" *liveEditProp=\"link.resourceKeyName\">\r\n              {{ guidedHelpHealthText }}\r\n            </h3>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"link.pageTag === pageTags.GUIDED_HELP_PROVIDER_SEARCH\">\r\n            <h3 class=\"Spa_Style_H4 mt-2 d-none d-md-inline\" *liveEditProp=\"link.resourceKeyName\">\r\n              {{ guidedHelpProvidersText }}\r\n            </h3>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"link.pageTag === pageTags.GUIDED_HELP_PRESCRIPTIONS\">\r\n            <h3 class=\"Spa_Style_H4 mt-2 d-none d-md-inline\" *liveEditProp=\"link.resourceKeyName\">\r\n              {{ guidedHelpPrescriptionsText }}\r\n            </h3>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"link.pageTag === pageTags.GUIDED_HELP_PHARMACY_SEARCH\">\r\n            <h3 class=\"Spa_Style_H4 mt-2 d-none d-md-inline\" *liveEditProp=\"link.resourceKeyName\">\r\n              {{ guidedHelpPharmacyText }}\r\n            </h3>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"link.pageTag === pageTags.GUIDED_HELP_OTHER_PREFERENCES && hasEnteredPreferences\">\r\n            <h3 class=\"Spa_Style_H4 mt-2 d-none d-md-inline\" *liveEditProp=\"link.resourceKeyName\">\r\n              {{ guidedHelpOtherPreferencesText }}\r\n            </h3>\r\n          </ng-container>\r\n          <vnext-link\r\n            *ngIf=\"link.showEditLink\"\r\n            class=\"float-right pr-2\"\r\n            [title]=\"editLinkText\"\r\n            [tag]=\"link.pageTag\"\r\n            [ariaLabel]=\"editLinkText + ' ' + link.ariaLabel\"\r\n            [onClickAction]=\"onClick(link.pageTag)\"\r\n          ></vnext-link>\r\n        </div>\r\n      </div>\r\n      <div class=\"row flex-nowrap\">\r\n        <div class=\"col-12 Spa_Style_Primary_Color\">\r\n          <ng-container *ngIf=\"link.pageTag === pageTags.GUIDED_HELP_GETTING_STARTED; then getStarted\"> </ng-container>\r\n          <ng-container *ngIf=\"link.pageTag === pageTags.GUIDED_HELP_HEALTH; then health\"> </ng-container>\r\n          <ng-container *ngIf=\"link.pageTag === pageTags.GUIDED_HELP_PROVIDER_SEARCH; then provider\"> </ng-container>\r\n          <ng-container *ngIf=\"link.pageTag === pageTags.GUIDED_HELP_PRESCRIPTIONS; then prescription\"> </ng-container>\r\n          <ng-container *ngIf=\"link.pageTag === pageTags.GUIDED_HELP_PHARMACY_SEARCH; then pharmacy\"> </ng-container>\r\n          <ng-container *ngIf=\"link.pageTag === pageTags.GUIDED_HELP_OTHER_PREFERENCES; then otherPreferences\"> </ng-container>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div *ngIf=\"!hasEnteredPreferences\">\r\n    <button class=\"Spa_Style_PrimaryButton btn w-100 my-2\" *liveEditProp=\"'Spa_Site_AddPreferences'\" (click)=\"onButtonClick()\">\r\n      {{ preferenceButtonText }}\r\n    </button>\r\n  </div>\r\n</div>\r\n\r\n<!-- Templates  -->\r\n\r\n<ng-template #getStarted>\r\n  <div *ngIf=\"hasEnteredPreferences || (medicaidEligibilityCheckEnabled && isMedicaidEligible)\" class=\"row flex-nowrap\">\r\n    <div class=\"col-1\">&nbsp;</div>\r\n    <div [ngClass]=\"(hasEnteredPreferences && !subsidyAndPercentText) ? 'col-auto' : 'col-11'\">\r\n      <vnext-link\r\n        *ngIf=\"hasEnteredPreferences && !subsidyAndPercentText\"\r\n        [tag]=\"pageTags.GUIDED_HELP_GETTING_STARTED\"\r\n        [ariaLabel]=\"addLinkText + ' ' + guidedHelpGetStartedText\"\r\n      >\r\n        <div tag-image-body>{{ addLinkText }}<i class=\"fas fa-plus-circle ml-1\"></i></div>\r\n      </vnext-link>\r\n      <div *ngIf=\"subsidyAndPercentText || (medicaidEligibilityCheckEnabled && isMedicaidEligible)\" class=\"Spa_Style_Small_Font mb-2 pl-3\">\r\n        <ul class=\"p-0 m-0\">\r\n          <li *ngIf=\"subsidyAndPercentText\">{{ subsidyAndPercentText }}</li>\r\n          <li\r\n            *ngIf=\"medicaidEligibilityCheckEnabled && isMedicaidEligible && medicaidCodeWithStateAndLastCheckedDateText\"\r\n            class=\"text-break\"\r\n          >\r\n            {{ medicaidCodeWithStateAndLastCheckedDateText }}\r\n          </li>\r\n        </ul>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #health>\r\n  <div *ngIf=\"hasEnteredPreferences\" class=\"row flex-nowrap\">\r\n    <div class=\"col-1\">&nbsp;</div>\r\n    <div [ngClass]=\"!isHealthStatusAdded ? 'col-auto' : 'col-11'\">\r\n      <vnext-link\r\n        *ngIf=\"!isHealthStatusAdded\"\r\n        [tag]=\"pageTags.GUIDED_HELP_HEALTH\"\r\n        [ariaLabel]=\"addLinkText + ' ' + guidedHelpHealthText\"\r\n        [onClickAction]=\"onClick(pageTags.GUIDED_HELP_HEALTH)\"\r\n      >\r\n        <div tag-image-body>{{ addLinkText }}<i class=\"fas fa-plus-circle ml-1\"></i></div>\r\n      </vnext-link>\r\n      <div *ngIf=\"isHealthStatusAdded\" class=\"Spa_Style_Small_Font mb-2 pl-3\">\r\n        <ul class=\"p-0 m-0\">\r\n          <li>{{ healthStatusText }}</li>\r\n          <li>{{ ageRangeText }}</li>\r\n        </ul>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #provider>\r\n  <div *ngIf=\"hasEnteredPreferences\" class=\"row flex-nowrap\">\r\n    <div class=\"col-1\">&nbsp;</div>\r\n    <div [ngClass]=\"!selectedProviders.length ? 'col-auto' : 'col-11'\">\r\n      <vnext-link\r\n        *ngIf=\"!selectedProviders.length\"\r\n        [tag]=\"pageTags.GUIDED_HELP_PROVIDER_SEARCH\"\r\n        [ariaLabel]=\"addLinkText + ' ' + guidedHelpProvidersText\"\r\n        [onClickAction]=\"onClick(pageTags.GUIDED_HELP_PROVIDER_SEARCH)\"\r\n      >\r\n        <div tag-image-body>{{ addLinkText }}<i class=\"fas fa-plus-circle ml-1\"></i></div>\r\n      </vnext-link>\r\n      <ul class=\"py-0 pr-0 pl-3 m-0\">\r\n        <ng-container *ngFor=\"let selectedProvider of selectedProviders; index as index\">\r\n          <ng-container *ngIf=\"index === 5\">\r\n            <div class=\"mb-1 view-hide-text\">\r\n              <vnext-link\r\n                [makeInlineBlock]=\"true\"\r\n                [keyNameForLiveEdit]=\"'Spa_Site_Hide_Text'\"\r\n                (click)=\"showAllSelectedProviders = !showAllSelectedProviders\"\r\n                (keyup.enter)=\"showAllSelectedProviders = !showAllSelectedProviders\"\r\n              >\r\n                <div class=\"pl-0\" link-body>\r\n                  {{ getLinkText(showAllSelectedProviders) }} <i class=\"{{ getIcon(showAllSelectedProviders) }}\"></i>\r\n                </div>\r\n              </vnext-link>\r\n            </div>\r\n          </ng-container>\r\n          <li *ngIf=\"(index < 5 || showAllSelectedProviders) && selectedProvider.displayName\" class=\"Spa_Style_Small_Font mb-2\">\r\n            <span class=\"no-translate-block\">{{ displayLabel(selectedProvider.displayName) | titlecase }}</span> <span *ngIf=\"selectedProvider.isPrimary\">({{ pcpText }})</span>\r\n          </li>\r\n        </ng-container>\r\n      </ul>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #prescription>\r\n  <div *ngIf=\"hasEnteredPreferences\" class=\"row flex-nowrap\">\r\n    <div class=\"col-1\">&nbsp;</div>\r\n    <div [ngClass]=\"medicineCabinet.length === 0 ? 'col-auto' : 'col-11'\">\r\n      <vnext-link\r\n        *ngIf=\"medicineCabinet.length === 0\"\r\n        [tag]=\"pageTags.GUIDED_HELP_PRESCRIPTIONS\"\r\n        [ariaLabel]=\"addLinkText + ' ' + guidedHelpPrescriptionsText\"\r\n        [onClickAction]=\"onClick(pageTags.GUIDED_HELP_PRESCRIPTIONS)\"\r\n      >\r\n        <div tag-image-body>{{ addLinkText }}<i class=\"fas fa-plus-circle ml-1\"></i></div>\r\n      </vnext-link>\r\n      <ul class=\"py-0 pr-0 pl-3 m-0\">\r\n        <ng-container *ngFor=\"let medicine of medicineCabinet | orderBy : 'labelName' : false : true; index as index\">\r\n          <div *ngIf=\"index === 5\" class=\"mb-1\">\r\n            <vnext-link\r\n              [makeInlineBlock]=\"true\"\r\n              [keyNameForLiveEdit]=\"'Spa_Site_Hide_Text'\"\r\n              (click)=\"showAllMedicineLabels = !showAllMedicineLabels\"\r\n              (keyup.enter)=\"showAllMedicineLabels = !showAllMedicineLabels\"\r\n            >\r\n              <div class=\"\" link-body>{{ getLinkText(showAllMedicineLabels) }} <i class=\"{{ getIcon(showAllMedicineLabels) }}\"></i></div>\r\n            </vnext-link>\r\n          </div>\r\n          <li *ngIf=\"index < 5 || showAllMedicineLabels\" class=\"Spa_Style_Small_Font mb-2 no-translate-block\">\r\n            {{ displayLabel(medicine.labelName) }}\r\n          </li>\r\n        </ng-container>\r\n      </ul>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #pharmacy>\r\n  <div *ngIf=\"hasEnteredPreferences\" class=\"row flex-nowrap\">\r\n    <div class=\"col-1\">&nbsp;</div>\r\n    <div [ngClass]=\"(!multiPharmacyEnabled && !selectedPharmacy) || (multiPharmacyEnabled && !selectedPharmacies.length) ? 'col-auto' : 'col-11'\">\r\n      <vnext-link\r\n        *ngIf=\"(!multiPharmacyEnabled && !selectedPharmacy) || (multiPharmacyEnabled && !selectedPharmacies.length)\"\r\n        [tag]=\"pageTags.GUIDED_HELP_PHARMACY_SEARCH\"\r\n        [ariaLabel]=\"addLinkText + ' ' + guidedHelpPharmacyText\"\r\n        [onClickAction]=\"onClick(pageTags.GUIDED_HELP_PHARMACY_SEARCH)\"\r\n      >\r\n        <div tag-image-body>{{ addLinkText }}<i class=\"fas fa-plus-circle ml-1\"></i></div>\r\n      </vnext-link>\r\n      <ul class=\"py-0 pr-0 pl-3 m-0\">\r\n        <ng-container *ngIf=\"multiPharmacyEnabled; else pharmacyDetail\">\r\n          <li *ngFor=\"let selectedPharmacy of selectedPharmacies\" class=\"Spa_Style_Small_Font mb-2\">\r\n            <span class=\"no-translate-block\">{{ displayLabel(selectedPharmacy.name) }}</span>\r\n            <span *ngIf=\"selectedPharmacy.pharmacyId === primaryPharmacy.pharmacyId\">({{ primaryPharmacyIndicatorText }})</span>\r\n          </li>\r\n        </ng-container>\r\n        <ng-template #pharmacyDetail>\r\n          <ng-container *ngIf=\"selectedPharmacy\">\r\n            <li class=\"Spa_Style_Small_Font mb-2\">\r\n              <span class=\"no-translate-block\">{{ displayLabel(selectedPharmacy.name) }}</span>\r\n            </li>\r\n          </ng-container>\r\n        </ng-template>\r\n      </ul>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #otherPreferences>\r\n  <div *ngIf=\"hasEnteredPreferences\" class=\"row flex-nowrap\">\r\n    <div class=\"col-1\">&nbsp;</div>\r\n    <div [ngClass]=\"!hasEnteredOtherPreferences() ? 'col-auto' : 'col-11'\">\r\n      <vnext-link\r\n        *ngIf=\"!hasEnteredOtherPreferences()\"\r\n        [tag]=\"pageTags.GUIDED_HELP_OTHER_PREFERENCES\"\r\n        [ariaLabel]=\"addLinkText + ' ' + guidedHelpOtherPreferencesText\"\r\n        [onClickAction]=\"logOtherPreferencesNavigation\"\r\n      >\r\n        <div tag-image-body>{{ addLinkText }}<i class=\"fas fa-plus-circle ml-1\"></i></div>\r\n      </vnext-link>\r\n      <div *ngIf=\"hasEnteredOtherPreferences()\" class=\"Spa_Style_Small_Font mb-2 pl-3\">\r\n        <ul class=\"p-0 m-0\">\r\n          <li *liveEditProp=\"guidedHelpOtherPreferencesMessageKey\">{{ guidedHelpOtherPreferencesMessageText }}</li>\r\n        </ul>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n", styles: [".fixed-icon-size{min-width:25px;max-width:25px}.view-hide-text{margin-left:-16px}\n"] }]
    }], function () { return [{ type: i1.GuidedHelpService }, { type: i0.ChangeDetectorRef }, { type: AnalyticsService }, { type: i1.LocaleService }, { type: i2.Store }, { type: i1.ProfileService }]; }, { guidedHelpPreferenceText: [{
            type: Input
        }], preferenceButtonText: [{
            type: Input
        }], guidedHelpHideLinkText: [{
            type: Input
        }], guidedHelpViewAllLinkText: [{
            type: Input
        }], guidedHelpGetStartedText: [{
            type: Input
        }], guidedHelpHealthText: [{
            type: Input
        }], guidedHelpPrescriptionsText: [{
            type: Input
        }], guidedHelpPharmacyText: [{
            type: Input
        }], guidedHelpOtherPreferencesText: [{
            type: Input
        }], guidedHelpOtherPreferencesMessageText: [{
            type: Input
        }], guidedHelpOtherPreferencesMessageKey: [{
            type: Input
        }], multiPharmacyEnabled: [{
            type: Input
        }], primaryPharmacyIndicatorText: [{
            type: Input
        }], guidedHelpProvidersText: [{
            type: Input
        }], pcpText: [{
            type: Input
        }], subsidyLabelText: [{
            type: Input
        }], medicaidEligibilityCheckEnabled: [{
            type: Input
        }], medicaidCodeText: [{
            type: Input
        }], onButtonClick: [] }); })();

function MapPinComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r3.alternateNumberIndicatorClass);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.index, " ");
} }
function MapPinComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "span", 3);
    i0.ɵɵelement(2, "i", 4);
    i0.ɵɵtemplate(3, MapPinComponent_div_0_div_3_Template, 2, 2, "div", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(ctx_r0.customClass);
    i0.ɵɵproperty("ngStyle", ctx_r0.backgroundStyle)("ngClass", ctx_r0.alternateViewClass);
    i0.ɵɵattribute("aria-label", ctx_r0.isPrimary ? ctx_r0.primaryIconAriaLabelText : "Location pin " + (ctx_r0.index || ""));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isPrimary);
} }
function MapPinComponent_ng_template_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r4.alternateNumberIndicatorClass);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.index, " ");
} }
function MapPinComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "i", 4);
    i0.ɵɵtemplate(2, MapPinComponent_ng_template_1_span_2_Template, 2, 2, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r2.customClass);
    i0.ɵɵproperty("ngStyle", ctx_r2.backgroundStyle)("ngClass", ctx_r2.alternateViewClass);
    i0.ɵɵattribute("aria-label", ctx_r2.isPrimary ? ctx_r2.primaryIconAriaLabelText : "Location pin " + (ctx_r2.index || ""));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isPrimary);
} }
class MapPinComponent {
}
MapPinComponent.ɵfac = function MapPinComponent_Factory(t) { return new (t || MapPinComponent)(); };
MapPinComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MapPinComponent, selectors: [["vnext-widget-map-pin"]], inputs: { index: "index", customClass: "customClass", backgroundStyle: "backgroundStyle", alternateViewClass: "alternateViewClass", alternateNumberIndicatorClass: "alternateNumberIndicatorClass", isMap: "isMap", isPrimary: "isPrimary", primaryIconAriaLabelText: "primaryIconAriaLabelText" }, decls: 3, vars: 2, consts: [["class", "float-left", 4, "ngIf", "ngIfElse"], ["showMapIconAndDetails", ""], [1, "float-left"], [1, "fa-stack"], ["role", "img", 3, "ngStyle", "ngClass"], ["class", "fa-stack-1x pin-number", 3, "ngClass", 4, "ngIf"], [1, "fa-stack-1x", "pin-number", 3, "ngClass"], ["role", "button", "aria-haspopup", "true", 1, "marker-container"], ["class", "map-pin-index", 3, "ngClass", 4, "ngIf"], [1, "map-pin-index", 3, "ngClass"]], template: function MapPinComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MapPinComponent_div_0_Template, 4, 7, "div", 0);
        i0.ɵɵtemplate(1, MapPinComponent_ng_template_1_Template, 3, 7, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", !ctx.isMap)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$2.NgStyle], styles: [".primary-icon-size[_ngcontent-%COMP%]{font-size:20px!important}.indicator[_ngcontent-%COMP%]{font-family:montserrat_bold;font-weight:700;font-size:14px;color:#fff}i[_ngcontent-%COMP%]{font-size:28px}.pin-number[_ngcontent-%COMP%]{line-height:1.6}.map-pin-index[_ngcontent-%COMP%]{position:absolute;left:0;top:11%;width:100%}.marker-container[_ngcontent-%COMP%]{position:relative;text-align:center}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MapPinComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-map-pin', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"float-left\" *ngIf=\"!isMap; else showMapIconAndDetails\">\r\n  <span class=\"fa-stack\">\r\n    <i\r\n      class=\"{{ customClass }}\"\r\n      role=\"img\"\r\n      [attr.aria-label]=\"isPrimary ? primaryIconAriaLabelText : 'Location pin ' + (index || '')\"\r\n      [ngStyle]=\"backgroundStyle\"\r\n      [ngClass]=\"alternateViewClass\"\r\n    ></i>\r\n    <div *ngIf=\"!isPrimary\" class=\"fa-stack-1x pin-number\" [ngClass]=\"alternateNumberIndicatorClass\">\r\n      {{ index }}\r\n    </div>\r\n  </span>\r\n</div>\r\n<ng-template #showMapIconAndDetails>\r\n  <div class=\"marker-container\" role=\"button\" aria-haspopup=\"true\">\r\n    <i\r\n      class=\"{{ customClass }}\"\r\n      role=\"img\"\r\n      [attr.aria-label]=\"isPrimary ? primaryIconAriaLabelText : 'Location pin ' + (index || '')\"\r\n      [ngStyle]=\"backgroundStyle\"\r\n      [ngClass]=\"alternateViewClass\"\r\n    ></i>\r\n    <span class=\"map-pin-index\" *ngIf=\"!isPrimary\" [ngClass]=\"alternateNumberIndicatorClass\">\r\n      {{ index }}\r\n    </span>\r\n  </div>\r\n</ng-template>\r\n", styles: [".primary-icon-size{font-size:20px!important}.indicator{font-family:montserrat_bold;font-weight:700;font-size:14px;color:#fff}i{font-size:28px}.pin-number{line-height:1.6}.map-pin-index{position:absolute;left:0;top:11%;width:100%}.marker-container{position:relative;text-align:center}\n"] }]
    }], null, { index: [{
            type: Input
        }], customClass: [{
            type: Input
        }], backgroundStyle: [{
            type: Input
        }], alternateViewClass: [{
            type: Input
        }], alternateNumberIndicatorClass: [{
            type: Input
        }], isMap: [{
            type: Input
        }], isPrimary: [{
            type: Input
        }], primaryIconAriaLabelText: [{
            type: Input
        }] }); })();

const _c0$1_ = ["providerButton"];
const _c1$W = ["selectedProviderButton"];
const _c2$C = ["addressListPopover"];
const _c3$p = ["providerLocationButton"];
function ProviderListComponent_vnext_widget_provider_phone_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-provider-phone", 13);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("phoneNumber", ctx_r0.provider.phoneNumber)("countryCode", ctx_r0.countryCode)("showPhoneIcon", ctx_r0.isHelpfulToolsView);
} }
function ProviderListComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 14)(2, "button", 15, 16);
    i0.ɵɵlistener("keydown.enter", function ProviderListComponent_ng_container_10_Template_button_keydown_enter_2_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.togglePopover($event)); })("shown", function ProviderListComponent_ng_container_10_Template_button_shown_2_listener() { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.focusPopoverClose()); });
    i0.ɵɵelementStart(5, "span", 17);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "i", 18);
    i0.ɵɵelementStart(8, "span", 19);
    i0.ɵɵtext(9, "Expand");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r11 = i0.ɵɵreference(4);
    const ctx_r1 = i0.ɵɵnextContext();
    const _r8 = i0.ɵɵreference(18);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("placement", ctx_r1.providerListPopoverPlacement)("ngbPopover", _r8)("autoClose", "outside")("popoverClass", ctx_r1.providerListPopoverClass);
    i0.ɵɵattribute("aria-expanded", _r11.isOpen())("aria-label", ctx_r1.providerLocationsText);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2("", ctx_r1.providerGroup.length, " ", ctx_r1.providerLocationsText, "");
} }
function ProviderListComponent_ng_template_11_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "titlecase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r15.provider.address2));
} }
function ProviderListComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ProviderListComponent_ng_template_11_div_4_Template, 3, 3, "div", 9);
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "titlecase");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 5, ctx_r3.provider.address1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.provider.address2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3("", i0.ɵɵpipeBind1(7, 7, ctx_r3.provider.city), ", ", ctx_r3.provider.state, " ", ctx_r3.provider.zip, "");
} }
function ProviderListComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-widget-provider-accepting-new-patients", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("acceptingNewPatientsIcon", ctx_r4.acceptingNewPatientsIcon)("acceptingNewPatientsText", ctx_r4.acceptingNewPatientsText);
} }
function ProviderListComponent_ng_container_14_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelement(1, "vnext-widget-provider-inline-element", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("values", ctx_r16.provider.languages)("icon", ctx_r16.languagesIcon);
} }
function ProviderListComponent_ng_container_14_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelement(1, "vnext-widget-provider-inline-element", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("values", ctx_r17.provider.groups)("icon", "fas fa-building");
} }
function ProviderListComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProviderListComponent_ng_container_14_div_1_Template, 2, 2, "div", 22);
    i0.ɵɵtemplate(2, ProviderListComponent_ng_container_14_div_2_Template, 2, 2, "div", 23);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.isZelisIntegrationDisabledOrSingleZelisProviderEntry && (ctx_r5.provider.languages == null ? null : ctx_r5.provider.languages.length));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.provider.groups == null ? null : ctx_r5.provider.groups.length);
} }
function ProviderListComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelement(1, "i");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("", ctx_r6.valueBasedCareIcon, " Spa_Style_Accent1_Color");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r6.valueBasedCareText, " ", (ctx_r6.provider == null ? null : ctx_r6.provider.valueBasedCare == null ? null : ctx_r6.provider.valueBasedCare.vbcOrgName) ? "(" + ctx_r6.provider.valueBasedCare.vbcOrgName + ")" : "", " ");
} }
function ProviderListComponent_div_16_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 30);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 31);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "titlecase");
    i0.ɵɵpipe(6, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-describedby", "Spa_Style_HeaderTextLevel_" + ctx_r18.index + " addedProviderText");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r18.providerAddedText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(5, 4, ctx_r18.provider.displayName), " ", i0.ɵɵpipeBind1(6, 6, ctx_r18.provider.address1), " ");
} }
function ProviderListComponent_div_16_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ProviderListComponent_div_16_ng_template_2_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 37, 38);
    i0.ɵɵlistener("click", function ProviderListComponent_div_16_ng_template_2_ng_template_1_ng_container_0_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r33); const ctx_r32 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r32.confirm(ctx_r32.provider)); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-describedby", "Spa_Style_HeaderTextLevel_" + ctx_r30.index + " addProviderText");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r30.addProviderText, " ");
} }
function ProviderListComponent_div_16_ng_template_2_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ProviderListComponent_div_16_ng_template_2_ng_template_1_ng_container_0_Template, 4, 2, "ng-container", 7);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r28 = i0.ɵɵreference(8);
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", (ctx_r23.selectedProviders == null ? null : ctx_r23.selectedProviders.length) < ctx_r23.maxCount)("ngIfElse", _r28);
} }
function ProviderListComponent_div_16_ng_template_2_ng_template_3_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 37, 38);
    i0.ɵɵlistener("click", function ProviderListComponent_div_16_ng_template_2_ng_template_3_ng_container_0_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r36.confirm(ctx_r36.provider)); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-describedby", "Spa_Style_HeaderTextLevel_" + ctx_r34.index + " addProviderText");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r34.addProviderText, " ");
} }
function ProviderListComponent_div_16_ng_template_2_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ProviderListComponent_div_16_ng_template_2_ng_template_3_ng_container_0_Template, 4, 2, "ng-container", 7);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r26 = i0.ɵɵreference(6);
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", (ctx_r25.selectedProviders == null ? null : ctx_r25.selectedProviders.length) < ctx_r25.maxCount && (!ctx_r25.alreadySelectedProvider || !ctx_r25.providerSingleSelectEnabled))("ngIfElse", _r26);
} }
function ProviderListComponent_div_16_ng_template_2_ng_template_5_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 39, 40);
    i0.ɵɵlistener("mouseleave", function ProviderListComponent_div_16_ng_template_2_ng_template_5_ng_container_0_Template_button_mouseleave_1_listener() { i0.ɵɵrestoreView(_r41); const _r39 = i0.ɵɵreference(2); return i0.ɵɵresetView(_r39.close()); })("click", function ProviderListComponent_div_16_ng_template_2_ng_template_5_ng_container_0_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r41); const _r39 = i0.ɵɵreference(2); return i0.ɵɵresetView(_r39.open()); });
    i0.ɵɵtext(3);
    i0.ɵɵelementStart(4, "span", 19);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngbTooltip", ctx_r38.providerExistsTooltipText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r38.addProviderText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r38.providerExistsTooltipText);
} }
function ProviderListComponent_div_16_ng_template_2_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ProviderListComponent_div_16_ng_template_2_ng_template_5_ng_container_0_Template, 6, 3, "ng-container", 7);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r28 = i0.ɵɵreference(8);
    const ctx_r27 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", (ctx_r27.selectedProviders == null ? null : ctx_r27.selectedProviders.length) < ctx_r27.maxCount && ctx_r27.alreadySelectedProvider)("ngIfElse", _r28);
} }
function ProviderListComponent_div_16_ng_template_2_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 39, 41);
    i0.ɵɵlistener("mouseleave", function ProviderListComponent_div_16_ng_template_2_ng_template_7_Template_button_mouseleave_0_listener() { i0.ɵɵrestoreView(_r45); const _r43 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r43.close()); })("click", function ProviderListComponent_div_16_ng_template_2_ng_template_7_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r45); const _r43 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r43.open()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "span", 19);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngbTooltip", ctx_r29.maxCountErrorMessage);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r29.addProviderText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r29.maxCountErrorMessage);
} }
function ProviderListComponent_div_16_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ProviderListComponent_div_16_ng_template_2_ng_container_0_Template, 1, 0, "ng-container", 32);
    i0.ɵɵtemplate(1, ProviderListComponent_div_16_ng_template_2_ng_template_1_Template, 1, 2, "ng-template", null, 33, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(3, ProviderListComponent_div_16_ng_template_2_ng_template_3_Template, 1, 2, "ng-template", null, 34, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(5, ProviderListComponent_div_16_ng_template_2_ng_template_5_Template, 1, 2, "ng-template", null, 35, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(7, ProviderListComponent_div_16_ng_template_2_ng_template_7_Template, 5, 3, "ng-template", null, 36, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(9, "span", 31);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "titlecase");
    i0.ɵɵpipe(12, "titlecase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r22 = i0.ɵɵreference(2);
    const _r24 = i0.ɵɵreference(4);
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r20.singleProviderInListEnabled)("ngIfThen", _r22)("ngIfElse", _r24);
    i0.ɵɵadvance(10);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(11, 5, ctx_r20.provider.displayName), " ", i0.ɵɵpipeBind1(12, 7, ctx_r20.provider.address1), " ");
} }
function ProviderListComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtemplate(1, ProviderListComponent_div_16_ng_container_1_Template, 7, 8, "ng-container", 7);
    i0.ɵɵtemplate(2, ProviderListComponent_div_16_ng_template_2_Template, 13, 9, "ng-template", null, 29, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r19 = i0.ɵɵreference(3);
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.isProviderAdded)("ngIfElse", _r19);
} }
function ProviderListComponent_ng_template_17_div_5_vnext_widget_provider_phone_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-provider-phone", 13);
} if (rf & 2) {
    const group_r48 = i0.ɵɵnextContext().$implicit;
    const ctx_r49 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("phoneNumber", group_r48.phoneNumber)("countryCode", ctx_r49.countryCode)("showPhoneIcon", ctx_r49.isHelpfulToolsView);
} }
function ProviderListComponent_ng_template_17_div_5_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "titlecase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const group_r48 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, group_r48.address2));
} }
function ProviderListComponent_ng_template_17_div_5_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelement(1, "vnext-widget-provider-inline-element", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const group_r48 = i0.ɵɵnextContext().$implicit;
    const ctx_r51 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("values", group_r48.languages)("icon", ctx_r51.languagesIcon);
} }
function ProviderListComponent_ng_template_17_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵtemplate(1, ProviderListComponent_ng_template_17_div_5_vnext_widget_provider_phone_1_Template, 1, 3, "vnext-widget-provider-phone", 6);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ProviderListComponent_ng_template_17_div_5_div_5_Template, 3, 3, "div", 9);
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ProviderListComponent_ng_template_17_div_5_div_9_Template, 2, 2, "div", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const group_r48 = ctx.$implicit;
    const ctx_r47 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r47.isZelisIntegrationEnabled && group_r48.phoneNumber);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 7, group_r48.address1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r47.provider.address2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3("", i0.ɵɵpipeBind1(8, 9, group_r48.city), ", ", group_r48.state, " ", group_r48.zip, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r47.isZelisIntegrationEnabled && ctx_r47.isHelpfulToolsView && (group_r48.languages == null ? null : group_r48.languages.length));
} }
function ProviderListComponent_ng_template_17_Template(rf, ctx) { if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 42)(1, "button", 43);
    i0.ɵɵlistener("click", function ProviderListComponent_ng_template_17_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r56); const ctx_r55 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r55.closePopover()); })("keyup.enter", function ProviderListComponent_ng_template_17_Template_button_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r56); const ctx_r57 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r57.closePopover()); });
    i0.ɵɵelement(2, "i", 44);
    i0.ɵɵelementStart(3, "span", 19);
    i0.ɵɵtext(4, "Close");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, ProviderListComponent_ng_template_17_div_5_Template, 10, 11, "div", 45);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r9.providerGroup)("ngForTrackBy", ctx_r9.trackByProviderId);
} }
class ProviderListComponent {
    constructor(providerFacade, cdr) {
        this.providerFacade = providerFacade;
        this.cdr = cdr;
        this.addProvider = new EventEmitter();
        this.defaultProviderListPopoverClass = 'address-list-popover';
        this.defaultProviderListPopoverPlacement = 'bottom';
        this.subscriptions = new Subscription();
        this.providerListPopoverClass = this.defaultProviderListPopoverClass;
        this.providerListPopoverPlacement = this.defaultProviderListPopoverPlacement;
    }
    get pinIconIndex() {
        return this.pageIndex * this.pageSize - this.pageSize + 1;
    }
    ngOnChanges(changes) {
        const { isHelpfulToolsView, provider, isZelisIntegrationEnabled, providerGroup } = changes;
        if (provider && !_isEqual(provider.previousValue, provider.currentValue)) {
            this.vbcWhitelisted = this.providerFacade.isWhitelistedVBC(this.provider?.valueBasedCare?.vbcid);
        }
        if ((isZelisIntegrationEnabled && isZelisIntegrationEnabled.previousValue !== isZelisIntegrationEnabled.currentValue) ||
            (providerGroup && !_isEqual(providerGroup.previousValue, providerGroup.currentValue))) {
            this.isZelisIntegrationDisabledOrSingleZelisProviderEntry =
                !this.isZelisIntegrationEnabled || !this.providerGroup || this.providerGroup.length <= 1;
        }
        if (isHelpfulToolsView && isHelpfulToolsView.previousValue !== isHelpfulToolsView.currentValue) {
            if (this.isHelpfulToolsView) {
                this.providerListPopoverClass = `helpful-tools ${this.defaultProviderListPopoverClass}`;
                this.providerListPopoverPlacement = 'bottom-left';
            }
            else {
                this.providerListPopoverClass = this.defaultProviderListPopoverClass;
                this.providerListPopoverPlacement = this.defaultProviderListPopoverPlacement;
            }
        }
    }
    ngAfterViewInit() {
        if (this.index === 0 && this.providerButton?.nativeElement) {
            this.providerButton.nativeElement.focus();
        }
        if (this.index === 0 && this.selectedProviderButton?.nativeElement) {
            this.selectedProviderButton.nativeElement.focus();
        }
        const popoverHidden$ = this.popover?.hidden;
        if (popoverHidden$) {
            this.subscriptions.add(popoverHidden$.subscribe({
                next: () => {
                    this.providerLocationButton.nativeElement.focus();
                    this.cdr.markForCheck();
                }
            }));
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    updateFocus(isFocus) {
        this.isFocusEnabled = isFocus;
    }
    closePopover() {
        if (this.popover && this.popover.isOpen()) {
            this.popover.close();
        }
    }
    togglePopover(event) {
        event?.preventDefault();
        if (this.popover) {
            this.popover.toggle();
        }
    }
    focusPopoverClose() {
        const popoverCloseButton = document.querySelector('.provider-address-list-popover-close');
        if (popoverCloseButton) {
            popoverCloseButton.focus();
        }
    }
    confirm(provider) {
        const sameProvider = this.selectedProviders.find(selectedProvider => selectedProvider.id === provider.id);
        this.addProvider.emit({
            id: provider.id,
            addressId: provider.addressId,
            addedProviders: [
                {
                    ...provider,
                    ...(sameProvider?.addresses?.length > 1 && { addresses: sameProvider?.addresses })
                }
            ]
        });
    }
    trackByProviderId(index, provider) {
        return provider.id;
    }
    onScroll($event) {
        this.closePopover();
    }
}
ProviderListComponent.ɵfac = function ProviderListComponent_Factory(t) { return new (t || ProviderListComponent)(i0.ɵɵdirectiveInject(ProviderFacade), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
ProviderListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProviderListComponent, selectors: [["vnext-widget-provider-list"]], viewQuery: function ProviderListComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1_, 5);
        i0.ɵɵviewQuery(_c1$W, 5);
        i0.ɵɵviewQuery(_c2$C, 5);
        i0.ɵɵviewQuery(_c3$p, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.providerButton = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.selectedProviderButton = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popover = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.providerLocationButton = _t.first);
    } }, hostBindings: function ProviderListComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("scroll", function ProviderListComponent_scroll_HostBindingHandler($event) { return ctx.onScroll($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { isHelpfulToolsView: "isHelpfulToolsView", provider: "provider", pageSize: "pageSize", pageIndex: "pageIndex", selectedProviders: "selectedProviders", providerGroup: "providerGroup", addProviderText: "addProviderText", providerAddedText: "providerAddedText", maxCountErrorMessage: "maxCountErrorMessage", maxCount: "maxCount", index: "index", customClass: "customClass", alternateViewClass: "alternateViewClass", alternateNumberIndicatorClass: "alternateNumberIndicatorClass", isProviderAdded: "isProviderAdded", backgroundStyle: "backgroundStyle", isPrimary: "isPrimary", alreadySelectedProvider: "alreadySelectedProvider", providerExistsTooltipText: "providerExistsTooltipText", countryCode: "countryCode", acceptingNewPatientsText: "acceptingNewPatientsText", acceptingNewPatientsIcon: "acceptingNewPatientsIcon", languagesIcon: "languagesIcon", providerSingleSelectEnabled: "providerSingleSelectEnabled", providerLocationsText: "providerLocationsText", valueBasedCareEnabled: "valueBasedCareEnabled", valueBasedCareIcon: "valueBasedCareIcon", valueBasedCareText: "valueBasedCareText", singleProviderInListEnabled: "singleProviderInListEnabled", primaryCareProviderText: "primaryCareProviderText", isZelisIntegrationEnabled: "isZelisIntegrationEnabled" }, outputs: { addProvider: "addProvider" }, features: [i0.ɵɵNgOnChangesFeature], decls: 19, vars: 19, consts: [[1, "d-flex", "flex-row"], [3, "index", "isPrimary", "customClass", "backgroundStyle", "alternateViewClass", "alternateNumberIndicatorClass", "primaryIconAriaLabelText"], [1, "d-flex", "flex-column", "w-100", "provider-address"], [1, "Spa_Style_HeaderTextLevel", "float-left", "w-100", "no-translate-block", 3, "id"], [1, "Spa_Style_Paragraph", "float-left", "no-translate-block"], [1, "Spa_Style_Note"], [3, "phoneNumber", "countryCode", "showPhoneIcon", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["showAddress", ""], [4, "ngIf"], ["class", "Spa_Style_Gray4_Color Spa_Style_Smaller_Font", 4, "ngIf"], ["aria-live", "off", 4, "ngIf"], ["popOverTemplate", ""], [3, "phoneNumber", "countryCode", "showPhoneIcon"], [1, "mb-2"], ["container", "body", "type", "button", "tabindex", "0", 1, "action-button", "Spa_Style_Link", 3, "placement", "ngbPopover", "autoClose", "popoverClass", "keydown.enter", "shown"], ["providerLocationButton", "", "addressListPopover", "ngbPopover"], [1, "Spa_Style_Smaller_Font", "underline", "text-nowrap"], [1, "fa", "fa-angle-down", "pl-1"], [1, "sr-only"], [1, "no-translate-block"], [3, "acceptingNewPatientsIcon", "acceptingNewPatientsText"], ["class", "Spa_Style_Note mb-1", 4, "ngIf"], ["class", "Spa_Style_Note mb-2", 4, "ngIf"], [1, "Spa_Style_Note", "mb-1"], [3, "values", "icon"], [1, "Spa_Style_Note", "mb-2"], [1, "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font"], ["aria-live", "off"], ["showAddProvider", ""], ["tabindex", "0", 1, "btn", "mt-2", "w-100", "Spa_Style_SecondaryButtonSelected", "Spa_Style_Bold_Weight"], [1, "sr-only", "no-translate-block"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["showAddProviderNoCondition", ""], ["showAddProviderByCondition", ""], ["showSelectedProviderMessage", ""], ["showProviderLimitMessage", ""], ["role", "button", 1, "btn", "mt-2", "w-100", "Spa_Style_SecondaryButton", "Spa_Style_Regular_Weight", "provider-border-color", 3, "click"], ["providerButton", ""], ["triggers", "manual", "placement", "top", "container", "body", "autoClose", "true", 1, "btn", "mt-2", "w-100", "Spa_Style_SecondaryButton", "Spa_Style_Regular_Weight", "provider-border-color", 3, "ngbTooltip", "mouseleave", "click"], ["providerSelectedTooltip", "ngbTooltip"], ["providerLimitTooltip", "ngbTooltip"], [1, "my-3", "mr-3", "ml-1"], ["role", "button", "tabindex", "0", 1, "popover-cancel", "m-2", "action-button", "provider-address-list-popover-close", 3, "click", "keyup.enter"], [1, "fas", "fa-times"], ["class", "mb-3 mt-1 no-translate-block", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "mb-3", "mt-1", "no-translate-block"]], template: function ProviderListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "vnext-widget-map-pin", 1);
        i0.ɵɵelementStart(2, "div", 2)(3, "h2", 3);
        i0.ɵɵtext(4);
        i0.ɵɵpipe(5, "titlecase");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4)(7, "i", 5);
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, ProviderListComponent_vnext_widget_provider_phone_9_Template, 1, 3, "vnext-widget-provider-phone", 6);
        i0.ɵɵtemplate(10, ProviderListComponent_ng_container_10_Template, 10, 8, "ng-container", 7);
        i0.ɵɵtemplate(11, ProviderListComponent_ng_template_11_Template, 8, 9, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(13, ProviderListComponent_div_13_Template, 2, 2, "div", 9);
        i0.ɵɵtemplate(14, ProviderListComponent_ng_container_14_Template, 3, 2, "ng-container", 9);
        i0.ɵɵtemplate(15, ProviderListComponent_div_15_Template, 3, 5, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(16, ProviderListComponent_div_16_Template, 4, 2, "div", 11);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(17, ProviderListComponent_ng_template_17_Template, 6, 2, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(12);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("index", ctx.index + ctx.pinIconIndex)("isPrimary", ctx.isPrimary)("customClass", ctx.customClass)("backgroundStyle", ctx.backgroundStyle)("alternateViewClass", ctx.alternateViewClass)("alternateNumberIndicatorClass", ctx.alternateNumberIndicatorClass)("primaryIconAriaLabelText", ctx.primaryCareProviderText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("id", "Spa_Style_HeaderTextLevel_" + ctx.index);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 17, ctx.provider.displayName), " ");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.provider.specialtyDisplayName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isZelisIntegrationDisabledOrSingleZelisProviderEntry && ctx.provider.phoneNumber);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.providerGroup == null ? null : ctx.providerGroup.length) > 1)("ngIfElse", _r2);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.provider.acceptingNewPatients);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isHelpfulToolsView);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.valueBasedCareEnabled && (ctx.provider == null ? null : ctx.provider.valueBasedCare == null ? null : ctx.provider.valueBasedCare.vbcid) && ctx.vbcWhitelisted);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isHelpfulToolsView);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, ProviderAcceptingNewPatientsComponent, ProviderInlineElementComponent, ProviderPhoneComponent, IconAriaAttributesDirective, i1$1.NgbPopover, i1$1.NgbTooltip, MapPinComponent, i1$2.TitleCasePipe], styles: [".provider-address[_ngcontent-%COMP%]{padding:0 24px 0 10px}.provider-pin-number[_ngcontent-%COMP%]{line-height:1.6}.provider-map-pin[_ngcontent-%COMP%]{font-size:28px}.provider-indicator[_ngcontent-%COMP%]{font-family:montserrat_bold;font-weight:700;font-size:14px;color:#fff}.underline[_ngcontent-%COMP%]{text-decoration:underline}.popover-cancel[_ngcontent-%COMP%]{position:absolute;top:0;right:0;cursor:pointer;color:var(--Spa_Style_Primary);width:20px;height:20px;text-align:center}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProviderListComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-provider-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"d-flex flex-row\">\r\n  <vnext-widget-map-pin\r\n    [index]=\"index + pinIconIndex\"\r\n    [isPrimary]=\"isPrimary\"\r\n    [customClass]=\"customClass\"\r\n    [backgroundStyle]=\"backgroundStyle\"\r\n    [alternateViewClass]=\"alternateViewClass\"\r\n    [alternateNumberIndicatorClass]=\"alternateNumberIndicatorClass\"\r\n    [primaryIconAriaLabelText]=\"primaryCareProviderText\"\r\n  ></vnext-widget-map-pin>\r\n  <div class=\"d-flex flex-column w-100 provider-address\">\r\n    <h2 [id]=\"'Spa_Style_HeaderTextLevel_' + index\" class=\"Spa_Style_HeaderTextLevel float-left w-100 no-translate-block\">\r\n      {{ provider.displayName | titlecase }}\r\n    </h2>\r\n\r\n    <div class=\"Spa_Style_Paragraph float-left no-translate-block\">\r\n      <i class=\"Spa_Style_Note\">{{ provider.specialtyDisplayName }}</i>\r\n      <vnext-widget-provider-phone\r\n        *ngIf=\"isZelisIntegrationDisabledOrSingleZelisProviderEntry && provider.phoneNumber\"\r\n        [phoneNumber]=\"provider.phoneNumber\"\r\n        [countryCode]=\"countryCode\"\r\n        [showPhoneIcon]=\"isHelpfulToolsView\"\r\n      ></vnext-widget-provider-phone>\r\n      <ng-container *ngIf=\"providerGroup?.length > 1; else showAddress\">\r\n        <div class=\"mb-2\">\r\n          <button\r\n            #providerLocationButton\r\n            [placement]=\"providerListPopoverPlacement\"\r\n            [ngbPopover]=\"popOverTemplate\"\r\n            [autoClose]=\"'outside'\"\r\n            #addressListPopover=\"ngbPopover\"\r\n            [popoverClass]=\"providerListPopoverClass\"\r\n            container=\"body\"\r\n            (keydown.enter)=\"togglePopover($event)\"\r\n            [attr.aria-expanded]=\"addressListPopover.isOpen()\"\r\n            [attr.aria-label]=\"providerLocationsText\"\r\n            type=\"button\"\r\n            tabindex=\"0\"\r\n            class=\"action-button Spa_Style_Link\"\r\n            (shown)=\"focusPopoverClose()\"\r\n          >\r\n            <span class=\"Spa_Style_Smaller_Font underline text-nowrap\">{{ providerGroup.length }} {{ providerLocationsText }}</span>\r\n            <i class=\"fa fa-angle-down pl-1\"></i>\r\n            <span class=\"sr-only\">Expand</span>\r\n          </button>\r\n        </div>\r\n      </ng-container>\r\n      <ng-template #showAddress>\r\n        <div class=\"no-translate-block\">\r\n          <div>{{ provider.address1 | titlecase }}</div>\r\n          <div *ngIf=\"provider.address2\">{{ provider.address2 | titlecase }}</div>\r\n          <div>{{ provider.city | titlecase }}, {{ provider.state }} {{ provider.zip }}</div>\r\n        </div>\r\n      </ng-template>\r\n\r\n      <div *ngIf=\"provider.acceptingNewPatients\">\r\n        <vnext-widget-provider-accepting-new-patients\r\n          [acceptingNewPatientsIcon]=\"acceptingNewPatientsIcon\"\r\n          [acceptingNewPatientsText]=\"acceptingNewPatientsText\"\r\n        ></vnext-widget-provider-accepting-new-patients>\r\n      </div>\r\n      <ng-container *ngIf=\"isHelpfulToolsView\">\r\n        <div class=\"Spa_Style_Note mb-1\" *ngIf=\"isZelisIntegrationDisabledOrSingleZelisProviderEntry && provider.languages?.length\">\r\n          <vnext-widget-provider-inline-element [values]=\"provider.languages\" [icon]=\"languagesIcon\">\r\n          </vnext-widget-provider-inline-element>\r\n        </div>\r\n        <div class=\"Spa_Style_Note mb-2\" *ngIf=\"provider.groups?.length\">\r\n          <vnext-widget-provider-inline-element [values]=\"provider.groups\" [icon]=\"'fas fa-building'\">\r\n          </vnext-widget-provider-inline-element>\r\n        </div>\r\n      </ng-container>\r\n      <div\r\n        *ngIf=\"valueBasedCareEnabled && provider?.valueBasedCare?.vbcid && vbcWhitelisted\"\r\n        class=\"Spa_Style_Gray4_Color Spa_Style_Smaller_Font\"\r\n      >\r\n        <i class=\"{{ valueBasedCareIcon }} Spa_Style_Accent1_Color\"></i>\r\n        {{ valueBasedCareText }} {{ provider?.valueBasedCare?.vbcOrgName ? '(' + provider.valueBasedCare.vbcOrgName + ')' : '' }}\r\n      </div>\r\n    </div>\r\n    <div aria-live=\"off\" *ngIf=\"!isHelpfulToolsView\">\r\n      <ng-container *ngIf=\"isProviderAdded; else showAddProvider\">\r\n        <div\r\n          class=\"btn mt-2 w-100 Spa_Style_SecondaryButtonSelected Spa_Style_Bold_Weight\"\r\n          [attr.aria-describedby]=\"'Spa_Style_HeaderTextLevel_' + index + ' addedProviderText'\"\r\n          tabindex=\"0\"\r\n        >\r\n          {{ providerAddedText }}\r\n        </div>\r\n        <span class=\"sr-only no-translate-block\">{{ provider.displayName | titlecase }} {{ provider.address1 | titlecase }} </span>\r\n      </ng-container>\r\n\r\n      <ng-template #showAddProvider>\r\n        <ng-container *ngIf=\"singleProviderInListEnabled; then showAddProviderNoCondition; else showAddProviderByCondition\"> </ng-container>\r\n\r\n        <ng-template #showAddProviderNoCondition>\r\n          <ng-container *ngIf=\"selectedProviders?.length < maxCount; else showProviderLimitMessage\">\r\n            <button\r\n              #providerButton\r\n              class=\"btn mt-2 w-100 Spa_Style_SecondaryButton Spa_Style_Regular_Weight provider-border-color\"\r\n              (click)=\"confirm(provider)\"\r\n              role=\"button\"\r\n              [attr.aria-describedby]=\"'Spa_Style_HeaderTextLevel_' + index + ' addProviderText'\"\r\n            >\r\n              {{ addProviderText }}\r\n            </button>\r\n          </ng-container>\r\n        </ng-template>\r\n\r\n        <ng-template #showAddProviderByCondition>\r\n          <ng-container\r\n            *ngIf=\"\r\n              selectedProviders?.length < maxCount && (!alreadySelectedProvider || !providerSingleSelectEnabled);\r\n              else showSelectedProviderMessage\r\n            \"\r\n          >\r\n            <button\r\n              #providerButton\r\n              class=\"btn mt-2 w-100 Spa_Style_SecondaryButton Spa_Style_Regular_Weight provider-border-color\"\r\n              (click)=\"confirm(provider)\"\r\n              role=\"button\"\r\n              [attr.aria-describedby]=\"'Spa_Style_HeaderTextLevel_' + index + ' addProviderText'\"\r\n            >\r\n              {{ addProviderText }}\r\n            </button>\r\n          </ng-container>\r\n        </ng-template>\r\n\r\n        <ng-template #showSelectedProviderMessage>\r\n          <ng-container *ngIf=\"selectedProviders?.length < maxCount && alreadySelectedProvider; else showProviderLimitMessage\">\r\n            <button\r\n              class=\"btn mt-2 w-100 Spa_Style_SecondaryButton Spa_Style_Regular_Weight provider-border-color\"\r\n              [ngbTooltip]=\"providerExistsTooltipText\"\r\n              triggers=\"manual\"\r\n              placement=\"top\"\r\n              container=\"body\"\r\n              autoClose=\"true\"\r\n              #providerSelectedTooltip=\"ngbTooltip\"\r\n              (mouseleave)=\"providerSelectedTooltip.close()\"\r\n              (click)=\"providerSelectedTooltip.open()\"\r\n            >\r\n              {{ addProviderText }} <span class=\"sr-only\">{{ providerExistsTooltipText }}</span>\r\n            </button>\r\n          </ng-container>\r\n        </ng-template>\r\n\r\n        <ng-template #showProviderLimitMessage>\r\n          <button\r\n            class=\"btn mt-2 w-100 Spa_Style_SecondaryButton Spa_Style_Regular_Weight provider-border-color\"\r\n            [ngbTooltip]=\"maxCountErrorMessage\"\r\n            triggers=\"manual\"\r\n            placement=\"top\"\r\n            container=\"body\"\r\n            autoClose=\"true\"\r\n            #providerLimitTooltip=\"ngbTooltip\"\r\n            (mouseleave)=\"providerLimitTooltip.close()\"\r\n            (click)=\"providerLimitTooltip.open()\"\r\n          >\r\n            {{ addProviderText }} <span class=\"sr-only\">{{ maxCountErrorMessage }}</span>\r\n          </button>\r\n        </ng-template>\r\n        <span class=\"sr-only no-translate-block\">{{ provider.displayName | titlecase }} {{ provider.address1 | titlecase }} </span>\r\n      </ng-template>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<ng-template #popOverTemplate>\r\n  <div class=\"my-3 mr-3 ml-1\">\r\n    <button\r\n      role=\"button\"\r\n      tabindex=\"0\"\r\n      (click)=\"closePopover()\"\r\n      (keyup.enter)=\"closePopover()\"\r\n      class=\"popover-cancel m-2 action-button provider-address-list-popover-close\"\r\n    >\r\n      <i class=\"fas fa-times\"></i>\r\n      <span class=\"sr-only\">Close</span>\r\n    </button>\r\n\r\n    <div *ngFor=\"let group of providerGroup; trackBy: trackByProviderId\" class=\"mb-3 mt-1 no-translate-block\">\r\n      <vnext-widget-provider-phone\r\n        *ngIf=\"isZelisIntegrationEnabled && group.phoneNumber\"\r\n        [phoneNumber]=\"group.phoneNumber\"\r\n        [countryCode]=\"countryCode\"\r\n        [showPhoneIcon]=\"isHelpfulToolsView\"\r\n      ></vnext-widget-provider-phone>\r\n      <div>{{ group.address1 | titlecase }}</div>\r\n      <div *ngIf=\"provider.address2\">{{ group.address2 | titlecase }}</div>\r\n      <div>{{ group.city | titlecase }}, {{ group.state }} {{ group.zip }}</div>\r\n      <div class=\"Spa_Style_Note mb-1\" *ngIf=\"isZelisIntegrationEnabled && isHelpfulToolsView && group.languages?.length\">\r\n        <vnext-widget-provider-inline-element [values]=\"group.languages\" [icon]=\"languagesIcon\"> </vnext-widget-provider-inline-element>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n", styles: [".provider-address{padding:0 24px 0 10px}.provider-pin-number{line-height:1.6}.provider-map-pin{font-size:28px}.provider-indicator{font-family:montserrat_bold;font-weight:700;font-size:14px;color:#fff}.underline{text-decoration:underline}.popover-cancel{position:absolute;top:0;right:0;cursor:pointer;color:var(--Spa_Style_Primary);width:20px;height:20px;text-align:center}\n"] }]
    }], function () { return [{ type: ProviderFacade }, { type: i0.ChangeDetectorRef }]; }, { providerButton: [{
            type: ViewChild,
            args: ['providerButton']
        }], selectedProviderButton: [{
            type: ViewChild,
            args: ['selectedProviderButton']
        }], popover: [{
            type: ViewChild,
            args: ['addressListPopover']
        }], providerLocationButton: [{
            type: ViewChild,
            args: ['providerLocationButton']
        }], isHelpfulToolsView: [{
            type: Input
        }], provider: [{
            type: Input
        }], pageSize: [{
            type: Input
        }], pageIndex: [{
            type: Input
        }], selectedProviders: [{
            type: Input
        }], providerGroup: [{
            type: Input
        }], addProviderText: [{
            type: Input
        }], providerAddedText: [{
            type: Input
        }], maxCountErrorMessage: [{
            type: Input
        }], maxCount: [{
            type: Input
        }], index: [{
            type: Input
        }], customClass: [{
            type: Input
        }], alternateViewClass: [{
            type: Input
        }], alternateNumberIndicatorClass: [{
            type: Input
        }], isProviderAdded: [{
            type: Input
        }], backgroundStyle: [{
            type: Input
        }], isPrimary: [{
            type: Input
        }], alreadySelectedProvider: [{
            type: Input
        }], providerExistsTooltipText: [{
            type: Input
        }], countryCode: [{
            type: Input
        }], acceptingNewPatientsText: [{
            type: Input
        }], acceptingNewPatientsIcon: [{
            type: Input
        }], languagesIcon: [{
            type: Input
        }], providerSingleSelectEnabled: [{
            type: Input
        }], providerLocationsText: [{
            type: Input
        }], valueBasedCareEnabled: [{
            type: Input
        }], valueBasedCareIcon: [{
            type: Input
        }], valueBasedCareText: [{
            type: Input
        }], singleProviderInListEnabled: [{
            type: Input
        }], primaryCareProviderText: [{
            type: Input
        }], isZelisIntegrationEnabled: [{
            type: Input
        }], addProvider: [{
            type: Output
        }], onScroll: [{
            type: HostListener,
            args: ['window:scroll', ['$event']]
        }] }); })();

function MapComponent_agm_overlay_1_ng_template_5_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17)(1, "i");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "titlecase");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const marker_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, marker_r2.specialty));
} }
function MapComponent_agm_overlay_1_ng_template_5_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "titlecase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const marker_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, marker_r2.address2));
} }
function MapComponent_agm_overlay_1_ng_template_5_span_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 18);
} }
function MapComponent_agm_overlay_1_ng_template_5_ng_container_15_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 21);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 22);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const marker_r2 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r11.addedLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", marker_r2.name, " ", marker_r2.address, " ");
} }
function MapComponent_agm_overlay_1_ng_template_5_ng_container_15_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 25);
    i0.ɵɵlistener("click", function MapComponent_agm_overlay_1_ng_template_5_ng_container_15_ng_template_2_ng_container_0_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r22); const marker_r2 = i0.ɵɵnextContext(4).$implicit; const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.addSelection(marker_r2)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r15.addButtonText, " ");
} }
function MapComponent_agm_overlay_1_ng_template_5_ng_container_15_ng_template_2_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 26, 27);
    i0.ɵɵlistener("mouseleave", function MapComponent_agm_overlay_1_ng_template_5_ng_container_15_ng_template_2_ng_template_1_ng_container_0_Template_button_mouseleave_1_listener() { i0.ɵɵrestoreView(_r26); const _r24 = i0.ɵɵreference(2); return i0.ɵɵresetView(_r24.close()); })("click", function MapComponent_agm_overlay_1_ng_template_5_ng_container_15_ng_template_2_ng_template_1_ng_container_0_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r26); const _r24 = i0.ɵɵreference(2); return i0.ɵɵresetView(_r24.open()); });
    i0.ɵɵtext(3);
    i0.ɵɵelementStart(4, "span", 28);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngbTooltip", ctx_r23.providerExistsTooltipText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r23.addButtonText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r23.providerExistsTooltipText);
} }
function MapComponent_agm_overlay_1_ng_template_5_ng_container_15_ng_template_2_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, MapComponent_agm_overlay_1_ng_template_5_ng_container_15_ng_template_2_ng_template_1_ng_container_0_Template, 6, 3, "ng-container", 19);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r18 = i0.ɵɵreference(4);
    const marker_r2 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r17 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r17.isProvider && ctx_r17.providerSingleSelectEnabled && ctx_r17.isProviderCountWithinLimits && ctx_r17.providerFacade.selectedProviderIds[marker_r2.id])("ngIfElse", _r18);
} }
function MapComponent_agm_overlay_1_ng_template_5_ng_container_15_ng_template_2_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 29, 30);
    i0.ɵɵlistener("mouseleave", function MapComponent_agm_overlay_1_ng_template_5_ng_container_15_ng_template_2_ng_template_3_Template_button_mouseleave_0_listener() { i0.ɵɵrestoreView(_r31); const _r29 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r29.close()); })("click", function MapComponent_agm_overlay_1_ng_template_5_ng_container_15_ng_template_2_ng_template_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r31); const _r29 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r29.open()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "span", 28);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("ngbTooltip", ctx_r19.limitErrorMessage);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r19.addButtonText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r19.limitErrorMessage);
} }
function MapComponent_agm_overlay_1_ng_template_5_ng_container_15_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, MapComponent_agm_overlay_1_ng_template_5_ng_container_15_ng_template_2_ng_container_0_Template, 3, 1, "ng-container", 19);
    i0.ɵɵtemplate(1, MapComponent_agm_overlay_1_ng_template_5_ng_container_15_ng_template_2_ng_template_1_Template, 1, 2, "ng-template", null, 23, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(3, MapComponent_agm_overlay_1_ng_template_5_ng_container_15_ng_template_2_ng_template_3_Template, 5, 3, "ng-template", null, 24, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(5, "span", 22);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r16 = i0.ɵɵreference(2);
    const marker_r2 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r13.isProvider ? ctx_r13.isProviderCountWithinLimits && (!ctx_r13.providerFacade.selectedProviderIds[marker_r2.id] || !ctx_r13.providerSingleSelectEnabled) : ctx_r13.isPharmacyCountWithinLimits && !ctx_r13.pharmacyFacade.isSelectedPharmacy(marker_r2.pharmacyId))("ngIfElse", _r16);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate2("", marker_r2.name, " ", marker_r2.address, " ");
} }
function MapComponent_agm_overlay_1_ng_template_5_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MapComponent_agm_overlay_1_ng_template_5_ng_container_15_ng_container_1_Template, 5, 3, "ng-container", 19);
    i0.ɵɵtemplate(2, MapComponent_agm_overlay_1_ng_template_5_ng_container_15_ng_template_2_Template, 7, 4, "ng-template", null, 20, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r12 = i0.ɵɵreference(3);
    const marker_r2 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.isProvider ? ctx_r8.providerFacade.isProviderAdded(marker_r2.id, marker_r2.addressId) : ctx_r8.pharmacyFacade.isSelectedPharmacy(marker_r2))("ngIfElse", _r12);
} }
const _c0$1Z = function (a0) { return { "marker-address-wrapper": a0 }; };
const _c1$V = function (a0) { return { "marker-address": a0 }; };
function MapComponent_agm_overlay_1_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 9)(4, "div", 10);
    i0.ɵɵtemplate(5, MapComponent_agm_overlay_1_ng_template_5_div_5_Template, 4, 3, "div", 11);
    i0.ɵɵelementStart(6, "span", 12);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, MapComponent_agm_overlay_1_ng_template_5_div_9_Template, 3, 3, "div", 13);
    i0.ɵɵelementStart(10, "div", 14);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "titlecase");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "div", 15);
    i0.ɵɵtemplate(14, MapComponent_agm_overlay_1_ng_template_5_span_14_Template, 1, 0, "span", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(15, MapComponent_agm_overlay_1_ng_template_5_ng_container_15_Template, 4, 2, "ng-container", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const marker_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", !ctx_r4.isProvider ? ctx_r4.pharmacyFacade.noticeAlternateViewBackgroundForMarker(marker_r2) : ctx_r4.providerFacade.noticeAlternateViewBackgroundForMarker(marker_r2));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 12, marker_r2.name), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c0$1Z, !ctx_r4.isProvider));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.isProvider);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c1$V, !ctx_r4.isProvider));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 14, marker_r2.address));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", marker_r2.address2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3("", i0.ɵɵpipeBind1(12, 16, marker_r2.city), ", ", marker_r2.state, " ", marker_r2.zip, "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", marker_r2.hasEPrescriptions);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.isHelpfulToolsView);
} }
function MapComponent_agm_overlay_1_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "agm-overlay", 3);
    i0.ɵɵlistener("markerClick", function MapComponent_agm_overlay_1_Template_agm_overlay_markerClick_0_listener() { i0.ɵɵrestoreView(_r37); const _r3 = i0.ɵɵreference(4); const ctx_r36 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r36.showInfoWindow(_r3)); });
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵlistener("keyup.enter", function MapComponent_agm_overlay_1_Template_div_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r37); const _r3 = i0.ɵɵreference(4); const ctx_r38 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r38.showInfoWindow(_r3)); });
    i0.ɵɵelement(2, "vnext-widget-map-pin", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "agm-snazzy-info-window", 6, 7);
    i0.ɵɵtemplate(5, MapComponent_agm_overlay_1_ng_template_5_Template, 16, 22, "ng-template");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const marker_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("latitude", marker_r2.latitude)("longitude", marker_r2.longitude)("draggable", marker_r2.draggable);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("index", marker_r2.label)("isMap", true)("isPrimary", ctx_r0.isProvider ? ctx_r0.providerFacade.isPcp(marker_r2) : ctx_r0.pharmacyFacade.isPrimaryPharmacy(marker_r2, ctx_r0.isHelpfulToolsView))("customClass", ctx_r0.isProvider ? ctx_r0.providerFacade.getProviderPinClass(marker_r2, true) : ctx_r0.pharmacyFacade.getPharmacyMapPinClass(marker_r2, true, ctx_r0.isHelpfulToolsView))("backgroundStyle", ctx_r0.isProvider ? ctx_r0.providerFacade.getPrimaryProviderBackgroundColor(marker_r2) : ctx_r0.pharmacyFacade.getBackGroundColor(marker_r2, ctx_r0.isHelpfulToolsView))("alternateViewClass", ctx_r0.isProvider ? ctx_r0.providerFacade.noticeAlternateViewForMarker(marker_r2) : ctx_r0.pharmacyFacade.noticeAlternateViewForMarker(marker_r2))("alternateNumberIndicatorClass", ctx_r0.isProvider ? ctx_r0.providerFacade.noticeAlternateIndicatorForMarker(marker_r2) : ctx_r0.pharmacyFacade.noticeAlternateIndicatorForMarker(marker_r2))("primaryIconAriaLabelText", ctx_r0.primaryIconAriaLabelText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("latitude", marker_r2.latitude)("longitude", marker_r2.longitude)("closeWhenOthersOpen", true)("showCloseButton", false)("closeOnMapClick", true)("shadow", true)("wrapperClass", "pharmacyMapInfo");
} }
function MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r45.providerExistsTooltipText, " ");
} }
function MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_div_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-link", 42);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r47.groupAddedLabel)("customClass", "Spa_Style_Link Spa_Style_Gray4_Color")("makeInlineBlock", true)("noUnderlineOnHover", true)("alwaysUnderlined", false);
} }
function MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_div_9_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-link", 43);
    i0.ɵɵlistener("click", function MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_div_9_ng_template_2_ng_container_0_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r57); const marker_r44 = i0.ɵɵnextContext(3).$implicit; const ctx_r55 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r55.addSelectedProvider(marker_r44)); })("keyup.enter", function MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_div_9_ng_template_2_ng_container_0_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r57); const marker_r44 = i0.ɵɵnextContext(3).$implicit; const ctx_r58 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r58.addSelectedProvider(marker_r44)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r50.groupAddText)("makeInlineBlock", true)("alwaysUnderlined", true);
} }
function MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_div_9_ng_template_2_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-link", 42);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r60 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r60.groupAddText)("customClass", "Spa_Style_Link Spa_Style_Gray4_Color")("makeInlineBlock", true)("noUnderlineOnHover", true)("alwaysUnderlined", false);
} }
function MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_div_9_ng_template_2_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_div_9_ng_template_2_ng_template_1_ng_container_0_Template, 2, 5, "ng-container", 19);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r53 = i0.ɵɵreference(4);
    const marker_r44 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r52 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngIf", ctx_r52.isProvider && ctx_r52.isProviderCountWithinLimits && ctx_r52.providerFacade.selectedProviderIds[marker_r44.id])("ngIfElse", _r53);
} }
function MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_div_9_ng_template_2_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r64 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 44, 30);
    i0.ɵɵlistener("mouseleave", function MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_div_9_ng_template_2_ng_template_3_Template_vnext_link_mouseleave_0_listener() { i0.ɵɵrestoreView(_r64); const _r62 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r62.close()); })("click", function MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_div_9_ng_template_2_ng_template_3_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r64); const _r62 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r62.open()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(7);
    i0.ɵɵproperty("ngbTooltip", ctx_r54.limitErrorMessage)("title", ctx_r54.groupAddText);
} }
function MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_div_9_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_div_9_ng_template_2_ng_container_0_Template, 2, 3, "ng-container", 19);
    i0.ɵɵtemplate(1, MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_div_9_ng_template_2_ng_template_1_Template, 1, 2, "ng-template", null, 23, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(3, MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_div_9_ng_template_2_ng_template_3_Template, 2, 2, "ng-template", null, 24, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(5, "span", 22);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r51 = i0.ɵɵreference(2);
    const marker_r44 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r49 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngIf", ctx_r49.isProviderCountWithinLimits && (!ctx_r49.providerFacade.selectedProviderIds[marker_r44.id] || !ctx_r49.providerSingleSelectEnabled))("ngIfElse", _r51);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1("", marker_r44.name, " ");
} }
function MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵtemplate(1, MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_div_9_ng_container_1_Template, 2, 5, "ng-container", 19);
    i0.ɵɵtemplate(2, MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_div_9_ng_template_2_Template, 7, 3, "ng-template", null, 20, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r48 = i0.ɵɵreference(3);
    const marker_r44 = i0.ɵɵnextContext().$implicit;
    const ctx_r46 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r46.providerFacade.isProviderAdded(marker_r44.id, marker_r44.addressId))("ngIfElse", _r48);
} }
function MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36)(1, "div", 12);
    i0.ɵɵelement(2, "vnext-widget-map-pin", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 12)(4, "div")(5, "div", 37);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "titlecase");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_div_8_Template, 2, 1, "div", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_div_9_Template, 4, 2, "div", 39);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const marker_r44 = ctx.$implicit;
    const ctx_r43 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", !ctx_r43.isHelpfulToolsView ? "col-2" : "col-3");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("index", marker_r44.label)("isMap", true)("isPrimary", ctx_r43.providerFacade.isPcp(marker_r44))("customClass", ctx_r43.providerFacade.getProviderPinClass(marker_r44, true))("backgroundStyle", ctx_r43.providerFacade.getPrimaryProviderBackgroundColor(marker_r44))("alternateViewClass", ctx_r43.providerFacade.noticeAlternateViewForMarker(marker_r44))("alternateNumberIndicatorClass", ctx_r43.providerFacade.noticeAlternateIndicatorForMarker(marker_r44))("primaryIconAriaLabelText", ctx_r43.primaryIconAriaLabelText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", !ctx_r43.isHelpfulToolsView ? "col-6" : "col-8");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 13, marker_r44.name), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r43.isHelpfulToolsView && ctx_r43.providerSingleSelectEnabled && ctx_r43.isProviderCountWithinLimits && ctx_r43.providerFacade.selectedProviderIds[marker_r44.id]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r43.isHelpfulToolsView);
} }
function MapComponent_div_2_agm_overlay_1_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵtemplate(1, MapComponent_div_2_agm_overlay_1_ng_template_5_div_1_Template, 10, 15, "div", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const markers_r40 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", markers_r40);
} }
function MapComponent_div_2_agm_overlay_1_Template(rf, ctx) { if (rf & 1) {
    const _r70 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "agm-overlay", 3);
    i0.ɵɵlistener("markerClick", function MapComponent_div_2_agm_overlay_1_Template_agm_overlay_markerClick_0_listener() { i0.ɵɵrestoreView(_r70); const _r41 = i0.ɵɵreference(4); const ctx_r69 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r69.showInfoWindow(_r41)); });
    i0.ɵɵelementStart(1, "div", 31);
    i0.ɵɵelement(2, "vnext-widget-map-pin", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "agm-snazzy-info-window", 6, 33);
    i0.ɵɵtemplate(5, MapComponent_div_2_agm_overlay_1_ng_template_5_Template, 2, 1, "ng-template");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const markers_r40 = ctx.$implicit;
    const ctx_r39 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("latitude", markers_r40[0].latitude)("longitude", markers_r40[0].longitude)("draggable", markers_r40[0].draggable);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("isMap", true)("isPrimary", ctx_r39.providerFacade.hasPrimaryCareProviderMarker(markers_r40))("customClass", ctx_r39.providerFacade.getGroupProviderPinClass(markers_r40))("backgroundStyle", ctx_r39.providerFacade.getPrimaryGroupProviderBackgroundColor(markers_r40))("primaryIconAriaLabelText", ctx_r39.primaryIconAriaLabelText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("latitude", markers_r40[0].latitude)("longitude", markers_r40[0].longitude)("closeWhenOthersOpen", true)("showCloseButton", true)("closeOnMapClick", true)("shadow", true)("wrapperClass", !ctx_r39.isHelpfulToolsView ? "pharmacy-map-usergroup-info" : "pharmacy-map-usergroup-helpfultools-info");
} }
function MapComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MapComponent_div_2_agm_overlay_1_Template, 6, 15, "agm-overlay", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.markerGroups);
} }
class MapComponent {
    constructor(cdr, pharmacyFacade, providerFacade, mapFacade, mapContextService, elementRef, store) {
        this.cdr = cdr;
        this.pharmacyFacade = pharmacyFacade;
        this.providerFacade = providerFacade;
        this.mapFacade = mapFacade;
        this.mapContextService = mapContextService;
        this.elementRef = elementRef;
        this.store = store;
        this.setZoom = new EventEmitter();
        this.resetToDefaultPageIndex = new EventEmitter();
        this.setMapCenter = new EventEmitter();
        this.setMap = new EventEmitter();
        this.setMapDefaultBounds = new EventEmitter();
        this.addSelectedItem = new EventEmitter();
        this.isProviderCountWithinLimits = false;
        this.isPharmacyCountWithinLimits = false;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.subscriptions.add(this.providerFacade.providerCountWithinLimits$().subscribe({
            next: isProviderCountWithinLimits => {
                this.isProviderCountWithinLimits = isProviderCountWithinLimits;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.pharmacyFacade.pharmacyCountWithinLimits$().subscribe({
            next: isPharmacyCountWithinLimits => {
                this.isPharmacyCountWithinLimits = isPharmacyCountWithinLimits;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.mapContextService.location$.subscribe({
            next: location => {
                if (location) {
                    this.latitude = location.lat;
                    this.longitude = location.lng;
                    if (this.map) {
                        const position = this.mapFacade.getLatitudeAndLongitude(this.latitude, this.longitude);
                        this.map.panTo(position);
                    }
                    this.resetToDefaultPageIndex.emit();
                }
            }
        }));
        this.subscriptions.add(this.mapContextService.markers$.subscribe({
            next: markers => {
                if (this.mapFacade.getIsOptimalZoomEnabled() && markers.length) {
                    const markerBounds = this.mapFacade.getMarkerBounds(markers);
                    const optimalZoom = this.mapFacade.getBoundsZoomLevel(markerBounds, this.getMapContainerDimension());
                    if (markers.length === 1) {
                        const location = { lat: markers[0].latitude, lng: markers[0].longitude };
                        this.mapContextService.setLocation(location);
                    }
                    else {
                        const location = markerBounds.getCenter();
                        this.mapContextService.setLocation({ lat: location.lat(), lng: location.lng() });
                    }
                    this.mapContextService.isCenterLocationSetByPharmacy = true;
                    this.store.dispatch(new SetOptimalZoom(optimalZoom));
                    this.zoom = this.mapFacade.zoomLevel = optimalZoom;
                    this.store.dispatch(new SetIsOptimalZoomEnabled(false));
                    this.cdr.detectChanges();
                }
            }
        }));
    }
    ngAfterViewChecked() {
        if (this.map) {
            this.setMapDefaultBounds.emit(this.map.getBounds());
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    setupMap(map) {
        this.map = map;
        this.setMap.emit(map);
    }
    setZoomLevel(zoom) {
        this.setZoom.emit(zoom);
        const activeClass = 'gm-control-active';
        const disableClass = 'gm-disabled';
        const zoomInButtonElement = document.querySelector('button[aria-label="Zoom in"]');
        if (zoomInButtonElement) {
            const zoomInElement = zoomInButtonElement;
            zoomInElement.className = zoom >= this.maxZoom ? `${activeClass} ${disableClass}` : `${activeClass}`;
        }
        const zoomOutButtonElement = document.querySelector('button[aria-label="Zoom out"]');
        if (zoomOutButtonElement) {
            const zoomOutElement = zoomOutButtonElement;
            zoomOutElement.className = zoom <= this.minZoom ? `${activeClass} ${disableClass}` : `${activeClass}`;
        }
    }
    setCenter(value) {
        this.setMapCenter.emit({ lat: value.lat, lng: value.lng });
    }
    showInfoWindow(infoWindow) {
        infoWindow._openInfoWindow();
    }
    addSelectedProvider(marker) {
        this.addSelectedItem.emit({ providerId: marker.id, addressId: marker.addressId });
    }
    addSelection(marker) {
        if (this.isProvider) {
            this.addSelectedItem.emit({ providerId: marker.id, addressId: marker.addressId });
        }
        else {
            this.addSelectedItem.emit({ pharmacyId: marker.pharmacyId });
        }
    }
    getMapContainerDimension() {
        const rootElement = this.elementRef.nativeElement;
        const childElement = rootElement.firstElementChild;
        const contentElement = childElement.firstElementChild;
        return {
            height: contentElement.clientHeight,
            width: contentElement.clientWidth
        };
    }
}
MapComponent.ɵfac = function MapComponent_Factory(t) { return new (t || MapComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PharmacyFacade), i0.ɵɵdirectiveInject(ProviderFacade), i0.ɵɵdirectiveInject(MapFacade), i0.ɵɵdirectiveInject(MapContextService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.Store)); };
MapComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MapComponent, selectors: [["vnext-widget-map"]], inputs: { zoom: "zoom", maxZoom: "maxZoom", minZoom: "minZoom", isHelpfulToolsView: "isHelpfulToolsView", isProvider: "isProvider", zip: "zip", addedLabel: "addedLabel", addButtonText: "addButtonText", markers: "markers", limitErrorMessage: "limitErrorMessage", markerGroups: "markerGroups", groupAddedLabel: "groupAddedLabel", groupAddText: "groupAddText", providerExistsTooltipText: "providerExistsTooltipText", providerSingleSelectEnabled: "providerSingleSelectEnabled", primaryIconAriaLabelText: "primaryIconAriaLabelText" }, outputs: { setZoom: "setZoom", resetToDefaultPageIndex: "resetToDefaultPageIndex", setMapCenter: "setMapCenter", setMap: "setMap", setMapDefaultBounds: "setMapDefaultBounds", addSelectedItem: "addSelectedItem" }, decls: 3, vars: 11, consts: [[3, "latitude", "longitude", "zoom", "minZoom", "maxZoom", "streetViewControl", "clickableIcons", "usePanning", "scrollwheel", "zoomChange", "centerChange", "mapReady"], [3, "latitude", "longitude", "draggable", "markerClick", 4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "latitude", "longitude", "draggable", "markerClick"], ["tabindex", "0", 1, "marker", 3, "keyup.enter"], [3, "index", "isMap", "isPrimary", "customClass", "backgroundStyle", "alternateViewClass", "alternateNumberIndicatorClass", "primaryIconAriaLabelText"], [3, "latitude", "longitude", "closeWhenOthersOpen", "showCloseButton", "closeOnMapClick", "shadow", "wrapperClass"], ["snazzyWindow", ""], [1, "Spa_Style_TooltipTextAndNumberIndicators", "map-info-header", "no-translate-block", 3, "ngClass"], [1, "map-info-address", "Spa_Style_Paragraph"], [1, "no-translate-block", 3, "ngClass"], ["class", "py-1 Spa_Style_Paragraph", 4, "ngIf"], [3, "ngClass"], ["class", "p-0 Spa_Style_Paragraph", 4, "ngIf"], [1, "p-0", "Spa_Style_Paragraph"], [1, "electronic-prescribing-icon-wrapper"], ["class", "float-right electronic-prescribing-icon", "class", "Spa_Style_Electronic_Prescription_Icon", 4, "ngIf"], [1, "py-1", "Spa_Style_Paragraph"], [1, "Spa_Style_Electronic_Prescription_Icon"], [4, "ngIf", "ngIfElse"], ["showAddSection", ""], [1, "btn", "my-2", "w-100", "Spa_Style_SecondaryButtonSelected", "Spa_Style_Bold_Weight"], [1, "sr-only", "no-translate-block"], ["showSelectedProviderMessage", ""], ["showLimitMessage", ""], ["tabindex", "0", "type", "button", 1, "btn", "my-2", "w-100", "Spa_Style_SecondaryButton", "Spa_Style_Regular_Weight", "pharmacy-border-color", 3, "click"], ["triggers", "manual", "placement", "top", "container", "body", "autoClose", "true", 1, "btn", "mb-2", "mt-2", "w-100", "Spa_Style_SecondaryButton", "Spa_Style_Regular_Weight", "provider-border-color", 3, "ngbTooltip", "mouseleave", "click"], ["providerSelectedTooltip", "ngbTooltip"], [1, "sr-only"], ["placement", "top", "triggers", "manual", "container", "body", "autoClose", "true", 1, "btn", "my-2", "w-100", "Spa_Style_SecondaryButton", "Spa_Style_Regular_Weight", "pharmacy-border-color", 3, "ngbTooltip", "mouseleave", "click"], ["limitErrorTooltip", "ngbTooltip"], [1, "marker"], [3, "isMap", "isPrimary", "customClass", "backgroundStyle", "primaryIconAriaLabelText"], ["snazzyGroupProviderWindow", ""], [1, "row"], ["class", "d-flex flex-row w-100 pt-2 pl-2", 4, "ngFor", "ngForOf"], [1, "d-flex", "flex-row", "w-100", "pt-2", "pl-2"], [1, "user-group-info", "Spa_Style_Paragraph", "no-translate-block"], ["class", "p-0 provider-selected", 4, "ngIf"], ["class", "col-4", 4, "ngIf"], [1, "p-0", "provider-selected"], [1, "col-4"], [3, "title", "customClass", "makeInlineBlock", "noUnderlineOnHover", "alwaysUnderlined"], [3, "title", "makeInlineBlock", "alwaysUnderlined", "click", "keyup.enter"], ["placement", "top", "triggers", "manual", "container", "body", "autoClose", "true", 3, "ngbTooltip", "title", "mouseleave", "click"]], template: function MapComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "agm-map", 0);
        i0.ɵɵlistener("zoomChange", function MapComponent_Template_agm_map_zoomChange_0_listener($event) { return ctx.setZoomLevel($event); })("centerChange", function MapComponent_Template_agm_map_centerChange_0_listener($event) { return ctx.setCenter($event); })("mapReady", function MapComponent_Template_agm_map_mapReady_0_listener($event) { return ctx.setupMap($event); });
        i0.ɵɵtemplate(1, MapComponent_agm_overlay_1_Template, 6, 18, "agm-overlay", 1);
        i0.ɵɵtemplate(2, MapComponent_div_2_Template, 2, 1, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("latitude", ctx.latitude)("longitude", ctx.longitude)("zoom", ctx.zoom)("minZoom", ctx.minZoom)("maxZoom", ctx.maxZoom)("streetViewControl", false)("clickableIcons", false)("usePanning", true)("scrollwheel", null);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.markers);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isProvider && (ctx.markerGroups == null ? null : ctx.markerGroups.length));
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, i1$1.NgbTooltip, i9.AgmOverlay, i1$4.AgmMap, i11.AgmSnazzyInfoWindow, MapPinComponent, i1$2.TitleCasePipe], styles: ["agm-map[_ngcontent-%COMP%]{height:455px}.marker[_ngcontent-%COMP%]{position:relative;text-align:center}.marker[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:28px}.marker[_ngcontent-%COMP%]:hover{cursor:pointer}.marker[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{position:absolute;left:0;top:11%;width:100%}.map-info-header[_ngcontent-%COMP%]{padding:6px 10px}.map-info-address[_ngcontent-%COMP%]{padding:6px 10px 0}.map-info-header-content[_ngcontent-%COMP%]{padding:0}.user-group-info[_ngcontent-%COMP%]{padding:2px 0 0}.marker-address[_ngcontent-%COMP%]{width:88%;float:left}.electronic-prescribing-icon[_ngcontent-%COMP%]{position:absolute;right:5px}.marker-address-wrapper[_ngcontent-%COMP%]{float:left;width:85%;padding-bottom:10px}.electronic-prescribing-icon-wrapper[_ngcontent-%COMP%]{float:right}.pharmacy-border-color[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent1)}.provider-selected[_ngcontent-%COMP%]{font-size:12px;font-family:montserratregular}@media only screen and (max-width: 991.9px){agm-map[_ngcontent-%COMP%]{height:265px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MapComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-map', changeDetection: ChangeDetectionStrategy.OnPush, template: "<agm-map\r\n  [latitude]=\"latitude\"\r\n  [longitude]=\"longitude\"\r\n  [zoom]=\"zoom\"\r\n  [minZoom]=\"minZoom\"\r\n  [maxZoom]=\"maxZoom\"\r\n  [streetViewControl]=\"false\"\r\n  [clickableIcons]=\"false\"\r\n  [usePanning]=\"true\"\r\n  [scrollwheel]=\"null\"\r\n  (zoomChange)=\"setZoomLevel($event)\"\r\n  (centerChange)=\"setCenter($event)\"\r\n  (mapReady)=\"setupMap($event)\"\r\n>\r\n  <agm-overlay\r\n    *ngFor=\"let marker of markers\"\r\n    [latitude]=\"marker.latitude\"\r\n    [longitude]=\"marker.longitude\"\r\n    [draggable]=\"marker.draggable\"\r\n    (markerClick)=\"showInfoWindow(snazzyWindow)\"\r\n  >\r\n    <div class=\"marker\" tabindex=\"0\" (keyup.enter)=\"showInfoWindow(snazzyWindow)\">\r\n      <vnext-widget-map-pin\r\n        [index]=\"marker.label\"\r\n        [isMap]=\"true\"\r\n        [isPrimary]=\"isProvider ? providerFacade.isPcp(marker) : pharmacyFacade.isPrimaryPharmacy(marker, isHelpfulToolsView)\"\r\n        [customClass]=\"\r\n          isProvider\r\n            ? providerFacade.getProviderPinClass(marker, true)\r\n            : pharmacyFacade.getPharmacyMapPinClass(marker, true, isHelpfulToolsView)\r\n        \"\r\n        [backgroundStyle]=\"\r\n          isProvider\r\n            ? providerFacade.getPrimaryProviderBackgroundColor(marker)\r\n            : pharmacyFacade.getBackGroundColor(marker, isHelpfulToolsView)\r\n        \"\r\n        [alternateViewClass]=\"\r\n          isProvider ? providerFacade.noticeAlternateViewForMarker(marker) : pharmacyFacade.noticeAlternateViewForMarker(marker)\r\n        \"\r\n        [alternateNumberIndicatorClass]=\"\r\n          isProvider ? providerFacade.noticeAlternateIndicatorForMarker(marker) : pharmacyFacade.noticeAlternateIndicatorForMarker(marker)\r\n        \"\r\n        [primaryIconAriaLabelText]=\"primaryIconAriaLabelText\"\r\n      ></vnext-widget-map-pin>\r\n    </div>\r\n    <agm-snazzy-info-window\r\n      #snazzyWindow\r\n      [latitude]=\"marker.latitude\"\r\n      [longitude]=\"marker.longitude\"\r\n      [closeWhenOthersOpen]=\"true\"\r\n      [showCloseButton]=\"false\"\r\n      [closeOnMapClick]=\"true\"\r\n      [shadow]=\"true\"\r\n      [wrapperClass]=\"'pharmacyMapInfo'\"\r\n    >\r\n      <ng-template>\r\n        <div\r\n          class=\"Spa_Style_TooltipTextAndNumberIndicators map-info-header no-translate-block\"\r\n          [ngClass]=\"\r\n            !isProvider\r\n              ? pharmacyFacade.noticeAlternateViewBackgroundForMarker(marker)\r\n              : providerFacade.noticeAlternateViewBackgroundForMarker(marker)\r\n          \"\r\n        >\r\n          {{ marker.name | titlecase }}\r\n        </div>\r\n        <div class=\"map-info-address Spa_Style_Paragraph\">\r\n          <div class=\"no-translate-block\" [ngClass]=\"{ 'marker-address-wrapper': !isProvider }\">\r\n            <div class=\"py-1 Spa_Style_Paragraph\" *ngIf=\"isProvider\">\r\n              <i>{{ marker.specialty | titlecase }}</i>\r\n            </div>\r\n            <span [ngClass]=\"{ 'marker-address': !isProvider }\">{{ marker.address | titlecase }}</span>\r\n            <div *ngIf=\"marker.address2\" class=\"p-0 Spa_Style_Paragraph\">{{ marker.address2 | titlecase }}</div>\r\n            <div class=\"p-0 Spa_Style_Paragraph\">{{ marker.city | titlecase }}, {{ marker.state }} {{ marker.zip }}</div>\r\n          </div>\r\n          <div class=\"electronic-prescribing-icon-wrapper\">\r\n            <span\r\n              class=\"float-right electronic-prescribing-icon\"\r\n              *ngIf=\"marker.hasEPrescriptions\"\r\n              class=\"Spa_Style_Electronic_Prescription_Icon\"\r\n            ></span>\r\n          </div>\r\n          <ng-container *ngIf=\"!isHelpfulToolsView\">\r\n            <ng-container\r\n              *ngIf=\"\r\n                isProvider ? providerFacade.isProviderAdded(marker.id, marker.addressId) : pharmacyFacade.isSelectedPharmacy(marker);\r\n                else showAddSection\r\n              \"\r\n            >\r\n              <button class=\"btn my-2 w-100 Spa_Style_SecondaryButtonSelected Spa_Style_Bold_Weight\">\r\n                {{ addedLabel }}\r\n              </button>\r\n              <span class=\"sr-only no-translate-block\">{{ marker.name }} {{ marker.address }} </span>\r\n            </ng-container>\r\n            <ng-template #showAddSection>\r\n              <ng-container\r\n                *ngIf=\"\r\n                  isProvider\r\n                    ? isProviderCountWithinLimits && (!providerFacade.selectedProviderIds[marker.id] || !providerSingleSelectEnabled)\r\n                    : isPharmacyCountWithinLimits && !pharmacyFacade.isSelectedPharmacy(marker.pharmacyId);\r\n                  else showSelectedProviderMessage\r\n                \"\r\n              >\r\n                <button\r\n                  tabindex=\"0\"\r\n                  type=\"button\"\r\n                  class=\"btn my-2 w-100 Spa_Style_SecondaryButton Spa_Style_Regular_Weight pharmacy-border-color\"\r\n                  (click)=\"addSelection(marker)\"\r\n                >\r\n                  {{ addButtonText }}\r\n                </button>\r\n              </ng-container>\r\n              <ng-template #showSelectedProviderMessage>\r\n                <ng-container\r\n                  *ngIf=\"\r\n                    isProvider &&\r\n                      providerSingleSelectEnabled &&\r\n                      isProviderCountWithinLimits &&\r\n                      providerFacade.selectedProviderIds[marker.id];\r\n                    else showLimitMessage\r\n                  \"\r\n                >\r\n                  <button\r\n                    class=\"btn mb-2 mt-2 w-100 Spa_Style_SecondaryButton Spa_Style_Regular_Weight provider-border-color\"\r\n                    [ngbTooltip]=\"providerExistsTooltipText\"\r\n                    triggers=\"manual\"\r\n                    placement=\"top\"\r\n                    container=\"body\"\r\n                    autoClose=\"true\"\r\n                    #providerSelectedTooltip=\"ngbTooltip\"\r\n                    (mouseleave)=\"providerSelectedTooltip.close()\"\r\n                    (click)=\"providerSelectedTooltip.open()\"\r\n                  >\r\n                    {{ addButtonText }} <span class=\"sr-only\">{{ providerExistsTooltipText }}</span>\r\n                  </button>\r\n                </ng-container>\r\n              </ng-template>\r\n              <ng-template #showLimitMessage>\r\n                <button\r\n                  class=\"btn my-2 w-100 Spa_Style_SecondaryButton Spa_Style_Regular_Weight pharmacy-border-color\"\r\n                  [ngbTooltip]=\"limitErrorMessage\"\r\n                  placement=\"top\"\r\n                  triggers=\"manual\"\r\n                  container=\"body\"\r\n                  autoClose=\"true\"\r\n                  #limitErrorTooltip=\"ngbTooltip\"\r\n                  (mouseleave)=\"limitErrorTooltip.close()\"\r\n                  (click)=\"limitErrorTooltip.open()\"\r\n                >\r\n                  {{ addButtonText }} <span class=\"sr-only\">{{ limitErrorMessage }}</span>\r\n                </button>\r\n              </ng-template>\r\n              <span class=\"sr-only no-translate-block\">{{ marker.name }} {{ marker.address }} </span>\r\n            </ng-template>\r\n          </ng-container>\r\n        </div>\r\n      </ng-template>\r\n    </agm-snazzy-info-window>\r\n  </agm-overlay>\r\n  <div *ngIf=\"isProvider && markerGroups?.length\">\r\n    <agm-overlay\r\n      *ngFor=\"let markers of markerGroups\"\r\n      [latitude]=\"markers[0].latitude\"\r\n      [longitude]=\"markers[0].longitude\"\r\n      [draggable]=\"markers[0].draggable\"\r\n      (markerClick)=\"showInfoWindow(snazzyGroupProviderWindow)\"\r\n    >\r\n      <div class=\"marker\">\r\n        <vnext-widget-map-pin\r\n          [isMap]=\"true\"\r\n          [isPrimary]=\"providerFacade.hasPrimaryCareProviderMarker(markers)\"\r\n          [customClass]=\"providerFacade.getGroupProviderPinClass(markers)\"\r\n          [backgroundStyle]=\"providerFacade.getPrimaryGroupProviderBackgroundColor(markers)\"\r\n          [primaryIconAriaLabelText]=\"primaryIconAriaLabelText\"\r\n        >\r\n        </vnext-widget-map-pin>\r\n      </div>\r\n      <agm-snazzy-info-window\r\n        #snazzyGroupProviderWindow\r\n        [latitude]=\"markers[0].latitude\"\r\n        [longitude]=\"markers[0].longitude\"\r\n        [closeWhenOthersOpen]=\"true\"\r\n        [showCloseButton]=\"true\"\r\n        [closeOnMapClick]=\"true\"\r\n        [shadow]=\"true\"\r\n        [wrapperClass]=\"!isHelpfulToolsView ? 'pharmacy-map-usergroup-info' : 'pharmacy-map-usergroup-helpfultools-info'\"\r\n      >\r\n        <ng-template>\r\n          <div class=\"row\">\r\n            <div class=\"d-flex flex-row w-100 pt-2 pl-2\" *ngFor=\"let marker of markers\">\r\n              <div [ngClass]=\"!isHelpfulToolsView ? 'col-2' : 'col-3'\">\r\n                <vnext-widget-map-pin\r\n                  [index]=\"marker.label\"\r\n                  [isMap]=\"true\"\r\n                  [isPrimary]=\"providerFacade.isPcp(marker)\"\r\n                  [customClass]=\"providerFacade.getProviderPinClass(marker, true)\"\r\n                  [backgroundStyle]=\"providerFacade.getPrimaryProviderBackgroundColor(marker)\"\r\n                  [alternateViewClass]=\"providerFacade.noticeAlternateViewForMarker(marker)\"\r\n                  [alternateNumberIndicatorClass]=\"providerFacade.noticeAlternateIndicatorForMarker(marker)\"\r\n                  [primaryIconAriaLabelText]=\"primaryIconAriaLabelText\"\r\n                >\r\n                </vnext-widget-map-pin>\r\n              </div>\r\n              <div [ngClass]=\"!isHelpfulToolsView ? 'col-6' : 'col-8'\">\r\n                <div>\r\n                  <div class=\"user-group-info Spa_Style_Paragraph no-translate-block\">\r\n                    {{ marker.name | titlecase }}\r\n                  </div>\r\n                </div>\r\n                <div\r\n                  class=\"p-0 provider-selected\"\r\n                  *ngIf=\"\r\n                    !isHelpfulToolsView &&\r\n                    providerSingleSelectEnabled &&\r\n                    isProviderCountWithinLimits &&\r\n                    providerFacade.selectedProviderIds[marker.id]\r\n                  \"\r\n                >\r\n                  {{ providerExistsTooltipText }}\r\n                </div>\r\n              </div>\r\n              <div class=\"col-4\" *ngIf=\"!isHelpfulToolsView\">\r\n                <ng-container *ngIf=\"providerFacade.isProviderAdded(marker.id, marker.addressId); else showAddSection\">\r\n                  <vnext-link\r\n                    [title]=\"groupAddedLabel\"\r\n                    [customClass]=\"'Spa_Style_Link Spa_Style_Gray4_Color'\"\r\n                    [makeInlineBlock]=\"true\"\r\n                    [noUnderlineOnHover]=\"true\"\r\n                    [alwaysUnderlined]=\"false\"\r\n                  >\r\n                  </vnext-link>\r\n                </ng-container>\r\n                <ng-template #showAddSection>\r\n                  <ng-container\r\n                    *ngIf=\"\r\n                      isProviderCountWithinLimits && (!providerFacade.selectedProviderIds[marker.id] || !providerSingleSelectEnabled);\r\n                      else showSelectedProviderMessage\r\n                    \"\r\n                  >\r\n                    <vnext-link\r\n                      [title]=\"groupAddText\"\r\n                      (click)=\"addSelectedProvider(marker)\"\r\n                      (keyup.enter)=\"addSelectedProvider(marker)\"\r\n                      [makeInlineBlock]=\"true\"\r\n                      [alwaysUnderlined]=\"true\"\r\n                    ></vnext-link>\r\n                  </ng-container>\r\n\r\n                  <ng-template #showSelectedProviderMessage>\r\n                    <ng-container\r\n                      *ngIf=\"\r\n                        isProvider && isProviderCountWithinLimits && providerFacade.selectedProviderIds[marker.id];\r\n                        else showLimitMessage\r\n                      \"\r\n                    >\r\n                      <vnext-link\r\n                        [title]=\"groupAddText\"\r\n                        [customClass]=\"'Spa_Style_Link Spa_Style_Gray4_Color'\"\r\n                        [makeInlineBlock]=\"true\"\r\n                        [noUnderlineOnHover]=\"true\"\r\n                        [alwaysUnderlined]=\"false\"\r\n                      >\r\n                      </vnext-link>\r\n                    </ng-container>\r\n                  </ng-template>\r\n                  <ng-template #showLimitMessage>\r\n                    <vnext-link\r\n                      [ngbTooltip]=\"limitErrorMessage\"\r\n                      placement=\"top\"\r\n                      triggers=\"manual\"\r\n                      container=\"body\"\r\n                      autoClose=\"true\"\r\n                      #limitErrorTooltip=\"ngbTooltip\"\r\n                      (mouseleave)=\"limitErrorTooltip.close()\"\r\n                      (click)=\"limitErrorTooltip.open()\"\r\n                      [title]=\"groupAddText\"\r\n                    >\r\n                    </vnext-link>\r\n                  </ng-template>\r\n                  <span class=\"sr-only no-translate-block\">{{ marker.name }} </span>\r\n                </ng-template>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n      </agm-snazzy-info-window>\r\n    </agm-overlay>\r\n  </div>\r\n</agm-map>\r\n", styles: ["agm-map{height:455px}.marker{position:relative;text-align:center}.marker i{font-size:28px}.marker:hover{cursor:pointer}.marker span{position:absolute;left:0;top:11%;width:100%}.map-info-header{padding:6px 10px}.map-info-address{padding:6px 10px 0}.map-info-header-content{padding:0}.user-group-info{padding:2px 0 0}.marker-address{width:88%;float:left}.electronic-prescribing-icon{position:absolute;right:5px}.marker-address-wrapper{float:left;width:85%;padding-bottom:10px}.electronic-prescribing-icon-wrapper{float:right}.pharmacy-border-color{border-color:var(--static-Spa_Style_Accent1)}.provider-selected{font-size:12px;font-family:montserratregular}@media only screen and (max-width: 991.9px){agm-map{height:265px}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: PharmacyFacade }, { type: ProviderFacade }, { type: MapFacade }, { type: MapContextService }, { type: i0.ElementRef }, { type: i2.Store }]; }, { zoom: [{
            type: Input
        }], maxZoom: [{
            type: Input
        }], minZoom: [{
            type: Input
        }], isHelpfulToolsView: [{
            type: Input
        }], isProvider: [{
            type: Input
        }], zip: [{
            type: Input
        }], addedLabel: [{
            type: Input
        }], addButtonText: [{
            type: Input
        }], markers: [{
            type: Input
        }], limitErrorMessage: [{
            type: Input
        }], markerGroups: [{
            type: Input
        }], groupAddedLabel: [{
            type: Input
        }], groupAddText: [{
            type: Input
        }], providerExistsTooltipText: [{
            type: Input
        }], providerSingleSelectEnabled: [{
            type: Input
        }], primaryIconAriaLabelText: [{
            type: Input
        }], setZoom: [{
            type: Output
        }], resetToDefaultPageIndex: [{
            type: Output
        }], setMapCenter: [{
            type: Output
        }], setMap: [{
            type: Output
        }], setMapDefaultBounds: [{
            type: Output
        }], addSelectedItem: [{
            type: Output
        }] }); })();

function SelectedProviderComponent_div_0_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.yourProviderText);
} }
function SelectedProviderComponent_div_0_div_3_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelement(1, "i", 22);
    i0.ɵɵelementStart(2, "span", 23);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "phone");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const selectedProvider_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(4, 1, selectedProvider_r3.phoneNumber, ctx_r4.countryCode));
} }
function SelectedProviderComponent_div_0_div_3_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "titlecase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const selectedProvider_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, selectedProvider_r3.address2));
} }
function SelectedProviderComponent_div_0_div_3_div_22_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 26);
    i0.ɵɵlistener("click", function SelectedProviderComponent_div_0_div_3_div_22_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const selectedProvider_r3 = i0.ɵɵnextContext(2).$implicit; const ctx_r14 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r14.editProvider.emit(selectedProvider_r3)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(4);
    i0.ɵɵattribute("aria-label", ctx_r13.editLinkText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.editLinkText, " ");
} }
function SelectedProviderComponent_div_0_div_3_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, SelectedProviderComponent_div_0_div_3_div_22_button_1_Template, 2, 2, "button", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const selectedProvider_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", selectedProvider_r3 == null ? null : selectedProvider_r3.addresses == null ? null : selectedProvider_r3.addresses.length);
} }
function SelectedProviderComponent_div_0_div_3_div_23_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 30);
    i0.ɵɵelement(2, "i", 31);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 32)(5, "i");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const selectedProvider_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("", ctx_r18.iconClass, " provider-primary-icon-size mr-1");
    i0.ɵɵproperty("ngStyle", ctx_r18.backgroundStyleColor);
    i0.ɵɵattribute("aria-label", ctx_r18.primaryCareProviderText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r18.primaryCareProviderText, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate((selectedProvider_r3 == null ? null : selectedProvider_r3.isNewPatient) ? ctx_r18.newPatientText : ctx_r18.existingPatientText);
} }
function SelectedProviderComponent_div_0_div_3_div_23_ng_template_2_vnext_link_0_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 34);
    i0.ɵɵlistener("click", function SelectedProviderComponent_div_0_div_3_div_23_ng_template_2_vnext_link_0_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r25); const selectedProvider_r3 = i0.ɵɵnextContext(3).$implicit; const ctx_r23 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r23.setAsPrimaryCareProvider.emit(selectedProvider_r3)); })("keyup.Enter", function SelectedProviderComponent_div_0_div_3_div_23_ng_template_2_vnext_link_0_Template_vnext_link_keyup_Enter_0_listener() { i0.ɵɵrestoreView(_r25); const selectedProvider_r3 = i0.ɵɵnextContext(3).$implicit; const ctx_r26 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r26.setAsPrimaryCareProvider.emit(selectedProvider_r3)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("title", ctx_r22.setPrimaryCareProviderText)("alwaysUnderlined", true)("makeInlineBlock", true)("isLinkButton", true);
} }
function SelectedProviderComponent_div_0_div_3_div_23_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SelectedProviderComponent_div_0_div_3_div_23_ng_template_2_vnext_link_0_Template, 1, 4, "vnext-link", 33);
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngIf", !ctx_r20.selectedProviderOptionsEnabled);
} }
function SelectedProviderComponent_div_0_div_3_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtemplate(1, SelectedProviderComponent_div_0_div_3_div_23_ng_container_1_Template, 7, 7, "ng-container", 28);
    i0.ɵɵtemplate(2, SelectedProviderComponent_div_0_div_3_div_23_ng_template_2_Template, 1, 1, "ng-template", null, 29, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r19 = i0.ɵɵreference(3);
    const selectedProvider_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r7.showEditLinkEnabled && (ctx_r7.providerSingleSelectEnabled || ctx_r7.singleProviderInListEnabled) ? "col-md-3" : "col-md-4");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", selectedProvider_r3.isPrimary)("ngIfElse", _r19);
} }
function SelectedProviderComponent_div_0_div_3_div_24_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35)(1, "div", 36)(2, "button", 37);
    i0.ɵɵlistener("click", function SelectedProviderComponent_div_0_div_3_div_24_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r31); const selectedProvider_r3 = i0.ɵɵnextContext().$implicit; const ctx_r29 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r29.editProvider.emit(selectedProvider_r3)); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 26);
    i0.ɵɵlistener("click", function SelectedProviderComponent_div_0_div_3_div_24_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r31); const selectedProvider_r3 = i0.ɵɵnextContext().$implicit; const ctx_r32 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r32.removeProvider.emit(selectedProvider_r3)); });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", ctx_r8.editLinkText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.editLinkText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", ctx_r8.editLinkText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.removeText, " ");
} }
function SelectedProviderComponent_div_0_div_3_ng_template_25_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 38)(1, "div", 39);
    i0.ɵɵlistener("click", function SelectedProviderComponent_div_0_div_3_ng_template_25_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r36); const selectedProvider_r3 = i0.ɵɵnextContext().$implicit; const ctx_r34 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r34.removeProvider.emit(selectedProvider_r3)); })("keyup.enter", function SelectedProviderComponent_div_0_div_3_ng_template_25_Template_div_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r36); const selectedProvider_r3 = i0.ɵɵnextContext().$implicit; const ctx_r37 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r37.removeProvider.emit(selectedProvider_r3)); });
    i0.ɵɵelement(2, "i", 40);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", ctx_r10.removeProviderText);
} }
function SelectedProviderComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "div", 7)(3, "div", 8)(4, "div", 9)(5, "div", 7)(6, "div", 10)(7, "h3", 11);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 12)(11, "i");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(13, SelectedProviderComponent_div_0_div_3_div_13_Template, 5, 4, "div", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 14)(15, "div", 15);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, SelectedProviderComponent_div_0_div_3_div_18_Template, 3, 3, "div", 16);
    i0.ɵɵelementStart(19, "div", 15);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "titlecase");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(22, SelectedProviderComponent_div_0_div_3_div_22_Template, 2, 1, "div", 17);
    i0.ɵɵtemplate(23, SelectedProviderComponent_div_0_div_3_div_23_Template, 4, 3, "div", 18);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(24, SelectedProviderComponent_div_0_div_3_div_24_Template, 6, 4, "div", 19);
    i0.ɵɵtemplate(25, SelectedProviderComponent_div_0_div_3_ng_template_25_Template, 3, 1, "ng-template", null, 20, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const selectedProvider_r3 = ctx.$implicit;
    const _r9 = i0.ɵɵreference(26);
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r2.selectedProviderOptionsEnabled ? "col-12" : "col-10 col-md-11");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 13, selectedProvider_r3.displayName));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(selectedProvider_r3.specialtyDisplayName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.countryCode && selectedProvider_r3.phoneNumber);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 15, selectedProvider_r3.address1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", selectedProvider_r3.address2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3(" ", i0.ɵɵpipeBind1(21, 17, selectedProvider_r3.city), ", ", selectedProvider_r3.state, " ", selectedProvider_r3.zip, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.showEditLinkEnabled && !ctx_r2.selectedProviderOptionsEnabled && (ctx_r2.providerSingleSelectEnabled || ctx_r2.singleProviderInListEnabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", selectedProvider_r3.isIndividual);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.selectedProviderOptionsEnabled)("ngIfElse", _r9);
} }
function SelectedProviderComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "h2", 2);
    i0.ɵɵtemplate(2, SelectedProviderComponent_div_0_span_2_Template, 2, 1, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SelectedProviderComponent_div_0_div_3_Template, 27, 19, "div", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Provider_YourProvider_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.selectedProviders);
} }
class SelectedProviderComponent {
    constructor() {
        this.removeProvider = new EventEmitter();
        this.setAsPrimaryCareProvider = new EventEmitter();
        this.editProvider = new EventEmitter();
    }
}
SelectedProviderComponent.ɵfac = function SelectedProviderComponent_Factory(t) { return new (t || SelectedProviderComponent)(); };
SelectedProviderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectedProviderComponent, selectors: [["vnext-widget-selected-provider"]], inputs: { selectedProviders: "selectedProviders", yourProviderText: "yourProviderText", removeProviderText: "removeProviderText", setPrimaryCareProviderText: "setPrimaryCareProviderText", primaryCareProviderText: "primaryCareProviderText", backgroundStyleColor: "backgroundStyleColor", iconClass: "iconClass", countryCode: "countryCode", editLinkText: "editLinkText", showEditLinkEnabled: "showEditLinkEnabled", providerSingleSelectEnabled: "providerSingleSelectEnabled", singleProviderInListEnabled: "singleProviderInListEnabled", newPatientText: "newPatientText", existingPatientText: "existingPatientText", selectedProviderOptionsEnabled: "selectedProviderOptionsEnabled", removeText: "removeText" }, outputs: { removeProvider: "removeProvider", setAsPrimaryCareProvider: "setAsPrimaryCareProvider", editProvider: "editProvider" }, decls: 1, vars: 1, consts: [["class", "mt-3 mt-md-5", 4, "ngIf"], [1, "mt-3", "mt-md-5"], [1, "Spa_Style_H2"], [4, "liveEditProp"], ["class", "mt-1", 4, "ngFor", "ngForOf"], [1, "mt-1"], [1, "selected-provider", "px-3", "py-3"], [1, "row"], [3, "ngClass"], [1, "p-0"], [1, "col-12", "col-md-4", "no-translate-block"], [1, "Spa_Style_H4"], [1, "Spa_Style_Note"], ["class", "Spa_Style_Note mb-1", 4, "ngIf"], [1, "col-10", "col-md-3", "pr-0", "pl-4", "no-translate-block"], [1, "Spa_Style_Paragraph"], ["class", "Spa_Style_Paragraph", 4, "ngIf"], ["class", "col-2 pr-0 pl-4", 4, "ngIf"], ["class", "col-12 pr-0 pt-2 pt-md-0", 3, "ngClass", 4, "ngIf"], ["class", "col-12", 4, "ngIf", "ngIfElse"], ["defaultRemoveButton", ""], [1, "Spa_Style_Note", "mb-1"], [1, "accent1-static", "fas", "fa-phone"], [1, "pl-1"], [1, "col-2", "pr-0", "pl-4"], ["class", "Spa_Style_Link action-button", "tabindex", "0", 3, "click", 4, "ngIf"], ["tabindex", "0", 1, "Spa_Style_Link", "action-button", 3, "click"], [1, "col-12", "pr-0", "pt-2", "pt-md-0", 3, "ngClass"], [4, "ngIf", "ngIfElse"], ["showSetPcpLink", ""], [1, "Spa_Style_Paragraph", "pt-2"], ["role", "img", 3, "ngStyle"], [1, "Spa_Style_Note", "pt-2"], [3, "title", "alwaysUnderlined", "makeInlineBlock", "isLinkButton", "click", "keyup.Enter", 4, "ngIf"], [3, "title", "alwaysUnderlined", "makeInlineBlock", "isLinkButton", "click", "keyup.Enter"], [1, "col-12"], [1, "float-right"], ["tabindex", "0", 1, "Spa_Style_Link", "action-button", "pr-2", 3, "click"], [1, "col-2", "col-md-1"], ["tabindex", "0", "role", "button", 1, "provider-tile-remove", 3, "click", "keyup.enter"], [1, "fas", "fa-times"]], template: function SelectedProviderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SelectedProviderComponent_div_0_Template, 4, 2, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.selectedProviders && ctx.selectedProviders.length);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgStyle, LinkComponent, LiveEditPropDirective, IconAriaAttributesDirective, i1$2.TitleCasePipe, PhonePipe], styles: [".provider-tile-remove[_ngcontent-%COMP%]{font-size:14px;float:right;display:flex;align-items:center;cursor:pointer;width:17px;height:17px;padding:3px}.provider-tile-remove[_ngcontent-%COMP%]:focus{border-radius:12px}.selected-provider[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px;margin:8px 0;width:100%}.provider-primary-icon-size[_ngcontent-%COMP%]{font-size:16px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectedProviderComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-selected-provider', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"mt-3 mt-md-5\" *ngIf=\"selectedProviders && selectedProviders.length\">\r\n  <h2 class=\"Spa_Style_H2\">\r\n    <span *liveEditProp=\"'Spa_Provider_YourProvider_Text'\">{{ yourProviderText }}</span>\r\n  </h2>\r\n  <div class=\"mt-1\" *ngFor=\"let selectedProvider of selectedProviders\">\r\n    <div class=\"selected-provider px-3 py-3\">\r\n      <div class=\"row\">\r\n        <div [ngClass]=\"selectedProviderOptionsEnabled ? 'col-12' : 'col-10 col-md-11'\">\r\n          <div class=\"p-0\">\r\n            <div class=\"row\">\r\n              <div class=\"col-12 col-md-4 no-translate-block\">\r\n                <h3 class=\"Spa_Style_H4\">{{ selectedProvider.displayName | titlecase }}</h3>\r\n                <div class=\"Spa_Style_Note\">\r\n                  <i>{{ selectedProvider.specialtyDisplayName }}</i>\r\n                </div>\r\n                <div class=\"Spa_Style_Note mb-1\" *ngIf=\"countryCode && selectedProvider.phoneNumber\">\r\n                  <i class=\"accent1-static fas fa-phone\"></i\r\n                  ><span class=\"pl-1\">{{ selectedProvider.phoneNumber | phone : countryCode }}</span>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-10 col-md-3 pr-0 pl-4 no-translate-block\">\r\n                <div class=\"Spa_Style_Paragraph\">{{ selectedProvider.address1 | titlecase }}</div>\r\n                <div *ngIf=\"selectedProvider.address2\" class=\"Spa_Style_Paragraph\">{{ selectedProvider.address2 | titlecase }}</div>\r\n                <div class=\"Spa_Style_Paragraph\">\r\n                  {{ selectedProvider.city | titlecase }}, {{ selectedProvider.state }} {{ selectedProvider.zip }}\r\n                </div>\r\n              </div>\r\n              <div\r\n                class=\"col-2 pr-0 pl-4\"\r\n                *ngIf=\"\r\n                  showEditLinkEnabled && !selectedProviderOptionsEnabled && (providerSingleSelectEnabled || singleProviderInListEnabled)\r\n                \"\r\n              >\r\n                <button\r\n                  class=\"Spa_Style_Link action-button\"\r\n                  tabindex=\"0\"\r\n                  (click)=\"editProvider.emit(selectedProvider)\"\r\n                  [attr.aria-label]=\"editLinkText\"\r\n                  *ngIf=\"selectedProvider?.addresses?.length\"\r\n                >\r\n                  {{ editLinkText }}\r\n                </button>\r\n              </div>\r\n              <div\r\n                class=\"col-12 pr-0 pt-2 pt-md-0\"\r\n                *ngIf=\"selectedProvider.isIndividual\"\r\n                [ngClass]=\"showEditLinkEnabled && (providerSingleSelectEnabled || singleProviderInListEnabled) ? 'col-md-3' : 'col-md-4'\"\r\n              >\r\n                <ng-container *ngIf=\"selectedProvider.isPrimary; else showSetPcpLink\">\r\n                  <div class=\"Spa_Style_Paragraph pt-2\">\r\n                    <i\r\n                      class=\"{{ iconClass }} provider-primary-icon-size mr-1\"\r\n                      role=\"img\"\r\n                      [attr.aria-label]=\"primaryCareProviderText\"\r\n                      [ngStyle]=\"backgroundStyleColor\"\r\n                    ></i\r\n                    >{{ primaryCareProviderText }}\r\n                  </div>\r\n                  <div class=\"Spa_Style_Note pt-2\">\r\n                    <i>{{ selectedProvider?.isNewPatient ? newPatientText : existingPatientText }}</i>\r\n                  </div>\r\n                </ng-container>\r\n                <ng-template #showSetPcpLink>\r\n                  <vnext-link\r\n                    *ngIf=\"!selectedProviderOptionsEnabled\"\r\n                    [title]=\"setPrimaryCareProviderText\"\r\n                    [alwaysUnderlined]=\"true\"\r\n                    [makeInlineBlock]=\"true\"\r\n                    (click)=\"setAsPrimaryCareProvider.emit(selectedProvider)\"\r\n                    (keyup.Enter)=\"setAsPrimaryCareProvider.emit(selectedProvider)\"\r\n                    [isLinkButton]=\"true\"\r\n                  >\r\n                  </vnext-link>\r\n                </ng-template>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div *ngIf=\"selectedProviderOptionsEnabled; else defaultRemoveButton\" class=\"col-12\">\r\n          <div class=\"float-right\">\r\n            <button\r\n              class=\"Spa_Style_Link action-button pr-2\"\r\n              tabindex=\"0\"\r\n              (click)=\"editProvider.emit(selectedProvider)\"\r\n              [attr.aria-label]=\"editLinkText\"\r\n            >\r\n              {{ editLinkText }}\r\n            </button>\r\n            <button\r\n              class=\"Spa_Style_Link action-button\"\r\n              tabindex=\"0\"\r\n              (click)=\"removeProvider.emit(selectedProvider)\"\r\n              [attr.aria-label]=\"editLinkText\"\r\n            >\r\n              {{ removeText }}\r\n            </button>\r\n          </div>\r\n        </div>\r\n        <ng-template #defaultRemoveButton>\r\n          <div class=\"col-2 col-md-1\">\r\n            <div\r\n              class=\"provider-tile-remove\"\r\n              tabindex=\"0\"\r\n              [attr.aria-label]=\"removeProviderText\"\r\n              role=\"button\"\r\n              (click)=\"removeProvider.emit(selectedProvider)\"\r\n              (keyup.enter)=\"removeProvider.emit(selectedProvider)\"\r\n            >\r\n              <i class=\"fas fa-times\"></i>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".provider-tile-remove{font-size:14px;float:right;display:flex;align-items:center;cursor:pointer;width:17px;height:17px;padding:3px}.provider-tile-remove:focus{border-radius:12px}.selected-provider{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px;margin:8px 0;width:100%}.provider-primary-icon-size{font-size:16px}\n"] }]
    }], null, { selectedProviders: [{
            type: Input
        }], yourProviderText: [{
            type: Input
        }], removeProviderText: [{
            type: Input
        }], setPrimaryCareProviderText: [{
            type: Input
        }], primaryCareProviderText: [{
            type: Input
        }], backgroundStyleColor: [{
            type: Input
        }], iconClass: [{
            type: Input
        }], countryCode: [{
            type: Input
        }], editLinkText: [{
            type: Input
        }], showEditLinkEnabled: [{
            type: Input
        }], providerSingleSelectEnabled: [{
            type: Input
        }], singleProviderInListEnabled: [{
            type: Input
        }], newPatientText: [{
            type: Input
        }], existingPatientText: [{
            type: Input
        }], selectedProviderOptionsEnabled: [{
            type: Input
        }], removeText: [{
            type: Input
        }], removeProvider: [{
            type: Output
        }], setAsPrimaryCareProvider: [{
            type: Output
        }], editProvider: [{
            type: Output
        }] }); })();

function GeneralPracticeToggleComponent_div_0_span_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r3.generalPracticeToolTipText, "html"), i0.ɵɵsanitizeHtml);
} }
function GeneralPracticeToggleComponent_div_0_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtemplate(1, GeneralPracticeToggleComponent_div_0_span_3_ng_template_1_Template, 2, 4, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "i", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r2 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbTooltip", _r2);
} }
function GeneralPracticeToggleComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "label", 2);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, GeneralPracticeToggleComponent_div_0_span_3_Template, 4, 1, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "vnext-toggle-select", 4);
    i0.ɵɵlistener("optionSelected", function GeneralPracticeToggleComponent_div_0_Template_vnext_toggle_select_optionSelected_4_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.onGeneralPracticeSelect($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.generalPracticeLabel, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.generalPracticeToolTipText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("items", ctx_r0.generalPracticeOptions)("selectedValue", ctx_r0.selectedGeneralPracticeOption)("buttonHeight", "36px")("ariaLabelledById", "general-practice-toggle-label")("toggleControlId", "general-practice-toggle-select");
} }
class GeneralPracticeToggleComponent {
    constructor() {
        this.generalPracticeOptions = [];
        this.selectedGeneralPracticeOption = false;
        this.optionSelected = new EventEmitter();
    }
    onGeneralPracticeSelect($event) {
        this.optionSelected.emit(!!$event?.data?.value);
    }
}
GeneralPracticeToggleComponent.ɵfac = function GeneralPracticeToggleComponent_Factory(t) { return new (t || GeneralPracticeToggleComponent)(); };
GeneralPracticeToggleComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GeneralPracticeToggleComponent, selectors: [["vnext-widget-general-practice-toggle"]], inputs: { generalPracticeOptions: "generalPracticeOptions", generalPracticeToolTipText: "generalPracticeToolTipText", generalPracticeLabel: "generalPracticeLabel", generalPracticeFilterOptionEnabled: "generalPracticeFilterOptionEnabled", selectedGeneralPracticeOption: "selectedGeneralPracticeOption" }, outputs: { optionSelected: "optionSelected" }, decls: 1, vars: 1, consts: [["class", "gp-toggle-select mr-1", 4, "ngIf"], [1, "gp-toggle-select", "mr-1"], ["for", "general-practice-toggle-select", "id", "general-practice-toggle-label", 1, "Spa_Style_Label", "w-100"], ["class", "pl-1", 4, "ngIf"], [3, "items", "selectedValue", "buttonHeight", "ariaLabelledById", "toggleControlId", "optionSelected"], [1, "pl-1"], ["generalPracticeTooltip", ""], ["tabindex", "0", "aria-labelledby", "generalPracticeTooltipId", "aria-label", "Show tooltip", 1, "fas", "Spa_Style_QuestionIcon", 3, "ngbTooltip"], ["id", "generalPracticeTooltipId", "navigationAdapter", "", 1, "Spa_Style_ToolTip", 3, "innerHtml"]], template: function GeneralPracticeToggleComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, GeneralPracticeToggleComponent_div_0_Template, 5, 7, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.generalPracticeFilterOptionEnabled);
    } }, dependencies: [i1$2.NgIf, ToggleSelectComponent, NavigationAdapterDirective, i1$1.NgbTooltip, SafePipe], styles: [".gp-toggle-select[_ngcontent-%COMP%]{min-width:160px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GeneralPracticeToggleComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-general-practice-toggle', template: "<div class=\"gp-toggle-select mr-1\" *ngIf=\"generalPracticeFilterOptionEnabled\">\r\n  <label for=\"general-practice-toggle-select\" class=\"Spa_Style_Label w-100\" id=\"general-practice-toggle-label\">\r\n    {{ generalPracticeLabel }}\r\n    <span class=\"pl-1\" *ngIf=\"generalPracticeToolTipText\">\r\n      <ng-template #generalPracticeTooltip>\r\n        <div\r\n          id=\"generalPracticeTooltipId\"\r\n          [innerHtml]=\"generalPracticeToolTipText | safe : 'html'\"\r\n          class=\"Spa_Style_ToolTip\"\r\n          navigationAdapter\r\n        ></div>\r\n      </ng-template>\r\n      <i\r\n        class=\"fas Spa_Style_QuestionIcon\"\r\n        tabindex=\"0\"\r\n        aria-labelledby=\"generalPracticeTooltipId\"\r\n        [ngbTooltip]=\"generalPracticeTooltip\"\r\n        aria-label=\"Show tooltip\"\r\n      ></i>\r\n    </span>\r\n  </label>\r\n  <vnext-toggle-select\r\n    [items]=\"generalPracticeOptions\"\r\n    [selectedValue]=\"selectedGeneralPracticeOption\"\r\n    [buttonHeight]=\"'36px'\"\r\n    (optionSelected)=\"onGeneralPracticeSelect($event)\"\r\n    [ariaLabelledById]=\"'general-practice-toggle-label'\"\r\n    [toggleControlId]=\"'general-practice-toggle-select'\"\r\n  ></vnext-toggle-select>\r\n</div>\r\n", styles: [".gp-toggle-select{min-width:160px}\n"] }]
    }], null, { generalPracticeOptions: [{
            type: Input
        }], generalPracticeToolTipText: [{
            type: Input
        }], generalPracticeLabel: [{
            type: Input
        }], generalPracticeFilterOptionEnabled: [{
            type: Input
        }], selectedGeneralPracticeOption: [{
            type: Input
        }], optionSelected: [{
            type: Output
        }] }); })();

function ValueBasedProviderToggleComponent_div_0_span_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r3.valueBasedCareToggleToolTipText, "html"), i0.ɵɵsanitizeHtml);
} }
function ValueBasedProviderToggleComponent_div_0_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtemplate(1, ValueBasedProviderToggleComponent_div_0_span_3_ng_template_1_Template, 2, 4, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "i", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r2 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbTooltip", _r2);
} }
function ValueBasedProviderToggleComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "label", 2);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, ValueBasedProviderToggleComponent_div_0_span_3_Template, 4, 1, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "vnext-toggle-select", 4);
    i0.ɵɵlistener("optionSelected", function ValueBasedProviderToggleComponent_div_0_Template_vnext_toggle_select_optionSelected_4_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.onValueBaseCareToggleSelect($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.valueBasedCareToggleLabel, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.valueBasedCareToggleToolTipText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("items", ctx_r0.valueBasedCareToggleOptions)("selectedValue", ctx_r0.selectedValueBasedCareOption)("buttonHeight", "36px")("ariaLabelledById", "value-based-toggle-label")("toggleControlId", "value-based-search-toggle-select");
} }
class ValueBasedProviderToggleComponent {
    constructor() {
        this.valueBasedCareToggleOptions = [];
        this.selectedValueBasedToggleOption = false;
        this.optionSelected = new EventEmitter();
    }
    ngOnChanges(changes) {
        const { valueBasedCareToggleOptions, selectedValueBasedToggleOption } = changes;
        if ((!!this.valueBasedCareToggleOptions?.length &&
            valueBasedCareToggleOptions &&
            !_isEqual(valueBasedCareToggleOptions.previousValue, valueBasedCareToggleOptions.currentValue)) ||
            (selectedValueBasedToggleOption && selectedValueBasedToggleOption.previousValue !== selectedValueBasedToggleOption.currentValue)) {
            const firstValue = this.valueBasedCareToggleOptions?.[0]?.value;
            this.selectedValueBasedCareOption = this.selectedValueBasedToggleOption || (typeof firstValue === 'boolean' ? false : 'false');
        }
    }
    onValueBaseCareToggleSelect($event) {
        this.optionSelected.emit(typeof $event?.data?.value === 'boolean' ? $event.data.value : $event?.data?.value?.toLocaleLowerCase() === 'true');
    }
}
ValueBasedProviderToggleComponent.ɵfac = function ValueBasedProviderToggleComponent_Factory(t) { return new (t || ValueBasedProviderToggleComponent)(); };
ValueBasedProviderToggleComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ValueBasedProviderToggleComponent, selectors: [["vnext-widget-value-based-provider-toggle"]], inputs: { valueBasedCareToggleOptions: "valueBasedCareToggleOptions", valueBasedCareToggleToolTipText: "valueBasedCareToggleToolTipText", valueBasedCareToggleLabel: "valueBasedCareToggleLabel", valueBasedCareToggleEnabled: "valueBasedCareToggleEnabled", selectedValueBasedToggleOption: "selectedValueBasedToggleOption" }, outputs: { optionSelected: "optionSelected" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "value-based-toggle-select mr-1", 4, "ngIf"], [1, "value-based-toggle-select", "mr-1"], ["for", "value-based-search-toggle-select", "id", "value-based-toggle-label", 1, "Spa_Style_Label", "w-100"], ["class", "pl-1", 4, "ngIf"], [3, "items", "selectedValue", "buttonHeight", "ariaLabelledById", "toggleControlId", "optionSelected"], [1, "pl-1"], ["valueBasedCareToggleTooltip", ""], ["tabindex", "0", "aria-labelledby", "valueBasedCareToggleTooltipId", "aria-label", "Show tooltip", 1, "fas", "Spa_Style_QuestionIcon", 3, "ngbTooltip"], ["id", "valueBasedCareToggleTooltipId", "navigationAdapter", "", 1, "Spa_Style_ToolTip", 3, "innerHtml"]], template: function ValueBasedProviderToggleComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ValueBasedProviderToggleComponent_div_0_Template, 5, 7, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.valueBasedCareToggleEnabled);
    } }, dependencies: [i1$2.NgIf, ToggleSelectComponent, NavigationAdapterDirective, i1$1.NgbTooltip, SafePipe], styles: [".value-based-toggle-select[_ngcontent-%COMP%]{min-width:160px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ValueBasedProviderToggleComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-value-based-provider-toggle', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"valueBasedCareToggleEnabled\" class=\"value-based-toggle-select mr-1\">\r\n  <label for=\"value-based-search-toggle-select\" class=\"Spa_Style_Label w-100\" id=\"value-based-toggle-label\">\r\n    {{ valueBasedCareToggleLabel }}\r\n    <span *ngIf=\"valueBasedCareToggleToolTipText\" class=\"pl-1\">\r\n      <ng-template #valueBasedCareToggleTooltip>\r\n        <div\r\n          id=\"valueBasedCareToggleTooltipId\"\r\n          [innerHtml]=\"valueBasedCareToggleToolTipText | safe : 'html'\"\r\n          class=\"Spa_Style_ToolTip\"\r\n          navigationAdapter\r\n        ></div>\r\n      </ng-template>\r\n      <i\r\n        class=\"fas Spa_Style_QuestionIcon\"\r\n        tabindex=\"0\"\r\n        aria-labelledby=\"valueBasedCareToggleTooltipId\"\r\n        [ngbTooltip]=\"valueBasedCareToggleTooltip\"\r\n        aria-label=\"Show tooltip\"\r\n      ></i>\r\n    </span>\r\n  </label>\r\n  <vnext-toggle-select\r\n    [items]=\"valueBasedCareToggleOptions\"\r\n    [selectedValue]=\"selectedValueBasedCareOption\"\r\n    [buttonHeight]=\"'36px'\"\r\n    (optionSelected)=\"onValueBaseCareToggleSelect($event)\"\r\n    [ariaLabelledById]=\"'value-based-toggle-label'\"\r\n    [toggleControlId]=\"'value-based-search-toggle-select'\"\r\n  ></vnext-toggle-select>\r\n</div>\r\n", styles: [".value-based-toggle-select{min-width:160px}\n"] }]
    }], null, { valueBasedCareToggleOptions: [{
            type: Input
        }], valueBasedCareToggleToolTipText: [{
            type: Input
        }], valueBasedCareToggleLabel: [{
            type: Input
        }], valueBasedCareToggleEnabled: [{
            type: Input
        }], selectedValueBasedToggleOption: [{
            type: Input
        }], optionSelected: [{
            type: Output
        }] }); })();

function ProviderToggleComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "label", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "vnext-toggle-select", 3);
    i0.ɵɵlistener("optionSelected", function ProviderToggleComponent_div_0_Template_vnext_toggle_select_optionSelected_3_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onToggleSelect($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.toggleLabel, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("items", ctx_r0.toggleOptions)("selectedValue", ctx_r0.selectedOption)("buttonHeight", "36px")("ariaLabelledById", "provider-toggle-label")("toggleControlId", "provider-toggle-select");
} }
class ProviderToggleComponent {
    constructor() {
        this.toggleOptions = [];
        this.optionSelected = new EventEmitter();
        this.selectedOption = 'no';
    }
    ngOnChanges(changes) {
        const { isDefaultSelected } = changes;
        if (isDefaultSelected && isDefaultSelected.previousValue !== isDefaultSelected.currentValue) {
            if (this.isDefaultSelected !== null) {
                this.selectedOption = this.isDefaultSelected;
            }
        }
    }
    onToggleSelect($event) {
        this.optionSelected.emit($event?.data?.value);
    }
}
ProviderToggleComponent.ɵfac = function ProviderToggleComponent_Factory(t) { return new (t || ProviderToggleComponent)(); };
ProviderToggleComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProviderToggleComponent, selectors: [["vnext-widget-provider-toggle"]], inputs: { toggleOptions: "toggleOptions", toggleLabel: "toggleLabel", isToggleEnabled: "isToggleEnabled", isDefaultSelected: "isDefaultSelected" }, outputs: { optionSelected: "optionSelected" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "provider-toggle-select mr-1", 4, "ngIf"], [1, "provider-toggle-select", "mr-1"], ["for", "provider-toggle-select", "id", "provider-toggle-label", 1, "Spa_Style_Label", "w-100"], [3, "items", "selectedValue", "buttonHeight", "ariaLabelledById", "toggleControlId", "optionSelected"]], template: function ProviderToggleComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ProviderToggleComponent_div_0_Template, 4, 6, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.isToggleEnabled && ctx.toggleOptions && ctx.toggleOptions.length > 0);
    } }, dependencies: [i1$2.NgIf, ToggleSelectComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProviderToggleComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-provider-toggle', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"isToggleEnabled && toggleOptions && toggleOptions.length > 0\" class=\"provider-toggle-select mr-1\">\r\n  <label for=\"provider-toggle-select\" class=\"Spa_Style_Label w-100\" id=\"provider-toggle-label\">\r\n    {{ toggleLabel }}\r\n  </label>\r\n  <vnext-toggle-select\r\n    [items]=\"toggleOptions\"\r\n    [selectedValue]=\"selectedOption\"\r\n    [buttonHeight]=\"'36px'\"\r\n    (optionSelected)=\"onToggleSelect($event)\"\r\n    [ariaLabelledById]=\"'provider-toggle-label'\"\r\n    [toggleControlId]=\"'provider-toggle-select'\"\r\n  ></vnext-toggle-select>\r\n</div>" }]
    }], null, { toggleOptions: [{
            type: Input
        }], toggleLabel: [{
            type: Input
        }], isToggleEnabled: [{
            type: Input
        }], isDefaultSelected: [{
            type: Input
        }], optionSelected: [{
            type: Output
        }] }); })();

function SingleProviderAddressSelectorComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1, 2);
    i0.ɵɵlistener("click", function SingleProviderAddressSelectorComponent_div_0_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const provider_r1 = restoredCtx.$implicit; const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.select(provider_r1)); })("keyup.enter", function SingleProviderAddressSelectorComponent_div_0_Template_div_keyup_enter_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const provider_r1 = restoredCtx.$implicit; const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.select(provider_r1)); });
    i0.ɵɵelementStart(2, "span", 3);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "titlecase");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const provider_r1 = ctx.$implicit;
    const index_r2 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", (ctx_r0.selectedProvider == null ? null : ctx_r0.selectedProvider.addressId) === provider_r1.addressId && (ctx_r0.selectedProvider == null ? null : ctx_r0.selectedProvider.id) === provider_r1.id ? "Spa_Style_SecondaryButtonSelected Spa_Style_Primary_Link_Border Spa_Style_Bold_Weight" : "Spa_Style_SecondaryButton Spa_Style_Regular_Weight");
    i0.ɵɵattribute("aria-checked", (ctx_r0.selectedProvider == null ? null : ctx_r0.selectedProvider.addressId) === provider_r1.addressId && (ctx_r0.selectedProvider == null ? null : ctx_r0.selectedProvider.id) === provider_r1.id ? "true" : "false")("aria-labelledby", "provider-" + index_r2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", "provider-" + index_r2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate5("", provider_r1 == null ? null : provider_r1.address1, "", provider_r1.address2 ? " " + provider_r1.address2 : "", " ", i0.ɵɵpipeBind1(4, 9, provider_r1.city), ", ", provider_r1.state, " ", provider_r1.zip, "");
} }
class SingleProviderAddressSelectorComponent {
    constructor() {
        this.providersList = [];
        this.selectProvider = new EventEmitter();
    }
    providerTrackBy(index, provider) {
        return provider.id;
    }
    select(provider) {
        this.selectProvider.emit({ provider });
    }
}
SingleProviderAddressSelectorComponent.ɵfac = function SingleProviderAddressSelectorComponent_Factory(t) { return new (t || SingleProviderAddressSelectorComponent)(); };
SingleProviderAddressSelectorComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SingleProviderAddressSelectorComponent, selectors: [["vnext-widget-single-provider-address-selector"]], inputs: { providersList: "providersList", selectedProvider: "selectedProvider" }, outputs: { selectProvider: "selectProvider" }, decls: 1, vars: 2, consts: [["class", "toggle-option no-translate-block", "role", "radio", "tabindex", "0", 3, "ngClass", "click", "keyup.enter", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["role", "radio", "tabindex", "0", 1, "toggle-option", "no-translate-block", 3, "ngClass", "click", "keyup.enter"], ["toggles", ""], [3, "id"]], template: function SingleProviderAddressSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SingleProviderAddressSelectorComponent_div_0_Template, 5, 11, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.providersList)("ngForTrackBy", ctx.providerTrackBy);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.TitleCasePipe], styles: [".toggle-option[_ngcontent-%COMP%]{align-items:left;justify-content:left;flex:1;border-width:1px;border-style:solid;padding:6px 15px;cursor:pointer}.toggle-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:focus{border-color:var(--static-Spa_Style_Primary_Link)}.toggle-option[_ngcontent-%COMP%]:first-of-type{border-top-left-radius:5px;border-top-right-radius:5px}.vertical[_ngcontent-%COMP%]   .toggle-option[_ngcontent-%COMP%]:last-of-type{border-bottom-left-radius:5px;border-bottom-right-radius:5px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SingleProviderAddressSelectorComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-single-provider-address-selector', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  *ngFor=\"let provider of providersList; index as index; trackBy: providerTrackBy\"\r\n  #toggles\r\n  class=\"toggle-option no-translate-block\"\r\n  (click)=\"select(provider)\"\r\n  [ngClass]=\"\r\n    selectedProvider?.addressId === provider.addressId && selectedProvider?.id === provider.id\r\n      ? 'Spa_Style_SecondaryButtonSelected Spa_Style_Primary_Link_Border Spa_Style_Bold_Weight'\r\n      : 'Spa_Style_SecondaryButton Spa_Style_Regular_Weight'\r\n  \"\r\n  role=\"radio\"\r\n  [attr.aria-checked]=\"selectedProvider?.addressId === provider.addressId && selectedProvider?.id === provider.id ? 'true' : 'false'\"\r\n  [attr.aria-labelledby]=\"'provider-' + index\"\r\n  (keyup.enter)=\"select(provider)\"\r\n  tabindex=\"0\"\r\n>\r\n  <span [id]=\"'provider-' + index\"\r\n    >{{ provider?.address1 }}{{ provider.address2 ? ' ' + provider.address2 : '' }} {{ provider.city | titlecase }}, {{ provider.state }}\r\n    {{ provider.zip }}</span\r\n  >\r\n</div>\r\n", styles: [".toggle-option{align-items:left;justify-content:left;flex:1;border-width:1px;border-style:solid;padding:6px 15px;cursor:pointer}.toggle-container>div:focus{border-color:var(--static-Spa_Style_Primary_Link)}.toggle-option:first-of-type{border-top-left-radius:5px;border-top-right-radius:5px}.vertical .toggle-option:last-of-type{border-bottom-left-radius:5px;border-bottom-right-radius:5px}\n"] }]
    }], null, { providersList: [{
            type: Input
        }], selectedProvider: [{
            type: Input
        }], selectProvider: [{
            type: Output
        }] }); })();

function MultipleProviderAddressSelectorComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1, 2);
    i0.ɵɵlistener("click", function MultipleProviderAddressSelectorComponent_div_0_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const providerOption_r1 = restoredCtx.$implicit; const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.selectMultipleProvider(providerOption_r1.provider)); })("keyup.enter", function MultipleProviderAddressSelectorComponent_div_0_Template_div_keyup_enter_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const providerOption_r1 = restoredCtx.$implicit; const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.selectMultipleProvider(providerOption_r1.provider)); });
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵelement(3, "input", 4);
    i0.ɵɵelementStart(4, "span", 5);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "titlecase");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const providerOption_r1 = ctx.$implicit;
    const index_r2 = ctx.index;
    i0.ɵɵproperty("ngClass", providerOption_r1.providerIsSelected ? "Spa_Style_SecondaryButtonSelected Spa_Style_Primary_Link_Border Spa_Style_Bold_Weight" : "Spa_Style_SecondaryButton Spa_Style_Regular_Weight");
    i0.ɵɵattribute("aria-labelledby", "provider-" + index_r2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("checked", providerOption_r1.providerIsSelected);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", "provider-" + index_r2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate5("", providerOption_r1 == null ? null : providerOption_r1.provider.address1, "", (providerOption_r1 == null ? null : providerOption_r1.provider.address2) ? " " + (providerOption_r1 == null ? null : providerOption_r1.provider.address2) : "", " ", i0.ɵɵpipeBind1(6, 9, providerOption_r1 == null ? null : providerOption_r1.provider.city), ", ", providerOption_r1 == null ? null : providerOption_r1.provider.state, " ", providerOption_r1 == null ? null : providerOption_r1.provider.zip, "");
} }
class MultipleProviderAddressSelectorComponent {
    constructor() {
        this.providersList = [];
        this.selectedMultipleProviders = [];
        this.selectProvider = new EventEmitter();
        this.providerMultiSelectOptions = [];
    }
    ngOnChanges(changes) {
        const { providersList, selectedMultipleProviders } = changes;
        if ((providersList && !_isEqual(providersList.previousValue, providersList.currentValue)) ||
            (selectedMultipleProviders && !_isEqual(selectedMultipleProviders.previousValue, selectedMultipleProviders.currentValue))) {
            if (this.providersList) {
                this.getProviderMultiSelectOptionsList();
            }
        }
    }
    getProviderMultiSelectOptionsList() {
        this.providerMultiSelectOptions = this.providersList.map(provider => {
            return {
                provider,
                providerIsSelected: this.providerIsSelected(provider.id, provider.addressId)
            };
        });
    }
    providerTrackBy(index, providerMultiSelectOption) {
        return providerMultiSelectOption.provider.addressId;
    }
    providerIsSelected(providerId, addressId) {
        return this.selectedMultipleProviders.some(provider => provider.id === providerId && provider.addressId === addressId);
    }
    selectMultipleProvider(provider) {
        if (this.providerIsSelected(provider.id, provider.addressId)) {
            const index = this.selectedMultipleProviders.findIndex(selectedMultipleProvider => selectedMultipleProvider.id === provider.id && selectedMultipleProvider.addressId === provider.addressId);
            this.selectedMultipleProviders.splice(index, 1);
        }
        else {
            this.selectedMultipleProviders.push(provider);
        }
        this.getProviderMultiSelectOptionsList();
        this.selectProvider.emit(true);
    }
}
MultipleProviderAddressSelectorComponent.ɵfac = function MultipleProviderAddressSelectorComponent_Factory(t) { return new (t || MultipleProviderAddressSelectorComponent)(); };
MultipleProviderAddressSelectorComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MultipleProviderAddressSelectorComponent, selectors: [["vnext-widget-multiple-provider-address-selector"]], inputs: { providersList: "providersList", selectedMultipleProviders: "selectedMultipleProviders" }, outputs: { selectProvider: "selectProvider" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 2, consts: [["class", "toggle-option can-click no-translate-block", "role", "checkbox", 3, "ngClass", "click", "keyup.enter", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["role", "checkbox", 1, "toggle-option", "can-click", "no-translate-block", 3, "ngClass", "click", "keyup.enter"], ["toggles", ""], [1, "multiselect-option"], ["type", "checkbox", 1, "checkbox", 3, "checked"], [1, "user-select-none", 3, "id"]], template: function MultipleProviderAddressSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MultipleProviderAddressSelectorComponent_div_0_Template, 7, 11, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.providerMultiSelectOptions)("ngForTrackBy", ctx.providerTrackBy);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.TitleCasePipe], styles: [".toggle-option[_ngcontent-%COMP%]{align-items:left;justify-content:left;flex:1;border-width:1px;border-style:solid;padding:6px 15px;cursor:pointer}.toggle-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:focus{border-color:var(--static-Spa_Style_Primary_Link)}.toggle-option[_ngcontent-%COMP%]:first-of-type{border-top-left-radius:5px;border-top-right-radius:5px}.toggle-option[_ngcontent-%COMP%]:last-of-type{border-bottom-left-radius:5px;border-bottom-right-radius:5px}.multiselect-option[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:left}.checkbox[_ngcontent-%COMP%]{min-width:16px;height:16px;margin-right:10px;cursor:pointer}.user-select-none[_ngcontent-%COMP%]{-webkit-user-select:none!important;user-select:none!important}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultipleProviderAddressSelectorComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-multiple-provider-address-selector', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  #toggles\r\n  *ngFor=\"let providerOption of providerMultiSelectOptions; index as index; trackBy: providerTrackBy\"\r\n  class=\"toggle-option can-click no-translate-block\"\r\n  role=\"checkbox\"\r\n  [attr.aria-labelledby]=\"'provider-' + index\"\r\n  [ngClass]=\"\r\n    providerOption.providerIsSelected\r\n      ? 'Spa_Style_SecondaryButtonSelected Spa_Style_Primary_Link_Border Spa_Style_Bold_Weight'\r\n      : 'Spa_Style_SecondaryButton Spa_Style_Regular_Weight'\r\n  \"\r\n  (click)=\"selectMultipleProvider(providerOption.provider)\"\r\n  (keyup.enter)=\"selectMultipleProvider(providerOption.provider)\"\r\n>\r\n  <div class=\"multiselect-option\">\r\n    <input type=\"checkbox\" class=\"checkbox\" [checked]=\"providerOption.providerIsSelected\" />\r\n    <span class=\"user-select-none\" [id]=\"'provider-' + index\"\r\n      >{{ providerOption?.provider.address1 }}{{ providerOption?.provider.address2 ? ' ' + providerOption?.provider.address2 : '' }}\r\n      {{ providerOption?.provider.city | titlecase }}, {{ providerOption?.provider.state }} {{ providerOption?.provider.zip }}</span\r\n    >\r\n  </div>\r\n</div>\r\n", styles: [".toggle-option{align-items:left;justify-content:left;flex:1;border-width:1px;border-style:solid;padding:6px 15px;cursor:pointer}.toggle-container>div:focus{border-color:var(--static-Spa_Style_Primary_Link)}.toggle-option:first-of-type{border-top-left-radius:5px;border-top-right-radius:5px}.toggle-option:last-of-type{border-bottom-left-radius:5px;border-bottom-right-radius:5px}.multiselect-option{display:flex;align-items:center;justify-content:left}.checkbox{min-width:16px;height:16px;margin-right:10px;cursor:pointer}.user-select-none{-webkit-user-select:none!important;user-select:none!important}\n"] }]
    }], null, { providersList: [{
            type: Input
        }], selectedMultipleProviders: [{
            type: Input
        }], selectProvider: [{
            type: Output
        }] }); })();

const _c0$1Y = ["multiAddressProviderList"];
function MultipleProviderAddressComponent_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 13)(2, "vnext-widget-provider-toggle", 14);
    i0.ɵɵlistener("optionSelected", function MultipleProviderAddressComponent_div_2_div_5_Template_vnext_widget_provider_toggle_optionSelected_2_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.onPcpToggleSelect($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "div", 13)(4, "vnext-widget-provider-toggle", 14);
    i0.ɵɵlistener("optionSelected", function MultipleProviderAddressComponent_div_2_div_5_Template_vnext_widget_provider_toggle_optionSelected_4_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r9.onNewPatientToggleSelect($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("isToggleEnabled", true)("toggleLabel", ctx_r2.pcpToggleLabel)("isDefaultSelected", (ctx_r2.selectedProvider == null ? null : ctx_r2.selectedProvider.isPrimary) ? ctx_r2.primaryCareProviderToggleValues.YES : ctx_r2.primaryCareProviderToggleValues.NO)("toggleOptions", ctx_r2.pcpToggleOptions);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("isToggleEnabled", ctx_r2.newPatientToggleEnabled && ctx_r2.selectedPcpToggleOption)("toggleLabel", ctx_r2.newPatientToggleLabel)("isDefaultSelected", (ctx_r2.selectedProvider == null ? null : ctx_r2.selectedProvider.isNewPatient) ? ctx_r2.newPatientToggleValues.YES : ctx_r2.newPatientToggleValues.NO)("toggleOptions", ctx_r2.newPatientToggleOptions);
} }
function MultipleProviderAddressComponent_div_2_ng_container_6_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-widget-single-provider-address-selector", 19);
    i0.ɵɵlistener("selectProvider", function MultipleProviderAddressComponent_div_2_ng_container_6_ng_container_9_Template_vnext_widget_single_provider_address_selector_selectProvider_1_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r13.selectProvider($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("providersList", ctx_r10.sameProvidersList)("selectedProvider", ctx_r10.selectedProvider);
} }
function MultipleProviderAddressComponent_div_2_ng_container_6_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-widget-multiple-provider-address-selector", 20);
    i0.ɵɵlistener("selectProvider", function MultipleProviderAddressComponent_div_2_ng_container_6_ng_template_10_Template_vnext_widget_multiple_provider_address_selector_selectProvider_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r15.getProviderCountWithinLimits()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("providersList", ctx_r12.sameProvidersList)("selectedMultipleProviders", ctx_r12.selectedMultipleProviders);
} }
function MultipleProviderAddressComponent_div_2_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 15)(4, "p", 16);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "fieldset")(7, "legend", 17);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, MultipleProviderAddressComponent_div_2_ng_container_6_ng_container_9_Template, 2, 2, "ng-container", 10);
    i0.ɵɵtemplate(10, MultipleProviderAddressComponent_div_2_ng_container_6_ng_template_10_Template, 1, 2, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r11 = i0.ɵɵreference(11);
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.providerMultiLocationText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.selectProviderLabelText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.selectProviderLabelText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.providerSingleSelectEnabled)("ngIfElse", _r11);
} }
function MultipleProviderAddressComponent_div_2_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 21);
    i0.ɵɵlistener("keyup.enter", function MultipleProviderAddressComponent_div_2_ng_container_10_Template_button_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.confirm()); })("click", function MultipleProviderAddressComponent_div_2_ng_container_10_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r18); const ctx_r19 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r19.confirm()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", ctx_r4.isEditMode ? ctx_r4.updateLinkText : ctx_r4.addLinkText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.isEditMode ? ctx_r4.updateLinkText : ctx_r4.addLinkText, " ");
} }
function MultipleProviderAddressComponent_div_2_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22, 23);
    i0.ɵɵlistener("mouseleave", function MultipleProviderAddressComponent_div_2_ng_template_11_Template_button_mouseleave_0_listener() { i0.ɵɵrestoreView(_r22); const _r20 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r20.close()); })("click", function MultipleProviderAddressComponent_div_2_ng_template_11_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r22); const _r20 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r20.open()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "span", 17);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngbTooltip", ctx_r6.maxCountErrorMessage);
    i0.ɵɵattribute("aria-label", ctx_r6.isEditMode ? ctx_r6.updateLinkText : ctx_r6.addLinkText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.isEditMode ? ctx_r6.updateLinkText : ctx_r6.addLinkText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r6.maxCountErrorMessage);
} }
function MultipleProviderAddressComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4)(3, "h2", 5);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, MultipleProviderAddressComponent_div_2_div_5_Template, 5, 8, "div", 6);
    i0.ɵɵtemplate(6, MultipleProviderAddressComponent_div_2_ng_container_6_Template, 12, 5, "ng-container", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 8)(8, "button", 9);
    i0.ɵɵlistener("click", function MultipleProviderAddressComponent_div_2_Template_button_click_8_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r24.cancel()); })("keyup.enter", function MultipleProviderAddressComponent_div_2_Template_button_keyup_enter_8_listener() { i0.ɵɵrestoreView(_r25); const ctx_r26 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r26.cancel()); });
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, MultipleProviderAddressComponent_div_2_ng_container_10_Template, 3, 2, "ng-container", 10);
    i0.ɵɵtemplate(11, MultipleProviderAddressComponent_div_2_ng_template_11_Template, 5, 4, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r5 = i0.ɵɵreference(12);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.sameProvidersList[0].displayName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.pcpToggleEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r1.sameProvidersList == null ? null : ctx_r1.sameProvidersList.length) > 1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.cancelProvidersLabel, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.providerCountWithinLimits)("ngIfElse", _r5);
} }
class MultipleProviderAddressComponent {
    constructor() {
        this.newPatientToggleOptions = [];
        this.pcpToggleOptions = [];
        this.addProvider = new EventEmitter();
        this.addProviders = new EventEmitter();
        this.setAsPrimaryCareProvider = new EventEmitter();
        this.sameProvidersList = [];
        this.selectedMultipleProviders = [];
        this.removedMultipleProviders = [];
        this.selectedPcpToggleOption = false;
        this.selectedNewPatientToggleOption = false;
        this.primaryCareProviderToggleValues = PrimaryCareProviderToggleValues;
        this.newPatientToggleValues = NewPatientToggleValues;
    }
    ngOnChanges(changes) {
        const { chosenProvider, selectedProviders } = changes;
        if (chosenProvider || (selectedProviders && !_isEqual(selectedProviders.previousValue, selectedProviders.currentValue))) {
            this.hasMultipleProviders();
        }
    }
    getProviderCountWithinLimits() {
        this.providerCountWithinLimits =
            this.selectedProviders.filter(provider => provider.id !== this.chosenProvider?.id).length + this.selectedMultipleProviders?.length <=
                this.maxCount;
    }
    hasMultipleProviders() {
        if (!this.providerSingleSelectEnabled && !this.singleProviderInListEnabled) {
            this.selectedProvider = this.chosenProvider;
            this.selectedPcpToggleOption = this.chosenProvider?.isPrimary || false;
            this.selectedNewPatientToggleOption = this.chosenProvider?.isNewPatient || false;
            this.confirm();
            return;
        }
        this.isEditMode = this.selectedProviders.some(provider => provider.id === this.chosenProvider?.id);
        if (this.providerSingleSelectEnabled) {
            this.selectedProvider = this.chosenProvider;
        }
        else {
            this.selectedMultipleProviders = this.selectedProviders.filter(provider => provider.id === this.chosenProvider?.id);
        }
        this.getProviderCountWithinLimits();
        const selectedProviderAddress = this.selectedProviders.find(provider => provider.id === this.chosenProvider?.id && provider.addressId === this.chosenProvider?.addressId);
        if (selectedProviderAddress?.addresses?.length) {
            this.sameProvidersList = selectedProviderAddress.addresses;
        }
        else {
            this.sameProvidersList = this.providers?.length
                ? this.providers?.filter(provider => provider.id === this.chosenProvider?.id)
                : this.selectedProviders?.filter(provider => provider.id === this.chosenProvider?.id);
            if (!this.sameProvidersList?.length && this.isEditMode) {
                this.sameProvidersList = this.selectedProviders?.filter(provider => provider.id === this.chosenProvider?.id);
            }
        }
        if (this.sameProvidersList?.length > 1) {
            this.multiAddressProviderList?.nativeElement.scrollIntoView({ behavior: 'smooth' });
            this.selectedProvider = this.chosenProvider;
            this.selectedPcpToggleOption = this.chosenProvider?.isPrimary || false;
            this.selectedNewPatientToggleOption = this.chosenProvider?.isNewPatient || false;
        }
        else if (this.sameProvidersList?.length === 1) {
            this.selectedProvider = this.chosenProvider;
            this.selectedPcpToggleOption = this.chosenProvider?.isPrimary || false;
            this.selectedNewPatientToggleOption = this.chosenProvider?.isNewPatient || false;
            if (!this.pcpToggleEnabled) {
                this.confirm();
            }
        }
    }
    selectProvider($event) {
        this.selectedProvider = $event.provider;
    }
    confirm() {
        if (this.selectedProvider && (this.providerSingleSelectEnabled || this.sameProvidersList?.length === 1)) {
            this.singleProviderUpdate();
        }
        else {
            this.multipleProviderUpdate();
        }
        this.clear();
    }
    singleProviderUpdate() {
        let provider = this.sameProvidersList.find(provider => provider.id === this.selectedProvider.id && provider.addressId === this.selectedProvider.addressId);
        if (!provider) {
            provider = this.providers.find(provider => provider.id === this.selectedProvider.id && provider.addressId === this.selectedProvider.addressId);
        }
        if (this.isEditMode) {
            const addedProvidersList = this.selectedProviders.find(selectedProvider => selectedProvider.id === this.selectedProvider.id);
            const removedProvidersFromList = this.selectedProviders.filter(savedProvider => savedProvider.id === this.selectedProvider.id && savedProvider.addressId !== this.selectedProvider.addressId);
            this.addProviders.emit({
                providers: this.providers,
                addedProviders: [
                    {
                        ...provider,
                        isPrimary: this.selectedPcpToggleOption,
                        isNewPatient: this.selectedPcpToggleOption ? this.selectedNewPatientToggleOption : false,
                        ...(addedProvidersList?.addresses?.length > 1 && { addresses: addedProvidersList?.addresses })
                    }
                ],
                ...(this.providerSingleSelectEnabled && { removedProviders: removedProvidersFromList })
            });
        }
        else if (provider) {
            this.addProviders.emit({
                providers: this.providers,
                addedProviders: [
                    {
                        ...provider,
                        isPrimary: this.selectedPcpToggleOption,
                        isNewPatient: this.selectedPcpToggleOption ? this.selectedNewPatientToggleOption : false,
                        ...(this.sameProvidersList?.length > 1 && { addresses: this.sameProvidersList })
                    }
                ],
                removedProviders: []
            });
        }
    }
    multipleProviderUpdate() {
        const savedProviders = this.selectedProviders.filter(selectedProvider => selectedProvider.id === this.chosenProvider?.id);
        const providerAddress = this.selectedMultipleProviders.find(provider => provider.id === this.chosenProvider?.id);
        const addedProvidersWithAddresses = this.selectedMultipleProviders.reduce((providers, provider, currentIndex) => {
            if (!savedProviders.some((savedProvider) => savedProvider.addressId === provider.addressId) ||
                savedProviders.some((savedProvider) => savedProvider.addressId === provider.addressId && this.selectedPcpToggleOption !== savedProvider.isPrimary)) {
                providers.push({
                    ...provider,
                    isPrimary: currentIndex === 0 && this.selectedPcpToggleOption,
                    isNewPatient: this.selectedPcpToggleOption ? this.selectedNewPatientToggleOption : false,
                    addresses: providerAddress?.addresses?.length > 1 ? providerAddress.addresses : this.sameProvidersList
                });
            }
            return providers;
        }, []);
        const removedProviders = savedProviders.filter(savedProvider => !this.selectedMultipleProviders.some((selectedMultipleProvider) => selectedMultipleProvider.addressId === savedProvider.addressId));
        this.addProviders.emit({
            providers: this.providers,
            addedProviders: addedProvidersWithAddresses,
            removedProviders
        });
    }
    onPcpToggleSelect($event) {
        this.selectedPcpToggleOption = $event === PrimaryCareProviderToggleValues.YES;
    }
    onNewPatientToggleSelect($event) {
        this.selectedNewPatientToggleOption = $event === NewPatientToggleValues.YES;
    }
    cancel() {
        if (this.selectedMultipleProviders?.length > 1) {
            this.addProviders.emit();
        }
        else {
            this.addProvider.emit();
        }
        this.clear();
    }
    clear() {
        this.selectedMultipleProviders = [];
        this.sameProvidersList = [];
        this.selectedProvider = null;
        this.selectedPcpToggleOption = false;
        this.selectedNewPatientToggleOption = false;
    }
}
MultipleProviderAddressComponent.ɵfac = function MultipleProviderAddressComponent_Factory(t) { return new (t || MultipleProviderAddressComponent)(); };
MultipleProviderAddressComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MultipleProviderAddressComponent, selectors: [["vnext-widget-multiple-provider-address"]], viewQuery: function MultipleProviderAddressComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1Y, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.multiAddressProviderList = _t.first);
    } }, inputs: { selectedProviders: "selectedProviders", providers: "providers", yourProviderText: "yourProviderText", removeProviderText: "removeProviderText", setPrimaryCareProviderText: "setPrimaryCareProviderText", primaryCareProviderText: "primaryCareProviderText", backgroundStyleColor: "backgroundStyleColor", iconClass: "iconClass", chosenProvider: "chosenProvider", providerSingleSelectEnabled: "providerSingleSelectEnabled", addLinkText: "addLinkText", cancelProvidersLabel: "cancelProvidersLabel", providerMultiLocationText: "providerMultiLocationText", selectProviderLabelText: "selectProviderLabelText", maxCount: "maxCount", maxCountErrorMessage: "maxCountErrorMessage", singleProviderInListEnabled: "singleProviderInListEnabled", updateLinkText: "updateLinkText", newPatientToggleEnabled: "newPatientToggleEnabled", newPatientToggleLabel: "newPatientToggleLabel", newPatientToggleOptions: "newPatientToggleOptions", pcpToggleLabel: "pcpToggleLabel", pcpToggleOptions: "pcpToggleOptions", pcpToggleEnabled: "pcpToggleEnabled" }, outputs: { addProvider: "addProvider", addProviders: "addProviders", setAsPrimaryCareProvider: "setAsPrimaryCareProvider" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 1, consts: [["multiAddressProviderList", ""], ["class", "provider mt-3 mb-3 provider-border-color", 4, "ngIf"], [1, "provider", "mt-3", "mb-3", "provider-border-color"], [1, "pb-2"], [1, "d-flex", "py-2"], [1, "Spa_Style_Large_Font", "font-weight-bold", "no-translate-block"], ["class", "row mb-4", 4, "ngIf"], [4, "ngIf"], [1, "col-12", "modal-footer", "footer-content"], ["type", "button", "tabindex", "0", 1, "btn", "Spa_Style_SecondaryButton", 3, "click", "keyup.enter"], [4, "ngIf", "ngIfElse"], ["showProviderLimitMessage", ""], [1, "row", "mb-4"], [1, "col-6"], [3, "isToggleEnabled", "toggleLabel", "isDefaultSelected", "toggleOptions", "optionSelected"], [1, "toggle-container", "vertical"], [1, "Spa_Style_Bold_Weight"], [1, "sr-only"], ["providerMultiSelect", ""], [3, "providersList", "selectedProvider", "selectProvider"], [3, "providersList", "selectedMultipleProviders", "selectProvider"], ["type", "button", "tabindex", "0", 1, "btn", "Spa_Style_PrimaryButton", 3, "keyup.enter", "click"], ["type", "button", "tabindex", "0", "triggers", "manual", "placement", "top", "container", "body", "autoClose", "true", 1, "btn", "Spa_Style_PrimaryButton", 3, "ngbTooltip", "mouseleave", "click"], ["providerLimitTooltip", "ngbTooltip"]], template: function MultipleProviderAddressComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", null, 0);
        i0.ɵɵtemplate(2, MultipleProviderAddressComponent_div_2_Template, 13, 6, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.sameProvidersList == null ? null : ctx.sameProvidersList.length) && ctx.pcpToggleEnabled || (ctx.sameProvidersList == null ? null : ctx.sameProvidersList.length) > 1 && !ctx.pcpToggleEnabled);
    } }, dependencies: [i1$2.NgIf, i1$1.NgbTooltip, ProviderToggleComponent, SingleProviderAddressSelectorComponent, MultipleProviderAddressSelectorComponent], styles: [".vertical[_ngcontent-%COMP%]{flex-direction:column;text-align:left}.provider-border-color[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent1)}.provider[_ngcontent-%COMP%]{border-radius:5px;border-width:1px;border-style:solid;padding:10px}.footer-content[_ngcontent-%COMP%]{display:flex;justify-content:space-between}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultipleProviderAddressComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-multiple-provider-address', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div #multiAddressProviderList>\r\n  <div class=\"provider mt-3 mb-3 provider-border-color\" *ngIf=\"(sameProvidersList?.length && pcpToggleEnabled) || (sameProvidersList?.length > 1 && !pcpToggleEnabled)\">\r\n    <div class=\"pb-2\">\r\n      <div class=\"d-flex py-2\">\r\n        <h2 class=\"Spa_Style_Large_Font font-weight-bold no-translate-block\">{{ sameProvidersList[0].displayName }}</h2>\r\n      </div>\r\n      <div class=\"row mb-4\" *ngIf=\"pcpToggleEnabled\">\r\n        <div class=\"col-6\">\r\n          <vnext-widget-provider-toggle\r\n            [isToggleEnabled]=\"true\"\r\n            [toggleLabel]=\"pcpToggleLabel\"\r\n            [isDefaultSelected]=\"selectedProvider?.isPrimary ? primaryCareProviderToggleValues.YES : primaryCareProviderToggleValues.NO\"\r\n            [toggleOptions]=\"pcpToggleOptions\"\r\n            (optionSelected)=\"onPcpToggleSelect($event)\"\r\n          >\r\n          </vnext-widget-provider-toggle>\r\n        </div>\r\n        <div class=\"col-6\">\r\n          <vnext-widget-provider-toggle\r\n            [isToggleEnabled]=\"newPatientToggleEnabled && selectedPcpToggleOption\"\r\n            [toggleLabel]=\"newPatientToggleLabel\"\r\n            [isDefaultSelected]=\"selectedProvider?.isNewPatient ? newPatientToggleValues.YES : newPatientToggleValues.NO\"\r\n            [toggleOptions]=\"newPatientToggleOptions\"\r\n            (optionSelected)=\"onNewPatientToggleSelect($event)\"\r\n          >\r\n          </vnext-widget-provider-toggle>\r\n        </div>\r\n      </div>\r\n      <ng-container *ngIf=\"sameProvidersList?.length > 1\">\r\n        <p>{{ providerMultiLocationText }}</p>\r\n        <div class=\"toggle-container vertical\">\r\n          <p class=\"Spa_Style_Bold_Weight\">{{ selectProviderLabelText }}</p>\r\n          <fieldset>\r\n            <legend class=\"sr-only\">{{ selectProviderLabelText }}</legend>\r\n            <ng-container *ngIf=\"providerSingleSelectEnabled; else providerMultiSelect\">\r\n              <vnext-widget-single-provider-address-selector\r\n                [providersList]=\"sameProvidersList\"\r\n                [selectedProvider]=\"selectedProvider\"\r\n                (selectProvider)=\"selectProvider($event)\"\r\n              ></vnext-widget-single-provider-address-selector>\r\n            </ng-container>\r\n            <ng-template #providerMultiSelect>\r\n              <vnext-widget-multiple-provider-address-selector\r\n                [providersList]=\"sameProvidersList\"\r\n                [selectedMultipleProviders]=\"selectedMultipleProviders\"\r\n                (selectProvider)=\"getProviderCountWithinLimits()\"\r\n              >\r\n              </vnext-widget-multiple-provider-address-selector>\r\n            </ng-template>\r\n          </fieldset>\r\n        </div>\r\n      </ng-container>\r\n    </div>\r\n    <div class=\"col-12 modal-footer footer-content\">\r\n      <button type=\"button\" class=\"btn Spa_Style_SecondaryButton\" tabindex=\"0\" (click)=\"cancel()\" (keyup.enter)=\"cancel()\">\r\n        {{ cancelProvidersLabel }}\r\n      </button>\r\n\r\n      <ng-container *ngIf=\"providerCountWithinLimits; else showProviderLimitMessage\">\r\n        <button\r\n          type=\"button\"\r\n          (keyup.enter)=\"confirm()\"\r\n          (click)=\"confirm()\"\r\n          tabindex=\"0\"\r\n          class=\"btn Spa_Style_PrimaryButton\"\r\n          [attr.aria-label]=\"isEditMode ? updateLinkText : addLinkText\"\r\n        >\r\n          {{ isEditMode ? updateLinkText : addLinkText }}\r\n        </button>\r\n      </ng-container>\r\n\r\n      <ng-template #showProviderLimitMessage>\r\n        <button\r\n          type=\"button\"\r\n          tabindex=\"0\"\r\n          class=\"btn Spa_Style_PrimaryButton\"\r\n          [ngbTooltip]=\"maxCountErrorMessage\"\r\n          triggers=\"manual\"\r\n          placement=\"top\"\r\n          container=\"body\"\r\n          autoClose=\"true\"\r\n          #providerLimitTooltip=\"ngbTooltip\"\r\n          (mouseleave)=\"providerLimitTooltip.close()\"\r\n          (click)=\"providerLimitTooltip.open()\"\r\n          [attr.aria-label]=\"isEditMode ? updateLinkText : addLinkText\"\r\n        >\r\n          {{ isEditMode ? updateLinkText : addLinkText }}\r\n          <span class=\"sr-only\">{{ maxCountErrorMessage }}</span>\r\n        </button>\r\n      </ng-template>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".vertical{flex-direction:column;text-align:left}.provider-border-color{border-color:var(--static-Spa_Style_Accent1)}.provider{border-radius:5px;border-width:1px;border-style:solid;padding:10px}.footer-content{display:flex;justify-content:space-between}\n"] }]
    }], null, { selectedProviders: [{
            type: Input
        }], providers: [{
            type: Input
        }], yourProviderText: [{
            type: Input
        }], removeProviderText: [{
            type: Input
        }], setPrimaryCareProviderText: [{
            type: Input
        }], primaryCareProviderText: [{
            type: Input
        }], backgroundStyleColor: [{
            type: Input
        }], iconClass: [{
            type: Input
        }], chosenProvider: [{
            type: Input
        }], providerSingleSelectEnabled: [{
            type: Input
        }], addLinkText: [{
            type: Input
        }], cancelProvidersLabel: [{
            type: Input
        }], providerMultiLocationText: [{
            type: Input
        }], selectProviderLabelText: [{
            type: Input
        }], maxCount: [{
            type: Input
        }], maxCountErrorMessage: [{
            type: Input
        }], singleProviderInListEnabled: [{
            type: Input
        }], updateLinkText: [{
            type: Input
        }], newPatientToggleEnabled: [{
            type: Input
        }], newPatientToggleLabel: [{
            type: Input
        }], newPatientToggleOptions: [{
            type: Input
        }], pcpToggleLabel: [{
            type: Input
        }], pcpToggleOptions: [{
            type: Input
        }], pcpToggleEnabled: [{
            type: Input
        }], multiAddressProviderList: [{
            type: ViewChild,
            args: ['multiAddressProviderList']
        }], addProvider: [{
            type: Output
        }], addProviders: [{
            type: Output
        }], setAsPrimaryCareProvider: [{
            type: Output
        }] }); })();

const _c0$1X = ["providerFilterCheckBox"];
function ProviderSearchComponent_div_0_h1_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r7.providersText);
} }
function ProviderSearchComponent_div_0_p_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 28);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r8.providerSingleSelectEnabled ? ctx_r8.providersMultiBodyText : ctx_r8.providersBodyText, "html"), i0.ɵɵsanitizeHtml);
} }
function ProviderSearchComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21)(2, "div", 22)(3, "div", 23);
    i0.ɵɵelement(4, "i", 24);
    i0.ɵɵtemplate(5, ProviderSearchComponent_div_0_h1_5_Template, 2, 1, "h1", 25);
    i0.ɵɵtemplate(6, ProviderSearchComponent_div_0_p_6_Template, 2, 4, "p", 26);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_Providers_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_Providers_Body_Text");
} }
function ProviderSearchComponent_div_8_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 33);
    i0.ɵɵelement(1, "i", 34);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.providerErrorText, "");
} }
function ProviderSearchComponent_div_8_label_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.providerNameText, " ");
} }
function ProviderSearchComponent_div_8_input_3_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 36);
    i0.ɵɵlistener("keyup.enter", function ProviderSearchComponent_div_8_input_3_Template_input_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r12.validateZip()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("placeholder", ctx_r11.providerNameHintText)("formControl", ctx_r11.providerName);
} }
function ProviderSearchComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵtemplate(1, ProviderSearchComponent_div_8_span_1_Template, 3, 1, "span", 30);
    i0.ɵɵtemplate(2, ProviderSearchComponent_div_8_label_2_Template, 2, 1, "label", 31);
    i0.ɵɵtemplate(3, ProviderSearchComponent_div_8_input_3_Template, 1, 2, "input", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.hasMinCharError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_ProviderName_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_ProviderName_HintText");
} }
function ProviderSearchComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵelement(1, "span", 38);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementStart(3, "vnext-link", 39);
    i0.ɵɵlistener("click", function ProviderSearchComponent_div_15_Template_vnext_link_click_3_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.openExternalLink()); })("keydown.enter", function ProviderSearchComponent_div_15_Template_vnext_link_keydown_enter_3_listener() { i0.ɵɵrestoreView(_r15); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.openExternalLink()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 5, ctx_r2.valueBasedCareAvailableText, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("isLinkButton", true)("title", ctx_r2.valueBasedCareLearnMoreText)("makeInlineBlock", true)("ariaHasPopup", true);
} }
function ProviderSearchComponent_div_16_div_1_ng_container_2_vnext_link_5_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 39);
    i0.ɵɵlistener("click", function ProviderSearchComponent_div_16_div_1_ng_container_2_vnext_link_5_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r26); const providerFilter_r19 = i0.ɵɵnextContext(2).$implicit; const ctx_r24 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r24.onFilterLinkSelection(providerFilter_r19.value)); })("keydown.enter", function ProviderSearchComponent_div_16_div_1_ng_container_2_vnext_link_5_Template_vnext_link_keydown_enter_0_listener($event) { i0.ɵɵrestoreView(_r26); const providerFilter_r19 = i0.ɵɵnextContext(2).$implicit; const ctx_r27 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r27.onFilterLinkSelection(providerFilter_r19.value, $event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const providerFilter_r19 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("isLinkButton", true)("title", providerFilter_r19.link)("makeInlineBlock", true)("ariaHasPopup", true);
} }
function ProviderSearchComponent_div_16_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "input", 45, 46);
    i0.ɵɵlistener("change", function ProviderSearchComponent_div_16_div_1_ng_container_2_Template_input_change_1_listener($event) { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r30.onFilterSelected($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 47);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ProviderSearchComponent_div_16_div_1_ng_container_2_vnext_link_5_Template, 1, 4, "vnext-link", 48);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext();
    const providerFilter_r19 = ctx_r32.$implicit;
    const i_r20 = ctx_r32.index;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("value", providerFilter_r19.label);
    i0.ɵɵproperty("id", i_r20 + "providerFilterCheckBox")("checked", providerFilter_r19.initiallyChecked);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", i_r20 + "providerFilterCheckBox");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(providerFilter_r19.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", providerFilter_r19.link);
} }
const _c1$U = function (a0) { return { "Spa_Style_Paragraph ": a0 }; };
function ProviderSearchComponent_div_16_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵtemplate(2, ProviderSearchComponent_div_16_div_1_ng_container_2_Template, 6, 6, "ng-container", 44);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const providerFilter_r19 = ctx.$implicit;
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1$U, i0.ɵɵpipeBind1(1, 2, ctx_r17.providerFacade.isMobile$)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !providerFilter_r19.disabled);
} }
function ProviderSearchComponent_div_16_div_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div")(2, "input", 51);
    i0.ɵɵlistener("change", function ProviderSearchComponent_div_16_div_2_ng_container_3_Template_input_change_2_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r37); const i_r35 = restoredCtx.index; const ctx_r36 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r36.onVbcSelection(i_r35, $event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 47);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const vbc_r34 = ctx.$implicit;
    const i_r35 = ctx.index;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", vbc_r34.name)("checked", vbc_r34.selected)("id", i_r35 + "vbcCheckBox");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", i_r35 + "vbcCheckBox");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(vbc_r34.name);
} }
function ProviderSearchComponent_div_16_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 49)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ProviderSearchComponent_div_16_div_2_ng_container_3_Template, 5, 5, "ng-container", 50);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r18.vbcNameFilterLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r18.vbcList)("ngForTrackBy", ctx_r18.trackByVbcId);
} }
function ProviderSearchComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵtemplate(1, ProviderSearchComponent_div_16_div_1_Template, 3, 6, "div", 41);
    i0.ɵɵtemplate(2, ProviderSearchComponent_div_16_div_2_Template, 4, 3, "div", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.providerFilters);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.vbcNameFilterEnabled && (ctx_r3.vbcList == null ? null : ctx_r3.vbcList.length) > 1);
} }
function ProviderSearchComponent_div_18_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 56)(1, "vnext-widget-provider-list", 57);
    i0.ɵɵlistener("addProvider", function ProviderSearchComponent_div_18_ng_container_2_div_1_Template_vnext_widget_provider_list_addProvider_1_listener($event) { i0.ɵɵrestoreView(_r45); const ctx_r44 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r44.addToSelectedProvider($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const provider_r42 = ctx.$implicit;
    const i_r43 = ctx.index;
    const ctx_r41 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("alreadySelectedProvider", ctx_r41.providerFacade.selectedProviderIds[provider_r42.id])("isHelpfulToolsView", ctx_r41.isHelpfulToolsView)("provider", provider_r42)("pageSize", ctx_r41.pageSize)("pageIndex", ctx_r41.pageIndex)("selectedProviders", ctx_r41.selectedProviders)("addProviderText", ctx_r41.addProviderText)("providerLocationsText", ctx_r41.providerLocationsText)("providerAddedText", ctx_r41.providerAddedText)("maxCountErrorMessage", ctx_r41.maxCountErrorMessage)("maxCount", ctx_r41.maxCount)("customClass", ctx_r41.providerFacade.getProviderPinClass(provider_r42, false, ctx_r41.isHelpfulToolsView))("alternateViewClass", ctx_r41.providerFacade.noticeAlternateView(provider_r42))("alternateNumberIndicatorClass", ctx_r41.providerFacade.noticeAlternateProviderIndicator(provider_r42))("isProviderAdded", ctx_r41.providerFacade.isProviderAdded(provider_r42.id, provider_r42.addressId, provider_r42.providerGroup, !ctx_r41.providerSingleSelectEnabled))("backgroundStyle", ctx_r41.providerFacade.getPrimaryProviderBackgroundColor(provider_r42, ctx_r41.isHelpfulToolsView))("index", i_r43)("isPrimary", ctx_r41.providerFacade.isPcp(provider_r42))("providerExistsTooltipText", ctx_r41.providerExistsTooltipText)("countryCode", ctx_r41.countryCode)("acceptingNewPatientsIcon", ctx_r41.acceptingNewPatientsIcon)("acceptingNewPatientsText", ctx_r41.acceptingNewPatientsText)("languagesIcon", ctx_r41.languagesIcon)("providerGroup", provider_r42.providerGroup)("providerSingleSelectEnabled", ctx_r41.providerSingleSelectEnabled)("valueBasedCareEnabled", ctx_r41.valueBasedCareEnabled)("valueBasedCareIcon", ctx_r41.valueBasedCareIcon)("valueBasedCareText", ctx_r41.valueBasedCareText)("singleProviderInListEnabled", ctx_r41.singleProviderInListEnabled)("primaryCareProviderText", ctx_r41.primaryCareProviderText)("isZelisIntegrationEnabled", ctx_r41.isZelisIntegrationEnabled);
} }
function ProviderSearchComponent_div_18_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProviderSearchComponent_div_18_ng_container_2_div_1_Template, 2, 31, "div", 55);
    i0.ɵɵpipe(2, "slice");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(2, 1, ctx_r38.providerList, ctx_r38.startValueOfItemsToBeSliced, ctx_r38.endValueOfItemsToBeSliced));
} }
function ProviderSearchComponent_div_18_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 58)(2, "h3", 59);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p", 60);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r39.viewNotFoundHeaderText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r39.viewNotFoundBodyText, " ");
} }
function ProviderSearchComponent_div_18_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 61)(1, "vnext-widget-map", 62);
    i0.ɵɵlistener("setZoom", function ProviderSearchComponent_div_18_div_4_Template_vnext_widget_map_setZoom_1_listener($event) { i0.ɵɵrestoreView(_r47); const ctx_r46 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r46.setZoom($event)); })("resetToDefaultPageIndex", function ProviderSearchComponent_div_18_div_4_Template_vnext_widget_map_resetToDefaultPageIndex_1_listener() { i0.ɵɵrestoreView(_r47); const ctx_r48 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r48.updateProviders({ pageSize: ctx_r48.itemsPerPage, defaultStartItem: 1 })); })("setMapCenter", function ProviderSearchComponent_div_18_div_4_Template_vnext_widget_map_setMapCenter_1_listener($event) { i0.ɵɵrestoreView(_r47); const ctx_r49 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r49.setMapCenter.emit($event)); })("setMap", function ProviderSearchComponent_div_18_div_4_Template_vnext_widget_map_setMap_1_listener($event) { i0.ɵɵrestoreView(_r47); const ctx_r50 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r50.initializeMap.emit($event)); })("setMapDefaultBounds", function ProviderSearchComponent_div_18_div_4_Template_vnext_widget_map_setMapDefaultBounds_1_listener($event) { i0.ɵɵrestoreView(_r47); const ctx_r51 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r51.setMapDefaultBounds.emit($event)); })("addSelectedItem", function ProviderSearchComponent_div_18_div_4_Template_vnext_widget_map_addSelectedItem_1_listener($event) { i0.ɵɵrestoreView(_r47); const ctx_r52 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r52.addToMapSelectedProvider($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("zip", ctx_r40.zip)("zoom", ctx_r40.zoom)("minZoom", ctx_r40.minZoom)("maxZoom", ctx_r40.maxZoom)("isHelpfulToolsView", ctx_r40.isHelpfulToolsView)("isProvider", true)("addButtonText", ctx_r40.addProviderText)("addedLabel", ctx_r40.providerAddedText)("markers", ctx_r40.markers)("markerGroups", ctx_r40.markerGroups)("limitErrorMessage", ctx_r40.maxCountErrorMessage)("groupAddedLabel", ctx_r40.providerGroupAddedLabelText)("groupAddText", ctx_r40.providerGroupAddLabelText)("providerExistsTooltipText", ctx_r40.providerExistsTooltipText)("providerSingleSelectEnabled", ctx_r40.providerSingleSelectEnabled)("primaryIconAriaLabelText", ctx_r40.primaryCareProviderText);
} }
const _c2$B = function (a0) { return { "mt-3": a0 }; };
function ProviderSearchComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52)(1, "div", 53);
    i0.ɵɵtemplate(2, ProviderSearchComponent_div_18_ng_container_2_Template, 3, 5, "ng-container", 44);
    i0.ɵɵtemplate(3, ProviderSearchComponent_div_18_ng_container_3_Template, 6, 2, "ng-container", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ProviderSearchComponent_div_18_div_4_Template, 2, 16, "div", 54);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c2$B, !ctx_r4.providerFiltersEnabled));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r4.providers == null ? null : ctx_r4.providers.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !((ctx_r4.providers == null ? null : ctx_r4.providers.length) > 0) && !ctx_r4.mapFacade.showSpinner);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.zip);
} }
function ProviderSearchComponent_div_19_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 64)(1, "vnext-pagination", 65);
    i0.ɵɵlistener("updatePagination", function ProviderSearchComponent_div_19_div_1_Template_vnext_pagination_updatePagination_1_listener($event) { i0.ɵɵrestoreView(_r55); const ctx_r54 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r54.updateProviders($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pagination", ctx_r53.providerList)("defaultStartItem", ctx_r53.defaultStartItem)("itemsPerPage", ctx_r53.itemsPerPage)("paginationText", ctx_r53.paginationText);
} }
function ProviderSearchComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵtemplate(1, ProviderSearchComponent_div_19_div_1_Template, 2, 4, "div", 63);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.providerPaginationEnabled && ctx_r5.itemsPerPage < (ctx_r5.providerList == null ? null : ctx_r5.providerList.length));
} }
function ProviderSearchComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17)(1, "vnext-widget-selected-provider", 66);
    i0.ɵɵlistener("removeProvider", function ProviderSearchComponent_div_22_Template_vnext_widget_selected_provider_removeProvider_1_listener($event) { i0.ɵɵrestoreView(_r57); const ctx_r56 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r56.removeProvider($event)); })("setAsPrimaryCareProvider", function ProviderSearchComponent_div_22_Template_vnext_widget_selected_provider_setAsPrimaryCareProvider_1_listener($event) { i0.ɵɵrestoreView(_r57); const ctx_r58 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r58.providerFacade.setAsPrimaryCareProvider($event)); })("editProvider", function ProviderSearchComponent_div_22_Template_vnext_widget_selected_provider_editProvider_1_listener($event) { i0.ɵɵrestoreView(_r57); const ctx_r59 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r59.editProvider($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("selectedProviders", ctx_r6.selectedProviders)("yourProviderText", ctx_r6.yourProviderText)("removeProviderText", ctx_r6.removeProviderText)("setPrimaryCareProviderText", ctx_r6.setPrimaryCareProviderText)("primaryCareProviderText", ctx_r6.primaryCareProviderText)("iconClass", ctx_r6.providerFacade.primaryPinIcon)("backgroundStyleColor", ctx_r6.providerFacade.getPrimaryProviderBackgroundColor())("countryCode", ctx_r6.countryCode)("editLinkText", ctx_r6.editLinkText)("showEditLinkEnabled", ctx_r6.showEditLinkEnabled)("providerSingleSelectEnabled", ctx_r6.providerSingleSelectEnabled)("singleProviderInListEnabled", ctx_r6.singleProviderInListEnabled)("newPatientText", ctx_r6.newPatientText)("existingPatientText", ctx_r6.existingPatientText)("selectedProviderOptionsEnabled", ctx_r6.selectedProviderOptionsEnabled)("removeText", ctx_r6.removeText);
} }
const _c3$o = function (a0) { return { "flex-1": a0 }; };
class ProviderSearchComponent {
    constructor(cdr, configurableWidgetService, widgetValidationService, mapFacade, providerFacade, helpfulToolsContext, helpfulToolsService, spinnerService, mapContextService, formValidationService, providerContext, filterService, analyticsService, providerService, navigationService, stringFormatUtilityService) {
        this.cdr = cdr;
        this.configurableWidgetService = configurableWidgetService;
        this.widgetValidationService = widgetValidationService;
        this.mapFacade = mapFacade;
        this.providerFacade = providerFacade;
        this.helpfulToolsContext = helpfulToolsContext;
        this.helpfulToolsService = helpfulToolsService;
        this.spinnerService = spinnerService;
        this.mapContextService = mapContextService;
        this.formValidationService = formValidationService;
        this.providerContext = providerContext;
        this.filterService = filterService;
        this.analyticsService = analyticsService;
        this.providerService = providerService;
        this.navigationService = navigationService;
        this.stringFormatUtilityService = stringFormatUtilityService;
        this.generalPracticeOptions = [];
        this.valueBasedCareToggleOptions = [];
        this.newPatientToggleOptions = [];
        this.pcpToggleOptions = [];
        this.isPreferenceBannerEnabled = false;
        this.fetchProvidersFromLocation = new EventEmitter();
        this.initializeMap = new EventEmitter();
        this.setMapCenter = new EventEmitter();
        this.setMapDefaultBounds = new EventEmitter();
        this.addProviders = new EventEmitter();
        this.addProviderSelectedFromMarker = new EventEmitter();
        this.fetchProvidersFromAPI = new EventEmitter();
        this.previousZip = '';
        this.providerName = new UntypedFormControl('');
        this.hasMinCharError = false;
        this.previousProvider = '';
        this.vbcList = [];
        this.pageIndex = 1;
        this.defaultStartItem = 1;
        this.isZipUpdated = false;
        this.selectedProviders = [];
        this.zipCodeStyles = { roundInputRightBorder: true };
        this.checkFocus = false;
        this.filteredProviders = [];
        this.isFilterChecked = false;
        this.filteredProviderGroups = [];
        this.markerGroups = [];
        this.providersGroup = [];
        this.providerSearchIsDirty = false;
        this.selectedGeneralPracticeOption = false;
        this.isGeneralPracticeOptionUpdate = false;
        this.isValueBasedCareOptionUpdate = false;
        this.providerFilterKeyType = ProviderFilterKeyType;
        this.selectedValueBasedToggleOption = false;
        this.isFocusEnabled = true;
        this.subscriptions = new Subscription();
    }
    get startValueOfItemsToBeSliced() {
        return (this.pageIndex - 1) * this.pageSize;
    }
    get endValueOfItemsToBeSliced() {
        return (this.pageIndex - 1) * this.pageSize + this.pageSize;
    }
    ngOnInit() {
        this.zip = this.configurableWidgetService.store.selectSnapshot(DemographicState.selectedZipCode);
        this.previousZip = this.zip;
        this.pageSize = this.providerPaginationEnabled ? this.itemsPerPage : this.providerLimit;
        this.helpfulToolsContext.isHelpfulToolsView = this.isHelpfulToolsView;
        this.searchProviderByNameEnabled = this.providerFacade.searchProviderByNameEnabled;
        this.providerErrorText = this.formValidationService.errorMessages.minCharacters2();
        if (this.isHelpfulToolsView) {
            this.zip = this.helpfulToolsService.getZipCodeSelected();
            this.previousZip = this.zip;
        }
        else {
            this.zip = this.configurableWidgetService.store.selectSnapshot(DemographicState.selectedZipCode);
            this.previousZip = this.zip;
        }
        this.mapFacade.showMap = false;
        this.providerSearchIsDirty = this.providerService.isProviderSearchLoaded();
        if (this.zip && this.providerSearchIsDirty) {
            this.spinnerService.show(SpinnerEvent.PROVIDERS_LOADING);
            this.mapFacade.toggleSpinner();
            this.fetchProviders(true);
        }
        this.subscriptions.add(this.providerFacade.getSelectedProviders$().subscribe({
            next: selectedProviders => {
                if (selectedProviders) {
                    this.selectedProviders = selectedProviders;
                    this.cdr.markForCheck();
                }
            }
        }));
        this.subscriptions.add(this.providerContext.providers$.subscribe({
            next: providers => {
                if (!this.providerFiltersEnabled) {
                    this.providers = providers;
                }
                else {
                    if (this.providersFilterCheckBoxes?.length) {
                        this.filteredProviders = this.providerFacade.getFilteredProviders(this.providersFilterCheckBoxes);
                    }
                    this.providers = this.filteredProviders;
                }
                this.vbcList = [];
                this.providers.forEach(provider => {
                    this.providerFacade.sameProviderAlreadySelected(provider);
                });
                this.providerList = this.singleProviderInListEnabled ? this.groupByProviderId(this.providers) : this.providers;
                if (this.selectedValueBasedToggleOption) {
                    this.providers = this.providers.filter(provider => provider?.valueBasedCare?.vbcid &&
                        this.providerFacade.isWhitelistedVBC(provider.valueBasedCare.vbcid) &&
                        provider.isIndividual);
                    if (this.providers?.length > 1) {
                        this.providers?.forEach(provider => {
                            if (!this.vbcList.some(vbc => vbc?.vbcid === provider?.valueBasedCare?.vbcid)) {
                                this.vbcList.push({ vbcid: provider?.valueBasedCare?.vbcid, name: provider?.valueBasedCare?.vbcOrgName, selected: true });
                            }
                        });
                        if (this.vbcList.length > 1) {
                            this.vbcList.unshift({
                                vbcid: '',
                                name: this.selectAllText,
                                selected: true
                            });
                        }
                    }
                    this.providerList = this.providers;
                }
                this.filterProviders();
                this.markers = this.mapFacade.getProviderMarkers(this.filteredProviderGroups);
                this.setProviderMarkerLabels();
                this.mapContextService.setMarkers(this.markers);
                this.mapFacade.toggleSpinner(false);
                this.spinnerService.hide(SpinnerEvent.PREFERENCE_BANNER_PROVIDER_LOADING);
                this.cdr.detectChanges();
            }
        }));
        this.subscriptions.add(this.mapContextService.fetchDataFromAPI$.subscribe({
            next: value => {
                if (value) {
                    this.fetchProvidersFromAPI.emit({
                        latitude: this.location?.lat,
                        longitude: this.location?.lng,
                        bounds: this.bounds,
                        zip: this.zip,
                        includeGP: this.selectedGeneralPracticeOption
                    });
                }
            }
        }));
        this.subscriptions.add(this.mapContextService.location$.subscribe({
            next: value => {
                this.location = value;
            }
        }));
        this.subscriptions.add(this.mapContextService.bounds$.subscribe({
            next: value => {
                this.bounds = value;
            }
        }));
        this.subscriptions.add(this.mapContextService.loadData$.subscribe({
            next: mapData => {
                if (mapData) {
                    this.fetchProvidersFromLocation.emit({
                        latitude: mapData.location?.lat,
                        longitude: mapData.location?.lng,
                        bounds: mapData.bounds,
                        distance: mapData.distance,
                        zip: this.zip,
                        includeGP: this.selectedGeneralPracticeOption
                    });
                }
            }
        }));
    }
    ngAfterViewChecked() {
        if (this.checkFocus) {
            const invalidZipFormInput = document.querySelector('input.has-error');
            const invalidZipFormInputFormElement = invalidZipFormInput;
            if (invalidZipFormInputFormElement) {
                invalidZipFormInputFormElement.focus();
            }
            this.checkFocus = false;
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    onVbcSelection(index, event) {
        const vbcFilterCheckBox = event.currentTarget;
        this.vbcList[index].selected = vbcFilterCheckBox.checked;
        if (this.vbcList[index].name === this.selectAllText) {
            this.vbcList.forEach(vbc => {
                vbc.selected = vbcFilterCheckBox.checked;
            });
        }
        else {
            const vbcListOptions = this.vbcList.slice(1);
            this.vbcList[0].selected = vbcListOptions.every(vbc => vbc.selected);
        }
        this.onFilterSelected(event);
    }
    trackByVbcId(index, vbc) {
        return vbc.vbcid;
    }
    groupByProviderId(providersList) {
        return providersList.reduce((provider, item) => {
            if (!provider.some(p => p.id === item.id)) {
                provider.push({ ...item, providerGroup: providersList.filter(pFilter => pFilter.id === item.id) });
            }
            return provider;
        }, []);
    }
    addToMapSelectedProvider($event) {
        const selectedProvider = this.providers.find(provider => provider.id === $event.providerId && provider.addressId === $event.addressId);
        this.addToSelectedProvider(selectedProvider);
    }
    addToSelectedProvider(selectedProvider) {
        this.selectedProvider = selectedProvider;
    }
    providersAddToList($event) {
        if ($event) {
            this.addProviders.emit({ providers: this.providers, addedProviders: $event.addedProviders });
            $event.addedProviders.forEach(provider => (this.providerFacade.selectedProviderIds[provider.id] = true));
            $event.removedProviders?.forEach(provider => {
                this.removeProvider(provider);
            });
        }
        this.selectedProvider = null;
    }
    filterProviders() {
        this.providersGroup = this.providers.reduce(function (providerGroup, provider) {
            providerGroup[(provider.longitude, provider.latitude)] = providerGroup[(provider.longitude, provider.latitude)] || [];
            providerGroup[(provider.longitude, provider.latitude)].push(provider);
            return providerGroup;
        }, []);
        this.clearProviders();
        this.filteredProviderGroups = this.filteredProviderGroups.concat(this.providers);
        const providers = Object.keys(this.providersGroup);
        if (providers.length > 0) {
            providers.forEach(key => {
                const providersGroupCount = this.providersGroup[key].length;
                if (providersGroupCount > 1) {
                    this.markerGroups.push(this.mapFacade.getProviderMarkers(this.providersGroup[key]));
                    this.providersGroup[key].forEach((provider) => {
                        if (this.filteredProviderGroups.includes(provider)) {
                            const index = this.filteredProviderGroups.indexOf(provider);
                            this.filteredProviderGroups.splice(index, 1);
                        }
                    });
                }
            });
            this.setProviderMarkerLabels();
        }
        else {
            this.clearProviders();
        }
    }
    editProvider(selectedProvider) {
        this.addToSelectedProvider(selectedProvider);
    }
    clearProviders() {
        this.markerGroups = [];
        this.filteredProviderGroups = [];
    }
    setProviderMarkerLabels() {
        this.providers.forEach(provider => {
            this.updateMarkerLabel(this.markers, provider);
            this.markerGroups.forEach(markerGroup => {
                this.updateMarkerLabel(markerGroup, provider);
            });
        });
    }
    onFilterLinkSelection(filterValue, $event) {
        if ($event) {
            $event.preventDefault();
        }
        if (filterValue === ProviderFilterKeyType.PROVIDER_VALUE_BASED_CARE) {
            this.providerFacade.getVBCVideoInfo();
        }
    }
    openExternalLink() {
        const navigationLink = {
            type: LinkType.EXTERNAL,
            title: '',
            href: this.valueBasedCareLearnMoreLink,
            target: TargetType.BLANK
        };
        this.navigationService.navigate(navigationLink);
    }
    updateMarkerLabel(markers, provider) {
        const marker = markers.find(marker => marker.addressId === provider.addressId && marker.id === provider.id);
        if (marker) {
            const index = this.singleProviderInListEnabled
                ? this.providerList.findIndex(item => item.id === provider.id)
                : this.providerList.indexOf(provider);
            marker.label = (index + 1).toString();
        }
    }
    onFilterSelected(event) {
        const providerFilterCheckBox = event.currentTarget;
        let dataLayerTags;
        if (providerFilterCheckBox.checked) {
            dataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PREFERENCES_PROVIDER_FILTER_ADD,
                [DataLayerGlobalVariable.PROVIDER_FILTER]: this.getProviderFilterType(event)
            };
        }
        else {
            dataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PREFERENCES_PROVIDER_FILTER_REMOVE,
                [DataLayerGlobalVariable.PROVIDER_FILTER]: this.getProviderFilterType(event)
            };
        }
        const isVbcFilterSelected = this.vbcList?.some(vbc => vbc.name === providerFilterCheckBox?.value);
        if (isVbcFilterSelected) {
            const selectedValue = providerFilterCheckBox?.value;
            let vbcFilterSelected = selectedValue;
            if (selectedValue === this.selectAllText) {
                const vbcNames = this.vbcList
                    .reduce((vbcNames, vbc) => {
                    if (vbc.name !== this.selectAllText) {
                        vbcNames.push(vbc.name);
                    }
                    return vbcNames;
                }, [])
                    .join('|');
                vbcFilterSelected = `${this.stringFormatUtilityService.convertToCamelCase(selectedValue)}:${vbcNames}`;
            }
            dataLayerTags = {
                ...dataLayerTags,
                [DataLayerGlobalVariable.PROVIDER_FILTER_VBC_ORG_NAME]: vbcFilterSelected
            };
        }
        this.analyticsService.googleDataLayerTags = dataLayerTags;
        if (this.providersFilterCheckBoxes?.length) {
            this.providers = this.providerFacade.getFilteredProviders(this.providersFilterCheckBoxes);
        }
        if (this.vbcNameFilterEnabled) {
            const selectedVbcNames = this.vbcList?.reduce((vbcOrgNames, vbcProvider) => {
                if (vbcProvider.selected) {
                    vbcOrgNames.push(vbcProvider.name);
                }
                return vbcOrgNames;
            }, []);
            if (selectedVbcNames?.length) {
                this.providers = this.getFilteredByVbc(selectedVbcNames);
            }
        }
        // It is important to follow the sequence of function calling where the provider list is updated first,
        // and then the map markers are updated accordingly to reflect the changes.
        this.providerList = this.singleProviderInListEnabled ? this.groupByProviderId(this.providers) : this.providers;
        this.filterProviders();
        this.markers = this.mapFacade.getProviderMarkers(this.filteredProviderGroups);
        this.setProviderMarkerLabels();
        this.mapContextService.setMarkers(this.markers);
        this.mapFacade.toggleSpinner(false);
        this.cdr.detectChanges();
    }
    setZipCode(zipCode) {
        if (zipCode !== this.previousZip || this.previousZip === '') {
            this.zip = zipCode;
            this.isZipUpdated = true;
            this.previousZip = this.zip;
            if (this.searchProviderByNameEnabled) {
                this.mapContextService.isCenterLocationSetByPharmacy = false;
                if (this.providerName?.value && this.providerName.value === this.previousProvider) {
                    this.configurableWidgetService.store.dispatch(new SetIsOptimalZoomEnabled(true));
                }
            }
        }
    }
    setZoom(zoom) {
        this.zoom = zoom;
    }
    validateZip() {
        const errors = this.widgetValidationService.validate();
        if (errors.length === 0) {
            if (this.providersFilterCheckBoxes?.length) {
                const vbcLabel = this.providerFacade.getProviderDisplayName(ProviderFilterKeyType.PROVIDER_VALUE_BASED_CARE);
                this.providersFilterCheckBoxes.forEach(element => {
                    if (!element.nativeElement.checked && element.nativeElement.value !== vbcLabel) {
                        this.isFilterChecked = true;
                        element.nativeElement.checked = true;
                    }
                    else if (element.nativeElement.value === vbcLabel) {
                        this.isFilterChecked = this.providerFacade.providersValueBasedCareFilterChecked;
                        element.nativeElement.checked = this.providerFacade.providersValueBasedCareFilterChecked;
                    }
                });
            }
            this.fetchProviders(!this.providers?.length);
        }
        else {
            this.checkFocus = true;
        }
    }
    getFilteredByVbc(selectedVbcNames) {
        return this.providers.filter(provider => provider?.valueBasedCare?.vbcOrgName && selectedVbcNames.includes(provider?.valueBasedCare?.vbcOrgName));
    }
    fetchProviders(isInitialFetch) {
        if (isInitialFetch ||
            this.isZipUpdated ||
            (this.providerName && this.providerName.value !== this.previousProvider) ||
            (this.generalPracticeFilterOptionEnabled && this.isGeneralPracticeOptionUpdate) ||
            (this.valueBasedCareToggleEnabled && this.isValueBasedCareOptionUpdate) ||
            this.mapContextService.isMapCenterChanged ||
            this.isFilterChecked) {
            this.mapFacade.toggleSpinner(true);
            if (this.isPreferenceBannerEnabled) {
                this.spinnerService.show(SpinnerEvent.PREFERENCE_BANNER_PROVIDER_LOADING);
            }
            let searchFields = 'zip';
            if (this.searchProviderByNameEnabled) {
                this.hasMinCharError = this.validatePharmacyError(this.providerName.value);
                if (this.hasMinCharError ||
                    (this.providerName && this.providerName.value !== this.previousProvider && this.previousProvider !== '')) {
                    this.mapContextService.isCenterLocationSetByPharmacy = false;
                }
                if (!this.hasMinCharError && this.providerName?.value && this.providerName.value !== this.previousProvider) {
                    searchFields = 'zip|name';
                    this.providerContext.providerByName = this.providerName.value;
                    this.previousProvider = this.providerName.value;
                    this.configurableWidgetService.store.dispatch(new SetIsOptimalZoomEnabled(true));
                }
            }
            this.mapFacade.setGeocoder(this.zip, this.providerMapDefaultZoom, this.minZoom, this.maxZoom, this.providerFacade.searchProviderByNameEnabled);
            this.mapFacade.showMap = true;
            this.zoom = this.getDefaultZoom();
            this.isZipUpdated = false;
            this.isGeneralPracticeOptionUpdate = false;
            this.isValueBasedCareOptionUpdate = false;
            this.previousProvider = this.providerName.value;
            this.tagsToUpdate(searchFields);
            this.isFilterChecked = false;
        }
    }
    updateProviders(pagination) {
        this.defaultStartItem = pagination.defaultStartItem;
        this.pageSize = this.providerPaginationEnabled ? pagination.pageSize : this.providerLimit;
        this.pageIndex = pagination.defaultStartItem;
        if (this.providerListContainer) {
            this.providerListContainer.updateFocus(this.isFocusEnabled);
        }
        this.cdr.detectChanges();
    }
    removeProvider(provider) {
        this.providerFacade.removeProvider$(provider).subscribe({
            next: message => {
                if (message) {
                    this.providerFacade.logRemoveProviderForAnalytics(provider);
                    this.providerFacade.selectedProviderIds[provider.id] = false;
                }
            }
        });
    }
    onGeneralPracticeSelect($event) {
        this.isGeneralPracticeOptionUpdate = true;
        this.selectedGeneralPracticeOption = $event;
    }
    onValueBasedToggleSelect($event) {
        this.isValueBasedCareOptionUpdate = true;
        this.selectedValueBasedToggleOption = $event;
    }
    getDefaultZoom() {
        this.mapFacade.zoomLevel = null;
        if (this.searchProviderByNameEnabled) {
            const providerValue = this.providerName.value;
            const optimalZoom = this.configurableWidgetService.store.selectSnapshot(MapState.optimalZoom);
            if (providerValue && providerValue.length >= 2 && optimalZoom) {
                return optimalZoom;
            }
        }
        return +this.providerMapDefaultZoom;
    }
    validatePharmacyError(provider) {
        if (!provider || provider.length === 1) {
            this.providerContext.providerByName = null;
        }
        return provider && provider.length < 2;
    }
    tagsToUpdate(searchCriteria) {
        let vbcFilterStatus = GOOGLE_ANALYTICS_NOT_APPLICABLE;
        if (this.selectedValueBasedToggleOption) {
            vbcFilterStatus = GOOGLE_ANALYTICS_YES;
        }
        else if (this.valueBasedCareToggleEnabled) {
            vbcFilterStatus = GOOGLE_ANALYTICS_NO;
        }
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PREFERENCES_PROVIDER_SEARCH,
            [DataLayerGlobalVariable.PROVIDER_SEARCH_FIELDS]: searchCriteria,
            [DataLayerGlobalVariable.PROVIDER_SEARCH_OPTION_GENERAL_PRACTICE]: this.selectedGeneralPracticeOption
                ? GOOGLE_ANALYTICS_YES
                : GOOGLE_ANALYTICS_NO,
            [DataLayerGlobalVariable.PROVIDER_SEARCH_OPTION_VBC]: vbcFilterStatus
        };
    }
    getProviderFilterType(event) {
        let providerFilterType;
        if (this.vbcList?.some(vbc => vbc.name === event.currentTarget?.value)) {
            providerFilterType = VBC_ORG;
        }
        else {
            providerFilterType = this.providerFilters?.find(item => item.label === event.currentTarget?.value)?.label;
        }
        return providerFilterType ?? '';
    }
}
ProviderSearchComponent.ɵfac = function ProviderSearchComponent_Factory(t) { return new (t || ProviderSearchComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(MapFacade), i0.ɵɵdirectiveInject(ProviderFacade), i0.ɵɵdirectiveInject(HelpfulToolsContextService), i0.ɵɵdirectiveInject(HelpfulToolsService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(MapContextService), i0.ɵɵdirectiveInject(i1.FormValidationService), i0.ɵɵdirectiveInject(ProviderContextService), i0.ɵɵdirectiveInject(i1.FilterService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.ProviderService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.StringFormatUtilityService)); };
ProviderSearchComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProviderSearchComponent, selectors: [["vnext-widget-provider-search"]], viewQuery: function ProviderSearchComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(ProviderListComponent, 5);
        i0.ɵɵviewQuery(_c0$1X, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.providerListContainer = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.providersFilterCheckBoxes = _t);
    } }, inputs: { isHelpfulToolsView: "isHelpfulToolsView", providerLimit: "providerLimit", providerMapDefaultZoom: "providerMapDefaultZoom", maxZoom: "maxZoom", minZoom: "minZoom", providersText: "providersText", providersBodyText: "providersBodyText", providersMultiBodyText: "providersMultiBodyText", retrieveZipCode: "retrieveZipCode", retrieveFipsCode: "retrieveFipsCode", errorKeywordText: "errorKeywordText", zipLabel: "zipLabel", zipErrorText: "zipErrorText", providerNameText: "providerNameText", providerNameHintText: "providerNameHintText", providerSearchButtonText: "providerSearchButtonText", itemsPerPage: "itemsPerPage", providerPaginationEnabled: "providerPaginationEnabled", viewNotFoundHeaderText: "viewNotFoundHeaderText", viewNotFoundBodyText: "viewNotFoundBodyText", paginationText: "paginationText", addProviderText: "addProviderText", providerAddedText: "providerAddedText", maxCountErrorMessage: "maxCountErrorMessage", maxCount: "maxCount", yourProviderText: "yourProviderText", removeProviderText: "removeProviderText", setPrimaryCareProviderText: "setPrimaryCareProviderText", primaryCareProviderText: "primaryCareProviderText", providerFiltersEnabled: "providerFiltersEnabled", providerFilters: "providerFilters", providerGroupAddedLabelText: "providerGroupAddedLabelText", providerGroupAddLabelText: "providerGroupAddLabelText", countyLabel: "countyLabel", showCountyLabel: "showCountyLabel", addLinkText: "addLinkText", cancelProvidersLabel: "cancelProvidersLabel", providerSingleSelectEnabled: "providerSingleSelectEnabled", providerExistsTooltipText: "providerExistsTooltipText", providerMultiLocationText: "providerMultiLocationText", selectProviderLabelText: "selectProviderLabelText", countryCode: "countryCode", acceptingNewPatientsText: "acceptingNewPatientsText", acceptingNewPatientsIcon: "acceptingNewPatientsIcon", languagesIcon: "languagesIcon", providerLocationsText: "providerLocationsText", valueBasedCareEnabled: "valueBasedCareEnabled", valueBasedCareIcon: "valueBasedCareIcon", valueBasedCareText: "valueBasedCareText", generalPracticeOptions: "generalPracticeOptions", generalPracticeToolTipText: "generalPracticeToolTipText", generalPracticeLabel: "generalPracticeLabel", generalPracticeFilterOptionEnabled: "generalPracticeFilterOptionEnabled", singleProviderInListEnabled: "singleProviderInListEnabled", updateLinkText: "updateLinkText", editLinkText: "editLinkText", showEditLinkEnabled: "showEditLinkEnabled", isValueBasedCareLearnMoreLink2Enabled: "isValueBasedCareLearnMoreLink2Enabled", valueBasedCareAvailableText: "valueBasedCareAvailableText", valueBasedCareLearnMoreLink: "valueBasedCareLearnMoreLink", valueBasedCareLearnMoreText: "valueBasedCareLearnMoreText", valueBasedCareToggleLabel: "valueBasedCareToggleLabel", valueBasedCareToggleEnabled: "valueBasedCareToggleEnabled", valueBasedCareToggleToolTipText: "valueBasedCareToggleToolTipText", valueBasedCareToggleOptions: "valueBasedCareToggleOptions", newPatientToggleEnabled: "newPatientToggleEnabled", newPatientToggleLabel: "newPatientToggleLabel", newPatientToggleOptions: "newPatientToggleOptions", pcpToggleEnabled: "pcpToggleEnabled", pcpToggleLabel: "pcpToggleLabel", pcpToggleOptions: "pcpToggleOptions", newPatientText: "newPatientText", existingPatientText: "existingPatientText", vbcNameFilterEnabled: "vbcNameFilterEnabled", vbcNameFilterLabel: "vbcNameFilterLabel", selectedProviderOptionsEnabled: "selectedProviderOptionsEnabled", removeText: "removeText", selectAllText: "selectAllText", isZelisIntegrationEnabled: "isZelisIntegrationEnabled", isPreferenceBannerEnabled: "isPreferenceBannerEnabled" }, outputs: { fetchProvidersFromLocation: "fetchProvidersFromLocation", initializeMap: "initializeMap", setMapCenter: "setMapCenter", setMapDefaultBounds: "setMapDefaultBounds", addProviders: "addProviders", addProviderSelectedFromMarker: "addProviderSelectedFromMarker", fetchProvidersFromAPI: "fetchProvidersFromAPI" }, decls: 23, vars: 55, consts: [["class", "pb-3", 4, "ngIf"], [1, "row", "px-1"], ["aria-live", "polite", 1, "col-12"], [1, "padd-4"], [1, "container-row", "flex-row-nowrap"], [1, "zip-code-name", "flex-row-nowrap", 3, "ngClass"], [1, "zip-code-input", "mr-2"], [1, "zipcode-width", 3, "customStyles", "showCounty", "retrieveZipCode", "retrieveFipsCode", "errorKeywordText", "zipCodeText", "zipCodeErrorText", "countyLabel", "showCountyLabel", "zip", "keyup.enter"], ["class", "provider-name-field flex-1 mr-2", 4, "ngIf"], [3, "generalPracticeFilterOptionEnabled", "generalPracticeLabel", "generalPracticeToolTipText", "generalPracticeOptions", "optionSelected"], [3, "valueBasedCareToggleEnabled", "valueBasedCareToggleLabel", "valueBasedCareToggleToolTipText", "valueBasedCareToggleOptions", "optionSelected"], ["aria-labelledby", "providerSearch", 1, "btn", "Spa_Style_SecondaryButton", "zipcode-search-button", "provider-border-color", "provider-search-button", "align-self-end", 3, "click"], ["id", "providerSearch", 1, "ml-1"], ["class", "mt-2", 4, "ngIf"], ["class", "row", 4, "ngIf"], [1, "pl-3", "pr-3"], ["class", "row provider mb-3 provider-border-color no-translate-block", 3, "ngClass", 4, "ngIf"], [1, "col-12"], [3, "selectedProviders", "providers", "yourProviderText", "removeProviderText", "setPrimaryCareProviderText", "primaryCareProviderText", "chosenProvider", "providerSingleSelectEnabled", "addLinkText", "cancelProvidersLabel", "providerMultiLocationText", "selectProviderLabelText", "maxCount", "maxCountErrorMessage", "singleProviderInListEnabled", "updateLinkText", "newPatientToggleEnabled", "newPatientToggleLabel", "newPatientToggleOptions", "pcpToggleEnabled", "pcpToggleLabel", "pcpToggleOptions", "addProviders", "addProvider", "setAsPrimaryCareProvider"], ["class", "col-12", 4, "ngIf"], [1, "pb-3"], ["aria-relevant", "text", 1, "row"], ["id", "drugsearch", 1, "col-12"], [1, "text-center"], ["aria-hidden", "true", 1, "fas", "Spa_Style_ProvidersIcon", "provider-icon", "pl-2", "pl-md-0"], ["class", "Spa_Style_H1", 4, "liveEditProp"], ["navigationAdapter", "", "class", "Spa_Style_IntroParagraph", 3, "innerHtml", 4, "liveEditProp"], [1, "Spa_Style_H1"], ["navigationAdapter", "", 1, "Spa_Style_IntroParagraph", 3, "innerHtml"], [1, "provider-name-field", "flex-1", "mr-2"], ["class", "error-display error-color text-nowrap", 4, "ngIf"], ["for", "provider-name-text-input", "class", "Spa_Style_Label w-100", 4, "liveEditProp"], ["id", "provider-name-text-input", "type", "text", "class", "Spa_Style_Paragraph provider-name-input", 3, "placeholder", "formControl", "keyup.enter", 4, "liveEditProp"], [1, "error-display", "error-color", "text-nowrap"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], ["for", "provider-name-text-input", 1, "Spa_Style_Label", "w-100"], ["id", "provider-name-text-input", "type", "text", 1, "Spa_Style_Paragraph", "provider-name-input", 3, "placeholder", "formControl", "keyup.enter"], [1, "mt-2"], [1, "provider-search-filter-text", "ml-1", 3, "innerHTML"], [1, "pl-2", 3, "isLinkButton", "title", "makeInlineBlock", "ariaHasPopup", "click", "keydown.enter"], [1, "row"], ["class", "provider-search-filter-item", 3, "ngClass", 4, "ngFor", "ngForOf"], ["class", "col-12 ml-1 provider-search-filter-text", 4, "ngIf"], [1, "provider-search-filter-item", 3, "ngClass"], [4, "ngIf"], ["type", "checkbox", "role", "checkbox", 3, "value", "id", "checked", "change"], ["providerFilterCheckBox", ""], [1, "provider-search-filter-text", "ml-1", 3, "for"], ["class", "pl-2", 3, "isLinkButton", "title", "makeInlineBlock", "ariaHasPopup", "click", "keydown.enter", 4, "ngIf"], [1, "col-12", "ml-1", "provider-search-filter-text"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["type", "checkbox", "role", "checkbox", 3, "value", "checked", "id", "change"], [1, "row", "provider", "mb-3", "provider-border-color", "no-translate-block", 3, "ngClass"], [1, "col-12", "col-md-12", "col-lg-5", "order-last", "order-lg-first", "provider-wrapper", "px-0"], ["class", "col-12 col-md-12 col-lg-7 order-first order-lg-last p-0", 4, "ngIf"], ["class", "provider-list provider-border-color", 4, "ngFor", "ngForOf"], [1, "provider-list", "provider-border-color"], [3, "alreadySelectedProvider", "isHelpfulToolsView", "provider", "pageSize", "pageIndex", "selectedProviders", "addProviderText", "providerLocationsText", "providerAddedText", "maxCountErrorMessage", "maxCount", "customClass", "alternateViewClass", "alternateNumberIndicatorClass", "isProviderAdded", "backgroundStyle", "index", "isPrimary", "providerExistsTooltipText", "countryCode", "acceptingNewPatientsIcon", "acceptingNewPatientsText", "languagesIcon", "providerGroup", "providerSingleSelectEnabled", "valueBasedCareEnabled", "valueBasedCareIcon", "valueBasedCareText", "singleProviderInListEnabled", "primaryCareProviderText", "isZelisIntegrationEnabled", "addProvider"], [1, "col-12", "px-2", "mt-2"], [1, "text-center", "Spa_Style_H3", "mt-1"], [1, "Spa_Style_Paragraph", "pt-1", "no-pharmacies-body-text"], [1, "col-12", "col-md-12", "col-lg-7", "order-first", "order-lg-last", "p-0"], [3, "zip", "zoom", "minZoom", "maxZoom", "isHelpfulToolsView", "isProvider", "addButtonText", "addedLabel", "markers", "markerGroups", "limitErrorMessage", "groupAddedLabel", "groupAddText", "providerExistsTooltipText", "providerSingleSelectEnabled", "primaryIconAriaLabelText", "setZoom", "resetToDefaultPageIndex", "setMapCenter", "setMap", "setMapDefaultBounds", "addSelectedItem"], ["class", "col-md-5 col-12 px-0 pr-md-3", 4, "ngIf"], [1, "col-md-5", "col-12", "px-0", "pr-md-3"], [3, "pagination", "defaultStartItem", "itemsPerPage", "paginationText", "updatePagination"], [3, "selectedProviders", "yourProviderText", "removeProviderText", "setPrimaryCareProviderText", "primaryCareProviderText", "iconClass", "backgroundStyleColor", "countryCode", "editLinkText", "showEditLinkEnabled", "providerSingleSelectEnabled", "singleProviderInListEnabled", "newPatientText", "existingPatientText", "selectedProviderOptionsEnabled", "removeText", "removeProvider", "setAsPrimaryCareProvider", "editProvider"]], template: function ProviderSearchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ProviderSearchComponent_div_0_Template, 7, 2, "div", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "div", 6)(7, "vnext-zip-code-input", 7);
        i0.ɵɵlistener("zip", function ProviderSearchComponent_Template_vnext_zip_code_input_zip_7_listener($event) { return ctx.setZipCode($event); })("keyup.enter", function ProviderSearchComponent_Template_vnext_zip_code_input_keyup_enter_7_listener() { return ctx.validateZip(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(8, ProviderSearchComponent_div_8_Template, 4, 3, "div", 8);
        i0.ɵɵelementStart(9, "vnext-widget-general-practice-toggle", 9);
        i0.ɵɵlistener("optionSelected", function ProviderSearchComponent_Template_vnext_widget_general_practice_toggle_optionSelected_9_listener($event) { return ctx.onGeneralPracticeSelect($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "vnext-widget-value-based-provider-toggle", 10);
        i0.ɵɵlistener("optionSelected", function ProviderSearchComponent_Template_vnext_widget_value_based_provider_toggle_optionSelected_10_listener($event) { return ctx.onValueBasedToggleSelect($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(11, "button", 11);
        i0.ɵɵlistener("click", function ProviderSearchComponent_Template_button_click_11_listener() { return ctx.validateZip(); });
        i0.ɵɵelement(12, "i");
        i0.ɵɵelementStart(13, "span", 12);
        i0.ɵɵtext(14);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵtemplate(15, ProviderSearchComponent_div_15_Template, 4, 8, "div", 13);
        i0.ɵɵtemplate(16, ProviderSearchComponent_div_16_Template, 3, 2, "div", 14);
        i0.ɵɵelementStart(17, "div", 15);
        i0.ɵɵtemplate(18, ProviderSearchComponent_div_18_Template, 5, 6, "div", 16);
        i0.ɵɵtemplate(19, ProviderSearchComponent_div_19_Template, 2, 1, "div", 14);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(20, "div", 17)(21, "vnext-widget-multiple-provider-address", 18);
        i0.ɵɵlistener("addProviders", function ProviderSearchComponent_Template_vnext_widget_multiple_provider_address_addProviders_21_listener($event) { return ctx.providersAddToList($event); })("addProvider", function ProviderSearchComponent_Template_vnext_widget_multiple_provider_address_addProvider_21_listener($event) { return ctx.addToSelectedProvider($event); })("setAsPrimaryCareProvider", function ProviderSearchComponent_Template_vnext_widget_multiple_provider_address_setAsPrimaryCareProvider_21_listener($event) { return ctx.providerFacade.setAsPrimaryCareProvider($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(22, ProviderSearchComponent_div_22_Template, 2, 16, "div", 19);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.isHelpfulToolsView);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(53, _c3$o, ctx.searchProviderByNameEnabled));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("customStyles", ctx.zipCodeStyles)("showCounty", false)("retrieveZipCode", ctx.retrieveZipCode)("retrieveFipsCode", ctx.retrieveFipsCode)("errorKeywordText", ctx.errorKeywordText)("zipCodeText", ctx.zipLabel)("zipCodeErrorText", ctx.zipErrorText)("countyLabel", ctx.countyLabel)("showCountyLabel", ctx.showCountyLabel);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.searchProviderByNameEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("generalPracticeFilterOptionEnabled", ctx.generalPracticeFilterOptionEnabled)("generalPracticeLabel", ctx.generalPracticeLabel)("generalPracticeToolTipText", ctx.generalPracticeToolTipText)("generalPracticeOptions", ctx.generalPracticeOptions);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("valueBasedCareToggleEnabled", ctx.valueBasedCareToggleEnabled)("valueBasedCareToggleLabel", ctx.valueBasedCareToggleLabel)("valueBasedCareToggleToolTipText", ctx.valueBasedCareToggleToolTipText)("valueBasedCareToggleOptions", ctx.valueBasedCareToggleOptions);
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("ml-1", ctx.searchProviderByNameEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("fas ", ctx.mapFacade.showSpinner ? "fa-spinner fa-spin" : "fa-search", "");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.providerSearchButtonText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isValueBasedCareLearnMoreLink2Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.providerFiltersEnabled && ctx.mapFacade.showMap);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.mapFacade.showMap);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.mapFacade.showMap);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("selectedProviders", ctx.selectedProviders)("providers", ctx.providers)("yourProviderText", ctx.yourProviderText)("removeProviderText", ctx.removeProviderText)("setPrimaryCareProviderText", ctx.setPrimaryCareProviderText)("primaryCareProviderText", ctx.primaryCareProviderText)("chosenProvider", ctx.selectedProvider)("providerSingleSelectEnabled", ctx.providerSingleSelectEnabled)("addLinkText", ctx.addLinkText)("cancelProvidersLabel", ctx.cancelProvidersLabel)("providerMultiLocationText", ctx.providerMultiLocationText)("selectProviderLabelText", ctx.selectProviderLabelText)("maxCount", ctx.maxCount)("maxCountErrorMessage", ctx.maxCountErrorMessage)("singleProviderInListEnabled", ctx.singleProviderInListEnabled)("updateLinkText", ctx.updateLinkText)("newPatientToggleEnabled", ctx.newPatientToggleEnabled)("newPatientToggleLabel", ctx.newPatientToggleLabel)("newPatientToggleOptions", ctx.newPatientToggleOptions)("pcpToggleEnabled", ctx.pcpToggleEnabled)("pcpToggleLabel", ctx.pcpToggleLabel)("pcpToggleOptions", ctx.pcpToggleOptions);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ((ctx.providers == null ? null : ctx.providers.length) || (ctx.selectedProviders == null ? null : ctx.selectedProviders.length)) && !ctx.isHelpfulToolsView);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i4.DefaultValueAccessor, i4.NgControlStatus, i4.FormControlDirective, ZipCodeInputComponent, PaginationComponent, LinkComponent, NavigationAdapterDirective, LiveEditPropDirective, IconAriaAttributesDirective, ProviderListComponent, MapComponent, SelectedProviderComponent, GeneralPracticeToggleComponent, ValueBasedProviderToggleComponent, MultipleProviderAddressComponent, i1$2.AsyncPipe, i1$2.SlicePipe, SafePipe], styles: [".provider-icon[_ngcontent-%COMP%]{font-size:46px}.zipcode-width[_ngcontent-%COMP%]{width:auto}.error-display[_ngcontent-%COMP%]{height:24px}.provider-name-input[_ngcontent-%COMP%]{height:38px;width:100%}.zipcode-search-button[_ngcontent-%COMP%]{line-height:1.4}.provider[_ngcontent-%COMP%]{border-radius:5px;border-width:1px;border-style:solid}.provider-wrapper[_ngcontent-%COMP%]{max-height:455px;overflow-y:auto}.provider-list[_ngcontent-%COMP%]{padding:10px 0;float:left;width:100%;border-width:0 0 1px;border-style:solid}.provider-search-filter-item[_ngcontent-%COMP%]{justify-content:space-around;padding:15px 0 10px 19px;margin:0;list-style:none}.provider-list[_ngcontent-%COMP%]:last-child{border-bottom:none}.underline[_ngcontent-%COMP%]{text-decoration:underline}.provider-border-color[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent1)}.provider-search-button[_ngcontent-%COMP%]{height:38px;min-width:105px}.no-pharmacies-body-text[_ngcontent-%COMP%]{line-height:24px}.flex-row-nowrap[_ngcontent-%COMP%]{display:flex;flex-wrap:nowrap;align-items:flex-end}.flex-1[_ngcontent-%COMP%]{flex:1}.padd-4[_ngcontent-%COMP%]{padding:0 4px}.bg-grey[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray2)}.provider-search-filter-text[_ngcontent-%COMP%]{font-family:montserrat_light;font-size:var(--Spa_Style_Small_Font);color:var(--static-Spa_Style_Black)}@media print{.col-md-12.col-lg-5[_ngcontent-%COMP%]{flex:0 0 41.6667%;max-width:41.6667%}.col-md-12.col-lg-7[_ngcontent-%COMP%]{flex:0 0 58.3333%;max-width:58.3333%}.order-lg-first[_ngcontent-%COMP%]{order:-1}.order-lg-last[_ngcontent-%COMP%]{order:13}}@media (max-width: 680px){.provider-search-filter-item[_ngcontent-%COMP%]{padding:10px 0 6px 19px}.zip-code-name[_ngcontent-%COMP%]{flex-direction:column;align-items:flex-start;justify-content:flex-start;align-self:stretch}.container-row[_ngcontent-%COMP%]{flex-direction:column;align-items:flex-start;justify-content:flex-start}.provider-search-button[_ngcontent-%COMP%]{margin-top:1rem;align-self:stretch!important;margin-left:0!important}.provider-name-field[_ngcontent-%COMP%]{align-self:stretch;margin:1rem 0 1.5rem}}@media (min-width: 767px) and (max-width: 769px){.zip-code-name[_ngcontent-%COMP%]{margin-bottom:1rem;align-self:stretch}.container-row[_ngcontent-%COMP%]{flex-direction:column;align-items:flex-start;justify-content:flex-start}.provider-search-button[_ngcontent-%COMP%]{align-self:stretch!important;margin-left:0!important}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProviderSearchComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-provider-search', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"!isHelpfulToolsView\" class=\"pb-3\">\r\n  <div class=\"row\" aria-relevant=\"text\">\r\n    <div id=\"drugsearch\" class=\"col-12\">\r\n      <div class=\"text-center\">\r\n        <i class=\"fas Spa_Style_ProvidersIcon provider-icon pl-2 pl-md-0\" aria-hidden=\"true\"></i>\r\n        <h1 *liveEditProp=\"'Spa_Site_Providers_Text'\" class=\"Spa_Style_H1\">{{ providersText }}</h1>\r\n        <p\r\n          *liveEditProp=\"'Spa_Site_Providers_Body_Text'\"\r\n          navigationAdapter\r\n          class=\"Spa_Style_IntroParagraph\"\r\n          [innerHtml]=\"(providerSingleSelectEnabled ? providersMultiBodyText : providersBodyText) | safe : 'html'\"\r\n        ></p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"row px-1\">\r\n  <div class=\"col-12\" aria-live=\"polite\">\r\n    <div class=\"padd-4\">\r\n      <div class=\"container-row flex-row-nowrap\">\r\n        <div class=\"zip-code-name flex-row-nowrap\" [ngClass]=\"{ 'flex-1': searchProviderByNameEnabled }\">\r\n          <div class=\"zip-code-input mr-2\">\r\n            <vnext-zip-code-input\r\n              class=\"zipcode-width\"\r\n              [customStyles]=\"zipCodeStyles\"\r\n              [showCounty]=\"false\"\r\n              [retrieveZipCode]=\"retrieveZipCode\"\r\n              [retrieveFipsCode]=\"retrieveFipsCode\"\r\n              [errorKeywordText]=\"errorKeywordText\"\r\n              [zipCodeText]=\"zipLabel\"\r\n              [zipCodeErrorText]=\"zipErrorText\"\r\n              [countyLabel]=\"countyLabel\"\r\n              [showCountyLabel]=\"showCountyLabel\"\r\n              (zip)=\"setZipCode($event)\"\r\n              (keyup.enter)=\"validateZip()\"\r\n            >\r\n            </vnext-zip-code-input>\r\n          </div>\r\n          <div *ngIf=\"searchProviderByNameEnabled\" class=\"provider-name-field flex-1 mr-2\">\r\n            <span *ngIf=\"hasMinCharError\" class=\"error-display error-color text-nowrap\"\r\n              ><i aria-hidden=\"true\" class=\"fas fa-exclamation-circle\"></i> {{ providerErrorText }}</span\r\n            >\r\n            <label *liveEditProp=\"'Spa_ProviderName_Text'\" for=\"provider-name-text-input\" class=\"Spa_Style_Label w-100\">\r\n              {{ providerNameText }}\r\n            </label>\r\n            <input\r\n              *liveEditProp=\"'Spa_ProviderName_HintText'\"\r\n              id=\"provider-name-text-input\"\r\n              type=\"text\"\r\n              class=\"Spa_Style_Paragraph provider-name-input\"\r\n              [placeholder]=\"providerNameHintText\"\r\n              [formControl]=\"providerName\"\r\n              (keyup.enter)=\"validateZip()\"\r\n            />\r\n          </div>\r\n          <vnext-widget-general-practice-toggle\r\n            [generalPracticeFilterOptionEnabled]=\"generalPracticeFilterOptionEnabled\"\r\n            [generalPracticeLabel]=\"generalPracticeLabel\"\r\n            [generalPracticeToolTipText]=\"generalPracticeToolTipText\"\r\n            [generalPracticeOptions]=\"generalPracticeOptions\"\r\n            (optionSelected)=\"onGeneralPracticeSelect($event)\"\r\n          >\r\n          </vnext-widget-general-practice-toggle>\r\n          <vnext-widget-value-based-provider-toggle\r\n            [valueBasedCareToggleEnabled]=\"valueBasedCareToggleEnabled\"\r\n            [valueBasedCareToggleLabel]=\"valueBasedCareToggleLabel\"\r\n            [valueBasedCareToggleToolTipText]=\"valueBasedCareToggleToolTipText\"\r\n            [valueBasedCareToggleOptions]=\"valueBasedCareToggleOptions\"\r\n            (optionSelected)=\"onValueBasedToggleSelect($event)\"\r\n          >\r\n          </vnext-widget-value-based-provider-toggle>\r\n        </div>\r\n        <button\r\n          class=\"btn Spa_Style_SecondaryButton zipcode-search-button provider-border-color provider-search-button align-self-end\"\r\n          aria-labelledby=\"providerSearch\"\r\n          [class.ml-1]=\"searchProviderByNameEnabled\"\r\n          (click)=\"validateZip()\"\r\n        >\r\n          <i class=\"fas {{ mapFacade.showSpinner ? 'fa-spinner fa-spin' : 'fa-search' }}\"></i>\r\n          <span class=\"ml-1\" id=\"providerSearch\">{{ providerSearchButtonText }}</span>\r\n        </button>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"mt-2\" *ngIf=\"isValueBasedCareLearnMoreLink2Enabled\">\r\n      <span class=\"provider-search-filter-text ml-1\" [innerHTML]=\"valueBasedCareAvailableText | safe : 'html'\"></span>\r\n      <vnext-link\r\n        class=\"pl-2\"\r\n        [isLinkButton]=\"true\"\r\n        [title]=\"valueBasedCareLearnMoreText\"\r\n        [makeInlineBlock]=\"true\"\r\n        [ariaHasPopup]=\"true\"\r\n        (click)=\"openExternalLink()\"\r\n        (keydown.enter)=\"openExternalLink()\"\r\n      ></vnext-link>\r\n    </div>\r\n    <div class=\"row\" *ngIf=\"providerFiltersEnabled && this.mapFacade.showMap\">\r\n      <div\r\n        *ngFor=\"let providerFilter of providerFilters; index as i\"\r\n        class=\"provider-search-filter-item\"\r\n        [ngClass]=\"{ 'Spa_Style_Paragraph ': (providerFacade.isMobile$ | async) }\"\r\n      >\r\n        <ng-container *ngIf=\"!providerFilter.disabled\">\r\n          <input\r\n            #providerFilterCheckBox\r\n            type=\"checkbox\"\r\n            value=\"{{ providerFilter.label }}\"\r\n            role=\"checkbox\"\r\n            [id]=\"i + 'providerFilterCheckBox'\"\r\n            [checked]=\"providerFilter.initiallyChecked\"\r\n            (change)=\"onFilterSelected($event)\"\r\n          /><label [for]=\"i + 'providerFilterCheckBox'\" class=\"provider-search-filter-text ml-1\">{{ providerFilter.label }}</label>\r\n          <vnext-link\r\n            *ngIf=\"providerFilter.link\"\r\n            class=\"pl-2\"\r\n            [isLinkButton]=\"true\"\r\n            [title]=\"providerFilter.link\"\r\n            [makeInlineBlock]=\"true\"\r\n            [ariaHasPopup]=\"true\"\r\n            (click)=\"onFilterLinkSelection(providerFilter.value)\"\r\n            (keydown.enter)=\"onFilterLinkSelection(providerFilter.value, $event)\"\r\n          ></vnext-link>\r\n        </ng-container>\r\n      </div>\r\n      <div *ngIf=\"vbcNameFilterEnabled && vbcList?.length > 1\" class=\"col-12 ml-1 provider-search-filter-text\">\r\n        <label>{{ vbcNameFilterLabel }}</label>\r\n        <ng-container *ngFor=\"let vbc of vbcList; index as i; trackBy: trackByVbcId\">\r\n          <div>\r\n            <input\r\n              type=\"checkbox\"\r\n              [value]=\"vbc.name\"\r\n              [checked]=\"vbc.selected\"\r\n              role=\"checkbox\"\r\n              [id]=\"i + 'vbcCheckBox'\"\r\n              (change)=\"onVbcSelection(i, $event)\"\r\n            /><label [for]=\"i + 'vbcCheckBox'\" class=\"provider-search-filter-text ml-1\">{{ vbc.name }}</label>\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n    </div>\r\n    <div class=\"pl-3 pr-3\">\r\n      <div\r\n        *ngIf=\"mapFacade.showMap\"\r\n        [ngClass]=\"{ 'mt-3': !providerFiltersEnabled }\"\r\n        class=\"row provider mb-3 provider-border-color no-translate-block\"\r\n      >\r\n        <div class=\"col-12 col-md-12 col-lg-5 order-last order-lg-first provider-wrapper px-0\">\r\n          <ng-container *ngIf=\"providers?.length > 0\">\r\n            <div\r\n              class=\"provider-list provider-border-color\"\r\n              *ngFor=\"let provider of providerList | slice : startValueOfItemsToBeSliced : endValueOfItemsToBeSliced; index as i\"\r\n            >\r\n              <vnext-widget-provider-list\r\n                [alreadySelectedProvider]=\"providerFacade.selectedProviderIds[provider.id]\"\r\n                [isHelpfulToolsView]=\"isHelpfulToolsView\"\r\n                [provider]=\"provider\"\r\n                [pageSize]=\"pageSize\"\r\n                [pageIndex]=\"pageIndex\"\r\n                [selectedProviders]=\"selectedProviders\"\r\n                [addProviderText]=\"addProviderText\"\r\n                [providerLocationsText]=\"providerLocationsText\"\r\n                [providerAddedText]=\"providerAddedText\"\r\n                [maxCountErrorMessage]=\"maxCountErrorMessage\"\r\n                [maxCount]=\"maxCount\"\r\n                [customClass]=\"providerFacade.getProviderPinClass(provider, false, isHelpfulToolsView)\"\r\n                [alternateViewClass]=\"providerFacade.noticeAlternateView(provider)\"\r\n                [alternateNumberIndicatorClass]=\"providerFacade.noticeAlternateProviderIndicator(provider)\"\r\n                [isProviderAdded]=\"\r\n                  providerFacade.isProviderAdded(provider.id, provider.addressId, provider.providerGroup, !providerSingleSelectEnabled)\r\n                \"\r\n                [backgroundStyle]=\"providerFacade.getPrimaryProviderBackgroundColor(provider, isHelpfulToolsView)\"\r\n                [index]=\"i\"\r\n                [isPrimary]=\"providerFacade.isPcp(provider)\"\r\n                [providerExistsTooltipText]=\"providerExistsTooltipText\"\r\n                [countryCode]=\"countryCode\"\r\n                [acceptingNewPatientsIcon]=\"acceptingNewPatientsIcon\"\r\n                [acceptingNewPatientsText]=\"acceptingNewPatientsText\"\r\n                [languagesIcon]=\"languagesIcon\"\r\n                [providerGroup]=\"provider.providerGroup\"\r\n                [providerSingleSelectEnabled]=\"providerSingleSelectEnabled\"\r\n                [valueBasedCareEnabled]=\"valueBasedCareEnabled\"\r\n                [valueBasedCareIcon]=\"valueBasedCareIcon\"\r\n                [valueBasedCareText]=\"valueBasedCareText\"\r\n                [singleProviderInListEnabled]=\"singleProviderInListEnabled\"\r\n                [primaryCareProviderText]=\"primaryCareProviderText\"\r\n                [isZelisIntegrationEnabled]=\"isZelisIntegrationEnabled\"\r\n                (addProvider)=\"addToSelectedProvider($event)\"\r\n              >\r\n              </vnext-widget-provider-list>\r\n            </div>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"!(providers?.length > 0) && !mapFacade.showSpinner\">\r\n            <div class=\"col-12 px-2 mt-2\">\r\n              <h3 class=\"text-center Spa_Style_H3 mt-1\">\r\n                {{ viewNotFoundHeaderText }}\r\n              </h3>\r\n              <p class=\"Spa_Style_Paragraph pt-1 no-pharmacies-body-text\">\r\n                {{ viewNotFoundBodyText }}\r\n              </p>\r\n            </div>\r\n          </ng-container>\r\n        </div>\r\n        <div *ngIf=\"zip\" class=\"col-12 col-md-12 col-lg-7 order-first order-lg-last p-0\">\r\n          <vnext-widget-map\r\n            [zip]=\"zip\"\r\n            [zoom]=\"zoom\"\r\n            [minZoom]=\"minZoom\"\r\n            [maxZoom]=\"maxZoom\"\r\n            [isHelpfulToolsView]=\"isHelpfulToolsView\"\r\n            [isProvider]=\"true\"\r\n            [addButtonText]=\"addProviderText\"\r\n            [addedLabel]=\"providerAddedText\"\r\n            [markers]=\"markers\"\r\n            [markerGroups]=\"markerGroups\"\r\n            [limitErrorMessage]=\"maxCountErrorMessage\"\r\n            [groupAddedLabel]=\"providerGroupAddedLabelText\"\r\n            [groupAddText]=\"providerGroupAddLabelText\"\r\n            [providerExistsTooltipText]=\"providerExistsTooltipText\"\r\n            [providerSingleSelectEnabled]=\"providerSingleSelectEnabled\"\r\n            [primaryIconAriaLabelText]=\"primaryCareProviderText\"\r\n            (setZoom)=\"setZoom($event)\"\r\n            (resetToDefaultPageIndex)=\"updateProviders({ pageSize: itemsPerPage, defaultStartItem: 1 })\"\r\n            (setMapCenter)=\"setMapCenter.emit($event)\"\r\n            (setMap)=\"initializeMap.emit($event)\"\r\n            (setMapDefaultBounds)=\"setMapDefaultBounds.emit($event)\"\r\n            (addSelectedItem)=\"addToMapSelectedProvider($event)\"\r\n          >\r\n          </vnext-widget-map>\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"this.mapFacade.showMap\" class=\"row\">\r\n        <div *ngIf=\"providerPaginationEnabled && itemsPerPage < providerList?.length\" class=\"col-md-5 col-12 px-0 pr-md-3\">\r\n          <vnext-pagination\r\n            [pagination]=\"providerList\"\r\n            [defaultStartItem]=\"defaultStartItem\"\r\n            [itemsPerPage]=\"itemsPerPage\"\r\n            [paginationText]=\"paginationText\"\r\n            (updatePagination)=\"updateProviders($event)\"\r\n          ></vnext-pagination>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-12\">\r\n    <vnext-widget-multiple-provider-address\r\n      [selectedProviders]=\"selectedProviders\"\r\n      [providers]=\"providers\"\r\n      [yourProviderText]=\"yourProviderText\"\r\n      [removeProviderText]=\"removeProviderText\"\r\n      [setPrimaryCareProviderText]=\"setPrimaryCareProviderText\"\r\n      [primaryCareProviderText]=\"primaryCareProviderText\"\r\n      [chosenProvider]=\"selectedProvider\"\r\n      [providerSingleSelectEnabled]=\"providerSingleSelectEnabled\"\r\n      [addLinkText]=\"addLinkText\"\r\n      [cancelProvidersLabel]=\"cancelProvidersLabel\"\r\n      [providerMultiLocationText]=\"providerMultiLocationText\"\r\n      [selectProviderLabelText]=\"selectProviderLabelText\"\r\n      [maxCount]=\"maxCount\"\r\n      [maxCountErrorMessage]=\"maxCountErrorMessage\"\r\n      [singleProviderInListEnabled]=\"singleProviderInListEnabled\"\r\n      [updateLinkText]=\"updateLinkText\"\r\n      [newPatientToggleEnabled]=\"newPatientToggleEnabled\"\r\n      [newPatientToggleLabel]=\"newPatientToggleLabel\"\r\n      [newPatientToggleOptions]=\"newPatientToggleOptions\"\r\n      [pcpToggleEnabled]=\"pcpToggleEnabled\"\r\n      [pcpToggleLabel]=\"pcpToggleLabel\"\r\n      [pcpToggleOptions]=\"pcpToggleOptions\"\r\n      (addProviders)=\"providersAddToList($event)\"\r\n      (addProvider)=\"addToSelectedProvider($event)\"\r\n      (setAsPrimaryCareProvider)=\"providerFacade.setAsPrimaryCareProvider($event)\"\r\n    >\r\n    </vnext-widget-multiple-provider-address>\r\n  </div>\r\n  <div *ngIf=\"(providers?.length || selectedProviders?.length) && !isHelpfulToolsView\" class=\"col-12\">\r\n    <vnext-widget-selected-provider\r\n      [selectedProviders]=\"selectedProviders\"\r\n      [yourProviderText]=\"yourProviderText\"\r\n      [removeProviderText]=\"removeProviderText\"\r\n      [setPrimaryCareProviderText]=\"setPrimaryCareProviderText\"\r\n      [primaryCareProviderText]=\"primaryCareProviderText\"\r\n      [iconClass]=\"providerFacade.primaryPinIcon\"\r\n      [backgroundStyleColor]=\"providerFacade.getPrimaryProviderBackgroundColor()\"\r\n      [countryCode]=\"countryCode\"\r\n      [editLinkText]=\"editLinkText\"\r\n      [showEditLinkEnabled]=\"showEditLinkEnabled\"\r\n      [providerSingleSelectEnabled]=\"providerSingleSelectEnabled\"\r\n      [singleProviderInListEnabled]=\"singleProviderInListEnabled\"\r\n      [newPatientText]=\"newPatientText\"\r\n      [existingPatientText]=\"existingPatientText\"\r\n      [selectedProviderOptionsEnabled]=\"selectedProviderOptionsEnabled\"\r\n      [removeText]=\"removeText\"\r\n      (removeProvider)=\"removeProvider($event)\"\r\n      (setAsPrimaryCareProvider)=\"providerFacade.setAsPrimaryCareProvider($event)\"\r\n      (editProvider)=\"editProvider($event)\"\r\n    >\r\n    </vnext-widget-selected-provider>\r\n  </div>\r\n</div>\r\n", styles: [".provider-icon{font-size:46px}.zipcode-width{width:auto}.error-display{height:24px}.provider-name-input{height:38px;width:100%}.zipcode-search-button{line-height:1.4}.provider{border-radius:5px;border-width:1px;border-style:solid}.provider-wrapper{max-height:455px;overflow-y:auto}.provider-list{padding:10px 0;float:left;width:100%;border-width:0 0 1px;border-style:solid}.provider-search-filter-item{justify-content:space-around;padding:15px 0 10px 19px;margin:0;list-style:none}.provider-list:last-child{border-bottom:none}.underline{text-decoration:underline}.provider-border-color{border-color:var(--static-Spa_Style_Accent1)}.provider-search-button{height:38px;min-width:105px}.no-pharmacies-body-text{line-height:24px}.flex-row-nowrap{display:flex;flex-wrap:nowrap;align-items:flex-end}.flex-1{flex:1}.padd-4{padding:0 4px}.bg-grey{background-color:var(--static-Spa_Style_Gray2)}.provider-search-filter-text{font-family:montserrat_light;font-size:var(--Spa_Style_Small_Font);color:var(--static-Spa_Style_Black)}@media print{.col-md-12.col-lg-5{flex:0 0 41.6667%;max-width:41.6667%}.col-md-12.col-lg-7{flex:0 0 58.3333%;max-width:58.3333%}.order-lg-first{order:-1}.order-lg-last{order:13}}@media (max-width: 680px){.provider-search-filter-item{padding:10px 0 6px 19px}.zip-code-name{flex-direction:column;align-items:flex-start;justify-content:flex-start;align-self:stretch}.container-row{flex-direction:column;align-items:flex-start;justify-content:flex-start}.provider-search-button{margin-top:1rem;align-self:stretch!important;margin-left:0!important}.provider-name-field{align-self:stretch;margin:1rem 0 1.5rem}}@media (min-width: 767px) and (max-width: 769px){.zip-code-name{margin-bottom:1rem;align-self:stretch}.container-row{flex-direction:column;align-items:flex-start;justify-content:flex-start}.provider-search-button{align-self:stretch!important;margin-left:0!important}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: ConfigurableWidgetService }, { type: i1.WidgetValidationService }, { type: MapFacade }, { type: ProviderFacade }, { type: HelpfulToolsContextService }, { type: HelpfulToolsService }, { type: i1.SpinnerService }, { type: MapContextService }, { type: i1.FormValidationService }, { type: ProviderContextService }, { type: i1.FilterService }, { type: AnalyticsService }, { type: i1.ProviderService }, { type: i1.NavigationService }, { type: i1.StringFormatUtilityService }]; }, { providerListContainer: [{
            type: ViewChild,
            args: [ProviderListComponent]
        }], providersFilterCheckBoxes: [{
            type: ViewChildren,
            args: ['providerFilterCheckBox']
        }], isHelpfulToolsView: [{
            type: Input
        }], providerLimit: [{
            type: Input
        }], providerMapDefaultZoom: [{
            type: Input
        }], maxZoom: [{
            type: Input
        }], minZoom: [{
            type: Input
        }], providersText: [{
            type: Input
        }], providersBodyText: [{
            type: Input
        }], providersMultiBodyText: [{
            type: Input
        }], retrieveZipCode: [{
            type: Input
        }], retrieveFipsCode: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], zipLabel: [{
            type: Input
        }], zipErrorText: [{
            type: Input
        }], providerNameText: [{
            type: Input
        }], providerNameHintText: [{
            type: Input
        }], providerSearchButtonText: [{
            type: Input
        }], itemsPerPage: [{
            type: Input
        }], providerPaginationEnabled: [{
            type: Input
        }], viewNotFoundHeaderText: [{
            type: Input
        }], viewNotFoundBodyText: [{
            type: Input
        }], paginationText: [{
            type: Input
        }], addProviderText: [{
            type: Input
        }], providerAddedText: [{
            type: Input
        }], maxCountErrorMessage: [{
            type: Input
        }], maxCount: [{
            type: Input
        }], yourProviderText: [{
            type: Input
        }], removeProviderText: [{
            type: Input
        }], setPrimaryCareProviderText: [{
            type: Input
        }], primaryCareProviderText: [{
            type: Input
        }], providerFiltersEnabled: [{
            type: Input
        }], providerFilters: [{
            type: Input
        }], providerGroupAddedLabelText: [{
            type: Input
        }], providerGroupAddLabelText: [{
            type: Input
        }], countyLabel: [{
            type: Input
        }], showCountyLabel: [{
            type: Input
        }], addLinkText: [{
            type: Input
        }], cancelProvidersLabel: [{
            type: Input
        }], providerSingleSelectEnabled: [{
            type: Input
        }], providerExistsTooltipText: [{
            type: Input
        }], providerMultiLocationText: [{
            type: Input
        }], selectProviderLabelText: [{
            type: Input
        }], countryCode: [{
            type: Input
        }], acceptingNewPatientsText: [{
            type: Input
        }], acceptingNewPatientsIcon: [{
            type: Input
        }], languagesIcon: [{
            type: Input
        }], providerLocationsText: [{
            type: Input
        }], valueBasedCareEnabled: [{
            type: Input
        }], valueBasedCareIcon: [{
            type: Input
        }], valueBasedCareText: [{
            type: Input
        }], generalPracticeOptions: [{
            type: Input
        }], generalPracticeToolTipText: [{
            type: Input
        }], generalPracticeLabel: [{
            type: Input
        }], generalPracticeFilterOptionEnabled: [{
            type: Input
        }], singleProviderInListEnabled: [{
            type: Input
        }], updateLinkText: [{
            type: Input
        }], editLinkText: [{
            type: Input
        }], showEditLinkEnabled: [{
            type: Input
        }], isValueBasedCareLearnMoreLink2Enabled: [{
            type: Input
        }], valueBasedCareAvailableText: [{
            type: Input
        }], valueBasedCareLearnMoreLink: [{
            type: Input
        }], valueBasedCareLearnMoreText: [{
            type: Input
        }], valueBasedCareToggleLabel: [{
            type: Input
        }], valueBasedCareToggleEnabled: [{
            type: Input
        }], valueBasedCareToggleToolTipText: [{
            type: Input
        }], valueBasedCareToggleOptions: [{
            type: Input
        }], newPatientToggleEnabled: [{
            type: Input
        }], newPatientToggleLabel: [{
            type: Input
        }], newPatientToggleOptions: [{
            type: Input
        }], pcpToggleEnabled: [{
            type: Input
        }], pcpToggleLabel: [{
            type: Input
        }], pcpToggleOptions: [{
            type: Input
        }], newPatientText: [{
            type: Input
        }], existingPatientText: [{
            type: Input
        }], vbcNameFilterEnabled: [{
            type: Input
        }], vbcNameFilterLabel: [{
            type: Input
        }], selectedProviderOptionsEnabled: [{
            type: Input
        }], removeText: [{
            type: Input
        }], selectAllText: [{
            type: Input
        }], isZelisIntegrationEnabled: [{
            type: Input
        }], isPreferenceBannerEnabled: [{
            type: Input
        }], fetchProvidersFromLocation: [{
            type: Output
        }], initializeMap: [{
            type: Output
        }], setMapCenter: [{
            type: Output
        }], setMapDefaultBounds: [{
            type: Output
        }], addProviders: [{
            type: Output
        }], addProviderSelectedFromMarker: [{
            type: Output
        }], fetchProvidersFromAPI: [{
            type: Output
        }] }); })();

class PharmacyFilterModalItemsComponent {
    constructor(filterService, pharmacyFacade) {
        this.filterService = filterService;
        this.pharmacyFacade = pharmacyFacade;
        this.pharmacyFilterControl = 'pharmacyFilterControl';
        this.pharmacyGroupFilters = [];
    }
    ngOnInit() {
        this.filterForm = new UntypedFormGroup({
            ['pharmacyFilterControl']: new UntypedFormControl(null)
        });
        this.populateInitialFormValues();
    }
    updateFilters() {
        this.updateFilter(this.pharmacyFacade.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_24HR_SERVICE));
        this.updateFilter(this.pharmacyFacade.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_E_PRESCRIPTION));
        this.updateFilter(this.pharmacyFacade.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_HANDICAP_ACCESS));
        this.updateFilter(this.pharmacyFacade.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_DURABLE_EQUIPMENT));
        this.updateFilter(this.pharmacyFacade.getPharmacyDisplayName(PharmacyFilterKeyType.PHARMACY_MAIL_ORDER));
        this.updateFilter(PharmacyFilterKeyType.STANDARD);
        this.updateFilter(PharmacyFilterKeyType.PREFERRED);
    }
    uncheckAllFilters() {
        this.pharmacyFacade.updateFilterForm(this.pharmacyFilterControl, [], this.filterForm);
    }
    updateFilter(displayName) {
        this.pharmacyFacade.updateFilter(displayName, this.filterForm.get(this.pharmacyFilterControl).value.indexOf(displayName) > -1, this.filterForm);
    }
    populateInitialFormValues() {
        const filters = this.filterService.getPharmacyFiltersByFilterGroup(this.pharmacyGroupFilters);
        if (filters.length > 0) {
            const pharmacyFilter = filters.filter(filter => {
                const filterKey = filter.key;
                this.pharmacyFacade.isPharmacyFilterKey(filterKey);
            });
            this.pharmacyFacade.updateFilterForm(this.pharmacyFilterControl, pharmacyFilter, this.filterForm);
        }
    }
}
PharmacyFilterModalItemsComponent.ɵfac = function PharmacyFilterModalItemsComponent_Factory(t) { return new (t || PharmacyFilterModalItemsComponent)(i0.ɵɵdirectiveInject(i1.FilterService), i0.ɵɵdirectiveInject(PharmacyFacade)); };
PharmacyFilterModalItemsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PharmacyFilterModalItemsComponent, selectors: [["vnext-pharmacy-filter-modal-items"]], inputs: { pharmacyFilters: "pharmacyFilters", pharmacyFilterClearText: "pharmacyFilterClearText" }, decls: 5, vars: 4, consts: [[3, "formGroup"], [1, "clear-all"], [3, "title", "alwaysUnderlined", "click"], ["formControlName", "pharmacyFilterControl", 1, "pharmacy-filter-modal-items", 3, "items"]], template: function PharmacyFilterModalItemsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 0)(1, "div", 1)(2, "vnext-link", 2);
        i0.ɵɵlistener("click", function PharmacyFilterModalItemsComponent_Template_vnext_link_click_2_listener() { return ctx.uncheckAllFilters(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(3, "div");
        i0.ɵɵelement(4, "vnext-checkbox-group", 3);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.filterForm);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("title", ctx.pharmacyFilterClearText)("alwaysUnderlined", true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("items", ctx.pharmacyFilters);
    } }, dependencies: [i4.ɵNgNoValidate, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, CheckboxGroupComponent, LinkComponent], styles: [".clear-all[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Primary_Link);font-family:montserrat_light;font-size:var(--Spa_Style_Small_Font);text-align:right;cursor:pointer;margin-top:6px}.sub-items[_ngcontent-%COMP%]{margin-left:15px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PharmacyFilterModalItemsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-pharmacy-filter-modal-items', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form [formGroup]=\"filterForm\">\r\n  <div class=\"clear-all\">\r\n    <vnext-link [title]=\"pharmacyFilterClearText\" (click)=\"uncheckAllFilters()\" [alwaysUnderlined]=\"true\">\r\n    </vnext-link>\r\n  </div>\r\n  <div>\r\n    <vnext-checkbox-group\r\n      formControlName=\"pharmacyFilterControl\"\r\n      [items]=\"pharmacyFilters\"\r\n      class=\"pharmacy-filter-modal-items\">\r\n    </vnext-checkbox-group>\r\n  </div>\r\n</form>\r\n", styles: [".clear-all{color:var(--static-Spa_Style_Primary_Link);font-family:montserrat_light;font-size:var(--Spa_Style_Small_Font);text-align:right;cursor:pointer;margin-top:6px}.sub-items{margin-left:15px}\n"] }]
    }], function () { return [{ type: i1.FilterService }, { type: PharmacyFacade }]; }, { pharmacyFilters: [{
            type: Input
        }], pharmacyFilterClearText: [{
            type: Input
        }] }); })();

class PharmacyFilterModalComponent {
    constructor(activeModal, pharmacyFacade) {
        this.activeModal = activeModal;
        this.pharmacyFacade = pharmacyFacade;
    }
    ngOnInit() {
        this.pharmacyFacade.updatePharmacyType(this.isHelpToolRoute, this.otherPharmacyFilterEnabled, this.inNetworkFilterEnabled, this.inNetworkFilters);
    }
    cancelChanges() {
        this.activeModal.dismiss();
    }
    applyFilter() {
        this.pharmacyFilterModalItems.updateFilters();
        this.pharmacyFacade.setAnalyticsForAddedFilters();
        this.activeModal.dismiss();
    }
}
PharmacyFilterModalComponent.ɵfac = function PharmacyFilterModalComponent_Factory(t) { return new (t || PharmacyFilterModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(PharmacyFacade)); };
PharmacyFilterModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PharmacyFilterModalComponent, selectors: [["vnext-pharmacy-filter-modal"]], viewQuery: function PharmacyFilterModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(PharmacyFilterModalItemsComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pharmacyFilterModalItems = _t.first);
    } }, decls: 10, vars: 7, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "modal-body", "pharmacy-filter-modal-content"], [3, "pharmacyFilterClearText", "pharmacyFilters"], [1, "modal-footer", "justify-content-between"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", 3, "click"], ["type", "button", 1, "btn", "Spa_Style_PrimaryButton", 3, "click"]], template: function PharmacyFilterModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div")(1, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function PharmacyFilterModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_1_listener() { return ctx.cancelChanges(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵelement(3, "vnext-pharmacy-filter-modal-items", 2);
        i0.ɵɵpipe(4, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 3)(6, "button", 4);
        i0.ɵɵlistener("click", function PharmacyFilterModalComponent_Template_button_click_6_listener() { return ctx.cancelChanges(); });
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "button", 5);
        i0.ɵɵlistener("click", function PharmacyFilterModalComponent_Template_button_click_8_listener() { return ctx.applyFilter(); });
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("modalTitleText", ctx.filterHeaderText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("pharmacyFilterClearText", ctx.pharmacyFilterClearText)("pharmacyFilters", ctx.pharmacyFacade.sortFilterControls(i0.ɵɵpipeBind1(4, 5, ctx.pharmacyFacade.pharmacyTypes$), true));
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.filterModalCancelButtonText);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.filterModalApplyButtonText);
    } }, dependencies: [ModalHeaderComponent, PharmacyFilterModalItemsComponent, i1$2.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PharmacyFilterModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-pharmacy-filter-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div>\r\n  <vnext-widget-modal-header [modalTitleText]=\"filterHeaderText\" (modalTitleCancelAction)=\"cancelChanges()\"></vnext-widget-modal-header>\r\n\r\n  <div class=\"modal-body pharmacy-filter-modal-content\">\r\n    <vnext-pharmacy-filter-modal-items\r\n      [pharmacyFilterClearText]=\"pharmacyFilterClearText\"\r\n      [pharmacyFilters]=\"pharmacyFacade.sortFilterControls(pharmacyFacade.pharmacyTypes$ | async, true)\"\r\n    ></vnext-pharmacy-filter-modal-items>\r\n  </div>\r\n  <div class=\"modal-footer justify-content-between\">\r\n    <button type=\"button\" class=\"btn Spa_Style_SecondaryButton\" (click)=\"cancelChanges()\">{{ filterModalCancelButtonText }}</button>\r\n    <button type=\"button\" class=\"btn Spa_Style_PrimaryButton\" (click)=\"applyFilter()\">{{ filterModalApplyButtonText }}</button>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: PharmacyFacade }]; }, { pharmacyFilterModalItems: [{
            type: ViewChild,
            args: [PharmacyFilterModalItemsComponent]
        }] }); })();

const _c0$1W = ["pharmacyButton"];
const _c1$T = ["helpfulToolsFocusIcon"];
const _c2$A = ["addedPharmacy"];
function PharmacyListComponent_div_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-widget-map-pin", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    const i_r2 = ctx_r10.index;
    const pharmacy_r1 = ctx_r10.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("index", i_r2 + ctx_r3.pinIconIndex)("isPrimary", ctx_r3.pharmacyFacade.isPrimaryPharmacy(pharmacy_r1, ctx_r3.isHelpfulToolsView))("customClass", ctx_r3.pharmacyFacade.getPharmacyMapPinClass(pharmacy_r1, false, ctx_r3.isHelpfulToolsView))("backgroundStyle", ctx_r3.pharmacyFacade.getBackGroundColor(pharmacy_r1, ctx_r3.isHelpfulToolsView))("alternateViewClass", ctx_r3.noticeAlternateView(pharmacy_r1))("alternateNumberIndicatorClass", ctx_r3.noticeAlternatePharmacyIndicator(pharmacy_r1))("primaryIconAriaLabelText", ctx_r3.primaryPharmacyText);
} }
function PharmacyListComponent_div_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12, 13)(2, "span", 14);
    i0.ɵɵelement(3, "i", 15);
    i0.ɵɵelementStart(4, "div", 16);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 17);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    const pharmacy_r1 = ctx_r12.$implicit;
    const i_r2 = ctx_r12.index;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r5.noticeAlternateView(pharmacy_r1));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r5.noticeAlternatePharmacyIndicator(pharmacy_r1));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i_r2 + ctx_r5.pinIconIndex, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", pharmacy_r1.name, " ", pharmacy_r1.address1, " ");
} }
function PharmacyListComponent_div_4_div_7_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 24);
    i0.ɵɵpipe(1, "safe");
    i0.ɵɵelement(2, "div", 25);
    i0.ɵɵpipe(3, "safe");
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 2, ctx_r14.electronicPrescriptionTooltipHeader, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(3, 5, ctx_r14.electronicPrescriptionTooltipBody, "html"), i0.ɵɵsanitizeHtml);
} }
function PharmacyListComponent_div_4_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, PharmacyListComponent_div_4_div_7_ng_template_1_Template, 4, 8, "ng-template", null, 19, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(3, "span", 20, 21);
    i0.ɵɵelement(6, "span", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 23);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r13 = i0.ɵɵreference(2);
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbTooltip", _r13);
    i0.ɵɵattribute("aria-label", ctx_r6.Spa_Site_Tooltip_Text + " " + ctx_r6.electronicPrescriptionTooltipHeader + " " + ctx_r6.electronicPrescriptionTooltipBody);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-label", ctx_r6.ePrescribingAltText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate4("", ctx_r6.Spa_Site_Tooltip_Text, " ", ctx_r6.ePrescribingAltText, " ", ctx_r6.electronicPrescriptionTooltipHeader, " ", ctx_r6.electronicPrescriptionTooltipBody, "");
} }
function PharmacyListComponent_div_4_ng_container_13_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-tooltip", 29);
    i0.ɵɵelement(2, "i", 30);
    i0.ɵɵelementStart(3, "span", 31);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("header", ctx_r17.preferredInNetworkText)("body", ctx_r17.preferredInNetworkTooltipContent)("Spa_Site_Tooltip_Text", ctx_r17.Spa_Site_Tooltip_Text);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r17.preferredInNetworkText);
} }
function PharmacyListComponent_div_4_ng_container_13_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-tooltip", 29);
    i0.ɵɵelement(1, "i", 32);
    i0.ɵɵelementStart(2, "span", 31);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("header", ctx_r19.standardInNetworkText)("body", ctx_r19.standardInNetworkTooltipContent)("Spa_Site_Tooltip_Text", ctx_r19.Spa_Site_Tooltip_Text);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r19.standardInNetworkText);
} }
function PharmacyListComponent_div_4_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵtemplate(2, PharmacyListComponent_div_4_ng_container_13_ng_container_2_Template, 5, 4, "ng-container", 4);
    i0.ɵɵtemplate(3, PharmacyListComponent_div_4_ng_container_13_ng_template_3_Template, 4, 4, "ng-template", null, 27, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(5, "div", 28);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r18 = i0.ɵɵreference(4);
    const pharmacy_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", pharmacy_r1.isPreferred)("ngIfElse", _r18);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r7.getPharmacyDesignation(pharmacy_r1));
} }
function PharmacyListComponent_div_4_ng_template_14_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 35, 36);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 17);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    const i_r2 = ctx_r25.index;
    const pharmacy_r1 = ctx_r25.$implicit;
    const ctx_r21 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-describedby", "Spa_Style_HeaderTextLevel_" + i_r2 + " addedPharmacyText");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r21.pharmacyAddedLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", pharmacy_r1.name, " ", pharmacy_r1.address1, " ");
} }
function PharmacyListComponent_div_4_ng_template_14_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 38, 39);
    i0.ɵɵlistener("click", function PharmacyListComponent_div_4_ng_template_14_ng_template_2_ng_container_0_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r32); const pharmacy_r1 = i0.ɵɵnextContext(3).$implicit; const ctx_r30 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r30.addPharmacy(pharmacy_r1.pharmacyId)); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r2 = i0.ɵɵnextContext(3).index;
    const ctx_r26 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-describedby", "Spa_Style_HeaderTextLevel_" + i_r2 + " addPharmacyText");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r26.addPharmacyButtonText, " ");
} }
function PharmacyListComponent_div_4_ng_template_14_ng_template_2_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 40, 41);
    i0.ɵɵlistener("mouseleave", function PharmacyListComponent_div_4_ng_template_14_ng_template_2_ng_template_1_Template_button_mouseleave_0_listener() { i0.ɵɵrestoreView(_r36); const _r34 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r34.close()); })("click", function PharmacyListComponent_div_4_ng_template_14_ng_template_2_ng_template_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r36); const _r34 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r34.open()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "span", 42);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngbTooltip", ctx_r28.pharmacyLimitErrorMessage);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r28.addPharmacyButtonText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r28.pharmacyLimitErrorMessage);
} }
function PharmacyListComponent_div_4_ng_template_14_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PharmacyListComponent_div_4_ng_template_14_ng_template_2_ng_container_0_Template, 4, 2, "ng-container", 4);
    i0.ɵɵtemplate(1, PharmacyListComponent_div_4_ng_template_14_ng_template_2_ng_template_1_Template, 5, 3, "ng-template", null, 37, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(3, "span", 17);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r27 = i0.ɵɵreference(2);
    const pharmacy_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r23 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r23.pharmacyCountWithinLimits)("ngIfElse", _r27);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2("", pharmacy_r1.name, " ", pharmacy_r1.address1, " ");
} }
function PharmacyListComponent_div_4_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵtemplate(1, PharmacyListComponent_div_4_ng_template_14_ng_container_1_Template, 6, 4, "ng-container", 4);
    i0.ɵɵtemplate(2, PharmacyListComponent_div_4_ng_template_14_ng_template_2_Template, 5, 4, "ng-template", null, 34, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r22 = i0.ɵɵreference(3);
    const pharmacy_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.pharmacyFacade.isSelectedPharmacy(pharmacy_r1))("ngIfElse", _r22);
} }
function PharmacyListComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, PharmacyListComponent_div_4_ng_container_1_Template, 2, 7, "ng-container", 4);
    i0.ɵɵtemplate(2, PharmacyListComponent_div_4_ng_template_2_Template, 8, 5, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(4, "div", 6)(5, "h2", 7);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, PharmacyListComponent_div_4_div_7_Template, 9, 7, "div", 8);
    i0.ɵɵelementStart(8, "div", 9)(9, "div");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(13, PharmacyListComponent_div_4_ng_container_13_Template, 7, 3, "ng-container", 4);
    i0.ɵɵtemplate(14, PharmacyListComponent_div_4_ng_template_14_Template, 4, 2, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const pharmacy_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const _r4 = i0.ɵɵreference(3);
    const _r8 = i0.ɵɵreference(15);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isHelpfulToolsView)("ngIfElse", _r4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("id", "Spa_Style_HeaderTextLevel_" + i_r2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(pharmacy_r1.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", pharmacy_r1.hasEPrescriptions);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(pharmacy_r1.address1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3("", pharmacy_r1.city, ", ", pharmacy_r1.state, " ", pharmacy_r1.zip, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isHelpfulToolsView)("ngIfElse", _r8);
} }
class PharmacyListComponent {
    constructor(pharmacyFacade, helpfulToolsContext, cdr) {
        this.pharmacyFacade = pharmacyFacade;
        this.helpfulToolsContext = helpfulToolsContext;
        this.cdr = cdr;
        this.isHelpfulToolsView = false;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.subscriptions.add(this.pharmacyFacade.pharmacyCountWithinLimits$().subscribe({
            next: pharmacyCountWithinLimits => {
                this.pharmacyCountWithinLimits = pharmacyCountWithinLimits;
                this.cdr.markForCheck();
            }
        }));
        this.isHelpfulToolsView = this.helpfulToolsContext.isHelpfulToolsView;
    }
    ngAfterViewInit() {
        if (!this.isHelpfulToolsView) {
            this.subscriptions.add(this.pharmacyButton.changes.subscribe({
                next: element => {
                    if (this.isFocusEnabled && element.first?.nativeElement) {
                        element.first.nativeElement.focus();
                        this.isFocusEnabled = false;
                    }
                }
            }));
        }
        else {
            this.subscriptions.add(this.helpfulToolsFocusIcon.changes.subscribe({
                next: element => {
                    if (this.isFocusEnabled && element.first?.nativeElement) {
                        element.first.nativeElement.focus();
                        this.isFocusEnabled = false;
                    }
                }
            }));
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    addPharmacy(pharmacyId) {
        const pharmacy = this.pharmacies.find(existingPharmacy => existingPharmacy.pharmacyId === pharmacyId);
        this.pharmacyFacade.addPharmacy(pharmacy);
        this.updateFocus(true);
    }
    noticeAlternateView(pharmacy) {
        const selectedPharmacy = this.selectedPharmacies.find(existingPharmacy => existingPharmacy.pharmacyId === pharmacy.pharmacyId);
        return this.pharmacyFacade.noticeAlternateView(selectedPharmacy, pharmacy);
    }
    noticeAlternatePharmacyIndicator(pharmacy) {
        const selectedPharmacy = this.selectedPharmacies.find(existingPharmacy => existingPharmacy.pharmacyId === pharmacy.pharmacyId);
        return this.pharmacyFacade.noticeAlternatePharmacyIndicator(selectedPharmacy, pharmacy);
    }
    getPharmacyDesignation(pharmacy) {
        return this.pharmacyFacade.getPharmacyDesignation(pharmacy);
    }
    updateFocus(isFocus) {
        this.isFocusEnabled = isFocus;
    }
    get pinIconIndex() {
        return this.pageIndex * this.pageSize - this.pageSize + 1;
    }
    get startValueOfItemsToBeSliced() {
        return (this.pageIndex - 1) * this.pageSize;
    }
    get endValueOfItemsToBeSliced() {
        return (this.pageIndex - 1) * this.pageSize + this.pageSize;
    }
}
PharmacyListComponent.ɵfac = function PharmacyListComponent_Factory(t) { return new (t || PharmacyListComponent)(i0.ɵɵdirectiveInject(PharmacyFacade), i0.ɵɵdirectiveInject(HelpfulToolsContextService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
PharmacyListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PharmacyListComponent, selectors: [["vnext-widget-pharmacy-list"]], viewQuery: function PharmacyListComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1W, 5);
        i0.ɵɵviewQuery(_c1$T, 5);
        i0.ɵɵviewQuery(_c2$A, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pharmacyButton = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.helpfulToolsFocusIcon = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addedPharmacy = _t);
    } }, inputs: { addPharmacyButtonText: "addPharmacyButtonText", pharmacies: "pharmacies", selectedPharmacies: "selectedPharmacies", pharmacyAddedLabel: "pharmacyAddedLabel", pageSize: "pageSize", pageIndex: "pageIndex", electronicPrescriptionTooltipHeader: "electronicPrescriptionTooltipHeader", electronicPrescriptionTooltipBody: "electronicPrescriptionTooltipBody", preferredInNetworkText: "preferredInNetworkText", standardInNetworkText: "standardInNetworkText", standardInNetworkTooltipContent: "standardInNetworkTooltipContent", preferredInNetworkTooltipContent: "preferredInNetworkTooltipContent", addedPharmacyText: "addedPharmacyText", addPharmacyText: "addPharmacyText", ePrescribingAltText: "ePrescribingAltText", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text", multiPharmacyEnabled: "multiPharmacyEnabled", maxPharmacyCount: "maxPharmacyCount", pharmacyLimitErrorMessage: "pharmacyLimitErrorMessage", primaryPharmacyText: "primaryPharmacyText" }, decls: 6, vars: 7, consts: [["id", "addedPharmacyText", 1, "hidden-off-screen"], ["id", "addPharmacyText", 1, "hidden-off-screen"], ["class", "pharmacy-list pharmacy-border-color", 4, "ngFor", "ngForOf"], [1, "pharmacy-list", "pharmacy-border-color"], [4, "ngIf", "ngIfElse"], ["helpfulToolsFocus", ""], [1, "pharmacy-address"], [1, "Spa_Style_HeaderTextLevel", "float-left", "pharmacy-name", "no-translate-block", 3, "id"], ["class", "float-right", 4, "ngIf"], [1, "Spa_Style_Paragraph", "float-left", "no-translate-block"], ["addPharmacyEnabled", ""], [3, "index", "isPrimary", "customClass", "backgroundStyle", "alternateViewClass", "alternateNumberIndicatorClass", "primaryIconAriaLabelText"], ["tabindex", "0", 1, "float-left"], ["helpfulToolsFocusIcon", ""], [1, "fa-stack"], ["aria-hidden", "true", 1, "fas", "fa-map-marker", "fa-stack-2x", "pharmacy-map-pin", 3, "ngClass"], ["aria-hidden", "true", 1, "fa-stack-1x", "pharmacy-pin-number", 3, "ngClass"], [1, "sr-only", "no-translate-block"], [1, "float-right"], ["ePrescriptionTooltip", ""], ["tooltipClass", "eprescription-logo", "tabindex", "0", "container", "body", "placement", "left", 3, "ngbTooltip"], ["electronicPresciptionIcon", "", "tooltipController", "ngbTooltip"], ["role", "img", 1, "Spa_Style_Electronic_Prescription_Icon", "eprescribing-icon"], ["aria-hidden", "true", 1, "hidden-off-screen"], ["navigationAdapter", "", 1, "Spa_Style_TooltipTextAndNumberIndicators", 3, "innerHtml"], ["navigationAdapter", "", 1, "Spa_Style_ToolTip", "eprescription-tooltip-body", 3, "innerHtml"], [1, "pharmacy-in-network"], ["standardInNetwork", ""], [1, "Spa_Style_Paragraph"], [3, "header", "body", "Spa_Site_Tooltip_Text"], ["aria-hidden", "true", 1, "fas", "fa-circle", "Spa_Style_Accent5_Color"], [1, "Spa_Style_Paragraph", "underline", "pl-1"], ["aria-hidden", "true", 1, "fas", "fa-circle", "Spa_Style_Accent3_Color"], ["aria-live", "off"], ["showAddPharmacy", ""], ["tabindex", "0", 1, "btn", "mt-2", "w-100", "Spa_Style_SecondaryButtonSelected", "Spa_Style_Bold_Weight"], ["addedPharmacy", ""], ["showPharmacyLimitMessage", ""], [1, "btn", "mt-2", "w-100", "Spa_Style_SecondaryButton", "Spa_Style_Regular_Weight", "pharmacy-border-color", 3, "click"], ["pharmacyButton", ""], ["triggers", "manual", "placement", "top", "container", "body", "autoClose", "true", 1, "btn", "mt-2", "w-100", "Spa_Style_SecondaryButton", "Spa_Style_Regular_Weight", "pharmacy-border-color", 3, "ngbTooltip", "mouseleave", "click"], ["pharmacyLimitTooltip", "ngbTooltip"], [1, "sr-only"]], template: function PharmacyListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "span", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "span", 1);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, PharmacyListComponent_div_4_Template, 16, 11, "div", 2);
        i0.ɵɵpipe(5, "slice");
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.addedPharmacyText);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.addPharmacyText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(5, 3, ctx.pharmacies, ctx.startValueOfItemsToBeSliced, ctx.endValueOfItemsToBeSliced));
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, TooltipComponent, NavigationAdapterDirective, IconAriaAttributesDirective, i1$1.NgbTooltip, MapPinComponent, i1$2.SlicePipe, SafePipe], styles: [".pharmacy-list[_ngcontent-%COMP%]{padding:10px 0;float:left;width:100%;border-width:0 0 1px;border-style:solid}.pharmacy-list[_ngcontent-%COMP%]:last-child{border-bottom:none}.pharmacy-address[_ngcontent-%COMP%]{padding-left:10px;float:left;width:83%}.pharmacy-name[_ngcontent-%COMP%]{width:85%}.pharmacy-pin-number[_ngcontent-%COMP%]{line-height:1.6}.pharmacy-map-pin[_ngcontent-%COMP%]{font-size:28px}.pharmacy-primary-icon-size[_ngcontent-%COMP%]{font-size:25px!important}.pharmacy-indicator[_ngcontent-%COMP%]{font-family:montserrat_bold;font-weight:700;font-size:14px;color:#fff}.eprescription-tooltip-body[_ngcontent-%COMP%]{padding:5px 0 10px}.pharmacy-border-color[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent1)}.underline[_ngcontent-%COMP%]{text-decoration:underline}.Spa_Style_Electronic_Prescription_Icon[_ngcontent-%COMP%]:focus{border-radius:50%;padding:4px;margin:-4px}.eprescribing-tooltip-text[_ngcontent-%COMP%]{width:20px;height:20px;margin-top:0;display:block;overflow:hidden}.eprescribing-icon[_ngcontent-%COMP%]{position:relative;top:0}.pharmacy-in-network[_ngcontent-%COMP%]{float:left;width:100%}@media (min-width: 479.98px) and (max-width: 992px){.pharmacy-in-network[_ngcontent-%COMP%]{float:right;text-align:right;width:auto}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PharmacyListComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-pharmacy-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<span id=\"addedPharmacyText\" class=\"hidden-off-screen\">{{ addedPharmacyText }}</span>\r\n<span id=\"addPharmacyText\" class=\"hidden-off-screen\">{{ addPharmacyText }}</span>\r\n<div\r\n  class=\"pharmacy-list pharmacy-border-color\"\r\n  *ngFor=\"let pharmacy of pharmacies | slice : startValueOfItemsToBeSliced : endValueOfItemsToBeSliced; index as i\"\r\n>\r\n  <ng-container *ngIf=\"!isHelpfulToolsView; else helpfulToolsFocus\">\r\n    <vnext-widget-map-pin\r\n      [index]=\"i + pinIconIndex\"\r\n      [isPrimary]=\"pharmacyFacade.isPrimaryPharmacy(pharmacy, isHelpfulToolsView)\"\r\n      [customClass]=\"pharmacyFacade.getPharmacyMapPinClass(pharmacy, false, isHelpfulToolsView)\"\r\n      [backgroundStyle]=\"pharmacyFacade.getBackGroundColor(pharmacy, isHelpfulToolsView)\"\r\n      [alternateViewClass]=\"noticeAlternateView(pharmacy)\"\r\n      [alternateNumberIndicatorClass]=\"noticeAlternatePharmacyIndicator(pharmacy)\"\r\n      [primaryIconAriaLabelText]=\"primaryPharmacyText\"\r\n    ></vnext-widget-map-pin>\r\n  </ng-container>\r\n  <ng-template #helpfulToolsFocus>\r\n    <div #helpfulToolsFocusIcon class=\"float-left\" tabindex=\"0\">\r\n      <span class=\"fa-stack\">\r\n        <i class=\"fas fa-map-marker fa-stack-2x pharmacy-map-pin\" [ngClass]=\"noticeAlternateView(pharmacy)\" aria-hidden=\"true\"></i>\r\n        <div class=\"fa-stack-1x pharmacy-pin-number\" [ngClass]=\"noticeAlternatePharmacyIndicator(pharmacy)\" aria-hidden=\"true\">\r\n          {{ i + pinIconIndex }}\r\n        </div>\r\n        <span class=\"sr-only no-translate-block\">{{ pharmacy.name }} {{ pharmacy.address1 }} </span>\r\n      </span>\r\n    </div>\r\n  </ng-template>\r\n  <div class=\"pharmacy-address\">\r\n    <h2 [id]=\"'Spa_Style_HeaderTextLevel_' + i\" class=\"Spa_Style_HeaderTextLevel float-left pharmacy-name no-translate-block\">{{ pharmacy.name }}</h2>\r\n    <div class=\"float-right\" *ngIf=\"pharmacy.hasEPrescriptions\">\r\n      <ng-template #ePrescriptionTooltip>\r\n        <div\r\n          class=\"Spa_Style_TooltipTextAndNumberIndicators\"\r\n          [innerHtml]=\"electronicPrescriptionTooltipHeader | safe : 'html'\"\r\n          navigationAdapter\r\n        ></div>\r\n        <div\r\n          class=\"Spa_Style_ToolTip eprescription-tooltip-body\"\r\n          [innerHtml]=\"electronicPrescriptionTooltipBody | safe : 'html'\"\r\n          navigationAdapter\r\n        ></div>\r\n      </ng-template>\r\n      <span\r\n        #electronicPresciptionIcon\r\n        #tooltipController=\"ngbTooltip\"\r\n        tooltipClass=\"eprescription-logo\"\r\n        [ngbTooltip]=\"ePrescriptionTooltip\"\r\n        tabindex=\"0\"\r\n        container=\"body\"\r\n        placement=\"left\"\r\n        [attr.aria-label]=\"Spa_Site_Tooltip_Text + ' ' + electronicPrescriptionTooltipHeader + ' ' + electronicPrescriptionTooltipBody\"\r\n      >\r\n        <span class=\"Spa_Style_Electronic_Prescription_Icon eprescribing-icon\" role=\"img\" [attr.aria-label]=\"ePrescribingAltText\"></span>\r\n      </span>\r\n      <span class=\"hidden-off-screen\" aria-hidden=\"true\"\r\n        >{{ Spa_Site_Tooltip_Text }} {{ ePrescribingAltText }} {{ electronicPrescriptionTooltipHeader }}\r\n        {{ electronicPrescriptionTooltipBody }}</span\r\n      >\r\n    </div>\r\n    <div class=\"Spa_Style_Paragraph float-left no-translate-block\">\r\n      <div>{{ pharmacy.address1 }}</div>\r\n      <div>{{ pharmacy.city }}, {{ pharmacy.state }} {{ pharmacy.zip }}</div>\r\n    </div>\r\n    <ng-container *ngIf=\"isHelpfulToolsView; else addPharmacyEnabled\">\r\n      <div class=\"pharmacy-in-network\">\r\n        <ng-container *ngIf=\"pharmacy.isPreferred; else standardInNetwork\">\r\n          <vnext-tooltip\r\n            [header]=\"preferredInNetworkText\"\r\n            [body]=\"preferredInNetworkTooltipContent\"\r\n            [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n          >\r\n            <i aria-hidden=\"true\" class=\"fas fa-circle Spa_Style_Accent5_Color\"></i>\r\n            <span class=\"Spa_Style_Paragraph underline pl-1\">{{ preferredInNetworkText }}</span>\r\n          </vnext-tooltip>\r\n        </ng-container>\r\n        <ng-template #standardInNetwork>\r\n          <vnext-tooltip\r\n            [header]=\"standardInNetworkText\"\r\n            [body]=\"standardInNetworkTooltipContent\"\r\n            [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n          >\r\n            <i aria-hidden=\"true\" class=\"fas fa-circle Spa_Style_Accent3_Color\"></i>\r\n            <span class=\"Spa_Style_Paragraph underline pl-1\">{{ standardInNetworkText }}</span>\r\n          </vnext-tooltip>\r\n        </ng-template>\r\n        <div class=\"Spa_Style_Paragraph\">{{ getPharmacyDesignation(pharmacy) }}</div>\r\n      </div>\r\n    </ng-container>\r\n    <ng-template #addPharmacyEnabled>\r\n      <div aria-live=\"off\">\r\n        <ng-container *ngIf=\"this.pharmacyFacade.isSelectedPharmacy(pharmacy); else showAddPharmacy\">\r\n          <div\r\n            #addedPharmacy\r\n            class=\"btn mt-2 w-100 Spa_Style_SecondaryButtonSelected Spa_Style_Bold_Weight\"\r\n            [attr.aria-describedby]=\"'Spa_Style_HeaderTextLevel_' + i + ' addedPharmacyText'\"\r\n            tabindex=\"0\"\r\n          >\r\n            {{ pharmacyAddedLabel }}\r\n          </div>\r\n          <span class=\"sr-only no-translate-block\">{{ pharmacy.name }} {{ pharmacy.address1 }} </span>\r\n        </ng-container>\r\n        <ng-template #showAddPharmacy>\r\n          <ng-container *ngIf=\"pharmacyCountWithinLimits; else showPharmacyLimitMessage\">\r\n            <button\r\n              #pharmacyButton\r\n              class=\"btn mt-2 w-100 Spa_Style_SecondaryButton Spa_Style_Regular_Weight pharmacy-border-color\"\r\n              (click)=\"addPharmacy(pharmacy.pharmacyId)\"\r\n              [attr.aria-describedby]=\"'Spa_Style_HeaderTextLevel_' + i + ' addPharmacyText'\"\r\n            >\r\n              {{ addPharmacyButtonText }}\r\n            </button>\r\n          </ng-container>\r\n          <ng-template #showPharmacyLimitMessage>\r\n            <button\r\n              class=\"btn mt-2 w-100 Spa_Style_SecondaryButton Spa_Style_Regular_Weight pharmacy-border-color\"\r\n              [ngbTooltip]=\"pharmacyLimitErrorMessage\"\r\n              triggers=\"manual\"\r\n              placement=\"top\"\r\n              container=\"body\"\r\n              autoClose=\"true\"\r\n              #pharmacyLimitTooltip=\"ngbTooltip\"\r\n              (mouseleave)=\"pharmacyLimitTooltip.close()\"\r\n              (click)=\"pharmacyLimitTooltip.open()\"\r\n            >\r\n              {{ addPharmacyButtonText }} <span class=\"sr-only\">{{ pharmacyLimitErrorMessage }}</span>\r\n            </button>\r\n          </ng-template>\r\n          <span class=\"sr-only no-translate-block\">{{ pharmacy.name }} {{ pharmacy.address1 }} </span>\r\n        </ng-template>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n</div>\r\n", styles: [".pharmacy-list{padding:10px 0;float:left;width:100%;border-width:0 0 1px;border-style:solid}.pharmacy-list:last-child{border-bottom:none}.pharmacy-address{padding-left:10px;float:left;width:83%}.pharmacy-name{width:85%}.pharmacy-pin-number{line-height:1.6}.pharmacy-map-pin{font-size:28px}.pharmacy-primary-icon-size{font-size:25px!important}.pharmacy-indicator{font-family:montserrat_bold;font-weight:700;font-size:14px;color:#fff}.eprescription-tooltip-body{padding:5px 0 10px}.pharmacy-border-color{border-color:var(--static-Spa_Style_Accent1)}.underline{text-decoration:underline}.Spa_Style_Electronic_Prescription_Icon:focus{border-radius:50%;padding:4px;margin:-4px}.eprescribing-tooltip-text{width:20px;height:20px;margin-top:0;display:block;overflow:hidden}.eprescribing-icon{position:relative;top:0}.pharmacy-in-network{float:left;width:100%}@media (min-width: 479.98px) and (max-width: 992px){.pharmacy-in-network{float:right;text-align:right;width:auto}}\n"] }]
    }], function () { return [{ type: PharmacyFacade }, { type: HelpfulToolsContextService }, { type: i0.ChangeDetectorRef }]; }, { pharmacyButton: [{
            type: ViewChildren,
            args: ['pharmacyButton']
        }], helpfulToolsFocusIcon: [{
            type: ViewChildren,
            args: ['helpfulToolsFocusIcon']
        }], addedPharmacy: [{
            type: ViewChildren,
            args: ['addedPharmacy']
        }], addPharmacyButtonText: [{
            type: Input
        }], pharmacies: [{
            type: Input
        }], selectedPharmacies: [{
            type: Input
        }], pharmacyAddedLabel: [{
            type: Input
        }], pageSize: [{
            type: Input
        }], pageIndex: [{
            type: Input
        }], electronicPrescriptionTooltipHeader: [{
            type: Input
        }], electronicPrescriptionTooltipBody: [{
            type: Input
        }], preferredInNetworkText: [{
            type: Input
        }], standardInNetworkText: [{
            type: Input
        }], standardInNetworkTooltipContent: [{
            type: Input
        }], preferredInNetworkTooltipContent: [{
            type: Input
        }], addedPharmacyText: [{
            type: Input
        }], addPharmacyText: [{
            type: Input
        }], ePrescribingAltText: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }], multiPharmacyEnabled: [{
            type: Input
        }], maxPharmacyCount: [{
            type: Input
        }], pharmacyLimitErrorMessage: [{
            type: Input
        }], primaryPharmacyText: [{
            type: Input
        }] }); })();

class PharmacyFilterItemsComponent {
    constructor(pharmacyFacade) {
        this.pharmacyFacade = pharmacyFacade;
        this.clearFormGroupValues = new EventEmitter();
        this.pharmacyFilterControl = 'pharmacyFilterControl';
    }
    onFilterSelected(event) {
        this.pharmacyFacade.onFilterSelected(event, this.filterForm);
    }
}
PharmacyFilterItemsComponent.ɵfac = function PharmacyFilterItemsComponent_Factory(t) { return new (t || PharmacyFilterItemsComponent)(i0.ɵɵdirectiveInject(PharmacyFacade)); };
PharmacyFilterItemsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PharmacyFilterItemsComponent, selectors: [["vnext-pharmacy-filter-items"]], inputs: { pharmacyFilters: "pharmacyFilters", pharmacyFilterClearText: "pharmacyFilterClearText", filterForm: "filterForm" }, outputs: { clearFormGroupValues: "clearFormGroupValues" }, decls: 5, vars: 4, consts: [[3, "formGroup"], [1, "clearFilterText"], [3, "title", "alwaysUnderlined", "click"], ["formControlName", "pharmacyFilterControl", 1, "pharmacy-filter-items", 3, "items", "change"]], template: function PharmacyFilterItemsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 0)(1, "div", 1)(2, "vnext-link", 2);
        i0.ɵɵlistener("click", function PharmacyFilterItemsComponent_Template_vnext_link_click_2_listener() { return ctx.clearFormGroupValues.emit(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(3, "div")(4, "vnext-checkbox-group", 3);
        i0.ɵɵlistener("change", function PharmacyFilterItemsComponent_Template_vnext_checkbox_group_change_4_listener($event) { return ctx.onFilterSelected($event); });
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.filterForm);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("title", ctx.pharmacyFilterClearText)("alwaysUnderlined", true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("items", ctx.pharmacyFilters);
    } }, dependencies: [i4.ɵNgNoValidate, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, CheckboxGroupComponent, LinkComponent], styles: [".clearFilterText[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;margin-right:15px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PharmacyFilterItemsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-pharmacy-filter-items', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form [formGroup]=\"filterForm\">\r\n  <div class=\"clearFilterText\">\r\n    <vnext-link [title]=\"pharmacyFilterClearText\" (click)=\"clearFormGroupValues.emit()\" [alwaysUnderlined]=\"true\"></vnext-link>\r\n  </div>\r\n  <div>\r\n    <vnext-checkbox-group\r\n      formControlName=\"pharmacyFilterControl\"\r\n      [items]=\"pharmacyFilters\"\r\n      (change)=\"onFilterSelected($event)\"\r\n      class=\"pharmacy-filter-items\"\r\n    >\r\n    </vnext-checkbox-group>\r\n  </div>\r\n</form>\r\n", styles: [".clearFilterText{display:flex;justify-content:flex-end;margin-right:15px}\n"] }]
    }], function () { return [{ type: PharmacyFacade }]; }, { pharmacyFilters: [{
            type: Input
        }], pharmacyFilterClearText: [{
            type: Input
        }], filterForm: [{
            type: Input
        }], clearFormGroupValues: [{
            type: Output
        }] }); })();

function DigitalPharmacyCardComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-describedby", "Spa_Style_HeaderTextLevel_" + ctx_r0.index + " addedPharmacyText");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.pharmacyAddedLabel, " ");
} }
function DigitalPharmacyCardComponent_ng_template_5_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 7, 8);
    i0.ɵɵlistener("click", function DigitalPharmacyCardComponent_ng_template_5_ng_container_0_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.addPharmacy(ctx_r7.pharmacy.pharmacyId)); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-describedby", "Spa_Style_HeaderTextLevel_" + ctx_r3.index + " addPharmacyText");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.addPharmacyButtonText, " ");
} }
function DigitalPharmacyCardComponent_ng_template_5_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9, 10);
    i0.ɵɵlistener("mouseleave", function DigitalPharmacyCardComponent_ng_template_5_ng_template_1_Template_button_mouseleave_0_listener() { i0.ɵɵrestoreView(_r11); const _r9 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r9.close()); })("click", function DigitalPharmacyCardComponent_ng_template_5_ng_template_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r11); const _r9 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r9.open()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngbTooltip", ctx_r5.pharmacyLimitErrorMessage);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.addPharmacyButtonText, " ");
} }
function DigitalPharmacyCardComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, DigitalPharmacyCardComponent_ng_template_5_ng_container_0_Template, 4, 2, "ng-container", 3);
    i0.ɵɵtemplate(1, DigitalPharmacyCardComponent_ng_template_5_ng_template_1_Template, 3, 2, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r4 = i0.ɵɵreference(2);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.pharmacyCountWithinLimits)("ngIfElse", _r4);
} }
class DigitalPharmacyCardComponent {
    constructor(pharmacyFacade) {
        this.pharmacyFacade = pharmacyFacade;
    }
    ngOnChanges(changes) {
        const { selectedPharmacies } = changes;
        if (!_isEqual(selectedPharmacies?.previousValue, selectedPharmacies?.currentValue)) {
            this.isSelectedPharmacy = this.pharmacyFacade.isSelectedPharmacy(this.pharmacy);
        }
    }
    addPharmacy(pharmacyId) {
        const pharmacy = this.digitalPharmacies.find(existingPharmacy => existingPharmacy.pharmacyId === pharmacyId);
        if (pharmacy) {
            this.pharmacyFacade.addPharmacy(pharmacy);
        }
    }
}
DigitalPharmacyCardComponent.ɵfac = function DigitalPharmacyCardComponent_Factory(t) { return new (t || DigitalPharmacyCardComponent)(i0.ɵɵdirectiveInject(PharmacyFacade)); };
DigitalPharmacyCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DigitalPharmacyCardComponent, selectors: [["vnext-digital-pharmacy-card"]], inputs: { pharmacy: "pharmacy", pharmacyAddedLabel: "pharmacyAddedLabel", index: "index", pharmacyCountWithinLimits: "pharmacyCountWithinLimits", addPharmacyButtonText: "addPharmacyButtonText", pharmacyLimitErrorMessage: "pharmacyLimitErrorMessage", digitalPharmacies: "digitalPharmacies", selectedPharmacies: "selectedPharmacies" }, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 3, consts: [[1, "row", "pharmacy-card"], [1, "col-12", "col-sm-8", "Spa_Style_H4", "mb-2", "mb-sm-0", "no-translate-block"], [1, "col-12", "col-sm-4"], [4, "ngIf", "ngIfElse"], ["showAddPharmacy", ""], ["tabindex", "0", 1, "btn", "mt-2", "w-100", "Spa_Style_SecondaryButtonSelected", "Spa_Style_Bold_Weight"], ["showPharmacyLimitMessage", ""], ["role", "button", 1, "btn", "w-100", "Spa_Style_SecondaryButton", "Spa_Style_Regular_Weight", "pharmacy-border-color", 3, "click"], ["pharmacyButton", ""], ["triggers", "manual", "placement", "top", "container", "body", "autoClose", "true", 1, "btn", "w-100", "Spa_Style_SecondaryButton", "Spa_Style_Regular_Weight", "pharmacy-border-color", 3, "ngbTooltip", "mouseleave", "click"], ["pharmacyLimitTooltip", "ngbTooltip"]], template: function DigitalPharmacyCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵtemplate(4, DigitalPharmacyCardComponent_ng_container_4_Template, 3, 2, "ng-container", 3);
        i0.ɵɵtemplate(5, DigitalPharmacyCardComponent_ng_template_5_Template, 3, 2, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(6);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.pharmacy.name, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isSelectedPharmacy)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgIf, i1$1.NgbTooltip], styles: [".pharmacy-card[_ngcontent-%COMP%]{align-items:center;border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px;padding:12px 0;margin-bottom:12px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DigitalPharmacyCardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-digital-pharmacy-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row pharmacy-card\">\r\n  <div class=\"col-12 col-sm-8 Spa_Style_H4 mb-2 mb-sm-0 no-translate-block\">\r\n    {{ pharmacy.name }}\r\n  </div>\r\n  <div class=\"col-12 col-sm-4\">\r\n    <ng-container *ngIf=\"isSelectedPharmacy; else showAddPharmacy\">\r\n      <div\r\n        class=\"btn mt-2 w-100 Spa_Style_SecondaryButtonSelected Spa_Style_Bold_Weight\"\r\n        [attr.aria-describedby]=\"'Spa_Style_HeaderTextLevel_' + index + ' addedPharmacyText'\"\r\n        tabindex=\"0\"\r\n      >\r\n        {{ pharmacyAddedLabel }}\r\n      </div>\r\n    </ng-container>\r\n    <ng-template #showAddPharmacy>\r\n      <ng-container *ngIf=\"pharmacyCountWithinLimits; else showPharmacyLimitMessage\">\r\n        <button\r\n          #pharmacyButton\r\n          class=\"btn w-100 Spa_Style_SecondaryButton Spa_Style_Regular_Weight pharmacy-border-color\"\r\n          (click)=\"addPharmacy(pharmacy.pharmacyId)\"\r\n          role=\"button\"\r\n          [attr.aria-describedby]=\"'Spa_Style_HeaderTextLevel_' + index + ' addPharmacyText'\"\r\n        >\r\n          {{ addPharmacyButtonText }}\r\n        </button>\r\n      </ng-container>\r\n      <ng-template #showPharmacyLimitMessage>\r\n        <button\r\n          class=\"btn w-100 Spa_Style_SecondaryButton Spa_Style_Regular_Weight pharmacy-border-color\"\r\n          [ngbTooltip]=\"pharmacyLimitErrorMessage\"\r\n          triggers=\"manual\"\r\n          placement=\"top\"\r\n          container=\"body\"\r\n          autoClose=\"true\"\r\n          #pharmacyLimitTooltip=\"ngbTooltip\"\r\n          (mouseleave)=\"pharmacyLimitTooltip.close()\"\r\n          (click)=\"pharmacyLimitTooltip.open()\"\r\n        >\r\n          {{ addPharmacyButtonText }}\r\n        </button>\r\n      </ng-template>\r\n    </ng-template>\r\n  </div>\r\n</div>\r\n", styles: [".pharmacy-card{align-items:center;border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px;padding:12px 0;margin-bottom:12px}\n"] }]
    }], function () { return [{ type: PharmacyFacade }]; }, { pharmacy: [{
            type: Input
        }], pharmacyAddedLabel: [{
            type: Input
        }], index: [{
            type: Input
        }], pharmacyCountWithinLimits: [{
            type: Input
        }], addPharmacyButtonText: [{
            type: Input
        }], pharmacyLimitErrorMessage: [{
            type: Input
        }], digitalPharmacies: [{
            type: Input
        }], selectedPharmacies: [{
            type: Input
        }] }); })();

function DigitalPharmacyComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-digital-pharmacy-card", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const pharmacy_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pharmacy", pharmacy_r2)("pharmacyAddedLabel", ctx_r0.pharmacyAddedLabel)("index", i_r3)("pharmacyCountWithinLimits", ctx_r0.pharmacyCountWithinLimits)("addPharmacyButtonText", ctx_r0.addPharmacyButtonText)("pharmacyLimitErrorMessage", ctx_r0.pharmacyLimitErrorMessage)("digitalPharmacies", ctx_r0.digitalPharmacies)("selectedPharmacies", ctx_r0.selectedPharmacies);
} }
function DigitalPharmacyComponent_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "vnext-pagination", 7);
    i0.ɵɵlistener("updatePagination", function DigitalPharmacyComponent_div_4_div_1_Template_vnext_pagination_updatePagination_1_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r5.updateDigitalPharmacies($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pagination", ctx_r4.digitalPharmacies)("defaultStartItem", ctx_r4.defaultStartItem)("itemsPerPage", ctx_r4.itemsPerPage)("paginationText", ctx_r4.paginationText);
} }
function DigitalPharmacyComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, DigitalPharmacyComponent_div_4_div_1_Template, 2, 4, "div", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.pharmacyPaginationEnabled && ctx_r1.itemsPerPage < (ctx_r1.digitalPharmacies == null ? null : ctx_r1.digitalPharmacies.length));
} }
class DigitalPharmacyComponent {
    constructor() {
        this.subscriptions = [];
    }
    updateDigitalPharmacies(pagination) {
        this.defaultStartItem = pagination.defaultStartItem;
        this.pageSize = this.pharmacyPaginationEnabled ? pagination.pageSize : this.pharmacyLimit;
        this.pageIndex = pagination.defaultStartItem;
        this.digitalPharmaciesSliceStartIndex = (this.pageIndex - 1) * this.pageSize;
        this.digitalPharmaciesSliceEndIndex = (this.pageIndex - 1) * this.pageSize + this.pageSize;
    }
    trackByPharmacyId(index, pharmacy) {
        return pharmacy.pharmacyId;
    }
}
DigitalPharmacyComponent.ɵfac = function DigitalPharmacyComponent_Factory(t) { return new (t || DigitalPharmacyComponent)(); };
DigitalPharmacyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DigitalPharmacyComponent, selectors: [["vnext-widget-digital-pharmacy"]], inputs: { digitalTabIntroText: "digitalTabIntroText", digitalPharmacies: "digitalPharmacies", addPharmacyButtonText: "addPharmacyButtonText", pharmacyAddedLabel: "pharmacyAddedLabel", addPharmacyText: "addPharmacyText", pharmacyLimitErrorMessage: "pharmacyLimitErrorMessage", pageSize: "pageSize", pageIndex: "pageIndex", pharmacyCountWithinLimits: "pharmacyCountWithinLimits", pharmacyPaginationEnabled: "pharmacyPaginationEnabled", itemsPerPage: "itemsPerPage", defaultStartItem: "defaultStartItem", paginationText: "paginationText", pharmacyLimit: "pharmacyLimit", selectedPharmacies: "selectedPharmacies" }, decls: 5, vars: 8, consts: [[1, "mt-4", "mb-4", "Spa_Style_Primary_Color", "Spa_Style_Small_Font"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "row", 4, "ngIf"], [3, "pharmacy", "pharmacyAddedLabel", "index", "pharmacyCountWithinLimits", "addPharmacyButtonText", "pharmacyLimitErrorMessage", "digitalPharmacies", "selectedPharmacies"], [1, "row"], ["class", "col-12 px-0 pr-md-3 mt-3", 4, "ngIf"], [1, "col-12", "px-0", "pr-md-3", "mt-3"], [3, "pagination", "defaultStartItem", "itemsPerPage", "paginationText", "updatePagination"]], template: function DigitalPharmacyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, DigitalPharmacyComponent_ng_container_2_Template, 2, 8, "ng-container", 1);
        i0.ɵɵpipe(3, "slice");
        i0.ɵɵtemplate(4, DigitalPharmacyComponent_div_4_Template, 2, 1, "div", 2);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.digitalTabIntroText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(3, 4, ctx.digitalPharmacies, ctx.digitalPharmaciesSliceStartIndex, ctx.digitalPharmaciesSliceEndIndex))("ngForTrackBy", ctx.trackByPharmacyId);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.digitalPharmacies == null ? null : ctx.digitalPharmacies.length);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, PaginationComponent, DigitalPharmacyCardComponent, i1$2.SlicePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DigitalPharmacyComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-digital-pharmacy', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"mt-4 mb-4 Spa_Style_Primary_Color Spa_Style_Small_Font\">{{ digitalTabIntroText }}</div>\r\n\r\n<ng-container\r\n  *ngFor=\"\r\n    let pharmacy of digitalPharmacies | slice : digitalPharmaciesSliceStartIndex : digitalPharmaciesSliceEndIndex;\r\n    index as i;\r\n    trackBy: trackByPharmacyId\r\n  \"\r\n>\r\n  <vnext-digital-pharmacy-card\r\n    [pharmacy]=\"pharmacy\"\r\n    [pharmacyAddedLabel]=\"pharmacyAddedLabel\"\r\n    [index]=\"i\"\r\n    [pharmacyCountWithinLimits]=\"pharmacyCountWithinLimits\"\r\n    [addPharmacyButtonText]=\"addPharmacyButtonText\"\r\n    [pharmacyLimitErrorMessage]=\"pharmacyLimitErrorMessage\"\r\n    [digitalPharmacies]=\"digitalPharmacies\"\r\n    [selectedPharmacies]=\"selectedPharmacies\"\r\n  ></vnext-digital-pharmacy-card>\r\n</ng-container>\r\n<div class=\"row\" *ngIf=\"digitalPharmacies?.length\">\r\n  <div class=\"col-12 px-0 pr-md-3 mt-3\" *ngIf=\"pharmacyPaginationEnabled && itemsPerPage < digitalPharmacies?.length\">\r\n    <vnext-pagination\r\n      [pagination]=\"digitalPharmacies\"\r\n      [defaultStartItem]=\"defaultStartItem\"\r\n      [itemsPerPage]=\"itemsPerPage\"\r\n      [paginationText]=\"paginationText\"\r\n      (updatePagination)=\"updateDigitalPharmacies($event)\"\r\n    ></vnext-pagination>\r\n  </div>\r\n</div>\r\n" }]
    }], null, { digitalTabIntroText: [{
            type: Input
        }], digitalPharmacies: [{
            type: Input
        }], addPharmacyButtonText: [{
            type: Input
        }], pharmacyAddedLabel: [{
            type: Input
        }], addPharmacyText: [{
            type: Input
        }], pharmacyLimitErrorMessage: [{
            type: Input
        }], pageSize: [{
            type: Input
        }], pageIndex: [{
            type: Input
        }], pharmacyCountWithinLimits: [{
            type: Input
        }], pharmacyPaginationEnabled: [{
            type: Input
        }], itemsPerPage: [{
            type: Input
        }], defaultStartItem: [{
            type: Input
        }], paginationText: [{
            type: Input
        }], pharmacyLimit: [{
            type: Input
        }], selectedPharmacies: [{
            type: Input
        }] }); })();

function PharmacySearchHeaderComponent_h1_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.pharmacyText);
} }
function PharmacySearchHeaderComponent_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 5);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r1.pharmacySearchIntroText, "html"), i0.ɵɵsanitizeHtml);
} }
let PharmacySearchHeaderComponent = class PharmacySearchHeaderComponent extends ConfigurableWidget {
};
PharmacySearchHeaderComponent.ɵfac = /*@__PURE__*/ function () { let ɵPharmacySearchHeaderComponent_BaseFactory; return function PharmacySearchHeaderComponent_Factory(t) { return (ɵPharmacySearchHeaderComponent_BaseFactory || (ɵPharmacySearchHeaderComponent_BaseFactory = i0.ɵɵgetInheritedFactory(PharmacySearchHeaderComponent)))(t || PharmacySearchHeaderComponent); }; }();
PharmacySearchHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PharmacySearchHeaderComponent, selectors: [["vnext-pharmacy-search-header"]], inputs: { pharmacySearchIntroText: "pharmacySearchIntroText", pharmacySearchHeaderText: "pharmacySearchHeaderText", currentPharmacyText: "currentPharmacyText", pharmacyText: "pharmacyText", selectedPharmacy: "selectedPharmacy", multiPharmacyEnabled: "multiPharmacyEnabled" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 2, consts: [[1, "text-center"], ["aria-hidden", "true", 1, "fas", "Spa_Style_PharmacyIcon", "pharmacy-icon"], ["class", "Spa_Style_H1", 4, "liveEditProp"], ["class", "Spa_Style_IntroParagraph", "navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], [1, "Spa_Style_H1"], ["navigationAdapter", "", 1, "Spa_Style_IntroParagraph", 3, "innerHTML"]], template: function PharmacySearchHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "i", 1);
        i0.ɵɵtemplate(2, PharmacySearchHeaderComponent_h1_2_Template, 2, 1, "h1", 2);
        i0.ɵɵtemplate(3, PharmacySearchHeaderComponent_p_3_Template, 2, 4, "p", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_Pharmacy_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_PharmacySearch_Intro_Text");
    } }, dependencies: [NavigationAdapterDirective, LiveEditPropDirective, IconAriaAttributesDirective, SafePipe], styles: [".pharmacy-icon[_ngcontent-%COMP%]{font-size:46px}.selected-pharmacy[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);padding:12px 18px;border-radius:5px}"] });
PharmacySearchHeaderComponent = __decorate([
    PlatformWidget
], PharmacySearchHeaderComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PharmacySearchHeaderComponent, [{
        type: Component,
        args: [{ selector: 'vnext-pharmacy-search-header', template: "<div class=\"text-center\">\r\n  <i class=\"fas Spa_Style_PharmacyIcon pharmacy-icon\" aria-hidden=\"true\"></i>\r\n  <h1 class=\"Spa_Style_H1\" *liveEditProp=\"'Spa_Site_Pharmacy_Text'\">{{ pharmacyText }}</h1>\r\n  <p\r\n    class=\"Spa_Style_IntroParagraph\"\r\n    *liveEditProp=\"'Spa_PharmacySearch_Intro_Text'\"\r\n    [innerHTML]=\"pharmacySearchIntroText | safe: 'html'\"\r\n    navigationAdapter\r\n  ></p>\r\n</div>\r\n", styles: [".pharmacy-icon{font-size:46px}.selected-pharmacy{border:1px solid var(--static-Spa_Style_Accent1);padding:12px 18px;border-radius:5px}\n"] }]
    }], null, { pharmacySearchIntroText: [{
            type: Input
        }], pharmacySearchHeaderText: [{
            type: Input
        }], currentPharmacyText: [{
            type: Input
        }], pharmacyText: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], multiPharmacyEnabled: [{
            type: Input
        }] }); })();

function SelectedPharmacyComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.selectedPharmacy.address1, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3("", ctx_r0.selectedPharmacy.city, ", ", ctx_r0.selectedPharmacy.state, " ", ctx_r0.selectedPharmacy.zip, "");
} }
function SelectedPharmacyComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate(ctx_r2.digitalTabText);
} }
function SelectedPharmacyComponent_div_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 11)(2, "span", 12);
    i0.ɵɵelement(3, "i", 13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 14);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngStyle", ctx_r4.pharmacyFacade.getBackGroundColor(ctx_r4.selectedPharmacy, ctx_r4.isHelpfulToolsView));
    i0.ɵɵattribute("aria-label", ctx_r4.primaryPharmacyText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.primaryPharmacyText);
} }
function SelectedPharmacyComponent_div_8_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 15);
    i0.ɵɵlistener("click", function SelectedPharmacyComponent_div_8_ng_template_2_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.setAsPrimaryClickEvent(ctx_r7.selectedPharmacy)); })("keyup.Enter", function SelectedPharmacyComponent_div_8_ng_template_2_Template_vnext_link_keyup_Enter_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r9.setAsPrimaryClickEvent(ctx_r9.selectedPharmacy)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r6.setAsPrimaryLinkText)("alwaysUnderlined", true)("isLinkButton", true);
} }
function SelectedPharmacyComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, SelectedPharmacyComponent_div_8_ng_container_1_Template, 6, 3, "ng-container", 3);
    i0.ɵɵtemplate(2, SelectedPharmacyComponent_div_8_ng_template_2_Template, 1, 3, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r5 = i0.ɵɵreference(3);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.selectedPharmacy.isPrimaryPharmacy)("ngIfElse", _r5);
} }
const _c0$1V = function (a0, a1) { return { "col-3 col-lg-4": a0, "col-6 col-lg-6": a1 }; };
const _c1$S = function (a0, a1) { return { "col-1 pr-2 mt-3": a0, "col-2 pr-2 mt-2": a1 }; };
class SelectedPharmacyComponent {
    constructor(pharmacyFacade) {
        this.pharmacyFacade = pharmacyFacade;
        this.Spa_SelectedPharmacy_RemovePharmacy_Text = 'remove pharmacy';
    }
    removePharmacy(pharmacyId) {
        this.pharmacyFacade.removePharmacy(pharmacyId);
    }
    setAsPrimaryClickEvent(pharmacy) {
        this.pharmacyFacade
            .setAsPrimaryPharmacy$(pharmacy)
            .pipe(take(1), finalize(() => {
            const selectedNABPPharmacies = this.pharmacyFacade.getSelectedNABPPharmacies();
            return this.pharmacyFacade.setClickPreferencesPharmacySwitchAnalytics(selectedNABPPharmacies);
        }))
            .subscribe(() => { });
    }
}
SelectedPharmacyComponent.ɵfac = function SelectedPharmacyComponent_Factory(t) { return new (t || SelectedPharmacyComponent)(i0.ɵɵdirectiveInject(PharmacyFacade)); };
SelectedPharmacyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectedPharmacyComponent, selectors: [["vnext-widget-selected-pharmacy"]], inputs: { selectedPharmacy: "selectedPharmacy", setAsPrimaryLinkText: "setAsPrimaryLinkText", primaryPharmacyText: "primaryPharmacyText", multiPharmacyEnabled: "multiPharmacyEnabled", isHelpfulToolsView: "isHelpfulToolsView", digitalTabText: "digitalTabText" }, decls: 12, vars: 13, consts: [[1, "row", "align-items-center"], [1, "Spa_Style_H4", "pl-2", "col-5", "col-lg-4", "no-translate-block"], [1, "Spa_Style_Paragraph", "pl-0", "no-translate-block", 3, "ngClass"], [4, "ngIf", "ngIfElse"], ["digitalPharmacyAddress", ""], ["class", "col-3 col-lg-3 Spa_Style_Paragraph pl-4", 4, "ngIf"], [3, "ngClass"], ["tabindex", "0", "role", "button", 1, "pharmacytile-remove", 3, "click", "keyup.enter"], [1, "fas", "fa-times"], [1, "col-3", "col-lg-3", "Spa_Style_Paragraph", "pl-4"], ["showSetPrimaryPharmacyLink", ""], [1, "float-left"], [1, "fa-stack"], ["role", "img", 1, "fas", "fa-star", "fa-stack-2x", "pharmacy-primary-icon-size", 3, "ngStyle"], [1, "mt-1"], [3, "title", "alwaysUnderlined", "isLinkButton", "click", "keyup.Enter"]], template: function SelectedPharmacyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div")(1, "div", 0)(2, "h3", 1);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtemplate(5, SelectedPharmacyComponent_ng_container_5_Template, 4, 4, "ng-container", 3);
        i0.ɵɵtemplate(6, SelectedPharmacyComponent_ng_template_6_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, SelectedPharmacyComponent_div_8_Template, 4, 2, "div", 5);
        i0.ɵɵelementStart(9, "div", 6)(10, "div", 7);
        i0.ɵɵlistener("click", function SelectedPharmacyComponent_Template_div_click_10_listener() { return ctx.removePharmacy(ctx.selectedPharmacy.pharmacyId); })("keyup.enter", function SelectedPharmacyComponent_Template_div_keyup_enter_10_listener() { return ctx.removePharmacy(ctx.selectedPharmacy.pharmacyId); });
        i0.ɵɵelement(11, "i", 8);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(7);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.selectedPharmacy.name, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c0$1V, ctx.multiPharmacyEnabled, !ctx.multiPharmacyEnabled));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.selectedPharmacy.isDigitalPharmacy)("ngIfElse", _r1);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.multiPharmacyEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(10, _c1$S, ctx.multiPharmacyEnabled, !ctx.multiPharmacyEnabled));
        i0.ɵɵadvance(1);
        i0.ɵɵattribute("aria-label", ctx.Spa_SelectedPharmacy_RemovePharmacy_Text);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$2.NgStyle, LinkComponent, IconAriaAttributesDirective], styles: [".pharmacytile-remove[_ngcontent-%COMP%]{font-size:14px;float:right;display:flex;align-items:center;cursor:pointer}.pharmacytile-remove[_ngcontent-%COMP%]:focus{padding:0 5px;margin:0 -5px;border-radius:5px}.pharmacy-primary-icon-size[_ngcontent-%COMP%]{font-size:25px!important}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], SelectedPharmacyComponent.prototype, "Spa_SelectedPharmacy_RemovePharmacy_Text", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectedPharmacyComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-selected-pharmacy', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div>\r\n  <div class=\"row align-items-center\">\r\n    <h3 class=\"Spa_Style_H4 pl-2 col-5 col-lg-4 no-translate-block\">\r\n      {{ selectedPharmacy.name }}\r\n    </h3>\r\n    <div [ngClass]=\"{ 'col-3 col-lg-4': multiPharmacyEnabled, 'col-6 col-lg-6': !multiPharmacyEnabled }\" class=\"Spa_Style_Paragraph pl-0 no-translate-block\">\r\n      <ng-container *ngIf=\"!selectedPharmacy.isDigitalPharmacy; else digitalPharmacyAddress\">\r\n        {{ selectedPharmacy.address1 }}\r\n        <div>{{ selectedPharmacy.city }}, {{ selectedPharmacy.state }} {{ selectedPharmacy.zip }}</div>\r\n      </ng-container>\r\n      <ng-template #digitalPharmacyAddress>{{ digitalTabText }}</ng-template>\r\n    </div>\r\n    <div *ngIf=\"multiPharmacyEnabled\" class=\"col-3 col-lg-3 Spa_Style_Paragraph pl-4\">\r\n      <ng-container *ngIf=\"selectedPharmacy.isPrimaryPharmacy; else showSetPrimaryPharmacyLink\">\r\n        <div class=\"float-left\">\r\n          <span class=\"fa-stack\"\r\n            ><i\r\n              class=\"fas fa-star fa-stack-2x pharmacy-primary-icon-size\"\r\n              role=\"img\"\r\n              [attr.aria-label]=\"primaryPharmacyText\"\r\n              [ngStyle]=\"this.pharmacyFacade.getBackGroundColor(selectedPharmacy, isHelpfulToolsView)\"\r\n            ></i\r\n          ></span>\r\n        </div>\r\n        <div class=\"mt-1\">{{ primaryPharmacyText }}</div>\r\n      </ng-container>\r\n      <ng-template #showSetPrimaryPharmacyLink>\r\n        <vnext-link\r\n          [title]=\"setAsPrimaryLinkText\"\r\n          [alwaysUnderlined]=\"true\"\r\n          (click)=\"setAsPrimaryClickEvent(selectedPharmacy)\"\r\n          (keyup.Enter)=\"setAsPrimaryClickEvent(selectedPharmacy)\"\r\n          [isLinkButton]=\"true\"\r\n        >\r\n        </vnext-link>\r\n      </ng-template>\r\n    </div>\r\n    <div [ngClass]=\"{ 'col-1 pr-2 mt-3': multiPharmacyEnabled, 'col-2 pr-2 mt-2': !multiPharmacyEnabled }\">\r\n      <div\r\n        class=\"pharmacytile-remove\"\r\n        tabindex=\"0\"\r\n        [attr.aria-label]=\"Spa_SelectedPharmacy_RemovePharmacy_Text\"\r\n        role=\"button\"\r\n        (click)=\"removePharmacy(selectedPharmacy.pharmacyId)\"\r\n        (keyup.enter)=\"removePharmacy(selectedPharmacy.pharmacyId)\"\r\n      >\r\n        <i class=\"fas fa-times\"></i>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".pharmacytile-remove{font-size:14px;float:right;display:flex;align-items:center;cursor:pointer}.pharmacytile-remove:focus{padding:0 5px;margin:0 -5px;border-radius:5px}.pharmacy-primary-icon-size{font-size:25px!important}\n"] }]
    }], function () { return [{ type: PharmacyFacade }]; }, { Spa_SelectedPharmacy_RemovePharmacy_Text: [], selectedPharmacy: [{
            type: Input
        }], setAsPrimaryLinkText: [{
            type: Input
        }], primaryPharmacyText: [{
            type: Input
        }], multiPharmacyEnabled: [{
            type: Input
        }], isHelpfulToolsView: [{
            type: Input
        }], digitalTabText: [{
            type: Input
        }] }); })();

const _c0$1U = ["pharmacyPopover"];
function PharmacySearchComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-pharmacy-search-header", 23);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pharmacySearchHeaderText", ctx_r0.pharmacySearchHeaderText)("pharmacySearchIntroText", ctx_r0.pharmacySearchIntroText)("currentPharmacyText", ctx_r0.currentPharmacyText)("pharmacyText", ctx_r0.pharmacyText)("selectedPharmacy", ctx_r0.selectedPharmacies)("multiPharmacyEnabled", ctx_r0.multiPharmacyEnabled);
} }
function PharmacySearchComponent_div_8_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵelement(1, "i", 30);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r17.pharmacyErrorText, "");
} }
function PharmacySearchComponent_div_8_label_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 31);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r18.pharmacyNameText, " ");
} }
function PharmacySearchComponent_div_8_ng_container_3_input_1_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 33);
    i0.ɵɵlistener("keyup.enter", function PharmacySearchComponent_div_8_ng_container_3_input_1_Template_input_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r23.validateZip()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("placeholder", ctx_r22.pharmacyNameHintText)("formControl", ctx_r22.pharmacyName);
} }
function PharmacySearchComponent_div_8_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PharmacySearchComponent_div_8_ng_container_3_input_1_Template, 1, 2, "input", 32);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_PharmacyName_HintText");
} }
function PharmacySearchComponent_div_8_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 33);
    i0.ɵɵlistener("keyup.enter", function PharmacySearchComponent_div_8_ng_template_4_Template_input_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r25.filterDigitalPharmacies()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("placeholder", ctx_r21.pharmacyNameHintText)("formControl", ctx_r21.digitalPharmacyName);
} }
function PharmacySearchComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, PharmacySearchComponent_div_8_span_1_Template, 3, 1, "span", 25);
    i0.ɵɵtemplate(2, PharmacySearchComponent_div_8_label_2_Template, 2, 1, "label", 26);
    i0.ɵɵtemplate(3, PharmacySearchComponent_div_8_ng_container_3_Template, 2, 1, "ng-container", 27);
    i0.ɵɵtemplate(4, PharmacySearchComponent_div_8_ng_template_4_Template, 1, 2, "ng-template", null, 28, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r20 = i0.ɵɵreference(5);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.hasMinCharError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_PharmacyName_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.isRetailTabActive)("ngIfElse", _r20);
} }
function PharmacySearchComponent_div_13_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37, 38);
    i0.ɵɵlistener("click", function PharmacySearchComponent_div_13_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r30.pharmacyFilterPopover()); })("hidden", function PharmacySearchComponent_div_13_button_1_Template_button_hidden_0_listener() { i0.ɵɵrestoreView(_r31); const ctx_r32 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r32.onClosePharmacyFilterPopover()); });
    i0.ɵɵelement(2, "i", 39);
    i0.ɵɵelementStart(3, "span", 40);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "i", 41);
    i0.ɵɵelementStart(6, "span", 42);
    i0.ɵɵtext(7, "Expand");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(2);
    const _r5 = i0.ɵɵreference(20);
    i0.ɵɵproperty("ngbPopover", _r5)("autoClose", "outside");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r27.pharmacyFilterText);
} }
function PharmacySearchComponent_div_13_label_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 43)(1, "span", 44);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", ctx_r28.pharmacyFacade.getBadgeColor());
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r28.filterCount);
} }
function PharmacySearchComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵtemplate(1, PharmacySearchComponent_div_13_button_1_Template, 8, 3, "button", 35);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, PharmacySearchComponent_div_13_label_3_Template, 3, 2, "label", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const _r7 = i0.ɵɵreference(22);
    let tmp_0_0;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_0_0 = i0.ɵɵpipeBind1(2, 3, ctx_r2.pharmacyFacade.pharmacyTypes$)) == null ? null : tmp_0_0.length)("ngIfElse", _r7);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.showHideFilter() && ctx_r2.filterCount > 0);
} }
function PharmacySearchComponent_button_15_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 45);
    i0.ɵɵlistener("click", function PharmacySearchComponent_button_15_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r33.pharmacyFilterModal()); });
    i0.ɵɵelement(1, "i", 39);
    i0.ɵɵelementStart(2, "span", 40);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.pharmacyFilterText);
} }
function PharmacySearchComponent_span_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 46);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", ctx_r4.pharmacyFacade.getBadgeColor());
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r4.filterCount);
} }
function PharmacySearchComponent_ng_template_19_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 47)(1, "vnext-pharmacy-filter-items", 48);
    i0.ɵɵlistener("clearFormGroupValues", function PharmacySearchComponent_ng_template_19_Template_vnext_pharmacy_filter_items_clearFormGroupValues_1_listener() { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r35.clearFormGroupValues()); });
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pharmacyFilterClearText", ctx_r6.pharmacyFilterClearText)("pharmacyFilters", ctx_r6.pharmacyFacade.sortFilterControls(i0.ɵɵpipeBind1(2, 3, ctx_r6.pharmacyFacade.pharmacyTypes$), true))("filterForm", ctx_r6.filterForm);
} }
function PharmacySearchComponent_ng_template_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 49);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r8.defaultFilterText);
} }
function PharmacySearchComponent_ng_container_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function PharmacySearchComponent_div_25_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r38.currentPharmacyText);
} }
function PharmacySearchComponent_div_25_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 55);
    i0.ɵɵelement(1, "vnext-widget-selected-pharmacy", 56);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const pharmacy_r40 = ctx.$implicit;
    const ctx_r39 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("selectedPharmacy", pharmacy_r40)("setAsPrimaryLinkText", ctx_r39.setAsPrimaryLinkText)("primaryPharmacyText", ctx_r39.primaryPharmacyText)("multiPharmacyEnabled", ctx_r39.multiPharmacyEnabled)("isHelpfulToolsView", ctx_r39.isHelpfulToolsView)("digitalTabText", ctx_r39.digitalTabText);
} }
function PharmacySearchComponent_div_25_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 51)(1, "h2", 52);
    i0.ɵɵtemplate(2, PharmacySearchComponent_div_25_div_1_span_2_Template, 2, 1, "span", 53);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PharmacySearchComponent_div_25_div_1_div_3_Template, 2, 6, "div", 54);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", ctx_r37.multiPharmacyEnabled ? "Spa_Site_AddPharmacy_YourMultiPharmacyText" : "Spa_AddPharmacy_YourPharmacyText");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r37.selectedPharmacies);
} }
function PharmacySearchComponent_div_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵtemplate(1, PharmacySearchComponent_div_25_div_1_Template, 4, 2, "div", 50);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.selectedPharmacies.length > 0 && ctx_r10.selectedPharmacies);
} }
function PharmacySearchComponent_ng_template_26_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-widget-pharmacy-list", 61);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pharmacies", i0.ɵɵpipeBind1(2, 20, ctx_r43.filteredPharmacies$))("selectedPharmacies", ctx_r43.selectedPharmacies)("addPharmacyButtonText", ctx_r43.addPharmacyButtonText)("pharmacyAddedLabel", ctx_r43.pharmacyAddedLabel)("pageSize", ctx_r43.pageSize)("pageIndex", ctx_r43.pageIndex)("electronicPrescriptionTooltipHeader", ctx_r43.electronicPrescriptionTooltipHeader)("electronicPrescriptionTooltipBody", ctx_r43.electronicPrescriptionTooltipBody)("standardInNetworkText", ctx_r43.standardInNetworkText)("standardInNetworkTooltipContent", ctx_r43.standardInNetworkTooltipContent)("preferredInNetworkText", ctx_r43.preferredInNetworkText)("preferredInNetworkTooltipContent", ctx_r43.preferredInNetworkTooltipContent)("addedPharmacyText", ctx_r43.addedPharmacyText)("addPharmacyText", ctx_r43.addPharmacyText)("ePrescribingAltText", ctx_r43.ePrescribingAltText)("Spa_Site_Tooltip_Text", ctx_r43.Spa_Site_Tooltip_Text)("multiPharmacyEnabled", ctx_r43.multiPharmacyEnabled)("maxPharmacyCount", ctx_r43.maxPharmacyCount)("pharmacyLimitErrorMessage", ctx_r43.pharmacyLimitErrorMessage)("primaryPharmacyText", ctx_r43.primaryPharmacyText);
} }
function PharmacySearchComponent_ng_template_26_div_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 62);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 63);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r44.viewNotFoundHeaderText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r44.viewNotFoundBodyText, " ");
} }
function PharmacySearchComponent_ng_template_26_div_0_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47)(1, "div", 66)(2, "vnext-tooltip", 67);
    i0.ɵɵelement(3, "i", 68);
    i0.ɵɵelementStart(4, "span", 69);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(6, "div", 66)(7, "vnext-tooltip", 67);
    i0.ɵɵelement(8, "i", 70);
    i0.ɵɵelementStart(9, "span", 69);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("header", ctx_r46.preferredInNetworkText)("body", ctx_r46.preferredInNetworkTooltipContent)("Spa_Site_Tooltip_Text", ctx_r46.Spa_Site_Tooltip_Text);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r46.preferredInNetworkText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("header", ctx_r46.standardInNetworkText)("body", ctx_r46.standardInNetworkTooltipContent)("Spa_Site_Tooltip_Text", ctx_r46.Spa_Site_Tooltip_Text);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r46.standardInNetworkText);
} }
function PharmacySearchComponent_ng_template_26_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 64);
    i0.ɵɵtemplate(1, PharmacySearchComponent_ng_template_26_div_0_div_4_div_1_Template, 11, 8, "div", 19);
    i0.ɵɵelementStart(2, "vnext-widget-map", 65);
    i0.ɵɵlistener("setZoom", function PharmacySearchComponent_ng_template_26_div_0_div_4_Template_vnext_widget_map_setZoom_2_listener($event) { i0.ɵɵrestoreView(_r48); const ctx_r47 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r47.setZoom($event)); })("resetToDefaultPageIndex", function PharmacySearchComponent_ng_template_26_div_0_div_4_Template_vnext_widget_map_resetToDefaultPageIndex_2_listener() { i0.ɵɵrestoreView(_r48); const ctx_r49 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r49.updatePharmacies({ pageSize: ctx_r49.itemsPerPage, defaultStartItem: 1 })); })("setMapCenter", function PharmacySearchComponent_ng_template_26_div_0_div_4_Template_vnext_widget_map_setMapCenter_2_listener($event) { i0.ɵɵrestoreView(_r48); const ctx_r50 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r50.setMapCenter($event)); })("setMap", function PharmacySearchComponent_ng_template_26_div_0_div_4_Template_vnext_widget_map_setMap_2_listener($event) { i0.ɵɵrestoreView(_r48); const ctx_r51 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r51.initializeMap($event)); })("setMapDefaultBounds", function PharmacySearchComponent_ng_template_26_div_0_div_4_Template_vnext_widget_map_setMapDefaultBounds_2_listener($event) { i0.ɵɵrestoreView(_r48); const ctx_r52 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r52.setMapDefaultBounds($event)); })("addSelectedItem", function PharmacySearchComponent_ng_template_26_div_0_div_4_Template_vnext_widget_map_addSelectedItem_2_listener($event) { i0.ɵɵrestoreView(_r48); const ctx_r53 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r53.addPharmacyFromMarker($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r45.isHelpfulToolsView);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("zip", ctx_r45.zip)("zoom", ctx_r45.zoom)("minZoom", ctx_r45.minZoom)("maxZoom", ctx_r45.maxZoom)("isHelpfulToolsView", ctx_r45.isHelpfulToolsView)("addButtonText", ctx_r45.addPharmacyButtonText)("addedLabel", ctx_r45.pharmacyAddedLabel)("markers", ctx_r45.markers)("limitErrorMessage", ctx_r45.pharmacyLimitErrorMessage)("primaryIconAriaLabelText", ctx_r45.primaryPharmacyText);
} }
function PharmacySearchComponent_ng_template_26_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 58)(1, "div", 59);
    i0.ɵɵtemplate(2, PharmacySearchComponent_ng_template_26_div_0_ng_container_2_Template, 3, 22, "ng-container", 2);
    i0.ɵɵtemplate(3, PharmacySearchComponent_ng_template_26_div_0_ng_container_3_Template, 5, 2, "ng-container", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PharmacySearchComponent_ng_template_26_div_0_div_4_Template, 3, 11, "div", 60);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r41.pharmacies == null ? null : ctx_r41.pharmacies.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !((ctx_r41.pharmacies == null ? null : ctx_r41.pharmacies.length) > 0) && !ctx_r41.mapFacade.showSpinner);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r41.zip);
} }
function PharmacySearchComponent_ng_template_26_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 72)(1, "vnext-pagination", 73);
    i0.ɵɵlistener("updatePagination", function PharmacySearchComponent_ng_template_26_div_1_div_1_Template_vnext_pagination_updatePagination_1_listener($event) { i0.ɵɵrestoreView(_r56); const ctx_r55 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r55.updatePharmacies($event)); });
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pagination", i0.ɵɵpipeBind1(2, 4, ctx_r54.filteredPharmacies$))("defaultStartItem", ctx_r54.defaultStartItem)("itemsPerPage", ctx_r54.itemsPerPage)("paginationText", ctx_r54.paginationText);
} }
function PharmacySearchComponent_ng_template_26_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵtemplate(1, PharmacySearchComponent_ng_template_26_div_1_div_1_Template, 3, 6, "div", 71);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r42.pharmacyPaginationEnabled && ctx_r42.itemsPerPage < (ctx_r42.pharmacies == null ? null : ctx_r42.pharmacies.length));
} }
function PharmacySearchComponent_ng_template_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PharmacySearchComponent_ng_template_26_div_0_Template, 5, 3, "div", 57);
    i0.ɵɵtemplate(1, PharmacySearchComponent_ng_template_26_div_1_Template, 2, 1, "div", 19);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r12.mapFacade.showMap);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.mapFacade.showMap);
} }
function PharmacySearchComponent_ng_template_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-digital-pharmacy", 74);
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    let tmp_12_0;
    i0.ɵɵproperty("digitalTabIntroText", ctx_r14.digitalTabIntroText)("digitalPharmacies", ctx_r14.filteredDigitalPharmacies)("pharmacyAddedLabel", ctx_r14.pharmacyAddedLabel)("addPharmacyButtonText", ctx_r14.addPharmacyButtonText)("addPharmacyText", ctx_r14.addPharmacyText)("pharmacyLimitErrorMessage", ctx_r14.pharmacyLimitErrorMessage)("pageSize", ctx_r14.pageSize)("pageIndex", ctx_r14.pageIndex)("pharmacyCountWithinLimits", ctx_r14.pharmacyCountWithinLimits)("itemsPerPage", ctx_r14.itemsPerPage)("defaultStartItem", ctx_r14.defaultStartItem)("paginationText", ctx_r14.paginationText)("pharmacyLimit", (tmp_12_0 = ctx_r14.digitalPharmacies == null ? null : ctx_r14.digitalPharmacies.length) !== null && tmp_12_0 !== undefined ? tmp_12_0 : ctx_r14.pharmacyLimit)("selectedPharmacies", ctx_r14.selectedPharmacies)("pharmacyPaginationEnabled", false);
} }
function PharmacySearchComponent_ng_template_30_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function PharmacySearchComponent_ng_template_30_Template(rf, ctx) { if (rf & 1) {
    const _r59 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 75)(1, "vnext-tab-list", 76);
    i0.ɵɵlistener("updateActiveTab", function PharmacySearchComponent_ng_template_30_Template_vnext_tab_list_updateActiveTab_1_listener($event) { i0.ɵɵrestoreView(_r59); const ctx_r58 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r58.updateActiveTab($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(2, PharmacySearchComponent_ng_template_30_ng_container_2_Template, 1, 0, "ng-container", 18);
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext();
    const _r11 = i0.ɵɵreference(27);
    const _r13 = i0.ɵɵreference(29);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("tabList", ctx_r16.pharmacyTabList)("activeTab", ctx_r16.activeTab);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.isRetailTabActive)("ngIfThen", _r11)("ngIfElse", _r13);
} }
class PharmacySearchComponent {
    constructor(cdr, widgetValidationService, configurableWidgetService, pharmacyFacade, mapFacade, helpfulToolsContext, helpfulToolsService, spinnerService, mapContextService, formValidationService, filterService, localeService, injector, navigationutilityService, navigationContext) {
        this.cdr = cdr;
        this.widgetValidationService = widgetValidationService;
        this.configurableWidgetService = configurableWidgetService;
        this.pharmacyFacade = pharmacyFacade;
        this.mapFacade = mapFacade;
        this.helpfulToolsContext = helpfulToolsContext;
        this.helpfulToolsService = helpfulToolsService;
        this.spinnerService = spinnerService;
        this.mapContextService = mapContextService;
        this.formValidationService = formValidationService;
        this.filterService = filterService;
        this.localeService = localeService;
        this.injector = injector;
        this.navigationutilityService = navigationutilityService;
        this.navigationContext = navigationContext;
        this.isFilterEnabled = false;
        this.pharmacyTabList = [];
        this.Spa_Site_Preferred_In_Network_Text = 'Preferred In-network';
        this.Spa_Site_Standard_In_Network_Text = 'Standard In-network';
        this.Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text = 'Pharmacies that are willing to give the plans a larger discount than other pharmacies.';
        this.Spa_PharmacySearch_Standard_In_Network_Tooltip_Text = 'These pharmacies may charge a higher copayment or co-insurance for filling your prescription.';
        this.zipCodeStyles = { roundInputRightBorder: true };
        this.pharmacyName = new UntypedFormControl('');
        this.digitalPharmacyName = new UntypedFormControl('');
        this.hasMinCharError = false;
        this.pageIndex = 1;
        this.defaultStartItem = 1;
        this.checkFocus = false;
        this.isZipUpdated = false;
        this.previousZip = '';
        this.previousPharmacy = '';
        this.isPopOverOpen = false;
        this.pharmacyGroupFilters = [];
        this.isPharmacyFilterGroupSet = false;
        this.selectedFilters = [];
        this.isFocusEnabled = true;
    }
    updateActiveTab(activeTab) {
        if (this.activeTab?.title !== activeTab?.title) {
            this.activeTab = activeTab;
            this.pharmacyTabList.forEach(tab => (tab.isActive = tab.tabType === activeTab.tabType));
            this.configurableWidgetService.store.dispatch(new UpdateActivePharmacyTab(activeTab.tabType));
            this.setDefaultPagination();
            if (this.activeTab.tabType === PharmacyTabType.DIGITAL) {
                this.pharmacyFacade.fetchDigitalPharmacies();
            }
            this.isRetailTabActive = this.activeTab.tabType === PharmacyTabType.RETAIL && this.activeTab.isActive;
        }
    }
    ngOnChanges(changes) {
        const { retailTabText, digitalTabText } = changes;
        if ((retailTabText && !_isEqual(retailTabText.previousValue, retailTabText.currentValue)) ||
            (digitalTabText && !_isEqual(digitalTabText.previousValue, digitalTabText.currentValue))) {
            this.initializeTabs();
        }
    }
    ngOnInit() {
        this.isFilterEnabled = this.isPharmacyFiltersEnabled();
        this.pharmacyGroupFilters.push({
            key: 'hasProperties',
            values: ['properties'],
            comparator: ComparatorType.EQUAL
        });
        this.setPharmacyFilterGroup(this.selectedFilters);
        this.selectedFilterCount$ = this.filterService.getPharmacyFiltersByFilterGroup$(this.pharmacyGroupFilters).pipe(map(filters => {
            const filterLength = filters.filter(filter => {
                const filterKey = filter.key;
                return this.pharmacyFacade.isPharmacyFilterKey(filterKey);
            }).length;
            return filterLength;
        }));
        this.helpfulToolsContext.isHelpfulToolsView = this.isHelpfulToolsView;
        this.pageSize = this.pharmacyPaginationEnabled ? this.itemsPerPage : this.pharmacyLimit;
        this.searchPharmacyByNameEnabled = this.pharmacyFacade.searchPharmacyByNameEnabled;
        this.pharmacyErrorText = this.formValidationService.errorMessages.minCharacters2();
        this.filteredPharmacies$ = this.pharmacyFacade.filteredPharmacies$;
        if (this.isHelpfulToolsView) {
            this.zip = this.helpfulToolsService.getZipCodeSelected();
            this.previousZip = this.zip;
        }
        else {
            this.zip = this.configurableWidgetService.store.selectSnapshot(DemographicState.selectedZipCode);
            this.previousZip = this.zip;
        }
        if (this.zip) {
            this.spinnerService.show(SpinnerEvent.PHARMACIES_LOADING);
            this.mapFacade.toggleSpinner();
            this.fetchPharmacies(true);
        }
        this.subscriptions = [
            this.filteredPharmacies$.subscribe({
                next: pharmacies => {
                    this.pharmacies = pharmacies;
                    if (!this.isPharmacyFilterGroupSet && this.pharmacies.length) {
                        this.selectedFilters = this.availableNetworkFilters(this.pharmacies, this.isPharmacyInNetworkFilterEnabled, this.isHelpfulToolsView);
                        this.setPharmacyFilterGroup(this.selectedFilters);
                    }
                    this.markers = this.mapFacade.getMarkers(this.pharmacies);
                    this.mapContextService.setMarkers(this.markers);
                    this.mapFacade.toggleSpinner(false);
                    this.cdr.markForCheck();
                }
            }),
            this.selectedFilterCount$.subscribe({
                next: count => {
                    this.filterCount = count;
                    this.cdr.markForCheck();
                }
            }),
            this.pharmacyFacade.getSelectedPharmacies$().subscribe({
                next: selectedPharmacies => {
                    this.selectedPharmacies = selectedPharmacies;
                    this.cdr.markForCheck();
                }
            })
        ];
        this.subscriptions.push(this.localeService.getCurrentLocale$().subscribe({
            next: () => {
                this.initializeTabs();
                this.intializeFilters();
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.push(this.mapContextService.fetchDataFromAPI$.subscribe({
            next: value => {
                if (value) {
                    this.fetchPharmaciesFromAPI();
                }
            }
        }));
        this.subscriptions.push(this.mapContextService.location$.subscribe({
            next: value => {
                this.location = value;
            }
        }));
        this.subscriptions.push(this.mapContextService.bounds$.subscribe({
            next: value => {
                this.bounds = value;
            }
        }));
        this.subscriptions.push(this.mapContextService.loadData$.subscribe({
            next: mapData => {
                if (mapData?.location && mapData.bounds && mapData.distance) {
                    this.pharmacyFacade.fetchPharmaciesFromLocation(mapData.location.lat, mapData.location.lng, mapData.bounds, mapData.distance);
                }
            }
        }));
        this.subscriptions.push(this.pharmacyFacade.getDigitalPharmacies$().subscribe({
            next: digitalPharmacies => {
                this.digitalPharmacies = digitalPharmacies;
                this.filteredDigitalPharmacies = digitalPharmacies;
                this.mapFacade.hideSpinner(SpinnerEvent.PHARMACIES_LOADING);
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.push(this.pharmacyFacade.pharmacyCountWithinLimits$().subscribe({
            next: pharmacyCountWithinLimits => {
                this.pharmacyCountWithinLimits = pharmacyCountWithinLimits;
                this.cdr.markForCheck();
            }
        }));
    }
    initializeTabs() {
        this.pharmacyTabList = [
            {
                title: this.retailTabText,
                tabType: PharmacyTabType.RETAIL,
                isActive: true
            },
            {
                title: this.digitalTabText,
                tabType: PharmacyTabType.DIGITAL,
                isActive: false
            }
        ];
        const activeTabType = this.configurableWidgetService.store.selectSnapshot(PharmacyState.activePharmacyTab);
        const activeTab = activeTabType
            ? this.pharmacyTabList.find(tab => tab.tabType === activeTabType)
            : this.pharmacyTabList.find(tab => tab.isActive);
        this.updateActiveTab(activeTab);
    }
    setPharmacyFilterGroup(initialSelectedFilters) {
        this.pharmacyGroupFilters.forEach(groupFilter => {
            this.filterService.setPharmacyFilterGroup({
                groupKey: new Filter({ ...groupFilter }),
                filters: initialSelectedFilters
            });
        });
    }
    availableNetworkFilters(pharmacies, isPharmacyInNetworkFilterEnabled, isHelpfulToolsView) {
        const initialSelectedFilters = [];
        if (isPharmacyInNetworkFilterEnabled && isHelpfulToolsView) {
            if (pharmacies.some(pharmacy => pharmacy[PharmacyFilterKeyType.STANDARD])) {
                initialSelectedFilters.push({
                    key: PharmacyFilterKeyType.STANDARD,
                    values: [true, false],
                    comparator: ComparatorType.IN
                });
            }
            if (pharmacies.some(pharmacy => pharmacy[PharmacyFilterKeyType.PREFERRED])) {
                initialSelectedFilters.push({
                    key: PharmacyFilterKeyType.PREFERRED,
                    values: [true, false],
                    comparator: ComparatorType.IN
                });
            }
        }
        if (initialSelectedFilters.length || !isPharmacyInNetworkFilterEnabled || !isHelpfulToolsView) {
            this.isPharmacyFilterGroupSet = true;
        }
        return initialSelectedFilters;
    }
    intializeForm() {
        let initialSelectedFilters = null;
        if (this.isPharmacyInNetworkFilterEnabled && this.isHelpfulToolsView) {
            initialSelectedFilters = [PharmacyFilterKeyType.PREFERRED, PharmacyFilterKeyType.STANDARD];
        }
        this.filterForm = new UntypedFormGroup({
            [this.pharmacyFacade.pharmacyFilterControl]: new UntypedFormControl(initialSelectedFilters)
        });
    }
    intializeFilters() {
        this.intializeForm();
        this.pharmacyFacade.updatePharmacyType(this.isHelpfulToolsView, this.isPharmacyOtherFilterEnabled, this.isPharmacyInNetworkFilterEnabled, this.pharmacyInNetworkFilters);
        this.filterService.getPharmacyFiltersByFilterGroup$(this.pharmacyGroupFilters).subscribe({
            next: filters => {
                if (filters.length > 0) {
                    this.pharmacyFilter = filters.filter(filter => {
                        const filterKey = filter.key;
                        return this.pharmacyFacade.isPharmacyFilterKey(filterKey);
                    });
                }
                if (this.pharmacyFilter?.length) {
                    this.pharmacyFacade.updateFilterForm(this.pharmacyFacade.pharmacyFilterControl, this.pharmacyFilter, this.filterForm);
                }
            }
        });
    }
    isPharmacyFiltersEnabled() {
        let enabled = false;
        this.isHelpfulToolsView = this.navigationutilityService.pageTagURLMatch(PageTags.HELPFUL_TOOLS_PHARMACYSEARCH, this.navigationContext.getUrl());
        // standard/preferred pharmacy filter only in shown on helptool module
        if (this.isHelpfulToolsView &&
            this.isPharmacyFilterEnabled &&
            (this.isPharmacyInNetworkFilterEnabled || this.isPharmacyOtherFilterEnabled)) {
            enabled = true;
        }
        else if (!this.isHelpfulToolsView && this.isPharmacyFilterEnabled && this.isPharmacyOtherFilterEnabled) {
            enabled = true;
        }
        return enabled;
    }
    ngAfterViewChecked() {
        if (this.checkFocus) {
            const invalidZipFormInput = document.querySelector('input.has-error');
            const invalidZipFormInputFormElement = invalidZipFormInput;
            if (invalidZipFormInputFormElement) {
                invalidZipFormInputFormElement.focus();
            }
            this.checkFocus = false;
        }
    }
    setZipCode(zipCode) {
        if (zipCode !== this.previousZip || this.previousZip === '') {
            this.zip = zipCode;
            this.isZipUpdated = true;
            this.previousZip = this.zip;
            if (this.searchPharmacyByNameEnabled) {
                this.mapContextService.isCenterLocationSetByPharmacy = false;
                if (this.pharmacyName?.value && this.pharmacyName.value === this.previousPharmacy) {
                    this.configurableWidgetService.store.dispatch(new SetIsOptimalZoomEnabled(true));
                }
            }
        }
    }
    getPharmacyContainerClass() {
        if (this.isPopOverOpen && this.showHideFilter()) {
            if (!this.isHelpfulToolsView) {
                if (!this.isPPCSite) {
                    return 'pharmacy-popover';
                }
                return 'pharmacy-popover-broker';
            }
            return 'helpfultools-pharmacy-popover';
        }
        return '';
    }
    setZoom(zoom) {
        this.zoom = zoom;
    }
    validateZip() {
        const errors = this.widgetValidationService.validate();
        if (errors.length === 0) {
            this.fetchPharmacies();
        }
        else {
            this.checkFocus = true;
        }
    }
    filterDigitalPharmacies() {
        const digitalPharmacyNameSearchText = this.digitalPharmacyName?.value?.trim();
        if (digitalPharmacyNameSearchText) {
            const searchRegex = new RegExp(digitalPharmacyNameSearchText, 'i');
            this.filteredDigitalPharmacies = this.digitalPharmacies.filter(digitalPharmacy => searchRegex.test(digitalPharmacy.name));
        }
        else {
            this.filteredDigitalPharmacies = this.digitalPharmacies;
        }
        this.cdr.markForCheck();
    }
    fetchPharmacies(isInitialFetch) {
        if (!isInitialFetch) {
            this.pharmacyFacade.setAnalyticsForPharmacySearch(this.zip, this.pharmacyName.value);
        }
        if (isInitialFetch ||
            this.isZipUpdated ||
            (this.pharmacyName && this.pharmacyName.value !== this.previousPharmacy) ||
            this.mapContextService.isMapCenterChanged) {
            this.mapFacade.toggleSpinner(true);
            if (this.searchPharmacyByNameEnabled) {
                this.hasMinCharError = this.validatePharmacyError(this.pharmacyName.value);
                if (this.hasMinCharError ||
                    (this.pharmacyName && this.pharmacyName.value !== this.previousPharmacy && this.previousPharmacy !== '')) {
                    this.mapContextService.isCenterLocationSetByPharmacy = false;
                }
                if (!this.hasMinCharError && this.pharmacyName?.value && this.pharmacyName.value !== this.previousPharmacy) {
                    this.pharmacyFacade.pharmacyByName = this.pharmacyName.value;
                    this.previousPharmacy = this.pharmacyName.value;
                    this.configurableWidgetService.store.dispatch(new SetIsOptimalZoomEnabled(true));
                }
            }
            this.mapFacade.setGeocoder(this.zip, this.pharmacyMapDefaultZoom, this.minZoom, this.maxZoom, this.pharmacyFacade.searchPharmacyByNameEnabled);
            this.mapFacade.showMap = true;
            this.zoom = this.getDefaultZoom();
            this.isZipUpdated = false;
            this.previousPharmacy = this.pharmacyName.value;
        }
    }
    updatePharmacies(pagination) {
        this.defaultStartItem = pagination.defaultStartItem;
        this.pageSize = this.pharmacyPaginationEnabled ? pagination.pageSize : this.pharmacyLimit;
        this.pageIndex = pagination.defaultStartItem;
        if (this.pharmacyListContainer) {
            this.pharmacyListContainer.updateFocus(this.isFocusEnabled);
        }
        this.cdr.detectChanges();
    }
    setMapCenter(location) {
        this.mapFacade.setCenterPosition(location);
    }
    initializeMap(map) {
        this.mapFacade.initializeMap(map);
    }
    setMapDefaultBounds(bounds) {
        this.mapContextService.setDefaultBounds(bounds);
    }
    clearFormGroupValues() {
        this.pharmacyFacade.updatePharmacyType(this.isHelpfulToolsView, this.isPharmacyOtherFilterEnabled, this.isPharmacyInNetworkFilterEnabled, this.pharmacyInNetworkFilters);
        this.pharmacyFilter = [];
        this.pharmacyFacade.updateFilterForm(this.pharmacyFacade.pharmacyFilterControl, this.pharmacyFilter, this.filterForm);
        this.pharmacyFacade.clearPharmacyFilter();
    }
    addPharmacyFromMarker(selectedPharmacy) {
        const pharmacySelectedToAdd = this.pharmacies.find(pharmacy => selectedPharmacy && pharmacy.pharmacyId === selectedPharmacy.pharmacyId);
        this.pharmacyFacade.addPharmacy(pharmacySelectedToAdd);
    }
    ngOnDestroy() {
        this.subscriptions.forEach(sub => {
            sub.unsubscribe();
        });
    }
    pharmacyFilterModal() {
        const options = {
            scrollable: true,
            ariaLabelledBy: 'add some labelled by text',
            injector: this.injector
        };
        const pharmacyFilterModal = this.configurableWidgetService.modalService.open(PharmacyFilterModalComponent, options);
        pharmacyFilterModal.componentInstance.pharmacyFilterClearText = this.clearAllText;
        pharmacyFilterModal.componentInstance.filterHeaderText = this.filterHeaderText;
        pharmacyFilterModal.componentInstance.filterModalCancelButtonText = this.modalCancelButtonText;
        pharmacyFilterModal.componentInstance.filterModalApplyButtonText = this.modalApplyButtonText;
        pharmacyFilterModal.componentInstance.isHelpToolRoute = this.isHelpfulToolsView;
        pharmacyFilterModal.componentInstance.otherPharmacyFilterEnabled = this.isPharmacyOtherFilterEnabled;
        pharmacyFilterModal.componentInstance.inNetworkFilterEnabled = this.isPharmacyInNetworkFilterEnabled;
        pharmacyFilterModal.componentInstance.filterForm = this.filterForm;
        pharmacyFilterModal.componentInstance.inNetworkFilters = this.pharmacyInNetworkFilters;
        pharmacyFilterModal.result
            .then(() => { }, () => { } // could set focus here for when it's done
        )
            .catch(() => { }); // could set focus for when it's done here, too
    }
    pharmacyFilterPopover() {
        this.isPopOverOpen = true;
        if (this.popover && this.popover.isOpen()) {
            this.isPopOverOpen = false;
        }
    }
    onClosePharmacyFilterPopover() {
        this.isPopOverOpen = false;
    }
    showHideFilter() {
        const pharmacyFilter = this.pharmacyFacade.getFilterKeys(this.pharmacies);
        if (pharmacyFilter && pharmacyFilter.length === 0) {
            this.isPopOverOpen = false;
            return false;
        }
        return true;
    }
    fetchPharmaciesFromAPI() {
        if (this.location && this.bounds) {
            this.mapFacade.toggleSpinner(true);
            this.pharmacyFacade.fetchPharmaciesFromLocation(this.location.lat, this.location.lng, this.bounds);
        }
    }
    validatePharmacyError(pharmacy) {
        if (!pharmacy || pharmacy.length === 1) {
            this.pharmacyFacade.pharmacyByName = null;
        }
        if (pharmacy && pharmacy.length < 2) {
            return true;
        }
        return false;
    }
    getDefaultZoom() {
        if (this.searchPharmacyByNameEnabled) {
            const pharmacyValue = this.pharmacyName.value;
            const optimalZoom = this.configurableWidgetService.store.selectSnapshot(MapState.optimalZoom);
            if (pharmacyValue && pharmacyValue.length >= 2 && optimalZoom) {
                return (this.mapFacade.zoomLevel = optimalZoom);
            }
        }
        return +this.pharmacyMapDefaultZoom;
    }
    setDefaultPagination() {
        this.defaultStartItem = 1;
        this.pageIndex = 1;
        this.pageSize = this.pharmacyPaginationEnabled ? this.itemsPerPage : this.pharmacyLimit;
    }
}
PharmacySearchComponent.ɵfac = function PharmacySearchComponent_Factory(t) { return new (t || PharmacySearchComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(PharmacyFacade), i0.ɵɵdirectiveInject(MapFacade), i0.ɵɵdirectiveInject(HelpfulToolsContextService), i0.ɵɵdirectiveInject(HelpfulToolsService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(MapContextService), i0.ɵɵdirectiveInject(i1.FormValidationService), i0.ɵɵdirectiveInject(i1.FilterService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(i1.NavigationContext)); };
PharmacySearchComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PharmacySearchComponent, selectors: [["vnext-widget-pharmacy-search"]], viewQuery: function PharmacySearchComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(PharmacyListComponent, 5);
        i0.ɵɵviewQuery(_c0$1U, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pharmacyListContainer = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popover = _t.first);
    } }, inputs: { isHelpfulToolsView: "isHelpfulToolsView", retrieveZipCode: "retrieveZipCode", retrieveFipsCode: "retrieveFipsCode", addPharmacyButtonText: "addPharmacyButtonText", pharmacyLimit: "pharmacyLimit", pharmacyMapDefaultZoom: "pharmacyMapDefaultZoom", maxZoom: "maxZoom", minZoom: "minZoom", currentPharmacyText: "currentPharmacyText", pharmacyAddedLabel: "pharmacyAddedLabel", electronicPrescriptionTooltipHeader: "electronicPrescriptionTooltipHeader", electronicPrescriptionTooltipBody: "electronicPrescriptionTooltipBody", itemsPerPage: "itemsPerPage", pharmacyPaginationEnabled: "pharmacyPaginationEnabled", paginationText: "paginationText", viewNotFoundHeaderText: "viewNotFoundHeaderText", viewNotFoundBodyText: "viewNotFoundBodyText", preferredInNetworkText: "preferredInNetworkText", standardInNetworkText: "standardInNetworkText", preferredInNetworkTooltipContent: "preferredInNetworkTooltipContent", standardInNetworkTooltipContent: "standardInNetworkTooltipContent", pharmacySearchIntroText: "pharmacySearchIntroText", pharmacySearchHeaderText: "pharmacySearchHeaderText", errorKeywordText: "errorKeywordText", addedPharmacyText: "addedPharmacyText", addPharmacyText: "addPharmacyText", pharmacyText: "pharmacyText", ePrescribingAltText: "ePrescribingAltText", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text", zipLabel: "zipLabel", zipErrorText: "zipErrorText", pharmacySearchButtonText: "pharmacySearchButtonText", pharmacyNameText: "pharmacyNameText", multiPharmacyEnabled: "multiPharmacyEnabled", maxPharmacyCount: "maxPharmacyCount", setAsPrimaryLinkText: "setAsPrimaryLinkText", primaryPharmacyText: "primaryPharmacyText", pharmacyLimitErrorMessage: "pharmacyLimitErrorMessage", pharmacyNameHintText: "pharmacyNameHintText", pharmacyFilterText: "pharmacyFilterText", isPharmacyFilterEnabled: "isPharmacyFilterEnabled", isPharmacyOtherFilterEnabled: "isPharmacyOtherFilterEnabled", isPharmacyInNetworkFilterEnabled: "isPharmacyInNetworkFilterEnabled", pharmacyFilterClearText: "pharmacyFilterClearText", pharmacyFilterData: "pharmacyFilterData", defaultFilterText: "defaultFilterText", isPPCSite: "isPPCSite", clearAllText: "clearAllText", filterHeaderText: "filterHeaderText", modalCancelButtonText: "modalCancelButtonText", modalApplyButtonText: "modalApplyButtonText", countyLabel: "countyLabel", showCountyLabel: "showCountyLabel", pharmacyInNetworkFilters: "pharmacyInNetworkFilters", digitalPharmacyEnabled: "digitalPharmacyEnabled", retailTabText: "retailTabText", digitalTabText: "digitalTabText", digitalTabIntroText: "digitalTabIntroText" }, features: [i0.ɵɵProvidersFeature([MapFacade]), i0.ɵɵNgOnChangesFeature], decls: 32, vars: 30, consts: [[1, "row", "px-1"], ["aria-live", "polite", 1, "col-12"], [4, "ngIf"], [1, "padd-4"], [1, "container-row", "flex-row-nowrap"], [1, "zip-code-name", "flex-row-nowrap"], [1, "zip-code-input", "mr-4"], [1, "zipcode-width", 3, "customStyles", "showCounty", "retrieveZipCode", "retrieveFipsCode", "errorKeywordText", "zipCodeText", "zipCodeErrorText", "countyLabel", "showCountyLabel", "zip", "keyup.enter"], ["class", "pharmacy-name-field flex-1", 4, "ngIf"], ["aria-labelledby", "pharmacySearch", 1, "btn", "Spa_Style_SecondaryButton", "zipcode-search-button", "pharmacy-border-color", "pharmacy-search-button", "align-self-end", 3, "click"], ["id", "pharmacySearch", 1, "ml-1"], ["class", "ml-auto row mr-0 d-none d-md-block", 4, "ngIf"], [1, "ml-auto", "row", "mr-0", "col-12", "col-sm-6", "d-block", "d-md-none", "mobile-filter-button"], ["class", "flex-row-nowrap ml-4 mb-2 filter-pharmacy-popover can-click pharmacyFilter d-inline", 3, "click", 4, "ngIf", "ngIfElse"], ["class", "badge mb-1 text-center ml-2", 3, "ngStyle", 4, "ngIf"], [1, "col-12", "p-0", "pt-2"], ["filterTooltipContent", ""], ["showNoFilterMessage", ""], [4, "ngIf", "ngIfThen", "ngIfElse"], ["class", "row", 4, "ngIf"], ["retailPharmacy", ""], ["digitalPharmacy", ""], ["showPharmacyTabs", ""], [3, "pharmacySearchHeaderText", "pharmacySearchIntroText", "currentPharmacyText", "pharmacyText", "selectedPharmacy", "multiPharmacyEnabled"], [1, "pharmacy-name-field", "flex-1"], ["class", "error-display error-color text-nowrap", 4, "ngIf"], ["for", "pharmacy-name-text-input", "class", "Spa_Style_Label w-100", 4, "liveEditProp"], [4, "ngIf", "ngIfElse"], ["digitialTabSearchInput", ""], [1, "error-display", "error-color", "text-nowrap"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], ["for", "pharmacy-name-text-input", 1, "Spa_Style_Label", "w-100"], ["id", "pharmacy-name-text-input", "type", "text", "class", "Spa_Style_Paragraph pharmacy-name-input", 3, "placeholder", "formControl", "keyup.enter", 4, "liveEditProp"], ["id", "pharmacy-name-text-input", "type", "text", 1, "Spa_Style_Paragraph", "pharmacy-name-input", 3, "placeholder", "formControl", "keyup.enter"], [1, "ml-auto", "row", "mr-0", "d-none", "d-md-block"], ["class", "ml-2 mb-2 filter-pharmacy-popover can-click pharmacyFilter", "placement", "bottom-right", 3, "ngbPopover", "autoClose", "click", "hidden", 4, "ngIf", "ngIfElse"], ["class", "badge Spa_Style_PrimaryButton mb-2 ml-2", 3, "ngStyle", 4, "ngIf"], ["placement", "bottom-right", 1, "ml-2", "mb-2", "filter-pharmacy-popover", "can-click", "pharmacyFilter", 3, "ngbPopover", "autoClose", "click", "hidden"], ["pharmacyPopover", "ngbPopover"], [1, "fas", "fa-filter", "Spa_Style_Accent3_Color", "mb-1"], [1, "ml-1", "Spa_Style_Paragraph"], [1, "fas", "fa-chevron-down", "Spa_Style_Accent3_Color", "ml-2", "pb-1", "Spa_Style_Smaller_Font"], [1, "sr-only"], [1, "badge", "Spa_Style_PrimaryButton", "mb-2", "ml-2", 3, "ngStyle"], [1, "pb-2", "align-middle"], [1, "flex-row-nowrap", "ml-4", "mb-2", "filter-pharmacy-popover", "can-click", "pharmacyFilter", "d-inline", 3, "click"], [1, "badge", "mb-1", "text-center", "ml-2", 3, "ngStyle"], [1, "row"], [3, "pharmacyFilterClearText", "pharmacyFilters", "filterForm", "clearFormGroupValues"], [1, "my-2", "ml-2"], ["class", "col-12 px-0 mt-3 mt-md-5", 4, "ngIf"], [1, "col-12", "px-0", "mt-3", "mt-md-5"], [1, "Spa_Style_H2"], [4, "liveEditProp"], ["class", "selected-pharmacy mt-1", 4, "ngFor", "ngForOf"], [1, "selected-pharmacy", "mt-1"], [3, "selectedPharmacy", "setAsPrimaryLinkText", "primaryPharmacyText", "multiPharmacyEnabled", "isHelpfulToolsView", "digitalTabText"], ["class", "row pharmacy mb-3 mt-3 pharmacy-border-color", 4, "ngIf"], [1, "row", "pharmacy", "mb-3", "mt-3", "pharmacy-border-color"], [1, "col-12", "col-md-12", "col-lg-5", "order-last", "order-lg-first", "pharmacy-wrapper", "px-0", "px-md-2"], ["class", "col-12 col-md-12 col-lg-7 order-first order-lg-last p-0", 4, "ngIf"], [3, "pharmacies", "selectedPharmacies", "addPharmacyButtonText", "pharmacyAddedLabel", "pageSize", "pageIndex", "electronicPrescriptionTooltipHeader", "electronicPrescriptionTooltipBody", "standardInNetworkText", "standardInNetworkTooltipContent", "preferredInNetworkText", "preferredInNetworkTooltipContent", "addedPharmacyText", "addPharmacyText", "ePrescribingAltText", "Spa_Site_Tooltip_Text", "multiPharmacyEnabled", "maxPharmacyCount", "pharmacyLimitErrorMessage", "primaryPharmacyText"], [1, "Spa_Style_Large_Font", "font-weight-bold", "text-center", "mt-1"], [1, "Spa_Style_Paragraph", "pt-1", "no-pharmacies-body-text"], [1, "col-12", "col-md-12", "col-lg-7", "order-first", "order-lg-last", "p-0"], [3, "zip", "zoom", "minZoom", "maxZoom", "isHelpfulToolsView", "addButtonText", "addedLabel", "markers", "limitErrorMessage", "primaryIconAriaLabelText", "setZoom", "resetToDefaultPageIndex", "setMapCenter", "setMap", "setMapDefaultBounds", "addSelectedItem"], [1, "col-6", "text-center"], [3, "header", "body", "Spa_Site_Tooltip_Text"], ["aria-hidden", "true", 1, "fas", "fa-circle", "Spa_Style_Accent5_Color"], [1, "Spa_Style_Paragraph", "underline", "pl-1"], ["aria-hidden", "true", 1, "fas", "fa-circle", "Spa_Style_Accent3_Color"], ["class", "col-md-5 col-12 px-0 pr-md-3", 4, "ngIf"], [1, "col-md-5", "col-12", "px-0", "pr-md-3"], [3, "pagination", "defaultStartItem", "itemsPerPage", "paginationText", "updatePagination"], [3, "digitalTabIntroText", "digitalPharmacies", "pharmacyAddedLabel", "addPharmacyButtonText", "addPharmacyText", "pharmacyLimitErrorMessage", "pageSize", "pageIndex", "pharmacyCountWithinLimits", "itemsPerPage", "defaultStartItem", "paginationText", "pharmacyLimit", "selectedPharmacies", "pharmacyPaginationEnabled"], [1, "row", "d-block"], [3, "tabList", "activeTab", "updateActiveTab"]], template: function PharmacySearchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, PharmacySearchComponent_ng_container_2_Template, 2, 6, "ng-container", 2);
        i0.ɵɵelementStart(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "div", 6)(7, "vnext-zip-code-input", 7);
        i0.ɵɵlistener("zip", function PharmacySearchComponent_Template_vnext_zip_code_input_zip_7_listener($event) { return ctx.setZipCode($event); })("keyup.enter", function PharmacySearchComponent_Template_vnext_zip_code_input_keyup_enter_7_listener() { return ctx.validateZip(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(8, PharmacySearchComponent_div_8_Template, 6, 4, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "button", 9);
        i0.ɵɵlistener("click", function PharmacySearchComponent_Template_button_click_9_listener() { return ctx.isRetailTabActive ? ctx.validateZip() : ctx.filterDigitalPharmacies(); });
        i0.ɵɵelement(10, "i");
        i0.ɵɵelementStart(11, "span", 10);
        i0.ɵɵtext(12);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(13, PharmacySearchComponent_div_13_Template, 4, 5, "div", 11);
        i0.ɵɵelementStart(14, "div", 12);
        i0.ɵɵtemplate(15, PharmacySearchComponent_button_15_Template, 4, 1, "button", 13);
        i0.ɵɵtemplate(16, PharmacySearchComponent_span_16_Template, 2, 2, "span", 14);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(17, "div", 15);
        i0.ɵɵelement(18, "vnext-selectrx-section");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(19, PharmacySearchComponent_ng_template_19_Template, 3, 5, "ng-template", null, 16, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(21, PharmacySearchComponent_ng_template_21_Template, 2, 1, "ng-template", null, 17, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(23, "div");
        i0.ɵɵtemplate(24, PharmacySearchComponent_ng_container_24_Template, 1, 0, "ng-container", 18);
        i0.ɵɵtemplate(25, PharmacySearchComponent_div_25_Template, 2, 1, "div", 19);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(26, PharmacySearchComponent_ng_template_26_Template, 2, 2, "ng-template", null, 20, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(28, PharmacySearchComponent_ng_template_28_Template, 1, 15, "ng-template", null, 21, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(30, PharmacySearchComponent_ng_template_30_Template, 3, 5, "ng-template", null, 22, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r7 = i0.ɵɵreference(22);
        const _r11 = i0.ɵɵreference(27);
        const _r15 = i0.ɵɵreference(31);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isHelpfulToolsView);
        i0.ɵɵadvance(3);
        i0.ɵɵclassProp("flex-1", ctx.searchPharmacyByNameEnabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("customStyles", ctx.zipCodeStyles)("showCounty", false)("retrieveZipCode", ctx.retrieveZipCode)("retrieveFipsCode", ctx.retrieveFipsCode)("errorKeywordText", ctx.errorKeywordText)("zipCodeText", ctx.zipLabel)("zipCodeErrorText", ctx.zipErrorText)("countyLabel", ctx.countyLabel)("showCountyLabel", ctx.showCountyLabel);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.searchPharmacyByNameEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("ml-4", ctx.searchPharmacyByNameEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("fas ", ctx.mapFacade.showSpinner ? "fa-spinner fa-spin" : "fa-search", "");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.pharmacySearchButtonText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isFilterEnabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showHideFilter())("ngIfElse", _r7);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showHideFilter() && ctx.filterCount > 0);
        i0.ɵɵadvance(7);
        i0.ɵɵclassMapInterpolate1("p-3 ", ctx.getPharmacyContainerClass(), "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.digitalPharmacyEnabled)("ngIfThen", _r11)("ngIfElse", _r15);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isHelpfulToolsView);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, i1$2.NgStyle, i4.DefaultValueAccessor, i4.NgControlStatus, i4.FormControlDirective, ZipCodeInputComponent, TabListComponent, PaginationComponent, TooltipComponent, LiveEditPropDirective, IconAriaAttributesDirective, i1$1.NgbPopover, PharmacyFilterItemsComponent, PharmacyListComponent, DigitalPharmacyComponent, PharmacySearchHeaderComponent, MapComponent, SelectedPharmacyComponent, SelectRXSectionComponent, i1$2.AsyncPipe], styles: [".pharmacy-icon[_ngcontent-%COMP%]{font-size:46px}.zipcode-width[_ngcontent-%COMP%]{width:auto}.error-display[_ngcontent-%COMP%]{height:24px}.pharmacy-name-input[_ngcontent-%COMP%]{height:38px;width:100%}.zipcode-search-button[_ngcontent-%COMP%]{line-height:1.4}.mobile-filter-button[_ngcontent-%COMP%]{margin-top:.5rem;text-align:right}.pharmacy[_ngcontent-%COMP%]{border-radius:5px;border-width:1px;border-style:solid}.pharmacy-wrapper[_ngcontent-%COMP%]{max-height:455px;overflow-y:auto}.pharmacy-border-color[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent1)}.underline[_ngcontent-%COMP%]{text-decoration:underline}.pharmacy-search-button[_ngcontent-%COMP%]{height:38px;min-width:105px}.no-pharmacies-body-text[_ngcontent-%COMP%]{line-height:24px}.selected-pharmacy[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);padding:12px 18px;border-radius:5px}.flex-row-nowrap[_ngcontent-%COMP%]{display:flex;flex-wrap:nowrap;align-items:flex-end}.flex-1[_ngcontent-%COMP%]{flex:1}.padd-4[_ngcontent-%COMP%]{padding:0 4px}.pharmacy-popover[_ngcontent-%COMP%]{margin-top:26%}.pharmacy-popover-broker[_ngcontent-%COMP%]{margin-top:29%}.helpfultools-pharmacy-popover[_ngcontent-%COMP%]{margin-top:17%}.badge[_ngcontent-%COMP%]{font-size:16px;color:var(--static-Spa_Style_Primary);border-radius:44%;width:24px}[_nghost-%COMP%]     .popover{max-width:95%;margin-top:24px;max-height:100%;box-shadow:2px 4px 12px 2px;color:var(--static-Spa_Style-Gray2)!important;z-index:1}.pharmacyFilter[_ngcontent-%COMP%]{background:none!important;border:none;padding:0!important;cursor:pointer}@media print{.col-md-12.col-lg-5[_ngcontent-%COMP%]{flex:0 0 41.6667%;max-width:41.6667%}.col-md-12.col-lg-7[_ngcontent-%COMP%]{flex:0 0 58.3333%;max-width:58.3333%}.order-lg-first[_ngcontent-%COMP%]{order:-1}.order-lg-last[_ngcontent-%COMP%]{order:13}}@media (max-width: 680px){.zip-code-name[_ngcontent-%COMP%]{flex-direction:column;align-items:flex-start;justify-content:flex-start;align-self:stretch}.container-row[_ngcontent-%COMP%]{flex-direction:column;align-items:flex-start;justify-content:flex-start}.pharmacy-search-button[_ngcontent-%COMP%]{margin-top:1rem;align-self:stretch!important;margin-left:0!important}.pharmacy-name-field[_ngcontent-%COMP%]{align-self:stretch;margin:1rem 0 1.5rem}}@media (min-width: 767px) and (max-width: 769px){.zip-code-name[_ngcontent-%COMP%]{margin-bottom:1rem;align-self:stretch}.container-row[_ngcontent-%COMP%]{flex-direction:column;align-items:flex-start;justify-content:flex-start}.pharmacy-search-button[_ngcontent-%COMP%]{align-self:stretch!important;margin-left:0!important}}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], PharmacySearchComponent.prototype, "Spa_Site_Preferred_In_Network_Text", void 0);
__decorate([
    GlobalResource()
], PharmacySearchComponent.prototype, "Spa_Site_Standard_In_Network_Text", void 0);
__decorate([
    GlobalResource()
], PharmacySearchComponent.prototype, "Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PharmacySearchComponent.prototype, "Spa_PharmacySearch_Standard_In_Network_Tooltip_Text", void 0);
__decorate([
    LiveEditInactive()
], PharmacySearchComponent.prototype, "addPharmacyFromMarker", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PharmacySearchComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-pharmacy-search', changeDetection: ChangeDetectionStrategy.OnPush, providers: [MapFacade], template: "<div class=\"row px-1\">\r\n  <div class=\"col-12\" aria-live=\"polite\">\r\n    <ng-container *ngIf=\"!isHelpfulToolsView\">\r\n      <vnext-pharmacy-search-header\r\n        [pharmacySearchHeaderText]=\"pharmacySearchHeaderText\"\r\n        [pharmacySearchIntroText]=\"pharmacySearchIntroText\"\r\n        [currentPharmacyText]=\"currentPharmacyText\"\r\n        [pharmacyText]=\"pharmacyText\"\r\n        [selectedPharmacy]=\"selectedPharmacies\"\r\n        [multiPharmacyEnabled]=\"multiPharmacyEnabled\"\r\n      ></vnext-pharmacy-search-header>\r\n    </ng-container>\r\n    <div class=\"padd-4\">\r\n      <div class=\"container-row flex-row-nowrap\">\r\n        <div class=\"zip-code-name flex-row-nowrap\" [class.flex-1]=\"searchPharmacyByNameEnabled\">\r\n          <div class=\"zip-code-input mr-4\">\r\n            <vnext-zip-code-input\r\n              class=\"zipcode-width\"\r\n              [customStyles]=\"zipCodeStyles\"\r\n              [showCounty]=\"false\"\r\n              (zip)=\"setZipCode($event)\"\r\n              [retrieveZipCode]=\"retrieveZipCode\"\r\n              [retrieveFipsCode]=\"retrieveFipsCode\"\r\n              [errorKeywordText]=\"errorKeywordText\"\r\n              [zipCodeText]=\"zipLabel\"\r\n              [zipCodeErrorText]=\"zipErrorText\"\r\n              [countyLabel]=\"countyLabel\"\r\n              [showCountyLabel]=\"showCountyLabel\"\r\n              (keyup.enter)=\"validateZip()\"\r\n            >\r\n            </vnext-zip-code-input>\r\n          </div>\r\n          <div class=\"pharmacy-name-field flex-1\" *ngIf=\"searchPharmacyByNameEnabled\">\r\n            <span *ngIf=\"hasMinCharError\" class=\"error-display error-color text-nowrap\"\r\n              ><i aria-hidden=\"true\" class=\"fas fa-exclamation-circle\"></i> {{ pharmacyErrorText }}</span\r\n            >\r\n            <label for=\"pharmacy-name-text-input\" class=\"Spa_Style_Label w-100\" *liveEditProp=\"'Spa_PharmacyName_Text'\">\r\n              {{ pharmacyNameText }}\r\n            </label>\r\n            <ng-container *ngIf=\"isRetailTabActive; else digitialTabSearchInput\">\r\n              <input\r\n                *liveEditProp=\"'Spa_PharmacyName_HintText'\"\r\n                id=\"pharmacy-name-text-input\"\r\n                type=\"text\"\r\n                class=\"Spa_Style_Paragraph pharmacy-name-input\"\r\n                [placeholder]=\"pharmacyNameHintText\"\r\n                [formControl]=\"pharmacyName\"\r\n                (keyup.enter)=\"validateZip()\"\r\n              />\r\n            </ng-container>\r\n            <ng-template #digitialTabSearchInput>\r\n              <input\r\n                id=\"pharmacy-name-text-input\"\r\n                type=\"text\"\r\n                class=\"Spa_Style_Paragraph pharmacy-name-input\"\r\n                [placeholder]=\"pharmacyNameHintText\"\r\n                [formControl]=\"digitalPharmacyName\"\r\n                (keyup.enter)=\"filterDigitalPharmacies()\"\r\n              />\r\n            </ng-template>\r\n          </div>\r\n        </div>\r\n        <button\r\n          [class.ml-4]=\"searchPharmacyByNameEnabled\"\r\n          class=\"btn Spa_Style_SecondaryButton zipcode-search-button pharmacy-border-color pharmacy-search-button align-self-end\"\r\n          (click)=\"isRetailTabActive ? validateZip() : filterDigitalPharmacies()\"\r\n          aria-labelledby=\"pharmacySearch\"\r\n        >\r\n          <i class=\"fas {{ mapFacade.showSpinner ? 'fa-spinner fa-spin' : 'fa-search' }}\"></i\r\n          ><span class=\"ml-1\" id=\"pharmacySearch\">{{ pharmacySearchButtonText }}</span>\r\n        </button>\r\n        <div *ngIf=\"isFilterEnabled\" class=\"ml-auto row mr-0 d-none d-md-block\">\r\n          <button\r\n            *ngIf=\"(pharmacyFacade.pharmacyTypes$ | async)?.length; else showNoFilterMessage\"\r\n            class=\"ml-2 mb-2 filter-pharmacy-popover can-click pharmacyFilter\"\r\n            #pharmacyPopover=\"ngbPopover\"\r\n            [ngbPopover]=\"filterTooltipContent\"\r\n            placement=\"bottom-right\"\r\n            (click)=\"pharmacyFilterPopover()\"\r\n            [autoClose]=\"'outside'\"\r\n            (hidden)=\"onClosePharmacyFilterPopover()\"\r\n          >\r\n            <i class=\"fas fa-filter Spa_Style_Accent3_Color mb-1\"></i><span class=\"ml-1 Spa_Style_Paragraph\">{{ pharmacyFilterText }}</span\r\n            ><i class=\"fas fa-chevron-down Spa_Style_Accent3_Color ml-2 pb-1 Spa_Style_Smaller_Font\"></i>\r\n            <span class=\"sr-only\">Expand</span>\r\n          </button>\r\n          <label\r\n            *ngIf=\"showHideFilter() && filterCount > 0\"\r\n            [ngStyle]=\"this.pharmacyFacade.getBadgeColor()\"\r\n            class=\"badge Spa_Style_PrimaryButton mb-2 ml-2\"\r\n            ><span class=\"pb-2 align-middle\">{{ filterCount }}</span></label\r\n          >\r\n        </div>\r\n        <div class=\"ml-auto row mr-0 col-12 col-sm-6 d-block d-md-none mobile-filter-button\">\r\n          <button\r\n            *ngIf=\"showHideFilter(); else showNoFilterMessage\"\r\n            class=\"flex-row-nowrap ml-4 mb-2 filter-pharmacy-popover can-click pharmacyFilter d-inline\"\r\n            (click)=\"pharmacyFilterModal()\"\r\n          >\r\n            <i class=\"fas fa-filter Spa_Style_Accent3_Color mb-1\"></i><span class=\"ml-1 Spa_Style_Paragraph\">{{ pharmacyFilterText }}</span>\r\n          </button>\r\n          <span\r\n            *ngIf=\"showHideFilter() && filterCount > 0\"\r\n            [ngStyle]=\"this.pharmacyFacade.getBadgeColor()\"\r\n            class=\"badge mb-1 text-center ml-2\"\r\n            >{{ filterCount }}</span\r\n          >\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"col-12 p-0 pt-2\">\r\n      <vnext-selectrx-section></vnext-selectrx-section>\r\n    </div>\r\n\r\n    <ng-template #filterTooltipContent>\r\n      <div class=\"row\">\r\n        <vnext-pharmacy-filter-items\r\n          [pharmacyFilterClearText]=\"pharmacyFilterClearText\"\r\n          [pharmacyFilters]=\"pharmacyFacade.sortFilterControls(pharmacyFacade.pharmacyTypes$ | async, true)\"\r\n          (clearFormGroupValues)=\"clearFormGroupValues()\"\r\n          [filterForm]=\"filterForm\"\r\n        >\r\n        </vnext-pharmacy-filter-items>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template #showNoFilterMessage>\r\n      <div class=\"my-2 ml-2\">{{ defaultFilterText }}</div>\r\n    </ng-template>\r\n    <div class=\"p-3 {{ getPharmacyContainerClass() }}\">\r\n      <ng-container *ngIf=\"!digitalPharmacyEnabled; then retailPharmacy; else showPharmacyTabs\"> </ng-container>\r\n      <div class=\"row\" *ngIf=\"!isHelpfulToolsView\">\r\n        <div class=\"col-12 px-0 mt-3 mt-md-5\" *ngIf=\"selectedPharmacies.length > 0 && selectedPharmacies\">\r\n          <h2 class=\"Spa_Style_H2\">\r\n            <span\r\n              *liveEditProp=\"multiPharmacyEnabled ? 'Spa_Site_AddPharmacy_YourMultiPharmacyText' : 'Spa_AddPharmacy_YourPharmacyText'\"\r\n              >{{ currentPharmacyText }}</span\r\n            >\r\n          </h2>\r\n          <div class=\"selected-pharmacy mt-1\" *ngFor=\"let pharmacy of selectedPharmacies\">\r\n            <vnext-widget-selected-pharmacy\r\n              [selectedPharmacy]=\"pharmacy\"\r\n              [setAsPrimaryLinkText]=\"setAsPrimaryLinkText\"\r\n              [primaryPharmacyText]=\"primaryPharmacyText\"\r\n              [multiPharmacyEnabled]=\"multiPharmacyEnabled\"\r\n              [isHelpfulToolsView]=\"isHelpfulToolsView\"\r\n              [digitalTabText]=\"digitalTabText\"\r\n            >\r\n            </vnext-widget-selected-pharmacy>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <ng-template #retailPharmacy>\r\n      <div class=\"row pharmacy mb-3 mt-3 pharmacy-border-color\" *ngIf=\"mapFacade.showMap\">\r\n        <div class=\"col-12 col-md-12 col-lg-5 order-last order-lg-first pharmacy-wrapper px-0 px-md-2\">\r\n          <ng-container *ngIf=\"pharmacies?.length > 0\">\r\n            <vnext-widget-pharmacy-list\r\n              [pharmacies]=\"filteredPharmacies$ | async\"\r\n              [selectedPharmacies]=\"selectedPharmacies\"\r\n              [addPharmacyButtonText]=\"addPharmacyButtonText\"\r\n              [pharmacyAddedLabel]=\"pharmacyAddedLabel\"\r\n              [pageSize]=\"pageSize\"\r\n              [pageIndex]=\"pageIndex\"\r\n              [electronicPrescriptionTooltipHeader]=\"electronicPrescriptionTooltipHeader\"\r\n              [electronicPrescriptionTooltipBody]=\"electronicPrescriptionTooltipBody\"\r\n              [standardInNetworkText]=\"standardInNetworkText\"\r\n              [standardInNetworkTooltipContent]=\"standardInNetworkTooltipContent\"\r\n              [preferredInNetworkText]=\"preferredInNetworkText\"\r\n              [preferredInNetworkTooltipContent]=\"preferredInNetworkTooltipContent\"\r\n              [addedPharmacyText]=\"addedPharmacyText\"\r\n              [addPharmacyText]=\"addPharmacyText\"\r\n              [ePrescribingAltText]=\"ePrescribingAltText\"\r\n              [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n              [multiPharmacyEnabled]=\"multiPharmacyEnabled\"\r\n              [maxPharmacyCount]=\"maxPharmacyCount\"\r\n              [pharmacyLimitErrorMessage]=\"pharmacyLimitErrorMessage\"\r\n              [primaryPharmacyText]=\"primaryPharmacyText\"\r\n            ></vnext-widget-pharmacy-list>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"!(pharmacies?.length > 0) && !mapFacade.showSpinner\">\r\n            <div class=\"Spa_Style_Large_Font font-weight-bold text-center mt-1\">{{ viewNotFoundHeaderText }}</div>\r\n            <div class=\"Spa_Style_Paragraph pt-1 no-pharmacies-body-text\">\r\n              {{ viewNotFoundBodyText }}\r\n            </div>\r\n          </ng-container>\r\n        </div>\r\n        <div class=\"col-12 col-md-12 col-lg-7 order-first order-lg-last p-0\" *ngIf=\"zip\">\r\n          <div class=\"row\" *ngIf=\"isHelpfulToolsView\">\r\n            <div class=\"col-6 text-center\">\r\n              <vnext-tooltip\r\n                [header]=\"preferredInNetworkText\"\r\n                [body]=\"preferredInNetworkTooltipContent\"\r\n                [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n              >\r\n                <i aria-hidden=\"true\" class=\"fas fa-circle Spa_Style_Accent5_Color\"></i>\r\n                <span class=\"Spa_Style_Paragraph underline pl-1\">{{ preferredInNetworkText }}</span>\r\n              </vnext-tooltip>\r\n            </div>\r\n            <div class=\"col-6 text-center\">\r\n              <vnext-tooltip\r\n                [header]=\"standardInNetworkText\"\r\n                [body]=\"standardInNetworkTooltipContent\"\r\n                [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n              >\r\n                <i aria-hidden=\"true\" class=\"fas fa-circle Spa_Style_Accent3_Color\"></i>\r\n                <span class=\"Spa_Style_Paragraph underline pl-1\">{{ standardInNetworkText }}</span>\r\n              </vnext-tooltip>\r\n            </div>\r\n          </div>\r\n          <vnext-widget-map\r\n            [zip]=\"zip\"\r\n            [zoom]=\"zoom\"\r\n            [minZoom]=\"minZoom\"\r\n            [maxZoom]=\"maxZoom\"\r\n            [isHelpfulToolsView]=\"isHelpfulToolsView\"\r\n            [addButtonText]=\"addPharmacyButtonText\"\r\n            [addedLabel]=\"pharmacyAddedLabel\"\r\n            [markers]=\"markers\"\r\n            [limitErrorMessage]=\"pharmacyLimitErrorMessage\"\r\n            [primaryIconAriaLabelText]=\"primaryPharmacyText\"\r\n            (setZoom)=\"setZoom($event)\"\r\n            (resetToDefaultPageIndex)=\"updatePharmacies({ pageSize: itemsPerPage, defaultStartItem: 1 })\"\r\n            (setMapCenter)=\"setMapCenter($event)\"\r\n            (setMap)=\"initializeMap($event)\"\r\n            (setMapDefaultBounds)=\"setMapDefaultBounds($event)\"\r\n            (addSelectedItem)=\"addPharmacyFromMarker($event)\"\r\n          >\r\n          </vnext-widget-map>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\" *ngIf=\"this.mapFacade.showMap\">\r\n        <div class=\"col-md-5 col-12 px-0 pr-md-3\" *ngIf=\"pharmacyPaginationEnabled && itemsPerPage < pharmacies?.length\">\r\n          <vnext-pagination\r\n            [pagination]=\"filteredPharmacies$ | async\"\r\n            [defaultStartItem]=\"defaultStartItem\"\r\n            [itemsPerPage]=\"itemsPerPage\"\r\n            (updatePagination)=\"updatePharmacies($event)\"\r\n            [paginationText]=\"paginationText\"\r\n          ></vnext-pagination>\r\n        </div>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template #digitalPharmacy>\r\n      <vnext-widget-digital-pharmacy\r\n        [digitalTabIntroText]=\"digitalTabIntroText\"\r\n        [digitalPharmacies]=\"filteredDigitalPharmacies\"\r\n        [pharmacyAddedLabel]=\"pharmacyAddedLabel\"\r\n        [addPharmacyButtonText]=\"addPharmacyButtonText\"\r\n        [addPharmacyText]=\"addPharmacyText\"\r\n        [pharmacyLimitErrorMessage]=\"pharmacyLimitErrorMessage\"\r\n        [pageSize]=\"pageSize\"\r\n        [pageIndex]=\"pageIndex\"\r\n        [pharmacyCountWithinLimits]=\"pharmacyCountWithinLimits\"\r\n        [itemsPerPage]=\"itemsPerPage\"\r\n        [defaultStartItem]=\"defaultStartItem\"\r\n        [paginationText]=\"paginationText\"\r\n        [pharmacyLimit]=\"digitalPharmacies?.length ?? pharmacyLimit\"\r\n        [selectedPharmacies]=\"selectedPharmacies\"\r\n        [pharmacyPaginationEnabled]=\"false\"\r\n      ></vnext-widget-digital-pharmacy>\r\n    </ng-template>\r\n    <ng-template #showPharmacyTabs>\r\n      <div class=\"row d-block\">\r\n        <vnext-tab-list [tabList]=\"pharmacyTabList\" [activeTab]=\"activeTab\" (updateActiveTab)=\"updateActiveTab($event)\"></vnext-tab-list>\r\n      </div>\r\n      <!-- show tabs here -->\r\n      <ng-container *ngIf=\"isRetailTabActive; then retailPharmacy; else digitalPharmacy\"></ng-container>\r\n    </ng-template>\r\n  </div>\r\n</div>\r\n", styles: [".pharmacy-icon{font-size:46px}.zipcode-width{width:auto}.error-display{height:24px}.pharmacy-name-input{height:38px;width:100%}.zipcode-search-button{line-height:1.4}.mobile-filter-button{margin-top:.5rem;text-align:right}.pharmacy{border-radius:5px;border-width:1px;border-style:solid}.pharmacy-wrapper{max-height:455px;overflow-y:auto}.pharmacy-border-color{border-color:var(--static-Spa_Style_Accent1)}.underline{text-decoration:underline}.pharmacy-search-button{height:38px;min-width:105px}.no-pharmacies-body-text{line-height:24px}.selected-pharmacy{border:1px solid var(--static-Spa_Style_Accent1);padding:12px 18px;border-radius:5px}.flex-row-nowrap{display:flex;flex-wrap:nowrap;align-items:flex-end}.flex-1{flex:1}.padd-4{padding:0 4px}.pharmacy-popover{margin-top:26%}.pharmacy-popover-broker{margin-top:29%}.helpfultools-pharmacy-popover{margin-top:17%}.badge{font-size:16px;color:var(--static-Spa_Style_Primary);border-radius:44%;width:24px}:host >>> .popover{max-width:95%;margin-top:24px;max-height:100%;box-shadow:2px 4px 12px 2px;color:var(--static-Spa_Style-Gray2)!important;z-index:1}.pharmacyFilter{background:none!important;border:none;padding:0!important;cursor:pointer}@media print{.col-md-12.col-lg-5{flex:0 0 41.6667%;max-width:41.6667%}.col-md-12.col-lg-7{flex:0 0 58.3333%;max-width:58.3333%}.order-lg-first{order:-1}.order-lg-last{order:13}}@media (max-width: 680px){.zip-code-name{flex-direction:column;align-items:flex-start;justify-content:flex-start;align-self:stretch}.container-row{flex-direction:column;align-items:flex-start;justify-content:flex-start}.pharmacy-search-button{margin-top:1rem;align-self:stretch!important;margin-left:0!important}.pharmacy-name-field{align-self:stretch;margin:1rem 0 1.5rem}}@media (min-width: 767px) and (max-width: 769px){.zip-code-name{margin-bottom:1rem;align-self:stretch}.container-row{flex-direction:column;align-items:flex-start;justify-content:flex-start}.pharmacy-search-button{align-self:stretch!important;margin-left:0!important}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: PharmacyFacade }, { type: MapFacade }, { type: HelpfulToolsContextService }, { type: HelpfulToolsService }, { type: i1.SpinnerService }, { type: MapContextService }, { type: i1.FormValidationService }, { type: i1.FilterService }, { type: i1.LocaleService }, { type: i0.Injector }, { type: i1.NavigationUtilityService }, { type: i1.NavigationContext }]; }, { pharmacyListContainer: [{
            type: ViewChild,
            args: [PharmacyListComponent]
        }], popover: [{
            type: ViewChild,
            args: ['pharmacyPopover']
        }], isHelpfulToolsView: [{
            type: Input
        }], retrieveZipCode: [{
            type: Input
        }], retrieveFipsCode: [{
            type: Input
        }], addPharmacyButtonText: [{
            type: Input
        }], pharmacyLimit: [{
            type: Input
        }], pharmacyMapDefaultZoom: [{
            type: Input
        }], maxZoom: [{
            type: Input
        }], minZoom: [{
            type: Input
        }], currentPharmacyText: [{
            type: Input
        }], pharmacyAddedLabel: [{
            type: Input
        }], electronicPrescriptionTooltipHeader: [{
            type: Input
        }], electronicPrescriptionTooltipBody: [{
            type: Input
        }], itemsPerPage: [{
            type: Input
        }], pharmacyPaginationEnabled: [{
            type: Input
        }], paginationText: [{
            type: Input
        }], viewNotFoundHeaderText: [{
            type: Input
        }], viewNotFoundBodyText: [{
            type: Input
        }], preferredInNetworkText: [{
            type: Input
        }], standardInNetworkText: [{
            type: Input
        }], preferredInNetworkTooltipContent: [{
            type: Input
        }], standardInNetworkTooltipContent: [{
            type: Input
        }], pharmacySearchIntroText: [{
            type: Input
        }], pharmacySearchHeaderText: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], addedPharmacyText: [{
            type: Input
        }], addPharmacyText: [{
            type: Input
        }], pharmacyText: [{
            type: Input
        }], ePrescribingAltText: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }], zipLabel: [{
            type: Input
        }], zipErrorText: [{
            type: Input
        }], pharmacySearchButtonText: [{
            type: Input
        }], pharmacyNameText: [{
            type: Input
        }], multiPharmacyEnabled: [{
            type: Input
        }], maxPharmacyCount: [{
            type: Input
        }], setAsPrimaryLinkText: [{
            type: Input
        }], primaryPharmacyText: [{
            type: Input
        }], pharmacyLimitErrorMessage: [{
            type: Input
        }], pharmacyNameHintText: [{
            type: Input
        }], pharmacyFilterText: [{
            type: Input
        }], isPharmacyFilterEnabled: [{
            type: Input
        }], isPharmacyOtherFilterEnabled: [{
            type: Input
        }], isPharmacyInNetworkFilterEnabled: [{
            type: Input
        }], pharmacyFilterClearText: [{
            type: Input
        }], pharmacyFilterData: [{
            type: Input
        }], defaultFilterText: [{
            type: Input
        }], isPPCSite: [{
            type: Input
        }], clearAllText: [{
            type: Input
        }], filterHeaderText: [{
            type: Input
        }], modalCancelButtonText: [{
            type: Input
        }], modalApplyButtonText: [{
            type: Input
        }], countyLabel: [{
            type: Input
        }], showCountyLabel: [{
            type: Input
        }], pharmacyInNetworkFilters: [{
            type: Input
        }], digitalPharmacyEnabled: [{
            type: Input
        }], retailTabText: [{
            type: Input
        }], digitalTabText: [{
            type: Input
        }], digitalTabIntroText: [{
            type: Input
        }], Spa_Site_Preferred_In_Network_Text: [], Spa_Site_Standard_In_Network_Text: [], Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text: [], Spa_PharmacySearch_Standard_In_Network_Tooltip_Text: [], addPharmacyFromMarker: [] }); })();

class GuidedHelpAgeSelectFacade {
    constructor(guidedHelpService, demographicService, store) {
        this.guidedHelpService = guidedHelpService;
        this.demographicService = demographicService;
        this.store = store;
    }
    get isMobile$() {
        return this.guidedHelpService.isMobile$;
    }
    get isMedium$() {
        return this.guidedHelpService.isMedium$;
    }
    getAgeRange$() {
        return combineLatest(this.store.select(DemographicState.ageRange), this.store.select(DemographicState.birthdate), this.store.select(MedSupState.formField('DateOfBirth'))).pipe(map(([demographicAgeRange, demographicBirthdate, medsupDateOfBirth]) => {
            if (demographicAgeRange) {
                return demographicAgeRange;
            }
            if (demographicBirthdate) {
                return this.guidedHelpService.getAgeRangeByDateOfBirth(demographicBirthdate);
            }
            if (medsupDateOfBirth) {
                return this.guidedHelpService.getAgeRangeByDateOfBirth(medsupDateOfBirth);
            }
            return this.guidedHelpService.getAgeRangeDefault();
        }));
    }
    selectOption(ageRange) {
        this.guidedHelpService.setAgeRange(ageRange);
        this.demographicService.updateDemographicSession();
    }
    getAgeGroups(ageRange) {
        return this.guidedHelpService.ageGroups.map(group => {
            group.display = `<div class="d-flex justify-content-center"><span class="text-center ${this.getButtonStyle(group.value === ageRange)}">${group.label}</span></div>`;
            return group;
        });
    }
    getButtonStyle(selected = false) {
        return selected ? 'Spa_Style_Weight_Semi_Bold Spa_Style_Primary_Link_Color Spa_Style_Small_Font' : 'Spa_Style_Paragraph';
    }
}
GuidedHelpAgeSelectFacade.ɵfac = function GuidedHelpAgeSelectFacade_Factory(t) { return new (t || GuidedHelpAgeSelectFacade)(i0.ɵɵinject(i1.GuidedHelpService), i0.ɵɵinject(i1.DemographicService), i0.ɵɵinject(i2.Store)); };
GuidedHelpAgeSelectFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GuidedHelpAgeSelectFacade, factory: GuidedHelpAgeSelectFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuidedHelpAgeSelectFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.GuidedHelpService }, { type: i1.DemographicService }, { type: i2.Store }]; }, null); })();

function GuidedHelpAgeSelectComponent_h2_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 4)(1, "span", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.healthAgeQuestionText, " ");
} }
class GuidedHelpAgeSelectComponent {
    constructor(ageSelectFacade, cdr, localeService) {
        this.ageSelectFacade = ageSelectFacade;
        this.cdr = cdr;
        this.localeService = localeService;
        this.ageRangeToggles = [];
    }
    ngOnInit() {
        this.ageSubscription = combineLatest(this.ageSelectFacade.getAgeRange$(), this.localeService.getCurrentLocale$()).subscribe(([ageRange, locale]) => {
            this.ageRangeToggles = this.ageSelectFacade.getAgeGroups(ageRange);
            this.selectedAge = ageRange;
            this.cdr.markForCheck();
        });
    }
    ngOnDestroy() {
        this.ageSubscription.unsubscribe();
    }
    get isMobile$() {
        return this.ageSelectFacade.isMobile$;
    }
    get isMedium$() {
        return this.ageSelectFacade.isMedium$;
    }
    onOptionSelect(event) {
        this.ageSelectFacade.selectOption(event.data.value);
    }
}
GuidedHelpAgeSelectComponent.ɵfac = function GuidedHelpAgeSelectComponent_Factory(t) { return new (t || GuidedHelpAgeSelectComponent)(i0.ɵɵdirectiveInject(GuidedHelpAgeSelectFacade), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.LocaleService)); };
GuidedHelpAgeSelectComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GuidedHelpAgeSelectComponent, selectors: [["vnext-guided-help-age-select"]], inputs: { healthAgeQuestionText: "healthAgeQuestionText" }, features: [i0.ɵɵProvidersFeature([InputResetContextService])], decls: 5, vars: 9, consts: [[1, "container", "pl-md-0", "mt-5"], ["class", "Spa_Style_Bold_Weight Spa_Style_Small_Font col px-0 text-md-left text-center", 4, "liveEditProp"], [1, "col-12", "col-md-11", "mx-auto", "mx-md-0", "px-0"], [3, "items", "selectedValue", "buttonHeight", "verticalGrow", "ariaLabelledById", "toggleControlId", "optionSelected"], [1, "Spa_Style_Bold_Weight", "Spa_Style_Small_Font", "col", "px-0", "text-md-left", "text-center"], ["id", "health-age-question"]], template: function GuidedHelpAgeSelectComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, GuidedHelpAgeSelectComponent_h2_1_Template, 3, 1, "h2", 1);
        i0.ɵɵelementStart(2, "div", 2)(3, "vnext-toggle-select", 3);
        i0.ɵɵlistener("optionSelected", function GuidedHelpAgeSelectComponent_Template_vnext_toggle_select_optionSelected_3_listener($event) { return ctx.onOptionSelect($event); });
        i0.ɵɵpipe(4, "async");
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_GuidedHelp_Health_AgeQuestion_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("items", ctx.ageRangeToggles)("selectedValue", ctx.selectedAge)("buttonHeight", "36px")("verticalGrow", i0.ɵɵpipeBind1(4, 7, ctx.isMobile$))("ariaLabelledById", "health-age-question")("toggleControlId", "guidedhelp-age");
    } }, dependencies: [ToggleSelectComponent, LiveEditPropDirective, i1$2.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuidedHelpAgeSelectComponent, [{
        type: Component,
        args: [{ selector: 'vnext-guided-help-age-select', providers: [InputResetContextService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container pl-md-0 mt-5\">\r\n  <h2\r\n    class=\"Spa_Style_Bold_Weight Spa_Style_Small_Font col px-0 text-md-left text-center\"\r\n    *liveEditProp=\"'Spa_GuidedHelp_Health_AgeQuestion_Text'\"\r\n  >\r\n    <span id=\"health-age-question\">\r\n      {{ healthAgeQuestionText }}\r\n    </span>\r\n  </h2>\r\n  <div class=\"col-12 col-md-11 mx-auto mx-md-0 px-0\">\r\n    <vnext-toggle-select\r\n      [items]=\"ageRangeToggles\"\r\n      [selectedValue]=\"selectedAge\"\r\n      [buttonHeight]=\"'36px'\"\r\n      [verticalGrow]=\"isMobile$ | async\"\r\n      (optionSelected)=\"onOptionSelect($event)\"\r\n      [ariaLabelledById]=\"'health-age-question'\"\r\n      [toggleControlId]=\"'guidedhelp-age'\"\r\n    ></vnext-toggle-select>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: GuidedHelpAgeSelectFacade }, { type: i0.ChangeDetectorRef }, { type: i1.LocaleService }]; }, { healthAgeQuestionText: [{
            type: Input
        }] }); })();

class HealthSliderFacade {
    constructor(guidedHelpService, demographicService, store) {
        this.guidedHelpService = guidedHelpService;
        this.demographicService = demographicService;
        this.store = store;
    }
    get isMobile$() {
        return this.guidedHelpService.isMobile$;
    }
    updateHealthStatus(selectedStatus) {
        this.store.dispatch(new SetHealthStatus(selectedStatus));
        this.guidedHelpService.dirtyGuidedHelpPlanTypes();
        this.demographicService.updateDemographicSession();
    }
    getHealthStatus$() {
        let healthStatus = this.store.selectSnapshot(DemographicState.healthStatus);
        if (!healthStatus) {
            healthStatus = this.guidedHelpService.getProcessedResourceValue('Spa_GuidedHelp_Health_DefaultHealthStatus_Number', GuidedHelpHealthStatus.MEMBER_HEALTH_GOOD);
            this.store.dispatch(new SetHealthStatus(healthStatus));
        }
        return this.store.select(DemographicState.healthStatus);
    }
}
HealthSliderFacade.ɵfac = function HealthSliderFacade_Factory(t) { return new (t || HealthSliderFacade)(i0.ɵɵinject(i1.GuidedHelpService), i0.ɵɵinject(i1.DemographicService), i0.ɵɵinject(i2.Store)); };
HealthSliderFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HealthSliderFacade, factory: HealthSliderFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HealthSliderFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.GuidedHelpService }, { type: i1.DemographicService }, { type: i2.Store }]; }, null); })();

const _c0$1T = ["sliderKnob"];
const _c1$R = ["sliderBar"];
const _c2$z = ["divider1"];
const _c3$n = ["divider2"];
const _c4$e = ["focusToTooltipSelectedLink"];
const _c5$9 = function (a0, a1) { return { "text-center mx-auto": a0, "text-right": a1 }; };
function HealthSliderComponent_div_1_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21, 22);
    i0.ɵɵlistener("click", function HealthSliderComponent_div_1_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r19); const ctx_r20 = i0.ɵɵnextContext(); const slide_r9 = ctx_r20.$implicit; const index_r10 = ctx_r20.index; const _r11 = i0.ɵɵreference(2); const ctx_r18 = i0.ɵɵnextContext(); ctx_r18.openSliderTooltip(_r11); ctx_r18.selectedSlide = slide_r9; return i0.ɵɵresetView(ctx_r18.selectedIndex = index_r10); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext();
    const index_r10 = ctx_r21.index;
    const slide_r9 = ctx_r21.$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c5$9, index_r10 === 1, index_r10 === 2));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", slide_r9.header, " ");
} }
function HealthSliderComponent_div_1_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "span", 23);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(3, "div", 24);
    i0.ɵɵpipe(4, "safe");
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r14.selectedSlide.header);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 2, ctx_r14.selectedSlide.body, "html"), i0.ɵɵsanitizeHtml);
} }
const _c6$8 = function (a0) { return { "pl-4": a0 }; };
function HealthSliderComponent_div_1_h2_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext();
    const index_r10 = ctx_r22.index;
    const slide_r9 = ctx_r22.$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c6$8, index_r10 !== 0));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", slide_r9.header, " ");
} }
const _c7$6 = function (a0) { return { " pl-4": a0 }; };
function HealthSliderComponent_div_1_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 26);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext();
    const index_r10 = ctx_r23.index;
    const slide_r9 = ctx_r23.$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c7$6, index_r10 !== 0))("innerHTML", i0.ɵɵpipeBind2(1, 2, slide_r9.body, "html"), i0.ɵɵsanitizeHtml);
} }
function HealthSliderComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelement(1, "div", 14, 15);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtemplate(4, HealthSliderComponent_div_1_button_4_Template, 3, 5, "button", 16);
    i0.ɵɵtemplate(5, HealthSliderComponent_div_1_ng_template_5_Template, 5, 5, "ng-template", 17, 18, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, HealthSliderComponent_div_1_h2_7_Template, 2, 4, "h2", 19);
    i0.ɵɵtemplate(8, HealthSliderComponent_div_1_div_8_Template, 2, 7, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const slide_r9 = ctx.$implicit;
    const index_r10 = ctx.index;
    const _r13 = i0.ɵɵreference(6);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngbTooltip", _r13)("placement", ctx_r0.getTooltipPlacement(index_r10));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", slide_r9.headerKey);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", slide_r9.headerKey);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", slide_r9.bodyKey);
} }
function HealthSliderComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div");
} }
function HealthSliderComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div");
} }
function HealthSliderComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div");
} }
function HealthSliderComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div");
} }
const _c8$4 = function (a0, a1) { return { "shift-left": a0, "shift-right": a1 }; };
class HealthSliderComponent {
    constructor(healthSliderFacade, cdr, guidedHelpService) {
        this.healthSliderFacade = healthSliderFacade;
        this.cdr = cdr;
        this.guidedHelpService = guidedHelpService;
        this.knob = GuidedHelpHealthStatus.MEMBER_HEALTH_FAIR;
        this.toggleSelected = false;
        this.subscriptions = [];
        this.healthStatus = GuidedHelpHealthStatus;
    }
    ngOnInit() {
        this.subscriptions = [
            this.healthSliderFacade.getHealthStatus$().subscribe(status => {
                if (status) {
                    this.knob = status;
                    this.guidedHelpService.updateMemberPreferencesHealthAnalytics(this.knob);
                }
                this.cdr.markForCheck();
            })
        ];
    }
    ngAfterViewInit() {
        this.subscriptions = [
            ...this.subscriptions,
            // touchend does not provide x coordinates, so we grab the last touchmove call
            fromEvent(document, 'touchmove').subscribe((event) => {
                this.postDragEvent = event;
            }),
            merge(fromEvent(document, 'mouseup'), fromEvent(document, 'touchend'))
                .pipe(filter(() => this.toggleSelected))
                .subscribe((event) => {
                if (event instanceof MouseEvent) {
                    this.postDragEvent = event;
                }
                this.toggleSelected = false;
                this.changeCursor('auto');
                this.moveToggle();
            }),
            merge(fromEvent(this.sliderKnob.nativeElement, 'mousedown'), fromEvent(this.sliderKnob.nativeElement, 'touchstart')).subscribe((event) => {
                this.preDragEvent = event;
                this.toggleSelected = true;
                this.changeCursor('move');
                // prevents the page from highlighting text or doing other actions
                event.preventDefault();
            }),
            fromEvent(this.sliderKnob.nativeElement, 'keyup')
                .pipe(filter((event) => 
            // so key is the only attribute supported in all browser and of course IE calls their arrow clicks something different.
            event.key === 'ArrowRight' || event.key === 'ArrowLeft' || event.key === 'Left' || event.key === 'Right'))
                .subscribe((event) => {
                this.knob = this.moveKnobByOne(event.key === 'ArrowRight' || event.key === 'Right');
                this.updateHealthStatus(this.knob);
            }),
            fromEvent(this.sliderBar.nativeElement, 'click').subscribe(event => {
                this.moveToggleOnClick(event);
            })
        ];
    }
    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
    openSliderTooltip(tooltip) {
        tooltip.open();
    }
    getTooltipPlacement(index) {
        if (index === 0) {
            return 'top-left';
        }
        if (index === 2) {
            return 'top-right';
        }
        return 'auto';
    }
    getSliderHeader() {
        if (this.slideSections) {
            const slideSection = this.slideSections.find(slide => slide.value === this.knob);
            return slideSection && slideSection.header ? slideSection.header + slideSection.body : '';
        }
        return '';
    }
    moveToggle() {
        let moveRight;
        let distance;
        if (this.preDragEvent instanceof MouseEvent && this.postDragEvent instanceof MouseEvent) {
            moveRight = this.preDragEvent.clientX < this.postDragEvent.clientX;
            distance = this.preDragEvent.clientX - this.postDragEvent.clientX;
        }
        else if (this.preDragEvent instanceof TouchEvent && this.postDragEvent instanceof TouchEvent) {
            moveRight = this.preDragEvent.touches[0].clientX < this.postDragEvent.touches[0].clientX;
            distance = this.preDragEvent.touches[0].clientX - this.postDragEvent.touches[0].clientX;
        }
        else {
            // who knows what would trigger this, but returning just in case
            return;
        }
        this.knob = this.calculateKnobValue(distance, moveRight);
        this.updateHealthStatus(this.knob);
        this.cdr.markForCheck();
    }
    moveToggleOnClick(event) {
        const div1RectList = this.divider1.nativeElement.getClientRects();
        const div2RectList = this.divider2.nativeElement.getClientRects();
        const div1Left = div1RectList[0].left;
        const div1Right = div1RectList[0].right;
        const div2Left = div2RectList[0].left;
        const div2Right = div2RectList[0].right;
        const clickX = event.clientX;
        let clickedKnob;
        if (clickX < div1Left) {
            clickedKnob = GuidedHelpHealthStatus.MEMBER_HEALTH_GOOD;
        }
        else if (clickX > div1Right) {
            if (clickX < div2Left) {
                clickedKnob = GuidedHelpHealthStatus.MEMBER_HEALTH_FAIR;
            }
            else if (clickX > div2Right) {
                clickedKnob = GuidedHelpHealthStatus.MEMBER_HEALTH_POOR;
            }
        }
        if (clickedKnob) {
            this.knob = clickedKnob;
            this.updateHealthStatus(clickedKnob);
            this.cdr.markForCheck();
        }
    }
    changeCursor(cursorValue) {
        document.body.style.cursor = cursorValue;
    }
    updateHealthStatus(newValue) {
        this.healthSliderFacade.updateHealthStatus(newValue);
    }
    calculateKnobValue(distance, moveRight) {
        // first we check to see the width of the slider.
        const sliderWidth = this.sliderBar.nativeElement.clientWidth;
        // then we check to see how far the slider went.
        const absoluteDistance = Math.abs(distance);
        // the ratios for jumping 1 knob is 1/6 of the slider width, distance for 2 jumps is 3/6.
        const ratio = absoluteDistance / sliderWidth;
        // when the ratio is greater than .5 jump 2
        if (ratio > 0.5) {
            return moveRight ? GuidedHelpHealthStatus.MEMBER_HEALTH_POOR : GuidedHelpHealthStatus.MEMBER_HEALTH_GOOD;
        }
        // when the ratio is greater than 1/6, but less than 1/2 jump 1
        if (ratio > 1 / 6) {
            return this.moveKnobByOne(moveRight);
        }
        return this.knob;
    }
    moveKnobByOne(moveRight) {
        // the min/max prevents the user from going past the lowest/highest value
        return moveRight
            ? Math.min(this.knob + 1, GuidedHelpHealthStatus.MEMBER_HEALTH_POOR)
            : Math.max(this.knob - 1, GuidedHelpHealthStatus.MEMBER_HEALTH_GOOD);
    }
}
HealthSliderComponent.ɵfac = function HealthSliderComponent_Factory(t) { return new (t || HealthSliderComponent)(i0.ɵɵdirectiveInject(HealthSliderFacade), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.GuidedHelpService)); };
HealthSliderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HealthSliderComponent, selectors: [["vnext-health-slider"]], viewQuery: function HealthSliderComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1T, 5);
        i0.ɵɵviewQuery(_c1$R, 5);
        i0.ɵɵviewQuery(_c2$z, 5);
        i0.ɵɵviewQuery(_c3$n, 5);
        i0.ɵɵviewQuery(_c4$e, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sliderKnob = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sliderBar = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.divider1 = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.divider2 = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.focusToTooltipSelectedLink = _t);
    } }, inputs: { slideSections: "slideSections", healthStatusSliderLabel: "healthStatusSliderLabel" }, decls: 17, vars: 14, consts: [[1, "d-flex", "justify-content-between", "my-4"], ["class", "w-100", 4, "ngFor", "ngForOf"], [1, "slider-bar-container"], ["sliderBar", ""], [1, "slider-bar", "d-flex", "justify-content-center"], [1, "divider-1"], ["divider1", ""], [1, "divider-2"], ["divider2", ""], [1, "d-flex", "justify-content-around"], [4, "ngIf"], ["tabindex", "0", "role", "slider", "aria-orientation", "horizontal", 1, "slider-knob", 3, "ngClass"], ["sliderKnob", ""], [1, "w-100"], ["tooltipClass", "health-slider", 1, "tooltip-placement", 3, "ngbTooltip", "placement"], ["tooltipController", "ngbTooltip"], ["class", "Spa_Style_Bold_Weight Spa_Style_Smaller_Font Spa_Style_Primary_Color d-md-none d-block underline text-left mx-auto action-button", "tabindex", "0", "role", "button", "triggers", "click:blur", 3, "ngClass", "click", 4, "liveEditProp"], ["class", "d-block d-md-none"], ["tooltip", ""], ["class", "Spa_Style_Bold_Weight Spa_Style_Small_Font Spa_Style_Primary_Color text-left d-none d-md-block", 3, "ngClass", 4, "liveEditProp"], ["class", "Spa_Style_Note text-left d-none d-md-block", "navigationAdapter", "", 3, "ngClass", "innerHTML", 4, "liveEditProp"], ["tabindex", "0", "role", "button", "triggers", "click:blur", 1, "Spa_Style_Bold_Weight", "Spa_Style_Smaller_Font", "Spa_Style_Primary_Color", "d-md-none", "d-block", "underline", "text-left", "mx-auto", "action-button", 3, "ngClass", "click"], ["focusToTooltipSelectedLink", ""], [1, "Spa_Style_Regular_Font", "Spa_Style_Primary_Color"], ["navigationAdapter", "", 1, "Spa_Style_Note", "text-left", 3, "innerHTML"], [1, "Spa_Style_Bold_Weight", "Spa_Style_Small_Font", "Spa_Style_Primary_Color", "text-left", "d-none", "d-md-block", 3, "ngClass"], ["navigationAdapter", "", 1, "Spa_Style_Note", "text-left", "d-none", "d-md-block", 3, "ngClass", "innerHTML"]], template: function HealthSliderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, HealthSliderComponent_div_1_Template, 9, 5, "div", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2, 3)(4, "div", 4);
        i0.ɵɵelement(5, "div", 5, 6)(7, "div")(8, "div", 7, 8);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "div", 9);
        i0.ɵɵtemplate(11, HealthSliderComponent_div_11_Template, 1, 0, "div", 10);
        i0.ɵɵtemplate(12, HealthSliderComponent_div_12_Template, 1, 0, "div", 10);
        i0.ɵɵelement(13, "div", 11, 12);
        i0.ɵɵtemplate(15, HealthSliderComponent_div_15_Template, 1, 0, "div", 10);
        i0.ɵɵtemplate(16, HealthSliderComponent_div_16_Template, 1, 0, "div", 10);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.slideSections);
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("ngIf", ctx.knob === ctx.healthStatus.MEMBER_HEALTH_POOR || ctx.knob === ctx.healthStatus.MEMBER_HEALTH_FAIR);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.knob === ctx.healthStatus.MEMBER_HEALTH_POOR);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c8$4, ctx.knob === ctx.healthStatus.MEMBER_HEALTH_GOOD, ctx.knob === ctx.healthStatus.MEMBER_HEALTH_POOR));
        i0.ɵɵattribute("aria-label", ctx.healthStatusSliderLabel)("aria-valuemin", ctx.healthStatus.MEMBER_HEALTH_GOOD)("aria-valuemax", ctx.healthStatus.MEMBER_HEALTH_POOR)("aria-valuenow", ctx.knob)("aria-valuetext", ctx.getSliderHeader());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.knob === ctx.healthStatus.MEMBER_HEALTH_GOOD);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.knob === ctx.healthStatus.MEMBER_HEALTH_GOOD || ctx.knob === ctx.healthStatus.MEMBER_HEALTH_FAIR);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, NavigationAdapterDirective, LiveEditPropDirective, i1$1.NgbTooltip, SafePipe], styles: [".slider-bar-container[_ngcontent-%COMP%]{padding-top:15px;padding-bottom:15px}.slider-bar[_ngcontent-%COMP%]{background:linear-gradient(to right,var(--static-Spa_Style_Accent5) 0%,var(--static-Spa_Style_Warn_Dark) 100%);min-height:7px;border-radius:5px}.divider-1[_ngcontent-%COMP%], .divider-2[_ngcontent-%COMP%]{background-color:#fff;min-height:7px;min-width:3.25px;max-width:3.25px;margin-right:16.5%}.divider-2[_ngcontent-%COMP%]{margin-right:0%;margin-left:16.5%}.slider-knob[_ngcontent-%COMP%]{background-color:#fff;min-width:25px;min-height:25px;max-width:25px;max-height:25px;border-radius:50%;border:1px solid var(--static-Spa_Style_Accent1);box-shadow:0 0 7px var(--static-Spa_Style_Accent1);position:relative;bottom:30.25px}.slider-knob[_ngcontent-%COMP%]:focus{box-shadow:0 0 5px var(--static-Spa_Style_Black)}.shift-left[_ngcontent-%COMP%]{right:12.25px}.shift-right[_ngcontent-%COMP%]{left:12.25px}.slider-knob[_ngcontent-%COMP%]:hover{cursor:pointer}.underline[_ngcontent-%COMP%]{text-decoration:underline}.header[_ngcontent-%COMP%]{width:33%}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HealthSliderComponent, [{
        type: Component,
        args: [{ selector: 'vnext-health-slider', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"d-flex justify-content-between my-4\">\r\n  <div *ngFor=\"let slide of slideSections; index as index\" class=\"w-100\">\r\n    <div\r\n      class=\"tooltip-placement\"\r\n      [ngbTooltip]=\"tooltip\"\r\n      #tooltipController=\"ngbTooltip\"\r\n      tooltipClass=\"health-slider\"\r\n      [placement]=\"getTooltipPlacement(index)\"\r\n    ></div>\r\n    <div>\r\n      <button\r\n        *liveEditProp=\"slide.headerKey\"\r\n        (click)=\"openSliderTooltip(tooltipController); selectedSlide = slide; selectedIndex = index\"\r\n        class=\"Spa_Style_Bold_Weight Spa_Style_Smaller_Font Spa_Style_Primary_Color d-md-none d-block underline text-left mx-auto action-button\"\r\n        [ngClass]=\"{ 'text-center mx-auto': index === 1, 'text-right': index === 2 }\"\r\n        tabindex=\"0\"\r\n        role=\"button\"\r\n        triggers=\"click:blur\"\r\n        #focusToTooltipSelectedLink\r\n      >\r\n        {{ slide.header }}\r\n      </button>\r\n\r\n      <!-- tooltip -->\r\n      <ng-template #tooltip class=\"d-block d-md-none\">\r\n        <div>\r\n          <span class=\"Spa_Style_Regular_Font Spa_Style_Primary_Color\">{{ selectedSlide.header }}</span>\r\n        </div>\r\n\r\n        <div class=\"Spa_Style_Note text-left\" [innerHTML]=\"selectedSlide.body | safe : 'html'\" navigationAdapter></div>\r\n      </ng-template>\r\n    </div>\r\n    <h2\r\n      *liveEditProp=\"slide.headerKey\"\r\n      class=\"Spa_Style_Bold_Weight Spa_Style_Small_Font Spa_Style_Primary_Color text-left d-none d-md-block\"\r\n      [ngClass]=\"{ 'pl-4': index !== 0 }\"\r\n    >\r\n      {{ slide.header }}\r\n    </h2>\r\n    <div\r\n      *liveEditProp=\"slide.bodyKey\"\r\n      class=\"Spa_Style_Note text-left d-none d-md-block\"\r\n      [ngClass]=\"{ ' pl-4': index !== 0 }\"\r\n      [innerHTML]=\"slide.body | safe : 'html'\"\r\n      navigationAdapter\r\n    ></div>\r\n  </div>\r\n</div>\r\n\r\n<!-- slider -->\r\n<div #sliderBar class=\"slider-bar-container\">\r\n  <div class=\"slider-bar d-flex justify-content-center\">\r\n    <div #divider1 class=\"divider-1\"></div>\r\n    <div></div>\r\n    <div #divider2 class=\"divider-2\"></div>\r\n  </div>\r\n</div>\r\n<div class=\"d-flex justify-content-around\">\r\n  <div *ngIf=\"knob === healthStatus.MEMBER_HEALTH_POOR || knob === healthStatus.MEMBER_HEALTH_FAIR\"></div>\r\n  <div *ngIf=\"knob === healthStatus.MEMBER_HEALTH_POOR\"></div>\r\n  <div\r\n    class=\"slider-knob\"\r\n    #sliderKnob\r\n    tabindex=\"0\"\r\n    [ngClass]=\"{\r\n      'shift-left': knob === healthStatus.MEMBER_HEALTH_GOOD,\r\n      'shift-right': knob === healthStatus.MEMBER_HEALTH_POOR\r\n    }\"\r\n    role=\"slider\"\r\n    aria-orientation=\"horizontal\"\r\n    [attr.aria-label]=\"healthStatusSliderLabel\"\r\n    [attr.aria-valuemin]=\"healthStatus.MEMBER_HEALTH_GOOD\"\r\n    [attr.aria-valuemax]=\"healthStatus.MEMBER_HEALTH_POOR\"\r\n    [attr.aria-valuenow]=\"knob\"\r\n    [attr.aria-valuetext]=\"getSliderHeader()\"\r\n  ></div>\r\n  <div *ngIf=\"knob === healthStatus.MEMBER_HEALTH_GOOD\"></div>\r\n  <div *ngIf=\"knob === healthStatus.MEMBER_HEALTH_GOOD || knob === healthStatus.MEMBER_HEALTH_FAIR\"></div>\r\n</div>\r\n", styles: [".slider-bar-container{padding-top:15px;padding-bottom:15px}.slider-bar{background:linear-gradient(to right,var(--static-Spa_Style_Accent5) 0%,var(--static-Spa_Style_Warn_Dark) 100%);min-height:7px;border-radius:5px}.divider-1,.divider-2{background-color:#fff;min-height:7px;min-width:3.25px;max-width:3.25px;margin-right:16.5%}.divider-2{margin-right:0%;margin-left:16.5%}.slider-knob{background-color:#fff;min-width:25px;min-height:25px;max-width:25px;max-height:25px;border-radius:50%;border:1px solid var(--static-Spa_Style_Accent1);box-shadow:0 0 7px var(--static-Spa_Style_Accent1);position:relative;bottom:30.25px}.slider-knob:focus{box-shadow:0 0 5px var(--static-Spa_Style_Black)}.shift-left{right:12.25px}.shift-right{left:12.25px}.slider-knob:hover{cursor:pointer}.underline{text-decoration:underline}.header{width:33%}\n"] }]
    }], function () { return [{ type: HealthSliderFacade }, { type: i0.ChangeDetectorRef }, { type: i1.GuidedHelpService }]; }, { slideSections: [{
            type: Input
        }], healthStatusSliderLabel: [{
            type: Input
        }], sliderKnob: [{
            type: ViewChild,
            args: ['sliderKnob']
        }], sliderBar: [{
            type: ViewChild,
            args: ['sliderBar']
        }], divider1: [{
            type: ViewChild,
            args: ['divider1']
        }], divider2: [{
            type: ViewChild,
            args: ['divider2']
        }], focusToTooltipSelectedLink: [{
            type: ViewChildren,
            args: ['focusToTooltipSelectedLink']
        }] }); })();

function HealthCostCustomizationTableComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.healthCostsBenefitsBodyText, " ");
} }
function HealthCostCustomizationTableComponent_div_0_h3_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.healthCostsBenefitsTableHeader, " ");
} }
function HealthCostCustomizationTableComponent_div_0_h3_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.healthCostsUsageTableHeader, " ");
} }
function HealthCostCustomizationTableComponent_div_0_h3_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.healthCostsDaysTableHeader, " ");
} }
function HealthCostCustomizationTableComponent_div_0_tr_13_span_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 33);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const benefit_r8 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, benefit_r8.tooltip, "html"), i0.ɵɵsanitizeHtml);
} }
function HealthCostCustomizationTableComponent_div_0_tr_13_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtemplate(1, HealthCostCustomizationTableComponent_div_0_tr_13_span_3_ng_template_1_Template, 2, 4, "ng-template", null, 31, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "i", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r16 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbTooltip", _r16);
} }
function HealthCostCustomizationTableComponent_div_0_tr_13_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "input", 34);
    i0.ɵɵlistener("ngModelChange", function HealthCostCustomizationTableComponent_div_0_tr_13_div_10_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r21); const benefit_r8 = i0.ɵɵnextContext().$implicit; return i0.ɵɵresetView(benefit_r8.defaultOccurences = $event); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const benefit_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", benefit_r8.defaultOccurences);
    i0.ɵɵattribute("aria-label", ctx_r10.healthCostsUsageTableHeader + " " + benefit_r8.name);
} }
function HealthCostCustomizationTableComponent_div_0_tr_13_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const benefit_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(benefit_r8.defaultOccurences);
} }
function HealthCostCustomizationTableComponent_div_0_tr_13_div_19_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "input", 34);
    i0.ɵɵlistener("ngModelChange", function HealthCostCustomizationTableComponent_div_0_tr_13_div_19_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r26); const benefit_r8 = i0.ɵɵnextContext().$implicit; return i0.ɵɵresetView(benefit_r8.defaultDuration = $event); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const benefit_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", benefit_r8.defaultDuration);
    i0.ɵɵattribute("aria-label", ctx_r13.healthCostsDaysTableHeader + " " + benefit_r8.name);
} }
function HealthCostCustomizationTableComponent_div_0_tr_13_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const benefit_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", benefit_r8.defaultDuration && benefit_r8.durationValue === ctx_r15.healthCostsDurationValues.YES ? benefit_r8.defaultDuration : "\u2014", " ");
} }
function HealthCostCustomizationTableComponent_div_0_tr_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 20)(1, "td", 21);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, HealthCostCustomizationTableComponent_div_0_tr_13_span_3_Template, 4, 1, "span", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td", 23)(5, "div", 2)(6, "div", 24)(7, "div", 25);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 26);
    i0.ɵɵtemplate(10, HealthCostCustomizationTableComponent_div_0_tr_13_div_10_Template, 2, 2, "div", 27);
    i0.ɵɵtemplate(11, HealthCostCustomizationTableComponent_div_0_tr_13_ng_template_11_Template, 2, 1, "ng-template", null, 28, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(13, "td", 23)(14, "div", 2)(15, "div", 24)(16, "div", 25);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "div", 26);
    i0.ɵɵtemplate(19, HealthCostCustomizationTableComponent_div_0_tr_13_div_19_Template, 2, 2, "div", 27);
    i0.ɵɵtemplate(20, HealthCostCustomizationTableComponent_div_0_tr_13_ng_template_20_Template, 2, 1, "ng-template", null, 29, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const benefit_r8 = ctx.$implicit;
    const _r11 = i0.ɵɵreference(12);
    const _r14 = i0.ɵɵreference(21);
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", benefit_r8.name, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", benefit_r8.tooltip);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r7.healthCostsUsageTableHeader);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r7.editingForm)("ngIfElse", _r11);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r7.healthCostsDaysTableHeader);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r7.editingForm && benefit_r8.durationValue === ctx_r7.healthCostsDurationValues.YES)("ngIfElse", _r14);
} }
function HealthCostCustomizationTableComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, HealthCostCustomizationTableComponent_div_0_div_1_Template, 2, 1, "div", 3);
    i0.ɵɵelementStart(2, "table", 4)(3, "thead", 5)(4, "tr", 6)(5, "th", 7);
    i0.ɵɵtemplate(6, HealthCostCustomizationTableComponent_div_0_h3_6_Template, 2, 1, "h3", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th", 9)(8, "div", 10);
    i0.ɵɵtemplate(9, HealthCostCustomizationTableComponent_div_0_h3_9_Template, 2, 1, "h3", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "th", 9);
    i0.ɵɵtemplate(11, HealthCostCustomizationTableComponent_div_0_h3_11_Template, 2, 1, "h3", 8);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(12, "tbody");
    i0.ɵɵtemplate(13, HealthCostCustomizationTableComponent_div_0_tr_13_Template, 22, 8, "tr", 11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 12)(15, "div", 13)(16, "button", 14);
    i0.ɵɵlistener("click", function HealthCostCustomizationTableComponent_div_0_Template_button_click_16_listener() { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r29.resetDefaultConfirmationModal(true)); });
    i0.ɵɵelement(17, "i", 15);
    i0.ɵɵelementStart(18, "span", 16);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(20, "vnext-status-button", 17);
    i0.ɵɵlistener("click", function HealthCostCustomizationTableComponent_div_0_Template_vnext_status_button_click_20_listener() { i0.ɵɵrestoreView(_r30); const ctx_r31 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r31.update()); })("keyup.enter", function HealthCostCustomizationTableComponent_div_0_Template_vnext_status_button_keyup_enter_20_listener() { i0.ɵɵrestoreView(_r30); const ctx_r32 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r32.update()); });
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_HealthCosts_Benefits_Body_Text");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_HealthCosts_Benefits_Table_Header");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_HealthCosts_Usage_Table_Header");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_HealthCosts_Days_Table_Header");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.costBenefitsFormValues);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r0.healthCostsRestoreDefaultsText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("buttonText", ctx_r0.editingForm ? ctx_r0.healthCostsSaveAnswersText : ctx_r0.healthCostsUpdateAnswersText)("tooltipMessageError", ctx_r0.saveFailedText)("tooltipMessageSuccess", ctx_r0.saveSuccessText)("buttonClass", "btn Spa_Style_SecondaryButton");
} }
function HealthCostCustomizationTableComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35)(1, "p", 36);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.saveFailedText, " ");
} }
class HealthCostCustomizationTableComponent {
    constructor(cdr, memberSessionService, store, configurableWidgetService, modalService, unsavedModalContext, deactivationGuardService, spinnerService, analyticsService, plansService) {
        this.cdr = cdr;
        this.memberSessionService = memberSessionService;
        this.store = store;
        this.configurableWidgetService = configurableWidgetService;
        this.modalService = modalService;
        this.unsavedModalContext = unsavedModalContext;
        this.deactivationGuardService = deactivationGuardService;
        this.spinnerService = spinnerService;
        this.analyticsService = analyticsService;
        this.plansService = plansService;
        this.subscriptions = new Subscription();
        this.mappedCostBenefits = [];
        this.costBenefitsFormValues = [];
        this.editingForm = false;
        this.hasMedicalCosts = false;
        this.medicalCostsLoadError = false;
        this.medicalCostsEdited = false;
        this.setToDefault = false;
        this.healthCostsDurationValues = HealthCostsDurationValues;
    }
    ngOnInit() {
        this.deactivationGuardService.addDeactivationGuard({
            canDeactivate: this.showUnsavedChangesModal.bind(this)
        });
        if (this.estimateHealthCost !== EstimateHealthCostFlag.Edited) {
            this.memberSessionService.saveEstimateHealthCost(EstimateHealthCostFlag.Default);
        }
        this.memberSessionService.getMedicalCosts$().subscribe((medicalCosts) => {
            this.hasMedicalCosts = medicalCosts.length > 0;
            if (this.hasMedicalCosts) {
                this.mapConfigBenefits(medicalCosts);
                this.saveChanges(false);
            }
            this.subscriptions.add(combineLatest([this.store.select(DemographicState.ageRange), this.store.select(DemographicState.healthStatus)]).subscribe(([ageRange, healthStatus]) => {
                if (ageRange && healthStatus) {
                    this.getMedicalCostDefault(ageRange, healthStatus);
                }
            }));
            this.subscriptions.add(this.unsavedModalContext.getUnsavedChangesModalContext$().subscribe(display => {
                if (display) {
                    if (this.isFieldValuesChanged()) {
                        this.showUnsavedChangesModal(true);
                    }
                    else {
                        this.setDefault();
                    }
                }
            }));
        }, err => {
            this.medicalCostsLoadError = true;
            this.cdr.markForCheck();
        });
    }
    mapConfigBenefits(configBenefits) {
        this.mappedCostBenefits = this.healthCostsBenefits.map(benefit => {
            const match = configBenefits.find(entry => benefit.medCategoryID === entry.medCategoryID || benefit.medCategoryID === entry.benefitID);
            let defaultOccurences;
            let defaultDuration;
            if (match) {
                if ('defaultOccurences' in match) {
                    defaultOccurences = match.defaultOccurences;
                    defaultDuration = match.defaultDuration;
                }
                else {
                    defaultOccurences = match.annualOccurrences;
                    defaultDuration = match.annualDuration;
                }
            }
            return {
                benefitID: benefit.medCategoryID,
                name: benefit.name,
                defaultDuration: defaultDuration >= 0 && defaultDuration !== null ? `${defaultDuration}` : undefined,
                durationValue: benefit.durationValue,
                tooltip: benefit.toolTip,
                defaultOccurences: `${defaultOccurences}`
            };
        });
        this.costBenefitsFormValues = _cloneDeep(this.mappedCostBenefits);
        this.cdr.markForCheck();
    }
    getMedicalCostDefault(ageRange, healthStatus) {
        this.memberSessionService.getMedicalCostDefault$(ageRange, healthStatus).subscribe(defaults => {
            this.defaultCostBenefits = defaults;
            if ((!this.hasMedicalCosts && this.estimateHealthCost === EstimateHealthCostFlag.Default) ||
                this.estimateHealthCost === undefined ||
                this.estimateHealthCost === null) {
                this.mapConfigBenefits(defaults);
            }
        });
    }
    setDefault() {
        this.hasMedicalCosts = false;
        this.mapConfigBenefits(this.defaultCostBenefits);
        this.saveChanges(true);
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PREF_HEALTHCOST_CALC_RESTORE_DEFAULT);
        this.updateHealthCostCalcAnalytics(GOOGLE_ANALYTICS_NO);
    }
    update() {
        if (this.editingForm) {
            this.saveChanges(false);
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PREF_HEALTHCOST_CALC_SAVE);
            this.updateHealthCostCalcAnalytics(GOOGLE_ANALYTICS_YES);
        }
        else {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PREF_HEALTHCOST_CALC_EDIT);
        }
        this.editingForm = !this.editingForm;
    }
    resetDefaultConfirmationModal(isDefault) {
        const modalTitle = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_RestoreDefaults_Modal_TitleText', null, 'Restore defaults');
        const modalPrompt = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_RestoreDefaults_Modal_Text', null, 'Are you sure you want to reset your selections?');
        const modalCancel = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_Cancel', null, 'No');
        const modalLeave = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_Yes', null, 'Yes');
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true });
        confirmationModal.componentInstance.title = modalTitle;
        confirmationModal.componentInstance.prompt = modalPrompt;
        confirmationModal.componentInstance.cancelButton = modalCancel;
        confirmationModal.componentInstance.confirmButton = modalLeave;
        if (isDefault) {
            confirmationModal.result.then(() => this.setDefault()).catch(() => false);
        }
    }
    updateHealthCostCalcAnalytics(healthCostCalc) {
        const tagsToUpdate = {
            [DataLayerGlobalVariable.MEMBER_PREF_HEALTH_COST_CALC]: healthCostCalc
        };
        this.analyticsService.googleDataLayerTags = tagsToUpdate;
    }
    isFieldValuesChanged() {
        // check from default cost benefits if changes were made in cost benefits form
        return JSON.stringify(this.costBenefitsFormValues) !== JSON.stringify(this.mappedCostBenefits);
    }
    async showUnsavedChangesModal(isDefault) {
        if (this.isFieldValuesChanged()) {
            // To prevent any un-expected stuck spinner event at moment to shows up the modal
            this.spinnerService.reset();
            const modalTitle = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_LeavingPageModal_Title', null, 'Unsaved changes');
            const modalPrompt = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_LeavingPageModal_Message', null, 'Are you sure you want to leave without saving your changes');
            const modalCancel = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_LeavingPageModal_CancelButton', null, 'Stay on page');
            const modalLeave = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_LeavingPageModal_LeaveButton', null, 'Leave page');
            const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true });
            confirmationModal.componentInstance.title = modalTitle;
            confirmationModal.componentInstance.prompt = modalPrompt;
            confirmationModal.componentInstance.cancelButton = modalCancel;
            confirmationModal.componentInstance.confirmButton = modalLeave;
            return confirmationModal.result
                .then(() => {
                this.spinnerService.show(SpinnerEvent.NAVIGATION);
                if (isDefault) {
                    this.setDefault();
                }
                return true;
            })
                .catch(() => false);
        }
        else {
            return Promise.resolve(true);
        }
    }
    saveChanges(saveDefaults) {
        const updateValues = [];
        const mapValues = saveDefaults ? this.defaultCostBenefits : this.costBenefitsFormValues;
        mapValues.forEach(benefit => {
            updateValues.push({
                benefitID: saveDefaults ? benefit.medCategoryID : benefit.benefitID,
                annualOccurrences: parseInt(benefit.defaultOccurences),
                annualDuration: benefit.defaultDuration ? parseInt(benefit.defaultDuration) : null
            });
        });
        this.memberSessionService.saveMedicalCosts$(updateValues).subscribe(() => {
            this.memberSessionService.setHealthMedicalCostInputs(updateValues);
            if (saveDefaults && !this.setToDefault) {
                this.medicalCostsEdited = false;
                this.setToDefault = true;
                this.memberSessionService.saveEstimateHealthCost(EstimateHealthCostFlag.Default);
            }
            else {
                this.medicalCostsEdited = true;
                this.setToDefault = false;
                this.mappedCostBenefits = _cloneDeep(this.costBenefitsFormValues);
                this.memberSessionService.saveEstimateHealthCost(EstimateHealthCostFlag.Edited, this.requestFeedback.bind(this));
            }
            this.plansService.setAllPlansDirty(true);
        }, () => {
            this.saveButton.showErrorMessage();
        });
    }
    requestFeedback(successfull) {
        if (successfull) {
            this.saveButton.showSuccessMessage();
        }
        else {
            this.saveButton.showErrorMessage();
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
HealthCostCustomizationTableComponent.ɵfac = function HealthCostCustomizationTableComponent_Factory(t) { return new (t || HealthCostCustomizationTableComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(i1.UnsavedModalContext), i0.ɵɵdirectiveInject(i1.DeactivationGuardService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.PlansService)); };
HealthCostCustomizationTableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HealthCostCustomizationTableComponent, selectors: [["vnext-health-cost-customization-table"]], viewQuery: function HealthCostCustomizationTableComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(StatusButtonComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.saveButton = _t.first);
    } }, inputs: { healthCostsBenefitsBodyText: "healthCostsBenefitsBodyText", healthCostsBenefitsTableHeader: "healthCostsBenefitsTableHeader", healthCostsUsageTableHeader: "healthCostsUsageTableHeader", healthCostsDaysTableHeader: "healthCostsDaysTableHeader", healthCostsRestoreDefaultsText: "healthCostsRestoreDefaultsText", healthCostsUpdateAnswersText: "healthCostsUpdateAnswersText", healthCostsSaveAnswersText: "healthCostsSaveAnswersText", estimateHealthCost: "estimateHealthCost", healthCostsBenefits: "healthCostsBenefits", saveFailedText: "saveFailedText", saveSuccessText: "saveSuccessText" }, decls: 3, vars: 2, consts: [["class", "container", 4, "ngIf", "ngIfElse"], ["emptyHealthCostsBenefits", ""], [1, "container"], ["class", "Spa_Style_Primary_Color text-left row", 4, "liveEditProp"], [1, "active-selling-permissions-table", "table"], [1, "d-none", "d-md-block"], [1, "row", "Spa_Style_Bold_Weight", "Spa_Style_Primary_Color", "text-left"], ["scope", "col", 1, "col-12", "col-md-8"], ["class", "wrap-header-text Spa_Style_Regular_Font", 4, "liveEditProp"], ["scope", "col", 1, "col-6", "col-md-2"], [1, "wrap-header-width"], ["class", "Spa_Style_Primary_Color row d-flex justify-content-end", 4, "ngFor", "ngForOf"], [1, "row"], [1, "w-100", "d-flex", "justify-content-end"], [1, "Spa_Style_Link", "can-click", "btn", "no-underline", 3, "click"], [1, "far", "fa-redo-alt", "mr-1"], [1, "text-underline"], [3, "buttonText", "tooltipMessageError", "tooltipMessageSuccess", "buttonClass", "click", "keyup.enter"], [1, "Spa_Style_Primary_Color", "text-left", "row"], [1, "wrap-header-text", "Spa_Style_Regular_Font"], [1, "Spa_Style_Primary_Color", "row", "d-flex", "justify-content-end"], [1, "d-flex", "align-items-center", "col-12", "col-md-8", "text-left"], ["class", "pl-1", 4, "ngIf"], [1, "col-5", "col-md-2", "health-cost-input"], [1, "Spa_Style_Bold_Weight", "row", "d-flex", "d-none", "d-sm-block", "d-md-none"], [1, "wrap-header-text", "font-weight-bold"], [1, "row", "d-flex", "justify-content-center"], [4, "ngIf", "ngIfElse"], ["showUsageValue", ""], ["showTotalValue", ""], [1, "pl-1"], ["benefitTooltip", ""], ["aria-label", "Show tooltip", "tabindex", "0", "aria-labelledby", "benefitToolTipId", 1, "fas", "Spa_Style_QuestionIcon", 3, "ngbTooltip"], ["id", "benefitToolTipId", "navigationAdapter", "", 1, "Spa_Style_ToolTip", 3, "innerHtml"], ["tabindex", "0", "type", "text", "maxlength", "5", "digitOnly", "", 1, "form-control", "text-center", "can-click", 3, "ngModel", "ngModelChange"], [1, "text-center"], [1, "Spa_Style_Gray4_Color", "c-mt-30"]], template: function HealthCostCustomizationTableComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, HealthCostCustomizationTableComponent_div_0_Template, 21, 10, "div", 0);
        i0.ɵɵtemplate(1, HealthCostCustomizationTableComponent_ng_template_1_Template, 3, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", !ctx.medicalCostsLoadError)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, i4.DefaultValueAccessor, i4.NgControlStatus, i4.MaxLengthValidator, i4.NgModel, StatusButtonComponent, NavigationAdapterDirective, LiveEditPropDirective, IconAriaAttributesDirective, i1$1.NgbTooltip, i3.DigitOnlyDirective, SafePipe], styles: [".table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], td[_ngcontent-%COMP%]{border:none}tr[_ngcontent-%COMP%]{height:60px;border-bottom:1px solid var(--static-Spa_Style_Accent1)}.wrap-header-width[_ngcontent-%COMP%]{width:100%}.wrap-header-text[_ngcontent-%COMP%]{width:100%;display:inline-block;word-wrap:break-word;word-break:break-word}.btn.Spa_Style_Link[_ngcontent-%COMP%]{font-size:14px!important}.fa-question-circle[_ngcontent-%COMP%]{margin-left:15px;color:var(--static-Spa_Style_Gray4)}.health-cost-input[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center}@media (max-width: 768px){tr[_ngcontent-%COMP%]{height:auto}}@media (min-width: 768px) and (max-width: 992px){.wrap-header-width[_ngcontent-%COMP%]   .wrap-header-text[_ngcontent-%COMP%]{width:70%}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HealthCostCustomizationTableComponent, [{
        type: Component,
        args: [{ selector: 'vnext-health-cost-customization-table', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container\" *ngIf=\"!medicalCostsLoadError; else emptyHealthCostsBenefits\">\r\n  <div class=\"Spa_Style_Primary_Color text-left row\" *liveEditProp=\"'Spa_HealthCosts_Benefits_Body_Text'\">\r\n    {{ healthCostsBenefitsBodyText }}\r\n  </div>\r\n  <table class=\"active-selling-permissions-table table\">\r\n    <thead class=\"d-none d-md-block\">\r\n      <tr class=\"row Spa_Style_Bold_Weight Spa_Style_Primary_Color text-left\">\r\n        <th scope=\"col\" class=\"col-12 col-md-8\">\r\n          <h3 class=\"wrap-header-text Spa_Style_Regular_Font\" *liveEditProp=\"'Spa_Site_HealthCosts_Benefits_Table_Header'\">\r\n            {{ healthCostsBenefitsTableHeader }}\r\n          </h3>\r\n        </th>\r\n        <th scope=\"col\" class=\"col-6 col-md-2\">\r\n          <div class=\"wrap-header-width\">\r\n            <h3 class=\"wrap-header-text Spa_Style_Regular_Font\" *liveEditProp=\"'Spa_Site_HealthCosts_Usage_Table_Header'\">\r\n              {{ healthCostsUsageTableHeader }}\r\n            </h3>\r\n          </div>\r\n        </th>\r\n        <th scope=\"col\" class=\"col-6 col-md-2\">\r\n          <h3 class=\"wrap-header-text Spa_Style_Regular_Font\" *liveEditProp=\"'Spa_Site_HealthCosts_Days_Table_Header'\">\r\n            {{ healthCostsDaysTableHeader }}\r\n          </h3>\r\n        </th>\r\n      </tr>\r\n    </thead>\r\n    <tbody>\r\n      <tr class=\"Spa_Style_Primary_Color row d-flex justify-content-end\" *ngFor=\"let benefit of costBenefitsFormValues\">\r\n        <td class=\"d-flex align-items-center col-12 col-md-8 text-left\">\r\n          {{ benefit.name }}\r\n          <span class=\"pl-1\" *ngIf=\"benefit.tooltip\">\r\n            <ng-template #benefitTooltip>\r\n              <div id=\"benefitToolTipId\" [innerHtml]=\"benefit.tooltip | safe : 'html'\" class=\"Spa_Style_ToolTip\" navigationAdapter></div>\r\n            </ng-template>\r\n            <i class=\"fas Spa_Style_QuestionIcon\" aria-label=\"Show tooltip\" tabindex=\"0\" [ngbTooltip]=\"benefitTooltip\" aria-labelledby=\"benefitToolTipId\"></i>\r\n          </span>\r\n        </td>\r\n        <td class=\"col-5 col-md-2 health-cost-input\">\r\n          <div class=\"container\">\r\n            <div class=\"Spa_Style_Bold_Weight row d-flex d-none d-sm-block d-md-none\">\r\n              <div class=\"wrap-header-text font-weight-bold\">{{ healthCostsUsageTableHeader }}</div>\r\n            </div>\r\n            <div class=\"row d-flex justify-content-center\">\r\n              <div *ngIf=\"editingForm; else showUsageValue\">\r\n                <input\r\n                  tabindex=\"0\"\r\n                  type=\"text\"\r\n                  maxlength=\"5\"\r\n                  digitOnly\r\n                  class=\"form-control text-center can-click\"\r\n                  [attr.aria-label]=\"healthCostsUsageTableHeader + ' ' + benefit.name\"\r\n                  [(ngModel)]=\"benefit.defaultOccurences\"\r\n                />\r\n              </div>\r\n              <ng-template #showUsageValue>\r\n                <div>{{ benefit.defaultOccurences }}</div>\r\n              </ng-template>\r\n            </div>\r\n          </div>\r\n        </td>\r\n        <td class=\"col-5 col-md-2 health-cost-input\">\r\n          <div class=\"container\">\r\n            <div class=\"Spa_Style_Bold_Weight row d-flex d-none d-sm-block d-md-none\">\r\n              <div class=\"wrap-header-text font-weight-bold\">{{ healthCostsDaysTableHeader }}</div>\r\n            </div>\r\n            <div class=\"row d-flex justify-content-center\">\r\n              <div *ngIf=\"editingForm && benefit.durationValue === healthCostsDurationValues.YES; else showTotalValue\">\r\n                <input\r\n                  tabindex=\"0\"\r\n                  type=\"text\"\r\n                  maxlength=\"5\"\r\n                  digitOnly\r\n                  class=\"form-control text-center can-click\"\r\n                  [attr.aria-label]=\"healthCostsDaysTableHeader + ' ' + benefit.name\"\r\n                  [(ngModel)]=\"benefit.defaultDuration\"\r\n                />\r\n              </div>\r\n              <ng-template #showTotalValue>\r\n                <div>\r\n                  {{ benefit.defaultDuration && benefit.durationValue === healthCostsDurationValues.YES ? benefit.defaultDuration : '\u2014' }}\r\n                </div>\r\n              </ng-template>\r\n            </div>\r\n          </div>\r\n        </td>\r\n      </tr>\r\n    </tbody>\r\n  </table>\r\n  <div class=\"row\">\r\n    <div class=\"w-100 d-flex justify-content-end\">\r\n      <button class=\"Spa_Style_Link can-click btn no-underline\" (click)=\"resetDefaultConfirmationModal(true)\">\r\n        <i class=\"far fa-redo-alt mr-1\"></i>\r\n        <span class=\"text-underline\">{{ healthCostsRestoreDefaultsText }}</span>\r\n      </button>\r\n      <vnext-status-button\r\n        [buttonText]=\"editingForm ? healthCostsSaveAnswersText : healthCostsUpdateAnswersText\"\r\n        [tooltipMessageError]=\"saveFailedText\"\r\n        [tooltipMessageSuccess]=\"saveSuccessText\"\r\n        [buttonClass]=\"'btn Spa_Style_SecondaryButton'\"\r\n        (click)=\"update()\"\r\n        (keyup.enter)=\"update()\"\r\n      >\r\n      </vnext-status-button>\r\n    </div>\r\n  </div>\r\n</div>\r\n<ng-template #emptyHealthCostsBenefits>\r\n  <div class=\"text-center\">\r\n    <p class=\"Spa_Style_Gray4_Color c-mt-30\">\r\n      {{ saveFailedText }}\r\n    </p>\r\n  </div>\r\n</ng-template>\r\n", styles: [".table thead th,td{border:none}tr{height:60px;border-bottom:1px solid var(--static-Spa_Style_Accent1)}.wrap-header-width{width:100%}.wrap-header-text{width:100%;display:inline-block;word-wrap:break-word;word-break:break-word}.btn.Spa_Style_Link{font-size:14px!important}.fa-question-circle{margin-left:15px;color:var(--static-Spa_Style_Gray4)}.health-cost-input{display:flex;align-items:center;justify-content:center}@media (max-width: 768px){tr{height:auto}}@media (min-width: 768px) and (max-width: 992px){.wrap-header-width .wrap-header-text{width:70%}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.MemberSessionService }, { type: i2.Store }, { type: ConfigurableWidgetService }, { type: i1$1.NgbModal }, { type: i1.UnsavedModalContext }, { type: i1.DeactivationGuardService }, { type: i1.SpinnerService }, { type: AnalyticsService }, { type: i1.PlansService }]; }, { healthCostsBenefitsBodyText: [{
            type: Input
        }], healthCostsBenefitsTableHeader: [{
            type: Input
        }], healthCostsUsageTableHeader: [{
            type: Input
        }], healthCostsDaysTableHeader: [{
            type: Input
        }], healthCostsRestoreDefaultsText: [{
            type: Input
        }], healthCostsUpdateAnswersText: [{
            type: Input
        }], healthCostsSaveAnswersText: [{
            type: Input
        }], estimateHealthCost: [{
            type: Input
        }], healthCostsBenefits: [{
            type: Input
        }], saveFailedText: [{
            type: Input
        }], saveSuccessText: [{
            type: Input
        }], saveButton: [{
            type: ViewChild,
            args: [StatusButtonComponent]
        }] }); })();

function HealthCostCustomizationComponent_h2_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 5)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.healthCostsBodyText, " ");
} }
function HealthCostCustomizationComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "vnext-health-cost-customization-table", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("healthCostsBenefitsBodyText", ctx_r1.healthCostsBenefitsBodyText)("healthCostsBenefitsTableHeader", ctx_r1.healthCostsBenefitsTableHeader)("healthCostsUsageTableHeader", ctx_r1.healthCostsUsageTableHeader)("healthCostsDaysTableHeader", ctx_r1.healthCostsDaysTableHeader)("healthCostsRestoreDefaultsText", ctx_r1.healthCostsRestoreDefaultsText)("healthCostsUpdateAnswersText", ctx_r1.healthCostsUpdateAnswersText)("healthCostsSaveAnswersText", ctx_r1.healthCostsSaveAnswersText)("healthCostsBenefits", ctx_r1.healthCostsBenefits)("estimateHealthCost", ctx_r1.estimateHealthCost)("saveFailedText", ctx_r1.saveFailedText)("saveSuccessText", ctx_r1.saveSuccessText);
} }
class HealthCostCustomizationComponent {
    constructor(memberSessionService, spinnerService, guidedHelpService, analyticsService) {
        this.memberSessionService = memberSessionService;
        this.spinnerService = spinnerService;
        this.guidedHelpService = guidedHelpService;
        this.analyticsService = analyticsService;
        this.updateEstimateHealthCost = new EventEmitter();
        this.showHealthCostCustomizationTable = false;
        this.healthCostItems = [];
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        if (this.estimateHealthCost === EstimateHealthCostFlag.OptOut) {
            this.selectedOption = false;
        }
        else if (this.estimateHealthCost === EstimateHealthCostFlag.Edited || this.estimateHealthCost === EstimateHealthCostFlag.Default) {
            this.showHealthCostCustomizationTable = true;
            this.selectedOption = true;
        }
        else {
            this.memberSessionService.saveEstimateHealthCost(null);
        }
        this.subscriptions.add(this.memberSessionService.isLoadingEstimateHealthCost$().subscribe({
            next: loadingEstimateHealthCost => {
                loadingEstimateHealthCost
                    ? this.spinnerService.show(SpinnerEvent.DEMOGRAPHICS_LOADING)
                    : this.spinnerService.hide(SpinnerEvent.DEMOGRAPHICS_LOADING);
            }
        }));
    }
    ngOnChanges(changes) {
        if (changes.toggleYesText?.currentValue !== changes.toggleYesText?.previousValue ||
            changes.toggleNoText?.currentValue !== changes.toggleNoText?.previousValue) {
            this.healthCostItems = [
                { display: this.toggleYesText, value: true },
                { display: this.toggleNoText, value: false }
            ];
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    onToggle(event) {
        // showHealthCostCustomizationTable will be set to true when clicking again the toogle,
        // so we need to update saveEstimateHealthCost because we opted to avoid health cost customization
        if (!event?.data?.value) {
            this.memberSessionService.saveEstimateHealthCost(EstimateHealthCostFlag.OptOut);
        }
        else if (this.estimateHealthCost === EstimateHealthCostFlag.OptOut) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PREF_HEALTHCOST_CALC_OPEN);
            this.memberSessionService.saveEstimateHealthCost(EstimateHealthCostFlag.Default);
            this.updateEstimateHealthCost.emit(EstimateHealthCostFlag.Default);
        }
        else {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PREF_HEALTHCOST_CALC_OPEN);
        }
        this.showHealthCostCustomizationTable = event?.data?.value;
        this.guidedHelpService.setIsHealthCostEstimateSelected(this.showHealthCostCustomizationTable);
    }
}
HealthCostCustomizationComponent.ɵfac = function HealthCostCustomizationComponent_Factory(t) { return new (t || HealthCostCustomizationComponent)(i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(AnalyticsService)); };
HealthCostCustomizationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HealthCostCustomizationComponent, selectors: [["vnext-health-cost-customization"]], inputs: { healthCostsBodyText: "healthCostsBodyText", keyNameForLiveEdit: "keyNameForLiveEdit", toggleYesText: "toggleYesText", toggleNoText: "toggleNoText", healthCostsBenefitsBodyText: "healthCostsBenefitsBodyText", healthCostsBenefitsTableHeader: "healthCostsBenefitsTableHeader", healthCostsUsageTableHeader: "healthCostsUsageTableHeader", healthCostsDaysTableHeader: "healthCostsDaysTableHeader", healthCostsRestoreDefaultsText: "healthCostsRestoreDefaultsText", healthCostsUpdateAnswersText: "healthCostsUpdateAnswersText", healthCostsSaveAnswersText: "healthCostsSaveAnswersText", estimateHealthCost: "estimateHealthCost", healthCostsBenefits: "healthCostsBenefits", saveFailedText: "saveFailedText", saveSuccessText: "saveSuccessText" }, outputs: { updateEstimateHealthCost: "updateEstimateHealthCost" }, features: [i0.ɵɵNgOnChangesFeature], decls: 5, vars: 6, consts: [[1, "container", "pl-md-0", "mt-5"], ["class", "Spa_Style_Bold_Weight Spa_Style_Small_Font col px-0 text-md-left text-center", 4, "liveEditProp"], [1, "col-6", "col-md-4", "mx-auto", "mx-md-0", "px-0"], [3, "selectedValue", "items", "buttonHeight", "disabledBlurEvent", "optionSelected"], ["class", "container pl-md-0 mt-4", 4, "ngIf"], [1, "Spa_Style_Bold_Weight", "Spa_Style_Small_Font", "col", "px-0", "text-md-left", "text-center"], [1, "container", "pl-md-0", "mt-4"], [3, "healthCostsBenefitsBodyText", "healthCostsBenefitsTableHeader", "healthCostsUsageTableHeader", "healthCostsDaysTableHeader", "healthCostsRestoreDefaultsText", "healthCostsUpdateAnswersText", "healthCostsSaveAnswersText", "healthCostsBenefits", "estimateHealthCost", "saveFailedText", "saveSuccessText"]], template: function HealthCostCustomizationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, HealthCostCustomizationComponent_h2_1_Template, 3, 1, "h2", 1);
        i0.ɵɵelementStart(2, "div", 2)(3, "vnext-toggle-select", 3);
        i0.ɵɵlistener("optionSelected", function HealthCostCustomizationComponent_Template_vnext_toggle_select_optionSelected_3_listener($event) { return ctx.onToggle($event); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(4, HealthCostCustomizationComponent_div_4_Template, 2, 11, "div", 4);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", ctx.keyNameForLiveEdit);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("selectedValue", ctx.selectedOption)("items", ctx.healthCostItems)("buttonHeight", "36px")("disabledBlurEvent", true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showHealthCostCustomizationTable);
    } }, dependencies: [i1$2.NgIf, ToggleSelectComponent, LiveEditPropDirective, HealthCostCustomizationTableComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HealthCostCustomizationComponent, [{
        type: Component,
        args: [{ selector: 'vnext-health-cost-customization', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container pl-md-0 mt-5\">\r\n  <h2 class=\"Spa_Style_Bold_Weight Spa_Style_Small_Font col px-0 text-md-left text-center\" *liveEditProp=\"keyNameForLiveEdit\">\r\n    <span>\r\n      {{ healthCostsBodyText }}\r\n    </span>\r\n  </h2>\r\n  <div class=\"col-6 col-md-4 mx-auto mx-md-0 px-0\">\r\n    <vnext-toggle-select\r\n      [selectedValue]=\"selectedOption\"\r\n      [items]=\"healthCostItems\"\r\n      [buttonHeight]=\"'36px'\"\r\n      (optionSelected)=\"onToggle($event)\"\r\n      [disabledBlurEvent]=\"true\"\r\n    >\r\n    </vnext-toggle-select>\r\n  </div>\r\n</div>\r\n<div class=\"container pl-md-0 mt-4\" *ngIf=\"showHealthCostCustomizationTable\">\r\n  <vnext-health-cost-customization-table\r\n    [healthCostsBenefitsBodyText]=\"healthCostsBenefitsBodyText\"\r\n    [healthCostsBenefitsTableHeader]=\"healthCostsBenefitsTableHeader\"\r\n    [healthCostsUsageTableHeader]=\"healthCostsUsageTableHeader\"\r\n    [healthCostsDaysTableHeader]=\"healthCostsDaysTableHeader\"\r\n    [healthCostsRestoreDefaultsText]=\"healthCostsRestoreDefaultsText\"\r\n    [healthCostsUpdateAnswersText]=\"healthCostsUpdateAnswersText\"\r\n    [healthCostsSaveAnswersText]=\"healthCostsSaveAnswersText\"\r\n    [healthCostsBenefits]=\"healthCostsBenefits\"\r\n    [estimateHealthCost]=\"estimateHealthCost\"\r\n    [saveFailedText]=\"saveFailedText\"\r\n    [saveSuccessText]=\"saveSuccessText\"\r\n  ></vnext-health-cost-customization-table>\r\n</div>\r\n" }]
    }], function () { return [{ type: i1.MemberSessionService }, { type: i1.SpinnerService }, { type: i1.GuidedHelpService }, { type: AnalyticsService }]; }, { healthCostsBodyText: [{
            type: Input
        }], keyNameForLiveEdit: [{
            type: Input
        }], toggleYesText: [{
            type: Input
        }], toggleNoText: [{
            type: Input
        }], healthCostsBenefitsBodyText: [{
            type: Input
        }], healthCostsBenefitsTableHeader: [{
            type: Input
        }], healthCostsUsageTableHeader: [{
            type: Input
        }], healthCostsDaysTableHeader: [{
            type: Input
        }], healthCostsRestoreDefaultsText: [{
            type: Input
        }], healthCostsUpdateAnswersText: [{
            type: Input
        }], healthCostsSaveAnswersText: [{
            type: Input
        }], estimateHealthCost: [{
            type: Input
        }], healthCostsBenefits: [{
            type: Input
        }], saveFailedText: [{
            type: Input
        }], saveSuccessText: [{
            type: Input
        }], updateEstimateHealthCost: [{
            type: Output
        }] }); })();

function HealthComponent_h1_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.healthPageProperties.header);
} }
function HealthComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r1.healthPageProperties.body, "html"), i0.ɵɵsanitizeHtml);
} }
function HealthComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "vnext-health-cost-customization", 10);
    i0.ɵɵlistener("updateEstimateHealthCost", function HealthComponent_div_8_Template_vnext_health_cost_customization_updateEstimateHealthCost_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.updateEstimateHealthCost.emit($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("toggleYesText", ctx_r2.toggleYesText)("toggleNoText", ctx_r2.toggleNoText)("healthCostsBodyText", ctx_r2.healthCostsBodyText)("healthCostsBenefitsBodyText", ctx_r2.healthCostsBenefitsBodyText)("healthCostsBenefitsTableHeader", ctx_r2.healthCostsBenefitsTableHeader)("healthCostsUsageTableHeader", ctx_r2.healthCostsUsageTableHeader)("healthCostsDaysTableHeader", ctx_r2.healthCostsDaysTableHeader)("healthCostsRestoreDefaultsText", ctx_r2.healthCostsRestoreDefaultsText)("healthCostsUpdateAnswersText", ctx_r2.healthCostsUpdateAnswersText)("healthCostsSaveAnswersText", ctx_r2.healthCostsSaveAnswersText)("healthCostsBenefits", ctx_r2.healthCostsBenefits)("estimateHealthCost", ctx_r2.estimateHealthCost)("keyNameForLiveEdit", "Spa_HealthCosts_Body_Text")("saveFailedText", ctx_r2.saveFailedText)("saveSuccessText", ctx_r2.saveSuccessText);
} }
class HealthComponent {
    constructor(guidedHelpService) {
        this.guidedHelpService = guidedHelpService;
        this.healthCostsCustomizationEnabled = false;
        this.updateEstimateHealthCost = new EventEmitter();
    }
    get healthLink() {
        return this.guidedHelpService.links.find(link => link.pageTag === PageTags.GUIDED_HELP_HEALTH);
    }
}
HealthComponent.ɵfac = function HealthComponent_Factory(t) { return new (t || HealthComponent)(i0.ɵɵdirectiveInject(i1.GuidedHelpService)); };
HealthComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HealthComponent, selectors: [["vnext-health"]], inputs: { guidedHelpHealthAgeQuestionText: "guidedHelpHealthAgeQuestionText", slideSections: "slideSections", healthStatusSliderLabel: "healthStatusSliderLabel", healthCostsCustomizationEnabled: "healthCostsCustomizationEnabled", healthCostsBodyText: "healthCostsBodyText", toggleYesText: "toggleYesText", toggleNoText: "toggleNoText", healthCostsBenefitsBodyText: "healthCostsBenefitsBodyText", healthCostsBenefitsTableHeader: "healthCostsBenefitsTableHeader", healthCostsUsageTableHeader: "healthCostsUsageTableHeader", healthCostsDaysTableHeader: "healthCostsDaysTableHeader", healthCostsRestoreDefaultsText: "healthCostsRestoreDefaultsText", healthCostsUpdateAnswersText: "healthCostsUpdateAnswersText", healthCostsSaveAnswersText: "healthCostsSaveAnswersText", estimateHealthCost: "estimateHealthCost", healthCostsBenefits: "healthCostsBenefits", healthPageProperties: "healthPageProperties", saveFailedText: "saveFailedText", saveSuccessText: "saveSuccessText" }, outputs: { updateEstimateHealthCost: "updateEstimateHealthCost" }, decls: 9, vars: 9, consts: [[1, "text-center"], ["class", "Spa_Style_H1", 4, "liveEditProp"], ["class", "Spa_Style_IntroParagraph", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [1, "mx-md-0", "mx-4", "mt-5"], [3, "slideSections", "healthStatusSliderLabel"], [1, "mb-5"], [3, "healthAgeQuestionText"], ["class", "mb-5", 4, "ngIf"], [1, "Spa_Style_H1"], ["navigationAdapter", "", 1, "Spa_Style_IntroParagraph", 3, "innerHtml"], [3, "toggleYesText", "toggleNoText", "healthCostsBodyText", "healthCostsBenefitsBodyText", "healthCostsBenefitsTableHeader", "healthCostsUsageTableHeader", "healthCostsDaysTableHeader", "healthCostsRestoreDefaultsText", "healthCostsUpdateAnswersText", "healthCostsSaveAnswersText", "healthCostsBenefits", "estimateHealthCost", "keyNameForLiveEdit", "saveFailedText", "saveSuccessText", "updateEstimateHealthCost"]], template: function HealthComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "i");
        i0.ɵɵtemplate(2, HealthComponent_h1_2_Template, 2, 1, "h1", 1);
        i0.ɵɵtemplate(3, HealthComponent_div_3_Template, 2, 4, "div", 2);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelement(5, "vnext-health-slider", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelement(7, "vnext-guided-help-age-select", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, HealthComponent_div_8_Template, 2, 15, "div", 7);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1(" fas ", ctx.healthLink.iconClass, "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", ctx.healthLink.resourceKeyName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_Health_Body_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("slideSections", ctx.slideSections)("healthStatusSliderLabel", ctx.healthStatusSliderLabel);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("healthAgeQuestionText", ctx.guidedHelpHealthAgeQuestionText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.healthCostsCustomizationEnabled);
    } }, dependencies: [i1$2.NgIf, NavigationAdapterDirective, LiveEditPropDirective, GuidedHelpAgeSelectComponent, HealthSliderComponent, HealthCostCustomizationComponent, SafePipe], styles: ["i[_ngcontent-%COMP%]{font-size:46px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HealthComponent, [{
        type: Component,
        args: [{ selector: 'vnext-health', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"text-center\">\r\n  <i class=\" fas {{ healthLink.iconClass }}\"></i>\r\n  <h1 class=\"Spa_Style_H1\" *liveEditProp=\"healthLink.resourceKeyName\">{{ healthPageProperties.header }}</h1>\r\n  <div\r\n    *liveEditProp=\"'Spa_Site_Health_Body_Text'\"\r\n    class=\"Spa_Style_IntroParagraph\"\r\n    [innerHtml]=\"healthPageProperties.body | safe: 'html'\"\r\n    navigationAdapter\r\n  ></div>\r\n  <div class=\"mx-md-0 mx-4 mt-5\">\r\n    <vnext-health-slider [slideSections]=\"slideSections\" [healthStatusSliderLabel]=\"healthStatusSliderLabel\"></vnext-health-slider>\r\n  </div>\r\n  <div class=\"mb-5\">\r\n    <vnext-guided-help-age-select [healthAgeQuestionText]=\"guidedHelpHealthAgeQuestionText\"> </vnext-guided-help-age-select>\r\n  </div>\r\n  <div class=\"mb-5\" *ngIf=\"healthCostsCustomizationEnabled\">\r\n    <vnext-health-cost-customization\r\n      [toggleYesText]=\"toggleYesText\"\r\n      [toggleNoText]=\"toggleNoText\"\r\n      [healthCostsBodyText]=\"healthCostsBodyText\"\r\n      [healthCostsBenefitsBodyText]=\"healthCostsBenefitsBodyText\"\r\n      [healthCostsBenefitsTableHeader]=\"healthCostsBenefitsTableHeader\"\r\n      [healthCostsUsageTableHeader]=\"healthCostsUsageTableHeader\"\r\n      [healthCostsDaysTableHeader]=\"healthCostsDaysTableHeader\"\r\n      [healthCostsRestoreDefaultsText]=\"healthCostsRestoreDefaultsText\"\r\n      [healthCostsUpdateAnswersText]=\"healthCostsUpdateAnswersText\"\r\n      [healthCostsSaveAnswersText]=\"healthCostsSaveAnswersText\"\r\n      [healthCostsBenefits]=\"healthCostsBenefits\"\r\n      [estimateHealthCost]=\"estimateHealthCost\"\r\n      [keyNameForLiveEdit]=\"'Spa_HealthCosts_Body_Text'\"\r\n      [saveFailedText]=\"saveFailedText\"\r\n      [saveSuccessText]=\"saveSuccessText\"\r\n      (updateEstimateHealthCost)=\"updateEstimateHealthCost.emit($event)\"\r\n    >\r\n    </vnext-health-cost-customization>\r\n  </div>\r\n</div>\r\n", styles: ["i{font-size:46px}\n"] }]
    }], function () { return [{ type: i1.GuidedHelpService }]; }, { guidedHelpHealthAgeQuestionText: [{
            type: Input
        }], slideSections: [{
            type: Input
        }], healthStatusSliderLabel: [{
            type: Input
        }], healthCostsCustomizationEnabled: [{
            type: Input
        }], healthCostsBodyText: [{
            type: Input
        }], toggleYesText: [{
            type: Input
        }], toggleNoText: [{
            type: Input
        }], healthCostsBenefitsBodyText: [{
            type: Input
        }], healthCostsBenefitsTableHeader: [{
            type: Input
        }], healthCostsUsageTableHeader: [{
            type: Input
        }], healthCostsDaysTableHeader: [{
            type: Input
        }], healthCostsRestoreDefaultsText: [{
            type: Input
        }], healthCostsUpdateAnswersText: [{
            type: Input
        }], healthCostsSaveAnswersText: [{
            type: Input
        }], estimateHealthCost: [{
            type: Input
        }], healthCostsBenefits: [{
            type: Input
        }], healthPageProperties: [{
            type: Input
        }], saveFailedText: [{
            type: Input
        }], saveSuccessText: [{
            type: Input
        }], updateEstimateHealthCost: [{
            type: Output
        }] }); })();

function GuidedHelpComponent_div_4_vnext_get_started_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-get-started", 19);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tagsToUpdate", ctx_r4.tagsToUpdate)("saveDefaultValues", ctx_r4.analyticsService.isDefaultTagToUpdate)("optionalLabel", ctx_r4.Spa_GuidedHelp_OptionalLabel_Text)("zipCodeInputZipCodeError", ctx_r4.Spa_Site_ZipCodeInput_ZipCodeError)("zipCodeInputCountyError", ctx_r4.Spa_Site_ZipCodeInput_CountyError)("zipCodeInputSelectCounty", ctx_r4.Spa_Site_ZipCodeInput_SelectCounty)("zipCodeInputZipCodeLabel", ctx_r4.Spa_Site_ZipCodeInput_ZipCodeLabel)("selectedCountyEnabled", ctx_r4.Spa_Site_ZipCodeInput_SelectedCountyEnabled)("zipCodeInputEditCounty", ctx_r4.Spa_Site_ZipCodeInput_EditCounty)("errorKeywordText", ctx_r4.Spa_Site_ErrorKeyword_Text)("getStartedText", ctx_r4.Spa_Site_GetStarted_Text)("medicalOnlyDefault", ctx_r4.Spa_GuidedHelp_MedicalOnly_Default)("coverageTextQuestion", ctx_r4.Spa_GuidedHelp_GettingStarted_CoverageText_Question)("spaPageSubHeader", ctx_r4.Spa_Site_PageSubHeader_Text)("accordionHeaderText", ctx_r4.Spa_GettingStarted_SubsidyHeader_Text)("showSubsidyAccordion", ctx_r4.Spa_GettingStarted_ShowSubsidyAccordion_Flag)("enableDSNPDisplay", ctx_r4.Spa_GettingStarted_EnableDSNPDisplay_Flag)("zipCodeIsReadOnly", i0.ɵɵpipeBind1(1, 23, ctx_r4.ssoPopulatedFieldService.isFieldReadOnly$("Demographic.ZipCode")))("zipCodeHintText", ctx_r4.Spa_GuidedHelp_GetStarted_ZipCode_Text)("countyLabel", ctx_r4.Spa_ZipCodeInput_CountyLabel_Text)("showCountyLabel", ctx_r4.Spa_ZipCodeInput_CountyLabel_Enabled)("defaultCoverageTypes", ctx_r4.Spa_GuidedHelp_GettingStarted_CoverageTypes)("isMobile", ctx_r4.isMobile);
} }
function GuidedHelpComponent_div_4_vnext_widget_drug_search_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-drug-search", 20);
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tagsToUpdate", ctx_r5.tagsToUpdate)("saveDefaultValues", ctx_r5.analyticsService.isDefaultTagToUpdate)("frequencyList", ctx_r5.drugSearchFrequencyList)("contentSectionText", ctx_r5.Spa_DrugSearch_Content_Section_Text)("dosageHeader", ctx_r5.Spa_DrugSearch_Dosage_Header)("quantityAndFrequencyHeader", ctx_r5.Spa_DrugSearch_Frequency_Header)("packageHeader", ctx_r5.Spa_DrugSearch_Package_Header)("addButtonText", ctx_r5.Spa_DrugSearch_Add_Button)("cancelButtonText", ctx_r5.Spa_DrugSearch_Cancel_Button)("quantityMaxLimit", ctx_r5.Spa_DrugSearch_Quantity_Max_Limit)("medicineCabinetLimit", ctx_r5.Spa_DrugSearch_Cabinet_Limit)("cabinetLimitErrorMessage", ctx_r5.Spa_DrugSearch_MaxCount_Error_Message)("quantityErrorMessage", ctx_r5.Spa_DrugSearch_Quantity_Error_Message)("placeholder", ctx_r5.Spa_DrugSearch_Hint_Text)("drugSearchText", ctx_r5.Spa_DrugSearch_Label_Text)("drugsImage", ctx_r5.Spa_DrugSearch_Drugs_Image)("inCabinetErrorMessage", ctx_r5.Spa_DrugSearch_InCabinetError_Text)("medCabinetHeader", ctx_r5.Spa_DrugSearch_Medicine_Header)("genericOptionIcon", ctx_r5.Spa_DrugSearch_GenericOption_Icon)("showGenericOption", ctx_r5.Spa_Site_Show_GenericDrugOption)("genericOptionQuestion", ctx_r5.Spa_DrugSearch_GenericOption_Question)("genericOptionInfo", ctx_r5.Spa_DrugSearch_GenericOption_Info)("genericOptions", ctx_r5.Spa_DrugSearch_GenericOptions)("checkDrugCoverageButtonText", ctx_r5.Spa_DrugSearch_CheckDrugCoverageButton_Text)("genericOptionDefaultSelection", ctx_r5.Spa_DrugSearch_GenericOption_Default_Selection)("showCosts", ctx_r5.Spa_DrugListCard_HideCosts_Flag)("drugSearchIntroText", ctx_r5.Spa_DrugSearch_Intro_Text)("drugSearchPageHeaderText", ctx_r5.Spa_DrugSearch_PageHeader_Text)("errorKeywordText", ctx_r5.Spa_Site_ErrorKeyword_Text)("drugSearchFrequencyListBoxLabel", ctx_r5.Spa_DrugSearch_Frequency_ListBox_Label)("prescriptionsText", ctx_r5.Spa_Site_Prescriptions_Text)("isBlueButtonEnabled", ctx_r5.Spa_Site_Enable_BlueButton)("blueButtonStartAddingDrugText", ctx_r5.Spa_BlueButton_StartAddDrug_Text)("orText", ctx_r5.Spa_Site_OrText)("blueButtonConnectToMyMedicareText", ctx_r5.Spa_BlueButton_MyMedicare_Connect_Text)("blueButtonMyMedicareButtonText", ctx_r5.Spa_BlueButton_MyMedicare_Button)("emailLabelText", ctx_r5.Spa_Site_EmailAddress_Text)("emailRequiredErrorText", ctx_r5.Spa_Profile_EmailRequired_Error)("emailInvalidErrorText", ctx_r5.Spa_Profile_EmailInvalid_Error)("sendEmailButtonText", ctx_r5.Spa_Site_SendEmailButton_Text)("blueButtonModalHeaderText", ctx_r5.Spa_BlueButton_Modal_Header)("blueButtonModalContent", ctx_r5.Spa_BlueButton_Modal_Content)("blueButtonSuccessText", ctx_r5.Spa_BlueButton_Success_Text)("blueButtonDownloadText", ctx_r5.Spa_BlueButton_Download_Text)("blueButtonSuccessMessage", ctx_r5.Spa_BlueButton_Success_Message)("blueButtonEmailSendText", ctx_r5.Spa_BlueButton_EmailSentToStatus_Text)("blueButtonIssueLoadingText", ctx_r5.Spa_BlueButton_Issue_Loading_Text)("blueButtonBeneficiaryDeniedText", ctx_r5.Spa_BlueButton_Beneficiary_Denied_Text)("blueButtonErrorLoadingText", ctx_r5.Spa_BlueButton_Error_Loading_Text)("blueButtonBeneficiaryEmailDetails", ctx_r5.Spa_BlueButton_Beneficiary_Email_Details)("blueButtonImportLatestPrescriptionButtonText", ctx_r5.Spa_BlueButton_ImportLatestPrescription_Button_Text)("blueButtonImportLatestPrescriptionErrorText", ctx_r5.Spa_BlueButton_ImportLatestPrescription_Error_Text)("blueButtonAccessDeniedText", ctx_r5.Spa_BlueButton_AccessDenied_Error_Text)("blueButtonClaimDataLoadingErrorText", ctx_r5.Spa_BlueButton_ClaimData_Loading_Error_Text)("isMemberSessionUpdated", ctx_r5.isMemberSessionUpdated)("editDrugText", ctx_r5.Spa_DrugSearch_EditDrug_Button)("isUseCMSDrugFlagEnabled", ctx_r5.Spa_Drugs_UseCMSDrugFlag_Enabled);
} }
function GuidedHelpComponent_div_4_vnext_widget_pharmacy_search_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-pharmacy-search", 21);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tagsToUpdate", ctx_r6.tagsToUpdate)("digitalPharmacyEnabled", ctx_r6.Spa_Site_Digital_Pharmacy_Enabled)("retailTabText", ctx_r6.Spa_Pharmacy_Retail_Tab_Text)("digitalTabText", ctx_r6.Spa_Pharmacy_Digital_Tab_Text)("digitalTabIntroText", ctx_r6.Spa_Pharmacy_Digital_Tab_Intro_Text)("saveDefaultValues", ctx_r6.analyticsService.isDefaultTagToUpdate)("addPharmacyButtonText", ctx_r6.Spa_Add_Pharmacy_Button)("pharmacyLimit", ctx_r6.Spa_Pharmacy_Limit)("pharmacyMapDefaultZoom", ctx_r6.Spa_PharmacyMap_Default_Zoom)("maxZoom", ctx_r6.Spa_PharmacyMap_Max_Zoom)("minZoom", ctx_r6.Spa_PharmacyMap_Min_Zoom)("currentPharmacyText", ctx_r6.Spa_Site_Multi_Pharmacy_Enabled ? ctx_r6.Spa_Site_AddPharmacy_YourMultiPharmacyText : ctx_r6.Spa_AddPharmacy_YourPharmacyText)("pharmacyAddedLabel", ctx_r6.Spa_Pharmacy_Added_Label)("electronicPrescriptionTooltipHeader", ctx_r6.Spa_Site_ElectronicPrescription_ToolTipHeader)("electronicPrescriptionTooltipBody", ctx_r6.Spa_Site_ElectronicPrescription_ToolTipBody)("itemsPerPage", ctx_r6.Spa_PharmacySearch_Pagination_ItemsPerPage)("pharmacyPaginationEnabled", ctx_r6.Spa_PharmacySearch_Pagination_Enabled)("paginationText", ctx_r6.Spa_PharmacySearch_Pagination_View_Text)("viewNotFoundHeaderText", ctx_r6.Spa_Pharmacy_Alt_View_Not_Found_Header_Text)("viewNotFoundBodyText", ctx_r6.Spa_Pharmacy_Alt_View_Not_Found_Body_Text)("preferredInNetworkText", ctx_r6.Spa_Site_Preferred_In_Network_Text)("standardInNetworkText", ctx_r6.Spa_Site_Standard_In_Network_Text)("preferredInNetworkTooltipContent", ctx_r6.Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text)("standardInNetworkTooltipContent", ctx_r6.Spa_PharmacySearch_Standard_In_Network_Tooltip_Text)("pharmacySearchIntroText", ctx_r6.Spa_Site_Multi_Pharmacy_Enabled ? ctx_r6.Spa_PharmacySearch_MultiPharmacy_Intro_Text : ctx_r6.Spa_PharmacySearch_Intro_Text)("pharmacySearchHeaderText", ctx_r6.Spa_PharmacySearch_PageHeader_Text)("errorKeywordText", ctx_r6.Spa_Site_ErrorKeyword_Text)("addedPharmacyText", ctx_r6.Spa_Site_Pharmacy_Added_Text)("addPharmacyText", ctx_r6.Spa_Site_Pharmacy_Add_Text)("pharmacyText", ctx_r6.Spa_Site_Pharmacy_Text)("ePrescribingAltText", ctx_r6.Spa_Site_EPrescribing_Alt_Text)("Spa_Site_Tooltip_Text", ctx_r6.Spa_Site_Tooltip_Text)("zipLabel", ctx_r6.Spa_Site_ZipCodeInput_ZipCodeLabel)("zipErrorText", ctx_r6.Spa_Site_ZipCodeInput_ZipCodeError)("pharmacySearchButtonText", ctx_r6.Spa_Site_SearchButton_Text)("pharmacyNameText", ctx_r6.Spa_PharmacyName_Text)("pharmacyNameHintText", ctx_r6.Spa_PharmacyName_HintText)("multiPharmacyEnabled", ctx_r6.Spa_Site_Multi_Pharmacy_Enabled)("maxPharmacyCount", ctx_r6.Spa_Site_Maximum_Pharmacy_Count)("setAsPrimaryLinkText", ctx_r6.Spa_Site_Set_Primary_Pharmacy_Link_Text)("primaryPharmacyText", ctx_r6.Spa_Site_Primary_Pharmacy_Text)("pharmacyLimitErrorMessage", ctx_r6.pharmacyLimitCountErrorMessage)("pharmacyFilterText", ctx_r6.Spa_Filter_Header_Text)("isPharmacyFilterEnabled", ctx_r6.Spa_Site_Pharmacy_Filter_Enabled)("isPharmacyInNetworkFilterEnabled", ctx_r6.Spa_Site_Pharmacy_In_Network_Filter_Enabled)("isPharmacyOtherFilterEnabled", ctx_r6.Spa_Site_Pharmacy_Other_Filter_Enabled)("pharmacyFilterClearText", ctx_r6.Spa_Filter_Clear_All)("pharmacyFilterData", ctx_r6.Spa_Pharmacy_Filters)("defaultFilterText", ctx_r6.Spa_Filter_Default_Filter_Text)("isPPCSite", ctx_r6.isPPCSite())("clearAllText", ctx_r6.Spa_Filter_Clear_All)("filterHeaderText", ctx_r6.Spa_Filter_Header_Text)("modalCancelButtonText", ctx_r6.Spa_PlanFilters_Modal_Cancel_Button)("modalApplyButtonText", ctx_r6.Spa_PlanFilters_Modal_Apply_Button)("countyLabel", ctx_r6.Spa_ZipCodeInput_CountyLabel_Text)("showCountyLabel", ctx_r6.Spa_ZipCodeInput_CountyLabel_Enabled)("pharmacyInNetworkFilters", ctx_r6.Spa_Pharmacy_In_Network_Filters);
} }
function GuidedHelpComponent_div_4_vnext_health_5_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-health", 22);
    i0.ɵɵlistener("updateEstimateHealthCost", function GuidedHelpComponent_div_4_vnext_health_5_Template_vnext_health_updateEstimateHealthCost_0_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.updateEstimateHealthCost($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tagsToUpdate", ctx_r7.tagsToUpdate)("estimateHealthCost", ctx_r7.estimateHealthCost)("saveDefaultValues", ctx_r7.analyticsService.isDefaultTagToUpdate)("guidedHelpHealthAgeQuestionText", ctx_r7.Spa_GuidedHelp_Health_AgeQuestion_Text)("slideSections", ctx_r7.slideSections)("healthPageProperties", ctx_r7.healthPageProperties)("healthStatusSliderLabel", ctx_r7.Spa_Site_Health_Slider_Label_Text)("healthCostsCustomizationEnabled", ctx_r7.Spa_Site_HealthCosts_Customization_Enabled)("healthCostsBodyText", ctx_r7.Spa_HealthCosts_Body_Text)("toggleYesText", ctx_r7.toggleYesText)("toggleNoText", ctx_r7.toggleNoText)("healthCostsBenefitsBodyText", ctx_r7.Spa_HealthCosts_Benefits_Body_Text)("healthCostsBenefitsTableHeader", ctx_r7.Spa_Site_HealthCosts_Benefits_Table_Header)("healthCostsUsageTableHeader", ctx_r7.Spa_Site_HealthCosts_Usage_Table_Header)("healthCostsDaysTableHeader", ctx_r7.Spa_Site_HealthCosts_Days_Table_Header)("healthCostsRestoreDefaultsText", ctx_r7.Spa_Site_HealthCosts_Restore_Defaults_Text)("healthCostsUpdateAnswersText", ctx_r7.Spa_Site_HealthCosts_Update_Answers_Text)("healthCostsSaveAnswersText", ctx_r7.Spa_Site_HealthCosts_Save_Answers_Text)("healthCostsBenefits", ctx_r7.Spa_Site_HealthCosts_Benefits_JSON)("saveFailedText", ctx_r7.Spa_Site_HealthCosts_Save_Failed_Text)("saveSuccessText", ctx_r7.Spa_Site_HealthCosts_Save_Success_Text);
} }
function GuidedHelpComponent_div_4_vnext_widget_provider_search_6_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-widget-provider-search", 23);
    i0.ɵɵlistener("fetchProvidersFromLocation", function GuidedHelpComponent_div_4_vnext_widget_provider_search_6_Template_vnext_widget_provider_search_fetchProvidersFromLocation_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r12.fetchProvidersFromLocation($event)); })("setMapCenter", function GuidedHelpComponent_div_4_vnext_widget_provider_search_6_Template_vnext_widget_provider_search_setMapCenter_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r14.mapFacade.setCenterPosition($event)); })("initializeMap", function GuidedHelpComponent_div_4_vnext_widget_provider_search_6_Template_vnext_widget_provider_search_initializeMap_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r15 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r15.mapFacade.initializeMap($event)); })("setMapDefaultBounds", function GuidedHelpComponent_div_4_vnext_widget_provider_search_6_Template_vnext_widget_provider_search_setMapDefaultBounds_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r16 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r16.mapContextService.setDefaultBounds($event)); })("addProviders", function GuidedHelpComponent_div_4_vnext_widget_provider_search_6_Template_vnext_widget_provider_search_addProviders_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.providerFacade.addProviders($event)); })("addProviderSelectedFromMarker", function GuidedHelpComponent_div_4_vnext_widget_provider_search_6_Template_vnext_widget_provider_search_addProviderSelectedFromMarker_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r18 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r18.providerFacade.addProviderSelectedFromMarker($event)); })("fetchProvidersFromAPI", function GuidedHelpComponent_div_4_vnext_widget_provider_search_6_Template_vnext_widget_provider_search_fetchProvidersFromAPI_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r19 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r19.providerFacade.fetchProvidersFromAPI($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tagsToUpdate", ctx_r8.tagsToUpdate)("saveDefaultValues", ctx_r8.analyticsService.isDefaultTagToUpdate)("providersText", ctx_r8.Spa_Site_Providers_Text)("providersBodyText", ctx_r8.Spa_Site_Providers_Body_Text)("providersMultiBodyText", ctx_r8.Spa_Multi_Providers_Body_Text)("errorKeywordText", ctx_r8.Spa_Site_ErrorKeyword_Text)("zipLabel", ctx_r8.Spa_Site_ZipCodeInput_ZipCodeLabel)("zipErrorText", ctx_r8.Spa_Site_ZipCodeInput_ZipCodeError)("providerNameText", ctx_r8.Spa_ProviderName_Text)("providerNameHintText", ctx_r8.Spa_ProviderName_HintText)("providerSearchButtonText", ctx_r8.Spa_Site_SearchButton_Text)("providerLimit", ctx_r8.Spa_Provider_Limit)("itemsPerPage", ctx_r8.Spa_ProviderSearch_Pagination_ItemsPerPage)("providerPaginationEnabled", ctx_r8.Spa_ProviderSearch_Pagination_Enabled)("viewNotFoundHeaderText", ctx_r8.Spa_Provider_Alt_View_Not_Found_Header_Text)("viewNotFoundBodyText", ctx_r8.Spa_Provider_Alt_View_Not_Found_Body_Text)("paginationText", ctx_r8.Spa_ProviderSearch_Pagination_View_Text)("maxZoom", ctx_r8.Spa_ProviderMap_Max_Zoom)("minZoom", ctx_r8.Spa_ProviderMap_Min_Zoom)("providerMapDefaultZoom", ctx_r8.Spa_ProviderMap_Default_Zoom)("addProviderText", ctx_r8.Spa_Provider_Add_Text)("providerAddedText", ctx_r8.Spa_Provider_Added_Text)("maxCount", ctx_r8.addProviderMaxLimit.MAX_COUNT)("maxCountErrorMessage", ctx_r8.providerMaxLimitError)("yourProviderText", ctx_r8.Spa_Provider_YourProvider_Text)("removeProviderText", ctx_r8.Spa_Provider_RemoveProvider_Text)("setPrimaryCareProviderText", ctx_r8.Spa_Provider_Set_Primary_Care_Provider_Text)("primaryCareProviderText", ctx_r8.Spa_Provider_Primary_Care_Provider_Text)("providerFiltersEnabled", ctx_r8.Spa_Providers_Filter_Enabled)("providerFilters", ctx_r8.providerFilters)("providerGroupAddedLabelText", ctx_r8.Spa_Group_Provider_Added_Text)("providerGroupAddLabelText", ctx_r8.Spa_Group_Provider_Add_Text)("countyLabel", ctx_r8.Spa_ZipCodeInput_CountyLabel_Text)("showCountyLabel", ctx_r8.Spa_ZipCodeInput_CountyLabel_Enabled)("addLinkText", ctx_r8.Spa_Site_Add)("cancelProvidersLabel", ctx_r8.Spa_Site_Cancel)("providerSingleSelectEnabled", ctx_r8.Spa_Select_Single_Provider_For_Multi_Address_Enabled)("selectProviderLabelText", ctx_r8.Spa_Select_Provider_Location_Text)("providerExistsTooltipText", ctx_r8.Spa_Provider_Exists_Text)("providerMultiLocationText", ctx_r8.Spa_Provider_Multiple_Location_Text)("countryCode", ctx_r8.countryCode)("providerLocationsText", ctx_r8.Spa_Plan_Providers_Locations_Link_Text)("valueBasedCareEnabled", ctx_r8.Spa_Site_ValueBasedCare_Enabled)("valueBasedCareIcon", ctx_r8.Spa_Site_ValueBasedCare_Icon)("valueBasedCareText", ctx_r8.Spa_Site_ValueBasedCare_Text)("generalPracticeOptions", ctx_r8.Spa_Provider_Search_Filter_General_Practice_Options)("generalPracticeToolTipText", ctx_r8.Spa_Provider_Search_General_Practice_Tooltip_Text)("generalPracticeLabel", ctx_r8.Spa_Provider_Search_General_Practice_Label_Text)("generalPracticeFilterOptionEnabled", ctx_r8.Spa_Provider_Search_Filter_General_Practice_Option_Enabled)("singleProviderInListEnabled", ctx_r8.Spa_Provider_Search_ShowSingleProviderInList_Enabled)("updateLinkText", ctx_r8.Spa_Site_Update_Text)("editLinkText", ctx_r8.Spa_Site_Edit_Text)("showEditLinkEnabled", ctx_r8.Spa_Provider_ShowEditLink_Enabled)("valueBasedCareAvailableText", ctx_r8.Spa_ValueBasedCare_Available_Text)("valueBasedCareLearnMoreLink", ctx_r8.Spa_ValueBasedCare_LearnMore_Link)("valueBasedCareLearnMoreText", ctx_r8.Spa_ValueBasedCare_LearnMore_Text)("isValueBasedCareLearnMoreLink2Enabled", ctx_r8.Spa_ValueBasedCare_LearnMoreLink2_Enabled && ctx_r8.Spa_Site_ValueBasedCare_Enabled)("valueBasedCareToggleLabel", ctx_r8.Spa_ValueBasedCare_Toggle_Label)("valueBasedCareToggleToolTipText", ctx_r8.Spa_ValueBasedCare_Toggle_ToolTip_Text)("valueBasedCareToggleEnabled", ctx_r8.Spa_ValueBasedCare_Toggle_Enabled && ctx_r8.Spa_Site_ValueBasedCare_Enabled)("valueBasedCareToggleOptions", ctx_r8.Spa_Provider_Search_Filter_ValueBasedCare_Options)("newPatientToggleEnabled", ctx_r8.Spa_Provider_New_Patient_Toggle_Enabled)("pcpToggleEnabled", ctx_r8.Spa_Primary_Care_Provider_Toggle_Enabled)("newPatientToggleOptions", ctx_r8.Spa_Provider_New_Patient_Options)("newPatientToggleLabel", ctx_r8.Spa_Provider_New_Patient_Toggle_Label)("pcpToggleLabel", ctx_r8.Spa_Primary_Care_Provider_Toggle_Label)("pcpToggleOptions", ctx_r8.Spa_Primary_Care_Provider_Options)("newPatientText", ctx_r8.Spa_New_Patient_For_Provider_Text)("existingPatientText", ctx_r8.Spa_Existing_Patient_For_Provider_Text)("vbcNameFilterEnabled", ctx_r8.Spa_Provider_ValueBasedCare_Name_Filter_Enabled)("vbcNameFilterLabel", ctx_r8.Spa_Provider_ValueBasedCare_Name_Filter_Label)("selectedProviderOptionsEnabled", ctx_r8.Spa_Selected_Provider_Options_Enabled)("removeText", ctx_r8.Spa_Site_Remove_Text)("selectAllText", ctx_r8.Spa_Site_SelectAll_Text)("isZelisIntegrationEnabled", ctx_r8.Spa_Site_ZelisIntegration_Enabled);
} }
function GuidedHelpComponent_div_4_ng_container_7_vnext_guided_help_other_preferences_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-guided-help-other-preferences", 25);
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("preferencesText", ctx_r20.Spa_Site_OtherPreferences_Text)("spaPageSubHeader", ctx_r20.Spa_Site_PageSubHeader_Text)("noQuestionsText", ctx_r20.Spa_GuidedHelp_OtherPreferences_NoQuestions_Text)("availablePages", ctx_r20.availableQuestionPages)("preferencesLink", ctx_r20.preferencesLink)("currentPage", ctx_r20.currentPreferencesPage)("pageCountText", ctx_r20.Spa_OtherPreferences_PageCount_Text)("enterZipText", ctx_r20.Spa_GuidedHelp_OtherPreferences_EnterZip_Text)("provideZipText", ctx_r20.Spa_GuidedHelp_OtherPreferences_ProvideZip_Text)("zipCodeInputZipCodeError", ctx_r20.Spa_Site_ZipCodeInput_ZipCodeError)("zipCodeInputCountyError", ctx_r20.Spa_Site_ZipCodeInput_CountyError)("zipCodeInputSelectCounty", ctx_r20.Spa_Site_ZipCodeInput_SelectCounty)("zipCodeInputZipCodeLabel", ctx_r20.Spa_Site_ZipCodeInput_ZipCodeLabel)("selectedCountyEnabled", ctx_r20.Spa_Site_ZipCodeInput_SelectedCountyEnabled)("zipCodeInputEditCounty", ctx_r20.Spa_Site_ZipCodeInput_EditCounty)("errorKeywordText", ctx_r20.Spa_Site_ErrorKeyword_Text)("countyLabel", ctx_r20.Spa_ZipCodeInput_CountyLabel_Text)("showCountyLabel", ctx_r20.Spa_ZipCodeInput_CountyLabel_Enabled);
} }
function GuidedHelpComponent_div_4_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GuidedHelpComponent_div_4_ng_container_7_vnext_guided_help_other_preferences_1_Template, 1, 18, "vnext-guided-help-other-preferences", 24);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.questionsLoaded);
} }
function GuidedHelpComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementContainerStart(1, 12);
    i0.ɵɵtemplate(2, GuidedHelpComponent_div_4_vnext_get_started_2_Template, 2, 25, "vnext-get-started", 13);
    i0.ɵɵtemplate(3, GuidedHelpComponent_div_4_vnext_widget_drug_search_3_Template, 1, 57, "vnext-widget-drug-search", 14);
    i0.ɵɵtemplate(4, GuidedHelpComponent_div_4_vnext_widget_pharmacy_search_4_Template, 1, 57, "vnext-widget-pharmacy-search", 15);
    i0.ɵɵtemplate(5, GuidedHelpComponent_div_4_vnext_health_5_Template, 1, 21, "vnext-health", 16);
    i0.ɵɵtemplate(6, GuidedHelpComponent_div_4_vnext_widget_provider_search_6_Template, 1, 75, "vnext-widget-provider-search", 17);
    i0.ɵɵtemplate(7, GuidedHelpComponent_div_4_ng_container_7_Template, 2, 1, "ng-container", 18);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r0.activeLink.pageTag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.pageTags.GUIDED_HELP_GETTING_STARTED);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.pageTags.GUIDED_HELP_PRESCRIPTIONS);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.pageTags.GUIDED_HELP_PHARMACY_SEARCH);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.pageTags.GUIDED_HELP_HEALTH);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.pageTags.GUIDED_HELP_PROVIDER_SEARCH);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.pageTags.GUIDED_HELP_OTHER_PREFERENCES);
} }
function GuidedHelpComponent_vnext_link_8_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 26);
    i0.ɵɵlistener("click", function GuidedHelpComponent_vnext_link_8_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r21.onPreviousClick()); })("keyup.enter", function GuidedHelpComponent_vnext_link_8_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r22); const ctx_r23 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r23.onPreviousClick()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r1.Spa_Site_Previous)("isLinkButton", true)("showArrow", "left")("makeInlineBlock", true);
} }
function GuidedHelpComponent_ng_container_9_vnext_link_1_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 26);
    i0.ɵɵlistener("click", function GuidedHelpComponent_ng_container_9_vnext_link_1_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r25.onSkipClick()); })("keyup.enter", function GuidedHelpComponent_ng_container_9_vnext_link_1_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r26); const ctx_r27 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r27.onSkipClick()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r24.Spa_Site_Skip)("isLinkButton", true)("showArrow", "right")("makeInlineBlock", true);
} }
function GuidedHelpComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GuidedHelpComponent_ng_container_9_vnext_link_1_Template, 1, 4, "vnext-link", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_Skip");
} }
function GuidedHelpComponent_ng_container_11_vnext_link_1_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 28);
    i0.ɵɵlistener("click", function GuidedHelpComponent_ng_container_11_vnext_link_1_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r29.onSkipClick()); })("keyup.enter", function GuidedHelpComponent_ng_container_11_vnext_link_1_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r30); const ctx_r31 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r31.onSkipClick()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r28.Spa_Site_Skip)("isLinkButton", true)("showArrow", "right")("makeInlineBlock", true);
} }
function GuidedHelpComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, GuidedHelpComponent_ng_container_11_vnext_link_1_Template, 1, 4, "vnext-link", 27);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_Skip");
} }
let GuidedHelpComponent = class GuidedHelpComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, guidedHelpService, demographicService, injector, modalService, memberSessionService, siteService, store, planFacade, analyticsService, pharmacyFacade, providerFacade, mapFacade, mapContextService, ssoPopulatedFieldService, spinnerService, plansService, preferencesService, preferencesContextService, helpfulToolsService, zipCodeContextService, configResourceService, localeService, responsiveLayoutService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.guidedHelpService = guidedHelpService;
        this.demographicService = demographicService;
        this.injector = injector;
        this.modalService = modalService;
        this.memberSessionService = memberSessionService;
        this.siteService = siteService;
        this.store = store;
        this.planFacade = planFacade;
        this.analyticsService = analyticsService;
        this.pharmacyFacade = pharmacyFacade;
        this.providerFacade = providerFacade;
        this.mapFacade = mapFacade;
        this.mapContextService = mapContextService;
        this.ssoPopulatedFieldService = ssoPopulatedFieldService;
        this.spinnerService = spinnerService;
        this.plansService = plansService;
        this.preferencesService = preferencesService;
        this.preferencesContextService = preferencesContextService;
        this.helpfulToolsService = helpfulToolsService;
        this.zipCodeContextService = zipCodeContextService;
        this.configResourceService = configResourceService;
        this.localeService = localeService;
        this.responsiveLayoutService = responsiveLayoutService;
        // #region resources
        this.Spa_GuidedHelp_PlansLink_Text = 'Go to plans';
        this.Spa_GuidedHelp_SummaryLink_Text = 'Go to summary';
        this.Spa_Site_Previous = 'Previous';
        this.Spa_GuidedHelp_OptionalLabel_Text = '(Optional)';
        this.Spa_GuidedHelp_Health_AgeQuestion_Text = 'How old are you?';
        this.Spa_GuidedHelp_GetStarted_ZipCode_Text = 'These optional questions help us estimate your potential costs';
        this.Spa_Site_Health_Text = 'Health';
        this.Spa_Site_Pharmacy_Text = 'Pharmacy';
        this.Spa_Site_GetStarted_Text = 'Get started';
        this.Spa_Site_Prescriptions_Text = 'Prescriptions';
        this.Spa_Site_OtherPreferences_Text = 'Other preferences';
        this.Spa_Site_Health_Body_Text = 'This will be used to calculate your estimated costs and will not affect your premiums';
        this.Spa_GuidedHelp_Health_SliderHeader1_Text = 'Generally healthy';
        this.Spa_GuidedHelp_Health_SliderHeader2_Text = 'Some health needs';
        this.Spa_GuidedHelp_Health_SliderHeader3_Text = 'Significant health needs';
        this.Spa_GuidedHelp_Health_SliderBody1 = 'No major illnesses <br /> Less than 2 prescriptions for an illness <br /> Less than 2 visits to primary care';
        this.Spa_GuidedHelp_Health_SliderBody2 = 'Ongoing condition like diabetes <br /> Regular prescription needs <br /> 1 or more visits to a specialist';
        this.Spa_GuidedHelp_Health_SliderBody3 = 'Multiple prescriptions <br /> Managing a serious condition <br /> Multiple visits to specialists';
        this.Spa_Site_PageSubHeader_Text = '';
        this.Spa_DrugSearch_Hint_Text = 'search for prescription';
        this.Spa_DrugSearch_Intro_Text = 'This will allow you to see how each plan provides coverage for your prescriptions.';
        this.Spa_DrugSearch_PageHeader_Text = 'Prescriptions';
        this.Spa_PharmacySearch_Intro_Text = 'Find your pharmacy to help us estimate costs and show you which plans include in-network pharmacy discounts.';
        this.Spa_PharmacySearch_PageHeader_Text = 'Pharmacy';
        this.Spa_Site_SendEmailButton_Text = 'Send email';
        this.Spa_BlueButton_StartAddDrug_Text = 'Start adding drugs';
        this.Spa_BlueButton_MyMedicare_Connect_Text = `<div class="Spa_Style_H4 mb-1">Download your prescription list from myMedicare.gov.</div>
    <p class="Spa_Style_Primary_Color Spa_Style_Paragraph mb-0">The easy and secure way to download all current prescriptions.</p>`;
        this.Spa_BlueButton_MyMedicare_Button = 'MyMedicare.gov';
        this.Spa_GuidedHelp_OtherPreferences_NoQuestions_Text = 'There are no other preferences for your service area, \n please continue to see your available Plans.';
        this.Spa_GuidedHelp_MedicalOnly_Default = 'MA';
        this.Spa_GuidedHelp_GettingStarted_CoverageText_Question = 'What coverage type are you interested in?';
        this.Spa_BlueButton_Modal_Header = 'You are leaving site';
        this.Spa_BlueButton_Modal_Content = `<p class="Spa_Style_Paragraph">Are you sure you want to continue to login to Mymedicare.gov?</p>
    <p class="Spa_Style_Paragraph">Connecture,Inc. is a trusted entity of Healthcare co. By allowing Connecture, Inc access to
    your drug list, you will be able to download your drugs to our site and be able to find a plan that covers them that
    much quicker.</p><p class="Spa_Style_Paragraph">Review Connecture's <a class="Spa_Style_Link" href="">privacy policy</a>
    and <a class="Spa_Style_Link" href="">terms and conditions</a> relating to the download of the prescriptions.</p>`;
        this.Spa_BlueButton_EmailSentToStatus_Text = `Email sent to {{[member.profile.emailAddress]}} on {{[member.blueButtonInfo.updateDate]}} `;
        this.Spa_BlueButton_Issue_Loading_Text = 'Issue loading prescriptions. Please try again.';
        this.Spa_BlueButton_Beneficiary_Denied_Text = 'Beneficiary denied access.';
        this.Spa_BlueButton_ImportLatestPrescription_Button_Text = 'Import latest prescriptions';
        this.Spa_BlueButton_ImportLatestPrescription_Error_Text = 'Unable to import latest prescriptions. Try again.';
        this.Spa_BlueButton_AccessDenied_Error_Text = 'Access denied. We are unable to load prescriptions';
        this.Spa_BlueButton_ClaimData_Loading_Error_Text = 'There was an issue loading your prescriptions. Please try again later';
        this.Spa_BlueButton_Success_Text = 'Prescriptions shared successully';
        this.Spa_BlueButton_Download_Text = 'Prescriptions last downloaded on ';
        this.Spa_Site_Skip = 'Skip';
        this.Spa_GuidedHelp_Continue_Button = 'Continue';
        this.Spa_DrugSearch_Frequency_List = [
            { label: "per month" /* FrequencyLabel.Month */, value: 30 /* FrequencyValue.Month */ },
            { label: "per two months" /* FrequencyLabel.TwoMonths */, value: 60 /* FrequencyValue.TwoMonths */ },
            { label: "per three months" /* FrequencyLabel.ThreeMonths */, value: 90 /* FrequencyValue.ThreeMonths */ },
            { label: "per six months" /* FrequencyLabel.SixMonths */, value: 180 /* FrequencyValue.SixMonths */ },
            { label: "per year" /* FrequencyLabel.PerYear */, value: 365 /* FrequencyValue.PerYear */ }
        ];
        this.Spa_DrugSearch_Content_Section_Text = 'We defaulted the most common dosage so you have a better idea of what you might take.';
        this.Spa_DrugSearch_Dosage_Header = 'Select dose and form';
        this.Spa_DrugSearch_Frequency_Header = 'Enter quantity and frequency';
        this.Spa_DrugSearch_Package_Header = 'Select package';
        this.Spa_DrugSearch_Add_Button = 'Add';
        this.Spa_DrugSearch_Cancel_Button = 'Cancel';
        this.Spa_DrugSearch_EditDrug_Button = 'Edit Drug';
        this.Spa_DrugSearch_Quantity_Max_Limit = 1000;
        this.Spa_DrugSearch_Cabinet_Limit = 25;
        this.Spa_DrugSearch_MaxCount_Error_Message = `You can only add up to ${this.Spa_DrugSearch_Cabinet_Limit} drugs`;
        this.Spa_DrugSearch_Quantity_Error_Message = `
  Please provide a number between 0 and ${this.Spa_DrugSearch_Quantity_Max_Limit}`;
        this.Spa_DrugSearch_Label_Text = 'Drug Search';
        this.Spa_DrugSearch_InCabinetError_Text = 'This drug and dosage already exists in your list.';
        this.Spa_DrugSearch_Medicine_Header = 'Your prescriptions';
        this.Spa_DrugSearch_GenericOption_Icon = 'fas fa-tag';
        this.Spa_Site_Show_GenericDrugOption = true;
        this.Spa_DrugSearch_GenericOption_Question = 'Would you like to use a Generic (<genericDrugName>) for <brandName>';
        this.Spa_DrugSearch_GenericOption_Info = `
    According to the FDA, this generic drug has the same quality, strength, safety and active ingredient as the brand name drug.
    Generic drugs are usually covered by part D plans and are generally a lower price.`;
        this.Spa_DrugSearch_GenericOptions = [
            { label: 'Yes', value: true },
            { label: 'No', value: false }
        ];
        this.Spa_DrugSearch_CheckDrugCoverageButton_Text = 'See if this drug is covered';
        this.Spa_DrugSearch_GenericOption_Default_Selection = false;
        this.Spa_DrugListCard_HideCosts_Flag = false;
        this.Spa_Add_Pharmacy_Button = 'Add pharmacy';
        this.Spa_Pharmacy_Limit = 25;
        this.Spa_Provider_Limit = 25;
        this.Spa_PharmacyMap_Default_Zoom = 11;
        this.Spa_ProviderMap_Default_Zoom = 11;
        this.Spa_PharmacyMap_Max_Zoom = 28;
        this.Spa_PharmacyMap_Min_Zoom = 4;
        this.Spa_ProviderMap_Max_Zoom = 28;
        this.Spa_ProviderMap_Min_Zoom = 4;
        this.Spa_AddPharmacy_YourPharmacyText = 'Your Pharmacy';
        this.Spa_Pharmacy_Added_Label = 'Pharmacy Added';
        this.Spa_Site_SearchButton_Text = 'Search';
        this.Spa_PharmacyName_Text = 'Pharmacy name';
        this.Spa_ProviderName_Text = 'Provider name';
        this.Spa_PharmacyName_HintText = 'Pharmacy name';
        this.Spa_ProviderName_HintText = 'Provider name';
        this.Spa_Site_ElectronicPrescription_ToolTipHeader = 'Electronic prescribing';
        this.Spa_Site_ElectronicPrescription_ToolTipBody = 'Prescriptions can be written and sent to the pharmacy electronically.';
        this.Spa_Pharmacy_Not_Found_Text = `We're sorry, but we did not find any pharmacies near that location.
    Please use the map zoom [-] to expand your search area, or enter a new search location in the ZIP code search box above.`;
        this.Spa_PharmacySearch_Pagination_ItemsPerPage = 10;
        this.Spa_ProviderSearch_Pagination_ItemsPerPage = 10;
        this.Spa_PharmacySearch_Pagination_Enabled = false;
        this.Spa_ProviderSearch_Pagination_Enabled = false;
        this.Spa_PharmacySearch_Pagination_View_Text = 'Viewing <startPageItem> - <endPageItem> of <totalPages>';
        this.Spa_ProviderSearch_Pagination_View_Text = 'Viewing <startPageItem> - <endPageItem> of <totalPages>';
        this.Spa_Pharmacy_Alt_View_Not_Found_Header_Text = 'No pharmacy results';
        this.Spa_Provider_Alt_View_Not_Found_Header_Text = 'No provider results';
        this.Spa_Pharmacy_Alt_View_Not_Found_Body_Text = 'There are no pharmacies available in this location. Try zooming out or entering a new ZIP code.';
        this.Spa_Provider_Alt_View_Not_Found_Body_Text = 'There are no providers available in this location. Try zooming out or entering a new ZIP code.';
        this.Spa_Site_Preferred_In_Network_Text = 'Preferred In-network';
        this.Spa_Site_Standard_In_Network_Text = 'Standard In-network';
        this.Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text = 'Pharmacies that are willing to give the plans a larger discount than other pharmacies.';
        this.Spa_PharmacySearch_Standard_In_Network_Tooltip_Text = 'These pharmacies may charge a higher copayment or co-insurance for filling your prescription.';
        this.Spa_Site_ZipCodeInput_ZipCodeError = 'Zip code is invalid';
        this.Spa_Site_ZipCodeInput_CountyError = 'Please select your county';
        this.Spa_Site_ZipCodeInput_SelectCounty = 'Select county';
        this.Spa_Site_ZipCodeInput_ZipCodeLabel = 'Zip code';
        this.Spa_Site_ZipCodeInput_EditCounty = 'Edit';
        this.Spa_Site_ErrorKeyword_Text = 'Error:';
        this.Spa_DrugSearch_Frequency_ListBox_Label = 'Choose any one the frequency from list of options available';
        this.Spa_Site_Pharmacy_Added_Text = 'has been added';
        this.Spa_Site_Pharmacy_Add_Text = 'Press Enter to add this Pharmacy';
        this.Spa_Site_Health_Slider_Label_Text = 'Select health status range';
        this.Spa_Site_Enable_BlueButton = true;
        this.Spa_Site_OrText = 'OR';
        this.Spa_Site_EmailAddress_Text = 'Email address';
        this.Spa_Profile_EmailRequired_Error = 'Please provide email address';
        this.Spa_Profile_EmailInvalid_Error = 'Please provide a valid email address';
        this.Spa_BlueButton_Success_Message = ' Prescriptions last downloaded on';
        this.Spa_BlueButton_Error_Loading_Text = 'Unable to load latest prescriptions.';
        this.Spa_BlueButton_Beneficiary_Email_Details = 'You may need to email the beneficiary again to update their login information.';
        this.Spa_Site_EPrescribing_Alt_Text = 'This pharmacy supports e-prescribing.';
        this.Spa_Site_Completed_Text = 'Completed';
        this.Spa_Site_Not_Visited_Text = 'Not Visited';
        this.Spa_Site_Current_Text = 'Current';
        this.Spa_Site_Tooltip_Text = 'Tooltip:';
        this.Spa_Site_SiteType = 'consumer';
        this.Spa_GettingStarted_SubsidyHeader_Text = 'Do you receive extra help with paying for your prescription drugs?';
        this.Spa_GettingStarted_ShowSubsidyAccordion_Flag = true;
        this.Spa_Site_Multi_Pharmacy_Enabled = false;
        this.Spa_Site_Maximum_Pharmacy_Count = 3;
        this.Spa_Site_Set_Primary_Pharmacy_Link_Text = 'Set as primary pharmacy';
        this.Spa_Site_Primary_Pharmacy_Text = 'Primary Pharmacy';
        this.Spa_Site_Primary_Pharmacy_Icon = 'fas fa-star';
        this.Spa_Site_Primary_Pharmacy_Icon_Color = '#b07d0f';
        this.Spa_PharmacySearch_MultiPharmacy_Intro_Text = 'Add one or more pharmacies to help us estimate costs and show you which plans include in-network pharmacy discounts.';
        this.Spa_Site_Pharmacy_Limit_Error_Message = 'You can only add up to <maxPharmacyCount> pharmacies';
        this.Spa_Site_Providers_Text = 'Providers';
        this.Spa_Site_Providers_Body_Text = `See which plans cover your doctor, specialist, urgent care or hospital. Reference the plan's Medical Provider Directory to see up-to-date network information.`;
        this.Spa_Multi_Providers_Body_Text = `Add your providers to see which plans cover your doctor, specialist, urgent care or hospital. Choose the exact location for your provider because network status can vary for a provider based on the location.`;
        this.Spa_Site_AddPharmacy_YourMultiPharmacyText = 'Your Pharmacies';
        this.Spa_OtherPreferences_PageCount_Text = 'Page <currentPage> of <lastPage>';
        this.Spa_GuidedHelp_OtherPreferences_EnterZip_Text = 'Search';
        this.Spa_GuidedHelp_OtherPreferences_ProvideZip_Text = 'Please enter your zip code to see other preferences.';
        this.Spa_Filter_Header_Text = 'Filters';
        this.Spa_Site_Pharmacy_Filter_Enabled = true;
        this.Spa_Site_Pharmacy_In_Network_Filter_Enabled = true;
        this.Spa_Site_Pharmacy_Other_Filter_Enabled = false;
        this.Spa_Filter_Clear_All = 'Clear all';
        this.Spa_Pharmacy_Filter_Open24hrs_Text = 'Open 24 hours';
        this.Spa_Pharmacy_Filter_Eprescribing_Text = 'Electronic prescribing(prescriptions can be written and sent to the pharmacy electronically)';
        this.Spa_Pharmacy_Filter_HandicapAccess_Text = 'Handicap accessible';
        this.Spa_Pharmacy_Filter_DurableEquipment_Text = 'Durable medical Equipment';
        this.Spa_Pharmacy_Filter_MailOrder_Text = 'Mail Order';
        this.Spa_Filter_Default_Filter_Text = 'No filters available';
        this.Spa_Filter_Badge_Color = '#fcb215';
        this.Spa_Site_OtherPreferences_Enabled = false;
        this.Spa_Pharmacy_Filters = [
            {
                dataKey: 'has24hrService',
                displayName: this.Spa_Pharmacy_Filter_Open24hrs_Text
            },
            {
                dataKey: 'hasEPrescriptions',
                displayName: this.Spa_Pharmacy_Filter_Eprescribing_Text
            },
            {
                dataKey: 'hasHandicapAccess',
                displayName: this.Spa_Pharmacy_Filter_HandicapAccess_Text
            },
            {
                dataKey: 'hasDurableEquipment',
                displayName: this.Spa_Pharmacy_Filter_DurableEquipment_Text
            },
            {
                dataKey: 'isMailOrder',
                displayName: this.Spa_Pharmacy_Filter_MailOrder_Text
            }
        ];
        this.Spa_Provider_Add_Text = 'Add Provider';
        this.Spa_Provider_Added_Text = 'Provider added';
        this.Spa_Provider_Add_Maximum_Limit_Message = 'You can only add up to <maxCount> providers';
        this.Spa_Provider_RemoveProvider_Text = 'Remove provider';
        this.Spa_Provider_YourProvider_Text = 'Your providers';
        this.Spa_Provider_Set_Primary_Care_Provider_Text = 'Set as primary care provider';
        this.Spa_Provider_Primary_Care_Provider_Text = 'Primary care provider';
        this.Spa_Providers_Filter_Enabled = false;
        this.Spa_Providers_Filter_Individuals_Text = 'Doctors and other professionals';
        this.Spa_Providers_Filter_Facilties_Text = 'Facilities (hospitals, clinics and urgent care)';
        this.Spa_Group_Provider_Add_Text = 'Add';
        this.Spa_Group_Provider_Added_Text = 'Added';
        this.Spa_Site_Preferences_Score_Enabled = false;
        this.Spa_Site_Show_Preferences_Score = false;
        this.Spa_Site_Preferences_Weight_Provider = 0;
        this.Spa_Site_Preferences_Weight_Drug = 0;
        this.Spa_Site_Preferences_Weight_Pharmacy = 0;
        this.Spa_Site_Preferences_Weight_Chronic = 0;
        this.Spa_Site_Preferences_Weight_Benefits = 0;
        this.Spa_Site_Preferences_Weight_Medsup = 0;
        this.Spa_PlanList_Sort_By_PreferenceScore_Label = 'Preference Score (High to Low)';
        this.Spa_GettingStarted_EnableDSNPDisplay_Flag = true;
        this.Spa_GuidedHelp_Preference_Questions = [];
        this.Spa_PlanFilters_Modal_Cancel_Button = 'Cancel';
        this.Spa_PlanFilters_Modal_Apply_Button = 'Apply';
        this.Spa_ZipCodeInput_CountyLabel_Text = 'County';
        this.Spa_ZipCodeInput_CountyLabel_Enabled = false;
        this.Spa_Drugs_UseCMSDrugFlag_Enabled = true;
        this.Spa_Pharmacy_In_Network_Filters = [
            {
                dataKey: 'isStandard',
                displayName: '[[Spa_Site_Standard_In_Network_Text]] ([[Spa_PharmacySearch_Standard_In_Network_Tooltip_Text]])'
            },
            {
                dataKey: 'isPreferred',
                displayName: '[[Spa_Site_Preferred_In_Network_Text]] ([[Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text]])'
            }
        ];
        this.Spa_Site_Add = 'Add';
        this.Spa_Site_Cancel = 'Cancel';
        this.Spa_Select_Single_Provider_For_Multi_Address_Enabled = false;
        this.Spa_Select_Provider_Location_Text = 'Select the provider location';
        this.Spa_Provider_Exists_Text = 'You may only select one location for each provider';
        this.Spa_Provider_Multiple_Location_Text = 'This provider has multiple locations which may give different insurance information.';
        this.Spa_Site_HealthCosts_Customization_Enabled = false;
        this.Spa_Site_HealthCosts_Restore_Defaults_Text = 'Restore defaults';
        this.Spa_Site_HealthCosts_Update_Answers_Text = 'Update answers';
        this.Spa_Site_HealthCosts_Save_Answers_Text = 'Save';
        this.Spa_Site_HealthCosts_Benefits_JSON = [];
        this.Spa_Site_HealthCosts_Save_Failed_Text = 'Server error. Please try again.';
        this.Spa_Site_HealthCosts_Save_Success_Text = 'Saved';
        this.Spa_HealthCosts_Benefits_Body_Text = 'Decide how often you might use these benefits annually to help estimate medical costs for each plan.';
        this.Spa_Site_HealthCosts_Benefits_Table_Header = 'Benefit';
        this.Spa_Site_HealthCosts_Usage_Table_Header = 'Visits/Uses';
        this.Spa_Site_HealthCosts_Days_Table_Header = 'Total days';
        this.Spa_HealthCosts_Body_Text = 'Would you like to estimate your medical costs?';
        this.Spa_GuidedHelp_GettingStarted_CoverageTypes = [
            {
                ordinal: 1,
                title: 'Medical Only',
                display: true,
                key: CoverageType.MEDICAL_ONLY
            },
            {
                ordinal: 2,
                title: 'Prescription drug',
                display: true,
                key: CoverageType.PRESCRIPTION_DRUG
            },
            {
                ordinal: 3,
                title: 'Medical and  prescription drug',
                display: true,
                key: CoverageType.MEDICAL_AND_PRESCRIPTION_DRUG
            },
            {
                ordinal: 4,
                title: `I don't know`,
                display: true,
                key: CoverageType.I_DONT_KNOW
            }
        ];
        this.Spa_GuidedHelp_PlanCard_EditLink_Text = 'Edit preferences';
        this.Spa_GuidedHelp_SubsidyLabel_Text = 'Subsidy:';
        this.Spa_Plan_Providers_Locations_Link_Text = 'locations';
        this.Spa_Site_ValueBasedCare_Enabled = true;
        this.Spa_Site_ValueBasedCare_Icon = 'fas fa-briefcase-medical';
        this.Spa_Site_ValueBasedCare_Text = 'Value based care';
        this.Spa_Site_ValueBasedCare_Filter_Enabled = true;
        this.Spa_ValueBasedCare_Filter_Text = 'Only show Value Based Care providers';
        this.Spa_ValueBasedCare_Filter_Checked = false;
        this.Spa_ValueBasedCare_LearnMore_Text = 'Learn more';
        this.Spa_ValueBasedCare_LearnMoreLink_Enabled = true;
        this.Spa_Provider_Search_Filter_General_Practice_Options = [
            { display: 'Yes', value: true },
            { display: 'No', value: false }
        ];
        this.Spa_Provider_Search_General_Practice_Label_Text = 'General practice';
        this.Spa_Provider_Search_General_Practice_Tooltip_Text = 'General practitioners treat patients of all ages, but do not typically specialize in a particular area. They may treat your medical condition or refer you to a specialist.';
        this.Spa_Provider_Search_Filter_General_Practice_Option_Enabled = false;
        this.Spa_Site_Digital_Pharmacy_Enabled = false;
        this.Spa_Pharmacy_Retail_Tab_Text = 'Retail';
        this.Spa_Pharmacy_Digital_Tab_Text = 'Digital';
        this.Spa_Pharmacy_Digital_Tab_Intro_Text = 'Many retail pharmacies have online options for ordering prescriptions. Similar to mail order pharmacies associated with your health plan, digital pharmacies allow you to order prescriptions online and have them delivered to your home. Inclusion in this list does not guarantee delivery to your service area.';
        this.Spa_Provider_Search_ShowSingleProviderInList_Enabled = false;
        this.Spa_Site_Edit_Text = 'Edit';
        this.Spa_Site_Update_Text = 'Update';
        this.Spa_Provider_ShowEditLink_Enabled = false;
        this.Spa_ValueBasedCare_Available_Text = '<i class="fas fa-solid fa-info-circle"></i> Value Based Care providers may be available in your area';
        this.Spa_ValueBasedCare_LearnMore_Link = 'https://www.cms.gov/priorities/innovation-center/value-based-care-spotlight';
        this.Spa_ValueBasedCare_LearnMoreLink2_Enabled = false;
        this.Spa_ValueBasedCare_Toggle_Label = 'Search Value Based Providers';
        this.Spa_ValueBasedCare_Toggle_ToolTip_Text = '';
        this.Spa_ValueBasedCare_Toggle_Enabled = false;
        this.Spa_Provider_Search_Filter_ValueBasedCare_Options = [
            { display: 'Yes', value: 'true' },
            { display: 'No', value: 'false' }
        ];
        this.Spa_Provider_New_Patient_Toggle_Enabled = false;
        this.Spa_Provider_New_Patient_Toggle_Label = 'Are you a new patient for this provider?';
        this.Spa_Provider_New_Patient_Options = [
            { display: 'Yes', value: 'yes' },
            { display: 'No', value: 'no' }
        ];
        this.Spa_Primary_Care_Provider_Toggle_Enabled = false;
        this.Spa_Primary_Care_Provider_Toggle_Label = 'Is this your primary care physician';
        this.Spa_Primary_Care_Provider_Options = [
            { display: 'Yes', value: 'yes' },
            { display: 'No', value: 'no' }
        ];
        this.Spa_New_Patient_For_Provider_Text = 'New Patient';
        this.Spa_Existing_Patient_For_Provider_Text = 'Existing patient';
        this.Spa_Provider_ValueBasedCare_Name_Filter_Enabled = false;
        this.Spa_Provider_ValueBasedCare_Name_Filter_Label = 'Participating Value Based Care organizations in this area';
        this.Spa_Selected_Provider_Options_Enabled = false;
        this.Spa_Site_Remove_Text = 'Remove';
        this.Spa_Site_SelectAll_Text = 'Select all';
        this.Spa_Site_ZelisIntegration_Enabled = false;
        // #endregion resources
        this.providerFilters = [];
        this.pageTags = PageTags;
        this.tagsToUpdate = {};
        this.blueButtonStatus = BlueButtonStatus;
        this.isMemberSessionUpdated = false;
        this.availableQuestionPages = [];
        this.questionsLoaded = false;
        this.currentPreferencesPage = 1;
        this.addProviderMaxLimit = AddProviderMaxLimit;
        this.subscriptions = new Subscription();
    }
    get activeLink() {
        return this.guidedHelpService.links.find(link => link.status === 'selected');
    }
    get goToLinkText() {
        return (this.isRetentionView && this.guidedHelpService.getRetentionDefaultPageTag() === PageTags.RETENTION_SUMMARY) ||
            this.isQuotingSite
            ? this.Spa_GuidedHelp_SummaryLink_Text
            : this.Spa_GuidedHelp_PlansLink_Text;
    }
    get goToLinkKeyNamesForLiveEdit() {
        return (this.isRetentionView && this.guidedHelpService.getRetentionDefaultPageTag() === PageTags.RETENTION_SUMMARY) ||
            this.isQuotingSite
            ? 'Spa_GuidedHelp_SummaryLink_Text'
            : 'Spa_GuidedHelp_PlansLink_Text';
    }
    get isMobile$() {
        return this.guidedHelpService.isMobile$;
    }
    /**
     * Checks if the selected link is the last link based on
     * the Interested Coverage type/presence of preference questions
     *
     * @returns a boolean value
     */
    get isLastLink() {
        return this.guidedHelpService.isLastNavigationLink;
    }
    /**
     * Checks if the selected link is the last link for Medical only
     *
     * @returns a boolean value
     */
    get isLastMedicalLink() {
        return this.guidedHelpService.isLastMedicalNavigationLink;
    }
    /**
     * Checks if the selected link is the last Physical link
     * as per the placement on the navigation bar
     *
     * @returns a boolean value
     */
    get isLastPhysicalLink() {
        return (this.guidedHelpService.isLastPhysicalLink &&
            this.currentPreferencesPage === this.preferencesContextService.preferenceQuestionsPages.length);
    }
    ngOnInit() {
        super.ngOnInit();
        this.getMedBenefitsAndUpdateQuestions();
        this.helpfulToolsService.resetPlan();
        this.drugSearchFrequencyList = this.getFilteredFrequencyOptions();
        this.preferencesLink = this.guidedHelpService.links.find(link => link.pageTag === PageTags.GUIDED_HELP_OTHER_PREFERENCES);
        this.memberSessionService.updateDemographics();
        if (this.analyticsService.googleDataLayerTags[DataLayerGlobalVariable.SITE_HAS_GUIDED_HELP_INFO] !== 'yes') {
            this.tagsToUpdate = { [DataLayerGlobalVariable.SITE_HAS_GUIDED_HELP_INFO]: 'yes' };
        }
        if (this.guidedHelpService.getSelectedLink().pageTag === PageTags.GUIDED_HELP_HEALTH) {
            const healthCostCalc = this.analyticsService.googleDataLayerTags[DataLayerGlobalVariable.MEMBER_PREF_HEALTH_COST_CALC];
            this.tagsToUpdate = {
                ...this.tagsToUpdate,
                [DataLayerGlobalVariable.MEMBER_PREF_HEALTH_COST_CALC]: healthCostCalc || GOOGLE_ANALYTICS_NO
            };
        }
        this.tagsToUpdate = {
            ...this.tagsToUpdate,
            [DataLayerGlobalVariable.HEALTH_COST_CALC_ISPRESENT]: this.guidedHelpService.getSelectedLink().pageTag === PageTags.GUIDED_HELP_HEALTH && this.Spa_Site_HealthCosts_Customization_Enabled
                ? GOOGLE_ANALYTICS_YES
                : GOOGLE_ANALYTICS_NO
        };
        this.isRetentionView = this.siteService.isRetentionView();
        this.isQuotingSite = this.siteService.isQuotingSite();
        const selectedLink = this.guidedHelpService.getSelectedLink();
        if (selectedLink && selectedLink.pageTag === PageTags.GUIDED_HELP_PRESCRIPTIONS && this.Spa_Site_Enable_BlueButton) {
            this.fetchUpdatedMemberDetails();
        }
        this.subscriptions.add(this.zipCodeContextService.onZipCodeEnter$().subscribe({
            next: zipCode => {
                if (zipCode && selectedLink.pageTag === PageTags.GUIDED_HELP_GETTING_STARTED) {
                    this.onContinueClick();
                }
            }
        }));
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe({
            next: locale => {
                this.initializeTranslatableText();
                this.drugSearchFrequencyList = this.getFilteredFrequencyOptions();
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.memberSessionService.getMemberDemographicEstimateHealthCost$().subscribe({
            next: (estimateHealthCost) => {
                if (!this.estimateHealthCost) {
                    this.tagsToUpdate = {
                        ...this.tagsToUpdate,
                        [DataLayerGlobalVariable.HEALTH_COST_CALC_ISPRESENT]: selectedLink.pageTag === PageTags.GUIDED_HELP_HEALTH && this.Spa_Site_HealthCosts_Customization_Enabled
                            ? GOOGLE_ANALYTICS_YES
                            : GOOGLE_ANALYTICS_NO
                    };
                }
                this.estimateHealthCost = estimateHealthCost;
            }
        }));
        this.subscriptions.add(this.responsiveLayoutService.isCompact$.subscribe({
            next: isMobile => {
                this.isMobile = isMobile;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.localeService.getCountryCode$.subscribe({
            next: countryCode => {
                if (countryCode) {
                    this.countryCode = countryCode;
                    this.cdr.markForCheck();
                }
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        super.ngOnDestroy();
    }
    fetchUpdatedMemberDetails() {
        if (this.siteService.isPPCSite(this.Spa_Site_SiteType)) {
            this.blueButtonUpdateInfo$ = this.store.select(MemberState.blueButtonInfo);
            const sessionId = this.memberSessionService.getMemberSessionId();
            this.spinnerService.show(SpinnerEvent.BLUE_BUTTON_LOADING);
            this.subscriptions.add(this.memberSessionService
                .fetchMemberSession$({ sessionId })
                .pipe(switchMap(() => this.blueButtonUpdateInfo$))
                .subscribe({
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                next: async (blueButtonUpdateInfo) => {
                    if (blueButtonUpdateInfo?.status && blueButtonUpdateInfo.status === this.blueButtonStatus.SUCCESS) {
                        await this.memberSessionService.updateDrugs();
                    }
                    this.isMemberSessionUpdated = true;
                    this.spinnerService.hide(SpinnerEvent.BLUE_BUTTON_LOADING);
                    this.cdr.detectChanges();
                }
            }));
        }
        else {
            this.isMemberSessionUpdated = true;
            this.cdr.detectChanges();
        }
    }
    preProcessProperties() {
        this.setUpHealthPageProperties();
        this.pharmacyLimitCountErrorMessage = this.getPharmacyMaximumCount();
        this.providerMaxLimitError = this.getProviderMaxLimitErrorMessage();
        this.providerFilters = [
            {
                label: this.Spa_Providers_Filter_Individuals_Text,
                value: ProviderFilterKeyType.PROVIDER_INDIVIDUAL,
                disabled: false,
                initiallyChecked: true,
                link: null
            },
            {
                label: this.Spa_Providers_Filter_Facilties_Text,
                value: ProviderFilterKeyType.PROVIDER_FACILITIES,
                disabled: false,
                initiallyChecked: true,
                link: null
            },
            {
                label: this.Spa_ValueBasedCare_Filter_Text,
                value: ProviderFilterKeyType.PROVIDER_VALUE_BASED_CARE,
                disabled: !(this.Spa_Site_ValueBasedCare_Enabled && this.Spa_Site_ValueBasedCare_Filter_Enabled),
                initiallyChecked: this.Spa_ValueBasedCare_Filter_Checked,
                link: !this.Spa_ValueBasedCare_LearnMoreLink2_Enabled && this.Spa_ValueBasedCare_LearnMoreLink_Enabled
                    ? this.Spa_ValueBasedCare_LearnMore_Text
                    : null
            }
        ];
    }
    getPharmacyMaximumCount() {
        return this.Spa_Site_Pharmacy_Limit_Error_Message.replace('<maxPharmacyCount>', this.pharmacyFacade.maxPharmacyCount.toString());
    }
    isPPCSite() {
        return this.siteService.isPPCSite(this.Spa_Site_SiteType);
    }
    getProviderMaxLimitErrorMessage() {
        return this.Spa_Provider_Add_Maximum_Limit_Message && this.addProviderMaxLimit.MAX_COUNT
            ? this.Spa_Provider_Add_Maximum_Limit_Message.replace('<maxCount>', this.addProviderMaxLimit.MAX_COUNT.toString())
            : this.Spa_Provider_Add_Maximum_Limit_Message;
    }
    setUpHealthPageProperties() {
        this.healthPageProperties = {
            header: this.Spa_Site_Health_Text,
            body: this.Spa_Site_Health_Body_Text
        };
        this.slideSections = [
            {
                value: GuidedHelpHealthStatus.MEMBER_HEALTH_GOOD,
                headerKey: 'Spa_GuidedHelp_Health_SliderHeader1_Text',
                bodyKey: 'Spa_GuidedHelp_Health_SliderBody1',
                header: this.Spa_GuidedHelp_Health_SliderHeader1_Text,
                body: this.Spa_GuidedHelp_Health_SliderBody1
            },
            {
                value: GuidedHelpHealthStatus.MEMBER_HEALTH_FAIR,
                headerKey: 'Spa_GuidedHelp_Health_SliderHeader2_Text',
                bodyKey: 'Spa_GuidedHelp_Health_SliderBody2',
                header: this.Spa_GuidedHelp_Health_SliderHeader2_Text,
                body: this.Spa_GuidedHelp_Health_SliderBody2
            },
            {
                value: GuidedHelpHealthStatus.MEMBER_HEALTH_POOR,
                headerKey: 'Spa_GuidedHelp_Health_SliderHeader3_Text',
                bodyKey: 'Spa_GuidedHelp_Health_SliderBody3',
                header: this.Spa_GuidedHelp_Health_SliderHeader3_Text,
                body: this.Spa_GuidedHelp_Health_SliderBody3
            }
        ];
    }
    onContinueClick() {
        this.logContinueEvent();
        if (!this.validatePage()) {
            return;
        }
        if (this.activeLink.pageTag === PageTags.GUIDED_HELP_HEALTH) {
            this.demographicService.updateDemographicSession();
        }
        if (this.activeLink.pageTag === PageTags.GUIDED_HELP_OTHER_PREFERENCES) {
            if (this.currentPreferencesPage < this.preferencesContextService.preferenceQuestionsPages.length) {
                this.currentPreferencesPage++;
            }
            else {
                this.navigateToNextLinkOnContinue();
            }
        }
        else {
            this.navigateToNextLinkOnContinue();
        }
    }
    onSkipClick() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PREFERENCES_SKIP);
        if (this.activeLink.pageTag === PageTags.GUIDED_HELP_OTHER_PREFERENCES) {
            if (this.currentPreferencesPage < this.preferencesContextService.preferenceQuestionsPages.length) {
                this.currentPreferencesPage++;
            }
            else {
                this.navigateToNextLinkOnSkip();
            }
        }
        else {
            this.navigateToNextLinkOnSkip();
        }
    }
    onPreviousClick() {
        if (this.activeLink.pageTag === PageTags.GUIDED_HELP_OTHER_PREFERENCES) {
            if (this.currentPreferencesPage > 1) {
                this.currentPreferencesPage--;
            }
            else {
                this.backToPrevious();
            }
        }
        else {
            this.backToPrevious();
        }
    }
    backToPrevious() {
        this.plansService.setOverrideActiveTab(false);
        this.guidedHelpService.goToPreviousLink();
    }
    async getMedBenefitsAndUpdateQuestions() {
        if (this.guidedHelpService.getSelectedLink().pageTag === PageTags.GUIDED_HELP_OTHER_PREFERENCES &&
            this.Spa_Site_OtherPreferences_Enabled) {
            this.spinnerService.show(SpinnerEvent.PLANS_LOADING);
            const medBenefits = await this.plansService.getMedBenefits();
            this.spinnerService.hide(SpinnerEvent.PLANS_LOADING);
            const coverageType = this.guidedHelpService.coverageType();
            const modifiedForBenefits = this.preferencesService.filterQuestionsByBenefits(medBenefits);
            const modifiedByCoverageType = this.preferencesService.filterQuestionsByCoverageType(modifiedForBenefits, coverageType);
            const modifiedPages = this.preferencesService.filterMedsupQuestions(modifiedByCoverageType);
            this.preferencesContextService.updateQuestionPages(modifiedPages);
            this.availableQuestionPages = modifiedPages;
            this.questionsLoaded = true;
            this.cdr.markForCheck();
        }
    }
    fetchProvidersFromLocation(providerSearchFilter) {
        if (providerSearchFilter?.latitude &&
            providerSearchFilter?.longitude &&
            providerSearchFilter?.bounds &&
            providerSearchFilter?.distance) {
            this.providerFacade.fetchProvidersFromLocation(providerSearchFilter);
        }
    }
    updateEstimateHealthCost(costFlag) {
        this.estimateHealthCost = costFlag;
    }
    logContinueEvent() {
        if (this.activeLink.pageTag === PageTags.GUIDED_HELP_OTHER_PREFERENCES) {
            this.preferencesContextService.continue();
        }
        else {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PREFERENCES_CONTINUE);
        }
    }
    validatePage() {
        if (this.activeLink.pageTag === PageTags.GUIDED_HELP_PHARMACY_SEARCH) {
            return true;
        }
        return this.widgetValidationService.validate().length === 0;
    }
    navigateToNextLinkOnContinue() {
        const coverageType = this.guidedHelpService.coverageType();
        const selectedZip = this.guidedHelpService.getSelectedZipCode();
        if (!selectedZip) {
            if (this.isLastPhysicalLink) {
                // last link and they have not added a zip, open modal
                this.openZipModal(false, false);
            }
            else {
                this.navigationWhenNoZipSelected(coverageType);
            }
        }
        else {
            // last link
            if (this.isLastPhysicalLink) {
                this.guidedHelpService.goToNextLink(false, false);
            }
            else {
                this.navigationWhenZipSelected(coverageType);
            }
        }
    }
    navigateToNextLinkOnSkip() {
        const selectedZip = this.guidedHelpService.getSelectedZipCode();
        if (this.isLastLink && !selectedZip) {
            this.openZipModal(false, false);
        }
        else {
            this.guidedHelpService.goToNextLink(false, false);
        }
    }
    navigationWhenNoZipSelected(coverageType) {
        if ((coverageType === CoverageType.MEDICAL_ONLY && this.isLastMedicalLink) || this.isLastLink) {
            this.openZipModal(true);
        }
        else {
            // otherwise go to the next medical link if coverage type is medical
            if (coverageType === CoverageType.MEDICAL_ONLY) {
                if (this.guidedHelpService.medicalOnlyPages(this.activeLink)) {
                    this.guidedHelpService.goToNextLink();
                }
                else {
                    this.guidedHelpService.goToNextLink(false);
                }
            }
            else {
                this.guidedHelpService.goToNextLink(false);
            }
        }
    }
    navigationWhenZipSelected(coverageType) {
        // there is a zip value, but not the last link
        if (coverageType === CoverageType.MEDICAL_ONLY) {
            if (this.guidedHelpService.isLastNavigationLink) {
                this.guidedHelpService.goToNextLink(false);
            }
            else {
                this.guidedHelpService.goToNextLink();
            }
        }
        else {
            this.guidedHelpService.goToNextLink(false);
        }
    }
    openZipModal(useMedicalLinks = true, checkForPreferenceQuestions = true) {
        this.modalService
            .open(ZipCodeModalComponent, { centered: true, injector: this.injector })
            .result.then(() => {
            const selectedZip = this.guidedHelpService.getSelectedZipCode();
            if (selectedZip) {
                this.guidedHelpService.goToNextLink(useMedicalLinks, checkForPreferenceQuestions);
            }
        })
            .catch(err => err);
    }
    getFilteredFrequencyOptions() {
        return this.guidedHelpService.getFilteredFrequencyOptions(this.Spa_DrugSearch_Frequency_List);
    }
    initializeTranslatableText() {
        this.toggleYesText = this.configResourceService.getProcessedResourceValue('Spa_Site_Yes', null, 'Yes');
        this.toggleNoText = this.configResourceService.getProcessedResourceValue('Spa_Site_No', null, 'No');
    }
};
GuidedHelpComponent.ɵfac = function GuidedHelpComponent_Factory(t) { return new (t || GuidedHelpComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(i1.DemographicService), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(PharmacyFacade), i0.ɵɵdirectiveInject(ProviderFacade), i0.ɵɵdirectiveInject(MapFacade), i0.ɵɵdirectiveInject(MapContextService), i0.ɵɵdirectiveInject(i1.SSOPopulatedFieldService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(i1.PreferencesService), i0.ɵɵdirectiveInject(i1.PreferencesContextService), i0.ɵɵdirectiveInject(HelpfulToolsService), i0.ɵɵdirectiveInject(ZipCodeContextService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService)); };
GuidedHelpComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GuidedHelpComponent, selectors: [["vnext-guided-help"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 14, vars: 14, consts: [[1, "container"], [1, "row"], [1, "col-md-3", "col-xs-12"], [3, "isRetentionView", "isQuotingSite", "goToLinkText", "goToLinkKeyNamesForLiveEdit", "completedText", "notVisitedText", "currentText"], ["class", "col-md-9 col-xs-12", 4, "ngIf"], [1, "col-md-9", "offset-md-3", 3, "providedPrevious", "showPrevious"], ["previous-link", "", 1, "d-flex", "justify-content-between"], ["class", "pr-2", 3, "title", "isLinkButton", "showArrow", "makeInlineBlock", "click", "keyup.enter", 4, "liveEditProp"], [4, "ngIf"], ["continue-button", ""], [1, "btn", "Spa_Style_PrimaryButton", "col-xs-12", "col-md-auto", "continue-button", 3, "click"], [1, "col-md-9", "col-xs-12"], [3, "ngSwitch"], ["vnextGoogleTagManager", "", 3, "tagsToUpdate", "saveDefaultValues", "optionalLabel", "zipCodeInputZipCodeError", "zipCodeInputCountyError", "zipCodeInputSelectCounty", "zipCodeInputZipCodeLabel", "selectedCountyEnabled", "zipCodeInputEditCounty", "errorKeywordText", "getStartedText", "medicalOnlyDefault", "coverageTextQuestion", "spaPageSubHeader", "accordionHeaderText", "showSubsidyAccordion", "enableDSNPDisplay", "zipCodeIsReadOnly", "zipCodeHintText", "countyLabel", "showCountyLabel", "defaultCoverageTypes", "isMobile", 4, "ngSwitchCase"], ["vnextGoogleTagManager", "", 3, "tagsToUpdate", "saveDefaultValues", "frequencyList", "contentSectionText", "dosageHeader", "quantityAndFrequencyHeader", "packageHeader", "addButtonText", "cancelButtonText", "quantityMaxLimit", "medicineCabinetLimit", "cabinetLimitErrorMessage", "quantityErrorMessage", "placeholder", "drugSearchText", "drugsImage", "inCabinetErrorMessage", "medCabinetHeader", "genericOptionIcon", "showGenericOption", "genericOptionQuestion", "genericOptionInfo", "genericOptions", "checkDrugCoverageButtonText", "genericOptionDefaultSelection", "showCosts", "drugSearchIntroText", "drugSearchPageHeaderText", "errorKeywordText", "drugSearchFrequencyListBoxLabel", "prescriptionsText", "isBlueButtonEnabled", "blueButtonStartAddingDrugText", "orText", "blueButtonConnectToMyMedicareText", "blueButtonMyMedicareButtonText", "emailLabelText", "emailRequiredErrorText", "emailInvalidErrorText", "sendEmailButtonText", "blueButtonModalHeaderText", "blueButtonModalContent", "blueButtonSuccessText", "blueButtonDownloadText", "blueButtonSuccessMessage", "blueButtonEmailSendText", "blueButtonIssueLoadingText", "blueButtonBeneficiaryDeniedText", "blueButtonErrorLoadingText", "blueButtonBeneficiaryEmailDetails", "blueButtonImportLatestPrescriptionButtonText", "blueButtonImportLatestPrescriptionErrorText", "blueButtonAccessDeniedText", "blueButtonClaimDataLoadingErrorText", "isMemberSessionUpdated", "editDrugText", "isUseCMSDrugFlagEnabled", 4, "ngSwitchCase"], ["vnextGoogleTagManager", "", 3, "tagsToUpdate", "digitalPharmacyEnabled", "retailTabText", "digitalTabText", "digitalTabIntroText", "saveDefaultValues", "addPharmacyButtonText", "pharmacyLimit", "pharmacyMapDefaultZoom", "maxZoom", "minZoom", "currentPharmacyText", "pharmacyAddedLabel", "electronicPrescriptionTooltipHeader", "electronicPrescriptionTooltipBody", "itemsPerPage", "pharmacyPaginationEnabled", "paginationText", "viewNotFoundHeaderText", "viewNotFoundBodyText", "preferredInNetworkText", "standardInNetworkText", "preferredInNetworkTooltipContent", "standardInNetworkTooltipContent", "pharmacySearchIntroText", "pharmacySearchHeaderText", "errorKeywordText", "addedPharmacyText", "addPharmacyText", "pharmacyText", "ePrescribingAltText", "Spa_Site_Tooltip_Text", "zipLabel", "zipErrorText", "pharmacySearchButtonText", "pharmacyNameText", "pharmacyNameHintText", "multiPharmacyEnabled", "maxPharmacyCount", "setAsPrimaryLinkText", "primaryPharmacyText", "pharmacyLimitErrorMessage", "pharmacyFilterText", "isPharmacyFilterEnabled", "isPharmacyInNetworkFilterEnabled", "isPharmacyOtherFilterEnabled", "pharmacyFilterClearText", "pharmacyFilterData", "defaultFilterText", "isPPCSite", "clearAllText", "filterHeaderText", "modalCancelButtonText", "modalApplyButtonText", "countyLabel", "showCountyLabel", "pharmacyInNetworkFilters", 4, "ngSwitchCase"], ["vnextGoogleTagManager", "", 3, "tagsToUpdate", "estimateHealthCost", "saveDefaultValues", "guidedHelpHealthAgeQuestionText", "slideSections", "healthPageProperties", "healthStatusSliderLabel", "healthCostsCustomizationEnabled", "healthCostsBodyText", "toggleYesText", "toggleNoText", "healthCostsBenefitsBodyText", "healthCostsBenefitsTableHeader", "healthCostsUsageTableHeader", "healthCostsDaysTableHeader", "healthCostsRestoreDefaultsText", "healthCostsUpdateAnswersText", "healthCostsSaveAnswersText", "healthCostsBenefits", "saveFailedText", "saveSuccessText", "updateEstimateHealthCost", 4, "ngSwitchCase"], ["vnextGoogleTagManager", "", 3, "tagsToUpdate", "saveDefaultValues", "providersText", "providersBodyText", "providersMultiBodyText", "errorKeywordText", "zipLabel", "zipErrorText", "providerNameText", "providerNameHintText", "providerSearchButtonText", "providerLimit", "itemsPerPage", "providerPaginationEnabled", "viewNotFoundHeaderText", "viewNotFoundBodyText", "paginationText", "maxZoom", "minZoom", "providerMapDefaultZoom", "addProviderText", "providerAddedText", "maxCount", "maxCountErrorMessage", "yourProviderText", "removeProviderText", "setPrimaryCareProviderText", "primaryCareProviderText", "providerFiltersEnabled", "providerFilters", "providerGroupAddedLabelText", "providerGroupAddLabelText", "countyLabel", "showCountyLabel", "addLinkText", "cancelProvidersLabel", "providerSingleSelectEnabled", "selectProviderLabelText", "providerExistsTooltipText", "providerMultiLocationText", "countryCode", "providerLocationsText", "valueBasedCareEnabled", "valueBasedCareIcon", "valueBasedCareText", "generalPracticeOptions", "generalPracticeToolTipText", "generalPracticeLabel", "generalPracticeFilterOptionEnabled", "singleProviderInListEnabled", "updateLinkText", "editLinkText", "showEditLinkEnabled", "valueBasedCareAvailableText", "valueBasedCareLearnMoreLink", "valueBasedCareLearnMoreText", "isValueBasedCareLearnMoreLink2Enabled", "valueBasedCareToggleLabel", "valueBasedCareToggleToolTipText", "valueBasedCareToggleEnabled", "valueBasedCareToggleOptions", "newPatientToggleEnabled", "pcpToggleEnabled", "newPatientToggleOptions", "newPatientToggleLabel", "pcpToggleLabel", "pcpToggleOptions", "newPatientText", "existingPatientText", "vbcNameFilterEnabled", "vbcNameFilterLabel", "selectedProviderOptionsEnabled", "removeText", "selectAllText", "isZelisIntegrationEnabled", "fetchProvidersFromLocation", "setMapCenter", "initializeMap", "setMapDefaultBounds", "addProviders", "addProviderSelectedFromMarker", "fetchProvidersFromAPI", 4, "ngSwitchCase"], [4, "ngSwitchCase"], ["vnextGoogleTagManager", "", 3, "tagsToUpdate", "saveDefaultValues", "optionalLabel", "zipCodeInputZipCodeError", "zipCodeInputCountyError", "zipCodeInputSelectCounty", "zipCodeInputZipCodeLabel", "selectedCountyEnabled", "zipCodeInputEditCounty", "errorKeywordText", "getStartedText", "medicalOnlyDefault", "coverageTextQuestion", "spaPageSubHeader", "accordionHeaderText", "showSubsidyAccordion", "enableDSNPDisplay", "zipCodeIsReadOnly", "zipCodeHintText", "countyLabel", "showCountyLabel", "defaultCoverageTypes", "isMobile"], ["vnextGoogleTagManager", "", 3, "tagsToUpdate", "saveDefaultValues", "frequencyList", "contentSectionText", "dosageHeader", "quantityAndFrequencyHeader", "packageHeader", "addButtonText", "cancelButtonText", "quantityMaxLimit", "medicineCabinetLimit", "cabinetLimitErrorMessage", "quantityErrorMessage", "placeholder", "drugSearchText", "drugsImage", "inCabinetErrorMessage", "medCabinetHeader", "genericOptionIcon", "showGenericOption", "genericOptionQuestion", "genericOptionInfo", "genericOptions", "checkDrugCoverageButtonText", "genericOptionDefaultSelection", "showCosts", "drugSearchIntroText", "drugSearchPageHeaderText", "errorKeywordText", "drugSearchFrequencyListBoxLabel", "prescriptionsText", "isBlueButtonEnabled", "blueButtonStartAddingDrugText", "orText", "blueButtonConnectToMyMedicareText", "blueButtonMyMedicareButtonText", "emailLabelText", "emailRequiredErrorText", "emailInvalidErrorText", "sendEmailButtonText", "blueButtonModalHeaderText", "blueButtonModalContent", "blueButtonSuccessText", "blueButtonDownloadText", "blueButtonSuccessMessage", "blueButtonEmailSendText", "blueButtonIssueLoadingText", "blueButtonBeneficiaryDeniedText", "blueButtonErrorLoadingText", "blueButtonBeneficiaryEmailDetails", "blueButtonImportLatestPrescriptionButtonText", "blueButtonImportLatestPrescriptionErrorText", "blueButtonAccessDeniedText", "blueButtonClaimDataLoadingErrorText", "isMemberSessionUpdated", "editDrugText", "isUseCMSDrugFlagEnabled"], ["vnextGoogleTagManager", "", 3, "tagsToUpdate", "digitalPharmacyEnabled", "retailTabText", "digitalTabText", "digitalTabIntroText", "saveDefaultValues", "addPharmacyButtonText", "pharmacyLimit", "pharmacyMapDefaultZoom", "maxZoom", "minZoom", "currentPharmacyText", "pharmacyAddedLabel", "electronicPrescriptionTooltipHeader", "electronicPrescriptionTooltipBody", "itemsPerPage", "pharmacyPaginationEnabled", "paginationText", "viewNotFoundHeaderText", "viewNotFoundBodyText", "preferredInNetworkText", "standardInNetworkText", "preferredInNetworkTooltipContent", "standardInNetworkTooltipContent", "pharmacySearchIntroText", "pharmacySearchHeaderText", "errorKeywordText", "addedPharmacyText", "addPharmacyText", "pharmacyText", "ePrescribingAltText", "Spa_Site_Tooltip_Text", "zipLabel", "zipErrorText", "pharmacySearchButtonText", "pharmacyNameText", "pharmacyNameHintText", "multiPharmacyEnabled", "maxPharmacyCount", "setAsPrimaryLinkText", "primaryPharmacyText", "pharmacyLimitErrorMessage", "pharmacyFilterText", "isPharmacyFilterEnabled", "isPharmacyInNetworkFilterEnabled", "isPharmacyOtherFilterEnabled", "pharmacyFilterClearText", "pharmacyFilterData", "defaultFilterText", "isPPCSite", "clearAllText", "filterHeaderText", "modalCancelButtonText", "modalApplyButtonText", "countyLabel", "showCountyLabel", "pharmacyInNetworkFilters"], ["vnextGoogleTagManager", "", 3, "tagsToUpdate", "estimateHealthCost", "saveDefaultValues", "guidedHelpHealthAgeQuestionText", "slideSections", "healthPageProperties", "healthStatusSliderLabel", "healthCostsCustomizationEnabled", "healthCostsBodyText", "toggleYesText", "toggleNoText", "healthCostsBenefitsBodyText", "healthCostsBenefitsTableHeader", "healthCostsUsageTableHeader", "healthCostsDaysTableHeader", "healthCostsRestoreDefaultsText", "healthCostsUpdateAnswersText", "healthCostsSaveAnswersText", "healthCostsBenefits", "saveFailedText", "saveSuccessText", "updateEstimateHealthCost"], ["vnextGoogleTagManager", "", 3, "tagsToUpdate", "saveDefaultValues", "providersText", "providersBodyText", "providersMultiBodyText", "errorKeywordText", "zipLabel", "zipErrorText", "providerNameText", "providerNameHintText", "providerSearchButtonText", "providerLimit", "itemsPerPage", "providerPaginationEnabled", "viewNotFoundHeaderText", "viewNotFoundBodyText", "paginationText", "maxZoom", "minZoom", "providerMapDefaultZoom", "addProviderText", "providerAddedText", "maxCount", "maxCountErrorMessage", "yourProviderText", "removeProviderText", "setPrimaryCareProviderText", "primaryCareProviderText", "providerFiltersEnabled", "providerFilters", "providerGroupAddedLabelText", "providerGroupAddLabelText", "countyLabel", "showCountyLabel", "addLinkText", "cancelProvidersLabel", "providerSingleSelectEnabled", "selectProviderLabelText", "providerExistsTooltipText", "providerMultiLocationText", "countryCode", "providerLocationsText", "valueBasedCareEnabled", "valueBasedCareIcon", "valueBasedCareText", "generalPracticeOptions", "generalPracticeToolTipText", "generalPracticeLabel", "generalPracticeFilterOptionEnabled", "singleProviderInListEnabled", "updateLinkText", "editLinkText", "showEditLinkEnabled", "valueBasedCareAvailableText", "valueBasedCareLearnMoreLink", "valueBasedCareLearnMoreText", "isValueBasedCareLearnMoreLink2Enabled", "valueBasedCareToggleLabel", "valueBasedCareToggleToolTipText", "valueBasedCareToggleEnabled", "valueBasedCareToggleOptions", "newPatientToggleEnabled", "pcpToggleEnabled", "newPatientToggleOptions", "newPatientToggleLabel", "pcpToggleLabel", "pcpToggleOptions", "newPatientText", "existingPatientText", "vbcNameFilterEnabled", "vbcNameFilterLabel", "selectedProviderOptionsEnabled", "removeText", "selectAllText", "isZelisIntegrationEnabled", "fetchProvidersFromLocation", "setMapCenter", "initializeMap", "setMapDefaultBounds", "addProviders", "addProviderSelectedFromMarker", "fetchProvidersFromAPI"], [3, "preferencesText", "spaPageSubHeader", "noQuestionsText", "availablePages", "preferencesLink", "currentPage", "pageCountText", "enterZipText", "provideZipText", "zipCodeInputZipCodeError", "zipCodeInputCountyError", "zipCodeInputSelectCounty", "zipCodeInputZipCodeLabel", "selectedCountyEnabled", "zipCodeInputEditCounty", "errorKeywordText", "countyLabel", "showCountyLabel", 4, "ngIf"], [3, "preferencesText", "spaPageSubHeader", "noQuestionsText", "availablePages", "preferencesLink", "currentPage", "pageCountText", "enterZipText", "provideZipText", "zipCodeInputZipCodeError", "zipCodeInputCountyError", "zipCodeInputSelectCounty", "zipCodeInputZipCodeLabel", "selectedCountyEnabled", "zipCodeInputEditCounty", "errorKeywordText", "countyLabel", "showCountyLabel"], [1, "pr-2", 3, "title", "isLinkButton", "showArrow", "makeInlineBlock", "click", "keyup.enter"], ["class", "pr-3", 3, "title", "isLinkButton", "showArrow", "makeInlineBlock", "click", "keyup.enter", 4, "liveEditProp"], [1, "pr-3", 3, "title", "isLinkButton", "showArrow", "makeInlineBlock", "click", "keyup.enter"]], template: function GuidedHelpComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵelement(3, "vnext-guided-help-navigation", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, GuidedHelpComponent_div_4_Template, 8, 7, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 1)(6, "vnext-navigation-banner", 5)(7, "div", 6);
        i0.ɵɵtemplate(8, GuidedHelpComponent_vnext_link_8_Template, 1, 4, "vnext-link", 7);
        i0.ɵɵtemplate(9, GuidedHelpComponent_ng_container_9_Template, 2, 1, "ng-container", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 9);
        i0.ɵɵtemplate(11, GuidedHelpComponent_ng_container_11_Template, 2, 1, "ng-container", 8);
        i0.ɵɵelementStart(12, "button", 10);
        i0.ɵɵlistener("click", function GuidedHelpComponent_Template_button_click_12_listener() { return ctx.onContinueClick(); });
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("isRetentionView", ctx.isRetentionView)("isQuotingSite", ctx.isQuotingSite)("goToLinkText", ctx.goToLinkText)("goToLinkKeyNamesForLiveEdit", ctx.goToLinkKeyNamesForLiveEdit)("completedText", ctx.Spa_Site_Completed_Text)("notVisitedText", ctx.Spa_Site_Not_Visited_Text)("currentText", ctx.Spa_Site_Current_Text);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.activeLink);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("providedPrevious", true)("showPrevious", true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_Previous");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isMobile && !ctx.isLastPhysicalLink);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isMobile && !ctx.isLastPhysicalLink);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.Spa_GuidedHelp_Continue_Button, " ");
    } }, dependencies: [i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, NavigationBannerComponent, LinkComponent, LiveEditPropDirective, GoogleTagManagerDirective, DrugSearchComponent, ProviderSearchComponent, GuidedHelpNavigationComponent, PharmacySearchComponent, GuidedHelpGetStartedComponent, GuidedHelpOtherPreferencesComponent, HealthComponent, i1$2.AsyncPipe], styles: [".container[_ngcontent-%COMP%]{margin-top:40px}.banner-margin[_ngcontent-%COMP%]{margin-right:auto;margin-left:10px}"], changeDetection: 0 });
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_PlansLink_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_SummaryLink_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_Site_Previous", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_OptionalLabel_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_Health_AgeQuestion_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_GetStarted_ZipCode_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], GuidedHelpComponent.prototype, "Spa_Site_Health_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_Site_Pharmacy_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_Site_GetStarted_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_Site_Prescriptions_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_Site_OtherPreferences_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], GuidedHelpComponent.prototype, "Spa_Site_Health_Body_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_Health_SliderHeader1_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_Health_SliderHeader2_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_Health_SliderHeader3_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_Health_SliderBody1", void 0);
__decorate([
    PlatformProp('live-edit', true)
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_Health_SliderBody2", void 0);
__decorate([
    PlatformProp('live-edit', true)
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_Health_SliderBody3", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_Site_PageSubHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_DrugSearch_Hint_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_DrugSearch_Intro_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_DrugSearch_PageHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_PharmacySearch_Intro_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_PharmacySearch_PageHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_Site_SendEmailButton_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_BlueButton_StartAddDrug_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_BlueButton_MyMedicare_Connect_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_BlueButton_MyMedicare_Button", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_OtherPreferences_NoQuestions_Text", void 0);
__decorate([
    PlatformProp()
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_MedicalOnly_Default", void 0);
__decorate([
    PlatformProp()
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_GettingStarted_CoverageText_Question", void 0);
__decorate([
    PlatformProp()
], GuidedHelpComponent.prototype, "Spa_BlueButton_Modal_Header", void 0);
__decorate([
    PlatformProp()
], GuidedHelpComponent.prototype, "Spa_BlueButton_Modal_Content", void 0);
__decorate([
    PlatformProp()
], GuidedHelpComponent.prototype, "Spa_BlueButton_EmailSentToStatus_Text", void 0);
__decorate([
    PlatformProp()
], GuidedHelpComponent.prototype, "Spa_BlueButton_Issue_Loading_Text", void 0);
__decorate([
    PlatformProp()
], GuidedHelpComponent.prototype, "Spa_BlueButton_Beneficiary_Denied_Text", void 0);
__decorate([
    PlatformProp()
], GuidedHelpComponent.prototype, "Spa_BlueButton_ImportLatestPrescription_Button_Text", void 0);
__decorate([
    PlatformProp()
], GuidedHelpComponent.prototype, "Spa_BlueButton_ImportLatestPrescription_Error_Text", void 0);
__decorate([
    PlatformProp()
], GuidedHelpComponent.prototype, "Spa_BlueButton_AccessDenied_Error_Text", void 0);
__decorate([
    PlatformProp()
], GuidedHelpComponent.prototype, "Spa_BlueButton_ClaimData_Loading_Error_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_BlueButton_Success_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_BlueButton_Download_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_Health_AgeDefault_Number", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_Health_DefaultHealthStatus_Number", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Skip", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_Continue_Button", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_Frequency_List", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_Content_Section_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_Dosage_Header", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_Frequency_Header", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_Package_Header", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_Add_Button", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_Cancel_Button", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_EditDrug_Button", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_Quantity_Max_Limit", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_Cabinet_Limit", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_MaxCount_Error_Message", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_Quantity_Error_Message", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_Label_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_Drugs_Image", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_InCabinetError_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_Medicine_Header", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_GenericOption_Icon", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Show_GenericDrugOption", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_GenericOption_Question", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_GenericOption_Info", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_GenericOptions", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_CheckDrugCoverageButton_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_GenericOption_Default_Selection", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugListCard_HideCosts_Flag", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Add_Pharmacy_Button", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Pharmacy_Limit", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_Limit", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_PharmacyMap_Default_Zoom", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_ProviderMap_Default_Zoom", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_PharmacyMap_Max_Zoom", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_PharmacyMap_Min_Zoom", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_ProviderMap_Max_Zoom", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_ProviderMap_Min_Zoom", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_AddPharmacy_YourPharmacyText", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Pharmacy_Added_Label", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_SearchButton_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_PharmacyName_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_ProviderName_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_PharmacyName_HintText", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_ProviderName_HintText", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_ElectronicPrescription_ToolTipHeader", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_ElectronicPrescription_ToolTipBody", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Pharmacy_Not_Found_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_PharmacySearch_Pagination_ItemsPerPage", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_ProviderSearch_Pagination_ItemsPerPage", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_PharmacySearch_Pagination_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_ProviderSearch_Pagination_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_PharmacySearch_Pagination_View_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_ProviderSearch_Pagination_View_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Pharmacy_Alt_View_Not_Found_Header_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_Alt_View_Not_Found_Header_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Pharmacy_Alt_View_Not_Found_Body_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_Alt_View_Not_Found_Body_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Preferred_In_Network_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Standard_In_Network_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_PharmacySearch_Standard_In_Network_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_ZipCodeInput_ZipCodeError", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_ZipCodeInput_CountyError", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_ZipCodeInput_SelectCounty", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_ZipCodeInput_ZipCodeLabel", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_ZipCodeInput_EditCounty", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_ZipCodeInput_SelectedCountyEnabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_ErrorKeyword_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_DrugSearch_Frequency_ListBox_Label", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Pharmacy_Added_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Pharmacy_Add_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Health_Slider_Label_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Enable_BlueButton", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_OrText", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_EmailAddress_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Profile_EmailRequired_Error", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Profile_EmailInvalid_Error", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_BlueButton_Success_Message", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_BlueButton_Error_Loading_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_BlueButton_Beneficiary_Email_Details", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_EPrescribing_Alt_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Completed_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Not_Visited_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Current_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_SiteType", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_GettingStarted_SubsidyHeader_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_GettingStarted_ShowSubsidyAccordion_Flag", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Multi_Pharmacy_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Maximum_Pharmacy_Count", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Set_Primary_Pharmacy_Link_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Primary_Pharmacy_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Primary_Pharmacy_Icon", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Primary_Pharmacy_Icon_Color", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_PharmacySearch_MultiPharmacy_Intro_Text", void 0);
__decorate([
    GlobalResource(true)
], GuidedHelpComponent.prototype, "Spa_Site_Pharmacy_Limit_Error_Message", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_Site_Providers_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_Site_Providers_Body_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_Multi_Providers_Body_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_Site_AddPharmacy_YourMultiPharmacyText", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_OtherPreferences_PageCount_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_OtherPreferences_EnterZip_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_OtherPreferences_ProvideZip_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Filter_Header_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Pharmacy_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Pharmacy_In_Network_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Pharmacy_Other_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Filter_Clear_All", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Pharmacy_Filter_Open24hrs_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Pharmacy_Filter_Eprescribing_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Pharmacy_Filter_HandicapAccess_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Pharmacy_Filter_DurableEquipment_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Pharmacy_Filter_MailOrder_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Filter_Default_Filter_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Filter_Badge_Color", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_OtherPreferences_Enabled", void 0);
__decorate([
    PlatformProp()
], GuidedHelpComponent.prototype, "Spa_Pharmacy_Filters", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_Add_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_Added_Text", void 0);
__decorate([
    GlobalResource(true)
], GuidedHelpComponent.prototype, "Spa_Provider_Add_Maximum_Limit_Message", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_RemoveProvider_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_Provider_YourProvider_Text", void 0);
__decorate([
    PlatformProp()
], GuidedHelpComponent.prototype, "Spa_Provider_Set_Primary_Care_Provider_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_Primary_Care_Provider_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Providers_Filter_Enabled", void 0);
__decorate([
    GlobalResource(true)
], GuidedHelpComponent.prototype, "Spa_Providers_Filter_Individuals_Text", void 0);
__decorate([
    GlobalResource(true)
], GuidedHelpComponent.prototype, "Spa_Providers_Filter_Facilties_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Group_Provider_Add_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Group_Provider_Added_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Preferences_Score_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Show_Preferences_Score", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Preferences_Weight_Provider", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Preferences_Weight_Drug", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Preferences_Weight_Pharmacy", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Preferences_Weight_Chronic", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Preferences_Weight_Benefits", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Preferences_Weight_Medsup", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_PlanList_Sort_By_PreferenceScore_Label", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_GettingStarted_EnableDSNPDisplay_Flag", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_Preference_Questions", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_PlanFilters_Modal_Cancel_Button", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_PlanFilters_Modal_Apply_Button", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Drugs_UseCMSDrugFlag_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Pharmacy_In_Network_Filters", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Add", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Cancel", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Select_Single_Provider_For_Multi_Address_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Select_Provider_Location_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_Exists_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_Multiple_Location_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_HealthCosts_Customization_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_HealthCosts_Restore_Defaults_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_HealthCosts_Update_Answers_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_HealthCosts_Save_Answers_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_HealthCosts_Benefits_JSON", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_HealthCosts_Save_Failed_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_HealthCosts_Save_Success_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_HealthCosts_Benefits_Body_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_Site_HealthCosts_Benefits_Table_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_Site_HealthCosts_Usage_Table_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_Site_HealthCosts_Days_Table_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], GuidedHelpComponent.prototype, "Spa_HealthCosts_Body_Text", void 0);
__decorate([
    PlatformProp()
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_GettingStarted_CoverageTypes", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_PlanCard_EditLink_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_GuidedHelp_SubsidyLabel_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Plan_Providers_Locations_Link_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_ValueBasedCare_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_ValueBasedCare_Icon", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_ValueBasedCare_Text", void 0);
__decorate([
    GlobalResource(true)
], GuidedHelpComponent.prototype, "Spa_Site_ValueBasedCare_Filter_Enabled", void 0);
__decorate([
    GlobalResource(true)
], GuidedHelpComponent.prototype, "Spa_ValueBasedCare_Filter_Text", void 0);
__decorate([
    GlobalResource(true)
], GuidedHelpComponent.prototype, "Spa_ValueBasedCare_Filter_Checked", void 0);
__decorate([
    GlobalResource(true)
], GuidedHelpComponent.prototype, "Spa_ValueBasedCare_LearnMore_Text", void 0);
__decorate([
    GlobalResource(true)
], GuidedHelpComponent.prototype, "Spa_ValueBasedCare_LearnMoreLink_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_Search_Filter_General_Practice_Options", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_Search_General_Practice_Label_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_Search_General_Practice_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_Search_Filter_General_Practice_Option_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Digital_Pharmacy_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Pharmacy_Retail_Tab_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Pharmacy_Digital_Tab_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Pharmacy_Digital_Tab_Intro_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_Search_ShowSingleProviderInList_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Edit_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Update_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_ShowEditLink_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_ValueBasedCare_Available_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_ValueBasedCare_LearnMore_Link", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_ValueBasedCare_LearnMoreLink2_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_ValueBasedCare_Toggle_Label", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_ValueBasedCare_Toggle_ToolTip_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_ValueBasedCare_Toggle_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_Search_Filter_ValueBasedCare_Options", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_New_Patient_Toggle_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_New_Patient_Toggle_Label", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_New_Patient_Options", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Primary_Care_Provider_Toggle_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Primary_Care_Provider_Toggle_Label", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Primary_Care_Provider_Options", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_New_Patient_For_Provider_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Existing_Patient_For_Provider_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_ValueBasedCare_Name_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Provider_ValueBasedCare_Name_Filter_Label", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Selected_Provider_Options_Enabled", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_Remove_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_SelectAll_Text", void 0);
__decorate([
    GlobalResource()
], GuidedHelpComponent.prototype, "Spa_Site_ZelisIntegration_Enabled", void 0);
__decorate([
    LiveEditInactive()
], GuidedHelpComponent.prototype, "onContinueClick", null);
__decorate([
    LiveEditInactive()
], GuidedHelpComponent.prototype, "onSkipClick", null);
__decorate([
    LiveEditInactive()
], GuidedHelpComponent.prototype, "onPreviousClick", null);
GuidedHelpComponent = __decorate([
    PlatformWidget
], GuidedHelpComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuidedHelpComponent, [{
        type: Component,
        args: [{ selector: 'vnext-guided-help', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-3 col-xs-12\">\r\n      <vnext-guided-help-navigation\r\n        [isRetentionView]=\"isRetentionView\"\r\n        [isQuotingSite]=\"isQuotingSite\"\r\n        [goToLinkText]=\"goToLinkText\"\r\n        [goToLinkKeyNamesForLiveEdit]=\"goToLinkKeyNamesForLiveEdit\"\r\n        [completedText]=\"Spa_Site_Completed_Text\"\r\n        [notVisitedText]=\"Spa_Site_Not_Visited_Text\"\r\n        [currentText]=\"Spa_Site_Current_Text\"\r\n      ></vnext-guided-help-navigation>\r\n    </div>\r\n\r\n    <div *ngIf=\"activeLink\" class=\"col-md-9 col-xs-12\">\r\n      <ng-container [ngSwitch]=\"activeLink.pageTag\">\r\n        <vnext-get-started\r\n          *ngSwitchCase=\"pageTags.GUIDED_HELP_GETTING_STARTED\"\r\n          vnextGoogleTagManager\r\n          [tagsToUpdate]=\"tagsToUpdate\"\r\n          [saveDefaultValues]=\"analyticsService.isDefaultTagToUpdate\"\r\n          [optionalLabel]=\"Spa_GuidedHelp_OptionalLabel_Text\"\r\n          [zipCodeInputZipCodeError]=\"Spa_Site_ZipCodeInput_ZipCodeError\"\r\n          [zipCodeInputCountyError]=\"Spa_Site_ZipCodeInput_CountyError\"\r\n          [zipCodeInputSelectCounty]=\"Spa_Site_ZipCodeInput_SelectCounty\"\r\n          [zipCodeInputZipCodeLabel]=\"Spa_Site_ZipCodeInput_ZipCodeLabel\"\r\n          [selectedCountyEnabled]=\"Spa_Site_ZipCodeInput_SelectedCountyEnabled\"\r\n          [zipCodeInputEditCounty]=\"Spa_Site_ZipCodeInput_EditCounty\"\r\n          [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n          [getStartedText]=\"Spa_Site_GetStarted_Text\"\r\n          [medicalOnlyDefault]=\"Spa_GuidedHelp_MedicalOnly_Default\"\r\n          [coverageTextQuestion]=\"Spa_GuidedHelp_GettingStarted_CoverageText_Question\"\r\n          [spaPageSubHeader]=\"Spa_Site_PageSubHeader_Text\"\r\n          [accordionHeaderText]=\"Spa_GettingStarted_SubsidyHeader_Text\"\r\n          [showSubsidyAccordion]=\"Spa_GettingStarted_ShowSubsidyAccordion_Flag\"\r\n          [enableDSNPDisplay]=\"Spa_GettingStarted_EnableDSNPDisplay_Flag\"\r\n          [zipCodeIsReadOnly]=\"ssoPopulatedFieldService.isFieldReadOnly$('Demographic.ZipCode') | async\"\r\n          [zipCodeHintText]=\"Spa_GuidedHelp_GetStarted_ZipCode_Text\"\r\n          [countyLabel]=\"Spa_ZipCodeInput_CountyLabel_Text\"\r\n          [showCountyLabel]=\"Spa_ZipCodeInput_CountyLabel_Enabled\"\r\n          [defaultCoverageTypes]=\"Spa_GuidedHelp_GettingStarted_CoverageTypes\"\r\n          [isMobile]=\"isMobile\"\r\n        ></vnext-get-started>\r\n        <vnext-widget-drug-search\r\n          *ngSwitchCase=\"pageTags.GUIDED_HELP_PRESCRIPTIONS\"\r\n          vnextGoogleTagManager\r\n          [tagsToUpdate]=\"tagsToUpdate\"\r\n          [saveDefaultValues]=\"analyticsService.isDefaultTagToUpdate\"\r\n          [frequencyList]=\"drugSearchFrequencyList\"\r\n          [contentSectionText]=\"Spa_DrugSearch_Content_Section_Text\"\r\n          [dosageHeader]=\"Spa_DrugSearch_Dosage_Header\"\r\n          [quantityAndFrequencyHeader]=\"Spa_DrugSearch_Frequency_Header\"\r\n          [packageHeader]=\"Spa_DrugSearch_Package_Header\"\r\n          [addButtonText]=\"Spa_DrugSearch_Add_Button\"\r\n          [cancelButtonText]=\"Spa_DrugSearch_Cancel_Button\"\r\n          [quantityMaxLimit]=\"Spa_DrugSearch_Quantity_Max_Limit\"\r\n          [medicineCabinetLimit]=\"Spa_DrugSearch_Cabinet_Limit\"\r\n          [cabinetLimitErrorMessage]=\"Spa_DrugSearch_MaxCount_Error_Message\"\r\n          [quantityErrorMessage]=\"Spa_DrugSearch_Quantity_Error_Message\"\r\n          [placeholder]=\"Spa_DrugSearch_Hint_Text\"\r\n          [drugSearchText]=\"Spa_DrugSearch_Label_Text\"\r\n          [drugsImage]=\"Spa_DrugSearch_Drugs_Image\"\r\n          [inCabinetErrorMessage]=\"Spa_DrugSearch_InCabinetError_Text\"\r\n          [medCabinetHeader]=\"Spa_DrugSearch_Medicine_Header\"\r\n          [genericOptionIcon]=\"Spa_DrugSearch_GenericOption_Icon\"\r\n          [showGenericOption]=\"Spa_Site_Show_GenericDrugOption\"\r\n          [genericOptionQuestion]=\"Spa_DrugSearch_GenericOption_Question\"\r\n          [genericOptionInfo]=\"Spa_DrugSearch_GenericOption_Info\"\r\n          [genericOptions]=\"Spa_DrugSearch_GenericOptions\"\r\n          [checkDrugCoverageButtonText]=\"Spa_DrugSearch_CheckDrugCoverageButton_Text\"\r\n          [genericOptionDefaultSelection]=\"Spa_DrugSearch_GenericOption_Default_Selection\"\r\n          [showCosts]=\"Spa_DrugListCard_HideCosts_Flag\"\r\n          [drugSearchIntroText]=\"Spa_DrugSearch_Intro_Text\"\r\n          [drugSearchPageHeaderText]=\"Spa_DrugSearch_PageHeader_Text\"\r\n          [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n          [drugSearchFrequencyListBoxLabel]=\"Spa_DrugSearch_Frequency_ListBox_Label\"\r\n          [prescriptionsText]=\"Spa_Site_Prescriptions_Text\"\r\n          [isBlueButtonEnabled]=\"Spa_Site_Enable_BlueButton\"\r\n          [blueButtonStartAddingDrugText]=\"Spa_BlueButton_StartAddDrug_Text\"\r\n          [orText]=\"Spa_Site_OrText\"\r\n          [blueButtonConnectToMyMedicareText]=\"Spa_BlueButton_MyMedicare_Connect_Text\"\r\n          [blueButtonMyMedicareButtonText]=\"Spa_BlueButton_MyMedicare_Button\"\r\n          [emailLabelText]=\"Spa_Site_EmailAddress_Text\"\r\n          [emailRequiredErrorText]=\"Spa_Profile_EmailRequired_Error\"\r\n          [emailInvalidErrorText]=\"Spa_Profile_EmailInvalid_Error\"\r\n          [sendEmailButtonText]=\"Spa_Site_SendEmailButton_Text\"\r\n          [blueButtonModalHeaderText]=\"Spa_BlueButton_Modal_Header\"\r\n          [blueButtonModalContent]=\"Spa_BlueButton_Modal_Content\"\r\n          [blueButtonSuccessText]=\"Spa_BlueButton_Success_Text\"\r\n          [blueButtonDownloadText]=\"Spa_BlueButton_Download_Text\"\r\n          [blueButtonSuccessMessage]=\"Spa_BlueButton_Success_Message\"\r\n          [blueButtonEmailSendText]=\"Spa_BlueButton_EmailSentToStatus_Text\"\r\n          [blueButtonIssueLoadingText]=\"Spa_BlueButton_Issue_Loading_Text\"\r\n          [blueButtonBeneficiaryDeniedText]=\"Spa_BlueButton_Beneficiary_Denied_Text\"\r\n          [blueButtonErrorLoadingText]=\"Spa_BlueButton_Error_Loading_Text\"\r\n          [blueButtonBeneficiaryEmailDetails]=\"Spa_BlueButton_Beneficiary_Email_Details\"\r\n          [blueButtonImportLatestPrescriptionButtonText]=\"Spa_BlueButton_ImportLatestPrescription_Button_Text\"\r\n          [blueButtonImportLatestPrescriptionErrorText]=\"Spa_BlueButton_ImportLatestPrescription_Error_Text\"\r\n          [blueButtonAccessDeniedText]=\"Spa_BlueButton_AccessDenied_Error_Text\"\r\n          [blueButtonClaimDataLoadingErrorText]=\"Spa_BlueButton_ClaimData_Loading_Error_Text\"\r\n          [isMemberSessionUpdated]=\"isMemberSessionUpdated\"\r\n          [editDrugText]=\"Spa_DrugSearch_EditDrug_Button\"\r\n          [isUseCMSDrugFlagEnabled]=\"Spa_Drugs_UseCMSDrugFlag_Enabled\"\r\n        >\r\n        </vnext-widget-drug-search>\r\n        <vnext-widget-pharmacy-search\r\n          *ngSwitchCase=\"pageTags.GUIDED_HELP_PHARMACY_SEARCH\"\r\n          vnextGoogleTagManager\r\n          [tagsToUpdate]=\"tagsToUpdate\"\r\n          [digitalPharmacyEnabled]=\"Spa_Site_Digital_Pharmacy_Enabled\"\r\n          [retailTabText]=\"Spa_Pharmacy_Retail_Tab_Text\"\r\n          [digitalTabText]=\"Spa_Pharmacy_Digital_Tab_Text\"\r\n          [digitalTabIntroText]=\"Spa_Pharmacy_Digital_Tab_Intro_Text\"\r\n          [saveDefaultValues]=\"analyticsService.isDefaultTagToUpdate\"\r\n          [addPharmacyButtonText]=\"Spa_Add_Pharmacy_Button\"\r\n          [pharmacyLimit]=\"Spa_Pharmacy_Limit\"\r\n          [pharmacyMapDefaultZoom]=\"Spa_PharmacyMap_Default_Zoom\"\r\n          [maxZoom]=\"Spa_PharmacyMap_Max_Zoom\"\r\n          [minZoom]=\"Spa_PharmacyMap_Min_Zoom\"\r\n          [currentPharmacyText]=\"\r\n            Spa_Site_Multi_Pharmacy_Enabled ? Spa_Site_AddPharmacy_YourMultiPharmacyText : Spa_AddPharmacy_YourPharmacyText\r\n          \"\r\n          [pharmacyAddedLabel]=\"Spa_Pharmacy_Added_Label\"\r\n          [electronicPrescriptionTooltipHeader]=\"Spa_Site_ElectronicPrescription_ToolTipHeader\"\r\n          [electronicPrescriptionTooltipBody]=\"Spa_Site_ElectronicPrescription_ToolTipBody\"\r\n          [itemsPerPage]=\"Spa_PharmacySearch_Pagination_ItemsPerPage\"\r\n          [pharmacyPaginationEnabled]=\"Spa_PharmacySearch_Pagination_Enabled\"\r\n          [paginationText]=\"Spa_PharmacySearch_Pagination_View_Text\"\r\n          [viewNotFoundHeaderText]=\"Spa_Pharmacy_Alt_View_Not_Found_Header_Text\"\r\n          [viewNotFoundBodyText]=\"Spa_Pharmacy_Alt_View_Not_Found_Body_Text\"\r\n          [preferredInNetworkText]=\"Spa_Site_Preferred_In_Network_Text\"\r\n          [standardInNetworkText]=\"Spa_Site_Standard_In_Network_Text\"\r\n          [preferredInNetworkTooltipContent]=\"Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text\"\r\n          [standardInNetworkTooltipContent]=\"Spa_PharmacySearch_Standard_In_Network_Tooltip_Text\"\r\n          [pharmacySearchIntroText]=\"\r\n            Spa_Site_Multi_Pharmacy_Enabled ? Spa_PharmacySearch_MultiPharmacy_Intro_Text : Spa_PharmacySearch_Intro_Text\r\n          \"\r\n          [pharmacySearchHeaderText]=\"Spa_PharmacySearch_PageHeader_Text\"\r\n          [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n          [addedPharmacyText]=\"Spa_Site_Pharmacy_Added_Text\"\r\n          [addPharmacyText]=\"Spa_Site_Pharmacy_Add_Text\"\r\n          [pharmacyText]=\"Spa_Site_Pharmacy_Text\"\r\n          [ePrescribingAltText]=\"Spa_Site_EPrescribing_Alt_Text\"\r\n          [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n          [zipLabel]=\"Spa_Site_ZipCodeInput_ZipCodeLabel\"\r\n          [zipErrorText]=\"Spa_Site_ZipCodeInput_ZipCodeError\"\r\n          [pharmacySearchButtonText]=\"Spa_Site_SearchButton_Text\"\r\n          [pharmacyNameText]=\"Spa_PharmacyName_Text\"\r\n          [pharmacyNameHintText]=\"Spa_PharmacyName_HintText\"\r\n          [multiPharmacyEnabled]=\"Spa_Site_Multi_Pharmacy_Enabled\"\r\n          [maxPharmacyCount]=\"Spa_Site_Maximum_Pharmacy_Count\"\r\n          [setAsPrimaryLinkText]=\"Spa_Site_Set_Primary_Pharmacy_Link_Text\"\r\n          [primaryPharmacyText]=\"Spa_Site_Primary_Pharmacy_Text\"\r\n          [pharmacyLimitErrorMessage]=\"pharmacyLimitCountErrorMessage\"\r\n          [pharmacyFilterText]=\"Spa_Filter_Header_Text\"\r\n          [isPharmacyFilterEnabled]=\"Spa_Site_Pharmacy_Filter_Enabled\"\r\n          [isPharmacyInNetworkFilterEnabled]=\"Spa_Site_Pharmacy_In_Network_Filter_Enabled\"\r\n          [isPharmacyOtherFilterEnabled]=\"Spa_Site_Pharmacy_Other_Filter_Enabled\"\r\n          [pharmacyFilterClearText]=\"Spa_Filter_Clear_All\"\r\n          [pharmacyFilterData]=\"Spa_Pharmacy_Filters\"\r\n          [defaultFilterText]=\"Spa_Filter_Default_Filter_Text\"\r\n          [isPPCSite]=\"isPPCSite()\"\r\n          [clearAllText]=\"Spa_Filter_Clear_All\"\r\n          [filterHeaderText]=\"Spa_Filter_Header_Text\"\r\n          [modalCancelButtonText]=\"Spa_PlanFilters_Modal_Cancel_Button\"\r\n          [modalApplyButtonText]=\"Spa_PlanFilters_Modal_Apply_Button\"\r\n          [countyLabel]=\"Spa_ZipCodeInput_CountyLabel_Text\"\r\n          [showCountyLabel]=\"Spa_ZipCodeInput_CountyLabel_Enabled\"\r\n          [pharmacyInNetworkFilters]=\"Spa_Pharmacy_In_Network_Filters\"\r\n        >\r\n        </vnext-widget-pharmacy-search>\r\n        <vnext-health\r\n          *ngSwitchCase=\"pageTags.GUIDED_HELP_HEALTH\"\r\n          vnextGoogleTagManager\r\n          [tagsToUpdate]=\"tagsToUpdate\"\r\n          [estimateHealthCost]=\"estimateHealthCost\"\r\n          [saveDefaultValues]=\"analyticsService.isDefaultTagToUpdate\"\r\n          [guidedHelpHealthAgeQuestionText]=\"Spa_GuidedHelp_Health_AgeQuestion_Text\"\r\n          [slideSections]=\"slideSections\"\r\n          [healthPageProperties]=\"healthPageProperties\"\r\n          [healthStatusSliderLabel]=\"Spa_Site_Health_Slider_Label_Text\"\r\n          [healthCostsCustomizationEnabled]=\"Spa_Site_HealthCosts_Customization_Enabled\"\r\n          [healthCostsBodyText]=\"Spa_HealthCosts_Body_Text\"\r\n          [toggleYesText]=\"toggleYesText\"\r\n          [toggleNoText]=\"toggleNoText\"\r\n          [healthCostsBenefitsBodyText]=\"Spa_HealthCosts_Benefits_Body_Text\"\r\n          [healthCostsBenefitsTableHeader]=\"Spa_Site_HealthCosts_Benefits_Table_Header\"\r\n          [healthCostsUsageTableHeader]=\"Spa_Site_HealthCosts_Usage_Table_Header\"\r\n          [healthCostsDaysTableHeader]=\"Spa_Site_HealthCosts_Days_Table_Header\"\r\n          [healthCostsRestoreDefaultsText]=\"Spa_Site_HealthCosts_Restore_Defaults_Text\"\r\n          [healthCostsUpdateAnswersText]=\"Spa_Site_HealthCosts_Update_Answers_Text\"\r\n          [healthCostsSaveAnswersText]=\"Spa_Site_HealthCosts_Save_Answers_Text\"\r\n          [healthCostsBenefits]=\"Spa_Site_HealthCosts_Benefits_JSON\"\r\n          [saveFailedText]=\"Spa_Site_HealthCosts_Save_Failed_Text\"\r\n          [saveSuccessText]=\"Spa_Site_HealthCosts_Save_Success_Text\"\r\n          (updateEstimateHealthCost)=\"updateEstimateHealthCost($event)\"\r\n        >\r\n        </vnext-health>\r\n        <vnext-widget-provider-search\r\n          *ngSwitchCase=\"pageTags.GUIDED_HELP_PROVIDER_SEARCH\"\r\n          vnextGoogleTagManager\r\n          [tagsToUpdate]=\"tagsToUpdate\"\r\n          [saveDefaultValues]=\"analyticsService.isDefaultTagToUpdate\"\r\n          [providersText]=\"Spa_Site_Providers_Text\"\r\n          [providersBodyText]=\"Spa_Site_Providers_Body_Text\"\r\n          [providersMultiBodyText]=\"Spa_Multi_Providers_Body_Text\"\r\n          [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n          [zipLabel]=\"Spa_Site_ZipCodeInput_ZipCodeLabel\"\r\n          [zipErrorText]=\"Spa_Site_ZipCodeInput_ZipCodeError\"\r\n          [providerNameText]=\"Spa_ProviderName_Text\"\r\n          [providerNameHintText]=\"Spa_ProviderName_HintText\"\r\n          [providerSearchButtonText]=\"Spa_Site_SearchButton_Text\"\r\n          [providerLimit]=\"Spa_Provider_Limit\"\r\n          [itemsPerPage]=\"Spa_ProviderSearch_Pagination_ItemsPerPage\"\r\n          [providerPaginationEnabled]=\"Spa_ProviderSearch_Pagination_Enabled\"\r\n          [viewNotFoundHeaderText]=\"Spa_Provider_Alt_View_Not_Found_Header_Text\"\r\n          [viewNotFoundBodyText]=\"Spa_Provider_Alt_View_Not_Found_Body_Text\"\r\n          [paginationText]=\"Spa_ProviderSearch_Pagination_View_Text\"\r\n          [maxZoom]=\"Spa_ProviderMap_Max_Zoom\"\r\n          [minZoom]=\"Spa_ProviderMap_Min_Zoom\"\r\n          [providerMapDefaultZoom]=\"Spa_ProviderMap_Default_Zoom\"\r\n          [addProviderText]=\"Spa_Provider_Add_Text\"\r\n          [providerAddedText]=\"Spa_Provider_Added_Text\"\r\n          [maxCount]=\"addProviderMaxLimit.MAX_COUNT\"\r\n          [maxCountErrorMessage]=\"providerMaxLimitError\"\r\n          [yourProviderText]=\"Spa_Provider_YourProvider_Text\"\r\n          [removeProviderText]=\"Spa_Provider_RemoveProvider_Text\"\r\n          [setPrimaryCareProviderText]=\"Spa_Provider_Set_Primary_Care_Provider_Text\"\r\n          [primaryCareProviderText]=\"Spa_Provider_Primary_Care_Provider_Text\"\r\n          (fetchProvidersFromLocation)=\"fetchProvidersFromLocation($event)\"\r\n          (setMapCenter)=\"mapFacade.setCenterPosition($event)\"\r\n          (initializeMap)=\"mapFacade.initializeMap($event)\"\r\n          (setMapDefaultBounds)=\"mapContextService.setDefaultBounds($event)\"\r\n          (addProviders)=\"providerFacade.addProviders($event)\"\r\n          (addProviderSelectedFromMarker)=\"providerFacade.addProviderSelectedFromMarker($event)\"\r\n          (fetchProvidersFromAPI)=\"providerFacade.fetchProvidersFromAPI($event)\"\r\n          [providerFiltersEnabled]=\"Spa_Providers_Filter_Enabled\"\r\n          [providerFilters]=\"providerFilters\"\r\n          [providerGroupAddedLabelText]=\"Spa_Group_Provider_Added_Text\"\r\n          [providerGroupAddLabelText]=\"Spa_Group_Provider_Add_Text\"\r\n          [countyLabel]=\"Spa_ZipCodeInput_CountyLabel_Text\"\r\n          [showCountyLabel]=\"Spa_ZipCodeInput_CountyLabel_Enabled\"\r\n          [addLinkText]=\"Spa_Site_Add\"\r\n          [cancelProvidersLabel]=\"Spa_Site_Cancel\"\r\n          [providerSingleSelectEnabled]=\"Spa_Select_Single_Provider_For_Multi_Address_Enabled\"\r\n          [selectProviderLabelText]=\"Spa_Select_Provider_Location_Text\"\r\n          [providerExistsTooltipText]=\"Spa_Provider_Exists_Text\"\r\n          [providerMultiLocationText]=\"Spa_Provider_Multiple_Location_Text\"\r\n          [countryCode]=\"countryCode\"\r\n          [providerLocationsText]=\"Spa_Plan_Providers_Locations_Link_Text\"\r\n          [valueBasedCareEnabled]=\"Spa_Site_ValueBasedCare_Enabled\"\r\n          [valueBasedCareIcon]=\"Spa_Site_ValueBasedCare_Icon\"\r\n          [valueBasedCareText]=\"Spa_Site_ValueBasedCare_Text\"\r\n          [generalPracticeOptions]=\"Spa_Provider_Search_Filter_General_Practice_Options\"\r\n          [generalPracticeToolTipText]=\"Spa_Provider_Search_General_Practice_Tooltip_Text\"\r\n          [generalPracticeLabel]=\"Spa_Provider_Search_General_Practice_Label_Text\"\r\n          [generalPracticeFilterOptionEnabled]=\"Spa_Provider_Search_Filter_General_Practice_Option_Enabled\"\r\n          [singleProviderInListEnabled]=\"Spa_Provider_Search_ShowSingleProviderInList_Enabled\"\r\n          [updateLinkText]=\"Spa_Site_Update_Text\"\r\n          [editLinkText]=\"Spa_Site_Edit_Text\"\r\n          [showEditLinkEnabled]=\"Spa_Provider_ShowEditLink_Enabled\"\r\n          [valueBasedCareAvailableText]=\"Spa_ValueBasedCare_Available_Text\"\r\n          [valueBasedCareLearnMoreLink]=\"Spa_ValueBasedCare_LearnMore_Link\"\r\n          [valueBasedCareLearnMoreText]=\"Spa_ValueBasedCare_LearnMore_Text\"\r\n          [isValueBasedCareLearnMoreLink2Enabled]=\"Spa_ValueBasedCare_LearnMoreLink2_Enabled && Spa_Site_ValueBasedCare_Enabled\"\r\n          [valueBasedCareToggleLabel]=\"Spa_ValueBasedCare_Toggle_Label\"\r\n          [valueBasedCareToggleToolTipText]=\"Spa_ValueBasedCare_Toggle_ToolTip_Text\"\r\n          [valueBasedCareToggleEnabled]=\"Spa_ValueBasedCare_Toggle_Enabled && Spa_Site_ValueBasedCare_Enabled\"\r\n          [valueBasedCareToggleOptions]=\"Spa_Provider_Search_Filter_ValueBasedCare_Options\"\r\n          [newPatientToggleEnabled]=\"Spa_Provider_New_Patient_Toggle_Enabled\"\r\n          [pcpToggleEnabled]=\"Spa_Primary_Care_Provider_Toggle_Enabled\"\r\n          [newPatientToggleOptions]=\"Spa_Provider_New_Patient_Options\"\r\n          [newPatientToggleLabel]=\"Spa_Provider_New_Patient_Toggle_Label\"\r\n          [pcpToggleLabel]=\"Spa_Primary_Care_Provider_Toggle_Label\"\r\n          [pcpToggleOptions]=\"Spa_Primary_Care_Provider_Options\"\r\n          [newPatientText]=\"Spa_New_Patient_For_Provider_Text\"\r\n          [existingPatientText]=\"Spa_Existing_Patient_For_Provider_Text\"\r\n          [vbcNameFilterEnabled]=\"Spa_Provider_ValueBasedCare_Name_Filter_Enabled\"\r\n          [vbcNameFilterLabel]=\"Spa_Provider_ValueBasedCare_Name_Filter_Label\"\r\n          [selectedProviderOptionsEnabled]=\"Spa_Selected_Provider_Options_Enabled\"\r\n          [removeText]=\"Spa_Site_Remove_Text\"\r\n          [selectAllText]=\"Spa_Site_SelectAll_Text\"\r\n          [isZelisIntegrationEnabled]=\"Spa_Site_ZelisIntegration_Enabled\"\r\n        >\r\n        </vnext-widget-provider-search>\r\n        <ng-container *ngSwitchCase=\"pageTags.GUIDED_HELP_OTHER_PREFERENCES\">\r\n          <vnext-guided-help-other-preferences\r\n            *ngIf=\"questionsLoaded\"\r\n            [preferencesText]=\"Spa_Site_OtherPreferences_Text\"\r\n            [spaPageSubHeader]=\"Spa_Site_PageSubHeader_Text\"\r\n            [noQuestionsText]=\"Spa_GuidedHelp_OtherPreferences_NoQuestions_Text\"\r\n            [availablePages]=\"availableQuestionPages\"\r\n            [preferencesLink]=\"preferencesLink\"\r\n            [currentPage]=\"currentPreferencesPage\"\r\n            [pageCountText]=\"Spa_OtherPreferences_PageCount_Text\"\r\n            [enterZipText]=\"Spa_GuidedHelp_OtherPreferences_EnterZip_Text\"\r\n            [provideZipText]=\"Spa_GuidedHelp_OtherPreferences_ProvideZip_Text\"\r\n            [zipCodeInputZipCodeError]=\"Spa_Site_ZipCodeInput_ZipCodeError\"\r\n            [zipCodeInputCountyError]=\"Spa_Site_ZipCodeInput_CountyError\"\r\n            [zipCodeInputSelectCounty]=\"Spa_Site_ZipCodeInput_SelectCounty\"\r\n            [zipCodeInputZipCodeLabel]=\"Spa_Site_ZipCodeInput_ZipCodeLabel\"\r\n            [selectedCountyEnabled]=\"Spa_Site_ZipCodeInput_SelectedCountyEnabled\"\r\n            [zipCodeInputEditCounty]=\"Spa_Site_ZipCodeInput_EditCounty\"\r\n            [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n            [countyLabel]=\"Spa_ZipCodeInput_CountyLabel_Text\"\r\n            [showCountyLabel]=\"Spa_ZipCodeInput_CountyLabel_Enabled\"\r\n          ></vnext-guided-help-other-preferences>\r\n        </ng-container>\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <vnext-navigation-banner class=\"col-md-9 offset-md-3\" [providedPrevious]=\"true\" [showPrevious]=\"true\">\r\n      <div previous-link class=\"d-flex justify-content-between\">\r\n        <vnext-link\r\n          [title]=\"Spa_Site_Previous\"\r\n          [isLinkButton]=\"true\"\r\n          [showArrow]=\"'left'\"\r\n          class=\"pr-2\"\r\n          (click)=\"onPreviousClick()\"\r\n          [makeInlineBlock]=\"true\"\r\n          (keyup.enter)=\"onPreviousClick()\"\r\n          *liveEditProp=\"'Spa_Site_Previous'\"\r\n        >\r\n        </vnext-link>\r\n        <ng-container *ngIf=\"isMobile && !isLastPhysicalLink\">\r\n          <vnext-link\r\n            [title]=\"Spa_Site_Skip\"\r\n            [isLinkButton]=\"true\"\r\n            [showArrow]=\"'right'\"\r\n            class=\"pr-2\"\r\n            (click)=\"onSkipClick()\"\r\n            [makeInlineBlock]=\"true\"\r\n            (keyup.enter)=\"onSkipClick()\"\r\n            *liveEditProp=\"'Spa_Site_Skip'\"\r\n          ></vnext-link>\r\n        </ng-container>\r\n      </div>\r\n      <div continue-button>\r\n        <ng-container *ngIf=\"!isMobile && !isLastPhysicalLink\">\r\n          <vnext-link\r\n            [title]=\"Spa_Site_Skip\"\r\n            [isLinkButton]=\"true\"\r\n            [showArrow]=\"'right'\"\r\n            (click)=\"onSkipClick()\"\r\n            (keyup.enter)=\"onSkipClick()\"\r\n            [makeInlineBlock]=\"true\"\r\n            class=\"pr-3\"\r\n            *liveEditProp=\"'Spa_Site_Skip'\"\r\n          ></vnext-link>\r\n        </ng-container>\r\n        <button class=\"btn Spa_Style_PrimaryButton col-xs-12 col-md-auto continue-button\" (click)=\"onContinueClick()\">\r\n          {{ Spa_GuidedHelp_Continue_Button }}\r\n        </button>\r\n      </div>\r\n    </vnext-navigation-banner>\r\n  </div>\r\n</div>\r\n", styles: [".container{margin-top:40px}.banner-margin{margin-right:auto;margin-left:10px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.GuidedHelpService }, { type: i1.DemographicService }, { type: i0.Injector }, { type: i1$1.NgbModal }, { type: i1.MemberSessionService }, { type: i1.SiteService }, { type: i2.Store }, { type: PlanFacade }, { type: AnalyticsService }, { type: PharmacyFacade }, { type: ProviderFacade }, { type: MapFacade }, { type: MapContextService }, { type: i1.SSOPopulatedFieldService }, { type: i1.SpinnerService }, { type: i1.PlansService }, { type: i1.PreferencesService }, { type: i1.PreferencesContextService }, { type: HelpfulToolsService }, { type: ZipCodeContextService }, { type: i1.ConfigResourceService }, { type: i1.LocaleService }, { type: i1.ResponsiveLayoutService }]; }, { Spa_GuidedHelp_PlansLink_Text: [], Spa_GuidedHelp_SummaryLink_Text: [], Spa_Site_Previous: [], Spa_GuidedHelp_OptionalLabel_Text: [], Spa_GuidedHelp_Health_AgeQuestion_Text: [], Spa_GuidedHelp_GetStarted_ZipCode_Text: [], Spa_Site_Health_Text: [], Spa_Site_Pharmacy_Text: [], Spa_Site_GetStarted_Text: [], Spa_Site_Prescriptions_Text: [], Spa_Site_OtherPreferences_Text: [], Spa_Site_Health_Body_Text: [], Spa_GuidedHelp_Health_SliderHeader1_Text: [], Spa_GuidedHelp_Health_SliderHeader2_Text: [], Spa_GuidedHelp_Health_SliderHeader3_Text: [], Spa_GuidedHelp_Health_SliderBody1: [], Spa_GuidedHelp_Health_SliderBody2: [], Spa_GuidedHelp_Health_SliderBody3: [], Spa_Site_PageSubHeader_Text: [], Spa_DrugSearch_Hint_Text: [], Spa_DrugSearch_Intro_Text: [], Spa_DrugSearch_PageHeader_Text: [], Spa_PharmacySearch_Intro_Text: [], Spa_PharmacySearch_PageHeader_Text: [], Spa_Site_SendEmailButton_Text: [], Spa_BlueButton_StartAddDrug_Text: [], Spa_BlueButton_MyMedicare_Connect_Text: [], Spa_BlueButton_MyMedicare_Button: [], Spa_GuidedHelp_OtherPreferences_NoQuestions_Text: [], Spa_GuidedHelp_MedicalOnly_Default: [], Spa_GuidedHelp_GettingStarted_CoverageText_Question: [], Spa_BlueButton_Modal_Header: [], Spa_BlueButton_Modal_Content: [], Spa_BlueButton_EmailSentToStatus_Text: [], Spa_BlueButton_Issue_Loading_Text: [], Spa_BlueButton_Beneficiary_Denied_Text: [], Spa_BlueButton_ImportLatestPrescription_Button_Text: [], Spa_BlueButton_ImportLatestPrescription_Error_Text: [], Spa_BlueButton_AccessDenied_Error_Text: [], Spa_BlueButton_ClaimData_Loading_Error_Text: [], Spa_BlueButton_Success_Text: [], Spa_BlueButton_Download_Text: [], Spa_GuidedHelp_Health_AgeDefault_Number: [], Spa_GuidedHelp_Health_DefaultHealthStatus_Number: [], Spa_Site_Skip: [], Spa_GuidedHelp_Continue_Button: [], Spa_DrugSearch_Frequency_List: [], Spa_DrugSearch_Content_Section_Text: [], Spa_DrugSearch_Dosage_Header: [], Spa_DrugSearch_Frequency_Header: [], Spa_DrugSearch_Package_Header: [], Spa_DrugSearch_Add_Button: [], Spa_DrugSearch_Cancel_Button: [], Spa_DrugSearch_EditDrug_Button: [], Spa_DrugSearch_Quantity_Max_Limit: [], Spa_DrugSearch_Cabinet_Limit: [], Spa_DrugSearch_MaxCount_Error_Message: [], Spa_DrugSearch_Quantity_Error_Message: [], Spa_DrugSearch_Label_Text: [], Spa_DrugSearch_Drugs_Image: [], Spa_DrugSearch_InCabinetError_Text: [], Spa_DrugSearch_Medicine_Header: [], Spa_DrugSearch_GenericOption_Icon: [], Spa_Site_Show_GenericDrugOption: [], Spa_DrugSearch_GenericOption_Question: [], Spa_DrugSearch_GenericOption_Info: [], Spa_DrugSearch_GenericOptions: [], Spa_DrugSearch_CheckDrugCoverageButton_Text: [], Spa_DrugSearch_GenericOption_Default_Selection: [], Spa_DrugListCard_HideCosts_Flag: [], Spa_Add_Pharmacy_Button: [], Spa_Pharmacy_Limit: [], Spa_Provider_Limit: [], Spa_PharmacyMap_Default_Zoom: [], Spa_ProviderMap_Default_Zoom: [], Spa_PharmacyMap_Max_Zoom: [], Spa_PharmacyMap_Min_Zoom: [], Spa_ProviderMap_Max_Zoom: [], Spa_ProviderMap_Min_Zoom: [], Spa_AddPharmacy_YourPharmacyText: [], Spa_Pharmacy_Added_Label: [], Spa_Site_SearchButton_Text: [], Spa_PharmacyName_Text: [], Spa_ProviderName_Text: [], Spa_PharmacyName_HintText: [], Spa_ProviderName_HintText: [], Spa_Site_ElectronicPrescription_ToolTipHeader: [], Spa_Site_ElectronicPrescription_ToolTipBody: [], Spa_Pharmacy_Not_Found_Text: [], Spa_PharmacySearch_Pagination_ItemsPerPage: [], Spa_ProviderSearch_Pagination_ItemsPerPage: [], Spa_PharmacySearch_Pagination_Enabled: [], Spa_ProviderSearch_Pagination_Enabled: [], Spa_PharmacySearch_Pagination_View_Text: [], Spa_ProviderSearch_Pagination_View_Text: [], Spa_Pharmacy_Alt_View_Not_Found_Header_Text: [], Spa_Provider_Alt_View_Not_Found_Header_Text: [], Spa_Pharmacy_Alt_View_Not_Found_Body_Text: [], Spa_Provider_Alt_View_Not_Found_Body_Text: [], Spa_Site_Preferred_In_Network_Text: [], Spa_Site_Standard_In_Network_Text: [], Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text: [], Spa_PharmacySearch_Standard_In_Network_Tooltip_Text: [], Spa_Site_ZipCodeInput_ZipCodeError: [], Spa_Site_ZipCodeInput_CountyError: [], Spa_Site_ZipCodeInput_SelectCounty: [], Spa_Site_ZipCodeInput_ZipCodeLabel: [], Spa_Site_ZipCodeInput_EditCounty: [], Spa_Site_ZipCodeInput_SelectedCountyEnabled: [], Spa_Site_ErrorKeyword_Text: [], Spa_DrugSearch_Frequency_ListBox_Label: [], Spa_Site_Pharmacy_Added_Text: [], Spa_Site_Pharmacy_Add_Text: [], Spa_Site_Health_Slider_Label_Text: [], Spa_Site_Enable_BlueButton: [], Spa_Site_OrText: [], Spa_Site_EmailAddress_Text: [], Spa_Profile_EmailRequired_Error: [], Spa_Profile_EmailInvalid_Error: [], Spa_BlueButton_Success_Message: [], Spa_BlueButton_Error_Loading_Text: [], Spa_BlueButton_Beneficiary_Email_Details: [], Spa_Site_EPrescribing_Alt_Text: [], Spa_Site_Completed_Text: [], Spa_Site_Not_Visited_Text: [], Spa_Site_Current_Text: [], Spa_Site_Tooltip_Text: [], Spa_Site_SiteType: [], Spa_GettingStarted_SubsidyHeader_Text: [], Spa_GettingStarted_ShowSubsidyAccordion_Flag: [], Spa_Site_Multi_Pharmacy_Enabled: [], Spa_Site_Maximum_Pharmacy_Count: [], Spa_Site_Set_Primary_Pharmacy_Link_Text: [], Spa_Site_Primary_Pharmacy_Text: [], Spa_Site_Primary_Pharmacy_Icon: [], Spa_Site_Primary_Pharmacy_Icon_Color: [], Spa_PharmacySearch_MultiPharmacy_Intro_Text: [], Spa_Site_Pharmacy_Limit_Error_Message: [], Spa_Site_Providers_Text: [], Spa_Site_Providers_Body_Text: [], Spa_Multi_Providers_Body_Text: [], Spa_Site_AddPharmacy_YourMultiPharmacyText: [], Spa_OtherPreferences_PageCount_Text: [], Spa_GuidedHelp_OtherPreferences_EnterZip_Text: [], Spa_GuidedHelp_OtherPreferences_ProvideZip_Text: [], Spa_Filter_Header_Text: [], Spa_Site_Pharmacy_Filter_Enabled: [], Spa_Site_Pharmacy_In_Network_Filter_Enabled: [], Spa_Site_Pharmacy_Other_Filter_Enabled: [], Spa_Filter_Clear_All: [], Spa_Pharmacy_Filter_Open24hrs_Text: [], Spa_Pharmacy_Filter_Eprescribing_Text: [], Spa_Pharmacy_Filter_HandicapAccess_Text: [], Spa_Pharmacy_Filter_DurableEquipment_Text: [], Spa_Pharmacy_Filter_MailOrder_Text: [], Spa_Filter_Default_Filter_Text: [], Spa_Filter_Badge_Color: [], Spa_Site_OtherPreferences_Enabled: [], Spa_Pharmacy_Filters: [], Spa_Provider_Add_Text: [], Spa_Provider_Added_Text: [], Spa_Provider_Add_Maximum_Limit_Message: [], Spa_Provider_RemoveProvider_Text: [], Spa_Provider_YourProvider_Text: [], Spa_Provider_Set_Primary_Care_Provider_Text: [], Spa_Provider_Primary_Care_Provider_Text: [], Spa_Providers_Filter_Enabled: [], Spa_Providers_Filter_Individuals_Text: [], Spa_Providers_Filter_Facilties_Text: [], Spa_Group_Provider_Add_Text: [], Spa_Group_Provider_Added_Text: [], Spa_Site_Preferences_Score_Enabled: [], Spa_Site_Show_Preferences_Score: [], Spa_Site_Preferences_Weight_Provider: [], Spa_Site_Preferences_Weight_Drug: [], Spa_Site_Preferences_Weight_Pharmacy: [], Spa_Site_Preferences_Weight_Chronic: [], Spa_Site_Preferences_Weight_Benefits: [], Spa_Site_Preferences_Weight_Medsup: [], Spa_PlanList_Sort_By_PreferenceScore_Label: [], Spa_GettingStarted_EnableDSNPDisplay_Flag: [], Spa_GuidedHelp_Preference_Questions: [], Spa_PlanFilters_Modal_Cancel_Button: [], Spa_PlanFilters_Modal_Apply_Button: [], Spa_ZipCodeInput_CountyLabel_Text: [], Spa_ZipCodeInput_CountyLabel_Enabled: [], Spa_Drugs_UseCMSDrugFlag_Enabled: [], Spa_Pharmacy_In_Network_Filters: [], Spa_Site_Add: [], Spa_Site_Cancel: [], Spa_Select_Single_Provider_For_Multi_Address_Enabled: [], Spa_Select_Provider_Location_Text: [], Spa_Provider_Exists_Text: [], Spa_Provider_Multiple_Location_Text: [], Spa_Site_HealthCosts_Customization_Enabled: [], Spa_Site_HealthCosts_Restore_Defaults_Text: [], Spa_Site_HealthCosts_Update_Answers_Text: [], Spa_Site_HealthCosts_Save_Answers_Text: [], Spa_Site_HealthCosts_Benefits_JSON: [], Spa_Site_HealthCosts_Save_Failed_Text: [], Spa_Site_HealthCosts_Save_Success_Text: [], Spa_HealthCosts_Benefits_Body_Text: [], Spa_Site_HealthCosts_Benefits_Table_Header: [], Spa_Site_HealthCosts_Usage_Table_Header: [], Spa_Site_HealthCosts_Days_Table_Header: [], Spa_HealthCosts_Body_Text: [], Spa_GuidedHelp_GettingStarted_CoverageTypes: [], Spa_GuidedHelp_PlanCard_EditLink_Text: [], Spa_GuidedHelp_SubsidyLabel_Text: [], Spa_Plan_Providers_Locations_Link_Text: [], Spa_Site_ValueBasedCare_Enabled: [], Spa_Site_ValueBasedCare_Icon: [], Spa_Site_ValueBasedCare_Text: [], Spa_Site_ValueBasedCare_Filter_Enabled: [], Spa_ValueBasedCare_Filter_Text: [], Spa_ValueBasedCare_Filter_Checked: [], Spa_ValueBasedCare_LearnMore_Text: [], Spa_ValueBasedCare_LearnMoreLink_Enabled: [], Spa_Provider_Search_Filter_General_Practice_Options: [], Spa_Provider_Search_General_Practice_Label_Text: [], Spa_Provider_Search_General_Practice_Tooltip_Text: [], Spa_Provider_Search_Filter_General_Practice_Option_Enabled: [], Spa_Site_Digital_Pharmacy_Enabled: [], Spa_Pharmacy_Retail_Tab_Text: [], Spa_Pharmacy_Digital_Tab_Text: [], Spa_Pharmacy_Digital_Tab_Intro_Text: [], Spa_Provider_Search_ShowSingleProviderInList_Enabled: [], Spa_Site_Edit_Text: [], Spa_Site_Update_Text: [], Spa_Provider_ShowEditLink_Enabled: [], Spa_ValueBasedCare_Available_Text: [], Spa_ValueBasedCare_LearnMore_Link: [], Spa_ValueBasedCare_LearnMoreLink2_Enabled: [], Spa_ValueBasedCare_Toggle_Label: [], Spa_ValueBasedCare_Toggle_ToolTip_Text: [], Spa_ValueBasedCare_Toggle_Enabled: [], Spa_Provider_Search_Filter_ValueBasedCare_Options: [], Spa_Provider_New_Patient_Toggle_Enabled: [], Spa_Provider_New_Patient_Toggle_Label: [], Spa_Provider_New_Patient_Options: [], Spa_Primary_Care_Provider_Toggle_Enabled: [], Spa_Primary_Care_Provider_Toggle_Label: [], Spa_Primary_Care_Provider_Options: [], Spa_New_Patient_For_Provider_Text: [], Spa_Existing_Patient_For_Provider_Text: [], Spa_Provider_ValueBasedCare_Name_Filter_Enabled: [], Spa_Provider_ValueBasedCare_Name_Filter_Label: [], Spa_Selected_Provider_Options_Enabled: [], Spa_Site_Remove_Text: [], Spa_Site_SelectAll_Text: [], Spa_Site_ZelisIntegration_Enabled: [], onContinueClick: [], onSkipClick: [], onPreviousClick: [] }); })();

const _c0$1S = function (a0) { return { Spa_Style_Bold_Weight: a0 }; };
function ClientNavigationHeaderComponent_div_3_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function ClientNavigationHeaderComponent_div_3_button_4_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r8); const link_r5 = restoredCtx.$implicit; const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.navigate(link_r5)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r5 = ctx.$implicit;
    const index_r6 = ctx.index;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0$1S, ctx_r4.isCurrentPlanYear(link_r5)));
    i0.ɵɵattribute("aria-posinset", index_r6 + 1)("aria-setsize", ctx_r4.Spa_Client_Navigation_Navigation_Links.length)("aria-label", link_r5.title);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", link_r5.title, " ");
} }
function ClientNavigationHeaderComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 6)(2, "span", 7);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, ClientNavigationHeaderComponent_div_3_button_4_Template, 2, 7, "button", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.Spa_Client_Navigation_DropDown_Label_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.Spa_Client_Navigation_Navigation_Links);
} }
function ClientNavigationHeaderComponent_ng_template_4_div_5_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function ClientNavigationHeaderComponent_ng_template_4_div_5_button_1_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r14); const link_r11 = restoredCtx.$implicit; const ctx_r13 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r13.navigate(link_r11)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r11 = ctx.$implicit;
    const index_r12 = ctx.index;
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-posinset", index_r12 + 1)("aria-setsize", ctx_r10.Spa_Client_Navigation_Navigation_Links.length)("aria-label", link_r11.title);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", link_r11.title, " ");
} }
function ClientNavigationHeaderComponent_ng_template_4_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, ClientNavigationHeaderComponent_ng_template_4_div_5_button_1_Template, 2, 4, "button", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r9.Spa_Client_Navigation_Navigation_Links);
} }
function ClientNavigationHeaderComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "button", 11)(2, "span", 7);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "i", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ClientNavigationHeaderComponent_ng_template_4_div_5_Template, 2, 1, "div", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.Spa_Client_Navigation_DropDown_Label_Text);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.Spa_Client_Navigation_Navigation_Links == null ? null : ctx_r2.Spa_Client_Navigation_Navigation_Links.length);
} }
function ClientNavigationHeaderComponent_div_6_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function ClientNavigationHeaderComponent_div_6_button_6_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r19); const link_r16 = restoredCtx.$implicit; const ctx_r18 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r18.navigate(link_r16)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r16 = ctx.$implicit;
    const index_r17 = ctx.index;
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-posinset", index_r17 + 1)("aria-setsize", ctx_r15.Spa_Client_Navigation_Optional_Navigation_Links.length)("aria-label", link_r16.title);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", link_r16.title, " ");
} }
function ClientNavigationHeaderComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17)(1, "button", 11)(2, "span", 7);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "i", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 14);
    i0.ɵɵtemplate(6, ClientNavigationHeaderComponent_div_6_button_6_Template, 2, 4, "button", 15);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.Spa_Client_Navigation_Optional_DropDown_Label_Text);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r3.Spa_Client_Navigation_Optional_Navigation_Links);
} }
let ClientNavigationHeaderComponent = class ClientNavigationHeaderComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, configResourceService, zoneService, widgetService, navigationService, googleTagManagerService, planYearResourceService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.cdr = cdr;
        this.widgetValidationService = widgetValidationService;
        this.configurableWidgetService = configurableWidgetService;
        this.configResourceService = configResourceService;
        this.zoneService = zoneService;
        this.widgetService = widgetService;
        this.navigationService = navigationService;
        this.googleTagManagerService = googleTagManagerService;
        this.planYearResourceService = planYearResourceService;
        this.Spa_Client_Navigation_DropDown_Label_Text = 'Medicare';
    }
    navigate(link) {
        this.googleTagManagerService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_HEADER_SWITCH_SITE,
            [DataLayerGlobalVariable.HEADER_SWITCH_SITE_LABEL]: link.title
        };
        const navigationLink = this.getNavigationLink(link);
        if (navigationLink) {
            this.navigationService.navigate(navigationLink);
        }
    }
    isCurrentPlanYear(link) {
        // check if the year in the link title matches the plan year resource
        return link?.title && link?.title === this.planYearResourceService.getSelectedPlanYear();
    }
    getNavigationLink(link) {
        if (link) {
            return link.type
                ? link
                : {
                    ...link,
                    type: LinkType.EXTERNAL
                };
        }
        return null;
    }
};
ClientNavigationHeaderComponent.ɵfac = function ClientNavigationHeaderComponent_Factory(t) { return new (t || ClientNavigationHeaderComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.GoogleTagManagerService), i0.ɵɵdirectiveInject(i1.PlanYearResourceService)); };
ClientNavigationHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ClientNavigationHeaderComponent, selectors: [["vnext-client-navigation-header"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 7, vars: 3, consts: [[1, "Spa_Style_Gray1_Background"], [1, "nav-bar", "container"], [1, "row", "container"], ["class", "row container", 4, "ngIf", "ngIfElse"], ["showLinksAsDropdown", ""], ["class", "col-12 col-md-auto col-lg-3 client-navigation-optional-col", "ngbDropdown", "", 4, "ngIf"], [1, "text-wrap"], [1, "Spa_Style_Primary_Color"], ["role", "option", "class", "text-left text-wrap Spa_Style_Gray1_Background Spa_Style_Primary_Color border-0", "tabindex", "0", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], ["role", "option", "tabindex", "0", 1, "text-left", "text-wrap", "Spa_Style_Gray1_Background", "Spa_Style_Primary_Color", "border-0", 3, "ngClass", "click"], ["ngbDropdown", "", 1, "col-12", "col-md-auto", "col-lg-3", "client-navigation-primary-col"], ["ngbDropdownToggle", "", "aria-haspopup", "listbox", 1, "btn", "client-navigation-dropdown-item", "text-wrap"], ["aria-hidden", "true", 1, "fas", "fa-angle-down", "mt-1", "ml-2", "float-right"], ["ngbDropdownMenu", "", "class", "p-0 mt-0", "role", "listbox", 4, "ngIf"], ["ngbDropdownMenu", "", "role", "listbox", 1, "p-0", "mt-0"], ["ngbDropdownItem", "", "role", "option", "class", "client-navigation-dropdown-item text-left text-wrap Spa_Style_Gray1_Background Spa_Style_Primary_Color", "tabindex", "0", 3, "click", 4, "ngFor", "ngForOf"], ["ngbDropdownItem", "", "role", "option", "tabindex", "0", 1, "client-navigation-dropdown-item", "text-left", "text-wrap", "Spa_Style_Gray1_Background", "Spa_Style_Primary_Color", 3, "click"], ["ngbDropdown", "", 1, "col-12", "col-md-auto", "col-lg-3", "client-navigation-optional-col"]], template: function ClientNavigationHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, ClientNavigationHeaderComponent_div_3_Template, 5, 2, "div", 3);
        i0.ɵɵtemplate(4, ClientNavigationHeaderComponent_ng_template_4_Template, 6, 2, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(6, ClientNavigationHeaderComponent_div_6_Template, 7, 2, "div", 5);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(5);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.Spa_Client_Navigation_Display_Links)("ngIfElse", _r1);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.Spa_Client_Navigation_Optional_Navigation_Links == null ? null : ctx.Spa_Client_Navigation_Optional_Navigation_Links.length);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, IconAriaAttributesDirective, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem], styles: [".client-navigation-dropdown-item[_ngcontent-%COMP%]{overflow:hidden}.client-navigation-dropdown-item[_ngcontent-%COMP%]:hover, .client-navigation-dropdown-item[_ngcontent-%COMP%]:focus{background-color:#fff}.client-navigation-dropdown-item[_ngcontent-%COMP%]:hover{outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:0 0 5px var(--static-Spa_Style_Black)}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], ClientNavigationHeaderComponent.prototype, "Spa_Client_Navigation_DropDown_Label_Text", void 0);
__decorate([
    GlobalResource()
], ClientNavigationHeaderComponent.prototype, "Spa_Client_Navigation_Optional_DropDown_Label_Text", void 0);
__decorate([
    GlobalResource()
], ClientNavigationHeaderComponent.prototype, "Spa_Client_Navigation_Navigation_Links", void 0);
__decorate([
    GlobalResource()
], ClientNavigationHeaderComponent.prototype, "Spa_Client_Navigation_Optional_Navigation_Links", void 0);
__decorate([
    GlobalResource()
], ClientNavigationHeaderComponent.prototype, "Spa_Client_Navigation_Display_Links", void 0);
ClientNavigationHeaderComponent = __decorate([
    PlatformWidget
], ClientNavigationHeaderComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClientNavigationHeaderComponent, [{
        type: Component,
        args: [{ selector: 'vnext-client-navigation-header', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"Spa_Style_Gray1_Background\">\r\n  <div class=\"nav-bar container\">\r\n    <div class=\"row container\">\r\n      <div class=\"row container\" *ngIf=\"Spa_Client_Navigation_Display_Links; else showLinksAsDropdown\">\r\n        <div class=\"text-wrap\">\r\n          <span class=\"Spa_Style_Primary_Color\">{{ Spa_Client_Navigation_DropDown_Label_Text }}</span>\r\n        </div>\r\n        <button\r\n          *ngFor=\"let link of Spa_Client_Navigation_Navigation_Links; index as index\"\r\n          role=\"option\"\r\n          (click)=\"navigate(link)\"\r\n          class=\"text-left text-wrap Spa_Style_Gray1_Background Spa_Style_Primary_Color border-0\"\r\n          [ngClass]=\"{ Spa_Style_Bold_Weight: isCurrentPlanYear(link) }\"\r\n          [attr.aria-posinset]=\"index + 1\"\r\n          [attr.aria-setsize]=\"Spa_Client_Navigation_Navigation_Links.length\"\r\n          [attr.aria-label]=\"link.title\"\r\n          tabindex=\"0\"\r\n        >\r\n          {{ link.title }}\r\n        </button>\r\n      </div>\r\n      <ng-template #showLinksAsDropdown>\r\n        <div class=\"col-12 col-md-auto col-lg-3 client-navigation-primary-col\" ngbDropdown>\r\n          <button class=\"btn client-navigation-dropdown-item text-wrap\" ngbDropdownToggle aria-haspopup=\"listbox\">\r\n            <span class=\"Spa_Style_Primary_Color\">{{ Spa_Client_Navigation_DropDown_Label_Text }}</span>\r\n            <i aria-hidden=\"true\" class=\"fas fa-angle-down mt-1 ml-2 float-right\"></i>\r\n          </button>\r\n          <div ngbDropdownMenu *ngIf=\"Spa_Client_Navigation_Navigation_Links?.length\" class=\"p-0 mt-0\" role=\"listbox\">\r\n            <button\r\n              *ngFor=\"let link of Spa_Client_Navigation_Navigation_Links; index as index\"\r\n              ngbDropdownItem\r\n              role=\"option\"\r\n              (click)=\"navigate(link)\"\r\n              class=\"client-navigation-dropdown-item text-left text-wrap Spa_Style_Gray1_Background Spa_Style_Primary_Color\"\r\n              [attr.aria-posinset]=\"index + 1\"\r\n              [attr.aria-setsize]=\"Spa_Client_Navigation_Navigation_Links.length\"\r\n              [attr.aria-label]=\"link.title\"\r\n              tabindex=\"0\"\r\n            >\r\n              {{ link.title }}\r\n            </button>\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n      <div\r\n        *ngIf=\"Spa_Client_Navigation_Optional_Navigation_Links?.length\"\r\n        class=\"col-12 col-md-auto col-lg-3 client-navigation-optional-col\"\r\n        ngbDropdown\r\n      >\r\n        <button class=\"btn client-navigation-dropdown-item text-wrap\" ngbDropdownToggle aria-haspopup=\"listbox\">\r\n          <span class=\"Spa_Style_Primary_Color\">{{ Spa_Client_Navigation_Optional_DropDown_Label_Text }}</span>\r\n          <i aria-hidden=\"true\" class=\"fas fa-angle-down mt-1 ml-2 float-right\"></i>\r\n        </button>\r\n        <div ngbDropdownMenu class=\"p-0 mt-0\" role=\"listbox\">\r\n          <button\r\n            *ngFor=\"let link of Spa_Client_Navigation_Optional_Navigation_Links; index as index\"\r\n            ngbDropdownItem\r\n            role=\"option\"\r\n            (click)=\"navigate(link)\"\r\n            class=\"client-navigation-dropdown-item text-left text-wrap Spa_Style_Gray1_Background Spa_Style_Primary_Color\"\r\n            [attr.aria-posinset]=\"index + 1\"\r\n            [attr.aria-setsize]=\"Spa_Client_Navigation_Optional_Navigation_Links.length\"\r\n            [attr.aria-label]=\"link.title\"\r\n            tabindex=\"0\"\r\n          >\r\n            {{ link.title }}\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".client-navigation-dropdown-item{overflow:hidden}.client-navigation-dropdown-item:hover,.client-navigation-dropdown-item:focus{background-color:#fff}.client-navigation-dropdown-item:hover{outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:0 0 5px var(--static-Spa_Style_Black)}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: i1.ConfigResourceService }, { type: ZoneService }, { type: WidgetService }, { type: i1.NavigationService }, { type: i1.GoogleTagManagerService }, { type: i1.PlanYearResourceService }]; }, { Spa_Client_Navigation_DropDown_Label_Text: [], Spa_Client_Navigation_Optional_DropDown_Label_Text: [], Spa_Client_Navigation_Navigation_Links: [], Spa_Client_Navigation_Optional_Navigation_Links: [], Spa_Client_Navigation_Display_Links: [] }); })();

class CopyrightComponent {
    constructor() {
        this.defaultCopyRight = `© ${new Date().getFullYear()}  Connecture, Inc. All rights reserved.`;
    }
}
CopyrightComponent.ɵfac = function CopyrightComponent_Factory(t) { return new (t || CopyrightComponent)(); };
CopyrightComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CopyrightComponent, selectors: [["vnext-copyright"]], inputs: { copyright: "copyright" }, decls: 2, vars: 1, consts: [[1, "Spa_Style_Note", "pt-2"]], template: function CopyrightComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.copyright || ctx.defaultCopyRight);
    } } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CopyrightComponent, [{
        type: Component,
        args: [{ selector: 'vnext-copyright', template: "<div class=\"Spa_Style_Note pt-2\">{{ copyright || defaultCopyRight }}</div>\r\n" }]
    }], null, { copyright: [{
            type: Input
        }] }); })();

function CmsApprovalCodeComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 2);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r0.lastUpdatedLabel, "html"), i0.ɵɵsanitizeHtml);
} }
function CmsApprovalCodeComponent_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "span", 2);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 1, ctx_r3.CMS, "html"), i0.ɵɵsanitizeHtml);
} }
function CmsApprovalCodeComponent_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 2);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r4.defaultCMS, "html"), i0.ɵɵsanitizeHtml);
} }
function CmsApprovalCodeComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CmsApprovalCodeComponent_ng_container_1_div_1_Template, 3, 4, "div", 1);
    i0.ɵɵtemplate(2, CmsApprovalCodeComponent_ng_container_1_div_2_Template, 2, 4, "div", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.CMS);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.CMS);
} }
function CmsApprovalCodeComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 2);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r2.formCMS, "html"), i0.ɵɵsanitizeHtml);
} }
class CmsApprovalCodeComponent {
    constructor(localeService) {
        this.localeService = localeService;
        this.hideMainCMS = false;
        this.currentLocale$ = this.localeService.getCurrentLocale$(); // TODO is this needed?
        this.defaultCMS = 'CMS Pending Approval';
    }
}
CmsApprovalCodeComponent.ɵfac = function CmsApprovalCodeComponent_Factory(t) { return new (t || CmsApprovalCodeComponent)(i0.ɵɵdirectiveInject(i1.LocaleService)); };
CmsApprovalCodeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CmsApprovalCodeComponent, selectors: [["vnext-cms-approval-code"]], inputs: { CMS: "CMS", formCMS: "formCMS", lastUpdatedLabel: "lastUpdatedLabel", hideMainCMS: "hideMainCMS" }, decls: 3, vars: 3, consts: [["class", "Spa_Style_Note", "navigationAdapter", "", 3, "innerHTML", 4, "ngIf"], [4, "ngIf"], ["navigationAdapter", "", 1, "Spa_Style_Note", 3, "innerHTML"]], template: function CmsApprovalCodeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CmsApprovalCodeComponent_div_0_Template, 2, 4, "div", 0);
        i0.ɵɵtemplate(1, CmsApprovalCodeComponent_ng_container_1_Template, 3, 2, "ng-container", 1);
        i0.ɵɵtemplate(2, CmsApprovalCodeComponent_div_2_Template, 2, 4, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.lastUpdatedLabel);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.hideMainCMS);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.formCMS);
    } }, dependencies: [i1$2.NgIf, NavigationAdapterDirective, SafePipe] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CmsApprovalCodeComponent, [{
        type: Component,
        args: [{ selector: 'vnext-cms-approval-code', template: "<div class=\"Spa_Style_Note\" *ngIf=\"lastUpdatedLabel\" [innerHTML]=\"lastUpdatedLabel | safe: 'html'\" navigationAdapter></div>\r\n<ng-container *ngIf=\"!hideMainCMS\">\r\n  <div *ngIf=\"CMS\">\r\n    <span class=\"Spa_Style_Note\" [innerHTML]=\"CMS | safe: 'html'\" navigationAdapter></span>\r\n  </div>\r\n  <div *ngIf=\"!CMS\" class=\"Spa_Style_Note\" [innerHTML]=\"defaultCMS | safe: 'html'\" navigationAdapter></div>\r\n</ng-container>\r\n\r\n<div *ngIf=\"formCMS\" class=\"Spa_Style_Note\" [innerHTML]=\"formCMS | safe: 'html'\" navigationAdapter></div>\r\n" }]
    }], function () { return [{ type: i1.LocaleService }]; }, { CMS: [{
            type: Input
        }], formCMS: [{
            type: Input
        }], lastUpdatedLabel: [{
            type: Input
        }], hideMainCMS: [{
            type: Input
        }] }); })();

function LogoComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "img", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("width", ctx_r0.width)("src", ctx_r0.logoUrl, i0.ɵɵsanitizeUrl)("alt", ctx_r0.footerLogoAlternateText);
} }
class LogoComponent {
    constructor() {
        this.WIDTH_SIZE = {
            small: 75,
            medium: 150,
            large: 225
        };
    }
    ngOnInit() {
        // if no logo config, set the default
        if (!this.logoConfig) {
            this.logoConfig = {
                size: 'large',
                theme: 'color'
            };
        }
    }
    get logoUrl() {
        return `${this.contentServerUrl}/phoenix/assets/connecture_logo/${this.logoConfig.theme}/connecture.png`;
    }
    get width() {
        return this.WIDTH_SIZE[this.logoConfig.size];
    }
}
LogoComponent.ɵfac = function LogoComponent_Factory(t) { return new (t || LogoComponent)(); };
LogoComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LogoComponent, selectors: [["vnext-logo"]], inputs: { logoConfig: "logoConfig", contentServerUrl: "contentServerUrl", footerLogoAlternateText: "footerLogoAlternateText" }, decls: 1, vars: 1, consts: [["class", "logo-container", 4, "ngIf"], [1, "logo-container"], [1, "p-1", 3, "width", "src", "alt"]], template: function LogoComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LogoComponent_div_0_Template, 2, 3, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.logoConfig.size);
    } }, dependencies: [i1$2.NgIf], styles: [".logo-container[_ngcontent-%COMP%]{display:flex;justify-content:flex-end}img[_ngcontent-%COMP%]{padding-bottom:5px;height:100%}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LogoComponent, [{
        type: Component,
        args: [{ selector: 'vnext-logo', template: "<div class=\"logo-container\" *ngIf=\"logoConfig.size\">\r\n  <img class=\"p-1\" [width]=\"width\" [src]=\"logoUrl\" [alt]=\"footerLogoAlternateText\" />\r\n</div>\r\n", styles: [".logo-container{display:flex;justify-content:flex-end}img{padding-bottom:5px;height:100%}\n"] }]
    }], null, { logoConfig: [{
            type: Input
        }], contentServerUrl: [{
            type: Input
        }], footerLogoAlternateText: [{
            type: Input
        }] }); })();

function DefaultLinksComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "vnext-link", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", link_r1.title)("tag", link_r1.tag)("href", link_r1.href)("onClickAction", ctx_r0.submitAction(link_r1))("linkTarget", link_r1.target ? link_r1.target : "_self");
} }
class DefaultLinksComponent {
    constructor(navigationUtilityService, memberSessionService) {
        this.navigationUtilityService = navigationUtilityService;
        this.memberSessionService = memberSessionService;
    }
    submitAction(link) {
        return () => {
            if (link.tag === PageTags.HOME || link.tag === PageTags.RETENTION) {
                const page = this.navigationUtilityService.getCurrentPage();
                if (page.tags.includes(PageTags.ENROLLMENT_CONFIRMATION)) {
                    this.memberSessionService.memberLogout();
                }
            }
            else {
                this.navigationUtilityService.openLinkInNewWindow(link);
            }
        };
    }
}
DefaultLinksComponent.ɵfac = function DefaultLinksComponent_Factory(t) { return new (t || DefaultLinksComponent)(i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(i1.MemberSessionService)); };
DefaultLinksComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DefaultLinksComponent, selectors: [["vnext-default-links"]], inputs: { links: "links" }, decls: 3, vars: 1, consts: [[1, "default-link-container"], ["class", "default-link d-flex align-items-center", 4, "ngFor", "ngForOf"], [1, "default-link", "d-none", "d-md-block"], [1, "default-link", "d-flex", "align-items-center"], [3, "title", "tag", "href", "onClickAction", "linkTarget"]], template: function DefaultLinksComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, DefaultLinksComponent_div_1_Template, 2, 5, "div", 1);
        i0.ɵɵelement(2, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.links);
    } }, dependencies: [i1$2.NgForOf, LinkComponent], styles: [".default-link-container[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;justify-content:flex-start;padding:30px 0}.default-link[_ngcontent-%COMP%]{flex:1 0 33%}@media (max-width: 768px){.default-link-container[_ngcontent-%COMP%]{padding-top:10px}.default-link[_ngcontent-%COMP%]{flex:1 0 100%;min-height:44px}}"] });
__decorate([
    LiveEditInactive()
], DefaultLinksComponent.prototype, "submitAction", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DefaultLinksComponent, [{
        type: Component,
        args: [{ selector: 'vnext-default-links', template: "<div class=\"default-link-container\">\r\n  <div *ngFor=\"let link of links\" class=\"default-link d-flex align-items-center\">\r\n    <vnext-link\r\n      [title]=\"link.title\"\r\n      [tag]=\"link.tag\"\r\n      [href]=\"link.href\"\r\n      [onClickAction]=\"submitAction(link)\"\r\n      [linkTarget]=\"link.target ? link.target : '_self'\"\r\n    ></vnext-link>\r\n  </div>\r\n  <!-- spacer for the 6th spot -->\r\n  <div class=\"default-link d-none d-md-block\"></div>\r\n</div>\r\n", styles: [".default-link-container{display:flex;flex-wrap:wrap;justify-content:flex-start;padding:30px 0}.default-link{flex:1 0 33%}@media (max-width: 768px){.default-link-container{padding-top:10px}.default-link{flex:1 0 100%;min-height:44px}}\n"] }]
    }], function () { return [{ type: i1.NavigationUtilityService }, { type: i1.MemberSessionService }]; }, { links: [{
            type: Input
        }], submitAction: [] }); })();

const _c0$1R = ["siteDisclaimer"];
function SiteDisclaimerComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 2, 3);
    i0.ɵɵpipe(2, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", ctx_r1.siteDisclaimerHtmlText ? i0.ɵɵpipeBind2(2, 1, ctx_r1.siteDisclaimerHtmlText, "html") : "", i0.ɵɵsanitizeHtml);
} }
function SiteDisclaimerComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SiteDisclaimerComponent_ng_container_0_div_1_Template, 3, 4, "div", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_HeaderFooter_Disclaimer");
} }
class SiteDisclaimerComponent {
    constructor(htmlUtilityService) {
        this.htmlUtilityService = htmlUtilityService;
    }
    set disclaimerConfig(value) {
        this._siteDisclaimerText = value ?
            this.htmlUtilityService.applyClassToElement(this.htmlUtilityService.convertStringToHtml(value), 'Spa_Style_Link', 'a').innerHTML : '';
    }
    get siteDisclaimerHtmlText() {
        return this._siteDisclaimerText;
    }
}
SiteDisclaimerComponent.ɵfac = function SiteDisclaimerComponent_Factory(t) { return new (t || SiteDisclaimerComponent)(i0.ɵɵdirectiveInject(i1.HtmlUtilityService)); };
SiteDisclaimerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SiteDisclaimerComponent, selectors: [["vnext-site-disclaimer"]], viewQuery: function SiteDisclaimerComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1R, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.siteDisclaimer = _t.first);
    } }, inputs: { disclaimerConfig: "disclaimerConfig" }, decls: 1, vars: 1, consts: [[4, "ngIf"], ["class", "Spa_Style_Note", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["navigationAdapter", "", 1, "Spa_Style_Note", 3, "innerHtml"], ["siteDisclaimer", ""]], template: function SiteDisclaimerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SiteDisclaimerComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.siteDisclaimerHtmlText);
    } }, dependencies: [i1$2.NgIf, NavigationAdapterDirective, LiveEditPropDirective, SafePipe] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SiteDisclaimerComponent, [{
        type: Component,
        args: [{ selector: 'vnext-site-disclaimer', template: "<ng-container *ngIf=\"siteDisclaimerHtmlText\"\r\n  ><div\r\n    #siteDisclaimer\r\n    *liveEditProp=\"'Spa_HeaderFooter_Disclaimer'\"\r\n    class=\"Spa_Style_Note\"\r\n    [innerHtml]=\"siteDisclaimerHtmlText ? (siteDisclaimerHtmlText | safe: 'html') : ''\"\r\n    navigationAdapter\r\n  ></div>\r\n</ng-container>\r\n" }]
    }], function () { return [{ type: i1.HtmlUtilityService }]; }, { siteDisclaimer: [{
            type: ViewChild,
            args: ['siteDisclaimer']
        }], disclaimerConfig: [{
            type: Input
        }] }); })();

function DynamicFooterComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
} }
function DynamicFooterComponent_ng_container_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelement(1, "vnext-sub-header", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("links", ctx_r2.Spa_HeaderFooter_SubHeaderLinks)("linkContainerClass", "sub-header-container-footer container")("currentLanguageLabelText", ctx_r2.Spa_HeaderFooter_Language_Label_Text)("hideContactUsLink", ctx_r2.Spa_HeaderFooter_HideContactUs_Link)("motionPointEnabled", ctx_r2.MotionPoint_WidgetEnabled)("showPrintLink", ctx_r2.Spa_HeaderFooter_Print_Display)("weglotMultiLanguageEnabled", ctx_r2.Spa_Weglot_MultiLanguage_Enabled);
} }
function DynamicFooterComponent_ng_container_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "vnext-default-links", 15);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("links", i0.ɵɵpipeBind1(2, 1, ctx_r3.links$));
} }
function DynamicFooterComponent_ng_container_0_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "vnext-disclaimer-section", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disclaimerText", ctx_r4.Spa_Site_PageLevel_Disclaimer_Text);
} }
function DynamicFooterComponent_ng_container_0_vnext_cms_approval_code_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-cms-approval-code", 18);
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hideMainCMS", !ctx_r5.Spa_Site_FooterCMS_Enabled)("CMS", ctx_r5.Spa_HeaderFooter_CmsApprovalCode)("formCMS", ctx_r5.formCMS)("lastUpdatedLabel", ctx_r5.Spa_Site_LastUpdatedLabel);
} }
function DynamicFooterComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DynamicFooterComponent_ng_container_0_div_1_Template, 1, 0, "div", 1);
    i0.ɵɵelementStart(2, "footer", 2);
    i0.ɵɵtemplate(3, DynamicFooterComponent_ng_container_0_div_3_Template, 2, 7, "div", 3);
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵtemplate(5, DynamicFooterComponent_ng_container_0_div_5_Template, 3, 3, "div", 5);
    i0.ɵɵtemplate(6, DynamicFooterComponent_ng_container_0_div_6_Template, 2, 1, "div", 6);
    i0.ɵɵelementStart(7, "div", 7);
    i0.ɵɵelement(8, "vnext-site-disclaimer", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 7);
    i0.ɵɵelement(10, "vnext-copyright", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 7);
    i0.ɵɵtemplate(12, DynamicFooterComponent_ng_container_0_vnext_cms_approval_code_12_Template, 1, 4, "vnext-cms-approval-code", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "vnext-logo", 11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.Spa_Site_DynamicFooter_TopSpacer_Enabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.Spa_Site_IsHelpfulTools);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.Spa_Site_IsHelpfulTools && ctx_r0.Spa_HeaderFooter_Links);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.Spa_Site_DisclaimerSection_Enabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disclaimerConfig", ctx_r0.headerFooterDisclaimerText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("copyright", ctx_r0.Spa_Site_Copyright);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.Spa_Site_FooterCMS_Enabled || ctx_r0.Spa_Site_FooterFormCMS_Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("logoConfig", ctx_r0.footerLogoProperties)("contentServerUrl", ctx_r0.ContentServerUrl)("footerLogoAlternateText", ctx_r0.Spa_HeaderFooter_Logo_Alternate_Text);
} }
let DynamicFooterComponent = class DynamicFooterComponent extends ConfigurableWidget {
    constructor(store, cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, enrollmentService, navigationUtilityService, configResourceService, siteService, carriersService, localeService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.store = store;
        this.enrollmentService = enrollmentService;
        this.navigationUtilityService = navigationUtilityService;
        this.configResourceService = configResourceService;
        this.siteService = siteService;
        this.carriersService = carriersService;
        this.localeService = localeService;
        this.Spa_HeaderFooter_SubHeaderLinks = [];
        this.Spa_HeaderFooter_Links = [];
        this.Spa_Site_LogoProperties = {
            theme: 'color',
            size: 'large'
        };
        this.Spa_Site_LastUpdatedLabel = 'Last Updated:';
        this.Spa_Site_IsHelpfulTools = false;
        this.Spa_HeaderFooter_HideContactUs_Link = false;
        this.Spa_Site_FooterHomeLink_Enabled = true;
        this.Spa_Site_FooterCMS_Enabled = true;
        this.Spa_Site_FooterFormCMS_Enabled = true;
        this.Spa_HeaderFooter_Language_Label_Text = 'Current Language:';
        this.Spa_Site_DisclaimerSection_Enabled = true;
        this.Spa_Site_Show_Footer = true;
        this.MotionPoint_WidgetEnabled = false;
        this.Spa_HeaderFooter_Print_Display = false;
        this.Spa_HeaderFooter_Logo_Alternate_Text = '[Your Client Name] logo icon';
        this.Spa_RetentionSite_Custom_Navigation_PageTag = PageTags.RETENTION_SUMMARY;
        this.Spa_Site_DynamicFooter_TopSpacer_Enabled = true;
        this.Spa_Site_TotalSiteCountsPPC_Enabled = true;
        this.Spa_Weglot_MultiLanguage_Enabled = false;
        this.formCMS = '';
        this.subscriptions = new Subscription();
        this.headerFooterDisclaimerText = '';
    }
    ngOnInit() {
        super.ngOnInit();
        if (this.Spa_Site_TotalSiteCountsPPC_Enabled) {
            this.subscriptions.add(this.carriersService.getTotalCountsResource$('Spa_HeaderFooter_Disclaimer', true).subscribe({
                next: (totalCountString) => {
                    this.headerFooterDisclaimerText = totalCountString;
                    this.cdr.markForCheck();
                }
            }));
        }
        else {
            this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe({
                next: () => {
                    this.headerFooterDisclaimerText = this.Spa_HeaderFooter_Disclaimer;
                    this.cdr.markForCheck();
                }
            }));
        }
        this.subscriptions.add(this.store.select(SiteState.sharedConfigResource).subscribe({
            next: () => {
                this.headerFooterDisclaimerText = this.configResourceService.getProcessedResourceValue('Spa_HeaderFooter_Disclaimer');
                this.cdr.markForCheck();
            }
        }));
        if (this.Spa_Site_FooterFormCMS_Enabled) {
            this.subscriptions.add(this.enrollmentService.getCMSApprovalCode$().subscribe({
                next: (cmsCode) => {
                    if (this.enrollmentService.getPageIsEnrollment()) {
                        this.formCMS = cmsCode;
                    }
                    else {
                        this.formCMS = '';
                    }
                    this.cdr.markForCheck();
                }
            }));
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    preProcessProperties() {
        if (this.Spa_Site_LogoProperties) {
            this.footerLogoProperties = {
                theme: this.Spa_Site_LogoProperties.theme ? this.Spa_Site_LogoProperties.theme.toLowerCase() : '',
                size: this.Spa_Site_LogoProperties.size ? this.Spa_Site_LogoProperties.size.toLowerCase() : ''
            };
        }
        this.links$ = this.getLinks$();
    }
    getLinks$() {
        return combineLatest([this.siteService.isRetentionView$(), this.siteService.isQuotingSite$()]).pipe(withLatestFrom(this.enrollmentService.getIsMemberLoggedIn$()), map(([[isRetentionView, isQuotingSite], isMemberLoggedIn]) => {
            let isEnrollmentCompleted = false;
            const page = this.navigationUtilityService.getCurrentPage();
            if (page && page.tags.includes(PageTags.ENROLLMENT_CONFIRMATION)) {
                isEnrollmentCompleted = true;
            }
            return this.Spa_HeaderFooter_Links.map(link => {
                if (link.tag === PageTags.HOME) {
                    if (isEnrollmentCompleted) {
                        if (isQuotingSite) {
                            link.tag = PageTags.HOME;
                        }
                        else if (isRetentionView) {
                            link.tag = PageTags.RETENTION;
                        }
                    }
                    else if (isRetentionView && isMemberLoggedIn) {
                        link.tag = this.configResourceService.getProcessedResourceValue('Spa_RetentionSite_Custom_Navigation_PageTag', null, PageTags.RETENTION_SUMMARY);
                    }
                    else if (isRetentionView) {
                        link.tag = PageTags.RETENTION;
                    }
                    else if (isQuotingSite && isMemberLoggedIn) {
                        link.tag = PageTags.QUOTE_SUMMARY;
                    }
                    else if (isQuotingSite) {
                        link.tag = PageTags.BENEFICIARY_LOGIN;
                    }
                    return link;
                }
                return link;
            });
        }));
    }
};
DynamicFooterComponent.ɵfac = function DynamicFooterComponent_Factory(t) { return new (t || DynamicFooterComponent)(i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(i1.CarriersService), i0.ɵɵdirectiveInject(i1.LocaleService)); };
DynamicFooterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DynamicFooterComponent, selectors: [["vnext-dynamic-footer"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["class", "spacer", 4, "ngIf"], ["id", "dynamicfooter", 1, "Spa_Style_Gray1_Background"], ["class", "sub-header Spa_Style_Gray2_Background", 4, "ngIf"], [1, "container"], ["class", "row", 4, "ngIf"], ["class", "row pb-2", 4, "ngIf"], [1, "row"], [1, "col-12", 3, "disclaimerConfig"], [1, "col-12", 3, "copyright"], ["class", "col-12", 3, "hideMainCMS", "CMS", "formCMS", "lastUpdatedLabel", 4, "ngIf"], [3, "logoConfig", "contentServerUrl", "footerLogoAlternateText"], [1, "spacer"], [1, "sub-header", "Spa_Style_Gray2_Background"], [3, "links", "linkContainerClass", "currentLanguageLabelText", "hideContactUsLink", "motionPointEnabled", "showPrintLink", "weglotMultiLanguageEnabled"], [1, "col-12", 3, "links"], [1, "row", "pb-2"], [1, "col-12", 3, "disclaimerText"], [1, "col-12", 3, "hideMainCMS", "CMS", "formCMS", "lastUpdatedLabel"]], template: function DynamicFooterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, DynamicFooterComponent_ng_container_0_Template, 14, 10, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.Spa_Site_Show_Footer);
    } }, dependencies: [i1$2.NgIf, DisclaimerSectionComponent, SubHeaderComponent, CopyrightComponent, CmsApprovalCodeComponent, LogoComponent, DefaultLinksComponent, SiteDisclaimerComponent, i1$2.AsyncPipe], styles: ["footer[_ngcontent-%COMP%]{width:100%;font-size:var(--Spa_Style_Small_Fonter);padding-bottom:24px}.sub-header[_ngcontent-%COMP%]{width:100%}.spacer[_ngcontent-%COMP%]{min-height:90px}"], changeDetection: 0 });
__decorate([
    PlatformProp()
], DynamicFooterComponent.prototype, "Spa_HeaderFooter_SubHeaderLinks", void 0);
__decorate([
    PlatformProp(null, true)
], DynamicFooterComponent.prototype, "Spa_HeaderFooter_Links", void 0);
__decorate([
    PlatformProp()
], DynamicFooterComponent.prototype, "Spa_HeaderFooter_Disclaimer", void 0);
__decorate([
    PlatformProp(null, true)
], DynamicFooterComponent.prototype, "Spa_Site_LogoProperties", void 0);
__decorate([
    PlatformProp()
], DynamicFooterComponent.prototype, "Spa_Site_Copyright", void 0);
__decorate([
    GlobalResource()
], DynamicFooterComponent.prototype, "Spa_HeaderFooter_CmsApprovalCode", void 0);
__decorate([
    PlatformProp()
], DynamicFooterComponent.prototype, "Spa_Site_LastUpdatedLabel", void 0);
__decorate([
    PlatformProp()
], DynamicFooterComponent.prototype, "Spa_Site_IsHelpfulTools", void 0);
__decorate([
    PlatformProp()
], DynamicFooterComponent.prototype, "Spa_HeaderFooter_HideContactUs_Link", void 0);
__decorate([
    GlobalResource()
], DynamicFooterComponent.prototype, "ContentServerUrl", void 0);
__decorate([
    GlobalResource()
], DynamicFooterComponent.prototype, "Spa_Site_FooterHomeLink_Enabled", void 0);
__decorate([
    GlobalResource()
], DynamicFooterComponent.prototype, "Spa_Site_FooterCMS_Enabled", void 0);
__decorate([
    GlobalResource()
], DynamicFooterComponent.prototype, "Spa_Site_FooterFormCMS_Enabled", void 0);
__decorate([
    GlobalResource()
], DynamicFooterComponent.prototype, "Spa_HeaderFooter_Language_Label_Text", void 0);
__decorate([
    GlobalResource()
], DynamicFooterComponent.prototype, "Spa_Site_DisclaimerSection_Enabled", void 0);
__decorate([
    GlobalResource()
], DynamicFooterComponent.prototype, "Spa_Site_PageLevel_Disclaimer_Text", void 0);
__decorate([
    GlobalResource()
], DynamicFooterComponent.prototype, "Spa_Site_Show_Footer", void 0);
__decorate([
    GlobalResource()
], DynamicFooterComponent.prototype, "MotionPoint_WidgetEnabled", void 0);
__decorate([
    GlobalResource()
], DynamicFooterComponent.prototype, "Spa_HeaderFooter_Print_Display", void 0);
__decorate([
    GlobalResource()
], DynamicFooterComponent.prototype, "Spa_HeaderFooter_Logo_Alternate_Text", void 0);
__decorate([
    GlobalResource(true)
], DynamicFooterComponent.prototype, "Spa_RetentionSite_Custom_Navigation_PageTag", void 0);
__decorate([
    GlobalResource()
], DynamicFooterComponent.prototype, "Spa_Site_DynamicFooter_TopSpacer_Enabled", void 0);
__decorate([
    GlobalResource()
], DynamicFooterComponent.prototype, "Spa_Site_TotalSiteCountsPPC_Enabled", void 0);
__decorate([
    GlobalResource()
], DynamicFooterComponent.prototype, "Spa_Weglot_MultiLanguage_Enabled", void 0);
DynamicFooterComponent = __decorate([
    PlatformWidget
], DynamicFooterComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DynamicFooterComponent, [{
        type: Component,
        args: [{ selector: 'vnext-dynamic-footer', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<ng-container *ngIf=\"Spa_Site_Show_Footer\">\r\n  <div *ngIf=\"Spa_Site_DynamicFooter_TopSpacer_Enabled\" class=\"spacer\"></div>\r\n  <footer class=\"Spa_Style_Gray1_Background\" id=\"dynamicfooter\">\r\n    <div class=\"sub-header Spa_Style_Gray2_Background\" *ngIf=\"!Spa_Site_IsHelpfulTools\">\r\n      <vnext-sub-header\r\n        [links]=\"Spa_HeaderFooter_SubHeaderLinks\"\r\n        [linkContainerClass]=\"'sub-header-container-footer container'\"\r\n        [currentLanguageLabelText]=\"Spa_HeaderFooter_Language_Label_Text\"\r\n        [hideContactUsLink]=\"Spa_HeaderFooter_HideContactUs_Link\"\r\n        [motionPointEnabled]=\"MotionPoint_WidgetEnabled\"\r\n        [showPrintLink]=\"Spa_HeaderFooter_Print_Display\"\r\n        [weglotMultiLanguageEnabled]=\"Spa_Weglot_MultiLanguage_Enabled\"\r\n      ></vnext-sub-header>\r\n    </div>\r\n    <div class=\"container\">\r\n      <div class=\"row\" *ngIf=\"!Spa_Site_IsHelpfulTools && Spa_HeaderFooter_Links\">\r\n        <vnext-default-links [links]=\"links$ | async\" class=\"col-12\"></vnext-default-links>\r\n      </div>\r\n      <div class=\"row pb-2\" *ngIf=\"Spa_Site_DisclaimerSection_Enabled\">\r\n        <vnext-disclaimer-section class=\"col-12\" [disclaimerText]=\"Spa_Site_PageLevel_Disclaimer_Text\"></vnext-disclaimer-section>\r\n      </div>\r\n      <div class=\"row\">\r\n        <vnext-site-disclaimer class=\"col-12\" [disclaimerConfig]=\"headerFooterDisclaimerText\"></vnext-site-disclaimer>\r\n      </div>\r\n      <div class=\"row\">\r\n        <vnext-copyright class=\"col-12\" [copyright]=\"Spa_Site_Copyright\"></vnext-copyright>\r\n      </div>\r\n      <div class=\"row\">\r\n        <vnext-cms-approval-code\r\n          *ngIf=\"Spa_Site_FooterCMS_Enabled || Spa_Site_FooterFormCMS_Enabled\"\r\n          class=\"col-12\"\r\n          [hideMainCMS]=\"!Spa_Site_FooterCMS_Enabled\"\r\n          [CMS]=\"Spa_HeaderFooter_CmsApprovalCode\"\r\n          [formCMS]=\"formCMS\"\r\n          [lastUpdatedLabel]=\"Spa_Site_LastUpdatedLabel\"\r\n        ></vnext-cms-approval-code>\r\n      </div>\r\n      <vnext-logo\r\n        [logoConfig]=\"footerLogoProperties\"\r\n        [contentServerUrl]=\"ContentServerUrl\"\r\n        [footerLogoAlternateText]=\"Spa_HeaderFooter_Logo_Alternate_Text\"\r\n      ></vnext-logo>\r\n    </div></footer\r\n></ng-container>\r\n", styles: ["footer{width:100%;font-size:var(--Spa_Style_Small_Fonter);padding-bottom:24px}.sub-header{width:100%}.spacer{min-height:90px}\n"] }]
    }], function () { return [{ type: i2.Store }, { type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.EnrollmentFormService }, { type: i1.NavigationUtilityService }, { type: i1.ConfigResourceService }, { type: i1.SiteService }, { type: i1.CarriersService }, { type: i1.LocaleService }]; }, { Spa_HeaderFooter_SubHeaderLinks: [], Spa_HeaderFooter_Links: [], Spa_HeaderFooter_Disclaimer: [], Spa_Site_LogoProperties: [], Spa_Site_Copyright: [], Spa_HeaderFooter_CmsApprovalCode: [], Spa_Site_LastUpdatedLabel: [], Spa_Site_IsHelpfulTools: [], Spa_HeaderFooter_HideContactUs_Link: [], ContentServerUrl: [], Spa_Site_FooterHomeLink_Enabled: [], Spa_Site_FooterCMS_Enabled: [], Spa_Site_FooterFormCMS_Enabled: [], Spa_HeaderFooter_Language_Label_Text: [], Spa_Site_DisclaimerSection_Enabled: [], Spa_Site_PageLevel_Disclaimer_Text: [], Spa_Site_Show_Footer: [], MotionPoint_WidgetEnabled: [], Spa_HeaderFooter_Print_Display: [], Spa_HeaderFooter_Logo_Alternate_Text: [], Spa_RetentionSite_Custom_Navigation_PageTag: [], Spa_Site_DynamicFooter_TopSpacer_Enabled: [], Spa_Site_TotalSiteCountsPPC_Enabled: [], Spa_Weglot_MultiLanguage_Enabled: [] }); })();

let DefaultLinkPageComponent = class DefaultLinkPageComponent {
    constructor(titleService) {
        this.titleService = titleService;
    }
    get defaultText() {
        return `Please provide ${this.title}`;
    }
    ngOnInit() {
        this.title = this.titleService.getTitle();
    }
};
DefaultLinkPageComponent.ɵfac = function DefaultLinkPageComponent_Factory(t) { return new (t || DefaultLinkPageComponent)(i0.ɵɵdirectiveInject(i1$3.Title)); };
DefaultLinkPageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DefaultLinkPageComponent, selectors: [["vnext-default-link-page"]], decls: 1, vars: 1, template: function DefaultLinkPageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtext(0);
    } if (rf & 2) {
        i0.ɵɵtextInterpolate1("", ctx.defaultText, "\n");
    } } });
DefaultLinkPageComponent = __decorate([
    PlatformWidget
], DefaultLinkPageComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DefaultLinkPageComponent, [{
        type: Component,
        args: [{ selector: 'vnext-default-link-page', template: "{{defaultText}}\r\n" }]
    }], function () { return [{ type: i1$3.Title }]; }, null); })();

const _c0$1Q = function (a0, a1) { return { Spa_Style_Gray4_Color: a0, header: a1 }; };
class TextSizeComponent {
    constructor(widgetService) {
        this.widgetService = widgetService;
    }
    changeTextSize(command) {
        const fontVars = ['--font-larger', '--font-large', '--font-default', '--font-small', '--font-smaller'];
        const increaseSize = (fontSize) => `${fontSize + 2}px`;
        const decreaseSize = (fontSize) => `${fontSize - 2}px`;
        fontVars.forEach(fontVar => {
            const fontsize = getComputedStyle(document.documentElement)
                .getPropertyValue(fontVar)
                .match(/\d+/g)
                .map(Number)[0];
            if (command === 'increase') {
                document.documentElement.style.setProperty(fontVar, increaseSize(fontsize));
            }
            else if (command === 'decrease') {
                document.documentElement.style.setProperty(fontVar, decreaseSize(fontsize));
            }
        });
        const siteFontSize = getComputedStyle(document.documentElement)
            .fontSize.match(/\d+/g)
            .map(Number)[0];
        if (command === 'increase') {
            document.documentElement.style.fontSize = increaseSize(siteFontSize);
        }
        else if (command === 'decrease') {
            document.documentElement.style.fontSize = decreaseSize(siteFontSize);
        }
    }
    get isFooter() {
        return this.widgetService.widgetName === 'dynamicfooter';
    }
}
TextSizeComponent.ɵfac = function TextSizeComponent_Factory(t) { return new (t || TextSizeComponent)(i0.ɵɵdirectiveInject(WidgetService)); };
TextSizeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TextSizeComponent, selectors: [["vnext-text-size"]], inputs: { link: "link" }, decls: 5, vars: 15, consts: [[1, "text-size", "Spa_Style_Smaller_Font"], ["tabindex", "0", 3, "ngClass", "click", "keyup.enter"], [1, "text", "Spa_Style_Primary_Color"]], template: function TextSizeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "span", 0)(1, "i", 1);
        i0.ɵɵlistener("click", function TextSizeComponent_Template_i_click_1_listener() { return ctx.changeTextSize("increase"); })("keyup.enter", function TextSizeComponent_Template_i_keyup_enter_1_listener() { return ctx.changeTextSize("increase"); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "i", 1);
        i0.ɵɵlistener("click", function TextSizeComponent_Template_i_click_2_listener() { return ctx.changeTextSize("decrease"); })("keyup.enter", function TextSizeComponent_Template_i_keyup_enter_2_listener() { return ctx.changeTextSize("decrease"); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "span", 2);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("", ctx.link.iconName[0], " can-click  pr-1 ");
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c0$1Q, ctx.isFooter, !ctx.isFooter));
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("", ctx.link.iconName[1], " can-click pr-1");
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(12, _c0$1Q, ctx.isFooter, !ctx.isFooter));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.link.title);
    } }, dependencies: [i1$2.NgClass], styles: [".header[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent1)}.header[_ngcontent-%COMP%]:hover{color:var(--static-Spa_Style_Gray4)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextSizeComponent, [{
        type: Component,
        args: [{ selector: 'vnext-text-size', template: "<span class=\"text-size Spa_Style_Smaller_Font\">\r\n  <i\r\n    class=\"{{ link.iconName[0] }} can-click  pr-1 \"\r\n    [ngClass]=\"{ Spa_Style_Gray4_Color: isFooter, header: !isFooter }\"\r\n    (click)=\"changeTextSize('increase')\"\r\n    tabindex=\"0\"\r\n    (keyup.enter)=\"changeTextSize('increase')\"\r\n  ></i>\r\n  <i\r\n    class=\"{{ link.iconName[1] }} can-click pr-1\"\r\n    [ngClass]=\"{ Spa_Style_Gray4_Color: isFooter, header: !isFooter }\"\r\n    (click)=\"changeTextSize('decrease')\"\r\n    (keyup.enter)=\"changeTextSize('decrease')\"\r\n    tabindex=\"0\"\r\n  ></i>\r\n  <span class=\"text Spa_Style_Primary_Color\">{{ link.title }}</span>\r\n</span>\r\n", styles: [".header{color:var(--static-Spa_Style_Accent1)}.header:hover{color:var(--static-Spa_Style_Gray4)}\n"] }]
    }], function () { return [{ type: WidgetService }]; }, { link: [{
            type: Input
        }] }); })();

function HelpfulToolsLinkComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵlistener("click", function HelpfulToolsLinkComponent_span_0_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onAction()); })("keyup.Space", function HelpfulToolsLinkComponent_span_0_Template_span_keyup_Space_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.onAction()); })("keyup.Enter", function HelpfulToolsLinkComponent_span_0_Template_span_keyup_Enter_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onAction()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r0.linkText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r0.linkText, "\n");
} }
function HelpfulToolsLinkComponent_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r1.getUniqueId())("href", ctx_r1.href, i0.ɵɵsanitizeUrl)("title", ctx_r1.linkText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r1.linkText, "\n");
} }
class HelpfulToolsLinkComponent extends ConfigurableWidget {
    onAction() {
        if (this.linkNavigate) {
            this.linkNavigate();
        }
    }
    getUniqueId() {
        return uuid();
    }
}
HelpfulToolsLinkComponent.ɵfac = /*@__PURE__*/ function () { let ɵHelpfulToolsLinkComponent_BaseFactory; return function HelpfulToolsLinkComponent_Factory(t) { return (ɵHelpfulToolsLinkComponent_BaseFactory || (ɵHelpfulToolsLinkComponent_BaseFactory = i0.ɵɵgetInheritedFactory(HelpfulToolsLinkComponent)))(t || HelpfulToolsLinkComponent); }; }();
HelpfulToolsLinkComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HelpfulToolsLinkComponent, selectors: [["vnext-helpful-tools-link"]], inputs: { title: "title", linkText: "linkText", href: "href", isExternalRedirect: "isExternalRedirect", linkNavigate: "linkNavigate" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [["role", "link", "tabindex", "0", "class", "Spa_Style_Link link-button d-inline-block ml-1", 3, "title", "click", "keyup.Space", "keyup.Enter", 4, "ngIf"], ["navigationAdapter", "", "target", "_blank", "tabindex", "0", "class", "Spa_Style_Link link-button d-inline-block ml-1", 3, "id", "href", "title", 4, "ngIf"], ["role", "link", "tabindex", "0", 1, "Spa_Style_Link", "link-button", "d-inline-block", "ml-1", 3, "title", "click", "keyup.Space", "keyup.Enter"], ["navigationAdapter", "", "target", "_blank", "tabindex", "0", 1, "Spa_Style_Link", "link-button", "d-inline-block", "ml-1", 3, "id", "href", "title"]], template: function HelpfulToolsLinkComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, HelpfulToolsLinkComponent_span_0_Template, 2, 2, "span", 0);
        i0.ɵɵtemplate(1, HelpfulToolsLinkComponent_a_1_Template, 2, 4, "a", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.isExternalRedirect);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isExternalRedirect && ctx.href);
    } }, dependencies: [i1$2.NgIf, NavigationAdapterDirective], styles: [".link-button[_ngcontent-%COMP%]{cursor:pointer}.link-button[_ngcontent-%COMP%]:hover{text-decoration:underline}"] });
__decorate([
    LiveEditInactive()
], HelpfulToolsLinkComponent.prototype, "onAction", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpfulToolsLinkComponent, [{
        type: Component,
        args: [{ selector: 'vnext-helpful-tools-link', template: "<span\r\n  *ngIf=\"!isExternalRedirect\"\r\n  role=\"link\"\r\n  tabindex=\"0\"\r\n  class=\"Spa_Style_Link link-button d-inline-block ml-1\"\r\n  [title]=\"linkText\"\r\n  (click)=\"onAction()\"\r\n  (keyup.Space)=\"onAction()\"\r\n  (keyup.Enter)=\"onAction()\"\r\n  >{{ linkText }}\r\n</span>\r\n<a\r\n  *ngIf=\"isExternalRedirect && href\"\r\n  navigationAdapter\r\n  [id]=\"getUniqueId()\"\r\n  [href]=\"href\"\r\n  target=\"_blank\"\r\n  [title]=\"linkText\"\r\n  tabindex=\"0\"\r\n  class=\"Spa_Style_Link link-button d-inline-block ml-1\"\r\n  >{{ linkText }}\r\n</a>\r\n", styles: [".link-button{cursor:pointer}.link-button:hover{text-decoration:underline}\n"] }]
    }], null, { title: [{
            type: Input
        }], linkText: [{
            type: Input
        }], href: [{
            type: Input
        }], isExternalRedirect: [{
            type: Input
        }], linkNavigate: [{
            type: Input
        }], onAction: [] }); })();

function HelpfulToolsPharmacySearchTabComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 5);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", ctx_r1.informationalText ? i0.ɵɵpipeBind2(1, 1, ctx_r1.informationalText, "html") : "", i0.ɵɵsanitizeHtml);
} }
function HelpfulToolsPharmacySearchTabComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtemplate(2, HelpfulToolsPharmacySearchTabComponent_div_0_div_2_Template, 2, 4, "div", 4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_HelpfulTools_Pharmacy_Info_Text");
} }
class HelpfulToolsPharmacySearchTabComponent {
}
HelpfulToolsPharmacySearchTabComponent.ɵfac = function HelpfulToolsPharmacySearchTabComponent_Factory(t) { return new (t || HelpfulToolsPharmacySearchTabComponent)(); };
HelpfulToolsPharmacySearchTabComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HelpfulToolsPharmacySearchTabComponent, selectors: [["vnext-helpful-tools-pharmacy-search-tab"]], inputs: { pharmacySearchIntroText: "pharmacySearchIntroText", informationalText: "informationalText", enablePharmacyInfoSection: "enablePharmacyInfoSection", retrieveZipCode: "retrieveZipCode", retrieveFipsCode: "retrieveFipsCode", addPharmacyButtonText: "addPharmacyButtonText", pharmacyLimit: "pharmacyLimit", pharmacyMapDefaultZoom: "pharmacyMapDefaultZoom", maxZoom: "maxZoom", minZoom: "minZoom", currentPharmacyText: "currentPharmacyText", pharmacyAddedLabel: "pharmacyAddedLabel", electronicPrescriptionTooltipHeader: "electronicPrescriptionTooltipHeader", electronicPrescriptionTooltipBody: "electronicPrescriptionTooltipBody", itemsPerPage: "itemsPerPage", pharmacyPaginationEnabled: "pharmacyPaginationEnabled", paginationText: "paginationText", viewNotFoundHeaderText: "viewNotFoundHeaderText", viewNotFoundBodyText: "viewNotFoundBodyText", preferredInNetworkText: "preferredInNetworkText", standardInNetworkText: "standardInNetworkText", preferredInNetworkTooltipContent: "preferredInNetworkTooltipContent", standardInNetworkTooltipContent: "standardInNetworkTooltipContent", errorKeywordText: "errorKeywordText", addedPharmacyText: "addedPharmacyText", addPharmacyText: "addPharmacyText", ePrescribingAltText: "ePrescribingAltText", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text", zipLabel: "zipLabel", zipErrorText: "zipErrorText", pharmacySearchButtonText: "pharmacySearchButtonText", pharmacyNameText: "pharmacyNameText", pharmacyNameHintText: "pharmacyNameHintText", pharmacyFilterText: "pharmacyFilterText", isPharmacyFilterEnabled: "isPharmacyFilterEnabled", isPharmacyOtherFilterEnabled: "isPharmacyOtherFilterEnabled", isPharmacyInNetworkFilterEnabled: "isPharmacyInNetworkFilterEnabled", pharmacyFilterClearText: "pharmacyFilterClearText", pharmacyFilterData: "pharmacyFilterData", defaultFilterText: "defaultFilterText", countyLabel: "countyLabel", showCountyLabel: "showCountyLabel", pharmacyInNetworkFilters: "pharmacyInNetworkFilters", digitalPharmacyEnabled: "digitalPharmacyEnabled", retailTabText: "retailTabText", digitalTabText: "digitalTabText" }, decls: 2, vars: 46, consts: [["class", "row mt-4 mb-3", 4, "ngIf"], [3, "retrieveFipsCode", "retrieveZipCode", "isHelpfulToolsView", "addPharmacyButtonText", "pharmacyLimit", "pharmacyMapDefaultZoom", "maxZoom", "minZoom", "currentPharmacyText", "pharmacyAddedLabel", "electronicPrescriptionTooltipHeader", "electronicPrescriptionTooltipBody", "itemsPerPage", "pharmacyPaginationEnabled", "paginationText", "viewNotFoundHeaderText", "viewNotFoundBodyText", "preferredInNetworkText", "standardInNetworkText", "preferredInNetworkTooltipContent", "standardInNetworkTooltipContent", "pharmacySearchIntroText", "errorKeywordText", "addedPharmacyText", "addPharmacyText", "ePrescribingAltText", "Spa_Site_Tooltip_Text", "zipLabel", "zipErrorText", "pharmacySearchButtonText", "pharmacyNameText", "pharmacyNameHintText", "pharmacyFilterText", "isPharmacyFilterEnabled", "isPharmacyInNetworkFilterEnabled", "isPharmacyOtherFilterEnabled", "pharmacyFilterClearText", "pharmacyFilterData", "defaultFilterText", "countyLabel", "showCountyLabel", "pharmacyInNetworkFilters", "digitalPharmacyEnabled", "retailTabText", "digitalTabText"], [1, "row", "mt-4", "mb-3"], [1, "col-12"], ["class", "Spa_Style_Regular text-center ml-2 mr-2 mb-0", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["navigationAdapter", "", 1, "Spa_Style_Regular", "text-center", "ml-2", "mr-2", "mb-0", 3, "innerHtml"]], template: function HelpfulToolsPharmacySearchTabComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, HelpfulToolsPharmacySearchTabComponent_div_0_Template, 3, 1, "div", 0);
        i0.ɵɵelement(1, "vnext-widget-pharmacy-search", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.enablePharmacyInfoSection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("retrieveFipsCode", ctx.retrieveFipsCode)("retrieveZipCode", ctx.retrieveZipCode)("isHelpfulToolsView", true)("addPharmacyButtonText", ctx.addPharmacyButtonText)("pharmacyLimit", ctx.pharmacyLimit)("pharmacyMapDefaultZoom", ctx.pharmacyMapDefaultZoom)("maxZoom", ctx.maxZoom)("minZoom", ctx.minZoom)("currentPharmacyText", ctx.currentPharmacyText)("pharmacyAddedLabel", ctx.pharmacyAddedLabel)("electronicPrescriptionTooltipHeader", ctx.electronicPrescriptionTooltipHeader)("electronicPrescriptionTooltipBody", ctx.electronicPrescriptionTooltipBody)("itemsPerPage", ctx.itemsPerPage)("pharmacyPaginationEnabled", ctx.pharmacyPaginationEnabled)("paginationText", ctx.paginationText)("viewNotFoundHeaderText", ctx.viewNotFoundHeaderText)("viewNotFoundBodyText", ctx.viewNotFoundBodyText)("preferredInNetworkText", ctx.preferredInNetworkText)("standardInNetworkText", ctx.standardInNetworkText)("preferredInNetworkTooltipContent", ctx.preferredInNetworkTooltipContent)("standardInNetworkTooltipContent", ctx.standardInNetworkTooltipContent)("pharmacySearchIntroText", ctx.pharmacySearchIntroText)("errorKeywordText", ctx.errorKeywordText)("addedPharmacyText", ctx.addedPharmacyText)("addPharmacyText", ctx.addPharmacyText)("ePrescribingAltText", ctx.ePrescribingAltText)("Spa_Site_Tooltip_Text", ctx.Spa_Site_Tooltip_Text)("zipLabel", ctx.zipLabel)("zipErrorText", ctx.zipErrorText)("pharmacySearchButtonText", ctx.pharmacySearchButtonText)("pharmacyNameText", ctx.pharmacyNameText)("pharmacyNameHintText", ctx.pharmacyNameHintText)("pharmacyFilterText", ctx.pharmacyFilterText)("isPharmacyFilterEnabled", ctx.isPharmacyFilterEnabled)("isPharmacyInNetworkFilterEnabled", ctx.isPharmacyInNetworkFilterEnabled)("isPharmacyOtherFilterEnabled", ctx.isPharmacyOtherFilterEnabled)("pharmacyFilterClearText", ctx.pharmacyFilterClearText)("pharmacyFilterData", ctx.pharmacyFilterData)("defaultFilterText", ctx.defaultFilterText)("countyLabel", ctx.countyLabel)("showCountyLabel", ctx.showCountyLabel)("pharmacyInNetworkFilters", ctx.pharmacyInNetworkFilters)("digitalPharmacyEnabled", ctx.digitalPharmacyEnabled)("retailTabText", ctx.retailTabText)("digitalTabText", ctx.digitalTabText);
    } }, dependencies: [i1$2.NgIf, NavigationAdapterDirective, LiveEditPropDirective, PharmacySearchComponent, SafePipe], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpfulToolsPharmacySearchTabComponent, [{
        type: Component,
        args: [{ selector: 'vnext-helpful-tools-pharmacy-search-tab', template: "<div class=\"row mt-4 mb-3\" *ngIf=\"enablePharmacyInfoSection\">\r\n  <div class=\"col-12\">\r\n    <div\r\n      *liveEditProp=\"'Spa_HelpfulTools_Pharmacy_Info_Text'\"\r\n      class=\"Spa_Style_Regular text-center ml-2 mr-2 mb-0\"\r\n      [innerHtml]=\"informationalText ? (informationalText | safe : 'html') : ''\"\r\n      navigationAdapter\r\n    ></div>\r\n  </div>\r\n</div>\r\n<vnext-widget-pharmacy-search\r\n  [retrieveFipsCode]=\"retrieveFipsCode\"\r\n  [retrieveZipCode]=\"retrieveZipCode\"\r\n  [isHelpfulToolsView]=\"true\"\r\n  [addPharmacyButtonText]=\"addPharmacyButtonText\"\r\n  [pharmacyLimit]=\"pharmacyLimit\"\r\n  [pharmacyMapDefaultZoom]=\"pharmacyMapDefaultZoom\"\r\n  [maxZoom]=\"maxZoom\"\r\n  [minZoom]=\"minZoom\"\r\n  [currentPharmacyText]=\"currentPharmacyText\"\r\n  [pharmacyAddedLabel]=\"pharmacyAddedLabel\"\r\n  [electronicPrescriptionTooltipHeader]=\"electronicPrescriptionTooltipHeader\"\r\n  [electronicPrescriptionTooltipBody]=\"electronicPrescriptionTooltipBody\"\r\n  [itemsPerPage]=\"itemsPerPage\"\r\n  [pharmacyPaginationEnabled]=\"pharmacyPaginationEnabled\"\r\n  [paginationText]=\"paginationText\"\r\n  [viewNotFoundHeaderText]=\"viewNotFoundHeaderText\"\r\n  [viewNotFoundBodyText]=\"viewNotFoundBodyText\"\r\n  [preferredInNetworkText]=\"preferredInNetworkText\"\r\n  [standardInNetworkText]=\"standardInNetworkText\"\r\n  [preferredInNetworkTooltipContent]=\"preferredInNetworkTooltipContent\"\r\n  [standardInNetworkTooltipContent]=\"standardInNetworkTooltipContent\"\r\n  [pharmacySearchIntroText]=\"pharmacySearchIntroText\"\r\n  [errorKeywordText]=\"errorKeywordText\"\r\n  [addedPharmacyText]=\"addedPharmacyText\"\r\n  [addPharmacyText]=\"addPharmacyText\"\r\n  [ePrescribingAltText]=\"ePrescribingAltText\"\r\n  [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n  [zipLabel]=\"zipLabel\"\r\n  [zipErrorText]=\"zipErrorText\"\r\n  [pharmacySearchButtonText]=\"pharmacySearchButtonText\"\r\n  [pharmacyNameText]=\"pharmacyNameText\"\r\n  [pharmacyNameHintText]=\"pharmacyNameHintText\"\r\n  [pharmacyFilterText]=\"pharmacyFilterText\"\r\n  [isPharmacyFilterEnabled]=\"isPharmacyFilterEnabled\"\r\n  [isPharmacyInNetworkFilterEnabled]=\"isPharmacyInNetworkFilterEnabled\"\r\n  [isPharmacyOtherFilterEnabled]=\"isPharmacyOtherFilterEnabled\"\r\n  [pharmacyFilterClearText]=\"pharmacyFilterClearText\"\r\n  [pharmacyFilterData]=\"pharmacyFilterData\"\r\n  [defaultFilterText]=\"defaultFilterText\"\r\n  [countyLabel]=\"countyLabel\"\r\n  [showCountyLabel]=\"showCountyLabel\"\r\n  [pharmacyInNetworkFilters]=\"pharmacyInNetworkFilters\"\r\n  [digitalPharmacyEnabled]=\"digitalPharmacyEnabled\"\r\n  [retailTabText]=\"retailTabText\"\r\n  [digitalTabText]=\"digitalTabText\"\r\n></vnext-widget-pharmacy-search>\r\n" }]
    }], null, { pharmacySearchIntroText: [{
            type: Input
        }], informationalText: [{
            type: Input
        }], enablePharmacyInfoSection: [{
            type: Input
        }], retrieveZipCode: [{
            type: Input
        }], retrieveFipsCode: [{
            type: Input
        }], addPharmacyButtonText: [{
            type: Input
        }], pharmacyLimit: [{
            type: Input
        }], pharmacyMapDefaultZoom: [{
            type: Input
        }], maxZoom: [{
            type: Input
        }], minZoom: [{
            type: Input
        }], currentPharmacyText: [{
            type: Input
        }], pharmacyAddedLabel: [{
            type: Input
        }], electronicPrescriptionTooltipHeader: [{
            type: Input
        }], electronicPrescriptionTooltipBody: [{
            type: Input
        }], itemsPerPage: [{
            type: Input
        }], pharmacyPaginationEnabled: [{
            type: Input
        }], paginationText: [{
            type: Input
        }], viewNotFoundHeaderText: [{
            type: Input
        }], viewNotFoundBodyText: [{
            type: Input
        }], preferredInNetworkText: [{
            type: Input
        }], standardInNetworkText: [{
            type: Input
        }], preferredInNetworkTooltipContent: [{
            type: Input
        }], standardInNetworkTooltipContent: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], addedPharmacyText: [{
            type: Input
        }], addPharmacyText: [{
            type: Input
        }], ePrescribingAltText: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }], zipLabel: [{
            type: Input
        }], zipErrorText: [{
            type: Input
        }], pharmacySearchButtonText: [{
            type: Input
        }], pharmacyNameText: [{
            type: Input
        }], pharmacyNameHintText: [{
            type: Input
        }], pharmacyFilterText: [{
            type: Input
        }], isPharmacyFilterEnabled: [{
            type: Input
        }], isPharmacyOtherFilterEnabled: [{
            type: Input
        }], isPharmacyInNetworkFilterEnabled: [{
            type: Input
        }], pharmacyFilterClearText: [{
            type: Input
        }], pharmacyFilterData: [{
            type: Input
        }], defaultFilterText: [{
            type: Input
        }], countyLabel: [{
            type: Input
        }], showCountyLabel: [{
            type: Input
        }], pharmacyInNetworkFilters: [{
            type: Input
        }], digitalPharmacyEnabled: [{
            type: Input
        }], retailTabText: [{
            type: Input
        }], digitalTabText: [{
            type: Input
        }] }); })();

const BLACKLISTED_PRESCRIPTION_PLAN_TYPES = [PlanType.MA, PlanType.DENTAL, PlanType.VISION];
const BLACKLISTED_PHARMACY_PLAN_TYPES = [PlanType.MA, PlanType.DENTAL, PlanType.VISION];
const BLACKLISTED_OTHER_PREFERENCES_PLAN_TYPES = [PlanType.PDP, PlanType.DENTAL, PlanType.VISION];
const WHITELISTED_PROVIDER_PLAN_TYPES = [PlanType.MA, PlanType.MAPD];
const BLACKLISTED_TOTAL_COSTS_PLAN_TYPES = [PlanType.MEDIGAP, PlanType.DENTAL, PlanType.VISION];
const WHITELISTED_HEALTH_COSTS_PLAN_TYPES = [PlanType.MA, PlanType.MAPD];

class FootnoteFacade {
    constructor(configResourceService) {
        this.configResourceService = configResourceService;
    }
    getFootNotes(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanDetails_Footnotes', widgetName, {
            'A': `This drug may be covered under Medicare Part B or D depending upon the circumstances. Information may need to be
      submitted describing the use and setting of the drug to make the determination.`,
            '+': `This drug can be ordered through a mail order pharmacy`,
            '11': `You may be charged a separate vaccine administration  fee to get a vaccine at a network pharmacy.
      The maximum vaccine administration fee that you can be charged at a network pharmacy is <Vaccine_Admin_Fee>.
      Not all pharmacies provide and/or administer vaccines. If you are not getting the vaccine administered at a network
      pharmacy, please contact your plan for more information about vaccine administration charges.`,
            '15': `Any amount you spend for a non-formulary drug is not counted towards the deductible, initial coverage limit or out of
      pocket costs UNLESS the plan approves a formulary exception. If an exception is approved, the non-formulary drug will
      be covered. The drug cost displayed is only an estimate and actual cost may vary.  Please contact the plan for more information.`,
            '4': `This type of drug is excluded from coverage under the Medicare program. This plan does not offer a
    supplemental benefit for this type of drug. Any amount that you spend for this type of drug is not counted toward any deductibles,
    initial coverage or out of pocket limits. The drug cost displayed is only an estimate and actual cost may vary.`,
            '14': `You selected that you get this medicine from a mail order pharmacy.
    The cost displayed is what you would pay at a retail pharmacy.`,
            '9': `This drug may only be available at certain pharmacies due
    to reasons such as special handling or requirements by the Food and Drug Administration. Please contact the plan for details.`,
            '1': `Cost (co-payment) displayed is for a 30-day supply.`,
            '104': `Cost (co-payment) displayed is for a 30-day supply.`,
            '103': `Cost (co-payment) displayed is for a 30-day supply.`,
            '102': `Cost (co-payment) displayed is for a 30-day supply.`,
            '101': `Cost (co-payment) displayed is for a 30-day supply.`,
            '16': `This drug is covered by the plan; however, the plan does not offer a benefit for the frequency and pharmacy type you selected.
      Therefore, the cost displayed is an estimate of the full cost of the drug for the frequency entered.`,
            '7': `The price displayed for this drug may be lower than what you would typically pay during
      this period because of additional gap coverage offered by this plan.`,
            '17': `Your plan also provides coverage of this drug under a supplemental Part D benefit. Please contact your plan for additional
    information regarding how coverage under a supplemental benefit could impact the cost sharing estimate shown above for this drug.`,
            '6': `The initial fill of a prescription for this drug is available at $0.00 cost-sharing.  Please contact your plan for details.`,
            '10': `Medicare Part D drug plans may have quantity limitations on their coverage for drugs offered under a supplemental
    benefit such as drugs for weight loss/gain or erectile dysfunction. These coverage limits are not subject to exception.`,
            '12': `This is a home infusion drug and is covered under enhanced medical (Part C) benefits. Please contact the plan for details.`,
            '2': `By law, this type of drug is excluded from coverage under the Medicare program; however, some plans, including this one,
    may cover this type of drug under a Part D supplemental benefit.  Any amount that you spend for this type of drug is not
    counted toward any deductibles, initial coverage or out of pocket limits.`,
            '20': `The price displayed for this insulin may be lower than what you would typically pay for a drug in this tier because this drug is included in the Part D Senior Savings Model program offered by this plan.`
        });
    }
}
FootnoteFacade.ɵfac = function FootnoteFacade_Factory(t) { return new (t || FootnoteFacade)(i0.ɵɵinject(i1.ConfigResourceService)); };
FootnoteFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FootnoteFacade, factory: FootnoteFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FootnoteFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.ConfigResourceService }]; }, null); })();

class HelpfulToolsFacade {
    constructor(store, helpfulToolsContext, helpfulToolsService, planListFacade, plansService) {
        this.store = store;
        this.helpfulToolsContext = helpfulToolsContext;
        this.helpfulToolsService = helpfulToolsService;
        this.planListFacade = planListFacade;
        this.plansService = plansService;
    }
    get zipCodeAction() {
        return this.helpfulToolsService.getZipCodeSelected;
    }
    get fipsCodeAction() {
        return this.helpfulToolsService.getFipsCodeSelected;
    }
    get helpfulToolsCounties() {
        return this.helpfulToolsService.getHelpfulToolsCounties;
    }
    get visiblePlanCountsByTabIndex$() {
        return this.planListFacade.getVisiblePlanCountsByTabIndex$();
    }
    get totalPlanCount$() {
        return this.planListFacade.getTotalPlanCount$();
    }
    get activeTabIndex$() {
        return this.planListFacade.getActiveTabIndex$();
    }
    // TODO: test plan counts in helpful tools
    get currentTabPlanCount$() {
        return this.planListFacade.getCurrentTabPlanCount$();
    }
    get lastActiveTabThatIsNotDefault$() {
        return this.planListFacade.getLastActiveTabThatIsNotDefault$();
    }
    get filteredPlans$() {
        return this.planListFacade.getFilteredPlans$();
    }
    get filteredPlansHasSNPPlans$() {
        return this.planListFacade.getFilteredPlansHasSNPPlans$();
    }
    get totalAppliedFilters$() {
        return this.planListFacade.getTotalAppliedFilters$();
    }
    get defaultPlansTabType$() {
        return this.planListFacade.getDefaultTabType$();
    }
    // Preparing store data.
    getLoadingStatus$(planType) {
        return this.store.select(PlansState.loading(planType));
    }
    getLoadedStatus$(planType) {
        return this.store.select(PlansState.loaded(planType));
    }
    getMemberZipcode$() {
        return this.store.select(DemographicState.selectedZipCode);
    }
    getPlan() {
        return this.store.selectSnapshot(HelpfulToolsState.selectedPlan);
    }
    getPlans$() {
        return this.store.select(PlansState.plansByType([ALL_MEDICARE_PLAN_TYPE_VALUE]));
    }
    getSelectedPlan$() {
        return this.helpfulToolsService.getPlan$();
    }
    getFilterGroups$() {
        return this.store.select(PlansState.filterGroups);
    }
    getActiveTabType$() {
        return this.store.select(PlansState.activeTabType);
    }
    getDefaultTabType$() {
        return this.store.select(PlansState.defaultTabType);
    }
    getVisibleSNPTypes$() {
        return this.planListFacade.getVisibleSNPTypes$();
    }
    // Preparing the tab data as this is different from PlanList, but config is the same.
    getPreparedTabData() {
        // get the tabdata and look and see if defaultActive is set
        const tabData = this.helpfulToolsContext.getTabInformation();
        const isDefaultActiveSet = !!tabData.find(x => x.defaultActive);
        const secondaryIndex = tabData.findIndex(x => x.secondaryDefaultActive);
        if (isDefaultActiveSet) {
            return this.sort(tabData);
        }
        // if not look for secondary and set it
        const hasSecondary = secondaryIndex !== -1;
        if (hasSecondary) {
            tabData[secondaryIndex].defaultActive = true;
            tabData[secondaryIndex].secondaryDefaultActive = false;
            return this.sort(tabData);
        }
        // else set first as default
        tabData[0].defaultActive = true;
        return tabData;
    }
    // get the mobile tabs
    getMobileTabs(lastActiveTab) {
        return this.planListFacade.getMobileTabs(lastActiveTab);
    }
    // sort the tabs
    sort(tabs) {
        return this.planListFacade.sort(tabs);
    }
    updateDefaultTab(planType) {
        this.planListFacade.updateDefaultTab(planType);
    }
    resetPharmacy() {
        this.store.dispatch(new ResetPharmacy());
    }
    getPlanById(planId) {
        return this.plansService.getPlan(planId);
    }
}
HelpfulToolsFacade.ɵfac = function HelpfulToolsFacade_Factory(t) { return new (t || HelpfulToolsFacade)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(HelpfulToolsContextService), i0.ɵɵinject(HelpfulToolsService), i0.ɵɵinject(PlanListFacadeService), i0.ɵɵinject(i1.PlansService)); };
HelpfulToolsFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HelpfulToolsFacade, factory: HelpfulToolsFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpfulToolsFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i2.Store }, { type: HelpfulToolsContextService }, { type: HelpfulToolsService }, { type: PlanListFacadeService }, { type: i1.PlansService }]; }, null); })();

class DrugCabinetContext {
    constructor() {
        this._drugEntry$ = new BehaviorSubject(null);
        this.extendedPlanWithDrugAlternatives$ = new BehaviorSubject(null);
    }
    getDrugEntry$() {
        return this._drugEntry$.asObservable();
    }
    setDrugEntry(plan, cabinetEntry) {
        this._drugEntry$.next({
            cabinetEntry,
            formularyStatus: this.getDrugFormularyStatus(plan, cabinetEntry)
        });
    }
    clearDrugEntry() {
        this._drugEntry$.next(null);
    }
    getExtendedPlanWithDrugAlternatives$() {
        return this.extendedPlanWithDrugAlternatives$.asObservable();
    }
    setExtendedPlanWithDrugAlternatives(extendedPlanWithDrugAlternatives) {
        this.extendedPlanWithDrugAlternatives$.next(extendedPlanWithDrugAlternatives);
    }
    clearExtendedPlanWithDrugAlternatives() {
        this.extendedPlanWithDrugAlternatives$.next(null);
    }
    getDrugFormularyStatus(plan, cabinetEntry) {
        return plan.planRetailDrugCoverageMultiPharmacy?.find(drugNonCoveraged => drugNonCoveraged.drugDosageID === cabinetEntry.dosageID);
    }
}
DrugCabinetContext.ɵfac = function DrugCabinetContext_Factory(t) { return new (t || DrugCabinetContext)(); };
DrugCabinetContext.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DrugCabinetContext, factory: DrugCabinetContext.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugCabinetContext, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

function MedicalConditionsDrugAlternativesDetailsComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 8);
    i0.ɵɵlistener("click", function MedicalConditionsDrugAlternativesDetailsComponent_ng_container_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.showMedicalConditionsToSelect()); })("keyup.enter", function MedicalConditionsDrugAlternativesDetailsComponent_ng_container_9_Template_button_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.showMedicalConditionsToSelect()); });
    i0.ɵɵelementStart(2, "div", 9)(3, "span", 10);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "i", 11);
    i0.ɵɵelementStart(6, "span", 12);
    i0.ɵɵtext(7, "Edit");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.selectedMedicalCondition == null ? null : ctx_r0.selectedMedicalCondition.conditionDisplayName, " ");
} }
function MedicalConditionsDrugAlternativesDetailsComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.selectedMedicalCondition == null ? null : ctx_r2.selectedMedicalCondition.conditionDisplayName, " ");
} }
class MedicalConditionsDrugAlternativesDetailsComponent {
    constructor(drugDetailsFacade, injector, modalService, analyticsService, cdr) {
        this.drugDetailsFacade = drugDetailsFacade;
        this.injector = injector;
        this.modalService = modalService;
        this.analyticsService = analyticsService;
        this.cdr = cdr;
        this.drugAlternativesCount = 0;
        this.selectMedicalCondition = new EventEmitter();
        this.subscriptions = new Subscription();
    }
    ngOnChanges(changes) {
        const { cabinet, plan, isMailOrder, changeMedicalConditionsEnabled } = changes;
        if ((changeMedicalConditionsEnabled && changeMedicalConditionsEnabled.previousValue !== changeMedicalConditionsEnabled.currentValue) ||
            (isMailOrder && isMailOrder.previousValue !== isMailOrder.currentValue) ||
            (cabinet && !_isEqual(cabinet.previousValue, cabinet.currentValue)) ||
            (plan && !_isEqual(plan.previousValue, plan.currentValue))) {
            if (this.cabinet && this.plan) {
                const drugCoverage = this.isMailOrder
                    ? this.plan.planMailOrderDrugCoverage
                    : this.plan.planRetailDrugCoverageMultiPharmacy;
                this.medicalConditions = this.drugDetailsFacade.getMedicalConditions(drugCoverage, this.cabinet.dosageID);
                if (this.medicalConditions?.length) {
                    this.showMultipleMedicalConditionsLink = this.medicalConditions.length > 1 && this.changeMedicalConditionsEnabled;
                }
            }
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    showMedicalConditionsToSelect() {
        const options = {
            centered: true,
            injector: this.injector
        };
        const medicalConditionDrugAlternativesSelectionModal = this.modalService.open(MedicalConditionDrugAlternativesSelectionModalComponent, options);
        this.setAnalyticsForDrugAlternativesChangeMedicalCondition();
        medicalConditionDrugAlternativesSelectionModal.componentInstance.title = this.cabinet?.dosage.labelName;
        medicalConditionDrugAlternativesSelectionModal.componentInstance.medicalConditions = this.medicalConditions;
        medicalConditionDrugAlternativesSelectionModal.componentInstance.medicalConditionSelectedId = this.selectedMedicalCondition.conditionID;
        medicalConditionDrugAlternativesSelectionModal.componentInstance.conditionPrescribedForText = this.conditionPrescribedForText;
        this.subscriptions.add(from(medicalConditionDrugAlternativesSelectionModal.result)
            .pipe(filter(medicalConditionSelectedId => !!medicalConditionSelectedId))
            .subscribe({
            next: (medicalConditionSelectedId) => {
                this.setAnalyticsForDrugAlternativesConfirmChangeMedicalCondition(medicalConditionSelectedId.toString());
                this.selectedMedicalCondition = this.medicalConditions.find(medicalCondition => medicalCondition.conditionID === medicalConditionSelectedId);
                this.selectMedicalCondition.emit(this.selectedMedicalCondition);
                this.cdr.markForCheck();
            },
            error: () => { }
        }));
    }
    setAnalyticsForDrugAlternativesChangeMedicalCondition() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_DRUG_ALTERNATIVES_CHANGE_CONDITION);
    }
    setAnalyticsForDrugAlternativesConfirmChangeMedicalCondition(drugMedicalCondition) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLANS_DRUG_ALTERNATIVES_CHANGE_CONDITION_CONFIRM,
            [DataLayerGlobalVariable.DRUG_CONDITION]: drugMedicalCondition
        };
    }
}
MedicalConditionsDrugAlternativesDetailsComponent.ɵfac = function MedicalConditionsDrugAlternativesDetailsComponent_Factory(t) { return new (t || MedicalConditionsDrugAlternativesDetailsComponent)(i0.ɵɵdirectiveInject(DrugDetailsFacade), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
MedicalConditionsDrugAlternativesDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedicalConditionsDrugAlternativesDetailsComponent, selectors: [["vnext-medical-conditions-drug-alternatives-details"]], inputs: { hintAlternativesForCabinetHeaderText: "hintAlternativesForCabinetHeaderText", cabinet: "cabinet", isMailOrder: "isMailOrder", plan: "plan", conditionPrescribedForText: "conditionPrescribedForText", changeMedicalConditionsEnabled: "changeMedicalConditionsEnabled", drugAlternativesCount: "drugAlternativesCount", selectedMedicalCondition: "selectedMedicalCondition" }, outputs: { selectMedicalCondition: "selectMedicalCondition" }, features: [i0.ɵɵNgOnChangesFeature], decls: 14, vars: 7, consts: [[1, "row"], [1, "col-12"], [1, "my-2", "Spa_Style_H4", "font-weight-bold"], [1, "no-translate-block"], [4, "ngIf", "ngIfElse"], ["singleMedicalCondition", ""], [1, "p-0"], [1, "my-0", "mt-2"], ["tabindex", "0", 1, "action-button", "font-weight-bold", "Spa_Style_Link", "pl-1", 3, "click", "keyup.enter"], [1, "d-flex", "flex-row"], [1, "Spa_Style_Regular_Font"], [1, "fa", "fa-edit", "pl-1", "Spa_Style_Smaller_Font"], [1, "sr-only"]], template: function MedicalConditionsDrugAlternativesDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h4", 2)(3, "span");
        i0.ɵɵtext(4);
        i0.ɵɵelementStart(5, "span", 3);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵtext(7);
        i0.ɵɵpipe(8, "lowercase");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, MedicalConditionsDrugAlternativesDetailsComponent_ng_container_9_Template, 8, 1, "ng-container", 4);
        i0.ɵɵtemplate(10, MedicalConditionsDrugAlternativesDetailsComponent_ng_template_10_Template, 2, 1, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 6);
        i0.ɵɵelement(13, "hr", 7);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(11);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.drugAlternativesCount, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.cabinet == null ? null : ctx.cabinet.dosage == null ? null : ctx.cabinet.dosage.drugName);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 5, ctx.hintAlternativesForCabinetHeaderText), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showMultipleMedicalConditionsLink)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgIf, IconAriaAttributesDirective, i1$2.LowerCasePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedicalConditionsDrugAlternativesDetailsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-medical-conditions-drug-alternatives-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row\">\r\n  <div class=\"col-12\">\r\n    <h4 class=\"my-2 Spa_Style_H4 font-weight-bold\">\r\n      <span> {{ drugAlternativesCount }} <span class=\"no-translate-block\">{{ cabinet?.dosage?.drugName }}</span> {{ hintAlternativesForCabinetHeaderText | lowercase }} </span>\r\n\r\n      <ng-container *ngIf=\"showMultipleMedicalConditionsLink; else singleMedicalCondition\">\r\n        <button\r\n          class=\"action-button font-weight-bold Spa_Style_Link pl-1\"\r\n          tabindex=\"0\"\r\n          (click)=\"showMedicalConditionsToSelect()\"\r\n          (keyup.enter)=\"showMedicalConditionsToSelect()\"\r\n        >\r\n          <div class=\"d-flex flex-row\">\r\n            <span class=\"Spa_Style_Regular_Font\">\r\n              {{ selectedMedicalCondition?.conditionDisplayName }}\r\n            </span>\r\n            <i class=\"fa fa-edit pl-1 Spa_Style_Smaller_Font\"></i>\r\n            <span class=\"sr-only\">Edit</span>\r\n          </div>\r\n        </button>\r\n      </ng-container>\r\n\r\n      <ng-template #singleMedicalCondition>\r\n        <span>\r\n          {{ selectedMedicalCondition?.conditionDisplayName }}\r\n        </span>\r\n      </ng-template>\r\n    </h4>\r\n\r\n    <div class=\"p-0\">\r\n      <hr class=\"my-0 mt-2\" />\r\n    </div>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: DrugDetailsFacade }, { type: i0.Injector }, { type: i1$1.NgbModal }, { type: AnalyticsService }, { type: i0.ChangeDetectorRef }]; }, { hintAlternativesForCabinetHeaderText: [{
            type: Input
        }], cabinet: [{
            type: Input
        }], isMailOrder: [{
            type: Input
        }], plan: [{
            type: Input
        }], conditionPrescribedForText: [{
            type: Input
        }], changeMedicalConditionsEnabled: [{
            type: Input
        }], drugAlternativesCount: [{
            type: Input
        }], selectedMedicalCondition: [{
            type: Input
        }], selectMedicalCondition: [{
            type: Output
        }] }); })();

function NonCoveredDrugAlternativesSubDetailsComponent_div_0_vnext_drug_footnote_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-drug-footnote", 25);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("plan", ctx_r3.plan)("footnoteAId", ctx_r3.footnoteAId)("footnoteIdsToShow", ctx_r3.footnoteIdsToShow);
} }
function NonCoveredDrugAlternativesSubDetailsComponent_div_0_ng_container_32_ng_container_2_ng_container_4_vnext_drug_card_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-drug-card", 31);
} if (rf & 2) {
    const drugAlternative_r11 = ctx.$implicit;
    const ctx_r10 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("cabinetEntry", drugAlternative_r11.cabinetEntry)("drugCostDetails", drugAlternative_r11.drugCostDetails)("plan", ctx_r10.extendedPlanWithDrugAlternatives)("showGenericOption", ctx_r10.showGenericOption)("showCosts", true)("selectedPharmacy", ctx_r10.selectedPharmacy)("isCovered", false)("isMailOrderSelected", ctx_r10.isMailOrder);
} }
function NonCoveredDrugAlternativesSubDetailsComponent_div_0_ng_container_32_ng_container_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NonCoveredDrugAlternativesSubDetailsComponent_div_0_ng_container_32_ng_container_2_ng_container_4_vnext_drug_card_1_Template, 1, 8, "vnext-drug-card", 30);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const planTierDrugAlternatives_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", planTierDrugAlternatives_r6 == null ? null : planTierDrugAlternatives_r6.drugAlternatives)("ngForTrackBy", ctx_r7.trackByDosageIdAndPharmacyNABP);
} }
function NonCoveredDrugAlternativesSubDetailsComponent_div_0_ng_container_32_ng_container_2_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32)(1, "p", 33);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r9.noPrescriptionInTierText);
} }
function NonCoveredDrugAlternativesSubDetailsComponent_div_0_ng_container_32_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 27)(2, "h3", 28);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, NonCoveredDrugAlternativesSubDetailsComponent_div_0_ng_container_32_ng_container_2_ng_container_4_Template, 2, 2, "ng-container", 24);
    i0.ɵɵtemplate(5, NonCoveredDrugAlternativesSubDetailsComponent_div_0_ng_container_32_ng_container_2_ng_template_5_Template, 3, 1, "ng-template", null, 29, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const planTierDrugAlternatives_r6 = ctx.$implicit;
    const _r8 = i0.ɵɵreference(6);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", planTierDrugAlternatives_r6 == null ? null : planTierDrugAlternatives_r6.tierInformation == null ? null : planTierDrugAlternatives_r6.tierInformation.description, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (planTierDrugAlternatives_r6 == null ? null : planTierDrugAlternatives_r6.drugAlternatives == null ? null : planTierDrugAlternatives_r6.drugAlternatives.length) > 0)("ngIfElse", _r8);
} }
function NonCoveredDrugAlternativesSubDetailsComponent_div_0_ng_container_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵtemplate(2, NonCoveredDrugAlternativesSubDetailsComponent_div_0_ng_container_32_ng_container_2_Template, 7, 3, "ng-container", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r4.planTiersDrugAlternatives);
} }
function NonCoveredDrugAlternativesSubDetailsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "vnext-link", 4);
    i0.ɵɵlistener("click", function NonCoveredDrugAlternativesSubDetailsComponent_div_0_Template_vnext_link_click_2_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.backToPrevious()); })("keyup.enter", function NonCoveredDrugAlternativesSubDetailsComponent_div_0_Template_vnext_link_keyup_enter_2_listener() { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.backToPrevious()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "div", 5)(4, "div")(5, "h5", 6);
    i0.ɵɵtext(6);
    i0.ɵɵelementStart(7, "span", 7);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(9, "div", 8);
    i0.ɵɵpipe(10, "safe");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 9)(12, "div", 10)(13, "div", 11)(14, "div", 12)(15, "div", 13)(16, "h3", 14);
    i0.ɵɵtext(17);
    i0.ɵɵtemplate(18, NonCoveredDrugAlternativesSubDetailsComponent_div_0_vnext_drug_footnote_18_Template, 1, 3, "vnext-drug-footnote", 15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "div", 16)(20, "div", 17);
    i0.ɵɵelement(21, "p", 18);
    i0.ɵɵpipe(22, "safe");
    i0.ɵɵelement(23, "vnext-drug-type", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 20)(25, "p", 21);
    i0.ɵɵtext(26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "strong");
    i0.ɵɵtext(28);
    i0.ɵɵpipe(29, "currency");
    i0.ɵɵelementEnd()()()()()();
    i0.ɵɵelementStart(30, "div", 22)(31, "vnext-medical-conditions-drug-alternatives-details", 23);
    i0.ɵɵlistener("selectMedicalCondition", function NonCoveredDrugAlternativesSubDetailsComponent_div_0_Template_vnext_medical_conditions_drug_alternatives_details_selectMedicalCondition_31_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.onSelectMedicalCondition($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(32, NonCoveredDrugAlternativesSubDetailsComponent_div_0_ng_container_32_Template, 3, 1, "ng-container", 24);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", ctx_r0.backToPrescriptionLabelText)("showArrow", "left");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.hintAlternativesForCabinetHeaderText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.cabinet == null ? null : ctx_r0.cabinet.dosage.drugName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(10, 23, ctx_r0.hintAlternativesForCabinetText, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.cabinet == null ? null : ctx_r0.cabinet.dosage.labelName, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.footnoteIdsToShow);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(22, 26, ctx_r0.dosePackageQuantityFreq, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("dosage", ctx_r0.cabinet == null ? null : ctx_r0.cabinet.dosage)("drugListCardBrandText", ctx_r0.drugListCardBrandText)("drugListCardGenericText", ctx_r0.drugListCardGenericText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.drugCostsRetailCostText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind4(29, 29, ctx_r0.basePrice, "USD", "symbol", "1.2-2"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("hintAlternativesForCabinetHeaderText", ctx_r0.hintAlternativesForCabinetHeaderText)("conditionPrescribedForText", ctx_r0.conditionPrescribedForText)("changeMedicalConditionsEnabled", ctx_r0.changeMedicalConditionsEnabled)("cabinet", ctx_r0.cabinet)("plan", ctx_r0.plan)("isMailOrder", ctx_r0.isMailOrder)("drugAlternativesCount", ctx_r0.filteredDrugAlternatives.length)("selectedMedicalCondition", ctx_r0.selectedMedicalCondition);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.extendedPlanWithDrugAlternatives && (ctx_r0.planTiersDrugAlternatives == null ? null : ctx_r0.planTiersDrugAlternatives.length) > 0)("ngIfElse", _r1);
} }
function NonCoveredDrugAlternativesSubDetailsComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 34);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r2.hintNoAlternativesForCabinet, "html"), i0.ɵɵsanitizeHtml);
} }
class NonCoveredDrugAlternativesSubDetailsComponent {
    constructor(drugDetailsFacade, drugsService, drugFrequencyFacade, planFacade, cdr, drugCabinetContext, spinnerService, helpfulToolsService) {
        this.drugDetailsFacade = drugDetailsFacade;
        this.drugsService = drugsService;
        this.drugFrequencyFacade = drugFrequencyFacade;
        this.planFacade = planFacade;
        this.cdr = cdr;
        this.drugCabinetContext = drugCabinetContext;
        this.spinnerService = spinnerService;
        this.helpfulToolsService = helpfulToolsService;
        this.isHelpfulToolsView = false;
        this.backToDefaultPrescriptionTab = new EventEmitter();
        this.basePrice = 0;
        this.footnoteAId = 'A';
        this.planTiersDrugAlternatives = [];
        this.filteredDrugAlternatives = [];
        this.drugAlternatives = [];
        this.subscriptions = new Subscription();
        this.cabinet$ = new BehaviorSubject(null);
        this.plan$ = new BehaviorSubject(null);
        this.isMailOrder$ = new BehaviorSubject(false);
    }
    ngOnChanges(changes) {
        const { isMailOrder, cabinet, drugSearchFrequencies, plan, selectedPharmacy } = changes;
        if ((isMailOrder && isMailOrder.previousValue !== isMailOrder.currentValue) ||
            (cabinet && !_isEqual(cabinet.previousValue, cabinet.currentValue)) ||
            (drugSearchFrequencies && !_isEqual(drugSearchFrequencies.previousValue, drugSearchFrequencies.currentValue))) {
            if (this.cabinet) {
                const drugSearchFrequencyList = this.drugFrequencyFacade.getFilteredFrequencyOptions(this.drugSearchFrequencies);
                this.dosePackageQuantityFreq = this.drugDetailsFacade.calculateDosage(this.isMailOrder, this.cabinet.dosage, this.cabinet.packageId, drugSearchFrequencyList, this.drugsService.getFrequency(this.cabinet.dosage.daysOfSupply), this.drugsService.getForm(this.cabinet.dosage.labelName));
            }
        }
        if ((isMailOrder && isMailOrder.previousValue !== isMailOrder.currentValue) ||
            (cabinet && !_isEqual(cabinet.previousValue, cabinet.currentValue)) ||
            (plan && !_isEqual(plan.previousValue, plan.currentValue)) ||
            (selectedPharmacy && !_isEqual(selectedPharmacy.previousValue, selectedPharmacy.currentValue))) {
            if (this.cabinet && this.plan) {
                const coverageStatus = this.drugDetailsFacade.getDrugCoverageForPrices(this.isMailOrder, this.plan.planMailOrderDrugCoverage, this.plan.planRetailDrugCoverageMultiPharmacy, this.selectedPharmacy, this.cabinet);
                this.basePrice = coverageStatus?.basePrice ?? 0;
            }
        }
        if (cabinet?.currentValue && !_isEqual(cabinet.previousValue, cabinet.currentValue)) {
            this.cabinet$.next(this.cabinet);
        }
        if (plan?.currentValue && !_isEqual(plan.previousValue, plan.currentValue)) {
            this.plan$.next(this.plan);
        }
        if (isMailOrder && isMailOrder.previousValue !== isMailOrder.currentValue) {
            this.isMailOrder$.next(this.isMailOrder);
        }
        if (this.plan &&
            ((selectedPharmacy?.currentValue && !_isEqual(selectedPharmacy.previousValue, selectedPharmacy.currentValue)) ||
                (isMailOrder && isMailOrder.previousValue !== isMailOrder.currentValue))) {
            this.setFilteredDrugAlternativesWithUpdatedPlan({
                drugAlternatives: this.drugAlternatives,
                selectedPharmacy: this.selectedPharmacy,
                isMailOrder: this.isMailOrder,
                plan: this.plan
            });
        }
    }
    ngOnInit() {
        this.subscriptions.add(this.drugCabinetContext.getExtendedPlanWithDrugAlternatives$().subscribe({
            next: extendedPlanWithDrugAlternatives => {
                this.extendedPlanWithDrugAlternatives = extendedPlanWithDrugAlternatives;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.drugDetailsFacade
            .getMedicalCondition$(this.cabinet$.asObservable(), this.plan$.asObservable(), this.isMailOrder$.asObservable())
            // prevents a 2nd fetch when we save a new medical condition
            .pipe(filter(selectedMedicalCondition => !_isEqual(this.selectedMedicalCondition, selectedMedicalCondition)))
            .subscribe({
            next: selectedMedicalCondition => {
                this.selectedMedicalCondition = selectedMedicalCondition;
                this.fetchDrugAlternatives(this.plan.id, this.cabinet, this.selectedMedicalCondition?.conditionID);
                this.cdr.markForCheck();
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    backToPrevious() {
        this.backToDefaultPrescriptionTab.emit();
    }
    onSelectMedicalCondition(selectedMedicalCondition) {
        if (selectedMedicalCondition) {
            this.selectedMedicalCondition = selectedMedicalCondition;
            this.drugDetailsFacade.saveMedicalCondition(this.selectedMedicalCondition.conditionID, this.cabinet.dosageID);
            this.fetchDrugAlternatives(this.plan.id, this.cabinet, this.selectedMedicalCondition?.conditionID);
            this.cdr.markForCheck();
        }
    }
    trackByDosageIdAndPharmacyNABP(index, drugAlternative) {
        const { dosageId, formularyStatus } = drugAlternative.drugCostDetails;
        return `${dosageId}-${formularyStatus.pharmacyNABP}`;
    }
    fetchDrugAlternatives(planId, cabinet, medicalConditionId) {
        if (planId && cabinet && medicalConditionId) {
            this.spinnerService.show(SpinnerEvent.NAVIGATION);
            const helpfulToolsDemographicsOptions = this.getHelpfulToolsDemographicsOptions();
            this.subscriptions.add(this.planFacade
                .getDrugAlternatives$(planId, cabinet.dosageID, medicalConditionId, [cabinet], helpfulToolsDemographicsOptions)
                .subscribe({
                next: drugAlternatives => {
                    this.drugAlternatives = drugAlternatives;
                    this.setFilteredDrugAlternativesWithUpdatedPlan({
                        drugAlternatives,
                        selectedPharmacy: this.selectedPharmacy,
                        isMailOrder: this.isMailOrder,
                        plan: this.plan
                    });
                    this.spinnerService.hide(SpinnerEvent.NAVIGATION);
                    this.cdr.markForCheck();
                },
                error: () => {
                    this.spinnerService.hide(SpinnerEvent.NAVIGATION);
                }
            }));
        }
    }
    getHelpfulToolsDemographicsOptions() {
        let helpfulToolsDemographicsOptions;
        if (this.isHelpfulToolsView) {
            helpfulToolsDemographicsOptions = {
                fips: this.helpfulToolsService.getFipsCodeSelected(),
                zip: this.helpfulToolsService.getZipCodeSelected()
            };
        }
        return helpfulToolsDemographicsOptions;
    }
    filterDrugAlternativesByPharmacy(drugAlternatives, selectedPharmacy, isMailOrder) {
        return this.drugsService.filterDrugAlternativesByPharmacy(drugAlternatives, selectedPharmacy, isMailOrder);
    }
    setFilteredDrugAlternativesWithUpdatedPlan(options) {
        const { drugAlternatives, selectedPharmacy, isMailOrder, plan } = options;
        this.filteredDrugAlternatives = this.filterDrugAlternativesByPharmacy(drugAlternatives, selectedPharmacy, isMailOrder);
        this.drugCabinetContext.setExtendedPlanWithDrugAlternatives(this.planFacade.extendPlanRetailDrugCoverageMultiPharmacyWithDrugAlternatives(plan, this.filteredDrugAlternatives, isMailOrder));
        this.planTiersDrugAlternatives = this.getPlanDrugAlternativesWithTierInformation(this.filteredDrugAlternatives);
    }
    getPlanDrugAlternativesWithTierInformation(filteredDrugAlternatives) {
        const planTiers = this.drugDetailsFacade.getCoveredPlanTiers(this.plan, this.isMailOrder ? PharmacyType.MailOrder : PharmacyType.Retail);
        const drugsAlternativesByTierNumberMap = filteredDrugAlternatives.reduce((drugsAlternativesMap, drugAlternativeDetails) => {
            const { tierNumber } = drugAlternativeDetails.drugCostDetails.formularyStatus;
            if (!drugsAlternativesMap[tierNumber]) {
                drugsAlternativesMap[tierNumber] = [];
            }
            drugsAlternativesMap[tierNumber].push(drugAlternativeDetails);
            return drugsAlternativesMap;
        }, {});
        return planTiers.reduce((drugAlternativesWithTierInformation, tier) => {
            const drugDetails = drugsAlternativesByTierNumberMap[tier.tierNumber]?.sort((drugAlternativeA, drugAlternativeB) => drugAlternativeA.cabinetEntry.labelName > drugAlternativeB.cabinetEntry.labelName ? 1 : -1) ?? [];
            const drugDetailsWithTierInformation = {
                drugAlternatives: drugDetails,
                tierInformation: tier
            };
            return [...drugAlternativesWithTierInformation, drugDetailsWithTierInformation];
        }, []);
    }
}
NonCoveredDrugAlternativesSubDetailsComponent.ɵfac = function NonCoveredDrugAlternativesSubDetailsComponent_Factory(t) { return new (t || NonCoveredDrugAlternativesSubDetailsComponent)(i0.ɵɵdirectiveInject(DrugDetailsFacade), i0.ɵɵdirectiveInject(i1.DrugsService), i0.ɵɵdirectiveInject(i1.DrugFrequencyFacade), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(DrugCabinetContext), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(HelpfulToolsService)); };
NonCoveredDrugAlternativesSubDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NonCoveredDrugAlternativesSubDetailsComponent, selectors: [["vnext-non-covered-drug-alternatives-sub-details"]], inputs: { backToPrescriptionLabelText: "backToPrescriptionLabelText", hintAlternativesForCabinetText: "hintAlternativesForCabinetText", hintAlternativesForCabinetHeaderText: "hintAlternativesForCabinetHeaderText", hintNoAlternativesForCabinet: "hintNoAlternativesForCabinet", conditionPrescribedForText: "conditionPrescribedForText", drugCostsRetailCostText: "drugCostsRetailCostText", noPrescriptionInTierText: "noPrescriptionInTierText", cabinet: "cabinet", plan: "plan", isMailOrder: "isMailOrder", drugSearchFrequencies: "drugSearchFrequencies", selectedPharmacy: "selectedPharmacy", drugListCardBrandText: "drugListCardBrandText", drugListCardGenericText: "drugListCardGenericText", changeMedicalConditionsEnabled: "changeMedicalConditionsEnabled", footnoteIdsToShow: "footnoteIdsToShow", showGenericOption: "showGenericOption", isHelpfulToolsView: "isHelpfulToolsView" }, outputs: { backToDefaultPrescriptionTab: "backToDefaultPrescriptionTab" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 1, consts: [["class", "row", 4, "ngIf"], ["noAlternativesAvailable", ""], [1, "row"], [1, "col-auto", "text-center"], [3, "title", "showArrow", "click", "keyup.enter"], [1, "col-12", "mt-3"], [1, "Spa_Style_Larger_Font", "Spa_Style_Primary_Color", "mt-1", "pb-3", "text-center"], [1, "no-translate-block"], [3, "innerHTML"], [1, "row", "mx-0", "mt-4", "justify-content-center", "w-100"], [1, "col-12"], [1, "card"], [1, "card-body", "pr-0", "pl-3", "py-2"], [1, "d-flex"], [1, "Spa_Style_Regular_Font", "mt-1", "Spa_Style_Primary_Color", "Spa_Style_Semi_Bold_Weight"], [3, "plan", "footnoteAId", "footnoteIdsToShow", 4, "ngIf"], [1, "d-flex", "flex-column", "flex-sm-row", "justify-content-sm-between"], [1, "d-flex", "flex-column"], [1, "Spa_Style_Paragraph", "mb-0", 3, "innerHTML"], [3, "dosage", "drugListCardBrandText", "drugListCardGenericText"], [1, "d-flex", "flex-row", "flex-sm-column", "justify-content-between", "align-items-sm-center", "pr-3", "pt-4", "pt-sm-0"], [1, "Spa_Style_Paragraph", "mb-0"], [1, "col-12", "my-3", "pb-2", "pt-3"], [3, "hintAlternativesForCabinetHeaderText", "conditionPrescribedForText", "changeMedicalConditionsEnabled", "cabinet", "plan", "isMailOrder", "drugAlternativesCount", "selectedMedicalCondition", "selectMedicalCondition"], [4, "ngIf", "ngIfElse"], [3, "plan", "footnoteAId", "footnoteIdsToShow"], [4, "ngFor", "ngForOf"], [1, "ml-1", "mt-3", "pt-3"], [1, "Spa_Style_Large_Font", "Spa_Style_Bold_Weight", "Spa_Style_Primary_Color"], ["noDrugs", ""], [3, "cabinetEntry", "drugCostDetails", "plan", "showGenericOption", "showCosts", "selectedPharmacy", "isCovered", "isMailOrderSelected", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "cabinetEntry", "drugCostDetails", "plan", "showGenericOption", "showCosts", "selectedPharmacy", "isCovered", "isMailOrderSelected"], [1, "mt-2", "ml-1"], [1, "mt-1", "ml-1", "Spa_Style_Note"], [1, "d-flex", "flex-column", "text-center", "mt-4", 3, "innerHTML"]], template: function NonCoveredDrugAlternativesSubDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, NonCoveredDrugAlternativesSubDetailsComponent_div_0_Template, 33, 34, "div", 0);
        i0.ɵɵtemplate(1, NonCoveredDrugAlternativesSubDetailsComponent_ng_template_1_Template, 2, 4, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.cabinet && ctx.plan);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, LinkComponent, DrugFootNoteComponent, DrugTypeComponent, MedicalConditionsDrugAlternativesDetailsComponent, DrugCardComponent, i1$2.CurrencyPipe, SafePipe], styles: [".medical-condition-delimiter[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Accent1)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NonCoveredDrugAlternativesSubDetailsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-non-covered-drug-alternatives-sub-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row\" *ngIf=\"cabinet && plan\">\r\n  <div class=\"col-auto text-center\">\r\n    <vnext-link [title]=\"backToPrescriptionLabelText\" [showArrow]=\"'left'\" (click)=\"backToPrevious()\" (keyup.enter)=\"backToPrevious()\">\r\n    </vnext-link>\r\n  </div>\r\n\r\n  <div class=\"col-12 mt-3\">\r\n    <div>\r\n      <h5 class=\"Spa_Style_Larger_Font Spa_Style_Primary_Color mt-1 pb-3 text-center\">\r\n        {{ hintAlternativesForCabinetHeaderText }} <span class=\"no-translate-block\">{{ cabinet?.dosage.drugName }}</span>\r\n      </h5>\r\n    </div>\r\n    <div [innerHTML]=\"hintAlternativesForCabinetText | safe: 'html'\"></div>\r\n  </div>\r\n\r\n  <div class=\"row mx-0 mt-4 justify-content-center w-100\">\r\n    <div class=\"col-12\">\r\n      <div class=\"card\">\r\n        <div class=\"card-body pr-0 pl-3 py-2\">\r\n          <div class=\"d-flex\">\r\n            <h3 class=\"Spa_Style_Regular_Font mt-1 Spa_Style_Primary_Color Spa_Style_Semi_Bold_Weight\">\r\n              {{ cabinet?.dosage.labelName }}\r\n              <vnext-drug-footnote\r\n                *ngIf=\"footnoteIdsToShow\"\r\n                [plan]=\"plan\"\r\n                [footnoteAId]=\"footnoteAId\"\r\n                [footnoteIdsToShow]=\"footnoteIdsToShow\"\r\n              ></vnext-drug-footnote>\r\n            </h3>\r\n          </div>\r\n\r\n          <div class=\"d-flex flex-column flex-sm-row justify-content-sm-between\">\r\n            <div class=\"d-flex flex-column\">\r\n              <p class=\"Spa_Style_Paragraph mb-0\" [innerHTML]=\"dosePackageQuantityFreq | safe: 'html'\"></p>\r\n              <vnext-drug-type\r\n                [dosage]=\"cabinet?.dosage\"\r\n                [drugListCardBrandText]=\"drugListCardBrandText\"\r\n                [drugListCardGenericText]=\"drugListCardGenericText\"\r\n              >\r\n              </vnext-drug-type>\r\n            </div>\r\n\r\n            <div class=\"d-flex flex-row flex-sm-column justify-content-between align-items-sm-center pr-3 pt-4 pt-sm-0\">\r\n              <p class=\"Spa_Style_Paragraph mb-0\">{{ drugCostsRetailCostText }}</p>\r\n              <strong>{{ basePrice | currency: 'USD':'symbol':'1.2-2' }}</strong>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"col-12 my-3 pb-2 pt-3\">\r\n      <vnext-medical-conditions-drug-alternatives-details\r\n        [hintAlternativesForCabinetHeaderText]=\"hintAlternativesForCabinetHeaderText\"\r\n        [conditionPrescribedForText]=\"conditionPrescribedForText\"\r\n        [changeMedicalConditionsEnabled]=\"changeMedicalConditionsEnabled\"\r\n        [cabinet]=\"cabinet\"\r\n        [plan]=\"plan\"\r\n        [isMailOrder]=\"isMailOrder\"\r\n        [drugAlternativesCount]=\"filteredDrugAlternatives.length\"\r\n        [selectedMedicalCondition]=\"selectedMedicalCondition\"\r\n        (selectMedicalCondition)=\"onSelectMedicalCondition($event)\"\r\n      >\r\n      </vnext-medical-conditions-drug-alternatives-details>\r\n    </div>\r\n\r\n    <ng-container *ngIf=\"extendedPlanWithDrugAlternatives && planTiersDrugAlternatives?.length > 0; else noAlternativesAvailable\">\r\n      <div class=\"col-12\">\r\n        <ng-container *ngFor=\"let planTierDrugAlternatives of planTiersDrugAlternatives\">\r\n          <div class=\"ml-1 mt-3 pt-3\">\r\n            <h3 class=\"Spa_Style_Large_Font Spa_Style_Bold_Weight Spa_Style_Primary_Color\">\r\n              {{ planTierDrugAlternatives?.tierInformation?.description }}\r\n            </h3>\r\n          </div>\r\n\r\n          <ng-container *ngIf=\"planTierDrugAlternatives?.drugAlternatives?.length > 0; else noDrugs\">\r\n            <vnext-drug-card\r\n              *ngFor=\"let drugAlternative of planTierDrugAlternatives?.drugAlternatives; trackBy: trackByDosageIdAndPharmacyNABP\"\r\n              [cabinetEntry]=\"drugAlternative.cabinetEntry\"\r\n              [drugCostDetails]=\"drugAlternative.drugCostDetails\"\r\n              [plan]=\"extendedPlanWithDrugAlternatives\"\r\n              [showGenericOption]=\"showGenericOption\"\r\n              [showCosts]=\"true\"\r\n              [selectedPharmacy]=\"selectedPharmacy\"\r\n              [isCovered]=\"false\"\r\n              [isMailOrderSelected]=\"isMailOrder\"\r\n            ></vnext-drug-card>\r\n          </ng-container>\r\n\r\n          <ng-template #noDrugs>\r\n            <div class=\"mt-2 ml-1\">\r\n              <p class=\"mt-1 ml-1 Spa_Style_Note\">{{ noPrescriptionInTierText }}</p>\r\n            </div>\r\n          </ng-template>\r\n        </ng-container>\r\n      </div>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n\r\n<ng-template #noAlternativesAvailable>\r\n  <div class=\"d-flex flex-column text-center mt-4\" [innerHTML]=\"hintNoAlternativesForCabinet | safe: 'html'\"></div>\r\n</ng-template>\r\n", styles: [".medical-condition-delimiter{border-bottom:1px solid var(--static-Spa_Style_Accent1)}\n"] }]
    }], function () { return [{ type: DrugDetailsFacade }, { type: i1.DrugsService }, { type: i1.DrugFrequencyFacade }, { type: PlanFacade }, { type: i0.ChangeDetectorRef }, { type: DrugCabinetContext }, { type: i1.SpinnerService }, { type: HelpfulToolsService }]; }, { backToPrescriptionLabelText: [{
            type: Input
        }], hintAlternativesForCabinetText: [{
            type: Input
        }], hintAlternativesForCabinetHeaderText: [{
            type: Input
        }], hintNoAlternativesForCabinet: [{
            type: Input
        }], conditionPrescribedForText: [{
            type: Input
        }], drugCostsRetailCostText: [{
            type: Input
        }], noPrescriptionInTierText: [{
            type: Input
        }], cabinet: [{
            type: Input
        }], plan: [{
            type: Input
        }], isMailOrder: [{
            type: Input
        }], drugSearchFrequencies: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], drugListCardBrandText: [{
            type: Input
        }], drugListCardGenericText: [{
            type: Input
        }], changeMedicalConditionsEnabled: [{
            type: Input
        }], footnoteIdsToShow: [{
            type: Input
        }], showGenericOption: [{
            type: Input
        }], isHelpfulToolsView: [{
            type: Input
        }], backToDefaultPrescriptionTab: [{
            type: Output
        }] }); })();

function FormularyDetailsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "span", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.formularyContractPlanSegmentLabelPrefix);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.getContractPlanSegment());
} }
class FormularyDetailsComponent {
    getContractPlanSegment() {
        return `${this.plan.contractId}-${this.plan.planId}-${this.plan.segmentId}`;
    }
}
FormularyDetailsComponent.ɵfac = function FormularyDetailsComponent_Factory(t) { return new (t || FormularyDetailsComponent)(); };
FormularyDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FormularyDetailsComponent, selectors: [["vnext-formulary-details"]], inputs: { plan: "plan", formularyID: "formularyID", formularyVersionText: "formularyVersionText", showContractPlanSegment: "showContractPlanSegment", formularyContractPlanSegmentLabelPrefix: "formularyContractPlanSegmentLabelPrefix" }, decls: 12, vars: 8, consts: [[1, "Spa_Style_Smaller_Font", "mt-5"], [4, "ngIf"], [1, "mr-1"], ["navigationAdapter", "", 3, "innerHTML"]], template: function FormularyDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, FormularyDetailsComponent_div_1_Template, 5, 2, "div", 1);
        i0.ɵɵelementStart(2, "div")(3, "span", 2);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "span");
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div")(8, "span", 2);
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(10, "span", 3);
        i0.ɵɵpipe(11, "safe");
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showContractPlanSegment);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.formularyID);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.plan.formularyExternalId);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.formularyVersionText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(11, 5, ctx.plan.formularyVersion, "html"), i0.ɵɵsanitizeHtml);
    } }, dependencies: [i1$2.NgIf, NavigationAdapterDirective, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormularyDetailsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-formulary-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"Spa_Style_Smaller_Font mt-5\">\r\n  <div *ngIf=\"showContractPlanSegment\">\r\n    <span class=\"mr-1\">{{ formularyContractPlanSegmentLabelPrefix }}</span>\r\n    <span>{{ getContractPlanSegment() }}</span>\r\n  </div>\r\n  <div>\r\n    <span class=\"mr-1\">{{ formularyID }}</span>\r\n    <span>{{ plan.formularyExternalId }}</span>\r\n  </div>\r\n  <div>\r\n    <span class=\"mr-1\">{{ formularyVersionText }}</span>\r\n    <span [innerHTML]=\"plan.formularyVersion | safe: 'html'\" navigationAdapter></span>\r\n  </div>\r\n</div>\r\n" }]
    }], null, { plan: [{
            type: Input
        }], formularyID: [{
            type: Input
        }], formularyVersionText: [{
            type: Input
        }], showContractPlanSegment: [{
            type: Input
        }], formularyContractPlanSegmentLabelPrefix: [{
            type: Input
        }] }); })();

function HelpfulToolsPrescriptionSearchTabComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", ctx_r3.informationalText ? i0.ɵɵpipeBind2(1, 1, ctx_r3.informationalText, "html") : "", i0.ɵɵsanitizeHtml);
} }
function HelpfulToolsPrescriptionSearchTabComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵtemplate(2, HelpfulToolsPrescriptionSearchTabComponent_div_1_div_2_Template, 2, 4, "div", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_HelpfulTools_Prescription_Info_Text");
} }
function HelpfulToolsPrescriptionSearchTabComponent_div_4_vnext_footnote_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-footnote", 14);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("footnoteIdsToShow", ctx_r4.footnoteIds)("footnoteHeader", ctx_r4.footnotesHeader)("footnotes", ctx_r4.footnotes);
} }
function HelpfulToolsPrescriptionSearchTabComponent_div_4_div_4_vnext_formulary_details_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-formulary-details", 16);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("plan", ctx_r6.plan)("showContractPlanSegment", ctx_r6.showContractPlanSegment)("formularyContractPlanSegmentLabelPrefix", ctx_r6.formularyContractPlanSegmentLabelPrefix)("formularyID", ctx_r6.formularyId)("formularyVersionText", ctx_r6.formularyVersionText);
} }
function HelpfulToolsPrescriptionSearchTabComponent_div_4_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 7);
    i0.ɵɵtemplate(2, HelpfulToolsPrescriptionSearchTabComponent_div_4_div_4_vnext_formulary_details_2_Template, 1, 5, "vnext-formulary-details", 15);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.plan && ctx_r5.plan.formularyExternalId);
} }
function HelpfulToolsPrescriptionSearchTabComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 11)(2, "div", 7);
    i0.ɵɵtemplate(3, HelpfulToolsPrescriptionSearchTabComponent_div_4_vnext_footnote_3_Template, 1, 3, "vnext-footnote", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, HelpfulToolsPrescriptionSearchTabComponent_div_4_div_4_Template, 3, 1, "div", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (ctx_r1.footnoteIds == null ? null : ctx_r1.footnoteIds.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showFormulary);
} }
function HelpfulToolsPrescriptionSearchTabComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 17)(2, "vnext-non-covered-drug-alternatives-sub-details", 18);
    i0.ɵɵlistener("backToDefaultPrescriptionTab", function HelpfulToolsPrescriptionSearchTabComponent_ng_container_5_Template_vnext_non_covered_drug_alternatives_sub_details_backToDefaultPrescriptionTab_2_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.onBackToDefaultPrescriptionTab()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "vnext-footnote", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("backToPrescriptionLabelText", ctx_r2.backToPrescriptionLabelText)("hintAlternativesForCabinetHeaderText", ctx_r2.hintAlternativesForCabinetHeaderText)("hintAlternativesForCabinetText", ctx_r2.hintAlternativesForCabinetText)("hintNoAlternativesForCabinet", ctx_r2.hintNoAlternativesForCabinet)("drugCostsRetailCostText", ctx_r2.drugCostsRetailCostText)("conditionPrescribedForText", ctx_r2.conditionPrescribedForText)("noPrescriptionInTierText", ctx_r2.noPrescriptionInTier)("plan", ctx_r2.planForDrugAlternatives)("cabinet", ctx_r2.cabinetForAlternatives)("drugSearchFrequencies", ctx_r2.drugSearchFrequencies)("isMailOrder", ctx_r2.isMailOrderSelected)("selectedPharmacy", ctx_r2.selectedPharmacy)("drugListCardBrandText", ctx_r2.drugListCardBrandText)("drugListCardGenericText", ctx_r2.drugListCardGenericText)("changeMedicalConditionsEnabled", ctx_r2.changeMedicalConditionsEnabled)("footnoteIdsToShow", ctx_r2.footnoteIds)("showGenericOption", ctx_r2.showGenericOption)("isHelpfulToolsView", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("footnoteIdsToShow", ctx_r2.footnoteIdsToShowForDrugAlternatives)("footnoteHeader", ctx_r2.footnotesHeader)("footnotes", ctx_r2.footnotes);
} }
const _c0$1P = function (a0) { return { "d-none": a0 }; };
class HelpfulToolsPrescriptionSearchTabComponent {
    constructor() {
        this.viewPossibleAlternativeDrugs = new EventEmitter();
        this.backToDefaultPrescriptionTab = new EventEmitter();
        this.prescriptionTabViewMode = PrescriptionTabViewMode;
    }
    onViewPossibleAlternativeDrugs(drugWithPlan) {
        this.viewPossibleAlternativeDrugs.emit(drugWithPlan);
    }
    onBackToDefaultPrescriptionTab() {
        this.backToDefaultPrescriptionTab.emit();
    }
}
HelpfulToolsPrescriptionSearchTabComponent.ɵfac = function HelpfulToolsPrescriptionSearchTabComponent_Factory(t) { return new (t || HelpfulToolsPrescriptionSearchTabComponent)(); };
HelpfulToolsPrescriptionSearchTabComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HelpfulToolsPrescriptionSearchTabComponent, selectors: [["vnext-helpful-tools-prescription-search-tab"]], inputs: { formularyContractPlanSegmentLabelPrefix: "formularyContractPlanSegmentLabelPrefix", informationalText: "informationalText", enablePrescriptionInfoSection: "enablePrescriptionInfoSection", showContractPlanSegment: "showContractPlanSegment", showFootnotes: "showFootnotes", showFormulary: "showFormulary", formularyVersionText: "formularyVersionText", formularyId: "formularyId", footnoteIds: "footnoteIds", footnotes: "footnotes", footnotesHeader: "footnotesHeader", plan: "plan", frequencyList: "frequencyList", contentSectionText: "contentSectionText", dosageHeader: "dosageHeader", quantityAndFrequencyHeader: "quantityAndFrequencyHeader", packageHeader: "packageHeader", addButtonText: "addButtonText", cancelButtonText: "cancelButtonText", quantityMaxLimit: "quantityMaxLimit", medicineCabinetLimit: "medicineCabinetLimit", cabinetLimitErrorMessage: "cabinetLimitErrorMessage", quantityErrorMessage: "quantityErrorMessage", placeholder: "placeholder", drugSearchText: "drugSearchText", drugsImage: "drugsImage", inCabinetErrorMessage: "inCabinetErrorMessage", medCabinetHeader: "medCabinetHeader", genericOptionIcon: "genericOptionIcon", showGenericOption: "showGenericOption", genericOptionQuestion: "genericOptionQuestion", genericOptionInfo: "genericOptionInfo", genericOptions: "genericOptions", checkDrugCoverageButtonText: "checkDrugCoverageButtonText", genericOptionDefaultSelection: "genericOptionDefaultSelection", showCosts: "showCosts", drugSearchIntroText: "drugSearchIntroText", drugSearchPageHeaderText: "drugSearchPageHeaderText", errorKeywordText: "errorKeywordText", drugSearchFrequencyListBoxLabel: "drugSearchFrequencyListBoxLabel", nonCoveredPrescriptions: "nonCoveredPrescriptions", coveredPrescriptions: "coveredPrescriptions", noPrescriptionInTier: "noPrescriptionInTier", editDrugText: "editDrugText", isUseCMSDrugFlagEnabled: "isUseCMSDrugFlagEnabled", showDrugAlternativesEnabled: "showDrugAlternativesEnabled", helpfulToolsShowDrugAlternativesNudgeEnabled: "helpfulToolsShowDrugAlternativesNudgeEnabled", prescriptionsDrugAlternativesButtonText: "prescriptionsDrugAlternativesButtonText", prescriptionTabView: "prescriptionTabView", cabinetForAlternatives: "cabinetForAlternatives", planForDrugAlternatives: "planForDrugAlternatives", selectedPlanPharmacy: "selectedPlanPharmacy", backToPrescriptionLabelText: "backToPrescriptionLabelText", hintAlternativesForCabinetHeaderText: "hintAlternativesForCabinetHeaderText", hintAlternativesForCabinetText: "hintAlternativesForCabinetText", hintNoAlternativesForCabinet: "hintNoAlternativesForCabinet", drugCostsRetailCostText: "drugCostsRetailCostText", conditionPrescribedForText: "conditionPrescribedForText", drugSearchFrequencies: "drugSearchFrequencies", isMailOrderSelected: "isMailOrderSelected", selectedPharmacy: "selectedPharmacy", drugListCardBrandText: "drugListCardBrandText", drugListCardGenericText: "drugListCardGenericText", changeMedicalConditionsEnabled: "changeMedicalConditionsEnabled", footnoteIdsToShowForDrugAlternatives: "footnoteIdsToShowForDrugAlternatives", isMobile: "isMobile" }, outputs: { viewPossibleAlternativeDrugs: "viewPossibleAlternativeDrugs", backToDefaultPrescriptionTab: "backToDefaultPrescriptionTab" }, decls: 6, vars: 47, consts: [[3, "ngClass"], ["class", "row mt-4 mb-3", 4, "ngIf"], [1, "search-wrapper"], [3, "helpfulTools", "helpfulToolsPlan", "frequencyList", "contentSectionText", "dosageHeader", "quantityAndFrequencyHeader", "packageHeader", "addButtonText", "cancelButtonText", "quantityMaxLimit", "medicineCabinetLimit", "cabinetLimitErrorMessage", "quantityErrorMessage", "placeholder", "drugSearchText", "drugsImage", "inCabinetErrorMessage", "medCabinetHeader", "genericOptionIcon", "showGenericOption", "genericOptionQuestion", "genericOptionInfo", "genericOptions", "checkDrugCoverageButtonText", "genericOptionDefaultSelection", "showCosts", "drugSearchIntroText", "drugSearchPageHeaderText", "errorKeywordText", "drugSearchFrequencyListBoxLabel", "nonCoveredPrescriptions", "coveredPrescriptions", "noPrescriptionInTier", "editDrugText", "isUseCMSDrugFlagEnabled", "showDrugAlternativesEnabled", "helpfulToolsShowDrugAlternativesNudgeEnabled", "cabinetForAlternatives", "selectedPlanPharmacy", "prescriptionsDrugAlternativesButtonText", "isMobile", "viewPossibleAlternativeDrugs"], ["class", "container", 4, "ngIf"], [4, "ngIf"], [1, "row", "mt-4", "mb-3"], [1, "col-12"], ["class", "Spa_Style_Regular text-center ml-2 mr-2 mb-0", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["navigationAdapter", "", 1, "Spa_Style_Regular", "text-center", "ml-2", "mr-2", "mb-0", 3, "innerHtml"], [1, "container"], [1, "row"], [3, "footnoteIdsToShow", "footnoteHeader", "footnotes", 4, "ngIf"], ["class", "row", 4, "ngIf"], [3, "footnoteIdsToShow", "footnoteHeader", "footnotes"], [3, "plan", "showContractPlanSegment", "formularyContractPlanSegmentLabelPrefix", "formularyID", "formularyVersionText", 4, "ngIf"], [3, "plan", "showContractPlanSegment", "formularyContractPlanSegmentLabelPrefix", "formularyID", "formularyVersionText"], [1, "pt-3"], [3, "backToPrescriptionLabelText", "hintAlternativesForCabinetHeaderText", "hintAlternativesForCabinetText", "hintNoAlternativesForCabinet", "drugCostsRetailCostText", "conditionPrescribedForText", "noPrescriptionInTierText", "plan", "cabinet", "drugSearchFrequencies", "isMailOrder", "selectedPharmacy", "drugListCardBrandText", "drugListCardGenericText", "changeMedicalConditionsEnabled", "footnoteIdsToShow", "showGenericOption", "isHelpfulToolsView", "backToDefaultPrescriptionTab"]], template: function HelpfulToolsPrescriptionSearchTabComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, HelpfulToolsPrescriptionSearchTabComponent_div_1_Template, 3, 1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2)(3, "vnext-widget-drug-search", 3);
        i0.ɵɵlistener("viewPossibleAlternativeDrugs", function HelpfulToolsPrescriptionSearchTabComponent_Template_vnext_widget_drug_search_viewPossibleAlternativeDrugs_3_listener($event) { return ctx.onViewPossibleAlternativeDrugs($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(4, HelpfulToolsPrescriptionSearchTabComponent_div_4_Template, 5, 2, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, HelpfulToolsPrescriptionSearchTabComponent_ng_container_5_Template, 4, 21, "ng-container", 5);
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(45, _c0$1P, ctx.prescriptionTabView !== ctx.prescriptionTabViewMode.DEFAULT));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.enablePrescriptionInfoSection);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("helpfulTools", true)("helpfulToolsPlan", ctx.plan)("frequencyList", ctx.frequencyList)("contentSectionText", ctx.contentSectionText)("dosageHeader", ctx.dosageHeader)("quantityAndFrequencyHeader", ctx.quantityAndFrequencyHeader)("packageHeader", ctx.packageHeader)("addButtonText", ctx.addButtonText)("cancelButtonText", ctx.cancelButtonText)("quantityMaxLimit", ctx.quantityMaxLimit)("medicineCabinetLimit", ctx.medicineCabinetLimit)("cabinetLimitErrorMessage", ctx.cabinetLimitErrorMessage)("quantityErrorMessage", ctx.quantityErrorMessage)("placeholder", ctx.placeholder)("drugSearchText", ctx.drugSearchText)("drugsImage", ctx.drugsImage)("inCabinetErrorMessage", ctx.inCabinetErrorMessage)("medCabinetHeader", ctx.medCabinetHeader)("genericOptionIcon", ctx.genericOptionIcon)("showGenericOption", ctx.showGenericOption)("genericOptionQuestion", ctx.genericOptionQuestion)("genericOptionInfo", ctx.genericOptionInfo)("genericOptions", ctx.genericOptions)("checkDrugCoverageButtonText", ctx.checkDrugCoverageButtonText)("genericOptionDefaultSelection", ctx.genericOptionDefaultSelection)("showCosts", ctx.showCosts)("drugSearchIntroText", ctx.drugSearchIntroText)("drugSearchPageHeaderText", ctx.drugSearchPageHeaderText)("errorKeywordText", ctx.errorKeywordText)("drugSearchFrequencyListBoxLabel", ctx.drugSearchFrequencyListBoxLabel)("nonCoveredPrescriptions", ctx.nonCoveredPrescriptions)("coveredPrescriptions", ctx.coveredPrescriptions)("noPrescriptionInTier", ctx.noPrescriptionInTier)("editDrugText", ctx.editDrugText)("isUseCMSDrugFlagEnabled", ctx.isUseCMSDrugFlagEnabled)("showDrugAlternativesEnabled", ctx.showDrugAlternativesEnabled)("helpfulToolsShowDrugAlternativesNudgeEnabled", ctx.helpfulToolsShowDrugAlternativesNudgeEnabled)("cabinetForAlternatives", ctx.cabinetForAlternatives)("selectedPlanPharmacy", ctx.selectedPlanPharmacy)("prescriptionsDrugAlternativesButtonText", ctx.prescriptionsDrugAlternativesButtonText)("isMobile", ctx.isMobile);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showFootnotes);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showDrugAlternativesEnabled && ctx.helpfulToolsShowDrugAlternativesNudgeEnabled && ctx.prescriptionTabView === ctx.prescriptionTabViewMode.ALTERNATIVES_OFF_FORMULARY_DRUGS && ctx.cabinetForAlternatives);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, FootnoteComponent, NavigationAdapterDirective, LiveEditPropDirective, DrugSearchComponent, NonCoveredDrugAlternativesSubDetailsComponent, FormularyDetailsComponent, SafePipe], styles: [".search-wrapper[_ngcontent-%COMP%]{margin-top:30px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpfulToolsPrescriptionSearchTabComponent, [{
        type: Component,
        args: [{ selector: 'vnext-helpful-tools-prescription-search-tab', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div [ngClass]=\"{ 'd-none': prescriptionTabView !== prescriptionTabViewMode.DEFAULT }\">\r\n  <div class=\"row mt-4 mb-3\" *ngIf=\"enablePrescriptionInfoSection\">\r\n    <div class=\"col-12\">\r\n      <div\r\n        *liveEditProp=\"'Spa_HelpfulTools_Prescription_Info_Text'\"\r\n        class=\"Spa_Style_Regular text-center ml-2 mr-2 mb-0\"\r\n        [innerHtml]=\"informationalText ? (informationalText | safe: 'html') : ''\"\r\n        navigationAdapter\r\n      ></div>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"search-wrapper\">\r\n    <vnext-widget-drug-search\r\n      [helpfulTools]=\"true\"\r\n      [helpfulToolsPlan]=\"plan\"\r\n      [frequencyList]=\"frequencyList\"\r\n      [contentSectionText]=\"contentSectionText\"\r\n      [dosageHeader]=\"dosageHeader\"\r\n      [quantityAndFrequencyHeader]=\"quantityAndFrequencyHeader\"\r\n      [packageHeader]=\"packageHeader\"\r\n      [addButtonText]=\"addButtonText\"\r\n      [cancelButtonText]=\"cancelButtonText\"\r\n      [quantityMaxLimit]=\"quantityMaxLimit\"\r\n      [medicineCabinetLimit]=\"medicineCabinetLimit\"\r\n      [cabinetLimitErrorMessage]=\"cabinetLimitErrorMessage\"\r\n      [quantityErrorMessage]=\"quantityErrorMessage\"\r\n      [placeholder]=\"placeholder\"\r\n      [drugSearchText]=\"drugSearchText\"\r\n      [drugsImage]=\"drugsImage\"\r\n      [inCabinetErrorMessage]=\"inCabinetErrorMessage\"\r\n      [medCabinetHeader]=\"medCabinetHeader\"\r\n      [genericOptionIcon]=\"genericOptionIcon\"\r\n      [showGenericOption]=\"showGenericOption\"\r\n      [genericOptionQuestion]=\"genericOptionQuestion\"\r\n      [genericOptionInfo]=\"genericOptionInfo\"\r\n      [genericOptions]=\"genericOptions\"\r\n      [checkDrugCoverageButtonText]=\"checkDrugCoverageButtonText\"\r\n      [genericOptionDefaultSelection]=\"genericOptionDefaultSelection\"\r\n      [showCosts]=\"showCosts\"\r\n      [drugSearchIntroText]=\"drugSearchIntroText\"\r\n      [drugSearchPageHeaderText]=\"drugSearchPageHeaderText\"\r\n      [errorKeywordText]=\"errorKeywordText\"\r\n      [drugSearchFrequencyListBoxLabel]=\"drugSearchFrequencyListBoxLabel\"\r\n      [nonCoveredPrescriptions]=\"nonCoveredPrescriptions\"\r\n      [coveredPrescriptions]=\"coveredPrescriptions\"\r\n      [noPrescriptionInTier]=\"noPrescriptionInTier\"\r\n      [editDrugText]=\"editDrugText\"\r\n      [isUseCMSDrugFlagEnabled]=\"isUseCMSDrugFlagEnabled\"\r\n      [showDrugAlternativesEnabled]=\"showDrugAlternativesEnabled\"\r\n      [helpfulToolsShowDrugAlternativesNudgeEnabled]=\"helpfulToolsShowDrugAlternativesNudgeEnabled\"\r\n      [cabinetForAlternatives]=\"cabinetForAlternatives\"\r\n      [selectedPlanPharmacy]=\"selectedPlanPharmacy\"\r\n      [prescriptionsDrugAlternativesButtonText]=\"prescriptionsDrugAlternativesButtonText\"\r\n      [isMobile]=\"isMobile\"\r\n      (viewPossibleAlternativeDrugs)=\"onViewPossibleAlternativeDrugs($event)\"\r\n    >\r\n    </vnext-widget-drug-search>\r\n  </div>\r\n\r\n  <div class=\"container\" *ngIf=\"showFootnotes\">\r\n    <div class=\"row\">\r\n      <div class=\"col-12\">\r\n        <vnext-footnote\r\n          *ngIf=\"footnoteIds?.length > 0\"\r\n          [footnoteIdsToShow]=\"footnoteIds\"\r\n          [footnoteHeader]=\"footnotesHeader\"\r\n          [footnotes]=\"footnotes\"\r\n        >\r\n        </vnext-footnote>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\" *ngIf=\"showFormulary\">\r\n      <div class=\"col-12\">\r\n        <vnext-formulary-details\r\n          *ngIf=\"plan && plan.formularyExternalId\"\r\n          [plan]=\"plan\"\r\n          [showContractPlanSegment]=\"showContractPlanSegment\"\r\n          [formularyContractPlanSegmentLabelPrefix]=\"formularyContractPlanSegmentLabelPrefix\"\r\n          [formularyID]=\"formularyId\"\r\n          [formularyVersionText]=\"formularyVersionText\"\r\n        >\r\n        </vnext-formulary-details>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<ng-container\r\n  *ngIf=\"\r\n    showDrugAlternativesEnabled &&\r\n    helpfulToolsShowDrugAlternativesNudgeEnabled &&\r\n    prescriptionTabView === prescriptionTabViewMode.ALTERNATIVES_OFF_FORMULARY_DRUGS &&\r\n    cabinetForAlternatives\r\n  \"\r\n>\r\n  <div class=\"pt-3\">\r\n    <vnext-non-covered-drug-alternatives-sub-details\r\n      [backToPrescriptionLabelText]=\"backToPrescriptionLabelText\"\r\n      [hintAlternativesForCabinetHeaderText]=\"hintAlternativesForCabinetHeaderText\"\r\n      [hintAlternativesForCabinetText]=\"hintAlternativesForCabinetText\"\r\n      [hintNoAlternativesForCabinet]=\"hintNoAlternativesForCabinet\"\r\n      [drugCostsRetailCostText]=\"drugCostsRetailCostText\"\r\n      [conditionPrescribedForText]=\"conditionPrescribedForText\"\r\n      [noPrescriptionInTierText]=\"noPrescriptionInTier\"\r\n      [plan]=\"planForDrugAlternatives\"\r\n      [cabinet]=\"cabinetForAlternatives\"\r\n      [drugSearchFrequencies]=\"drugSearchFrequencies\"\r\n      [isMailOrder]=\"isMailOrderSelected\"\r\n      [selectedPharmacy]=\"selectedPharmacy\"\r\n      [drugListCardBrandText]=\"drugListCardBrandText\"\r\n      [drugListCardGenericText]=\"drugListCardGenericText\"\r\n      [changeMedicalConditionsEnabled]=\"changeMedicalConditionsEnabled\"\r\n      [footnoteIdsToShow]=\"footnoteIds\"\r\n      [showGenericOption]=\"showGenericOption\"\r\n      [isHelpfulToolsView]=\"true\"\r\n      (backToDefaultPrescriptionTab)=\"onBackToDefaultPrescriptionTab()\"\r\n    >\r\n    </vnext-non-covered-drug-alternatives-sub-details>\r\n\r\n    <vnext-footnote [footnoteIdsToShow]=\"footnoteIdsToShowForDrugAlternatives\" [footnoteHeader]=\"footnotesHeader\" [footnotes]=\"footnotes\">\r\n    </vnext-footnote>\r\n  </div>\r\n</ng-container>\r\n", styles: [".search-wrapper{margin-top:30px}\n"] }]
    }], null, { formularyContractPlanSegmentLabelPrefix: [{
            type: Input
        }], informationalText: [{
            type: Input
        }], enablePrescriptionInfoSection: [{
            type: Input
        }], showContractPlanSegment: [{
            type: Input
        }], showFootnotes: [{
            type: Input
        }], showFormulary: [{
            type: Input
        }], formularyVersionText: [{
            type: Input
        }], formularyId: [{
            type: Input
        }], footnoteIds: [{
            type: Input
        }], footnotes: [{
            type: Input
        }], footnotesHeader: [{
            type: Input
        }], plan: [{
            type: Input
        }], frequencyList: [{
            type: Input
        }], contentSectionText: [{
            type: Input
        }], dosageHeader: [{
            type: Input
        }], quantityAndFrequencyHeader: [{
            type: Input
        }], packageHeader: [{
            type: Input
        }], addButtonText: [{
            type: Input
        }], cancelButtonText: [{
            type: Input
        }], quantityMaxLimit: [{
            type: Input
        }], medicineCabinetLimit: [{
            type: Input
        }], cabinetLimitErrorMessage: [{
            type: Input
        }], quantityErrorMessage: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], drugSearchText: [{
            type: Input
        }], drugsImage: [{
            type: Input
        }], inCabinetErrorMessage: [{
            type: Input
        }], medCabinetHeader: [{
            type: Input
        }], genericOptionIcon: [{
            type: Input
        }], showGenericOption: [{
            type: Input
        }], genericOptionQuestion: [{
            type: Input
        }], genericOptionInfo: [{
            type: Input
        }], genericOptions: [{
            type: Input
        }], checkDrugCoverageButtonText: [{
            type: Input
        }], genericOptionDefaultSelection: [{
            type: Input
        }], showCosts: [{
            type: Input
        }], drugSearchIntroText: [{
            type: Input
        }], drugSearchPageHeaderText: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], drugSearchFrequencyListBoxLabel: [{
            type: Input
        }], nonCoveredPrescriptions: [{
            type: Input
        }], coveredPrescriptions: [{
            type: Input
        }], noPrescriptionInTier: [{
            type: Input
        }], editDrugText: [{
            type: Input
        }], isUseCMSDrugFlagEnabled: [{
            type: Input
        }], showDrugAlternativesEnabled: [{
            type: Input
        }], helpfulToolsShowDrugAlternativesNudgeEnabled: [{
            type: Input
        }], prescriptionsDrugAlternativesButtonText: [{
            type: Input
        }], prescriptionTabView: [{
            type: Input
        }], cabinetForAlternatives: [{
            type: Input
        }], planForDrugAlternatives: [{
            type: Input
        }], selectedPlanPharmacy: [{
            type: Input
        }], backToPrescriptionLabelText: [{
            type: Input
        }], hintAlternativesForCabinetHeaderText: [{
            type: Input
        }], hintAlternativesForCabinetText: [{
            type: Input
        }], hintNoAlternativesForCabinet: [{
            type: Input
        }], drugCostsRetailCostText: [{
            type: Input
        }], conditionPrescribedForText: [{
            type: Input
        }], drugSearchFrequencies: [{
            type: Input
        }], isMailOrderSelected: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], drugListCardBrandText: [{
            type: Input
        }], drugListCardGenericText: [{
            type: Input
        }], changeMedicalConditionsEnabled: [{
            type: Input
        }], footnoteIdsToShowForDrugAlternatives: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], viewPossibleAlternativeDrugs: [{
            type: Output
        }], backToDefaultPrescriptionTab: [{
            type: Output
        }] }); })();

function HelpfulToolsProviderSearchTabComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 5);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r1.providerInformationalText, "html"), i0.ɵɵsanitizeHtml);
} }
function HelpfulToolsProviderSearchTabComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtemplate(2, HelpfulToolsProviderSearchTabComponent_div_0_div_2_Template, 2, 4, "div", 4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_HelpfulTools_Provider_Info_Text");
} }
class HelpfulToolsProviderSearchTabComponent {
    constructor() {
        this.generalPracticeOptions = [];
        this.valueBasedCareToggleOptions = [];
        this.newPatientToggleOptions = [];
        this.pcpToggleOptions = [];
        this.fetchProvidersFromLocation = new EventEmitter();
        this.initializeMap = new EventEmitter();
        this.setMapCenter = new EventEmitter();
        this.setMapDefaultBounds = new EventEmitter();
        this.fetchProvidersFromAPI = new EventEmitter();
    }
    ngOnChanges(changes) {
        const { informationalText, plan } = changes;
        if (informationalText.previousValue !== informationalText.currentValue || !_isEqual(plan.previousValue, plan.currentValue)) {
            this.providerInformationalText = this.processProviderUrl(this.informationalText, this.plan);
        }
    }
    processProviderUrl(informationalText, plan) {
        const providerUrl = plan?.providerURL;
        return informationalText.replace('<providerDirectoryUrl>', providerUrl ? `<a href="${providerUrl}" target="_blank" class="Spa_Style_Link">${providerUrl}</a>` : '');
    }
}
HelpfulToolsProviderSearchTabComponent.ɵfac = function HelpfulToolsProviderSearchTabComponent_Factory(t) { return new (t || HelpfulToolsProviderSearchTabComponent)(); };
HelpfulToolsProviderSearchTabComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HelpfulToolsProviderSearchTabComponent, selectors: [["vnext-helpful-tools-provider-search-tab"]], inputs: { plan: "plan", informationalText: "informationalText", enableProviderInfoSection: "enableProviderInfoSection", isHelpfulToolsView: "isHelpfulToolsView", providerLimit: "providerLimit", providerMapDefaultZoom: "providerMapDefaultZoom", maxZoom: "maxZoom", minZoom: "minZoom", providersText: "providersText", providersBodyText: "providersBodyText", retrieveZipCode: "retrieveZipCode", retrieveFipsCode: "retrieveFipsCode", errorKeywordText: "errorKeywordText", zipLabel: "zipLabel", zipErrorText: "zipErrorText", providerNameText: "providerNameText", providerNameHintText: "providerNameHintText", providerSearchButtonText: "providerSearchButtonText", itemsPerPage: "itemsPerPage", providerPaginationEnabled: "providerPaginationEnabled", viewNotFoundHeaderText: "viewNotFoundHeaderText", viewNotFoundBodyText: "viewNotFoundBodyText", paginationText: "paginationText", providerFiltersEnabled: "providerFiltersEnabled", providerFilters: "providerFilters", countyLabel: "countyLabel", showCountyLabel: "showCountyLabel", acceptingNewPatientsText: "acceptingNewPatientsText", acceptingNewPatientsIcon: "acceptingNewPatientsIcon", languagesIcon: "languagesIcon", countryCode: "countryCode", providerLocationsText: "providerLocationsText", providerSingleSelectEnabled: "providerSingleSelectEnabled", valueBasedCareEnabled: "valueBasedCareEnabled", valueBasedCareIcon: "valueBasedCareIcon", valueBasedCareText: "valueBasedCareText", generalPracticeOptions: "generalPracticeOptions", generalPracticeToolTipText: "generalPracticeToolTipText", generalPracticeLabel: "generalPracticeLabel", generalPracticeFilterOptionEnabled: "generalPracticeFilterOptionEnabled", singleProviderInListEnabled: "singleProviderInListEnabled", updateLinkText: "updateLinkText", editLinkText: "editLinkText", showEditLinkEnabled: "showEditLinkEnabled", isValueBasedCareLearnMoreLink2Enabled: "isValueBasedCareLearnMoreLink2Enabled", valueBasedCareAvailableText: "valueBasedCareAvailableText", valueBasedCareLearnMoreLink: "valueBasedCareLearnMoreLink", valueBasedCareLearnMoreText: "valueBasedCareLearnMoreText", valueBasedCareToggleLabel: "valueBasedCareToggleLabel", valueBasedCareToggleEnabled: "valueBasedCareToggleEnabled", valueBasedCareToggleToolTipText: "valueBasedCareToggleToolTipText", valueBasedCareToggleOptions: "valueBasedCareToggleOptions", newPatientToggleEnabled: "newPatientToggleEnabled", newPatientToggleLabel: "newPatientToggleLabel", newPatientToggleOptions: "newPatientToggleOptions", pcpToggleLabel: "pcpToggleLabel", pcpToggleOptions: "pcpToggleOptions", newPatientText: "newPatientText", existingPatientText: "existingPatientText", vbcNameFilterEnabled: "vbcNameFilterEnabled", vbcNameFilterLabel: "vbcNameFilterLabel", pcpToggleEnabled: "pcpToggleEnabled", selectedProviderOptionsEnabled: "selectedProviderOptionsEnabled", removeText: "removeText", selectAllText: "selectAllText", isZelisIntegrationEnabled: "isZelisIntegrationEnabled" }, outputs: { fetchProvidersFromLocation: "fetchProvidersFromLocation", initializeMap: "initializeMap", setMapCenter: "setMapCenter", setMapDefaultBounds: "setMapDefaultBounds", fetchProvidersFromAPI: "fetchProvidersFromAPI" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 64, consts: [["class", "row mt-4 mb-3", 4, "ngIf"], [3, "retrieveFipsCode", "retrieveZipCode", "isHelpfulToolsView", "providersText", "providersBodyText", "errorKeywordText", "zipLabel", "zipErrorText", "providerNameText", "providerNameHintText", "providerSearchButtonText", "providerLimit", "itemsPerPage", "providerPaginationEnabled", "viewNotFoundHeaderText", "viewNotFoundBodyText", "paginationText", "maxZoom", "minZoom", "providerMapDefaultZoom", "providerFiltersEnabled", "providerFilters", "countyLabel", "showCountyLabel", "countryCode", "acceptingNewPatientsIcon", "acceptingNewPatientsText", "languagesIcon", "providerLocationsText", "providerSingleSelectEnabled", "valueBasedCareEnabled", "valueBasedCareIcon", "valueBasedCareText", "generalPracticeOptions", "generalPracticeToolTipText", "generalPracticeLabel", "generalPracticeFilterOptionEnabled", "singleProviderInListEnabled", "updateLinkText", "editLinkText", "showEditLinkEnabled", "valueBasedCareAvailableText", "valueBasedCareLearnMoreLink", "valueBasedCareLearnMoreText", "isValueBasedCareLearnMoreLink2Enabled", "valueBasedCareToggleEnabled", "valueBasedCareToggleLabel", "valueBasedCareToggleToolTipText", "valueBasedCareToggleOptions", "newPatientToggleEnabled", "newPatientToggleLabel", "newPatientToggleOptions", "pcpToggleLabel", "pcpToggleOptions", "newPatientText", "existingPatientText", "vbcNameFilterEnabled", "vbcNameFilterLabel", "pcpToggleEnabled", "selectedProviderOptionsEnabled", "removeText", "selectAllText", "isZelisIntegrationEnabled", "fetchProvidersFromLocation", "setMapCenter", "initializeMap", "setMapDefaultBounds", "fetchProvidersFromAPI"], [1, "row", "mt-4", "mb-3"], [1, "col-12"], ["class", "Spa_Style_Regular text-center ml-2 mr-2 mb-0", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["navigationAdapter", "", 1, "Spa_Style_Regular", "text-center", "ml-2", "mr-2", "mb-0", 3, "innerHtml"]], template: function HelpfulToolsProviderSearchTabComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, HelpfulToolsProviderSearchTabComponent_div_0_Template, 3, 1, "div", 0);
        i0.ɵɵelementStart(1, "vnext-widget-provider-search", 1);
        i0.ɵɵlistener("fetchProvidersFromLocation", function HelpfulToolsProviderSearchTabComponent_Template_vnext_widget_provider_search_fetchProvidersFromLocation_1_listener($event) { return ctx.fetchProvidersFromLocation.emit($event); })("setMapCenter", function HelpfulToolsProviderSearchTabComponent_Template_vnext_widget_provider_search_setMapCenter_1_listener($event) { return ctx.setMapCenter.emit($event); })("initializeMap", function HelpfulToolsProviderSearchTabComponent_Template_vnext_widget_provider_search_initializeMap_1_listener($event) { return ctx.initializeMap.emit($event); })("setMapDefaultBounds", function HelpfulToolsProviderSearchTabComponent_Template_vnext_widget_provider_search_setMapDefaultBounds_1_listener($event) { return ctx.setMapDefaultBounds.emit($event); })("fetchProvidersFromAPI", function HelpfulToolsProviderSearchTabComponent_Template_vnext_widget_provider_search_fetchProvidersFromAPI_1_listener($event) { return ctx.fetchProvidersFromAPI.emit($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.enableProviderInfoSection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("retrieveFipsCode", ctx.retrieveFipsCode)("retrieveZipCode", ctx.retrieveZipCode)("isHelpfulToolsView", true)("providersText", ctx.providersText)("providersBodyText", ctx.providersBodyText)("errorKeywordText", ctx.errorKeywordText)("zipLabel", ctx.zipLabel)("zipErrorText", ctx.zipErrorText)("providerNameText", ctx.providerNameText)("providerNameHintText", ctx.providerNameHintText)("providerSearchButtonText", ctx.providerSearchButtonText)("providerLimit", ctx.providerLimit)("itemsPerPage", ctx.itemsPerPage)("providerPaginationEnabled", ctx.providerPaginationEnabled)("viewNotFoundHeaderText", ctx.viewNotFoundHeaderText)("viewNotFoundBodyText", ctx.viewNotFoundBodyText)("paginationText", ctx.paginationText)("maxZoom", ctx.maxZoom)("minZoom", ctx.minZoom)("providerMapDefaultZoom", ctx.providerMapDefaultZoom)("providerFiltersEnabled", ctx.providerFiltersEnabled)("providerFilters", ctx.providerFilters)("countyLabel", ctx.countyLabel)("showCountyLabel", ctx.showCountyLabel)("countryCode", ctx.countryCode)("acceptingNewPatientsIcon", ctx.acceptingNewPatientsIcon)("acceptingNewPatientsText", ctx.acceptingNewPatientsText)("languagesIcon", ctx.languagesIcon)("providerLocationsText", ctx.providerLocationsText)("providerSingleSelectEnabled", ctx.providerSingleSelectEnabled)("valueBasedCareEnabled", ctx.valueBasedCareEnabled)("valueBasedCareIcon", ctx.valueBasedCareIcon)("valueBasedCareText", ctx.valueBasedCareText)("generalPracticeOptions", ctx.generalPracticeOptions)("generalPracticeToolTipText", ctx.generalPracticeToolTipText)("generalPracticeLabel", ctx.generalPracticeLabel)("generalPracticeFilterOptionEnabled", ctx.generalPracticeFilterOptionEnabled)("singleProviderInListEnabled", ctx.singleProviderInListEnabled)("updateLinkText", ctx.updateLinkText)("editLinkText", ctx.editLinkText)("showEditLinkEnabled", ctx.showEditLinkEnabled)("valueBasedCareAvailableText", ctx.valueBasedCareAvailableText)("valueBasedCareLearnMoreLink", ctx.valueBasedCareLearnMoreLink)("valueBasedCareLearnMoreText", ctx.valueBasedCareLearnMoreText)("isValueBasedCareLearnMoreLink2Enabled", ctx.isValueBasedCareLearnMoreLink2Enabled)("valueBasedCareToggleEnabled", ctx.valueBasedCareToggleEnabled)("valueBasedCareToggleLabel", ctx.valueBasedCareToggleLabel)("valueBasedCareToggleToolTipText", ctx.valueBasedCareToggleToolTipText)("valueBasedCareToggleOptions", ctx.valueBasedCareToggleOptions)("newPatientToggleEnabled", ctx.newPatientToggleEnabled)("newPatientToggleLabel", ctx.newPatientToggleLabel)("newPatientToggleOptions", ctx.newPatientToggleOptions)("pcpToggleLabel", ctx.pcpToggleLabel)("pcpToggleOptions", ctx.pcpToggleOptions)("newPatientText", ctx.newPatientText)("existingPatientText", ctx.existingPatientText)("vbcNameFilterEnabled", ctx.vbcNameFilterEnabled)("vbcNameFilterLabel", ctx.vbcNameFilterLabel)("pcpToggleEnabled", ctx.pcpToggleEnabled)("selectedProviderOptionsEnabled", ctx.selectedProviderOptionsEnabled)("removeText", ctx.removeText)("selectAllText", ctx.selectAllText)("isZelisIntegrationEnabled", ctx.isZelisIntegrationEnabled);
    } }, dependencies: [i1$2.NgIf, NavigationAdapterDirective, LiveEditPropDirective, ProviderSearchComponent, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpfulToolsProviderSearchTabComponent, [{
        type: Component,
        args: [{ selector: 'vnext-helpful-tools-provider-search-tab', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row mt-4 mb-3\" *ngIf=\"enableProviderInfoSection\">\r\n  <div class=\"col-12\">\r\n    <div\r\n      *liveEditProp=\"'Spa_HelpfulTools_Provider_Info_Text'\"\r\n      class=\"Spa_Style_Regular text-center ml-2 mr-2 mb-0\"\r\n      [innerHtml]=\"providerInformationalText | safe : 'html'\"\r\n      navigationAdapter\r\n    ></div>\r\n  </div>\r\n</div>\r\n<vnext-widget-provider-search\r\n  [retrieveFipsCode]=\"retrieveFipsCode\"\r\n  [retrieveZipCode]=\"retrieveZipCode\"\r\n  [isHelpfulToolsView]=\"true\"\r\n  [providersText]=\"providersText\"\r\n  [providersBodyText]=\"providersBodyText\"\r\n  [errorKeywordText]=\"errorKeywordText\"\r\n  [zipLabel]=\"zipLabel\"\r\n  [zipErrorText]=\"zipErrorText\"\r\n  [providerNameText]=\"providerNameText\"\r\n  [providerNameHintText]=\"providerNameHintText\"\r\n  [providerSearchButtonText]=\"providerSearchButtonText\"\r\n  [providerLimit]=\"providerLimit\"\r\n  [itemsPerPage]=\"itemsPerPage\"\r\n  [providerPaginationEnabled]=\"providerPaginationEnabled\"\r\n  [viewNotFoundHeaderText]=\"viewNotFoundHeaderText\"\r\n  [viewNotFoundBodyText]=\"viewNotFoundBodyText\"\r\n  [paginationText]=\"paginationText\"\r\n  [maxZoom]=\"maxZoom\"\r\n  [minZoom]=\"minZoom\"\r\n  [providerMapDefaultZoom]=\"providerMapDefaultZoom\"\r\n  (fetchProvidersFromLocation)=\"fetchProvidersFromLocation.emit($event)\"\r\n  (setMapCenter)=\"setMapCenter.emit($event)\"\r\n  (initializeMap)=\"initializeMap.emit($event)\"\r\n  (setMapDefaultBounds)=\"setMapDefaultBounds.emit($event)\"\r\n  (fetchProvidersFromAPI)=\"fetchProvidersFromAPI.emit($event)\"\r\n  [providerFiltersEnabled]=\"providerFiltersEnabled\"\r\n  [providerFilters]=\"providerFilters\"\r\n  [countyLabel]=\"countyLabel\"\r\n  [showCountyLabel]=\"showCountyLabel\"\r\n  [countryCode]=\"countryCode\"\r\n  [acceptingNewPatientsIcon]=\"acceptingNewPatientsIcon\"\r\n  [acceptingNewPatientsText]=\"acceptingNewPatientsText\"\r\n  [languagesIcon]=\"languagesIcon\"\r\n  [providerLocationsText]=\"providerLocationsText\"\r\n  [providerSingleSelectEnabled]=\"providerSingleSelectEnabled\"\r\n  [valueBasedCareEnabled]=\"valueBasedCareEnabled\"\r\n  [valueBasedCareIcon]=\"valueBasedCareIcon\"\r\n  [valueBasedCareText]=\"valueBasedCareText\"\r\n  [generalPracticeOptions]=\"generalPracticeOptions\"\r\n  [generalPracticeToolTipText]=\"generalPracticeToolTipText\"\r\n  [generalPracticeLabel]=\"generalPracticeLabel\"\r\n  [generalPracticeFilterOptionEnabled]=\"generalPracticeFilterOptionEnabled\"\r\n  [singleProviderInListEnabled]=\"singleProviderInListEnabled\"\r\n  [updateLinkText]=\"updateLinkText\"\r\n  [editLinkText]=\"editLinkText\"\r\n  [showEditLinkEnabled]=\"showEditLinkEnabled\"\r\n  [valueBasedCareAvailableText]=\"valueBasedCareAvailableText\"\r\n  [valueBasedCareLearnMoreLink]=\"valueBasedCareLearnMoreLink\"\r\n  [valueBasedCareLearnMoreText]=\"valueBasedCareLearnMoreText\"\r\n  [isValueBasedCareLearnMoreLink2Enabled]=\"isValueBasedCareLearnMoreLink2Enabled\"\r\n  [valueBasedCareToggleEnabled]=\"valueBasedCareToggleEnabled\"\r\n  [valueBasedCareToggleLabel]=\"valueBasedCareToggleLabel\"\r\n  [valueBasedCareToggleToolTipText]=\"valueBasedCareToggleToolTipText\"\r\n  [valueBasedCareToggleOptions]=\"valueBasedCareToggleOptions\"\r\n  [newPatientToggleEnabled]=\"newPatientToggleEnabled\"\r\n  [newPatientToggleLabel]=\"newPatientToggleLabel\"\r\n  [newPatientToggleOptions]=\"newPatientToggleOptions\"\r\n  [pcpToggleLabel]=\"pcpToggleLabel\"\r\n  [pcpToggleOptions]=\"pcpToggleOptions\"\r\n  [newPatientText]=\"newPatientText\"\r\n  [existingPatientText]=\"existingPatientText\"\r\n  [vbcNameFilterEnabled]=\"vbcNameFilterEnabled\"\r\n  [vbcNameFilterLabel]=\"vbcNameFilterLabel\"\r\n  [pcpToggleEnabled]=\"pcpToggleEnabled\"\r\n  [selectedProviderOptionsEnabled]=\"selectedProviderOptionsEnabled\"\r\n  [removeText]=\"removeText\"\r\n  [selectAllText]=\"selectAllText\"\r\n  [isZelisIntegrationEnabled]=\"isZelisIntegrationEnabled\"\r\n>\r\n</vnext-widget-provider-search>\r\n" }]
    }], null, { plan: [{
            type: Input
        }], informationalText: [{
            type: Input
        }], enableProviderInfoSection: [{
            type: Input
        }], isHelpfulToolsView: [{
            type: Input
        }], providerLimit: [{
            type: Input
        }], providerMapDefaultZoom: [{
            type: Input
        }], maxZoom: [{
            type: Input
        }], minZoom: [{
            type: Input
        }], providersText: [{
            type: Input
        }], providersBodyText: [{
            type: Input
        }], retrieveZipCode: [{
            type: Input
        }], retrieveFipsCode: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], zipLabel: [{
            type: Input
        }], zipErrorText: [{
            type: Input
        }], providerNameText: [{
            type: Input
        }], providerNameHintText: [{
            type: Input
        }], providerSearchButtonText: [{
            type: Input
        }], itemsPerPage: [{
            type: Input
        }], providerPaginationEnabled: [{
            type: Input
        }], viewNotFoundHeaderText: [{
            type: Input
        }], viewNotFoundBodyText: [{
            type: Input
        }], paginationText: [{
            type: Input
        }], providerFiltersEnabled: [{
            type: Input
        }], providerFilters: [{
            type: Input
        }], countyLabel: [{
            type: Input
        }], showCountyLabel: [{
            type: Input
        }], acceptingNewPatientsText: [{
            type: Input
        }], acceptingNewPatientsIcon: [{
            type: Input
        }], languagesIcon: [{
            type: Input
        }], countryCode: [{
            type: Input
        }], providerLocationsText: [{
            type: Input
        }], providerSingleSelectEnabled: [{
            type: Input
        }], valueBasedCareEnabled: [{
            type: Input
        }], valueBasedCareIcon: [{
            type: Input
        }], valueBasedCareText: [{
            type: Input
        }], generalPracticeOptions: [{
            type: Input
        }], generalPracticeToolTipText: [{
            type: Input
        }], generalPracticeLabel: [{
            type: Input
        }], generalPracticeFilterOptionEnabled: [{
            type: Input
        }], singleProviderInListEnabled: [{
            type: Input
        }], updateLinkText: [{
            type: Input
        }], editLinkText: [{
            type: Input
        }], showEditLinkEnabled: [{
            type: Input
        }], isValueBasedCareLearnMoreLink2Enabled: [{
            type: Input
        }], valueBasedCareAvailableText: [{
            type: Input
        }], valueBasedCareLearnMoreLink: [{
            type: Input
        }], valueBasedCareLearnMoreText: [{
            type: Input
        }], valueBasedCareToggleLabel: [{
            type: Input
        }], valueBasedCareToggleEnabled: [{
            type: Input
        }], valueBasedCareToggleToolTipText: [{
            type: Input
        }], valueBasedCareToggleOptions: [{
            type: Input
        }], newPatientToggleEnabled: [{
            type: Input
        }], newPatientToggleLabel: [{
            type: Input
        }], newPatientToggleOptions: [{
            type: Input
        }], pcpToggleLabel: [{
            type: Input
        }], pcpToggleOptions: [{
            type: Input
        }], newPatientText: [{
            type: Input
        }], existingPatientText: [{
            type: Input
        }], vbcNameFilterEnabled: [{
            type: Input
        }], vbcNameFilterLabel: [{
            type: Input
        }], pcpToggleEnabled: [{
            type: Input
        }], selectedProviderOptionsEnabled: [{
            type: Input
        }], removeText: [{
            type: Input
        }], selectAllText: [{
            type: Input
        }], isZelisIntegrationEnabled: [{
            type: Input
        }], fetchProvidersFromLocation: [{
            type: Output
        }], initializeMap: [{
            type: Output
        }], setMapCenter: [{
            type: Output
        }], setMapDefaultBounds: [{
            type: Output
        }], fetchProvidersFromAPI: [{
            type: Output
        }] }); })();

const _c0$1O = function (a0) { return { "active": a0 }; };
class PlanDetailsTabComponent {
    constructor() {
        this.setFocusToTabEvent = new EventEmitter();
    }
    setFocusToPreviousTabElement(currentIndex, $event) {
        if (this.lastIndex) {
            $event.preventDefault();
            this.setFocusToTabEvent.emit(currentIndex === 0 ? this.lastIndex : currentIndex - 1);
        }
    }
    setFocusToNextTabElement(currentIndex, $event) {
        if (this.lastIndex) {
            $event.preventDefault();
            this.setFocusToTabEvent.emit(currentIndex === this.lastIndex ? 0 : currentIndex + 1);
        }
    }
}
PlanDetailsTabComponent.ɵfac = function PlanDetailsTabComponent_Factory(t) { return new (t || PlanDetailsTabComponent)(); };
PlanDetailsTabComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanDetailsTabComponent, selectors: [["vnext-plan-details-tab"]], inputs: { title: "title", currentIndex: "currentIndex", lastIndex: "lastIndex", isActiveTab: "isActiveTab", ariaControlsId: "ariaControlsId" }, outputs: { setFocusToTabEvent: "setFocusToTabEvent" }, decls: 3, vars: 11, consts: [["role", "tab", "tabindex", "0", 1, "tab_link", "d-block", "Spa_Style_Primary_Color", 3, "ngClass", "keyup.arrowleft", "keyup.arrowright"]], template: function PlanDetailsTabComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "a", 0);
        i0.ɵɵlistener("keyup.arrowleft", function PlanDetailsTabComponent_Template_a_keyup_arrowleft_0_listener($event) { return ctx.setFocusToPreviousTabElement(ctx.currentIndex, $event); })("keyup.arrowright", function PlanDetailsTabComponent_Template_a_keyup_arrowright_0_listener($event) { return ctx.setFocusToNextTabElement(ctx.currentIndex, $event); });
        i0.ɵɵelementStart(1, "div");
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0$1O, ctx.isActiveTab));
        i0.ɵɵattribute("aria-posinset", ctx.currentIndex + 1)("aria-setsize", ctx.lastIndex + 1)("aria-selected", ctx.isActiveTab)("aria-expanded", ctx.isActiveTab)("aria-label", ctx.title)("aria-controls", ctx.ariaControlsId)("tabindex", ctx.isActiveTab ? "0" : "-1");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
    } }, dependencies: [i1$2.NgClass], styles: [".tab_link[_ngcontent-%COMP%]{padding:1rem .8rem;text-decoration:none}.tab_link[_ngcontent-%COMP%]:hover{text-decoration:none}.tab_link.active[_ngcontent-%COMP%]{font-weight:700}@media (max-width: 992px){.tab_link[_ngcontent-%COMP%]{font-size:var(--Spa_Style_Smaller_Font)}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanDetailsTabComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-details-tab', changeDetection: ChangeDetectionStrategy.OnPush, template: "<a\r\n  role=\"tab\"\r\n  [ngClass]=\"{ 'active': isActiveTab }\"\r\n  class=\"tab_link d-block Spa_Style_Primary_Color\"\r\n  tabindex=\"0\"\r\n  (keyup.arrowleft)=\"setFocusToPreviousTabElement(currentIndex, $event)\"\r\n  (keyup.arrowright)=\"setFocusToNextTabElement(currentIndex, $event)\"\r\n  [attr.aria-posinset]=\"currentIndex + 1\"\r\n  [attr.aria-setsize]=\"lastIndex + 1\"\r\n  [attr.aria-selected]=\"isActiveTab\"\r\n  [attr.aria-expanded]=\"isActiveTab\"\r\n  [attr.aria-label]=\"title\"\r\n  [attr.aria-controls]=\"ariaControlsId\"\r\n  [attr.tabindex]=\"isActiveTab ? '0' : '-1'\"\r\n>\r\n  <div>\r\n    {{ title }}\r\n  </div>\r\n</a>\r\n", styles: [".tab_link{padding:1rem .8rem;text-decoration:none}.tab_link:hover{text-decoration:none}.tab_link.active{font-weight:700}@media (max-width: 992px){.tab_link{font-size:var(--Spa_Style_Smaller_Font)}}\n"] }]
    }], null, { title: [{
            type: Input
        }], currentIndex: [{
            type: Input
        }], lastIndex: [{
            type: Input
        }], isActiveTab: [{
            type: Input
        }], ariaControlsId: [{
            type: Input
        }], setFocusToTabEvent: [{
            type: Output
        }] }); })();

const _c0$1N = ["helpfulToolsPlanDetailsTab"];
function HelpfulToolsPharmacySearchComponent_h1_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.selectedPlan == null ? null : ctx_r0.selectedPlan.planName);
} }
const _c1$Q = function (a0) { return { active: a0 }; };
function HelpfulToolsPharmacySearchComponent_div_9_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li", 15);
    i0.ɵɵlistener("click", function HelpfulToolsPharmacySearchComponent_div_9_ng_container_2_Template_li_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r10); const tab_r6 = restoredCtx.$implicit; const ctx_r9 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r9.selectTab(tab_r6)); })("keyup.enter", function HelpfulToolsPharmacySearchComponent_div_9_ng_container_2_Template_li_keyup_enter_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r10); const tab_r6 = restoredCtx.$implicit; const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.selectTab(tab_r6)); });
    i0.ɵɵelementStart(2, "vnext-plan-details-tab", 16, 17);
    i0.ɵɵlistener("setFocusToTabEvent", function HelpfulToolsPharmacySearchComponent_div_9_ng_container_2_Template_vnext_plan_details_tab_setFocusToTabEvent_2_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r12 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r12.shiftFocusToTabElement($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tab_r6 = ctx.$implicit;
    const index_r7 = ctx.index;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$Q, ctx_r5.activeTab === tab_r6.name));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", tab_r6.title)("currentIndex", index_r7)("lastIndex", ctx_r5.helpfulToolsTabs.length - 1)("isActiveTab", ctx_r5.activeTab === tab_r6.name)("ariaControlsId", tab_r6.id);
} }
function HelpfulToolsPharmacySearchComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "ul", 13);
    i0.ɵɵtemplate(2, HelpfulToolsPharmacySearchComponent_div_9_ng_container_2_Template, 4, 8, "ng-container", 14);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.helpfulToolsTabs);
} }
function HelpfulToolsPharmacySearchComponent_vnext_helpful_tools_pharmacy_search_tab_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-helpful-tools-pharmacy-search-tab", 18);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("retrieveZipCode", ctx_r2.helpfulToolsFacade.zipCodeAction)("retrieveFipsCode", ctx_r2.helpfulToolsFacade.fipsCodeAction)("addPharmacyButtonText", ctx_r2.Spa_Add_Pharmacy_Button)("pharmacyLimit", ctx_r2.Spa_Pharmacy_Limit)("pharmacyMapDefaultZoom", ctx_r2.Spa_PharmacyMap_Default_Zoom)("maxZoom", ctx_r2.Spa_PharmacyMap_Max_Zoom)("minZoom", ctx_r2.Spa_PharmacyMap_Min_Zoom)("currentPharmacyText", ctx_r2.Spa_AddPharmacy_YourPharmacyText)("pharmacyAddedLabel", ctx_r2.Spa_Pharmacy_Added_Label)("electronicPrescriptionTooltipHeader", ctx_r2.Spa_Site_ElectronicPrescription_ToolTipHeader)("electronicPrescriptionTooltipBody", ctx_r2.Spa_Site_ElectronicPrescription_ToolTipBody)("itemsPerPage", ctx_r2.Spa_PharmacySearch_Pagination_ItemsPerPage)("pharmacyPaginationEnabled", ctx_r2.Spa_PharmacySearch_Pagination_Enabled)("paginationText", ctx_r2.Spa_PharmacySearch_Pagination_View_Text)("viewNotFoundHeaderText", ctx_r2.Spa_Pharmacy_Alt_View_Not_Found_Header_Text)("viewNotFoundBodyText", ctx_r2.Spa_Pharmacy_Alt_View_Not_Found_Body_Text)("preferredInNetworkText", ctx_r2.Spa_Site_Preferred_In_Network_Text)("standardInNetworkText", ctx_r2.Spa_Site_Standard_In_Network_Text)("preferredInNetworkTooltipContent", ctx_r2.Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text)("standardInNetworkTooltipContent", ctx_r2.Spa_PharmacySearch_Standard_In_Network_Tooltip_Text)("pharmacySearchIntroText", ctx_r2.Spa_PharmacySearch_Intro_Text)("errorKeywordText", ctx_r2.Spa_Site_ErrorKeyword_Text)("addedPharmacyText", ctx_r2.Spa_Site_Pharmacy_Added_Text)("addPharmacyText", ctx_r2.Spa_Site_Pharmacy_Add_Text)("informationalText", ctx_r2.Spa_HelpfulTools_Pharmacy_Info_Text)("enablePharmacyInfoSection", ctx_r2.Spa_HelpfulTools_Enable_Prescription_Info_Section || ctx_r2.isLiveEdit)("ePrescribingAltText", ctx_r2.Spa_Site_EPrescribing_Alt_Text)("Spa_Site_Tooltip_Text", ctx_r2.Spa_Site_Tooltip_Text)("zipLabel", ctx_r2.Spa_Site_ZipCodeInput_ZipCodeLabel)("zipErrorText", ctx_r2.Spa_Site_ZipCodeInput_ZipCodeError)("pharmacySearchButtonText", ctx_r2.Spa_Pharmacy_SearchButton_Text)("pharmacyNameText", ctx_r2.Spa_PharmacyName_Text)("pharmacyNameHintText", ctx_r2.Spa_PharmacyName_HintText)("pharmacyFilterText", ctx_r2.Spa_Filter_Header_Text)("isPharmacyFilterEnabled", ctx_r2.Spa_Site_Pharmacy_Filter_Enabled)("isPharmacyOtherFilterEnabled", ctx_r2.Spa_Site_Pharmacy_Other_Filter_Enabled)("isPharmacyInNetworkFilterEnabled", ctx_r2.Spa_Site_Pharmacy_In_Network_Filter_Enabled)("pharmacyFilterClearText", ctx_r2.Spa_Filter_Clear_All)("pharmacyFilterData", ctx_r2.Spa_Pharmacy_Filters)("defaultFilterText", ctx_r2.Spa_Filter_Default_Filter_Text)("countyLabel", ctx_r2.Spa_ZipCodeInput_CountyLabel_Text)("showCountyLabel", ctx_r2.Spa_ZipCodeInput_CountyLabel_Enabled)("pharmacyInNetworkFilters", ctx_r2.Spa_Pharmacy_In_Network_Filters)("digitalPharmacyEnabled", ctx_r2.Spa_Site_Digital_Pharmacy_Enabled)("retailTabText", ctx_r2.Spa_Pharmacy_Retail_Tab_Text)("digitalTabText", ctx_r2.Spa_Pharmacy_Digital_Tab_Text);
} }
function HelpfulToolsPharmacySearchComponent_vnext_helpful_tools_prescription_search_tab_12_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-helpful-tools-prescription-search-tab", 19);
    i0.ɵɵlistener("viewPossibleAlternativeDrugs", function HelpfulToolsPharmacySearchComponent_vnext_helpful_tools_prescription_search_tab_12_Template_vnext_helpful_tools_prescription_search_tab_viewPossibleAlternativeDrugs_0_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.onViewPossibleAlternativeDrugs($event)); })("backToDefaultPrescriptionTab", function HelpfulToolsPharmacySearchComponent_vnext_helpful_tools_prescription_search_tab_12_Template_vnext_helpful_tools_prescription_search_tab_backToDefaultPrescriptionTab_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.onBackToDefaultPrescriptionTab()); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("plan", ctx_r3.selectedPlan)("footnoteIds", i0.ɵɵpipeBind1(1, 66, ctx_r3.footnoteIds$))("footnotesHeader", ctx_r3.Spa_PlanDetails_Footnote_Header)("footnotes", ctx_r3.Spa_PlanDetails_Footnotes)("formularyId", ctx_r3.Spa_Site_Formulary_ID_Text)("formularyContractPlanSegmentLabelPrefix", ctx_r3.Spa_Site_Formulary_Plan_Text)("formularyVersionText", ctx_r3.Spa_Site_Formulary_Version_Text)("showContractPlanSegment", ctx_r3.Spa_HelpfulTools_Show_ContractPlanSegment)("showFootnotes", i0.ɵɵpipeBind1(2, 68, ctx_r3.showFormularyAndFootnotes$))("showFormulary", i0.ɵɵpipeBind1(3, 70, ctx_r3.showFormularyAndFootnotes$))("frequencyList", ctx_r3.drugSearchFrequencyList)("contentSectionText", ctx_r3.Spa_DrugSearch_Content_Section_Text)("dosageHeader", ctx_r3.Spa_DrugSearch_Dosage_Header)("quantityAndFrequencyHeader", ctx_r3.Spa_DrugSearch_Frequency_Header)("packageHeader", ctx_r3.Spa_DrugSearch_Package_Header)("addButtonText", ctx_r3.Spa_DrugSearch_Add_Button)("cancelButtonText", ctx_r3.Spa_DrugSearch_Cancel_Button)("quantityMaxLimit", ctx_r3.Spa_DrugSearch_Quantity_Max_Limit)("medicineCabinetLimit", ctx_r3.Spa_DrugSearch_Cabinet_Limit)("cabinetLimitErrorMessage", ctx_r3.Spa_DrugSearch_MaxCount_Error_Message)("quantityErrorMessage", ctx_r3.Spa_DrugSearch_Quantity_Error_Message)("placeholder", ctx_r3.Spa_DrugSearch_Hint_Text)("drugSearchText", ctx_r3.Spa_DrugSearch_Label_Text)("drugsImage", ctx_r3.Spa_DrugSearch_Drugs_Image)("inCabinetErrorMessage", ctx_r3.Spa_DrugSearch_InCabinetError_Text)("medCabinetHeader", ctx_r3.Spa_DrugSearch_Medicine_Header)("genericOptionIcon", ctx_r3.Spa_DrugSearch_GenericOption_Icon)("showGenericOption", ctx_r3.Spa_Site_Show_GenericDrugOption)("genericOptionQuestion", ctx_r3.Spa_DrugSearch_GenericOption_Question)("genericOptionInfo", ctx_r3.Spa_DrugSearch_GenericOption_Info)("genericOptions", ctx_r3.Spa_DrugSearch_GenericOptions)("checkDrugCoverageButtonText", ctx_r3.Spa_DrugSearch_CheckDrugCoverageButton_Text)("genericOptionDefaultSelection", ctx_r3.Spa_DrugSearch_GenericOption_Default_Selection)("showCosts", ctx_r3.Spa_DrugListCard_HideCosts_Flag)("drugSearchIntroText", ctx_r3.Spa_DrugSearch_Intro_Text)("drugSearchPageHeaderText", ctx_r3.Spa_DrugSearch_PageHeader_Text)("errorKeywordText", ctx_r3.Spa_Site_ErrorKeyword_Text)("drugSearchFrequencyListBoxLabel", ctx_r3.Spa_DrugSearch_Frequency_ListBox_Label)("nonCoveredPrescriptions", ctx_r3.Spa_PrescriptionsTab_NonCovered_Text)("coveredPrescriptions", ctx_r3.Spa_PrescriptionsTab_Covered_Text)("noPrescriptionInTier", ctx_r3.Spa_PrescriptionsTab_NotInTier_Text)("informationalText", ctx_r3.Spa_HelpfulTools_Prescription_Info_Text)("editDrugText", ctx_r3.Spa_DrugSearch_EditDrug_Button)("enablePrescriptionInfoSection", ctx_r3.Spa_HelpfulTools_Enable_Prescription_Info_Section || ctx_r3.isLiveEdit)("isUseCMSDrugFlagEnabled", ctx_r3.Spa_Drugs_UseCMSDrugFlag_Enabled)("showDrugAlternativesEnabled", ctx_r3.Spa_Site_ShowDrugAlternatives_Enabled)("helpfulToolsShowDrugAlternativesNudgeEnabled", ctx_r3.showDrugAlternativesNudgeEnabled)("prescriptionsDrugAlternativesButtonText", ctx_r3.Spa_Prescriptions_ShowDrugAlternatives_ViewAlternatives_Text)("prescriptionTabView", ctx_r3.prescriptionTabView)("selectedPlanPharmacy", ctx_r3.selectedPlanPharmacy)("isMailOrderSelected", ctx_r3.isMailOrderSelected)("selectedPharmacy", ctx_r3.selectedPharmacy)("backToPrescriptionLabelText", ctx_r3.Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_BackToPrescriptions_Link_Text)("hintAlternativesForCabinetHeaderText", ctx_r3.Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_Header_Text)("hintNoAlternativesForCabinet", ctx_r3.Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_NoDrugs_Empty_Text)("hintAlternativesForCabinetText", ctx_r3.Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_Intro_Text)("drugCostsRetailCostText", ctx_r3.Spa_DrugCosts_RetailCostText)("conditionPrescribedForText", ctx_r3.Spa_Prescriptions_ShowDrugAlternatives_Condition_Modal_Text)("changeMedicalConditionsEnabled", ctx_r3.Spa_Site_ShowDrugAlternatives_Change_Medical_Conditions_Enabled)("planForDrugAlternatives", ctx_r3.planForDrugAlternatives)("cabinetForAlternatives", ctx_r3.cabinetForAlternatives)("footnoteIdsToShowForDrugAlternatives", ctx_r3.footnoteIdsToShowForDrugAlternatives)("drugSearchFrequencies", ctx_r3.Spa_DrugSearch_Frequency_List)("drugListCardBrandText", ctx_r3.Spa_DrugListCard_Brand_Text)("drugListCardGenericText", ctx_r3.Spa_DrugListCard_Generic_Text)("isMobile", ctx_r3.isMobile);
} }
function HelpfulToolsPharmacySearchComponent_vnext_helpful_tools_provider_search_tab_13_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-helpful-tools-provider-search-tab", 20);
    i0.ɵɵlistener("fetchProvidersFromLocation", function HelpfulToolsPharmacySearchComponent_vnext_helpful_tools_provider_search_tab_13_Template_vnext_helpful_tools_provider_search_tab_fetchProvidersFromLocation_0_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.fetchProvidersFromLocation($event)); })("setMapCenter", function HelpfulToolsPharmacySearchComponent_vnext_helpful_tools_provider_search_tab_13_Template_vnext_helpful_tools_provider_search_tab_setMapCenter_0_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.mapFacade.setCenterPosition($event)); })("initializeMap", function HelpfulToolsPharmacySearchComponent_vnext_helpful_tools_provider_search_tab_13_Template_vnext_helpful_tools_provider_search_tab_initializeMap_0_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r19 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r19.mapFacade.initializeMap($event)); })("setMapDefaultBounds", function HelpfulToolsPharmacySearchComponent_vnext_helpful_tools_provider_search_tab_13_Template_vnext_helpful_tools_provider_search_tab_setMapDefaultBounds_0_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.mapContextService.setDefaultBounds($event)); })("fetchProvidersFromAPI", function HelpfulToolsPharmacySearchComponent_vnext_helpful_tools_provider_search_tab_13_Template_vnext_helpful_tools_provider_search_tab_fetchProvidersFromAPI_0_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r21 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r21.providerFacade.fetchProvidersFromAPI($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("retrieveZipCode", ctx_r4.helpfulToolsFacade.zipCodeAction)("retrieveFipsCode", ctx_r4.helpfulToolsFacade.fipsCodeAction)("providersText", ctx_r4.Spa_Site_Providers_Text)("providersBodyText", ctx_r4.Spa_Site_Providers_Body_Text)("errorKeywordText", ctx_r4.Spa_Site_ErrorKeyword_Text)("zipLabel", ctx_r4.Spa_Site_ZipCodeInput_ZipCodeLabel)("zipErrorText", ctx_r4.Spa_Site_ZipCodeInput_ZipCodeError)("providerNameText", ctx_r4.Spa_ProviderName_Text)("providerNameHintText", ctx_r4.Spa_ProviderName_HintText)("providerSearchButtonText", ctx_r4.Spa_Site_SearchButton_Text)("providerLimit", ctx_r4.Spa_Provider_Limit)("itemsPerPage", ctx_r4.Spa_ProviderSearch_Pagination_ItemsPerPage)("providerPaginationEnabled", ctx_r4.Spa_ProviderSearch_Pagination_Enabled)("viewNotFoundHeaderText", ctx_r4.Spa_Provider_Alt_View_Not_Found_Header_Text)("viewNotFoundBodyText", ctx_r4.Spa_Provider_Alt_View_Not_Found_Body_Text)("paginationText", ctx_r4.Spa_ProviderSearch_Pagination_View_Text)("maxZoom", ctx_r4.Spa_ProviderMap_Max_Zoom)("minZoom", ctx_r4.Spa_ProviderMap_Min_Zoom)("providerMapDefaultZoom", ctx_r4.Spa_ProviderMap_Default_Zoom)("informationalText", ctx_r4.Spa_HelpfulTools_Provider_Info_Text)("plan", ctx_r4.selectedPlan)("enableProviderInfoSection", ctx_r4.Spa_HelpfulTools_Enable_Provider_Info_Section || ctx_r4.isLiveEdit)("providerFiltersEnabled", ctx_r4.Spa_Providers_Filter_Enabled)("providerFilters", ctx_r4.providerFilters)("countyLabel", ctx_r4.Spa_ZipCodeInput_CountyLabel_Text)("showCountyLabel", ctx_r4.Spa_ZipCodeInput_CountyLabel_Enabled)("acceptingNewPatientsIcon", ctx_r4.Spa_Providers_AcceptingNewPatients_Icon)("acceptingNewPatientsText", ctx_r4.Spa_Providers_AcceptingNewPatients_Text)("languagesIcon", ctx_r4.Spa_Providers_Languages_Icon)("providerLocationsText", ctx_r4.Spa_Plan_Providers_Locations_Link_Text)("providerSingleSelectEnabled", ctx_r4.Spa_Select_Single_Provider_For_Multi_Address_Enabled)("countryCode", ctx_r4.countryCode)("valueBasedCareEnabled", ctx_r4.Spa_Site_ValueBasedCare_Enabled)("valueBasedCareIcon", ctx_r4.Spa_Site_ValueBasedCare_Icon)("valueBasedCareText", ctx_r4.Spa_Site_ValueBasedCare_Text)("generalPracticeOptions", ctx_r4.Spa_Provider_Search_Filter_General_Practice_Options)("generalPracticeToolTipText", ctx_r4.Spa_Provider_Search_General_Practice_Tooltip_Text)("generalPracticeLabel", ctx_r4.Spa_Provider_Search_General_Practice_Label_Text)("generalPracticeFilterOptionEnabled", ctx_r4.Spa_Provider_Search_Filter_General_Practice_Option_Enabled)("singleProviderInListEnabled", ctx_r4.Spa_Provider_Search_ShowSingleProviderInList_Enabled)("updateLinkText", ctx_r4.Spa_Site_Update_Text)("editLinkText", ctx_r4.Spa_Site_Edit_Text)("showEditLinkEnabled", ctx_r4.Spa_Provider_ShowEditLink_Enabled)("valueBasedCareAvailableText", ctx_r4.Spa_ValueBasedCare_Available_Text)("valueBasedCareLearnMoreLink", ctx_r4.Spa_ValueBasedCare_LearnMore_Link)("valueBasedCareLearnMoreText", ctx_r4.Spa_ValueBasedCare_LearnMore_Text)("isValueBasedCareLearnMoreLink2Enabled", ctx_r4.Spa_ValueBasedCare_LearnMoreLink2_Enabled && ctx_r4.Spa_Site_ValueBasedCare_Enabled)("valueBasedCareToggleLabel", ctx_r4.Spa_ValueBasedCare_Toggle_Label)("valueBasedCareToggleToolTipText", ctx_r4.Spa_ValueBasedCare_Toggle_ToolTip_Text)("valueBasedCareToggleEnabled", ctx_r4.Spa_ValueBasedCare_Toggle_Enabled && ctx_r4.Spa_Site_ValueBasedCare_Enabled)("valueBasedCareToggleOptions", ctx_r4.Spa_Provider_Search_Filter_ValueBasedCare_Options)("newPatientToggleEnabled", ctx_r4.Spa_Provider_New_Patient_Toggle_Enabled)("newPatientToggleOptions", ctx_r4.Spa_Provider_New_Patient_Options)("newPatientToggleLabel", ctx_r4.Spa_Provider_New_Patient_Toggle_Label)("pcpToggleLabel", ctx_r4.Spa_Primary_Care_Provider_Toggle_Label)("pcpToggleOptions", ctx_r4.Spa_Primary_Care_Provider_Options)("newPatientText", ctx_r4.Spa_New_Patient_For_Provider_Text)("existingPatientText", ctx_r4.Spa_Existing_Patient_For_Provider_Text)("vbcNameFilterEnabled", ctx_r4.Spa_Provider_ValueBasedCare_Name_Filter_Enabled)("vbcNameFilterLabel", ctx_r4.Spa_Provider_ValueBasedCare_Name_Filter_Label)("pcpToggleEnabled", ctx_r4.Spa_Primary_Care_Provider_Toggle_Enabled)("selectedProviderOptionsEnabled", ctx_r4.Spa_Selected_Provider_Options_Enabled)("removeText", ctx_r4.Spa_Site_Remove_Text)("selectAllText", ctx_r4.Spa_Site_SelectAll_Text)("isZelisIntegrationEnabled", ctx_r4.Spa_Site_ZelisIntegration_Enabled);
} }
let HelpfulToolsPharmacySearchComponent = class HelpfulToolsPharmacySearchComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, responsiveLayoutService, helpfulToolsService, helpfulToolsContext, helpfulToolsResourceFacade, footnoteFacade, helpfulToolsFacade, pharmacyContext, router, analyticsService, providerFacade, mapFacade, navigationService, mapContextService, memberSessionService, store, pharmacyService, drugCabinetContext, pharmacyFacade, planFacade, localeService, activatedRoute) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.responsiveLayoutService = responsiveLayoutService;
        this.helpfulToolsService = helpfulToolsService;
        this.helpfulToolsContext = helpfulToolsContext;
        this.helpfulToolsResourceFacade = helpfulToolsResourceFacade;
        this.footnoteFacade = footnoteFacade;
        this.helpfulToolsFacade = helpfulToolsFacade;
        this.pharmacyContext = pharmacyContext;
        this.router = router;
        this.analyticsService = analyticsService;
        this.providerFacade = providerFacade;
        this.mapFacade = mapFacade;
        this.navigationService = navigationService;
        this.mapContextService = mapContextService;
        this.memberSessionService = memberSessionService;
        this.store = store;
        this.pharmacyService = pharmacyService;
        this.drugCabinetContext = drugCabinetContext;
        this.pharmacyFacade = pharmacyFacade;
        this.planFacade = planFacade;
        this.localeService = localeService;
        this.activatedRoute = activatedRoute;
        // #region resources
        this.Spa_Site_Pharmacy_Text = 'Pharmacy';
        this.Spa_Site_Providers_Text = 'Providers';
        this.Spa_Site_Prescriptions_Text = 'Prescriptions';
        this.Spa_Site_Formulary_ID_Text = 'Formulary ID:';
        this.Spa_Site_Formulary_Plan_Text = 'Plan:';
        this.Spa_Site_Formulary_Version_Text = 'No changes made since:';
        this.Spa_HelpfulTools_Show_ContractPlanSegment = true;
        this.Spa_HelpfulTools_Medicare_Plans = 'Medicare Plans';
        this.Spa_PlanDetails_Footnotes = this.footnoteFacade.getFootNotes();
        this.Spa_Pharmacy_SearchButton_Text = 'Search';
        this.Spa_PharmacyName_Text = 'Pharmacy name';
        this.Spa_PharmacyName_HintText = 'Pharmacy name';
        this.Spa_DrugSearch_Frequency_List = [
            { label: "per month" /* FrequencyLabel.Month */, value: 30 /* FrequencyValue.Month */ },
            { label: "per two months" /* FrequencyLabel.TwoMonths */, value: 60 /* FrequencyValue.TwoMonths */ },
            { label: "per three months" /* FrequencyLabel.ThreeMonths */, value: 90 /* FrequencyValue.ThreeMonths */ },
            { label: "per six months" /* FrequencyLabel.SixMonths */, value: 180 /* FrequencyValue.SixMonths */ },
            { label: "per year" /* FrequencyLabel.PerYear */, value: 365 /* FrequencyValue.PerYear */ }
        ];
        this.Spa_DrugSearch_Content_Section_Text = 'We defaulted the most common dosage so you have a better idea of what you might take.';
        this.Spa_DrugSearch_Dosage_Header = 'Select dose and form';
        this.Spa_DrugSearch_Frequency_Header = 'Enter quantity and frequency';
        this.Spa_DrugSearch_Package_Header = 'Select package';
        this.Spa_DrugSearch_Add_Button = 'Add';
        this.Spa_DrugSearch_Cancel_Button = 'Cancel';
        this.Spa_DrugSearch_EditDrug_Button = 'Edit Drug';
        this.Spa_DrugSearch_Quantity_Max_Limit = 1000;
        this.Spa_DrugSearch_Cabinet_Limit = 25;
        this.Spa_DrugSearch_MaxCount_Error_Message = `You can only add up to ${this.Spa_DrugSearch_Cabinet_Limit} drugs`;
        this.Spa_DrugSearch_Quantity_Error_Message = `
  Please provide a number between 0 and ${this.Spa_DrugSearch_Quantity_Max_Limit}`;
        this.Spa_DrugSearch_Hint_Text = 'search for prescription';
        this.Spa_DrugSearch_Label_Text = 'Drug Search';
        this.Spa_DrugSearch_InCabinetError_Text = 'This drug and dosage already exists in your list.';
        this.Spa_DrugSearch_Medicine_Header = 'Your prescriptions';
        this.Spa_DrugSearch_GenericOption_Icon = 'fas fa-tag';
        this.Spa_Site_Show_GenericDrugOption = true;
        this.Spa_DrugSearch_GenericOption_Question = 'Would you like to use a Generic (<genericDrugName>) for <brandName>';
        this.Spa_DrugSearch_GenericOption_Info = `
    According to the FDA, this generic drug has the same quality, strength, safety and active ingredient as the brand name drug.
    Generic drugs are usually covered by part D plans and are generally a lower price.`;
        this.Spa_DrugSearch_GenericOptions = [
            { label: 'Yes', value: true },
            { label: 'No', value: false }
        ];
        this.Spa_DrugSearch_CheckDrugCoverageButton_Text = 'See if this drug is covered';
        this.Spa_DrugSearch_GenericOption_Default_Selection = false;
        this.Spa_DrugListCard_HideCosts_Flag = false;
        this.Spa_DrugSearch_Intro_Text = 'This will allow you to see how each plan provides coverage for your prescriptions.';
        this.Spa_DrugSearch_PageHeader_Text = 'Prescriptions';
        this.Spa_Add_Pharmacy_Button = 'Add pharmacy';
        this.Spa_Pharmacy_Limit = 25;
        this.Spa_PharmacyMap_Default_Zoom = 11;
        this.Spa_PharmacyMap_Max_Zoom = 28;
        this.Spa_PharmacyMap_Min_Zoom = 4;
        this.Spa_AddPharmacy_YourPharmacyText = 'Your Pharmacy';
        this.Spa_Pharmacy_Added_Label = 'Pharmacy Added';
        this.Spa_Site_ElectronicPrescription_ToolTipHeader = 'Electronic prescribing';
        this.Spa_Site_ElectronicPrescription_ToolTipBody = 'Prescriptions can be written and sent to the pharmacy electronically.';
        this.Spa_Pharmacy_Not_Found_Text = `We're sorry, but we did not find any pharmacies near that location.
    Please use the map zoom [-] to expand your search area, or enter a new search location in the ZIP code search box above.`;
        this.Spa_PharmacySearch_Pagination_ItemsPerPage = 10;
        this.Spa_PharmacySearch_Pagination_Enabled = false;
        this.Spa_PharmacySearch_Pagination_View_Text = 'Viewing <startPageItem> - <endPageItem> of <totalPages>';
        this.Spa_Pharmacy_Alt_View_Not_Found_Header_Text = 'No pharmacy results';
        this.Spa_Pharmacy_Alt_View_Not_Found_Body_Text = 'There are no pharmacies available in this location. Try zooming out or entering a new ZIP code.';
        this.Spa_Site_Preferred_In_Network_Text = 'Preferred In-network';
        this.Spa_Site_Standard_In_Network_Text = 'Standard In-network';
        this.Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text = 'Pharmacies that are willing to give the plans a larger discount than other pharmacies.';
        this.Spa_PharmacySearch_Standard_In_Network_Tooltip_Text = 'These pharmacies may charge a higher copayment or co-insurance for filling your prescription.';
        this.Spa_Site_ErrorKeyword_Text = 'Error:';
        this.Spa_DrugSearch_Frequency_ListBox_Label = 'Choose any one the frequency from list of options available';
        this.Spa_Site_Pharmacy_Added_Text = 'has been added';
        this.Spa_Site_Pharmacy_Add_Text = 'Press Enter to add this Pharmacy';
        this.Spa_PharmacySearch_Intro_Text = 'Find your pharmacy to help us estimate costs and show you which plans include in-network pharmacy discounts.';
        this.Spa_PrescriptionsTab_NonCovered_Text = 'Non-covered prescriptions';
        this.Spa_PrescriptionsTab_Covered_Text = 'Covered prescriptions';
        this.Spa_PrescriptionsTab_NotInTier_Text = 'None of your prescriptions are in this tier';
        this.Spa_HelpfulTools_Prescription_Info_Text = 'Add your prescription to see how this plan provides coverage. Formularies may change on January 1';
        this.Spa_HelpfulTools_Pharmacy_Info_Text = 'Find a pharmacy to see if it is in-network. Pharmacy networks may change from year to year.';
        this.Spa_HelpfulTools_Provider_Info_Text = 'The map below shows providers in-network with this plan. If you do not see a provider you are looking for, please check the carrier provider directory to determine if they are in network';
        this.Spa_HelpfulTools_Enable_Prescription_Info_Section = true;
        this.Spa_HelpfulTools_Enable_Pharmacy_Info_Section = true;
        this.Spa_HelpfulTools_Enable_Provider_Info_Section = true;
        this.Spa_Site_EPrescribing_Alt_Text = 'This pharmacy supports e-prescribing.';
        this.Spa_Site_Tooltip_Text = 'Tooltip:';
        this.Spa_Site_ZipCodeInput_ZipCodeError = 'Zip code is invalid';
        this.Spa_Site_ZipCodeInput_ZipCodeLabel = 'Zip code';
        this.Spa_Filter_Header_Text = 'Filters';
        this.Spa_Site_Pharmacy_Filter_Enabled = true;
        this.Spa_Site_Pharmacy_In_Network_Filter_Enabled = true;
        this.Spa_Site_Pharmacy_Other_Filter_Enabled = false;
        this.Spa_Filter_Clear_All = 'Clear all';
        this.Spa_Pharmacy_Filter_Open24hrs_Text = 'Open 24 hours';
        this.Spa_Pharmacy_Filter_Eprescribing_Text = 'Electronic prescribing(prescriptions can be written and sent to the pharmacy electronically)';
        this.Spa_Pharmacy_Filter_HandicapAccess_Text = 'Handicap accessible';
        this.Spa_Pharmacy_Filter_DurableEquipment_Text = 'Durable medical Equipment';
        this.Spa_Pharmacy_Filter_MailOrder_Text = 'Mail Order';
        this.Spa_Filter_Default_Filter_Text = 'No filters available';
        this.Spa_Site_SearchButton_Text = 'Search';
        this.Spa_Site_Providers_Enabled = false;
        this.Spa_Provider_Limit = 25;
        this.Spa_ProviderSearch_Pagination_ItemsPerPage = 10;
        this.Spa_ProviderSearch_Pagination_Enabled = false;
        this.Spa_Provider_Alt_View_Not_Found_Header_Text = 'No provider results';
        this.Spa_Provider_Alt_View_Not_Found_Body_Text = 'There are no providers available in this location. Try zooming out or entering a new ZIP code.';
        this.Spa_ProviderSearch_Pagination_View_Text = 'Viewing <startPageItem> - <endPageItem> of <totalPages>';
        this.Spa_ProviderMap_Max_Zoom = 28;
        this.Spa_ProviderMap_Min_Zoom = 4;
        this.Spa_ProviderMap_Default_Zoom = 11;
        this.Spa_Providers_Filter_Enabled = false;
        this.Spa_Providers_Filter_Individuals_Text = 'Doctors and other professionals';
        this.Spa_Providers_Filter_Facilties_Text = 'Facilities (hospitals, clinics and urgent care)';
        this.Spa_ZipCodeInput_CountyLabel_Text = 'County';
        this.Spa_ZipCodeInput_CountyLabel_Enabled = false;
        this.Spa_Drugs_UseCMSDrugFlag_Enabled = true;
        this.Spa_ValueBasedCare_Available_Text = 'Value Based Care providers may be available in your area';
        this.Spa_ValueBasedCare_LearnMore_Link = 'https://www.cms.gov/priorities/innovation-center/value-based-care-spotlight';
        this.Spa_ValueBasedCare_LearnMoreLink2_Enabled = false;
        this.Spa_ValueBasedCare_Toggle_Label = 'Search Value Based Providers';
        this.Spa_ValueBasedCare_Toggle_ToolTip_Text = '';
        this.Spa_ValueBasedCare_Toggle_Enabled = false;
        this.Spa_Provider_Search_Filter_ValueBasedCare_Options = [
            { display: 'Yes', value: 'true' },
            { display: 'No', value: 'false' }
        ];
        this.Spa_Provider_New_Patient_Toggle_Enabled = false;
        this.Spa_Provider_New_Patient_Toggle_Label = 'Are you a new patient for this provider?';
        this.Spa_Provider_New_Patient_Options = [
            { display: 'Yes', value: 'yes' },
            { display: 'No', value: 'no' }
        ];
        this.Spa_Primary_Care_Provider_Toggle_Label = 'Is this your primary care physician';
        this.Spa_Primary_Care_Provider_Options = [
            { display: 'Yes', value: 'yes' },
            { display: 'No', value: 'no' }
        ];
        this.Spa_New_Patient_For_Provider_Text = 'New Patient';
        this.Spa_Existing_Patient_For_Provider_Text = 'Existing patient';
        this.Spa_ProviderName_Text = 'Provider name';
        this.Spa_ProviderName_HintText = 'Provider name';
        this.Spa_Site_Providers_Body_Text = `See which plans cover your doctor, specialist, urgent care or hospital. Reference the plan's Medical Provider Directory to see up-to-date network information.`;
        this.Spa_Pharmacy_Filters = [
            {
                dataKey: 'has24hrService',
                displayName: this.Spa_Pharmacy_Filter_Open24hrs_Text
            },
            {
                dataKey: 'hasEPrescriptions',
                displayName: this.Spa_Pharmacy_Filter_Eprescribing_Text
            },
            {
                dataKey: 'hasHandicapAccess',
                displayName: this.Spa_Pharmacy_Filter_HandicapAccess_Text
            },
            {
                dataKey: 'hasDurableEquipment',
                displayName: this.Spa_Pharmacy_Filter_DurableEquipment_Text
            },
            {
                dataKey: 'isMailOrder',
                displayName: this.Spa_Pharmacy_Filter_MailOrder_Text
            }
        ];
        this.Spa_Pharmacy_In_Network_Filters = [
            {
                dataKey: 'isStandard',
                displayName: '[[Spa_Site_Standard_In_Network_Text]] ([[Spa_PharmacySearch_Standard_In_Network_Tooltip_Text]])'
            },
            {
                dataKey: 'isPreferred',
                displayName: '[[Spa_Site_Preferred_In_Network_Text]] ([[Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text]])'
            }
        ];
        this.Spa_Site_ShowDrugAlternatives_Enabled = false;
        this.Spa_Prescriptions_ShowDrugAlternatives_ViewAlternatives_Text = 'View possible alternatives';
        this.Spa_DrugCosts_RetailCostText = 'Retail Cost';
        this.Spa_DrugListCard_Brand_Text = 'Branded';
        this.Spa_DrugListCard_Generic_Text = 'Generic';
        this.Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_BackToPrescriptions_Link_Text = 'Go to prescriptions';
        this.Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_Header_Text = 'Alternatives for';
        this.Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_Intro_Text = `
    Talk to your doctor if you are interested in switching to any of these alternatives.
    Doctors may not know the actual cost of each medication prescribed to you.
  `;
        this.Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_NoDrugs_Empty_Text = `
    <h4 class="Spa_Style_H4 my-2">No alternatives available.</h4>
    <span class="Spa_Style_Primary_Color">Make sure the condition listed above is correct.</span>
  `;
        this.Spa_PlanDetails_StickyMiniCart_Enabled = false;
        this.Spa_Prescriptions_ShowDrugAlternatives_Condition_Modal_Text = '<strong>Condition prescribed for</strong>';
        this.Spa_Site_ShowDrugAlternatives_Change_Medical_Conditions_Enabled = false;
        this.Spa_Providers_AcceptingNewPatients_Text = 'Accepting new patients';
        this.Spa_Providers_AcceptingNewPatients_Icon = 'fas fa-user-plus';
        this.Spa_Providers_Languages_Icon = 'fas fa-globe';
        this.Spa_Plan_Providers_Locations_Link_Text = 'locations';
        this.Spa_Select_Single_Provider_For_Multi_Address_Enabled = false;
        this.Spa_Site_ValueBasedCare_Enabled = true;
        this.Spa_Site_ValueBasedCare_Icon = 'fas fa-briefcase-medical';
        this.Spa_Site_ValueBasedCare_Text = 'Value based care';
        this.Spa_Site_ValueBasedCare_Filter_Enabled = true;
        this.Spa_ValueBasedCare_Filter_Text = 'Only show Value Based Care providers';
        this.Spa_ValueBasedCare_Filter_Checked = false;
        this.Spa_ValueBasedCare_LearnMore_Text = 'Learn more';
        this.Spa_ValueBasedCare_LearnMoreLink_Enabled = true;
        this.Spa_Provider_Search_Filter_General_Practice_Options = [
            { display: 'Yes', value: true },
            { display: 'No', value: false }
        ];
        this.Spa_Provider_Search_General_Practice_Label_Text = 'General practice';
        this.Spa_Provider_Search_General_Practice_Tooltip_Text = 'General practitioners treat patients of all ages, but do not typically specialize in a particular area. They may treat your medical condition or refer you to a specialist.';
        this.Spa_Provider_Search_Filter_General_Practice_Option_Enabled = false;
        this.Spa_Provider_Search_ShowSingleProviderInList_Enabled = false;
        this.Spa_Site_Edit_Text = 'Edit';
        this.Spa_Site_Update_Text = 'Update';
        this.Spa_Provider_ShowEditLink_Enabled = false;
        this.Spa_Provider_ValueBasedCare_Name_Filter_Enabled = false;
        this.Spa_Provider_ValueBasedCare_Name_Filter_Label = 'Participating Value Based Care organizations in this area';
        this.Spa_Primary_Care_Provider_Toggle_Enabled = false;
        this.Spa_Selected_Provider_Options_Enabled = false;
        this.Spa_Site_Remove_Text = 'Remove';
        this.Spa_Site_SelectAll_Text = 'Select all';
        this.Spa_Site_Digital_Pharmacy_Enabled = false;
        this.Spa_Pharmacy_Retail_Tab_Text = 'Retail pharmacy';
        this.Spa_Pharmacy_Digital_Tab_Text = 'Digital pharmacy';
        this.Spa_Site_ZelisIntegration_Enabled = false;
        // #endregion resources
        this.providerFilters = [];
        this.activeTab = HelpfulToolsTabs.Pharmacy;
        this.helpfulTools = PageTags.HELPFUL_TOOLS;
        this.pharmacyTab = HelpfulToolsTabs.Pharmacy;
        this.providerTab = HelpfulToolsTabs.Providers;
        this.prescriptionsTab = HelpfulToolsTabs.Prescriptions;
        this.helpfulToolsTabs = [];
        this.prescriptionTabView = PrescriptionTabViewMode.DEFAULT;
        this.footnoteIdsToShowForDrugAlternatives = [];
        this.subscriptions = new Subscription();
        this.vaccineAdminFeeText = '<Vaccine_Admin_Fee>';
    }
    ngOnInit() {
        super.ngOnInit();
        this.isLiveEdit = this.isLiveEditMode();
        this.rehydrateHelpfulTools();
        this.drugSearchFrequencyList = this.getFilteredFrequencyOptions();
        const queryPlanId = this.activatedRoute.snapshot.queryParamMap.get('detailedPlanId');
        this.selectedPlan = queryPlanId ? this.helpfulToolsFacade.getPlanById(queryPlanId) : this.helpfulToolsFacade.getPlan();
        if (this.selectedPlan && queryPlanId) {
            this.helpfulToolsService.setSelectedHelpfulToolsPlan$(this.selectedPlan);
        }
        this.showDrugAlternativesNudgeEnabled = this.helpfulToolsResourceFacade.getShowDrugAlternativesNudgeEnabled();
        this.helpfulToolsService
            .getCurrentTab$()
            .pipe(take(1))
            .subscribe({
            next: tabName => {
                this.initializeHelpToolsTabs();
                // If there's a value from navigation, we'll use that first, otherwise we'll use the value in the store.
                // The value in the store could be out of sync if we navigated new a new tab, due to SPA-17752 where we added a setTimeout
                // when updating the storage.
                const tabValueFromNavigation = this.activatedRoute.snapshot.queryParamMap.get('tab');
                let currentTabName = tabValueFromNavigation ?? tabName;
                if (!this.helpfulToolsTabs.find(tab => tab.name === currentTabName)) {
                    currentTabName = this.helpfulToolsTabs[0].name;
                }
                this.activeTab = currentTabName;
                this.setCurrentTab(currentTabName);
            }
        });
        this.showFormularyAndFootnotes$ = this.helpfulToolsContext.getShowFormularyAndFootnotes$();
        this.selectedDrug$ = this.helpfulToolsContext.getSelectedDrugDosageId$();
        this.selectedDrugSubscription = this.selectedDrug$.subscribe({
            next: dosageId => {
                this.setFootnotesForView(dosageId);
            }
        });
        this.subscriptions.add(this.responsiveLayoutService.isCompact$.subscribe({
            next: isMobile => {
                this.isMobile = isMobile;
                this.cdr.markForCheck();
            }
        }));
        if (this.Spa_Site_ShowDrugAlternatives_Enabled) {
            this.subscriptions.add(this.drugCabinetContext.getDrugEntry$().subscribe({
                next: drugEntry => {
                    this.cabinetForAlternatives = drugEntry?.cabinetEntry;
                    if (this.cabinetForAlternatives) {
                        this.prescriptionTabView = PrescriptionTabViewMode.ALTERNATIVES_OFF_FORMULARY_DRUGS;
                    }
                    else {
                        this.prescriptionTabView = PrescriptionTabViewMode.DEFAULT;
                    }
                    this.cdr.markForCheck();
                }
            }));
            this.subscriptions.add(combineLatest([
                this.pharmacyFacade.getSelectedPharmacy$(),
                this.pharmacyService.getAPIPharmacyInfoForPlan$(this.selectedPlan?.id)
            ]).subscribe({
                next: ([selectedPharmacy, pharmaciesForPlan]) => {
                    this.selectedPharmacy = selectedPharmacy;
                    this.selectedPlanPharmacy = this.planFacade.getPharmacy(pharmaciesForPlan, selectedPharmacy);
                    this.cdr.markForCheck();
                }
            }));
            this.subscriptions.add(combineLatest([this.helpfulToolsFacade.getSelectedPlan$(), this.drugCabinetContext.getDrugEntry$()])
                .pipe(filter(([detailedPlan, drugEntry]) => !!detailedPlan && !!drugEntry?.cabinetEntry), switchMap(([detailedPlan, { cabinetEntry: cabinetForAlternatives }]) => this.pharmacyContext.getFootnoteIdsToShow$(detailedPlan, cabinetForAlternatives.dosageID)))
                .subscribe({
                next: footnoteIdsToShow => {
                    this.footnoteIdsToShowForDrugAlternatives = footnoteIdsToShow;
                    this.cdr.markForCheck();
                }
            }));
            this.pharmacyFacade.mailOrder$.subscribe({
                next: isMailOrderSelected => {
                    this.isMailOrderSelected = isMailOrderSelected;
                    this.cdr.markForCheck();
                }
            });
            this.subscriptions.add(this.drugCabinetContext
                .getExtendedPlanWithDrugAlternatives$()
                .pipe(switchMap(extendedPlanWithDrugAlternatives => this.pharmacyContext.getFootnoteIdsToShow$(extendedPlanWithDrugAlternatives ?? this.selectedPlan)))
                .subscribe({
                next: footnoteIdsToShow => {
                    this.footnoteIdsToShowForDrugAlternatives = footnoteIdsToShow;
                    this.cdr.markForCheck();
                }
            }));
        }
        this.subscriptions.add(this.localeService.getCountryCode$.subscribe({
            next: countryCode => {
                if (countryCode) {
                    this.countryCode = countryCode;
                }
                this.cdr.markForCheck();
            }
        }));
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.drugCabinetContext.clearDrugEntry();
        this.drugCabinetContext.clearExtendedPlanWithDrugAlternatives();
        if (this.selectedDrugSubscription) {
            this.selectedDrugSubscription.unsubscribe();
        }
    }
    preProcessProperties() {
        this.initializeTranslatableText();
        this.providerFilters = [
            {
                label: this.Spa_Providers_Filter_Individuals_Text,
                value: ProviderFilterKeyType.PROVIDER_INDIVIDUAL,
                disabled: false,
                initiallyChecked: true,
                link: null
            },
            {
                label: this.Spa_Providers_Filter_Facilties_Text,
                value: ProviderFilterKeyType.PROVIDER_FACILITIES,
                disabled: false,
                initiallyChecked: true,
                link: null
            },
            {
                label: this.Spa_ValueBasedCare_Filter_Text,
                value: ProviderFilterKeyType.PROVIDER_VALUE_BASED_CARE,
                disabled: !(this.Spa_Site_ValueBasedCare_Enabled && this.Spa_Site_ValueBasedCare_Filter_Enabled),
                initiallyChecked: this.Spa_ValueBasedCare_Filter_Checked,
                link: !this.Spa_ValueBasedCare_LearnMoreLink2_Enabled && this.Spa_ValueBasedCare_LearnMoreLink_Enabled
                    ? this.Spa_ValueBasedCare_LearnMore_Text
                    : null
            }
        ];
    }
    initializeHelpToolsTabs() {
        if (this.Spa_Site_Providers_Enabled && WHITELISTED_PROVIDER_PLAN_TYPES.includes(this.selectedPlan?.planType)) {
            this.helpfulToolsTabs.push({
                title: this.Spa_Site_Providers_Text,
                name: HelpfulToolsTabs.Providers,
                id: 'helpful-provider-tab'
            });
        }
        if (!BLACKLISTED_PRESCRIPTION_PLAN_TYPES.includes(this.selectedPlan?.planType)) {
            this.helpfulToolsTabs.push({
                title: this.Spa_Site_Prescriptions_Text,
                name: HelpfulToolsTabs.Prescriptions,
                id: 'helpful-tools-prescriptions-tab'
            });
        }
        if (!BLACKLISTED_PHARMACY_PLAN_TYPES.includes(this.selectedPlan?.planType)) {
            this.helpfulToolsTabs.push({
                title: this.Spa_Site_Pharmacy_Text,
                name: HelpfulToolsTabs.Pharmacy,
                id: 'helpful-pharmacy-tab'
            });
        }
    }
    initializeTranslatableText() {
        this.helpfulToolsTabs.forEach(tab => {
            switch (tab.name) {
                case HelpfulToolsTabs.Providers:
                    tab.title = this.Spa_Site_Providers_Text;
                    break;
                case HelpfulToolsTabs.Prescriptions:
                    tab.title = this.Spa_Site_Prescriptions_Text;
                    break;
                case HelpfulToolsTabs.Pharmacy:
                    tab.title = this.Spa_Site_Pharmacy_Text;
                    break;
                default:
                    break;
            }
        });
    }
    onViewPossibleAlternativeDrugs(drugWithPlan) {
        this.planForDrugAlternatives = drugWithPlan?.plan;
        this.drugCabinetContext.setDrugEntry(drugWithPlan?.plan, drugWithPlan?.cabinet);
        this.prescriptionTabView = PrescriptionTabViewMode.ALTERNATIVES_OFF_FORMULARY_DRUGS;
        this.cdr.markForCheck();
    }
    onBackToDefaultPrescriptionTab() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_DRUG_ALTERNATIVES_PREVIOUS_PAGE);
        this.prescriptionTabView = PrescriptionTabViewMode.DEFAULT;
        this.drugCabinetContext.clearDrugEntry();
        this.drugCabinetContext.clearExtendedPlanWithDrugAlternatives();
        this.cdr.markForCheck();
    }
    fetchProvidersFromLocation(providerSearchFilter) {
        if (providerSearchFilter?.latitude &&
            providerSearchFilter?.longitude &&
            providerSearchFilter?.bounds &&
            providerSearchFilter?.distance) {
            this.providerFacade.fetchProvidersFromLocation(providerSearchFilter);
        }
    }
    /**
     * Takes zip and fips geo location data and rehydrates the helpful tools state with
     * valid zip and fips information. It required when no items are in the cart and
     * the zip and fips information is not rehydrated in session service updateSelectedMemberDetails method
     */
    rehydrateHelpfulTools() {
        const helpfulToolsZip = this.store.selectSnapshot(HelpfulToolsState.selectedZipCode);
        const helpfulToolsFips = this.store.selectSnapshot(HelpfulToolsState.selectedFipsCode);
        if (!helpfulToolsZip || !helpfulToolsFips) {
            const selectedZip = this.memberSessionService.getZipCode();
            const selectedFips = this.memberSessionService.getFipsCode();
            const helpfulToolsData = { zipCode: selectedZip, fipsCode: selectedFips };
            this.memberSessionService.rehydrateHelpfulTools(helpfulToolsData);
        }
    }
    hideFormularyAndFootnotes() {
        this.helpfulToolsContext.hideFormularyAndFootnotes();
    }
    selectTab(tab) {
        // hide formulary and footnotes if we are on Rx tab and click Pharmacy tab
        if (tab.name === HelpfulToolsTabs.Pharmacy) {
            this.hideFormularyAndFootnotes();
        }
        this.activeTab = tab.name;
        this.setCurrentTab(HelpfulToolsTabs[tab.name]);
        this.analyticsService.googleDataLayerTags = this.tagsToUpdate();
    }
    tagsToUpdate() {
        return {
            [DataLayerGlobalVariable.PAGE_TAB_NAME]: this.activeTab,
            [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
            [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE
        };
    }
    shiftFocusToTabElement(focusIndex) {
        if (this.helpfulToolsPlanDetailsTabs) {
            this.helpfulToolsPlanDetailsTabs.forEach(tabElement => tabElement.nativeElement.firstChild.setAttribute('tabindex', '-1'));
            const tabElement = this.helpfulToolsPlanDetailsTabs.find((_element, index) => index === focusIndex);
            if (tabElement) {
                tabElement.nativeElement.firstChild.setAttribute('tabindex', '0');
                tabElement.nativeElement.firstChild.focus();
            }
        }
    }
    redirectToHelpfulTool() {
        this.helpfulToolsFacade.resetPharmacy();
        this.navigationService.navigateByPageTag(this.helpfulTools);
    }
    isLiveEditMode() {
        const environment = EnvironmentService.getEnvironment();
        return environment.liveedit;
    }
    setFootnotesForView(dosageId) {
        if (dosageId && this.selectedPlan) {
            const pharmacies = this.pharmacyService.getPharmacyData();
            if (pharmacies?.length && pharmacies[0]?.vaccineAdminFee) {
                this.footnoteIds$ = this.pharmacyContext.getFootnoteIdsToShow$(this.helpfulToolsService.getPlan(), dosageId);
                this.footnoteIds$.subscribe({
                    next: footnoteIds => {
                        footnoteIds.forEach(id => (this.Spa_PlanDetails_Footnotes[id] = this.Spa_PlanDetails_Footnotes[id].replace(this.vaccineAdminFeeText, `$${pharmacies[0].vaccineAdminFee.toString()}`)));
                    }
                });
            }
        }
    }
    getFilteredFrequencyOptions() {
        return this.helpfulToolsResourceFacade.getFilteredFrequencyOptions(this.Spa_DrugSearch_Frequency_List);
    }
    setCurrentTab(tab) {
        this.helpfulToolsService.setCurrentTab(tab);
    }
};
HelpfulToolsPharmacySearchComponent.ɵfac = function HelpfulToolsPharmacySearchComponent_Factory(t) { return new (t || HelpfulToolsPharmacySearchComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService), i0.ɵɵdirectiveInject(HelpfulToolsService), i0.ɵɵdirectiveInject(HelpfulToolsContextService), i0.ɵɵdirectiveInject(HelpfulToolsResourceFacade), i0.ɵɵdirectiveInject(FootnoteFacade), i0.ɵɵdirectiveInject(HelpfulToolsFacade), i0.ɵɵdirectiveInject(PharmacyContext), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(ProviderFacade), i0.ɵɵdirectiveInject(MapFacade), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(MapContextService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.PharmacyService), i0.ɵɵdirectiveInject(DrugCabinetContext), i0.ɵɵdirectiveInject(PharmacyFacade), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute)); };
HelpfulToolsPharmacySearchComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HelpfulToolsPharmacySearchComponent, selectors: [["vnext-helpful-tools-pharmacy-search"]], viewQuery: function HelpfulToolsPharmacySearchComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1N, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.helpfulToolsPlanDetailsTabs = _t);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 14, vars: 11, consts: [["vnextGoogleTagManager", "", 1, "container", 3, "tagsToUpdate", "saveDefaultValues"], [1, "row"], [1, "col-md-12", "text-center", "backToPlans"], [3, "title", "showArrow", "alwaysUnderlined", "click"], [1, "col-md-12", "text-center"], ["class", "Spa_Style_H1 plan-name-header no-translate-block", 4, "ngIf"], [1, "col-md-12"], [4, "ngIf"], [3, "ngSwitch"], ["id", "helpful-pharmacy-tab", 3, "retrieveZipCode", "retrieveFipsCode", "addPharmacyButtonText", "pharmacyLimit", "pharmacyMapDefaultZoom", "maxZoom", "minZoom", "currentPharmacyText", "pharmacyAddedLabel", "electronicPrescriptionTooltipHeader", "electronicPrescriptionTooltipBody", "itemsPerPage", "pharmacyPaginationEnabled", "paginationText", "viewNotFoundHeaderText", "viewNotFoundBodyText", "preferredInNetworkText", "standardInNetworkText", "preferredInNetworkTooltipContent", "standardInNetworkTooltipContent", "pharmacySearchIntroText", "errorKeywordText", "addedPharmacyText", "addPharmacyText", "informationalText", "enablePharmacyInfoSection", "ePrescribingAltText", "Spa_Site_Tooltip_Text", "zipLabel", "zipErrorText", "pharmacySearchButtonText", "pharmacyNameText", "pharmacyNameHintText", "pharmacyFilterText", "isPharmacyFilterEnabled", "isPharmacyOtherFilterEnabled", "isPharmacyInNetworkFilterEnabled", "pharmacyFilterClearText", "pharmacyFilterData", "defaultFilterText", "countyLabel", "showCountyLabel", "pharmacyInNetworkFilters", "digitalPharmacyEnabled", "retailTabText", "digitalTabText", 4, "ngSwitchCase"], ["id", "helpful-tools-prescriptions-tab", 3, "plan", "footnoteIds", "footnotesHeader", "footnotes", "formularyId", "formularyContractPlanSegmentLabelPrefix", "formularyVersionText", "showContractPlanSegment", "showFootnotes", "showFormulary", "frequencyList", "contentSectionText", "dosageHeader", "quantityAndFrequencyHeader", "packageHeader", "addButtonText", "cancelButtonText", "quantityMaxLimit", "medicineCabinetLimit", "cabinetLimitErrorMessage", "quantityErrorMessage", "placeholder", "drugSearchText", "drugsImage", "inCabinetErrorMessage", "medCabinetHeader", "genericOptionIcon", "showGenericOption", "genericOptionQuestion", "genericOptionInfo", "genericOptions", "checkDrugCoverageButtonText", "genericOptionDefaultSelection", "showCosts", "drugSearchIntroText", "drugSearchPageHeaderText", "errorKeywordText", "drugSearchFrequencyListBoxLabel", "nonCoveredPrescriptions", "coveredPrescriptions", "noPrescriptionInTier", "informationalText", "editDrugText", "enablePrescriptionInfoSection", "isUseCMSDrugFlagEnabled", "showDrugAlternativesEnabled", "helpfulToolsShowDrugAlternativesNudgeEnabled", "prescriptionsDrugAlternativesButtonText", "prescriptionTabView", "selectedPlanPharmacy", "isMailOrderSelected", "selectedPharmacy", "backToPrescriptionLabelText", "hintAlternativesForCabinetHeaderText", "hintNoAlternativesForCabinet", "hintAlternativesForCabinetText", "drugCostsRetailCostText", "conditionPrescribedForText", "changeMedicalConditionsEnabled", "planForDrugAlternatives", "cabinetForAlternatives", "footnoteIdsToShowForDrugAlternatives", "drugSearchFrequencies", "drugListCardBrandText", "drugListCardGenericText", "isMobile", "viewPossibleAlternativeDrugs", "backToDefaultPrescriptionTab", 4, "ngSwitchCase"], ["id", "helpful-provider-tab", 3, "retrieveZipCode", "retrieveFipsCode", "providersText", "providersBodyText", "errorKeywordText", "zipLabel", "zipErrorText", "providerNameText", "providerNameHintText", "providerSearchButtonText", "providerLimit", "itemsPerPage", "providerPaginationEnabled", "viewNotFoundHeaderText", "viewNotFoundBodyText", "paginationText", "maxZoom", "minZoom", "providerMapDefaultZoom", "informationalText", "plan", "enableProviderInfoSection", "providerFiltersEnabled", "providerFilters", "countyLabel", "showCountyLabel", "acceptingNewPatientsIcon", "acceptingNewPatientsText", "languagesIcon", "providerLocationsText", "providerSingleSelectEnabled", "countryCode", "valueBasedCareEnabled", "valueBasedCareIcon", "valueBasedCareText", "generalPracticeOptions", "generalPracticeToolTipText", "generalPracticeLabel", "generalPracticeFilterOptionEnabled", "singleProviderInListEnabled", "updateLinkText", "editLinkText", "showEditLinkEnabled", "valueBasedCareAvailableText", "valueBasedCareLearnMoreLink", "valueBasedCareLearnMoreText", "isValueBasedCareLearnMoreLink2Enabled", "valueBasedCareToggleLabel", "valueBasedCareToggleToolTipText", "valueBasedCareToggleEnabled", "valueBasedCareToggleOptions", "newPatientToggleEnabled", "newPatientToggleOptions", "newPatientToggleLabel", "pcpToggleLabel", "pcpToggleOptions", "newPatientText", "existingPatientText", "vbcNameFilterEnabled", "vbcNameFilterLabel", "pcpToggleEnabled", "selectedProviderOptionsEnabled", "removeText", "selectAllText", "isZelisIntegrationEnabled", "fetchProvidersFromLocation", "setMapCenter", "initializeMap", "setMapDefaultBounds", "fetchProvidersFromAPI", 4, "ngSwitchCase"], [1, "Spa_Style_H1", "plan-name-header", "no-translate-block"], ["role", "tablist", 1, "tabs", "tabs-horizontal", "helpfultools-tab", "text-center"], [4, "ngFor", "ngForOf"], ["role", "presentation", 1, "tab", "Spa_Style_Gray2_Background", "Spa_Style_Primary_Color", 3, "ngClass", "click", "keyup.enter"], [3, "title", "currentIndex", "lastIndex", "isActiveTab", "ariaControlsId", "setFocusToTabEvent"], ["helpfulToolsPlanDetailsTab", ""], ["id", "helpful-pharmacy-tab", 3, "retrieveZipCode", "retrieveFipsCode", "addPharmacyButtonText", "pharmacyLimit", "pharmacyMapDefaultZoom", "maxZoom", "minZoom", "currentPharmacyText", "pharmacyAddedLabel", "electronicPrescriptionTooltipHeader", "electronicPrescriptionTooltipBody", "itemsPerPage", "pharmacyPaginationEnabled", "paginationText", "viewNotFoundHeaderText", "viewNotFoundBodyText", "preferredInNetworkText", "standardInNetworkText", "preferredInNetworkTooltipContent", "standardInNetworkTooltipContent", "pharmacySearchIntroText", "errorKeywordText", "addedPharmacyText", "addPharmacyText", "informationalText", "enablePharmacyInfoSection", "ePrescribingAltText", "Spa_Site_Tooltip_Text", "zipLabel", "zipErrorText", "pharmacySearchButtonText", "pharmacyNameText", "pharmacyNameHintText", "pharmacyFilterText", "isPharmacyFilterEnabled", "isPharmacyOtherFilterEnabled", "isPharmacyInNetworkFilterEnabled", "pharmacyFilterClearText", "pharmacyFilterData", "defaultFilterText", "countyLabel", "showCountyLabel", "pharmacyInNetworkFilters", "digitalPharmacyEnabled", "retailTabText", "digitalTabText"], ["id", "helpful-tools-prescriptions-tab", 3, "plan", "footnoteIds", "footnotesHeader", "footnotes", "formularyId", "formularyContractPlanSegmentLabelPrefix", "formularyVersionText", "showContractPlanSegment", "showFootnotes", "showFormulary", "frequencyList", "contentSectionText", "dosageHeader", "quantityAndFrequencyHeader", "packageHeader", "addButtonText", "cancelButtonText", "quantityMaxLimit", "medicineCabinetLimit", "cabinetLimitErrorMessage", "quantityErrorMessage", "placeholder", "drugSearchText", "drugsImage", "inCabinetErrorMessage", "medCabinetHeader", "genericOptionIcon", "showGenericOption", "genericOptionQuestion", "genericOptionInfo", "genericOptions", "checkDrugCoverageButtonText", "genericOptionDefaultSelection", "showCosts", "drugSearchIntroText", "drugSearchPageHeaderText", "errorKeywordText", "drugSearchFrequencyListBoxLabel", "nonCoveredPrescriptions", "coveredPrescriptions", "noPrescriptionInTier", "informationalText", "editDrugText", "enablePrescriptionInfoSection", "isUseCMSDrugFlagEnabled", "showDrugAlternativesEnabled", "helpfulToolsShowDrugAlternativesNudgeEnabled", "prescriptionsDrugAlternativesButtonText", "prescriptionTabView", "selectedPlanPharmacy", "isMailOrderSelected", "selectedPharmacy", "backToPrescriptionLabelText", "hintAlternativesForCabinetHeaderText", "hintNoAlternativesForCabinet", "hintAlternativesForCabinetText", "drugCostsRetailCostText", "conditionPrescribedForText", "changeMedicalConditionsEnabled", "planForDrugAlternatives", "cabinetForAlternatives", "footnoteIdsToShowForDrugAlternatives", "drugSearchFrequencies", "drugListCardBrandText", "drugListCardGenericText", "isMobile", "viewPossibleAlternativeDrugs", "backToDefaultPrescriptionTab"], ["id", "helpful-provider-tab", 3, "retrieveZipCode", "retrieveFipsCode", "providersText", "providersBodyText", "errorKeywordText", "zipLabel", "zipErrorText", "providerNameText", "providerNameHintText", "providerSearchButtonText", "providerLimit", "itemsPerPage", "providerPaginationEnabled", "viewNotFoundHeaderText", "viewNotFoundBodyText", "paginationText", "maxZoom", "minZoom", "providerMapDefaultZoom", "informationalText", "plan", "enableProviderInfoSection", "providerFiltersEnabled", "providerFilters", "countyLabel", "showCountyLabel", "acceptingNewPatientsIcon", "acceptingNewPatientsText", "languagesIcon", "providerLocationsText", "providerSingleSelectEnabled", "countryCode", "valueBasedCareEnabled", "valueBasedCareIcon", "valueBasedCareText", "generalPracticeOptions", "generalPracticeToolTipText", "generalPracticeLabel", "generalPracticeFilterOptionEnabled", "singleProviderInListEnabled", "updateLinkText", "editLinkText", "showEditLinkEnabled", "valueBasedCareAvailableText", "valueBasedCareLearnMoreLink", "valueBasedCareLearnMoreText", "isValueBasedCareLearnMoreLink2Enabled", "valueBasedCareToggleLabel", "valueBasedCareToggleToolTipText", "valueBasedCareToggleEnabled", "valueBasedCareToggleOptions", "newPatientToggleEnabled", "newPatientToggleOptions", "newPatientToggleLabel", "pcpToggleLabel", "pcpToggleOptions", "newPatientText", "existingPatientText", "vbcNameFilterEnabled", "vbcNameFilterLabel", "pcpToggleEnabled", "selectedProviderOptionsEnabled", "removeText", "selectAllText", "isZelisIntegrationEnabled", "fetchProvidersFromLocation", "setMapCenter", "initializeMap", "setMapDefaultBounds", "fetchProvidersFromAPI"]], template: function HelpfulToolsPharmacySearchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "vnext-link", 3);
        i0.ɵɵlistener("click", function HelpfulToolsPharmacySearchComponent_Template_vnext_link_click_3_listener() { return ctx.redirectToHelpfulTool(); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(4, "div", 1)(5, "div", 4);
        i0.ɵɵtemplate(6, HelpfulToolsPharmacySearchComponent_h1_6_Template, 2, 1, "h1", 5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 1)(8, "div", 6);
        i0.ɵɵtemplate(9, HelpfulToolsPharmacySearchComponent_div_9_Template, 3, 1, "div", 7);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "div", 8);
        i0.ɵɵtemplate(11, HelpfulToolsPharmacySearchComponent_vnext_helpful_tools_pharmacy_search_tab_11_Template, 1, 46, "vnext-helpful-tools-pharmacy-search-tab", 9);
        i0.ɵɵtemplate(12, HelpfulToolsPharmacySearchComponent_vnext_helpful_tools_prescription_search_tab_12_Template, 4, 72, "vnext-helpful-tools-prescription-search-tab", 10);
        i0.ɵɵtemplate(13, HelpfulToolsPharmacySearchComponent_vnext_helpful_tools_provider_search_tab_13_Template, 1, 65, "vnext-helpful-tools-provider-search-tab", 11);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("tagsToUpdate", ctx.tagsToUpdate())("saveDefaultValues", ctx.analyticsService.isDefaultTagToUpdate);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("title", ctx.Spa_HelpfulTools_Medicare_Plans)("showArrow", "left")("alwaysUnderlined", false);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.selectedPlan);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.helpfulToolsTabs && ctx.helpfulToolsTabs.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitch", ctx.activeTab);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.pharmacyTab);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.prescriptionsTab);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.providerTab);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, LinkComponent, GoogleTagManagerDirective, HelpfulToolsPharmacySearchTabComponent, HelpfulToolsPrescriptionSearchTabComponent, HelpfulToolsProviderSearchTabComponent, PlanDetailsTabComponent, i1$2.AsyncPipe], styles: [".backToPlans[_ngcontent-%COMP%], .plan-name-header[_ngcontent-%COMP%]{margin-top:20px}.tab[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Primary_Light);border-radius:5px 5px 0 0;display:block;padding:9px 12px;position:relative;margin:0 0 -1px 6px;text-decoration:none;outline:none;cursor:pointer;font-weight:700}.tab[_ngcontent-%COMP%]:hover, .tab.active[_ngcontent-%COMP%]{background-color:#fff}.tab.active[_ngcontent-%COMP%]{border-bottom-color:#fff}.tabs[_ngcontent-%COMP%]{margin:0;padding:0;list-style:none;display:flex;justify-content:center;align-items:flex-end}.tabs-horizontal[_ngcontent-%COMP%]   .tab.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{border-bottom-color:#fff}.helpfultools-tab.tabs[_ngcontent-%COMP%]{padding:15px 10px 0}.tabs-horizontal[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Primary_Light);border-bottom-style:solid;border-bottom-color:var(--static-Spa_Style_Primary_Light)}"], changeDetection: 0 });
__decorate([
    GlobalResource(true)
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Pharmacy_Text", void 0);
__decorate([
    GlobalResource(true)
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Providers_Text", void 0);
__decorate([
    GlobalResource(true)
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Prescriptions_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Formulary_ID_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Formulary_Plan_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Formulary_Version_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_HelpfulTools_Show_ContractPlanSegment", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_HelpfulTools_Medicare_Plans", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_PlanDetails_Footnote_Header", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_PlanDetails_Footnotes", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Pharmacy_SearchButton_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_PharmacyName_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_PharmacyName_HintText", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_Frequency_List", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_Content_Section_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_Dosage_Header", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_Frequency_Header", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_Package_Header", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_Add_Button", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_Cancel_Button", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_EditDrug_Button", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_Quantity_Max_Limit", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_Cabinet_Limit", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_MaxCount_Error_Message", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_Quantity_Error_Message", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_Hint_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_Label_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_Drugs_Image", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_InCabinetError_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_Medicine_Header", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_GenericOption_Icon", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Show_GenericDrugOption", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_GenericOption_Question", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_GenericOption_Info", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_GenericOptions", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_CheckDrugCoverageButton_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_GenericOption_Default_Selection", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugListCard_HideCosts_Flag", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_Intro_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_PageHeader_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Add_Pharmacy_Button", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Pharmacy_Limit", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_PharmacyMap_Default_Zoom", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_PharmacyMap_Max_Zoom", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_PharmacyMap_Min_Zoom", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_AddPharmacy_YourPharmacyText", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Pharmacy_Added_Label", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_ElectronicPrescription_ToolTipHeader", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_ElectronicPrescription_ToolTipBody", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Pharmacy_Not_Found_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_PharmacySearch_Pagination_ItemsPerPage", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_PharmacySearch_Pagination_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_PharmacySearch_Pagination_View_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Pharmacy_Alt_View_Not_Found_Header_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Pharmacy_Alt_View_Not_Found_Body_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Preferred_In_Network_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Standard_In_Network_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_PharmacySearch_Standard_In_Network_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_ErrorKeyword_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugSearch_Frequency_ListBox_Label", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Pharmacy_Added_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Pharmacy_Add_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_PharmacySearch_Intro_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_PrescriptionsTab_NonCovered_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_PrescriptionsTab_Covered_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_PrescriptionsTab_NotInTier_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_HelpfulTools_Prescription_Info_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_HelpfulTools_Pharmacy_Info_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_HelpfulTools_Provider_Info_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_HelpfulTools_Enable_Prescription_Info_Section", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_HelpfulTools_Enable_Pharmacy_Info_Section", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_HelpfulTools_Enable_Provider_Info_Section", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_EPrescribing_Alt_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_ZipCodeInput_ZipCodeError", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_ZipCodeInput_ZipCodeLabel", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Filter_Header_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Pharmacy_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Pharmacy_In_Network_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Pharmacy_Other_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Filter_Clear_All", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Pharmacy_Filter_Open24hrs_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Pharmacy_Filter_Eprescribing_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Pharmacy_Filter_HandicapAccess_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Pharmacy_Filter_DurableEquipment_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Pharmacy_Filter_MailOrder_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Filter_Default_Filter_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_SearchButton_Text", void 0);
__decorate([
    GlobalResource(true)
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Providers_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Provider_Limit", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_ProviderSearch_Pagination_ItemsPerPage", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_ProviderSearch_Pagination_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Provider_Alt_View_Not_Found_Header_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Provider_Alt_View_Not_Found_Body_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_ProviderSearch_Pagination_View_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_ProviderMap_Max_Zoom", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_ProviderMap_Min_Zoom", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_ProviderMap_Default_Zoom", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Providers_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Providers_Filter_Individuals_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Providers_Filter_Facilties_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Drugs_UseCMSDrugFlag_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_ValueBasedCare_Available_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_ValueBasedCare_LearnMore_Link", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_ValueBasedCare_LearnMoreLink2_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_ValueBasedCare_Toggle_Label", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_ValueBasedCare_Toggle_ToolTip_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_ValueBasedCare_Toggle_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Provider_Search_Filter_ValueBasedCare_Options", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Provider_New_Patient_Toggle_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Provider_New_Patient_Toggle_Label", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Provider_New_Patient_Options", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Primary_Care_Provider_Toggle_Label", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Primary_Care_Provider_Options", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_New_Patient_For_Provider_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Existing_Patient_For_Provider_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_ProviderName_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_ProviderName_HintText", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Providers_Body_Text", void 0);
__decorate([
    PlatformProp()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Pharmacy_Filters", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Pharmacy_In_Network_Filters", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_ShowDrugAlternatives_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Prescriptions_ShowDrugAlternatives_ViewAlternatives_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugCosts_RetailCostText", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugListCard_Brand_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_DrugListCard_Generic_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_BackToPrescriptions_Link_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_Header_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_Intro_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_NoDrugs_Empty_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_PlanDetails_StickyMiniCart_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Prescriptions_ShowDrugAlternatives_Condition_Modal_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_ShowDrugAlternatives_Change_Medical_Conditions_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Providers_AcceptingNewPatients_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Providers_AcceptingNewPatients_Icon", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Providers_Languages_Icon", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Plan_Providers_Locations_Link_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Select_Single_Provider_For_Multi_Address_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_ValueBasedCare_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_ValueBasedCare_Icon", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_ValueBasedCare_Text", void 0);
__decorate([
    GlobalResource(true)
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_ValueBasedCare_Filter_Enabled", void 0);
__decorate([
    GlobalResource(true)
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_ValueBasedCare_Filter_Text", void 0);
__decorate([
    GlobalResource(true)
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_ValueBasedCare_Filter_Checked", void 0);
__decorate([
    GlobalResource(true)
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_ValueBasedCare_LearnMore_Text", void 0);
__decorate([
    GlobalResource(true)
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_ValueBasedCare_LearnMoreLink_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Provider_Search_Filter_General_Practice_Options", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Provider_Search_General_Practice_Label_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Provider_Search_General_Practice_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Provider_Search_Filter_General_Practice_Option_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Provider_Search_ShowSingleProviderInList_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Edit_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Update_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Provider_ShowEditLink_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Provider_ValueBasedCare_Name_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Provider_ValueBasedCare_Name_Filter_Label", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Primary_Care_Provider_Toggle_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Selected_Provider_Options_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Remove_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_SelectAll_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_Digital_Pharmacy_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Pharmacy_Retail_Tab_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Pharmacy_Digital_Tab_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPharmacySearchComponent.prototype, "Spa_Site_ZelisIntegration_Enabled", void 0);
HelpfulToolsPharmacySearchComponent = __decorate([
    PlatformWidget
], HelpfulToolsPharmacySearchComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpfulToolsPharmacySearchComponent, [{
        type: Component,
        args: [{ selector: 'vnext-helpful-tools-pharmacy-search', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"container\" vnextGoogleTagManager [tagsToUpdate]=\"tagsToUpdate()\" [saveDefaultValues]=\"analyticsService.isDefaultTagToUpdate\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12 text-center backToPlans\">\r\n      <vnext-link\r\n        [title]=\"Spa_HelpfulTools_Medicare_Plans\"\r\n        [showArrow]=\"'left'\"\r\n        [alwaysUnderlined]=\"false\"\r\n        (click)=\"redirectToHelpfulTool()\"\r\n      ></vnext-link>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12 text-center\">\r\n      <h1 class=\"Spa_Style_H1 plan-name-header no-translate-block\" *ngIf=\"selectedPlan\">{{ selectedPlan?.planName }}</h1>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <div *ngIf=\"helpfulToolsTabs && helpfulToolsTabs.length\">\r\n        <ul class=\"tabs tabs-horizontal helpfultools-tab text-center\" role=\"tablist\">\r\n          <ng-container *ngFor=\"let tab of helpfulToolsTabs; index as index\">\r\n            <li\r\n              role=\"presentation\"\r\n              class=\"tab Spa_Style_Gray2_Background Spa_Style_Primary_Color\"\r\n              [ngClass]=\"{ active: activeTab === tab.name }\"\r\n              (click)=\"selectTab(tab)\"\r\n              (keyup.enter)=\"selectTab(tab)\"\r\n            >\r\n              <vnext-plan-details-tab\r\n                #helpfulToolsPlanDetailsTab\r\n                [title]=\"tab.title\"\r\n                [currentIndex]=\"index\"\r\n                [lastIndex]=\"helpfulToolsTabs.length - 1\"\r\n                [isActiveTab]=\"activeTab === tab.name\"\r\n                [ariaControlsId]=\"tab.id\"\r\n                (setFocusToTabEvent)=\"shiftFocusToTabElement($event)\"\r\n              >\r\n              </vnext-plan-details-tab>\r\n            </li>\r\n          </ng-container>\r\n        </ul>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div [ngSwitch]=\"activeTab\">\r\n    <vnext-helpful-tools-pharmacy-search-tab\r\n      *ngSwitchCase=\"pharmacyTab\"\r\n      [retrieveZipCode]=\"helpfulToolsFacade.zipCodeAction\"\r\n      [retrieveFipsCode]=\"helpfulToolsFacade.fipsCodeAction\"\r\n      [addPharmacyButtonText]=\"Spa_Add_Pharmacy_Button\"\r\n      [pharmacyLimit]=\"Spa_Pharmacy_Limit\"\r\n      [pharmacyMapDefaultZoom]=\"Spa_PharmacyMap_Default_Zoom\"\r\n      [maxZoom]=\"Spa_PharmacyMap_Max_Zoom\"\r\n      [minZoom]=\"Spa_PharmacyMap_Min_Zoom\"\r\n      [currentPharmacyText]=\"Spa_AddPharmacy_YourPharmacyText\"\r\n      [pharmacyAddedLabel]=\"Spa_Pharmacy_Added_Label\"\r\n      [electronicPrescriptionTooltipHeader]=\"Spa_Site_ElectronicPrescription_ToolTipHeader\"\r\n      [electronicPrescriptionTooltipBody]=\"Spa_Site_ElectronicPrescription_ToolTipBody\"\r\n      [itemsPerPage]=\"Spa_PharmacySearch_Pagination_ItemsPerPage\"\r\n      [pharmacyPaginationEnabled]=\"Spa_PharmacySearch_Pagination_Enabled\"\r\n      [paginationText]=\"Spa_PharmacySearch_Pagination_View_Text\"\r\n      [viewNotFoundHeaderText]=\"Spa_Pharmacy_Alt_View_Not_Found_Header_Text\"\r\n      [viewNotFoundBodyText]=\"Spa_Pharmacy_Alt_View_Not_Found_Body_Text\"\r\n      [preferredInNetworkText]=\"Spa_Site_Preferred_In_Network_Text\"\r\n      [standardInNetworkText]=\"Spa_Site_Standard_In_Network_Text\"\r\n      [preferredInNetworkTooltipContent]=\"Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text\"\r\n      [standardInNetworkTooltipContent]=\"Spa_PharmacySearch_Standard_In_Network_Tooltip_Text\"\r\n      [pharmacySearchIntroText]=\"Spa_PharmacySearch_Intro_Text\"\r\n      [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n      [addedPharmacyText]=\"Spa_Site_Pharmacy_Added_Text\"\r\n      [addPharmacyText]=\"Spa_Site_Pharmacy_Add_Text\"\r\n      [informationalText]=\"Spa_HelpfulTools_Pharmacy_Info_Text\"\r\n      [enablePharmacyInfoSection]=\"Spa_HelpfulTools_Enable_Prescription_Info_Section || isLiveEdit\"\r\n      [ePrescribingAltText]=\"Spa_Site_EPrescribing_Alt_Text\"\r\n      [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n      [zipLabel]=\"Spa_Site_ZipCodeInput_ZipCodeLabel\"\r\n      [zipErrorText]=\"Spa_Site_ZipCodeInput_ZipCodeError\"\r\n      [pharmacySearchButtonText]=\"Spa_Pharmacy_SearchButton_Text\"\r\n      [pharmacyNameText]=\"Spa_PharmacyName_Text\"\r\n      [pharmacyNameHintText]=\"Spa_PharmacyName_HintText\"\r\n      [pharmacyFilterText]=\"Spa_Filter_Header_Text\"\r\n      [isPharmacyFilterEnabled]=\"Spa_Site_Pharmacy_Filter_Enabled\"\r\n      [isPharmacyOtherFilterEnabled]=\"Spa_Site_Pharmacy_Other_Filter_Enabled\"\r\n      [isPharmacyInNetworkFilterEnabled]=\"Spa_Site_Pharmacy_In_Network_Filter_Enabled\"\r\n      [pharmacyFilterClearText]=\"Spa_Filter_Clear_All\"\r\n      [pharmacyFilterData]=\"Spa_Pharmacy_Filters\"\r\n      [defaultFilterText]=\"Spa_Filter_Default_Filter_Text\"\r\n      [countyLabel]=\"Spa_ZipCodeInput_CountyLabel_Text\"\r\n      [showCountyLabel]=\"Spa_ZipCodeInput_CountyLabel_Enabled\"\r\n      [pharmacyInNetworkFilters]=\"Spa_Pharmacy_In_Network_Filters\"\r\n      [digitalPharmacyEnabled]=\"Spa_Site_Digital_Pharmacy_Enabled\"\r\n      [retailTabText]=\"Spa_Pharmacy_Retail_Tab_Text\"\r\n      [digitalTabText]=\"Spa_Pharmacy_Digital_Tab_Text\"\r\n      id=\"helpful-pharmacy-tab\"\r\n    ></vnext-helpful-tools-pharmacy-search-tab>\r\n    <vnext-helpful-tools-prescription-search-tab\r\n      *ngSwitchCase=\"prescriptionsTab\"\r\n      [plan]=\"selectedPlan\"\r\n      [footnoteIds]=\"footnoteIds$ | async\"\r\n      [footnotesHeader]=\"Spa_PlanDetails_Footnote_Header\"\r\n      [footnotes]=\"Spa_PlanDetails_Footnotes\"\r\n      [formularyId]=\"Spa_Site_Formulary_ID_Text\"\r\n      [formularyContractPlanSegmentLabelPrefix]=\"Spa_Site_Formulary_Plan_Text\"\r\n      [formularyVersionText]=\"Spa_Site_Formulary_Version_Text\"\r\n      [showContractPlanSegment]=\"Spa_HelpfulTools_Show_ContractPlanSegment\"\r\n      [showFootnotes]=\"showFormularyAndFootnotes$ | async\"\r\n      [showFormulary]=\"showFormularyAndFootnotes$ | async\"\r\n      [frequencyList]=\"drugSearchFrequencyList\"\r\n      [contentSectionText]=\"Spa_DrugSearch_Content_Section_Text\"\r\n      [dosageHeader]=\"Spa_DrugSearch_Dosage_Header\"\r\n      [quantityAndFrequencyHeader]=\"Spa_DrugSearch_Frequency_Header\"\r\n      [packageHeader]=\"Spa_DrugSearch_Package_Header\"\r\n      [addButtonText]=\"Spa_DrugSearch_Add_Button\"\r\n      [cancelButtonText]=\"Spa_DrugSearch_Cancel_Button\"\r\n      [quantityMaxLimit]=\"Spa_DrugSearch_Quantity_Max_Limit\"\r\n      [medicineCabinetLimit]=\"Spa_DrugSearch_Cabinet_Limit\"\r\n      [cabinetLimitErrorMessage]=\"Spa_DrugSearch_MaxCount_Error_Message\"\r\n      [quantityErrorMessage]=\"Spa_DrugSearch_Quantity_Error_Message\"\r\n      [placeholder]=\"Spa_DrugSearch_Hint_Text\"\r\n      [drugSearchText]=\"Spa_DrugSearch_Label_Text\"\r\n      [drugsImage]=\"Spa_DrugSearch_Drugs_Image\"\r\n      [inCabinetErrorMessage]=\"Spa_DrugSearch_InCabinetError_Text\"\r\n      [medCabinetHeader]=\"Spa_DrugSearch_Medicine_Header\"\r\n      [genericOptionIcon]=\"Spa_DrugSearch_GenericOption_Icon\"\r\n      [showGenericOption]=\"Spa_Site_Show_GenericDrugOption\"\r\n      [genericOptionQuestion]=\"Spa_DrugSearch_GenericOption_Question\"\r\n      [genericOptionInfo]=\"Spa_DrugSearch_GenericOption_Info\"\r\n      [genericOptions]=\"Spa_DrugSearch_GenericOptions\"\r\n      [checkDrugCoverageButtonText]=\"Spa_DrugSearch_CheckDrugCoverageButton_Text\"\r\n      [genericOptionDefaultSelection]=\"Spa_DrugSearch_GenericOption_Default_Selection\"\r\n      [showCosts]=\"Spa_DrugListCard_HideCosts_Flag\"\r\n      [drugSearchIntroText]=\"Spa_DrugSearch_Intro_Text\"\r\n      [drugSearchPageHeaderText]=\"Spa_DrugSearch_PageHeader_Text\"\r\n      [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n      [drugSearchFrequencyListBoxLabel]=\"Spa_DrugSearch_Frequency_ListBox_Label\"\r\n      [nonCoveredPrescriptions]=\"Spa_PrescriptionsTab_NonCovered_Text\"\r\n      [coveredPrescriptions]=\"Spa_PrescriptionsTab_Covered_Text\"\r\n      [noPrescriptionInTier]=\"Spa_PrescriptionsTab_NotInTier_Text\"\r\n      [informationalText]=\"Spa_HelpfulTools_Prescription_Info_Text\"\r\n      [editDrugText]=\"Spa_DrugSearch_EditDrug_Button\"\r\n      [enablePrescriptionInfoSection]=\"Spa_HelpfulTools_Enable_Prescription_Info_Section || isLiveEdit\"\r\n      [isUseCMSDrugFlagEnabled]=\"Spa_Drugs_UseCMSDrugFlag_Enabled\"\r\n      id=\"helpful-tools-prescriptions-tab\"\r\n      [showDrugAlternativesEnabled]=\"Spa_Site_ShowDrugAlternatives_Enabled\"\r\n      [helpfulToolsShowDrugAlternativesNudgeEnabled]=\"showDrugAlternativesNudgeEnabled\"\r\n      [prescriptionsDrugAlternativesButtonText]=\"Spa_Prescriptions_ShowDrugAlternatives_ViewAlternatives_Text\"\r\n      [prescriptionTabView]=\"prescriptionTabView\"\r\n      [selectedPlanPharmacy]=\"selectedPlanPharmacy\"\r\n      [isMailOrderSelected]=\"isMailOrderSelected\"\r\n      [selectedPharmacy]=\"selectedPharmacy\"\r\n      [backToPrescriptionLabelText]=\"Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_BackToPrescriptions_Link_Text\"\r\n      [hintAlternativesForCabinetHeaderText]=\"Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_Header_Text\"\r\n      [hintNoAlternativesForCabinet]=\"Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_NoDrugs_Empty_Text\"\r\n      [hintAlternativesForCabinetText]=\"Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_Intro_Text\"\r\n      [drugCostsRetailCostText]=\"Spa_DrugCosts_RetailCostText\"\r\n      [conditionPrescribedForText]=\"Spa_Prescriptions_ShowDrugAlternatives_Condition_Modal_Text\"\r\n      [changeMedicalConditionsEnabled]=\"Spa_Site_ShowDrugAlternatives_Change_Medical_Conditions_Enabled\"\r\n      [planForDrugAlternatives]=\"planForDrugAlternatives\"\r\n      [cabinetForAlternatives]=\"cabinetForAlternatives\"\r\n      [footnoteIdsToShowForDrugAlternatives]=\"footnoteIdsToShowForDrugAlternatives\"\r\n      [drugSearchFrequencies]=\"Spa_DrugSearch_Frequency_List\"\r\n      [drugListCardBrandText]=\"Spa_DrugListCard_Brand_Text\"\r\n      [drugListCardGenericText]=\"Spa_DrugListCard_Generic_Text\"\r\n      [isMobile]=\"isMobile\"\r\n      (viewPossibleAlternativeDrugs)=\"onViewPossibleAlternativeDrugs($event)\"\r\n      (backToDefaultPrescriptionTab)=\"onBackToDefaultPrescriptionTab()\"\r\n    >\r\n    </vnext-helpful-tools-prescription-search-tab>\r\n    <vnext-helpful-tools-provider-search-tab\r\n      *ngSwitchCase=\"providerTab\"\r\n      id=\"helpful-provider-tab\"\r\n      [retrieveZipCode]=\"helpfulToolsFacade.zipCodeAction\"\r\n      [retrieveFipsCode]=\"helpfulToolsFacade.fipsCodeAction\"\r\n      [providersText]=\"Spa_Site_Providers_Text\"\r\n      [providersBodyText]=\"Spa_Site_Providers_Body_Text\"\r\n      [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n      [zipLabel]=\"Spa_Site_ZipCodeInput_ZipCodeLabel\"\r\n      [zipErrorText]=\"Spa_Site_ZipCodeInput_ZipCodeError\"\r\n      [providerNameText]=\"Spa_ProviderName_Text\"\r\n      [providerNameHintText]=\"Spa_ProviderName_HintText\"\r\n      [providerSearchButtonText]=\"Spa_Site_SearchButton_Text\"\r\n      [providerLimit]=\"Spa_Provider_Limit\"\r\n      [itemsPerPage]=\"Spa_ProviderSearch_Pagination_ItemsPerPage\"\r\n      [providerPaginationEnabled]=\"Spa_ProviderSearch_Pagination_Enabled\"\r\n      [viewNotFoundHeaderText]=\"Spa_Provider_Alt_View_Not_Found_Header_Text\"\r\n      [viewNotFoundBodyText]=\"Spa_Provider_Alt_View_Not_Found_Body_Text\"\r\n      [paginationText]=\"Spa_ProviderSearch_Pagination_View_Text\"\r\n      [maxZoom]=\"Spa_ProviderMap_Max_Zoom\"\r\n      [minZoom]=\"Spa_ProviderMap_Min_Zoom\"\r\n      [providerMapDefaultZoom]=\"Spa_ProviderMap_Default_Zoom\"\r\n      [informationalText]=\"Spa_HelpfulTools_Provider_Info_Text\"\r\n      [plan]=\"selectedPlan\"\r\n      [enableProviderInfoSection]=\"Spa_HelpfulTools_Enable_Provider_Info_Section || isLiveEdit\"\r\n      [providerFiltersEnabled]=\"Spa_Providers_Filter_Enabled\"\r\n      [providerFilters]=\"providerFilters\"\r\n      [countyLabel]=\"Spa_ZipCodeInput_CountyLabel_Text\"\r\n      [showCountyLabel]=\"Spa_ZipCodeInput_CountyLabel_Enabled\"\r\n      [acceptingNewPatientsIcon]=\"Spa_Providers_AcceptingNewPatients_Icon\"\r\n      [acceptingNewPatientsText]=\"Spa_Providers_AcceptingNewPatients_Text\"\r\n      [languagesIcon]=\"Spa_Providers_Languages_Icon\"\r\n      [providerLocationsText]=\"Spa_Plan_Providers_Locations_Link_Text\"\r\n      [providerSingleSelectEnabled]=\"Spa_Select_Single_Provider_For_Multi_Address_Enabled\"\r\n      [countryCode]=\"countryCode\"\r\n      [valueBasedCareEnabled]=\"Spa_Site_ValueBasedCare_Enabled\"\r\n      [valueBasedCareIcon]=\"Spa_Site_ValueBasedCare_Icon\"\r\n      [valueBasedCareText]=\"Spa_Site_ValueBasedCare_Text\"\r\n      [generalPracticeOptions]=\"Spa_Provider_Search_Filter_General_Practice_Options\"\r\n      [generalPracticeToolTipText]=\"Spa_Provider_Search_General_Practice_Tooltip_Text\"\r\n      [generalPracticeLabel]=\"Spa_Provider_Search_General_Practice_Label_Text\"\r\n      [generalPracticeFilterOptionEnabled]=\"Spa_Provider_Search_Filter_General_Practice_Option_Enabled\"\r\n      [singleProviderInListEnabled]=\"Spa_Provider_Search_ShowSingleProviderInList_Enabled\"\r\n      [updateLinkText]=\"Spa_Site_Update_Text\"\r\n      [editLinkText]=\"Spa_Site_Edit_Text\"\r\n      [showEditLinkEnabled]=\"Spa_Provider_ShowEditLink_Enabled\"\r\n      [valueBasedCareAvailableText]=\"Spa_ValueBasedCare_Available_Text\"\r\n      [valueBasedCareLearnMoreLink]=\"Spa_ValueBasedCare_LearnMore_Link\"\r\n      [valueBasedCareLearnMoreText]=\"Spa_ValueBasedCare_LearnMore_Text\"\r\n      [isValueBasedCareLearnMoreLink2Enabled]=\"Spa_ValueBasedCare_LearnMoreLink2_Enabled && Spa_Site_ValueBasedCare_Enabled\"\r\n      [valueBasedCareToggleLabel]=\"Spa_ValueBasedCare_Toggle_Label\"\r\n      [valueBasedCareToggleToolTipText]=\"Spa_ValueBasedCare_Toggle_ToolTip_Text\"\r\n      [valueBasedCareToggleEnabled]=\"Spa_ValueBasedCare_Toggle_Enabled && Spa_Site_ValueBasedCare_Enabled\"\r\n      [valueBasedCareToggleOptions]=\"Spa_Provider_Search_Filter_ValueBasedCare_Options\"\r\n      [newPatientToggleEnabled]=\"Spa_Provider_New_Patient_Toggle_Enabled\"\r\n      [newPatientToggleOptions]=\"Spa_Provider_New_Patient_Options\"\r\n      [newPatientToggleLabel]=\"Spa_Provider_New_Patient_Toggle_Label\"\r\n      [pcpToggleLabel]=\"Spa_Primary_Care_Provider_Toggle_Label\"\r\n      [pcpToggleOptions]=\"Spa_Primary_Care_Provider_Options\"\r\n      [newPatientText]=\"Spa_New_Patient_For_Provider_Text\"\r\n      [existingPatientText]=\"Spa_Existing_Patient_For_Provider_Text\"\r\n      [vbcNameFilterEnabled]=\"Spa_Provider_ValueBasedCare_Name_Filter_Enabled\"\r\n      [vbcNameFilterLabel]=\"Spa_Provider_ValueBasedCare_Name_Filter_Label\"\r\n      [pcpToggleEnabled]=\"Spa_Primary_Care_Provider_Toggle_Enabled\"\r\n      [selectedProviderOptionsEnabled]=\"Spa_Selected_Provider_Options_Enabled\"\r\n      [removeText]=\"Spa_Site_Remove_Text\"\r\n      [selectAllText]=\"Spa_Site_SelectAll_Text\"\r\n      [isZelisIntegrationEnabled]=\"Spa_Site_ZelisIntegration_Enabled\"\r\n      (fetchProvidersFromLocation)=\"fetchProvidersFromLocation($event)\"\r\n      (setMapCenter)=\"mapFacade.setCenterPosition($event)\"\r\n      (initializeMap)=\"mapFacade.initializeMap($event)\"\r\n      (setMapDefaultBounds)=\"mapContextService.setDefaultBounds($event)\"\r\n      (fetchProvidersFromAPI)=\"providerFacade.fetchProvidersFromAPI($event)\"\r\n    >\r\n    </vnext-helpful-tools-provider-search-tab>\r\n  </div>\r\n</div>\r\n", styles: [".backToPlans,.plan-name-header{margin-top:20px}.tab{border:1px solid var(--static-Spa_Style_Primary_Light);border-radius:5px 5px 0 0;display:block;padding:9px 12px;position:relative;margin:0 0 -1px 6px;text-decoration:none;outline:none;cursor:pointer;font-weight:700}.tab:hover,.tab.active{background-color:#fff}.tab.active{border-bottom-color:#fff}.tabs{margin:0;padding:0;list-style:none;display:flex;justify-content:center;align-items:flex-end}.tabs-horizontal .tab.active>a{border-bottom-color:#fff}.helpfultools-tab.tabs{padding:15px 10px 0}.tabs-horizontal{border-bottom:1px solid var(--static-Spa_Style_Primary_Light);border-bottom-style:solid;border-bottom-color:var(--static-Spa_Style_Primary_Light)}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.ResponsiveLayoutService }, { type: HelpfulToolsService }, { type: HelpfulToolsContextService }, { type: HelpfulToolsResourceFacade }, { type: FootnoteFacade }, { type: HelpfulToolsFacade }, { type: PharmacyContext }, { type: i2$1.Router }, { type: AnalyticsService }, { type: ProviderFacade }, { type: MapFacade }, { type: i1.NavigationService }, { type: MapContextService }, { type: i1.MemberSessionService }, { type: i2.Store }, { type: i1.PharmacyService }, { type: DrugCabinetContext }, { type: PharmacyFacade }, { type: PlanFacade }, { type: i1.LocaleService }, { type: i2$1.ActivatedRoute }]; }, { helpfulToolsPlanDetailsTabs: [{
            type: ViewChildren,
            args: ['helpfulToolsPlanDetailsTab', { read: ElementRef }]
        }], Spa_Site_Pharmacy_Text: [], Spa_Site_Providers_Text: [], Spa_Site_Prescriptions_Text: [], Spa_Site_Formulary_ID_Text: [], Spa_Site_Formulary_Plan_Text: [], Spa_Site_Formulary_Version_Text: [], Spa_HelpfulTools_Show_ContractPlanSegment: [], Spa_HelpfulTools_Medicare_Plans: [], Spa_PlanDetails_Footnote_Header: [], Spa_PlanDetails_Footnotes: [], Spa_Pharmacy_SearchButton_Text: [], Spa_PharmacyName_Text: [], Spa_PharmacyName_HintText: [], Spa_DrugSearch_Frequency_List: [], Spa_DrugSearch_Content_Section_Text: [], Spa_DrugSearch_Dosage_Header: [], Spa_DrugSearch_Frequency_Header: [], Spa_DrugSearch_Package_Header: [], Spa_DrugSearch_Add_Button: [], Spa_DrugSearch_Cancel_Button: [], Spa_DrugSearch_EditDrug_Button: [], Spa_DrugSearch_Quantity_Max_Limit: [], Spa_DrugSearch_Cabinet_Limit: [], Spa_DrugSearch_MaxCount_Error_Message: [], Spa_DrugSearch_Quantity_Error_Message: [], Spa_DrugSearch_Hint_Text: [], Spa_DrugSearch_Label_Text: [], Spa_DrugSearch_Drugs_Image: [], Spa_DrugSearch_InCabinetError_Text: [], Spa_DrugSearch_Medicine_Header: [], Spa_DrugSearch_GenericOption_Icon: [], Spa_Site_Show_GenericDrugOption: [], Spa_DrugSearch_GenericOption_Question: [], Spa_DrugSearch_GenericOption_Info: [], Spa_DrugSearch_GenericOptions: [], Spa_DrugSearch_CheckDrugCoverageButton_Text: [], Spa_DrugSearch_GenericOption_Default_Selection: [], Spa_DrugListCard_HideCosts_Flag: [], Spa_DrugSearch_Intro_Text: [], Spa_DrugSearch_PageHeader_Text: [], Spa_Add_Pharmacy_Button: [], Spa_Pharmacy_Limit: [], Spa_PharmacyMap_Default_Zoom: [], Spa_PharmacyMap_Max_Zoom: [], Spa_PharmacyMap_Min_Zoom: [], Spa_AddPharmacy_YourPharmacyText: [], Spa_Pharmacy_Added_Label: [], Spa_Site_ElectronicPrescription_ToolTipHeader: [], Spa_Site_ElectronicPrescription_ToolTipBody: [], Spa_Pharmacy_Not_Found_Text: [], Spa_PharmacySearch_Pagination_ItemsPerPage: [], Spa_PharmacySearch_Pagination_Enabled: [], Spa_PharmacySearch_Pagination_View_Text: [], Spa_Pharmacy_Alt_View_Not_Found_Header_Text: [], Spa_Pharmacy_Alt_View_Not_Found_Body_Text: [], Spa_Site_Preferred_In_Network_Text: [], Spa_Site_Standard_In_Network_Text: [], Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text: [], Spa_PharmacySearch_Standard_In_Network_Tooltip_Text: [], Spa_Site_ErrorKeyword_Text: [], Spa_DrugSearch_Frequency_ListBox_Label: [], Spa_Site_Pharmacy_Added_Text: [], Spa_Site_Pharmacy_Add_Text: [], Spa_PharmacySearch_Intro_Text: [], Spa_PrescriptionsTab_NonCovered_Text: [], Spa_PrescriptionsTab_Covered_Text: [], Spa_PrescriptionsTab_NotInTier_Text: [], Spa_HelpfulTools_Prescription_Info_Text: [], Spa_HelpfulTools_Pharmacy_Info_Text: [], Spa_HelpfulTools_Provider_Info_Text: [], Spa_HelpfulTools_Enable_Prescription_Info_Section: [], Spa_HelpfulTools_Enable_Pharmacy_Info_Section: [], Spa_HelpfulTools_Enable_Provider_Info_Section: [], Spa_Site_EPrescribing_Alt_Text: [], Spa_Site_Tooltip_Text: [], Spa_Site_ZipCodeInput_ZipCodeError: [], Spa_Site_ZipCodeInput_ZipCodeLabel: [], Spa_Filter_Header_Text: [], Spa_Site_Pharmacy_Filter_Enabled: [], Spa_Site_Pharmacy_In_Network_Filter_Enabled: [], Spa_Site_Pharmacy_Other_Filter_Enabled: [], Spa_Filter_Clear_All: [], Spa_Pharmacy_Filter_Open24hrs_Text: [], Spa_Pharmacy_Filter_Eprescribing_Text: [], Spa_Pharmacy_Filter_HandicapAccess_Text: [], Spa_Pharmacy_Filter_DurableEquipment_Text: [], Spa_Pharmacy_Filter_MailOrder_Text: [], Spa_Filter_Default_Filter_Text: [], Spa_Site_SearchButton_Text: [], Spa_Site_Providers_Enabled: [], Spa_Provider_Limit: [], Spa_ProviderSearch_Pagination_ItemsPerPage: [], Spa_ProviderSearch_Pagination_Enabled: [], Spa_Provider_Alt_View_Not_Found_Header_Text: [], Spa_Provider_Alt_View_Not_Found_Body_Text: [], Spa_ProviderSearch_Pagination_View_Text: [], Spa_ProviderMap_Max_Zoom: [], Spa_ProviderMap_Min_Zoom: [], Spa_ProviderMap_Default_Zoom: [], Spa_Providers_Filter_Enabled: [], Spa_Providers_Filter_Individuals_Text: [], Spa_Providers_Filter_Facilties_Text: [], Spa_ZipCodeInput_CountyLabel_Text: [], Spa_ZipCodeInput_CountyLabel_Enabled: [], Spa_Drugs_UseCMSDrugFlag_Enabled: [], Spa_ValueBasedCare_Available_Text: [], Spa_ValueBasedCare_LearnMore_Link: [], Spa_ValueBasedCare_LearnMoreLink2_Enabled: [], Spa_ValueBasedCare_Toggle_Label: [], Spa_ValueBasedCare_Toggle_ToolTip_Text: [], Spa_ValueBasedCare_Toggle_Enabled: [], Spa_Provider_Search_Filter_ValueBasedCare_Options: [], Spa_Provider_New_Patient_Toggle_Enabled: [], Spa_Provider_New_Patient_Toggle_Label: [], Spa_Provider_New_Patient_Options: [], Spa_Primary_Care_Provider_Toggle_Label: [], Spa_Primary_Care_Provider_Options: [], Spa_New_Patient_For_Provider_Text: [], Spa_Existing_Patient_For_Provider_Text: [], Spa_ProviderName_Text: [], Spa_ProviderName_HintText: [], Spa_Site_Providers_Body_Text: [], Spa_Pharmacy_Filters: [], Spa_Pharmacy_In_Network_Filters: [], Spa_Site_ShowDrugAlternatives_Enabled: [], Spa_Prescriptions_ShowDrugAlternatives_ViewAlternatives_Text: [], Spa_DrugCosts_RetailCostText: [], Spa_DrugListCard_Brand_Text: [], Spa_DrugListCard_Generic_Text: [], Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_BackToPrescriptions_Link_Text: [], Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_Header_Text: [], Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_Intro_Text: [], Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_NoDrugs_Empty_Text: [], Spa_PlanDetails_StickyMiniCart_Enabled: [], Spa_Prescriptions_ShowDrugAlternatives_Condition_Modal_Text: [], Spa_Site_ShowDrugAlternatives_Change_Medical_Conditions_Enabled: [], Spa_Providers_AcceptingNewPatients_Text: [], Spa_Providers_AcceptingNewPatients_Icon: [], Spa_Providers_Languages_Icon: [], Spa_Plan_Providers_Locations_Link_Text: [], Spa_Select_Single_Provider_For_Multi_Address_Enabled: [], Spa_Site_ValueBasedCare_Enabled: [], Spa_Site_ValueBasedCare_Icon: [], Spa_Site_ValueBasedCare_Text: [], Spa_Site_ValueBasedCare_Filter_Enabled: [], Spa_ValueBasedCare_Filter_Text: [], Spa_ValueBasedCare_Filter_Checked: [], Spa_ValueBasedCare_LearnMore_Text: [], Spa_ValueBasedCare_LearnMoreLink_Enabled: [], Spa_Provider_Search_Filter_General_Practice_Options: [], Spa_Provider_Search_General_Practice_Label_Text: [], Spa_Provider_Search_General_Practice_Tooltip_Text: [], Spa_Provider_Search_Filter_General_Practice_Option_Enabled: [], Spa_Provider_Search_ShowSingleProviderInList_Enabled: [], Spa_Site_Edit_Text: [], Spa_Site_Update_Text: [], Spa_Provider_ShowEditLink_Enabled: [], Spa_Provider_ValueBasedCare_Name_Filter_Enabled: [], Spa_Provider_ValueBasedCare_Name_Filter_Label: [], Spa_Primary_Care_Provider_Toggle_Enabled: [], Spa_Selected_Provider_Options_Enabled: [], Spa_Site_Remove_Text: [], Spa_Site_SelectAll_Text: [], Spa_Site_Digital_Pharmacy_Enabled: [], Spa_Pharmacy_Retail_Tab_Text: [], Spa_Pharmacy_Digital_Tab_Text: [], Spa_Site_ZelisIntegration_Enabled: [] }); })();

class HelpfulToolsPlanCardFacade {
    constructor(planFacade, helpfulToolsResourceFacade) {
        this.planFacade = planFacade;
        this.helpfulToolsResourceFacade = helpfulToolsResourceFacade;
    }
    getExtraDataValueByName(plan, name, defaultValue) {
        return this.planFacade.getExtraDataValueByName(plan, name, defaultValue);
    }
    getPlanImageAltText(plan) {
        return plan.logo2Description;
    }
    getPlanLogo(plan) {
        return this.planFacade.getPlanLogoUrl(plan);
    }
    showProviderSearchLink(plan) {
        return this.isMedicareAdvantagePartD(plan) || this.isMedicareAdvantage(plan);
    }
    isHelpfulToolsProviderSearchEnabled(widgetName) {
        // is Spa_HelpfulTools_Show_Provider enabled (widget level)
        return this.helpfulToolsResourceFacade.getShowProvider(widgetName);
    }
    getProviderSearchEnabled() {
        // determines if Spa_Site_Providers_Enabled is enabled (site level)
        return this.helpfulToolsResourceFacade.getProviderSearchEnabled();
    }
    getShowPharmacyLink(plan) {
        return this.isMedicarePartD(plan) || this.isMedicareAdvantagePartD(plan);
    }
    getShowPresciptionsLink(plan) {
        return this.isMedicarePartD(plan) || this.isMedicareAdvantagePartD(plan);
    }
    getIsMedicareAdvantage(plan) {
        return this.isMedicareAdvantage(plan);
    }
    hasProviderUrl(plan) {
        return plan.providerURL && plan.providerURL.length > 0;
    }
    isMedicareAdvantage(plan) {
        return this.isPlanType(plan, PlanTypeAbbreviation.MA);
    }
    isMedicareAdvantagePartD(plan) {
        return this.isPlanType(plan, PlanTypeAbbreviation.MAPD);
    }
    isMedicarePartD(plan) {
        return this.isPlanType(plan, PlanTypeAbbreviation.PDP);
    }
    isPlanType(plan, type) {
        return plan.planTypeAbbreviation === type;
    }
}
HelpfulToolsPlanCardFacade.ɵfac = function HelpfulToolsPlanCardFacade_Factory(t) { return new (t || HelpfulToolsPlanCardFacade)(i0.ɵɵinject(PlanFacade), i0.ɵɵinject(HelpfulToolsResourceFacade)); };
HelpfulToolsPlanCardFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HelpfulToolsPlanCardFacade, factory: HelpfulToolsPlanCardFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpfulToolsPlanCardFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: PlanFacade }, { type: HelpfulToolsResourceFacade }]; }, null); })();

function HelpfulToolsPlanCardComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵelement(2, "vnext-plan-logo", 16);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("alternateText", ctx_r0.planImageAltText)("imageSrc", ctx_r0.planLogo)("classNames", "plan-logo")("planLogoSize", ctx_r0.planLogoSize);
} }
function HelpfulToolsPlanCardComponent_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span", 17)(2, "vnext-link", 18);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", ctx_r1.Spa_HelpfulTools_FindDentists_Link_Text)("href", ctx_r1.dentistUrl);
} }
function HelpfulToolsPlanCardComponent_ng_container_15_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span", 19)(2, "vnext-link", 18);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", ctx_r5.Spa_HelpfulTools_FindProviders_Link_Text)("href", ctx_r5.plan.providerURL);
} }
function HelpfulToolsPlanCardComponent_ng_container_15_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span", 19)(2, "vnext-helpful-tools-link", 20);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("linkText", ctx_r6.Spa_HelpfulTools_FindProviders_Link_Text)("linkNavigate", ctx_r6.onProvidersClick);
} }
function HelpfulToolsPlanCardComponent_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HelpfulToolsPlanCardComponent_ng_container_15_ng_container_1_Template, 3, 2, "ng-container", 12);
    i0.ɵɵtemplate(2, HelpfulToolsPlanCardComponent_ng_container_15_ng_container_2_Template, 3, 2, "ng-container", 12);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.showExternalProvidersLink());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.showInternalProvidersLink());
} }
function HelpfulToolsPlanCardComponent_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span", 21)(2, "vnext-helpful-tools-link", 22);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("linkText", ctx_r3.Spa_HelpfulTools_FindPrescriptions_Link_Text)("linkNavigate", ctx_r3.onPrescriptionsClick)("href", ctx_r3.Spa_HelpfulTools_FindPrescriptions_Url[0] == null ? null : ctx_r3.Spa_HelpfulTools_FindPrescriptions_Url[0].href)("isExternalRedirect", ctx_r3.Spa_HelpfulTools_ExternalPrescriptionsEnabled);
} }
function HelpfulToolsPlanCardComponent_ng_container_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "span", 23)(2, "vnext-helpful-tools-link", 22);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("linkText", ctx_r4.Spa_HelpfulTools_FindPharmacy_Link_Text)("linkNavigate", ctx_r4.onPharmacyClick)("href", ctx_r4.Spa_HelpfulTools_FindPharmacy_Url[0] == null ? null : ctx_r4.Spa_HelpfulTools_FindPharmacy_Url[0].href)("isExternalRedirect", ctx_r4.Spa_HelpfulTools_ExternalPharmacyEnabled);
} }
const _c0$1M = function (a0) { return { "order-3": a0 }; };
class HelpfulToolsPlanCardComponent {
    constructor(planCardFacade, helpfulToolsService, navigationService, navigationUtilityService) {
        this.planCardFacade = planCardFacade;
        this.helpfulToolsService = helpfulToolsService;
        this.navigationService = navigationService;
        this.navigationUtilityService = navigationUtilityService;
        this.Spa_Site_Show_PlanLogo = true;
        this.Spa_HelpfulTools_ExternalPharmacyEnabled = false;
        this.Spa_HelpfulTools_ExternalPrescriptionsEnabled = false;
        this.Spa_HelpfulTools_FindPrescriptions_Url = [{ target: '_self', href: '', tag: PageTags.HELPFUL_TOOLS_PHARMACYSEARCH }];
        this.Spa_HelpfulTools_FindPharmacy_Url = [{ target: '_self', href: '', tag: PageTags.HELPFUL_TOOLS_PHARMACYSEARCH }];
        this.Spa_HelpfulTools_FindProviders_Link_Text = 'Find providers';
        this.Spa_HelpfulTools_FindPrescriptions_Link_Text = 'Find prescriptions';
        this.Spa_HelpfulTools_FindPharmacy_Link_Text = 'Find pharmacy';
        this.CSNPEnabled = false;
        this.DSNPEnabled = false;
        this.ISNPEnabled = false;
        this.CSNPText = '';
        this.DSNPText = '';
        this.ISNPText = '';
        this.SNPText = '<snpType> Plan';
        this.isMedicareAdvantage = false;
        this.showDentistsLink = false;
        this.dentitstLinkIdentifierText = 'FindDentistLink';
        this.onPrescriptionsClick = () => {
            this.helpfulToolsService.setCurrentTab(HelpfulToolsTabs.Prescriptions);
            this.setSelectedPlanAndNavigate();
        };
        this.onPharmacyClick = () => {
            this.helpfulToolsService.setCurrentTab(HelpfulToolsTabs.Pharmacy);
            this.setSelectedPlanAndNavigate();
        };
        this.onProvidersClick = () => {
            this.helpfulToolsService.setCurrentTab(HelpfulToolsTabs.Providers);
            this.setSelectedPlanAndNavigate();
        };
    }
    ngOnInit() {
        this.isMedicareAdvantage = this.planCardFacade.getIsMedicareAdvantage(this.plan);
        this.isHelpfulToolsProviderSearchEnabled = this.planCardFacade.isHelpfulToolsProviderSearchEnabled();
        this.showProviderSearchLink = this.planCardFacade.showProviderSearchLink(this.plan);
        this.showPharmacyLink = this.planCardFacade.getShowPharmacyLink(this.plan);
        this.showPrescriptionsLink = this.planCardFacade.getShowPresciptionsLink(this.plan);
        this.planImageAltText = this.planCardFacade.getPlanImageAltText(this.plan);
        this.planLogo = this.planCardFacade.getPlanLogo(this.plan);
        if (this.Spa_HelpfulTools_FindDentists_Link_Enabled) {
            const dentistUrl = this.planCardFacade.getExtraDataValueByName(this.plan, PlanExtraDataKey.FIND_DENTIST_LINK);
            if (dentistUrl && this.navigationUtilityService.isValidUrl(dentistUrl)) {
                this.dentistUrl = dentistUrl;
                this.showDentistsLink = true;
            }
        }
    }
    get showPlanLogo() {
        return this.planLogo && this.Spa_Site_Show_PlanLogo;
    }
    showInternalProvidersLink() {
        return this.planCardFacade.getProviderSearchEnabled() && this.plan.showProviderSearch;
    }
    showExternalProvidersLink() {
        return (this.plan.providerURL &&
            this.plan.providerURL.length > 0 &&
            (!this.planCardFacade.getProviderSearchEnabled() || !this.plan.showProviderSearch));
    }
    setSelectedPlanAndNavigate() {
        this.helpfulToolsService
            .setSelectedHelpfulToolsPlan$(this.plan)
            // Since we're going to a new tab, we need to wait for the session storage to update, not just the store
            // and so we need a delay 0 to wait for the optimizations made in VnextStorageEngine before navigation
            .pipe(take(1), delay(0))
            .subscribe({
            next: () => {
                this.navigate(PageTags.HELPFUL_TOOLS_PHARMACYSEARCH);
            }
        });
    }
    navigate(pageTag) {
        this.navigationService.navigate({
            title: '',
            type: LinkType.INTERNAL,
            tag: pageTag,
            validateWidgets: false
        });
    }
}
HelpfulToolsPlanCardComponent.ɵfac = function HelpfulToolsPlanCardComponent_Factory(t) { return new (t || HelpfulToolsPlanCardComponent)(i0.ɵɵdirectiveInject(HelpfulToolsPlanCardFacade), i0.ɵɵdirectiveInject(HelpfulToolsService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.NavigationUtilityService)); };
HelpfulToolsPlanCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HelpfulToolsPlanCardComponent, selectors: [["vnext-helpful-tools-plancard"]], inputs: { Spa_Site_Show_PlanLogo: "Spa_Site_Show_PlanLogo", Spa_HelpfulTools_ExternalPharmacyEnabled: "Spa_HelpfulTools_ExternalPharmacyEnabled", Spa_HelpfulTools_ExternalPrescriptionsEnabled: "Spa_HelpfulTools_ExternalPrescriptionsEnabled", Spa_HelpfulTools_FindPrescriptions_Url: "Spa_HelpfulTools_FindPrescriptions_Url", Spa_HelpfulTools_FindPharmacy_Url: "Spa_HelpfulTools_FindPharmacy_Url", Spa_HelpfulTools_FindProviders_Link_Text: "Spa_HelpfulTools_FindProviders_Link_Text", Spa_HelpfulTools_FindDentists_Link_Text: "Spa_HelpfulTools_FindDentists_Link_Text", Spa_HelpfulTools_FindDentists_Link_Enabled: "Spa_HelpfulTools_FindDentists_Link_Enabled", Spa_HelpfulTools_FindPrescriptions_Link_Text: "Spa_HelpfulTools_FindPrescriptions_Link_Text", Spa_HelpfulTools_FindPharmacy_Link_Text: "Spa_HelpfulTools_FindPharmacy_Link_Text", plan: "plan", CSNPEnabled: "CSNPEnabled", DSNPEnabled: "DSNPEnabled", ISNPEnabled: "ISNPEnabled", CSNPText: "CSNPText", DSNPText: "DSNPText", ISNPText: "ISNPText", SNPText: "SNPText", planLogoSize: "planLogoSize" }, decls: 20, vars: 17, consts: [[1, "helpful-tools-plancard-panel", "pl-4", "mb-2"], [1, "row", "plan-card-header", "mb-2", "pt-2", "mt-2"], ["class", "col-12 col-md-2", 4, "ngIf"], [1, "col-12", "col-md-10"], [1, "Spa_Style_H5", "pt-0", "pt-md-1", "no-translate-block"], [3, "SNPType", "CSNPEnabled", "DSNPEnabled", "ISNPEnabled", "CSNPText", "DSNPText", "ISNPText", "SNPText"], [1, "row", "mt-3", "pt-sm-0"], [1, "col-10", "col-md-8", "offset-md-3"], [1, "row", "pt-4", "pt-md-2", "pb-2"], [1, "col-12"], [1, "row", "justify-content-end"], [1, "col-12", "col-md-auto", "pb-1"], [4, "ngIf"], [1, "col-12", "col-md-auto", "pb-1", 3, "ngClass"], [1, "col-12", "col-md-2"], [1, "image-responsive"], [3, "alternateText", "imageSrc", "classNames", "planLogoSize"], ["aria-hidden", "true", 1, "Spa_Style_DentistsIcon", "pr-1"], ["linkTarget", "_blank", 1, "d-inline-block", "ml-1", 3, "title", "href"], ["aria-hidden", "true", 1, "Spa_Style_ProvidersIcon", "pr-1"], [3, "linkText", "linkNavigate"], ["aria-hidden", "true", 1, "Spa_Style_PrescriptionsIcon"], [3, "linkText", "linkNavigate", "href", "isExternalRedirect"], ["aria-hidden", "true", 1, "Spa_Style_PharmacyIcon", "pr-1"]], template: function HelpfulToolsPlanCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, HelpfulToolsPlanCardComponent_div_2_Template, 3, 4, "div", 2);
        i0.ɵɵelementStart(3, "div", 3)(4, "h2", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(6, "vnext-plan-SNP-Indicator", 5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 6)(8, "div", 7)(9, "div", 8)(10, "div", 9)(11, "div", 10)(12, "div", 11);
        i0.ɵɵtemplate(13, HelpfulToolsPlanCardComponent_ng_container_13_Template, 3, 2, "ng-container", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 13);
        i0.ɵɵtemplate(15, HelpfulToolsPlanCardComponent_ng_container_15_Template, 3, 2, "ng-container", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 11);
        i0.ɵɵtemplate(17, HelpfulToolsPlanCardComponent_ng_container_17_Template, 3, 4, "ng-container", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 11);
        i0.ɵɵtemplate(19, HelpfulToolsPlanCardComponent_ng_container_19_Template, 3, 4, "ng-container", 12);
        i0.ɵɵelementEnd()()()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showPlanLogo);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.plan.planName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("SNPType", ctx.plan.snpType)("CSNPEnabled", ctx.CSNPEnabled)("DSNPEnabled", ctx.DSNPEnabled)("ISNPEnabled", ctx.ISNPEnabled)("CSNPText", ctx.CSNPText)("DSNPText", ctx.DSNPText)("ISNPText", ctx.ISNPText)("SNPText", ctx.SNPText);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngIf", ctx.showDentistsLink);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c0$1M, ctx.isMedicareAdvantage));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isHelpfulToolsProviderSearchEnabled && ctx.showProviderSearchLink);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showPrescriptionsLink);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showPharmacyLink);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, LinkComponent, HelpfulToolsLinkComponent, PlanSNPIndicatorComponent, PlanLogoComponent], styles: [".helpful-tools-plancard-panel[_ngcontent-%COMP%]{background:white;border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px;box-shadow:none}.plan-card-header[_ngcontent-%COMP%]{height:45px;max-height:60px}.image-responsive[_ngcontent-%COMP%]{padding-right:0;max-width:100%;width:130px;height:45px;text-align:center}.link-button[_ngcontent-%COMP%]{text-decoration:underline;cursor:pointer}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpfulToolsPlanCardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-helpful-tools-plancard', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"helpful-tools-plancard-panel pl-4 mb-2\">\r\n  <div class=\"row plan-card-header mb-2 pt-2 mt-2\">\r\n    <div class=\"col-12 col-md-2\" *ngIf=\"showPlanLogo\">\r\n      <div class=\"image-responsive\">\r\n        <vnext-plan-logo [alternateText]=\"planImageAltText\" [imageSrc]=\"planLogo\" [classNames]=\"'plan-logo'\" [planLogoSize]=\"planLogoSize\"></vnext-plan-logo>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-12 col-md-10\">\r\n      <h2 class=\"Spa_Style_H5 pt-0 pt-md-1 no-translate-block\">{{ plan.planName }}</h2>\r\n      <vnext-plan-SNP-Indicator\r\n        [SNPType]=\"plan.snpType\"\r\n        [CSNPEnabled]=\"CSNPEnabled\"\r\n        [DSNPEnabled]=\"DSNPEnabled\"\r\n        [ISNPEnabled]=\"ISNPEnabled\"\r\n        [CSNPText]=\"CSNPText\"\r\n        [DSNPText]=\"DSNPText\"\r\n        [ISNPText]=\"ISNPText\"\r\n        [SNPText]=\"SNPText\"\r\n      ></vnext-plan-SNP-Indicator>\r\n    </div>\r\n  </div>\r\n  <div class=\"row mt-3 pt-sm-0\">\r\n    <div class=\"col-10 col-md-8 offset-md-3\">\r\n      <div class=\"row pt-4 pt-md-2 pb-2\">\r\n        <div class=\"col-12\">\r\n          <div class=\"row justify-content-end\">\r\n            <div class=\"col-12 col-md-auto pb-1\">\r\n              <!--Find Dentists-->\r\n              <ng-container *ngIf=\"showDentistsLink\">\r\n                <span class=\"Spa_Style_DentistsIcon pr-1\" aria-hidden=\"true\"></span>\r\n                <vnext-link\r\n                  class=\"d-inline-block ml-1\"\r\n                  [title]=\"Spa_HelpfulTools_FindDentists_Link_Text\"\r\n                  [href]=\"dentistUrl\"\r\n                  linkTarget=\"_blank\"\r\n                ></vnext-link>\r\n              </ng-container>\r\n            </div>\r\n            <div class=\"col-12 col-md-auto pb-1\" [ngClass]=\"{ 'order-3': isMedicareAdvantage }\">\r\n              <!--Find Providers-->\r\n              <ng-container *ngIf=\"isHelpfulToolsProviderSearchEnabled && showProviderSearchLink\">\r\n                <ng-container *ngIf=\"showExternalProvidersLink()\">\r\n                  <span class=\"Spa_Style_ProvidersIcon pr-1\" aria-hidden=\"true\"></span>\r\n                  <vnext-link\r\n                    class=\"d-inline-block ml-1\"\r\n                    [title]=\"Spa_HelpfulTools_FindProviders_Link_Text\"\r\n                    [href]=\"plan.providerURL\"\r\n                    linkTarget=\"_blank\"\r\n                  >\r\n                  </vnext-link>\r\n                </ng-container>\r\n                <ng-container *ngIf=\"showInternalProvidersLink()\">\r\n                  <span class=\"Spa_Style_ProvidersIcon pr-1\" aria-hidden=\"true\"></span>\r\n                  <vnext-helpful-tools-link [linkText]=\"Spa_HelpfulTools_FindProviders_Link_Text\" [linkNavigate]=\"onProvidersClick\">\r\n                  </vnext-helpful-tools-link>\r\n                </ng-container>\r\n              </ng-container>\r\n            </div>\r\n            <div class=\"col-12 col-md-auto pb-1\">\r\n              <!--Find Prescriptions-->\r\n              <ng-container *ngIf=\"showPrescriptionsLink\">\r\n                <span class=\"Spa_Style_PrescriptionsIcon\" aria-hidden=\"true\"></span>\r\n                <vnext-helpful-tools-link\r\n                  [linkText]=\"Spa_HelpfulTools_FindPrescriptions_Link_Text\"\r\n                  [linkNavigate]=\"onPrescriptionsClick\"\r\n                  [href]=\"Spa_HelpfulTools_FindPrescriptions_Url[0]?.href\"\r\n                  [isExternalRedirect]=\"Spa_HelpfulTools_ExternalPrescriptionsEnabled\"\r\n                ></vnext-helpful-tools-link>\r\n              </ng-container>\r\n            </div>\r\n            <div class=\"col-12 col-md-auto pb-1\">\r\n              <!--Find Pharmacy-->\r\n              <ng-container *ngIf=\"showPharmacyLink\">\r\n                <span class=\"Spa_Style_PharmacyIcon pr-1\" aria-hidden=\"true\"></span>\r\n                <vnext-helpful-tools-link\r\n                  [linkText]=\"Spa_HelpfulTools_FindPharmacy_Link_Text\"\r\n                  [linkNavigate]=\"onPharmacyClick\"\r\n                  [href]=\"Spa_HelpfulTools_FindPharmacy_Url[0]?.href\"\r\n                  [isExternalRedirect]=\"Spa_HelpfulTools_ExternalPharmacyEnabled\"\r\n                >\r\n                </vnext-helpful-tools-link>\r\n              </ng-container>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".helpful-tools-plancard-panel{background:white;border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px;box-shadow:none}.plan-card-header{height:45px;max-height:60px}.image-responsive{padding-right:0;max-width:100%;width:130px;height:45px;text-align:center}.link-button{text-decoration:underline;cursor:pointer}\n"] }]
    }], function () { return [{ type: HelpfulToolsPlanCardFacade }, { type: HelpfulToolsService }, { type: i1.NavigationService }, { type: i1.NavigationUtilityService }]; }, { Spa_Site_Show_PlanLogo: [{
            type: Input
        }], Spa_HelpfulTools_ExternalPharmacyEnabled: [{
            type: Input
        }], Spa_HelpfulTools_ExternalPrescriptionsEnabled: [{
            type: Input
        }], Spa_HelpfulTools_FindPrescriptions_Url: [{
            type: Input
        }], Spa_HelpfulTools_FindPharmacy_Url: [{
            type: Input
        }], Spa_HelpfulTools_FindProviders_Link_Text: [{
            type: Input
        }], Spa_HelpfulTools_FindDentists_Link_Text: [{
            type: Input
        }], Spa_HelpfulTools_FindDentists_Link_Enabled: [{
            type: Input
        }], Spa_HelpfulTools_FindPrescriptions_Link_Text: [{
            type: Input
        }], Spa_HelpfulTools_FindPharmacy_Link_Text: [{
            type: Input
        }], plan: [{
            type: Input
        }], CSNPEnabled: [{
            type: Input
        }], DSNPEnabled: [{
            type: Input
        }], ISNPEnabled: [{
            type: Input
        }], CSNPText: [{
            type: Input
        }], DSNPText: [{
            type: Input
        }], ISNPText: [{
            type: Input
        }], SNPText: [{
            type: Input
        }], planLogoSize: [{
            type: Input
        }] }); })();

function FilterTabComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "vnext-configurable-tooltip", 9);
    i0.ɵɵelement(2, "i", 10);
    i0.ɵɵelementStart(3, "span", 11);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("customClass", ctx_r2.displayBadgeNormalFontSize ? "" : "align-middle")("header", ctx_r2.bestCoverageText)("body", ctx_r2.bestCoverageTooltip)("autoClose", "outside")("triggers", "clicks");
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("", ctx_r2.bestCoverageIcon, " mr-1 Spa_Style_Primary_Color");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r2.displayBadgeNormalFontSize ? "pl-1" : "font-small");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.bestCoverageText, " ");
} }
function FilterTabComponent_div_0_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelement(1, "vnext-loader-placeholder", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("loaderIconEnabled", ctx_r4.loaderIconEnabled)("spinnerSize", ctx_r4.spinnerSizeSmall)("loaderText", ctx_r4.plansLoadingText);
} }
function FilterTabComponent_div_0_ng_container_6_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r5.planCount);
} }
function FilterTabComponent_div_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FilterTabComponent_div_0_ng_container_6_div_1_Template, 2, 3, "div", 12);
    i0.ɵɵtemplate(2, FilterTabComponent_div_0_ng_container_6_span_2_Template, 2, 1, "span", 13);
    i0.ɵɵelementStart(3, "span", 14);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.loading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.loading);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.loading ? "" : ctx_r3.planCount === 1 ? ctx_r3.planText : ctx_r3.plansText);
} }
const _c0$1L = function (a0, a1) { return { active: a0, isBestCoverageTab: a1 }; };
const _c1$P = function (a0) { return { "pb-md-1": a0 }; };
function FilterTabComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵlistener("click", function FilterTabComponent_div_0_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.onClick()); })("keyup.enter", function FilterTabComponent_div_0_Template_div_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.onClick()); })("keyup.Space", function FilterTabComponent_div_0_Template_div_keyup_Space_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.onClick()); })("keyup.arrowleft", function FilterTabComponent_div_0_Template_div_keyup_arrowleft_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.setFocusToPreviousTabElement(ctx_r10.currentIndex, $event)); })("keyup.arrowright", function FilterTabComponent_div_0_Template_div_keyup_arrowright_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.setFocusToNextTabElement(ctx_r11.currentIndex, $event)); });
    i0.ɵɵtemplate(1, FilterTabComponent_div_0_div_1_Template, 5, 10, "div", 3);
    i0.ɵɵelementStart(2, "div", 4)(3, "span", 5);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 6);
    i0.ɵɵtemplate(6, FilterTabComponent_div_0_ng_container_6_Template, 5, 3, "ng-container", 7);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(10, _c0$1L, ctx_r0.isActive, ctx_r0.isBestCoverageTab));
    i0.ɵɵattribute("aria-selected", ctx_r0.isActive)("aria-posinset", ctx_r0.currentIndex + 1)("aria-setsize", ctx_r0.lastIndex + 1)("aria-controls", ctx_r0.ariaControlsId)("tabindex", ctx_r0.isActive ? "0" : "-1");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isBestCoverageTab);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c1$P, ctx_r0.lastIndex > 3));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.tabData.title);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showAllMedSupEnabled && ctx_r0.hasMedSupAnswers === false ? false : true);
} }
function FilterTabComponent_div_1_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function FilterTabComponent_div_1_button_7_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r16); const tab_r14 = restoredCtx.$implicit; i0.ɵɵnextContext(); const _r12 = i0.ɵɵreference(1); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.onDropDownClick(tab_r14, _r12)); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const tab_r14 = ctx.$implicit;
    i0.ɵɵattribute("aria-label", tab_r14.planTabEducationalText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(tab_r14.title);
} }
const _c2$y = function (a0) { return { active: a0 }; };
function FilterTabComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18, 19);
    i0.ɵɵlistener("openChange", function FilterTabComponent_div_1_Template_div_openChange_0_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.openChangeMobileTabPlans($event)); });
    i0.ɵɵelementStart(2, "button", 20)(3, "span", 21);
    i0.ɵɵtext(4, " More ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "i", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 23);
    i0.ɵɵtemplate(7, FilterTabComponent_div_1_button_7_Template, 3, 2, "button", 24);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c2$y, ctx_r1.isOpenMoreTab));
    i0.ɵɵattribute("aria-label", ctx_r1.moreOptionsText);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r1.dropdownTabs);
} }
class FilterTabComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, analyticsService, router, plansService, siteService, planListFacade, planFacade) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.analyticsService = analyticsService;
        this.router = router;
        this.plansService = plansService;
        this.siteService = siteService;
        this.planListFacade = planListFacade;
        this.planFacade = planFacade;
        this.isActive = false;
        this.mobileTab = false;
        this.showAllMedSupEnabled = false;
        this.loaderIconEnabled = false;
        this.setFocusToTabEvent = new EventEmitter();
        this.tabClicked = new EventEmitter();
        this.loading = false;
        this.planCount = 0;
        this.cSNPPlanCount = 0;
        this.dSNPPlanCount = 0;
        this.iSNPPlanCount = 0;
        this.filteredPlans = [];
        this.isBestCoverageTab = false;
        this.displayBadgeNormalFontSize = true;
        this.isOpenMoreTab = false;
        this.spinnerSizeSmall = SpinnerSize.SMALL;
        this.maxTabsCountForNormalFontSize = 6;
        this.tabFilters$ = new BehaviorSubject([]);
        this.subscriptions = new Subscription();
        this._tabType$ = new BehaviorSubject(null);
    }
    ngOnInit() {
        super.ngOnInit();
        this.planCount$ = combineLatest([this.getPlanType$(false), this.planListFacade.getVisiblePlanCountsByPlanType$()]).pipe(map(([planType, visiblePlanCountByType]) => visiblePlanCountByType?.[planType] ?? 0));
        this.tabPlansLoaded$ = this.getPlanType$().pipe(switchMap(planType => this.plansService.getPlansStateIsLoaded$(planType)));
        this.tabPlansLoading$ = this.getPlanType$().pipe(switchMap(planType => this.plansService.getPlansStateIsLoading$(planType)));
        this.tabPlansDirty$ = this.getPlanType$().pipe(switchMap(planType => this.plansService.getPlansStateIsDirty$(planType)));
        this.plans$ = this.tabFilters$
            .asObservable()
            .pipe(switchMap(filterList => this.configurableWidgetService.filterService.getPlansByFilterGroup$(filterList)));
        this.subscriptions.add(this.plans$.subscribe({
            next: plans => {
                this.filteredPlans = plans;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.planCount$.subscribe({
            next: planCount => {
                this.planCount = planCount;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.tabPlansLoading$.subscribe(loading => {
            this.loading = loading;
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.tabFilters$
            .asObservable()
            // TODO: this should be fine because we will only use this when we open the tab for analytics? OR will we always use this
            // and we need to account for this all of the time?
            .pipe(switchMap(filterList => this.configurableWidgetService.filterService.getPayloadByFilterGroup$(filterList)))
            .subscribe({
            next: (totalTabPlans) => {
                this.cSNPPlanCount = totalTabPlans.filter(plan => plan.snpType === SNPBaseType.cSNP).length;
                this.dSNPPlanCount = totalTabPlans.filter(plan => plan.snpType === SNPBaseType.dSNP).length;
                this.iSNPPlanCount = totalTabPlans.filter(plan => plan.snpType === SNPBaseType.iSNP).length;
            }
        }));
        if (this.tabData?.tabTypes?.includes(PlanTypeAbbreviation.MEDIGAP)) {
            this.subscriptions.add(this.plansService.getHasMedSupAnswers$().subscribe({
                next: (hasAnswers) => {
                    this.hasMedSupAnswers = hasAnswers;
                    this.cdr.markForCheck();
                }
            }));
        }
        this.displayBadgeNormalFontSize = this.lastIndex + 1 <= this.maxTabsCountForNormalFontSize;
    }
    ngOnChanges(changes) {
        const { tabData } = changes;
        if (tabData && tabData.currentValue && !_isEqual(tabData.previousValue, tabData.currentValue)) {
            const tab = this.tabData;
            this.tabFilters$.next(tab.filters);
            this.setTabType(tab?.tabTypes[0]);
        }
        if (changes.bestCoverageTabTypeAbbreviation &&
            !_isEqual(changes.bestCoverageTabTypeAbbreviation.previousValue, changes.bestCoverageTabTypeAbbreviation.currentValue)) {
            this.isBestCoverageTab = this.showBestCoverageBanner && this.tabData?.tabTypes?.includes(this.bestCoverageTabTypeAbbreviation);
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
    onClick() {
        this.tagsToUpdate(this.tabData.filters[0].values[0], this.planCount.toString());
        // now when we change tabs by clicking on a tab we need to make sure we aren't running the override active tab
        // logic as we now load on each change and that will trigger a recalculation each time
        this.plansService.setOverrideActiveTab(false);
        // We disable the active tab's plan count check to keep the selected tab by the user, regardless of plan coverage
        this.plansService.setActiveTabPlanCountCheckEnabled(false);
        this.configurableWidgetService.store.dispatch(new SetActiveTab(this.tabData.filters[0].values[0]));
        this.tabClicked.emit();
    }
    onDropDownClick(tab, ngbDropdown) {
        // get the plan count and update GA based on the next filter tab section, not current tab.
        this.configurableWidgetService.filterService
            .getPlansByFilterGroup$(tab.filters)
            .pipe(take(1))
            .subscribe({
            next: plans => {
                this.tagsToUpdate(tab.filters[0].values[0], plans.length.toString());
            }
        });
        // We disable the active tab's plan count check to keep the selected tab by the user, regardless of plan coverage
        this.plansService.setActiveTabPlanCountCheckEnabled(false);
        this.configurableWidgetService.store.dispatch(new SetActiveTab(tab.filters[0].values[0]));
        ngbDropdown.close();
        this.tabClicked.emit();
    }
    tagsToUpdate(tabType, planCount) {
        let dataLayerTags = {
            [DataLayerGlobalVariable.PAGE_TAB_NAME]: tabType,
            [DataLayerGlobalVariable.PLAN_TYPE]: tabType,
            [DataLayerGlobalVariable.PLANS_COUNT]: planCount,
            [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
            [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE,
            [DataLayerGlobalVariable.CSNP_PLAN_COUNT]: this.cSNPPlanCount.toString(),
            [DataLayerGlobalVariable.DSNP_PLAN_COUNT]: this.dSNPPlanCount.toString(),
            [DataLayerGlobalVariable.ISNP_PLAN_COUNT]: this.iSNPPlanCount.toString(),
            [DataLayerGlobalVariable.PLAN_ID_BEST_MATCH]: this.planListFacade.getBestMatchPlanIdValueForAnalytics(),
            [DataLayerGlobalVariable.PLAN_TYPE_BEST_MATCH]: this.planListFacade.getBestCoverageTabAbbreviationValueForAnalytics(),
            [DataLayerGlobalVariable.PLANS_COUNT_VBC]: this.planFacade.getPlanVbcAgreementCount(this.filteredPlans),
        };
        if (this.siteService.isPPCSite()) {
            dataLayerTags = {
                ...dataLayerTags,
                [DataLayerGlobalVariable.PLANS_COUNT_NON_LICENSED]: this.plansService.getNonLicensedPlansCount(this.filteredPlans).toString()
            };
        }
        this.analyticsService.googleDataLayerTags = dataLayerTags;
    }
    setFocusToPreviousTabElement(currentIndex, $event) {
        if (this.lastIndex) {
            $event.preventDefault();
            this.setFocusToTabEvent.emit(currentIndex === 0 ? this.lastIndex : currentIndex - 1);
        }
    }
    setFocusToNextTabElement(currentIndex, $event) {
        if (this.lastIndex) {
            $event.preventDefault();
            this.setFocusToTabEvent.emit(currentIndex === this.lastIndex ? 0 : currentIndex + 1);
        }
    }
    getAriaLabelText() {
        return `${this.bestCoverageText} ${this.bestCoverageTooltip}`;
    }
    openChangeMobileTabPlans(open) {
        this.isOpenMoreTab = open;
    }
    setTabType(tabType) {
        this._tabType$.next(tabType);
    }
    getTabType$() {
        return this._tabType$.asObservable();
    }
    getPlanType$(aggregateMedicareType = true) {
        return this.getTabType$().pipe(map(tabType => PlansUtilityService.convertToPlanType(tabType, aggregateMedicareType)));
    }
}
FilterTabComponent.ɵfac = function FilterTabComponent_Factory(t) { return new (t || FilterTabComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(PlanListFacadeService), i0.ɵɵdirectiveInject(PlanFacade)); };
FilterTabComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FilterTabComponent, selectors: [["vnext-filter-tab"]], inputs: { tabData: "tabData", showBestCoverageBanner: "showBestCoverageBanner", isActive: "isActive", bestCoverageText: "bestCoverageText", bestCoverageIcon: "bestCoverageIcon", bestCoverageTooltip: "bestCoverageTooltip", plansText: "plansText", planText: "planText", mobileTab: "mobileTab", dropdownTabs: "dropdownTabs", currentIndex: "currentIndex", lastIndex: "lastIndex", ariaControlsId: "ariaControlsId", moreOptionsText: "moreOptionsText", showAllMedSupEnabled: "showAllMedSupEnabled", bestCoverageTabTypeAbbreviation: "bestCoverageTabTypeAbbreviation", loaderIconEnabled: "loaderIconEnabled", plansLoadingText: "plansLoadingText" }, outputs: { setFocusToTabEvent: "setFocusToTabEvent", tabClicked: "tabClicked" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [["class", "tab d-flex flex-column justify-content-between Spa_Style_InactiveTabAndModal can-click", "role", "tab", 3, "ngClass", "click", "keyup.enter", "keyup.Space", "keyup.arrowleft", "keyup.arrowright", 4, "ngIf"], ["ngbDropdown", "", "class", "h-100", "placement", "bottom-right", 3, "openChange", 4, "ngIf"], ["role", "tab", 1, "tab", "d-flex", "flex-column", "justify-content-between", "Spa_Style_InactiveTabAndModal", "can-click", 3, "ngClass", "click", "keyup.enter", "keyup.Space", "keyup.arrowleft", "keyup.arrowright"], ["class", "best-coverage-badge Spa_Style_Accent4_Background", 4, "ngIf"], [1, "Spa_Style_H5", "text-center", "w-100", "my-auto", "tab-title-padding", 3, "ngClass"], [1, "tab-title", "no-translate-block"], [1, "plan-count", "text-center", "mt-2", "mt-lg-0"], [4, "ngIf"], [1, "best-coverage-badge", "Spa_Style_Accent4_Background"], [1, "Spa_Style_Accent4_Background", "py-1", "text-center", "px-1", "best-coverage-plan-text", 3, "customClass", "header", "body", "autoClose", "triggers"], ["aria-hidden", "true"], [1, "Spa_Style_Paragraph", "Spa_Style_Primary_Color", "underline", "best-coverage-text", 3, "ngClass"], ["class", "d-flex justify-content-center mt-2", 4, "ngIf"], ["class", "no-translate-block", 4, "ngIf"], [1, "no-translate-block", "pl-1"], [1, "d-flex", "justify-content-center", "mt-2"], [3, "loaderIconEnabled", "spinnerSize", "loaderText"], [1, "no-translate-block"], ["ngbDropdown", "", "placement", "bottom-right", 1, "h-100", 3, "openChange"], ["dropDown", "ngbDropdown"], ["ngbDropdownToggle", "", "tabindex", "0", 1, "tab", "h-100", "w-100", "align-items-center", "d-flex", "justify-content-center", "Spa_Style_InactiveTabAndModal", 3, "ngClass"], [1, "Spa_Style_Paragraph", "mr-1"], ["aria-hidden", "true", 1, "fa", "fa-angle-down"], ["ngbDropdownMenu", ""], ["class", "item p-2 text-center text-wrap text-break", "tabindex", "0", "ngbDropdownItem", "", 3, "click", 4, "ngFor", "ngForOf"], ["tabindex", "0", "ngbDropdownItem", "", 1, "item", "p-2", "text-center", "text-wrap", "text-break", 3, "click"]], template: function FilterTabComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, FilterTabComponent_div_0_Template, 7, 15, "div", 0);
        i0.ɵɵtemplate(1, FilterTabComponent_div_1_Template, 8, 5, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.mobileTab);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.mobileTab);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, ConfigurableTooltipComponent, LoaderPlaceholderComponent, IconAriaAttributesDirective, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem], styles: [".best-coverage-badge[_ngcontent-%COMP%]{padding-bottom:-2px;top:-26px;left:-1px;width:calc(100% + 2px);font-size:14px;position:absolute}.best-coverage-badge[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:14px}.best-coverage-plan-text[_ngcontent-%COMP%]{border-radius:5px 5px 0 0;width:100%;position:absolute;font-size:14px;border:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.best-coverage-plan-text[_ngcontent-%COMP%]   .best-coverage-text[_ngcontent-%COMP%]{font-family:montserrat_semibold}.tab[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px 5px 0 0;color:var(--static-Spa_Style_Primary);padding:12px;min-height:100%;position:relative;min-height:95px;max-height:230px;height:100%}.tab[_ngcontent-%COMP%]:hover{background:white;cursor:pointer}.tab.active[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Primary);background-color:#fff;border-bottom-color:#fff;font-weight:700}.tab.isBestCoverageTab[_ngcontent-%COMP%]{border-radius:0}.title[_ngcontent-%COMP%]{font-size:var(--Spa_Style_Small_Font);font-weight:700}.plan-count[_ngcontent-%COMP%]{font-size:13px;font-weight:400}li[_ngcontent-%COMP%]{width:100%}.font-small[_ngcontent-%COMP%]{font-size:12px}.tab[_ngcontent-%COMP%]   .tab-title-padding[_ngcontent-%COMP%]{padding:.5em .3em}@media (min-width: 768px) and (max-width: 991.9px){.tab[_ngcontent-%COMP%]{padding:3px;line-height:16px}.tab[_ngcontent-%COMP%]   .tab-title[_ngcontent-%COMP%]{font-size:.78rem}.best-coverage-plan-text[_ngcontent-%COMP%]   .best-coverage-text[_ngcontent-%COMP%]{width:50%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}}@media (min-width: 992px){.tab[_ngcontent-%COMP%]   .tab-title[_ngcontent-%COMP%]{font-size:.9rem}}.dropdown-menu[_ngcontent-%COMP%]{min-width:80vw}@media (max-width: 575.98px){.tab-title[_ngcontent-%COMP%]{word-break:break-word}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilterTabComponent, [{
        type: Component,
        args: [{ selector: 'vnext-filter-tab', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  class=\"tab d-flex flex-column justify-content-between Spa_Style_InactiveTabAndModal can-click\"\r\n  [ngClass]=\"{ active: isActive, isBestCoverageTab: isBestCoverageTab }\"\r\n  *ngIf=\"!mobileTab\"\r\n  (click)=\"onClick()\"\r\n  (keyup.enter)=\"onClick()\"\r\n  (keyup.Space)=\"onClick()\"\r\n  role=\"tab\"\r\n  [attr.aria-selected]=\"isActive\"\r\n  (keyup.arrowleft)=\"setFocusToPreviousTabElement(currentIndex, $event)\"\r\n  (keyup.arrowright)=\"setFocusToNextTabElement(currentIndex, $event)\"\r\n  [attr.aria-posinset]=\"currentIndex + 1\"\r\n  [attr.aria-setsize]=\"lastIndex + 1\"\r\n  [attr.aria-controls]=\"ariaControlsId\"\r\n  [attr.tabindex]=\"isActive ? '0' : '-1'\"\r\n>\r\n  <div class=\"best-coverage-badge Spa_Style_Accent4_Background\" *ngIf=\"isBestCoverageTab\">\r\n    <vnext-configurable-tooltip\r\n      class=\"Spa_Style_Accent4_Background py-1 text-center px-1 best-coverage-plan-text\"\r\n      [customClass]=\"displayBadgeNormalFontSize ? '' : 'align-middle'\"\r\n      [header]=\"bestCoverageText\"\r\n      [body]=\"bestCoverageTooltip\"\r\n      [autoClose]=\"'outside'\"\r\n      [triggers]=\"'clicks'\"\r\n    >\r\n      <i aria-hidden=\"true\" class=\"{{ bestCoverageIcon }} mr-1 Spa_Style_Primary_Color\"></i>\r\n      <span\r\n        class=\"Spa_Style_Paragraph Spa_Style_Primary_Color underline best-coverage-text\"\r\n        [ngClass]=\"displayBadgeNormalFontSize ? 'pl-1' : 'font-small'\"\r\n      >\r\n        {{ bestCoverageText }}\r\n      </span>\r\n    </vnext-configurable-tooltip>\r\n  </div>\r\n\r\n  <div class=\"Spa_Style_H5 text-center w-100 my-auto tab-title-padding\" [ngClass]=\"{ 'pb-md-1': lastIndex > 3 }\">\r\n    <span class=\"tab-title no-translate-block\">{{ tabData.title }}</span>\r\n  </div>\r\n  <div class=\"plan-count text-center mt-2 mt-lg-0\">\r\n    <ng-container *ngIf=\"showAllMedSupEnabled && hasMedSupAnswers === false ? false : true\">\r\n      <div *ngIf=\"loading\" class=\"d-flex justify-content-center mt-2\">\r\n        <vnext-loader-placeholder [loaderIconEnabled]=\"loaderIconEnabled\" [spinnerSize]=\"spinnerSizeSmall\" [loaderText]=\"plansLoadingText\">\r\n        </vnext-loader-placeholder>\r\n      </div>\r\n      <span *ngIf=\"!loading\" class=\"no-translate-block\">{{ planCount }}</span>\r\n      <span class=\"no-translate-block pl-1\">{{ loading ? '' : planCount === 1 ? planText : plansText }}</span>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n<div\r\n  *ngIf=\"mobileTab\"\r\n  ngbDropdown\r\n  #dropDown=\"ngbDropdown\"\r\n  class=\"h-100\"\r\n  placement=\"bottom-right\"\r\n  (openChange)=\"openChangeMobileTabPlans($event)\"\r\n>\r\n  <button\r\n    [ngClass]=\"{ active: isOpenMoreTab }\"\r\n    class=\"tab h-100 w-100 align-items-center d-flex justify-content-center Spa_Style_InactiveTabAndModal\"\r\n    ngbDropdownToggle\r\n    tabindex=\"0\"\r\n    [attr.aria-label]=\"moreOptionsText\"\r\n  >\r\n    <span class=\"Spa_Style_Paragraph mr-1\"> More </span>\r\n    <i aria-hidden=\"true\" class=\"fa fa-angle-down\"></i>\r\n  </button>\r\n  <div ngbDropdownMenu>\r\n    <button\r\n      *ngFor=\"let tab of dropdownTabs\"\r\n      class=\"item p-2 text-center text-wrap text-break\"\r\n      (click)=\"onDropDownClick(tab, dropDown)\"\r\n      [attr.aria-label]=\"tab.planTabEducationalText\"\r\n      tabindex=\"0\"\r\n      ngbDropdownItem\r\n    >\r\n      <span>{{ tab.title }}</span>\r\n    </button>\r\n  </div>\r\n</div>\r\n", styles: [".best-coverage-badge{padding-bottom:-2px;top:-26px;left:-1px;width:calc(100% + 2px);font-size:14px;position:absolute}.best-coverage-badge i{font-size:14px}.best-coverage-plan-text{border-radius:5px 5px 0 0;width:100%;position:absolute;font-size:14px;border:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.best-coverage-plan-text .best-coverage-text{font-family:montserrat_semibold}.tab{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px 5px 0 0;color:var(--static-Spa_Style_Primary);padding:12px;min-height:100%;position:relative;min-height:95px;max-height:230px;height:100%}.tab:hover{background:white;cursor:pointer}.tab.active{color:var(--static-Spa_Style_Primary);background-color:#fff;border-bottom-color:#fff;font-weight:700}.tab.isBestCoverageTab{border-radius:0}.title{font-size:var(--Spa_Style_Small_Font);font-weight:700}.plan-count{font-size:13px;font-weight:400}li{width:100%}.font-small{font-size:12px}.tab .tab-title-padding{padding:.5em .3em}@media (min-width: 768px) and (max-width: 991.9px){.tab{padding:3px;line-height:16px}.tab .tab-title{font-size:.78rem}.best-coverage-plan-text .best-coverage-text{width:50%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}}@media (min-width: 992px){.tab .tab-title{font-size:.9rem}}.dropdown-menu{min-width:80vw}@media (max-width: 575.98px){.tab-title{word-break:break-word}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: AnalyticsService }, { type: i2$1.Router }, { type: i1.PlansService }, { type: i1.SiteService }, { type: PlanListFacadeService }, { type: PlanFacade }]; }, { tabData: [{
            type: Input
        }], showBestCoverageBanner: [{
            type: Input
        }], isActive: [{
            type: Input
        }], bestCoverageText: [{
            type: Input
        }], bestCoverageIcon: [{
            type: Input
        }], bestCoverageTooltip: [{
            type: Input
        }], plansText: [{
            type: Input
        }], planText: [{
            type: Input
        }], mobileTab: [{
            type: Input
        }], dropdownTabs: [{
            type: Input
        }], currentIndex: [{
            type: Input
        }], lastIndex: [{
            type: Input
        }], ariaControlsId: [{
            type: Input
        }], moreOptionsText: [{
            type: Input
        }], showAllMedSupEnabled: [{
            type: Input
        }], bestCoverageTabTypeAbbreviation: [{
            type: Input
        }], loaderIconEnabled: [{
            type: Input
        }], plansLoadingText: [{
            type: Input
        }], setFocusToTabEvent: [{
            type: Output
        }], tabClicked: [{
            type: Output
        }] }); })();

function PlanYearLabelComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 2);
    i0.ɵɵlistener("click", function PlanYearLabelComponent_ng_container_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.openPlanYearModal()); });
    i0.ɵɵtext(2);
    i0.ɵɵelement(3, "i", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", false);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.dualPlanYear, "");
} }
function PlanYearLabelComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.dualPlanYear, " ");
} }
class PlanYearLabelComponent {
    constructor(modalService, analyticsService, planYearResourceService) {
        this.modalService = modalService;
        this.analyticsService = analyticsService;
        this.planYearResourceService = planYearResourceService;
        this.onPlanYearUpdate = new EventEmitter();
    }
    openPlanYearModal() {
        const planYearModal = this.modalService.open(PlanYearModalComponent, {
            centered: true
        });
        planYearModal.result.then(showPlanRemovalWarning => {
            this.logContinueAnalyticsEvent(showPlanRemovalWarning);
            this.onPlanYearUpdate.emit();
        }, () => { });
    }
    logContinueAnalyticsEvent(showPlanRemovalWarning) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLAN_YEAR_MODAL_CONTINUE,
            [DataLayerGlobalVariable.SITE_PLAN_YEAR]: this.planYearResourceService.getSelectedPlanYear(),
            [DataLayerGlobalVariable.PLAN_YEAR_MODAL_HAS_WARNING_MESSAGE]: showPlanRemovalWarning ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO
        };
    }
}
PlanYearLabelComponent.ɵfac = function PlanYearLabelComponent_Factory(t) { return new (t || PlanYearLabelComponent)(i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.PlanYearResourceService)); };
PlanYearLabelComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanYearLabelComponent, selectors: [["vnext-plan-year-label"]], inputs: { dualPlanYearPrefix: "dualPlanYearPrefix", dualPlanYearText: "dualPlanYearText", dualPlanYear: "dualPlanYear", dualPlanYearPostfix: "dualPlanYearPostfix", isPlanYearUpdateModalEnabled: "isPlanYearUpdateModalEnabled" }, outputs: { onPlanYearUpdate: "onPlanYearUpdate" }, decls: 6, vars: 4, consts: [[4, "ngIf", "ngIfElse"], ["dualPlanYearText", ""], ["tabindex", "0", 1, "link", "zip-code-link", "Spa_Style_Largest_Font", "Spa_Style_Link", "d-inline", "focus-text", "action-button", 3, "disabled", "click"], [1, "fa", "fa-edit", "ml-2"]], template: function PlanYearLabelComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "span");
        i0.ɵɵtext(1);
        i0.ɵɵtemplate(2, PlanYearLabelComponent_ng_container_2_Template, 4, 2, "ng-container", 0);
        i0.ɵɵtemplate(3, PlanYearLabelComponent_ng_template_3_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(4);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.dualPlanYearPrefix, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isPlanYearUpdateModalEnabled)("ngIfElse", _r1);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.dualPlanYearPostfix, "\n");
    } }, dependencies: [i1$2.NgIf, IconAriaAttributesDirective], styles: [".zip-code-link[_ngcontent-%COMP%]{text-decoration:underline;position:relative;cursor:pointer}.fa-edit[_ngcontent-%COMP%]{font-size:var(--Spa_Style_Regular_Font);position:relative;top:-6px}.zip-code-link[_ngcontent-%COMP%]   .fa-edit[_ngcontent-%COMP%]{font-size:.5em}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanYearLabelComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-year-label', changeDetection: ChangeDetectionStrategy.OnPush, template: "<span>\r\n  {{ dualPlanYearPrefix }}\r\n  <ng-container *ngIf=\"isPlanYearUpdateModalEnabled; else dualPlanYearText\">\r\n    <button\r\n      class=\"link zip-code-link Spa_Style_Largest_Font Spa_Style_Link d-inline focus-text action-button\"\r\n      tabindex=\"0\"\r\n      (click)=\"openPlanYearModal()\"\r\n      [disabled]=\"false\"\r\n    >\r\n      {{ dualPlanYear }}<i class=\"fa fa-edit ml-2\"></i>\r\n    </button>\r\n  </ng-container>\r\n  <ng-template #dualPlanYearText>\r\n    {{ dualPlanYear }}\r\n  </ng-template>\r\n  {{ dualPlanYearPostfix }}\r\n</span>\r\n", styles: [".zip-code-link{text-decoration:underline;position:relative;cursor:pointer}.fa-edit{font-size:var(--Spa_Style_Regular_Font);position:relative;top:-6px}.zip-code-link .fa-edit{font-size:.5em}\n"] }]
    }], function () { return [{ type: i1$1.NgbModal }, { type: AnalyticsService }, { type: i1.PlanYearResourceService }]; }, { dualPlanYearPrefix: [{
            type: Input
        }], dualPlanYearText: [{
            type: Input
        }], dualPlanYear: [{
            type: Input
        }], dualPlanYearPostfix: [{
            type: Input
        }], isPlanYearUpdateModalEnabled: [{
            type: Input
        }], onPlanYearUpdate: [{
            type: Output
        }] }); })();

const _c0$1K = ["helpfulToolsPlanTab"];
function HelpfulToolsPlanListComponent_h1_3_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function HelpfulToolsPlanListComponent_h1_3_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r14.editZipCode()); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelement(3, "i", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("title", ctx_r10.Spa_PlanList_EditZipCode_Label);
    i0.ɵɵattribute("aria-label", ctx_r10.Spa_PlanList_EditZipCode_ButtonLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, ctx_r10.helpfulToolsService.getZipCode$()), "");
} }
function HelpfulToolsPlanListComponent_h1_3_ng_template_4_span_0_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵlistener("click", function HelpfulToolsPlanListComponent_h1_3_ng_template_4_span_0_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r17.editZipCode()); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelement(3, "i", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵpropertyInterpolate("title", ctx_r16.Spa_PlanList_EditZipCode_Label);
    i0.ɵɵattribute("aria-label", ctx_r16.Spa_PlanList_EditZipCode_ButtonLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 3, ctx_r16.zipCode$));
} }
function HelpfulToolsPlanListComponent_h1_3_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, HelpfulToolsPlanListComponent_h1_3_ng_template_4_span_0_Template, 4, 5, "span", 21);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx_r12.zipCode$));
} }
function HelpfulToolsPlanListComponent_h1_3_vnext_plan_year_label_6_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-plan-year-label", 24);
    i0.ɵɵlistener("onPlanYearUpdate", function HelpfulToolsPlanListComponent_h1_3_vnext_plan_year_label_6_Template_vnext_plan_year_label_onPlanYearUpdate_0_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r19.onPlanYearUpdate()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("dualPlanYearPrefix", ctx_r13.dualPlanYearPrefix)("isPlanYearUpdateModalEnabled", ctx_r13.isPlanYearUpdateModalEnabled)("dualPlanYearText", ctx_r13.dualPlanYear)("dualPlanYear", ctx_r13.dualPlanYear)("dualPlanYearPostfix", ctx_r13.dualPlanYearPostfix);
} }
function HelpfulToolsPlanListComponent_h1_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 15);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, HelpfulToolsPlanListComponent_h1_3_button_2_Template, 4, 5, "button", 16);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵtemplate(4, HelpfulToolsPlanListComponent_h1_3_ng_template_4_Template, 2, 3, "ng-template", null, 17, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(6, HelpfulToolsPlanListComponent_h1_3_vnext_plan_year_label_6_Template, 1, 5, "vnext-plan-year-label", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r11 = i0.ɵɵreference(5);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r0.totalPlanCount, " ", ctx_r0.totalPlanCount === 1 ? ctx_r0.Spa_PlanList_PlansAvailableSingular_Text : ctx_r0.totalPlanCount === 0 ? ctx_r0.Spa_HelpfulTools_PlansAvailablePlural_Text : ctx_r0.Spa_PlanList_PlansAvailablePlural_Text, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.totalPlanCount && i0.ɵɵpipeBind1(3, 5, ctx_r0.helpfulToolsService.getZipCode$()))("ngIfElse", _r11);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.planYearTextEnabled);
} }
function HelpfulToolsPlanListComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 25);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r1.Spa_Site_PageSubHeader_Text ? i0.ɵɵpipeBind2(1, 1, ctx_r1.Spa_Site_PageSubHeader_Text, "html") : "", i0.ɵɵsanitizeHtml);
} }
function HelpfulToolsPlanListComponent_div_9_vnext_filter_tab_1_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-filter-tab", 28, 29);
    i0.ɵɵlistener("setFocusToTabEvent", function HelpfulToolsPlanListComponent_div_9_vnext_filter_tab_1_Template_vnext_filter_tab_setFocusToTabEvent_0_listener($event) { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r25.shiftFocusToTabElement($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r22 = ctx.$implicit;
    const i_r23 = ctx.index;
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tabData", tab_r22)("isActive", i_r23 === ctx_r21.activeTabIndex)("plansText", ctx_r21.Spa_Site_Plans_Text)("planText", ctx_r21.Spa_Site_Plan_Text)("currentIndex", i_r23)("lastIndex", ctx_r21.tabs.length - 1)("ariaControlsId", "helpful-tools-container");
} }
function HelpfulToolsPlanListComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵtemplate(1, HelpfulToolsPlanListComponent_div_9_vnext_filter_tab_1_Template, 2, 7, "vnext-filter-tab", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.tabs);
} }
function HelpfulToolsPlanListComponent_div_10_vnext_filter_tab_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-filter-tab", 31);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(2);
    let tmp_1_0;
    i0.ɵɵproperty("tabData", i0.ɵɵpipeBind1(1, 4, ctx_r27.lastActiveTabThatIsNotDefault$) || ctx_r27.tabs[1])("isActive", ((tmp_1_0 = i0.ɵɵpipeBind1(2, 6, ctx_r27.lastActiveTabThatIsNotDefault$)) == null ? null : tmp_1_0.tabIndex) === ctx_r27.activeTabIndex)("plansText", ctx_r27.Spa_Site_Plans_Text)("planText", ctx_r27.Spa_Site_Plan_Text);
} }
function HelpfulToolsPlanListComponent_div_10_vnext_filter_tab_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-filter-tab", 34);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("mobileTab", true)("dropdownTabs", ctx_r28.mobileTabs(i0.ɵɵpipeBind1(1, 3, ctx_r28.lastActiveTabThatIsNotDefault$)))("moreOptionsText", ctx_r28.Spa_Site_MoreOptions_Text);
} }
function HelpfulToolsPlanListComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelement(1, "vnext-filter-tab", 31);
    i0.ɵɵtemplate(2, HelpfulToolsPlanListComponent_div_10_vnext_filter_tab_2_Template, 3, 8, "vnext-filter-tab", 32);
    i0.ɵɵtemplate(3, HelpfulToolsPlanListComponent_div_10_vnext_filter_tab_3_Template, 2, 5, "vnext-filter-tab", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("tabData", ctx_r3.tabs[0])("isActive", ctx_r3.tabs[0].tabIndex === ctx_r3.activeTabIndex)("plansText", ctx_r3.Spa_Site_Plans_Text)("planText", ctx_r3.Spa_Site_Plan_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.tabs.length > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.tabs.length > 2);
} }
function HelpfulToolsPlanListComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "div", 35);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 1, ctx_r4.tabs[ctx_r4.activeTabIndex] == null ? null : ctx_r4.tabs[ctx_r4.activeTabIndex].planTabEducationalText, "html"), i0.ɵɵsanitizeHtml);
} }
function HelpfulToolsPlanListComponent_ng_template_13_ng_template_5_button_0_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 41);
    i0.ɵɵlistener("click", function HelpfulToolsPlanListComponent_ng_template_13_ng_template_5_button_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r33); const ctx_r32 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r32.viewPlansOnClick()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r31.Spa_HelpfulTools_PlanList_ViewPlans_Button_Text, " ");
} }
function HelpfulToolsPlanListComponent_ng_template_13_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, HelpfulToolsPlanListComponent_ng_template_13_ng_template_5_button_0_Template, 2, 1, "button", 40);
} if (rf & 2) {
    i0.ɵɵproperty("liveEditProp", "Spa_HelpfulTools_PlanList_ViewPlans_Button_Text");
} }
function HelpfulToolsPlanListComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 36)(2, "div", 37);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "vnext-zip-code-input", 38);
    i0.ɵɵlistener("zip", function HelpfulToolsPlanListComponent_ng_template_13_Template_vnext_zip_code_input_zip_4_listener($event) { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r34.updateZip($event)); })("fips", function HelpfulToolsPlanListComponent_ng_template_13_Template_vnext_zip_code_input_fips_4_listener($event) { i0.ɵɵrestoreView(_r35); const ctx_r36 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r36.updateFips($event)); })("keyup.enter", function HelpfulToolsPlanListComponent_ng_template_13_Template_vnext_zip_code_input_keyup_enter_4_listener() { i0.ɵɵrestoreView(_r35); const ctx_r37 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r37.viewPlansOnClick()); });
    i0.ɵɵtemplate(5, HelpfulToolsPlanListComponent_ng_template_13_ng_template_5_Template, 1, 1, "ng-template", null, 39, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const _r29 = i0.ɵɵreference(6);
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.Spa_HelpfulTools_PlanList_PleaseEnterZip_Text, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("retrieveZipCode", ctx_r6.helpfulToolsFacade.zipCodeAction)("retrieveFipsCode", ctx_r6.helpfulToolsFacade.fipsCodeAction)("retrieveCounties", ctx_r6.helpfulToolsFacade.helpfulToolsCounties)("selectedCountyEnabled", ctx_r6.helpfulToolsResources.getSelectedCountyEnabled())("zipCodeErrorText", ctx_r6.helpfulToolsResources.getZipCodeErrorText())("countyErrorText", ctx_r6.helpfulToolsResources.getCountyErrorText())("selectCountyText", ctx_r6.helpfulToolsResources.getSelectCountyText())("zipCodeText", ctx_r6.helpfulToolsResources.getZipCodeText())("editCountyText", ctx_r6.helpfulToolsResources.getEditCountyText())("searchButtonTemplate", _r29)("errorKeywordText", ctx_r6.Spa_Site_ErrorKeyword_Text)("countyLabel", ctx_r6.Spa_ZipCodeInput_CountyLabel_Text)("showCountyLabel", ctx_r6.Spa_ZipCodeInput_CountyLabel_Enabled)("logAnalytics", !ctx_r6.deepLinkingZipCode || ctx_r6.loaded);
} }
function HelpfulToolsPlanListComponent_ng_container_16_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-snp-toggle", 44);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("showLinkText", ctx_r38.Spa_HelpfulTools_ShowSNPLink_Text)("hideLinkText", ctx_r38.Spa_HelpfulTools_HideSNPLink_Text)("activeTabType", ctx_r38.activeTabType)("filteredPlansHasSNPPlans", i0.ɵɵpipeBind1(2, 4, ctx_r38.filteredPlansHasSNPPlans$));
} }
function HelpfulToolsPlanListComponent_ng_container_16_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 45);
    i0.ɵɵelement(2, "vnext-helpful-tools-plancard", 46);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const plan_r40 = ctx.$implicit;
    const ctx_r39 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("plan", plan_r40)("Spa_Site_Show_PlanLogo", ctx_r39.Spa_Site_Show_PlanLogo)("Spa_HelpfulTools_FindPrescriptions_Url", ctx_r39.Spa_HelpfulTools_FindPrescriptions_Url)("Spa_HelpfulTools_FindPharmacy_Url", ctx_r39.Spa_HelpfulTools_FindPharmacy_Url)("Spa_HelpfulTools_FindProviders_Link_Text", ctx_r39.Spa_HelpfulTools_FindProviders_Link_Text)("Spa_HelpfulTools_FindPrescriptions_Link_Text", ctx_r39.Spa_HelpfulTools_FindPrescriptions_Link_Text)("Spa_HelpfulTools_FindDentists_Link_Text", ctx_r39.Spa_HelpfulTools_FindDentists_Link_Text)("Spa_HelpfulTools_FindDentists_Link_Enabled", ctx_r39.Spa_HelpfulTools_FindDentists_Link_Enabled)("Spa_HelpfulTools_FindPharmacy_Link_Text", ctx_r39.Spa_HelpfulTools_FindPharmacy_Link_Text)("Spa_HelpfulTools_ExternalPharmacyEnabled", ctx_r39.Spa_HelpfulTools_ExternalPharmacyEnabled)("Spa_HelpfulTools_ExternalPrescriptionsEnabled", ctx_r39.Spa_HelpfulTools_ExternalPrescriptionsEnabled)("CSNPEnabled", ctx_r39.Spa_Site_SNPTools_Enabled ? ctx_r39.Spa_PlanCard_CSNP_Indicator_Enabled : false)("DSNPEnabled", ctx_r39.Spa_Site_SNPTools_Enabled ? ctx_r39.Spa_PlanCard_DSNP_Indicator_Enabled : false)("ISNPEnabled", ctx_r39.Spa_Site_SNPTools_Enabled ? ctx_r39.Spa_PlanCard_ISNP_Indicator_Enabled : false)("CSNPText", ctx_r39.Spa_PlanCard_CSNP_Tooltip_Text)("DSNPText", ctx_r39.Spa_PlanCard_DSNP_Tooltip_Text)("ISNPText", ctx_r39.Spa_PlanCard_ISNP_Tooltip_Text)("SNPText", ctx_r39.Spa_PlanCard_SNP_Indicator_Text)("planLogoSize", ctx_r39.Spa_Site_PlanLogo_Size);
} }
function HelpfulToolsPlanListComponent_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HelpfulToolsPlanListComponent_ng_container_16_ng_container_1_Template, 3, 6, "ng-container", 42);
    i0.ɵɵtemplate(2, HelpfulToolsPlanListComponent_ng_container_16_div_2_Template, 3, 19, "div", 43);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.Spa_Site_SNPTools_Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(3, 2, ctx_r7.filteredPlans$));
} }
function HelpfulToolsPlanListComponent_ng_template_18_div_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-snp-toggle", 44);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("showLinkText", ctx_r42.Spa_HelpfulTools_ShowSNPLink_Text)("hideLinkText", ctx_r42.Spa_HelpfulTools_HideSNPLink_Text)("activeTabType", ctx_r42.activeTabType)("filteredPlansHasSNPPlans", i0.ɵɵpipeBind1(2, 4, ctx_r42.filteredPlansHasSNPPlans$));
} }
function HelpfulToolsPlanListComponent_ng_template_18_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48)(1, "div", 49);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 50);
    i0.ɵɵpipe(4, "safe");
    i0.ɵɵtemplate(5, HelpfulToolsPlanListComponent_ng_template_18_div_0_ng_container_5_Template, 3, 6, "ng-container", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r41.tabs[ctx_r41.activeTabIndex] == null ? null : ctx_r41.tabs[ctx_r41.activeTabIndex].tabError.heading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 3, ctx_r41.tabs[ctx_r41.activeTabIndex] == null ? null : ctx_r41.tabs[ctx_r41.activeTabIndex].tabError.body, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r41.Spa_Site_SNPTools_Enabled);
} }
function HelpfulToolsPlanListComponent_ng_template_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, HelpfulToolsPlanListComponent_ng_template_18_div_0_Template, 6, 6, "div", 47);
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r9.totalPlanCount !== 0);
} }
let HelpfulToolsPlanListComponent = class HelpfulToolsPlanListComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, injector, modalService, plansService, planFacade, navigationService, helpfulToolsFacade, helpfulToolsService, helpfulToolsResources, helpfulToolsContext, responsiveLayoutService, memberSessionService, filterService, snpService, router, analyticsService, planListFacade, deepLinkingService, planYearService, planYearResourceService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.cdr = cdr;
        this.widgetValidationService = widgetValidationService;
        this.configurableWidgetService = configurableWidgetService;
        this.zoneService = zoneService;
        this.widgetService = widgetService;
        this.injector = injector;
        this.modalService = modalService;
        this.plansService = plansService;
        this.planFacade = planFacade;
        this.navigationService = navigationService;
        this.helpfulToolsFacade = helpfulToolsFacade;
        this.helpfulToolsService = helpfulToolsService;
        this.helpfulToolsResources = helpfulToolsResources;
        this.helpfulToolsContext = helpfulToolsContext;
        this.responsiveLayoutService = responsiveLayoutService;
        this.memberSessionService = memberSessionService;
        this.filterService = filterService;
        this.snpService = snpService;
        this.router = router;
        this.analyticsService = analyticsService;
        this.planListFacade = planListFacade;
        this.deepLinkingService = deepLinkingService;
        this.planYearService = planYearService;
        this.planYearResourceService = planYearResourceService;
        this.Spa_HelpfulTools_PlanList_PleaseEnterZip_Text = 'Please enter your ZIP code to see plans:';
        this.Spa_PlanFilters_No_Plans_Available_Message = 'Please remove some or clear all your filters to view plans.';
        this.Spa_HelpfulTools_FindPrescriptions_Url = [{ target: '_self', href: '', tag: PageTags.HELPFUL_TOOLS_PHARMACYSEARCH }];
        this.Spa_HelpfulTools_FindPharmacy_Url = [{ target: '_self', href: '', tag: PageTags.HELPFUL_TOOLS_PHARMACYSEARCH }];
        this.Spa_HelpfulTools_FindProviders_Link_Text = 'Find providers';
        this.Spa_HelpfulTools_FindDentists_Link_Text = 'Find dentists';
        this.Spa_HelpfulTools_FindDentists_Link_Enabled = false;
        this.Spa_HelpfulTools_FindPrescriptions_Link_Text = 'Find prescriptions';
        this.Spa_HelpfulTools_FindPharmacy_Link_Text = 'Find pharmacy';
        this.Spa_HelpfulTools_ExternalPharmacyEnabled = false;
        this.Spa_HelpfulTools_ExternalPrescriptionsEnabled = false;
        this.Spa_HelpfulTools_Show_Provider = true;
        this.Spa_Site_Show_PlanLogo = true;
        this.Spa_Site_Plans_Text = 'plans';
        this.Spa_Site_Plan_Text = 'plan';
        this.Spa_Site_ErrorKeyword_Text = 'Error:';
        this.Spa_PlanList_EditZipCode_ButtonLabel = 'Change Zip Code';
        this.Spa_Site_MoreOptions_Text = 'More Options';
        this.Spa_HelpfulTools_ShowSNPLink_Text = 'Add all Special Needs Plans (SNP)';
        this.Spa_HelpfulTools_HideSNPLink_Text = 'Hide all Special Needs Plans (SNP)';
        this.Spa_HelpfulTools_ShowSNPPlansDefault_Flag = false;
        this.Spa_PlanCard_CSNP_Indicator_Enabled = true;
        this.Spa_PlanCard_DSNP_Indicator_Enabled = true;
        this.Spa_PlanCard_ISNP_Indicator_Enabled = true;
        this.Spa_PlanCard_CSNP_Tooltip_Text = 'Chronic Condition Special Needs Plan - This plan is designed for an individual with a severe or disabling chronic condition, as specified by CMS.';
        this.Spa_PlanCard_DSNP_Tooltip_Text = 'Dual Eligible Special Needs Plan - This plan is designed for an individual eligible for both Medicare and Medicaid.';
        this.Spa_PlanCard_ISNP_Tooltip_Text = 'Institutional Special Needs Plan - This plan is designed for an individual residing in a long term care facility.';
        this.Spa_PlanCard_SNP_Indicator_Text = '<snpType> Plan';
        this.Spa_Site_SNPTools_Enabled = true;
        this.Spa_ZipCodeInput_CountyLabel_Text = 'County';
        this.Spa_ZipCodeInput_CountyLabel_Enabled = false;
        this.Spa_Site_PlanLogo_Size = 'small';
        this.Spa_HelpfulTools_ShowDrugAlternatives_Nudge_Enabled = false;
        this.Spa_HelpfulTools_PlanList_ViewPlans_Button_Text = 'View Plans';
        this.Spa_PlanList_PlansAvailableSingular_Text = 'Medicare plan available in';
        this.Spa_PlanList_PlansAvailablePlural_Text = 'Medicare plans available in';
        this.Spa_HelpfulTools_PlansAvailablePlural_Text = 'Medicare plans available';
        this.Spa_DualPlanYear_PlanList_Text_Enabled = true;
        this.Spa_DualPlanYear_Enabled = true;
        this.Spa_DualPlanYear_Update_Enabled = true;
        this.Spa_DualPlanYear_PlanList_Text = 'for <YYYY>';
        this.Spa_PlanList_EditZipCode_Label = 'Click here to change your ZIP code';
        this.Spa_Site_PageSubHeader_Text = '';
        this.tabs = [];
        this.subscriptions = [];
        this.cSNPPlansCount = 0;
        this.dSNPPlansCount = 0;
        this.iSNPPlansCount = 0;
        this.loaded = false;
        this.deepLinkingZipCode = '';
        this.planYearTextEnabled = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.environment = EnvironmentService.getEnvironment();
        // set initial values
        this.setComponentValues();
        // initialize the tabs
        this.initTabs();
        this.initializeContext();
        this.isPlanYearUpdateModalEnabled = this.planListFacade.isPlanYearUpdateModalEnabled(this.widgetName);
        this.planYearTextEnabled = this.planYearResourceService.getIsDualPlanYearSite() && this.Spa_DualPlanYear_PlanList_Text_Enabled;
        if (this.environment.liveedit) {
            this.helpfulToolsService.rehydrateHelpfulToolsZipAndFips();
        }
        // fetch the plans
        this.fetchPlans();
        // set default SNP toggle state
        this.toggleSNPPlanVisibility(this.Spa_HelpfulTools_ShowSNPPlansDefault_Flag);
        // Get prepared observables for presentation layer from facade
        this.visiblePlanCountsByTabIndex$ = this.helpfulToolsFacade.visiblePlanCountsByTabIndex$;
        this.totalPlanCount$ = this.helpfulToolsFacade.totalPlanCount$;
        this.cSNPPlansCount$ = this.planListFacade.getFilteredCSNPPlansCount$();
        this.dSNPPlansCount$ = this.planListFacade.getFilteredDSNPPlansCount$();
        this.iSNPPlansCount$ = this.planListFacade.getFilteredISNPPlansCount$();
        this.activeTabIndex$ = this.helpfulToolsFacade.activeTabIndex$;
        this.lastActiveTabThatIsNotDefault$ = this.helpfulToolsFacade.lastActiveTabThatIsNotDefault$;
        this.filteredPlans$ = this.helpfulToolsFacade.filteredPlans$;
        this.filteredPlansHasSNPPlans$ = this.helpfulToolsFacade.filteredPlansHasSNPPlans$;
        if (this.Spa_ZipCodeInput_CountyLabel_Enabled) {
            this.stateCountyInformationalText$ = this.planFacade.getStateCountyInformationalText$(this.helpfulToolsContext.isHelpfulToolsView);
        }
        // Apply licensing filters, regardless if feature is enabled or not for regular plan list
        this.applyLicensingFilters();
        this.googleTagManagerNotApplicableText = this.analyticsService.getGoogleTagManagerNotApplicableText();
        this.subscriptions = [
            // display friendly spinner
            this.loading$.subscribe({
                next: loading => {
                    loading
                        ? this.configurableWidgetService.spinnerService.show(SpinnerEvent.PLANS_LOADING)
                        : this.configurableWidgetService.spinnerService.hide(SpinnerEvent.PLANS_LOADING);
                }
            }),
            this.loaded$.subscribe({
                next: loaded => {
                    this.loaded = loaded;
                    this.cdr.markForCheck();
                }
            }),
            this.deepLinkingZipCode$.subscribe({
                next: deepLinkingZipCode => {
                    this.deepLinkingZipCode = deepLinkingZipCode;
                    this.cdr.markForCheck();
                }
            }),
            this.responsiveLayoutService.isCompact$.subscribe({
                next: compact => {
                    if (this.mobile !== compact) {
                        this.mobile = compact;
                        this.cdr.markForCheck();
                    }
                }
            }),
            this.filteredPlans$.subscribe({
                next: planCount => {
                    this.currentTabPlanCount = planCount?.length;
                }
            }),
            this.helpfulToolsFacade.defaultPlansTabType$.subscribe({
                next: planType => {
                    this.helpfulToolsFacade.updateDefaultTab(planType);
                }
            }),
            this.activeTabIndex$.subscribe({
                next: activeTabIndex => {
                    this.activeTabIndex = activeTabIndex;
                    this.cdr.markForCheck();
                }
            }),
            this.currentLocale$.subscribe({
                next: locale => {
                    this.tabData = this.helpfulToolsFacade.getPreparedTabData();
                    this.tabs = this.tabData.map((tab, index) => new FilterTab(tab, index));
                    this.helpfulToolsContext.setTabs(this.tabs);
                    this.cdr.markForCheck();
                }
            }),
            this.activeTabType$.subscribe({
                next: activeTabType => {
                    this.activeTabType = activeTabType;
                    this.cdr.markForCheck();
                }
            }),
            this.totalPlanCount$.subscribe({
                next: totalPlanCount => {
                    this.totalPlanCount = totalPlanCount;
                    this.cdr.markForCheck();
                }
            }),
            this.cSNPPlansCount$.subscribe({
                next: cSNPPlansCount => {
                    this.cSNPPlansCount = cSNPPlansCount;
                    this.cdr.markForCheck();
                }
            }),
            this.dSNPPlansCount$.subscribe({
                next: dSNPPlansCount => {
                    this.dSNPPlansCount = dSNPPlansCount;
                    this.cdr.markForCheck();
                }
            }),
            this.iSNPPlansCount$.subscribe({
                next: iSNPPlansCount => {
                    this.iSNPPlansCount = iSNPPlansCount;
                    this.cdr.markForCheck();
                }
            }),
            this.planYearResourceService.getSelectedPlanYear$().subscribe({
                next: selectedPlanYear => {
                    this.selectedPlanYear = selectedPlanYear;
                    this.setDualPlanYearText(selectedPlanYear);
                    this.cdr.markForCheck();
                }
            })
        ];
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.forEach(sub => {
            sub.unsubscribe();
        });
    }
    initTabs() {
        // initialize the tabs
        this.tabs = this.tabData.map((tab, index) => new FilterTab(tab, index));
        this.tabData.forEach(tab => {
            this.configurableWidgetService.filterService.setFilterGroup({
                groupKey: new Filter({ key: FilterKeyType.PLAN_TYPE_SHORT, values: tab.tabTypes }),
                filters: []
            });
        });
    }
    editZipCode() {
        const options = {
            ariaLabelledBy: 'modalHeaderTitle',
            centered: true,
            injector: this.injector
        };
        const zipCodeModal = this.modalService.open(ZipCodeModalComponent, options);
        zipCodeModal.componentInstance.retrieveZipCode = this.helpfulToolsService.getZipCodeSelected;
        zipCodeModal.componentInstance.retrieveFipsCode = this.helpfulToolsService.getFipsCodeSelected;
        zipCodeModal.componentInstance.retrieveCounties = this.helpfulToolsService.getHelpfulToolsCounties;
        zipCodeModal.componentInstance.continueButtonAction = () => {
            this.selectHelpfulToolsZip(zipCodeModal);
        };
        zipCodeModal.result
            .then(async () => {
            this.plansService.resetPlans();
            await this.fetchPlans();
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE,
                ...this.tagsToUpdate()
            };
        })
            .catch(() => {
            // eat the error to prevent a console error
        });
    }
    onPlanYearUpdate() {
        // Disabling the active tab's plan count check before clearing the plan year session ensures to keep the current active tab.
        // This will prevent any undesired automatic selections while the plans and plan counts are being updated.
        // Once it is done, we will enabled it back to check if the current tab still has coverage or we should select another automatically
        this.plansService.setActiveTabPlanCountCheckEnabled(false);
        this.planYearService.clearPlanYearSessionData();
        this.fetchPlans();
    }
    async fetchPlans() {
        const memberData = this.memberSessionService.getMemberSession();
        const agentGuid = this.configurableWidgetService.store.selectSnapshot(AgentState.agentGuid);
        const zip = this.helpfulToolsService.getZipCodeSelected();
        const fips = this.helpfulToolsService.getFipsCodeSelected();
        const demographicsOptions = { zip, fips };
        let currentYearPlanId;
        if (memberData?.currentYearPlanID) {
            currentYearPlanId = memberData.currentYearPlanID;
        }
        const hasValues = zip && fips;
        const activePlanType = this.plansService.getActivePlanType(this.activeTabType, this.tabs);
        if (hasValues && this.plansService.getArePlansDirty(activePlanType) && !this.plansService.getArePlansLoading(activePlanType)) {
            const overrideSearchOptions = { planType: activePlanType.toString() };
            const searchOptions = this.plansService.createPlansSearchOptionsWithDefaults(overrideSearchOptions);
            await this.plansService.fetchPlansByOptionsAndSave({ demographicsOptions, searchOptions, currentYearPlanId, agentGuid });
        }
        else {
            this.helpfulToolsService.rehydrateHelpfulToolsZipAndFips();
        }
    }
    async viewPlansOnClick() {
        if (this.widgetValidationService.validate().length === 0) {
            await this.fetchPlans();
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE,
                ...this.tagsToUpdate()
            };
        }
    }
    mobileTabs(lastActiveTab) {
        return this.helpfulToolsFacade.getMobileTabs(lastActiveTab);
    }
    updateZip(zip) {
        this.helpfulToolsService.selectZipCode(zip);
    }
    updateFips(fips) {
        this.helpfulToolsService.selectFipsCode(fips);
    }
    shiftFocusToTabElement(focusIndex) {
        if (this.helpfulToolsPlanListTabElement) {
            this.helpfulToolsPlanListTabElement.forEach(tabElement => tabElement.nativeElement.firstElementChild.setAttribute('tabindex', '-1'));
            const optionElement = this.helpfulToolsPlanListTabElement.find((_element, index) => index === focusIndex);
            if (optionElement) {
                optionElement.nativeElement.firstElementChild.setAttribute('tabindex', '0');
                optionElement.nativeElement.firstElementChild.focus();
            }
        }
    }
    tagsToUpdate() {
        const planCount = !this.currentTabPlanCount ? '0' : this.currentTabPlanCount.toString();
        const selectedZip = this.helpfulToolsService.getZipCodeSelected();
        const selectedFips = this.helpfulToolsService.getFipsCodeSelected();
        return {
            [DataLayerGlobalVariable.PAGE_TAB_NAME]: this.tabData && this.activeTabIndex >= 0 ? this.tabData[this.activeTabIndex].tabTypes[0] : null,
            [DataLayerGlobalVariable.PLANS_COUNT]: planCount,
            [DataLayerGlobalVariable.CSNP_PLAN_COUNT]: this.cSNPPlansCount.toString(),
            [DataLayerGlobalVariable.DSNP_PLAN_COUNT]: this.dSNPPlansCount.toString(),
            [DataLayerGlobalVariable.ISNP_PLAN_COUNT]: this.iSNPPlansCount.toString(),
            [DataLayerGlobalVariable.PLAN_TYPE]: this.activeTabType ? this.activeTabType : this.googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
            [DataLayerGlobalVariable.ZIP]: selectedZip || null,
            [DataLayerGlobalVariable.COUNTY_FIPS]: selectedFips || null
        };
    }
    toggleSNPPlanVisibility(SNPVisibility) {
        this.snpService.setAllSNPTypesVisibility(SNPVisibility);
    }
    setComponentValues() {
        this.loading$ = this.helpfulToolsFacade.getLoadingStatus$(ALL_MEDICARE_PLAN_TYPE_VALUE);
        this.loaded$ = this.helpfulToolsFacade.getLoadedStatus$(ALL_MEDICARE_PLAN_TYPE_VALUE);
        this.filterGroups$ = this.helpfulToolsFacade.getFilterGroups$();
        this.activeTabType$ = this.helpfulToolsFacade.getActiveTabType$();
        this.zipCode$ = this.helpfulToolsFacade.getMemberZipcode$();
        this.deepLinkingZipCode$ = this.deepLinkingService.getDeepLinkingParam$(DeepLinkingParamKey.ZIP);
        this.plans$ = this.helpfulToolsFacade.getPlans$();
        this.helpfulToolsContext.isHelpfulToolsView = true;
        // get tab data.
        this.tabData = this.helpfulToolsFacade.getPreparedTabData();
    }
    initializeContext() {
        const excludedPlanTypes = this.helpfulToolsContext.getDefaultExcludedPlanTypes();
        this.helpfulToolsContext.setTabs(this.tabs);
        this.helpfulToolsContext.setHasExclusion(true);
        this.helpfulToolsContext.setExcludedPlanTypes(excludedPlanTypes);
        this.helpfulToolsContext.hideFormularyAndFootnotes();
    }
    navigateAfterUpdate(pageTag, zipCodeModal) {
        this.navigationService
            .navigate({
            title: '',
            type: LinkType.INTERNAL,
            tag: pageTag,
            validateWidgets: false
        })
            .then(success => {
            if (success) {
                zipCodeModal.close();
            }
        });
    }
    selectHelpfulToolsZip(zipCodeModal) {
        this.navigateAfterUpdate(PageTags.HELPFUL_TOOLS, zipCodeModal);
    }
    applyLicensingFilters() {
        const tabFilters = [];
        this.tabs.forEach(tab => {
            tabFilters.push(tab.filters);
        });
        tabFilters.forEach(tabFilter => {
            this.filterService.addFilterToFilterGroups(tabFilter, new Filter({ key: FilterKeyType.PLAN_ISPUF, values: [true], comparator: ComparatorType.NOT_EQUAL }));
        });
    }
    setDualPlanYearText(selectedPlanYear) {
        if (this.planYearTextEnabled) {
            const dualPlanYearChunks = this.Spa_DualPlanYear_PlanList_Text.split('<YYYY>');
            this.dualPlanYearPrefix = dualPlanYearChunks[0];
            this.dualPlanYear = `${selectedPlanYear || ''}`;
            this.dualPlanYearPostfix = dualPlanYearChunks[1];
        }
    }
};
HelpfulToolsPlanListComponent.ɵfac = function HelpfulToolsPlanListComponent_Factory(t) { return new (t || HelpfulToolsPlanListComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(HelpfulToolsFacade), i0.ɵɵdirectiveInject(HelpfulToolsService), i0.ɵɵdirectiveInject(HelpfulToolsResourceFacade), i0.ɵɵdirectiveInject(HelpfulToolsContextService), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.FilterService), i0.ɵɵdirectiveInject(i1.SNPService), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(PlanListFacadeService), i0.ɵɵdirectiveInject(i1.DeepLinkingService), i0.ɵɵdirectiveInject(i1.PlanYearService), i0.ɵɵdirectiveInject(i1.PlanYearResourceService)); };
HelpfulToolsPlanListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HelpfulToolsPlanListComponent, selectors: [["vnext-helpful-tools-plan-list"]], viewQuery: function HelpfulToolsPlanListComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1K, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.helpfulToolsPlanListTabElement = _t);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 20, vars: 16, consts: [["vnextGoogleTagManager", "", 1, "container", 3, "disableCommonEvent", "tagsToUpdate", "shouldUpdateTags"], [1, "row"], [1, "col-md-12", "text-center"], ["class", "Spa_Style_H1 plan-list-title", 4, "liveEditProp"], [1, "Spa_Style_Paragraph", "text-center", "mb-2", "mt-2", "no-translate-block"], [1, "col-12", "mt-4"], ["navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["role", "tablist", "class", "row d-flex justify-content-center tabs", 4, "ngIf"], ["class", "row justify-content-center tabs", 4, "ngIf"], ["id", "helpful-tools-container", "role", "tabpanel"], ["class", "row", 4, "ngIf", "ngIfElse"], ["showZipInput", ""], [1, "mt-2"], [4, "ngIf", "ngIfElse"], ["showNoPlansAvailable", ""], [1, "Spa_Style_H1", "plan-list-title"], ["tabindex", "0", "class", "zip-code-link Spa_Style_Largest_Font Spa_Style_Link action-button", "role", "button", 3, "title", "click", 4, "ngIf", "ngIfElse"], ["useDemographics", ""], [3, "dualPlanYearPrefix", "isPlanYearUpdateModalEnabled", "dualPlanYearText", "dualPlanYear", "dualPlanYearPostfix", "onPlanYearUpdate", 4, "ngIf"], ["tabindex", "0", "role", "button", 1, "zip-code-link", "Spa_Style_Largest_Font", "Spa_Style_Link", "action-button", 3, "title", "click"], ["aria-hidden", "true", 1, "fa", "fa-edit", "ml-2"], ["class", "zip-code-link Spa_Style_Largest_Font Spa_Style_Link", "role", "button", 3, "title", "click", 4, "ngIf"], ["role", "button", 1, "zip-code-link", "Spa_Style_Largest_Font", "Spa_Style_Link", 3, "title", "click"], ["aria-hidden", "true", 1, "fas", "fa-edit", "ml-2"], [3, "dualPlanYearPrefix", "isPlanYearUpdateModalEnabled", "dualPlanYearText", "dualPlanYear", "dualPlanYearPostfix", "onPlanYearUpdate"], ["navigationAdapter", "", 3, "innerHtml"], ["role", "tablist", 1, "row", "d-flex", "justify-content-center", "tabs"], [3, "tabData", "isActive", "plansText", "planText", "currentIndex", "lastIndex", "ariaControlsId", "setFocusToTabEvent", 4, "ngFor", "ngForOf"], [3, "tabData", "isActive", "plansText", "planText", "currentIndex", "lastIndex", "ariaControlsId", "setFocusToTabEvent"], ["helpfulToolsPlanTab", ""], [1, "row", "justify-content-center", "tabs"], [3, "tabData", "isActive", "plansText", "planText"], [3, "tabData", "isActive", "plansText", "planText", 4, "ngIf"], ["class", "mobile-tab", 3, "mobileTab", "dropdownTabs", "moreOptionsText", 4, "ngIf"], [1, "mobile-tab", 3, "mobileTab", "dropdownTabs", "moreOptionsText"], ["navigationAdapter", "", 1, "Spa_Style_Regular", "ml-3", "mr-3", "mb-0", 3, "innerHTML"], [1, "col-xs-8", "col-md-6", "pl-5", "pl-md-0", "offset-xs-2", "offset-md-4"], [1, "Spa_Style_Paragraph"], [3, "retrieveZipCode", "retrieveFipsCode", "retrieveCounties", "selectedCountyEnabled", "zipCodeErrorText", "countyErrorText", "selectCountyText", "zipCodeText", "editCountyText", "searchButtonTemplate", "errorKeywordText", "countyLabel", "showCountyLabel", "logAnalytics", "zip", "fips", "keyup.enter"], ["helpfulToolsZipCodeButton", ""], ["id", "helpfultools_zip_button", "class", "btn Spa_Style_PrimaryButton", 3, "click", 4, "liveEditProp"], ["id", "helpfultools_zip_button", 1, "btn", "Spa_Style_PrimaryButton", 3, "click"], [4, "ngIf"], ["class", "row", 4, "ngFor", "ngForOf"], [3, "showLinkText", "hideLinkText", "activeTabType", "filteredPlansHasSNPPlans"], [1, "col-12"], [3, "plan", "Spa_Site_Show_PlanLogo", "Spa_HelpfulTools_FindPrescriptions_Url", "Spa_HelpfulTools_FindPharmacy_Url", "Spa_HelpfulTools_FindProviders_Link_Text", "Spa_HelpfulTools_FindPrescriptions_Link_Text", "Spa_HelpfulTools_FindDentists_Link_Text", "Spa_HelpfulTools_FindDentists_Link_Enabled", "Spa_HelpfulTools_FindPharmacy_Link_Text", "Spa_HelpfulTools_ExternalPharmacyEnabled", "Spa_HelpfulTools_ExternalPrescriptionsEnabled", "CSNPEnabled", "DSNPEnabled", "ISNPEnabled", "CSNPText", "DSNPText", "ISNPText", "SNPText", "planLogoSize"], ["class", "col-md-12 no-plan-error", 4, "ngIf"], [1, "col-md-12", "no-plan-error"], [1, "Spa_Style_Large_Font", "font-weight-bold"], ["navigationAdapter", "", 1, "Spa_Style_H5", 3, "innerHTML"]], template: function HelpfulToolsPlanListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, HelpfulToolsPlanListComponent_h1_3_Template, 7, 7, "h1", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtext(5);
        i0.ɵɵpipe(6, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵtemplate(8, HelpfulToolsPlanListComponent_div_8_Template, 2, 4, "div", 6);
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(9, HelpfulToolsPlanListComponent_div_9_Template, 2, 1, "div", 7);
        i0.ɵɵtemplate(10, HelpfulToolsPlanListComponent_div_10_Template, 4, 6, "div", 8);
        i0.ɵɵelementStart(11, "div", 9);
        i0.ɵɵtemplate(12, HelpfulToolsPlanListComponent_div_12_Template, 3, 4, "div", 10);
        i0.ɵɵtemplate(13, HelpfulToolsPlanListComponent_ng_template_13_Template, 7, 15, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(15, "div", 12);
        i0.ɵɵtemplate(16, HelpfulToolsPlanListComponent_ng_container_16_Template, 4, 4, "ng-container", 13);
        i0.ɵɵpipe(17, "async");
        i0.ɵɵtemplate(18, HelpfulToolsPlanListComponent_ng_template_18_Template, 1, 1, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        const _r5 = i0.ɵɵreference(14);
        const _r8 = i0.ɵɵreference(19);
        let tmp_10_0;
        i0.ɵɵproperty("disableCommonEvent", true)("tagsToUpdate", ctx.tagsToUpdate())("shouldUpdateTags", !ctx.deepLinkingZipCode || ctx.loaded);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", ctx.totalPlanCount === 1 ? "Spa_PlanList_PlansAvailableSingular_Text" : ctx.totalPlanCount === 0 ? "Spa_HelpfulTools_PlansAvailablePlural_Text" : "Spa_PlanList_PlansAvailablePlural_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 12, ctx.stateCountyInformationalText$), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_PageSubHeader_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.tabs && ctx.tabs.length && !ctx.mobile);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.tabs && ctx.tabs.length && ctx.mobile);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.totalPlanCount !== 0)("ngIfElse", _r5);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", (tmp_10_0 = i0.ɵɵpipeBind1(17, 14, ctx.filteredPlans$)) == null ? null : tmp_10_0.length)("ngIfElse", _r8);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, ZipCodeInputComponent, SNPToggleComponent, NavigationAdapterDirective, LiveEditPropDirective, GoogleTagManagerDirective, IconAriaAttributesDirective, HelpfulToolsPlanCardComponent, FilterTabComponent, PlanYearLabelComponent, i1$2.AsyncPipe, SafePipe], styles: ["vnext-filter-tab[_ngcontent-%COMP%]{margin-right:6px;margin-left:6px;max-width:22%;min-width:22%;min-height:100%;margin-bottom:-1px}.no-plan-error[_ngcontent-%COMP%]{white-space:pre-line;text-align:center;margin-top:80px;line-height:28px}.no-plan-error[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{font-weight:700;text-align:center}.plan-list-title[_ngcontent-%COMP%]{margin-top:60px;margin-bottom:10px}.zip-code-link[_ngcontent-%COMP%]{text-decoration:underline;position:relative}.fa-edit[_ngcontent-%COMP%]{position:relative;top:-6px}.zip-code-link[_ngcontent-%COMP%]   .fa-edit[_ngcontent-%COMP%]{font-size:.5em}.tabs[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Accent1);margin-bottom:30px}select[_ngcontent-%COMP%]{width:100%}.mobile-tab[_ngcontent-%COMP%]{max-width:20%;min-width:20%}@media (max-width: 768px){vnext-filter-tab[_ngcontent-%COMP%]{max-width:33%;min-width:33%}}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_HelpfulTools_PlanList_PleaseEnterZip_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_PlanFilters_No_Plans_Available_Message", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_HelpfulTools_FindPrescriptions_Url", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_HelpfulTools_FindPharmacy_Url", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_HelpfulTools_FindProviders_Link_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_HelpfulTools_FindDentists_Link_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_HelpfulTools_FindDentists_Link_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_HelpfulTools_FindPrescriptions_Link_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_HelpfulTools_FindPharmacy_Link_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_HelpfulTools_ExternalPharmacyEnabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_HelpfulTools_ExternalPrescriptionsEnabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_HelpfulTools_Show_Provider", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_Site_Show_PlanLogo", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_Site_Plans_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_Site_Plan_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_Site_ErrorKeyword_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_PlanList_EditZipCode_ButtonLabel", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_Site_MoreOptions_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_HelpfulTools_ShowSNPLink_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_HelpfulTools_HideSNPLink_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_HelpfulTools_ShowSNPPlansDefault_Flag", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_PlanCard_CSNP_Indicator_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_PlanCard_DSNP_Indicator_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_PlanCard_ISNP_Indicator_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_PlanCard_CSNP_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_PlanCard_DSNP_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_PlanCard_ISNP_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_PlanCard_SNP_Indicator_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_Site_SNPTools_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Text", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_Site_PlanLogo_Size", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_HelpfulTools_ShowDrugAlternatives_Nudge_Enabled", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPlanListComponent.prototype, "Spa_HelpfulTools_PlanList_ViewPlans_Button_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPlanListComponent.prototype, "Spa_PlanList_PlansAvailableSingular_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPlanListComponent.prototype, "Spa_PlanList_PlansAvailablePlural_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPlanListComponent.prototype, "Spa_HelpfulTools_PlansAvailablePlural_Text", void 0);
__decorate([
    GlobalResource(true)
], HelpfulToolsPlanListComponent.prototype, "Spa_DualPlanYear_PlanList_Text_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_DualPlanYear_Enabled", void 0);
__decorate([
    GlobalResource()
], HelpfulToolsPlanListComponent.prototype, "Spa_DualPlanYear_Update_Enabled", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPlanListComponent.prototype, "Spa_DualPlanYear_PlanList_Text", void 0);
__decorate([
    PlatformProp()
], HelpfulToolsPlanListComponent.prototype, "Spa_PlanList_EditZipCode_Label", void 0);
__decorate([
    PlatformProp('live-edit')
], HelpfulToolsPlanListComponent.prototype, "Spa_Site_PageSubHeader_Text", void 0);
__decorate([
    LiveEditInactive()
], HelpfulToolsPlanListComponent.prototype, "editZipCode", null);
__decorate([
    LiveEditInactive()
], HelpfulToolsPlanListComponent.prototype, "viewPlansOnClick", null);
HelpfulToolsPlanListComponent = __decorate([
    PlatformWidget
], HelpfulToolsPlanListComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HelpfulToolsPlanListComponent, [{
        type: Component,
        args: [{ selector: 'vnext-helpful-tools-plan-list', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div\r\n  class=\"container\"\r\n  vnextGoogleTagManager\r\n  [disableCommonEvent]=\"true\"\r\n  [tagsToUpdate]=\"tagsToUpdate()\"\r\n  [shouldUpdateTags]=\"!deepLinkingZipCode || loaded\"\r\n>\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12 text-center\">\r\n      <h1\r\n        class=\"Spa_Style_H1 plan-list-title\"\r\n        *liveEditProp=\"\r\n          totalPlanCount === 1\r\n            ? 'Spa_PlanList_PlansAvailableSingular_Text'\r\n            : totalPlanCount === 0\r\n            ? 'Spa_HelpfulTools_PlansAvailablePlural_Text'\r\n            : 'Spa_PlanList_PlansAvailablePlural_Text'\r\n        \"\r\n      >\r\n        {{ totalPlanCount }}\r\n        {{\r\n          totalPlanCount === 1\r\n            ? Spa_PlanList_PlansAvailableSingular_Text\r\n            : totalPlanCount === 0\r\n            ? Spa_HelpfulTools_PlansAvailablePlural_Text\r\n            : Spa_PlanList_PlansAvailablePlural_Text\r\n        }}\r\n        <button\r\n          *ngIf=\"totalPlanCount && (helpfulToolsService.getZipCode$() | async); else useDemographics\"\r\n          tabindex=\"0\"\r\n          class=\"zip-code-link Spa_Style_Largest_Font Spa_Style_Link action-button\"\r\n          title=\"{{ Spa_PlanList_EditZipCode_Label }}\"\r\n          (click)=\"editZipCode()\"\r\n          role=\"button\"\r\n          [attr.aria-label]=\"Spa_PlanList_EditZipCode_ButtonLabel\"\r\n        >\r\n          {{ helpfulToolsService.getZipCode$() | async }}<i aria-hidden=\"true\" class=\"fa fa-edit ml-2\"></i>\r\n        </button>\r\n        <ng-template #useDemographics>\r\n          <span\r\n            *ngIf=\"zipCode$ | async\"\r\n            class=\"zip-code-link Spa_Style_Largest_Font Spa_Style_Link\"\r\n            title=\"{{ Spa_PlanList_EditZipCode_Label }}\"\r\n            (click)=\"editZipCode()\"\r\n            role=\"button\"\r\n            [attr.aria-label]=\"Spa_PlanList_EditZipCode_ButtonLabel\"\r\n            >{{ zipCode$ | async }}<i aria-hidden=\"true\" class=\"fas fa-edit ml-2\"></i>\r\n          </span>\r\n        </ng-template>\r\n        <vnext-plan-year-label\r\n          *ngIf=\"planYearTextEnabled\"\r\n          [dualPlanYearPrefix]=\"dualPlanYearPrefix\"\r\n          [isPlanYearUpdateModalEnabled]=\"isPlanYearUpdateModalEnabled\"\r\n          [dualPlanYearText]=\"dualPlanYear\"\r\n          [dualPlanYear]=\"dualPlanYear\"\r\n          [dualPlanYearPostfix]=\"dualPlanYearPostfix\"\r\n          (onPlanYearUpdate)=\"onPlanYearUpdate()\"\r\n        ></vnext-plan-year-label>\r\n      </h1>\r\n      <div class=\"Spa_Style_Paragraph text-center mb-2 mt-2 no-translate-block\">\r\n        {{ stateCountyInformationalText$ | async }}\r\n      </div>\r\n      <div class=\"col-12 mt-4\">\r\n        <div\r\n          *liveEditProp=\"'Spa_Site_PageSubHeader_Text'\"\r\n          [innerHtml]=\"Spa_Site_PageSubHeader_Text ? (Spa_Site_PageSubHeader_Text | safe : 'html') : ''\"\r\n          navigationAdapter\r\n        ></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div role=\"tablist\" *ngIf=\"tabs && tabs.length && !mobile\" class=\"row d-flex justify-content-center tabs\">\r\n    <vnext-filter-tab\r\n      #helpfulToolsPlanTab\r\n      *ngFor=\"let tab of tabs; index as i\"\r\n      [tabData]=\"tab\"\r\n      [isActive]=\"i === activeTabIndex\"\r\n      [plansText]=\"Spa_Site_Plans_Text\"\r\n      [planText]=\"Spa_Site_Plan_Text\"\r\n      [currentIndex]=\"i\"\r\n      [lastIndex]=\"tabs.length - 1\"\r\n      (setFocusToTabEvent)=\"shiftFocusToTabElement($event)\"\r\n      [ariaControlsId]=\"'helpful-tools-container'\"\r\n    >\r\n    </vnext-filter-tab>\r\n  </div>\r\n  <div *ngIf=\"tabs && tabs.length && mobile\" class=\"row justify-content-center tabs\">\r\n    <!--  since its sorted primary tab is 0 -->\r\n    <vnext-filter-tab\r\n      [tabData]=\"tabs[0]\"\r\n      [isActive]=\"tabs[0].tabIndex === activeTabIndex\"\r\n      [plansText]=\"Spa_Site_Plans_Text\"\r\n      [planText]=\"Spa_Site_Plan_Text\"\r\n    >\r\n    </vnext-filter-tab>\r\n    <!-- selected tab, will be tab 1 (secondary default) if no selected tab -->\r\n    <vnext-filter-tab\r\n      *ngIf=\"tabs.length > 1\"\r\n      [tabData]=\"(lastActiveTabThatIsNotDefault$ | async) || tabs[1]\"\r\n      [isActive]=\"(lastActiveTabThatIsNotDefault$ | async)?.tabIndex === activeTabIndex\"\r\n      [plansText]=\"Spa_Site_Plans_Text\"\r\n      [planText]=\"Spa_Site_Plan_Text\"\r\n    >\r\n    </vnext-filter-tab>\r\n    <!-- show the more tab only if there are more than 2 tabs -->\r\n    <vnext-filter-tab\r\n      class=\"mobile-tab\"\r\n      *ngIf=\"tabs.length > 2\"\r\n      [mobileTab]=\"true\"\r\n      [dropdownTabs]=\"mobileTabs(lastActiveTabThatIsNotDefault$ | async)\"\r\n      [moreOptionsText]=\"Spa_Site_MoreOptions_Text\"\r\n    ></vnext-filter-tab>\r\n  </div>\r\n  <div id=\"helpful-tools-container\" role=\"tabpanel\">\r\n    <div class=\"row\" *ngIf=\"totalPlanCount !== 0; else showZipInput\">\r\n      <div\r\n        class=\"Spa_Style_Regular ml-3 mr-3 mb-0\"\r\n        [innerHTML]=\"tabs[activeTabIndex]?.planTabEducationalText | safe : 'html'\"\r\n        navigationAdapter\r\n      ></div>\r\n    </div>\r\n    <ng-template #showZipInput>\r\n      <div class=\"row\">\r\n        <div class=\"col-xs-8 col-md-6 pl-5 pl-md-0 offset-xs-2 offset-md-4\">\r\n          <div class=\"Spa_Style_Paragraph\">\r\n            {{ Spa_HelpfulTools_PlanList_PleaseEnterZip_Text }}\r\n          </div>\r\n          <vnext-zip-code-input\r\n            [retrieveZipCode]=\"helpfulToolsFacade.zipCodeAction\"\r\n            [retrieveFipsCode]=\"helpfulToolsFacade.fipsCodeAction\"\r\n            [retrieveCounties]=\"helpfulToolsFacade.helpfulToolsCounties\"\r\n            [selectedCountyEnabled]=\"helpfulToolsResources.getSelectedCountyEnabled()\"\r\n            [zipCodeErrorText]=\"helpfulToolsResources.getZipCodeErrorText()\"\r\n            [countyErrorText]=\"helpfulToolsResources.getCountyErrorText()\"\r\n            [selectCountyText]=\"helpfulToolsResources.getSelectCountyText()\"\r\n            [zipCodeText]=\"helpfulToolsResources.getZipCodeText()\"\r\n            [editCountyText]=\"helpfulToolsResources.getEditCountyText()\"\r\n            [searchButtonTemplate]=\"helpfulToolsZipCodeButton\"\r\n            (zip)=\"updateZip($event)\"\r\n            (fips)=\"updateFips($event)\"\r\n            [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n            [countyLabel]=\"Spa_ZipCodeInput_CountyLabel_Text\"\r\n            [showCountyLabel]=\"Spa_ZipCodeInput_CountyLabel_Enabled\"\r\n            [logAnalytics]=\"!deepLinkingZipCode || loaded\"\r\n            (keyup.enter)=\"viewPlansOnClick()\"\r\n          >\r\n            <ng-template #helpfulToolsZipCodeButton>\r\n              <button\r\n                *liveEditProp=\"'Spa_HelpfulTools_PlanList_ViewPlans_Button_Text'\"\r\n                id=\"helpfultools_zip_button\"\r\n                class=\"btn Spa_Style_PrimaryButton\"\r\n                (click)=\"viewPlansOnClick()\"\r\n              >\r\n                {{ Spa_HelpfulTools_PlanList_ViewPlans_Button_Text }}\r\n              </button>\r\n            </ng-template>\r\n          </vnext-zip-code-input>\r\n        </div>\r\n      </div>\r\n    </ng-template>\r\n    <div class=\"mt-2\">\r\n      <ng-container *ngIf=\"(filteredPlans$ | async)?.length; else showNoPlansAvailable\">\r\n        <ng-container *ngIf=\"Spa_Site_SNPTools_Enabled\">\r\n          <vnext-snp-toggle\r\n            [showLinkText]=\"Spa_HelpfulTools_ShowSNPLink_Text\"\r\n            [hideLinkText]=\"Spa_HelpfulTools_HideSNPLink_Text\"\r\n            [activeTabType]=\"activeTabType\"\r\n            [filteredPlansHasSNPPlans]=\"filteredPlansHasSNPPlans$ | async\"\r\n          >\r\n          </vnext-snp-toggle>\r\n        </ng-container>\r\n        <div class=\"row\" *ngFor=\"let plan of filteredPlans$ | async\">\r\n          <div class=\"col-12\">\r\n            <vnext-helpful-tools-plancard\r\n              [plan]=\"plan\"\r\n              [Spa_Site_Show_PlanLogo]=\"Spa_Site_Show_PlanLogo\"\r\n              [Spa_HelpfulTools_FindPrescriptions_Url]=\"Spa_HelpfulTools_FindPrescriptions_Url\"\r\n              [Spa_HelpfulTools_FindPharmacy_Url]=\"Spa_HelpfulTools_FindPharmacy_Url\"\r\n              [Spa_HelpfulTools_FindProviders_Link_Text]=\"Spa_HelpfulTools_FindProviders_Link_Text\"\r\n              [Spa_HelpfulTools_FindPrescriptions_Link_Text]=\"Spa_HelpfulTools_FindPrescriptions_Link_Text\"\r\n              [Spa_HelpfulTools_FindDentists_Link_Text]=\"Spa_HelpfulTools_FindDentists_Link_Text\"\r\n              [Spa_HelpfulTools_FindDentists_Link_Enabled]=\"Spa_HelpfulTools_FindDentists_Link_Enabled\"\r\n              [Spa_HelpfulTools_FindPharmacy_Link_Text]=\"Spa_HelpfulTools_FindPharmacy_Link_Text\"\r\n              [Spa_HelpfulTools_ExternalPharmacyEnabled]=\"Spa_HelpfulTools_ExternalPharmacyEnabled\"\r\n              [Spa_HelpfulTools_ExternalPrescriptionsEnabled]=\"Spa_HelpfulTools_ExternalPrescriptionsEnabled\"\r\n              [CSNPEnabled]=\"Spa_Site_SNPTools_Enabled ? Spa_PlanCard_CSNP_Indicator_Enabled : false\"\r\n              [DSNPEnabled]=\"Spa_Site_SNPTools_Enabled ? Spa_PlanCard_DSNP_Indicator_Enabled : false\"\r\n              [ISNPEnabled]=\"Spa_Site_SNPTools_Enabled ? Spa_PlanCard_ISNP_Indicator_Enabled : false\"\r\n              [CSNPText]=\"Spa_PlanCard_CSNP_Tooltip_Text\"\r\n              [DSNPText]=\"Spa_PlanCard_DSNP_Tooltip_Text\"\r\n              [ISNPText]=\"Spa_PlanCard_ISNP_Tooltip_Text\"\r\n              [SNPText]=\"Spa_PlanCard_SNP_Indicator_Text\"\r\n              [planLogoSize]=\"Spa_Site_PlanLogo_Size\"\r\n            ></vnext-helpful-tools-plancard>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n      <ng-template #showNoPlansAvailable>\r\n        <div class=\"col-md-12 no-plan-error\" *ngIf=\"totalPlanCount !== 0\">\r\n          <div class=\"Spa_Style_Large_Font font-weight-bold\">{{ tabs[activeTabIndex]?.tabError.heading }}</div>\r\n          <div class=\"Spa_Style_H5\" [innerHTML]=\"tabs[activeTabIndex]?.tabError.body | safe : 'html'\" navigationAdapter></div>\r\n          <ng-container *ngIf=\"Spa_Site_SNPTools_Enabled\">\r\n            <vnext-snp-toggle\r\n              [showLinkText]=\"Spa_HelpfulTools_ShowSNPLink_Text\"\r\n              [hideLinkText]=\"Spa_HelpfulTools_HideSNPLink_Text\"\r\n              [activeTabType]=\"activeTabType\"\r\n              [filteredPlansHasSNPPlans]=\"filteredPlansHasSNPPlans$ | async\"\r\n            >\r\n            </vnext-snp-toggle>\r\n          </ng-container>\r\n        </div>\r\n      </ng-template>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: ["vnext-filter-tab{margin-right:6px;margin-left:6px;max-width:22%;min-width:22%;min-height:100%;margin-bottom:-1px}.no-plan-error{white-space:pre-line;text-align:center;margin-top:80px;line-height:28px}.no-plan-error h4{font-weight:700;text-align:center}.plan-list-title{margin-top:60px;margin-bottom:10px}.zip-code-link{text-decoration:underline;position:relative}.fa-edit{position:relative;top:-6px}.zip-code-link .fa-edit{font-size:.5em}.tabs{border-bottom:1px solid var(--static-Spa_Style_Accent1);margin-bottom:30px}select{width:100%}.mobile-tab{max-width:20%;min-width:20%}@media (max-width: 768px){vnext-filter-tab{max-width:33%;min-width:33%}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i0.Injector }, { type: i1$1.NgbModal }, { type: i1.PlansService }, { type: PlanFacade }, { type: i1.NavigationService }, { type: HelpfulToolsFacade }, { type: HelpfulToolsService }, { type: HelpfulToolsResourceFacade }, { type: HelpfulToolsContextService }, { type: i1.ResponsiveLayoutService }, { type: i1.MemberSessionService }, { type: i1.FilterService }, { type: i1.SNPService }, { type: i2$1.Router }, { type: AnalyticsService }, { type: PlanListFacadeService }, { type: i1.DeepLinkingService }, { type: i1.PlanYearService }, { type: i1.PlanYearResourceService }]; }, { helpfulToolsPlanListTabElement: [{
            type: ViewChildren,
            args: ['helpfulToolsPlanTab', { read: ElementRef }]
        }], Spa_HelpfulTools_PlanList_PleaseEnterZip_Text: [], Spa_PlanFilters_No_Plans_Available_Message: [], Spa_HelpfulTools_FindPrescriptions_Url: [], Spa_HelpfulTools_FindPharmacy_Url: [], Spa_HelpfulTools_FindProviders_Link_Text: [], Spa_HelpfulTools_FindDentists_Link_Text: [], Spa_HelpfulTools_FindDentists_Link_Enabled: [], Spa_HelpfulTools_FindPrescriptions_Link_Text: [], Spa_HelpfulTools_FindPharmacy_Link_Text: [], Spa_HelpfulTools_ExternalPharmacyEnabled: [], Spa_HelpfulTools_ExternalPrescriptionsEnabled: [], Spa_HelpfulTools_Show_Provider: [], Spa_Site_Show_PlanLogo: [], Spa_Site_Plans_Text: [], Spa_Site_Plan_Text: [], Spa_Site_ErrorKeyword_Text: [], Spa_PlanList_EditZipCode_ButtonLabel: [], Spa_Site_MoreOptions_Text: [], Spa_HelpfulTools_ShowSNPLink_Text: [], Spa_HelpfulTools_HideSNPLink_Text: [], Spa_HelpfulTools_ShowSNPPlansDefault_Flag: [], Spa_PlanCard_CSNP_Indicator_Enabled: [], Spa_PlanCard_DSNP_Indicator_Enabled: [], Spa_PlanCard_ISNP_Indicator_Enabled: [], Spa_PlanCard_CSNP_Tooltip_Text: [], Spa_PlanCard_DSNP_Tooltip_Text: [], Spa_PlanCard_ISNP_Tooltip_Text: [], Spa_PlanCard_SNP_Indicator_Text: [], Spa_Site_SNPTools_Enabled: [], Spa_ZipCodeInput_CountyLabel_Text: [], Spa_ZipCodeInput_CountyLabel_Enabled: [], Spa_Site_PlanLogo_Size: [], Spa_HelpfulTools_ShowDrugAlternatives_Nudge_Enabled: [], Spa_HelpfulTools_PlanList_ViewPlans_Button_Text: [], Spa_PlanList_PlansAvailableSingular_Text: [], Spa_PlanList_PlansAvailablePlural_Text: [], Spa_HelpfulTools_PlansAvailablePlural_Text: [], Spa_DualPlanYear_PlanList_Text_Enabled: [], Spa_DualPlanYear_Enabled: [], Spa_DualPlanYear_Update_Enabled: [], Spa_DualPlanYear_PlanList_Text: [], Spa_PlanList_EditZipCode_Label: [], Spa_Site_PageSubHeader_Text: [], editZipCode: [], viewPlansOnClick: [] }); })();

function HRACompleteSectionComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "i", 6);
    i0.ɵɵelementStart(2, "span", 7);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.daysLeftText);
} }
function HRACompleteSectionComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.hraLastAccessedDate, " ");
} }
const _c0$1J = function (a0) { return { "offset-lg-6": a0 }; };
class HRACompleteSectionComponent {
    constructor() {
        this.planHRAType = PlanHRAType.INTERNAL;
        this.remainingHRADays = 0;
        this.clickCompleteEnrollmentHRA = new EventEmitter();
        this.planHRATypeModel = PlanHRAType;
    }
    ngOnChanges(changes) {
        const { completeHRADaysLeftText, memberHraLastAccessedDate, completeHRALastVisitedText, remainingHRADays } = changes;
        if ((completeHRADaysLeftText &&
            completeHRADaysLeftText?.currentValue &&
            completeHRADaysLeftText.previousValue !== completeHRADaysLeftText.currentValue) ||
            (remainingHRADays && remainingHRADays.previousValue !== remainingHRADays.currentValue)) {
            if (this.remainingHRADays) {
                this.daysLeftText = this.completeHRADaysLeftText?.replace('<hraDaysLeft>', this.remainingHRADays.toString());
            }
        }
        if ((completeHRALastVisitedText && completeHRALastVisitedText.currentValue !== completeHRALastVisitedText.previousValue) ||
            (memberHraLastAccessedDate && memberHraLastAccessedDate.currentValue !== memberHraLastAccessedDate.previousValue)) {
            if (this.memberHraLastAccessedDate) {
                this.hraLastAccessedDate = `${this.completeHRALastVisitedText} ${this.getConvertedDate(this.memberHraLastAccessedDate)}`;
            }
        }
    }
    onClickCompleteHRA() {
        this.clickCompleteEnrollmentHRA.emit();
    }
    getConvertedDate(lastAccessedDate) {
        const formattedDate = DateUtilities.getFormattedDateTime(new Date(lastAccessedDate), DateUtilities.defaultFormat);
        return formattedDate;
    }
}
HRACompleteSectionComponent.ɵfac = function HRACompleteSectionComponent_Factory(t) { return new (t || HRACompleteSectionComponent)(); };
HRACompleteSectionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HRACompleteSectionComponent, selectors: [["vnext-hra-complete-section"]], inputs: { memberHraLastAccessedDate: "memberHraLastAccessedDate", completeHRAButtonText: "completeHRAButtonText", completeHRALastVisitedText: "completeHRALastVisitedText", completeHRADaysLeftText: "completeHRADaysLeftText", planHRAType: "planHRAType", remainingHRADays: "remainingHRADays" }, outputs: { clickCompleteEnrollmentHRA: "clickCompleteEnrollmentHRA" }, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 6, consts: [[1, "row"], ["class", "warn-container col-12 col-lg-6 d-flex flex-row align-items-center", 4, "ngIf"], [1, "col-12", "col-lg-6", "d-flex", "flex-column", "flex-lg-row", "align-items-start", "align-items-lg-center", "justify-content-lg-end", 3, "ngClass"], ["class", "Spa_Style_Gray4_Color Spa_Style_Note", 4, "ngIf"], [1, "btn", "Spa_Style_SecondaryButton", "col-xs-12", "col-lg-auto", "ml-0", "ml-lg-2", "mt-2", "mt-lg-0", 3, "click", "keyup.enter"], [1, "warn-container", "col-12", "col-lg-6", "d-flex", "flex-row", "align-items-center"], [1, "fas", "fa-exclamation-triangle"], [1, "ml-1", "mt-1", "Spa_Style_Paragraph"], [1, "Spa_Style_Gray4_Color", "Spa_Style_Note"]], template: function HRACompleteSectionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, HRACompleteSectionComponent_div_1_Template, 4, 1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, HRACompleteSectionComponent_span_3_Template, 2, 1, "span", 3);
        i0.ɵɵelementStart(4, "button", 4);
        i0.ɵɵlistener("click", function HRACompleteSectionComponent_Template_button_click_4_listener() { return ctx.onClickCompleteHRA(); })("keyup.enter", function HRACompleteSectionComponent_Template_button_keyup_enter_4_listener() { return ctx.onClickCompleteHRA(); });
        i0.ɵɵelementStart(5, "span");
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.daysLeftText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$1J, !ctx.daysLeftText));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hraLastAccessedDate && ctx.planHRAType !== ctx.planHRATypeModel.INTERNAL);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.completeHRAButtonText);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, IconAriaAttributesDirective], styles: [".warning-color[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent4)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HRACompleteSectionComponent, [{
        type: Component,
        args: [{ selector: 'vnext-hra-complete-section', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row\">\r\n  <div *ngIf=\"daysLeftText\" class=\"warn-container col-12 col-lg-6 d-flex flex-row align-items-center\">\r\n    <i class=\"fas fa-exclamation-triangle\"></i>\r\n    <span class=\"ml-1 mt-1 Spa_Style_Paragraph\">{{ daysLeftText }}</span>\r\n  </div>\r\n\r\n  <div\r\n    [ngClass]=\"{\r\n      'offset-lg-6': !daysLeftText\r\n    }\"\r\n    class=\"col-12 col-lg-6 d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-lg-end\"\r\n  >\r\n    <span *ngIf=\"hraLastAccessedDate && planHRAType !== planHRATypeModel.INTERNAL\" class=\"Spa_Style_Gray4_Color Spa_Style_Note\">\r\n      {{ hraLastAccessedDate }}\r\n    </span>\r\n\r\n    <button\r\n      class=\"btn Spa_Style_SecondaryButton col-xs-12 col-lg-auto ml-0 ml-lg-2 mt-2 mt-lg-0\"\r\n      (click)=\"onClickCompleteHRA()\"\r\n      (keyup.enter)=\"onClickCompleteHRA()\"\r\n    >\r\n      <span>{{ completeHRAButtonText }}</span>\r\n    </button>\r\n  </div>\r\n</div>\r\n", styles: [".warning-color{color:var(--static-Spa_Style_Accent4)}\n"] }]
    }], null, { memberHraLastAccessedDate: [{
            type: Input
        }], completeHRAButtonText: [{
            type: Input
        }], completeHRALastVisitedText: [{
            type: Input
        }], completeHRADaysLeftText: [{
            type: Input
        }], planHRAType: [{
            type: Input
        }], remainingHRADays: [{
            type: Input
        }], clickCompleteEnrollmentHRA: [{
            type: Output
        }] }); })();

function HRAConfirmationComponent_h1_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.Spa_HRAConfirmation_Confirmation_Title, " ");
} }
function HRAConfirmationComponent_ng_template_5_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r8.Spa_HRAConfirmation_Completed_Text);
} }
function HRAConfirmationComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, HRAConfirmationComponent_ng_template_5_span_0_Template, 2, 1, "span", 7);
} if (rf & 2) {
    i0.ɵɵproperty("liveEditProp", "Spa_HRAConfirmation_Completed_Text");
} }
function HRAConfirmationComponent_ng_template_7_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.Spa_HRAConfirmation_ConfirmationNumber_Text + " " + ctx_r9.confirmationNumber, " ");
} }
function HRAConfirmationComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, HRAConfirmationComponent_ng_template_7_span_0_Template, 2, 1, "span", 12);
} if (rf & 2) {
    i0.ɵɵproperty("liveEditProp", "Spa_HRAConfirmation_ConfirmationNumber_Text");
} }
function HRAConfirmationComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "div", 14);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", ctx_r5.Spa_HRAConfirmation_Details_Text ? i0.ɵɵpipeBind2(2, 1, ctx_r5.Spa_HRAConfirmation_Details_Text, "html") : "", i0.ɵɵsanitizeHtml);
} }
function HRAConfirmationComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "vnext-vbc-confirmation-section", 15);
    i0.ɵɵlistener("onVbcConfirmationAttestationSubmit", function HRAConfirmationComponent_div_15_Template_vnext_vbc_confirmation_section_onVbcConfirmationAttestationSubmit_1_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.updateVbcConfirmationAttestation($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("messageText", ctx_r6.valueBasedCareProvider.confirmationMessageText)("primaryButtonText", ctx_r6.valueBasedCareProvider.primaryButtonText)("secondaryButtonText", ctx_r6.valueBasedCareProvider.secondaryButtonText)("primaryButtonLink", ctx_r6.valueBasedCareProvider.primaryButtonURL)("secondaryButtonLink", ctx_r6.valueBasedCareProvider.secondaryButtonURL)("vbcConfirmationAttestationEnabled", ctx_r6.Spa_ValueBasedCare_ConfirmationAttestation_Enabled)("pcpName", ctx_r6.valueBasedCareProvider.pcpName)("vbcOrgName", ctx_r6.valueBasedCareProvider.vbcOrgName)("vbcid", ctx_r6.valueBasedCareProvider.vbcid)("npi", ctx_r6.valueBasedCareProvider.npi)("optInEnabled", (ctx_r6.valueBasedCareProvider == null ? null : ctx_r6.valueBasedCareProvider.optin) !== false)("vbcConfirmationAttestationProviderText", ctx_r6.Spa_ValueBasedCare_ConfirmationAttestation_Provider_Text)("vbcConfirmationAttestationText", ctx_r6.Spa_ValueBasedCare_ConfirmationAttestation_Text)("optInConfirmationSuccessText", ctx_r6.Spa_ValueBasedCare_ConfirmationAttestationSuccess_Text)("optOutSubmitButtonText", ctx_r6.Spa_ValueBasedCare_OptOutButton_Text)("optOutConfirmationSuccessText", ctx_r6.Spa_ValueBasedCare_OptOutConfirmationSuccess_Text)("saveFailedErrorText", ctx_r6.Spa_Save_Failed_ErrorText)("submitButtonText", ctx_r6.Spa_Site_Submit)("vbcAttestationSubmitted", ctx_r6.vbcAttestationSubmitted);
} }
function HRAConfirmationComponent_div_16_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function HRAConfirmationComponent_div_16_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.shopForSomeoneElse()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.Spa_Confirmation_Shop_For_Someone_Else, " ");
} }
function HRAConfirmationComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "vnext-navigation-banner")(2, "div", 16);
    i0.ɵɵtemplate(3, HRAConfirmationComponent_div_16_button_3_Template, 2, 1, "button", 17);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", "Spa_Confirmation_Shop_For_Someone_Else");
} }
let HRAConfirmationComponent = class HRAConfirmationComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, siteService, enrollmentConfirmationFacade, memberSessionService, store, navigationService, enrollmentFormService, analyticsService, hraFormFacade, router, enrollmentFormFacade, providerFacade) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.siteService = siteService;
        this.enrollmentConfirmationFacade = enrollmentConfirmationFacade;
        this.memberSessionService = memberSessionService;
        this.store = store;
        this.navigationService = navigationService;
        this.enrollmentFormService = enrollmentFormService;
        this.analyticsService = analyticsService;
        this.hraFormFacade = hraFormFacade;
        this.router = router;
        this.enrollmentFormFacade = enrollmentFormFacade;
        this.providerFacade = providerFacade;
        this.Spa_Confirmation_Shop_For_Someone_Else = 'Shop for someone else';
        this.Spa_HRAConfirmation_ConfirmationNumber_Text = 'HRA Confirmation';
        this.Spa_HRAConfirmation_Confirmation_Title = 'Confirmation';
        this.Spa_HRAConfirmation_Completed_Text = 'Your Health Risk Assessment has been completed.';
        this.Spa_HRAConfirmation_ViewAssessment_Text = 'View Health Risk Assessment';
        this.Spa_HRAConfirmation_Details_Text = 'Thank you for completing the Health Risk Assessment. It gives us valuable information that helps cater to your needs.';
        this.Spa_ValueBasedCare_Confirmation_Enabled = true;
        this.Spa_ValueBasedCare_ConfirmationAttestation_Enabled = false;
        this.Spa_ValueBasedCare_ConfirmationAttestation_Provider_Text = 'Primary Care Provider selected: <pcpName> and <vbcOrgName>';
        this.Spa_ValueBasedCare_ConfirmationAttestation_Text = 'By clicking submit, I am providing a one-time consent to share my information with <vbcOrgName> that is inclusive of this enrollment application.';
        this.Spa_ValueBasedCare_ConfirmationAttestationSuccess_Text = 'Your application information has been sent to <vbcOrgName>';
        this.Spa_Save_Failed_ErrorText = 'Server error. Please try again.';
        this.Spa_Site_Submit = 'Submit';
        this.Spa_ValueBasedCare_OptOutConsentConfirmationAttestation_Text = 'By selecting a primary care physician who is affiliated with a Value Based Care organization, you are providing your one-time consent to share your information with <vbcOrgName> that is inclusive of this enrollment.<br />If you do not want to share your information, click the Opt-out button below.';
        this.Spa_ValueBasedCare_OptOutButton_Text = 'Opt-out';
        this.Spa_ValueBasedCare_OptOutConfirmationSuccess_Text = 'Your request to opt out has been processed. Your information will not be shared with <vbcOrgName>';
        this.showBanner = false;
        this.confirmationNumber = '';
        this.activeEnrollmentKey = '';
        this.vbcAttestationSubmitted = false;
        this.enrollmentConfirmationNumber = '';
    }
    ngOnInit() {
        super.ngOnInit();
        this.configurableWidgetService.spinnerService.show(SpinnerEvent.HRA_CONFIRMATION_LOADING);
        this.showBanner = !this.siteService.isPPCSite();
        this.activeEnrollmentKey = this.enrollmentFormService.getActiveEnrollmentKey();
        this.confirmationNumber = this.store.selectSnapshot(EnrollmentState.answer(this.activeEnrollmentKey, 'ConfirmationNumber'))?.value;
        const nativeTransactionID = this.store.selectSnapshot(ConfirmationState.hraAPINativeTransactionID);
        if (!this.confirmationNumber && nativeTransactionID) {
            // we didnt have a confirmation number in transaction data, or we had no transaction data due to skipping to confirmation
            const matchingEnrollment = this.store
                .selectSnapshot(MemberState.memberEnrollments)
                ?.find(enrollment => enrollment.nativeTransactionID === nativeTransactionID);
            this.confirmationNumber = matchingEnrollment?.hraConfirmationNumber;
            this.hraConfirmationNumberFromEnrollment = matchingEnrollment?.hraConfirmationNumber;
            this.hraTransactionSIDFromEnrollment = matchingEnrollment?.hraTransactionSID;
        }
        const sessionId = this.memberSessionService.getMemberSessionId();
        this.memberSessionService
            .fetchMemberSession$({ sessionId, isEnrollmentHistoryIncluded: true })
            .pipe(take(1))
            .subscribe({
            complete: () => {
                this.getVbcAttestation();
                this.closeLoadersOnConfirmation();
            }
        });
        this.providerFacade
            .fetchValueBasedCareConfirmation$(this.hraFormFacade.getHRAPlan())
            .pipe(switchMap(vbcProvider => {
            if (vbcProvider?.optin === false) {
                const vbcAttestation = {
                    pcpName: vbcProvider.pcpName,
                    vbcOrgName: vbcProvider.vbcOrgName,
                    npi: vbcProvider.npi,
                    vbcid: vbcProvider.vbcid,
                    optin: true
                };
                return from(this.updateVbcConfirmationAttestation(vbcAttestation, false)).pipe(tap(() => {
                    this.vbcAttestationSubmitted = false;
                    this.cdr.markForCheck();
                }), map(() => vbcProvider));
            }
            return of(vbcProvider);
        }))
            .subscribe(vbcProvider => {
            this.valueBasedCareProvider = vbcProvider;
            this.cdr.markForCheck();
        });
        this.updateDataLayer();
    }
    async getVbcAttestation() {
        const matchingEnrollment = this.store
            .selectSnapshot(MemberState.memberEnrollments)
            ?.find(enrollment => enrollment.hraConfirmationNumber === this.confirmationNumber);
        if (matchingEnrollment?.confirmationNumber) {
            this.enrollmentConfirmationNumber = matchingEnrollment?.confirmationNumber;
            this.vbcAttestationSubmitted = await this.providerFacade.getVbcAttestationConfirmation(this.enrollmentConfirmationNumber);
            this.cdr.markForCheck();
        }
    }
    async updateVbcConfirmationAttestation(event, setVbcAttestationSubmitted = true) {
        const vbcSubmitted = await this.providerFacade.updateVbcAttestationConfirmation({
            ...event,
            confirmationNumber: this.enrollmentConfirmationNumber
        });
        if (setVbcAttestationSubmitted) {
            this.vbcAttestationSubmitted = vbcSubmitted;
            this.cdr.markForCheck();
        }
    }
    shopForSomeoneElse() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_ENROLLMENT_SHOPFORSOMEONEELSE);
        this.memberSessionService.memberLogout({ clearAnonymousSession: true });
        this.memberSessionService.resetAuthType();
        this.store.dispatch(new ResetAgentState());
        this.navigationService.navigateByPageTag(PageTags.HOME);
    }
    viewPDF() {
        this.enrollmentConfirmationFacade.downloadEnrollmentApplicationPDF();
    }
    updateDataLayer() {
        const hraPlan = this.hraFormFacade.getHRAPlan();
        const googleTagManagerNotApplicableText = this.analyticsService.getGoogleTagManagerNotApplicableText();
        const externalMemberId = this.store.selectSnapshot(DeepLinkingParamsState.ssoValue);
        const externalReferenceId = this.store.selectSnapshot(DeepLinkingParamsState.pegi);
        const planType = hraPlan ? hraPlan.planTypeAbbreviation : googleTagManagerNotApplicableText;
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE,
            [DataLayerGlobalVariable.ENROLLMENT_CONFIRMATION_NUMBER]: this.confirmationNumber,
            [DataLayerGlobalVariable.PLAN_ID_ENROLLED]: hraPlan ? hraPlan?.id : googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
            [DataLayerGlobalVariable.PLAN_CARRIER]: hraPlan ? hraPlan?.carrierName : googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.PLAN_TYPE]: planType.toString(),
            [DataLayerGlobalVariable.EXTERNAL_MEMBER_ID]: externalMemberId ? externalMemberId : googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.EXTERNAL_REFERENCE_ID]: externalReferenceId ? externalReferenceId : googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.PLAN_NAME]: hraPlan?.planName ?? googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.PLAN_PREMIUM_MONTHLY]: this.enrollmentFormFacade.getEnrollingPlanPremium(this.activeEnrollmentKey),
            [DataLayerGlobalVariable.VBC_ATTESTATION_IS_PRESENT]: this.Spa_ValueBasedCare_Confirmation_Enabled && this.valueBasedCareProvider ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO
        };
    }
    closeLoadersOnConfirmation() {
        this.configurableWidgetService.spinnerService.hide(SpinnerEvent.SUBMITTED_FORM_LOADING);
        this.configurableWidgetService.spinnerService.hide(SpinnerEvent.HRA_CONFIRMATION_LOADING);
    }
};
HRAConfirmationComponent.ɵfac = function HRAConfirmationComponent_Factory(t) { return new (t || HRAConfirmationComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(EnrollmentConfirmationFacade), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(HRAFormFacade), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(EnrollmentFormFacade), i0.ɵɵdirectiveInject(ProviderFacade)); };
HRAConfirmationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HRAConfirmationComponent, selectors: [["vnext-hra-confirmation"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 17, vars: 10, consts: [[1, "c-mt-30", "c-mb-30", "container"], [1, "row"], [1, "col-12"], ["class", "text-center Spa_Style_H1 c-mt-30 c-mb-30", 4, "liveEditProp"], ["noticeTitle", ""], ["noticeBody", ""], [3, "titleTemplate", "bodyTemplate", "type"], [4, "liveEditProp"], [1, "col-12", "pdf-link"], [3, "alwaysUnderlined", "title", "keyNameForLiveEdit", "click", "keyup.enter"], ["class", "col-12", 4, "ngIf"], [1, "text-center", "Spa_Style_H1", "c-mt-30", "c-mb-30"], ["class", "Spa_Style_Primary_Color Spa_Style_Light_Weight", 4, "liveEditProp"], [1, "Spa_Style_Primary_Color", "Spa_Style_Light_Weight"], [1, "col-12", "Spa_Style_Primary_Color", "c-mt-30", "c-mb-30", 3, "innerHtml"], [3, "messageText", "primaryButtonText", "secondaryButtonText", "primaryButtonLink", "secondaryButtonLink", "vbcConfirmationAttestationEnabled", "pcpName", "vbcOrgName", "vbcid", "npi", "optInEnabled", "vbcConfirmationAttestationProviderText", "vbcConfirmationAttestationText", "optInConfirmationSuccessText", "optOutSubmitButtonText", "optOutConfirmationSuccessText", "saveFailedErrorText", "submitButtonText", "vbcAttestationSubmitted", "onVbcConfirmationAttestationSubmit"], ["continue-button", ""], ["class", "btn Spa_Style_PrimaryButton w-100", 3, "click", 4, "liveEditProp"], [1, "btn", "Spa_Style_PrimaryButton", "w-100", 3, "click"]], template: function HRAConfirmationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, HRAConfirmationComponent_h1_3_Template, 2, 1, "h1", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtemplate(5, HRAConfirmationComponent_ng_template_5_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(7, HRAConfirmationComponent_ng_template_7_Template, 1, 1, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelement(9, "vnext-notice", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 2);
        i0.ɵɵelement(11, "vnext-selectrx-section");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, HRAConfirmationComponent_div_12_Template, 3, 4, "div", 7);
        i0.ɵɵelementStart(13, "div", 8)(14, "vnext-link", 9);
        i0.ɵɵlistener("click", function HRAConfirmationComponent_Template_vnext_link_click_14_listener() { return ctx.viewPDF(); })("keyup.enter", function HRAConfirmationComponent_Template_vnext_link_keyup_enter_14_listener() { return ctx.viewPDF(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(15, HRAConfirmationComponent_div_15_Template, 2, 19, "div", 10);
        i0.ɵɵtemplate(16, HRAConfirmationComponent_div_16_Template, 4, 1, "div", 10);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(6);
        const _r3 = i0.ɵɵreference(8);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "Spa_HRAConfirmation_Confirmation_Title");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("titleTemplate", _r1)("bodyTemplate", _r3)("type", "success");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "Spa_HRAConfirmation_Details_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("alwaysUnderlined", true)("title", ctx.Spa_HRAConfirmation_ViewAssessment_Text)("keyNameForLiveEdit", "Spa_HRAConfirmation_ViewAssessment_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_ValueBasedCare_Confirmation_Enabled && ctx.valueBasedCareProvider);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showBanner);
    } }, dependencies: [i1$2.NgIf, NavigationBannerComponent, LinkComponent, NoticeComponent, LiveEditPropDirective, SelectRXSectionComponent, EnrollmentConfirmationVBCSectionComponent, SafePipe], styles: [".pdf-link[_ngcontent-%COMP%]{margin-bottom:100px}"], changeDetection: 0 });
__decorate([
    PlatformProp('live-edit')
], HRAConfirmationComponent.prototype, "Spa_Confirmation_Shop_For_Someone_Else", void 0);
__decorate([
    PlatformProp('live-edit')
], HRAConfirmationComponent.prototype, "Spa_HRAConfirmation_ConfirmationNumber_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], HRAConfirmationComponent.prototype, "Spa_HRAConfirmation_Confirmation_Title", void 0);
__decorate([
    PlatformProp('live-edit')
], HRAConfirmationComponent.prototype, "Spa_HRAConfirmation_Completed_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], HRAConfirmationComponent.prototype, "Spa_HRAConfirmation_ViewAssessment_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], HRAConfirmationComponent.prototype, "Spa_HRAConfirmation_Details_Text", void 0);
__decorate([
    GlobalResource()
], HRAConfirmationComponent.prototype, "Spa_ValueBasedCare_Confirmation_Enabled", void 0);
__decorate([
    GlobalResource()
], HRAConfirmationComponent.prototype, "Spa_ValueBasedCare_ConfirmationAttestation_Enabled", void 0);
__decorate([
    GlobalResource()
], HRAConfirmationComponent.prototype, "Spa_ValueBasedCare_ConfirmationAttestation_Provider_Text", void 0);
__decorate([
    GlobalResource()
], HRAConfirmationComponent.prototype, "Spa_ValueBasedCare_ConfirmationAttestation_Text", void 0);
__decorate([
    GlobalResource()
], HRAConfirmationComponent.prototype, "Spa_ValueBasedCare_ConfirmationAttestationSuccess_Text", void 0);
__decorate([
    GlobalResource()
], HRAConfirmationComponent.prototype, "Spa_Save_Failed_ErrorText", void 0);
__decorate([
    GlobalResource()
], HRAConfirmationComponent.prototype, "Spa_Site_Submit", void 0);
__decorate([
    GlobalResource()
], HRAConfirmationComponent.prototype, "Spa_ValueBasedCare_OptOutConsentConfirmationAttestation_Text", void 0);
__decorate([
    GlobalResource()
], HRAConfirmationComponent.prototype, "Spa_ValueBasedCare_OptOutButton_Text", void 0);
__decorate([
    GlobalResource()
], HRAConfirmationComponent.prototype, "Spa_ValueBasedCare_OptOutConfirmationSuccess_Text", void 0);
HRAConfirmationComponent = __decorate([
    PlatformWidget
], HRAConfirmationComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HRAConfirmationComponent, [{
        type: Component,
        args: [{ selector: 'vnext-hra-confirmation', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"c-mt-30 c-mb-30 container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-12\">\r\n      <h1 *liveEditProp=\"'Spa_HRAConfirmation_Confirmation_Title'\" class=\"text-center Spa_Style_H1 c-mt-30 c-mb-30\">\r\n        {{ Spa_HRAConfirmation_Confirmation_Title }}\r\n      </h1>\r\n    </div>\r\n    <div class=\"col-12\">\r\n      <ng-template #noticeTitle>\r\n        <span *liveEditProp=\"'Spa_HRAConfirmation_Completed_Text'\">{{ Spa_HRAConfirmation_Completed_Text }}</span>\r\n      </ng-template>\r\n      <ng-template #noticeBody>\r\n        <span *liveEditProp=\"'Spa_HRAConfirmation_ConfirmationNumber_Text'\" class=\"Spa_Style_Primary_Color Spa_Style_Light_Weight\">\r\n          {{ Spa_HRAConfirmation_ConfirmationNumber_Text + ' ' + confirmationNumber }}\r\n        </span>\r\n      </ng-template>\r\n      <vnext-notice [titleTemplate]=\"noticeTitle\" [bodyTemplate]=\"noticeBody\" [type]=\"'success'\"></vnext-notice>\r\n    </div>\r\n    <div class=\"col-12\">\r\n      <vnext-selectrx-section></vnext-selectrx-section>\r\n    </div>\r\n    <div *liveEditProp=\"'Spa_HRAConfirmation_Details_Text'\">\r\n      <div\r\n        class=\"col-12 Spa_Style_Primary_Color c-mt-30 c-mb-30\"\r\n        [innerHtml]=\"Spa_HRAConfirmation_Details_Text ? (Spa_HRAConfirmation_Details_Text | safe : 'html') : ''\"\r\n      ></div>\r\n    </div>\r\n    <div class=\"col-12 pdf-link\">\r\n      <vnext-link\r\n        (click)=\"viewPDF()\"\r\n        (keyup.enter)=\"viewPDF()\"\r\n        [alwaysUnderlined]=\"true\"\r\n        [title]=\"Spa_HRAConfirmation_ViewAssessment_Text\"\r\n        [keyNameForLiveEdit]=\"'Spa_HRAConfirmation_ViewAssessment_Text'\"\r\n      ></vnext-link>\r\n    </div>\r\n    <div class=\"col-12\" *ngIf=\"Spa_ValueBasedCare_Confirmation_Enabled && valueBasedCareProvider\">\r\n      <vnext-vbc-confirmation-section\r\n        [messageText]=\"valueBasedCareProvider.confirmationMessageText\"\r\n        [primaryButtonText]=\"valueBasedCareProvider.primaryButtonText\"\r\n        [secondaryButtonText]=\"valueBasedCareProvider.secondaryButtonText\"\r\n        [primaryButtonLink]=\"valueBasedCareProvider.primaryButtonURL\"\r\n        [secondaryButtonLink]=\"valueBasedCareProvider.secondaryButtonURL\"\r\n        [vbcConfirmationAttestationEnabled]=\"Spa_ValueBasedCare_ConfirmationAttestation_Enabled\"\r\n        [pcpName]=\"valueBasedCareProvider.pcpName\"\r\n        [vbcOrgName]=\"valueBasedCareProvider.vbcOrgName\"\r\n        [vbcid]=\"valueBasedCareProvider.vbcid\"\r\n        [npi]=\"valueBasedCareProvider.npi\"\r\n        [optInEnabled]=\"valueBasedCareProvider?.optin !== false\"\r\n        [vbcConfirmationAttestationProviderText]=\"Spa_ValueBasedCare_ConfirmationAttestation_Provider_Text\"\r\n        [vbcConfirmationAttestationText]=\"Spa_ValueBasedCare_ConfirmationAttestation_Text\"\r\n        [optInConfirmationSuccessText]=\"Spa_ValueBasedCare_ConfirmationAttestationSuccess_Text\"\r\n        [optOutSubmitButtonText]=\"Spa_ValueBasedCare_OptOutButton_Text\"\r\n        [optOutConfirmationSuccessText]=\"Spa_ValueBasedCare_OptOutConfirmationSuccess_Text\"\r\n        [saveFailedErrorText]=\"Spa_Save_Failed_ErrorText\"\r\n        [submitButtonText]=\"Spa_Site_Submit\"\r\n        [vbcAttestationSubmitted]=\"vbcAttestationSubmitted\"\r\n        (onVbcConfirmationAttestationSubmit)=\"updateVbcConfirmationAttestation($event)\"\r\n      ></vnext-vbc-confirmation-section>\r\n    </div>\r\n    <div class=\"col-12\" *ngIf=\"showBanner\">\r\n      <vnext-navigation-banner>\r\n        <div continue-button>\r\n          <button\r\n            *liveEditProp=\"'Spa_Confirmation_Shop_For_Someone_Else'\"\r\n            class=\"btn Spa_Style_PrimaryButton w-100\"\r\n            (click)=\"shopForSomeoneElse()\"\r\n          >\r\n            {{ Spa_Confirmation_Shop_For_Someone_Else }}\r\n          </button>\r\n        </div>\r\n      </vnext-navigation-banner>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".pdf-link{margin-bottom:100px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.SiteService }, { type: EnrollmentConfirmationFacade }, { type: i1.MemberSessionService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i1.EnrollmentFormService }, { type: AnalyticsService }, { type: HRAFormFacade }, { type: i2$1.Router }, { type: EnrollmentFormFacade }, { type: ProviderFacade }]; }, { Spa_Confirmation_Shop_For_Someone_Else: [], Spa_HRAConfirmation_ConfirmationNumber_Text: [], Spa_HRAConfirmation_Confirmation_Title: [], Spa_HRAConfirmation_Completed_Text: [], Spa_HRAConfirmation_ViewAssessment_Text: [], Spa_HRAConfirmation_Details_Text: [], Spa_ValueBasedCare_Confirmation_Enabled: [], Spa_ValueBasedCare_ConfirmationAttestation_Enabled: [], Spa_ValueBasedCare_ConfirmationAttestation_Provider_Text: [], Spa_ValueBasedCare_ConfirmationAttestation_Text: [], Spa_ValueBasedCare_ConfirmationAttestationSuccess_Text: [], Spa_Save_Failed_ErrorText: [], Spa_Site_Submit: [], Spa_ValueBasedCare_OptOutConsentConfirmationAttestation_Text: [], Spa_ValueBasedCare_OptOutButton_Text: [], Spa_ValueBasedCare_OptOutConfirmationSuccess_Text: [] }); })();

const _c0$1I = ["HRAFormHtml"];
function HRAFormRendererComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "form", 1, 2);
    i0.ɵɵpipe(3, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", ctx_r0.formId)("innerHTML", i0.ɵɵpipeBind2(3, 2, ctx_r0.formPageHtml, "html"), i0.ɵɵsanitizeHtml);
} }
class HRAFormRendererComponent extends FormRendererComponent {
    constructor(elementRef, enrollmentFormService, activatedRoute, cdr) {
        super(elementRef, enrollmentFormService, activatedRoute, cdr);
        this.elementRef = elementRef;
        this.enrollmentFormService = enrollmentFormService;
        this.activatedRoute = activatedRoute;
        this.cdr = cdr;
    }
    set formHtml(html) {
        this.formPageHtml = html;
        if (this.formPageHtml) {
            this.cdr.markForCheck();
            setTimeout(() => {
                this.loadPrerequisiteScripts();
                this.initializeView();
                this.viewInitialized$.next(true);
            });
        }
    }
}
HRAFormRendererComponent.ɵfac = function HRAFormRendererComponent_Factory(t) { return new (t || HRAFormRendererComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
HRAFormRendererComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HRAFormRendererComponent, selectors: [["vnext-hra-form-renderer"]], viewQuery: function HRAFormRendererComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1I, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.HRAFormHtml = _t.first);
    } }, inputs: { formHtml: "formHtml" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["navigationAdapter", "", 3, "id", "innerHTML"], ["HRAFormHtml", ""]], template: function HRAFormRendererComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, HRAFormRendererComponent_div_0_Template, 4, 5, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.formPageHtml);
    } }, dependencies: [i1$2.NgIf, i4.ɵNgNoValidate, i4.NgControlStatusGroup, i4.NgForm, NavigationAdapterDirective, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HRAFormRendererComponent, [{
        type: Component,
        args: [{ selector: 'vnext-hra-form-renderer', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"formPageHtml\">\r\n  <form #HRAFormHtml [id]=\"formId\" [innerHTML]=\"formPageHtml | safe: 'html'\" navigationAdapter></form>\r\n</div>\r\n" }]
    }], function () { return [{ type: i0.ElementRef }, { type: i1.EnrollmentFormService }, { type: i2$1.ActivatedRoute }, { type: i0.ChangeDetectorRef }]; }, { HRAFormHtml: [{
            type: ViewChild,
            args: ['HRAFormHtml']
        }], formHtml: [{
            type: Input
        }] }); })();

const _c0$1H = ["hraForm"];
let HRAFormComponent = class HRAFormComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, spinnerService, hraFormFacade, router, activatedRoute, navigationutilityService, enrollmentFormErrorsContext, viewContainer, authService, enrollmentFormService, analyticsService, store, enrollmentFormFacade) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.spinnerService = spinnerService;
        this.hraFormFacade = hraFormFacade;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.navigationutilityService = navigationutilityService;
        this.enrollmentFormErrorsContext = enrollmentFormErrorsContext;
        this.viewContainer = viewContainer;
        this.authService = authService;
        this.enrollmentFormService = enrollmentFormService;
        this.analyticsService = analyticsService;
        this.store = store;
        this.enrollmentFormFacade = enrollmentFormFacade;
        this.Spa_HRAForm_RedirectTag = PageTags.HRA_CONFIRMATION;
        this.Spa_HRAForm_SubmitButton_Text = 'Complete Assessment';
        this.subscriptions = [];
        this.checkFocus = false;
    }
    navigateNext(event) {
        const validateFOAMForm = _get(event, 'detail.SPA_Validate');
        // we should always validate unless SPA_Validate has been explicitly set to false
        this.next(validateFOAMForm !== false);
    }
    navigateBack(event) {
        this.back();
    }
    onInputBlur(event) {
        const validationErrors = Array.from(_get(event, 'detail.ValidationErrors') || []).map(formError => ({
            message: formError.message,
            severity: formError.severity,
            source: MESSAGE_SOURCE.CLIENT
        }));
        // get current errors from context
        this.enrollmentFormErrorsContext
            .observeForFormErrors$()
            .pipe(take(1))
            .subscribe(errors => {
            // not sure we will have many situations where we get server errors and client side errors
            // at the same time but if we do server errors should be placed above client side errors
            const serverErrors = errors && errors.messages && errors.messages.filter(error => error.source === MESSAGE_SOURCE.SERVER);
            const updatedErrors = [...serverErrors, ...validationErrors];
            if (!_isEqual(errors, updatedErrors)) {
                this.enrollmentFormErrorsContext.addErrors({
                    title: this.hraFormFacade.getEnrollmentErrorNoticeTitle(),
                    messages: updatedErrors
                });
            }
        });
    }
    ngAfterViewChecked() {
        if (this.checkFocus) {
            const formElement = document.getElementById(this.focusFieldID);
            if (formElement) {
                formElement.focus();
            }
            this.checkFocus = false;
        }
    }
    ngOnInit() {
        super.ngOnInit();
        this.environment = EnvironmentService.getEnvironment();
        this.pageName$ = this.activatedRoute.params.pipe(pluck('pageName'));
        this.enrollingFormId = this.enrollmentFormService.getActiveEnrollmentKey();
        this.store.dispatch(new ResetHRAAPINativeTransactionID());
        this.initializeSubscriptions(this.environment.liveedit);
    }
    initializeSubscriptions(liveEdit = false) {
        if (liveEdit) {
            return;
        }
        // Subscripe to page html
        this.subscriptions.push(this.pageName$.pipe(switchMap(pageName => this.hraFormFacade.getPageHtml$(this.enrollingFormId, pageName))).subscribe(pageHtml => {
            this.pageHtml = pageHtml;
            this.cdr.markForCheck();
        }));
        // Subscribe to loading
        this.subscriptions.push(combineLatest([this.pageName$, this.hraFormFacade.getFormLoading$(this.enrollingFormId)]).subscribe(([pageName, formLoading]) => {
            if (!pageName || formLoading) {
                this.spinnerService.show(SpinnerEvent.HRA_FORM_LOADING);
            }
            else {
                this.spinnerService.hide(SpinnerEvent.HRA_FORM_LOADING);
                this.updateTags();
            }
        }));
        // Fetch page html if locale change
        this.subscriptions.push(this.hraFormFacade.getCurrentLocale$().subscribe(locale => {
            this.locale = locale;
            this.hraFormFacade.fetchPageHtml$(this.enrollingFormId, this.pageName, locale);
        }));
        // Subscribe to page change from navigation bar
        this.subscriptions.push(this.hraFormFacade.observeForNavigationEvent$().subscribe(pageName => {
            this.navigateTo(pageName);
        }));
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }
    back() {
        // Let HOPEBundle.js know we are going to previous page
        this.viewContainer.element.nativeElement.dispatchEvent(new CustomEvent(CustomVNextEvents.ENROLLMENT_BACK, { bubbles: true }));
        // Go back a page without updating transaction
        const currentPageIndex = this.currentPageIndex();
        const pageName = this.hraFormFacade.getPageName(this.enrollingFormId, currentPageIndex - 1);
        this.navigateTo(pageName);
    }
    async next(validateFOAM = true) {
        const FOAMErrors = this.getFOAMErrors();
        if (validateFOAM && Array.isArray(FOAMErrors) && FOAMErrors.length) {
            this.handleFOAMErrors(FOAMErrors);
        }
        else {
            if (!this.authService.isCurrentTokenValid()) {
                await this.authService.loadJWT();
            }
            // Let HOPEBundle.js know we are going to next page
            this.viewContainer.element.nativeElement.dispatchEvent(new CustomEvent(CustomVNextEvents.ENROLLMENT_NEXT, { bubbles: true }));
            // Update transaction and go next page if no API error
            this.handleUpdateTransaction(() => {
                const currentPageName = this.currentPageName();
                const nextPageName = this.hraFormFacade.getPageName(this.enrollingFormId, this.currentPageIndex() + 1);
                this.hraFormFacade.setPageComplete(currentPageName, this.enrollingFormId);
                this.navigateTo(nextPageName, true);
            });
        }
    }
    async submit() {
        const FOAMErrors = this.getFOAMErrors();
        if (Array.isArray(FOAMErrors) && FOAMErrors.length) {
            this.handleFOAMErrors(FOAMErrors);
        }
        else {
            this.configurableWidgetService.spinnerService.show(SpinnerEvent.SUBMITTED_FORM_LOADING);
            if (!this.authService.isCurrentTokenValid()) {
                await this.authService.loadJWT();
            }
            // Update transaction and go to redirect page if no API error
            this.handleUpdateTransaction(() => {
                const currentPageName = this.currentPageName();
                this.hraFormFacade.setPageComplete(currentPageName, this.enrollingFormId);
                this.completeEnrollment(this.enrollingFormId);
            });
        }
    }
    showNext() {
        return !this.isCurrentPageLastPage();
    }
    showBack() {
        return !this.isCurrentPageFirstPage();
    }
    showSubmit() {
        return this.isCurrentPageLastPage();
    }
    currentPageName() {
        return this.activatedRoute.snapshot.params.pageName;
    }
    currentPageIndex() {
        return this.hraFormFacade.getPageIndex(this.enrollingFormId, this.currentPageName());
    }
    navigateTo(pageName, setPageVisited = false) {
        // clear errors right away since if we have new errors they will show up when returned from the API
        this.enrollmentFormErrorsContext.clearFormErrors();
        // if we are navigating to the next page and the viewInitialized subject is persisting from the last page
        // then reset the subject to false so we hide the page as it loads
        if (this.childForms && this.childForms.first) {
            this.childForms.first.viewInitialized$.next(false);
        }
        if (setPageVisited) {
            this.hraFormFacade.setPageVisited(this.enrollingFormId, pageName);
        }
        if (pageName) {
            const nextPageHtml = this.hraFormFacade.getPageHtml(this.enrollingFormId, pageName);
            const nextPageDirty = this.hraFormFacade.getPageDirty(this.enrollingFormId, pageName);
            if (!nextPageHtml || nextPageDirty) {
                this.hraFormFacade
                    .fetchPageHtml$(this.enrollingFormId, pageName)
                    .toPromise()
                    .then(() => {
                    this.navigateToPage(pageName);
                    this.navigationutilityService.setFocusToMainContent();
                });
            }
            else {
                this.navigateToPage(pageName);
                this.navigationutilityService.setFocusToMainContent();
            }
        }
    }
    retrieveFOAMAnswers() {
        const inputAnswers = this.childForms.first.retrieveFormInputValues();
        return Object.keys(inputAnswers).map(key => new Answer(key, inputAnswers[key]));
    }
    handleFOAMErrors(FOAMErrors) {
        this.addFOAMErrorsAndScroll(FOAMErrors);
        this.focusFieldID = FOAMErrors[0].focusFieldID;
        this.checkFocus = true;
    }
    getFOAMErrors() {
        const validateFormMethod = window && window[VALIDATE_FORM_METHOD];
        // passing true in order to get error messages back rather than a pure boolean pass/fail result
        return !validateFormMethod || validateFormMethod(true);
    }
    addFOAMErrorsAndScroll(FOAMErrors) {
        this.addErrorsAndScroll({
            title: this.hraFormFacade.getEnrollmentErrorNoticeTitle(),
            messages: FOAMErrors.map(formError => ({
                message: formError.message,
                severity: formError.severity,
                source: MESSAGE_SOURCE.CLIENT
            }))
        });
    }
    addErrorsAndScroll(errors) {
        this.enrollmentFormErrorsContext.addErrors(errors);
        this.enrollmentFormErrorsContext
            .observeForFormErrors$()
            .pipe(take(1))
            .subscribe(() => {
            this.enrollmentFormErrorsContext.scrollToErrors();
        });
    }
    handleUpdateTransaction(onSuccess) {
        const pageIndex = this.currentPageIndex();
        const answers = this.retrieveFOAMAnswers();
        const formType = this.hraFormFacade.getFormType(this.enrollingFormId).toString();
        this.hraFormFacade
            .updateTransaction$(pageIndex, answers, formType, this.enrollingFormId, this.locale)
            .toPromise()
            .then(() => {
            const transaction = this.hraFormFacade.getTransaction(this.enrollingFormId);
            this.processTransactionResponse(transaction, onSuccess);
        });
    }
    processTransactionResponse(transaction, onSuccess) {
        if (transaction.status === EnrollmentTransactionStatus.SUCCESS || transaction.status === EnrollmentTransactionStatus.COMPLETED) {
            onSuccess();
        }
        else if (transaction.status === EnrollmentTransactionStatus.FAIL_COMPLETED && transaction.statusMessage) {
            this.addErrorsAndScroll({
                title: this.hraFormFacade.getEnrollmentErrorNoticeTitle(),
                messages: [{ message: transaction.statusMessage, severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER }]
            });
        }
        else {
            this.showServerErrors(transaction);
        }
    }
    showServerErrors(transaction) {
        // server errors don't return types so we need to assign one so the notice displays
        const serverErrors = transaction.validations && {
            title: this.hraFormFacade.getEnrollmentErrorNoticeTitle(),
            messages: transaction.validations.map(validation => ({ severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER, ...validation }))
        };
        this.addErrorsAndScroll(serverErrors);
    }
    async completeEnrollment(formId) {
        await this.hraFormFacade.fetchTransaction$(formId).toPromise();
        const transactionAnswers = this.hraFormFacade.getTransaction(formId).answers;
        this.hraFormFacade
            .completeEnrollment$(transactionAnswers, formId, this.widgetService.widgetName)
            .toPromise()
            .then(() => {
            this.processTransactionResponse(this.hraFormFacade.getTransaction(formId), () => {
                this.configurableWidgetService.navigationService.navigateByPageTag(this.Spa_HRAForm_RedirectTag);
            });
        })
            .catch(error => {
            this.hraFormFacade.setFormPageLoading$(false, false, formId);
            this.configurableWidgetService.spinnerService.hide(SpinnerEvent.SUBMITTED_FORM_LOADING);
            if (error?.status === HttpStatusCode.BAD_REQUEST && error?.error?.AdditionalInfo) {
                const errorMessages = Object.keys(error.error.AdditionalInfo).reduce((errors, errorKey) => {
                    const errorMessage = error.error.AdditionalInfo[errorKey];
                    if (errorMessage) {
                        errors.push({ message: errorMessage });
                    }
                    return errors;
                }, []);
                this.addErrorsAndScroll({
                    title: this.hraFormFacade.getEnrollmentErrorNoticeTitle(),
                    messages: errorMessages.length
                        ? errorMessages
                        : [{ message: error.message, severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER }]
                });
            }
            else {
                this.addErrorsAndScroll({
                    title: this.hraFormFacade.getEnrollmentErrorNoticeTitle(),
                    messages: [{ message: error.message, severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER }]
                });
            }
        });
    }
    navigateToPage(pageName) {
        const url = this.configurableWidgetService.store.selectSnapshot(AppConfigState.hrefByTag(PageTags.HRA_FORM));
        this.router.navigate([url, pageName]);
    }
    isCurrentPageFirstPage() {
        return this.currentPageIndex() === 0;
    }
    isCurrentPageLastPage() {
        const pageInfos = this.hraFormFacade.getPageInfos(this.enrollingFormId);
        const currentPageIndex = this.currentPageIndex();
        return pageInfos && currentPageIndex === pageInfos.length - 1;
    }
    updateTags() {
        const hraPlan = this.hraFormFacade.getHRAPlan();
        const googleTagManagerNotApplicableText = this.analyticsService.getGoogleTagManagerNotApplicableText();
        const externalMemberId = this.store.selectSnapshot(DeepLinkingParamsState.ssoValue);
        const externalReferenceId = this.store.selectSnapshot(DeepLinkingParamsState.pegi);
        const planType = hraPlan ? hraPlan.planTypeAbbreviation : googleTagManagerNotApplicableText;
        const transaction = this.hraFormFacade.getTransaction(this.enrollingFormId);
        if (this.analyticsService.googleDataLayerTags[DataLayerGlobalVariable.PAGE_PATH] !== this.router.url) {
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE,
                [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
                [DataLayerGlobalVariable.PLAN_CARRIER]: hraPlan ? hraPlan?.carrierName : googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.PLAN_TYPE]: planType.toString(),
                [DataLayerGlobalVariable.FORM_VERSION]: EnrollmentFormTypeDisplayName.HRA,
                [DataLayerGlobalVariable.TRANSACTION_GUID]: transaction.transactionGUID,
                [DataLayerGlobalVariable.PLAN_ID]: hraPlan ? hraPlan?.id : googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.EXTERNAL_MEMBER_ID]: externalMemberId || googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.EXTERNAL_REFERENCE_ID]: externalReferenceId || googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.PLAN_NAME]: hraPlan?.planName ?? googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.PLAN_PREMIUM_MONTHLY]: this.enrollmentFormFacade.getEnrollingPlanPremium(this.enrollingFormId)
            };
        }
    }
};
HRAFormComponent.ɵfac = function HRAFormComponent_Factory(t) { return new (t || HRAFormComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(HRAFormFacade), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(i1.EnrollmentFormErrorsContext), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i1.AuthService), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(EnrollmentFormFacade)); };
HRAFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HRAFormComponent, selectors: [["vnext-hra-form"]], viewQuery: function HRAFormComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1H, 5);
        i0.ɵɵviewQuery(HRAFormRendererComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.enrollmentForm = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childForms = _t);
    } }, hostBindings: function HRAFormComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("SpaEnrollmentNextEvent", function HRAFormComponent_SpaEnrollmentNextEvent_HostBindingHandler($event) { return ctx.navigateNext($event.target); }, false, i0.ɵɵresolveDocument)("SpaEnrollmentBackEvent", function HRAFormComponent_SpaEnrollmentBackEvent_HostBindingHandler($event) { return ctx.navigateBack($event.target); }, false, i0.ɵɵresolveDocument)("SpaInputBlurEvent", function HRAFormComponent_SpaInputBlurEvent_HostBindingHandler($event) { return ctx.onInputBlur($event); });
    } }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 9, vars: 8, consts: [[1, "container"], [1, "row"], [1, "col-12"], [1, "col-12", 2, "margin", "0 20px"], [3, "formHtml"], ["hraForm", ""], [3, "showNext", "showSubmit", "showPrevious", "showSendApplicationEmail", "previousButtonText", "nextButtonText", "submitButtonText", "sendApplicationButtonText", "enrollSubmitTooltipText", "backEvent", "nextEvent", "submitEvent", "closeTooltipEvent"]], template: function HRAFormComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵelement(3, "vnext-enrollment-notice");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 1)(5, "div", 3);
        i0.ɵɵelement(6, "vnext-hra-form-renderer", 4, 5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "vnext-enrollment-form-navigation", 6);
        i0.ɵɵlistener("backEvent", function HRAFormComponent_Template_vnext_enrollment_form_navigation_backEvent_8_listener() { return ctx.back(); })("nextEvent", function HRAFormComponent_Template_vnext_enrollment_form_navigation_nextEvent_8_listener() { return ctx.next(); })("submitEvent", function HRAFormComponent_Template_vnext_enrollment_form_navigation_submitEvent_8_listener() { return ctx.submit(); })("closeTooltipEvent", function HRAFormComponent_Template_vnext_enrollment_form_navigation_closeTooltipEvent_8_listener($event) { return ctx.hraFormFacade.closeTooltip($event); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("formHtml", ctx.pageHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("showNext", ctx.showNext())("showSubmit", ctx.showSubmit())("showPrevious", ctx.showBack())("showSendApplicationEmail", false)("previousButtonText", ctx.hraFormFacade.getPreviousText())("nextButtonText", ctx.hraFormFacade.getNextText())("submitButtonText", ctx.hraFormFacade.getSubmitText());
    } }, dependencies: [EnrollmentFormNavigationComponent, EnrollmentNoticeComponent, HRAFormRendererComponent], encapsulation: 2, changeDetection: 0 });
__decorate([
    GlobalResource()
], HRAFormComponent.prototype, "Spa_HRA_EnrollmentConfirmationIdValidCharacters", void 0);
__decorate([
    GlobalResource()
], HRAFormComponent.prototype, "Spa_HRA_EnrollmentConfirmationIdValidDigits", void 0);
__decorate([
    GlobalResource()
], HRAFormComponent.prototype, "Spa_HRA_EnrollmentConfirmationIdFormat", void 0);
__decorate([
    GlobalResource()
], HRAFormComponent.prototype, "Spa_HRA_EnrollmentConfirmationIdPrefix", void 0);
__decorate([
    GlobalResource()
], HRAFormComponent.prototype, "Spa_HRA_EnrollmentConfirmationIdSuffix", void 0);
__decorate([
    GlobalResource()
], HRAFormComponent.prototype, "Spa_HRAForm_CustomInternal_Json", void 0);
__decorate([
    GlobalResource()
], HRAFormComponent.prototype, "Spa_HRAForm_RedirectTag", void 0);
__decorate([
    GlobalResource()
], HRAFormComponent.prototype, "Spa_HRAForm_SubmitButton_Text", void 0);
HRAFormComponent = __decorate([
    PlatformWidget
], HRAFormComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HRAFormComponent, [{
        type: Component,
        args: [{ selector: 'vnext-hra-form', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-12\">\r\n      <vnext-enrollment-notice></vnext-enrollment-notice>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-12\" style=\"margin: 0 20px\">\r\n      <vnext-hra-form-renderer [formHtml]=\"pageHtml\" #hraForm></vnext-hra-form-renderer>\r\n    </div>\r\n  </div>\r\n  <vnext-enrollment-form-navigation\r\n    (backEvent)=\"back()\"\r\n    (nextEvent)=\"next()\"\r\n    (submitEvent)=\"submit()\"\r\n    [showNext]=\"showNext()\"\r\n    [showSubmit]=\"showSubmit()\"\r\n    [showPrevious]=\"showBack()\"\r\n    [showSendApplicationEmail]=\"false\"\r\n    [previousButtonText]=\"hraFormFacade.getPreviousText()\"\r\n    [nextButtonText]=\"hraFormFacade.getNextText()\"\r\n    [submitButtonText]=\"hraFormFacade.getSubmitText()\"\r\n    [sendApplicationButtonText]=\"\"\r\n    [enrollSubmitTooltipText]=\"\"\r\n    (closeTooltipEvent)=\"hraFormFacade.closeTooltip($event)\"\r\n  ></vnext-enrollment-form-navigation>\r\n</div>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.SpinnerService }, { type: HRAFormFacade }, { type: i2$1.Router }, { type: i2$1.ActivatedRoute }, { type: i1.NavigationUtilityService }, { type: i1.EnrollmentFormErrorsContext }, { type: i0.ViewContainerRef }, { type: i1.AuthService }, { type: i1.EnrollmentFormService }, { type: AnalyticsService }, { type: i2.Store }, { type: EnrollmentFormFacade }]; }, { Spa_HRA_EnrollmentConfirmationIdValidCharacters: [], Spa_HRA_EnrollmentConfirmationIdValidDigits: [], Spa_HRA_EnrollmentConfirmationIdFormat: [], Spa_HRA_EnrollmentConfirmationIdPrefix: [], Spa_HRA_EnrollmentConfirmationIdSuffix: [], Spa_HRAForm_CustomInternal_Json: [], Spa_HRAForm_RedirectTag: [], Spa_HRAForm_SubmitButton_Text: [], childForms: [{
            type: ViewChildren,
            args: [HRAFormRendererComponent]
        }], enrollmentForm: [{
            type: ViewChild,
            args: ['hraForm']
        }], navigateNext: [{
            type: HostListener,
            args: [`document:${CustomFOAMEvents.ENROLLMENT_NEXT}`, ['$event.target']]
        }], navigateBack: [{
            type: HostListener,
            args: [`document:${CustomFOAMEvents.ENROLLMENT_BACK}`, ['$event.target']]
        }], onInputBlur: [{
            type: HostListener,
            args: [`${CustomFOAMEvents.INPUT_BLUR}`, ['$event']]
        }] }); })();

class AgentLoginFacade {
    constructor(responsiveLayoutService, navigationService, agentService, store) {
        this.responsiveLayoutService = responsiveLayoutService;
        this.navigationService = navigationService;
        this.agentService = agentService;
        this.store = store;
    }
    get isMobile$() {
        return this.responsiveLayoutService.isCompact$;
    }
    get isMedium$() {
        return this.responsiveLayoutService.isMedium$;
    }
    login$(userName, userPassword) {
        return this.agentService.agentLogin$({ userName, userPassword });
    }
    isLoggedIn() {
        return this.store.selectSnapshot(AgentState.isLoggedIn);
    }
    updateErrorType(errorType) {
        this.store.dispatch(new SetAgentError(errorType));
    }
    fetchRetireFloStatus() {
        this.agentService.fetchRetireFloStatus();
    }
    navigateAfterLogin() {
        const defaultLanding = this.agentService.getDefaultPageTag();
        this.navigationService.navigateByPageTag(defaultLanding);
    }
}
AgentLoginFacade.ɵfac = function AgentLoginFacade_Factory(t) { return new (t || AgentLoginFacade)(i0.ɵɵinject(i1.ResponsiveLayoutService), i0.ɵɵinject(i1.NavigationService), i0.ɵɵinject(i1.AgentService), i0.ɵɵinject(i2.Store)); };
AgentLoginFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentLoginFacade, factory: AgentLoginFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentLoginFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.ResponsiveLayoutService }, { type: i1.NavigationService }, { type: i1.AgentService }, { type: i2.Store }]; }, null); })();

var SubscriptionFormInputs;
(function (SubscriptionFormInputs) {
    SubscriptionFormInputs["AGENT_FIRST_NAME"] = "AgentFirstName";
    SubscriptionFormInputs["AGENT_LAST_NAME"] = "AgentLastName";
    SubscriptionFormInputs["AGENT_EMAIL"] = "AgentEmail";
    SubscriptionFormInputs["AGENT_PHONE"] = "AgentPhone";
    SubscriptionFormInputs["AGENT_NPN"] = "AgentNpn";
    SubscriptionFormInputs["AGENT_ADDRESS1"] = "AgentAddress1";
    SubscriptionFormInputs["CITY"] = "City";
    SubscriptionFormInputs["STATE"] = "State";
    SubscriptionFormInputs["ZIP"] = "Zip";
    SubscriptionFormInputs["LICENSE_NUMBER"] = "CaliforniaLicenseNumber";
})(SubscriptionFormInputs || (SubscriptionFormInputs = {}));
const PHONE_LENGTH = 10;
const ZIP_LENGTH$1 = 5;
const NPN_LENGTH = 10;
class SubscriptionFacade {
    constructor(configResourceService, formBuilder, agentService, store, formValidationService) {
        this.configResourceService = configResourceService;
        this.formBuilder = formBuilder;
        this.agentService = agentService;
        this.store = store;
        this.formValidationService = formValidationService;
        this.subscriptionForm = [
            {
                keyName: SubscriptionFormInputs.AGENT_FIRST_NAME,
                labelText: 'First name',
                required: true,
                ordinal: 1,
                display: true,
                disabled: false
            },
            { keyName: SubscriptionFormInputs.AGENT_LAST_NAME, labelText: 'Last name', required: true, ordinal: 2, display: true, disabled: true },
            {
                keyName: SubscriptionFormInputs.AGENT_NPN,
                labelText: 'National Producer Number',
                required: true,
                ordinal: 3,
                display: true,
                disabled: true
            },
            {
                keyName: SubscriptionFormInputs.AGENT_EMAIL,
                labelText: 'Email address',
                required: true,
                ordinal: 4,
                display: true,
                disabled: false
            },
            { keyName: SubscriptionFormInputs.AGENT_PHONE, labelText: 'Phone', required: true, ordinal: 5, display: true, disabled: false },
            { keyName: SubscriptionFormInputs.AGENT_ADDRESS1, labelText: 'Address', required: true, ordinal: 6, display: true, disabled: false },
            { keyName: SubscriptionFormInputs.CITY, labelText: 'City', required: true, ordinal: 7, display: true, disabled: false },
            { keyName: SubscriptionFormInputs.STATE, labelText: 'State', required: true, ordinal: 8, display: true, disabled: false },
            { keyName: SubscriptionFormInputs.ZIP, labelText: 'Zip', required: true, ordinal: 9, display: true, disabled: false },
            {
                keyName: SubscriptionFormInputs.LICENSE_NUMBER,
                labelText: 'California license number (Optional)',
                required: false,
                ordinal: 10,
                display: true,
                disabled: false
            }
        ];
    }
    getSubscriptionFormGroup() {
        this.subscriptionForm = this.configResourceService.getProcessedResourceValue('Spa_Agent_Subscription_Form', null, this.subscriptionForm);
        return this.subscriptionForm.reduce((fg, input) => {
            const control = new UntypedFormControl({
                value: '',
                disabled: input.disabled
            });
            const validators = [];
            if (input.required) {
                validators.push(Validators.required);
            }
            if (input.keyName === SubscriptionFormInputs.AGENT_EMAIL) {
                validators.push(Validators.email);
            }
            else if (input.keyName === SubscriptionFormInputs.AGENT_PHONE) {
                validators.push(Validators.minLength(10), Validators.maxLength(PHONE_LENGTH));
            }
            else if (input.keyName === SubscriptionFormInputs.ZIP) {
                validators.push(Validators.minLength(5), Validators.maxLength(ZIP_LENGTH$1));
            }
            else if (input.keyName === SubscriptionFormInputs.AGENT_NPN) {
                validators.push(Validators.maxLength(NPN_LENGTH));
            }
            control.setValidators(validators);
            fg.addControl(input.keyName, control);
            return fg;
        }, this.formBuilder.group({}, { updateOn: 'blur' }));
    }
    getSubscriptionErrorMessage(keyName) {
        if (keyName === SubscriptionFormInputs.AGENT_FIRST_NAME) {
            return this.formValidationService.errorMessages.requiredFirstName();
        }
        if (keyName === SubscriptionFormInputs.AGENT_LAST_NAME) {
            return this.formValidationService.errorMessages.requiredLastName();
        }
        if (keyName === SubscriptionFormInputs.AGENT_EMAIL) {
            return this.formValidationService.errorMessages.invalidEmail();
        }
        if (keyName === SubscriptionFormInputs.AGENT_PHONE) {
            return this.formValidationService.errorMessages.requiredPhone();
        }
        if (keyName === SubscriptionFormInputs.ZIP) {
            return this.formValidationService.errorMessages.requiredZipCode();
        }
        if (keyName === SubscriptionFormInputs.STATE) {
            return this.formValidationService.errorMessages.requiredState();
        }
        if (keyName === SubscriptionFormInputs.CITY) {
            return this.formValidationService.errorMessages.requiredCity();
        }
        if (keyName === SubscriptionFormInputs.AGENT_ADDRESS1) {
            return this.formValidationService.errorMessages.requiredAddress();
        }
        if (keyName === SubscriptionFormInputs.AGENT_NPN) {
            return this.formValidationService.errorMessages.maxLengthNPN();
        }
        if (keyName === SubscriptionFormInputs.LICENSE_NUMBER) {
            return this.formValidationService.errorMessages.licenseNumber();
        }
        return '';
    }
    validateAgentDetails$(payload) {
        return this.agentService.validateAgentDetails$(payload);
    }
    getSubscriptionPricingOption$(productId) {
        return this.agentService.getSubscriptionPricingOption$(productId);
    }
    getAgentSubscriptionStatus$(stripeSessionId) {
        return this.agentService.getAgentSubscriptionStatus$(stripeSessionId);
    }
    getStripeCheckoutSession$(priceId) {
        return this.agentService.getStripeCheckoutSession$(priceId);
    }
    getSubscriptionStatusEvents$(customerId) {
        return this.agentService.getSubscriptionStatusEvents$(customerId);
    }
    setAgentSubscriptionInfo(payload) {
        this.store.dispatch(new AddAgentSubscriptionInfo(payload));
    }
    resetAgentSubscriptionInfo() {
        this.store.dispatch(new ResetAgentSubscriptionInfo());
    }
    getAgentSubscriptionInfo() {
        return this.store.selectSnapshot(AgentState.agentSubscriptionData);
    }
    submitAgentInfo$(payload) {
        return this.agentService.submitAgentInfo$(payload);
    }
    getCustomerId() {
        return this.store.selectSnapshot(AgentState.customerId);
    }
    isSubscriptionExpired(eventDate, expireDaysCount) {
        const subscriptionExpirationDate = DateUtilities.addDays(eventDate, expireDaysCount);
        const difference = DateUtilities.getDaysDifference(DateUtilities.getFormattedCurrentDate(), subscriptionExpirationDate, DaysDifferencePrecision.DATE_ONLY);
        return difference < 1;
    }
}
SubscriptionFacade.ɵfac = function SubscriptionFacade_Factory(t) { return new (t || SubscriptionFacade)(i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i4.UntypedFormBuilder), i0.ɵɵinject(i1.AgentService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.FormValidationService)); };
SubscriptionFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SubscriptionFacade, factory: SubscriptionFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubscriptionFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: i4.UntypedFormBuilder }, { type: i1.AgentService }, { type: i2.Store }, { type: i1.FormValidationService }]; }, null); })();

function AgentLoginComponent_h1_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.Spa_AgentLogin_Header_Text, " ");
} }
function AgentLoginComponent_h2_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.Spa_AgentLogin_SubHeader_Text, " ");
} }
function AgentLoginComponent_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 24);
    i0.ɵɵelement(1, "i", 25);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.errorMessage, "");
} }
function AgentLoginComponent_label_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.Spa_AgentLogin_Username_Text, " ");
} }
function AgentLoginComponent_label_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.Spa_AgentLogin_Password_Text, " ");
} }
function AgentLoginComponent_button_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.Spa_AgentLogin_Button_Text, " ");
} }
function AgentLoginComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelement(1, "vnext-link", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("keyNameForLiveEdit", "Spa_AgentLogin_ForgotUsernameLink_Text")("alwaysUnderlined", true)("title", ctx_r6.Spa_AgentLogin_ForgotUsernameLink_Text)("tag", ctx_r6.pageTags.FORGOT_USERNAME)("customClass", "Spa_Style_LinkOnDarkBackgrounds login-popover-container-linktext");
} }
function AgentLoginComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelement(1, "vnext-link", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("keyNameForLiveEdit", "Spa_AgentLogin_ForgotPasswordLink_Text")("alwaysUnderlined", true)("title", ctx_r7.Spa_AgentLogin_ForgotPasswordLink_Text)("tag", ctx_r7.pageTags.FORGOT_PASSWORD)("customClass", "Spa_Style_LinkOnDarkBackgrounds login-popover-container-linktext");
} }
function AgentLoginComponent_div_22_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r11.Spa_AgentLogin_NoAccount_Text, " ");
} }
function AgentLoginComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AgentLoginComponent_div_22_div_1_Template, 2, 1, "div", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_AgentLogin_NoAccount_Text");
} }
function AgentLoginComponent_div_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 33);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r9.Spa_AgentLogin_AdditionalInformation_Html, "html"), i0.ɵɵsanitizeHtml);
} }
function AgentLoginComponent_div_26_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 35);
    i0.ɵɵlistener("click", function AgentLoginComponent_div_26_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.navigateToSubscription()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.Spa_AgentLogin_SubscribeNow_Text, " ");
} }
function AgentLoginComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, AgentLoginComponent_div_26_button_1_Template, 2, 1, "button", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_AgentLogin_SubscribeNow_Text");
} }
const _c0$1G = function (a0) { return { "background-image": a0 }; };
const _c1$O = function (a0) { return { "login-wrapper": a0 }; };
const _c2$x = function (a0) { return { "border-right": a0 }; };
const _c3$m = function (a0) { return { "error-border": a0 }; };
const _c4$d = function (a0, a1) { return { "col-6 d-lg-block d-none": a0, "col-12 col-lg-6 mb-3": a1 }; };
let AgentLoginComponent = class AgentLoginComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, formBuilder, agentLoginFacade, formValidationService, authService, router, analyticsService, navigationService, configResourceService, agentService, emailService, subscriptionFacade, loginService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.formBuilder = formBuilder;
        this.agentLoginFacade = agentLoginFacade;
        this.formValidationService = formValidationService;
        this.authService = authService;
        this.router = router;
        this.analyticsService = analyticsService;
        this.navigationService = navigationService;
        this.configResourceService = configResourceService;
        this.agentService = agentService;
        this.emailService = emailService;
        this.subscriptionFacade = subscriptionFacade;
        this.loginService = loginService;
        this.Spa_AgentLogin_ForgotPassword_Enabled = true;
        this.Spa_AgentLogin_ForgotUsername_Enabled = true;
        this.Spa_AgentLogin_SubscribeNow_Enabled = true;
        this.Spa_Site_Is_MedicareEdge = false;
        this.Spa_AgentLogin_NoAccount_Enabled = false;
        this.Spa_AgentLogin_SubscribeNow_Text = 'Subscribe now';
        this.Spa_AgentLogin_Header_Text = 'Welcome';
        this.Spa_AgentLogin_SubHeader_Text = 'Login and get started';
        this.Spa_AgentLogin_Button_Text = 'Login';
        this.Spa_AgentLogin_Username_Text = 'Username';
        this.Spa_AgentLogin_Password_Text = 'Password';
        this.Spa_AgentLogin_ForgotUsernameLink_Text = 'Forgot username';
        this.Spa_AgentLogin_ForgotPasswordLink_Text = 'Forgot password';
        this.Spa_AgentLogin_NoAccount_Text = 'No account? Contact your manager to get access.';
        this.Spa_AgentLogin_AdditionalInformation_Html = `
  <strong><h6>Welcome to [Healthcare co]</h3></strong>
  <strong><p class="mt-3">One shopping | One Location | One administration</p></strong>
  <ul class="pl-1">
  <li class="mt-2"> Medicare shopping and enrollment tools</li>
  <li class="mt-2"> Present plan options and accurately calculate drug costs</li>
  <li class="mt-2"> Capture leads and track their status through enrollment</li>
  <li class="mt-2"> Manage all your applications through one portal</li>
  </ul>
  `;
        this.Spa_AgentLogin_ErrorMessage_Text = 'Please provide valid login credentials.';
        this.Spa_AgentLogin_MaxAttemptErrorMessage_Text = 'The maximum number of log in attempts have been exceeded. Try again later.';
        this.Spa_HeaderFooter_PrimaryClientLogo = '';
        this.Spa_HeaderFooter_PrimaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_HeaderFooter_SecondaryClientLogo = '';
        this.Spa_HeaderFooter_SecondaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_PlanCompareEdgeForAgentsEmail_ButtonUrl = '';
        this.Spa_Site_Agent_Subscription_Expire_Days_Count = 30;
        this.Spa_Site_SiteType = SiteType.BROKER;
        this.pageTags = PageTags;
        this.loginAttempted = false;
        this.checkFocus = false;
    }
    get isMobile$() {
        return this.agentLoginFacade.isMobile$;
    }
    get isMedium$() {
        return this.agentLoginFacade.isMedium$;
    }
    get username() {
        return this.fg.get('username');
    }
    get password() {
        return this.fg.get('password');
    }
    get errorMessage() {
        if (this.fg.getError('maxAttempts')) {
            return this.Spa_AgentLogin_MaxAttemptErrorMessage_Text;
        }
        return this.Spa_AgentLogin_ErrorMessage_Text;
    }
    ngOnInit() {
        super.ngOnInit();
        this.fg = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        }, { validators: [this.formValidationService.validAgentLogin()], updateOn: 'submit' });
        // already logged in? go to the post login page.
        if (this.agentLoginFacade.isLoggedIn()) {
            this.agentLoginFacade.navigateAfterLogin();
        }
    }
    ngAfterContentChecked() {
        if (this.checkFocus) {
            const firstInvalidAgentLoginFormInput = document.querySelector('input.ng-invalid');
            const errorMessageElement = document.querySelector('span.error');
            const firstInvalidAgentLoginFormElement = firstInvalidAgentLoginFormInput;
            if (firstInvalidAgentLoginFormElement) {
                firstInvalidAgentLoginFormElement.focus();
            }
            else if (errorMessageElement) {
                const firstAgentloginFormInput = document.querySelector('input.ng-valid');
                const firstAgentloginFormElement = firstAgentloginFormInput;
                if (firstAgentloginFormElement) {
                    firstAgentloginFormElement.focus();
                }
            }
            this.checkFocus = false;
        }
    }
    login() {
        this.loginAttempted = true;
        if (!this.isApiSessionLive()) {
            this.refresh();
        }
        else {
            if (this.username.valid && this.password.valid) {
                this.agentLoginFacade
                    .login$(this.fg.get('username').value, this.fg.get('password').value)
                    .pipe(take(1))
                    .subscribe({
                    next: agentData => {
                        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CASE_LOGIN_SUCCESS);
                        this.agentLoginFacade.updateErrorType(AgentError.NO_ERROR);
                        this.agentLoginFacade.fetchRetireFloStatus();
                        if (agentData?.subscriptionEvents?.length) {
                            const isSubscriptionExpired = this.subscriptionFacade.isSubscriptionExpired(agentData?.subscriptionEvents[0]?.EventTime, this.Spa_Site_Agent_Subscription_Expire_Days_Count);
                            isSubscriptionExpired ? this.disableAgent() : this.agentLoginFacade.navigateAfterLogin();
                        }
                        else {
                            this.agentLoginFacade.navigateAfterLogin();
                        }
                    },
                    error: error => {
                        if (error.status === HttpStatusCode.TOO_MANY_REQUESTS) {
                            this.agentLoginFacade.updateErrorType(AgentError.MAX_ATTEMPTS);
                        }
                        else if (error.status === HttpStatusCode.NOT_FOUND ||
                            error.status === HttpStatusCode.UNAUTHORIZED ||
                            error.status === HttpStatusCode.GONE) {
                            if (error.error.Detail === RESET_REQUIRED_ERROR) {
                                return;
                            }
                            this.agentLoginFacade.updateErrorType(AgentError.INVALID_CREDENTIALS);
                        }
                        this.checkFocus = true;
                        this.fg.updateValueAndValidity();
                        this.cdr.markForCheck();
                    }
                });
            }
            else {
                this.checkFocus = true;
            }
        }
    }
    disableAgent() {
        this.agentService
            .disableAgent$({ agentGuid: this.agentService.getAgentInContextGuid(), siteAccess: false, isActive: false })
            .pipe(take(1))
            .subscribe((agentData) => {
            if (agentData.data) {
                this.loginService.logout(this.Spa_Site_SiteType);
            }
        });
    }
    isApiSessionLive() {
        return this.authService.hasApiSession() && !this.authService.isApiTokenExpired();
    }
    refresh() {
        // If API session expired, perform a hard refresh of the page.
        location.href = location.href.split('?')[0];
    }
    showErrorMessage() {
        if (this.loginAttempted === false) {
            return false;
        }
        return this.username.errors || this.password.errors || this.fg.errors ? true : false;
    }
    getTagsToUpdate() {
        if (!this.agentLoginFacade.isLoggedIn()) {
            return {
                [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE,
                [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
                [DataLayerGlobalVariable.DRUG_COUNT]: NO_DRUGS_COUNT,
                [DataLayerGlobalVariable.MEMBER_PREF_COVERAGE]: null,
                [DataLayerGlobalVariable.MEMBER_PREF_SUBSIDY]: null,
                [DataLayerGlobalVariable.MEMBER_PREF_HEALTH]: null,
                [DataLayerGlobalVariable.MEMBER_PREF_AGE]: null
            };
        }
    }
    navigateToSubscription() {
        this.navigationService.navigateByPageTag(PageTags.AGENT_SUBSCRIPTION);
    }
};
AgentLoginComponent.ɵfac = function AgentLoginComponent_Factory(t) { return new (t || AgentLoginComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i4.UntypedFormBuilder), i0.ɵɵdirectiveInject(AgentLoginFacade), i0.ɵɵdirectiveInject(i1.FormValidationService), i0.ɵɵdirectiveInject(i1.AuthService), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(i1.EmailService), i0.ɵɵdirectiveInject(SubscriptionFacade), i0.ɵɵdirectiveInject(i1.LoginService)); };
AgentLoginComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentLoginComponent, selectors: [["vnext-agent-login"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 27, vars: 42, consts: [[3, "headerType", "primaryLogo", "primaryLogoUrl", "secondaryLogo", "secondaryLogoUrl"], ["vnextGoogleTagManager", "", 1, "account-background", "d-flex", "flex-column", 3, "saveDefaultValues", "tagsToUpdate", "ngStyle"], [1, "mx-auto", "text-center", "w-70", "mt-lg-5", "mt-3", "pt-3", 3, "ngClass"], ["class", "Spa_Style_H1 Spa_Style_Secondary_Text_Color", 4, "liveEditProp"], ["class", "Spa_Style_H2 Spa_Style_Secondary_Text_Color", 4, "liveEditProp"], [1, "row", "mt-lg-5", "mt-4"], [1, "d-flex", "offset-lg-1", "offset-0", "col-lg-5", "col-12", "flex-column", "text-left", 3, "ngClass"], ["disableKeyDownSubmit", "", 3, "formGroup", "ngSubmit"], [1, "error-spacing"], ["class", "error Spa_Style_Small_Font", 4, "ngIf"], [1, "mt-2"], ["for", "username", "class", "Spa_Style_Label Spa_Style_Secondary_Text_Color d-block mb-0", 4, "liveEditProp"], ["id", "username", "formControlName", "username", 1, "w-100", "form-control", 3, "ngClass"], [1, "mt-4"], ["for", "password", "class", "Spa_Style_Label Spa_Style_Secondary_Text_Color d-block mb-0", 4, "liveEditProp"], ["id", "password", "formControlName", "password", "type", "password", 1, "form-control", 3, "ngClass"], ["type", "submit", "class", "btn btn-block Spa_Style_PrimaryButton mt-5 login-popover-container-button", 4, "liveEditProp"], [1, "row", "mt-lg-2", "mt-1"], ["class", "col-6 text-center", 4, "ngIf"], [4, "ngIf"], [3, "ngClass"], ["class", "Spa_Style_Secondary_Text_Color Spa_Style_Smaller_Font text-left mt-2 pl-3 pr-0", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [1, "Spa_Style_H1", "Spa_Style_Secondary_Text_Color"], [1, "Spa_Style_H2", "Spa_Style_Secondary_Text_Color"], [1, "error", "Spa_Style_Small_Font"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], ["for", "username", 1, "Spa_Style_Label", "Spa_Style_Secondary_Text_Color", "d-block", "mb-0"], ["for", "password", 1, "Spa_Style_Label", "Spa_Style_Secondary_Text_Color", "d-block", "mb-0"], ["type", "submit", 1, "btn", "btn-block", "Spa_Style_PrimaryButton", "mt-5", "login-popover-container-button"], [1, "col-6", "text-center"], [1, "mt-4", 3, "keyNameForLiveEdit", "alwaysUnderlined", "title", "tag", "customClass"], ["class", "Spa_Style_Paragraph Spa_Style_Secondary_Text_Color text-left mt-4", 4, "liveEditProp"], [1, "Spa_Style_Paragraph", "Spa_Style_Secondary_Text_Color", "text-left", "mt-4"], ["navigationAdapter", "", 1, "Spa_Style_Secondary_Text_Color", "Spa_Style_Smaller_Font", "text-left", "mt-2", "pl-3", "pr-0", 3, "innerHtml"], ["type", "submit", "class", "btn btn-block Spa_Style_SecondaryButton mt-5 login-popover-container-button", 3, "click", 4, "liveEditProp"], ["type", "submit", 1, "btn", "btn-block", "Spa_Style_SecondaryButton", "mt-5", "login-popover-container-button", 3, "click"]], template: function AgentLoginComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "vnext-dynamic-header", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, AgentLoginComponent_h1_3_Template, 2, 1, "h1", 3);
        i0.ɵɵtemplate(4, AgentLoginComponent_h2_4_Template, 2, 1, "h2", 4);
        i0.ɵɵelementStart(5, "div", 5)(6, "div", 6);
        i0.ɵɵpipe(7, "async");
        i0.ɵɵpipe(8, "async");
        i0.ɵɵelementStart(9, "form", 7);
        i0.ɵɵlistener("ngSubmit", function AgentLoginComponent_Template_form_ngSubmit_9_listener() { return ctx.login(); });
        i0.ɵɵelementStart(10, "div", 8);
        i0.ɵɵtemplate(11, AgentLoginComponent_span_11_Template, 3, 1, "span", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 10);
        i0.ɵɵtemplate(13, AgentLoginComponent_label_13_Template, 2, 1, "label", 11);
        i0.ɵɵelement(14, "input", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "div", 13);
        i0.ɵɵtemplate(16, AgentLoginComponent_label_16_Template, 2, 1, "label", 14);
        i0.ɵɵelement(17, "input", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(18, AgentLoginComponent_button_18_Template, 2, 1, "button", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div", 17);
        i0.ɵɵtemplate(20, AgentLoginComponent_div_20_Template, 2, 5, "div", 18);
        i0.ɵɵtemplate(21, AgentLoginComponent_div_21_Template, 2, 5, "div", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(22, AgentLoginComponent_div_22_Template, 2, 1, "div", 19);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "div", 20);
        i0.ɵɵelement(24, "div", 8);
        i0.ɵɵtemplate(25, AgentLoginComponent_div_25_Template, 2, 4, "div", 21);
        i0.ɵɵtemplate(26, AgentLoginComponent_div_26_Template, 2, 1, "div", 19);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("headerType", "basic")("primaryLogo", ctx.Spa_HeaderFooter_PrimaryClientLogo)("primaryLogoUrl", ctx.Spa_HeaderFooter_PrimaryClientLogo_Url)("secondaryLogo", ctx.Spa_HeaderFooter_SecondaryClientLogo)("secondaryLogoUrl", ctx.Spa_HeaderFooter_SecondaryClientLogo_Url);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("saveDefaultValues", true)("tagsToUpdate", ctx.getTagsToUpdate())("ngStyle", i0.ɵɵpureFunction1(29, _c0$1G, "url(" + ctx.Spa_AgentLogin_Background_Image + ")"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(31, _c1$O, ctx.Spa_Site_Is_MedicareEdge));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_AgentLogin_Header_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_AgentLogin_SubHeader_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(33, _c2$x, !i0.ɵɵpipeBind1(7, 25, ctx.isMobile$) && !i0.ɵɵpipeBind1(8, 27, ctx.isMedium$)));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("formGroup", ctx.fg);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showErrorMessage());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_AgentLogin_Username_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(35, _c3$m, ctx.username.errors && ctx.loginAttempted));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_AgentLogin_Password_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(37, _c3$m, ctx.password.errors && ctx.loginAttempted));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_AgentLogin_Button_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.Spa_AgentLogin_ForgotUsername_Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_AgentLogin_ForgotPassword_Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_AgentLogin_NoAccount_Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(39, _c4$d, !ctx.Spa_Site_Is_MedicareEdge, ctx.Spa_Site_Is_MedicareEdge));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_AgentLogin_AdditionalInformation_Html");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_AgentLogin_SubscribeNow_Enabled);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$2.NgStyle, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, LinkComponent, NavigationAdapterDirective, LiveEditPropDirective, FormInputSubmitDirective, GoogleTagManagerDirective, IconAriaAttributesDirective, DynamicHeaderComponent, i1$2.AsyncPipe, SafePipe], styles: [".account-background[_ngcontent-%COMP%]{min-height:100vh;height:100%;background-color:#344157e6;background-size:cover}.border[_ngcontent-%COMP%]{border-right:3px}.error[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Error_On_Dark)}.error-spacing[_ngcontent-%COMP%]{min-height:30px}.error-border[_ngcontent-%COMP%]{border:2px solid var(--static-Spa_Style_Error_On_Dark)}@media (max-width: 992px){.login-wrapper[_ngcontent-%COMP%]{max-width:350px}}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], AgentLoginComponent.prototype, "Spa_AgentLogin_Background_Image", void 0);
__decorate([
    GlobalResource()
], AgentLoginComponent.prototype, "Spa_AgentLogin_ForgotPassword_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentLoginComponent.prototype, "Spa_AgentLogin_ForgotUsername_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentLoginComponent.prototype, "Spa_AgentLogin_SubscribeNow_Enabled", void 0);
__decorate([
    GlobalResource()
], AgentLoginComponent.prototype, "Spa_Site_Is_MedicareEdge", void 0);
__decorate([
    GlobalResource()
], AgentLoginComponent.prototype, "Spa_AgentLogin_NoAccount_Enabled", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentLoginComponent.prototype, "Spa_AgentLogin_SubscribeNow_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentLoginComponent.prototype, "Spa_AgentLogin_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentLoginComponent.prototype, "Spa_AgentLogin_SubHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentLoginComponent.prototype, "Spa_AgentLogin_Button_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentLoginComponent.prototype, "Spa_AgentLogin_Username_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentLoginComponent.prototype, "Spa_AgentLogin_Password_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentLoginComponent.prototype, "Spa_AgentLogin_ForgotUsernameLink_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentLoginComponent.prototype, "Spa_AgentLogin_ForgotPasswordLink_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentLoginComponent.prototype, "Spa_AgentLogin_NoAccount_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AgentLoginComponent.prototype, "Spa_AgentLogin_AdditionalInformation_Html", void 0);
__decorate([
    GlobalResource()
], AgentLoginComponent.prototype, "Spa_AgentLogin_ErrorMessage_Text", void 0);
__decorate([
    GlobalResource()
], AgentLoginComponent.prototype, "Spa_AgentLogin_MaxAttemptErrorMessage_Text", void 0);
__decorate([
    GlobalResource()
], AgentLoginComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo", void 0);
__decorate([
    GlobalResource()
], AgentLoginComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo_Url", void 0);
__decorate([
    GlobalResource()
], AgentLoginComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo", void 0);
__decorate([
    GlobalResource()
], AgentLoginComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo_Url", void 0);
__decorate([
    GlobalResource()
], AgentLoginComponent.prototype, "Spa_PlanCompareEdgeForAgentsEmail_ButtonUrl", void 0);
__decorate([
    GlobalResource()
], AgentLoginComponent.prototype, "Spa_Site_Agent_Subscription_Expire_Days_Count", void 0);
__decorate([
    GlobalResource()
], AgentLoginComponent.prototype, "Spa_Site_SiteType", void 0);
__decorate([
    LiveEditInactive()
], AgentLoginComponent.prototype, "login", null);
AgentLoginComponent = __decorate([
    PlatformWidget
], AgentLoginComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgentLoginComponent, [{
        type: Component,
        args: [{ selector: 'vnext-agent-login', providers: [WidgetService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-dynamic-header\r\n  [headerType]=\"'basic'\"\r\n  [primaryLogo]=\"Spa_HeaderFooter_PrimaryClientLogo\"\r\n  [primaryLogoUrl]=\"Spa_HeaderFooter_PrimaryClientLogo_Url\"\r\n  [secondaryLogo]=\"Spa_HeaderFooter_SecondaryClientLogo\"\r\n  [secondaryLogoUrl]=\"Spa_HeaderFooter_SecondaryClientLogo_Url\"\r\n>\r\n</vnext-dynamic-header>\r\n<div\r\n  vnextGoogleTagManager\r\n  [saveDefaultValues]=\"true\"\r\n  [tagsToUpdate]=\"getTagsToUpdate()\"\r\n  class=\"account-background d-flex flex-column\"\r\n  [ngStyle]=\"{ 'background-image': 'url(' + Spa_AgentLogin_Background_Image + ')' }\"\r\n>\r\n  <div class=\"mx-auto text-center w-70 mt-lg-5 mt-3 pt-3\" [ngClass]=\"{ 'login-wrapper': Spa_Site_Is_MedicareEdge }\">\r\n    <h1 class=\"Spa_Style_H1 Spa_Style_Secondary_Text_Color\" *liveEditProp=\"'Spa_AgentLogin_Header_Text'\">\r\n      {{ Spa_AgentLogin_Header_Text }}\r\n    </h1>\r\n    <h2 class=\"Spa_Style_H2 Spa_Style_Secondary_Text_Color\" *liveEditProp=\"'Spa_AgentLogin_SubHeader_Text'\">\r\n      {{ Spa_AgentLogin_SubHeader_Text }}\r\n    </h2>\r\n    <div class=\"row mt-lg-5 mt-4\">\r\n      <div\r\n        class=\"d-flex offset-lg-1 offset-0 col-lg-5 col-12 flex-column text-left\"\r\n        [ngClass]=\"{ 'border-right': !(isMobile$ | async) && !(isMedium$ | async) }\"\r\n      >\r\n        <form disableKeyDownSubmit [formGroup]=\"fg\" (ngSubmit)=\"login()\">\r\n          <div class=\"error-spacing\">\r\n            <span *ngIf=\"showErrorMessage()\" class=\"error Spa_Style_Small_Font\"\r\n              ><i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i> {{ errorMessage }}</span\r\n            >\r\n          </div>\r\n          <div class=\"mt-2\">\r\n            <label\r\n              *liveEditProp=\"'Spa_AgentLogin_Username_Text'\"\r\n              for=\"username\"\r\n              class=\"Spa_Style_Label Spa_Style_Secondary_Text_Color d-block mb-0\"\r\n            >\r\n              {{ Spa_AgentLogin_Username_Text }}\r\n            </label>\r\n            <!-- placeholder input will be added in a different story -->\r\n            <input\r\n              id=\"username\"\r\n              class=\"w-100 form-control\"\r\n              formControlName=\"username\"\r\n              [ngClass]=\"{ 'error-border': username.errors && loginAttempted }\"\r\n            />\r\n          </div>\r\n          <div class=\"mt-4\">\r\n            <label\r\n              *liveEditProp=\"'Spa_AgentLogin_Password_Text'\"\r\n              for=\"password\"\r\n              class=\"Spa_Style_Label Spa_Style_Secondary_Text_Color d-block mb-0\"\r\n            >\r\n              {{ Spa_AgentLogin_Password_Text }}\r\n            </label>\r\n            <!-- placeholder input will be added in a different story -->\r\n            <input\r\n              id=\"password\"\r\n              class=\"w-100\"\r\n              formControlName=\"password\"\r\n              type=\"password\"\r\n              class=\"form-control\"\r\n              [ngClass]=\"{ 'error-border': password.errors && loginAttempted }\"\r\n            />\r\n          </div>\r\n          <button\r\n            type=\"submit\"\r\n            class=\"btn btn-block Spa_Style_PrimaryButton mt-5 login-popover-container-button\"\r\n            *liveEditProp=\"'Spa_AgentLogin_Button_Text'\"\r\n          >\r\n            {{ Spa_AgentLogin_Button_Text }}\r\n          </button>\r\n        </form>\r\n        <div class=\"row mt-lg-2 mt-1\">\r\n          <div *ngIf=\"Spa_AgentLogin_ForgotUsername_Enabled\" class=\"col-6 text-center\">\r\n            <vnext-link\r\n              [keyNameForLiveEdit]=\"'Spa_AgentLogin_ForgotUsernameLink_Text'\"\r\n              [alwaysUnderlined]=\"true\"\r\n              class=\"mt-4\"\r\n              [title]=\"Spa_AgentLogin_ForgotUsernameLink_Text\"\r\n              [tag]=\"pageTags.FORGOT_USERNAME\"\r\n              [customClass]=\"'Spa_Style_LinkOnDarkBackgrounds login-popover-container-linktext'\"\r\n            >\r\n            </vnext-link>\r\n          </div>\r\n          <div *ngIf=\"Spa_AgentLogin_ForgotPassword_Enabled\" class=\"col-6 text-center\">\r\n            <vnext-link\r\n              [keyNameForLiveEdit]=\"'Spa_AgentLogin_ForgotPasswordLink_Text'\"\r\n              [alwaysUnderlined]=\"true\"\r\n              class=\"mt-4\"\r\n              [title]=\"Spa_AgentLogin_ForgotPasswordLink_Text\"\r\n              [tag]=\"pageTags.FORGOT_PASSWORD\"\r\n              [customClass]=\"'Spa_Style_LinkOnDarkBackgrounds login-popover-container-linktext'\"\r\n            >\r\n            </vnext-link>\r\n          </div>\r\n        </div>\r\n        <div *ngIf=\"Spa_AgentLogin_NoAccount_Enabled\">\r\n          <div class=\"Spa_Style_Paragraph Spa_Style_Secondary_Text_Color text-left mt-4\" *liveEditProp=\"'Spa_AgentLogin_NoAccount_Text'\">\r\n            {{ Spa_AgentLogin_NoAccount_Text }}\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div [ngClass]=\"{ 'col-6 d-lg-block d-none': !Spa_Site_Is_MedicareEdge, 'col-12 col-lg-6 mb-3': Spa_Site_Is_MedicareEdge }\">\r\n        <div class=\"error-spacing\"></div>\r\n        <div\r\n          *liveEditProp=\"'Spa_AgentLogin_AdditionalInformation_Html'\"\r\n          class=\"Spa_Style_Secondary_Text_Color Spa_Style_Smaller_Font text-left mt-2 pl-3 pr-0\"\r\n          navigationAdapter\r\n          [innerHtml]=\"Spa_AgentLogin_AdditionalInformation_Html | safe : 'html'\"\r\n        ></div>\r\n        <div *ngIf=\"Spa_AgentLogin_SubscribeNow_Enabled\">\r\n          <button\r\n            type=\"submit\"\r\n            class=\"btn btn-block Spa_Style_SecondaryButton mt-5 login-popover-container-button\"\r\n            (click)=\"navigateToSubscription()\"\r\n            *liveEditProp=\"'Spa_AgentLogin_SubscribeNow_Text'\"\r\n          >\r\n            {{ Spa_AgentLogin_SubscribeNow_Text }}\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".account-background{min-height:100vh;height:100%;background-color:#344157e6;background-size:cover}.border{border-right:3px}.error{color:var(--static-Spa_Style_Error_On_Dark)}.error-spacing{min-height:30px}.error-border{border:2px solid var(--static-Spa_Style_Error_On_Dark)}@media (max-width: 992px){.login-wrapper{max-width:350px}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i4.UntypedFormBuilder }, { type: AgentLoginFacade }, { type: i1.FormValidationService }, { type: i1.AuthService }, { type: i2$1.Router }, { type: AnalyticsService }, { type: i1.NavigationService }, { type: i1.ConfigResourceService }, { type: i1.AgentService }, { type: i1.EmailService }, { type: SubscriptionFacade }, { type: i1.LoginService }]; }, { Spa_AgentLogin_Background_Image: [], Spa_AgentLogin_ForgotPassword_Enabled: [], Spa_AgentLogin_ForgotUsername_Enabled: [], Spa_AgentLogin_SubscribeNow_Enabled: [], Spa_Site_Is_MedicareEdge: [], Spa_AgentLogin_NoAccount_Enabled: [], Spa_AgentLogin_SubscribeNow_Text: [], Spa_AgentLogin_Header_Text: [], Spa_AgentLogin_SubHeader_Text: [], Spa_AgentLogin_Button_Text: [], Spa_AgentLogin_Username_Text: [], Spa_AgentLogin_Password_Text: [], Spa_AgentLogin_ForgotUsernameLink_Text: [], Spa_AgentLogin_ForgotPasswordLink_Text: [], Spa_AgentLogin_NoAccount_Text: [], Spa_AgentLogin_AdditionalInformation_Html: [], Spa_AgentLogin_ErrorMessage_Text: [], Spa_AgentLogin_MaxAttemptErrorMessage_Text: [], Spa_HeaderFooter_PrimaryClientLogo: [], Spa_HeaderFooter_PrimaryClientLogo_Url: [], Spa_HeaderFooter_SecondaryClientLogo: [], Spa_HeaderFooter_SecondaryClientLogo_Url: [], Spa_PlanCompareEdgeForAgentsEmail_ButtonUrl: [], Spa_Site_Agent_Subscription_Expire_Days_Count: [], Spa_Site_SiteType: [], login: [] }); })();

function CreateAccountNudgeComponent_ng_template_0_p_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.Spa_Profile_CreateAccount_Nudge_Prompt, " ");
} }
function CreateAccountNudgeComponent_ng_template_0_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵelement(1, "i", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r4.Spa_Profile_CreateAccount_Nudge_Time_Estimate_Text, " ");
} }
function CreateAccountNudgeComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, CreateAccountNudgeComponent_ng_template_0_p_0_Template, 2, 1, "p", 2);
    i0.ɵɵelement(1, "vnext-link", 3);
    i0.ɵɵtemplate(2, CreateAccountNudgeComponent_ng_template_0_span_2_Template, 3, 1, "span", 4);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("liveEditProp", "Spa_Profile_CreateAccount_Nudge_Prompt");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r1.Spa_Profile_CreateAccount_Nudge_Link_Text)("titleClass", "Spa_Style_Light_Weight")("onClickAction", ctx_r1.openCreateAccount)("keyNameForLiveEdit", "Spa_Profile_CreateAccount_Nudge_Link_Text")("makeInlineBlock", true)("isLinkButton", true)("alwaysUnderlined", true)("customClass", "Spa_Style_Link mb-md-0 mb-1 pb-1 login-popover-container-linktext");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Profile_CreateAccount_Nudge_Time_Estimate_Text");
} }
function CreateAccountNudgeComponent_div_2_ng_container_1_vnext_notice_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice", 15);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵproperty("type", "info")("title", ctx_r8.Spa_Profile_CreateAccount_Nudge_Title)("bodyTemplate", _r0)("infoCustomClass", "mb-md-0 mb-1");
} }
function CreateAccountNudgeComponent_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelement(2, "div", 12);
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵtemplate(4, CreateAccountNudgeComponent_div_2_ng_container_1_vnext_notice_4_Template, 1, 4, "vnext-notice", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("liveEditProp", "Spa_Profile_CreateAccount_Nudge_Title");
} }
function CreateAccountNudgeComponent_div_2_ng_template_2_vnext_notice_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice", 15);
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵproperty("type", "info")("title", ctx_r9.Spa_Profile_CreateAccount_Nudge_Title)("bodyTemplate", _r0)("infoCustomClass", "mb-md-0 mb-1");
} }
function CreateAccountNudgeComponent_div_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, CreateAccountNudgeComponent_div_2_ng_template_2_vnext_notice_1_Template, 1, 4, "vnext-notice", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Profile_CreateAccount_Nudge_Title");
} }
function CreateAccountNudgeComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, CreateAccountNudgeComponent_div_2_ng_container_1_Template, 5, 1, "ng-container", 9);
    i0.ɵɵtemplate(2, CreateAccountNudgeComponent_div_2_ng_template_2_Template, 2, 1, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r6 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.Spa_Profile_CreateAccount_RightAlign)("ngIfElse", _r6);
} }
let CreateAccountNudgeComponent = class CreateAccountNudgeComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, createAccountContext, sessionService, analyticsService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.cdr = cdr;
        this.widgetValidationService = widgetValidationService;
        this.configurableWidgetService = configurableWidgetService;
        this.zoneService = zoneService;
        this.widgetService = widgetService;
        this.createAccountContext = createAccountContext;
        this.sessionService = sessionService;
        this.analyticsService = analyticsService;
        this.Spa_Profile_CreateAccount_RightAlign = false;
        this.Spa_Profile_CreateAccount_Nudge_Title = "<b>You've added a lot of info!</b>";
        this.Spa_Profile_CreateAccount_Nudge_Prompt = 'Save information to your account and return at a later time.';
        this.Spa_Profile_CreateAccount_Nudge_Link_Text = 'Create an account';
        this.Spa_Profile_CreateAccount_Nudge_Time_Estimate_Text = 'Takes 2 minutes';
        this.Spa_Profile_CreateAccount_Nudge_Enabled = false;
        this.Spa_LoginWidget_Create_Account_Display = true;
        this.displayNudge = false;
        this.subscriptions = [];
        this.openCreateAccount = () => {
            this.updateGoogleTagEvent(DataLayerEvent.CLICK_HEADER_CREATE_ACCOUNT_FROM_NUDGE);
            this.createAccountContext.isCreateAccountFromExternal(true);
            this.createAccountContext.openCreateAccount();
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.subscriptions.push(combineLatest([this.sessionService.isMemberLoggedIn$(), this.createAccountContext.showCreateAccountNudge$]).subscribe(([memberLoggedIn, show]) => {
            this.displayNudge = !memberLoggedIn && show;
            this.cdr.markForCheck();
        }));
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    updateGoogleTagEvent(event) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: event
        };
    }
};
CreateAccountNudgeComponent.ɵfac = function CreateAccountNudgeComponent_Factory(t) { return new (t || CreateAccountNudgeComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(CreateAccountContext), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(AnalyticsService)); };
CreateAccountNudgeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CreateAccountNudgeComponent, selectors: [["vnext-create-account-nudge"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 1, consts: [["createAccountNudgeBody", ""], ["class", "container", 4, "ngIf"], ["class", "mb-0 mt-md-0 mt-1 Spa_Style_Light_Weight expanded-line-height", 4, "liveEditProp"], [3, "title", "titleClass", "onClickAction", "keyNameForLiveEdit", "makeInlineBlock", "isLinkButton", "alwaysUnderlined", "customClass"], ["class", "Spa_Style_Light_Weight Spa_Style_Smaller_Font d-inline-block expanded-line-height ml-3", 4, "liveEditProp"], [1, "mb-0", "mt-md-0", "mt-1", "Spa_Style_Light_Weight", "expanded-line-height"], [1, "Spa_Style_Light_Weight", "Spa_Style_Smaller_Font", "d-inline-block", "expanded-line-height", "ml-3"], [1, "fas", "fa-clock", "light-clock", "pr-1"], [1, "container"], [4, "ngIf", "ngIfElse"], ["expandedView", ""], [1, "row"], [1, "col-md-3", "col-xs-12"], [1, "pl-md-4", "col-md-9", "col-xs-12", "nudge-notice-container"], [3, "type", "title", "bodyTemplate", "infoCustomClass", 4, "liveEditProp"], [3, "type", "title", "bodyTemplate", "infoCustomClass"], [1, "col-12", "nudge-notice-container", "px-0"]], template: function CreateAccountNudgeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CreateAccountNudgeComponent_ng_template_0_Template, 3, 10, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(2, CreateAccountNudgeComponent_div_2_Template, 4, 2, "div", 1);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.Spa_LoginWidget_Create_Account_Display && ctx.Spa_Profile_CreateAccount_Nudge_Enabled && ctx.displayNudge);
    } }, dependencies: [i1$2.NgIf, LinkComponent, NoticeComponent, LiveEditPropDirective, IconAriaAttributesDirective], styles: [".nudge-notice-container[_ngcontent-%COMP%]{padding-top:16px}.expanded-line-height[_ngcontent-%COMP%]{line-height:1.4}.light-clock[_ngcontent-%COMP%]{font-size:13px;color:var(--static-Spa_Style_Gray4)}"], changeDetection: 0 });
__decorate([
    PlatformProp()
], CreateAccountNudgeComponent.prototype, "Spa_Profile_CreateAccount_RightAlign", void 0);
__decorate([
    PlatformProp('live-edit')
], CreateAccountNudgeComponent.prototype, "Spa_Profile_CreateAccount_Nudge_Title", void 0);
__decorate([
    PlatformProp('live-edit')
], CreateAccountNudgeComponent.prototype, "Spa_Profile_CreateAccount_Nudge_Prompt", void 0);
__decorate([
    PlatformProp('live-edit')
], CreateAccountNudgeComponent.prototype, "Spa_Profile_CreateAccount_Nudge_Link_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], CreateAccountNudgeComponent.prototype, "Spa_Profile_CreateAccount_Nudge_Time_Estimate_Text", void 0);
__decorate([
    GlobalResource()
], CreateAccountNudgeComponent.prototype, "Spa_Profile_CreateAccount_Nudge_Enabled", void 0);
__decorate([
    GlobalResource()
], CreateAccountNudgeComponent.prototype, "Spa_LoginWidget_Create_Account_Display", void 0);
CreateAccountNudgeComponent = __decorate([
    PlatformWidget
], CreateAccountNudgeComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CreateAccountNudgeComponent, [{
        type: Component,
        args: [{ selector: 'vnext-create-account-nudge', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<ng-template #createAccountNudgeBody>\r\n  <p class=\"mb-0 mt-md-0 mt-1 Spa_Style_Light_Weight expanded-line-height\" *liveEditProp=\"'Spa_Profile_CreateAccount_Nudge_Prompt'\">\r\n    {{ Spa_Profile_CreateAccount_Nudge_Prompt }}\r\n  </p>\r\n  <vnext-link\r\n    [title]=\"Spa_Profile_CreateAccount_Nudge_Link_Text\"\r\n    [titleClass]=\"'Spa_Style_Light_Weight'\"\r\n    [onClickAction]=\"openCreateAccount\"\r\n    [keyNameForLiveEdit]=\"'Spa_Profile_CreateAccount_Nudge_Link_Text'\"\r\n    [makeInlineBlock]=\"true\"\r\n    [isLinkButton]=\"true\"\r\n    [alwaysUnderlined]=\"true\"\r\n    [customClass]=\"'Spa_Style_Link mb-md-0 mb-1 pb-1 login-popover-container-linktext'\"\r\n  >\r\n  </vnext-link>\r\n  <span class=\"Spa_Style_Light_Weight Spa_Style_Smaller_Font d-inline-block expanded-line-height ml-3\" *liveEditProp=\"'Spa_Profile_CreateAccount_Nudge_Time_Estimate_Text'\">\r\n    <i class=\"fas fa-clock light-clock pr-1\"></i>{{ Spa_Profile_CreateAccount_Nudge_Time_Estimate_Text }}\r\n  </span>\r\n</ng-template>\r\n<div class=\"container\" *ngIf=\"Spa_LoginWidget_Create_Account_Display && Spa_Profile_CreateAccount_Nudge_Enabled && displayNudge\">\r\n  <ng-container *ngIf=\"Spa_Profile_CreateAccount_RightAlign; else expandedView\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-3 col-xs-12\"></div>\r\n      <div class=\"pl-md-4 col-md-9 col-xs-12 nudge-notice-container\">\r\n        <vnext-notice\r\n          [type]=\"'info'\"\r\n          [title]=\"Spa_Profile_CreateAccount_Nudge_Title\"\r\n          [bodyTemplate]=\"createAccountNudgeBody\"\r\n          [infoCustomClass]=\"'mb-md-0 mb-1'\"\r\n          *liveEditProp=\"'Spa_Profile_CreateAccount_Nudge_Title'\"\r\n        ></vnext-notice>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n  <ng-template #expandedView>\r\n    <div class=\"col-12 nudge-notice-container px-0\">\r\n      <vnext-notice\r\n        [type]=\"'info'\"\r\n        [title]=\"Spa_Profile_CreateAccount_Nudge_Title\"\r\n        [bodyTemplate]=\"createAccountNudgeBody\"\r\n        [infoCustomClass]=\"'mb-md-0 mb-1'\"\r\n        *liveEditProp=\"'Spa_Profile_CreateAccount_Nudge_Title'\"\r\n      ></vnext-notice>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n", styles: [".nudge-notice-container{padding-top:16px}.expanded-line-height{line-height:1.4}.light-clock{font-size:13px;color:var(--static-Spa_Style_Gray4)}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: CreateAccountContext }, { type: i1.MemberSessionService }, { type: AnalyticsService }]; }, { Spa_Profile_CreateAccount_RightAlign: [], Spa_Profile_CreateAccount_Nudge_Title: [], Spa_Profile_CreateAccount_Nudge_Prompt: [], Spa_Profile_CreateAccount_Nudge_Link_Text: [], Spa_Profile_CreateAccount_Nudge_Time_Estimate_Text: [], Spa_Profile_CreateAccount_Nudge_Enabled: [], Spa_LoginWidget_Create_Account_Display: [] }); })();

function CheckOutFormComponent_div_0_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9)(2, "p", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 11)(5, "p");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div")(8, "div", 12);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "currency");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "div", 13)(14, "button", 14);
    i0.ɵɵlistener("click", function CheckOutFormComponent_div_0_ng_container_1_div_1_Template_button_click_14_listener() { i0.ɵɵrestoreView(_r7); const option_r3 = i0.ɵɵnextContext().$implicit; const ctx_r5 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r5.getStripeCheckoutSession(option_r3.pricingId)); });
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const option_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(option_r3.productLabel);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(option_r3.description);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 5, option_r3.price), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(option_r3.durationLabel);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.buttonText, " ");
} }
function CheckOutFormComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckOutFormComponent_div_0_ng_container_1_div_1_Template, 16, 7, "div", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const option_r3 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", option_r3 == null ? null : option_r3.pricingId);
} }
function CheckOutFormComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, CheckOutFormComponent_div_0_ng_container_1_Template, 2, 1, "ng-container", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.productOptions)("ngForTrackBy", ctx_r0.trackByPricingId);
} }
function CheckOutFormComponent_vnext_link_4_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 15);
    i0.ɵɵlistener("click", function CheckOutFormComponent_vnext_link_4_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.backToPrevious()); })("keyup.enter", function CheckOutFormComponent_vnext_link_4_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.backToPrevious()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r1.previousLabel)("showArrow", "left")("customClass", "Spa_Style_Link p-1")("makeInlineBlock", true)("role", ctx_r1.linkRoles.BUTTON)("ariaLabel", ctx_r1.previousLabel);
} }
let CheckOutFormComponent = class CheckOutFormComponent {
    constructor(cdr, subscriptionFacade) {
        this.cdr = cdr;
        this.subscriptionFacade = subscriptionFacade;
        this.backToSubscriptionForm = new EventEmitter();
        this.stripeConstant = StripeConstant;
        this.isStripePaymentLoaded = false;
        this.linkRoles = LinkRoles;
        this.stripePromise = loadStripe(StripeConstant.PUBLISHABLE_KEY_TEST);
        this.checkout = null;
    }
    ngOnChanges(changes) {
        const { productOptions } = changes;
        if (productOptions && !_isEqual(productOptions.previousValue, productOptions.currentValue)) {
            this.productOptions = this.productOptions.sort((optionA, optionB) => optionA.price - optionB.price);
        }
    }
    backToPrevious() {
        if (this.isStripePaymentLoaded) {
            this.isStripePaymentLoaded = false;
            this.cleanupCheckout();
        }
        else {
            this.backToSubscriptionForm.emit({ showPayment: false });
        }
    }
    trackByPricingId(index, productOption) {
        return productOption.pricingId;
    }
    getStripeCheckoutSession(priceId) {
        this.subscriptionFacade.getStripeCheckoutSession$(priceId).subscribe({
            next: (sessionData) => {
                if (sessionData?.clientSecret) {
                    this.stripePromise = loadStripe(this.isPublishableKeyLiveEnabled ? StripeConstant.PUBLISHABLE_KEY_LIVE : StripeConstant.PUBLISHABLE_KEY_TEST);
                    this.clientSecret = sessionData.clientSecret;
                    this.initializeCheckout(this.clientSecret);
                }
            }
        });
    }
    async initializeCheckout(clientSecret) {
        const stripe = await this.stripePromise;
        if (stripe) {
            this.checkout = await stripe.initEmbeddedCheckout({
                clientSecret
            });
            this.checkout.mount('#checkout');
            this.isStripePaymentLoaded = true;
        }
        this.cdr.markForCheck();
    }
    ngOnDestroy() {
        this.cleanupCheckout();
    }
    cleanupCheckout() {
        if (this.checkout) {
            this.checkout?.['embeddedCheckout']?.isDestroyed || this.checkout?.destroy();
            this.checkout = null; // Ensure instance is nullified
        }
    }
};
CheckOutFormComponent.ɵfac = function CheckOutFormComponent_Factory(t) { return new (t || CheckOutFormComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(SubscriptionFacade)); };
CheckOutFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CheckOutFormComponent, selectors: [["vnext-checkout-form"]], inputs: { productLabel: "productLabel", monthlyDescription: "monthlyDescription", quarterlyDescription: "quarterlyDescription", annuallyDescription: "annuallyDescription", durationLabel: "durationLabel", buttonText: "buttonText", productOptions: "productOptions", previousLabel: "previousLabel", isPublishableKeyLiveEnabled: "isPublishableKeyLiveEnabled" }, outputs: { backToSubscriptionForm: "backToSubscriptionForm" }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵNgOnChangesFeature], decls: 5, vars: 2, consts: [["class", "row", 4, "ngIf"], ["id", "checkout", 1, "mt-4"], [1, "w-100", "d-flex", "align-items-center", "mx-3", "my-5"], ["previous-link", ""], [3, "title", "showArrow", "customClass", "makeInlineBlock", "role", "ariaLabel", "click", "keyup.enter", 4, "liveEditProp"], [1, "row"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "col-12 col-sm-4 col-md-4", 4, "ngIf"], [1, "col-12", "col-sm-4", "col-md-4"], [1, "m-3", "p-4", "product-container"], [1, "Spa_Style_Regular_Font", "Spa_Style_Bold_Weight"], [1, "product-description-container"], [1, "Spa_Style_H1", "Spa_Style_Bold_Weight"], [1, "my-5"], ["type", "submit", 1, "col-12", "btn", "Spa_Style_PrimaryButton", 3, "click"], [3, "title", "showArrow", "customClass", "makeInlineBlock", "role", "ariaLabel", "click", "keyup.enter"]], template: function CheckOutFormComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CheckOutFormComponent_div_0_Template, 2, 2, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3);
        i0.ɵɵtemplate(4, CheckOutFormComponent_vnext_link_4_Template, 1, 6, "vnext-link", 4);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.isStripePaymentLoaded);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_Previous");
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, LinkComponent, LiveEditPropDirective, i1$2.CurrencyPipe], styles: [".product-container[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray1);border:1px solid var(--static-Spa_Style_Gray2);border-radius:10px;display:flex;flex-direction:column;justify-content:space-between;height:100%}.product-description-container[_ngcontent-%COMP%]{flex:1 1 auto;min-height:50px;margin-bottom:1rem}"], changeDetection: 0 });
CheckOutFormComponent = __decorate([
    PlatformWidget
], CheckOutFormComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckOutFormComponent, [{
        type: Component,
        args: [{ selector: 'vnext-checkout-form', providers: [WidgetService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"!isStripePaymentLoaded\" class=\"row\">\r\n  <ng-container *ngFor=\"let option of productOptions; trackBy: trackByPricingId\">\r\n    <div *ngIf=\"option?.pricingId\" class=\"col-12 col-sm-4 col-md-4\">\r\n      <div class=\"m-3 p-4 product-container\">\r\n        <p class=\"Spa_Style_Regular_Font Spa_Style_Bold_Weight\">{{ option.productLabel }}</p>\r\n        <div class=\"product-description-container\">\r\n          <p>{{ option.description }}</p>\r\n        </div>\r\n        <div>\r\n          <div class=\"Spa_Style_H1 Spa_Style_Bold_Weight\">\r\n            {{ option.price | currency }}\r\n          </div>\r\n          <div>{{ option.durationLabel }}</div>\r\n        </div>\r\n\r\n        <div class=\"my-5\">\r\n          <button type=\"submit\" class=\"col-12 btn Spa_Style_PrimaryButton\" (click)=\"getStripeCheckoutSession(option.pricingId)\">\r\n            {{ buttonText }}\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n</div>\r\n\r\n<div id=\"checkout\" class=\"mt-4\"></div>\r\n<div class=\"w-100 d-flex align-items-center mx-3 my-5\">\r\n  <div previous-link>\r\n    <vnext-link\r\n      [title]=\"previousLabel\"\r\n      [showArrow]=\"'left'\"\r\n      (click)=\"backToPrevious()\"\r\n      [customClass]=\"'Spa_Style_Link p-1'\"\r\n      (keyup.enter)=\"backToPrevious()\"\r\n      [makeInlineBlock]=\"true\"\r\n      [role]=\"linkRoles.BUTTON\"\r\n      [ariaLabel]=\"previousLabel\"\r\n      *liveEditProp=\"'Spa_Site_Previous'\"\r\n    >\r\n    </vnext-link>\r\n  </div>\r\n</div>\r\n", styles: [".product-container{background-color:var(--static-Spa_Style_Gray1);border:1px solid var(--static-Spa_Style_Gray2);border-radius:10px;display:flex;flex-direction:column;justify-content:space-between;height:100%}.product-description-container{flex:1 1 auto;min-height:50px;margin-bottom:1rem}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: SubscriptionFacade }]; }, { productLabel: [{
            type: Input
        }], monthlyDescription: [{
            type: Input
        }], quarterlyDescription: [{
            type: Input
        }], annuallyDescription: [{
            type: Input
        }], durationLabel: [{
            type: Input
        }], buttonText: [{
            type: Input
        }], productOptions: [{
            type: Input
        }], previousLabel: [{
            type: Input
        }], backToSubscriptionForm: [{
            type: Output
        }], isPublishableKeyLiveEnabled: [{
            type: Input
        }] }); })();

function SubscriptionConfirmationComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r1.Spa_Site_Agent_Subscription_Success_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function SubscriptionConfirmationComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtemplate(2, SubscriptionConfirmationComponent_div_1_div_2_Template, 2, 4, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 5);
    i0.ɵɵpipe(4, "safe");
    i0.ɵɵelement(5, "div", 6);
    i0.ɵɵpipe(6, "safe");
    i0.ɵɵelementStart(7, "div", 7)(8, "button", 8);
    i0.ɵɵlistener("click", function SubscriptionConfirmationComponent_div_1_Template_button_click_8_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.navigateToLogin()); });
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(10, "div", 5);
    i0.ɵɵpipe(11, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_Agent_Subscription_Success_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(4, 5, ctx_r0.Spa_Agent_Subscription_Success_Instruction_Text, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(6, 8, ctx_r0.Spa_Agent_Subscription_Succuss_Instruction_Options_Text, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.Spa_Agent_Subscription_Login_Button_Text, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(11, 11, ctx_r0.Spa_Agent_Subscription_Contact_Text, "html"), i0.ɵɵsanitizeHtml);
} }
let SubscriptionConfirmationComponent = class SubscriptionConfirmationComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, navigationService, subscriptionFacade, emailService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.navigationService = navigationService;
        this.subscriptionFacade = subscriptionFacade;
        this.emailService = emailService;
        this.Spa_HeaderFooter_PrimaryClientLogo = '';
        this.Spa_HeaderFooter_PrimaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_HeaderFooter_SecondaryClientLogo = '';
        this.Spa_HeaderFooter_SecondaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_Site_Agent_Subscription_Success_Text = 'Congratulations! Your application has processed successfully.';
        this.Spa_Agent_Subscription_Success_Instruction_Text = 'You will receive an email with log in instructions.';
        this.Spa_Agent_Subscription_Succuss_Instruction_Options_Text = '<ul><li><b>Your username will be the email address you provided on your subscription form.</b></li><li>You will be required to change your password upon your initial log in</li></ul>';
        this.Spa_Agent_Subscription_Login_Button_Text = 'Log in to PlanCompare Edge for Agents';
        this.Spa_Agent_Subscription_Contact_Text = ' If you do not receive an email with our log in instructions, contact us at <site email address>.';
        this.Spa_PlanCompareEdgeForAgents_Email_ButtonUrl = '';
        this.Spa_ContactUsModal_Email = '';
        this.Spa_PlanCompareEdgeForAgents_Email_Subject = 'Welcome to PlanCompare Edge for Agents';
        this.Spa_PlanCompareEdgeForAgents_TemporarypPassword_Text = 'Temporary password';
        this.Spa_PlanCompareEdgeForAgents_AgentEmail = '';
        this.Spa_PlanCompareEdgeForAgents_AgentName = '';
        this.Spa_PlanCompareEdgeForAgents_AgencyName = '';
        this.Spa_PlanCompareEdgeForAgents_AgencyPhoneNumber = '125789-9999';
        this.Spa_PlanCompareEdgeForAgentsEmail_ClosingText = `Thank you for subscribing to PlanCompare Edge for Agents. If you have trouble logging in or have questions, please email us at <ContactUsModal_Email> <br /><br />Note: You will be receiving a separate confirmation regarding payment.`;
        this.Spa_PlanCompareEdgeForAgentsEmail_Header = `Welcome to PlanCompare Edge for Agents, <agentFullName>`;
        this.Spa_PlanCompareEdgeForAgentsEmail_Body = 'Your subscription application was successfully processed. Upon logging into PlanCompare Edge for Agents, you will be required to change your password.';
    }
    ngOnInit() {
        super.ngOnInit();
        const urlParams = new URLSearchParams(window.location.search);
        const stripeSessionId = urlParams.get('session_id');
        this.agentSubscriptionInfo = this.subscriptionFacade.getAgentSubscriptionInfo();
        if (stripeSessionId && this.agentSubscriptionInfo) {
            this.getAgentSubscriptionStatusAndSubmitInfo(stripeSessionId);
        }
        else {
            this.navigateToSubscription();
        }
    }
    getAgentSubscriptionStatusAndSubmitInfo(stripeSessionId) {
        this.subscriptionFacade
            .getAgentSubscriptionStatus$(stripeSessionId)
            .pipe(switchMap((statusDetail) => {
            if (statusDetail?.status === StripeSessionStatus.COMPLETE) {
                return this.subscriptionFacade.submitAgentInfo$({ customerID: statusDetail.customerId, ...this.agentSubscriptionInfo }).pipe(catchError(err => {
                    this.navigateToSubscription();
                    return of(null);
                }));
            }
            else {
                this.navigateToSubscription();
                return of(null);
            }
        }), catchError(err => {
            this.navigateToSubscription();
            return of(null);
        }))
            .subscribe({
            next: (agent) => {
                if (agent?.data) {
                    this.agentData = agent.data;
                    const agentFullName = this.agentData.firstName.concat(' ', this.agentData.lastName);
                    const emailheader = this.Spa_PlanCompareEdgeForAgentsEmail_Header.replace('<agentFullName>', agentFullName);
                    const agentsEmailClosingText = this.Spa_PlanCompareEdgeForAgentsEmail_ClosingText.replace('<ContactUsModal_Email>', this.Spa_ContactUsModal_Email);
                    const inputs = [
                        {
                            key: 'planDocumentHeader',
                            value: `${this.Spa_PlanCompareEdgeForAgents_TemporarypPassword_Text}: <br /><br /> <b>${this.agentData.tempPassword}</b>`
                        },
                        { key: 'planDocuments', value: '' },
                        { key: 'buttonUrl', value: this.Spa_PlanCompareEdgeForAgents_Email_ButtonUrl },
                        { key: 'agentName', value: this.Spa_PlanCompareEdgeForAgents_AgentName },
                        { key: 'agencyName', value: this.Spa_PlanCompareEdgeForAgents_AgencyName },
                        { key: 'agentEmail', value: this.Spa_PlanCompareEdgeForAgents_AgentEmail },
                        { key: 'agentPhoneAndHours', value: this.Spa_PlanCompareEdgeForAgents_AgencyPhoneNumber },
                        { key: 'emailHeader', value: emailheader },
                        { key: 'californiaLicenseNumber', value: '' },
                        { key: 'agentsEmailClosingText', value: agentsEmailClosingText },
                        { key: 'planCompareEdgeForAgentsEmailBody', value: this.Spa_PlanCompareEdgeForAgentsEmail_Body },
                        { key: 'planCompareEdgeForAgentsEmailWarningText', value: '' }
                    ];
                    this.emailService.sendEmail(EmailNames.PCEDGE_AGENTS_EMAIL, [this.agentData.emailAddress], this.Spa_PlanCompareEdgeForAgents_Email_Subject, inputs);
                    this.subscriptionFacade.resetAgentSubscriptionInfo();
                    this.cdr.markForCheck();
                }
            }
        });
    }
    navigateToLogin() {
        this.navigationService.navigateByPageTag(PageTags.AGENT_LOGIN);
    }
    navigateToSubscription() {
        this.navigationService.navigateByPageTag(PageTags.AGENT_SUBSCRIPTION);
    }
};
SubscriptionConfirmationComponent.ɵfac = function SubscriptionConfirmationComponent_Factory(t) { return new (t || SubscriptionConfirmationComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(SubscriptionFacade), i0.ɵɵdirectiveInject(i1.EmailService)); };
SubscriptionConfirmationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SubscriptionConfirmationComponent, selectors: [["vnext-subscription-confirmation"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 6, consts: [[3, "headerType", "primaryLogo", "primaryLogoUrl", "secondaryLogo", "secondaryLogoUrl"], ["class", "mx-auto container", 4, "ngIf"], [1, "mx-auto", "container"], [1, "col-12", "text-center", "mt-4"], ["class", "Spa_Style_H1", 3, "innerHTML", 4, "liveEditProp"], [1, "m-4", 3, "innerHTML"], [1, "mt-2", "mb-4", 3, "innerHTML"], [1, "w-100", "d-flex", "mx-3", "my-5"], ["triggers", "manual", 1, "btn", "Spa_Style_PrimaryButton", 3, "click"], [1, "Spa_Style_H1", 3, "innerHTML"]], template: function SubscriptionConfirmationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "vnext-dynamic-header", 0);
        i0.ɵɵtemplate(1, SubscriptionConfirmationComponent_div_1_Template, 12, 14, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("headerType", "basic")("primaryLogo", ctx.Spa_HeaderFooter_PrimaryClientLogo)("primaryLogoUrl", ctx.Spa_HeaderFooter_PrimaryClientLogo_Url)("secondaryLogo", ctx.Spa_HeaderFooter_SecondaryClientLogo)("secondaryLogoUrl", ctx.Spa_HeaderFooter_SecondaryClientLogo_Url);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.agentData);
    } }, dependencies: [i1$2.NgIf, LiveEditPropDirective, DynamicHeaderComponent, SafePipe], encapsulation: 2, changeDetection: 0 });
__decorate([
    PlatformProp()
], SubscriptionConfirmationComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo", void 0);
__decorate([
    PlatformProp()
], SubscriptionConfirmationComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo_Url", void 0);
__decorate([
    PlatformProp()
], SubscriptionConfirmationComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo", void 0);
__decorate([
    PlatformProp()
], SubscriptionConfirmationComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo_Url", void 0);
__decorate([
    PlatformProp('live-edit')
], SubscriptionConfirmationComponent.prototype, "Spa_Site_Agent_Subscription_Success_Text", void 0);
__decorate([
    GlobalResource()
], SubscriptionConfirmationComponent.prototype, "Spa_Agent_Subscription_Success_Instruction_Text", void 0);
__decorate([
    GlobalResource()
], SubscriptionConfirmationComponent.prototype, "Spa_Agent_Subscription_Succuss_Instruction_Options_Text", void 0);
__decorate([
    GlobalResource()
], SubscriptionConfirmationComponent.prototype, "Spa_Agent_Subscription_Login_Button_Text", void 0);
__decorate([
    GlobalResource()
], SubscriptionConfirmationComponent.prototype, "Spa_Agent_Subscription_Contact_Text", void 0);
__decorate([
    GlobalResource()
], SubscriptionConfirmationComponent.prototype, "Spa_PlanCompareEdgeForAgents_Email_ButtonUrl", void 0);
__decorate([
    GlobalResource()
], SubscriptionConfirmationComponent.prototype, "Spa_ContactUsModal_Email", void 0);
__decorate([
    GlobalResource()
], SubscriptionConfirmationComponent.prototype, "Spa_PlanCompareEdgeForAgents_Email_Subject", void 0);
__decorate([
    GlobalResource()
], SubscriptionConfirmationComponent.prototype, "Spa_PlanCompareEdgeForAgents_TemporarypPassword_Text", void 0);
__decorate([
    GlobalResource()
], SubscriptionConfirmationComponent.prototype, "Spa_PlanCompareEdgeForAgents_AgentEmail", void 0);
__decorate([
    GlobalResource()
], SubscriptionConfirmationComponent.prototype, "Spa_PlanCompareEdgeForAgents_AgentName", void 0);
__decorate([
    GlobalResource()
], SubscriptionConfirmationComponent.prototype, "Spa_PlanCompareEdgeForAgents_AgencyName", void 0);
__decorate([
    GlobalResource()
], SubscriptionConfirmationComponent.prototype, "Spa_PlanCompareEdgeForAgents_AgencyPhoneNumber", void 0);
__decorate([
    GlobalResource()
], SubscriptionConfirmationComponent.prototype, "Spa_PlanCompareEdgeForAgentsEmail_ClosingText", void 0);
__decorate([
    GlobalResource()
], SubscriptionConfirmationComponent.prototype, "Spa_PlanCompareEdgeForAgentsEmail_Header", void 0);
__decorate([
    GlobalResource()
], SubscriptionConfirmationComponent.prototype, "Spa_PlanCompareEdgeForAgentsEmail_Body", void 0);
SubscriptionConfirmationComponent = __decorate([
    PlatformWidget
], SubscriptionConfirmationComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubscriptionConfirmationComponent, [{
        type: Component,
        args: [{ selector: 'vnext-subscription-confirmation', providers: [WidgetService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-dynamic-header\r\n  [headerType]=\"'basic'\"\r\n  [primaryLogo]=\"Spa_HeaderFooter_PrimaryClientLogo\"\r\n  [primaryLogoUrl]=\"Spa_HeaderFooter_PrimaryClientLogo_Url\"\r\n  [secondaryLogo]=\"Spa_HeaderFooter_SecondaryClientLogo\"\r\n  [secondaryLogoUrl]=\"Spa_HeaderFooter_SecondaryClientLogo_Url\"\r\n>\r\n</vnext-dynamic-header>\r\n\r\n<div *ngIf=\"agentData\" class=\"mx-auto container\">\r\n  <div class=\"col-12 text-center mt-4\">\r\n    <div\r\n      class=\"Spa_Style_H1\"\r\n      [innerHTML]=\"Spa_Site_Agent_Subscription_Success_Text | safe : 'html'\"\r\n      *liveEditProp=\"'Spa_Site_Agent_Subscription_Success_Text'\"\r\n    ></div>\r\n  </div>\r\n\r\n  <div class=\"m-4\" [innerHTML]=\"Spa_Agent_Subscription_Success_Instruction_Text | safe : 'html'\"></div>\r\n  <div class=\"mt-2 mb-4\" [innerHTML]=\"Spa_Agent_Subscription_Succuss_Instruction_Options_Text | safe : 'html'\"></div>\r\n\r\n  <div class=\"w-100 d-flex mx-3 my-5\">\r\n    <button (click)=\"navigateToLogin()\" class=\"btn Spa_Style_PrimaryButton\" triggers=\"manual\">\r\n      {{ Spa_Agent_Subscription_Login_Button_Text }}\r\n    </button>\r\n  </div>\r\n  \r\n  <div class=\"m-4\" [innerHTML]=\"Spa_Agent_Subscription_Contact_Text | safe : 'html'\"></div>\r\n</div>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.NavigationService }, { type: SubscriptionFacade }, { type: i1.EmailService }]; }, { Spa_HeaderFooter_PrimaryClientLogo: [], Spa_HeaderFooter_PrimaryClientLogo_Url: [], Spa_HeaderFooter_SecondaryClientLogo: [], Spa_HeaderFooter_SecondaryClientLogo_Url: [], Spa_Site_Agent_Subscription_Success_Text: [], Spa_Agent_Subscription_Success_Instruction_Text: [], Spa_Agent_Subscription_Succuss_Instruction_Options_Text: [], Spa_Agent_Subscription_Login_Button_Text: [], Spa_Agent_Subscription_Contact_Text: [], Spa_PlanCompareEdgeForAgents_Email_ButtonUrl: [], Spa_ContactUsModal_Email: [], Spa_PlanCompareEdgeForAgents_Email_Subject: [], Spa_PlanCompareEdgeForAgents_TemporarypPassword_Text: [], Spa_PlanCompareEdgeForAgents_AgentEmail: [], Spa_PlanCompareEdgeForAgents_AgentName: [], Spa_PlanCompareEdgeForAgents_AgencyName: [], Spa_PlanCompareEdgeForAgents_AgencyPhoneNumber: [], Spa_PlanCompareEdgeForAgentsEmail_ClosingText: [], Spa_PlanCompareEdgeForAgentsEmail_Header: [], Spa_PlanCompareEdgeForAgentsEmail_Body: [] }); })();

function SubscriptionFormComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r0.Spa_Site_Agent_Subscription_Form_Header_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function SubscriptionFormComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r1.Spa_Site_Agent_Subscription_Form_SubHeader_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function SubscriptionFormComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-notice", 10);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("messages", ctx_r2.errorBannerList)("type", "error");
} }
function SubscriptionFormComponent_form_7_ng_container_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 31);
    i0.ɵɵelement(2, "i", 32);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.getSubscriptionError(control_r7.keyName), " ");
} }
const _c0$1F = function (a0) { return { "error-color": a0 }; };
function SubscriptionFormComponent_form_7_ng_container_2_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 33);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const control_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("id", control_r7.keyName + "LabelId")("ngClass", i0.ɵɵpureFunction1(2, _c0$1F, !control_r7.disabled));
} }
const _c1$N = function (a0, a1, a2) { return { "has-error": a0, "Spa_Style_Gray4_Color readonly": a1, "error-field": a2 }; };
function SubscriptionFormComponent_form_7_ng_container_2_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "input", 34);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(7, _c1$N, (ctx_r10.agentInfoFormGroup.controls[control_r7.keyName] == null ? null : ctx_r10.agentInfoFormGroup.controls[control_r7.keyName].errors) && ctx_r10.submitted && ((ctx_r10.agentInfoFormGroup.controls[control_r7.keyName] == null ? null : ctx_r10.agentInfoFormGroup.controls[control_r7.keyName].touched) || (ctx_r10.agentInfoFormGroup.controls[control_r7.keyName] == null ? null : ctx_r10.agentInfoFormGroup.controls[control_r7.keyName].dirty)), control_r7.disabled, ctx_r10.submitted && (control_r7.keyName === ctx_r10.subscriptionFormInputs.AGENT_NPN && !ctx_r10.isValidNPN || control_r7.keyName === ctx_r10.subscriptionFormInputs.AGENT_EMAIL && !ctx_r10.isValidEmail)))("ngClass", control_r7.class)("formControlName", control_r7.keyName)("readonly", control_r7.disabled)("mask", control_r7.keyName === ctx_r10.subscriptionFormInputs.AGENT_PHONE ? ctx_r10.phoneMask : "")("validation", true);
    i0.ɵɵattribute("aria-labelledby", control_r7.keyName + "LabelId");
} }
function SubscriptionFormComponent_form_7_ng_container_2_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-state-selector-input", 35);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("customClass", "Spa_Style_Small_Font Spa_Style_Primary_Color")("control", ctx_r11.agentInfoFormGroup.controls[control_r7.keyName])("formSubmitted", ctx_r11.submitted)("height", "36px")("isReadOnly", control_r7.disabled)("ariaLabelledById", control_r7.keyName + "LabelId");
} }
const _c2$w = function (a0, a1, a2, a3) { return { Spa_Style_Primary_Color: a0, Spa_Style_Gray4_Color: a1, Spa_Style_ErrorText: a2, Spa_Style_Accent2_Color: a3 }; };
function SubscriptionFormComponent_form_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 25)(2, "div", 26)(3, "div", 27);
    i0.ɵɵtemplate(4, SubscriptionFormComponent_form_7_ng_container_2_ng_container_4_Template, 4, 1, "ng-container", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 28)(6, "label", 29);
    i0.ɵɵtemplate(7, SubscriptionFormComponent_form_7_ng_container_2_span_7_Template, 2, 4, "span", 30);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(9, SubscriptionFormComponent_form_7_ng_container_2_ng_container_9_Template, 2, 11, "ng-container", 6);
    i0.ɵɵtemplate(10, SubscriptionFormComponent_form_7_ng_container_2_ng_container_10_Template, 2, 6, "ng-container", 6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const control_r7 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", (ctx_r5.agentInfoFormGroup.controls[control_r7.keyName] == null ? null : ctx_r5.agentInfoFormGroup.controls[control_r7.keyName].errors) && (ctx_r5.agentInfoFormGroup.controls[control_r7.keyName] == null ? null : ctx_r5.agentInfoFormGroup.controls[control_r7.keyName].enabled) && ctx_r5.submitted);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(6, _c2$w, ctx_r5.agentInfoFormGroup.controls[control_r7.keyName] == null ? null : ctx_r5.agentInfoFormGroup.controls[control_r7.keyName].enabled, control_r7.disabled, (ctx_r5.agentInfoFormGroup.controls[control_r7.keyName] == null ? null : ctx_r5.agentInfoFormGroup.controls[control_r7.keyName].errors) && ctx_r5.submitted && ((ctx_r5.agentInfoFormGroup.controls[control_r7.keyName] == null ? null : ctx_r5.agentInfoFormGroup.controls[control_r7.keyName].touched) || (ctx_r5.agentInfoFormGroup.controls[control_r7.keyName] == null ? null : ctx_r5.agentInfoFormGroup.controls[control_r7.keyName].dirty)), ctx_r5.submitted && (control_r7.keyName === ctx_r5.subscriptionFormInputs.AGENT_NPN && !ctx_r5.isValidNPN || control_r7.keyName === ctx_r5.subscriptionFormInputs.AGENT_EMAIL && !ctx_r5.isValidEmail)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.subscriptionControlIsRequired(control_r7.keyName) || ctx_r5.submitted && (ctx_r5.agentInfoFormGroup.controls[control_r7.keyName] == null ? null : ctx_r5.agentInfoFormGroup.controls[control_r7.keyName].errors));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", control_r7.labelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.getControlType(control_r7.keyName) === "input");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", control_r7.keyName === ctx_r5.subscriptionFormInputs.STATE);
} }
function SubscriptionFormComponent_form_7_vnext_link_13_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 36);
    i0.ɵɵlistener("click", function SubscriptionFormComponent_form_7_vnext_link_13_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r16.backToPrevious()); })("keyup.enter", function SubscriptionFormComponent_form_7_vnext_link_13_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r18 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r18.backToPrevious()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r6.Spa_Site_Previous)("showArrow", "left")("customClass", "Spa_Style_Link p-1")("makeInlineBlock", true)("role", ctx_r6.linkRoles.BUTTON)("ariaLabel", ctx_r6.Spa_Site_Previous);
} }
function SubscriptionFormComponent_form_7_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 11);
    i0.ɵɵlistener("ngSubmit", function SubscriptionFormComponent_form_7_Template_form_ngSubmit_0_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r19.saveAgentInfo()); });
    i0.ɵɵelementStart(1, "div", 12);
    i0.ɵɵtemplate(2, SubscriptionFormComponent_form_7_ng_container_2_Template, 11, 11, "ng-container", 13);
    i0.ɵɵelementStart(3, "div", 14)(4, "div", 15)(5, "input", 16);
    i0.ɵɵlistener("click", function SubscriptionFormComponent_form_7_Template_input_click_5_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r21 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r21.onTermsOfUseChecked($event == null ? null : $event.target == null ? null : $event.target.checked)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "label", 17)(7, "span", 18);
    i0.ɵɵtext(8, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "span", 19);
    i0.ɵɵpipe(10, "safe");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(11, "div", 20)(12, "div", 21);
    i0.ɵɵtemplate(13, SubscriptionFormComponent_form_7_vnext_link_13_Template, 1, 6, "vnext-link", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 23);
    i0.ɵɵprojection(15);
    i0.ɵɵelementStart(16, "button", 24);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r3.agentInfoFormGroup);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.agentInfoForm)("ngForTrackBy", ctx_r3.trackIndex);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(10, 7, ctx_r3.Spa_Site_Agent_Subscription_TermsOfUse_Text, "html"), i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction1(10, _c0$1F, !ctx_r3.isTermsOfUseChecked && ctx_r3.submitted));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_Previous");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r3.Spa_Agent_Subscription_Button_Text);
} }
function SubscriptionFormComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-checkout-form", 37);
    i0.ɵɵlistener("backToSubscriptionForm", function SubscriptionFormComponent_div_8_Template_vnext_checkout_form_backToSubscriptionForm_1_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r22.setShowPayment($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("productLabel", ctx_r4.Spa_Site_Agent_Subscription_Pricing_Product_Label)("productOptions", ctx_r4.Spa_Site_Agent_Subscription_product_options)("monthlyDescription", ctx_r4.Spa_Site_Agent_Subscription_Pricing_Monthly_Description)("quarterlyDescription", ctx_r4.Spa_Site_Agent_Subscription_Pricing_Quarterly_Description)("annuallyDescription", ctx_r4.Spa_Site_Agent_Subscription_Pricing_Annual_Description)("durationLabel", ctx_r4.Spa_Site_Agent_Subscription_Pricing_Duration_Label)("buttonText", ctx_r4.Spa_Site_Agent_Subscription_Pricing_Button_Label)("previousLabel", ctx_r4.Spa_Site_Previous)("isPublishableKeyLiveEnabled", ctx_r4.Spa_Site_Agent_Subscription_Publishable_Key_Live_Enabled);
} }
const _c3$l = [[["", "previous-link", ""]]];
const _c4$c = ["[previous-link]"];
let SubscriptionFormComponent = class SubscriptionFormComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, subscriptionFacade, spinnerService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.subscriptionFacade = subscriptionFacade;
        this.spinnerService = spinnerService;
        this.Spa_HeaderFooter_PrimaryClientLogo = '';
        this.Spa_HeaderFooter_PrimaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_HeaderFooter_SecondaryClientLogo = '';
        this.Spa_HeaderFooter_SecondaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_Site_Agent_Subscription_Form_Header_Text = 'PC Edge for Agents Subscription Form';
        this.Spa_Site_Agent_Subscription_Form_SubHeader_Text = 'PC Edge for Agents Subscription Form';
        this.Spa_Site_Previous = 'Previous';
        this.Spa_Agent_Subscription_Form = [];
        this.Spa_Agent_Subscription_Button_Text = 'Continue to payment';
        this.AgentLogin_LoginDomain = 'PCEdgeAgent_QA';
        this.Spa_Site_Agent_Subscription_Npn_Error_Text = 'We are unable to validate your NPN. Please check your number and try again.';
        this.Spa_Site_Agent_Subscription_Email_Error_Text = 'Email already exists. Please enter a different email address.';
        this.Spa_Site_Agent_Subscription_Pricing_Product_Label = 'PlanCompare Edge for Agents';
        this.Spa_Site_Agent_Subscription_Pricing_Monthly_Description = '';
        this.Spa_Site_Agent_Subscription_Pricing_Quarterly_Description = '';
        this.Spa_Site_Agent_Subscription_Pricing_Annual_Description = '';
        this.Spa_Site_Agent_Subscription_Pricing_Duration_Label = 'every <duration>';
        this.Spa_Site_Agent_Subscription_Pricing_Button_Label = 'Subscribe';
        this.Spa_Site_Agent_Subscription_TermsOfUse_Error_Text = 'Please review and check the terms of use checkbox.';
        this.Spa_Site_Agent_Subscription_TermsOfUse_Text = 'I acknowledge that I have read, understand, and agree to the <a href="https://www.connecture.com/" target="_blank">Terms of Use</a>';
        this.Spa_Site_Agent_Subscription_Publishable_Key_Live_Enabled = false;
        this.Spa_Site_Agent_Subscription_product_options = [
            {
                productLabel: 'PlanCompare Edge for Agent',
                description: '',
                price: 1128.0,
                durationType: 'Annual',
                durationLabel: 'every month',
                currency: 'USD',
                pricingId: 'price_1Pn11Y064exJIVkzDBJnDCJp'
            },
            {
                productLabel: 'PlanCompare Edge for Agent',
                description: '',
                price: 291.0,
                durationType: 'quarterly',
                durationLabel: 'every 3 month',
                currency: 'USD',
                pricingId: 'price_1Pn0yW064exJIVkzTwDRdqkI'
            },
            {
                productLabel: 'PlanCompare Edge for Agent',
                description: '',
                price: 100.0,
                durationType: 'monthly',
                durationLabel: 'every year',
                currency: 'USD',
                pricingId: 'price_1PpsnZ064exJIVkzl1yYron4'
            }
        ];
        this.submitted = false;
        this.showPayment = false;
        this.isValidEmail = true;
        this.isValidNPN = true;
        this.errorBannerList = [];
        this.isTermsOfUseChecked = false;
        this.subscriptionFormInputs = SubscriptionFormInputs;
        this.phoneMask = FormValidationService.phoneMask;
        this.linkRoles = LinkRoles;
    }
    preProcessProperties() {
        this.agentInfoForm = this.Spa_Agent_Subscription_Form;
        this.agentInfoFormGroup = this.subscriptionFacade.getSubscriptionFormGroup();
    }
    ngOnInit() {
        super.ngOnInit();
        const subscriptionFormData = this.subscriptionFacade.getAgentSubscriptionInfo();
        if (subscriptionFormData) {
            this.agentInfoFormGroup?.controls[SubscriptionFormInputs.AGENT_FIRST_NAME]?.setValue(subscriptionFormData['firstName']);
            this.agentInfoFormGroup?.controls[SubscriptionFormInputs.AGENT_LAST_NAME]?.setValue(subscriptionFormData['lastName']);
            this.agentInfoFormGroup?.controls[SubscriptionFormInputs.AGENT_EMAIL]?.setValue(subscriptionFormData['emailAddress']);
            this.agentInfoFormGroup?.controls[SubscriptionFormInputs.AGENT_PHONE]?.setValue(subscriptionFormData['phoneNumber']);
            this.agentInfoFormGroup?.controls[SubscriptionFormInputs.AGENT_NPN]?.setValue(subscriptionFormData['npn']);
            this.agentInfoFormGroup?.controls[SubscriptionFormInputs.AGENT_ADDRESS1]?.setValue(subscriptionFormData['address1']);
            this.agentInfoFormGroup?.controls[SubscriptionFormInputs.CITY]?.setValue(subscriptionFormData['city']);
            this.agentInfoFormGroup?.controls[SubscriptionFormInputs.STATE]?.setValue(subscriptionFormData['state']);
            this.agentInfoFormGroup?.controls[SubscriptionFormInputs.ZIP]?.setValue(subscriptionFormData['zip']);
            this.agentInfoFormGroup?.controls[SubscriptionFormInputs.LICENSE_NUMBER]?.setValue(subscriptionFormData['licenses']?.[0]?.['license']);
        }
    }
    subscriptionControlIsRequired(controlName) {
        const control = this.getSubscriptionFormControl(controlName);
        if (!control.validator) {
            return false;
        }
        const validator = control.validator({});
        return validator?.required;
    }
    trackIndex(index) {
        return index;
    }
    getSubscriptionError(controlName) {
        return this.subscriptionFacade.getSubscriptionErrorMessage(controlName);
    }
    saveAgentInfo() {
        this.submitted = true;
        if (this.agentInfoFormGroup.valid) {
            if (!this.isTermsOfUseChecked) {
                this.errorBannerList = [{ message: this.Spa_Site_Agent_Subscription_TermsOfUse_Error_Text }];
            }
            else {
                this.validateAgentDetails(this.agentInfoFormGroup.value);
            }
        }
    }
    onTermsOfUseChecked(isChecked) {
        this.isTermsOfUseChecked = isChecked;
        if (isChecked) {
            this.errorBannerList = this.errorBannerList.filter(item => item.message !== this.Spa_Site_Agent_Subscription_TermsOfUse_Error_Text);
        }
    }
    backToPrevious() {
        this.configurableWidgetService.navigationService.backToPrevious();
    }
    getControlType(controlName) {
        return controlName === SubscriptionFormInputs.STATE ? InputControlType$1.DROPDOWN : InputControlType$1.INPUT;
    }
    getSubscriptionFormControl(controlName) {
        return this.agentInfoFormGroup.get(controlName);
    }
    setShowPayment($event) {
        this.showPayment = $event.showPayment;
        this.isTermsOfUseChecked = false;
        this.cdr.markForCheck();
    }
    validateAgentDetails(agentInfoFormGroup) {
        const agentInfo = {
            clientID: this.AgentLogin_LoginDomain,
            firstName: agentInfoFormGroup[SubscriptionFormInputs.AGENT_FIRST_NAME],
            lastName: agentInfoFormGroup[SubscriptionFormInputs.AGENT_LAST_NAME],
            emailAddress: agentInfoFormGroup[SubscriptionFormInputs.AGENT_EMAIL],
            phoneNumber: agentInfoFormGroup[SubscriptionFormInputs.AGENT_PHONE],
            address1: agentInfoFormGroup[SubscriptionFormInputs.AGENT_ADDRESS1],
            city: agentInfoFormGroup[SubscriptionFormInputs.CITY],
            zip: agentInfoFormGroup[SubscriptionFormInputs.ZIP],
            state: agentInfoFormGroup[SubscriptionFormInputs.STATE],
            npn: agentInfoFormGroup[SubscriptionFormInputs.AGENT_NPN],
            licenses: [{ state: 'CA', license: agentInfoFormGroup[SubscriptionFormInputs.LICENSE_NUMBER] }]
        };
        const payload = {
            NPN: agentInfoFormGroup[SubscriptionFormInputs.AGENT_NPN],
            FirstName: agentInfoFormGroup[SubscriptionFormInputs.AGENT_FIRST_NAME],
            LastName: agentInfoFormGroup[SubscriptionFormInputs.AGENT_LAST_NAME],
            EmailAddress: agentInfoFormGroup[SubscriptionFormInputs.AGENT_EMAIL]
        };
        this.errorBannerList = [];
        this.spinnerService.show(SpinnerEvent.SUBSCRIPTION_LOADING);
        this.subscriptionFacade.validateAgentDetails$(payload).subscribe({
            next: (validateAgent) => {
                this.spinnerService.hide(SpinnerEvent.SUBSCRIPTION_LOADING);
                if (validateAgent?.data?.isValidNPN && validateAgent?.data?.isValidEmail) {
                    this.showPayment = !this.showPayment;
                    this.subscriptionFacade.setAgentSubscriptionInfo(agentInfo);
                    this.cdr.markForCheck();
                }
                else {
                    if (!validateAgent?.data?.isValidNPN) {
                        this.errorBannerList.push({ message: this.Spa_Site_Agent_Subscription_Npn_Error_Text });
                    }
                    if (!validateAgent?.data?.isValidEmail) {
                        this.errorBannerList.push({ message: this.Spa_Site_Agent_Subscription_Email_Error_Text });
                    }
                }
                this.isValidEmail = validateAgent?.data?.isValidEmail || false;
                this.isValidNPN = validateAgent?.data?.isValidNPN || false;
                this.cdr.markForCheck();
            },
            error: () => {
                this.spinnerService.hide(SpinnerEvent.SUBSCRIPTION_LOADING);
            }
        });
    }
};
SubscriptionFormComponent.ɵfac = function SubscriptionFormComponent_Factory(t) { return new (t || SubscriptionFormComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(SubscriptionFacade), i0.ɵɵdirectiveInject(i1.SpinnerService)); };
SubscriptionFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SubscriptionFormComponent, selectors: [["vnext-subscription-form"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c4$c, decls: 9, vars: 10, consts: [[3, "headerType", "primaryLogo", "primaryLogoUrl", "secondaryLogo", "secondaryLogoUrl"], [1, "mx-auto", "container"], [1, "col-12", "text-center", "mt-4"], ["class", "Spa_Style_H1", 3, "innerHTML", 4, "liveEditProp"], ["class", "Spa_Style_H2 mt-3", 3, "innerHTML", 4, "liveEditProp"], [1, "col-12"], [4, "ngIf"], ["class", "row pb-4 align-items-end", 3, "formGroup", "ngSubmit", 4, "ngIf"], [1, "Spa_Style_H1", 3, "innerHTML"], [1, "Spa_Style_H2", "mt-3", 3, "innerHTML"], [3, "messages", "type"], [1, "row", "pb-4", "align-items-end", 3, "formGroup", "ngSubmit"], [1, "row"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "w-100", "mx-3", "my-5"], [1, "d-flex", "align-items-center"], ["id", "termsOfUseCheckbox", "type", "checkbox", 3, "click"], [1, "pt-2", "Spa_Style_Bold_Weight"], [1, "mx-2", "error-color"], ["for", "termsOfUseCheckbox", 1, "Spa_Style_Small_Font", 3, "innerHTML", "ngClass"], [1, "w-100", "d-flex", "align-items-center", "mx-3", "my-5"], ["previous-link", ""], [3, "title", "showArrow", "customClass", "makeInlineBlock", "role", "ariaLabel", "click", "keyup.enter", 4, "liveEditProp"], [1, "ml-auto"], ["type", "submit", "triggers", "manual", 1, "btn", "Spa_Style_PrimaryButton"], [1, "col-lg-3", "col-md-6", "col-12"], [1, "w-100", "d-flex", "flex-column"], [1, "error-container", "pt-2"], [1, "label-wrapper"], [1, "Spa_Style_Small_Font", "Spa_Style_Bold_Weight", 3, "ngClass"], ["class", "input-asterisk", 3, "id", "ngClass", 4, "ngIf"], [1, "Spa_Style_ErrorText", "align-bottom"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], [1, "input-asterisk", 3, "id", "ngClass"], ["tabindex", "0", 1, "Spa_Style_Small_Font", "Spa_Style_Primary_Color", "form-control", 3, "ngClass", "formControlName", "readonly", "mask", "validation"], [3, "customClass", "control", "formSubmitted", "height", "isReadOnly", "ariaLabelledById"], [3, "title", "showArrow", "customClass", "makeInlineBlock", "role", "ariaLabel", "click", "keyup.enter"], [3, "productLabel", "productOptions", "monthlyDescription", "quarterlyDescription", "annuallyDescription", "durationLabel", "buttonText", "previousLabel", "isPublishableKeyLiveEnabled", "backToSubscriptionForm"]], template: function SubscriptionFormComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c3$l);
        i0.ɵɵelement(0, "vnext-dynamic-header", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, SubscriptionFormComponent_div_3_Template, 2, 4, "div", 3);
        i0.ɵɵtemplate(4, SubscriptionFormComponent_div_4_Template, 2, 4, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵtemplate(6, SubscriptionFormComponent_ng_container_6_Template, 2, 2, "ng-container", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, SubscriptionFormComponent_form_7_Template, 18, 12, "form", 7);
        i0.ɵɵtemplate(8, SubscriptionFormComponent_div_8_Template, 2, 9, "div", 6);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("headerType", "basic")("primaryLogo", ctx.Spa_HeaderFooter_PrimaryClientLogo)("primaryLogoUrl", ctx.Spa_HeaderFooter_PrimaryClientLogo_Url)("secondaryLogo", ctx.Spa_HeaderFooter_SecondaryClientLogo)("secondaryLogoUrl", ctx.Spa_HeaderFooter_SecondaryClientLogo_Url);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_Agent_Subscription_Form_Header_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_Agent_Subscription_Form_SubHeader_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.submitted && (ctx.errorBannerList == null ? null : ctx.errorBannerList.length));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.showPayment && ctx.agentInfoFormGroup);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showPayment);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, LinkComponent, StateSelectorInputComponent, NoticeComponent, LiveEditPropDirective, IconAriaAttributesDirective, i8.MaskDirective, DynamicHeaderComponent, CheckOutFormComponent, SafePipe], styles: ["input.form-control[_ngcontent-%COMP%], button.btn[_ngcontent-%COMP%]{height:36px}form[_ngcontent-%COMP%]{min-height:200px;border-radius:5px;padding:0 18px}.label-wrapper[_ngcontent-%COMP%]{min-height:50px;display:flex;align-items:flex-end}.error-field[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent2)}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], SubscriptionFormComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo", void 0);
__decorate([
    GlobalResource()
], SubscriptionFormComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo_Url", void 0);
__decorate([
    GlobalResource()
], SubscriptionFormComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo", void 0);
__decorate([
    GlobalResource()
], SubscriptionFormComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo_Url", void 0);
__decorate([
    PlatformProp('live-edit')
], SubscriptionFormComponent.prototype, "Spa_Site_Agent_Subscription_Form_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], SubscriptionFormComponent.prototype, "Spa_Site_Agent_Subscription_Form_SubHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], SubscriptionFormComponent.prototype, "Spa_Site_Previous", void 0);
__decorate([
    GlobalResource(true)
], SubscriptionFormComponent.prototype, "Spa_Agent_Subscription_Form", void 0);
__decorate([
    GlobalResource()
], SubscriptionFormComponent.prototype, "Spa_Agent_Subscription_Button_Text", void 0);
__decorate([
    GlobalResource()
], SubscriptionFormComponent.prototype, "AgentLogin_LoginDomain", void 0);
__decorate([
    GlobalResource()
], SubscriptionFormComponent.prototype, "Spa_Site_Agent_Subscription_Npn_Error_Text", void 0);
__decorate([
    GlobalResource()
], SubscriptionFormComponent.prototype, "Spa_Site_Agent_Subscription_Email_Error_Text", void 0);
__decorate([
    GlobalResource()
], SubscriptionFormComponent.prototype, "Spa_Site_Agent_Subscription_Pricing_Product_Label", void 0);
__decorate([
    GlobalResource()
], SubscriptionFormComponent.prototype, "Spa_Site_Agent_Subscription_Pricing_Monthly_Description", void 0);
__decorate([
    GlobalResource()
], SubscriptionFormComponent.prototype, "Spa_Site_Agent_Subscription_Pricing_Quarterly_Description", void 0);
__decorate([
    GlobalResource()
], SubscriptionFormComponent.prototype, "Spa_Site_Agent_Subscription_Pricing_Annual_Description", void 0);
__decorate([
    GlobalResource()
], SubscriptionFormComponent.prototype, "Spa_Site_Agent_Subscription_Pricing_Duration_Label", void 0);
__decorate([
    GlobalResource()
], SubscriptionFormComponent.prototype, "Spa_Site_Agent_Subscription_Pricing_Button_Label", void 0);
__decorate([
    GlobalResource()
], SubscriptionFormComponent.prototype, "Spa_Site_Agent_Subscription_TermsOfUse_Error_Text", void 0);
__decorate([
    GlobalResource()
], SubscriptionFormComponent.prototype, "Spa_Site_Agent_Subscription_TermsOfUse_Text", void 0);
__decorate([
    GlobalResource()
], SubscriptionFormComponent.prototype, "Spa_Site_Agent_Subscription_Publishable_Key_Live_Enabled", void 0);
__decorate([
    GlobalResource()
], SubscriptionFormComponent.prototype, "Spa_Site_Agent_Subscription_product_options", void 0);
SubscriptionFormComponent = __decorate([
    PlatformWidget
], SubscriptionFormComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SubscriptionFormComponent, [{
        type: Component,
        args: [{ selector: 'vnext-subscription-form', providers: [WidgetService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-dynamic-header\r\n  [headerType]=\"'basic'\"\r\n  [primaryLogo]=\"Spa_HeaderFooter_PrimaryClientLogo\"\r\n  [primaryLogoUrl]=\"Spa_HeaderFooter_PrimaryClientLogo_Url\"\r\n  [secondaryLogo]=\"Spa_HeaderFooter_SecondaryClientLogo\"\r\n  [secondaryLogoUrl]=\"Spa_HeaderFooter_SecondaryClientLogo_Url\"\r\n>\r\n</vnext-dynamic-header>\r\n\r\n<div class=\"mx-auto container\">\r\n  <div class=\"col-12 text-center mt-4\">\r\n    <div\r\n      class=\"Spa_Style_H1\"\r\n      [innerHTML]=\"Spa_Site_Agent_Subscription_Form_Header_Text | safe : 'html'\"\r\n      *liveEditProp=\"'Spa_Site_Agent_Subscription_Form_Header_Text'\"\r\n    ></div>\r\n    <div\r\n      class=\"Spa_Style_H2 mt-3\"\r\n      [innerHTML]=\"Spa_Site_Agent_Subscription_Form_SubHeader_Text | safe : 'html'\"\r\n      *liveEditProp=\"'Spa_Site_Agent_Subscription_Form_SubHeader_Text'\"\r\n    ></div>\r\n  </div>\r\n\r\n  <div class=\"col-12\">\r\n    <ng-container *ngIf=\"submitted && errorBannerList?.length\">\r\n      <vnext-notice [messages]=\"errorBannerList\" [type]=\"'error'\"></vnext-notice>\r\n    </ng-container>\r\n  </div>\r\n  <form\r\n    *ngIf=\"!showPayment && agentInfoFormGroup\"\r\n    class=\"row pb-4 align-items-end\"\r\n    [formGroup]=\"agentInfoFormGroup\"\r\n    (ngSubmit)=\"saveAgentInfo()\"\r\n  >\r\n    <div class=\"row\">\r\n      <ng-container *ngFor=\"let control of agentInfoForm; trackBy: trackIndex\">\r\n        <div class=\"col-lg-3 col-md-6 col-12\">\r\n          <div class=\"w-100 d-flex flex-column\">\r\n            <div class=\"error-container pt-2\">\r\n              <ng-container\r\n                *ngIf=\"\r\n                  agentInfoFormGroup.controls[control.keyName]?.errors && agentInfoFormGroup.controls[control.keyName]?.enabled && submitted\r\n                \"\r\n              >\r\n                <span class=\"Spa_Style_ErrorText align-bottom\">\r\n                  <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n                  {{ getSubscriptionError(control.keyName) }}\r\n                </span>\r\n              </ng-container>\r\n            </div>\r\n            <div class=\"label-wrapper\">\r\n              <label\r\n                class=\"Spa_Style_Small_Font Spa_Style_Bold_Weight\"\r\n                [ngClass]=\"{\r\n                  Spa_Style_Primary_Color: agentInfoFormGroup.controls[control.keyName]?.enabled,\r\n                  Spa_Style_Gray4_Color: control.disabled,\r\n                  Spa_Style_ErrorText:\r\n                    agentInfoFormGroup.controls[control.keyName]?.errors &&\r\n                    submitted &&\r\n                    (agentInfoFormGroup.controls[control.keyName]?.touched || agentInfoFormGroup.controls[control.keyName]?.dirty),\r\n                  Spa_Style_Accent2_Color:\r\n                    submitted &&\r\n                    ((control.keyName === subscriptionFormInputs.AGENT_NPN && !isValidNPN) ||\r\n                      (control.keyName === subscriptionFormInputs.AGENT_EMAIL && !isValidEmail))\r\n                }\"\r\n              >\r\n                <span\r\n                  *ngIf=\"\r\n                    subscriptionControlIsRequired(control.keyName) || (submitted && agentInfoFormGroup.controls[control.keyName]?.errors)\r\n                  \"\r\n                  class=\"input-asterisk\"\r\n                  [id]=\"control.keyName + 'LabelId'\"\r\n                  [ngClass]=\"{ 'error-color': !control.disabled }\"\r\n                  >*</span\r\n                >{{ control.labelText }}\r\n              </label>\r\n            </div>\r\n            <ng-container *ngIf=\"getControlType(control.keyName) === 'input'\">\r\n              <input\r\n                class=\"Spa_Style_Small_Font Spa_Style_Primary_Color form-control\"\r\n                tabindex=\"0\"\r\n                [attr.aria-labelledby]=\"control.keyName + 'LabelId'\"\r\n                [ngClass]=\"{\r\n                  'has-error':\r\n                    agentInfoFormGroup.controls[control.keyName]?.errors &&\r\n                    submitted &&\r\n                    (agentInfoFormGroup.controls[control.keyName]?.touched || agentInfoFormGroup.controls[control.keyName]?.dirty),\r\n                  'Spa_Style_Gray4_Color readonly': control.disabled,\r\n                  'error-field':\r\n                    submitted &&\r\n                    ((control.keyName === subscriptionFormInputs.AGENT_NPN && !isValidNPN) ||\r\n                      (control.keyName === subscriptionFormInputs.AGENT_EMAIL && !isValidEmail))\r\n                }\"\r\n                [ngClass]=\"control.class\"\r\n                [formControlName]=\"control.keyName\"\r\n                [readonly]=\"control.disabled\"\r\n                [mask]=\"control.keyName === subscriptionFormInputs.AGENT_PHONE ? phoneMask : ''\"\r\n                [validation]=\"true\"\r\n              />\r\n            </ng-container>\r\n            <ng-container *ngIf=\"control.keyName === subscriptionFormInputs.STATE\">\r\n              <vnext-state-selector-input\r\n                [customClass]=\"'Spa_Style_Small_Font Spa_Style_Primary_Color'\"\r\n                [control]=\"agentInfoFormGroup.controls[control.keyName]\"\r\n                [formSubmitted]=\"submitted\"\r\n                [height]=\"'36px'\"\r\n                [isReadOnly]=\"control.disabled\"\r\n                [ariaLabelledById]=\"control.keyName + 'LabelId'\"\r\n              >\r\n              </vnext-state-selector-input>\r\n            </ng-container>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n      <div class=\"w-100 mx-3 my-5\">\r\n        <div class=\"d-flex align-items-center\">\r\n          <input id=\"termsOfUseCheckbox\" type=\"checkbox\" (click)=\"onTermsOfUseChecked($event?.target?.checked)\" />\r\n          <label class=\"pt-2 Spa_Style_Bold_Weight\"\r\n            ><span class=\"mx-2 error-color\">*</span>\r\n            <span\r\n              for=\"termsOfUseCheckbox\"\r\n              class=\"Spa_Style_Small_Font\"\r\n              [innerHTML]=\"Spa_Site_Agent_Subscription_TermsOfUse_Text | safe : 'html'\"\r\n              [ngClass]=\"{ 'error-color': !isTermsOfUseChecked && submitted }\"\r\n            ></span>\r\n          </label>\r\n        </div>\r\n      </div>\r\n      <div class=\"w-100 d-flex align-items-center mx-3 my-5\">\r\n        <div previous-link>\r\n          <vnext-link\r\n            [title]=\"Spa_Site_Previous\"\r\n            [showArrow]=\"'left'\"\r\n            (click)=\"backToPrevious()\"\r\n            [customClass]=\"'Spa_Style_Link p-1'\"\r\n            (keyup.enter)=\"backToPrevious()\"\r\n            [makeInlineBlock]=\"true\"\r\n            [role]=\"linkRoles.BUTTON\"\r\n            [ariaLabel]=\"Spa_Site_Previous\"\r\n            *liveEditProp=\"'Spa_Site_Previous'\"\r\n          >\r\n          </vnext-link>\r\n        </div>\r\n        <div class=\"ml-auto\">\r\n          <ng-content select=\"[previous-link]\"></ng-content>\r\n          <button type=\"submit\" class=\"btn Spa_Style_PrimaryButton\" triggers=\"manual\">{{ Spa_Agent_Subscription_Button_Text }}</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </form>\r\n\r\n  <div *ngIf=\"showPayment\">\r\n    <vnext-checkout-form\r\n      [productLabel]=\"Spa_Site_Agent_Subscription_Pricing_Product_Label\"\r\n      [productOptions]=\"Spa_Site_Agent_Subscription_product_options\"\r\n      [monthlyDescription]=\"Spa_Site_Agent_Subscription_Pricing_Monthly_Description\"\r\n      [quarterlyDescription]=\"Spa_Site_Agent_Subscription_Pricing_Quarterly_Description\"\r\n      [annuallyDescription]=\"Spa_Site_Agent_Subscription_Pricing_Annual_Description\"\r\n      [durationLabel]=\"Spa_Site_Agent_Subscription_Pricing_Duration_Label\"\r\n      [buttonText]=\"Spa_Site_Agent_Subscription_Pricing_Button_Label\"\r\n      [previousLabel]=\"Spa_Site_Previous\"\r\n      [isPublishableKeyLiveEnabled]=\"Spa_Site_Agent_Subscription_Publishable_Key_Live_Enabled\"\r\n      (backToSubscriptionForm)=\"setShowPayment($event)\"\r\n    ></vnext-checkout-form>\r\n  </div>\r\n</div>\r\n", styles: ["input.form-control,button.btn{height:36px}form{min-height:200px;border-radius:5px;padding:0 18px}.label-wrapper{min-height:50px;display:flex;align-items:flex-end}.error-field{border-color:var(--static-Spa_Style_Accent2)}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: SubscriptionFacade }, { type: i1.SpinnerService }]; }, { Spa_HeaderFooter_PrimaryClientLogo: [], Spa_HeaderFooter_PrimaryClientLogo_Url: [], Spa_HeaderFooter_SecondaryClientLogo: [], Spa_HeaderFooter_SecondaryClientLogo_Url: [], Spa_Site_Agent_Subscription_Form_Header_Text: [], Spa_Site_Agent_Subscription_Form_SubHeader_Text: [], Spa_Site_Previous: [], Spa_Agent_Subscription_Form: [], Spa_Agent_Subscription_Button_Text: [], AgentLogin_LoginDomain: [], Spa_Site_Agent_Subscription_Npn_Error_Text: [], Spa_Site_Agent_Subscription_Email_Error_Text: [], Spa_Site_Agent_Subscription_Pricing_Product_Label: [], Spa_Site_Agent_Subscription_Pricing_Monthly_Description: [], Spa_Site_Agent_Subscription_Pricing_Quarterly_Description: [], Spa_Site_Agent_Subscription_Pricing_Annual_Description: [], Spa_Site_Agent_Subscription_Pricing_Duration_Label: [], Spa_Site_Agent_Subscription_Pricing_Button_Label: [], Spa_Site_Agent_Subscription_TermsOfUse_Error_Text: [], Spa_Site_Agent_Subscription_TermsOfUse_Text: [], Spa_Site_Agent_Subscription_Publishable_Key_Live_Enabled: [], Spa_Site_Agent_Subscription_product_options: [] }); })();

function MedicareBlockTextComponent_div_0_h2_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h2", 7);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r1.Spa_Medicare_Block_Title, "html"), i0.ɵɵsanitizeHtml);
} }
function MedicareBlockTextComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r2.Spa_Medicare_Block_SubTitle, "html"), i0.ɵɵsanitizeHtml);
} }
function MedicareBlockTextComponent_div_0_ng_container_5_h3_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h3", 12);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const textBlock_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, textBlock_r4.medicareHeaderSection, "html"), i0.ɵɵsanitizeHtml);
} }
function MedicareBlockTextComponent_div_0_ng_container_5_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 13);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const textBlock_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, textBlock_r4.medicareBodySection, "html"), i0.ɵɵsanitizeHtml);
} }
function MedicareBlockTextComponent_div_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵtemplate(2, MedicareBlockTextComponent_div_0_ng_container_5_h3_2_Template, 2, 4, "h3", 10);
    i0.ɵɵtemplate(3, MedicareBlockTextComponent_div_0_ng_container_5_div_3_Template, 2, 4, "div", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const textBlock_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", textBlock_r4.headerPropName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", textBlock_r4.bodyPropName);
} }
function MedicareBlockTextComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtemplate(2, MedicareBlockTextComponent_div_0_h2_2_Template, 2, 4, "h2", 3);
    i0.ɵɵtemplate(3, MedicareBlockTextComponent_div_0_div_3_Template, 2, 4, "div", 4);
    i0.ɵɵelementStart(4, "div", 5);
    i0.ɵɵtemplate(5, MedicareBlockTextComponent_div_0_ng_container_5_Template, 4, 2, "ng-container", 6);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Medicare_Block_Title");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Medicare_Block_SubTitle");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.medicareTextBlocks);
} }
class MedicareTextBlock {
}
let MedicareBlockTextComponent = class MedicareBlockTextComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, configResourceService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.configResourceService = configResourceService;
        // define configurable properties with defaults
        this.Spa_Medicare_Block_Show = true;
        this.Spa_Medicare_Block_Title = 'Medicare Coverage Types 101';
        this.Spa_Medicare_Block_SubTitle = "There are several types of Medicare coverage. We'll help you towards the best match plan for your needs";
        this.Spa_Medicare_Block_Section1_Header = 'Medicare Advantage (Part C)';
        this.Spa_Medicare_Block_Section1_Text = 'Medicare Advantage (Part C) plans replace your Part A and Part B Medicare coverage. Your benefits would include medical expenses, but not prescriptions.';
        this.Spa_Medicare_Block_Section2_Header = 'Prescription Drug (Part D)';
        this.Spa_Medicare_Block_Section2_Text = 'Prescription Drug plans cover your prescription needs, but offer no medical coverage.';
        this.Spa_Medicare_Block_Section3_Header = 'Medicare Advantage Prescription Drug (C + D)';
        this.Spa_Medicare_Block_Section3_Text = 'Medicare Advantage and Drug plans bundle the benefits of a Medicare Advantage plan with a Prescription Drug plan. Your coverage would include medical expenses and prescriptions.';
        this.Spa_Medicare_Block_Section4_Header = 'Medicare Supplement';
        this.Spa_Medicare_Block_Section4_Text = 'Medicare Supplement plans cover gaps in Original Medicare. You may choose to also enroll in a Prescription Drug plan.';
        this.Spa_Medicare_BG_Color = '#2c374a';
        this.Spa_Medicare_FontColor = '#fff';
        this.medicareTextBlocks = [];
        this.preProcess = () => {
            this.medicareTextBlocks = [
                {
                    medicareHeaderSection: this.Spa_Medicare_Block_Section1_Header,
                    medicareBodySection: this.Spa_Medicare_Block_Section1_Text,
                    headerPropName: 'Spa_Medicare_Block_Section1_Header',
                    bodyPropName: 'Spa_Medicare_Block_Section1_Text'
                },
                {
                    medicareHeaderSection: this.Spa_Medicare_Block_Section2_Header,
                    medicareBodySection: this.Spa_Medicare_Block_Section2_Text,
                    headerPropName: 'Spa_Medicare_Block_Section2_Header',
                    bodyPropName: 'Spa_Medicare_Block_Section2_Text'
                },
                {
                    medicareHeaderSection: this.Spa_Medicare_Block_Section3_Header,
                    medicareBodySection: this.Spa_Medicare_Block_Section3_Text,
                    headerPropName: 'Spa_Medicare_Block_Section3_Header',
                    bodyPropName: 'Spa_Medicare_Block_Section3_Text'
                },
                {
                    medicareHeaderSection: this.Spa_Medicare_Block_Section4_Header,
                    medicareBodySection: this.Spa_Medicare_Block_Section4_Text,
                    headerPropName: 'Spa_Medicare_Block_Section4_Header',
                    bodyPropName: 'Spa_Medicare_Block_Section4_Text'
                }
            ].filter(block => !this.isNullOrEmpty(block.medicareHeaderSection) && !this.isNullOrEmpty(block.medicareBodySection));
        };
    }
    // returns true if string is null, undefined, or contains only whitespace
    isNullOrEmpty(someString) {
        if (EnvironmentService.getEnvironment().liveedit) {
            return false;
        }
        return !(someString && someString.trim().length > 0);
    }
};
MedicareBlockTextComponent.ɵfac = function MedicareBlockTextComponent_Factory(t) { return new (t || MedicareBlockTextComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.ConfigResourceService)); };
MedicareBlockTextComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedicareBlockTextComponent, selectors: [["vnext-medicare-block-text"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "medicare-block Spa_Style_Accent6_Background", 4, "ngIf"], [1, "medicare-block", "Spa_Style_Accent6_Background"], [1, "container", "medicare-text-blocks"], ["class", "Spa_Style_H2_Light text-center", "navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], ["class", "medicare-subtitle Spa_Style_IntroParagraph_Light", "navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], [1, "d-flex", "flex-column", "flex-md-row", "justify-content-md-center"], [4, "ngFor", "ngForOf"], ["navigationAdapter", "", 1, "Spa_Style_H2_Light", "text-center", 3, "innerHTML"], ["navigationAdapter", "", 1, "medicare-subtitle", "Spa_Style_IntroParagraph_Light", 3, "innerHTML"], [1, "medicare-text"], ["class", "Spa_Style_H4_Light medicare-title", "navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], ["class", "coverage-text Spa_Style_Paragraph_Light", "navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], ["navigationAdapter", "", 1, "Spa_Style_H4_Light", "medicare-title", 3, "innerHTML"], ["navigationAdapter", "", 1, "coverage-text", "Spa_Style_Paragraph_Light", 3, "innerHTML"]], template: function MedicareBlockTextComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MedicareBlockTextComponent_div_0_Template, 6, 3, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.Spa_Medicare_Block_Show);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, NavigationAdapterDirective, LiveEditPropDirective, SafePipe], styles: [".medicare-subtitle[_ngcontent-%COMP%]{text-align:center;margin-bottom:40px}.medicare-text[_ngcontent-%COMP%]{padding-left:10px;padding-right:10px;flex:1 1 0}.medicare-title[_ngcontent-%COMP%]{min-height:55px}.coverage-title[_ngcontent-%COMP%]{min-height:70px}.coverage-text[_ngcontent-%COMP%]{display:block}.medicare-text-blocks[_ngcontent-%COMP%]{padding-top:82px;padding-bottom:150px}@media only screen and (max-width: 767.9px){.medicare-subtitle[_ngcontent-%COMP%]{text-align:left;margin-bottom:30px;margin-top:24px}.coverage-title[_ngcontent-%COMP%]{min-height:0;margin-bottom:7px}.coverage-text[_ngcontent-%COMP%]{margin-bottom:30px}.medicare-text[_ngcontent-%COMP%]{max-width:100%}.medicare-text-blocks[_ngcontent-%COMP%]{padding-bottom:60px;padding-top:90px}.medicare-title[_ngcontent-%COMP%]{min-height:auto;padding-bottom:14px;margin-bottom:0}}"], changeDetection: 0 });
__decorate([
    PlatformProp()
], MedicareBlockTextComponent.prototype, "Spa_Medicare_Block_Show", void 0);
__decorate([
    PlatformProp('live-edit')
], MedicareBlockTextComponent.prototype, "Spa_Medicare_Block_Title", void 0);
__decorate([
    PlatformProp('live-edit')
], MedicareBlockTextComponent.prototype, "Spa_Medicare_Block_SubTitle", void 0);
__decorate([
    PlatformProp('live-edit')
], MedicareBlockTextComponent.prototype, "Spa_Medicare_Block_Section1_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], MedicareBlockTextComponent.prototype, "Spa_Medicare_Block_Section1_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], MedicareBlockTextComponent.prototype, "Spa_Medicare_Block_Section2_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], MedicareBlockTextComponent.prototype, "Spa_Medicare_Block_Section2_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], MedicareBlockTextComponent.prototype, "Spa_Medicare_Block_Section3_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], MedicareBlockTextComponent.prototype, "Spa_Medicare_Block_Section3_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], MedicareBlockTextComponent.prototype, "Spa_Medicare_Block_Section4_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], MedicareBlockTextComponent.prototype, "Spa_Medicare_Block_Section4_Text", void 0);
__decorate([
    PlatformProp()
], MedicareBlockTextComponent.prototype, "Spa_Medicare_BG_Color", void 0);
__decorate([
    PlatformProp()
], MedicareBlockTextComponent.prototype, "Spa_Medicare_FontColor", void 0);
MedicareBlockTextComponent = __decorate([
    PlatformWidget
], MedicareBlockTextComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedicareBlockTextComponent, [{
        type: Component,
        args: [{ selector: 'vnext-medicare-block-text', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"medicare-block Spa_Style_Accent6_Background\" *ngIf=\"Spa_Medicare_Block_Show\">\r\n  <div class=\"container medicare-text-blocks\">\r\n    <h2\r\n      class=\"Spa_Style_H2_Light text-center\"\r\n      [innerHTML]=\"Spa_Medicare_Block_Title | safe : 'html'\"\r\n      *liveEditProp=\"'Spa_Medicare_Block_Title'\"\r\n      navigationAdapter\r\n    ></h2>\r\n    <div\r\n      class=\"medicare-subtitle Spa_Style_IntroParagraph_Light\"\r\n      [innerHTML]=\"Spa_Medicare_Block_SubTitle | safe : 'html'\"\r\n      *liveEditProp=\"'Spa_Medicare_Block_SubTitle'\"\r\n      navigationAdapter\r\n    ></div>\r\n    <div class=\"d-flex flex-column flex-md-row justify-content-md-center\">\r\n      <ng-container *ngFor=\"let textBlock of medicareTextBlocks\">\r\n        <div class=\"medicare-text\">\r\n          <h3\r\n            class=\"Spa_Style_H4_Light medicare-title\"\r\n            *liveEditProp=\"textBlock.headerPropName\"\r\n            [innerHTML]=\"textBlock.medicareHeaderSection | safe : 'html'\"\r\n            navigationAdapter\r\n          ></h3>\r\n          <div\r\n            class=\"coverage-text Spa_Style_Paragraph_Light\"\r\n            *liveEditProp=\"textBlock.bodyPropName\"\r\n            [innerHTML]=\"textBlock.medicareBodySection | safe : 'html'\"\r\n            navigationAdapter\r\n          ></div>\r\n        </div>\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".medicare-subtitle{text-align:center;margin-bottom:40px}.medicare-text{padding-left:10px;padding-right:10px;flex:1 1 0}.medicare-title{min-height:55px}.coverage-title{min-height:70px}.coverage-text{display:block}.medicare-text-blocks{padding-top:82px;padding-bottom:150px}@media only screen and (max-width: 767.9px){.medicare-subtitle{text-align:left;margin-bottom:30px;margin-top:24px}.coverage-title{min-height:0;margin-bottom:7px}.coverage-text{margin-bottom:30px}.medicare-text{max-width:100%}.medicare-text-blocks{padding-bottom:60px;padding-top:90px}.medicare-title{min-height:auto;padding-bottom:14px;margin-bottom:0}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.ConfigResourceService }]; }, { Spa_Medicare_Block_Show: [], Spa_Medicare_Block_Title: [], Spa_Medicare_Block_SubTitle: [], Spa_Medicare_Block_Section1_Header: [], Spa_Medicare_Block_Section1_Text: [], Spa_Medicare_Block_Section2_Header: [], Spa_Medicare_Block_Section2_Text: [], Spa_Medicare_Block_Section3_Header: [], Spa_Medicare_Block_Section3_Text: [], Spa_Medicare_Block_Section4_Header: [], Spa_Medicare_Block_Section4_Text: [], Spa_Medicare_BG_Color: [], Spa_Medicare_FontColor: [] }); })();

class MemberProfileRetentionSummaryComponent {
    constructor(navigationService) {
        this.navigationService = navigationService;
    }
    redirectToRetentionSummary() {
        this.navigationService.navigateByPageTag(PageTags.RETENTION_SUMMARY);
    }
}
MemberProfileRetentionSummaryComponent.ɵfac = function MemberProfileRetentionSummaryComponent_Factory(t) { return new (t || MemberProfileRetentionSummaryComponent)(i0.ɵɵdirectiveInject(i1.NavigationService)); };
MemberProfileRetentionSummaryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MemberProfileRetentionSummaryComponent, selectors: [["vnext-member-profile-retention-summary"]], inputs: { retentionSummaryHeaderText: "retentionSummaryHeaderText", retentionSummaryBodyText: "retentionSummaryBodyText", retentionSummaryLinkText: "retentionSummaryLinkText" }, decls: 9, vars: 3, consts: [[1, "mb-2", "px-2"], [1, "Spa_Style_H2"], [1, "Spa_Style_Paragraph"], ["tabindex", "0", 1, "Spa_Style_Link", "can-click", 3, "click", "keyup.enter"], ["aria-hidden", "true", 1, "fas", "fa-angle-right", "ml-1"]], template: function MemberProfileRetentionSummaryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "h2", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div")(4, "p", 2);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "div", 3);
        i0.ɵɵlistener("click", function MemberProfileRetentionSummaryComponent_Template_div_click_6_listener() { return ctx.redirectToRetentionSummary(); })("keyup.enter", function MemberProfileRetentionSummaryComponent_Template_div_keyup_enter_6_listener() { return ctx.redirectToRetentionSummary(); });
        i0.ɵɵtext(7);
        i0.ɵɵelement(8, "span", 4);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.retentionSummaryHeaderText);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.retentionSummaryBodyText);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.retentionSummaryLinkText, " ");
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberProfileRetentionSummaryComponent, [{
        type: Component,
        args: [{ selector: 'vnext-member-profile-retention-summary', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"mb-2 px-2\">\r\n  <h2 class=\"Spa_Style_H2\">{{ retentionSummaryHeaderText }}</h2>\r\n  <div>\r\n    <p class=\"Spa_Style_Paragraph\">{{ retentionSummaryBodyText }}</p>\r\n  </div>\r\n  <div class=\"Spa_Style_Link can-click\" tabindex=\"0\" (click)=\"redirectToRetentionSummary()\" (keyup.enter)=\"redirectToRetentionSummary()\">\r\n    {{ retentionSummaryLinkText }}\r\n    <span class=\"fas fa-angle-right ml-1\" aria-hidden=\"true\"></span>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: i1.NavigationService }]; }, { retentionSummaryHeaderText: [{
            type: Input
        }], retentionSummaryBodyText: [{
            type: Input
        }], retentionSummaryLinkText: [{
            type: Input
        }] }); })();

const _c0$1E = ["typeahead"];
const _c1$M = ["addressSearchInput"];
const _c2$v = ["accountSummaryZipInput"];
function AccountSummaryInputComponent_label_0_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 9);
    i0.ɵɵelement(2, "i", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.requiredErrorMessage, "");
} }
function AccountSummaryInputComponent_label_0_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 9);
    i0.ɵɵelement(2, "i", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.invalidErrorMessage, "");
} }
function AccountSummaryInputComponent_label_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, AccountSummaryInputComponent_label_0_div_1_ng_container_1_Template, 4, 1, "ng-container", 1);
    i0.ɵɵtemplate(2, AccountSummaryInputComponent_label_0_div_1_ng_container_2_Template, 4, 1, "ng-container", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r3.control == null ? null : ctx_r3.control.errors) && (ctx_r3.control == null ? null : ctx_r3.control.enabled) && ((ctx_r3.control == null ? null : ctx_r3.control.touched) || (ctx_r3.control == null ? null : ctx_r3.control.dirty) || ctx_r3.submitted) && !(ctx_r3.control == null ? null : ctx_r3.control.value));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r3.control == null ? null : ctx_r3.control.errors) && (ctx_r3.control == null ? null : ctx_r3.control.enabled) && ((ctx_r3.control == null ? null : ctx_r3.control.touched) || (ctx_r3.control == null ? null : ctx_r3.control.dirty) || ctx_r3.submitted) && (ctx_r3.control == null ? null : ctx_r3.control.value) && !(ctx_r3.control == null ? null : ctx_r3.control.valid));
} }
function AccountSummaryInputComponent_label_0_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
const _c3$k = function (a0, a1, a2, a3) { return { "has-error": a0, "account-summary-input-small-width": a1, "account-summary-input-medium-width": a2, "account-summary-input-large-width": a3 }; };
function AccountSummaryInputComponent_label_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "input", 12);
    i0.ɵɵlistener("blur", function AccountSummaryInputComponent_label_0_ng_container_6_Template_input_blur_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.validateControl()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(5, _c3$k, (ctx_r5.control == null ? null : ctx_r5.control.errors) && ((ctx_r5.control == null ? null : ctx_r5.control.touched) || ctx_r5.submitted), ctx_r5.isSmallInputWidth, ctx_r5.isMediumInputWidth, !ctx_r5.isSmallInputWidth && !ctx_r5.isMediumInputWidth))("formControl", ctx_r5.control)("mask", ctx_r5.inputMask)("dropSpecialCharacters", ctx_r5.personalFormInputConfig.keyName !== ctx_r5.accountOverviewInputs.CONSUMER_BIRTH_DATE)("readonly", ctx_r5.personalFormInputConfig.keyName === ctx_r5.accountOverviewInputs.CONSUMER_CELL_PHONE ? ctx_r5.disableCellPhoneInput || ctx_r5.control.disabled : ctx_r5.control.disabled);
} }
function AccountSummaryInputComponent_label_0_ng_container_7_ng_template_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r16 = i0.ɵɵnextContext().result;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", r_r16.secondary, "");
} }
function AccountSummaryInputComponent_label_0_ng_container_7_ng_template_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r16 = i0.ɵɵnextContext().result;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(", ", r_r16.zipcode, "");
} }
function AccountSummaryInputComponent_label_0_ng_container_7_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵelement(1, "ngb-highlight", 18);
    i0.ɵɵtemplate(2, AccountSummaryInputComponent_label_0_ng_container_7_ng_template_2_span_2_Template, 2, 1, "span", 1);
    i0.ɵɵtext(3);
    i0.ɵɵtemplate(4, AccountSummaryInputComponent_label_0_ng_container_7_ng_template_2_span_4_Template, 2, 1, "span", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r16 = ctx.result;
    const t_r17 = ctx.term;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("result", r_r16.street_line)("term", t_r17);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", r_r16.secondary);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", r_r16.city, " ", r_r16.state, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", r_r16.zipcode);
} }
const _c4$b = function (a0, a1) { return { "has-error": a0, "Spa_Style_Gray4_Color readonly": a1 }; };
const _c5$8 = function () { return { standalone: true }; };
function AccountSummaryInputComponent_label_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 13);
    i0.ɵɵtemplate(2, AccountSummaryInputComponent_label_0_ng_container_7_ng_template_2_Template, 5, 6, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(4, "input", 15, 16);
    i0.ɵɵlistener("ngModelChange", function AccountSummaryInputComponent_label_0_ng_container_7_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r22.addressSearchTerm = $event); })("selectItem", function AccountSummaryInputComponent_label_0_ng_container_7_Template_input_selectItem_4_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r24 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r24.selectItemForAddress($event)); })("keyup", function AccountSummaryInputComponent_label_0_ng_container_7_Template_input_keyup_4_listener() { i0.ɵɵrestoreView(_r23); const ctx_r25 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r25.scrollItemIntoView()); })("focus", function AccountSummaryInputComponent_label_0_ng_container_7_Template_input_focus_4_listener() { i0.ɵɵrestoreView(_r23); const ctx_r26 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r26.focusAddressInput()); })("blur", function AccountSummaryInputComponent_label_0_ng_container_7_Template_input_blur_4_listener() { i0.ɵɵrestoreView(_r23); const ctx_r27 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r27.validateControl()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r12 = i0.ɵɵreference(3);
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngbTypeahead", ctx_r6.suggestedAddresses)("ngClass", i0.ɵɵpureFunction2(8, _c4$b, (ctx_r6.control == null ? null : ctx_r6.control.errors) && (ctx_r6.control == null ? null : ctx_r6.control.enabled) && ((ctx_r6.control == null ? null : ctx_r6.control.touched) || (ctx_r6.control == null ? null : ctx_r6.control.dirty) || ctx_r6.submitted), ctx_r6.control.disabled))("resultTemplate", _r12)("inputFormatter", ctx_r6.addressAutocompleteFormatter)("ngModelOptions", i0.ɵɵpureFunction0(11, _c5$8))("readonly", ctx_r6.control.disabled)("ngModel", ctx_r6.addressSearchTerm);
    i0.ɵɵattribute("initialized", false);
} }
const _c6$7 = function (a0, a1) { return { "account-summary-input-small-width": a0, "account-summary-input-medium-width": a1 }; };
function AccountSummaryInputComponent_label_0_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 19);
    i0.ɵɵelement(2, "vnext-state-selector-input", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c6$7, ctx_r7.isSmallInputWidth, ctx_r7.isMediumInputWidth));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("control", ctx_r7.control)("formSubmitted", ctx_r7.submitted)("height", "36px")("isReadOnly", ctx_r7.control.disabled)("controlValue", ctx_r7.control.value);
} }
const _c7$5 = function (a0, a1) { return { "error-message": a0, "Spa_Style_Gray4_Color": a1 }; };
function AccountSummaryInputComponent_label_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 3);
    i0.ɵɵtemplate(1, AccountSummaryInputComponent_label_0_div_1_Template, 3, 2, "div", 4);
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵtemplate(3, AccountSummaryInputComponent_label_0_span_3_Template, 2, 0, "span", 6);
    i0.ɵɵelementStart(4, "span", 7);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, AccountSummaryInputComponent_label_0_ng_container_6_Template, 2, 10, "ng-container", 1);
    i0.ɵɵtemplate(7, AccountSummaryInputComponent_label_0_ng_container_7_Template, 7, 12, "ng-container", 1);
    i0.ɵɵtemplate(8, AccountSummaryInputComponent_label_0_ng_container_8_Template, 3, 9, "ng-container", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.personalFormInputConfig.keyName !== ctx_r0.accountOverviewInputs.ZIP);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isControlRequired);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c7$5, (ctx_r0.control == null ? null : ctx_r0.control.errors) && (ctx_r0.control == null ? null : ctx_r0.control.enabled) && ((ctx_r0.control == null ? null : ctx_r0.control.touched) || (ctx_r0.control == null ? null : ctx_r0.control.dirty) || ctx_r0.submitted), !(ctx_r0.control == null ? null : ctx_r0.control.enabled)));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.personalFormInputConfig.labelText, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.controlType === "input" && ctx_r0.personalFormInputConfig.keyName !== ctx_r0.accountOverviewInputs.ZIP && ctx_r0.personalFormInputConfig.keyName !== ctx_r0.accountOverviewInputs.CONSUMER_ADDRESS1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.controlType === "input" && ctx_r0.personalFormInputConfig.keyName !== ctx_r0.accountOverviewInputs.ZIP && ctx_r0.personalFormInputConfig.keyName === ctx_r0.accountOverviewInputs.CONSUMER_ADDRESS1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.controlType === "dropdown");
} }
function AccountSummaryInputComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 21)(2, "vnext-zip-code-input", 22, 23);
    i0.ɵɵlistener("zip", function AccountSummaryInputComponent_ng_container_1_Template_vnext_zip_code_input_zip_2_listener($event) { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r29.updateZip($event)); })("fips", function AccountSummaryInputComponent_ng_container_1_Template_vnext_zip_code_input_fips_2_listener($event) { i0.ɵɵrestoreView(_r30); const ctx_r31 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r31.updateFips($event)); })("onError", function AccountSummaryInputComponent_ng_container_1_Template_vnext_zip_code_input_onError_2_listener($event) { i0.ɵɵrestoreView(_r30); const ctx_r32 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r32.updateErrorStatus($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "input", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("selectedCountyEnabled", ctx_r1.selectedCountyEnabled)("zipCodeErrorText", ctx_r1.zipCodeErrorText)("countyErrorText", ctx_r1.countyErrorText)("selectCountyText", ctx_r1.selectCountyText)("zipCodeText", ctx_r1.zipCodeText)("editCountyText", ctx_r1.editCountyText)("customStyles", ctx_r1.customStyles)("errorKeywordText", ctx_r1.errorKeywordText)("emitOnEmptyValue", true)("validateOnBlur", true)("countyLabel", ctx_r1.countyLabel)("showCountyLabel", ctx_r1.showCountyLabel)("isReadOnly", ctx_r1.control.disabled)("retrieveZipCode", ctx_r1.retrieveZipCode)("retrieveFipsCode", ctx_r1.retrieveFipsCode)("isProfileZip", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControl", ctx_r1.control);
} }
function AccountSummaryInputComponent_label_2_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 25)(1, "input", 26);
    i0.ɵɵlistener("change", function AccountSummaryInputComponent_label_2_Template_input_change_1_listener() { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r33.toggleCellPhoneCheckbox()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span", 27);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("for", ctx_r2.personalFormInputConfig.keyName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", ctx_r2.personalFormInputConfig.keyName)("value", ctx_r2.disableCellPhoneInput)("checked", ctx_r2.disableCellPhoneInput);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.sameAsPrimaryText);
} }
var InputControlType;
(function (InputControlType) {
    InputControlType["INPUT"] = "input";
    InputControlType["DROPDOWN"] = "dropdown";
    InputControlType["TEXT"] = "text";
})(InputControlType || (InputControlType = {}));
class AccountSummaryInputComponent {
    constructor(cdr, accountOverviewFacade, addressService, autoCompleteService, localeService) {
        this.cdr = cdr;
        this.accountOverviewFacade = accountOverviewFacade;
        this.addressService = addressService;
        this.autoCompleteService = autoCompleteService;
        this.localeService = localeService;
        this.submitted = false;
        this.selectedCountyEnabled = false;
        this.zipCodeInvalidErrorText = '';
        this.zipCodeRequiredErrorText = '';
        this.countyErrorText = '';
        this.selectCountyText = '';
        this.zipCodeText = '';
        this.editCountyText = '';
        this.customStyles = {};
        this.errorKeywordText = '';
        this.countyLabel = '';
        this.showCountyLabel = '';
        this.selectedZipCode = '';
        this.addressAutoCompleteEnabled = false;
        this.noDateError = '';
        this.futureDateError = '';
        this.outOfRangeError = '';
        this.maxAge = 0;
        this.sameAsPrimaryText = 'Same as primary';
        this.displayCellPhoneCheckbox = false;
        this.disableCellPhoneInput = false;
        this.selectedFips = new EventEmitter();
        this.cellPhoneCheckBoxToggled = new EventEmitter();
        this.controlType = '';
        this.isSmallInputWidth = false;
        this.isMediumInputWidth = false;
        this.isControlRequired = false;
        this.requiredErrorMessage = '';
        this.invalidErrorMessage = '';
        this.inputMask = '';
        this.hasError = false;
        this.zipCodeErrorText = '';
        this.addressSearchTerm = '';
        this.subscriptions = new Subscription();
        this.accountOverviewInputs = AccountOverviewInputs;
        this.suggestedAddresses = (text$) => {
            if (!this.addressAutoCompleteEnabled) {
                return of([]);
            }
            return this.addressService.getAddresses$(text$.pipe(map(text => ({ partialAddress: text, zip: this.selectedZipCode ?? '', selected: '' }))));
        };
        this.addressAutocompleteFormatter = (address) => address.street_line;
    }
    ngOnChanges(changes) {
        const controlChanges = changes.control;
        const formConfigChanges = changes.personalFormInputConfig;
        if (!_isEqual(formConfigChanges?.currentValue, formConfigChanges?.previousValue)) {
            this.controlType = this.getControlType();
            this.isSmallInputWidth = this.isInputSmallWidth();
            this.isMediumInputWidth = this.isInputMediumWidth();
            this.requiredErrorMessage = this.getRequiredErrorMessage();
            this.invalidErrorMessage = this.getInvalidErrorMessage();
            this.inputMask = this.getMask();
        }
        if (!_isEqual(controlChanges?.currentValue, controlChanges?.previousValue)) {
            this.isControlRequired = this.controlIsRequired();
        }
    }
    ngOnInit() {
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe({
            next: () => {
                this.requiredErrorMessage = this.getRequiredErrorMessage();
                this.invalidErrorMessage = this.getInvalidErrorMessage();
                this.updateZipErrorText();
                if (this.isFormInputAddress1()) {
                    this.addressSearchTerm = this.personalFormGroup.get(this.accountOverviewInputs.CONSUMER_ADDRESS1)?.value ?? '';
                }
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.control.valueChanges.subscribe({
            next: () => {
                this.cdr.markForCheck();
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    ngAfterViewChecked() {
        if (this.isFormInputAddress1()) {
            if (this.addressSearchInput?.nativeElement) {
                const addressSearchInput = this.addressSearchInput.nativeElement;
                if (addressSearchInput.getAttribute('initialized') === 'false' && !addressSearchInput.value) {
                    addressSearchInput.value = this.addressSearchTerm;
                }
            }
        }
    }
    updateZip(updatedZip) {
        this.personalFormGroup.get(this.accountOverviewInputs.ZIP)?.setValue(updatedZip);
    }
    updateFips(fips) {
        this.selectedFips.emit(fips);
    }
    updateErrorStatus(errors) {
        if (errors.length) {
            this.updateZipErrorText();
            this.invalidateZipInput();
        }
    }
    selectItemForAddress(event) {
        const address = event.item;
        this.personalFormGroup.get(this.accountOverviewInputs.CONSUMER_ADDRESS1).setValue(address.street_line ?? '');
        this.personalFormGroup.get(this.accountOverviewInputs.CITY).setValue(address.city ?? '');
        this.personalFormGroup.get(this.accountOverviewInputs.CONSUMER_ADDRESS2).setValue(address.secondary ?? '');
        this.personalFormGroup.get(this.accountOverviewInputs.STATE).setValue(address.state ?? '');
        this.updateAddressZip(address.zipcode ?? '');
        this.typeahead.dismissPopup();
        this.cdr.detectChanges();
    }
    scrollItemIntoView() {
        this.autoCompleteService.scrollItemIntoView(this.typeahead);
    }
    focusAddressInput() {
        // A null check on nativeElement is not required here due to this only be called when you interact with the element,
        // which means that the element has to already exist.
        this.addressSearchInput.nativeElement.setAttribute('initialized', 'true');
    }
    updateAddressZip(zip) {
        this.updateZip(zip);
        if (this.zipInput?.zipCodeControl) {
            this.zipInput.zipCodeControl.setValue(zip);
        }
    }
    validateControl() {
        if (this.personalFormInputConfig.keyName === this.accountOverviewInputs.CONSUMER_BIRTH_DATE) {
            return this.getDateOfBirthValidation();
        }
        if (this.personalFormInputConfig.keyName === this.accountOverviewInputs.CONSUMER_ADDRESS1) {
            return this.validateAddress1();
        }
        return false;
    }
    toggleCellPhoneCheckbox() {
        this.cellPhoneCheckBoxToggled.emit(!this.disableCellPhoneInput);
    }
    updateZipErrorText() {
        const zipValue = this.zipInput?.zipCodeControl?.value ?? '';
        this.zipCodeErrorText = zipValue ? this.zipCodeInvalidErrorText : this.zipCodeRequiredErrorText;
    }
    getDateOfBirthValidation() {
        const date = this.personalFormGroup.get(this.accountOverviewInputs.CONSUMER_BIRTH_DATE)?.value;
        if (date !== '' && date.length < 10) {
            this.invalidErrorMessage = this.noDateError;
            this.invalidateDateOfBirth();
            return true;
        }
        if ((date === '' && this.isControlRequired) || (date !== '' && !DateUtilities.isValidDate(date))) {
            this.invalidErrorMessage = this.noDateError;
            this.invalidateDateOfBirth();
            return true;
        }
        if (date !== '' && DateUtilities.dateIsInFuture(date)) {
            this.invalidErrorMessage = this.futureDateError;
            this.invalidateDateOfBirth();
            return true;
        }
        if (date !== '' && !DateUtilities.dateIsInPastYearRange(date, this.maxAge)) {
            this.invalidErrorMessage = this.outOfRangeError;
            this.invalidateDateOfBirth();
            return true;
        }
        this.personalFormGroup.get(this.accountOverviewInputs.CONSUMER_BIRTH_DATE).setErrors(null);
        return false;
    }
    invalidateDateOfBirth() {
        this.personalFormGroup.get(this.accountOverviewInputs.CONSUMER_BIRTH_DATE).markAsTouched({ onlySelf: true });
        this.personalFormGroup.get(this.accountOverviewInputs.CONSUMER_BIRTH_DATE).setErrors({ incorrect: true });
        this.cdr.detectChanges();
    }
    invalidateZipInput() {
        this.personalFormGroup.get(this.accountOverviewInputs.ZIP).markAsTouched();
        this.personalFormGroup.get(this.accountOverviewInputs.ZIP).setErrors({ incorrect: true });
        this.cdr.detectChanges();
    }
    validateAddress1() {
        // If searchTerm is a string instead of an object, they did not click an item in the dropdown
        // So save the text in the field to the address field
        if (this.addressSearchInput?.nativeElement && typeof this.addressSearchTerm === 'string') {
            const searchInputValue = this.addressSearchInput.nativeElement.value;
            this.personalFormGroup.get(this.accountOverviewInputs.CONSUMER_ADDRESS1).setValue(searchInputValue);
        }
        const addressValue = this.personalFormGroup.get(this.accountOverviewInputs.CONSUMER_ADDRESS1)?.value;
        if (this.isControlRequired && addressValue === '') {
            this.personalFormGroup.get(this.accountOverviewInputs.CONSUMER_ADDRESS1).markAsTouched();
            this.personalFormGroup.get(this.accountOverviewInputs.CONSUMER_ADDRESS1).setErrors({ incorrect: true });
            this.cdr.detectChanges();
            return true;
        }
        this.personalFormGroup.get(this.accountOverviewInputs.CONSUMER_ADDRESS1).setErrors(null);
        return false;
    }
    getRequiredErrorMessage() {
        const controlName = this.personalFormInputConfig.keyName;
        return this.accountOverviewFacade.getProfileRequiredErrorMessage(controlName);
    }
    getInvalidErrorMessage() {
        const controlName = this.personalFormInputConfig.keyName;
        return this.accountOverviewFacade.getProfileInvalidErrorMessage(controlName);
    }
    getControlType() {
        const controlName = this.personalFormInputConfig.keyName;
        if (controlName === this.accountOverviewInputs.STATE) {
            return InputControlType.DROPDOWN;
        }
        return InputControlType.INPUT;
    }
    controlIsRequired() {
        return this.control?.validator?.({})?.required ?? false;
    }
    getMask() {
        const controlName = this.personalFormInputConfig.keyName;
        if (controlName === this.accountOverviewInputs.CONSUMER_PHONE || controlName === this.accountOverviewInputs.CONSUMER_CELL_PHONE) {
            return FormValidationService.phoneMask;
        }
        if (controlName === this.accountOverviewInputs.CONSUMER_BIRTH_DATE) {
            return FormValidationService.dateMask;
        }
    }
    isInputSmallWidth() {
        const controlName = this.personalFormInputConfig.keyName;
        return [this.accountOverviewInputs.STATE].includes(controlName);
    }
    isInputMediumWidth() {
        const controlName = this.personalFormInputConfig.keyName;
        return [
            this.accountOverviewInputs.CONSUMER_BIRTH_DATE,
            this.accountOverviewInputs.CONSUMER_PHONE,
            this.accountOverviewInputs.CONSUMER_CELL_PHONE
        ].includes(controlName);
    }
    isFormInputAddress1() {
        return this.personalFormInputConfig.keyName === this.accountOverviewInputs.CONSUMER_ADDRESS1;
    }
}
AccountSummaryInputComponent.ɵfac = function AccountSummaryInputComponent_Factory(t) { return new (t || AccountSummaryInputComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(AccountOverviewFacade), i0.ɵɵdirectiveInject(i1.AddressService), i0.ɵɵdirectiveInject(i1.AutoCompleteService), i0.ɵɵdirectiveInject(i1.LocaleService)); };
AccountSummaryInputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AccountSummaryInputComponent, selectors: [["vnext-widget-account-summary-input"]], viewQuery: function AccountSummaryInputComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1E, 5);
        i0.ɵɵviewQuery(_c1$M, 5);
        i0.ɵɵviewQuery(_c2$v, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.typeahead = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addressSearchInput = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.zipInput = _t.first);
    } }, inputs: { personalFormGroup: "personalFormGroup", personalFormInputConfig: "personalFormInputConfig", control: "control", submitted: "submitted", selectedCountyEnabled: "selectedCountyEnabled", zipCodeInvalidErrorText: "zipCodeInvalidErrorText", zipCodeRequiredErrorText: "zipCodeRequiredErrorText", countyErrorText: "countyErrorText", selectCountyText: "selectCountyText", zipCodeText: "zipCodeText", editCountyText: "editCountyText", customStyles: "customStyles", errorKeywordText: "errorKeywordText", countyLabel: "countyLabel", showCountyLabel: "showCountyLabel", selectedZipCode: "selectedZipCode", addressAutoCompleteEnabled: "addressAutoCompleteEnabled", noDateError: "noDateError", futureDateError: "futureDateError", outOfRangeError: "outOfRangeError", maxAge: "maxAge", retrieveZipCode: "retrieveZipCode", retrieveFipsCode: "retrieveFipsCode", sameAsPrimaryText: "sameAsPrimaryText", displayCellPhoneCheckbox: "displayCellPhoneCheckbox", disableCellPhoneInput: "disableCellPhoneInput" }, outputs: { selectedFips: "selectedFips", cellPhoneCheckBoxToggled: "cellPhoneCheckBoxToggled" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 3, consts: [["class", "mb-0 w-100", 4, "ngIf"], [4, "ngIf"], ["class", "w-100 pt-2", 3, "for", 4, "ngIf"], [1, "mb-0", "w-100"], ["class", "error-container pt-2", 4, "ngIf"], ["id", "personalFormInputLabelId", 1, "mb-2"], ["class", "input-error-asterisk Spa_Style_Small_Font", 4, "ngIf"], [1, "Spa_Style_Small_Font", "Spa_Style_Label", 3, "ngClass"], [1, "error-container", "pt-2"], [1, "error", "Spa_Style_Smaller_Font", "align-bottom"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], [1, "input-error-asterisk", "Spa_Style_Small_Font"], ["type", "text", "tabindex", "0", "aria-labelledby", "personalFormInputLabelId", 1, "form-control", 3, "ngClass", "formControl", "mask", "dropSpecialCharacters", "readonly", "blur"], ["for", "memberRegistrationAddressLabelId", 1, "w-100", "address-autocomplete-wrapper"], ["addressResultTemplate", ""], ["id", "memberRegistrationAddressLabelId", "type", "text", "placement", "bottom-left", 1, "form-control", "w-100", 3, "ngbTypeahead", "ngClass", "resultTemplate", "inputFormatter", "ngModelOptions", "readonly", "ngModel", "ngModelChange", "selectItem", "keyup", "focus", "blur"], ["addressSearchInput", "", "typeahead", "ngbTypeahead"], [1, "Spa_Style_H5", "no-translate-block"], [3, "result", "term"], [3, "ngClass"], [3, "control", "formSubmitted", "height", "isReadOnly", "controlValue"], [1, "zip-label"], [3, "selectedCountyEnabled", "zipCodeErrorText", "countyErrorText", "selectCountyText", "zipCodeText", "editCountyText", "customStyles", "errorKeywordText", "emitOnEmptyValue", "validateOnBlur", "countyLabel", "showCountyLabel", "isReadOnly", "retrieveZipCode", "retrieveFipsCode", "isProfileZip", "zip", "fips", "onError"], ["accountSummaryZipInput", ""], ["type", "hidden", 3, "formControl"], [1, "w-100", "pt-2", 3, "for"], ["type", "checkbox", 3, "id", "value", "checked", "change"], [1, "pl-2", "Spa_Style_Primary_Color"]], template: function AccountSummaryInputComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, AccountSummaryInputComponent_label_0_Template, 9, 10, "label", 0);
        i0.ɵɵtemplate(1, AccountSummaryInputComponent_ng_container_1_Template, 5, 17, "ng-container", 1);
        i0.ɵɵtemplate(2, AccountSummaryInputComponent_label_2_Template, 4, 5, "label", 2);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.personalFormInputConfig.keyName !== ctx.accountOverviewInputs.ZIP);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.personalFormInputConfig.keyName === ctx.accountOverviewInputs.ZIP);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.personalFormInputConfig.keyName === ctx.accountOverviewInputs.CONSUMER_CELL_PHONE && ctx.displayCellPhoneCheckbox);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, i4.FormControlDirective, ZipCodeInputComponent, StateSelectorInputComponent, IconAriaAttributesDirective, i1$1.NgbTypeahead, i1$1.NgbHighlight, i8.MaskDirective], styles: [".account-summary-input-small-width[_ngcontent-%COMP%]{min-width:90px;max-width:90px}.account-summary-input-medium-width[_ngcontent-%COMP%]{min-width:147px;max-width:147px}.error-message[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent2)}@media (max-width: 768px){.account-summary-input-small-width[_ngcontent-%COMP%], .account-summary-input-medium-width[_ngcontent-%COMP%], .account-summary-input-large-width[_ngcontent-%COMP%]{width:100%;max-width:100%}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccountSummaryInputComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-account-summary-input', changeDetection: ChangeDetectionStrategy.OnPush, template: "<label class=\"mb-0 w-100\" *ngIf=\"personalFormInputConfig.keyName !== accountOverviewInputs.ZIP\">\r\n  <div class=\"error-container pt-2\" *ngIf=\"personalFormInputConfig.keyName !== accountOverviewInputs.ZIP\">\r\n    <ng-container *ngIf=\"control?.errors && control?.enabled && (control?.touched || control?.dirty || submitted) && !control?.value\">\r\n      <span class=\"error Spa_Style_Smaller_Font align-bottom\"\r\n        ><i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i> {{ requiredErrorMessage }}</span\r\n      >\r\n    </ng-container>\r\n\r\n    <ng-container\r\n      *ngIf=\"control?.errors && control?.enabled && (control?.touched || control?.dirty || submitted) && control?.value && !control?.valid\"\r\n    >\r\n      <span class=\"error Spa_Style_Smaller_Font align-bottom\"\r\n        ><i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i> {{ invalidErrorMessage }}</span\r\n      >\r\n    </ng-container>\r\n  </div>\r\n\r\n  <div id=\"personalFormInputLabelId\" class=\"mb-2\">\r\n    <span *ngIf=\"isControlRequired\" class=\"input-error-asterisk Spa_Style_Small_Font\">*</span>\r\n    <span\r\n      class=\"Spa_Style_Small_Font Spa_Style_Label\"\r\n      [ngClass]=\"{\r\n        'error-message': control?.errors && control?.enabled && (control?.touched || control?.dirty || submitted),\r\n        'Spa_Style_Gray4_Color': !control?.enabled\r\n      }\"\r\n    >\r\n      {{ personalFormInputConfig.labelText }}</span\r\n    >\r\n  </div>\r\n\r\n  <ng-container\r\n    *ngIf=\"\r\n      controlType === 'input' &&\r\n      personalFormInputConfig.keyName !== accountOverviewInputs.ZIP &&\r\n      personalFormInputConfig.keyName !== accountOverviewInputs.CONSUMER_ADDRESS1\r\n    \"\r\n  >\r\n    <input\r\n      type=\"text\"\r\n      class=\"Spa_Style_Smaller_Font\"\r\n      tabindex=\"0\"\r\n      class=\"form-control\"\r\n      aria-labelledby=\"personalFormInputLabelId\"\r\n      [ngClass]=\"{\r\n        'has-error': control?.errors && (control?.touched || submitted),\r\n        'account-summary-input-small-width': isSmallInputWidth,\r\n        'account-summary-input-medium-width': isMediumInputWidth,\r\n        'account-summary-input-large-width': !isSmallInputWidth && !isMediumInputWidth\r\n      }\"\r\n      [formControl]=\"control\"\r\n      [mask]=\"inputMask\"\r\n      [dropSpecialCharacters]=\"personalFormInputConfig.keyName !== accountOverviewInputs.CONSUMER_BIRTH_DATE\"\r\n      [readonly]=\"\r\n        personalFormInputConfig.keyName === accountOverviewInputs.CONSUMER_CELL_PHONE\r\n          ? disableCellPhoneInput || control.disabled\r\n          : control.disabled\r\n      \"\r\n      (blur)=\"validateControl()\"\r\n    />\r\n  </ng-container>\r\n\r\n  <ng-container\r\n    *ngIf=\"\r\n      controlType === 'input' &&\r\n      personalFormInputConfig.keyName !== accountOverviewInputs.ZIP &&\r\n      personalFormInputConfig.keyName === accountOverviewInputs.CONSUMER_ADDRESS1\r\n    \"\r\n  >\r\n    <label for=\"memberRegistrationAddressLabelId\" class=\"w-100 address-autocomplete-wrapper\">\r\n      <!-- TODO: refactor this into a component as is a copy of same functionality from MemberRegistration Component.  -->\r\n      <ng-template #addressResultTemplate let-r=\"result\" let-t=\"term\">\r\n        <span class=\"Spa_Style_H5 no-translate-block\">\r\n          <ngb-highlight [result]=\"r.street_line\" [term]=\"t\"></ngb-highlight>\r\n          <span *ngIf=\"r.secondary\"> {{ r.secondary }}</span> {{ r.city }} {{ r.state\r\n          }}<span *ngIf=\"r.zipcode\">, {{ r.zipcode }}</span></span\r\n        >\r\n      </ng-template>\r\n      <input\r\n        #addressSearchInput\r\n        #typeahead=\"ngbTypeahead\"\r\n        id=\"memberRegistrationAddressLabelId\"\r\n        type=\"text\"\r\n        placement=\"bottom-left\"\r\n        class=\"form-control w-100\"\r\n        [attr.initialized]=\"false\"\r\n        [ngbTypeahead]=\"suggestedAddresses\"\r\n        [ngClass]=\"{\r\n          'has-error': control?.errors && control?.enabled && (control?.touched || control?.dirty || submitted),\r\n          'Spa_Style_Gray4_Color readonly': control.disabled\r\n        }\"\r\n        [resultTemplate]=\"addressResultTemplate\"\r\n        [inputFormatter]=\"addressAutocompleteFormatter\"\r\n        [ngModelOptions]=\"{ standalone: true }\"\r\n        [readonly]=\"control.disabled\"\r\n        [(ngModel)]=\"addressSearchTerm\"\r\n        (selectItem)=\"selectItemForAddress($event)\"\r\n        (keyup)=\"scrollItemIntoView()\"\r\n        (focus)=\"focusAddressInput()\"\r\n        (blur)=\"validateControl()\"\r\n      />\r\n    </label>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"controlType === 'dropdown'\">\r\n    <div\r\n      [ngClass]=\"{\r\n        'account-summary-input-small-width': isSmallInputWidth,\r\n        'account-summary-input-medium-width': isMediumInputWidth\r\n      }\"\r\n    >\r\n      <vnext-state-selector-input\r\n        [control]=\"control\"\r\n        [formSubmitted]=\"submitted\"\r\n        [height]=\"'36px'\"\r\n        [isReadOnly]=\"control.disabled\"\r\n        [controlValue]=\"control.value\"\r\n      >\r\n      </vnext-state-selector-input>\r\n    </div>\r\n  </ng-container>\r\n</label>\r\n\r\n<ng-container *ngIf=\"personalFormInputConfig.keyName === accountOverviewInputs.ZIP\">\r\n  <label class=\"zip-label\">\r\n    <vnext-zip-code-input\r\n      #accountSummaryZipInput\r\n      [selectedCountyEnabled]=\"selectedCountyEnabled\"\r\n      [zipCodeErrorText]=\"zipCodeErrorText\"\r\n      [countyErrorText]=\"countyErrorText\"\r\n      [selectCountyText]=\"selectCountyText\"\r\n      [zipCodeText]=\"zipCodeText\"\r\n      [editCountyText]=\"editCountyText\"\r\n      [customStyles]=\"customStyles\"\r\n      [errorKeywordText]=\"errorKeywordText\"\r\n      [emitOnEmptyValue]=\"true\"\r\n      [validateOnBlur]=\"true\"\r\n      [countyLabel]=\"countyLabel\"\r\n      [showCountyLabel]=\"showCountyLabel\"\r\n      [isReadOnly]=\"control.disabled\"\r\n      (zip)=\"updateZip($event)\"\r\n      (fips)=\"updateFips($event)\"\r\n      (onError)=\"updateErrorStatus($event)\"\r\n      [retrieveZipCode]=\"retrieveZipCode\"\r\n      [retrieveFipsCode]=\"retrieveFipsCode\"\r\n      [isProfileZip]=\"true\"\r\n    >\r\n    </vnext-zip-code-input>\r\n    <input type=\"hidden\" [formControl]=\"control\" />\r\n  </label>\r\n</ng-container>\r\n\r\n<!-- This is outside of the ng-container for inputs to account for input alignments, as they all need to be aligned, and then this\r\nbox needs to be under that alignment. -->\r\n<label\r\n  *ngIf=\"personalFormInputConfig.keyName === accountOverviewInputs.CONSUMER_CELL_PHONE && displayCellPhoneCheckbox\"\r\n  class=\"w-100 pt-2\"\r\n  [for]=\"personalFormInputConfig.keyName\"\r\n>\r\n  <input\r\n    type=\"checkbox\"\r\n    [id]=\"personalFormInputConfig.keyName\"\r\n    [value]=\"disableCellPhoneInput\"\r\n    [checked]=\"disableCellPhoneInput\"\r\n    (change)=\"toggleCellPhoneCheckbox()\"\r\n  />\r\n  <span class=\"pl-2 Spa_Style_Primary_Color\">{{ sameAsPrimaryText }}</span>\r\n</label>\r\n", styles: [".account-summary-input-small-width{min-width:90px;max-width:90px}.account-summary-input-medium-width{min-width:147px;max-width:147px}.error-message{color:var(--static-Spa_Style_Accent2)}@media (max-width: 768px){.account-summary-input-small-width,.account-summary-input-medium-width,.account-summary-input-large-width{width:100%;max-width:100%}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: AccountOverviewFacade }, { type: i1.AddressService }, { type: i1.AutoCompleteService }, { type: i1.LocaleService }]; }, { typeahead: [{
            type: ViewChild,
            args: ['typeahead']
        }], addressSearchInput: [{
            type: ViewChild,
            args: ['addressSearchInput']
        }], zipInput: [{
            type: ViewChild,
            args: ['accountSummaryZipInput']
        }], personalFormGroup: [{
            type: Input
        }], personalFormInputConfig: [{
            type: Input
        }], control: [{
            type: Input
        }], submitted: [{
            type: Input
        }], selectedCountyEnabled: [{
            type: Input
        }], zipCodeInvalidErrorText: [{
            type: Input
        }], zipCodeRequiredErrorText: [{
            type: Input
        }], countyErrorText: [{
            type: Input
        }], selectCountyText: [{
            type: Input
        }], zipCodeText: [{
            type: Input
        }], editCountyText: [{
            type: Input
        }], customStyles: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], countyLabel: [{
            type: Input
        }], showCountyLabel: [{
            type: Input
        }], selectedZipCode: [{
            type: Input
        }], addressAutoCompleteEnabled: [{
            type: Input
        }], noDateError: [{
            type: Input
        }], futureDateError: [{
            type: Input
        }], outOfRangeError: [{
            type: Input
        }], maxAge: [{
            type: Input
        }], retrieveZipCode: [{
            type: Input
        }], retrieveFipsCode: [{
            type: Input
        }], sameAsPrimaryText: [{
            type: Input
        }], displayCellPhoneCheckbox: [{
            type: Input
        }], disableCellPhoneInput: [{
            type: Input
        }], selectedFips: [{
            type: Output
        }], cellPhoneCheckBoxToggled: [{
            type: Output
        }] }); })();

function MemberExpandableEnrollmentCardComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.memberEnrollmentSubmittedDate, " ");
} }
function MemberExpandableEnrollmentCardComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.memberEnrollmentSubmittedDate, " ");
} }
function MemberExpandableEnrollmentCardComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14)(2, "h3", 15);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.memberEnrollmentPlanName);
} }
function MemberExpandableEnrollmentCardComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.planYear);
} }
function MemberExpandableEnrollmentCardComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "vnext-link", 17);
    i0.ɵɵlistener("click", function MemberExpandableEnrollmentCardComponent_div_11_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.viewApplication.emit()); })("keyup.enter", function MemberExpandableEnrollmentCardComponent_div_11_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.viewApplication.emit()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("additionalIcon", "fas fa-file-pdf")("title", ctx_r4.viewApplicationLinkText);
} }
function MemberExpandableEnrollmentCardComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 19);
    i0.ɵɵelement(2, "i", 20);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.daysLeftText, "");
} }
class MemberExpandableEnrollmentCardComponent {
    constructor() {
        this.viewApplication = new EventEmitter();
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.subscriptions.add(this.isMobile$.subscribe(isMobile => {
            this.isMobile = isMobile;
        }));
    }
    ngOnChanges(changes) {
        const { completeHRADaysLeftText, remainingHRADays } = changes;
        if ((completeHRADaysLeftText && completeHRADaysLeftText.previousValue !== completeHRADaysLeftText.currentValue) ||
            (remainingHRADays && remainingHRADays.previousValue !== remainingHRADays.currentValue)) {
            if (this.remainingHRADays) {
                this.daysLeftText = this.completeHRADaysLeftText?.replace('<hraDaysLeft>', this.remainingHRADays.toString());
            }
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
MemberExpandableEnrollmentCardComponent.ɵfac = function MemberExpandableEnrollmentCardComponent_Factory(t) { return new (t || MemberExpandableEnrollmentCardComponent)(); };
MemberExpandableEnrollmentCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MemberExpandableEnrollmentCardComponent, selectors: [["vnext-member-expandable-enrollment-card"]], inputs: { memberEnrollmentPlanName: "memberEnrollmentPlanName", memberEnrollmentSubmittedDate: "memberEnrollmentSubmittedDate", planNameEnabled: "planNameEnabled", displayPlanYearBadge: "displayPlanYearBadge", disableExpandableDetailsInAccountSummaryPage: "disableExpandableDetailsInAccountSummaryPage", hraConfirmationNumberEnabled: "hraConfirmationNumberEnabled", remainingHRADays: "remainingHRADays", isHRAEnabled: "isHRAEnabled", planYear: "planYear", submissionDateEnabled: "submissionDateEnabled", hraConfirmationText: "hraConfirmationText", viewApplicationLinkText: "viewApplicationLinkText", forceViewApplicationPdfLink: "forceViewApplicationPdfLink", showViewApplicationLink: "showViewApplicationLink", planTypeID: "planTypeID", totalMonthlyPremiumLabel: "totalMonthlyPremiumLabel", memberEnrollmentPremium: "memberEnrollmentPremium", hraConfirmationNumber: "hraConfirmationNumber", planTypeText: "planTypeText", completeHRADaysLeftText: "completeHRADaysLeftText" }, outputs: { viewApplication: "viewApplication" }, features: [i0.ɵɵNgOnChangesFeature], decls: 13, vars: 9, consts: [[1, "pb-2"], [1, "row", "no-gutters", "justify-content-end", "mb-1"], ["class", "Spa_Style_Gray4_Color Spa_Style_Smaller_Font d-flex justify-content-end col-sm-12", 4, "ngIf"], ["class", "Spa_Style_Gray4_Color Spa_Style_Smaller_Font d-flex justify-content-end col-6", 4, "ngIf"], ["class", "row no-gutters", 4, "ngIf"], [1, "row", "member-enrollment-details"], [1, "col-sm-12", "col-lg-5", "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font"], [4, "ngIf"], [1, "col-sm-12", "col-lg-3", "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font", "d-flex", "center-card-content"], ["class", "col-sm-12 col-lg-4 Spa_Style_Primary_Link d-flex justify-content-end", 4, "ngIf"], ["class", "mt-2", 4, "ngIf"], [1, "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font", "d-flex", "justify-content-end", "col-sm-12"], [1, "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font", "d-flex", "justify-content-end", "col-6"], [1, "row", "no-gutters"], [1, "Spa_Style_Primary_Color", "Spa_Style_Regular_Font", "col-12"], [1, "Spa_Style_H3", "mb-0", "no-translate-block"], [1, "col-sm-12", "col-lg-4", "Spa_Style_Primary_Link", "d-flex", "justify-content-end"], [3, "additionalIcon", "title", "click", "keyup.enter"], [1, "mt-2"], [1, "warn-container", "Spa_Style_Small_Font"], [1, "fas", "fa-exclamation-triangle"]], template: function MemberExpandableEnrollmentCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, MemberExpandableEnrollmentCardComponent_div_2_Template, 2, 1, "div", 2);
        i0.ɵɵtemplate(3, MemberExpandableEnrollmentCardComponent_div_3_Template, 2, 1, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, MemberExpandableEnrollmentCardComponent_div_4_Template, 4, 1, "div", 4);
        i0.ɵɵelementStart(5, "div", 5)(6, "div", 6);
        i0.ɵɵtext(7);
        i0.ɵɵtemplate(8, MemberExpandableEnrollmentCardComponent_span_8_Template, 2, 1, "span", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(11, MemberExpandableEnrollmentCardComponent_div_11_Template, 2, 2, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, MemberExpandableEnrollmentCardComponent_div_12_Template, 4, 1, "div", 10);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isMobile);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isMobile);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.planNameEnabled);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.planTypeText, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.displayPlanYearBadge);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate2(" ", ctx.totalMonthlyPremiumLabel, " ", ctx.memberEnrollmentPremium, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.forceViewApplicationPdfLink || ctx.showViewApplicationLink);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isHRAEnabled && ctx.remainingHRADays > 0 && !ctx.hraConfirmationNumber);
    } }, dependencies: [i1$2.NgIf, LinkComponent, IconAriaAttributesDirective], styles: [".member-enrollment-details[_ngcontent-%COMP%]{gap:24px 0}@media (max-width: 768px){.center-card-content[_ngcontent-%COMP%]{justify-content:center}}"], changeDetection: 0 });
__decorate([
    ResponsiveLayout(BreakPoint.COMPACT)
], MemberExpandableEnrollmentCardComponent.prototype, "isMobile$", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberExpandableEnrollmentCardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-member-expandable-enrollment-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"pb-2\">\r\n  <div class=\"row no-gutters justify-content-end mb-1\">\r\n    <div *ngIf=\"isMobile\" class=\"Spa_Style_Gray4_Color Spa_Style_Smaller_Font d-flex justify-content-end col-sm-12\">\r\n      {{ memberEnrollmentSubmittedDate }}\r\n    </div>\r\n    <div *ngIf=\"!isMobile\" class=\"Spa_Style_Gray4_Color Spa_Style_Smaller_Font d-flex justify-content-end col-6\">\r\n      {{ memberEnrollmentSubmittedDate }}\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"planNameEnabled\" class=\"row no-gutters\">\r\n    <div class=\"Spa_Style_Primary_Color Spa_Style_Regular_Font col-12\">\r\n      <h3 class=\"Spa_Style_H3 mb-0 no-translate-block\">{{ memberEnrollmentPlanName }}</h3>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row member-enrollment-details\">\r\n    <div class=\"col-sm-12 col-lg-5 Spa_Style_Gray4_Color Spa_Style_Smaller_Font\">\r\n      {{ planTypeText }} <span *ngIf=\"displayPlanYearBadge\">{{ planYear }}</span>\r\n    </div>\r\n    <div class=\"col-sm-12 col-lg-3 Spa_Style_Gray4_Color Spa_Style_Smaller_Font d-flex center-card-content\">\r\n      {{ totalMonthlyPremiumLabel }} {{ memberEnrollmentPremium }}\r\n    </div>\r\n    <div\r\n      *ngIf=\"forceViewApplicationPdfLink || showViewApplicationLink\"\r\n      class=\"col-sm-12 col-lg-4 Spa_Style_Primary_Link d-flex justify-content-end\"\r\n    >\r\n      <vnext-link\r\n        (click)=\"viewApplication.emit()\"\r\n        (keyup.enter)=\"viewApplication.emit()\"\r\n        [additionalIcon]=\"'fas fa-file-pdf'\"\r\n        [title]=\"viewApplicationLinkText\"\r\n      ></vnext-link>\r\n    </div>\r\n  </div>\r\n  <div class=\"mt-2\" *ngIf=\"isHRAEnabled && remainingHRADays > 0 && !hraConfirmationNumber\">\r\n    <div class=\"warn-container Spa_Style_Small_Font\"><i class=\"fas fa-exclamation-triangle\"></i> {{ daysLeftText }}</div>\r\n  </div>\r\n</div>\r\n", styles: [".member-enrollment-details{gap:24px 0}@media (max-width: 768px){.center-card-content{justify-content:center}}\n"] }]
    }], null, { memberEnrollmentPlanName: [{
            type: Input
        }], memberEnrollmentSubmittedDate: [{
            type: Input
        }], planNameEnabled: [{
            type: Input
        }], displayPlanYearBadge: [{
            type: Input
        }], disableExpandableDetailsInAccountSummaryPage: [{
            type: Input
        }], hraConfirmationNumberEnabled: [{
            type: Input
        }], remainingHRADays: [{
            type: Input
        }], isHRAEnabled: [{
            type: Input
        }], planYear: [{
            type: Input
        }], submissionDateEnabled: [{
            type: Input
        }], hraConfirmationText: [{
            type: Input
        }], viewApplicationLinkText: [{
            type: Input
        }], forceViewApplicationPdfLink: [{
            type: Input
        }], showViewApplicationLink: [{
            type: Input
        }], planTypeID: [{
            type: Input
        }], totalMonthlyPremiumLabel: [{
            type: Input
        }], memberEnrollmentPremium: [{
            type: Input
        }], hraConfirmationNumber: [{
            type: Input
        }], planTypeText: [{
            type: Input
        }], completeHRADaysLeftText: [{
            type: Input
        }], viewApplication: [{
            type: Output
        }], isMobile$: [] }); })();

const _c0$1D = function (a0, a1, a2) { return { "py-1": a0, "col-md-6": a1, "col-md-1": a2 }; };
function CallRecordingAudioPlayerComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(2, _c0$1D, ctx_r0.showVerticalPadding, ctx_r0.isEnrollmentCardDetail, !ctx_r0.isEnrollmentCardDetail));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.callDuration, " ");
} }
function CallRecordingAudioPlayerComponent_div_10_i_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 18);
} }
function CallRecordingAudioPlayerComponent_div_10_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 19);
} }
const _c1$L = function (a0) { return { "pl-0": a0 }; };
const _c2$u = function (a0) { return { "pt-1": a0 }; };
function CallRecordingAudioPlayerComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "span", 11);
    i0.ɵɵlistener("click", function CallRecordingAudioPlayerComponent_div_10_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.togglePlayStop()); });
    i0.ɵɵtemplate(3, CallRecordingAudioPlayerComponent_div_10_i_3_Template, 1, 0, "i", 12);
    i0.ɵɵtemplate(4, CallRecordingAudioPlayerComponent_div_10_ng_template_4_Template, 1, 0, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 14);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 15)(10, "input", 16);
    i0.ɵɵlistener("positionChange", function CallRecordingAudioPlayerComponent_div_10_Template_input_positionChange_10_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.onPositionChange($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "span", 17);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const _r3 = i0.ɵɵreference(5);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c1$L, ctx_r1.isEnrollmentCardDetail));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c2$u, ctx_r1.showVerticalPadding));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.audio || ctx_r1.audio.paused)("ngIfElse", _r3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 9, ctx_r1.elapsedTime$) || ctx_r1.DEFAULT_START_TIME);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("maxValue", ctx_r1.callRecord.callDuration)("formControl", ctx_r1.audioSliderFormControl);
    i0.ɵɵattribute("aria-label", ctx_r1.callDuration);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.callDuration, " ");
} }
const _c3$j = function (a0) { return { "py-3 py-md-4": a0 }; };
const _c4$a = function (a0, a1, a2, a3, a4) { return { "col-md-5": a0, "col-md-9": a1, "col-md-12": a2, "col-md-8": a3, "py-1": a4 }; };
const _c5$7 = function (a0, a1, a2, a3, a4) { return { "py-1": a0, "col-md-6": a1, "col-md-3": a2, "text-right": a3, "text-md-left": a4 }; };
class CallRecordingAudioPlayerComponent {
    constructor(agentCallRecordingHttpService, fileUtilityService, agentCallRecordingFacade, cdr, analyticsService) {
        this.agentCallRecordingHttpService = agentCallRecordingHttpService;
        this.fileUtilityService = fileUtilityService;
        this.agentCallRecordingFacade = agentCallRecordingFacade;
        this.cdr = cdr;
        this.analyticsService = analyticsService;
        this.showVerticalPadding = true;
        this.isEnrollmentCardDetail = false;
        this.audioSliderFormControl = new UntypedFormControl();
        this.audio = null;
        this.DEFAULT_START_TIME = '00:00';
        this.AUDIO_TYPE = 'audio/mp3';
    }
    ngOnInit() {
        this.formattedDate = this.getConvertedDate(this.callRecord.timestamp);
        this.callDuration = DateUtilities.getElapsedTime(parseInt(this.callRecord.callDuration, 10));
        this.isPlayAudioRecording = this.agentCallRecordingFacade.isDisplayPlayAudioRecordingEnabled();
        this.callRecordingFileDurationEnabled = this.agentCallRecordingFacade.callRecordingFileDurationEnabled();
        this.getCallRecordingRequest$ = this.agentCallRecordingHttpService.getCallRecording$(this.callRecord.recordingID);
    }
    ngOnDestroy() {
        this.audio?.pause();
    }
    onPositionChange(seekedPosition) {
        if (this.isLoading) {
            return;
        }
        this.getCallRecording$()
            .pipe(take(1))
            .subscribe(() => {
            this.audio.currentTime = seekedPosition;
        });
    }
    togglePlayStop() {
        if (this.isLoading) {
            return;
        }
        this.getCallRecording$()
            .pipe(take(1))
            .subscribe((audio) => {
            if (audio.paused || audio.currentTime === 0 || audio.ended) {
                audio.play();
                this.analyticsService.googleDataLayerTags = {
                    [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_CALL_RECORDING_PLAYBACK,
                    [DataLayerGlobalVariable.CALL_RECORDING_TRACKING_ID]: this.callRecord.callTrackingID,
                    [DataLayerGlobalVariable.CALL_RECORDING_DURATION]: `${this.callRecord.callDuration}`
                };
            }
            else {
                audio.pause();
            }
            this.cdr.markForCheck();
        });
    }
    download() {
        if (this.isLoading) {
            return;
        }
        this.getCallRecording$()
            .pipe(take(1))
            .subscribe(() => {
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_CALL_RECORDING_DOWNLOAD_RECORDING,
                [DataLayerGlobalVariable.CALL_RECORDING_TRACKING_ID]: this.callRecord.callTrackingID
            };
            this.fileUtilityService.downloadFile(this.blob, this.callRecord.recordingName, this.AUDIO_TYPE);
        });
    }
    getConvertedDate(date) {
        const formattedDate = DateUtilities.getFormattedDateTime(new Date(date), DateUtilities.dateTimeFormat);
        return `${formattedDate} ${this.pacificStandardTimeText}`;
    }
    getCallRecording$() {
        this.isLoading = true;
        return iif(() => !!this.audio, of(this.audio), this.getCallRecordingRequest$.pipe(take(1), map((audioStream) => {
            this.blob = new Blob([audioStream], { type: this.AUDIO_TYPE });
            this.fileUrl = window.URL.createObjectURL(this.blob);
            this.audio = new Audio(this.fileUrl);
            const timeUpdate$ = fromEvent(this.audio, 'timeupdate').pipe(map(() => this.audio.currentTime));
            const audioEnded$ = fromEvent(this.audio, 'ended').pipe(map(() => {
                this.audio.currentTime = 0;
                return 0;
            }));
            this.elapsedTime$ = merge(timeUpdate$, audioEnded$).pipe(map(currentTime => {
                const fixedCurrentTime = +currentTime.toFixed(0);
                this.audioSliderFormControl.setValue(fixedCurrentTime);
                return DateUtilities.getElapsedTime(fixedCurrentTime);
            }));
            return this.audio;
        }))).pipe(finalize(() => {
            this.isLoading = false;
        }));
    }
}
CallRecordingAudioPlayerComponent.ɵfac = function CallRecordingAudioPlayerComponent_Factory(t) { return new (t || CallRecordingAudioPlayerComponent)(i0.ɵɵdirectiveInject(i1.AgentCallRecordingHttpService), i0.ɵɵdirectiveInject(i1.FileDownloadUtilityService), i0.ɵɵdirectiveInject(AgentCallRecordingFacade), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(AnalyticsService)); };
CallRecordingAudioPlayerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CallRecordingAudioPlayerComponent, selectors: [["vnext-call-recording-audio-player"]], inputs: { callRecord: "callRecord", pacificStandardTimeText: "pacificStandardTimeText", showVerticalPadding: "showVerticalPadding", isEnrollmentCardDetail: "isEnrollmentCardDetail" }, decls: 11, vars: 21, consts: [[1, "row", "m-0", 3, "ngClass"], [1, "col-12", "order-1", "pl-0", 3, "ngClass"], [1, "Spa_Style_Link"], ["role", "button", "tabindex", "0", 1, "can-click", "d-flex", "align-items-baseline", "text-break", 3, "click", "keyup.enter"], [1, "Spa_Style_Smaller_Font", "fa-file-audio", "fas", "pr-1", "ng-star-inserted"], ["class", "order-3 order-md-3 Spa_Style_Gray4_Color Spa_Style_Smaller_Font pr-0 col-4", 3, "ngClass", 4, "ngIf"], [1, "order-4", "order-md-4", "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font", "pr-0", "col-8", 3, "ngClass"], ["class", "col-12 col-md-6 order-2 order-md-5 Spa_Style_Gray4_Color Spa_Style_Smaller_Font", 3, "ngClass", 4, "ngIf"], [1, "order-3", "order-md-3", "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font", "pr-0", "col-4", 3, "ngClass"], [1, "col-12", "col-md-6", "order-2", "order-md-5", "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font", 3, "ngClass"], [1, "d-flex", "align-items-center", 3, "ngClass"], [1, "Spa_Style_Link", "text-decoration-none", "audio-controls", "d-flex", 3, "click"], ["class", "fas fa-play-circle", 4, "ngIf", "ngIfElse"], ["playing", ""], [1, "time", "flex-grow-2"], [1, "d-flex"], ["type", "text", "vnextRangeSlider", "", "name", "audioSlider", 3, "maxValue", "formControl", "positionChange"], [1, "time"], [1, "fas", "fa-play-circle"], [1, "fas", "fa-stop-circle"]], template: function CallRecordingAudioPlayerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "a", 3);
        i0.ɵɵlistener("click", function CallRecordingAudioPlayerComponent_Template_a_click_3_listener() { return ctx.download(); })("keyup.enter", function CallRecordingAudioPlayerComponent_Template_a_keyup_enter_3_listener() { return ctx.download(); });
        i0.ɵɵelement(4, "i", 4);
        i0.ɵɵelementStart(5, "span");
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵtemplate(7, CallRecordingAudioPlayerComponent_div_7_Template, 2, 6, "div", 5);
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, CallRecordingAudioPlayerComponent_div_10_Template, 13, 15, "div", 7);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c3$j, ctx.showVerticalPadding));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction5(9, _c4$a, ctx.isPlayAudioRecording && !ctx.callRecordingFileDurationEnabled, !ctx.isPlayAudioRecording && !ctx.callRecordingFileDurationEnabled, ctx.isPlayAudioRecording && ctx.callRecordingFileDurationEnabled, !ctx.isPlayAudioRecording && ctx.callRecordingFileDurationEnabled, ctx.showVerticalPadding));
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.callRecord.recordingName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.callRecordingFileDurationEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction5(15, _c5$7, ctx.showVerticalPadding, ctx.isEnrollmentCardDetail, !ctx.isEnrollmentCardDetail, ctx.callRecordingFileDurationEnabled, ctx.isPlayAudioRecording && !ctx.isEnrollmentCardDetail));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.formattedDate, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isPlayAudioRecording);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.DefaultValueAccessor, i4.NgControlStatus, i4.FormControlDirective, IconAriaAttributesDirective, RangeSliderDirective, i1$2.AsyncPipe], styles: [".audio-controls[_ngcontent-%COMP%]{cursor:pointer}.time[_ngcontent-%COMP%]{width:50px;text-align:center}.slider[_ngcontent-%COMP%]{-webkit-appearance:none;width:100%;background:var(--static-Spa_Style_Accent1);outline:none;transition:opacity .2s;margin:0;opacity:1;height:4px;z-index:2}.slider[_ngcontent-%COMP%]::-webkit-slider-thumb{appearance:none;cursor:pointer;content:\"\";background:white;height:16px;width:16px;border-radius:100%;border:1px var(--static-Spa_Style_Gray2);border-style:solid;top:0;box-shadow:0 1px 5px #00000040;z-index:20;-webkit-transition:all .2s;transition:all .2s}.slider[_ngcontent-%COMP%]::-moz-range-thumb{appearance:none;cursor:pointer;content:\"\";background:white;height:32px;width:32px;border-radius:100%;top:0;box-shadow:0 2px 5px #00000040;z-index:10;-moz-transition:all .2s;transition:all .2s}.slider[_ngcontent-%COMP%]::-ms-thumb{appearance:none;cursor:pointer;content:\"\";background:white;height:32px;width:32px;border-radius:100%;top:0;box-shadow:0 2px 5px #00000040;z-index:10;-ms-transition:all .2s;transition:all .2s}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CallRecordingAudioPlayerComponent, [{
        type: Component,
        args: [{ selector: 'vnext-call-recording-audio-player', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row m-0\" [ngClass]=\"{ 'py-3 py-md-4': showVerticalPadding }\">\r\n  <div\r\n    class=\"col-12 order-1 pl-0\"\r\n    [ngClass]=\"{\r\n      'col-md-5': isPlayAudioRecording && !callRecordingFileDurationEnabled,\r\n      'col-md-9': !isPlayAudioRecording && !callRecordingFileDurationEnabled,\r\n      'col-md-12': isPlayAudioRecording && callRecordingFileDurationEnabled,\r\n      'col-md-8': !isPlayAudioRecording && callRecordingFileDurationEnabled,\r\n      'py-1': showVerticalPadding\r\n    }\"\r\n  >\r\n    <div class=\"Spa_Style_Link\">\r\n      <a\r\n        class=\"can-click d-flex align-items-baseline text-break\"\r\n        role=\"button\"\r\n        tabindex=\"0\"\r\n        (click)=\"download()\"\r\n        (keyup.enter)=\"download()\"\r\n      >\r\n        <i class=\"Spa_Style_Smaller_Font fa-file-audio fas pr-1 ng-star-inserted\"></i>\r\n        <span>{{ callRecord.recordingName }}</span>\r\n      </a>\r\n    </div>\r\n  </div>\r\n\r\n  <div\r\n    *ngIf=\"callRecordingFileDurationEnabled\"\r\n    class=\"order-3 order-md-3 Spa_Style_Gray4_Color Spa_Style_Smaller_Font pr-0 col-4\"\r\n    [ngClass]=\"{\r\n      'py-1': showVerticalPadding,\r\n      'col-md-6': isEnrollmentCardDetail,\r\n      'col-md-1': !isEnrollmentCardDetail\r\n    }\"\r\n  >\r\n    {{ callDuration }}\r\n  </div>\r\n\r\n  <div\r\n    class=\"order-4 order-md-4 Spa_Style_Gray4_Color Spa_Style_Smaller_Font pr-0 col-8\"\r\n    [ngClass]=\"{\r\n      'py-1': showVerticalPadding,\r\n      'col-md-6': isEnrollmentCardDetail,\r\n      'col-md-3': !isEnrollmentCardDetail,\r\n      'text-right': callRecordingFileDurationEnabled,\r\n      'text-md-left': isPlayAudioRecording && !isEnrollmentCardDetail\r\n    }\"\r\n  >\r\n    {{ formattedDate }}\r\n  </div>\r\n\r\n  <div\r\n    *ngIf=\"isPlayAudioRecording\"\r\n    class=\"col-12 col-md-6 order-2 order-md-5 Spa_Style_Gray4_Color Spa_Style_Smaller_Font\"\r\n    [ngClass]=\"{\r\n      'pl-0': isEnrollmentCardDetail\r\n    }\"\r\n  >\r\n    <div\r\n      class=\"d-flex align-items-center\"\r\n      [ngClass]=\"{\r\n        'pt-1': showVerticalPadding\r\n      }\"\r\n    >\r\n      <span (click)=\"togglePlayStop()\" class=\"Spa_Style_Link text-decoration-none audio-controls d-flex\">\r\n        <i *ngIf=\"!audio || audio.paused; else playing\" class=\"fas fa-play-circle\"></i>\r\n        <ng-template #playing>\r\n          <i class=\"fas fa-stop-circle\"></i>\r\n        </ng-template>\r\n      </span>\r\n      <span class=\"time flex-grow-2\">{{ (elapsedTime$ | async) || DEFAULT_START_TIME }}</span>\r\n      <div class=\"d-flex\">\r\n        <input\r\n          type=\"text\"\r\n          vnextRangeSlider\r\n          name=\"audioSlider\"\r\n          [maxValue]=\"callRecord.callDuration\"\r\n          [formControl]=\"audioSliderFormControl\"\r\n          [attr.aria-label]=\"callDuration\"\r\n          (positionChange)=\"onPositionChange($event)\"\r\n        />\r\n      </div>\r\n      <span class=\"time\">\r\n        {{ callDuration }}\r\n      </span>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".audio-controls{cursor:pointer}.time{width:50px;text-align:center}.slider{-webkit-appearance:none;width:100%;background:var(--static-Spa_Style_Accent1);outline:none;transition:opacity .2s;margin:0;opacity:1;height:4px;z-index:2}.slider::-webkit-slider-thumb{appearance:none;cursor:pointer;content:\"\";background:white;height:16px;width:16px;border-radius:100%;border:1px var(--static-Spa_Style_Gray2);border-style:solid;top:0;box-shadow:0 1px 5px #00000040;z-index:20;-webkit-transition:all .2s;transition:all .2s}.slider::-moz-range-thumb{appearance:none;cursor:pointer;content:\"\";background:white;height:32px;width:32px;border-radius:100%;top:0;box-shadow:0 2px 5px #00000040;z-index:10;-moz-transition:all .2s;transition:all .2s}.slider::-ms-thumb{appearance:none;cursor:pointer;content:\"\";background:white;height:32px;width:32px;border-radius:100%;top:0;box-shadow:0 2px 5px #00000040;z-index:10;-ms-transition:all .2s;transition:all .2s}\n"] }]
    }], function () { return [{ type: i1.AgentCallRecordingHttpService }, { type: i1.FileDownloadUtilityService }, { type: AgentCallRecordingFacade }, { type: i0.ChangeDetectorRef }, { type: AnalyticsService }]; }, { callRecord: [{
            type: Input
        }], pacificStandardTimeText: [{
            type: Input
        }], showVerticalPadding: [{
            type: Input
        }], isEnrollmentCardDetail: [{
            type: Input
        }] }); })();

function EnrollmentCardDetailsComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "button", 5)(2, "p", 6);
    i0.ɵɵtext(3);
    i0.ɵɵelement(4, "i", 7);
    i0.ɵɵelementStart(5, "span", 8);
    i0.ɵɵtext(6, "Collapse");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.enrollmentMoreDetailsText, " ");
} }
function EnrollmentCardDetailsComponent_ng_template_4_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.enrollmentStatus.statusDate, " ");
} }
function EnrollmentCardDetailsComponent_ng_template_4_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "h5", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 12)(4, "div", 13)(5, "div", 14);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, EnrollmentCardDetailsComponent_ng_template_4_div_0_div_7_Template, 2, 1, "div", 15);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.enrollmentStatusHeaderText, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r3.enrollmentStatus.status);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.enrollmentStatus.statusDate);
} }
function EnrollmentCardDetailsComponent_ng_template_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "h5", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 12)(4, "button", 16);
    i0.ɵɵlistener("click", function EnrollmentCardDetailsComponent_ng_template_4_div_1_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.clickCompleteEnrollmentHRA.emit()); })("keyup.enter", function EnrollmentCardDetailsComponent_ng_template_4_div_1_Template_button_keyup_enter_4_listener() { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r15.clickCompleteEnrollmentHRA.emit()); });
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.enrollmentHraHeaderText, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r4.completeHRAButtonText);
} }
function EnrollmentCardDetailsComponent_ng_template_4_div_2_h5_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.hraEnrollmentConfirmationNumber, " ");
} }
function EnrollmentCardDetailsComponent_ng_template_4_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20)(1, "vnext-link", 21);
    i0.ɵɵlistener("click", function EnrollmentCardDetailsComponent_ng_template_4_div_2_div_5_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r18.generateHRAPDF.emit()); })("keyup.enter", function EnrollmentCardDetailsComponent_ng_template_4_div_2_div_5_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r19); const ctx_r20 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r20.generateHRAPDF.emit()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("additionalIcon", "fa fa-file-pdf d-inline-block")("title", ctx_r17.hraPDFLinkText)("titleClass", "d-inline-block w-75 align-top Spa_Style_Link");
} }
function EnrollmentCardDetailsComponent_ng_template_4_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "h5", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 12);
    i0.ɵɵtemplate(4, EnrollmentCardDetailsComponent_ng_template_4_div_2_h5_4_Template, 2, 1, "h5", 17);
    i0.ɵɵtemplate(5, EnrollmentCardDetailsComponent_ng_template_4_div_2_div_5_Template, 2, 3, "div", 18);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.hraConfirmationText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.hraConfirmationNumberEnabled && ctx_r5.hraEnrollmentConfirmationNumber);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.canDisplayDocuments && ctx_r5.isHRAPDFAccessEnabled && !ctx_r5.isCarrierExcluded && ctx_r5.isHRAPDFEnabledForProfileAdmin);
} }
function EnrollmentCardDetailsComponent_ng_template_4_div_3_vnext_vbc_confirmation_section_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-vbc-confirmation-section", 24);
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("messageText", ctx_r21.valueBasedCareProviders[ctx_r21.npi].confirmationMessageText)("primaryButtonText", ctx_r21.valueBasedCareProviders[ctx_r21.npi].primaryButtonText)("secondaryButtonText", ctx_r21.valueBasedCareProviders[ctx_r21.npi].secondaryButtonText)("primaryButtonLink", ctx_r21.valueBasedCareProviders[ctx_r21.npi].primaryButtonURL)("secondaryButtonLink", ctx_r21.valueBasedCareProviders[ctx_r21.npi].secondaryButtonURL)("isEnrollmentDetail", true);
} }
function EnrollmentCardDetailsComponent_ng_template_4_div_3_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r22.pcpName);
} }
function EnrollmentCardDetailsComponent_ng_template_4_div_3_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r23.vbcOrgName);
} }
function EnrollmentCardDetailsComponent_ng_template_4_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "h5", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 12);
    i0.ɵɵtemplate(4, EnrollmentCardDetailsComponent_ng_template_4_div_3_vnext_vbc_confirmation_section_4_Template, 1, 6, "vnext-vbc-confirmation-section", 22);
    i0.ɵɵelementStart(5, "div", 19);
    i0.ɵɵtemplate(6, EnrollmentCardDetailsComponent_ng_template_4_div_3_div_6_Template, 2, 1, "div", 23);
    i0.ɵɵtemplate(7, EnrollmentCardDetailsComponent_ng_template_4_div_3_div_7_Template, 2, 1, "div", 23);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.valueBasedCareConfirmationText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r6.vbcExpired);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r6.pcpName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.vbcOrgName);
} }
function EnrollmentCardDetailsComponent_ng_template_4_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "h5", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 12)(4, "h5", 19);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.enrollmentConfirmationHeaderText, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.enrollmentConfirmationNumber, " ");
} }
function EnrollmentCardDetailsComponent_ng_template_4_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "h5", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 12)(4, "h5", 19);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.memberEnrollmentEffectiveDateHeaderText, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r8.memberEnrollmentEffectiveDate);
} }
function EnrollmentCardDetailsComponent_ng_template_4_div_6_h5_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rider_r25 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(rider_r25);
} }
function EnrollmentCardDetailsComponent_ng_template_4_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "h5", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 12);
    i0.ɵɵtemplate(4, EnrollmentCardDetailsComponent_ng_template_4_div_6_h5_4_Template, 3, 1, "h5", 25);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.riderHeaderText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r9.memberRiders);
} }
function EnrollmentCardDetailsComponent_ng_template_4_div_7_vnext_call_recording_audio_player_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-call-recording-audio-player", 28);
} if (rf & 2) {
    const callRecord_r27 = ctx.$implicit;
    const ctx_r26 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("callRecord", callRecord_r27)("pacificStandardTimeText", ctx_r26.pacificStandardTimeText)("isEnrollmentCardDetail", ctx_r26.isEnrollmentCardDetail)("showVerticalPadding", ctx_r26.showVerticalPadding);
} }
function EnrollmentCardDetailsComponent_ng_template_4_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "h5", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 12)(4, "div");
    i0.ɵɵtemplate(5, EnrollmentCardDetailsComponent_ng_template_4_div_7_vnext_call_recording_audio_player_5_Template, 1, 4, "vnext-call-recording-audio-player", 27);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.callRecordingHeaderText, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r10.agentCallRecords);
} }
function EnrollmentCardDetailsComponent_ng_template_4_div_8_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20)(1, "vnext-link", 21);
    i0.ɵɵlistener("click", function EnrollmentCardDetailsComponent_ng_template_4_div_8_div_4_Template_vnext_link_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r31); const memberFile_r29 = restoredCtx.$implicit; const ctx_r30 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r30.openDocument.emit(memberFile_r29)); })("keyup.enter", function EnrollmentCardDetailsComponent_ng_template_4_div_8_div_4_Template_vnext_link_keyup_enter_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r31); const memberFile_r29 = restoredCtx.$implicit; const ctx_r32 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r32.openDocument.emit(memberFile_r29)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const memberFile_r29 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("additionalIcon", "fa fa-file-alt d-inline-block")("title", memberFile_r29.name)("titleClass", "d-inline-block w-75 align-top Spa_Style_Link");
} }
function EnrollmentCardDetailsComponent_ng_template_4_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "h5", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 12);
    i0.ɵɵtemplate(4, EnrollmentCardDetailsComponent_ng_template_4_div_8_div_4_Template, 2, 3, "div", 29);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r11.uploadDocumentHeaderText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r11.memberEnrollmentFiles);
} }
function EnrollmentCardDetailsComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, EnrollmentCardDetailsComponent_ng_template_4_div_0_Template, 8, 3, "div", 9);
    i0.ɵɵtemplate(1, EnrollmentCardDetailsComponent_ng_template_4_div_1_Template, 7, 2, "div", 9);
    i0.ɵɵtemplate(2, EnrollmentCardDetailsComponent_ng_template_4_div_2_Template, 6, 3, "div", 9);
    i0.ɵɵtemplate(3, EnrollmentCardDetailsComponent_ng_template_4_div_3_Template, 8, 4, "div", 9);
    i0.ɵɵtemplate(4, EnrollmentCardDetailsComponent_ng_template_4_div_4_Template, 6, 2, "div", 9);
    i0.ɵɵtemplate(5, EnrollmentCardDetailsComponent_ng_template_4_div_5_Template, 6, 2, "div", 9);
    i0.ɵɵtemplate(6, EnrollmentCardDetailsComponent_ng_template_4_div_6_Template, 5, 2, "div", 9);
    i0.ɵɵtemplate(7, EnrollmentCardDetailsComponent_ng_template_4_div_7_Template, 6, 2, "div", 9);
    i0.ɵɵtemplate(8, EnrollmentCardDetailsComponent_ng_template_4_div_8_Template, 5, 2, "div", 9);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.enrollmentStatus == null ? null : ctx_r1.enrollmentStatus.status);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.isHRAEnabled && ctx_r1.isCompleteHRAEnabledForAdmin);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.hraConfirmationNumberEnabled && ctx_r1.hraEnrollmentConfirmationNumber || ctx_r1.canDisplayDocuments && ctx_r1.showHRAPDFLink);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.valueBasedCareConfirmationEnabled && (ctx_r1.valueBasedCareProviders == null ? null : ctx_r1.valueBasedCareProviders[ctx_r1.npi] == null ? null : ctx_r1.valueBasedCareProviders[ctx_r1.npi]["vbcid"]));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.confirmationNumberEnabled && ctx_r1.enrollmentConfirmationNumber);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showEffectiveDate && ctx_r1.memberEnrollmentEffectiveDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.ridersEnabled && (ctx_r1.memberRiders == null ? null : ctx_r1.memberRiders.length));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.agentCallRecords == null ? null : ctx_r1.agentCallRecords.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.canDisplayDocuments && (ctx_r1.memberEnrollmentFiles == null ? null : ctx_r1.memberEnrollmentFiles.length));
} }
let EnrollmentCardDetailsComponent = class EnrollmentCardDetailsComponent {
    constructor() {
        this.generateHRAPDF = new EventEmitter();
        this.openDocument = new EventEmitter();
        this.clickCompleteEnrollmentHRA = new EventEmitter();
        this.isEnrollmentCardDetail = true;
        this.showVerticalPadding = false;
        this.isHRAPDFAccessEnabled = true;
        this.isCarrierExcluded = false;
        this.isCompleteHRAEnabledForAdmin = false;
        this.isHRAPDFEnabledForProfileAdmin = false;
    }
};
EnrollmentCardDetailsComponent.ɵfac = function EnrollmentCardDetailsComponent_Factory(t) { return new (t || EnrollmentCardDetailsComponent)(); };
EnrollmentCardDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EnrollmentCardDetailsComponent, selectors: [["vnext-enrollment-card-details"]], inputs: { enrollmentMoreDetailsText: "enrollmentMoreDetailsText", enrollmentStatusHeaderText: "enrollmentStatusHeaderText", enrollmentStatus: "enrollmentStatus", isHRAEnabled: "isHRAEnabled", completeHRAButtonEnabled: "completeHRAButtonEnabled", showCompleteHRASection: "showCompleteHRASection", enrollmentHraHeaderText: "enrollmentHraHeaderText", completeHRAButtonText: "completeHRAButtonText", confirmationNumberEnabled: "confirmationNumberEnabled", enrollmentConfirmationHeaderText: "enrollmentConfirmationHeaderText", enrollmentConfirmationNumber: "enrollmentConfirmationNumber", hraConfirmationNumberEnabled: "hraConfirmationNumberEnabled", hraConfirmationText: "hraConfirmationText", hraEnrollmentConfirmationNumber: "hraEnrollmentConfirmationNumber", showEffectiveDate: "showEffectiveDate", memberEnrollmentEffectiveDateHeaderText: "memberEnrollmentEffectiveDateHeaderText", memberEnrollmentEffectiveDate: "memberEnrollmentEffectiveDate", ridersEnabled: "ridersEnabled", riderHeaderText: "riderHeaderText", memberRiders: "memberRiders", callRecordingHeaderText: "callRecordingHeaderText", agentCallRecords: "agentCallRecords", pacificStandardTimeText: "pacificStandardTimeText", uploadDocumentHeaderText: "uploadDocumentHeaderText", canDisplayDocuments: "canDisplayDocuments", memberEnrollmentFiles: "memberEnrollmentFiles", showHRAPDFLink: "showHRAPDFLink", hraPDFLinkText: "hraPDFLinkText", valueBasedCareConfirmationEnabled: "valueBasedCareConfirmationEnabled", valueBasedCareConfirmationText: "valueBasedCareConfirmationText", npi: "npi", pcpName: "pcpName", vbcOrgName: "vbcOrgName", valueBasedCareProviders: "valueBasedCareProviders", vbcExpired: "vbcExpired", isHRAPDFAccessEnabled: "isHRAPDFAccessEnabled", isCarrierExcluded: "isCarrierExcluded", isCompleteHRAEnabledForAdmin: "isCompleteHRAEnabledForAdmin", isHRAPDFEnabledForProfileAdmin: "isHRAPDFEnabledForProfileAdmin" }, outputs: { generateHRAPDF: "generateHRAPDF", openDocument: "openDocument", clickCompleteEnrollmentHRA: "clickCompleteEnrollmentHRA" }, features: [i0.ɵɵProvidersFeature([WidgetService])], decls: 5, vars: 0, consts: [[1, "plan-details-accordion", "accordion-container", "w-100"], [1, "card-header"], ["ngbPanelHeader", ""], ["ngbPanelContent", ""], [1, "row", "Spa_Style_Gray1_Background"], ["ngbPanelToggle", "", 1, "btn", "btn-expand", "container-fluid", "col-12", "px-4"], [1, "m-0", "Spa_Style_Bold_Weight", "Spa_Style_Primary_Color", "float-right"], [1, "fas", "fa-chevron-up", "pt-1", "pl-1"], [1, "sr-only"], ["class", "row mx-0 enrollment-details-section-min-height", 4, "ngIf"], [1, "row", "mx-0", "enrollment-details-section-min-height"], [1, "Spa_Style_H5", "enrollment-details-section-left", "m-0", "col-4", "Spa_Style_Gray1_Background"], [1, "enrollment-details-section-right", "col-8"], [1, "row"], [1, "col-lg-12", "Spa_Style_H5"], ["class", "col-lg-12 Spa_Style_H5", 4, "ngIf"], [1, "btn", "Spa_Style_SecondaryButton", "col-xs-12", "col-lg-auto", "ml-0", "ml-lg-2", "mt-2", "mt-lg-0", 3, "click", "keyup.enter"], ["class", "Spa_Style_H5", 4, "ngIf"], ["class", "Spa_Style_Primary_Link enrollment-files-wrapper", 4, "ngIf"], [1, "Spa_Style_H5"], [1, "Spa_Style_Primary_Link", "enrollment-files-wrapper"], [3, "additionalIcon", "title", "titleClass", "click", "keyup.enter"], [3, "messageText", "primaryButtonText", "secondaryButtonText", "primaryButtonLink", "secondaryButtonLink", "isEnrollmentDetail", 4, "ngIf"], [4, "ngIf"], [3, "messageText", "primaryButtonText", "secondaryButtonText", "primaryButtonLink", "secondaryButtonLink", "isEnrollmentDetail"], ["class", "d-inline Spa_Style_H5 mr-1", 4, "ngFor", "ngForOf"], [1, "d-inline", "Spa_Style_H5", "mr-1"], [3, "callRecord", "pacificStandardTimeText", "isEnrollmentCardDetail", "showVerticalPadding", 4, "ngFor", "ngForOf"], [3, "callRecord", "pacificStandardTimeText", "isEnrollmentCardDetail", "showVerticalPadding"], ["class", "Spa_Style_Primary_Link enrollment-files-wrapper", 4, "ngFor", "ngForOf"]], template: function EnrollmentCardDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "ngb-accordion")(2, "ngb-panel", 1);
        i0.ɵɵtemplate(3, EnrollmentCardDetailsComponent_ng_template_3_Template, 7, 1, "ng-template", 2);
        i0.ɵɵtemplate(4, EnrollmentCardDetailsComponent_ng_template_4_Template, 9, 9, "ng-template", 3);
        i0.ɵɵelementEnd()()();
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, LinkComponent, IconAriaAttributesDirective, i1$1.NgbAccordion, i1$1.NgbPanel, i1$1.NgbPanelContent, i1$1.NgbPanelHeader, i1$1.NgbPanelToggle, EnrollmentConfirmationVBCSectionComponent, CallRecordingAudioPlayerComponent], styles: [".plan-details-accordion[_ngcontent-%COMP%]   .fa-chevron-up[_ngcontent-%COMP%]:before{content:\"\\f077\";font-size:16px}.plan-details-accordion[_ngcontent-%COMP%]   .collapsed[_ngcontent-%COMP%]   .fa-chevron-up[_ngcontent-%COMP%]:before{content:\"\\f078\"}.enrollment-details-section-min-height[_ngcontent-%COMP%]{min-height:60px}.gray1-static[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray1)}.enrollment-details-section-left[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-width:1px 1px 0px 0px;padding:15px 0 15px 10px}.enrollment-details-section-right[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-width:1px 0px 0px 0px;padding:15px 5px 15px 10px}.btn-expand[_ngcontent-%COMP%]:focus{outline:none!important;box-shadow:none!important}.btn-expand[_ngcontent-%COMP%]{border:none}"], changeDetection: 0 });
EnrollmentCardDetailsComponent = __decorate([
    PlatformWidget
], EnrollmentCardDetailsComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnrollmentCardDetailsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-enrollment-card-details', providers: [WidgetService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"plan-details-accordion accordion-container w-100\">\r\n  <ngb-accordion>\r\n    <ngb-panel class=\"card-header\">\r\n      <ng-template ngbPanelHeader let-opened=\"closed\">\r\n        <div class=\"row Spa_Style_Gray1_Background\">\r\n          <button ngbPanelToggle class=\"btn btn-expand container-fluid col-12 px-4\">\r\n            <p class=\"m-0 Spa_Style_Bold_Weight Spa_Style_Primary_Color float-right\">\r\n              {{ enrollmentMoreDetailsText }}\r\n              <i class=\"fas fa-chevron-up pt-1 pl-1\"></i>\r\n              <span class=\"sr-only\">Collapse</span>\r\n            </p>\r\n          </button>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template ngbPanelContent>\r\n        <div class=\"row mx-0 enrollment-details-section-min-height\" *ngIf=\"enrollmentStatus?.status\">\r\n          <h5 class=\"Spa_Style_H5 enrollment-details-section-left m-0 col-4 Spa_Style_Gray1_Background\">\r\n            {{ enrollmentStatusHeaderText }}\r\n          </h5>\r\n          <div class=\"enrollment-details-section-right col-8\">\r\n            <div class=\"row\">\r\n              <div class=\"col-lg-12 Spa_Style_H5\">{{ enrollmentStatus.status }}</div>\r\n              <div *ngIf=\"enrollmentStatus.statusDate\" class=\"col-lg-12 Spa_Style_H5\">\r\n                {{ enrollmentStatus.statusDate }}\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row mx-0 enrollment-details-section-min-height\" *ngIf=\"isHRAEnabled && isCompleteHRAEnabledForAdmin\">\r\n          <h5 class=\"Spa_Style_H5 enrollment-details-section-left m-0 col-4 Spa_Style_Gray1_Background\">\r\n            {{ enrollmentHraHeaderText }}\r\n          </h5>\r\n          <div class=\"enrollment-details-section-right col-8\">\r\n            <button\r\n              class=\"btn Spa_Style_SecondaryButton col-xs-12 col-lg-auto ml-0 ml-lg-2 mt-2 mt-lg-0\"\r\n              (click)=\"clickCompleteEnrollmentHRA.emit()\"\r\n              (keyup.enter)=\"clickCompleteEnrollmentHRA.emit()\"\r\n            >\r\n              <span>{{ completeHRAButtonText }}</span>\r\n            </button>\r\n          </div>\r\n        </div>\r\n        <div\r\n          class=\"row mx-0 enrollment-details-section-min-height\"\r\n          *ngIf=\"(hraConfirmationNumberEnabled && hraEnrollmentConfirmationNumber) || (canDisplayDocuments && showHRAPDFLink)\"\r\n        >\r\n          <h5 class=\"Spa_Style_H5 enrollment-details-section-left m-0 col-4 Spa_Style_Gray1_Background\">\r\n            {{ hraConfirmationText }}\r\n          </h5>\r\n          <div class=\"enrollment-details-section-right col-8\">\r\n            <h5 class=\"Spa_Style_H5\" *ngIf=\"hraConfirmationNumberEnabled && hraEnrollmentConfirmationNumber\">\r\n              {{ hraEnrollmentConfirmationNumber }}\r\n            </h5>\r\n            <div\r\n              *ngIf=\"canDisplayDocuments && isHRAPDFAccessEnabled && !isCarrierExcluded && isHRAPDFEnabledForProfileAdmin\"\r\n              class=\"Spa_Style_Primary_Link enrollment-files-wrapper\"\r\n            >\r\n              <vnext-link\r\n                (click)=\"generateHRAPDF.emit()\"\r\n                (keyup.enter)=\"generateHRAPDF.emit()\"\r\n                [additionalIcon]=\"'fa fa-file-pdf d-inline-block'\"\r\n                [title]=\"hraPDFLinkText\"\r\n                [titleClass]=\"'d-inline-block w-75 align-top Spa_Style_Link'\"\r\n              ></vnext-link>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div\r\n          class=\"row mx-0 enrollment-details-section-min-height\"\r\n          *ngIf=\"valueBasedCareConfirmationEnabled && valueBasedCareProviders?.[npi]?.['vbcid']\"\r\n        >\r\n          <h5 class=\"Spa_Style_H5 enrollment-details-section-left m-0 col-4 Spa_Style_Gray1_Background\">\r\n            {{ valueBasedCareConfirmationText }}\r\n          </h5>\r\n          <div class=\"enrollment-details-section-right col-8\">\r\n            <vnext-vbc-confirmation-section\r\n              *ngIf=\"vbcExpired\"\r\n              [messageText]=\"valueBasedCareProviders[npi].confirmationMessageText\"\r\n              [primaryButtonText]=\"valueBasedCareProviders[npi].primaryButtonText\"\r\n              [secondaryButtonText]=\"valueBasedCareProviders[npi].secondaryButtonText\"\r\n              [primaryButtonLink]=\"valueBasedCareProviders[npi].primaryButtonURL\"\r\n              [secondaryButtonLink]=\"valueBasedCareProviders[npi].secondaryButtonURL\"\r\n              [isEnrollmentDetail]=\"true\"\r\n            ></vnext-vbc-confirmation-section>\r\n            <div class=\"Spa_Style_H5\">\r\n              <div *ngIf=\"pcpName\">{{ pcpName }}</div>\r\n              <div *ngIf=\"vbcOrgName\">{{ vbcOrgName }}</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row mx-0 enrollment-details-section-min-height\" *ngIf=\"confirmationNumberEnabled && enrollmentConfirmationNumber\">\r\n          <h5 class=\"Spa_Style_H5 enrollment-details-section-left m-0 col-4 Spa_Style_Gray1_Background\">\r\n            {{ enrollmentConfirmationHeaderText }}\r\n          </h5>\r\n          <div class=\"enrollment-details-section-right col-8\">\r\n            <h5 class=\"Spa_Style_H5\">\r\n              {{ enrollmentConfirmationNumber }}\r\n            </h5>\r\n          </div>\r\n        </div>\r\n        <div class=\"row mx-0 enrollment-details-section-min-height\" *ngIf=\"showEffectiveDate && memberEnrollmentEffectiveDate\">\r\n          <h5 class=\"Spa_Style_H5 enrollment-details-section-left m-0 col-4 Spa_Style_Gray1_Background\">\r\n            {{ memberEnrollmentEffectiveDateHeaderText }}\r\n          </h5>\r\n          <div class=\"enrollment-details-section-right col-8\">\r\n            <h5 class=\"Spa_Style_H5\">{{ memberEnrollmentEffectiveDate }}</h5>\r\n          </div>\r\n        </div>\r\n        <div class=\"row mx-0 enrollment-details-section-min-height\" *ngIf=\"ridersEnabled && memberRiders?.length\">\r\n          <h5 class=\"Spa_Style_H5 enrollment-details-section-left m-0 col-4 Spa_Style_Gray1_Background\">\r\n            {{ riderHeaderText }}\r\n          </h5>\r\n          <div class=\"enrollment-details-section-right col-8\">\r\n            <h5 *ngFor=\"let rider of memberRiders\" class=\"d-inline Spa_Style_H5 mr-1\">{{ rider }}<br /></h5>\r\n          </div>\r\n        </div>\r\n        <div class=\"row mx-0 enrollment-details-section-min-height\" *ngIf=\"agentCallRecords?.length\">\r\n          <h5 class=\"Spa_Style_H5 enrollment-details-section-left m-0 col-4 Spa_Style_Gray1_Background\">\r\n            {{ callRecordingHeaderText }}\r\n          </h5>\r\n          <div class=\"enrollment-details-section-right col-8\">\r\n            <div>\r\n              <vnext-call-recording-audio-player\r\n                *ngFor=\"let callRecord of agentCallRecords\"\r\n                [callRecord]=\"callRecord\"\r\n                [pacificStandardTimeText]=\"pacificStandardTimeText\"\r\n                [isEnrollmentCardDetail]=\"isEnrollmentCardDetail\"\r\n                [showVerticalPadding]=\"showVerticalPadding\"\r\n              ></vnext-call-recording-audio-player>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row mx-0 enrollment-details-section-min-height\" *ngIf=\"canDisplayDocuments && memberEnrollmentFiles?.length\">\r\n          <h5 class=\"Spa_Style_H5 enrollment-details-section-left m-0 col-4 Spa_Style_Gray1_Background\">\r\n            {{ uploadDocumentHeaderText }}\r\n          </h5>\r\n          <div class=\"enrollment-details-section-right col-8\">\r\n            <div *ngFor=\"let memberFile of memberEnrollmentFiles\" class=\"Spa_Style_Primary_Link enrollment-files-wrapper\">\r\n              <vnext-link\r\n                (click)=\"openDocument.emit(memberFile)\"\r\n                (keyup.enter)=\"openDocument.emit(memberFile)\"\r\n                [additionalIcon]=\"'fa fa-file-alt d-inline-block'\"\r\n                [title]=\"memberFile.name\"\r\n                [titleClass]=\"'d-inline-block w-75 align-top Spa_Style_Link'\"\r\n              ></vnext-link>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n    </ngb-panel>\r\n  </ngb-accordion>\r\n</div>\r\n", styles: [".plan-details-accordion .fa-chevron-up:before{content:\"\\f077\";font-size:16px}.plan-details-accordion .collapsed .fa-chevron-up:before{content:\"\\f078\"}.enrollment-details-section-min-height{min-height:60px}.gray1-static{background-color:var(--static-Spa_Style_Gray1)}.enrollment-details-section-left{border:1px solid var(--static-Spa_Style_Accent1);border-width:1px 1px 0px 0px;padding:15px 0 15px 10px}.enrollment-details-section-right{border:1px solid var(--static-Spa_Style_Accent1);border-width:1px 0px 0px 0px;padding:15px 5px 15px 10px}.btn-expand:focus{outline:none!important;box-shadow:none!important}.btn-expand{border:none}\n"] }]
    }], null, { enrollmentMoreDetailsText: [{
            type: Input
        }], enrollmentStatusHeaderText: [{
            type: Input
        }], enrollmentStatus: [{
            type: Input
        }], isHRAEnabled: [{
            type: Input
        }], completeHRAButtonEnabled: [{
            type: Input
        }], showCompleteHRASection: [{
            type: Input
        }], enrollmentHraHeaderText: [{
            type: Input
        }], completeHRAButtonText: [{
            type: Input
        }], confirmationNumberEnabled: [{
            type: Input
        }], enrollmentConfirmationHeaderText: [{
            type: Input
        }], enrollmentConfirmationNumber: [{
            type: Input
        }], hraConfirmationNumberEnabled: [{
            type: Input
        }], hraConfirmationText: [{
            type: Input
        }], hraEnrollmentConfirmationNumber: [{
            type: Input
        }], showEffectiveDate: [{
            type: Input
        }], memberEnrollmentEffectiveDateHeaderText: [{
            type: Input
        }], memberEnrollmentEffectiveDate: [{
            type: Input
        }], ridersEnabled: [{
            type: Input
        }], riderHeaderText: [{
            type: Input
        }], memberRiders: [{
            type: Input
        }], callRecordingHeaderText: [{
            type: Input
        }], agentCallRecords: [{
            type: Input
        }], pacificStandardTimeText: [{
            type: Input
        }], uploadDocumentHeaderText: [{
            type: Input
        }], canDisplayDocuments: [{
            type: Input
        }], memberEnrollmentFiles: [{
            type: Input
        }], showHRAPDFLink: [{
            type: Input
        }], hraPDFLinkText: [{
            type: Input
        }], valueBasedCareConfirmationEnabled: [{
            type: Input
        }], valueBasedCareConfirmationText: [{
            type: Input
        }], npi: [{
            type: Input
        }], pcpName: [{
            type: Input
        }], vbcOrgName: [{
            type: Input
        }], valueBasedCareProviders: [{
            type: Input
        }], vbcExpired: [{
            type: Input
        }], generateHRAPDF: [{
            type: Output
        }], openDocument: [{
            type: Output
        }], clickCompleteEnrollmentHRA: [{
            type: Output
        }], isHRAPDFAccessEnabled: [{
            type: Input
        }], isCarrierExcluded: [{
            type: Input
        }], isCompleteHRAEnabledForAdmin: [{
            type: Input
        }], isHRAPDFEnabledForProfileAdmin: [{
            type: Input
        }] }); })();

function MemberEnrollmentCardComponent_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.memberEnrollmentPlanName, " ");
} }
function MemberEnrollmentCardComponent_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelement(1, "vnext-plan-year-badge", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("planYear", ctx_r5.planYear)("isDualPlanYearActive", ctx_r5.isActivePlanYear);
} }
function MemberEnrollmentCardComponent_div_2_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.memberEnrollmentSubmittedDate, " ");
} }
function MemberEnrollmentCardComponent_div_2_div_8_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 22);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", ctx_r15.confirmationText, " ", ctx_r15.memberEnrollment.confirmationNumber, " ");
} }
function MemberEnrollmentCardComponent_div_2_div_8_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 22);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", ctx_r16.hraConfirmationText, " ", ctx_r16.hraEnrollmentConfirmationNumber, " ");
} }
function MemberEnrollmentCardComponent_div_2_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtemplate(1, MemberEnrollmentCardComponent_div_2_div_8_div_1_Template, 3, 2, "div", 2);
    i0.ɵɵtemplate(2, MemberEnrollmentCardComponent_div_2_div_8_div_2_Template, 3, 2, "div", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.confirmationNumberEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.hraConfirmationNumberEnabled && ctx_r7.hraEnrollmentConfirmationNumber);
} }
function MemberEnrollmentCardComponent_div_2_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23)(1, "vnext-link", 24);
    i0.ɵɵlistener("click", function MemberEnrollmentCardComponent_div_2_div_9_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.viewApplication()); })("keyup.enter", function MemberEnrollmentCardComponent_div_2_div_9_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r18); const ctx_r19 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r19.viewApplication()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("additionalIcon", "fas fa-file-pdf mr-2")("title", ctx_r8.viewApplicationLinkText);
} }
function MemberEnrollmentCardComponent_div_2_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.memberEnrollmentEffectiveDate, " ");
} }
function MemberEnrollmentCardComponent_div_2_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25)(1, "vnext-hra-complete-section", 26);
    i0.ɵɵlistener("clickCompleteEnrollmentHRA", function MemberEnrollmentCardComponent_div_2_div_11_Template_vnext_hra_complete_section_clickCompleteEnrollmentHRA_1_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r20.onClickCompleteEnrollmentHRA()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("completeHRAButtonText", ctx_r10.completeHRAButtonText)("completeHRALastVisitedText", ctx_r10.completeHRALastVisitedText)("completeHRADaysLeftText", ctx_r10.completeHRADaysLeftText)("planHRAType", ctx_r10.planHRAType)("remainingHRADays", ctx_r10.remainingHRADays)("memberHraLastAccessedDate", ctx_r10.memberEnrollment.hraLastAccessedDate);
} }
function MemberEnrollmentCardComponent_div_2_div_12_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30)(1, "vnext-link", 31);
    i0.ɵɵlistener("click", function MemberEnrollmentCardComponent_div_2_div_12_div_1_Template_vnext_link_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r26); const memberFile_r24 = restoredCtx.$implicit; const ctx_r25 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r25.openDocument(memberFile_r24)); })("keyup.enter", function MemberEnrollmentCardComponent_div_2_div_12_div_1_Template_vnext_link_keyup_enter_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r26); const memberFile_r24 = restoredCtx.$implicit; const ctx_r27 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r27.openDocument(memberFile_r24)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const memberFile_r24 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("additionalIcon", "fa fa-file-alt mr-2 d-inline-block")("title", memberFile_r24.name)("titleClass", "d-inline-block w-75 align-top");
} }
function MemberEnrollmentCardComponent_div_2_div_12_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30)(1, "vnext-link", 31);
    i0.ɵɵlistener("click", function MemberEnrollmentCardComponent_div_2_div_12_div_2_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r28.generateHRAPDF()); })("keyup.enter", function MemberEnrollmentCardComponent_div_2_div_12_div_2_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r29); const ctx_r30 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r30.generateHRAPDF()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("additionalIcon", "fa fa-file-pdf mr-2 d-inline-block")("title", ctx_r23.hraPDFLinkText)("titleClass", "d-inline-block w-75 align-top");
} }
function MemberEnrollmentCardComponent_div_2_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtemplate(1, MemberEnrollmentCardComponent_div_2_div_12_div_1_Template, 2, 3, "div", 28);
    i0.ɵɵtemplate(2, MemberEnrollmentCardComponent_div_2_div_12_div_2_Template, 2, 3, "div", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r11.memberEnrollmentFiles);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.showHRAPDFLink);
} }
function MemberEnrollmentCardComponent_div_2_div_13_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rider_r32 = ctx.$implicit;
    const ctx_r31 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r31.getRiderName(rider_r32), " ");
} }
function MemberEnrollmentCardComponent_div_2_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 32);
    i0.ɵɵtemplate(2, MemberEnrollmentCardComponent_div_2_div_13_div_2_Template, 2, 1, "div", 33);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r12.memberRiders);
} }
function MemberEnrollmentCardComponent_div_2_div_14_vnext_call_recording_audio_player_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-call-recording-audio-player", 36);
} if (rf & 2) {
    const callRecord_r34 = ctx.$implicit;
    const ctx_r33 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("callRecord", callRecord_r34)("pacificStandardTimeText", ctx_r33.pacificStandardTimeText);
} }
function MemberEnrollmentCardComponent_div_2_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MemberEnrollmentCardComponent_div_2_div_14_vnext_call_recording_audio_player_1_Template, 1, 2, "vnext-call-recording-audio-player", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r13.agentCallRecords);
} }
const _c0$1C = function (a0, a1) { return { "Spa_Style_Large_Font Spa_Style_Label Spa_Style_Gray4_Color": a0, "Spa_Style_Larger_Font Spa_Style_CostPremiumSmall": a1 }; };
function MemberEnrollmentCardComponent_div_2_div_15_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 41);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c0$1C, ctx_r35.isAccountSummaryPage && !ctx_r35.isCurrentYearEnrollment, !ctx_r35.isAccountSummaryPage || ctx_r35.isCurrentYearEnrollment));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, ctx_r35.memberEnrollmentPremium));
} }
function MemberEnrollmentCardComponent_div_2_div_15_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-plan-fees-tooltip", 42);
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("planFees", ctx_r37.memberEnrollment.fees)("planTotalPremium", ctx_r37.memberEnrollmentPremium)("planFeesTooltipText", ctx_r37.planFeesTooltipText)("planFeesIncludedInPremiumTooltipText", ctx_r37.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r37.planFeesNotIncludedInPremiumTooltipText)("customClass", "inline-block-layout stacked-xs-content stacked-sm-content")("totalPremiumCustomClass", ctx_r37.isCurrentYearEnrollment ? "Spa_Style_Larger_Font" : "Spa_Style_Large_Font Spa_Style_Label Spa_Style_Gray4_Color")("tooltipCustomClass", "stacked-xs-content stacked-sm-content");
} }
const _c1$K = function (a0, a1) { return { Spa_Style_Secondary_Text_Background: a0, Spa_Style_Cost_Background: a1 }; };
const _c2$t = function (a0) { return { Spa_Style_Gray4_Color: a0 }; };
function MemberEnrollmentCardComponent_div_2_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 37)(2, "h4", 38);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, MemberEnrollmentCardComponent_div_2_div_15_span_4_Template, 3, 7, "span", 39);
    i0.ɵɵtemplate(5, MemberEnrollmentCardComponent_div_2_div_15_ng_template_5_Template, 1, 8, "ng-template", null, 40, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r36 = i0.ɵɵreference(6);
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c1$K, ctx_r14.isAccountSummaryPage && !ctx_r14.isCurrentYearEnrollment, !ctx_r14.isAccountSummaryPage || ctx_r14.isCurrentYearEnrollment));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c2$t, ctx_r14.isAccountSummaryPage && !ctx_r14.isCurrentYearEnrollment));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.totalMonthlyPremiumLabel, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r14.planFeesEnabled || !(ctx_r14.memberEnrollment.fees == null ? null : ctx_r14.memberEnrollment.fees.length))("ngIfElse", _r36);
} }
function MemberEnrollmentCardComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 6);
    i0.ɵɵtemplate(2, MemberEnrollmentCardComponent_div_2_div_2_Template, 2, 1, "div", 7);
    i0.ɵɵtemplate(3, MemberEnrollmentCardComponent_div_2_div_3_Template, 2, 2, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 9)(5, "div", 10)(6, "div", 9);
    i0.ɵɵtemplate(7, MemberEnrollmentCardComponent_div_2_div_7_Template, 2, 1, "div", 11);
    i0.ɵɵtemplate(8, MemberEnrollmentCardComponent_div_2_div_8_Template, 3, 2, "div", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(9, MemberEnrollmentCardComponent_div_2_div_9_Template, 2, 2, "div", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, MemberEnrollmentCardComponent_div_2_div_10_Template, 2, 1, "div", 14);
    i0.ɵɵtemplate(11, MemberEnrollmentCardComponent_div_2_div_11_Template, 2, 6, "div", 15);
    i0.ɵɵtemplate(12, MemberEnrollmentCardComponent_div_2_div_12_Template, 3, 2, "div", 16);
    i0.ɵɵtemplate(13, MemberEnrollmentCardComponent_div_2_div_13_Template, 3, 1, "div", 2);
    i0.ɵɵtemplate(14, MemberEnrollmentCardComponent_div_2_div_14_Template, 2, 1, "div", 2);
    i0.ɵɵtemplate(15, MemberEnrollmentCardComponent_div_2_div_15_Template, 7, 10, "div", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.planNameEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.displayPlanYearBadge);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.submissionDateEnabled && ctx_r0.memberEnrollmentSubmittedDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.hraConfirmationNumberEnabled || ctx_r0.confirmationNumberEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.forceViewApplicationPdfLink || ctx_r0.showViewApplicationLink);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showEffectiveDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isHRAEnabled && ctx_r0.completeHRAButtonEnabled && ctx_r0.showCompleteHRASection);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.canDisplayDocuments && ((ctx_r0.memberEnrollmentFiles == null ? null : ctx_r0.memberEnrollmentFiles.length) || ctx_r0.showHRAPDFLink));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.memberRiders && ctx_r0.ridersEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.agentCallRecords == null ? null : ctx_r0.agentCallRecords.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.totalMonthlyPremiumEnabled);
} }
function MemberEnrollmentCardComponent_vnext_member_expandable_enrollment_card_3_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-member-expandable-enrollment-card", 43);
    i0.ɵɵlistener("viewApplication", function MemberEnrollmentCardComponent_vnext_member_expandable_enrollment_card_3_Template_vnext_member_expandable_enrollment_card_viewApplication_0_listener() { i0.ɵɵrestoreView(_r39); const ctx_r38 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r38.viewApplication()); });
    i0.ɵɵpipe(1, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("memberEnrollmentPlanName", ctx_r1.memberEnrollmentPlanName)("memberEnrollmentSubmittedDate", ctx_r1.memberEnrollmentSubmittedDate)("planYear", ctx_r1.planYear)("submissionDateEnabled", ctx_r1.submissionDateEnabled)("remainingHRADays", ctx_r1.remainingHRADays)("isHRAEnabled", ctx_r1.isHRAEnabled)("hraConfirmationText", ctx_r1.hraConfirmationText)("viewApplicationLinkText", ctx_r1.viewApplicationLinkText)("forceViewApplicationPdfLink", ctx_r1.forceViewApplicationPdfLink)("showViewApplicationLink", ctx_r1.showViewApplicationLink)("planNameEnabled", ctx_r1.planNameEnabled)("planTypeID", ctx_r1.memberEnrollment.planTypeID)("displayPlanYearBadge", ctx_r1.displayPlanYearBadge)("totalMonthlyPremiumLabel", ctx_r1.totalMonthlyPremiumLabel)("memberEnrollmentPremium", i0.ɵɵpipeBind1(1, 18, ctx_r1.memberEnrollmentPremium))("planTypeText", ctx_r1.planTypeText)("hraConfirmationNumber", ctx_r1.memberEnrollment.hraConfirmationNumber)("completeHRADaysLeftText", ctx_r1.completeHRADaysLeftText);
} }
function MemberEnrollmentCardComponent_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r40.enrollmentStatus.status, " ");
} }
function MemberEnrollmentCardComponent_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r41.enrollmentStatus.statusDate, " ");
} }
function MemberEnrollmentCardComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, MemberEnrollmentCardComponent_div_4_div_1_Template, 2, 1, "div", 44);
    i0.ɵɵtemplate(2, MemberEnrollmentCardComponent_div_4_div_2_Template, 2, 1, "div", 44);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.enrollmentStatus.status);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.enrollmentStatus.statusDate);
} }
function MemberEnrollmentCardComponent_vnext_enrollment_card_details_5_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-enrollment-card-details", 46);
    i0.ɵɵlistener("clickCompleteEnrollmentHRA", function MemberEnrollmentCardComponent_vnext_enrollment_card_details_5_Template_vnext_enrollment_card_details_clickCompleteEnrollmentHRA_0_listener() { i0.ɵɵrestoreView(_r43); const ctx_r42 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r42.onClickCompleteEnrollmentHRA()); })("openDocument", function MemberEnrollmentCardComponent_vnext_enrollment_card_details_5_Template_vnext_enrollment_card_details_openDocument_0_listener($event) { i0.ɵɵrestoreView(_r43); const ctx_r44 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r44.openDocument($event)); })("generateHRAPDF", function MemberEnrollmentCardComponent_vnext_enrollment_card_details_5_Template_vnext_enrollment_card_details_generateHRAPDF_0_listener() { i0.ɵɵrestoreView(_r43); const ctx_r45 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r45.generateHRAPDF()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("enrollmentMoreDetailsText", ctx_r3.enrollmentMoreDetailsText)("enrollmentStatus", ctx_r3.enrollmentStatus)("enrollmentStatusHeaderText", ctx_r3.enrollmentStatusHeaderText)("isHRAEnabled", ctx_r3.isHRAEnabled)("completeHRAButtonEnabled", ctx_r3.completeHRAButtonEnabled)("showCompleteHRASection", ctx_r3.showCompleteHRASection)("completeHRAButtonText", ctx_r3.completeHRAButtonText)("enrollmentHraHeaderText", ctx_r3.enrollmentHraHeaderText)("confirmationNumberEnabled", ctx_r3.confirmationNumberEnabled)("enrollmentConfirmationHeaderText", ctx_r3.enrollmentConfirmationHeaderText)("enrollmentConfirmationNumber", ctx_r3.memberEnrollment.confirmationNumber)("hraConfirmationNumberEnabled", ctx_r3.hraConfirmationNumberEnabled)("hraConfirmationText", ctx_r3.hraConfirmationText)("hraEnrollmentConfirmationNumber", ctx_r3.hraEnrollmentConfirmationNumber)("showEffectiveDate", ctx_r3.showEffectiveDate)("memberEnrollmentEffectiveDateHeaderText", ctx_r3.memberEnrollmentEffectiveDateHeaderText)("memberEnrollmentEffectiveDate", ctx_r3.memberEnrollmentEffectiveDate)("ridersEnabled", ctx_r3.ridersEnabled)("riderHeaderText", ctx_r3.riderHeaderText)("memberRiders", ctx_r3.memberRiders)("callRecordingHeaderText", ctx_r3.callRecordingHeaderText)("agentCallRecords", ctx_r3.agentCallRecords)("pacificStandardTimeText", ctx_r3.pacificStandardTimeText)("uploadDocumentHeaderText", ctx_r3.uploadDocumentHeaderText)("canDisplayDocuments", ctx_r3.canDisplayDocuments)("memberEnrollmentFiles", ctx_r3.memberEnrollmentFiles)("showHRAPDFLink", ctx_r3.showHRAPDFLink)("hraPDFLinkText", ctx_r3.hraPDFLinkText)("valueBasedCareConfirmationEnabled", ctx_r3.valueBasedCareConfirmationEnabled)("valueBasedCareConfirmationText", ctx_r3.valueBasedCareConfirmationText)("valueBasedCareProviders", ctx_r3.valueBasedCareProviders)("npi", ctx_r3.memberEnrollment == null ? null : ctx_r3.memberEnrollment.pcpNpi)("pcpName", ctx_r3.memberEnrollment == null ? null : ctx_r3.memberEnrollment.pcpName)("vbcOrgName", ctx_r3.memberEnrollment == null ? null : ctx_r3.memberEnrollment.vbcOrgName)("vbcExpired", ctx_r3.vbcExpired)("isHRAPDFAccessEnabled", ctx_r3.isHRAPDFAccessEnabled)("isCarrierExcluded", ctx_r3.isCarrierExcluded)("isCompleteHRAEnabledForAdmin", ctx_r3.isCompleteHRAEnabledForAdmin)("isHRAPDFEnabledForProfileAdmin", ctx_r3.isHRAPDFEnabledForProfileAdmin);
} }
const _c3$i = function (a0) { return { Spa_Style_Gray1_Background: a0 }; };
class MemberEnrollmentCardComponent {
    constructor(agentService, siteService, hraFormFacade, confirmationService, analyticsService, cdr, planYearService, hraService, planFacade, localeService, enrollmentFormService, agentPermissionsService) {
        this.agentService = agentService;
        this.siteService = siteService;
        this.hraFormFacade = hraFormFacade;
        this.confirmationService = confirmationService;
        this.analyticsService = analyticsService;
        this.cdr = cdr;
        this.planYearService = planYearService;
        this.hraService = hraService;
        this.planFacade = planFacade;
        this.localeService = localeService;
        this.enrollmentFormService = enrollmentFormService;
        this.agentPermissionsService = agentPermissionsService;
        this.hraConfirmationText = 'HRA Confirmation';
        this.hraPDFLinkText = 'Health Risk Assessment';
        this.excludedCarrierIds = [];
        this.showCompleteHRASection = false;
        this.planHRAType = PlanHRAType.NONE;
        this.remainingHRADays = 0;
        this.passedHRADays = 0;
        this.displayPlanYearBadge = false;
        this.isCompleteHRAEnabledForAdmin = false;
        this.subscriptions = new Subscription();
    }
    get confirmationNumber() {
        return `${this.confirmationText} #${this.memberEnrollment.confirmationNumber}`;
    }
    ngOnInit() {
        const isPPCSite = this.siteService.isPPCSite();
        this.vbcExpired =
            DateUtilities.getDaysDifference(this.memberEnrollment.createdWhen, DateUtilities.getFormattedDate(), DaysDifferencePrecision.DATE_ONLY) < this.valueBasedCareConfirmationExpiration;
        this.memberEnrollmentPlanName = this.memberEnrollment.planName;
        this.hraEnrollmentConfirmationNumber = this.memberEnrollment.hraConfirmationNumber;
        this.memberRiders = this.memberEnrollment.riderNames;
        this.disableExpandableDetailsInAccountSummaryPage = !this.isExpandableDetailViewEnabled || this.isAccountSummaryPage;
        this.memberEnrollmentPremium = this.memberEnrollment.enrolledPremium;
        this.memberEnrollmentFiles = this.memberEnrollment.memberFiles?.map(fileDetails => {
            return {
                ...fileDetails,
                name: this.getFileName(fileDetails.name)
            };
        });
        this.transactionSID = this.memberEnrollment.transactionSID;
        this.isCurrentYearEnrollment = this.memberEnrollment.isCurrentYearEnrollment;
        this.showHRAPDFLink = !!this.memberEnrollment.hraTransactionSID && !!this.memberEnrollment.hraConfirmationNumber;
        this.canDisplayDocuments = this.memberEnrollment.canDisplayDocuments;
        this.showViewApplicationLink = this.memberEnrollment.showViewApplicationLink;
        this.forceViewApplicationPdfLink = this.memberEnrollment.forceViewApplicationPdfLink;
        this.displayPlanYearBadge =
            this.showPlanYearBadge &&
                this.planYear &&
                this.planYearService.showEnrollmentPlanYearBadgeByPlanType(this.memberEnrollment?.planTypeID);
        if (!this.enrollmentUserTypeMatchesSiteType(this.memberEnrollment.userType)) {
            this.showHRAPDFLink = false;
        }
        else {
            // site/user type match, make sure agentIds match
            const currentAgentGuid = this.agentService.getAgentInContextGuid();
            if (isPPCSite && !(currentAgentGuid && currentAgentGuid === this.memberEnrollment.agentGUID)) {
                this.showHRAPDFLink = false;
            }
        }
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe({
            next: () => {
                this.planTypeText = this.planFacade.getPlanDescriptionById(this.memberEnrollment?.planTypeID);
                this.cdr.markForCheck();
            }
        }));
    }
    ngOnChanges(changes) {
        const { memberEnrollment, excludedCarrierIds } = changes;
        const isPPCSite = this.siteService.isPPCSite();
        if (memberEnrollment && !_isEqual(memberEnrollment.currentValue, memberEnrollment.previousValue)) {
            if (isPPCSite &&
                this.memberEnrollment?.hraUserType !== PlanHRAUserType.NONE &&
                this.memberEnrollment?.hraUserType !== PlanHRAUserType.CONSUMER) {
                const hraDaysLeft = this.memberEnrollment?.hraDaysLeft || 0;
                this.remainingHRADays = this.hraFormFacade.getRemainingDaysToSumbmitHRA(this.memberEnrollment, hraDaysLeft);
                this.passedHRADays = this.hraFormFacade.getHRADaysDifference(this.memberEnrollment?.completedWhen, hraDaysLeft, DifferenceTypeToSubmitHRA.PASSED);
                if (this.memberEnrollment?.hraExternalUrl) {
                    this.planHRAType = PlanHRAType.EXTERNAL;
                    this.showCompleteHRASection = this.remainingHRADays > 0;
                }
                else {
                    this.planHRAType = PlanHRAType.INTERNAL;
                    this.showCompleteHRASection =
                        !this.memberEnrollment.hraTransactionSID && !this.memberEnrollment.hraConfirmationNumber && this.remainingHRADays > 0;
                }
                if (memberEnrollment.currentValue.planID &&
                    memberEnrollment.currentValue.canDisplayDocuments &&
                    (!_isEqual(memberEnrollment.currentValue?.planID, memberEnrollment.previousValue?.planID) ||
                        !_isEqual(excludedCarrierIds?.currentValue, excludedCarrierIds?.previousValue))) {
                    this.getCarriersByPlanId();
                    if (this.completeHRAButtonEnabled) {
                        this.setCompleteHRAButtonEnabled();
                    }
                    if (this.isHRAEnabled && this.isCompleteHRAEnabledForAdmin) {
                        this.isCompleteHRAEnabledForAdmin = this.showCompleteHRASection;
                        this.isHRAPDFEnabledForProfileAdmin = !this.showCompleteHRASection;
                    }
                }
            }
        }
    }
    getRiderName(name) {
        return `+ ${name}`;
    }
    getFileName(value) {
        return value.replace(/"/g, '');
    }
    generateHRAPDF() {
        this.agentService.downloadEnrollmentApplicationPDF(this.memberEnrollment.hraTransactionSID, this.hraEnrollmentConfirmationNumber, false);
    }
    openDocument(memberFile) {
        const downloadFile$ = this.memberEnrollment.enrollSystemType === EnrollSystemType.NextGen
            ? this.enrollmentFormService.nextGenDownloadFile$(this.memberEnrollment.nativeTransactionID, memberFile.id)
            : this.agentService.openMemberDocument$(this.memberEnrollment.nativeTransactionID, memberFile.id);
        downloadFile$.pipe(take(1)).subscribe({
            next: response => {
                this.downloadEnrolledDocument(response, this.getFileName(memberFile.name));
            }
        });
    }
    downloadEnrolledDocument(data, fileName) {
        const blob = new Blob([data], { type: data.type });
        const fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = fileName;
        link.click();
    }
    viewApplication() {
        const enrollmentPlanHasNextGenForm = this.memberEnrollment.enrollSystemType === EnrollSystemType.NextGen;
        const transactionId = enrollmentPlanHasNextGenForm ? this.memberEnrollment?.nativeTransactionID : this.memberEnrollment?.transactionSID;
        this.agentService.downloadEnrollmentApplicationPDF(transactionId, this.memberEnrollment.confirmationNumber, enrollmentPlanHasNextGenForm);
    }
    onClickCompleteEnrollmentHRA() {
        const prenavigationInternalFunction = () => {
            this.confirmationService.resetConfirmationState();
            this.addHRAEnterFormClickGoogleTag(this.planHRAType, this.passedHRADays);
            this.cdr.markForCheck();
        };
        const prenavigationExternalFunction = () => {
            this.addHRAEnterFormClickGoogleTag(this.planHRAType, this.passedHRADays);
            this.setNewHRALastVisitedDate();
            this.cdr.markForCheck();
        };
        this.hraService.fetchHRAExternalLinkOrNavigateToInternal(this.planHRAType, this.memberEnrollment, undefined, this.openExternalInNewTab, null, prenavigationInternalFunction.bind(this), prenavigationExternalFunction.bind(this));
    }
    setNewHRALastVisitedDate() {
        this.memberEnrollment = {
            ...this.memberEnrollment,
            hraLastAccessedDate: DateUtilities.getFormattedPTDate()
        };
    }
    enrollmentUserTypeMatchesSiteType(userType) {
        const isPPCSite = this.siteService.isPPCSite();
        return (isPPCSite && userType === EnrollmentUserType.BROKER) || (!isPPCSite && userType === EnrollmentUserType.CONSUMER);
    }
    addHRAEnterFormClickGoogleTag(planHRAType, daysPostEnrollment) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_HRA_ENTER_FORM,
            [DataLayerGlobalVariable.HRA_DAYS_POST_ENROLLMENT]: daysPostEnrollment?.toString(),
            [DataLayerGlobalVariable.HRA_HOSTED_STATUS]: planHRAType?.toLocaleLowerCase()
        };
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    async getCarriersByPlanId() {
        if (this.memberEnrollment?.planID && this.excludedCarrierIds?.length > 0) {
            const enrollmentPlan = await this.enrollmentFormService.fetchEnrollingPlan(this.memberEnrollment.planID);
            if (enrollmentPlan) {
                this.isCarrierExcluded = !!this.excludedCarrierIds?.includes(enrollmentPlan.carrierId);
            }
        }
    }
    setCompleteHRAButtonEnabled() {
        const isEnrollerAdmin = this.agentPermissionsService.isEnrollerAdmin();
        const currentAgentGuid = this.agentService.getAgentInContextGuid();
        const isEnrollmentAgent = currentAgentGuid && currentAgentGuid === this.memberEnrollment.agentGUID;
        this.isCompleteHRAEnabledForAdmin =
            (this.isCompleteHRAProfileAdminEnabled && this.isProfileAdmin) || (isEnrollerAdmin && isEnrollmentAgent) || isEnrollmentAgent;
    }
}
MemberEnrollmentCardComponent.ɵfac = function MemberEnrollmentCardComponent_Factory(t) { return new (t || MemberEnrollmentCardComponent)(i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(HRAFormFacade), i0.ɵɵdirectiveInject(EnrollmentConfirmationService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.PlanYearService), i0.ɵɵdirectiveInject(i1.HRAService), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(i1.AgentPermissionsService)); };
MemberEnrollmentCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MemberEnrollmentCardComponent, selectors: [["vnext-member-enrollment-card"]], inputs: { memberEnrollment: "memberEnrollment", memberEnrollmentSubmittedDate: "memberEnrollmentSubmittedDate", memberEnrollmentEffectiveDate: "memberEnrollmentEffectiveDate", showEffectiveDate: "showEffectiveDate", totalMonthlyPremiumLabel: "totalMonthlyPremiumLabel", viewApplicationLinkText: "viewApplicationLinkText", confirmationText: "confirmationText", hraConfirmationText: "hraConfirmationText", hraConfirmationNumberEnabled: "hraConfirmationNumberEnabled", confirmationNumberEnabled: "confirmationNumberEnabled", planNameEnabled: "planNameEnabled", effectiveDateEnabled: "effectiveDateEnabled", totalMonthlyPremiumEnabled: "totalMonthlyPremiumEnabled", submissionDateEnabled: "submissionDateEnabled", ridersEnabled: "ridersEnabled", memberEnrollmentPlanTypeId: "memberEnrollmentPlanTypeId", hraPDFLinkText: "hraPDFLinkText", agentCallRecords: "agentCallRecords", pacificStandardTimeText: "pacificStandardTimeText", completeHRAButtonEnabled: "completeHRAButtonEnabled", isHRAEnabled: "isHRAEnabled", openExternalInNewTab: "openExternalInNewTab", completeHRAButtonText: "completeHRAButtonText", completeHRALastVisitedText: "completeHRALastVisitedText", completeHRADaysLeftText: "completeHRADaysLeftText", showPlanYearBadge: "showPlanYearBadge", isActivePlanYear: "isActivePlanYear", planYear: "planYear", planFeesEnabled: "planFeesEnabled", planFeesTooltipText: "planFeesTooltipText", planFeesIncludedInPremiumTooltipText: "planFeesIncludedInPremiumTooltipText", planFeesNotIncludedInPremiumTooltipText: "planFeesNotIncludedInPremiumTooltipText", enrollmentStatus: "enrollmentStatus", enrollmentStatusHeaderText: "enrollmentStatusHeaderText", enrollmentMoreDetailsText: "enrollmentMoreDetailsText", enrollmentHraHeaderText: "enrollmentHraHeaderText", enrollmentConfirmationHeaderText: "enrollmentConfirmationHeaderText", memberEnrollmentEffectiveDateHeaderText: "memberEnrollmentEffectiveDateHeaderText", riderHeaderText: "riderHeaderText", callRecordingHeaderText: "callRecordingHeaderText", uploadDocumentHeaderText: "uploadDocumentHeaderText", valueBasedCareConfirmationEnabled: "valueBasedCareConfirmationEnabled", valueBasedCareConfirmationText: "valueBasedCareConfirmationText", valueBasedCareProviders: "valueBasedCareProviders", isExpandableDetailViewEnabled: "isExpandableDetailViewEnabled", isAccountSummaryPage: "isAccountSummaryPage", valueBasedCareConfirmationExpiration: "valueBasedCareConfirmationExpiration", isHRAPDFAccessEnabled: "isHRAPDFAccessEnabled", isProfileAdmin: "isProfileAdmin", isCompleteHRAProfileAdminEnabled: "isCompleteHRAProfileAdminEnabled", excludedCarrierIds: "excludedCarrierIds" }, features: [i0.ɵɵNgOnChangesFeature], decls: 6, vars: 7, consts: [[1, "member-enrollment-card-container", 3, "ngClass"], [1, "p-2"], [4, "ngIf"], [3, "memberEnrollmentPlanName", "memberEnrollmentSubmittedDate", "planYear", "submissionDateEnabled", "remainingHRADays", "isHRAEnabled", "hraConfirmationText", "viewApplicationLinkText", "forceViewApplicationPdfLink", "showViewApplicationLink", "planNameEnabled", "planTypeID", "displayPlanYearBadge", "totalMonthlyPremiumLabel", "memberEnrollmentPremium", "planTypeText", "hraConfirmationNumber", "completeHRADaysLeftText", "viewApplication", 4, "ngIf"], ["class", "row", 4, "ngIf"], [3, "enrollmentMoreDetailsText", "enrollmentStatus", "enrollmentStatusHeaderText", "isHRAEnabled", "completeHRAButtonEnabled", "showCompleteHRASection", "completeHRAButtonText", "enrollmentHraHeaderText", "confirmationNumberEnabled", "enrollmentConfirmationHeaderText", "enrollmentConfirmationNumber", "hraConfirmationNumberEnabled", "hraConfirmationText", "hraEnrollmentConfirmationNumber", "showEffectiveDate", "memberEnrollmentEffectiveDateHeaderText", "memberEnrollmentEffectiveDate", "ridersEnabled", "riderHeaderText", "memberRiders", "callRecordingHeaderText", "agentCallRecords", "pacificStandardTimeText", "uploadDocumentHeaderText", "canDisplayDocuments", "memberEnrollmentFiles", "showHRAPDFLink", "hraPDFLinkText", "valueBasedCareConfirmationEnabled", "valueBasedCareConfirmationText", "valueBasedCareProviders", "npi", "pcpName", "vbcOrgName", "vbcExpired", "isHRAPDFAccessEnabled", "isCarrierExcluded", "isCompleteHRAEnabledForAdmin", "isHRAPDFEnabledForProfileAdmin", "clickCompleteEnrollmentHRA", "openDocument", "generateHRAPDF", 4, "ngIf"], [1, "d-flex", "pb-2"], ["class", "Spa_Style_Primary_Color Spa_Style_Regular_Font mt-4 mt-sm-0 no-translate-block", 4, "ngIf"], ["class", "enrollment-plan-year-badge", 4, "ngIf"], [1, "row"], [1, "col-md-8", "col-lg-9"], ["class", "col-lg-6 Spa_Style_Gray4_Color Spa_Style_Smaller_Font", 4, "ngIf"], ["class", "col-lg-6", 4, "ngIf"], ["class", "col-md-4 col-lg-3 Spa_Style_Primary_Link text-right", 4, "ngIf"], ["class", "Spa_Style_Gray4_Color Spa_Style_Smaller_Font", 4, "ngIf"], ["class", "document-separator py-2", 4, "ngIf"], ["class", "row document-separator py-2", 4, "ngIf"], [1, "Spa_Style_Primary_Color", "Spa_Style_Regular_Font", "mt-4", "mt-sm-0", "no-translate-block"], [1, "enrollment-plan-year-badge"], [3, "planYear", "isDualPlanYearActive"], [1, "col-lg-6", "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font"], [1, "col-lg-6"], [1, "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font"], [1, "col-md-4", "col-lg-3", "Spa_Style_Primary_Link", "text-right"], [3, "additionalIcon", "title", "click", "keyup.enter"], [1, "document-separator", "py-2"], [3, "completeHRAButtonText", "completeHRALastVisitedText", "completeHRADaysLeftText", "planHRAType", "remainingHRADays", "memberHraLastAccessedDate", "clickCompleteEnrollmentHRA"], [1, "row", "document-separator", "py-2"], ["class", "col-lg-4 pl-0 Spa_Style_Primary_Link enrollment-files-wrapper", 4, "ngFor", "ngForOf"], ["class", "col-lg-4 pl-0 Spa_Style_Primary_Link enrollment-files-wrapper", 4, "ngIf"], [1, "col-lg-4", "pl-0", "Spa_Style_Primary_Link", "enrollment-files-wrapper"], [3, "additionalIcon", "title", "titleClass", "click", "keyup.enter"], [1, "pt-2"], ["class", "d-inline Spa_Style_Gray4_Color Spa_Style_Small_Font mr-1 no-translate-block", 4, "ngFor", "ngForOf"], [1, "d-inline", "Spa_Style_Gray4_Color", "Spa_Style_Small_Font", "mr-1", "no-translate-block"], [3, "callRecord", "pacificStandardTimeText", 4, "ngFor", "ngForOf"], [3, "callRecord", "pacificStandardTimeText"], [1, "col-12", "flex-column", "flex-md-row", "justify-content-end", "total-premium-banner", 3, "ngClass"], [1, "Spa_Style_H4", "d-sm-block", "d-lg-inline-block", "mb-lg-0", 3, "ngClass"], ["class", "ml-3", 3, "ngClass", 4, "ngIf", "ngIfElse"], ["showPremiumWithFees", ""], [1, "ml-3", 3, "ngClass"], [1, "ml-3", 3, "planFees", "planTotalPremium", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "customClass", "totalPremiumCustomClass", "tooltipCustomClass"], [3, "memberEnrollmentPlanName", "memberEnrollmentSubmittedDate", "planYear", "submissionDateEnabled", "remainingHRADays", "isHRAEnabled", "hraConfirmationText", "viewApplicationLinkText", "forceViewApplicationPdfLink", "showViewApplicationLink", "planNameEnabled", "planTypeID", "displayPlanYearBadge", "totalMonthlyPremiumLabel", "memberEnrollmentPremium", "planTypeText", "hraConfirmationNumber", "completeHRADaysLeftText", "viewApplication"], ["class", "col-lg-12 Spa_Style_Gray4_Color Spa_Style_Smaller_Font", 4, "ngIf"], [1, "col-lg-12", "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font"], [3, "enrollmentMoreDetailsText", "enrollmentStatus", "enrollmentStatusHeaderText", "isHRAEnabled", "completeHRAButtonEnabled", "showCompleteHRASection", "completeHRAButtonText", "enrollmentHraHeaderText", "confirmationNumberEnabled", "enrollmentConfirmationHeaderText", "enrollmentConfirmationNumber", "hraConfirmationNumberEnabled", "hraConfirmationText", "hraEnrollmentConfirmationNumber", "showEffectiveDate", "memberEnrollmentEffectiveDateHeaderText", "memberEnrollmentEffectiveDate", "ridersEnabled", "riderHeaderText", "memberRiders", "callRecordingHeaderText", "agentCallRecords", "pacificStandardTimeText", "uploadDocumentHeaderText", "canDisplayDocuments", "memberEnrollmentFiles", "showHRAPDFLink", "hraPDFLinkText", "valueBasedCareConfirmationEnabled", "valueBasedCareConfirmationText", "valueBasedCareProviders", "npi", "pcpName", "vbcOrgName", "vbcExpired", "isHRAPDFAccessEnabled", "isCarrierExcluded", "isCompleteHRAEnabledForAdmin", "isHRAPDFEnabledForProfileAdmin", "clickCompleteEnrollmentHRA", "openDocument", "generateHRAPDF"]], template: function MemberEnrollmentCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, MemberEnrollmentCardComponent_div_2_Template, 16, 11, "div", 2);
        i0.ɵɵtemplate(3, MemberEnrollmentCardComponent_vnext_member_expandable_enrollment_card_3_Template, 2, 20, "vnext-member-expandable-enrollment-card", 3);
        i0.ɵɵtemplate(4, MemberEnrollmentCardComponent_div_4_Template, 3, 2, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, MemberEnrollmentCardComponent_vnext_enrollment_card_details_5_Template, 1, 39, "vnext-enrollment-card-details", 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c3$i, ctx.isAccountSummaryPage && !ctx.isCurrentYearEnrollment));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.disableExpandableDetailsInAccountSummaryPage);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isExpandableDetailViewEnabled && !ctx.isAccountSummaryPage);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.enrollmentStatus && ctx.disableExpandableDetailsInAccountSummaryPage);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isExpandableDetailViewEnabled && !ctx.isAccountSummaryPage);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, PlanYearBadgeComponent, PlanFeesTooltipComponent, MemberExpandableEnrollmentCardComponent, HRACompleteSectionComponent, EnrollmentCardDetailsComponent, CallRecordingAudioPlayerComponent, i1$2.CurrencyPipe], styles: [".member-enrollment-card-container[_ngcontent-%COMP%]{position:relative;margin-top:18px;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;border:1px solid var(--static-Spa_Style_Accent1);border-radius:4px;background-clip:border-box}.document-separator[_ngcontent-%COMP%]{border-top:1px solid var(--static-Spa_Style_Gray2);border-bottom:1px solid var(--static-Spa_Style_Gray2);margin:2px}.total-premium-banner[_ngcontent-%COMP%]{display:flex;border-radius:5px;padding:7px 12px;align-items:center;justify-content:flex-end}.enrollment-plan-year-badge[_ngcontent-%COMP%]{margin-left:auto}@media (max-width: 768px){.total-premium-banner[_ngcontent-%COMP%]{flex-direction:column;align-items:flex-end}}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], MemberEnrollmentCardComponent.prototype, "openDocument", null);
__decorate([
    LiveEditInactive()
], MemberEnrollmentCardComponent.prototype, "viewApplication", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberEnrollmentCardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-member-enrollment-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"member-enrollment-card-container\" [ngClass]=\"{ Spa_Style_Gray1_Background: isAccountSummaryPage && !isCurrentYearEnrollment }\">\r\n  <div class=\"p-2\">\r\n    <div *ngIf=\"disableExpandableDetailsInAccountSummaryPage\">\r\n      <div class=\"d-flex pb-2\">\r\n        <div *ngIf=\"planNameEnabled\" class=\"Spa_Style_Primary_Color Spa_Style_Regular_Font mt-4 mt-sm-0 no-translate-block\">\r\n          {{ memberEnrollmentPlanName }}\r\n        </div>\r\n        <div class=\"enrollment-plan-year-badge\" *ngIf=\"displayPlanYearBadge\">\r\n          <vnext-plan-year-badge [planYear]=\"planYear\" [isDualPlanYearActive]=\"isActivePlanYear\"> </vnext-plan-year-badge>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-8 col-lg-9\">\r\n          <div class=\"row\">\r\n            <div\r\n              *ngIf=\"submissionDateEnabled && memberEnrollmentSubmittedDate\"\r\n              class=\"col-lg-6 Spa_Style_Gray4_Color Spa_Style_Smaller_Font\"\r\n            >\r\n              {{ memberEnrollmentSubmittedDate }}\r\n            </div>\r\n            <div *ngIf=\"hraConfirmationNumberEnabled || confirmationNumberEnabled\" class=\"col-lg-6\">\r\n              <div *ngIf=\"confirmationNumberEnabled\">\r\n                <div class=\"Spa_Style_Gray4_Color Spa_Style_Smaller_Font\">\r\n                  {{ confirmationText }} {{ memberEnrollment.confirmationNumber }}\r\n                </div>\r\n              </div>\r\n              <div *ngIf=\"hraConfirmationNumberEnabled && hraEnrollmentConfirmationNumber\">\r\n                <div class=\"Spa_Style_Gray4_Color Spa_Style_Smaller_Font\">\r\n                  {{ hraConfirmationText }} {{ hraEnrollmentConfirmationNumber }}\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div *ngIf=\"forceViewApplicationPdfLink || showViewApplicationLink\" class=\"col-md-4 col-lg-3 Spa_Style_Primary_Link text-right\">\r\n          <vnext-link\r\n            (click)=\"viewApplication()\"\r\n            (keyup.enter)=\"viewApplication()\"\r\n            [additionalIcon]=\"'fas fa-file-pdf mr-2'\"\r\n            [title]=\"viewApplicationLinkText\"\r\n          ></vnext-link>\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"showEffectiveDate\" class=\"Spa_Style_Gray4_Color Spa_Style_Smaller_Font\">\r\n        {{ memberEnrollmentEffectiveDate }}\r\n      </div>\r\n\r\n      <div *ngIf=\"isHRAEnabled && completeHRAButtonEnabled && showCompleteHRASection\" class=\"document-separator py-2\">\r\n        <vnext-hra-complete-section\r\n          [completeHRAButtonText]=\"completeHRAButtonText\"\r\n          [completeHRALastVisitedText]=\"completeHRALastVisitedText\"\r\n          [completeHRADaysLeftText]=\"completeHRADaysLeftText\"\r\n          [planHRAType]=\"planHRAType\"\r\n          [remainingHRADays]=\"remainingHRADays\"\r\n          [memberHraLastAccessedDate]=\"memberEnrollment.hraLastAccessedDate\"\r\n          (clickCompleteEnrollmentHRA)=\"onClickCompleteEnrollmentHRA()\"\r\n        ></vnext-hra-complete-section>\r\n      </div>\r\n      <div *ngIf=\"canDisplayDocuments && (memberEnrollmentFiles?.length || showHRAPDFLink)\" class=\"row document-separator py-2\">\r\n        <div *ngFor=\"let memberFile of memberEnrollmentFiles\" class=\"col-lg-4 pl-0 Spa_Style_Primary_Link enrollment-files-wrapper\">\r\n          <vnext-link\r\n            (click)=\"openDocument(memberFile)\"\r\n            (keyup.enter)=\"openDocument(memberFile)\"\r\n            [additionalIcon]=\"'fa fa-file-alt mr-2 d-inline-block'\"\r\n            [title]=\"memberFile.name\"\r\n            [titleClass]=\"'d-inline-block w-75 align-top'\"\r\n          ></vnext-link>\r\n        </div>\r\n        <div *ngIf=\"showHRAPDFLink\" class=\"col-lg-4 pl-0 Spa_Style_Primary_Link enrollment-files-wrapper\">\r\n          <vnext-link\r\n            (click)=\"generateHRAPDF()\"\r\n            (keyup.enter)=\"generateHRAPDF()\"\r\n            [additionalIcon]=\"'fa fa-file-pdf mr-2 d-inline-block'\"\r\n            [title]=\"hraPDFLinkText\"\r\n            [titleClass]=\"'d-inline-block w-75 align-top'\"\r\n          ></vnext-link>\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"memberRiders && ridersEnabled\">\r\n        <div class=\"pt-2\">\r\n          <div *ngFor=\"let rider of memberRiders\" class=\"d-inline Spa_Style_Gray4_Color Spa_Style_Small_Font mr-1 no-translate-block\">\r\n            {{ getRiderName(rider) }}\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"agentCallRecords?.length\">\r\n        <vnext-call-recording-audio-player\r\n          *ngFor=\"let callRecord of agentCallRecords\"\r\n          [callRecord]=\"callRecord\"\r\n          [pacificStandardTimeText]=\"pacificStandardTimeText\"\r\n        ></vnext-call-recording-audio-player>\r\n      </div>\r\n      <div *ngIf=\"totalMonthlyPremiumEnabled\">\r\n        <div\r\n          class=\"col-12 flex-column flex-md-row justify-content-end total-premium-banner\"\r\n          [ngClass]=\"{\r\n            Spa_Style_Secondary_Text_Background: isAccountSummaryPage && !isCurrentYearEnrollment,\r\n            Spa_Style_Cost_Background: !isAccountSummaryPage || isCurrentYearEnrollment\r\n          }\"\r\n        >\r\n          <h4\r\n            class=\"Spa_Style_H4 d-sm-block d-lg-inline-block mb-lg-0\"\r\n            [ngClass]=\"{ Spa_Style_Gray4_Color: isAccountSummaryPage && !isCurrentYearEnrollment }\"\r\n          >\r\n            {{ totalMonthlyPremiumLabel }}\r\n          </h4>\r\n          <span\r\n            *ngIf=\"!planFeesEnabled || !memberEnrollment.fees?.length; else showPremiumWithFees\"\r\n            class=\"ml-3\"\r\n            [ngClass]=\"{\r\n              'Spa_Style_Large_Font Spa_Style_Label Spa_Style_Gray4_Color': isAccountSummaryPage && !isCurrentYearEnrollment,\r\n              'Spa_Style_Larger_Font Spa_Style_CostPremiumSmall': !isAccountSummaryPage || isCurrentYearEnrollment\r\n            }\"\r\n            >{{ memberEnrollmentPremium | currency }}</span\r\n          >\r\n\r\n          <ng-template #showPremiumWithFees>\r\n            <vnext-widget-plan-fees-tooltip\r\n              class=\"ml-3\"\r\n              [planFees]=\"memberEnrollment.fees\"\r\n              [planTotalPremium]=\"memberEnrollmentPremium\"\r\n              [planFeesTooltipText]=\"planFeesTooltipText\"\r\n              [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n              [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n              [customClass]=\"'inline-block-layout stacked-xs-content stacked-sm-content'\"\r\n              [totalPremiumCustomClass]=\"\r\n                isCurrentYearEnrollment ? 'Spa_Style_Larger_Font' : 'Spa_Style_Large_Font Spa_Style_Label Spa_Style_Gray4_Color'\r\n              \"\r\n              [tooltipCustomClass]=\"'stacked-xs-content stacked-sm-content'\"\r\n            ></vnext-widget-plan-fees-tooltip>\r\n          </ng-template>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <vnext-member-expandable-enrollment-card\r\n      *ngIf=\"isExpandableDetailViewEnabled && !isAccountSummaryPage\"\r\n      [memberEnrollmentPlanName]=\"memberEnrollmentPlanName\"\r\n      [memberEnrollmentSubmittedDate]=\"memberEnrollmentSubmittedDate\"\r\n      [planYear]=\"planYear\"\r\n      [submissionDateEnabled]=\"submissionDateEnabled\"\r\n      [remainingHRADays]=\"remainingHRADays\"\r\n      [isHRAEnabled]=\"isHRAEnabled\"\r\n      [hraConfirmationText]=\"hraConfirmationText\"\r\n      [viewApplicationLinkText]=\"viewApplicationLinkText\"\r\n      [forceViewApplicationPdfLink]=\"forceViewApplicationPdfLink\"\r\n      [showViewApplicationLink]=\"showViewApplicationLink\"\r\n      [planNameEnabled]=\"planNameEnabled\"\r\n      [planTypeID]=\"memberEnrollment.planTypeID\"\r\n      [displayPlanYearBadge]=\"displayPlanYearBadge\"\r\n      [totalMonthlyPremiumLabel]=\"totalMonthlyPremiumLabel\"\r\n      [memberEnrollmentPremium]=\"memberEnrollmentPremium | currency\"\r\n      [planTypeText]=\"planTypeText\"\r\n      [hraConfirmationNumber]=\"memberEnrollment.hraConfirmationNumber\"\r\n      [completeHRADaysLeftText]=\"completeHRADaysLeftText\"\r\n      (viewApplication)=\"viewApplication()\"\r\n    ></vnext-member-expandable-enrollment-card>\r\n    <div *ngIf=\"enrollmentStatus && disableExpandableDetailsInAccountSummaryPage\" class=\"row\">\r\n      <div *ngIf=\"enrollmentStatus.status\" class=\"col-lg-12 Spa_Style_Gray4_Color Spa_Style_Smaller_Font\">\r\n        {{ enrollmentStatus.status }}\r\n      </div>\r\n      <div *ngIf=\"enrollmentStatus.statusDate\" class=\"col-lg-12 Spa_Style_Gray4_Color Spa_Style_Smaller_Font\">\r\n        {{ enrollmentStatus.statusDate }}\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <vnext-enrollment-card-details\r\n    *ngIf=\"isExpandableDetailViewEnabled && !isAccountSummaryPage\"\r\n    [enrollmentMoreDetailsText]=\"enrollmentMoreDetailsText\"\r\n    [enrollmentStatus]=\"enrollmentStatus\"\r\n    [enrollmentStatusHeaderText]=\"enrollmentStatusHeaderText\"\r\n    [isHRAEnabled]=\"isHRAEnabled\"\r\n    [completeHRAButtonEnabled]=\"completeHRAButtonEnabled\"\r\n    [showCompleteHRASection]=\"showCompleteHRASection\"\r\n    [completeHRAButtonText]=\"completeHRAButtonText\"\r\n    (clickCompleteEnrollmentHRA)=\"onClickCompleteEnrollmentHRA()\"\r\n    [enrollmentHraHeaderText]=\"enrollmentHraHeaderText\"\r\n    [confirmationNumberEnabled]=\"confirmationNumberEnabled\"\r\n    [enrollmentConfirmationHeaderText]=\"enrollmentConfirmationHeaderText\"\r\n    [enrollmentConfirmationNumber]=\"memberEnrollment.confirmationNumber\"\r\n    [hraConfirmationNumberEnabled]=\"hraConfirmationNumberEnabled\"\r\n    [hraConfirmationText]=\"hraConfirmationText\"\r\n    [hraEnrollmentConfirmationNumber]=\"hraEnrollmentConfirmationNumber\"\r\n    [showEffectiveDate]=\"showEffectiveDate\"\r\n    [memberEnrollmentEffectiveDateHeaderText]=\"memberEnrollmentEffectiveDateHeaderText\"\r\n    [memberEnrollmentEffectiveDate]=\"memberEnrollmentEffectiveDate\"\r\n    [ridersEnabled]=\"ridersEnabled\"\r\n    [riderHeaderText]=\"riderHeaderText\"\r\n    [memberRiders]=\"memberRiders\"\r\n    [callRecordingHeaderText]=\"callRecordingHeaderText\"\r\n    [agentCallRecords]=\"agentCallRecords\"\r\n    [pacificStandardTimeText]=\"pacificStandardTimeText\"\r\n    [uploadDocumentHeaderText]=\"uploadDocumentHeaderText\"\r\n    [canDisplayDocuments]=\"canDisplayDocuments\"\r\n    [memberEnrollmentFiles]=\"memberEnrollmentFiles\"\r\n    [showHRAPDFLink]=\"showHRAPDFLink\"\r\n    [hraPDFLinkText]=\"hraPDFLinkText\"\r\n    [valueBasedCareConfirmationEnabled]=\"valueBasedCareConfirmationEnabled\"\r\n    [valueBasedCareConfirmationText]=\"valueBasedCareConfirmationText\"\r\n    [valueBasedCareProviders]=\"valueBasedCareProviders\"\r\n    [npi]=\"memberEnrollment?.pcpNpi\"\r\n    [pcpName]=\"memberEnrollment?.pcpName\"\r\n    [vbcOrgName]=\"memberEnrollment?.vbcOrgName\"\r\n    [vbcExpired]=\"vbcExpired\"\r\n    (openDocument)=\"openDocument($event)\"\r\n    (generateHRAPDF)=\"generateHRAPDF()\"\r\n    [isHRAPDFAccessEnabled]=\"isHRAPDFAccessEnabled\"\r\n    [isCarrierExcluded]=\"isCarrierExcluded\"\r\n    [isCompleteHRAEnabledForAdmin]=\"isCompleteHRAEnabledForAdmin\"\r\n    [isHRAPDFEnabledForProfileAdmin]=\"isHRAPDFEnabledForProfileAdmin\"\r\n  ></vnext-enrollment-card-details>\r\n</div>\r\n", styles: [".member-enrollment-card-container{position:relative;margin-top:18px;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;border:1px solid var(--static-Spa_Style_Accent1);border-radius:4px;background-clip:border-box}.document-separator{border-top:1px solid var(--static-Spa_Style_Gray2);border-bottom:1px solid var(--static-Spa_Style_Gray2);margin:2px}.total-premium-banner{display:flex;border-radius:5px;padding:7px 12px;align-items:center;justify-content:flex-end}.enrollment-plan-year-badge{margin-left:auto}@media (max-width: 768px){.total-premium-banner{flex-direction:column;align-items:flex-end}}\n"] }]
    }], function () { return [{ type: i1.AgentService }, { type: i1.SiteService }, { type: HRAFormFacade }, { type: EnrollmentConfirmationService }, { type: AnalyticsService }, { type: i0.ChangeDetectorRef }, { type: i1.PlanYearService }, { type: i1.HRAService }, { type: PlanFacade }, { type: i1.LocaleService }, { type: i1.EnrollmentFormService }, { type: i1.AgentPermissionsService }]; }, { memberEnrollment: [{
            type: Input
        }], memberEnrollmentSubmittedDate: [{
            type: Input
        }], memberEnrollmentEffectiveDate: [{
            type: Input
        }], showEffectiveDate: [{
            type: Input
        }], totalMonthlyPremiumLabel: [{
            type: Input
        }], viewApplicationLinkText: [{
            type: Input
        }], confirmationText: [{
            type: Input
        }], hraConfirmationText: [{
            type: Input
        }], hraConfirmationNumberEnabled: [{
            type: Input
        }], confirmationNumberEnabled: [{
            type: Input
        }], planNameEnabled: [{
            type: Input
        }], effectiveDateEnabled: [{
            type: Input
        }], totalMonthlyPremiumEnabled: [{
            type: Input
        }], submissionDateEnabled: [{
            type: Input
        }], ridersEnabled: [{
            type: Input
        }], memberEnrollmentPlanTypeId: [{
            type: Input
        }], hraPDFLinkText: [{
            type: Input
        }], agentCallRecords: [{
            type: Input
        }], pacificStandardTimeText: [{
            type: Input
        }], completeHRAButtonEnabled: [{
            type: Input
        }], isHRAEnabled: [{
            type: Input
        }], openExternalInNewTab: [{
            type: Input
        }], completeHRAButtonText: [{
            type: Input
        }], completeHRALastVisitedText: [{
            type: Input
        }], completeHRADaysLeftText: [{
            type: Input
        }], showPlanYearBadge: [{
            type: Input
        }], isActivePlanYear: [{
            type: Input
        }], planYear: [{
            type: Input
        }], planFeesEnabled: [{
            type: Input
        }], planFeesTooltipText: [{
            type: Input
        }], planFeesIncludedInPremiumTooltipText: [{
            type: Input
        }], planFeesNotIncludedInPremiumTooltipText: [{
            type: Input
        }], enrollmentStatus: [{
            type: Input
        }], enrollmentStatusHeaderText: [{
            type: Input
        }], enrollmentMoreDetailsText: [{
            type: Input
        }], enrollmentHraHeaderText: [{
            type: Input
        }], enrollmentConfirmationHeaderText: [{
            type: Input
        }], memberEnrollmentEffectiveDateHeaderText: [{
            type: Input
        }], riderHeaderText: [{
            type: Input
        }], callRecordingHeaderText: [{
            type: Input
        }], uploadDocumentHeaderText: [{
            type: Input
        }], valueBasedCareConfirmationEnabled: [{
            type: Input
        }], valueBasedCareConfirmationText: [{
            type: Input
        }], valueBasedCareProviders: [{
            type: Input
        }], isExpandableDetailViewEnabled: [{
            type: Input
        }], isAccountSummaryPage: [{
            type: Input
        }], valueBasedCareConfirmationExpiration: [{
            type: Input
        }], isHRAPDFAccessEnabled: [{
            type: Input
        }], isProfileAdmin: [{
            type: Input
        }], isCompleteHRAProfileAdminEnabled: [{
            type: Input
        }], excludedCarrierIds: [{
            type: Input
        }], openDocument: [], viewApplication: [] }); })();

function MemberExpandablePartialEnrollmentCardComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.memberEnrollmentUpdatedDate, " ");
} }
function MemberExpandablePartialEnrollmentCardComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.memberEnrollmentUpdatedDate, " ");
} }
function MemberExpandablePartialEnrollmentCardComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15)(2, "h3", 16);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.memberEnrollmentPlanName);
} }
function MemberExpandablePartialEnrollmentCardComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.planYear);
} }
const _c0$1B = function (a0) { return { "w-100": a0 }; };
function MemberExpandablePartialEnrollmentCardComponent_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17, 18);
    i0.ɵɵlistener("click", function MemberExpandablePartialEnrollmentCardComponent_button_12_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r9); const _r7 = i0.ɵɵreference(1); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.continueEnrollment(_r7)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngbTooltip", ctx_r4.enrollerButtonTooltipText)("ngClass", i0.ɵɵpureFunction1(3, _c0$1B, ctx_r4.isMobile));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.continueEnrollmentButtonText, " ");
} }
function MemberExpandablePartialEnrollmentCardComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.partialEnrollmentDisabledText, " ");
} }
class MemberExpandablePartialEnrollmentCardComponent {
    constructor() {
        this.navigateToEnrollmentPage = new EventEmitter();
    }
    continueEnrollment(enrollerButtonTooltip) {
        this.navigateToEnrollmentPage.emit(enrollerButtonTooltip);
    }
}
MemberExpandablePartialEnrollmentCardComponent.ɵfac = function MemberExpandablePartialEnrollmentCardComponent_Factory(t) { return new (t || MemberExpandablePartialEnrollmentCardComponent)(); };
MemberExpandablePartialEnrollmentCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MemberExpandablePartialEnrollmentCardComponent, selectors: [["vnext-member-expandable-partial-enrollment-card"]], inputs: { memberEnrollmentPlanName: "memberEnrollmentPlanName", memberEnrollmentSubmittedDate: "memberEnrollmentSubmittedDate", planNameEnabled: "planNameEnabled", displayPlanYearBadge: "displayPlanYearBadge", disableExpandableDetailsInAccountSummaryPage: "disableExpandableDetailsInAccountSummaryPage", hraConfirmationNumberEnabled: "hraConfirmationNumberEnabled", confirmationNumberEnabled: "confirmationNumberEnabled", enrollmentConfirmationNumber: "enrollmentConfirmationNumber", planYear: "planYear", planTypeID: "planTypeID", totalMonthlyPremiumLabel: "totalMonthlyPremiumLabel", memberEnrollmentPremium: "memberEnrollmentPremium", continueEnrollmentButtonText: "continueEnrollmentButtonText", partialEnrollmentEnabled: "partialEnrollmentEnabled", partialEnrollmentDisabledText: "partialEnrollmentDisabledText", planTypeText: "planTypeText", isMobile: "isMobile", updatedDateEnabled: "updatedDateEnabled", memberEnrollmentUpdatedDate: "memberEnrollmentUpdatedDate", enrollerButtonTooltipText: "enrollerButtonTooltipText" }, outputs: { navigateToEnrollmentPage: "navigateToEnrollmentPage" }, decls: 15, vars: 9, consts: [[1, "pb-2"], [1, "row", "no-gutters", "justify-content-end", "mb-1"], ["class", "Spa_Style_Gray4_Color Spa_Style_Smaller_Font d-flex justify-content-end col-sm-12", 4, "ngIf"], ["class", "Spa_Style_Gray4_Color Spa_Style_Smaller_Font d-flex justify-content-end col-6", 4, "ngIf"], ["class", "row no-gutters no-translate-block", 4, "ngIf"], [1, "row", "member-enrollment-details"], [1, "col-sm-12", "col-lg-5", "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font"], [4, "ngIf"], [1, "col-sm-12", "col-lg-3", "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font", "d-flex", "center-card-content"], [1, "col-sm-12", "col-lg-4", "Spa_Style_Smaller_Font", "d-flex", "justify-content-end"], ["class", "btn Spa_Style_PrimaryButton", "triggers", "manual", 3, "ngbTooltip", "ngClass", "click", 4, "ngIf", "ngIfElse"], ["partialEnrollmentDisabled", ""], [1, "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font", "d-flex", "justify-content-end", "col-sm-12"], [1, "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font", "d-flex", "justify-content-end", "col-6"], [1, "row", "no-gutters", "no-translate-block"], [1, "Spa_Style_Primary_Color", "Spa_Style_Regular_Font", "col-12"], [1, "Spa_Style_H3", "mb-0"], ["triggers", "manual", 1, "btn", "Spa_Style_PrimaryButton", 3, "ngbTooltip", "ngClass", "click"], ["enrollerButtonTooltip", "ngbTooltip"], [1, "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font", "text-center"]], template: function MemberExpandablePartialEnrollmentCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, MemberExpandablePartialEnrollmentCardComponent_div_2_Template, 2, 1, "div", 2);
        i0.ɵɵtemplate(3, MemberExpandablePartialEnrollmentCardComponent_div_3_Template, 2, 1, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, MemberExpandablePartialEnrollmentCardComponent_div_4_Template, 4, 1, "div", 4);
        i0.ɵɵelementStart(5, "div", 5)(6, "div", 6);
        i0.ɵɵtext(7);
        i0.ɵɵtemplate(8, MemberExpandablePartialEnrollmentCardComponent_span_8_Template, 2, 1, "span", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 9);
        i0.ɵɵtemplate(12, MemberExpandablePartialEnrollmentCardComponent_button_12_Template, 3, 5, "button", 10);
        i0.ɵɵtemplate(13, MemberExpandablePartialEnrollmentCardComponent_ng_template_13_Template, 2, 1, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        const _r5 = i0.ɵɵreference(14);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.updatedDateEnabled && ctx.memberEnrollmentUpdatedDate && ctx.isMobile);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.updatedDateEnabled && ctx.memberEnrollmentUpdatedDate && !ctx.isMobile);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.planNameEnabled);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.planTypeText, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.displayPlanYearBadge);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate2(" ", ctx.totalMonthlyPremiumLabel, " ", ctx.memberEnrollmentPremium, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.partialEnrollmentEnabled)("ngIfElse", _r5);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$1.NgbTooltip], styles: [".member-enrollment-details[_ngcontent-%COMP%]{gap:24px 0}@media (max-width: 768px){.center-card-content[_ngcontent-%COMP%]{justify-content:center}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberExpandablePartialEnrollmentCardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-member-expandable-partial-enrollment-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"pb-2\">\r\n  <div class=\"row no-gutters justify-content-end mb-1\">\r\n    <div\r\n      *ngIf=\"updatedDateEnabled && memberEnrollmentUpdatedDate && isMobile\"\r\n      class=\"Spa_Style_Gray4_Color Spa_Style_Smaller_Font d-flex justify-content-end col-sm-12\"\r\n    >\r\n      {{ memberEnrollmentUpdatedDate }}\r\n    </div>\r\n    <div\r\n      *ngIf=\"updatedDateEnabled && memberEnrollmentUpdatedDate && !isMobile\"\r\n      class=\"Spa_Style_Gray4_Color Spa_Style_Smaller_Font d-flex justify-content-end col-6\"\r\n    >\r\n      {{ memberEnrollmentUpdatedDate }}\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"planNameEnabled\" class=\"row no-gutters no-translate-block\">\r\n    <div class=\"Spa_Style_Primary_Color Spa_Style_Regular_Font col-12\">\r\n      <h3 class=\"Spa_Style_H3 mb-0\">{{ memberEnrollmentPlanName }}</h3>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row member-enrollment-details\">\r\n    <div class=\"col-sm-12 col-lg-5 Spa_Style_Gray4_Color Spa_Style_Smaller_Font\">\r\n      {{ planTypeText }} <span *ngIf=\"displayPlanYearBadge\">{{ planYear }}</span>\r\n    </div>\r\n    <div class=\"col-sm-12 col-lg-3 Spa_Style_Gray4_Color Spa_Style_Smaller_Font d-flex center-card-content\">\r\n      {{ totalMonthlyPremiumLabel }} {{ memberEnrollmentPremium }}\r\n    </div>\r\n    <div class=\"col-sm-12 col-lg-4 Spa_Style_Smaller_Font d-flex justify-content-end\">\r\n      <button\r\n        *ngIf=\"partialEnrollmentEnabled; else partialEnrollmentDisabled\"\r\n        class=\"btn Spa_Style_PrimaryButton\"\r\n        triggers=\"manual\"\r\n        #enrollerButtonTooltip=\"ngbTooltip\"\r\n        [ngbTooltip]=\"enrollerButtonTooltipText\"\r\n        [ngClass]=\"{ 'w-100': isMobile }\"\r\n        (click)=\"continueEnrollment(enrollerButtonTooltip)\"\r\n      >\r\n        {{ continueEnrollmentButtonText }}\r\n      </button>\r\n      <ng-template #partialEnrollmentDisabled>\r\n        <div class=\"Spa_Style_Gray4_Color Spa_Style_Smaller_Font text-center\">\r\n          {{ partialEnrollmentDisabledText }}\r\n        </div>\r\n      </ng-template>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".member-enrollment-details{gap:24px 0}@media (max-width: 768px){.center-card-content{justify-content:center}}\n"] }]
    }], null, { memberEnrollmentPlanName: [{
            type: Input
        }], memberEnrollmentSubmittedDate: [{
            type: Input
        }], planNameEnabled: [{
            type: Input
        }], displayPlanYearBadge: [{
            type: Input
        }], disableExpandableDetailsInAccountSummaryPage: [{
            type: Input
        }], hraConfirmationNumberEnabled: [{
            type: Input
        }], confirmationNumberEnabled: [{
            type: Input
        }], enrollmentConfirmationNumber: [{
            type: Input
        }], planYear: [{
            type: Input
        }], planTypeID: [{
            type: Input
        }], totalMonthlyPremiumLabel: [{
            type: Input
        }], memberEnrollmentPremium: [{
            type: Input
        }], continueEnrollmentButtonText: [{
            type: Input
        }], partialEnrollmentEnabled: [{
            type: Input
        }], partialEnrollmentDisabledText: [{
            type: Input
        }], planTypeText: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], updatedDateEnabled: [{
            type: Input
        }], memberEnrollmentUpdatedDate: [{
            type: Input
        }], enrollerButtonTooltipText: [{
            type: Input
        }], navigateToEnrollmentPage: [{
            type: Output
        }] }); })();

function MemberPartialEnrollmentCardComponent_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.enrollment.planName, " ");
} }
function MemberPartialEnrollmentCardComponent_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "vnext-plan-year-badge", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("planYear", ctx_r4.enrollment.planYear)("isDualPlanYearActive", ctx_r4.enrollment.isCurrentYearEnrollment);
} }
function MemberPartialEnrollmentCardComponent_div_2_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.memberEnrollmentUpdatedDate, " ");
} }
function MemberPartialEnrollmentCardComponent_div_2_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.getAuthCodeText(ctx_r6.authCode), " ");
} }
function MemberPartialEnrollmentCardComponent_div_2_div_9_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r16.planAllowsCallRecordingText);
} }
function MemberPartialEnrollmentCardComponent_div_2_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19)(1, "i", 20, 21);
    i0.ɵɵlistener("mouseover", function MemberPartialEnrollmentCardComponent_div_2_div_9_Template_i_mouseover_1_listener() { i0.ɵɵrestoreView(_r18); const _r15 = i0.ɵɵreference(2); return i0.ɵɵresetView(_r15.open()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, MemberPartialEnrollmentCardComponent_div_2_div_9_span_3_Template, 2, 1, "span", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r7.agentCallInProgressAcceptCallIcon);
    i0.ɵɵproperty("disableTooltip", ctx_r7.isMobile)("ngbTooltip", ctx_r7.planAllowsCallRecordingText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r7.isMobile);
} }
const _c0$1A = function (a0) { return { "w-100": a0 }; };
function MemberPartialEnrollmentCardComponent_div_2_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 24, 25);
    i0.ɵɵlistener("click", function MemberPartialEnrollmentCardComponent_div_2_ng_container_10_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r21); const _r19 = i0.ɵɵreference(2); const ctx_r20 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r20.onNavigateToEnrollmentPage(_r19)); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngbTooltip", ctx_r8.enrollerButtonTooltipText)("ngClass", i0.ɵɵpureFunction1(3, _c0$1A, ctx_r8.isMobile));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.continueEnrollmentButtonText, " ");
} }
function MemberPartialEnrollmentCardComponent_div_2_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r10.partialEnrollmentDisabledText);
} }
function MemberPartialEnrollmentCardComponent_div_2_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r11.memberEnrollmentEffectiveDate, " ");
} }
function MemberPartialEnrollmentCardComponent_div_2_div_14_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const riderName_r23 = ctx.$implicit;
    const ctx_r22 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r22.getModifiedRiderName(riderName_r23), " ");
} }
function MemberPartialEnrollmentCardComponent_div_2_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 26);
    i0.ɵɵtemplate(2, MemberPartialEnrollmentCardComponent_div_2_div_14_div_2_Template, 2, 1, "div", 27);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r12.enrollment.riderNames);
} }
function MemberPartialEnrollmentCardComponent_div_2_div_15_vnext_call_recording_audio_player_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-call-recording-audio-player", 30);
} if (rf & 2) {
    const callRecord_r25 = ctx.$implicit;
    const ctx_r24 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("callRecord", callRecord_r25)("pacificStandardTimeText", ctx_r24.pacificStandardTimeText);
} }
function MemberPartialEnrollmentCardComponent_div_2_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MemberPartialEnrollmentCardComponent_div_2_div_15_vnext_call_recording_audio_player_1_Template, 1, 2, "vnext-call-recording-audio-player", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r13.enrollment.agentCallRecords);
} }
function MemberPartialEnrollmentCardComponent_div_2_div_16_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 35);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r26.enrollment.enrolledPremium));
} }
function MemberPartialEnrollmentCardComponent_div_2_div_16_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-plan-fees-tooltip", 36);
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("planFees", ctx_r28.enrollment.fees)("planTotalPremium", ctx_r28.enrollment.enrolledPremium)("planFeesTooltipText", ctx_r28.planFeesTooltipText)("planFeesIncludedInPremiumTooltipText", ctx_r28.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r28.planFeesNotIncludedInPremiumTooltipText)("customClass", "inline-block-layout stacked-xs-content stacked-sm-content")("totalPremiumCustomClass", "Spa_Style_Larger_Font")("tooltipCustomClass", "stacked-xs-content stacked-sm-content");
} }
function MemberPartialEnrollmentCardComponent_div_2_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 31)(2, "h4", 32);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, MemberPartialEnrollmentCardComponent_div_2_div_16_span_4_Template, 3, 3, "span", 33);
    i0.ɵɵtemplate(5, MemberPartialEnrollmentCardComponent_div_2_div_16_ng_template_5_Template, 1, 8, "ng-template", null, 34, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r27 = i0.ɵɵreference(6);
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.totalMonthlyPremiumLabel, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r14.planFeesEnabled || !(ctx_r14.enrollment.fees == null ? null : ctx_r14.enrollment.fees.length))("ngIfElse", _r27);
} }
const _c1$J = function (a0) { return { "pb-2": a0 }; };
function MemberPartialEnrollmentCardComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 5);
    i0.ɵɵtemplate(2, MemberPartialEnrollmentCardComponent_div_2_div_2_Template, 2, 1, "div", 6);
    i0.ɵɵtemplate(3, MemberPartialEnrollmentCardComponent_div_2_div_3_Template, 2, 2, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 8)(5, "div", 9);
    i0.ɵɵtemplate(6, MemberPartialEnrollmentCardComponent_div_2_div_6_Template, 2, 1, "div", 10);
    i0.ɵɵtemplate(7, MemberPartialEnrollmentCardComponent_div_2_div_7_Template, 2, 1, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 11);
    i0.ɵɵtemplate(9, MemberPartialEnrollmentCardComponent_div_2_div_9_Template, 4, 6, "div", 12);
    i0.ɵɵtemplate(10, MemberPartialEnrollmentCardComponent_div_2_ng_container_10_Template, 4, 5, "ng-container", 13);
    i0.ɵɵtemplate(11, MemberPartialEnrollmentCardComponent_div_2_ng_template_11_Template, 2, 1, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(13, MemberPartialEnrollmentCardComponent_div_2_div_13_Template, 2, 1, "div", 10);
    i0.ɵɵtemplate(14, MemberPartialEnrollmentCardComponent_div_2_div_14_Template, 3, 1, "div", 2);
    i0.ɵɵtemplate(15, MemberPartialEnrollmentCardComponent_div_2_div_15_Template, 2, 1, "div", 2);
    i0.ɵɵtemplate(16, MemberPartialEnrollmentCardComponent_div_2_div_16_Template, 7, 3, "div", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r9 = i0.ɵɵreference(12);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.planNameEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.displayPlanYearBadge);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c1$J, ctx_r0.isExpandableDetailViewEnabled && !ctx_r0.isAccountSummaryPage));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.updatedDateEnabled && ctx_r0.memberEnrollmentUpdatedDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.authCode.length);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.allowsCallRecording);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isEnrollmentContinueButtonEnabled || ctx_r0.showContinueButtonForEligiblePartialEnrollment)("ngIfElse", _r9);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.showEffectiveDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.enrollment.riderNames && ctx_r0.ridersEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.enrollment.agentCallRecords == null ? null : ctx_r0.enrollment.agentCallRecords.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.totalMonthlyPremiumEnabled);
} }
function MemberPartialEnrollmentCardComponent_vnext_member_expandable_partial_enrollment_card_3_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-member-expandable-partial-enrollment-card", 37);
    i0.ɵɵlistener("navigateToEnrollmentPage", function MemberPartialEnrollmentCardComponent_vnext_member_expandable_partial_enrollment_card_3_Template_vnext_member_expandable_partial_enrollment_card_navigateToEnrollmentPage_0_listener($event) { i0.ɵɵrestoreView(_r30); const ctx_r29 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r29.onNavigateToEnrollmentPage($event)); });
    i0.ɵɵpipe(1, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("memberEnrollmentPlanName", ctx_r1.enrollment.planName)("planYear", ctx_r1.enrollment.planYear)("planNameEnabled", ctx_r1.planNameEnabled)("planTypeID", ctx_r1.enrollment.planTypeID)("displayPlanYearBadge", ctx_r1.displayPlanYearBadge)("totalMonthlyPremiumLabel", ctx_r1.totalMonthlyPremiumLabel)("continueEnrollmentButtonText", ctx_r1.continueEnrollmentButtonText)("partialEnrollmentEnabled", !ctx_r1.isEnrollmentContinueButtonEnabled || ctx_r1.showContinueButtonForEligiblePartialEnrollment)("partialEnrollmentDisabledText", ctx_r1.partialEnrollmentDisabledText)("memberEnrollmentPremium", i0.ɵɵpipeBind1(1, 15, ctx_r1.enrollment == null ? null : ctx_r1.enrollment.enrolledPremium))("updatedDateEnabled", ctx_r1.updatedDateEnabled)("memberEnrollmentUpdatedDate", ctx_r1.memberEnrollmentUpdatedDate)("planTypeText", ctx_r1.planTypeText)("isMobile", ctx_r1.isMobile)("enrollerButtonTooltipText", ctx_r1.enrollerButtonTooltipText);
} }
function MemberPartialEnrollmentCardComponent_vnext_enrollment_card_details_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-enrollment-card-details", 38);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("enrollmentMoreDetailsText", ctx_r2.enrollmentMoreDetailsText)("showEffectiveDate", ctx_r2.showEffectiveDate)("memberEnrollmentEffectiveDateHeaderText", ctx_r2.memberEnrollmentEffectiveDateHeaderText)("memberEnrollmentEffectiveDate", ctx_r2.memberEnrollmentEffectiveDate)("ridersEnabled", ctx_r2.ridersEnabled)("riderHeaderText", ctx_r2.riderHeaderText)("memberRiders", ctx_r2.enrollment.riderNames)("callRecordingHeaderText", ctx_r2.callRecordingHeaderText)("agentCallRecords", ctx_r2.enrollment.agentCallRecords)("pacificStandardTimeText", ctx_r2.pacificStandardTimeText);
} }
class MemberPartialEnrollmentCardComponent {
    constructor(enrollmentFormService, enrollmentHistoryFacade, modalService, agentCallRecordingFacade, analyticsService, shoppingCartService, cdr, plansService, planYearService, planFacade, localeService, demographicService, cartFacade) {
        this.enrollmentFormService = enrollmentFormService;
        this.enrollmentHistoryFacade = enrollmentHistoryFacade;
        this.modalService = modalService;
        this.agentCallRecordingFacade = agentCallRecordingFacade;
        this.analyticsService = analyticsService;
        this.shoppingCartService = shoppingCartService;
        this.cdr = cdr;
        this.plansService = plansService;
        this.planYearService = planYearService;
        this.planFacade = planFacade;
        this.localeService = localeService;
        this.demographicService = demographicService;
        this.cartFacade = cartFacade;
        this.displayPlanYearBadge = false;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1;
        if (this.isEnrollmentContinueButtonEnabled) {
            const planYear = this.enrollment?.planYear;
            const currentYear = currentDate.getFullYear();
            this.showContinueButtonForEligiblePartialEnrollment =
                (DateUtilities.isAEP(currentMonth) &&
                    MEDICARE_PLAN_TYPE_VALUES.includes(this.enrollment?.planTypeID) &&
                    planYear > currentYear &&
                    this.isPartialEnrollmentAllowedBeforeDate(currentDate, currentYear, this.partialEnrollmentAllowedDate)) ||
                    this.isBefore2ndDayOfNextMonth(this.enrollment?.createdWhen);
        }
        this.displayPlanYearBadge =
            this.showPlanYearBadge &&
                this.enrollment.planYear &&
                this.planYearService.showEnrollmentPlanYearBadgeByPlanType(this.enrollment.planTypeID);
        this.disableExpandableDetailsInAccountSummaryPage = !this.isExpandableDetailViewEnabled || this.isAccountSummaryPage;
        this.subscriptions.add(this.plansService.loaded$(this.enrollment.planTypeID).subscribe((loaded) => {
            if (loaded) {
                this.allowsCallRecording =
                    this.agentCallRecordingFacade.isAgentCallRecordingEnabled() &&
                        this.displayPlanAllowsCallRecordingIconEnabled &&
                        this.shoppingCartService.isMultiCarrierSite() &&
                        this.shoppingCartService.allowsCallRecordingOnMultiCarrier(this.enrollment.planID);
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe(() => {
            this.planTypeText = this.planFacade.getPlanDescriptionById(this.enrollment?.planTypeID);
            this.cdr.markForCheck();
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    getModifiedRiderName(name) {
        return `+ ${name}`;
    }
    getAuthCodeText(authCode) {
        return this.enrollmentHistoryFacade.getSuccessAuthCodeMessage(authCode);
    }
    onNavigateToEnrollmentPage(enrollerButtonTooltip) {
        const enrollmentPlan = { id: this.enrollment.planID, planYear: this.enrollment.planYear };
        const fips = this.demographicService.getSelectedFipsCode();
        const effectiveDate = this.cartFacade.getAgentPlanPermissionEffectiveDate(this.enrollment.planTypeID);
        this.cartFacade.processAgentEnrollPermissions(enrollmentPlan, effectiveDate, fips, enrollerButtonTooltip, () => {
            this.navigateToEnrollmentPage();
        });
    }
    continueToEnrollmentPage() {
        if (this.enrollment.agentCallRecords?.length > 0) {
            this.enrollmentFormService.setCallRecordingAvailable();
        }
        this.updateContinueEnrollmentTag();
        this.enrollmentFormService.navigateToEnrollmentPage(this.enrollment.planID, this.enrollment.planTypeID, this.enrollment.selectedRiderIDs, this.enrollment.userType, `${this.enrollment.planYear ?? ''}`);
    }
    navigateToEnrollmentPage() {
        if (this.agentCallRecordingFacade.isAgentCallRecordingEnabled() &&
            this.agentCallRecordingFacade.isAgentCallRecordingFromProfilePartialEnrollmentEnabled() &&
            this.enrollmentFormService.getUserFormTypeKey(this.enrollment.userType?.toLowerCase()) !== UserTypeKeys.CONSUMER) {
            if (this.shoppingCartService.isMultiCarrierSite()) {
                if (this.shoppingCartService.allowsCallRecordingOnMultiCarrier(this.enrollment.planID)) {
                    this.showAgentCallRecordingModal(() => {
                        this.continueToEnrollmentPage();
                    });
                }
                else {
                    this.continueToEnrollmentPage();
                }
            }
            else {
                this.showAgentCallRecordingModal(() => {
                    this.continueToEnrollmentPage();
                });
            }
        }
        else {
            this.continueToEnrollmentPage();
        }
    }
    showAgentCallRecordingModal(confirmAction) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_CALL_RECORDING_MODAL_OPEN
        };
        const confirmationModal = this.modalService.open(AgentCallRecordingModalComponent, {
            centered: true,
            backdrop: 'static',
            size: 'lg'
        });
        confirmationModal.componentInstance.confirmAction = confirmAction;
    }
    updateContinueEnrollmentTag() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_ACCOUNT_CONTINUE_ENROLLMENT
        };
    }
    isBefore2ndDayOfNextMonth(createdWhen) {
        return (createdWhen && DateUtilities.isBeforeNthDayOfNextMonth(createdWhen, 2)) || false;
    }
    isPartialEnrollmentAllowedBeforeDate(currentDate, currentYear, partialEnrollmentAllowedDate) {
        return DateUtilities.dateTimeBefore(currentDate, new Date(partialEnrollmentAllowedDate + `/${currentYear}`));
    }
}
MemberPartialEnrollmentCardComponent.ɵfac = function MemberPartialEnrollmentCardComponent_Factory(t) { return new (t || MemberPartialEnrollmentCardComponent)(i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(EnrollmentHistoryFacade), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(AgentCallRecordingFacade), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.ShoppingCartService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(i1.PlanYearService), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.DemographicService), i0.ɵɵdirectiveInject(CartFacade)); };
MemberPartialEnrollmentCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MemberPartialEnrollmentCardComponent, selectors: [["vnext-partial-member-enrollment-card"]], inputs: { enrollment: "enrollment", authCode: "authCode", memberEnrollmentUpdatedDate: "memberEnrollmentUpdatedDate", memberEnrollmentEffectiveDate: "memberEnrollmentEffectiveDate", showEffectiveDate: "showEffectiveDate", totalMonthlyPremiumLabel: "totalMonthlyPremiumLabel", planNameEnabled: "planNameEnabled", effectiveDateEnabled: "effectiveDateEnabled", totalMonthlyPremiumEnabled: "totalMonthlyPremiumEnabled", updatedDateEnabled: "updatedDateEnabled", ridersEnabled: "ridersEnabled", continueEnrollmentButtonText: "continueEnrollmentButtonText", pacificStandardTimeText: "pacificStandardTimeText", displayPlanAllowsCallRecordingIconEnabled: "displayPlanAllowsCallRecordingIconEnabled", planAllowsCallRecordingText: "planAllowsCallRecordingText", agentCallInProgressAcceptCallIcon: "agentCallInProgressAcceptCallIcon", isMobile: "isMobile", showPlanYearBadge: "showPlanYearBadge", planFeesEnabled: "planFeesEnabled", planFeesTooltipText: "planFeesTooltipText", planFeesIncludedInPremiumTooltipText: "planFeesIncludedInPremiumTooltipText", planFeesNotIncludedInPremiumTooltipText: "planFeesNotIncludedInPremiumTooltipText", enrollmentMoreDetailsText: "enrollmentMoreDetailsText", memberEnrollmentEffectiveDateHeaderText: "memberEnrollmentEffectiveDateHeaderText", riderHeaderText: "riderHeaderText", callRecordingHeaderText: "callRecordingHeaderText", isExpandableDetailViewEnabled: "isExpandableDetailViewEnabled", isAccountSummaryPage: "isAccountSummaryPage", partialEnrollmentDisabledText: "partialEnrollmentDisabledText", isEnrollmentContinueButtonEnabled: "isEnrollmentContinueButtonEnabled", partialEnrollmentAllowedDate: "partialEnrollmentAllowedDate", enrollerButtonTooltipText: "enrollerButtonTooltipText" }, decls: 5, vars: 3, consts: [[1, "member-enrollment-card-container"], [1, "p-3"], [4, "ngIf"], [3, "memberEnrollmentPlanName", "planYear", "planNameEnabled", "planTypeID", "displayPlanYearBadge", "totalMonthlyPremiumLabel", "continueEnrollmentButtonText", "partialEnrollmentEnabled", "partialEnrollmentDisabledText", "memberEnrollmentPremium", "updatedDateEnabled", "memberEnrollmentUpdatedDate", "planTypeText", "isMobile", "enrollerButtonTooltipText", "navigateToEnrollmentPage", 4, "ngIf"], [3, "enrollmentMoreDetailsText", "showEffectiveDate", "memberEnrollmentEffectiveDateHeaderText", "memberEnrollmentEffectiveDate", "ridersEnabled", "riderHeaderText", "memberRiders", "callRecordingHeaderText", "agentCallRecords", "pacificStandardTimeText", 4, "ngIf"], [1, "d-flex", "pb-2"], ["class", "Spa_Style_Primary_Color Spa_Style_Regular_Font mt-4 mt-sm-0 no-translate-block", 4, "ngIf"], ["class", "enrollment-plan-year-badge", 4, "ngIf"], [1, "row", 3, "ngClass"], [1, "col-lg-6"], ["class", "Spa_Style_Gray4_Color Spa_Style_Smaller_Font", 4, "ngIf"], [1, "col-lg-6", "text-left", "text-sm-right", "d-flex", "flex-column", "flex-sm-row", "justify-content-end", "align-items-start", "align-items-sm-center"], ["class", "Spa_Style_Gray4_Color mr-2 pt-2 pb-2", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["showAlternateText", ""], [1, "Spa_Style_Primary_Color", "Spa_Style_Regular_Font", "mt-4", "mt-sm-0", "no-translate-block"], [1, "enrollment-plan-year-badge"], [3, "planYear", "isDualPlanYearActive"], [1, "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font"], [1, "Spa_Style_Gray4_Color", "mr-2", "pt-2", "pb-2"], ["aria-hidden", "true", 3, "disableTooltip", "ngbTooltip", "mouseover"], ["allowsRecordingTooltip", "ngbTooltip"], ["class", "ml-2", 4, "ngIf"], [1, "ml-2"], ["triggers", "manual", 1, "btn", "Spa_Style_SecondaryButton", 3, "ngbTooltip", "ngClass", "click"], ["enrollerButtonTooltip", "ngbTooltip"], [1, "pt-2"], ["class", "d-inline Spa_Style_Gray4_Color Spa_Style_Small_Font mr-1 no-translate-block", 4, "ngFor", "ngForOf"], [1, "d-inline", "Spa_Style_Gray4_Color", "Spa_Style_Small_Font", "mr-1", "no-translate-block"], [3, "callRecord", "pacificStandardTimeText", 4, "ngFor", "ngForOf"], [3, "callRecord", "pacificStandardTimeText"], [1, "col-12", "flex-column", "flex-md-row", "justify-content-end", "total-premium-banner", "Spa_Style_Cost_Background"], [1, "Spa_Style_H4", "d-sm-block", "d-lg-inline-block", "mb-lg-0"], ["class", "Spa_Style_Larger_Font Spa_Style_CostPremiumSmall ml-3", 4, "ngIf", "ngIfElse"], ["showPremiumWithFees", ""], [1, "Spa_Style_Larger_Font", "Spa_Style_CostPremiumSmall", "ml-3"], [1, "ml-3", 3, "planFees", "planTotalPremium", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "customClass", "totalPremiumCustomClass", "tooltipCustomClass"], [3, "memberEnrollmentPlanName", "planYear", "planNameEnabled", "planTypeID", "displayPlanYearBadge", "totalMonthlyPremiumLabel", "continueEnrollmentButtonText", "partialEnrollmentEnabled", "partialEnrollmentDisabledText", "memberEnrollmentPremium", "updatedDateEnabled", "memberEnrollmentUpdatedDate", "planTypeText", "isMobile", "enrollerButtonTooltipText", "navigateToEnrollmentPage"], [3, "enrollmentMoreDetailsText", "showEffectiveDate", "memberEnrollmentEffectiveDateHeaderText", "memberEnrollmentEffectiveDate", "ridersEnabled", "riderHeaderText", "memberRiders", "callRecordingHeaderText", "agentCallRecords", "pacificStandardTimeText"]], template: function MemberPartialEnrollmentCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, MemberPartialEnrollmentCardComponent_div_2_Template, 17, 14, "div", 2);
        i0.ɵɵtemplate(3, MemberPartialEnrollmentCardComponent_vnext_member_expandable_partial_enrollment_card_3_Template, 2, 17, "vnext-member-expandable-partial-enrollment-card", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, MemberPartialEnrollmentCardComponent_vnext_enrollment_card_details_4_Template, 1, 10, "vnext-enrollment-card-details", 4);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.disableExpandableDetailsInAccountSummaryPage);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isExpandableDetailViewEnabled && !ctx.isAccountSummaryPage);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isExpandableDetailViewEnabled && !ctx.isAccountSummaryPage);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, PlanYearBadgeComponent, i1$1.NgbTooltip, PlanFeesTooltipComponent, MemberExpandablePartialEnrollmentCardComponent, EnrollmentCardDetailsComponent, CallRecordingAudioPlayerComponent, i1$2.CurrencyPipe], styles: [".member-enrollment-card-container[_ngcontent-%COMP%]{position:relative;margin-top:18px;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;border:1px solid var(--static-Spa_Style_Accent1);border-radius:4px}.total-premium-banner[_ngcontent-%COMP%]{display:flex;border-radius:5px;padding:7px 12px;align-items:center}.enrollment-plan-year-badge[_ngcontent-%COMP%]{margin-left:auto}@media (max-width: 768px){.total-premium-banner[_ngcontent-%COMP%]{align-items:flex-end}}.document-separator[_ngcontent-%COMP%]{border-top:1px solid var(--static-Spa_Style_Gray2);border-bottom:1px solid var(--static-Spa_Style_Gray2);margin:2px}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], MemberPartialEnrollmentCardComponent.prototype, "onNavigateToEnrollmentPage", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberPartialEnrollmentCardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-partial-member-enrollment-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"member-enrollment-card-container\">\r\n  <div class=\"p-3\">\r\n    <div *ngIf=\"disableExpandableDetailsInAccountSummaryPage\">\r\n      <div class=\"d-flex pb-2\">\r\n        <div *ngIf=\"planNameEnabled\" class=\"Spa_Style_Primary_Color Spa_Style_Regular_Font mt-4 mt-sm-0 no-translate-block\">\r\n          {{ enrollment.planName }}\r\n        </div>\r\n        <div class=\"enrollment-plan-year-badge\" *ngIf=\"displayPlanYearBadge\">\r\n          <vnext-plan-year-badge [planYear]=\"enrollment.planYear\" [isDualPlanYearActive]=\"enrollment.isCurrentYearEnrollment\">\r\n          </vnext-plan-year-badge>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\" [ngClass]=\"{ 'pb-2': isExpandableDetailViewEnabled && !isAccountSummaryPage }\">\r\n        <div class=\"col-lg-6\">\r\n          <div *ngIf=\"updatedDateEnabled && memberEnrollmentUpdatedDate\" class=\"Spa_Style_Gray4_Color Spa_Style_Smaller_Font\">\r\n            {{ memberEnrollmentUpdatedDate }}\r\n          </div>\r\n          <div *ngIf=\"authCode.length\" class=\"Spa_Style_Gray4_Color Spa_Style_Smaller_Font\">\r\n            {{ getAuthCodeText(authCode) }}\r\n          </div>\r\n        </div>\r\n        <div\r\n          class=\"col-lg-6 text-left text-sm-right d-flex flex-column flex-sm-row justify-content-end align-items-start align-items-sm-center\"\r\n        >\r\n          <div *ngIf=\"allowsCallRecording\" class=\"Spa_Style_Gray4_Color mr-2 pt-2 pb-2\">\r\n            <i\r\n              [disableTooltip]=\"isMobile\"\r\n              #allowsRecordingTooltip=\"ngbTooltip\"\r\n              [ngbTooltip]=\"planAllowsCallRecordingText\"\r\n              (mouseover)=\"allowsRecordingTooltip.open()\"\r\n              class=\"{{ agentCallInProgressAcceptCallIcon }}\"\r\n              aria-hidden=\"true\"\r\n            ></i>\r\n            <span class=\"ml-2\" *ngIf=\"isMobile\">{{ planAllowsCallRecordingText }}</span>\r\n          </div>\r\n          <ng-container\r\n            *ngIf=\"!isEnrollmentContinueButtonEnabled || showContinueButtonForEligiblePartialEnrollment; else showAlternateText\"\r\n          >\r\n            <button\r\n              class=\"btn Spa_Style_SecondaryButton\"\r\n              triggers=\"manual\"\r\n              #enrollerButtonTooltip=\"ngbTooltip\"\r\n              [ngbTooltip]=\"enrollerButtonTooltipText\"\r\n              [ngClass]=\"{ 'w-100': isMobile }\"\r\n              (click)=\"onNavigateToEnrollmentPage(enrollerButtonTooltip)\"\r\n            >\r\n              {{ continueEnrollmentButtonText }}\r\n            </button>\r\n          </ng-container>\r\n          <ng-template #showAlternateText>\r\n            <div class=\"Spa_Style_Gray4_Color Spa_Style_Smaller_Font\">{{ partialEnrollmentDisabledText }}</div>\r\n          </ng-template>\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"showEffectiveDate\" class=\"Spa_Style_Gray4_Color Spa_Style_Smaller_Font\">\r\n        {{ memberEnrollmentEffectiveDate }}\r\n      </div>\r\n      <div *ngIf=\"enrollment.riderNames && ridersEnabled\">\r\n        <div class=\"pt-2\">\r\n          <div *ngFor=\"let riderName of enrollment.riderNames\" class=\"d-inline Spa_Style_Gray4_Color Spa_Style_Small_Font mr-1 no-translate-block\">\r\n            {{ getModifiedRiderName(riderName) }}\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"enrollment.agentCallRecords?.length\">\r\n        <vnext-call-recording-audio-player\r\n          *ngFor=\"let callRecord of enrollment.agentCallRecords\"\r\n          [callRecord]=\"callRecord\"\r\n          [pacificStandardTimeText]=\"pacificStandardTimeText\"\r\n        ></vnext-call-recording-audio-player>\r\n      </div>\r\n      <div *ngIf=\"totalMonthlyPremiumEnabled\">\r\n        <div class=\"col-12 flex-column flex-md-row justify-content-end total-premium-banner Spa_Style_Cost_Background\">\r\n          <h4 class=\"Spa_Style_H4 d-sm-block d-lg-inline-block mb-lg-0\">\r\n            {{ totalMonthlyPremiumLabel }}\r\n          </h4>\r\n          <span\r\n            *ngIf=\"!planFeesEnabled || !enrollment.fees?.length; else showPremiumWithFees\"\r\n            class=\"Spa_Style_Larger_Font Spa_Style_CostPremiumSmall ml-3\"\r\n            >{{ enrollment.enrolledPremium | currency }}</span\r\n          >\r\n\r\n          <ng-template #showPremiumWithFees>\r\n            <vnext-widget-plan-fees-tooltip\r\n              class=\"ml-3\"\r\n              [planFees]=\"enrollment.fees\"\r\n              [planTotalPremium]=\"enrollment.enrolledPremium\"\r\n              [planFeesTooltipText]=\"planFeesTooltipText\"\r\n              [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n              [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n              [customClass]=\"'inline-block-layout stacked-xs-content stacked-sm-content'\"\r\n              [totalPremiumCustomClass]=\"'Spa_Style_Larger_Font'\"\r\n              [tooltipCustomClass]=\"'stacked-xs-content stacked-sm-content'\"\r\n            ></vnext-widget-plan-fees-tooltip>\r\n          </ng-template>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <vnext-member-expandable-partial-enrollment-card\r\n      *ngIf=\"isExpandableDetailViewEnabled && !isAccountSummaryPage\"\r\n      [memberEnrollmentPlanName]=\"enrollment.planName\"\r\n      [planYear]=\"enrollment.planYear\"\r\n      [planNameEnabled]=\"planNameEnabled\"\r\n      [planTypeID]=\"enrollment.planTypeID\"\r\n      [displayPlanYearBadge]=\"displayPlanYearBadge\"\r\n      [totalMonthlyPremiumLabel]=\"totalMonthlyPremiumLabel\"\r\n      [continueEnrollmentButtonText]=\"continueEnrollmentButtonText\"\r\n      [partialEnrollmentEnabled]=\"!isEnrollmentContinueButtonEnabled || showContinueButtonForEligiblePartialEnrollment\"\r\n      [partialEnrollmentDisabledText]=\"partialEnrollmentDisabledText\"\r\n      [memberEnrollmentPremium]=\"enrollment?.enrolledPremium | currency\"\r\n      [updatedDateEnabled]=\"updatedDateEnabled\"\r\n      [memberEnrollmentUpdatedDate]=\"memberEnrollmentUpdatedDate\"\r\n      [planTypeText]=\"planTypeText\"\r\n      [isMobile]=\"isMobile\"\r\n      [enrollerButtonTooltipText]=\"enrollerButtonTooltipText\"\r\n      (navigateToEnrollmentPage)=\"onNavigateToEnrollmentPage($event)\"\r\n    ></vnext-member-expandable-partial-enrollment-card>\r\n  </div>\r\n  <vnext-enrollment-card-details\r\n    *ngIf=\"isExpandableDetailViewEnabled && !isAccountSummaryPage\"\r\n    [enrollmentMoreDetailsText]=\"enrollmentMoreDetailsText\"\r\n    [showEffectiveDate]=\"showEffectiveDate\"\r\n    [memberEnrollmentEffectiveDateHeaderText]=\"memberEnrollmentEffectiveDateHeaderText\"\r\n    [memberEnrollmentEffectiveDate]=\"memberEnrollmentEffectiveDate\"\r\n    [ridersEnabled]=\"ridersEnabled\"\r\n    [riderHeaderText]=\"riderHeaderText\"\r\n    [memberRiders]=\"enrollment.riderNames\"\r\n    [callRecordingHeaderText]=\"callRecordingHeaderText\"\r\n    [agentCallRecords]=\"enrollment.agentCallRecords\"\r\n    [pacificStandardTimeText]=\"pacificStandardTimeText\"\r\n  ></vnext-enrollment-card-details>\r\n</div>\r\n", styles: [".member-enrollment-card-container{position:relative;margin-top:18px;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;border:1px solid var(--static-Spa_Style_Accent1);border-radius:4px}.total-premium-banner{display:flex;border-radius:5px;padding:7px 12px;align-items:center}.enrollment-plan-year-badge{margin-left:auto}@media (max-width: 768px){.total-premium-banner{align-items:flex-end}}.document-separator{border-top:1px solid var(--static-Spa_Style_Gray2);border-bottom:1px solid var(--static-Spa_Style_Gray2);margin:2px}\n"] }]
    }], function () { return [{ type: i1.EnrollmentFormService }, { type: EnrollmentHistoryFacade }, { type: i1$1.NgbModal }, { type: AgentCallRecordingFacade }, { type: AnalyticsService }, { type: i1.ShoppingCartService }, { type: i0.ChangeDetectorRef }, { type: i1.PlansService }, { type: i1.PlanYearService }, { type: PlanFacade }, { type: i1.LocaleService }, { type: i1.DemographicService }, { type: CartFacade }]; }, { enrollment: [{
            type: Input
        }], authCode: [{
            type: Input
        }], memberEnrollmentUpdatedDate: [{
            type: Input
        }], memberEnrollmentEffectiveDate: [{
            type: Input
        }], showEffectiveDate: [{
            type: Input
        }], totalMonthlyPremiumLabel: [{
            type: Input
        }], planNameEnabled: [{
            type: Input
        }], effectiveDateEnabled: [{
            type: Input
        }], totalMonthlyPremiumEnabled: [{
            type: Input
        }], updatedDateEnabled: [{
            type: Input
        }], ridersEnabled: [{
            type: Input
        }], continueEnrollmentButtonText: [{
            type: Input
        }], pacificStandardTimeText: [{
            type: Input
        }], displayPlanAllowsCallRecordingIconEnabled: [{
            type: Input
        }], planAllowsCallRecordingText: [{
            type: Input
        }], agentCallInProgressAcceptCallIcon: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], showPlanYearBadge: [{
            type: Input
        }], planFeesEnabled: [{
            type: Input
        }], planFeesTooltipText: [{
            type: Input
        }], planFeesIncludedInPremiumTooltipText: [{
            type: Input
        }], planFeesNotIncludedInPremiumTooltipText: [{
            type: Input
        }], enrollmentMoreDetailsText: [{
            type: Input
        }], memberEnrollmentEffectiveDateHeaderText: [{
            type: Input
        }], riderHeaderText: [{
            type: Input
        }], callRecordingHeaderText: [{
            type: Input
        }], isExpandableDetailViewEnabled: [{
            type: Input
        }], isAccountSummaryPage: [{
            type: Input
        }], partialEnrollmentDisabledText: [{
            type: Input
        }], isEnrollmentContinueButtonEnabled: [{
            type: Input
        }], partialEnrollmentAllowedDate: [{
            type: Input
        }], enrollerButtonTooltipText: [{
            type: Input
        }], onNavigateToEnrollmentPage: [] }); })();

function MemberEnrollmentHistoryComponent_h2_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.memberEnrollmentHistoryHeaderText, " ");
} }
function MemberEnrollmentHistoryComponent_ng_container_3_ng_container_1_vnext_partial_member_enrollment_card_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-partial-member-enrollment-card", 10);
} if (rf & 2) {
    const enrollmentDetails_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("enrollment", enrollmentDetails_r6.memberEnrollment)("memberEnrollmentUpdatedDate", enrollmentDetails_r6.updatedDate)("memberEnrollmentEffectiveDate", enrollmentDetails_r6.effectiveDate)("showEffectiveDate", enrollmentDetails_r6.showEffectiveDate)("totalMonthlyPremiumLabel", ctx_r7.totalMonthlyPremiumLabel)("planNameEnabled", ctx_r7.planNameEnabled)("effectiveDateEnabled", ctx_r7.effectiveDateEnabled)("totalMonthlyPremiumEnabled", ctx_r7.totalMonthlyPremiumEnabled)("updatedDateEnabled", ctx_r7.updatedDateEnabled)("ridersEnabled", ctx_r7.ridersEnabled)("continueEnrollmentButtonText", ctx_r7.continueEnrollmentButtonText)("authCode", enrollmentDetails_r6.authCode)("pacificStandardTimeText", ctx_r7.pacificStandardTimeText)("displayPlanAllowsCallRecordingIconEnabled", ctx_r7.displayPlanAllowsCallRecordingIconEnabled)("planAllowsCallRecordingText", ctx_r7.planAllowsCallRecordingText)("agentCallInProgressAcceptCallIcon", ctx_r7.agentCallInProgressAcceptCallIcon)("isMobile", ctx_r7.isMobile)("showPlanYearBadge", ctx_r7.showPlanYearBadge)("planFeesEnabled", ctx_r7.planFeesEnabled)("planFeesTooltipText", ctx_r7.planFeesTooltipText)("planFeesIncludedInPremiumTooltipText", ctx_r7.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r7.planFeesNotIncludedInPremiumTooltipText)("enrollmentMoreDetailsText", ctx_r7.enrollmentMoreDetailsText)("memberEnrollmentEffectiveDateHeaderText", ctx_r7.memberEnrollmentEffectiveDateHeaderText)("riderHeaderText", ctx_r7.riderHeaderText)("callRecordingHeaderText", ctx_r7.callRecordingHeaderText)("isExpandableDetailViewEnabled", ctx_r7.enrollmentHistoryProfileLinkEnabled)("isAccountSummaryPage", ctx_r7.isAccountSummaryPage)("partialEnrollmentDisabledText", ctx_r7.partialEnrollmentDisabledText)("isEnrollmentContinueButtonEnabled", ctx_r7.isEnrollmentContinueButtonEnabled)("partialEnrollmentAllowedDate", ctx_r7.partialEnrollmentAllowedDate)("enrollerButtonTooltipText", ctx_r7.enrollerButtonTooltipText);
} }
function MemberEnrollmentHistoryComponent_ng_container_3_ng_container_1_vnext_member_enrollment_card_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-member-enrollment-card", 11);
} if (rf & 2) {
    const enrollmentDetails_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("memberEnrollment", enrollmentDetails_r6.memberEnrollment)("memberEnrollmentSubmittedDate", enrollmentDetails_r6.submittedDate)("memberEnrollmentEffectiveDate", enrollmentDetails_r6.effectiveDate)("showEffectiveDate", enrollmentDetails_r6.showEffectiveDate)("enrollmentStatus", enrollmentDetails_r6.latestStatus)("totalMonthlyPremiumLabel", ctx_r8.totalMonthlyPremiumLabel)("viewApplicationLinkText", ctx_r8.viewApplicationLinkText)("confirmationText", enrollmentDetails_r6.memberEnrollment.isCurrentYearEnrollment || enrollmentDetails_r6.memberEnrollment.confirmationNumber ? ctx_r8.confirmationText : "")("confirmationNumberEnabled", ctx_r8.confirmationNumberEnabled)("planNameEnabled", ctx_r8.planNameEnabled)("effectiveDateEnabled", ctx_r8.effectiveDateEnabled)("totalMonthlyPremiumEnabled", enrollmentDetails_r6.memberEnrollment.isCurrentYearEnrollment || enrollmentDetails_r6.memberEnrollment.enrolledPremium ? ctx_r8.totalMonthlyPremiumEnabled : false)("submissionDateEnabled", ctx_r8.submissionDateEnabled)("ridersEnabled", ctx_r8.ridersEnabled)("hraConfirmationNumberEnabled", ctx_r8.hraConfirmationNumberEnabled && enrollmentDetails_r6.memberEnrollment.isCurrentYearEnrollment)("hraConfirmationText", ctx_r8.hraConfirmationText)("hraPDFLinkText", ctx_r8.hraPDFLinkText)("agentCallRecords", enrollmentDetails_r6.memberEnrollment.agentCallRecords)("pacificStandardTimeText", ctx_r8.pacificStandardTimeText)("isHRAEnabled", ctx_r8.isHRAEnabled)("completeHRAButtonEnabled", ctx_r8.completeHRAButtonEnabled)("openExternalInNewTab", ctx_r8.openExternalInNewTab)("completeHRAButtonText", ctx_r8.completeHRAButtonText)("completeHRALastVisitedText", ctx_r8.completeHRALastVisitedText)("completeHRADaysLeftText", ctx_r8.completeHRADaysLeftText)("showPlanYearBadge", ctx_r8.showPlanYearBadge)("planYear", enrollmentDetails_r6.memberEnrollment.planYear)("isActivePlanYear", enrollmentDetails_r6.memberEnrollment.isCurrentYearEnrollment)("planFeesEnabled", ctx_r8.planFeesEnabled)("planFeesTooltipText", ctx_r8.planFeesTooltipText)("planFeesIncludedInPremiumTooltipText", ctx_r8.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r8.planFeesNotIncludedInPremiumTooltipText)("enrollmentStatusHeaderText", ctx_r8.enrollmentStatusHeaderText)("enrollmentMoreDetailsText", ctx_r8.enrollmentMoreDetailsText)("enrollmentHraHeaderText", ctx_r8.enrollmentHraHeaderText)("enrollmentConfirmationHeaderText", ctx_r8.enrollmentConfirmationHeaderText)("memberEnrollmentEffectiveDateHeaderText", ctx_r8.memberEnrollmentEffectiveDateHeaderText)("riderHeaderText", ctx_r8.riderHeaderText)("callRecordingHeaderText", ctx_r8.callRecordingHeaderText)("uploadDocumentHeaderText", ctx_r8.uploadDocumentHeaderText)("valueBasedCareConfirmationEnabled", ctx_r8.valueBasedCareConfirmationEnabled)("valueBasedCareConfirmationText", ctx_r8.valueBasedCareConfirmationText)("valueBasedCareProviders", ctx_r8.valueBasedCareProviders)("isExpandableDetailViewEnabled", ctx_r8.enrollmentHistoryProfileLinkEnabled)("isAccountSummaryPage", ctx_r8.isAccountSummaryPage)("valueBasedCareConfirmationExpiration", ctx_r8.valueBasedCareConfirmationExpiration)("isHRAPDFAccessEnabled", ctx_r8.isHRAPDFAccessEnabled)("isProfileAdmin", ctx_r8.isProfileAdmin)("isCompleteHRAProfileAdminEnabled", ctx_r8.isCompleteHRAProfileAdminEnabled)("excludedCarrierIds", ctx_r8.excludedCarrierIds);
} }
function MemberEnrollmentHistoryComponent_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MemberEnrollmentHistoryComponent_ng_container_3_ng_container_1_vnext_partial_member_enrollment_card_1_Template, 1, 32, "vnext-partial-member-enrollment-card", 8);
    i0.ɵɵtemplate(2, MemberEnrollmentHistoryComponent_ng_container_3_ng_container_1_vnext_member_enrollment_card_2_Template, 1, 50, "vnext-member-enrollment-card", 9);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const enrollmentDetails_r6 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", enrollmentDetails_r6.memberEnrollment && !enrollmentDetails_r6.memberEnrollment.completedWhen);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !!(enrollmentDetails_r6.memberEnrollment == null ? null : enrollmentDetails_r6.memberEnrollment.completedWhen));
} }
function MemberEnrollmentHistoryComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MemberEnrollmentHistoryComponent_ng_container_3_ng_container_1_Template, 3, 2, "ng-container", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.memberEnrollmentsDetails);
} }
function MemberEnrollmentHistoryComponent_ng_container_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r11.noEnrollmentMessageText, " ");
} }
function MemberEnrollmentHistoryComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MemberEnrollmentHistoryComponent_ng_container_4_div_1_Template, 2, 1, "div", 12);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentHistory_NoEnrollmentMessageText");
} }
function MemberEnrollmentHistoryComponent_ng_template_5_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "vnext-link", 16);
    i0.ɵɵlistener("click", function MemberEnrollmentHistoryComponent_ng_template_5_div_0_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.redirectToCompletedEnrollmentHistoryPage()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r12.enrollmentHistoryLinkText)("alwaysUnderlined", true)("showArrow", "right");
} }
function MemberEnrollmentHistoryComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, MemberEnrollmentHistoryComponent_ng_template_5_div_0_Template, 2, 3, "div", 14);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r4.enrollmentHistoryProfileLinkEnabled);
} }
const _c0$1z = function (a0) { return { "col-md-12": a0 }; };
class MemberEnrollmentHistoryComponent {
    constructor(datePipe, navigationService) {
        this.datePipe = datePipe;
        this.navigationService = navigationService;
        // SPA-15613: The API orders the member enrollments from most recent at the top - regardless of Partial vs. Completed status
        // Enabled by default for broker sites. To disable it for consumer sites, we have to pass `[keepDefaultAPIEnrollmentOrdering]="false"`
        this.keepDefaultAPIEnrollmentOrdering = true;
        this.isComponentFullWidth = false;
        this.excludedCarrierIds = [];
    }
    ngOnChanges(changes) {
        const { memberEnrollments, effectiveDateEnabled, keepDefaultAPIEnrollmentOrdering, enrollmentHistoryProfileLinkEnabled, memberEnrollmentHistoryEffectiveDateText, submittedDateText, pacificStandardTimeText, enrollmentStatusEnabled, memberEnrollmentStatus, statusText, defaultStatusText, statusDateText, lastUpdatedText, memberQuoteHistory } = changes;
        if ((memberEnrollments && !_isEqual(memberEnrollments.previousValue, memberEnrollments.currentValue)) ||
            (keepDefaultAPIEnrollmentOrdering &&
                keepDefaultAPIEnrollmentOrdering.previousValue !== keepDefaultAPIEnrollmentOrdering.currentValue) ||
            (effectiveDateEnabled && effectiveDateEnabled.previousValue !== effectiveDateEnabled.currentValue) ||
            (enrollmentHistoryProfileLinkEnabled &&
                enrollmentHistoryProfileLinkEnabled.previousValue !== enrollmentHistoryProfileLinkEnabled.currentValue) ||
            (memberEnrollmentHistoryEffectiveDateText &&
                memberEnrollmentHistoryEffectiveDateText.previousValue !== memberEnrollmentHistoryEffectiveDateText.currentValue) ||
            (submittedDateText && submittedDateText.previousValue !== submittedDateText.currentValue) ||
            (pacificStandardTimeText && pacificStandardTimeText.previousValue !== pacificStandardTimeText.currentValue) ||
            (enrollmentStatusEnabled && enrollmentStatusEnabled.previousValue !== enrollmentStatusEnabled.currentValue) ||
            (memberEnrollmentStatus && !_isEqual(memberEnrollmentStatus.previousValue, memberEnrollmentStatus.currentValue)) ||
            (statusText && statusText.previousValue !== statusText.currentValue) ||
            (defaultStatusText && defaultStatusText.previousValue !== defaultStatusText.currentValue) ||
            (statusDateText && statusDateText.previousValue !== statusDateText.currentValue) ||
            (lastUpdatedText && lastUpdatedText.previousValue !== lastUpdatedText.currentValue) ||
            (memberQuoteHistory && !_isEqual(memberQuoteHistory.previousValue, memberQuoteHistory.currentValue))) {
            if (this.keepDefaultAPIEnrollmentOrdering) {
                this.memberEnrollmentsDetails =
                    this.memberEnrollments?.map(memberEnrollment => this.getMemberEnrollmentDetails(memberEnrollment)) ?? [];
            }
            else {
                this.memberEnrollmentsDetails = this.getOrderedMemberEnrollmentsDetailsByStatus(this.memberEnrollments);
            }
        }
    }
    getRequestedEffectiveDate(effectiveDate) {
        const convertedDate = this.datePipe.transform(effectiveDate, DatePipeFormats.DATE);
        return this.enrollmentHistoryProfileLinkEnabled
            ? `${convertedDate}`
            : `${this.memberEnrollmentHistoryEffectiveDateText} ${convertedDate}`;
    }
    showEffectiveDate(effectiveDate, planTypeId) {
        return !!effectiveDate && this.effectiveDateEnabled && planTypeId === PlanType.MEDIGAP;
    }
    getSubmittedDate(submittedDate) {
        if (!submittedDate) {
            return null;
        }
        return `${this.submittedDateText} ${DateUtilities.getDateFromUtc(submittedDate)} ${this.pacificStandardTimeText}`;
    }
    getUpdatedDate(updatedDate) {
        if (!updatedDate) {
            return null;
        }
        return `${this.lastUpdatedText} ${DateUtilities.getDateFromUtc(updatedDate)} ${this.pacificStandardTimeText}`;
    }
    // The latest enrollment quote authcode for a given plan may be obtained with
    // the plan id and quote history (filtered by quoteType).
    // The Quotes endpoint provides a quoteType and plan id.
    getEnrollmentAuthCode(memberEnrollment) {
        // Find member quote history by EnrollmentQuote quoteType and by member enrollment plan id.
        const quote = this.memberQuoteHistory?.find(enrollmentQuote => enrollmentQuote.quoteType === QuoteType.ENROLLMENTQUOTE && enrollmentQuote.planIds.includes(memberEnrollment.planID));
        return quote?.authCode ?? '';
    }
    getLatestEnrollmentStatus(nativeTransactionID) {
        if (this.enrollmentStatusEnabled) {
            const statuses = this.memberEnrollmentStatus?.find(enrollmentStatus => enrollmentStatus.transactionGUID === nativeTransactionID)?.statuses;
            const enrollmentStatus = { ...statuses?.find(status => status.lastUpdated) };
            if (enrollmentStatus?.status) {
                enrollmentStatus.status = `${this.statusText} ${enrollmentStatus.status}`;
            }
            else {
                enrollmentStatus.status = this.defaultStatusText;
            }
            if (enrollmentStatus?.statusDate) {
                enrollmentStatus.statusDate = `${this.statusDateText} ${DateUtilities.getFormattedDateTime(new Date(enrollmentStatus.statusDate), DateUtilities.defaultFormat)}`;
            }
            return enrollmentStatus;
        }
        return null;
    }
    redirectToCompletedEnrollmentHistoryPage() {
        this.navigationService.navigateByPageTag(PageTags.COMPLETED_ENROLLMENTS);
    }
    getMemberEnrollmentDetails(memberEnrollment) {
        const memberEnrollmentDetails = {
            memberEnrollment,
            effectiveDate: this.getRequestedEffectiveDate(memberEnrollment.effectiveDate),
            showEffectiveDate: this.showEffectiveDate(memberEnrollment.effectiveDate, memberEnrollment.planTypeID)
        };
        if (!!memberEnrollment.completedWhen) {
            memberEnrollmentDetails.submittedDate = this.getSubmittedDate(memberEnrollment.completedWhen);
            if (memberEnrollment.isCurrentYearEnrollment) {
                memberEnrollmentDetails.latestStatus = this.getLatestEnrollmentStatus(memberEnrollment.nativeTransactionID);
            }
        }
        else {
            memberEnrollmentDetails.updatedDate = this.getUpdatedDate(memberEnrollment.modifiedWhen);
            memberEnrollmentDetails.authCode = this.getEnrollmentAuthCode(memberEnrollment);
        }
        return memberEnrollmentDetails;
    }
    getMemberEnrollmentsByStatus(memberEnrollments) {
        const defaultMemberEnrollmentsByStatus = {
            partial: [],
            completed: []
        };
        return (memberEnrollments?.reduce((groups, memberEnrollment) => {
            const enrollmentStatus = !!memberEnrollment.completedWhen ? 'completed' : 'partial';
            groups[enrollmentStatus]?.push(this.getMemberEnrollmentDetails(memberEnrollment));
            return groups;
        }, defaultMemberEnrollmentsByStatus) ?? defaultMemberEnrollmentsByStatus);
    }
    getOrderedMemberEnrollmentsDetailsByStatus(memberEnrollments) {
        const memberEnrollmentsByStatus = this.getMemberEnrollmentsByStatus(memberEnrollments);
        const partialEnrollmentsDetails = memberEnrollmentsByStatus?.partial ?? [];
        const completedEnrollmentsDetails = memberEnrollmentsByStatus?.completed ?? [];
        return [...partialEnrollmentsDetails, ...completedEnrollmentsDetails];
    }
}
MemberEnrollmentHistoryComponent.ɵfac = function MemberEnrollmentHistoryComponent_Factory(t) { return new (t || MemberEnrollmentHistoryComponent)(i0.ɵɵdirectiveInject(i1$2.DatePipe), i0.ɵɵdirectiveInject(i1.NavigationService)); };
MemberEnrollmentHistoryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MemberEnrollmentHistoryComponent, selectors: [["vnext-member-enrollment-history"]], inputs: { memberEnrollments: "memberEnrollments", keepDefaultAPIEnrollmentOrdering: "keepDefaultAPIEnrollmentOrdering", memberQuoteHistory: "memberQuoteHistory", memberEnrollmentHistoryHeaderText: "memberEnrollmentHistoryHeaderText", noEnrollmentMessageText: "noEnrollmentMessageText", pacificStandardTimeText: "pacificStandardTimeText", memberEnrollmentHistoryEffectiveDateText: "memberEnrollmentHistoryEffectiveDateText", totalMonthlyPremiumLabel: "totalMonthlyPremiumLabel", viewApplicationLinkText: "viewApplicationLinkText", confirmationText: "confirmationText", submittedDateText: "submittedDateText", confirmationNumberEnabled: "confirmationNumberEnabled", planNameEnabled: "planNameEnabled", effectiveDateEnabled: "effectiveDateEnabled", totalMonthlyPremiumEnabled: "totalMonthlyPremiumEnabled", submissionDateEnabled: "submissionDateEnabled", ridersEnabled: "ridersEnabled", lastUpdatedText: "lastUpdatedText", continueEnrollmentButtonText: "continueEnrollmentButtonText", updatedDateEnabled: "updatedDateEnabled", hraPDFLinkText: "hraPDFLinkText", hraConfirmationText: "hraConfirmationText", hraConfirmationNumberEnabled: "hraConfirmationNumberEnabled", isComponentFullWidth: "isComponentFullWidth", displayPlanAllowsCallRecordingIconEnabled: "displayPlanAllowsCallRecordingIconEnabled", planAllowsCallRecordingText: "planAllowsCallRecordingText", agentCallInProgressAcceptCallIcon: "agentCallInProgressAcceptCallIcon", isHRAEnabled: "isHRAEnabled", completeHRAButtonEnabled: "completeHRAButtonEnabled", openExternalInNewTab: "openExternalInNewTab", completeHRAButtonText: "completeHRAButtonText", completeHRALastVisitedText: "completeHRALastVisitedText", completeHRADaysLeftText: "completeHRADaysLeftText", isMobile: "isMobile", showPlanYearBadge: "showPlanYearBadge", planFeesEnabled: "planFeesEnabled", planFeesTooltipText: "planFeesTooltipText", planFeesIncludedInPremiumTooltipText: "planFeesIncludedInPremiumTooltipText", planFeesNotIncludedInPremiumTooltipText: "planFeesNotIncludedInPremiumTooltipText", memberEnrollmentStatus: "memberEnrollmentStatus", enrollmentStatusEnabled: "enrollmentStatusEnabled", statusDateText: "statusDateText", statusText: "statusText", defaultStatusText: "defaultStatusText", enrollmentHistoryProfileLinkEnabled: "enrollmentHistoryProfileLinkEnabled", enrollmentHistoryLinkText: "enrollmentHistoryLinkText", enrollmentStatusHeaderText: "enrollmentStatusHeaderText", enrollmentMoreDetailsText: "enrollmentMoreDetailsText", enrollmentHraHeaderText: "enrollmentHraHeaderText", enrollmentConfirmationHeaderText: "enrollmentConfirmationHeaderText", memberEnrollmentEffectiveDateHeaderText: "memberEnrollmentEffectiveDateHeaderText", riderHeaderText: "riderHeaderText", callRecordingHeaderText: "callRecordingHeaderText", uploadDocumentHeaderText: "uploadDocumentHeaderText", isAccountSummaryPage: "isAccountSummaryPage", partialEnrollmentDisabledText: "partialEnrollmentDisabledText", valueBasedCareConfirmationEnabled: "valueBasedCareConfirmationEnabled", valueBasedCareConfirmationText: "valueBasedCareConfirmationText", valueBasedCareProviders: "valueBasedCareProviders", isEnrollmentContinueButtonEnabled: "isEnrollmentContinueButtonEnabled", partialEnrollmentAllowedDate: "partialEnrollmentAllowedDate", enrollerButtonTooltipText: "enrollerButtonTooltipText", valueBasedCareConfirmationExpiration: "valueBasedCareConfirmationExpiration", isHRAPDFAccessEnabled: "isHRAPDFAccessEnabled", isProfileAdmin: "isProfileAdmin", isCompleteHRAProfileAdminEnabled: "isCompleteHRAProfileAdminEnabled", excludedCarrierIds: "excludedCarrierIds" }, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 7, consts: [[1, "row"], [1, "col-12", 3, "ngClass"], ["class", "Spa_Style_H2 mt-3 mb-0", 4, "liveEditProp"], [4, "ngIf"], [4, "ngIf", "ngIfElse"], ["allEnrollments", ""], [1, "Spa_Style_H2", "mt-3", "mb-0"], [4, "ngFor", "ngForOf"], [3, "enrollment", "memberEnrollmentUpdatedDate", "memberEnrollmentEffectiveDate", "showEffectiveDate", "totalMonthlyPremiumLabel", "planNameEnabled", "effectiveDateEnabled", "totalMonthlyPremiumEnabled", "updatedDateEnabled", "ridersEnabled", "continueEnrollmentButtonText", "authCode", "pacificStandardTimeText", "displayPlanAllowsCallRecordingIconEnabled", "planAllowsCallRecordingText", "agentCallInProgressAcceptCallIcon", "isMobile", "showPlanYearBadge", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "enrollmentMoreDetailsText", "memberEnrollmentEffectiveDateHeaderText", "riderHeaderText", "callRecordingHeaderText", "isExpandableDetailViewEnabled", "isAccountSummaryPage", "partialEnrollmentDisabledText", "isEnrollmentContinueButtonEnabled", "partialEnrollmentAllowedDate", "enrollerButtonTooltipText", 4, "ngIf"], [3, "memberEnrollment", "memberEnrollmentSubmittedDate", "memberEnrollmentEffectiveDate", "showEffectiveDate", "enrollmentStatus", "totalMonthlyPremiumLabel", "viewApplicationLinkText", "confirmationText", "confirmationNumberEnabled", "planNameEnabled", "effectiveDateEnabled", "totalMonthlyPremiumEnabled", "submissionDateEnabled", "ridersEnabled", "hraConfirmationNumberEnabled", "hraConfirmationText", "hraPDFLinkText", "agentCallRecords", "pacificStandardTimeText", "isHRAEnabled", "completeHRAButtonEnabled", "openExternalInNewTab", "completeHRAButtonText", "completeHRALastVisitedText", "completeHRADaysLeftText", "showPlanYearBadge", "planYear", "isActivePlanYear", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "enrollmentStatusHeaderText", "enrollmentMoreDetailsText", "enrollmentHraHeaderText", "enrollmentConfirmationHeaderText", "memberEnrollmentEffectiveDateHeaderText", "riderHeaderText", "callRecordingHeaderText", "uploadDocumentHeaderText", "valueBasedCareConfirmationEnabled", "valueBasedCareConfirmationText", "valueBasedCareProviders", "isExpandableDetailViewEnabled", "isAccountSummaryPage", "valueBasedCareConfirmationExpiration", "isHRAPDFAccessEnabled", "isProfileAdmin", "isCompleteHRAProfileAdminEnabled", "excludedCarrierIds", 4, "ngIf"], [3, "enrollment", "memberEnrollmentUpdatedDate", "memberEnrollmentEffectiveDate", "showEffectiveDate", "totalMonthlyPremiumLabel", "planNameEnabled", "effectiveDateEnabled", "totalMonthlyPremiumEnabled", "updatedDateEnabled", "ridersEnabled", "continueEnrollmentButtonText", "authCode", "pacificStandardTimeText", "displayPlanAllowsCallRecordingIconEnabled", "planAllowsCallRecordingText", "agentCallInProgressAcceptCallIcon", "isMobile", "showPlanYearBadge", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "enrollmentMoreDetailsText", "memberEnrollmentEffectiveDateHeaderText", "riderHeaderText", "callRecordingHeaderText", "isExpandableDetailViewEnabled", "isAccountSummaryPage", "partialEnrollmentDisabledText", "isEnrollmentContinueButtonEnabled", "partialEnrollmentAllowedDate", "enrollerButtonTooltipText"], [3, "memberEnrollment", "memberEnrollmentSubmittedDate", "memberEnrollmentEffectiveDate", "showEffectiveDate", "enrollmentStatus", "totalMonthlyPremiumLabel", "viewApplicationLinkText", "confirmationText", "confirmationNumberEnabled", "planNameEnabled", "effectiveDateEnabled", "totalMonthlyPremiumEnabled", "submissionDateEnabled", "ridersEnabled", "hraConfirmationNumberEnabled", "hraConfirmationText", "hraPDFLinkText", "agentCallRecords", "pacificStandardTimeText", "isHRAEnabled", "completeHRAButtonEnabled", "openExternalInNewTab", "completeHRAButtonText", "completeHRALastVisitedText", "completeHRADaysLeftText", "showPlanYearBadge", "planYear", "isActivePlanYear", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "enrollmentStatusHeaderText", "enrollmentMoreDetailsText", "enrollmentHraHeaderText", "enrollmentConfirmationHeaderText", "memberEnrollmentEffectiveDateHeaderText", "riderHeaderText", "callRecordingHeaderText", "uploadDocumentHeaderText", "valueBasedCareConfirmationEnabled", "valueBasedCareConfirmationText", "valueBasedCareProviders", "isExpandableDetailViewEnabled", "isAccountSummaryPage", "valueBasedCareConfirmationExpiration", "isHRAPDFAccessEnabled", "isProfileAdmin", "isCompleteHRAProfileAdminEnabled", "excludedCarrierIds"], ["class", "no-enrollment-text Spa_Style_Note", 4, "liveEditProp"], [1, "no-enrollment-text", "Spa_Style_Note"], ["class", "row justify-content-center mt-2", 4, "ngIf"], [1, "row", "justify-content-center", "mt-2"], [3, "title", "alwaysUnderlined", "showArrow", "click"]], template: function MemberEnrollmentHistoryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, MemberEnrollmentHistoryComponent_h2_2_Template, 2, 1, "h2", 2);
        i0.ɵɵtemplate(3, MemberEnrollmentHistoryComponent_ng_container_3_Template, 2, 1, "ng-container", 3);
        i0.ɵɵtemplate(4, MemberEnrollmentHistoryComponent_ng_container_4_Template, 2, 1, "ng-container", 4);
        i0.ɵɵtemplate(5, MemberEnrollmentHistoryComponent_ng_template_5_Template, 1, 1, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(6);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0$1z, ctx.isComponentFullWidth));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentHistory_Header_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.memberEnrollmentsDetails == null ? null : ctx.memberEnrollmentsDetails.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !(ctx.memberEnrollmentsDetails == null ? null : ctx.memberEnrollmentsDetails.length))("ngIfElse", _r3);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, LiveEditPropDirective, MemberEnrollmentCardComponent, MemberPartialEnrollmentCardComponent], styles: [".no-enrollment-text[_ngcontent-%COMP%]{border-top:2px solid var(--static-Spa_Style_Gray2);text-align:center;padding-top:12px;margin-top:10px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberEnrollmentHistoryComponent, [{
        type: Component,
        args: [{ selector: 'vnext-member-enrollment-history', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row\">\r\n  <div class=\"col-12\" [ngClass]=\"{ 'col-md-12': isComponentFullWidth }\">\r\n    <h2 class=\"Spa_Style_H2 mt-3 mb-0\" *liveEditProp=\"'Spa_EnrollmentHistory_Header_Text'\">\r\n      {{ memberEnrollmentHistoryHeaderText }}\r\n    </h2>\r\n    <ng-container *ngIf=\"memberEnrollmentsDetails?.length\">\r\n      <ng-container *ngFor=\"let enrollmentDetails of memberEnrollmentsDetails\">\r\n        <vnext-partial-member-enrollment-card\r\n          *ngIf=\"enrollmentDetails.memberEnrollment && !enrollmentDetails.memberEnrollment.completedWhen\"\r\n          [enrollment]=\"enrollmentDetails.memberEnrollment\"\r\n          [memberEnrollmentUpdatedDate]=\"enrollmentDetails.updatedDate\"\r\n          [memberEnrollmentEffectiveDate]=\"enrollmentDetails.effectiveDate\"\r\n          [showEffectiveDate]=\"enrollmentDetails.showEffectiveDate\"\r\n          [totalMonthlyPremiumLabel]=\"totalMonthlyPremiumLabel\"\r\n          [planNameEnabled]=\"planNameEnabled\"\r\n          [effectiveDateEnabled]=\"effectiveDateEnabled\"\r\n          [totalMonthlyPremiumEnabled]=\"totalMonthlyPremiumEnabled\"\r\n          [updatedDateEnabled]=\"updatedDateEnabled\"\r\n          [ridersEnabled]=\"ridersEnabled\"\r\n          [continueEnrollmentButtonText]=\"continueEnrollmentButtonText\"\r\n          [authCode]=\"enrollmentDetails.authCode\"\r\n          [pacificStandardTimeText]=\"pacificStandardTimeText\"\r\n          [displayPlanAllowsCallRecordingIconEnabled]=\"displayPlanAllowsCallRecordingIconEnabled\"\r\n          [planAllowsCallRecordingText]=\"planAllowsCallRecordingText\"\r\n          [agentCallInProgressAcceptCallIcon]=\"agentCallInProgressAcceptCallIcon\"\r\n          [isMobile]=\"isMobile\"\r\n          [showPlanYearBadge]=\"showPlanYearBadge\"\r\n          [planFeesEnabled]=\"planFeesEnabled\"\r\n          [planFeesTooltipText]=\"planFeesTooltipText\"\r\n          [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n          [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n          [enrollmentMoreDetailsText]=\"enrollmentMoreDetailsText\"\r\n          [memberEnrollmentEffectiveDateHeaderText]=\"memberEnrollmentEffectiveDateHeaderText\"\r\n          [riderHeaderText]=\"riderHeaderText\"\r\n          [callRecordingHeaderText]=\"callRecordingHeaderText\"\r\n          [isExpandableDetailViewEnabled]=\"enrollmentHistoryProfileLinkEnabled\"\r\n          [isAccountSummaryPage]=\"isAccountSummaryPage\"\r\n          [partialEnrollmentDisabledText]=\"partialEnrollmentDisabledText\"\r\n          [isEnrollmentContinueButtonEnabled]=\"isEnrollmentContinueButtonEnabled\"\r\n          [partialEnrollmentAllowedDate]=\"partialEnrollmentAllowedDate\"\r\n          [enrollerButtonTooltipText]=\"enrollerButtonTooltipText\"\r\n        >\r\n        </vnext-partial-member-enrollment-card>\r\n\r\n        <vnext-member-enrollment-card\r\n          *ngIf=\"!!enrollmentDetails.memberEnrollment?.completedWhen\"\r\n          [memberEnrollment]=\"enrollmentDetails.memberEnrollment\"\r\n          [memberEnrollmentSubmittedDate]=\"enrollmentDetails.submittedDate\"\r\n          [memberEnrollmentEffectiveDate]=\"enrollmentDetails.effectiveDate\"\r\n          [showEffectiveDate]=\"enrollmentDetails.showEffectiveDate\"\r\n          [enrollmentStatus]=\"enrollmentDetails.latestStatus\"\r\n          [totalMonthlyPremiumLabel]=\"totalMonthlyPremiumLabel\"\r\n          [viewApplicationLinkText]=\"viewApplicationLinkText\"\r\n          [confirmationText]=\"\r\n            enrollmentDetails.memberEnrollment.isCurrentYearEnrollment || enrollmentDetails.memberEnrollment.confirmationNumber\r\n              ? confirmationText\r\n              : ''\r\n          \"\r\n          [confirmationNumberEnabled]=\"confirmationNumberEnabled\"\r\n          [planNameEnabled]=\"planNameEnabled\"\r\n          [effectiveDateEnabled]=\"effectiveDateEnabled\"\r\n          [totalMonthlyPremiumEnabled]=\"\r\n            enrollmentDetails.memberEnrollment.isCurrentYearEnrollment || enrollmentDetails.memberEnrollment.enrolledPremium\r\n              ? totalMonthlyPremiumEnabled\r\n              : false\r\n          \"\r\n          [submissionDateEnabled]=\"submissionDateEnabled\"\r\n          [ridersEnabled]=\"ridersEnabled\"\r\n          [hraConfirmationNumberEnabled]=\"hraConfirmationNumberEnabled && enrollmentDetails.memberEnrollment.isCurrentYearEnrollment\"\r\n          [hraConfirmationText]=\"hraConfirmationText\"\r\n          [hraPDFLinkText]=\"hraPDFLinkText\"\r\n          [agentCallRecords]=\"enrollmentDetails.memberEnrollment.agentCallRecords\"\r\n          [pacificStandardTimeText]=\"pacificStandardTimeText\"\r\n          [isHRAEnabled]=\"isHRAEnabled\"\r\n          [completeHRAButtonEnabled]=\"completeHRAButtonEnabled\"\r\n          [openExternalInNewTab]=\"openExternalInNewTab\"\r\n          [completeHRAButtonText]=\"completeHRAButtonText\"\r\n          [completeHRALastVisitedText]=\"completeHRALastVisitedText\"\r\n          [completeHRADaysLeftText]=\"completeHRADaysLeftText\"\r\n          [showPlanYearBadge]=\"showPlanYearBadge\"\r\n          [planYear]=\"enrollmentDetails.memberEnrollment.planYear\"\r\n          [isActivePlanYear]=\"enrollmentDetails.memberEnrollment.isCurrentYearEnrollment\"\r\n          [planFeesEnabled]=\"planFeesEnabled\"\r\n          [planFeesTooltipText]=\"planFeesTooltipText\"\r\n          [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n          [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n          [enrollmentStatusHeaderText]=\"enrollmentStatusHeaderText\"\r\n          [enrollmentMoreDetailsText]=\"enrollmentMoreDetailsText\"\r\n          [enrollmentHraHeaderText]=\"enrollmentHraHeaderText\"\r\n          [enrollmentConfirmationHeaderText]=\"enrollmentConfirmationHeaderText\"\r\n          [memberEnrollmentEffectiveDateHeaderText]=\"memberEnrollmentEffectiveDateHeaderText\"\r\n          [riderHeaderText]=\"riderHeaderText\"\r\n          [callRecordingHeaderText]=\"callRecordingHeaderText\"\r\n          [uploadDocumentHeaderText]=\"uploadDocumentHeaderText\"\r\n          [valueBasedCareConfirmationEnabled]=\"valueBasedCareConfirmationEnabled\"\r\n          [valueBasedCareConfirmationText]=\"valueBasedCareConfirmationText\"\r\n          [valueBasedCareProviders]=\"valueBasedCareProviders\"\r\n          [isExpandableDetailViewEnabled]=\"enrollmentHistoryProfileLinkEnabled\"\r\n          [isAccountSummaryPage]=\"isAccountSummaryPage\"\r\n          [valueBasedCareConfirmationExpiration]=\"valueBasedCareConfirmationExpiration\"\r\n          [isHRAPDFAccessEnabled]=\"isHRAPDFAccessEnabled\"\r\n          [isProfileAdmin]=\"isProfileAdmin\"\r\n          [isCompleteHRAProfileAdminEnabled]=\"isCompleteHRAProfileAdminEnabled\"\r\n          [excludedCarrierIds]=\"excludedCarrierIds\"\r\n        ></vnext-member-enrollment-card>\r\n      </ng-container>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"!memberEnrollmentsDetails?.length; else allEnrollments\">\r\n      <div class=\"no-enrollment-text Spa_Style_Note\" *liveEditProp=\"'Spa_EnrollmentHistory_NoEnrollmentMessageText'\">\r\n        {{ noEnrollmentMessageText }}\r\n      </div>\r\n    </ng-container>\r\n    <ng-template #allEnrollments>\r\n      <div *ngIf=\"enrollmentHistoryProfileLinkEnabled\" class=\"row justify-content-center mt-2\">\r\n        <vnext-link\r\n          [title]=\"enrollmentHistoryLinkText\"\r\n          [alwaysUnderlined]=\"true\"\r\n          [showArrow]=\"'right'\"\r\n          (click)=\"redirectToCompletedEnrollmentHistoryPage()\"\r\n        ></vnext-link>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n</div>\r\n", styles: [".no-enrollment-text{border-top:2px solid var(--static-Spa_Style_Gray2);text-align:center;padding-top:12px;margin-top:10px}\n"] }]
    }], function () { return [{ type: i1$2.DatePipe }, { type: i1.NavigationService }]; }, { memberEnrollments: [{
            type: Input
        }], keepDefaultAPIEnrollmentOrdering: [{
            type: Input
        }], memberQuoteHistory: [{
            type: Input
        }], memberEnrollmentHistoryHeaderText: [{
            type: Input
        }], noEnrollmentMessageText: [{
            type: Input
        }], pacificStandardTimeText: [{
            type: Input
        }], memberEnrollmentHistoryEffectiveDateText: [{
            type: Input
        }], totalMonthlyPremiumLabel: [{
            type: Input
        }], viewApplicationLinkText: [{
            type: Input
        }], confirmationText: [{
            type: Input
        }], submittedDateText: [{
            type: Input
        }], confirmationNumberEnabled: [{
            type: Input
        }], planNameEnabled: [{
            type: Input
        }], effectiveDateEnabled: [{
            type: Input
        }], totalMonthlyPremiumEnabled: [{
            type: Input
        }], submissionDateEnabled: [{
            type: Input
        }], ridersEnabled: [{
            type: Input
        }], lastUpdatedText: [{
            type: Input
        }], continueEnrollmentButtonText: [{
            type: Input
        }], updatedDateEnabled: [{
            type: Input
        }], hraPDFLinkText: [{
            type: Input
        }], hraConfirmationText: [{
            type: Input
        }], hraConfirmationNumberEnabled: [{
            type: Input
        }], isComponentFullWidth: [{
            type: Input
        }], displayPlanAllowsCallRecordingIconEnabled: [{
            type: Input
        }], planAllowsCallRecordingText: [{
            type: Input
        }], agentCallInProgressAcceptCallIcon: [{
            type: Input
        }], isHRAEnabled: [{
            type: Input
        }], completeHRAButtonEnabled: [{
            type: Input
        }], openExternalInNewTab: [{
            type: Input
        }], completeHRAButtonText: [{
            type: Input
        }], completeHRALastVisitedText: [{
            type: Input
        }], completeHRADaysLeftText: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], showPlanYearBadge: [{
            type: Input
        }], planFeesEnabled: [{
            type: Input
        }], planFeesTooltipText: [{
            type: Input
        }], planFeesIncludedInPremiumTooltipText: [{
            type: Input
        }], planFeesNotIncludedInPremiumTooltipText: [{
            type: Input
        }], memberEnrollmentStatus: [{
            type: Input
        }], enrollmentStatusEnabled: [{
            type: Input
        }], statusDateText: [{
            type: Input
        }], statusText: [{
            type: Input
        }], defaultStatusText: [{
            type: Input
        }], enrollmentHistoryProfileLinkEnabled: [{
            type: Input
        }], enrollmentHistoryLinkText: [{
            type: Input
        }], enrollmentStatusHeaderText: [{
            type: Input
        }], enrollmentMoreDetailsText: [{
            type: Input
        }], enrollmentHraHeaderText: [{
            type: Input
        }], enrollmentConfirmationHeaderText: [{
            type: Input
        }], memberEnrollmentEffectiveDateHeaderText: [{
            type: Input
        }], riderHeaderText: [{
            type: Input
        }], callRecordingHeaderText: [{
            type: Input
        }], uploadDocumentHeaderText: [{
            type: Input
        }], isAccountSummaryPage: [{
            type: Input
        }], partialEnrollmentDisabledText: [{
            type: Input
        }], valueBasedCareConfirmationEnabled: [{
            type: Input
        }], valueBasedCareConfirmationText: [{
            type: Input
        }], valueBasedCareProviders: [{
            type: Input
        }], isEnrollmentContinueButtonEnabled: [{
            type: Input
        }], partialEnrollmentAllowedDate: [{
            type: Input
        }], enrollerButtonTooltipText: [{
            type: Input
        }], valueBasedCareConfirmationExpiration: [{
            type: Input
        }], isHRAPDFAccessEnabled: [{
            type: Input
        }], isProfileAdmin: [{
            type: Input
        }], isCompleteHRAProfileAdminEnabled: [{
            type: Input
        }], excludedCarrierIds: [{
            type: Input
        }] }); })();

function CallToActionAreaComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
class CallToActionAreaComponent {
    constructor() {
        this.soaActivities = [];
        this.memberQuoteHistory = [];
        this.memberPartialEnrollments = [];
        this.enableTilesCount = 0;
    }
    ngOnChanges(changes) {
        const { isSOAEnabled, isQuoteEnabled, isEnrollmentEnabled, soaActivities, memberQuoteHistory, memberPartialEnrollments } = changes;
        if ((isSOAEnabled && isSOAEnabled.previousValue !== isSOAEnabled.currentValue) ||
            (isQuoteEnabled && isQuoteEnabled.previousValue !== isQuoteEnabled.currentValue) ||
            (isEnrollmentEnabled && isEnrollmentEnabled.previousValue !== isEnrollmentEnabled.currentValue) ||
            (soaActivities && !_isEqual(soaActivities.previousValue, soaActivities.currentValue)) ||
            (memberQuoteHistory && !_isEqual(memberQuoteHistory.previousValue, memberQuoteHistory.currentValue)) ||
            (memberPartialEnrollments && !_isEqual(memberPartialEnrollments.previousValue, memberPartialEnrollments.currentValue))) {
            this.showSOATile = this.isSOAEnabled && !!this.soaActivities?.length;
            this.showQuoteTile = this.isQuoteEnabled && !!this.memberQuoteHistory?.length;
            this.showEnrollmentTile = this.isEnrollmentEnabled && !!this.memberPartialEnrollments?.length;
            this.showCallToActionArea = this.showSOATile || this.showQuoteTile || this.showEnrollmentTile;
            // Booleans converted to numbers will be either 1 when true, or 0 when false.
            this.enableTilesCount = Number(this.showSOATile) + Number(this.showQuoteTile) + Number(this.showEnrollmentTile);
        }
    }
}
CallToActionAreaComponent.ɵfac = function CallToActionAreaComponent_Factory(t) { return new (t || CallToActionAreaComponent)(); };
CallToActionAreaComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CallToActionAreaComponent, selectors: [["vnext-widget-call-to-action-area"]], inputs: { isSOAEnabled: "isSOAEnabled", isQuoteEnabled: "isQuoteEnabled", isEnrollmentEnabled: "isEnrollmentEnabled", soaActivities: "soaActivities", memberQuoteHistory: "memberQuoteHistory", memberPartialEnrollments: "memberPartialEnrollments" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"]], template: function CallToActionAreaComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CallToActionAreaComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showCallToActionArea);
    } }, dependencies: [i1$2.NgIf], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CallToActionAreaComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-call-to-action-area', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"showCallToActionArea\">\r\n  <!-- SPA-21563: SOA tile -->\r\n  <!-- SPA-21659: Quotes tile -->\r\n  <!-- SPA-21660: Enrollments tile -->\r\n</ng-container>\r\n" }]
    }], null, { isSOAEnabled: [{
            type: Input
        }], isQuoteEnabled: [{
            type: Input
        }], isEnrollmentEnabled: [{
            type: Input
        }], soaActivities: [{
            type: Input
        }], memberQuoteHistory: [{
            type: Input
        }], memberPartialEnrollments: [{
            type: Input
        }] }); })();

function AccountSummaryComponent_h1_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.Spa_Consumer_AccountOverview_Header_Text, " ");
} }
function AccountSummaryComponent_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r5.Spa_Consumer_AccountOverview_Introduction_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function AccountSummaryComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AccountSummaryComponent_ng_container_2_div_1_Template, 2, 4, "div", 10);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Consumer_AccountOverview_Introduction_Text");
} }
function AccountSummaryComponent_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 24);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r6.Spa_Site_PageSubHeader_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function AccountSummaryComponent_div_3_h2_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.Spa_Consumer_AccountOverview_PersonalHeader_Text, " ");
} }
function AccountSummaryComponent_div_3_form_5_ng_container_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 32);
} }
const _c0$1y = function (a0, a1) { return { "col": a0, "col-lg-3 col-md-6 col-12": a1 }; };
function AccountSummaryComponent_div_3_form_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 28)(2, "vnext-widget-account-summary-input", 29, 30);
    i0.ɵɵlistener("selectedFips", function AccountSummaryComponent_div_3_form_5_ng_container_1_Template_vnext_widget_account_summary_input_selectedFips_2_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r16.updateFipsCode($event)); })("cellPhoneCheckBoxToggled", function AccountSummaryComponent_div_3_form_5_ng_container_1_Template_vnext_widget_account_summary_input_cellPhoneCheckBoxToggled_2_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r18 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r18.updateCellPhoneValue($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, AccountSummaryComponent_div_3_form_5_ng_container_1_div_4_Template, 1, 0, "div", 31);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const formInputConfig_r13 = ctx.$implicit;
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(26, _c0$1y, formInputConfig_r13.keyName === ctx_r12.accountOverviewInputs.ZIP || (ctx_r12.consumerPersonalAccountFormConfig[formInputConfig_r13.keyName] == null ? null : ctx_r12.consumerPersonalAccountFormConfig[formInputConfig_r13.keyName].breakRowLayout), formInputConfig_r13.keyName !== ctx_r12.accountOverviewInputs.ZIP && !(ctx_r12.consumerPersonalAccountFormConfig[formInputConfig_r13.keyName] == null ? null : ctx_r12.consumerPersonalAccountFormConfig[formInputConfig_r13.keyName].breakRowLayout)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("personalFormGroup", ctx_r12.personalFormGroup)("personalFormInputConfig", formInputConfig_r13)("control", ctx_r12.consumerPersonalAccountFormConfig[formInputConfig_r13.keyName] == null ? null : ctx_r12.consumerPersonalAccountFormConfig[formInputConfig_r13.keyName].control)("submitted", ctx_r12.submitted)("selectedCountyEnabled", ctx_r12.Spa_Site_ZipCodeInput_SelectedCountyEnabled)("zipCodeRequiredErrorText", ctx_r12.Spa_Site_ZipCodeRequired_Error)("zipCodeInvalidErrorText", ctx_r12.Spa_Member_Profile_Invalid_ZipError_Text)("countyErrorText", ctx_r12.Spa_Site_ZipCodeInput_CountyError)("selectCountyText", ctx_r12.Spa_Site_ZipCodeInput_SelectCounty)("zipCodeText", ctx_r12.Spa_Site_ZipCodeInput_ZipCodeLabel)("editCountyText", ctx_r12.Spa_Site_ZipCodeInput_EditCounty)("customStyles", ctx_r12.zipCodeCustomStyles)("errorKeywordText", ctx_r12.Spa_Site_ErrorKeyword_Text)("countyLabel", ctx_r12.Spa_ZipCodeInput_CountyLabel_Text)("showCountyLabel", ctx_r12.Spa_ZipCodeInput_CountyLabel_Enabled)("noDateError", ctx_r12.Spa_Member_Profile_NoBirthDateError_Text)("futureDateError", ctx_r12.Spa_Member_Profile_FutureBirthDateError_Text)("outOfRangeError", ctx_r12.Spa_Member_Profile_BirthDateOutOfRangeError_Text)("maxAge", ctx_r12.Spa_Member_Profile_Maximum_Age)("retrieveZipCode", ctx_r12.getZipCodeFunction)("retrieveFipsCode", ctx_r12.getFipsCodeFunction)("sameAsPrimaryText", ctx_r12.Spa_Site_SameAsPrimary_Text)("displayCellPhoneCheckbox", ctx_r12.Spa_Member_Profile_MobilePhoneCopyMain_Enabled)("disableCellPhoneInput", ctx_r12.disableCellPhoneInput);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r12.consumerPersonalAccountFormConfig[formInputConfig_r13.keyName] == null ? null : ctx_r12.consumerPersonalAccountFormConfig[formInputConfig_r13.keyName].breakRowLayout);
} }
function AccountSummaryComponent_div_3_form_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "form", 26);
    i0.ɵɵtemplate(1, AccountSummaryComponent_div_3_form_5_ng_container_1_Template, 5, 29, "ng-container", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r8.personalFormGroup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r8.Spa_Consumer_AccountOverview_PersonalForm);
} }
function AccountSummaryComponent_div_3_h3_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.Spa_Consumer_AccountOverview_PersonalAddressHeader_Text, " ");
} }
function AccountSummaryComponent_div_3_form_7_ng_container_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 32);
} }
function AccountSummaryComponent_div_3_form_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 35);
    i0.ɵɵelement(2, "vnext-widget-account-summary-input", 36);
    i0.ɵɵtemplate(3, AccountSummaryComponent_div_3_form_7_ng_container_1_div_3_Template, 1, 0, "div", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const formInputConfig_r20 = ctx.$implicit;
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("personalFormGroup", ctx_r19.personalAddressFormGroup)("personalFormInputConfig", formInputConfig_r20)("control", ctx_r19.consumerPersonalAddressFormConfig[formInputConfig_r20.keyName] == null ? null : ctx_r19.consumerPersonalAddressFormConfig[formInputConfig_r20.keyName].control)("submitted", ctx_r19.submitted)("selectedZipCode", ctx_r19.consumerPersonalAccountFormConfig[ctx_r19.accountOverviewInputs.ZIP].control.value)("addressAutoCompleteEnabled", ctx_r19.Spa_Member_Profile_AddressAutoComplete_Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.consumerPersonalAddressFormConfig[formInputConfig_r20.keyName] == null ? null : ctx_r19.consumerPersonalAddressFormConfig[formInputConfig_r20.keyName].breakRowLayout);
} }
function AccountSummaryComponent_div_3_form_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "form", 34);
    i0.ɵɵtemplate(1, AccountSummaryComponent_div_3_form_7_ng_container_1_Template, 4, 7, "ng-container", 27);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r10.personalAddressFormGroup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r10.Spa_Consumer_AccountOverview_PersonalAddressForm);
} }
function AccountSummaryComponent_div_3_vnext_status_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-status-button", 37);
    i0.ɵɵlistener("click", function AccountSummaryComponent_div_3_vnext_status_button_12_Template_vnext_status_button_click_0_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r22.saveConsumerInfo()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("buttonText", ctx_r11.Spa_Consumer_AccountOverview_Button_Text)("buttonClass", "Spa_Style_PrimaryButton")("tooltipMessageError", ctx_r11.Spa_Consumer_AccountOverview_TooltipError_Text)("tooltipMessageSuccess", ctx_r11.Spa_Consumer_AccountOverview_TooltipSuccess_Text);
} }
function AccountSummaryComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 12);
    i0.ɵɵtemplate(2, AccountSummaryComponent_div_3_div_2_Template, 2, 4, "div", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, AccountSummaryComponent_div_3_h2_3_Template, 2, 1, "h2", 14);
    i0.ɵɵelementStart(4, "div", 15);
    i0.ɵɵtemplate(5, AccountSummaryComponent_div_3_form_5_Template, 2, 2, "form", 16);
    i0.ɵɵtemplate(6, AccountSummaryComponent_div_3_h3_6_Template, 2, 1, "h3", 17);
    i0.ɵɵtemplate(7, AccountSummaryComponent_div_3_form_7_Template, 2, 2, "form", 18);
    i0.ɵɵelementStart(8, "div", 19)(9, "div", 20)(10, "div", 21)(11, "div", 22);
    i0.ɵɵtemplate(12, AccountSummaryComponent_div_3_vnext_status_button_12_Template, 1, 4, "vnext-status-button", 23);
    i0.ɵɵelementEnd()()()()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_PageSubHeader_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Consumer_AccountOverview_PersonalHeader_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.personalFormGroup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Consumer_AccountOverview_PersonalAddressHeader_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.Spa_Consumer_AccountOverview_PersonalFormEnabled && ctx_r2.personalAddressFormGroup);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("liveEditProp", "Spa_Consumer_AccountOverview_Button_Text");
} }
function AccountSummaryComponent_vnext_widget_call_to_action_area_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-call-to-action-area", 38);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isSOAEnabled", ctx_r3.Spa_Site_SOA_Enabled)("isQuoteEnabled", ctx_r3.Spa_Site_EnableQuoteSummary)("isEnrollmentEnabled", ctx_r3.Spa_Site_Enrollment_Enabled)("soaActivities", ctx_r3.soaActivities)("memberQuoteHistory", ctx_r3.memberQuoteHistory)("memberPartialEnrollments", ctx_r3.memberPartialEnrollments);
} }
function AccountSummaryComponent_vnext_member_enrollment_history_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-member-enrollment-history", 39);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("memberEnrollments", ctx_r4.memberEnrollments)("keepDefaultAPIEnrollmentOrdering", false)("memberQuoteHistory", ctx_r4.memberQuoteHistory)("memberEnrollmentHistoryHeaderText", ctx_r4.Spa_EnrollmentHistory_Header_Text)("noEnrollmentMessageText", ctx_r4.Spa_EnrollmentHistory_NoEnrollmentMessageText)("pacificStandardTimeText", ctx_r4.Spa_EnrollmentHistory_Pacific_StandardTime_Text)("memberEnrollmentHistoryEffectiveDateText", ctx_r4.Spa_EnrollmentHistory_RequestedEffectiveDate_Text)("totalMonthlyPremiumLabel", ctx_r4.Spa_Site_TotalMonthlyPremiumLabel)("viewApplicationLinkText", ctx_r4.Spa_Site_ViewApplication_Link_Text)("confirmationText", ctx_r4.Spa_EnrollmentHistory_Confirmation_Text)("submittedDateText", ctx_r4.Spa_EnrollmentHistory_SubmittedDate_Text)("lastUpdatedText", ctx_r4.Spa_EnrollmentHistory_UpdatedDate_Text)("confirmationNumberEnabled", ctx_r4.Spa_EnrollmentHistory_ConfirmationNumber_Enabled)("planNameEnabled", ctx_r4.Spa_EnrollmentHistory_PlanName_Enabled)("effectiveDateEnabled", ctx_r4.Spa_EnrollmentHistory_EffectiveDate_Enabled)("totalMonthlyPremiumEnabled", ctx_r4.Spa_EnrollmentHistory_TotalMonthlyPremium_Enabled)("submissionDateEnabled", ctx_r4.Spa_EnrollmentHistory_SubmissionDate_Enabled)("updatedDateEnabled", ctx_r4.Spa_EnrollmentHistory_UpdatedDate_Enabled)("ridersEnabled", ctx_r4.Spa_EnrollmentHistory_Riders_Enabled)("continueEnrollmentButtonText", ctx_r4.Spa_EnrollmentHistory_ContinueEnrollment_ButtonText)("hraPDFLinkText", ctx_r4.SPA_EnrollmentHistory_HRALink_Text)("hraConfirmationText", ctx_r4.Spa_EnrollmentHistory_hraConfirmation_Text)("hraConfirmationNumberEnabled", ctx_r4.Spa_EnrollmentHistory_hraConfirmation_Enabled)("isComponentFullWidth", true)("planFeesEnabled", ctx_r4.Spa_Site_PlanFees_Enabled)("planFeesTooltipText", ctx_r4.Spa_PlanFees_Tooltip_Text)("planFeesIncludedInPremiumTooltipText", ctx_r4.Spa_PlanFees_IncludedInPremium_Tooltip_Text)("planFeesNotIncludedInPremiumTooltipText", ctx_r4.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text)("enrollmentStatusHeaderText", ctx_r4.Spa_EnrollmentHistory_EnrollmentStatus_HeaderText)("enrollmentMoreDetailsText", ctx_r4.Spa_Site_EnrollmentHistory_MoreDetailsText)("enrollmentHraHeaderText", ctx_r4.Spa_EnrollmentHistory_HealthRiskAssessment_HeaderText)("enrollmentConfirmationHeaderText", ctx_r4.Spa_EnrollmentHistory_Confirmation_HeaderText)("memberEnrollmentEffectiveDateHeaderText", ctx_r4.Spa_EnrollmentHistory_RequestedEffectiveDate_HeaderText)("riderHeaderText", ctx_r4.Spa_EnrollmentHistory_Riders_HeaderText)("callRecordingHeaderText", ctx_r4.Spa_EnrollmentHistory_CallRecordings_HeaderText)("uploadDocumentHeaderText", ctx_r4.Spa_EnrollmentHistory_UploadedDocuments_HeaderText)("enrollmentHistoryProfileLinkEnabled", ctx_r4.Spa_Site_EnrollmentHistory_ProfileLink_Enabled)("isAccountSummaryPage", ctx_r4.isAccountSummaryPage)("enrollerButtonTooltipText", ctx_r4.Spa_Site_EnrollerButton_Tooltip_Text);
} }
let AccountSummaryComponent = class AccountSummaryComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, navigationService, memberSessionService, memberRegistrationFacade, enrollmentHistoryFacade, accountOverviewFacade, analyticsService, deactivationGuardService, unsavedModalContext, modalService, spinnerService, zipCodeService, soaFacade) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.navigationService = navigationService;
        this.memberSessionService = memberSessionService;
        this.memberRegistrationFacade = memberRegistrationFacade;
        this.enrollmentHistoryFacade = enrollmentHistoryFacade;
        this.accountOverviewFacade = accountOverviewFacade;
        this.analyticsService = analyticsService;
        this.deactivationGuardService = deactivationGuardService;
        this.unsavedModalContext = unsavedModalContext;
        this.modalService = modalService;
        this.spinnerService = spinnerService;
        this.zipCodeService = zipCodeService;
        this.soaFacade = soaFacade;
        this.Spa_Consumer_AccountOverview_ViewPlans_Text = 'View Plans';
        this.Spa_Consumer_AccountOverview_Header_Text = 'Account Overview';
        this.Spa_Consumer_AccountOverview_Introduction_Text = '';
        this.Spa_Site_PageSubHeader_Text = '';
        // Enrollment history related
        this.Spa_Site_EnrollmentHistory_Enabled = true;
        this.Spa_EnrollmentHistory_Header_Text = 'Enrollment History';
        this.Spa_EnrollmentHistory_NoEnrollmentMessageText = 'You have no enrollments for this beneficiary';
        this.Spa_EnrollmentHistory_Pacific_StandardTime_Text = 'PST';
        this.Spa_EnrollmentHistory_RequestedEffectiveDate_Text = 'Requested effective date';
        this.Spa_Site_TotalMonthlyPremiumLabel = 'Total monthly premium';
        this.Spa_Site_ViewApplication_Link_Text = 'View application';
        this.Spa_EnrollmentHistory_Confirmation_Text = 'Confirmation';
        this.Spa_EnrollmentHistory_SubmittedDate_Text = 'Submitted';
        this.Spa_EnrollmentHistory_UpdatedDate_Text = 'last updated';
        this.Spa_EnrollmentHistory_ConfirmationNumber_Enabled = true;
        this.Spa_EnrollmentHistory_PlanName_Enabled = true;
        this.Spa_EnrollmentHistory_EffectiveDate_Enabled = true;
        this.Spa_EnrollmentHistory_TotalMonthlyPremium_Enabled = true;
        this.Spa_EnrollmentHistory_SubmissionDate_Enabled = true;
        this.Spa_EnrollmentHistory_UpdatedDate_Enabled = true;
        this.Spa_EnrollmentHistory_Riders_Enabled = true;
        this.Spa_EnrollmentHistory_ContinueEnrollment_ButtonText = 'Continue enrollment';
        this.SPA_EnrollmentHistory_HRALink_Text = 'Health Risk Assessment';
        this.Spa_EnrollmentHistory_hraConfirmation_Text = 'HRA Confirmation';
        this.Spa_EnrollmentHistory_hraConfirmation_Enabled = true;
        this.Spa_Consumer_AccountOverview_PersonalHeader_Text = 'Personal information';
        this.Spa_Consumer_AccountOverview_PersonalAddressHeader_Text = 'Home address';
        this.Spa_Consumer_AccountOverview_Button_Text = 'Save';
        this.Spa_Site_ZipCodeInput_SelectedCountyEnabled = true;
        this.Spa_Member_Profile_Invalid_ZipError_Text = 'Please provide a valid Zip code';
        this.Spa_Site_ZipCodeRequired_Error = 'Please provide Zip code';
        this.Spa_Site_ZipCodeInput_CountyError = 'Please select your county';
        this.Spa_Site_ZipCodeInput_SelectCounty = 'Select county';
        this.Spa_Site_ZipCodeInput_ZipCodeLabel = 'Zip code';
        this.Spa_Site_ZipCodeInput_EditCounty = 'Edit';
        this.Spa_ZipCodeInput_CountyLabel_Text = 'County';
        this.Spa_ZipCodeInput_CountyLabel_Enabled = false;
        this.Spa_Site_ErrorKeyword_Text = 'Error:';
        this.Spa_Consumer_AccountOverview_TooltipError_Text = 'Try again';
        this.Spa_Consumer_AccountOverview_TooltipSuccess_Text = 'Saved';
        this.Spa_Consumer_AccountOverview_PersonalForm = this.accountOverviewFacade.consumerPersonalFormConfig;
        this.Spa_Consumer_AccountOverview_PersonalAddressForm = this.accountOverviewFacade.consumerPersonalAddressFormConfig;
        this.Spa_Consumer_AccountOverview_PersonalFormEnabled = false;
        this.Spa_Member_Profile_AddressAutoComplete_Enabled = false;
        this.Spa_Member_Profile_NoBirthDateError_Text = 'Please provide a valid date of birth';
        this.Spa_Member_Profile_FutureBirthDateError_Text = 'Please provide a date of birth in the past';
        this.Spa_Member_Profile_BirthDateOutOfRangeError_Text = 'The date of birth is too far in the past';
        this.Spa_Member_Profile_Maximum_Age = 105;
        this.Spa_Site_PlanFees_Enabled = false;
        this.Spa_PlanFees_Tooltip_Text = 'Fees';
        this.Spa_PlanFees_IncludedInPremium_Tooltip_Text = 'Included in premium';
        this.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text = 'Not included in premium';
        this.Spa_Site_SameAsPrimary_Text = 'Same as primary';
        this.Spa_Member_Profile_MobilePhoneCopyMain_Enabled = true;
        this.Spa_Site_EnrollmentHistory_ProfileLink_Enabled = true;
        this.Spa_Site_EnrollmentHistory_MoreDetailsText = 'More details';
        this.Spa_EnrollmentHistory_EnrollmentStatus_HeaderText = 'Enrollment status';
        this.Spa_EnrollmentHistory_HealthRiskAssessment_HeaderText = 'Health Risk Assessment';
        this.Spa_EnrollmentHistory_Confirmation_HeaderText = 'Enrollment confirmation';
        this.Spa_EnrollmentHistory_RequestedEffectiveDate_HeaderText = 'Requested effective date';
        this.Spa_EnrollmentHistory_Riders_HeaderText = 'Riders';
        this.Spa_EnrollmentHistory_CallRecordings_HeaderText = 'Call recordings';
        this.Spa_EnrollmentHistory_UploadedDocuments_HeaderText = 'Uploaded documents';
        this.Spa_Site_EnrollerButton_Tooltip_Text = `You don't have permission to take this action.`;
        this.Spa_Site_SOA_Enabled = true;
        this.Spa_Site_EnableQuoteSummary = true;
        this.Spa_Site_Enrollment_Enabled = true;
        this.Spa_Consumer_AccountOverview_DisplayCallToAction_Enabled = false;
        this.soaActivities = [];
        this.memberQuoteHistory = [];
        this.memberEnrollments = [];
        this.memberPartialEnrollments = [];
        // End Enrollment history
        this.subscriptions = new Subscription();
        this.submitted = false;
        this.setFocus = false;
        this.isAccountSummaryPage = true;
        this.accountOverviewInputs = AccountOverviewInputs;
        this.zipCodeCustomStyles = {
            roundInputRightBorder: true,
            noErrorGapWhenValid: true,
            redBorderOnError: true,
            smallerErrorFont: true
        };
        this.selectedFips = '';
        this.getZipCodeFunction = this.accountOverviewFacade.getZipCodeSelected.bind(this.accountOverviewFacade);
        this.getFipsCodeFunction = this.accountOverviewFacade.getFipsCodeSelected.bind(this.accountOverviewFacade);
        this.disableCellPhoneInput = false;
    }
    ngOnInit() {
        super.ngOnInit();
        const includeSOA = this.Spa_Site_SOA_Enabled && this.Spa_Consumer_AccountOverview_DisplayCallToAction_Enabled;
        this.personalFormGroup = this.accountOverviewFacade.getConsumerPersonalFormGroup();
        this.personalAddressFormGroup = this.accountOverviewFacade.getConsumerPersonalAddressFormGroup();
        this.consumerPersonalAccountFormConfig = this.Spa_Consumer_AccountOverview_PersonalForm.reduce((formConfig, formInputConfig) => {
            formConfig[formInputConfig.keyName] = {
                control: this.getPersonalFormControl(formInputConfig.keyName),
                breakRowLayout: this.breakRowLayout(formInputConfig)
            };
            return formConfig;
        }, {});
        this.consumerPersonalAddressFormConfig = this.Spa_Consumer_AccountOverview_PersonalAddressForm.reduce((formConfig, formInputConfig) => {
            formConfig[formInputConfig.keyName] = {
                control: this.getPersonalAddressFormControl(formInputConfig.keyName),
                breakRowLayout: this.breakRowLayout(formInputConfig)
            };
            return formConfig;
        }, {});
        this.deactivationGuardService.addDeactivationGuard({
            canDeactivate: this.showUnsavedChangesModal.bind(this)
        });
        if (!this.memberSessionService.getIsEnrollmentHistoryIncluded()) {
            this.spinnerService.show(SpinnerEvent.MEMBER_LOADING);
            this.subscriptions.add(this.memberSessionService
                .fetchMemberSession$({
                sessionId: this.memberSessionService.getMemberSessionId(),
                isEnrollmentHistoryIncluded: true,
                includeSOA
            })
                .pipe(take(1), finalize(() => {
                this.spinnerService.hide(SpinnerEvent.MEMBER_LOADING);
            }))
                .subscribe({
                next: memberSession => { }
            }));
        }
        if (includeSOA) {
            this.subscriptions.add(this.soaFacade
                .getSOAActivities$()
                .pipe(distinctUntilChanged(_isEqual))
                .subscribe({
                next: soaActivities => {
                    if (soaActivities?.length) {
                        this.soaActivities = soaActivities;
                        this.cdr.markForCheck();
                    }
                }
            }));
        }
        if (this.Spa_Site_EnrollmentHistory_Enabled || this.Spa_Consumer_AccountOverview_DisplayCallToAction_Enabled) {
            this.subscriptions.add(this.memberSessionService
                .getMemberQuoteHistoryForAgent$()
                .pipe(distinctUntilChanged(_isEqual))
                .subscribe({
                next: memberQuoteHistory => {
                    if (memberQuoteHistory?.length) {
                        this.memberQuoteHistory = memberQuoteHistory;
                        this.cdr.markForCheck();
                    }
                }
            }));
            this.subscriptions.add(this.memberRegistrationFacade
                .getMemberPlanEnrollments$()
                .pipe(this.memberRegistrationFacade.mapMemberEnrollmentsWithFees())
                .subscribe({
                next: memberEnrollments => {
                    if (memberEnrollments?.length) {
                        this.memberEnrollments = this.enrollmentHistoryFacade.sortEnrollments(this.enrollmentHistoryFacade.setCompletedMemberEnrollmentFlags(memberEnrollments, false));
                        if (this.Spa_Consumer_AccountOverview_DisplayCallToAction_Enabled && this.Spa_Site_Enrollment_Enabled) {
                            this.memberPartialEnrollments = this.enrollmentHistoryFacade.getPartialEnrollments(this.memberEnrollments, false);
                        }
                        this.cdr.markForCheck();
                    }
                }
            }));
        }
        this.subscriptions.add(this.unsavedModalContext.getUnsavedChangesModalContext$().subscribe({
            next: display => {
                if (display) {
                    if (!this.personalFormGroup.pristine || !this.personalAddressFormGroup.pristine) {
                        this.showUnsavedChangesModal(true);
                    }
                    else {
                        this.resetProfile();
                    }
                }
            }
        }));
        if (this.Spa_Member_Profile_MobilePhoneCopyMain_Enabled) {
            const phoneControl = this.getPersonalFormControl(this.accountOverviewInputs.CONSUMER_PHONE);
            const cellPhoneControl = this.getPersonalFormControl(this.accountOverviewInputs.CONSUMER_CELL_PHONE);
            if (cellPhoneControl && phoneControl) {
                if (phoneControl.value && cellPhoneControl.value === phoneControl.value) {
                    this.updateCellPhoneControlDisabledStatus(true);
                }
                this.subscriptions.add(combineLatest([phoneControl.valueChanges, phoneControl.statusChanges]).subscribe({
                    next: ([newValue, status]) => {
                        if (status === 'VALID' && this.disableCellPhoneInput) {
                            // This subscription makes sure that if the box is checked while the main phone field is invalid, it will update
                            // Once it is valid.
                            cellPhoneControl.setValue(newValue);
                            cellPhoneControl.markAsDirty();
                            cellPhoneControl.markAsTouched();
                            this.cdr.markForCheck();
                        }
                    }
                }));
                this.cdr.markForCheck();
            }
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
    onContinueClick() {
        this.addOnViewPlansClickGoogleTag();
        this.navigateByPageTag(PageTags.PLAN_LIST);
    }
    navigateByPageTag(pageTag) {
        this.navigationService.navigateByPageTag(pageTag);
    }
    getPersonalFormControl(controlName) {
        return this.personalFormGroup.get(controlName);
    }
    getPersonalAddressFormControl(controlName) {
        return this.personalAddressFormGroup.get(controlName);
    }
    breakRowLayout(formInputConfig) {
        return [
            this.accountOverviewInputs.ZIP,
            this.accountOverviewInputs.CONSUMER_USERNAME,
            this.accountOverviewInputs.CONSUMER_BIRTH_DATE
        ].includes(formInputConfig.keyName);
    }
    updateFipsCode(fips) {
        this.selectedFips = fips;
    }
    updateCellPhoneValue(disableCellPhoneInput) {
        this.updateCellPhoneControlDisabledStatus(disableCellPhoneInput);
        const cellPhoneControl = this.getPersonalFormControl(this.accountOverviewInputs.CONSUMER_CELL_PHONE);
        if (cellPhoneControl) {
            if (this.Spa_Member_Profile_MobilePhoneCopyMain_Enabled && this.disableCellPhoneInput) {
                const phoneControl = this.getPersonalFormControl(this.accountOverviewInputs.CONSUMER_PHONE);
                if (phoneControl?.valid) {
                    cellPhoneControl.setValue(phoneControl.value);
                    cellPhoneControl.markAsTouched();
                    cellPhoneControl.markAsDirty();
                }
            }
        }
    }
    async saveConsumerInfo() {
        const zipInputErrors = this.accountSummaryInput?.zipInput?.validateWidget?.() ?? [];
        if (!zipInputErrors.length) {
            this.submitted = true;
            if (this.personalFormGroup.valid && this.personalAddressFormGroup.valid) {
                this.submitButton.toggleSpinner(true);
                let personalFormValues = this.personalFormGroup.getRawValue();
                if (this.Spa_Member_Profile_MobilePhoneCopyMain_Enabled && this.disableCellPhoneInput) {
                    personalFormValues[AccountOverviewInputs.CONSUMER_CELL_PHONE] = personalFormValues[AccountOverviewInputs.CONSUMER_PHONE];
                }
                const personalAddressFormValues = this.personalAddressFormGroup.getRawValue();
                this.accountOverviewFacade.updateProfile$(personalFormValues, personalAddressFormValues, this.selectedFips).subscribe({
                    next: () => {
                        this.zipCodeService.updateZipCountyForMedSupAnswers();
                        this.submitButton.showSuccessMessage();
                        this.submitButton.closeTooltip(TOOLTIP_TIMEOUT);
                        this.personalFormGroup.markAsPristine();
                        this.personalAddressFormGroup.markAsPristine();
                        this.submitted = false;
                    },
                    error: error => {
                        this.submitButton.showErrorMessage();
                        this.submitButton.closeTooltip(TOOLTIP_TIMEOUT);
                        this.cdr.markForCheck();
                        this.submitted = false;
                    }
                });
            }
            else {
                this.setFocus = true;
            }
        }
    }
    resetProfile() {
        this.personalFormGroup.reset();
        this.personalAddressFormGroup.reset();
        return true;
    }
    async showUnsavedChangesModal(resetProfile) {
        // To prevent any un-expected stuck spinner event at moment to shows up the modal
        this.spinnerService.reset();
        if (this.personalFormGroup.pristine && this.personalAddressFormGroup.pristine) {
            return Promise.resolve(true);
        }
        const modalTitle = this.accountOverviewFacade.getModalTitle();
        const modalPrompt = this.accountOverviewFacade.getModalPrompt();
        const modalCancel = this.accountOverviewFacade.getModalCancel();
        const modalLeave = this.accountOverviewFacade.getModalLeave();
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true });
        confirmationModal.componentInstance.title = modalTitle;
        confirmationModal.componentInstance.prompt = modalPrompt;
        confirmationModal.componentInstance.cancelButton = modalCancel;
        confirmationModal.componentInstance.confirmButton = modalLeave;
        return confirmationModal.result
            .then(() => {
            this.spinnerService.show(SpinnerEvent.NAVIGATION);
            return resetProfile ? this.resetProfile() : true;
        })
            .catch(() => false);
    }
    addOnViewPlansClickGoogleTag() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_ACCOUNT_VIEW_PLANS
        };
    }
    updateCellPhoneControlDisabledStatus(disableCellPhoneInput) {
        this.disableCellPhoneInput = disableCellPhoneInput;
        const cellPhoneControl = this.getPersonalFormControl(this.accountOverviewInputs.CONSUMER_CELL_PHONE);
        if (cellPhoneControl) {
            if (this.disableCellPhoneInput) {
                cellPhoneControl.disable();
            }
            else {
                cellPhoneControl.enable();
            }
        }
        this.cdr.markForCheck();
    }
};
AccountSummaryComponent.ɵfac = function AccountSummaryComponent_Factory(t) { return new (t || AccountSummaryComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(MemberRegistrationFacade), i0.ɵɵdirectiveInject(EnrollmentHistoryFacade), i0.ɵɵdirectiveInject(AccountOverviewFacade), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.DeactivationGuardService), i0.ɵɵdirectiveInject(i1.UnsavedModalContext), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i1.ZipCodeService), i0.ɵɵdirectiveInject(SOAFacade)); };
AccountSummaryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AccountSummaryComponent, selectors: [["vnext-widget-account-summary"]], viewQuery: function AccountSummaryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(StatusButtonComponent, 5);
        i0.ɵɵviewQuery(AccountSummaryInputComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.submitButton = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.accountSummaryInput = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 11, vars: 8, consts: [["vnextGoogleTagManager", "", 1, "container", 3, "saveDefaultValues"], ["class", "Spa_Style_H1 pt-5 text-center", 4, "liveEditProp"], [4, "ngIf"], [3, "isSOAEnabled", "isQuoteEnabled", "isEnrollmentEnabled", "soaActivities", "memberQuoteHistory", "memberPartialEnrollments", 4, "ngIf"], [3, "memberEnrollments", "keepDefaultAPIEnrollmentOrdering", "memberQuoteHistory", "memberEnrollmentHistoryHeaderText", "noEnrollmentMessageText", "pacificStandardTimeText", "memberEnrollmentHistoryEffectiveDateText", "totalMonthlyPremiumLabel", "viewApplicationLinkText", "confirmationText", "submittedDateText", "lastUpdatedText", "confirmationNumberEnabled", "planNameEnabled", "effectiveDateEnabled", "totalMonthlyPremiumEnabled", "submissionDateEnabled", "updatedDateEnabled", "ridersEnabled", "continueEnrollmentButtonText", "hraPDFLinkText", "hraConfirmationText", "hraConfirmationNumberEnabled", "isComponentFullWidth", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "enrollmentStatusHeaderText", "enrollmentMoreDetailsText", "enrollmentHraHeaderText", "enrollmentConfirmationHeaderText", "memberEnrollmentEffectiveDateHeaderText", "riderHeaderText", "callRecordingHeaderText", "uploadDocumentHeaderText", "enrollmentHistoryProfileLinkEnabled", "isAccountSummaryPage", "enrollerButtonTooltipText", 4, "ngIf"], [1, "row", "banner-margin"], [1, "pl-0", "pl-md-4", "col-md-12", 3, "showPrevious"], ["continue-button", ""], [1, "btn", "Spa_Style_PrimaryButton", "col-xs-12", "col-md-auto", "continue-button", 3, "click"], [1, "Spa_Style_H1", "pt-5", "text-center"], ["class", "Spa_Style_Primary pt-2", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["navigationAdapter", "", 1, "Spa_Style_Primary", "pt-2", 3, "innerHtml"], [1, "col-12", "mt-4"], ["navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["class", "Spa_Style_H2 mt-3 px-0", 4, "liveEditProp"], [1, "personal-information-container"], ["class", "row pb-4 align-items-baseline", 3, "formGroup", 4, "ngIf"], ["class", "Spa_Style_H3 Spa_Style_Primary_Color section-title mt-3 px-0", 4, "liveEditProp"], ["class", "row pb-4", 3, "formGroup", 4, "ngIf"], [1, "mb-2"], [1, "d-flex", "justify-content-end", "row"], [1, "col-md-2", "px-0"], [1, "button-container"], ["class", "btn col-sm-12", "disabled", "!personalFormGroup.valid || !this.personalAddressFormGroup.valid", 3, "buttonText", "buttonClass", "tooltipMessageError", "tooltipMessageSuccess", "click", 4, "liveEditProp"], ["navigationAdapter", "", 3, "innerHtml"], [1, "Spa_Style_H2", "mt-3", "px-0"], [1, "row", "pb-4", "align-items-baseline", 3, "formGroup"], [4, "ngFor", "ngForOf"], [3, "ngClass"], [3, "personalFormGroup", "personalFormInputConfig", "control", "submitted", "selectedCountyEnabled", "zipCodeRequiredErrorText", "zipCodeInvalidErrorText", "countyErrorText", "selectCountyText", "zipCodeText", "editCountyText", "customStyles", "errorKeywordText", "countyLabel", "showCountyLabel", "noDateError", "futureDateError", "outOfRangeError", "maxAge", "retrieveZipCode", "retrieveFipsCode", "sameAsPrimaryText", "displayCellPhoneCheckbox", "disableCellPhoneInput", "selectedFips", "cellPhoneCheckBoxToggled"], ["accountSummaryInput", ""], ["class", "break", 4, "ngIf"], [1, "break"], [1, "Spa_Style_H3", "Spa_Style_Primary_Color", "section-title", "mt-3", "px-0"], [1, "row", "pb-4", 3, "formGroup"], [1, "col-lg-3", "col-md-6", "col-12"], [3, "personalFormGroup", "personalFormInputConfig", "control", "submitted", "selectedZipCode", "addressAutoCompleteEnabled"], ["disabled", "!personalFormGroup.valid || !this.personalAddressFormGroup.valid", 1, "btn", "col-sm-12", 3, "buttonText", "buttonClass", "tooltipMessageError", "tooltipMessageSuccess", "click"], [3, "isSOAEnabled", "isQuoteEnabled", "isEnrollmentEnabled", "soaActivities", "memberQuoteHistory", "memberPartialEnrollments"], [3, "memberEnrollments", "keepDefaultAPIEnrollmentOrdering", "memberQuoteHistory", "memberEnrollmentHistoryHeaderText", "noEnrollmentMessageText", "pacificStandardTimeText", "memberEnrollmentHistoryEffectiveDateText", "totalMonthlyPremiumLabel", "viewApplicationLinkText", "confirmationText", "submittedDateText", "lastUpdatedText", "confirmationNumberEnabled", "planNameEnabled", "effectiveDateEnabled", "totalMonthlyPremiumEnabled", "submissionDateEnabled", "updatedDateEnabled", "ridersEnabled", "continueEnrollmentButtonText", "hraPDFLinkText", "hraConfirmationText", "hraConfirmationNumberEnabled", "isComponentFullWidth", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "enrollmentStatusHeaderText", "enrollmentMoreDetailsText", "enrollmentHraHeaderText", "enrollmentConfirmationHeaderText", "memberEnrollmentEffectiveDateHeaderText", "riderHeaderText", "callRecordingHeaderText", "uploadDocumentHeaderText", "enrollmentHistoryProfileLinkEnabled", "isAccountSummaryPage", "enrollerButtonTooltipText"]], template: function AccountSummaryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, AccountSummaryComponent_h1_1_Template, 2, 1, "h1", 1);
        i0.ɵɵtemplate(2, AccountSummaryComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
        i0.ɵɵtemplate(3, AccountSummaryComponent_div_3_Template, 13, 6, "div", 2);
        i0.ɵɵtemplate(4, AccountSummaryComponent_vnext_widget_call_to_action_area_4_Template, 1, 6, "vnext-widget-call-to-action-area", 3);
        i0.ɵɵtemplate(5, AccountSummaryComponent_vnext_member_enrollment_history_5_Template, 1, 39, "vnext-member-enrollment-history", 4);
        i0.ɵɵelementStart(6, "div", 5)(7, "vnext-navigation-banner", 6)(8, "div", 7)(9, "button", 8);
        i0.ɵɵlistener("click", function AccountSummaryComponent_Template_button_click_9_listener() { return ctx.onContinueClick(); });
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("saveDefaultValues", true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_Consumer_AccountOverview_Header_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Consumer_AccountOverview_Introduction_Text);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Consumer_AccountOverview_PersonalFormEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Consumer_AccountOverview_DisplayCallToAction_Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Site_EnrollmentHistory_Enabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("showPrevious", true);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.Spa_Consumer_AccountOverview_ViewPlans_Text, " ");
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i4.ɵNgNoValidate, i4.NgControlStatusGroup, i4.FormGroupDirective, NavigationBannerComponent, StatusButtonComponent, NavigationAdapterDirective, LiveEditPropDirective, GoogleTagManagerDirective, MemberEnrollmentHistoryComponent, AccountSummaryInputComponent, CallToActionAreaComponent, SafePipe], styles: [".personal-information-container[_ngcontent-%COMP%]{padding:10px 16px;border:1px solid var(--static-Spa_Style_Accent1);border-radius:4px;background-clip:border-box}.personal-information-container[_ngcontent-%COMP%]   .break[_ngcontent-%COMP%]{flex-basis:100%;height:0}.personal-information-container[_ngcontent-%COMP%]   .section-title[_ngcontent-%COMP%]{font-family:montserratregular;font-size:18px}"], changeDetection: 0 });
__decorate([
    PlatformProp('live-edit')
], AccountSummaryComponent.prototype, "Spa_Consumer_AccountOverview_ViewPlans_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountSummaryComponent.prototype, "Spa_Consumer_AccountOverview_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountSummaryComponent.prototype, "Spa_Consumer_AccountOverview_Introduction_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountSummaryComponent.prototype, "Spa_Site_PageSubHeader_Text", void 0);
__decorate([
    PlatformProp()
], AccountSummaryComponent.prototype, "Spa_Site_EnrollmentHistory_Enabled", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_NoEnrollmentMessageText", void 0);
__decorate([
    PlatformProp()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_Pacific_StandardTime_Text", void 0);
__decorate([
    PlatformProp()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_RequestedEffectiveDate_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountSummaryComponent.prototype, "Spa_Site_TotalMonthlyPremiumLabel", void 0);
__decorate([
    PlatformProp()
], AccountSummaryComponent.prototype, "Spa_Site_ViewApplication_Link_Text", void 0);
__decorate([
    PlatformProp()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_Confirmation_Text", void 0);
__decorate([
    PlatformProp()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_SubmittedDate_Text", void 0);
__decorate([
    PlatformProp()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_UpdatedDate_Text", void 0);
__decorate([
    PlatformProp()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_ConfirmationNumber_Enabled", void 0);
__decorate([
    PlatformProp()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_PlanName_Enabled", void 0);
__decorate([
    PlatformProp()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_EffectiveDate_Enabled", void 0);
__decorate([
    PlatformProp()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_TotalMonthlyPremium_Enabled", void 0);
__decorate([
    PlatformProp()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_SubmissionDate_Enabled", void 0);
__decorate([
    PlatformProp()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_UpdatedDate_Enabled", void 0);
__decorate([
    PlatformProp()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_Riders_Enabled", void 0);
__decorate([
    PlatformProp()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_ContinueEnrollment_ButtonText", void 0);
__decorate([
    PlatformProp()
], AccountSummaryComponent.prototype, "SPA_EnrollmentHistory_HRALink_Text", void 0);
__decorate([
    PlatformProp()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_hraConfirmation_Text", void 0);
__decorate([
    PlatformProp()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_hraConfirmation_Enabled", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountSummaryComponent.prototype, "Spa_Consumer_AccountOverview_PersonalHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AccountSummaryComponent.prototype, "Spa_Consumer_AccountOverview_PersonalAddressHeader_Text", void 0);
__decorate([
    PlatformProp()
], AccountSummaryComponent.prototype, "Spa_Consumer_AccountOverview_Button_Text", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Site_ZipCodeInput_SelectedCountyEnabled", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Member_Profile_Invalid_ZipError_Text", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Site_ZipCodeRequired_Error", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Site_ZipCodeInput_CountyError", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Site_ZipCodeInput_SelectCounty", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Site_ZipCodeInput_ZipCodeLabel", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Site_ZipCodeInput_EditCounty", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Text", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Enabled", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Site_ErrorKeyword_Text", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Consumer_AccountOverview_TooltipError_Text", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Consumer_AccountOverview_TooltipSuccess_Text", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Consumer_AccountOverview_PersonalForm", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Consumer_AccountOverview_PersonalAddressForm", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Consumer_AccountOverview_PersonalFormEnabled", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Member_Profile_AddressAutoComplete_Enabled", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Member_Profile_NoBirthDateError_Text", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Member_Profile_FutureBirthDateError_Text", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Member_Profile_BirthDateOutOfRangeError_Text", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Member_Profile_Maximum_Age", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Site_PlanFees_Enabled", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_PlanFees_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_PlanFees_IncludedInPremium_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Site_SameAsPrimary_Text", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Member_Profile_MobilePhoneCopyMain_Enabled", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Site_EnrollmentHistory_ProfileLink_Enabled", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Site_EnrollmentHistory_MoreDetailsText", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_EnrollmentStatus_HeaderText", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_HealthRiskAssessment_HeaderText", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_Confirmation_HeaderText", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_RequestedEffectiveDate_HeaderText", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_Riders_HeaderText", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_CallRecordings_HeaderText", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_EnrollmentHistory_UploadedDocuments_HeaderText", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Site_EnrollerButton_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Site_SOA_Enabled", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Site_EnableQuoteSummary", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Site_Enrollment_Enabled", void 0);
__decorate([
    GlobalResource()
], AccountSummaryComponent.prototype, "Spa_Consumer_AccountOverview_DisplayCallToAction_Enabled", void 0);
__decorate([
    LiveEditInactive()
], AccountSummaryComponent.prototype, "onContinueClick", null);
__decorate([
    LiveEditInactive()
], AccountSummaryComponent.prototype, "saveConsumerInfo", null);
AccountSummaryComponent = __decorate([
    PlatformWidget
], AccountSummaryComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccountSummaryComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-account-summary', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"container\" vnextGoogleTagManager [saveDefaultValues]=\"true\">\r\n  <h1 class=\"Spa_Style_H1 pt-5 text-center\" *liveEditProp=\"'Spa_Consumer_AccountOverview_Header_Text'\">\r\n    {{ Spa_Consumer_AccountOverview_Header_Text }}\r\n  </h1>\r\n  <ng-container *ngIf=\"Spa_Consumer_AccountOverview_Introduction_Text\">\r\n    <div\r\n      class=\"Spa_Style_Primary pt-2\"\r\n      *liveEditProp=\"'Spa_Consumer_AccountOverview_Introduction_Text'\"\r\n      [innerHtml]=\"Spa_Consumer_AccountOverview_Introduction_Text | safe : 'html'\"\r\n      navigationAdapter\r\n    ></div>\r\n  </ng-container>\r\n  <div *ngIf=\"Spa_Consumer_AccountOverview_PersonalFormEnabled\">\r\n    <div class=\"col-12 mt-4\">\r\n      <div *liveEditProp=\"'Spa_Site_PageSubHeader_Text'\" [innerHtml]=\"Spa_Site_PageSubHeader_Text | safe : 'html'\" navigationAdapter></div>\r\n    </div>\r\n    <h2 *liveEditProp=\"'Spa_Consumer_AccountOverview_PersonalHeader_Text'\" class=\"Spa_Style_H2 mt-3 px-0\">\r\n      {{ Spa_Consumer_AccountOverview_PersonalHeader_Text }}\r\n    </h2>\r\n    <div class=\"personal-information-container\">\r\n      <form *ngIf=\"personalFormGroup\" class=\"row pb-4 align-items-baseline\" [formGroup]=\"personalFormGroup\">\r\n        <ng-container *ngFor=\"let formInputConfig of Spa_Consumer_AccountOverview_PersonalForm\">\r\n          <div\r\n            [ngClass]=\"{\r\n              'col':\r\n                formInputConfig.keyName === accountOverviewInputs.ZIP ||\r\n                consumerPersonalAccountFormConfig[formInputConfig.keyName]?.breakRowLayout,\r\n              'col-lg-3 col-md-6 col-12':\r\n                formInputConfig.keyName !== accountOverviewInputs.ZIP &&\r\n                !consumerPersonalAccountFormConfig[formInputConfig.keyName]?.breakRowLayout\r\n            }\"\r\n          >\r\n            <vnext-widget-account-summary-input\r\n              #accountSummaryInput\r\n              [personalFormGroup]=\"personalFormGroup\"\r\n              [personalFormInputConfig]=\"formInputConfig\"\r\n              [control]=\"consumerPersonalAccountFormConfig[formInputConfig.keyName]?.control\"\r\n              [submitted]=\"submitted\"\r\n              [selectedCountyEnabled]=\"Spa_Site_ZipCodeInput_SelectedCountyEnabled\"\r\n              [zipCodeRequiredErrorText]=\"Spa_Site_ZipCodeRequired_Error\"\r\n              [zipCodeInvalidErrorText]=\"Spa_Member_Profile_Invalid_ZipError_Text\"\r\n              [countyErrorText]=\"Spa_Site_ZipCodeInput_CountyError\"\r\n              [selectCountyText]=\"Spa_Site_ZipCodeInput_SelectCounty\"\r\n              [zipCodeText]=\"Spa_Site_ZipCodeInput_ZipCodeLabel\"\r\n              [editCountyText]=\"Spa_Site_ZipCodeInput_EditCounty\"\r\n              [customStyles]=\"zipCodeCustomStyles\"\r\n              [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n              [countyLabel]=\"Spa_ZipCodeInput_CountyLabel_Text\"\r\n              [showCountyLabel]=\"Spa_ZipCodeInput_CountyLabel_Enabled\"\r\n              [noDateError]=\"Spa_Member_Profile_NoBirthDateError_Text\"\r\n              [futureDateError]=\"Spa_Member_Profile_FutureBirthDateError_Text\"\r\n              [outOfRangeError]=\"Spa_Member_Profile_BirthDateOutOfRangeError_Text\"\r\n              [maxAge]=\"Spa_Member_Profile_Maximum_Age\"\r\n              [retrieveZipCode]=\"getZipCodeFunction\"\r\n              [retrieveFipsCode]=\"getFipsCodeFunction\"\r\n              [sameAsPrimaryText]=\"Spa_Site_SameAsPrimary_Text\"\r\n              [displayCellPhoneCheckbox]=\"Spa_Member_Profile_MobilePhoneCopyMain_Enabled\"\r\n              (selectedFips)=\"updateFipsCode($event)\"\r\n              [disableCellPhoneInput]=\"disableCellPhoneInput\"\r\n              (cellPhoneCheckBoxToggled)=\"updateCellPhoneValue($event)\"\r\n            >\r\n            </vnext-widget-account-summary-input>\r\n          </div>\r\n          <div *ngIf=\"consumerPersonalAccountFormConfig[formInputConfig.keyName]?.breakRowLayout\" class=\"break\"></div>\r\n        </ng-container>\r\n      </form>\r\n\r\n      <h3\r\n        *liveEditProp=\"'Spa_Consumer_AccountOverview_PersonalAddressHeader_Text'\"\r\n        class=\"Spa_Style_H3 Spa_Style_Primary_Color section-title mt-3 px-0\"\r\n      >\r\n        {{ Spa_Consumer_AccountOverview_PersonalAddressHeader_Text }}\r\n      </h3>\r\n      <form\r\n        *ngIf=\"Spa_Consumer_AccountOverview_PersonalFormEnabled && personalAddressFormGroup\"\r\n        class=\"row pb-4\"\r\n        [formGroup]=\"personalAddressFormGroup\"\r\n      >\r\n        <ng-container *ngFor=\"let formInputConfig of Spa_Consumer_AccountOverview_PersonalAddressForm\">\r\n          <div class=\"col-lg-3 col-md-6 col-12\">\r\n            <vnext-widget-account-summary-input\r\n              [personalFormGroup]=\"personalAddressFormGroup\"\r\n              [personalFormInputConfig]=\"formInputConfig\"\r\n              [control]=\"consumerPersonalAddressFormConfig[formInputConfig.keyName]?.control\"\r\n              [submitted]=\"submitted\"\r\n              [selectedZipCode]=\"consumerPersonalAccountFormConfig[accountOverviewInputs.ZIP].control.value\"\r\n              [addressAutoCompleteEnabled]=\"Spa_Member_Profile_AddressAutoComplete_Enabled\"\r\n            >\r\n            </vnext-widget-account-summary-input>\r\n            <div *ngIf=\"consumerPersonalAddressFormConfig[formInputConfig.keyName]?.breakRowLayout\" class=\"break\"></div>\r\n          </div>\r\n        </ng-container>\r\n      </form>\r\n      <div class=\"mb-2\">\r\n        <div class=\"d-flex justify-content-end row\">\r\n          <div class=\"col-md-2 px-0\">\r\n            <div class=\"button-container\">\r\n              <vnext-status-button\r\n                [buttonText]=\"Spa_Consumer_AccountOverview_Button_Text\"\r\n                [buttonClass]=\"'Spa_Style_PrimaryButton'\"\r\n                [tooltipMessageError]=\"Spa_Consumer_AccountOverview_TooltipError_Text\"\r\n                [tooltipMessageSuccess]=\"Spa_Consumer_AccountOverview_TooltipSuccess_Text\"\r\n                (click)=\"saveConsumerInfo()\"\r\n                class=\"btn col-sm-12\"\r\n                disabled=\"!personalFormGroup.valid || !this.personalAddressFormGroup.valid\"\r\n                *liveEditProp=\"'Spa_Consumer_AccountOverview_Button_Text'\"\r\n              >\r\n              </vnext-status-button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <vnext-widget-call-to-action-area\r\n    *ngIf=\"Spa_Consumer_AccountOverview_DisplayCallToAction_Enabled\"\r\n    [isSOAEnabled]=\"Spa_Site_SOA_Enabled\"\r\n    [isQuoteEnabled]=\"Spa_Site_EnableQuoteSummary\"\r\n    [isEnrollmentEnabled]=\"Spa_Site_Enrollment_Enabled\"\r\n    [soaActivities]=\"soaActivities\"\r\n    [memberQuoteHistory]=\"memberQuoteHistory\"\r\n    [memberPartialEnrollments]=\"memberPartialEnrollments\"\r\n  ></vnext-widget-call-to-action-area>\r\n\r\n  <vnext-member-enrollment-history\r\n    *ngIf=\"Spa_Site_EnrollmentHistory_Enabled\"\r\n    [memberEnrollments]=\"memberEnrollments\"\r\n    [keepDefaultAPIEnrollmentOrdering]=\"false\"\r\n    [memberQuoteHistory]=\"memberQuoteHistory\"\r\n    [memberEnrollmentHistoryHeaderText]=\"Spa_EnrollmentHistory_Header_Text\"\r\n    [noEnrollmentMessageText]=\"Spa_EnrollmentHistory_NoEnrollmentMessageText\"\r\n    [pacificStandardTimeText]=\"Spa_EnrollmentHistory_Pacific_StandardTime_Text\"\r\n    [memberEnrollmentHistoryEffectiveDateText]=\"Spa_EnrollmentHistory_RequestedEffectiveDate_Text\"\r\n    [totalMonthlyPremiumLabel]=\"Spa_Site_TotalMonthlyPremiumLabel\"\r\n    [viewApplicationLinkText]=\"Spa_Site_ViewApplication_Link_Text\"\r\n    [confirmationText]=\"Spa_EnrollmentHistory_Confirmation_Text\"\r\n    [submittedDateText]=\"Spa_EnrollmentHistory_SubmittedDate_Text\"\r\n    [lastUpdatedText]=\"Spa_EnrollmentHistory_UpdatedDate_Text\"\r\n    [confirmationNumberEnabled]=\"Spa_EnrollmentHistory_ConfirmationNumber_Enabled\"\r\n    [planNameEnabled]=\"Spa_EnrollmentHistory_PlanName_Enabled\"\r\n    [effectiveDateEnabled]=\"Spa_EnrollmentHistory_EffectiveDate_Enabled\"\r\n    [totalMonthlyPremiumEnabled]=\"Spa_EnrollmentHistory_TotalMonthlyPremium_Enabled\"\r\n    [submissionDateEnabled]=\"Spa_EnrollmentHistory_SubmissionDate_Enabled\"\r\n    [updatedDateEnabled]=\"Spa_EnrollmentHistory_UpdatedDate_Enabled\"\r\n    [ridersEnabled]=\"Spa_EnrollmentHistory_Riders_Enabled\"\r\n    [continueEnrollmentButtonText]=\"Spa_EnrollmentHistory_ContinueEnrollment_ButtonText\"\r\n    [hraPDFLinkText]=\"SPA_EnrollmentHistory_HRALink_Text\"\r\n    [hraConfirmationText]=\"Spa_EnrollmentHistory_hraConfirmation_Text\"\r\n    [hraConfirmationNumberEnabled]=\"Spa_EnrollmentHistory_hraConfirmation_Enabled\"\r\n    [isComponentFullWidth]=\"true\"\r\n    [planFeesEnabled]=\"Spa_Site_PlanFees_Enabled\"\r\n    [planFeesTooltipText]=\"Spa_PlanFees_Tooltip_Text\"\r\n    [planFeesIncludedInPremiumTooltipText]=\"Spa_PlanFees_IncludedInPremium_Tooltip_Text\"\r\n    [planFeesNotIncludedInPremiumTooltipText]=\"Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text\"\r\n    [enrollmentStatusHeaderText]=\"Spa_EnrollmentHistory_EnrollmentStatus_HeaderText\"\r\n    [enrollmentMoreDetailsText]=\"Spa_Site_EnrollmentHistory_MoreDetailsText\"\r\n    [enrollmentHraHeaderText]=\"Spa_EnrollmentHistory_HealthRiskAssessment_HeaderText\"\r\n    [enrollmentConfirmationHeaderText]=\"Spa_EnrollmentHistory_Confirmation_HeaderText\"\r\n    [memberEnrollmentEffectiveDateHeaderText]=\"Spa_EnrollmentHistory_RequestedEffectiveDate_HeaderText\"\r\n    [riderHeaderText]=\"Spa_EnrollmentHistory_Riders_HeaderText\"\r\n    [callRecordingHeaderText]=\"Spa_EnrollmentHistory_CallRecordings_HeaderText\"\r\n    [uploadDocumentHeaderText]=\"Spa_EnrollmentHistory_UploadedDocuments_HeaderText\"\r\n    [enrollmentHistoryProfileLinkEnabled]=\"Spa_Site_EnrollmentHistory_ProfileLink_Enabled\"\r\n    [isAccountSummaryPage]=\"isAccountSummaryPage\"\r\n    [enrollerButtonTooltipText]=\"Spa_Site_EnrollerButton_Tooltip_Text\"\r\n  ></vnext-member-enrollment-history>\r\n\r\n  <div class=\"row banner-margin\">\r\n    <vnext-navigation-banner class=\"pl-0 pl-md-4 col-md-12\" [showPrevious]=\"true\">\r\n      <div continue-button>\r\n        <button class=\"btn Spa_Style_PrimaryButton col-xs-12 col-md-auto continue-button\" (click)=\"onContinueClick()\">\r\n          {{ Spa_Consumer_AccountOverview_ViewPlans_Text }}\r\n        </button>\r\n      </div>\r\n    </vnext-navigation-banner>\r\n  </div>\r\n</div>\r\n", styles: [".personal-information-container{padding:10px 16px;border:1px solid var(--static-Spa_Style_Accent1);border-radius:4px;background-clip:border-box}.personal-information-container .break{flex-basis:100%;height:0}.personal-information-container .section-title{font-family:montserratregular;font-size:18px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.NavigationService }, { type: i1.MemberSessionService }, { type: MemberRegistrationFacade }, { type: EnrollmentHistoryFacade }, { type: AccountOverviewFacade }, { type: AnalyticsService }, { type: i1.DeactivationGuardService }, { type: i1.UnsavedModalContext }, { type: i1$1.NgbModal }, { type: i1.SpinnerService }, { type: i1.ZipCodeService }, { type: SOAFacade }]; }, { Spa_Consumer_AccountOverview_ViewPlans_Text: [], Spa_Consumer_AccountOverview_Header_Text: [], Spa_Consumer_AccountOverview_Introduction_Text: [], Spa_Site_PageSubHeader_Text: [], Spa_Site_EnrollmentHistory_Enabled: [], Spa_EnrollmentHistory_Header_Text: [], Spa_EnrollmentHistory_NoEnrollmentMessageText: [], Spa_EnrollmentHistory_Pacific_StandardTime_Text: [], Spa_EnrollmentHistory_RequestedEffectiveDate_Text: [], Spa_Site_TotalMonthlyPremiumLabel: [], Spa_Site_ViewApplication_Link_Text: [], Spa_EnrollmentHistory_Confirmation_Text: [], Spa_EnrollmentHistory_SubmittedDate_Text: [], Spa_EnrollmentHistory_UpdatedDate_Text: [], Spa_EnrollmentHistory_ConfirmationNumber_Enabled: [], Spa_EnrollmentHistory_PlanName_Enabled: [], Spa_EnrollmentHistory_EffectiveDate_Enabled: [], Spa_EnrollmentHistory_TotalMonthlyPremium_Enabled: [], Spa_EnrollmentHistory_SubmissionDate_Enabled: [], Spa_EnrollmentHistory_UpdatedDate_Enabled: [], Spa_EnrollmentHistory_Riders_Enabled: [], Spa_EnrollmentHistory_ContinueEnrollment_ButtonText: [], SPA_EnrollmentHistory_HRALink_Text: [], Spa_EnrollmentHistory_hraConfirmation_Text: [], Spa_EnrollmentHistory_hraConfirmation_Enabled: [], Spa_Consumer_AccountOverview_PersonalHeader_Text: [], Spa_Consumer_AccountOverview_PersonalAddressHeader_Text: [], Spa_Consumer_AccountOverview_Button_Text: [], Spa_Site_ZipCodeInput_SelectedCountyEnabled: [], Spa_Member_Profile_Invalid_ZipError_Text: [], Spa_Site_ZipCodeRequired_Error: [], Spa_Site_ZipCodeInput_CountyError: [], Spa_Site_ZipCodeInput_SelectCounty: [], Spa_Site_ZipCodeInput_ZipCodeLabel: [], Spa_Site_ZipCodeInput_EditCounty: [], Spa_ZipCodeInput_CountyLabel_Text: [], Spa_ZipCodeInput_CountyLabel_Enabled: [], Spa_Site_ErrorKeyword_Text: [], Spa_Consumer_AccountOverview_TooltipError_Text: [], Spa_Consumer_AccountOverview_TooltipSuccess_Text: [], Spa_Consumer_AccountOverview_PersonalForm: [], Spa_Consumer_AccountOverview_PersonalAddressForm: [], Spa_Consumer_AccountOverview_PersonalFormEnabled: [], Spa_Member_Profile_AddressAutoComplete_Enabled: [], Spa_Member_Profile_NoBirthDateError_Text: [], Spa_Member_Profile_FutureBirthDateError_Text: [], Spa_Member_Profile_BirthDateOutOfRangeError_Text: [], Spa_Member_Profile_Maximum_Age: [], Spa_Site_PlanFees_Enabled: [], Spa_PlanFees_Tooltip_Text: [], Spa_PlanFees_IncludedInPremium_Tooltip_Text: [], Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text: [], Spa_Site_SameAsPrimary_Text: [], Spa_Member_Profile_MobilePhoneCopyMain_Enabled: [], Spa_Site_EnrollmentHistory_ProfileLink_Enabled: [], Spa_Site_EnrollmentHistory_MoreDetailsText: [], Spa_EnrollmentHistory_EnrollmentStatus_HeaderText: [], Spa_EnrollmentHistory_HealthRiskAssessment_HeaderText: [], Spa_EnrollmentHistory_Confirmation_HeaderText: [], Spa_EnrollmentHistory_RequestedEffectiveDate_HeaderText: [], Spa_EnrollmentHistory_Riders_HeaderText: [], Spa_EnrollmentHistory_CallRecordings_HeaderText: [], Spa_EnrollmentHistory_UploadedDocuments_HeaderText: [], Spa_Site_EnrollerButton_Tooltip_Text: [], Spa_Site_SOA_Enabled: [], Spa_Site_EnableQuoteSummary: [], Spa_Site_Enrollment_Enabled: [], Spa_Consumer_AccountOverview_DisplayCallToAction_Enabled: [], submitButton: [{
            type: ViewChild,
            args: [StatusButtonComponent]
        }], accountSummaryInput: [{
            type: ViewChild,
            args: [AccountSummaryInputComponent]
        }], onContinueClick: [], saveConsumerInfo: [] }); })();

class CallToActionTile {
}
CallToActionTile.ɵfac = function CallToActionTile_Factory(t) { return new (t || CallToActionTile)(); };
CallToActionTile.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CallToActionTile, selectors: [["vnext-widget-call-to-action-tile"]], decls: 0, vars: 0, template: function CallToActionTile_Template(rf, ctx) { }, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CallToActionTile, [{
        type: Component,
        args: [{ selector: 'vnext-widget-call-to-action-tile', changeDetection: ChangeDetectionStrategy.OnPush, template: "<!-- SPA-21563: SOA tile -->\r\n<!-- SPA-21659: Quotes tile -->\r\n<!-- SPA-21660: Enrollments tile -->\r\n" }]
    }], null, null); })();

function CompletedEnrollmentsHistoryComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 7);
    i0.ɵɵelement(2, "vnext-member-enrollment-card", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const enrollment_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("memberEnrollment", enrollment_r2)("memberEnrollmentSubmittedDate", enrollment_r2.submittedDate)("memberEnrollmentEffectiveDate", enrollment_r2.requestedEffectiveDate)("showEffectiveDate", enrollment_r2.showEffectiveDate)("enrollmentStatus", enrollment_r2.enrollmentStatus)("totalMonthlyPremiumLabel", ctx_r0.Spa_Site_TotalMonthlyPremiumLabel)("viewApplicationLinkText", ctx_r0.Spa_Site_ViewApplication_Link_Text)("confirmationText", ctx_r0.Spa_EnrollmentHistory_Confirmation_Text)("confirmationNumberEnabled", ctx_r0.Spa_EnrollmentHistory_ConfirmationNumber_Enabled)("planNameEnabled", ctx_r0.Spa_EnrollmentHistory_PlanName_Enabled)("effectiveDateEnabled", ctx_r0.Spa_EnrollmentHistory_EffectiveDate_Enabled)("totalMonthlyPremiumEnabled", ctx_r0.Spa_EnrollmentHistory_TotalMonthlyPremium_Enabled)("submissionDateEnabled", ctx_r0.Spa_EnrollmentHistory_SubmissionDate_Enabled)("ridersEnabled", ctx_r0.Spa_EnrollmentHistory_Riders_Enabled)("hraConfirmationNumberEnabled", ctx_r0.Spa_EnrollmentHistory_hraConfirmation_Enabled)("hraConfirmationText", ctx_r0.Spa_EnrollmentHistory_hraConfirmation_Text)("hraPDFLinkText", ctx_r0.SPA_EnrollmentHistory_HRALink_Text)("agentCallRecords", enrollment_r2.agentCallRecords)("pacificStandardTimeText", ctx_r0.Spa_EnrollmentHistory_Pacific_StandardTime_Text)("isHRAEnabled", ctx_r0.Spa_Site_HRA_Enabled)("completeHRAButtonEnabled", ctx_r0.Spa_Site_CompleteHRA_Button_Enabled)("openExternalInNewTab", ctx_r0.Spa_EnrollmentConfirmation_OpenExternalHRAInNewTab_Enabled)("completeHRAButtonText", ctx_r0.Spa_Site_CompleteHRA_Button_Text)("completeHRALastVisitedText", ctx_r0.Spa_Site_CompleteHRA_LastVisited_Text)("completeHRADaysLeftText", ctx_r0.Spa_Site_CompleteHRA_DaysLeft_Text)("showPlanYearBadge", ctx_r0.isDualPlanYearSite && ctx_r0.Spa_EnrollmentHistory_ShowPlanYearBadge_Enabled)("planYear", enrollment_r2.planYear)("isActivePlanYear", enrollment_r2.isCurrentYearEnrollment)("planFeesEnabled", ctx_r0.Spa_Site_PlanFees_Enabled)("planFeesTooltipText", ctx_r0.Spa_PlanFees_Tooltip_Text)("planFeesIncludedInPremiumTooltipText", ctx_r0.Spa_PlanFees_IncludedInPremium_Tooltip_Text)("planFeesNotIncludedInPremiumTooltipText", ctx_r0.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text)("enrollmentStatusHeaderText", ctx_r0.Spa_EnrollmentHistory_EnrollmentStatus_HeaderText)("enrollmentMoreDetailsText", ctx_r0.Spa_Site_EnrollmentHistory_MoreDetailsText)("enrollmentHraHeaderText", ctx_r0.Spa_EnrollmentHistory_HealthRiskAssessment_HeaderText)("enrollmentConfirmationHeaderText", ctx_r0.Spa_EnrollmentHistory_Confirmation_HeaderText)("memberEnrollmentEffectiveDateHeaderText", ctx_r0.Spa_EnrollmentHistory_RequestedEffectiveDate_HeaderText)("riderHeaderText", ctx_r0.Spa_EnrollmentHistory_Riders_HeaderText)("callRecordingHeaderText", ctx_r0.Spa_EnrollmentHistory_CallRecordings_HeaderText)("uploadDocumentHeaderText", ctx_r0.Spa_EnrollmentHistory_UploadedDocuments_HeaderText)("valueBasedCareConfirmationEnabled", ctx_r0.Spa_ValueBasedCare_Confirmation_Enabled)("valueBasedCareConfirmationText", ctx_r0.Spa_EnrollmentHistory_ValueBasedCare_HeaderText)("valueBasedCareProviders", ctx_r0.valueBasedCareProviders)("isExpandableDetailViewEnabled", ctx_r0.Spa_Site_EnrollmentHistory_ProfileLink_Enabled)("isHRAPDFAccessEnabled", ctx_r0.Spa_EditProfile_AccessHRAPDF_Enabled)("isProfileAdmin", ctx_r0.isProfileAdmin)("isCompleteHRAProfileAdminEnabled", ctx_r0.Spa_EditProfile_CompleteHRAProfileAdmin_Enabled)("excludedCarrierIds", ctx_r0.Spa_HRA_ExcludedCarriers);
} }
function CompletedEnrollmentsHistoryComponent_ng_container_12_h5_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h5", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.Spa_EnrollmentHistory_NoEnrollmentMessageText, " ");
} }
function CompletedEnrollmentsHistoryComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CompletedEnrollmentsHistoryComponent_ng_container_12_h5_1_Template, 2, 1, "h5", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_EnrollmentHistory_NoEnrollmentMessageText");
} }
let CompletedEnrollmentsHistoryComponent = class CompletedEnrollmentsHistoryComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, navigationService, memberSessionService, profileService, enrollmentHistoryFacade, datePipe, planYearResourceService, localeService, providerFacade, agentService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.navigationService = navigationService;
        this.memberSessionService = memberSessionService;
        this.profileService = profileService;
        this.enrollmentHistoryFacade = enrollmentHistoryFacade;
        this.datePipe = datePipe;
        this.planYearResourceService = planYearResourceService;
        this.localeService = localeService;
        this.providerFacade = providerFacade;
        this.agentService = agentService;
        this.Spa_Site_Previous = 'Previous';
        this.Spa_Site_EnrollmentHistory_TitleText = 'Completed Enrollment History';
        this.Spa_Site_EnrollmentHistory_HeaderText = 'View all enrollments for <member>';
        this.Spa_Site_EnrollmentHistory_MoreDetailsText = 'More details';
        this.Spa_EnrollmentHistory_EnrollmentStatus_HeaderText = 'Enrollment status';
        this.Spa_EnrollmentHistory_HealthRiskAssessment_HeaderText = 'Health Risk Assessment';
        this.Spa_EnrollmentHistory_Confirmation_HeaderText = 'Enrollment confirmation';
        this.Spa_EnrollmentHistory_RequestedEffectiveDate_HeaderText = 'Requested effective date';
        this.Spa_EnrollmentHistory_Riders_HeaderText = 'Riders';
        this.Spa_EnrollmentHistory_CallRecordings_HeaderText = 'Call recordings';
        this.Spa_EnrollmentHistory_UploadedDocuments_HeaderText = 'Uploaded documents';
        this.Spa_EnrollmentHistory_SubmittedDate_Text = 'Submitted';
        this.Spa_EnrollmentHistory_Pacific_StandardTime_Text = 'PST';
        this.Spa_EnrollmentHistory_EffectiveDate_Enabled = true;
        this.Spa_EnrollmentHistory_EnrollmentStatus_Enabled = false;
        this.Spa_EnrollmentStatus_Label_Text = 'Status:';
        this.Spa_EnrollmentStatus_Default = 'Status unknown';
        this.Spa_EnrollmentStatus_Date_Text = 'Last Updated';
        this.Spa_Site_TotalMonthlyPremiumLabel = 'Total monthly premium';
        this.Spa_Site_ViewApplication_Link_Text = 'View application';
        this.Spa_EnrollmentHistory_Confirmation_Text = 'Confirmation';
        this.Spa_EnrollmentHistory_ConfirmationNumber_Enabled = true;
        this.Spa_EnrollmentHistory_PlanName_Enabled = true;
        this.Spa_EnrollmentHistory_TotalMonthlyPremium_Enabled = true;
        this.Spa_EnrollmentHistory_SubmissionDate_Enabled = true;
        this.Spa_EnrollmentHistory_Riders_Enabled = true;
        this.Spa_EnrollmentHistory_hraConfirmation_Enabled = true;
        this.Spa_EnrollmentHistory_hraConfirmation_Text = 'HRA Confirmation';
        this.SPA_EnrollmentHistory_HRALink_Text = 'Health Risk Assessment';
        this.Spa_Site_HRA_Enabled = false;
        this.Spa_Site_CompleteHRA_Button_Enabled = false;
        this.Spa_EnrollmentConfirmation_OpenExternalHRAInNewTab_Enabled = false;
        this.Spa_Site_CompleteHRA_Button_Text = 'Complete HRA';
        this.Spa_Site_CompleteHRA_LastVisited_Text = 'Last visited';
        this.Spa_Site_CompleteHRA_DaysLeft_Text = '<hraDaysLeft> days left to complete HRA';
        this.Spa_EnrollmentHistory_ShowPlanYearBadge_Enabled = true;
        this.Spa_Site_PlanFees_Enabled = false;
        this.Spa_PlanFees_Tooltip_Text = 'Fees';
        this.Spa_PlanFees_IncludedInPremium_Tooltip_Text = 'Included in premium';
        this.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text = 'Not included in premium';
        this.Spa_Site_EnrollmentHistory_ProfileLink_Enabled = true;
        this.Spa_EnrollmentHistory_NoEnrollmentMessageText = 'You have no enrollments for this beneficiary';
        this.Spa_ValueBasedCare_Confirmation_Enabled = false;
        this.Spa_EnrollmentHistory_ValueBasedCare_HeaderText = 'Value based care provider selected';
        this.Spa_Site_ValueBasedCare_Enabled = false;
        this.Spa_EditProfile_AccessHRAPDF_Enabled = true;
        this.Spa_EditProfile_CompleteHRAProfileAdmin_Enabled = false;
        this.Spa_HRA_ExcludedCarriers = [];
        this.completedEnrollmentsLoaded = false;
        this.valueBasedCareProviders = {};
        this.isProfileAdmin = false;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        super.ngOnInit();
        this.isProfileAdmin = this.agentService.getIsProfileAdmin();
        const memberSession = this.memberSessionService.getMemberSessionId();
        this.isDualPlanYearSite = this.planYearResourceService.getIsDualPlanYearSite();
        this.completeEnrollmentsStatuses$ = this.memberSessionService.getCompleteEnrollmentsStatuses$(memberSession).pipe(map(completeEnrollmentsStatuses => {
            // Display completed plan enrollments only
            if (completeEnrollmentsStatuses?.enrollments?.length) {
                completeEnrollmentsStatuses.enrollments = completeEnrollmentsStatuses.enrollments.filter(enrollment => !this.enrollmentHistoryFacade.isSOAEnrollment(enrollment.coverageTypeEvent));
            }
            return completeEnrollmentsStatuses;
        }));
        this.memberEnrollmentStatuses$ = this.memberSessionService.getEnrollmentStatuses$(memberSession);
        this.locale$ = this.localeService.getCurrentLocale$();
        this.subscriptions.add(this.locale$
            .pipe(switchMap(locale => forkJoin([this.completeEnrollmentsStatuses$, this.memberEnrollmentStatuses$]).pipe(switchMap(([completedMemberEnrollments, memberEnrollmentStatuses]) => {
            const npis = this.providerFacade.getFormattedNpisfromEnrollments(completedMemberEnrollments?.enrollments);
            const isVbcProviderEnabled = this.Spa_Site_ValueBasedCare_Enabled && this.Spa_ValueBasedCare_Confirmation_Enabled && npis?.length;
            return (isVbcProviderEnabled ? this.providerFacade.getValueBasedCareProvider$(npis, locale) : of([])).pipe(map((vbcProviderList) => ({
                completedMemberEnrollments,
                memberEnrollmentStatuses,
                vbcProviderList
            })));
        }))))
            .subscribe({
            next: ({ completedMemberEnrollments, memberEnrollmentStatuses, vbcProviderList }) => {
                this.completedEnrollmentsLoaded = true;
                if (memberEnrollmentStatuses) {
                    this.memberEnrollmentStatuses = memberEnrollmentStatuses;
                }
                if (completedMemberEnrollments?.enrollments) {
                    const memberCompletedEnrollments = this.enrollmentHistoryFacade.setCompletedMemberEnrollmentFlags(completedMemberEnrollments.enrollments, false);
                    this.completedEnrollments = memberCompletedEnrollments.map(enrollment => ({
                        ...enrollment,
                        enrollmentStatus: this.getLatestEnrollmentStatus(enrollment.nativeTransactionID),
                        showEffectiveDate: this.showEffectiveDate(enrollment.effectiveDate, enrollment.planTypeID),
                        submittedDate: this.getSubmittedDate(enrollment.completedWhen),
                        requestedEffectiveDate: this.getRequestedEffectiveDate(enrollment.effectiveDate)
                    }));
                }
                if (vbcProviderList?.length) {
                    this.valueBasedCareProviders = this.providerFacade.reformatVbcProvidersforEnrollments(vbcProviderList);
                }
                this.cdr.markForCheck();
            }
        }));
    }
    preProcessProperties() {
        const memberName = this.profileService.getMemberFullName();
        this.enrollmentHistoryHeaderText = this.Spa_Site_EnrollmentHistory_HeaderText.replace('<member>', memberName);
    }
    onPreviousClick() {
        this.navigationService.backToPrevious();
    }
    trackByPlanID(index, plan) {
        return `${plan.planID}${plan.planYear}${plan.completedWhen}`;
    }
    getSubmittedDate(submittedDate) {
        if (!submittedDate) {
            return null;
        }
        return `${this.Spa_EnrollmentHistory_SubmittedDate_Text} ${DateUtilities.getDateFromUtc(submittedDate)} ${this.Spa_EnrollmentHistory_Pacific_StandardTime_Text}`;
    }
    getRequestedEffectiveDate(effectiveDate) {
        const convertedDate = this.datePipe.transform(effectiveDate, DatePipeFormats.DATE);
        return this.Spa_Site_EnrollmentHistory_ProfileLink_Enabled
            ? `${convertedDate}`
            : `${this.Spa_EnrollmentHistory_RequestedEffectiveDate_HeaderText} ${convertedDate}`;
    }
    showEffectiveDate(effectiveDate, planTypeId) {
        return !!effectiveDate && this.Spa_EnrollmentHistory_EffectiveDate_Enabled && planTypeId === PlanType.MEDIGAP;
    }
    getLatestEnrollmentStatus(nativeTransactionID) {
        if (this.Spa_EnrollmentHistory_EnrollmentStatus_Enabled) {
            const statuses = this.memberEnrollmentStatuses?.find(enrollmentStatus => enrollmentStatus.transactionGUID === nativeTransactionID)?.statuses;
            const enrollmentStatus = { ...statuses?.find(status => status.lastUpdated) };
            enrollmentStatus.status = enrollmentStatus?.status
                ? `${this.Spa_EnrollmentStatus_Label_Text} ${enrollmentStatus.status}`
                : this.Spa_EnrollmentStatus_Default;
            if (enrollmentStatus?.statusDate) {
                enrollmentStatus.statusDate = `${this.Spa_EnrollmentStatus_Date_Text} ${DateUtilities.getFormattedDateTime(new Date(enrollmentStatus.statusDate), DateUtilities.defaultFormat)}`;
            }
            return enrollmentStatus;
        }
        return null;
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
};
CompletedEnrollmentsHistoryComponent.ɵfac = function CompletedEnrollmentsHistoryComponent_Factory(t) { return new (t || CompletedEnrollmentsHistoryComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.ProfileService), i0.ɵɵdirectiveInject(EnrollmentHistoryFacade), i0.ɵɵdirectiveInject(i1$2.DatePipe), i0.ɵɵdirectiveInject(i1.PlanYearResourceService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(ProviderFacade), i0.ɵɵdirectiveInject(i1.AgentService)); };
CompletedEnrollmentsHistoryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CompletedEnrollmentsHistoryComponent, selectors: [["vnext-completed-enrollments-history"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 13, vars: 8, consts: [[1, "container", "mb-2"], [1, "row"], [1, "col-auto", "mx-auto", "text-center", "my-4"], [3, "title", "showArrow", "alwaysUnderlined", "click", "keyup.enter"], [1, "row", "content-bottom-spacing"], [1, "Spa_Style_Primary", "col-md-12", "text-center"], [1, "Spa_Style_H1"], [1, "col-12"], ["class", "row", 4, "ngFor", "ngForOf", "ngForTrackBy"], [4, "ngIf"], [3, "memberEnrollment", "memberEnrollmentSubmittedDate", "memberEnrollmentEffectiveDate", "showEffectiveDate", "enrollmentStatus", "totalMonthlyPremiumLabel", "viewApplicationLinkText", "confirmationText", "confirmationNumberEnabled", "planNameEnabled", "effectiveDateEnabled", "totalMonthlyPremiumEnabled", "submissionDateEnabled", "ridersEnabled", "hraConfirmationNumberEnabled", "hraConfirmationText", "hraPDFLinkText", "agentCallRecords", "pacificStandardTimeText", "isHRAEnabled", "completeHRAButtonEnabled", "openExternalInNewTab", "completeHRAButtonText", "completeHRALastVisitedText", "completeHRADaysLeftText", "showPlanYearBadge", "planYear", "isActivePlanYear", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "enrollmentStatusHeaderText", "enrollmentMoreDetailsText", "enrollmentHraHeaderText", "enrollmentConfirmationHeaderText", "memberEnrollmentEffectiveDateHeaderText", "riderHeaderText", "callRecordingHeaderText", "uploadDocumentHeaderText", "valueBasedCareConfirmationEnabled", "valueBasedCareConfirmationText", "valueBasedCareProviders", "isExpandableDetailViewEnabled", "isHRAPDFAccessEnabled", "isProfileAdmin", "isCompleteHRAProfileAdminEnabled", "excludedCarrierIds"], ["class", "text-center py-4", 4, "liveEditProp"], [1, "text-center", "py-4"]], template: function CompletedEnrollmentsHistoryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "vnext-link", 3);
        i0.ɵɵlistener("click", function CompletedEnrollmentsHistoryComponent_Template_vnext_link_click_3_listener() { return ctx.onPreviousClick(); })("keyup.enter", function CompletedEnrollmentsHistoryComponent_Template_vnext_link_keyup_enter_3_listener() { return ctx.onPreviousClick(); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(4, "div", 4)(5, "div", 5)(6, "h1", 6);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 7)(9, "span");
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵtemplate(11, CompletedEnrollmentsHistoryComponent_div_11_Template, 3, 48, "div", 8);
        i0.ɵɵtemplate(12, CompletedEnrollmentsHistoryComponent_ng_container_12_Template, 2, 1, "ng-container", 9);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("title", ctx.Spa_Site_Previous)("showArrow", "left")("alwaysUnderlined", true);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.Spa_Site_EnrollmentHistory_TitleText, " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.enrollmentHistoryHeaderText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.completedEnrollments)("ngForTrackBy", ctx.trackByPlanID);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.completedEnrollmentsLoaded && !(ctx.completedEnrollments == null ? null : ctx.completedEnrollments.length));
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, LinkComponent, LiveEditPropDirective, MemberEnrollmentCardComponent], styles: [".content-bottom-spacing[_ngcontent-%COMP%]{margin-bottom:60px}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_Site_Previous", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_Site_EnrollmentHistory_TitleText", void 0);
__decorate([
    GlobalResource(true)
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_Site_EnrollmentHistory_HeaderText", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_Site_EnrollmentHistory_MoreDetailsText", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_EnrollmentStatus_HeaderText", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_HealthRiskAssessment_HeaderText", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_Confirmation_HeaderText", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_RequestedEffectiveDate_HeaderText", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_Riders_HeaderText", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_CallRecordings_HeaderText", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_UploadedDocuments_HeaderText", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_SubmittedDate_Text", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_Pacific_StandardTime_Text", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_EffectiveDate_Enabled", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_EnrollmentStatus_Enabled", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentStatus_Label_Text", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentStatus_Default", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentStatus_Date_Text", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_Site_TotalMonthlyPremiumLabel", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_Site_ViewApplication_Link_Text", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_Confirmation_Text", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_ConfirmationNumber_Enabled", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_PlanName_Enabled", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_TotalMonthlyPremium_Enabled", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_SubmissionDate_Enabled", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_Riders_Enabled", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_hraConfirmation_Enabled", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_hraConfirmation_Text", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "SPA_EnrollmentHistory_HRALink_Text", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_Site_HRA_Enabled", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_Site_CompleteHRA_Button_Enabled", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentConfirmation_OpenExternalHRAInNewTab_Enabled", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_Site_CompleteHRA_Button_Text", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_Site_CompleteHRA_LastVisited_Text", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_Site_CompleteHRA_DaysLeft_Text", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_ShowPlanYearBadge_Enabled", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_Site_PlanFees_Enabled", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_PlanFees_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_PlanFees_IncludedInPremium_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_Site_EnrollmentHistory_ProfileLink_Enabled", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_NoEnrollmentMessageText", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_ValueBasedCare_Confirmation_Enabled", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EnrollmentHistory_ValueBasedCare_HeaderText", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_Site_ValueBasedCare_Enabled", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EditProfile_AccessHRAPDF_Enabled", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_EditProfile_CompleteHRAProfileAdmin_Enabled", void 0);
__decorate([
    GlobalResource()
], CompletedEnrollmentsHistoryComponent.prototype, "Spa_HRA_ExcludedCarriers", void 0);
CompletedEnrollmentsHistoryComponent = __decorate([
    PlatformWidget
], CompletedEnrollmentsHistoryComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CompletedEnrollmentsHistoryComponent, [{
        type: Component,
        args: [{ selector: 'vnext-completed-enrollments-history', providers: [WidgetService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container mb-2\">\r\n  <div class=\"row\">\r\n    <div class=\"col-auto mx-auto text-center my-4\">\r\n      <vnext-link\r\n        [title]=\"Spa_Site_Previous\"\r\n        [showArrow]=\"'left'\"\r\n        [alwaysUnderlined]=\"true\"\r\n        (click)=\"onPreviousClick()\"\r\n        (keyup.enter)=\"onPreviousClick()\"\r\n      >\r\n      </vnext-link>\r\n    </div>\r\n  </div>\r\n  <div class=\"row content-bottom-spacing\">\r\n    <div class=\"Spa_Style_Primary col-md-12 text-center\">\r\n      <h1 class=\"Spa_Style_H1\">\r\n        {{ Spa_Site_EnrollmentHistory_TitleText }}\r\n      </h1>\r\n      <div class=\"col-12\">\r\n        <span>{{ enrollmentHistoryHeaderText }}</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\" *ngFor=\"let enrollment of completedEnrollments; trackBy: trackByPlanID\">\r\n    <div class=\"col-12\">\r\n      <vnext-member-enrollment-card\r\n        [memberEnrollment]=\"enrollment\"\r\n        [memberEnrollmentSubmittedDate]=\"enrollment.submittedDate\"\r\n        [memberEnrollmentEffectiveDate]=\"enrollment.requestedEffectiveDate\"\r\n        [showEffectiveDate]=\"enrollment.showEffectiveDate\"\r\n        [enrollmentStatus]=\"enrollment.enrollmentStatus\"\r\n        [totalMonthlyPremiumLabel]=\"Spa_Site_TotalMonthlyPremiumLabel\"\r\n        [viewApplicationLinkText]=\"Spa_Site_ViewApplication_Link_Text\"\r\n        [confirmationText]=\"Spa_EnrollmentHistory_Confirmation_Text\"\r\n        [confirmationNumberEnabled]=\"Spa_EnrollmentHistory_ConfirmationNumber_Enabled\"\r\n        [planNameEnabled]=\"Spa_EnrollmentHistory_PlanName_Enabled\"\r\n        [effectiveDateEnabled]=\"Spa_EnrollmentHistory_EffectiveDate_Enabled\"\r\n        [totalMonthlyPremiumEnabled]=\"Spa_EnrollmentHistory_TotalMonthlyPremium_Enabled\"\r\n        [submissionDateEnabled]=\"Spa_EnrollmentHistory_SubmissionDate_Enabled\"\r\n        [ridersEnabled]=\"Spa_EnrollmentHistory_Riders_Enabled\"\r\n        [hraConfirmationNumberEnabled]=\"Spa_EnrollmentHistory_hraConfirmation_Enabled\"\r\n        [hraConfirmationText]=\"Spa_EnrollmentHistory_hraConfirmation_Text\"\r\n        [hraPDFLinkText]=\"SPA_EnrollmentHistory_HRALink_Text\"\r\n        [agentCallRecords]=\"enrollment.agentCallRecords\"\r\n        [pacificStandardTimeText]=\"Spa_EnrollmentHistory_Pacific_StandardTime_Text\"\r\n        [isHRAEnabled]=\"Spa_Site_HRA_Enabled\"\r\n        [completeHRAButtonEnabled]=\"Spa_Site_CompleteHRA_Button_Enabled\"\r\n        [openExternalInNewTab]=\"Spa_EnrollmentConfirmation_OpenExternalHRAInNewTab_Enabled\"\r\n        [completeHRAButtonText]=\"Spa_Site_CompleteHRA_Button_Text\"\r\n        [completeHRALastVisitedText]=\"Spa_Site_CompleteHRA_LastVisited_Text\"\r\n        [completeHRADaysLeftText]=\"Spa_Site_CompleteHRA_DaysLeft_Text\"\r\n        [showPlanYearBadge]=\"isDualPlanYearSite && Spa_EnrollmentHistory_ShowPlanYearBadge_Enabled\"\r\n        [planYear]=\"enrollment.planYear\"\r\n        [isActivePlanYear]=\"enrollment.isCurrentYearEnrollment\"\r\n        [planFeesEnabled]=\"Spa_Site_PlanFees_Enabled\"\r\n        [planFeesTooltipText]=\"Spa_PlanFees_Tooltip_Text\"\r\n        [planFeesIncludedInPremiumTooltipText]=\"Spa_PlanFees_IncludedInPremium_Tooltip_Text\"\r\n        [planFeesNotIncludedInPremiumTooltipText]=\"Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text\"\r\n        [enrollmentStatusHeaderText]=\"Spa_EnrollmentHistory_EnrollmentStatus_HeaderText\"\r\n        [enrollmentMoreDetailsText]=\"Spa_Site_EnrollmentHistory_MoreDetailsText\"\r\n        [enrollmentHraHeaderText]=\"Spa_EnrollmentHistory_HealthRiskAssessment_HeaderText\"\r\n        [enrollmentConfirmationHeaderText]=\"Spa_EnrollmentHistory_Confirmation_HeaderText\"\r\n        [memberEnrollmentEffectiveDateHeaderText]=\"Spa_EnrollmentHistory_RequestedEffectiveDate_HeaderText\"\r\n        [riderHeaderText]=\"Spa_EnrollmentHistory_Riders_HeaderText\"\r\n        [callRecordingHeaderText]=\"Spa_EnrollmentHistory_CallRecordings_HeaderText\"\r\n        [uploadDocumentHeaderText]=\"Spa_EnrollmentHistory_UploadedDocuments_HeaderText\"\r\n        [valueBasedCareConfirmationEnabled]=\"Spa_ValueBasedCare_Confirmation_Enabled\"\r\n        [valueBasedCareConfirmationText]=\"Spa_EnrollmentHistory_ValueBasedCare_HeaderText\"\r\n        [valueBasedCareProviders]=\"valueBasedCareProviders\"\r\n        [isExpandableDetailViewEnabled]=\"Spa_Site_EnrollmentHistory_ProfileLink_Enabled\"\r\n        [isHRAPDFAccessEnabled]=\"Spa_EditProfile_AccessHRAPDF_Enabled\"\r\n        [isProfileAdmin]=\"isProfileAdmin\"\r\n        [isCompleteHRAProfileAdminEnabled]=\"Spa_EditProfile_CompleteHRAProfileAdmin_Enabled\"\r\n        [excludedCarrierIds]=\"Spa_HRA_ExcludedCarriers\"\r\n      ></vnext-member-enrollment-card>\r\n    </div>\r\n  </div>\r\n\r\n  <ng-container *ngIf=\"completedEnrollmentsLoaded && !completedEnrollments?.length\">\r\n    <h5 class=\"text-center py-4\" *liveEditProp=\"'Spa_EnrollmentHistory_NoEnrollmentMessageText'\">\r\n      {{ Spa_EnrollmentHistory_NoEnrollmentMessageText }}\r\n    </h5>\r\n  </ng-container>\r\n</div>\r\n", styles: [".content-bottom-spacing{margin-bottom:60px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.NavigationService }, { type: i1.MemberSessionService }, { type: i1.ProfileService }, { type: EnrollmentHistoryFacade }, { type: i1$2.DatePipe }, { type: i1.PlanYearResourceService }, { type: i1.LocaleService }, { type: ProviderFacade }, { type: i1.AgentService }]; }, { Spa_Site_Previous: [], Spa_Site_EnrollmentHistory_TitleText: [], Spa_Site_EnrollmentHistory_HeaderText: [], Spa_Site_EnrollmentHistory_MoreDetailsText: [], Spa_EnrollmentHistory_EnrollmentStatus_HeaderText: [], Spa_EnrollmentHistory_HealthRiskAssessment_HeaderText: [], Spa_EnrollmentHistory_Confirmation_HeaderText: [], Spa_EnrollmentHistory_RequestedEffectiveDate_HeaderText: [], Spa_EnrollmentHistory_Riders_HeaderText: [], Spa_EnrollmentHistory_CallRecordings_HeaderText: [], Spa_EnrollmentHistory_UploadedDocuments_HeaderText: [], Spa_EnrollmentHistory_SubmittedDate_Text: [], Spa_EnrollmentHistory_Pacific_StandardTime_Text: [], Spa_EnrollmentHistory_EffectiveDate_Enabled: [], Spa_EnrollmentHistory_EnrollmentStatus_Enabled: [], Spa_EnrollmentStatus_Label_Text: [], Spa_EnrollmentStatus_Default: [], Spa_EnrollmentStatus_Date_Text: [], Spa_Site_TotalMonthlyPremiumLabel: [], Spa_Site_ViewApplication_Link_Text: [], Spa_EnrollmentHistory_Confirmation_Text: [], Spa_EnrollmentHistory_ConfirmationNumber_Enabled: [], Spa_EnrollmentHistory_PlanName_Enabled: [], Spa_EnrollmentHistory_TotalMonthlyPremium_Enabled: [], Spa_EnrollmentHistory_SubmissionDate_Enabled: [], Spa_EnrollmentHistory_Riders_Enabled: [], Spa_EnrollmentHistory_hraConfirmation_Enabled: [], Spa_EnrollmentHistory_hraConfirmation_Text: [], SPA_EnrollmentHistory_HRALink_Text: [], Spa_Site_HRA_Enabled: [], Spa_Site_CompleteHRA_Button_Enabled: [], Spa_EnrollmentConfirmation_OpenExternalHRAInNewTab_Enabled: [], Spa_Site_CompleteHRA_Button_Text: [], Spa_Site_CompleteHRA_LastVisited_Text: [], Spa_Site_CompleteHRA_DaysLeft_Text: [], Spa_EnrollmentHistory_ShowPlanYearBadge_Enabled: [], Spa_Site_PlanFees_Enabled: [], Spa_PlanFees_Tooltip_Text: [], Spa_PlanFees_IncludedInPremium_Tooltip_Text: [], Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text: [], Spa_Site_EnrollmentHistory_ProfileLink_Enabled: [], Spa_EnrollmentHistory_NoEnrollmentMessageText: [], Spa_ValueBasedCare_Confirmation_Enabled: [], Spa_EnrollmentHistory_ValueBasedCare_HeaderText: [], Spa_Site_ValueBasedCare_Enabled: [], Spa_EditProfile_AccessHRAPDF_Enabled: [], Spa_EditProfile_CompleteHRAProfileAdmin_Enabled: [], Spa_HRA_ExcludedCarriers: [] }); })();

class MemberRegistration {
}
const ALL_MEDICAID_INTEGRATION_STATES = 'ALL';
var MemberSaveExecutionResultType;
(function (MemberSaveExecutionResultType) {
    MemberSaveExecutionResultType[MemberSaveExecutionResultType["SuccessfulSave"] = 0] = "SuccessfulSave";
    MemberSaveExecutionResultType[MemberSaveExecutionResultType["ValidationError"] = 1] = "ValidationError";
    MemberSaveExecutionResultType[MemberSaveExecutionResultType["ServerError"] = 2] = "ServerError";
    MemberSaveExecutionResultType[MemberSaveExecutionResultType["NoChangesDetected"] = 3] = "NoChangesDetected";
})(MemberSaveExecutionResultType || (MemberSaveExecutionResultType = {}));
var MedicaidEligibilityStatus;
(function (MedicaidEligibilityStatus) {
    MedicaidEligibilityStatus["PENDING"] = "PENDING";
    MedicaidEligibilityStatus["ELIGIBLE"] = "ELIGIBLE";
    MedicaidEligibilityStatus["INELIGIBLE"] = "INELIGIBLE";
    MedicaidEligibilityStatus["FAILED"] = "FAILED";
})(MedicaidEligibilityStatus || (MedicaidEligibilityStatus = {}));
const MEDICAID_ELIGIBILITY_SUCCESS_STATUSES = [
    MedicaidEligibilityStatus.ELIGIBLE,
    MedicaidEligibilityStatus.INELIGIBLE
];
class MemberRegistrationMap {
}
var EffectiveDateErrors;
(function (EffectiveDateErrors) {
    EffectiveDateErrors[EffectiveDateErrors["INVALID_EFFECTIVE_DATE"] = 0] = "INVALID_EFFECTIVE_DATE";
    EffectiveDateErrors[EffectiveDateErrors["AFTER_DATE_OF_BIRTH"] = 1] = "AFTER_DATE_OF_BIRTH";
    EffectiveDateErrors[EffectiveDateErrors["FUTURE_DATE"] = 2] = "FUTURE_DATE";
    EffectiveDateErrors[EffectiveDateErrors["PAST_DATE"] = 3] = "PAST_DATE";
    EffectiveDateErrors[EffectiveDateErrors["EFFECTIVE_DATE_AFTER_PART_A_EFFECTIVEDATE"] = 4] = "EFFECTIVE_DATE_AFTER_PART_A_EFFECTIVEDATE";
})(EffectiveDateErrors || (EffectiveDateErrors = {}));

function MedicaidEligibilityCheckComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelement(1, "i", 16);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.errorMessage);
} }
function MedicaidEligibilityCheckComponent_ng_container_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "i", 20);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r7.stateNotEligibleText);
} }
function MedicaidEligibilityCheckComponent_ng_container_4_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelement(1, "i", 16);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r10.federalEligibilityForStateRequiredText);
} }
function MedicaidEligibilityCheckComponent_ng_container_4_ng_template_2_ng_template_1_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelement(1, "i", 25);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r13.medicaidCheckCannotCompleteErrorText);
} }
function MedicaidEligibilityCheckComponent_ng_container_4_ng_template_2_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, MedicaidEligibilityCheckComponent_ng_container_4_ng_template_2_ng_template_1_div_0_Template, 4, 1, "div", 23);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r12.medicaidCheckStatus === ctx_r12.medicaidEligibilityStatus.FAILED);
} }
function MedicaidEligibilityCheckComponent_ng_container_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, MedicaidEligibilityCheckComponent_ng_container_4_ng_template_2_div_0_Template, 4, 1, "div", 21);
    i0.ɵɵtemplate(1, MedicaidEligibilityCheckComponent_ng_container_4_ng_template_2_ng_template_1_Template, 1, 1, "ng-template", null, 22, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r11 = i0.ɵɵreference(2);
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r9.showFederalEligibilityForStateRequiredText)("ngIfElse", _r11);
} }
function MedicaidEligibilityCheckComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MedicaidEligibilityCheckComponent_ng_container_4_div_1_Template, 4, 1, "div", 17);
    i0.ɵɵtemplate(2, MedicaidEligibilityCheckComponent_ng_container_4_ng_template_2_Template, 3, 2, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r8 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.isMedicaidEligibilityEnabledForSelectedState)("ngIfElse", _r8);
} }
const _c0$1x = function (a0) { return { "label-disabled": a0 }; };
const _c1$I = function (a0) { return { Spa_Style_Gray4_Color: a0 }; };
function MedicaidEligibilityCheckComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "label", 7)(2, "label", 26)(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "vnext-toggle-select", 27);
    i0.ɵɵlistener("optionSelected", function MedicaidEligibilityCheckComponent_div_13_Template_vnext_toggle_select_optionSelected_5_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.onSelectGender($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0$1x, ctx_r2.medicaidCheckButtonDisabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c1$I, ctx_r2.medicaidCheckButtonDisabled));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r2.genderLabel, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("items", ctx_r2.genderItems)("buttonHeight", "36px")("selectedValue", ctx_r2.defaultGender)("largerText", true);
} }
function MedicaidEligibilityCheckComponent_span_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.stateEligibilityCheckButtonLabel);
} }
function MedicaidEligibilityCheckComponent_ng_template_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-spinner", 28);
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("size", ctx_r5.spinnerSizeSmall);
} }
function MedicaidEligibilityCheckComponent_ng_container_19_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "span", 33);
    i0.ɵɵelement(2, "i", 34);
    i0.ɵɵelementStart(3, "span", 35);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 36);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.eligibilityCheckPendingLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.eligibilityCheckPendingDescriptionLabel, " ");
} }
function MedicaidEligibilityCheckComponent_ng_container_19_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37)(1, "div", 38);
    i0.ɵɵelement(2, "i", 39);
    i0.ɵɵelementStart(3, "span")(4, "div", 40);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 36);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "date");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r17.medicaidEligibleText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r17.medicaidCheckDateReceivedText + " " + i0.ɵɵpipeBind2(8, 2, ctx_r17.medicaidLastCheckedDate, "MM/dd/yyyy"), " ");
} }
function MedicaidEligibilityCheckComponent_ng_container_19_div_4_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r20.medicaidClientMessage, " ");
} }
function MedicaidEligibilityCheckComponent_ng_container_19_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelement(1, "i", 44);
    i0.ɵɵelementStart(2, "span")(3, "div", 45);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, MedicaidEligibilityCheckComponent_ng_container_19_div_4_div_1_div_5_Template, 2, 1, "div", 46);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r19.notEligibleText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.medicaidClientMessage);
} }
function MedicaidEligibilityCheckComponent_ng_container_19_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵtemplate(1, MedicaidEligibilityCheckComponent_ng_container_19_div_4_div_1_Template, 6, 2, "div", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r18.isMedicaidEligible);
} }
function MedicaidEligibilityCheckComponent_ng_container_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0)(1, 29);
    i0.ɵɵtemplate(2, MedicaidEligibilityCheckComponent_ng_container_19_div_2_Template, 7, 2, "div", 30);
    i0.ɵɵtemplate(3, MedicaidEligibilityCheckComponent_ng_container_19_div_3_Template, 9, 5, "div", 31);
    i0.ɵɵtemplate(4, MedicaidEligibilityCheckComponent_ng_container_19_div_4_Template, 2, 1, "div", 32);
    i0.ɵɵelementContainerEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r6.medicaidCheckStatus);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.medicaidEligibilityStatus.PENDING);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.medicaidEligibilityStatus.ELIGIBLE);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r6.medicaidEligibilityStatus.INELIGIBLE);
} }
const ZIP_LENGTH = 5;
class MedicaidEligibilityCheckComponent {
    constructor() {
        this.medicaidId = '';
        this.defaultGender = 0;
        this.checkMedicaidEligibility = new EventEmitter();
        this.medicaidDataChanged = new EventEmitter();
        this.medicaidEligibleText = '';
        this.errorMessage = '';
        this.medicaidEligibilityStatus = MedicaidEligibilityStatus;
        this.medicaidCheckButtonDisabled = false;
        this.showFederalEligibilityForStateRequiredText = false;
        this.isCountyStateDifferentThanLastMedicaidStateSelection = false;
        this.subscriptions = new Subscription();
    }
    ngOnChanges(changes) {
        const { medicaidId, medicaidCodeText, medicaidEligibilityLevel, medicaidStateSelection, isZipValid, zipCode, countyFips, noZipCodeText, medicaidCheckStatus, medicaidLastCheckedDate, medicaidCheckDays, isMedicareEligible, isDSNPEligible, isMedicaidEligibilityEnabledForSelectedState, selectedCountyState } = changes;
        if (this.isMedicaidEligible &&
            ((medicaidCodeText && medicaidCodeText.previousValue !== medicaidCodeText.currentValue) ||
                (medicaidEligibilityLevel && medicaidEligibilityLevel.previousValue !== medicaidEligibilityLevel) ||
                (medicaidStateSelection && medicaidStateSelection.previousValue !== medicaidStateSelection))) {
            this.medicaidEligibleText =
                this.medicaidCodeText?.replace('<medicaidCode>', this.medicaidEligibilityLevel).replace('<state>', this.medicaidStateSelection) ??
                    '';
        }
        if ((zipCode && zipCode.previousValue !== zipCode.currentValue) ||
            (medicaidCheckStatus && medicaidCheckStatus.previousValue !== medicaidCheckStatus.currentValue) ||
            (medicaidLastCheckedDate && medicaidLastCheckedDate.previousValue !== medicaidLastCheckedDate.currentValue) ||
            (medicaidCheckDays && medicaidCheckDays.previousValue !== medicaidCheckDays.currentValue) ||
            (isMedicareEligible && isMedicareEligible.previousValue !== isMedicareEligible.currentValue) ||
            (isDSNPEligible && isDSNPEligible.previousValue !== isDSNPEligible.currentValue) ||
            (isMedicaidEligibilityEnabledForSelectedState &&
                isMedicaidEligibilityEnabledForSelectedState.previousValue !== isMedicaidEligibilityEnabledForSelectedState.currentValue) ||
            (medicaidStateSelection && medicaidStateSelection.previousValue !== medicaidStateSelection.currentValue) ||
            (selectedCountyState && selectedCountyState.previousValue !== selectedCountyState.currentValue)) {
            this.isCountyStateDifferentThanLastMedicaidStateSelection =
                this.selectedCountyState && this.medicaidStateSelection && this.selectedCountyState !== this.medicaidStateSelection;
            // Show text when Federal Eligibility for State is required and:
            // 1. The user is not federally eligible, or
            // 2. The user is federally eligible, the DSNP check is enabled and the user is not DSNP eligible
            this.showFederalEligibilityForStateRequiredText =
                this.isFederalEligibilityForStateRequired &&
                    (!this.isMedicareEligible || (this.isProfileEligibilityCheckDSNPEnabled && !this.isDSNPEligible));
            this.medicaidCheckButtonDisabled =
                this.zipCode &&
                    this.isMedicaidCheckButtonDisabled({
                        medicaidCheckStatus: this.medicaidCheckStatus,
                        medicaidLastCheckedDate: this.medicaidLastCheckedDate,
                        medicaidCheckDays: this.medicaidCheckDays,
                        // Default format: MM/DD/YYYY
                        currentDate: DateUtilities.getFormattedDate(),
                        isMedicaidEligibilityEnabledForSelectedState: this.isMedicaidEligibilityEnabledForSelectedState,
                        showFederalEligibilityForStateRequiredText: this.showFederalEligibilityForStateRequiredText,
                        isCountyStateDifferentThanLastMedicaidStateSelection: this.isCountyStateDifferentThanLastMedicaidStateSelection
                    });
            this.toggleMedicaidCheckButtonStatus(this.medicaidCheckButtonDisabled);
        }
        if (this.errorMessage &&
            ((zipCode && zipCode.previousValue !== zipCode.currentValue) ||
                (isZipValid && isZipValid.previousValue !== isZipValid.currentValue) ||
                (noZipCodeText && noZipCodeText.previousValue !== noZipCodeText.currentValue) ||
                (countyFips && countyFips.previousValue !== countyFips.currentValue))) {
            this.errorMessage = this.getMedicaidEligibilityFormErrorMessage({
                noZipCodeText: this.noZipCodeText,
                isZipCodeInvalid: !this.isZipValid || this.zipCode?.length !== ZIP_LENGTH || !this.countyFips
            });
        }
        if (medicaidId && medicaidId.previousValue !== medicaidId.currentValue) {
            this.stateEligibilityCheckForm?.controls?.medicaidId?.setValue(this.medicaidId);
        }
    }
    ngOnInit() {
        const medicaidIdControl = new FormControl({ value: this.medicaidId, disabled: this.medicaidCheckButtonDisabled }, [Validators.required]);
        this.stateEligibilityCheckForm = new UntypedFormGroup({
            medicaidId: medicaidIdControl
        });
        this.subscriptions.add(medicaidIdControl.valueChanges.subscribe({
            next: medicaidId => {
                this.medicaidDataFieldChanged('medicaidId', medicaidId);
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    medicaidEligibilitySubmit() {
        this.errorMessage = this.getMedicaidEligibilityFormErrorMessage({
            noZipCodeText: this.noZipCodeText,
            isZipCodeInvalid: !this.isZipValid || this.zipCode?.length !== ZIP_LENGTH || !this.countyFips,
            isStateEligibilityCheckFormInvalid: this.stateEligibilityCheckForm.invalid,
            noMedicaidIdErrorLabel: this.noMedicaidIdErrorLabel,
            selectedGenderCode: this.selectedGenderCode
        });
        if (this.stateEligibilityCheckForm.valid && !this.errorMessage) {
            this.checkMedicaidEligibility.emit({
                medicaidId: this.stateEligibilityCheckForm.controls.medicaidId.value,
                gender: this.selectedGenderCode
            });
        }
    }
    onSelectGender(event) {
        this.selectedGenderCode = event.data.value;
        this.medicaidDataFieldChanged('gender', this.selectedGenderCode);
    }
    getMedicaidEligibilityFormErrorMessage(config) {
        const { isZipCodeInvalid, noZipCodeText, isStateEligibilityCheckFormInvalid, noMedicaidIdErrorLabel, selectedGenderCode } = config;
        let errorMessage = '';
        if (isZipCodeInvalid) {
            errorMessage = noZipCodeText;
        }
        else if (isStateEligibilityCheckFormInvalid && noMedicaidIdErrorLabel) {
            errorMessage = noMedicaidIdErrorLabel;
        }
        else if (this.genderEnabled && !selectedGenderCode) {
            errorMessage = this.genderRequiredErrorText;
        }
        return errorMessage;
    }
    isMedicaidCheckButtonDisabled(config) {
        const { isMedicaidEligibilityEnabledForSelectedState } = config;
        if (isMedicaidEligibilityEnabledForSelectedState) {
            const { medicaidCheckStatus, medicaidLastCheckedDate, medicaidCheckDays, currentDate, showFederalEligibilityForStateRequiredText, isCountyStateDifferentThanLastMedicaidStateSelection } = config;
            // State Eligibility check button should be disabled when Federal Eligibility for State is required and:
            // 1. The user is not federally eligible, or
            // 2. The user is federally eligible, the DSNP check is enabled and the user is not DSNP eligible
            if (showFederalEligibilityForStateRequiredText) {
                return true;
            }
            // State Eligibility check button should be enabled when the selected State is integrated and different than the last checked State
            if (isCountyStateDifferentThanLastMedicaidStateSelection) {
                return false;
            }
            // State Eligibility check button should be disabled while the last check is still in progress (PENDING)
            if (medicaidCheckStatus === MedicaidEligibilityStatus.PENDING) {
                return true;
            }
            // State Eligibility check button should be disabled when the last successful check (ELIGIBLE/INELIGIBLE) is still within a range of days
            // Otherwise, it should be enabled after that period of time or if the last check was unsuccessful (FAILED)
            return this.isMedicaidCheckInitiatedWithinDaysRange(medicaidCheckStatus, medicaidLastCheckedDate, currentDate, medicaidCheckDays);
        }
        // State Eligibility check button should be disabled when the selected State is not integrated
        return true;
    }
    isMedicaidCheckInitiatedWithinDaysRange(medicaidCheckStatus, medicaidLastCheckedDate, currentDate, medicaidCheckDays) {
        return (MEDICAID_ELIGIBILITY_SUCCESS_STATUSES.includes(medicaidCheckStatus) &&
            DateUtilities.getDaysDifference(medicaidLastCheckedDate, currentDate, DaysDifferencePrecision.DATE_ONLY) <= medicaidCheckDays);
    }
    toggleMedicaidCheckButtonStatus(medicaidCheckButtonDisabled) {
        if (medicaidCheckButtonDisabled) {
            this.stateEligibilityCheckForm?.controls?.medicaidId?.disable();
        }
        else {
            this.stateEligibilityCheckForm?.controls?.medicaidId?.enable();
        }
    }
    medicaidDataFieldChanged(fieldName, value) {
        const change = {
            fieldName,
            value
        };
        this.medicaidDataChanged.emit(change);
    }
}
MedicaidEligibilityCheckComponent.ɵfac = function MedicaidEligibilityCheckComponent_Factory(t) { return new (t || MedicaidEligibilityCheckComponent)(); };
MedicaidEligibilityCheckComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedicaidEligibilityCheckComponent, selectors: [["vnext-widgets-medicaid-eligibility-check"]], inputs: { medicaidId: "medicaidId", stateEligibilityCheckDescription: "stateEligibilityCheckDescription", medicaidIdLabel: "medicaidIdLabel", stateEligibilityCheckButtonLabel: "stateEligibilityCheckButtonLabel", noMedicaidIdErrorLabel: "noMedicaidIdErrorLabel", eligibilityCheckPendingLabel: "eligibilityCheckPendingLabel", eligibilityCheckPendingDescriptionLabel: "eligibilityCheckPendingDescriptionLabel", isZipValid: "isZipValid", noZipCodeText: "noZipCodeText", zipCode: "zipCode", countyFips: "countyFips", isMedicareEligible: "isMedicareEligible", medicaidCheckStatus: "medicaidCheckStatus", isMedicaidEligible: "isMedicaidEligible", isDSNPEligible: "isDSNPEligible", medicaidEligibilityLevel: "medicaidEligibilityLevel", medicaidLastCheckedDate: "medicaidLastCheckedDate", medicaidStateSelection: "medicaidStateSelection", spinnerSizeSmall: "spinnerSizeSmall", checkMedicaidEligibilityLoading: "checkMedicaidEligibilityLoading", medicaidCodeText: "medicaidCodeText", medicaidCheckDateReceivedText: "medicaidCheckDateReceivedText", medicaidCheckDays: "medicaidCheckDays", medicaidClientMessage: "medicaidClientMessage", medicaidCheckCannotCompleteErrorText: "medicaidCheckCannotCompleteErrorText", isFederalEligibilityForStateRequired: "isFederalEligibilityForStateRequired", isProfileEligibilityCheckDSNPEnabled: "isProfileEligibilityCheckDSNPEnabled", federalEligibilityForStateRequiredText: "federalEligibilityForStateRequiredText", stateNotEligibleText: "stateNotEligibleText", selectedCountyState: "selectedCountyState", isMedicaidEligibilityEnabledForSelectedState: "isMedicaidEligibilityEnabledForSelectedState", notEligibleText: "notEligibleText", genderEnabled: "genderEnabled", genderItems: "genderItems", genderLabel: "genderLabel", defaultGender: "defaultGender", genderRequiredErrorText: "genderRequiredErrorText" }, outputs: { checkMedicaidEligibility: "checkMedicaidEligibility", medicaidDataChanged: "medicaidDataChanged" }, features: [i0.ɵɵNgOnChangesFeature], decls: 20, vars: 19, consts: [[1, "Spa_Style_Regular_Font", "Spa_Style_Primary_Color", "medicaid-section", "mt-4"], [1, "mt-4", "text-left", 3, "innerHTML"], ["class", "warning-message mb-2 Spa_Style_Small_Font", 4, "ngIf"], [4, "ngIf"], [1, "contain-wrapper", 3, "formGroup"], [1, "row", "mt-2", "mb-1", "align-items-baseline"], [1, "col-lg-4", "col-md-6", "col-12", "button-inside"], [1, "w-100", 3, "ngClass"], ["for", "medicaidId", 1, "Spa_Style_Label", 3, "ngClass"], ["id", "medicaidId", "type", "text", "formControlName", "medicaidId", 1, "w-100", "input-clear-button"], ["class", "col-lg-4 col-md-6 col-12 button-inside", 4, "ngIf"], [1, "col-lg-4", "col-md-6", "col-12"], [1, "Spa_Style_SecondaryButton", "d-flex", "justify-content-center", "btn", "w-100", 3, "disabled", "click"], [4, "ngIf", "ngIfElse"], ["loading", ""], [1, "warning-message", "mb-2", "Spa_Style_Small_Font"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-triangle", "mr-2"], ["class", "info-message mb-2 Spa_Style_Small_Font", 4, "ngIf", "ngIfElse"], ["federalEligibilityForState", ""], [1, "info-message", "mb-2", "Spa_Style_Small_Font"], ["aria-hidden", "true", 1, "fas", "fa-info-circle", "mr-2"], ["class", "warning-message mb-2 Spa_Style_Small_Font", 4, "ngIf", "ngIfElse"], ["checkMedicaidStatus", ""], ["class", "check-error mb-2 Spa_Style_Small_Font", 4, "ngIf"], [1, "check-error", "mb-2", "Spa_Style_Small_Font"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle", "mr-2"], [1, "Spa_Style_Label", 3, "ngClass"], [3, "items", "buttonHeight", "selectedValue", "largerText", "optionSelected"], [3, "size"], [3, "ngSwitch"], ["class", "col-lg-4 col-md-6 col-12", 4, "ngSwitchCase"], ["class", "col-12 col-md-6 col-lg-4", 4, "ngSwitchCase"], ["class", "col-lg-4 col-md-6 col-12 w-100 Spa_Style_Small_Font", 4, "ngSwitchCase"], [1, "warning-message", "Spa_Style_Small_Font"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-triangle", "mr-1"], [1, "ml-2"], [1, "Spa_Style_Note"], [1, "col-12", "col-md-6", "col-lg-4"], [1, "d-flex", "align-items-baseline", "Spa_Style_Small_Font"], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "mr-2", "completed-check"], [1, "completed-check"], [1, "col-lg-4", "col-md-6", "col-12", "w-100", "Spa_Style_Small_Font"], ["class", "d-flex align-items-baseline", 4, "ngIf"], [1, "d-flex", "align-items-baseline"], ["aria-hidden", "true", 1, "fas", "fa-times-circle", "mr-2", "not-eligible"], [1, "not-eligible"], ["class", "Spa_Style_Note", 4, "ngIf"]], template: function MedicaidEligibilityCheckComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵpipe(2, "safe");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, MedicaidEligibilityCheckComponent_div_3_Template, 4, 1, "div", 2);
        i0.ɵɵtemplate(4, MedicaidEligibilityCheckComponent_ng_container_4_Template, 4, 2, "ng-container", 3);
        i0.ɵɵelementStart(5, "form", 4)(6, "div", 5)(7, "div", 6)(8, "label", 7)(9, "label", 8)(10, "span");
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(12, "input", 9);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(13, MedicaidEligibilityCheckComponent_div_13_Template, 6, 11, "div", 10);
        i0.ɵɵelementStart(14, "div", 11)(15, "button", 12);
        i0.ɵɵlistener("click", function MedicaidEligibilityCheckComponent_Template_button_click_15_listener() { return ctx.medicaidEligibilitySubmit(); });
        i0.ɵɵtemplate(16, MedicaidEligibilityCheckComponent_span_16_Template, 2, 1, "span", 13);
        i0.ɵɵtemplate(17, MedicaidEligibilityCheckComponent_ng_template_17_Template, 1, 1, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(19, MedicaidEligibilityCheckComponent_ng_container_19_Template, 5, 4, "ng-container", 3);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r4 = i0.ɵɵreference(18);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 12, ctx.stateEligibilityCheckDescription, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.errorMessage);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.zipCode && !ctx.errorMessage && !ctx.checkMedicaidEligibilityLoading);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.stateEligibilityCheckForm);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c0$1x, ctx.medicaidCheckButtonDisabled));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c1$I, ctx.medicaidCheckButtonDisabled));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1("", ctx.medicaidIdLabel, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.genderEnabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.medicaidCheckButtonDisabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.checkMedicaidEligibilityLoading)("ngIfElse", _r4);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.checkMedicaidEligibilityLoading);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, ToggleSelectComponent, SpinnerComponent, IconAriaAttributesDirective, i1$2.DatePipe, SafePipe], styles: [".medicaid-section[_ngcontent-%COMP%]{text-align:center;padding-bottom:20px;border-top:1px solid var(--static-Spa_Style_Gray2)}.completed-check[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text)}.warning-message[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Warn_on_Blue)}.warning-message[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Warn_Darker)}.info-message[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Primary_Link)}.info-message[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Info_Dark)}.not-eligible[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Gray4)}.check-error[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent2)}"], changeDetection: 0 });
__decorate([
    Memoize()
], MedicaidEligibilityCheckComponent.prototype, "getMedicaidEligibilityFormErrorMessage", null);
__decorate([
    Memoize()
], MedicaidEligibilityCheckComponent.prototype, "isMedicaidCheckButtonDisabled", null);
__decorate([
    Memoize()
], MedicaidEligibilityCheckComponent.prototype, "isMedicaidCheckInitiatedWithinDaysRange", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedicaidEligibilityCheckComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widgets-medicaid-eligibility-check', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"Spa_Style_Regular_Font Spa_Style_Primary_Color medicaid-section mt-4\">\r\n  <div class=\"mt-4 text-left\" [innerHTML]=\"stateEligibilityCheckDescription | safe : 'html'\"></div>\r\n</div>\r\n<div *ngIf=\"errorMessage\" class=\"warning-message mb-2 Spa_Style_Small_Font\">\r\n  <i class=\"fas fa-exclamation-triangle mr-2\" aria-hidden=\"true\"></i><span>{{ errorMessage }}</span>\r\n</div>\r\n\r\n<ng-container *ngIf=\"zipCode && !errorMessage && !checkMedicaidEligibilityLoading\">\r\n  <div\r\n    *ngIf=\"!isMedicaidEligibilityEnabledForSelectedState; else federalEligibilityForState\"\r\n    class=\"info-message mb-2 Spa_Style_Small_Font\"\r\n  >\r\n    <i class=\"fas fa-info-circle mr-2\" aria-hidden=\"true\"></i><span>{{ stateNotEligibleText }}</span>\r\n  </div>\r\n\r\n  <ng-template #federalEligibilityForState>\r\n    <div *ngIf=\"showFederalEligibilityForStateRequiredText; else checkMedicaidStatus\" class=\"warning-message mb-2 Spa_Style_Small_Font\">\r\n      <i class=\"fas fa-exclamation-triangle mr-2\" aria-hidden=\"true\"></i><span>{{ federalEligibilityForStateRequiredText }}</span>\r\n    </div>\r\n\r\n    <ng-template #checkMedicaidStatus>\r\n      <div *ngIf=\"medicaidCheckStatus === medicaidEligibilityStatus.FAILED\" class=\"check-error mb-2 Spa_Style_Small_Font\">\r\n        <i class=\"fas fa-exclamation-circle mr-2\" aria-hidden=\"true\"></i><span>{{ medicaidCheckCannotCompleteErrorText }}</span>\r\n      </div>\r\n    </ng-template>\r\n  </ng-template>\r\n</ng-container>\r\n\r\n<form class=\"contain-wrapper\" [formGroup]=\"stateEligibilityCheckForm\">\r\n  <div class=\"row mt-2 mb-1 align-items-baseline\">\r\n    <div class=\"col-lg-4 col-md-6 col-12 button-inside\">\r\n      <label class=\"w-100\" [ngClass]=\"{ 'label-disabled': medicaidCheckButtonDisabled }\">\r\n        <label for=\"medicaidId\" class=\"Spa_Style_Label\" [ngClass]=\"{ Spa_Style_Gray4_Color: medicaidCheckButtonDisabled }\">\r\n          <span>{{ medicaidIdLabel }} </span>\r\n        </label>\r\n        <input id=\"medicaidId\" type=\"text\" class=\"w-100 input-clear-button\" formControlName=\"medicaidId\" />\r\n      </label>\r\n    </div>\r\n    <div *ngIf=\"genderEnabled\" class=\"col-lg-4 col-md-6 col-12 button-inside\">\r\n      <label class=\"w-100\" [ngClass]=\"{ 'label-disabled': medicaidCheckButtonDisabled }\">\r\n        <label class=\"Spa_Style_Label\" [ngClass]=\"{ Spa_Style_Gray4_Color: medicaidCheckButtonDisabled }\">\r\n          <span>{{ genderLabel }} </span>\r\n        </label>\r\n        <vnext-toggle-select\r\n          [items]=\"genderItems\"\r\n          [buttonHeight]=\"'36px'\"\r\n          (optionSelected)=\"onSelectGender($event)\"\r\n          [selectedValue]=\"defaultGender\"\r\n          [largerText]=\"true\"\r\n        >\r\n        </vnext-toggle-select>\r\n      </label>\r\n    </div>\r\n    <div class=\"col-lg-4 col-md-6 col-12\">\r\n      <button\r\n        class=\"Spa_Style_SecondaryButton d-flex justify-content-center btn w-100\"\r\n        [disabled]=\"medicaidCheckButtonDisabled\"\r\n        (click)=\"medicaidEligibilitySubmit()\"\r\n      >\r\n        <span *ngIf=\"!checkMedicaidEligibilityLoading; else loading\">{{ stateEligibilityCheckButtonLabel }}</span>\r\n        <ng-template #loading>\r\n          <vnext-spinner [size]=\"spinnerSizeSmall\"></vnext-spinner>\r\n        </ng-template>\r\n      </button>\r\n    </div>\r\n    <ng-container *ngIf=\"!checkMedicaidEligibilityLoading\">\r\n      <ng-container [ngSwitch]=\"medicaidCheckStatus\">\r\n        <div *ngSwitchCase=\"medicaidEligibilityStatus.PENDING\" class=\"col-lg-4 col-md-6 col-12\">\r\n          <span class=\"warning-message Spa_Style_Small_Font\">\r\n            <i class=\"fas fa-exclamation-triangle mr-1\" aria-hidden=\"true\"></i\r\n            ><span class=\"ml-2\">\r\n              {{ eligibilityCheckPendingLabel }}\r\n            </span>\r\n          </span>\r\n          <div class=\"Spa_Style_Note\">\r\n            {{ eligibilityCheckPendingDescriptionLabel }}\r\n          </div>\r\n        </div>\r\n\r\n        <div *ngSwitchCase=\"medicaidEligibilityStatus.ELIGIBLE\" class=\"col-12 col-md-6 col-lg-4\">\r\n          <div class=\"d-flex align-items-baseline Spa_Style_Small_Font\">\r\n            <i class=\"fas fa-check-circle mr-2 completed-check\" aria-hidden=\"true\"></i\r\n            ><span>\r\n              <div class=\"completed-check\">\r\n                {{ medicaidEligibleText }}\r\n              </div>\r\n              <div class=\"Spa_Style_Note\">\r\n                {{ medicaidCheckDateReceivedText + ' ' + (medicaidLastCheckedDate | date : 'MM/dd/yyyy') }}\r\n              </div>\r\n            </span>\r\n          </div>\r\n        </div>\r\n\r\n        <div *ngSwitchCase=\"medicaidEligibilityStatus.INELIGIBLE\" class=\"col-lg-4 col-md-6 col-12 w-100 Spa_Style_Small_Font\">\r\n          <div *ngIf=\"!isMedicaidEligible\" class=\"d-flex align-items-baseline\">\r\n            <i class=\"fas fa-times-circle mr-2 not-eligible\" aria-hidden=\"true\"></i\r\n            ><span>\r\n              <div class=\"not-eligible\">\r\n                {{ notEligibleText }}\r\n              </div>\r\n              <div *ngIf=\"medicaidClientMessage\" class=\"Spa_Style_Note\">\r\n                {{ medicaidClientMessage }}\r\n              </div>\r\n            </span>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n    </ng-container>\r\n  </div>\r\n</form>\r\n", styles: [".medicaid-section{text-align:center;padding-bottom:20px;border-top:1px solid var(--static-Spa_Style_Gray2)}.completed-check{color:var(--static-Spa_Style_Cost_Text)}.warning-message{color:var(--static-Spa_Style_Warn_on_Blue)}.warning-message i{color:var(--static-Spa_Style_Warn_Darker)}.info-message{color:var(--static-Spa_Style_Primary_Link)}.info-message i{color:var(--static-Spa_Style_Info_Dark)}.not-eligible{color:var(--static-Spa_Style_Gray4)}.check-error{color:var(--static-Spa_Style_Accent2)}\n"] }]
    }], null, { medicaidId: [{
            type: Input
        }], stateEligibilityCheckDescription: [{
            type: Input
        }], medicaidIdLabel: [{
            type: Input
        }], stateEligibilityCheckButtonLabel: [{
            type: Input
        }], noMedicaidIdErrorLabel: [{
            type: Input
        }], eligibilityCheckPendingLabel: [{
            type: Input
        }], eligibilityCheckPendingDescriptionLabel: [{
            type: Input
        }], isZipValid: [{
            type: Input
        }], noZipCodeText: [{
            type: Input
        }], zipCode: [{
            type: Input
        }], countyFips: [{
            type: Input
        }], isMedicareEligible: [{
            type: Input
        }], medicaidCheckStatus: [{
            type: Input
        }], isMedicaidEligible: [{
            type: Input
        }], isDSNPEligible: [{
            type: Input
        }], medicaidEligibilityLevel: [{
            type: Input
        }], medicaidLastCheckedDate: [{
            type: Input
        }], medicaidStateSelection: [{
            type: Input
        }], spinnerSizeSmall: [{
            type: Input
        }], checkMedicaidEligibilityLoading: [{
            type: Input
        }], medicaidCodeText: [{
            type: Input
        }], medicaidCheckDateReceivedText: [{
            type: Input
        }], medicaidCheckDays: [{
            type: Input
        }], medicaidClientMessage: [{
            type: Input
        }], medicaidCheckCannotCompleteErrorText: [{
            type: Input
        }], isFederalEligibilityForStateRequired: [{
            type: Input
        }], isProfileEligibilityCheckDSNPEnabled: [{
            type: Input
        }], federalEligibilityForStateRequiredText: [{
            type: Input
        }], stateNotEligibleText: [{
            type: Input
        }], selectedCountyState: [{
            type: Input
        }], isMedicaidEligibilityEnabledForSelectedState: [{
            type: Input
        }], notEligibleText: [{
            type: Input
        }], genderEnabled: [{
            type: Input
        }], genderItems: [{
            type: Input
        }], genderLabel: [{
            type: Input
        }], defaultGender: [{
            type: Input
        }], genderRequiredErrorText: [{
            type: Input
        }], checkMedicaidEligibility: [{
            type: Output
        }], medicaidDataChanged: [{
            type: Output
        }], getMedicaidEligibilityFormErrorMessage: [], isMedicaidCheckButtonDisabled: [], isMedicaidCheckInitiatedWithinDaysRange: [] }); })();

class MemberEligibilityCheckFacade {
    constructor(memberSessionHttpService) {
        this.memberSessionHttpService = memberSessionHttpService;
    }
    checkMemberEligibility$(checkEligibilityPayload) {
        return this.memberSessionHttpService.checkMemberEligibility$(checkEligibilityPayload);
    }
    getGenderType(genderCode) {
        switch (genderCode) {
            case GenderCode.MALE:
                return GenderValue.MALE;
            case GenderCode.FEMALE:
                return GenderValue.FEMALE;
            default:
                return null;
        }
    }
    checkMedicaidEligibility$(checkEligibilityPayload, sessionId) {
        return this.memberSessionHttpService.checkMedicaidEligibility$(checkEligibilityPayload, sessionId);
    }
}
MemberEligibilityCheckFacade.ɵfac = function MemberEligibilityCheckFacade_Factory(t) { return new (t || MemberEligibilityCheckFacade)(i0.ɵɵinject(i1.MemberSessionHttpService)); };
MemberEligibilityCheckFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MemberEligibilityCheckFacade, factory: MemberEligibilityCheckFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberEligibilityCheckFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.MemberSessionHttpService }]; }, null); })();

class MemberRegistrationService {
    constructor(store) {
        this.store = store;
    }
    isCountySelectionCheckNeeded() {
        return !!this.store.selectSnapshot(RuntimeState.ssoResult) && !!this.store.selectSnapshot(DemographicState.selectedZipCode);
    }
    getPartAEffectiveDateValidation(effectiveDate, dateOfBirth, partAEffectiveDateValidationForm, effectiveDatePartAMaxFutureMonths, effectiveDatePartAMaxPastMonths) {
        const partAEffectiveDate = partAEffectiveDateValidationForm.get('partAEffectiveDate');
        const effectiveDateValidation = {
            error: true
        };
        if (!effectiveDate || effectiveDate.length < 10 || !DateUtilities.isValidDate(effectiveDate)) {
            partAEffectiveDate.markAsTouched({ onlySelf: true });
            partAEffectiveDate.setErrors({ incorrect: true }, { emitEvent: false });
            effectiveDateValidation.errorCase = EffectiveDateErrors.INVALID_EFFECTIVE_DATE;
            return effectiveDateValidation;
        }
        if (dateOfBirth && !DateUtilities.dateAfter(effectiveDate, dateOfBirth)) {
            partAEffectiveDate.markAsTouched({ onlySelf: true });
            partAEffectiveDate.setErrors({ incorrect: true }, { emitEvent: false });
            effectiveDateValidation.errorCase = EffectiveDateErrors.AFTER_DATE_OF_BIRTH;
            return effectiveDateValidation;
        }
        if (!DateUtilities.dateIsInFutureMonthRange(effectiveDate, effectiveDatePartAMaxFutureMonths)) {
            effectiveDateValidation.errorCase = EffectiveDateErrors.FUTURE_DATE;
            partAEffectiveDate.markAsTouched({ onlySelf: true });
            partAEffectiveDate.setErrors({ incorrect: true }, { emitEvent: false });
            return effectiveDateValidation;
        }
        if (!DateUtilities.dateIsInPastMonthRange(effectiveDate, effectiveDatePartAMaxPastMonths)) {
            partAEffectiveDate.markAsTouched({ onlySelf: true });
            partAEffectiveDate.setErrors({ incorrect: true }, { emitEvent: false });
            effectiveDateValidation.errorCase = EffectiveDateErrors.PAST_DATE;
            return effectiveDateValidation;
        }
        partAEffectiveDate.setErrors(null, { emitEvent: false });
        effectiveDateValidation.error = false;
        return effectiveDateValidation;
    }
    getPartBEffectiveDateValidation(effectiveDate, dateOfBirth, partBEffectiveDateValidationForm, effectiveDatePartBMaxFutureMonths, effectiveDatePartBMaxPastMonths, displayValidation, partAProfileConfig) {
        const partAEffectiveDate = partBEffectiveDateValidationForm.get('partAEffectiveDate').value;
        const partBEffectiveDate = partBEffectiveDateValidationForm.get('partBEffectiveDate');
        const effectiveDateValidation = {
            error: true
        };
        if (!effectiveDate || effectiveDate.length < 10 || !DateUtilities.isValidDate(effectiveDate)) {
            partBEffectiveDate.markAsTouched({ onlySelf: true });
            partBEffectiveDate.setErrors({ incorrect: true }, { emitEvent: false });
            effectiveDateValidation.errorCase = EffectiveDateErrors.INVALID_EFFECTIVE_DATE;
            return effectiveDateValidation;
        }
        if (dateOfBirth && !DateUtilities.dateAfter(effectiveDate, dateOfBirth)) {
            partBEffectiveDate.markAsTouched({ onlySelf: true });
            partBEffectiveDate.setErrors({ incorrect: true }, { emitEvent: false });
            effectiveDateValidation.errorCase = EffectiveDateErrors.AFTER_DATE_OF_BIRTH;
            return effectiveDateValidation;
        }
        if (partAEffectiveDate &&
            partAProfileConfig.display &&
            displayValidation &&
            DateUtilities.dateBefore(effectiveDate, partAEffectiveDate)) {
            partBEffectiveDate.markAsTouched({ onlySelf: true });
            partBEffectiveDate.setErrors({ incorrect: true }, { emitEvent: false });
            effectiveDateValidation.errorCase = EffectiveDateErrors.EFFECTIVE_DATE_AFTER_PART_A_EFFECTIVEDATE;
            return effectiveDateValidation;
        }
        if (!DateUtilities.dateIsInFutureMonthRange(effectiveDate, effectiveDatePartBMaxFutureMonths)) {
            partBEffectiveDate.markAsTouched({ onlySelf: true });
            partBEffectiveDate.setErrors({ incorrect: true }, { emitEvent: false });
            effectiveDateValidation.errorCase = EffectiveDateErrors.FUTURE_DATE;
            return effectiveDateValidation;
        }
        if (!DateUtilities.dateIsInPastMonthRange(effectiveDate, effectiveDatePartBMaxPastMonths)) {
            partBEffectiveDate.markAsTouched({ onlySelf: true });
            partBEffectiveDate.setErrors({ incorrect: true }, { emitEvent: false });
            effectiveDateValidation.errorCase = EffectiveDateErrors.PAST_DATE;
            return effectiveDateValidation;
        }
        partBEffectiveDate.setErrors(null, { emitEvent: false });
        effectiveDateValidation.error = false;
        return effectiveDateValidation;
    }
}
MemberRegistrationService.ɵfac = function MemberRegistrationService_Factory(t) { return new (t || MemberRegistrationService)(i0.ɵɵinject(i2.Store)); };
MemberRegistrationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MemberRegistrationService, factory: MemberRegistrationService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberRegistrationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i2.Store }]; }, null); })();

const _c0$1w = ["memberEffectiveDate"];
const _c1$H = ["memberEffectiveDateDropdown"];
function MemberEffectiveDateComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function MemberEffectiveDateComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-form-date", 3, 4);
    i0.ɵɵlistener("sendDate", function MemberEffectiveDateComponent_ng_template_1_Template_vnext_form_date_sendDate_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.getDate($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("defaultValue", ctx_r2.defaultValue)("showDatePicker", ctx_r2.showDatePicker)("hasError", ctx_r2.hasError)("datePickerButtonLabelText", ctx_r2.datePickerButtonLabelText)("ariaDescribedById", ctx_r2.ariaDescribedById)("ariaLabelledById", ctx_r2.ariaLabelledById);
} }
function MemberEffectiveDateComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-form-month-year-dropdown", 5, 6);
    i0.ɵɵlistener("updatedDate", function MemberEffectiveDateComponent_ng_template_3_Template_vnext_form_month_year_dropdown_updatedDate_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.selectDate($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("maxFutureMonths", ctx_r4.maxFutureMonths)("maxPastMonths", ctx_r4.maxPastMonths)("monthRange", ctx_r4.monthRange)("defaultValue", ctx_r4.defaultValue)("hasError", ctx_r4.hasError)("monthList", ctx_r4.monthList)("yearRange", ctx_r4.yearRange);
} }
class MemberEffectiveDateComponent {
    constructor() {
        this.hasError = false;
        this.showDatePicker = true;
        this.updateAnswer = new EventEmitter();
    }
    selectDate(selectedDate) {
        this.getDate(selectedDate);
    }
    getDate(date) {
        this.updateAnswer.emit(date);
    }
    resetSelectedValues() {
        this.memberEffectiveDateDropdown?.resetSelectedValues();
    }
}
MemberEffectiveDateComponent.ɵfac = function MemberEffectiveDateComponent_Factory(t) { return new (t || MemberEffectiveDateComponent)(); };
MemberEffectiveDateComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MemberEffectiveDateComponent, selectors: [["vnext-member-effective-date"]], viewQuery: function MemberEffectiveDateComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1w, 5);
        i0.ɵɵviewQuery(_c1$H, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.memberEffectiveDate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.memberEffectiveDateDropdown = _t.first);
    } }, inputs: { defaultValue: "defaultValue", hasError: "hasError", ariaDescribedById: "ariaDescribedById", ariaLabelledById: "ariaLabelledById", datePickerButtonLabelText: "datePickerButtonLabelText", dropdownEnabled: "dropdownEnabled", monthList: "monthList", yearRange: "yearRange", monthRange: "monthRange", showDatePicker: "showDatePicker", maxFutureMonths: "maxFutureMonths", maxPastMonths: "maxPastMonths" }, outputs: { updateAnswer: "updateAnswer" }, decls: 5, vars: 3, consts: [[4, "ngIf", "ngIfThen", "ngIfElse"], ["dateField", ""], ["dropdown", ""], [3, "defaultValue", "showDatePicker", "hasError", "datePickerButtonLabelText", "ariaDescribedById", "ariaLabelledById", "sendDate"], ["memberEffectiveDate", ""], [3, "maxFutureMonths", "maxPastMonths", "monthRange", "defaultValue", "hasError", "monthList", "yearRange", "updatedDate"], ["memberEffectiveDateDropdown", ""]], template: function MemberEffectiveDateComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MemberEffectiveDateComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        i0.ɵɵtemplate(1, MemberEffectiveDateComponent_ng_template_1_Template, 2, 6, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(3, MemberEffectiveDateComponent_ng_template_3_Template, 2, 7, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        const _r3 = i0.ɵɵreference(4);
        i0.ɵɵproperty("ngIf", ctx.dropdownEnabled)("ngIfThen", _r3)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgIf, FormMonthYearDropdownComponent, FormDateComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberEffectiveDateComponent, [{
        type: Component,
        args: [{ selector: 'vnext-member-effective-date', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"dropdownEnabled; then dropdown; else dateField\"></ng-container>\r\n<ng-template #dateField>\r\n  <vnext-form-date\r\n    #memberEffectiveDate\r\n    [defaultValue]=\"defaultValue\"\r\n    [showDatePicker]=\"showDatePicker\"\r\n    [hasError]=\"hasError\"\r\n    [datePickerButtonLabelText]=\"datePickerButtonLabelText\"\r\n    [ariaDescribedById]=\"ariaDescribedById\"\r\n    [ariaLabelledById]=\"ariaLabelledById\"\r\n    (sendDate)=\"getDate($event)\"\r\n  ></vnext-form-date>\r\n</ng-template>\r\n<ng-template #dropdown>\r\n  <vnext-form-month-year-dropdown\r\n    #memberEffectiveDateDropdown\r\n    [maxFutureMonths]=\"maxFutureMonths\"\r\n    [maxPastMonths]=\"maxPastMonths\"\r\n    [monthRange]=\"monthRange\"\r\n    [defaultValue]=\"defaultValue\"\r\n    [hasError]=\"hasError\"\r\n    [monthList]=\"monthList\"\r\n    [yearRange]=\"yearRange\"\r\n    (updatedDate)=\"selectDate($event)\"\r\n  >\r\n  </vnext-form-month-year-dropdown>\r\n</ng-template>\r\n" }]
    }], null, { memberEffectiveDate: [{
            type: ViewChild,
            args: ['memberEffectiveDate']
        }], memberEffectiveDateDropdown: [{
            type: ViewChild,
            args: ['memberEffectiveDateDropdown']
        }], defaultValue: [{
            type: Input
        }], hasError: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], datePickerButtonLabelText: [{
            type: Input
        }], dropdownEnabled: [{
            type: Input
        }], monthList: [{
            type: Input
        }], yearRange: [{
            type: Input
        }], monthRange: [{
            type: Input
        }], showDatePicker: [{
            type: Input
        }], maxFutureMonths: [{
            type: Input
        }], maxPastMonths: [{
            type: Input
        }], updateAnswer: [{
            type: Output
        }] }); })();

const _c0$1v = ["memberPartAEffectiveDate"];
const _c1$G = ["memberPartBEffectiveDate"];
function MemberEligibilityCheckComponent_h2_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.headerText);
} }
function MemberEligibilityCheckComponent_div_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 18);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.formError ? ctx_r10.errorKeywordText : ctx_r10.emptyFields + " " + ctx_r10.requiredFieldError, " ");
} }
function MemberEligibilityCheckComponent_div_6_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 18);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.checkEligibilityResponse.clientMessage, " ");
} }
function MemberEligibilityCheckComponent_div_6_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, MemberEligibilityCheckComponent_div_6_ng_template_2_ng_container_0_Template, 4, 1, "ng-container", 19);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r12.checkEligibilityResponse.clientMessage);
} }
function MemberEligibilityCheckComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, MemberEligibilityCheckComponent_div_6_ng_container_1_Template, 4, 1, "ng-container", 16);
    i0.ɵɵtemplate(2, MemberEligibilityCheckComponent_div_6_ng_template_2_Template, 1, 1, "ng-template", null, 17, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r11 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.formError || ctx_r1.emptyFields.length > 0)("ngIfElse", _r11);
} }
function MemberEligibilityCheckComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelement(1, "i", 21);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.mbiValidErrorText, " ");
} }
function MemberEligibilityCheckComponent_div_9_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
const _c2$s = function (a0) { return { "readonly Spa_Style_Gray4_Color": a0 }; };
const _c3$h = function (a0, a1) { return { "Spa_Style_Gray4_Color readonly": a0, "show-mbi-as-password": a1 }; };
function MemberEligibilityCheckComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "label", 23);
    i0.ɵɵtemplate(2, MemberEligibilityCheckComponent_div_9_span_2_Template, 2, 0, "span", 24);
    i0.ɵɵelementStart(3, "label", 25)(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(6, "input", 26);
    i0.ɵɵelementStart(7, "vnext-link", 27);
    i0.ɵɵlistener("click", function MemberEligibilityCheckComponent_div_9_Template_vnext_link_click_7_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.toggleMedicareNumber()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", ctx_r3.mbiFieldName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.memberRegistrationMap[ctx_r3.mbiFieldName].required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c2$s, ctx_r3.isReadOnly));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r3.memberRegistrationMap[ctx_r3.mbiFieldName] == null ? null : ctx_r3.memberRegistrationMap[ctx_r3.mbiFieldName].labelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("maxlength", ctx_r3.mbiValidLength);
    i0.ɵɵpropertyInterpolate("minlength", ctx_r3.mbiValidLength);
    i0.ɵɵproperty("id", ctx_r3.mbiFieldName)("ngClass", i0.ɵɵpureFunction2(12, _c3$h, ctx_r3.isReadOnly, !ctx_r3.showMedicareNumber))("readonly", ctx_r3.isReadOnly);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r3.showMedicareNumber ? ctx_r3.hideText : ctx_r3.showText);
} }
function MemberEligibilityCheckComponent_div_10_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberEligibilityCheckComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29)(1, "label", 30)(2, "label", 25);
    i0.ɵɵtemplate(3, MemberEligibilityCheckComponent_div_10_span_3_Template, 2, 0, "span", 24);
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div")(7, "vnext-member-effective-date", 31, 32);
    i0.ɵɵlistener("updateAnswer", function MemberEligibilityCheckComponent_div_10_Template_vnext_member_effective_date_updateAnswer_7_listener($event) { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r19.updateEffectiveDate($event, "partAEffectiveDate")); });
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c2$s, ctx_r4.isReadOnly));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.memberRegistrationMap["partAEffectiveDate"].required);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r4.memberRegistrationMap["partAEffectiveDate"].labelText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("defaultValue", ctx_r4.partAEffectiveDate)("dropdownEnabled", ctx_r4.dropdownPartAEnabled)("maxFutureMonths", ctx_r4.effectiveDatePartAMaxFutureMonths)("maxPastMonths", ctx_r4.effectiveDatePartAMaxPastMonths)("monthRange", ctx_r4.effectiveDatePartAMonthRange)("yearRange", ctx_r4.effectiveDatePartAYearRange)("monthList", ctx_r4.effectiveDateMonthList);
} }
function MemberEligibilityCheckComponent_div_11_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberEligibilityCheckComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29)(1, "label", 30)(2, "label", 25);
    i0.ɵɵtemplate(3, MemberEligibilityCheckComponent_div_11_span_3_Template, 2, 0, "span", 24);
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div")(7, "vnext-member-effective-date", 31, 33);
    i0.ɵɵlistener("updateAnswer", function MemberEligibilityCheckComponent_div_11_Template_vnext_member_effective_date_updateAnswer_7_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r23.updateEffectiveDate($event, "partBEffectiveDate")); });
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c2$s, ctx_r5.isReadOnly));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.memberRegistrationMap["partBEffectiveDate"].required);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r5.memberRegistrationMap["partBEffectiveDate"].labelText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("defaultValue", ctx_r5.partBEffectiveDate)("dropdownEnabled", ctx_r5.dropdownPartBEnabled)("maxFutureMonths", ctx_r5.effectiveDatePartBMaxFutureMonths)("maxPastMonths", ctx_r5.effectiveDatePartBMaxPastMonths)("monthRange", ctx_r5.effectiveDatePartBMonthRange)("yearRange", ctx_r5.effectiveDatePartBYearRange)("monthList", ctx_r5.effectiveDateMonthList);
} }
const _c4$9 = function (a0, a1) { return { "fa-angle-up": a0, "fa-angle-down": a1 }; };
function MemberEligibilityCheckComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34)(1, "vnext-link", 35);
    i0.ɵɵlistener("click", function MemberEligibilityCheckComponent_div_12_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r25.toggleSubsidyAccordion()); });
    i0.ɵɵelementStart(2, "div", 36)(3, "span", 37);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "i", 38);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r6.openSubsidyText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c4$9, ctx_r6.showSubsidyAccordion, !ctx_r6.showSubsidyAccordion));
} }
function MemberEligibilityCheckComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 39)(1, "p", 40)(2, "span", 41);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 42);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 43)(7, "vnext-accordion", 44);
    i0.ɵɵlistener("valueSelected", function MemberEligibilityCheckComponent_div_13_Template_vnext_accordion_valueSelected_7_listener($event) { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r27.setSubsidyValue($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r7.accordionHeaderText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.optionalLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("items", ctx_r7.subsidyAccordionItems)("allowParentValues", true)("selectedParent", ctx_r7.selectedParentId)("selectedChild", ctx_r7.selectedChildId)("emitParentValueWhenNoChildrenSelected", true)("ariaLabelledById", "extra-help-for-drugs-text extra-help-for-drugs-optional-text")("largerText", true)("buttonHeight", "36px")("secondaryButtonTextColor", ctx_r7.secondaryButtonTextColor)("isMobile", ctx_r7.isMobile);
} }
function MemberEligibilityCheckComponent_div_14_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r29.profileEligibilityButtonText);
} }
function MemberEligibilityCheckComponent_div_14_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-spinner", 52);
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("size", ctx_r31.spinnerSizeSmall);
} }
function MemberEligibilityCheckComponent_div_14_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 53);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r32.lastCheckedDateText, " ", i0.ɵɵpipeBind2(2, 2, ctx_r32.lastCheckedDate, "MM/dd/yyyy"), " ");
} }
function MemberEligibilityCheckComponent_div_14_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 57);
    i0.ɵɵelement(1, "i", 58);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r35.medicareEligibleText);
} }
function MemberEligibilityCheckComponent_div_14_div_7_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 59);
    i0.ɵɵelement(1, "i", 60);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate((ctx_r37.checkEligibilityResponse == null ? null : ctx_r37.checkEligibilityResponse.isError) ? ctx_r37.requestErrorText : ctx_r37.notEligibleText);
} }
function MemberEligibilityCheckComponent_div_14_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵtemplate(1, MemberEligibilityCheckComponent_div_14_div_7_div_1_Template, 4, 1, "div", 55);
    i0.ɵɵtemplate(2, MemberEligibilityCheckComponent_div_14_div_7_ng_template_2_Template, 4, 1, "ng-template", null, 56, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r36 = i0.ɵɵreference(3);
    const ctx_r33 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r33.checkEligibilityResponse == null ? null : ctx_r33.checkEligibilityResponse.isMedicareEligible)("ngIfElse", _r36);
} }
function MemberEligibilityCheckComponent_div_14_div_9_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 63);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", ctx_r38.dsnpChangedFromText, " \"", ctx_r38.pastSelectionTitle, "\"");
} }
function MemberEligibilityCheckComponent_div_14_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 61);
    i0.ɵɵelement(2, "i", 58);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, MemberEligibilityCheckComponent_div_14_div_9_div_5_Template, 2, 2, "div", 62);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r34.dsnpText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r34.subsidyUpdated && ctx_r34.pastSelectionTitle);
} }
const _c5$6 = function (a0) { return { "pr-0": a0 }; };
function MemberEligibilityCheckComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 45)(1, "div", 46)(2, "button", 47);
    i0.ɵɵlistener("click", function MemberEligibilityCheckComponent_div_14_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r40); const ctx_r39 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r39.checkMemberEligibility()); })("keyup.enter", function MemberEligibilityCheckComponent_div_14_Template_button_keyup_enter_2_listener() { i0.ɵɵrestoreView(_r40); const ctx_r41 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r41.checkMemberEligibility()); });
    i0.ɵɵtemplate(3, MemberEligibilityCheckComponent_div_14_span_3_Template, 2, 1, "span", 16);
    i0.ɵɵtemplate(4, MemberEligibilityCheckComponent_div_14_ng_template_4_Template, 1, 1, "ng-template", null, 48, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, MemberEligibilityCheckComponent_div_14_div_6_Template, 3, 5, "div", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, MemberEligibilityCheckComponent_div_14_div_7_Template, 4, 2, "div", 50);
    i0.ɵɵelementStart(8, "div", 51);
    i0.ɵɵtemplate(9, MemberEligibilityCheckComponent_div_14_div_9_Template, 6, 2, "div", 19);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r30 = i0.ɵɵreference(5);
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c5$6, ctx_r8.isMobile));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r8.checkEligibilityLoading)("ngIfElse", _r30);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r8.lastCheckedDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r8.memberEligibilityCheckPerformed || ctx_r8.lastCheckedDate) && !ctx_r8.checkEligibilityLoading);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r8.checkEligibilityResponse == null ? null : ctx_r8.checkEligibilityResponse.isDSNPEligible) && (ctx_r8.eligibilityCheckProfileData == null ? null : ctx_r8.eligibilityCheckProfileData.includeDSNPCheck));
} }
function MemberEligibilityCheckComponent_vnext_widgets_medicaid_eligibility_check_15_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-widgets-medicaid-eligibility-check", 64);
    i0.ɵɵlistener("checkMedicaidEligibility", function MemberEligibilityCheckComponent_vnext_widgets_medicaid_eligibility_check_15_Template_vnext_widgets_medicaid_eligibility_check_checkMedicaidEligibility_0_listener($event) { i0.ɵɵrestoreView(_r43); const ctx_r42 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r42.checkMedicaidEligibility($event)); })("medicaidDataChanged", function MemberEligibilityCheckComponent_vnext_widgets_medicaid_eligibility_check_15_Template_vnext_widgets_medicaid_eligibility_check_medicaidDataChanged_0_listener($event) { i0.ɵɵrestoreView(_r43); const ctx_r44 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r44.msiDataChanged.emit($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("stateEligibilityCheckDescription", ctx_r9.stateEligibilityCheckDescription)("medicaidIdLabel", ctx_r9.medicaidIdLabel)("stateEligibilityCheckButtonLabel", ctx_r9.stateEligibilityCheckButtonLabel)("noMedicaidIdErrorLabel", ctx_r9.noMedicaidIdErrorLabel)("eligibilityCheckPendingLabel", ctx_r9.eligibilityCheckPendingLabel)("eligibilityCheckPendingDescriptionLabel", ctx_r9.eligibilityCheckPendingDescriptionLabel)("isZipValid", ctx_r9.isZipValid)("noZipCodeText", ctx_r9.noZipCodeText)("zipCode", ctx_r9.zipCode)("countyFips", ctx_r9.countyFips)("isMedicareEligible", ctx_r9.checkEligibilityResponse == null ? null : ctx_r9.checkEligibilityResponse.isMedicareEligible)("medicaidId", ctx_r9.medicaidId)("medicaidCheckStatus", ctx_r9.medicaidCheckStatus)("isMedicaidEligible", ctx_r9.isMedicaidEligible)("isDSNPEligible", ctx_r9.isDSNPEligible)("medicaidEligibilityLevel", ctx_r9.medicaidEligibilityLevel)("medicaidCodeText", ctx_r9.medicaidCodeText)("medicaidCheckDateReceivedText", ctx_r9.medicaidCheckDateReceivedText)("medicaidLastCheckedDate", ctx_r9.medicaidLastCheckedDate)("medicaidStateSelection", ctx_r9.medicaidStateSelection)("medicaidCheckDays", ctx_r9.medicaidCheckDays)("spinnerSizeSmall", ctx_r9.spinnerSizeSmall)("checkMedicaidEligibilityLoading", ctx_r9.checkMedicaidEligibilityLoading)("medicaidCheckCannotCompleteErrorText", ctx_r9.medicaidCheckCannotCompleteErrorText)("medicaidClientMessage", ctx_r9.medicaidClientMessage)("isFederalEligibilityForStateRequired", ctx_r9.isFederalEligibilityForStateRequired)("isProfileEligibilityCheckDSNPEnabled", ctx_r9.isProfileEligibilityCheckDSNPEnabled)("federalEligibilityForStateRequiredText", ctx_r9.federalEligibilityForStateRequiredText)("stateNotEligibleText", ctx_r9.stateNotEligibleText)("selectedCountyState", ctx_r9.selectedCountyState)("isMedicaidEligibilityEnabledForSelectedState", ctx_r9.isMedicaidEligibilityEnabledForSelectedState)("notEligibleText", ctx_r9.notEligibleText)("genderEnabled", ctx_r9.genderEnabled)("genderItems", ctx_r9.genderItems)("genderLabel", ctx_r9.genderLabel)("defaultGender", ctx_r9.defaultGender)("genderRequiredErrorText", ctx_r9.genderRequiredErrorText);
} }
const _c6$6 = function (a0, a1) { return { "mb-1": a0, "mb-4": a1 }; };
var MSIField;
(function (MSIField) {
    MSIField["PART_A_EFFECTIVE_DATE"] = "partAEffectiveDate";
    MSIField["PART_B_EFFECTIVE_DATE"] = "partBEffectiveDate";
    MSIField["MBI"] = "mbi";
})(MSIField || (MSIField = {}));
class MemberEligibilityCheckComponent {
    constructor(planFacade, localeService, cdr, profileCryptoService, memberEligibilityCheckFacade, ssoPopulatedFieldService, memberSessionService, demographicService, profileFacade, profileService, memberRegistrationService, responsiveLayoutService, snpService, agentService) {
        this.planFacade = planFacade;
        this.localeService = localeService;
        this.cdr = cdr;
        this.profileCryptoService = profileCryptoService;
        this.memberEligibilityCheckFacade = memberEligibilityCheckFacade;
        this.ssoPopulatedFieldService = ssoPopulatedFieldService;
        this.memberSessionService = memberSessionService;
        this.demographicService = demographicService;
        this.profileFacade = profileFacade;
        this.profileService = profileService;
        this.memberRegistrationService = memberRegistrationService;
        this.responsiveLayoutService = responsiveLayoutService;
        this.snpService = snpService;
        this.agentService = agentService;
        this.iconColor = '';
        this.msiDataChanged = new EventEmitter();
        this.subsidyIdChanged = new EventEmitter();
        this.spinnerSizeSmall = SpinnerSize.SMALL;
        this.checkEligibilityLoading = false;
        this.msiFieldErrors = {
            [MSIField.PART_A_EFFECTIVE_DATE]: false,
            [MSIField.PART_B_EFFECTIVE_DATE]: false,
            [MSIField.MBI]: false
        };
        this.subscriptions = new Subscription();
        this.source = MemberEligibilitySource.Profile;
        this.emptyFields = '';
        this.pastSelectionTitle = '';
        this.disableMedicaidCheckButton = false;
        this.checkMedicaidEligibilityLoading = false;
        this.memberEligibilityCheckPerformed = false;
        this.checkEligibilityResponse = {
            isMedicareEligible: false,
            isDSNPEligible: false
        };
        this.isMobile = false;
        this.isMedicaidEligibilityEnabledForSelectedState = false;
    }
    ngOnChanges(changes) {
        const { isMedicareEligible, isDSNPEligible, hicn, partAEffectiveDate, partBEffectiveDate } = changes;
        if (!!this.checkEligibilityResponse &&
            isMedicareEligible &&
            isMedicareEligible.currentValue !== this.checkEligibilityResponse.isMedicareEligible) {
            this.checkEligibilityResponse.isMedicareEligible = isMedicareEligible.currentValue;
        }
        if (!!this.checkEligibilityResponse && isDSNPEligible && isDSNPEligible.currentValue !== this.checkEligibilityResponse.isDSNPEligible) {
            this.checkEligibilityResponse.isDSNPEligible = isDSNPEligible.currentValue;
            if (this.checkEligibilityResponse.isDSNPEligible) {
                this.snpService.setDSNPTypesVisibility(isDSNPEligible.currentValue);
            }
        }
        if (this.partAEffectiveDateField &&
            partAEffectiveDate?.currentValue &&
            partAEffectiveDate.currentValue !== this.partAEffectiveDateField.value) {
            this.partAEffectiveDateField.setValue(partAEffectiveDate?.currentValue);
        }
        if (this.partBEffectiveDateField &&
            partBEffectiveDate?.currentValue &&
            partBEffectiveDate.currentValue !== this.partBEffectiveDateField.value) {
            this.partBEffectiveDateField.setValue(partBEffectiveDate?.currentValue);
        }
        if (this.mbiField && hicn && hicn.currentValue !== hicn.previousValue) {
            this.resetFormOnHICNChange();
        }
    }
    ngOnInit() {
        this.checkEligibilityResponse = {
            isMedicareEligible: this.isMedicareEligible,
            isDSNPEligible: this.isDSNPEligible
        };
        this.selectedParentId = `${this.subsidySelected}`;
        this.selectedChildId = `${this.subsidyPercent}`;
        this.memberEligibilityCheckPerformed =
            (this.isMedicareEligible !== undefined && this.isMedicareEligible !== null) ||
                (this.isDSNPEligible !== undefined && this.isDSNPEligible !== null);
        this.dateMaskFormat = DateUtilities.defaultFormat.replace('DD', 'd0').replace('MM', 'M0').replace('YYYY', '0000');
        const mbiValidators = [
            Validators.minLength(this.mbiValidLength),
            Validators.maxLength(this.mbiValidLength),
            Validators.pattern(this.mbiRegexPattern)
        ];
        this.memberEligibilityCheck = new UntypedFormGroup({
            // MBI and HICN are considered/used the same
            mbi: new UntypedFormControl(this.hicn ? this.profileCryptoService.getDecryptedHICN(this.hicn) : '', this.getProfileConfig(this.mbiFieldName).required ? [Validators.required, ...mbiValidators] : mbiValidators),
            partAEffectiveDate: new UntypedFormControl(this.partAEffectiveDate ? DateUtilities.getFormattedDate(new Date(this.partAEffectiveDate), DateUtilities.defaultFormat) : '', this.getProfileConfig(MSIField.PART_A_EFFECTIVE_DATE).required ? [Validators.required, Validators.maxLength(12)] : null),
            partBEffectiveDate: new UntypedFormControl(this.partBEffectiveDate ? DateUtilities.getFormattedDate(new Date(this.partBEffectiveDate), DateUtilities.defaultFormat) : '', this.getProfileConfig(MSIField.PART_B_EFFECTIVE_DATE).required ? [Validators.required, Validators.maxLength(12)] : null)
        });
        this.mbiField = this.memberEligibilityCheck.get(MSIField.MBI);
        this.partAEffectiveDateField = this.memberEligibilityCheck.get(MSIField.PART_A_EFFECTIVE_DATE);
        this.partBEffectiveDateField = this.memberEligibilityCheck.get(MSIField.PART_B_EFFECTIVE_DATE);
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe({
            next: locale => {
                this.subsidyAccordionItems = this.planFacade.subsidyAccordionItems;
                if (this.selectedParentId) {
                    this.setPastItemTitle();
                }
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.ssoPopulatedFieldService.isFieldReadOnly$('Profile.Mbi').subscribe({
            next: isReadOnly => {
                this.isReadOnly = isReadOnly;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.partAEffectiveDateField.valueChanges.pipe(distinctUntilChanged()).subscribe({
            next: partAEffectiveDate => {
                this.msiDataFieldChanged(MSIField.PART_A_EFFECTIVE_DATE, partAEffectiveDate);
            }
        }));
        this.subscriptions.add(this.partBEffectiveDateField.valueChanges.pipe(distinctUntilChanged()).subscribe({
            next: partBEffectiveDate => {
                this.msiDataFieldChanged(MSIField.PART_B_EFFECTIVE_DATE, partBEffectiveDate);
            }
        }));
        this.subscriptions.add(this.mbiField.valueChanges.pipe(distinctUntilChanged()).subscribe({
            next: mbi => {
                this.msiDataFieldChanged(MSIField.MBI, mbi);
            }
        }));
        this.subscriptions.add(this.responsiveLayoutService.isCompact$.subscribe({
            next: isMobile => {
                this.isMobile = isMobile;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.profileService.getSelectedProfileCounty$().subscribe({
            next: selectedCounty => {
                if (selectedCounty) {
                    this.selectedCountyState = selectedCounty.state;
                    this.isMedicaidEligibilityEnabledForSelectedState = !!this.medicaidIntegrationConfig?.some(medicaidIntegration => medicaidIntegration.state === ALL_MEDICAID_INTEGRATION_STATES || medicaidIntegration.state === this.selectedCountyState);
                    this.cdr.markForCheck();
                }
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    updateEffectiveDate(date, field) {
        this.memberEligibilityCheck.get(field)?.setValue(date);
        this.cdr.markForCheck();
    }
    msiDataFieldChanged(fieldName, value) {
        const hasFieldError = this.fieldHasError(fieldName);
        this.msiFieldErrors[fieldName] = hasFieldError;
        this.setFormError();
        const change = {
            fieldName,
            value
        };
        this.msiDataChanged.emit(change);
    }
    setSubsidyValue($event) {
        this.subsidyUpdated = true;
        this.setPastItemTitle();
        if (!this.subsidySelected) {
            this.selectedParentId = $event.id;
        }
        let idAsNumber = parseInt($event.id, 10);
        if (Object.hasOwnProperty.call(SubsidySelected, idAsNumber)) {
            if (idAsNumber === SubsidySelected.DONT_KNOW) {
                idAsNumber = SubsidySelected.NONE;
            }
            this.demographicService.setSubsidySelected(idAsNumber);
        }
        else {
            this.demographicService.setSubsidyPercent(idAsNumber);
        }
        this.subsidyIdChanged.emit(this.subsidyUpdated);
        this.planFacade.setPlansDirty(true, [ALL_MEDICARE_PLAN_TYPE_VALUE]);
    }
    setPastItemTitle() {
        this.pastSelectionTitle = this.subsidyAccordionItems?.find(item => item.id === this.selectedParentId)?.title ?? '';
    }
    toggleSubsidyAccordion() {
        this.showSubsidyAccordion = !this.showSubsidyAccordion;
    }
    toggleMedicareNumber() {
        this.showMedicareNumber = !this.showMedicareNumber;
    }
    getProfileConfig(key) {
        const profileConfig = this.memberRegistrationResources.find(registrationResource => registrationResource.keyName === key);
        return profileConfig ?? new MemberRegistration();
    }
    fieldHasError(fieldName) {
        const control = this.memberEligibilityCheck.get(fieldName);
        if (fieldName === this.mbiFieldName && control.value) {
            return this.isMbiInvalid(control.value);
        }
        if (fieldName === MSIField.PART_A_EFFECTIVE_DATE && control.value) {
            const validationData = this.memberRegistrationService.getPartAEffectiveDateValidation(control.value, this.eligibilityCheckProfileData.dob, this.memberEligibilityCheck, this.effectiveDatePartAMaxFutureMonths, this.effectiveDatePartAMaxPastMonths);
            return validationData.error;
        }
        if (fieldName === MSIField.PART_B_EFFECTIVE_DATE && control.value) {
            const validationData = this.memberRegistrationService.getPartBEffectiveDateValidation(control.value, this.eligibilityCheckProfileData.dob, this.memberEligibilityCheck, this.effectiveDatePartBMaxFutureMonths, this.effectiveDatePartBMaxPastMonths, this.isPartAandBEffDateValidationEnabled, this.getProfileConfig(MSIField.PART_A_EFFECTIVE_DATE));
            return validationData.error;
        }
        return !control.valid && control.touched;
    }
    isMbiInvalid(mbi) {
        const mbiErrors = this.memberEligibilityCheck.get(this.mbiFieldName)?.errors;
        return (mbi !== undefined && mbiErrors?.minlength) || mbiErrors?.pattern;
    }
    checkMedicaidEligibility(medicaidSelection) {
        const formInputs = this.memberEligibilityCheck.getRawValue();
        const gender = medicaidSelection?.gender ?? this.profileFacade.getMemberGenderCode();
        const checkEligibilityPayload = {
            zipCode: this.zipCode,
            medicaidId: medicaidSelection?.medicaidId,
            agentGuid: this.agentService.getAgentInContextGuid(),
            countyFips: this.countyFips
        };
        if (this.eligibilityCheckProfileData.firstName) {
            checkEligibilityPayload.firstName = this.eligibilityCheckProfileData.firstName;
        }
        if (this.eligibilityCheckProfileData.lastName) {
            checkEligibilityPayload.lastName = this.eligibilityCheckProfileData.lastName;
        }
        if (this.eligibilityCheckProfileData.dob) {
            checkEligibilityPayload.dob = this.eligibilityCheckProfileData.dob;
        }
        if (formInputs.partAEffectiveDate || this.partAEffectiveDate) {
            checkEligibilityPayload.partAEffectiveDate = formInputs.partAEffectiveDate?.replaceAll('-', '/') ?? this.partAEffectiveDate;
        }
        if (formInputs.partBEffectiveDate || this.partBEffectiveDate) {
            checkEligibilityPayload.partBEffectiveDate = formInputs.partBEffectiveDate?.replaceAll('-', '/') ?? this.partBEffectiveDate;
        }
        if (gender !== GenderCode.NOT_PROVIDED) {
            checkEligibilityPayload.gender = this.memberEligibilityCheckFacade.getGenderType(gender);
        }
        if (formInputs.mbi) {
            checkEligibilityPayload.mbi = formInputs.mbi;
        }
        this.checkMedicaidEligibilityLoading = true;
        this.memberEligibilityCheckFacade
            .checkMedicaidEligibility$(checkEligibilityPayload, this.memberSessionService.getMemberSessionId())
            .subscribe({
            next: (response) => {
                this.checkMedicaidEligibilityLoading = false;
                this.updateMemberProfileMedicaid(response);
                this.cdr.markForCheck();
            },
            error: (error) => {
                this.checkMedicaidEligibilityLoading = false;
                if (this.isMedicaidEligibilityStatus(error?.status)) {
                    this.updateMemberProfileMedicaid(error);
                }
                else {
                    this.profileService.updateProfile({ medicaidCheckStatus: MedicaidEligibilityStatus.FAILED });
                }
                this.cdr.markForCheck();
            }
        });
    }
    updateMemberProfileMedicaid(response) {
        if (this.isMedicaidEligibilityStatus(response?.status)) {
            this.profileService.updateProfile({
                medicaidCheckStatus: response.status,
                ...(response.isMedicaidEligible && { isMedicaidEligible: response.isMedicaidEligible }),
                ...(response.eligibilityLevel && { eligibilityLevel: response.eligibilityLevel }),
                ...(response.errorMessage && { clientMessage: response.errorMessage })
            });
            if (response.status !== MedicaidEligibilityStatus.FAILED) {
                this.addStateMedicaidEligibilityCheckedNote();
            }
        }
    }
    checkMemberEligibility() {
        const formInputs = this.memberEligibilityCheck.getRawValue();
        const checkEligibilityPayload = {
            firstName: this.eligibilityCheckProfileData.firstName,
            lastName: this.eligibilityCheckProfileData.lastName,
            mbi: formInputs.mbi,
            dob: this.eligibilityCheckProfileData.dob,
            partAEffectiveDate: formInputs.partAEffectiveDate?.replaceAll('-', '/') ?? this.partAEffectiveDate,
            partBEffectiveDate: formInputs.partBEffectiveDate?.replaceAll('-', '/') ?? this.partBEffectiveDate,
            source: this.source,
            memberID: this.eligibilityCheckProfileData.memberID,
            includeDSNPCheck: this.eligibilityCheckProfileData.includeDSNPCheck
        };
        this.checkRequiredFields(checkEligibilityPayload);
        if (this.emptyFields.length === 0 && this.mbiField?.valid) {
            this.checkEligibilityLoading = true;
            this.memberEligibilityCheckPerformed = true;
            this.memberEligibilityCheckFacade.checkMemberEligibility$(checkEligibilityPayload).subscribe({
                next: (response) => {
                    this.checkEligibilityLoading = false;
                    this.checkEligibilityResponse = response;
                    if (!this.checkEligibilityResponse.isError) {
                        const sessionUpdate = {
                            profile: {
                                isMedicareEligible: response.isMedicareEligible,
                                isDSNPEligible: response.isDSNPEligible,
                                lastCheckedDate: DateUtilities.getFormattedCurrentDate()
                            }
                        };
                        if (this.checkEligibilityResponse.isDSNPEligible) {
                            this.setSubsidyValue({ id: `${SubsidySelected.MEDICAID}` });
                            this.snpService.setDSNPTypesVisibility(true);
                        }
                        this.memberSessionService.updateMemberProfile(sessionUpdate);
                        this.demographicService.updateDemographicSession();
                    }
                    this.cdr.markForCheck();
                },
                error: () => {
                    this.checkEligibilityLoading = false;
                    this.checkEligibilityResponse.isError = true;
                    this.cdr.markForCheck();
                }
            });
        }
    }
    checkRequiredFields(payload) {
        this.emptyFields = '';
        for (const field of ELIGIBILITY_CHECK_REQUIRED_FIELDS) {
            if (!payload[field] && this.memberRegistrationMap[field]?.labelText) {
                this.emptyFields +=
                    this.emptyFields.length === 0
                        ? ` ${this.memberRegistrationMap[field].labelText}`
                        : `, ${this.memberRegistrationMap[field].labelText}`;
            }
        }
    }
    resetFormOnHICNChange() {
        this.memberEligibilityCheckPerformed = false;
        this.subsidyUpdated = false;
        this.lastCheckedDate = undefined;
        this.selectedParentId = undefined;
        this.selectedChildId = undefined;
        this.checkEligibilityResponse = {
            isMedicareEligible: false,
            isDSNPEligible: false
        };
        this.subsidyIdChanged.emit(this.subsidyUpdated);
        this.memberEligibilityCheck.reset();
        this.memberPartAEffectiveDate?.resetSelectedValues();
        this.memberPartBEffectiveDate?.resetSelectedValues();
    }
    isMedicaidEligibilityStatus(status) {
        return Object.values(MedicaidEligibilityStatus).includes(status);
    }
    addStateMedicaidEligibilityCheckedNote(userAgentGUID = this.agentService.getAgentInContextGuid()) {
        if (userAgentGUID) {
            const countyState = this.profileService.getSelectedProfileCounty()?.state;
            if (countyState) {
                const createdWhen = DateUtilities.getFormattedCurrentDate();
                const description = this.medicaidCheckedNoteText?.replace('<state>', countyState)?.replace('<checkedDate>', createdWhen);
                if (description) {
                    const agentName = this.agentService.getBrokerFullName();
                    const note = {
                        userAgentGUID,
                        agentNoteActionType: NoteActionType.Note,
                        description,
                        agentName,
                        createdWhen
                    };
                    this.memberSessionService.addMemberNoteByAgent(note);
                }
            }
        }
    }
    setFormError() {
        this.formError = Object.values(this.msiFieldErrors).some(value => value === true);
    }
}
MemberEligibilityCheckComponent.ɵfac = function MemberEligibilityCheckComponent_Factory(t) { return new (t || MemberEligibilityCheckComponent)(i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.ProfileCryptoService), i0.ɵɵdirectiveInject(MemberEligibilityCheckFacade), i0.ɵɵdirectiveInject(i1.SSOPopulatedFieldService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.DemographicService), i0.ɵɵdirectiveInject(ProfileFacade), i0.ɵɵdirectiveInject(i1.ProfileService), i0.ɵɵdirectiveInject(MemberRegistrationService), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService), i0.ɵɵdirectiveInject(i1.SNPService), i0.ɵɵdirectiveInject(i1.AgentService)); };
MemberEligibilityCheckComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MemberEligibilityCheckComponent, selectors: [["vnext-widgets-member-eligiblity-check"]], viewQuery: function MemberEligibilityCheckComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1v, 5);
        i0.ɵɵviewQuery(_c1$G, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.memberPartAEffectiveDate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.memberPartBEffectiveDate = _t.first);
    } }, inputs: { checkEnabled: "checkEnabled", iconColor: "iconColor", mbiRegexPattern: "mbiRegexPattern", showMedicareNumber: "showMedicareNumber", mbiError: "mbiError", hideText: "hideText", showText: "showText", dropdownPartAEnabled: "dropdownPartAEnabled", dropdownPartBEnabled: "dropdownPartBEnabled", medicareEligibleText: "medicareEligibleText", dsnpText: "dsnpText", dsnpUpdatedText: "dsnpUpdatedText", dsnpChangedFromText: "dsnpChangedFromText", headerText: "headerText", errorKeywordText: "errorKeywordText", formDescriptionText: "formDescriptionText", accordionHeaderText: "accordionHeaderText", mbiFieldName: "mbiFieldName", profileEligibilityButtonText: "profileEligibilityButtonText", openSubsidyText: "openSubsidyText", effectiveDatePartAMaxFutureMonths: "effectiveDatePartAMaxFutureMonths", effectiveDatePartAMaxPastMonths: "effectiveDatePartAMaxPastMonths", effectiveDatePartBMaxFutureMonths: "effectiveDatePartBMaxFutureMonths", effectiveDatePartBMaxPastMonths: "effectiveDatePartBMaxPastMonths", mbiValidLength: "mbiValidLength", effectiveDateMonthList: "effectiveDateMonthList", effectiveDatePartAMonthRange: "effectiveDatePartAMonthRange", effectiveDatePartAYearRange: "effectiveDatePartAYearRange", effectiveDatePartBMonthRange: "effectiveDatePartBMonthRange", effectiveDatePartBYearRange: "effectiveDatePartBYearRange", memberRegistrationResources: "memberRegistrationResources", showSubsidyAccordionOnProfile: "showSubsidyAccordionOnProfile", isMedicareEligible: "isMedicareEligible", isDSNPEligible: "isDSNPEligible", lastCheckedDate: "lastCheckedDate", hicn: "hicn", subsidySelected: "subsidySelected", subsidyPercent: "subsidyPercent", partAEffectiveDate: "partAEffectiveDate", partBEffectiveDate: "partBEffectiveDate", memberRegistrationMap: "memberRegistrationMap", eligibilityCheckProfileData: "eligibilityCheckProfileData", isPartAandBEffDateValidationEnabled: "isPartAandBEffDateValidationEnabled", lastCheckedDateText: "lastCheckedDateText", notEligibleText: "notEligibleText", requestErrorText: "requestErrorText", requiredFieldError: "requiredFieldError", countyFips: "countyFips", isStateEligibilityCheckEnabled: "isStateEligibilityCheckEnabled", stateEligibilityCheckDescription: "stateEligibilityCheckDescription", medicaidIdLabel: "medicaidIdLabel", stateEligibilityCheckButtonLabel: "stateEligibilityCheckButtonLabel", noMedicaidIdErrorLabel: "noMedicaidIdErrorLabel", eligibilityCheckPendingLabel: "eligibilityCheckPendingLabel", eligibilityCheckPendingDescriptionLabel: "eligibilityCheckPendingDescriptionLabel", isZipValid: "isZipValid", noZipCodeText: "noZipCodeText", zipCode: "zipCode", medicaidId: "medicaidId", medicaidCheckStatus: "medicaidCheckStatus", isMedicaidEligible: "isMedicaidEligible", medicaidEligibilityLevel: "medicaidEligibilityLevel", medicaidLastCheckedDate: "medicaidLastCheckedDate", medicaidStateSelection: "medicaidStateSelection", medicaidClientMessage: "medicaidClientMessage", medicaidCodeText: "medicaidCodeText", medicaidCheckDateReceivedText: "medicaidCheckDateReceivedText", medicaidCheckDays: "medicaidCheckDays", medicaidCheckCannotCompleteErrorText: "medicaidCheckCannotCompleteErrorText", medicaidCheckedNoteText: "medicaidCheckedNoteText", isFederalEligibilityForStateRequired: "isFederalEligibilityForStateRequired", isProfileEligibilityCheckDSNPEnabled: "isProfileEligibilityCheckDSNPEnabled", federalEligibilityForStateRequiredText: "federalEligibilityForStateRequiredText", stateNotEligibleText: "stateNotEligibleText", medicaidIntegrationConfig: "medicaidIntegrationConfig", optionalLabel: "optionalLabel", genderEnabled: "genderEnabled", genderItems: "genderItems", genderLabel: "genderLabel", defaultGender: "defaultGender", genderRequiredErrorText: "genderRequiredErrorText", mbiValidErrorText: "mbiValidErrorText" }, outputs: { msiDataChanged: "msiDataChanged", subsidyIdChanged: "subsidyIdChanged" }, features: [i0.ɵɵNgOnChangesFeature], decls: 16, vars: 16, consts: [["class", "Spa_Style_H2 mt-3 mb-0", 4, "liveEditProp"], [1, "member-eligibility-check-container", "mb-1", "align-items-baseline"], [1, "contain-wrapper", 3, "formGroup"], [1, "mt-1"], [1, "Spa_Style_Regular_Font"], ["class", "Spa_Style_Small_Font warning-message", 4, "ngIf"], ["class", "Spa_Style_Small_Font error-container", 4, "ngIf"], [1, "row", "mt-2", "align-items-baseline", 3, "ngClass"], ["class", "col-lg-4 col-md-6 col-12 button-inside", 4, "ngIf"], ["class", "col-lg-4 col-md-6 col-12", 4, "ngIf"], ["class", "row mt-4 justify-content-center w-100", 4, "ngIf"], ["class", "row mt-1 mb-4", 4, "ngIf"], ["class", "row m-1 align-items-baseline w-100", 4, "ngIf"], ["class", "w-100", 3, "stateEligibilityCheckDescription", "medicaidIdLabel", "stateEligibilityCheckButtonLabel", "noMedicaidIdErrorLabel", "eligibilityCheckPendingLabel", "eligibilityCheckPendingDescriptionLabel", "isZipValid", "noZipCodeText", "zipCode", "countyFips", "isMedicareEligible", "medicaidId", "medicaidCheckStatus", "isMedicaidEligible", "isDSNPEligible", "medicaidEligibilityLevel", "medicaidCodeText", "medicaidCheckDateReceivedText", "medicaidLastCheckedDate", "medicaidStateSelection", "medicaidCheckDays", "spinnerSizeSmall", "checkMedicaidEligibilityLoading", "medicaidCheckCannotCompleteErrorText", "medicaidClientMessage", "isFederalEligibilityForStateRequired", "isProfileEligibilityCheckDSNPEnabled", "federalEligibilityForStateRequiredText", "stateNotEligibleText", "selectedCountyState", "isMedicaidEligibilityEnabledForSelectedState", "notEligibleText", "genderEnabled", "genderItems", "genderLabel", "defaultGender", "genderRequiredErrorText", "checkMedicaidEligibility", "medicaidDataChanged", 4, "ngIf"], [1, "Spa_Style_H2", "mt-3", "mb-0"], [1, "Spa_Style_Small_Font", "warning-message"], [4, "ngIf", "ngIfElse"], ["clientMessage", ""], ["aria-hidden", "true", 1, "fas", "fa-exclamation-triangle", "mr-2"], [4, "ngIf"], [1, "Spa_Style_Small_Font", "error-container"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle", "mr-2"], [1, "col-lg-4", "col-md-6", "col-12", "button-inside"], [1, "w-100", 3, "for"], ["class", "input-error-asterisk", 4, "ngIf"], [1, "Spa_Style_Label", 3, "ngClass"], ["type", "text", "formControlName", "mbi", 1, "w-100", "input-clear-button", 3, "maxlength", "minlength", "id", "ngClass", "readonly"], ["alwaysUnderlined", "true", 1, "link-position", 3, "title", "click"], [1, "input-error-asterisk"], [1, "col-lg-4", "col-md-6", "col-12"], [1, "w-100"], [3, "defaultValue", "dropdownEnabled", "maxFutureMonths", "maxPastMonths", "monthRange", "yearRange", "monthList", "updateAnswer"], ["memberPartAEffectiveDate", ""], ["memberPartBEffectiveDate", ""], [1, "row", "mt-4", "justify-content-center", "w-100"], ["alwaysUnderlined", "true", 3, "click"], ["link-body", ""], [1, "Spa_Style_Link", "mr-1"], ["aria-hidden", "true", 1, "fa", "pl-1", "Spa_Style_Primary_Link_Color", 3, "ngClass"], [1, "row", "mt-1", "mb-4"], [1, "col-12"], ["id", "extra-help-for-drugs-text", 1, "Spa_Style_H4"], ["id", "extra-help-for-drugs-optional-text", 1, "Spa_Style_Gray4_Color"], [1, "accordion-wrapper", "col-12"], [3, "items", "allowParentValues", "selectedParent", "selectedChild", "emitParentValueWhenNoChildrenSelected", "ariaLabelledById", "largerText", "buttonHeight", "secondaryButtonTextColor", "isMobile", "valueSelected"], [1, "row", "m-1", "align-items-baseline", "w-100"], [1, "d-flex", "flex-column", "align-items-center", "col-xs-12", "col-md-auto", "col-lg-4", "pl-0", 3, "ngClass"], [1, "Spa_Style_SecondaryButton", "d-flex", "justify-content-center", "btn", "w-100", 3, "click", "keyup.enter"], ["loading", ""], ["class", "mt-2 w-100 Spa_Style_Note", 4, "ngIf"], ["class", "col-xs-12 col-lg-3 Spa_Style_Small_Font", 4, "ngIf"], [1, "col-xs-12", "col-lg-5", "Spa_Style_Small_Font"], [3, "size"], [1, "mt-2", "w-100", "Spa_Style_Note"], [1, "col-xs-12", "col-lg-3", "Spa_Style_Small_Font"], ["class", "w-100 completed-check", 4, "ngIf", "ngIfElse"], ["notEligible", ""], [1, "w-100", "completed-check"], [1, "fas", "fa-check-circle", "mr-2"], [1, "w-100", "not-eligible"], [1, "fas", "fa-times-circle", "mr-2"], [1, "completed-check"], ["class", "Spa_Style_Note", 4, "ngIf"], [1, "Spa_Style_Note"], [1, "w-100", 3, "stateEligibilityCheckDescription", "medicaidIdLabel", "stateEligibilityCheckButtonLabel", "noMedicaidIdErrorLabel", "eligibilityCheckPendingLabel", "eligibilityCheckPendingDescriptionLabel", "isZipValid", "noZipCodeText", "zipCode", "countyFips", "isMedicareEligible", "medicaidId", "medicaidCheckStatus", "isMedicaidEligible", "isDSNPEligible", "medicaidEligibilityLevel", "medicaidCodeText", "medicaidCheckDateReceivedText", "medicaidLastCheckedDate", "medicaidStateSelection", "medicaidCheckDays", "spinnerSizeSmall", "checkMedicaidEligibilityLoading", "medicaidCheckCannotCompleteErrorText", "medicaidClientMessage", "isFederalEligibilityForStateRequired", "isProfileEligibilityCheckDSNPEnabled", "federalEligibilityForStateRequiredText", "stateNotEligibleText", "selectedCountyState", "isMedicaidEligibilityEnabledForSelectedState", "notEligibleText", "genderEnabled", "genderItems", "genderLabel", "defaultGender", "genderRequiredErrorText", "checkMedicaidEligibility", "medicaidDataChanged"]], template: function MemberEligibilityCheckComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MemberEligibilityCheckComponent_h2_0_Template, 2, 1, "h2", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "form", 2)(3, "div", 3)(4, "p", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, MemberEligibilityCheckComponent_div_6_Template, 4, 2, "div", 5);
        i0.ɵɵtemplate(7, MemberEligibilityCheckComponent_div_7_Template, 4, 1, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵtemplate(9, MemberEligibilityCheckComponent_div_9_Template, 8, 15, "div", 8);
        i0.ɵɵtemplate(10, MemberEligibilityCheckComponent_div_10_Template, 9, 12, "div", 9);
        i0.ɵɵtemplate(11, MemberEligibilityCheckComponent_div_11_Template, 9, 12, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, MemberEligibilityCheckComponent_div_12_Template, 6, 5, "div", 10);
        i0.ɵɵtemplate(13, MemberEligibilityCheckComponent_div_13_Template, 8, 12, "div", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(14, MemberEligibilityCheckComponent_div_14_Template, 10, 8, "div", 12);
        i0.ɵɵtemplate(15, MemberEligibilityCheckComponent_vnext_widgets_medicaid_eligibility_check_15_Template, 1, 37, "vnext-widgets-medicaid-eligibility-check", 13);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("liveEditProp", "Spa_MemberQuoteHistory_Header_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("formGroup", ctx.memberEligibilityCheck);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.formDescriptionText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.formError || ctx.emptyFields.length > 0 || (ctx.checkEligibilityResponse == null ? null : ctx.checkEligibilityResponse.clientMessage));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.mbiField == null ? null : ctx.mbiField.hasError("pattern")) && (ctx.mbiField == null ? null : ctx.mbiField.touched));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(13, _c6$6, ctx.showSubsidyAccordionOnProfile, !ctx.showSubsidyAccordionOnProfile));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.memberRegistrationMap == null ? null : ctx.memberRegistrationMap[ctx.mbiFieldName] == null ? null : ctx.memberRegistrationMap[ctx.mbiFieldName].display);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.memberRegistrationMap == null ? null : ctx.memberRegistrationMap["partAEffectiveDate"] == null ? null : ctx.memberRegistrationMap["partAEffectiveDate"].display);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.memberRegistrationMap == null ? null : ctx.memberRegistrationMap["partBEffectiveDate"] == null ? null : ctx.memberRegistrationMap["partBEffectiveDate"].display);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showSubsidyAccordionOnProfile);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showSubsidyAccordionOnProfile && ctx.showSubsidyAccordion);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.checkEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isStateEligibilityCheckEnabled);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.MinLengthValidator, i4.MaxLengthValidator, i4.FormGroupDirective, i4.FormControlName, LinkComponent, SpinnerComponent, LiveEditPropDirective, IconAriaAttributesDirective, MedicaidEligibilityCheckComponent, AccordionComponent, MemberEffectiveDateComponent, i1$2.DatePipe], styles: [".member-eligibility-check-container[_ngcontent-%COMP%]{padding:10px 18px 10px 10px;position:relative;margin-top:10px;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;border:1px solid var(--static-Spa_Style_Accent1);border-radius:4px;background-clip:border-box}.contain-wrapper[_ngcontent-%COMP%]{width:100%}.link-position[_ngcontent-%COMP%]{position:absolute;border-radius:5px;right:20px;margin-top:6px;margin-right:3px;z-index:2;border:none;height:30px;cursor:pointer;color:#fff;transform:translate(2px)}.warning-message[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Warn_on_Blue)}.warning-message[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Warn_Darker)}.not-eligible[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Gray4)}.show-mbi-as-password[_ngcontent-%COMP%]{-webkit-text-security:disc}.completed-check[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text)}.check-error[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent2)}@-moz-document url-prefix(){.show-mbi-as-password{font-family:text-security-disc;font-size:1.5rem;padding-top:10px!important}}i[_ngcontent-%COMP%]{cursor:pointer}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){.show-mbi-as-password[_ngcontent-%COMP%]{font-family:text-security-disc;font-size:1.2rem;padding-top:12px!important}}"], changeDetection: 0 });
__decorate([
    Memoize()
], MemberEligibilityCheckComponent.prototype, "isMedicaidEligibilityStatus", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberEligibilityCheckComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widgets-member-eligiblity-check', changeDetection: ChangeDetectionStrategy.OnPush, template: "<h2 *liveEditProp=\"'Spa_MemberQuoteHistory_Header_Text'\" class=\"Spa_Style_H2 mt-3 mb-0\">{{ headerText }}</h2>\r\n<div class=\"member-eligibility-check-container mb-1 align-items-baseline\">\r\n  <form class=\"contain-wrapper\" [formGroup]=\"memberEligibilityCheck\">\r\n    <div class=\"mt-1\">\r\n      <p class=\"Spa_Style_Regular_Font\">{{ formDescriptionText }}</p>\r\n\r\n      <div\r\n        *ngIf=\"formError || emptyFields.length > 0 || checkEligibilityResponse?.clientMessage\"\r\n        class=\"Spa_Style_Small_Font warning-message\"\r\n      >\r\n        <ng-container *ngIf=\"(formError || emptyFields.length > 0); else clientMessage\">\r\n          <i class=\"fas fa-exclamation-triangle mr-2\" aria-hidden=\"true\"></i\r\n          ><span>\r\n            {{ formError ? errorKeywordText : emptyFields + ' ' + requiredFieldError }}\r\n          </span>\r\n        </ng-container>\r\n        <ng-template #clientMessage>\r\n          <ng-container *ngIf=\"checkEligibilityResponse.clientMessage\">\r\n            <i class=\"fas fa-exclamation-triangle mr-2\" aria-hidden=\"true\"></i>\r\n            <span>\r\n              {{ checkEligibilityResponse.clientMessage }}\r\n            </span>\r\n          </ng-container>\r\n        </ng-template>\r\n      </div>\r\n      \r\n      <div *ngIf=\"mbiField?.hasError('pattern') && mbiField?.touched\" class=\"Spa_Style_Small_Font error-container\">\r\n        <i class=\"fas fa-exclamation-circle mr-2\" aria-hidden=\"true\"></i\r\n        ><span>\r\n          {{ mbiValidErrorText }}\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <div\r\n      class=\"row mt-2 align-items-baseline\"\r\n      [ngClass]=\"{ 'mb-1': showSubsidyAccordionOnProfile, 'mb-4': !showSubsidyAccordionOnProfile }\"\r\n    >\r\n      <div *ngIf=\"memberRegistrationMap?.[mbiFieldName]?.display\" class=\"col-lg-4 col-md-6 col-12 button-inside\">\r\n        <label [for]=\"mbiFieldName\" class=\"w-100\">\r\n          <span *ngIf=\"memberRegistrationMap[mbiFieldName].required\" class=\"input-error-asterisk\">*</span>\r\n          <label class=\"Spa_Style_Label\" [ngClass]=\"{ 'readonly Spa_Style_Gray4_Color': isReadOnly }\">\r\n            <span>{{ memberRegistrationMap[mbiFieldName]?.labelText }} </span>\r\n          </label>\r\n          <input\r\n            type=\"text\"\r\n            class=\"w-100 input-clear-button\"\r\n            formControlName=\"mbi\"\r\n            maxlength=\"{{ mbiValidLength }}\"\r\n            minlength=\"{{ mbiValidLength }}\"\r\n            [id]=\"mbiFieldName\"\r\n            [ngClass]=\"{\r\n              'Spa_Style_Gray4_Color readonly': isReadOnly,\r\n              'show-mbi-as-password': !showMedicareNumber\r\n            }\"\r\n            [readonly]=\"isReadOnly\"\r\n          />\r\n          <vnext-link\r\n            class=\"link-position\"\r\n            [title]=\"showMedicareNumber ? hideText : showText\"\r\n            alwaysUnderlined=\"true\"\r\n            (click)=\"toggleMedicareNumber()\"\r\n          >\r\n          </vnext-link>\r\n        </label>\r\n      </div>\r\n      <div *ngIf=\"memberRegistrationMap?.['partAEffectiveDate']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n        <label class=\"w-100\">\r\n          <label class=\"Spa_Style_Label\" [ngClass]=\"{ 'readonly Spa_Style_Gray4_Color': isReadOnly }\">\r\n            <span *ngIf=\"memberRegistrationMap['partAEffectiveDate'].required\" class=\"input-error-asterisk\">*</span>\r\n            <span>{{ memberRegistrationMap['partAEffectiveDate'].labelText }} </span>\r\n          </label>\r\n          <div>\r\n            <vnext-member-effective-date\r\n              #memberPartAEffectiveDate\r\n              [defaultValue]=\"partAEffectiveDate\"\r\n              (updateAnswer)=\"updateEffectiveDate($event, 'partAEffectiveDate')\"\r\n              [dropdownEnabled]=\"dropdownPartAEnabled\"\r\n              [maxFutureMonths]=\"effectiveDatePartAMaxFutureMonths\"\r\n              [maxPastMonths]=\"effectiveDatePartAMaxPastMonths\"\r\n              [monthRange]=\"effectiveDatePartAMonthRange\"\r\n              [yearRange]=\"effectiveDatePartAYearRange\"\r\n              [monthList]=\"effectiveDateMonthList\"\r\n            >\r\n            </vnext-member-effective-date>\r\n          </div>\r\n        </label>\r\n      </div>\r\n      <div *ngIf=\"memberRegistrationMap?.['partBEffectiveDate']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n        <label class=\"w-100\">\r\n          <label class=\"Spa_Style_Label\" [ngClass]=\"{ 'readonly Spa_Style_Gray4_Color': isReadOnly }\">\r\n            <span *ngIf=\"memberRegistrationMap['partBEffectiveDate'].required\" class=\"input-error-asterisk\">*</span>\r\n            <span>{{ memberRegistrationMap['partBEffectiveDate'].labelText }} </span>\r\n          </label>\r\n          <div>\r\n            <vnext-member-effective-date\r\n              #memberPartBEffectiveDate\r\n              [defaultValue]=\"partBEffectiveDate\"\r\n              (updateAnswer)=\"updateEffectiveDate($event, 'partBEffectiveDate')\"\r\n              [dropdownEnabled]=\"dropdownPartBEnabled\"\r\n              [maxFutureMonths]=\"effectiveDatePartBMaxFutureMonths\"\r\n              [maxPastMonths]=\"effectiveDatePartBMaxPastMonths\"\r\n              [monthRange]=\"effectiveDatePartBMonthRange\"\r\n              [yearRange]=\"effectiveDatePartBYearRange\"\r\n              [monthList]=\"effectiveDateMonthList\"\r\n            >\r\n            </vnext-member-effective-date>\r\n          </div>\r\n        </label>\r\n      </div>\r\n    </div>\r\n    <div *ngIf=\"showSubsidyAccordionOnProfile\" class=\"row mt-4 justify-content-center w-100\">\r\n      <vnext-link alwaysUnderlined=\"true\" (click)=\"toggleSubsidyAccordion()\">\r\n        <div link-body>\r\n          <span class=\"Spa_Style_Link mr-1\">{{ openSubsidyText }}</span>\r\n          <i\r\n            class=\"fa pl-1 Spa_Style_Primary_Link_Color\"\r\n            aria-hidden=\"true\"\r\n            [ngClass]=\"{ 'fa-angle-up': showSubsidyAccordion, 'fa-angle-down': !showSubsidyAccordion }\"\r\n          ></i>\r\n        </div>\r\n      </vnext-link>\r\n    </div>\r\n    <div *ngIf=\"showSubsidyAccordionOnProfile && showSubsidyAccordion\" class=\"row mt-1 mb-4\">\r\n      <p class=\"col-12\">\r\n        <span class=\"Spa_Style_H4\" id=\"extra-help-for-drugs-text\">{{ accordionHeaderText }}</span>\r\n        <span class=\"Spa_Style_Gray4_Color\" id=\"extra-help-for-drugs-optional-text\"> {{ optionalLabel }} </span>\r\n      </p>\r\n      <div class=\"accordion-wrapper col-12\">\r\n        <vnext-accordion\r\n          [items]=\"subsidyAccordionItems\"\r\n          [allowParentValues]=\"true\"\r\n          [selectedParent]=\"selectedParentId\"\r\n          [selectedChild]=\"selectedChildId\"\r\n          [emitParentValueWhenNoChildrenSelected]=\"true\"\r\n          [ariaLabelledById]=\"'extra-help-for-drugs-text extra-help-for-drugs-optional-text'\"\r\n          [largerText]=\"true\"\r\n          [buttonHeight]=\"'36px'\"\r\n          [secondaryButtonTextColor]=\"secondaryButtonTextColor\"\r\n          [isMobile]=\"isMobile\"\r\n          (valueSelected)=\"setSubsidyValue($event)\"\r\n        ></vnext-accordion>\r\n      </div>\r\n    </div>\r\n  </form>\r\n  <div class=\"row m-1 align-items-baseline w-100\" *ngIf=\"checkEnabled\">\r\n    <div class=\"d-flex flex-column align-items-center col-xs-12 col-md-auto col-lg-4 pl-0\" [ngClass]=\"{ 'pr-0': isMobile }\">\r\n      <button\r\n        class=\"Spa_Style_SecondaryButton d-flex justify-content-center btn w-100\"\r\n        (click)=\"checkMemberEligibility()\"\r\n        (keyup.enter)=\"checkMemberEligibility()\"\r\n      >\r\n        <span *ngIf=\"!checkEligibilityLoading; else loading\">{{ profileEligibilityButtonText }}</span>\r\n        <ng-template #loading>\r\n          <vnext-spinner [size]=\"spinnerSizeSmall\"></vnext-spinner>\r\n        </ng-template>\r\n      </button>\r\n      <div class=\"mt-2 w-100 Spa_Style_Note\" *ngIf=\"lastCheckedDate\">\r\n        {{ lastCheckedDateText }} {{ lastCheckedDate | date : 'MM/dd/yyyy' }}\r\n      </div>\r\n    </div>\r\n    <div\r\n      class=\"col-xs-12 col-lg-3 Spa_Style_Small_Font\"\r\n      *ngIf=\"(memberEligibilityCheckPerformed || lastCheckedDate) && !checkEligibilityLoading\"\r\n    >\r\n      <div *ngIf=\"checkEligibilityResponse?.isMedicareEligible; else notEligible\" class=\"w-100 completed-check\">\r\n        <i class=\"fas fa-check-circle mr-2\"></i>\r\n        <span>{{ medicareEligibleText }}</span>\r\n      </div>\r\n      <ng-template #notEligible>\r\n        <div class=\"w-100 not-eligible\">\r\n          <i class=\"fas fa-times-circle mr-2\"></i>\r\n          <span>{{ checkEligibilityResponse?.isError ? requestErrorText : notEligibleText }}</span>\r\n        </div>\r\n      </ng-template>\r\n    </div>\r\n    <div class=\"col-xs-12 col-lg-5 Spa_Style_Small_Font\">\r\n      <div *ngIf=\"checkEligibilityResponse?.isDSNPEligible && eligibilityCheckProfileData?.includeDSNPCheck\">\r\n        <div class=\"completed-check\">\r\n          <i class=\"fas fa-check-circle mr-2\"></i>\r\n          <span>{{ dsnpText }}</span>\r\n        </div>\r\n        <div *ngIf=\"subsidyUpdated && pastSelectionTitle\" class=\"Spa_Style_Note\">{{ dsnpChangedFromText }} \"{{ pastSelectionTitle }}\"</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <vnext-widgets-medicaid-eligibility-check\r\n    *ngIf=\"isStateEligibilityCheckEnabled\"\r\n    class=\"w-100\"\r\n    [stateEligibilityCheckDescription]=\"stateEligibilityCheckDescription\"\r\n    [medicaidIdLabel]=\"medicaidIdLabel\"\r\n    [stateEligibilityCheckButtonLabel]=\"stateEligibilityCheckButtonLabel\"\r\n    [noMedicaidIdErrorLabel]=\"noMedicaidIdErrorLabel\"\r\n    [eligibilityCheckPendingLabel]=\"eligibilityCheckPendingLabel\"\r\n    [eligibilityCheckPendingDescriptionLabel]=\"eligibilityCheckPendingDescriptionLabel\"\r\n    [isZipValid]=\"isZipValid\"\r\n    [noZipCodeText]=\"noZipCodeText\"\r\n    [zipCode]=\"zipCode\"\r\n    [countyFips]=\"countyFips\"\r\n    [isMedicareEligible]=\"checkEligibilityResponse?.isMedicareEligible\"\r\n    [medicaidId]=\"medicaidId\"\r\n    [medicaidCheckStatus]=\"medicaidCheckStatus\"\r\n    [isMedicaidEligible]=\"isMedicaidEligible\"\r\n    [isDSNPEligible]=\"isDSNPEligible\"\r\n    [medicaidEligibilityLevel]=\"medicaidEligibilityLevel\"\r\n    [medicaidCodeText]=\"medicaidCodeText\"\r\n    [medicaidCheckDateReceivedText]=\"medicaidCheckDateReceivedText\"\r\n    [medicaidLastCheckedDate]=\"medicaidLastCheckedDate\"\r\n    [medicaidStateSelection]=\"medicaidStateSelection\"\r\n    [medicaidCheckDays]=\"medicaidCheckDays\"\r\n    [spinnerSizeSmall]=\"spinnerSizeSmall\"\r\n    [checkMedicaidEligibilityLoading]=\"checkMedicaidEligibilityLoading\"\r\n    [medicaidCheckCannotCompleteErrorText]=\"medicaidCheckCannotCompleteErrorText\"\r\n    [medicaidClientMessage]=\"medicaidClientMessage\"\r\n    [isFederalEligibilityForStateRequired]=\"isFederalEligibilityForStateRequired\"\r\n    [isProfileEligibilityCheckDSNPEnabled]=\"isProfileEligibilityCheckDSNPEnabled\"\r\n    [federalEligibilityForStateRequiredText]=\"federalEligibilityForStateRequiredText\"\r\n    [stateNotEligibleText]=\"stateNotEligibleText\"\r\n    [selectedCountyState]=\"selectedCountyState\"\r\n    [isMedicaidEligibilityEnabledForSelectedState]=\"isMedicaidEligibilityEnabledForSelectedState\"\r\n    [notEligibleText]=\"notEligibleText\"\r\n    [genderEnabled]=\"genderEnabled\"\r\n    [genderItems]=\"genderItems\"\r\n    [genderLabel]=\"genderLabel\"\r\n    [defaultGender]=\"defaultGender\"\r\n    [genderRequiredErrorText]=\"genderRequiredErrorText\"\r\n    (checkMedicaidEligibility)=\"checkMedicaidEligibility($event)\"\r\n    (medicaidDataChanged)=\"msiDataChanged.emit($event)\"\r\n  ></vnext-widgets-medicaid-eligibility-check>\r\n</div>\r\n", styles: [".member-eligibility-check-container{padding:10px 18px 10px 10px;position:relative;margin-top:10px;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;border:1px solid var(--static-Spa_Style_Accent1);border-radius:4px;background-clip:border-box}.contain-wrapper{width:100%}.link-position{position:absolute;border-radius:5px;right:20px;margin-top:6px;margin-right:3px;z-index:2;border:none;height:30px;cursor:pointer;color:#fff;transform:translate(2px)}.warning-message{color:var(--static-Spa_Style_Warn_on_Blue)}.warning-message i{color:var(--static-Spa_Style_Warn_Darker)}.not-eligible{color:var(--static-Spa_Style_Gray4)}.show-mbi-as-password{-webkit-text-security:disc}.completed-check{color:var(--static-Spa_Style_Cost_Text)}.check-error{color:var(--static-Spa_Style_Accent2)}@-moz-document url-prefix(){.show-mbi-as-password{font-family:text-security-disc;font-size:1.5rem;padding-top:10px!important}}i{cursor:pointer}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){.show-mbi-as-password{font-family:text-security-disc;font-size:1.2rem;padding-top:12px!important}}\n"] }]
    }], function () { return [{ type: PlanFacade }, { type: i1.LocaleService }, { type: i0.ChangeDetectorRef }, { type: i1.ProfileCryptoService }, { type: MemberEligibilityCheckFacade }, { type: i1.SSOPopulatedFieldService }, { type: i1.MemberSessionService }, { type: i1.DemographicService }, { type: ProfileFacade }, { type: i1.ProfileService }, { type: MemberRegistrationService }, { type: i1.ResponsiveLayoutService }, { type: i1.SNPService }, { type: i1.AgentService }]; }, { memberPartAEffectiveDate: [{
            type: ViewChild,
            args: ['memberPartAEffectiveDate']
        }], memberPartBEffectiveDate: [{
            type: ViewChild,
            args: ['memberPartBEffectiveDate']
        }], checkEnabled: [{
            type: Input
        }], iconColor: [{
            type: Input
        }], mbiRegexPattern: [{
            type: Input
        }], showMedicareNumber: [{
            type: Input
        }], mbiError: [{
            type: Input
        }], hideText: [{
            type: Input
        }], showText: [{
            type: Input
        }], dropdownPartAEnabled: [{
            type: Input
        }], dropdownPartBEnabled: [{
            type: Input
        }], medicareEligibleText: [{
            type: Input
        }], dsnpText: [{
            type: Input
        }], dsnpUpdatedText: [{
            type: Input
        }], dsnpChangedFromText: [{
            type: Input
        }], headerText: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], formDescriptionText: [{
            type: Input
        }], accordionHeaderText: [{
            type: Input
        }], mbiFieldName: [{
            type: Input
        }], profileEligibilityButtonText: [{
            type: Input
        }], openSubsidyText: [{
            type: Input
        }], effectiveDatePartAMaxFutureMonths: [{
            type: Input
        }], effectiveDatePartAMaxPastMonths: [{
            type: Input
        }], effectiveDatePartBMaxFutureMonths: [{
            type: Input
        }], effectiveDatePartBMaxPastMonths: [{
            type: Input
        }], mbiValidLength: [{
            type: Input
        }], effectiveDateMonthList: [{
            type: Input
        }], effectiveDatePartAMonthRange: [{
            type: Input
        }], effectiveDatePartAYearRange: [{
            type: Input
        }], effectiveDatePartBMonthRange: [{
            type: Input
        }], effectiveDatePartBYearRange: [{
            type: Input
        }], memberRegistrationResources: [{
            type: Input
        }], showSubsidyAccordionOnProfile: [{
            type: Input
        }], isMedicareEligible: [{
            type: Input
        }], isDSNPEligible: [{
            type: Input
        }], lastCheckedDate: [{
            type: Input
        }], hicn: [{
            type: Input
        }], subsidySelected: [{
            type: Input
        }], subsidyPercent: [{
            type: Input
        }], partAEffectiveDate: [{
            type: Input
        }], partBEffectiveDate: [{
            type: Input
        }], memberRegistrationMap: [{
            type: Input
        }], eligibilityCheckProfileData: [{
            type: Input
        }], isPartAandBEffDateValidationEnabled: [{
            type: Input
        }], lastCheckedDateText: [{
            type: Input
        }], notEligibleText: [{
            type: Input
        }], requestErrorText: [{
            type: Input
        }], requiredFieldError: [{
            type: Input
        }], countyFips: [{
            type: Input
        }], isStateEligibilityCheckEnabled: [{
            type: Input
        }], stateEligibilityCheckDescription: [{
            type: Input
        }], medicaidIdLabel: [{
            type: Input
        }], stateEligibilityCheckButtonLabel: [{
            type: Input
        }], noMedicaidIdErrorLabel: [{
            type: Input
        }], eligibilityCheckPendingLabel: [{
            type: Input
        }], eligibilityCheckPendingDescriptionLabel: [{
            type: Input
        }], isZipValid: [{
            type: Input
        }], noZipCodeText: [{
            type: Input
        }], zipCode: [{
            type: Input
        }], medicaidId: [{
            type: Input
        }], medicaidCheckStatus: [{
            type: Input
        }], isMedicaidEligible: [{
            type: Input
        }], medicaidEligibilityLevel: [{
            type: Input
        }], medicaidLastCheckedDate: [{
            type: Input
        }], medicaidStateSelection: [{
            type: Input
        }], medicaidClientMessage: [{
            type: Input
        }], medicaidCodeText: [{
            type: Input
        }], medicaidCheckDateReceivedText: [{
            type: Input
        }], medicaidCheckDays: [{
            type: Input
        }], medicaidCheckCannotCompleteErrorText: [{
            type: Input
        }], medicaidCheckedNoteText: [{
            type: Input
        }], isFederalEligibilityForStateRequired: [{
            type: Input
        }], isProfileEligibilityCheckDSNPEnabled: [{
            type: Input
        }], federalEligibilityForStateRequiredText: [{
            type: Input
        }], stateNotEligibleText: [{
            type: Input
        }], medicaidIntegrationConfig: [{
            type: Input
        }], optionalLabel: [{
            type: Input
        }], genderEnabled: [{
            type: Input
        }], genderItems: [{
            type: Input
        }], genderLabel: [{
            type: Input
        }], defaultGender: [{
            type: Input
        }], genderRequiredErrorText: [{
            type: Input
        }], mbiValidErrorText: [{
            type: Input
        }], msiDataChanged: [{
            type: Output
        }], subsidyIdChanged: [{
            type: Output
        }], isMedicaidEligibilityStatus: [] }); })();

function MemberQuoteCardComponent_h3_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.quoteSentText, " ");
} }
function MemberQuoteCardComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelement(1, "vnext-plan-year-badge", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("planYear", ctx_r1.planYear);
} }
function MemberQuoteCardComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "span", 14);
    i0.ɵɵtext(2, "-");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 15);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2("", ctx_r2.sendingAgentData == null ? null : ctx_r2.sendingAgentData.data == null ? null : ctx_r2.sendingAgentData.data.firstName, " ", ctx_r2.sendingAgentData == null ? null : ctx_r2.sendingAgentData.data == null ? null : ctx_r2.sendingAgentData.data.lastName, "");
} }
function MemberQuoteCardComponent_div_6_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "span", 15);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const quotedPlan_r12 = ctx.$implicit;
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r11.memberQuoteHistoryCarrierNameEnabled ? quotedPlan_r12.carrierName + " - " : "", " ", quotedPlan_r12.planName, " ");
} }
function MemberQuoteCardComponent_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, MemberQuoteCardComponent_div_6_div_1_div_1_Template, 3, 2, "div", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r10.memberQuotePlanInfo);
} }
function MemberQuoteCardComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, MemberQuoteCardComponent_div_6_div_1_Template, 2, 1, "div", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.memberQuoteHistoryPlanNameEnabled);
} }
function MemberQuoteCardComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r4.planTypeHeader, " ", ctx_r4.planType, " ");
} }
function MemberQuoteCardComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.getRequestedEffectiveDate(), " ");
} }
function MemberQuoteCardComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r6.memberQuoteAuthorizationCodeText, " ", ctx_r6.memberQuoteAuthorizationCode, " ");
} }
function MemberQuoteCardComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.memberQuoteMessageText, " ");
} }
function MemberQuoteCardComponent_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r8.memberQuoteAgentFirstName, " ", ctx_r8.memberQuoteAgentLastName, " ");
} }
function MemberQuoteCardComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.memberQuoteAgentUserName, " ");
} }
class MemberQuoteCardComponent {
    constructor(phoneUtilityService, planYearService) {
        this.phoneUtilityService = phoneUtilityService;
        this.planYearService = planYearService;
        this.displayPlanYearBadge = false;
        this.quoteSentText = '';
    }
    ngOnInit() {
        this.setQuoteSentText();
        this.displayPlanYearBadge =
            this.showPlanYearBadge &&
                !!this.planYear?.length &&
                this.planYearService.showEnrollmentPlanYearBadgeByPlanTypeAbbreviation(this.planType);
    }
    setQuoteSentText() {
        let separator = '';
        this.quoteSentText = `${this.memberQuoteSentText} ${this.formatDate(this.memberQuoteSentDate, true)}`;
        if (!!this.memberQuoteDeliveryMethod) {
            const deliveryMethod = JSON.parse(this.memberQuoteDeliveryMethod);
            this.quoteSentText += ` ${this.deliveryMethodPrefix} `;
            if (!!deliveryMethod.Email) {
                this.quoteSentText += deliveryMethod.Email;
                separator = `${this.deliveryMethodSeparator} `;
            }
            if (!!deliveryMethod.Phone) {
                this.quoteSentText += separator + this.phoneUtilityService.getNationalPhoneNumber(deliveryMethod.Phone);
            }
        }
    }
    getRequestedEffectiveDate() {
        return `${this.requestedEffectiveDateHeader}: ${this.formatDate(this.memberQuoteEffectiveDate, false)}`;
    }
    formatDate(date, includeTime) {
        const format = includeTime ? DateUtilities.dateTimeFormat : DateUtilities.defaultFormat;
        // Need to convert to Pacific Time (PT) even though API data is in PT, because date includes timezone identifier (-7 or -8:00) and new Date() will convert to next day if after 9PM for east coast users
        const formattedDate = date ? DateUtilities.getFormattedPTDate(new Date(date), format) : '';
        return includeTime ? formattedDate + ` ${this.pacificTimePostFix}` : formattedDate;
    }
}
MemberQuoteCardComponent.ɵfac = function MemberQuoteCardComponent_Factory(t) { return new (t || MemberQuoteCardComponent)(i0.ɵɵdirectiveInject(i1.PhoneUtilityService), i0.ɵɵdirectiveInject(i1.PlanYearService)); };
MemberQuoteCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MemberQuoteCardComponent, selectors: [["vnext-member-quote-card"]], inputs: { memberQuoteAgentFirstName: "memberQuoteAgentFirstName", memberQuoteAgentLastName: "memberQuoteAgentLastName", memberQuoteAgentUserName: "memberQuoteAgentUserName", memberQuoteEffectiveDate: "memberQuoteEffectiveDate", memberQuoteSentDate: "memberQuoteSentDate", memberQuoteAuthorizationCodeText: "memberQuoteAuthorizationCodeText", memberQuoteAuthorizationCode: "memberQuoteAuthorizationCode", memberQuoteSentText: "memberQuoteSentText", memberQuoteMessageText: "memberQuoteMessageText", memberQuoteDeliveryMethod: "memberQuoteDeliveryMethod", deliveryMethodPrefix: "deliveryMethodPrefix", deliveryMethodSeparator: "deliveryMethodSeparator", planTypeHeader: "planTypeHeader", planIds: "planIds", requestedEffectiveDateHeader: "requestedEffectiveDateHeader", isMedigap: "isMedigap", pacificTimePostFix: "pacificTimePostFix", displayQuoteSentInformation: "displayQuoteSentInformation", displayPlanType: "displayPlanType", planType: "planType", displayRequestedEffectiveDate: "displayRequestedEffectiveDate", displayAuthCode: "displayAuthCode", displayPersonalizedMessage: "displayPersonalizedMessage", displayAgentUserName: "displayAgentUserName", displayAgentFullName: "displayAgentFullName", memberQuotePlanInfo: "memberQuotePlanInfo", memberQuoteHistoryPlanNameEnabled: "memberQuoteHistoryPlanNameEnabled", memberQuoteHistoryCarrierNameEnabled: "memberQuoteHistoryCarrierNameEnabled", showPlanYearBadge: "showPlanYearBadge", planYear: "planYear", sendQuoteAgentOfRecordEnabled: "sendQuoteAgentOfRecordEnabled", sendingAgentData: "sendingAgentData" }, decls: 15, vars: 10, consts: [[1, "member-quote-card-container"], [1, "row", "no-gutters"], ["class", "Spa_Style_H3 col col-sm-11 mt-4 mt-sm-0", 4, "ngIf"], ["class", "quote-plan-year-badge", 4, "ngIf"], [1, "row"], ["class", "col-sm-12 pt-1 Spa_Style_Paragraph", 4, "ngIf"], ["class", "col-sm-12 pt-2 mb-4", 4, "ngIf"], [1, "col-sm-5"], [4, "ngIf"], [1, "col-sm-7"], [1, "Spa_Style_H3", "col", "col-sm-11", "mt-4", "mt-sm-0"], [1, "quote-plan-year-badge"], [3, "planYear"], [1, "col-sm-12", "pt-1", "Spa_Style_Paragraph"], [1, "mr-1"], [1, "no-translate-block"], [1, "col-sm-12", "pt-2", "mb-4"], ["class", "quote-plan-detail-container pb-4", 4, "ngIf"], [1, "quote-plan-detail-container", "pb-4"], ["class", "pt-2", 4, "ngFor", "ngForOf"], [1, "pt-2"]], template: function MemberQuoteCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, MemberQuoteCardComponent_h3_2_Template, 2, 1, "h3", 2);
        i0.ɵɵtemplate(3, MemberQuoteCardComponent_div_3_Template, 2, 1, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtemplate(5, MemberQuoteCardComponent_div_5_Template, 5, 2, "div", 5);
        i0.ɵɵtemplate(6, MemberQuoteCardComponent_div_6_Template, 2, 1, "div", 6);
        i0.ɵɵelementStart(7, "div", 7);
        i0.ɵɵtemplate(8, MemberQuoteCardComponent_ng_container_8_Template, 3, 2, "ng-container", 8);
        i0.ɵɵtemplate(9, MemberQuoteCardComponent_ng_container_9_Template, 3, 1, "ng-container", 8);
        i0.ɵɵtemplate(10, MemberQuoteCardComponent_ng_container_10_Template, 2, 2, "ng-container", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 9);
        i0.ɵɵtemplate(12, MemberQuoteCardComponent_ng_container_12_Template, 3, 1, "ng-container", 8);
        i0.ɵɵtemplate(13, MemberQuoteCardComponent_ng_container_13_Template, 3, 2, "ng-container", 8);
        i0.ɵɵtemplate(14, MemberQuoteCardComponent_ng_container_14_Template, 2, 1, "ng-container", 8);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.displayQuoteSentInformation);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.displayPlanYearBadge);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.sendQuoteAgentOfRecordEnabled && (ctx.sendingAgentData == null ? null : ctx.sendingAgentData.data));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.memberQuoteHistoryCarrierNameEnabled || ctx.memberQuoteHistoryPlanNameEnabled) && (ctx.memberQuotePlanInfo == null ? null : ctx.memberQuotePlanInfo.length));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.displayPlanType);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isMedigap && ctx.displayRequestedEffectiveDate);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.displayAuthCode);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.displayPersonalizedMessage);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.displayAgentFullName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.displayAgentUserName);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, PlanYearBadgeComponent], styles: [".member-quote-card-container[_ngcontent-%COMP%]{padding:18px;position:relative;margin-top:10px;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;border:1px solid var(--static-Spa_Style_Accent1);border-radius:4px;background-clip:border-box}.quote-plan-detail-container[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.quote-plan-year-badge[_ngcontent-%COMP%]{margin-left:auto}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberQuoteCardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-member-quote-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"member-quote-card-container\">\r\n  <div class=\"row no-gutters\">\r\n    <h3 *ngIf=\"displayQuoteSentInformation\" class=\"Spa_Style_H3 col col-sm-11 mt-4 mt-sm-0\">\r\n      {{ quoteSentText }}\r\n    </h3>\r\n    <div *ngIf=\"displayPlanYearBadge\" class=\"quote-plan-year-badge\">\r\n      <vnext-plan-year-badge [planYear]=\"planYear\"> </vnext-plan-year-badge>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div *ngIf=\"sendQuoteAgentOfRecordEnabled && sendingAgentData?.data\" class=\"col-sm-12 pt-1 Spa_Style_Paragraph\">\r\n      <span class=\"mr-1\">-</span><span class=\"no-translate-block\">{{ sendingAgentData?.data?.firstName }} {{ sendingAgentData?.data?.lastName }}</span>\r\n    </div>\r\n    <div\r\n      class=\"col-sm-12 pt-2 mb-4\"\r\n      *ngIf=\"(memberQuoteHistoryCarrierNameEnabled || memberQuoteHistoryPlanNameEnabled) && memberQuotePlanInfo?.length\"\r\n    >\r\n      <div  *ngIf=\"memberQuoteHistoryPlanNameEnabled\" class=\"quote-plan-detail-container pb-4\">\r\n        <div *ngFor=\"let quotedPlan of memberQuotePlanInfo\" class=\"pt-2\">\r\n          <span class=\"no-translate-block\">{{ memberQuoteHistoryCarrierNameEnabled ? quotedPlan.carrierName + ' - ' : '' }} {{ quotedPlan.planName }} </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-5\">\r\n      <ng-container *ngIf=\"displayPlanType\">\r\n        {{ planTypeHeader }} {{ planType }}\r\n        <br />\r\n      </ng-container>\r\n      <ng-container *ngIf=\"isMedigap && displayRequestedEffectiveDate\">\r\n        {{ getRequestedEffectiveDate() }}\r\n        <br />\r\n      </ng-container>\r\n      <ng-container *ngIf=\"displayAuthCode\"> {{ memberQuoteAuthorizationCodeText }} {{ memberQuoteAuthorizationCode }} </ng-container>\r\n    </div>\r\n    <div class=\"col-sm-7\">\r\n      <ng-container *ngIf=\"displayPersonalizedMessage\">\r\n        {{ memberQuoteMessageText }}\r\n        <br />\r\n      </ng-container>\r\n      <ng-container *ngIf=\"displayAgentFullName\">\r\n        {{ memberQuoteAgentFirstName }} {{ memberQuoteAgentLastName }}\r\n        <br />\r\n      </ng-container>\r\n      <ng-container *ngIf=\"displayAgentUserName\">\r\n        {{ memberQuoteAgentUserName }}\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".member-quote-card-container{padding:18px;position:relative;margin-top:10px;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;border:1px solid var(--static-Spa_Style_Accent1);border-radius:4px;background-clip:border-box}.quote-plan-detail-container{border-bottom:1px solid var(--static-Spa_Style_Gray2)}.quote-plan-year-badge{margin-left:auto}\n"] }]
    }], function () { return [{ type: i1.PhoneUtilityService }, { type: i1.PlanYearService }]; }, { memberQuoteAgentFirstName: [{
            type: Input
        }], memberQuoteAgentLastName: [{
            type: Input
        }], memberQuoteAgentUserName: [{
            type: Input
        }], memberQuoteEffectiveDate: [{
            type: Input
        }], memberQuoteSentDate: [{
            type: Input
        }], memberQuoteAuthorizationCodeText: [{
            type: Input
        }], memberQuoteAuthorizationCode: [{
            type: Input
        }], memberQuoteSentText: [{
            type: Input
        }], memberQuoteMessageText: [{
            type: Input
        }], memberQuoteDeliveryMethod: [{
            type: Input
        }], deliveryMethodPrefix: [{
            type: Input
        }], deliveryMethodSeparator: [{
            type: Input
        }], planTypeHeader: [{
            type: Input
        }], planIds: [{
            type: Input
        }], requestedEffectiveDateHeader: [{
            type: Input
        }], isMedigap: [{
            type: Input
        }], pacificTimePostFix: [{
            type: Input
        }], displayQuoteSentInformation: [{
            type: Input
        }], displayPlanType: [{
            type: Input
        }], planType: [{
            type: Input
        }], displayRequestedEffectiveDate: [{
            type: Input
        }], displayAuthCode: [{
            type: Input
        }], displayPersonalizedMessage: [{
            type: Input
        }], displayAgentUserName: [{
            type: Input
        }], displayAgentFullName: [{
            type: Input
        }], memberQuotePlanInfo: [{
            type: Input
        }], memberQuoteHistoryPlanNameEnabled: [{
            type: Input
        }], memberQuoteHistoryCarrierNameEnabled: [{
            type: Input
        }], showPlanYearBadge: [{
            type: Input
        }], planYear: [{
            type: Input
        }], sendQuoteAgentOfRecordEnabled: [{
            type: Input
        }], sendingAgentData: [{
            type: Input
        }] }); })();

function MemberQuoteHistoryComponent_h2_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.memberQuoteHistoryHeaderText, " ");
} }
function MemberQuoteHistoryComponent_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-member-quote-card", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const quote_r5 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("memberQuoteAgentFirstName", quote_r5.fName)("memberQuoteAgentLastName", quote_r5.lName)("memberQuoteAgentUserName", quote_r5.username)("memberQuoteEffectiveDate", quote_r5.effectiveDate)("memberQuotePlanInfo", quote_r5.quotedPlanInfo)("memberQuoteHistoryPlanNameEnabled", ctx_r4.memberQuoteHistoryPlanNameEnabled)("memberQuoteHistoryCarrierNameEnabled", ctx_r4.memberQuoteHistoryCarrierNameEnabled)("memberQuoteSentDate", quote_r5.sentDate)("memberQuoteAuthorizationCodeText", ctx_r4.memberQuoteHistoryAuthorizationEmailBodyText)("memberQuoteAuthorizationCode", quote_r5.authCode)("memberQuoteSentText", ctx_r4.memberQuoteHistoryQuoteSentText)("memberQuoteMessageText", quote_r5.message)("memberQuoteDeliveryMethod", quote_r5.deliveryMethod)("deliveryMethodPrefix", ctx_r4.deliveryMethodPrefix)("deliveryMethodSeparator", ctx_r4.deliveryMethodSeparator)("planIds", quote_r5.planIds)("planTypeHeader", ctx_r4.planTypeHeader)("requestedEffectiveDateHeader", ctx_r4.requestedEffectiveDateHeader)("isMedigap", quote_r5.isMedigap)("pacificTimePostFix", ctx_r4.pacificTimePostFix)("displayQuoteSentInformation", ctx_r4.displayQuoteSentInformation)("displayPlanType", ctx_r4.displayPlanType)("planType", quote_r5.planType)("displayRequestedEffectiveDate", ctx_r4.displayRequestedEffectiveDate)("displayAuthCode", ctx_r4.displayAuthCode)("displayPersonalizedMessage", ctx_r4.displayPersonalizedMessage)("displayAgentFullName", ctx_r4.displayAgentFullName)("displayAgentUserName", ctx_r4.displayAgentUserName)("showPlanYearBadge", ctx_r4.showPlanYearBadge)("planYear", quote_r5.planYear)("sendQuoteAgentOfRecordEnabled", ctx_r4.sendQuoteAgentOfRecordEnabled)("sendingAgentData", ctx_r4.quoteHistory == null ? null : ctx_r4.quoteHistory[quote_r5.quoteId] == null ? null : ctx_r4.quoteHistory[quote_r5.quoteId].sendingAgentData);
} }
function MemberQuoteHistoryComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MemberQuoteHistoryComponent_ng_container_3_ng_container_1_Template, 2, 32, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.memberQuoteHistory);
} }
function MemberQuoteHistoryComponent_ng_template_4_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.memberQuoteHistoryNoQuotesMessageText, " ");
} }
function MemberQuoteHistoryComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, MemberQuoteHistoryComponent_ng_template_4_div_0_Template, 2, 1, "div", 8);
} if (rf & 2) {
    i0.ɵɵproperty("liveEditProp", "Spa_MemberQuoteHistory_NoQuotesMessageText");
} }
class MemberQuoteHistoryComponent {
    constructor(agentService) {
        this.agentService = agentService;
        this.quoteHistory = {};
    }
    ngOnChanges(changes) {
        const { memberQuoteHistory, currentAgentGuid } = changes;
        if ((memberQuoteHistory && !_isEqual(memberQuoteHistory.currentValue, memberQuoteHistory.previousValue)) ||
            (currentAgentGuid && currentAgentGuid.currentValue !== currentAgentGuid.previousValue)) {
            if (this.memberQuoteHistory?.length) {
                this.memberQuoteHistory.forEach(quote => {
                    if (quote.agentId !== quote.sendingAgent)
                        this.agentService
                            .fetchAgent$(quote.sendingAgent, this.currentAgentGuid)
                            .pipe(take(1))
                            .subscribe(agentFetchedData => {
                            this.quoteHistory[quote.quoteId] = {
                                sendingAgentData: agentFetchedData
                            };
                        });
                });
            }
        }
    }
}
MemberQuoteHistoryComponent.ɵfac = function MemberQuoteHistoryComponent_Factory(t) { return new (t || MemberQuoteHistoryComponent)(i0.ɵɵdirectiveInject(i1.AgentService)); };
MemberQuoteHistoryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MemberQuoteHistoryComponent, selectors: [["vnext-member-quote-history"]], inputs: { memberQuoteHistoryHeaderText: "memberQuoteHistoryHeaderText", memberQuoteHistoryNoQuotesMessageText: "memberQuoteHistoryNoQuotesMessageText", memberQuoteHistoryQuoteSentText: "memberQuoteHistoryQuoteSentText", deliveryMethodPrefix: "deliveryMethodPrefix", deliveryMethodSeparator: "deliveryMethodSeparator", memberQuoteHistoryAuthorizationEmailBodyText: "memberQuoteHistoryAuthorizationEmailBodyText", memberQuoteHistory: "memberQuoteHistory", planTypeHeader: "planTypeHeader", requestedEffectiveDateHeader: "requestedEffectiveDateHeader", sendingAgentUserName: "sendingAgentUserName", sendingAgentFullName: "sendingAgentFullName", pacificTimePostFix: "pacificTimePostFix", displayQuoteSentInformation: "displayQuoteSentInformation", displayPlanType: "displayPlanType", displayRequestedEffectiveDate: "displayRequestedEffectiveDate", displayAuthCode: "displayAuthCode", displayPersonalizedMessage: "displayPersonalizedMessage", displayAgentUserName: "displayAgentUserName", displayAgentFullName: "displayAgentFullName", memberQuoteHistoryPlanNameEnabled: "memberQuoteHistoryPlanNameEnabled", memberQuoteHistoryCarrierNameEnabled: "memberQuoteHistoryCarrierNameEnabled", sendQuoteAgentOfRecordEnabled: "sendQuoteAgentOfRecordEnabled", showPlanYearBadge: "showPlanYearBadge", currentAgentGuid: "currentAgentGuid" }, features: [i0.ɵɵNgOnChangesFeature], decls: 6, vars: 3, consts: [[1, "row"], [1, "col-12"], ["class", "Spa_Style_H2 mt-3 mb-0", 4, "liveEditProp"], [4, "ngIf", "ngIfElse"], ["noMemberQuoteHistoryAvailable", ""], [1, "Spa_Style_H2", "mt-3", "mb-0"], [4, "ngFor", "ngForOf"], [3, "memberQuoteAgentFirstName", "memberQuoteAgentLastName", "memberQuoteAgentUserName", "memberQuoteEffectiveDate", "memberQuotePlanInfo", "memberQuoteHistoryPlanNameEnabled", "memberQuoteHistoryCarrierNameEnabled", "memberQuoteSentDate", "memberQuoteAuthorizationCodeText", "memberQuoteAuthorizationCode", "memberQuoteSentText", "memberQuoteMessageText", "memberQuoteDeliveryMethod", "deliveryMethodPrefix", "deliveryMethodSeparator", "planIds", "planTypeHeader", "requestedEffectiveDateHeader", "isMedigap", "pacificTimePostFix", "displayQuoteSentInformation", "displayPlanType", "planType", "displayRequestedEffectiveDate", "displayAuthCode", "displayPersonalizedMessage", "displayAgentFullName", "displayAgentUserName", "showPlanYearBadge", "planYear", "sendQuoteAgentOfRecordEnabled", "sendingAgentData"], ["class", "no-quote-history Spa_Style_Note", 4, "liveEditProp"], [1, "no-quote-history", "Spa_Style_Note"]], template: function MemberQuoteHistoryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, MemberQuoteHistoryComponent_h2_2_Template, 2, 1, "h2", 2);
        i0.ɵɵtemplate(3, MemberQuoteHistoryComponent_ng_container_3_Template, 2, 1, "ng-container", 3);
        i0.ɵɵtemplate(4, MemberQuoteHistoryComponent_ng_template_4_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(5);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_MemberQuoteHistory_Header_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.memberQuoteHistory && ctx.memberQuoteHistory.length)("ngIfElse", _r2);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, LiveEditPropDirective, MemberQuoteCardComponent], styles: [".no-quote-history[_ngcontent-%COMP%]{border-top:2px solid var(--static-Spa_Style_Gray2);text-align:center;padding-top:12px;margin-top:10px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberQuoteHistoryComponent, [{
        type: Component,
        args: [{ selector: 'vnext-member-quote-history', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row\">\r\n  <div class=\"col-12\">\r\n    <h2 *liveEditProp=\"'Spa_MemberQuoteHistory_Header_Text'\" class=\"Spa_Style_H2 mt-3 mb-0\">\r\n      {{ memberQuoteHistoryHeaderText }}\r\n    </h2>\r\n    <ng-container *ngIf=\"memberQuoteHistory && memberQuoteHistory.length; else noMemberQuoteHistoryAvailable\">\r\n      <ng-container *ngFor=\"let quote of memberQuoteHistory\">\r\n        <vnext-member-quote-card\r\n          [memberQuoteAgentFirstName]=\"quote.fName\"\r\n          [memberQuoteAgentLastName]=\"quote.lName\"\r\n          [memberQuoteAgentUserName]=\"quote.username\"\r\n          [memberQuoteEffectiveDate]=\"quote.effectiveDate\"\r\n          [memberQuotePlanInfo]=\"quote.quotedPlanInfo\"\r\n          [memberQuoteHistoryPlanNameEnabled]=\"memberQuoteHistoryPlanNameEnabled\"\r\n          [memberQuoteHistoryCarrierNameEnabled]=\"memberQuoteHistoryCarrierNameEnabled\"\r\n          [memberQuoteSentDate]=\"quote.sentDate\"\r\n          [memberQuoteAuthorizationCodeText]=\"memberQuoteHistoryAuthorizationEmailBodyText\"\r\n          [memberQuoteAuthorizationCode]=\"quote.authCode\"\r\n          [memberQuoteSentText]=\"memberQuoteHistoryQuoteSentText\"\r\n          [memberQuoteMessageText]=\"quote.message\"\r\n          [memberQuoteDeliveryMethod]=\"quote.deliveryMethod\"\r\n          [deliveryMethodPrefix]=\"deliveryMethodPrefix\"\r\n          [deliveryMethodSeparator]=\"deliveryMethodSeparator\"\r\n          [planIds]=\"quote.planIds\"\r\n          [planTypeHeader]=\"planTypeHeader\"\r\n          [requestedEffectiveDateHeader]=\"requestedEffectiveDateHeader\"\r\n          [isMedigap]=\"quote.isMedigap\"\r\n          [pacificTimePostFix]=\"pacificTimePostFix\"\r\n          [displayQuoteSentInformation]=\"displayQuoteSentInformation\"\r\n          [displayPlanType]=\"displayPlanType\"\r\n          [planType]=\"quote.planType\"\r\n          [displayRequestedEffectiveDate]=\"displayRequestedEffectiveDate\"\r\n          [displayAuthCode]=\"displayAuthCode\"\r\n          [displayPersonalizedMessage]=\"displayPersonalizedMessage\"\r\n          [displayAgentFullName]=\"displayAgentFullName\"\r\n          [displayAgentUserName]=\"displayAgentUserName\"\r\n          [showPlanYearBadge]=\"showPlanYearBadge\"\r\n          [planYear]=\"quote.planYear\"\r\n          [sendQuoteAgentOfRecordEnabled]=\"sendQuoteAgentOfRecordEnabled\"\r\n          [sendingAgentData]=\"quoteHistory?.[quote.quoteId]?.sendingAgentData\"\r\n        >\r\n        </vnext-member-quote-card>\r\n      </ng-container>\r\n    </ng-container>\r\n    <ng-template #noMemberQuoteHistoryAvailable>\r\n      <div class=\"no-quote-history Spa_Style_Note\" *liveEditProp=\"'Spa_MemberQuoteHistory_NoQuotesMessageText'\">\r\n        {{ memberQuoteHistoryNoQuotesMessageText }}\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n</div>\r\n", styles: [".no-quote-history{border-top:2px solid var(--static-Spa_Style_Gray2);text-align:center;padding-top:12px;margin-top:10px}\n"] }]
    }], function () { return [{ type: i1.AgentService }]; }, { memberQuoteHistoryHeaderText: [{
            type: Input
        }], memberQuoteHistoryNoQuotesMessageText: [{
            type: Input
        }], memberQuoteHistoryQuoteSentText: [{
            type: Input
        }], deliveryMethodPrefix: [{
            type: Input
        }], deliveryMethodSeparator: [{
            type: Input
        }], memberQuoteHistoryAuthorizationEmailBodyText: [{
            type: Input
        }], memberQuoteHistory: [{
            type: Input
        }], planTypeHeader: [{
            type: Input
        }], requestedEffectiveDateHeader: [{
            type: Input
        }], sendingAgentUserName: [{
            type: Input
        }], sendingAgentFullName: [{
            type: Input
        }], pacificTimePostFix: [{
            type: Input
        }], displayQuoteSentInformation: [{
            type: Input
        }], displayPlanType: [{
            type: Input
        }], displayRequestedEffectiveDate: [{
            type: Input
        }], displayAuthCode: [{
            type: Input
        }], displayPersonalizedMessage: [{
            type: Input
        }], displayAgentUserName: [{
            type: Input
        }], displayAgentFullName: [{
            type: Input
        }], memberQuoteHistoryPlanNameEnabled: [{
            type: Input
        }], memberQuoteHistoryCarrierNameEnabled: [{
            type: Input
        }], sendQuoteAgentOfRecordEnabled: [{
            type: Input
        }], showPlanYearBadge: [{
            type: Input
        }], currentAgentGuid: [{
            type: Input
        }] }); })();

class EffectiveDateFacade {
    constructor(configResourceService) {
        this.configResourceService = configResourceService;
        this.defaultMaxPastMonths = 1200;
        this.defaultMaxFutureMonths = 3;
    }
    getPartAEffectiveMaxFutureMonths() {
        const partAEffectiveMaxFutureMonths = this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartA_Effective_Max_Future_Months');
        return partAEffectiveMaxFutureMonths >= 0 ? partAEffectiveMaxFutureMonths : this.defaultMaxFutureMonths;
    }
    getPartAEffectiveMaxPastMonths() {
        const partAEffectiveMaxPastMonths = this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartA_Effective_Max_Past_Months');
        return partAEffectiveMaxPastMonths >= 0 ? partAEffectiveMaxPastMonths : this.defaultMaxPastMonths;
    }
    getPartBEffectiveMaxFutureMonths() {
        const partBEffectiveMaxFutureMonths = this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartB_Effective_Max_Future_Months');
        return partBEffectiveMaxFutureMonths >= 0 ? partBEffectiveMaxFutureMonths : this.defaultMaxFutureMonths;
    }
    getPartBEffectiveMaxPastMonths() {
        const partBEffectiveMaxPastMonths = this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartB_Effective_Max_Past_Months');
        return partBEffectiveMaxPastMonths >= 0 ? partBEffectiveMaxPastMonths : this.defaultMaxPastMonths;
    }
    getMonthsForDropdownParts(maxPastMonths, maxFutureMonths) {
        return DateUtilities.getMonthsFromFloorToCeil(maxPastMonths, maxFutureMonths);
    }
    getYearsForDropdown(maxPastMonths = 0, maxFutureMonths = 0) {
        return DateUtilities.getYearsRange(maxPastMonths, maxFutureMonths);
    }
    getMonthList() {
        return [
            this.configResourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_1') || 'January',
            this.configResourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_2') || 'February',
            this.configResourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_3') || 'March',
            this.configResourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_4') || 'April',
            this.configResourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_5') || 'May',
            this.configResourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_6') || 'June',
            this.configResourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_7') || 'July',
            this.configResourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_8') || 'August',
            this.configResourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_9') || 'September',
            this.configResourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_10') || 'October',
            this.configResourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_11') || 'November',
            this.configResourceService.getProcessedResourceValue('Spa_Site_Total_Est_Cost_Month_12') || 'December'
        ];
    }
}
EffectiveDateFacade.ɵfac = function EffectiveDateFacade_Factory(t) { return new (t || EffectiveDateFacade)(i0.ɵɵinject(i1.ConfigResourceService)); };
EffectiveDateFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EffectiveDateFacade, factory: EffectiveDateFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EffectiveDateFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.ConfigResourceService }]; }, null); })();

const _c0$1u = ["memberRegistrationZipInput"];
const _c1$F = ["typeahead"];
const _c2$r = ["addressSearchInput"];
const _c3$g = ["authRepAddressSearchInput"];
const _c4$8 = ["ngFormInstance"];
const _c5$5 = ["errorContainer"];
function MemberRegistrationComponent_h2_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.profileSubHeaderLabel, " ");
} }
function MemberRegistrationComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelement(2, "vnext-notice", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", ctx_r3.Spa_Member_Profile_ErrorMessages_TitleText)("messages", ctx_r3.errorMessages)("type", "error");
} }
function MemberRegistrationComponent_div_16_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r25.memberRegistrationMap["firstName"] == null ? null : ctx_r25.memberRegistrationMap["firstName"].requiredText);
} }
function MemberRegistrationComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_16_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.memberRegistrationMap["firstName"] == null ? null : ctx_r5.memberRegistrationMap["firstName"].required);
} }
function MemberRegistrationComponent_span_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberRegistrationComponent_div_24_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r26.memberRegistrationMap["lastName"] == null ? null : ctx_r26.memberRegistrationMap["lastName"].requiredText);
} }
function MemberRegistrationComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_24_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r7.memberRegistrationMap["lastName"] == null ? null : ctx_r7.memberRegistrationMap["lastName"].required);
} }
function MemberRegistrationComponent_span_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberRegistrationComponent_div_30_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r29.memberRegistrationMap["dateOfBirth"] == null ? null : ctx_r29.memberRegistrationMap["dateOfBirth"].requiredText);
} }
function MemberRegistrationComponent_div_30_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r30.dobError);
} }
function MemberRegistrationComponent_div_30_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_30_div_2_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_30_div_2_span_3_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r27.memberRegistrationMap["dateOfBirth"] == null ? null : ctx_r27.memberRegistrationMap["dateOfBirth"].required) && !(ctx_r27.createMemberProfile.controls.dateOfBirth == null ? null : ctx_r27.createMemberProfile.controls.dateOfBirth.value));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r27.memberRegistrationMap["dateOfBirth"] == null ? null : ctx_r27.memberRegistrationMap["dateOfBirth"].hasError) && (ctx_r27.createMemberProfile.controls.dateOfBirth == null ? null : ctx_r27.createMemberProfile.controls.dateOfBirth.value));
} }
function MemberRegistrationComponent_div_30_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
const _c6$5 = function (a0) { return { "has-error": a0 }; };
const _c7$4 = function (a0) { return { "readonly Spa_Style_Gray4_Color": a0 }; };
const _c8$3 = function (a0) { return { "error-color": a0 }; };
const _c9$1 = function (a0, a1) { return { "has-error": a0, "Spa_Style_Gray4_Color readonly": a1 }; };
function MemberRegistrationComponent_div_30_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "label", 14);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_30_div_2_Template, 4, 2, "div", 15);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_30_span_3_Template, 2, 0, "span", 16);
    i0.ɵɵelementStart(4, "label", 37)(5, "span", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "input", 38);
    i0.ɵɵlistener("blur", function MemberRegistrationComponent_div_30_Template_input_blur_7_listener() { i0.ɵɵrestoreView(_r32); const ctx_r31 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r31.getDateValidation(ctx_r31.createMemberProfile.controls.dateOfBirth == null ? null : ctx_r31.createMemberProfile.controls.dateOfBirth.value)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c6$5, ctx_r9.memberRegistrationMap["dateOfBirth"] == null ? null : ctx_r9.memberRegistrationMap["dateOfBirth"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.memberRegistrationMap["dateOfBirth"] == null ? null : ctx_r9.memberRegistrationMap["dateOfBirth"].hasError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.memberRegistrationMap["dateOfBirth"] == null ? null : ctx_r9.memberRegistrationMap["dateOfBirth"].required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c7$4, ctx_r9.memberRegistrationMap["dateOfBirth"] == null ? null : ctx_r9.memberRegistrationMap["dateOfBirth"].isReadOnly));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c8$3, ctx_r9.memberRegistrationMap["dateOfBirth"] == null ? null : ctx_r9.memberRegistrationMap["dateOfBirth"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r9.memberRegistrationMap["dateOfBirth"] == null ? null : ctx_r9.memberRegistrationMap["dateOfBirth"].labelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r9.getDateFormat());
    i0.ɵɵpropertyInterpolate("mask", ctx_r9.getDateMaskFormat());
    i0.ɵɵproperty("dropSpecialCharacters", false)("ngClass", i0.ɵɵpureFunction2(17, _c9$1, ctx_r9.memberRegistrationMap["dateOfBirth"] == null ? null : ctx_r9.memberRegistrationMap["dateOfBirth"].hasError, ctx_r9.memberRegistrationMap["dateOfBirth"] == null ? null : ctx_r9.memberRegistrationMap["dateOfBirth"].isReadOnly))("readonly", ctx_r9.memberRegistrationMap["dateOfBirth"] == null ? null : ctx_r9.memberRegistrationMap["dateOfBirth"].isReadOnly);
} }
function MemberRegistrationComponent_div_32_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r35.memberRegistrationMap["email"] == null ? null : ctx_r35.memberRegistrationMap["email"].requiredText);
} }
function MemberRegistrationComponent_div_32_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r36.Spa_Member_Profile_Invalid_EmailError_Text);
} }
function MemberRegistrationComponent_div_32_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_32_div_2_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_32_div_2_span_3_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r33.memberRegistrationMap["email"] == null ? null : ctx_r33.memberRegistrationMap["email"].required) && !(ctx_r33.createMemberProfile.controls.email == null ? null : ctx_r33.createMemberProfile.controls.email.value));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r33.memberRegistrationMap["email"] == null ? null : ctx_r33.memberRegistrationMap["email"].hasError) && (ctx_r33.createMemberProfile.controls.email == null ? null : ctx_r33.createMemberProfile.controls.email.value));
} }
function MemberRegistrationComponent_div_32_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberRegistrationComponent_div_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "label", 14);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_32_div_2_Template, 4, 2, "div", 15);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_32_span_3_Template, 2, 0, "span", 16);
    i0.ɵɵelementStart(4, "label", 39)(5, "span", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "input", 40);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c6$5, ctx_r10.memberRegistrationMap["email"] == null ? null : ctx_r10.memberRegistrationMap["email"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.memberRegistrationMap["email"] == null ? null : ctx_r10.memberRegistrationMap["email"].hasError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.memberRegistrationMap["email"] == null ? null : ctx_r10.memberRegistrationMap["email"].required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c7$4, ctx_r10.memberRegistrationMap["email"] == null ? null : ctx_r10.memberRegistrationMap["email"].isReadOnly));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c8$3, ctx_r10.memberRegistrationMap["email"] == null ? null : ctx_r10.memberRegistrationMap["email"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r10.memberRegistrationMap["email"] == null ? null : ctx_r10.memberRegistrationMap["email"].labelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(14, _c9$1, ctx_r10.memberRegistrationMap["email"] == null ? null : ctx_r10.memberRegistrationMap["email"].hasError, ctx_r10.memberRegistrationMap["email"] == null ? null : ctx_r10.memberRegistrationMap["email"].isReadOnly))("readonly", ctx_r10.memberRegistrationMap["email"] == null ? null : ctx_r10.memberRegistrationMap["email"].isReadOnly);
} }
function MemberRegistrationComponent_div_33_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r39.memberRegistrationMap["phone"] == null ? null : ctx_r39.memberRegistrationMap["phone"].requiredText, " ");
} }
function MemberRegistrationComponent_div_33_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r40.Spa_Member_Profile_Invalid_PhoneError_Text);
} }
function MemberRegistrationComponent_div_33_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_33_div_2_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_33_div_2_span_3_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r37.memberRegistrationMap["phone"] == null ? null : ctx_r37.memberRegistrationMap["phone"].required) && !(ctx_r37.createMemberProfile.controls.phone == null ? null : ctx_r37.createMemberProfile.controls.phone.value));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r37.memberRegistrationMap["phone"] == null ? null : ctx_r37.memberRegistrationMap["phone"].hasError) && (ctx_r37.createMemberProfile.controls.phone == null ? null : ctx_r37.createMemberProfile.controls.phone.value));
} }
function MemberRegistrationComponent_div_33_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberRegistrationComponent_div_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "label", 14);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_33_div_2_Template, 4, 2, "div", 15);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_33_span_3_Template, 2, 0, "span", 16);
    i0.ɵɵelementStart(4, "label", 41)(5, "span", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "input", 42);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c6$5, ctx_r11.memberRegistrationMap["phone"] == null ? null : ctx_r11.memberRegistrationMap["phone"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.memberRegistrationMap["phone"] == null ? null : ctx_r11.memberRegistrationMap["phone"].hasError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.memberRegistrationMap["phone"] == null ? null : ctx_r11.memberRegistrationMap["phone"].required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c7$4, ctx_r11.memberRegistrationMap["phone"] == null ? null : ctx_r11.memberRegistrationMap["phone"].isReadOnly));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c8$3, ctx_r11.memberRegistrationMap["phone"] == null ? null : ctx_r11.memberRegistrationMap["phone"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r11.memberRegistrationMap["phone"] == null ? null : ctx_r11.memberRegistrationMap["phone"].labelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("mask", ctx_r11.phoneMask)("ngClass", i0.ɵɵpureFunction2(15, _c9$1, ctx_r11.memberRegistrationMap["phone"] == null ? null : ctx_r11.memberRegistrationMap["phone"].hasError, ctx_r11.memberRegistrationMap["phone"] == null ? null : ctx_r11.memberRegistrationMap["phone"].isReadOnly))("readonly", ctx_r11.memberRegistrationMap["phone"] == null ? null : ctx_r11.memberRegistrationMap["phone"].isReadOnly);
} }
function MemberRegistrationComponent_div_34_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r44.memberRegistrationMap["cellPhone"] == null ? null : ctx_r44.memberRegistrationMap["cellPhone"].requiredText, " ");
} }
function MemberRegistrationComponent_div_34_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r45.Spa_Member_Profile_Invalid_CellPhoneError_Text);
} }
function MemberRegistrationComponent_div_34_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_34_div_2_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_34_div_2_span_3_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r41.memberRegistrationMap["cellPhone"] == null ? null : ctx_r41.memberRegistrationMap["cellPhone"].required) && !(ctx_r41.createMemberProfile.controls.cellPhone == null ? null : ctx_r41.createMemberProfile.controls.cellPhone.value));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r41.memberRegistrationMap["cellPhone"] == null ? null : ctx_r41.memberRegistrationMap["cellPhone"].hasError) && (ctx_r41.createMemberProfile.controls.cellPhone == null ? null : ctx_r41.createMemberProfile.controls.cellPhone.value));
} }
function MemberRegistrationComponent_div_34_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberRegistrationComponent_div_34_label_8_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 46)(1, "input", 47);
    i0.ɵɵlistener("change", function MemberRegistrationComponent_div_34_label_8_Template_input_change_1_listener() { i0.ɵɵrestoreView(_r47); const ctx_r46 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r46.toggleCellPhoneCheckbox()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span", 48);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r43.disableCellPhoneInput)("checked", ctx_r43.disableCellPhoneInput);
    i0.ɵɵattribute("aria-label", ctx_r43.Spa_Site_SameAsPrimary_Text);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r43.Spa_Site_SameAsPrimary_Text);
} }
function MemberRegistrationComponent_div_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "label", 14);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_34_div_2_Template, 4, 2, "div", 15);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_34_span_3_Template, 2, 0, "span", 16);
    i0.ɵɵelementStart(4, "label", 43)(5, "span", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "input", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, MemberRegistrationComponent_div_34_label_8_Template, 4, 4, "label", 45);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c6$5, ctx_r12.memberRegistrationMap["cellPhone"] == null ? null : ctx_r12.memberRegistrationMap["cellPhone"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.memberRegistrationMap["cellPhone"] == null ? null : ctx_r12.memberRegistrationMap["cellPhone"].hasError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.memberRegistrationMap["cellPhone"] == null ? null : ctx_r12.memberRegistrationMap["cellPhone"].required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c7$4, (ctx_r12.memberRegistrationMap["cellPhone"] == null ? null : ctx_r12.memberRegistrationMap["cellPhone"].isReadOnly) || ctx_r12.disableCellPhoneInput));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c8$3, ctx_r12.memberRegistrationMap["cellPhone"] == null ? null : ctx_r12.memberRegistrationMap["cellPhone"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r12.memberRegistrationMap["cellPhone"] == null ? null : ctx_r12.memberRegistrationMap["cellPhone"].labelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("mask", ctx_r12.phoneMask)("ngClass", i0.ɵɵpureFunction2(16, _c9$1, ctx_r12.memberRegistrationMap["cellPhone"] == null ? null : ctx_r12.memberRegistrationMap["cellPhone"].hasError, (ctx_r12.memberRegistrationMap["cellPhone"] == null ? null : ctx_r12.memberRegistrationMap["cellPhone"].isReadOnly) || ctx_r12.disableCellPhoneInput))("readonly", (ctx_r12.memberRegistrationMap["cellPhone"] == null ? null : ctx_r12.memberRegistrationMap["cellPhone"].isReadOnly) || ctx_r12.disableCellPhoneInput);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.Spa_Member_Profile_MobilePhoneCopyMain_Enabled);
} }
function MemberRegistrationComponent_h3_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 49);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.profileHomeHeaderLabel, " ");
} }
function MemberRegistrationComponent_div_40_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r54.memberRegistrationMap["address1"] == null ? null : ctx_r54.memberRegistrationMap["address1"].requiredText);
} }
function MemberRegistrationComponent_div_40_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_40_div_2_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r48.memberRegistrationMap["address1"] == null ? null : ctx_r48.memberRegistrationMap["address1"].required);
} }
function MemberRegistrationComponent_div_40_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberRegistrationComponent_div_40_ng_template_7_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r55 = i0.ɵɵnextContext().result;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", r_r55.secondary, "");
} }
function MemberRegistrationComponent_div_40_ng_template_7_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r55 = i0.ɵɵnextContext().result;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(", ", r_r55.zipcode, "");
} }
function MemberRegistrationComponent_div_40_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 55);
    i0.ɵɵelement(1, "ngb-highlight", 56);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_40_ng_template_7_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵtemplate(4, MemberRegistrationComponent_div_40_ng_template_7_span_4_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r55 = ctx.result;
    const t_r56 = ctx.term;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("result", r_r55.street_line)("term", t_r56);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", r_r55.secondary);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", r_r55.city, " ", r_r55.state, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", r_r55.zipcode);
} }
const _c10$1 = function () { return { standalone: true }; };
function MemberRegistrationComponent_div_40_Template(rf, ctx) { if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "label", 50);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_40_div_2_Template, 3, 1, "div", 15);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_40_span_3_Template, 2, 0, "span", 16);
    i0.ɵɵelementStart(4, "label", 51)(5, "span", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, MemberRegistrationComponent_div_40_ng_template_7_Template, 5, 6, "ng-template", null, 52, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(9, "input", 53, 54);
    i0.ɵɵlistener("ngModelChange", function MemberRegistrationComponent_div_40_Template_input_ngModelChange_9_listener($event) { i0.ɵɵrestoreView(_r62); const ctx_r61 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r61.addressSearchTerm = $event); })("selectItem", function MemberRegistrationComponent_div_40_Template_input_selectItem_9_listener($event) { i0.ɵɵrestoreView(_r62); const ctx_r63 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r63.selectItemForAddress($event)); })("keyup", function MemberRegistrationComponent_div_40_Template_input_keyup_9_listener() { i0.ɵɵrestoreView(_r62); const ctx_r64 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r64.scrollItemIntoView()); })("focus", function MemberRegistrationComponent_div_40_Template_input_focus_9_listener() { i0.ɵɵrestoreView(_r62); const ctx_r65 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r65.focusAddressInput()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const _r50 = i0.ɵɵreference(8);
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c6$5, ctx_r14.memberRegistrationMap["address1"] == null ? null : ctx_r14.memberRegistrationMap["address1"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.memberRegistrationMap["address1"] == null ? null : ctx_r14.memberRegistrationMap["address1"].hasError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.memberRegistrationMap["address1"] == null ? null : ctx_r14.memberRegistrationMap["address1"].required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c7$4, ctx_r14.memberRegistrationMap["address1"] == null ? null : ctx_r14.memberRegistrationMap["address1"].isReadOnly));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c8$3, ctx_r14.memberRegistrationMap["address1"] == null ? null : ctx_r14.memberRegistrationMap["address1"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r14.memberRegistrationMap["address1"] == null ? null : ctx_r14.memberRegistrationMap["address1"].labelText, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbTypeahead", ctx_r14.suggestedAddresses)("ngClass", i0.ɵɵpureFunction2(20, _c9$1, ctx_r14.memberRegistrationMap["address1"] == null ? null : ctx_r14.memberRegistrationMap["address1"].hasError, ctx_r14.memberRegistrationMap["address1"] == null ? null : ctx_r14.memberRegistrationMap["address1"].isReadOnly))("resultTemplate", _r50)("inputFormatter", ctx_r14.addressAutocompleteFormatter)("ngModelOptions", i0.ɵɵpureFunction0(23, _c10$1))("readonly", ctx_r14.memberRegistrationMap["address1"] == null ? null : ctx_r14.memberRegistrationMap["address1"].isReadOnly)("ngModel", ctx_r14.addressSearchTerm);
    i0.ɵɵattribute("initialized", false);
} }
function MemberRegistrationComponent_div_41_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r68 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r68.memberRegistrationMap["address2"] == null ? null : ctx_r68.memberRegistrationMap["address2"].requiredText);
} }
function MemberRegistrationComponent_div_41_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_41_div_2_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r66 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r66.memberRegistrationMap["address2"] == null ? null : ctx_r66.memberRegistrationMap["address2"].required);
} }
function MemberRegistrationComponent_div_41_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberRegistrationComponent_div_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "label", 57);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_41_div_2_Template, 3, 1, "div", 15);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_41_span_3_Template, 2, 0, "span", 16);
    i0.ɵɵelementStart(4, "label", 58)(5, "span", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "input", 59);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c6$5, ctx_r15.memberRegistrationMap["address2"] == null ? null : ctx_r15.memberRegistrationMap["address2"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.memberRegistrationMap["address2"] == null ? null : ctx_r15.memberRegistrationMap["address2"].hasError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.memberRegistrationMap["address2"] == null ? null : ctx_r15.memberRegistrationMap["address2"].required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c7$4, ctx_r15.memberRegistrationMap["address2"] == null ? null : ctx_r15.memberRegistrationMap["address2"].isReadOnly));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c8$3, ctx_r15.memberRegistrationMap["address2"] == null ? null : ctx_r15.memberRegistrationMap["address2"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r15.memberRegistrationMap["address2"] == null ? null : ctx_r15.memberRegistrationMap["address2"].labelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(14, _c9$1, ctx_r15.memberRegistrationMap["address2"] == null ? null : ctx_r15.memberRegistrationMap["address2"].hasError, ctx_r15.memberRegistrationMap["address2"] == null ? null : ctx_r15.memberRegistrationMap["address2"].isReadOnly))("readonly", ctx_r15.memberRegistrationMap["address2"] == null ? null : ctx_r15.memberRegistrationMap["address2"].isReadOnly);
} }
function MemberRegistrationComponent_div_43_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r71 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r71.memberRegistrationMap["city"] == null ? null : ctx_r71.memberRegistrationMap["city"].requiredText);
} }
function MemberRegistrationComponent_div_43_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_43_div_2_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r69 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r69.memberRegistrationMap["city"] == null ? null : ctx_r69.memberRegistrationMap["city"].required);
} }
function MemberRegistrationComponent_div_43_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberRegistrationComponent_div_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "label", 14);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_43_div_2_Template, 3, 1, "div", 15);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_43_span_3_Template, 2, 0, "span", 16);
    i0.ɵɵelementStart(4, "label", 60)(5, "span", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "input", 61);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c6$5, ctx_r16.memberRegistrationMap["city"] == null ? null : ctx_r16.memberRegistrationMap["city"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.memberRegistrationMap["city"] == null ? null : ctx_r16.memberRegistrationMap["city"].hasError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.memberRegistrationMap["city"] == null ? null : ctx_r16.memberRegistrationMap["city"].required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c7$4, ctx_r16.memberRegistrationMap["city"] == null ? null : ctx_r16.memberRegistrationMap["city"].isReadOnly));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c8$3, ctx_r16.memberRegistrationMap["city"] == null ? null : ctx_r16.memberRegistrationMap["city"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r16.memberRegistrationMap["city"] == null ? null : ctx_r16.memberRegistrationMap["city"].labelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(14, _c9$1, ctx_r16.memberRegistrationMap["city"] == null ? null : ctx_r16.memberRegistrationMap["city"].hasError, ctx_r16.memberRegistrationMap["city"] == null ? null : ctx_r16.memberRegistrationMap["city"].isReadOnly))("readonly", ctx_r16.memberRegistrationMap["city"] == null ? null : ctx_r16.memberRegistrationMap["city"].isReadOnly);
} }
function MemberRegistrationComponent_div_44_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r74 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r74.memberRegistrationMap["state"] == null ? null : ctx_r74.memberRegistrationMap["state"].requiredText);
} }
function MemberRegistrationComponent_div_44_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_44_div_2_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r72 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r72.memberRegistrationMap["state"] == null ? null : ctx_r72.memberRegistrationMap["state"].required);
} }
function MemberRegistrationComponent_div_44_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberRegistrationComponent_div_44_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "label", 14);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_44_div_2_Template, 3, 1, "div", 15);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_44_span_3_Template, 2, 0, "span", 16);
    i0.ɵɵelementStart(4, "label", 58)(5, "span", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 62);
    i0.ɵɵelement(8, "vnext-state-selector-input", 63);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c6$5, ctx_r17.memberRegistrationMap["state"] == null ? null : ctx_r17.memberRegistrationMap["state"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.memberRegistrationMap["state"] == null ? null : ctx_r17.memberRegistrationMap["state"].hasError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.memberRegistrationMap["state"] == null ? null : ctx_r17.memberRegistrationMap["state"].required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c7$4, ctx_r17.memberRegistrationMap["state"] == null ? null : ctx_r17.memberRegistrationMap["state"].isReadOnly));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c8$3, ctx_r17.memberRegistrationMap["state"] == null ? null : ctx_r17.memberRegistrationMap["state"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r17.memberRegistrationMap["state"] == null ? null : ctx_r17.memberRegistrationMap["state"].labelText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("control", ctx_r17.createMemberProfile == null ? null : ctx_r17.createMemberProfile.controls == null ? null : ctx_r17.createMemberProfile.controls.state)("height", "36px")("controlValue", ctx_r17.createMemberProfile == null ? null : ctx_r17.createMemberProfile.controls == null ? null : ctx_r17.createMemberProfile.controls.state == null ? null : ctx_r17.createMemberProfile.controls.state.value)("isReadOnly", ctx_r17.memberRegistrationMap["state"] == null ? null : ctx_r17.memberRegistrationMap["state"].isReadOnly);
} }
function MemberRegistrationComponent_h3_46_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 49);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r18.profileSectionHeaderSalesInformationLabel, " ");
} }
function MemberRegistrationComponent_div_48_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r77 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r77.memberRegistrationMap["crm"] == null ? null : ctx_r77.memberRegistrationMap["crm"].requiredText);
} }
function MemberRegistrationComponent_div_48_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_48_div_2_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r75 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r75.memberRegistrationMap["crm"] == null ? null : ctx_r75.memberRegistrationMap["crm"].required);
} }
function MemberRegistrationComponent_div_48_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberRegistrationComponent_div_48_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "label", 14);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_48_div_2_Template, 3, 1, "div", 15);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_48_span_3_Template, 2, 0, "span", 16);
    i0.ɵɵelementStart(4, "label", 64)(5, "span", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "input", 65);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c6$5, ctx_r19.memberRegistrationMap["crm"] == null ? null : ctx_r19.memberRegistrationMap["crm"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.memberRegistrationMap["crm"] == null ? null : ctx_r19.memberRegistrationMap["crm"].hasError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.memberRegistrationMap["crm"] == null ? null : ctx_r19.memberRegistrationMap["crm"].required);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c8$3, ctx_r19.memberRegistrationMap["crm"] == null ? null : ctx_r19.memberRegistrationMap["crm"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r19.memberRegistrationMap["crm"] == null ? null : ctx_r19.memberRegistrationMap["crm"].labelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c6$5, ctx_r19.memberRegistrationMap["crm"] == null ? null : ctx_r19.memberRegistrationMap["crm"].hasError));
} }
function MemberRegistrationComponent_span_51_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 66);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r20.profileIsSalesContactDifferentLabel, " ");
} }
function MemberRegistrationComponent_div_54_div_2_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r90 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r90.memberRegistrationMap["authRepFirstName"] == null ? null : ctx_r90.memberRegistrationMap["authRepFirstName"].requiredText);
} }
function MemberRegistrationComponent_div_54_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_2_div_2_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r88 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r88.memberRegistrationMap["authRepFirstName"] == null ? null : ctx_r88.memberRegistrationMap["authRepFirstName"].required);
} }
function MemberRegistrationComponent_div_54_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberRegistrationComponent_div_54_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "label", 14);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_2_div_2_Template, 3, 1, "div", 15);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_54_div_2_span_3_Template, 2, 0, "span", 16);
    i0.ɵɵelementStart(4, "label", 67)(5, "span", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "input", 68);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r78 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c6$5, ctx_r78.memberRegistrationMap["authRepFirstName"] == null ? null : ctx_r78.memberRegistrationMap["authRepFirstName"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r78.memberRegistrationMap["authRepFirstName"] == null ? null : ctx_r78.memberRegistrationMap["authRepFirstName"].hasError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r78.memberRegistrationMap["authRepFirstName"] == null ? null : ctx_r78.memberRegistrationMap["authRepFirstName"].required);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c8$3, ctx_r78.memberRegistrationMap["authRepFirstName"] == null ? null : ctx_r78.memberRegistrationMap["authRepFirstName"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r78.memberRegistrationMap["authRepFirstName"] == null ? null : ctx_r78.memberRegistrationMap["authRepFirstName"].labelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c6$5, ctx_r78.memberRegistrationMap["authRepFirstName"] == null ? null : ctx_r78.memberRegistrationMap["authRepFirstName"].hasError));
} }
function MemberRegistrationComponent_div_54_div_3_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r93 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r93.memberRegistrationMap["authRepLastName"] == null ? null : ctx_r93.memberRegistrationMap["authRepLastName"].requiredText);
} }
function MemberRegistrationComponent_div_54_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_3_div_2_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r91 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r91.memberRegistrationMap["authRepLastName"] == null ? null : ctx_r91.memberRegistrationMap["authRepLastName"].required);
} }
function MemberRegistrationComponent_div_54_div_3_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberRegistrationComponent_div_54_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "label", 14);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_3_div_2_Template, 3, 1, "div", 15);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_54_div_3_span_3_Template, 2, 0, "span", 16);
    i0.ɵɵelementStart(4, "label", 69)(5, "span", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "input", 70);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r79 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c6$5, ctx_r79.memberRegistrationMap["authRepLastName"] == null ? null : ctx_r79.memberRegistrationMap["authRepLastName"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r79.memberRegistrationMap["authRepLastName"] == null ? null : ctx_r79.memberRegistrationMap["authRepLastName"].hasError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r79.memberRegistrationMap["authRepLastName"] == null ? null : ctx_r79.memberRegistrationMap["authRepLastName"].required);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c8$3, ctx_r79.memberRegistrationMap["authRepLastName"] == null ? null : ctx_r79.memberRegistrationMap["authRepLastName"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r79.memberRegistrationMap["authRepLastName"] == null ? null : ctx_r79.memberRegistrationMap["authRepLastName"].labelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c6$5, ctx_r79.memberRegistrationMap["authRepLastName"] == null ? null : ctx_r79.memberRegistrationMap["authRepLastName"].hasError));
} }
function MemberRegistrationComponent_div_54_div_5_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r96 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r96.memberRegistrationMap["authRepRelationship"] == null ? null : ctx_r96.memberRegistrationMap["authRepRelationship"].requiredText);
} }
function MemberRegistrationComponent_div_54_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_5_div_2_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r94 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r94.memberRegistrationMap["authRepRelationship"] == null ? null : ctx_r94.memberRegistrationMap["authRepRelationship"].required);
} }
function MemberRegistrationComponent_div_54_div_5_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberRegistrationComponent_div_54_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "label", 14);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_5_div_2_Template, 3, 1, "div", 15);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_54_div_5_span_3_Template, 2, 0, "span", 16);
    i0.ɵɵelementStart(4, "label", 71)(5, "span", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "input", 72);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r80 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c6$5, ctx_r80.memberRegistrationMap["authRepRelationship"] == null ? null : ctx_r80.memberRegistrationMap["authRepRelationship"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r80.memberRegistrationMap["authRepRelationship"] == null ? null : ctx_r80.memberRegistrationMap["authRepRelationship"].hasError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r80.memberRegistrationMap["authRepRelationship"] == null ? null : ctx_r80.memberRegistrationMap["authRepRelationship"].required);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c8$3, ctx_r80.memberRegistrationMap["authRepRelationship"] == null ? null : ctx_r80.memberRegistrationMap["authRepRelationship"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r80.memberRegistrationMap["authRepRelationship"] == null ? null : ctx_r80.memberRegistrationMap["authRepRelationship"].labelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c6$5, ctx_r80.memberRegistrationMap["authRepRelationship"] == null ? null : ctx_r80.memberRegistrationMap["authRepRelationship"].hasError));
} }
function MemberRegistrationComponent_div_54_div_6_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r99 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r99.memberRegistrationMap["authRepEmail"] == null ? null : ctx_r99.memberRegistrationMap["authRepEmail"].requiredText);
} }
function MemberRegistrationComponent_div_54_div_6_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r100 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r100.Spa_Member_Profile_Invalid_EmailError_Text);
} }
function MemberRegistrationComponent_div_54_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_6_div_2_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_54_div_6_div_2_span_3_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r97 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r97.memberRegistrationMap["authRepEmail"] == null ? null : ctx_r97.memberRegistrationMap["authRepEmail"].required) && !(ctx_r97.createMemberProfile.controls.authRepEmail == null ? null : ctx_r97.createMemberProfile.controls.authRepEmail.value));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r97.memberRegistrationMap["authRepEmail"] == null ? null : ctx_r97.memberRegistrationMap["authRepEmail"].hasError) && (ctx_r97.createMemberProfile.controls.authRepEmail == null ? null : ctx_r97.createMemberProfile.controls.authRepEmail.value));
} }
function MemberRegistrationComponent_div_54_div_6_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberRegistrationComponent_div_54_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "label", 14);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_6_div_2_Template, 4, 2, "div", 15);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_54_div_6_span_3_Template, 2, 0, "span", 16);
    i0.ɵɵelementStart(4, "label", 73)(5, "span", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "input", 74);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r81 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c6$5, ctx_r81.memberRegistrationMap["authRepEmail"] == null ? null : ctx_r81.memberRegistrationMap["authRepEmail"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r81.memberRegistrationMap["authRepEmail"] == null ? null : ctx_r81.memberRegistrationMap["authRepEmail"].hasError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r81.memberRegistrationMap["authRepEmail"] == null ? null : ctx_r81.memberRegistrationMap["authRepEmail"].required);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c8$3, ctx_r81.memberRegistrationMap["authRepEmail"] == null ? null : ctx_r81.memberRegistrationMap["authRepEmail"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r81.memberRegistrationMap["authRepEmail"] == null ? null : ctx_r81.memberRegistrationMap["authRepEmail"].labelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c6$5, ctx_r81.memberRegistrationMap["authRepEmail"] == null ? null : ctx_r81.memberRegistrationMap["authRepEmail"].hasError));
} }
function MemberRegistrationComponent_div_54_div_7_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r103 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r103.memberRegistrationMap["authRepPhone"] == null ? null : ctx_r103.memberRegistrationMap["authRepPhone"].requiredText);
} }
function MemberRegistrationComponent_div_54_div_7_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r104 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r104.Spa_Member_Profile_Invalid_PhoneError_Text);
} }
function MemberRegistrationComponent_div_54_div_7_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_7_div_2_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_54_div_7_div_2_span_3_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r101 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r101.memberRegistrationMap["authRepPhone"] == null ? null : ctx_r101.memberRegistrationMap["authRepPhone"].required) && !(ctx_r101.createMemberProfile.controls.authRepPhone == null ? null : ctx_r101.createMemberProfile.controls.authRepPhone.value));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r101.memberRegistrationMap["authRepPhone"] == null ? null : ctx_r101.memberRegistrationMap["authRepPhone"].hasError) && (ctx_r101.createMemberProfile.controls.authRepPhone == null ? null : ctx_r101.createMemberProfile.controls.authRepPhone.value));
} }
function MemberRegistrationComponent_div_54_div_7_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberRegistrationComponent_div_54_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "label", 14);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_7_div_2_Template, 4, 2, "div", 15);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_54_div_7_span_3_Template, 2, 0, "span", 16);
    i0.ɵɵelementStart(4, "label", 75)(5, "span", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "input", 76);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r82 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c6$5, ctx_r82.memberRegistrationMap["authRepPhone"] == null ? null : ctx_r82.memberRegistrationMap["authRepPhone"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r82.memberRegistrationMap["authRepPhone"] == null ? null : ctx_r82.memberRegistrationMap["authRepPhone"].hasError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r82.memberRegistrationMap["authRepPhone"] == null ? null : ctx_r82.memberRegistrationMap["authRepPhone"].required);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c8$3, ctx_r82.memberRegistrationMap["authRepPhone"] == null ? null : ctx_r82.memberRegistrationMap["authRepPhone"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r82.memberRegistrationMap["authRepPhone"] == null ? null : ctx_r82.memberRegistrationMap["authRepPhone"].labelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("mask", ctx_r82.phoneMask)("ngClass", i0.ɵɵpureFunction1(11, _c6$5, ctx_r82.memberRegistrationMap["authRepPhone"] == null ? null : ctx_r82.memberRegistrationMap["authRepPhone"].hasError));
} }
function MemberRegistrationComponent_div_54_div_9_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r111 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r111.memberRegistrationMap["authRepAddress1"] == null ? null : ctx_r111.memberRegistrationMap["authRepAddress1"].requiredText);
} }
function MemberRegistrationComponent_div_54_div_9_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_9_div_2_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r105 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r105.memberRegistrationMap["authRepAddress1"] == null ? null : ctx_r105.memberRegistrationMap["authRepAddress1"].required);
} }
function MemberRegistrationComponent_div_54_div_9_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberRegistrationComponent_div_54_div_9_ng_template_7_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r112 = i0.ɵɵnextContext().result;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", r_r112.secondary, "");
} }
function MemberRegistrationComponent_div_54_div_9_ng_template_7_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r112 = i0.ɵɵnextContext().result;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(", ", r_r112.zipcode, "");
} }
function MemberRegistrationComponent_div_54_div_9_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 55);
    i0.ɵɵelement(1, "ngb-highlight", 56);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_9_ng_template_7_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵtemplate(4, MemberRegistrationComponent_div_54_div_9_ng_template_7_span_4_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r112 = ctx.result;
    const t_r113 = ctx.term;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("result", r_r112.street_line)("term", t_r113);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", r_r112.secondary);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", r_r112.city, " ", r_r112.state, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", r_r112.zipcode);
} }
function MemberRegistrationComponent_div_54_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r119 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "label", 50);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_9_div_2_Template, 3, 1, "div", 15);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_54_div_9_span_3_Template, 2, 0, "span", 16);
    i0.ɵɵelementStart(4, "label", 77)(5, "span", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, MemberRegistrationComponent_div_54_div_9_ng_template_7_Template, 5, 6, "ng-template", null, 78, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(9, "input", 79, 80);
    i0.ɵɵlistener("ngModelChange", function MemberRegistrationComponent_div_54_div_9_Template_input_ngModelChange_9_listener($event) { i0.ɵɵrestoreView(_r119); const ctx_r118 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r118.authRepAddressSearchTerm = $event); })("selectItem", function MemberRegistrationComponent_div_54_div_9_Template_input_selectItem_9_listener($event) { i0.ɵɵrestoreView(_r119); const ctx_r120 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r120.selectItemForAuthRepAddress($event)); })("keyup", function MemberRegistrationComponent_div_54_div_9_Template_input_keyup_9_listener() { i0.ɵɵrestoreView(_r119); const ctx_r121 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r121.scrollItemIntoView()); })("focus", function MemberRegistrationComponent_div_54_div_9_Template_input_focus_9_listener() { i0.ɵɵrestoreView(_r119); const ctx_r122 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r122.focusAuthRepAddressInput()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const _r107 = i0.ɵɵreference(8);
    const ctx_r83 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c6$5, ctx_r83.memberRegistrationMap["authRepAddress1"] == null ? null : ctx_r83.memberRegistrationMap["authRepAddress1"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r83.memberRegistrationMap["authRepAddress1"] == null ? null : ctx_r83.memberRegistrationMap["authRepAddress1"].hasError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r83.memberRegistrationMap["authRepAddress1"] == null ? null : ctx_r83.memberRegistrationMap["authRepAddress1"].required);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c8$3, ctx_r83.memberRegistrationMap["authRepAddress1"] == null ? null : ctx_r83.memberRegistrationMap["authRepAddress1"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r83.memberRegistrationMap["authRepAddress1"] == null ? null : ctx_r83.memberRegistrationMap["authRepAddress1"].labelText, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbTypeahead", ctx_r83.suggestedAuthRepAddresses)("ngClass", i0.ɵɵpureFunction1(16, _c6$5, ctx_r83.memberRegistrationMap["authRepAddress1"] == null ? null : ctx_r83.memberRegistrationMap["authRepAddress1"].hasError))("resultTemplate", _r107)("inputFormatter", ctx_r83.addressAutocompleteFormatter)("ngModelOptions", i0.ɵɵpureFunction0(18, _c10$1))("ngModel", ctx_r83.authRepAddressSearchTerm);
    i0.ɵɵattribute("initialized", false);
} }
function MemberRegistrationComponent_div_54_div_10_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r125 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r125.memberRegistrationMap["authRepAddress2"] == null ? null : ctx_r125.memberRegistrationMap["authRepAddress2"].requiredText);
} }
function MemberRegistrationComponent_div_54_div_10_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_10_div_2_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r123 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r123.memberRegistrationMap["authRepAddress2"] == null ? null : ctx_r123.memberRegistrationMap["authRepAddress2"].required);
} }
function MemberRegistrationComponent_div_54_div_10_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberRegistrationComponent_div_54_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "label", 14);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_10_div_2_Template, 3, 1, "div", 15);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_54_div_10_span_3_Template, 2, 0, "span", 16);
    i0.ɵɵelementStart(4, "label", 81)(5, "span", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "input", 82);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r84 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c6$5, ctx_r84.memberRegistrationMap["authRepAddress2"] == null ? null : ctx_r84.memberRegistrationMap["authRepAddress2"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r84.memberRegistrationMap["authRepAddress2"] == null ? null : ctx_r84.memberRegistrationMap["authRepAddress2"].hasError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r84.memberRegistrationMap["authRepAddress2"] == null ? null : ctx_r84.memberRegistrationMap["authRepAddress2"].required);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c8$3, ctx_r84.memberRegistrationMap["authRepAddress2"] == null ? null : ctx_r84.memberRegistrationMap["authRepAddress2"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r84.memberRegistrationMap["authRepAddress2"] == null ? null : ctx_r84.memberRegistrationMap["authRepAddress2"].labelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c6$5, ctx_r84.memberRegistrationMap["authRepAddress2"] == null ? null : ctx_r84.memberRegistrationMap["authRepAddress2"].hasError));
} }
function MemberRegistrationComponent_div_54_div_12_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r128 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r128.memberRegistrationMap["authRepCity"] == null ? null : ctx_r128.memberRegistrationMap["authRepCity"].requiredText);
} }
function MemberRegistrationComponent_div_54_div_12_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_12_div_2_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r126 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r126.memberRegistrationMap["authRepCity"] == null ? null : ctx_r126.memberRegistrationMap["authRepCity"].required);
} }
function MemberRegistrationComponent_div_54_div_12_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberRegistrationComponent_div_54_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "label", 14);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_12_div_2_Template, 3, 1, "div", 15);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_54_div_12_span_3_Template, 2, 0, "span", 16);
    i0.ɵɵelementStart(4, "label", 83)(5, "span", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "input", 84);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r85 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c6$5, ctx_r85.memberRegistrationMap["authRepCity"] == null ? null : ctx_r85.memberRegistrationMap["authRepCity"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r85.memberRegistrationMap["authRepCity"] == null ? null : ctx_r85.memberRegistrationMap["authRepCity"].hasError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r85.memberRegistrationMap["authRepCity"] == null ? null : ctx_r85.memberRegistrationMap["authRepCity"].required);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c8$3, ctx_r85.memberRegistrationMap["authRepCity"] == null ? null : ctx_r85.memberRegistrationMap["authRepCity"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r85.memberRegistrationMap["authRepCity"] == null ? null : ctx_r85.memberRegistrationMap["authRepCity"].labelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c6$5, ctx_r85.memberRegistrationMap["authRepCity"] == null ? null : ctx_r85.memberRegistrationMap["authRepCity"].hasError));
} }
function MemberRegistrationComponent_div_54_div_13_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r131 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r131.memberRegistrationMap["authRepState"] == null ? null : ctx_r131.memberRegistrationMap["authRepState"].requiredText);
} }
function MemberRegistrationComponent_div_54_div_13_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_13_div_2_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r129 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r129.memberRegistrationMap["authRepState"] == null ? null : ctx_r129.memberRegistrationMap["authRepState"].required);
} }
function MemberRegistrationComponent_div_54_div_13_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberRegistrationComponent_div_54_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "label", 14);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_13_div_2_Template, 3, 1, "div", 15);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_54_div_13_span_3_Template, 2, 0, "span", 16);
    i0.ɵɵelementStart(4, "label", 66)(5, "span", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵelement(8, "vnext-state-selector-input", 85);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r86 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c6$5, ctx_r86.memberRegistrationMap["authRepState"] == null ? null : ctx_r86.memberRegistrationMap["authRepState"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r86.memberRegistrationMap["authRepState"] == null ? null : ctx_r86.memberRegistrationMap["authRepState"].hasError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r86.memberRegistrationMap["authRepState"] == null ? null : ctx_r86.memberRegistrationMap["authRepState"].required);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c8$3, ctx_r86.memberRegistrationMap["authRepState"] == null ? null : ctx_r86.memberRegistrationMap["authRepState"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r86.memberRegistrationMap["authRepState"] == null ? null : ctx_r86.memberRegistrationMap["authRepState"].labelText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("control", ctx_r86.createMemberProfile == null ? null : ctx_r86.createMemberProfile.controls == null ? null : ctx_r86.createMemberProfile.controls.authRepState)("height", "36px")("controlValue", ctx_r86.createMemberProfile == null ? null : ctx_r86.createMemberProfile.controls == null ? null : ctx_r86.createMemberProfile.controls.authRepState == null ? null : ctx_r86.createMemberProfile.controls.authRepState.value);
} }
function MemberRegistrationComponent_div_54_div_14_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r134 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r134.memberRegistrationMap["authRepZip"] == null ? null : ctx_r134.memberRegistrationMap["authRepZip"].requiredText);
} }
function MemberRegistrationComponent_div_54_div_14_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_14_div_2_span_2_Template, 2, 1, "span", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r132 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r132.memberRegistrationMap["authRepZip"] == null ? null : ctx_r132.memberRegistrationMap["authRepZip"].required);
} }
function MemberRegistrationComponent_div_54_div_14_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MemberRegistrationComponent_div_54_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "label", 14);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_14_div_2_Template, 3, 1, "div", 15);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_54_div_14_span_3_Template, 2, 0, "span", 16);
    i0.ɵɵelementStart(4, "label", 86)(5, "span", 18);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 87);
    i0.ɵɵelement(8, "input", 88);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r87 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c6$5, ctx_r87.memberRegistrationMap["authRepZip"] == null ? null : ctx_r87.memberRegistrationMap["authRepZip"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r87.memberRegistrationMap["authRepZip"] == null ? null : ctx_r87.memberRegistrationMap["authRepZip"].hasError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r87.memberRegistrationMap["authRepZip"] == null ? null : ctx_r87.memberRegistrationMap["authRepZip"].required);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c8$3, ctx_r87.memberRegistrationMap["authRepZip"] == null ? null : ctx_r87.memberRegistrationMap["authRepZip"].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r87.memberRegistrationMap["authRepZip"] == null ? null : ctx_r87.memberRegistrationMap["authRepZip"].labelText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c6$5, ctx_r87.memberRegistrationMap["authRepZip"] == null ? null : ctx_r87.memberRegistrationMap["authRepZip"].hasError));
} }
function MemberRegistrationComponent_div_54_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 12);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_div_54_div_2_Template, 8, 12, "div", 22);
    i0.ɵɵtemplate(3, MemberRegistrationComponent_div_54_div_3_Template, 8, 12, "div", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 12);
    i0.ɵɵtemplate(5, MemberRegistrationComponent_div_54_div_5_Template, 8, 12, "div", 22);
    i0.ɵɵtemplate(6, MemberRegistrationComponent_div_54_div_6_Template, 8, 12, "div", 22);
    i0.ɵɵtemplate(7, MemberRegistrationComponent_div_54_div_7_Template, 8, 13, "div", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 12);
    i0.ɵɵtemplate(9, MemberRegistrationComponent_div_54_div_9_Template, 12, 19, "div", 22);
    i0.ɵɵtemplate(10, MemberRegistrationComponent_div_54_div_10_Template, 8, 12, "div", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 12);
    i0.ɵɵtemplate(12, MemberRegistrationComponent_div_54_div_12_Template, 8, 12, "div", 22);
    i0.ɵɵtemplate(13, MemberRegistrationComponent_div_54_div_13_Template, 9, 12, "div", 22);
    i0.ɵɵtemplate(14, MemberRegistrationComponent_div_54_div_14_Template, 9, 12, "div", 22);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r21.memberRegistrationMap["authRepFirstName"] == null ? null : ctx_r21.memberRegistrationMap["authRepFirstName"].display);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.memberRegistrationMap["authRepLastName"] == null ? null : ctx_r21.memberRegistrationMap["authRepLastName"].display);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r21.memberRegistrationMap["authRepRelationship"] == null ? null : ctx_r21.memberRegistrationMap["authRepRelationship"].display);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.memberRegistrationMap["authRepEmail"] == null ? null : ctx_r21.memberRegistrationMap["authRepEmail"].display);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.memberRegistrationMap["authRepPhone"] == null ? null : ctx_r21.memberRegistrationMap["authRepPhone"].display);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r21.memberRegistrationMap["authRepAddress1"] == null ? null : ctx_r21.memberRegistrationMap["authRepAddress1"].display);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.memberRegistrationMap["authRepAddress2"] == null ? null : ctx_r21.memberRegistrationMap["authRepAddress2"].display);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r21.memberRegistrationMap["authRepCity"] == null ? null : ctx_r21.memberRegistrationMap["authRepCity"].display);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.memberRegistrationMap["authRepState"] == null ? null : ctx_r21.memberRegistrationMap["authRepState"].display);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.memberRegistrationMap["authRepZip"] == null ? null : ctx_r21.memberRegistrationMap["authRepZip"].display);
} }
function MemberRegistrationComponent_h3_55_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 89);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r22.profileAdditionalInformationHeaderLabel, " ");
} }
function MemberRegistrationComponent_ng_container_57_div_1_div_1_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r142 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r142.noSpecialCharactersError);
} }
function MemberRegistrationComponent_ng_container_57_div_1_div_1_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const customFieldIndex_r135 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r143 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r143.memberRegistrationMap["customField" + customFieldIndex_r135].requiredText);
} }
function MemberRegistrationComponent_ng_container_57_div_1_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MemberRegistrationComponent_ng_container_57_div_1_div_1_ng_container_2_ng_container_1_Template, 2, 1, "ng-container", 4);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_ng_container_57_div_1_div_1_ng_container_2_ng_container_2_Template, 2, 1, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const errors_r141 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", errors_r141.pattern);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", errors_r141.required);
} }
function MemberRegistrationComponent_ng_container_57_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵtemplate(2, MemberRegistrationComponent_ng_container_57_div_1_div_1_ng_container_2_Template, 3, 2, "ng-container", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const customFieldIndex_r135 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r137 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r137.createMemberProfile.controls["customField" + customFieldIndex_r135] == null ? null : ctx_r137.createMemberProfile.controls["customField" + customFieldIndex_r135].errors);
} }
function MemberRegistrationComponent_ng_container_57_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementContainerEnd();
} }
function MemberRegistrationComponent_ng_container_57_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 91);
    i0.ɵɵtemplate(1, MemberRegistrationComponent_ng_container_57_div_1_div_1_Template, 3, 1, "div", 15);
    i0.ɵɵelementStart(2, "label", 92)(3, "span", 18);
    i0.ɵɵtemplate(4, MemberRegistrationComponent_ng_container_57_div_1_ng_container_4_Template, 2, 0, "ng-container", 4);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(6, "input", 93);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const customFieldIndex_r135 = i0.ɵɵnextContext().$implicit;
    const ctx_r136 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r136.memberRegistrationMap["customField" + customFieldIndex_r135] == null ? null : ctx_r136.memberRegistrationMap["customField" + customFieldIndex_r135].hasError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", "customField" + customFieldIndex_r135);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c8$3, ctx_r136.memberRegistrationMap["customField" + customFieldIndex_r135] == null ? null : ctx_r136.memberRegistrationMap["customField" + customFieldIndex_r135].hasError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r136.memberRegistrationMap["customField" + customFieldIndex_r135].required);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r136.memberRegistrationMap["customField" + customFieldIndex_r135].labelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", "customField" + customFieldIndex_r135)("formControlName", "customField" + customFieldIndex_r135)("ngClass", i0.ɵɵpureFunction1(10, _c6$5, ctx_r136.memberRegistrationMap["customField" + customFieldIndex_r135] == null ? null : ctx_r136.memberRegistrationMap["customField" + customFieldIndex_r135].hasError));
} }
function MemberRegistrationComponent_ng_container_57_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MemberRegistrationComponent_ng_container_57_div_1_Template, 7, 12, "div", 90);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const customFieldIndex_r135 = ctx.$implicit;
    const ctx_r23 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r23.memberRegistrationMap["customField" + customFieldIndex_r135] && ctx_r23.memberRegistrationMap["customField" + customFieldIndex_r135].display);
} }
function MemberRegistrationComponent_vnext_status_button_60_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-status-button", 94);
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext();
    i0.ɵɵproperty("buttonText", ctx_r24.profileSaveButtonLabel)("tooltipMessageError", ctx_r24.Spa_Member_Profile_Save_Failed_ErrorText)("tooltipMessageSuccess", ctx_r24.Spa_Member_Profile_Save_Success_Text)("buttonClass", "Spa_Style_PrimaryButton")("isButtonTypeSubmit", true);
} }
const _c11$1 = function () { return [1, 2, 3, 4, 5]; };
class MemberRegistrationComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, modalService, deactivationGuardService, profileFacade, store, formValidationService, memberRegistrationFacade, memberRegistrationService, zipCodeContextService, element, addressService, autoCompleteService, ssoPopulatedFieldService, effectiveDateFacade, analyticsService, memberSessionService, demographicService, profileCryptoService, spinnerService, agentCallRecordingShoppingFacade, shoppingRecordingContextService, snpService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.modalService = modalService;
        this.deactivationGuardService = deactivationGuardService;
        this.profileFacade = profileFacade;
        this.store = store;
        this.formValidationService = formValidationService;
        this.memberRegistrationFacade = memberRegistrationFacade;
        this.memberRegistrationService = memberRegistrationService;
        this.zipCodeContextService = zipCodeContextService;
        this.element = element;
        this.addressService = addressService;
        this.autoCompleteService = autoCompleteService;
        this.ssoPopulatedFieldService = ssoPopulatedFieldService;
        this.effectiveDateFacade = effectiveDateFacade;
        this.analyticsService = analyticsService;
        this.memberSessionService = memberSessionService;
        this.demographicService = demographicService;
        this.profileCryptoService = profileCryptoService;
        this.spinnerService = spinnerService;
        this.agentCallRecordingShoppingFacade = agentCallRecordingShoppingFacade;
        this.shoppingRecordingContextService = shoppingRecordingContextService;
        this.snpService = snpService;
        this.sendDate = new EventEmitter();
        this.showDatePicker = true;
        this.Spa_Member_Profile_Save_Failed_ErrorText = 'Try again';
        this.Spa_Member_Profile_Save_Success_Text = 'Saved';
        this.Spa_Member_Profile_NoBirthDateError_Text = 'Please provide a valid date of birth';
        this.Spa_Member_Profile_FutureBirthDateError_Text = 'Please provide a date of birth in the past';
        this.Spa_Member_Profile_Invalid_EmailError_Text = 'Please provide a valid email address';
        this.Spa_Member_Profile_Invalid_PhoneError_Text = 'Please provide a valid phone number';
        this.Spa_Member_Profile_Invalid_CellPhoneError_Text = 'Please provide a valid mobile phone number';
        this.Spa_Member_Profile_Invalid_PartAEffectiveDate_Text = 'Please provide a valid Part A effective date';
        this.Spa_Member_Profile_Invalid_PartBEffectiveDate_Text = 'Please provide a valid Part B effective date';
        this.Spa_Member_Profile_Invalid_ZipError_Text = 'Please provide a valid zip code';
        this.Spa_Member_Profile_MBI_Valid_ErrorText = 'Please check your Medicare Number and re-enter (do not enter dashes)';
        this.Spa_Member_Profile_MBI_Length_ErrorText = '11 Characters required.';
        this.Spa_Site_Show_Text = 'Show';
        this.Spa_Site_Hide_Text = 'Hide';
        this.Spa_Member_Profile_ErrorMessages_TitleText = 'Correct the following error(s) on the form, then submit again';
        this.Spa_Member_Profile_PartAEffectiveDate_After_DateofBirth_Text = 'Part A effective date cannot be before date of birth.';
        this.Spa_Member_Profile_PartBEffectiveDate_After_DateofBirth_Text = 'Part B effective date cannot be before date of birth.';
        this.Spa_Member_Profile_PartBEffectiveDate_After_PartAEffectiveDate = 'Part B effective date cannot be before Part A effective date.';
        this.Spa_Member_Profile_Disable_CRMID = true;
        this.Spa_ZipCodeInput_CountyLabel_Text = 'County';
        this.Spa_ZipCodeInput_CountyLabel_Enabled = false;
        this.SPA_Member_Profile_Is_Sales_Contact_Different_Items = [
            { display: 'Yes', value: true },
            { display: 'No', value: false }
        ];
        this.Spa_Member_Profile_PartAEffectiveDate_DropDown_Enabled = false;
        this.Spa_Member_Profile_PartBEffectiveDate_DropDown_Enabled = false;
        this.Spa_MemberRegistration_Resource_Content = [
            {
                keyName: 'firstName',
                labelText: 'First Name',
                display: true,
                required: true,
                requiredText: 'First name is required'
            },
            {
                keyName: 'lastName',
                labelText: 'Last name',
                display: true,
                required: true,
                requiredText: 'Last name is required'
            },
            {
                keyName: 'dateOfBirth',
                labelText: 'Date of birth',
                display: true,
                required: false,
                requiredText: 'Date of birth is required'
            },
            {
                keyName: 'email',
                labelText: 'Email address',
                display: true,
                required: false,
                requiredText: 'Email address is required'
            },
            {
                keyName: 'phone',
                labelText: 'Phone number',
                display: true,
                required: false,
                requiredText: 'Phone is required'
            },
            {
                keyName: 'cellPhone',
                labelText: 'Mobile phone number',
                display: true,
                required: false,
                requiredText: 'Mobile phone is required'
            },
            {
                keyName: 'address1',
                labelText: 'Address 1',
                display: true,
                required: false,
                requiredText: 'Address 1 is required'
            },
            {
                keyName: 'address2',
                labelText: 'Address 2',
                display: true,
                required: false,
                requiredText: 'Address 2 is required'
            },
            {
                keyName: 'city',
                labelText: 'City',
                display: true,
                required: false,
                requiredText: 'City is required'
            },
            {
                keyName: 'state',
                labelText: 'State',
                display: true,
                required: false,
                requiredText: 'State is required'
            },
            {
                keyName: 'zip',
                labelText: 'ZIP',
                display: true,
                required: true,
                requiredText: 'ZIP is required'
            },
            {
                keyName: 'countyFips',
                labelText: 'County',
                display: false,
                required: false,
                requiredText: 'County is required'
            },
            {
                keyName: 'crm',
                labelText: 'CRM ID',
                display: true,
                required: false,
                requiredText: 'CRM ID is required'
            },
            {
                keyName: 'authRepFirstName',
                labelText: 'First name',
                display: true,
                required: false,
                requiredText: 'First name is required'
            },
            {
                keyName: 'authRepLastName',
                labelText: 'Last name',
                display: true,
                required: false,
                requiredText: 'Last name is required'
            },
            {
                keyName: 'authRepEmail',
                labelText: 'Email',
                display: true,
                required: false,
                requiredText: 'Email is required'
            },
            {
                keyName: 'authRepPhone',
                labelText: 'Phone number',
                display: true,
                required: false,
                requiredText: 'Phone number is required'
            },
            {
                keyName: 'authRepAddress1',
                labelText: 'Address line 1',
                display: true,
                required: false,
                requiredText: 'Address line 1 is required'
            },
            {
                keyName: 'authRepAddress2',
                labelText: 'Address line 2',
                display: true,
                required: false,
                requiredText: 'Address line 2 is required'
            },
            {
                keyName: 'authRepCity',
                labelText: 'City',
                display: true,
                required: false,
                requiredText: 'City is required'
            },
            {
                keyName: 'authRepState',
                labelText: 'State',
                display: true,
                required: false,
                requiredText: 'State is required'
            },
            {
                keyName: 'authRepZip',
                labelText: 'Zip',
                display: true,
                required: false,
                requiredText: 'Zip is required'
            },
            {
                keyName: 'authRepRelationship',
                labelText: 'Relationship to beneficiary',
                display: true,
                required: false,
                requiredText: 'Relationship is required'
            },
            {
                keyName: 'customField1',
                labelText: '[Primary care provider]',
                display: true,
                required: false,
                requiredText: 'Custom field 1 is required'
            },
            {
                keyName: 'customField2',
                labelText: '[Custom 2]',
                display: true,
                required: false,
                requiredText: 'Custom field 2 is required'
            },
            {
                keyName: 'customField3',
                labelText: '[Custom 3]',
                display: true,
                required: false,
                requiredText: 'Custom field 3 is required'
            },
            {
                keyName: 'customField4',
                labelText: '[Custom 4]',
                display: true,
                required: false,
                requiredText: 'Custom field 4 is required'
            },
            {
                keyName: 'customField5',
                labelText: '[Custom 5]',
                display: true,
                required: false,
                requiredText: 'Custom field 5 is required'
            },
            {
                keyName: 'partAEffectiveDate',
                labelText: 'Hospital (Part A) Effective Date',
                display: true,
                required: false,
                requiredText: 'Hospital (Part A) Effective Date is required'
            },
            {
                keyName: 'partBEffectiveDate',
                labelText: 'Medical (Part B) Effective Date',
                display: true,
                required: false,
                requiredText: 'Medical (Part B) Effective Date is required'
            }
        ];
        this.Spa_Member_Profile_AddressAutoComplete_Enabled = false;
        this.Spa_ProfileEligiblityCheck_Enabled = false;
        this.SPA_ProfileEligibilityCheck_DSNP_Enabled = false;
        this.Spa_GettingStarted_EnableDSNPDisplay_Flag = true;
        this.Spa_ProfileEligiblity_Header = 'Eligibility';
        this.SPA_ProfileEligiblityCheck_RequiredFieldError = 'required for eligibility check.';
        this.Spa_ProfileEligiblity_Last_Checked_Date_Text = 'Last checked';
        this.SPA_ProfileEligiblityCheck_MedicareEligibleText = 'Success';
        this.SPA_ProfileEligiblityCheck_DSNPText = 'Gets supplemental security income';
        this.SPA_ProfileEligiblityCheck_ChangedFrom_DSNPText = 'Changed from';
        this.Spa_ProfileEligiblity_Description = "Check to confirm the beneficiary's subsidy and see if they are eligible for Medicare.";
        this.Spa_ProfileEligiblity_ButtonText = 'Check eligiblity';
        this.Spa_ProfileEligiblity_ErrorText = 'Check the Medicare number, last name, and effective dates.';
        this.Spa_ProfileEligiblity_OpenSubsidyText = 'Add/edit subsidy';
        this.SPA_ProfileEligibilityCheck_Request_Error = 'Could not complete eligibility check. Please try again later.';
        this.Spa_ProfileEligiblity_PrescriptionDrugsText = 'Does beneficiary receive extra help paying for prescription drugs?';
        this.Spa_Site_SameAsPrimary_Text = 'Same as primary';
        this.Spa_Member_Profile_MobilePhoneCopyMain_Enabled = true;
        this.Spa_Member_Profile_MobilePhoneCopyMain_Default = true;
        this.Spa_Site_TotalSiteCountsPPC_Enabled = false;
        this.Spa_DualPlanYear_Enabled = true;
        this.setFocus = false;
        this.isCRMDisable = true;
        this.salescontactDifferent = [];
        this.dirty = false;
        this.zipCode = '';
        this.initZipCode = '';
        this.initFipsCode = '';
        this.zipCodeStyles = { roundInputRightBorder: true };
        this.errorMessages = [];
        this.isZipValid = false;
        this.isExternalSave = false;
        this.showMedicareNumber = false;
        this.authRepControls = [
            'authRepFirstName',
            'authRepLastName',
            'authRepEmail',
            'authRepPhone',
            'authRepAddress1',
            'authRepAddress2',
            'authRepCity',
            'authRepState',
            'authRepZip',
            'authRepRelationship'
        ];
        this.memberRegistrationMap = {};
        this.mbiFieldName = 'mbi';
        this.mbiValidLength = 11;
        this.isPartAandBEffDateValidationEnabled = false;
        this.noSpecialCharactersError = '';
        this.eligibilityCheckProfileData = {
            firstName: '',
            lastName: '',
            dob: '',
            memberID: '',
            includeDSNPCheck: false
        };
        this.getZipCodeFunction = this.memberRegistrationFacade.getZipCodeSelected.bind(this.memberRegistrationFacade);
        this.getFipsCodeFunction = this.memberRegistrationFacade.getFipsCodeSelected.bind(this.memberRegistrationFacade);
        this.disableCellPhoneInput = false;
        this.subsidyIdChanged = false;
        this.agentCallRecordingInProgress = false;
        this.baseError = {
            severity: 'error',
            widgetId: this.widgetService.widgetId,
            errorData: null
        };
        this.subscriptions = new Subscription();
        this._requestSaveAndValidate$ = new Subject();
        this.validateWidget = () => {
            const errors = [];
            this.errorMessages.forEach(msg => {
                errors.push({
                    ...this.baseError,
                    errorData: msg.message,
                    property: ''
                });
            });
            return errors;
        };
        this.suggestedAddresses = (text$) => {
            if (!this.Spa_Member_Profile_AddressAutoComplete_Enabled) {
                return of([]);
            }
            return this.addressService.getAddresses$(text$.pipe(map(text => ({ partialAddress: text, zip: this.createMemberProfile.get('zip').value, selected: '' }))));
        };
        this.suggestedAuthRepAddresses = (text$) => {
            if (!this.Spa_Member_Profile_AddressAutoComplete_Enabled) {
                return of([]);
            }
            return this.addressService.getAddresses$(text$.pipe(map(text => ({ partialAddress: text, zip: this.createMemberProfile.get('authRepZip').value, selected: '' }))));
        };
        this.addressAutocompleteFormatter = (address) => address.street_line;
    }
    get alphaNumericPattern() {
        return FormValidationService.alphaNumericPattern;
    }
    requestSaveAndValidate() {
        this._requestSaveAndValidate$.next(null);
    }
    onRequestSaveAndValidate$() {
        return this._requestSaveAndValidate$.asObservable();
    }
    onSelectState(state) {
        this.createMemberProfile.get('state').setValue(state);
    }
    onSelectAuthRepState(state) {
        this.createMemberProfile.get('authRepState').setValue(state);
    }
    updateErrorStatus(errors) {
        if (errors.length) {
            this.isZipValid = false;
            this.cdr.markForCheck();
        }
    }
    getProfileConfig(key) {
        const profileConfig = this.memberRegistrationResources.find(i => i.keyName === key);
        return profileConfig || new MemberRegistration();
    }
    initalizeFormMap() {
        this.memberRegistrationResources.forEach(config => {
            this.memberRegistrationMap[config.keyName] = config;
        });
    }
    getDateFormat() {
        return DateUtilities.defaultFormat;
    }
    getDateMaskFormat() {
        return this.getDateFormat().replace(/\w/g, '0');
    }
    fieldHasError(fieldName) {
        const control = this.createMemberProfile.get(fieldName);
        if (this.errorMessages.length > 0 && control.value && control.dirty && control.valid) {
            this.removeErrorMessages(fieldName);
        }
        if (fieldName === this.mbiFieldName && control.value) {
            this.mbiError = this.getMbiValidationText(control.value);
            return !!this.mbiError;
        }
        if (fieldName === 'dateOfBirth' && control.value) {
            return this.getDateValidation(control.value);
        }
        if (fieldName === 'partAEffectiveDate' && control.value) {
            const validationData = this.memberRegistrationService.getPartAEffectiveDateValidation(control.value, this.createMemberProfile.get('dateOfBirth').value, this.createMemberProfile, this.effectiveDatePartAMaxFutureMonths, this.effectiveDatePartAMaxPastMonths);
            this.setPartAValidationErrorText(validationData.errorCase);
            return validationData.error;
        }
        if (fieldName === 'partBEffectiveDate' && control.value) {
            const validationData = this.memberRegistrationService.getPartBEffectiveDateValidation(control.value, this.createMemberProfile.get('dateOfBirth').value, this.createMemberProfile, this.effectiveDatePartBMaxFutureMonths, this.effectiveDatePartBMaxPastMonths, this.isPartAandBEffDateValidationEnabled, this.getProfileConfig('partAEffectiveDate'));
            this.setPartBValidationErrorText(validationData.errorCase);
            return validationData.error;
        }
        return !control.valid && control.touched;
    }
    setPartAValidationErrorText(error) {
        switch (error) {
            case EffectiveDateErrors.INVALID_EFFECTIVE_DATE:
                this.partAEffectiveDateError = this.Spa_Member_Profile_Invalid_PartAEffectiveDate_Text;
                break;
            case EffectiveDateErrors.AFTER_DATE_OF_BIRTH:
                this.partAEffectiveDateError = this.Spa_Member_Profile_PartAEffectiveDate_After_DateofBirth_Text;
                break;
            case EffectiveDateErrors.FUTURE_DATE:
                this.partAEffectiveDateError = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartA_Effective_FutureDateError_Text', null, 'Hospital (Part A) effective date is too far in the future');
                break;
            case EffectiveDateErrors.PAST_DATE:
                this.partAEffectiveDateError = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartA_Effective_PastDateError_Text', null, 'Hospital (Part A) effective date is too far in the past');
                break;
        }
    }
    setPartBValidationErrorText(error) {
        switch (error) {
            case EffectiveDateErrors.INVALID_EFFECTIVE_DATE:
                this.partBEffectiveDateError = this.Spa_Member_Profile_Invalid_PartBEffectiveDate_Text;
                break;
            case EffectiveDateErrors.AFTER_DATE_OF_BIRTH:
                this.partBEffectiveDateError = this.Spa_Member_Profile_PartBEffectiveDate_After_DateofBirth_Text;
                break;
            case EffectiveDateErrors.FUTURE_DATE:
                this.partBEffectiveDateError = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartB_Effective_FutureDateError_Text', null, 'Hospital (Part B) effective date is too far in the future');
                break;
            case EffectiveDateErrors.PAST_DATE:
                this.partBEffectiveDateError = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartB_Effective_PastDateError_Text', null, 'Medical (Part B) effective date is too far in the past');
                break;
            case EffectiveDateErrors.EFFECTIVE_DATE_AFTER_PART_A_EFFECTIVEDATE:
                this.partBEffectiveDateError = this.Spa_Member_Profile_PartBEffectiveDate_After_PartAEffectiveDate;
                break;
        }
    }
    getZipErrorText() {
        const zipValue = this.zipInput === undefined ? '' : this.zipInput.zipCodeControl.value;
        return zipValue ? this.Spa_Member_Profile_Invalid_ZipError_Text : this.getProfileConfig('zip').requiredText;
    }
    getCountySelectionText() {
        return this.memberRegistrationFacade.getCountyErrorText();
    }
    isCountySelectionCheckNeeded() {
        return this.memberRegistrationService.isCountySelectionCheckNeeded();
    }
    onOptionSelect(event) {
        if (event.data.value) {
            this.isAdditionalInformationRequired = true;
        }
        else {
            this.isAdditionalInformationRequired = false;
        }
    }
    updateDemographics() {
        const zip = this.createMemberProfile.get('zip').value;
        const countyFips = this.createMemberProfile.get('countyFips').value;
        const demographicZip = this.demographicService.getSelectedZipCode();
        const demographicFips = this.demographicService.getSelectedFipsCode();
        if (demographicZip !== zip || countyFips !== demographicFips) {
            this.demographicService.selectLocation(countyFips, zip);
        }
    }
    async saveMemberProfileExternal() {
        this.validateMemberProfile();
        if (this.createMemberProfile.dirty) {
            this.isExternalSave = true;
            if (await this.saveMemberProfile()) {
                return MemberSaveExecutionResultType.SuccessfulSave;
            }
            if (!this.createMemberProfile.valid) {
                this.isExternalSave = false;
                return MemberSaveExecutionResultType.ValidationError;
            }
            else {
                this.isExternalSave = false;
                return MemberSaveExecutionResultType.ServerError;
            }
        }
        else {
            return MemberSaveExecutionResultType.NoChangesDetected;
        }
    }
    async validateMemberProfile() {
        this.updateFormValueAndValidity();
        this.errorMessages = [];
        this.isZipValid = true;
        this.validateAuthRepFields();
        if (!this.zipInput.zipCodeControl.value) {
            this.isZipValid = false;
        }
        if (this.zipInput) {
            const zipInputWidgetId = this.zipInput.widgetService.widgetId;
            const zipErrors = this.widgetValidationService
                .validate({ widgetIds: [zipInputWidgetId] })
                .filter(error => error.widgetId === zipInputWidgetId);
            if (zipErrors?.length) {
                this.isZipValid = false;
            }
        }
        if (!this.createMemberProfile.value.zip || !this.isZipValid) {
            const zipControl = this.createMemberProfile.get('zip');
            zipControl.markAsTouched({ onlySelf: true });
            zipControl.setErrors({ invalid: true });
            zipControl.markAsDirty();
            this.widgetValidationService.validate();
        }
        if (this.isZipValid) {
            const countyFips = this.createMemberProfile.get('countyFips').value;
            await this.validateFipsCode(this.zipInput.zipCodeControl.value, countyFips);
        }
        this.setMemberProfileErrorMessages();
        this.cdr.markForCheck();
    }
    onClickSave() {
        this.requestSaveAndValidate();
    }
    async saveAndValidateMemberProfile() {
        await this.validateMemberProfile();
        return await this.saveMemberProfile();
    }
    saveAndValidateMemberProfile$() {
        return from(this.saveAndValidateMemberProfile());
    }
    async saveMemberProfile() {
        let saveSuccessful = false;
        // If searchTerm is a string instead of an object, they did not click an item in the dropdown
        // So save the text in the field to the address field
        if (this.addressSearchInput?.nativeElement && typeof this.addressSearchTerm === 'string') {
            const searchInputValue = this.addressSearchInput.nativeElement.value;
            this.createMemberProfile.get('address1').setValue(searchInputValue);
        }
        // While there will always be a member address field, there will not always be a sales rep address field,
        // So we need to check that before doing something with it.
        if (this.authRepAddressSearchInput?.nativeElement && typeof this.authRepAddressSearchTerm === 'string') {
            const searchInputValue = this.authRepAddressSearchInput.nativeElement.value;
            if (searchInputValue?.length > 0) {
                this.createMemberProfile.get('authRepAddress1').setValue(searchInputValue);
            }
        }
        if (this.createMemberProfile.valid) {
            if (!this.isExternalSave) {
                this.submitButton.toggleSpinner(true);
            }
            this.errorMessages = [];
            const gender = this.createMemberProfile.value.gender;
            const medicaidId = this.createMemberProfile.value.medicaidId;
            const apiMemberStateModel = {
                agentGuid: this.store.selectSnapshot(AgentState.agentGuid),
                memberID: this.store.selectSnapshot(MemberState.memberID),
                profile: {
                    firstName: this.createMemberProfile.value.firstName,
                    lastName: this.createMemberProfile.value.lastName,
                    birthdate: this.createMemberProfile.value.dateOfBirth,
                    emailAddress: this.createMemberProfile.value.email,
                    // MBI and HICN are considered/used the same
                    hicn: this.createMemberProfile.value.mbi,
                    homePhone: this.createMemberProfile.value.phone,
                    cellPhone: this.disableCellPhoneInput ? this.createMemberProfile.value.phone : this.createMemberProfile.value.cellPhone,
                    maritalStatus: 0,
                    middleInitial: '',
                    workPhone: '',
                    crmid: this.createMemberProfile.value.crm,
                    customField1: this.createMemberProfile.value.customField1,
                    customField2: this.createMemberProfile.value.customField2,
                    customField3: this.createMemberProfile.value.customField3,
                    customField4: this.createMemberProfile.value.customField4,
                    customField5: this.createMemberProfile.value.customField5,
                    addresses: [
                        {
                            address1: this.createMemberProfile.value.address1,
                            address2: this.createMemberProfile.value.address2,
                            city: this.createMemberProfile.value.city ?? '',
                            state: this.createMemberProfile.value.state ?? '',
                            countyFips: this.createMemberProfile.value.countyFips,
                            zip: this.createMemberProfile.value.zip,
                            isPrimaryAddress: true
                        }
                    ],
                    authRepData: {
                        firstName: this.createMemberProfile.value.authRepFirstName,
                        lastName: this.createMemberProfile.value.authRepLastName,
                        email: this.createMemberProfile.value.authRepEmail,
                        phoneNumber: this.createMemberProfile.value.authRepPhone,
                        addressLine1: this.createMemberProfile.value.authRepAddress1,
                        addressLine2: this.createMemberProfile.value.authRepAddress2,
                        city: this.createMemberProfile.value.authRepCity,
                        state: this.createMemberProfile.value.authRepState,
                        zipCode: this.createMemberProfile.value.authRepZip,
                        relationship: this.createMemberProfile.value.authRepRelationship
                    },
                    ...(gender && { gender }),
                    ...(medicaidId && { medicaidId })
                },
                demographic: {
                    zip: this.createMemberProfile.value.zip,
                    fips: this.fips,
                    birthdate: this.createMemberProfile.value.dateOfBirth,
                    ...(this.subsidyIdChanged && {
                        subsidySelected: this.demographicService.getSubsidySelected(),
                        subsidyPercent: this.demographicService.getSubsidyPercent()
                    })
                },
                medigapAnswers: {
                    partAEffectiveDate: this.createMemberProfile.value.partAEffectiveDate,
                    partBEffectiveDate: this.createMemberProfile.value.partBEffectiveDate
                }
            };
            // if member is new the name will not be defined initially
            // we omit pushing the datalayer event named "case-CreateAccount-Success"
            const omitCreateAccountAnalyticsEvent = !!this.store.selectSnapshot(ProfileState.fullName);
            await this.memberRegistrationFacade
                .updateProfile(apiMemberStateModel)
                .then(() => {
                this.submitButton.showSuccessMessage();
                this.updateEffectiveDates();
                this.submitButton.closeTooltip(TOOLTIP_TIMEOUT);
                this.createMemberProfile.markAsPristine();
                saveSuccessful = true;
                this.memberRegistrationFacade.updateGtm();
                if (!omitCreateAccountAnalyticsEvent) {
                    this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CASE_CREATE_ACCOUNT_SUCCESS);
                }
                this.cdr.markForCheck();
            })
                .catch(() => {
                if (!this.isExternalSave) {
                    this.submitButton.showErrorMessage();
                    this.submitButton.closeTooltip(TOOLTIP_TIMEOUT);
                    saveSuccessful = false;
                    this.cdr.markForCheck();
                }
                this.isExternalSave = false;
            });
        }
        else {
            this.setMemberProfileErrorMessages();
        }
        return saveSuccessful;
    }
    async validateFipsCode(zipCode, fipsCode) {
        if (this.isCountySelectionCheckNeeded()) {
            const { counties, isValid } = await this.zipCodeContextService.checkValidationStatus(zipCode, fipsCode);
            const countyFipsControl = this.createMemberProfile.get('countyFips');
            if (!isValid && counties.length > 1) {
                countyFipsControl.setErrors({ invalid: true });
                countyFipsControl.markAsDirty();
            }
            else {
                countyFipsControl.reset(countyFipsControl.value);
            }
        }
    }
    updateEffectiveDates() {
        this.memberSessionService.setPartAEffectiveDate(this.createMemberProfile.value.partAEffectiveDate);
        this.memberSessionService.setPartBEffectiveDate(this.createMemberProfile.value.partBEffectiveDate);
    }
    resetEffectiveDates() {
        this.memberSessionService.setPartAEffectiveDate(null);
        this.memberSessionService.setPartBEffectiveDate(null);
    }
    validateAuthRepFields() {
        if (this.isAdditionalInformationRequired) {
            this.authRepControls.forEach(controlName => {
                if (this.getProfileConfig(controlName).required && !this.createMemberProfile.get(controlName).value) {
                    this.createMemberProfile.get(controlName).setErrors({ invalid: true });
                }
            });
        }
        else {
            this.authRepControls.forEach(controlName => {
                if (this.getProfileConfig(controlName).required && !this.createMemberProfile.get(controlName).value) {
                    this.createMemberProfile.get(controlName).updateValueAndValidity();
                }
            });
        }
    }
    isAuthRepFieldRequired(controlName) {
        if (this.isAdditionalInformationRequired) {
            if (this.getProfileConfig(controlName).required) {
                return true;
            }
        }
        else {
            return false;
        }
    }
    // Sets the error messages for display in the error notice
    setErrorMessages(controlName) {
        if (!this.isAdditionalInformationRequired && this.authRepControls.includes(controlName)) {
            return;
        }
        this.createMemberProfile.get(controlName).markAsTouched({ onlySelf: true });
        if (this.createMemberProfile.get(controlName).dirty) {
            this.setCustomMessages(controlName);
        }
        else {
            this.errorMessages.push({ message: this.getProfileConfig(controlName).requiredText });
        }
        this.errorContainer.first.nativeElement.scrollIntoView({ behavior: 'smooth' });
        if (this.memberRegistrationMap[controlName]) {
            this.memberRegistrationMap[controlName].hasError = this.fieldHasError(controlName);
        }
        this.cdr.markForCheck();
    }
    /**
     * Remove error messages from notice container
     * @param controlName - name of the control
     */
    removeErrorMessages(controlName) {
        const control = this.createMemberProfile.get(controlName);
        const noticeMessage = this.getErrorMessage(controlName);
        if (controlName === 'zip' && this.zipInput?.zipCodeControl.value && this.isZipValid) {
            this.errorMessages = this.errorMessages.filter(p => p.message !== this.getProfileConfig(controlName).requiredText);
        }
        if (controlName === 'dateOfBirth' && control.value) {
            if (this.getDateValidation(control.value) === undefined) {
                this.errorMessages = this.errorMessages.filter(p => p.message !== noticeMessage.message);
            }
        }
        else {
            this.errorMessages = this.errorMessages.filter(p => p.message !== noticeMessage.message);
        }
        this.cdr.markForCheck();
    }
    /**
     * Get error messages of a control
     * @param controlName - name of the control
     */
    // eslint-disable-next-line complexity
    getErrorMessage(controlName) {
        const control = this.createMemberProfile.get(controlName);
        const controlHasValue = !!control.value;
        const config = this.getProfileConfig(controlName);
        const requiredText = config.requiredText;
        switch (controlName) {
            case 'zip':
                return { message: this.getZipErrorText() };
            case 'countyFips':
                return { message: this.getCountySelectionText() };
            case 'dateOfBirth':
                return { message: controlHasValue ? this.dobError : requiredText };
            case 'email':
                return {
                    message: controlHasValue ? this.Spa_Member_Profile_Invalid_EmailError_Text : requiredText
                };
            case this.mbiFieldName:
                return {
                    message: controlHasValue ? this.mbiError : requiredText
                };
            case 'phone':
                return {
                    message: controlHasValue ? this.Spa_Member_Profile_Invalid_PhoneError_Text : requiredText
                };
            case 'cellPhone':
                return {
                    message: controlHasValue ? this.Spa_Member_Profile_Invalid_CellPhoneError_Text : requiredText
                };
            case 'authRepEmail':
                return {
                    message: controlHasValue ? this.Spa_Member_Profile_Invalid_EmailError_Text : requiredText
                };
            case 'authRepPhone':
                return {
                    message: controlHasValue ? this.Spa_Member_Profile_Invalid_PhoneError_Text : requiredText
                };
            case 'partAEffectiveDate':
                return {
                    message: controlHasValue ? this.partAEffectiveDateError : requiredText
                };
            case 'partBEffectiveDate':
                return {
                    message: controlHasValue ? this.partBEffectiveDateError : requiredText
                };
            default:
                return { message: requiredText };
        }
    }
    /**
     * Set error messages of a control
     * @param controlName - name of the control
     */
    setCustomMessages(controlName) {
        const control = this.createMemberProfile.get(controlName);
        const config = this.getProfileConfig(controlName);
        switch (controlName) {
            case 'zip':
                this.errorMessages.push({ message: this.getZipErrorText() });
                break;
            case 'countyFips':
                this.errorMessages.push({ message: this.getCountySelectionText() });
                break;
            case 'customField1':
            case 'customField2':
            case 'customField3':
            case 'customField4':
            case 'customField5':
                if (control.errors?.pattern) {
                    this.errorMessages.push({
                        message: `${config.labelText} ${this.formValidationService.errorMessages.noSpecialCharacters().toLowerCase()}`
                    });
                }
                else {
                    this.errorMessages.push(this.getErrorMessage(controlName));
                }
                break;
            default:
                this.errorMessages.push(this.getErrorMessage(controlName));
                break;
        }
    }
    getMbiValidationText(mbi) {
        const mbiField = this.createMemberProfile.get(this.mbiFieldName);
        const mbiErrors = mbiField?.errors;
        if (mbi !== undefined && mbiErrors?.minlength) {
            return this.Spa_Member_Profile_MBI_Length_ErrorText;
        }
        if (mbi && mbiErrors?.pattern) {
            return this.Spa_Member_Profile_MBI_Valid_ErrorText;
        }
        return '';
    }
    getDateValidation(date) {
        if (date !== undefined && date.length < 10) {
            this.dobError = this.noDateError;
            this.createMemberProfile.get('dateOfBirth').markAsTouched({ onlySelf: true });
            return true;
        }
        if (date === '' || !DateUtilities.isValidDate(date)) {
            this.dobError = this.noDateError;
            this.createMemberProfile.get('dateOfBirth').markAsTouched({ onlySelf: true });
            return true;
        }
        if (DateUtilities.dateIsInFuture(date)) {
            this.dobError = this.futureDateError;
            this.createMemberProfile.get('dateOfBirth').markAsTouched({ onlySelf: true });
            return true;
        }
        if (!DateUtilities.dateIsInPastYearRange(date, this.maxAge)) {
            this.dobError = this.outOfRangeError;
            this.createMemberProfile.get('dateOfBirth').markAsTouched({ onlySelf: true });
            return true;
        }
    }
    updateAddressZip(zip) {
        const zipControl = this.createMemberProfile.get('zip');
        if (zipControl?.value !== zip) {
            zipControl.setValue(zip);
            zipControl.markAsDirty();
        }
        this.zipInput?.zipCodeControl?.setValue(zip, { emitEvent: true });
        this.updateDemographics();
    }
    updatePartAEffectiveDate(date) {
        const partAControl = this.createMemberProfile.get('partAEffectiveDate');
        partAControl.setValue(date);
        partAControl.markAsDirty();
        this.cdr.markForCheck();
    }
    updatePartBEffectiveDate(date) {
        const partBControl = this.createMemberProfile.get('partBEffectiveDate');
        partBControl.setValue(date);
        partBControl.markAsDirty();
        this.cdr.markForCheck();
    }
    updateAuthRepAddressZip(zip) {
        const authRepZipControl = this.createMemberProfile.get('authRepZip');
        authRepZipControl.setValue(zip);
        authRepZipControl.markAsDirty();
        this.cdr.markForCheck();
    }
    setFipsAndZipValidFlag(fips) {
        const countyFipsControl = this.createMemberProfile.get('countyFips');
        this.fips = fips;
        if (countyFipsControl.value !== fips) {
            countyFipsControl.setValue(fips);
            countyFipsControl.markAsDirty();
        }
        this.removeErrorMessages('countyFips');
        const zipControl = this.createMemberProfile.get('zip');
        zipControl.updateValueAndValidity();
        this.isZipValid = zipControl.valid;
        this.removeErrorMessages('zip');
        this.updateDemographics();
        this.cdr.markForCheck();
    }
    // During SPA-14930, it's been noticed that this doesn't seem to fire after you've clicked "leave page" on it once before.
    async showUnsavedChangesModal() {
        this.validateZipCode();
        if (this.isExternalSave || this.isCreateProfileFormPristine() || !this.createMemberProfile.dirty) {
            // This skips showing the modal
            return true;
        }
        if (this.agentCallRecordingInProgress) {
            this.agentCallRecordingShoppingFacade.setActionOnAcceptEndCallRecordingModal(() => {
                this.resetProfile(true, true);
            });
        }
        // To prevent any un-expected stuck spinner event at moment to shows up the modal
        this.spinnerService.reset();
        const modalTitle = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_LeavingPageModal_Title', null, 'Unsaved changes');
        const modalPrompt = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_LeavingPageModal_Message', null, 'Are you sure you want to leave without saving your changes');
        const modalCancel = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_LeavingPageModal_CancelButton', null, 'Stay on page');
        const modalLeave = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Site_LeavingPageModal_LeaveButton', null, 'Leave page');
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true });
        confirmationModal.componentInstance.title = modalTitle;
        confirmationModal.componentInstance.prompt = modalPrompt;
        confirmationModal.componentInstance.cancelButton = modalCancel;
        confirmationModal.componentInstance.confirmButton = modalLeave;
        return await confirmationModal.result
            .then(() => {
            this.spinnerService.show(SpinnerEvent.NAVIGATION);
            const resetable = !this.agentCallRecordingInProgress && this.currentMemberProfilePageTag !== PageTags.MEMBER_PROFILE_PAGE;
            return this.resetProfile(resetable, resetable);
        })
            .catch(() => false);
    }
    isCreateProfileFormPristine() {
        return Object.keys(this.createMemberProfile.controls).every(key => this.createMemberProfile.controls[key].pristine);
    }
    validateZipCode() {
        if (this.zipInput.zipCodeControl.value && this.zipInput.zipCodeControl.value.length !== 5) {
            this.createMemberProfile.get('zip').markAsDirty();
        }
    }
    updateEligibilityCheckData() {
        const eligibilityCheckProfileData = {
            ...this.eligibilityCheckProfileData
        };
        if (this.memberStateModel?.profile) {
            eligibilityCheckProfileData.firstName = this.memberStateModel.profile.firstName || this.memberStateModel.firstName;
            eligibilityCheckProfileData.lastName = this.memberStateModel.profile.lastName || this.memberStateModel.lastName;
            eligibilityCheckProfileData.dob = this.memberStateModel.profile.birthdate || this.memberStateModel.dateOfBirth;
        }
        eligibilityCheckProfileData.memberID = this.store.selectSnapshot(MemberState.memberID);
        eligibilityCheckProfileData.includeDSNPCheck = this.SPA_ProfileEligibilityCheck_DSNP_Enabled;
        this.eligibilityCheckProfileData = eligibilityCheckProfileData;
        this.subscriptions.add(this.createMemberProfile.get('firstName').valueChanges.subscribe({
            next: firstName => {
                this.eligibilityCheckProfileData = {
                    ...this.eligibilityCheckProfileData,
                    firstName
                };
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.createMemberProfile.get('lastName').valueChanges.subscribe({
            next: lastName => {
                this.eligibilityCheckProfileData = {
                    ...this.eligibilityCheckProfileData,
                    lastName
                };
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.createMemberProfile.get('dateOfBirth').valueChanges.subscribe({
            next: dateOfBirth => {
                this.eligibilityCheckProfileData = {
                    ...this.eligibilityCheckProfileData,
                    dob: dateOfBirth
                };
                this.cdr.markForCheck();
            }
        }));
        this.cdr.markForCheck();
    }
    updateProfileForm(event) {
        const formControl = this.createMemberProfile.get(event.fieldName);
        if (formControl?.value !== event.value) {
            formControl?.setValue(event.value);
            this.createMemberProfile.markAsDirty();
            this.createMemberProfile.markAsTouched();
        }
    }
    ngOnInit() {
        super.ngOnInit();
        this.phoneMask = FormValidationService.phoneMask;
        this.isCRMDisable = this.Spa_Member_Profile_Disable_CRMID;
        this.memberRegistrationResources = this.Spa_MemberRegistration_Resource_Content;
        this.formControlNames = this.memberRegistrationResources.map(resource => resource.keyName);
        this.salescontactDifferent = this.SPA_Member_Profile_Is_Sales_Contact_Different_Items;
        this.isAdditionalInformationRequired = false;
        this.mbiRegexPattern = RegexPattern.MBI_PATTERN;
        this.memberStateModel = this.memberRegistrationFacade.getCurrentMemberSession();
        this.primaryAddress = this.getPrimaryAddress();
        this.initializePartAEffectiveDateDropdown();
        this.initializePartBEffectiveDateDropdown();
        this.effectiveDateMonthList = this.effectiveDateFacade.getMonthList();
        this.isPartAandBEffDateValidationEnabled = this.memberRegistrationFacade.isPartAandBEffDateValidationEnabled();
        this.deactivationGuardService.addDeactivationGuard({
            canDeactivate: this.showUnsavedChangesModal.bind(this)
        });
        if (this.getDataFromPrimaryAddress('zip')) {
            this.isZipValid = true;
        }
        const crmValidations = [Validators.maxLength(100)];
        if (!this.isCRMDisable) {
            crmValidations.push(Validators.required);
        }
        const phoneValue = this.memberStateModel?.profile?.homePhone ?? this.store.selectSnapshot(MemberState.phoneNumber);
        this.setDefaultMobileCheckboxState(phoneValue);
        this.createMemberProfile = this.initCreateMemberProfileForm(phoneValue, crmValidations);
        if (this.Spa_ProfileEligiblityCheck_Enabled) {
            this.updateEligibilityCheckData();
        }
        if (this.getDataFromPrimaryAddress('zip')) {
            this.initZipCode = this.getDataFromPrimaryAddress('zip');
        }
        if (this.getDataFromPrimaryAddress('countyFips')) {
            this.initFipsCode = this.getDataFromPrimaryAddress('countyFips');
        }
        this.noDateError = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Member_Profile_NoBirthDateError_Text', null, 'Please provide a valid date of birth');
        this.futureDateError = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Member_Profile_FutureBirthDateError_Text', null, 'Please provide a date of birth in the past');
        this.outOfRangeError = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Member_Profile_BirthDateOutOfRangeError_Text', null, 'The date of birth is too far in the past');
        this.maxAge = this.configurableWidgetService.configResourceService.getProcessedResourceValue('Spa_Member_Profile_Maximum_Age', null, 105);
        this.addressSearchTerm = this.createMemberProfile.get('address1').value;
        this.authRepAddressSearchTerm = this.createMemberProfile.get('authRepAddress1').value;
        this.initalizeFormMap();
        if (this.memberRegistrationMap.crm) {
            this.memberRegistrationMap.crm.required = !this.isCRMDisable;
        }
        this.noSpecialCharactersError = this.formValidationService.errorMessages.noSpecialCharacters();
        this.initSubscriptions();
    }
    // eslint-disable-next-line complexity
    initCreateMemberProfileForm(phoneValue, crmValidations) {
        return new UntypedFormGroup({
            zip: new UntypedFormControl(this.getDataFromPrimaryAddress('zip'), FormValidationService.validateOnSubmit([Validators.required, Validators.minLength(5)], this)),
            countyFips: new UntypedFormControl(this.getDataFromPrimaryAddress('countyFips') ?? ''),
            firstName: new UntypedFormControl(this.memberStateModel.profile.firstName
                ? this.memberStateModel.profile.firstName
                : this.store.selectSnapshot(MemberState.firstName), this.addRequiredValidator([Validators.maxLength(100)], this.getProfileConfig('firstName')?.required)),
            lastName: new UntypedFormControl(this.memberStateModel.profile.lastName ? this.memberStateModel.profile.lastName : this.store.selectSnapshot(MemberState.lastName), this.addRequiredValidator([Validators.maxLength(100)], this.getProfileConfig('lastName')?.required)),
            dateOfBirth: new UntypedFormControl(this.memberStateModel.profile.birthdate
                ? this.formatDOB(this.memberStateModel.profile.birthdate)
                : this.memberSessionService.getMemberDateOfBirth(), this.addRequiredValidator([Validators.maxLength(12)], this.getProfileConfig('dateOfBirth')?.required)),
            email: new UntypedFormControl(this.memberStateModel.profile.emailAddress
                ? this.memberStateModel.profile.emailAddress
                : this.store.selectSnapshot(MemberState.emailAddress), this.addRequiredValidator([Validators.email, Validators.maxLength(255)], this.getProfileConfig('email').required)),
            phone: new UntypedFormControl(phoneValue, this.addRequiredValidator([Validators.maxLength(12)], this.getProfileConfig('phone').required)),
            cellPhone: new UntypedFormControl(this.getDefaultCellPhoneValue(phoneValue), this.addRequiredValidator([Validators.maxLength(12)], this.getProfileConfig('cellPhone')?.required)),
            // MBI and HICN are considered/used the same
            mbi: new UntypedFormControl(this.memberStateModel.profile.hicn ? this.profileCryptoService.getDecryptedHICN(this.memberStateModel.profile.hicn) : '', this.addRequiredValidator([Validators.minLength(this.mbiValidLength), Validators.maxLength(this.mbiValidLength)], this.getProfileConfig(this.mbiFieldName)?.required)),
            address1: new UntypedFormControl(this.getDataFromPrimaryAddress('address1'), this.addRequiredValidator([Validators.maxLength(255)], this.getProfileConfig('address1')?.required)),
            address2: new UntypedFormControl(this.getDataFromPrimaryAddress('address2'), this.addRequiredValidator([Validators.maxLength(255)], this.getProfileConfig('address2')?.required)),
            city: new UntypedFormControl(this.getDataFromPrimaryAddress('city'), this.addRequiredValidator([Validators.maxLength(255)], this.getProfileConfig('city')?.required)),
            state: new UntypedFormControl(this.getDataFromPrimaryAddress('state'), this.addRequiredValidator([Validators.maxLength(2)], this.getProfileConfig('state')?.required)),
            crm: new UntypedFormControl({ value: this.memberStateModel?.profile?.crmid ?? '', disabled: this.isCRMDisable }, this.getProfileConfig('crm')?.required ? FormValidationService.validateOnSubmit(crmValidations, this) : null),
            authRepFirstName: new UntypedFormControl(this.memberStateModel?.profile?.authRepData?.firstName ?? '', this.addRequiredValidator([Validators.maxLength(100)], this.getProfileConfig('authRepFirstName')?.required)),
            authRepLastName: new UntypedFormControl(this.memberStateModel?.profile?.authRepData?.lastName ?? '', this.addRequiredValidator([Validators.maxLength(100)], this.getProfileConfig('authRepLastName')?.required)),
            authRepEmail: new UntypedFormControl(this.memberStateModel?.profile?.authRepData?.email ?? '', this.addRequiredValidator([Validators.maxLength(100)], this.getProfileConfig('authRepEmail')?.required)),
            authRepPhone: new UntypedFormControl(this.memberStateModel?.profile?.authRepData?.phoneNumber ?? '', this.addRequiredValidator([Validators.maxLength(12)], this.getProfileConfig('authRepPhone')?.required)),
            authRepAddress1: new UntypedFormControl(this.memberStateModel?.profile?.authRepData?.addressLine1 ?? '', this.addRequiredValidator([Validators.maxLength(255)], this.getProfileConfig('authRepAddress1')?.required)),
            authRepAddress2: new UntypedFormControl(this.memberStateModel?.profile?.authRepData?.addressLine2 ?? '', this.addRequiredValidator([Validators.maxLength(255)], this.getProfileConfig('authRepAddress2')?.required)),
            authRepCity: new UntypedFormControl(this.memberStateModel?.profile?.authRepData?.city ?? '', this.addRequiredValidator([Validators.maxLength(255)], this.getProfileConfig('authRepCity')?.required)),
            authRepState: new UntypedFormControl(this.memberStateModel?.profile?.authRepData?.state ?? '', this.addRequiredValidator([Validators.maxLength(2)], this.getProfileConfig('authRepState')?.required)),
            authRepZip: new UntypedFormControl(this.memberStateModel?.profile?.authRepData?.zipCode ?? '', this.addRequiredValidator([Validators.maxLength(5)], this.getProfileConfig('authRepZip')?.required)),
            authRepRelationship: new UntypedFormControl(this.memberStateModel?.profile?.authRepData?.relationship ?? '', this.addRequiredValidator([Validators.maxLength(100)], this.getProfileConfig('authRepRelationship')?.required)),
            customField1: new UntypedFormControl(this.memberStateModel?.profile?.customField1 ?? '', FormValidationService.validateOnSubmit(this.getCustomFieldValidators(this.getProfileConfig('customField1')), this)),
            customField2: new UntypedFormControl(this.memberStateModel?.profile?.customField2 ?? '', FormValidationService.validateOnSubmit(this.getCustomFieldValidators(this.getProfileConfig('customField2')), this)),
            customField3: new UntypedFormControl(this.memberStateModel?.profile?.customField3 ?? '', FormValidationService.validateOnSubmit(this.getCustomFieldValidators(this.getProfileConfig('customField3')), this)),
            customField4: new UntypedFormControl(this.memberStateModel?.profile?.customField4 ?? '', FormValidationService.validateOnSubmit(this.getCustomFieldValidators(this.getProfileConfig('customField4')), this)),
            customField5: new UntypedFormControl(this.memberStateModel?.profile?.customField5 ?? '', FormValidationService.validateOnSubmit(this.getCustomFieldValidators(this.getProfileConfig('customField5')), this)),
            partAEffectiveDate: new UntypedFormControl(this.memberStateModel.medigapAnswers?.partAEffectiveDate
                ? DateUtilities.getFormattedDate(new Date(this.memberStateModel.medigapAnswers.partAEffectiveDate), DateUtilities.defaultFormat)
                : '', this.addRequiredValidator([Validators.maxLength(12)], this.getProfileConfig('partAEffectiveDate')?.required)),
            partBEffectiveDate: new UntypedFormControl(this.memberStateModel.medigapAnswers?.partBEffectiveDate
                ? DateUtilities.getFormattedDate(new Date(this.memberStateModel.medigapAnswers.partBEffectiveDate), DateUtilities.defaultFormat)
                : '', this.addRequiredValidator([Validators.maxLength(12)], this.getProfileConfig('partBEffectiveDate')?.required)),
            ...(this.genderEnabled && {
                gender: new UntypedFormControl(this.memberStateModel?.profile?.gender ?? 0, this.addRequiredValidator([], this.getProfileConfig('gender')?.required))
            }),
            ...(this.isStateEligibilityCheckEnabled && {
                medicaidId: new UntypedFormControl(this.memberStateModel?.profile?.medicaidId ?? '', this.addRequiredValidator([], this.getProfileConfig('medicaidId')?.required))
            })
        }, { updateOn: 'blur' });
    }
    initSubscriptions() {
        this.subscriptions.add(this.shoppingRecordingContextService.getCallInProgress$().subscribe({
            next: agentCallRecordingInProgress => {
                this.agentCallRecordingInProgress = agentCallRecordingInProgress;
            }
        }));
        const currentMemberSession$ = this.memberRegistrationFacade.getCurrentMemberSession$();
        this.subscriptions.add(currentMemberSession$.pipe(distinctUntilChanged(_isEqual)).subscribe({
            next: (model) => {
                if (this.memberStateModel?.memberID !== model?.memberID) {
                    this.memberStateModel = model;
                    this.eligibilityCheckProfileData = {
                        firstName: this.memberStateModel.profile?.firstName ?? '',
                        lastName: this.memberStateModel.profile?.lastName ?? '',
                        dob: this.memberStateModel.profile?.birthdate ?? '',
                        memberID: this.memberStateModel.memberID,
                        includeDSNPCheck: this.SPA_ProfileEligibilityCheck_DSNP_Enabled
                    };
                    this.cdr.detectChanges();
                }
                // Partially update the profile with Medicare and Medicaid status when the current profile changes.
                // We don't update the whole profile to avoid replacing the encrypted HICN with the decrypted value from the member session.
                else if (!_isEqual(this.memberStateModel?.profile, model?.profile)) {
                    const profile = this.extractMedicareAndMedicaidProfile(model?.profile);
                    if (profile) {
                        this.memberStateModel = _merge(_cloneDeep(this.memberStateModel), { profile });
                        this.cdr.detectChanges();
                    }
                }
            }
        }));
        this.subscriptions.add(combineLatest([
            this.memberRegistrationFacade.getCurrentMemberProfilePageTag$(),
            currentMemberSession$.pipe(map(memberState => memberState.memberID), distinctUntilChanged())
        ]).subscribe({
            next: ([currentMemberProfilePageTag, memberID]) => {
                this.currentMemberProfilePageTag = currentMemberProfilePageTag;
                if (currentMemberProfilePageTag === PageTags.ADD_NEW_PROFILE && !memberID) {
                    // This is mainly just to clear out the form if we're going from edit existing profile A to create new profile B.
                    this.resetProfile(true, true);
                    this.memberEligibilityCheckComponent?.resetFormOnHICNChange();
                }
            }
        }));
        this.subscriptions.add(this.onRequestSaveAndValidate$()
            .pipe(exhaustMap(() => this.saveAndValidateMemberProfile$()))
            .subscribe({
            next: () => {
                this.cdr.markForCheck();
            }
        }));
        const phoneControl = this.createMemberProfile.get('phone');
        const cellPhoneControl = this.createMemberProfile.get('cellPhone');
        if (this.Spa_Member_Profile_MobilePhoneCopyMain_Enabled && cellPhoneControl && phoneControl) {
            this.subscriptions.add(combineLatest([phoneControl.valueChanges, phoneControl.statusChanges]).subscribe({
                next: ([newValue, status]) => {
                    if (status === 'VALID' && this.disableCellPhoneInput) {
                        // This subscription makes sure that if the box is checked while the main phone field is invalid, it will update
                        // Once it is valid.
                        cellPhoneControl.setValue(newValue);
                        // TODO: These aren't doing anything. Is functionality broken, or should they be removed?
                        cellPhoneControl.markAsDirty();
                        cellPhoneControl.markAsTouched();
                        this.cdr.markForCheck();
                    }
                }
            }));
            this.cdr.markForCheck();
        }
        this.formControlNames.forEach(controlName => {
            this.subscriptions.add(this.isReadOnly$(controlName).subscribe({
                next: isReadOnly => {
                    if (this.memberRegistrationMap[controlName]) {
                        this.memberRegistrationMap[controlName].isReadOnly = isReadOnly;
                        this.cdr.markForCheck();
                    }
                }
            }));
            this.subscriptions.add(this.createMemberProfile.get(controlName)?.statusChanges.subscribe({
                next: status => {
                    if (this.memberRegistrationMap[controlName]) {
                        this.memberRegistrationMap[controlName].hasError = this.fieldHasError(controlName);
                        this.cdr.markForCheck();
                    }
                }
            }));
        });
        this.subscriptions.add(this.currentLocale$.subscribe({
            next: () => {
                this.effectiveDateMonthList = this.effectiveDateFacade.getMonthList();
                this.cdr.markForCheck();
            }
        }));
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
        const enableDSNPDisplay = this.Spa_GettingStarted_EnableDSNPDisplay_Flag || this.Spa_ProfileEligiblityCheck_Enabled;
        this.snpService.setDSNPTypesVisibilityOnMedicaidSubsidy(enableDSNPDisplay);
    }
    ngAfterViewInit() {
        if (this.memberStateModel.profile.firstName && this.memberStateModel.profile.lastName) {
            this.createMemberProfile.markAsPristine();
        }
        if (this.zipInput?.zipCodeControl?.valueChanges) {
            this.subscriptions.add(this.zipInput.zipCodeControl.valueChanges
                .pipe(startWith(this.memberRegistrationFacade.getZipCodeSelected()), distinctUntilChanged())
                .subscribe({
                next: zipCode => {
                    this.zipCode = zipCode;
                    this.cdr.markForCheck();
                }
            }));
        }
    }
    ngAfterViewChecked() {
        if (this.addressSearchInput?.nativeElement) {
            const addressSearchInput = this.addressSearchInput.nativeElement;
            if (!addressSearchInput.value) {
                if (addressSearchInput.getAttribute('initialized') === 'false' && this.addressSearchTerm) {
                    addressSearchInput.value = this.addressSearchTerm;
                }
            }
        }
        if (this.authRepAddressSearchInput?.nativeElement) {
            const authRepAddressSearchInput = this.authRepAddressSearchInput.nativeElement;
            if (!authRepAddressSearchInput.value) {
                if (authRepAddressSearchInput.getAttribute('initialized') === 'false' && this.authRepAddressSearchTerm) {
                    authRepAddressSearchInput.value = this.authRepAddressSearchTerm;
                }
            }
        }
        if (this.setFocus) {
            for (const key of Object.keys(this.createMemberProfile.controls)) {
                if (this.createMemberProfile.controls[key].invalid) {
                    const invalidControl = this.element.nativeElement.querySelector('.has-error');
                    if (invalidControl) {
                        invalidControl.focus();
                    }
                    break;
                }
            }
            this.setFocus = false;
        }
    }
    focusAddressInput() {
        // A null check on nativeElement is not required here due to this only be called when you interact with the element,
        // which means that the element has to already exist.
        this.addressSearchInput.nativeElement.setAttribute('initialized', 'true');
    }
    focusAuthRepAddressInput() {
        // A null check on nativeElement is not required here due to this only be called when you interact with the element,
        // which means that the element has to already exist.
        this.authRepAddressSearchInput.nativeElement.setAttribute('initialized', 'true');
    }
    hasSalesContactSelection() {
        if (this.isAnyAuthRepDataPresentInProfile()) {
            return (this.isAdditionalInformationRequired = true);
        }
    }
    formatDOB(dob) {
        const dateofbirth = DateUtilities.getFormattedDate(new Date(dob));
        if (this.createMemberProfile) {
            this.createMemberProfile.value.dateOfBirth = dateofbirth;
        }
        return dateofbirth;
    }
    // ----- Start typeahead -----
    selectItemForAddress(event) {
        const address = event.item;
        // TODO: SPA-???? add functionality for making a new call and replace dropdown with sub-results when multiple entries
        // if (address.entires === 0) { // stuff below } else { // ???}
        // <span *ngIf="r.entries >= 1" class="text-right font-weight-bold"></span>
        this.createMemberProfile.get('address1').setValue(address.street_line ? address.street_line : '');
        this.createMemberProfile.get('city').setValue(address.city ? address.city : '');
        this.createMemberProfile.get('address2').setValue(address.secondary ? address.secondary : '');
        this.createMemberProfile.get('state').setValue(address.state ? address.state : '');
        this.updateAddressZip(address.zipcode ? address.zipcode : '');
        this.validateWidget();
        this.typeahead.dismissPopup();
        this.cdr.detectChanges();
    }
    selectItemForAuthRepAddress(event) {
        const address = event.item;
        // TODO: SPA-???? add functionality for making a new call and replace dropdown with sub-results when multiple entries
        // if (address.entires === 0) { // stuff below } else { // ???}
        // <span *ngIf="r.entries >= 1" class="text-right font-weight-bold"></span>
        this.createMemberProfile.get('authRepAddress1').setValue(address.street_line ? address.street_line : '');
        this.createMemberProfile.get('authRepCity').setValue(address.city ? address.city : '');
        this.createMemberProfile.get('authRepAddress2').setValue(address.secondary ? address.secondary : '');
        this.createMemberProfile.get('authRepState').setValue(address.state ? address.state : '');
        this.updateAuthRepAddressZip(address.zipcode ? address.zipcode : '');
        this.validateWidget();
        this.typeahead.dismissPopup();
        this.cdr.detectChanges();
    }
    scrollItemIntoView() {
        this.autoCompleteService.scrollItemIntoView(this.typeahead);
    }
    isReadOnly$(key) {
        if (key) {
            switch (key) {
                case 'zip':
                    return this.ssoPopulatedFieldService.isFieldReadOnly$('Profile.ZipCode');
                case 'firstName':
                    return this.ssoPopulatedFieldService.isFieldReadOnly$('Profile.FirstName');
                case 'lastName':
                    return this.ssoPopulatedFieldService.isFieldReadOnly$('Profile.LastName');
                case 'dateOfBirth':
                    return this.ssoPopulatedFieldService.isFieldReadOnly$('Profile.Birthdate');
                case 'email':
                    return this.ssoPopulatedFieldService.isFieldReadOnly$('Profile.PrimaryEmailAddress');
                case 'phone':
                    return this.ssoPopulatedFieldService.isFieldReadOnly$('Profile.HomePhone');
                case 'cellPhone':
                    return this.ssoPopulatedFieldService.isFieldReadOnly$('Profile.CellPhone');
                case 'mbi':
                    return this.ssoPopulatedFieldService.isFieldReadOnly$('Profile.Mbi');
                case 'address1':
                case 'address2':
                case 'city':
                case 'state':
                    return this.ssoPopulatedFieldService.isFieldReadOnly$('Profile.Address');
                default:
                    return of(false);
            }
        }
        return of(false);
    }
    setSubsidyIdChanged(change) {
        this.subsidyIdChanged = change;
    }
    toggleCellPhoneCheckbox() {
        this.disableCellPhoneInput = !this.disableCellPhoneInput;
        const phoneControl = this.createMemberProfile.get('phone');
        if (phoneControl?.valid && this.disableCellPhoneInput) {
            this.createMemberProfile.get('cellPhone')?.setValue(phoneControl.value);
        }
    }
    updateFormValueAndValidity() {
        if (this.createMemberProfile?.controls) {
            for (const control of Object.values(this.createMemberProfile.controls)) {
                control.updateValueAndValidity();
            }
        }
    }
    getDefaultCellPhoneValue(phoneValue) {
        const existingCellPhoneValue = this.memberStateModel.profile.cellPhone;
        return (this.disableCellPhoneInput ? phoneValue : existingCellPhoneValue) ?? '';
    }
    setDefaultMobileCheckboxState(phoneValue) {
        if (this.Spa_Member_Profile_MobilePhoneCopyMain_Enabled) {
            // An existing account has to have a zip. At the time of this check, we can't just use memberId, as a new one will have
            // been generated. Both existing and new flows use the /EditProfile PageTag, making a check for zip about the only way
            // at this step to tell. An account must have a zip, so the lack of one means it's new.
            const isExistingProfile = this.isZipValid;
            if (isExistingProfile) {
                const mobilePhoneValue = this.memberStateModel.profile.cellPhone;
                // If we have both values and they are the same, check the box, else leave it unchecked
                this.disableCellPhoneInput = !!phoneValue && !!mobilePhoneValue && phoneValue === mobilePhoneValue;
            }
            else {
                this.resetDisableCellPhoneCheckbox();
            }
        }
        else {
            // We don't have the feature enabled, so make sure the box is off.
            this.disableCellPhoneInput = false;
        }
    }
    setMemberProfileErrorMessages() {
        const controls = this.createMemberProfile.controls;
        this.errorMessages = [];
        for (const name in controls) {
            if (controls[name].invalid) {
                this.setErrorMessages(name);
            }
        }
        this.setFocus = true;
    }
    // ----- End typeahead -----
    isAnyAuthRepDataPresentInProfile() {
        if (this.memberStateModel.profile?.authRepData &&
            (this.memberStateModel.profile.authRepData.firstName ||
                this.memberStateModel.profile.authRepData.lastName ||
                this.memberStateModel.profile.authRepData.phoneNumber ||
                this.memberStateModel.profile.authRepData.relationship ||
                this.memberStateModel.profile.authRepData.addressLine1 ||
                this.memberStateModel.profile.authRepData.addressLine2 ||
                this.memberStateModel.profile.authRepData.city ||
                this.memberStateModel.profile.authRepData.state ||
                this.memberStateModel.profile.authRepData.email)) {
            return true;
        }
    }
    getCustomFieldValidators(customField) {
        const requiredCustomFieldValidators = [Validators.required, Validators.maxLength(255)];
        const notRequiredCustomFieldValidators = [Validators.maxLength(255)];
        return customField.required ? requiredCustomFieldValidators : notRequiredCustomFieldValidators;
    }
    initializePartAEffectiveDateDropdown() {
        this.effectiveDatePartAMaxFutureMonths = this.effectiveDateFacade.getPartAEffectiveMaxFutureMonths();
        this.effectiveDatePartAMaxPastMonths = this.effectiveDateFacade.getPartAEffectiveMaxPastMonths();
        this.effectiveDatePartAMonthRange = this.effectiveDateFacade.getMonthsForDropdownParts(this.effectiveDatePartAMaxPastMonths, this.effectiveDatePartAMaxFutureMonths);
        this.effectiveDatePartAYearRange = this.effectiveDateFacade.getYearsForDropdown(this.effectiveDatePartAMaxPastMonths, this.effectiveDatePartAMaxFutureMonths);
    }
    initializePartBEffectiveDateDropdown() {
        this.effectiveDatePartBMaxFutureMonths = this.effectiveDateFacade.getPartBEffectiveMaxFutureMonths();
        this.effectiveDatePartBMaxPastMonths = this.effectiveDateFacade.getPartBEffectiveMaxPastMonths();
        this.effectiveDatePartBMonthRange = this.effectiveDateFacade.getMonthsForDropdownParts(this.effectiveDatePartBMaxPastMonths, this.effectiveDatePartBMaxFutureMonths);
        this.effectiveDatePartBYearRange = this.effectiveDateFacade.getYearsForDropdown(this.effectiveDatePartBMaxPastMonths, this.effectiveDatePartBMaxFutureMonths);
    }
    getPrimaryAddress() {
        const primaryAddress = this.memberStateModel.profile?.addresses?.find(address => address.isPrimaryAddress);
        return primaryAddress ?? this.memberStateModel.profile?.addresses?.[0];
    }
    getDataFromPrimaryAddress(attributeName) {
        return this.primaryAddress?.[attributeName] ?? '';
    }
    resetMemberSession() {
        this.profileFacade.logOutMember();
        this.profileFacade.newMemberSession();
    }
    resetProfileForm() {
        this.createMemberProfile.reset();
        // SPA-14930, there was originally a comment here about updateAddressZip being called at some point after this function,
        // but that seemed to no longer be the case. Added it back here as it seems to be fine, and there's no obvious spot
        // where it was originally supposed to be.
        this.createMemberProfile.get('zip')?.setValue('');
        this.addressSearchTerm = '';
        this.initZipCode = '';
        this.initFipsCode = '';
        this.updateAddressZip('');
        this.resetEffectiveDates();
        this.resetDisableCellPhoneCheckbox();
    }
    resetProfile(resetProfile, resetMember) {
        if (resetProfile) {
            this.resetProfileForm();
        }
        if (resetMember) {
            this.resetMemberSession();
        }
        return true;
    }
    addRequiredValidator(validators, required) {
        const newValidators = validators;
        if (required) {
            newValidators.push(Validators.required);
        }
        return FormValidationService.validateOnSubmit(newValidators, this);
    }
    resetDisableCellPhoneCheckbox() {
        this.disableCellPhoneInput = this.Spa_Member_Profile_MobilePhoneCopyMain_Default;
        this.cdr.markForCheck();
    }
    extractMedicareAndMedicaidProfile(profile) {
        if (profile) {
            const { isMedicareEligible, isDSNPEligible, lastCheckedDate, medicaidId, medicaidCheckStatus, isMedicaidEligible, eligibilityLevel, medicaidLastCheckedDate, medicaidStateSelection, clientMessage } = profile;
            return {
                ...(isMedicareEligible !== undefined && { isMedicareEligible }),
                ...(isDSNPEligible !== undefined && { isDSNPEligible }),
                ...(lastCheckedDate !== undefined && { lastCheckedDate }),
                ...(medicaidId !== undefined && { medicaidId }),
                ...(medicaidCheckStatus !== undefined && { medicaidCheckStatus }),
                ...(isMedicaidEligible !== undefined && { isMedicaidEligible }),
                ...(eligibilityLevel !== undefined && { eligibilityLevel }),
                ...(medicaidLastCheckedDate !== undefined && { medicaidLastCheckedDate }),
                ...(medicaidStateSelection !== undefined && { medicaidStateSelection }),
                ...(clientMessage !== undefined && { clientMessage })
            };
        }
    }
}
MemberRegistrationComponent.ɵfac = function MemberRegistrationComponent_Factory(t) { return new (t || MemberRegistrationComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(i1.DeactivationGuardService), i0.ɵɵdirectiveInject(ProfileFacade), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.FormValidationService), i0.ɵɵdirectiveInject(MemberRegistrationFacade), i0.ɵɵdirectiveInject(MemberRegistrationService), i0.ɵɵdirectiveInject(ZipCodeContextService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.AddressService), i0.ɵɵdirectiveInject(i1.AutoCompleteService), i0.ɵɵdirectiveInject(i1.SSOPopulatedFieldService), i0.ɵɵdirectiveInject(EffectiveDateFacade), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.DemographicService), i0.ɵɵdirectiveInject(i1.ProfileCryptoService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(AgentCallRecordingShoppingFacade), i0.ɵɵdirectiveInject(i1.ShoppingRecordingContextService), i0.ɵɵdirectiveInject(i1.SNPService)); };
MemberRegistrationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MemberRegistrationComponent, selectors: [["vnext-member-registration"]], viewQuery: function MemberRegistrationComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(MemberEligibilityCheckComponent, 5);
        i0.ɵɵviewQuery(StatusButtonComponent, 5);
        i0.ɵɵviewQuery(_c0$1u, 5);
        i0.ɵɵviewQuery(_c1$F, 5);
        i0.ɵɵviewQuery(_c2$r, 5);
        i0.ɵɵviewQuery(_c3$g, 5);
        i0.ɵɵviewQuery(_c4$8, 5);
        i0.ɵɵviewQuery(_c5$5, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.memberEligibilityCheckComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.submitButton = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.zipInput = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.typeahead = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addressSearchInput = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.authRepAddressSearchInput = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.ngFormInstance = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.errorContainer = _t);
    } }, inputs: { profileSubHeaderLabel: "profileSubHeaderLabel", profileHomeHeaderLabel: "profileHomeHeaderLabel", profileAdditionalInformationHeaderLabel: "profileAdditionalInformationHeaderLabel", profileSectionHeaderSalesInformationLabel: "profileSectionHeaderSalesInformationLabel", profileIsSalesContactDifferentLabel: "profileIsSalesContactDifferentLabel", profileSaveButtonLabel: "profileSaveButtonLabel", datePickerMinDate: "datePickerMinDate", datePickerMaxDate: "datePickerMaxDate", showDatePicker: "showDatePicker", isStateEligibilityCheckEnabled: "isStateEligibilityCheckEnabled", stateEligibilityCheckDescription: "stateEligibilityCheckDescription", medicaidIdLabel: "medicaidIdLabel", stateEligibilityCheckButtonLabel: "stateEligibilityCheckButtonLabel", noMedicaidIdErrorLabel: "noMedicaidIdErrorLabel", eligibilityCheckPendingLabel: "eligibilityCheckPendingLabel", eligibilityCheckPendingDescriptionLabel: "eligibilityCheckPendingDescriptionLabel", noZipCodeText: "noZipCodeText", medicaidCodeText: "medicaidCodeText", medicaidCheckDateReceivedText: "medicaidCheckDateReceivedText", medicaidCheckDays: "medicaidCheckDays", medicaidCheckCannotCompleteErrorText: "medicaidCheckCannotCompleteErrorText", medicaidCheckedNoteText: "medicaidCheckedNoteText", isFederalEligibilityForStateRequired: "isFederalEligibilityForStateRequired", federalEligibilityForStateRequiredText: "federalEligibilityForStateRequiredText", stateNotEligibleText: "stateNotEligibleText", medicaidIntegrationConfig: "medicaidIntegrationConfig", notEligibleText: "notEligibleText", showSubsidyAccordionOnProfile: "showSubsidyAccordionOnProfile", optionalLabel: "optionalLabel", genderEnabled: "genderEnabled", genderItems: "genderItems", genderLabel: "genderLabel", genderRequiredErrorText: "genderRequiredErrorText" }, outputs: { sendDate: "sendDate" }, features: [i0.ɵɵProvidersFeature([InputResetContextService]), i0.ɵɵInheritDefinitionFeature], decls: 62, vars: 159, consts: [[3, "formGroup", "ngSubmit"], ["ngFormInstance", "ngForm"], ["class", "Spa_Style_H2 personal-information", 4, "liveEditProp"], ["errorContainer", ""], [4, "ngIf"], [1, "member-registration-container"], [1, "row", "mb-1"], [1, "col"], [3, "zipCodeText", "isProfileZip", "defaultZipCode", "defaultFipsCode", "zipCodeErrorText", "customStyles", "checkCounty", "isReadOnly", "emitOnEmptyValue", "countyLabel", "showCountyLabel", "retrieveZipCode", "retrieveFipsCode", "totalCountsMessageEnabled", "totalCountsYearClickable", "zip", "fips", "onError"], ["memberRegistrationZipInput", ""], ["type", "hidden", "formControlName", "zip"], ["type", "hidden", "formControlName", "countyFips"], [1, "row", "mb-1", "align-items-baseline"], [1, "col-lg-4", "col-md-6", "col-12"], [1, "w-100", 3, "ngClass"], ["class", "error-container", 4, "ngIf"], ["class", "input-error-asterisk", 4, "ngIf"], ["for", "firstName", 1, "Spa_Style_Label", 3, "ngClass"], [3, "ngClass"], ["id", "firstName", "type", "text", "formControlName", "firstName", 1, "w-100", 3, "ngClass", "readonly"], ["for", "lastName", 1, "Spa_Style_Label", 3, "ngClass"], ["id", "lastName", "type", "text", "formControlName", "lastName", 1, "w-100", 3, "ngClass", "readonly"], ["class", "col-lg-4 col-md-6 col-12", 4, "ngIf"], ["class", "Spa_Style_H3 w-100", 4, "liveEditProp"], ["class", "Spa_Style_Label", 4, "liveEditProp"], ["ngClass", "Spa_Style_Label", 3, "items", "verticalGrow", "lightBackground", "darkenOnHover", "largerText", "buttonHeight", "selectedValue", "limitButtonWidth", "limitButtonWidthClass", "optionSelected"], ["class", "Spa_Style_H3 mt-2", 4, "liveEditProp"], [1, "row"], [4, "ngFor", "ngForOf"], [1, "col-12"], ["class", "profile-submit", "disabled", "!createMemberProfile.valid", 3, "buttonText", "tooltipMessageError", "tooltipMessageSuccess", "buttonClass", "isButtonTypeSubmit", 4, "liveEditProp"], [3, "checkEnabled", "showSubsidyAccordionOnProfile", "memberRegistrationResources", "mbiRegexPattern", "showMedicareNumber", "openSubsidyText", "mbiError", "hideText", "showText", "dropdownPartAEnabled", "dropdownPartBEnabled", "profileEligibilityButtonText", "headerText", "errorKeywordText", "formDescriptionText", "accordionHeaderText", "medicareEligibleText", "dsnpText", "dsnpChangedFromText", "mbiFieldName", "effectiveDatePartAMaxFutureMonths", "effectiveDatePartAMaxPastMonths", "effectiveDatePartBMaxFutureMonths", "effectiveDatePartBMaxPastMonths", "mbiValidLength", "effectiveDateMonthList", "effectiveDatePartAMonthRange", "effectiveDatePartAYearRange", "effectiveDatePartBMonthRange", "effectiveDatePartBYearRange", "isMedicareEligible", "isDSNPEligible", "lastCheckedDate", "hicn", "subsidySelected", "subsidyPercent", "partAEffectiveDate", "partBEffectiveDate", "memberRegistrationMap", "eligibilityCheckProfileData", "isPartAandBEffDateValidationEnabled", "lastCheckedDateText", "requiredFieldError", "notEligibleText", "requestErrorText", "isStateEligibilityCheckEnabled", "stateEligibilityCheckDescription", "medicaidIdLabel", "stateEligibilityCheckButtonLabel", "noMedicaidIdErrorLabel", "eligibilityCheckPendingLabel", "eligibilityCheckPendingDescriptionLabel", "isZipValid", "noZipCodeText", "zipCode", "countyFips", "medicaidId", "medicaidCheckStatus", "isMedicaidEligible", "medicaidEligibilityLevel", "medicaidLastCheckedDate", "medicaidStateSelection", "medicaidClientMessage", "medicaidCodeText", "medicaidCheckDateReceivedText", "medicaidCheckDays", "medicaidCheckCannotCompleteErrorText", "medicaidCheckedNoteText", "isFederalEligibilityForStateRequired", "isProfileEligibilityCheckDSNPEnabled", "federalEligibilityForStateRequiredText", "stateNotEligibleText", "medicaidIntegrationConfig", "optionalLabel", "genderEnabled", "genderItems", "genderLabel", "defaultGender", "genderRequiredErrorText", "mbiValidErrorText", "msiDataChanged", "subsidyIdChanged"], [1, "Spa_Style_H2", "personal-information"], [3, "title", "messages", "type"], [1, "error-container"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], [1, "input-error-asterisk"], ["for", "dateOfBirth", 1, "w-75", "Spa_Style_Label", 3, "ngClass"], ["id", "dateOfBirth", "type", "text", "inputmode", "numeric", "autocomplete", "off", "formControlName", "dateOfBirth", 1, "w-50", "date-of-birth", 3, "placeholder", "mask", "dropSpecialCharacters", "ngClass", "readonly", "blur"], ["for", "email", 1, "Spa_Style_Label", 3, "ngClass"], ["id", "email", "type", "email", "formControlName", "email", 1, "w-100", 3, "ngClass", "readonly"], ["for", "phone", 1, "Spa_Style_Label", "w-75", 3, "ngClass"], ["id", "phone", "type", "text", "inputmode", "numeric", "formControlName", "phone", 1, "w-50", "primary-phone", 3, "mask", "ngClass", "readonly"], ["for", "cellPhone", 1, "Spa_Style_Label", "w-75", 3, "ngClass"], ["id", "cellPhone", "type", "text", "inputmode", "numeric", "formControlName", "cellPhone", 1, "w-50", "cell-phone", 3, "mask", "ngClass", "readonly"], ["for", "sameAsPrimaryCheckbox", "class", "w-100", 4, "ngIf"], ["for", "sameAsPrimaryCheckbox", 1, "w-100"], ["type", "checkbox", "id", "sameAsPrimaryCheckbox", 3, "value", "checked", "change"], [1, "pl-2", "Spa_Style_Primary_Color"], [1, "Spa_Style_H3", "w-100"], [1, "w-100", "address-autocomplete-wrapper", 3, "ngClass"], ["for", "memberRegistrationAddressLabelId", 1, "Spa_Style_Label", 3, "ngClass"], ["addressResultTemplate", ""], ["id", "memberRegistrationAddressLabelId", "type", "text", "placement", "bottom-left", 1, "form-control", "w-100", 3, "ngbTypeahead", "ngClass", "resultTemplate", "inputFormatter", "ngModelOptions", "readonly", "ngModel", "ngModelChange", "selectItem", "keyup", "focus"], ["addressSearchInput", "", "typeahead", "ngbTypeahead"], [1, "Spa_Style_H5", "no-translate-block"], [3, "result", "term"], ["for", "address2", 1, "w-100", 3, "ngClass"], [1, "Spa_Style_Label", 3, "ngClass"], ["id", "address2", "type", "text", "formControlName", "address2", 1, "w-100", 3, "ngClass", "readonly"], ["for", "city", 1, "Spa_Style_Label", 3, "ngClass"], ["id", "city", "type", "text", "formControlName", "city", 1, "w-100", 3, "ngClass", "readonly"], [1, "state-selector"], [3, "control", "height", "controlValue", "isReadOnly"], ["for", "crm", 1, "Spa_Style_Label"], ["id", "crm", "type", "text", "formControlName", "crm", 1, "w-100", 3, "ngClass"], [1, "Spa_Style_Label"], ["for", "authRepFirstName", 1, "Spa_Style_Label"], ["id", "authRepFirstName", "type", "text", "formControlName", "authRepFirstName", 1, "w-100", 3, "ngClass"], ["for", "authRepLastName", 1, "Spa_Style_Label"], ["id", "authRepLastName", "type", "text", "formControlName", "authRepLastName", "vnextDisableSSOPopulatedField", "Profile.LastName", 1, "w-100", 3, "ngClass"], ["for", "authRepRelationship", 1, "Spa_Style_Label"], ["id", "authRepRelationship", "type", "text", "formControlName", "authRepRelationship", 1, "w-100", 3, "ngClass"], ["for", "authRepEmail", 1, "Spa_Style_Label"], ["id", "authRepEmail", "type", "email", "formControlName", "authRepEmail", 1, "w-100", 3, "ngClass"], ["for", "authRepPhone", 1, "Spa_Style_Label"], ["id", "authRepPhone", "type", "text", "inputmode", "numeric", "formControlName", "authRepPhone", 1, "w-100", 3, "mask", "ngClass"], ["for", "authRepAddress1", 1, "Spa_Style_Label"], ["authRepAddressResultTemplate", ""], ["id", "authRepAddress1", "type", "text", "placement", "bottom-left", 1, "form-control", "w-100", 3, "ngbTypeahead", "ngClass", "resultTemplate", "inputFormatter", "ngModelOptions", "ngModel", "ngModelChange", "selectItem", "keyup", "focus"], ["authRepAddressSearchInput", "", "typeahead", "ngbTypeahead"], ["for", "authRepAddress2", 1, "Spa_Style_Label"], ["id", "authRepAddress2", "type", "text", "formControlName", "authRepAddress2", "maxlength", "50", 1, "w-100", 3, "ngClass"], ["for", "authRepCity", 1, "Spa_Style_Label"], ["id", "authRepCity", "type", "text", "formControlName", "authRepCity", "maxlength", "50", 1, "w-100", 3, "ngClass"], [3, "control", "height", "controlValue"], ["for", "authRepZip", 1, "Spa_Style_Label"], [1, "w-100"], ["digitOnly", "", "id", "authRepZip", "type", "text", "formControlName", "authRepZip", "maxlength", "5", "minlength", "5", "inputmode", "numeric", "pattern", "[0-9]*", "autocomplete", "off", 1, "w-50", 3, "ngClass"], [1, "Spa_Style_H3", "mt-2"], ["class", "col-12 col-md-6 col-lg-4 my-2", 4, "ngIf"], [1, "col-12", "col-md-6", "col-lg-4", "my-2"], [1, "Spa_Style_Label", 3, "for"], ["maxlength", "255", "type", "text", 1, "w-100", 3, "id", "formControlName", "ngClass"], ["disabled", "!createMemberProfile.valid", 1, "profile-submit", 3, "buttonText", "tooltipMessageError", "tooltipMessageSuccess", "buttonClass", "isButtonTypeSubmit"]], template: function MemberRegistrationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 0, 1);
        i0.ɵɵlistener("ngSubmit", function MemberRegistrationComponent_Template_form_ngSubmit_0_listener() { return ctx.onClickSave(); });
        i0.ɵɵtemplate(2, MemberRegistrationComponent_h2_2_Template, 2, 1, "h2", 2);
        i0.ɵɵelementStart(3, "div", null, 3);
        i0.ɵɵtemplate(5, MemberRegistrationComponent_ng_container_5_Template, 3, 3, "ng-container", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5)(7, "div", 6)(8, "div", 7)(9, "vnext-zip-code-input", 8, 9);
        i0.ɵɵlistener("zip", function MemberRegistrationComponent_Template_vnext_zip_code_input_zip_9_listener($event) { return ctx.updateAddressZip($event); })("fips", function MemberRegistrationComponent_Template_vnext_zip_code_input_fips_9_listener($event) { return ctx.setFipsAndZipValidFlag($event); })("onError", function MemberRegistrationComponent_Template_vnext_zip_code_input_onError_9_listener($event) { return ctx.updateErrorStatus($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(11, "input", 10)(12, "input", 11);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "div", 12)(14, "div", 13)(15, "label", 14);
        i0.ɵɵtemplate(16, MemberRegistrationComponent_div_16_Template, 3, 1, "div", 15);
        i0.ɵɵtemplate(17, MemberRegistrationComponent_span_17_Template, 2, 0, "span", 16);
        i0.ɵɵelementStart(18, "label", 17)(19, "span", 18);
        i0.ɵɵtext(20);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(21, "input", 19);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(22, "div", 13)(23, "label", 14);
        i0.ɵɵtemplate(24, MemberRegistrationComponent_div_24_Template, 3, 1, "div", 15);
        i0.ɵɵtemplate(25, MemberRegistrationComponent_span_25_Template, 2, 0, "span", 16);
        i0.ɵɵelementStart(26, "label", 20)(27, "span", 18);
        i0.ɵɵtext(28);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(29, "input", 21);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(30, MemberRegistrationComponent_div_30_Template, 8, 20, "div", 22);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "div", 12);
        i0.ɵɵtemplate(32, MemberRegistrationComponent_div_32_Template, 8, 17, "div", 22);
        i0.ɵɵtemplate(33, MemberRegistrationComponent_div_33_Template, 8, 18, "div", 22);
        i0.ɵɵtemplate(34, MemberRegistrationComponent_div_34_Template, 9, 19, "div", 22);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(35, "br");
        i0.ɵɵelementStart(36, "div", 6)(37, "div", 7);
        i0.ɵɵtemplate(38, MemberRegistrationComponent_h3_38_Template, 2, 1, "h3", 23);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(39, "div", 12);
        i0.ɵɵtemplate(40, MemberRegistrationComponent_div_40_Template, 12, 24, "div", 22);
        i0.ɵɵtemplate(41, MemberRegistrationComponent_div_41_Template, 8, 17, "div", 22);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(42, "div", 12);
        i0.ɵɵtemplate(43, MemberRegistrationComponent_div_43_Template, 8, 17, "div", 22);
        i0.ɵɵtemplate(44, MemberRegistrationComponent_div_44_Template, 9, 16, "div", 22);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(45, "br");
        i0.ɵɵtemplate(46, MemberRegistrationComponent_h3_46_Template, 2, 1, "h3", 23);
        i0.ɵɵelementStart(47, "div", 12);
        i0.ɵɵtemplate(48, MemberRegistrationComponent_div_48_Template, 8, 12, "div", 22);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(49, "div", 6)(50, "div", 13);
        i0.ɵɵtemplate(51, MemberRegistrationComponent_span_51_Template, 2, 1, "span", 24);
        i0.ɵɵelementStart(52, "vnext-toggle-select", 25);
        i0.ɵɵlistener("optionSelected", function MemberRegistrationComponent_Template_vnext_toggle_select_optionSelected_52_listener($event) { return ctx.onOptionSelect($event); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(53, "br");
        i0.ɵɵtemplate(54, MemberRegistrationComponent_div_54_Template, 15, 10, "div", 4);
        i0.ɵɵtemplate(55, MemberRegistrationComponent_h3_55_Template, 2, 1, "h3", 26);
        i0.ɵɵelementStart(56, "div", 27);
        i0.ɵɵtemplate(57, MemberRegistrationComponent_ng_container_57_Template, 2, 1, "ng-container", 28);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(58, "div", 27)(59, "div", 29);
        i0.ɵɵtemplate(60, MemberRegistrationComponent_vnext_status_button_60_Template, 1, 5, "vnext-status-button", 30);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(61, "vnext-widgets-member-eligiblity-check", 31);
        i0.ɵɵlistener("msiDataChanged", function MemberRegistrationComponent_Template_vnext_widgets_member_eligiblity_check_msiDataChanged_61_listener($event) { return ctx.updateProfileForm($event); })("subsidyIdChanged", function MemberRegistrationComponent_Template_vnext_widgets_member_eligiblity_check_subsidyIdChanged_61_listener($event) { return ctx.setSubsidyIdChanged($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.createMemberProfile);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "SPA_Member_Profile_Sub_Header_Label");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.errorMessages.length && !ctx.createMemberProfile.valid);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("zipCodeText", ctx.memberRegistrationMap["zip"] == null ? null : ctx.memberRegistrationMap["zip"].labelText)("isProfileZip", true)("defaultZipCode", ctx.initZipCode)("defaultFipsCode", ctx.initFipsCode)("zipCodeErrorText", ctx.getZipErrorText())("customStyles", ctx.zipCodeStyles)("checkCounty", ctx.isCountySelectionCheckNeeded())("isReadOnly", ctx.memberRegistrationMap["zip"] == null ? null : ctx.memberRegistrationMap["zip"].isReadOnly)("emitOnEmptyValue", true)("countyLabel", ctx.Spa_ZipCodeInput_CountyLabel_Text)("showCountyLabel", ctx.Spa_ZipCodeInput_CountyLabel_Enabled)("retrieveZipCode", ctx.getZipCodeFunction)("retrieveFipsCode", ctx.getFipsCodeFunction)("totalCountsMessageEnabled", ctx.Spa_Site_TotalSiteCountsPPC_Enabled)("totalCountsYearClickable", ctx.Spa_DualPlanYear_Enabled);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(140, _c6$5, ctx.memberRegistrationMap["firstName"] == null ? null : ctx.memberRegistrationMap["firstName"].hasError));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.memberRegistrationMap["firstName"] == null ? null : ctx.memberRegistrationMap["firstName"].hasError);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.memberRegistrationMap["firstName"] == null ? null : ctx.memberRegistrationMap["firstName"].required);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(142, _c7$4, ctx.memberRegistrationMap["firstName"] == null ? null : ctx.memberRegistrationMap["firstName"].isReadOnly));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(144, _c8$3, ctx.memberRegistrationMap["firstName"] == null ? null : ctx.memberRegistrationMap["firstName"].hasError));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1("", ctx.memberRegistrationMap["firstName"] == null ? null : ctx.memberRegistrationMap["firstName"].labelText, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(146, _c9$1, ctx.memberRegistrationMap["firstName"] == null ? null : ctx.memberRegistrationMap["firstName"].hasError, ctx.memberRegistrationMap["firstName"] == null ? null : ctx.memberRegistrationMap["firstName"].isReadOnly))("readonly", ctx.memberRegistrationMap["firstName"] == null ? null : ctx.memberRegistrationMap["firstName"].isReadOnly);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(149, _c6$5, ctx.memberRegistrationMap["lastName"] == null ? null : ctx.memberRegistrationMap["lastName"].hasError));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.memberRegistrationMap["lastName"] == null ? null : ctx.memberRegistrationMap["lastName"].hasError);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.memberRegistrationMap["lastName"] == null ? null : ctx.memberRegistrationMap["lastName"].required);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(151, _c7$4, ctx.memberRegistrationMap["lastName"] == null ? null : ctx.memberRegistrationMap["lastName"].isReadOnly));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(153, _c8$3, ctx.memberRegistrationMap["lastName"] == null ? null : ctx.memberRegistrationMap["lastName"].hasError));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1("", ctx.memberRegistrationMap["lastName"] == null ? null : ctx.memberRegistrationMap["lastName"].labelText, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(155, _c9$1, ctx.memberRegistrationMap["lastName"] == null ? null : ctx.memberRegistrationMap["lastName"].hasError, ctx.memberRegistrationMap["lastName"] == null ? null : ctx.memberRegistrationMap["lastName"].isReadOnly))("readonly", ctx.memberRegistrationMap["lastName"] == null ? null : ctx.memberRegistrationMap["lastName"].isReadOnly);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.memberRegistrationMap["dateOfBirth"] == null ? null : ctx.memberRegistrationMap["dateOfBirth"].display);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.memberRegistrationMap["email"] == null ? null : ctx.memberRegistrationMap["email"].display);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.memberRegistrationMap["phone"] == null ? null : ctx.memberRegistrationMap["phone"].display);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.memberRegistrationMap["cellPhone"] == null ? null : ctx.memberRegistrationMap["cellPhone"].display);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("liveEditProp", "SPA_Member_Profile_Home_Header_Label");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.memberRegistrationMap["address1"] == null ? null : ctx.memberRegistrationMap["address1"].display);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.memberRegistrationMap["address2"] == null ? null : ctx.memberRegistrationMap["address2"].display);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.memberRegistrationMap["city"] == null ? null : ctx.memberRegistrationMap["city"].display);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.memberRegistrationMap["state"] == null ? null : ctx.memberRegistrationMap["state"].display);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "SPA_Member_Profile_SectionHeader_Sales_Information_Label");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.memberRegistrationMap["crm"] == null ? null : ctx.memberRegistrationMap["crm"].display);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "SPA_Member_Profile_Is_Sales_Contact_Different_Label");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("items", ctx.salescontactDifferent)("verticalGrow", false)("lightBackground", false)("darkenOnHover", false)("largerText", true)("buttonHeight", "36px")("selectedValue", ctx.hasSalesContactSelection())("limitButtonWidth", true)("limitButtonWidthClass", "mt-3");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isAdditionalInformationRequired);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "SPA_Member_Profile_Additional_Information_Header_Label");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(158, _c11$1));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "Spa_Member_Profile_Save_Button_Label");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("checkEnabled", ctx.Spa_ProfileEligiblityCheck_Enabled)("showSubsidyAccordionOnProfile", ctx.showSubsidyAccordionOnProfile)("memberRegistrationResources", ctx.memberRegistrationResources)("mbiRegexPattern", ctx.mbiRegexPattern)("showMedicareNumber", ctx.showMedicareNumber)("openSubsidyText", ctx.Spa_ProfileEligiblity_OpenSubsidyText)("mbiError", ctx.mbiError)("hideText", ctx.Spa_Site_Hide_Text)("showText", ctx.Spa_Site_Show_Text)("dropdownPartAEnabled", ctx.Spa_Member_Profile_PartAEffectiveDate_DropDown_Enabled)("dropdownPartBEnabled", ctx.Spa_Member_Profile_PartBEffectiveDate_DropDown_Enabled)("profileEligibilityButtonText", ctx.Spa_ProfileEligiblity_ButtonText)("headerText", ctx.Spa_ProfileEligiblity_Header)("errorKeywordText", ctx.Spa_ProfileEligiblity_ErrorText)("formDescriptionText", ctx.Spa_ProfileEligiblity_Description)("accordionHeaderText", ctx.Spa_ProfileEligiblity_PrescriptionDrugsText)("medicareEligibleText", ctx.SPA_ProfileEligiblityCheck_MedicareEligibleText)("dsnpText", ctx.SPA_ProfileEligiblityCheck_DSNPText)("dsnpChangedFromText", ctx.SPA_ProfileEligiblityCheck_ChangedFrom_DSNPText)("mbiFieldName", ctx.mbiFieldName)("effectiveDatePartAMaxFutureMonths", ctx.effectiveDatePartAMaxFutureMonths)("effectiveDatePartAMaxPastMonths", ctx.effectiveDatePartAMaxPastMonths)("effectiveDatePartBMaxFutureMonths", ctx.effectiveDatePartBMaxFutureMonths)("effectiveDatePartBMaxPastMonths", ctx.effectiveDatePartBMaxPastMonths)("mbiValidLength", ctx.mbiValidLength)("effectiveDateMonthList", ctx.effectiveDateMonthList)("effectiveDatePartAMonthRange", ctx.effectiveDatePartAMonthRange)("effectiveDatePartAYearRange", ctx.effectiveDatePartAYearRange)("effectiveDatePartBMonthRange", ctx.effectiveDatePartBMonthRange)("effectiveDatePartBYearRange", ctx.effectiveDatePartBYearRange)("isMedicareEligible", ctx.memberStateModel == null ? null : ctx.memberStateModel.profile == null ? null : ctx.memberStateModel.profile.isMedicareEligible)("isDSNPEligible", ctx.memberStateModel == null ? null : ctx.memberStateModel.profile == null ? null : ctx.memberStateModel.profile.isDSNPEligible)("lastCheckedDate", ctx.memberStateModel == null ? null : ctx.memberStateModel.profile == null ? null : ctx.memberStateModel.profile.lastCheckedDate)("hicn", ctx.memberStateModel == null ? null : ctx.memberStateModel.profile == null ? null : ctx.memberStateModel.profile.hicn)("subsidySelected", ctx.memberStateModel == null ? null : ctx.memberStateModel.demographic == null ? null : ctx.memberStateModel.demographic.subsidySelected)("subsidyPercent", ctx.memberStateModel == null ? null : ctx.memberStateModel.demographic == null ? null : ctx.memberStateModel.demographic.subsidyPercent)("partAEffectiveDate", ctx.memberStateModel == null ? null : ctx.memberStateModel.medigapAnswers == null ? null : ctx.memberStateModel.medigapAnswers.partAEffectiveDate)("partBEffectiveDate", ctx.memberStateModel == null ? null : ctx.memberStateModel.medigapAnswers == null ? null : ctx.memberStateModel.medigapAnswers.partBEffectiveDate)("memberRegistrationMap", ctx.memberRegistrationMap)("mbiRegexPattern", ctx.mbiRegexPattern)("eligibilityCheckProfileData", ctx.eligibilityCheckProfileData)("isPartAandBEffDateValidationEnabled", ctx.isPartAandBEffDateValidationEnabled)("lastCheckedDateText", ctx.Spa_ProfileEligiblity_Last_Checked_Date_Text)("requiredFieldError", ctx.SPA_ProfileEligiblityCheck_RequiredFieldError)("notEligibleText", ctx.notEligibleText)("requestErrorText", ctx.SPA_ProfileEligibilityCheck_Request_Error)("isStateEligibilityCheckEnabled", ctx.isStateEligibilityCheckEnabled)("stateEligibilityCheckDescription", ctx.stateEligibilityCheckDescription)("medicaidIdLabel", ctx.medicaidIdLabel)("stateEligibilityCheckButtonLabel", ctx.stateEligibilityCheckButtonLabel)("noMedicaidIdErrorLabel", ctx.noMedicaidIdErrorLabel)("eligibilityCheckPendingLabel", ctx.eligibilityCheckPendingLabel)("eligibilityCheckPendingDescriptionLabel", ctx.eligibilityCheckPendingDescriptionLabel)("isZipValid", ctx.isZipValid)("noZipCodeText", ctx.noZipCodeText)("zipCode", ctx.zipCode)("countyFips", ctx.createMemberProfile == null ? null : ctx.createMemberProfile.value == null ? null : ctx.createMemberProfile.value.countyFips)("medicaidId", ctx.memberStateModel == null ? null : ctx.memberStateModel.profile == null ? null : ctx.memberStateModel.profile.medicaidId)("medicaidCheckStatus", ctx.memberStateModel == null ? null : ctx.memberStateModel.profile == null ? null : ctx.memberStateModel.profile.medicaidCheckStatus)("isMedicaidEligible", ctx.memberStateModel == null ? null : ctx.memberStateModel.profile == null ? null : ctx.memberStateModel.profile.isMedicaidEligible)("medicaidEligibilityLevel", ctx.memberStateModel == null ? null : ctx.memberStateModel.profile == null ? null : ctx.memberStateModel.profile.eligibilityLevel)("medicaidLastCheckedDate", ctx.memberStateModel == null ? null : ctx.memberStateModel.profile == null ? null : ctx.memberStateModel.profile.medicaidLastCheckedDate)("medicaidStateSelection", ctx.memberStateModel == null ? null : ctx.memberStateModel.profile == null ? null : ctx.memberStateModel.profile.medicaidStateSelection)("medicaidClientMessage", ctx.memberStateModel == null ? null : ctx.memberStateModel.profile == null ? null : ctx.memberStateModel.profile.clientMessage)("medicaidCodeText", ctx.medicaidCodeText)("medicaidCheckDateReceivedText", ctx.medicaidCheckDateReceivedText)("medicaidCheckDays", ctx.medicaidCheckDays)("medicaidCheckCannotCompleteErrorText", ctx.medicaidCheckCannotCompleteErrorText)("medicaidCheckedNoteText", ctx.medicaidCheckedNoteText)("isFederalEligibilityForStateRequired", ctx.isFederalEligibilityForStateRequired)("isProfileEligibilityCheckDSNPEnabled", ctx.SPA_ProfileEligibilityCheck_DSNP_Enabled)("federalEligibilityForStateRequiredText", ctx.federalEligibilityForStateRequiredText)("stateNotEligibleText", ctx.stateNotEligibleText)("medicaidIntegrationConfig", ctx.medicaidIntegrationConfig)("optionalLabel", ctx.optionalLabel)("genderEnabled", ctx.genderEnabled)("genderItems", ctx.genderItems)("genderLabel", ctx.genderLabel)("defaultGender", ctx.memberStateModel == null ? null : ctx.memberStateModel.profile == null ? null : ctx.memberStateModel.profile.gender)("genderRequiredErrorText", ctx.genderRequiredErrorText)("mbiValidErrorText", ctx.Spa_Member_Profile_MBI_Valid_ErrorText);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.MinLengthValidator, i4.MaxLengthValidator, i4.PatternValidator, i4.NgModel, i4.FormGroupDirective, i4.FormControlName, ZipCodeInputComponent, ToggleSelectComponent, StatusButtonComponent, StateSelectorInputComponent, NoticeComponent, LiveEditPropDirective, IconAriaAttributesDirective, i1$1.NgbTypeahead, i1$1.NgbHighlight, i3.DigitOnlyDirective, i8.MaskDirective, MemberEligibilityCheckComponent], styles: [".profile-submit[_ngcontent-%COMP%]{position:relative;float:right;padding-left:0;padding-right:0}.member-registration-container[_ngcontent-%COMP%]{padding:18px;position:relative;margin-top:10px;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;border:1px solid var(--static-Spa_Style_Accent1);border-radius:4px;background-clip:border-box}.personal-information[_ngcontent-%COMP%]{padding-top:30px}.date-of-birth[_ngcontent-%COMP%], .primary-phone[_ngcontent-%COMP%], .cell-phone[_ngcontent-%COMP%]{min-width:135px}.button-inside[_ngcontent-%COMP%]{width:300px;position:relative}.input-clear-button[_ngcontent-%COMP%]{margin:0;width:100%;outline:none;border-radius:5px}.link-position[_ngcontent-%COMP%]{position:absolute;border-radius:5px;right:20px;margin-top:6px;margin-right:3px;z-index:2;border:none;height:30px;cursor:pointer;color:#fff;transform:translate(2px)}.show-mbi-as-password[_ngcontent-%COMP%]{-webkit-text-security:disc}.state-selector[_ngcontent-%COMP%]{max-width:100px}@-moz-document url-prefix(){.show-mbi-as-password{font-family:text-security-disc;font-size:1.5rem;padding-top:10px!important}}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){.show-mbi-as-password[_ngcontent-%COMP%]{font-family:text-security-disc;font-size:1.2rem;padding-top:12px!important}}"] });
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_Save_Failed_ErrorText", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_Save_Success_Text", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_NoBirthDateError_Text", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_FutureBirthDateError_Text", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_Invalid_EmailError_Text", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_Invalid_PhoneError_Text", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_Invalid_CellPhoneError_Text", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_Invalid_PartAEffectiveDate_Text", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_Invalid_PartBEffectiveDate_Text", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_Invalid_ZipError_Text", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_MBI_Valid_ErrorText", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_MBI_Length_ErrorText", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Site_Show_Text", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Site_Hide_Text", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_ErrorMessages_TitleText", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_PartAEffectiveDate_After_DateofBirth_Text", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_PartBEffectiveDate_After_DateofBirth_Text", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_PartBEffectiveDate_After_PartAEffectiveDate", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_Disable_CRMID", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Text", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Enabled", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "SPA_Member_Profile_Is_Sales_Contact_Different_Items", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_PartAEffectiveDate_DropDown_Enabled", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_PartBEffectiveDate_DropDown_Enabled", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_MemberRegistration_Resource_Content", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_AddressAutoComplete_Enabled", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_ProfileEligiblityCheck_Enabled", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "SPA_ProfileEligibilityCheck_DSNP_Enabled", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_GettingStarted_EnableDSNPDisplay_Flag", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_ProfileEligiblity_Header", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "SPA_ProfileEligiblityCheck_RequiredFieldError", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_ProfileEligiblity_Last_Checked_Date_Text", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "SPA_ProfileEligiblityCheck_MedicareEligibleText", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "SPA_ProfileEligiblityCheck_DSNPText", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "SPA_ProfileEligiblityCheck_ChangedFrom_DSNPText", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_ProfileEligiblity_Description", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_ProfileEligiblity_ButtonText", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_ProfileEligiblity_ErrorText", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_ProfileEligiblity_OpenSubsidyText", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "SPA_ProfileEligibilityCheck_Request_Error", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_ProfileEligiblity_PrescriptionDrugsText", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Site_SameAsPrimary_Text", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_MobilePhoneCopyMain_Enabled", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Member_Profile_MobilePhoneCopyMain_Default", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_Site_TotalSiteCountsPPC_Enabled", void 0);
__decorate([
    GlobalResource()
], MemberRegistrationComponent.prototype, "Spa_DualPlanYear_Enabled", void 0);
__decorate([
    LiveEditInactive()
], MemberRegistrationComponent.prototype, "saveMemberProfile", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberRegistrationComponent, [{
        type: Component,
        args: [{ selector: 'vnext-member-registration', providers: [InputResetContextService], template: "<form [formGroup]=\"createMemberProfile\" #ngFormInstance=\"ngForm\" (ngSubmit)=\"onClickSave()\">\r\n  <h2 *liveEditProp=\"'SPA_Member_Profile_Sub_Header_Label'\" class=\"Spa_Style_H2 personal-information\">\r\n    {{ profileSubHeaderLabel }}\r\n  </h2>\r\n  <div #errorContainer>\r\n    <ng-container *ngIf=\"errorMessages.length && !createMemberProfile.valid\">\r\n      <div>\r\n        <vnext-notice [title]=\"Spa_Member_Profile_ErrorMessages_TitleText\" [messages]=\"errorMessages\" [type]=\"'error'\"> </vnext-notice>\r\n      </div>\r\n    </ng-container>\r\n  </div>\r\n  <div class=\"member-registration-container\">\r\n    <div class=\"row mb-1\">\r\n      <div class=\"col\">\r\n        <vnext-zip-code-input\r\n          #memberRegistrationZipInput\r\n          [zipCodeText]=\"memberRegistrationMap['zip']?.labelText\"\r\n          (zip)=\"updateAddressZip($event)\"\r\n          (fips)=\"setFipsAndZipValidFlag($event)\"\r\n          [isProfileZip]=\"true\"\r\n          [defaultZipCode]=\"initZipCode\"\r\n          [defaultFipsCode]=\"initFipsCode\"\r\n          [zipCodeErrorText]=\"getZipErrorText()\"\r\n          [customStyles]=\"zipCodeStyles\"\r\n          [checkCounty]=\"isCountySelectionCheckNeeded()\"\r\n          (onError)=\"updateErrorStatus($event)\"\r\n          [isReadOnly]=\"memberRegistrationMap['zip']?.isReadOnly\"\r\n          [emitOnEmptyValue]=\"true\"\r\n          [countyLabel]=\"Spa_ZipCodeInput_CountyLabel_Text\"\r\n          [showCountyLabel]=\"Spa_ZipCodeInput_CountyLabel_Enabled\"\r\n          [retrieveZipCode]=\"getZipCodeFunction\"\r\n          [retrieveFipsCode]=\"getFipsCodeFunction\"\r\n          [totalCountsMessageEnabled]=\"Spa_Site_TotalSiteCountsPPC_Enabled\"\r\n          [totalCountsYearClickable]=\"Spa_DualPlanYear_Enabled\"\r\n        >\r\n        </vnext-zip-code-input>\r\n        <input type=\"hidden\" formControlName=\"zip\" />\r\n        <input type=\"hidden\" formControlName=\"countyFips\" />\r\n      </div>\r\n    </div>\r\n    <div class=\"row mb-1 align-items-baseline\">\r\n      <div class=\"col-lg-4 col-md-6 col-12\">\r\n        <label class=\"w-100\" [ngClass]=\"{ 'has-error': memberRegistrationMap['firstName']?.hasError }\">\r\n          <div class=\"error-container\" *ngIf=\"memberRegistrationMap['firstName']?.hasError\">\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span *ngIf=\"memberRegistrationMap['firstName']?.required\">{{ memberRegistrationMap['firstName']?.requiredText }}</span>\r\n          </div>\r\n          <span *ngIf=\"memberRegistrationMap['firstName']?.required\" class=\"input-error-asterisk\">*</span>\r\n          <label\r\n            for=\"firstName\"\r\n            class=\"Spa_Style_Label\"\r\n            [ngClass]=\"{ 'readonly Spa_Style_Gray4_Color': memberRegistrationMap['firstName']?.isReadOnly }\"\r\n          >\r\n            <span [ngClass]=\"{ 'error-color': memberRegistrationMap['firstName']?.hasError }\"\r\n              >{{ memberRegistrationMap['firstName']?.labelText }}\r\n            </span>\r\n          </label>\r\n          <input\r\n            id=\"firstName\"\r\n            type=\"text\"\r\n            class=\"w-100\"\r\n            formControlName=\"firstName\"\r\n            [ngClass]=\"{\r\n              'has-error': memberRegistrationMap['firstName']?.hasError,\r\n              'Spa_Style_Gray4_Color readonly': memberRegistrationMap['firstName']?.isReadOnly\r\n            }\"\r\n            [readonly]=\"memberRegistrationMap['firstName']?.isReadOnly\"\r\n          />\r\n        </label>\r\n      </div>\r\n      <div class=\"col-lg-4 col-md-6 col-12\">\r\n        <label class=\"w-100\" [ngClass]=\"{ 'has-error': memberRegistrationMap['lastName']?.hasError }\">\r\n          <div class=\"error-container\" *ngIf=\"memberRegistrationMap['lastName']?.hasError\">\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span *ngIf=\"memberRegistrationMap['lastName']?.required\">{{ memberRegistrationMap['lastName']?.requiredText }}</span>\r\n          </div>\r\n          <span *ngIf=\"memberRegistrationMap['lastName']?.required\" class=\"input-error-asterisk\">*</span>\r\n          <label\r\n            for=\"lastName\"\r\n            class=\"Spa_Style_Label\"\r\n            [ngClass]=\"{ 'readonly Spa_Style_Gray4_Color': memberRegistrationMap['lastName']?.isReadOnly }\"\r\n          >\r\n            <span [ngClass]=\"{ 'error-color': memberRegistrationMap['lastName']?.hasError }\"\r\n              >{{ memberRegistrationMap['lastName']?.labelText }}\r\n            </span>\r\n          </label>\r\n          <input\r\n            id=\"lastName\"\r\n            type=\"text\"\r\n            class=\"w-100\"\r\n            formControlName=\"lastName\"\r\n            [ngClass]=\"{\r\n              'has-error': memberRegistrationMap['lastName']?.hasError,\r\n              'Spa_Style_Gray4_Color readonly': memberRegistrationMap['lastName']?.isReadOnly\r\n            }\"\r\n            [readonly]=\"memberRegistrationMap['lastName']?.isReadOnly\"\r\n          />\r\n        </label>\r\n      </div>\r\n\r\n      <div *ngIf=\"memberRegistrationMap['dateOfBirth']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n        <label class=\"w-100\" [ngClass]=\"{ 'has-error': memberRegistrationMap['dateOfBirth']?.hasError }\">\r\n          <div class=\"error-container\" *ngIf=\"memberRegistrationMap['dateOfBirth']?.hasError\">\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span *ngIf=\"memberRegistrationMap['dateOfBirth']?.required && !createMemberProfile.controls.dateOfBirth?.value\">{{\r\n              memberRegistrationMap['dateOfBirth']?.requiredText\r\n            }}</span>\r\n            <span *ngIf=\"memberRegistrationMap['dateOfBirth']?.hasError && createMemberProfile.controls.dateOfBirth?.value\">{{\r\n              dobError\r\n            }}</span>\r\n          </div>\r\n          <span *ngIf=\"memberRegistrationMap['dateOfBirth']?.required\" class=\"input-error-asterisk\">*</span>\r\n          <label\r\n            for=\"dateOfBirth\"\r\n            class=\"w-75 Spa_Style_Label\"\r\n            [ngClass]=\"{ 'readonly Spa_Style_Gray4_Color': memberRegistrationMap['dateOfBirth']?.isReadOnly }\"\r\n          >\r\n            <span [ngClass]=\"{ 'error-color': memberRegistrationMap['dateOfBirth']?.hasError }\"\r\n              >{{ memberRegistrationMap['dateOfBirth']?.labelText }}\r\n            </span>\r\n          </label>\r\n          <input\r\n            id=\"dateOfBirth\"\r\n            type=\"text\"\r\n            class=\"w-50 date-of-birth\"\r\n            inputmode=\"numeric\"\r\n            autocomplete=\"off\"\r\n            placeholder=\"{{ getDateFormat() }}\"\r\n            mask=\"{{ getDateMaskFormat() }}\"\r\n            formControlName=\"dateOfBirth\"\r\n            [dropSpecialCharacters]=\"false\"\r\n            [ngClass]=\"{\r\n              'has-error': memberRegistrationMap['dateOfBirth']?.hasError,\r\n              'Spa_Style_Gray4_Color readonly': memberRegistrationMap['dateOfBirth']?.isReadOnly\r\n            }\"\r\n            [readonly]=\"memberRegistrationMap['dateOfBirth']?.isReadOnly\"\r\n            (blur)=\"getDateValidation(createMemberProfile.controls.dateOfBirth?.value)\"\r\n          />\r\n        </label>\r\n      </div>\r\n    </div>\r\n    <div class=\"row mb-1 align-items-baseline\">\r\n      <div *ngIf=\"memberRegistrationMap['email']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n        <label class=\"w-100\" [ngClass]=\"{ 'has-error': memberRegistrationMap['email']?.hasError }\">\r\n          <div class=\"error-container\" *ngIf=\"memberRegistrationMap['email']?.hasError\">\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span *ngIf=\"memberRegistrationMap['email']?.required && !createMemberProfile.controls.email?.value\">{{\r\n              memberRegistrationMap['email']?.requiredText\r\n            }}</span>\r\n            <span *ngIf=\"memberRegistrationMap['email']?.hasError && createMemberProfile.controls.email?.value\">{{\r\n              Spa_Member_Profile_Invalid_EmailError_Text\r\n            }}</span>\r\n          </div>\r\n          <span *ngIf=\"memberRegistrationMap['email']?.required\" class=\"input-error-asterisk\">*</span>\r\n          <label\r\n            for=\"email\"\r\n            class=\"Spa_Style_Label\"\r\n            [ngClass]=\"{\r\n              'readonly Spa_Style_Gray4_Color': memberRegistrationMap['email']?.isReadOnly\r\n            }\"\r\n          >\r\n            <span [ngClass]=\"{ 'error-color': memberRegistrationMap['email']?.hasError }\"\r\n              >{{ memberRegistrationMap['email']?.labelText }}\r\n            </span>\r\n          </label>\r\n          <input\r\n            id=\"email\"\r\n            type=\"email\"\r\n            class=\"w-100\"\r\n            formControlName=\"email\"\r\n            [ngClass]=\"{\r\n              'has-error': memberRegistrationMap['email']?.hasError,\r\n              'Spa_Style_Gray4_Color readonly': memberRegistrationMap['email']?.isReadOnly\r\n            }\"\r\n            [readonly]=\"memberRegistrationMap['email']?.isReadOnly\"\r\n          />\r\n        </label>\r\n      </div>\r\n\r\n      <div *ngIf=\"memberRegistrationMap['phone']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n        <label class=\"w-100\" [ngClass]=\"{ 'has-error': memberRegistrationMap['phone']?.hasError }\">\r\n          <div class=\"error-container\" *ngIf=\"memberRegistrationMap['phone']?.hasError\">\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span *ngIf=\"memberRegistrationMap['phone']?.required && !createMemberProfile.controls.phone?.value\">\r\n              {{ memberRegistrationMap['phone']?.requiredText }}\r\n            </span>\r\n            <span *ngIf=\"memberRegistrationMap['phone']?.hasError && createMemberProfile.controls.phone?.value\">{{\r\n              Spa_Member_Profile_Invalid_PhoneError_Text\r\n            }}</span>\r\n          </div>\r\n          <span *ngIf=\"memberRegistrationMap['phone']?.required\" class=\"input-error-asterisk\">*</span>\r\n          <label\r\n            for=\"phone\"\r\n            class=\"Spa_Style_Label w-75\"\r\n            [ngClass]=\"{ 'readonly Spa_Style_Gray4_Color': memberRegistrationMap['phone']?.isReadOnly }\"\r\n          >\r\n            <span [ngClass]=\"{ 'error-color': memberRegistrationMap['phone']?.hasError }\"\r\n              >{{ memberRegistrationMap['phone']?.labelText }}\r\n            </span>\r\n          </label>\r\n          <input\r\n            id=\"phone\"\r\n            type=\"text\"\r\n            class=\"w-50 primary-phone\"\r\n            inputmode=\"numeric\"\r\n            formControlName=\"phone\"\r\n            [mask]=\"phoneMask\"\r\n            [ngClass]=\"{\r\n              'has-error': memberRegistrationMap['phone']?.hasError,\r\n              'Spa_Style_Gray4_Color readonly': memberRegistrationMap['phone']?.isReadOnly\r\n            }\"\r\n            [readonly]=\"memberRegistrationMap['phone']?.isReadOnly\"\r\n          />\r\n        </label>\r\n      </div>\r\n\r\n      <div *ngIf=\"memberRegistrationMap['cellPhone']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n        <label class=\"w-100\" [ngClass]=\"{ 'has-error': memberRegistrationMap['cellPhone']?.hasError }\">\r\n          <div class=\"error-container\" *ngIf=\"memberRegistrationMap['cellPhone']?.hasError\">\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span *ngIf=\"memberRegistrationMap['cellPhone']?.required && !createMemberProfile.controls.cellPhone?.value\">\r\n              {{ memberRegistrationMap['cellPhone']?.requiredText }}\r\n            </span>\r\n            <span *ngIf=\"memberRegistrationMap['cellPhone']?.hasError && createMemberProfile.controls.cellPhone?.value\">{{\r\n              Spa_Member_Profile_Invalid_CellPhoneError_Text\r\n            }}</span>\r\n          </div>\r\n          <span *ngIf=\"memberRegistrationMap['cellPhone']?.required\" class=\"input-error-asterisk\">*</span>\r\n          <label\r\n            for=\"cellPhone\"\r\n            class=\"Spa_Style_Label w-75\"\r\n            [ngClass]=\"{ 'readonly Spa_Style_Gray4_Color': memberRegistrationMap['cellPhone']?.isReadOnly || disableCellPhoneInput }\"\r\n          >\r\n            <span [ngClass]=\"{ 'error-color': memberRegistrationMap['cellPhone']?.hasError }\"\r\n              >{{ memberRegistrationMap['cellPhone']?.labelText }}\r\n            </span>\r\n          </label>\r\n          <input\r\n            id=\"cellPhone\"\r\n            type=\"text\"\r\n            class=\"w-50 cell-phone\"\r\n            inputmode=\"numeric\"\r\n            formControlName=\"cellPhone\"\r\n            [mask]=\"phoneMask\"\r\n            [ngClass]=\"{\r\n              'has-error': memberRegistrationMap['cellPhone']?.hasError,\r\n              'Spa_Style_Gray4_Color readonly': memberRegistrationMap['cellPhone']?.isReadOnly || disableCellPhoneInput\r\n            }\"\r\n            [readonly]=\"memberRegistrationMap['cellPhone']?.isReadOnly || disableCellPhoneInput\"\r\n          />\r\n        </label>\r\n        <label *ngIf=\"Spa_Member_Profile_MobilePhoneCopyMain_Enabled\" for=\"sameAsPrimaryCheckbox\" class=\"w-100\">\r\n          <input\r\n            type=\"checkbox\"\r\n            id=\"sameAsPrimaryCheckbox\"\r\n            [value]=\"disableCellPhoneInput\"\r\n            [checked]=\"disableCellPhoneInput\"\r\n            [attr.aria-label]=\"Spa_Site_SameAsPrimary_Text\"\r\n            (change)=\"toggleCellPhoneCheckbox()\"\r\n          />\r\n          <span class=\"pl-2 Spa_Style_Primary_Color\">{{ Spa_Site_SameAsPrimary_Text }}</span>\r\n        </label>\r\n      </div>\r\n    </div>\r\n    <br />\r\n    <div class=\"row mb-1\">\r\n      <div class=\"col\">\r\n        <h3 *liveEditProp=\"'SPA_Member_Profile_Home_Header_Label'\" class=\"Spa_Style_H3 w-100\">\r\n          {{ profileHomeHeaderLabel }}\r\n        </h3>\r\n      </div>\r\n    </div>\r\n    <div class=\"row mb-1 align-items-baseline\">\r\n      <div *ngIf=\"memberRegistrationMap['address1']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n        <label class=\"w-100 address-autocomplete-wrapper\" [ngClass]=\"{ 'has-error': memberRegistrationMap['address1']?.hasError }\">\r\n          <div class=\"error-container\" *ngIf=\"memberRegistrationMap['address1']?.hasError\">\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span *ngIf=\"memberRegistrationMap['address1']?.required\">{{ memberRegistrationMap['address1']?.requiredText }}</span>\r\n          </div>\r\n          <span *ngIf=\"memberRegistrationMap['address1']?.required\" class=\"input-error-asterisk\">*</span>\r\n          <label\r\n            class=\"Spa_Style_Label\"\r\n            for=\"memberRegistrationAddressLabelId\"\r\n            [ngClass]=\"{ 'readonly Spa_Style_Gray4_Color': memberRegistrationMap['address1']?.isReadOnly }\"\r\n          >\r\n            <span [ngClass]=\"{ 'error-color': memberRegistrationMap['address1']?.hasError }\"\r\n              >{{ memberRegistrationMap['address1']?.labelText }}\r\n            </span>\r\n          </label>\r\n          <ng-template #addressResultTemplate let-r=\"result\" let-t=\"term\">\r\n            <span class=\"Spa_Style_H5 no-translate-block\">\r\n              <ngb-highlight [result]=\"r.street_line\" [term]=\"t\"></ngb-highlight>\r\n              <span *ngIf=\"r.secondary\"> {{ r.secondary }}</span> {{ r.city }} {{ r.state\r\n              }}<span *ngIf=\"r.zipcode\">, {{ r.zipcode }}</span></span\r\n            >\r\n          </ng-template>\r\n          <input\r\n            #addressSearchInput\r\n            #typeahead=\"ngbTypeahead\"\r\n            id=\"memberRegistrationAddressLabelId\"\r\n            type=\"text\"\r\n            placement=\"bottom-left\"\r\n            class=\"form-control w-100\"\r\n            [ngbTypeahead]=\"suggestedAddresses\"\r\n            [attr.initialized]=\"false\"\r\n            [ngClass]=\"{\r\n              'has-error': memberRegistrationMap['address1']?.hasError,\r\n              'Spa_Style_Gray4_Color readonly': memberRegistrationMap['address1']?.isReadOnly\r\n            }\"\r\n            [resultTemplate]=\"addressResultTemplate\"\r\n            [inputFormatter]=\"addressAutocompleteFormatter\"\r\n            [ngModelOptions]=\"{ standalone: true }\"\r\n            [readonly]=\"memberRegistrationMap['address1']?.isReadOnly\"\r\n            [(ngModel)]=\"addressSearchTerm\"\r\n            (selectItem)=\"selectItemForAddress($event)\"\r\n            (keyup)=\"scrollItemIntoView()\"\r\n            (focus)=\"focusAddressInput()\"\r\n          />\r\n        </label>\r\n      </div>\r\n      <div *ngIf=\"memberRegistrationMap['address2']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n        <label for=\"address2\" class=\"w-100\" [ngClass]=\"{ 'has-error': memberRegistrationMap['address2']?.hasError }\">\r\n          <div class=\"error-container\" *ngIf=\"memberRegistrationMap['address2']?.hasError\">\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span *ngIf=\"memberRegistrationMap['address2']?.required\">{{ memberRegistrationMap['address2']?.requiredText }}</span>\r\n          </div>\r\n          <span *ngIf=\"memberRegistrationMap['address2']?.required\" class=\"input-error-asterisk\">*</span>\r\n          <label class=\"Spa_Style_Label\" [ngClass]=\"{ 'readonly Spa_Style_Gray4_Color': memberRegistrationMap['address2']?.isReadOnly }\">\r\n            <span [ngClass]=\"{ 'error-color': memberRegistrationMap['address2']?.hasError }\"\r\n              >{{ memberRegistrationMap['address2']?.labelText }}\r\n            </span>\r\n          </label>\r\n          <input\r\n            id=\"address2\"\r\n            type=\"text\"\r\n            class=\"w-100\"\r\n            formControlName=\"address2\"\r\n            [ngClass]=\"{\r\n              'has-error': memberRegistrationMap['address2']?.hasError,\r\n              'Spa_Style_Gray4_Color readonly': memberRegistrationMap['address2']?.isReadOnly\r\n            }\"\r\n            [readonly]=\"memberRegistrationMap['address2']?.isReadOnly\"\r\n          />\r\n        </label>\r\n      </div>\r\n    </div>\r\n    <div class=\"row mb-1 align-items-baseline\">\r\n      <div *ngIf=\"memberRegistrationMap['city']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n        <label class=\"w-100\" [ngClass]=\"{ 'has-error': memberRegistrationMap['city']?.hasError }\">\r\n          <div class=\"error-container\" *ngIf=\"memberRegistrationMap['city']?.hasError\">\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span *ngIf=\"memberRegistrationMap['city']?.required\">{{ memberRegistrationMap['city']?.requiredText }}</span>\r\n          </div>\r\n          <span *ngIf=\"memberRegistrationMap['city']?.required\" class=\"input-error-asterisk\">*</span>\r\n          <label\r\n            for=\"city\"\r\n            class=\"Spa_Style_Label\"\r\n            [ngClass]=\"{ 'readonly Spa_Style_Gray4_Color': memberRegistrationMap['city']?.isReadOnly }\"\r\n          >\r\n            <span [ngClass]=\"{ 'error-color': memberRegistrationMap['city']?.hasError }\"\r\n              >{{ memberRegistrationMap['city']?.labelText }}\r\n            </span>\r\n          </label>\r\n          <input\r\n            id=\"city\"\r\n            type=\"text\"\r\n            class=\"w-100\"\r\n            formControlName=\"city\"\r\n            [ngClass]=\"{\r\n              'has-error': memberRegistrationMap['city']?.hasError,\r\n              'Spa_Style_Gray4_Color readonly': memberRegistrationMap['city']?.isReadOnly\r\n            }\"\r\n            [readonly]=\"memberRegistrationMap['city']?.isReadOnly\"\r\n          />\r\n        </label>\r\n      </div>\r\n      <div *ngIf=\"memberRegistrationMap['state']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n        <label class=\"w-100\" [ngClass]=\"{ 'has-error': memberRegistrationMap['state']?.hasError }\">\r\n          <div class=\"error-container\" *ngIf=\"memberRegistrationMap['state']?.hasError\">\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span *ngIf=\"memberRegistrationMap['state']?.required\">{{ memberRegistrationMap['state']?.requiredText }}</span>\r\n          </div>\r\n          <span *ngIf=\"memberRegistrationMap['state']?.required\" class=\"input-error-asterisk\">*</span>\r\n          <label class=\"Spa_Style_Label\" [ngClass]=\"{ 'readonly Spa_Style_Gray4_Color': memberRegistrationMap['state']?.isReadOnly }\">\r\n            <span [ngClass]=\"{ 'error-color': memberRegistrationMap['state']?.hasError }\"\r\n              >{{ memberRegistrationMap['state']?.labelText }}\r\n            </span>\r\n          </label>\r\n          <div class=\"state-selector\">\r\n            <vnext-state-selector-input\r\n              [control]=\"createMemberProfile?.controls?.state\"\r\n              [height]=\"'36px'\"\r\n              [controlValue]=\"createMemberProfile?.controls?.state?.value\"\r\n              [isReadOnly]=\"memberRegistrationMap['state']?.isReadOnly\"\r\n            ></vnext-state-selector-input>\r\n          </div>\r\n        </label>\r\n      </div>\r\n    </div>\r\n    <br />\r\n    <h3 *liveEditProp=\"'SPA_Member_Profile_SectionHeader_Sales_Information_Label'\" class=\"Spa_Style_H3 w-100\">\r\n      {{ profileSectionHeaderSalesInformationLabel }}\r\n    </h3>\r\n    <div class=\"row mb-1 align-items-baseline\">\r\n      <div *ngIf=\"memberRegistrationMap['crm']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n        <label class=\"w-100\" [ngClass]=\"{ 'has-error': memberRegistrationMap['crm']?.hasError }\">\r\n          <div class=\"error-container\" *ngIf=\"memberRegistrationMap['crm']?.hasError\">\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span *ngIf=\"memberRegistrationMap['crm']?.required\">{{ memberRegistrationMap['crm']?.requiredText }}</span>\r\n          </div>\r\n          <span *ngIf=\"memberRegistrationMap['crm']?.required\" class=\"input-error-asterisk\">*</span>\r\n          <label for=\"crm\" class=\"Spa_Style_Label\">\r\n            <span [ngClass]=\"{ 'error-color': memberRegistrationMap['crm']?.hasError }\"\r\n              >{{ memberRegistrationMap['crm']?.labelText }}\r\n            </span>\r\n          </label>\r\n          <input\r\n            id=\"crm\"\r\n            type=\"text\"\r\n            class=\"w-100\"\r\n            formControlName=\"crm\"\r\n            [ngClass]=\"{ 'has-error': memberRegistrationMap['crm']?.hasError }\"\r\n          />\r\n        </label>\r\n      </div>\r\n    </div>\r\n    <div class=\"row mb-1\">\r\n      <div class=\"col-lg-4 col-md-6 col-12\">\r\n        <span *liveEditProp=\"'SPA_Member_Profile_Is_Sales_Contact_Different_Label'\" class=\"Spa_Style_Label\">\r\n          {{ profileIsSalesContactDifferentLabel }}\r\n        </span>\r\n        <vnext-toggle-select\r\n          [items]=\"salescontactDifferent\"\r\n          [verticalGrow]=\"false\"\r\n          [lightBackground]=\"false\"\r\n          [darkenOnHover]=\"false\"\r\n          [largerText]=\"true\"\r\n          (optionSelected)=\"onOptionSelect($event)\"\r\n          ngClass=\"Spa_Style_Label\"\r\n          [buttonHeight]=\"'36px'\"\r\n          [selectedValue]=\"hasSalesContactSelection()\"\r\n          [limitButtonWidth]=\"true\"\r\n          [limitButtonWidthClass]=\"'mt-3'\"\r\n        >\r\n        </vnext-toggle-select>\r\n      </div>\r\n    </div>\r\n    <br />\r\n    <div *ngIf=\"isAdditionalInformationRequired\">\r\n      <div class=\"row mb-1 align-items-baseline\">\r\n        <div *ngIf=\"memberRegistrationMap['authRepFirstName']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n          <label class=\"w-100\" [ngClass]=\"{ 'has-error': memberRegistrationMap['authRepFirstName']?.hasError }\">\r\n            <div class=\"error-container\" *ngIf=\"memberRegistrationMap['authRepFirstName']?.hasError\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"memberRegistrationMap['authRepFirstName']?.required\">{{\r\n                memberRegistrationMap['authRepFirstName']?.requiredText\r\n              }}</span>\r\n            </div>\r\n            <span *ngIf=\"memberRegistrationMap['authRepFirstName']?.required\" class=\"input-error-asterisk\">*</span>\r\n            <label for=\"authRepFirstName\" class=\"Spa_Style_Label\">\r\n              <span [ngClass]=\"{ 'error-color': memberRegistrationMap['authRepFirstName']?.hasError }\"\r\n                >{{ memberRegistrationMap['authRepFirstName']?.labelText }}\r\n              </span>\r\n            </label>\r\n            <input\r\n              id=\"authRepFirstName\"\r\n              type=\"text\"\r\n              class=\"w-100\"\r\n              formControlName=\"authRepFirstName\"\r\n              [ngClass]=\"{ 'has-error': memberRegistrationMap['authRepFirstName']?.hasError }\"\r\n            />\r\n          </label>\r\n        </div>\r\n        <div *ngIf=\"memberRegistrationMap['authRepLastName']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n          <label class=\"w-100\" [ngClass]=\"{ 'has-error': memberRegistrationMap['authRepLastName']?.hasError }\">\r\n            <div class=\"error-container\" *ngIf=\"memberRegistrationMap['authRepLastName']?.hasError\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"memberRegistrationMap['authRepLastName']?.required\">{{\r\n                memberRegistrationMap['authRepLastName']?.requiredText\r\n              }}</span>\r\n            </div>\r\n\r\n            <span *ngIf=\"memberRegistrationMap['authRepLastName']?.required\" class=\"input-error-asterisk\">*</span>\r\n            <label for=\"authRepLastName\" class=\"Spa_Style_Label\">\r\n              <span [ngClass]=\"{ 'error-color': memberRegistrationMap['authRepLastName']?.hasError }\"\r\n                >{{ memberRegistrationMap['authRepLastName']?.labelText }}\r\n              </span>\r\n            </label>\r\n            <input\r\n              id=\"authRepLastName\"\r\n              type=\"text\"\r\n              class=\"w-100\"\r\n              formControlName=\"authRepLastName\"\r\n              [ngClass]=\"{ 'has-error': memberRegistrationMap['authRepLastName']?.hasError }\"\r\n              vnextDisableSSOPopulatedField=\"Profile.LastName\"\r\n            />\r\n          </label>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row mb-1 align-items-baseline\">\r\n        <div *ngIf=\"memberRegistrationMap['authRepRelationship']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n          <label class=\"w-100\" [ngClass]=\"{ 'has-error': memberRegistrationMap['authRepRelationship']?.hasError }\">\r\n            <div class=\"error-container\" *ngIf=\"memberRegistrationMap['authRepRelationship']?.hasError\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"memberRegistrationMap['authRepRelationship']?.required\">{{\r\n                memberRegistrationMap['authRepRelationship']?.requiredText\r\n              }}</span>\r\n            </div>\r\n            <span *ngIf=\"memberRegistrationMap['authRepRelationship']?.required\" class=\"input-error-asterisk\">*</span>\r\n            <label for=\"authRepRelationship\" class=\"Spa_Style_Label\">\r\n              <span [ngClass]=\"{ 'error-color': memberRegistrationMap['authRepRelationship']?.hasError }\">\r\n                {{ memberRegistrationMap['authRepRelationship']?.labelText }}\r\n              </span>\r\n            </label>\r\n            <input\r\n              id=\"authRepRelationship\"\r\n              type=\"text\"\r\n              class=\"w-100\"\r\n              formControlName=\"authRepRelationship\"\r\n              [ngClass]=\"{ 'has-error': memberRegistrationMap['authRepRelationship']?.hasError }\"\r\n            />\r\n          </label>\r\n        </div>\r\n        <div *ngIf=\"memberRegistrationMap['authRepEmail']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n          <label class=\"w-100\" [ngClass]=\"{ 'has-error': memberRegistrationMap['authRepEmail']?.hasError }\">\r\n            <div class=\"error-container\" *ngIf=\"memberRegistrationMap['authRepEmail']?.hasError\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"memberRegistrationMap['authRepEmail']?.required && !createMemberProfile.controls.authRepEmail?.value\">{{\r\n                memberRegistrationMap['authRepEmail']?.requiredText\r\n              }}</span>\r\n              <span *ngIf=\"memberRegistrationMap['authRepEmail']?.hasError && createMemberProfile.controls.authRepEmail?.value\">{{\r\n                Spa_Member_Profile_Invalid_EmailError_Text\r\n              }}</span>\r\n            </div>\r\n            <span *ngIf=\"memberRegistrationMap['authRepEmail']?.required\" class=\"input-error-asterisk\">*</span>\r\n            <label for=\"authRepEmail\" class=\"Spa_Style_Label\">\r\n              <span [ngClass]=\"{ 'error-color': memberRegistrationMap['authRepEmail']?.hasError }\"\r\n                >{{ memberRegistrationMap['authRepEmail']?.labelText }}\r\n              </span>\r\n            </label>\r\n            <input\r\n              id=\"authRepEmail\"\r\n              type=\"email\"\r\n              class=\"w-100\"\r\n              formControlName=\"authRepEmail\"\r\n              [ngClass]=\"{ 'has-error': memberRegistrationMap['authRepEmail']?.hasError }\"\r\n            />\r\n          </label>\r\n        </div>\r\n        <div *ngIf=\"memberRegistrationMap['authRepPhone']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n          <label class=\"w-100\" [ngClass]=\"{ 'has-error': memberRegistrationMap['authRepPhone']?.hasError }\">\r\n            <div class=\"error-container\" *ngIf=\"memberRegistrationMap['authRepPhone']?.hasError\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"memberRegistrationMap['authRepPhone']?.required && !createMemberProfile.controls.authRepPhone?.value\">{{\r\n                memberRegistrationMap['authRepPhone']?.requiredText\r\n              }}</span>\r\n              <span *ngIf=\"memberRegistrationMap['authRepPhone']?.hasError && createMemberProfile.controls.authRepPhone?.value\">{{\r\n                Spa_Member_Profile_Invalid_PhoneError_Text\r\n              }}</span>\r\n            </div>\r\n            <span *ngIf=\"memberRegistrationMap['authRepPhone']?.required\" class=\"input-error-asterisk\">*</span>\r\n            <label for=\"authRepPhone\" class=\"Spa_Style_Label\">\r\n              <span [ngClass]=\"{ 'error-color': memberRegistrationMap['authRepPhone']?.hasError }\"\r\n                >{{ memberRegistrationMap['authRepPhone']?.labelText }}\r\n              </span>\r\n            </label>\r\n            <input\r\n              id=\"authRepPhone\"\r\n              type=\"text\"\r\n              class=\"w-100\"\r\n              inputmode=\"numeric\"\r\n              formControlName=\"authRepPhone\"\r\n              [mask]=\"phoneMask\"\r\n              [ngClass]=\"{ 'has-error': memberRegistrationMap['authRepPhone']?.hasError }\"\r\n            />\r\n          </label>\r\n        </div>\r\n      </div>\r\n      <div class=\"row mb-1 align-items-baseline\">\r\n        <div *ngIf=\"memberRegistrationMap['authRepAddress1']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n          <label class=\"w-100 address-autocomplete-wrapper\" [ngClass]=\"{ 'has-error': memberRegistrationMap['authRepAddress1']?.hasError }\">\r\n            <div class=\"error-container\" *ngIf=\"memberRegistrationMap['authRepAddress1']?.hasError\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"memberRegistrationMap['authRepAddress1']?.required\">{{\r\n                memberRegistrationMap['authRepAddress1']?.requiredText\r\n              }}</span>\r\n            </div>\r\n            <span *ngIf=\"memberRegistrationMap['authRepAddress1']?.required\" class=\"input-error-asterisk\">*</span>\r\n            <label for=\"authRepAddress1\" class=\"Spa_Style_Label\">\r\n              <span [ngClass]=\"{ 'error-color': memberRegistrationMap['authRepAddress1']?.hasError }\"\r\n                >{{ memberRegistrationMap['authRepAddress1']?.labelText }}\r\n              </span>\r\n            </label>\r\n            <ng-template #authRepAddressResultTemplate let-r=\"result\" let-t=\"term\">\r\n              <span class=\"Spa_Style_H5 no-translate-block\">\r\n                <ngb-highlight [result]=\"r.street_line\" [term]=\"t\"></ngb-highlight>\r\n                <span *ngIf=\"r.secondary\"> {{ r.secondary }}</span> {{ r.city }} {{ r.state\r\n                }}<span *ngIf=\"r.zipcode\">, {{ r.zipcode }}</span></span\r\n              >\r\n            </ng-template>\r\n            <input\r\n              #authRepAddressSearchInput\r\n              #typeahead=\"ngbTypeahead\"\r\n              id=\"authRepAddress1\"\r\n              type=\"text\"\r\n              placement=\"bottom-left\"\r\n              class=\"form-control w-100\"\r\n              [attr.initialized]=\"false\"\r\n              [ngbTypeahead]=\"suggestedAuthRepAddresses\"\r\n              [ngClass]=\"{ 'has-error': memberRegistrationMap['authRepAddress1']?.hasError }\"\r\n              [resultTemplate]=\"authRepAddressResultTemplate\"\r\n              [inputFormatter]=\"addressAutocompleteFormatter\"\r\n              [ngModelOptions]=\"{ standalone: true }\"\r\n              [(ngModel)]=\"authRepAddressSearchTerm\"\r\n              (selectItem)=\"selectItemForAuthRepAddress($event)\"\r\n              (keyup)=\"scrollItemIntoView()\"\r\n              (focus)=\"focusAuthRepAddressInput()\"\r\n            />\r\n          </label>\r\n        </div>\r\n        <div *ngIf=\"memberRegistrationMap['authRepAddress2']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n          <label class=\"w-100\" [ngClass]=\"{ 'has-error': memberRegistrationMap['authRepAddress2']?.hasError }\">\r\n            <div class=\"error-container\" *ngIf=\"memberRegistrationMap['authRepAddress2']?.hasError\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"memberRegistrationMap['authRepAddress2']?.required\">{{\r\n                memberRegistrationMap['authRepAddress2']?.requiredText\r\n              }}</span>\r\n            </div>\r\n\r\n            <span *ngIf=\"memberRegistrationMap['authRepAddress2']?.required\" class=\"input-error-asterisk\">*</span>\r\n            <label for=\"authRepAddress2\" class=\"Spa_Style_Label\">\r\n              <span [ngClass]=\"{ 'error-color': memberRegistrationMap['authRepAddress2']?.hasError }\"\r\n                >{{ memberRegistrationMap['authRepAddress2']?.labelText }}\r\n              </span>\r\n            </label>\r\n            <input\r\n              id=\"authRepAddress2\"\r\n              type=\"text\"\r\n              class=\"w-100\"\r\n              formControlName=\"authRepAddress2\"\r\n              maxlength=\"50\"\r\n              [ngClass]=\"{ 'has-error': memberRegistrationMap['authRepAddress2']?.hasError }\"\r\n            />\r\n          </label>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row mb-1 align-items-baseline\">\r\n        <div *ngIf=\"memberRegistrationMap['authRepCity']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n          <label class=\"w-100\" [ngClass]=\"{ 'has-error': memberRegistrationMap['authRepCity']?.hasError }\">\r\n            <div class=\"error-container\" *ngIf=\"memberRegistrationMap['authRepCity']?.hasError\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"memberRegistrationMap['authRepCity']?.required\">{{ memberRegistrationMap['authRepCity']?.requiredText }}</span>\r\n            </div>\r\n            <span *ngIf=\"memberRegistrationMap['authRepCity']?.required\" class=\"input-error-asterisk\">*</span>\r\n            <label for=\"authRepCity\" class=\"Spa_Style_Label\">\r\n              <span [ngClass]=\"{ 'error-color': memberRegistrationMap['authRepCity']?.hasError }\"\r\n                >{{ memberRegistrationMap['authRepCity']?.labelText }}\r\n              </span>\r\n            </label>\r\n            <input\r\n              id=\"authRepCity\"\r\n              type=\"text\"\r\n              class=\"w-100\"\r\n              formControlName=\"authRepCity\"\r\n              maxlength=\"50\"\r\n              [ngClass]=\"{ 'has-error': memberRegistrationMap['authRepCity']?.hasError }\"\r\n            />\r\n          </label>\r\n        </div>\r\n        <div *ngIf=\"memberRegistrationMap['authRepState']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n          <label class=\"w-100\" [ngClass]=\"{ 'has-error': memberRegistrationMap['authRepState']?.hasError }\">\r\n            <div class=\"error-container\" *ngIf=\"memberRegistrationMap['authRepState']?.hasError\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"memberRegistrationMap['authRepState']?.required\">{{ memberRegistrationMap['authRepState']?.requiredText }}</span>\r\n            </div>\r\n            <span *ngIf=\"memberRegistrationMap['authRepState']?.required\" class=\"input-error-asterisk\">*</span>\r\n            <label class=\"Spa_Style_Label\">\r\n              <span [ngClass]=\"{ 'error-color': memberRegistrationMap['authRepState']?.hasError }\"\r\n                >{{ memberRegistrationMap['authRepState']?.labelText }}\r\n              </span>\r\n            </label>\r\n            <div>\r\n              <vnext-state-selector-input\r\n                [control]=\"createMemberProfile?.controls?.authRepState\"\r\n                [height]=\"'36px'\"\r\n                [controlValue]=\"createMemberProfile?.controls?.authRepState?.value\"\r\n              ></vnext-state-selector-input>\r\n            </div>\r\n          </label>\r\n        </div>\r\n        <div *ngIf=\"memberRegistrationMap['authRepZip']?.display\" class=\"col-lg-4 col-md-6 col-12\">\r\n          <label class=\"w-100\" [ngClass]=\"{ 'has-error': memberRegistrationMap['authRepZip']?.hasError }\">\r\n            <div class=\"error-container\" *ngIf=\"memberRegistrationMap['authRepZip']?.hasError\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"memberRegistrationMap['authRepZip']?.required\">{{ memberRegistrationMap['authRepZip']?.requiredText }}</span>\r\n            </div>\r\n            <span *ngIf=\"memberRegistrationMap['authRepZip']?.required\" class=\"input-error-asterisk\">*</span>\r\n            <label for=\"authRepZip\" class=\"Spa_Style_Label\">\r\n              <span [ngClass]=\"{ 'error-color': memberRegistrationMap['authRepZip']?.hasError }\"\r\n                >{{ memberRegistrationMap['authRepZip']?.labelText }}\r\n              </span>\r\n            </label>\r\n            <div class=\"w-100\">\r\n              <input\r\n                digitOnly\r\n                id=\"authRepZip\"\r\n                type=\"text\"\r\n                class=\"w-50\"\r\n                formControlName=\"authRepZip\"\r\n                maxlength=\"5\"\r\n                minlength=\"5\"\r\n                inputmode=\"numeric\"\r\n                pattern=\"[0-9]*\"\r\n                autocomplete=\"off\"\r\n                [ngClass]=\"{ 'has-error': memberRegistrationMap['authRepZip']?.hasError }\"\r\n              />\r\n            </div>\r\n          </label>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <h3 *liveEditProp=\"'SPA_Member_Profile_Additional_Information_Header_Label'\" class=\"Spa_Style_H3 mt-2\">\r\n      {{ profileAdditionalInformationHeaderLabel }}\r\n    </h3>\r\n    <div class=\"row\">\r\n      <ng-container *ngFor=\"let customFieldIndex of [1, 2, 3, 4, 5]\">\r\n        <div\r\n          class=\"col-12 col-md-6 col-lg-4 my-2\"\r\n          *ngIf=\"memberRegistrationMap['customField' + customFieldIndex] && memberRegistrationMap['customField' + customFieldIndex].display\"\r\n        >\r\n          <div class=\"error-container\" *ngIf=\"memberRegistrationMap['customField' + customFieldIndex]?.hasError; let hasError\">\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <ng-container *ngIf=\"createMemberProfile.controls['customField' + customFieldIndex]?.errors as errors\">\r\n              <ng-container *ngIf=\"errors.pattern\">{{ noSpecialCharactersError }}</ng-container>\r\n              <ng-container *ngIf=\"errors.required\">{{\r\n                memberRegistrationMap['customField' + customFieldIndex].requiredText\r\n              }}</ng-container>\r\n            </ng-container>\r\n          </div>\r\n          <label [for]=\"'customField' + customFieldIndex\" class=\"Spa_Style_Label\">\r\n            <span [ngClass]=\"{ 'error-color': memberRegistrationMap['customField' + customFieldIndex]?.hasError }\">\r\n              <ng-container *ngIf=\"memberRegistrationMap['customField' + customFieldIndex].required\">*</ng-container>\r\n              {{ memberRegistrationMap['customField' + customFieldIndex].labelText }}\r\n            </span>\r\n          </label>\r\n          <input\r\n            class=\"w-100\"\r\n            maxlength=\"255\"\r\n            type=\"text\"\r\n            [id]=\"'customField' + customFieldIndex\"\r\n            [formControlName]=\"'customField' + customFieldIndex\"\r\n            [ngClass]=\"{ 'has-error': memberRegistrationMap['customField' + customFieldIndex]?.hasError }\"\r\n          />\r\n        </div>\r\n      </ng-container>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-12\">\r\n        <vnext-status-button\r\n          [buttonText]=\"profileSaveButtonLabel\"\r\n          [tooltipMessageError]=\"Spa_Member_Profile_Save_Failed_ErrorText\"\r\n          [tooltipMessageSuccess]=\"Spa_Member_Profile_Save_Success_Text\"\r\n          class=\"profile-submit\"\r\n          disabled=\"!createMemberProfile.valid\"\r\n          [buttonClass]=\"'Spa_Style_PrimaryButton'\"\r\n          [isButtonTypeSubmit]=\"true\"\r\n          *liveEditProp=\"'Spa_Member_Profile_Save_Button_Label'\"\r\n        >\r\n        </vnext-status-button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</form>\r\n\r\n<vnext-widgets-member-eligiblity-check\r\n  [checkEnabled]=\"Spa_ProfileEligiblityCheck_Enabled\"\r\n  [showSubsidyAccordionOnProfile]=\"showSubsidyAccordionOnProfile\"\r\n  [memberRegistrationResources]=\"memberRegistrationResources\"\r\n  [mbiRegexPattern]=\"mbiRegexPattern\"\r\n  [showMedicareNumber]=\"showMedicareNumber\"\r\n  [openSubsidyText]=\"Spa_ProfileEligiblity_OpenSubsidyText\"\r\n  [mbiError]=\"mbiError\"\r\n  [hideText]=\"Spa_Site_Hide_Text\"\r\n  [showText]=\"Spa_Site_Show_Text\"\r\n  [dropdownPartAEnabled]=\"Spa_Member_Profile_PartAEffectiveDate_DropDown_Enabled\"\r\n  [dropdownPartBEnabled]=\"Spa_Member_Profile_PartBEffectiveDate_DropDown_Enabled\"\r\n  [profileEligibilityButtonText]=\"Spa_ProfileEligiblity_ButtonText\"\r\n  [headerText]=\"Spa_ProfileEligiblity_Header\"\r\n  [errorKeywordText]=\"Spa_ProfileEligiblity_ErrorText\"\r\n  [formDescriptionText]=\"Spa_ProfileEligiblity_Description\"\r\n  [accordionHeaderText]=\"Spa_ProfileEligiblity_PrescriptionDrugsText\"\r\n  [medicareEligibleText]=\"SPA_ProfileEligiblityCheck_MedicareEligibleText\"\r\n  [dsnpText]=\"SPA_ProfileEligiblityCheck_DSNPText\"\r\n  [dsnpChangedFromText]=\"SPA_ProfileEligiblityCheck_ChangedFrom_DSNPText\"\r\n  [mbiFieldName]=\"mbiFieldName\"\r\n  [effectiveDatePartAMaxFutureMonths]=\"effectiveDatePartAMaxFutureMonths\"\r\n  [effectiveDatePartAMaxPastMonths]=\"effectiveDatePartAMaxPastMonths\"\r\n  [effectiveDatePartBMaxFutureMonths]=\"effectiveDatePartBMaxFutureMonths\"\r\n  [effectiveDatePartBMaxPastMonths]=\"effectiveDatePartBMaxPastMonths\"\r\n  [mbiValidLength]=\"mbiValidLength\"\r\n  [effectiveDateMonthList]=\"effectiveDateMonthList\"\r\n  [effectiveDatePartAMonthRange]=\"effectiveDatePartAMonthRange\"\r\n  [effectiveDatePartAYearRange]=\"effectiveDatePartAYearRange\"\r\n  [effectiveDatePartBMonthRange]=\"effectiveDatePartBMonthRange\"\r\n  [effectiveDatePartBYearRange]=\"effectiveDatePartBYearRange\"\r\n  [isMedicareEligible]=\"memberStateModel?.profile?.isMedicareEligible\"\r\n  [isDSNPEligible]=\"memberStateModel?.profile?.isDSNPEligible\"\r\n  [lastCheckedDate]=\"memberStateModel?.profile?.lastCheckedDate\"\r\n  [hicn]=\"memberStateModel?.profile?.hicn\"\r\n  [subsidySelected]=\"memberStateModel?.demographic?.subsidySelected\"\r\n  [subsidyPercent]=\"memberStateModel?.demographic?.subsidyPercent\"\r\n  [partAEffectiveDate]=\"memberStateModel?.medigapAnswers?.partAEffectiveDate\"\r\n  [partBEffectiveDate]=\"memberStateModel?.medigapAnswers?.partBEffectiveDate\"\r\n  [memberRegistrationMap]=\"memberRegistrationMap\"\r\n  [mbiRegexPattern]=\"mbiRegexPattern\"\r\n  [eligibilityCheckProfileData]=\"eligibilityCheckProfileData\"\r\n  [isPartAandBEffDateValidationEnabled]=\"isPartAandBEffDateValidationEnabled\"\r\n  [lastCheckedDateText]=\"Spa_ProfileEligiblity_Last_Checked_Date_Text\"\r\n  [requiredFieldError]=\"SPA_ProfileEligiblityCheck_RequiredFieldError\"\r\n  [notEligibleText]=\"notEligibleText\"\r\n  [requestErrorText]=\"SPA_ProfileEligibilityCheck_Request_Error\"\r\n  [isStateEligibilityCheckEnabled]=\"isStateEligibilityCheckEnabled\"\r\n  [stateEligibilityCheckDescription]=\"stateEligibilityCheckDescription\"\r\n  [medicaidIdLabel]=\"medicaidIdLabel\"\r\n  [stateEligibilityCheckButtonLabel]=\"stateEligibilityCheckButtonLabel\"\r\n  [noMedicaidIdErrorLabel]=\"noMedicaidIdErrorLabel\"\r\n  [eligibilityCheckPendingLabel]=\"eligibilityCheckPendingLabel\"\r\n  [eligibilityCheckPendingDescriptionLabel]=\"eligibilityCheckPendingDescriptionLabel\"\r\n  [isZipValid]=\"isZipValid\"\r\n  [noZipCodeText]=\"noZipCodeText\"\r\n  [zipCode]=\"zipCode\"\r\n  [countyFips]=\"createMemberProfile?.value?.countyFips\"\r\n  [medicaidId]=\"memberStateModel?.profile?.medicaidId\"\r\n  [medicaidCheckStatus]=\"memberStateModel?.profile?.medicaidCheckStatus\"\r\n  [isMedicaidEligible]=\"memberStateModel?.profile?.isMedicaidEligible\"\r\n  [medicaidEligibilityLevel]=\"memberStateModel?.profile?.eligibilityLevel\"\r\n  [medicaidLastCheckedDate]=\"memberStateModel?.profile?.medicaidLastCheckedDate\"\r\n  [medicaidStateSelection]=\"memberStateModel?.profile?.medicaidStateSelection\"\r\n  [medicaidClientMessage]=\"memberStateModel?.profile?.clientMessage\"\r\n  [medicaidCodeText]=\"medicaidCodeText\"\r\n  [medicaidCheckDateReceivedText]=\"medicaidCheckDateReceivedText\"\r\n  [medicaidCheckDays]=\"medicaidCheckDays\"\r\n  [medicaidCheckCannotCompleteErrorText]=\"medicaidCheckCannotCompleteErrorText\"\r\n  [medicaidCheckedNoteText]=\"medicaidCheckedNoteText\"\r\n  [isFederalEligibilityForStateRequired]=\"isFederalEligibilityForStateRequired\"\r\n  [isProfileEligibilityCheckDSNPEnabled]=\"SPA_ProfileEligibilityCheck_DSNP_Enabled\"\r\n  [federalEligibilityForStateRequiredText]=\"federalEligibilityForStateRequiredText\"\r\n  [stateNotEligibleText]=\"stateNotEligibleText\"\r\n  [medicaidIntegrationConfig]=\"medicaidIntegrationConfig\"\r\n  [optionalLabel]=\"optionalLabel\"\r\n  [genderEnabled]=\"genderEnabled\"\r\n  [genderItems]=\"genderItems\"\r\n  [genderLabel]=\"genderLabel\"\r\n  [defaultGender]=\"memberStateModel?.profile?.gender\"\r\n  [genderRequiredErrorText]=\"genderRequiredErrorText\"\r\n  [mbiValidErrorText]=\"Spa_Member_Profile_MBI_Valid_ErrorText\"\r\n  (msiDataChanged)=\"updateProfileForm($event)\"\r\n  (subsidyIdChanged)=\"setSubsidyIdChanged($event)\"\r\n></vnext-widgets-member-eligiblity-check>\r\n", styles: [".profile-submit{position:relative;float:right;padding-left:0;padding-right:0}.member-registration-container{padding:18px;position:relative;margin-top:10px;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;border:1px solid var(--static-Spa_Style_Accent1);border-radius:4px;background-clip:border-box}.personal-information{padding-top:30px}.date-of-birth,.primary-phone,.cell-phone{min-width:135px}.button-inside{width:300px;position:relative}.input-clear-button{margin:0;width:100%;outline:none;border-radius:5px}.link-position{position:absolute;border-radius:5px;right:20px;margin-top:6px;margin-right:3px;z-index:2;border:none;height:30px;cursor:pointer;color:#fff;transform:translate(2px)}.show-mbi-as-password{-webkit-text-security:disc}.state-selector{max-width:100px}@-moz-document url-prefix(){.show-mbi-as-password{font-family:text-security-disc;font-size:1.5rem;padding-top:10px!important}}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){.show-mbi-as-password{font-family:text-security-disc;font-size:1.2rem;padding-top:12px!important}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1$1.NgbModal }, { type: i1.DeactivationGuardService }, { type: ProfileFacade }, { type: i2.Store }, { type: i1.FormValidationService }, { type: MemberRegistrationFacade }, { type: MemberRegistrationService }, { type: ZipCodeContextService }, { type: i0.ElementRef }, { type: i1.AddressService }, { type: i1.AutoCompleteService }, { type: i1.SSOPopulatedFieldService }, { type: EffectiveDateFacade }, { type: AnalyticsService }, { type: i1.MemberSessionService }, { type: i1.DemographicService }, { type: i1.ProfileCryptoService }, { type: i1.SpinnerService }, { type: AgentCallRecordingShoppingFacade }, { type: i1.ShoppingRecordingContextService }, { type: i1.SNPService }]; }, { memberEligibilityCheckComponent: [{
            type: ViewChild,
            args: [MemberEligibilityCheckComponent]
        }], submitButton: [{
            type: ViewChild,
            args: [StatusButtonComponent]
        }], zipInput: [{
            type: ViewChild,
            args: ['memberRegistrationZipInput']
        }], typeahead: [{
            type: ViewChild,
            args: ['typeahead']
        }], addressSearchInput: [{
            type: ViewChild,
            args: ['addressSearchInput']
        }], authRepAddressSearchInput: [{
            type: ViewChild,
            args: ['authRepAddressSearchInput']
        }], errorContainer: [{
            type: ViewChildren,
            args: ['errorContainer']
        }], ngFormInstance: [{
            type: ViewChild,
            args: ['ngFormInstance']
        }], sendDate: [{
            type: Output
        }], profileSubHeaderLabel: [{
            type: Input
        }], profileHomeHeaderLabel: [{
            type: Input
        }], profileAdditionalInformationHeaderLabel: [{
            type: Input
        }], profileSectionHeaderSalesInformationLabel: [{
            type: Input
        }], profileIsSalesContactDifferentLabel: [{
            type: Input
        }], profileSaveButtonLabel: [{
            type: Input
        }], datePickerMinDate: [{
            type: Input
        }], datePickerMaxDate: [{
            type: Input
        }], showDatePicker: [{
            type: Input
        }], isStateEligibilityCheckEnabled: [{
            type: Input
        }], stateEligibilityCheckDescription: [{
            type: Input
        }], medicaidIdLabel: [{
            type: Input
        }], stateEligibilityCheckButtonLabel: [{
            type: Input
        }], noMedicaidIdErrorLabel: [{
            type: Input
        }], eligibilityCheckPendingLabel: [{
            type: Input
        }], eligibilityCheckPendingDescriptionLabel: [{
            type: Input
        }], noZipCodeText: [{
            type: Input
        }], medicaidCodeText: [{
            type: Input
        }], medicaidCheckDateReceivedText: [{
            type: Input
        }], medicaidCheckDays: [{
            type: Input
        }], medicaidCheckCannotCompleteErrorText: [{
            type: Input
        }], medicaidCheckedNoteText: [{
            type: Input
        }], isFederalEligibilityForStateRequired: [{
            type: Input
        }], federalEligibilityForStateRequiredText: [{
            type: Input
        }], stateNotEligibleText: [{
            type: Input
        }], medicaidIntegrationConfig: [{
            type: Input
        }], notEligibleText: [{
            type: Input
        }], showSubsidyAccordionOnProfile: [{
            type: Input
        }], optionalLabel: [{
            type: Input
        }], genderEnabled: [{
            type: Input
        }], genderItems: [{
            type: Input
        }], genderLabel: [{
            type: Input
        }], genderRequiredErrorText: [{
            type: Input
        }], Spa_Member_Profile_Save_Failed_ErrorText: [], Spa_Member_Profile_Save_Success_Text: [], Spa_Member_Profile_NoBirthDateError_Text: [], Spa_Member_Profile_FutureBirthDateError_Text: [], Spa_Member_Profile_Invalid_EmailError_Text: [], Spa_Member_Profile_Invalid_PhoneError_Text: [], Spa_Member_Profile_Invalid_CellPhoneError_Text: [], Spa_Member_Profile_Invalid_PartAEffectiveDate_Text: [], Spa_Member_Profile_Invalid_PartBEffectiveDate_Text: [], Spa_Member_Profile_Invalid_ZipError_Text: [], Spa_Member_Profile_MBI_Valid_ErrorText: [], Spa_Member_Profile_MBI_Length_ErrorText: [], Spa_Site_Show_Text: [], Spa_Site_Hide_Text: [], Spa_Member_Profile_ErrorMessages_TitleText: [], Spa_Member_Profile_PartAEffectiveDate_After_DateofBirth_Text: [], Spa_Member_Profile_PartBEffectiveDate_After_DateofBirth_Text: [], Spa_Member_Profile_PartBEffectiveDate_After_PartAEffectiveDate: [], Spa_Member_Profile_Disable_CRMID: [], Spa_ZipCodeInput_CountyLabel_Text: [], Spa_ZipCodeInput_CountyLabel_Enabled: [], SPA_Member_Profile_Is_Sales_Contact_Different_Items: [], Spa_Member_Profile_PartAEffectiveDate_DropDown_Enabled: [], Spa_Member_Profile_PartBEffectiveDate_DropDown_Enabled: [], Spa_MemberRegistration_Resource_Content: [], Spa_Member_Profile_AddressAutoComplete_Enabled: [], Spa_ProfileEligiblityCheck_Enabled: [], SPA_ProfileEligibilityCheck_DSNP_Enabled: [], Spa_GettingStarted_EnableDSNPDisplay_Flag: [], Spa_ProfileEligiblity_Header: [], SPA_ProfileEligiblityCheck_RequiredFieldError: [], Spa_ProfileEligiblity_Last_Checked_Date_Text: [], SPA_ProfileEligiblityCheck_MedicareEligibleText: [], SPA_ProfileEligiblityCheck_DSNPText: [], SPA_ProfileEligiblityCheck_ChangedFrom_DSNPText: [], Spa_ProfileEligiblity_Description: [], Spa_ProfileEligiblity_ButtonText: [], Spa_ProfileEligiblity_ErrorText: [], Spa_ProfileEligiblity_OpenSubsidyText: [], SPA_ProfileEligibilityCheck_Request_Error: [], Spa_ProfileEligiblity_PrescriptionDrugsText: [], Spa_Site_SameAsPrimary_Text: [], Spa_Member_Profile_MobilePhoneCopyMain_Enabled: [], Spa_Member_Profile_MobilePhoneCopyMain_Default: [], Spa_Site_TotalSiteCountsPPC_Enabled: [], Spa_DualPlanYear_Enabled: [], saveMemberProfile: [] }); })();

function BackNextNavigationComponent_span_1_vnext_page_nav_button_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-page-nav-button", 2);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("link", ctx_r2.back);
} }
function BackNextNavigationComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, BackNextNavigationComponent_span_1_vnext_page_nav_button_1_Template, 1, 1, "vnext-page-nav-button", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "PageNavigation_BackText");
} }
function BackNextNavigationComponent_span_2_vnext_page_nav_button_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-page-nav-button", 2);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("link", ctx_r3.next);
} }
function BackNextNavigationComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, BackNextNavigationComponent_span_2_vnext_page_nav_button_1_Template, 1, 1, "vnext-page-nav-button", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "PageNavigation_GoToText");
} }
let BackNextNavigationComponent = class BackNextNavigationComponent extends ConfigurableWidget {
    preProcessProperties() {
        if (this.PageNavigation_BackText && this.PageNavigation_BackUrl) {
            this.back = { title: this.PageNavigation_BackText, tag: this.PageNavigation_BackUrl, type: LinkType.INTERNAL };
        }
        if (this.PageNavigation_GoToText && this.PageNavigation_GoToUrl) {
            this.next = { title: this.PageNavigation_GoToText, tag: this.PageNavigation_GoToUrl, type: LinkType.INTERNAL };
        }
        // we default next navigation to validate
        // platform can override this if they wish by passing
        // in the validateWidgets flag on this component
        if (this.next && this.next.validateWidgets === undefined) {
            // TODO: need to run changeDetection here?
            this.next = { ...this.next, validateWidgets: true };
        }
    }
};
BackNextNavigationComponent.ɵfac = /*@__PURE__*/ function () { let ɵBackNextNavigationComponent_BaseFactory; return function BackNextNavigationComponent_Factory(t) { return (ɵBackNextNavigationComponent_BaseFactory || (ɵBackNextNavigationComponent_BaseFactory = i0.ɵɵgetInheritedFactory(BackNextNavigationComponent)))(t || BackNextNavigationComponent); }; }();
BackNextNavigationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BackNextNavigationComponent, selectors: [["vnext-widget-back-next"]], features: [i0.ɵɵProvidersFeature([WidgetService] // provides widget data to components down the tree
        ), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [[4, "ngIf"], [3, "link", 4, "liveEditProp"], [3, "link"]], template: function BackNextNavigationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, BackNextNavigationComponent_span_1_Template, 2, 1, "span", 0);
        i0.ɵɵtemplate(2, BackNextNavigationComponent_span_2_Template, 2, 1, "span", 0);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.back);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.next);
    } }, dependencies: [i1$2.NgIf, PageNavButtonComponent, LiveEditPropDirective], encapsulation: 2, changeDetection: 0 });
__decorate([
    PlatformProp()
], BackNextNavigationComponent.prototype, "back", void 0);
__decorate([
    PlatformProp()
], BackNextNavigationComponent.prototype, "next", void 0);
__decorate([
    PlatformProp('live-edit', true)
], BackNextNavigationComponent.prototype, "PageNavigation_BackText", void 0);
__decorate([
    PlatformProp(null, true)
], BackNextNavigationComponent.prototype, "PageNavigation_BackUrl", void 0);
__decorate([
    PlatformProp('live-edit', true)
], BackNextNavigationComponent.prototype, "PageNavigation_GoToText", void 0);
__decorate([
    PlatformProp(null, true)
], BackNextNavigationComponent.prototype, "PageNavigation_GoToUrl", void 0);
BackNextNavigationComponent = __decorate([
    PlatformWidget
], BackNextNavigationComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BackNextNavigationComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-back-next', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService] // provides widget data to components down the tree
                , template: "<div>\r\n  <span *ngIf=\"back\">\r\n    <vnext-page-nav-button *liveEditProp=\"'PageNavigation_BackText'\" [link]=\"back\"> </vnext-page-nav-button>\r\n  </span>\r\n  <span *ngIf=\"next\">\r\n    <vnext-page-nav-button *liveEditProp=\"'PageNavigation_GoToText'\" [link]=\"next\"> </vnext-page-nav-button>\r\n  </span>\r\n</div>\r\n" }]
    }], null, { back: [], next: [], PageNavigation_BackText: [], PageNavigation_BackUrl: [], PageNavigation_GoToText: [], PageNavigation_GoToUrl: [] }); })();

function PageNavButtonsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-page-nav-button", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r1 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("link", link_r1);
} }
class PageNavButtonsComponent extends ConfigurableWidget {
    constructor() {
        super(...arguments);
        this.links = [];
    }
}
PageNavButtonsComponent.ɵfac = /*@__PURE__*/ function () { let ɵPageNavButtonsComponent_BaseFactory; return function PageNavButtonsComponent_Factory(t) { return (ɵPageNavButtonsComponent_BaseFactory || (ɵPageNavButtonsComponent_BaseFactory = i0.ɵɵgetInheritedFactory(PageNavButtonsComponent)))(t || PageNavButtonsComponent); }; }();
PageNavButtonsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PageNavButtonsComponent, selectors: [["vnext-page-nav-buttons"]], inputs: { links: "links" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], [3, "link"]], template: function PageNavButtonsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PageNavButtonsComponent_div_0_Template, 2, 1, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.links);
    } }, dependencies: [i1$2.NgForOf, PageNavButtonComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageNavButtonsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-page-nav-buttons', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngFor=\"let link of links\">\r\n  <vnext-page-nav-button [link]=\"link\"></vnext-page-nav-button>\r\n</div>\r\n" }]
    }], null, { links: [{
            type: Input
        }] }); })();

/**
 * LARGE WARNING
 * Do not use this component as is in a template. It has its own providers as it currently works outside of a template.
 * If you use this in a template without refactoring something, your providers will be overwritten and something will mess up.
 */
let PageNotFoundComponent = class PageNotFoundComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, imageService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.imageService = imageService;
        this.Spa_PageNotFound_Header_Image = 'phoenix/assets/images/playing_chess.png';
        this.Spa_PageNotFound_Header_Image_Mobile = 'phoenix/assets/images/404_Mobile_Image.jpg';
        this.Spa_PageNotFound_Header_Text = `We're stumped.`;
        this.Spa_PageNotFound_Body_Text = `We can't find the page you were looking for.`;
        this.Spa_HeaderFooter_PrimaryClientLogo = '';
        this.Spa_HeaderFooter_PrimaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_HeaderFooter_SecondaryClientLogo = '';
        this.Spa_HeaderFooter_SecondaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
    }
    preProcessProperties() {
        this.pageNotFoundHeaderImageUrl = this.imageService.resolveFullImagePath(this.Spa_PageNotFound_Header_Image);
        this.pageNotFoundHeaderImageMobileUrl = this.imageService.resolveFullImagePath(this.Spa_PageNotFound_Header_Image_Mobile);
    }
};
PageNotFoundComponent.ɵfac = function PageNotFoundComponent_Factory(t) { return new (t || PageNotFoundComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.ImageService)); };
PageNotFoundComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PageNotFoundComponent, selectors: [["vnext-page-not-found"]], features: [i0.ɵɵProvidersFeature([WidgetService, WidgetValidationService, ZoneService]), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 8, consts: [[3, "imageUrl", "imageMobileUrl", "headerText", "bodyText", "headerFooterPrimaryClientLogo", "headerFooterPrimaryClientLogoUrl", "headerFooterSecondaryClientLogo", "headerFooterSecondaryClientLogoUrl"]], template: function PageNotFoundComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "vnext-image-banner-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("imageUrl", ctx.pageNotFoundHeaderImageUrl)("imageMobileUrl", ctx.pageNotFoundHeaderImageMobileUrl)("headerText", ctx.Spa_PageNotFound_Header_Text)("bodyText", ctx.Spa_PageNotFound_Body_Text)("headerFooterPrimaryClientLogo", ctx.Spa_HeaderFooter_PrimaryClientLogo)("headerFooterPrimaryClientLogoUrl", ctx.Spa_HeaderFooter_PrimaryClientLogo_Url)("headerFooterSecondaryClientLogo", ctx.Spa_HeaderFooter_SecondaryClientLogo)("headerFooterSecondaryClientLogoUrl", ctx.Spa_HeaderFooter_SecondaryClientLogo_Url);
    } }, dependencies: [ImageBannerContainerComponent], encapsulation: 2, changeDetection: 0 });
__decorate([
    GlobalResource(true)
], PageNotFoundComponent.prototype, "Spa_PageNotFound_Header_Image", void 0);
__decorate([
    GlobalResource(true)
], PageNotFoundComponent.prototype, "Spa_PageNotFound_Header_Image_Mobile", void 0);
__decorate([
    GlobalResource()
], PageNotFoundComponent.prototype, "Spa_PageNotFound_Header_Text", void 0);
__decorate([
    GlobalResource()
], PageNotFoundComponent.prototype, "Spa_PageNotFound_Body_Text", void 0);
__decorate([
    GlobalResource()
], PageNotFoundComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo", void 0);
__decorate([
    GlobalResource()
], PageNotFoundComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo_Url", void 0);
__decorate([
    GlobalResource()
], PageNotFoundComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo", void 0);
__decorate([
    GlobalResource()
], PageNotFoundComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo_Url", void 0);
PageNotFoundComponent = __decorate([
    PlatformWidget
], PageNotFoundComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageNotFoundComponent, [{
        type: Component,
        args: [{ selector: 'vnext-page-not-found', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService, WidgetValidationService, ZoneService], template: "<vnext-image-banner-container\r\n  [imageUrl]=\"pageNotFoundHeaderImageUrl\"\r\n  [imageMobileUrl]=\"pageNotFoundHeaderImageMobileUrl\"\r\n  [headerText]=\"Spa_PageNotFound_Header_Text\"\r\n  [bodyText]=\"Spa_PageNotFound_Body_Text\"\r\n  [headerFooterPrimaryClientLogo]=\"Spa_HeaderFooter_PrimaryClientLogo\"\r\n  [headerFooterPrimaryClientLogoUrl]=\"Spa_HeaderFooter_PrimaryClientLogo_Url\"\r\n  [headerFooterSecondaryClientLogo]=\"Spa_HeaderFooter_SecondaryClientLogo\"\r\n  [headerFooterSecondaryClientLogoUrl]=\"Spa_HeaderFooter_SecondaryClientLogo_Url\"\r\n></vnext-image-banner-container>" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.ImageService }]; }, { Spa_PageNotFound_Header_Image: [], Spa_PageNotFound_Header_Image_Mobile: [], Spa_PageNotFound_Header_Text: [], Spa_PageNotFound_Body_Text: [], Spa_HeaderFooter_PrimaryClientLogo: [], Spa_HeaderFooter_PrimaryClientLogo_Url: [], Spa_HeaderFooter_SecondaryClientLogo: [], Spa_HeaderFooter_SecondaryClientLogo_Url: [] }); })();

const planSmartControlNames = {
    stateControlName: 'state',
    quoteSentControlName: 'quoteSent',
    enrollmentApplicationsControlName: 'enrollmentApplications',
    carrierNamesControlName: 'carrierNames',
    pcpInNetworkControlName: 'pcpInNetwork'
};
const planSmartControlKeys = {
    quoteSentControlKey: 'QUOTE_SENT_KEY',
    noQuoteSentControlKey: 'NO_QUOTE_SENT_KEY',
    enrollmentApplicationsControlKey: 'ENROLLMENT_APPLICATIONS_KEY',
    noEnrollmentApplicationsControlKey: 'NO_ENROLLMENT_APPLICATIONS_KEY'
};

class PlanSmartFilterItemsFacade {
    constructor(filterService, configResourceService) {
        this.filterService = filterService;
        this.configResourceService = configResourceService;
        this.filterFormTypes = {
            [planSmartControlNames.stateControlName]: FilterKeyType.MEMBER_REQUEST_STATE,
            [planSmartControlNames.quoteSentControlName]: FilterKeyType.MEMBER_REQUEST_QUOTE_SENT,
            [planSmartControlNames.enrollmentApplicationsControlName]: FilterKeyType.MEMBER_ENROLLMENT_APPLICATIONS,
            [planSmartControlNames.carrierNamesControlName]: FilterKeyType.MEMBER_REQUEST_CARRIER_NAMES,
            [planSmartControlNames.pcpInNetworkControlName]: FilterKeyType.LOWEST_COST_PCP_IN_NETWORK_STATUS
        };
    }
    createFilterForm() {
        return new UntypedFormGroup({
            [planSmartControlNames.stateControlName]: VnextFormControl.create({
                name: planSmartControlNames.stateControlName,
                formState: null
            }),
            [planSmartControlNames.quoteSentControlName]: VnextFormControl.create({
                name: planSmartControlNames.quoteSentControlName,
                formState: null
            }),
            [planSmartControlNames.enrollmentApplicationsControlName]: VnextFormControl.create({
                name: planSmartControlNames.enrollmentApplicationsControlName,
                formState: null
            }),
            [planSmartControlNames.carrierNamesControlName]: VnextFormControl.create({
                name: planSmartControlNames.carrierNamesControlName,
                formState: null
            }),
            [planSmartControlNames.pcpInNetworkControlName]: VnextFormControl.create({
                name: planSmartControlNames.pcpInNetworkControlName,
                formState: null
            })
        });
    }
    onFilterSelected(filterForm, controlName, planYear) {
        const selectedFilterValues = typeof filterForm.value[controlName] === 'string' ? [filterForm.value[controlName]] : filterForm.value[controlName];
        if (selectedFilterValues?.length) {
            const selectedFilter = selectedFilterValues.reduce((filter, value) => {
                if (Array.isArray(value)) {
                    filter.push(...value);
                }
                else {
                    filter.push(value);
                }
                return filter;
            }, []);
            let comparator = selectedFilter.length > 1 ? ComparatorType.IN : ComparatorType.EQUAL;
            const allowedControlNames = [
                planSmartControlNames.quoteSentControlName,
                planSmartControlNames.enrollmentApplicationsControlName
            ];
            const addToFilter = controlName === planSmartControlNames.stateControlName ||
                controlName === planSmartControlNames.carrierNamesControlName ||
                (allowedControlNames.includes(controlName) && filterForm.value?.[controlName]?.length === 1);
            if (addToFilter) {
                if (allowedControlNames.includes(controlName)) {
                    comparator =
                        filterForm.value[controlName][0] === planSmartControlKeys.quoteSentControlKey ||
                            filterForm.value[controlName][0] === planSmartControlKeys.enrollmentApplicationsControlKey
                            ? ComparatorType.EXISTS
                            : ComparatorType.NOT_EXISTS;
                }
                this.filterService.addFilterToPlanSmartFilterGroups(new Filter({ key: this.filterFormTypes[controlName], values: selectedFilter, comparator, defaultReturnValue: false }), planYear);
            }
            else {
                this.clearPlanSmartFilterGroupWithKey(planYear, this.filterFormTypes[controlName]);
            }
        }
        else {
            this.clearPlanSmartFilterGroupWithKey(planYear, this.filterFormTypes[controlName]);
        }
    }
    clearPlanSmartFilterGroupFilters(planYear) {
        this.filterService.clearPlanSmartFilterGroupFilters(planYear);
    }
    clearPlanSmartFilterGroupWithKey(planYear, filterKeyToClear) {
        this.filterService.clearPlanSmartFilterGroupWithKey(planYear, filterKeyToClear);
    }
    getPlanSmartFilterGroupFilters(planYear) {
        return this.filterService.getPlanSmartFilterGroupFilters(planYear);
    }
    getQuotingFiltersControl() {
        const quotingFiltersControl = [
            {
                label: this.configResourceService.getProcessedResourceValue('Spa_PlanSmart_Filter_QuoteSent_Text', null, 'Quote Sent'),
                value: planSmartControlKeys.quoteSentControlKey,
                disabled: false
            },
            {
                label: this.configResourceService.getProcessedResourceValue('Spa_PlanSmart_Filter_NoQuoteSent_Text', null, 'No Quote Sent'),
                value: planSmartControlKeys.noQuoteSentControlKey,
                disabled: false
            }
        ];
        return quotingFiltersControl;
    }
    getEnrollmentApplicationsFiltersControl() {
        const quotingFiltersControl = [
            {
                label: this.configResourceService.getProcessedResourceValue('Spa_PlanSmart_FilterEnrollmentSubmitted_Text', null, 'Enrollment submitted'),
                value: planSmartControlKeys.enrollmentApplicationsControlKey,
                disabled: false
            },
            {
                label: this.configResourceService.getProcessedResourceValue('Spa_PlanSmart_FilterNoEnrollmentSubmitted_Text', null, 'No enrollments submitted'),
                value: planSmartControlKeys.noEnrollmentApplicationsControlKey,
                disabled: false
            }
        ];
        return quotingFiltersControl;
    }
    getPcpFiltersControl() {
        const pcpFiltersControl = [
            {
                label: this.configResourceService.getProcessedResourceValue('Spa_PlanSmart_Filter_PCPLabel_Text', null, 'Show only lowest cost plans with PCP in-network'),
                value: true,
                disabled: false
            }
        ];
        return pcpFiltersControl;
    }
}
PlanSmartFilterItemsFacade.ɵfac = function PlanSmartFilterItemsFacade_Factory(t) { return new (t || PlanSmartFilterItemsFacade)(i0.ɵɵinject(i1.FilterService), i0.ɵɵinject(i1.ConfigResourceService)); };
PlanSmartFilterItemsFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlanSmartFilterItemsFacade, factory: PlanSmartFilterItemsFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanSmartFilterItemsFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.FilterService }, { type: i1.ConfigResourceService }]; }, null); })();

function PlanSmartFilterItemsComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "h4", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "vnext-checkbox-group", 7);
    i0.ɵɵlistener("change", function PlanSmartFilterItemsComponent_div_3_Template_vnext_checkbox_group_change_3_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onPcpFilterSelected(ctx_r2.planSmartControlNames.pcpInNetworkControlName, $event.target.checked)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.pcpFilterText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r0.planSmartControlNames.pcpInNetworkControlName);
    i0.ɵɵproperty("items", ctx_r0.pcpFiltersControl)("parentId", ctx_r0.checkboxId);
} }
function PlanSmartFilterItemsComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "h4", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "vnext-checkbox-group", 7);
    i0.ɵɵlistener("change", function PlanSmartFilterItemsComponent_div_16_Template_vnext_checkbox_group_change_3_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.onFilterSelected(ctx_r4.planSmartControlNames.carrierNamesControlName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.carrierText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r1.planSmartControlNames.carrierNamesControlName);
    i0.ɵɵproperty("items", ctx_r1.carrierOptions)("parentId", ctx_r1.checkboxId);
} }
class PlanSmartFilterItemsComponent {
    constructor(planSmartFilterItemsFacade, cdr, clearInputService) {
        this.planSmartFilterItemsFacade = planSmartFilterItemsFacade;
        this.cdr = cdr;
        this.clearInputService = clearInputService;
        this.filterItemClicked = new EventEmitter();
        this.quotingFiltersControl = [];
        this.enrollmentApplicationsFiltersControl = [];
        this.pcpFiltersControl = [];
        this.linkRoles = LinkRoles;
        this.checkboxId = 'planSmartCheckboxes';
        this.planSmartControlNames = planSmartControlNames;
    }
    ngOnChanges(changes) {
        const { planYear } = changes;
        if (this.filterForm && this.planYear && planYear?.previousValue !== planYear?.currentValue) {
            this.quotingFiltersControl = this.planSmartFilterItemsFacade.getQuotingFiltersControl();
            this.enrollmentApplicationsFiltersControl = this.planSmartFilterItemsFacade.getEnrollmentApplicationsFiltersControl();
            this.loadFormValues();
        }
    }
    ngOnInit() {
        this.filterForm = this.planSmartFilterItemsFacade.createFilterForm();
        this.quotingFiltersControl = this.planSmartFilterItemsFacade.getQuotingFiltersControl();
        this.enrollmentApplicationsFiltersControl = this.planSmartFilterItemsFacade.getEnrollmentApplicationsFiltersControl();
        if (this.isPcpFilterEnabled) {
            this.pcpFiltersControl = this.planSmartFilterItemsFacade.getPcpFiltersControl();
            this.onPcpFilterSelected(planSmartControlNames.pcpInNetworkControlName, this.isPcpFilterChecked);
        }
        if (this.isMobile) {
            this.loadFormValues();
            this.onPcpFilterSelected(planSmartControlNames.pcpInNetworkControlName, this.isPcpFilterEnabled && this.isPcpFilterChecked, this.isMobile);
        }
    }
    onFilterSelected(controlName) {
        if (!this.isMobile) {
            this.planSmartFilterItemsFacade.onFilterSelected(this.filterForm, controlName, this.planYear);
        }
    }
    onStateFilterSelected(controlName, selectedStateAbbrev) {
        if (controlName === planSmartControlNames.stateControlName && !selectedStateAbbrev) {
            this.filterForm.controls[planSmartControlNames.stateControlName].setValue(null);
        }
        this.onFilterSelected(controlName);
    }
    onPcpFilterSelected(controlName, selectedPcpOption, shouldUpdateFilterControl = !this.isMobile) {
        if (shouldUpdateFilterControl) {
            const pcpFilterControl = this.filterForm.controls[controlName];
            pcpFilterControl.setValue([selectedPcpOption]);
            this.filterItemClicked.emit(pcpFilterControl);
        }
    }
    onClearFilters() {
        this.planSmartFilterItemsFacade.clearPlanSmartFilterGroupFilters(this.planYear);
        this.filterForm.reset();
        this.clearInputService.clearInputById(this.checkboxId);
        this.cdr.markForCheck();
    }
    loadFormValues() {
        const filterValues = this.planSmartFilterItemsFacade.getPlanSmartFilterGroupFilters(this.planYear);
        if (filterValues.length) {
            for (const filter of filterValues) {
                this.setFormControlValue(filter);
            }
        }
        else {
            this.filterForm.reset();
        }
    }
    updateFilters() {
        Object.keys(this.filterForm.controls).forEach(controlName => {
            if (controlName === planSmartControlNames.pcpInNetworkControlName) {
                const pcpFilterControl = this.filterForm.controls[controlName];
                this.filterItemClicked.emit(pcpFilterControl);
            }
            else {
                this.planSmartFilterItemsFacade.onFilterSelected(this.filterForm, controlName, this.planYear);
            }
        });
    }
    setFormControlValue(filter) {
        if (filter.key === FilterKeyType.MEMBER_REQUEST_STATE) {
            this.filterForm.controls[planSmartControlNames.stateControlName].setValue(filter.values[0]);
        }
        else if (filter.key === FilterKeyType.MEMBER_REQUEST_CARRIER_NAMES) {
            this.filterForm.controls[planSmartControlNames.carrierNamesControlName].setValue(filter.values);
        }
        else if (filter.key === FilterKeyType.LOWEST_COST_PCP_IN_NETWORK_STATUS) {
            this.filterForm.controls[planSmartControlNames.pcpInNetworkControlName].setValue(filter.values);
        }
        else if (filter.key === FilterKeyType.MEMBER_ENROLLMENT_APPLICATIONS) {
            this.filterForm.controls[planSmartControlNames.enrollmentApplicationsControlName].setValue(filter.values);
        }
        else if (filter.key === FilterKeyType.MEMBER_REQUEST_QUOTE_SENT) {
            this.filterForm.controls[planSmartControlNames.quoteSentControlName].setValue(filter.values);
        }
        else {
            this.filterForm.controls[planSmartControlNames.stateControlName].setValue(null);
        }
    }
}
PlanSmartFilterItemsComponent.ɵfac = function PlanSmartFilterItemsComponent_Factory(t) { return new (t || PlanSmartFilterItemsComponent)(i0.ɵɵdirectiveInject(PlanSmartFilterItemsFacade), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.InputResetContextService)); };
PlanSmartFilterItemsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanSmartFilterItemsComponent, selectors: [["vnext-plan-smart-filter-items"]], inputs: { filterStateText: "filterStateText", filterQuoteText: "filterQuoteText", filterEnrollmentApplicationsText: "filterEnrollmentApplicationsText", planYear: "planYear", filterClearAllText: "filterClearAllText", carrierText: "carrierText", isCarrierFilterEnabled: "isCarrierFilterEnabled", carrierOptions: "carrierOptions", pcpFilterText: "pcpFilterText", isPcpFilterEnabled: "isPcpFilterEnabled", isPcpFilterChecked: "isPcpFilterChecked", isMobile: "isMobile" }, outputs: { filterItemClicked: "filterItemClicked" }, features: [i0.ɵɵNgOnChangesFeature], decls: 17, vars: 19, consts: [[3, "formGroup"], [1, "text-right", "mt-2"], [1, "can-click", 3, "title", "makeInlineBlock", "ariaLabel", "role", "click", "keyup.enter"], ["class", "mt-4", 4, "ngIf"], [1, "mt-4"], [1, "Spa_Style_H4", "ml-1", "my-2"], [3, "control", "height", "controlValue", "onStateSelect"], [1, "plan-filter-items", 3, "items", "formControlName", "parentId", "change"]], template: function PlanSmartFilterItemsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 0)(1, "div", 1)(2, "vnext-link", 2);
        i0.ɵɵlistener("click", function PlanSmartFilterItemsComponent_Template_vnext_link_click_2_listener() { return ctx.onClearFilters(); })("keyup.enter", function PlanSmartFilterItemsComponent_Template_vnext_link_keyup_enter_2_listener() { return ctx.onClearFilters(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(3, PlanSmartFilterItemsComponent_div_3_Template, 4, 4, "div", 3);
        i0.ɵɵelementStart(4, "div", 4)(5, "h4", 5);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "vnext-state-selector-input", 6);
        i0.ɵɵlistener("onStateSelect", function PlanSmartFilterItemsComponent_Template_vnext_state_selector_input_onStateSelect_7_listener($event) { return ctx.onStateFilterSelected(ctx.planSmartControlNames.stateControlName, $event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "div", 4)(9, "h4", 5);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "vnext-checkbox-group", 7);
        i0.ɵɵlistener("change", function PlanSmartFilterItemsComponent_Template_vnext_checkbox_group_change_11_listener() { return ctx.onFilterSelected(ctx.planSmartControlNames.quoteSentControlName); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(12, "div", 4)(13, "h4", 5);
        i0.ɵɵtext(14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "vnext-checkbox-group", 7);
        i0.ɵɵlistener("change", function PlanSmartFilterItemsComponent_Template_vnext_checkbox_group_change_15_listener() { return ctx.onFilterSelected(ctx.planSmartControlNames.enrollmentApplicationsControlName); });
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(16, PlanSmartFilterItemsComponent_div_16_Template, 4, 4, "div", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.filterForm);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("title", ctx.filterClearAllText)("makeInlineBlock", true)("ariaLabel", ctx.filterClearAllText)("role", ctx.linkRoles.BUTTON);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isPcpFilterEnabled);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.filterStateText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("control", ctx.filterForm == null ? null : ctx.filterForm.controls == null ? null : ctx.filterForm.controls.state)("height", "36px")("controlValue", ctx.filterForm == null ? null : ctx.filterForm.controls == null ? null : ctx.filterForm.controls.state == null ? null : ctx.filterForm.controls.state.value);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.filterQuoteText, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("formControlName", ctx.planSmartControlNames.quoteSentControlName);
        i0.ɵɵproperty("items", ctx.quotingFiltersControl)("parentId", ctx.checkboxId);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.filterEnrollmentApplicationsText);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("formControlName", ctx.planSmartControlNames.enrollmentApplicationsControlName);
        i0.ɵɵproperty("items", ctx.enrollmentApplicationsFiltersControl)("parentId", ctx.checkboxId);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isCarrierFilterEnabled && (ctx.carrierOptions == null ? null : ctx.carrierOptions.length));
    } }, dependencies: [i1$2.NgIf, i4.ɵNgNoValidate, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, CheckboxGroupComponent, LinkComponent, StateSelectorInputComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanSmartFilterItemsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-smart-filter-items', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form [formGroup]=\"filterForm\">\r\n  <div class=\"text-right mt-2\">\r\n    <vnext-link\r\n      (click)=\"onClearFilters()\"\r\n      (keyup.enter)=\"onClearFilters()\"\r\n      [title]=\"filterClearAllText\"\r\n      class=\"can-click\"\r\n      [makeInlineBlock]=\"true\"\r\n      [ariaLabel]=\"filterClearAllText\"\r\n      [role]=\"linkRoles.BUTTON\"\r\n    >\r\n    </vnext-link>\r\n  </div>\r\n  <div *ngIf=\"isPcpFilterEnabled\" class=\"mt-4\">\r\n    <h4 class=\"Spa_Style_H4 ml-1 my-2\">\r\n      {{ pcpFilterText }}\r\n    </h4>\r\n    <vnext-checkbox-group\r\n      [items]=\"pcpFiltersControl\"\r\n      class=\"plan-filter-items\"\r\n      (change)=\"onPcpFilterSelected(planSmartControlNames.pcpInNetworkControlName, $event.target.checked)\"\r\n      formControlName=\"{{ planSmartControlNames.pcpInNetworkControlName }}\"\r\n      [parentId]=\"checkboxId\"\r\n    >\r\n    </vnext-checkbox-group>\r\n  </div>\r\n  <div class=\"mt-4\">\r\n    <h4 class=\"Spa_Style_H4 ml-1 my-2\">{{ filterStateText }}</h4>\r\n    <vnext-state-selector-input\r\n      [control]=\"filterForm?.controls?.state\"\r\n      [height]=\"'36px'\"\r\n      [controlValue]=\"filterForm?.controls?.state?.value\"\r\n      (onStateSelect)=\"onStateFilterSelected(planSmartControlNames.stateControlName, $event)\"\r\n    ></vnext-state-selector-input>\r\n  </div>\r\n  <div class=\"mt-4\">\r\n    <h4 class=\"Spa_Style_H4 ml-1 my-2\">\r\n      {{ filterQuoteText }}\r\n    </h4>\r\n    <vnext-checkbox-group\r\n      [items]=\"quotingFiltersControl\"\r\n      class=\"plan-filter-items\"\r\n      (change)=\"onFilterSelected(planSmartControlNames.quoteSentControlName)\"\r\n      formControlName=\"{{ planSmartControlNames.quoteSentControlName }}\"\r\n      [parentId]=\"checkboxId\"\r\n    >\r\n    </vnext-checkbox-group>\r\n  </div>\r\n  <div class=\"mt-4\">\r\n    <h4 class=\"Spa_Style_H4 ml-1 my-2\">{{ filterEnrollmentApplicationsText }}</h4>\r\n    <vnext-checkbox-group\r\n      [items]=\"enrollmentApplicationsFiltersControl\"\r\n      class=\"plan-filter-items\"\r\n      (change)=\"onFilterSelected(planSmartControlNames.enrollmentApplicationsControlName)\"\r\n      formControlName=\"{{ planSmartControlNames.enrollmentApplicationsControlName }}\"\r\n      [parentId]=\"checkboxId\"\r\n    >\r\n    </vnext-checkbox-group>\r\n  </div>\r\n  <div class=\"mt-4\" *ngIf=\"isCarrierFilterEnabled && carrierOptions?.length\">\r\n    <h4 class=\"Spa_Style_H4 ml-1 my-2\">\r\n      {{ carrierText }}\r\n    </h4>\r\n    <vnext-checkbox-group\r\n      [items]=\"carrierOptions\"\r\n      class=\"plan-filter-items\"\r\n      (change)=\"onFilterSelected(planSmartControlNames.carrierNamesControlName)\"\r\n      formControlName=\"{{ planSmartControlNames.carrierNamesControlName }}\"\r\n      [parentId]=\"checkboxId\"\r\n    >\r\n    </vnext-checkbox-group>\r\n  </div>\r\n</form>\r\n" }]
    }], function () { return [{ type: PlanSmartFilterItemsFacade }, { type: i0.ChangeDetectorRef }, { type: i1.InputResetContextService }]; }, { filterStateText: [{
            type: Input
        }], filterQuoteText: [{
            type: Input
        }], filterEnrollmentApplicationsText: [{
            type: Input
        }], planYear: [{
            type: Input
        }], filterClearAllText: [{
            type: Input
        }], carrierText: [{
            type: Input
        }], isCarrierFilterEnabled: [{
            type: Input
        }], carrierOptions: [{
            type: Input
        }], pcpFilterText: [{
            type: Input
        }], isPcpFilterEnabled: [{
            type: Input
        }], isPcpFilterChecked: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], filterItemClicked: [{
            type: Output
        }] }); })();

class PlanSmartFilterModalComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
    }
    cancelChanges() {
        this.activeModal.dismiss();
    }
    applyFilter() {
        this.planFilterModalItems?.updateFilters();
        this.activeModal.dismiss();
    }
}
PlanSmartFilterModalComponent.ɵfac = function PlanSmartFilterModalComponent_Factory(t) { return new (t || PlanSmartFilterModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal)); };
PlanSmartFilterModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanSmartFilterModalComponent, selectors: [["vnext-plan-smart-filter-modal"]], viewQuery: function PlanSmartFilterModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(PlanSmartFilterItemsComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.planFilterModalItems = _t.first);
    } }, inputs: { filterClearAll: "filterClearAll", filterHeaderText: "filterHeaderText", filterStateText: "filterStateText", planYear: "planYear", stateHeaderText: "stateHeaderText", filterClearAllText: "filterClearAllText", filterQuoteText: "filterQuoteText", filterEnrollmentApplicationsText: "filterEnrollmentApplicationsText", carrierText: "carrierText", isCarrierFilterEnabled: "isCarrierFilterEnabled", carrierOptions: "carrierOptions", pcpFilterText: "pcpFilterText", isPcpFilterEnabled: "isPcpFilterEnabled", isPcpFilterChecked: "isPcpFilterChecked", filterModalCancelButtonText: "filterModalCancelButtonText", filterModalApplyButtonText: "filterModalApplyButtonText", isMobile: "isMobile" }, decls: 8, vars: 15, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "modal-body", "plan-filter-modal-content"], [3, "planYear", "filterStateText", "filterClearAllText", "filterQuoteText", "filterEnrollmentApplicationsText", "carrierText", "isCarrierFilterEnabled", "carrierOptions", "pcpFilterText", "isPcpFilterEnabled", "isPcpFilterChecked", "isMobile"], [1, "modal-footer", "justify-content-between"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", 3, "click"], ["type", "button", 1, "btn", "Spa_Style_PrimaryButton", 3, "click"]], template: function PlanSmartFilterModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function PlanSmartFilterModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.cancelChanges(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "vnext-plan-smart-filter-items", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3)(4, "button", 4);
        i0.ɵɵlistener("click", function PlanSmartFilterModalComponent_Template_button_click_4_listener() { return ctx.cancelChanges(); });
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "button", 5);
        i0.ɵɵlistener("click", function PlanSmartFilterModalComponent_Template_button_click_6_listener() { return ctx.applyFilter(); });
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.filterHeaderText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("planYear", ctx.planYear)("filterStateText", ctx.filterStateText)("filterClearAllText", ctx.filterClearAllText)("filterQuoteText", ctx.filterQuoteText)("filterEnrollmentApplicationsText", ctx.filterEnrollmentApplicationsText)("carrierText", ctx.carrierText)("isCarrierFilterEnabled", ctx.isCarrierFilterEnabled)("carrierOptions", ctx.carrierOptions)("pcpFilterText", ctx.pcpFilterText)("isPcpFilterEnabled", ctx.isPcpFilterEnabled)("isPcpFilterChecked", ctx.isPcpFilterChecked)("isMobile", ctx.isMobile);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.filterModalCancelButtonText);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.filterModalApplyButtonText);
    } }, dependencies: [ModalHeaderComponent, PlanSmartFilterItemsComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanSmartFilterModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-smart-filter-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"filterHeaderText\" (modalTitleCancelAction)=\"cancelChanges()\"></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body plan-filter-modal-content\">\r\n  <vnext-plan-smart-filter-items\r\n    [planYear]=\"planYear\"\r\n    [filterStateText]=\"filterStateText\"\r\n    [filterClearAllText]=\"filterClearAllText\"\r\n    [filterQuoteText]=\"filterQuoteText\"\r\n    [filterEnrollmentApplicationsText]=\"filterEnrollmentApplicationsText\"\r\n    [carrierText]=\"carrierText\"\r\n    [isCarrierFilterEnabled]=\"isCarrierFilterEnabled\"\r\n    [carrierOptions]=\"carrierOptions\"\r\n    [pcpFilterText]=\"pcpFilterText\"\r\n    [isPcpFilterEnabled]=\"isPcpFilterEnabled\"\r\n    [isPcpFilterChecked]=\"isPcpFilterChecked\"\r\n    [isMobile]=\"isMobile\"\r\n  >\r\n  </vnext-plan-smart-filter-items>\r\n</div>\r\n<div class=\"modal-footer justify-content-between\">\r\n  <button type=\"button\" class=\"btn Spa_Style_SecondaryButton\" (click)=\"cancelChanges()\">{{ filterModalCancelButtonText }}</button>\r\n  <button type=\"button\" class=\"btn Spa_Style_PrimaryButton\" (click)=\"applyFilter()\">{{ filterModalApplyButtonText }}</button>\r\n</div>\r\n" }]
    }], function () { return [{ type: i1$1.NgbActiveModal }]; }, { planFilterModalItems: [{
            type: ViewChild,
            args: [PlanSmartFilterItemsComponent]
        }], filterClearAll: [{
            type: Input
        }], filterHeaderText: [{
            type: Input
        }], filterStateText: [{
            type: Input
        }], planYear: [{
            type: Input
        }], stateHeaderText: [{
            type: Input
        }], filterClearAllText: [{
            type: Input
        }], filterQuoteText: [{
            type: Input
        }], filterEnrollmentApplicationsText: [{
            type: Input
        }], carrierText: [{
            type: Input
        }], isCarrierFilterEnabled: [{
            type: Input
        }], carrierOptions: [{
            type: Input
        }], pcpFilterText: [{
            type: Input
        }], isPcpFilterEnabled: [{
            type: Input
        }], isPcpFilterChecked: [{
            type: Input
        }], filterModalCancelButtonText: [{
            type: Input
        }], filterModalApplyButtonText: [{
            type: Input
        }], isMobile: [{
            type: Input
        }] }); })();

class PlanSmartFilterComponent {
    constructor() {
        this.filterItemClicked = new EventEmitter();
    }
}
PlanSmartFilterComponent.ɵfac = function PlanSmartFilterComponent_Factory(t) { return new (t || PlanSmartFilterComponent)(); };
PlanSmartFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanSmartFilterComponent, selectors: [["vnext-plan-smart-filter"]], inputs: { filterClearAll: "filterClearAll", filterHeaderText: "filterHeaderText", filterStateText: "filterStateText", planYear: "planYear", stateHeaderText: "stateHeaderText", filterClearAllText: "filterClearAllText", filterQuoteText: "filterQuoteText", filterEnrollmentApplicationsText: "filterEnrollmentApplicationsText", carrierText: "carrierText", isCarrierFilterEnabled: "isCarrierFilterEnabled", carrierOptions: "carrierOptions", pcpFilterText: "pcpFilterText", isPcpFilterEnabled: "isPcpFilterEnabled", isPcpFilterChecked: "isPcpFilterChecked" }, outputs: { filterItemClicked: "filterItemClicked" }, decls: 5, vars: 12, consts: [[1, "d-flex", "justify-content-between", "filter-header"], [1, "Spa_Style_H3", "accordion-header", "py-2", "mb-0"], [1, "plan-filter-container"], [3, "planYear", "filterStateText", "filterClearAllText", "filterQuoteText", "filterEnrollmentApplicationsText", "carrierText", "isCarrierFilterEnabled", "carrierOptions", "pcpFilterText", "isPcpFilterEnabled", "isPcpFilterChecked", "filterItemClicked"]], template: function PlanSmartFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "h3", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(3, "div", 2)(4, "vnext-plan-smart-filter-items", 3);
        i0.ɵɵlistener("filterItemClicked", function PlanSmartFilterComponent_Template_vnext_plan_smart_filter_items_filterItemClicked_4_listener($event) { return ctx.filterItemClicked.emit($event); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.filterHeaderText, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("planYear", ctx.planYear)("filterStateText", ctx.filterStateText)("filterClearAllText", ctx.filterClearAllText)("filterQuoteText", ctx.filterQuoteText)("filterEnrollmentApplicationsText", ctx.filterEnrollmentApplicationsText)("carrierText", ctx.carrierText)("isCarrierFilterEnabled", ctx.isCarrierFilterEnabled)("carrierOptions", ctx.carrierOptions)("pcpFilterText", ctx.pcpFilterText)("isPcpFilterEnabled", ctx.isPcpFilterEnabled)("isPcpFilterChecked", ctx.isPcpFilterChecked);
    } }, dependencies: [PlanSmartFilterItemsComponent], styles: [".filter-header[_ngcontent-%COMP%]{border-bottom:1px solid rgba(0,0,0,.125);border-top:1px solid rgba(0,0,0,.125);padding:5px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanSmartFilterComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-smart-filter', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"d-flex justify-content-between filter-header\">\r\n  <h3 class=\"Spa_Style_H3 accordion-header py-2 mb-0\">\r\n    {{ filterHeaderText }}\r\n  </h3>\r\n</div>\r\n<div class=\"plan-filter-container\">\r\n  <vnext-plan-smart-filter-items\r\n    [planYear]=\"planYear\"\r\n    [filterStateText]=\"filterStateText\"\r\n    [filterClearAllText]=\"filterClearAllText\"\r\n    [filterQuoteText]=\"filterQuoteText\"\r\n    [filterEnrollmentApplicationsText]=\"filterEnrollmentApplicationsText\"\r\n    [carrierText]=\"carrierText\"\r\n    [isCarrierFilterEnabled]=\"isCarrierFilterEnabled\"\r\n    [carrierOptions]=\"carrierOptions\"\r\n    [pcpFilterText]=\"pcpFilterText\"\r\n    [isPcpFilterEnabled]=\"isPcpFilterEnabled\"\r\n    [isPcpFilterChecked]=\"isPcpFilterChecked\"\r\n    (filterItemClicked)=\"filterItemClicked.emit($event)\"\r\n  >\r\n  </vnext-plan-smart-filter-items>\r\n</div>\r\n", styles: [".filter-header{border-bottom:1px solid rgba(0,0,0,.125);border-top:1px solid rgba(0,0,0,.125);padding:5px}\n"] }]
    }], null, { filterClearAll: [{
            type: Input
        }], filterHeaderText: [{
            type: Input
        }], filterStateText: [{
            type: Input
        }], planYear: [{
            type: Input
        }], stateHeaderText: [{
            type: Input
        }], filterClearAllText: [{
            type: Input
        }], filterQuoteText: [{
            type: Input
        }], filterEnrollmentApplicationsText: [{
            type: Input
        }], carrierText: [{
            type: Input
        }], isCarrierFilterEnabled: [{
            type: Input
        }], carrierOptions: [{
            type: Input
        }], pcpFilterText: [{
            type: Input
        }], isPcpFilterEnabled: [{
            type: Input
        }], isPcpFilterChecked: [{
            type: Input
        }], filterItemClicked: [{
            type: Output
        }] }); })();

const _c0$1t = function (a0, a1) { return { "text-success fa-check": a0, "fa-times-circle": a1 }; };
function PCPNetworkStatusComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5);
    i0.ɵɵelement(2, "i", 6);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "titlecase");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c0$1t, ctx_r0.pcpNetworkStatus, !ctx_r0.pcpNetworkStatus));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(4, 3, ctx_r0.pcpName), " (", ctx_r0.pcpText, ") ");
} }
class PCPNetworkStatusComponent {
}
PCPNetworkStatusComponent.ɵfac = function PCPNetworkStatusComponent_Factory(t) { return new (t || PCPNetworkStatusComponent)(); };
PCPNetworkStatusComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PCPNetworkStatusComponent, selectors: [["vnext-widget-pcp-network-status"]], inputs: { providerText: "providerText", providerInNetworkText: "providerInNetworkText", pcpNetworkStatus: "pcpNetworkStatus", pcpName: "pcpName", pcpText: "pcpText" }, decls: 6, vars: 3, consts: [[1, "Spa_Style_Bold_Weight", "Spa_Style_Paragraph"], [1, "fas", "Spa_Style_ProvidersIcon", "mr-1"], [1, "Spa_Style_Gray4_Color", "Spa_Style_Paragraph", "ml-4"], ["class", "ml-4", 4, "ngIf"], [1, "ml-4"], [1, "Spa_Style_Gray4_Color", "Spa_Style_Paragraph", "mb-3"], [1, "mr-1", "fas", 3, "ngClass"]], template: function PCPNetworkStatusComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "i", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, PCPNetworkStatusComponent_div_5_Template, 5, 8, "div", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.providerText, "\n");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.providerInNetworkText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.pcpName);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, IconAriaAttributesDirective, i1$2.TitleCasePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PCPNetworkStatusComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-pcp-network-status', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"Spa_Style_Bold_Weight Spa_Style_Paragraph\">\r\n  <i class=\"fas Spa_Style_ProvidersIcon mr-1\"></i>\r\n  {{ providerText }}\r\n</div>\r\n<div class=\"Spa_Style_Gray4_Color Spa_Style_Paragraph ml-4\">{{ providerInNetworkText }}</div>\r\n<div class=\"ml-4\" *ngIf=\"pcpName\">\r\n  <div class=\"Spa_Style_Gray4_Color Spa_Style_Paragraph mb-3\">\r\n    <i class=\"mr-1 fas\" [ngClass]=\"{ 'text-success fa-check': pcpNetworkStatus, 'fa-times-circle': !pcpNetworkStatus }\"></i\r\n    >{{ pcpName | titlecase }} ({{ pcpText }})\r\n  </div>\r\n</div>\r\n" }]
    }], null, { providerText: [{
            type: Input
        }], providerInNetworkText: [{
            type: Input
        }], pcpNetworkStatus: [{
            type: Input
        }], pcpName: [{
            type: Input
        }], pcpText: [{
            type: Input
        }] }); })();

var PlanSmartReportFields;
(function (PlanSmartReportFields) {
    PlanSmartReportFields["MEMBER_INFO"] = "Member Info";
    PlanSmartReportFields["CURRENT_PLAN"] = "Current Plan";
    PlanSmartReportFields["NEXT_YEAR_PLAN"] = "Next Year Plan";
    PlanSmartReportFields["LOWEST_ESTIMATED_COST_PLAN_PCP_IN_NETWORK"] = "Lowest Estimated Cost Plan PCP In Network";
    PlanSmartReportFields["LOWEST_ESTIMATED_COST_PLAN_REGARDLESS_OF_PCP_IN_NETWORK"] = "Lowest Estimated Cost Plan Regardless of PCP In Network";
})(PlanSmartReportFields || (PlanSmartReportFields = {}));
var PlanSmartReportSubFields;
(function (PlanSmartReportSubFields) {
    PlanSmartReportSubFields["FIRST_NAME"] = "First Name";
    PlanSmartReportSubFields["LAST_NAME"] = "Last Name";
    PlanSmartReportSubFields["ZIP_CODE"] = "ZIP";
    PlanSmartReportSubFields["COUNTY"] = "County";
    PlanSmartReportSubFields["TOTAL_DRUGS"] = "Total Drugs";
    PlanSmartReportSubFields["PCP_NAME"] = "PCP Name";
    PlanSmartReportSubFields["CARRIER_NAME"] = "Carrier Name";
    PlanSmartReportSubFields["PLAN_NAME"] = "Plan Name";
    PlanSmartReportSubFields["ANNUAL_PLAN_PREMIUM"] = "Annual Plan Premium";
    PlanSmartReportSubFields["ON_FORMULARY_DRUGS"] = "On Formulary Drugs";
    PlanSmartReportSubFields["EST_ANNUAL_DRUG_COST"] = "Est Annual Drug Cost";
    PlanSmartReportSubFields["TOTAL_ANNUAL_EST_COST"] = "Total Annual Est Cost";
    PlanSmartReportSubFields["PCP_NETWORK_STATUS"] = "PCP Network Status";
})(PlanSmartReportSubFields || (PlanSmartReportSubFields = {}));
var PlanSmartReportFieldKeys;
(function (PlanSmartReportFieldKeys) {
    PlanSmartReportFieldKeys["FIRST_NAME"] = "firstName";
    PlanSmartReportFieldKeys["LAST_NAME"] = "lastName";
    PlanSmartReportFieldKeys["ZIP_CODE"] = "zipCode";
    PlanSmartReportFieldKeys["COUNTY"] = "city";
    PlanSmartReportFieldKeys["TOTAL_DRUGS"] = "prescriptionsCount";
    PlanSmartReportFieldKeys["PCP_NAME"] = "pcpName";
    PlanSmartReportFieldKeys["CARRIER_NAME"] = "carrierName";
    PlanSmartReportFieldKeys["PLAN_NAME"] = "planName";
    PlanSmartReportFieldKeys["ANNUAL_PLAN_PREMIUM"] = "annualPlanPremium";
    PlanSmartReportFieldKeys["ON_FORMULARY_DRUGS"] = "drugsOnFormulary";
    PlanSmartReportFieldKeys["EST_ANNUAL_DRUG_COST"] = "estAnnualDrugCost";
    PlanSmartReportFieldKeys["TOTAL_ANNUAL_EST_COST"] = "totalEstAnnualCost";
    PlanSmartReportFieldKeys["PCP_NETWORK_STATUS"] = "pcpNetworkStatus";
})(PlanSmartReportFieldKeys || (PlanSmartReportFieldKeys = {}));
var PcpNetworkStatus;
(function (PcpNetworkStatus) {
    PcpNetworkStatus["IN_NETWORK"] = "In-Network";
    PcpNetworkStatus["OUT_OF_NETWORK"] = "Out-of-Network";
})(PcpNetworkStatus || (PcpNetworkStatus = {}));
const PLAN_SMART_REPORTS_FILE_HEADINGS = {
    [PlanSmartReportFields.MEMBER_INFO]: {
        [PlanSmartReportFieldKeys.FIRST_NAME]: PlanSmartReportSubFields.FIRST_NAME,
        [PlanSmartReportFieldKeys.LAST_NAME]: PlanSmartReportSubFields.LAST_NAME,
        [PlanSmartReportFieldKeys.ZIP_CODE]: PlanSmartReportSubFields.ZIP_CODE,
        [PlanSmartReportFieldKeys.COUNTY]: PlanSmartReportSubFields.COUNTY,
        [PlanSmartReportFieldKeys.TOTAL_DRUGS]: PlanSmartReportSubFields.TOTAL_DRUGS,
        [PlanSmartReportFieldKeys.PCP_NAME]: PlanSmartReportSubFields.PCP_NAME
    },
    [PlanSmartReportFields.CURRENT_PLAN]: {
        [PlanSmartReportFieldKeys.CARRIER_NAME]: PlanSmartReportSubFields.CARRIER_NAME,
        [PlanSmartReportFieldKeys.PLAN_NAME]: PlanSmartReportSubFields.PLAN_NAME
    },
    [PlanSmartReportFields.NEXT_YEAR_PLAN]: {
        [PlanSmartReportFieldKeys.CARRIER_NAME]: PlanSmartReportSubFields.CARRIER_NAME,
        [PlanSmartReportFieldKeys.PLAN_NAME]: PlanSmartReportSubFields.PLAN_NAME,
        [PlanSmartReportFieldKeys.ANNUAL_PLAN_PREMIUM]: PlanSmartReportSubFields.ANNUAL_PLAN_PREMIUM,
        [PlanSmartReportFieldKeys.ON_FORMULARY_DRUGS]: PlanSmartReportSubFields.ON_FORMULARY_DRUGS,
        [PlanSmartReportFieldKeys.EST_ANNUAL_DRUG_COST]: PlanSmartReportSubFields.EST_ANNUAL_DRUG_COST,
        [PlanSmartReportFieldKeys.TOTAL_ANNUAL_EST_COST]: PlanSmartReportSubFields.TOTAL_ANNUAL_EST_COST,
        [PlanSmartReportFieldKeys.PCP_NETWORK_STATUS]: PlanSmartReportSubFields.PCP_NETWORK_STATUS
    },
    [PlanSmartReportFields.LOWEST_ESTIMATED_COST_PLAN_PCP_IN_NETWORK]: {
        [PlanSmartReportFieldKeys.CARRIER_NAME]: PlanSmartReportSubFields.CARRIER_NAME,
        [PlanSmartReportFieldKeys.PLAN_NAME]: PlanSmartReportSubFields.PLAN_NAME,
        [PlanSmartReportFieldKeys.ANNUAL_PLAN_PREMIUM]: PlanSmartReportSubFields.ANNUAL_PLAN_PREMIUM,
        [PlanSmartReportFieldKeys.ON_FORMULARY_DRUGS]: PlanSmartReportSubFields.ON_FORMULARY_DRUGS,
        [PlanSmartReportFieldKeys.EST_ANNUAL_DRUG_COST]: PlanSmartReportSubFields.EST_ANNUAL_DRUG_COST,
        [PlanSmartReportFieldKeys.TOTAL_ANNUAL_EST_COST]: PlanSmartReportSubFields.TOTAL_ANNUAL_EST_COST,
        [PlanSmartReportFieldKeys.PCP_NETWORK_STATUS]: PlanSmartReportSubFields.PCP_NETWORK_STATUS
    },
    [PlanSmartReportFields.LOWEST_ESTIMATED_COST_PLAN_REGARDLESS_OF_PCP_IN_NETWORK]: {
        [PlanSmartReportFieldKeys.CARRIER_NAME]: PlanSmartReportSubFields.CARRIER_NAME,
        [PlanSmartReportFieldKeys.PLAN_NAME]: PlanSmartReportSubFields.PLAN_NAME,
        [PlanSmartReportFieldKeys.ANNUAL_PLAN_PREMIUM]: PlanSmartReportSubFields.ANNUAL_PLAN_PREMIUM,
        [PlanSmartReportFieldKeys.ON_FORMULARY_DRUGS]: PlanSmartReportSubFields.ON_FORMULARY_DRUGS,
        [PlanSmartReportFieldKeys.EST_ANNUAL_DRUG_COST]: PlanSmartReportSubFields.EST_ANNUAL_DRUG_COST,
        [PlanSmartReportFieldKeys.TOTAL_ANNUAL_EST_COST]: PlanSmartReportSubFields.TOTAL_ANNUAL_EST_COST,
        [PlanSmartReportFieldKeys.PCP_NETWORK_STATUS]: PlanSmartReportSubFields.PCP_NETWORK_STATUS
    }
};
const PLAN_SMART_REPORTS_FILE_TYPE = 'text/plain';
var PlanSmartCardReportSummaryHeightSelectors;
(function (PlanSmartCardReportSummaryHeightSelectors) {
    PlanSmartCardReportSummaryHeightSelectors["TOTAL_COST_SECTION"] = "total-cost-section";
    PlanSmartCardReportSummaryHeightSelectors["PLAN_SMART_NAME_SECTION"] = "plan-name-section";
    PlanSmartCardReportSummaryHeightSelectors["COST_SAVING_SECTION"] = "cost-saving-section";
})(PlanSmartCardReportSummaryHeightSelectors || (PlanSmartCardReportSummaryHeightSelectors = {}));

class PlanSmartFacade {
    constructor(configResourceService, store, plansService, fileUtilityService) {
        this.configResourceService = configResourceService;
        this.store = store;
        this.plansService = plansService;
        this.fileUtilityService = fileUtilityService;
    }
    getSortOptions(widgetName) {
        return [
            {
                label: this.configResourceService.getProcessedResourceValue('Spa_PlanSmart_Sort_EstimatedSavings_Text', widgetName, 'Estimated savings'),
                value: PlanSmartSortFields.TOTAL_ESTIMATE
            },
            {
                label: this.configResourceService.getProcessedResourceValue('Spa_PlanSmart_Sort_LastName_Text', widgetName, 'Last name'),
                value: PlanSmartSortFields.LAST_NAME
            }
        ];
    }
    getPlanSmartSort() {
        return this.store.selectSnapshot(PlansState.planSmartSorts);
    }
    getSortByPlanSavings(planSmartData) {
        return planSmartData.sort((planSmartA, planSmartB) => {
            const planSavingA = planSmartA?.memberRequest?.planSavings ?? 0;
            const planSavingB = planSmartB?.memberRequest?.planSavings ?? 0;
            if (planSavingA !== planSavingB) {
                if (planSavingA < planSavingB) {
                    return 1;
                }
                else if (planSavingA > planSavingB) {
                    return -1;
                }
                else {
                    return 0;
                }
            }
            else {
                return planSmartA?.memberRequest?.lastName?.localeCompare(planSmartB?.memberRequest?.lastName);
            }
        });
    }
    updateSortGroup(planSmartSort, planYear) {
        this.store.dispatch(new UpdatePlanSmartSort(planSmartSort, planYear));
    }
    planSmartLoading$() {
        return this.store.select(PlansState.planSmartLoading);
    }
    getPlanSmartLogoUrl(logoUrl) {
        const logoBaseUrl = this.plansService.getLogoBaseUrl();
        if (logoUrl && logoBaseUrl) {
            return new URL(logoUrl, logoBaseUrl).toString();
        }
        return null;
    }
    getCurrency(premium) {
        return premium ? this.plansService.getCurrency(premium) : '$0.00';
    }
    getConvertedDate(date, offsetIncluded) {
        if (date) {
            const utcDate = offsetIncluded || date.endsWith('Z') ? date : `${date}Z`;
            return DateUtilities.getFormattedPTDate(utcDate, DateUtilities.dateTimeFormat);
        }
        return '';
    }
    initializePlanSmartFilterGroups(planYearList) {
        this.store.dispatch(new InitializePlanSmartFilterGroups(planYearList));
    }
    getPlanSmartFilterGroup$() {
        return this.store.select(PlansState.planSmartFilterGroup);
    }
    getFilteredPlanSmartReportData(planYear) {
        return this.store.selectSnapshot(PlansState.getPlansSmartReportByFilterGroup(planYear));
    }
    downloadPlanSmartReport(data, filename, contentType) {
        this.fileUtilityService.downloadFile(data, filename, contentType);
    }
    generatePlanSmartReport(planYear) {
        const planSmartReports = this.store.selectSnapshot(PlansState.planSmartReports);
        if (planSmartReports?.[planYear]) {
            const planSmartReport = planSmartReports[planYear];
            const [completedDateDay, completedDateMonth, completedDateYear] = planSmartReport.reportCompletedDate.split(' ')[0].split('/');
            const fileName = `Plansmart-Report - ${completedDateYear}-${completedDateMonth}-${completedDateDay}.txt`;
            const planSmartReportData = planSmartReport.data;
            const primaryHeadingsKeys = Object.keys(PLAN_SMART_REPORTS_FILE_HEADINGS);
            let fileData = this.prepareFileHeadings(primaryHeadingsKeys);
            fileData += planSmartReportData.reduce((result, memberData) => {
                return result + this.extractPlanSmartReportData(primaryHeadingsKeys, memberData);
            }, '');
            this.downloadPlanSmartReport(fileData, fileName, PLAN_SMART_REPORTS_FILE_TYPE);
        }
    }
    prepareFileHeadings(primaryHeadingsKeys) {
        const fileDataAndSecondaryHeadings = this.prepareFileDataAndHeadings(primaryHeadingsKeys);
        const { fileData, secondaryHeadingsFields } = fileDataAndSecondaryHeadings;
        const formattedFileData = fileData.slice(0, -1) + '\n';
        const formattedSecondaryHeadings = secondaryHeadingsFields.join('\t') + '\n';
        return formattedFileData + formattedSecondaryHeadings;
    }
    extractPlanSmartReportData(reportFields, planSmartReportData) {
        const memberRequest = planSmartReportData.memberRequest;
        const currentPlan = planSmartReportData.planSmartResults.find((plan) => plan.isCurrentYearPlan);
        const nextYearPlan = planSmartReportData.planSmartResults.find((plan) => plan.isNextYearPlan);
        const lowestCostPlanPCPInNetwork = planSmartReportData.planSmartResults.find((plan) => plan.isLowestCostPlan && plan.pcpNetworkStatus);
        const lowestCostPlan = planSmartReportData.planSmartResults.find((plan) => plan.isLowestCostPlan);
        const memberData = this.prepareReportData(reportFields, memberRequest, currentPlan, nextYearPlan, lowestCostPlanPCPInNetwork, lowestCostPlan);
        return memberData.slice(0, -1) + '\n';
    }
    prepareFileDataAndHeadings(primaryHeadingsKeys) {
        const defaultValue = {
            fileData: '',
            secondaryHeadingsFields: []
        };
        return (primaryHeadingsKeys?.reduce((result, primaryHeading) => {
            const secondaryHeadings = Object.entries(PLAN_SMART_REPORTS_FILE_HEADINGS[primaryHeading]);
            const { secondaryHeadingsKeys, secondaryHeadingsValues } = this.prepareSecondaryHeadings(secondaryHeadings);
            result.secondaryHeadingsFields.push(...secondaryHeadingsValues);
            if (primaryHeading !== PlanSmartReportFields.MEMBER_INFO) {
                result.fileData += primaryHeading;
            }
            secondaryHeadingsKeys.forEach(_ => {
                result.fileData += '\t';
            });
            return result;
        }, defaultValue) ?? defaultValue);
    }
    prepareSecondaryHeadings(secondaryHeadings) {
        const defaultValue = {
            secondaryHeadingsKeys: [],
            secondaryHeadingsValues: []
        };
        return (secondaryHeadings?.reduce((result, [key, value]) => {
            result.secondaryHeadingsKeys.push(key);
            result.secondaryHeadingsValues.push(value);
            return result;
        }, defaultValue) ?? defaultValue);
    }
    getPcpNetworkStatusForReport(secondaryHeading, planData) {
        if (secondaryHeading === PlanSmartReportFieldKeys.PCP_NETWORK_STATUS) {
            return planData[secondaryHeading] === false ? PcpNetworkStatus.OUT_OF_NETWORK + '\t' : PcpNetworkStatus.IN_NETWORK + '\t';
        }
        else {
            return planData[secondaryHeading] || planData[secondaryHeading] === 0 ? `${planData[secondaryHeading]}\t` : '\t';
        }
    }
    prepareReportData(reportFields, memberRequest, currentPlan, nextYearPlan, lowestCostPlanPCPInNetwork, lowestCostPlan) {
        return (reportFields.reduce((reportFieldData, reportField) => {
            const secondaryHeadingsKeys = Object.keys(PLAN_SMART_REPORTS_FILE_HEADINGS[reportField]);
            const fieldData = secondaryHeadingsKeys.reduce((secondaryHeadingData, secondaryHeading) => {
                if (reportField === PlanSmartReportFields.MEMBER_INFO) {
                    secondaryHeadingData +=
                        memberRequest && (memberRequest[secondaryHeading] || memberRequest[secondaryHeading] === 0)
                            ? `${memberRequest[secondaryHeading]}\t`
                            : '\t';
                }
                else if (reportField === PlanSmartReportFields.CURRENT_PLAN) {
                    secondaryHeadingData += currentPlan && currentPlan[secondaryHeading] ? `${currentPlan[secondaryHeading]}\t` : '\t';
                }
                else if (reportField === PlanSmartReportFields.NEXT_YEAR_PLAN) {
                    secondaryHeadingData += nextYearPlan ? this.getPcpNetworkStatusForReport(secondaryHeading, nextYearPlan) : '\t';
                }
                else if (reportField === PlanSmartReportFields.LOWEST_ESTIMATED_COST_PLAN_PCP_IN_NETWORK) {
                    secondaryHeadingData += lowestCostPlanPCPInNetwork
                        ? this.getPcpNetworkStatusForReport(secondaryHeading, lowestCostPlanPCPInNetwork)
                        : '\t';
                }
                else if (reportField === PlanSmartReportFields.LOWEST_ESTIMATED_COST_PLAN_REGARDLESS_OF_PCP_IN_NETWORK) {
                    secondaryHeadingData += lowestCostPlan ? this.getPcpNetworkStatusForReport(secondaryHeading, lowestCostPlan) : '\t';
                }
                return secondaryHeadingData;
            }, '');
            return reportFieldData + fieldData;
        }, '') ?? '');
    }
}
PlanSmartFacade.ɵfac = function PlanSmartFacade_Factory(t) { return new (t || PlanSmartFacade)(i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.PlansService), i0.ɵɵinject(i1.FileDownloadUtilityService)); };
PlanSmartFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PlanSmartFacade, factory: PlanSmartFacade.ɵfac, providedIn: 'root' });
__decorate([
    Memoize()
], PlanSmartFacade.prototype, "prepareFileHeadings", null);
__decorate([
    Memoize()
], PlanSmartFacade.prototype, "prepareFileDataAndHeadings", null);
__decorate([
    Memoize()
], PlanSmartFacade.prototype, "prepareSecondaryHeadings", null);
__decorate([
    Memoize()
], PlanSmartFacade.prototype, "getPcpNetworkStatusForReport", null);
__decorate([
    Memoize()
], PlanSmartFacade.prototype, "prepareReportData", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanSmartFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: i2.Store }, { type: i1.PlansService }, { type: i1.FileDownloadUtilityService }]; }, { prepareFileHeadings: [], prepareFileDataAndHeadings: [], prepareSecondaryHeadings: [], getPcpNetworkStatusForReport: [], prepareReportData: [] }); })();

function PlanSmartCardReportSummary_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.isNextYearPlan ? "Spa_Style_Gray2_Background" : "costs-savings-background Spa_Style_Secondary_Text_Color");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.isNextYearPlan ? ctx_r0.planSmartContinuedText : ctx_r0.isEstimatedSavingTextEnabled ? ctx_r0.savingText : "", " ");
} }
function PlanSmartCardReportSummary_div_5_vnext_plan_logo_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-plan-logo", 12);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("imageSrc", ctx_r3.planSmartLogoUrl)("classNames", "plan-logo")("planLogoSize", "small");
} }
function PlanSmartCardReportSummary_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, PlanSmartCardReportSummary_div_5_vnext_plan_logo_1_Template, 1, 3, "vnext-plan-logo", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.planSmartLogoUrl);
} }
function PlanSmartCardReportSummary_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-widget-pcp-network-status", 13);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("providerText", ctx_r2.providerText)("providerInNetworkText", ctx_r2.providerInNetworkText)("pcpNetworkStatus", ctx_r2.pcpNetworkStatus)("pcpName", ctx_r2.pcpName)("pcpText", ctx_r2.pcpText);
} }
const _c0$1s = function (a0, a1, a2) { return { "no-next-year-report": a0, "plan-smart-label": a1, "plan-smart-label-show-logo": a2 }; };
class PlanSmartCardReportSummary {
    constructor(planSmartFacade) {
        this.planSmartFacade = planSmartFacade;
        this.planSmartCardReportSummaryHeightSelectors = PlanSmartCardReportSummaryHeightSelectors;
    }
    ngOnChanges(changes) {
        const { estimatedSavingsText, logoURL, drugsOnFormulary, prescriptionsCoveredText } = changes;
        if (estimatedSavingsText && estimatedSavingsText.previousValue !== estimatedSavingsText.currentValue) {
            this.savingText = this.estimatedSavingsText?.replace('<estimatedSavings>', this.planSmartFacade.getCurrency(this.planSavings)) ?? '';
        }
        if (logoURL && logoURL.previousValue !== logoURL.currentValue) {
            this.planSmartLogoUrl = this.planSmartFacade.getPlanSmartLogoUrl(this.logoURL);
        }
        if ((drugsOnFormulary && drugsOnFormulary.previousValue !== drugsOnFormulary.currentValue) ||
            (prescriptionsCoveredText && prescriptionsCoveredText.previousValue !== prescriptionsCoveredText.currentValue)) {
            if (this.prescriptionsCoveredText && (this.drugsOnFormulary || this.drugsOnFormulary === 0)) {
                this.prescriptionsCoveredText = this.prescriptionsCoveredText?.replace('<coveredDrugCount>', this.drugsOnFormulary.toString());
            }
        }
    }
}
PlanSmartCardReportSummary.ɵfac = function PlanSmartCardReportSummary_Factory(t) { return new (t || PlanSmartCardReportSummary)(i0.ɵɵdirectiveInject(PlanSmartFacade)); };
PlanSmartCardReportSummary.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanSmartCardReportSummary, selectors: [["vnext-plan-smart-card-report-summary"]], inputs: { lowCostPlanLabel: "lowCostPlanLabel", totalEstimatedCostText: "totalEstimatedCostText", showPlanLogo: "showPlanLogo", planSmartContinuedText: "planSmartContinuedText", estimatedSavingsText: "estimatedSavingsText", planSmartNextYearLabel: "planSmartNextYearLabel", isNextYearAvailable: "isNextYearAvailable", isLowestCostPlanAvailable: "isLowestCostPlanAvailable", isNextYearPlan: "isNextYearPlan", planName: "planName", totalEstAnnualCost: "totalEstAnnualCost", logoURL: "logoURL", planSavings: "planSavings", isEstimatedSavingTextEnabled: "isEstimatedSavingTextEnabled", isProviderEnabled: "isProviderEnabled", providerText: "providerText", providerInNetworkText: "providerInNetworkText", pcpNetworkStatus: "pcpNetworkStatus", pcpName: "pcpName", pcpText: "pcpText", prescriptionLabel: "prescriptionLabel", prescriptionsCoveredText: "prescriptionsCoveredText", drugsOnFormulary: "drugsOnFormulary" }, features: [i0.ɵɵNgOnChangesFeature], decls: 19, vars: 24, consts: [["class", "rounded Spa_Style_Paragraph px-2 fit-content Spa_Style_Bold_Weight", 3, "ngClass", 4, "ngIf"], [1, "Spa_Style_H3", 3, "ngClass"], [1, "Spa_Style_Paragraph"], ["class", "plan-logo-wrapper d-flex align-items-center mb-2", 4, "ngIf"], [1, "Spa_Style_Bold_Weight"], [1, "fas", "Spa_Style_PrescriptionsIcon", "mr-1"], [1, "ml-4", "Spa_Style_Gray4_Color"], [4, "ngIf"], [1, "d-md-none"], [1, "rounded", "Spa_Style_Paragraph", "px-2", "fit-content", "Spa_Style_Bold_Weight", 3, "ngClass"], [1, "plan-logo-wrapper", "d-flex", "align-items-center", "mb-2"], [3, "imageSrc", "classNames", "planLogoSize", 4, "ngIf"], [3, "imageSrc", "classNames", "planLogoSize"], [3, "providerText", "providerInNetworkText", "pcpNetworkStatus", "pcpName", "pcpText"]], template: function PlanSmartCardReportSummary_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, PlanSmartCardReportSummary_div_1_Template, 2, 2, "div", 0);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "h4", 1);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtemplate(5, PlanSmartCardReportSummary_div_5_Template, 2, 1, "div", 3);
        i0.ɵɵelementStart(6, "div");
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div");
        i0.ɵɵtext(9);
        i0.ɵɵpipe(10, "currency");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 4);
        i0.ɵɵelement(12, "i", 5);
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 6);
        i0.ɵɵtext(15);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(16, PlanSmartCardReportSummary_ng_container_16_Template, 2, 5, "ng-container", 7);
        i0.ɵɵelementStart(17, "div", 8);
        i0.ɵɵelement(18, "hr");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassMapInterpolate1("pb-2 ", ctx.planSmartCardReportSummaryHeightSelectors.COST_SAVING_SECTION, "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isNextYearAvailable);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(20, _c0$1s, !ctx.isNextYearAvailable, !ctx.showPlanLogo, ctx.showPlanLogo));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.isNextYearPlan ? ctx.planSmartNextYearLabel : ctx.lowCostPlanLabel, "\n");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showPlanLogo);
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("Spa_Style_Gray4_Color Spa_Style_Note plan-smart-name py-2 no-translate-block ", ctx.planSmartCardReportSummaryHeightSelectors.PLAN_SMART_NAME_SECTION, "");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.planName, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("pb-3 ", ctx.planSmartCardReportSummaryHeightSelectors.TOTAL_COST_SECTION, "");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.totalEstimatedCostText + " " + i0.ɵɵpipeBind1(10, 18, ctx.totalEstAnnualCost), " ");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.prescriptionLabel, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.prescriptionsCoveredText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isProviderEnabled);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, IconAriaAttributesDirective, PCPNetworkStatusComponent, PlanLogoComponent, i1$2.CurrencyPipe], styles: [".no-next-year-report[_ngcontent-%COMP%]{margin-top:3.2rem}.plan-smart-label[_ngcontent-%COMP%]{margin-bottom:.75rem}.plan-smart-label-show-logo[_ngcontent-%COMP%]{margin-bottom:.375rem}.plan-smart-name[_ngcontent-%COMP%]{min-height:2rem}.fit-content[_ngcontent-%COMP%]{width:-moz-fit-content;width:fit-content}.plan-logo-wrapper[_ngcontent-%COMP%]{height:2.2rem}.costs-savings-background[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Cost_Text)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanSmartCardReportSummary, [{
        type: Component,
        args: [{ selector: 'vnext-plan-smart-card-report-summary', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"pb-2 {{ planSmartCardReportSummaryHeightSelectors.COST_SAVING_SECTION }}\">\r\n  <div\r\n    *ngIf=\"isNextYearAvailable\"\r\n    class=\"rounded Spa_Style_Paragraph px-2 fit-content Spa_Style_Bold_Weight\"\r\n    [ngClass]=\"isNextYearPlan ? 'Spa_Style_Gray2_Background' : 'costs-savings-background Spa_Style_Secondary_Text_Color'\"\r\n  >\r\n    {{ isNextYearPlan ? planSmartContinuedText : isEstimatedSavingTextEnabled ? savingText : '' }}\r\n  </div>\r\n</div>\r\n<h4\r\n  [ngClass]=\"{\r\n    'no-next-year-report': !isNextYearAvailable,\r\n    'plan-smart-label': !showPlanLogo,\r\n    'plan-smart-label-show-logo': showPlanLogo\r\n  }\"\r\n  class=\"Spa_Style_H3\"\r\n>\r\n  {{ isNextYearPlan ? planSmartNextYearLabel : lowCostPlanLabel }}\r\n</h4>\r\n<div class=\"Spa_Style_Paragraph\">\r\n  <div *ngIf=\"showPlanLogo\" class=\"plan-logo-wrapper d-flex align-items-center mb-2\">\r\n    <vnext-plan-logo\r\n      *ngIf=\"planSmartLogoUrl\"\r\n      [imageSrc]=\"planSmartLogoUrl\"\r\n      [classNames]=\"'plan-logo'\"\r\n      [planLogoSize]=\"'small'\"\r\n    ></vnext-plan-logo>\r\n  </div>\r\n  <div\r\n    class=\"Spa_Style_Gray4_Color Spa_Style_Note plan-smart-name py-2 no-translate-block {{\r\n      planSmartCardReportSummaryHeightSelectors.PLAN_SMART_NAME_SECTION\r\n    }}\"\r\n  >\r\n    {{ planName }}\r\n  </div>\r\n  <div class=\"pb-3 {{ planSmartCardReportSummaryHeightSelectors.TOTAL_COST_SECTION }}\">\r\n    {{ totalEstimatedCostText + ' ' + (totalEstAnnualCost | currency) }}\r\n  </div>\r\n  <div class=\"Spa_Style_Bold_Weight\">\r\n    <i class=\"fas Spa_Style_PrescriptionsIcon mr-1\"></i>\r\n    {{ prescriptionLabel }}\r\n  </div>\r\n  <div class=\"ml-4 Spa_Style_Gray4_Color\">{{ prescriptionsCoveredText }}</div>\r\n</div>\r\n<ng-container *ngIf=\"isProviderEnabled\">\r\n  <vnext-widget-pcp-network-status\r\n    [providerText]=\"providerText\"\r\n    [providerInNetworkText]=\"providerInNetworkText\"\r\n    [pcpNetworkStatus]=\"pcpNetworkStatus\"\r\n    [pcpName]=\"pcpName\"\r\n    [pcpText]=\"pcpText\"\r\n  >\r\n  </vnext-widget-pcp-network-status>\r\n</ng-container>\r\n<div class=\"d-md-none\">\r\n  <hr />\r\n</div>\r\n", styles: [".no-next-year-report{margin-top:3.2rem}.plan-smart-label{margin-bottom:.75rem}.plan-smart-label-show-logo{margin-bottom:.375rem}.plan-smart-name{min-height:2rem}.fit-content{width:-moz-fit-content;width:fit-content}.plan-logo-wrapper{height:2.2rem}.costs-savings-background{background-color:var(--static-Spa_Style_Cost_Text)}\n"] }]
    }], function () { return [{ type: PlanSmartFacade }]; }, { lowCostPlanLabel: [{
            type: Input
        }], totalEstimatedCostText: [{
            type: Input
        }], showPlanLogo: [{
            type: Input
        }], planSmartContinuedText: [{
            type: Input
        }], estimatedSavingsText: [{
            type: Input
        }], planSmartNextYearLabel: [{
            type: Input
        }], isNextYearAvailable: [{
            type: Input
        }], isLowestCostPlanAvailable: [{
            type: Input
        }], isNextYearPlan: [{
            type: Input
        }], planName: [{
            type: Input
        }], totalEstAnnualCost: [{
            type: Input
        }], logoURL: [{
            type: Input
        }], planSavings: [{
            type: Input
        }], isEstimatedSavingTextEnabled: [{
            type: Input
        }], isProviderEnabled: [{
            type: Input
        }], providerText: [{
            type: Input
        }], providerInNetworkText: [{
            type: Input
        }], pcpNetworkStatus: [{
            type: Input
        }], pcpName: [{
            type: Input
        }], pcpText: [{
            type: Input
        }], prescriptionLabel: [{
            type: Input
        }], prescriptionsCoveredText: [{
            type: Input
        }], drugsOnFormulary: [{
            type: Input
        }] }); })();

function PlanSmartCardComponent_div_7_div_1_vnext_plan_logo_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-plan-logo", 21);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("imageSrc", ctx_r6.logoUrl)("classNames", "plan-logo")("planLogoSize", "small");
} }
function PlanSmartCardComponent_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, PlanSmartCardComponent_div_7_div_1_vnext_plan_logo_1_Template, 1, 3, "vnext-plan-logo", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.logoUrl);
} }
function PlanSmartCardComponent_div_7_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate3("", ctx_r5.planSmartMember.city, ", ", ctx_r5.planSmartMember.state, " ", ctx_r5.planSmartMember.zipCode, ",");
} }
function PlanSmartCardComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, PlanSmartCardComponent_div_7_div_1_Template, 2, 1, "div", 16);
    i0.ɵɵelementStart(2, "div", 17);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PlanSmartCardComponent_div_7_div_4_Template, 2, 3, "div", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showPlanLogo);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.currentPlanYearReport == null ? null : ctx_r0.currentPlanYearReport.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.planSmartMember);
} }
function PlanSmartCardComponent_ng_container_10_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "vnext-plan-smart-card-report-summary", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const reportSummary_r8 = ctx.$implicit;
    const index_r9 = ctx.index;
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-plan-id", reportSummary_r8.planId + "-" + index_r9);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("lowCostPlanLabel", ctx_r7.lowCostPlanLabel)("totalEstimatedCostText", ctx_r7.totalEstimatedCostText)("showPlanLogo", ctx_r7.showPlanLogo)("planSmartContinuedText", ctx_r7.planSmartContinuedText)("estimatedSavingsText", ctx_r7.estimatedSavingsText)("planSmartNextYearLabel", ctx_r7.planSmartNextYearLabel)("isNextYearAvailable", ctx_r7.reportData.memberRequest == null ? null : ctx_r7.reportData.memberRequest.isNextYearPlan)("isLowestCostPlanAvailable", reportSummary_r8.isLowestCostPlan)("isNextYearPlan", reportSummary_r8.isNextYearPlan)("planName", reportSummary_r8.planName)("totalEstAnnualCost", reportSummary_r8.totalEstAnnualCost)("logoURL", reportSummary_r8.logoURL ? reportSummary_r8.logoURL : reportSummary_r8.logo2URL)("planSavings", reportSummary_r8.planSavings)("isEstimatedSavingTextEnabled", ctx_r7.reportData.memberRequest == null ? null : ctx_r7.reportData.memberRequest.isEstimatedSavingTextEnabled)("isProviderEnabled", ctx_r7.isProviderEnabled)("providerText", ctx_r7.providerText)("providerInNetworkText", reportSummary_r8 == null ? null : reportSummary_r8.inNetworkText)("pcpName", ctx_r7.planSmartMember == null ? null : ctx_r7.planSmartMember.pcpName)("pcpNetworkStatus", reportSummary_r8.pcpNetworkStatus)("pcpText", ctx_r7.pcpText)("prescriptionLabel", ctx_r7.prescriptionLabel)("prescriptionsCoveredText", ctx_r7.prescriptionText)("drugsOnFormulary", reportSummary_r8 == null ? null : reportSummary_r8.drugsOnFormulary);
} }
function PlanSmartCardComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanSmartCardComponent_ng_container_10_div_1_Template, 2, 24, "div", 23);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.otherPlanYearReports)("ngForTrackBy", ctx_r1.trackByPlanId);
} }
function PlanSmartCardComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25)(1, "p", 15);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.beneficiaryErrorText);
} }
const _c0$1r = function (a0, a1) { return { "plan-smart-label": a0, "plan-smart-label-show-logo": a1 }; };
class PlanSmartCardComponent {
    constructor(navigationService, memberSessionService, store, planSmartFacade) {
        this.navigationService = navigationService;
        this.memberSessionService = memberSessionService;
        this.store = store;
        this.planSmartFacade = planSmartFacade;
        this.isExpanded = false;
        this.planSmartReportList = [];
        this.planSmartCardReportSummaryHeightSelectors = [
            PlanSmartCardReportSummaryHeightSelectors.COST_SAVING_SECTION,
            PlanSmartCardReportSummaryHeightSelectors.PLAN_SMART_NAME_SECTION,
            PlanSmartCardReportSummaryHeightSelectors.TOTAL_COST_SECTION
        ];
        this.planSmartCardReportSummaryParentHeightIdentifier = 'plan-id';
        this.currentYear = (new Date()).getFullYear();
        this.viewMember = new EventEmitter();
        this.trackByPlanId = (index, reportSummary) => {
            const additionalKey = this.getAdditionalKey(reportSummary.isCurrentYearPlan, reportSummary.isNextYearPlan, index);
            return `${reportSummary.planId}-${additionalKey}`;
        };
    }
    ngOnChanges(changes) {
        const { reportData, prescriptionsCoveredText, enrollmentSubmittedText, quoteSentText, pacificStandardTimeText, noPrescriptionsText, providerInNetworkText, noProviderText, selectedPcpOption } = changes;
        if (reportData && !_isEqual(reportData.previousValue, reportData.currentValue)) {
            this.planSmartMember = this.reportData.memberRequest;
            this.planSmartReportList = this.reportData.planSmartResults;
            this.currentPlanYearReport = this.planSmartReportList.find(report => report.isCurrentYearPlan);
            this.memberName = `${this.planSmartMember?.firstName} ${this.planSmartMember?.lastName}`;
            const logoUrl = this.currentPlanYearReport?.logoURL ?? this.currentPlanYearReport?.logo2URL;
            this.logoUrl = this.planSmartFacade.getPlanSmartLogoUrl(logoUrl);
        }
        if ((reportData && !_isEqual(reportData.previousValue, reportData.currentValue)) ||
            (providerInNetworkText && providerInNetworkText.previousValue !== providerInNetworkText.currentValue) ||
            (noProviderText && noProviderText.previousValue !== noProviderText.currentValue) ||
            (selectedPcpOption && selectedPcpOption.previousValue !== selectedPcpOption.currentValue)) {
            const isNextYearPlans = this.planSmartReportList.filter(report => report.isNextYearPlan);
            let isLowestCostPlans = this.planSmartReportList.filter(report => report.isLowestCostPlan);
            if (isLowestCostPlans.length && isLowestCostPlans.length > 1) {
                isLowestCostPlans = isLowestCostPlans.filter(report => this.selectedPcpOption ? report.considerPCPInNetwork : !report.considerPCPInNetwork);
            }
            this.otherPlanYearReports = isNextYearPlans.concat(isLowestCostPlans);
            if (this.isProviderEnabled) {
                this.otherPlanYearReports = this.otherPlanYearReports.map(report => ({
                    ...report,
                    inNetworkText: this.getUpdatedInNetworkText(report)
                }));
            }
        }
        if ((reportData && !_isEqual(reportData.previousValue, reportData.currentValue)) ||
            (prescriptionsCoveredText && prescriptionsCoveredText.previousValue !== prescriptionsCoveredText.currentValue) ||
            (noPrescriptionsText && noPrescriptionsText.previousValue !== noPrescriptionsText.currentValue)) {
            this.prescriptionText = this.getPrescriptionText(this.planSmartMember, this.prescriptionsCoveredText, this.noPrescriptionsText);
        }
        if ((reportData && !_isEqual(reportData.previousValue, reportData.currentValue)) ||
            (enrollmentSubmittedText && enrollmentSubmittedText.previousValue !== enrollmentSubmittedText.currentValue) ||
            (quoteSentText && quoteSentText.previousValue !== quoteSentText.currentValue) ||
            (pacificStandardTimeText && pacificStandardTimeText.previousValue !== pacificStandardTimeText.currentValue)) {
            this.enrollmentText = this.getEnrollmentText(this.planSmartMember);
        }
    }
    getUpdatedInNetworkText(plan) {
        if (this.planSmartMember?.totalNumberOfProviders) {
            return this.providerInNetworkText
                .replace('<inNetwork>', plan?.numberOfInNetworkProviders?.toString() ?? '0')
                .replace('<totalProviders>', this.planSmartMember.totalNumberOfProviders.toString());
        }
        else {
            return this.noProviderText;
        }
    }
    toggle() {
        this.isExpanded = !this.isExpanded;
    }
    navigateToPlanList() {
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        this.memberSessionService.selectMemberForAgent$(agentGuid, this.reportData.memberId).subscribe(() => {
            this.store.dispatch(new SetSelectedPlanSmartDetails(this.reportData));
            this.memberSessionService.updateSelectedMemberDetails();
            this.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
        });
    }
    getEnrollmentText(planSmartMember) {
        if (planSmartMember?.enrollmentSubmittedDate) {
            return `${this.enrollmentSubmittedText} ${this.planSmartFacade.getConvertedDate(planSmartMember?.enrollmentSubmittedDate)} ${this.pacificStandardTimeText}`;
        }
        else if (planSmartMember?.quoteSentDate) {
            return `${this.quoteSentText} ${this.planSmartFacade.getConvertedDate(planSmartMember?.quoteSentDate, true)} ${this.pacificStandardTimeText}`;
        }
        return '';
    }
    getPrescriptionText(planSmartMember, prescriptionsCoveredText, noPrescriptionsText) {
        if (planSmartMember?.prescriptionsCount) {
            return prescriptionsCoveredText?.replace('<totalDrugCount>', planSmartMember.prescriptionsCount.toString()) ?? '';
        }
        return noPrescriptionsText ?? '';
    }
    getAdditionalKey(isCurrentYearPlan, isNextYearPlan, defaultKey) {
        let additionalKey = defaultKey;
        if (isCurrentYearPlan) {
            additionalKey = this.currentYear;
        }
        else if (isNextYearPlan) {
            additionalKey = this.currentYear + 1;
        }
        return additionalKey;
    }
}
PlanSmartCardComponent.ɵfac = function PlanSmartCardComponent_Factory(t) { return new (t || PlanSmartCardComponent)(i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(PlanSmartFacade)); };
PlanSmartCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanSmartCardComponent, selectors: [["vnext-plan-smart-card"]], inputs: { reportData: "reportData", planSmartCurrentYearLabel: "planSmartCurrentYearLabel", planSmartNextYearLabel: "planSmartNextYearLabel", planSmartContinuedText: "planSmartContinuedText", showPlanLogo: "showPlanLogo", prescriptionsCoveredText: "prescriptionsCoveredText", totalEstimatedCostText: "totalEstimatedCostText", lowCostPlanLabel: "lowCostPlanLabel", estimatedSavingsText: "estimatedSavingsText", buttonText: "buttonText", quoteSentText: "quoteSentText", enrollmentSubmittedText: "enrollmentSubmittedText", pacificStandardTimeText: "pacificStandardTimeText", isProviderEnabled: "isProviderEnabled", selectedPcpOption: "selectedPcpOption", providerText: "providerText", providerInNetworkText: "providerInNetworkText", noProviderText: "noProviderText", pcpText: "pcpText", prescriptionLabel: "prescriptionLabel", noPrescriptionsText: "noPrescriptionsText", beneficiaryErrorText: "beneficiaryErrorText" }, outputs: { viewMember: "viewMember" }, features: [i0.ɵɵNgOnChangesFeature], decls: 20, vars: 17, consts: [["vnextMaximumHeight", "", 1, "plan-smart-card", "mb-3", "plan-smart-card-border", "row", 3, "heightSelectorsToCompare", "parentElementIdentifier"], [1, "col-12", "col-md-4"], [1, "user-name-container", "no-translate-block"], [3, "title", "alwaysUnderlined", "click"], [1, "Spa_Style_H3", "can-click", 3, "ngClass", "click"], ["aria-hidden", "true"], ["class", "Spa_Style_Note Spa_Style_Gray4_Color", 4, "ngIf"], [1, "d-md-none"], [4, "ngIf", "ngIfElse"], ["showErrorMsg", ""], [1, "col-12", "mt-0", "mt-md-4"], [1, "row", "justify-content-between"], [1, "col-12", "col-md-4", "Spa_Style_Note", "Spa_Style_Gray4_Color", "my-2"], [1, "col-12", "col-md-3"], ["type", "button", 1, "btn", "btn-block", "Spa_Style_PrimaryButton", "px-1", 3, "click"], [1, "Spa_Style_Note", "Spa_Style_Gray4_Color"], ["class", "plan-logo-wrapper mb-2", 4, "ngIf"], [1, "summary-plan-name", "mt-1", "no-translate-block"], ["class", "no-translate-block", 4, "ngIf"], [1, "plan-logo-wrapper", "mb-2"], [3, "imageSrc", "classNames", "planLogoSize", 4, "ngIf"], [3, "imageSrc", "classNames", "planLogoSize"], [1, "no-translate-block"], ["class", "col-12 col-md-4", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "lowCostPlanLabel", "totalEstimatedCostText", "showPlanLogo", "planSmartContinuedText", "estimatedSavingsText", "planSmartNextYearLabel", "isNextYearAvailable", "isLowestCostPlanAvailable", "isNextYearPlan", "planName", "totalEstAnnualCost", "logoURL", "planSavings", "isEstimatedSavingTextEnabled", "isProviderEnabled", "providerText", "providerInNetworkText", "pcpName", "pcpNetworkStatus", "pcpText", "prescriptionLabel", "prescriptionsCoveredText", "drugsOnFormulary"], [1, "col-12", "col-md-8", "error-container"]], template: function PlanSmartCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "vnext-link", 3);
        i0.ɵɵlistener("click", function PlanSmartCardComponent_Template_vnext_link_click_3_listener() { return ctx.viewMember.emit(ctx.reportData.memberId); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "h4", 4);
        i0.ɵɵlistener("click", function PlanSmartCardComponent_Template_h4_click_4_listener() { return ctx.toggle(); });
        i0.ɵɵtext(5);
        i0.ɵɵelement(6, "i", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, PlanSmartCardComponent_div_7_Template, 5, 3, "div", 6);
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵelement(9, "hr");
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(10, PlanSmartCardComponent_ng_container_10_Template, 2, 2, "ng-container", 8);
        i0.ɵɵtemplate(11, PlanSmartCardComponent_ng_template_11_Template, 3, 1, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(13, "div", 10)(14, "div", 11)(15, "div", 12);
        i0.ɵɵtext(16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 13)(18, "button", 14);
        i0.ɵɵlistener("click", function PlanSmartCardComponent_Template_button_click_18_listener() { return ctx.navigateToPlanList(); });
        i0.ɵɵtext(19);
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(12);
        i0.ɵɵproperty("heightSelectorsToCompare", ctx.planSmartCardReportSummaryHeightSelectors)("parentElementIdentifier", ctx.planSmartCardReportSummaryParentHeightIdentifier);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("title", ctx.memberName)("alwaysUnderlined", true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(14, _c0$1r, !ctx.showPlanLogo, ctx.showPlanLogo));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.planSmartCurrentYearLabel, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("fas ", ctx.isExpanded ? "fa-angle-up" : "fa-angle-down", "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isExpanded);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.reportData.isFailed)("ngIfElse", _r2);
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate(ctx.enrollmentText);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.buttonText);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, MaximumHeightDirective, PlanSmartCardReportSummary, PlanLogoComponent], styles: [".plan-smart-card[_ngcontent-%COMP%]{border-width:1px;border-style:solid;border-top-right-radius:4px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;padding:10px 0}.plan-smart-card.plan-smart-card-border[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent1);border-top-left-radius:4px}.plan-logo-wrapper[_ngcontent-%COMP%]{height:1.7rem}.summary-plan-name[_ngcontent-%COMP%]{min-height:2.4rem}.user-name-container[_ngcontent-%COMP%]{min-height:3.2rem}.plan-smart-label[_ngcontent-%COMP%]{margin-bottom:.75rem}.plan-smart-label-show-logo[_ngcontent-%COMP%]{margin-bottom:.375rem}.error-container[_ngcontent-%COMP%]{margin-top:3.2rem}"], changeDetection: 0 });
__decorate([
    Memoize()
], PlanSmartCardComponent.prototype, "getAdditionalKey", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanSmartCardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-smart-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  class=\"plan-smart-card mb-3 plan-smart-card-border row\"\r\n  vnextMaximumHeight\r\n  [heightSelectorsToCompare]=\"planSmartCardReportSummaryHeightSelectors\"\r\n  [parentElementIdentifier]=\"planSmartCardReportSummaryParentHeightIdentifier\"\r\n>\r\n  <div class=\"col-12 col-md-4\">\r\n    <div class=\"user-name-container no-translate-block\">\r\n      <vnext-link [title]=\"memberName\" [alwaysUnderlined]=\"true\" (click)=\"viewMember.emit(reportData.memberId)\"></vnext-link>\r\n    </div>\r\n    <h4\r\n      class=\"Spa_Style_H3 can-click\"\r\n      [ngClass]=\"{\r\n        'plan-smart-label': !showPlanLogo,\r\n        'plan-smart-label-show-logo': showPlanLogo\r\n      }\"\r\n      (click)=\"toggle()\"\r\n    >\r\n      {{ planSmartCurrentYearLabel }}\r\n      <i class=\"fas {{ isExpanded ? 'fa-angle-up' : 'fa-angle-down' }}\" aria-hidden=\"true\"></i>\r\n    </h4>\r\n    <div class=\"Spa_Style_Note Spa_Style_Gray4_Color\" *ngIf=\"isExpanded\">\r\n      <div class=\"plan-logo-wrapper mb-2\" *ngIf=\"showPlanLogo\">\r\n        <vnext-plan-logo *ngIf=\"logoUrl\" [imageSrc]=\"logoUrl\" [classNames]=\"'plan-logo'\" [planLogoSize]=\"'small'\"></vnext-plan-logo>\r\n      </div>\r\n      <div class=\"summary-plan-name mt-1 no-translate-block\">{{ currentPlanYearReport?.planName }}</div>\r\n      <div *ngIf=\"planSmartMember\" class=\"no-translate-block\">{{ planSmartMember.city }}, {{ planSmartMember.state }} {{ planSmartMember.zipCode }},</div>\r\n    </div>\r\n    <div class=\"d-md-none\">\r\n      <hr />\r\n    </div>\r\n  </div>\r\n  <ng-container *ngIf=\"!reportData.isFailed; else showErrorMsg\">\r\n    <div\r\n      class=\"col-12 col-md-4\"\r\n      *ngFor=\"let reportSummary of otherPlanYearReports; trackBy: trackByPlanId; index as index\"\r\n      [attr.data-plan-id]=\"reportSummary.planId + '-' + index\"\r\n    >\r\n      <vnext-plan-smart-card-report-summary\r\n        [lowCostPlanLabel]=\"lowCostPlanLabel\"\r\n        [totalEstimatedCostText]=\"totalEstimatedCostText\"\r\n        [showPlanLogo]=\"showPlanLogo\"\r\n        [planSmartContinuedText]=\"planSmartContinuedText\"\r\n        [estimatedSavingsText]=\"estimatedSavingsText\"\r\n        [planSmartNextYearLabel]=\"planSmartNextYearLabel\"\r\n        [isNextYearAvailable]=\"reportData.memberRequest?.isNextYearPlan\"\r\n        [isLowestCostPlanAvailable]=\"reportSummary.isLowestCostPlan\"\r\n        [isNextYearPlan]=\"reportSummary.isNextYearPlan\"\r\n        [planName]=\"reportSummary.planName\"\r\n        [totalEstAnnualCost]=\"reportSummary.totalEstAnnualCost\"\r\n        [logoURL]=\"reportSummary.logoURL ? reportSummary.logoURL : reportSummary.logo2URL\"\r\n        [planSavings]=\"reportSummary.planSavings\"\r\n        [isEstimatedSavingTextEnabled]=\"reportData.memberRequest?.isEstimatedSavingTextEnabled\"\r\n        [isProviderEnabled]=\"isProviderEnabled\"\r\n        [providerText]=\"providerText\"\r\n        [providerInNetworkText]=\"reportSummary?.inNetworkText\"\r\n        [pcpName]=\"planSmartMember?.pcpName\"\r\n        [pcpNetworkStatus]=\"reportSummary.pcpNetworkStatus\"\r\n        [pcpText]=\"pcpText\"\r\n        [prescriptionLabel]=\"prescriptionLabel\"\r\n        [prescriptionsCoveredText]=\"prescriptionText\"\r\n        [drugsOnFormulary]=\"reportSummary?.drugsOnFormulary\"\r\n      ></vnext-plan-smart-card-report-summary>\r\n    </div>\r\n  </ng-container>\r\n  <ng-template #showErrorMsg>\r\n    <div class=\"col-12 col-md-8 error-container\">\r\n      <p class=\"Spa_Style_Note Spa_Style_Gray4_Color\">{{ beneficiaryErrorText }}</p>\r\n    </div>\r\n  </ng-template>\r\n  <div class=\"col-12 mt-0 mt-md-4\">\r\n    <div class=\"row justify-content-between\">\r\n      <div class=\"col-12 col-md-4 Spa_Style_Note Spa_Style_Gray4_Color my-2\">{{ enrollmentText }}</div>\r\n      <div class=\"col-12 col-md-3\">\r\n        <button type=\"button\" class=\"btn btn-block Spa_Style_PrimaryButton px-1\" (click)=\"navigateToPlanList()\">{{ buttonText }}</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".plan-smart-card{border-width:1px;border-style:solid;border-top-right-radius:4px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;padding:10px 0}.plan-smart-card.plan-smart-card-border{border-color:var(--static-Spa_Style_Accent1);border-top-left-radius:4px}.plan-logo-wrapper{height:1.7rem}.summary-plan-name{min-height:2.4rem}.user-name-container{min-height:3.2rem}.plan-smart-label{margin-bottom:.75rem}.plan-smart-label-show-logo{margin-bottom:.375rem}.error-container{margin-top:3.2rem}\n"] }]
    }], function () { return [{ type: i1.NavigationService }, { type: i1.MemberSessionService }, { type: i2.Store }, { type: PlanSmartFacade }]; }, { reportData: [{
            type: Input
        }], planSmartCurrentYearLabel: [{
            type: Input
        }], planSmartNextYearLabel: [{
            type: Input
        }], planSmartContinuedText: [{
            type: Input
        }], showPlanLogo: [{
            type: Input
        }], prescriptionsCoveredText: [{
            type: Input
        }], totalEstimatedCostText: [{
            type: Input
        }], lowCostPlanLabel: [{
            type: Input
        }], estimatedSavingsText: [{
            type: Input
        }], buttonText: [{
            type: Input
        }], quoteSentText: [{
            type: Input
        }], enrollmentSubmittedText: [{
            type: Input
        }], pacificStandardTimeText: [{
            type: Input
        }], isProviderEnabled: [{
            type: Input
        }], selectedPcpOption: [{
            type: Input
        }], providerText: [{
            type: Input
        }], providerInNetworkText: [{
            type: Input
        }], noProviderText: [{
            type: Input
        }], pcpText: [{
            type: Input
        }], prescriptionLabel: [{
            type: Input
        }], noPrescriptionsText: [{
            type: Input
        }], beneficiaryErrorText: [{
            type: Input
        }], viewMember: [{
            type: Output
        }], getAdditionalKey: [] }); })();

function PlanSmartReportButtonComponent_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵlistener("click", function PlanSmartReportButtonComponent_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.runReport.emit()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.buttonText, " ");
} }
class PlanSmartReportButtonComponent {
    constructor() {
        this.runReport = new EventEmitter();
    }
}
PlanSmartReportButtonComponent.ɵfac = function PlanSmartReportButtonComponent_Factory(t) { return new (t || PlanSmartReportButtonComponent)(); };
PlanSmartReportButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanSmartReportButtonComponent, selectors: [["vnext-widget-plan-smart-report-button"]], inputs: { introText: "introText", buttonText: "buttonText", activeTab: "activeTab", reportInProgressText: "reportInProgressText" }, outputs: { runReport: "runReport" }, decls: 4, vars: 2, consts: [[1, "Spa_Style_Paragraph", "Spa_Style_Regular_Font"], [1, "form-row", "flex-column", "align-items-center"], ["type", "submit", "tabindex", "0", "class", "btn Spa_Style_PrimaryButton", 3, "click", 4, "liveEditProp"], ["type", "submit", "tabindex", "0", 1, "btn", "Spa_Style_PrimaryButton", 3, "click"]], template: function PlanSmartReportButtonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "p", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵtemplate(3, PlanSmartReportButtonComponent_button_3_Template, 2, 1, "button", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.introText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_PlanSmart_Run_Button_Text");
    } }, dependencies: [LiveEditPropDirective], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanSmartReportButtonComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-smart-report-button', changeDetection: ChangeDetectionStrategy.OnPush, template: "<p class=\"Spa_Style_Paragraph Spa_Style_Regular_Font\">{{ introText }}</p>\r\n<div class=\"form-row flex-column align-items-center\">\r\n  <button\r\n    type=\"submit\"\r\n    tabindex=\"0\"\r\n    class=\"btn Spa_Style_PrimaryButton\"\r\n    *liveEditProp=\"'Spa_PlanSmart_Run_Button_Text'\"\r\n    (click)=\"runReport.emit()\"\r\n  >\r\n    {{ buttonText }}\r\n  </button>\r\n</div>\r\n" }]
    }], null, { introText: [{
            type: Input
        }], buttonText: [{
            type: Input
        }], activeTab: [{
            type: Input
        }], reportInProgressText: [{
            type: Input
        }], runReport: [{
            type: Output
        }] }); })();

const _c0$1q = ["planSmartFilterButton"];
function PlanSmartTabContentComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "h3", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "vnext-widget-plan-smart-report-button", 6);
    i0.ɵɵlistener("runReport", function PlanSmartTabContentComponent_div_0_div_2_Template_vnext_widget_plan_smart_report_button_runReport_3_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.runReport.emit(ctx_r4.activeTab)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.runBeforeHeaderText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("introText", ctx_r1.introText)("buttonText", ctx_r1.buttonText)("activeTab", ctx_r1.activeTab);
} }
function PlanSmartTabContentComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "h3", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.duringRunHeaderText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.reportInProgressText);
} }
function PlanSmartTabContentComponent_div_0_ng_container_4_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29)(1, "vnext-link", 30);
    i0.ɵɵlistener("click", function PlanSmartTabContentComponent_div_0_ng_container_4_div_4_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r13.downloadResults()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r6.downloadLinkText)("alwaysUnderlined", true)("linkTarget", "_blank")("additionalIcon", ctx_r6.downloadIcon)("iconColor", ctx_r6.downloadIconColor);
} }
function PlanSmartTabContentComponent_div_0_ng_container_4_h4_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h4", 31);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r8.sortHeaderText);
} }
function PlanSmartTabContentComponent_div_0_ng_container_4_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵlistener("click", function PlanSmartTabContentComponent_div_0_ng_container_4_div_20_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r17); const sort_r15 = restoredCtx.$implicit; const ctx_r16 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r16.changeSort(sort_r15)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sort_r15 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", sort_r15.label, " ");
} }
function PlanSmartTabContentComponent_div_0_ng_container_4_div_25_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-plan-smart-card", 34);
    i0.ɵɵlistener("viewMember", function PlanSmartTabContentComponent_div_0_ng_container_4_div_25_div_1_Template_vnext_plan_smart_card_viewMember_1_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r20.viewMember.emit($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const reportData_r19 = ctx.$implicit;
    const ctx_r18 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("reportData", reportData_r19)("planSmartCurrentYearLabel", ctx_r18.planSmartCurrentYearLabel)("planSmartNextYearLabel", ctx_r18.planSmartNextYearLabel)("planSmartContinuedText", ctx_r18.planSmartContinuedText)("showPlanLogo", ctx_r18.showPlanLogo)("prescriptionsCoveredText", ctx_r18.prescriptionsCoveredText)("noPrescriptionsText", ctx_r18.noPrescriptionsText)("totalEstimatedCostText", ctx_r18.totalEstimatedCostText)("buttonText", ctx_r18.planSmartButtonText)("lowCostPlanLabel", ctx_r18.lowCostPlanLabel)("estimatedSavingsText", ctx_r18.estimatedSavingsText)("quoteSentText", ctx_r18.quoteSentText)("enrollmentSubmittedText", ctx_r18.enrollmentSubmittedText)("pacificStandardTimeText", ctx_r18.pacificStandardTimeText)("isProviderEnabled", ctx_r18.isProviderEnabled)("selectedPcpOption", ctx_r18.selectedPcpOption)("providerText", ctx_r18.providerText)("providerInNetworkText", ctx_r18.providerInNetworkText)("noProviderText", ctx_r18.noProviderText)("pcpText", ctx_r18.pcpText)("prescriptionLabel", ctx_r18.prescriptionLabel)("beneficiaryErrorText", ctx_r18.beneficiaryErrorText);
} }
function PlanSmartTabContentComponent_div_0_ng_container_4_div_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PlanSmartTabContentComponent_div_0_ng_container_4_div_25_div_1_Template, 2, 22, "div", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r10.planSmartReportData)("ngForTrackBy", ctx_r10.trackByMemberId);
} }
function PlanSmartTabContentComponent_div_0_ng_container_4_ng_template_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35)(1, "h3", 36);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p", 37);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r12.noPlanSmartHeaderMessage);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r12.noPlanSmartBodyMessage);
} }
const _c1$E = function (a0) { return { "d-flex align-items-center justify-content-center": a0 }; };
function PlanSmartTabContentComponent_div_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div")(2, "div", 8)(3, "div", 9);
    i0.ɵɵtemplate(4, PlanSmartTabContentComponent_div_0_ng_container_4_div_4_Template, 2, 5, "div", 10);
    i0.ɵɵelementStart(5, "div", 11);
    i0.ɵɵelementContainerStart(6);
    i0.ɵɵelementStart(7, "button", 12, 13);
    i0.ɵɵlistener("click", function PlanSmartTabContentComponent_div_0_ng_container_4_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r22.showFilters()); });
    i0.ɵɵelement(9, "i", 14);
    i0.ɵɵelementStart(10, "span");
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 15);
    i0.ɵɵtemplate(13, PlanSmartTabContentComponent_div_0_ng_container_4_h4_13_Template, 2, 1, "h4", 16);
    i0.ɵɵelementStart(14, "div", 17)(15, "input", 18);
    i0.ɵɵlistener("keydown", function PlanSmartTabContentComponent_div_0_ng_container_4_Template_input_keydown_15_listener($event) { return $event.preventDefault(); })("ngModelChange", function PlanSmartTabContentComponent_div_0_ng_container_4_Template_input_ngModelChange_15_listener() { i0.ɵɵrestoreView(_r23); const ctx_r25 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r25.sortOption); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(16, "i", 19);
    i0.ɵɵelementStart(17, "span", 20);
    i0.ɵɵtext(18, "Expand menu");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 21);
    i0.ɵɵtemplate(20, PlanSmartTabContentComponent_div_0_ng_container_4_div_20_Template, 2, 1, "div", 22);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementStart(21, "div", 23)(22, "div", 24)(23, "vnext-plan-smart-filter", 25);
    i0.ɵɵlistener("filterItemClicked", function PlanSmartTabContentComponent_div_0_ng_container_4_Template_vnext_plan_smart_filter_filterItemClicked_23_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r26 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r26.onFilterItemClicked($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(24, "div", 26);
    i0.ɵɵtemplate(25, PlanSmartTabContentComponent_div_0_ng_container_4_div_25_Template, 2, 2, "div", 27);
    i0.ɵɵtemplate(26, PlanSmartTabContentComponent_div_0_ng_container_4_ng_template_26_Template, 5, 2, "ng-template", null, 28, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r11 = i0.ɵɵreference(27);
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r3.showDownloadResultsButton);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", ctx_r3.filterHeaderText);
    i0.ɵɵattribute("aria-label", ctx_r3.filterHeaderText);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r3.filterHeaderText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Agent_Search_SortHeader_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r3.sortOption == null ? null : ctx_r3.sortOption.label);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r3.sortOptions);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("planYear", ctx_r3.activeTab == null ? null : ctx_r3.activeTab.title)("filterHeaderText", ctx_r3.filterHeaderText)("filterStateText", ctx_r3.filterStateText)("filterClearAllText", ctx_r3.filterClearAllText)("filterQuoteText", ctx_r3.filterQuoteText)("filterEnrollmentApplicationsText", ctx_r3.filterEnrollmentApplicationsText)("carrierOptions", ctx_r3.carrierOptions)("carrierText", ctx_r3.carrierText)("isCarrierFilterEnabled", ctx_r3.isCarrierFilterEnabled)("pcpFilterText", ctx_r3.pcpFilterText)("isPcpFilterEnabled", ctx_r3.isPcpFilterEnabled)("isPcpFilterChecked", ctx_r3.isPcpFilterChecked);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(22, _c1$E, !(ctx_r3.planSmartReportData == null ? null : ctx_r3.planSmartReportData.length)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.planSmartReportData == null ? null : ctx_r3.planSmartReportData.length)("ngIfElse", _r11);
} }
function PlanSmartTabContentComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementContainerStart(1, 1);
    i0.ɵɵtemplate(2, PlanSmartTabContentComponent_div_0_div_2_Template, 4, 4, "div", 2);
    i0.ɵɵtemplate(3, PlanSmartTabContentComponent_div_0_div_3_Template, 5, 2, "div", 2);
    i0.ɵɵtemplate(4, PlanSmartTabContentComponent_div_0_ng_container_4_Template, 28, 24, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r0.currentPlanSmartStatus);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.planSmartStatus.INITIATE);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.planSmartStatus.IN_PROGRESS);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.planSmartStatus.COMPLETED);
} }
class PlanSmartTabContentComponent {
    constructor(cdr, planSmartFacade, modalService) {
        this.cdr = cdr;
        this.planSmartFacade = planSmartFacade;
        this.modalService = modalService;
        this.carrierOptions = [];
        this.runReport = new EventEmitter();
        this.viewMember = new EventEmitter();
        this.selectedSortOption = new EventEmitter();
        this.planSmartStatus = PlanSmartStatus;
    }
    trackByMemberId(index, report) {
        return report.memberId;
    }
    ngOnChanges(changes) {
        const { activeTab, isPcpFilterChecked } = changes;
        if (activeTab && !_isEqual(activeTab.previousValue, activeTab.currentValue)) {
            this.sortOption = this.defaultSortOption;
            this.changeSort(this.sortOption);
        }
        if (isPcpFilterChecked && isPcpFilterChecked.firstChange) {
            this.selectedPcpOption = this.isPcpFilterChecked;
        }
    }
    changeSort(value) {
        if (value && this.activeTab?.title) {
            this.sortOption = value;
            this.planSmartFacade.updateSortGroup(value, this.activeTab.title);
            this.selectedSortOption.emit(value);
        }
    }
    downloadResults() {
        this.planSmartFacade.generatePlanSmartReport(this.activeTab.title);
    }
    onFilterItemClicked(filterControl) {
        if (filterControl.name === planSmartControlNames.pcpInNetworkControlName) {
            this.selectedPcpOption = !!filterControl.value?.[0];
            this.cdr.markForCheck();
        }
    }
    async showFilters() {
        const planFilterModal = this.modalService.open(PlanSmartFilterModalComponent, { centered: true });
        planFilterModal.componentInstance.planYear = this.activeTab?.title;
        planFilterModal.componentInstance.filterHeaderText = this.filterHeaderText;
        planFilterModal.componentInstance.filterStateText = this.filterStateText;
        planFilterModal.componentInstance.filterClearAllText = this.filterClearAllText;
        planFilterModal.componentInstance.filterQuoteText = this.filterQuoteText;
        planFilterModal.componentInstance.filterEnrollmentApplicationsText = this.filterEnrollmentApplicationsText;
        planFilterModal.componentInstance.carrierOptions = this.carrierOptions;
        planFilterModal.componentInstance.carrierText = this.carrierText;
        planFilterModal.componentInstance.isCarrierFilterEnabled = this.isCarrierFilterEnabled;
        planFilterModal.componentInstance.pcpFilterText = this.pcpFilterText;
        planFilterModal.componentInstance.isPcpFilterEnabled = this.isPcpFilterEnabled;
        planFilterModal.componentInstance.isPcpFilterChecked = this.isPcpFilterChecked;
        planFilterModal.componentInstance.isMobile = true;
        planFilterModal.componentInstance.filterModalCancelButtonText = this.filterModalCancelButtonText;
        planFilterModal.componentInstance.filterModalApplyButtonText = this.filterModalApplyButtonText;
        planFilterModal.result.catch(() => {
            this.setFocusToFilterPlansButton();
        });
    }
    setFocusToFilterPlansButton() {
        if (this.planSmartFilterButtonElement) {
            this.planSmartFilterButtonElement.nativeElement.focus();
        }
    }
}
PlanSmartTabContentComponent.ɵfac = function PlanSmartTabContentComponent_Factory(t) { return new (t || PlanSmartTabContentComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlanSmartFacade), i0.ɵɵdirectiveInject(i1$1.NgbModal)); };
PlanSmartTabContentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanSmartTabContentComponent, selectors: [["vnext-widget-plan-smart-tab-content"]], viewQuery: function PlanSmartTabContentComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1q, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.planSmartFilterButtonElement = _t.first);
    } }, inputs: { introText: "introText", activeTab: "activeTab", buttonText: "buttonText", reportInProgressText: "reportInProgressText", currentPlanSmartStatus: "currentPlanSmartStatus", planSmartReportData: "planSmartReportData", planSmartCurrentYearLabel: "planSmartCurrentYearLabel", planSmartNextYearLabel: "planSmartNextYearLabel", planSmartContinuedText: "planSmartContinuedText", showPlanLogo: "showPlanLogo", prescriptionsCoveredText: "prescriptionsCoveredText", totalEstimatedCostText: "totalEstimatedCostText", lowCostPlanLabel: "lowCostPlanLabel", planSmartButtonText: "planSmartButtonText", estimatedSavingsText: "estimatedSavingsText", defaultSortOption: "defaultSortOption", sortOptions: "sortOptions", quoteSentText: "quoteSentText", enrollmentSubmittedText: "enrollmentSubmittedText", pacificStandardTimeText: "pacificStandardTimeText", filterHeaderText: "filterHeaderText", filterStateText: "filterStateText", filterClearAllText: "filterClearAllText", filterQuoteText: "filterQuoteText", filterEnrollmentApplicationsText: "filterEnrollmentApplicationsText", noPlanSmartHeaderMessage: "noPlanSmartHeaderMessage", noPlanSmartBodyMessage: "noPlanSmartBodyMessage", runBeforeHeaderText: "runBeforeHeaderText", duringRunHeaderText: "duringRunHeaderText", carrierText: "carrierText", isCarrierFilterEnabled: "isCarrierFilterEnabled", carrierOptions: "carrierOptions", isProviderEnabled: "isProviderEnabled", providerText: "providerText", providerInNetworkText: "providerInNetworkText", noProviderText: "noProviderText", pcpText: "pcpText", prescriptionLabel: "prescriptionLabel", noPrescriptionsText: "noPrescriptionsText", pcpFilterText: "pcpFilterText", downloadLinkText: "downloadLinkText", downloadIcon: "downloadIcon", downloadIconColor: "downloadIconColor", showDownloadResultsButton: "showDownloadResultsButton", isPcpFilterEnabled: "isPcpFilterEnabled", isPcpFilterChecked: "isPcpFilterChecked", filterModalCancelButtonText: "filterModalCancelButtonText", filterModalApplyButtonText: "filterModalApplyButtonText", beneficiaryErrorText: "beneficiaryErrorText", sortHeaderText: "sortHeaderText" }, outputs: { runReport: "runReport", viewMember: "viewMember", selectedSortOption: "selectedSortOption" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "ngSwitch"], ["class", "text-center", 4, "ngSwitchCase"], [4, "ngSwitchCase"], [1, "text-center"], [1, "Spa_Style_H3"], [3, "introText", "buttonText", "activeTab", "runReport"], [1, "Spa_Style_Paragraph", "Spa_Style_Regular_Font"], [1, "row", "px-4", "justify-content-start", "justify-content-md-end"], [1, "d-flex", "col-9", "row", "align-items-end", "py-3", "pl-md-0"], ["class", "px-0", 4, "ngIf"], [1, "col-12", "d-flex", "d-md-none", "px-0", "py-3"], ["type", "button", "tabindex", "0", 1, "plan-mobile-filter", "my-auto", "action-button", "Spa_Style_Link", "d-inline", 3, "title", "click"], ["planSmartFilterButton", ""], [1, "fas", "fa-filter", "mr-2"], [1, "ml-md-auto", "px-0"], ["id", "sortHeaderId", "class", "Spa_Style_H4", 4, "liveEditProp"], ["ngbDropdown", "", 1, "position-relative"], ["ngbDropdownToggle", "", "type", "text", "tabindex", "0", "autocomplete", "new-text", "placeholder", "", "aria-labelledby", "sortHeaderId", 1, "Spa_Style_Primary_Color", "form-control", "can-click", "dropdown", 3, "ngModel", "keydown", "ngModelChange"], ["ngbDropdownToggle", "", 1, "fas", "fa-angle-down", "icon-in-input", "can-click", "float-right"], [1, "sr-only"], ["ngbDropdownMenu", ""], ["class", "Spa_Style_Primary_Color can-click", "ngbDropdownItem", "", 3, "click", 4, "ngFor", "ngForOf"], [1, "row", "px-4"], [1, "d-none", "d-md-block", "col-md-3"], [3, "planYear", "filterHeaderText", "filterStateText", "filterClearAllText", "filterQuoteText", "filterEnrollmentApplicationsText", "carrierOptions", "carrierText", "isCarrierFilterEnabled", "pcpFilterText", "isPcpFilterEnabled", "isPcpFilterChecked", "filterItemClicked"], [1, "col-12", "col-sm-12", "col-md-9", "ml-md-auto", "ml-sm-auto", 3, "ngClass"], [4, "ngIf", "ngIfElse"], ["showNoFilterMessage", ""], [1, "px-0"], [1, "pl-2", "link", 3, "title", "alwaysUnderlined", "linkTarget", "additionalIcon", "iconColor", "click"], ["id", "sortHeaderId", 1, "Spa_Style_H4"], ["ngbDropdownItem", "", 1, "Spa_Style_Primary_Color", "can-click", 3, "click"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "reportData", "planSmartCurrentYearLabel", "planSmartNextYearLabel", "planSmartContinuedText", "showPlanLogo", "prescriptionsCoveredText", "noPrescriptionsText", "totalEstimatedCostText", "buttonText", "lowCostPlanLabel", "estimatedSavingsText", "quoteSentText", "enrollmentSubmittedText", "pacificStandardTimeText", "isProviderEnabled", "selectedPcpOption", "providerText", "providerInNetworkText", "noProviderText", "pcpText", "prescriptionLabel", "beneficiaryErrorText", "viewMember"], [1, "col-12", "text-center"], [1, "Spa_Style_Large_Font", "Spa_Style_H3"], [1, "Spa_Style_Paragraph"]], template: function PlanSmartTabContentComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanSmartTabContentComponent_div_0_Template, 5, 4, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.activeTab == null ? null : ctx.activeTab.title);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, LinkComponent, LiveEditPropDirective, IconAriaAttributesDirective, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem, PlanSmartCardComponent, PlanSmartReportButtonComponent, PlanSmartFilterComponent], styles: [".icon-in-input[_ngcontent-%COMP%]{position:absolute;top:8px;left:calc(100% - 15px)}input.dropdown[_ngcontent-%COMP%]{height:36px}.dropdown[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{width:100%;padding:0;margin-top:0}.dropdown-menu[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]{padding:6px 10px;white-space:normal}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanSmartTabContentComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-smart-tab-content', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"activeTab?.title\">\r\n  <ng-container [ngSwitch]=\"currentPlanSmartStatus\">\r\n    <div *ngSwitchCase=\"planSmartStatus.INITIATE\" class=\"text-center\">\r\n      <h3 class=\"Spa_Style_H3\">{{ runBeforeHeaderText }}</h3>\r\n      <vnext-widget-plan-smart-report-button\r\n        [introText]=\"introText\"\r\n        [buttonText]=\"buttonText\"\r\n        [activeTab]=\"activeTab\"\r\n        (runReport)=\"runReport.emit(activeTab)\"\r\n      ></vnext-widget-plan-smart-report-button>\r\n    </div>\r\n    <div *ngSwitchCase=\"planSmartStatus.IN_PROGRESS\" class=\"text-center\">\r\n      <h3 class=\"Spa_Style_H3\">{{ duringRunHeaderText }}</h3>\r\n      <p class=\"Spa_Style_Paragraph Spa_Style_Regular_Font\">{{ reportInProgressText }}</p>\r\n    </div>\r\n    <ng-container *ngSwitchCase=\"planSmartStatus.COMPLETED\">\r\n      <div>\r\n        <div class=\"row px-4 justify-content-start justify-content-md-end\">\r\n          <div class=\"d-flex col-9 row align-items-end py-3 pl-md-0\">\r\n            <div *ngIf=\"showDownloadResultsButton\" class=\"px-0\">\r\n              <vnext-link\r\n                class=\"pl-2 link\"\r\n                [title]=\"downloadLinkText\"\r\n                [alwaysUnderlined]=\"true\"\r\n                [linkTarget]=\"'_blank'\"\r\n                [additionalIcon]=\"downloadIcon\"\r\n                [iconColor]=\"downloadIconColor\"\r\n                (click)=\"downloadResults()\"\r\n              ></vnext-link>\r\n            </div>\r\n            <div class=\"col-12 d-flex d-md-none px-0 py-3\">\r\n              <ng-container>\r\n                <button\r\n                  #planSmartFilterButton\r\n                  type=\"button\"\r\n                  [attr.aria-label]=\"filterHeaderText\"\r\n                  tabindex=\"0\"\r\n                  (click)=\"showFilters()\"\r\n                  class=\"plan-mobile-filter my-auto action-button Spa_Style_Link d-inline\"\r\n                  [title]=\"filterHeaderText\"\r\n                >\r\n                  <i class=\"fas fa-filter mr-2\"></i>\r\n                  <span>{{ filterHeaderText }}</span>\r\n                </button>\r\n              </ng-container>\r\n            </div>\r\n            <div class=\"ml-md-auto px-0\">\r\n              <h4 id=\"sortHeaderId\" class=\"Spa_Style_H4\" *liveEditProp=\"'Spa_Agent_Search_SortHeader_Text'\">{{ sortHeaderText }}</h4>\r\n              <div class=\"position-relative\" ngbDropdown>\r\n                <input\r\n                  ngbDropdownToggle\r\n                  type=\"text\"\r\n                  tabindex=\"0\"\r\n                  autocomplete=\"new-text\"\r\n                  placeholder=\"\"\r\n                  class=\"Spa_Style_Primary_Color form-control can-click dropdown\"\r\n                  aria-labelledby=\"sortHeaderId\"\r\n                  [ngModel]=\"sortOption?.label\"\r\n                  (keydown)=\"$event.preventDefault()\"\r\n                  (ngModelChange)=\"(sortOption)\"\r\n                />\r\n                <i class=\"fas fa-angle-down icon-in-input can-click float-right\" ngbDropdownToggle></i>\r\n                <span class=\"sr-only\">Expand menu</span>\r\n                <div ngbDropdownMenu>\r\n                  <div\r\n                    *ngFor=\"let sort of sortOptions\"\r\n                    class=\"Spa_Style_Primary_Color can-click\"\r\n                    ngbDropdownItem\r\n                    (click)=\"changeSort(sort)\"\r\n                  >\r\n                    {{ sort.label }}\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row px-4\">\r\n          <div class=\"d-none d-md-block col-md-3\">\r\n            <vnext-plan-smart-filter\r\n              [planYear]=\"activeTab?.title\"\r\n              [filterHeaderText]=\"filterHeaderText\"\r\n              [filterStateText]=\"filterStateText\"\r\n              [filterClearAllText]=\"filterClearAllText\"\r\n              [filterQuoteText]=\"filterQuoteText\"\r\n              [filterEnrollmentApplicationsText]=\"filterEnrollmentApplicationsText\"\r\n              [carrierOptions]=\"carrierOptions\"\r\n              [carrierText]=\"carrierText\"\r\n              [isCarrierFilterEnabled]=\"isCarrierFilterEnabled\"\r\n              [pcpFilterText]=\"pcpFilterText\"\r\n              [isPcpFilterEnabled]=\"isPcpFilterEnabled\"\r\n              [isPcpFilterChecked]=\"isPcpFilterChecked\"\r\n              (filterItemClicked)=\"onFilterItemClicked($event)\"\r\n            ></vnext-plan-smart-filter>\r\n          </div>\r\n          <div\r\n            class=\"col-12 col-sm-12 col-md-9 ml-md-auto ml-sm-auto\"\r\n            [ngClass]=\"{ 'd-flex align-items-center justify-content-center': !planSmartReportData?.length }\"\r\n          >\r\n            <div *ngIf=\"planSmartReportData?.length; else showNoFilterMessage\">\r\n              <div *ngFor=\"let reportData of planSmartReportData; trackBy: trackByMemberId\">\r\n                <vnext-plan-smart-card\r\n                  [reportData]=\"reportData\"\r\n                  [planSmartCurrentYearLabel]=\"planSmartCurrentYearLabel\"\r\n                  [planSmartNextYearLabel]=\"planSmartNextYearLabel\"\r\n                  [planSmartContinuedText]=\"planSmartContinuedText\"\r\n                  [showPlanLogo]=\"showPlanLogo\"\r\n                  [prescriptionsCoveredText]=\"prescriptionsCoveredText\"\r\n                  [noPrescriptionsText]=\"noPrescriptionsText\"\r\n                  [totalEstimatedCostText]=\"totalEstimatedCostText\"\r\n                  [buttonText]=\"planSmartButtonText\"\r\n                  [lowCostPlanLabel]=\"lowCostPlanLabel\"\r\n                  [estimatedSavingsText]=\"estimatedSavingsText\"\r\n                  [quoteSentText]=\"quoteSentText\"\r\n                  [enrollmentSubmittedText]=\"enrollmentSubmittedText\"\r\n                  [pacificStandardTimeText]=\"pacificStandardTimeText\"\r\n                  [isProviderEnabled]=\"isProviderEnabled\"\r\n                  [selectedPcpOption]=\"selectedPcpOption\"\r\n                  [providerText]=\"providerText\"\r\n                  [providerInNetworkText]=\"providerInNetworkText\"\r\n                  [noProviderText]=\"noProviderText\"\r\n                  [pcpText]=\"pcpText\"\r\n                  [prescriptionLabel]=\"prescriptionLabel\"\r\n                  [beneficiaryErrorText]=\"beneficiaryErrorText\"\r\n                  (viewMember)=\"viewMember.emit($event)\"\r\n                ></vnext-plan-smart-card>\r\n              </div>\r\n            </div>\r\n            <ng-template #showNoFilterMessage>\r\n              <div class=\"col-12 text-center\">\r\n                <h3 class=\"Spa_Style_Large_Font Spa_Style_H3\">{{ noPlanSmartHeaderMessage }}</h3>\r\n                <p class=\"Spa_Style_Paragraph\">{{ noPlanSmartBodyMessage }}</p>\r\n              </div>\r\n            </ng-template>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n  </ng-container>\r\n</div>\r\n", styles: [".icon-in-input{position:absolute;top:8px;left:calc(100% - 15px)}input.dropdown{height:36px}.dropdown .dropdown-menu{width:100%;padding:0;margin-top:0}.dropdown-menu .dropdown-item{padding:6px 10px;white-space:normal}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: PlanSmartFacade }, { type: i1$1.NgbModal }]; }, { planSmartFilterButtonElement: [{
            type: ViewChild,
            args: ['planSmartFilterButton']
        }], introText: [{
            type: Input
        }], activeTab: [{
            type: Input
        }], buttonText: [{
            type: Input
        }], reportInProgressText: [{
            type: Input
        }], currentPlanSmartStatus: [{
            type: Input
        }], planSmartReportData: [{
            type: Input
        }], planSmartCurrentYearLabel: [{
            type: Input
        }], planSmartNextYearLabel: [{
            type: Input
        }], planSmartContinuedText: [{
            type: Input
        }], showPlanLogo: [{
            type: Input
        }], prescriptionsCoveredText: [{
            type: Input
        }], totalEstimatedCostText: [{
            type: Input
        }], lowCostPlanLabel: [{
            type: Input
        }], planSmartButtonText: [{
            type: Input
        }], estimatedSavingsText: [{
            type: Input
        }], defaultSortOption: [{
            type: Input
        }], sortOptions: [{
            type: Input
        }], quoteSentText: [{
            type: Input
        }], enrollmentSubmittedText: [{
            type: Input
        }], pacificStandardTimeText: [{
            type: Input
        }], filterHeaderText: [{
            type: Input
        }], filterStateText: [{
            type: Input
        }], filterClearAllText: [{
            type: Input
        }], filterQuoteText: [{
            type: Input
        }], filterEnrollmentApplicationsText: [{
            type: Input
        }], noPlanSmartHeaderMessage: [{
            type: Input
        }], noPlanSmartBodyMessage: [{
            type: Input
        }], runBeforeHeaderText: [{
            type: Input
        }], duringRunHeaderText: [{
            type: Input
        }], carrierText: [{
            type: Input
        }], isCarrierFilterEnabled: [{
            type: Input
        }], carrierOptions: [{
            type: Input
        }], isProviderEnabled: [{
            type: Input
        }], providerText: [{
            type: Input
        }], providerInNetworkText: [{
            type: Input
        }], noProviderText: [{
            type: Input
        }], pcpText: [{
            type: Input
        }], prescriptionLabel: [{
            type: Input
        }], noPrescriptionsText: [{
            type: Input
        }], pcpFilterText: [{
            type: Input
        }], downloadLinkText: [{
            type: Input
        }], downloadIcon: [{
            type: Input
        }], downloadIconColor: [{
            type: Input
        }], showDownloadResultsButton: [{
            type: Input
        }], isPcpFilterEnabled: [{
            type: Input
        }], isPcpFilterChecked: [{
            type: Input
        }], filterModalCancelButtonText: [{
            type: Input
        }], filterModalApplyButtonText: [{
            type: Input
        }], beneficiaryErrorText: [{
            type: Input
        }], sortHeaderText: [{
            type: Input
        }], runReport: [{
            type: Output
        }], viewMember: [{
            type: Output
        }], selectedSortOption: [{
            type: Output
        }] }); })();

const _c0$1p = function (a0) { return { "active Spa_Style_Bold_Weight": a0 }; };
function PlanSmartTabListComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 2);
    i0.ɵɵlistener("click", function PlanSmartTabListComponent_li_1_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r3); const tabDetail_r1 = restoredCtx.$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.setActiveTab(tabDetail_r1)); })("keyup.enter", function PlanSmartTabListComponent_li_1_Template_li_keyup_enter_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r3); const tabDetail_r1 = restoredCtx.$implicit; const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.setActiveTab(tabDetail_r1)); })("keyup.Space", function PlanSmartTabListComponent_li_1_Template_li_keyup_Space_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r3); const tabDetail_r1 = restoredCtx.$implicit; const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.setActiveTab(tabDetail_r1)); });
    i0.ɵɵelement(1, "vnext-plan-details-tab", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tabDetail_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$1p, ctx_r0.activeTab.title === tabDetail_r1.title));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", tabDetail_r1.title)("isActiveTab", ctx_r0.activeTab.title === tabDetail_r1.title)("ariaControlsId", tabDetail_r1.title);
} }
class PlanSmartTabListComponent {
    constructor() {
        this.updateActiveTab = new EventEmitter();
    }
    setActiveTab(activeTab) {
        this.activeTab = activeTab;
        this.updateActiveTab.emit(activeTab);
    }
}
PlanSmartTabListComponent.ɵfac = function PlanSmartTabListComponent_Factory(t) { return new (t || PlanSmartTabListComponent)(); };
PlanSmartTabListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanSmartTabListComponent, selectors: [["vnext-widget-plan-smart-tab-list"]], inputs: { tabList: "tabList", activeTab: "activeTab" }, outputs: { updateActiveTab: "updateActiveTab" }, decls: 2, vars: 1, consts: [["role", "tablist", 1, "tabs", "tabs--horizontal", "plans-smart-tab", "text-center"], ["role", "presentation", "class", "tab Spa_Style_Gray2_Background Spa_Style_Primary_Color", 3, "ngClass", "click", "keyup.enter", "keyup.Space", 4, "ngFor", "ngForOf"], ["role", "presentation", 1, "tab", "Spa_Style_Gray2_Background", "Spa_Style_Primary_Color", 3, "ngClass", "click", "keyup.enter", "keyup.Space"], [3, "title", "isActiveTab", "ariaControlsId"]], template: function PlanSmartTabListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ul", 0);
        i0.ɵɵtemplate(1, PlanSmartTabListComponent_li_1_Template, 2, 6, "li", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.tabList);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, PlanDetailsTabComponent], styles: [".tab[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px 5px 0 0;margin:0 6px -1px;min-width:83px;display:block;position:relative;text-decoration:none;outline:none;cursor:pointer}.tab[_ngcontent-%COMP%]:hover, .tab.active[_ngcontent-%COMP%]{background-color:#fff}.tab.active[_ngcontent-%COMP%]{border-bottom-color:#fff}.tabs[_ngcontent-%COMP%]{margin:0;padding:0;list-style:none;display:flex;justify-content:center;align-items:flex-end}.tabs--horizontal[_ngcontent-%COMP%]   .tab.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{border-bottom-color:#fff}.plans-smart-tab.tabs[_ngcontent-%COMP%]{padding:15px 10px 0}.tabs--horizontal[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Primary_Light);border-bottom-style:solid;border-bottom-color:var(--static-Spa_Style_Primary_Light)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanSmartTabListComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-smart-tab-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ul class=\"tabs tabs--horizontal plans-smart-tab text-center\" role=\"tablist\">\r\n  <li\r\n    *ngFor=\"let tabDetail of tabList\"\r\n    role=\"presentation\"\r\n    class=\"tab Spa_Style_Gray2_Background Spa_Style_Primary_Color\"\r\n    (click)=\"setActiveTab(tabDetail)\"\r\n    (keyup.enter)=\"setActiveTab(tabDetail)\"\r\n    (keyup.Space)=\"setActiveTab(tabDetail)\"\r\n    [ngClass]=\"{ 'active Spa_Style_Bold_Weight': activeTab.title === tabDetail.title }\"\r\n  >\r\n    <vnext-plan-details-tab\r\n      [title]=\"tabDetail.title\"\r\n      [isActiveTab]=\"activeTab.title === tabDetail.title\"\r\n      [ariaControlsId]=\"tabDetail.title\"\r\n    >\r\n    </vnext-plan-details-tab>\r\n  </li>\r\n</ul>\r\n", styles: [".tab{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px 5px 0 0;margin:0 6px -1px;min-width:83px;display:block;position:relative;text-decoration:none;outline:none;cursor:pointer}.tab:hover,.tab.active{background-color:#fff}.tab.active{border-bottom-color:#fff}.tabs{margin:0;padding:0;list-style:none;display:flex;justify-content:center;align-items:flex-end}.tabs--horizontal .tab.active>a{border-bottom-color:#fff}.plans-smart-tab.tabs{padding:15px 10px 0}.tabs--horizontal{border-bottom:1px solid var(--static-Spa_Style_Primary_Light);border-bottom-style:solid;border-bottom-color:var(--static-Spa_Style_Primary_Light)}\n"] }]
    }], null, { tabList: [{
            type: Input
        }], activeTab: [{
            type: Input
        }], updateActiveTab: [{
            type: Output
        }] }); })();

class PlanSmartTabComponent {
    constructor() {
        this.updateActiveTab = new EventEmitter();
        this.runReport = new EventEmitter();
        this.viewMember = new EventEmitter();
        this.selectedSortOption = new EventEmitter();
    }
}
PlanSmartTabComponent.ɵfac = function PlanSmartTabComponent_Factory(t) { return new (t || PlanSmartTabComponent)(); };
PlanSmartTabComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanSmartTabComponent, selectors: [["vnext-widget-plan-smart-tab"]], inputs: { introText: "introText", activeTab: "activeTab", buttonText: "buttonText", reportInProgressText: "reportInProgressText", currentPlanSmartStatus: "currentPlanSmartStatus", tabList: "tabList", planSmartReportData: "planSmartReportData", planSmartCurrentYearLabel: "planSmartCurrentYearLabel", planSmartNextYearLabel: "planSmartNextYearLabel", planSmartContinuedText: "planSmartContinuedText", showPlanLogo: "showPlanLogo", prescriptionsCoveredText: "prescriptionsCoveredText", totalEstimatedCostText: "totalEstimatedCostText", lowCostPlanLabel: "lowCostPlanLabel", planSmartButtonText: "planSmartButtonText", estimatedSavingsText: "estimatedSavingsText", defaultSortOption: "defaultSortOption", sortOptions: "sortOptions", quoteSentText: "quoteSentText", enrollmentSubmittedText: "enrollmentSubmittedText", pacificStandardTimeText: "pacificStandardTimeText", filterHeaderText: "filterHeaderText", filterStateText: "filterStateText", filterClearAllText: "filterClearAllText", filterQuoteText: "filterQuoteText", filterEnrollmentApplicationsText: "filterEnrollmentApplicationsText", noPlanSmartHeaderMessage: "noPlanSmartHeaderMessage", noPlanSmartBodyMessage: "noPlanSmartBodyMessage", runBeforeHeaderText: "runBeforeHeaderText", duringRunHeaderText: "duringRunHeaderText", carrierText: "carrierText", isCarrierFilterEnabled: "isCarrierFilterEnabled", carrierOptions: "carrierOptions", isProviderEnabled: "isProviderEnabled", providerText: "providerText", providerInNetworkText: "providerInNetworkText", noProviderText: "noProviderText", pcpText: "pcpText", prescriptionLabel: "prescriptionLabel", noPrescriptionsText: "noPrescriptionsText", pcpFilterText: "pcpFilterText", downloadLinkText: "downloadLinkText", downloadIcon: "downloadIcon", downloadIconColor: "downloadIconColor", showDownloadResultsButton: "showDownloadResultsButton", isPcpFilterEnabled: "isPcpFilterEnabled", isPcpFilterChecked: "isPcpFilterChecked", filterModalCancelButtonText: "filterModalCancelButtonText", filterModalApplyButtonText: "filterModalApplyButtonText", beneficiaryErrorText: "beneficiaryErrorText", sortHeaderText: "sortHeaderText" }, outputs: { updateActiveTab: "updateActiveTab", runReport: "runReport", viewMember: "viewMember", selectedSortOption: "selectedSortOption" }, decls: 4, vars: 52, consts: [[1, "col-md-12"], [3, "tabList", "activeTab", "updateActiveTab"], [1, "col-md-12", "mt-2", "mt-md-4", "details-list"], [3, "activeTab", "introText", "buttonText", "reportInProgressText", "currentPlanSmartStatus", "planSmartReportData", "planSmartCurrentYearLabel", "planSmartNextYearLabel", "planSmartContinuedText", "showPlanLogo", "planSmartButtonText", "prescriptionsCoveredText", "totalEstimatedCostText", "lowCostPlanLabel", "estimatedSavingsText", "defaultSortOption", "sortOptions", "quoteSentText", "enrollmentSubmittedText", "pacificStandardTimeText", "filterHeaderText", "filterStateText", "filterClearAllText", "filterQuoteText", "filterEnrollmentApplicationsText", "noPlanSmartHeaderMessage", "noPlanSmartBodyMessage", "runBeforeHeaderText", "duringRunHeaderText", "carrierText", "isCarrierFilterEnabled", "carrierOptions", "isProviderEnabled", "providerText", "providerInNetworkText", "noProviderText", "pcpText", "prescriptionLabel", "noPrescriptionsText", "pcpFilterText", "downloadLinkText", "downloadIcon", "downloadIconColor", "showDownloadResultsButton", "isPcpFilterEnabled", "isPcpFilterChecked", "filterModalCancelButtonText", "filterModalApplyButtonText", "beneficiaryErrorText", "sortHeaderText", "runReport", "viewMember", "selectedSortOption"]], template: function PlanSmartTabComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "vnext-tab-list", 1);
        i0.ɵɵlistener("updateActiveTab", function PlanSmartTabComponent_Template_vnext_tab_list_updateActiveTab_1_listener($event) { return ctx.updateActiveTab.emit($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(2, "div", 2)(3, "vnext-widget-plan-smart-tab-content", 3);
        i0.ɵɵlistener("runReport", function PlanSmartTabComponent_Template_vnext_widget_plan_smart_tab_content_runReport_3_listener($event) { return ctx.runReport.emit($event); })("viewMember", function PlanSmartTabComponent_Template_vnext_widget_plan_smart_tab_content_viewMember_3_listener($event) { return ctx.viewMember.emit($event); })("selectedSortOption", function PlanSmartTabComponent_Template_vnext_widget_plan_smart_tab_content_selectedSortOption_3_listener($event) { return ctx.selectedSortOption.emit($event); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("tabList", ctx.tabList)("activeTab", ctx.activeTab);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("activeTab", ctx.activeTab)("introText", ctx.introText)("buttonText", ctx.buttonText)("reportInProgressText", ctx.reportInProgressText)("currentPlanSmartStatus", ctx.currentPlanSmartStatus)("planSmartReportData", ctx.planSmartReportData)("planSmartCurrentYearLabel", ctx.planSmartCurrentYearLabel)("planSmartNextYearLabel", ctx.planSmartNextYearLabel)("planSmartContinuedText", ctx.planSmartContinuedText)("showPlanLogo", ctx.showPlanLogo)("planSmartButtonText", ctx.planSmartButtonText)("prescriptionsCoveredText", ctx.prescriptionsCoveredText)("totalEstimatedCostText", ctx.totalEstimatedCostText)("lowCostPlanLabel", ctx.lowCostPlanLabel)("estimatedSavingsText", ctx.estimatedSavingsText)("defaultSortOption", ctx.defaultSortOption)("sortOptions", ctx.sortOptions)("quoteSentText", ctx.quoteSentText)("enrollmentSubmittedText", ctx.enrollmentSubmittedText)("pacificStandardTimeText", ctx.pacificStandardTimeText)("filterHeaderText", ctx.filterHeaderText)("filterStateText", ctx.filterStateText)("filterClearAllText", ctx.filterClearAllText)("filterQuoteText", ctx.filterQuoteText)("filterEnrollmentApplicationsText", ctx.filterEnrollmentApplicationsText)("noPlanSmartHeaderMessage", ctx.noPlanSmartHeaderMessage)("noPlanSmartBodyMessage", ctx.noPlanSmartBodyMessage)("runBeforeHeaderText", ctx.runBeforeHeaderText)("duringRunHeaderText", ctx.duringRunHeaderText)("carrierText", ctx.carrierText)("isCarrierFilterEnabled", ctx.isCarrierFilterEnabled)("carrierOptions", ctx.carrierOptions)("isProviderEnabled", ctx.isProviderEnabled)("providerText", ctx.providerText)("providerInNetworkText", ctx.providerInNetworkText)("noProviderText", ctx.noProviderText)("pcpText", ctx.pcpText)("prescriptionLabel", ctx.prescriptionLabel)("noPrescriptionsText", ctx.noPrescriptionsText)("pcpFilterText", ctx.pcpFilterText)("downloadLinkText", ctx.downloadLinkText)("downloadIcon", ctx.downloadIcon)("downloadIconColor", ctx.downloadIconColor)("showDownloadResultsButton", ctx.showDownloadResultsButton)("isPcpFilterEnabled", ctx.isPcpFilterEnabled)("isPcpFilterChecked", ctx.isPcpFilterChecked)("filterModalCancelButtonText", ctx.filterModalCancelButtonText)("filterModalApplyButtonText", ctx.filterModalApplyButtonText)("beneficiaryErrorText", ctx.beneficiaryErrorText)("sortHeaderText", ctx.sortHeaderText);
    } }, dependencies: [TabListComponent, PlanSmartTabContentComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanSmartTabComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-smart-tab', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"col-md-12\">\r\n  <vnext-tab-list [tabList]=\"tabList\" [activeTab]=\"activeTab\" (updateActiveTab)=\"updateActiveTab.emit($event)\"></vnext-tab-list>\r\n</div>\r\n<div class=\"col-md-12 mt-2 mt-md-4 details-list\">\r\n  <vnext-widget-plan-smart-tab-content\r\n    [activeTab]=\"activeTab\"\r\n    [introText]=\"introText\"\r\n    [buttonText]=\"buttonText\"\r\n    [reportInProgressText]=\"reportInProgressText\"\r\n    [currentPlanSmartStatus]=\"currentPlanSmartStatus\"\r\n    [planSmartReportData]=\"planSmartReportData\"\r\n    [planSmartCurrentYearLabel]=\"planSmartCurrentYearLabel\"\r\n    [planSmartNextYearLabel]=\"planSmartNextYearLabel\"\r\n    [planSmartContinuedText]=\"planSmartContinuedText\"\r\n    [showPlanLogo]=\"showPlanLogo\"\r\n    [planSmartButtonText]=\"planSmartButtonText\"\r\n    [prescriptionsCoveredText]=\"prescriptionsCoveredText\"\r\n    [totalEstimatedCostText]=\"totalEstimatedCostText\"\r\n    [lowCostPlanLabel]=\"lowCostPlanLabel\"\r\n    [estimatedSavingsText]=\"estimatedSavingsText\"\r\n    [defaultSortOption]=\"defaultSortOption\"\r\n    [sortOptions]=\"sortOptions\"\r\n    [quoteSentText]=\"quoteSentText\"\r\n    [enrollmentSubmittedText]=\"enrollmentSubmittedText\"\r\n    [pacificStandardTimeText]=\"pacificStandardTimeText\"\r\n    [filterHeaderText]=\"filterHeaderText\"\r\n    [filterStateText]=\"filterStateText\"\r\n    [filterClearAllText]=\"filterClearAllText\"\r\n    [filterQuoteText]=\"filterQuoteText\"\r\n    [filterEnrollmentApplicationsText]=\"filterEnrollmentApplicationsText\"\r\n    [noPlanSmartHeaderMessage]=\"noPlanSmartHeaderMessage\"\r\n    [noPlanSmartBodyMessage]=\"noPlanSmartBodyMessage\"\r\n    [runBeforeHeaderText]=\"runBeforeHeaderText\"\r\n    [duringRunHeaderText]=\"duringRunHeaderText\"\r\n    [carrierText]=\"carrierText\"\r\n    [isCarrierFilterEnabled]=\"isCarrierFilterEnabled\"\r\n    [carrierOptions]=\"carrierOptions\"\r\n    [isProviderEnabled]=\"isProviderEnabled\"\r\n    [providerText]=\"providerText\"\r\n    [providerInNetworkText]=\"providerInNetworkText\"\r\n    [noProviderText]=\"noProviderText\"\r\n    [pcpText]=\"pcpText\"\r\n    [prescriptionLabel]=\"prescriptionLabel\"\r\n    [noPrescriptionsText]=\"noPrescriptionsText\"\r\n    [pcpFilterText]=\"pcpFilterText\"\r\n    [downloadLinkText]=\"downloadLinkText\"\r\n    [downloadIcon]=\"downloadIcon\"\r\n    [downloadIconColor]=\"downloadIconColor\"\r\n    [showDownloadResultsButton]=\"showDownloadResultsButton\"\r\n    [isPcpFilterEnabled]=\"isPcpFilterEnabled\"\r\n    [isPcpFilterChecked]=\"isPcpFilterChecked\"\r\n    [filterModalCancelButtonText]=\"filterModalCancelButtonText\"\r\n    [filterModalApplyButtonText]=\"filterModalApplyButtonText\"\r\n    [beneficiaryErrorText]=\"beneficiaryErrorText\"\r\n    [sortHeaderText]=\"sortHeaderText\"\r\n    (runReport)=\"runReport.emit($event)\"\r\n    (viewMember)=\"viewMember.emit($event)\"\r\n    (selectedSortOption)=\"selectedSortOption.emit($event)\"\r\n  ></vnext-widget-plan-smart-tab-content>\r\n</div>\r\n" }]
    }], null, { introText: [{
            type: Input
        }], activeTab: [{
            type: Input
        }], buttonText: [{
            type: Input
        }], reportInProgressText: [{
            type: Input
        }], currentPlanSmartStatus: [{
            type: Input
        }], tabList: [{
            type: Input
        }], planSmartReportData: [{
            type: Input
        }], planSmartCurrentYearLabel: [{
            type: Input
        }], planSmartNextYearLabel: [{
            type: Input
        }], planSmartContinuedText: [{
            type: Input
        }], showPlanLogo: [{
            type: Input
        }], prescriptionsCoveredText: [{
            type: Input
        }], totalEstimatedCostText: [{
            type: Input
        }], lowCostPlanLabel: [{
            type: Input
        }], planSmartButtonText: [{
            type: Input
        }], estimatedSavingsText: [{
            type: Input
        }], defaultSortOption: [{
            type: Input
        }], sortOptions: [{
            type: Input
        }], quoteSentText: [{
            type: Input
        }], enrollmentSubmittedText: [{
            type: Input
        }], pacificStandardTimeText: [{
            type: Input
        }], filterHeaderText: [{
            type: Input
        }], filterStateText: [{
            type: Input
        }], filterClearAllText: [{
            type: Input
        }], filterQuoteText: [{
            type: Input
        }], filterEnrollmentApplicationsText: [{
            type: Input
        }], noPlanSmartHeaderMessage: [{
            type: Input
        }], noPlanSmartBodyMessage: [{
            type: Input
        }], runBeforeHeaderText: [{
            type: Input
        }], duringRunHeaderText: [{
            type: Input
        }], carrierText: [{
            type: Input
        }], isCarrierFilterEnabled: [{
            type: Input
        }], carrierOptions: [{
            type: Input
        }], isProviderEnabled: [{
            type: Input
        }], providerText: [{
            type: Input
        }], providerInNetworkText: [{
            type: Input
        }], noProviderText: [{
            type: Input
        }], pcpText: [{
            type: Input
        }], prescriptionLabel: [{
            type: Input
        }], noPrescriptionsText: [{
            type: Input
        }], pcpFilterText: [{
            type: Input
        }], downloadLinkText: [{
            type: Input
        }], downloadIcon: [{
            type: Input
        }], downloadIconColor: [{
            type: Input
        }], showDownloadResultsButton: [{
            type: Input
        }], isPcpFilterEnabled: [{
            type: Input
        }], isPcpFilterChecked: [{
            type: Input
        }], filterModalCancelButtonText: [{
            type: Input
        }], filterModalApplyButtonText: [{
            type: Input
        }], beneficiaryErrorText: [{
            type: Input
        }], sortHeaderText: [{
            type: Input
        }], updateActiveTab: [{
            type: Output
        }], runReport: [{
            type: Output
        }], viewMember: [{
            type: Output
        }], selectedSortOption: [{
            type: Output
        }] }); })();

function PlanSmartComponent_vnext_link_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 6);
    i0.ɵɵlistener("click", function PlanSmartComponent_vnext_link_3_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.backToPrevious()); })("keyup.enter", function PlanSmartComponent_vnext_link_3_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.backToPrevious()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r0.Spa_Site_Previous)("showArrow", "left");
} }
function PlanSmartComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.Spa_PlanSmart_Header_Text, " ");
} }
let PlanSmartComponent = class PlanSmartComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, navigationService, agentService, plansService, spinnerService, localeService, agentSearchFacade, profileFacade, planSmartFacade, orderPipe) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.navigationService = navigationService;
        this.agentService = agentService;
        this.plansService = plansService;
        this.spinnerService = spinnerService;
        this.localeService = localeService;
        this.agentSearchFacade = agentSearchFacade;
        this.profileFacade = profileFacade;
        this.planSmartFacade = planSmartFacade;
        this.orderPipe = orderPipe;
        this.Spa_PlanSmart_Header_Text = 'Plan Smart';
        this.Spa_Agent_Search_SortHeader_Text = 'Sort';
        this.Spa_Site_Previous = 'Previous';
        this.Spa_PlanSmart_PlanYear_Text = '2022';
        this.Spa_PlanSmart_DualPlanYear_Text = '2023';
        this.Spa_PlanSmart_Before_Run_Intro_Text = 'Please confirm that all of your beneficiary profiles for this upcoming AEP are ready before running this report. When you are ready, click “Run report” below. Please be aware that the PlanSmart report takes some time to run, you will be notified when the report is complete through the email address in your AccountOverview.';
        this.Spa_PlanSmart_Run_Button_Text = 'Run report';
        this.Spa_Site_PlanSmart_During_Run_Intro_Text = 'Your Plan Smart report is in progress. You will be notified when your Plan Smart results are ready through the email address defined in your Account Overview.';
        this.Spa_PlanSmart_CurrentPlan_Text = '<currentYearTabLabel> summary';
        this.Spa_Site_Show_PlanLogo = true;
        this.Spa_PlanSmart_PrescriptionCount_Text = '<prescriptionsCount> prescriptions';
        this.Spa_PlanSmart_NextPlan_Text = '<currentYearTabLabel> plan';
        this.Spa_PlanCard_TotalEstimatedAnnualCost_Text = 'Total est. annual cost';
        this.Spa_PlanSmart_PlanContinued_Text = '<currentYearTabLabel> plan continued';
        this.Spa_PlanSmart_Plans_Button_Text = 'View plans';
        this.Spa_PlanSmart_LowCostPlan_Text = 'Low cost plan';
        this.Spa_PlanSmart_EstimatedSavings_Text = 'Estimated Savings <estimatedSavings>';
        this.Spa_PlanSmart_Sort_Default = 'Estimated savings';
        this.Spa_MemberQuoteHistory_QuoteSentText = 'Quote sent';
        this.Spa_EnrollmentHistory_SubmittedDate_Text = 'Submitted';
        this.Spa_EnrollmentHistory_Pacific_StandardTime_Text = 'PST';
        this.Spa_Filter_Header_Text = 'Filters';
        this.Spa_PlanSmart_Filter_State_Text = 'State';
        this.Spa_Site_ClearAll_Text = 'Clear all';
        this.Spa_PlanSmart_Filter_QuoteHeader_Text = 'Quoting';
        this.Spa_PlanSmart_FilterEnrollmentSubmittedHeader_Text = 'Enrollment applications';
        this.Spa_PlanSmart_Tab_Header_NoResults = 'No results';
        this.Spa_PlanSmart_Tab_Body_NoResults = 'Please remove some or clear all filters and try again.';
        this.Spa_Site_PlanSmart_During_Run_Header_Text = 'Loading report';
        this.Spa_Site_PlanSmart_Before_Run_Header_Text = 'Run a report';
        this.Spa_PlanSmart_Filter_CarrierHeader_Text = 'Carrier';
        this.Spa_PlanSmart_CarrierFilter_Enabled = true;
        this.Spa_Site_Providers_Enabled = true;
        this.Spa_Site_Providers_Text = 'Providers';
        this.Spa_PlanCard_Providers_InNetwork_Text = '<inNetwork> of <totalProviders> In-network';
        this.Spa_Plansmart_NoProviders_Text = 'No providers';
        this.Spa_Site_Pcp_Text = 'PCP';
        this.Spa_Site_Prescriptions_Text = 'Prescriptions';
        this.Spa_PlanCard_Drug_Covered_Text = '<coveredDrugCount> of <totalDrugCount> covered';
        this.Spa_Plansmart_NoPrescriptions_Text = 'No prescriptions';
        this.Spa_Site_DownloadLink_Text = 'Download results';
        this.Spa_Site_Download_Icon = 'fas fa-download';
        this.Spa_Style_Primary_Link = '#016C86';
        this.Spa_Plansmart_Download_Enabled = true;
        this.Spa_PlanSmart_Filter_PCPHeader_Text = 'Primary care provider';
        this.Spa_PlanSmart_Filter_PCP_Enabled = true;
        this.Spa_PlanSmart_Filter_PCP_Checked = false;
        this.Spa_PlanFilters_Modal_Cancel_Button = 'Cancel';
        this.Spa_PlanFilters_Modal_Apply_Button = 'Apply';
        this.Spa_Plansmart_BeneficiaryError_Text = 'Information is not available for this beneficiary, please contact your administrator for details.';
        this.planSmartTabList = [];
        this.subscriptions = [];
        this.agentGuid = '';
        this.mappedPlanSmartData = [];
        this.carrierOptions = [];
        this.viewMemberSubject$ = new Subject();
    }
    preProcessProperties() {
        this.planSmartTabList = [
            {
                title: this.Spa_PlanSmart_PlanYear_Text,
                isActive: true
            },
            {
                title: this.Spa_PlanSmart_DualPlanYear_Text,
                isActive: false
            }
        ];
        this.activeTab = this.planSmartTabList[0];
        this.sortOptions = this.planSmartFacade.getSortOptions();
    }
    ngOnInit() {
        super.ngOnInit();
        this.agentGuid = this.agentService.getAgentInContextGuid();
        const planYearList = this.planSmartTabList.map(planYear => planYear.title);
        this.subscriptions.push(this.planSmartFacade.planSmartLoading$().subscribe({
            next: loading => {
                loading ? this.spinnerService.show(SpinnerEvent.PLAN_SMART_LOADING) : this.spinnerService.hide(SpinnerEvent.PLAN_SMART_LOADING);
            },
            error: () => {
                this.spinnerService.hide(SpinnerEvent.PLAN_SMART_LOADING);
            }
        }));
        if (this.activeTab?.title) {
            this.planSmartFacade.initializePlanSmartFilterGroups(planYearList);
            this.initiatePlanSmart();
            this.subscriptions.push(this.plansService.getPlanSmartReports$().subscribe({
                next: reportData => {
                    this.updatePlanSmartDataAndSort(this.activeTab.title);
                    if (reportData?.[this.activeTab.title]?.data?.length) {
                        this.updateFilters(this.mappedPlanSmartData);
                    }
                    this.cdr.markForCheck();
                }
            }));
            this.subscriptions.push(this.localeService.getCurrentLocale$().subscribe(() => {
                this.initiatePlanSmartLabel();
                this.cdr.markForCheck();
            }));
            this.subscriptions.push(this.planSmartFacade.getPlanSmartFilterGroup$().subscribe(() => {
                this.updatePlanSmartDataAndSort(this.activeTab.title);
                this.cdr.markForCheck();
            }));
            this.subscriptions.push(this.onViewMember$().subscribe(() => {
                this.handleOnViewMember();
            }));
        }
    }
    initiatePlanSmart() {
        this.initiatePlanSmartLabel();
        const planSmartReportData = this.plansService.getPlanSmartReportData(this.activeTab.title);
        if (!planSmartReportData.length) {
            this.plansService
                .fetchPlanSmartStatus$(this.agentGuid, this.activeTab.title)
                .pipe(take(1))
                .subscribe((planSmartStatus) => {
                this.currentPlanSmartStatus = planSmartStatus;
                if (planSmartStatus === PlanSmartStatus.COMPLETED) {
                    this.plansService.fetchPlanSmartReports(this.agentGuid, this.activeTab.title);
                }
                this.cdr.markForCheck();
            });
        }
        else {
            this.updatePlanSmartDataAndSort(this.activeTab.title);
            this.updateFilters(planSmartReportData);
            this.currentPlanSmartStatus = PlanSmartStatus.COMPLETED;
            this.cdr.markForCheck();
        }
    }
    runReport(activeTab) {
        this.subscriptions.push(this.plansService.initiatePlanSmart$(this.agentGuid, activeTab.title).subscribe(() => {
            this.currentPlanSmartStatus = PlanSmartStatus.IN_PROGRESS;
            this.cdr.markForCheck();
        }));
        this.planSmartTabList.forEach(tab => {
            if (tab.title === activeTab.title) {
                tab.isActive = true;
            }
        });
        this.cdr.markForCheck();
    }
    updateSort(sortOption) {
        if (sortOption.value && sortOption.value === PlanSmartSortFields.TOTAL_ESTIMATE) {
            this.mappedPlanSmartData = this.planSmartFacade.getSortByPlanSavings(this.mappedPlanSmartData);
        }
        else {
            this.mappedPlanSmartData = this.orderPipe.transform(this.mappedPlanSmartData, [sortOption.value, this.getDefaultSort().value], null, true);
        }
        this.cdr.detectChanges();
    }
    backToPrevious() {
        this.navigationService.backToPrevious();
    }
    updateActiveTab(activeTab) {
        if (this.activeTab?.title !== activeTab?.title) {
            this.activeTab = activeTab;
            this.initiatePlanSmart();
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
        this.plansService.resetPlanSmart();
    }
    viewMember(member) {
        this.viewMemberSubject$.next(member);
    }
    updatePlanSmartDataAndSort(planYear) {
        const filteredData = this.planSmartFacade.getFilteredPlanSmartReportData(planYear);
        this.mappedPlanSmartData = this.getMappedPlanSmartData(filteredData);
        const defaultSortOptions = this.planSmartFacade.getPlanSmartSort();
        this.defaultSortOption = defaultSortOptions?.[this.activeTab.title] || this.getDefaultSort();
        this.updateSort(this.defaultSortOption);
    }
    getMappedPlanSmartData(planSmartReportData) {
        return planSmartReportData.map(reportDetail => {
            const newReportDetail = { ...reportDetail };
            const planSmartResults = newReportDetail?.planSmartResults || [];
            if (planSmartResults.length && newReportDetail?.memberRequest) {
                const nextPlanYearReport = planSmartResults.find(report => report.isNextYearPlan);
                const lowestPlanYearReport = planSmartResults.find(report => report.isLowestCostPlan);
                newReportDetail.memberRequest = {
                    ...newReportDetail.memberRequest,
                    isNextYearPlan: nextPlanYearReport?.isNextYearPlan ?? false,
                    isLowestCostPlan: lowestPlanYearReport?.isLowestCostPlan ?? false,
                    isEstimatedSavingTextEnabled: nextPlanYearReport?.planId !== lowestPlanYearReport?.planId || false,
                    planSavings: lowestPlanYearReport?.planSavings ?? 0
                };
            }
            return newReportDetail;
        });
    }
    updateFilters(mappedPlanSmartData) {
        this.carrierOptions = this.getCarriersOptions(mappedPlanSmartData);
    }
    getCarriersOptions(planSmartReportData) {
        const carrierOptions = [];
        planSmartReportData?.forEach(report => {
            report?.planSmartResults?.forEach(result => {
                if (result.isCurrentYearPlan && !carrierOptions.some(carrier => carrier.label === result.carrierName)) {
                    carrierOptions.push({
                        label: result.carrierName,
                        value: result.carrierName,
                        disabled: false,
                        initiallyChecked: false,
                        link: null
                    });
                }
            });
        });
        return carrierOptions.sort((a, b) => a.label.localeCompare(b.label));
    }
    initiatePlanSmartLabel() {
        this.planSmartCurrentYearLabel = this.Spa_PlanSmart_CurrentPlan_Text.replace('<currentYearTabLabel>', this.activeTab?.title);
        this.planSmartNextYearLabel = this.Spa_PlanSmart_NextPlan_Text.replace('<currentYearTabLabel>', (parseInt(this.activeTab?.title, 10) + 1).toString());
        this.planSmartContinuedText = this.Spa_PlanSmart_PlanContinued_Text.replace('<currentYearTabLabel>', this.activeTab?.title);
    }
    handleOnViewMember() {
        this.agentSearchFacade.navigateByPageTag(PageTags.ADD_NEW_PROFILE);
        this.profileFacade.beneficiarySearchNavigationClicked(true);
    }
    onViewMember$() {
        return this.viewMemberSubject$.pipe(exhaustMap((memberID) => this.agentSearchFacade.selectMember$(memberID)));
    }
    getDefaultSort() {
        return this.sortOptions?.find(sortOption => sortOption.label === this.Spa_PlanSmart_Sort_Default) || this.sortOptions[0];
    }
};
PlanSmartComponent.ɵfac = function PlanSmartComponent_Factory(t) { return new (t || PlanSmartComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(AgentSearchFacade), i0.ɵɵdirectiveInject(ProfileFacade), i0.ɵɵdirectiveInject(PlanSmartFacade), i0.ɵɵdirectiveInject(OrderPipe)); };
PlanSmartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanSmartComponent, selectors: [["vnext-widget-plan-smart"]], features: [i0.ɵɵProvidersFeature([WidgetService, OrderPipe, InputResetContextService]), i0.ɵɵInheritDefinitionFeature], decls: 6, vars: 53, consts: [[1, "container"], [1, "col-12", "c-mt-30", "c-mb-30"], [1, "col-auto", "mx-auto", "text-center"], [3, "title", "showArrow", "click", "keyup.enter", 4, "liveEditProp"], ["class", "Spa_Style_H1 c-mt-30 c-mb-30 text-center", 4, "liveEditProp"], [3, "tabList", "activeTab", "introText", "reportInProgressText", "buttonText", "currentPlanSmartStatus", "planSmartReportData", "planSmartCurrentYearLabel", "planSmartNextYearLabel", "planSmartContinuedText", "showPlanLogo", "prescriptionsCoveredText", "noPrescriptionsText", "totalEstimatedCostText", "lowCostPlanLabel", "planSmartButtonText", "estimatedSavingsText", "defaultSortOption", "sortOptions", "quoteSentText", "enrollmentSubmittedText", "pacificStandardTimeText", "filterHeaderText", "filterStateText", "filterClearAllText", "filterQuoteText", "filterEnrollmentApplicationsText", "noPlanSmartHeaderMessage", "noPlanSmartBodyMessage", "runBeforeHeaderText", "duringRunHeaderText", "carrierText", "isCarrierFilterEnabled", "carrierOptions", "isProviderEnabled", "providerText", "providerInNetworkText", "noProviderText", "pcpText", "prescriptionLabel", "pcpFilterText", "downloadLinkText", "downloadIcon", "downloadIconColor", "showDownloadResultsButton", "isPcpFilterEnabled", "isPcpFilterChecked", "filterModalCancelButtonText", "filterModalApplyButtonText", "beneficiaryErrorText", "sortHeaderText", "updateActiveTab", "runReport", "viewMember", "selectedSortOption"], [3, "title", "showArrow", "click", "keyup.enter"], [1, "Spa_Style_H1", "c-mt-30", "c-mb-30", "text-center"]], template: function PlanSmartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, PlanSmartComponent_vnext_link_3_Template, 1, 2, "vnext-link", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, PlanSmartComponent_div_4_Template, 2, 1, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "vnext-widget-plan-smart-tab", 5);
        i0.ɵɵlistener("updateActiveTab", function PlanSmartComponent_Template_vnext_widget_plan_smart_tab_updateActiveTab_5_listener($event) { return ctx.updateActiveTab($event); })("runReport", function PlanSmartComponent_Template_vnext_widget_plan_smart_tab_runReport_5_listener($event) { return ctx.runReport($event); })("viewMember", function PlanSmartComponent_Template_vnext_widget_plan_smart_tab_viewMember_5_listener($event) { return ctx.viewMember($event); })("selectedSortOption", function PlanSmartComponent_Template_vnext_widget_plan_smart_tab_selectedSortOption_5_listener($event) { return ctx.updateSort($event); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_Previous");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_PlanSmart_Header_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("tabList", ctx.planSmartTabList)("activeTab", ctx.activeTab)("introText", ctx.Spa_PlanSmart_Before_Run_Intro_Text)("reportInProgressText", ctx.Spa_Site_PlanSmart_During_Run_Intro_Text)("buttonText", ctx.Spa_PlanSmart_Run_Button_Text)("currentPlanSmartStatus", ctx.currentPlanSmartStatus)("planSmartReportData", ctx.mappedPlanSmartData)("planSmartCurrentYearLabel", ctx.planSmartCurrentYearLabel)("planSmartNextYearLabel", ctx.planSmartNextYearLabel)("planSmartContinuedText", ctx.planSmartContinuedText)("showPlanLogo", ctx.Spa_Site_Show_PlanLogo)("prescriptionsCoveredText", ctx.Spa_PlanCard_Drug_Covered_Text)("noPrescriptionsText", ctx.Spa_Plansmart_NoPrescriptions_Text)("totalEstimatedCostText", ctx.Spa_PlanCard_TotalEstimatedAnnualCost_Text)("lowCostPlanLabel", ctx.Spa_PlanSmart_LowCostPlan_Text)("planSmartButtonText", ctx.Spa_PlanSmart_Plans_Button_Text)("estimatedSavingsText", ctx.Spa_PlanSmart_EstimatedSavings_Text)("defaultSortOption", ctx.defaultSortOption)("sortOptions", ctx.sortOptions)("quoteSentText", ctx.Spa_MemberQuoteHistory_QuoteSentText)("enrollmentSubmittedText", ctx.Spa_EnrollmentHistory_SubmittedDate_Text)("pacificStandardTimeText", ctx.Spa_EnrollmentHistory_Pacific_StandardTime_Text)("filterHeaderText", ctx.Spa_Filter_Header_Text)("filterStateText", ctx.Spa_PlanSmart_Filter_State_Text)("filterClearAllText", ctx.Spa_Site_ClearAll_Text)("filterQuoteText", ctx.Spa_PlanSmart_Filter_QuoteHeader_Text)("filterEnrollmentApplicationsText", ctx.Spa_PlanSmart_FilterEnrollmentSubmittedHeader_Text)("noPlanSmartHeaderMessage", ctx.Spa_PlanSmart_Tab_Header_NoResults)("noPlanSmartBodyMessage", ctx.Spa_PlanSmart_Tab_Body_NoResults)("runBeforeHeaderText", ctx.Spa_Site_PlanSmart_Before_Run_Header_Text)("duringRunHeaderText", ctx.Spa_Site_PlanSmart_During_Run_Header_Text)("carrierText", ctx.Spa_PlanSmart_Filter_CarrierHeader_Text)("isCarrierFilterEnabled", ctx.Spa_PlanSmart_CarrierFilter_Enabled)("carrierOptions", ctx.carrierOptions)("isProviderEnabled", ctx.Spa_Site_Providers_Enabled)("providerText", ctx.Spa_Site_Providers_Text)("providerInNetworkText", ctx.Spa_PlanCard_Providers_InNetwork_Text)("noProviderText", ctx.Spa_Plansmart_NoProviders_Text)("pcpText", ctx.Spa_Site_Pcp_Text)("prescriptionLabel", ctx.Spa_Site_Prescriptions_Text)("pcpFilterText", ctx.Spa_PlanSmart_Filter_PCPHeader_Text)("downloadLinkText", ctx.Spa_Site_DownloadLink_Text)("downloadIcon", ctx.Spa_Site_Download_Icon)("downloadIconColor", ctx.Spa_Style_Primary_Link)("showDownloadResultsButton", ctx.Spa_Plansmart_Download_Enabled)("isPcpFilterEnabled", ctx.Spa_PlanSmart_Filter_PCP_Enabled)("isPcpFilterChecked", ctx.Spa_PlanSmart_Filter_PCP_Checked)("filterModalCancelButtonText", ctx.Spa_PlanFilters_Modal_Cancel_Button)("filterModalApplyButtonText", ctx.Spa_PlanFilters_Modal_Apply_Button)("beneficiaryErrorText", ctx.Spa_Plansmart_BeneficiaryError_Text)("sortHeaderText", ctx.Spa_Agent_Search_SortHeader_Text);
    } }, dependencies: [LinkComponent, LiveEditPropDirective, PlanSmartTabComponent], encapsulation: 2, changeDetection: 0 });
__decorate([
    PlatformProp('live-edit')
], PlanSmartComponent.prototype, "Spa_PlanSmart_Header_Text", void 0);
__decorate([
    PlatformProp()
], PlanSmartComponent.prototype, "Spa_Agent_Search_SortHeader_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_Site_Previous", void 0);
__decorate([
    GlobalResource(true)
], PlanSmartComponent.prototype, "Spa_PlanSmart_PlanYear_Text", void 0);
__decorate([
    GlobalResource(true)
], PlanSmartComponent.prototype, "Spa_PlanSmart_DualPlanYear_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanSmart_Before_Run_Intro_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanSmart_Run_Button_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_Site_PlanSmart_During_Run_Intro_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanSmart_CurrentPlan_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_Site_Show_PlanLogo", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanSmart_PrescriptionCount_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanSmart_NextPlan_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanCard_TotalEstimatedAnnualCost_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanSmart_PlanContinued_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanSmart_Plans_Button_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanSmart_LowCostPlan_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanSmart_EstimatedSavings_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanSmart_Sort_Default", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_MemberQuoteHistory_QuoteSentText", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_EnrollmentHistory_SubmittedDate_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_EnrollmentHistory_Pacific_StandardTime_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_Filter_Header_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanSmart_Filter_State_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_Site_ClearAll_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanSmart_Filter_QuoteHeader_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanSmart_FilterEnrollmentSubmittedHeader_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanSmart_Tab_Header_NoResults", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanSmart_Tab_Body_NoResults", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_Site_PlanSmart_During_Run_Header_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_Site_PlanSmart_Before_Run_Header_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanSmart_Filter_CarrierHeader_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanSmart_CarrierFilter_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_Site_Providers_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_Site_Providers_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanCard_Providers_InNetwork_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_Plansmart_NoProviders_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_Site_Pcp_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_Site_Prescriptions_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanCard_Drug_Covered_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_Plansmart_NoPrescriptions_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_Site_DownloadLink_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_Site_Download_Icon", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_Style_Primary_Link", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_Plansmart_Download_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanSmart_Filter_PCPHeader_Text", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanSmart_Filter_PCP_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanSmart_Filter_PCP_Checked", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanFilters_Modal_Cancel_Button", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_PlanFilters_Modal_Apply_Button", void 0);
__decorate([
    GlobalResource()
], PlanSmartComponent.prototype, "Spa_Plansmart_BeneficiaryError_Text", void 0);
PlanSmartComponent = __decorate([
    PlatformWidget
], PlanSmartComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanSmartComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-smart', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService, OrderPipe, InputResetContextService], template: "<div class=\"container\">\r\n  <div class=\"col-12 c-mt-30 c-mb-30\">\r\n    <div class=\"col-auto mx-auto text-center\">\r\n      <vnext-link\r\n        [title]=\"Spa_Site_Previous\"\r\n        [showArrow]=\"'left'\"\r\n        (click)=\"backToPrevious()\"\r\n        (keyup.enter)=\"backToPrevious()\"\r\n        *liveEditProp=\"'Spa_Site_Previous'\"\r\n      >\r\n      </vnext-link>\r\n    </div>\r\n    <div class=\"Spa_Style_H1 c-mt-30 c-mb-30 text-center\" *liveEditProp=\"'Spa_PlanSmart_Header_Text'\">\r\n      {{ Spa_PlanSmart_Header_Text }}\r\n    </div>\r\n  </div>\r\n\r\n  <vnext-widget-plan-smart-tab\r\n    [tabList]=\"planSmartTabList\"\r\n    [activeTab]=\"activeTab\"\r\n    [introText]=\"Spa_PlanSmart_Before_Run_Intro_Text\"\r\n    [reportInProgressText]=\"Spa_Site_PlanSmart_During_Run_Intro_Text\"\r\n    [buttonText]=\"Spa_PlanSmart_Run_Button_Text\"\r\n    [currentPlanSmartStatus]=\"currentPlanSmartStatus\"\r\n    [planSmartReportData]=\"mappedPlanSmartData\"\r\n    [planSmartCurrentYearLabel]=\"planSmartCurrentYearLabel\"\r\n    [planSmartNextYearLabel]=\"planSmartNextYearLabel\"\r\n    [planSmartContinuedText]=\"planSmartContinuedText\"\r\n    [showPlanLogo]=\"Spa_Site_Show_PlanLogo\"\r\n    [prescriptionsCoveredText]=\"Spa_PlanCard_Drug_Covered_Text\"\r\n    [noPrescriptionsText]=\"Spa_Plansmart_NoPrescriptions_Text\"\r\n    [totalEstimatedCostText]=\"Spa_PlanCard_TotalEstimatedAnnualCost_Text\"\r\n    [lowCostPlanLabel]=\"Spa_PlanSmart_LowCostPlan_Text\"\r\n    [planSmartButtonText]=\"Spa_PlanSmart_Plans_Button_Text\"\r\n    [estimatedSavingsText]=\"Spa_PlanSmart_EstimatedSavings_Text\"\r\n    [defaultSortOption]=\"defaultSortOption\"\r\n    [sortOptions]=\"sortOptions\"\r\n    [quoteSentText]=\"Spa_MemberQuoteHistory_QuoteSentText\"\r\n    [enrollmentSubmittedText]=\"Spa_EnrollmentHistory_SubmittedDate_Text\"\r\n    [pacificStandardTimeText]=\"Spa_EnrollmentHistory_Pacific_StandardTime_Text\"\r\n    [filterHeaderText]=\"Spa_Filter_Header_Text\"\r\n    [filterStateText]=\"Spa_PlanSmart_Filter_State_Text\"\r\n    [filterClearAllText]=\"Spa_Site_ClearAll_Text\"\r\n    [filterQuoteText]=\"Spa_PlanSmart_Filter_QuoteHeader_Text\"\r\n    [filterEnrollmentApplicationsText]=\"Spa_PlanSmart_FilterEnrollmentSubmittedHeader_Text\"\r\n    [noPlanSmartHeaderMessage]=\"Spa_PlanSmart_Tab_Header_NoResults\"\r\n    [noPlanSmartBodyMessage]=\"Spa_PlanSmart_Tab_Body_NoResults\"\r\n    [runBeforeHeaderText]=\"Spa_Site_PlanSmart_Before_Run_Header_Text\"\r\n    [duringRunHeaderText]=\"Spa_Site_PlanSmart_During_Run_Header_Text\"\r\n    [carrierText]=\"Spa_PlanSmart_Filter_CarrierHeader_Text\"\r\n    [isCarrierFilterEnabled]=\"Spa_PlanSmart_CarrierFilter_Enabled\"\r\n    [carrierOptions]=\"carrierOptions\"\r\n    [isProviderEnabled]=\"Spa_Site_Providers_Enabled\"\r\n    [providerText]=\"Spa_Site_Providers_Text\"\r\n    [providerInNetworkText]=\"Spa_PlanCard_Providers_InNetwork_Text\"\r\n    [noProviderText]=\"Spa_Plansmart_NoProviders_Text\"\r\n    [pcpText]=\"Spa_Site_Pcp_Text\"\r\n    [prescriptionLabel]=\"Spa_Site_Prescriptions_Text\"\r\n    [pcpFilterText]=\"Spa_PlanSmart_Filter_PCPHeader_Text\"\r\n    [downloadLinkText]=\"Spa_Site_DownloadLink_Text\"\r\n    [downloadIcon]=\"Spa_Site_Download_Icon\"\r\n    [downloadIconColor]=\"Spa_Style_Primary_Link\"\r\n    [showDownloadResultsButton]=\"Spa_Plansmart_Download_Enabled\"\r\n    [isPcpFilterEnabled]=\"Spa_PlanSmart_Filter_PCP_Enabled\"\r\n    [isPcpFilterChecked]=\"Spa_PlanSmart_Filter_PCP_Checked\"\r\n    [filterModalCancelButtonText]=\"Spa_PlanFilters_Modal_Cancel_Button\"\r\n    [filterModalApplyButtonText]=\"Spa_PlanFilters_Modal_Apply_Button\"\r\n    [beneficiaryErrorText]=\"Spa_Plansmart_BeneficiaryError_Text\"\r\n    [sortHeaderText]=\"Spa_Agent_Search_SortHeader_Text\"\r\n    (updateActiveTab)=\"updateActiveTab($event)\"\r\n    (runReport)=\"runReport($event)\"\r\n    (viewMember)=\"viewMember($event)\"\r\n    (selectedSortOption)=\"updateSort($event)\"\r\n  ></vnext-widget-plan-smart-tab>\r\n</div>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.NavigationService }, { type: i1.AgentService }, { type: i1.PlansService }, { type: i1.SpinnerService }, { type: i1.LocaleService }, { type: AgentSearchFacade }, { type: ProfileFacade }, { type: PlanSmartFacade }, { type: OrderPipe }]; }, { Spa_PlanSmart_Header_Text: [], Spa_Agent_Search_SortHeader_Text: [], Spa_Site_Previous: [], Spa_PlanSmart_PlanYear_Text: [], Spa_PlanSmart_DualPlanYear_Text: [], Spa_PlanSmart_Before_Run_Intro_Text: [], Spa_PlanSmart_Run_Button_Text: [], Spa_Site_PlanSmart_During_Run_Intro_Text: [], Spa_PlanSmart_CurrentPlan_Text: [], Spa_Site_Show_PlanLogo: [], Spa_PlanSmart_PrescriptionCount_Text: [], Spa_PlanSmart_NextPlan_Text: [], Spa_PlanCard_TotalEstimatedAnnualCost_Text: [], Spa_PlanSmart_PlanContinued_Text: [], Spa_PlanSmart_Plans_Button_Text: [], Spa_PlanSmart_LowCostPlan_Text: [], Spa_PlanSmart_EstimatedSavings_Text: [], Spa_PlanSmart_Sort_Default: [], Spa_MemberQuoteHistory_QuoteSentText: [], Spa_EnrollmentHistory_SubmittedDate_Text: [], Spa_EnrollmentHistory_Pacific_StandardTime_Text: [], Spa_Filter_Header_Text: [], Spa_PlanSmart_Filter_State_Text: [], Spa_Site_ClearAll_Text: [], Spa_PlanSmart_Filter_QuoteHeader_Text: [], Spa_PlanSmart_FilterEnrollmentSubmittedHeader_Text: [], Spa_PlanSmart_Tab_Header_NoResults: [], Spa_PlanSmart_Tab_Body_NoResults: [], Spa_Site_PlanSmart_During_Run_Header_Text: [], Spa_Site_PlanSmart_Before_Run_Header_Text: [], Spa_PlanSmart_Filter_CarrierHeader_Text: [], Spa_PlanSmart_CarrierFilter_Enabled: [], Spa_Site_Providers_Enabled: [], Spa_Site_Providers_Text: [], Spa_PlanCard_Providers_InNetwork_Text: [], Spa_Plansmart_NoProviders_Text: [], Spa_Site_Pcp_Text: [], Spa_Site_Prescriptions_Text: [], Spa_PlanCard_Drug_Covered_Text: [], Spa_Plansmart_NoPrescriptions_Text: [], Spa_Site_DownloadLink_Text: [], Spa_Site_Download_Icon: [], Spa_Style_Primary_Link: [], Spa_Plansmart_Download_Enabled: [], Spa_PlanSmart_Filter_PCPHeader_Text: [], Spa_PlanSmart_Filter_PCP_Enabled: [], Spa_PlanSmart_Filter_PCP_Checked: [], Spa_PlanFilters_Modal_Cancel_Button: [], Spa_PlanFilters_Modal_Apply_Button: [], Spa_Plansmart_BeneficiaryError_Text: [] }); })();

function DrugSearchModalComponent_ng_container_2_div_1_h1_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r9.prescriptionsText);
} }
function DrugSearchModalComponent_ng_container_2_div_1_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 19);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r10.drugSearchIntroText, "html"), i0.ɵɵsanitizeHtml);
} }
function DrugSearchModalComponent_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵtemplate(2, DrugSearchModalComponent_ng_container_2_div_1_h1_2_Template, 2, 1, "h1", 16);
    i0.ɵɵtemplate(3, DrugSearchModalComponent_ng_container_2_div_1_p_3_Template, 2, 4, "p", 17);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_Prescriptions_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_DrugSearch_Intro_Text");
} }
function DrugSearchModalComponent_ng_container_2_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "ngb-highlight", 21);
} if (rf & 2) {
    const r_r11 = ctx.result;
    const t_r12 = ctx.term;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r5.drugSearchText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("result", r_r11.drugName)("term", t_r12);
} }
function DrugSearchModalComponent_ng_container_2_input_8_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 22, 23);
    i0.ɵɵlistener("ngModelChange", function DrugSearchModalComponent_ng_container_2_input_8_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r15.searchTerm = $event); })("selectItem", function DrugSearchModalComponent_ng_container_2_input_8_Template_input_selectItem_0_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.selectItem($event)); })("click", function DrugSearchModalComponent_ng_container_2_input_8_Template_input_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r18 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r18.clearSearchTerm()); })("keyup", function DrugSearchModalComponent_ng_container_2_input_8_Template_input_keyup_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r19 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r19.scrollItemIntoView()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(5);
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("placeholder", ctx_r6.placeholder)("ngbTypeahead", ctx_r6.suggestedDrugs)("resultTemplate", _r4)("inputFormatter", ctx_r6.drugAutocompleteformatter)("popupClass", ctx_r6.noTranslateBlockClass)("ngModel", ctx_r6.searchTerm);
    i0.ɵɵattribute("aria-label", ctx_r6.drugSearchPageHeaderText);
} }
function DrugSearchModalComponent_ng_container_2_vnext_blue_button_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-blue-button", 24);
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("startAddingDrugText", ctx_r7.blueButtonStartAddingDrugText)("orText", ctx_r7.orText)("connectToMyMedicareText", ctx_r7.blueButtonConnectToMyMedicareText)("myMedicareButtonText", ctx_r7.blueButtonMyMedicareButtonText)("emailLabelText", ctx_r7.emailLabelText)("emailRequiredErrorText", ctx_r7.emailRequiredErrorText)("emailInvalidErrorText", ctx_r7.emailInvalidErrorText)("sendEmailButtonText", ctx_r7.sendEmailButtonText)("blueButtonModalHeaderText", ctx_r7.blueButtonModalHeaderText)("blueButtonModalContent", ctx_r7.blueButtonModalContent)("blueButtonSuccessText", ctx_r7.blueButtonSuccessText)("blueButtonDownloadText", ctx_r7.blueButtonDownloadText)("blueButtonSuccessMessage", ctx_r7.blueButtonSuccessMessage)("blueButtonEmailSendText", ctx_r7.blueButtonEmailSendText)("blueButtonIssueLoadingText", ctx_r7.blueButtonIssueLoadingText)("blueButtonBeneficiaryDeniedText", ctx_r7.blueButtonBeneficiaryDeniedText)("blueButtonErrorLoadingText", ctx_r7.blueButtonErrorLoadingText)("blueButtonBeneficiaryEmailDetails", ctx_r7.blueButtonBeneficiaryEmailDetails)("blueButtonImportLatestPrescriptionButtonText", ctx_r7.blueButtonImportLatestPrescriptionButtonText)("blueButtonImportLatestPrescriptionErrorText", ctx_r7.blueButtonImportLatestPrescriptionErrorText)("blueButtonAccessDeniedText", ctx_r7.blueButtonAccessDeniedText)("blueButtonClaimDataLoadingErrorText", ctx_r7.blueButtonClaimDataLoadingErrorText)("isPreferenceBannerEnabled", true);
} }
function DrugSearchModalComponent_ng_container_2_vnext_medicine_cabinet_modal_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-medicine-cabinet-modal", 25);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("medCabinetHeader", ctx_r8.medCabinetHeader)("showGenericOption", ctx_r8.showGenericOption);
} }
function DrugSearchModalComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DrugSearchModalComponent_ng_container_2_div_1_Template, 4, 2, "div", 4);
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵelement(3, "i", 6);
    i0.ɵɵtemplate(4, DrugSearchModalComponent_ng_container_2_ng_template_4_Template, 3, 3, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(6, "label", 8);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, DrugSearchModalComponent_ng_container_2_input_8_Template, 3, 7, "input", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 10);
    i0.ɵɵelement(10, "vnext-selectrx-section");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 11);
    i0.ɵɵtemplate(12, DrugSearchModalComponent_ng_container_2_vnext_blue_button_12_Template, 1, 23, "vnext-blue-button", 12);
    i0.ɵɵtemplate(13, DrugSearchModalComponent_ng_container_2_vnext_medicine_cabinet_modal_13_Template, 1, 2, "vnext-medicine-cabinet-modal", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.helpfulTools);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.drugSearchInputLabelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_DrugSearch_Hint_Text");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r0.helpfulTools && ctx_r0.isBlueButtonEnabled && ctx_r0.isMemberSessionUpdated);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.helpfulTools && (!ctx_r0.isBlueButtonEnabled || ctx_r0.isMemberSessionUpdated));
} }
function DrugSearchModalComponent_ng_template_3_vnext_drug_details_6_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-drug-details", 29);
    i0.ɵɵlistener("updateFrequency", function DrugSearchModalComponent_ng_template_3_vnext_drug_details_6_Template_vnext_drug_details_updateFrequency_0_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r21.updateFrequency($event)); })("updateIsQuantityValid", function DrugSearchModalComponent_ng_template_3_vnext_drug_details_6_Template_vnext_drug_details_updateIsQuantityValid_0_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r23 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r23.updateIsQuantityValid($event)); })("updateActiveGenericOption", function DrugSearchModalComponent_ng_template_3_vnext_drug_details_6_Template_vnext_drug_details_updateActiveGenericOption_0_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r24 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r24.updateActiveGenericOption($event)); })("removeSelectedDrug", function DrugSearchModalComponent_ng_template_3_vnext_drug_details_6_Template_vnext_drug_details_removeSelectedDrug_0_listener() { i0.ɵɵrestoreView(_r22); const ctx_r25 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r25.removeSelectedDrug()); })("viewPossibleAlternativeDrugs", function DrugSearchModalComponent_ng_template_3_vnext_drug_details_6_Template_vnext_drug_details_viewPossibleAlternativeDrugs_0_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r26 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r26.onViewPossibleAlternativeDrugs($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("isEditing", ctx_r20.isEditing)("drugName", ctx_r20.drugName)("drugDetails", ctx_r20.drugDetails)("selectedDosage", ctx_r20.drugDetails.commonDosage)("frequencyList", ctx_r20.frequencyList)("quantityAndFrequencyHeader", ctx_r20.quantityAndFrequencyHeader)("dosageHeader", ctx_r20.dosageHeader)("packageHeader", ctx_r20.packageHeader)("contentSectionText", ctx_r20.contentSectionText)("addButtonText", ctx_r20.addButtonText)("cancelButtonText", ctx_r20.backButtonText)("quantityMaxLimit", ctx_r20.quantityMaxLimit)("quantityErrorMessage", ctx_r20.quantityErrorMessage)("genericOptionIcon", ctx_r20.genericOptionIcon)("showGenericOption", ctx_r20.showGenericOption)("genericOptionInfo", ctx_r20.genericOptionInfo)("genericOptions", ctx_r20.genericOptions)("activeGenericOption", ctx_r20.activeGenericOption)("genericEquivalentQuestion", ctx_r20.genericEquivalentQuestion)("isQuantityValid", ctx_r20.isQuantityValid)("defaultFrequency", ctx_r20.defaultFrequency)("dosages", ctx_r20.dosages)("dosageToEdit", ctx_r20.dosageToEdit)("hasGenericDrug", ctx_r20.drugDetails.hasGenericDrug)("medicineCabinetLimit", ctx_r20.medicineCabinetLimit)("cabinetLimitErrorMessage", ctx_r20.cabinetLimitErrorMessage)("inCabinetErrorMessage", ctx_r20.inCabinetErrorMessage)("helpfulTools", ctx_r20.helpfulTools)("helpfulToolsPlan", ctx_r20.helpfulToolsPlan)("checkDrugCoverageButtonText", ctx_r20.checkDrugCoverageButtonText)("showCosts", !ctx_r20.showCosts)("errorKeywordText", ctx_r20.errorKeywordText)("drugSearchFrequencyListBoxLabel", ctx_r20.drugSearchFrequencyListBoxLabel)("nonCoveredPrescriptions", ctx_r20.nonCoveredPrescriptions)("coveredPrescriptions", ctx_r20.coveredPrescriptions)("noPrescriptionInTier", ctx_r20.noPrescriptionInTier)("editDrugText", ctx_r20.editDrugText)("isUseCMSDrugFlagEnabled", ctx_r20.isUseCMSDrugFlagEnabled)("showDrugAlternativesEnabled", ctx_r20.showDrugAlternativesEnabled)("helpfulToolsShowDrugAlternativesNudgeEnabled", ctx_r20.helpfulToolsShowDrugAlternativesNudgeEnabled)("cabinetForAlternatives", ctx_r20.cabinetForAlternatives)("selectedPlanPharmacy", ctx_r20.selectedPlanPharmacy)("prescriptionsDrugAlternativesButtonText", ctx_r20.prescriptionsDrugAlternativesButtonText)("isMobile", ctx_r20.isMobile)("isModalDrugDetail", true);
} }
function DrugSearchModalComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "h1", 26);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p", 19);
    i0.ɵɵpipe(4, "safe");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 27);
    i0.ɵɵtemplate(6, DrugSearchModalComponent_ng_template_3_vnext_drug_details_6_Template, 1, 45, "vnext-drug-details", 28);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.modalView2HeaderText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(4, 3, ctx_r2.modalView2IntroText, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.drugDetails);
} }
class DrugSearchModalComponent extends DrugSearchComponent {
    constructor(activeModal, cdr, drugsService, helpfulToolsService, helpfulToolsContext, deactivationService, renderer, autoCompleteService, createAccountContext, analyticsService) {
        super(cdr, drugsService, helpfulToolsService, helpfulToolsContext, deactivationService, renderer, autoCompleteService, createAccountContext, analyticsService);
        this.activeModal = activeModal;
        this.cdr = cdr;
        this.drugsService = drugsService;
        this.helpfulToolsService = helpfulToolsService;
        this.helpfulToolsContext = helpfulToolsContext;
        this.deactivationService = deactivationService;
        this.renderer = renderer;
        this.autoCompleteService = autoCompleteService;
        this.createAccountContext = createAccountContext;
        this.analyticsService = analyticsService;
        this.backButtonText = '';
        this.modalView2HeaderText = '';
        this.modalView2IntroText = '';
    }
}
DrugSearchModalComponent.ɵfac = function DrugSearchModalComponent_Factory(t) { return new (t || DrugSearchModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.DrugsService), i0.ɵɵdirectiveInject(HelpfulToolsService), i0.ɵɵdirectiveInject(HelpfulToolsContextService), i0.ɵɵdirectiveInject(i1.DeactivationGuardService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1.AutoCompleteService), i0.ɵɵdirectiveInject(CreateAccountContext), i0.ɵɵdirectiveInject(AnalyticsService)); };
DrugSearchModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DrugSearchModalComponent, selectors: [["vnext-drug-search-modal"]], inputs: { backButtonText: "backButtonText", modalView2HeaderText: "modalView2HeaderText", modalView2IntroText: "modalView2IntroText", drugSearchInputLabelText: "drugSearchInputLabelText" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 2, consts: [[1, "px-3"], ["aria-relevant", "text", 1, "row"], [4, "ngIf", "ngIfElse"], ["showDrugDetail", ""], ["id", "drugsearch", "class", "col-12 p-0", 4, "ngIf"], [1, "inner-addon", "search-wrapper", "col-md-8", "col-12", "p-0", "drug-search-list"], ["aria-hidden", "true", 1, "fas", "fa-search"], ["drug", ""], ["for", "drugSearchInput", 1, "Spa_Style_Label"], ["type", "text", "class", "form-control drug-search-input", "placement", "bottom-left", 3, "placeholder", "ngbTypeahead", "resultTemplate", "inputFormatter", "popupClass", "ngModel", "ngModelChange", "selectItem", "click", "keyup", 4, "liveEditProp"], [1, "col-12", "p-0"], [1, "col-12"], [3, "startAddingDrugText", "orText", "connectToMyMedicareText", "myMedicareButtonText", "emailLabelText", "emailRequiredErrorText", "emailInvalidErrorText", "sendEmailButtonText", "blueButtonModalHeaderText", "blueButtonModalContent", "blueButtonSuccessText", "blueButtonDownloadText", "blueButtonSuccessMessage", "blueButtonEmailSendText", "blueButtonIssueLoadingText", "blueButtonBeneficiaryDeniedText", "blueButtonErrorLoadingText", "blueButtonBeneficiaryEmailDetails", "blueButtonImportLatestPrescriptionButtonText", "blueButtonImportLatestPrescriptionErrorText", "blueButtonAccessDeniedText", "blueButtonClaimDataLoadingErrorText", "isPreferenceBannerEnabled", 4, "ngIf"], [3, "medCabinetHeader", "showGenericOption", 4, "ngIf"], ["id", "drugsearch", 1, "col-12", "p-0"], [1, "text-left"], ["class", "Spa_Style_H2", 4, "liveEditProp"], ["class", "Spa_Style_IntroParagraph", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [1, "Spa_Style_H2"], ["navigationAdapter", "", 1, "Spa_Style_IntroParagraph", 3, "innerHtml"], ["for", "drugSearch", "id", "drugSearchLabel", "aria-live", "off", 1, "sr-only"], [1, "Spa_Style_H5", 3, "result", "term"], ["type", "text", "placement", "bottom-left", 1, "form-control", "drug-search-input", 3, "placeholder", "ngbTypeahead", "resultTemplate", "inputFormatter", "popupClass", "ngModel", "ngModelChange", "selectItem", "click", "keyup"], ["drugSearchInput", "", "typeahead", "ngbTypeahead"], [3, "startAddingDrugText", "orText", "connectToMyMedicareText", "myMedicareButtonText", "emailLabelText", "emailRequiredErrorText", "emailInvalidErrorText", "sendEmailButtonText", "blueButtonModalHeaderText", "blueButtonModalContent", "blueButtonSuccessText", "blueButtonDownloadText", "blueButtonSuccessMessage", "blueButtonEmailSendText", "blueButtonIssueLoadingText", "blueButtonBeneficiaryDeniedText", "blueButtonErrorLoadingText", "blueButtonBeneficiaryEmailDetails", "blueButtonImportLatestPrescriptionButtonText", "blueButtonImportLatestPrescriptionErrorText", "blueButtonAccessDeniedText", "blueButtonClaimDataLoadingErrorText", "isPreferenceBannerEnabled"], [3, "medCabinetHeader", "showGenericOption"], [1, "Spa_Style_H1"], [1, "drug-detail-wrapper"], [3, "isEditing", "drugName", "drugDetails", "selectedDosage", "frequencyList", "quantityAndFrequencyHeader", "dosageHeader", "packageHeader", "contentSectionText", "addButtonText", "cancelButtonText", "quantityMaxLimit", "quantityErrorMessage", "genericOptionIcon", "showGenericOption", "genericOptionInfo", "genericOptions", "activeGenericOption", "genericEquivalentQuestion", "isQuantityValid", "defaultFrequency", "dosages", "dosageToEdit", "hasGenericDrug", "medicineCabinetLimit", "cabinetLimitErrorMessage", "inCabinetErrorMessage", "helpfulTools", "helpfulToolsPlan", "checkDrugCoverageButtonText", "showCosts", "errorKeywordText", "drugSearchFrequencyListBoxLabel", "nonCoveredPrescriptions", "coveredPrescriptions", "noPrescriptionInTier", "editDrugText", "isUseCMSDrugFlagEnabled", "showDrugAlternativesEnabled", "helpfulToolsShowDrugAlternativesNudgeEnabled", "cabinetForAlternatives", "selectedPlanPharmacy", "prescriptionsDrugAlternativesButtonText", "isMobile", "isModalDrugDetail", "updateFrequency", "updateIsQuantityValid", "updateActiveGenericOption", "removeSelectedDrug", "viewPossibleAlternativeDrugs", 4, "ngIf"], [3, "isEditing", "drugName", "drugDetails", "selectedDosage", "frequencyList", "quantityAndFrequencyHeader", "dosageHeader", "packageHeader", "contentSectionText", "addButtonText", "cancelButtonText", "quantityMaxLimit", "quantityErrorMessage", "genericOptionIcon", "showGenericOption", "genericOptionInfo", "genericOptions", "activeGenericOption", "genericEquivalentQuestion", "isQuantityValid", "defaultFrequency", "dosages", "dosageToEdit", "hasGenericDrug", "medicineCabinetLimit", "cabinetLimitErrorMessage", "inCabinetErrorMessage", "helpfulTools", "helpfulToolsPlan", "checkDrugCoverageButtonText", "showCosts", "errorKeywordText", "drugSearchFrequencyListBoxLabel", "nonCoveredPrescriptions", "coveredPrescriptions", "noPrescriptionInTier", "editDrugText", "isUseCMSDrugFlagEnabled", "showDrugAlternativesEnabled", "helpfulToolsShowDrugAlternativesNudgeEnabled", "cabinetForAlternatives", "selectedPlanPharmacy", "prescriptionsDrugAlternativesButtonText", "isMobile", "isModalDrugDetail", "updateFrequency", "updateIsQuantityValid", "updateActiveGenericOption", "removeSelectedDrug", "viewPossibleAlternativeDrugs"]], template: function DrugSearchModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, DrugSearchModalComponent_ng_container_2_Template, 14, 5, "ng-container", 2);
        i0.ɵɵtemplate(3, DrugSearchModalComponent_ng_template_3_Template, 7, 6, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(4);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.drugDetails)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgIf, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, NavigationAdapterDirective, LiveEditPropDirective, IconAriaAttributesDirective, i1$1.NgbTypeahead, i1$1.NgbHighlight, DrugDetailsComponent, MedicineCabinetModalComponent, BlueButtonComponent, SelectRXSectionComponent, SafePipe], styles: [".search-wrapper[_ngcontent-%COMP%]{margin:0 0 15px;position:relative}.search-wrapper.inner-addon[_ngcontent-%COMP%]   .fas[_ngcontent-%COMP%]{position:absolute;padding:8px 10px;pointer-events:none;right:0;bottom:2px;font-size:16px}.details-content[_ngcontent-%COMP%]   .search-wrapper.inner-addon[_ngcontent-%COMP%]   .fas[_ngcontent-%COMP%]{top:25px}.search-wrapper.inner-addon[_ngcontent-%COMP%]   .address[_ngcontent-%COMP%]   span.fas[_ngcontent-%COMP%]{top:0}.drug-search-input[_ngcontent-%COMP%]{width:100%;padding-right:30px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.drug-search-input[_ngcontent-%COMP%]::-ms-clear{display:none}.prescription-drug-icon[_ngcontent-%COMP%]{font-size:46px}.drug-detail-wrapper[_ngcontent-%COMP%]{width:100%}.drug-details-container[_ngcontent-%COMP%]{border:none}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DrugSearchModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-drug-search-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"px-3\">\r\n  <div class=\"row\" aria-relevant=\"text\">\r\n    <ng-container *ngIf=\"!drugDetails; else showDrugDetail\">\r\n      <div id=\"drugsearch\" class=\"col-12 p-0\" *ngIf=\"!helpfulTools\">\r\n        <div class=\"text-left\">\r\n          <h1 class=\"Spa_Style_H2\" *liveEditProp=\"'Spa_Site_Prescriptions_Text'\">{{ prescriptionsText }}</h1>\r\n          <p\r\n            class=\"Spa_Style_IntroParagraph\"\r\n            *liveEditProp=\"'Spa_DrugSearch_Intro_Text'\"\r\n            [innerHtml]=\"drugSearchIntroText | safe : 'html'\"\r\n            navigationAdapter\r\n          ></p>\r\n        </div>\r\n      </div>\r\n      <div class=\"inner-addon search-wrapper col-md-8 col-12 p-0 drug-search-list\">\r\n        <i class=\"fas fa-search\" aria-hidden=\"true\"></i>\r\n        <ng-template #drug let-r=\"result\" let-t=\"term\">\r\n          <label class=\"sr-only\" for=\"drugSearch\" id=\"drugSearchLabel\" aria-live=\"off\">{{ drugSearchText }}</label>\r\n          <ngb-highlight class=\"Spa_Style_H5\" [result]=\"r.drugName\" [term]=\"t\"></ngb-highlight>\r\n        </ng-template>\r\n        <label class=\"Spa_Style_Label\" for=\"drugSearchInput\">\r\n          {{ drugSearchInputLabelText }}\r\n        </label>\r\n        <input\r\n          #drugSearchInput\r\n          #typeahead=\"ngbTypeahead\"\r\n          *liveEditProp=\"'Spa_DrugSearch_Hint_Text'\"\r\n          type=\"text\"\r\n          class=\"form-control drug-search-input\"\r\n          placement=\"bottom-left\"\r\n          [attr.aria-label]=\"drugSearchPageHeaderText\"\r\n          [placeholder]=\"placeholder\"\r\n          [ngbTypeahead]=\"suggestedDrugs\"\r\n          [resultTemplate]=\"drug\"\r\n          [inputFormatter]=\"drugAutocompleteformatter\"\r\n          [popupClass]=\"noTranslateBlockClass\"\r\n          [(ngModel)]=\"searchTerm\"\r\n          (selectItem)=\"selectItem($event)\"\r\n          (click)=\"clearSearchTerm()\"\r\n          (keyup)=\"scrollItemIntoView()\"\r\n        />\r\n      </div>\r\n\r\n      <div class=\"col-12 p-0\">\r\n        <vnext-selectrx-section></vnext-selectrx-section>\r\n      </div>\r\n\r\n      <div class=\"col-12\">\r\n        <vnext-blue-button\r\n          *ngIf=\"!helpfulTools && isBlueButtonEnabled && isMemberSessionUpdated\"\r\n          [startAddingDrugText]=\"blueButtonStartAddingDrugText\"\r\n          [orText]=\"orText\"\r\n          [connectToMyMedicareText]=\"blueButtonConnectToMyMedicareText\"\r\n          [myMedicareButtonText]=\"blueButtonMyMedicareButtonText\"\r\n          [emailLabelText]=\"emailLabelText\"\r\n          [emailRequiredErrorText]=\"emailRequiredErrorText\"\r\n          [emailInvalidErrorText]=\"emailInvalidErrorText\"\r\n          [sendEmailButtonText]=\"sendEmailButtonText\"\r\n          [blueButtonModalHeaderText]=\"blueButtonModalHeaderText\"\r\n          [blueButtonModalContent]=\"blueButtonModalContent\"\r\n          [blueButtonSuccessText]=\"blueButtonSuccessText\"\r\n          [blueButtonDownloadText]=\"blueButtonDownloadText\"\r\n          [blueButtonSuccessMessage]=\"blueButtonSuccessMessage\"\r\n          [blueButtonEmailSendText]=\"blueButtonEmailSendText\"\r\n          [blueButtonIssueLoadingText]=\"blueButtonIssueLoadingText\"\r\n          [blueButtonBeneficiaryDeniedText]=\"blueButtonBeneficiaryDeniedText\"\r\n          [blueButtonErrorLoadingText]=\"blueButtonErrorLoadingText\"\r\n          [blueButtonBeneficiaryEmailDetails]=\"blueButtonBeneficiaryEmailDetails\"\r\n          [blueButtonImportLatestPrescriptionButtonText]=\"blueButtonImportLatestPrescriptionButtonText\"\r\n          [blueButtonImportLatestPrescriptionErrorText]=\"blueButtonImportLatestPrescriptionErrorText\"\r\n          [blueButtonAccessDeniedText]=\"blueButtonAccessDeniedText\"\r\n          [blueButtonClaimDataLoadingErrorText]=\"blueButtonClaimDataLoadingErrorText\"\r\n          [isPreferenceBannerEnabled]=\"true\"\r\n        ></vnext-blue-button>\r\n        <vnext-medicine-cabinet-modal\r\n          *ngIf=\"!helpfulTools && (!isBlueButtonEnabled || isMemberSessionUpdated)\"\r\n          [medCabinetHeader]=\"medCabinetHeader\"\r\n          [showGenericOption]=\"showGenericOption\"\r\n        ></vnext-medicine-cabinet-modal>\r\n      </div>\r\n    </ng-container>\r\n\r\n    <ng-template #showDrugDetail>\r\n      <div class=\"text-left\">\r\n        <h1 class=\"Spa_Style_H1\">{{ modalView2HeaderText }}</h1>\r\n        <p class=\"Spa_Style_IntroParagraph\" [innerHtml]=\"modalView2IntroText | safe : 'html'\" navigationAdapter></p>\r\n      </div>\r\n      <div class=\"drug-detail-wrapper\">\r\n        <vnext-drug-details\r\n          *ngIf=\"drugDetails\"\r\n          [isEditing]=\"isEditing\"\r\n          [drugName]=\"drugName\"\r\n          [drugDetails]=\"drugDetails\"\r\n          [selectedDosage]=\"drugDetails.commonDosage\"\r\n          [frequencyList]=\"frequencyList\"\r\n          [quantityAndFrequencyHeader]=\"quantityAndFrequencyHeader\"\r\n          [dosageHeader]=\"dosageHeader\"\r\n          [packageHeader]=\"packageHeader\"\r\n          [contentSectionText]=\"contentSectionText\"\r\n          [addButtonText]=\"addButtonText\"\r\n          [cancelButtonText]=\"backButtonText\"\r\n          [quantityMaxLimit]=\"quantityMaxLimit\"\r\n          [quantityErrorMessage]=\"quantityErrorMessage\"\r\n          [genericOptionIcon]=\"genericOptionIcon\"\r\n          [showGenericOption]=\"showGenericOption\"\r\n          [genericOptionInfo]=\"genericOptionInfo\"\r\n          [genericOptions]=\"genericOptions\"\r\n          [activeGenericOption]=\"activeGenericOption\"\r\n          [genericEquivalentQuestion]=\"genericEquivalentQuestion\"\r\n          [isQuantityValid]=\"isQuantityValid\"\r\n          [defaultFrequency]=\"defaultFrequency\"\r\n          [dosages]=\"dosages\"\r\n          [dosageToEdit]=\"dosageToEdit\"\r\n          [hasGenericDrug]=\"drugDetails.hasGenericDrug\"\r\n          [medicineCabinetLimit]=\"medicineCabinetLimit\"\r\n          [cabinetLimitErrorMessage]=\"cabinetLimitErrorMessage\"\r\n          [inCabinetErrorMessage]=\"inCabinetErrorMessage\"\r\n          [helpfulTools]=\"helpfulTools\"\r\n          [helpfulToolsPlan]=\"helpfulToolsPlan\"\r\n          [checkDrugCoverageButtonText]=\"checkDrugCoverageButtonText\"\r\n          [showCosts]=\"!showCosts\"\r\n          (updateFrequency)=\"updateFrequency($event)\"\r\n          (updateIsQuantityValid)=\"updateIsQuantityValid($event)\"\r\n          (updateActiveGenericOption)=\"updateActiveGenericOption($event)\"\r\n          (removeSelectedDrug)=\"removeSelectedDrug()\"\r\n          [errorKeywordText]=\"errorKeywordText\"\r\n          [drugSearchFrequencyListBoxLabel]=\"drugSearchFrequencyListBoxLabel\"\r\n          [nonCoveredPrescriptions]=\"nonCoveredPrescriptions\"\r\n          [coveredPrescriptions]=\"coveredPrescriptions\"\r\n          [noPrescriptionInTier]=\"noPrescriptionInTier\"\r\n          [editDrugText]=\"editDrugText\"\r\n          [isUseCMSDrugFlagEnabled]=\"isUseCMSDrugFlagEnabled\"\r\n          [showDrugAlternativesEnabled]=\"showDrugAlternativesEnabled\"\r\n          [helpfulToolsShowDrugAlternativesNudgeEnabled]=\"helpfulToolsShowDrugAlternativesNudgeEnabled\"\r\n          [cabinetForAlternatives]=\"cabinetForAlternatives\"\r\n          [selectedPlanPharmacy]=\"selectedPlanPharmacy\"\r\n          [prescriptionsDrugAlternativesButtonText]=\"prescriptionsDrugAlternativesButtonText\"\r\n          [isMobile]=\"isMobile\"\r\n          [isModalDrugDetail]=\"true\"\r\n          (viewPossibleAlternativeDrugs)=\"onViewPossibleAlternativeDrugs($event)\"\r\n        >\r\n        </vnext-drug-details>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n</div>\r\n", styles: [".search-wrapper{margin:0 0 15px;position:relative}.search-wrapper.inner-addon .fas{position:absolute;padding:8px 10px;pointer-events:none;right:0;bottom:2px;font-size:16px}.details-content .search-wrapper.inner-addon .fas{top:25px}.search-wrapper.inner-addon .address span.fas{top:0}.drug-search-input{width:100%;padding-right:30px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.drug-search-input::-ms-clear{display:none}.prescription-drug-icon{font-size:46px}.drug-detail-wrapper{width:100%}.drug-details-container{border:none}\n"] }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i0.ChangeDetectorRef }, { type: i1.DrugsService }, { type: HelpfulToolsService }, { type: HelpfulToolsContextService }, { type: i1.DeactivationGuardService }, { type: i0.Renderer2 }, { type: i1.AutoCompleteService }, { type: CreateAccountContext }, { type: AnalyticsService }]; }, { backButtonText: [{
            type: Input
        }], modalView2HeaderText: [{
            type: Input
        }], modalView2IntroText: [{
            type: Input
        }], drugSearchInputLabelText: [{
            type: Input
        }] }); })();

class GuidedHelpModalStyleService {
    applyModalStyle(renderer, modalElement) {
        renderer.setStyle(modalElement, 'display', 'flex');
        renderer.setStyle(modalElement, 'flex-direction', 'column');
        renderer.setStyle(modalElement, 'height', '100%');
    }
}
GuidedHelpModalStyleService.ɵfac = function GuidedHelpModalStyleService_Factory(t) { return new (t || GuidedHelpModalStyleService)(); };
GuidedHelpModalStyleService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GuidedHelpModalStyleService, factory: GuidedHelpModalStyleService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuidedHelpModalStyleService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

function EligibilityModalComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.accordionHeaderText);
} }
function EligibilityModalComponent_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.optionalLabel);
} }
function EligibilityModalComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "span", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.errorKeywordText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r2.subsidyError.message, " ");
} }
class EligibilityModalComponent {
    constructor(activeModal, planFacade, configResourceService, demographicService, store, guidedHelpService, localeService, cdr, elementRef, renderer, guidedHelpModalStyleService) {
        this.activeModal = activeModal;
        this.planFacade = planFacade;
        this.configResourceService = configResourceService;
        this.demographicService = demographicService;
        this.store = store;
        this.guidedHelpService = guidedHelpService;
        this.localeService = localeService;
        this.cdr = cdr;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.guidedHelpModalStyleService = guidedHelpModalStyleService;
        this.coverageTypeEnabled = this.guidedHelpService.coverageTypeEnabled;
        this.coverageType = CoverageType;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.selectedParentId = `${this.store.selectSnapshot(DemographicState.subsidySelected)}`;
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe({
            next: locale => {
                this.subsidyAccordionItems = this.planFacade.subsidyAccordionItems;
                this.cdr.markForCheck();
            }
        }));
    }
    ngAfterViewInit() {
        const modalElement = this.elementRef.nativeElement;
        if (modalElement) {
            this.guidedHelpModalStyleService.applyModalStyle(this.renderer, modalElement);
        }
    }
    receiveValueFromSubsidyAccordion($event) {
        let idAsNumber = parseInt($event.id, 10);
        this.guidedHelpService.updateMemberPreferenceSubsidyAnalytics(idAsNumber);
        // Convert "DONT_KNOW" to "NONE"
        if (idAsNumber === SubsidySelected.DONT_KNOW) {
            idAsNumber = SubsidySelected.NONE;
        }
        const action = SubsidySelected[idAsNumber] !== undefined ? new SelectSubsidySelected(idAsNumber) : new SelectSubsidyPercent(idAsNumber);
        this.store
            .dispatch(action)
            .pipe(take$1(1))
            .subscribe({
            next: () => {
                this.demographicService.updateDemographicSession();
            }
        });
        this.store.dispatch(new SetPlansDirty(true, [ALL_MEDICARE_PLAN_TYPE_VALUE]));
        this.subsidyError = null;
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
EligibilityModalComponent.ɵfac = function EligibilityModalComponent_Factory(t) { return new (t || EligibilityModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.DemographicService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(GuidedHelpModalStyleService)); };
EligibilityModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EligibilityModalComponent, selectors: [["vnext-eligibility-modal"]], decls: 16, vars: 17, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "modal-body"], [1, "Spa_Style_H2"], ["class", "Spa_Style_H4", "id", "extra-help-for-drugs-text", 4, "liveEditProp"], ["id", "extra-help-for-drugs-optional-text", 4, "liveEditProp"], ["class", "error-color", "id", "getStartedSubsidyError", 4, "ngIf"], [1, "getting-started-accordion-wrapper"], [3, "items", "allowParentValues", "selectedParent", "emitParentValueWhenNoChildrenSelected", "ariaDescribedById", "ariaLabelledById", "largerText", "isMobile", "buttonHeight", "valueSelected"], [3, "cancelButtonText", "primaryButtonEnabled", "cancelButtonAction"], ["id", "extra-help-for-drugs-text", 1, "Spa_Style_H4"], ["id", "extra-help-for-drugs-optional-text"], ["id", "getStartedSubsidyError", 1, "error-color"], [1, "sr-only"]], template: function EligibilityModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function EligibilityModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.activeModal.dismiss(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1)(2, "div")(3, "h2", 2);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div")(6, "p");
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "div")(9, "p");
        i0.ɵɵtemplate(10, EligibilityModalComponent_span_10_Template, 2, 1, "span", 3);
        i0.ɵɵtemplate(11, EligibilityModalComponent_span_11_Template, 2, 1, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, EligibilityModalComponent_div_12_Template, 4, 2, "div", 5);
        i0.ɵɵelementStart(13, "div", 6)(14, "vnext-accordion", 7);
        i0.ɵɵlistener("valueSelected", function EligibilityModalComponent_Template_vnext_accordion_valueSelected_14_listener($event) { return ctx.receiveValueFromSubsidyAccordion($event); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(15, "vnext-widget-modal-footer", 8);
        i0.ɵɵlistener("cancelButtonAction", function EligibilityModalComponent_Template_vnext_widget_modal_footer_cancelButtonAction_15_listener() { return ctx.activeModal.dismiss(); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.eligibilityModalView1HeadingText);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.eligibilityModalView1IntroText);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "Spa_GettingStarted_SubsidyHeader_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_GuidedHelp_OptionalLabel_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.subsidyError);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("items", ctx.subsidyAccordionItems)("allowParentValues", true)("selectedParent", ctx.selectedParentId)("emitParentValueWhenNoChildrenSelected", true)("ariaDescribedById", ctx.subsidyError ? "getStartedSubsidyError" : "")("ariaLabelledById", "extra-help-for-drugs-text extra-help-for-drugs-optional-text")("largerText", true)("isMobile", ctx.isMobile)("buttonHeight", "36px");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("cancelButtonText", ctx.cancelButton)("primaryButtonEnabled", false);
    } }, dependencies: [i1$2.NgIf, ModalFooterComponent, ModalHeaderComponent, LiveEditPropDirective, AccordionComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EligibilityModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-eligibility-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"activeModal.dismiss()\"></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body\">\r\n  <div>\r\n    <h2 class=\"Spa_Style_H2\">{{ eligibilityModalView1HeadingText }}</h2>\r\n  </div>\r\n  <div>\r\n    <p>{{ eligibilityModalView1IntroText }}</p>\r\n  </div>\r\n  <div>\r\n    <p>\r\n      <span class=\"Spa_Style_H4\" *liveEditProp=\"'Spa_GettingStarted_SubsidyHeader_Text'\" id=\"extra-help-for-drugs-text\">{{\r\n        accordionHeaderText\r\n      }}</span>\r\n      <span *liveEditProp=\"'Spa_GuidedHelp_OptionalLabel_Text'\" id=\"extra-help-for-drugs-optional-text\">{{ optionalLabel }}</span>\r\n    </p>\r\n    <div class=\"error-color\" *ngIf=\"subsidyError\" id=\"getStartedSubsidyError\">\r\n      <span class=\"sr-only\">{{ errorKeywordText }}</span\r\n      >{{ subsidyError.message }}\r\n    </div>\r\n    <div class=\"getting-started-accordion-wrapper\">\r\n      <vnext-accordion\r\n        (valueSelected)=\"receiveValueFromSubsidyAccordion($event)\"\r\n        [items]=\"subsidyAccordionItems\"\r\n        [allowParentValues]=\"true\"\r\n        [selectedParent]=\"selectedParentId\"\r\n        [emitParentValueWhenNoChildrenSelected]=\"true\"\r\n        [ariaDescribedById]=\"subsidyError ? 'getStartedSubsidyError' : ''\"\r\n        [ariaLabelledById]=\"'extra-help-for-drugs-text extra-help-for-drugs-optional-text'\"\r\n        [largerText]=\"true\"\r\n        [isMobile]=\"isMobile\"\r\n        [buttonHeight]=\"'36px'\"\r\n      ></vnext-accordion>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<vnext-widget-modal-footer\r\n  [cancelButtonText]=\"cancelButton\"\r\n  [primaryButtonEnabled]=\"false\"\r\n  (cancelButtonAction)=\"activeModal.dismiss()\"\r\n></vnext-widget-modal-footer>\r\n" }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: PlanFacade }, { type: i1.ConfigResourceService }, { type: i1.DemographicService }, { type: i2.Store }, { type: i1.GuidedHelpService }, { type: i1.LocaleService }, { type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: GuidedHelpModalStyleService }]; }, null); })();

function HealthModalComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "vnext-health-cost-customization", 9);
    i0.ɵɵlistener("updateEstimateHealthCost", function HealthModalComponent_div_12_Template_vnext_health_cost_customization_updateEstimateHealthCost_1_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.updateEstimateHealthCost($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("toggleYesText", ctx_r0.toggleYesText)("toggleNoText", ctx_r0.toggleNoText)("healthCostsBodyText", ctx_r0.healthCostsBodyText)("healthCostsBenefitsBodyText", ctx_r0.healthCostsBenefitsBodyText)("healthCostsBenefitsTableHeader", ctx_r0.healthCostsBenefitsTableHeader)("healthCostsUsageTableHeader", ctx_r0.healthCostsUsageTableHeader)("healthCostsDaysTableHeader", ctx_r0.healthCostsDaysTableHeader)("healthCostsRestoreDefaultsText", ctx_r0.healthCostsRestoreDefaultsText)("healthCostsUpdateAnswersText", ctx_r0.healthCostsUpdateAnswersText)("healthCostsSaveAnswersText", ctx_r0.healthCostsSaveAnswersText)("healthCostsBenefits", ctx_r0.healthCostsBenefits)("estimateHealthCost", ctx_r0.estimateHealthCost)("saveFailedText", ctx_r0.saveFailedText)("saveSuccessText", ctx_r0.saveSuccessText);
} }
class HealthModalComponent {
    constructor(activeModal, memberSessionService, configResourceService, elementRef, renderer, guidedHelpModalStyleService) {
        this.activeModal = activeModal;
        this.memberSessionService = memberSessionService;
        this.configResourceService = configResourceService;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.guidedHelpModalStyleService = guidedHelpModalStyleService;
        this.subscriptions = new Subscription();
        this.availableQuestionPages = [];
        this.pageTags = PageTags;
        this.questionsLoaded = false;
        this.tagsToUpdate = {};
    }
    ngOnInit() {
        this.setUpHealthPageProperties();
        this.initializeTranslatableText();
        this.subscriptions.add(this.memberSessionService.getMemberDemographicEstimateHealthCost$().subscribe((estimateHealthCost) => {
            this.estimateHealthCost = estimateHealthCost;
        }));
    }
    ngAfterViewInit() {
        const modalElement = this.elementRef.nativeElement;
        if (modalElement) {
            this.guidedHelpModalStyleService.applyModalStyle(this.renderer, modalElement);
        }
    }
    setUpHealthPageProperties() {
        this.healthPageProperties = {};
        this.slideSections = [
            {
                value: GuidedHelpHealthStatus.MEMBER_HEALTH_GOOD,
                headerKey: 'Spa_GuidedHelp_Health_SliderHeader1_Text',
                bodyKey: 'Spa_GuidedHelp_Health_SliderBody1',
                header: this.healthSliderHeader1Text,
                body: this.healthSliderBody1
            },
            {
                value: GuidedHelpHealthStatus.MEMBER_HEALTH_FAIR,
                headerKey: 'Spa_GuidedHelp_Health_SliderHeader2_Text',
                bodyKey: 'Spa_GuidedHelp_Health_SliderBody2',
                header: this.healthSliderHeader2Text,
                body: this.healthSliderBody2
            },
            {
                value: GuidedHelpHealthStatus.MEMBER_HEALTH_POOR,
                headerKey: 'Spa_GuidedHelp_Health_SliderHeader3_Text',
                bodyKey: 'Spa_GuidedHelp_Health_SliderBody3',
                header: this.healthSliderHeader3Text,
                body: this.healthSliderBody3
            }
        ];
    }
    initializeTranslatableText() {
        this.toggleYesText = this.configResourceService.getProcessedResourceValue('Spa_Site_Yes', null, 'Yes');
        this.toggleNoText = this.configResourceService.getProcessedResourceValue('Spa_Site_No', null, 'No');
    }
    updateEstimateHealthCost(costFlag) {
        this.estimateHealthCost = costFlag;
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
HealthModalComponent.ɵfac = function HealthModalComponent_Factory(t) { return new (t || HealthModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(GuidedHelpModalStyleService)); };
HealthModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HealthModalComponent, selectors: [["vnext-health-modal"]], decls: 14, vars: 9, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "modal-body"], [1, "Spa_Style_H2"], [1, "mx-md-0", "mx-4", "mt-5"], [3, "slideSections", "healthStatusSliderLabel"], [1, "mb-5"], [3, "healthAgeQuestionText"], ["class", "mb-5", 4, "ngIf"], [3, "cancelButtonText", "primaryButtonEnabled", "cancelButtonAction"], [3, "toggleYesText", "toggleNoText", "healthCostsBodyText", "healthCostsBenefitsBodyText", "healthCostsBenefitsTableHeader", "healthCostsUsageTableHeader", "healthCostsDaysTableHeader", "healthCostsRestoreDefaultsText", "healthCostsUpdateAnswersText", "healthCostsSaveAnswersText", "healthCostsBenefits", "estimateHealthCost", "saveFailedText", "saveSuccessText", "updateEstimateHealthCost"]], template: function HealthModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function HealthModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.activeModal.dismiss(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1)(2, "div")(3, "h2", 2);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div")(6, "p");
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "div", 3);
        i0.ɵɵelement(9, "vnext-health-slider", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 5);
        i0.ɵɵelement(11, "vnext-guided-help-age-select", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, HealthModalComponent_div_12_Template, 2, 14, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "vnext-widget-modal-footer", 8);
        i0.ɵɵlistener("cancelButtonAction", function HealthModalComponent_Template_vnext_widget_modal_footer_cancelButtonAction_13_listener() { return ctx.activeModal.dismiss(); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.healthModalView1HeadingText);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.healthModalView1IntroText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("slideSections", ctx.slideSections)("healthStatusSliderLabel", ctx.healthSliderLabelText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("healthAgeQuestionText", ctx.healthAgeQuestionText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.healthCostsCustomizationEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("cancelButtonText", ctx.cancelButton)("primaryButtonEnabled", false);
    } }, dependencies: [i1$2.NgIf, ModalFooterComponent, ModalHeaderComponent, GuidedHelpAgeSelectComponent, HealthSliderComponent, HealthCostCustomizationComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HealthModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-health-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"activeModal.dismiss()\"></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body\">\r\n  <!-- TODO: SPA-21606 - [UI] Migrate Subsidy question from GH to Health Modal -->\r\n  <div>\r\n    <h2 class=\"Spa_Style_H2\">{{ healthModalView1HeadingText }}</h2>\r\n  </div>\r\n  <div>\r\n    <p>{{ healthModalView1IntroText }}</p>\r\n  </div>\r\n  <div class=\"mx-md-0 mx-4 mt-5\">\r\n    <vnext-health-slider [slideSections]=\"slideSections\" [healthStatusSliderLabel]=\"healthSliderLabelText\"></vnext-health-slider>\r\n  </div>\r\n  <div class=\"mb-5\">\r\n    <vnext-guided-help-age-select [healthAgeQuestionText]=\"healthAgeQuestionText\"></vnext-guided-help-age-select>\r\n  </div>\r\n  <div class=\"mb-5\" *ngIf=\"healthCostsCustomizationEnabled\">\r\n    <vnext-health-cost-customization\r\n      [toggleYesText]=\"toggleYesText\"\r\n      [toggleNoText]=\"toggleNoText\"\r\n      [healthCostsBodyText]=\"healthCostsBodyText\"\r\n      [healthCostsBenefitsBodyText]=\"healthCostsBenefitsBodyText\"\r\n      [healthCostsBenefitsTableHeader]=\"healthCostsBenefitsTableHeader\"\r\n      [healthCostsUsageTableHeader]=\"healthCostsUsageTableHeader\"\r\n      [healthCostsDaysTableHeader]=\"healthCostsDaysTableHeader\"\r\n      [healthCostsRestoreDefaultsText]=\"healthCostsRestoreDefaultsText\"\r\n      [healthCostsUpdateAnswersText]=\"healthCostsUpdateAnswersText\"\r\n      [healthCostsSaveAnswersText]=\"healthCostsSaveAnswersText\"\r\n      [healthCostsBenefits]=\"healthCostsBenefits\"\r\n      [estimateHealthCost]=\"estimateHealthCost\"\r\n      [saveFailedText]=\"saveFailedText\"\r\n      [saveSuccessText]=\"saveSuccessText\"\r\n      (updateEstimateHealthCost)=\"updateEstimateHealthCost($event)\"\r\n    >\r\n    </vnext-health-cost-customization>\r\n  </div>\r\n</div>\r\n\r\n<vnext-widget-modal-footer\r\n  [cancelButtonText]=\"cancelButton\"\r\n  [primaryButtonEnabled]=\"false\"\r\n  (cancelButtonAction)=\"activeModal.dismiss()\"\r\n></vnext-widget-modal-footer>\r\n" }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i1.MemberSessionService }, { type: i1.ConfigResourceService }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: GuidedHelpModalStyleService }]; }, null); })();

function HIPDetailsBannerComponent_div_0_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 1)(6, "div", 8)(7, "div", 9);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 10);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "currency");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 11);
    i0.ɵɵelement(13, "vnext-link", 12);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.numberOfDaysText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.fullDaysText);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r2.basePlanText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind4(11, 7, ctx_r2.benefitAmount, "USD", "symbol", "1.0"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", ctx_r2.editYourAnswersText)("isLinkButton", true)("onClickAction", ctx_r2.goToHIPForm());
} }
function HIPDetailsBannerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵelement(2, "vnext-notice", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, HIPDetailsBannerComponent_div_0_ng_template_3_Template, 14, 12, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r1 = i0.ɵɵreference(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", "warn")("titleTemplate", _r1);
} }
class HIPDetailsBannerComponent {
    constructor(hospitalIndemnityFormFacade) {
        this.hospitalIndemnityFormFacade = hospitalIndemnityFormFacade;
        this.numberOfDaysText = 'Number of days';
        this.daysText = 'days';
        this.dayText = 'day';
        this.lumpSumText = 'Lump sum';
        this.editYourAnswersText = 'Edit your answers.';
        this.basePlanText = 'Base plan: Hospital Confinement';
        this.fullDaysText = '';
    }
    ngOnChanges(changes) {
        const { daysAmount, dayText, daysText, lumpSumText } = changes;
        if ((daysAmount?.currentValue && daysAmount.currentValue !== daysAmount.previousValue) ||
            (dayText?.currentValue && dayText.currentValue !== dayText.previousValue) ||
            (daysText?.currentValue && daysText.currentValue !== daysText.previousValue) ||
            (lumpSumText?.currentValue && lumpSumText.currentValue !== lumpSumText.previousValue)) {
            if (this.daysAmount === 999) {
                this.fullDaysText = this.lumpSumText;
            }
            else if (this.daysAmount === 1) {
                this.fullDaysText = `${this.daysAmount} ${this.dayText}`;
            }
            else {
                this.fullDaysText = `${this.daysAmount} ${this.daysText}`;
            }
        }
    }
    goToHIPForm() {
        return () => {
            this.hospitalIndemnityFormFacade.navigateToHospitalIndemnityForm();
        };
    }
}
HIPDetailsBannerComponent.ɵfac = function HIPDetailsBannerComponent_Factory(t) { return new (t || HIPDetailsBannerComponent)(i0.ɵɵdirectiveInject(HospitalIndemnityFormFacade)); };
HIPDetailsBannerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HIPDetailsBannerComponent, selectors: [["vnext-hip-details-banner"]], inputs: { numberOfDaysText: "numberOfDaysText", daysText: "daysText", dayText: "dayText", lumpSumText: "lumpSumText", editYourAnswersText: "editYourAnswersText", basePlanText: "basePlanText", daysAmount: "daysAmount", benefitAmount: "benefitAmount" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "row", 4, "ngIf"], [1, "row"], [1, "col-12"], [3, "type", "titleTemplate"], ["titleTemplate", ""], [1, "d-flex"], [1, "Spa_Style_Bold_Weight"], [1, "ml-2"], [1, "col-12", "col-md-8"], [1, "Spa_Style_Bold_Weight", "d-inline-block", "mb-1"], [1, "ml-2", "d-inline-block"], [1, "col-12", "col-md-4", "edit-your-answers"], [3, "title", "isLinkButton", "onClickAction"]], template: function HIPDetailsBannerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, HIPDetailsBannerComponent_div_0_Template, 5, 2, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.daysAmount && ctx.benefitAmount);
    } }, dependencies: [i1$2.NgIf, LinkComponent, NoticeComponent, i1$2.CurrencyPipe], styles: ["@media (min-width: 768px){.edit-your-answers[_ngcontent-%COMP%]{text-align:right}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HIPDetailsBannerComponent, [{
        type: Component,
        args: [{ selector: 'vnext-hip-details-banner', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"daysAmount && benefitAmount\" class=\"row\">\r\n  <div class=\"col-12\">\r\n    <vnext-notice [type]=\"'warn'\" [titleTemplate]=\"titleTemplate\"></vnext-notice>\r\n  </div>\r\n  <ng-template #titleTemplate\r\n    ><div class=\"d-flex\">\r\n      <div class=\"Spa_Style_Bold_Weight\">{{ numberOfDaysText }}</div>\r\n      <div class=\"ml-2\">{{ fullDaysText }}</div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-12 col-md-8\">\r\n        <div class=\"Spa_Style_Bold_Weight d-inline-block mb-1\">{{ basePlanText }}</div>\r\n        <div class=\"ml-2 d-inline-block\">{{ benefitAmount | currency: 'USD':'symbol':'1.0' }}</div>\r\n      </div>\r\n      <div class=\"col-12 col-md-4 edit-your-answers\">\r\n        <vnext-link [title]=\"editYourAnswersText\" [isLinkButton]=\"true\" [onClickAction]=\"goToHIPForm()\"></vnext-link>\r\n      </div></div\r\n  ></ng-template>\r\n</div>\r\n", styles: ["@media (min-width: 768px){.edit-your-answers{text-align:right}}\n"] }]
    }], function () { return [{ type: HospitalIndemnityFormFacade }]; }, { numberOfDaysText: [{
            type: Input
        }], daysText: [{
            type: Input
        }], dayText: [{
            type: Input
        }], lumpSumText: [{
            type: Input
        }], editYourAnswersText: [{
            type: Input
        }], basePlanText: [{
            type: Input
        }], daysAmount: [{
            type: Input
        }], benefitAmount: [{
            type: Input
        }] }); })();

const _c0$1o = ["medSupBirthDate"];
class MedSupBirthDateComponent {
    constructor(resourceService) {
        this.resourceService = resourceService;
        this.hasError = false;
        this.isReadOnly = false;
        this.updateAnswer = new EventEmitter();
    }
    getName() {
        return 'DateOfBirth';
    }
    focus() {
        this.medSupBirthDate.medSupDate.nativeElement.focus();
    }
    ngOnInit() {
        this.maxAge = this.resourceService.getProcessedResourceValue('Spa_MedSupForm_Maximum_Age') || 105;
    }
    getDate(date) {
        let error;
        if (date === '' || !DateUtilities.isValidDate(date)) {
            error = MedSupFormErrorTypes.INVALID;
        }
        else if (DateUtilities.dateIsInFuture(date)) {
            error = MedSupFormErrorTypes.FUTURE_DATE;
        }
        else if (!DateUtilities.dateIsInPastYearRange(date, this.maxAge)) {
            error = MedSupFormErrorTypes.PAST_DATE;
        }
        this.updateAnswer.emit({ name: this.question.name, value: date, valid: !error, error });
    }
}
MedSupBirthDateComponent.ɵfac = function MedSupBirthDateComponent_Factory(t) { return new (t || MedSupBirthDateComponent)(i0.ɵɵdirectiveInject(i1.ConfigResourceService)); };
MedSupBirthDateComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedSupBirthDateComponent, selectors: [["vnext-med-sup-birth-date"]], viewQuery: function MedSupBirthDateComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1o, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupBirthDate = _t.first);
    } }, inputs: { question: "question", defaultValue: "defaultValue", hasError: "hasError", isReadOnly: "isReadOnly", ariaDescribedById: "ariaDescribedById", ariaLabelledById: "ariaLabelledById" }, outputs: { updateAnswer: "updateAnswer" }, features: [i0.ɵɵProvidersFeature([])], decls: 2, vars: 5, consts: [[3, "defaultValue", "hasError", "ariaDescribedById", "ariaLabelledById", "isReadOnly", "sendDate"], ["medSupBirthDate", ""]], template: function MedSupBirthDateComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-med-sup-date", 0, 1);
        i0.ɵɵlistener("sendDate", function MedSupBirthDateComponent_Template_vnext_med_sup_date_sendDate_0_listener($event) { return ctx.getDate($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("defaultValue", ctx.defaultValue)("hasError", ctx.hasError)("ariaDescribedById", ctx.ariaDescribedById)("ariaLabelledById", ctx.ariaLabelledById)("isReadOnly", ctx.isReadOnly);
    } }, dependencies: [MedSupDateComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupBirthDateComponent, [{
        type: Component,
        args: [{ selector: 'vnext-med-sup-birth-date', changeDetection: ChangeDetectionStrategy.OnPush, providers: [], template: "<vnext-med-sup-date\r\n  #medSupBirthDate\r\n  (sendDate)=\"getDate($event)\"\r\n  [defaultValue]=\"defaultValue\"\r\n  [hasError]=\"hasError\"\r\n  [ariaDescribedById]=\"ariaDescribedById\"\r\n  [ariaLabelledById]=\"ariaLabelledById\"\r\n  [isReadOnly]=\"isReadOnly\"\r\n></vnext-med-sup-date>\r\n" }]
    }], function () { return [{ type: i1.ConfigResourceService }]; }, { medSupBirthDate: [{
            type: ViewChild,
            args: ['medSupBirthDate']
        }], question: [{
            type: Input
        }], defaultValue: [{
            type: Input
        }], hasError: [{
            type: Input
        }], isReadOnly: [{
            type: Input
        }], updateAnswer: [{
            type: Output
        }], ariaDescribedById: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }] }); })();

const _c0$1n = function (a0, a1, a2) { return { "Spa_Style_SecondaryButtonSelected selected Spa_Style_Bold_Weight": a0, "Spa_Style_SecondaryButton": a1, "Spa_Style_Gray4_Color": a2 }; };
class MedSupCheckboxComponent {
    constructor() {
        this.defaultSelected = false;
        this.disabled = false;
        this.onToggle = new EventEmitter();
        this.selected = false;
    }
    ngOnInit() {
        this.selected = this.defaultSelected;
    }
    ngOnChanges(changes) {
        const previousDisabled = !!changes.disabled?.previousValue;
        const currentDisabled = !!changes.disabled?.currentValue;
        if (previousDisabled != currentDisabled) {
            this.selected = false;
        }
    }
    toggle() {
        this.selected = !this.selected;
        this.onToggle.emit(this.selected ? this.value : null);
    }
}
MedSupCheckboxComponent.ɵfac = function MedSupCheckboxComponent_Factory(t) { return new (t || MedSupCheckboxComponent)(); };
MedSupCheckboxComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedSupCheckboxComponent, selectors: [["vnext-med-sup-checkbox"]], inputs: { text: "text", defaultSelected: "defaultSelected", disabled: "disabled", value: "value" }, outputs: { onToggle: "onToggle" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 7, consts: [["role", "checkbox", 1, "Spa_Style_Paragraph", "Spa_Style_Regular_Weight", "Spa_Style_Small_Font", 3, "ngClass", "disabled", "click"]], template: function MedSupCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function MedSupCheckboxComponent_Template_button_click_0_listener() { return ctx.toggle(); });
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(3, _c0$1n, ctx.selected, !ctx.selected, ctx.disabled))("disabled", ctx.disabled);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.text, "\n");
    } }, dependencies: [i1$2.NgClass], styles: ["button[_ngcontent-%COMP%]{border-radius:5px;border:1px solid var(--static-Spa_Style_Accent1);background-color:var(--static-Spa_Style_Gray2);width:100%;height:100%}button.selected[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Primary_Link);background-color:var(--static-Spa_Style_Toggle)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupCheckboxComponent, [{
        type: Component,
        args: [{ selector: 'vnext-med-sup-checkbox', changeDetection: ChangeDetectionStrategy.OnPush, template: "<button\r\n  class=\"Spa_Style_Paragraph Spa_Style_Regular_Weight Spa_Style_Small_Font\"\r\n  role=\"checkbox\"\r\n  [ngClass]=\"{\r\n    'Spa_Style_SecondaryButtonSelected selected Spa_Style_Bold_Weight': selected,\r\n    'Spa_Style_SecondaryButton': !selected,\r\n    'Spa_Style_Gray4_Color': disabled\r\n  }\"\r\n  (click)=\"toggle()\"\r\n  [disabled]=\"disabled\"\r\n>\r\n  {{ text }}\r\n</button>\r\n", styles: ["button{border-radius:5px;border:1px solid var(--static-Spa_Style_Accent1);background-color:var(--static-Spa_Style_Gray2);width:100%;height:100%}button.selected{border-color:var(--static-Spa_Style_Primary_Link);background-color:var(--static-Spa_Style_Toggle)}\n"] }]
    }], null, { text: [{
            type: Input
        }], defaultSelected: [{
            type: Input
        }], disabled: [{
            type: Input
        }], value: [{
            type: Input
        }], onToggle: [{
            type: Output
        }] }); })();

function MedSupCheckboxesComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "vnext-med-sup-checkbox", 4);
    i0.ɵɵlistener("onToggle", function MedSupCheckboxesComponent_div_1_Template_vnext_med_sup_checkbox_onToggle_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r4); const option_r2 = restoredCtx.$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.updateAnswers(option_r2.key, $event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("text", option_r2.text)("disabled", option_r2.disabled)("value", option_r2.value)("defaultSelected", option_r2.selected);
} }
function MedSupCheckboxesComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "vnext-med-sup-checkbox", 4);
    i0.ɵɵlistener("onToggle", function MedSupCheckboxesComponent_div_2_Template_vnext_med_sup_checkbox_onToggle_1_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.updateAnswers(ctx_r5.noneOfTheseApply.key, $event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("text", ctx_r1.noneOfTheseApply.text)("disabled", ctx_r1.noneOfTheseApply.disabled)("value", ctx_r1.noneOfTheseApply.value)("defaultSelected", ctx_r1.noneOfTheseApply.selected);
} }
class MedSupCheckboxesComponent {
    constructor() {
        this.disableOptionsIfNoneOfTheseApplySelected = false;
        this.disableNoneOfTheseApplyIfOptionSelected = false;
        this.required = false;
        this.onAnswersChanged = new EventEmitter();
        this.answers = {};
    }
    ngOnInit() {
        this.populatedAnswers(this.options);
    }
    updateAnswers(key, value) {
        if (key) {
            this.answers[key] = value;
            if (this.noneOfTheseApply?.key === key) {
                this.applyAdditionNoneOfTheseApplyProcesses(!!value);
            }
            else {
                this.applyAdditionalOptionsProcesses();
            }
            this.emitNewAnswers();
        }
    }
    applyAdditionNoneOfTheseApplyProcesses(isNoneOfTheseApplySelected) {
        if (this.disableOptionsIfNoneOfTheseApplySelected) {
            this.options.forEach(option => (isNoneOfTheseApplySelected ? this.disable(option) : this.enable(option)));
        }
    }
    applyAdditionalOptionsProcesses() {
        if (this.disableNoneOfTheseApplyIfOptionSelected) {
            if (this.anyOptionsSelected()) {
                this.disable(this.noneOfTheseApply);
            }
            else {
                this.enable(this.noneOfTheseApply);
            }
        }
    }
    anyOptionsSelected() {
        return this.answers && Object.values(this.getOptionAnswers()).some(value => value);
    }
    disable(option) {
        this.answers[option.key] = null;
        option.disabled = true;
        option.selected = false;
    }
    enable(option) {
        this.answers[option.key] = null;
        option.disabled = false;
        option.selected = false;
    }
    getOptionAnswers() {
        if (this.answers) {
            const optionAnswers = {};
            Object.entries(this.answers).forEach(([key, value]) => {
                if (key !== this.noneOfTheseApply?.key) {
                    optionAnswers[key] = value;
                }
            });
            return optionAnswers;
        }
        return null;
    }
    populatedAnswers(options) {
        if (options) {
            if (!this.answers) {
                this.answers = {};
            }
            options.forEach(option => {
                this.answers[option.key] = option.selected ? option.value : null;
            });
        }
    }
    emitNewAnswers() {
        this.onAnswersChanged.emit({
            value: this.answers,
            hasError: !!this.getRequiredError(),
            error: this.getRequiredError()
        });
    }
    getRequiredError() {
        return this.required && !this.hasAnswers() ? MedSupFormErrorTypes.REQUIRED : null;
    }
    hasAnswers() {
        return !!this.answers && !!Object.values(this.answers).filter(answer => answer).length;
    }
}
MedSupCheckboxesComponent.ɵfac = function MedSupCheckboxesComponent_Factory(t) { return new (t || MedSupCheckboxesComponent)(); };
MedSupCheckboxesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedSupCheckboxesComponent, selectors: [["vnext-med-sup-checkboxes"]], inputs: { options: "options", noneOfTheseApply: "noneOfTheseApply", disableOptionsIfNoneOfTheseApplySelected: "disableOptionsIfNoneOfTheseApplySelected", disableNoneOfTheseApplyIfOptionSelected: "disableNoneOfTheseApplyIfOptionSelected", required: "required" }, outputs: { onAnswersChanged: "onAnswersChanged" }, decls: 3, vars: 3, consts: [["role", "group", 1, "row"], ["class", "col-6 col-md-3 option", 4, "ngFor", "ngForOf"], ["class", "col-6 col-md-3 option", 4, "ngIf"], [1, "col-6", "col-md-3", "option"], [3, "text", "disabled", "value", "defaultSelected", "onToggle"]], template: function MedSupCheckboxesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, MedSupCheckboxesComponent_div_1_Template, 2, 4, "div", 1);
        i0.ɵɵtemplate(2, MedSupCheckboxesComponent_div_2_Template, 2, 4, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵattribute("aria-required", ctx.required);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.options);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.noneOfTheseApply);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, MedSupCheckboxComponent], styles: [".option[_ngcontent-%COMP%]{min-height:36px;margin:10px 0}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupCheckboxesComponent, [{
        type: Component,
        args: [{ selector: 'vnext-med-sup-checkboxes', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row\" role=\"group\" [attr.aria-required]=\"required\">\r\n  <div class=\"col-6 col-md-3 option\" *ngFor=\"let option of options\">\r\n    <vnext-med-sup-checkbox\r\n      [text]=\"option.text\"\r\n      [disabled]=\"option.disabled\"\r\n      [value]=\"option.value\"\r\n      [defaultSelected]=\"option.selected\"\r\n      (onToggle)=\"updateAnswers(option.key, $event)\"\r\n    ></vnext-med-sup-checkbox>\r\n  </div>\r\n  <div class=\"col-6 col-md-3 option\" *ngIf=\"noneOfTheseApply\">\r\n    <vnext-med-sup-checkbox\r\n      [text]=\"noneOfTheseApply.text\"\r\n      [disabled]=\"noneOfTheseApply.disabled\"\r\n      [value]=\"noneOfTheseApply.value\"\r\n      [defaultSelected]=\"noneOfTheseApply.selected\"\r\n      (onToggle)=\"updateAnswers(noneOfTheseApply.key, $event)\"\r\n    ></vnext-med-sup-checkbox>\r\n  </div>\r\n</div>\r\n", styles: [".option{min-height:36px;margin:10px 0}\n"] }]
    }], null, { options: [{
            type: Input
        }], noneOfTheseApply: [{
            type: Input
        }], disableOptionsIfNoneOfTheseApplySelected: [{
            type: Input
        }], disableNoneOfTheseApplyIfOptionSelected: [{
            type: Input
        }], required: [{
            type: Input
        }], onAnswersChanged: [{
            type: Output
        }] }); })();

const _c0$1m = ["medSupDropDown"];
const _c1$D = ["medSupDropDownClose"];
const _c2$q = ["medSupDropDownItems"];
const _c3$f = function (a0) { return { Spa_Style_Gray1_Background: a0 }; };
function MedSupDateDropdownComponent_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8, 9);
    i0.ɵɵlistener("click", function MedSupDateDropdownComponent_button_9_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r7); const item_r4 = restoredCtx.$implicit; const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.updateDropdownSelection(item_r4.selectionValue, true)); })("keyup", function MedSupDateDropdownComponent_button_9_Template_button_keyup_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r7); const item_r4 = restoredCtx.$implicit; const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.keyPressedOnDropdownOption($event, item_r4.selectionValue)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("id", ctx_r3.MED_SUP_DROPDOWN_ID_PREFIX + item_r4.selectionValue);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c3$f, item_r4.selectionValue === ctx_r3.selectedValue));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r4.displayValue, " ");
} }
const _c4$7 = function (a0) { return { "has-error": a0 }; };
class MedSupDateDropdownComponent {
    constructor(planFacade, cdr, localeService) {
        this.planFacade = planFacade;
        this.cdr = cdr;
        this.localeService = localeService;
        this.hasError = false;
        this.updateAnswer = new EventEmitter();
        this.activeIndex = 0;
        this.dropdownItems = [];
        this.MED_SUP_DROPDOWN_ID_PREFIX = 'MED_SUP_DROPDOWN_ID_PREFIX';
        this.MED_SUP_DROPDOWN_PREFIX = 'dropdown_';
    }
    ngOnInit() {
        this.setSelectedValueDefault();
        this.updateDropdownItems();
        this.subscriptions = [
            this.localeService.getCurrentLocale$().subscribe(() => {
                // Since getSelectedValueDisplay() is used inline in the template,
                // we call markForCheck() to force the displayed text to update (Needed when useRawValue = false)
                this.cdr.markForCheck();
            })
        ];
    }
    ngOnChanges(changes) {
        if (changes.defaultValue && !_isEqual(changes.defaultValue.previousValue, changes.defaultValue.currentValue)) {
            this.setSelectedValueDefault();
        }
        if (changes.items && !_isEqual(changes.items.previousValue, changes.items.currentValue)) {
            this.updateDropdownItems();
        }
        this.selectedValueDisplay = this.getSelectedValueDisplay();
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    getSelectedValueDisplay() {
        if (!this.selectedValue || this.selectedValue === this.noAnswerLabel) {
            return this.noAnswerLabel;
        }
        return this.selectedValue;
    }
    emitDropdownSelection($event) {
        if ($event && $event.code !== 9) {
            return;
        }
        const value = this.selectedValue === this.noAnswerLabel ? '' : this.selectedValue;
        this.updateAnswer.emit(value);
    }
    updateDropdownSelection(value, mustCloseDropdown = false) {
        this.selectedValue = value;
        this.selectedValueDisplay = this.getSelectedValueDisplay();
        this.scrollToItem(this.selectedValue);
        if (mustCloseDropdown) {
            this.medSupDropDownClose.close();
        }
        this.medSupDropDown.nativeElement.focus();
        this.emitDropdownSelection();
        this.cdr.detectChanges();
    }
    keyPressedOnDropdownOption($event, value) {
        if ($event.code === 'Space' || $event.code === 'Enter') {
            $event.preventDefault();
            this.updateDropdownSelection(value, false);
        }
    }
    scrollToItem(selectedValue) {
        const parentElement = this.medSupDropDownItems?.first?.nativeElement.parentElement;
        this.medSupDropDownItems?.forEach(dropdownItem => {
            if (dropdownItem.nativeElement.id === this.MED_SUP_DROPDOWN_ID_PREFIX + selectedValue) {
                parentElement.scroll(0, dropdownItem.nativeElement.offsetTop - 100);
            }
        });
    }
    updateDropdownItems() {
        this.dropdownId = `${this.MED_SUP_DROPDOWN_PREFIX}${this.ariaLabelledById}`;
        this.dropdownItems = this.items.map(item => ({
            displayValue: `${item}`,
            selectionValue: item
        }));
    }
    setSelectedValueDefault() {
        this.selectedValue = this.defaultValue;
    }
}
MedSupDateDropdownComponent.ɵfac = function MedSupDateDropdownComponent_Factory(t) { return new (t || MedSupDateDropdownComponent)(i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.LocaleService)); };
MedSupDateDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedSupDateDropdownComponent, selectors: [["vnext-med-sup-date-dropdown"]], viewQuery: function MedSupDateDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1m, 5);
        i0.ɵɵviewQuery(_c1$D, 5);
        i0.ɵɵviewQuery(_c2$q, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupDropDown = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupDropDownClose = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupDropDownItems = _t);
    } }, inputs: { items: "items", defaultValue: "defaultValue", noAnswerLabel: "noAnswerLabel", hasError: "hasError", ariaLabelledById: "ariaLabelledById", ariaDescribedById: "ariaDescribedById" }, outputs: { updateAnswer: "updateAnswer" }, features: [i0.ɵɵNgOnChangesFeature], decls: 10, vars: 14, consts: [["ngbDropdown", "", 3, "ngClass"], ["medSupDropDownClose", "ngbDropdown", "dropdownInstance", "ngbDropdown"], ["ngbDropdownToggle", "", "tabindex", "0", "aria-required", "true", "role", "combobox", "selectDropdownByCharacter", "", 1, "med-sup-dropdown-toggle", "w-100", 3, "id", "dropdownValues", "dropdownLastSelection", "dropdownInstance", "closeDropdownOnKeyup", "keydown", "valueSelectedByCharacter"], ["medSupDropDown", ""], [3, "ngClass"], [1, "Spa_Style_Primary_Color", "fa", "fa-angle-down", "float-right", "pl-2"], ["ngbDropdownMenu", ""], ["ngbDropdownItem", "", "tabindex", "0", 3, "id", "ngClass", "click", "keyup", 4, "ngFor", "ngForOf"], ["ngbDropdownItem", "", "tabindex", "0", 3, "id", "ngClass", "click", "keyup"], ["medSupDropDownItems", ""]], template: function MedSupDateDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0, 1)(3, "button", 2, 3);
        i0.ɵɵlistener("keydown", function MedSupDateDropdownComponent_Template_button_keydown_3_listener($event) { return ctx.emitDropdownSelection($event); })("valueSelectedByCharacter", function MedSupDateDropdownComponent_Template_button_valueSelectedByCharacter_3_listener($event) { return ctx.updateDropdownSelection($event); });
        i0.ɵɵelementStart(5, "span", 4);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(7, "i", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵtemplate(9, MedSupDateDropdownComponent_button_9_Template, 3, 5, "button", 7);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c4$7, ctx.hasError));
        i0.ɵɵadvance(3);
        i0.ɵɵpropertyInterpolate("id", ctx.dropdownId);
        i0.ɵɵproperty("dropdownValues", ctx.dropdownItems)("dropdownLastSelection", ctx.selectedValue)("dropdownInstance", _r1)("closeDropdownOnKeyup", false);
        i0.ɵɵattribute("aria-labelledby", ctx.ariaLabelledById + " " + ctx.dropdownId)("aria-describedby", ctx.ariaDescribedById ? ctx.ariaDescribedById : null);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", ctx.selectedValueDisplay !== ctx.noAnswerLabel ? "Spa_Style_Primary_Color" : "default-item-text-color");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.selectedValueDisplay, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵattribute("aria-labelledby", ctx.dropdownId);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.dropdownItems);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, SelectDropdownByCharacterDirective, IconAriaAttributesDirective, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem], styles: [".dropdown-toggle[_ngcontent-%COMP%]{line-height:18px;padding:8px 11px;box-shadow:inset 0 1px 1px #00000013;display:flex;justify-content:space-between;cursor:pointer;-webkit-user-select:none;user-select:none}.dropdown-item[_ngcontent-%COMP%]{cursor:pointer;-webkit-user-select:none;user-select:none}.dropdown-item[_ngcontent-%COMP%]:hover, .dropdown-item[_ngcontent-%COMP%]:focus, .dropdown-item[_ngcontent-%COMP%]:active{background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}.dropdown-toggle[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%]{padding-top:3px}.dropdown-toggle[_ngcontent-%COMP%]:after{content:none}.dropdown-toggle[_ngcontent-%COMP%]:focus{box-shadow:0 0 5px var(--static-Spa_Style_Black)}.dropdown-menu[_ngcontent-%COMP%]{overflow-y:scroll;max-height:300px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupDateDropdownComponent, [{
        type: Component,
        args: [{ selector: 'vnext-med-sup-date-dropdown', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div ngbDropdown #medSupDropDownClose=\"ngbDropdown\" #dropdownInstance=\"ngbDropdown\" [ngClass]=\"{ 'has-error': hasError }\">\r\n  <button\r\n    #medSupDropDown\r\n    id=\"{{ dropdownId }}\"\r\n    ngbDropdownToggle\r\n    class=\"med-sup-dropdown-toggle w-100\"\r\n    tabindex=\"0\"\r\n    (keydown)=\"emitDropdownSelection($event)\"\r\n    [attr.aria-labelledby]=\"ariaLabelledById + ' ' + dropdownId\"\r\n    [attr.aria-describedby]=\"ariaDescribedById ? ariaDescribedById : null\"\r\n    aria-required=\"true\"\r\n    role=\"combobox\"\r\n    selectDropdownByCharacter\r\n    [dropdownValues]=\"dropdownItems\"\r\n    (valueSelectedByCharacter)=\"updateDropdownSelection($event)\"\r\n    [dropdownLastSelection]=\"this.selectedValue\"\r\n    [dropdownInstance]=\"dropdownInstance\"\r\n    [closeDropdownOnKeyup]=\"false\"\r\n  >\r\n    <span [ngClass]=\"selectedValueDisplay !== noAnswerLabel ? 'Spa_Style_Primary_Color' : 'default-item-text-color'\">\r\n      {{ selectedValueDisplay }}\r\n    </span>\r\n    <i class=\"Spa_Style_Primary_Color fa fa-angle-down float-right pl-2\"></i>\r\n  </button>\r\n  <div ngbDropdownMenu [attr.aria-labelledby]=\"dropdownId\">\r\n    <button\r\n      *ngFor=\"let item of dropdownItems\"\r\n      ngbDropdownItem\r\n      #medSupDropDownItems\r\n      (click)=\"updateDropdownSelection(item.selectionValue, true)\"\r\n      tabindex=\"0\"\r\n      (keyup)=\"keyPressedOnDropdownOption($event, item.selectionValue)\"\r\n      id=\"{{ MED_SUP_DROPDOWN_ID_PREFIX + item.selectionValue }}\"\r\n      [ngClass]=\"{ Spa_Style_Gray1_Background: item.selectionValue === selectedValue }\"\r\n    >\r\n      {{ item.displayValue }}\r\n    </button>\r\n  </div>\r\n</div>\r\n", styles: [".dropdown-toggle{line-height:18px;padding:8px 11px;box-shadow:inset 0 1px 1px #00000013;display:flex;justify-content:space-between;cursor:pointer;-webkit-user-select:none;user-select:none}.dropdown-item{cursor:pointer;-webkit-user-select:none;user-select:none}.dropdown-item:hover,.dropdown-item:focus,.dropdown-item:active{background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}.dropdown-toggle>.fa{padding-top:3px}.dropdown-toggle:after{content:none}.dropdown-toggle:focus{box-shadow:0 0 5px var(--static-Spa_Style_Black)}.dropdown-menu{overflow-y:scroll;max-height:300px}\n"] }]
    }], function () { return [{ type: PlanFacade }, { type: i0.ChangeDetectorRef }, { type: i1.LocaleService }]; }, { medSupDropDown: [{
            type: ViewChild,
            args: ['medSupDropDown']
        }], medSupDropDownClose: [{
            type: ViewChild,
            args: ['medSupDropDownClose']
        }], medSupDropDownItems: [{
            type: ViewChildren,
            args: ['medSupDropDownItems']
        }], items: [{
            type: Input
        }], defaultValue: [{
            type: Input
        }], noAnswerLabel: [{
            type: Input
        }], hasError: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], updateAnswer: [{
            type: Output
        }] }); })();

const _c0$1l = ["medSupDropDown"];
const _c1$C = ["medSupDropDownClose"];
const _c2$p = ["medSupDropDownItems"];
const _c3$e = function (a0) { return { Spa_Style_Gray1_Background: a0 }; };
function MedSupDropdownComponent_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8, 9);
    i0.ɵɵlistener("click", function MedSupDropdownComponent_button_9_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r7); const item_r4 = restoredCtx.$implicit; const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.updateDropdownSelection(item_r4.selectionValue, true)); })("keyup", function MedSupDropdownComponent_button_9_Template_button_keyup_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r7); const item_r4 = restoredCtx.$implicit; const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.keyPressedOnDropdownOption($event, item_r4.selectionValue)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("id", ctx_r3.MED_SUP_DROPDOWN_ID_PREFIX + item_r4.selectionValue);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c3$e, item_r4.selectionValue === ctx_r3.selectedValue));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r4.displayValue, " ");
} }
const _c4$6 = function (a0) { return { "has-error": a0 }; };
class MedSupDropdownComponent {
    constructor(planFacade, cdr, localeService) {
        this.planFacade = planFacade;
        this.cdr = cdr;
        this.localeService = localeService;
        this.hasError = false;
        this.updateAnswer = new EventEmitter();
        this.activeIndex = 0;
        this.dropdownItems = [];
        this.MED_SUP_DROPDOWN_ID_PREFIX = 'MED_SUP_DROPDOWN_ID_PREFIX';
    }
    ngOnInit() {
        this.setSelectedValueDefault();
        this.subscriptions = [
            this.localeService.getCurrentLocale$().subscribe(() => {
                // Since getSelectedValueDisplay() is used inline in the template, we call markForCheck() to force the displayed text to update (Needed when useRawValue = false)
                this.updateDropdownItems();
                this.cdr.markForCheck();
            })
        ];
    }
    ngOnChanges(changes) {
        if (changes.defaultValue && !_isEqual(changes.defaultValue.previousValue, changes.defaultValue.currentValue)) {
            this.setSelectedValueDefault();
        }
        if (changes.question && !_isEqual(changes.question.previousValue, changes.question.currentValue)) {
            this.updateDropdownItems();
        }
        this.selectedValueDisplay = this.getSelectedValueDisplay();
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    getSelectedValueDisplay() {
        if (!this.selectedValue || this.selectedValue === this.noAnswerLabel) {
            return this.noAnswerLabel;
        }
        return this.getDropdownDisplayText(this.selectedValue);
    }
    emitDropdownSelection($event) {
        if ($event && $event.code !== 9) {
            return;
        }
        const value = this.selectedValue === this.noAnswerLabel ? '' : this.selectedValue;
        this.updateAnswer.emit({
            name: this.question.name,
            value,
            valid: typeof this.selectedValue !== 'undefined' && this.selectedValue !== null
        });
    }
    updateDropdownSelection(value, mustCloseDropdown = false) {
        this.selectedValue = value;
        this.selectedValueDisplay = this.getSelectedValueDisplay();
        this.scrollToItem(this.selectedValue);
        if (mustCloseDropdown) {
            this.medSupDropDownClose.close();
        }
        this.medSupDropDown.nativeElement.focus();
        this.emitDropdownSelection();
        this.cdr.detectChanges();
    }
    getDropdownDisplayText(value) {
        return this.useRawValue ? value : this.planFacade.getMedSupFormKey(this.question.name, value);
    }
    keyPressedOnDropdownOption($event, value) {
        if ($event.code === 'Space' || $event.code === 'Enter') {
            $event.preventDefault();
            this.updateDropdownSelection(value, false);
        }
    }
    getIndexOfSelection(value) {
        return this.question.answerList.indexOf(value);
    }
    scrollToItem(selectedValue) {
        const parentElement = this.medSupDropDownItems?.first?.nativeElement.parentElement;
        this.medSupDropDownItems?.forEach(dropdownItem => {
            if (dropdownItem.nativeElement.id === this.MED_SUP_DROPDOWN_ID_PREFIX + selectedValue) {
                parentElement.scroll(0, dropdownItem.nativeElement.offsetTop - 100);
            }
        });
    }
    updateDropdownItems() {
        this.dropdownId = `dropdown_${this.question.name}`;
        this.dropdownItems = this.question.answerList.map(answer => ({
            displayValue: this.getDropdownDisplayText(answer),
            selectionValue: answer
        }));
    }
    setSelectedValueDefault() {
        this.selectedValue = this.defaultValue;
    }
}
MedSupDropdownComponent.ɵfac = function MedSupDropdownComponent_Factory(t) { return new (t || MedSupDropdownComponent)(i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.LocaleService)); };
MedSupDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedSupDropdownComponent, selectors: [["vnext-med-sup-dropdown"]], viewQuery: function MedSupDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1l, 5);
        i0.ɵɵviewQuery(_c1$C, 5);
        i0.ɵɵviewQuery(_c2$p, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupDropDown = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupDropDownClose = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupDropDownItems = _t);
    } }, inputs: { question: "question", defaultValue: "defaultValue", noAnswerLabel: "noAnswerLabel", useRawValue: "useRawValue", hasError: "hasError", ariaLabelledById: "ariaLabelledById", ariaDescribedById: "ariaDescribedById" }, outputs: { updateAnswer: "updateAnswer" }, features: [i0.ɵɵProvidersFeature([]), i0.ɵɵNgOnChangesFeature], decls: 10, vars: 14, consts: [["ngbDropdown", "", 3, "ngClass"], ["medSupDropDownClose", "ngbDropdown", "dropdownInstance", "ngbDropdown"], ["ngbDropdownToggle", "", "tabindex", "0", "aria-required", "true", "role", "combobox", "selectDropdownByCharacter", "", 1, "med-sup-dropdown-toggle", "w-100", 3, "id", "dropdownValues", "dropdownLastSelection", "dropdownInstance", "closeDropdownOnKeyup", "keydown", "valueSelectedByCharacter"], ["medSupDropDown", ""], [3, "ngClass"], [1, "Spa_Style_Primary_Color", "fa", "fa-angle-down", "float-right", "pl-2"], ["ngbDropdownMenu", ""], ["ngbDropdownItem", "", "tabindex", "0", 3, "id", "ngClass", "click", "keyup", 4, "ngFor", "ngForOf"], ["ngbDropdownItem", "", "tabindex", "0", 3, "id", "ngClass", "click", "keyup"], ["medSupDropDownItems", ""]], template: function MedSupDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0, 1)(3, "button", 2, 3);
        i0.ɵɵlistener("keydown", function MedSupDropdownComponent_Template_button_keydown_3_listener($event) { return ctx.emitDropdownSelection($event); })("valueSelectedByCharacter", function MedSupDropdownComponent_Template_button_valueSelectedByCharacter_3_listener($event) { return ctx.updateDropdownSelection($event); });
        i0.ɵɵelementStart(5, "span", 4);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(7, "i", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵtemplate(9, MedSupDropdownComponent_button_9_Template, 3, 5, "button", 7);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c4$6, ctx.hasError));
        i0.ɵɵadvance(3);
        i0.ɵɵpropertyInterpolate("id", ctx.dropdownId);
        i0.ɵɵproperty("dropdownValues", ctx.dropdownItems)("dropdownLastSelection", ctx.selectedValue)("dropdownInstance", _r1)("closeDropdownOnKeyup", false);
        i0.ɵɵattribute("aria-labelledby", ctx.ariaLabelledById + " " + ctx.dropdownId)("aria-describedby", ctx.ariaDescribedById ? ctx.ariaDescribedById : null);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", ctx.selectedValueDisplay !== ctx.noAnswerLabel ? "Spa_Style_Primary_Color" : "default-item-text-color");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.selectedValueDisplay, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵattribute("aria-labelledby", ctx.dropdownId);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.dropdownItems);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, SelectDropdownByCharacterDirective, IconAriaAttributesDirective, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem], styles: [".dropdown-toggle[_ngcontent-%COMP%]{line-height:18px;padding:8px 11px;box-shadow:inset 0 1px 1px #00000013;display:flex;justify-content:space-between;cursor:pointer;-webkit-user-select:none;user-select:none}.dropdown-item[_ngcontent-%COMP%]{cursor:pointer;-webkit-user-select:none;user-select:none}.dropdown-item[_ngcontent-%COMP%]:hover, .dropdown-item[_ngcontent-%COMP%]:focus, .dropdown-item[_ngcontent-%COMP%]:active{background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}.dropdown-toggle[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%]{padding-top:3px}.dropdown-toggle[_ngcontent-%COMP%]:after{content:none}.dropdown-toggle[_ngcontent-%COMP%]:focus{box-shadow:0 0 5px var(--static-Spa_Style_Black)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupDropdownComponent, [{
        type: Component,
        args: [{ selector: 'vnext-med-sup-dropdown', changeDetection: ChangeDetectionStrategy.OnPush, providers: [], template: "<div ngbDropdown #medSupDropDownClose=\"ngbDropdown\" #dropdownInstance=\"ngbDropdown\" [ngClass]=\"{ 'has-error': hasError }\">\r\n  <button\r\n    #medSupDropDown\r\n    id=\"{{ dropdownId }}\"\r\n    ngbDropdownToggle\r\n    class=\"med-sup-dropdown-toggle w-100\"\r\n    tabindex=\"0\"\r\n    (keydown)=\"emitDropdownSelection($event)\"\r\n    [attr.aria-labelledby]=\"ariaLabelledById + ' ' + dropdownId\"\r\n    [attr.aria-describedby]=\"ariaDescribedById ? ariaDescribedById : null\"\r\n    aria-required=\"true\"\r\n    role=\"combobox\"\r\n    selectDropdownByCharacter\r\n    [dropdownValues]=\"dropdownItems\"\r\n    (valueSelectedByCharacter)=\"updateDropdownSelection($event)\"\r\n    [dropdownLastSelection]=\"this.selectedValue\"\r\n    [dropdownInstance]=\"dropdownInstance\"\r\n    [closeDropdownOnKeyup]=\"false\"\r\n  >\r\n    <span [ngClass]=\"selectedValueDisplay !== noAnswerLabel ? 'Spa_Style_Primary_Color' : 'default-item-text-color'\">\r\n      {{ selectedValueDisplay }}\r\n    </span>\r\n    <i class=\"Spa_Style_Primary_Color fa fa-angle-down float-right pl-2\"></i>\r\n  </button>\r\n  <div ngbDropdownMenu [attr.aria-labelledby]=\"dropdownId\">\r\n    <button\r\n      *ngFor=\"let item of dropdownItems\"\r\n      ngbDropdownItem\r\n      #medSupDropDownItems\r\n      (click)=\"updateDropdownSelection(item.selectionValue, true)\"\r\n      tabindex=\"0\"\r\n      (keyup)=\"keyPressedOnDropdownOption($event, item.selectionValue)\"\r\n      id=\"{{ MED_SUP_DROPDOWN_ID_PREFIX + item.selectionValue }}\"\r\n      [ngClass]=\"{ Spa_Style_Gray1_Background: item.selectionValue === selectedValue }\"\r\n    >\r\n      {{ item.displayValue }}\r\n    </button>\r\n  </div>\r\n</div>\r\n", styles: [".dropdown-toggle{line-height:18px;padding:8px 11px;box-shadow:inset 0 1px 1px #00000013;display:flex;justify-content:space-between;cursor:pointer;-webkit-user-select:none;user-select:none}.dropdown-item{cursor:pointer;-webkit-user-select:none;user-select:none}.dropdown-item:hover,.dropdown-item:focus,.dropdown-item:active{background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}.dropdown-toggle>.fa{padding-top:3px}.dropdown-toggle:after{content:none}.dropdown-toggle:focus{box-shadow:0 0 5px var(--static-Spa_Style_Black)}\n"] }]
    }], function () { return [{ type: PlanFacade }, { type: i0.ChangeDetectorRef }, { type: i1.LocaleService }]; }, { medSupDropDown: [{
            type: ViewChild,
            args: ['medSupDropDown']
        }], medSupDropDownClose: [{
            type: ViewChild,
            args: ['medSupDropDownClose']
        }], medSupDropDownItems: [{
            type: ViewChildren,
            args: ['medSupDropDownItems']
        }], question: [{
            type: Input
        }], defaultValue: [{
            type: Input
        }], noAnswerLabel: [{
            type: Input
        }], useRawValue: [{
            type: Input
        }], hasError: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], updateAnswer: [{
            type: Output
        }] }); })();

var DropdownType;
(function (DropdownType) {
    DropdownType["Month"] = "month";
    DropdownType["Year"] = "year";
})(DropdownType || (DropdownType = {}));
class MedSupMonthYearDropdownComponent {
    constructor(medSupFacade) {
        this.medSupFacade = medSupFacade;
        this.updatedDate = new EventEmitter();
        this.hasError = false;
        this.MED_SUP_MONTH_DROPDOWN_ID_PREFIX = 'MED_SUP_MONTH_DROPDOWN_ID_PREFIX_';
        this.MED_SUP_YEAR_DROPDOWN_ID_PREFIX = 'MED_SUP_YEAR_DROPDOWN_ID_PREFIX_';
    }
    ngOnChanges(changes) {
        const { monthRangeForPartAandPartB, defaultValue } = changes;
        if ((defaultValue && !_isEqual(defaultValue.previousValue, defaultValue.currentValue)) ||
            (monthRangeForPartAandPartB && !_isEqual(monthRangeForPartAandPartB.previousValue, monthRangeForPartAandPartB.currentValue))) {
            if (this.defaultValue) {
                this.setDefaultValue(this.defaultValue);
            }
        }
    }
    ngOnInit() {
        this.monthDropdownId = `${this.MED_SUP_MONTH_DROPDOWN_ID_PREFIX}${DropdownType.Month}`;
        this.yearDropdownId = `${this.MED_SUP_YEAR_DROPDOWN_ID_PREFIX}${DropdownType.Year}`;
    }
    setDefaultValue(defaultValue) {
        const defaultDate = new Date(defaultValue);
        this.selectedMonth = this.monthRangeForPartAandPartB[defaultDate.getMonth()];
        this.selectedYear = defaultDate.getFullYear();
    }
    setSelectedYear(value) {
        this.selectedYear = value;
        this.monthRangeForPartAandPartB = this.medSupFacade.getRangeMonthList(this.monthYearRangePartAandPartB, value);
        this.updateDate();
    }
    setSelectedMonth(value) {
        this.selectedMonth = value;
        this.updateDate();
    }
    updateDate() {
        if (this.selectedMonth && this.selectedYear) {
            let selectedDate = `${DateUtilities.getIndexMonth(this.selectedMonth, this.locale)}/01/${this.selectedYear}`;
            selectedDate = DateUtilities.getFormattedDateTime(new Date(selectedDate), DateUtilities.defaultFormat, this.locale);
            this.updatedDate.emit(selectedDate);
        }
    }
}
MedSupMonthYearDropdownComponent.ɵfac = function MedSupMonthYearDropdownComponent_Factory(t) { return new (t || MedSupMonthYearDropdownComponent)(i0.ɵɵdirectiveInject(MedSupFacade)); };
MedSupMonthYearDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedSupMonthYearDropdownComponent, selectors: [["med-sup-month-year-dropdown"]], inputs: { defaultValue: "defaultValue", hasError: "hasError", monthRangeForPartAandPartB: "monthRangeForPartAandPartB", yearRangeForPartAandPartB: "yearRangeForPartAandPartB", monthYearRangePartAandPartB: "monthYearRangePartAandPartB", maxFutureMonths: "maxFutureMonths", maxPastMonths: "maxPastMonths", selectMonthText: "selectMonthText", selectYearText: "selectYearText", locale: "locale" }, outputs: { updatedDate: "updatedDate" }, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 12, consts: [[1, "d-inline-block", "pr-1"], [3, "items", "defaultValue", "noAnswerLabel", "hasError", "ariaLabelledById", "ariaDescribedById", "updateAnswer"], ["medSupMonthDropDown", ""], [1, "d-inline-block"]], template: function MedSupMonthYearDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵelementStart(1, "div", 0)(2, "vnext-med-sup-date-dropdown", 1, 2);
        i0.ɵɵlistener("updateAnswer", function MedSupMonthYearDropdownComponent_Template_vnext_med_sup_date_dropdown_updateAnswer_2_listener($event) { return ctx.setSelectedMonth($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 3)(5, "vnext-med-sup-date-dropdown", 1, 2);
        i0.ɵɵlistener("updateAnswer", function MedSupMonthYearDropdownComponent_Template_vnext_med_sup_date_dropdown_updateAnswer_5_listener($event) { return ctx.setSelectedYear($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("items", ctx.monthRangeForPartAandPartB)("defaultValue", ctx.selectedMonth)("noAnswerLabel", ctx.selectMonthText)("hasError", ctx.hasError)("ariaLabelledById", ctx.monthDropdownId)("ariaDescribedById", ctx.monthDropdownId);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("items", ctx.yearRangeForPartAandPartB)("defaultValue", ctx.selectedYear)("noAnswerLabel", ctx.selectYearText)("hasError", ctx.hasError)("ariaLabelledById", ctx.yearDropdownId)("ariaDescribedById", ctx.yearDropdownId);
    } }, dependencies: [MedSupDateDropdownComponent], styles: [".year-dropdown[_ngcontent-%COMP%]{max-height:300px;overflow-y:auto}.dropdown-item[_ngcontent-%COMP%]:active{background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}@media (max-width: 575px){.year-toggle[_ngcontent-%COMP%]{margin-top:10px}.month-toggle[_ngcontent-%COMP%]{margin-right:15px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupMonthYearDropdownComponent, [{
        type: Component,
        args: [{ selector: 'med-sup-month-year-dropdown', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container>\r\n  <div class=\"d-inline-block pr-1\">\r\n    <vnext-med-sup-date-dropdown\r\n      #medSupMonthDropDown\r\n      (updateAnswer)=\"setSelectedMonth($event)\"\r\n      [items]=\"monthRangeForPartAandPartB\"\r\n      [defaultValue]=\"selectedMonth\"\r\n      [noAnswerLabel]=\"selectMonthText\"\r\n      [hasError]=\"hasError\"\r\n      [ariaLabelledById]=\"monthDropdownId\"\r\n      [ariaDescribedById]=\"monthDropdownId\"\r\n    ></vnext-med-sup-date-dropdown>\r\n  </div>\r\n  <div class=\"d-inline-block\">  \r\n    <vnext-med-sup-date-dropdown\r\n      #medSupMonthDropDown\r\n      (updateAnswer)=\"setSelectedYear($event)\"\r\n      [items]=\"yearRangeForPartAandPartB\"\r\n      [defaultValue]=\"selectedYear\"\r\n      [noAnswerLabel]=\"selectYearText\"\r\n      [hasError]=\"hasError\"\r\n      [ariaLabelledById]=\"yearDropdownId\"\r\n      [ariaDescribedById]=\"yearDropdownId\"\r\n    ></vnext-med-sup-date-dropdown>\r\n  </div>\r\n</ng-container>\r\n", styles: [".year-dropdown{max-height:300px;overflow-y:auto}.dropdown-item:active{background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}@media (max-width: 575px){.year-toggle{margin-top:10px}.month-toggle{margin-right:15px}}\n"] }]
    }], function () { return [{ type: MedSupFacade }]; }, { updatedDate: [{
            type: Output
        }], defaultValue: [{
            type: Input
        }], hasError: [{
            type: Input
        }], monthRangeForPartAandPartB: [{
            type: Input
        }], yearRangeForPartAandPartB: [{
            type: Input
        }], monthYearRangePartAandPartB: [{
            type: Input
        }], maxFutureMonths: [{
            type: Input
        }], maxPastMonths: [{
            type: Input
        }], selectMonthText: [{
            type: Input
        }], selectYearText: [{
            type: Input
        }], locale: [{
            type: Input
        }] }); })();

const _c0$1k = ["medSupDateA"];
function MedSupEffectiveDateAComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function MedSupEffectiveDateAComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-date", 3, 4);
    i0.ɵɵlistener("sendDate", function MedSupEffectiveDateAComponent_ng_template_1_Template_vnext_med_sup_date_sendDate_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.getDate($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("defaultValue", ctx_r2.defaultValue)("showDatePicker", ctx_r2.showDatePicker)("hasError", ctx_r2.hasError)("datePickerButtonLabelText", ctx_r2.datePickerButtonLabelText)("ariaDescribedById", ctx_r2.ariaDescribedById)("ariaLabelledById", ctx_r2.ariaLabelledById);
} }
function MedSupEffectiveDateAComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "med-sup-month-year-dropdown", 5);
    i0.ɵɵlistener("updatedDate", function MedSupEffectiveDateAComponent_ng_template_3_Template_med_sup_month_year_dropdown_updatedDate_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.selectDate($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("maxFutureMonths", ctx_r4.maxFutureMonths)("maxPastMonths", ctx_r4.maxPastMonths)("monthYearRangePartAandPartB", ctx_r4.monthYearRangePartA)("defaultValue", ctx_r4.defaultValue)("selectMonthText", ctx_r4.selectMonthText)("selectYearText", ctx_r4.selectYearText)("hasError", ctx_r4.hasError)("monthRangeForPartAandPartB", ctx_r4.monthRangeForPartAandPartB)("yearRangeForPartAandPartB", ctx_r4.yearRangeForPartAandPartB)("locale", ctx_r4.locale);
} }
class MedSupEffectiveDateAComponent {
    constructor(resourceService, medSupFacade) {
        this.resourceService = resourceService;
        this.medSupFacade = medSupFacade;
        this.hasError = false;
        this.updateAnswer = new EventEmitter();
        this.priorOrAfterDateValidationEnabled = true;
    }
    getName() {
        return 'PartAEffectiveDate';
    }
    focus() {
        this.medSupDateA?.medSupDate.nativeElement.focus();
    }
    ngOnChanges(changes) {
        const dateOfBirth = changes.dateOfBirth;
        if (dateOfBirth &&
            !dateOfBirth.firstChange &&
            dateOfBirth.currentValue !== dateOfBirth.previousValue &&
            this.medSupDate &&
            this.medSupDate.dirty) {
            this.getDate(this.medSupDate.value);
        }
    }
    ngOnInit() {
        const showDatePickerResource = this.resourceService.getProcessedResourceValue('Spa_MedSupForm_ShowEffectiveDateAInputDatePicker_Flag');
        this.priorOrAfterDateValidationEnabled = this.resourceService.getProcessedResourceValue('Spa_MedSupForm_PartAandBEffectiveDateValidation_Enabled', null, true);
        this.showDatePicker = showDatePickerResource === null ? true : showDatePickerResource;
        this.maxFutureMonths = this.medSupFacade.getPartAEffectiveMaxFutureMonths();
        this.maxPastMonths = this.medSupFacade.getPartAEffectiveMaxPastMonths();
    }
    selectDate(selectedDate) {
        this.getDate(selectedDate);
    }
    getDate(date) {
        const error = this.checkError(date);
        this.updateAnswer.emit({ name: this.question.name, value: date, valid: !error, error });
    }
    checkError(date = this.medSupDate?.value) {
        return this.medSupFacade.checkError(date, this.dateOfBirth, this.maxFutureMonths, this.maxPastMonths, this.priorOrAfterDateValidationEnabled, null, this.partBEffectiveDate);
    }
}
MedSupEffectiveDateAComponent.ɵfac = function MedSupEffectiveDateAComponent_Factory(t) { return new (t || MedSupEffectiveDateAComponent)(i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(MedSupFacade)); };
MedSupEffectiveDateAComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedSupEffectiveDateAComponent, selectors: [["vnext-med-sup-effective-date-a"]], viewQuery: function MedSupEffectiveDateAComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1k, 5);
        i0.ɵɵviewQuery(MedSupDateComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupDateA = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupDate = _t.first);
    } }, inputs: { question: "question", defaultValue: "defaultValue", selectMonthText: "selectMonthText", selectYearText: "selectYearText", dateOfBirth: "dateOfBirth", partBEffectiveDate: "partBEffectiveDate", hasError: "hasError", ariaDescribedById: "ariaDescribedById", ariaLabelledById: "ariaLabelledById", datePickerButtonLabelText: "datePickerButtonLabelText", dropdownEnabledPartA: "dropdownEnabledPartA", monthRangeForPartAandPartB: "monthRangeForPartAandPartB", yearRangeForPartAandPartB: "yearRangeForPartAandPartB", monthYearRangePartA: "monthYearRangePartA", locale: "locale" }, outputs: { updateAnswer: "updateAnswer" }, features: [i0.ɵɵNgOnChangesFeature], decls: 5, vars: 3, consts: [[4, "ngIf", "ngIfThen", "ngIfElse"], ["dateField", ""], ["dropdown", ""], ["errorMessage", "displayError", 3, "defaultValue", "showDatePicker", "hasError", "datePickerButtonLabelText", "ariaDescribedById", "ariaLabelledById", "sendDate"], ["medSupDateA", ""], [3, "maxFutureMonths", "maxPastMonths", "monthYearRangePartAandPartB", "defaultValue", "selectMonthText", "selectYearText", "hasError", "monthRangeForPartAandPartB", "yearRangeForPartAandPartB", "locale", "updatedDate"]], template: function MedSupEffectiveDateAComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MedSupEffectiveDateAComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        i0.ɵɵtemplate(1, MedSupEffectiveDateAComponent_ng_template_1_Template, 2, 6, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(3, MedSupEffectiveDateAComponent_ng_template_3_Template, 1, 10, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        const _r3 = i0.ɵɵreference(4);
        i0.ɵɵproperty("ngIf", ctx.dropdownEnabledPartA)("ngIfThen", _r3)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgIf, MedSupMonthYearDropdownComponent, MedSupDateComponent], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupEffectiveDateAComponent, [{
        type: Component,
        args: [{ selector: 'vnext-med-sup-effective-date-a', template: "<ng-container *ngIf=\"dropdownEnabledPartA; then dropdown; else dateField\"></ng-container>\r\n<ng-template #dateField>\r\n  <vnext-med-sup-date\r\n    #medSupDateA\r\n    (sendDate)=\"getDate($event)\"\r\n    [defaultValue]=\"defaultValue\"\r\n    errorMessage=\"displayError\"\r\n    [showDatePicker]=\"showDatePicker\"\r\n    [hasError]=\"hasError\"\r\n    [datePickerButtonLabelText]=\"datePickerButtonLabelText\"\r\n    [ariaDescribedById]=\"ariaDescribedById\"\r\n    [ariaLabelledById]=\"ariaLabelledById\"\r\n  ></vnext-med-sup-date>\r\n</ng-template>\r\n\r\n<ng-template #dropdown>\r\n  <med-sup-month-year-dropdown\r\n    (updatedDate)=\"selectDate($event)\"\r\n    [maxFutureMonths]=\"maxFutureMonths\"\r\n    [maxPastMonths]=\"maxPastMonths\"\r\n    [monthYearRangePartAandPartB]=\"monthYearRangePartA\"\r\n    [defaultValue]=\"defaultValue\"\r\n    [selectMonthText]=\"selectMonthText\"\r\n    [selectYearText]=\"selectYearText\"\r\n    [hasError]=\"hasError\"\r\n    [monthRangeForPartAandPartB]=\"monthRangeForPartAandPartB\"\r\n    [yearRangeForPartAandPartB]=\"yearRangeForPartAandPartB\"\r\n    [locale]=\"locale\"\r\n  >\r\n  </med-sup-month-year-dropdown>\r\n</ng-template>\r\n" }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: MedSupFacade }]; }, { medSupDateA: [{
            type: ViewChild,
            args: ['medSupDateA']
        }], question: [{
            type: Input
        }], defaultValue: [{
            type: Input
        }], selectMonthText: [{
            type: Input
        }], selectYearText: [{
            type: Input
        }], dateOfBirth: [{
            type: Input
        }], partBEffectiveDate: [{
            type: Input
        }], hasError: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], datePickerButtonLabelText: [{
            type: Input
        }], dropdownEnabledPartA: [{
            type: Input
        }], monthRangeForPartAandPartB: [{
            type: Input
        }], yearRangeForPartAandPartB: [{
            type: Input
        }], monthYearRangePartA: [{
            type: Input
        }], locale: [{
            type: Input
        }], updateAnswer: [{
            type: Output
        }], medSupDate: [{
            type: ViewChild,
            args: [MedSupDateComponent]
        }] }); })();

const _c0$1j = ["medSupDateB"];
function MedSupEffectiveDateBComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function MedSupEffectiveDateBComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-date", 3, 4);
    i0.ɵɵlistener("sendDate", function MedSupEffectiveDateBComponent_ng_template_1_Template_vnext_med_sup_date_sendDate_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.getDate($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("defaultValue", ctx_r2.defaultValue)("showDatePicker", ctx_r2.showDatePicker)("hasError", ctx_r2.hasError)("datePickerButtonLabelText", ctx_r2.datePickerButtonLabelText)("ariaDescribedById", ctx_r2.ariaDescribedById)("ariaLabelledById", ctx_r2.ariaLabelledById);
} }
function MedSupEffectiveDateBComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "med-sup-month-year-dropdown", 5);
    i0.ɵɵlistener("updatedDate", function MedSupEffectiveDateBComponent_ng_template_3_Template_med_sup_month_year_dropdown_updatedDate_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.selectDate($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("maxFutureMonths", ctx_r4.maxFutureMonths)("maxPastMonths", ctx_r4.maxPastMonths)("monthYearRangePartAandPartB", ctx_r4.monthYearRangePartB)("defaultValue", ctx_r4.defaultValue)("selectMonthText", ctx_r4.selectMonthText)("selectYearText", ctx_r4.selectYearText)("hasError", ctx_r4.hasError)("monthRangeForPartAandPartB", ctx_r4.monthRangeForPartAandPartB)("yearRangeForPartAandPartB", ctx_r4.yearRangeForPartAandPartB)("locale", ctx_r4.locale);
} }
class MedSupEffectiveDateBComponent {
    constructor(resourceService, medSupFacade) {
        this.resourceService = resourceService;
        this.medSupFacade = medSupFacade;
        this.hasError = false;
        this.updateAnswer = new EventEmitter();
        this.priorOrAfterDateValidationEnabled = true;
    }
    getName() {
        return 'PartBEffectiveDate';
    }
    focus() {
        this.medSupDateB?.medSupDate.nativeElement.focus();
    }
    ngOnChanges(changes) {
        const dateOfBirth = changes.dateOfBirth;
        if (dateOfBirth &&
            !dateOfBirth.firstChange &&
            dateOfBirth.currentValue !== dateOfBirth.previousValue &&
            this.medSupDate &&
            this.medSupDate.dirty) {
            this.getDate(this.medSupDate.value);
        }
    }
    ngOnInit() {
        const showDatePickerResource = this.resourceService.getProcessedResourceValue('Spa_MedSupForm_ShowEffectiveDateBInputDatePicker_Flag');
        this.priorOrAfterDateValidationEnabled = this.resourceService.getProcessedResourceValue('Spa_MedSupForm_PartAandBEffectiveDateValidation_Enabled', null, true);
        this.showDatePicker = showDatePickerResource === null ? true : showDatePickerResource;
        this.maxFutureMonths = this.medSupFacade.getPartBEffectiveMaxFutureMonths();
        this.maxPastMonths = this.medSupFacade.getPartBEffectiveMaxPastMonths();
    }
    selectDate(selectedDate) {
        this.getDate(selectedDate);
    }
    getDate(date) {
        const error = this.checkError(date);
        this.updateAnswer.emit({ name: this.question.name, value: date, valid: !error, error });
    }
    checkError(date = this.medSupDate?.value) {
        return this.medSupFacade.checkError(date, this.dateOfBirth, this.maxFutureMonths, this.maxPastMonths, this.priorOrAfterDateValidationEnabled, this.partAEffectiveDate);
    }
}
MedSupEffectiveDateBComponent.ɵfac = function MedSupEffectiveDateBComponent_Factory(t) { return new (t || MedSupEffectiveDateBComponent)(i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(MedSupFacade)); };
MedSupEffectiveDateBComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedSupEffectiveDateBComponent, selectors: [["vnext-med-sup-effective-date-b"]], viewQuery: function MedSupEffectiveDateBComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1j, 5);
        i0.ɵɵviewQuery(MedSupDateComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupDateB = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupDate = _t.first);
    } }, inputs: { question: "question", defaultValue: "defaultValue", selectMonthText: "selectMonthText", selectYearText: "selectYearText", dateOfBirth: "dateOfBirth", partAEffectiveDate: "partAEffectiveDate", hasError: "hasError", ariaDescribedById: "ariaDescribedById", ariaLabelledById: "ariaLabelledById", datePickerButtonLabelText: "datePickerButtonLabelText", dropdownEnabledPartB: "dropdownEnabledPartB", monthRangeForPartAandPartB: "monthRangeForPartAandPartB", yearRangeForPartAandPartB: "yearRangeForPartAandPartB", monthYearRangePartB: "monthYearRangePartB", locale: "locale" }, outputs: { updateAnswer: "updateAnswer" }, features: [i0.ɵɵNgOnChangesFeature], decls: 5, vars: 3, consts: [[4, "ngIf", "ngIfThen", "ngIfElse"], ["dateField", ""], ["dropdown", ""], ["errorMessage", "displayError", 3, "defaultValue", "showDatePicker", "hasError", "datePickerButtonLabelText", "ariaDescribedById", "ariaLabelledById", "sendDate"], ["medSupDateB", ""], [3, "maxFutureMonths", "maxPastMonths", "monthYearRangePartAandPartB", "defaultValue", "selectMonthText", "selectYearText", "hasError", "monthRangeForPartAandPartB", "yearRangeForPartAandPartB", "locale", "updatedDate"]], template: function MedSupEffectiveDateBComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MedSupEffectiveDateBComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        i0.ɵɵtemplate(1, MedSupEffectiveDateBComponent_ng_template_1_Template, 2, 6, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(3, MedSupEffectiveDateBComponent_ng_template_3_Template, 1, 10, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        const _r3 = i0.ɵɵreference(4);
        i0.ɵɵproperty("ngIf", ctx.dropdownEnabledPartB)("ngIfThen", _r3)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgIf, MedSupMonthYearDropdownComponent, MedSupDateComponent], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupEffectiveDateBComponent, [{
        type: Component,
        args: [{ selector: 'vnext-med-sup-effective-date-b', template: "<ng-container *ngIf=\"dropdownEnabledPartB; then dropdown; else dateField\"></ng-container>\r\n<ng-template #dateField>\r\n  <vnext-med-sup-date\r\n    #medSupDateB\r\n    (sendDate)=\"getDate($event)\"\r\n    [defaultValue]=\"defaultValue\"\r\n    errorMessage=\"displayError\"\r\n    [showDatePicker]=\"showDatePicker\"\r\n    [hasError]=\"hasError\"\r\n    [datePickerButtonLabelText]=\"datePickerButtonLabelText\"\r\n    [ariaDescribedById]=\"ariaDescribedById\"\r\n    [ariaLabelledById]=\"ariaLabelledById\"\r\n  ></vnext-med-sup-date>\r\n</ng-template>\r\n\r\n<ng-template #dropdown>\r\n  <med-sup-month-year-dropdown\r\n    (updatedDate)=\"selectDate($event)\"\r\n    [maxFutureMonths]=\"maxFutureMonths\"\r\n    [maxPastMonths]=\"maxPastMonths\"\r\n    [monthYearRangePartAandPartB]=\"monthYearRangePartB\"\r\n    [defaultValue]=\"defaultValue\"\r\n    [selectMonthText]=\"selectMonthText\"\r\n    [selectYearText]=\"selectYearText\"\r\n    [hasError]=\"hasError\"\r\n    [monthRangeForPartAandPartB]=\"monthRangeForPartAandPartB\"\r\n    [yearRangeForPartAandPartB]=\"yearRangeForPartAandPartB\"\r\n    [locale]=\"locale\"\r\n  >\r\n  </med-sup-month-year-dropdown>\r\n</ng-template>\r\n" }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: MedSupFacade }]; }, { medSupDateB: [{
            type: ViewChild,
            args: ['medSupDateB']
        }], question: [{
            type: Input
        }], defaultValue: [{
            type: Input
        }], selectMonthText: [{
            type: Input
        }], selectYearText: [{
            type: Input
        }], dateOfBirth: [{
            type: Input
        }], partAEffectiveDate: [{
            type: Input
        }], hasError: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], datePickerButtonLabelText: [{
            type: Input
        }], dropdownEnabledPartB: [{
            type: Input
        }], monthRangeForPartAandPartB: [{
            type: Input
        }], yearRangeForPartAandPartB: [{
            type: Input
        }], monthYearRangePartB: [{
            type: Input
        }], locale: [{
            type: Input
        }], updateAnswer: [{
            type: Output
        }], medSupDate: [{
            type: ViewChild,
            args: [MedSupDateComponent]
        }] }); })();

const _c0$1i = ["medSupEffectiveDate"];
const _c1$B = ["medSupEffectiveDateDropDown"];
function MedSupEffectiveDateComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function MedSupEffectiveDateComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-date", 3, 4);
    i0.ɵɵlistener("sendDate", function MedSupEffectiveDateComponent_ng_template_1_Template_vnext_med_sup_date_sendDate_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.getAnswerFromDateField($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("defaultValue", ctx_r2.defaultValue)("showDatePicker", ctx_r2.showDatePicker)("datePickerMinDate", ctx_r2.minDate)("datePickerMaxDate", ctx_r2.maxDate)("hasError", ctx_r2.hasError)("datePickerButtonLabelText", ctx_r2.datePickerButtonLabelText)("ariaDescribedById", ctx_r2.ariaDescribedById)("ariaLabelledById", ctx_r2.ariaLabelledById);
} }
function MedSupEffectiveDateComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-dropdown", 5, 6);
    i0.ɵɵlistener("updateAnswer", function MedSupEffectiveDateComponent_ng_template_3_Template_vnext_med_sup_dropdown_updateAnswer_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.getAnswerFromDropdown($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("question", ctx_r4.modifiedQuestion)("defaultValue", ctx_r4.defaultValue)("noAnswerLabel", ctx_r4.noAnswerLabel)("useRawValue", true)("hasError", ctx_r4.hasError)("ariaLabelledById", ctx_r4.ariaLabelledById)("ariaDescribedById", ctx_r4.ariaDescribedById);
} }
class MedSupEffectiveDateComponent {
    constructor(configResourceService, localeService, cdr, dateService) {
        this.configResourceService = configResourceService;
        this.localeService = localeService;
        this.cdr = cdr;
        this.dateService = dateService;
        this.updateAnswer = new EventEmitter();
        this.hasError = 'false';
        this.displayFormat = 'MMMM YYYY';
        this.value = '';
        this.defaultMaxMonthsInFuture = 12;
    }
    getName() {
        return 'EffectiveDate';
    }
    focus() {
        if (this.showAsDropdown) {
            this.medSupEffectiveDateDropDown.medSupDropDown.nativeElement.focus();
        }
        else {
            this.medSupEffectiveDate.medSupDate.nativeElement.focus();
        }
    }
    ngOnInit() {
        this.showAsDropdown = this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_ShowEffectiveDateAsDropdown_Flag', null, true);
        let showCurrentMonth = this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_ShowCurrentMonthInEffectiveDateDropdown_Flag');
        if (showCurrentMonth === null) {
            showCurrentMonth = true;
        }
        const numMonths = Math.min(this.defaultMaxMonthsInFuture, parseInt(this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_EffectiveDateNumberOfMonths_Count') ||
            this.defaultMaxMonthsInFuture, 10));
        if (this.showAsDropdown) {
            const listOfMonths = DateUtilities.getFirstOfFutureMonths(numMonths + 1);
            if (!showCurrentMonth) {
                listOfMonths.shift();
            }
            this.optionsListAsDates = listOfMonths;
        }
        else {
            const showDatePickerResource = this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_ShowEffectiveDateInputDatePicker_Flag');
            this.showDatePicker = showDatePickerResource === null ? true : showDatePickerResource;
            this.minDate = this.getMinDate(showCurrentMonth);
            this.maxDate = this.getMaxDate(numMonths);
            this.defaultValue = this.getValidMedSupEffectiveDate(this.defaultValue);
        }
        this.subscriptions = [
            this.localeService.getCurrentLocale$().subscribe(locale => {
                this.locale = locale;
                if (this.showAsDropdown) {
                    if (this.defaultValue) {
                        this.defaultValue = DateUtilities.getFormattedDate(new Date(this.defaultValue), this.displayFormat, this.locale);
                        const currentDate = DateUtilities.getFormattedDate(undefined, this.displayFormat);
                        // check if default date has a difference of 1 more months from current it assign empty value
                        if (DateUtilities.getMonthsDifference(this.defaultValue, currentDate) >= 1) {
                            this.defaultValue = '';
                        }
                    }
                    this.optionsListAsFormattedString = this.optionsListAsDates.map(date => DateUtilities.getFormattedDateTime(date, this.displayFormat, this.locale));
                    this.modifiedQuestion = {
                        ...this.question,
                        answerList: this.optionsListAsFormattedString
                    };
                }
                this.cdr.markForCheck();
            })
        ];
    }
    getValidMedSupEffectiveDate(medSupEffectiveDate) {
        return this.dateService.isValidMedSupEffectiveDate(medSupEffectiveDate) ? medSupEffectiveDate : '';
    }
    getAnswerFromDropdown(emittedData) {
        if (emittedData.value === '') {
            this.updateAnswer.emit({
                name: this.question.name,
                value: emittedData.value,
                valid: false
            });
        }
        else {
            const date = new Date(this.optionsListAsDates[this.optionsListAsFormattedString.findIndex(option => option === emittedData.value)]);
            const formattedDate = DateUtilities.getFormattedDate(date, undefined, this.locale);
            this.updateAnswer.emit({
                name: this.question.name,
                value: formattedDate,
                valid: true
            });
        }
    }
    getAnswerFromDateField(date) {
        let error;
        if (date === '' || !DateUtilities.isValidDate(date)) {
            error = MedSupFormErrorTypes.INVALID;
        }
        else if (this.maxDate && DateUtilities.dateAfter(date, new Date(this.maxDate.year, this.maxDate.month - 1, this.maxDate.day))) {
            error = MedSupFormErrorTypes.FUTURE_DATE;
        }
        else if (this.minDate && DateUtilities.dateBefore(date, new Date(this.minDate.year, this.minDate.month - 1, this.minDate.day))) {
            error = MedSupFormErrorTypes.PAST_DATE;
        }
        this.updateAnswer.emit({
            name: this.question.name,
            value: date,
            valid: !error,
            error
        });
    }
    getMinDate(showCurrentMonth) {
        const current = new Date();
        let startMonth = current.getMonth();
        let startYear = current.getFullYear();
        if (!showCurrentMonth) {
            startMonth++;
            if (startMonth === 12) {
                startMonth = 0;
                startYear++;
            }
        }
        return {
            year: startYear,
            month: startMonth + 1,
            day: 1
        };
    }
    getMaxDate(numMonths) {
        const current = new Date();
        let endMonth = current.getMonth() + numMonths;
        let endYear = current.getFullYear();
        if (endMonth >= 12) {
            endMonth = endMonth % 12;
            endYear++;
        }
        return {
            year: endYear,
            month: endMonth + 1,
            day: new Date(endYear, endMonth + 1, 0).getDate()
        };
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
MedSupEffectiveDateComponent.ɵfac = function MedSupEffectiveDateComponent_Factory(t) { return new (t || MedSupEffectiveDateComponent)(i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.DateService)); };
MedSupEffectiveDateComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedSupEffectiveDateComponent, selectors: [["vnext-med-sup-effective-date"]], viewQuery: function MedSupEffectiveDateComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1i, 5);
        i0.ɵɵviewQuery(_c1$B, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupEffectiveDate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupEffectiveDateDropDown = _t.first);
    } }, inputs: { question: "question", defaultValue: "defaultValue", noAnswerLabel: "noAnswerLabel", hasError: "hasError", ariaLabelledById: "ariaLabelledById", ariaDescribedById: "ariaDescribedById", datePickerButtonLabelText: "datePickerButtonLabelText", effectiveDateMessage: "effectiveDateMessage", displayFormat: "displayFormat" }, outputs: { updateAnswer: "updateAnswer" }, decls: 5, vars: 3, consts: [[4, "ngIf", "ngIfThen", "ngIfElse"], ["dateField", ""], ["dropdown", ""], [3, "defaultValue", "showDatePicker", "datePickerMinDate", "datePickerMaxDate", "hasError", "datePickerButtonLabelText", "ariaDescribedById", "ariaLabelledById", "sendDate"], ["medSupEffectiveDate", ""], [3, "question", "defaultValue", "noAnswerLabel", "useRawValue", "hasError", "ariaLabelledById", "ariaDescribedById", "updateAnswer"], ["medSupEffectiveDateDropDown", ""]], template: function MedSupEffectiveDateComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MedSupEffectiveDateComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        i0.ɵɵtemplate(1, MedSupEffectiveDateComponent_ng_template_1_Template, 2, 8, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(3, MedSupEffectiveDateComponent_ng_template_3_Template, 2, 7, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        const _r3 = i0.ɵɵreference(4);
        i0.ɵɵproperty("ngIf", ctx.showAsDropdown)("ngIfThen", _r3)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgIf, MedSupDropdownComponent, MedSupDateComponent], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupEffectiveDateComponent, [{
        type: Component,
        args: [{ selector: 'vnext-med-sup-effective-date', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"showAsDropdown; then dropdown; else dateField\"></ng-container>\r\n<ng-template #dateField>\r\n  <vnext-med-sup-date\r\n    #medSupEffectiveDate\r\n    (sendDate)=\"getAnswerFromDateField($event)\"\r\n    [defaultValue]=\"defaultValue\"\r\n    [showDatePicker]=\"showDatePicker\"\r\n    [datePickerMinDate]=\"minDate\"\r\n    [datePickerMaxDate]=\"maxDate\"\r\n    [hasError]=\"hasError\"\r\n    [datePickerButtonLabelText]=\"datePickerButtonLabelText\"\r\n    [ariaDescribedById]=\"ariaDescribedById\"\r\n    [ariaLabelledById]=\"ariaLabelledById\"\r\n  ></vnext-med-sup-date>\r\n</ng-template>\r\n<ng-template #dropdown>\r\n  <vnext-med-sup-dropdown\r\n    #medSupEffectiveDateDropDown\r\n    (updateAnswer)=\"getAnswerFromDropdown($event)\"\r\n    [question]=\"modifiedQuestion\"\r\n    [defaultValue]=\"defaultValue\"\r\n    [noAnswerLabel]=\"noAnswerLabel\"\r\n    [useRawValue]=\"true\"\r\n    [hasError]=\"hasError\"\r\n    [ariaLabelledById]=\"ariaLabelledById\"\r\n    [ariaDescribedById]=\"ariaDescribedById\"\r\n  ></vnext-med-sup-dropdown>\r\n</ng-template>\r\n" }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: i1.LocaleService }, { type: i0.ChangeDetectorRef }, { type: i1.DateService }]; }, { medSupEffectiveDate: [{
            type: ViewChild,
            args: ['medSupEffectiveDate']
        }], medSupEffectiveDateDropDown: [{
            type: ViewChild,
            args: ['medSupEffectiveDateDropDown']
        }], question: [{
            type: Input
        }], updateAnswer: [{
            type: Output
        }], defaultValue: [{
            type: Input
        }], noAnswerLabel: [{
            type: Input
        }], hasError: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], datePickerButtonLabelText: [{
            type: Input
        }], effectiveDateMessage: [{
            type: Input
        }], displayFormat: [{
            type: Input
        }] }); })();

const _c0$1h = ["medSupHeightFoot"];
const _c1$A = ["medSupHeightInch"];
const _c2$o = function (a0) { return { "has-error": a0 }; };
class MedSupHeightComponent {
    constructor() {
        this.hasError = false;
        this.updateAnswer = new EventEmitter();
        this.footValue = '';
        this.inchValue = '';
    }
    getName() {
        return 'Height';
    }
    focus() {
        if (!this.medSupHeightFoot.nativeElement.value) {
            this.medSupHeightFoot.nativeElement.focus();
        }
        else if (this.medSupHeightFoot.nativeElement.value && !this.medSupHeightInch.nativeElement.value) {
            this.medSupHeightInch.nativeElement.focus();
        }
    }
    ngOnInit() {
        this.medSupHeightInchControl = new UntypedFormControl();
        if (!this.defaultValue) {
            this.footValue = '';
            this.inchValue = '';
        }
        else {
            this.footValue = Math.floor(this.defaultValue / 12).toString();
            this.inchValue = (this.defaultValue - this.parseValue(this.footValue) * 12).toString();
        }
    }
    emitAnswer() {
        if (this.medSupHeightInchControl.touched) {
            this.updateAnswer.emit({
                name: this.question.name,
                value: this.parseValue(this.footValue) * 12 + this.parseValue(this.inchValue),
                valid: this.validate()
            });
        }
    }
    parseValue(value) {
        if (value === '') {
            return 0;
        }
        return parseInt(value, 10);
    }
    validate() {
        if (this.medSupHeightInchControl.touched) {
            return !!this.footValue && !!this.inchValue;
        }
    }
    markInchControlTouched() {
        this.medSupHeightInchControl.markAsTouched();
    }
}
MedSupHeightComponent.ɵfac = function MedSupHeightComponent_Factory(t) { return new (t || MedSupHeightComponent)(); };
MedSupHeightComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedSupHeightComponent, selectors: [["vnext-med-sup-height"]], viewQuery: function MedSupHeightComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1h, 5);
        i0.ɵɵviewQuery(_c1$A, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupHeightFoot = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupHeightInch = _t.first);
    } }, inputs: { question: "question", feetLabel: "feetLabel", inchesLabel: "inchesLabel", defaultValue: "defaultValue", hasError: "hasError", ariaLabelledById: "ariaLabelledById", ariaDescribedByFtInputId: "ariaDescribedByFtInputId", ariaDescribedByInInputId: "ariaDescribedByInInputId" }, outputs: { updateAnswer: "updateAnswer" }, decls: 9, vars: 15, consts: [[1, "height-input-wrapper"], ["id", "medSupHeightFoot", "type", "text", "minlength", "1", "maxlength", "1", "inputmode", "numeric", "pattern", "[0-9]", "autocomplete", "off", "aria-required", "true", "digitOnly", "", 1, "med-sup-number-input", 3, "ngClass", "ngModel", "ngModelChange", "blur", "keyup.enter"], ["medSupHeightFoot", ""], ["id", "number-input-label-foot", 1, "number-input-label"], ["digitOnly", "", "id", "medSupHeightInch", "type", "text", "minlength", "1", "maxlength", "2", "inputmode", "numeric", "pattern", "[0-9]*", "autocomplete", "off", "aria-required", "true", 1, "med-sup-number-input", "ml-3", 3, "formControl", "ngClass", "ngModel", "ngModelChange", "keyup.enter", "blur", "focus"], ["medSupHeightInch", ""], ["id", "number-input-label-inch", 1, "number-input-label"]], template: function MedSupHeightComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "input", 1, 2);
        i0.ɵɵlistener("ngModelChange", function MedSupHeightComponent_Template_input_ngModelChange_1_listener($event) { return ctx.footValue = $event; })("blur", function MedSupHeightComponent_Template_input_blur_1_listener() { return ctx.emitAnswer(); })("keyup.enter", function MedSupHeightComponent_Template_input_keyup_enter_1_listener() { return ctx.emitAnswer(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "input", 4, 5);
        i0.ɵɵlistener("ngModelChange", function MedSupHeightComponent_Template_input_ngModelChange_5_listener($event) { return ctx.inchValue = $event; })("keyup.enter", function MedSupHeightComponent_Template_input_keyup_enter_5_listener() { return ctx.emitAnswer(); })("blur", function MedSupHeightComponent_Template_input_blur_5_listener() { return ctx.emitAnswer(); })("focus", function MedSupHeightComponent_Template_input_focus_5_listener() { return ctx.markInchControlTouched(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "span", 6);
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c2$o, ctx.hasError))("ngModel", ctx.footValue);
        i0.ɵɵattribute("aria-labelledby", ctx.ariaLabelledById + " number-input-label-foot")("aria-describedby", ctx.ariaDescribedByFtInputId);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.feetLabel);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formControl", ctx.medSupHeightInchControl)("ngClass", i0.ɵɵpureFunction1(13, _c2$o, ctx.hasError))("ngModel", ctx.inchValue);
        i0.ɵɵattribute("aria-labelledby", ctx.ariaLabelledById + " number-input-label-inch")("aria-describedby", ctx.ariaDescribedByInInputId);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.inchesLabel);
    } }, dependencies: [i1$2.NgClass, i4.DefaultValueAccessor, i4.NgControlStatus, i4.MinLengthValidator, i4.MaxLengthValidator, i4.PatternValidator, i4.NgModel, i4.FormControlDirective, i3.DigitOnlyDirective], styles: [".height-input-wrapper[_ngcontent-%COMP%]{display:inline-flex;align-items:center}.med-sup-number-input[_ngcontent-%COMP%]{width:0%;flex:1;min-width:40px}.number-input-label[_ngcontent-%COMP%]{font-family:montserrat_bold;margin-left:5px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupHeightComponent, [{
        type: Component,
        args: [{ selector: 'vnext-med-sup-height', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"height-input-wrapper\">\r\n  <input\r\n    #medSupHeightFoot\r\n    id=\"medSupHeightFoot\"\r\n    type=\"text\"\r\n    minlength=\"1\"\r\n    maxlength=\"1\"\r\n    class=\"med-sup-number-input\"\r\n    inputmode=\"numeric\"\r\n    pattern=\"[0-9]\"\r\n    autocomplete=\"off\"\r\n    aria-required=\"true\"\r\n    digitOnly\r\n    [attr.aria-labelledby]=\"ariaLabelledById + ' number-input-label-foot'\"\r\n    [attr.aria-describedby]=\"ariaDescribedByFtInputId\"\r\n    [ngClass]=\"{ 'has-error': hasError }\"\r\n    [(ngModel)]=\"footValue\"\r\n    (blur)=\"emitAnswer()\"\r\n    (keyup.enter)=\"emitAnswer()\"\r\n  />\r\n  <span id=\"number-input-label-foot\" class=\"number-input-label\">{{ feetLabel }}</span>\r\n\r\n  <input\r\n    #medSupHeightInch\r\n    digitOnly\r\n    id=\"medSupHeightInch\"\r\n    type=\"text\"\r\n    minlength=\"1\"\r\n    maxlength=\"2\"\r\n    class=\"med-sup-number-input ml-3\"\r\n    inputmode=\"numeric\"\r\n    pattern=\"[0-9]*\"\r\n    autocomplete=\"off\"\r\n    aria-required=\"true\"\r\n    [attr.aria-labelledby]=\"ariaLabelledById + ' number-input-label-inch'\"\r\n    [attr.aria-describedby]=\"ariaDescribedByInInputId\"\r\n    [formControl]=\"medSupHeightInchControl\"\r\n    [ngClass]=\"{ 'has-error': hasError }\"\r\n    [(ngModel)]=\"inchValue\"\r\n    (keyup.enter)=\"emitAnswer()\"\r\n    (blur)=\"emitAnswer()\"\r\n    (focus)=\"markInchControlTouched()\"\r\n  />\r\n  <span id=\"number-input-label-inch\" class=\"number-input-label\">{{ inchesLabel }}</span>\r\n</div>\r\n", styles: [".height-input-wrapper{display:inline-flex;align-items:center}.med-sup-number-input{width:0%;flex:1;min-width:40px}.number-input-label{font-family:montserrat_bold;margin-left:5px}\n"] }]
    }], null, { medSupHeightFoot: [{
            type: ViewChild,
            args: ['medSupHeightFoot']
        }], medSupHeightInch: [{
            type: ViewChild,
            args: ['medSupHeightInch']
        }], question: [{
            type: Input
        }], feetLabel: [{
            type: Input
        }], inchesLabel: [{
            type: Input
        }], defaultValue: [{
            type: Input
        }], hasError: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], ariaDescribedByFtInputId: [{
            type: Input
        }], ariaDescribedByInInputId: [{
            type: Input
        }], updateAnswer: [{
            type: Output
        }] }); })();

const _c0$1g = ["medSupInteger"];
function MedSupIntegerComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.label);
} }
const _c1$z = function (a0) { return { "has-error": a0 }; };
class MedSupIntegerComponent {
    constructor() {
        this.hasError = false;
        this.ariaLabelledById = 'extra-label';
        this.placeholder = '';
        this.updateAnswer = new EventEmitter();
        this.activeIndex = 0;
    }
    getName() {
        return this.fieldName;
    }
    focus() {
        this.medSupInteger.nativeElement.focus();
    }
    ngOnInit() {
        this.value = this.defaultValue;
    }
    emitAnswer() {
        this.updateAnswer.emit({
            name: this.question.name,
            value: this.value,
            valid: typeof this.value !== 'undefined' && this.value !== null
        });
    }
}
MedSupIntegerComponent.ɵfac = function MedSupIntegerComponent_Factory(t) { return new (t || MedSupIntegerComponent)(); };
MedSupIntegerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedSupIntegerComponent, selectors: [["vnext-med-sup-integer"]], viewQuery: function MedSupIntegerComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1g, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupInteger = _t.first);
    } }, inputs: { question: "question", defaultValue: "defaultValue", label: "label", hasError: "hasError", ariaLabelledById: "ariaLabelledById", ariaDescribedById: "ariaDescribedById", fieldName: "fieldName", placeholder: "placeholder" }, outputs: { updateAnswer: "updateAnswer" }, decls: 4, vars: 8, consts: [["digitOnly", "", "type", "text", "minlength", "0", "maxlength", "4", "inputmode", "numeric", "pattern", "[0-9]*", "autocomplete", "off", "aria-required", "true", 1, "med-sup-number-input", "form-control", 3, "ngClass", "placeholder", "ngModel", "ngModelChange", "blur", "keyup.enter"], ["medSupInteger", ""], ["class", "extra-label", "id", "extra-label", 4, "ngIf"], ["id", "extra-label", 1, "extra-label"]], template: function MedSupIntegerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "label")(1, "input", 0, 1);
        i0.ɵɵlistener("ngModelChange", function MedSupIntegerComponent_Template_input_ngModelChange_1_listener($event) { return ctx.value = $event; })("blur", function MedSupIntegerComponent_Template_input_blur_1_listener() { return ctx.emitAnswer(); })("keyup.enter", function MedSupIntegerComponent_Template_input_keyup_enter_1_listener() { return ctx.emitAnswer(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, MedSupIntegerComponent_span_3_Template, 2, 1, "span", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$z, ctx.hasError))("placeholder", ctx.placeholder)("ngModel", ctx.value);
        i0.ɵɵattribute("aria-labelledby", ctx.ariaLabelledById + " extra-label")("aria-describedby", ctx.ariaDescribedById);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.label);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.DefaultValueAccessor, i4.NgControlStatus, i4.MinLengthValidator, i4.MaxLengthValidator, i4.PatternValidator, i4.NgModel, i3.DigitOnlyDirective], styles: ["label[_ngcontent-%COMP%]{display:flex;align-items:center;margin-bottom:0}.med-sup-number-input[_ngcontent-%COMP%]{min-width:80px}.extra-label[_ngcontent-%COMP%]{font-family:montserrat_bold;margin-left:10px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupIntegerComponent, [{
        type: Component,
        args: [{ selector: 'vnext-med-sup-integer', changeDetection: ChangeDetectionStrategy.OnPush, template: "<label>\r\n  <input\r\n    #medSupInteger\r\n    digitOnly\r\n    type=\"text\"\r\n    minlength=\"0\"\r\n    maxlength=\"4\"\r\n    class=\"med-sup-number-input form-control\"\r\n    inputmode=\"numeric\"\r\n    pattern=\"[0-9]*\"\r\n    autocomplete=\"off\"\r\n    aria-required=\"true\"\r\n    [attr.aria-labelledby]=\"ariaLabelledById + ' extra-label'\"\r\n    [attr.aria-describedby]=\"ariaDescribedById\"\r\n    [ngClass]=\"{ 'has-error': hasError }\"\r\n    [placeholder]=\"placeholder\"\r\n    [(ngModel)]=\"value\"\r\n    (blur)=\"emitAnswer()\"\r\n    (keyup.enter)=\"emitAnswer()\"\r\n  />\r\n  <span *ngIf=\"label\" class=\"extra-label\" id=\"extra-label\">{{ label }}</span>\r\n</label>\r\n", styles: ["label{display:flex;align-items:center;margin-bottom:0}.med-sup-number-input{min-width:80px}.extra-label{font-family:montserrat_bold;margin-left:10px}\n"] }]
    }], null, { medSupInteger: [{
            type: ViewChild,
            args: ['medSupInteger']
        }], question: [{
            type: Input
        }], defaultValue: [{
            type: Input
        }], label: [{
            type: Input
        }], hasError: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], fieldName: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], updateAnswer: [{
            type: Output
        }] }); })();

const _c0$1f = ["medSupToggle"];
class MedSupToggleComponent {
    constructor(planFacade, localeService, cdr) {
        this.planFacade = planFacade;
        this.localeService = localeService;
        this.cdr = cdr;
        this.limitButtonWidth = false;
        this.isReadOnly = false;
        this.updateAnswer = new EventEmitter();
    }
    getName() {
        return this.fieldName;
    }
    focus() {
        this.medSupToggle.toggleElements.first.nativeElement.focus();
    }
    ngOnInit() {
        if (this.defaultValue) {
            this.updateAnswer.emit({
                name: this.question.name,
                value: this.defaultValue,
                valid: true
            });
        }
        this.subscriptions = [
            this.localeService.getCurrentLocale$().subscribe(locale => {
                this.items = this.question.answerList.map(answer => ({
                    display: this.planFacade.getMedSupFormKey(this.question.name, answer),
                    value: answer
                }));
                this.cdr.markForCheck();
            })
        ];
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    toggleClicked({ data, event }) {
        event.stopPropagation();
        if (data && data !== null) {
            this.updateAnswer.emit({
                name: this.question.name,
                value: data.value,
                valid: true
            });
        }
        else {
            this.updateAnswer.emit({
                name: this.question.name,
                value: null,
                valid: false
            });
        }
    }
}
MedSupToggleComponent.ɵfac = function MedSupToggleComponent_Factory(t) { return new (t || MedSupToggleComponent)(i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
MedSupToggleComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedSupToggleComponent, selectors: [["vnext-med-sup-toggle"]], viewQuery: function MedSupToggleComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1f, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupToggle = _t.first);
    } }, inputs: { question: "question", defaultValue: "defaultValue", limitButtonWidth: "limitButtonWidth", ariaLabelledById: "ariaLabelledById", ariaDescribedById: "ariaDescribedById", toggleControlId: "toggleControlId", fieldName: "fieldName", isReadOnly: "isReadOnly" }, outputs: { updateAnswer: "updateAnswer" }, features: [i0.ɵɵProvidersFeature([InputResetContextService])], decls: 2, vars: 9, consts: [[3, "items", "selectedValue", "limitButtonWidth", "ariaLabelledById", "ariaDescribedById", "toggleControlId", "largerText", "isReadOnly", "buttonHeight", "optionSelected"], ["medSupToggle", ""]], template: function MedSupToggleComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-toggle-select", 0, 1);
        i0.ɵɵlistener("optionSelected", function MedSupToggleComponent_Template_vnext_toggle_select_optionSelected_0_listener($event) { return ctx.toggleClicked($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("items", ctx.items)("selectedValue", ctx.defaultValue)("limitButtonWidth", ctx.limitButtonWidth)("ariaLabelledById", ctx.ariaLabelledById)("ariaDescribedById", ctx.ariaDescribedById)("toggleControlId", ctx.toggleControlId)("largerText", true)("isReadOnly", ctx.isReadOnly)("buttonHeight", "36px");
    } }, dependencies: [ToggleSelectComponent], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupToggleComponent, [{
        type: Component,
        args: [{ selector: 'vnext-med-sup-toggle', changeDetection: ChangeDetectionStrategy.OnPush, providers: [InputResetContextService], template: "<vnext-toggle-select\r\n  #medSupToggle\r\n  [items]=\"items\"\r\n  [selectedValue]=\"defaultValue\"\r\n  (optionSelected)=\"toggleClicked($event)\"\r\n  [limitButtonWidth]=\"limitButtonWidth\"\r\n  [ariaLabelledById]=\"ariaLabelledById\"\r\n  [ariaDescribedById]=\"ariaDescribedById\"\r\n  [toggleControlId]=\"toggleControlId\"\r\n  [largerText]=\"true\"\r\n  [isReadOnly]=\"isReadOnly\"\r\n  [buttonHeight]=\"'36px'\"\r\n></vnext-toggle-select>\r\n" }]
    }], function () { return [{ type: PlanFacade }, { type: i1.LocaleService }, { type: i0.ChangeDetectorRef }]; }, { medSupToggle: [{
            type: ViewChild,
            args: ['medSupToggle']
        }], question: [{
            type: Input
        }], defaultValue: [{
            type: Input
        }], limitButtonWidth: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], toggleControlId: [{
            type: Input
        }], fieldName: [{
            type: Input
        }], isReadOnly: [{
            type: Input
        }], updateAnswer: [{
            type: Output
        }] }); })();

const _c0$1e = ["medSupTogglePayment"];
const _c1$y = ["medSupDropdownPayment"];
function MedSupPaymentMethodComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-med-sup-toggle", 2, 3);
    i0.ɵɵlistener("updateAnswer", function MedSupPaymentMethodComponent_ng_container_0_Template_vnext_med_sup_toggle_updateAnswer_1_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.selectedAnswer($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("question", ctx_r0.question)("defaultValue", ctx_r0.defaultValue)("limitButtonWidth", ctx_r0.limitButtonWidth)("ariaLabelledById", ctx_r0.ariaLabelledById)("ariaDescribedById", ctx_r0.ariaDescribedById)("toggleControlId", "med-sup-payment");
} }
function MedSupPaymentMethodComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-dropdown", 4, 5);
    i0.ɵɵlistener("updateAnswer", function MedSupPaymentMethodComponent_ng_template_1_Template_vnext_med_sup_dropdown_updateAnswer_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.selectedAnswer($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("question", ctx_r2.question)("defaultValue", ctx_r2.defaultValue)("noAnswerLabel", ctx_r2.noAnswerLabel)("hasError", ctx_r2.hasError)("ariaLabelledById", ctx_r2.ariaLabelledById)("ariaDescribedById", ctx_r2.ariaDescribedById);
} }
class MedSupPaymentMethodComponent {
    constructor() {
        this.hasError = false;
        this.limitButtonWidth = false;
        this.updateAnswer = new EventEmitter();
    }
    getName() {
        return 'PaymentMethod';
    }
    focus() {
        if (this.useToggle) {
            this.medSupTogglePayment.medSupToggle.toggleElements.first.nativeElement.focus();
        }
        else {
            this.medSupDropdownPayment.medSupDropDown.nativeElement.focus();
        }
    }
    selectedAnswer(answer) {
        this.updateAnswer.emit(answer);
    }
}
MedSupPaymentMethodComponent.ɵfac = function MedSupPaymentMethodComponent_Factory(t) { return new (t || MedSupPaymentMethodComponent)(); };
MedSupPaymentMethodComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedSupPaymentMethodComponent, selectors: [["vnext-med-sup-payment-method"]], viewQuery: function MedSupPaymentMethodComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1e, 5);
        i0.ɵɵviewQuery(_c1$y, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupTogglePayment = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupDropdownPayment = _t.first);
    } }, inputs: { useToggle: "useToggle", question: "question", defaultValue: "defaultValue", noAnswerLabel: "noAnswerLabel", useRawValue: "useRawValue", hasError: "hasError", limitButtonWidth: "limitButtonWidth", ariaLabelledById: "ariaLabelledById", ariaDescribedById: "ariaDescribedById" }, outputs: { updateAnswer: "updateAnswer" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["dropdown", ""], [3, "question", "defaultValue", "limitButtonWidth", "ariaLabelledById", "ariaDescribedById", "toggleControlId", "updateAnswer"], ["medSupTogglePayment", ""], [3, "question", "defaultValue", "noAnswerLabel", "hasError", "ariaLabelledById", "ariaDescribedById", "updateAnswer"], ["medSupDropdownPayment", ""]], template: function MedSupPaymentMethodComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MedSupPaymentMethodComponent_ng_container_0_Template, 3, 6, "ng-container", 0);
        i0.ɵɵtemplate(1, MedSupPaymentMethodComponent_ng_template_1_Template, 2, 6, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.useToggle)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgIf, MedSupToggleComponent, MedSupDropdownComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupPaymentMethodComponent, [{
        type: Component,
        args: [{ selector: 'vnext-med-sup-payment-method', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"useToggle; else dropdown\"\r\n  ><vnext-med-sup-toggle\r\n    #medSupTogglePayment\r\n    (updateAnswer)=\"selectedAnswer($event)\"\r\n    [question]=\"question\"\r\n    [defaultValue]=\"defaultValue\"\r\n    [limitButtonWidth]=\"limitButtonWidth\"\r\n    [ariaLabelledById]=\"ariaLabelledById\"\r\n    [ariaDescribedById]=\"ariaDescribedById\"\r\n    [toggleControlId]=\"'med-sup-payment'\"\r\n  >\r\n  </vnext-med-sup-toggle>\r\n</ng-container>\r\n<ng-template #dropdown>\r\n  <vnext-med-sup-dropdown\r\n    #medSupDropdownPayment\r\n    (updateAnswer)=\"selectedAnswer($event)\"\r\n    [question]=\"question\"\r\n    [defaultValue]=\"defaultValue\"\r\n    [noAnswerLabel]=\"noAnswerLabel\"\r\n    [hasError]=\"hasError\"\r\n    [ariaLabelledById]=\"ariaLabelledById\"\r\n    [ariaDescribedById]=\"ariaDescribedById\"\r\n  ></vnext-med-sup-dropdown>\r\n</ng-template>\r\n" }]
    }], null, { medSupTogglePayment: [{
            type: ViewChild,
            args: ['medSupTogglePayment']
        }], medSupDropdownPayment: [{
            type: ViewChild,
            args: ['medSupDropdownPayment']
        }], useToggle: [{
            type: Input
        }], question: [{
            type: Input
        }], defaultValue: [{
            type: Input
        }], noAnswerLabel: [{
            type: Input
        }], useRawValue: [{
            type: Input
        }], hasError: [{
            type: Input
        }], limitButtonWidth: [{
            type: Input
        }], ariaLabelledById: [{
            type: Input
        }], ariaDescribedById: [{
            type: Input
        }], updateAnswer: [{
            type: Output
        }] }); })();

function MedSupPlanSubTypeComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "i", 13);
    i0.ɵɵelementStart(2, "span", 9);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.errorKeywordText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r0.error, " ");
} }
function MedSupPlanSubTypeComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MedSupPlanSubTypeComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵlistener("click", function MedSupPlanSubTypeComponent_div_13_Template_div_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r5); const subType_r3 = restoredCtx.$implicit; const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.optionClicked(subType_r3)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subType_r3 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", subType_r3, " ");
} }
const _c0$1d = function (a0) { return { "col-md-6 col-lg-5 test3": a0 }; };
const _c1$x = function (a0, a1) { return { "error-color": a0, "Spa_Style_Primary_Color": a1 }; };
const _c2$n = function (a0) { return { "has-error": a0 }; };
class MedSupPlanSubTypeComponent {
    constructor(medSupFacade) {
        this.medSupFacade = medSupFacade;
        this.headerText = '';
        this.placeholder = '';
        this.error = '';
        this.errorKeywordText = '';
        this.selectedPlanSubType = '';
        this.planSubTypes = [];
        this.showError = true;
        this.updateOnClick = true;
        this.fullWidth = false;
        this.valueSelected = new EventEmitter();
    }
    optionClicked(subType) {
        if (this.updateOnClick) {
            this.medSupFacade.updateSelectedPlanSubType(subType);
        }
        this.valueSelected.emit(subType);
    }
}
MedSupPlanSubTypeComponent.ɵfac = function MedSupPlanSubTypeComponent_Factory(t) { return new (t || MedSupPlanSubTypeComponent)(i0.ɵɵdirectiveInject(MedSupFacade)); };
MedSupPlanSubTypeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedSupPlanSubTypeComponent, selectors: [["vnext-med-sup-plan-sub-type"]], inputs: { headerText: "headerText", placeholder: "placeholder", error: "error", errorKeywordText: "errorKeywordText", selectedPlanSubType: "selectedPlanSubType", planSubTypes: "planSubTypes", showError: "showError", updateOnClick: "updateOnClick", fullWidth: "fullWidth" }, outputs: { valueSelected: "valueSelected" }, features: [i0.ɵɵProvidersFeature([])], decls: 14, vars: 17, consts: [[1, "row"], [1, "col-12", 3, "ngClass"], ["class", "error-color", 4, "ngIf"], ["id", "headerTextId", 1, "question-header", "Spa_Style_Bold_Weight"], ["class", "input-error-asterisk", 4, "ngIf"], [3, "ngClass"], ["ngbDropdown", ""], ["ngbDropdownToggle", "", "type", "text", "tabindex", "0", "aria-labelledby", "headerTextId", 1, "form-control", "can-click", 3, "placeholder", "ngClass", "disabled", "ngModel", "ngModelChange", "keydown"], ["ngbDropdownToggle", "", 1, "fas", "fa-angle-down", "icon-in-input", "can-click", "float-right"], [1, "sr-only"], ["ngbDropdownMenu", ""], ["class", "can-click", "ngbDropdownItem", "", 3, "click", 4, "ngFor", "ngForOf"], [1, "error-color"], ["aria-hidden", "true", 1, "fa", "fa-exclamation-circle", "mr-1"], [1, "input-error-asterisk"], ["ngbDropdownItem", "", 1, "can-click", 3, "click"]], template: function MedSupPlanSubTypeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, MedSupPlanSubTypeComponent_div_2_Template, 5, 2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, MedSupPlanSubTypeComponent_span_4_Template, 2, 0, "span", 4);
        i0.ɵɵelementStart(5, "span", 5);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 6)(8, "input", 7);
        i0.ɵɵlistener("ngModelChange", function MedSupPlanSubTypeComponent_Template_input_ngModelChange_8_listener($event) { return ctx.selectedPlanSubType = $event; })("keydown", function MedSupPlanSubTypeComponent_Template_input_keydown_8_listener($event) { return $event.preventDefault(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(9, "i", 8);
        i0.ɵɵelementStart(10, "span", 9);
        i0.ɵɵtext(11, "Expand menu");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 10);
        i0.ɵɵtemplate(13, MedSupPlanSubTypeComponent_div_13_Template, 2, 1, "div", 11);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c0$1d, !ctx.fullWidth));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.error.length && ctx.showError);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showError);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(12, _c1$x, ctx.error.length && ctx.showError, !ctx.showError));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.headerText);
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate("placeholder", ctx.placeholder);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c2$n, ctx.error.length))("disabled", !(ctx.planSubTypes == null ? null : ctx.planSubTypes.length))("ngModel", ctx.selectedPlanSubType);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngForOf", ctx.planSubTypes);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, IconAriaAttributesDirective, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem], styles: [".icon-in-input[_ngcontent-%COMP%]{position:absolute;top:8px;left:calc(100% - 15px)}.question-header[_ngcontent-%COMP%]{display:inline-block;margin-bottom:6px}.dropdown-menu[_ngcontent-%COMP%]{overflow-y:scroll;max-height:315px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupPlanSubTypeComponent, [{
        type: Component,
        args: [{ selector: 'vnext-med-sup-plan-sub-type', changeDetection: ChangeDetectionStrategy.OnPush, providers: [], template: "<div class=\"row\">\r\n  <div class=\"col-12\" [ngClass]=\"{ 'col-md-6 col-lg-5 test3': !fullWidth }\">\r\n    <div class=\"error-color\" *ngIf=\"error.length && showError\">\r\n      <i class=\"fa fa-exclamation-circle mr-1\" aria-hidden=\"true\"></i><span class=\"sr-only\">{{ errorKeywordText }}</span\r\n      >{{ error }}\r\n    </div>\r\n    <div class=\"question-header Spa_Style_Bold_Weight\" id=\"headerTextId\">\r\n      <span class=\"input-error-asterisk\" *ngIf=\"showError\">*</span>\r\n      <span [ngClass]=\"{ 'error-color': error.length && showError, 'Spa_Style_Primary_Color': !showError }\">{{ headerText }}</span>\r\n    </div>\r\n    <div ngbDropdown>\r\n      <input\r\n        ngbDropdownToggle\r\n        type=\"text\"\r\n        tabindex=\"0\"\r\n        class=\"form-control can-click\"\r\n        aria-labelledby=\"headerTextId\"\r\n        placeholder=\"{{ placeholder }}\"\r\n        [ngClass]=\"{ 'has-error': error.length }\"\r\n        [disabled]=\"!planSubTypes?.length\"\r\n        [(ngModel)]=\"selectedPlanSubType\"\r\n        (keydown)=\"$event.preventDefault()\"\r\n      />\r\n      <i class=\"fas fa-angle-down icon-in-input can-click float-right\" ngbDropdownToggle></i>\r\n      <span class=\"sr-only\">Expand menu</span>\r\n      <div ngbDropdownMenu>\r\n        <div *ngFor=\"let subType of planSubTypes\" (click)=\"optionClicked(subType)\" class=\"can-click\" ngbDropdownItem>\r\n          {{ subType }}\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".icon-in-input{position:absolute;top:8px;left:calc(100% - 15px)}.question-header{display:inline-block;margin-bottom:6px}.dropdown-menu{overflow-y:scroll;max-height:315px}\n"] }]
    }], function () { return [{ type: MedSupFacade }]; }, { headerText: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], error: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], selectedPlanSubType: [{
            type: Input
        }], planSubTypes: [{
            type: Input
        }], showError: [{
            type: Input
        }], updateOnClick: [{
            type: Input
        }], fullWidth: [{
            type: Input
        }], valueSelected: [{
            type: Output
        }] }); })();

const DEFAULT_ERROR_KEY = 'Default';
class MedSupFormErrorContext {
    constructor(configResourceService) {
        this.configResourceService = configResourceService;
        this.questionErrors = {};
    }
    initializeErrorMessages(questionMetaData) {
        const questionKeys = questionMetaData.map(metaData => metaData.key);
        const requiredErrors = this.requiredErrors;
        const defaultRequiredError = this.requiredErrors[DEFAULT_ERROR_KEY];
        const customQuestionErrors = this.customQuestionErrors;
        const errors = {};
        questionKeys.forEach(questionKey => {
            const requiredError = requiredErrors[questionKey] || defaultRequiredError.replace('<questionKey>', questionKey);
            const specificError = customQuestionErrors[questionKey];
            errors[questionKey] = { Required: requiredError, ...specificError };
        });
        errors[MedSupQuestionNames.PlanSubType] = { Required: requiredErrors[MedSupQuestionNames.PlanSubType] };
        this.questionErrors = errors;
    }
    initializeMillimanFormErrorMessages(millimanForm) {
        const errors = this.questionErrors || {};
        if (millimanForm) {
            const healthQuestions = millimanForm.healthQuestions;
            if (healthQuestions?.length) {
                healthQuestions.forEach(question => {
                    if (question) {
                        const requiredError = question.requiredErrorMessage;
                        errors[question.questionKey] = { Required: requiredError };
                    }
                });
            }
            const memberQuestions = millimanForm.memberQuestions;
            if (memberQuestions?.length) {
                memberQuestions.forEach(question => {
                    if (question) {
                        const requiredError = question.requiredText;
                        errors[question.keyName] = { Required: requiredError };
                    }
                });
            }
        }
        this.questionErrors = errors;
    }
    getErrorMessage(key, errorType) {
        const questionError = this.questionErrors[key];
        return questionError?.[errorType] ?? '';
    }
    get customQuestionErrors() {
        return {
            EffectiveDate: this.effectiveDateErrors,
            PartAEffectiveDate: this.partAEffectiveDateErrors,
            PartBEffectiveDate: this.partBEffectiveDateErrors,
            DateOfBirth: this.dateOfBirthErrors
        };
    }
    get dateOfBirthErrors() {
        return {
            FutureDate: this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_FutureBirthDateError_Text', null, 'Please provide a date of birth in the past'),
            PastDate: this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_BirthDateOutOfRangeError_Text', null, 'The date of birth is too far in the past'),
            Invalid: this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_NoBirthDateError_Text', null, 'Please provide a valid date of birth')
        };
    }
    get partAEffectiveDateErrors() {
        return {
            FutureDate: this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartA_Effective_FutureDateError_Text', null, 'Part A Effective Date is too far in the future.'),
            PastDate: this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartA_Effective_PastDateError_Text', null, 'Part A Effective Date is too far in the past.'),
            BeforeDOB: this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartA_DOB_After_Error_Text', null, 'Please provide a valid Part A effective date. Date must be after date of birth.'),
            Invalid: this.configResourceService.getProcessedResourceValue('Spa_MedSupFor_PartAEffectiveDateInvalidDateError_Text', null, 'Please provide a valid Part A effective date.'),
            AfterPartBEffectiveDate: this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartA_AfterDate_Error_Text', null, 'Part A effective date cannot be after Part B effective date.')
        };
    }
    get partBEffectiveDateErrors() {
        return {
            FutureDate: this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartB_FutureDateError_Text', null, 'Part B Effective Date is too far in the future.'),
            PastDate: this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartB_PastDateError_Text', null, 'Part B Effective Date is too far in the past.'),
            BeforeDOB: this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartB_DOB_After_Error_Text', null, 'Please provide a valid Part B effective date. Date must be after date of birth.'),
            Invalid: this.configResourceService.getProcessedResourceValue('Spa_MedSupFor_PartBEffectiveDateInvalidDateError_Text', null, 'Please provide a valid Part B effective date.'),
            BeforePartAEffectiveDate: this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartB_PriorDate_Error_Text', null, 'Part B effective date cannot be before Part A effective date.')
        };
    }
    get effectiveDateErrors() {
        return {
            FutureDate: this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_TooFarInFutureEffectiveDateError_Text', null, 'Effective Date is too far in the future'),
            PastDate: this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_TooFarInPastEffectiveDateError_Text', null, 'Please provide an effective date in the future'),
            Invalid: this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_InvalidEffectiveDateError_Text', null, 'Please provide a valid effective date')
        };
    }
    get requiredErrors() {
        return {
            [MedSupQuestionNames.Gender]: this.configResourceService.getProcessedResourceValue('Spa_MedSup_GenderRequiredError_Text', null, 'Please specify gender'),
            [MedSupQuestionNames.Tobacco]: this.configResourceService.getProcessedResourceValue('Spa_MedSup_TobaccoRequiredError_Text', null, 'Please specify tobacco use'),
            [MedSupQuestionNames.Weight]: this.configResourceService.getProcessedResourceValue('Spa_MedSup_WeightRequiredError_Text', null, 'Please provide weight'),
            [MedSupQuestionNames.Height]: this.configResourceService.getProcessedResourceValue('Spa_MedSup_HeightRequiredError_Text', null, 'Please provide height'),
            [MedSupQuestionNames.PaymentMethod]: this.configResourceService.getProcessedResourceValue('Spa_MedSup_PaymentMethodRequiredError_Text', null, 'Please specify preferred method of payment'),
            [MedSupQuestionNames.Household]: this.configResourceService.getProcessedResourceValue('Spa_MedSup_HouseholdRequiredError_Text', null, 'Please specify if you will be signing up a spouse'),
            [MedSupQuestionNames.GuaranteedIssue]: this.configResourceService.getProcessedResourceValue('Spa_MedSup_GuaranteedIssueRequiredError_Text', null, 'Please specify Guaranteed Issue qualification'),
            [MedSupQuestionNames.GIAdditional]: this.configResourceService.getProcessedResourceValue('Spa_MedSup_GIAdditionalRequiredError_Text', null, 'Please specify which answer(s) applies'),
            [MedSupQuestionNames.EffectiveDate]: this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_InvalidEffectiveDateError_Text', null, 'Please provide a valid effective date'),
            [MedSupQuestionNames.PartAEffectiveDate]: this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartAEffectiveDateRequiredError_Text', null, 'Please provide a Part A effective date'),
            [MedSupQuestionNames.PartBEffectiveDate]: this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartBEffectiveDateRequiredError_Text', null, 'Please provide a Part B effective date'),
            [MedSupQuestionNames.DateOfBirth]: this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_NoBirthDateError_Text', null, 'Please provide a valid date of birth'),
            [MedSupQuestionNames.PlanSubType]: this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_NoPlanSubTypeError_Text', null, 'Please make a selection'),
            [MedSupQuestionNames.EFTDiscount]: this.configResourceService.getProcessedResourceValue('Spa_MedSup_EFTDiscountRequiredError_Text', null, 'Please specify how you will be paying'),
            [MedSupQuestionNames.Disability]: this.configResourceService.getProcessedResourceValue('Spa_MedSup_DisabilityRequiredError_Text', null, 'Please specify eligibility'),
            Default: this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_DefaultRequiredError_Text', null, 'Please specify <questionKey>')
        };
    }
}
MedSupFormErrorContext.ɵfac = function MedSupFormErrorContext_Factory(t) { return new (t || MedSupFormErrorContext)(i0.ɵɵinject(i1.ConfigResourceService)); };
MedSupFormErrorContext.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MedSupFormErrorContext, factory: MedSupFormErrorContext.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupFormErrorContext, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.ConfigResourceService }]; }, null); })();

class MedSupMillimanFormFacade {
    constructor(store, configResourceService, millimanService, medSupMillimanCryptoService) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.millimanService = millimanService;
        this.medSupMillimanCryptoService = medSupMillimanCryptoService;
        this._validateMedSupForm$ = new Subject();
    }
    get onValidateMedSupForm$() {
        return this._validateMedSupForm$.asObservable();
    }
    validateMillimanForm() {
        this._validateMedSupForm$.next(null);
    }
    getMemberStateModel() {
        return this.store.selectSnapshot(MemberState.session);
    }
    getMillimanHealthInformationFromMemberNotes() {
        const medSupAnswers = this.millimanService.getMemberMedigapAnswers();
        if (medSupAnswers?.millimanHealthInformation) {
            const updatedMilliman = {
                ...medSupAnswers.millimanHealthInformation
            };
            return updatedMilliman;
        }
        return null;
    }
    getMillimanHealthInformation() {
        return this.store.selectSnapshot(MillimanState.healthInformation);
    }
    getAuthorizeUse() {
        return this.store.selectSnapshot(MillimanState.authorizeUse);
    }
    getAuthorizeDate() {
        return this.store.selectSnapshot(MillimanState.authorizeDate);
    }
    getApplicantFullName() {
        return this.store.selectSnapshot(MillimanState.applicantFullName);
    }
    getDecryptedApplicantId() {
        return this.medSupMillimanCryptoService.getDecryptedApplicantId();
    }
    isMedSupMillimanEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_MedSup_Milliman_Enabled', widgetName, false);
    }
    getDisableNoneOfTheseApplyIfOptionSelected(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_MedSup_Milliman_HealthQuestions_DisableNoneOfTheseApplyIfOptionSelected', widgetName, false);
    }
    getDisableOptionsIfNoneOfTheseApplySelected(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_MedSup_Milliman_HealthQuestions_DisableOptionsIfNoneOfTheseApplySelected', widgetName, true);
    }
    getMillimanJustAFewMoreQuestionsText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Milliman_JustAFew_Text', widgetName, 'Just a few more. Almost done.');
    }
    getMillimanAutoCompleteEnabled(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Milliman_AddressAutoComplete_Enabled', widgetName, true);
    }
    getMillimanApplicantsNameMuchMatchText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Milliman_ApplicantNameMuchMatch_Text', widgetName, "Must match the applicant's name as entered at the beginning of the application.");
    }
    getMillimanAuthorizationHeaderText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Milliman_AuthorizationHeader_Text', widgetName, 'Authorization for protected health information use and disclosure (required if applying outside' +
            ' your open enrollment or guaranteed issue period)');
    }
    getMillimanAuthorizationText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Milliman_Authorization_Text', widgetName, '<br/>I understand that the following parties may need to collect information about me in regards ' +
            'to the proposed coverage: Blue Cross Blue Shield of ' +
            'Michigan and its reinsurers; any insurance support organization; any consumer reporting agency; ' +
            'and all persons authorized to represent these organizations ' +
            'for this purpose. <br/><br/> Any and all individually identifiable health information, including ' +
            'but not limited to medical records, reports, pharmaceutical records, ' +
            'diagnostic testing and lab work results may be disclosed to or by Blue Cross Blue Shield of Michigan. ' +
            '<br/> <br/>Those parties that need to collect information may ' +
            'disclose information to the following: other insurers to whom I’ve applied or may apply; reinsurers, ' +
            'pharmacy benefit managers, physicians, hospitals, clinics or ' +
            'other medically related facilities; health care clearinghouses; or persons who perform business, ' +
            'professional or insurance tasks for them. They may disclose ' +
            'information as allowed or required by law. <br/><br/> I understand that this authorization is needed ' +
            'for the purpose of gathering information for making eligibility ' +
            'and underwriting determinations. Unless revoked earlier, this authorization will be valid for 30 months ' +
            'after the date signed.  <br/><br/> I understand I can revoke ' +
            'this authorization any time by giving written notice on a standard form available online at www.bcbsm.com, ' +
            'or by contacting my agent. I also understand that my ' +
            "revocation won't affect the rights of any individual who has acted in reliance on the authorization prior to " +
            'receiving notice of my revocation. <br/><br/> I understand ' +
            'that authorizing the disclosure of this health information is voluntary. I can refuse to sign this authorization ' +
            'but if I refuse, I may not be eligible for enrollment.  ' +
            'I understand there is a possibility of redisclosure of any information disclosed pursuant to this authorization ' +
            'and that information, once disclosed, may no longer be ' +
            'protected by federal rules governing privacy and confidentiality.');
    }
    getMillimanInchesLabelText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanList_MedSupFormInchesLabel_Text', widgetName, 'in');
    }
    getMillimanFeetLabelText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanList_MedSupFormFeetLabel_Text', widgetName, 'ft');
    }
    getMillimanPoundsLabelText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_PlanList_MedSupFormPoundsLabel_Text', widgetName, 'lbs');
    }
    getMillimanMemberInformationFormFields(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Milliman_MemberInformation_Form_Content', widgetName, [
            {
                keyName: 'firstName',
                labelText: 'First name',
                required: true,
                requiredText: 'First name is required'
            },
            {
                keyName: 'middleInitial',
                labelText: 'M.I.',
                required: false,
                requiredText: 'Middle initial is required'
            },
            {
                keyName: 'lastName',
                labelText: 'Last name',
                required: true,
                requiredText: 'Last name is required'
            },
            {
                keyName: 'socialSecurityNumber',
                labelText: 'Social Security number',
                required: true,
                requiredText: 'Social Security number is required'
            },
            {
                keyName: 'address1',
                labelText: 'Address 1',
                required: true,
                requiredText: 'Address 1 is required'
            },
            {
                keyName: 'address2',
                labelText: 'Address 2',
                required: false,
                requiredText: 'Address 2 is required'
            },
            {
                keyName: 'city',
                labelText: 'City',
                required: true,
                requiredText: 'City is required'
            },
            {
                keyName: 'state',
                labelText: 'State',
                required: true,
                requiredText: 'State is required'
            },
            {
                keyName: 'zip',
                labelText: 'ZIP',
                required: true,
                requiredText: 'ZIP is required'
            },
            {
                keyName: 'date',
                labelText: 'Date',
                required: true,
                requiredText: 'Date is required'
            },
            {
                keyName: 'applicantFullName',
                labelText: 'Applicant full name',
                required: true,
                requiredText: 'Applicant full name is required'
            },
            {
                keyName: 'authorize',
                labelText: 'I have read and authorize Blue Cross Blue Shield of Michigan to use my medical and drug information.',
                required: true,
                requiredText: 'Authorization is required'
            },
            {
                keyName: 'height',
                labelText: 'Height',
                required: true,
                requiredText: 'Height is required'
            },
            {
                keyName: 'weight',
                labelText: 'Weight',
                required: true,
                requiredText: 'Weight is required'
            }
        ]);
    }
    getMillimanHealthQuestions() {
        const existingHealthInformation = this.millimanService.getHealthInformation();
        return this.getHealthQuestionsMetadata().map(healthQuestion => {
            if (healthQuestion) {
                this.populateHealthQuestionWithExistingAnswers(healthQuestion, existingHealthInformation);
            }
            if (this.getDisableNoneOfTheseApplyIfOptionSelected()) {
                this.disableNoneOfTheseApplyIfOptionSelected(healthQuestion);
            }
            if (this.getDisableOptionsIfNoneOfTheseApplySelected()) {
                this.disableOptionsIfNoneOfTheseApplySelected(healthQuestion);
            }
            return healthQuestion;
        });
    }
    mapHealthQuestionToHealthInformation(healthQuestion) {
        if (healthQuestion) {
            const healthConditions = [...healthQuestion.healthConditions, healthQuestion.noneOfTheseApply];
            if (healthConditions?.length) {
                const millimanHealthInformation = {};
                healthConditions.forEach(healthCondition => {
                    millimanHealthInformation[healthCondition.key] = healthCondition.selected ? healthCondition.value : null;
                });
                return millimanHealthInformation;
            }
        }
        return null;
    }
    disableNoneOfTheseApplyIfOptionSelected(healthQuestion) {
        if (healthQuestion?.noneOfTheseApply) {
            const isHealthAnswerSelected = !!healthQuestion.healthConditions?.some(healthCondition => healthCondition.selected);
            if (isHealthAnswerSelected) {
                healthQuestion.noneOfTheseApply.selected = null;
                healthQuestion.noneOfTheseApply.disabled = true;
            }
        }
    }
    disableOptionsIfNoneOfTheseApplySelected(healthQuestion) {
        if (healthQuestion) {
            const isNoneOfTheseApplySelected = !!healthQuestion.noneOfTheseApply?.selected;
            if (isNoneOfTheseApplySelected) {
                healthQuestion.healthConditions.forEach(healthCondition => {
                    healthCondition.selected = false;
                    healthCondition.disabled = true;
                });
            }
        }
    }
    populateHealthQuestionWithExistingAnswers(healthQuestion, existingAnswers) {
        if (healthQuestion && existingAnswers) {
            if (healthQuestion.noneOfTheseApply) {
                healthQuestion.noneOfTheseApply.selected = !!existingAnswers[healthQuestion.noneOfTheseApply.key];
            }
            if (healthQuestion.healthConditions?.length) {
                healthQuestion.healthConditions.forEach(healthCondition => {
                    healthCondition.selected = !!existingAnswers[healthCondition.key];
                });
            }
        }
    }
    getHealthQuestionsMetadata(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_MedSup_Milliman_HealthQuestions', widgetName, [
            {
                questionKey: 'millimanQuestionA',
                questionText: 'A. Do you have any of the following disorders or conditions? Please select all that apply.',
                required: true,
                requiredErrorMessage: 'Please select at least one answer from health question A',
                noneOfTheseApply: {
                    text: 'None of these apply.',
                    value: 'NONE',
                    key: 'NoneOfTheseApplyQA'
                },
                healthConditions: [
                    {
                        text: 'AIDS OR HIV',
                        value: 'AIDS',
                        key: 'AidsOrHIV'
                    },
                    {
                        text: 'Amyotrophic lateral sclerosis',
                        value: 'ALS',
                        key: 'AmyotrophicLateralSclerosis'
                    },
                    {
                        text: 'Cardiomyopathy',
                        value: 'CARDIO',
                        key: 'Cardiomyopathy'
                    },
                    {
                        text: 'Cerebral palsy',
                        value: 'CP',
                        key: 'Cerebralpalsy'
                    },
                    {
                        text: 'Currently receiving dialysis',
                        value: 'DIAL',
                        key: 'CurrentlyReceivingDialysis'
                    },
                    {
                        text: 'Cystic or pulmonary fibrosis',
                        value: 'CF',
                        key: 'CysticOrPulmonaryFibrosis'
                    },
                    {
                        text: 'End stage renal disease',
                        value: 'ESRD',
                        key: 'EndStageRenalDisease'
                    },
                    {
                        text: "Gaucher's or Pompe disease",
                        value: 'GAUPOM',
                        key: 'GauchersOrPompeDisease'
                    },
                    {
                        text: 'Growth hormone deficiency',
                        value: 'GHD',
                        key: 'GrowthHormoneDeficiency'
                    },
                    {
                        text: 'Hemophilia',
                        value: 'HEMO',
                        key: 'Hemophilia'
                    },
                    {
                        text: 'Hepatitis C',
                        value: 'HCV',
                        key: 'HepatitisC'
                    },
                    {
                        text: 'Hospital inpatient within past 90 days',
                        value: 'HOS90',
                        key: 'HospitalinpatientWithinPast90Days'
                    },
                    {
                        text: "Huntington's disease",
                        value: 'HUNT',
                        key: 'HuntingtonsDisease'
                    },
                    {
                        text: 'Kidney disease that may require dialysis',
                        value: 'KIDNEY',
                        key: 'KidneyDiseaseThatMayRequireDialysis'
                    },
                    {
                        text: 'Leukemia, lymphoma, malignant melanoma',
                        value: 'LEUK',
                        key: 'LeukemiaLymphomaMalignantMelanoma'
                    },
                    {
                        text: 'Muscular dystrophy',
                        value: 'MD',
                        key: 'MuscularDystrophy'
                    },
                    {
                        text: 'Organ or bone marrow transplant',
                        value: 'TRANS',
                        key: 'OrganOrBoneMarrowTransplant'
                    },
                    {
                        text: 'Paraplegia, quadriplegia or hemiplegia',
                        value: 'PARA',
                        key: 'ParaplegiaQuadriplegiaOrHemiplegia'
                    },
                    {
                        text: 'Pulmonary arterial hypertension',
                        value: 'PULMHYP',
                        key: 'PulmonaryArterialHypertension'
                    },
                    {
                        text: 'Spinocerebrellar disease',
                        value: 'SPCERB',
                        key: 'SpinocerebrellarDisease'
                    },
                    {
                        text: 'Stroke',
                        value: 'STROKE',
                        key: 'Stroke'
                    },
                    {
                        text: 'Other metabolic disorders',
                        value: 'OTHMETA',
                        key: 'OtherMetabolicDisorders'
                    },
                    {
                        text: 'Other neurodegenerative disorders',
                        value: 'OTHNEUR',
                        key: 'OtherNeurodegenerativeDisorders'
                    }
                ]
            },
            {
                questionKey: 'millimanQuestionB',
                questionText: "B. Within the past two years, has a medical professional discussed any of the following treatment options that haven't yet been addressed? Please select all that apply.",
                required: true,
                requiredErrorMessage: 'Please select at least one answer from health question B',
                noneOfTheseApply: {
                    text: 'None of these apply.',
                    value: 'NONE',
                    key: 'NoneOfTheseApplyQB'
                },
                healthConditions: [
                    {
                        text: 'Hospital admittance as an inpatient',
                        value: 'HOSP',
                        key: 'HospitalAdmittanceAsAnInpatient'
                    },
                    {
                        text: 'Organ transplant',
                        value: 'TRANS',
                        key: 'OrganTransplant'
                    },
                    {
                        text: 'Back or spine surgery',
                        value: 'SPINE',
                        key: 'CardiomyobackOrSpineSurgerypathy'
                    },
                    {
                        text: 'Joint replacement',
                        value: 'JTREP',
                        key: 'JointReplacement'
                    },
                    {
                        text: 'Surgery, radiation or chemotherapy for cancer',
                        value: 'CNCER',
                        key: 'SurgeryRadiationOrChemotherapyForCancer'
                    },
                    {
                        text: 'Heart surgery',
                        value: 'HEART',
                        key: 'HeartSurgery'
                    },
                    {
                        text: 'Vascular surgery',
                        value: 'VASCU',
                        key: 'VascularSurgery'
                    }
                ]
            },
            {
                questionKey: 'millimanQuestionC',
                questionText: 'C. Have you been diagnosed or treated (including taking medication) for any of the following conditions in the past five years? Please select all that apply.',
                required: true,
                requiredErrorMessage: 'Please select at least one answer from health question C',
                noneOfTheseApply: {
                    text: 'None of these apply.',
                    value: 'NONE',
                    key: 'NoneOfTheseApplyQC'
                },
                healthConditions: [
                    {
                        text: 'Angina or heart attack',
                        value: 'HEART',
                        key: 'AnginaOrHeartAttack'
                    },
                    {
                        text: 'Atrial fibrillation or flutter',
                        value: 'AFIB',
                        key: 'AtrialFibrillationOrFlutter'
                    },
                    {
                        text: 'Coronary or carotid artery disease',
                        value: 'CAD',
                        key: 'CoronaryOrCarotidArteryDisease'
                    },
                    {
                        text: 'Congestive heart failure',
                        value: 'CHF',
                        key: 'CongestiveHeartFailure'
                    },
                    {
                        text: 'COPD/emphysema',
                        value: 'COPD',
                        key: 'LungOrRespiratoryConditions'
                    },
                    {
                        text: 'Cancer (other than skin cancer)',
                        value: 'CNCER',
                        key: 'CancersOrTumors'
                    },
                    {
                        text: 'Chronic kidney disease',
                        value: 'CKD',
                        key: 'KidneyConditions'
                    },
                    {
                        text: 'Cirrhosis',
                        value: 'Yes',
                        key: 'LiverConditions'
                    },
                    {
                        text: "Alzheimer's disease or dementia",
                        value: 'ALZ',
                        key: 'AlzheimersDiseaseOrDementia'
                    },
                    {
                        text: 'Multiple sclerosis',
                        value: 'MS',
                        key: 'MultipleSclerosis'
                    },
                    {
                        text: "Parkinson's disease",
                        value: 'PD',
                        key: 'ParkinsonsDisease'
                    },
                    {
                        text: 'Diabetes with any of the following Circulatory, kidney or eye problems',
                        value: 'DIAB',
                        key: 'Diabetes'
                    },
                    {
                        text: "Crohn's disease or ulcerative colitis",
                        value: 'CHRHN',
                        key: 'ChronsDiseaseOrUlcerativeColitis'
                    },
                    {
                        text: 'Lupus',
                        value: 'LUPUS',
                        key: 'Lupus'
                    },
                    {
                        text: 'Rheumatoid arthritis',
                        value: 'RA',
                        key: 'RhuematoidArthritis'
                    },
                    {
                        text: 'Other immune deficiency',
                        value: 'OID',
                        key: 'OtherImmuneDeficiency'
                    },
                    {
                        text: 'Bipolar or schizophrenia',
                        value: 'BIPSZ',
                        key: 'BipolarOrSchizophrenia'
                    },
                    {
                        text: 'Major depression',
                        value: 'MAJDEP',
                        key: 'MajorDepression'
                    }
                ]
            },
            {
                questionKey: 'millimanQuestionD',
                questionText: 'D. Do you have any of the following chronic health conditions? Please select all that apply.',
                required: true,
                requiredErrorMessage: 'Please select at least one answer from health question D',
                noneOfTheseApply: {
                    text: 'None of these apply.',
                    value: 'NONE',
                    key: 'NoneOfTheseApplyQD'
                },
                healthConditions: [
                    {
                        text: 'Anxiety or mild depression',
                        value: 'ANX',
                        key: 'AnxietyOrMildDepression'
                    },
                    {
                        text: 'Arthritis',
                        value: 'ARTH',
                        key: 'AthritisHipKnee'
                    },
                    {
                        text: 'Asthma',
                        value: 'ASTH',
                        key: 'Asthma'
                    },
                    {
                        text: 'Diabetes (with no complications)',
                        value: 'DIAB',
                        key: 'DiabetesNoComplications'
                    },
                    {
                        text: 'Enlarged prostate (BPH)',
                        value: 'BPH',
                        key: 'EnlargedProstate'
                    },
                    {
                        text: 'Fibromyalgia',
                        value: 'FIBRO',
                        key: 'Fibromyalgia'
                    },
                    {
                        text: 'GERD/acid reflux',
                        value: 'GERD',
                        key: 'GERDAcidReflux'
                    },
                    {
                        text: 'Glaucoma or macular degeneration',
                        value: 'GLAMD',
                        key: 'GlaucomaOrMacularDegeneration'
                    },
                    {
                        text: 'High blood pressure',
                        value: 'HBP',
                        key: 'HighBloodPressure'
                    },
                    {
                        text: 'High cholesterol',
                        value: 'HCHL',
                        key: 'HighCholesterol'
                    },
                    {
                        text: 'Hypothyroidism or hyperthyroidism',
                        value: 'HYPT',
                        key: 'HypothyroidismOrHyperthyroidism'
                    },
                    {
                        text: 'Migraines',
                        value: 'MIGR',
                        key: 'Migraines'
                    },
                    {
                        text: 'Myasthenia gravis',
                        value: 'MYGR',
                        key: 'MyastheniaGravis'
                    },
                    {
                        text: 'Osteoporosis',
                        value: 'OSTEO',
                        key: 'Osteoporosis'
                    },
                    {
                        text: 'Psoriasis',
                        value: 'PSOR',
                        key: 'Psoriasis'
                    }
                ]
            }
        ]);
    }
}
MedSupMillimanFormFacade.ɵfac = function MedSupMillimanFormFacade_Factory(t) { return new (t || MedSupMillimanFormFacade)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.MillimanService), i0.ɵɵinject(i1.MedSupMillimanCryptoService)); };
MedSupMillimanFormFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MedSupMillimanFormFacade, factory: MedSupMillimanFormFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupMillimanFormFacade, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i2.Store }, { type: i1.ConfigResourceService }, { type: i1.MillimanService }, { type: i1.MedSupMillimanCryptoService }]; }, null); })();

class MedSupMillimanForm {
}
class MedSupMillimanHealthQuestion {
    constructor() {
        this.touched = false;
    }
}
class MedSupEmitData {
}
class MedSupMillimanEmitData extends MedSupEmitData {
}
var MedSupMillimanHealthConditionKey;
(function (MedSupMillimanHealthConditionKey) {
    MedSupMillimanHealthConditionKey["AIDS_OR_HIV"] = "AidsOrHIV";
    MedSupMillimanHealthConditionKey["AMYOTROPHIC_LATERAL_SCLEROSIS"] = "AmyotrophicLateralSclerosis";
    MedSupMillimanHealthConditionKey["CARDIOMYOPATHY"] = "Cardiomyopathy";
    MedSupMillimanHealthConditionKey["CEREBRAL_PALSY"] = "Cerebralpalsy";
    MedSupMillimanHealthConditionKey["CURRENTLY_RECEIVING_DIALYSIS"] = "CurrentlyReceivingDialysis";
    MedSupMillimanHealthConditionKey["CYSTIC_OR_PULMONARY_FIBROSIS"] = "CysticOrPulmonaryFibrosis";
    MedSupMillimanHealthConditionKey["END_STAGE_RENAL_DISEASE"] = "EndStageRenalDisease";
    MedSupMillimanHealthConditionKey["GAUCHERS_OR_POMPE_DISEASE"] = "GauchersOrPompeDisease";
    MedSupMillimanHealthConditionKey["GROWTH_HORMONE_DEFICIENCY"] = "GrowthHormoneDeficiency";
    MedSupMillimanHealthConditionKey["HEMOPHILIA"] = "Hemophilia";
    MedSupMillimanHealthConditionKey["HEPATITIS_C"] = "HepatitisC";
    MedSupMillimanHealthConditionKey["HOSPITAL_INPATIENT_WITHIN_PAST_90_DAYS"] = "HospitalinpatientWithinPast90Days";
    MedSupMillimanHealthConditionKey["HUNTINGTONS_DISEASE"] = "HuntingtonsDisease";
    MedSupMillimanHealthConditionKey["KIDNEY_DISEASE_THAT_MAY_REQUIRE_DIALYSIS"] = "KidneyDiseaseThatMayRequireDialysis";
    MedSupMillimanHealthConditionKey["LEUKEMIA_LYMPHOMA_MALIGNANT_MELANOMA"] = "LeukemiaLymphomaMalignantMelanoma";
    MedSupMillimanHealthConditionKey["MUSCULAR_DYSTROPHY"] = "MuscularDystrophy";
    MedSupMillimanHealthConditionKey["ORGAN_OR_BONE_MARROW_TRANSPLANT"] = "OrganOrBoneMarrowTransplant";
    MedSupMillimanHealthConditionKey["PARAPLEGIA_QUADRIPLEGIA_OR_HEMIPLEGIA"] = "ParaplegiaQuadriplegiaOrHemiplegia";
    MedSupMillimanHealthConditionKey["PULMONARY_ARTERIAL_HYPERTENSION"] = "PulmonaryArterialHypertension";
    MedSupMillimanHealthConditionKey["SPINOCEREBRELLAR_DISEASE"] = "SpinocerebrellarDisease";
    MedSupMillimanHealthConditionKey["STROKE"] = "Stroke";
    MedSupMillimanHealthConditionKey["OTHER_METABOLIC_DISORDERS"] = "OtherMetabolicDisorders";
    MedSupMillimanHealthConditionKey["OTHER_NEURODEGENERATIVE_DISORDERS"] = "OtherNeurodegenerativeDisorders";
    MedSupMillimanHealthConditionKey["HOSPITAL_ADMITTANCE_AS_AN_INPATIENT"] = "HospitalAdmittanceAsAnInpatient";
    MedSupMillimanHealthConditionKey["ORGAN_TRANSPLANT"] = "OrganTransplant";
    MedSupMillimanHealthConditionKey["BACK_OR_SPINE_SURGERY"] = "BackOrSpineSurgery";
    MedSupMillimanHealthConditionKey["JOINT_REPLACEMENT"] = "JointReplacement";
    MedSupMillimanHealthConditionKey["SURGERY_RADIATION_OR_CHEMOTHERAPY_FOR_CANCER"] = "SurgeryRadiationOrChemotherapyForCancer";
    MedSupMillimanHealthConditionKey["HEART_SURGERY"] = "HeartSurgery";
    MedSupMillimanHealthConditionKey["VASCULAR_SURGERY"] = "VascularSurgery";
    MedSupMillimanHealthConditionKey["ANGINA_OR_HEART_ATTACK"] = "AnginaOrHeartAttack";
    MedSupMillimanHealthConditionKey["ATRIAL_FIBRILLATION_OR_FLUTTER"] = "AtrialFibrillationOrFlutter";
    MedSupMillimanHealthConditionKey["CORONARY_OR_CAROTIDARTERY_DISEASE"] = "CoronaryOrCarotidArteryDisease";
    MedSupMillimanHealthConditionKey["CONGESTIVE_HEART_FAILURE"] = "CongestiveHeartFailure";
    MedSupMillimanHealthConditionKey["LUNG_OR_RESPIRATORY_CONDITIONS"] = "LungOrRespiratoryConditions";
    MedSupMillimanHealthConditionKey["CANCERS_OR_TUMORS"] = "CancersOrTumors";
    MedSupMillimanHealthConditionKey["ALZHEIMERS_DISEASE_OR_DEMENTIA"] = "AlzheimersDiseaseOrDementia";
    MedSupMillimanHealthConditionKey["MULTIPLE_SCLEROSIS"] = "MultipleSclerosis";
    MedSupMillimanHealthConditionKey["PARKINSONS_DISEASE"] = "ParkinsonsDisease";
    MedSupMillimanHealthConditionKey["DIABETES"] = "Diabetes";
    MedSupMillimanHealthConditionKey["KIDNEY_CONDITIONS"] = "KidneyConditions";
    MedSupMillimanHealthConditionKey["LIVER_CONDITIONS"] = "LiverConditions";
    MedSupMillimanHealthConditionKey["CHRONS_DISEASE_OR_ULCERATIVE_COLITIS"] = "ChronsDiseaseOrUlcerativeColitis";
    MedSupMillimanHealthConditionKey["LUPUS"] = "Lupus";
    MedSupMillimanHealthConditionKey["RHUEMATOID_ARTHRITIS"] = "RhuematoidArthritis";
    MedSupMillimanHealthConditionKey["OTHER_IMMUNE_DEFICIENCY"] = "OtherImmuneDeficiency";
    MedSupMillimanHealthConditionKey["BIPOLAR_OR_SCHIZOPHRENIA"] = "BipolarOrSchizophrenia";
    MedSupMillimanHealthConditionKey["MAJOR_DEPRESSION"] = "MajorDepression";
    MedSupMillimanHealthConditionKey["ANXIETY_OR_MILD_DEPRESSION"] = "AnxietyOrMildDepression";
    MedSupMillimanHealthConditionKey["ATHRITIS_HIP_KNEE"] = "AthritisHipKnee";
    MedSupMillimanHealthConditionKey["ASTHMA"] = "Asthma";
    MedSupMillimanHealthConditionKey["DIABETES_NO_COMPLICATIONS"] = "DiabetesNoComplications";
    MedSupMillimanHealthConditionKey["ENLARGED_PROSTATE"] = "EnlargedProstate";
    MedSupMillimanHealthConditionKey["FIBROMYALGIA"] = "Fibromyalgia";
    MedSupMillimanHealthConditionKey["GERD_ACID_REFLUX"] = "GERDAcidReflux";
    MedSupMillimanHealthConditionKey["GLAUCOMA_OR_MACULAR_DEGENERATION"] = "GlaucomaOrMacularDegeneration";
    MedSupMillimanHealthConditionKey["HIGH_BLOOD_PRESSURE"] = "HighBloodPressure";
    MedSupMillimanHealthConditionKey["HIGH_CHOLESTEROL"] = "HighCholesterol";
    MedSupMillimanHealthConditionKey["HYPOTHYROID_ISM_OR_HYPERTHYROIDISM"] = "HypothyroidismOrHyperthyroidism";
    MedSupMillimanHealthConditionKey["MIGRAINES"] = "Migraines";
    MedSupMillimanHealthConditionKey["MYASTHENIA_GRAVIS"] = "MyastheniaGravis";
    MedSupMillimanHealthConditionKey["OSTEOPOROSIS"] = "Osteoporosis";
    MedSupMillimanHealthConditionKey["PSORIASIS"] = "Psoriasis";
    MedSupMillimanHealthConditionKey["HEIGHT_FT"] = "HeightFt";
    MedSupMillimanHealthConditionKey["HEIGHT_IN"] = "HeightIn";
    MedSupMillimanHealthConditionKey["HEIGHT_FT_IN"] = "HeightFtIn";
    MedSupMillimanHealthConditionKey["WEIGHT_LBS"] = "WeightLbs";
    MedSupMillimanHealthConditionKey["APPLICANT_TOBACCO_USE"] = "ApplicantTobaccoUse";
    MedSupMillimanHealthConditionKey["ADMINISTERED_DRUGS_IND"] = "AdministeredDrugsInd";
    MedSupMillimanHealthConditionKey["HEIGHT"] = "Height";
    MedSupMillimanHealthConditionKey["WEIGHT"] = "Weight";
    MedSupMillimanHealthConditionKey["NONE_OF_THESE_APPLY_QA"] = "NoneOfTheseApplyQA";
    MedSupMillimanHealthConditionKey["NONE_OF_THESE_APPLY_QB"] = "NoneOfTheseApplyQB";
    MedSupMillimanHealthConditionKey["NONE_OF_THESE_APPLY_QC"] = "NoneOfTheseApplyQC";
    MedSupMillimanHealthConditionKey["NONE_OF_THESE_APPLY_QD"] = "NoneOfTheseApplyQD";
})(MedSupMillimanHealthConditionKey || (MedSupMillimanHealthConditionKey = {}));
var MemberInformationFormKeyConstants;
(function (MemberInformationFormKeyConstants) {
    MemberInformationFormKeyConstants["FIRST_NAME"] = "firstName";
    MemberInformationFormKeyConstants["MIDDLE_INITIAL"] = "middleInitial";
    MemberInformationFormKeyConstants["LAST_NAME"] = "lastName";
    MemberInformationFormKeyConstants["SOCIAL_SECURITY_NUMBER"] = "socialSecurityNumber";
    MemberInformationFormKeyConstants["ADDRESS1"] = "address1";
    MemberInformationFormKeyConstants["ADDRESS2"] = "address2";
    MemberInformationFormKeyConstants["STATE"] = "state";
    MemberInformationFormKeyConstants["CITY"] = "city";
    MemberInformationFormKeyConstants["ZIP"] = "zip";
    MemberInformationFormKeyConstants["DATE"] = "date";
    MemberInformationFormKeyConstants["APPLICANT_FULL_NAME"] = "applicantFullName";
    MemberInformationFormKeyConstants["AUTHORIZE"] = "authorize";
    MemberInformationFormKeyConstants["WEIGHT"] = "weight";
    MemberInformationFormKeyConstants["HEIGHT"] = "height";
    MemberInformationFormKeyConstants["HEIGHT_FT"] = "heightFt";
    MemberInformationFormKeyConstants["HEIGHT_IN"] = "heightIn";
})(MemberInformationFormKeyConstants || (MemberInformationFormKeyConstants = {}));
const SOCIAL_SECURITY_NUMBER_REQUIRED_TEXT = 'Social Security number is required';
const SOCIAL_SECURITY_NUMBER_TEXT = 'Social Security number';
const ADDRESS1_TEXT = 'Address 1';
const ADDRESS1_REQUIRED_TEXT = 'Address 1 is required';
const ADDRESS2_TEXT = 'Address 2';
const ADDRESS2_REQUIRED_TEXT = 'Address 2 is required';
const CITY_TEXT = 'City';
const CITY_REQUIRED_TEXT = 'City is required';
const STATE_TEXT = 'State';
const STATE_REQUIRED_TEXT = 'State is required';
const ZIP_REQUIRED_TEXT = 'Zip is required';
const ZIP_TEXT = 'Zip';
const LAST_NAME_REQUIRED_TEXT = 'Last name is required';
const LAST_NAME_TEXT = 'Last name';
const MIDDLE_INITIAL_REQUIRED_TEXT = 'Middle initial is required';
const MIDDLE_INITIAL_TEXT = 'M.I.';
const FIRST_NAME_REQUIRED_TEXT = 'First name is required';
const FIRST_NAME_TEXT = 'First name';
const DATE_TEXT = 'Date';
const APPLICANT_FULL_NAME_TEXT = 'Applicant full name';
const DATE_REQUIRED_TEXT = 'Date is required';
const APPLICANT_FULL_NAME_REQUIRED_TEXT = 'Applicant full name is required';
const AUTHORIZATION_REQUIRED_TEXT = 'Authorization is required';
const AUTHORIZE_LABEL_TEXT = 'I have read and authorize the plan to use my medical and drug information.';
const HEIGHT_REQUIRED_TEXT = 'Height is required';
const HEIGHT_LABEL_TEXT = 'Height';
const WEIGHT_REQUIRED_TEXT = 'Weight is required';
const WEIGHT_LABEL_TEXT = 'Weight';
const MILLIMAN_DEFAULT_STATE = 'MI';
const MILLIMAN_HEALTH_QUESTION_A_KEY = 'millimanQuestionA';
const MILLIMAN_HEALTH_QUESTION_B_KEY = 'millimanQuestionB';
const MILLIMAN_HEALTH_QUESTION_C_KEY = 'millimanQuestionC';
const MILLIMAN_HEALTH_QUESTION_D_KEY = 'millimanQuestionD';

class MedSupMillimanService {
    constructor(store, profileService, sessionService, medSupMillimanCryptoService) {
        this.store = store;
        this.profileService = profileService;
        this.sessionService = sessionService;
        this.medSupMillimanCryptoService = medSupMillimanCryptoService;
    }
    getMillimanSecretKey() {
        return this.medSupMillimanCryptoService.getMillimanSecretKey();
    }
    setMillimanAuthorizationFields(memberInformation) {
        const applicantFullName = this.getApplicantFullName(memberInformation);
        const authorizeDate = this.getAuthorizeDate(memberInformation);
        const authorizeUse = this.getAuthorizeUse(memberInformation);
        this.store.dispatch(new SetMillimanAuthorizationFields(applicantFullName, authorizeDate, authorizeUse));
    }
    setMillimanSocialSecurityNumberInformation(memberInformation) {
        const secretKeyRandomElement = uuid();
        const socialSecurityNumber = this.getSocialSecurityNumber(memberInformation);
        const encrypted = this.medSupMillimanCryptoService.encrypt(socialSecurityNumber, secretKeyRandomElement + this.getMillimanSecretKey());
        this.store.dispatch(new SetMillimanApplicantId(encrypted, secretKeyRandomElement));
    }
    hasMemberInformationChanged(memberInformation) {
        const firstName = this.getFirstName(memberInformation);
        const profileFirstName = this.profileService.getFirstName();
        if (firstName !== profileFirstName) {
            return true;
        }
        const middleInitial = this.getMiddleInitial(memberInformation);
        const profileMiddleInitial = this.profileService.getMiddleInitial();
        if (middleInitial !== profileMiddleInitial) {
            return true;
        }
        const lastName = this.getLastName(memberInformation);
        const profileLastName = this.profileService.getLastName();
        if (lastName !== profileLastName) {
            return true;
        }
        const address1 = this.getAddress1(memberInformation);
        const profileAddress1 = this.profileService.getAddress1();
        if (address1 !== profileAddress1) {
            return true;
        }
        const address2 = this.getAddress2(memberInformation);
        const profileAddress2 = this.profileService.getAddress2();
        if (address2 !== profileAddress2) {
            return true;
        }
        const city = this.getCity(memberInformation);
        const profileCity = this.profileService.getCity();
        if (city !== profileCity) {
            return true;
        }
        const state = this.getState(memberInformation);
        const profileState = this.profileService.getState();
        if (state !== profileState) {
            return true;
        }
        const zip = this.getZip(memberInformation);
        const profileZip = this.profileService.getZip();
        if (zip !== profileZip) {
            return true;
        }
        return false;
    }
    async processMemberProfileInformation(memberInformation, birthDate, gender) {
        const firstName = this.getFirstName(memberInformation);
        const middleInitial = this.getMiddleInitial(memberInformation);
        const lastName = this.getLastName(memberInformation);
        const address1 = this.getAddress1(memberInformation);
        const address2 = this.getAddress2(memberInformation);
        const city = this.getCity(memberInformation);
        const state = this.getState(memberInformation);
        const zip = this.getZip(memberInformation);
        const memberProfileFields = {
            firstName,
            middleInitial,
            lastName,
            birthDate,
            gender,
            address1,
            address2,
            city,
            state,
            zip
        };
        if (!this.profileService.hasMemberProfile()) {
            await this.createNewMemberProfile(memberProfileFields);
        }
        else {
            await this.updateMemberProfile(memberProfileFields);
        }
    }
    getApplicantId() {
        return this.store.selectSnapshot(MillimanState.applicantId);
    }
    getApplicantSecretKeyValue() {
        return this.store.selectSnapshot(MillimanState.keyValue);
    }
    addApplicantIdToMillimanHealthInformation(millimanHealthInformation) {
        const keyValue = this.getApplicantSecretKeyValue();
        const applicantId = this.getApplicantId();
        millimanHealthInformation.applicantId = applicantId;
        millimanHealthInformation.keyValue = keyValue;
        return millimanHealthInformation;
    }
    getDecryptedApplicantId() {
        return this.medSupMillimanCryptoService.getDecryptedApplicantId();
    }
    processMillimanHealthQuestions(healthQuestions, millimanHealthInformation) {
        millimanHealthInformation.MedicalQuestionDialysis = this.getMedicalQuestionDialysis(healthQuestions, millimanHealthInformation);
        millimanHealthInformation.MedicalConditionPastTwoYears = this.getMedicalConditionPastTwoYears(healthQuestions, millimanHealthInformation);
        return millimanHealthInformation;
    }
    addTierStatusToHealthInformation(millimanHealthInformation) {
        const uwFlag = this.store.selectSnapshot(MillimanState.uwFlag);
        const serviceCalledNow = this.store.selectSnapshot(MillimanState.serviceCalledNow);
        millimanHealthInformation.UWFlag = uwFlag;
        millimanHealthInformation.serviceCalledNow = serviceCalledNow;
        return millimanHealthInformation;
    }
    addHeightAndWeightToHealthInformation(memberInformation, millimanHealthInformation) {
        const weight = this.getWeight(memberInformation);
        const heightFt = this.getHeightFt(memberInformation);
        const heightIn = this.getHeightIn(memberInformation);
        millimanHealthInformation.WeightLbs = weight;
        millimanHealthInformation.HeightFt = heightFt;
        millimanHealthInformation.HeightIn = heightIn;
        millimanHealthInformation.HeightFtIn = (parseInt(heightFt, 10) * 12 + parseInt(heightIn, 10)).toString();
        return millimanHealthInformation;
    }
    getAuthorizeUse(memberInformation) {
        return memberInformation.find(info => info.questionKey === MemberInformationFormKeyConstants.AUTHORIZE)?.value;
    }
    getAuthorizeDate(memberInformation) {
        return memberInformation.find(info => info.questionKey === MemberInformationFormKeyConstants.DATE)?.value;
    }
    getApplicantFullName(memberInformation) {
        return memberInformation.find(info => info.questionKey === MemberInformationFormKeyConstants.APPLICANT_FULL_NAME)?.value;
    }
    getSocialSecurityNumber(memberInformation) {
        return memberInformation.find(info => info.questionKey === MemberInformationFormKeyConstants.SOCIAL_SECURITY_NUMBER)?.value;
    }
    getZip(memberInformation) {
        return memberInformation.find(info => info.questionKey === MemberInformationFormKeyConstants.ZIP)?.value;
    }
    getState(memberInformation) {
        return memberInformation.find(info => info.questionKey === MemberInformationFormKeyConstants.STATE)?.value;
    }
    getCity(memberInformation) {
        return memberInformation.find(info => info.questionKey === MemberInformationFormKeyConstants.CITY)?.value;
    }
    getAddress2(memberInformation) {
        return memberInformation.find(info => info.questionKey === MemberInformationFormKeyConstants.ADDRESS2)?.value;
    }
    getAddress1(memberInformation) {
        return memberInformation.find(info => info.questionKey === MemberInformationFormKeyConstants.ADDRESS1)?.value;
    }
    getLastName(memberInformation) {
        return memberInformation.find(info => info.questionKey === MemberInformationFormKeyConstants.LAST_NAME)?.value;
    }
    getMiddleInitial(memberInformation) {
        return memberInformation.find(info => info.questionKey === MemberInformationFormKeyConstants.MIDDLE_INITIAL)?.value;
    }
    getFirstName(memberInformation) {
        return memberInformation.find(info => info.questionKey === MemberInformationFormKeyConstants.FIRST_NAME)?.value;
    }
    getWeight(memberInformation) {
        return memberInformation.find(info => info.questionKey === MemberInformationFormKeyConstants.WEIGHT)?.value;
    }
    getHeightFt(memberInformation) {
        return memberInformation.find(info => info.questionKey === MemberInformationFormKeyConstants.HEIGHT_FT)?.value;
    }
    getHeightIn(memberInformation) {
        return memberInformation.find(info => info.questionKey === MemberInformationFormKeyConstants.HEIGHT_IN)?.value;
    }
    getHealthQuestion(key, healthQuestions) {
        return healthQuestions?.find(question => question.questionKey === key);
    }
    getHealthQuestionKeys(healthQuestion, excludedKey) {
        return healthQuestion?.healthConditions
            .filter((healthCondition) => healthCondition.key !== excludedKey)
            .map((condition) => condition.key);
    }
    getMedicalQuestionDialysis(healthQuestions, millimanHealthInformation) {
        return this.getHealthQuestionKeyValues(MILLIMAN_HEALTH_QUESTION_A_KEY, MedSupMillimanHealthConditionKey.NONE_OF_THESE_APPLY_QA, healthQuestions, millimanHealthInformation);
    }
    getMedicalConditionPastTwoYears(healthQuestions, millimanHealthInformation) {
        return this.getHealthQuestionKeyValues(MILLIMAN_HEALTH_QUESTION_B_KEY, MedSupMillimanHealthConditionKey.NONE_OF_THESE_APPLY_QB, healthQuestions, millimanHealthInformation);
    }
    getHealthQuestionKeyValues(questionKey, excludedKey, healthQuestions, millimanHealthInformation) {
        const healthQuestion = this.getHealthQuestion(questionKey, healthQuestions);
        const questionKeys = this.getHealthQuestionKeys(healthQuestion, excludedKey);
        return questionKeys
            .reduce((questionSelections, selection) => {
            const selectedValue = millimanHealthInformation[selection];
            if (selectedValue) {
                questionSelections.push(selectedValue);
            }
            return questionSelections;
        }, [])
            .join(',');
    }
    async createNewMemberProfile(millimanMemberProfileFields) {
        const profile = {
            firstName: millimanMemberProfileFields.firstName,
            middleInitial: millimanMemberProfileFields.middleInitial,
            lastName: millimanMemberProfileFields.lastName,
            birthdate: millimanMemberProfileFields.birthDate,
            gender: millimanMemberProfileFields.gender,
            maritalStatus: 0,
            workPhone: '',
            homePhone: '',
            cellPhone: '',
            emailAddress: '',
            addresses: [
                {
                    address1: millimanMemberProfileFields.address1,
                    address2: millimanMemberProfileFields.address2,
                    city: millimanMemberProfileFields.city,
                    state: millimanMemberProfileFields.state,
                    countyFips: '',
                    zip: millimanMemberProfileFields.zip,
                    isPrimaryAddress: true
                }
            ]
        };
        const apiMemberStateModel = {
            agentGuid: this.store.selectSnapshot(AgentState.agentGuid),
            memberID: this.store.selectSnapshot(MemberState.memberID),
            demographic: {
                zip: millimanMemberProfileFields.zip,
                fips: this.store.selectSnapshot(DemographicState.selectedFipsCode)
            },
            profile
        };
        await this.sessionService.updateSession(this.sessionService.getMemberSessionId(), apiMemberStateModel);
    }
    async updateMemberProfile(millimanMemberProfileFields) {
        const profile = {
            firstName: millimanMemberProfileFields.firstName,
            middleInitial: millimanMemberProfileFields.middleInitial,
            lastName: millimanMemberProfileFields.lastName,
            birthdate: millimanMemberProfileFields.birthDate,
            gender: millimanMemberProfileFields.gender,
            maritalStatus: 0,
            addresses: [
                {
                    address1: millimanMemberProfileFields.address1,
                    address2: millimanMemberProfileFields.address2,
                    city: millimanMemberProfileFields.city,
                    state: millimanMemberProfileFields.state,
                    countyFips: '',
                    zip: millimanMemberProfileFields.zip,
                    isPrimaryAddress: true
                }
            ]
        };
        const apiMemberStateModel = {
            agentGuid: this.store.selectSnapshot(AgentState.agentGuid),
            memberID: this.store.selectSnapshot(MemberState.memberID),
            profile
        };
        await this.sessionService.updateSession(this.sessionService.getMemberSessionId(), apiMemberStateModel);
    }
}
MedSupMillimanService.ɵfac = function MedSupMillimanService_Factory(t) { return new (t || MedSupMillimanService)(i0.ɵɵinject(i2.Store), i0.ɵɵinject(i1.ProfileService), i0.ɵɵinject(i1.MemberSessionService), i0.ɵɵinject(i1.MedSupMillimanCryptoService)); };
MedSupMillimanService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MedSupMillimanService, factory: MedSupMillimanService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupMillimanService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i2.Store }, { type: i1.ProfileService }, { type: i1.MemberSessionService }, { type: i1.MedSupMillimanCryptoService }]; }, null); })();

const _c0$1c = ["typeahead"];
const _c1$w = ["addressSearchInput"];
function MedsupMillimanAuthorizationComponent_div_8_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r33.firstNameRequiredText);
} }
function MedsupMillimanAuthorizationComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 73);
    i0.ɵɵelement(1, "i", 74);
    i0.ɵɵtemplate(2, MedsupMillimanAuthorizationComponent_div_8_span_2_Template, 2, 1, "span", 63);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isFirstNameRequired);
} }
function MedsupMillimanAuthorizationComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 75);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MedsupMillimanAuthorizationComponent_div_17_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r34.middleInitialRequiredText);
} }
function MedsupMillimanAuthorizationComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 76);
    i0.ɵɵelement(1, "i", 74);
    i0.ɵɵtemplate(2, MedsupMillimanAuthorizationComponent_div_17_span_2_Template, 2, 1, "span", 63);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.isMiddleInitialRequired);
} }
function MedsupMillimanAuthorizationComponent_span_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 75);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MedsupMillimanAuthorizationComponent_div_26_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r35.lastNameRequiredText);
} }
function MedsupMillimanAuthorizationComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 77);
    i0.ɵɵelement(1, "i", 74);
    i0.ɵɵtemplate(2, MedsupMillimanAuthorizationComponent_div_26_span_2_Template, 2, 1, "span", 63);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.isLastNameRequired);
} }
function MedsupMillimanAuthorizationComponent_span_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 75);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MedsupMillimanAuthorizationComponent_div_35_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r36.socialSecurityNumberRequiredText);
} }
function MedsupMillimanAuthorizationComponent_div_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 78);
    i0.ɵɵelement(1, "i", 74);
    i0.ɵɵtemplate(2, MedsupMillimanAuthorizationComponent_div_35_span_2_Template, 2, 1, "span", 63);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r6.isSocialSecurityNumberRequired);
} }
function MedsupMillimanAuthorizationComponent_span_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 75);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MedsupMillimanAuthorizationComponent_div_45_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r37.address1RequiredText);
} }
function MedsupMillimanAuthorizationComponent_div_45_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 79);
    i0.ɵɵelement(1, "i", 74);
    i0.ɵɵtemplate(2, MedsupMillimanAuthorizationComponent_div_45_span_2_Template, 2, 1, "span", 63);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r8.isAddress1Required);
} }
function MedsupMillimanAuthorizationComponent_span_47_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 75);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MedsupMillimanAuthorizationComponent_ng_template_50_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r38 = i0.ɵɵnextContext().result;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", r_r38.secondary, "");
} }
function MedsupMillimanAuthorizationComponent_ng_template_50_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r38 = i0.ɵɵnextContext().result;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(", ", r_r38.zipcode, "");
} }
function MedsupMillimanAuthorizationComponent_ng_template_50_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 80);
    i0.ɵɵelement(1, "ngb-highlight", 81);
    i0.ɵɵtemplate(2, MedsupMillimanAuthorizationComponent_ng_template_50_span_2_Template, 2, 1, "span", 63);
    i0.ɵɵtext(3);
    i0.ɵɵtemplate(4, MedsupMillimanAuthorizationComponent_ng_template_50_span_4_Template, 2, 1, "span", 63);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r38 = ctx.result;
    const t_r39 = ctx.term;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("result", r_r38.street_line)("term", t_r39);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", r_r38.secondary);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", r_r38.city, " ", r_r38.state, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", r_r38.zipcode);
} }
function MedsupMillimanAuthorizationComponent_div_58_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r44.address2RequiredText);
} }
function MedsupMillimanAuthorizationComponent_div_58_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 82);
    i0.ɵɵelement(1, "i", 74);
    i0.ɵɵtemplate(2, MedsupMillimanAuthorizationComponent_div_58_span_2_Template, 2, 1, "span", 63);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r14.isAddress2Required);
} }
function MedsupMillimanAuthorizationComponent_span_60_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 75);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MedsupMillimanAuthorizationComponent_div_67_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r45.cityRequiredText);
} }
function MedsupMillimanAuthorizationComponent_div_67_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 83);
    i0.ɵɵelement(1, "i", 74);
    i0.ɵɵtemplate(2, MedsupMillimanAuthorizationComponent_div_67_span_2_Template, 2, 1, "span", 63);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r16.isCityRequired);
} }
function MedsupMillimanAuthorizationComponent_span_69_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 75);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MedsupMillimanAuthorizationComponent_div_75_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r46.stateRequiredText);
} }
function MedsupMillimanAuthorizationComponent_div_75_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 84);
    i0.ɵɵelement(1, "i", 74);
    i0.ɵɵtemplate(2, MedsupMillimanAuthorizationComponent_div_75_span_2_Template, 2, 1, "span", 63);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r18.isStateRequired);
} }
function MedsupMillimanAuthorizationComponent_span_77_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 75);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MedsupMillimanAuthorizationComponent_div_85_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r47.zipRequiredText);
} }
function MedsupMillimanAuthorizationComponent_div_85_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 85);
    i0.ɵɵelement(1, "i", 74);
    i0.ɵɵtemplate(2, MedsupMillimanAuthorizationComponent_div_85_span_2_Template, 2, 1, "span", 63);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r20.isZipRequired);
} }
function MedsupMillimanAuthorizationComponent_span_87_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 75);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MedsupMillimanAuthorizationComponent_div_95_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r48.heightFtRequiredText);
} }
function MedsupMillimanAuthorizationComponent_div_95_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 86);
    i0.ɵɵelement(1, "i", 74);
    i0.ɵɵtemplate(2, MedsupMillimanAuthorizationComponent_div_95_span_2_Template, 2, 1, "span", 63);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r22.isHeightRequired);
} }
function MedsupMillimanAuthorizationComponent_span_97_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 75);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MedsupMillimanAuthorizationComponent_div_110_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r49.weightRequiredText);
} }
function MedsupMillimanAuthorizationComponent_div_110_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 87);
    i0.ɵɵelement(1, "i", 74);
    i0.ɵɵtemplate(2, MedsupMillimanAuthorizationComponent_div_110_span_2_Template, 2, 1, "span", 63);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r24.isWeightRequired);
} }
function MedsupMillimanAuthorizationComponent_span_112_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 75);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MedsupMillimanAuthorizationComponent_div_127_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r50.applicantFullNameRequiredText);
} }
function MedsupMillimanAuthorizationComponent_div_127_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 88);
    i0.ɵɵelement(1, "i", 74);
    i0.ɵɵtemplate(2, MedsupMillimanAuthorizationComponent_div_127_span_2_Template, 2, 1, "span", 63);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r26.isApplicantFullNameRequired);
} }
function MedsupMillimanAuthorizationComponent_span_129_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 75);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function MedsupMillimanAuthorizationComponent_div_136_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r51 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r51.dateRequiredText);
} }
function MedsupMillimanAuthorizationComponent_div_136_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 89);
    i0.ɵɵelement(1, "i", 74);
    i0.ɵɵtemplate(2, MedsupMillimanAuthorizationComponent_div_136_span_2_Template, 2, 1, "span", 63);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r28.isDateRequired);
} }
function MedsupMillimanAuthorizationComponent_span_138_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 75);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
const _c2$m = function (a0) { return { "has-error": a0 }; };
function MedsupMillimanAuthorizationComponent_ng_container_143_Template(rf, ctx) { if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "input", 90, 91);
    i0.ɵɵlistener("dateSelect", function MedsupMillimanAuthorizationComponent_ng_container_143_Template_input_dateSelect_1_listener($event) { i0.ɵɵrestoreView(_r54); const ctx_r53 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r53.onDateSelection($event)); })("select", function MedsupMillimanAuthorizationComponent_ng_container_143_Template_input_select_1_listener($event) { i0.ɵɵrestoreView(_r54); const ctx_r55 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r55.onDateSelection($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 92);
    i0.ɵɵlistener("click", function MedsupMillimanAuthorizationComponent_ng_container_143_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r54); const _r52 = i0.ɵɵreference(2); return i0.ɵɵresetView(_r52.toggle()); });
    i0.ɵɵelement(4, "i", 93);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("minDate", ctx_r30.datePickerMinDate)("maxDate", ctx_r30.datePickerMaxDate)("ngClass", i0.ɵɵpureFunction1(3, _c2$m, ctx_r30.hasDateError()));
} }
function MedsupMillimanAuthorizationComponent_div_149_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r57 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r57.authorizationRequiredText);
} }
function MedsupMillimanAuthorizationComponent_div_149_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 94);
    i0.ɵɵelement(1, "i", 74);
    i0.ɵɵtemplate(2, MedsupMillimanAuthorizationComponent_div_149_span_2_Template, 2, 1, "span", 63);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r31.isAuthorizationRequired);
} }
function MedsupMillimanAuthorizationComponent_span_154_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 75);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
const _c3$d = function (a0) { return { "error-color": a0 }; };
class MedsupMillimanAuthorizationComponent {
    constructor(cdr, addressService, autoCompleteService, medSupMillimanFormFacade, configResourceService) {
        this.cdr = cdr;
        this.addressService = addressService;
        this.autoCompleteService = autoCompleteService;
        this.medSupMillimanFormFacade = medSupMillimanFormFacade;
        this.configResourceService = configResourceService;
        this.showDatePicker = true;
        this.formError = new EventEmitter();
        this.onUpdateMemberInformation = new EventEmitter();
        //#endregion
        this.millimanMemberProfileForm = new UntypedFormGroup({});
        this.suggestedAddresses = (text$) => {
            if (!this.millimanAutoCompleteEnabled) {
                return of([]);
            }
            return this.addressService.getAddresses$(text$.pipe(map(text => ({ partialAddress: text, zip: this.millimanMemberProfileForm.get('zip').value, selected: '' }))));
        };
        this.addressAutocompleteFormatter = (address) => address.street_line;
    }
    ngOnInit() {
        this.setComponentAttributes();
        this.initializeForm();
        this.setAddressSearchTerm();
        this.subscriptions = [
            this.medSupMillimanFormFacade.onValidateMedSupForm$.subscribe(() => {
                this.millimanMemberProfileForm.markAsTouched({ onlySelf: true });
                Object.values(this.millimanMemberProfileForm.controls)
                    .filter(control => control.enabled)
                    .map(control => control.markAsTouched({ onlySelf: true }));
                this.cdr.markForCheck();
                const errors = this.getMillimanFormErrorEmitData();
                const formAnswers = this.getMillimanAuthorizationAnswers();
                this.onUpdateMemberInformation.emit(formAnswers);
                this.formError.emit(errors);
            })
        ];
    }
    ngAfterViewInit() {
        this.initializeSearchTerm();
    }
    onChangeAddressSearchTerm(value) {
        if (value !== this.addressSearchTerm) {
            this.addressSearchTerm = value;
        }
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    onDateSelection(dateSelection) {
        const month = this.getMonthAsString(dateSelection);
        const day = this.getDayAsString(dateSelection);
        const date = `${month}/${day}/${dateSelection.year}`;
        this.millimanMemberProfileForm.get('date').setValue(date);
    }
    fieldHasError(fieldName) {
        const control = this.millimanMemberProfileForm.get(fieldName);
        if (this.millimanMemberProfileForm.touched) {
            return !control.valid && control.touched;
        }
        return false;
    }
    hasFirstNameError() {
        return this.fieldHasError(MemberInformationFormKeyConstants.FIRST_NAME);
    }
    hasMiddleInitialError() {
        return this.fieldHasError(MemberInformationFormKeyConstants.MIDDLE_INITIAL);
    }
    hasLastNameError() {
        return this.fieldHasError(MemberInformationFormKeyConstants.LAST_NAME);
    }
    hasSocialSecurityNumberError() {
        return this.fieldHasError(MemberInformationFormKeyConstants.SOCIAL_SECURITY_NUMBER);
    }
    hasAddress1Error() {
        return this.fieldHasError(MemberInformationFormKeyConstants.ADDRESS1);
    }
    hasAddress2Error() {
        return this.fieldHasError(MemberInformationFormKeyConstants.ADDRESS2);
    }
    hasCityError() {
        return this.fieldHasError(MemberInformationFormKeyConstants.CITY);
    }
    hasStateError() {
        return this.fieldHasError(MemberInformationFormKeyConstants.STATE);
    }
    hasZipCodeError() {
        return this.fieldHasError(MemberInformationFormKeyConstants.ZIP);
    }
    hasDateError() {
        return this.fieldHasError(MemberInformationFormKeyConstants.DATE);
    }
    hasApplicantFullNameError() {
        return this.fieldHasError(MemberInformationFormKeyConstants.APPLICANT_FULL_NAME);
    }
    hasAuthorizationError() {
        return this.fieldHasError(MemberInformationFormKeyConstants.AUTHORIZE);
    }
    hasHeightFtError() {
        return this.fieldHasError(MemberInformationFormKeyConstants.HEIGHT_FT);
    }
    hasHeightInError() {
        return this.fieldHasError(MemberInformationFormKeyConstants.HEIGHT_IN);
    }
    hasHeightError() {
        return this.hasHeightFtError() || this.hasHeightInError();
    }
    hasWeightError() {
        return this.fieldHasError(MemberInformationFormKeyConstants.WEIGHT);
    }
    scrollItemIntoView() {
        this.autoCompleteService.scrollItemIntoView(this.typeahead);
    }
    selectItemForAddress(event) {
        const address = event.item;
        this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.ADDRESS1).setValue(address.street_line ? address.street_line : '');
        this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.CITY).setValue(address.city ? address.city : '');
        this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.ADDRESS2).setValue(address.secondary ? address.secondary : '');
        this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.STATE).setValue(address.state ? address.state : '');
        this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.ZIP).setValue(address.zipcode ? address.zipcode : '');
        this.typeahead.dismissPopup();
        this.cdr.detectChanges();
    }
    mapSearchTermToAddress(event) {
        this.onChangeAddressSearchTerm(event.target.value);
        const address1Field = this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.ADDRESS1);
        const address1 = address1Field?.value;
        if (!this.addressSearchTerm) {
            address1Field.markAsTouched();
            address1Field.setErrors({ invalid: true });
            this.cdr.markForCheck();
        }
        if (address1 !== this.addressSearchTerm) {
            address1Field.setValue(this.addressSearchTerm);
        }
    }
    getDayAsString(dateValue) {
        if (dateValue) {
            return dateValue.day.toString().length === 1 ? `0${dateValue.day}` : `${dateValue.day}`;
        }
        return this.getDefaultDay();
    }
    getMonthAsString(dateValue) {
        if (dateValue) {
            return dateValue.month.toString().length === 1 ? `0${dateValue.month}` : `${dateValue.month}`;
        }
        return this.getDefaultMonth();
    }
    getDefaultDay() {
        const defaultDate = new Date().getDate();
        return defaultDate.toString().length === 1 ? `0${defaultDate}` : `${defaultDate}`;
    }
    getDefaultMonth() {
        const defaultMonth = new Date().getMonth() + 1;
        return defaultMonth.toString().length === 1 ? `0${defaultMonth}` : `${defaultMonth}`;
    }
    setComponentAttributes() {
        this.millimanAutoCompleteEnabled = this.medSupMillimanFormFacade.getMillimanAutoCompleteEnabled();
        this.millimanApplicantNameMustMatchText = this.medSupMillimanFormFacade.getMillimanApplicantsNameMuchMatchText();
        this.millimanJustAFewMoreQuestionsText = this.medSupMillimanFormFacade.getMillimanJustAFewMoreQuestionsText();
        this.millimanAuthorizationHeaderText = this.medSupMillimanFormFacade.getMillimanAuthorizationHeaderText();
        this.millimanAuthorizationText = this.medSupMillimanFormFacade.getMillimanAuthorizationText();
        this.millimanHealthInformation = this.medSupMillimanFormFacade.getMillimanHealthInformation();
        this.memberInformation = this.medSupMillimanFormFacade.getMillimanMemberInformationFormFields();
        this.memberStateModel = this.medSupMillimanFormFacade.getMemberStateModel();
        this.sessionApplicantFullName = this.medSupMillimanFormFacade.getApplicantFullName();
        this.sessionAuthorizeDate = this.medSupMillimanFormFacade.getAuthorizeDate();
        this.sessionAuthorizeUse = this.medSupMillimanFormFacade.getAuthorizeUse();
        this.sessionApplicantSSN = this.medSupMillimanFormFacade.getDecryptedApplicantId();
        this.inchLabelText = this.medSupMillimanFormFacade.getMillimanInchesLabelText();
        this.feetLabelText = this.medSupMillimanFormFacade.getMillimanFeetLabelText();
        this.poundsLabelText = this.medSupMillimanFormFacade.getMillimanPoundsLabelText();
        this.setSocialSecurityNumberMask();
        this.setDateMaskFormat();
        this.setDateDefaultFormat();
        this.setFormFieldAttributes();
    }
    setFormFieldAttributes() {
        this.setFirstNameFieldAttributes();
        this.setMiddleInitialFieldAttributes();
        this.setLastNameFieldAttributes();
        this.setSocialSecurityFieldAttributes();
        this.setAddress1FieldAttributes();
        this.setAddress2FieldAttributes();
        this.setCityFieldAttributes();
        this.setStateFieldAttributes();
        this.setZipFieldAttributes();
        this.setDateFieldAttributes();
        this.setApplicantFullNameFieldAttributes();
        this.setAcceptTermsCheckboxFieldAttributes();
        this.setHeightFieldsAttributes();
        this.setWeightFieldAttributes();
    }
    setSocialSecurityNumberMask() {
        this.socialSecurityNumberMask = FormValidationService.socialSecurityNumberMask;
    }
    setDateDefaultFormat() {
        this.dateDefaultFormat = DateUtilities.defaultFormat;
    }
    setDateMaskFormat() {
        this.dateMaskFormat = DateUtilities.defaultFormat.replace(/\w/g, '0');
    }
    setAddressSearchTerm() {
        this.addressSearchTerm = this.millimanMemberProfileForm?.get(MemberInformationFormKeyConstants.ADDRESS1)?.value;
    }
    getMemberInformationField(key) {
        return this.memberInformation?.find(field => field.keyName === key);
    }
    setFirstNameFieldAttributes() {
        const firstName = this.getMemberInformationField(MemberInformationFormKeyConstants.FIRST_NAME);
        this.firstNameLabelText = firstName ? firstName.labelText : FIRST_NAME_TEXT;
        this.firstNameRequiredText = firstName ? firstName.requiredText : FIRST_NAME_REQUIRED_TEXT;
        this.isFirstNameRequired = firstName ? firstName.required : false;
    }
    setMiddleInitialFieldAttributes() {
        const middleInitial = this.getMemberInformationField(MemberInformationFormKeyConstants.MIDDLE_INITIAL);
        this.middleInitialLabelText = middleInitial ? middleInitial.labelText : MIDDLE_INITIAL_TEXT;
        this.middleInitialRequiredText = middleInitial ? middleInitial.requiredText : MIDDLE_INITIAL_REQUIRED_TEXT;
        this.isMiddleInitialRequired = middleInitial ? middleInitial.required : false;
    }
    setLastNameFieldAttributes() {
        const lastName = this.getMemberInformationField(MemberInformationFormKeyConstants.LAST_NAME);
        this.lastNameLabelText = lastName ? lastName.labelText : LAST_NAME_TEXT;
        this.lastNameRequiredText = lastName ? lastName.requiredText : LAST_NAME_REQUIRED_TEXT;
        this.isLastNameRequired = lastName ? lastName.required : false;
    }
    setSocialSecurityFieldAttributes() {
        const socialSecurity = this.getMemberInformationField(MemberInformationFormKeyConstants.SOCIAL_SECURITY_NUMBER);
        this.socialSecurityNumberLabelText = socialSecurity ? socialSecurity.labelText : SOCIAL_SECURITY_NUMBER_TEXT;
        this.socialSecurityNumberRequiredText = socialSecurity ? socialSecurity.requiredText : SOCIAL_SECURITY_NUMBER_REQUIRED_TEXT;
        this.isSocialSecurityNumberRequired = socialSecurity ? socialSecurity.required : false;
    }
    setAddress1FieldAttributes() {
        const address1 = this.getMemberInformationField(MemberInformationFormKeyConstants.ADDRESS1);
        this.address1LabelText = address1 ? address1.labelText : ADDRESS1_TEXT;
        this.address1RequiredText = address1 ? address1.requiredText : ADDRESS1_REQUIRED_TEXT;
        this.isAddress1Required = address1 ? address1.required : false;
    }
    setAddress2FieldAttributes() {
        const address2 = this.getMemberInformationField(MemberInformationFormKeyConstants.ADDRESS2);
        this.address2LabelText = address2 ? address2.labelText : ADDRESS2_TEXT;
        this.address2RequiredText = address2 ? address2.requiredText : ADDRESS2_REQUIRED_TEXT;
        this.isAddress2Required = address2 ? address2.required : false;
    }
    setCityFieldAttributes() {
        const city = this.getMemberInformationField(MemberInformationFormKeyConstants.CITY);
        this.cityLabelText = city ? city.labelText : CITY_TEXT;
        this.cityRequiredText = city ? city.requiredText : CITY_REQUIRED_TEXT;
        this.isCityRequired = city ? city.required : false;
    }
    setStateFieldAttributes() {
        const state = this.getMemberInformationField(MemberInformationFormKeyConstants.STATE);
        this.stateLabelText = state ? state.labelText : STATE_TEXT;
        this.stateRequiredText = state ? state.requiredText : STATE_REQUIRED_TEXT;
        this.isStateRequired = state ? state.required : false;
    }
    setZipFieldAttributes() {
        const zip = this.getMemberInformationField(MemberInformationFormKeyConstants.ZIP);
        this.zipLabelText = zip ? zip.labelText : ZIP_TEXT;
        this.zipRequiredText = zip ? zip.requiredText : ZIP_REQUIRED_TEXT;
        this.isZipRequired = zip ? zip.required : false;
    }
    setDateFieldAttributes() {
        const date = this.getMemberInformationField(MemberInformationFormKeyConstants.DATE);
        this.dateLabelText = date ? date.labelText : DATE_TEXT;
        this.dateRequiredText = date ? date.requiredText : DATE_REQUIRED_TEXT;
        this.isDateRequired = date ? date.required : false;
    }
    setApplicantFullNameFieldAttributes() {
        const applicantFullName = this.getMemberInformationField(MemberInformationFormKeyConstants.APPLICANT_FULL_NAME);
        this.applicantFullNameLabelText = applicantFullName ? applicantFullName.labelText : APPLICANT_FULL_NAME_TEXT;
        this.applicantFullNameRequiredText = applicantFullName ? applicantFullName.requiredText : APPLICANT_FULL_NAME_REQUIRED_TEXT;
        this.isApplicantFullNameRequired = applicantFullName ? applicantFullName.required : false;
    }
    setAcceptTermsCheckboxFieldAttributes() {
        const authorizeUse = this.getMemberInformationField(MemberInformationFormKeyConstants.AUTHORIZE);
        this.authorizationLabelText = authorizeUse ? authorizeUse.labelText : AUTHORIZE_LABEL_TEXT;
        this.authorizationRequiredText = authorizeUse ? authorizeUse.requiredText : AUTHORIZATION_REQUIRED_TEXT;
        this.isAuthorizationRequired = authorizeUse ? authorizeUse.required : false;
    }
    setHeightFieldsAttributes() {
        const height = this.getMemberInformationField(MemberInformationFormKeyConstants.HEIGHT);
        this.heightLabelText = height ? height.labelText : HEIGHT_LABEL_TEXT;
        this.heightFtRequiredText = height ? height.requiredText : HEIGHT_REQUIRED_TEXT;
        this.isHeightRequired = height ? height.required : true;
        this.heightInRequiredText = height ? height.requiredText : HEIGHT_REQUIRED_TEXT;
    }
    setWeightFieldAttributes() {
        const weight = this.getMemberInformationField(MemberInformationFormKeyConstants.WEIGHT);
        this.weightLabelText = weight ? weight.labelText : WEIGHT_LABEL_TEXT;
        this.weightRequiredText = weight ? weight.requiredText : WEIGHT_REQUIRED_TEXT;
        this.isWeightRequired = weight ? weight.required : true;
    }
    initializeForm() {
        const memberProfile = this.memberStateModel?.profile;
        const memberDemographicZipCode = this.memberStateModel?.demographic?.zip ?? '';
        this.setMillimanForm(memberProfile, memberDemographicZipCode);
    }
    setMillimanForm(memberProfile, memberDemographicZipCode) {
        this.millimanMemberProfileForm = new UntypedFormGroup({
            firstName: this.getFirstNameFormControl(memberProfile),
            middleInitial: this.getMiddleInitialFormControl(memberProfile),
            lastName: this.getLastNameFormControl(memberProfile),
            socialSecurityNumber: this.getSocialSecurityFormControl(),
            address1: this.getAddress1FormControl(memberProfile),
            address2: this.getAddress2FormControl(memberProfile),
            city: this.getCityFormControl(memberProfile),
            state: this.getStateFormControl(memberProfile),
            zip: this.getZipFormControl(memberProfile, memberDemographicZipCode),
            applicantFullName: this.getApplicantFullNameFormControl(),
            date: this.getAuthorizeDateFormControl(),
            authorize: this.getAuthorizeUseFormControl(),
            heightFt: this.getHeightFtFormControl(),
            heightIn: this.getHeightInFormControl(),
            weight: this.getWeightFormControl()
        }, { updateOn: 'blur' });
    }
    getWeightFormControl() {
        return new UntypedFormControl(this.millimanHealthInformation?.WeightLbs ? this.millimanHealthInformation.WeightLbs : null, this.isWeightRequired ? [Validators.required, Validators.min(1)] : null);
    }
    getHeightInFormControl() {
        return new UntypedFormControl(this.millimanHealthInformation?.HeightIn ? this.millimanHealthInformation.HeightIn : null, this.isHeightRequired ? [Validators.required, Validators.max(11), Validators.min(0)] : null);
    }
    getHeightFtFormControl() {
        return new UntypedFormControl(this.millimanHealthInformation?.HeightFt ? this.millimanHealthInformation.HeightFt : null, this.isHeightRequired ? [Validators.required, Validators.min(1), Validators.max(10)] : null);
    }
    getAuthorizeUseFormControl() {
        return new UntypedFormControl(this.sessionAuthorizeUse ? this.sessionAuthorizeUse : null, this.isAuthorizationRequired ? Validators.requiredTrue : null);
    }
    getAuthorizeDateFormControl() {
        return new UntypedFormControl(this.sessionAuthorizeDate ? this.sessionAuthorizeDate : this.getAuthorizeDateFormControlValue(), this.isDateRequired ? Validators.required : null);
    }
    getAuthorizeDateFormControlValue() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Populate_CurrentDate_Field_Enabled', null, false)
            ? DateUtilities.getFormattedPTDate(new Date())
            : null;
    }
    getApplicantFullNameFormControl() {
        return new UntypedFormControl(this.sessionApplicantFullName ? this.sessionApplicantFullName : null, this.isApplicantFullNameRequired ? Validators.required : null);
    }
    getZipFormControl(memberProfile, memberDemographicZipCode) {
        return new UntypedFormControl(memberProfile?.addresses && memberProfile?.addresses[0]?.zip ? memberProfile.addresses[0].zip : memberDemographicZipCode, this.isZipRequired ? [Validators.required, Validators.minLength(5)] : null);
    }
    getStateFormControl(memberProfile) {
        return new UntypedFormControl(this.getMemberProfileState(memberProfile), this.isStateRequired ? [Validators.required, Validators.minLength(2), Validators.maxLength(2)] : null);
    }
    getCityFormControl(memberProfile) {
        return new UntypedFormControl(memberProfile?.addresses && memberProfile?.addresses[0]?.city ? memberProfile.addresses[0].city : '', this.isCityRequired ? [Validators.required] : null);
    }
    getAddress2FormControl(memberProfile) {
        return new UntypedFormControl(memberProfile?.addresses && memberProfile?.addresses[0]?.address2 ? memberProfile.addresses[0].address2 : '', this.isAddress2Required ? [Validators.required, Validators.maxLength(255)] : null);
    }
    getAddress1FormControl(memberProfile) {
        return new UntypedFormControl(memberProfile?.addresses && memberProfile?.addresses[0]?.address1 ? memberProfile.addresses[0].address1 : '', this.isAddress1Required ? [Validators.required, Validators.maxLength(255)] : null);
    }
    getSocialSecurityFormControl() {
        return new UntypedFormControl(this.sessionApplicantSSN ? this.sessionApplicantSSN : null, this.isSocialSecurityNumberRequired ? [Validators.required, Validators.maxLength(9)] : null);
    }
    getLastNameFormControl(memberProfile) {
        return new UntypedFormControl(memberProfile?.lastName ? memberProfile.lastName : this.memberStateModel?.lastName, this.isLastNameRequired ? [Validators.required, Validators.maxLength(100)] : null);
    }
    getMiddleInitialFormControl(memberProfile) {
        return new UntypedFormControl(memberProfile?.middleInitial ? memberProfile.middleInitial.trim() : null, this.isMiddleInitialRequired ? [Validators.required, Validators.maxLength(1)] : null);
    }
    getFirstNameFormControl(memberProfile) {
        return new UntypedFormControl(memberProfile?.firstName ? memberProfile.firstName : this.memberStateModel?.firstName, this.isFirstNameRequired ? [Validators.required, Validators.maxLength(100)] : null);
    }
    getMillimanAuthorizationAnswers() {
        return [
            !this.hasFirstNameError() && {
                questionKey: MemberInformationFormKeyConstants.FIRST_NAME,
                error: MedSupFormErrorTypes.REQUIRED,
                hasError: false,
                value: this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.FIRST_NAME)?.value
            },
            !this.hasMiddleInitialError() && {
                questionKey: MemberInformationFormKeyConstants.MIDDLE_INITIAL,
                error: MedSupFormErrorTypes.REQUIRED,
                hasError: false,
                value: this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.MIDDLE_INITIAL)?.value
            },
            !this.hasLastNameError() && {
                questionKey: MemberInformationFormKeyConstants.LAST_NAME,
                error: MedSupFormErrorTypes.REQUIRED,
                hasError: false,
                value: this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.LAST_NAME)?.value
            },
            !this.hasSocialSecurityNumberError() && {
                questionKey: MemberInformationFormKeyConstants.SOCIAL_SECURITY_NUMBER,
                error: MedSupFormErrorTypes.REQUIRED,
                hasError: false,
                value: this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.SOCIAL_SECURITY_NUMBER)?.value
            },
            !this.hasAddress1Error() && {
                questionKey: MemberInformationFormKeyConstants.ADDRESS1,
                error: MedSupFormErrorTypes.REQUIRED,
                hasError: false,
                value: this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.ADDRESS1)?.value.street_line ?? // ngbAutoComplete quirk
                    this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.ADDRESS1)?.value
            },
            !this.hasAddress2Error() && {
                questionKey: MemberInformationFormKeyConstants.ADDRESS2,
                error: MedSupFormErrorTypes.REQUIRED,
                hasError: false,
                value: this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.ADDRESS2)?.value
            },
            !this.hasCityError() && {
                questionKey: MemberInformationFormKeyConstants.CITY,
                error: MedSupFormErrorTypes.REQUIRED,
                hasError: false,
                value: this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.CITY)?.value
            },
            !this.hasStateError() && {
                questionKey: MemberInformationFormKeyConstants.STATE,
                error: MedSupFormErrorTypes.REQUIRED,
                hasError: false,
                value: this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.STATE)?.value
            },
            !this.hasZipCodeError() && {
                questionKey: MemberInformationFormKeyConstants.ZIP,
                error: MedSupFormErrorTypes.REQUIRED,
                hasError: false,
                value: this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.ZIP)?.value
            },
            !this.hasDateError() && {
                questionKey: MemberInformationFormKeyConstants.DATE,
                error: MedSupFormErrorTypes.REQUIRED,
                hasError: false,
                value: this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.DATE)?.value
            },
            !this.hasApplicantFullNameError() && {
                questionKey: MemberInformationFormKeyConstants.APPLICANT_FULL_NAME,
                error: MedSupFormErrorTypes.REQUIRED,
                hasError: false,
                value: this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.APPLICANT_FULL_NAME)?.value
            },
            !this.hasAuthorizationError() && {
                questionKey: MemberInformationFormKeyConstants.AUTHORIZE,
                error: MedSupFormErrorTypes.REQUIRED,
                hasError: false,
                value: this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.AUTHORIZE)?.value
            },
            !this.hasWeightError() && {
                questionKey: MemberInformationFormKeyConstants.WEIGHT,
                error: MedSupFormErrorTypes.REQUIRED,
                hasError: false,
                value: this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.WEIGHT)?.value
            },
            !this.hasHeightFtError() && {
                questionKey: MemberInformationFormKeyConstants.HEIGHT_FT,
                error: MedSupFormErrorTypes.REQUIRED,
                hasError: false,
                value: this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.HEIGHT_FT)?.value
            },
            !this.hasHeightInError() && {
                questionKey: MemberInformationFormKeyConstants.HEIGHT_IN,
                error: MedSupFormErrorTypes.REQUIRED,
                hasError: false,
                value: this.millimanMemberProfileForm.get(MemberInformationFormKeyConstants.HEIGHT_IN)?.value
            }
        ].filter(value => value);
    }
    getMillimanFormErrorEmitData() {
        return [
            {
                questionKey: MemberInformationFormKeyConstants.FIRST_NAME,
                error: this.hasFirstNameError() ? MedSupFormErrorTypes.REQUIRED : null,
                hasError: this.hasFirstNameError(),
                value: null
            },
            {
                questionKey: MemberInformationFormKeyConstants.MIDDLE_INITIAL,
                error: this.hasMiddleInitialError() ? MedSupFormErrorTypes.REQUIRED : null,
                hasError: this.hasMiddleInitialError(),
                value: null
            },
            {
                questionKey: MemberInformationFormKeyConstants.LAST_NAME,
                error: this.hasLastNameError() ? MedSupFormErrorTypes.REQUIRED : null,
                hasError: this.hasLastNameError(),
                value: null
            },
            {
                questionKey: MemberInformationFormKeyConstants.SOCIAL_SECURITY_NUMBER,
                error: this.hasSocialSecurityNumberError() ? MedSupFormErrorTypes.REQUIRED : null,
                hasError: this.hasSocialSecurityNumberError(),
                value: null
            },
            {
                questionKey: MemberInformationFormKeyConstants.ADDRESS1,
                error: this.hasAddress1Error() ? MedSupFormErrorTypes.REQUIRED : null,
                hasError: this.hasAddress1Error(),
                value: null
            },
            {
                questionKey: MemberInformationFormKeyConstants.ADDRESS2,
                error: this.hasAddress2Error() ? MedSupFormErrorTypes.REQUIRED : null,
                hasError: this.hasAddress2Error(),
                value: null
            },
            {
                questionKey: MemberInformationFormKeyConstants.CITY,
                error: this.hasCityError() ? MedSupFormErrorTypes.REQUIRED : null,
                hasError: this.hasCityError(),
                value: null
            },
            {
                questionKey: MemberInformationFormKeyConstants.STATE,
                error: this.hasStateError() ? MedSupFormErrorTypes.REQUIRED : null,
                hasError: this.hasStateError(),
                value: null
            },
            {
                questionKey: MemberInformationFormKeyConstants.ZIP,
                error: this.hasZipCodeError() ? MedSupFormErrorTypes.REQUIRED : null,
                hasError: this.hasZipCodeError(),
                value: null
            },
            {
                questionKey: MemberInformationFormKeyConstants.DATE,
                error: this.hasDateError() ? MedSupFormErrorTypes.REQUIRED : null,
                hasError: this.hasDateError(),
                value: null
            },
            {
                questionKey: MemberInformationFormKeyConstants.APPLICANT_FULL_NAME,
                error: this.hasApplicantFullNameError() ? MedSupFormErrorTypes.REQUIRED : null,
                hasError: this.hasApplicantFullNameError(),
                value: null
            },
            {
                questionKey: MemberInformationFormKeyConstants.AUTHORIZE,
                error: this.hasAuthorizationError() ? MedSupFormErrorTypes.REQUIRED : null,
                hasError: this.hasAuthorizationError(),
                value: null
            },
            {
                questionKey: MemberInformationFormKeyConstants.WEIGHT,
                error: this.hasWeightError() ? MedSupFormErrorTypes.REQUIRED : null,
                hasError: this.hasWeightError(),
                value: null
            },
            {
                questionKey: MemberInformationFormKeyConstants.HEIGHT,
                error: this.hasHeightError() ? MedSupFormErrorTypes.REQUIRED : null,
                hasError: this.hasHeightError(),
                value: null
            }
        ];
    }
    getMemberProfileState(memberProfile) {
        if (memberProfile?.addresses?.length) {
            const stateWithNoWhiteSpace = memberProfile.addresses[0]?.state?.replace(/\s/g, '');
            if (stateWithNoWhiteSpace?.length) {
                return memberProfile.addresses[0].state;
            }
        }
        return MILLIMAN_DEFAULT_STATE;
    }
    initializeSearchTerm() {
        if (this.addressSearchInput && this.addressSearchInput.nativeElement) {
            const addressSearchInput = this.addressSearchInput.nativeElement;
            if (!addressSearchInput.value) {
                if (addressSearchInput.getAttribute('initialized') === 'false' && this.addressSearchTerm) {
                    addressSearchInput.value = this.addressSearchTerm;
                    this.cdr.markForCheck();
                }
            }
        }
    }
}
MedsupMillimanAuthorizationComponent.ɵfac = function MedsupMillimanAuthorizationComponent_Factory(t) { return new (t || MedsupMillimanAuthorizationComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.AddressService), i0.ɵɵdirectiveInject(i1.AutoCompleteService), i0.ɵɵdirectiveInject(MedSupMillimanFormFacade), i0.ɵɵdirectiveInject(i1.ConfigResourceService)); };
MedsupMillimanAuthorizationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedsupMillimanAuthorizationComponent, selectors: [["vnext-medsup-milliman-authorization"]], viewQuery: function MedsupMillimanAuthorizationComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1c, 5);
        i0.ɵɵviewQuery(_c1$w, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.typeahead = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addressSearchInput = _t.first);
    } }, inputs: { showDatePicker: "showDatePicker", datePickerMaxDate: "datePickerMaxDate", datePickerMinDate: "datePickerMinDate" }, outputs: { formError: "formError", onUpdateMemberInformation: "onUpdateMemberInformation" }, decls: 157, vars: 222, consts: [[1, "mt-3", 3, "formGroup"], [1, "Spa_Style_H2", "mt-1"], [1, "my-3"], [1, "form-row", "align-items-baseline"], [1, "col-12", "col-md-3"], [1, "form-group"], ["for", "firstName", 3, "ngClass"], ["id", "firstNameError", "class", "error-container", "role", "alert", 4, "ngIf"], [1, "Spa_Style_Label", "d-md-inline"], ["class", "input-error-asterisk", "aria-hidden", "true", 4, "ngIf"], [3, "ngClass"], ["id", "firstName", "type", "text", "formControlName", "firstName", 1, "form-control", 3, "ngClass"], [1, "col-12", "col-md-1"], ["for", "middleInitial", 3, "ngClass"], ["id", "middleInitialError", "class", "error-container text-nowrap", "role", "alert", 4, "ngIf"], ["id", "middleInitial", "type", "text", "maxlength", "1", "formControlName", "middleInitial", 1, "form-control", 3, "ngClass"], ["for", "lastName", 3, "ngClass"], ["id", "lastNameError", "class", "error-container", "role", "alert", 4, "ngIf"], ["id", "lastName", "type", "text", "formControlName", "lastName", 1, "form-control", 3, "ngClass"], [1, "col-12", "col-md-4"], ["for", "socialSecurityNumber", 3, "ngClass"], ["id", "socialSecurityNumberError", "class", "error-container text-nowrap", "role", "alert", 4, "ngIf"], ["id", "socialSecurityNumber", "type", "text", "maxlength", "11", "inputmode", "numeric", "formControlName", "socialSecurityNumber", "autocomplete", "off", 1, "form-control", 3, "mask", "ngClass"], ["for", "address1", 1, "address-autocomplete-wrapper", 3, "ngClass"], ["id", "address1Error", "class", "error-container", "role", "alert", 4, "ngIf"], ["addressResultTemplate", ""], ["id", "address1", "type", "text", "placement", "bottom-left", 1, "form-control", 3, "ngbTypeahead", "resultTemplate", "inputFormatter", "value", "ngClass", "keyup", "change", "selectItem", "blur"], ["addressSearchInput", "", "typeahead", "ngbTypeahead"], ["for", "address2", 3, "ngClass"], ["id", "address2Error", "class", "error-container", "role", "alert", 4, "ngIf"], ["id", "address2", "type", "text", "formControlName", "address2", 1, "form-control", 3, "ngClass"], ["for", "city", 3, "ngClass"], ["id", "cityError", "class", "error-container text-nowrap", "role", "alert", 4, "ngIf"], ["id", "city", "type", "text", "formControlName", "city", 1, "form-control", 3, "ngClass"], ["id", "stateLabelId", 3, "ngClass"], ["id", "stateError", "class", "error-container", "role", "alert", 4, "ngIf"], ["ariaLabelledById", "stateLabelId", 3, "control", "height", "controlValue"], [1, "col-12", "col-md-2", "col-pad-right"], ["for", "zip", "role", "alert", 3, "ngClass"], ["id", "zipCodeError", "class", "error-container text-nowrap", 4, "ngIf"], ["id", "zip", "type", "text", "formControlName", "zip", "minlength", "5", "maxlength", "5", "inputmode", "numeric", 1, "form-control", 3, "ngClass"], ["id", "heightCodeError", "class", "error-container text-nowrap", "role", "alert", 4, "ngIf"], ["id", "heightLabelId", 1, "Spa_Style_Label", "d-md-inline"], [1, "input-wrapper"], ["type", "text", "formControlName", "heightFt", "inputmode", "numeric", "aria-labelledby", "heightLabelId feetLabelId", 1, "form-control", 3, "ngClass"], ["id", "feetLabelId", 1, "Spa_Style_Label", "number-input-label"], ["type", "text", "formControlName", "heightIn", "inputmode", "numeric", "aria-labelledby", "heightLabelId inchLabelId", 1, "form-control", 3, "ngClass"], ["id", "inchLabelId", 1, "Spa_Style_Label", "number-input-label"], ["for", "weight", 1, "address-autocomplete-wrapper", 3, "ngClass"], ["id", "weightError", "class", "error-container", "role", "alert", 4, "ngIf"], ["id", "weight", "type", "text", "formControlName", "weight", "inputmode", "numeric", "maxlength", "4", 1, "form-control", 3, "ngClass"], [1, "Spa_Style_Label", "number-input-label"], [1, "Spa_Style_H3", "my-2"], [1, "Spa_Style_Paragraph", 3, "innerHTML"], [1, "row", "mt-3", "align-items-baseline"], ["for", "applicantFullName", 3, "ngClass"], ["id", "applicantFullNameError", "class", "error-container", "role", "alert", 4, "ngIf"], ["id", "applicantFullName", "type", "text", "formControlName", "applicantFullName", "autocomplete", "off", 1, "form-control", 3, "ngClass"], [1, "col-12", "col-md-2"], ["for", "date", 3, "ngClass"], ["id", "dateError", "class", "error-container text-nowrap", "role", "alert", 4, "ngIf"], [1, "date-input"], ["id", "date", "type", "text", "formControlName", "date", "maxlength", "12", "inputmode", "numeric", "autocomplete", "off", 1, "form-control", "med-sup-number-input", 3, "placeholder", "mask", "ngClass", "dropSpecialCharacters"], [4, "ngIf"], [1, "row", "Spa_Style_Paragraph"], ["id", "applicantFullNameDescribedByText", 1, "col-12"], [1, "row", "mt-2"], [1, "col-12"], ["id", "authorizationError", "class", "error-container", 4, "ngIf"], [1, "form-check", "pl-0"], ["for", "authorize", "role", "alert", 3, "ngClass"], ["id", "authorize", "type", "checkbox", "formControlName", "authorize", 3, "ngClass"], [1, "Spa_Style_Label", "d-inline", "ml-2"], ["id", "firstNameError", "role", "alert", 1, "error-container"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], ["aria-hidden", "true", 1, "input-error-asterisk"], ["id", "middleInitialError", "role", "alert", 1, "error-container", "text-nowrap"], ["id", "lastNameError", "role", "alert", 1, "error-container"], ["id", "socialSecurityNumberError", "role", "alert", 1, "error-container", "text-nowrap"], ["id", "address1Error", "role", "alert", 1, "error-container"], [1, "Spa_Style_H5", "no-translate-block"], [3, "result", "term"], ["id", "address2Error", "role", "alert", 1, "error-container"], ["id", "cityError", "role", "alert", 1, "error-container", "text-nowrap"], ["id", "stateError", "role", "alert", 1, "error-container"], ["id", "zipCodeError", 1, "error-container", "text-nowrap"], ["id", "heightCodeError", "role", "alert", 1, "error-container", "text-nowrap"], ["id", "weightError", "role", "alert", 1, "error-container"], ["id", "applicantFullNameError", "role", "alert", 1, "error-container"], ["id", "dateError", "role", "alert", 1, "error-container", "text-nowrap"], ["ngbDatepicker", "", "type", "text", "tabindex", "-1", "aria-hidden", "true", 1, "date-picker-input", "float-left", "p-0", 3, "minDate", "maxDate", "ngClass", "dateSelect", "select"], ["datePickerInput", "ngbDatepicker"], [1, "btn", "btn-calendar", 3, "click"], ["aria-hidden", "true", "role", "presentation", 1, "fas", "fa-calendar-alt"], ["id", "authorizationError", 1, "error-container"]], template: function MedsupMillimanAuthorizationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 0)(1, "h2", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2)(4, "div", 3)(5, "div", 4)(6, "div", 5)(7, "label", 6);
        i0.ɵɵtemplate(8, MedsupMillimanAuthorizationComponent_div_8_Template, 3, 1, "div", 7);
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵtemplate(10, MedsupMillimanAuthorizationComponent_span_10_Template, 2, 0, "span", 9);
        i0.ɵɵelementStart(11, "span", 10);
        i0.ɵɵtext(12);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(13, "input", 11);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(14, "div", 12)(15, "div", 5)(16, "label", 13);
        i0.ɵɵtemplate(17, MedsupMillimanAuthorizationComponent_div_17_Template, 3, 1, "div", 14);
        i0.ɵɵelementStart(18, "div", 8);
        i0.ɵɵtemplate(19, MedsupMillimanAuthorizationComponent_span_19_Template, 2, 0, "span", 9);
        i0.ɵɵelementStart(20, "span", 10);
        i0.ɵɵtext(21);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(22, "input", 15);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(23, "div", 4)(24, "div", 5)(25, "label", 16);
        i0.ɵɵtemplate(26, MedsupMillimanAuthorizationComponent_div_26_Template, 3, 1, "div", 17);
        i0.ɵɵelementStart(27, "div", 8);
        i0.ɵɵtemplate(28, MedsupMillimanAuthorizationComponent_span_28_Template, 2, 0, "span", 9);
        i0.ɵɵelementStart(29, "span", 10);
        i0.ɵɵtext(30);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(31, "input", 18);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(32, "div", 19)(33, "div", 5)(34, "label", 20);
        i0.ɵɵtemplate(35, MedsupMillimanAuthorizationComponent_div_35_Template, 3, 1, "div", 21);
        i0.ɵɵelementStart(36, "div", 8);
        i0.ɵɵtemplate(37, MedsupMillimanAuthorizationComponent_span_37_Template, 2, 0, "span", 9);
        i0.ɵɵelementStart(38, "span", 10);
        i0.ɵɵtext(39);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(40, "input", 22);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(41, "div", 3)(42, "div", 4)(43, "div", 5)(44, "label", 23);
        i0.ɵɵtemplate(45, MedsupMillimanAuthorizationComponent_div_45_Template, 3, 1, "div", 24);
        i0.ɵɵelementStart(46, "div", 8);
        i0.ɵɵtemplate(47, MedsupMillimanAuthorizationComponent_span_47_Template, 2, 0, "span", 9);
        i0.ɵɵelementStart(48, "span", 10);
        i0.ɵɵtext(49);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(50, MedsupMillimanAuthorizationComponent_ng_template_50_Template, 5, 6, "ng-template", null, 25, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(52, "input", 26, 27);
        i0.ɵɵlistener("keyup", function MedsupMillimanAuthorizationComponent_Template_input_keyup_52_listener() { return ctx.scrollItemIntoView(); })("change", function MedsupMillimanAuthorizationComponent_Template_input_change_52_listener($event) { return ctx.onChangeAddressSearchTerm($event.target.value); })("selectItem", function MedsupMillimanAuthorizationComponent_Template_input_selectItem_52_listener($event) { return ctx.selectItemForAddress($event); })("blur", function MedsupMillimanAuthorizationComponent_Template_input_blur_52_listener($event) { return ctx.mapSearchTermToAddress($event); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(55, "div", 4)(56, "div", 5)(57, "label", 28);
        i0.ɵɵtemplate(58, MedsupMillimanAuthorizationComponent_div_58_Template, 3, 1, "div", 29);
        i0.ɵɵelementStart(59, "div", 8);
        i0.ɵɵtemplate(60, MedsupMillimanAuthorizationComponent_span_60_Template, 2, 0, "span", 9);
        i0.ɵɵelementStart(61, "span", 10);
        i0.ɵɵtext(62);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(63, "input", 30);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(64, "div", 4)(65, "div", 5)(66, "label", 31);
        i0.ɵɵtemplate(67, MedsupMillimanAuthorizationComponent_div_67_Template, 3, 1, "div", 32);
        i0.ɵɵelementStart(68, "div", 8);
        i0.ɵɵtemplate(69, MedsupMillimanAuthorizationComponent_span_69_Template, 2, 0, "span", 9);
        i0.ɵɵelementStart(70, "span", 10);
        i0.ɵɵtext(71);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(72, "input", 33);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(73, "div", 12)(74, "label", 34);
        i0.ɵɵtemplate(75, MedsupMillimanAuthorizationComponent_div_75_Template, 3, 1, "div", 35);
        i0.ɵɵelementStart(76, "div", 8);
        i0.ɵɵtemplate(77, MedsupMillimanAuthorizationComponent_span_77_Template, 2, 0, "span", 9);
        i0.ɵɵelementStart(78, "span", 10);
        i0.ɵɵtext(79);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(80, "div");
        i0.ɵɵelement(81, "vnext-state-selector-input", 36);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(82, "div", 37)(83, "div", 5)(84, "label", 38);
        i0.ɵɵtemplate(85, MedsupMillimanAuthorizationComponent_div_85_Template, 3, 1, "div", 39);
        i0.ɵɵelementStart(86, "div", 8);
        i0.ɵɵtemplate(87, MedsupMillimanAuthorizationComponent_span_87_Template, 2, 0, "span", 9);
        i0.ɵɵelementStart(88, "span", 10);
        i0.ɵɵtext(89);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(90, "input", 40);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(91, "div", 3)(92, "div", 4)(93, "div", 5)(94, "label", 10);
        i0.ɵɵtemplate(95, MedsupMillimanAuthorizationComponent_div_95_Template, 3, 1, "div", 41);
        i0.ɵɵelementStart(96, "div", 42);
        i0.ɵɵtemplate(97, MedsupMillimanAuthorizationComponent_span_97_Template, 2, 0, "span", 9);
        i0.ɵɵelementStart(98, "span", 10);
        i0.ɵɵtext(99);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(100, "div", 43);
        i0.ɵɵelement(101, "input", 44);
        i0.ɵɵelementStart(102, "span", 45);
        i0.ɵɵtext(103);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(104, "input", 46);
        i0.ɵɵelementStart(105, "span", 47);
        i0.ɵɵtext(106);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(107, "div", 4)(108, "div", 5)(109, "label", 48);
        i0.ɵɵtemplate(110, MedsupMillimanAuthorizationComponent_div_110_Template, 3, 1, "div", 49);
        i0.ɵɵelementStart(111, "div", 8);
        i0.ɵɵtemplate(112, MedsupMillimanAuthorizationComponent_span_112_Template, 2, 0, "span", 9);
        i0.ɵɵelementStart(113, "span", 10);
        i0.ɵɵtext(114);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(115, "div", 43);
        i0.ɵɵelement(116, "input", 50);
        i0.ɵɵelementStart(117, "span", 51);
        i0.ɵɵtext(118);
        i0.ɵɵelementEnd()()()()()()();
        i0.ɵɵelementStart(119, "h3", 52);
        i0.ɵɵtext(120);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(121, "div", 53);
        i0.ɵɵpipe(122, "safe");
        i0.ɵɵelementStart(123, "div", 54)(124, "div", 19)(125, "div", 5)(126, "label", 55);
        i0.ɵɵtemplate(127, MedsupMillimanAuthorizationComponent_div_127_Template, 3, 1, "div", 56);
        i0.ɵɵelementStart(128, "div", 8);
        i0.ɵɵtemplate(129, MedsupMillimanAuthorizationComponent_span_129_Template, 2, 0, "span", 9);
        i0.ɵɵelementStart(130, "span", 10);
        i0.ɵɵtext(131);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(132, "input", 57);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(133, "div", 58)(134, "div", 5)(135, "label", 59);
        i0.ɵɵtemplate(136, MedsupMillimanAuthorizationComponent_div_136_Template, 3, 1, "div", 60);
        i0.ɵɵelementStart(137, "div", 8);
        i0.ɵɵtemplate(138, MedsupMillimanAuthorizationComponent_span_138_Template, 2, 0, "span", 9);
        i0.ɵɵelementStart(139, "span", 10);
        i0.ɵɵtext(140);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(141, "div", 61);
        i0.ɵɵelement(142, "input", 62);
        i0.ɵɵtemplate(143, MedsupMillimanAuthorizationComponent_ng_container_143_Template, 5, 5, "ng-container", 63);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(144, "div", 64)(145, "div", 65);
        i0.ɵɵtext(146);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(147, "div", 66)(148, "div", 67);
        i0.ɵɵtemplate(149, MedsupMillimanAuthorizationComponent_div_149_Template, 3, 1, "div", 68);
        i0.ɵɵelementStart(150, "div", 69)(151, "label", 70);
        i0.ɵɵelement(152, "input", 71);
        i0.ɵɵelementStart(153, "div", 72);
        i0.ɵɵtemplate(154, MedsupMillimanAuthorizationComponent_span_154_Template, 2, 0, "span", 9);
        i0.ɵɵelementStart(155, "span", 10);
        i0.ɵɵtext(156);
        i0.ɵɵelementEnd()()()()()()();
    } if (rf & 2) {
        const _r10 = i0.ɵɵreference(51);
        i0.ɵɵproperty("formGroup", ctx.millimanMemberProfileForm);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.millimanJustAFewMoreQuestionsText);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(138, _c2$m, ctx.hasFirstNameError()));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasFirstNameError());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isFirstNameRequired);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(140, _c3$d, ctx.hasFirstNameError()));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1("", ctx.firstNameLabelText, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(142, _c2$m, ctx.hasFirstNameError()));
        i0.ɵɵattribute("aria-required", ctx.isFirstNameRequired)("aria-describedby", ctx.hasFirstNameError() ? "firstNameError" : null);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(144, _c2$m, ctx.hasMiddleInitialError()));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasMiddleInitialError());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isMiddleInitialRequired);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(146, _c3$d, ctx.hasMiddleInitialError()));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1("", ctx.middleInitialLabelText, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(148, _c2$m, ctx.hasMiddleInitialError()));
        i0.ɵɵattribute("aria-required", ctx.isMiddleInitialRequired)("aria-describedby", ctx.hasMiddleInitialError() ? "middleInitialError" : null);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(150, _c2$m, ctx.hasLastNameError()));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasLastNameError());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isLastNameRequired);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(152, _c3$d, ctx.hasLastNameError()));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1("", ctx.lastNameLabelText, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(154, _c2$m, ctx.hasLastNameError()));
        i0.ɵɵattribute("aria-required", ctx.isLastNameRequired)("aria-describedby", ctx.hasLastNameError() ? "lastNameError" : null);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(156, _c2$m, ctx.hasSocialSecurityNumberError()));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasSocialSecurityNumberError());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isSocialSecurityNumberRequired);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(158, _c3$d, ctx.hasSocialSecurityNumberError()));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1("", ctx.socialSecurityNumberLabelText, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("mask", ctx.socialSecurityNumberMask);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(160, _c2$m, ctx.hasSocialSecurityNumberError()));
        i0.ɵɵattribute("aria-required", ctx.isSocialSecurityNumberRequired)("aria-describedby", ctx.hasSocialSecurityNumberError() ? "socialSecurityNumberError" : null);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(162, _c2$m, ctx.hasAddress1Error()));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasAddress1Error());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isAddress1Required);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(164, _c3$d, ctx.hasAddress1Error()));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1("", ctx.address1LabelText, " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngbTypeahead", ctx.suggestedAddresses)("resultTemplate", _r10)("inputFormatter", ctx.addressAutocompleteFormatter)("value", ctx.addressSearchTerm)("ngClass", i0.ɵɵpureFunction1(166, _c2$m, ctx.hasAddress1Error()));
        i0.ɵɵattribute("aria-required", ctx.isAddress1Required)("aria-describedby", ctx.hasAddress1Error() ? "address1Error" : null)("initialized", false);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(168, _c2$m, ctx.hasAddress2Error()));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasAddress2Error());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isAddress2Required);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(170, _c3$d, ctx.hasAddress2Error()));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1("", ctx.address2LabelText, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(172, _c2$m, ctx.hasAddress2Error()));
        i0.ɵɵattribute("aria-required", ctx.isAddress2Required)("aria-describedby", ctx.hasAddress2Error() ? "address2Error" : null);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(174, _c2$m, ctx.hasCityError()));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasCityError());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isCityRequired);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(176, _c3$d, ctx.hasCityError()));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1("", ctx.cityLabelText, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(178, _c2$m, ctx.hasCityError()));
        i0.ɵɵattribute("aria-required", ctx.isCityRequired)("aria-describedby", ctx.hasCityError() ? "cityError" : null);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(180, _c2$m, ctx.hasStateError()));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasStateError());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isStateRequired);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(182, _c3$d, ctx.hasStateError()));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1("", ctx.stateLabelText, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("control", ctx.millimanMemberProfileForm == null ? null : ctx.millimanMemberProfileForm.controls == null ? null : ctx.millimanMemberProfileForm.controls.state)("height", "36px")("controlValue", ctx.millimanMemberProfileForm == null ? null : ctx.millimanMemberProfileForm.controls == null ? null : ctx.millimanMemberProfileForm.controls.state == null ? null : ctx.millimanMemberProfileForm.controls.state.value);
        i0.ɵɵattribute("aria-required", ctx.isStateRequired)("aria-describedby", ctx.hasStateError() ? "hasStateError()" : null);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(184, _c2$m, ctx.hasZipCodeError()));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasZipCodeError());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isZipRequired);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(186, _c3$d, ctx.hasZipCodeError()));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1("", ctx.zipLabelText, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(188, _c2$m, ctx.hasZipCodeError()));
        i0.ɵɵattribute("aria-describedby", ctx.hasZipCodeError() ? "zipCodeError" : null)("aria-required", ctx.isZipRequired);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(190, _c2$m, ctx.hasHeightError()));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasHeightError());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isHeightRequired);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(192, _c3$d, ctx.hasHeightError()));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1("", ctx.heightLabelText, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(194, _c2$m, ctx.hasHeightFtError()));
        i0.ɵɵattribute("aria-describedby", ctx.hasHeightFtError() ? "heightCodeError" : null)("aria-required", ctx.isHeightRequired);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.feetLabelText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(196, _c2$m, ctx.hasHeightInError()));
        i0.ɵɵattribute("aria-describedby", ctx.hasHeightInError() ? "heightCodeError" : null)("aria-required", ctx.isHeightRequired);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.inchLabelText);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(198, _c2$m, ctx.hasWeightError()));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasWeightError());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isWeightRequired);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(200, _c3$d, ctx.hasWeightError()));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1("", ctx.weightLabelText, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(202, _c2$m, ctx.hasWeightError()));
        i0.ɵɵattribute("aria-describedby", ctx.hasWeightError() ? "weightError" : null)("aria-required", ctx.isWeightRequired);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.poundsLabelText);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.millimanAuthorizationHeaderText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(122, 135, ctx.millimanAuthorizationText, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(204, _c2$m, ctx.hasApplicantFullNameError()));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasApplicantFullNameError());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isApplicantFullNameRequired);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(206, _c3$d, ctx.hasApplicantFullNameError()));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1("", ctx.applicantFullNameLabelText, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(208, _c2$m, ctx.hasApplicantFullNameError()));
        i0.ɵɵattribute("aria-required", ctx.isApplicantFullNameRequired)("aria-describedby", ctx.hasApplicantFullNameError() ? "applicantFullNameError" : "applicantFullNameDescribedByText");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(210, _c2$m, ctx.hasDateError()));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasDateError());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isDateRequired);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(212, _c3$d, ctx.hasDateError()));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1("", ctx.dateLabelText, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate("placeholder", ctx.dateDefaultFormat);
        i0.ɵɵpropertyInterpolate("mask", ctx.dateMaskFormat);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(214, _c2$m, ctx.hasDateError()))("dropSpecialCharacters", false);
        i0.ɵɵattribute("aria-required", ctx.isDateRequired)("aria-describedby", ctx.hasDateError() ? "dateError" : null);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showDatePicker);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.millimanApplicantNameMustMatchText, " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.hasAuthorizationError());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(216, _c2$m, ctx.hasAuthorizationError()));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(218, _c2$m, ctx.hasAuthorizationError()));
        i0.ɵɵattribute("aria-required", ctx.isAuthorizationRequired)("aria-describedby", ctx.hasAuthorizationError() ? "authorizationError" : null);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isAuthorizationRequired);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(220, _c3$d, ctx.hasAuthorizationError()));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1("", ctx.authorizationLabelText, " ");
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.CheckboxControlValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.MinLengthValidator, i4.MaxLengthValidator, i4.FormGroupDirective, i4.FormControlName, StateSelectorInputComponent, IconAriaAttributesDirective, i1$1.NgbInputDatepicker, i1$1.NgbTypeahead, i1$1.NgbHighlight, i8.MaskDirective, SafePipe], styles: [".med-sup-number-input[_ngcontent-%COMP%], .date-input[_ngcontent-%COMP%]{position:relative}.col-pad-right[_ngcontent-%COMP%]{padding-right:5%}.date-picker-input[_ngcontent-%COMP%]{color:transparent;border:transparent;height:0}.btn-calendar[_ngcontent-%COMP%]{position:absolute;right:0;top:0}.input-wrapper[_ngcontent-%COMP%]{display:inline-flex;align-items:center}.number-input-label[_ngcontent-%COMP%]{margin:0 5px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedsupMillimanAuthorizationComponent, [{
        type: Component,
        args: [{ selector: 'vnext-medsup-milliman-authorization', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form class=\"mt-3\" [formGroup]=\"millimanMemberProfileForm\">\r\n  <h2 class=\"Spa_Style_H2 mt-1\">{{ millimanJustAFewMoreQuestionsText }}</h2>\r\n  <div class=\"my-3\">\r\n    <div class=\"form-row align-items-baseline\">\r\n      <div class=\"col-12 col-md-3\">\r\n        <div class=\"form-group\">\r\n          <label for=\"firstName\" [ngClass]=\"{ 'has-error': hasFirstNameError() }\">\r\n            <div id=\"firstNameError\" class=\"error-container\" *ngIf=\"hasFirstNameError()\" role=\"alert\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"isFirstNameRequired\">{{ firstNameRequiredText }}</span>\r\n            </div>\r\n            <div class=\"Spa_Style_Label d-md-inline\">\r\n              <span *ngIf=\"isFirstNameRequired\" class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>\r\n              <span [ngClass]=\"{ 'error-color': hasFirstNameError() }\">{{ firstNameLabelText }} </span>\r\n            </div>\r\n            <input\r\n              id=\"firstName\"\r\n              type=\"text\"\r\n              class=\"form-control\"\r\n              formControlName=\"firstName\"\r\n              [attr.aria-required]=\"isFirstNameRequired\"\r\n              [attr.aria-describedby]=\"hasFirstNameError() ? 'firstNameError' : null\"\r\n              [ngClass]=\"{\r\n                'has-error': hasFirstNameError()\r\n              }\"\r\n            />\r\n          </label>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-12 col-md-1\">\r\n        <div class=\"form-group\">\r\n          <label for=\"middleInitial\" [ngClass]=\"{ 'has-error': hasMiddleInitialError() }\">\r\n            <div id=\"middleInitialError\" class=\"error-container text-nowrap\" *ngIf=\"hasMiddleInitialError()\" role=\"alert\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"isMiddleInitialRequired\">{{ middleInitialRequiredText }}</span>\r\n            </div>\r\n            <div class=\"Spa_Style_Label d-md-inline\">\r\n              <span *ngIf=\"isMiddleInitialRequired\" class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>\r\n              <span [ngClass]=\"{ 'error-color': hasMiddleInitialError() }\">{{ middleInitialLabelText }} </span>\r\n            </div>\r\n            <input\r\n              id=\"middleInitial\"\r\n              type=\"text\"\r\n              maxlength=\"1\"\r\n              class=\"form-control\"\r\n              formControlName=\"middleInitial\"\r\n              [attr.aria-required]=\"isMiddleInitialRequired\"\r\n              [attr.aria-describedby]=\"hasMiddleInitialError() ? 'middleInitialError' : null\"\r\n              [ngClass]=\"{\r\n                'has-error': hasMiddleInitialError()\r\n              }\"\r\n            />\r\n          </label>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-12 col-md-3\">\r\n        <div class=\"form-group\">\r\n          <label for=\"lastName\" [ngClass]=\"{ 'has-error': hasLastNameError() }\">\r\n            <div id=\"lastNameError\" class=\"error-container\" *ngIf=\"hasLastNameError()\" role=\"alert\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"isLastNameRequired\">{{ lastNameRequiredText }}</span>\r\n            </div>\r\n            <div class=\"Spa_Style_Label d-md-inline\">\r\n              <span *ngIf=\"isLastNameRequired\" class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>\r\n              <span [ngClass]=\"{ 'error-color': hasLastNameError() }\">{{ lastNameLabelText }} </span>\r\n            </div>\r\n            <input\r\n              id=\"lastName\"\r\n              type=\"text\"\r\n              class=\"form-control\"\r\n              formControlName=\"lastName\"\r\n              [attr.aria-required]=\"isLastNameRequired\"\r\n              [attr.aria-describedby]=\"hasLastNameError() ? 'lastNameError' : null\"\r\n              [ngClass]=\"{\r\n                'has-error': hasLastNameError()\r\n              }\"\r\n            />\r\n          </label>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-12 col-md-4\">\r\n        <div class=\"form-group\">\r\n          <label for=\"socialSecurityNumber\" [ngClass]=\"{ 'has-error': hasSocialSecurityNumberError() }\">\r\n            <div id=\"socialSecurityNumberError\" class=\"error-container text-nowrap\" *ngIf=\"hasSocialSecurityNumberError()\" role=\"alert\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"isSocialSecurityNumberRequired\">{{ socialSecurityNumberRequiredText }}</span>\r\n            </div>\r\n            <div class=\"Spa_Style_Label d-md-inline\">\r\n              <span *ngIf=\"isSocialSecurityNumberRequired\" class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>\r\n              <span [ngClass]=\"{ 'error-color': hasSocialSecurityNumberError() }\">{{ socialSecurityNumberLabelText }} </span>\r\n            </div>\r\n            <input\r\n              id=\"socialSecurityNumber\"\r\n              type=\"text\"\r\n              maxlength=\"11\"\r\n              inputmode=\"numeric\"\r\n              class=\"form-control\"\r\n              mask=\"{{ socialSecurityNumberMask }}\"\r\n              formControlName=\"socialSecurityNumber\"\r\n              autocomplete=\"off\"\r\n              [attr.aria-required]=\"isSocialSecurityNumberRequired\"\r\n              [attr.aria-describedby]=\"hasSocialSecurityNumberError() ? 'socialSecurityNumberError' : null\"\r\n              [ngClass]=\"{\r\n                'has-error': hasSocialSecurityNumberError()\r\n              }\"\r\n            />\r\n          </label>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"form-row align-items-baseline\">\r\n      <div class=\"col-12 col-md-3\">\r\n        <div class=\"form-group\">\r\n          <label for=\"address1\" class=\"address-autocomplete-wrapper\" [ngClass]=\"{ 'has-error': hasAddress1Error() }\">\r\n            <div id=\"address1Error\" class=\"error-container\" *ngIf=\"hasAddress1Error()\" role=\"alert\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"isAddress1Required\">{{ address1RequiredText }}</span>\r\n            </div>\r\n            <div class=\"Spa_Style_Label d-md-inline\">\r\n              <span *ngIf=\"isAddress1Required\" class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>\r\n              <span [ngClass]=\"{ 'error-color': hasAddress1Error() }\">{{ address1LabelText }} </span>\r\n            </div>\r\n            <ng-template #addressResultTemplate let-r=\"result\" let-t=\"term\">\r\n              <span class=\"Spa_Style_H5 no-translate-block\">\r\n                <ngb-highlight [result]=\"r.street_line\" [term]=\"t\"></ngb-highlight>\r\n                <span *ngIf=\"r.secondary\"> {{ r.secondary }}</span> {{ r.city }} {{ r.state\r\n                }}<span *ngIf=\"r.zipcode\">, {{ r.zipcode }}</span></span\r\n              >\r\n            </ng-template>\r\n            <input\r\n              #addressSearchInput\r\n              #typeahead=\"ngbTypeahead\"\r\n              id=\"address1\"\r\n              type=\"text\"\r\n              placement=\"bottom-left\"\r\n              class=\"form-control\"\r\n              [ngbTypeahead]=\"suggestedAddresses\"\r\n              [attr.aria-required]=\"isAddress1Required\"\r\n              [attr.aria-describedby]=\"hasAddress1Error() ? 'address1Error' : null\"\r\n              [attr.initialized]=\"false\"\r\n              [resultTemplate]=\"addressResultTemplate\"\r\n              [inputFormatter]=\"addressAutocompleteFormatter\"\r\n              [value]=\"addressSearchTerm\"\r\n              [ngClass]=\"{\r\n                'has-error': hasAddress1Error()\r\n              }\"\r\n              (keyup)=\"scrollItemIntoView()\"\r\n              (change)=\"onChangeAddressSearchTerm($event.target.value)\"\r\n              (selectItem)=\"selectItemForAddress($event)\"\r\n              (blur)=\"mapSearchTermToAddress($event)\"\r\n            />\r\n          </label>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-12 col-md-3\">\r\n        <div class=\"form-group\">\r\n          <label for=\"address2\" [ngClass]=\"{ 'has-error': hasAddress2Error() }\">\r\n            <div id=\"address2Error\" class=\"error-container\" *ngIf=\"hasAddress2Error()\" role=\"alert\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"isAddress2Required\">{{ address2RequiredText }}</span>\r\n            </div>\r\n            <div class=\"Spa_Style_Label d-md-inline\">\r\n              <span *ngIf=\"isAddress2Required\" class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>\r\n              <span [ngClass]=\"{ 'error-color': hasAddress2Error() }\">{{ address2LabelText }} </span>\r\n            </div>\r\n            <input\r\n              id=\"address2\"\r\n              type=\"text\"\r\n              formControlName=\"address2\"\r\n              class=\"form-control\"\r\n              [attr.aria-required]=\"isAddress2Required\"\r\n              [attr.aria-describedby]=\"hasAddress2Error() ? 'address2Error' : null\"\r\n              [ngClass]=\"{\r\n                'has-error': hasAddress2Error()\r\n              }\"\r\n            />\r\n          </label>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-12 col-md-3\">\r\n        <div class=\"form-group\">\r\n          <label for=\"city\" [ngClass]=\"{ 'has-error': hasCityError() }\">\r\n            <div id=\"cityError\" class=\"error-container text-nowrap\" *ngIf=\"hasCityError()\" role=\"alert\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"isCityRequired\">{{ cityRequiredText }}</span>\r\n            </div>\r\n            <div class=\"Spa_Style_Label d-md-inline\">\r\n              <span *ngIf=\"isCityRequired\" class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>\r\n              <span [ngClass]=\"{ 'error-color': hasCityError() }\">{{ cityLabelText }} </span>\r\n            </div>\r\n            <input\r\n              id=\"city\"\r\n              type=\"text\"\r\n              formControlName=\"city\"\r\n              class=\"form-control\"\r\n              [attr.aria-required]=\"isCityRequired\"\r\n              [attr.aria-describedby]=\"hasCityError() ? 'cityError' : null\"\r\n              [ngClass]=\"{\r\n                'has-error': hasCityError()\r\n              }\"\r\n            />\r\n          </label>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-12 col-md-1\">\r\n        <label id=\"stateLabelId\" [ngClass]=\"{ 'has-error': hasStateError() }\">\r\n          <div id=\"stateError\" class=\"error-container\" *ngIf=\"hasStateError()\" role=\"alert\">\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span *ngIf=\"isStateRequired\">{{ stateRequiredText }}</span>\r\n          </div>\r\n          <div class=\"Spa_Style_Label d-md-inline\">\r\n            <span *ngIf=\"isStateRequired\" class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>\r\n            <span [ngClass]=\"{ 'error-color': hasStateError() }\">{{ stateLabelText }} </span>\r\n          </div>\r\n          <div>\r\n            <vnext-state-selector-input\r\n              ariaLabelledById=\"stateLabelId\"\r\n              [control]=\"millimanMemberProfileForm?.controls?.state\"\r\n              [height]=\"'36px'\"\r\n              [attr.aria-required]=\"isStateRequired\"\r\n              [attr.aria-describedby]=\"hasStateError() ? 'hasStateError()' : null\"\r\n              [controlValue]=\"millimanMemberProfileForm?.controls?.state?.value\"\r\n            ></vnext-state-selector-input>\r\n          </div>\r\n        </label>\r\n      </div>\r\n      <div class=\"col-12 col-md-2 col-pad-right\">\r\n        <div class=\"form-group\">\r\n          <label for=\"zip\" [ngClass]=\"{ 'has-error': hasZipCodeError() }\" role=\"alert\">\r\n            <div id=\"zipCodeError\" class=\"error-container text-nowrap\" *ngIf=\"hasZipCodeError()\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"isZipRequired\">{{ zipRequiredText }}</span>\r\n            </div>\r\n            <div class=\"Spa_Style_Label d-md-inline\">\r\n              <span *ngIf=\"isZipRequired\" class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>\r\n              <span [ngClass]=\"{ 'error-color': hasZipCodeError() }\">{{ zipLabelText }} </span>\r\n            </div>\r\n            <input\r\n              id=\"zip\"\r\n              type=\"text\"\r\n              class=\"form-control\"\r\n              formControlName=\"zip\"\r\n              minlength=\"5\"\r\n              maxlength=\"5\"\r\n              inputmode=\"numeric\"\r\n              [attr.aria-describedby]=\"hasZipCodeError() ? 'zipCodeError' : null\"\r\n              [attr.aria-required]=\"isZipRequired\"\r\n              [ngClass]=\"{\r\n                'has-error': hasZipCodeError()\r\n              }\"\r\n            />\r\n          </label>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"form-row align-items-baseline\">\r\n      <div class=\"col-12 col-md-3\">\r\n        <div class=\"form-group\">\r\n          <label [ngClass]=\"{ 'has-error': hasHeightError() }\">\r\n            <div id=\"heightCodeError\" class=\"error-container text-nowrap\" *ngIf=\"hasHeightError()\" role=\"alert\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"isHeightRequired\">{{ heightFtRequiredText }}</span>\r\n            </div>\r\n            <div id=\"heightLabelId\" class=\"Spa_Style_Label d-md-inline\">\r\n              <span *ngIf=\"isHeightRequired\" class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>\r\n              <span [ngClass]=\"{ 'error-color': hasHeightError() }\">{{ heightLabelText }} </span>\r\n            </div>\r\n            <div class=\"input-wrapper\">\r\n              <input\r\n                type=\"text\"\r\n                class=\"form-control\"\r\n                formControlName=\"heightFt\"\r\n                inputmode=\"numeric\"\r\n                aria-labelledby=\"heightLabelId feetLabelId\"\r\n                [attr.aria-describedby]=\"hasHeightFtError() ? 'heightCodeError' : null\"\r\n                [attr.aria-required]=\"isHeightRequired\"\r\n                [ngClass]=\"{ 'has-error': hasHeightFtError() }\"\r\n              />\r\n              <span id=\"feetLabelId\" class=\"Spa_Style_Label number-input-label\">{{ feetLabelText }}</span>\r\n              <input\r\n                type=\"text\"\r\n                class=\"form-control\"\r\n                formControlName=\"heightIn\"\r\n                inputmode=\"numeric\"\r\n                aria-labelledby=\"heightLabelId inchLabelId\"\r\n                [attr.aria-describedby]=\"hasHeightInError() ? 'heightCodeError' : null\"\r\n                [attr.aria-required]=\"isHeightRequired\"\r\n                [ngClass]=\"{ 'has-error': hasHeightInError() }\"\r\n              />\r\n              <span id=\"inchLabelId\" class=\"Spa_Style_Label number-input-label\">{{ inchLabelText }}</span>\r\n            </div>\r\n          </label>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-12 col-md-3\">\r\n        <div class=\"form-group\">\r\n          <label for=\"weight\" class=\"address-autocomplete-wrapper\" [ngClass]=\"{ 'has-error': hasWeightError() }\">\r\n            <div id=\"weightError\" class=\"error-container\" *ngIf=\"hasWeightError()\" role=\"alert\">\r\n              <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"isWeightRequired\">{{ weightRequiredText }}</span>\r\n            </div>\r\n            <div class=\"Spa_Style_Label d-md-inline\">\r\n              <span *ngIf=\"isWeightRequired\" class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>\r\n              <span [ngClass]=\"{ 'error-color': hasWeightError() }\">{{ weightLabelText }} </span>\r\n            </div>\r\n            <div class=\"input-wrapper\">\r\n              <input\r\n                id=\"weight\"\r\n                type=\"text\"\r\n                class=\"form-control\"\r\n                formControlName=\"weight\"\r\n                inputmode=\"numeric\"\r\n                maxlength=\"4\"\r\n                [attr.aria-describedby]=\"hasWeightError() ? 'weightError' : null\"\r\n                [attr.aria-required]=\"isWeightRequired\"\r\n                [ngClass]=\"{ 'has-error': hasWeightError() }\"\r\n              />\r\n              <span class=\"Spa_Style_Label number-input-label\">{{ poundsLabelText }}</span>\r\n            </div>\r\n          </label>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <h3 class=\"Spa_Style_H3 my-2\">{{ millimanAuthorizationHeaderText }}</h3>\r\n  <div class=\"Spa_Style_Paragraph\" [innerHTML]=\"millimanAuthorizationText | safe : 'html'\"></div>\r\n  <div class=\"row mt-3 align-items-baseline\">\r\n    <div class=\"col-12 col-md-4\">\r\n      <div class=\"form-group\">\r\n        <label for=\"applicantFullName\" [ngClass]=\"{ 'has-error': hasApplicantFullNameError() }\">\r\n          <div id=\"applicantFullNameError\" class=\"error-container\" *ngIf=\"hasApplicantFullNameError()\" role=\"alert\">\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span *ngIf=\"isApplicantFullNameRequired\">{{ applicantFullNameRequiredText }}</span>\r\n          </div>\r\n          <div class=\"Spa_Style_Label d-md-inline\">\r\n            <span *ngIf=\"isApplicantFullNameRequired\" class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>\r\n            <span [ngClass]=\"{ 'error-color': hasApplicantFullNameError() }\">{{ applicantFullNameLabelText }} </span>\r\n          </div>\r\n          <input\r\n            id=\"applicantFullName\"\r\n            type=\"text\"\r\n            class=\"form-control\"\r\n            formControlName=\"applicantFullName\"\r\n            autocomplete=\"off\"\r\n            [attr.aria-required]=\"isApplicantFullNameRequired\"\r\n            [attr.aria-describedby]=\"hasApplicantFullNameError() ? 'applicantFullNameError' : 'applicantFullNameDescribedByText'\"\r\n            [ngClass]=\"{\r\n              'has-error': hasApplicantFullNameError()\r\n            }\"\r\n          />\r\n        </label>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-12 col-md-2\">\r\n      <div class=\"form-group\">\r\n        <label for=\"date\" [ngClass]=\"{ 'has-error': hasDateError() }\">\r\n          <div id=\"dateError\" class=\"error-container text-nowrap\" *ngIf=\"hasDateError()\" role=\"alert\">\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span *ngIf=\"isDateRequired\">{{ dateRequiredText }}</span>\r\n          </div>\r\n          <div class=\"Spa_Style_Label d-md-inline\">\r\n            <span *ngIf=\"isDateRequired\" class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>\r\n            <span [ngClass]=\"{ 'error-color': hasDateError() }\">{{ dateLabelText }} </span>\r\n          </div>\r\n          <div class=\"date-input\">\r\n            <input\r\n              id=\"date\"\r\n              type=\"text\"\r\n              class=\"form-control med-sup-number-input\"\r\n              formControlName=\"date\"\r\n              maxlength=\"12\"\r\n              inputmode=\"numeric\"\r\n              autocomplete=\"off\"\r\n              placeholder=\"{{ dateDefaultFormat }}\"\r\n              mask=\"{{ dateMaskFormat }}\"\r\n              [attr.aria-required]=\"isDateRequired\"\r\n              [attr.aria-describedby]=\"hasDateError() ? 'dateError' : null\"\r\n              [ngClass]=\"{\r\n                'has-error': hasDateError()\r\n              }\"\r\n              [dropSpecialCharacters]=\"false\"\r\n            />\r\n            <ng-container *ngIf=\"showDatePicker\">\r\n              <input\r\n                #datePickerInput=\"ngbDatepicker\"\r\n                ngbDatepicker\r\n                type=\"text\"\r\n                class=\"date-picker-input float-left p-0\"\r\n                tabindex=\"-1\"\r\n                aria-hidden=\"true\"\r\n                [minDate]=\"datePickerMinDate\"\r\n                [maxDate]=\"datePickerMaxDate\"\r\n                [ngClass]=\"{ 'has-error': hasDateError() }\"\r\n                (dateSelect)=\"onDateSelection($event)\"\r\n                (select)=\"onDateSelection($event)\"\r\n              />\r\n              <button class=\"btn btn-calendar\" (click)=\"datePickerInput.toggle()\">\r\n                <i aria-hidden=\"true\" role=\"presentation\" class=\"fas fa-calendar-alt\"></i>\r\n              </button>\r\n            </ng-container>\r\n          </div>\r\n        </label>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row Spa_Style_Paragraph\">\r\n    <div class=\"col-12\" id=\"applicantFullNameDescribedByText\">\r\n      {{ millimanApplicantNameMustMatchText }}\r\n    </div>\r\n  </div>\r\n  <div class=\"row mt-2\">\r\n    <div class=\"col-12\">\r\n      <div id=\"authorizationError\" class=\"error-container\" *ngIf=\"hasAuthorizationError()\">\r\n        <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n        <span *ngIf=\"isAuthorizationRequired\">{{ authorizationRequiredText }}</span>\r\n      </div>\r\n      <div class=\"form-check pl-0\">\r\n        <label for=\"authorize\" [ngClass]=\"{ 'has-error': hasAuthorizationError() }\" role=\"alert\">\r\n          <input\r\n            id=\"authorize\"\r\n            type=\"checkbox\"\r\n            formControlName=\"authorize\"\r\n            [attr.aria-required]=\"isAuthorizationRequired\"\r\n            [attr.aria-describedby]=\"hasAuthorizationError() ? 'authorizationError' : null\"\r\n            [ngClass]=\"{\r\n              'has-error': hasAuthorizationError()\r\n            }\"\r\n          />\r\n          <div class=\"Spa_Style_Label d-inline ml-2\">\r\n            <span *ngIf=\"isAuthorizationRequired\" class=\"input-error-asterisk\" aria-hidden=\"true\">*</span>\r\n            <span [ngClass]=\"{ 'error-color': hasAuthorizationError() }\">{{ authorizationLabelText }} </span>\r\n          </div>\r\n        </label>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</form>\r\n", styles: [".med-sup-number-input,.date-input{position:relative}.col-pad-right{padding-right:5%}.date-picker-input{color:transparent;border:transparent;height:0}.btn-calendar{position:absolute;right:0;top:0}.input-wrapper{display:inline-flex;align-items:center}.number-input-label{margin:0 5px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.AddressService }, { type: i1.AutoCompleteService }, { type: MedSupMillimanFormFacade }, { type: i1.ConfigResourceService }]; }, { typeahead: [{
            type: ViewChild,
            args: ['typeahead']
        }], addressSearchInput: [{
            type: ViewChild,
            args: ['addressSearchInput']
        }], showDatePicker: [{
            type: Input
        }], datePickerMaxDate: [{
            type: Input
        }], datePickerMinDate: [{
            type: Input
        }], formError: [{
            type: Output
        }], onUpdateMemberInformation: [{
            type: Output
        }] }); })();

function MedSupMillimanHealthQuestionComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "i", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r0.healthQuestion.requiredErrorMessage, " ");
} }
function MedSupMillimanHealthQuestionComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
const _c0$1b = function (a0) { return { "error-color": a0 }; };
class MedSupMillimanHealthQuestionComponent {
    constructor(cdr, medSupMillimanFormFacade) {
        this.cdr = cdr;
        this.medSupMillimanFormFacade = medSupMillimanFormFacade;
        this.onUpdateHealthQuestion = new EventEmitter();
        this.hasErrors = false;
        this.answers = {};
        this.subscriptions = [];
        this.disableNoneOfTheseApplyIfOptionSelected = false;
        this.disableOptionsIfNoneOfTheseApplySelected = false;
    }
    ngOnInit() {
        this.disableNoneOfTheseApplyIfOptionSelected = this.medSupMillimanFormFacade.getDisableNoneOfTheseApplyIfOptionSelected();
        this.disableOptionsIfNoneOfTheseApplySelected = this.medSupMillimanFormFacade.getDisableOptionsIfNoneOfTheseApplySelected();
        this.populateAnswers(this.healthQuestion);
        this.subscriptions = [
            this.medSupMillimanFormFacade.onValidateMedSupForm$.subscribe(() => {
                this.validateHealthQuestion(this.healthQuestion?.questionKey, this.answers);
                this.cdr.markForCheck();
            })
        ];
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    updateHealthQuestionAnswer(emitData) {
        const questionKey = this.healthQuestion.questionKey;
        if (questionKey) {
            const { value, hasError, error } = emitData;
            this.answers = value;
            this.hasErrors = hasError;
            this.onUpdateHealthQuestion.emit({ questionKey, error, hasError, value });
        }
    }
    populateAnswers(healthQuestion) {
        if (healthQuestion) {
            const options = [...healthQuestion.healthConditions, healthQuestion.noneOfTheseApply];
            options.forEach(option => (this.answers[option.key] = option.selected ? option.value : null));
        }
    }
    isMissingAnswers(answers) {
        return this.healthQuestion.required && !this.hasAnswers(answers);
    }
    hasAnswers(answers) {
        return !!answers && !!Object.values(answers).filter(answer => answer).length;
    }
    validateHealthQuestion(questionKey, answers) {
        if (questionKey && this.isMissingAnswers(answers)) {
            this.hasErrors = true;
            this.onUpdateHealthQuestion.emit({ questionKey, error: MedSupFormErrorTypes.REQUIRED, hasError: true, value: null });
        }
    }
}
MedSupMillimanHealthQuestionComponent.ɵfac = function MedSupMillimanHealthQuestionComponent_Factory(t) { return new (t || MedSupMillimanHealthQuestionComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(MedSupMillimanFormFacade)); };
MedSupMillimanHealthQuestionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedSupMillimanHealthQuestionComponent, selectors: [["vnext-med-sup-milliman-health-question"]], inputs: { healthQuestion: "healthQuestion" }, outputs: { onUpdateHealthQuestion: "onUpdateHealthQuestion" }, decls: 7, vars: 11, consts: [[1, "mt-3"], ["class", "error-color mb-1", 4, "ngIf"], [1, "Spa_Style_H4", "d-inline", "mb-3"], ["class", "input-error-asterisk", 4, "ngIf"], [3, "ngClass"], [3, "options", "noneOfTheseApply", "required", "disableOptionsIfNoneOfTheseApplySelected", "disableNoneOfTheseApplyIfOptionSelected", "onAnswersChanged"], [1, "error-color", "mb-1"], ["aria-hidden", "true", 1, "fa", "fa-exclamation-circle", "mr-1"], [1, "input-error-asterisk"]], template: function MedSupMillimanHealthQuestionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, MedSupMillimanHealthQuestionComponent_div_1_Template, 3, 1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, MedSupMillimanHealthQuestionComponent_span_3_Template, 2, 0, "span", 3);
        i0.ɵɵelementStart(4, "span", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "vnext-med-sup-checkboxes", 5);
        i0.ɵɵlistener("onAnswersChanged", function MedSupMillimanHealthQuestionComponent_Template_vnext_med_sup_checkboxes_onAnswersChanged_6_listener($event) { return ctx.updateHealthQuestionAnswer($event); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasErrors);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.healthQuestion.required);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0$1b, ctx.hasErrors));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.healthQuestion.questionText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("options", ctx.healthQuestion.healthConditions)("noneOfTheseApply", ctx.healthQuestion.noneOfTheseApply)("required", ctx.healthQuestion.required)("disableOptionsIfNoneOfTheseApplySelected", ctx.disableOptionsIfNoneOfTheseApplySelected)("disableNoneOfTheseApplyIfOptionSelected", ctx.disableNoneOfTheseApplyIfOptionSelected);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, IconAriaAttributesDirective, MedSupCheckboxesComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupMillimanHealthQuestionComponent, [{
        type: Component,
        args: [{ selector: 'vnext-med-sup-milliman-health-question', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"mt-3\">\r\n  <div class=\"error-color mb-1\" *ngIf=\"hasErrors\">\r\n    <i class=\"fa fa-exclamation-circle mr-1\" aria-hidden=\"true\"></i>{{ healthQuestion.requiredErrorMessage }}\r\n  </div>\r\n  <div class=\"Spa_Style_H4 d-inline mb-3\">\r\n    <span class=\"input-error-asterisk\" *ngIf=\"healthQuestion.required\">*</span>\r\n    <span [ngClass]=\"{ 'error-color': hasErrors }\">{{ healthQuestion.questionText }}</span>\r\n  </div>\r\n  <vnext-med-sup-checkboxes\r\n    [options]=\"healthQuestion.healthConditions\"\r\n    [noneOfTheseApply]=\"healthQuestion.noneOfTheseApply\"\r\n    [required]=\"healthQuestion.required\"\r\n    [disableOptionsIfNoneOfTheseApplySelected]=\"disableOptionsIfNoneOfTheseApplySelected\"\r\n    [disableNoneOfTheseApplyIfOptionSelected]=\"disableNoneOfTheseApplyIfOptionSelected\"\r\n    (onAnswersChanged)=\"updateHealthQuestionAnswer($event)\"\r\n  ></vnext-med-sup-checkboxes>\r\n</div>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: MedSupMillimanFormFacade }]; }, { healthQuestion: [{
            type: Input
        }], onUpdateHealthQuestion: [{
            type: Output
        }] }); })();

function MedSupMillimanFormComponent_ng_container_0_vnext_med_sup_milliman_health_question_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-milliman-health-question", 3);
    i0.ɵɵlistener("onUpdateHealthQuestion", function MedSupMillimanFormComponent_ng_container_0_vnext_med_sup_milliman_health_question_1_Template_vnext_med_sup_milliman_health_question_onUpdateHealthQuestion_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.updateHealthQuestionAnswer($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const healthQuestion_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("healthQuestion", healthQuestion_r2);
} }
function MedSupMillimanFormComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MedSupMillimanFormComponent_ng_container_0_vnext_med_sup_milliman_health_question_1_Template, 1, 1, "vnext-med-sup-milliman-health-question", 2);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const healthQuestion_r2 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", healthQuestion_r2);
} }
function MedSupMillimanFormComponent_vnext_medsup_milliman_authorization_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-medsup-milliman-authorization", 4);
    i0.ɵɵlistener("formError", function MedSupMillimanFormComponent_vnext_medsup_milliman_authorization_1_Template_vnext_medsup_milliman_authorization_formError_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.updateErrorList($event)); })("onUpdateMemberInformation", function MedSupMillimanFormComponent_vnext_medsup_milliman_authorization_1_Template_vnext_medsup_milliman_authorization_onUpdateMemberInformation_0_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.updateMemberInformation($event)); });
    i0.ɵɵelementEnd();
} }
class MedSupMillimanFormComponent {
    constructor(medSupMillimanFormFacade, medSupFormErrorContext) {
        this.medSupMillimanFormFacade = medSupMillimanFormFacade;
        this.medSupFormErrorContext = medSupFormErrorContext;
        this.formError = new EventEmitter();
        this.onMemberInformationReset = new EventEmitter();
        this.onMillimanMemberAuthorizationFormError = new EventEmitter();
        this.onHealthInformationChange = new EventEmitter();
        this.onMemberInformationChange = new EventEmitter();
        this.healthQuestionAnswers = {};
        this.millimanAuthorizationErrorList = [];
        this.subscriptions = [];
    }
    ngOnInit() {
        this.initHealthQuestionAnswers(this.healthQuestions);
        this.setHealthQuestionCKeys();
        this.setHealthQuestionDKeys();
        const millimanForm = { healthQuestions: this.healthQuestions, memberQuestions: this.memberQuestions };
        this.medSupFormErrorContext.initializeMillimanFormErrorMessages(millimanForm);
        this.toggleMedSupAuthorizationForm();
        this.subscriptions.push(this.medSupMillimanFormFacade.onValidateMedSupForm$.subscribe(() => {
            this.onHealthInformationChange.emit(this.healthQuestionAnswers);
        }));
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    updateHealthQuestionAnswer(data) {
        if (data) {
            const { questionKey, error, value } = data;
            if (error) {
                this.setHealthQuestionError(questionKey, error);
            }
            else if (value) {
                this.setHealthQuestionAnswers(questionKey, value);
            }
            this.toggleMedSupAuthorizationForm();
        }
    }
    updateErrorList(errorData) {
        this.millimanAuthorizationErrorList = errorData;
        this.onMillimanMemberAuthorizationFormError.emit(errorData);
    }
    updateMemberInformation(formData) {
        this.onMemberInformationChange.emit(formData);
    }
    trackByHealthQuestionKey(index, healthQuestion) {
        return healthQuestion.questionKey;
    }
    initHealthQuestionAnswers(healthQuestions) {
        if (healthQuestions) {
            if (!this.healthQuestionAnswers) {
                this.healthQuestionAnswers = {};
            }
            const options = _flatMap(healthQuestions, healthQuestion => [...healthQuestion.healthConditions, healthQuestion.noneOfTheseApply]);
            options.forEach(option => {
                this.healthQuestionAnswers[option.key] = option.selected ? option.value : null;
            });
        }
    }
    setHealthQuestionError(questionKey, error) {
        if (questionKey) {
            const updatedError = error || MedSupFormErrorTypes.REQUIRED;
            this.formError.emit({ questionKey, error: updatedError, hasError: !!updatedError, value: null });
        }
    }
    setHealthQuestionAnswers(questionKey, answers) {
        if (questionKey) {
            this.healthQuestionAnswers = { ...this.healthQuestionAnswers, ...answers };
            this.onHealthInformationChange.emit(this.healthQuestionAnswers);
            this.clearHealthQuestionError(questionKey);
        }
    }
    clearHealthQuestionError(questionKey) {
        if (questionKey) {
            this.formError.emit({ questionKey, error: null, hasError: false, value: null });
        }
    }
    setHealthQuestionCKeys() {
        const healthQuestionsC = this.getHealthQuestion(MILLIMAN_HEALTH_QUESTION_C_KEY);
        this.healthQuestionCKeys = this.getHealthQuestionKeys(healthQuestionsC, MedSupMillimanHealthConditionKey.NONE_OF_THESE_APPLY_QC);
    }
    setHealthQuestionDKeys() {
        const healthQuestionsD = this.getHealthQuestion(MILLIMAN_HEALTH_QUESTION_D_KEY);
        this.healthQuestionDKeys = this.getHealthQuestionKeys(healthQuestionsD, MedSupMillimanHealthConditionKey.NONE_OF_THESE_APPLY_QD);
    }
    getHealthQuestion(key) {
        return this.healthQuestions?.find(question => question.questionKey === key);
    }
    getHealthQuestionKeys(healthQuestions, key) {
        return healthQuestions?.healthConditions
            .filter((healthCondition) => healthCondition.key !== key)
            .map((condition) => condition.key);
    }
    toggleMedSupAuthorizationForm() {
        const isNoneOfTheAboveSelectedForAandB = !!this.healthQuestionAnswers[MedSupMillimanHealthConditionKey.NONE_OF_THESE_APPLY_QA] &&
            !!this.healthQuestionAnswers[MedSupMillimanHealthConditionKey.NONE_OF_THESE_APPLY_QB];
        const isNoneOfTheAboveSelectedForCandD = !!this.healthQuestionAnswers[MedSupMillimanHealthConditionKey.NONE_OF_THESE_APPLY_QC] &&
            !!this.healthQuestionAnswers[MedSupMillimanHealthConditionKey.NONE_OF_THESE_APPLY_QD];
        const isOptionSelectedForCorD = this.healthQuestionCKeys.some(key => !!this.healthQuestionAnswers[key]) ||
            this.healthQuestionDKeys.some(key => !!this.healthQuestionAnswers[key]);
        this.showMedSupMillimanAuthorization =
            (isNoneOfTheAboveSelectedForAandB && isNoneOfTheAboveSelectedForCandD) ||
                (isNoneOfTheAboveSelectedForAandB && isOptionSelectedForCorD);
        const cleanData = this.getClearedErrorList();
        if (this.isMedSupAuthorizationVisible) {
            if (this.isMedSupAuthorizationVisible !== this.showMedSupMillimanAuthorization) {
                this.onMillimanMemberAuthorizationFormError.emit(cleanData);
                this.onMemberInformationReset.emit(true);
            }
        }
        this.isMedSupAuthorizationVisible = this.showMedSupMillimanAuthorization;
    }
    getClearedErrorList() {
        return this.millimanAuthorizationErrorList.reduce((errorList, error) => {
            errorList.push({
                questionKey: error.questionKey,
                error: null,
                hasError: false,
                value: null
            });
            return errorList;
        }, []);
    }
}
MedSupMillimanFormComponent.ɵfac = function MedSupMillimanFormComponent_Factory(t) { return new (t || MedSupMillimanFormComponent)(i0.ɵɵdirectiveInject(MedSupMillimanFormFacade), i0.ɵɵdirectiveInject(MedSupFormErrorContext)); };
MedSupMillimanFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedSupMillimanFormComponent, selectors: [["vnext-med-sup-milliman-form"]], inputs: { healthQuestions: "healthQuestions", memberQuestions: "memberQuestions" }, outputs: { formError: "formError", onMemberInformationReset: "onMemberInformationReset", onMillimanMemberAuthorizationFormError: "onMillimanMemberAuthorizationFormError", onHealthInformationChange: "onHealthInformationChange", onMemberInformationChange: "onMemberInformationChange" }, decls: 2, vars: 3, consts: [[4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "formError", "onUpdateMemberInformation", 4, "ngIf"], [3, "healthQuestion", "onUpdateHealthQuestion", 4, "ngIf"], [3, "healthQuestion", "onUpdateHealthQuestion"], [3, "formError", "onUpdateMemberInformation"]], template: function MedSupMillimanFormComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MedSupMillimanFormComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
        i0.ɵɵtemplate(1, MedSupMillimanFormComponent_vnext_medsup_milliman_authorization_1_Template, 1, 0, "vnext-medsup-milliman-authorization", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.healthQuestions)("ngForTrackBy", ctx.trackByHealthQuestionKey);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showMedSupMillimanAuthorization);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, MedsupMillimanAuthorizationComponent, MedSupMillimanHealthQuestionComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupMillimanFormComponent, [{
        type: Component,
        args: [{ selector: 'vnext-med-sup-milliman-form', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngFor=\"let healthQuestion of healthQuestions; trackBy: trackByHealthQuestionKey\">\r\n  <vnext-med-sup-milliman-health-question\r\n    *ngIf=\"healthQuestion\"\r\n    [healthQuestion]=\"healthQuestion\"\r\n    (onUpdateHealthQuestion)=\"updateHealthQuestionAnswer($event)\"\r\n  ></vnext-med-sup-milliman-health-question>\r\n</ng-container>\r\n<vnext-medsup-milliman-authorization\r\n  *ngIf=\"showMedSupMillimanAuthorization\"\r\n  (formError)=\"updateErrorList($event)\"\r\n  (onUpdateMemberInformation)=\"updateMemberInformation($event)\"\r\n></vnext-medsup-milliman-authorization>\r\n" }]
    }], function () { return [{ type: MedSupMillimanFormFacade }, { type: MedSupFormErrorContext }]; }, { formError: [{
            type: Output
        }], onMemberInformationReset: [{
            type: Output
        }], onMillimanMemberAuthorizationFormError: [{
            type: Output
        }], onHealthInformationChange: [{
            type: Output
        }], onMemberInformationChange: [{
            type: Output
        }], healthQuestions: [{
            type: Input
        }], memberQuestions: [{
            type: Input
        }] }); })();

const _c0$1a = ["errorContainer"];
const _c1$v = ["medSupQuestions"];
const _c2$l = ["medSupEffectiveDate", "medSupPartAEffectiveDate", "medSupPartBEffectiveDate", "guaranteedIssue", "medSupGender", "medSupTobacco", "medSupHousehold", "medSupEFTDiscount", "medSupGIAdditional", "medSupPaymentMethod", "medSupWeight", "medSupPlanAge", "medSupTermLength", "medSupHeight", "medSupDateOfBirth", "medSupDisability"];
function MedSupFormComponent_ng_container_0_h2_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.formTitle);
} }
function MedSupFormComponent_ng_container_0_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelement(2, "vnext-notice", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", ctx_r3.errorNoticeTitle)("messages", ctx_r3.errorMessages)("type", "error")("errorKeywordText", ctx_r3.errorKeywordText);
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelement(1, "i", 35);
    i0.ɵɵelementStart(2, "span", 36);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", question_r8.name + "ValidationError");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r11.errorKeywordText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r11.getErrorMessage(question_r8.name, ctx_r11.questionErrors[question_r8.name]), " ");
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 37);
    i0.ɵɵtext(1, "* ");
    i0.ɵɵelementEnd();
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_span_8_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 41);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const tooltipKey_r35 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, tooltipKey_r35, "html"), i0.ɵɵsanitizeHtml);
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 38);
    i0.ɵɵtemplate(1, MedSupFormComponent_ng_container_0_ng_container_11_div_1_span_8_ng_template_1_Template, 2, 4, "ng-template", null, 39, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "i", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r36 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbTooltip", _r36);
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 41);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r15.guaranteedIssueTooltip, "html"), i0.ɵɵsanitizeHtml);
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42)(1, "span", 43);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "i", 44);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r14 = i0.ɵɵreference(10);
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r16.guaranteedIssueText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngbTooltip", _r14);
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-accordion", 45, 46);
    i0.ɵɵlistener("valueSelected", function MedSupFormComponent_ng_container_0_ng_container_11_div_1_ng_container_13_Template_vnext_accordion_valueSelected_1_listener($event) { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r40.giValueSelected($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const question_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fieldName", ctx_r17.medSupQuestionNames.GuaranteedIssue)("items", ctx_r17.guaranteedIssueOptions)("allowParentValues", true)("selectedParent", ctx_r17.selectedGIReasonParentId)("selectedChild", ctx_r17.selectedGIReasonChildId)("ariaDescribedById", ctx_r17.questionErrors[question_r8.name] ? question_r8.name + "ValidationError" : "")("ariaLabelledById", "guaranteed-issue-question-header guaranteed-issue-text");
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_toggle_14_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-toggle", 47, 48);
    i0.ɵɵlistener("updateAnswer", function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_toggle_14_Template_vnext_med_sup_toggle_updateAnswer_0_listener($event) { i0.ɵɵrestoreView(_r45); const ctx_r44 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r44.updateAnswer($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("question", question_r8)("fieldName", ctx_r18.medSupQuestionNames.Gender)("defaultValue", ctx_r18.questionUIDataMap[question_r8.name] == null ? null : ctx_r18.questionUIDataMap[question_r8.name].defaultValue)("limitButtonWidth", question_r8.name === ctx_r18.medSupQuestionNames.GIAdditional)("ariaLabelledById", ctx_r18.questionUIDataMap[question_r8.name] == null ? null : ctx_r18.questionUIDataMap[question_r8.name].ariaLabelledById)("ariaDescribedById", ctx_r18.questionErrors[question_r8.name] ? question_r8.name + "ValidationError" : "")("toggleControlId", question_r8.name)("isReadOnly", ctx_r18.questionUIDataMap[question_r8.name] == null ? null : ctx_r18.questionUIDataMap[question_r8.name].isPopulatedFromSSO);
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_toggle_15_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-toggle", 49, 50);
    i0.ɵɵlistener("updateAnswer", function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_toggle_15_Template_vnext_med_sup_toggle_updateAnswer_0_listener($event) { i0.ɵɵrestoreView(_r49); const ctx_r48 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r48.updateAnswer($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("question", question_r8)("fieldName", ctx_r19.medSupQuestionNames.Tobacco)("defaultValue", ctx_r19.questionUIDataMap[question_r8.name] == null ? null : ctx_r19.questionUIDataMap[question_r8.name].defaultValue)("limitButtonWidth", question_r8.name === ctx_r19.medSupQuestionNames.GIAdditional)("ariaLabelledById", ctx_r19.questionUIDataMap[question_r8.name] == null ? null : ctx_r19.questionUIDataMap[question_r8.name].ariaLabelledById)("ariaDescribedById", ctx_r19.questionErrors[question_r8.name] ? question_r8.name + "ValidationError" : "")("toggleControlId", question_r8.name);
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_toggle_16_Template(rf, ctx) { if (rf & 1) {
    const _r53 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-toggle", 49, 51);
    i0.ɵɵlistener("updateAnswer", function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_toggle_16_Template_vnext_med_sup_toggle_updateAnswer_0_listener($event) { i0.ɵɵrestoreView(_r53); const ctx_r52 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r52.updateAnswer($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("question", question_r8)("fieldName", ctx_r20.medSupQuestionNames.Disability)("defaultValue", ctx_r20.questionUIDataMap[question_r8.name] == null ? null : ctx_r20.questionUIDataMap[question_r8.name].defaultValue)("limitButtonWidth", question_r8.name === ctx_r20.medSupQuestionNames.GIAdditional)("ariaLabelledById", ctx_r20.questionUIDataMap[question_r8.name] == null ? null : ctx_r20.questionUIDataMap[question_r8.name].ariaLabelledById)("ariaDescribedById", ctx_r20.questionErrors[question_r8.name] ? question_r8.name + "ValidationError" : "")("toggleControlId", question_r8.name);
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_toggle_17_Template(rf, ctx) { if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-toggle", 49, 52);
    i0.ɵɵlistener("updateAnswer", function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_toggle_17_Template_vnext_med_sup_toggle_updateAnswer_0_listener($event) { i0.ɵɵrestoreView(_r57); const ctx_r56 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r56.updateAnswer($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("question", question_r8)("fieldName", ctx_r21.medSupQuestionNames.Household)("defaultValue", ctx_r21.questionUIDataMap[question_r8.name] == null ? null : ctx_r21.questionUIDataMap[question_r8.name].defaultValue)("limitButtonWidth", question_r8.name === ctx_r21.medSupQuestionNames.GIAdditional)("ariaLabelledById", ctx_r21.questionUIDataMap[question_r8.name] == null ? null : ctx_r21.questionUIDataMap[question_r8.name].ariaLabelledById)("ariaDescribedById", ctx_r21.questionErrors[question_r8.name] ? question_r8.name + "ValidationError" : "")("toggleControlId", question_r8.name);
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_toggle_18_Template(rf, ctx) { if (rf & 1) {
    const _r61 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-toggle", 49, 53);
    i0.ɵɵlistener("updateAnswer", function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_toggle_18_Template_vnext_med_sup_toggle_updateAnswer_0_listener($event) { i0.ɵɵrestoreView(_r61); const ctx_r60 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r60.updateAnswer($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("question", question_r8)("fieldName", ctx_r22.medSupQuestionNames.GIAdditional)("defaultValue", ctx_r22.questionUIDataMap[question_r8.name] == null ? null : ctx_r22.questionUIDataMap[question_r8.name].defaultValue)("limitButtonWidth", question_r8.name === ctx_r22.medSupQuestionNames.GIAdditional)("ariaLabelledById", ctx_r22.questionUIDataMap[question_r8.name] == null ? null : ctx_r22.questionUIDataMap[question_r8.name].ariaLabelledById)("ariaDescribedById", ctx_r22.questionErrors[question_r8.name] ? question_r8.name + "ValidationError" : "")("toggleControlId", question_r8.name);
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_effective_date_19_Template(rf, ctx) { if (rf & 1) {
    const _r65 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-effective-date", 54, 55);
    i0.ɵɵlistener("updateAnswer", function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_effective_date_19_Template_vnext_med_sup_effective_date_updateAnswer_0_listener($event) { i0.ɵɵrestoreView(_r65); const ctx_r64 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r64.updateAnswer($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("question", question_r8)("defaultValue", ctx_r23.questionUIDataMap[question_r8.name] == null ? null : ctx_r23.questionUIDataMap[question_r8.name].defaultValue)("noAnswerLabel", ctx_r23.dropdownDefaultText)("hasError", ctx_r23.questionErrors[question_r8.name] && ctx_r23.formSubmitted)("ariaLabelledById", ctx_r23.questionUIDataMap[question_r8.name] == null ? null : ctx_r23.questionUIDataMap[question_r8.name].ariaLabelledById)("ariaDescribedById", ctx_r23.questionErrors[question_r8.name] ? question_r8.name + "ValidationError" : "")("datePickerButtonLabelText", ctx_r23.datePickerButtonLabelText)("effectiveDateMessage", ctx_r23.effectiveDateMessage)("displayFormat", ctx_r23.displayFormat);
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_payment_method_20_Template(rf, ctx) { if (rf & 1) {
    const _r69 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-payment-method", 56, 57);
    i0.ɵɵlistener("updateAnswer", function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_payment_method_20_Template_vnext_med_sup_payment_method_updateAnswer_0_listener($event) { i0.ɵɵrestoreView(_r69); const ctx_r68 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r68.updateAnswer($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("question", question_r8)("defaultValue", ctx_r24.questionUIDataMap[question_r8.name] == null ? null : ctx_r24.questionUIDataMap[question_r8.name].defaultValue)("noAnswerLabel", ctx_r24.dropdownDefaultText)("hasError", ctx_r24.questionErrors[question_r8.name] && ctx_r24.formSubmitted)("ariaLabelledById", ctx_r24.questionUIDataMap[question_r8.name] == null ? null : ctx_r24.questionUIDataMap[question_r8.name].ariaLabelledById)("useToggle", ctx_r24.paymentMethodUseToggle)("ariaDescribedById", ctx_r24.questionErrors[question_r8.name] ? question_r8.name + "ValidationError" : "");
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_integer_21_Template(rf, ctx) { if (rf & 1) {
    const _r73 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-integer", 58, 59);
    i0.ɵɵlistener("updateAnswer", function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_integer_21_Template_vnext_med_sup_integer_updateAnswer_0_listener($event) { i0.ɵɵrestoreView(_r73); const ctx_r72 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r72.updateAnswer($event)); })("keyup.enter", function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_integer_21_Template_vnext_med_sup_integer_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r73); const ctx_r74 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r74.continueToPlans()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("question", question_r8)("fieldName", ctx_r25.medSupQuestionNames.Weight)("defaultValue", ctx_r25.questionUIDataMap[question_r8.name] == null ? null : ctx_r25.questionUIDataMap[question_r8.name].defaultValue)("label", ctx_r25.poundsLabel)("hasError", ctx_r25.questionErrors[question_r8.name] && ctx_r25.formSubmitted)("ariaLabelledById", ctx_r25.questionUIDataMap[question_r8.name] == null ? null : ctx_r25.questionUIDataMap[question_r8.name].ariaLabelledById)("ariaDescribedById", ctx_r25.questionErrors[question_r8.name] ? "extra-label " + question_r8.name + "ValidationError" : "");
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_integer_22_Template(rf, ctx) { if (rf & 1) {
    const _r78 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-integer", 60, 61);
    i0.ɵɵlistener("updateAnswer", function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_integer_22_Template_vnext_med_sup_integer_updateAnswer_0_listener($event) { i0.ɵɵrestoreView(_r78); const ctx_r77 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r77.updateAnswer($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r26 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("question", question_r8)("fieldName", ctx_r26.medSupQuestionNames.PlanAge)("defaultValue", ctx_r26.questionUIDataMap[question_r8.name] == null ? null : ctx_r26.questionUIDataMap[question_r8.name].defaultValue)("label", "")("hasError", ctx_r26.questionErrors[question_r8.name] && ctx_r26.formSubmitted)("ariaLabelledById", ctx_r26.questionUIDataMap[question_r8.name] == null ? null : ctx_r26.questionUIDataMap[question_r8.name].ariaLabelledById)("ariaDescribedById", ctx_r26.questionErrors[question_r8.name] ? question_r8.name + "ValidationError" : "");
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_integer_23_Template(rf, ctx) { if (rf & 1) {
    const _r82 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-integer", 60, 62);
    i0.ɵɵlistener("updateAnswer", function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_integer_23_Template_vnext_med_sup_integer_updateAnswer_0_listener($event) { i0.ɵɵrestoreView(_r82); const ctx_r81 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r81.updateAnswer($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r27 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("question", question_r8)("fieldName", ctx_r27.medSupQuestionNames.TermLength)("defaultValue", ctx_r27.questionUIDataMap[question_r8.name] == null ? null : ctx_r27.questionUIDataMap[question_r8.name].defaultValue)("label", "")("hasError", ctx_r27.questionErrors[question_r8.name] && ctx_r27.formSubmitted)("ariaLabelledById", ctx_r27.questionUIDataMap[question_r8.name] == null ? null : ctx_r27.questionUIDataMap[question_r8.name].ariaLabelledById)("ariaDescribedById", ctx_r27.questionErrors[question_r8.name] ? question_r8.name + "ValidationError" : "");
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_height_24_Template(rf, ctx) { if (rf & 1) {
    const _r86 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-height", 63, 64);
    i0.ɵɵlistener("updateAnswer", function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_height_24_Template_vnext_med_sup_height_updateAnswer_0_listener($event) { i0.ɵɵrestoreView(_r86); const ctx_r85 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r85.updateAnswer($event)); })("keyup.enter", function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_height_24_Template_vnext_med_sup_height_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r86); const ctx_r87 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r87.continueToPlans()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("question", question_r8)("defaultValue", ctx_r28.questionUIDataMap[question_r8.name] == null ? null : ctx_r28.questionUIDataMap[question_r8.name].defaultValue)("feetLabel", ctx_r28.feetLabel)("inchesLabel", ctx_r28.inchesLabel)("hasError", ctx_r28.questionErrors[question_r8.name] && ctx_r28.formSubmitted)("ariaLabelledById", ctx_r28.questionUIDataMap[question_r8.name] == null ? null : ctx_r28.questionUIDataMap[question_r8.name].ariaLabelledById)("ariaDescribedByFtInputId", ctx_r28.questionErrors[question_r8.name] ? "number-input-label-foot " + question_r8.name + "ValidationError" : "")("ariaDescribedByInInputId", ctx_r28.questionErrors[question_r8.name] ? "number-input-label-inch " + question_r8.name + "ValidationError" : "");
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_birth_date_25_Template(rf, ctx) { if (rf & 1) {
    const _r91 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-birth-date", 65, 66);
    i0.ɵɵlistener("updateAnswer", function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_birth_date_25_Template_vnext_med_sup_birth_date_updateAnswer_0_listener($event) { i0.ɵɵrestoreView(_r91); const ctx_r90 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r90.updateAnswer($event)); })("keyup.enter", function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_birth_date_25_Template_vnext_med_sup_birth_date_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r91); const ctx_r92 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r92.continueToPlans()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r29 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("defaultValue", ctx_r29.questionUIDataMap[question_r8.name] == null ? null : ctx_r29.questionUIDataMap[question_r8.name].defaultValue)("question", question_r8)("hasError", ctx_r29.questionErrors[question_r8.name] && ctx_r29.formSubmitted)("ariaDescribedById", ctx_r29.questionErrors[question_r8.name] ? question_r8.name + "ValidationError" : "")("ariaLabelledById", ctx_r29.questionUIDataMap[question_r8.name] == null ? null : ctx_r29.questionUIDataMap[question_r8.name].ariaLabelledById)("isReadOnly", ctx_r29.questionUIDataMap[question_r8.name] == null ? null : ctx_r29.questionUIDataMap[question_r8.name].isPopulatedFromSSO);
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_effective_date_a_26_Template(rf, ctx) { if (rf & 1) {
    const _r96 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-effective-date-a", 67, 68);
    i0.ɵɵlistener("updateAnswer", function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_effective_date_a_26_Template_vnext_med_sup_effective_date_a_updateAnswer_0_listener($event) { i0.ɵɵrestoreView(_r96); const ctx_r95 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r95.updateAnswer($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r30 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("defaultValue", ctx_r30.questionUIDataMap[question_r8.name] == null ? null : ctx_r30.questionUIDataMap[question_r8.name].defaultValue)("selectMonthText", ctx_r30.selectMonthText)("selectYearText", ctx_r30.selectYearText)("question", question_r8)("dateOfBirth", ctx_r30.questionUIDataMap[ctx_r30.medSupQuestionNames.DateOfBirth] == null ? null : ctx_r30.questionUIDataMap[ctx_r30.medSupQuestionNames.DateOfBirth].value)("hasError", ctx_r30.questionErrors[question_r8.name] && ctx_r30.formSubmitted)("ariaDescribedById", ctx_r30.questionErrors[question_r8.name] ? question_r8.name + "ValidationError" : "")("ariaLabelledById", ctx_r30.questionUIDataMap[question_r8.name] == null ? null : ctx_r30.questionUIDataMap[question_r8.name].ariaLabelledById)("datePickerButtonLabelText", ctx_r30.datePickerButtonLabelText)("monthYearRangePartA", ctx_r30.monthYearRangePartA)("dropdownEnabledPartA", ctx_r30.dropdownEnabledPartA)("monthRangeForPartAandPartB", ctx_r30.monthRangeForPartAandPartB)("yearRangeForPartAandPartB", ctx_r30.yearRangeForPartA)("partBEffectiveDate", ctx_r30.questionUIDataMap[ctx_r30.medSupQuestionNames.PartBEffectiveDate] == null ? null : ctx_r30.questionUIDataMap[ctx_r30.medSupQuestionNames.PartBEffectiveDate].value)("locale", ctx_r30.locale);
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_effective_date_b_27_Template(rf, ctx) { if (rf & 1) {
    const _r100 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-effective-date-b", 69, 70);
    i0.ɵɵlistener("updateAnswer", function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_effective_date_b_27_Template_vnext_med_sup_effective_date_b_updateAnswer_0_listener($event) { i0.ɵɵrestoreView(_r100); const ctx_r99 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r99.updateAnswer($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r31 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("defaultValue", ctx_r31.questionUIDataMap[question_r8.name] == null ? null : ctx_r31.questionUIDataMap[question_r8.name].defaultValue)("selectMonthText", ctx_r31.selectMonthText)("selectYearText", ctx_r31.selectYearText)("question", question_r8)("dateOfBirth", ctx_r31.questionUIDataMap[ctx_r31.medSupQuestionNames.DateOfBirth] == null ? null : ctx_r31.questionUIDataMap[ctx_r31.medSupQuestionNames.DateOfBirth].value)("hasError", ctx_r31.questionErrors[question_r8.name] && ctx_r31.formSubmitted)("ariaDescribedById", ctx_r31.questionErrors[question_r8.name] ? question_r8.name + "ValidationError" : "")("ariaLabelledById", ctx_r31.questionUIDataMap[question_r8.name] == null ? null : ctx_r31.questionUIDataMap[question_r8.name].ariaLabelledById)("datePickerButtonLabelText", ctx_r31.datePickerButtonLabelText)("monthYearRangePartB", ctx_r31.monthYearRangePartB)("dropdownEnabledPartB", ctx_r31.dropdownEnabledPartB)("monthRangeForPartAandPartB", ctx_r31.monthRangeForPartAandPartB)("yearRangeForPartAandPartB", ctx_r31.yearRangeForPartB)("partAEffectiveDate", ctx_r31.questionUIDataMap[ctx_r31.medSupQuestionNames.PartAEffectiveDate] == null ? null : ctx_r31.questionUIDataMap[ctx_r31.medSupQuestionNames.PartAEffectiveDate].value)("locale", ctx_r31.locale);
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_toggle_28_Template(rf, ctx) { if (rf & 1) {
    const _r104 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-toggle", 49, 71);
    i0.ɵɵlistener("updateAnswer", function MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_toggle_28_Template_vnext_med_sup_toggle_updateAnswer_0_listener($event) { i0.ɵɵrestoreView(_r104); const ctx_r103 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r103.updateAnswer($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("question", question_r8)("fieldName", ctx_r32.medSupQuestionNames.EFTDiscount)("defaultValue", ctx_r32.questionUIDataMap[question_r8.name] == null ? null : ctx_r32.questionUIDataMap[question_r8.name].defaultValue)("limitButtonWidth", question_r8.name === ctx_r32.medSupQuestionNames.GIAdditional)("ariaLabelledById", ctx_r32.questionUIDataMap[question_r8.name] == null ? null : ctx_r32.questionUIDataMap[question_r8.name].ariaLabelledById)("ariaDescribedById", ctx_r32.questionErrors[question_r8.name] ? question_r8.name + "ValidationError" : "")("toggleControlId", question_r8.name);
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_ng_container_29_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 74);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r106 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r106.effectiveDateMessage, " ");
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_ng_container_29_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 75);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r107 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r107.rateFactorDisclaimer, " ");
} }
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_ng_container_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MedSupFormComponent_ng_container_0_ng_container_11_div_1_ng_container_29_p_1_Template, 2, 1, "p", 72);
    i0.ɵɵtemplate(2, MedSupFormComponent_ng_container_0_ng_container_11_div_1_ng_container_29_div_2_Template, 2, 1, "div", 73);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r33.totalPlanCount > 0 && ctx_r33.displayEffectiveDateMessage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r33.rateFactorDisclaimerEnabled);
} }
const _c3$c = function (a0, a1) { return { "error-color": a0, "Spa_Style_Bold_Weight": a1 }; };
const _c4$5 = function (a0) { return { Spa_Style_Gray4_Color: a0 }; };
function MedSupFormComponent_ng_container_0_ng_container_11_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", null, 15)(2, "label", 16);
    i0.ɵɵtemplate(3, MedSupFormComponent_ng_container_0_ng_container_11_div_1_div_3_Template, 5, 3, "div", 17);
    i0.ɵɵelementStart(4, "div", 18);
    i0.ɵɵtemplate(5, MedSupFormComponent_ng_container_0_ng_container_11_div_1_span_5_Template, 2, 0, "span", 19);
    i0.ɵɵelement(6, "span", 20);
    i0.ɵɵpipe(7, "safe");
    i0.ɵɵtemplate(8, MedSupFormComponent_ng_container_0_ng_container_11_div_1_span_8_Template, 4, 1, "span", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, MedSupFormComponent_ng_container_0_ng_container_11_div_1_ng_template_9_Template, 2, 4, "ng-template", null, 22, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(11, MedSupFormComponent_ng_container_0_ng_container_11_div_1_div_11_Template, 4, 2, "div", 23);
    i0.ɵɵelementContainerStart(12);
    i0.ɵɵtemplate(13, MedSupFormComponent_ng_container_0_ng_container_11_div_1_ng_container_13_Template, 3, 7, "ng-container", 0);
    i0.ɵɵtemplate(14, MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_toggle_14_Template, 2, 8, "vnext-med-sup-toggle", 24);
    i0.ɵɵtemplate(15, MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_toggle_15_Template, 2, 7, "vnext-med-sup-toggle", 25);
    i0.ɵɵtemplate(16, MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_toggle_16_Template, 2, 7, "vnext-med-sup-toggle", 25);
    i0.ɵɵtemplate(17, MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_toggle_17_Template, 2, 7, "vnext-med-sup-toggle", 25);
    i0.ɵɵtemplate(18, MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_toggle_18_Template, 2, 7, "vnext-med-sup-toggle", 25);
    i0.ɵɵtemplate(19, MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_effective_date_19_Template, 2, 9, "vnext-med-sup-effective-date", 26);
    i0.ɵɵtemplate(20, MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_payment_method_20_Template, 2, 7, "vnext-med-sup-payment-method", 27);
    i0.ɵɵtemplate(21, MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_integer_21_Template, 2, 7, "vnext-med-sup-integer", 28);
    i0.ɵɵtemplate(22, MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_integer_22_Template, 2, 7, "vnext-med-sup-integer", 29);
    i0.ɵɵtemplate(23, MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_integer_23_Template, 2, 7, "vnext-med-sup-integer", 29);
    i0.ɵɵtemplate(24, MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_height_24_Template, 2, 8, "vnext-med-sup-height", 30);
    i0.ɵɵtemplate(25, MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_birth_date_25_Template, 2, 6, "vnext-med-sup-birth-date", 31);
    i0.ɵɵtemplate(26, MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_effective_date_a_26_Template, 2, 15, "vnext-med-sup-effective-date-a", 32);
    i0.ɵɵtemplate(27, MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_effective_date_b_27_Template, 2, 15, "vnext-med-sup-effective-date-b", 33);
    i0.ɵɵtemplate(28, MedSupFormComponent_ng_container_0_ng_container_11_div_1_vnext_med_sup_toggle_28_Template, 2, 7, "vnext-med-sup-toggle", 25);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(29, MedSupFormComponent_ng_container_0_ng_container_11_div_1_ng_container_29_Template, 3, 2, "ng-container", 0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const question_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMapInterpolate1("question-wrapper ", ctx_r9.questionClasses[question_r8.name], "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r9.questionUIDataMap[question_r8.name] == null ? null : ctx_r9.questionUIDataMap[question_r8.name].ariaLabelledById);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.questionErrors[question_r8.name] && ctx_r9.formSubmitted);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(31, _c3$c, ctx_r9.questionErrors[question_r8.name] && ctx_r9.formSubmitted, question_r8.name !== ctx_r9.medSupQuestionNames.GIAdditional));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.questionUIDataMap[question_r8.name] == null ? null : ctx_r9.questionUIDataMap[question_r8.name].required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(7, 28, ctx_r9.questionUIDataMap[question_r8.name] == null ? null : ctx_r9.questionUIDataMap[question_r8.name].description, "html"), i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction1(34, _c4$5, ctx_r9.questionUIDataMap[question_r8.name] == null ? null : ctx_r9.questionUIDataMap[question_r8.name].isPopulatedFromSSO));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r9.questionUIDataMap[question_r8.name] == null ? null : ctx_r9.questionUIDataMap[question_r8.name].tooltip);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", question_r8.name === ctx_r9.medSupQuestionNames.GuaranteedIssue);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", question_r8.name === ctx_r9.medSupQuestionNames.GuaranteedIssue);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", question_r8.name === ctx_r9.medSupQuestionNames.Gender);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", question_r8.name === ctx_r9.medSupQuestionNames.Tobacco);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", question_r8.name === ctx_r9.medSupQuestionNames.Disability);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", question_r8.name === ctx_r9.medSupQuestionNames.Household);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", question_r8.name === ctx_r9.medSupQuestionNames.GIAdditional);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", question_r8.name === ctx_r9.medSupQuestionNames.EffectiveDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", question_r8.name === ctx_r9.medSupQuestionNames.PaymentMethod);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", question_r8.name === ctx_r9.medSupQuestionNames.Weight);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", question_r8.name === ctx_r9.medSupQuestionNames.PlanAge);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", question_r8.name === ctx_r9.medSupQuestionNames.TermLength);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", question_r8.name === ctx_r9.medSupQuestionNames.Height);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", question_r8.name === ctx_r9.medSupQuestionNames.DateOfBirth);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", question_r8.name === ctx_r9.medSupQuestionNames.PartAEffectiveDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", question_r8.name === ctx_r9.medSupQuestionNames.PartBEffectiveDate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", question_r8.name === ctx_r9.medSupQuestionNames.EFTDiscount);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", question_r8.name === ctx_r9.medSupQuestionNames.EffectiveDate);
} }
function MedSupFormComponent_ng_container_0_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MedSupFormComponent_ng_container_0_ng_container_11_div_1_Template, 30, 36, "div", 14);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const question_r8 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.doesQuestionExist(question_r8.name) && ctx_r4.questionUIDataMap[question_r8.name] && !(ctx_r4.questionUIDataMap[question_r8.name] == null ? null : ctx_r4.questionUIDataMap[question_r8.name].hidden));
} }
function MedSupFormComponent_ng_container_0_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    const _r110 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-med-sup-plan-sub-type", 76);
    i0.ɵɵlistener("valueSelected", function MedSupFormComponent_ng_container_0_ng_container_12_Template_vnext_med_sup_plan_sub_type_valueSelected_1_listener($event) { i0.ɵɵrestoreView(_r110); const ctx_r109 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r109.selectPlanSubType($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("headerText", ctx_r5.planSubTypeHeaderText)("placeholder", ctx_r5.planSubTypePlaceholderText)("error", ctx_r5.planSubTypeError)("errorKeywordText", ctx_r5.errorKeywordText)("selectedPlanSubType", ctx_r5.selectedPlanSubType)("planSubTypes", ctx_r5.planSubTypes);
} }
function MedSupFormComponent_ng_container_0_vnext_med_sup_milliman_form_13_Template(rf, ctx) { if (rf & 1) {
    const _r112 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-med-sup-milliman-form", 77);
    i0.ɵɵlistener("formError", function MedSupFormComponent_ng_container_0_vnext_med_sup_milliman_form_13_Template_vnext_med_sup_milliman_form_formError_0_listener($event) { i0.ɵɵrestoreView(_r112); const ctx_r111 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r111.onMillimanFormError($event)); })("onMemberInformationReset", function MedSupFormComponent_ng_container_0_vnext_med_sup_milliman_form_13_Template_vnext_med_sup_milliman_form_onMemberInformationReset_0_listener($event) { i0.ɵɵrestoreView(_r112); const ctx_r113 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r113.onMemberInformationReset($event)); })("onMillimanMemberAuthorizationFormError", function MedSupFormComponent_ng_container_0_vnext_med_sup_milliman_form_13_Template_vnext_med_sup_milliman_form_onMillimanMemberAuthorizationFormError_0_listener($event) { i0.ɵɵrestoreView(_r112); const ctx_r114 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r114.onMillimanMemberAuthorizationFormError($event)); })("onHealthInformationChange", function MedSupFormComponent_ng_container_0_vnext_med_sup_milliman_form_13_Template_vnext_med_sup_milliman_form_onHealthInformationChange_0_listener($event) { i0.ɵɵrestoreView(_r112); const ctx_r115 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r115.updateMillimanHealthInformation($event)); })("onMemberInformationChange", function MedSupFormComponent_ng_container_0_vnext_med_sup_milliman_form_13_Template_vnext_med_sup_milliman_form_onMemberInformationChange_0_listener($event) { i0.ɵɵrestoreView(_r112); const ctx_r116 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r116.updateMillimanMemberInformation($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("healthQuestions", ctx_r6.healthQuestions)("memberQuestions", ctx_r6.memberQuestions);
} }
function MedSupFormComponent_ng_container_0_vnext_link_15_Template(rf, ctx) { if (rf & 1) {
    const _r118 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 78);
    i0.ɵɵlistener("click", function MedSupFormComponent_ng_container_0_vnext_link_15_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r118); const ctx_r117 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r117.hideForm()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r7.previousLabel)("showArrow", "left");
} }
function MedSupFormComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r120 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "p", 1);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵtemplate(3, MedSupFormComponent_ng_container_0_h2_3_Template, 2, 1, "h2", 2);
    i0.ɵɵelementStart(4, "div", 3);
    i0.ɵɵelement(5, "div", 4);
    i0.ɵɵpipe(6, "safe");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", null, 5);
    i0.ɵɵtemplate(9, MedSupFormComponent_ng_container_0_ng_container_9_Template, 3, 4, "ng-container", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 6);
    i0.ɵɵtemplate(11, MedSupFormComponent_ng_container_0_ng_container_11_Template, 2, 1, "ng-container", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, MedSupFormComponent_ng_container_0_ng_container_12_Template, 2, 6, "ng-container", 0);
    i0.ɵɵtemplate(13, MedSupFormComponent_ng_container_0_vnext_med_sup_milliman_form_13_Template, 1, 2, "vnext-med-sup-milliman-form", 8);
    i0.ɵɵelementStart(14, "vnext-navigation-banner", 9);
    i0.ɵɵtemplate(15, MedSupFormComponent_ng_container_0_vnext_link_15_Template, 1, 2, "vnext-link", 10);
    i0.ɵɵelementStart(16, "button", 11);
    i0.ɵɵlistener("click", function MedSupFormComponent_ng_container_0_Template_button_click_16_listener() { i0.ɵɵrestoreView(_r120); const ctx_r119 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r119.continueToPlans()); });
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(2, 10, ctx_r0.formPrompt, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r0.formTitle == null ? null : ctx_r0.formTitle.length) > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(6, 13, ctx_r0.spaPageSubHeader, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.errorMessages.length && ctx_r0.formSubmitted);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.sortedQuestions)("ngForTrackBy", ctx_r0.trackIndex);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showPlanTypeDropdown);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showMillimanForm);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showPreviousLink);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.continueButtonText, " ");
} }
class MedSupFormComponent {
    constructor(store, configResourceService, configurableWidgetService, planFacade, widgetService, cdr, medSupService, planListResourceFacade, router, analyticsService, localeService, spinnerService, medSupFormErrorContext, medSupFacade, profileFacade, ssoPopulatedFieldService, medSupMillimanFormFacade, medSupMillimanService, millimanService, planListFacade, hospitalIndemnityFormFacade, memberSessionService, planYearResourceService) {
        this.store = store;
        this.configResourceService = configResourceService;
        this.configurableWidgetService = configurableWidgetService;
        this.planFacade = planFacade;
        this.widgetService = widgetService;
        this.cdr = cdr;
        this.medSupService = medSupService;
        this.planListResourceFacade = planListResourceFacade;
        this.router = router;
        this.analyticsService = analyticsService;
        this.localeService = localeService;
        this.spinnerService = spinnerService;
        this.medSupFormErrorContext = medSupFormErrorContext;
        this.medSupFacade = medSupFacade;
        this.profileFacade = profileFacade;
        this.ssoPopulatedFieldService = ssoPopulatedFieldService;
        this.medSupMillimanFormFacade = medSupMillimanFormFacade;
        this.medSupMillimanService = medSupMillimanService;
        this.millimanService = millimanService;
        this.planListFacade = planListFacade;
        this.hospitalIndemnityFormFacade = hospitalIndemnityFormFacade;
        this.memberSessionService = memberSessionService;
        this.planYearResourceService = planYearResourceService;
        this.showPreviousLink = true;
        this.previousLabel = 'Previous';
        this.inchesLabel = 'in';
        this.feetLabel = 'ft';
        this.poundsLabel = 'lbs';
        this.selectMonthText = 'Month';
        this.selectYearText = 'Year';
        this.dropdownDefaultText = 'Select an option';
        this.continueButtonText = 'Continue to plans';
        this.formTitle = 'Medicare Supplemental Information';
        this.totalPlanCount = 0;
        this.formPrompt = 'Medicare Supplement plan premiums and eligibility may vary. Please provide the following additional ' +
            'information to calculate your plan premiums and determine if you are eligible for enrollment in the plan.';
        this.plansLoading = false;
        this.productType = ProductType.MEDICAL;
        this.planSubTypeEnabled = false;
        this.planSubTypeHeaderText = 'Plan type';
        this.planSubTypePlaceholderText = 'Select one';
        this.displayEffectiveDateMessage = false;
        this.formClose = new EventEmitter();
        this.medSupQuestionNames = MedSupQuestionNames;
        this.questions = [];
        this.answers = [];
        this.checkFocus = false;
        this.focusFirstMedSupFormElement = false;
        this.questionSizes = {
            toggle: 'col-6 col-sm-4 col-lg-3',
            small: 'col-6 col-sm-4 col-lg-3',
            medium: 'col-12 col-sm-8 col-lg-6',
            large: 'col-12'
        };
        this.hiddenQuestions = [];
        this.errorMessages = [];
        this.questionErrors = {};
        this.questionUIDataMap = {};
        this.millimanFormErrors = {};
        this.showMillimanForm = false;
        this.isMedSupMillimanEnabled = false;
        this.hasMillimanRequestSuccess = false;
        this.planSubTypeError = '';
        this.planSubTypeQuestionKey = 'PlanSubType';
        this.selectedPlanSubType = '';
        this.planSubTypes = [];
        this.showPlanTypeDropdown = false;
        this.millimanUpdating = false;
        this.millimanCalled = false;
        this.displayFormat = 'MMMM YYYY';
        this.formSubmitted = false;
        this.validateWidget = () => {
            const errors = [];
            return errors;
        };
        this.millimanErrorConfirmAction = async () => {
            await this.resetMillimanTier();
            this.formClose.emit(true);
            this.medSupService.resetActiveTabToDefault();
        };
    }
    setQuestionError(key, error) {
        if (error !== this.questionErrors[key]) {
            this.questionErrors[key] = error;
            this.setErrorMessages(this.questionErrors);
        }
    }
    setQuestionErrors(errors) {
        this.questionErrors = errors;
        this.setErrorMessages(this.questionErrors);
    }
    // Sets the error messages for display in the error notice
    setErrorMessages(errors) {
        this.errorMessages = Object.keys(errors).reduce((messages, key) => {
            if (errors[key]) {
                messages.push({ message: this.getErrorMessage(key, errors[key]) });
            }
            return messages;
        }, []);
        this.cdr.markForCheck();
    }
    selectPlanSubType(subType) {
        this.selectedPlanSubType = subType;
        this.planSubTypeError = '';
        this.setQuestionError(MedSupQuestionNames.PlanSubType, null);
    }
    ngOnInit() {
        this.googleTagManagerNotApplicableText = this.analyticsService.getGoogleTagManagerNotApplicableText();
        this.widgetName = this.widgetService.widgetName;
        this.initForm();
        this.focusFirstMedSupFormElement = true;
        this.initializePartAandPartBDropdownEnabled();
        this.initializeMedSupMillimanFormEnabled();
        this.subscriptions = [
            this.localeService.getCurrentLocale$().subscribe(locale => {
                this.initializeTranslatableText(this.widgetName);
                this.medSupFormErrorContext.initializeErrorMessages(this.questionMetaData);
                this.setErrorMessages(this.questionErrors);
                this.populateQuestionUIDataMap();
                this.initializeMillimanForm();
                this.locale = locale;
                if (this.dropdownEnabledPartA || this.dropdownEnabledPartB) {
                    this.setPartAandPartBMonthYearRange();
                }
                this.cdr.markForCheck();
            }),
            this.medSupFacade.getSelectedPlanSubType$().subscribe({
                next: (planSubType) => {
                    this.selectedPlanSubType = planSubType;
                }
            })
        ];
        if (this.ssoPopulatedFieldService.isReadOnlyEnabled()) {
            this.subscriptions.push(this.ssoPopulatedFieldService.getPopulatedFields$().subscribe(prepopulatedFields => {
                this.ssoPopulatedMedsupQuestionNames = this.mapPrepopulatedFieldToMedSupQuestionName(prepopulatedFields);
                this.populateQuestionUIDataMap();
                this.cdr.markForCheck();
            }));
        }
        if (this.dropdownEnabledPartA || this.dropdownEnabledPartB) {
            this.setPartAandPartBMonthYearRange();
        }
        if (this.isMedSupMillimanEnabled) {
            this.memberQuestions = this.medSupMillimanFormFacade.getMillimanMemberInformationFormFields();
            this.healthQuestions = this.medSupMillimanFormFacade.getMillimanHealthQuestions();
            this.millimanHealthInformation = this.medSupMillimanFormFacade.getMillimanHealthInformationFromMemberNotes();
            this.subscriptions.push(this.millimanService.getMillimanLoading$().subscribe(loading => {
                this.showMillimanLoadingSpinner(loading);
            }));
        }
        this.showPlanTypeDropdown = this.planSubTypeEnabled && !this.isDentalVisionForm();
        this.planSubTypes = this.medSupFacade.getPlanSubTypes();
    }
    ngOnChanges(changes) {
        const sortedQuestionsChanges = changes.sortedQuestions;
        const questionMetaDataChanges = changes.questionMetaData;
        const guaranteedIssueOptionsChanges = changes.guaranteedIssueOptions;
        const hasQuestionMetaDataChanges = questionMetaDataChanges &&
            !questionMetaDataChanges.firstChange &&
            !_isEqual(questionMetaDataChanges.previousValue, questionMetaDataChanges.currentValue);
        if ((sortedQuestionsChanges &&
            !sortedQuestionsChanges.firstChange &&
            !_isEqual(sortedQuestionsChanges.previousValue, sortedQuestionsChanges.currentValue)) ||
            (guaranteedIssueOptionsChanges &&
                !guaranteedIssueOptionsChanges.firstChange &&
                !_isEqual(guaranteedIssueOptionsChanges.previousValue, guaranteedIssueOptionsChanges.currentValue)) ||
            hasQuestionMetaDataChanges) {
            this.initForm();
            if (hasQuestionMetaDataChanges) {
                this.medSupFormErrorContext.initializeErrorMessages(this.questionMetaData);
            }
        }
    }
    ngAfterViewInit() {
        if (this.focusFirstMedSupFormElement) {
            this.medSupQuestions?.first?.nativeElement?.querySelector('input')?.focus();
            this.focusFirstMedSupFormElement = false;
            this.updateEffectiveDatesFromProfile();
        }
        // This should be logged in after view init otherwise it will modify the event type before the
        // plans list view page event is logged. We need to set a timeout here unfortunately because
        // when we reload this page the view-Page event and this event are fired at about the same time but
        // this one finishes first every time being much smaller. Going to use a timeout for now because we
        // currently have no means to figure out when the previous event finishes as the data layer is merely
        // an object on the browser and unattached to the Angular context. If this ever becomes a problem we will
        // need to create some means to check for the existence of a gtm object which will most likely involve
        // polling the data layer until our object is found on it.
        setTimeout(() => {
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
                [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_MODAL,
                [DataLayerGlobalVariable.MODAL_NAME]: this.getDataLayerModalName(this.productType)
            };
        }, 1500);
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }
    trackIndex(index) {
        return index;
    }
    focusFirstErrorElement(firstErrorFocusKey) {
        const matchingMedSupField = this.medSupFields.filter(medSupField => medSupField.getName() === firstErrorFocusKey)[0];
        if (matchingMedSupField) {
            matchingMedSupField.focus();
        }
    }
    giValueSelected(event) {
        const valid = event.id !== null && event.id !== undefined;
        this.updateAnswer({
            name: MedSupQuestionNames.GuaranteedIssue,
            valid,
            value: event.id === GIREASONS_NO_REASON_KEY ? GIREASONS_KEY.NO : GIREASONS_KEY.YES
        }, event.id);
        this.setShowMillimanForm(event.id);
    }
    // set each question's default value to be whatever value was previously in the store, if available
    populateAnswers() {
        const showEffectiveDateAsDropdown = this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_ShowEffectiveDateAsDropdown_Flag', null, true);
        const medSupPreviousAnswers = this.medSupService.getMedSupAnswers();
        const ancillaryPreviousAnswers = this.medSupService.getAncillaryAnswers();
        const isDentalVisionForm = this.isDentalVisionForm();
        const answersMap = this.getAnswersMap(this.answers);
        this.populateGIReason();
        this.questionMetaData.forEach(question => {
            let answer;
            if (isDentalVisionForm) {
                answer =
                    ancillaryPreviousAnswers[question.key] ??
                        medSupPreviousAnswers[question.key] ??
                        answersMap[MedSupPlanQuestionIds[question.key]]?.value;
            }
            else {
                answer =
                    medSupPreviousAnswers[question.key] ??
                        ancillaryPreviousAnswers[question.key] ??
                        answersMap[MedSupPlanQuestionIds[question.key]]?.value;
            }
            if (answer) {
                let defaultAnswer = answer;
                if (showEffectiveDateAsDropdown && question.key === MedSupQuestionNames.EffectiveDate) {
                    defaultAnswer = DateUtilities.getFormattedDate(new Date(answer), this.displayFormat, this.locale);
                }
                question.defaultValue = defaultAnswer;
                this.updateUIData(question.key, 'defaultValue', defaultAnswer);
                // found an answer in store values, 'answer' the question with it
                this.updateAnswer({ name: question.key, value: answer, valid: !question.invalid });
            }
            else {
                // no previous value, but it has a default that isn't 0/undefined/etc, 'answer' it with that default value
                this.resetAnswer(question.key);
            }
        });
    }
    populateGIReason() {
        this.medSupService.updateSelectedGIReasons();
        const reasons = this.medSupFacade.getGIReasons();
        const foundSelectedReason = reasons.find(reason => reason.selected);
        if (foundSelectedReason) {
            const selectedGIReason = foundSelectedReason.name;
            this.selectedGIReason = selectedGIReason;
            const parentOfKey = this.guaranteedIssueOptions.find(option => option.childItems.some(childItem => childItem.id === selectedGIReason));
            if (!parentOfKey) {
                // key has no parent, so it is a parent
                this.selectedGIReasonParentId = selectedGIReason;
                this.selectedGIReasonChildId = null;
            }
            else {
                this.selectedGIReasonParentId = parentOfKey.id;
                this.selectedGIReasonChildId = selectedGIReason;
            }
        }
    }
    resetAnswer(name) {
        // Reset questionMetadata to the default values.
        const defaultQuestionMetadata = this.planListResourceFacade.getPlanListMedSupQuestionData();
        const defaultSelected = defaultQuestionMetadata.find(x => x.key === name);
        const defaultByName = defaultSelected ? defaultSelected.defaultValue : '';
        const questionMetaDataMatch = this.getMetaData(name);
        questionMetaDataMatch.defaultValue = defaultByName;
        questionMetaDataMatch.answered = false;
        questionMetaDataMatch.invalid = false;
        const answersObject = {
            questionID: MedSupPlanQuestionIds[name],
            value: defaultByName,
            selectedGIReason: {}
        };
        this.updateUIData(name, 'defaultValue', defaultByName);
        this.updateUIData(name, 'value', defaultByName);
        const answersIndex = this.answers.findIndex(answer => answer.questionID === MedSupPlanQuestionIds[name]);
        // updates the answer if one already exists for the key, other wise adds it to the array
        answersIndex === -1 ? this.answers.push(answersObject) : (this.answers[answersIndex] = answersObject);
    }
    updateAnswer(emitData, selectedGIReason) {
        const name = emitData.name;
        const value = emitData.value;
        this.updateUIData(name, 'value', value);
        const questionMetaDataMatch = this.getMetaData(name);
        if (questionMetaDataMatch) {
            questionMetaDataMatch.answered = true;
            const matchingQuestion = this.sortedQuestions.find(question => question.name === name);
            if (matchingQuestion?.answerList?.length && !matchingQuestion.answerList?.includes(value)) {
                questionMetaDataMatch.answered = false;
            }
            if ((!emitData.value && !selectedGIReason) || !emitData.valid) {
                questionMetaDataMatch.invalid = true;
                if (emitData.showError === undefined || emitData.showError) {
                    this.setQuestionError(questionMetaDataMatch.key, emitData.error || MedSupFormErrorTypes.REQUIRED);
                }
            }
            else {
                questionMetaDataMatch.invalid = false;
                this.setQuestionError(questionMetaDataMatch.key, null);
                const answersObject = {
                    questionID: MedSupPlanQuestionIds[name],
                    value,
                    selectedGIReason: {}
                };
                if (selectedGIReason) {
                    const selectedGIReasonKey = 'Medigap_GaranteeIssue_AdvancedSetting_SelectedAnswer'; // spelling intended to match API
                    answersObject.selectedGIReason = { [selectedGIReasonKey]: selectedGIReason };
                    this.saveSelectedGIReasons(selectedGIReason);
                }
                if (name === MedSupQuestionNames.Tobacco) {
                    this.selectedTobaccoAnswer = value;
                }
                const answersIndex = this.answers.findIndex(answer => answer.questionID === MedSupPlanQuestionIds[name]);
                // updates the answer if one already exists for the key, other wise adds it to the array
                if (answersIndex === -1) {
                    this.answers.push(answersObject);
                }
                else {
                    this.answers[answersIndex] = answersObject;
                }
                if (this.isMedSupMillimanEnabled) {
                    this.setNbdIndicator();
                }
            }
        }
        this.cdr.markForCheck();
    }
    setNbdIndicator() {
        const dateOfBirth = this.answers.find(answer => {
            return answer.questionID === MedSupPlanQuestionIds.DateOfBirth;
        })?.value;
        const effectiveDate = this.answers.find(answer => {
            return answer.questionID === MedSupPlanQuestionIds.EffectiveDate;
        })?.value;
        const guaranteedIssue = this.answers.find(answer => {
            return answer.questionID === MedSupPlanQuestionIds.GuaranteedIssue;
        });
        if (dateOfBirth) {
            const firstOfNextMonth = DateUtilities.getFormattedDate(DateUtilities.getFirstOfNextMonth(effectiveDate));
            const age = DateUtilities.getAgeFromDate(dateOfBirth, firstOfNextMonth);
            let answerValue = { nbdIndicator: false };
            if (guaranteedIssue && guaranteedIssue.value === GIREASONS_KEY.YES && age >= DateUtilities.getMedicareEligibilityAge()) {
                answerValue = { nbdIndicator: true };
            }
            const nbdIndicator = this.answers.find(answer => {
                return answer.questionID === MedSupPlanQuestionIds.NBDIndicator;
            });
            if (nbdIndicator) {
                nbdIndicator.value = answerValue.nbdIndicator ? GIREASONS_VALUES.TRUE : GIREASONS_VALUES.FALSE;
            }
            else {
                this.answers.push({
                    questionID: MedSupPlanQuestionIds.NBDIndicator,
                    value: GIREASONS_VALUES.FALSE,
                    selectedGIReason: {}
                });
            }
        }
    }
    saveSelectedGIReasons(selectedGIReason) {
        this.selectedGIReason = selectedGIReason;
        // service.getSelectedGIReasons returns an array of all GI reasons with their status updated to have
        // the passed in reason selected
        const selectedGIReasons = this.medSupService.getSelectedGIReasons(selectedGIReason);
        this.medSupService.saveSelectedGIReasons(selectedGIReasons);
        this.populateQuestionUIDataMap();
        this.populateTobaccoDefaultAnswer(false);
        this.cdr.markForCheck();
    }
    populateTobaccoDefaultAnswer(showValidationError) {
        const tobaccoQuestionMetaData = this.getMetaData(MedSupQuestionNames.Tobacco);
        if (tobaccoQuestionMetaData) {
            if (this.questionMetaData.some(question => question.key === MedSupQuestionNames.GuaranteedIssue) &&
                this.questionMetaData.some(question => question.key === MedSupQuestionNames.Tobacco) &&
                this.medSupFacade.isMedsupTobaccoApplicableStates() &&
                this.medSupFacade.nonNullGIReasonIsSelected()) {
                // updating Tobacco answer if it is not displaying
                this.updateAnswer({ name: MedSupQuestionNames.Tobacco, value: 'Non-Smoker', valid: true, showError: showValidationError });
            }
            else {
                if (this.selectedTobaccoAnswer === undefined) {
                    this.selectedTobaccoAnswer = this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_Tobacco_Default', null, '');
                }
                this.updateUIData(MedSupQuestionNames.Tobacco, 'defaultValue', this.selectedTobaccoAnswer);
                this.updateAnswer({
                    name: MedSupQuestionNames.Tobacco,
                    value: this.selectedTobaccoAnswer,
                    valid: true,
                    showError: showValidationError
                });
            }
        }
    }
    async continueToPlans() {
        this.formSubmitted = true;
        this.medSupMillimanFormFacade.validateMillimanForm();
        this.populateTobaccoDefaultAnswer(true);
        const unansweredRequired = this.questionMetaData.filter(question => !question.answered &&
            (!question.defaultValue || (question.key === MedSupQuestionNames.Gender && question.defaultValue === Gender.NOT_PROVIDED)) &&
            question.required);
        const millimanFormHasErrors = this.showMillimanForm && !!Object.values(this.millimanFormErrors).filter(error => error).length;
        const planSubTypeHasErrors = this.showPlanTypeDropdown && !this.selectedPlanSubType;
        if (this.dropdownEnabledPartA || this.dropdownEnabledPartB) {
            this.checkPartAandPartBEffectiveDateQuestionErrors(unansweredRequired);
        }
        let invalid = this.questionMetaData.filter(question => question.invalid);
        if (this.answers.length === 0 || invalid.length || unansweredRequired.length || millimanFormHasErrors || planSubTypeHasErrors) {
            if (planSubTypeHasErrors) {
                this.planSubTypeError = this.medSupFormErrorContext.getErrorMessage(MedSupQuestionNames.PlanSubType, MedSupFormErrorTypes.REQUIRED);
                this.setQuestionError(MedSupQuestionNames.PlanSubType, MedSupFormErrorTypes.REQUIRED);
            }
            // sets all unanswered required questions to invalid at this point to show error
            // we do not set it earlier to prevent an error from showing up until attempted navigation
            unansweredRequired.forEach(question => {
                this.setQuestionError(question.key, MedSupFormErrorTypes.REQUIRED);
                this.getMetaData(question.key).invalid = true;
            });
            if (this.errorMessages?.length) {
                this.errorContainer.first.nativeElement.scrollIntoView({ behavior: 'smooth' });
            }
            // questionMetaData object's invalid property gets updated after the initial assignment,
            // so we have to filter questionMetaData object with invalid property again to set the focus on first element with error
            invalid = this.questionMetaData.filter(question => question.invalid);
            if (invalid?.length) {
                this.focusFirstErrorElement(invalid[0].key);
            }
        }
        else {
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.DATA_PLAN_SUBTYPE_SELECTION]: this.getDataLayerPlanSubTypeSelection(),
                [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLAN_RATE_FACTOR_QUESTIONNAIRE_COMPLETE
            };
            this.updateEffectiveDatesinProfile();
            this.planListFacade.updateSortGroup(this.planListFacade.medigapAfterAnswersSort, this.planListFacade.getActiveTabType());
            if (!this.millimanUpdating) {
                this.millimanUpdating = true;
                await this.updateQuestionAnswers().then(() => {
                    this.millimanUpdating = false;
                });
            }
            const allSectionsValid = this.areAllSectionsValid();
            if (allSectionsValid) {
                this.formClose.emit(true);
            }
        }
    }
    hasUpdatedAnswers() {
        const savedAnswers = this.isDentalVisionForm() ? this.medSupService.getAncillaryAnswers() : this.medSupService.getMedSupAnswers();
        const hasMillimanInformationChanged = this.hasMillimanInformationChanged(this.millimanHealthInformation);
        return (this.answers.some(answer => savedAnswers[this.getQuestionName(answer.questionID)] !== answer.value) || hasMillimanInformationChanged);
    }
    // Creates Data to be sent to the API and to update the store with saved answers
    async updateQuestionAnswers() {
        if (this.hasUpdatedAnswers()) {
            const hasEffectiveDateYearBeenUpdated = this.hasEffectiveDateYearBeenUpdated();
            const sessionId = this.store.selectSnapshot(MemberState.sessionId);
            this.questions = this.isDentalVisionForm() ? this.medSupService.getAncillaryQuestions() : this.medSupService.getMedSupQuestions();
            await this.initializeMillimanProcessingIfEnabled(sessionId);
            if (this.isMedSupMillimanEnabled) {
                if (this.millimanHealthInformation) {
                    this.addTierStatusToHealthInformation();
                }
                if (!this.millimanCalled) {
                    await this.updateMedigapAnswersWithMilliman(sessionId);
                }
            }
            else {
                await this.updateAnswers(sessionId);
            }
            // Update plan in cart since premium could be based off old medsup/dental/vision answers
            if (!hasEffectiveDateYearBeenUpdated) {
                this.medSupService.rehydrateShoppingCartPlan();
            }
        }
    }
    // Gets default answer from metadata or store if question is optional
    getDefaultAnswer(questionName) {
        if (questionName === MedSupQuestionNames.MillimanUWTier || questionName === MedSupQuestionNames.Tobacco) {
            const foundMetaData = this.getMetaData(questionName);
            return foundMetaData ? foundMetaData.defaultValue : null;
        }
        switch (questionName) {
            case MedSupQuestionNames.ZipCode:
                return this.memberSessionService.getZipCode();
            case MedSupQuestionNames.County_FIPS:
                return this.memberSessionService.getFipsCode();
            default:
                return null;
        }
    }
    // Using a separate object to track non-API related data here to keep the model returned from the API
    // clean as it needs to be returned as is (plus answers model) for the answers call
    getDefaultValue(question) {
        const overwrittenDefaultValue = this.configResourceService.getProcessedResourceValue(`Spa_MedSupForm_${question.name}_DefaultValue`);
        if (overwrittenDefaultValue !== null && overwrittenDefaultValue !== undefined) {
            return overwrittenDefaultValue;
        }
        const foundMetaData = this.getMetaData(question.name);
        if (foundMetaData) {
            if (question.name === this.medSupQuestionNames.DateOfBirth) {
                if (!foundMetaData.defaultValue) {
                    return this.profileFacade.getMemberDateOfBirth();
                }
            }
            if (question.name === this.medSupQuestionNames.Gender) {
                if (!foundMetaData.defaultValue) {
                    return this.profileFacade.getMemberGender();
                }
            }
            return foundMetaData.defaultValue;
        }
        return null;
    }
    getQuestionLabel(name) {
        return this.planFacade.getMedSupFormKey(name, 'Description');
    }
    getQuestionName(questionId) {
        return Object.keys(MedSupPlanQuestionIds).find(keyName => MedSupPlanQuestionIds[keyName] === questionId);
    }
    // TODO: refactor all lookups to use this?
    getValue(questionName) {
        const foundAnswer = this.answers.find(answer => answer.questionID === MedSupPlanQuestionIds[questionName]);
        return foundAnswer ? foundAnswer.value : null;
    }
    getIsRequired(questionKey) {
        const metadata = this.getMetaData(questionKey);
        return metadata && metadata.required ? metadata.required : true;
    }
    getIsHidden(questionKey) {
        const metadata = this.getMetaData(questionKey);
        if (questionKey === MedSupQuestionNames.Tobacco &&
            this.medSupFacade.isMedsupTobaccoApplicableStates() &&
            this.isGIQuestionsAvailable() &&
            this.medSupFacade.nonNullGIReasonIsSelected()) {
            return true;
        }
        return metadata && metadata.hidden ? metadata.hidden : false;
    }
    isGIQuestionsAvailable() {
        return this.questionMetaData.some(question => question.key === MedSupQuestionNames.GuaranteedIssue);
    }
    getMetaData(questionKey) {
        return this.questionMetaData.find(metadata => metadata.key === questionKey);
    }
    getSortedQuestionMetaData() {
        return this.sortedQuestions.reduce((questionMetaDataMap, question) => {
            questionMetaDataMap[question.name] = this.getQuestionMetaData(question);
            return questionMetaDataMap;
        }, {});
    }
    getQuestionMetaData(question) {
        const questionName = question.name;
        return {
            hidden: this.getIsHidden(questionName),
            required: this.getIsRequired(questionName),
            ariaLabelledById: this.getAriaLabelledById(question.questionId),
            isPopulatedFromSSO: this.isPopulatedFromSSO(questionName),
            value: this.getValue(questionName),
            defaultValue: this.getDefaultValue(question),
            description: this.planFacade.getMedSupFormKey(questionName, 'Description'),
            tooltip: this.planFacade.getMedSupFormKey(questionName, 'Tooltip')
        };
    }
    getAriaLabelledById(questionId) {
        return `question-name-${questionId}`;
    }
    getErrorMessage(questionKey, error) {
        return this.medSupFormErrorContext.getErrorMessage(questionKey, error);
    }
    hideForm() {
        this.formClose.emit(false);
    }
    isPopulatedFromSSO(questionName) {
        return this.ssoPopulatedMedsupQuestionNames && this.ssoPopulatedMedsupQuestionNames.includes(questionName);
    }
    onMillimanFormError(errorData) {
        if (errorData) {
            const { questionKey, error } = errorData;
            this.millimanFormErrors[questionKey] = error;
            this.setQuestionError(questionKey, error);
        }
    }
    onMillimanMemberAuthorizationFormError(errorData) {
        if (errorData?.length) {
            errorData.forEach(err => {
                const { questionKey, error } = err;
                this.millimanFormErrors[questionKey] = error;
                this.setQuestionError(questionKey, error);
            });
        }
    }
    onMemberInformationReset(isReset) {
        if (isReset) {
            this.millimanMemberInformation = null;
        }
    }
    updateMillimanHealthInformation(answers) {
        this.millimanHealthInformation = answers;
    }
    updateMillimanMemberInformation(answers) {
        this.millimanMemberInformation = answers;
    }
    async processMillimanAnswer(millimanUWTierAnswer) {
        // If any medsup answers change, set UWTier = "P" and TierServiceCalled = false.
        millimanUWTierAnswer.value = MILLIMAN_INITIAL.currentTier;
        await this.store.dispatch(new ResetMillimanState()).toPromise(); // Reset to clear any leftover data
        const milliman = {
            currentTier: MILLIMAN_INITIAL.currentTier,
            serviceCalledBefore: MILLIMAN_INITIAL.serviceCalledBefore
        };
        this.store.dispatch(new UpdateMilliman(milliman));
    }
    updateEffectiveDatesFromProfile() {
        const medigapAnswers = this.memberSessionService.getMemberMedigapAnswers();
        if (medigapAnswers?.partAEffectiveDate) {
            this.updatePartEffectiveDateFromProfile(MedSupQuestionNames.PartAEffectiveDate, medigapAnswers.partAEffectiveDate);
        }
        if (medigapAnswers?.partBEffectiveDate) {
            this.updatePartEffectiveDateFromProfile(MedSupQuestionNames.PartBEffectiveDate, medigapAnswers.partBEffectiveDate);
        }
        this.cdr.detectChanges();
    }
    doesQuestionExist(questionName) {
        return [
            this.medSupQuestionNames.GuaranteedIssue,
            this.medSupQuestionNames.Gender,
            this.medSupQuestionNames.Tobacco,
            this.medSupQuestionNames.Disability,
            this.medSupQuestionNames.Household,
            this.medSupQuestionNames.GIAdditional,
            this.medSupQuestionNames.EffectiveDate,
            this.medSupQuestionNames.PaymentMethod,
            this.medSupQuestionNames.Weight,
            this.medSupQuestionNames.PlanAge,
            this.medSupQuestionNames.TermLength,
            this.medSupQuestionNames.Height,
            this.medSupQuestionNames.DateOfBirth,
            this.medSupQuestionNames.PartAEffectiveDate,
            this.medSupQuestionNames.PartBEffectiveDate,
            this.medSupQuestionNames.EFTDiscount,
            this.medSupQuestionNames.NBDIndicator
        ].includes(questionName);
    }
    areAllSectionsValid() {
        // process additional sections
        let allSectionsValid = true;
        if (this.showPlanTypeDropdown) {
            allSectionsValid = allSectionsValid && !!this.selectedPlanSubType;
        }
        if (this.isMedSupMillimanEnabled && this.showMillimanForm && this.millimanMemberInformation?.length) {
            allSectionsValid = allSectionsValid && this.hasMillimanRequestSuccess;
        }
        return allSectionsValid;
    }
    isDentalVisionForm() {
        return ANCILLARY_PRODUCTS.includes(this.productType);
    }
    async initializeMillimanProcessingIfEnabled(sessionId) {
        if (this.isMedSupMillimanEnabled) {
            if (this.showMillimanForm) {
                if (this.millimanMemberInformation?.length) {
                    this.millimanCalled = true;
                    await this.processMillimanMemberInformation(sessionId);
                    await this.saveMillimanHealthInformationAndCallMilliman(sessionId, this.millimanErrorConfirmAction);
                }
                else {
                    this.millimanService.clearAndSetMillimanTier(MillimanTier.T3, true);
                    this.processAndSaveMillimanHealthInformation();
                }
            }
            else {
                this.millimanCalled = false;
                this.millimanService.clearAndSetMillimanTier(MillimanTier.P);
            }
        }
    }
    getUpdatedMedSupQuestions() {
        const newTier = this.millimanService.getMillimanNewTier();
        const updatedQuestions = [];
        this.questions.forEach(question => {
            let answerMatch = this.answers.find(answer => question.questionId === answer.questionID);
            // MedSupAnswerModel must not be null when sending answers back,
            // create one here with a certain value if we didn't get it from the form
            if (answerMatch === undefined) {
                answerMatch = {
                    questionID: question.questionId,
                    value: this.getDefaultAnswer(question.name),
                    selectedGIReason: {}
                };
            }
            if (question.name === MedSupQuestionNames.MillimanUWTier) {
                if (this.isMedSupMillimanEnabled) {
                    if (this.showMillimanForm) {
                        if (newTier && MillimanTier[newTier]) {
                            answerMatch = {
                                questionID: question.questionId,
                                value: newTier,
                                selectedGIReason: {}
                            };
                        }
                    }
                    else {
                        answerMatch = {
                            questionID: question.questionId,
                            value: MILLIMAN_INITIAL.currentTier,
                            selectedGIReason: {}
                        };
                    }
                }
                else {
                    this.processMillimanAnswer(answerMatch);
                }
            }
            if (question.name === MedSupQuestionNames.GuaranteedIssue) {
                answerMatch = {
                    questionID: question.questionId,
                    value: answerMatch.value,
                    selectedGIReason: { Medigap_GaranteeIssue_AdvancedSetting_SelectedAnswer: this.selectedGIReason }
                };
            }
            updatedQuestions.push({
                ...question,
                value: answerMatch.value,
                selectedGIReason: answerMatch.selectedGIReason
            });
        });
        return updatedQuestions;
    }
    getUpdatedDentalVisionQuestions() {
        const questionsMap = this.questions.reduce((mappedQuestions, question, index) => {
            mappedQuestions[question.questionId] = { index, question };
            return mappedQuestions;
        }, {});
        const answersMap = this.getAnswersMap(this.answers);
        return _sortBy(questionsMap, ['index'])
            .map(({ question }) => ({ ...question, value: answersMap[question.questionId]?.value }))
            .filter(question => question.value);
    }
    getAnswersMap(answers) {
        return answers.reduce((mappedAnswers, answer) => {
            mappedAnswers[answer.questionID] = answer;
            return mappedAnswers;
        }, {});
    }
    showMillimanLoadingSpinner(loading) {
        if (loading) {
            this.spinnerService.show(SpinnerEvent.MILLIMAN_LOADING);
        }
        else {
            this.spinnerService.hide(SpinnerEvent.MILLIMAN_LOADING);
        }
    }
    initForm() {
        this.populateAnswers();
        const initialQuestionErrors = {};
        this.sortedQuestions.forEach(question => {
            initialQuestionErrors[question.name] = '';
        });
        initialQuestionErrors[MedSupQuestionNames.PlanSubType] = '';
        this.setQuestionErrors(initialQuestionErrors);
        this.paymentMethodUseToggle = this.planListResourceFacade.getMedSuppPaymentMethodUseToggle();
        this.setQuestionClasses();
        this.populateQuestionUIDataMap();
        this.updateEffectiveDatesFromProfile();
        this.cdr.detectChanges();
    }
    setQuestionClasses() {
        this.questionClasses = {
            Gender: this.questionSizes.toggle,
            Tobacco: this.questionSizes.toggle,
            Disability: this.questionSizes.toggle,
            PaymentMethod: this.paymentMethodUseToggle ? this.questionSizes.toggle : this.questionSizes.small,
            Household: this.questionSizes.toggle,
            EffectiveDate: this.questionSizes.small,
            GuaranteedIssue: this.questionSizes.large,
            Height: this.questionSizes.small,
            Weight: this.questionSizes.small,
            ZipCode: this.questionSizes.small,
            County_FIPS: this.questionSizes.small,
            DateOfBirth: this.questionSizes.small,
            PartBEffectiveDate: this.questionSizes.small,
            Family: this.questionSizes.small,
            Relationship: this.questionSizes.medium,
            PlanAge: this.questionSizes.small,
            TermLength: this.questionSizes.small,
            MillimanUWTier: this.questionSizes.medium,
            NewlyEligible: this.questionSizes.small,
            AgeAsOfPartB: this.questionSizes.small,
            GIAdditional: this.questionSizes.large,
            PartAEffectiveDate: this.questionSizes.small,
            EFTDiscount: this.questionSizes.small
        };
    }
    initializePartAandPartBDropdownEnabled() {
        this.dropdownEnabledPartA = this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartA_Effective_DropDown');
        this.dropdownEnabledPartB = this.configResourceService.getProcessedResourceValue('Spa_MedSupForm_PartB_Effective_DropDown');
    }
    initializeMedSupMillimanFormEnabled() {
        this.isMedSupMillimanEnabled = this.medSupMillimanFormFacade.isMedSupMillimanEnabled();
    }
    initializeTranslatableText(widgetName) {
        this.datePickerButtonLabelText = this.configResourceService.getProcessedResourceValue('Spa_Site_DatePicker_Button_Label_Text', widgetName, 'Choose Date');
    }
    mapPrepopulatedFieldToMedSupQuestionName(prepopulatedFields) {
        if (prepopulatedFields?.length) {
            return prepopulatedFields
                .map(prepopulatedField => {
                switch (prepopulatedField) {
                    case SSOPopulatedField.GENDER:
                        return MedSupQuestionNames.Gender;
                    case SSOPopulatedField.DEMOGRAPHIC_DATE_OF_BIRTH:
                        return MedSupQuestionNames.DateOfBirth;
                    default:
                        return null;
                }
            })
                .filter(name => name);
        }
        return [];
    }
    populateQuestionUIDataMap() {
        this.questionUIDataMap = this.getSortedQuestionMetaData();
    }
    updateUIData(questionName, field, value) {
        if (this.questionUIDataMap[questionName]) {
            this.questionUIDataMap[questionName][field] = value;
        }
    }
    initializeMillimanForm() {
        if (this.isMedSupMillimanEnabled) {
            this.showMillimanForm = this.selectedGIReasonParentId === GIREASONS_NO_REASON_KEY;
        }
    }
    async processMillimanMemberInformation(sessionId) {
        this.medSupMillimanService.setMillimanAuthorizationFields(this.millimanMemberInformation);
        this.medSupMillimanService.setMillimanSocialSecurityNumberInformation(this.millimanMemberInformation);
        // Per Kim, check if we have a member profile, if we do update it, otherwise create a new one.
        await this.medSupMillimanService.processMemberProfileInformation(this.millimanMemberInformation, this.getMedSupQuestionsDateOfBirth(), this.getMedSupQuestionsGender());
        this.millimanHealthInformation = this.medSupMillimanService.addApplicantIdToMillimanHealthInformation(this.millimanHealthInformation);
        this.addHeightAndWeightToHealthInformation();
        this.addMillimanAuthorizationFieldsToHealthInformation();
        await this.updateMedigapAnswersWithMilliman(sessionId);
    }
    async updateMedigapAnswersWithMilliman(sessionId) {
        await this.updateAnswers(sessionId, true);
    }
    async updateAnswers(sessionId, invokeMilliman) {
        const year = this.planYearResourceService.getSelectedPlanYear();
        let updatedQuestions = this.isDentalVisionForm() ? this.getUpdatedDentalVisionQuestions() : this.getUpdatedMedSupQuestions();
        if (this.isMedSupMillimanEnabled && !updatedQuestions.every(question => question.questionId === MedSupPlanQuestionIds.NBDIndicator)) {
            updatedQuestions = [...updatedQuestions, this.getNBDIndicatorQuestion()];
        }
        await this.syncAnswers(sessionId, year, updatedQuestions, invokeMilliman);
    }
    getNBDIndicatorQuestion() {
        const nbdAnswer = this.answers.find(answer => answer.questionID === MedSupPlanQuestionIds.NBDIndicator);
        return {
            questionId: MedSupPlanQuestionIds.NBDIndicator,
            name: MedSupQuestionNames.NBDIndicator,
            text: MedSupQuestionNames.NBDIndicator,
            answerType: 'String',
            answerList: [GIREASONS_VALUES.TRUE, GIREASONS_VALUES.FALSE],
            tooltip: null,
            value: nbdAnswer?.value ?? '',
            status: '',
            statusReason: ''
        };
    }
    updateEffectiveDatesinProfile() {
        const effectiveDateA = this.getValue(MedSupQuestionNames.PartAEffectiveDate)?.toString();
        const effectiveDateB = this.getValue(MedSupQuestionNames.PartBEffectiveDate)?.toString();
        if (effectiveDateA) {
            this.memberSessionService.setPartAEffectiveDate(effectiveDateA);
        }
        if (effectiveDateB) {
            this.memberSessionService.setPartBEffectiveDate(effectiveDateB);
        }
    }
    async syncAnswers(sessionId, year, updatedQuestions, invokeMilliman) {
        await this.medSupService.syncAnswers(sessionId, year, updatedQuestions, this.productType, this.millimanHealthInformation, invokeMilliman);
        if (this.medSupService.getIsHospitalIndemnityPlansEnabled()) {
            await this.hospitalIndemnityFormFacade.updateHospitalIndemnityPlanAnswers(updatedQuestions);
        }
    }
    getMedSupQuestionsGender() {
        const questionId = this.questions.find(question => question.name === MedSupQuestionNames.Gender)?.questionId;
        const gender = this.answers.find(answer => answer.questionID === questionId)?.value;
        return this.getGenderCode(gender.toString());
    }
    getMedSupQuestionsDateOfBirth() {
        const questionId = this.questions.find(question => question.name === MedSupQuestionNames.DateOfBirth)?.questionId;
        const birthDate = this.answers.find(answer => answer.questionID === questionId)?.value;
        return birthDate ? birthDate.toString() : null;
    }
    async saveMillimanHealthInformationAndCallMilliman(sessionId, confirmAction) {
        this.processAndSaveMillimanHealthInformation();
        this.hasMillimanRequestSuccess = await this.millimanService.invokeAndProcessMillimanService(sessionId, confirmAction);
    }
    processAndSaveMillimanHealthInformation() {
        this.processMillimanHealthInformationQuestions();
        this.saveMillimanHealthInformation(this.millimanHealthInformation);
    }
    processMillimanHealthInformationQuestions() {
        this.millimanHealthInformation = this.medSupMillimanService.processMillimanHealthQuestions(this.healthQuestions, this.millimanHealthInformation);
    }
    addMillimanAuthorizationFieldsToHealthInformation() {
        this.millimanHealthInformation.applicantFullName = this.medSupMillimanService.getApplicantFullName(this.millimanMemberInformation);
        this.millimanHealthInformation.authorizeDate = this.medSupMillimanService.getAuthorizeDate(this.millimanMemberInformation);
        this.millimanHealthInformation.authorizeUse = this.medSupMillimanService.getAuthorizeUse(this.millimanMemberInformation);
    }
    addTierStatusToHealthInformation() {
        this.millimanHealthInformation = this.medSupMillimanService.addTierStatusToHealthInformation(this.millimanHealthInformation);
    }
    addHeightAndWeightToHealthInformation() {
        this.millimanHealthInformation = this.medSupMillimanService.addHeightAndWeightToHealthInformation(this.millimanMemberInformation, this.millimanHealthInformation);
    }
    saveMillimanHealthInformation(healthInformation) {
        const currentHealthInformation = this.store.selectSnapshot(MillimanState.healthInformation);
        this.store.dispatch(new UpdateMillimanHealthInformation({ ...currentHealthInformation, ...healthInformation }));
    }
    hasMillimanInformationChanged(healthAnswers) {
        return this.hasMillimanHealthInformationChanged(healthAnswers) || this.hasMillimanMemberInformationChanged();
    }
    hasMillimanHealthInformationChanged(answers) {
        const currentHealthInformation = this.store.selectSnapshot(MillimanState.healthInformation);
        return this.showMillimanForm && !!answers && !!currentHealthInformation && !_isEqual(answers, currentHealthInformation);
    }
    hasMillimanMemberInformationChanged() {
        return (this.showMillimanForm &&
            this.millimanMemberInformation?.length &&
            this.medSupMillimanService.hasMemberInformationChanged(this.millimanMemberInformation));
    }
    getGenderCode(genderText) {
        switch (genderText) {
            case Gender.MALE:
                return GenderCode.MALE;
            case Gender.FEMALE:
                return GenderCode.FEMALE;
            default:
                return GenderCode.NOT_PROVIDED;
        }
    }
    setShowMillimanForm(giReasonKey) {
        if (this.isMedSupMillimanEnabled) {
            this.showMillimanForm = giReasonKey === GIREASONS_NO_REASON_KEY;
            const millimanFormErrorKeys = Object.keys(this.millimanFormErrors);
            if (!this.showMillimanForm) {
                if (millimanFormErrorKeys?.length) {
                    millimanFormErrorKeys.forEach(questionKey => {
                        this.setQuestionError(questionKey, null);
                        this.millimanFormErrors[questionKey] = null;
                    });
                }
            }
        }
    }
    async resetMillimanTier() {
        const milliman = {
            currentTier: null,
            newTier: null
        };
        const sessionId = this.store.selectSnapshot(MemberState.sessionId);
        const year = this.planYearResourceService.getSelectedPlanYear();
        const updatedQuestions = this.getUpdatedMedSupQuestions();
        const millimanUWTier = updatedQuestions.find(question => question.questionId === MedSupPlanQuestionIds.MillimanUWTier);
        if (millimanUWTier) {
            millimanUWTier.value = '';
            await this.syncAnswers(sessionId, year, updatedQuestions, true);
        }
        this.store.dispatch(new UpdateMilliman(milliman));
    }
    getDataLayerModalName(productType) {
        const modalNames = {
            [ProductType.DENTAL]: DataLayerGlobalVariable.DENTAL_QUESTIONS,
            [ProductType.VISION]: DataLayerGlobalVariable.VISION_QUESTIONS,
            [ProductType.MEDICAL]: DataLayerGlobalVariable.MEDSUP_QUESTIONS
        };
        return modalNames[productType];
    }
    getDataLayerPlanSubTypeSelection() {
        if (this.isDentalVisionForm()) {
            return this.googleTagManagerNotApplicableText;
        }
        return this.selectedPlanSubType || this.googleTagManagerNotApplicableText;
    }
    updatePartEffectiveDateFromProfile(name, value) {
        this.updateUIData(name, 'defaultValue', value);
        this.updateAnswer({ name, value, valid: true });
    }
    setPartAandPartBMonthYearRange() {
        const partAMaxFutureMonths = this.medSupFacade.getPartAEffectiveMaxFutureMonths();
        const partAMaxPastMonths = this.medSupFacade.getPartAEffectiveMaxPastMonths();
        const partBMaxFutureMonths = this.medSupFacade.getPartBEffectiveMaxFutureMonths();
        const partBMaxPastMonths = this.medSupFacade.getPartBEffectiveMaxPastMonths();
        this.monthYearRangePartA = this.medSupFacade.getMonthsForDropdownParts(partAMaxPastMonths, partAMaxFutureMonths);
        this.monthYearRangePartB = this.medSupFacade.getMonthsForDropdownParts(partBMaxPastMonths, partBMaxFutureMonths);
        this.yearRangeForPartA = this.medSupFacade.getYearsForDropdown(partAMaxPastMonths, partAMaxFutureMonths);
        this.yearRangeForPartB = this.medSupFacade.getYearsForDropdown(partBMaxPastMonths, partBMaxFutureMonths);
        this.monthRangeForPartAandPartB = this.medSupFacade.getMonthList();
    }
    getPartEffectiveDateQuestionError(questionMetadata) {
        if (questionMetadata) {
            const partEffectiveDateField = this.medSupFields?.find(medSupField => medSupField.getName() === questionMetadata.key);
            if (partEffectiveDateField) {
                const partEffectiveDateAnswer = this.getValue(questionMetadata.key);
                return partEffectiveDateField.checkError?.(partEffectiveDateAnswer ?? partEffectiveDateField.defaultValue);
            }
        }
    }
    checkPartEffectiveDateQuestionError(partEffectiveDateQuestionName) {
        const partEffectiveDateQuestionMetadata = this.getMetaData(partEffectiveDateQuestionName);
        const error = this.getPartEffectiveDateQuestionError(partEffectiveDateQuestionMetadata);
        if (error) {
            partEffectiveDateQuestionMetadata.invalid = true;
            this.setQuestionError(partEffectiveDateQuestionName, error);
        }
    }
    checkPartAandPartBEffectiveDateQuestionErrors(unansweredRequired) {
        if (this.dropdownEnabledPartA && !unansweredRequired?.some(question => question.key === MedSupQuestionNames.PartAEffectiveDate)) {
            this.checkPartEffectiveDateQuestionError(MedSupQuestionNames.PartAEffectiveDate);
        }
        if (this.dropdownEnabledPartB && !unansweredRequired?.some(question => question.key === MedSupQuestionNames.PartBEffectiveDate)) {
            this.checkPartEffectiveDateQuestionError(MedSupQuestionNames.PartBEffectiveDate);
        }
    }
    hasEffectiveDateYearBeenUpdated() {
        const currentEffectiveDate = this.answers.find(answer => answer.questionID === MedSupPlanQuestionIds.EffectiveDate)?.value;
        if (currentEffectiveDate) {
            const savedAnswers = this.isDentalVisionForm() ? this.medSupService.getAncillaryAnswers() : this.medSupService.getMedSupAnswers();
            const previousEffectiveDate = savedAnswers[MedSupQuestionNames.EffectiveDate];
            if (previousEffectiveDate) {
                const previousEffectiveDateYear = DateUtilities.createDateObject(previousEffectiveDate).year();
                const currentEffectiveDateYear = DateUtilities.createDateObject(currentEffectiveDate).year();
                return previousEffectiveDateYear !== currentEffectiveDateYear;
            }
        }
        return false;
    }
}
MedSupFormComponent.ɵfac = function MedSupFormComponent_Factory(t) { return new (t || MedSupFormComponent)(i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.MedSupService), i0.ɵɵdirectiveInject(PlanListResourceFacade), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(MedSupFormErrorContext), i0.ɵɵdirectiveInject(MedSupFacade), i0.ɵɵdirectiveInject(ProfileFacade), i0.ɵɵdirectiveInject(i1.SSOPopulatedFieldService), i0.ɵɵdirectiveInject(MedSupMillimanFormFacade), i0.ɵɵdirectiveInject(MedSupMillimanService), i0.ɵɵdirectiveInject(i1.MillimanService), i0.ɵɵdirectiveInject(PlanListFacadeService), i0.ɵɵdirectiveInject(HospitalIndemnityFormFacade), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.PlanYearResourceService)); };
MedSupFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MedSupFormComponent, selectors: [["vnext-med-sup-form"]], viewQuery: function MedSupFormComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1a, 5);
        i0.ɵɵviewQuery(_c1$v, 5);
        i0.ɵɵviewQuery(_c2$l, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.errorContainer = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupQuestions = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.medSupFields = _t);
    } }, inputs: { showPreviousLink: "showPreviousLink", previousLabel: "previousLabel", inchesLabel: "inchesLabel", feetLabel: "feetLabel", poundsLabel: "poundsLabel", selectMonthText: "selectMonthText", selectYearText: "selectYearText", dropdownDefaultText: "dropdownDefaultText", continueButtonText: "continueButtonText", formTitle: "formTitle", spaPageSubHeader: "spaPageSubHeader", totalPlanCount: "totalPlanCount", formPrompt: "formPrompt", questionMetaData: "questionMetaData", sortedQuestions: "sortedQuestions", guaranteedIssueOptions: "guaranteedIssueOptions", guaranteedIssueText: "guaranteedIssueText", guaranteedIssueTooltip: "guaranteedIssueTooltip", plansLoading: "plansLoading", errorKeywordText: "errorKeywordText", errorNoticeTitle: "errorNoticeTitle", productType: "productType", planSubTypeEnabled: "planSubTypeEnabled", planSubTypeHeaderText: "planSubTypeHeaderText", planSubTypePlaceholderText: "planSubTypePlaceholderText", displayEffectiveDateMessage: "displayEffectiveDateMessage", effectiveDateMessage: "effectiveDateMessage", rateFactorDisclaimer: "rateFactorDisclaimer", rateFactorDisclaimerEnabled: "rateFactorDisclaimerEnabled" }, outputs: { formClose: "formClose" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "Spa_Style_IntroParagraph", 3, "innerHtml"], ["class", "Spa_Style_H2", 4, "ngIf"], [1, "my-4"], ["navigationAdapter", "", 3, "innerHtml"], ["errorContainer", ""], [1, "questions-container", "row"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "healthQuestions", "memberQuestions", "formError", "onMemberInformationReset", "onMillimanMemberAuthorizationFormError", "onHealthInformationChange", "onMemberInformationChange", 4, "ngIf"], ["showPrevious", "true", "providedPrevious", "true", 1, "col-12"], ["previous-link", "", 3, "title", "showArrow", "click", 4, "ngIf"], ["continue-button", "", 1, "btn", "btn", "Spa_Style_PrimaryButton", "width-full", "width-md-initial", 3, "click"], [1, "Spa_Style_H2"], [3, "title", "messages", "type", "errorKeywordText"], [3, "class", 4, "ngIf"], ["medSupQuestions", ""], [1, "question-name", 3, "id"], ["class", "error-message", 3, "id", 4, "ngIf"], ["id", "guaranteed-issue-question-header", 1, "question-header", 3, "ngClass"], ["class", "input-error-asterisk", 4, "ngIf"], ["navigationAdapter", "", 3, "innerHTML", "ngClass"], ["class", "pl-1 med-sup-tooltip", 4, "ngIf"], ["giTooltip", ""], ["class", "med-sup-tooltip", 4, "ngIf"], [3, "question", "fieldName", "defaultValue", "limitButtonWidth", "ariaLabelledById", "ariaDescribedById", "toggleControlId", "isReadOnly", "updateAnswer", 4, "ngIf"], [3, "question", "fieldName", "defaultValue", "limitButtonWidth", "ariaLabelledById", "ariaDescribedById", "toggleControlId", "updateAnswer", 4, "ngIf"], [3, "question", "defaultValue", "noAnswerLabel", "hasError", "ariaLabelledById", "ariaDescribedById", "datePickerButtonLabelText", "effectiveDateMessage", "displayFormat", "updateAnswer", 4, "ngIf"], [3, "question", "defaultValue", "noAnswerLabel", "hasError", "ariaLabelledById", "useToggle", "ariaDescribedById", "updateAnswer", 4, "ngIf"], [3, "question", "fieldName", "defaultValue", "label", "hasError", "ariaLabelledById", "ariaDescribedById", "updateAnswer", "keyup.enter", 4, "ngIf"], [3, "question", "fieldName", "defaultValue", "label", "hasError", "ariaLabelledById", "ariaDescribedById", "updateAnswer", 4, "ngIf"], [3, "question", "defaultValue", "feetLabel", "inchesLabel", "hasError", "ariaLabelledById", "ariaDescribedByFtInputId", "ariaDescribedByInInputId", "updateAnswer", "keyup.enter", 4, "ngIf"], [3, "defaultValue", "question", "hasError", "ariaDescribedById", "ariaLabelledById", "isReadOnly", "updateAnswer", "keyup.enter", 4, "ngIf"], [3, "defaultValue", "selectMonthText", "selectYearText", "question", "dateOfBirth", "hasError", "ariaDescribedById", "ariaLabelledById", "datePickerButtonLabelText", "monthYearRangePartA", "dropdownEnabledPartA", "monthRangeForPartAandPartB", "yearRangeForPartAandPartB", "partBEffectiveDate", "locale", "updateAnswer", 4, "ngIf"], [3, "defaultValue", "selectMonthText", "selectYearText", "question", "dateOfBirth", "hasError", "ariaDescribedById", "ariaLabelledById", "datePickerButtonLabelText", "monthYearRangePartB", "dropdownEnabledPartB", "monthRangeForPartAandPartB", "yearRangeForPartAandPartB", "partAEffectiveDate", "locale", "updateAnswer", 4, "ngIf"], [1, "error-message", 3, "id"], ["aria-hidden", "true", 1, "fa", "fa-exclamation-circle", "mr-1"], [1, "sr-only"], [1, "input-error-asterisk"], [1, "pl-1", "med-sup-tooltip"], ["medsupTooltip", ""], ["aria-label", "Show tooltip", "aria-hidden", "true", 1, "fas", "Spa_Style_QuestionIcon", 3, "ngbTooltip"], ["navigationAdapter", "", 1, "Spa_Style_ToolTip", 3, "innerHTML"], [1, "med-sup-tooltip"], ["id", "guaranteed-issue-text"], ["aria-label", "Show tooltip", 1, "fas", "Spa_Style_QuestionIcon", 3, "ngbTooltip"], [1, "col-12", 3, "fieldName", "items", "allowParentValues", "selectedParent", "selectedChild", "ariaDescribedById", "ariaLabelledById", "valueSelected"], ["guaranteedIssue", ""], [3, "question", "fieldName", "defaultValue", "limitButtonWidth", "ariaLabelledById", "ariaDescribedById", "toggleControlId", "isReadOnly", "updateAnswer"], ["medSupGender", ""], [3, "question", "fieldName", "defaultValue", "limitButtonWidth", "ariaLabelledById", "ariaDescribedById", "toggleControlId", "updateAnswer"], ["medSupTobacco", ""], ["medSupDisability", ""], ["medSupHousehold", ""], ["medSupGIAdditional", ""], [3, "question", "defaultValue", "noAnswerLabel", "hasError", "ariaLabelledById", "ariaDescribedById", "datePickerButtonLabelText", "effectiveDateMessage", "displayFormat", "updateAnswer"], ["medSupEffectiveDate", ""], [3, "question", "defaultValue", "noAnswerLabel", "hasError", "ariaLabelledById", "useToggle", "ariaDescribedById", "updateAnswer"], ["medSupPaymentMethod", ""], [3, "question", "fieldName", "defaultValue", "label", "hasError", "ariaLabelledById", "ariaDescribedById", "updateAnswer", "keyup.enter"], ["medSupWeight", ""], [3, "question", "fieldName", "defaultValue", "label", "hasError", "ariaLabelledById", "ariaDescribedById", "updateAnswer"], ["medSupPlanAge", ""], ["medSupTermLength", ""], [3, "question", "defaultValue", "feetLabel", "inchesLabel", "hasError", "ariaLabelledById", "ariaDescribedByFtInputId", "ariaDescribedByInInputId", "updateAnswer", "keyup.enter"], ["medSupHeight", ""], [3, "defaultValue", "question", "hasError", "ariaDescribedById", "ariaLabelledById", "isReadOnly", "updateAnswer", "keyup.enter"], ["medSupDateOfBirth", ""], [3, "defaultValue", "selectMonthText", "selectYearText", "question", "dateOfBirth", "hasError", "ariaDescribedById", "ariaLabelledById", "datePickerButtonLabelText", "monthYearRangePartA", "dropdownEnabledPartA", "monthRangeForPartAandPartB", "yearRangeForPartAandPartB", "partBEffectiveDate", "locale", "updateAnswer"], ["medSupPartAEffectiveDate", ""], [3, "defaultValue", "selectMonthText", "selectYearText", "question", "dateOfBirth", "hasError", "ariaDescribedById", "ariaLabelledById", "datePickerButtonLabelText", "monthYearRangePartB", "dropdownEnabledPartB", "monthRangeForPartAandPartB", "yearRangeForPartAandPartB", "partAEffectiveDate", "locale", "updateAnswer"], ["medSupPartBEffectiveDate", ""], ["medSupEFTDiscount", ""], ["class", "dropdown-message Spa_Style_H5", 4, "ngIf"], ["class", "Spa_Style_Paragraph my-2", 4, "ngIf"], [1, "dropdown-message", "Spa_Style_H5"], [1, "Spa_Style_Paragraph", "my-2"], [3, "headerText", "placeholder", "error", "errorKeywordText", "selectedPlanSubType", "planSubTypes", "valueSelected"], [3, "healthQuestions", "memberQuestions", "formError", "onMemberInformationReset", "onMillimanMemberAuthorizationFormError", "onHealthInformationChange", "onMemberInformationChange"], ["previous-link", "", 3, "title", "showArrow", "click"]], template: function MedSupFormComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MedSupFormComponent_ng_container_0_Template, 18, 16, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.plansLoading);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, NavigationBannerComponent, LinkComponent, NoticeComponent, NavigationAdapterDirective, IconAriaAttributesDirective, i1$1.NgbTooltip, MedSupPlanSubTypeComponent, AccordionComponent, MedSupToggleComponent, MedSupIntegerComponent, MedSupHeightComponent, MedSupEffectiveDateComponent, MedSupBirthDateComponent, MedSupEffectiveDateAComponent, MedSupEffectiveDateBComponent, MedSupMillimanFormComponent, MedSupPaymentMethodComponent, SafePipe], styles: ["h2[_ngcontent-%COMP%]{margin-top:50px}.questions-container[_ngcontent-%COMP%]{align-items:baseline;font-size:var(--Spa_Style_Small_Font)}.question-wrapper[_ngcontent-%COMP%]{margin-bottom:30px}.question-name[_ngcontent-%COMP%]{width:100%}.question-header[_ngcontent-%COMP%]{margin-bottom:6px}.error-message[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent2)}"], changeDetection: 0 });
__decorate([
    Memoize()
], MedSupFormComponent.prototype, "doesQuestionExist", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MedSupFormComponent, [{
        type: Component,
        args: [{ selector: 'vnext-med-sup-form', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"!plansLoading\">\r\n  <p class=\"Spa_Style_IntroParagraph\" [innerHtml]=\"formPrompt | safe : 'html'\"></p>\r\n  <h2 *ngIf=\"formTitle?.length > 0\" class=\"Spa_Style_H2\">{{ formTitle }}</h2>\r\n  <div class=\"my-4\">\r\n    <div [innerHtml]=\"spaPageSubHeader | safe : 'html'\" navigationAdapter></div>\r\n  </div>\r\n  <div #errorContainer>\r\n    <ng-container *ngIf=\"errorMessages.length && formSubmitted\">\r\n      <div>\r\n        <vnext-notice\r\n          [title]=\"errorNoticeTitle\"\r\n          [messages]=\"errorMessages\"\r\n          [type]=\"'error'\"\r\n          [errorKeywordText]=\"errorKeywordText\"\r\n        ></vnext-notice>\r\n      </div>\r\n    </ng-container>\r\n  </div>\r\n  <div class=\"questions-container row\">\r\n    <ng-container *ngFor=\"let question of sortedQuestions; trackBy: trackIndex\">\r\n      <div\r\n        #medSupQuestions\r\n        *ngIf=\"doesQuestionExist(question.name) && questionUIDataMap[question.name] && !questionUIDataMap[question.name]?.hidden\"\r\n        class=\"question-wrapper {{ questionClasses[question.name] }}\"\r\n      >\r\n        <label class=\"question-name\" [id]=\"questionUIDataMap[question.name]?.ariaLabelledById\">\r\n          <div class=\"error-message\" *ngIf=\"questionErrors[question.name] && formSubmitted\" [id]=\"question.name + 'ValidationError'\">\r\n            <i class=\"fa fa-exclamation-circle mr-1\" aria-hidden=\"true\"></i><span class=\"sr-only\">{{ errorKeywordText }}</span\r\n            >{{ getErrorMessage(question.name, questionErrors[question.name]) }}\r\n          </div>\r\n\r\n          <div\r\n            class=\"question-header\"\r\n            [ngClass]=\"{\r\n              'error-color': questionErrors[question.name] && formSubmitted,\r\n              'Spa_Style_Bold_Weight': question.name !== medSupQuestionNames.GIAdditional\r\n            }\"\r\n            id=\"guaranteed-issue-question-header\"\r\n          >\r\n            <span class=\"input-error-asterisk\" *ngIf=\"questionUIDataMap[question.name]?.required\">* </span>\r\n            <span\r\n              [innerHTML]=\"questionUIDataMap[question.name]?.description | safe : 'html'\"\r\n              navigationAdapter\r\n              [ngClass]=\"{ Spa_Style_Gray4_Color: questionUIDataMap[question.name]?.isPopulatedFromSSO }\"\r\n            ></span>\r\n            <span class=\"pl-1 med-sup-tooltip\" *ngIf=\"questionUIDataMap[question.name]?.tooltip; let tooltipKey\">\r\n              <ng-template #medsupTooltip>\r\n                <div [innerHTML]=\"tooltipKey | safe : 'html'\" class=\"Spa_Style_ToolTip\" navigationAdapter></div>\r\n              </ng-template>\r\n              <i class=\"fas Spa_Style_QuestionIcon\" aria-label=\"Show tooltip\" [ngbTooltip]=\"medsupTooltip\" aria-hidden=\"true\"></i>\r\n            </span>\r\n          </div>\r\n          <ng-template #giTooltip>\r\n            <div [innerHTML]=\"guaranteedIssueTooltip | safe : 'html'\" class=\"Spa_Style_ToolTip\" navigationAdapter></div>\r\n          </ng-template>\r\n          <div class=\"med-sup-tooltip\" *ngIf=\"question.name === medSupQuestionNames.GuaranteedIssue\">\r\n            <span id=\"guaranteed-issue-text\">{{ guaranteedIssueText }}</span>\r\n            <i class=\"fas Spa_Style_QuestionIcon\" aria-label=\"Show tooltip\" [ngbTooltip]=\"giTooltip\"></i>\r\n          </div>\r\n\r\n          <ng-container>\r\n            <ng-container *ngIf=\"question.name === medSupQuestionNames.GuaranteedIssue\">\r\n              <vnext-accordion\r\n                #guaranteedIssue\r\n                (valueSelected)=\"giValueSelected($event)\"\r\n                class=\"col-12\"\r\n                [fieldName]=\"medSupQuestionNames.GuaranteedIssue\"\r\n                [items]=\"guaranteedIssueOptions\"\r\n                [allowParentValues]=\"true\"\r\n                [selectedParent]=\"selectedGIReasonParentId\"\r\n                [selectedChild]=\"selectedGIReasonChildId\"\r\n                [ariaDescribedById]=\"questionErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n                [ariaLabelledById]=\"'guaranteed-issue-question-header guaranteed-issue-text'\"\r\n              ></vnext-accordion>\r\n            </ng-container>\r\n            <vnext-med-sup-toggle\r\n              #medSupGender\r\n              *ngIf=\"question.name === medSupQuestionNames.Gender\"\r\n              (updateAnswer)=\"updateAnswer($event)\"\r\n              [question]=\"question\"\r\n              [fieldName]=\"medSupQuestionNames.Gender\"\r\n              [defaultValue]=\"questionUIDataMap[question.name]?.defaultValue\"\r\n              [limitButtonWidth]=\"question.name === medSupQuestionNames.GIAdditional\"\r\n              [ariaLabelledById]=\"questionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [ariaDescribedById]=\"questionErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n              [toggleControlId]=\"question.name\"\r\n              [isReadOnly]=\"questionUIDataMap[question.name]?.isPopulatedFromSSO\"\r\n            >\r\n            </vnext-med-sup-toggle>\r\n\r\n            <vnext-med-sup-toggle\r\n              #medSupTobacco\r\n              *ngIf=\"question.name === medSupQuestionNames.Tobacco\"\r\n              (updateAnswer)=\"updateAnswer($event)\"\r\n              [question]=\"question\"\r\n              [fieldName]=\"medSupQuestionNames.Tobacco\"\r\n              [defaultValue]=\"questionUIDataMap[question.name]?.defaultValue\"\r\n              [limitButtonWidth]=\"question.name === medSupQuestionNames.GIAdditional\"\r\n              [ariaLabelledById]=\"questionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [ariaDescribedById]=\"questionErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n              [toggleControlId]=\"question.name\"\r\n            >\r\n            </vnext-med-sup-toggle>\r\n\r\n            <vnext-med-sup-toggle\r\n              #medSupDisability\r\n              *ngIf=\"question.name === medSupQuestionNames.Disability\"\r\n              (updateAnswer)=\"updateAnswer($event)\"\r\n              [question]=\"question\"\r\n              [fieldName]=\"medSupQuestionNames.Disability\"\r\n              [defaultValue]=\"questionUIDataMap[question.name]?.defaultValue\"\r\n              [limitButtonWidth]=\"question.name === medSupQuestionNames.GIAdditional\"\r\n              [ariaLabelledById]=\"questionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [ariaDescribedById]=\"questionErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n              [toggleControlId]=\"question.name\"\r\n            >\r\n            </vnext-med-sup-toggle>\r\n\r\n            <vnext-med-sup-toggle\r\n              #medSupHousehold\r\n              *ngIf=\"question.name === medSupQuestionNames.Household\"\r\n              (updateAnswer)=\"updateAnswer($event)\"\r\n              [question]=\"question\"\r\n              [fieldName]=\"medSupQuestionNames.Household\"\r\n              [defaultValue]=\"questionUIDataMap[question.name]?.defaultValue\"\r\n              [limitButtonWidth]=\"question.name === medSupQuestionNames.GIAdditional\"\r\n              [ariaLabelledById]=\"questionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [ariaDescribedById]=\"questionErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n              [toggleControlId]=\"question.name\"\r\n            >\r\n            </vnext-med-sup-toggle>\r\n\r\n            <vnext-med-sup-toggle\r\n              #medSupGIAdditional\r\n              *ngIf=\"question.name === medSupQuestionNames.GIAdditional\"\r\n              (updateAnswer)=\"updateAnswer($event)\"\r\n              [question]=\"question\"\r\n              [fieldName]=\"medSupQuestionNames.GIAdditional\"\r\n              [defaultValue]=\"questionUIDataMap[question.name]?.defaultValue\"\r\n              [limitButtonWidth]=\"question.name === medSupQuestionNames.GIAdditional\"\r\n              [ariaLabelledById]=\"questionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [ariaDescribedById]=\"questionErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n              [toggleControlId]=\"question.name\"\r\n            >\r\n            </vnext-med-sup-toggle>\r\n\r\n            <vnext-med-sup-effective-date\r\n              #medSupEffectiveDate\r\n              *ngIf=\"question.name === medSupQuestionNames.EffectiveDate\"\r\n              (updateAnswer)=\"updateAnswer($event)\"\r\n              [question]=\"question\"\r\n              [defaultValue]=\"questionUIDataMap[question.name]?.defaultValue\"\r\n              [noAnswerLabel]=\"dropdownDefaultText\"\r\n              [hasError]=\"questionErrors[question.name] && formSubmitted\"\r\n              [ariaLabelledById]=\"questionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [ariaDescribedById]=\"questionErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n              [datePickerButtonLabelText]=\"datePickerButtonLabelText\"\r\n              [effectiveDateMessage]=\"effectiveDateMessage\"\r\n              [displayFormat]=\"displayFormat\"\r\n            ></vnext-med-sup-effective-date>\r\n\r\n            <vnext-med-sup-payment-method\r\n              #medSupPaymentMethod\r\n              *ngIf=\"question.name === medSupQuestionNames.PaymentMethod\"\r\n              (updateAnswer)=\"updateAnswer($event)\"\r\n              [question]=\"question\"\r\n              [defaultValue]=\"questionUIDataMap[question.name]?.defaultValue\"\r\n              [noAnswerLabel]=\"dropdownDefaultText\"\r\n              [hasError]=\"questionErrors[question.name] && formSubmitted\"\r\n              [ariaLabelledById]=\"questionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [useToggle]=\"paymentMethodUseToggle\"\r\n              [ariaDescribedById]=\"questionErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n            >\r\n            </vnext-med-sup-payment-method>\r\n\r\n            <vnext-med-sup-integer\r\n              #medSupWeight\r\n              *ngIf=\"question.name === medSupQuestionNames.Weight\"\r\n              (updateAnswer)=\"updateAnswer($event)\"\r\n              [question]=\"question\"\r\n              [fieldName]=\"medSupQuestionNames.Weight\"\r\n              [defaultValue]=\"questionUIDataMap[question.name]?.defaultValue\"\r\n              [label]=\"poundsLabel\"\r\n              [hasError]=\"questionErrors[question.name] && formSubmitted\"\r\n              [ariaLabelledById]=\"questionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [ariaDescribedById]=\"questionErrors[question.name] ? 'extra-label ' + question.name + 'ValidationError' : ''\"\r\n              (keyup.enter)=\"continueToPlans()\"\r\n            ></vnext-med-sup-integer>\r\n\r\n            <vnext-med-sup-integer\r\n              #medSupPlanAge\r\n              *ngIf=\"question.name === medSupQuestionNames.PlanAge\"\r\n              (updateAnswer)=\"updateAnswer($event)\"\r\n              [question]=\"question\"\r\n              [fieldName]=\"medSupQuestionNames.PlanAge\"\r\n              [defaultValue]=\"questionUIDataMap[question.name]?.defaultValue\"\r\n              [label]=\"''\"\r\n              [hasError]=\"questionErrors[question.name] && formSubmitted\"\r\n              [ariaLabelledById]=\"questionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [ariaDescribedById]=\"questionErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n            >\r\n            </vnext-med-sup-integer>\r\n\r\n            <vnext-med-sup-integer\r\n              #medSupTermLength\r\n              *ngIf=\"question.name === medSupQuestionNames.TermLength\"\r\n              (updateAnswer)=\"updateAnswer($event)\"\r\n              [question]=\"question\"\r\n              [fieldName]=\"medSupQuestionNames.TermLength\"\r\n              [defaultValue]=\"questionUIDataMap[question.name]?.defaultValue\"\r\n              [label]=\"''\"\r\n              [hasError]=\"questionErrors[question.name] && formSubmitted\"\r\n              [ariaLabelledById]=\"questionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [ariaDescribedById]=\"questionErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n            >\r\n            </vnext-med-sup-integer>\r\n\r\n            <vnext-med-sup-height\r\n              #medSupHeight\r\n              *ngIf=\"question.name === medSupQuestionNames.Height\"\r\n              (updateAnswer)=\"updateAnswer($event)\"\r\n              [question]=\"question\"\r\n              [defaultValue]=\"questionUIDataMap[question.name]?.defaultValue\"\r\n              [feetLabel]=\"feetLabel\"\r\n              [inchesLabel]=\"inchesLabel\"\r\n              [hasError]=\"questionErrors[question.name] && formSubmitted\"\r\n              [ariaLabelledById]=\"questionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [ariaDescribedByFtInputId]=\"\r\n                questionErrors[question.name] ? 'number-input-label-foot ' + question.name + 'ValidationError' : ''\r\n              \"\r\n              [ariaDescribedByInInputId]=\"\r\n                questionErrors[question.name] ? 'number-input-label-inch ' + question.name + 'ValidationError' : ''\r\n              \"\r\n              (keyup.enter)=\"continueToPlans()\"\r\n            ></vnext-med-sup-height>\r\n\r\n            <vnext-med-sup-birth-date\r\n              #medSupDateOfBirth\r\n              *ngIf=\"question.name === medSupQuestionNames.DateOfBirth\"\r\n              (updateAnswer)=\"updateAnswer($event)\"\r\n              [defaultValue]=\"questionUIDataMap[question.name]?.defaultValue\"\r\n              [question]=\"question\"\r\n              [hasError]=\"questionErrors[question.name] && formSubmitted\"\r\n              [ariaDescribedById]=\"questionErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n              [ariaLabelledById]=\"questionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [isReadOnly]=\"questionUIDataMap[question.name]?.isPopulatedFromSSO\"\r\n              (keyup.enter)=\"continueToPlans()\"\r\n            >\r\n            </vnext-med-sup-birth-date>\r\n\r\n            <vnext-med-sup-effective-date-a\r\n              #medSupPartAEffectiveDate\r\n              *ngIf=\"question.name === medSupQuestionNames.PartAEffectiveDate\"\r\n              (updateAnswer)=\"updateAnswer($event)\"\r\n              [defaultValue]=\"questionUIDataMap[question.name]?.defaultValue\"\r\n              [selectMonthText]=\"selectMonthText\"\r\n              [selectYearText]=\"selectYearText\"\r\n              [question]=\"question\"\r\n              [dateOfBirth]=\"questionUIDataMap[medSupQuestionNames.DateOfBirth]?.value\"\r\n              [hasError]=\"questionErrors[question.name] && formSubmitted\"\r\n              [ariaDescribedById]=\"questionErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n              [ariaLabelledById]=\"questionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [datePickerButtonLabelText]=\"datePickerButtonLabelText\"\r\n              [monthYearRangePartA]=\"monthYearRangePartA\"\r\n              [dropdownEnabledPartA]=\"dropdownEnabledPartA\"\r\n              [monthRangeForPartAandPartB]=\"monthRangeForPartAandPartB\"\r\n              [yearRangeForPartAandPartB]=\"yearRangeForPartA\"\r\n              [partBEffectiveDate]=\"questionUIDataMap[medSupQuestionNames.PartBEffectiveDate]?.value\"\r\n              [locale]=\"locale\"\r\n            >\r\n            </vnext-med-sup-effective-date-a>\r\n\r\n            <vnext-med-sup-effective-date-b\r\n              #medSupPartBEffectiveDate\r\n              *ngIf=\"question.name === medSupQuestionNames.PartBEffectiveDate\"\r\n              (updateAnswer)=\"updateAnswer($event)\"\r\n              [defaultValue]=\"questionUIDataMap[question.name]?.defaultValue\"\r\n              [selectMonthText]=\"selectMonthText\"\r\n              [selectYearText]=\"selectYearText\"\r\n              [question]=\"question\"\r\n              [dateOfBirth]=\"questionUIDataMap[medSupQuestionNames.DateOfBirth]?.value\"\r\n              [hasError]=\"questionErrors[question.name] && formSubmitted\"\r\n              [ariaDescribedById]=\"questionErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n              [ariaLabelledById]=\"questionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [datePickerButtonLabelText]=\"datePickerButtonLabelText\"\r\n              [monthYearRangePartB]=\"monthYearRangePartB\"\r\n              [dropdownEnabledPartB]=\"dropdownEnabledPartB\"\r\n              [monthRangeForPartAandPartB]=\"monthRangeForPartAandPartB\"\r\n              [yearRangeForPartAandPartB]=\"yearRangeForPartB\"\r\n              [partAEffectiveDate]=\"questionUIDataMap[medSupQuestionNames.PartAEffectiveDate]?.value\"\r\n              [locale]=\"locale\"\r\n            >\r\n            </vnext-med-sup-effective-date-b>\r\n\r\n            <vnext-med-sup-toggle\r\n              #medSupEFTDiscount\r\n              *ngIf=\"question.name === medSupQuestionNames.EFTDiscount\"\r\n              (updateAnswer)=\"updateAnswer($event)\"\r\n              [question]=\"question\"\r\n              [fieldName]=\"medSupQuestionNames.EFTDiscount\"\r\n              [defaultValue]=\"questionUIDataMap[question.name]?.defaultValue\"\r\n              [limitButtonWidth]=\"question.name === medSupQuestionNames.GIAdditional\"\r\n              [ariaLabelledById]=\"questionUIDataMap[question.name]?.ariaLabelledById\"\r\n              [ariaDescribedById]=\"questionErrors[question.name] ? question.name + 'ValidationError' : ''\"\r\n              [toggleControlId]=\"question.name\"\r\n            >\r\n            </vnext-med-sup-toggle>\r\n          </ng-container>\r\n        </label>\r\n\r\n        <ng-container *ngIf=\"question.name === medSupQuestionNames.EffectiveDate\">\r\n          <p *ngIf=\"totalPlanCount > 0 && displayEffectiveDateMessage\" class=\"dropdown-message Spa_Style_H5\">\r\n            {{ effectiveDateMessage }}\r\n          </p>\r\n          <div class=\"Spa_Style_Paragraph my-2\" *ngIf=\"rateFactorDisclaimerEnabled\">\r\n            {{ rateFactorDisclaimer }}\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n    </ng-container>\r\n  </div>\r\n\r\n  <ng-container *ngIf=\"showPlanTypeDropdown\">\r\n    <vnext-med-sup-plan-sub-type\r\n      [headerText]=\"planSubTypeHeaderText\"\r\n      [placeholder]=\"planSubTypePlaceholderText\"\r\n      [error]=\"planSubTypeError\"\r\n      [errorKeywordText]=\"errorKeywordText\"\r\n      [selectedPlanSubType]=\"selectedPlanSubType\"\r\n      [planSubTypes]=\"planSubTypes\"\r\n      (valueSelected)=\"selectPlanSubType($event)\"\r\n    ></vnext-med-sup-plan-sub-type>\r\n  </ng-container>\r\n\r\n  <vnext-med-sup-milliman-form\r\n    *ngIf=\"showMillimanForm\"\r\n    (formError)=\"onMillimanFormError($event)\"\r\n    [healthQuestions]=\"healthQuestions\"\r\n    [memberQuestions]=\"memberQuestions\"\r\n    (onMemberInformationReset)=\"onMemberInformationReset($event)\"\r\n    (onMillimanMemberAuthorizationFormError)=\"onMillimanMemberAuthorizationFormError($event)\"\r\n    (onHealthInformationChange)=\"updateMillimanHealthInformation($event)\"\r\n    (onMemberInformationChange)=\"updateMillimanMemberInformation($event)\"\r\n  ></vnext-med-sup-milliman-form>\r\n  <vnext-navigation-banner class=\"col-12\" showPrevious=\"true\" providedPrevious=\"true\">\r\n    <vnext-link *ngIf=\"showPreviousLink\" previous-link (click)=\"hideForm()\" [title]=\"previousLabel\" [showArrow]=\"'left'\"></vnext-link>\r\n    <button continue-button class=\"btn btn Spa_Style_PrimaryButton width-full width-md-initial\" (click)=\"continueToPlans()\">\r\n      {{ continueButtonText }}\r\n    </button>\r\n  </vnext-navigation-banner>\r\n</ng-container>\r\n", styles: ["h2{margin-top:50px}.questions-container{align-items:baseline;font-size:var(--Spa_Style_Small_Font)}.question-wrapper{margin-bottom:30px}.question-name{width:100%}.question-header{margin-bottom:6px}.error-message{color:var(--static-Spa_Style_Accent2)}\n"] }]
    }], function () { return [{ type: i2.Store }, { type: i1.ConfigResourceService }, { type: ConfigurableWidgetService }, { type: PlanFacade }, { type: WidgetService }, { type: i0.ChangeDetectorRef }, { type: i1.MedSupService }, { type: PlanListResourceFacade }, { type: i2$1.Router }, { type: AnalyticsService }, { type: i1.LocaleService }, { type: i1.SpinnerService }, { type: MedSupFormErrorContext }, { type: MedSupFacade }, { type: ProfileFacade }, { type: i1.SSOPopulatedFieldService }, { type: MedSupMillimanFormFacade }, { type: MedSupMillimanService }, { type: i1.MillimanService }, { type: PlanListFacadeService }, { type: HospitalIndemnityFormFacade }, { type: i1.MemberSessionService }, { type: i1.PlanYearResourceService }]; }, { showPreviousLink: [{
            type: Input
        }], previousLabel: [{
            type: Input
        }], inchesLabel: [{
            type: Input
        }], feetLabel: [{
            type: Input
        }], poundsLabel: [{
            type: Input
        }], selectMonthText: [{
            type: Input
        }], selectYearText: [{
            type: Input
        }], dropdownDefaultText: [{
            type: Input
        }], continueButtonText: [{
            type: Input
        }], formTitle: [{
            type: Input
        }], spaPageSubHeader: [{
            type: Input
        }], totalPlanCount: [{
            type: Input
        }], formPrompt: [{
            type: Input
        }], questionMetaData: [{
            type: Input
        }], sortedQuestions: [{
            type: Input
        }], guaranteedIssueOptions: [{
            type: Input
        }], guaranteedIssueText: [{
            type: Input
        }], guaranteedIssueTooltip: [{
            type: Input
        }], plansLoading: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], errorNoticeTitle: [{
            type: Input
        }], productType: [{
            type: Input
        }], planSubTypeEnabled: [{
            type: Input
        }], planSubTypeHeaderText: [{
            type: Input
        }], planSubTypePlaceholderText: [{
            type: Input
        }], displayEffectiveDateMessage: [{
            type: Input
        }], effectiveDateMessage: [{
            type: Input
        }], rateFactorDisclaimer: [{
            type: Input
        }], rateFactorDisclaimerEnabled: [{
            type: Input
        }], formClose: [{
            type: Output
        }], errorContainer: [{
            type: ViewChildren,
            args: ['errorContainer']
        }], medSupQuestions: [{
            type: ViewChildren,
            args: ['medSupQuestions']
        }], medSupFields: [{
            type: ViewChildren,
            args: [`medSupEffectiveDate, medSupPartAEffectiveDate, medSupPartBEffectiveDate, guaranteedIssue,
    medSupGender, medSupTobacco, medSupHousehold, medSupEFTDiscount, medSupGIAdditional, medSupPaymentMethod,
    medSupWeight, medSupPlanAge, medSupTermLength, medSupHeight, medSupDateOfBirth, medSupDisability`]
        }], doesQuestionExist: [] }); })();

function PharmacySearchModalComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 7);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function PharmacySearchModalComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 7);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngTemplateOutlet", _r4);
} }
function PharmacySearchModalComponent_ng_template_4_h1_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.pharmacyModalView1HeadingText, " ");
} }
function PharmacySearchModalComponent_ng_template_4_p_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 24);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r13.pharmacyModalView1IntroText, "html"), i0.ɵɵsanitizeHtml);
} }
function PharmacySearchModalComponent_ng_template_4_div_10_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵelement(1, "i", 31);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.pharmacyErrorText, "");
} }
function PharmacySearchModalComponent_ng_template_4_div_10_label_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r17.pharmacyNameText, " ");
} }
function PharmacySearchModalComponent_ng_template_4_div_10_ng_container_3_input_1_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 34);
    i0.ɵɵlistener("keyup.enter", function PharmacySearchModalComponent_ng_template_4_div_10_ng_container_3_input_1_Template_input_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r22.validateZip()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("placeholder", ctx_r21.pharmacyNameHintText)("formControl", ctx_r21.pharmacyName);
} }
function PharmacySearchModalComponent_ng_template_4_div_10_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PharmacySearchModalComponent_ng_template_4_div_10_ng_container_3_input_1_Template, 1, 2, "input", 33);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_PharmacyName_HintText");
} }
function PharmacySearchModalComponent_ng_template_4_div_10_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 34);
    i0.ɵɵlistener("keyup.enter", function PharmacySearchModalComponent_ng_template_4_div_10_ng_template_4_Template_input_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r24.filterDigitalPharmacies()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("placeholder", ctx_r20.pharmacyNameHintText)("formControl", ctx_r20.digitalPharmacyName);
} }
function PharmacySearchModalComponent_ng_template_4_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, PharmacySearchModalComponent_ng_template_4_div_10_span_1_Template, 3, 1, "span", 26);
    i0.ɵɵtemplate(2, PharmacySearchModalComponent_ng_template_4_div_10_label_2_Template, 2, 1, "label", 27);
    i0.ɵɵtemplate(3, PharmacySearchModalComponent_ng_template_4_div_10_ng_container_3_Template, 2, 1, "ng-container", 28);
    i0.ɵɵtemplate(4, PharmacySearchModalComponent_ng_template_4_div_10_ng_template_4_Template, 1, 2, "ng-template", null, 29, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r19 = i0.ɵɵreference(5);
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.hasMinCharError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_PharmacyName_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.isRetailTabActive)("ngIfElse", _r19);
} }
function PharmacySearchModalComponent_ng_template_4_div_17_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r27.currentPharmacyText);
} }
function PharmacySearchModalComponent_ng_template_4_div_17_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵelement(1, "vnext-widget-selected-pharmacy", 41);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const pharmacy_r29 = ctx.$implicit;
    const ctx_r28 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("selectedPharmacy", pharmacy_r29)("setAsPrimaryLinkText", ctx_r28.setAsPrimaryLinkText)("primaryPharmacyText", ctx_r28.primaryPharmacyText)("multiPharmacyEnabled", ctx_r28.multiPharmacyEnabled)("isHelpfulToolsView", ctx_r28.isHelpfulToolsView)("digitalTabText", ctx_r28.digitalTabText);
} }
function PharmacySearchModalComponent_ng_template_4_div_17_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37)(1, "h2", 23);
    i0.ɵɵtemplate(2, PharmacySearchModalComponent_ng_template_4_div_17_div_1_span_2_Template, 2, 1, "span", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PharmacySearchModalComponent_ng_template_4_div_17_div_1_div_3_Template, 2, 6, "div", 39);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", ctx_r26.multiPharmacyEnabled ? "Spa_Site_AddPharmacy_YourMultiPharmacyText" : "Spa_AddPharmacy_YourPharmacyText");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r26.selectedPharmacies)("ngForTrackBy", ctx_r26.trackByPharmacy);
} }
function PharmacySearchModalComponent_ng_template_4_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, PharmacySearchModalComponent_ng_template_4_div_17_div_1_Template, 4, 3, "div", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.selectedPharmacies.length > 0 && ctx_r15.selectedPharmacies);
} }
function PharmacySearchModalComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9)(2, "div", 10);
    i0.ɵɵtemplate(3, PharmacySearchModalComponent_ng_template_4_h1_3_Template, 2, 1, "h1", 11);
    i0.ɵɵtemplate(4, PharmacySearchModalComponent_ng_template_4_p_4_Template, 2, 4, "p", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 13)(6, "div", 14)(7, "div", 15)(8, "div", 16)(9, "vnext-zip-code-input", 17);
    i0.ɵɵlistener("zip", function PharmacySearchModalComponent_ng_template_4_Template_vnext_zip_code_input_zip_9_listener($event) { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r30.setZipCode($event)); })("keyup.enter", function PharmacySearchModalComponent_ng_template_4_Template_vnext_zip_code_input_keyup_enter_9_listener() { i0.ɵɵrestoreView(_r31); const ctx_r32 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r32.validateZip()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, PharmacySearchModalComponent_ng_template_4_div_10_Template, 6, 4, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "button", 19);
    i0.ɵɵlistener("click", function PharmacySearchModalComponent_ng_template_4_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r31); const ctx_r33 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r33.isRetailTabActive ? ctx_r33.validateZip() : ctx_r33.filterDigitalPharmacies()); });
    i0.ɵɵelement(12, "i");
    i0.ɵɵelementStart(13, "span", 20);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(15, "div", 21);
    i0.ɵɵelement(16, "vnext-selectrx-section");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(17, PharmacySearchModalComponent_ng_template_4_div_17_Template, 2, 1, "div", 22);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", "Spa_AddPharmacy_ModalView1_HeadingText");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_AddPharmacy_ModalView1_IntroText");
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("flex-1", ctx_r3.searchPharmacyByNameEnabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("customStyles", ctx_r3.zipCodeStyles)("showCounty", false)("retrieveZipCode", ctx_r3.retrieveZipCode)("retrieveFipsCode", ctx_r3.retrieveFipsCode)("errorKeywordText", ctx_r3.errorKeywordText)("zipCodeText", ctx_r3.zipLabel)("zipCodeErrorText", ctx_r3.zipErrorText)("countyLabel", ctx_r3.countyLabel)("showCountyLabel", ctx_r3.showCountyLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.searchPharmacyByNameEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("ml-4", ctx_r3.searchPharmacyByNameEnabled);
    i0.ɵɵattribute("aria-label", "Search for pharmacies by ZIP code");
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("fas ", ctx_r3.mapFacade.showSpinner ? "fa-spinner fa-spin" : "fa-search", "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.pharmacySearchButtonText);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r3.isHelpfulToolsView);
} }
function PharmacySearchModalComponent_ng_template_6_h1_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r34.pharmacyModalView2HeadingText, " ");
} }
function PharmacySearchModalComponent_ng_template_6_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 24);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r35.pharmacyModalView2IntroText, "html"), i0.ɵɵsanitizeHtml);
} }
function PharmacySearchModalComponent_ng_template_6_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function PharmacySearchModalComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 10);
    i0.ɵɵtemplate(2, PharmacySearchModalComponent_ng_template_6_h1_2_Template, 2, 1, "h1", 11);
    i0.ɵɵtemplate(3, PharmacySearchModalComponent_ng_template_6_p_3_Template, 2, 4, "p", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PharmacySearchModalComponent_ng_template_6_ng_container_4_Template, 1, 0, "ng-container", 42);
    i0.ɵɵelementStart(5, "div", 43)(6, "button", 44);
    i0.ɵɵlistener("click", function PharmacySearchModalComponent_ng_template_6_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r38); const ctx_r37 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r37.onBackButtonAction()); });
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    const _r6 = i0.ɵɵreference(9);
    const _r10 = i0.ɵɵreference(13);
    i0.ɵɵclassMapInterpolate1("p-3 ", ctx_r5.pharmacyContainerClass, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_AddPharmacy_ModalView2_HeadingText");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_AddPharmacy_ModalView2_IntroText");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r5.digitalPharmacyEnabled)("ngIfThen", _r6)("ngIfElse", _r10);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", "Go back to the previous page or search results");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.pharmacySearchBackButton, " ");
} }
function PharmacySearchModalComponent_ng_template_8_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-widget-pharmacy-list", 50);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pharmacies", i0.ɵɵpipeBind1(2, 20, ctx_r41.filteredPharmacies$))("selectedPharmacies", ctx_r41.selectedPharmacies)("addPharmacyButtonText", ctx_r41.addPharmacyButtonText)("pharmacyAddedLabel", ctx_r41.pharmacyAddedLabel)("pageSize", ctx_r41.pageSize)("pageIndex", ctx_r41.pageIndex)("electronicPrescriptionTooltipHeader", ctx_r41.electronicPrescriptionTooltipHeader)("electronicPrescriptionTooltipBody", ctx_r41.electronicPrescriptionTooltipBody)("standardInNetworkText", ctx_r41.standardInNetworkText)("standardInNetworkTooltipContent", ctx_r41.standardInNetworkTooltipContent)("preferredInNetworkText", ctx_r41.preferredInNetworkText)("preferredInNetworkTooltipContent", ctx_r41.preferredInNetworkTooltipContent)("addedPharmacyText", ctx_r41.addedPharmacyText)("addPharmacyText", ctx_r41.addPharmacyText)("ePrescribingAltText", ctx_r41.ePrescribingAltText)("Spa_Site_Tooltip_Text", ctx_r41.Spa_Site_Tooltip_Text)("multiPharmacyEnabled", ctx_r41.multiPharmacyEnabled)("maxPharmacyCount", ctx_r41.maxPharmacyCount)("pharmacyLimitErrorMessage", ctx_r41.pharmacyLimitErrorMessage)("primaryPharmacyText", ctx_r41.primaryPharmacyText);
} }
function PharmacySearchModalComponent_ng_template_8_div_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 51);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 52);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r42.viewNotFoundHeaderText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r42.viewNotFoundBodyText, " ");
} }
function PharmacySearchModalComponent_ng_template_8_div_0_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35)(1, "div", 55)(2, "vnext-tooltip", 56);
    i0.ɵɵelement(3, "i", 57);
    i0.ɵɵelementStart(4, "span", 58);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(6, "div", 55)(7, "vnext-tooltip", 56);
    i0.ɵɵelement(8, "i", 59);
    i0.ɵɵelementStart(9, "span", 58);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("header", ctx_r44.preferredInNetworkText)("body", ctx_r44.preferredInNetworkTooltipContent)("Spa_Site_Tooltip_Text", ctx_r44.Spa_Site_Tooltip_Text);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r44.preferredInNetworkText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("header", ctx_r44.standardInNetworkText)("body", ctx_r44.standardInNetworkTooltipContent)("Spa_Site_Tooltip_Text", ctx_r44.Spa_Site_Tooltip_Text);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r44.standardInNetworkText);
} }
function PharmacySearchModalComponent_ng_template_8_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 53);
    i0.ɵɵtemplate(1, PharmacySearchModalComponent_ng_template_8_div_0_div_4_div_1_Template, 11, 8, "div", 22);
    i0.ɵɵelementStart(2, "vnext-widget-map", 54);
    i0.ɵɵlistener("setZoom", function PharmacySearchModalComponent_ng_template_8_div_0_div_4_Template_vnext_widget_map_setZoom_2_listener($event) { i0.ɵɵrestoreView(_r46); const ctx_r45 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r45.setZoom($event)); })("resetToDefaultPageIndex", function PharmacySearchModalComponent_ng_template_8_div_0_div_4_Template_vnext_widget_map_resetToDefaultPageIndex_2_listener() { i0.ɵɵrestoreView(_r46); const ctx_r47 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r47.updatePharmacies({ pageSize: ctx_r47.itemsPerPage, defaultStartItem: 1 })); })("setMapCenter", function PharmacySearchModalComponent_ng_template_8_div_0_div_4_Template_vnext_widget_map_setMapCenter_2_listener($event) { i0.ɵɵrestoreView(_r46); const ctx_r48 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r48.setMapCenter($event)); })("setMap", function PharmacySearchModalComponent_ng_template_8_div_0_div_4_Template_vnext_widget_map_setMap_2_listener($event) { i0.ɵɵrestoreView(_r46); const ctx_r49 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r49.initializeMap($event)); })("setMapDefaultBounds", function PharmacySearchModalComponent_ng_template_8_div_0_div_4_Template_vnext_widget_map_setMapDefaultBounds_2_listener($event) { i0.ɵɵrestoreView(_r46); const ctx_r50 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r50.setMapDefaultBounds($event)); })("addSelectedItem", function PharmacySearchModalComponent_ng_template_8_div_0_div_4_Template_vnext_widget_map_addSelectedItem_2_listener($event) { i0.ɵɵrestoreView(_r46); const ctx_r51 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r51.addPharmacyFromMarker($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r43.isHelpfulToolsView);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("zip", ctx_r43.zip)("zoom", ctx_r43.zoom)("minZoom", ctx_r43.minZoom)("maxZoom", ctx_r43.maxZoom)("isHelpfulToolsView", ctx_r43.isHelpfulToolsView)("addButtonText", ctx_r43.addPharmacyButtonText)("addedLabel", ctx_r43.pharmacyAddedLabel)("markers", ctx_r43.markers)("limitErrorMessage", ctx_r43.pharmacyLimitErrorMessage)("primaryIconAriaLabelText", ctx_r43.primaryPharmacyText);
} }
function PharmacySearchModalComponent_ng_template_8_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46)(1, "div", 47);
    i0.ɵɵtemplate(2, PharmacySearchModalComponent_ng_template_8_div_0_ng_container_2_Template, 3, 22, "ng-container", 48);
    i0.ɵɵtemplate(3, PharmacySearchModalComponent_ng_template_8_div_0_ng_container_3_Template, 5, 2, "ng-container", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PharmacySearchModalComponent_ng_template_8_div_0_div_4_Template, 3, 11, "div", 49);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r39.pharmacies == null ? null : ctx_r39.pharmacies.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !((ctx_r39.pharmacies == null ? null : ctx_r39.pharmacies.length) > 0) && !ctx_r39.mapFacade.showSpinner);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r39.zip);
} }
function PharmacySearchModalComponent_ng_template_8_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 61)(1, "vnext-pagination", 62);
    i0.ɵɵlistener("updatePagination", function PharmacySearchModalComponent_ng_template_8_div_1_div_1_Template_vnext_pagination_updatePagination_1_listener($event) { i0.ɵɵrestoreView(_r54); const ctx_r53 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r53.updatePharmacies($event)); });
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pagination", i0.ɵɵpipeBind1(2, 4, ctx_r52.filteredPharmacies$))("defaultStartItem", ctx_r52.defaultStartItem)("itemsPerPage", ctx_r52.itemsPerPage)("paginationText", ctx_r52.paginationText);
} }
function PharmacySearchModalComponent_ng_template_8_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtemplate(1, PharmacySearchModalComponent_ng_template_8_div_1_div_1_Template, 3, 6, "div", 60);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r40.pharmacyPaginationEnabled && ctx_r40.itemsPerPage < (ctx_r40.pharmacies == null ? null : ctx_r40.pharmacies.length));
} }
function PharmacySearchModalComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PharmacySearchModalComponent_ng_template_8_div_0_Template, 5, 3, "div", 45);
    i0.ɵɵtemplate(1, PharmacySearchModalComponent_ng_template_8_div_1_Template, 2, 1, "div", 22);
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r7.mapFacade.showMap);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.mapFacade.showMap);
} }
function PharmacySearchModalComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-digital-pharmacy", 63);
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    let tmp_12_0;
    i0.ɵɵproperty("digitalTabIntroText", ctx_r9.digitalTabIntroText)("digitalPharmacies", ctx_r9.filteredDigitalPharmacies)("pharmacyAddedLabel", ctx_r9.pharmacyAddedLabel)("addPharmacyButtonText", ctx_r9.addPharmacyButtonText)("addPharmacyText", ctx_r9.addPharmacyText)("pharmacyLimitErrorMessage", ctx_r9.pharmacyLimitErrorMessage)("pageSize", ctx_r9.pageSize)("pageIndex", ctx_r9.pageIndex)("pharmacyCountWithinLimits", ctx_r9.pharmacyCountWithinLimits)("itemsPerPage", ctx_r9.itemsPerPage)("defaultStartItem", ctx_r9.defaultStartItem)("paginationText", ctx_r9.paginationText)("pharmacyLimit", (tmp_12_0 = ctx_r9.digitalPharmacies == null ? null : ctx_r9.digitalPharmacies.length) !== null && tmp_12_0 !== undefined ? tmp_12_0 : ctx_r9.pharmacyLimit)("selectedPharmacies", ctx_r9.selectedPharmacies)("pharmacyPaginationEnabled", false);
} }
function PharmacySearchModalComponent_ng_template_12_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function PharmacySearchModalComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 64)(1, "vnext-tab-list", 65);
    i0.ɵɵlistener("updateActiveTab", function PharmacySearchModalComponent_ng_template_12_Template_vnext_tab_list_updateActiveTab_1_listener($event) { i0.ɵɵrestoreView(_r57); const ctx_r56 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r56.updateActiveTab($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(2, PharmacySearchModalComponent_ng_template_12_ng_container_2_Template, 1, 0, "ng-container", 42);
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    const _r6 = i0.ɵɵreference(9);
    const _r8 = i0.ɵɵreference(11);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("tabList", ctx_r11.pharmacyTabList)("activeTab", ctx_r11.activeTab);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.isRetailTabActive)("ngIfThen", _r6)("ngIfElse", _r8);
} }
class PharmacySearchModalComponent extends PharmacySearchComponent {
    constructor(cdr, widgetValidationService, configurableWidgetService, pharmacyFacade, mapFacade, helpfulToolsContext, helpfulToolsService, spinnerService, mapContextService, formValidationService, filterService, localeService, injector, navigationutilityService, navigationContext) {
        super(cdr, widgetValidationService, configurableWidgetService, pharmacyFacade, mapFacade, helpfulToolsContext, helpfulToolsService, spinnerService, mapContextService, formValidationService, filterService, localeService, injector, navigationutilityService, navigationContext);
        this.cdr = cdr;
        this.widgetValidationService = widgetValidationService;
        this.configurableWidgetService = configurableWidgetService;
        this.pharmacyFacade = pharmacyFacade;
        this.mapFacade = mapFacade;
        this.helpfulToolsContext = helpfulToolsContext;
        this.helpfulToolsService = helpfulToolsService;
        this.spinnerService = spinnerService;
        this.mapContextService = mapContextService;
        this.formValidationService = formValidationService;
        this.filterService = filterService;
        this.localeService = localeService;
        this.injector = injector;
        this.navigationutilityService = navigationutilityService;
        this.navigationContext = navigationContext;
        this.pharmacyModalViewName = PharmacyModalViewName;
    }
    ngOnInit() {
        super.ngOnInit();
        this.pharmacyContainerClass = this.getPharmacyContainerClass();
    }
    validateZip() {
        super.validateZip();
        const errors = this.widgetValidationService.validate();
        if (errors.length === 0) {
            this.pharmacyFacade.currentModalViewName = PharmacyModalViewName.MAP;
        }
    }
    filterDigitalPharmacies() {
        super.filterDigitalPharmacies();
        this.pharmacyFacade.currentModalViewName = PharmacyModalViewName.MAP;
    }
    onBackButtonAction() {
        this.pharmacyFacade.currentModalViewName = PharmacyModalViewName.SEARCH;
    }
    trackByPharmacy(pharmacy) {
        return pharmacy.id;
    }
}
PharmacySearchModalComponent.ɵfac = function PharmacySearchModalComponent_Factory(t) { return new (t || PharmacySearchModalComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(PharmacyFacade), i0.ɵɵdirectiveInject(MapFacade), i0.ɵɵdirectiveInject(HelpfulToolsContextService), i0.ɵɵdirectiveInject(HelpfulToolsService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(MapContextService), i0.ɵɵdirectiveInject(i1.FormValidationService), i0.ɵɵdirectiveInject(i1.FilterService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(i1.NavigationContext)); };
PharmacySearchModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PharmacySearchModalComponent, selectors: [["vnext-pharmacy-search-modal"]], inputs: { pharmacyModalViewName: "pharmacyModalViewName", pharmacyModalView1HeadingText: "pharmacyModalView1HeadingText", pharmacyModalView1IntroText: "pharmacyModalView1IntroText", pharmacyModalView2HeadingText: "pharmacyModalView2HeadingText", pharmacyModalView2IntroText: "pharmacyModalView2IntroText", pharmacyErrorText: "pharmacyErrorText", pharmacyNameText: "pharmacyNameText", pharmacySearchBackButton: "pharmacySearchBackButton" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 14, vars: 3, consts: [[3, "ngSwitch"], [3, "ngTemplateOutlet", 4, "ngSwitchCase"], ["searchView", ""], ["mapView", ""], ["retailPharmacy", ""], ["digitalPharmacy", ""], ["showPharmacyTabs", ""], [3, "ngTemplateOutlet"], [1, "row", "px-1"], ["aria-live", "polite", 1, "col-12"], [1, "text-left"], ["class", "Spa_Style_H2", 4, "liveEditProp"], ["class", "Spa_Style_IntroParagraph", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [1, "padd-4"], [1, "container-row", "flex-row-nowrap"], [1, "zip-code-name", "flex-row-nowrap"], [1, "zip-code-input", "mr-4"], [1, "zipcode-width", 3, "customStyles", "showCounty", "retrieveZipCode", "retrieveFipsCode", "errorKeywordText", "zipCodeText", "zipCodeErrorText", "countyLabel", "showCountyLabel", "zip", "keyup.enter"], ["class", "pharmacy-name-field flex-1", 4, "ngIf"], [1, "btn", "Spa_Style_SecondaryButton", "zipcode-search-button", "pharmacy-border-color", "pharmacy-search-button", "align-self-end", 3, "click"], ["id", "pharmacySearch", 1, "ml-1"], [1, "col-12", "p-0", "pt-2"], ["class", "row", 4, "ngIf"], [1, "Spa_Style_H2"], ["navigationAdapter", "", 1, "Spa_Style_IntroParagraph", 3, "innerHtml"], [1, "pharmacy-name-field", "flex-1"], ["class", "error-display error-color text-nowrap", 4, "ngIf"], ["for", "pharmacy-name-text-input", "class", "Spa_Style_Label w-100", 4, "liveEditProp"], [4, "ngIf", "ngIfElse"], ["digitialTabSearchInput", ""], [1, "error-display", "error-color", "text-nowrap"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], ["for", "pharmacy-name-text-input", 1, "Spa_Style_Label", "w-100"], ["id", "pharmacy-name-text-input", "type", "text", "class", "Spa_Style_Paragraph pharmacy-name-input", 3, "placeholder", "formControl", "keyup.enter", 4, "liveEditProp"], ["id", "pharmacy-name-text-input", "type", "text", 1, "Spa_Style_Paragraph", "pharmacy-name-input", 3, "placeholder", "formControl", "keyup.enter"], [1, "row"], ["class", "col-12 px-0 mt-3 mt-md-5", 4, "ngIf"], [1, "col-12", "px-0", "mt-3", "mt-md-5"], [4, "liveEditProp"], ["class", "selected-pharmacy mt-1", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "selected-pharmacy", "mt-1"], [3, "selectedPharmacy", "setAsPrimaryLinkText", "primaryPharmacyText", "multiPharmacyEnabled", "isHelpfulToolsView", "digitalTabText"], [4, "ngIf", "ngIfThen", "ngIfElse"], [1, "col-12", "footer-content", "d-flex", "px-0"], ["type", "button", "tabindex", "0", 1, "btn", "Spa_Style_SecondaryButton", "ml-lg-n3", "ml-md-0", "ml-0", 3, "click"], ["class", "row pharmacy mb-3 mt-3 pharmacy-border-color", 4, "ngIf"], [1, "row", "pharmacy", "mb-3", "mt-3", "pharmacy-border-color"], [1, "col-12", "col-md-12", "col-lg-5", "order-last", "order-lg-first", "pharmacy-wrapper", "px-0", "px-md-2"], [4, "ngIf"], ["class", "col-12 col-md-12 col-lg-7 order-first order-lg-last p-0", 4, "ngIf"], [3, "pharmacies", "selectedPharmacies", "addPharmacyButtonText", "pharmacyAddedLabel", "pageSize", "pageIndex", "electronicPrescriptionTooltipHeader", "electronicPrescriptionTooltipBody", "standardInNetworkText", "standardInNetworkTooltipContent", "preferredInNetworkText", "preferredInNetworkTooltipContent", "addedPharmacyText", "addPharmacyText", "ePrescribingAltText", "Spa_Site_Tooltip_Text", "multiPharmacyEnabled", "maxPharmacyCount", "pharmacyLimitErrorMessage", "primaryPharmacyText"], [1, "Spa_Style_Large_Font", "font-weight-bold", "text-center", "mt-1"], [1, "Spa_Style_Paragraph", "pt-1", "no-pharmacies-body-text"], [1, "col-12", "col-md-12", "col-lg-7", "order-first", "order-lg-last", "p-0"], [3, "zip", "zoom", "minZoom", "maxZoom", "isHelpfulToolsView", "addButtonText", "addedLabel", "markers", "limitErrorMessage", "primaryIconAriaLabelText", "setZoom", "resetToDefaultPageIndex", "setMapCenter", "setMap", "setMapDefaultBounds", "addSelectedItem"], [1, "col-6", "text-center"], [3, "header", "body", "Spa_Site_Tooltip_Text"], ["aria-hidden", "true", 1, "fas", "fa-circle", "Spa_Style_Accent5_Color"], [1, "Spa_Style_Paragraph", "underline", "pl-1"], ["aria-hidden", "true", 1, "fas", "fa-circle", "Spa_Style_Accent3_Color"], ["class", "col-md-5 col-12 px-0 pr-md-3", 4, "ngIf"], [1, "col-md-5", "col-12", "px-0", "pr-md-3"], [3, "pagination", "defaultStartItem", "itemsPerPage", "paginationText", "updatePagination"], [3, "digitalTabIntroText", "digitalPharmacies", "pharmacyAddedLabel", "addPharmacyButtonText", "addPharmacyText", "pharmacyLimitErrorMessage", "pageSize", "pageIndex", "pharmacyCountWithinLimits", "itemsPerPage", "defaultStartItem", "paginationText", "pharmacyLimit", "selectedPharmacies", "pharmacyPaginationEnabled"], [1, "row", "d-block"], [3, "tabList", "activeTab", "updateActiveTab"]], template: function PharmacySearchModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div")(1, "div", 0);
        i0.ɵɵtemplate(2, PharmacySearchModalComponent_ng_container_2_Template, 1, 1, "ng-container", 1);
        i0.ɵɵtemplate(3, PharmacySearchModalComponent_ng_container_3_Template, 1, 1, "ng-container", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, PharmacySearchModalComponent_ng_template_4_Template, 18, 22, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(6, PharmacySearchModalComponent_ng_template_6_Template, 8, 10, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(8, PharmacySearchModalComponent_ng_template_8_Template, 2, 2, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(10, PharmacySearchModalComponent_ng_template_10_Template, 1, 15, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(12, PharmacySearchModalComponent_ng_template_12_Template, 3, 5, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitch", ctx.pharmacyFacade.currentModalViewName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.pharmacyModalViewName.SEARCH);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.pharmacyModalViewName.MAP);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, i1$2.NgTemplateOutlet, i1$2.NgSwitch, i1$2.NgSwitchCase, i4.DefaultValueAccessor, i4.NgControlStatus, i4.FormControlDirective, ZipCodeInputComponent, TabListComponent, PaginationComponent, TooltipComponent, NavigationAdapterDirective, LiveEditPropDirective, IconAriaAttributesDirective, PharmacyListComponent, DigitalPharmacyComponent, MapComponent, SelectedPharmacyComponent, SelectRXSectionComponent, i1$2.AsyncPipe, SafePipe], styles: [".pharmacy-icon[_ngcontent-%COMP%]{font-size:46px}.zipcode-width[_ngcontent-%COMP%]{width:auto}.error-display[_ngcontent-%COMP%]{height:24px}.pharmacy-name-input[_ngcontent-%COMP%]{height:38px;width:100%}.zipcode-search-button[_ngcontent-%COMP%]{line-height:1.4}.mobile-filter-button[_ngcontent-%COMP%]{margin-top:.5rem;text-align:right}.pharmacy[_ngcontent-%COMP%]{border-radius:5px;border-width:1px;border-style:solid}.pharmacy-wrapper[_ngcontent-%COMP%]{max-height:455px;overflow-y:auto}.pharmacy-border-color[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent1)}.underline[_ngcontent-%COMP%]{text-decoration:underline}.pharmacy-search-button[_ngcontent-%COMP%]{height:38px;min-width:105px}.no-pharmacies-body-text[_ngcontent-%COMP%]{line-height:24px}.selected-pharmacy[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);padding:12px 18px;border-radius:5px}.flex-row-nowrap[_ngcontent-%COMP%]{display:flex;flex-wrap:nowrap;align-items:flex-end}.flex-1[_ngcontent-%COMP%]{flex:1}.padd-4[_ngcontent-%COMP%]{padding:0 4px}.pharmacy-popover[_ngcontent-%COMP%]{margin-top:26%}.pharmacy-popover-broker[_ngcontent-%COMP%]{margin-top:29%}.helpfultools-pharmacy-popover[_ngcontent-%COMP%]{margin-top:17%}.badge[_ngcontent-%COMP%]{font-size:16px;color:var(--static-Spa_Style_Primary);border-radius:44%;width:24px}[_nghost-%COMP%]     .popover{max-width:95%;margin-top:24px;max-height:100%;box-shadow:2px 4px 12px 2px;color:var(--static-Spa_Style-Gray2)!important;z-index:1}.pharmacyFilter[_ngcontent-%COMP%]{background:none!important;border:none;padding:0!important;cursor:pointer}@media print{.col-md-12.col-lg-5[_ngcontent-%COMP%]{flex:0 0 41.6667%;max-width:41.6667%}.col-md-12.col-lg-7[_ngcontent-%COMP%]{flex:0 0 58.3333%;max-width:58.3333%}.order-lg-first[_ngcontent-%COMP%]{order:-1}.order-lg-last[_ngcontent-%COMP%]{order:13}}@media (max-width: 680px){.zip-code-name[_ngcontent-%COMP%]{flex-direction:column;align-items:flex-start;justify-content:flex-start;align-self:stretch}.container-row[_ngcontent-%COMP%]{flex-direction:column;align-items:flex-start;justify-content:flex-start}.pharmacy-search-button[_ngcontent-%COMP%]{margin-top:1rem;align-self:stretch!important;margin-left:0!important}.pharmacy-name-field[_ngcontent-%COMP%]{align-self:stretch;margin:1rem 0 1.5rem}}@media (min-width: 767px) and (max-width: 769px){.zip-code-name[_ngcontent-%COMP%]{margin-bottom:1rem;align-self:stretch}.container-row[_ngcontent-%COMP%]{flex-direction:column;align-items:flex-start;justify-content:flex-start}.pharmacy-search-button[_ngcontent-%COMP%]{align-self:stretch!important;margin-left:0!important}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PharmacySearchModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-pharmacy-search-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div>\r\n  <div [ngSwitch]=\"pharmacyFacade.currentModalViewName\">\r\n    <ng-container *ngSwitchCase=\"pharmacyModalViewName.SEARCH\" [ngTemplateOutlet]=\"searchView\"> </ng-container>\r\n    <ng-container *ngSwitchCase=\"pharmacyModalViewName.MAP\" [ngTemplateOutlet]=\"mapView\"></ng-container>\r\n  </div>\r\n  <ng-template #searchView>\r\n    <div class=\"row px-1\">\r\n      <div class=\"col-12\" aria-live=\"polite\">\r\n        <div class=\"text-left\">\r\n          <h1 class=\"Spa_Style_H2\" *liveEditProp=\"'Spa_AddPharmacy_ModalView1_HeadingText'\">\r\n            {{ pharmacyModalView1HeadingText }}\r\n          </h1>\r\n          <p\r\n            class=\"Spa_Style_IntroParagraph\"\r\n            *liveEditProp=\"'Spa_AddPharmacy_ModalView1_IntroText'\"\r\n            [innerHtml]=\"pharmacyModalView1IntroText | safe : 'html'\"\r\n            navigationAdapter\r\n          ></p>\r\n        </div>\r\n        <div class=\"padd-4\">\r\n          <div class=\"container-row flex-row-nowrap\">\r\n            <div class=\"zip-code-name flex-row-nowrap\" [class.flex-1]=\"searchPharmacyByNameEnabled\">\r\n              <div class=\"zip-code-input mr-4\">\r\n                <vnext-zip-code-input\r\n                  class=\"zipcode-width\"\r\n                  [customStyles]=\"zipCodeStyles\"\r\n                  [showCounty]=\"false\"\r\n                  (zip)=\"setZipCode($event)\"\r\n                  [retrieveZipCode]=\"retrieveZipCode\"\r\n                  [retrieveFipsCode]=\"retrieveFipsCode\"\r\n                  [errorKeywordText]=\"errorKeywordText\"\r\n                  [zipCodeText]=\"zipLabel\"\r\n                  [zipCodeErrorText]=\"zipErrorText\"\r\n                  [countyLabel]=\"countyLabel\"\r\n                  [showCountyLabel]=\"showCountyLabel\"\r\n                  (keyup.enter)=\"validateZip()\"\r\n                >\r\n                </vnext-zip-code-input>\r\n              </div>\r\n              <div class=\"pharmacy-name-field flex-1\" *ngIf=\"searchPharmacyByNameEnabled\">\r\n                <span *ngIf=\"hasMinCharError\" class=\"error-display error-color text-nowrap\"\r\n                  ><i aria-hidden=\"true\" class=\"fas fa-exclamation-circle\"></i> {{ pharmacyErrorText }}</span\r\n                >\r\n                <label for=\"pharmacy-name-text-input\" class=\"Spa_Style_Label w-100\" *liveEditProp=\"'Spa_PharmacyName_Text'\">\r\n                  {{ pharmacyNameText }}\r\n                </label>\r\n                <ng-container *ngIf=\"isRetailTabActive; else digitialTabSearchInput\">\r\n                  <input\r\n                    *liveEditProp=\"'Spa_PharmacyName_HintText'\"\r\n                    id=\"pharmacy-name-text-input\"\r\n                    type=\"text\"\r\n                    class=\"Spa_Style_Paragraph pharmacy-name-input\"\r\n                    [placeholder]=\"pharmacyNameHintText\"\r\n                    [formControl]=\"pharmacyName\"\r\n                    (keyup.enter)=\"validateZip()\"\r\n                  />\r\n                </ng-container>\r\n                <ng-template #digitialTabSearchInput>\r\n                  <input\r\n                    id=\"pharmacy-name-text-input\"\r\n                    type=\"text\"\r\n                    class=\"Spa_Style_Paragraph pharmacy-name-input\"\r\n                    [placeholder]=\"pharmacyNameHintText\"\r\n                    [formControl]=\"digitalPharmacyName\"\r\n                    (keyup.enter)=\"filterDigitalPharmacies()\"\r\n                  />\r\n                </ng-template>\r\n              </div>\r\n            </div>\r\n            <button\r\n              [class.ml-4]=\"searchPharmacyByNameEnabled\"\r\n              class=\"btn Spa_Style_SecondaryButton zipcode-search-button pharmacy-border-color pharmacy-search-button align-self-end\"\r\n              (click)=\"isRetailTabActive ? validateZip() : filterDigitalPharmacies()\"\r\n              [attr.aria-label]=\"'Search for pharmacies by ZIP code'\"\r\n            >\r\n              <i class=\"fas {{ mapFacade.showSpinner ? 'fa-spinner fa-spin' : 'fa-search' }}\"></i\r\n              ><span class=\"ml-1\" id=\"pharmacySearch\">{{ pharmacySearchButtonText }}</span>\r\n            </button>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"col-12 p-0 pt-2\">\r\n          <vnext-selectrx-section></vnext-selectrx-section>\r\n        </div>\r\n        <div class=\"row\" *ngIf=\"!isHelpfulToolsView\">\r\n          <div class=\"col-12 px-0 mt-3 mt-md-5\" *ngIf=\"selectedPharmacies.length > 0 && selectedPharmacies\">\r\n            <h2 class=\"Spa_Style_H2\">\r\n              <span\r\n                *liveEditProp=\"multiPharmacyEnabled ? 'Spa_Site_AddPharmacy_YourMultiPharmacyText' : 'Spa_AddPharmacy_YourPharmacyText'\"\r\n                >{{ currentPharmacyText }}</span\r\n              >\r\n            </h2>\r\n            <div class=\"selected-pharmacy mt-1\" *ngFor=\"let pharmacy of selectedPharmacies; trackBy: trackByPharmacy\">\r\n              <vnext-widget-selected-pharmacy\r\n                [selectedPharmacy]=\"pharmacy\"\r\n                [setAsPrimaryLinkText]=\"setAsPrimaryLinkText\"\r\n                [primaryPharmacyText]=\"primaryPharmacyText\"\r\n                [multiPharmacyEnabled]=\"multiPharmacyEnabled\"\r\n                [isHelpfulToolsView]=\"isHelpfulToolsView\"\r\n                [digitalTabText]=\"digitalTabText\"\r\n              >\r\n              </vnext-widget-selected-pharmacy>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template #mapView>\r\n    <div class=\"p-3 {{ pharmacyContainerClass }}\">\r\n      <div class=\"text-left\">\r\n        <h1 class=\"Spa_Style_H2\" *liveEditProp=\"'Spa_AddPharmacy_ModalView2_HeadingText'\">\r\n          {{ pharmacyModalView2HeadingText }}\r\n        </h1>\r\n        <p\r\n          class=\"Spa_Style_IntroParagraph\"\r\n          *liveEditProp=\"'Spa_AddPharmacy_ModalView2_IntroText'\"\r\n          [innerHtml]=\"pharmacyModalView2IntroText | safe : 'html'\"\r\n          navigationAdapter\r\n        ></p>\r\n      </div>\r\n      <ng-container *ngIf=\"!digitalPharmacyEnabled; then retailPharmacy; else showPharmacyTabs\"> </ng-container>\r\n      <div class=\"col-12 footer-content d-flex px-0\">\r\n        <button\r\n          class=\"btn Spa_Style_SecondaryButton ml-lg-n3 ml-md-0 ml-0\"\r\n          type=\"button\"\r\n          tabindex=\"0\"\r\n          (click)=\"onBackButtonAction()\"\r\n          [attr.aria-label]=\"'Go back to the previous page or search results'\"\r\n        >\r\n          {{ pharmacySearchBackButton }}\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n\r\n  <ng-template #retailPharmacy>\r\n    <div class=\"row pharmacy mb-3 mt-3 pharmacy-border-color\" *ngIf=\"mapFacade.showMap\">\r\n      <div class=\"col-12 col-md-12 col-lg-5 order-last order-lg-first pharmacy-wrapper px-0 px-md-2\">\r\n        <ng-container *ngIf=\"pharmacies?.length > 0\">\r\n          <vnext-widget-pharmacy-list\r\n            [pharmacies]=\"filteredPharmacies$ | async\"\r\n            [selectedPharmacies]=\"selectedPharmacies\"\r\n            [addPharmacyButtonText]=\"addPharmacyButtonText\"\r\n            [pharmacyAddedLabel]=\"pharmacyAddedLabel\"\r\n            [pageSize]=\"pageSize\"\r\n            [pageIndex]=\"pageIndex\"\r\n            [electronicPrescriptionTooltipHeader]=\"electronicPrescriptionTooltipHeader\"\r\n            [electronicPrescriptionTooltipBody]=\"electronicPrescriptionTooltipBody\"\r\n            [standardInNetworkText]=\"standardInNetworkText\"\r\n            [standardInNetworkTooltipContent]=\"standardInNetworkTooltipContent\"\r\n            [preferredInNetworkText]=\"preferredInNetworkText\"\r\n            [preferredInNetworkTooltipContent]=\"preferredInNetworkTooltipContent\"\r\n            [addedPharmacyText]=\"addedPharmacyText\"\r\n            [addPharmacyText]=\"addPharmacyText\"\r\n            [ePrescribingAltText]=\"ePrescribingAltText\"\r\n            [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n            [multiPharmacyEnabled]=\"multiPharmacyEnabled\"\r\n            [maxPharmacyCount]=\"maxPharmacyCount\"\r\n            [pharmacyLimitErrorMessage]=\"pharmacyLimitErrorMessage\"\r\n            [primaryPharmacyText]=\"primaryPharmacyText\"\r\n          ></vnext-widget-pharmacy-list>\r\n        </ng-container>\r\n        <ng-container *ngIf=\"!(pharmacies?.length > 0) && !mapFacade.showSpinner\">\r\n          <div class=\"Spa_Style_Large_Font font-weight-bold text-center mt-1\">{{ viewNotFoundHeaderText }}</div>\r\n          <div class=\"Spa_Style_Paragraph pt-1 no-pharmacies-body-text\">\r\n            {{ viewNotFoundBodyText }}\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n      <div class=\"col-12 col-md-12 col-lg-7 order-first order-lg-last p-0\" *ngIf=\"zip\">\r\n        <div class=\"row\" *ngIf=\"isHelpfulToolsView\">\r\n          <div class=\"col-6 text-center\">\r\n            <vnext-tooltip\r\n              [header]=\"preferredInNetworkText\"\r\n              [body]=\"preferredInNetworkTooltipContent\"\r\n              [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n            >\r\n              <i aria-hidden=\"true\" class=\"fas fa-circle Spa_Style_Accent5_Color\"></i>\r\n              <span class=\"Spa_Style_Paragraph underline pl-1\">{{ preferredInNetworkText }}</span>\r\n            </vnext-tooltip>\r\n          </div>\r\n          <div class=\"col-6 text-center\">\r\n            <vnext-tooltip\r\n              [header]=\"standardInNetworkText\"\r\n              [body]=\"standardInNetworkTooltipContent\"\r\n              [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n            >\r\n              <i aria-hidden=\"true\" class=\"fas fa-circle Spa_Style_Accent3_Color\"></i>\r\n              <span class=\"Spa_Style_Paragraph underline pl-1\">{{ standardInNetworkText }}</span>\r\n            </vnext-tooltip>\r\n          </div>\r\n        </div>\r\n        <vnext-widget-map\r\n          [zip]=\"zip\"\r\n          [zoom]=\"zoom\"\r\n          [minZoom]=\"minZoom\"\r\n          [maxZoom]=\"maxZoom\"\r\n          [isHelpfulToolsView]=\"isHelpfulToolsView\"\r\n          [addButtonText]=\"addPharmacyButtonText\"\r\n          [addedLabel]=\"pharmacyAddedLabel\"\r\n          [markers]=\"markers\"\r\n          [limitErrorMessage]=\"pharmacyLimitErrorMessage\"\r\n          [primaryIconAriaLabelText]=\"primaryPharmacyText\"\r\n          (setZoom)=\"setZoom($event)\"\r\n          (resetToDefaultPageIndex)=\"updatePharmacies({ pageSize: itemsPerPage, defaultStartItem: 1 })\"\r\n          (setMapCenter)=\"setMapCenter($event)\"\r\n          (setMap)=\"initializeMap($event)\"\r\n          (setMapDefaultBounds)=\"setMapDefaultBounds($event)\"\r\n          (addSelectedItem)=\"addPharmacyFromMarker($event)\"\r\n        >\r\n        </vnext-widget-map>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\" *ngIf=\"this.mapFacade.showMap\">\r\n      <div class=\"col-md-5 col-12 px-0 pr-md-3\" *ngIf=\"pharmacyPaginationEnabled && itemsPerPage < pharmacies?.length\">\r\n        <vnext-pagination\r\n          [pagination]=\"filteredPharmacies$ | async\"\r\n          [defaultStartItem]=\"defaultStartItem\"\r\n          [itemsPerPage]=\"itemsPerPage\"\r\n          (updatePagination)=\"updatePharmacies($event)\"\r\n          [paginationText]=\"paginationText\"\r\n        ></vnext-pagination>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template #digitalPharmacy>\r\n    <vnext-widget-digital-pharmacy\r\n      [digitalTabIntroText]=\"digitalTabIntroText\"\r\n      [digitalPharmacies]=\"filteredDigitalPharmacies\"\r\n      [pharmacyAddedLabel]=\"pharmacyAddedLabel\"\r\n      [addPharmacyButtonText]=\"addPharmacyButtonText\"\r\n      [addPharmacyText]=\"addPharmacyText\"\r\n      [pharmacyLimitErrorMessage]=\"pharmacyLimitErrorMessage\"\r\n      [pageSize]=\"pageSize\"\r\n      [pageIndex]=\"pageIndex\"\r\n      [pharmacyCountWithinLimits]=\"pharmacyCountWithinLimits\"\r\n      [itemsPerPage]=\"itemsPerPage\"\r\n      [defaultStartItem]=\"defaultStartItem\"\r\n      [paginationText]=\"paginationText\"\r\n      [pharmacyLimit]=\"digitalPharmacies?.length ?? pharmacyLimit\"\r\n      [selectedPharmacies]=\"selectedPharmacies\"\r\n      [pharmacyPaginationEnabled]=\"false\"\r\n    ></vnext-widget-digital-pharmacy>\r\n  </ng-template>\r\n  <ng-template #showPharmacyTabs>\r\n    <div class=\"row d-block\">\r\n      <vnext-tab-list [tabList]=\"pharmacyTabList\" [activeTab]=\"activeTab\" (updateActiveTab)=\"updateActiveTab($event)\"></vnext-tab-list>\r\n    </div>\r\n    <!-- show tabs here -->\r\n    <ng-container *ngIf=\"isRetailTabActive; then retailPharmacy; else digitalPharmacy\"></ng-container>\r\n  </ng-template>\r\n</div>\r\n", styles: [".pharmacy-icon{font-size:46px}.zipcode-width{width:auto}.error-display{height:24px}.pharmacy-name-input{height:38px;width:100%}.zipcode-search-button{line-height:1.4}.mobile-filter-button{margin-top:.5rem;text-align:right}.pharmacy{border-radius:5px;border-width:1px;border-style:solid}.pharmacy-wrapper{max-height:455px;overflow-y:auto}.pharmacy-border-color{border-color:var(--static-Spa_Style_Accent1)}.underline{text-decoration:underline}.pharmacy-search-button{height:38px;min-width:105px}.no-pharmacies-body-text{line-height:24px}.selected-pharmacy{border:1px solid var(--static-Spa_Style_Accent1);padding:12px 18px;border-radius:5px}.flex-row-nowrap{display:flex;flex-wrap:nowrap;align-items:flex-end}.flex-1{flex:1}.padd-4{padding:0 4px}.pharmacy-popover{margin-top:26%}.pharmacy-popover-broker{margin-top:29%}.helpfultools-pharmacy-popover{margin-top:17%}.badge{font-size:16px;color:var(--static-Spa_Style_Primary);border-radius:44%;width:24px}:host >>> .popover{max-width:95%;margin-top:24px;max-height:100%;box-shadow:2px 4px 12px 2px;color:var(--static-Spa_Style-Gray2)!important;z-index:1}.pharmacyFilter{background:none!important;border:none;padding:0!important;cursor:pointer}@media print{.col-md-12.col-lg-5{flex:0 0 41.6667%;max-width:41.6667%}.col-md-12.col-lg-7{flex:0 0 58.3333%;max-width:58.3333%}.order-lg-first{order:-1}.order-lg-last{order:13}}@media (max-width: 680px){.zip-code-name{flex-direction:column;align-items:flex-start;justify-content:flex-start;align-self:stretch}.container-row{flex-direction:column;align-items:flex-start;justify-content:flex-start}.pharmacy-search-button{margin-top:1rem;align-self:stretch!important;margin-left:0!important}.pharmacy-name-field{align-self:stretch;margin:1rem 0 1.5rem}}@media (min-width: 767px) and (max-width: 769px){.zip-code-name{margin-bottom:1rem;align-self:stretch}.container-row{flex-direction:column;align-items:flex-start;justify-content:flex-start}.pharmacy-search-button{align-self:stretch!important;margin-left:0!important}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: PharmacyFacade }, { type: MapFacade }, { type: HelpfulToolsContextService }, { type: HelpfulToolsService }, { type: i1.SpinnerService }, { type: MapContextService }, { type: i1.FormValidationService }, { type: i1.FilterService }, { type: i1.LocaleService }, { type: i0.Injector }, { type: i1.NavigationUtilityService }, { type: i1.NavigationContext }]; }, { pharmacyModalViewName: [{
            type: Input
        }], pharmacyModalView1HeadingText: [{
            type: Input
        }], pharmacyModalView1IntroText: [{
            type: Input
        }], pharmacyModalView2HeadingText: [{
            type: Input
        }], pharmacyModalView2IntroText: [{
            type: Input
        }], pharmacyErrorText: [{
            type: Input
        }], pharmacyNameText: [{
            type: Input
        }], pharmacySearchBackButton: [{
            type: Input
        }] }); })();

class PharmacyModalComponent {
    constructor(activeModal, cdr, pharmacyFacade, mapFacade, mapContextService, formValidationService, elementRef, renderer, guidedHelpModalStyleService) {
        this.activeModal = activeModal;
        this.cdr = cdr;
        this.pharmacyFacade = pharmacyFacade;
        this.mapFacade = mapFacade;
        this.mapContextService = mapContextService;
        this.formValidationService = formValidationService;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.guidedHelpModalStyleService = guidedHelpModalStyleService;
        this.subscriptions = new Subscription();
        this.pharmacyName = new UntypedFormControl('');
    }
    ngOnInit() {
        this.subscriptions.add(this.pharmacyFacade.getDigitalPharmacies$().subscribe({
            next: digitalPharmacies => {
                this.digitalPharmacies = digitalPharmacies;
                this.filteredDigitalPharmacies = digitalPharmacies;
                this.mapFacade.hideSpinner(SpinnerEvent.PHARMACIES_LOADING);
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.pharmacyFacade.pharmacyCountWithinLimits$().subscribe({
            next: pharmacyCountWithinLimits => {
                this.pharmacyCountWithinLimits = pharmacyCountWithinLimits;
                this.cdr.markForCheck();
            }
        }));
        this.pharmacyErrorText = this.formValidationService.errorMessages.minCharacters2();
        this.pharmacyLimitErrorMessage = this.getPharmacyMaximumCount();
    }
    ngAfterViewInit() {
        const modalElement = this.elementRef.nativeElement;
        if (modalElement) {
            this.guidedHelpModalStyleService.applyModalStyle(this.renderer, modalElement);
        }
    }
    getPharmacyMaximumCount() {
        return this.pharmacyInputProps.pharmacyLimitErrorMessage.replace('<maxPharmacyCount>', this.pharmacyFacade.maxPharmacyCount.toString());
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
PharmacyModalComponent.ɵfac = function PharmacyModalComponent_Factory(t) { return new (t || PharmacyModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PharmacyFacade), i0.ɵɵdirectiveInject(MapFacade), i0.ɵɵdirectiveInject(MapContextService), i0.ɵɵdirectiveInject(i1.FormValidationService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(GuidedHelpModalStyleService)); };
PharmacyModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PharmacyModalComponent, selectors: [["vnext-pharmacy-modal"]], decls: 4, vars: 58, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "modal-body"], [3, "pharmacyModalView1HeadingText", "pharmacyModalView1IntroText", "errorKeywordText", "zipLabel", "zipCodeErrorText", "countyLabel", "showCountyLabel", "pharmacyNameText", "pharmacyNameHintText", "defaultFilterText", "pharmacyModalView2HeadingText", "pharmacyModalView2IntroText", "digitalPharmacyEnabled", "currentPharmacyText", "setAsPrimaryLinkText", "primaryPharmacyText", "digitalTabText", "retailTabText", "addPharmacyButtonText", "pharmacyAddedLabel", "electronicPrescriptionTooltipHeader", "electronicPrescriptionTooltipBody", "standardInNetworkText", "standardInNetworkTooltipContent", "preferredInNetworkText", "preferredInNetworkTooltipContent", "addedPharmacyText", "addPharmacyText", "ePrescribingAltText", "Spa_Site_Tooltip_Text", "multiPharmacyEnabled", "pharmacyLimitErrorMessage", "harmacyInputProps.viewNotFoundHeaderText", "isPPCSite", "retrieveZipCode", "retrieveFipsCode", "digitalTabIntroText", "digitalPharmacies", "viewNotFoundHeaderText", "viewNotFoundBodyText", "pharmacyCountWithinLimits", "itemsPerPage", "pharmacyLimit", "pharmacyErrorText", "zipErrorText", "pharmacyPaginationEnabled", "pharmacyMapDefaultZoom", "minZoom", "maxZoom", "addButtonText", "addedLabel", "limitErrorMessage", "primaryIconAriaLabelText", "paginationText", "pharmacySearchBackButton"], [3, "cancelButtonText", "primaryButtonEnabled", "cancelButtonAction"]], template: function PharmacyModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function PharmacyModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.activeModal.dismiss(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "vnext-pharmacy-search-modal", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "vnext-widget-modal-footer", 3);
        i0.ɵɵlistener("cancelButtonAction", function PharmacyModalComponent_Template_vnext_widget_modal_footer_cancelButtonAction_3_listener() { return ctx.activeModal.dismiss(); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        let tmp_43_0;
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("pharmacyModalView1HeadingText", ctx.pharmacyInputProps.pharmacyModalView1HeadingText)("pharmacyModalView1IntroText", ctx.pharmacyInputProps.pharmacyModalView1IntroText)("errorKeywordText", ctx.pharmacyInputProps.errorKeywordText)("zipLabel", ctx.pharmacyInputProps.zipLabel)("zipCodeErrorText", ctx.pharmacyInputProps.zipErrorText)("countyLabel", ctx.pharmacyInputProps.countyLabel)("showCountyLabel", ctx.pharmacyInputProps.showCountyLabel)("pharmacyNameText", ctx.pharmacyInputProps.pharmacyNameText)("pharmacyNameHintText", ctx.pharmacyInputProps.pharmacyNameHintText)("defaultFilterText", ctx.pharmacyInputProps.defaultFilterText)("pharmacyModalView2HeadingText", ctx.pharmacyInputProps.pharmacyModalView2HeadingText)("pharmacyModalView2IntroText", ctx.pharmacyInputProps.pharmacyModalView2IntroText)("digitalPharmacyEnabled", ctx.pharmacyInputProps.digitalPharmacyEnabled)("currentPharmacyText", ctx.pharmacyInputProps.currentPharmacyText)("setAsPrimaryLinkText", ctx.pharmacyInputProps.setAsPrimaryLinkText)("primaryPharmacyText", ctx.pharmacyInputProps.primaryPharmacyText)("digitalTabText", ctx.pharmacyInputProps.digitalTabText)("retailTabText", ctx.pharmacyInputProps.retailTabText)("addPharmacyButtonText", ctx.pharmacyInputProps.addPharmacyButtonText)("pharmacyAddedLabel", ctx.pharmacyInputProps.pharmacyAddedLabel)("electronicPrescriptionTooltipHeader", ctx.pharmacyInputProps.electronicPrescriptionTooltipHeader)("electronicPrescriptionTooltipBody", ctx.pharmacyInputProps.electronicPrescriptionTooltipBody)("standardInNetworkText", ctx.pharmacyInputProps.standardInNetworkText)("standardInNetworkTooltipContent", ctx.pharmacyInputProps.standardInNetworkTooltipContent)("preferredInNetworkText", ctx.pharmacyInputProps.preferredInNetworkText)("preferredInNetworkTooltipContent", ctx.pharmacyInputProps.preferredInNetworkTooltipContent)("addedPharmacyText", ctx.pharmacyInputProps.addedPharmacyText)("addPharmacyText", ctx.pharmacyInputProps.addPharmacyText)("ePrescribingAltText", ctx.pharmacyInputProps.ePrescribingAltText)("Spa_Site_Tooltip_Text", ctx.pharmacyInputProps.Spa_Site_Tooltip_Text)("multiPharmacyEnabled", ctx.pharmacyInputProps.multiPharmacyEnabled)("pharmacyLimitErrorMessage", ctx.pharmacyLimitErrorMessage)("harmacyInputProps.viewNotFoundHeaderText", ctx.pharmacyInputProps.viewNotFoundHeaderText)("isPPCSite", ctx.pharmacyInputProps.isPPCSite)("retrieveZipCode", ctx.retrieveZipCode)("retrieveFipsCode", ctx.retrieveFipsCode)("digitalTabIntroText", ctx.pharmacyInputProps.digitalTabIntroText)("digitalPharmacies", ctx.filteredDigitalPharmacies)("viewNotFoundHeaderText", ctx.pharmacyInputProps.viewNotFoundHeaderText)("viewNotFoundBodyText", ctx.pharmacyInputProps.viewNotFoundBodyText)("pharmacyCountWithinLimits", ctx.pharmacyCountWithinLimits)("itemsPerPage", ctx.pharmacyInputProps.itemsPerPage)("pharmacyLimit", (tmp_43_0 = ctx.digitalPharmacies == null ? null : ctx.digitalPharmacies.length) !== null && tmp_43_0 !== undefined ? tmp_43_0 : ctx.pharmacyInputProps.pharmacyLimit)("pharmacyErrorText", ctx.pharmacyErrorText)("zipErrorText", ctx.pharmacyInputProps.zipErrorText)("pharmacyPaginationEnabled", ctx.pharmacyInputProps.pharmacyPaginationEnabled)("pharmacyMapDefaultZoom", ctx.pharmacyInputProps.pharmacyMapDefaultZoom)("minZoom", ctx.pharmacyInputProps.minZoom)("maxZoom", ctx.pharmacyInputProps.maxZoom)("addButtonText", ctx.pharmacyInputProps.addPharmacyButtonText)("addedLabel", ctx.pharmacyInputProps.pharmacyAddedLabel)("limitErrorMessage", ctx.pharmacyInputProps.pharmacyLimitErrorMessage)("primaryIconAriaLabelText", ctx.pharmacyInputProps.primaryPharmacyText)("paginationText", ctx.pharmacyInputProps.paginationText)("pharmacySearchBackButton", ctx.pharmacyInputProps.pharmacySearchBackButton);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("cancelButtonText", ctx.cancelButton)("primaryButtonEnabled", false);
    } }, dependencies: [ModalFooterComponent, ModalHeaderComponent, PharmacySearchModalComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PharmacyModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-pharmacy-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"activeModal.dismiss()\"></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body\">\r\n  <!-- TODO: SPA-21602 - [UI] Migrate Pharmacies Search from GH to Pharmacy Modal -->\r\n  <vnext-pharmacy-search-modal\r\n    [pharmacyModalView1HeadingText]=\"pharmacyInputProps.pharmacyModalView1HeadingText\"\r\n    [pharmacyModalView1IntroText]=\"pharmacyInputProps.pharmacyModalView1IntroText\"\r\n    [errorKeywordText]=\"pharmacyInputProps.errorKeywordText\"\r\n    [zipLabel]=\"pharmacyInputProps.zipLabel\"\r\n    [zipCodeErrorText]=\"pharmacyInputProps.zipErrorText\"\r\n    [countyLabel]=\"pharmacyInputProps.countyLabel\"\r\n    [showCountyLabel]=\"pharmacyInputProps.showCountyLabel\"\r\n    [pharmacyNameText]=\"pharmacyInputProps.pharmacyNameText\"\r\n    [pharmacyNameHintText]=\"pharmacyInputProps.pharmacyNameHintText\"\r\n    [defaultFilterText]=\"pharmacyInputProps.defaultFilterText\"\r\n    [pharmacyModalView2HeadingText]=\"pharmacyInputProps.pharmacyModalView2HeadingText\"\r\n    [pharmacyModalView2IntroText]=\"pharmacyInputProps.pharmacyModalView2IntroText\"\r\n    [digitalPharmacyEnabled]=\"pharmacyInputProps.digitalPharmacyEnabled\"\r\n    [currentPharmacyText]=\"pharmacyInputProps.currentPharmacyText\"\r\n    [setAsPrimaryLinkText]=\"pharmacyInputProps.setAsPrimaryLinkText\"\r\n    [primaryPharmacyText]=\"pharmacyInputProps.primaryPharmacyText\"\r\n    [digitalTabText]=\"pharmacyInputProps.digitalTabText\"\r\n    [retailTabText]=\"pharmacyInputProps.retailTabText\"\r\n    [addPharmacyButtonText]=\"pharmacyInputProps.addPharmacyButtonText\"\r\n    [pharmacyAddedLabel]=\"pharmacyInputProps.pharmacyAddedLabel\"\r\n    [electronicPrescriptionTooltipHeader]=\"pharmacyInputProps.electronicPrescriptionTooltipHeader\"\r\n    [electronicPrescriptionTooltipBody]=\"pharmacyInputProps.electronicPrescriptionTooltipBody\"\r\n    [standardInNetworkText]=\"pharmacyInputProps.standardInNetworkText\"\r\n    [standardInNetworkTooltipContent]=\"pharmacyInputProps.standardInNetworkTooltipContent\"\r\n    [preferredInNetworkText]=\"pharmacyInputProps.preferredInNetworkText\"\r\n    [preferredInNetworkTooltipContent]=\"pharmacyInputProps.preferredInNetworkTooltipContent\"\r\n    [addedPharmacyText]=\"pharmacyInputProps.addedPharmacyText\"\r\n    [addPharmacyText]=\"pharmacyInputProps.addPharmacyText\"\r\n    [ePrescribingAltText]=\"pharmacyInputProps.ePrescribingAltText\"\r\n    [Spa_Site_Tooltip_Text]=\"pharmacyInputProps.Spa_Site_Tooltip_Text\"\r\n    [multiPharmacyEnabled]=\"pharmacyInputProps.multiPharmacyEnabled\"\r\n    [pharmacyLimitErrorMessage]=\"pharmacyLimitErrorMessage\"\r\n    [harmacyInputProps.viewNotFoundHeaderText]=\"pharmacyInputProps.viewNotFoundHeaderText\"\r\n    [isPPCSite]=\"pharmacyInputProps.isPPCSite\"\r\n    [retrieveZipCode]=\"retrieveZipCode\"\r\n    [retrieveFipsCode]=\"retrieveFipsCode\"\r\n    [digitalTabIntroText]=\"pharmacyInputProps.digitalTabIntroText\"\r\n    [digitalPharmacies]=\"filteredDigitalPharmacies\"\r\n    [viewNotFoundHeaderText]=\"pharmacyInputProps.viewNotFoundHeaderText\"\r\n    [viewNotFoundBodyText]=\"pharmacyInputProps.viewNotFoundBodyText\"\r\n    [pharmacyCountWithinLimits]=\"pharmacyCountWithinLimits\"\r\n    [itemsPerPage]=\"pharmacyInputProps.itemsPerPage\"\r\n    [pharmacyLimit]=\"digitalPharmacies?.length ?? pharmacyInputProps.pharmacyLimit\"\r\n    [pharmacyErrorText]=\"pharmacyErrorText\"\r\n    [zipErrorText]=\"pharmacyInputProps.zipErrorText\"\r\n    [pharmacyPaginationEnabled]=\"pharmacyInputProps.pharmacyPaginationEnabled\"\r\n    [pharmacyMapDefaultZoom]=\"pharmacyInputProps.pharmacyMapDefaultZoom\"\r\n    [minZoom]=\"pharmacyInputProps.minZoom\"\r\n    [maxZoom]=\"pharmacyInputProps.maxZoom\"\r\n    [addButtonText]=\"pharmacyInputProps.addPharmacyButtonText\"\r\n    [addedLabel]=\"pharmacyInputProps.pharmacyAddedLabel\"\r\n    [limitErrorMessage]=\"pharmacyInputProps.pharmacyLimitErrorMessage\"\r\n    [primaryIconAriaLabelText]=\"pharmacyInputProps.primaryPharmacyText\"\r\n    [paginationText]=\"pharmacyInputProps.paginationText\"\r\n    [pharmacySearchBackButton]=\"pharmacyInputProps.pharmacySearchBackButton\"\r\n  >\r\n  </vnext-pharmacy-search-modal>\r\n</div>\r\n\r\n<vnext-widget-modal-footer\r\n  [cancelButtonText]=\"cancelButton\"\r\n  [primaryButtonEnabled]=\"false\"\r\n  (cancelButtonAction)=\"activeModal.dismiss()\"\r\n></vnext-widget-modal-footer>\r\n" }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i0.ChangeDetectorRef }, { type: PharmacyFacade }, { type: MapFacade }, { type: MapContextService }, { type: i1.FormValidationService }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: GuidedHelpModalStyleService }]; }, null); })();

function HealthCostTableComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.healthCostsBenefitsTableHeader);
} }
function HealthCostTableComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.healthCostsUsageTableHeader);
} }
function HealthCostTableComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.healthCostsDaysTableHeader);
} }
function HealthCostTableComponent_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.healthEstimatedCostTableHeader);
} }
function HealthCostTableComponent_tr_14_span_5_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 32);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const benefit_r7 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, benefit_r7.tooltip, "html"), i0.ɵɵsanitizeHtml);
} }
function HealthCostTableComponent_tr_14_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtemplate(1, HealthCostTableComponent_tr_14_span_5_ng_template_1_Template, 2, 4, "ng-template", null, 30, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "i", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r9 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbTooltip", _r9);
} }
function HealthCostTableComponent_tr_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 21)(1, "td", 22)(2, "div", 0)(3, "div", 23);
    i0.ɵɵtext(4);
    i0.ɵɵtemplate(5, HealthCostTableComponent_tr_14_span_5_Template, 4, 1, "span", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 25)(7, "div", 20);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(9, "td", 26)(10, "div");
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "td", 27)(13, "div");
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "td", 28)(16, "div");
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "currency");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const benefit_r7 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", benefit_r7.name, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", benefit_r7.tooltip);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate4(" (", benefit_r7.defaultOccurences, " ", ctx_r4.healthCostsUsageTableMobileText, ", ", benefit_r7.defaultDuration && benefit_r7.durationValue === ctx_r4.healthCostsDurationValues.YES ? benefit_r7.defaultDuration : "\u2014", " ", ctx_r4.healthCostsDaysTableMobileText, ") ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(benefit_r7.defaultOccurences);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", benefit_r7.defaultDuration && benefit_r7.durationValue === ctx_r4.healthCostsDurationValues.YES ? benefit_r7.defaultDuration : "\u2014", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind4(18, 9, benefit_r7.coveredCost, "USD", "symbol", "1.0-0"));
} }
function HealthCostTableComponent_span_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.subTotalText, " ");
} }
function HealthCostTableComponent_span_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.totalEstimatedAnnualCostText, "");
} }
class HealthCostTableComponent {
    constructor(cdr, pharmacyFacade) {
        this.cdr = cdr;
        this.pharmacyFacade = pharmacyFacade;
        this.mappedCostBenefits = [];
        this.hasMedicalCosts = false;
        this.healthCostsDurationValues = HealthCostsDurationValues;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.subscriptions.add(this.pharmacyFacade.mailOrder$.subscribe((mailOrder) => {
            this.totalEstimateCost = this.getTotalEstimateCost(this.plan, mailOrder);
        }));
        this.getHealthCostsMedicalDeductible();
        this.getHealthCostsOOP();
        this.mapConfigBenefits(this.plan?.planAnnualCost?.annualCost?.totalMedicalCoveredCostByBenefit);
        this.getTotalBenefitsCost();
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    getMailOrderCost(plan) {
        return plan?.planAnnualMailOrderCost?.annualCostMultiPharmacy?.[0] ?? {};
    }
    getTotalEstimateCost(plan, isMailOrder) {
        if (isMailOrder) {
            const annualMailOrderCost = this.getMailOrderCost(plan);
            return annualMailOrderCost?.totalAnnualMedicalCostShare ?? 0;
        }
        return this.annualCost?.totalAnnualMedicalCostShare ?? 0;
    }
    getTotalBenefitsCost() {
        this.totalBenefitsCost = this.mappedCostBenefits.reduce((prev, current) => {
            return prev + current.coveredCost;
        }, 0);
    }
    getHealthCostsMedicalDeductible() {
        this.medicalDeductible = this.plan.medicalDeductible;
        if (this.medicalDeductible && this.medicalDeductible > 0) {
            this.healthCostsMedicalDeductibleTemplateText = this.healthCostsMedicalDeductibleText
                .replace('<medicalDeductibleValue>', `$${this.plan.medicalDeductible}`)
                .replace(/\u00A0/g, ' ');
        }
    }
    getHealthCostsOOP() {
        this.healthCostsOutOfPocketTemplateText = this.healthCostsOutOfPocketText.replace('<medicalMaxOutOfPocketValue>', `$${this.plan.maximumOutOfPocketCost}`);
    }
    mapConfigBenefits(configBenefits) {
        this.mappedCostBenefits = this.healthCostsBenefits.map(benefit => {
            const match = configBenefits.find(entry => benefit.medCategoryID === entry.benefitID);
            let defaultOccurences;
            let defaultDuration;
            let coveredCost;
            if (match) {
                defaultOccurences = match.annualOccurrences;
                defaultDuration = match.annualDuration;
                coveredCost = match.coveredCost;
            }
            return {
                benefitID: benefit.medCategoryID,
                name: benefit.name,
                defaultDuration: defaultDuration >= 0 && defaultDuration !== null ? `${defaultDuration}` : undefined,
                durationValue: benefit.durationValue,
                tooltip: benefit.toolTip,
                defaultOccurences,
                coveredCost
            };
        });
        this.cdr.markForCheck();
    }
}
HealthCostTableComponent.ɵfac = function HealthCostTableComponent_Factory(t) { return new (t || HealthCostTableComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PharmacyFacade)); };
HealthCostTableComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HealthCostTableComponent, selectors: [["vnext-health-cost-table"]], inputs: { healthCostsBenefitsTableHeader: "healthCostsBenefitsTableHeader", healthCostsUsageTableHeader: "healthCostsUsageTableHeader", healthCostsDaysTableHeader: "healthCostsDaysTableHeader", healthCostsUsageTableMobileText: "healthCostsUsageTableMobileText", healthCostsDaysTableMobileText: "healthCostsDaysTableMobileText", healthEstimatedCostTableHeader: "healthEstimatedCostTableHeader", subTotalText: "subTotalText", healthCostsBenefits: "healthCostsBenefits", annualCost: "annualCost", totalEstimatedCostText: "totalEstimatedCostText", totalEstimatedAnnualCostText: "totalEstimatedAnnualCostText", healthCostsMedicalDeductibleText: "healthCostsMedicalDeductibleText", healthCostsOutOfPocketText: "healthCostsOutOfPocketText", plan: "plan" }, decls: 33, vars: 21, consts: [[1, "container"], [1, "active-selling-permissions-table", "table"], [1, "row", "Spa_Style_Bold_Weight", "Spa_Style_Primary_Color", "text-left"], ["scope", "col", 1, "col-6", "col-md-4"], ["class", "wrap-header-text", 4, "liveEditProp"], ["scope", "col", 1, "col-md-3", "d-none", "d-md-block"], [1, "wrap-header-width"], ["scope", "col", 1, "col-md-2", "d-none", "d-md-block"], ["scope", "col", 1, "d-flex", "justify-content-end", "col-6", "col-md-3", "text-right"], ["class", "Spa_Style_Primary_Color row", 4, "ngFor", "ngForOf"], [1, "row", "total-table-row"], [1, "col-6", "d-flex", "align-items-center", "justify-content-start"], [4, "liveEditProp"], [1, "Spa_Style_Bold_Weight", "col-6", "d-flex", "align-items-center", "justify-content-end"], [1, "row"], [1, "total-container", "col-12", "mt-4", "mb-4", "Spa_Style_Cost_Background", "d-flex", "align-items-center", "justify-content-end"], ["class", "Spa_Style_H3 align-text-bottom", 4, "liveEditProp"], [1, "ml-4", "Spa_Style_Semi_Bold_Weight", "Spa_Style_Largest_Font", "Spa_Style_Cost_Text_Color"], [1, "Spa_Style_Gray4_Color", "row"], [1, "Spa_Style_Gray4_Color", "row", "mt-4"], [1, "wrap-header-text"], [1, "Spa_Style_Primary_Color", "row"], [1, "d-flex", "align-items-center", "col-6", "col-md-4", "text-left"], ["aria-live", "polite", 1, "row", "d-block"], ["class", "pl-1", 4, "ngIf"], [1, "Spa_Style_H5", "Spa_Style_Gray4_Color", "row", "d-flex", "d-none", "d-sm-block", "d-md-none"], [1, "d-lg-flex", "align-items-center", "justify-content-start", "col-5", "col-md-3", "d-none", "d-md-block"], [1, "d-lg-flex", "align-items-center", "justify-content-start", "col-5", "col-md-2", "d-none", "d-md-block"], [1, "Spa_Style_Bold_Weight", "d-flex", "align-items-center", "justify-content-end", "col-6", "col-md-3", "text-right"], [1, "pl-1"], ["benefitTooltip", ""], ["aria-label", "Show tooltip", "tabindex", "0", "aria-describedby", "benefitToolTipId", 1, "fas", "Spa_Style_QuestionIcon", 3, "ngbTooltip"], ["id", "benefitToolTipId", "navigationAdapter", "", 1, "Spa_Style_ToolTip", 3, "innerHtml"], [1, "Spa_Style_H3", "align-text-bottom"]], template: function HealthCostTableComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "table", 1)(2, "thead")(3, "tr", 2)(4, "th", 3);
        i0.ɵɵtemplate(5, HealthCostTableComponent_span_5_Template, 2, 1, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "th", 5)(7, "div", 6);
        i0.ɵɵtemplate(8, HealthCostTableComponent_span_8_Template, 2, 1, "span", 4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "th", 7);
        i0.ɵɵtemplate(10, HealthCostTableComponent_span_10_Template, 2, 1, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "th", 8);
        i0.ɵɵtemplate(12, HealthCostTableComponent_span_12_Template, 2, 1, "span", 4);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(13, "tbody");
        i0.ɵɵtemplate(14, HealthCostTableComponent_tr_14_Template, 19, 14, "tr", 9);
        i0.ɵɵelementStart(15, "tr", 10)(16, "td", 11);
        i0.ɵɵtemplate(17, HealthCostTableComponent_span_17_Template, 2, 1, "span", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "td", 13);
        i0.ɵɵtext(19);
        i0.ɵɵpipe(20, "currency");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(21, "div", 14)(22, "div", 15);
        i0.ɵɵtemplate(23, HealthCostTableComponent_span_23_Template, 2, 1, "span", 16);
        i0.ɵɵelementStart(24, "span", 17);
        i0.ɵɵtext(25);
        i0.ɵɵpipe(26, "currency");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(27, "div", 18)(28, "div");
        i0.ɵɵtext(29);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(30, "div", 19)(31, "div");
        i0.ɵɵtext(32);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("liveEditProp", "Spa_HealthCosts_Benefits_Table_Header_Text");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "Spa_HealthCosts_Usage_Table_Header_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_HealthCosts_Days_Table_Header_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_HealthCosts_EstCost_Table_Header_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.mappedCostBenefits);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "Spa_HealthCosts_Subtotal_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind4(20, 11, ctx.totalBenefitsCost, "USD", "symbol", "1.0-0"), " ");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("liveEditProp", "Spa_PlanDetails_EstimatedHealthCosts_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind4(26, 16, ctx.totalEstimateCost, "USD", "symbol", "1.0-0"), " ");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.healthCostsMedicalDeductibleTemplateText, " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.healthCostsOutOfPocketTemplateText, " ");
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, NavigationAdapterDirective, LiveEditPropDirective, i1$1.NgbTooltip, i1$2.CurrencyPipe, SafePipe], styles: [".table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], td[_ngcontent-%COMP%]{border:none;padding:.5rem}tr[_ngcontent-%COMP%]{min-height:60px;border-bottom:1px solid var(--static-Spa_Style_Accent1)}.wrap-header-width[_ngcontent-%COMP%]{width:100%}.wrap-header-text[_ngcontent-%COMP%]{width:100%;display:inline-block;word-wrap:break-word;word-break:break-word}.fa-question-circle[_ngcontent-%COMP%]{margin-left:15px;color:var(--static-Spa_Style_Gray4)}.total-table-row[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray1);min-height:45px}.total-container[_ngcontent-%COMP%]{height:60px}@media (max-width: 768px){tr[_ngcontent-%COMP%]{height:auto}}@media (min-width: 768px) and (max-width: 992px){.wrap-header-width[_ngcontent-%COMP%]   .wrap-header-text[_ngcontent-%COMP%]{width:58%}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HealthCostTableComponent, [{
        type: Component,
        args: [{ selector: 'vnext-health-cost-table', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container\">\r\n  <table class=\"active-selling-permissions-table table\">\r\n    <thead>\r\n      <tr class=\"row Spa_Style_Bold_Weight Spa_Style_Primary_Color text-left\">\r\n        <th scope=\"col\" class=\"col-6 col-md-4\">\r\n          <span class=\"wrap-header-text\" *liveEditProp=\"'Spa_HealthCosts_Benefits_Table_Header_Text'\">{{\r\n            healthCostsBenefitsTableHeader\r\n          }}</span>\r\n        </th>\r\n        <th scope=\"col\" class=\"col-md-3 d-none d-md-block\">\r\n          <div class=\"wrap-header-width\">\r\n            <span class=\"wrap-header-text\" *liveEditProp=\"'Spa_HealthCosts_Usage_Table_Header_Text'\">{{\r\n              healthCostsUsageTableHeader\r\n            }}</span>\r\n          </div>\r\n        </th>\r\n        <th scope=\"col\" class=\"col-md-2 d-none d-md-block\">\r\n          <span class=\"wrap-header-text\" *liveEditProp=\"'Spa_HealthCosts_Days_Table_Header_Text'\">{{ healthCostsDaysTableHeader }}</span>\r\n        </th>\r\n        <th scope=\"col\" class=\"d-flex justify-content-end col-6 col-md-3 text-right\">\r\n          <span class=\"wrap-header-text\" *liveEditProp=\"'Spa_HealthCosts_EstCost_Table_Header_Text'\">{{\r\n            healthEstimatedCostTableHeader\r\n          }}</span>\r\n        </th>\r\n      </tr>\r\n    </thead>\r\n    <tbody>\r\n      <tr class=\"Spa_Style_Primary_Color row\" *ngFor=\"let benefit of mappedCostBenefits\">\r\n        <td class=\"d-flex align-items-center col-6 col-md-4 text-left\">\r\n          <div class=\"container\">\r\n            <div aria-live=\"polite\" class=\"row d-block\">\r\n              {{ benefit.name }}\r\n              <span class=\"pl-1\" *ngIf=\"benefit.tooltip\">\r\n                <ng-template #benefitTooltip>\r\n                  <div id=\"benefitToolTipId\" [innerHtml]=\"benefit.tooltip | safe : 'html'\" class=\"Spa_Style_ToolTip\" navigationAdapter></div>\r\n                </ng-template>\r\n                <i class=\"fas Spa_Style_QuestionIcon\" aria-label=\"Show tooltip\" [ngbTooltip]=\"benefitTooltip\" tabindex=\"0\" aria-describedby=\"benefitToolTipId\"></i>\r\n              </span>\r\n            </div>\r\n            <div class=\"Spa_Style_H5 Spa_Style_Gray4_Color row d-flex d-none d-sm-block d-md-none\">\r\n              <div class=\"wrap-header-text\">\r\n                ({{ benefit.defaultOccurences }} {{ healthCostsUsageTableMobileText }},\r\n                {{ benefit.defaultDuration && benefit.durationValue === healthCostsDurationValues.YES ? benefit.defaultDuration : '\u2014' }}\r\n                {{ healthCostsDaysTableMobileText }})\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </td>\r\n        <td class=\"d-lg-flex align-items-center justify-content-start col-5 col-md-3 d-none d-md-block\">\r\n          <div>{{ benefit.defaultOccurences }}</div>\r\n        </td>\r\n        <td class=\"d-lg-flex align-items-center justify-content-start col-5 col-md-2 d-none d-md-block\">\r\n          <div>\r\n            {{ benefit.defaultDuration && benefit.durationValue === healthCostsDurationValues.YES ? benefit.defaultDuration : '\u2014' }}\r\n          </div>\r\n        </td>\r\n        <td class=\"Spa_Style_Bold_Weight d-flex align-items-center justify-content-end col-6 col-md-3 text-right\">\r\n          <div>{{ benefit.coveredCost | currency : 'USD' : 'symbol' : '1.0-0' }}</div>\r\n        </td>\r\n      </tr>\r\n      <tr class=\"row total-table-row\">\r\n        <td class=\"col-6 d-flex align-items-center justify-content-start\">\r\n          <span *liveEditProp=\"'Spa_HealthCosts_Subtotal_Text'\">\r\n            {{ subTotalText }}\r\n          </span>\r\n        </td>\r\n        <td class=\"Spa_Style_Bold_Weight col-6 d-flex align-items-center justify-content-end\">\r\n          {{ totalBenefitsCost | currency : 'USD' : 'symbol' : '1.0-0' }}\r\n        </td>\r\n      </tr>\r\n    </tbody>\r\n  </table>\r\n  <div class=\"row\">\r\n    <div class=\"total-container col-12 mt-4 mb-4 Spa_Style_Cost_Background d-flex align-items-center justify-content-end\">\r\n      <span class=\"Spa_Style_H3 align-text-bottom\" *liveEditProp=\"'Spa_PlanDetails_EstimatedHealthCosts_Text'\">\r\n        {{ totalEstimatedAnnualCostText }}</span\r\n      >\r\n      <span class=\"ml-4 Spa_Style_Semi_Bold_Weight Spa_Style_Largest_Font Spa_Style_Cost_Text_Color\">\r\n        {{ totalEstimateCost | currency : 'USD' : 'symbol' : '1.0-0' }}\r\n      </span>\r\n    </div>\r\n  </div>\r\n  <div class=\"Spa_Style_Gray4_Color row\">\r\n    <div>\r\n      {{ healthCostsMedicalDeductibleTemplateText }}\r\n    </div>\r\n  </div>\r\n  <div class=\"Spa_Style_Gray4_Color row mt-4\">\r\n    <div>\r\n      {{ healthCostsOutOfPocketTemplateText }}\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".table thead th,td{border:none;padding:.5rem}tr{min-height:60px;border-bottom:1px solid var(--static-Spa_Style_Accent1)}.wrap-header-width{width:100%}.wrap-header-text{width:100%;display:inline-block;word-wrap:break-word;word-break:break-word}.fa-question-circle{margin-left:15px;color:var(--static-Spa_Style_Gray4)}.total-table-row{background-color:var(--static-Spa_Style_Gray1);min-height:45px}.total-container{height:60px}@media (max-width: 768px){tr{height:auto}}@media (min-width: 768px) and (max-width: 992px){.wrap-header-width .wrap-header-text{width:58%}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: PharmacyFacade }]; }, { healthCostsBenefitsTableHeader: [{
            type: Input
        }], healthCostsUsageTableHeader: [{
            type: Input
        }], healthCostsDaysTableHeader: [{
            type: Input
        }], healthCostsUsageTableMobileText: [{
            type: Input
        }], healthCostsDaysTableMobileText: [{
            type: Input
        }], healthEstimatedCostTableHeader: [{
            type: Input
        }], subTotalText: [{
            type: Input
        }], healthCostsBenefits: [{
            type: Input
        }], annualCost: [{
            type: Input
        }], totalEstimatedCostText: [{
            type: Input
        }], totalEstimatedAnnualCostText: [{
            type: Input
        }], healthCostsMedicalDeductibleText: [{
            type: Input
        }], healthCostsOutOfPocketText: [{
            type: Input
        }], plan: [{
            type: Input
        }] }); })();

function HealthCostTabComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "h2", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p", 6);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 7);
    i0.ɵɵlistener("click", function HealthCostTabComponent_div_1_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.navigateByPageTag()); });
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.noHealthCostTitle, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.introHealthCostTitle, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.addHealthCostText, " ");
} }
function HealthCostTabComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "p", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 9)(4, "vnext-link", 10);
    i0.ɵɵlistener("click", function HealthCostTabComponent_ng_template_2_Template_vnext_link_click_4_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.navigateByPageTag()); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(5, "vnext-health-cost-table", 11);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.healthCostsDescriptionText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", ctx_r2.addHealthCostText)("role", ctx_r2.linkRoles.LINK)("alwaysUnderlined", true)("linkTarget", "_self");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("healthCostsBenefitsTableHeader", ctx_r2.healthCostsBenefitsTableHeader)("healthCostsUsageTableHeader", ctx_r2.healthCostsUsageTableHeader)("healthCostsDaysTableHeader", ctx_r2.healthCostsDaysTableHeader)("healthEstimatedCostTableHeader", ctx_r2.healthEstimatedCostTableHeader)("subTotalText", ctx_r2.subTotalText)("healthCostsBenefits", ctx_r2.healthCostsBenefits)("totalEstimatedCostText", ctx_r2.totalEstimatedCostText)("totalEstimatedAnnualCostText", ctx_r2.totalEstimatedAnnualCostText)("healthCostsOutOfPocketText", ctx_r2.healthCostsOutOfPocketText)("healthCostsMedicalDeductibleText", ctx_r2.healthCostsMedicalDeductibleText)("healthCostsUsageTableMobileText", ctx_r2.healthCostsUsageTableMobileText)("healthCostsDaysTableMobileText", ctx_r2.healthCostsDaysTableMobileText)("annualCost", ctx_r2.annualCost)("plan", ctx_r2.plan);
} }
class HealthCostTabComponent {
    constructor(guidedHelpService, memberSessionService, planDetailsFacade, analyticsService, modalService, injector, navigationService) {
        this.guidedHelpService = guidedHelpService;
        this.memberSessionService = memberSessionService;
        this.planDetailsFacade = planDetailsFacade;
        this.analyticsService = analyticsService;
        this.modalService = modalService;
        this.injector = injector;
        this.navigationService = navigationService;
        this.linkRoles = LinkRoles;
        this.estimateHealthCostFlag = EstimateHealthCostFlag;
        this.options = {
            ariaLabelledBy: 'modalHeaderTitle',
            centered: true,
            injector: this.injector,
            windowClass: 'modal--lg'
        };
    }
    ngOnInit() {
        this.isHealthCostEstimated = this.guidedHelpService.getHasHealthCostEstimateSelected();
        this.healthCostEstimatedValue = this.memberSessionService.getEstimateHealthCost();
    }
    navigateByPageTag() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_HEALTH);
        if (this.preferencesBannerEnabled) {
            const healthModal = this.modalService.open(HealthModalComponent, this.options);
            healthModal.componentInstance.title = this.modalHeaderHealthText;
            healthModal.componentInstance.cancelButton = this.closeButtonText;
            healthModal.componentInstance.healthCostsBenefits = this.healthCostsBenefits;
            healthModal.componentInstance.healthCostsBodyText = this.healthCostsBodyText;
            healthModal.componentInstance.healthCostsBenefitsBodyText = this.healthCostsBenefitsBodyText;
            healthModal.componentInstance.healthCostsBenefitsTableHeader = this.healthCostsBenefitsTableHeader;
            healthModal.componentInstance.healthCostsUsageTableHeader = this.healthCostsUsageTableHeader;
            healthModal.componentInstance.healthCostsDaysTableHeader = this.healthCostsDaysTableHeader;
            healthModal.componentInstance.saveFailedText = this.saveFailedText;
            healthModal.componentInstance.saveSuccessText = this.saveSuccessText;
            healthModal.componentInstance.healthCostsUpdateAnswersText = this.healthCostsUpdateAnswersText;
            healthModal.componentInstance.healthCostsSaveAnswersText = this.healthCostsSaveAnswersText;
            healthModal.componentInstance.healthCostsRestoreDefaultsText = this.healthCostsRestoreDefaultsText;
            healthModal.componentInstance.healthCostsCustomizationEnabled = this.healthCostsCustomizationEnabled;
            healthModal.componentInstance.healthAgeQuestionText = this.healthAgeQuestionText;
            healthModal.componentInstance.healthSliderHeader1Text = this.healthSliderHeader1Text;
            healthModal.componentInstance.healthSliderHeader2Text = this.healthSliderHeader2Text;
            healthModal.componentInstance.healthSliderHeader3Text = this.healthSliderHeader3Text;
            healthModal.componentInstance.healthSliderBody1 = this.healthSliderBody1;
            healthModal.componentInstance.healthSliderBody2 = this.healthSliderBody2;
            healthModal.componentInstance.healthSliderBody3 = this.healthSliderBody3;
            healthModal.componentInstance.healthSliderLabelText = this.healthSliderLabelText;
            healthModal.componentInstance.healthModalView1HeadingText = this.healthModalView1HeadingText;
            healthModal.componentInstance.healthModalView1IntroText = this.healthModalView1IntroText;
        }
        else {
            this.navigationService.navigateByPageTag(PageTags.GUIDED_HELP_HEALTH);
        }
    }
    tagsToUpdate() {
        return this.planDetailsFacade.tagsToUpdate(this.plan, this.noCostMedSupPlanText, this.isRetentionView, this.selectedTab, this.annualCost);
    }
}
HealthCostTabComponent.ɵfac = function HealthCostTabComponent_Factory(t) { return new (t || HealthCostTabComponent)(i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(PlanDetailsFacade), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1.NavigationService)); };
HealthCostTabComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HealthCostTabComponent, selectors: [["vnext-health-costs-details"]], inputs: { preferencesBannerEnabled: "preferencesBannerEnabled", healthCostsDescriptionText: "healthCostsDescriptionText", addHealthCostText: "addHealthCostText", noHealthCostTitle: "noHealthCostTitle", introHealthCostTitle: "introHealthCostTitle", annualCost: "annualCost", plan: "plan", totalEstimatedCostText: "totalEstimatedCostText", totalEstimatedAnnualCostText: "totalEstimatedAnnualCostText", healthCostsOutOfPocketText: "healthCostsOutOfPocketText", healthCostsMedicalDeductibleText: "healthCostsMedicalDeductibleText", healthCostsBenefitsTableHeader: "healthCostsBenefitsTableHeader", healthCostsUsageTableHeader: "healthCostsUsageTableHeader", healthCostsDaysTableHeader: "healthCostsDaysTableHeader", healthCostsUsageTableMobileText: "healthCostsUsageTableMobileText", healthCostsDaysTableMobileText: "healthCostsDaysTableMobileText", healthEstimatedCostTableHeader: "healthEstimatedCostTableHeader", subTotalText: "subTotalText", healthCostsBenefits: "healthCostsBenefits", selectedTab: "selectedTab", isRetentionView: "isRetentionView", noCostMedSupPlanText: "noCostMedSupPlanText", modalHeaderHealthText: "modalHeaderHealthText", closeButtonText: "closeButtonText", healthCostsBodyText: "healthCostsBodyText", healthCostsBenefitsBodyText: "healthCostsBenefitsBodyText", saveFailedText: "saveFailedText", saveSuccessText: "saveSuccessText", healthCostsUpdateAnswersText: "healthCostsUpdateAnswersText", healthCostsSaveAnswersText: "healthCostsSaveAnswersText", healthCostsRestoreDefaultsText: "healthCostsRestoreDefaultsText", healthCostsCustomizationEnabled: "healthCostsCustomizationEnabled", healthAgeQuestionText: "healthAgeQuestionText", healthSliderHeader1Text: "healthSliderHeader1Text", healthSliderHeader2Text: "healthSliderHeader2Text", healthSliderHeader3Text: "healthSliderHeader3Text", healthSliderBody1: "healthSliderBody1", healthSliderBody2: "healthSliderBody2", healthSliderBody3: "healthSliderBody3", healthSliderLabelText: "healthSliderLabelText", healthModalView1HeadingText: "healthModalView1HeadingText", healthModalView1IntroText: "healthModalView1IntroText", Spa_Site_HealthCosts_Restore_Defaults_Text: "Spa_Site_HealthCosts_Restore_Defaults_Text" }, decls: 4, vars: 3, consts: [["vnextGoogleTagManager", "", 1, "container", "px-0", 3, "tagsToUpdate"], ["class", "row text-center", 4, "ngIf", "ngIfElse"], ["showHealthCostTable", ""], [1, "row", "text-center"], [1, "col-12", "mt-5", "mb-4"], [1, "text-center", "Spa_Style_H3"], [1, "Spa_Style_Paragraph"], [1, "btn", "Spa_Style_PrimaryButton", "col-12", "col-md-auto", "continue-button", 3, "click"], [1, "border-bottom"], [1, "text-right", "mb-2", "Spa_Style_Primary_Link"], [3, "title", "role", "alwaysUnderlined", "linkTarget", "click"], [3, "healthCostsBenefitsTableHeader", "healthCostsUsageTableHeader", "healthCostsDaysTableHeader", "healthEstimatedCostTableHeader", "subTotalText", "healthCostsBenefits", "totalEstimatedCostText", "totalEstimatedAnnualCostText", "healthCostsOutOfPocketText", "healthCostsMedicalDeductibleText", "healthCostsUsageTableMobileText", "healthCostsDaysTableMobileText", "annualCost", "plan"]], template: function HealthCostTabComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, HealthCostTabComponent_div_1_Template, 8, 3, "div", 1);
        i0.ɵɵtemplate(2, HealthCostTabComponent_ng_template_2_Template, 6, 19, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(3);
        i0.ɵɵproperty("tagsToUpdate", ctx.tagsToUpdate());
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isHealthCostEstimated && (!ctx.healthCostEstimatedValue || ctx.healthCostEstimatedValue === ctx.estimateHealthCostFlag.OptOut))("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgIf, LinkComponent, GoogleTagManagerDirective, HealthCostTableComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HealthCostTabComponent, [{
        type: Component,
        args: [{ selector: 'vnext-health-costs-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container px-0\" vnextGoogleTagManager [tagsToUpdate]=\"tagsToUpdate()\">\r\n  <div\r\n    class=\"row text-center\"\r\n    *ngIf=\"\r\n      !isHealthCostEstimated && (!healthCostEstimatedValue || healthCostEstimatedValue === estimateHealthCostFlag.OptOut);\r\n      else showHealthCostTable\r\n    \"\r\n  >\r\n    <div class=\"col-12 mt-5 mb-4\">\r\n      <h2 class=\"text-center Spa_Style_H3\">\r\n        {{ noHealthCostTitle }}\r\n      </h2>\r\n      <p class=\"Spa_Style_Paragraph\">\r\n        {{ introHealthCostTitle }}\r\n      </p>\r\n\r\n      <button class=\"btn Spa_Style_PrimaryButton col-12 col-md-auto continue-button\" (click)=\"navigateByPageTag()\">\r\n        {{ addHealthCostText }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n  <ng-template #showHealthCostTable>\r\n    <div class=\"border-bottom\">\r\n      <p class=\"Spa_Style_Paragraph\">\r\n        {{ healthCostsDescriptionText }}\r\n      </p>\r\n      <div class=\"text-right mb-2 Spa_Style_Primary_Link\">\r\n        <vnext-link\r\n          [title]=\"addHealthCostText\"\r\n          [role]=\"linkRoles.LINK\"\r\n          [alwaysUnderlined]=\"true\"\r\n          [linkTarget]=\"'_self'\"\r\n          (click)=\"navigateByPageTag()\"\r\n        >\r\n        </vnext-link>\r\n      </div>\r\n    </div>\r\n    <vnext-health-cost-table\r\n      [healthCostsBenefitsTableHeader]=\"healthCostsBenefitsTableHeader\"\r\n      [healthCostsUsageTableHeader]=\"healthCostsUsageTableHeader\"\r\n      [healthCostsDaysTableHeader]=\"healthCostsDaysTableHeader\"\r\n      [healthEstimatedCostTableHeader]=\"healthEstimatedCostTableHeader\"\r\n      [subTotalText]=\"subTotalText\"\r\n      [healthCostsBenefits]=\"healthCostsBenefits\"\r\n      [totalEstimatedCostText]=\"totalEstimatedCostText\"\r\n      [totalEstimatedAnnualCostText]=\"totalEstimatedAnnualCostText\"\r\n      [healthCostsOutOfPocketText]=\"healthCostsOutOfPocketText\"\r\n      [healthCostsMedicalDeductibleText]=\"healthCostsMedicalDeductibleText\"\r\n      [healthCostsUsageTableMobileText]=\"healthCostsUsageTableMobileText\"\r\n      [healthCostsDaysTableMobileText]=\"healthCostsDaysTableMobileText\"\r\n      [annualCost]=\"annualCost\"\r\n      [plan]=\"plan\"\r\n    ></vnext-health-cost-table>\r\n  </ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: i1.GuidedHelpService }, { type: i1.MemberSessionService }, { type: PlanDetailsFacade }, { type: AnalyticsService }, { type: i1$1.NgbModal }, { type: i0.Injector }, { type: i1.NavigationService }]; }, { preferencesBannerEnabled: [{
            type: Input
        }], healthCostsDescriptionText: [{
            type: Input
        }], addHealthCostText: [{
            type: Input
        }], noHealthCostTitle: [{
            type: Input
        }], introHealthCostTitle: [{
            type: Input
        }], annualCost: [{
            type: Input
        }], plan: [{
            type: Input
        }], totalEstimatedCostText: [{
            type: Input
        }], totalEstimatedAnnualCostText: [{
            type: Input
        }], healthCostsOutOfPocketText: [{
            type: Input
        }], healthCostsMedicalDeductibleText: [{
            type: Input
        }], healthCostsBenefitsTableHeader: [{
            type: Input
        }], healthCostsUsageTableHeader: [{
            type: Input
        }], healthCostsDaysTableHeader: [{
            type: Input
        }], healthCostsUsageTableMobileText: [{
            type: Input
        }], healthCostsDaysTableMobileText: [{
            type: Input
        }], healthEstimatedCostTableHeader: [{
            type: Input
        }], subTotalText: [{
            type: Input
        }], healthCostsBenefits: [{
            type: Input
        }], selectedTab: [{
            type: Input
        }], isRetentionView: [{
            type: Input
        }], noCostMedSupPlanText: [{
            type: Input
        }], modalHeaderHealthText: [{
            type: Input
        }], closeButtonText: [{
            type: Input
        }], healthCostsBodyText: [{
            type: Input
        }], healthCostsBenefitsBodyText: [{
            type: Input
        }], saveFailedText: [{
            type: Input
        }], saveSuccessText: [{
            type: Input
        }], healthCostsUpdateAnswersText: [{
            type: Input
        }], healthCostsSaveAnswersText: [{
            type: Input
        }], healthCostsRestoreDefaultsText: [{
            type: Input
        }], healthCostsCustomizationEnabled: [{
            type: Input
        }], healthAgeQuestionText: [{
            type: Input
        }], healthSliderHeader1Text: [{
            type: Input
        }], healthSliderHeader2Text: [{
            type: Input
        }], healthSliderHeader3Text: [{
            type: Input
        }], healthSliderBody1: [{
            type: Input
        }], healthSliderBody2: [{
            type: Input
        }], healthSliderBody3: [{
            type: Input
        }], healthSliderLabelText: [{
            type: Input
        }], healthModalView1HeadingText: [{
            type: Input
        }], healthModalView1IntroText: [{
            type: Input
        }], Spa_Site_HealthCosts_Restore_Defaults_Text: [{
            type: Input
        }] }); })();

class HospitalIndemnityInformationNudgeComponent {
    constructor(injector, modalService, analyticsService, configurableWidgetService, planListFacade, plansService, responsiveLayoutService, planCompareFacade, planFacade) {
        this.injector = injector;
        this.modalService = modalService;
        this.analyticsService = analyticsService;
        this.configurableWidgetService = configurableWidgetService;
        this.planListFacade = planListFacade;
        this.plansService = plansService;
        this.responsiveLayoutService = responsiveLayoutService;
        this.planCompareFacade = planCompareFacade;
        this.planFacade = planFacade;
        this.subscriptions = [];
    }
    ngOnInit() {
        this.subscriptions.push(this.responsiveLayoutService.isCompact$.subscribe((isMobile) => {
            this.addToQuoteLimit = isMobile ? this.addToQuoteMobileLimit : this.addToQuoteDesktopLimit;
        }));
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }
    onClickInformationNudge() {
        if (this.areAllHospitalIndemnityQuestionsAnswered) {
            this.configurableWidgetService.spinnerService.show(SpinnerEvent.PLANS_LOADING);
            const hospitalIndemnityPlansSelectedForQuote = this.planCompareFacade.getHospitalIndemnityPlansSelectedForQuote();
            if (hospitalIndemnityPlansSelectedForQuote?.items?.length < this.addToQuoteLimit ||
                hospitalIndemnityPlansSelectedForQuote?.items?.some((hospitalIndemnityPlan) => !this.planFacade.isHCPlan(hospitalIndemnityPlan))) {
                this.plansService.setRateFactorPlan(this.rateFactorPlan);
            }
            this.plansService.setOverrideActiveTab(false);
            this.planListFacade.updateActiveTab(PlanTypeAbbreviation.HC);
            this.configurableWidgetService.navigationService.navigateByPageTag(PageTags.PLAN_LIST).then(() => {
                this.configurableWidgetService.spinnerService.hide(SpinnerEvent.PLANS_LOADING);
            });
        }
        else {
            this.openRateFactorModal();
        }
    }
    openRateFactorModal() {
        const options = {
            ariaLabelledBy: 'modalHeaderTitle',
            centered: true,
            injector: this.injector,
            size: 'lg'
        };
        const hospitalIndemnityFactorModal = this.modalService.open(HospitalIndemnityFactorModalComponent, options);
        hospitalIndemnityFactorModal.componentInstance.title = this.rateFactorModalTitle;
        hospitalIndemnityFactorModal.componentInstance.rateFactorFormPromptText = this.rateFactorFormPromptText;
        hospitalIndemnityFactorModal.componentInstance.rateFactorFormPageTitleText = this.rateFactorFormPageTitleText;
        hospitalIndemnityFactorModal.componentInstance.errorKeywordText = this.errorKeywordText;
        hospitalIndemnityFactorModal.componentInstance.errorNoticeTitle = this.errorNoticeTitle;
        hospitalIndemnityFactorModal.componentInstance.dropdownDefaultText = this.dropdownDefaultText;
        hospitalIndemnityFactorModal.componentInstance.rateFactorPlan = this.rateFactorPlan;
        // If we select "Add more coverage" from plan details, it should replace the previously selected medicare plan
        hospitalIndemnityFactorModal.componentInstance.shouldReplaceExistingRateFactor = true;
        hospitalIndemnityFactorModal.componentInstance.addToQuoteLimit = this.addToQuoteLimit;
        this.addOnCoverageModalGoogleTag();
    }
    addOnCoverageModalGoogleTag() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLANS_ADDONCOVERAGE
        };
    }
}
HospitalIndemnityInformationNudgeComponent.ɵfac = function HospitalIndemnityInformationNudgeComponent_Factory(t) { return new (t || HospitalIndemnityInformationNudgeComponent)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(PlanListFacadeService), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService), i0.ɵɵdirectiveInject(PlanCompareFacade), i0.ɵɵdirectiveInject(PlanFacade)); };
HospitalIndemnityInformationNudgeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HospitalIndemnityInformationNudgeComponent, selectors: [["vnext-hospital-indemnity-information-nudge"]], inputs: { informationalText: "informationalText", callOutButtonText: "callOutButtonText", rateFactorModalTitle: "rateFactorModalTitle", rateFactorFormPromptText: "rateFactorFormPromptText", rateFactorFormPageTitleText: "rateFactorFormPageTitleText", errorKeywordText: "errorKeywordText", errorNoticeTitle: "errorNoticeTitle", dropdownDefaultText: "dropdownDefaultText", rateFactorPlan: "rateFactorPlan", areAllHospitalIndemnityQuestionsAnswered: "areAllHospitalIndemnityQuestionsAnswered", addToQuoteMobileLimit: "addToQuoteMobileLimit", addToQuoteDesktopLimit: "addToQuoteDesktopLimit" }, decls: 6, vars: 5, consts: [[1, "row"], [3, "innerHTML"], [1, "col-12", "mt-3"], ["type", "button", 1, "btn", "btn-block", "Spa_Style_PrimaryButton", "px-1", 3, "click"]], template: function HospitalIndemnityInformationNudgeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵpipe(2, "safe");
        i0.ɵɵelementStart(3, "div", 2)(4, "button", 3);
        i0.ɵɵlistener("click", function HospitalIndemnityInformationNudgeComponent_Template_button_click_4_listener() { return ctx.onClickInformationNudge(); });
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 2, ctx.informationalText, "html"), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.callOutButtonText, " ");
    } }, dependencies: [SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HospitalIndemnityInformationNudgeComponent, [{
        type: Component,
        args: [{ selector: 'vnext-hospital-indemnity-information-nudge', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row\">\r\n  <div [innerHTML]=\"informationalText | safe: 'html'\"></div>\r\n  <div class=\"col-12 mt-3\">\r\n    <button type=\"button\" (click)=\"onClickInformationNudge()\" class=\"btn btn-block Spa_Style_PrimaryButton px-1\">\r\n      {{ callOutButtonText }}\r\n    </button>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: i0.Injector }, { type: i1$1.NgbModal }, { type: AnalyticsService }, { type: ConfigurableWidgetService }, { type: PlanListFacadeService }, { type: i1.PlansService }, { type: i1.ResponsiveLayoutService }, { type: PlanCompareFacade }, { type: PlanFacade }]; }, { informationalText: [{
            type: Input
        }], callOutButtonText: [{
            type: Input
        }], rateFactorModalTitle: [{
            type: Input
        }], rateFactorFormPromptText: [{
            type: Input
        }], rateFactorFormPageTitleText: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], errorNoticeTitle: [{
            type: Input
        }], dropdownDefaultText: [{
            type: Input
        }], rateFactorPlan: [{
            type: Input
        }], areAllHospitalIndemnityQuestionsAnswered: [{
            type: Input
        }], addToQuoteMobileLimit: [{
            type: Input
        }], addToQuoteDesktopLimit: [{
            type: Input
        }] }); })();

const _c0$19 = function (a0) { return { "gray-static": a0 }; };
function MailOrderPharmacyDetailsComponent_div_0_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$19, !ctx_r1.isMobile));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.mailOrderText, " ");
} }
function MailOrderPharmacyDetailsComponent_div_0_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.planName);
} }
const _c1$u = function (a0) { return { "pharmacy-icon": a0 }; };
function MailOrderPharmacyDetailsComponent_div_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 10);
    i0.ɵɵelementStart(2, "div", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1$u, ctx_r3.isComparePage));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.coveredText);
} }
function MailOrderPharmacyDetailsComponent_div_0_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 12);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1$u, ctx_r5.isComparePage));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r5.notCoveredText);
} }
const _c2$k = function (a0) { return { "row mx-0": a0 }; };
const _c3$b = function (a0) { return { "plan-details-section-right col-md-8": a0 }; };
function MailOrderPharmacyDetailsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, MailOrderPharmacyDetailsComponent_div_0_span_1_Template, 2, 4, "span", 2);
    i0.ɵɵelementStart(2, "div", 3)(3, "div");
    i0.ɵɵtemplate(4, MailOrderPharmacyDetailsComponent_div_0_span_4_Template, 2, 1, "span", 4);
    i0.ɵɵelementStart(5, "div", 5);
    i0.ɵɵtemplate(6, MailOrderPharmacyDetailsComponent_div_0_ng_container_6_Template, 4, 4, "ng-container", 6);
    i0.ɵɵtemplate(7, MailOrderPharmacyDetailsComponent_div_0_ng_template_7_Template, 3, 4, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const _r4 = i0.ɵɵreference(8);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c2$k, !ctx_r0.isComparePage));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isComparePage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c3$b, !ctx_r0.isComparePage));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isComparePage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r0.isComparePage ? "justify-content-center justify-content-lg-start" : "justify-content-start");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.hasMailOrder)("ngIfElse", _r4);
} }
class MailOrderPharmacyDetailsComponent {
}
MailOrderPharmacyDetailsComponent.ɵfac = function MailOrderPharmacyDetailsComponent_Factory(t) { return new (t || MailOrderPharmacyDetailsComponent)(); };
MailOrderPharmacyDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MailOrderPharmacyDetailsComponent, selectors: [["vnext-mail-order-pharmacy-details"]], inputs: { isComparePage: "isComparePage", mailOrderText: "mailOrderText", showMailOrderPharmacy: "showMailOrderPharmacy", coveredText: "coveredText", notCoveredText: "notCoveredText", hasMailOrder: "hasMailOrder", planName: "planName", isMobile: "isMobile" }, decls: 1, vars: 1, consts: [[3, "ngClass", 4, "ngIf"], [3, "ngClass"], ["role", "rowheader", "class", "Spa_Style_H5 plan-details-section-left m-0 col-md-4", 3, "ngClass", 4, "ngIf"], ["role", "cell", 3, "ngClass"], ["class", "sr-only no-translate-block", 4, "ngIf"], [1, "Spa_Style_H4", "mb-0", "mt-1", "mt-md-0", "d-flex", 3, "ngClass"], [4, "ngIf", "ngIfElse"], ["notMailOrderPharmacy", ""], ["role", "rowheader", 1, "Spa_Style_H5", "plan-details-section-left", "m-0", "col-md-4", 3, "ngClass"], [1, "sr-only", "no-translate-block"], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "covered-pharmacy", 3, "ngClass"], [1, "pl-1", "pr-0"], ["aria-hidden", "true", 1, "fas", "fa-times-circle", "not-covered-pharmacy", 3, "ngClass"]], template: function MailOrderPharmacyDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MailOrderPharmacyDetailsComponent_div_0_Template, 9, 11, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showMailOrderPharmacy);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, IconAriaAttributesDirective], styles: [".plan-details-section-left[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:15px 0 15px 10px}.plan-details-section-right[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-width:0 0 1px;padding:15px 5px 15px 10px}.gray-static[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray1)}.covered-pharmacy[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent5)}.not-covered-pharmacy[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent1)}.pharmacy-icon[_ngcontent-%COMP%]{margin-top:1px}@media (max-width: 767px){.plan-details-section-left[_ngcontent-%COMP%]{border-width:0;padding:6px 5px 0 10px}.plan-details-section-right[_ngcontent-%COMP%]{padding:4px 5px 15px 10px;border:none}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MailOrderPharmacyDetailsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-mail-order-pharmacy-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div [ngClass]=\"{ 'row mx-0': !isComparePage }\" *ngIf=\"showMailOrderPharmacy\">\r\n  <span\r\n    role=\"rowheader\"\r\n    *ngIf=\"!isComparePage\"\r\n    class=\"Spa_Style_H5 plan-details-section-left m-0 col-md-4\"\r\n    [ngClass]=\"{ 'gray-static': !isMobile }\"\r\n  >\r\n    {{ mailOrderText }}\r\n  </span>\r\n  <div role=\"cell\" [ngClass]=\"{ 'plan-details-section-right col-md-8': !isComparePage }\">\r\n    <div>\r\n      <span *ngIf=\"isComparePage\" class=\"sr-only no-translate-block\">{{ planName }}</span>\r\n      <div\r\n        class=\"Spa_Style_H4 mb-0 mt-1 mt-md-0 d-flex\"\r\n        [ngClass]=\"isComparePage ? 'justify-content-center justify-content-lg-start' : 'justify-content-start'\"\r\n      >\r\n        <ng-container *ngIf=\"hasMailOrder; else notMailOrderPharmacy\">\r\n          <i class=\"fas fa-check-circle covered-pharmacy\" [ngClass]=\"{ 'pharmacy-icon': isComparePage }\" aria-hidden=\"true\"></i>\r\n          <div class=\"pl-1 pr-0\">{{ coveredText }}</div>\r\n        </ng-container>\r\n        <ng-template #notMailOrderPharmacy>\r\n          <i class=\"fas fa-times-circle not-covered-pharmacy\" [ngClass]=\"{ 'pharmacy-icon': isComparePage }\" aria-hidden=\"true\"></i>\r\n          <div class=\"pl-1 pr-0\">{{ notCoveredText }}</div>\r\n        </ng-template>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".plan-details-section-left{border-right:1px solid var(--static-Spa_Style_Accent1);border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:15px 0 15px 10px}.plan-details-section-right{border:1px solid var(--static-Spa_Style_Accent1);border-width:0 0 1px;padding:15px 5px 15px 10px}.gray-static{background-color:var(--static-Spa_Style_Gray1)}.covered-pharmacy{color:var(--static-Spa_Style_Accent5)}.not-covered-pharmacy{color:var(--static-Spa_Style_Accent1)}.pharmacy-icon{margin-top:1px}@media (max-width: 767px){.plan-details-section-left{border-width:0;padding:6px 5px 0 10px}.plan-details-section-right{padding:4px 5px 15px 10px;border:none}}\n"] }]
    }], null, { isComparePage: [{
            type: Input
        }], mailOrderText: [{
            type: Input
        }], showMailOrderPharmacy: [{
            type: Input
        }], coveredText: [{
            type: Input
        }], notCoveredText: [{
            type: Input
        }], hasMailOrder: [{
            type: Input
        }], planName: [{
            type: Input
        }], isMobile: [{
            type: Input
        }] }); })();

const _c0$18 = function (a0) { return { "gray1-static": a0 }; };
function PlanBenefitDetailsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "span", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 4)(4, "span", 5);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 6);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$18, !ctx_r0.mobile));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.lowIncomeSubsidyLabel, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.lowIncomeSubsidyText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.lowIncomeSubsidyInformationalText);
} }
function PlanBenefitDetailsComponent_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const section_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$18, !ctx_r3.mobile));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", section_r2.name, " ");
} }
function PlanBenefitDetailsComponent_div_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 11);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const section_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, section_r2.value, "html"), i0.ɵɵsanitizeHtml);
} }
function PlanBenefitDetailsComponent_div_1_vnext_link_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-link", 12);
} if (rf & 2) {
    const section_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("title", section_r2.linkName)("href", section_r2.value)("alwaysUnderlined", true)("linkTarget", "_blank")("customClass", "Spa_Style_Link width-fit-content");
} }
const _c1$t = function (a0) { return { "plan-details-section-right col-md-8": a0 }; };
function PlanBenefitDetailsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 2);
    i0.ɵɵtemplate(2, PlanBenefitDetailsComponent_div_1_span_2_Template, 2, 4, "span", 7);
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtemplate(4, PlanBenefitDetailsComponent_div_1_span_4_Template, 2, 4, "span", 9);
    i0.ɵɵtemplate(5, PlanBenefitDetailsComponent_div_1_vnext_link_5_Template, 1, 5, "vnext-link", 10);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const section_r2 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.isComparePage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1$t, !ctx_r1.isComparePage));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !section_r2.linkName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", section_r2.linkName);
} }
class PlanBenefitDetailsComponent {
    constructor() {
        this.STANDARD_PRESCRIPTION_BENEFITS = 2;
    }
}
PlanBenefitDetailsComponent.ɵfac = function PlanBenefitDetailsComponent_Factory(t) { return new (t || PlanBenefitDetailsComponent)(); };
PlanBenefitDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanBenefitDetailsComponent, selectors: [["vnext-plan-benefit-details"]], inputs: { lowIncomeSubsidyLabel: "lowIncomeSubsidyLabel", lowIncomeSubsidyText: "lowIncomeSubsidyText", lowIncomeSubsidyInformationalText: "lowIncomeSubsidyInformationalText", showSubsidy: "showSubsidy", extendedDetails: "extendedDetails", mobile: "mobile", isComparePage: "isComparePage" }, decls: 2, vars: 2, consts: [["role", "row", "class", "row mx-0 plan-details-section-min-height", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["role", "row", 1, "row", "mx-0", "plan-details-section-min-height"], ["role", "rowheader", 1, "Spa_Style_H5", "plan-details-section-left", "m-0", "col-md-4", 3, "ngClass"], ["role", "cell", 1, "plan-details-section-right", "col-md-8"], [1, "Spa_Style_H4", "plan-details-benefit-section-header"], [1, "Spa_Style_Paragraph"], ["role", "rowheader", "class", "Spa_Style_H5 plan-details-section-left m-0 col-md-4", 3, "ngClass", 4, "ngIf"], ["role", "cell", 3, "ngClass"], ["class", "Spa_Style_H4 plan-details-benefit-section-header", "navigationAdapter", "", 3, "innerHTML", 4, "ngIf"], ["class", "Spa_Style_Link", 3, "title", "href", "alwaysUnderlined", "linkTarget", "customClass", 4, "ngIf"], ["navigationAdapter", "", 1, "Spa_Style_H4", "plan-details-benefit-section-header", 3, "innerHTML"], [1, "Spa_Style_Link", 3, "title", "href", "alwaysUnderlined", "linkTarget", "customClass"]], template: function PlanBenefitDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanBenefitDetailsComponent_div_0_Template, 8, 6, "div", 0);
        i0.ɵɵtemplate(1, PlanBenefitDetailsComponent_div_1_Template, 6, 6, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.isComparePage && ctx.showSubsidy && ctx.extendedDetails.headerType === ctx.STANDARD_PRESCRIPTION_BENEFITS);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.extendedDetails.sectionDetails);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, NavigationAdapterDirective, SafePipe], styles: [".plan-details-section-left[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:15px 0 15px 10px}.plan-details-section-right[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-width:0 0 1px;padding:15px 5px 15px 10px}.gray1-static[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray1)}.plan-details-section-min-height[_ngcontent-%COMP%]{min-height:60px}@media (max-width: 767.9px){.plan-details-section-left[_ngcontent-%COMP%]{border-width:0;padding:6px 5px 0 10px}.plan-details-section-right[_ngcontent-%COMP%]{padding:4px 5px 15px 10px;border:none}.plan-details-section-min-height[_ngcontent-%COMP%]{min-height:70px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanBenefitDetailsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-benefit-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  *ngIf=\"!isComparePage && showSubsidy && extendedDetails.headerType === STANDARD_PRESCRIPTION_BENEFITS\"\r\n  role=\"row\"\r\n  class=\"row mx-0 plan-details-section-min-height\"\r\n>\r\n  <span role=\"rowheader\" class=\"Spa_Style_H5 plan-details-section-left m-0 col-md-4\" [ngClass]=\"{ 'gray1-static': !mobile }\">\r\n    {{ lowIncomeSubsidyLabel }}\r\n  </span>\r\n  <div role=\"cell\" class=\"plan-details-section-right col-md-8\">\r\n    <span class=\"Spa_Style_H4 plan-details-benefit-section-header\">\r\n      {{ lowIncomeSubsidyText }}\r\n    </span>\r\n    <div class=\"Spa_Style_Paragraph\">{{ lowIncomeSubsidyInformationalText }}</div>\r\n  </div>\r\n</div>\r\n\r\n<div *ngFor=\"let section of extendedDetails.sectionDetails\">\r\n  <div role=\"row\" class=\"row mx-0 plan-details-section-min-height\">\r\n    <span\r\n      role=\"rowheader\"\r\n      class=\"Spa_Style_H5 plan-details-section-left m-0 col-md-4\"\r\n      *ngIf=\"!isComparePage\"\r\n      [ngClass]=\"{ 'gray1-static': !mobile }\"\r\n    >\r\n      {{ section.name }}\r\n    </span>\r\n    <div role=\"cell\" [ngClass]=\"{ 'plan-details-section-right col-md-8': !isComparePage }\">\r\n      <span\r\n        *ngIf=\"!section.linkName\"\r\n        [innerHTML]=\"section.value | safe : 'html'\"\r\n        class=\"Spa_Style_H4 plan-details-benefit-section-header\"\r\n        navigationAdapter\r\n      ></span>\r\n      <vnext-link\r\n        *ngIf=\"section.linkName\"\r\n        [title]=\"section.linkName\"\r\n        [href]=\"section.value\"\r\n        [alwaysUnderlined]=\"true\"\r\n        class=\"Spa_Style_Link\"\r\n        [linkTarget]=\"'_blank'\"\r\n        [customClass]=\"'Spa_Style_Link width-fit-content'\"\r\n      >\r\n      </vnext-link>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".plan-details-section-left{border-right:1px solid var(--static-Spa_Style_Accent1);border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:15px 0 15px 10px}.plan-details-section-right{border:1px solid var(--static-Spa_Style_Accent1);border-width:0 0 1px;padding:15px 5px 15px 10px}.gray1-static{background-color:var(--static-Spa_Style_Gray1)}.plan-details-section-min-height{min-height:60px}@media (max-width: 767.9px){.plan-details-section-left{border-width:0;padding:6px 5px 0 10px}.plan-details-section-right{padding:4px 5px 15px 10px;border:none}.plan-details-section-min-height{min-height:70px}}\n"] }]
    }], null, { lowIncomeSubsidyLabel: [{
            type: Input
        }], lowIncomeSubsidyText: [{
            type: Input
        }], lowIncomeSubsidyInformationalText: [{
            type: Input
        }], showSubsidy: [{
            type: Input
        }], extendedDetails: [{
            type: Input
        }], mobile: [{
            type: Input
        }], isComparePage: [{
            type: Input
        }] }); })();

const _c0$17 = function (a0) { return { "gray1-static": a0 }; };
function PlanCostDetailsComponent_div_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$17, !ctx_r2.mobile));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.premiumText, " ");
} }
function PlanCostDetailsComponent_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.planPremiumInitialRange);
} }
function PlanCostDetailsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, PlanCostDetailsComponent_div_1_span_1_Template, 2, 4, "span", 3);
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵtemplate(3, PlanCostDetailsComponent_div_1_span_3_Template, 2, 1, "span", 5);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "currency");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isComparePage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r0.isComparePage ? "mx-auto mx-lg-0" : "col-md-8 plan-details-section-right");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.snpPremiumRangeEnabled && ctx_r0.planPremiumInitialRange);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind4(5, 5, ctx_r0.premium, "USD", "symbol", "1.2-2"), " ", ctx_r0.premiumLabel, " ");
} }
function PlanCostDetailsComponent_div_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$17, !ctx_r4.mobile));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.planFeesLabelText, " ");
} }
function PlanCostDetailsComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, PlanCostDetailsComponent_div_2_span_1_Template, 2, 4, "span", 7);
    i0.ɵɵelementStart(2, "div", 8);
    i0.ɵɵelement(3, "vnext-widget-plan-fees", 9);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.isComparePage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r1.isComparePage ? "mx-auto mx-lg-0" : "col-md-8 plan-details-section-right");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("planFees", ctx_r1.planFees)("isComparePage", ctx_r1.isComparePage)("planFeesIncludedInPremiumTooltipText", ctx_r1.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r1.planFeesNotIncludedInPremiumTooltipText)("notApplicableText", ctx_r1.notApplicableText)("notApplicableTextCustomClass", "Spa_Style_H4 Spa_Style_Bold_Weight");
} }
class PlanCostDetailsComponent {
}
PlanCostDetailsComponent.ɵfac = function PlanCostDetailsComponent_Factory(t) { return new (t || PlanCostDetailsComponent)(); };
PlanCostDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCostDetailsComponent, selectors: [["vnext-plan-cost-details"]], inputs: { premiumText: "premiumText", premiumLabel: "premiumLabel", premium: "premium", mobile: "mobile", isComparePage: "isComparePage", isHCPlan: "isHCPlan", isNonMedicarePlan: "isNonMedicarePlan", planFees: "planFees", planFeesEnabled: "planFeesEnabled", planFeesLabelText: "planFeesLabelText", planFeesIncludedInPremiumTooltipText: "planFeesIncludedInPremiumTooltipText", planFeesNotIncludedInPremiumTooltipText: "planFeesNotIncludedInPremiumTooltipText", notApplicableText: "notApplicableText", snpPremiumRangeEnabled: "snpPremiumRangeEnabled", planPremiumInitialRange: "planPremiumInitialRange" }, decls: 3, vars: 2, consts: [[1, "benefit-details"], ["class", "row mx-0 plan-details-section-min-height", "role", "row", 4, "ngIf"], ["role", "row", 1, "row", "mx-0", "plan-details-section-min-height"], ["role", "cell", "id", "plan-sub-details-cost", "class", "col-md-4 m-0 plan-details-section-left Spa_Style_H5", 3, "ngClass", 4, "ngIf"], ["role", "cell", 1, "premium-value", "Spa_Style_Primary_Color", 3, "ngClass"], [4, "ngIf"], ["role", "cell", "id", "plan-sub-details-cost", 1, "col-md-4", "m-0", "plan-details-section-left", "Spa_Style_H5", 3, "ngClass"], ["role", "cell", "id", "plan-sub-details-fees", "class", "col-md-4 m-0 plan-details-section-left Spa_Style_H5", 3, "ngClass", 4, "ngIf"], ["role", "cell", 1, "Spa_Style_Primary_Color", 3, "ngClass"], [3, "planFees", "isComparePage", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "notApplicableText", "notApplicableTextCustomClass"], ["role", "cell", "id", "plan-sub-details-fees", 1, "col-md-4", "m-0", "plan-details-section-left", "Spa_Style_H5", 3, "ngClass"]], template: function PlanCostDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, PlanCostDetailsComponent_div_1_Template, 6, 10, "div", 1);
        i0.ɵɵtemplate(2, PlanCostDetailsComponent_div_2_Template, 4, 8, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isHCPlan);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.planFeesEnabled && ctx.isNonMedicarePlan && (ctx.planFees == null ? null : ctx.planFees.length));
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, PlanFeesComponent, i1$2.CurrencyPipe], styles: [".plan-details-section-left[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:15px 0 15px 10px}.plan-details-section-right[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-width:0 0 1px;padding:15px 5px 15px 10px}.plan-details-section-min-height[_ngcontent-%COMP%]{min-height:60px}.premium-value[_ngcontent-%COMP%]{font-family:montserrat_bold;font-size:16px}.gray1-static[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray1)}@media (max-width: 767.9px){.plan-details-section-left[_ngcontent-%COMP%]{border-width:0;padding:6px 5px 0 10px}.plan-details-section-right[_ngcontent-%COMP%]{padding:4px 5px 15px 10px;border-bottom:1px solid var(--static-Spa_Style_Accent1)}.premium-value[_ngcontent-%COMP%]{font-family:montserrat_semibold}.plan-details-section-min-height[_ngcontent-%COMP%]{min-height:70px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCostDetailsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-cost-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"benefit-details\">\r\n  <div *ngIf=\"!isHCPlan\" class=\"row mx-0 plan-details-section-min-height\" role=\"row\">\r\n    <span\r\n      role=\"cell\"\r\n      id=\"plan-sub-details-cost\"\r\n      class=\"col-md-4 m-0 plan-details-section-left Spa_Style_H5\"\r\n      [ngClass]=\"{ 'gray1-static': !mobile }\"\r\n      *ngIf=\"!isComparePage\"\r\n    >\r\n      {{ premiumText }}\r\n    </span>\r\n    <div\r\n      role=\"cell\"\r\n      class=\"premium-value Spa_Style_Primary_Color\"\r\n      [ngClass]=\"isComparePage ? 'mx-auto mx-lg-0' : 'col-md-8 plan-details-section-right'\"\r\n    >\r\n      <span *ngIf=\"snpPremiumRangeEnabled && planPremiumInitialRange\">{{ planPremiumInitialRange }}</span>\r\n      {{ premium | currency : 'USD' : 'symbol' : '1.2-2' }} {{ premiumLabel }}\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"planFeesEnabled && isNonMedicarePlan && planFees?.length\" class=\"row mx-0 plan-details-section-min-height\" role=\"row\">\r\n    <span\r\n      role=\"cell\"\r\n      id=\"plan-sub-details-fees\"\r\n      class=\"col-md-4 m-0 plan-details-section-left Spa_Style_H5\"\r\n      [ngClass]=\"{ 'gray1-static': !mobile }\"\r\n      *ngIf=\"!isComparePage\"\r\n    >\r\n      {{ planFeesLabelText }}\r\n    </span>\r\n    <div role=\"cell\" class=\"Spa_Style_Primary_Color\" [ngClass]=\"isComparePage ? 'mx-auto mx-lg-0' : 'col-md-8 plan-details-section-right'\">\r\n      <vnext-widget-plan-fees\r\n        [planFees]=\"planFees\"\r\n        [isComparePage]=\"isComparePage\"\r\n        [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n        [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n        [notApplicableText]=\"notApplicableText\"\r\n        [notApplicableTextCustomClass]=\"'Spa_Style_H4 Spa_Style_Bold_Weight'\"\r\n      ></vnext-widget-plan-fees>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".plan-details-section-left{border-right:1px solid var(--static-Spa_Style_Accent1);border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:15px 0 15px 10px}.plan-details-section-right{border:1px solid var(--static-Spa_Style_Accent1);border-width:0 0 1px;padding:15px 5px 15px 10px}.plan-details-section-min-height{min-height:60px}.premium-value{font-family:montserrat_bold;font-size:16px}.gray1-static{background-color:var(--static-Spa_Style_Gray1)}@media (max-width: 767.9px){.plan-details-section-left{border-width:0;padding:6px 5px 0 10px}.plan-details-section-right{padding:4px 5px 15px 10px;border-bottom:1px solid var(--static-Spa_Style_Accent1)}.premium-value{font-family:montserrat_semibold}.plan-details-section-min-height{min-height:70px}}\n"] }]
    }], null, { premiumText: [{
            type: Input
        }], premiumLabel: [{
            type: Input
        }], premium: [{
            type: Input
        }], mobile: [{
            type: Input
        }], isComparePage: [{
            type: Input
        }], isHCPlan: [{
            type: Input
        }], isNonMedicarePlan: [{
            type: Input
        }], planFees: [{
            type: Input
        }], planFeesEnabled: [{
            type: Input
        }], planFeesLabelText: [{
            type: Input
        }], planFeesIncludedInPremiumTooltipText: [{
            type: Input
        }], planFeesNotIncludedInPremiumTooltipText: [{
            type: Input
        }], notApplicableText: [{
            type: Input
        }], snpPremiumRangeEnabled: [{
            type: Input
        }], planPremiumInitialRange: [{
            type: Input
        }] }); })();

function PlanDetailsCardComponent_div_0_vnext_widget_plan_card_label_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-plan-card-label", 17);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("plan", ctx_r8.plan)("customClass", "col-5 col-sm-3 col-md-7")("currentPlanText", ctx_r8.currentPlanText)("nextYearPlanText", ctx_r8.nextYearPlanText)("optionOneText", ctx_r8.optionOneText)("optionTwoText", ctx_r8.optionTwoText)("displayOptionLabels", ctx_r8.displayOptionLabels)("disableNextYearDisplay", ctx_r8.memberHasOptionsDefined && ctx_r8.displayOptionLabels)("nonCommissionableText", ctx_r8.nonCommissionableText)("isNonCommissionableFlagCheckEnabled", ctx_r8.isNonCommissionableFlagCheckEnabled);
} }
function PlanDetailsCardComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14)(2, "div", 15);
    i0.ɵɵtemplate(3, PlanDetailsCardComponent_div_0_vnext_widget_plan_card_label_3_Template, 1, 10, "vnext-widget-plan-card-label", 16);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0.planTypeLoading && ctx_r0.planTypeLoaded);
} }
function PlanDetailsCardComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 18);
    i0.ɵɵelement(2, "vnext-plan-logo", 19);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("alternateText", ctx_r1.plan.logo2Description)("imageSrc", ctx_r1.planLogo)("classNames", "plan-logo")("planLogoSize", ctx_r1.planLogoSize);
} }
function PlanDetailsCardComponent_h2_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", ctx_r2.plan.carrierName, " ", ctx_r2.plan.planName, "");
} }
function PlanDetailsCardComponent_h2_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.plan.planName);
} }
function PlanDetailsCardComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelement(1, "vnext-star-rating", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("starRating", ctx_r4.plan.planRating)("ratingValueDescription", ctx_r4.plan.planRatingValueDescription)("showLowPerformanceIndicator", ctx_r4.plan.isLowPerformingPlan);
} }
function PlanDetailsCardComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23)(1, "vnext-link", 24);
    i0.ɵɵlistener("click", function PlanDetailsCardComponent_div_12_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.quoteClick()); })("keyup.enter", function PlanDetailsCardComponent_div_12_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.quoteClick()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r5.quoteLinkText);
} }
function PlanDetailsCardComponent_ng_template_13_ng_container_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r18.planPremiumInitialRange);
} }
function PlanDetailsCardComponent_ng_template_13_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanDetailsCardComponent_ng_template_13_ng_container_1_span_1_Template, 2, 1, "span", 32);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "currency");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.snpPremiumRangeEnabled && ctx_r12.planPremiumInitialRange);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, ctx_r12.planTotalPremium || 0), " ");
} }
function PlanDetailsCardComponent_ng_template_13_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-plan-fees-tooltip", 33);
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("planFees", ctx_r14.plan.fees)("planTotalPremium", ctx_r14.planTotalPremium || 0)("planFeesTooltipText", ctx_r14.planFeesTooltipText)("planFeesIncludedInPremiumTooltipText", ctx_r14.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r14.planFeesNotIncludedInPremiumTooltipText)("customClass", "inline-block-sm-layout")("tooltipContainer", !ctx_r14.stickyMiniCartEnabled ? "body" : undefined);
} }
const _c0$16 = function (a0, a1) { return { "col-sm-3": a0, "col-sm-2": a1 }; };
function PlanDetailsCardComponent_ng_template_13_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34)(1, "span", 35);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c0$16, !ctx_r15.showPlanFees, ctx_r15.showPlanFees));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r15.monthlyPremiumText, " ");
} }
function PlanDetailsCardComponent_ng_template_13_vnext_shopping_cart_button_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-shopping-cart-button", 36);
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("plan", ctx_r16.plan);
} }
function PlanDetailsCardComponent_ng_template_13_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 37)(1, "button", 38);
    i0.ɵɵlistener("click", function PlanDetailsCardComponent_ng_template_13_div_7_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r19.planFacade.openSendQuoteModal(ctx_r19.plan)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r17.sendQuoteButtonText, " ");
} }
const _c1$s = function (a0, a1) { return { "col-sm-3": a0, "col-sm-4": a1 }; };
function PlanDetailsCardComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, PlanDetailsCardComponent_ng_template_13_ng_container_1_Template, 4, 4, "ng-container", 26);
    i0.ɵɵtemplate(2, PlanDetailsCardComponent_ng_template_13_ng_template_2_Template, 1, 7, "ng-template", null, 27, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PlanDetailsCardComponent_ng_template_13_div_4_Template, 3, 5, "div", 28);
    i0.ɵɵelementStart(5, "div", 29);
    i0.ɵɵtemplate(6, PlanDetailsCardComponent_ng_template_13_vnext_shopping_cart_button_6_Template, 1, 1, "vnext-shopping-cart-button", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, PlanDetailsCardComponent_ng_template_13_div_7_Template, 3, 1, "div", 31);
} if (rf & 2) {
    const _r13 = i0.ɵɵreference(3);
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c1$s, !ctx_r7.showPlanFees || ctx_r7.plan.planType === ctx_r7.planType.HC, ctx_r7.showPlanFees && ctx_r7.plan.planType !== ctx_r7.planType.HC));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r7.showPlanFees)("ngIfElse", _r13);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r7.plan.planType === ctx_r7.planType.HC);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r7.planTypeLoading && ctx_r7.planTypeLoaded && ctx_r7.showAddToCartButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r7.isAncillaryPlan && ctx_r7.planFacade.isAddToQuoteAvailable(ctx_r7.plan.planTypeAbbreviation, ctx_r7.plan) && !ctx_r7.isHCPlan);
} }
const _c2$j = function (a0, a1, a2) { return { "current-plan-card-border Spa_Style_Accent6_Border": a0, "next-year-plan-card-border Spa_Style_Primary_Link_Border": a1, "plan-card": a2 }; };
const _c3$a = function (a0, a1, a2) { return { "col-sm-5": a0, "col-sm-3": a1, "col-sm-4": a2 }; };
class PlanDetailsCardComponent {
    constructor(cdr, planFacade, localeService, plansService) {
        this.cdr = cdr;
        this.planFacade = planFacade;
        this.localeService = localeService;
        this.plansService = plansService;
        this.planTotalPremium = 0;
        this.subscriptions = new Subscription();
        this.isAncillaryPlan = false;
        this.isHCPlan = false;
        this.planType = PlanType;
        this.planTypeAbbreviation = PlanTypeAbbreviation;
        this.memberHasOptionsDefined = false;
    }
    ngOnChanges(changes) {
        const { plan, planTotalPremium, snpPremiumRangeEnabled } = changes;
        if ((plan && !_isEqual(plan.previousValue, plan.currentValue)) ||
            (planTotalPremium && !_isEqual(planTotalPremium.previousValue, planTotalPremium.currentValue)) ||
            (snpPremiumRangeEnabled && !_isEqual(snpPremiumRangeEnabled.previousValue, snpPremiumRangeEnabled.currentValue))) {
            if (this.snpPremiumRangeEnabled) {
                this.planPremiumInitialRange = this.planFacade.getPlanPremiumRange(this.plan, this.planTotalPremium);
            }
        }
    }
    ngOnInit() {
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe(locale => {
            this.premiumLabel = this.planFacade.getPremiumLabel();
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.planFacade.hasPremium$(this.plan).subscribe(hasPremium => {
            this.hasPremium = hasPremium;
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.plansService.getPlansStateIsLoading$(this.plan.planType).subscribe(loading => {
            this.planTypeLoading = loading;
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.plansService.getPlansStateIsLoaded$(this.plan.planType).subscribe(loaded => {
            this.planTypeLoaded = loaded;
            this.cdr.markForCheck();
        }));
        this.isAncillaryPlan = this.isDentalPlan() || this.isVisionPlan();
        this.isHCPlan = this.planFacade.isHCPlan(this.plan);
        this.memberHasOptionsDefined = this.planFacade.memberHasOptionsDefined();
        this.showAddToCartButton = this.planFacade.isAddToCartAvailableForPlan(this.plan);
        this.showPlanFees = this.planFeesEnabled && this.plan.fees?.length > 0;
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    quoteClick() {
        if (this.plan.planTypeAbbreviation === PlanTypeAbbreviation.MEDIGAP) {
            this.planFacade.navigateToMedSupForm(this.plan);
        }
        else if (this.isAncillaryPlan) {
            this.planFacade.navigateToDentalVisionForm(this.plan);
        }
    }
    get planLogo() {
        return this.planFacade.getPlanLogoUrl(this.plan);
    }
    get showPlanLogo() {
        return this.planLogo && this.showLogo;
    }
    isDentalPlan() {
        return this.planFacade.isDentalPlan(this.plan);
    }
    isVisionPlan() {
        return this.planFacade.isVisionPlan(this.plan);
    }
}
PlanDetailsCardComponent.ɵfac = function PlanDetailsCardComponent_Factory(t) { return new (t || PlanDetailsCardComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.PlansService)); };
PlanDetailsCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanDetailsCardComponent, selectors: [["vnext-widget-plan-details-card"]], inputs: { plan: "plan", planTotalPremium: "planTotalPremium", quoteLinkText: "quoteLinkText", showLogo: "showLogo", currentPlanText: "currentPlanText", nextYearPlanText: "nextYearPlanText", isCurrentYearPlanExist: "isCurrentYearPlanExist", sendQuoteButtonText: "sendQuoteButtonText", optionOneText: "optionOneText", optionTwoText: "optionTwoText", displayOptionLabels: "displayOptionLabels", hidePlanCardLabel: "hidePlanCardLabel", monthlyPremiumText: "monthlyPremiumText", planLogoSize: "planLogoSize", stickyMiniCartEnabled: "stickyMiniCartEnabled", planFeesEnabled: "planFeesEnabled", planFeesTooltipText: "planFeesTooltipText", planFeesIncludedInPremiumTooltipText: "planFeesIncludedInPremiumTooltipText", planFeesNotIncludedInPremiumTooltipText: "planFeesNotIncludedInPremiumTooltipText", snpPremiumRangeEnabled: "snpPremiumRangeEnabled", nonCommissionableText: "nonCommissionableText", isNonCommissionableFlagCheckEnabled: "isNonCommissionableFlagCheckEnabled" }, features: [i0.ɵɵNgOnChangesFeature], decls: 15, vars: 19, consts: [["class", "p-0", 4, "ngIf"], [1, "px-2", "mb-2", 3, "id", "ngClass"], [1, "row", "mb-3", "mb-md-2"], ["class", "col-12", 4, "ngIf"], [1, "col-12", "text-center", "text-sm-left", "text-md-center", "mt-1", "no-translate-block"], [3, "ngSwitch"], ["class", "plan-title Spa_Style_H4 my-2", 4, "ngSwitchCase"], ["class", "plan-title Spa_Style_H4 my-2", 4, "ngSwitchDefault"], [1, "row", "align-items-center"], ["class", "col-12 text-center text-sm-left text-md-center mt-1", 4, "ngIf"], [1, "col-12", "col-md-12", "text-center", "text-sm-left", "text-md-center", "mt-0", "mt-sm-2", "mt-md-3", "Spa_Style_Paragraph", 3, "ngClass"], ["class", "col-12 col-sm-7 col-md-12 text-center text-sm-right text-md-center mt-sm-2 mt-md-0", 4, "ngIf", "ngIfElse"], ["showPremium", ""], [1, "p-0"], [1, "row"], [1, "col-12"], [3, "plan", "customClass", "currentPlanText", "nextYearPlanText", "optionOneText", "optionTwoText", "displayOptionLabels", "disableNextYearDisplay", "nonCommissionableText", "isNonCommissionableFlagCheckEnabled", 4, "ngIf"], [3, "plan", "customClass", "currentPlanText", "nextYearPlanText", "optionOneText", "optionTwoText", "displayOptionLabels", "disableNextYearDisplay", "nonCommissionableText", "isNonCommissionableFlagCheckEnabled"], [1, "image-responsive", "text-center", "mt-2", "mb-1"], [3, "alternateText", "imageSrc", "classNames", "planLogoSize"], [1, "plan-title", "Spa_Style_H4", "my-2"], [1, "col-12", "text-center", "text-sm-left", "text-md-center", "mt-1"], [3, "starRating", "ratingValueDescription", "showLowPerformanceIndicator"], [1, "col-12", "col-sm-7", "col-md-12", "text-center", "text-sm-right", "text-md-center", "mt-sm-2", "mt-md-0"], [3, "title", "click", "keyup.enter"], [1, "col-12", "col-md-12", "text-center", "text-sm-right", "text-md-center", "pl-0", "mt-sm-2", "mt-md-0", "Spa_Style_CostPremiumSmall", 3, "ngClass"], [4, "ngIf", "ngIfElse"], ["showPremiumWithFees", ""], ["class", "col-12 col-md-12 mt-2 text-center text-sm-right text-md-center", 3, "ngClass", 4, "ngIf"], [1, "col-12", "col-sm-4", "col-md-12", "mt-2", "mb-2"], [3, "plan", 4, "ngIf"], ["class", "col-12 col-sm-4 col-md-12 offset-sm-8 offset-md-0 mb-2", 4, "ngIf"], [4, "ngIf"], [3, "planFees", "planTotalPremium", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "customClass", "tooltipContainer"], [1, "col-12", "col-md-12", "mt-2", "text-center", "text-sm-right", "text-md-center", 3, "ngClass"], [1, "Spa_Style_Note"], [3, "plan"], [1, "col-12", "col-sm-4", "col-md-12", "offset-sm-8", "offset-md-0", "mb-2"], [1, "btn", "Spa_Style_SecondaryButton", "btn-block", 3, "click"]], template: function PlanDetailsCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanDetailsCardComponent_div_0_Template, 4, 1, "div", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "header", 2);
        i0.ɵɵtemplate(3, PlanDetailsCardComponent_div_3_Template, 3, 4, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelementContainerStart(5, 5);
        i0.ɵɵtemplate(6, PlanDetailsCardComponent_h2_6_Template, 2, 2, "h2", 6);
        i0.ɵɵtemplate(7, PlanDetailsCardComponent_h2_7_Template, 2, 1, "h2", 7);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "div", 8);
        i0.ɵɵtemplate(9, PlanDetailsCardComponent_div_9_Template, 2, 3, "div", 9);
        i0.ɵɵelementStart(10, "div", 10);
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, PlanDetailsCardComponent_div_12_Template, 2, 1, "div", 11);
        i0.ɵɵtemplate(13, PlanDetailsCardComponent_ng_template_13_Template, 8, 9, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r6 = i0.ɵɵreference(14);
        i0.ɵɵproperty("ngIf", !ctx.hidePlanCardLabel);
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate1("id", "PlanCard_", ctx.plan.id, "");
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(11, _c2$j, !ctx.hidePlanCardLabel && !ctx.planTypeLoading && ctx.planTypeLoaded && ctx.plan.isCurrentYearPlan, !ctx.hidePlanCardLabel && !ctx.planTypeLoading && ctx.planTypeLoaded && ctx.plan.isNextYearPlan && !ctx.plan.isPlanRolloverTerminated, ctx.hidePlanCardLabel || ctx.planTypeLoading || !ctx.planTypeLoaded || !ctx.plan.isCurrentYearPlan && (!ctx.plan.isNextYearPlan || ctx.plan.isNextYearPlan && ctx.plan.isPlanRolloverTerminated)));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showPlanLogo && ctx.planLogo);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngSwitch", ctx.plan.planTypeAbbreviation);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.planTypeAbbreviation.HC);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.isAncillaryPlan);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(15, _c3$a, !ctx.showPlanFees, ctx.showPlanFees && ctx.plan.planType === ctx.planType.HC, ctx.showPlanFees && ctx.plan.planType !== ctx.planType.HC));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.premiumLabel, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.hasPremium)("ngIfElse", _r6);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, i1$2.NgSwitchDefault, LinkComponent, StarRatingComponent, ShoppingCartButtonComponent, PlanFeesTooltipComponent, PlanCardLabelComponent, PlanLogoComponent, i1$2.CurrencyPipe], styles: [".plan-card[_ngcontent-%COMP%]{border-width:1px;border-style:solid;border-color:var(--static-Spa_Style_Accent1);border-radius:4px}.current-plan-card-border[_ngcontent-%COMP%], .next-year-plan-card-border[_ngcontent-%COMP%]{border-width:2px;border-style:solid}.current-plan-text[_ngcontent-%COMP%], .next-year-plan-text[_ngcontent-%COMP%]{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.plan-not-available-text[_ngcontent-%COMP%]{padding-top:6px;padding-bottom:4px}@media (max-width: 575.98px){.plan-not-available-text[_ngcontent-%COMP%]{padding-top:2px;padding-bottom:3px}.plan-card-button[_ngcontent-%COMP%]{margin:8px 0}}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], PlanDetailsCardComponent.prototype, "quoteClick", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanDetailsCardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-details-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"!hidePlanCardLabel\" class=\"p-0\">\r\n  <div class=\"row\">\r\n    <div class=\"col-12\">\r\n      <vnext-widget-plan-card-label\r\n        *ngIf=\"!planTypeLoading && planTypeLoaded\"\r\n        [plan]=\"plan\"\r\n        [customClass]=\"'col-5 col-sm-3 col-md-7'\"\r\n        [currentPlanText]=\"currentPlanText\"\r\n        [nextYearPlanText]=\"nextYearPlanText\"\r\n        [optionOneText]=\"optionOneText\"\r\n        [optionTwoText]=\"optionTwoText\"\r\n        [displayOptionLabels]=\"displayOptionLabels\"\r\n        [disableNextYearDisplay]=\"memberHasOptionsDefined && displayOptionLabels\"\r\n        [nonCommissionableText]=\"nonCommissionableText\"\r\n        [isNonCommissionableFlagCheckEnabled]=\"isNonCommissionableFlagCheckEnabled\"\r\n      ></vnext-widget-plan-card-label>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div\r\n  class=\"px-2 mb-2\"\r\n  id=\"PlanCard_{{ plan.id }}\"\r\n  [ngClass]=\"{\r\n    'current-plan-card-border Spa_Style_Accent6_Border': !hidePlanCardLabel && !planTypeLoading && planTypeLoaded && plan.isCurrentYearPlan,\r\n    'next-year-plan-card-border Spa_Style_Primary_Link_Border':\r\n      !hidePlanCardLabel && !planTypeLoading && planTypeLoaded && plan.isNextYearPlan && !plan.isPlanRolloverTerminated,\r\n    'plan-card':\r\n      hidePlanCardLabel ||\r\n      planTypeLoading ||\r\n      !planTypeLoaded ||\r\n      (!plan.isCurrentYearPlan && (!plan.isNextYearPlan || (plan.isNextYearPlan && plan.isPlanRolloverTerminated)))\r\n  }\"\r\n>\r\n  <header class=\"row mb-3 mb-md-2\">\r\n    <div class=\"col-12\" *ngIf=\"showPlanLogo && planLogo\">\r\n      <div class=\"image-responsive text-center mt-2 mb-1\">\r\n        <vnext-plan-logo\r\n          [alternateText]=\"plan.logo2Description\"\r\n          [imageSrc]=\"planLogo\"\r\n          [classNames]=\"'plan-logo'\"\r\n          [planLogoSize]=\"planLogoSize\"\r\n        ></vnext-plan-logo>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-12 text-center text-sm-left text-md-center mt-1 no-translate-block\">\r\n      <ng-container [ngSwitch]=\"plan.planTypeAbbreviation\">\r\n        <h2 *ngSwitchCase=\"planTypeAbbreviation.HC\" class=\"plan-title Spa_Style_H4 my-2\">{{ plan.carrierName }} {{ plan.planName }}</h2>\r\n\r\n        <h2 *ngSwitchDefault class=\"plan-title Spa_Style_H4 my-2\">{{ plan.planName }}</h2>\r\n      </ng-container>\r\n    </div>\r\n  </header>\r\n  <div class=\"row align-items-center\">\r\n    <div class=\"col-12 text-center text-sm-left text-md-center mt-1\" *ngIf=\"!isAncillaryPlan\">\r\n      <vnext-star-rating\r\n        [starRating]=\"plan.planRating\"\r\n        [ratingValueDescription]=\"plan.planRatingValueDescription\"\r\n        [showLowPerformanceIndicator]=\"plan.isLowPerformingPlan\"\r\n      ></vnext-star-rating>\r\n    </div>\r\n    <div\r\n      class=\"col-12 col-md-12 text-center text-sm-left text-md-center mt-0 mt-sm-2 mt-md-3 Spa_Style_Paragraph\"\r\n      [ngClass]=\"{\r\n        'col-sm-5': !showPlanFees,\r\n        'col-sm-3': showPlanFees && plan.planType === planType.HC,\r\n        'col-sm-4': showPlanFees && plan.planType !== planType.HC\r\n      }\"\r\n    >\r\n      {{ premiumLabel }}\r\n    </div>\r\n    <div class=\"col-12 col-sm-7 col-md-12 text-center text-sm-right text-md-center mt-sm-2 mt-md-0\" *ngIf=\"!hasPremium; else showPremium\">\r\n      <vnext-link [title]=\"quoteLinkText\" (click)=\"quoteClick()\" (keyup.enter)=\"quoteClick()\"></vnext-link>\r\n    </div>\r\n    <ng-template #showPremium>\r\n      <div\r\n        class=\"col-12 col-md-12 text-center text-sm-right text-md-center pl-0 mt-sm-2 mt-md-0 Spa_Style_CostPremiumSmall\"\r\n        [ngClass]=\"{\r\n          'col-sm-3': !showPlanFees || plan.planType === planType.HC,\r\n          'col-sm-4': showPlanFees && plan.planType !== planType.HC\r\n        }\"\r\n      >\r\n        <ng-container *ngIf=\"!showPlanFees; else showPremiumWithFees\">\r\n          <span *ngIf=\"snpPremiumRangeEnabled && planPremiumInitialRange\">{{ planPremiumInitialRange }}</span\r\n          >{{ planTotalPremium || 0 | currency }}\r\n        </ng-container>\r\n\r\n        <ng-template #showPremiumWithFees>\r\n          <vnext-widget-plan-fees-tooltip\r\n            [planFees]=\"plan.fees\"\r\n            [planTotalPremium]=\"planTotalPremium || 0\"\r\n            [planFeesTooltipText]=\"planFeesTooltipText\"\r\n            [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n            [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n            [customClass]=\"'inline-block-sm-layout'\"\r\n            [tooltipContainer]=\"!stickyMiniCartEnabled ? 'body' : undefined\"\r\n          ></vnext-widget-plan-fees-tooltip>\r\n        </ng-template>\r\n      </div>\r\n\r\n      <div\r\n        *ngIf=\"plan.planType === planType.HC\"\r\n        class=\"col-12 col-md-12 mt-2 text-center text-sm-right text-md-center\"\r\n        [ngClass]=\"{\r\n          'col-sm-3': !showPlanFees,\r\n          'col-sm-2': showPlanFees\r\n        }\"\r\n      >\r\n        <span class=\"Spa_Style_Note\">\r\n          {{ monthlyPremiumText }}\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"col-12 col-sm-4 col-md-12 mt-2 mb-2\">\r\n        <vnext-shopping-cart-button\r\n          *ngIf=\"!planTypeLoading && planTypeLoaded && showAddToCartButton\"\r\n          [plan]=\"plan\"\r\n        ></vnext-shopping-cart-button>\r\n      </div>\r\n      <div\r\n        class=\"col-12 col-sm-4 col-md-12 offset-sm-8 offset-md-0 mb-2\"\r\n        *ngIf=\"!isAncillaryPlan && planFacade.isAddToQuoteAvailable(plan.planTypeAbbreviation, plan) && !isHCPlan\"\r\n      >\r\n        <button class=\"btn Spa_Style_SecondaryButton btn-block\" (click)=\"planFacade.openSendQuoteModal(plan)\">\r\n          {{ sendQuoteButtonText }}\r\n        </button>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n</div>\r\n", styles: [".plan-card{border-width:1px;border-style:solid;border-color:var(--static-Spa_Style_Accent1);border-radius:4px}.current-plan-card-border,.next-year-plan-card-border{border-width:2px;border-style:solid}.current-plan-text,.next-year-plan-text{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.plan-not-available-text{padding-top:6px;padding-bottom:4px}@media (max-width: 575.98px){.plan-not-available-text{padding-top:2px;padding-bottom:3px}.plan-card-button{margin:8px 0}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: PlanFacade }, { type: i1.LocaleService }, { type: i1.PlansService }]; }, { plan: [{
            type: Input
        }], planTotalPremium: [{
            type: Input
        }], quoteLinkText: [{
            type: Input
        }], showLogo: [{
            type: Input
        }], currentPlanText: [{
            type: Input
        }], nextYearPlanText: [{
            type: Input
        }], isCurrentYearPlanExist: [{
            type: Input
        }], sendQuoteButtonText: [{
            type: Input
        }], optionOneText: [{
            type: Input
        }], optionTwoText: [{
            type: Input
        }], displayOptionLabels: [{
            type: Input
        }], hidePlanCardLabel: [{
            type: Input
        }], monthlyPremiumText: [{
            type: Input
        }], planLogoSize: [{
            type: Input
        }], stickyMiniCartEnabled: [{
            type: Input
        }], planFeesEnabled: [{
            type: Input
        }], planFeesTooltipText: [{
            type: Input
        }], planFeesIncludedInPremiumTooltipText: [{
            type: Input
        }], planFeesNotIncludedInPremiumTooltipText: [{
            type: Input
        }], snpPremiumRangeEnabled: [{
            type: Input
        }], nonCommissionableText: [{
            type: Input
        }], isNonCommissionableFlagCheckEnabled: [{
            type: Input
        }], quoteClick: [] }); })();

function PlanCostSectionComponent_div_0_ng_container_1_span_1_span_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const cost_r1 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r13.planFacade.isTotalEstimatedCostAnnually$()) ? cost_r1.label : cost_r1.label2);
} }
function PlanCostSectionComponent_div_0_ng_container_1_span_1_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, PlanCostSectionComponent_div_0_ng_container_1_span_1_span_2_span_1_Template, 3, 3, "span", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_PlanDetails_Health_Cost_Text");
} }
function PlanCostSectionComponent_div_0_ng_container_1_span_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const cost_r1 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r9.planFacade.isTotalEstimatedCostAnnually$()) ? cost_r1.label : cost_r1.label2);
} }
function PlanCostSectionComponent_div_0_ng_container_1_span_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "span", 15);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const cost_r1 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(cost_r1.label);
} }
function PlanCostSectionComponent_div_0_ng_container_1_span_1_span_8_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 16)(1, "vnext-link", 17);
    i0.ɵɵlistener("click", function PlanCostSectionComponent_div_0_ng_container_1_span_1_span_8_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r19); const cost_r1 = i0.ɵɵnextContext(3).$implicit; const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.navigateOrOpenModalByPage(cost_r1.title)); })("keyup.enter", function PlanCostSectionComponent_div_0_ng_container_1_span_1_span_8_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r19); const cost_r1 = i0.ɵɵnextContext(3).$implicit; const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.navigateOrOpenModalByPage(cost_r1.title)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const cost_r1 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r11.costAddEditLinkText)("makeInlineBlock", true)("alwaysUnderlined", true)("linkTarget", "_self")("customClass", "Spa_Style_Link Spa_Style_Smaller_Font")("role", ctx_r11.linkRoles.LINK);
    i0.ɵɵattribute("aria-label", ctx_r11.getAriaLabelValue(cost_r1.title));
} }
function PlanCostSectionComponent_div_0_ng_container_1_span_1_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const totalEstimatedCostEffectiveDate_r23 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" (", totalEstimatedCostEffectiveDate_r23, ") ");
} }
const _c0$15 = function (a0) { return { Spa_Style_Cost_Background: a0 }; };
function PlanCostSectionComponent_div_0_ng_container_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵtemplate(2, PlanCostSectionComponent_div_0_ng_container_1_span_1_span_2_Template, 2, 1, "span", 2);
    i0.ɵɵtemplate(3, PlanCostSectionComponent_div_0_ng_container_1_span_1_span_3_Template, 3, 3, "span", 9);
    i0.ɵɵtemplate(4, PlanCostSectionComponent_div_0_ng_container_1_span_1_span_4_Template, 3, 1, "span", 2);
    i0.ɵɵelementStart(5, "span", 10)(6, "span", 11);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, PlanCostSectionComponent_div_0_ng_container_1_span_1_span_8_Template, 2, 7, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, PlanCostSectionComponent_div_0_ng_container_1_span_1_span_9_Template, 2, 1, "span", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const cost_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c0$15, i0.ɵɵpipeBind1(1, 7, ctx_r3.mobile$) && cost_r1.title === ctx_r3.planDetailsCostLabels.TOTAL_ESTIMATED_COST));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", cost_r1.title === ctx_r3.planDetailsCostLabels.HEALTH_COST);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(cost_r1.title === ctx_r3.planDetailsCostLabels.HEALTH_COST));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", cost_r1.title === ctx_r3.planDetailsCostLabels.PLAN_FEES);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.getCostSubText(cost_r1));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", cost_r1.title === ctx_r3.planDetailsCostLabels.DRUG_COST || cost_r1.title === ctx_r3.planDetailsCostLabels.HEALTH_COST && ctx_r3.healthEnabled && ctx_r3.isHealthCostEstimated);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.planFacade.isLastMonthOfYear() && cost_r1.title === ctx_r3.planDetailsCostLabels.TOTAL_ESTIMATED_COST && ctx_r3.planFacade.getTotalEstimatedCostEffectiveDate());
} }
function PlanCostSectionComponent_div_0_ng_container_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r4.plan.planName);
} }
function PlanCostSectionComponent_div_0_ng_container_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.noCostAvailableText, " ");
} }
function PlanCostSectionComponent_div_0_ng_container_1_ng_template_6_ng_container_1_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "vnext-link", 17);
    i0.ɵɵlistener("click", function PlanCostSectionComponent_div_0_ng_container_1_ng_template_6_ng_container_1_span_1_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r33); const cost_r1 = i0.ɵɵnextContext(4).$implicit; const ctx_r31 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r31.navigateOrOpenModalByPage(cost_r1.title)); })("keyup.enter", function PlanCostSectionComponent_div_0_ng_container_1_ng_template_6_ng_container_1_span_1_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r33); const cost_r1 = i0.ɵɵnextContext(4).$implicit; const ctx_r34 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r34.navigateOrOpenModalByPage(cost_r1.title)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const cost_r1 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r28 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r28.addHealthCostText)("makeInlineBlock", true)("alwaysUnderlined", true)("linkTarget", "_self")("customClass", "Spa_Style_Link Spa_Style_Smaller_Font")("role", ctx_r28.linkRoles.LINK);
    i0.ɵɵattribute("aria-label", ctx_r28.getAriaLabelValue(cost_r1.title));
} }
function PlanCostSectionComponent_div_0_ng_container_1_ng_template_6_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-plan-default-cost", 24);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const cost_r1 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r30 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cost", cost_r1)("isMailOrderSelected", ctx_r30.isMailOrderSelected)("plan", ctx_r30.plan)("costDuration", i0.ɵɵpipeBind1(1, 4, ctx_r30.costDuration$()) ? cost_r1.duration : cost_r1.duration2);
} }
function PlanCostSectionComponent_div_0_ng_container_1_ng_template_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanCostSectionComponent_div_0_ng_container_1_ng_template_6_ng_container_1_span_1_Template, 2, 7, "span", 6);
    i0.ɵɵtemplate(2, PlanCostSectionComponent_div_0_ng_container_1_ng_template_6_ng_container_1_ng_template_2_Template, 2, 6, "ng-template", null, 23, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r29 = i0.ɵɵreference(3);
    const ctx_r25 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r25.isHealthCostEstimated && (!ctx_r25.healthCostEstimatedValue || ctx_r25.healthCostEstimatedValue === ctx_r25.estimateHealthCostFlag.OptOut))("ngIfElse", _r29);
} }
function PlanCostSectionComponent_div_0_ng_container_1_ng_template_6_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-widget-plan-fees", 25);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("planFees", ctx_r26.plan.fees)("isComparePage", ctx_r26.isComparePage)("planFeesIncludedInPremiumTooltipText", ctx_r26.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r26.planFeesNotIncludedInPremiumTooltipText)("notApplicableText", ctx_r26.noCostAvailableText)("notApplicableTextCustomClass", "Spa_Style_H4 Spa_Style_Bold_Weight");
} }
function PlanCostSectionComponent_div_0_ng_container_1_ng_template_6_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-plan-default-cost", 24);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const cost_r1 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r27 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("cost", cost_r1)("isMailOrderSelected", ctx_r27.isMailOrderSelected)("plan", ctx_r27.plan)("costDuration", i0.ɵɵpipeBind1(2, 4, ctx_r27.costDuration$()) ? cost_r1.duration : cost_r1.duration2);
} }
function PlanCostSectionComponent_div_0_ng_container_1_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 20);
    i0.ɵɵtemplate(1, PlanCostSectionComponent_div_0_ng_container_1_ng_template_6_ng_container_1_Template, 4, 2, "ng-container", 21);
    i0.ɵɵtemplate(2, PlanCostSectionComponent_div_0_ng_container_1_ng_template_6_ng_container_2_Template, 2, 6, "ng-container", 21);
    i0.ɵɵtemplate(3, PlanCostSectionComponent_div_0_ng_container_1_ng_template_6_ng_container_3_Template, 3, 6, "ng-container", 22);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const cost_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", cost_r1.title);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r7.planDetailsCostLabels.HEALTH_COST);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r7.planDetailsCostLabels.PLAN_FEES);
} }
const _c1$r = function (a0, a1, a2, a3, a4, a5) { return { "Spa_Style_Cost_Background": a0, "Spa_Style_CostPremiumSmall": a1, "Spa_Style_Bold_Weight": a2, "Spa_Style_Primary_Color": a3, "col-md-8 plan-details-section-right": a4, "w-100": a5 }; };
function PlanCostSectionComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanCostSectionComponent_div_0_ng_container_1_span_1_Template, 10, 11, "span", 3);
    i0.ɵɵelementStart(2, "div", 4)(3, "div");
    i0.ɵɵtemplate(4, PlanCostSectionComponent_div_0_ng_container_1_span_4_Template, 2, 1, "span", 5);
    i0.ɵɵtemplate(5, PlanCostSectionComponent_div_0_ng_container_1_ng_container_5_Template, 2, 1, "ng-container", 6);
    i0.ɵɵtemplate(6, PlanCostSectionComponent_div_0_ng_container_1_ng_template_6_Template, 4, 3, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r6 = i0.ɵɵreference(7);
    const cost_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isComparePage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction6(6, _c1$r, cost_r1.title === ctx_r2.planDetailsCostLabels.TOTAL_ESTIMATED_COST && !ctx_r2.isComparePage, cost_r1.title === ctx_r2.planDetailsCostLabels.TOTAL_ESTIMATED_COST, cost_r1.title !== ctx_r2.planDetailsCostLabels.TOTAL_ESTIMATED_COST, cost_r1.title !== ctx_r2.planDetailsCostLabels.TOTAL_ESTIMATED_COST, !ctx_r2.isComparePage, cost_r1.title === ctx_r2.planDetailsCostLabels.PLAN_FEES));
    i0.ɵɵattribute("role", !ctx_r2.isComparePage ? "cell" : null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.isComparePage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isTotalEstimatedCostAvailable() && cost_r1.title !== ctx_r2.planDetailsCostLabels.PREMIUM)("ngIfElse", _r6);
} }
function PlanCostSectionComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, PlanCostSectionComponent_div_0_ng_container_1_Template, 8, 13, "ng-container", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const cost_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("role", !ctx_r0.isComparePage ? "row" : null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showCost(cost_r1.title));
} }
class PlanCostSectionComponent {
    constructor(planDetailsFacade, planFacade, analyticsService, memberSessionService, modalService, injector, navigationService, guidedHelpModalContextService) {
        this.planDetailsFacade = planDetailsFacade;
        this.planFacade = planFacade;
        this.analyticsService = analyticsService;
        this.memberSessionService = memberSessionService;
        this.modalService = modalService;
        this.injector = injector;
        this.navigationService = navigationService;
        this.guidedHelpModalContextService = guidedHelpModalContextService;
        this.linkRoles = LinkRoles;
        this.estimateHealthCostFlag = EstimateHealthCostFlag;
        this.options = {
            ariaLabelledBy: 'modalHeaderTitle',
            centered: true,
            injector: this.injector,
            windowClass: 'modal--lg'
        };
        this.planDetailsCostLabels = PlanDetailsCostLabels;
    }
    ngOnInit() {
        this.isHealthCostEstimated = this.planFacade.isHealthCostEstimated();
        this.healthCostEstimatedValue = this.memberSessionService.getEstimateHealthCost();
    }
    getAriaLabelValue(title) {
        return title === PlanDetailsCostLabels.DRUG_COST
            ? this.drugCostAddEditLinkDescription
            : title === PlanDetailsCostLabels.HEALTH_COST && this.healthEnabled
                ? this.healthCostAddEditLinkDescription
                : '';
    }
    navigateOrOpenModalByPage(label) {
        const pageTag = this.planFacade.getPageTag(label);
        if (pageTag === PageTags.GUIDED_HELP_PRESCRIPTIONS) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_DRUGS);
            this.openGuidedHelp(pageTag);
        }
        else if (pageTag === PageTags.GUIDED_HELP_PHARMACY_SEARCH) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_PHARMACY);
            this.openGuidedHelp(pageTag);
        }
        else if (pageTag === PageTags.GUIDED_HELP_HEALTH) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_HEALTH);
            if (this.preferencesBannerEnabled) {
                const healthModal = this.modalService.open(HealthModalComponent, this.options);
                healthModal.componentInstance.title = this.modalHeaderHealthText;
                healthModal.componentInstance.cancelButton = this.closeButtonText;
                healthModal.componentInstance.healthCostsBenefits = this.healthCostsBenefits;
                healthModal.componentInstance.healthCostsBodyText = this.healthCostsBodyText;
                healthModal.componentInstance.healthCostsBenefitsBodyText = this.healthCostsBenefitsBodyText;
                healthModal.componentInstance.healthCostsBenefitsTableHeader = this.healthCostsBenefitsTableHeader;
                healthModal.componentInstance.healthCostsUsageTableHeader = this.healthCostsUsageTableHeader;
                healthModal.componentInstance.healthCostsDaysTableHeader = this.healthCostsDaysTableHeader;
                healthModal.componentInstance.saveFailedText = this.saveFailedText;
                healthModal.componentInstance.saveSuccessText = this.saveSuccessText;
                healthModal.componentInstance.healthCostsUpdateAnswersText = this.healthCostsUpdateAnswersText;
                healthModal.componentInstance.healthCostsSaveAnswersText = this.healthCostsSaveAnswersText;
                healthModal.componentInstance.healthCostsRestoreDefaultsText = this.healthCostsRestoreDefaultsText;
                healthModal.componentInstance.healthCostsCustomizationEnabled = this.healthCostsCustomizationEnabled;
                healthModal.componentInstance.healthAgeQuestionText = this.healthAgeQuestionText;
                healthModal.componentInstance.healthSliderHeader1Text = this.healthSliderHeader1Text;
                healthModal.componentInstance.healthSliderHeader2Text = this.healthSliderHeader2Text;
                healthModal.componentInstance.healthSliderHeader3Text = this.healthSliderHeader3Text;
                healthModal.componentInstance.healthSliderBody1 = this.healthSliderBody1;
                healthModal.componentInstance.healthSliderBody2 = this.healthSliderBody2;
                healthModal.componentInstance.healthSliderBody3 = this.healthSliderBody3;
                healthModal.componentInstance.healthSliderLabelText = this.healthSliderLabelText;
                healthModal.componentInstance.healthModalView1HeadingText = this.healthModalView1HeadingText;
                healthModal.componentInstance.healthModalView1IntroText = this.healthModalView1IntroText;
            }
            else {
                this.navigationService.navigateByPageTag(PageTags.GUIDED_HELP_HEALTH);
            }
        }
    }
    openGuidedHelp(pageTag) {
        if (this.preferencesBannerEnabled) {
            this.guidedHelpModalContextService.openGuidedHelpModal(pageTag);
        }
        else {
            this.navigationService.navigateByPageTag(pageTag);
        }
    }
    getCostSubText(planCostDetails) {
        return this.planFacade.getCostSubText(planCostDetails, this.plan, this.selectedPharmacy);
    }
    get mobile$() {
        return this.planDetailsFacade.mobile$;
    }
    showCost(title) {
        // We skip this row only for Plan Details because we already display the plan fees in the plan-cost-details component.
        // Otherwise, it will be displayed twice in the Costs section.
        if (!this.isComparePage && title === PlanDetailsCostLabels.PLAN_FEES) {
            return false;
        }
        return this.planFacade.showCost(title);
    }
    isTotalEstimatedCostAvailable() {
        // We skip this validation for Hospital Indemnity plans when plan fees is enabled.
        // Otherwise, we will display the text "N/A" instead of the plan fees
        if (this.planFeesEnabled && this.plan.planTypeAbbreviation === PlanTypeAbbreviation.HC) {
            return true;
        }
        return this.annualCost && typeof this.annualCost.totalEstimatedCost === 'number';
    }
    costDuration$() {
        return this.planFacade.isTotalEstimatedCostAnnually$();
    }
}
PlanCostSectionComponent.ɵfac = function PlanCostSectionComponent_Factory(t) { return new (t || PlanCostSectionComponent)(i0.ɵɵdirectiveInject(PlanDetailsFacade), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.GuidedHelpModalContextService)); };
PlanCostSectionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCostSectionComponent, selectors: [["vnext-plan-cost-section"]], inputs: { preferencesBannerEnabled: "preferencesBannerEnabled", costDetails: "costDetails", plan: "plan", costAddEditLinkText: "costAddEditLinkText", healthEnabled: "healthEnabled", isComparePage: "isComparePage", noCostAvailableText: "noCostAvailableText", healthText: "healthText", drugCostAddEditLinkDescription: "drugCostAddEditLinkDescription", healthCostAddEditLinkDescription: "healthCostAddEditLinkDescription", addHealthCostText: "addHealthCostText", annualCost: "annualCost", selectedPharmacy: "selectedPharmacy", isMailOrderSelected: "isMailOrderSelected", planFeesEnabled: "planFeesEnabled", planFeesIncludedInPremiumTooltipText: "planFeesIncludedInPremiumTooltipText", planFeesNotIncludedInPremiumTooltipText: "planFeesNotIncludedInPremiumTooltipText", modalHeaderHealthText: "modalHeaderHealthText", closeButtonText: "closeButtonText", healthCostsBenefits: "healthCostsBenefits", healthCostsBodyText: "healthCostsBodyText", healthCostsBenefitsBodyText: "healthCostsBenefitsBodyText", healthCostsBenefitsTableHeader: "healthCostsBenefitsTableHeader", healthCostsUsageTableHeader: "healthCostsUsageTableHeader", healthCostsDaysTableHeader: "healthCostsDaysTableHeader", saveFailedText: "saveFailedText", saveSuccessText: "saveSuccessText", healthCostsUpdateAnswersText: "healthCostsUpdateAnswersText", healthCostsSaveAnswersText: "healthCostsSaveAnswersText", healthCostsRestoreDefaultsText: "healthCostsRestoreDefaultsText", healthCostsCustomizationEnabled: "healthCostsCustomizationEnabled", healthAgeQuestionText: "healthAgeQuestionText", healthSliderHeader1Text: "healthSliderHeader1Text", healthSliderHeader2Text: "healthSliderHeader2Text", healthSliderHeader3Text: "healthSliderHeader3Text", healthSliderBody1: "healthSliderBody1", healthSliderBody2: "healthSliderBody2", healthSliderBody3: "healthSliderBody3", healthSliderLabelText: "healthSliderLabelText", healthModalView1HeadingText: "healthModalView1HeadingText", healthModalView1IntroText: "healthModalView1IntroText" }, decls: 1, vars: 1, consts: [["class", "row mx-0", 4, "ngFor", "ngForOf"], [1, "row", "mx-0"], [4, "ngIf"], ["role", "rowheader", "id", "plan-cost-section", "class", "col-md-4 m-0 plan-details-section-left Spa_Style_H5 gray1-static", 3, "ngClass", 4, "ngIf"], [3, "ngClass"], ["class", "sr-only no-translate-block", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["displayCost", ""], ["role", "rowheader", "id", "plan-cost-section", 1, "col-md-4", "m-0", "plan-details-section-left", "Spa_Style_H5", "gray1-static", 3, "ngClass"], ["class", "Spa_Style_Primary_Color", 4, "ngIf"], [1, "Spa_Style_Smaller_Font", "pt-1", "d-inline-block"], [1, "Spa_Style_Gray4_Color", "d-inline", "mr-1"], ["class", "d-inline-block", 4, "ngIf"], ["class", "Spa_Style_Smaller_Font Spa_Style_Gray4_Color d-inline mr-1", 4, "ngIf"], ["class", "Spa_Style_Primary_Color", 4, "liveEditProp"], [1, "Spa_Style_Primary_Color"], [1, "d-inline-block"], [3, "title", "makeInlineBlock", "alwaysUnderlined", "linkTarget", "customClass", "role", "click", "keyup.enter"], [1, "Spa_Style_Smaller_Font", "Spa_Style_Gray4_Color", "d-inline", "mr-1"], [1, "sr-only", "no-translate-block"], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], ["defaultCost", ""], [3, "cost", "isMailOrderSelected", "plan", "costDuration"], [3, "planFees", "isComparePage", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "notApplicableText", "notApplicableTextCustomClass"]], template: function PlanCostSectionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanCostSectionComponent_div_0_Template, 2, 2, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.costDetails);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, i1$2.NgSwitchDefault, LinkComponent, LiveEditPropDirective, PlanFeesComponent, PlanDefaultCostComponent, i1$2.AsyncPipe], styles: [".gray1-static[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray1)}.plan-details-section-left[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:15px 0 15px 10px}.plan-details-section-right[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:15px 5px 15px 10px}@media (max-width: 767px){.plan-details-section-left[_ngcontent-%COMP%]{border-width:0;padding:6px 5px 0 10px}.plan-details-section-right[_ngcontent-%COMP%]{padding:4px 5px 15px 10px;border-bottom:1px solid var(--static-Spa_Style_Accent1)}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCostSectionComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-cost-section', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row mx-0\" [attr.role]=\"!isComparePage ? 'row' : null\" *ngFor=\"let cost of costDetails\">\r\n  <ng-container *ngIf=\"showCost(cost.title)\">\r\n    <span\r\n      role=\"rowheader\"\r\n      id=\"plan-cost-section\"\r\n      class=\"col-md-4 m-0 plan-details-section-left Spa_Style_H5 gray1-static\"\r\n      [ngClass]=\"{\r\n        Spa_Style_Cost_Background: (mobile$ | async) && cost.title === planDetailsCostLabels.TOTAL_ESTIMATED_COST\r\n      }\"\r\n      *ngIf=\"!isComparePage\"\r\n    >\r\n      <span *ngIf=\"cost.title === planDetailsCostLabels.HEALTH_COST\">\r\n        <span class=\"Spa_Style_Primary_Color\" *liveEditProp=\"'Spa_PlanDetails_Health_Cost_Text'\">{{\r\n          (planFacade.isTotalEstimatedCostAnnually$() | async) ? cost.label : cost.label2\r\n        }}</span>\r\n      </span>\r\n      <span *ngIf=\"!(cost.title === planDetailsCostLabels.HEALTH_COST)\" class=\"Spa_Style_Primary_Color\">{{\r\n        (planFacade.isTotalEstimatedCostAnnually$() | async) ? cost.label : cost.label2\r\n      }}</span>\r\n      <span *ngIf=\"cost.title === planDetailsCostLabels.PLAN_FEES\">\r\n        <span class=\"Spa_Style_Primary_Color\">{{ cost.label }}</span>\r\n      </span>\r\n      <span class=\"Spa_Style_Smaller_Font pt-1 d-inline-block\">\r\n        <span class=\"Spa_Style_Gray4_Color d-inline mr-1\">{{ getCostSubText(cost) }}</span>\r\n        <span\r\n          class=\"d-inline-block\"\r\n          *ngIf=\"\r\n            cost.title === planDetailsCostLabels.DRUG_COST ||\r\n            (cost.title === planDetailsCostLabels.HEALTH_COST && healthEnabled && isHealthCostEstimated)\r\n          \"\r\n        >\r\n          <vnext-link\r\n            [title]=\"costAddEditLinkText\"\r\n            [makeInlineBlock]=\"true\"\r\n            [alwaysUnderlined]=\"true\"\r\n            [linkTarget]=\"'_self'\"\r\n            [customClass]=\"'Spa_Style_Link Spa_Style_Smaller_Font'\"\r\n            (click)=\"navigateOrOpenModalByPage(cost.title)\"\r\n            (keyup.enter)=\"navigateOrOpenModalByPage(cost.title)\"\r\n            [attr.aria-label]=\"getAriaLabelValue(cost.title)\"\r\n            [role]=\"linkRoles.LINK\"\r\n          >\r\n          </vnext-link>\r\n        </span>\r\n      </span>\r\n      <span\r\n        *ngIf=\"\r\n          !planFacade.isLastMonthOfYear() &&\r\n            cost.title === planDetailsCostLabels.TOTAL_ESTIMATED_COST &&\r\n            planFacade.getTotalEstimatedCostEffectiveDate();\r\n          let totalEstimatedCostEffectiveDate\r\n        \"\r\n        class=\"Spa_Style_Smaller_Font Spa_Style_Gray4_Color d-inline mr-1\"\r\n      >\r\n        ({{ totalEstimatedCostEffectiveDate }})\r\n      </span>\r\n    </span>\r\n    <div\r\n      [attr.role]=\"!isComparePage ? 'cell' : null\"\r\n      [ngClass]=\"{\r\n        'Spa_Style_Cost_Background': cost.title === planDetailsCostLabels.TOTAL_ESTIMATED_COST && !isComparePage,\r\n        'Spa_Style_CostPremiumSmall': cost.title === planDetailsCostLabels.TOTAL_ESTIMATED_COST,\r\n        'Spa_Style_Bold_Weight': cost.title !== planDetailsCostLabels.TOTAL_ESTIMATED_COST,\r\n        'Spa_Style_Primary_Color': cost.title !== planDetailsCostLabels.TOTAL_ESTIMATED_COST,\r\n        'col-md-8 plan-details-section-right': !isComparePage,\r\n        'w-100': cost.title === planDetailsCostLabels.PLAN_FEES\r\n      }\"\r\n    >\r\n      <div>\r\n        <span *ngIf=\"isComparePage\" class=\"sr-only no-translate-block\">{{ plan.planName }}</span>\r\n        <ng-container *ngIf=\"!isTotalEstimatedCostAvailable() && cost.title !== planDetailsCostLabels.PREMIUM; else displayCost\">\r\n          {{ noCostAvailableText }}\r\n        </ng-container>\r\n        <ng-template #displayCost>\r\n          <ng-container [ngSwitch]=\"cost.title\">\r\n            <ng-container *ngSwitchCase=\"planDetailsCostLabels.HEALTH_COST\">\r\n              <span\r\n                *ngIf=\"\r\n                  !isHealthCostEstimated && (!healthCostEstimatedValue || healthCostEstimatedValue === estimateHealthCostFlag.OptOut);\r\n                  else defaultCost\r\n                \"\r\n              >\r\n                <vnext-link\r\n                  [title]=\"addHealthCostText\"\r\n                  [makeInlineBlock]=\"true\"\r\n                  [alwaysUnderlined]=\"true\"\r\n                  [linkTarget]=\"'_self'\"\r\n                  [customClass]=\"'Spa_Style_Link Spa_Style_Smaller_Font'\"\r\n                  (click)=\"navigateOrOpenModalByPage(cost.title)\"\r\n                  (keyup.enter)=\"navigateOrOpenModalByPage(cost.title)\"\r\n                  [attr.aria-label]=\"getAriaLabelValue(cost.title)\"\r\n                  [role]=\"linkRoles.LINK\"\r\n                >\r\n                </vnext-link>\r\n              </span>\r\n              <ng-template #defaultCost>\r\n                <vnext-plan-default-cost\r\n                  [cost]=\"cost\"\r\n                  [isMailOrderSelected]=\"isMailOrderSelected\"\r\n                  [plan]=\"plan\"\r\n                  [costDuration]=\"(costDuration$() | async) ? cost.duration : cost.duration2\"\r\n                ></vnext-plan-default-cost>\r\n              </ng-template>\r\n            </ng-container>\r\n\r\n            <ng-container *ngSwitchCase=\"planDetailsCostLabels.PLAN_FEES\">\r\n              <vnext-widget-plan-fees\r\n                [planFees]=\"plan.fees\"\r\n                [isComparePage]=\"isComparePage\"\r\n                [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n                [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n                [notApplicableText]=\"noCostAvailableText\"\r\n                [notApplicableTextCustomClass]=\"'Spa_Style_H4 Spa_Style_Bold_Weight'\"\r\n              ></vnext-widget-plan-fees>\r\n            </ng-container>\r\n\r\n            <ng-container *ngSwitchDefault>\r\n              <vnext-plan-default-cost\r\n                [cost]=\"cost\"\r\n                [isMailOrderSelected]=\"isMailOrderSelected\"\r\n                [plan]=\"plan\"\r\n                [costDuration]=\"(costDuration$() | async) ? cost.duration : cost.duration2\"\r\n              ></vnext-plan-default-cost>\r\n            </ng-container>\r\n          </ng-container>\r\n        </ng-template>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n</div>\r\n", styles: [".gray1-static{background-color:var(--static-Spa_Style_Gray1)}.plan-details-section-left{border-right:1px solid var(--static-Spa_Style_Accent1);border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:15px 0 15px 10px}.plan-details-section-right{border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:15px 5px 15px 10px}@media (max-width: 767px){.plan-details-section-left{border-width:0;padding:6px 5px 0 10px}.plan-details-section-right{padding:4px 5px 15px 10px;border-bottom:1px solid var(--static-Spa_Style_Accent1)}}\n"] }]
    }], function () { return [{ type: PlanDetailsFacade }, { type: PlanFacade }, { type: AnalyticsService }, { type: i1.MemberSessionService }, { type: i1$1.NgbModal }, { type: i0.Injector }, { type: i1.NavigationService }, { type: i1.GuidedHelpModalContextService }]; }, { preferencesBannerEnabled: [{
            type: Input
        }], costDetails: [{
            type: Input
        }], plan: [{
            type: Input
        }], costAddEditLinkText: [{
            type: Input
        }], healthEnabled: [{
            type: Input
        }], isComparePage: [{
            type: Input
        }], noCostAvailableText: [{
            type: Input
        }], healthText: [{
            type: Input
        }], drugCostAddEditLinkDescription: [{
            type: Input
        }], healthCostAddEditLinkDescription: [{
            type: Input
        }], addHealthCostText: [{
            type: Input
        }], annualCost: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], isMailOrderSelected: [{
            type: Input
        }], planFeesEnabled: [{
            type: Input
        }], planFeesIncludedInPremiumTooltipText: [{
            type: Input
        }], planFeesNotIncludedInPremiumTooltipText: [{
            type: Input
        }], modalHeaderHealthText: [{
            type: Input
        }], closeButtonText: [{
            type: Input
        }], healthCostsBenefits: [{
            type: Input
        }], healthCostsBodyText: [{
            type: Input
        }], healthCostsBenefitsBodyText: [{
            type: Input
        }], healthCostsBenefitsTableHeader: [{
            type: Input
        }], healthCostsUsageTableHeader: [{
            type: Input
        }], healthCostsDaysTableHeader: [{
            type: Input
        }], saveFailedText: [{
            type: Input
        }], saveSuccessText: [{
            type: Input
        }], healthCostsUpdateAnswersText: [{
            type: Input
        }], healthCostsSaveAnswersText: [{
            type: Input
        }], healthCostsRestoreDefaultsText: [{
            type: Input
        }], healthCostsCustomizationEnabled: [{
            type: Input
        }], healthAgeQuestionText: [{
            type: Input
        }], healthSliderHeader1Text: [{
            type: Input
        }], healthSliderHeader2Text: [{
            type: Input
        }], healthSliderHeader3Text: [{
            type: Input
        }], healthSliderBody1: [{
            type: Input
        }], healthSliderBody2: [{
            type: Input
        }], healthSliderBody3: [{
            type: Input
        }], healthSliderLabelText: [{
            type: Input
        }], healthModalView1HeadingText: [{
            type: Input
        }], healthModalView1IntroText: [{
            type: Input
        }] }); })();

function RiderBenefitDetailsComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "h3", 5);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 1, ctx_r3.sectionDetail.value, "html"), i0.ɵɵsanitizeHtml);
} }
function RiderBenefitDetailsComponent_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r5.sectionDetail.value);
} }
function RiderBenefitDetailsComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, RiderBenefitDetailsComponent_ng_container_1_ng_container_1_Template, 3, 4, "ng-container", 3);
    i0.ɵɵtemplate(2, RiderBenefitDetailsComponent_ng_container_1_ng_template_2_Template, 2, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r4 = i0.ɵɵreference(3);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showAsHeadingText)("ngIfElse", _r4);
} }
function RiderBenefitDetailsComponent_ng_container_2_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.sectionDetail.value, " ");
} }
function RiderBenefitDetailsComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, RiderBenefitDetailsComponent_ng_container_2_p_1_Template, 2, 1, "p", 7);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.showAsHeadingText);
} }
function RiderBenefitDetailsComponent_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.sectionDetail.value);
} }
class RiderBenefitDetailsComponent {
    constructor() {
        this.benefitType = BenefitType;
    }
}
RiderBenefitDetailsComponent.ɵfac = function RiderBenefitDetailsComponent_Factory(t) { return new (t || RiderBenefitDetailsComponent)(); };
RiderBenefitDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RiderBenefitDetailsComponent, selectors: [["vnext-rider-benefit-details"]], inputs: { sectionDetail: "sectionDetail", showAsHeadingText: "showAsHeadingText" }, decls: 4, vars: 3, consts: [[3, "ngSwitch"], [4, "ngSwitchCase"], ["class", "Spa_Style_Note", 4, "ngSwitchDefault"], [4, "ngIf", "ngIfElse"], ["simpleText", ""], [1, "Spa_Style_H3", 3, "innerHTML"], [1, "Spa_Style_Primary_Color"], ["class", "Spa_Style_Note", 4, "ngIf"], [1, "Spa_Style_Note"]], template: function RiderBenefitDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementContainerStart(0, 0);
        i0.ɵɵtemplate(1, RiderBenefitDetailsComponent_ng_container_1_Template, 4, 2, "ng-container", 1);
        i0.ɵɵtemplate(2, RiderBenefitDetailsComponent_ng_container_2_Template, 2, 1, "ng-container", 1);
        i0.ɵɵtemplate(3, RiderBenefitDetailsComponent_p_3_Template, 2, 1, "p", 2);
        i0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngSwitch", ctx.sectionDetail.name);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.benefitType.BENEFIT_AMOUNT);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.benefitType.BENEFIT_NOTES);
    } }, dependencies: [i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, i1$2.NgSwitchDefault, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RiderBenefitDetailsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-rider-benefit-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container [ngSwitch]=\"sectionDetail.name\">\r\n  <ng-container *ngSwitchCase=\"benefitType.BENEFIT_AMOUNT\">\r\n    <ng-container *ngIf=\"showAsHeadingText; else simpleText\">\r\n      <h3 class=\"Spa_Style_H3\" [innerHTML]=\"sectionDetail.value | safe: 'html'\"></h3>\r\n    </ng-container>\r\n\r\n    <ng-template #simpleText>\r\n      <span class=\"Spa_Style_Primary_Color\">{{ sectionDetail.value }}</span>\r\n    </ng-template>\r\n  </ng-container>\r\n\r\n  <ng-container *ngSwitchCase=\"benefitType.BENEFIT_NOTES\">\r\n    <p class=\"Spa_Style_Note\" *ngIf=\"!showAsHeadingText\">\r\n      {{ sectionDetail.value }}\r\n    </p>\r\n  </ng-container>\r\n\r\n  <p class=\"Spa_Style_Note\" *ngSwitchDefault>{{ sectionDetail.value }}</p>\r\n</ng-container>\r\n" }]
    }], null, { sectionDetail: [{
            type: Input
        }], showAsHeadingText: [{
            type: Input
        }] }); })();

function RiderBenefitsComponent_ng_container_0_ng_container_1_vnext_rider_benefit_details_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-rider-benefit-details", 4);
} if (rf & 2) {
    const sectionDetail_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("sectionDetail", sectionDetail_r1)("showAsHeadingText", ctx_r5.showAsHeadingText);
} }
function RiderBenefitsComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, RiderBenefitsComponent_ng_container_0_ng_container_1_vnext_rider_benefit_details_1_Template, 1, 2, "vnext-rider-benefit-details", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const sectionDetail_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.sectionDetailsName === sectionDetail_r1.name);
} }
function RiderBenefitsComponent_ng_container_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-rider-benefit-details", 4);
} if (rf & 2) {
    const sectionDetail_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("sectionDetail", sectionDetail_r1)("showAsHeadingText", ctx_r4.showAsHeadingText);
} }
function RiderBenefitsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, RiderBenefitsComponent_ng_container_0_ng_container_1_Template, 2, 1, "ng-container", 1);
    i0.ɵɵtemplate(2, RiderBenefitsComponent_ng_container_0_ng_template_2_Template, 1, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r3 = i0.ɵɵreference(3);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.sectionDetailsName)("ngIfElse", _r3);
} }
class RiderBenefitsComponent {
    constructor() {
        this.showAsHeadingText = true;
    }
}
RiderBenefitsComponent.ɵfac = function RiderBenefitsComponent_Factory(t) { return new (t || RiderBenefitsComponent)(); };
RiderBenefitsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RiderBenefitsComponent, selectors: [["vnext-rider-benefits"]], inputs: { sectionDetailsList: "sectionDetailsList", sectionDetailsName: "sectionDetailsName", showAsHeadingText: "showAsHeadingText" }, decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], [4, "ngIf", "ngIfElse"], ["wholeSectionDetails", ""], [3, "sectionDetail", "showAsHeadingText", 4, "ngIf"], [3, "sectionDetail", "showAsHeadingText"]], template: function RiderBenefitsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, RiderBenefitsComponent_ng_container_0_Template, 4, 2, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.sectionDetailsList);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, RiderBenefitDetailsComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RiderBenefitsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-rider-benefits', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngFor=\"let sectionDetail of sectionDetailsList\">\r\n  <ng-container *ngIf=\"sectionDetailsName; else wholeSectionDetails\">\r\n    <vnext-rider-benefit-details\r\n      *ngIf=\"sectionDetailsName === sectionDetail.name\"\r\n      [sectionDetail]=\"sectionDetail\"\r\n      [showAsHeadingText]=\"showAsHeadingText\"\r\n    ></vnext-rider-benefit-details>\r\n  </ng-container>\r\n\r\n  <ng-template #wholeSectionDetails>\r\n    <vnext-rider-benefit-details [sectionDetail]=\"sectionDetail\" [showAsHeadingText]=\"showAsHeadingText\"></vnext-rider-benefit-details>\r\n  </ng-template>\r\n</ng-container>\r\n" }]
    }], null, { sectionDetailsList: [{
            type: Input
        }], sectionDetailsName: [{
            type: Input
        }], showAsHeadingText: [{
            type: Input
        }] }); })();

function RiderCategoryDetailComponent_ng_container_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.riderHIPBenefitDefaultDropdownText, " ");
} }
function RiderCategoryDetailComponent_ng_container_0_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵelement(1, "vnext-rider-benefits", 14);
    i0.ɵɵelementStart(2, "span", 12);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "currency");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("sectionDetailsList", ctx_r5.riderCategory == null ? null : ctx_r5.riderCategory.selectedRider == null ? null : ctx_r5.riderCategory.selectedRider.extendedPlanDetails[0].sectionDetails)("showAsHeadingText", false)("sectionDetailsName", ctx_r5.benefitType.BENEFIT_AMOUNT);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" (+", i0.ɵɵpipeBind1(4, 4, (ctx_r5.riderCategory.selectedRider == null ? null : ctx_r5.riderCategory.selectedRider.calculatedMedicalPremium) || 0), ") ");
} }
const _c0$14 = function (a0) { return { Spa_Style_Gray1_Background: a0 }; };
function RiderCategoryDetailComponent_ng_container_0_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function RiderCategoryDetailComponent_ng_container_0_button_12_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r9.onRiderBenefitDropdownSelection(null, ctx_r9.riderCategory == null ? null : ctx_r9.riderCategory.riderGroupKey)); })("keyup.enter", function RiderCategoryDetailComponent_ng_container_0_button_12_Template_button_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.onRiderBenefitDropdownSelection(null, ctx_r11.riderCategory == null ? null : ctx_r11.riderCategory.riderGroupKey)); });
    i0.ɵɵelementStart(1, "span", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$14, !(ctx_r6.riderCategory == null ? null : ctx_r6.riderCategory.selectedRider)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.riderHIPBenefitDefaultDropdownText, " ");
} }
function RiderCategoryDetailComponent_ng_container_0_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function RiderCategoryDetailComponent_ng_container_0_button_13_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r14); const rider_r12 = restoredCtx.$implicit; const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.onRiderBenefitDropdownSelection(rider_r12, ctx_r13.riderCategory == null ? null : ctx_r13.riderCategory.riderGroupKey)); })("keyup.enter", function RiderCategoryDetailComponent_ng_container_0_button_13_Template_button_keyup_enter_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r14); const rider_r12 = restoredCtx.$implicit; const ctx_r15 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r15.onRiderBenefitDropdownSelection(rider_r12, ctx_r15.riderCategory == null ? null : ctx_r15.riderCategory.riderGroupKey)); });
    i0.ɵɵelement(1, "vnext-rider-benefits", 14);
    i0.ɵɵelementStart(2, "span", 16);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "currency");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const rider_r12 = ctx.$implicit;
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0$14, rider_r12.planID === (ctx_r7.riderCategory == null ? null : ctx_r7.riderCategory.selectedRider == null ? null : ctx_r7.riderCategory.selectedRider.planID)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("sectionDetailsList", rider_r12.extendedPlanDetails[0] == null ? null : rider_r12.extendedPlanDetails[0].sectionDetails)("showAsHeadingText", false)("sectionDetailsName", ctx_r7.benefitType.BENEFIT_AMOUNT);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("(+", i0.ɵɵpipeBind1(4, 5, rider_r12.calculatedMedicalPremium || 0), ")");
} }
function RiderCategoryDetailComponent_ng_container_0_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17)(1, "p", 18);
    i0.ɵɵelement(2, "vnext-rider-benefits", 14);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("sectionDetailsList", ctx_r8.riderCategory == null ? null : ctx_r8.riderCategory.selectedRider == null ? null : ctx_r8.riderCategory.selectedRider.extendedPlanDetails[0] == null ? null : ctx_r8.riderCategory.selectedRider.extendedPlanDetails[0].sectionDetails)("showAsHeadingText", false)("sectionDetailsName", ctx_r8.benefitType.BENEFIT_NOTES);
} }
const _c1$q = function (a0) { return { "dropdown-overflow": a0 }; };
function RiderCategoryDetailComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h3", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 3)(4, "button", 4);
    i0.ɵɵtemplate(5, RiderCategoryDetailComponent_ng_container_0_ng_container_5_Template, 3, 1, "ng-container", 0);
    i0.ɵɵtemplate(6, RiderCategoryDetailComponent_ng_container_0_ng_template_6_Template, 5, 6, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(8, "i", 6);
    i0.ɵɵelementStart(9, "span", 7);
    i0.ɵɵtext(10, "Expand");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 8);
    i0.ɵɵtemplate(12, RiderCategoryDetailComponent_ng_container_0_button_12_Template, 3, 4, "button", 9);
    i0.ɵɵtemplate(13, RiderCategoryDetailComponent_ng_container_0_button_13_Template, 5, 9, "button", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(14, RiderCategoryDetailComponent_ng_container_0_div_14_Template, 3, 3, "div", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r4 = i0.ɵɵreference(7);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.riderHIPBenefitText, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !(ctx_r0.riderCategory == null ? null : ctx_r0.riderCategory.selectedRider))("ngIfElse", _r4);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1$q, ctx_r0.riderCategory.riders.length > ctx_r0.RIDER_DROPDOWN_SCROLLING_MAX_LENGTH));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showDefaultDropdownText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.riderCategory.riders);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showBenefitNote && (ctx_r0.riderCategory == null ? null : ctx_r0.riderCategory.selectedRider) && !ctx_r0.basePlanNames.includes(ctx_r0.riderCategory == null ? null : ctx_r0.riderCategory.riderGroupKey));
} }
function RiderCategoryDetailComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-rider-benefits", 14)(1, "vnext-rider-benefits", 14);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("sectionDetailsList", ctx_r2.riderCategory == null ? null : ctx_r2.riderCategory.riders[0] == null ? null : ctx_r2.riderCategory.riders[0].extendedPlanDetails[0] == null ? null : ctx_r2.riderCategory.riders[0].extendedPlanDetails[0].sectionDetails)("showAsHeadingText", true)("sectionDetailsName", ctx_r2.benefitType.BENEFIT_AMOUNT);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("sectionDetailsList", ctx_r2.riderCategory == null ? null : ctx_r2.riderCategory.riders[0] == null ? null : ctx_r2.riderCategory.riders[0].extendedPlanDetails[0] == null ? null : ctx_r2.riderCategory.riders[0].extendedPlanDetails[0].sectionDetails)("showAsHeadingText", false)("sectionDetailsName", ctx_r2.benefitType.BENEFIT_NOTES);
} }
class RiderCategoryDetailComponent {
    constructor() {
        this.benefitType = BenefitType;
        this.RIDER_DROPDOWN_SCROLLING_MAX_LENGTH = 10;
        this.showBenefitNote = true;
        this.showDefaultDropdownText = true;
        this.riderBenefitDropdownSelection = new EventEmitter();
    }
    onRiderBenefitDropdownSelection(rider, riderGroupKey) {
        const riderBenefitDropdownSelectionItem = { rider, riderGroupKey };
        this.riderBenefitDropdownSelection.emit(riderBenefitDropdownSelectionItem);
    }
}
RiderCategoryDetailComponent.ɵfac = function RiderCategoryDetailComponent_Factory(t) { return new (t || RiderCategoryDetailComponent)(); };
RiderCategoryDetailComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RiderCategoryDetailComponent, selectors: [["vnext-plan-rider-category-detail"]], inputs: { riderCategory: "riderCategory", riderHIPBenefitDefaultDropdownText: "riderHIPBenefitDefaultDropdownText", riderHIPBenefitText: "riderHIPBenefitText", basePlanNames: "basePlanNames", showBenefitNote: "showBenefitNote", showDefaultDropdownText: "showDefaultDropdownText" }, outputs: { riderBenefitDropdownSelection: "riderBenefitDropdownSelection" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["benefitRiderText", ""], [1, "Spa_Style_H3"], ["ngbDropdown", ""], ["id", "hipRiderAmount", "aria-labelledby", "hipRiderAmount", "ngbDropdownToggle", "", 1, "btn", "w-100"], ["benefitRiderHospitalIndemnitySelected", ""], [1, "fa", "fa-angle-down", "pl-2"], [1, "sr-only"], ["ngbDropdownMenu", "", "aria-labelledby", "hipRiderAmount", 3, "ngClass"], ["ngbDropdownItem", "", 3, "ngClass", "click", "keyup.enter", 4, "ngIf"], ["ngbDropdownItem", "", 3, "ngClass", "click", "keyup.enter", 4, "ngFor", "ngForOf"], ["class", "mt-2", 4, "ngIf"], [1, "Spa_Style_Paragraph"], [1, "dropdown-selected-value", "text-left"], [3, "sectionDetailsList", "showAsHeadingText", "sectionDetailsName"], ["ngbDropdownItem", "", 3, "ngClass", "click", "keyup.enter"], [1, "Spa_Style_Primary_Color"], [1, "mt-2"], [1, "Spa_Style_Note"]], template: function RiderCategoryDetailComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, RiderCategoryDetailComponent_ng_container_0_Template, 15, 9, "ng-container", 0);
        i0.ɵɵtemplate(1, RiderCategoryDetailComponent_ng_template_1_Template, 2, 6, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.riderCategory && ctx.riderCategory.selectable)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, IconAriaAttributesDirective, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem, RiderBenefitsComponent, i1$2.CurrencyPipe], styles: [".dropdown-toggle[_ngcontent-%COMP%]{line-height:18px;padding:8px 11px;box-shadow:inset 0 1px 1px #00000013;display:flex;justify-content:space-between;cursor:pointer;-webkit-user-select:none;user-select:none;border-width:1px;border-style:solid;border-color:var(--static-Spa_Style_Accent1);border-radius:5px;height:36px}.dropdown-selected-value[_ngcontent-%COMP%]{display:inline-block;overflow-x:hidden;width:calc(100% - 15px);text-overflow:ellipsis}.dropdown-menu[_ngcontent-%COMP%]{min-width:100%;width:-moz-fit-content;width:fit-content}.dropdown-item[_ngcontent-%COMP%]{cursor:pointer;-webkit-user-select:none;user-select:none}.dropdown-item[_ngcontent-%COMP%]:hover, .dropdown-item[_ngcontent-%COMP%]:focus, .dropdown-item[_ngcontent-%COMP%]:active{background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}.dropdown-toggle[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%]{padding-top:3px}.dropdown-toggle[_ngcontent-%COMP%]:after{content:none}.dropdown-overflow[_ngcontent-%COMP%]{height:315px;overflow-y:scroll}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RiderCategoryDetailComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-rider-category-detail', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"riderCategory && riderCategory.selectable; else benefitRiderText\">\r\n  <h3 class=\"Spa_Style_H3\">\r\n    {{ riderHIPBenefitText }}\r\n  </h3>\r\n\r\n  <div ngbDropdown>\r\n    <button class=\"btn w-100\" id=\"hipRiderAmount\" aria-labelledby=\"hipRiderAmount\" ngbDropdownToggle>\r\n      <ng-container *ngIf=\"!riderCategory?.selectedRider; else benefitRiderHospitalIndemnitySelected\">\r\n        <span class=\"Spa_Style_Paragraph\">\r\n          {{ riderHIPBenefitDefaultDropdownText }}\r\n        </span>\r\n      </ng-container>\r\n      <ng-template #benefitRiderHospitalIndemnitySelected>\r\n        <span class=\"dropdown-selected-value text-left\">\r\n          <vnext-rider-benefits\r\n            [sectionDetailsList]=\"riderCategory?.selectedRider?.extendedPlanDetails[0].sectionDetails\"\r\n            [showAsHeadingText]=\"false\"\r\n            [sectionDetailsName]=\"benefitType.BENEFIT_AMOUNT\"\r\n          >\r\n          </vnext-rider-benefits>\r\n          <span class=\"Spa_Style_Paragraph\"> (+{{ riderCategory.selectedRider?.calculatedMedicalPremium || 0 | currency }}) </span>\r\n        </span>\r\n      </ng-template>\r\n      <i class=\"fa fa-angle-down pl-2\"></i>\r\n      <span class=\"sr-only\">Expand</span>\r\n    </button>\r\n    <div\r\n      [ngClass]=\"{\r\n        'dropdown-overflow': riderCategory.riders.length > RIDER_DROPDOWN_SCROLLING_MAX_LENGTH\r\n      }\"\r\n      ngbDropdownMenu\r\n      aria-labelledby=\"hipRiderAmount\"\r\n    >\r\n      <button\r\n        ngbDropdownItem\r\n        [ngClass]=\"{ Spa_Style_Gray1_Background: !riderCategory?.selectedRider }\"\r\n        (click)=\"onRiderBenefitDropdownSelection(null, riderCategory?.riderGroupKey)\"\r\n        (keyup.enter)=\"onRiderBenefitDropdownSelection(null, riderCategory?.riderGroupKey)\"\r\n        *ngIf=\"showDefaultDropdownText\"\r\n      >\r\n        <span class=\"Spa_Style_Paragraph\">\r\n          {{ riderHIPBenefitDefaultDropdownText }}\r\n        </span>\r\n      </button>\r\n      <button\r\n        *ngFor=\"let rider of riderCategory.riders\"\r\n        ngbDropdownItem\r\n        [ngClass]=\"{ Spa_Style_Gray1_Background: rider.planID === riderCategory?.selectedRider?.planID }\"\r\n        (click)=\"onRiderBenefitDropdownSelection(rider, riderCategory?.riderGroupKey)\"\r\n        (keyup.enter)=\"onRiderBenefitDropdownSelection(rider, riderCategory?.riderGroupKey)\"\r\n      >\r\n        <vnext-rider-benefits\r\n          [sectionDetailsList]=\"rider.extendedPlanDetails[0]?.sectionDetails\"\r\n          [showAsHeadingText]=\"false\"\r\n          [sectionDetailsName]=\"benefitType.BENEFIT_AMOUNT\"\r\n        >\r\n        </vnext-rider-benefits>\r\n\r\n        <span class=\"Spa_Style_Primary_Color\">(+{{ rider.calculatedMedicalPremium || 0 | currency }})</span>\r\n      </button>\r\n    </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"showBenefitNote && riderCategory?.selectedRider && !basePlanNames.includes(riderCategory?.riderGroupKey)\" class=\"mt-2\">\r\n    <p class=\"Spa_Style_Note\">\r\n      <vnext-rider-benefits\r\n        [sectionDetailsList]=\"riderCategory?.selectedRider?.extendedPlanDetails[0]?.sectionDetails\"\r\n        [showAsHeadingText]=\"false\"\r\n        [sectionDetailsName]=\"benefitType.BENEFIT_NOTES\"\r\n      >\r\n      </vnext-rider-benefits>\r\n    </p>\r\n  </div>\r\n</ng-container>\r\n\r\n<ng-template #benefitRiderText>\r\n  <vnext-rider-benefits\r\n    [sectionDetailsList]=\"riderCategory?.riders[0]?.extendedPlanDetails[0]?.sectionDetails\"\r\n    [showAsHeadingText]=\"true\"\r\n    [sectionDetailsName]=\"benefitType.BENEFIT_AMOUNT\"\r\n  >\r\n  </vnext-rider-benefits>\r\n\r\n  <vnext-rider-benefits\r\n    [sectionDetailsList]=\"riderCategory?.riders[0]?.extendedPlanDetails[0]?.sectionDetails\"\r\n    [showAsHeadingText]=\"false\"\r\n    [sectionDetailsName]=\"benefitType.BENEFIT_NOTES\"\r\n  >\r\n  </vnext-rider-benefits>\r\n</ng-template>\r\n", styles: [".dropdown-toggle{line-height:18px;padding:8px 11px;box-shadow:inset 0 1px 1px #00000013;display:flex;justify-content:space-between;cursor:pointer;-webkit-user-select:none;user-select:none;border-width:1px;border-style:solid;border-color:var(--static-Spa_Style_Accent1);border-radius:5px;height:36px}.dropdown-selected-value{display:inline-block;overflow-x:hidden;width:calc(100% - 15px);text-overflow:ellipsis}.dropdown-menu{min-width:100%;width:-moz-fit-content;width:fit-content}.dropdown-item{cursor:pointer;-webkit-user-select:none;user-select:none}.dropdown-item:hover,.dropdown-item:focus,.dropdown-item:active{background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}.dropdown-toggle>.fa{padding-top:3px}.dropdown-toggle:after{content:none}.dropdown-overflow{height:315px;overflow-y:scroll}\n"] }]
    }], null, { riderCategory: [{
            type: Input
        }], riderHIPBenefitDefaultDropdownText: [{
            type: Input
        }], riderHIPBenefitText: [{
            type: Input
        }], basePlanNames: [{
            type: Input
        }], showBenefitNote: [{
            type: Input
        }], showDefaultDropdownText: [{
            type: Input
        }], riderBenefitDropdownSelection: [{
            type: Output
        }] }); })();

const _c0$13 = function (a0) { return { "border-bottom": a0 }; };
const _c1$p = function (a0) { return { gray: a0 }; };
function RiderCategoryComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "span", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 3)(4, "vnext-plan-rider-category-detail", 4);
    i0.ɵɵlistener("riderBenefitDropdownSelection", function RiderCategoryComponent_div_0_Template_vnext_plan_rider_category_detail_riderBenefitDropdownSelection_4_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onRiderBenefitDropdownSelection($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const riderCategory_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0$13, ctx_r0.mobile));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c1$p, !ctx_r0.mobile));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", riderCategory_r1.label, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("riderCategory", riderCategory_r1)("riderHIPBenefitDefaultDropdownText", ctx_r0.riderHIPBenefitDefaultDropdownText)("riderHIPBenefitText", ctx_r0.riderHIPBenefitText)("basePlanNames", ctx_r0.basePlanNames);
} }
class RiderCategoryComponent {
    constructor() {
        this.benefitType = BenefitType;
        this.riderBenefitDropdownSelection = new EventEmitter(null);
    }
    onRiderBenefitDropdownSelection(selected) {
        this.riderBenefitDropdownSelection.emit(selected);
    }
    trackByRiderGroupKey(index, riderBenefitCategory) {
        return riderBenefitCategory.riderGroupKey;
    }
}
RiderCategoryComponent.ɵfac = function RiderCategoryComponent_Factory(t) { return new (t || RiderCategoryComponent)(); };
RiderCategoryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RiderCategoryComponent, selectors: [["vnext-plan-sub-details-rider-category"]], inputs: { mobile: "mobile", riderCategories: "riderCategories", riderHIPBenefitDefaultDropdownText: "riderHIPBenefitDefaultDropdownText", riderHIPBenefitText: "riderHIPBenefitText", basePlanNames: "basePlanNames" }, outputs: { riderBenefitDropdownSelection: "riderBenefitDropdownSelection" }, decls: 1, vars: 2, consts: [["role", "row", "class", "row mx-0 plan-details-section-min-height", 3, "ngClass", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["role", "row", 1, "row", "mx-0", "plan-details-section-min-height", 3, "ngClass"], ["role", "rowheader", 1, "Spa_Style_H5", "plan-details-section-left", "gray1-static", "m-0", "col-md-4", "category-header-text", 3, "ngClass"], ["role", "cell", 1, "plan-details-section-right", "col-md-8", "mb-0", "pr-2"], [3, "riderCategory", "riderHIPBenefitDefaultDropdownText", "riderHIPBenefitText", "basePlanNames", "riderBenefitDropdownSelection"]], template: function RiderCategoryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, RiderCategoryComponent_div_0_Template, 5, 11, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.riderCategories)("ngForTrackBy", ctx.trackByRiderGroupKey);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, RiderCategoryDetailComponent], styles: ["button[_ngcontent-%COMP%]:focus, .btn[_ngcontent-%COMP%]:focus{outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:inset 0 1px 1px var(--static-Spa_Style_Accent1),0 0 8px var(--static-Spa_Style_Accent1)}.plan-details-section-left[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:15px 0 15px 10px}.plan-details-section-right[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-width:0 0 1px;padding:14px 0 10px 10px}.plan-details-section-min-height[_ngcontent-%COMP%]{min-height:60px}.gray1-static[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray1)}.category-header-text[_ngcontent-%COMP%]{padding-right:1rem}@media (max-width: 479.98px){.plan-details-section-min-height[_ngcontent-%COMP%]{min-height:70px}}@media (max-width: 767px){.plan-details-section-left[_ngcontent-%COMP%]{border-width:0;padding:6px 5px 0 10px;height:28px}.plan-details-section-right[_ngcontent-%COMP%]{padding:4px 5px 15px 10px;border:none}.plan-details-accordion[_ngcontent-%COMP%]:last-child   .plan-details-section-left[_ngcontent-%COMP%]:last-child, .plan-details-accordion[_ngcontent-%COMP%]:last-child   .plan-details-section-right[_ngcontent-%COMP%]:last-child{border:0}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RiderCategoryComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-sub-details-rider-category', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  *ngFor=\"let riderCategory of riderCategories; trackBy: trackByRiderGroupKey\"\r\n  role=\"row\"\r\n  class=\"row mx-0 plan-details-section-min-height\"\r\n  [ngClass]=\"{ 'border-bottom': mobile }\"\r\n>\r\n  <span\r\n    role=\"rowheader\"\r\n    class=\"Spa_Style_H5 plan-details-section-left gray1-static m-0 col-md-4 category-header-text\"\r\n    [ngClass]=\"{ gray: !mobile }\"\r\n  >\r\n    {{ riderCategory.label }}\r\n  </span>\r\n  <div role=\"cell\" class=\"plan-details-section-right col-md-8 mb-0 pr-2\">\r\n    <vnext-plan-rider-category-detail\r\n      [riderCategory]=\"riderCategory\"\r\n      [riderHIPBenefitDefaultDropdownText]=\"riderHIPBenefitDefaultDropdownText\"\r\n      [riderHIPBenefitText]=\"riderHIPBenefitText\"\r\n      [basePlanNames]=\"basePlanNames\"\r\n      (riderBenefitDropdownSelection)=\"onRiderBenefitDropdownSelection($event)\"\r\n    >\r\n    </vnext-plan-rider-category-detail>\r\n  </div>\r\n</div>\r\n", styles: ["button:focus,.btn:focus{outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:inset 0 1px 1px var(--static-Spa_Style_Accent1),0 0 8px var(--static-Spa_Style_Accent1)}.plan-details-section-left{border-right:1px solid var(--static-Spa_Style_Accent1);border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:15px 0 15px 10px}.plan-details-section-right{border:1px solid var(--static-Spa_Style_Accent1);border-width:0 0 1px;padding:14px 0 10px 10px}.plan-details-section-min-height{min-height:60px}.gray1-static{background-color:var(--static-Spa_Style_Gray1)}.category-header-text{padding-right:1rem}@media (max-width: 479.98px){.plan-details-section-min-height{min-height:70px}}@media (max-width: 767px){.plan-details-section-left{border-width:0;padding:6px 5px 0 10px;height:28px}.plan-details-section-right{padding:4px 5px 15px 10px;border:none}.plan-details-accordion:last-child .plan-details-section-left:last-child,.plan-details-accordion:last-child .plan-details-section-right:last-child{border:0}}\n"] }]
    }], null, { mobile: [{
            type: Input
        }], riderCategories: [{
            type: Input
        }], riderHIPBenefitDefaultDropdownText: [{
            type: Input
        }], riderHIPBenefitText: [{
            type: Input
        }], basePlanNames: [{
            type: Input
        }], riderBenefitDropdownSelection: [{
            type: Output
        }] }); })();

function PlanPharmacyDetailsComponent_div_0_div_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", ctx_r8.primaryPharmacyText, ")");
} }
const _c0$12 = function (a0) { return { "gray-static": a0 }; };
function PlanPharmacyDetailsComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵelementStart(2, "span", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PlanPharmacyDetailsComponent_div_0_div_1_span_4_Template, 2, 1, "span", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const pharmacy_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0$12, !i0.ɵɵpipeBind1(1, 3, ctx_r3.mobile$)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(pharmacy_r2.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.primaryPharmacy && pharmacy_r2.nabp === ctx_r3.primaryPharmacy.nabp && ctx_r3.showPrimaryPharmacyLabel);
} }
function PlanPharmacyDetailsComponent_div_0_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r4.planName);
} }
function PlanPharmacyDetailsComponent_div_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 12);
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r5.nonCoveredText);
} }
const _c1$o = function (a0) { return { "pharmacy-icon": a0 }; };
function PlanPharmacyDetailsComponent_div_0_ng_template_7_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 16);
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1$o, ctx_r13.isComparePage));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r13.inNetworkPreferredText);
} }
function PlanPharmacyDetailsComponent_div_0_ng_template_7_ng_container_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 16);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1$o, ctx_r15.isComparePage));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r15.inNetworkStandardText);
} }
function PlanPharmacyDetailsComponent_div_0_ng_template_7_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanPharmacyDetailsComponent_div_0_ng_template_7_ng_container_0_ng_container_1_Template, 4, 4, "ng-container", 7);
    i0.ɵɵtemplate(2, PlanPharmacyDetailsComponent_div_0_ng_template_7_ng_container_0_ng_template_2_Template, 3, 4, "ng-template", null, 15, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r14 = i0.ɵɵreference(3);
    const pharmacy_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", pharmacy_r2.isPreferred)("ngIfElse", _r14);
} }
function PlanPharmacyDetailsComponent_div_0_ng_template_7_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 17);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1$o, ctx_r12.isComparePage));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r12.outOfNetworkText);
} }
function PlanPharmacyDetailsComponent_div_0_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanPharmacyDetailsComponent_div_0_ng_template_7_ng_container_0_Template, 4, 2, "ng-container", 7);
    i0.ɵɵtemplate(1, PlanPharmacyDetailsComponent_div_0_ng_template_7_ng_template_1_Template, 3, 4, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r11 = i0.ɵɵreference(2);
    const pharmacy_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngIf", pharmacy_r2.isInNetwork)("ngIfElse", _r11);
} }
const _c2$i = function (a0) { return { "row mx-0": a0 }; };
const _c3$9 = function (a0) { return { "plan-details-section-right col-md-8": a0 }; };
function PlanPharmacyDetailsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, PlanPharmacyDetailsComponent_div_0_div_1_Template, 5, 7, "div", 3);
    i0.ɵɵelementStart(2, "div", 4)(3, "div");
    i0.ɵɵtemplate(4, PlanPharmacyDetailsComponent_div_0_span_4_Template, 2, 1, "span", 5);
    i0.ɵɵelementStart(5, "div", 6);
    i0.ɵɵtemplate(6, PlanPharmacyDetailsComponent_div_0_ng_container_6_Template, 4, 1, "ng-container", 7);
    i0.ɵɵtemplate(7, PlanPharmacyDetailsComponent_div_0_ng_template_7_Template, 3, 2, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const _r6 = i0.ɵɵreference(8);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c2$i, !ctx_r0.isComparePage));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isComparePage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c3$9, !ctx_r0.isComparePage));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isComparePage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r0.isComparePage ? "justify-content-center justify-content-lg-start" : "justify-content-start");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showNotCovered && !ctx_r0.isComparePage)("ngIfElse", _r6);
} }
function PlanPharmacyDetailsComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵelement(2, "i", 19);
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.nonCoveredText);
} }
class PlanPharmacyDetailsComponent {
    constructor(planDetailsFacade) {
        this.planDetailsFacade = planDetailsFacade;
    }
    get mobile$() {
        return this.planDetailsFacade.mobile$;
    }
}
PlanPharmacyDetailsComponent.ɵfac = function PlanPharmacyDetailsComponent_Factory(t) { return new (t || PlanPharmacyDetailsComponent)(i0.ɵɵdirectiveInject(PlanDetailsFacade)); };
PlanPharmacyDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanPharmacyDetailsComponent, selectors: [["vnext-plan-pharmacy-details"]], inputs: { pharmacies: "pharmacies", inNetworkPreferredText: "inNetworkPreferredText", inNetworkStandardText: "inNetworkStandardText", outOfNetworkText: "outOfNetworkText", isComparePage: "isComparePage", planName: "planName", showPrimaryPharmacyLabel: "showPrimaryPharmacyLabel", primaryPharmacyText: "primaryPharmacyText", primaryPharmacy: "primaryPharmacy", nonCoveredText: "nonCoveredText", showNotCovered: "showNotCovered" }, decls: 2, vars: 2, consts: [[3, "ngClass", 4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "ngClass"], ["role", "rowheader", "id", "plan-pharmacy-details", "class", "Spa_Style_H5 plan-level-header plan-details-section-left m-0 col-md-4", 3, "ngClass", 4, "ngIf"], ["role", "cell", 3, "ngClass"], ["class", "sr-only no-translate-block", 4, "ngIf"], [1, "Spa_Style_H4", "mb-0", "mt-1", "mt-md-0", "d-flex", 3, "ngClass"], [4, "ngIf", "ngIfElse"], ["showPharmacyCoverage", ""], ["role", "rowheader", "id", "plan-pharmacy-details", 1, "Spa_Style_H5", "plan-level-header", "plan-details-section-left", "m-0", "col-md-4", 3, "ngClass"], [1, "no-translate-block"], [1, "sr-only", "no-translate-block"], ["aria-hidden", "true", 1, "fas", "fa-times-circle", "out-of-network-pharmacy"], [1, "pl-1", "pr-0"], ["outOfNetworkPharmacy", ""], ["standardPharmacy", ""], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "in-network-pharmacy", 3, "ngClass"], ["aria-hidden", "true", 1, "fas", "fa-times-circle", "out-of-network-pharmacy", 3, "ngClass"], [1, "Spa_Style_H4", "mb-0", "mt-1", "mt-md-0", "d-flex", "justify-content-center", "justify-content-lg-start"], ["aria-hidden", "true", 1, "fas", "fa-times-circle", "out-of-network-pharmacy", "pharmacy-icon"]], template: function PlanPharmacyDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanPharmacyDetailsComponent_div_0_Template, 9, 11, "div", 0);
        i0.ɵɵtemplate(1, PlanPharmacyDetailsComponent_ng_container_1_Template, 5, 1, "ng-container", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.pharmacies);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showNotCovered && ctx.isComparePage);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, IconAriaAttributesDirective, i1$2.AsyncPipe], styles: [".plan-details-section-left[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:15px 0 15px 10px}.plan-details-section-right[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-width:0 0 1px;padding:15px 5px 15px 10px}.gray-static[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray1)}.pharmacy-icon[_ngcontent-%COMP%]{margin-top:1px}.in-network-pharmacy[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent5)}.out-of-network-pharmacy[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent1)}@media (max-width: 767px){.plan-details-section-left[_ngcontent-%COMP%]{border-width:0;padding:6px 5px 0 10px}.plan-details-section-right[_ngcontent-%COMP%]{padding:4px 5px 15px 10px;border:none}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanPharmacyDetailsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-pharmacy-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div [ngClass]=\"{ 'row mx-0': !isComparePage }\" *ngFor=\"let pharmacy of pharmacies\">\r\n  <div\r\n    role=\"rowheader\"\r\n    id=\"plan-pharmacy-details\"\r\n    *ngIf=\"!isComparePage\"\r\n    class=\"Spa_Style_H5 plan-level-header plan-details-section-left m-0 col-md-4\"\r\n    [ngClass]=\"{ 'gray-static': !(mobile$ | async) }\"\r\n  >\r\n    <span class=\"no-translate-block\">{{ pharmacy.name }}</span>\r\n    <span *ngIf=\"primaryPharmacy && pharmacy.nabp === primaryPharmacy.nabp && showPrimaryPharmacyLabel\">({{ primaryPharmacyText }})</span>\r\n  </div>\r\n  <div role=\"cell\" [ngClass]=\"{ 'plan-details-section-right col-md-8': !isComparePage }\">\r\n    <div>\r\n      <span *ngIf=\"isComparePage\" class=\"sr-only no-translate-block\">{{ planName }}</span>\r\n      <div\r\n        class=\"Spa_Style_H4 mb-0 mt-1 mt-md-0 d-flex\"\r\n        [ngClass]=\"isComparePage ? 'justify-content-center justify-content-lg-start' : 'justify-content-start'\"\r\n      >\r\n        <ng-container *ngIf=\"showNotCovered && !isComparePage; else showPharmacyCoverage\">\r\n          <i class=\"fas fa-times-circle out-of-network-pharmacy\" aria-hidden=\"true\"></i>\r\n          <div class=\"pl-1 pr-0\">{{ nonCoveredText }}</div>\r\n        </ng-container>\r\n        <ng-template #showPharmacyCoverage>\r\n          <ng-container *ngIf=\"pharmacy.isInNetwork; else outOfNetworkPharmacy\">\r\n            <ng-container *ngIf=\"pharmacy.isPreferred; else standardPharmacy\">\r\n              <i class=\"fas fa-check-circle in-network-pharmacy\" [ngClass]=\"{ 'pharmacy-icon': isComparePage }\" aria-hidden=\"true\"></i>\r\n              <div class=\"pl-1 pr-0\">{{ inNetworkPreferredText }}</div>\r\n            </ng-container>\r\n            <ng-template #standardPharmacy>\r\n              <i class=\"fas fa-check-circle in-network-pharmacy\" [ngClass]=\"{ 'pharmacy-icon': isComparePage }\" aria-hidden=\"true\"></i>\r\n              <div class=\"pl-1 pr-0\">{{ inNetworkStandardText }}</div>\r\n            </ng-template>\r\n          </ng-container>\r\n          <ng-template #outOfNetworkPharmacy>\r\n            <i class=\"fas fa-times-circle out-of-network-pharmacy\" [ngClass]=\"{ 'pharmacy-icon': isComparePage }\" aria-hidden=\"true\"></i>\r\n            <div class=\"pl-1 pr-0\">{{ outOfNetworkText }}</div>\r\n          </ng-template>\r\n        </ng-template>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<ng-container *ngIf=\"showNotCovered && isComparePage\">\r\n  <div class=\"Spa_Style_H4 mb-0 mt-1 mt-md-0 d-flex justify-content-center justify-content-lg-start\">\r\n    <i class=\"fas fa-times-circle out-of-network-pharmacy pharmacy-icon\" aria-hidden=\"true\"></i>\r\n    <div class=\"pl-1 pr-0\">{{ nonCoveredText }}</div>\r\n  </div>\r\n</ng-container>\r\n", styles: [".plan-details-section-left{border-right:1px solid var(--static-Spa_Style_Accent1);border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:15px 0 15px 10px}.plan-details-section-right{border:1px solid var(--static-Spa_Style_Accent1);border-width:0 0 1px;padding:15px 5px 15px 10px}.gray-static{background-color:var(--static-Spa_Style_Gray1)}.pharmacy-icon{margin-top:1px}.in-network-pharmacy{color:var(--static-Spa_Style_Accent5)}.out-of-network-pharmacy{color:var(--static-Spa_Style_Accent1)}@media (max-width: 767px){.plan-details-section-left{border-width:0;padding:6px 5px 0 10px}.plan-details-section-right{padding:4px 5px 15px 10px;border:none}}\n"] }]
    }], function () { return [{ type: PlanDetailsFacade }]; }, { pharmacies: [{
            type: Input
        }], inNetworkPreferredText: [{
            type: Input
        }], inNetworkStandardText: [{
            type: Input
        }], outOfNetworkText: [{
            type: Input
        }], isComparePage: [{
            type: Input
        }], planName: [{
            type: Input
        }], showPrimaryPharmacyLabel: [{
            type: Input
        }], primaryPharmacyText: [{
            type: Input
        }], primaryPharmacy: [{
            type: Input
        }], nonCoveredText: [{
            type: Input
        }], showNotCovered: [{
            type: Input
        }] }); })();

function PlanLevelContentComponent_div_0_div_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.planLevelContentLabel, " ");
} }
const _c0$11 = function (a0) { return { "col-md-4 plan-level-header plan-level-section-left": a0 }; };
function PlanLevelContentComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, PlanLevelContentComponent_div_0_div_2_span_1_Template, 2, 1, "span", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$11, !ctx_r1.isComparePage));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", ctx_r1.getLiveEditPlanLevelContentLabel());
} }
function PlanLevelContentComponent_div_0_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.plan.planName);
} }
const _c1$n = function (a0) { return { "plan-level-content-container": a0 }; };
const _c2$h = function (a0) { return { "col-md-8 plan-level-section-right": a0 }; };
function PlanLevelContentComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 1);
    i0.ɵɵtemplate(2, PlanLevelContentComponent_div_0_div_2_Template, 2, 4, "div", 2);
    i0.ɵɵelementStart(3, "div", 3)(4, "div");
    i0.ɵɵtemplate(5, PlanLevelContentComponent_div_0_span_5_Template, 2, 1, "span", 4);
    i0.ɵɵelement(6, "div", 5);
    i0.ɵɵpipe(7, "safe");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c1$n, !ctx_r0.isComparePage));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isComparePage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c2$h, !ctx_r0.isComparePage));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isComparePage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(7, 6, ctx_r0.planLevelContent, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("aria-colindex", ctx_r0.colIndex);
} }
class PlanLevelContentComponent {
    constructor() {
        this.colIndex = 1;
    }
    get planLevelContent() {
        // plan highlight data will always(if exists) be available in this ID
        const medCategoryId = 298;
        const planHighlights = this.plan?.planDataFields?.find(data => data.benefitID === medCategoryId)?.description;
        if (planHighlights) {
            return planHighlights;
        }
        return this.isComparePage ? this.notApplicableText : '';
    }
    getLiveEditPlanLevelContentLabel() {
        return `Spa_PlanLevel_Content_Label_${this.plan.planTypeAbbreviation}`;
    }
}
PlanLevelContentComponent.ɵfac = function PlanLevelContentComponent_Factory(t) { return new (t || PlanLevelContentComponent)(); };
PlanLevelContentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanLevelContentComponent, selectors: [["vnext-plan-level-content"]], inputs: { plan: "plan", planLevelContentLabel: "planLevelContentLabel", isComparePage: "isComparePage", notApplicableText: "notApplicableText", colIndex: "colIndex" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "row", "mx-0", 3, "ngClass"], ["role", "rowheader", "class", "Spa_Style_Small_Font", 3, "ngClass", 4, "ngIf"], ["role", "cell", 3, "ngClass"], ["class", "sr-only no-translate-block", 4, "ngIf"], ["navigationAdapter", "", 1, "Spa_Style_Gray4_Color", "plan-level-content", 3, "innerHTML"], ["role", "rowheader", 1, "Spa_Style_Small_Font", 3, "ngClass"], [4, "liveEditProp"], [1, "sr-only", "no-translate-block"]], template: function PlanLevelContentComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanLevelContentComponent_div_0_Template, 8, 13, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.planLevelContent);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, NavigationAdapterDirective, LiveEditPropDirective, SafePipe], styles: [".plan-level-section-left[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);background-color:var(--static-Spa_Style_Gray1);padding:10px 0 10px 10px}.plan-level-section-right[_ngcontent-%COMP%]{padding:10px 5px 10px 10px}.plan-level-content-container[_ngcontent-%COMP%]{border:1px solid rgba(0,0,0,.125);border-width:1px 1px 0;font-family:montserrat_light;min-height:60px}.plan-level-header[_ngcontent-%COMP%]{min-height:60px}.plan-level-content[_ngcontent-%COMP%]{font-size:12px}@media (max-width: 767px){.plan-level-section-left[_ngcontent-%COMP%]{border-right:0px;background-color:#fff;padding:10px 5px 0 10px}.plan-level-section-right[_ngcontent-%COMP%]{padding:4px 6px 14px 10px}.plan-level-header[_ngcontent-%COMP%], .plan-level-content-container[_ngcontent-%COMP%]{min-height:70px}.plan-level-header[_ngcontent-%COMP%]{min-height:0px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanLevelContentComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-level-content', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"planLevelContent\">\r\n  <div class=\"row mx-0\" [ngClass]=\"{ 'plan-level-content-container': !isComparePage }\">\r\n    <div\r\n      role=\"rowheader\"\r\n      class=\"Spa_Style_Small_Font\"\r\n      [ngClass]=\"{ 'col-md-4 plan-level-header plan-level-section-left': !isComparePage }\"\r\n      *ngIf=\"!isComparePage\"\r\n    >\r\n      <span *liveEditProp=\"getLiveEditPlanLevelContentLabel()\">\r\n        {{ planLevelContentLabel }}\r\n      </span>\r\n    </div>\r\n    <div role=\"cell\" [ngClass]=\"{ 'col-md-8 plan-level-section-right': !isComparePage }\">\r\n      <div>\r\n        <span *ngIf=\"isComparePage\" class=\"sr-only no-translate-block\">{{ plan.planName }}</span>\r\n        <div\r\n          class=\"Spa_Style_Gray4_Color plan-level-content\"\r\n          [innerHTML]=\"planLevelContent | safe: 'html'\"\r\n          navigationAdapter\r\n          [attr.aria-colindex]=\"colIndex\"\r\n        ></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".plan-level-section-left{border-right:1px solid var(--static-Spa_Style_Accent1);background-color:var(--static-Spa_Style_Gray1);padding:10px 0 10px 10px}.plan-level-section-right{padding:10px 5px 10px 10px}.plan-level-content-container{border:1px solid rgba(0,0,0,.125);border-width:1px 1px 0;font-family:montserrat_light;min-height:60px}.plan-level-header{min-height:60px}.plan-level-content{font-size:12px}@media (max-width: 767px){.plan-level-section-left{border-right:0px;background-color:#fff;padding:10px 5px 0 10px}.plan-level-section-right{padding:4px 6px 14px 10px}.plan-level-header,.plan-level-content-container{min-height:70px}.plan-level-header{min-height:0px}}\n"] }]
    }], null, { plan: [{
            type: Input
        }], planLevelContentLabel: [{
            type: Input
        }], isComparePage: [{
            type: Input
        }], notApplicableText: [{
            type: Input
        }], colIndex: [{
            type: Input
        }] }); })();

function PlanProviderDetailsComponent_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", ctx_r2.pcpText, ")");
} }
function PlanProviderDetailsComponent_div_1_ng_container_8_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "titlecase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r7.provider.address2));
} }
function PlanProviderDetailsComponent_div_1_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PlanProviderDetailsComponent_div_1_ng_container_8_div_4_Template, 3, 3, "div", 8);
    i0.ɵɵelementStart(5, "div", 7);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 5, ctx_r3.provider.address1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.provider.address2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3("", i0.ɵɵpipeBind1(7, 7, ctx_r3.provider.city), ", ", ctx_r3.provider.state, ", ", ctx_r3.provider.zip, "");
} }
function PlanProviderDetailsComponent_div_1_ng_container_9_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "vnext-widget-provider-inline-element", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("values", ctx_r8.languages)("icon", ctx_r8.languagesIcon);
} }
function PlanProviderDetailsComponent_div_1_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-widget-provider-phone", 9);
    i0.ɵɵtemplate(2, PlanProviderDetailsComponent_div_1_ng_container_9_div_2_Template, 2, 2, "div", 6);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("phoneNumber", ctx_r4.provider.phoneNumber)("countryCode", ctx_r4.countryCode)("showPhoneIcon", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.languages == null ? null : ctx_r4.languages.length);
} }
function PlanProviderDetailsComponent_div_1_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "vnext-widget-provider-inline-element", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("values", ctx_r5.medicalGroups)("icon", "fas fa-building");
} }
function PlanProviderDetailsComponent_div_1_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-value-based-care-agreement", 12);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("customClass", "pt-1")("vbcAgreementLabel", ctx_r6.vbcAgreementLabel)("vbcAgreementTooltip", ctx_r6.vbcAgreementTooltip);
} }
const _c0$10 = function (a0) { return { "gray-static": a0 }; };
function PlanProviderDetailsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "titlecase");
    i0.ɵɵtemplate(3, PlanProviderDetailsComponent_div_1_span_3_Template, 2, 1, "span", 2);
    i0.ɵɵelementStart(4, "div", 4)(5, "div", 5)(6, "i");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, PlanProviderDetailsComponent_div_1_ng_container_8_Template, 8, 9, "ng-container", 2);
    i0.ɵɵtemplate(9, PlanProviderDetailsComponent_div_1_ng_container_9_Template, 3, 4, "ng-container", 2);
    i0.ɵɵtemplate(10, PlanProviderDetailsComponent_div_1_div_10_Template, 2, 2, "div", 6);
    i0.ɵɵtemplate(11, PlanProviderDetailsComponent_div_1_ng_container_11_Template, 2, 3, "ng-container", 2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("Spa_Style_H5 no-translate-block ", ctx_r0.customClass, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c0$10, !ctx_r0.isMobile && !ctx_r0.isMedium));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 11, ctx_r0.provider == null ? null : ctx_r0.provider.displayName), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.provider == null ? null : ctx_r0.provider.isPrimary);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.provider == null ? null : ctx_r0.provider.specialtyDisplayName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.providerInfoEnabled && ctx_r0.provider);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isZelisIntegrationEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.medicalGroups == null ? null : ctx_r0.medicalGroups.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r0.selectedProviderDetails == null ? null : ctx_r0.selectedProviderDetails.hasAgreement) && ctx_r0.isVbcAgreementEnabled);
} }
const _c1$m = function (a0) { return { "provider-details-section-right col-md-8": a0 }; };
function PlanProviderDetailsComponent_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1$m, !ctx_r9.isComparePage));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.noProviderNetworkAccessText, " ");
} }
function PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 18);
    i0.ɵɵelement(2, "i", 0);
    i0.ɵɵelementStart(3, "div", 19);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r15.isComparePage ? "justify-content-center justify-content-lg-start" : "justify-content-start");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", (ctx_r15.selectedProviderDetails == null ? null : ctx_r15.selectedProviderDetails.inNetwork) ? "fas fa-check-circle in-network-provider" : "fas fa-times-circle out-of-network-provider");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r15.selectedProviderDetails == null ? null : ctx_r15.selectedProviderDetails.inNetwork) ? ctx_r15.inNetworkProviderText : ctx_r15.outOfNetworkProviderText);
} }
function PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_div_1_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r22.hideText, " ");
} }
function PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_div_1_div_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(7);
    i0.ɵɵtextInterpolate1("", ctx_r24.viewAllText, " ");
} }
function PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23)(1, "vnext-link", 24);
    i0.ɵɵlistener("click", function PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_div_1_div_1_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r25.showAllProviderLabels = !ctx_r25.showAllProviderLabels); });
    i0.ɵɵelementStart(2, "div", 25);
    i0.ɵɵtemplate(3, PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_div_1_div_1_ng_container_3_Template, 2, 1, "ng-container", 26);
    i0.ɵɵtemplate(4, PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_div_1_div_1_ng_template_4_Template, 1, 1, "ng-template", null, 27, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(6, "i", 28);
    i0.ɵɵelementStart(7, "span", 29);
    i0.ɵɵtext(8, "Expand/Collapse");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const _r23 = i0.ɵɵreference(5);
    const ctx_r20 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("keyNameForLiveEdit", "hide")("makeInlineBlock", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r20.showAllProviderLabels)("ngIfElse", _r23);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r20.showAllProviderLabels ? "fa-angle-up" : "fa-angle-down");
} }
function PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_div_1_div_2_vnext_widget_provider_phone_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-provider-phone", 9);
} if (rf & 2) {
    const addressDetail_r18 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r27 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("phoneNumber", addressDetail_r18.phoneNumber)("countryCode", ctx_r27.countryCode)("showPhoneIcon", true);
} }
function PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_div_1_div_2_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, ",");
    i0.ɵɵelementEnd();
} }
function PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_div_1_div_2_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-widget-provider-accepting-new-patients", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("acceptingNewPatientsIcon", ctx_r29.acceptingNewPatientsIcon)("acceptingNewPatientsText", ctx_r29.acceptingNewPatientsText);
} }
function PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_div_1_div_2_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "vnext-widget-provider-inline-element", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("values", ctx_r30.languages)("icon", ctx_r30.languagesIcon);
} }
function PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30)(1, "div", 31);
    i0.ɵɵelement(2, "i", 0);
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵelementStart(4, "div", 19);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 32);
    i0.ɵɵtemplate(7, PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_div_1_div_2_vnext_widget_provider_phone_7_Template, 1, 3, "vnext-widget-provider-phone", 33);
    i0.ɵɵelementStart(8, "div");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div");
    i0.ɵɵtext(11);
    i0.ɵɵtemplate(12, PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_div_1_div_2_span_12_Template, 2, 0, "span", 2);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_div_1_div_2_div_14_Template, 2, 2, "div", 2);
    i0.ɵɵtemplate(15, PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_div_1_div_2_div_15_Template, 2, 2, "div", 6);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const addressDetail_r18 = i0.ɵɵnextContext().$implicit;
    const ctx_r21 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("ngClass", (addressDetail_r18 == null ? null : addressDetail_r18.inNetwork) ? "Spa_Style_Primary_Color" : "Spa_Style_Gray4_Color");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", (addressDetail_r18 == null ? null : addressDetail_r18.inNetwork) ? "fas fa-check-circle in-network-provider" : "fas fa-times-circle out-of-network-provider");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(addressDetail_r18.inNetwork ? ctx_r21.inNetworkProviderText : ctx_r21.outOfNetworkProviderText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r21.isZelisIntegrationEnabled && addressDetail_r18.phoneNumber);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(addressDetail_r18.addressLine1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", addressDetail_r18.city, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", addressDetail_r18.city && addressDetail_r18.state);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", addressDetail_r18.state, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", addressDetail_r18.acceptingNewPatients);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.isZelisIntegrationEnabled && (ctx_r21.languages == null ? null : ctx_r21.languages.length));
} }
function PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵtemplate(1, PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_div_1_div_1_Template, 9, 5, "div", 21);
    i0.ɵɵtemplate(2, PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_div_1_div_2_Template, 16, 10, "div", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const index_r19 = ctx.index;
    const ctx_r17 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("ngClass", ctx_r17.isComparePage ? "justify-content-center justify-content-lg-start" : "justify-content-start");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", index_r19 === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", index_r19 === 0 || ctx_r17.showAllProviderLabels);
} }
function PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_div_1_Template, 3, 3, "div", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r16.addressList);
} }
function PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_1_Template, 5, 3, "div", 2);
    i0.ɵɵtemplate(2, PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_div_2_Template, 2, 1, "div", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1$m, !ctx_r12.isComparePage));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r12.providerInfoEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.providerInfoEnabled);
} }
const _c2$g = function (a0, a1) { return { "provider-details-section-right col-md-8": a0, "pl-0 provider-compare-details-section-right": a1 }; };
function PlanProviderDetailsComponent_ng_container_2_ng_template_2_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c2$g, !ctx_r14.isComparePage, ctx_r14.isComparePage));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.noProviderDetailsText, " ");
} }
function PlanProviderDetailsComponent_ng_container_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanProviderDetailsComponent_ng_container_2_ng_template_2_div_0_Template, 3, 5, "div", 13);
    i0.ɵɵtemplate(1, PlanProviderDetailsComponent_ng_container_2_ng_template_2_ng_template_1_Template, 2, 5, "ng-template", null, 17, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r13 = i0.ɵɵreference(2);
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r11.hasProviderDetails && !!(ctx_r11.selectedProviderDetails == null ? null : ctx_r11.selectedProviderDetails.npi))("ngIfElse", _r13);
} }
function PlanProviderDetailsComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanProviderDetailsComponent_ng_container_2_div_1_Template, 3, 4, "div", 13);
    i0.ɵɵtemplate(2, PlanProviderDetailsComponent_ng_container_2_ng_template_2_Template, 3, 2, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r10 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.canSellPlan)("ngIfElse", _r10);
} }
const _c3$8 = function (a0) { return { "row mx-0": a0 }; };
class PlanProviderDetailsComponent {
    constructor(providerFacade) {
        this.providerFacade = providerFacade;
        this.addressList = [];
        this.showAllProviderLabels = false;
        this.languages = [];
        this.medicalGroups = [];
    }
    ngOnChanges(changes) {
        const { provider, selectedProviderDetails, providerLanguages, providersAcceptingNewPatients, providerMedicalGroups } = changes;
        const hasProviderUpdates = provider && !_isEqual(provider.previousValue, provider.currentValue);
        if (hasProviderUpdates ||
            (selectedProviderDetails && !_isEqual(selectedProviderDetails.previousValue, selectedProviderDetails.currentValue)) ||
            (providersAcceptingNewPatients && !_isEqual(providersAcceptingNewPatients.previousValue, providersAcceptingNewPatients.currentValue))) {
            this.handleProviderAddresses();
        }
        if (hasProviderUpdates || (providerLanguages && !_isEqual(providerLanguages.previousValue, providerLanguages.currentValue))) {
            this.updateLanguages();
        }
        if (hasProviderUpdates ||
            (providerMedicalGroups && !_isEqual(providerMedicalGroups.previousValue, providerMedicalGroups.currentValue))) {
            this.updateProviderMedicalGroups();
        }
    }
    updateLanguages() {
        this.languages = this.providerLanguages?.[this.provider.npis[0]] ?? [];
    }
    updateProviderMedicalGroups() {
        this.medicalGroups = this.providerMedicalGroups?.[this.provider.npis[0]] ?? [];
    }
    handleProviderAddresses() {
        if (this.providerInfoEnabled) {
            const allProviderDetails = this.providerFacade.getProviderDetailInfo(this.planId, this.providerDetailResponse);
            const providerAddresses = this.providerFacade.getProviderAddresses(allProviderDetails, this.selectedProviderDetails?.npi ?? this.provider.npis[0]);
            this.addressList = ProviderUtilityService.getCoverageProviderAddresses(this.provider, providerAddresses, this.providersAcceptingNewPatients);
        }
    }
}
PlanProviderDetailsComponent.ɵfac = function PlanProviderDetailsComponent_Factory(t) { return new (t || PlanProviderDetailsComponent)(i0.ɵɵdirectiveInject(ProviderFacade)); };
PlanProviderDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanProviderDetailsComponent, selectors: [["vnext-plan-provider-details"]], inputs: { provider: "provider", isComparePage: "isComparePage", providerDetailResponse: "providerDetailResponse", planId: "planId", selectedProviderDetails: "selectedProviderDetails", inNetworkProviderText: "inNetworkProviderText", outOfNetworkProviderText: "outOfNetworkProviderText", noProviderDetailsText: "noProviderDetailsText", pcpText: "pcpText", isMobile: "isMobile", isMedium: "isMedium", showNetworkDetails: "showNetworkDetails", showProviderDetails: "showProviderDetails", customClass: "customClass", noProviderNetworkAccessText: "noProviderNetworkAccessText", hasProviderDetails: "hasProviderDetails", canSellPlan: "canSellPlan", viewAllText: "viewAllText", hideText: "hideText", providerInfoEnabled: "providerInfoEnabled", countryCode: "countryCode", acceptingNewPatientsText: "acceptingNewPatientsText", acceptingNewPatientsIcon: "acceptingNewPatientsIcon", languagesIcon: "languagesIcon", providerLanguages: "providerLanguages", providersAcceptingNewPatients: "providersAcceptingNewPatients", providerMedicalGroups: "providerMedicalGroups", isVbcAgreementEnabled: "isVbcAgreementEnabled", vbcAgreementLabel: "vbcAgreementLabel", vbcAgreementTooltip: "vbcAgreementTooltip", isZelisIntegrationEnabled: "isZelisIntegrationEnabled" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 5, consts: [[3, "ngClass"], ["role", "rowheader", 3, "class", "ngClass", 4, "ngIf"], [4, "ngIf"], ["role", "rowheader", 3, "ngClass"], [1, "pt-2", "Spa_Style_Note"], [1, "mb-2"], ["class", "Spa_Style_Note mt-1 mb-1", 4, "ngIf"], [1, "p-0"], ["class", "p-0", 4, "ngIf"], [3, "phoneNumber", "countryCode", "showPhoneIcon"], [1, "Spa_Style_Note", "mt-1", "mb-1"], [3, "values", "icon"], [3, "customClass", "vbcAgreementLabel", "vbcAgreementTooltip"], ["role", "cell", 3, "ngClass", 4, "ngIf", "ngIfElse"], ["providerDetailsSection", ""], ["role", "cell", 3, "ngClass"], [1, "px-0", "Spa_Style_H5"], ["noProviderDetails", ""], [1, "Spa_Style_H4", "mb-0", "mt-1", "mt-md-0", "d-flex", 3, "ngClass"], [1, "pl-1", "pr-0"], [3, "ngClass", 4, "ngFor", "ngForOf"], ["class", "mb-1", 4, "ngIf"], ["class", "mt-2", 3, "ngClass", 4, "ngIf"], [1, "mb-1"], [3, "keyNameForLiveEdit", "makeInlineBlock", "click"], ["link-body", "", 1, "pl-0"], [4, "ngIf", "ngIfElse"], ["showViewAll", ""], [1, "fas", "ml-1", 3, "ngClass"], [1, "sr-only"], [1, "mt-2", 3, "ngClass"], [1, "Spa_Style_H4", "mb-0", "mt-1", "mt-md-0", "d-flex"], [1, "px-4", "no-translate-block"], [3, "phoneNumber", "countryCode", "showPhoneIcon", 4, "ngIf"], [3, "acceptingNewPatientsIcon", "acceptingNewPatientsText"], [1, "pr-0", "col-md-8", "Spa_Style_H5", 3, "ngClass"]], template: function PlanProviderDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, PlanProviderDetailsComponent_div_1_Template, 12, 15, "div", 1);
        i0.ɵɵtemplate(2, PlanProviderDetailsComponent_ng_container_2_Template, 4, 2, "ng-container", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c3$8, !ctx.isComparePage));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showProviderDetails);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showNetworkDetails);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, ProviderAcceptingNewPatientsComponent, ProviderInlineElementComponent, ProviderPhoneComponent, ValueBasedCareAgreementComponent, IconAriaAttributesDirective, i1$2.TitleCasePipe], styles: [".gray-static[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray1)}.provider-details-section-right[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-width:0 0 1px;padding:15px 5px 15px 10px}.provider-compare-details-section-right[_ngcontent-%COMP%]{padding:0 5px 0 10px}.in-network-provider[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent5)}.out-of-network-provider[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent1)}.provider-details-section-left[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:15px 0 15px 10px}@media (max-width: 767px){.provider-details-section-left[_ngcontent-%COMP%]{border-width:0;padding:6px 5px 0 10px}.provider-details-section-right[_ngcontent-%COMP%]{padding:4px 5px 15px 10px;border:1px solid var(--static-Spa_Style_Accent1);border-width:0 0 1px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanProviderDetailsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-provider-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div [ngClass]=\"{ 'row mx-0': !isComparePage }\">\r\n  <div\r\n    role=\"rowheader\"\r\n    *ngIf=\"showProviderDetails\"\r\n    class=\"Spa_Style_H5 no-translate-block {{ customClass }}\"\r\n    [ngClass]=\"{ 'gray-static': !isMobile && !isMedium }\"\r\n  >\r\n    {{ provider?.displayName | titlecase }}\r\n    <span *ngIf=\"provider?.isPrimary\">({{ pcpText }})</span>\r\n    <div class=\"pt-2 Spa_Style_Note\">\r\n      <div class=\"mb-2\">\r\n        <i>{{ provider?.specialtyDisplayName }}</i>\r\n      </div>\r\n      <ng-container *ngIf=\"!providerInfoEnabled && provider\">\r\n        <div class=\"p-0\">{{ provider.address1 | titlecase }}</div>\r\n        <div *ngIf=\"provider.address2\" class=\"p-0\">{{ provider.address2 | titlecase }}</div>\r\n        <div class=\"p-0\">{{ provider.city | titlecase }}, {{ provider.state }}, {{ provider.zip }}</div>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"!isZelisIntegrationEnabled\">\r\n        <vnext-widget-provider-phone\r\n          [phoneNumber]=\"provider.phoneNumber\"\r\n          [countryCode]=\"countryCode\"\r\n          [showPhoneIcon]=\"true\"\r\n        ></vnext-widget-provider-phone>\r\n        <div class=\"Spa_Style_Note mt-1 mb-1\" *ngIf=\"languages?.length\">\r\n          <vnext-widget-provider-inline-element [values]=\"languages\" [icon]=\"languagesIcon\"> </vnext-widget-provider-inline-element>\r\n        </div>\r\n      </ng-container>\r\n      <div class=\"Spa_Style_Note mt-1 mb-1\" *ngIf=\"medicalGroups?.length\">\r\n        <vnext-widget-provider-inline-element [values]=\"medicalGroups\" [icon]=\"'fas fa-building'\"> </vnext-widget-provider-inline-element>\r\n      </div>\r\n      <ng-container *ngIf=\"selectedProviderDetails?.hasAgreement && isVbcAgreementEnabled\">\r\n        <vnext-value-based-care-agreement\r\n          [customClass]=\"'pt-1'\"\r\n          [vbcAgreementLabel]=\"vbcAgreementLabel\"\r\n          [vbcAgreementTooltip]=\"vbcAgreementTooltip\"\r\n        ></vnext-value-based-care-agreement>\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n  <ng-container *ngIf=\"showNetworkDetails\">\r\n    <div\r\n      role=\"cell\"\r\n      [ngClass]=\"{ 'provider-details-section-right col-md-8': !isComparePage }\"\r\n      *ngIf=\"!canSellPlan; else providerDetailsSection\"\r\n    >\r\n      <div class=\"px-0 Spa_Style_H5\">\r\n        {{ noProviderNetworkAccessText }}\r\n      </div>\r\n    </div>\r\n    <ng-template #providerDetailsSection>\r\n      <div\r\n        role=\"cell\"\r\n        [ngClass]=\"{ 'provider-details-section-right col-md-8': !isComparePage }\"\r\n        *ngIf=\"hasProviderDetails && !!selectedProviderDetails?.npi; else noProviderDetails\"\r\n      >\r\n        <div *ngIf=\"!providerInfoEnabled\">\r\n          <div\r\n            class=\"Spa_Style_H4 mb-0 mt-1 mt-md-0 d-flex\"\r\n            [ngClass]=\"isComparePage ? 'justify-content-center justify-content-lg-start' : 'justify-content-start'\"\r\n          >\r\n            <i\r\n              [ngClass]=\"\r\n                selectedProviderDetails?.inNetwork\r\n                  ? 'fas fa-check-circle in-network-provider'\r\n                  : 'fas fa-times-circle out-of-network-provider'\r\n              \"\r\n            ></i>\r\n            <div class=\"pl-1 pr-0\">{{ selectedProviderDetails?.inNetwork ? inNetworkProviderText : outOfNetworkProviderText }}</div>\r\n          </div>\r\n        </div>\r\n\r\n        <div *ngIf=\"providerInfoEnabled\">\r\n          <div\r\n            [ngClass]=\"isComparePage ? 'justify-content-center justify-content-lg-start' : 'justify-content-start'\"\r\n            *ngFor=\"let addressDetail of addressList; index as index\"\r\n          >\r\n            <div *ngIf=\"index === 1\" class=\"mb-1\">\r\n              <vnext-link [keyNameForLiveEdit]=\"'hide'\" [makeInlineBlock]=\"true\" (click)=\"showAllProviderLabels = !showAllProviderLabels\">\r\n                <div class=\"pl-0\" link-body>\r\n                  <ng-container *ngIf=\"showAllProviderLabels; else showViewAll\">{{ hideText }} </ng-container\r\n                  ><ng-template #showViewAll>{{ viewAllText }} </ng-template>\r\n                  <i class=\"fas ml-1\" [ngClass]=\"showAllProviderLabels ? 'fa-angle-up' : 'fa-angle-down'\"></i>\r\n                  <span class=\"sr-only\">Expand/Collapse</span>\r\n                </div>\r\n              </vnext-link>\r\n            </div>\r\n            <div\r\n              class=\"mt-2\"\r\n              *ngIf=\"index === 0 || showAllProviderLabels\"\r\n              [ngClass]=\"addressDetail?.inNetwork ? 'Spa_Style_Primary_Color' : 'Spa_Style_Gray4_Color'\"\r\n            >\r\n              <div class=\"Spa_Style_H4 mb-0 mt-1 mt-md-0 d-flex\">\r\n                <i\r\n                  [ngClass]=\"\r\n                    addressDetail?.inNetwork ? 'fas fa-check-circle in-network-provider' : 'fas fa-times-circle out-of-network-provider'\r\n                  \"\r\n                ></i>\r\n                <ng-container>\r\n                  <div class=\"pl-1 pr-0\">{{ addressDetail.inNetwork ? inNetworkProviderText : outOfNetworkProviderText }}</div>\r\n                </ng-container>\r\n              </div>\r\n              <div class=\"px-4 no-translate-block\">\r\n                <vnext-widget-provider-phone\r\n                  *ngIf=\"isZelisIntegrationEnabled && addressDetail.phoneNumber\"\r\n                  [phoneNumber]=\"addressDetail.phoneNumber\"\r\n                  [countryCode]=\"countryCode\"\r\n                  [showPhoneIcon]=\"true\"\r\n                ></vnext-widget-provider-phone>\r\n                <div>{{ addressDetail.addressLine1 }}</div>\r\n                <div>\r\n                  {{ addressDetail.city }}<span *ngIf=\"addressDetail.city && addressDetail.state\">,</span> {{ addressDetail.state }}\r\n                </div>\r\n                <div *ngIf=\"addressDetail.acceptingNewPatients\">\r\n                  <vnext-widget-provider-accepting-new-patients\r\n                    [acceptingNewPatientsIcon]=\"acceptingNewPatientsIcon\"\r\n                    [acceptingNewPatientsText]=\"acceptingNewPatientsText\"\r\n                  ></vnext-widget-provider-accepting-new-patients>\r\n                </div>\r\n                <div class=\"Spa_Style_Note mt-1 mb-1\" *ngIf=\"isZelisIntegrationEnabled && languages?.length\">\r\n                  <vnext-widget-provider-inline-element [values]=\"languages\" [icon]=\"languagesIcon\"> </vnext-widget-provider-inline-element>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <ng-template #noProviderDetails>\r\n        <div\r\n          [ngClass]=\"{\r\n            'provider-details-section-right col-md-8': !isComparePage,\r\n            'pl-0 provider-compare-details-section-right': isComparePage\r\n          }\"\r\n          class=\"pr-0 col-md-8 Spa_Style_H5\"\r\n        >\r\n          {{ noProviderDetailsText }}\r\n        </div>\r\n      </ng-template>\r\n    </ng-template>\r\n  </ng-container>\r\n</div>\r\n", styles: [".gray-static{background-color:var(--static-Spa_Style_Gray1)}.provider-details-section-right{border:1px solid var(--static-Spa_Style_Accent1);border-width:0 0 1px;padding:15px 5px 15px 10px}.provider-compare-details-section-right{padding:0 5px 0 10px}.in-network-provider{color:var(--static-Spa_Style_Accent5)}.out-of-network-provider{color:var(--static-Spa_Style_Accent1)}.provider-details-section-left{border-right:1px solid var(--static-Spa_Style_Accent1);border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:15px 0 15px 10px}@media (max-width: 767px){.provider-details-section-left{border-width:0;padding:6px 5px 0 10px}.provider-details-section-right{padding:4px 5px 15px 10px;border:1px solid var(--static-Spa_Style_Accent1);border-width:0 0 1px}}\n"] }]
    }], function () { return [{ type: ProviderFacade }]; }, { provider: [{
            type: Input
        }], isComparePage: [{
            type: Input
        }], providerDetailResponse: [{
            type: Input
        }], planId: [{
            type: Input
        }], selectedProviderDetails: [{
            type: Input
        }], inNetworkProviderText: [{
            type: Input
        }], outOfNetworkProviderText: [{
            type: Input
        }], noProviderDetailsText: [{
            type: Input
        }], pcpText: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], isMedium: [{
            type: Input
        }], showNetworkDetails: [{
            type: Input
        }], showProviderDetails: [{
            type: Input
        }], customClass: [{
            type: Input
        }], noProviderNetworkAccessText: [{
            type: Input
        }], hasProviderDetails: [{
            type: Input
        }], canSellPlan: [{
            type: Input
        }], viewAllText: [{
            type: Input
        }], hideText: [{
            type: Input
        }], providerInfoEnabled: [{
            type: Input
        }], countryCode: [{
            type: Input
        }], acceptingNewPatientsText: [{
            type: Input
        }], acceptingNewPatientsIcon: [{
            type: Input
        }], languagesIcon: [{
            type: Input
        }], providerLanguages: [{
            type: Input
        }], providersAcceptingNewPatients: [{
            type: Input
        }], providerMedicalGroups: [{
            type: Input
        }], isVbcAgreementEnabled: [{
            type: Input
        }], vbcAgreementLabel: [{
            type: Input
        }], vbcAgreementTooltip: [{
            type: Input
        }], isZelisIntegrationEnabled: [{
            type: Input
        }] }); })();

function PlanSubDetailsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelement(1, "vnext-plan-level-content", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", ctx_r0.detailedPlan)("planLevelContentLabel", ctx_r0.planLevelContentLabel);
} }
function PlanSubDetailsComponent_div_2_ng_template_3_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.costSectionHeader, "");
} }
function PlanSubDetailsComponent_div_2_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "button", 21)(2, "span", 22);
    i0.ɵɵtemplate(3, PlanSubDetailsComponent_div_2_ng_template_3_span_3_Template, 2, 1, "span", 23);
    i0.ɵɵelement(4, "i", 24);
    i0.ɵɵelementStart(5, "span", 25);
    i0.ɵɵtext(6, "Collapse");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", ctx_r9.costSectionHeader);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_PlanDetails_Costs_Header");
} }
function PlanSubDetailsComponent_div_2_ng_template_4_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r13.costSectionHeader, " type");
} }
function PlanSubDetailsComponent_div_2_ng_template_4_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r14.costSectionHeader, " amount");
} }
function PlanSubDetailsComponent_div_2_ng_template_4_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-cost-section", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("preferencesBannerEnabled", ctx_r15.preferencesBannerEnabled)("healthEnabled", ctx_r15.healthEnabled)("costDetails", ctx_r15.costMAPD)("plan", ctx_r15.detailedPlan)("costAddEditLinkText", ctx_r15.costAddEditLinkText)("noCostAvailableText", ctx_r15.noCostAvailableText)("healthText", ctx_r15.healthText)("annualCost", ctx_r15.annualCost)("selectedPharmacy", ctx_r15.selectedPharmacy)("isMailOrderSelected", ctx_r15.isMailOrderSelected)("addHealthCostText", ctx_r15.addHealthCostText)("modalHeaderHealthText", ctx_r15.modalHeaderHealthText)("closeButtonText", ctx_r15.closeButtonText)("healthCostsBenefits", ctx_r15.healthCostsBenefits)("healthCostsBodyText", ctx_r15.healthCostsBodyText)("healthCostsBenefitsBodyText", ctx_r15.healthCostsBenefitsBodyText)("healthCostsBenefitsTableHeader", ctx_r15.healthCostsBenefitsTableHeader)("healthCostsDaysTableHeader", ctx_r15.healthCostsDaysTableHeader)("saveFailedText", ctx_r15.saveFailedText)("healthCostsUpdateAnswersText", ctx_r15.healthCostsUpdateAnswersText)("healthCostsRestoreDefaultsText", ctx_r15.healthCostsRestoreDefaultsText)("healthCostsSaveAnswersText", ctx_r15.healthCostsSaveAnswersText)("saveSuccessText", ctx_r15.saveSuccessText)("healthAgeQuestionText", ctx_r15.healthAgeQuestionText)("healthCostsCustomizationEnabled", ctx_r15.healthCostsCustomizationEnabled)("healthSliderHeader1Text", ctx_r15.healthSliderHeader1Text)("healthSliderHeader2Text", ctx_r15.healthSliderHeader2Text)("healthSliderHeader3Text", ctx_r15.healthSliderHeader3Text)("healthSliderBody1", ctx_r15.healthSliderBody1)("healthSliderBody2", ctx_r15.healthSliderBody2)("healthSliderBody3", ctx_r15.healthSliderBody3)("healthSliderLabelText", ctx_r15.healthSliderLabelText)("healthModalView1HeadingText", ctx_r15.healthModalView1HeadingText)("healthModalView1IntroText", ctx_r15.healthModalView1IntroText)("healthCostsUsageTableHeader", ctx_r15.healthCostsUsageTableHeader);
} }
function PlanSubDetailsComponent_div_2_ng_template_4_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-cost-section", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("preferencesBannerEnabled", ctx_r16.preferencesBannerEnabled)("healthEnabled", ctx_r16.healthEnabled)("costDetails", ctx_r16.costMA)("plan", ctx_r16.detailedPlan)("costAddEditLinkText", ctx_r16.costAddEditLinkText)("noCostAvailableText", ctx_r16.noCostAvailableText)("healthText", ctx_r16.healthText)("annualCost", ctx_r16.annualCost)("selectedPharmacy", ctx_r16.selectedPharmacy)("isMailOrderSelected", ctx_r16.isMailOrderSelected)("addHealthCostText", ctx_r16.addHealthCostText)("modalHeaderHealthText", ctx_r16.modalHeaderHealthText)("closeButtonText", ctx_r16.closeButtonText)("healthCostsBenefits", ctx_r16.healthCostsBenefits)("healthCostsBodyText", ctx_r16.healthCostsBodyText)("healthCostsBenefitsBodyText", ctx_r16.healthCostsBenefitsBodyText)("healthCostsBenefitsTableHeader", ctx_r16.healthCostsBenefitsTableHeader)("healthCostsDaysTableHeader", ctx_r16.healthCostsDaysTableHeader)("saveFailedText", ctx_r16.saveFailedText)("healthCostsUpdateAnswersText", ctx_r16.healthCostsUpdateAnswersText)("healthCostsSaveAnswersText", ctx_r16.healthCostsSaveAnswersText)("healthCostsRestoreDefaultsText", ctx_r16.healthCostsRestoreDefaultsText)("saveSuccessText", ctx_r16.saveSuccessText)("healthAgeQuestionText", ctx_r16.healthAgeQuestionText)("healthCostsCustomizationEnabled", ctx_r16.healthCostsCustomizationEnabled)("healthSliderHeader1Text", ctx_r16.healthSliderHeader1Text)("healthSliderHeader2Text", ctx_r16.healthSliderHeader2Text)("healthSliderHeader3Text", ctx_r16.healthSliderHeader3Text)("healthSliderBody1", ctx_r16.healthSliderBody1)("healthSliderBody2", ctx_r16.healthSliderBody2)("healthSliderBody3", ctx_r16.healthSliderBody3)("healthSliderLabelText", ctx_r16.healthSliderLabelText)("healthModalView1HeadingText", ctx_r16.healthModalView1HeadingText)("healthModalView1IntroText", ctx_r16.healthModalView1IntroText)("healthCostsUsageTableHeader", ctx_r16.healthCostsUsageTableHeader);
} }
function PlanSubDetailsComponent_div_2_ng_template_4_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-cost-section", 37);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("preferencesBannerEnabled", ctx_r17.preferencesBannerEnabled)("healthEnabled", ctx_r17.healthEnabled)("costDetails", ctx_r17.costPDP)("plan", ctx_r17.detailedPlan)("costAddEditLinkText", ctx_r17.costAddEditLinkText)("noCostAvailableText", ctx_r17.noCostAvailableText)("annualCost", ctx_r17.annualCost)("selectedPharmacy", ctx_r17.selectedPharmacy)("isMailOrderSelected", ctx_r17.isMailOrderSelected)("addHealthCostText", ctx_r17.addHealthCostText)("modalHeaderHealthText", ctx_r17.modalHeaderHealthText)("closeButtonText", ctx_r17.closeButtonText)("healthCostsBenefits", ctx_r17.healthCostsBenefits)("healthCostsBodyText", ctx_r17.healthCostsBodyText)("healthCostsBenefitsBodyText", ctx_r17.healthCostsBenefitsBodyText)("healthCostsBenefitsTableHeader", ctx_r17.healthCostsBenefitsTableHeader)("healthCostsDaysTableHeader", ctx_r17.healthCostsDaysTableHeader)("saveFailedText", ctx_r17.saveFailedText)("healthCostsUpdateAnswersText", ctx_r17.healthCostsUpdateAnswersText)("healthCostsRestoreDefaultsText", ctx_r17.healthCostsRestoreDefaultsText)("healthCostsSaveAnswersText", ctx_r17.healthCostsSaveAnswersText)("saveSuccessText", ctx_r17.saveSuccessText)("healthAgeQuestionText", ctx_r17.healthAgeQuestionText)("healthCostsCustomizationEnabled", ctx_r17.healthCostsCustomizationEnabled)("healthSliderHeader1Text", ctx_r17.healthSliderHeader1Text)("healthSliderHeader2Text", ctx_r17.healthSliderHeader2Text)("healthSliderHeader3Text", ctx_r17.healthSliderHeader3Text)("healthSliderBody1", ctx_r17.healthSliderBody1)("healthSliderBody2", ctx_r17.healthSliderBody2)("healthSliderBody3", ctx_r17.healthSliderBody3)("healthSliderLabelText", ctx_r17.healthSliderLabelText)("healthModalView1HeadingText", ctx_r17.healthModalView1HeadingText)("healthModalView1IntroText", ctx_r17.healthModalView1IntroText)("healthCostsUsageTableHeader", ctx_r17.healthCostsUsageTableHeader);
} }
function PlanSubDetailsComponent_div_2_ng_template_4_div_11_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-cost-section", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("preferencesBannerEnabled", ctx_r19.preferencesBannerEnabled)("healthEnabled", ctx_r19.healthEnabled)("costDetails", ctx_r19.costMEDIGAP)("plan", ctx_r19.detailedPlan)("costAddEditLinkText", ctx_r19.costAddEditLinkText)("noCostAvailableText", ctx_r19.noCostAvailableText)("healthText", ctx_r19.healthText)("annualCost", ctx_r19.annualCost)("selectedPharmacy", ctx_r19.selectedPharmacy)("isMailOrderSelected", ctx_r19.isMailOrderSelected)("addHealthCostText", ctx_r19.addHealthCostText)("modalHeaderHealthText", ctx_r19.modalHeaderHealthText)("closeButtonText", ctx_r19.closeButtonText)("healthCostsBenefits", ctx_r19.healthCostsBenefits)("healthCostsBodyText", ctx_r19.healthCostsBodyText)("healthCostsBenefitsBodyText", ctx_r19.healthCostsBenefitsBodyText)("healthCostsBenefitsTableHeader", ctx_r19.healthCostsBenefitsTableHeader)("healthCostsDaysTableHeader", ctx_r19.healthCostsDaysTableHeader)("saveFailedText", ctx_r19.saveFailedText)("healthCostsUpdateAnswersText", ctx_r19.healthCostsUpdateAnswersText)("healthCostsRestoreDefaultsText", ctx_r19.healthCostsRestoreDefaultsText)("healthCostsSaveAnswersText", ctx_r19.healthCostsSaveAnswersText)("saveSuccessText", ctx_r19.saveSuccessText)("healthAgeQuestionText", ctx_r19.healthAgeQuestionText)("healthCostsCustomizationEnabled", ctx_r19.healthCostsCustomizationEnabled)("healthSliderHeader1Text", ctx_r19.healthSliderHeader1Text)("healthSliderHeader2Text", ctx_r19.healthSliderHeader2Text)("healthSliderHeader3Text", ctx_r19.healthSliderHeader3Text)("healthSliderBody1", ctx_r19.healthSliderBody1)("healthSliderBody2", ctx_r19.healthSliderBody2)("healthSliderBody3", ctx_r19.healthSliderBody3)("healthSliderLabelText", ctx_r19.healthSliderLabelText)("healthModalView1HeadingText", ctx_r19.healthModalView1HeadingText)("healthModalView1IntroText", ctx_r19.healthModalView1IntroText)("healthCostsUsageTableHeader", ctx_r19.healthCostsUsageTableHeader);
} }
function PlanSubDetailsComponent_div_2_ng_template_4_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PlanSubDetailsComponent_div_2_ng_template_4_div_11_div_1_Template, 2, 35, "div", 38);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.showCosts);
} }
function PlanSubDetailsComponent_div_2_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26)(1, "div", 27)(2, "div", 28);
    i0.ɵɵtemplate(3, PlanSubDetailsComponent_div_2_ng_template_4_span_3_Template, 2, 1, "span", 29);
    i0.ɵɵtemplate(4, PlanSubDetailsComponent_div_2_ng_template_4_span_4_Template, 2, 1, "span", 29);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 30);
    i0.ɵɵelement(6, "vnext-plan-cost-details", 31);
    i0.ɵɵelementStart(7, "div", 32);
    i0.ɵɵtemplate(8, PlanSubDetailsComponent_div_2_ng_template_4_div_8_Template, 2, 35, "div", 33);
    i0.ɵɵtemplate(9, PlanSubDetailsComponent_div_2_ng_template_4_div_9_Template, 2, 35, "div", 33);
    i0.ɵɵtemplate(10, PlanSubDetailsComponent_div_2_ng_template_4_div_10_Template, 2, 34, "div", 33);
    i0.ɵɵtemplate(11, PlanSubDetailsComponent_div_2_ng_template_4_div_11_Template, 2, 1, "div", 33);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", "Spa_PlanDetails_Costs_Header");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_PlanDetails_Costs_Header");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("premiumLabel", ctx_r10.premiumLabel)("premium", ctx_r10.getPremium())("premiumText", ctx_r10.premiumText)("mobile", ctx_r10.isMobile)("isHCPlan", ctx_r10.isHCPlan)("isNonMedicarePlan", ctx_r10.isNonMedicarePlan)("planFeesEnabled", ctx_r10.planFeesEnabled)("planFees", ctx_r10.detailedPlan.fees)("planFeesLabelText", ctx_r10.planFeesLabelText)("notApplicableText", ctx_r10.noCostAvailableText)("planFeesIncludedInPremiumTooltipText", ctx_r10.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r10.planFeesNotIncludedInPremiumTooltipText)("snpPremiumRangeEnabled", ctx_r10.snpPremiumRangeEnabled)("planPremiumInitialRange", ctx_r10.planPremiumInitialRange);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r10.detailedPlan.planType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r10.planType.MAPD);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r10.planType.MA);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r10.planType.PDP);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r10.planType.MEDIGAP);
} }
function PlanSubDetailsComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17)(1, "ngb-accordion", 18)(2, "ngb-panel", 19);
    i0.ɵɵtemplate(3, PlanSubDetailsComponent_div_2_ng_template_3_Template, 7, 2, "ng-template", 6);
    i0.ɵɵtemplate(4, PlanSubDetailsComponent_div_2_ng_template_4_Template, 12, 21, "ng-template", 7);
    i0.ɵɵelementEnd()()();
} }
function PlanSubDetailsComponent_ng_template_7_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r21.planBenefitSectionName, " ");
} }
function PlanSubDetailsComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "button", 21)(2, "span", 22);
    i0.ɵɵtemplate(3, PlanSubDetailsComponent_ng_template_7_span_3_Template, 2, 1, "span", 23);
    i0.ɵɵelement(4, "i", 24);
    i0.ɵɵelementStart(5, "span", 25);
    i0.ɵɵtext(6, "Collapse");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", ctx_r2.planBenefitSectionName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Plan_Benefits_Section_Name");
} }
function PlanSubDetailsComponent_ng_template_8_div_0_div_1_ng_container_1_4_ng_template_0_h3_1_vnext_tooltip_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-tooltip", 50);
    i0.ɵɵelement(1, "i", 51);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const extendedDetails_r25 = i0.ɵɵnextContext(5).$implicit;
    const ctx_r34 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("body", extendedDetails_r25.toolTip)("Spa_Site_Tooltip_Text", ctx_r34.Spa_Site_Tooltip_Text)("customClass", "focus-text focus-circle")("ariaLabel", "More info");
} }
const _c0$$ = function (a0) { return [a0]; };
function PlanSubDetailsComponent_ng_template_8_div_0_div_1_ng_container_1_4_ng_template_0_h3_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 48);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, PlanSubDetailsComponent_ng_template_8_div_0_div_1_ng_container_1_4_ng_template_0_h3_1_vnext_tooltip_2_Template, 2, 4, "vnext-tooltip", 49);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(4);
    const extendedDetails_r25 = ctx_r36.$implicit;
    const i_r26 = ctx_r36.index;
    const ctx_r32 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", extendedDetails_r25.name.toLowerCase() === ctx_r32.planDetailsText.toLowerCase() ? "documents-section-heading" : "benefits-section-heading-" + i0.ɵɵpureFunction1(3, _c0$$, i_r26));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", extendedDetails_r25.name, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", extendedDetails_r25.toolTip);
} }
function PlanSubDetailsComponent_ng_template_8_div_0_div_1_ng_container_1_4_ng_template_0_h3_2_vnext_tooltip_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-tooltip", 50);
    i0.ɵɵelement(1, "i", 53);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const extendedDetails_r25 = i0.ɵɵnextContext(5).$implicit;
    const ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("body", extendedDetails_r25.toolTip)("Spa_Site_Tooltip_Text", ctx_r37.Spa_Site_Tooltip_Text)("customClass", "focus-text focus-circle")("ariaLabel", "More info");
} }
function PlanSubDetailsComponent_ng_template_8_div_0_div_1_ng_container_1_4_ng_template_0_h3_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 52);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, PlanSubDetailsComponent_ng_template_8_div_0_div_1_ng_container_1_4_ng_template_0_h3_2_vnext_tooltip_2_Template, 2, 4, "vnext-tooltip", 49);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const extendedDetails_r25 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", extendedDetails_r25.name, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", extendedDetails_r25.toolTip);
} }
const _c1$l = function (a0) { return { "gray2-static": a0 }; };
function PlanSubDetailsComponent_ng_template_8_div_0_div_1_ng_container_1_4_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵtemplate(1, PlanSubDetailsComponent_ng_template_8_div_0_div_1_ng_container_1_4_ng_template_0_h3_1_Template, 3, 5, "h3", 46);
    i0.ɵɵtemplate(2, PlanSubDetailsComponent_ng_template_8_div_0_div_1_ng_container_1_4_ng_template_0_h3_2_Template, 3, 2, "h3", 47);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const extendedDetails_r25 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r30 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1$l, extendedDetails_r25.headerType === ctx_r30.sectionHeaderType.ONE || extendedDetails_r25.headerType === ctx_r30.sectionHeaderType.TWO));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", extendedDetails_r25.headerType === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", extendedDetails_r25.headerType === ctx_r30.sectionHeaderType.TWO);
} }
function PlanSubDetailsComponent_ng_template_8_div_0_div_1_ng_container_1_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanSubDetailsComponent_ng_template_8_div_0_div_1_ng_container_1_4_ng_template_0_Template, 3, 5, "ng-template", 6);
} }
function PlanSubDetailsComponent_ng_template_8_div_0_div_1_ng_container_1_ng_template_5_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 57);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r41.pharmacyNetworkText, " ");
} }
function PlanSubDetailsComponent_ng_template_8_div_0_div_1_ng_container_1_ng_template_5_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 57);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r42.mailOrderPharmacyText, " ");
} }
function PlanSubDetailsComponent_ng_template_8_div_0_div_1_ng_container_1_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanSubDetailsComponent_ng_template_8_div_0_div_1_ng_container_1_ng_template_5_div_0_Template, 2, 1, "div", 54);
    i0.ɵɵtemplate(1, PlanSubDetailsComponent_ng_template_8_div_0_div_1_ng_container_1_ng_template_5_div_1_Template, 2, 1, "div", 54);
    i0.ɵɵelementStart(2, "div", 55)(3, "div", 27)(4, "div", 28)(5, "span", 34);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 34);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(9, "vnext-plan-benefit-details", 56);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(2);
    const extendedDetails_r25 = ctx_r43.$implicit;
    const i_r26 = ctx_r43.index;
    const ctx_r29 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r29.showTierPharmacyNetworkLabel && (extendedDetails_r25.isInNetwork || extendedDetails_r25.isPreferred));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r29.showTierPharmacyNetworkLabel && ctx_r29.isMailOrderSelected && extendedDetails_r25.isMailOrder);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-labelledby", extendedDetails_r25.name.toLowerCase() === ctx_r29.planDetailsText.toLowerCase() ? "documents-section-heading" : "benefits-section-heading-" + i0.ɵɵpureFunction1(11, _c0$$, i_r26));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", extendedDetails_r25.name, " benefit description");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", extendedDetails_r25.name, " benefit amount");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("lowIncomeSubsidyText", ctx_r29.lowIncomeSubsidyText)("lowIncomeSubsidyLabel", ctx_r29.lowIncomeSubsidyLabel)("lowIncomeSubsidyInformationalText", ctx_r29.lowIncomeSubsidyInformationalText)("showSubsidy", ctx_r29.showSubsidy)("extendedDetails", extendedDetails_r25)("mobile", ctx_r29.isMobile);
} }
const _c2$f = function (a0, a1) { return { "section-accordion-container": a0, "sub-section-accordion-container": a1 }; };
function PlanSubDetailsComponent_ng_template_8_div_0_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 42)(2, "ngb-accordion", 43)(3, "ngb-panel", 44);
    i0.ɵɵtemplate(4, PlanSubDetailsComponent_ng_template_8_div_0_div_1_ng_container_1_4_Template, 1, 0, null, 38);
    i0.ɵɵtemplate(5, PlanSubDetailsComponent_ng_template_8_div_0_div_1_ng_container_1_ng_template_5_Template, 10, 13, "ng-template", 7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(6, "div");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const extendedDetails_r25 = i0.ɵɵnextContext().$implicit;
    const ctx_r27 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c2$f, extendedDetails_r25.headerType === ctx_r27.sectionHeaderType.ONE, extendedDetails_r25.headerType === ctx_r27.sectionHeaderType.TWO));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", extendedDetails_r25.sectionDetails);
} }
function PlanSubDetailsComponent_ng_template_8_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PlanSubDetailsComponent_ng_template_8_div_0_div_1_ng_container_1_Template, 7, 5, "ng-container", 38);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const extendedDetails_r25 = ctx.$implicit;
    const ctx_r24 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (extendedDetails_r25 == null ? null : extendedDetails_r25.name) !== (ctx_r24.planDocuments == null ? null : ctx_r24.planDocuments.name));
} }
function PlanSubDetailsComponent_ng_template_8_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵtemplate(1, PlanSubDetailsComponent_ng_template_8_div_0_div_1_Template, 2, 1, "div", 41);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r22.extendedPlanDetails);
} }
function PlanSubDetailsComponent_ng_template_8_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-plan-sub-details-rider-category", 58);
    i0.ɵɵlistener("riderBenefitDropdownSelection", function PlanSubDetailsComponent_ng_template_8_div_1_Template_vnext_plan_sub_details_rider_category_riderBenefitDropdownSelection_1_listener($event) { i0.ɵɵrestoreView(_r46); const ctx_r45 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r45.onRiderBenefitDropdownSelectionEvent($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("mobile", ctx_r23.isMobile)("riderCategories", ctx_r23.riderBenefitCategoriesForHospitalIndemnity)("riderHIPBenefitDefaultDropdownText", ctx_r23.riderHIPBenefitDefaultDropdownText)("riderHIPBenefitText", ctx_r23.riderHIPBenefitText)("basePlanNames", i0.ɵɵpureFunction1(5, _c0$$, ctx_r23.hospitalIndemnityBasePlanName));
} }
function PlanSubDetailsComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanSubDetailsComponent_ng_template_8_div_0_Template, 2, 1, "div", 39);
    i0.ɵɵtemplate(1, PlanSubDetailsComponent_ng_template_8_div_1_Template, 2, 7, "div", 38);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r3.extendedPlanDetails == null ? null : ctx_r3.extendedPlanDetails.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.isHCPlan);
} }
function PlanSubDetailsComponent_div_9_ng_template_4_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r51 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r51.preferencesText, " ");
} }
function PlanSubDetailsComponent_div_9_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r53 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 62);
    i0.ɵɵlistener("click", function PlanSubDetailsComponent_div_9_ng_template_4_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r53); i0.ɵɵnextContext(); const _r47 = i0.ɵɵreference(2); const ctx_r52 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r52.isLiveEdit && _r47.expand("custom-panel-1")); });
    i0.ɵɵelementStart(1, "button", 21)(2, "span", 22);
    i0.ɵɵtemplate(3, PlanSubDetailsComponent_div_9_ng_template_4_span_3_Template, 2, 1, "span", 23);
    i0.ɵɵelement(4, "i", 24);
    i0.ɵɵelementStart(5, "span", 25);
    i0.ɵɵtext(6, "Collapse");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", ctx_r48.preferencesText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Plan_Details_Preferences_Text");
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_0_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r58 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r58.providerText, " information type");
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_0_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r59 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r59.providerText, " coverage");
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_0_h3_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 73);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r60 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r60.providerText, " ");
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_0_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r65 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 74)(1, "vnext-link", 75);
    i0.ɵɵlistener("click", function PlanSubDetailsComponent_div_9_ng_template_5_div_0_div_10_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r65); const ctx_r64 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r64.openGuidedHelp(ctx_r64.pageTags.GUIDED_HELP_PROVIDER_SEARCH)); })("keyup.enter", function PlanSubDetailsComponent_div_9_ng_template_5_div_0_div_10_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r65); const ctx_r66 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r66.openGuidedHelp(ctx_r66.pageTags.GUIDED_HELP_PROVIDER_SEARCH)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r61 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("keyNameForLiveEdit", "Spa_Providers_Add_Edit_Link")("title", ctx_r61.providersAddEditLinkTitle)("alwaysUnderlined", true)("linkTarget", "_self")("role", ctx_r61.linkRoles.LINK);
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_0_div_11_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r67 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r67.searchProviderText, " ");
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_0_div_11_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-link", 80);
} if (rf & 2) {
    const ctx_r68 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("onClickAction", ctx_r68.onProviderClick)("title", ctx_r68.searchProviderLink.title)("alwaysUnderlined", true)("isLinkButton", true)("customClass", "Spa_Style_Link width-fit-content")("role", ctx_r68.linkRoles.LINK);
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_0_div_11_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-link", 81);
} if (rf & 2) {
    const ctx_r69 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("title", ctx_r69.providersDirectoryLink)("alwaysUnderlined", true)("href", ctx_r69.detailedPlan.providerURL)("linkTarget", "_blank")("customClass", "Spa_Style_Link width-fit-content")("role", ctx_r69.linkRoles.LINK);
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_0_div_11_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 82);
    i0.ɵɵelement(1, "vnext-link", 81);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "vnext-link", 80);
} if (rf & 2) {
    const ctx_r70 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r70.providersCarrierDirectoryLink)("alwaysUnderlined", true)("href", ctx_r70.detailedPlan.providerURL)("linkTarget", "_blank")("customClass", "Spa_Style_Link width-fit-content")("role", ctx_r70.linkRoles.LINK);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("onClickAction", ctx_r70.onProviderClick)("title", ctx_r70.providersInternalDirectoryLink)("alwaysUnderlined", true)("isLinkButton", true)("customClass", "Spa_Style_Link width-fit-content")("role", ctx_r70.linkRoles.LINK);
} }
const _c3$7 = function (a0) { return { "gray1-static": a0 }; };
const _c4$4 = function (a0) { return { "provider-link-border": a0 }; };
function PlanSubDetailsComponent_div_9_ng_template_5_div_0_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 76)(1, "div", 77);
    i0.ɵɵtemplate(2, PlanSubDetailsComponent_div_9_ng_template_5_div_0_div_11_span_2_Template, 2, 1, "span", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 78)(4, "div", 32);
    i0.ɵɵtemplate(5, PlanSubDetailsComponent_div_9_ng_template_5_div_0_div_11_ng_template_5_Template, 1, 6, "ng-template", 79);
    i0.ɵɵtemplate(6, PlanSubDetailsComponent_div_9_ng_template_5_div_0_div_11_ng_template_6_Template, 1, 6, "ng-template", 79);
    i0.ɵɵtemplate(7, PlanSubDetailsComponent_div_9_ng_template_5_div_0_div_11_ng_template_7_Template, 3, 12, "ng-template", 79);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r62 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c3$7, !ctx_r62.isMobile));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Plan_Providers_Search_Provider_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c4$4, (ctx_r62.selectedProviders == null ? null : ctx_r62.selectedProviders.length) && ctx_r62.isMobile));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r62.selectedPlanProvidersLinkType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r62.providersLinkType.INTERNAL);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r62.providersLinkType.EXTERNAL);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r62.providersLinkType.INTERNAL_AND_EXTERNAL);
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_0_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-plan-provider-details", 83);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const selectedProvider_r71 = ctx.$implicit;
    const ctx_r63 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("planId", ctx_r63.detailedPlan.id)("provider", selectedProvider_r71)("isComparePage", false)("providerDetailResponse", ctx_r63.providerDetailResponse)("selectedProviderDetails", ctx_r63.planDetailsFacade.getSelectedProviderDetails(ctx_r63.detailedPlan.id, ctx_r63.providerDetailResponse, selectedProvider_r71))("inNetworkProviderText", ctx_r63.inNetworkProviderText)("outOfNetworkProviderText", ctx_r63.outOfNetworkProviderText)("pcpText", ctx_r63.pcpText)("noProviderDetailsText", ctx_r63.noProviderDetailsText)("isMobile", ctx_r63.isMobile)("customClass", "plan-level-header provider-details-section-left m-0 col-md-4 no-translate-block")("showNetworkDetails", true)("showProviderDetails", true)("noProviderNetworkAccessText", ctx_r63.noProviderNetworkAccessText)("hasProviderDetails", ctx_r63.detailedPlan.showProviderSearch)("canSellPlan", ctx_r63.canSellPlan)("viewAllText", ctx_r63.viewAllText)("hideText", ctx_r63.hideText)("providerInfoEnabled", ctx_r63.providerInfoEnabled)("countryCode", ctx_r63.countryCode)("acceptingNewPatientsIcon", ctx_r63.acceptingNewPatientsIcon)("acceptingNewPatientsText", ctx_r63.acceptingNewPatientsText)("providerLanguages", ctx_r63.providerLanguages)("providersAcceptingNewPatients", ctx_r63.providersAcceptingNewPatients)("languagesIcon", ctx_r63.languagesIcon)("providerMedicalGroups", ctx_r63.providerMedicalGroups)("isVbcAgreementEnabled", ctx_r63.isVbcAgreementEnabled)("vbcAgreementLabel", ctx_r63.vbcAgreementLabel)("vbcAgreementTooltip", ctx_r63.vbcAgreementTooltip)("isZelisIntegrationEnabled", ctx_r63.isZelisIntegrationEnabled);
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 65)(1, "div", 66)(2, "div", 27)(3, "div", 28);
    i0.ɵɵtemplate(4, PlanSubDetailsComponent_div_9_ng_template_5_div_0_span_4_Template, 2, 1, "span", 29);
    i0.ɵɵtemplate(5, PlanSubDetailsComponent_div_9_ng_template_5_div_0_span_5_Template, 2, 1, "span", 29);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 67)(7, "div", 68);
    i0.ɵɵelement(8, "i", 69);
    i0.ɵɵtemplate(9, PlanSubDetailsComponent_div_9_ng_template_5_div_0_h3_9_Template, 2, 1, "h3", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, PlanSubDetailsComponent_div_9_ng_template_5_div_0_div_10_Template, 2, 5, "div", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, PlanSubDetailsComponent_div_9_ng_template_5_div_0_div_11_Template, 8, 11, "div", 72);
    i0.ɵɵtemplate(12, PlanSubDetailsComponent_div_9_ng_template_5_div_0_ng_container_12_Template, 2, 30, "ng-container", 41);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("liveEditProp", "Spa_Plan_Details_Preferences_Provider_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Plan_Details_Preferences_Provider_Text");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("liveEditProp", "Spa_Plan_Details_Preferences_Provider_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r54.isProvidersEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r54.showProvider && ctx_r54.selectedPlanProvidersLinkType !== ctx_r54.providersLinkType.NO_LINK);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r54.selectedProviders);
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r72 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r72.prescriptionText, " information type");
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_1_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r73 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r73.prescriptionText, " coverage");
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_1_h3_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 88);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r74 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r74.prescriptionText, " ");
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_1_span_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r75 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r75.searchPrescriptionsText);
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_1_div_18_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 94);
    i0.ɵɵelement(1, "i", 95);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r78 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r78.coveredDrugsText, " ");
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_1_div_18_ng_template_9_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r83 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 99)(1, "vnext-link", 100);
    i0.ɵɵlistener("click", function PlanSubDetailsComponent_div_9_ng_template_5_div_1_div_18_ng_template_9_div_3_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r83); const drug_r77 = i0.ɵɵnextContext(2).$implicit; const ctx_r82 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r82.onViewPossibleAlternativeDrugsClick(ctx_r82.detailedPlan, drug_r77)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r81 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r81.showDrugAlternativesText)("alwaysUnderlined", true)("showArrow", "right")("customClass", "Spa_Style_Link width-fit-content")("role", ctx_r81.linkRoles.LINK);
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_1_div_18_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 96);
    i0.ɵɵelement(1, "i", 97);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PlanSubDetailsComponent_div_9_ng_template_5_div_1_div_18_ng_template_9_div_3_Template, 2, 5, "div", 98);
} if (rf & 2) {
    const drug_r77 = i0.ɵɵnextContext().$implicit;
    const ctx_r80 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r80.nonCoveredText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r80.showDrugAlternativesEnabled && (ctx_r80.planAttributeMap[ctx_r80.detailedPlan.id][drug_r77.dosageID] == null ? null : ctx_r80.planAttributeMap[ctx_r80.detailedPlan.id][drug_r77.dosageID].showDrugAlternatives));
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_1_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 76)(2, "div", 77)(3, "span", 89);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "div", 90);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 86)(7, "div", 91);
    i0.ɵɵtemplate(8, PlanSubDetailsComponent_div_9_ng_template_5_div_1_div_18_span_8_Template, 3, 1, "span", 92);
    i0.ɵɵtemplate(9, PlanSubDetailsComponent_div_9_ng_template_5_div_1_div_18_ng_template_9_Template, 4, 2, "ng-template", null, 93, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const drug_r77 = ctx.$implicit;
    const _r79 = i0.ɵɵreference(10);
    const ctx_r76 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c3$7, !ctx_r76.isMobile));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(drug_r77.labelName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", ctx_r76.dosePackageQuantityFreqByDosage[drug_r77.dosageID], i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r76.isDrugCovered(drug_r77.dosage.ndc))("ngIfElse", _r79);
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r87 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 65)(1, "div", 84)(2, "div", 27)(3, "div", 28);
    i0.ɵɵtemplate(4, PlanSubDetailsComponent_div_9_ng_template_5_div_1_span_4_Template, 2, 1, "span", 29);
    i0.ɵɵtemplate(5, PlanSubDetailsComponent_div_9_ng_template_5_div_1_span_5_Template, 2, 1, "span", 29);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 67)(7, "div", 68);
    i0.ɵɵelement(8, "i");
    i0.ɵɵtemplate(9, PlanSubDetailsComponent_div_9_ng_template_5_div_1_h3_9_Template, 2, 1, "h3", 85);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 74)(11, "vnext-link", 75);
    i0.ɵɵlistener("click", function PlanSubDetailsComponent_div_9_ng_template_5_div_1_Template_vnext_link_click_11_listener() { i0.ɵɵrestoreView(_r87); const ctx_r86 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r86.openGuidedHelp(ctx_r86.pageTags.GUIDED_HELP_PRESCRIPTIONS)); })("keyup.enter", function PlanSubDetailsComponent_div_9_ng_template_5_div_1_Template_vnext_link_keyup_enter_11_listener() { i0.ɵɵrestoreView(_r87); const ctx_r88 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r88.openGuidedHelp(ctx_r88.pageTags.GUIDED_HELP_PRESCRIPTIONS)); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(12, "div", 76)(13, "div", 77);
    i0.ɵɵtemplate(14, PlanSubDetailsComponent_div_9_ng_template_5_div_1_span_14_Template, 2, 1, "span", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 86)(16, "span", 87);
    i0.ɵɵelement(17, "vnext-link", 80);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(18, PlanSubDetailsComponent_div_9_ng_template_5_div_1_div_18_Template, 11, 7, "div", 41);
    i0.ɵɵpipe(19, "orderBy");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r55 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("liveEditProp", "Spa_Plan_Details_Preferences_Prescription_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Plan_Details_Preferences_Prescription_Text");
    i0.ɵɵadvance(3);
    i0.ɵɵclassMapInterpolate1("", ctx_r55.prescriptionIcon, " fas icon preferences-icon Spa_Style_PrescriptionsIcon");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Plan_Details_Preferences_Prescription_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("keyNameForLiveEdit", "Spa_Prescription_Add_Edit_Link")("title", ctx_r55.prescriptionAddEditLinkTitle)("alwaysUnderlined", true)("linkTarget", "_self")("role", ctx_r55.linkRoles.LINK);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(25, _c3$7, !ctx_r55.isMobile));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_PlanDetails_Preferences_SearchPrescriptions_Text");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("onClickAction", ctx_r55.onPrescriptionClick)("title", ctx_r55.prescriptionDirectoryLink.title)("alwaysUnderlined", true)("isLinkButton", true)("customClass", "Spa_Style_Link width-fit-content")("role", ctx_r55.linkRoles.LINK);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind4(19, 20, ctx_r55.drugCabinet, "labelName", false, true));
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r89 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r89.pharmacyText, " information type");
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_2_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r90 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r90.pharmacyText, " coverage");
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_2_h3_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 108);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r91 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r91.pharmacyText, " ");
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_2_span_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r92 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r92.searchPharmacyText);
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_2_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 109);
    i0.ɵɵelement(1, "vnext-plan-pharmacy-details", 110)(2, "vnext-mail-order-pharmacy-details", 111);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r93 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pharmacies", ctx_r93.pharmacies)("inNetworkPreferredText", ctx_r93.inNetworkPreferredText)("inNetworkStandardText", ctx_r93.inNetworkStandardText)("outOfNetworkText", ctx_r93.outOfNetworkText)("showPrimaryPharmacyLabel", ctx_r93.isMultiPharmacyEnabled)("primaryPharmacyText", ctx_r93.primaryPharmacyText)("primaryPharmacy", ctx_r93.primaryPharmacy)("nonCoveredText", ctx_r93.nonCoveredText)("showNotCovered", !ctx_r93.isPlanPharmacyCovered);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isComparePage", false)("mailOrderText", ctx_r93.mailOrderText)("showMailOrderPharmacy", ctx_r93.showMailOrderPharmacy)("coveredText", ctx_r93.coveredDrugsText)("notCoveredText", ctx_r93.nonCoveredText)("hasMailOrder", ctx_r93.detailedPlan.hasMailDrugBenefits && ctx_r93.isPlanPharmacyCovered)("isMobile", ctx_r93.isMobile);
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r95 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 101)(1, "div", 102)(2, "div", 27)(3, "div", 28);
    i0.ɵɵtemplate(4, PlanSubDetailsComponent_div_9_ng_template_5_div_2_span_4_Template, 2, 1, "span", 29);
    i0.ɵɵtemplate(5, PlanSubDetailsComponent_div_9_ng_template_5_div_2_span_5_Template, 2, 1, "span", 29);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 103)(7, "div", 68);
    i0.ɵɵelement(8, "i", 104);
    i0.ɵɵtemplate(9, PlanSubDetailsComponent_div_9_ng_template_5_div_2_h3_9_Template, 2, 1, "h3", 105);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 74)(11, "vnext-link", 75);
    i0.ɵɵlistener("click", function PlanSubDetailsComponent_div_9_ng_template_5_div_2_Template_vnext_link_click_11_listener() { i0.ɵɵrestoreView(_r95); const ctx_r94 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r94.openGuidedHelp(ctx_r94.pageTags.GUIDED_HELP_PHARMACY_SEARCH)); })("keyup.enter", function PlanSubDetailsComponent_div_9_ng_template_5_div_2_Template_vnext_link_keyup_enter_11_listener() { i0.ɵɵrestoreView(_r95); const ctx_r96 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r96.openGuidedHelp(ctx_r96.pageTags.GUIDED_HELP_PHARMACY_SEARCH)); });
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(12, "div", 106)(13, "div", 76)(14, "div", 77);
    i0.ɵɵtemplate(15, PlanSubDetailsComponent_div_9_ng_template_5_div_2_span_15_Template, 2, 1, "span", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 86)(17, "span", 87);
    i0.ɵɵelement(18, "vnext-link", 80);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵtemplate(19, PlanSubDetailsComponent_div_9_ng_template_5_div_2_div_19_Template, 3, 16, "div", 107);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r56 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("liveEditProp", "Spa_Plan_Details_Preferences_Pharmacy_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Plan_Details_Preferences_Pharmacy_Text");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("liveEditProp", "Spa_Plan_Details_Preferences_Pharmacy_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("keyNameForLiveEdit", "Spa_Site_Pharmacy_AddEdit_Link")("title", ctx_r56.pharmacyAddEditLink)("alwaysUnderlined", true)("linkTarget", "_self")("role", ctx_r56.linkRoles.LINK);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c3$7, !ctx_r56.isMobile));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_PlanDetails_Preferences_SearchPharmacy_Text");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("onClickAction", ctx_r56.onPharmacyClick)("title", ctx_r56.searchPharmacyLink.title)("alwaysUnderlined", true)("isLinkButton", true)("customClass", "Spa_Style_Link width-fit-content")("role", ctx_r56.linkRoles.LINK);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r56.selectedPharmacy);
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_3_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r97 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r97.otherPreferencesText, " information type");
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_3_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r98 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r98.otherPreferencesText, " coverage");
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_3_h3_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 116);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r99 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r99.otherPreferencesText, " ");
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_3_div_12_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵelement(1, "i", 95);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r102 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r102.coveredBenefitText, " ");
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_3_div_12_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 118);
    i0.ɵɵelement(1, "i", 97);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r104 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r104.nonCoveredBenefitText, " ");
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_3_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 76)(2, "div", 77);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 86)(5, "div");
    i0.ɵɵtemplate(6, PlanSubDetailsComponent_div_9_ng_template_5_div_3_div_12_span_6_Template, 3, 1, "span", 117);
    i0.ɵɵtemplate(7, PlanSubDetailsComponent_div_9_ng_template_5_div_3_div_12_ng_template_7_Template, 3, 1, "ng-template", null, 93, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const benefit_r101 = ctx.$implicit;
    const _r103 = i0.ɵɵreference(8);
    const ctx_r100 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c3$7, !ctx_r100.isMobile));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", benefit_r101.displayLabel, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", benefit_r101.isCovered)("ngIfElse", _r103);
} }
function PlanSubDetailsComponent_div_9_ng_template_5_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r106 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 65)(1, "div", 112)(2, "div", 27)(3, "div", 28);
    i0.ɵɵtemplate(4, PlanSubDetailsComponent_div_9_ng_template_5_div_3_span_4_Template, 2, 1, "span", 29);
    i0.ɵɵtemplate(5, PlanSubDetailsComponent_div_9_ng_template_5_div_3_span_5_Template, 2, 1, "span", 29);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 113)(7, "div", 68);
    i0.ɵɵelement(8, "i", 114);
    i0.ɵɵtemplate(9, PlanSubDetailsComponent_div_9_ng_template_5_div_3_h3_9_Template, 2, 1, "h3", 115);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 74)(11, "vnext-link", 75);
    i0.ɵɵlistener("click", function PlanSubDetailsComponent_div_9_ng_template_5_div_3_Template_vnext_link_click_11_listener() { i0.ɵɵrestoreView(_r106); const ctx_r105 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r105.navigateByPageTag(ctx_r105.pageTags.GUIDED_HELP_OTHER_PREFERENCES)); })("keyup.enter", function PlanSubDetailsComponent_div_9_ng_template_5_div_3_Template_vnext_link_keyup_enter_11_listener() { i0.ɵɵrestoreView(_r106); const ctx_r107 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r107.navigateByPageTag(ctx_r107.pageTags.GUIDED_HELP_OTHER_PREFERENCES)); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(12, PlanSubDetailsComponent_div_9_ng_template_5_div_3_div_12_Template, 9, 6, "div", 41);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r57 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("liveEditProp", "Spa_Plan_Details_OtherPreferences_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Plan_Details_OtherPreferences_Text");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("liveEditProp", "Spa_Plan_Details_OtherPreferences_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("keyNameForLiveEdit", "Spa_Site_Preferences_AddEdit_Link")("title", ctx_r57.preferencesAddEditLink)("alwaysUnderlined", true)("linkTarget", "_self")("role", ctx_r57.linkRoles.LINK);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r57.answeredPreferenceBenefits);
} }
function PlanSubDetailsComponent_div_9_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanSubDetailsComponent_div_9_ng_template_5_div_0_Template, 13, 6, "div", 63);
    i0.ɵɵtemplate(1, PlanSubDetailsComponent_div_9_ng_template_5_div_1_Template, 20, 27, "div", 63);
    i0.ɵɵtemplate(2, PlanSubDetailsComponent_div_9_ng_template_5_div_2_Template, 20, 19, "div", 64);
    i0.ɵɵtemplate(3, PlanSubDetailsComponent_div_9_ng_template_5_div_3_Template, 13, 9, "div", 63);
} if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r49.showProvidersSection && (ctx_r49.isProvidersEnabled || ctx_r49.selectedPlanProvidersLinkType === ctx_r49.providersLinkType.EXTERNAL));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r49.showPrescriptionsSection);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r49.showPharmacySection);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r49.showOtherPreferencesSection);
} }
const _c5$4 = function (a0, a1) { return { "order-2": a0, "order-1": a1 }; };
function PlanSubDetailsComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "ngb-accordion", 59, 60)(3, "ngb-panel", 61);
    i0.ɵɵtemplate(4, PlanSubDetailsComponent_div_9_ng_template_4_Template, 7, 2, "ng-template", 6);
    i0.ɵɵtemplate(5, PlanSubDetailsComponent_div_9_ng_template_5_Template, 4, 4, "ng-template", 7);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c5$4, ctx_r4.preferencesPositionLast, !ctx_r4.preferencesPositionLast));
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("activeIds", ctx_r4.activeIds);
} }
function PlanSubDetailsComponent_div_10_ng_template_3_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r111 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r111.addOnRidersHeader);
} }
function PlanSubDetailsComponent_div_10_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 121)(1, "button", 21)(2, "div", 122)(3, "span", 123);
    i0.ɵɵtemplate(4, PlanSubDetailsComponent_div_10_ng_template_3_span_4_Template, 2, 1, "span", 23);
    i0.ɵɵelementStart(5, "p", 124);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(7, "i", 24);
    i0.ɵɵelementStart(8, "span", 25);
    i0.ɵɵtext(9, "Collapse");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r108 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", ctx_r108.addOnRidersHeader);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", "Spa_Plan_Details_AddOnRiders_Header");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r108.addOnRidersSubHeader);
} }
function PlanSubDetailsComponent_div_10_ng_template_4_div_1_i_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 132);
} if (rf & 2) {
    const riderCategory_r113 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassMapInterpolate1("", riderCategory_r113.icon, " Spa_Style_Primary_Link_Color icon");
} }
function PlanSubDetailsComponent_div_10_ng_template_4_div_1_i_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 133);
} if (rf & 2) {
    const riderCategory_r113 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngbTooltip", riderCategory_r113.waiverTooltip);
} }
function PlanSubDetailsComponent_div_10_ng_template_4_div_1_div_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function PlanSubDetailsComponent_div_10_ng_template_4_div_1_div_6_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 138);
    i0.ɵɵelement(1, "i", 139);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r122 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r122.riderIsIncludedText, " ");
} }
function PlanSubDetailsComponent_div_10_ng_template_4_div_1_div_6_ng_template_4_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 142);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rider_r119 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(rider_r119.planName);
} }
function PlanSubDetailsComponent_div_10_ng_template_4_div_1_div_6_ng_template_4_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rider_r119 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r126 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r126.getRiderMedicalPremium(rider_r119)), "");
} }
function PlanSubDetailsComponent_div_10_ng_template_4_div_1_div_6_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanSubDetailsComponent_div_10_ng_template_4_div_1_div_6_ng_template_4_div_0_Template, 2, 1, "div", 140);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtemplate(2, PlanSubDetailsComponent_div_10_ng_template_4_div_1_div_6_ng_template_4_span_2_Template, 3, 3, "span", 38);
    i0.ɵɵelement(3, "vnext-plan-rider-details", 141);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rider_r119 = i0.ɵɵnextContext().$implicit;
    const ctx_r124 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngIf", rider_r119.planName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r124.getRiderMedicalPremium(rider_r119) !== null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("rider", rider_r119)("showRiderDetails", ctx_r124.showRiderDetails)("hideRiderDetailsText", ctx_r124.hideRiderDetailsText)("showRiderDetailsText", ctx_r124.showRiderDetailsText);
} }
function PlanSubDetailsComponent_div_10_ng_template_4_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 134);
    i0.ɵɵtemplate(1, PlanSubDetailsComponent_div_10_ng_template_4_div_1_div_6_ng_container_1_Template, 1, 0, "ng-container", 135);
    i0.ɵɵtemplate(2, PlanSubDetailsComponent_div_10_ng_template_4_div_1_div_6_ng_template_2_Template, 3, 1, "ng-template", null, 136, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, PlanSubDetailsComponent_div_10_ng_template_4_div_1_div_6_ng_template_4_Template, 4, 6, "ng-template", null, 137, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rider_r119 = ctx.$implicit;
    const _r121 = i0.ɵɵreference(3);
    const _r123 = i0.ɵɵreference(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", rider_r119.isRequiredRider)("ngIfThen", _r121)("ngIfElse", _r123);
} }
const _c6$4 = function (a0) { return { "border-bottom": a0 }; };
const _c7$3 = function (a0) { return { gray: a0 }; };
function PlanSubDetailsComponent_div_10_ng_template_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 126)(1, "span", 127);
    i0.ɵɵtemplate(2, PlanSubDetailsComponent_div_10_ng_template_4_div_1_i_2_Template, 1, 3, "i", 128);
    i0.ɵɵtext(3);
    i0.ɵɵtemplate(4, PlanSubDetailsComponent_div_10_ng_template_4_div_1_i_4_Template, 1, 1, "i", 129);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 130);
    i0.ɵɵtemplate(6, PlanSubDetailsComponent_div_10_ng_template_4_div_1_div_6_Template, 6, 3, "div", 131);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const riderCategory_r113 = ctx.$implicit;
    const ctx_r112 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c6$4, ctx_r112.isMobile));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c7$3, !ctx_r112.isMobile));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", riderCategory_r113.waiverStateRider);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", riderCategory_r113.label, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", riderCategory_r113.waiverTooltip);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", riderCategory_r113.riders);
} }
function PlanSubDetailsComponent_div_10_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 55);
    i0.ɵɵtemplate(1, PlanSubDetailsComponent_div_10_ng_template_4_div_1_Template, 7, 10, "div", 125);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r109 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r109.riderCategories);
} }
function PlanSubDetailsComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "ngb-accordion", 119)(2, "ngb-panel", 120);
    i0.ɵɵtemplate(3, PlanSubDetailsComponent_div_10_ng_template_3_Template, 10, 3, "ng-template", 6);
    i0.ɵɵtemplate(4, PlanSubDetailsComponent_div_10_ng_template_4_Template, 2, 1, "ng-template", 7);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c5$4, ctx_r5.preferencesPositionLast, !ctx_r5.preferencesPositionLast));
} }
function PlanSubDetailsComponent_div_11_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "button", 21)(2, "span", 22)(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "i", 24);
    i0.ɵɵelementStart(6, "span", 25);
    i0.ɵɵtext(7, "Collapse");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r130 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", ctx_r130.planDetailsText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r130.planDocuments.name, "");
} }
function PlanSubDetailsComponent_div_11_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-plan-benefit-details", 146);
} if (rf & 2) {
    const ctx_r131 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("showSubsidy", ctx_r131.showSubsidy)("extendedDetails", ctx_r131.planDocuments)("mobile", ctx_r131.isMobile);
} }
function PlanSubDetailsComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 143)(1, "ngb-accordion", 144)(2, "ngb-panel", 145);
    i0.ɵɵtemplate(3, PlanSubDetailsComponent_div_11_ng_template_3_Template, 8, 2, "ng-template", 6);
    i0.ɵɵtemplate(4, PlanSubDetailsComponent_div_11_ng_template_4_Template, 1, 3, "ng-template", 7);
    i0.ɵɵelementEnd()()();
} }
function PlanSubDetailsComponent_div_13_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r133 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", ctx_r133.planBottomContentHeader, ": ", ctx_r133.planId, "");
} }
function PlanSubDetailsComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 147);
    i0.ɵɵtemplate(1, PlanSubDetailsComponent_div_13_div_1_Template, 2, 2, "div", 38);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.planId);
} }
function PlanSubDetailsComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 148);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r8.planDetailsBottomContentText, "html"), i0.ɵɵsanitizeHtml);
} }
const _c8$2 = function (a0, a1) { return { "order-1": a0, "order-2": a1 }; };
class PlanSubDetailsComponent {
    constructor(planDetailsFacade, planFacade, drugsService, analyticsService, navigationService, helpfulToolsService, localeService, cdr, route, viewportScroller, preferencesService, providerService, pharmacyFacade, riderFacade, store, drugDetailsFacade, guidedHelpModalContextService) {
        this.planDetailsFacade = planDetailsFacade;
        this.planFacade = planFacade;
        this.drugsService = drugsService;
        this.analyticsService = analyticsService;
        this.navigationService = navigationService;
        this.helpfulToolsService = helpfulToolsService;
        this.localeService = localeService;
        this.cdr = cdr;
        this.route = route;
        this.viewportScroller = viewportScroller;
        this.preferencesService = preferencesService;
        this.providerService = providerService;
        this.pharmacyFacade = pharmacyFacade;
        this.riderFacade = riderFacade;
        this.store = store;
        this.drugDetailsFacade = drugDetailsFacade;
        this.guidedHelpModalContextService = guidedHelpModalContextService;
        this.planType = PlanType;
        this.pageTags = PageTags;
        this.sectionHeaderType = SectionHeaderType;
        this.providersLinkType = ProvidersLinkType;
        this.showSubsidy = false;
        this.riderBenefitCategoriesForHospitalIndemnity = [];
        this.riderCategories = [];
        this.planAttributeMap = {};
        this.dosePackageQuantityFreqByDosage = {};
        this.showPharmacySection = false;
        this.showPrescriptionsSection = false;
        this.showProvidersSection = false;
        this.showOtherPreferencesSection = false;
        this.showPreferencesSection = false;
        this.planPremiumInitialRange = '';
        this.benefitRidersSelected = new EventEmitter();
        this.viewPossibleAlternativeDrugs = new EventEmitter();
        this.linkRoles = LinkRoles;
        this.isMailOrderSelected$ = new BehaviorSubject(false);
        this.onProviderClick = () => {
            this.helpfulToolsService.navigateToDirectory(this.detailedPlan, this.searchProviderLink, HelpfulToolsTabs.Providers);
        };
        this.onPrescriptionClick = () => {
            this.helpfulToolsService.navigateToDirectory(this.detailedPlan, this.prescriptionDirectoryLink, HelpfulToolsTabs.Prescriptions);
        };
        this.onPharmacyClick = () => {
            this.helpfulToolsService.navigateToDirectory(this.detailedPlan, this.searchPharmacyLink, HelpfulToolsTabs.Pharmacy);
        };
    }
    get planLevelContent() {
        return this.planFacade.getExtraDataValueByName(this.detailedPlan, PlanExtraDataKey.EDUCATIONAL_CONTENT, '');
    }
    get planId() {
        return this.planFacade.getFormattedFullPlanId(this.detailedPlan);
    }
    get isMedSupPlan() {
        return this.planDetailsFacade.isMedSupPlan(this.detailedPlan);
    }
    ngOnChanges(changes) {
        const { isMailOrderSelected, detailedPlan } = changes;
        if (!_isEqual(detailedPlan?.currentValue, detailedPlan?.previousValue)) {
            this.updateShowPreferencesSections();
            this.isHCPlan = this.detailedPlan.planType === this.planType.HC;
            this.isNonMedicarePlan = this.isHCPlan || !MEDICARE_PLAN_TYPE_VALUES.includes(this.detailedPlan.planType);
            this.extendedPlanDetails = this.planDetailsFacade.getExtendedPlanDetails(this.detailedPlan, this.pharmacyFacade.getSelectedPharmacy(), this.pharmacyFacade.getIsMailOrderSelected());
            if (this.extendedPlanDetails) {
                this.planDocuments = this.getPlanDocuments(this.extendedPlanDetails);
            }
            this.riderCategories = this.generateRiderCategories(this.detailedPlan);
            if (this.isHCPlan) {
                this.generateHospitalIndemnityBenefitCategories(this.riderCategories);
            }
        }
        if (isMailOrderSelected && isMailOrderSelected.currentValue !== isMailOrderSelected.previousValue) {
            this.isMailOrderSelected$.next(this.isMailOrderSelected);
        }
    }
    getPlanDocuments(extendedPlanDetails) {
        return extendedPlanDetails?.find(planDetail => planDetail.name.toLowerCase() === this.planDetailsText?.toLowerCase());
    }
    ngOnInit() {
        this.activeIds = 'custom-panel-1';
        this.selectedPlanProvidersLinkType = this.getProviderLinkType();
        this.lowIncomeSubsidyText = this.planDetailsFacade.getLowIncomeSubsidyText(this.detailedPlan.subsidy?.generic, this.detailedPlan.subsidy?.brand);
        this.lowIncomeSubsidyLabel = this.planDetailsFacade.getLowIncomeSubsidyLabel();
        this.lowIncomeSubsidyInformationalText = this.planDetailsFacade.getLowIncomeSubsidyInformationalText();
        this.showSubsidy = !!this.detailedPlan.subsidy?.showSubsidy;
        if (!this.preferencesExpanded) {
            this.activeIds = '';
        }
        this.subscriptions = [
            // Subscribe to the latest updates from the store for the drug cabinet and the selected pharmacy
            combineLatest([this.cabinet$, this.pharmacyFacade.getSelectedPharmacy$(), this.isMailOrderSelected$]).subscribe({
                next: ([cabinet, selectedPharmacy, isMailOrderSelected]) => {
                    this.drugCabinet = cabinet;
                    if (this.showDrugAlternativesEnabled) {
                        this.planAttributeMap = this.drugDetailsFacade.getPlanAttributeMapWithDrugAlternatives([this.detailedPlan], selectedPharmacy, this.drugCabinet, isMailOrderSelected);
                    }
                }
            }),
            combineLatest([this.cabinet$, this.isMailOrderSelected$.asObservable(), this.localeService.getCurrentLocale$()]).subscribe({
                next: ([medicineCabinet, isMailOrderSelected]) => {
                    this.dosePackageQuantityFreqByDosage = this.getDrugFrequencyAndQuantity(isMailOrderSelected, medicineCabinet);
                    this.cdr.markForCheck();
                }
            }),
            this.localeService.getCurrentLocale$().subscribe({
                next: () => {
                    this.premiumLabel = this.planDetailsFacade.getCostLabel();
                    this.setAnsweredPreferenceBenefits();
                    this.cdr.markForCheck();
                }
            }),
            this.planDetailsFacade.mobile$.subscribe({
                next: isMobile => {
                    this.isMobile = isMobile;
                    this.cdr.markForCheck();
                }
            })
        ];
    }
    ngAfterViewInit() {
        if (this.route.snapshot.fragment) {
            this.viewportScroller.scrollToAnchor(this.route.snapshot.fragment);
        }
    }
    getDrugSearchFrequencyList() {
        return this.drugDetailsFacade.getDrugSearchFrequencyList();
    }
    getDrugFrequencyAndQuantity(isMailOrderSelected, medicineCabinet) {
        return medicineCabinet.reduce((medicineCabinetWithDrugDosage, cabinetEntry) => {
            const dosePackageQuantityFreq = this.drugDetailsFacade.calculateDosage(isMailOrderSelected, cabinetEntry.dosage, cabinetEntry.packageId, this.getDrugSearchFrequencyList(), this.drugsService.getFrequency(cabinetEntry.dosage.daysOfSupply), this.drugsService.getForm(cabinetEntry.dosage.labelName));
            return {
                ...medicineCabinetWithDrugDosage,
                [cabinetEntry.dosageID]: dosePackageQuantityFreq
            };
        }, {});
    }
    onRiderBenefitDropdownSelectionEvent(riderBenefitDropdownSelection) {
        this.onRiderBenefitDropdownSelection(riderBenefitDropdownSelection.rider, riderBenefitDropdownSelection.riderGroupKey);
    }
    onRiderBenefitDropdownSelection(rider, riderGroupKey) {
        this.riderBenefitCategoriesForHospitalIndemnity = this.planFacade.updateRiderBenefitSelection(this.riderBenefitCategoriesForHospitalIndemnity, rider, riderGroupKey);
        const filteredRiderBenefitCategories = this.getFilteredRiderBenefitCategories(this.riderBenefitCategoriesForHospitalIndemnity);
        const selectedRiderBenefitCategories = filteredRiderBenefitCategories.map(riderCategory => ({
            riderGroupKey: riderCategory.riderGroupKey,
            selectedRiderId: riderCategory.selectedRider.planID
        }));
        this.planFacade.updatePlansRiderBenefitCategories(this.detailedPlan.id, selectedRiderBenefitCategories);
        this.store.dispatch(new SetPlansDirty(true, [PlanType.HC]));
        this.emitSelectedRiderBenefitCategories(filteredRiderBenefitCategories);
        this.cdr.markForCheck();
    }
    getRiderIcon(riderSubType) {
        return this.planDetailsFacade.getRiderIcon(riderSubType);
    }
    getRidersByCategory(riderCategory) {
        return this.planDetailsFacade.getRidersByCategory(riderCategory, this.detailedPlan);
    }
    getRiderLabel(riderSubType) {
        return this.planDetailsFacade.getRiderLabel(riderSubType);
    }
    getRidersWithMatchingCategory(category, riderCategoryKey) {
        return this.planDetailsFacade.getRidersWithMatchingCategory(category, this.detailedPlan, riderCategoryKey);
    }
    isMedicareRiderSubType(riderSubType) {
        return this.planDetailsFacade.isMedicareRiderSubType(riderSubType);
    }
    isWaiverStateRider(category) {
        return this.planDetailsFacade.isWaiverStateRider(category, this.detailedPlan);
    }
    getPremium() {
        const planTotalPremium = this.planDetailsFacade.getTotalPremium([this.detailedPlan]);
        this.planPremiumInitialRange = this.planFacade.getPlanPremiumRange(this.detailedPlan, planTotalPremium);
        return planTotalPremium;
    }
    getRiderMedicalPremium(rider) {
        const premium = this.planDetailsFacade.getRiderMedicalPremium(rider);
        if (premium === undefined || isNaN(premium)) {
            return null;
        }
        return premium;
    }
    waiverTooltip(riderSubType) {
        // if it is not a medicare rider sub type AND it has a tooltip value defined
        if (this.isWaiverStateRider(riderSubType) && this.waiverStateRiderTooltips.some(tooltip => tooltip.id === riderSubType)) {
            return this.waiverStateRiderTooltips.find(tooltip => tooltip.id === riderSubType).body;
        }
        return '';
    }
    isDrugCovered(drugNdc) {
        let planRetailDrugCoverage = this.detailedPlan ? this.detailedPlan.planRetailDrugCoverageMultiPharmacy : [];
        if (this.selectedPharmacy && planRetailDrugCoverage?.length) {
            planRetailDrugCoverage = planRetailDrugCoverage.filter(retailDrugCoverage => retailDrugCoverage.pharmacyNABP === this.selectedPharmacy.nabp);
        }
        const coverage = planRetailDrugCoverage ? planRetailDrugCoverage.find(drugCoverage => drugCoverage.ndc === drugNdc) : null;
        return coverage && coverage.tierNumber > 0;
    }
    getPreferenceBenefits() {
        return this.preferencesService.getPlanPreferenceBenefits(this.detailedPlan);
    }
    navigateByPageTag(pageTag) {
        if (pageTag === PageTags.GUIDED_HELP_PRESCRIPTIONS) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_DRUGS);
        }
        else if (pageTag === PageTags.GUIDED_HELP_PHARMACY_SEARCH) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_PHARMACY);
        }
        else if (pageTag === PageTags.GUIDED_HELP_PROVIDER_SEARCH) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_PROVIDER);
        }
        this.navigationService.navigateByPageTag(pageTag);
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => {
            if (subscription) {
                subscription.unsubscribe();
            }
        });
    }
    tagsToUpdate() {
        return this.planDetailsFacade.tagsToUpdate(this.detailedPlan, this.noCostMedSupPlanText, this.isRetentionView, this.selectedTab, this.annualCost, this.planTotalPremium);
    }
    getProviderLinkType() {
        return this.providerService.findProviderSearchLinkType(this.detailedPlan.providerURL, this.isProvidersEnabled, this.detailedPlan.showProviderSearch, this.isBothCarrierAndInternalProvidersDirectoryLinksEnabled);
    }
    onViewPossibleAlternativeDrugsClick(plan, cabinet) {
        this.setAnalyticsForViewDrugAlternatives(plan, cabinet);
        this.viewPossibleAlternativeDrugs.emit({
            plan,
            cabinet
        });
    }
    openGuidedHelp(pageTag) {
        if (this.preferencesBannerEnabled) {
            this.guidedHelpModalContextService.openGuidedHelpModal(pageTag);
        }
        else {
            this.navigationService.navigateByPageTag(pageTag);
        }
    }
    updateShowPreferencesSections() {
        this.showPharmacySection = this.showPharmacy && !BLACKLISTED_PRESCRIPTION_PLAN_TYPES.includes(this.detailedPlan.planType);
        this.showPrescriptionsSection = this.showPrescription && !BLACKLISTED_PHARMACY_PLAN_TYPES.includes(this.detailedPlan.planType);
        this.showProvidersSection = this.showProvider && WHITELISTED_PROVIDER_PLAN_TYPES.includes(this.detailedPlan.planType);
        this.showOtherPreferencesSection =
            this.showOtherPreferences && !BLACKLISTED_OTHER_PREFERENCES_PLAN_TYPES.includes(this.detailedPlan.planType);
        this.showPreferencesSection =
            this.showPreferences &&
                (this.showPharmacySection || this.showPrescriptionsSection || this.showProvidersSection || this.showOtherPreferencesSection) &&
                !this.isHCPlan;
    }
    setAnsweredPreferenceBenefits() {
        this.answeredPreferenceBenefits = this.preferencesService.getPlanPreferenceBenefits(this.detailedPlan);
    }
    // PRIVATE METHOD FOR CATEGORIES BENEFIT FOR HOSPITAL INDEMNITY
    generateHospitalIndemnityBenefitCategories(riderCategories) {
        const selectedRiderBenefitCategories = this.planDetailsFacade.getSelectedRiderBenefitCategories(this.detailedPlan);
        const hospitalIndemnityBasePlanRiders = this.planFacade.getHospitalIndemnityBasePlan(this.detailedPlan);
        this.riderBenefitCategoriesForHospitalIndemnity = this.planFacade.getHospitalIndemnityBenefitCategories(this.detailedPlan, riderCategories, selectedRiderBenefitCategories, this.basePlanOptionLabel);
        this.hospitalIndemnityBasePlanName = hospitalIndemnityBasePlanRiders[0]?.planTypeDescription ?? '';
        if (selectedRiderBenefitCategories?.length > 0) {
            const filteredRiderBenefitCategories = this.getFilteredRiderBenefitCategories(this.riderBenefitCategoriesForHospitalIndemnity);
            this.emitSelectedRiderBenefitCategories(filteredRiderBenefitCategories);
        }
    }
    getFilteredRiderBenefitCategories(selectedRiderBenefitCategories) {
        const filteredRiderBenefitCategories = selectedRiderBenefitCategories.filter(riderCategory => riderCategory.selectedRider);
        return filteredRiderBenefitCategories;
    }
    emitSelectedRiderBenefitCategories(filteredRiderBenefitCategories) {
        const selectedRiders = filteredRiderBenefitCategories.map(riderCategory => riderCategory.selectedRider);
        this.benefitRidersSelected.emit(selectedRiders);
    }
    generateRiderCategories(planDetail) {
        return this.planDetailsFacade
            .getRiderCategories(planDetail)
            .map(riderCategory => {
            const riderSortProperty = 'calculatedMedicalPremium';
            const riderMatchingProperty = this.isHCPlan ? 'planTypeDescription' : 'planSubType';
            const riders = this.planFacade
                .sortRiders(this.getRidersWithMatchingCategory(riderCategory, riderMatchingProperty), riderSortProperty)
                .filter(rider => this.getRiderMedicalPremium(rider) !== 0);
            const riderBenefitCategory = {
                riderGroupKey: riderCategory,
                icon: this.getRiderIcon(riderCategory),
                label: this.getRiderLabel(riderCategory),
                waiverTooltip: !this.isHCPlan ? this.waiverTooltip(riderCategory) : '',
                waiverStateRider: !this.isHCPlan ? this.isWaiverStateRider(riderCategory) : false,
                selectable: true,
                riders,
                selectedRider: null
            };
            return riderBenefitCategory;
        })
            .filter(category => category.riders?.length);
    }
    // END PRIVATE METHOD FOR CATEGORIES BENEFIT FOR HOSPITAL INDEMNITY
    setAnalyticsForViewDrugAlternatives(plan, cabinetEntry) {
        this.analyticsService.googleDataLayerTags = this.planDetailsFacade.getViewDrugAlternativesTag(plan, cabinetEntry);
    }
}
PlanSubDetailsComponent.ɵfac = function PlanSubDetailsComponent_Factory(t) { return new (t || PlanSubDetailsComponent)(i0.ɵɵdirectiveInject(PlanDetailsFacade), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.DrugsService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(HelpfulToolsService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i1$2.ViewportScroller), i0.ɵɵdirectiveInject(i1.PreferencesService), i0.ɵɵdirectiveInject(i1.ProviderService), i0.ɵɵdirectiveInject(PharmacyFacade), i0.ɵɵdirectiveInject(RiderFacade), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(DrugDetailsFacade), i0.ɵɵdirectiveInject(i1.GuidedHelpModalContextService)); };
PlanSubDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanSubDetailsComponent, selectors: [["vnext-plan-sub-details"]], inputs: { preferencesBannerEnabled: "preferencesBannerEnabled", detailedPlan: "detailedPlan", planBottomContentHeader: "planBottomContentHeader", planDetailsBottomContentText: "planDetailsBottomContentText", costSectionHeader: "costSectionHeader", planLevelContentLabel: "planLevelContentLabel", showPlanLevelContent: "showPlanLevelContent", premiumText: "premiumText", planBenefitSectionName: "planBenefitSectionName", pharmacyText: "pharmacyText", preferencesText: "preferencesText", preferencesExpanded: "preferencesExpanded", preferencesPositionLast: "preferencesPositionLast", showPreferences: "showPreferences", showProvider: "showProvider", showPrescription: "showPrescription", showPharmacy: "showPharmacy", showOtherPreferences: "showOtherPreferences", providerText: "providerText", prescriptionText: "prescriptionText", otherPreferencesText: "otherPreferencesText", addOnRidersHeader: "addOnRidersHeader", addOnRidersSubHeader: "addOnRidersSubHeader", prescriptionIcon: "prescriptionIcon", prescriptionAddEditLinkTitle: "prescriptionAddEditLinkTitle", pharmacyLink: "pharmacyLink", pharmacyAddEditLink: "pharmacyAddEditLink", preferencesAddEditLink: "preferencesAddEditLink", providersLink: "providersLink", riderIsIncludedText: "riderIsIncludedText", waiverStateRiderTooltips: "waiverStateRiderTooltips", inNetworkPreferredText: "inNetworkPreferredText", inNetworkStandardText: "inNetworkStandardText", outOfNetworkText: "outOfNetworkText", coveredDrugsText: "coveredDrugsText", nonCoveredText: "nonCoveredText", coveredBenefitText: "coveredBenefitText", nonCoveredBenefitText: "nonCoveredBenefitText", guidedHelpEnabled: "guidedHelpEnabled", healthText: "healthText", costMA: "costMA", costMAPD: "costMAPD", costMEDIGAP: "costMEDIGAP", costPDP: "costPDP", costDENTAL: "costDENTAL", costVISION: "costVISION", costHIP: "costHIP", costAddEditLinkText: "costAddEditLinkText", healthEnabled: "healthEnabled", noCostAvailableText: "noCostAvailableText", planBottomContentResource: "planBottomContentResource", planTypeText: "planTypeText", showRiderDetailsText: "showRiderDetailsText", hideRiderDetailsText: "hideRiderDetailsText", showRiderDetails: "showRiderDetails", riderHIPBenefitText: "riderHIPBenefitText", riderHIPBenefitDefaultDropdownText: "riderHIPBenefitDefaultDropdownText", prescriptionAddEditLinkDescription: "prescriptionAddEditLinkDescription", pharmacyAddEditLinkDescription: "pharmacyAddEditLinkDescription", drugCostAddEditLinkDescription: "drugCostAddEditLinkDescription", healthCostAddEditLinkDescription: "healthCostAddEditLinkDescription", selectedTab: "selectedTab", isRetentionView: "isRetentionView", noCostMedSupPlanText: "noCostMedSupPlanText", isLiveEdit: "isLiveEdit", prescriptionDirectoryLink: "prescriptionDirectoryLink", searchPrescriptionsText: "searchPrescriptionsText", searchPharmacyLink: "searchPharmacyLink", searchPharmacyText: "searchPharmacyText", searchProviderText: "searchProviderText", providersDirectoryLink: "providersDirectoryLink", providersInternalDirectoryLink: "providersInternalDirectoryLink", providersCarrierDirectoryLink: "providersCarrierDirectoryLink", isBothCarrierAndInternalProvidersDirectoryLinksEnabled: "isBothCarrierAndInternalProvidersDirectoryLinksEnabled", searchProviderLink: "searchProviderLink", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text", documentsSection: "documentsSection", planDetailsText: "planDetailsText", showCosts: "showCosts", annualCost: "annualCost", isMultiPharmacyEnabled: "isMultiPharmacyEnabled", primaryPharmacyText: "primaryPharmacyText", primaryPharmacy: "primaryPharmacy", selectedPharmacy: "selectedPharmacy", pharmacies: "pharmacies", isMailOrderSelected: "isMailOrderSelected", showTierPharmacyNetworkLabel: "showTierPharmacyNetworkLabel", pharmacyNetworkText: "pharmacyNetworkText", mailOrderPharmacyText: "mailOrderPharmacyText", mailOrderText: "mailOrderText", showMailOrderPharmacy: "showMailOrderPharmacy", providersAddEditLinkTitle: "providersAddEditLinkTitle", isProvidersEnabled: "isProvidersEnabled", inNetworkProviderText: "inNetworkProviderText", outOfNetworkProviderText: "outOfNetworkProviderText", noProviderDetailsText: "noProviderDetailsText", pcpText: "pcpText", selectedProviders: "selectedProviders", providerDetailResponse: "providerDetailResponse", isPlanPharmacyCovered: "isPlanPharmacyCovered", noProviderNetworkAccessText: "noProviderNetworkAccessText", canSellPlan: "canSellPlan", basePlanOptionLabel: "basePlanOptionLabel", planTotalPremium: "planTotalPremium", showDrugAlternativesEnabled: "showDrugAlternativesEnabled", showDrugAlternativesText: "showDrugAlternativesText", addHealthCostText: "addHealthCostText", hideText: "hideText", viewAllText: "viewAllText", providerInfoEnabled: "providerInfoEnabled", providers: "providers", acceptingNewPatientsText: "acceptingNewPatientsText", acceptingNewPatientsIcon: "acceptingNewPatientsIcon", languagesIcon: "languagesIcon", providerLanguages: "providerLanguages", providersAcceptingNewPatients: "providersAcceptingNewPatients", countryCode: "countryCode", planFeesEnabled: "planFeesEnabled", planFeesLabelText: "planFeesLabelText", planFeesIncludedInPremiumTooltipText: "planFeesIncludedInPremiumTooltipText", planFeesNotIncludedInPremiumTooltipText: "planFeesNotIncludedInPremiumTooltipText", snpPremiumRangeEnabled: "snpPremiumRangeEnabled", providerMedicalGroups: "providerMedicalGroups", isVbcAgreementEnabled: "isVbcAgreementEnabled", vbcAgreementLabel: "vbcAgreementLabel", vbcAgreementTooltip: "vbcAgreementTooltip", modalHeaderHealthText: "modalHeaderHealthText", closeButtonText: "closeButtonText", healthCostsBenefits: "healthCostsBenefits", healthCostsBodyText: "healthCostsBodyText", healthCostsBenefitsBodyText: "healthCostsBenefitsBodyText", healthCostsBenefitsTableHeader: "healthCostsBenefitsTableHeader", healthCostsUsageTableHeader: "healthCostsUsageTableHeader", healthCostsDaysTableHeader: "healthCostsDaysTableHeader", saveFailedText: "saveFailedText", saveSuccessText: "saveSuccessText", healthCostsUpdateAnswersText: "healthCostsUpdateAnswersText", healthCostsSaveAnswersText: "healthCostsSaveAnswersText", healthCostsRestoreDefaultsText: "healthCostsRestoreDefaultsText", healthCostsCustomizationEnabled: "healthCostsCustomizationEnabled", healthAgeQuestionText: "healthAgeQuestionText", healthSliderHeader1Text: "healthSliderHeader1Text", healthSliderHeader2Text: "healthSliderHeader2Text", healthSliderHeader3Text: "healthSliderHeader3Text", healthSliderBody1: "healthSliderBody1", healthSliderBody2: "healthSliderBody2", healthSliderBody3: "healthSliderBody3", healthSliderLabelText: "healthSliderLabelText", healthModalView1HeadingText: "healthModalView1HeadingText", healthModalView1IntroText: "healthModalView1IntroText", isZelisIntegrationEnabled: "isZelisIntegrationEnabled", providerInputProps: "providerInputProps", prescriptionInputProps: "prescriptionInputProps", modalHeaderProvidersText: "modalHeaderProvidersText", modalHeaderPrescriptionsText: "modalHeaderPrescriptionsText", siteType: "siteType" }, outputs: { benefitRidersSelected: "benefitRidersSelected", viewPossibleAlternativeDrugs: "viewPossibleAlternativeDrugs" }, features: [i0.ɵɵNgOnChangesFeature], decls: 18, vars: 16, consts: [["vnextGoogleTagManager", "", "aria-owns", "plan-sub-details", 1, "row", 3, "tagsToUpdate", "saveDefaultValues"], ["class", "col-md-12 order-first", 4, "ngIf"], ["class", "plan-details-accordion accordion-container col-12 order-first", 4, "ngIf"], [1, "plan-details-accordion", "accordion-container", "col-md-12", "plan-details-section-min-height", 3, "ngClass"], ["activeIds", "plan-benefits-container"], ["id", "plan-benefits-container", 1, "card-header"], ["ngbPanelHeader", ""], ["ngbPanelContent", ""], ["class", "plan-details-accordion accordion-container col-md-12 plan-details-section-min-height", 3, "ngClass", 4, "ngIf"], ["class", "plan-details-accordion accordion-container col-12 order-2", 4, "ngIf"], [1, "row"], ["class", "col-md-12 mt-3 Spa_Style_Smaller_Font Spa_Style_Gray4_Color", 4, "liveEditProp"], [1, "col-md-12", "d-inline-block"], [1, "Spa_Style_Smaller_Font", "Spa_Style_Gray4_Color"], ["class", "Spa_Style_Smaller_Font Spa_Style_Gray4_Color plantype-text", "navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], [1, "col-md-12", "order-first"], [3, "plan", "planLevelContentLabel"], [1, "plan-details-accordion", "accordion-container", "col-12", "order-first"], ["activeIds", "plan-cost-container"], ["id", "plan-cost-container", 1, "card-header"], [1, "d-flex", "align-items-center", "justify-content-between", "main-header", "Spa_Style_Accent6_Background"], ["ngbPanelToggle", "", "aria-expanded", "true", 1, "btn", "container-fluid", "text-left", "pl-0"], ["role", "heading", "aria-level", "2", 1, "m-0", "Spa_Style_H2", "Spa_Style_Secondary_Text_Color"], [4, "liveEditProp"], [1, "fas", "fa-chevron-up", "pt-1", "float-right"], [1, "sr-only"], ["role", "table", "aria-labelledby", "plan-cost-container-header", 1, "benefit-details"], ["role", "rowgroup", 1, "sr-only"], ["role", "row"], ["role", "columnheader", 4, "liveEditProp"], ["role", "rowgroup"], ["id", "plan-sub-details", "aria-owns", "plan-sub-details-cost", 3, "premiumLabel", "premium", "premiumText", "mobile", "isHCPlan", "isNonMedicarePlan", "planFeesEnabled", "planFees", "planFeesLabelText", "notApplicableText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "snpPremiumRangeEnabled", "planPremiumInitialRange"], [3, "ngSwitch"], [4, "ngSwitchCase"], ["role", "columnheader"], [3, "preferencesBannerEnabled", "healthEnabled", "costDetails", "plan", "costAddEditLinkText", "noCostAvailableText", "healthText", "annualCost", "selectedPharmacy", "isMailOrderSelected", "addHealthCostText", "modalHeaderHealthText", "closeButtonText", "healthCostsBenefits", "healthCostsBodyText", "healthCostsBenefitsBodyText", "healthCostsBenefitsTableHeader", "healthCostsDaysTableHeader", "saveFailedText", "healthCostsUpdateAnswersText", "healthCostsRestoreDefaultsText", "healthCostsSaveAnswersText", "saveSuccessText", "healthAgeQuestionText", "healthCostsCustomizationEnabled", "healthSliderHeader1Text", "healthSliderHeader2Text", "healthSliderHeader3Text", "healthSliderBody1", "healthSliderBody2", "healthSliderBody3", "healthSliderLabelText", "healthModalView1HeadingText", "healthModalView1IntroText", "healthCostsUsageTableHeader"], [3, "preferencesBannerEnabled", "healthEnabled", "costDetails", "plan", "costAddEditLinkText", "noCostAvailableText", "healthText", "annualCost", "selectedPharmacy", "isMailOrderSelected", "addHealthCostText", "modalHeaderHealthText", "closeButtonText", "healthCostsBenefits", "healthCostsBodyText", "healthCostsBenefitsBodyText", "healthCostsBenefitsTableHeader", "healthCostsDaysTableHeader", "saveFailedText", "healthCostsUpdateAnswersText", "healthCostsSaveAnswersText", "healthCostsRestoreDefaultsText", "saveSuccessText", "healthAgeQuestionText", "healthCostsCustomizationEnabled", "healthSliderHeader1Text", "healthSliderHeader2Text", "healthSliderHeader3Text", "healthSliderBody1", "healthSliderBody2", "healthSliderBody3", "healthSliderLabelText", "healthModalView1HeadingText", "healthModalView1IntroText", "healthCostsUsageTableHeader"], [3, "preferencesBannerEnabled", "healthEnabled", "costDetails", "plan", "costAddEditLinkText", "noCostAvailableText", "annualCost", "selectedPharmacy", "isMailOrderSelected", "addHealthCostText", "modalHeaderHealthText", "closeButtonText", "healthCostsBenefits", "healthCostsBodyText", "healthCostsBenefitsBodyText", "healthCostsBenefitsTableHeader", "healthCostsDaysTableHeader", "saveFailedText", "healthCostsUpdateAnswersText", "healthCostsRestoreDefaultsText", "healthCostsSaveAnswersText", "saveSuccessText", "healthAgeQuestionText", "healthCostsCustomizationEnabled", "healthSliderHeader1Text", "healthSliderHeader2Text", "healthSliderHeader3Text", "healthSliderBody1", "healthSliderBody2", "healthSliderBody3", "healthSliderLabelText", "healthModalView1HeadingText", "healthModalView1IntroText", "healthCostsUsageTableHeader"], [4, "ngIf"], ["class", "benefit-details", 4, "ngIf"], [1, "benefit-details"], [4, "ngFor", "ngForOf"], [3, "ngClass"], ["activeIds", "details-section-container", 1, "accordion-section-container"], ["id", "details-section-container", 1, "card-header", "section-card-header"], [1, "d-flex", "align-items-center", "justify-content-between", 3, "ngClass"], ["class", "m-0 section-header Spa_Style_H3", 3, "id", 4, "ngIf"], ["class", "m-0 section-header Spa_Style_H3", 4, "ngIf"], [1, "m-0", "section-header", "Spa_Style_H3", 3, "id"], [3, "body", "Spa_Site_Tooltip_Text", "customClass", "ariaLabel", 4, "ngIf"], [3, "body", "Spa_Site_Tooltip_Text", "customClass", "ariaLabel"], ["aria-hidden", "true", 1, "fas", "fa-question-circle", "icon-tooltip"], [1, "m-0", "section-header", "Spa_Style_H3"], ["aria-hidden", "true", 1, "fas", "fa-question-circle"], ["class", "Spa_Style_Accent6_Background p-2 Spa_Style_Secondary_Text_Color text-center", 4, "ngIf"], ["role", "table"], [3, "lowIncomeSubsidyText", "lowIncomeSubsidyLabel", "lowIncomeSubsidyInformationalText", "showSubsidy", "extendedDetails", "mobile"], [1, "Spa_Style_Accent6_Background", "p-2", "Spa_Style_Secondary_Text_Color", "text-center"], [3, "mobile", "riderCategories", "riderHIPBenefitDefaultDropdownText", "riderHIPBenefitText", "basePlanNames", "riderBenefitDropdownSelection"], [3, "activeIds"], ["preferencesAccordion", "ngbAccordion"], ["id", "custom-panel-1", 1, "card-header"], [1, "d-flex", "align-items-center", "justify-content-between", "main-header", "Spa_Style_Accent6_Background", 3, "click"], ["class", "row mx-0 plan-details-section-min-height", 4, "ngIf"], ["class", "row mx-0 plan-details-section-min-height", "role", "table", 4, "ngIf"], [1, "row", "mx-0", "plan-details-section-min-height"], ["role", "table", "aria-labelledby", "provider-section-heading", 1, "col-12", "p-0"], ["role", "row", 1, "gray2-static", "d-flex", "flex-column", "flex-sm-row", "align-items-start", "align-items-sm-center", "justify-content-start", "justify-content-sm-between", "preferences-header"], ["role", "rowheader", 1, "preferences-header-content-left"], ["aria-hidden", "true", 1, "fas", "fa-user-md", "Spa_Style_ProvidersIcon", "icon"], ["class", "Spa_Style_H3 d-inline pl-1", "id", "provider-section-heading", 4, "liveEditProp"], ["role", "rowheader", "class", "preferences-link pr-3", 4, "ngIf"], ["role", "row", "class", "row mx-0 plan-details-section-min-height", 4, "ngIf"], ["id", "provider-section-heading", 1, "Spa_Style_H3", "d-inline", "pl-1"], ["role", "rowheader", 1, "preferences-link", "pr-3"], [3, "keyNameForLiveEdit", "title", "alwaysUnderlined", "linkTarget", "role", "click", "keyup.enter"], ["role", "row", 1, "row", "mx-0", "plan-details-section-min-height"], ["role", "rowheader", 1, "Spa_Style_H5", "plan-level-header", "plan-details-section-left", "m-0", "col-md-4", 3, "ngClass"], ["role", "cell", 1, "plan-details-section-right", "col-md-8", "Spa_Style_H4", "Spa_Style_Primary_Link", 3, "ngClass"], [3, "ngSwitchCase"], [3, "onClickAction", "title", "alwaysUnderlined", "isLinkButton", "customClass", "role"], [3, "title", "alwaysUnderlined", "href", "linkTarget", "customClass", "role"], [1, "pb-4"], ["role", "row", 3, "planId", "provider", "isComparePage", "providerDetailResponse", "selectedProviderDetails", "inNetworkProviderText", "outOfNetworkProviderText", "pcpText", "noProviderDetailsText", "isMobile", "customClass", "showNetworkDetails", "showProviderDetails", "noProviderNetworkAccessText", "hasProviderDetails", "canSellPlan", "viewAllText", "hideText", "providerInfoEnabled", "countryCode", "acceptingNewPatientsIcon", "acceptingNewPatientsText", "providerLanguages", "providersAcceptingNewPatients", "languagesIcon", "providerMedicalGroups", "isVbcAgreementEnabled", "vbcAgreementLabel", "vbcAgreementTooltip", "isZelisIntegrationEnabled"], ["role", "table", "aria-labelledby", "prescriptions-section-heading", 1, "col-12", "p-0"], ["class", "Spa_Style_H3 d-inline pl-1", "id", "prescriptions-section-heading", 4, "liveEditProp"], ["role", "cell", 1, "plan-details-section-right", "col-md-8"], [1, "Spa_Style_H4", "mb-0", "Spa_Style_Primary_Link"], ["id", "prescriptions-section-heading", 1, "Spa_Style_H3", "d-inline", "pl-1"], [1, "no-translate-block"], [1, "pt-1", "Spa_Style_Note", 3, "innerHTML"], [1, "row", "pr-3"], ["class", "Spa_Style_H4 mb-0 col-12", 4, "ngIf", "ngIfElse"], ["nonCovered", ""], [1, "Spa_Style_H4", "mb-0", "col-12"], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "covered-drugs"], [1, "Spa_Style_H4", "col-12", "col-sm-6"], ["aria-hidden", "true", 1, "fas", "fa-times-circle", "non-covered-drugs"], ["class", "col-12 col-sm-6 text-left text-sm-right", 4, "ngIf"], [1, "col-12", "col-sm-6", "text-left", "text-sm-right"], [3, "title", "alwaysUnderlined", "showArrow", "customClass", "role", "click"], ["role", "table", 1, "row", "mx-0", "plan-details-section-min-height"], ["aria-labelledby", "pharmacy-section-heading", 1, "col-12", "gray2-static", "p-0"], ["role", "row", 1, "d-flex", "flex-column", "flex-sm-row", "align-items-start", "align-items-sm-center", "justify-content-start", "justify-content-sm-between", "preferences-header"], ["aria-hidden", "true", 1, "fas", "Spa_Style_PharmacyIcon", "icon"], ["class", "Spa_Style_H3 d-inline pl-1", "id", "pharmacy-section-heading", 4, "liveEditProp"], [1, "container", "p-0"], ["role", "row", "aria-owns", "plan-pharmacy-details", "class", "container p-0", 4, "ngIf"], ["id", "pharmacy-section-heading", 1, "Spa_Style_H3", "d-inline", "pl-1"], ["role", "row", "aria-owns", "plan-pharmacy-details", 1, "container", "p-0"], [1, "plan-details-section-min-height", 3, "pharmacies", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "showPrimaryPharmacyLabel", "primaryPharmacyText", "primaryPharmacy", "nonCoveredText", "showNotCovered"], [1, "plan-details-section-min-height", 3, "isComparePage", "mailOrderText", "showMailOrderPharmacy", "coveredText", "notCoveredText", "hasMailOrder", "isMobile"], ["role", "table", "aria-labelledby", "other-preferences-section-heading", 1, "col-12", "p-0"], ["role", "row", 1, "d-flex", "flex-column", "flex-sm-row", "align-items-start", "align-items-sm-center", "justify-content-start", "justify-content-sm-between", "preferences-header", "gray2-static"], ["aria-hidden", "true", 1, "fas", "Spa_Style_OtherPreferencesIcon", "icon"], ["class", "Spa_Style_H3 d-inline pl-1", "id", "other-preferences-section-heading", 4, "liveEditProp"], ["id", "other-preferences-section-heading", 1, "Spa_Style_H3", "d-inline", "pl-1"], ["class", "Spa_Style_H4 mb-0", 4, "ngIf", "ngIfElse"], [1, "Spa_Style_H4", "mb-0"], ["activeIds", "riders-panel"], ["id", "riders-panel", 1, "card-header"], [1, "d-flex", "align-items-center", "justify-content-between", "Spa_Style_Accent6_Background", "main-header"], [1, "m-0", "Spa_Style_Secondary_Text_Color", "plan-level-section-optional-coverage"], ["role", "heading", "aria-level", "2", 1, "Spa_Style_H2", "Spa_Style_Secondary_Text_Color"], [1, "Spa_Style_Paragraph_Light", "plan-level-section-available-cart"], ["role", "row", "class", "row mx-0 plan-details-section-min-height", 3, "ngClass", 4, "ngFor", "ngForOf"], ["role", "row", 1, "row", "mx-0", "plan-details-section-min-height", 3, "ngClass"], ["role", "rowheader", 1, "Spa_Style_H5", "plan-details-section-left", "m-0", "col-md-4", 3, "ngClass"], ["aria-hidden", "true", 3, "class", 4, "ngIf"], ["container", "body", "class", "fas Spa_Style_QuestionIcon", "tabindex", "0", "aria-label", "Show tooltip", 3, "ngbTooltip", 4, "ngIf"], ["role", "cell", 1, "plan-details-section-right", "col-md-8", "Spa_Style_H4", "mb-0"], ["class", "mb-2 pl-0", 4, "ngFor", "ngForOf"], ["aria-hidden", "true"], ["container", "body", "tabindex", "0", "aria-label", "Show tooltip", 1, "fas", "Spa_Style_QuestionIcon", 3, "ngbTooltip"], [1, "mb-2", "pl-0"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["requiredRider", ""], ["normalRider", ""], [1, "Spa_Style_H4"], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "included-icon", "Spa_Style_CheckmarksAndPreferredInNetwork"], ["class", "Spa_Style_Paragraph pb-2 no-translate-block", 4, "ngIf"], [3, "rider", "showRiderDetails", "hideRiderDetailsText", "showRiderDetailsText"], [1, "Spa_Style_Paragraph", "pb-2", "no-translate-block"], [1, "plan-details-accordion", "accordion-container", "col-12", "order-2"], ["activeIds", "plan-document-container"], ["id", "plan-document-container", 1, "card-header"], [3, "showSubsidy", "extendedDetails", "mobile"], [1, "col-md-12", "mt-3", "Spa_Style_Smaller_Font", "Spa_Style_Gray4_Color"], ["navigationAdapter", "", 1, "Spa_Style_Smaller_Font", "Spa_Style_Gray4_Color", "plantype-text", 3, "innerHTML"]], template: function PlanSubDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, PlanSubDetailsComponent_div_1_Template, 2, 2, "div", 1);
        i0.ɵɵtemplate(2, PlanSubDetailsComponent_div_2_Template, 5, 0, "div", 2);
        i0.ɵɵpipe(3, "async");
        i0.ɵɵelementStart(4, "div", 3)(5, "ngb-accordion", 4)(6, "ngb-panel", 5);
        i0.ɵɵtemplate(7, PlanSubDetailsComponent_ng_template_7_Template, 7, 2, "ng-template", 6);
        i0.ɵɵtemplate(8, PlanSubDetailsComponent_ng_template_8_Template, 2, 2, "ng-template", 7);
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(9, PlanSubDetailsComponent_div_9_Template, 6, 5, "div", 8);
        i0.ɵɵtemplate(10, PlanSubDetailsComponent_div_10_Template, 5, 4, "div", 8);
        i0.ɵɵtemplate(11, PlanSubDetailsComponent_div_11_Template, 5, 0, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 10);
        i0.ɵɵtemplate(13, PlanSubDetailsComponent_div_13_Template, 2, 1, "div", 11);
        i0.ɵɵelementStart(14, "div", 12)(15, "div", 13);
        i0.ɵɵtext(16);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(17, PlanSubDetailsComponent_div_17_Template, 2, 4, "div", 14);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("tagsToUpdate", ctx.tagsToUpdate())("saveDefaultValues", ctx.analyticsService.isDefaultTagToUpdate);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showPlanLevelContent);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 11, ctx.planDetailsFacade.hasPremium$(ctx.detailedPlan)) && (!ctx.isHCPlan || ctx.planFeesEnabled && (ctx.detailedPlan.fees == null ? null : ctx.detailedPlan.fees.length)));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(13, _c8$2, ctx.preferencesPositionLast, !ctx.preferencesPositionLast));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.guidedHelpEnabled && ctx.showPreferencesSection);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.planDetailsFacade.showRiders(ctx.detailedPlan) && !ctx.isHCPlan);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.planDocuments == null ? null : ctx.planDocuments.name);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_PlanDetails_Bottom_Content_Header");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.planTypeText, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", ctx.planBottomContentResource);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, LinkComponent, TooltipComponent, NavigationAdapterDirective, LiveEditPropDirective, GoogleTagManagerDirective, IconAriaAttributesDirective, i1$1.NgbAccordion, i1$1.NgbPanel, i1$1.NgbPanelContent, i1$1.NgbPanelHeader, i1$1.NgbPanelToggle, i1$1.NgbTooltip, PlanCostSectionComponent, PlanRiderDetailsComponent, RiderCategoryComponent, PlanPharmacyDetailsComponent, MailOrderPharmacyDetailsComponent, PlanLevelContentComponent, PlanCostDetailsComponent, PlanBenefitDetailsComponent, PlanProviderDetailsComponent, i1$2.AsyncPipe, i1$2.CurrencyPipe, SafePipe, OrderPipe], styles: [".plan-details-accordion[_ngcontent-%COMP%]   .fa-chevron-up[_ngcontent-%COMP%]:before{content:\"\\f077\";font-size:22px}.plan-details-accordion[_ngcontent-%COMP%]   .collapsed[_ngcontent-%COMP%]   .fa-chevron-up[_ngcontent-%COMP%]:before{content:\"\\f078\"}.plan-details-accordion[_ngcontent-%COMP%]:last-child   .plan-details-section-left[_ngcontent-%COMP%]:last-child, .plan-details-accordion[_ngcontent-%COMP%]:last-child   .plan-details-section-right[_ngcontent-%COMP%]:last-child{border-bottom:1px solid var(--static-Spa_Style_Accent1)}.section-header[_ngcontent-%COMP%]{padding:17px 5px;min-height:60px}.plan-details-section-right[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{margin-bottom:0!important}.main-header[_ngcontent-%COMP%]{padding:3px 5px 3px 10px;min-height:60px}.section-tooltip[_ngcontent-%COMP%]{width:323px}.icon-tooltip[_ngcontent-%COMP%]{font-size:18px}button[_ngcontent-%COMP%], .btn[_ngcontent-%COMP%]{border:none}button[_ngcontent-%COMP%]:focus, .btn[_ngcontent-%COMP%]:focus{outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:inset 0 1px 1px var(--static-Spa_Style_Accent1),0 0 8px var(--static-Spa_Style_Accent1)}.plan-details-section-left[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:15px 0 15px 10px}.plan-details-section-right[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-width:0 0 1px;padding:14px 0 10px 10px}.plan-details-section-min-height[_ngcontent-%COMP%]{min-height:60px}.covered-drugs[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent5)}.non-covered-drugs[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent1)}.icon[_ngcontent-%COMP%]{font-size:18px}.fa-chevron-up[_ngcontent-%COMP%]{font-size:22px}.preferences-header[_ngcontent-%COMP%]{min-height:60px;border-bottom:1px solid var(--static-Spa_Style_Accent1)}.preferences-header-content-left[_ngcontent-%COMP%]{padding-left:10px}.preferences-icon[_ngcontent-%COMP%]{width:20px}.included-icon[_ngcontent-%COMP%]{font-family:\"Font Awesome 5 Pro\"}.gray1-static[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray1)}.gray2-static[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray2)}.plan-level-section-optional-coverage[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.plan-level-section-available-cart[_ngcontent-%COMP%]{display:contents}@media (max-width: 767px){.plan-details-section-left[_ngcontent-%COMP%]{border-width:0;padding:6px 5px 0 10px;min-height:28px}.plan-details-section-right[_ngcontent-%COMP%]{padding:4px 5px 15px 10px;border:none}.preferences-link[_ngcontent-%COMP%]{margin-left:40px}.main-header[_ngcontent-%COMP%]{min-height:70px}.plan-details-accordion[_ngcontent-%COMP%]:last-child   .plan-details-section-left[_ngcontent-%COMP%]:last-child, .plan-details-accordion[_ngcontent-%COMP%]:last-child   .plan-details-section-right[_ngcontent-%COMP%]:last-child{border:0}}@media (max-width: 479.98px){.preferences-header[_ngcontent-%COMP%]{padding-top:12px;min-height:70px}.preferences-icon[_ngcontent-%COMP%]{width:25px}.plan-details-section-min-height[_ngcontent-%COMP%], .section-header[_ngcontent-%COMP%]{min-height:70px}}@media (min-width: 480px) and (max-width: 575.98px){.preferences-header[_ngcontent-%COMP%]{padding-top:12px;min-height:70px}}"], changeDetection: 0 });
__decorate([
    Select(MedicineCabinetState.medicineCabinet)
], PlanSubDetailsComponent.prototype, "cabinet$", void 0);
__decorate([
    LiveEditInactive()
], PlanSubDetailsComponent.prototype, "navigateByPageTag", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanSubDetailsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-sub-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  class=\"row\"\r\n  vnextGoogleTagManager\r\n  [tagsToUpdate]=\"tagsToUpdate()\"\r\n  [saveDefaultValues]=\"analyticsService.isDefaultTagToUpdate\"\r\n  aria-owns=\"plan-sub-details\"\r\n>\r\n  <div class=\"col-md-12 order-first\" *ngIf=\"showPlanLevelContent\">\r\n    <vnext-plan-level-content [plan]=\"detailedPlan\" [planLevelContentLabel]=\"planLevelContentLabel\"> </vnext-plan-level-content>\r\n  </div>\r\n  <div\r\n    class=\"plan-details-accordion accordion-container col-12 order-first\"\r\n    *ngIf=\"(planDetailsFacade.hasPremium$(detailedPlan) | async) && (!isHCPlan || (planFeesEnabled && detailedPlan.fees?.length))\"\r\n  >\r\n    <ngb-accordion activeIds=\"plan-cost-container\">\r\n      <ngb-panel id=\"plan-cost-container\" class=\"card-header\">\r\n        <ng-template ngbPanelHeader let-opened=\"open\">\r\n          <div class=\"d-flex align-items-center justify-content-between main-header Spa_Style_Accent6_Background\">\r\n            <button ngbPanelToggle class=\"btn container-fluid text-left pl-0\" [attr.aria-label]=\"costSectionHeader\" aria-expanded=\"true\">\r\n              <span class=\"m-0 Spa_Style_H2 Spa_Style_Secondary_Text_Color\" role=\"heading\" aria-level=\"2\">\r\n                <span *liveEditProp=\"'Spa_PlanDetails_Costs_Header'\"> {{ costSectionHeader }}</span>\r\n                <i class=\"fas fa-chevron-up pt-1 float-right\"></i>\r\n                <span class=\"sr-only\">Collapse</span>\r\n              </span>\r\n            </button>\r\n          </div>\r\n        </ng-template>\r\n        <ng-template ngbPanelContent>\r\n          <div class=\"benefit-details\" role=\"table\" aria-labelledby=\"plan-cost-container-header\">\r\n            <div role=\"rowgroup\" class=\"sr-only\">\r\n              <div role=\"row\">\r\n                <span *liveEditProp=\"'Spa_PlanDetails_Costs_Header'\" role=\"columnheader\">{{ costSectionHeader }} type</span>\r\n                <span *liveEditProp=\"'Spa_PlanDetails_Costs_Header'\" role=\"columnheader\">{{ costSectionHeader }} amount</span>\r\n              </div>\r\n            </div>\r\n            <div role=\"rowgroup\">\r\n              <vnext-plan-cost-details\r\n                id=\"plan-sub-details\"\r\n                aria-owns=\"plan-sub-details-cost\"\r\n                [premiumLabel]=\"premiumLabel\"\r\n                [premium]=\"getPremium()\"\r\n                [premiumText]=\"premiumText\"\r\n                [mobile]=\"isMobile\"\r\n                [isHCPlan]=\"isHCPlan\"\r\n                [isNonMedicarePlan]=\"isNonMedicarePlan\"\r\n                [planFeesEnabled]=\"planFeesEnabled\"\r\n                [planFees]=\"detailedPlan.fees\"\r\n                [planFeesLabelText]=\"planFeesLabelText\"\r\n                [notApplicableText]=\"noCostAvailableText\"\r\n                [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n                [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n                [snpPremiumRangeEnabled]=\"snpPremiumRangeEnabled\"\r\n                [planPremiumInitialRange]=\"planPremiumInitialRange\"\r\n              ></vnext-plan-cost-details>\r\n              <div [ngSwitch]=\"detailedPlan.planType\">\r\n                <!-- Checking for MAPD PlanType -->\r\n                <div *ngSwitchCase=\"planType.MAPD\">\r\n                  <vnext-plan-cost-section\r\n                    [preferencesBannerEnabled]=\"preferencesBannerEnabled\"\r\n                    [healthEnabled]=\"healthEnabled\"\r\n                    [costDetails]=\"costMAPD\"\r\n                    [plan]=\"detailedPlan\"\r\n                    [costAddEditLinkText]=\"costAddEditLinkText\"\r\n                    [noCostAvailableText]=\"noCostAvailableText\"\r\n                    [healthText]=\"healthText\"\r\n                    [annualCost]=\"annualCost\"\r\n                    [selectedPharmacy]=\"selectedPharmacy\"\r\n                    [isMailOrderSelected]=\"isMailOrderSelected\"\r\n                    [addHealthCostText]=\"addHealthCostText\"\r\n                    [modalHeaderHealthText]=\"modalHeaderHealthText\"\r\n                    [closeButtonText]=\"closeButtonText\"\r\n                    [healthCostsBenefits]=\"healthCostsBenefits\"\r\n                    [healthCostsBodyText]=\"healthCostsBodyText\"\r\n                    [healthCostsBenefitsBodyText]=\"healthCostsBenefitsBodyText\"\r\n                    [healthCostsBenefitsTableHeader]=\"healthCostsBenefitsTableHeader\"\r\n                    [healthCostsDaysTableHeader]=\"healthCostsDaysTableHeader\"\r\n                    [saveFailedText]=\"saveFailedText\"\r\n                    [healthCostsUpdateAnswersText]=\"healthCostsUpdateAnswersText\"\r\n                    [healthCostsRestoreDefaultsText]=\"healthCostsRestoreDefaultsText\"\r\n                    [healthCostsSaveAnswersText]=\"healthCostsSaveAnswersText\"\r\n                    [saveSuccessText]=\"saveSuccessText\"\r\n                    [healthAgeQuestionText]=\"healthAgeQuestionText\"\r\n                    [healthCostsCustomizationEnabled]=\"healthCostsCustomizationEnabled\"\r\n                    [healthSliderHeader1Text]=\"healthSliderHeader1Text\"\r\n                    [healthSliderHeader2Text]=\"healthSliderHeader2Text\"\r\n                    [healthSliderHeader3Text]=\"healthSliderHeader3Text\"\r\n                    [healthSliderBody1]=\"healthSliderBody1\"\r\n                    [healthSliderBody2]=\"healthSliderBody2\"\r\n                    [healthSliderBody3]=\"healthSliderBody3\"\r\n                    [healthSliderLabelText]=\"healthSliderLabelText\"\r\n                    [healthModalView1HeadingText]=\"healthModalView1HeadingText\"\r\n                    [healthModalView1IntroText]=\"healthModalView1IntroText\"\r\n                    [healthCostsUsageTableHeader]=\"healthCostsUsageTableHeader\"\r\n                  >\r\n                  </vnext-plan-cost-section>\r\n                </div>\r\n                <!-- Checking for MA PlanType -->\r\n                <div *ngSwitchCase=\"planType.MA\">\r\n                  <vnext-plan-cost-section\r\n                    [preferencesBannerEnabled]=\"preferencesBannerEnabled\"\r\n                    [healthEnabled]=\"healthEnabled\"\r\n                    [costDetails]=\"costMA\"\r\n                    [plan]=\"detailedPlan\"\r\n                    [costAddEditLinkText]=\"costAddEditLinkText\"\r\n                    [noCostAvailableText]=\"noCostAvailableText\"\r\n                    [healthText]=\"healthText\"\r\n                    [annualCost]=\"annualCost\"\r\n                    [selectedPharmacy]=\"selectedPharmacy\"\r\n                    [isMailOrderSelected]=\"isMailOrderSelected\"\r\n                    [addHealthCostText]=\"addHealthCostText\"\r\n                    [modalHeaderHealthText]=\"modalHeaderHealthText\"\r\n                    [closeButtonText]=\"closeButtonText\"\r\n                    [healthCostsBenefits]=\"healthCostsBenefits\"\r\n                    [healthCostsBodyText]=\"healthCostsBodyText\"\r\n                    [healthCostsBenefitsBodyText]=\"healthCostsBenefitsBodyText\"\r\n                    [healthCostsBenefitsTableHeader]=\"healthCostsBenefitsTableHeader\"\r\n                    [healthCostsDaysTableHeader]=\"healthCostsDaysTableHeader\"\r\n                    [saveFailedText]=\"saveFailedText\"\r\n                    [healthCostsUpdateAnswersText]=\"healthCostsUpdateAnswersText\"\r\n                    [healthCostsSaveAnswersText]=\"healthCostsSaveAnswersText\"\r\n                    [healthCostsRestoreDefaultsText]=\"healthCostsRestoreDefaultsText\"\r\n                    [saveSuccessText]=\"saveSuccessText\"\r\n                    [healthAgeQuestionText]=\"healthAgeQuestionText\"\r\n                    [healthCostsCustomizationEnabled]=\"healthCostsCustomizationEnabled\"\r\n                    [healthSliderHeader1Text]=\"healthSliderHeader1Text\"\r\n                    [healthSliderHeader2Text]=\"healthSliderHeader2Text\"\r\n                    [healthSliderHeader3Text]=\"healthSliderHeader3Text\"\r\n                    [healthSliderBody1]=\"healthSliderBody1\"\r\n                    [healthSliderBody2]=\"healthSliderBody2\"\r\n                    [healthSliderBody3]=\"healthSliderBody3\"\r\n                    [healthSliderLabelText]=\"healthSliderLabelText\"\r\n                    [healthModalView1HeadingText]=\"healthModalView1HeadingText\"\r\n                    [healthModalView1IntroText]=\"healthModalView1IntroText\"\r\n                    [healthCostsUsageTableHeader]=\"healthCostsUsageTableHeader\"\r\n                  >\r\n                  </vnext-plan-cost-section>\r\n                </div>\r\n                <!-- Checking for PDP PlanType -->\r\n                <div *ngSwitchCase=\"planType.PDP\">\r\n                  <vnext-plan-cost-section\r\n                    [preferencesBannerEnabled]=\"preferencesBannerEnabled\"\r\n                    [healthEnabled]=\"healthEnabled\"\r\n                    [costDetails]=\"costPDP\"\r\n                    [plan]=\"detailedPlan\"\r\n                    [costAddEditLinkText]=\"costAddEditLinkText\"\r\n                    [noCostAvailableText]=\"noCostAvailableText\"\r\n                    [annualCost]=\"annualCost\"\r\n                    [selectedPharmacy]=\"selectedPharmacy\"\r\n                    [isMailOrderSelected]=\"isMailOrderSelected\"\r\n                    [addHealthCostText]=\"addHealthCostText\"\r\n                    [modalHeaderHealthText]=\"modalHeaderHealthText\"\r\n                    [closeButtonText]=\"closeButtonText\"\r\n                    [healthCostsBenefits]=\"healthCostsBenefits\"\r\n                    [healthCostsBodyText]=\"healthCostsBodyText\"\r\n                    [healthCostsBenefitsBodyText]=\"healthCostsBenefitsBodyText\"\r\n                    [healthCostsBenefitsTableHeader]=\"healthCostsBenefitsTableHeader\"\r\n                    [healthCostsDaysTableHeader]=\"healthCostsDaysTableHeader\"\r\n                    [saveFailedText]=\"saveFailedText\"\r\n                    [healthCostsUpdateAnswersText]=\"healthCostsUpdateAnswersText\"\r\n                    [healthCostsRestoreDefaultsText]=\"healthCostsRestoreDefaultsText\"\r\n                    [healthCostsSaveAnswersText]=\"healthCostsSaveAnswersText\"\r\n                    [saveSuccessText]=\"saveSuccessText\"\r\n                    [healthAgeQuestionText]=\"healthAgeQuestionText\"\r\n                    [healthCostsCustomizationEnabled]=\"healthCostsCustomizationEnabled\"\r\n                    [healthSliderHeader1Text]=\"healthSliderHeader1Text\"\r\n                    [healthSliderHeader2Text]=\"healthSliderHeader2Text\"\r\n                    [healthSliderHeader3Text]=\"healthSliderHeader3Text\"\r\n                    [healthSliderBody1]=\"healthSliderBody1\"\r\n                    [healthSliderBody2]=\"healthSliderBody2\"\r\n                    [healthSliderBody3]=\"healthSliderBody3\"\r\n                    [healthSliderLabelText]=\"healthSliderLabelText\"\r\n                    [healthModalView1HeadingText]=\"healthModalView1HeadingText\"\r\n                    [healthModalView1IntroText]=\"healthModalView1IntroText\"\r\n                    [healthCostsUsageTableHeader]=\"healthCostsUsageTableHeader\"\r\n                  >\r\n                  </vnext-plan-cost-section>\r\n                </div>\r\n                <!-- Checking for MEDIGAP PlanType -->\r\n                <div *ngSwitchCase=\"planType.MEDIGAP\">\r\n                  <div *ngIf=\"showCosts\">\r\n                    <vnext-plan-cost-section\r\n                      [preferencesBannerEnabled]=\"preferencesBannerEnabled\"\r\n                      [healthEnabled]=\"healthEnabled\"\r\n                      [costDetails]=\"costMEDIGAP\"\r\n                      [plan]=\"detailedPlan\"\r\n                      [costAddEditLinkText]=\"costAddEditLinkText\"\r\n                      [noCostAvailableText]=\"noCostAvailableText\"\r\n                      [healthText]=\"healthText\"\r\n                      [annualCost]=\"annualCost\"\r\n                      [selectedPharmacy]=\"selectedPharmacy\"\r\n                      [isMailOrderSelected]=\"isMailOrderSelected\"\r\n                      [addHealthCostText]=\"addHealthCostText\"\r\n                      [modalHeaderHealthText]=\"modalHeaderHealthText\"\r\n                      [closeButtonText]=\"closeButtonText\"\r\n                      [healthCostsBenefits]=\"healthCostsBenefits\"\r\n                      [healthCostsBodyText]=\"healthCostsBodyText\"\r\n                      [healthCostsBenefitsBodyText]=\"healthCostsBenefitsBodyText\"\r\n                      [healthCostsBenefitsTableHeader]=\"healthCostsBenefitsTableHeader\"\r\n                      [healthCostsDaysTableHeader]=\"healthCostsDaysTableHeader\"\r\n                      [saveFailedText]=\"saveFailedText\"\r\n                      [healthCostsUpdateAnswersText]=\"healthCostsUpdateAnswersText\"\r\n                      [healthCostsRestoreDefaultsText]=\"healthCostsRestoreDefaultsText\"\r\n                      [healthCostsSaveAnswersText]=\"healthCostsSaveAnswersText\"\r\n                      [saveSuccessText]=\"saveSuccessText\"\r\n                      [healthAgeQuestionText]=\"healthAgeQuestionText\"\r\n                      [healthCostsCustomizationEnabled]=\"healthCostsCustomizationEnabled\"\r\n                      [healthSliderHeader1Text]=\"healthSliderHeader1Text\"\r\n                      [healthSliderHeader2Text]=\"healthSliderHeader2Text\"\r\n                      [healthSliderHeader3Text]=\"healthSliderHeader3Text\"\r\n                      [healthSliderBody1]=\"healthSliderBody1\"\r\n                      [healthSliderBody2]=\"healthSliderBody2\"\r\n                      [healthSliderBody3]=\"healthSliderBody3\"\r\n                      [healthSliderLabelText]=\"healthSliderLabelText\"\r\n                      [healthModalView1HeadingText]=\"healthModalView1HeadingText\"\r\n                      [healthModalView1IntroText]=\"healthModalView1IntroText\"\r\n                      [healthCostsUsageTableHeader]=\"healthCostsUsageTableHeader\"\r\n                    >\r\n                    </vnext-plan-cost-section>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n      </ngb-panel>\r\n    </ngb-accordion>\r\n  </div>\r\n  <div\r\n    class=\"plan-details-accordion accordion-container col-md-12 plan-details-section-min-height\"\r\n    [ngClass]=\"{ 'order-1': preferencesPositionLast, 'order-2': !preferencesPositionLast }\"\r\n  >\r\n    <ngb-accordion activeIds=\"plan-benefits-container\">\r\n      <ngb-panel id=\"plan-benefits-container\" class=\"card-header\">\r\n        <ng-template ngbPanelHeader let-opened=\"open\">\r\n          <div class=\"d-flex align-items-center justify-content-between main-header Spa_Style_Accent6_Background\">\r\n            <button\r\n              ngbPanelToggle\r\n              class=\"btn container-fluid text-left pl-0\"\r\n              [attr.aria-label]=\"planBenefitSectionName\"\r\n              aria-expanded=\"true\"\r\n            >\r\n              <span class=\"m-0 Spa_Style_H2 Spa_Style_Secondary_Text_Color\" role=\"heading\" aria-level=\"2\">\r\n                <span *liveEditProp=\"'Spa_Plan_Benefits_Section_Name'\"> {{ planBenefitSectionName }} </span>\r\n                <i class=\"fas fa-chevron-up pt-1 float-right\"></i>\r\n                <span class=\"sr-only\">Collapse</span>\r\n              </span>\r\n            </button>\r\n          </div>\r\n        </ng-template>\r\n        <ng-template ngbPanelContent>\r\n          <div class=\"benefit-details\" *ngIf=\"extendedPlanDetails?.length\">\r\n            <div *ngFor=\"let extendedDetails of extendedPlanDetails; let i = index\">\r\n              <ng-container *ngIf=\"extendedDetails?.name !== planDocuments?.name\">\r\n                <div\r\n                  [ngClass]=\"{\r\n                    'section-accordion-container': extendedDetails.headerType === sectionHeaderType.ONE,\r\n                    'sub-section-accordion-container': extendedDetails.headerType === sectionHeaderType.TWO\r\n                  }\"\r\n                >\r\n                  <ngb-accordion activeIds=\"details-section-container\" class=\"accordion-section-container\">\r\n                    <ngb-panel id=\"details-section-container\" class=\"card-header section-card-header\">\r\n                      <ng-template ngbPanelHeader *ngIf=\"extendedDetails.sectionDetails\" let-opened=\"open\">\r\n                        <div\r\n                          class=\"d-flex align-items-center justify-content-between\"\r\n                          [ngClass]=\"{\r\n                            'gray2-static':\r\n                              extendedDetails.headerType === sectionHeaderType.ONE || extendedDetails.headerType === sectionHeaderType.TWO\r\n                          }\"\r\n                        >\r\n                          <h3\r\n                            [id]=\"\r\n                              extendedDetails.name.toLowerCase() === this.planDetailsText.toLowerCase()\r\n                                ? 'documents-section-heading'\r\n                                : 'benefits-section-heading-' + [i]\r\n                            \"\r\n                            *ngIf=\"extendedDetails.headerType === 1\"\r\n                            class=\"m-0 section-header Spa_Style_H3\"\r\n                          >\r\n                            {{ extendedDetails.name }}\r\n                            <vnext-tooltip\r\n                              *ngIf=\"extendedDetails.toolTip\"\r\n                              [body]=\"extendedDetails.toolTip\"\r\n                              [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                              [customClass]=\"'focus-text focus-circle'\"\r\n                              [ariaLabel]=\"'More info'\"\r\n                            >\r\n                              <i class=\"fas fa-question-circle icon-tooltip\" aria-hidden=\"true\"></i>\r\n                            </vnext-tooltip>\r\n                          </h3>\r\n\r\n                          <h3 class=\"m-0 section-header Spa_Style_H3\" *ngIf=\"extendedDetails.headerType === sectionHeaderType.TWO\">\r\n                            {{ extendedDetails.name }}\r\n                            <vnext-tooltip\r\n                              *ngIf=\"extendedDetails.toolTip\"\r\n                              [body]=\"extendedDetails.toolTip\"\r\n                              [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                              [customClass]=\"'focus-text focus-circle'\"\r\n                              [ariaLabel]=\"'More info'\"\r\n                            >\r\n                              <i class=\"fas fa-question-circle\" aria-hidden=\"true\"></i>\r\n                            </vnext-tooltip>\r\n                          </h3>\r\n                        </div>\r\n                      </ng-template>\r\n                      <ng-template ngbPanelContent>\r\n                        <div\r\n                          class=\"Spa_Style_Accent6_Background p-2 Spa_Style_Secondary_Text_Color text-center\"\r\n                          *ngIf=\"showTierPharmacyNetworkLabel && (extendedDetails.isInNetwork || extendedDetails.isPreferred)\"\r\n                        >\r\n                          {{ pharmacyNetworkText }}\r\n                        </div>\r\n                        <div\r\n                          class=\"Spa_Style_Accent6_Background p-2 Spa_Style_Secondary_Text_Color text-center\"\r\n                          *ngIf=\"showTierPharmacyNetworkLabel && isMailOrderSelected && extendedDetails.isMailOrder\"\r\n                        >\r\n                          {{ mailOrderPharmacyText }}\r\n                        </div>\r\n                        <div\r\n                          role=\"table\"\r\n                          [attr.aria-labelledby]=\"\r\n                            extendedDetails.name.toLowerCase() === this.planDetailsText.toLowerCase()\r\n                              ? 'documents-section-heading'\r\n                              : 'benefits-section-heading-' + [i]\r\n                          \"\r\n                        >\r\n                          <div role=\"rowgroup\" class=\"sr-only\">\r\n                            <div role=\"row\">\r\n                              <span role=\"columnheader\">{{ extendedDetails.name }} benefit description</span>\r\n                              <span role=\"columnheader\">{{ extendedDetails.name }} benefit amount</span>\r\n                            </div>\r\n                          </div>\r\n                          <vnext-plan-benefit-details\r\n                            [lowIncomeSubsidyText]=\"lowIncomeSubsidyText\"\r\n                            [lowIncomeSubsidyLabel]=\"lowIncomeSubsidyLabel\"\r\n                            [lowIncomeSubsidyInformationalText]=\"lowIncomeSubsidyInformationalText\"\r\n                            [showSubsidy]=\"showSubsidy\"\r\n                            [extendedDetails]=\"extendedDetails\"\r\n                            [mobile]=\"isMobile\"\r\n                          >\r\n                          </vnext-plan-benefit-details>\r\n                        </div>\r\n                      </ng-template>\r\n                    </ngb-panel>\r\n                  </ngb-accordion>\r\n                </div>\r\n                <div></div>\r\n              </ng-container>\r\n            </div>\r\n          </div>\r\n\r\n          <!-- Checking for Hospital Care/HIP/HC PlanType -->\r\n          <div *ngIf=\"isHCPlan\">\r\n            <vnext-plan-sub-details-rider-category\r\n              [mobile]=\"isMobile\"\r\n              [riderCategories]=\"riderBenefitCategoriesForHospitalIndemnity\"\r\n              [riderHIPBenefitDefaultDropdownText]=\"riderHIPBenefitDefaultDropdownText\"\r\n              [riderHIPBenefitText]=\"riderHIPBenefitText\"\r\n              [basePlanNames]=\"[hospitalIndemnityBasePlanName]\"\r\n              (riderBenefitDropdownSelection)=\"onRiderBenefitDropdownSelectionEvent($event)\"\r\n            >\r\n            </vnext-plan-sub-details-rider-category>\r\n          </div>\r\n        </ng-template>\r\n      </ngb-panel>\r\n    </ngb-accordion>\r\n  </div>\r\n  <div\r\n    *ngIf=\"guidedHelpEnabled && showPreferencesSection\"\r\n    class=\"plan-details-accordion accordion-container col-md-12 plan-details-section-min-height\"\r\n    [ngClass]=\"{ 'order-2': preferencesPositionLast, 'order-1': !preferencesPositionLast }\"\r\n  >\r\n    <ngb-accordion #preferencesAccordion=\"ngbAccordion\" activeIds=\"{{ activeIds }}\">\r\n      <ngb-panel id=\"custom-panel-1\" class=\"card-header\">\r\n        <!-- Start accordion header section-->\r\n        <ng-template ngbPanelHeader let-opened=\"closed\">\r\n          <div\r\n            class=\"d-flex align-items-center justify-content-between main-header Spa_Style_Accent6_Background\"\r\n            (click)=\"isLiveEdit && preferencesAccordion.expand('custom-panel-1')\"\r\n          >\r\n            <button ngbPanelToggle class=\"btn container-fluid text-left pl-0\" [attr.aria-label]=\"preferencesText\" aria-expanded=\"true\">\r\n              <span class=\"m-0 Spa_Style_H2 Spa_Style_Secondary_Text_Color\" role=\"heading\" aria-level=\"2\">\r\n                <span *liveEditProp=\"'Spa_Plan_Details_Preferences_Text'\"> {{ preferencesText }} </span>\r\n                <i class=\"fas fa-chevron-up pt-1 float-right\"></i>\r\n                <span class=\"sr-only\">Collapse</span>\r\n              </span>\r\n            </button>\r\n          </div>\r\n        </ng-template>\r\n        <ng-template ngbPanelContent>\r\n          <!-- Start providers panel -->\r\n          <div\r\n            *ngIf=\"showProvidersSection && (isProvidersEnabled || selectedPlanProvidersLinkType === providersLinkType.EXTERNAL)\"\r\n            class=\"row mx-0 plan-details-section-min-height\"\r\n          >\r\n            <div class=\"col-12 p-0\" role=\"table\" aria-labelledby=\"provider-section-heading\">\r\n              <div role=\"rowgroup\" class=\"sr-only\">\r\n                <div role=\"row\">\r\n                  <span *liveEditProp=\"'Spa_Plan_Details_Preferences_Provider_Text'\" role=\"columnheader\"\r\n                    >{{ providerText }} information type</span\r\n                  >\r\n                  <span *liveEditProp=\"'Spa_Plan_Details_Preferences_Provider_Text'\" role=\"columnheader\">{{ providerText }} coverage</span>\r\n                </div>\r\n              </div>\r\n              <div\r\n                role=\"row\"\r\n                class=\"gray2-static d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-start justify-content-sm-between preferences-header\"\r\n              >\r\n                <div role=\"rowheader\" class=\"preferences-header-content-left\">\r\n                  <i class=\"fas fa-user-md Spa_Style_ProvidersIcon icon\" aria-hidden=\"true\"></i>\r\n                  <h3\r\n                    class=\"Spa_Style_H3 d-inline pl-1\"\r\n                    *liveEditProp=\"'Spa_Plan_Details_Preferences_Provider_Text'\"\r\n                    id=\"provider-section-heading\"\r\n                  >\r\n                    {{ providerText }}\r\n                  </h3>\r\n                </div>\r\n                <div role=\"rowheader\" class=\"preferences-link pr-3\" *ngIf=\"isProvidersEnabled\">\r\n                  <vnext-link\r\n                    [keyNameForLiveEdit]=\"'Spa_Providers_Add_Edit_Link'\"\r\n                    [title]=\"providersAddEditLinkTitle\"\r\n                    [alwaysUnderlined]=\"true\"\r\n                    [linkTarget]=\"'_self'\"\r\n                    [role]=\"linkRoles.LINK\"\r\n                    (click)=\"openGuidedHelp(pageTags.GUIDED_HELP_PROVIDER_SEARCH)\"\r\n                    (keyup.enter)=\"openGuidedHelp(pageTags.GUIDED_HELP_PROVIDER_SEARCH)\"\r\n                  >\r\n                  </vnext-link>\r\n                </div>\r\n              </div>\r\n              <div\r\n                *ngIf=\"showProvider && selectedPlanProvidersLinkType !== providersLinkType.NO_LINK\"\r\n                role=\"row\"\r\n                class=\"row mx-0 plan-details-section-min-height\"\r\n              >\r\n                <div\r\n                  role=\"rowheader\"\r\n                  class=\"Spa_Style_H5 plan-level-header plan-details-section-left m-0 col-md-4\"\r\n                  [ngClass]=\"{\r\n                    'gray1-static': !isMobile\r\n                  }\"\r\n                >\r\n                  <span *liveEditProp=\"'Spa_Plan_Providers_Search_Provider_Text'\"> {{ searchProviderText }} </span>\r\n                </div>\r\n                <div\r\n                  role=\"cell\"\r\n                  class=\"plan-details-section-right col-md-8 Spa_Style_H4 Spa_Style_Primary_Link\"\r\n                  [ngClass]=\"{ 'provider-link-border': selectedProviders?.length && isMobile }\"\r\n                >\r\n                  <div [ngSwitch]=\"selectedPlanProvidersLinkType\">\r\n                    <ng-template [ngSwitchCase]=\"providersLinkType.INTERNAL\">\r\n                      <vnext-link\r\n                        [onClickAction]=\"onProviderClick\"\r\n                        [title]=\"searchProviderLink.title\"\r\n                        [alwaysUnderlined]=\"true\"\r\n                        [isLinkButton]=\"true\"\r\n                        [customClass]=\"'Spa_Style_Link width-fit-content'\"\r\n                        [role]=\"linkRoles.LINK\"\r\n                      ></vnext-link>\r\n                    </ng-template>\r\n                    <ng-template [ngSwitchCase]=\"providersLinkType.EXTERNAL\">\r\n                      <vnext-link\r\n                        [title]=\"providersDirectoryLink\"\r\n                        [alwaysUnderlined]=\"true\"\r\n                        [href]=\"detailedPlan.providerURL\"\r\n                        [linkTarget]=\"'_blank'\"\r\n                        [customClass]=\"'Spa_Style_Link width-fit-content'\"\r\n                        [role]=\"linkRoles.LINK\"\r\n                      ></vnext-link>\r\n                    </ng-template>\r\n                    <ng-template [ngSwitchCase]=\"providersLinkType.INTERNAL_AND_EXTERNAL\">\r\n                      <div class=\"pb-4\">\r\n                        <vnext-link\r\n                          [title]=\"providersCarrierDirectoryLink\"\r\n                          [alwaysUnderlined]=\"true\"\r\n                          [href]=\"detailedPlan.providerURL\"\r\n                          [linkTarget]=\"'_blank'\"\r\n                          [customClass]=\"'Spa_Style_Link width-fit-content'\"\r\n                          [role]=\"linkRoles.LINK\"\r\n                        ></vnext-link>\r\n                      </div>\r\n                      <vnext-link\r\n                        [onClickAction]=\"onProviderClick\"\r\n                        [title]=\"providersInternalDirectoryLink\"\r\n                        [alwaysUnderlined]=\"true\"\r\n                        [isLinkButton]=\"true\"\r\n                        [customClass]=\"'Spa_Style_Link width-fit-content'\"\r\n                        [role]=\"linkRoles.LINK\"\r\n                      ></vnext-link>\r\n                    </ng-template>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <ng-container *ngFor=\"let selectedProvider of selectedProviders\">\r\n                <vnext-plan-provider-details\r\n                  [planId]=\"detailedPlan.id\"\r\n                  [provider]=\"selectedProvider\"\r\n                  [isComparePage]=\"false\"\r\n                  [providerDetailResponse]=\"providerDetailResponse\"\r\n                  [selectedProviderDetails]=\"\r\n                    planDetailsFacade.getSelectedProviderDetails(detailedPlan.id, providerDetailResponse, selectedProvider)\r\n                  \"\r\n                  [inNetworkProviderText]=\"inNetworkProviderText\"\r\n                  [outOfNetworkProviderText]=\"outOfNetworkProviderText\"\r\n                  [pcpText]=\"pcpText\"\r\n                  [noProviderDetailsText]=\"noProviderDetailsText\"\r\n                  [isMobile]=\"isMobile\"\r\n                  [customClass]=\"'plan-level-header provider-details-section-left m-0 col-md-4 no-translate-block'\"\r\n                  [showNetworkDetails]=\"true\"\r\n                  [showProviderDetails]=\"true\"\r\n                  [noProviderNetworkAccessText]=\"noProviderNetworkAccessText\"\r\n                  [hasProviderDetails]=\"detailedPlan.showProviderSearch\"\r\n                  [canSellPlan]=\"canSellPlan\"\r\n                  [viewAllText]=\"viewAllText\"\r\n                  [hideText]=\"hideText\"\r\n                  [providerInfoEnabled]=\"providerInfoEnabled\"\r\n                  [countryCode]=\"countryCode\"\r\n                  [acceptingNewPatientsIcon]=\"acceptingNewPatientsIcon\"\r\n                  [acceptingNewPatientsText]=\"acceptingNewPatientsText\"\r\n                  [providerLanguages]=\"providerLanguages\"\r\n                  [providersAcceptingNewPatients]=\"providersAcceptingNewPatients\"\r\n                  [languagesIcon]=\"languagesIcon\"\r\n                  [providerMedicalGroups]=\"providerMedicalGroups\"\r\n                  [isVbcAgreementEnabled]=\"isVbcAgreementEnabled\"\r\n                  [vbcAgreementLabel]=\"vbcAgreementLabel\"\r\n                  [vbcAgreementTooltip]=\"vbcAgreementTooltip\"\r\n                  [isZelisIntegrationEnabled]=\"isZelisIntegrationEnabled\"\r\n                  role=\"row\"\r\n                >\r\n                </vnext-plan-provider-details>\r\n              </ng-container>\r\n            </div>\r\n          </div>\r\n          <!-- Start prescriptions panel -->\r\n          <div *ngIf=\"showPrescriptionsSection\" class=\"row mx-0 plan-details-section-min-height\">\r\n            <div class=\"col-12 p-0\" role=\"table\" aria-labelledby=\"prescriptions-section-heading\">\r\n              <div role=\"rowgroup\" class=\"sr-only\">\r\n                <div role=\"row\">\r\n                  <span *liveEditProp=\"'Spa_Plan_Details_Preferences_Prescription_Text'\" role=\"columnheader\"\r\n                    >{{ prescriptionText }} information type</span\r\n                  >\r\n                  <span *liveEditProp=\"'Spa_Plan_Details_Preferences_Prescription_Text'\" role=\"columnheader\"\r\n                    >{{ prescriptionText }} coverage</span\r\n                  >\r\n                </div>\r\n              </div>\r\n              <div\r\n                role=\"row\"\r\n                class=\"gray2-static d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-start justify-content-sm-between preferences-header\"\r\n              >\r\n                <div role=\"rowheader\" class=\"preferences-header-content-left\">\r\n                  <i class=\"{{ prescriptionIcon }} fas icon preferences-icon Spa_Style_PrescriptionsIcon\"></i>\r\n                  <h3\r\n                    class=\"Spa_Style_H3 d-inline pl-1\"\r\n                    *liveEditProp=\"'Spa_Plan_Details_Preferences_Prescription_Text'\"\r\n                    id=\"prescriptions-section-heading\"\r\n                  >\r\n                    {{ prescriptionText }}\r\n                  </h3>\r\n                </div>\r\n                <div role=\"rowheader\" class=\"preferences-link pr-3\">\r\n                  <vnext-link\r\n                    [keyNameForLiveEdit]=\"'Spa_Prescription_Add_Edit_Link'\"\r\n                    [title]=\"prescriptionAddEditLinkTitle\"\r\n                    [alwaysUnderlined]=\"true\"\r\n                    [linkTarget]=\"'_self'\"\r\n                    [role]=\"linkRoles.LINK\"\r\n                    (click)=\"openGuidedHelp(pageTags.GUIDED_HELP_PRESCRIPTIONS)\"\r\n                    (keyup.enter)=\"openGuidedHelp(pageTags.GUIDED_HELP_PRESCRIPTIONS)\"\r\n                  >\r\n                  </vnext-link>\r\n                </div>\r\n              </div>\r\n              <div role=\"row\" class=\"row mx-0 plan-details-section-min-height\">\r\n                <div\r\n                  role=\"rowheader\"\r\n                  class=\"Spa_Style_H5 plan-level-header plan-details-section-left m-0 col-md-4\"\r\n                  [ngClass]=\"{ 'gray1-static': !isMobile }\"\r\n                >\r\n                  <span *liveEditProp=\"'Spa_PlanDetails_Preferences_SearchPrescriptions_Text'\">{{ searchPrescriptionsText }}</span>\r\n                </div>\r\n                <div role=\"cell\" class=\"plan-details-section-right col-md-8\">\r\n                  <span class=\"Spa_Style_H4 mb-0 Spa_Style_Primary_Link\">\r\n                    <vnext-link\r\n                      [onClickAction]=\"onPrescriptionClick\"\r\n                      [title]=\"prescriptionDirectoryLink.title\"\r\n                      [alwaysUnderlined]=\"true\"\r\n                      [isLinkButton]=\"true\"\r\n                      [customClass]=\"'Spa_Style_Link width-fit-content'\"\r\n                      [role]=\"linkRoles.LINK\"\r\n                    ></vnext-link>\r\n                  </span>\r\n                </div>\r\n              </div>\r\n              <div *ngFor=\"let drug of drugCabinet | orderBy : 'labelName' : false : true\">\r\n                <div role=\"row\" class=\"row mx-0 plan-details-section-min-height\">\r\n                  <div\r\n                    role=\"rowheader\"\r\n                    class=\"Spa_Style_H5 plan-level-header plan-details-section-left m-0 col-md-4\"\r\n                    [ngClass]=\"{ 'gray1-static': !isMobile }\"\r\n                  >\r\n                    <span class=\"no-translate-block\">{{ drug.labelName }}</span>\r\n                    <div class=\"pt-1 Spa_Style_Note\" [innerHTML]=\"dosePackageQuantityFreqByDosage[drug.dosageID]\"></div>\r\n                  </div>\r\n                  <div role=\"cell\" class=\"plan-details-section-right col-md-8\">\r\n                    <div class=\"row pr-3\">\r\n                      <span class=\"Spa_Style_H4 mb-0 col-12\" *ngIf=\"isDrugCovered(drug.dosage.ndc); else nonCovered\">\r\n                        <i class=\"fas fa-check-circle covered-drugs\" aria-hidden=\"true\"></i> {{ coveredDrugsText }}\r\n                      </span>\r\n                      <ng-template #nonCovered>\r\n                        <span class=\"Spa_Style_H4 col-12 col-sm-6\">\r\n                          <i class=\"fas fa-times-circle non-covered-drugs\" aria-hidden=\"true\"></i>\r\n                          {{ nonCoveredText }}\r\n                        </span>\r\n                        <div\r\n                          *ngIf=\"showDrugAlternativesEnabled && planAttributeMap[detailedPlan.id][drug.dosageID]?.showDrugAlternatives\"\r\n                          class=\"col-12 col-sm-6 text-left text-sm-right\"\r\n                        >\r\n                          <vnext-link\r\n                            (click)=\"onViewPossibleAlternativeDrugsClick(detailedPlan, drug)\"\r\n                            [title]=\"showDrugAlternativesText\"\r\n                            [alwaysUnderlined]=\"true\"\r\n                            [showArrow]=\"'right'\"\r\n                            [customClass]=\"'Spa_Style_Link width-fit-content'\"\r\n                            [role]=\"linkRoles.LINK\"\r\n                          ></vnext-link>\r\n                        </div>\r\n                      </ng-template>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <!-- Start pharmacy panel-->\r\n          <div *ngIf=\"showPharmacySection\" class=\"row mx-0 plan-details-section-min-height\" role=\"table\">\r\n            <div class=\"col-12 gray2-static p-0\" aria-labelledby=\"pharmacy-section-heading\">\r\n              <div role=\"rowgroup\" class=\"sr-only\">\r\n                <div role=\"row\">\r\n                  <span *liveEditProp=\"'Spa_Plan_Details_Preferences_Pharmacy_Text'\" role=\"columnheader\"\r\n                    >{{ pharmacyText }} information type</span\r\n                  >\r\n                  <span *liveEditProp=\"'Spa_Plan_Details_Preferences_Pharmacy_Text'\" role=\"columnheader\">{{ pharmacyText }} coverage</span>\r\n                </div>\r\n              </div>\r\n              <div\r\n                role=\"row\"\r\n                class=\"d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-start justify-content-sm-between preferences-header\"\r\n              >\r\n                <div role=\"rowheader\" class=\"preferences-header-content-left\">\r\n                  <i class=\"fas Spa_Style_PharmacyIcon icon\" aria-hidden=\"true\"></i>\r\n                  <h3\r\n                    class=\"Spa_Style_H3 d-inline pl-1\"\r\n                    *liveEditProp=\"'Spa_Plan_Details_Preferences_Pharmacy_Text'\"\r\n                    id=\"pharmacy-section-heading\"\r\n                  >\r\n                    {{ pharmacyText }}\r\n                  </h3>\r\n                </div>\r\n                <div role=\"rowheader\" class=\"preferences-link pr-3\">\r\n                  <vnext-link\r\n                    [keyNameForLiveEdit]=\"'Spa_Site_Pharmacy_AddEdit_Link'\"\r\n                    [title]=\"pharmacyAddEditLink\"\r\n                    [alwaysUnderlined]=\"true\"\r\n                    [linkTarget]=\"'_self'\"\r\n                    [role]=\"linkRoles.LINK\"\r\n                    (click)=\"openGuidedHelp(pageTags.GUIDED_HELP_PHARMACY_SEARCH)\"\r\n                    (keyup.enter)=\"openGuidedHelp(pageTags.GUIDED_HELP_PHARMACY_SEARCH)\"\r\n                  >\r\n                  </vnext-link>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"container p-0\">\r\n              <div role=\"row\" class=\"row mx-0 plan-details-section-min-height\">\r\n                <div\r\n                  role=\"rowheader\"\r\n                  class=\"Spa_Style_H5 plan-level-header plan-details-section-left m-0 col-md-4\"\r\n                  [ngClass]=\"{ 'gray1-static': !isMobile }\"\r\n                >\r\n                  <span *liveEditProp=\"'Spa_PlanDetails_Preferences_SearchPharmacy_Text'\">{{ searchPharmacyText }}</span>\r\n                </div>\r\n                <div role=\"cell\" class=\"plan-details-section-right col-md-8\">\r\n                  <span class=\"Spa_Style_H4 mb-0 Spa_Style_Primary_Link\">\r\n                    <vnext-link\r\n                      [onClickAction]=\"onPharmacyClick\"\r\n                      [title]=\"searchPharmacyLink.title\"\r\n                      [alwaysUnderlined]=\"true\"\r\n                      [isLinkButton]=\"true\"\r\n                      [customClass]=\"'Spa_Style_Link width-fit-content'\"\r\n                      [role]=\"linkRoles.LINK\"\r\n                    >\r\n                    </vnext-link>\r\n                  </span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div role=\"row\" aria-owns=\"plan-pharmacy-details\" class=\"container p-0\" *ngIf=\"selectedPharmacy\">\r\n              <vnext-plan-pharmacy-details\r\n                class=\"plan-details-section-min-height\"\r\n                [pharmacies]=\"pharmacies\"\r\n                [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n                [inNetworkStandardText]=\"inNetworkStandardText\"\r\n                [outOfNetworkText]=\"outOfNetworkText\"\r\n                [showPrimaryPharmacyLabel]=\"isMultiPharmacyEnabled\"\r\n                [primaryPharmacyText]=\"primaryPharmacyText\"\r\n                [primaryPharmacy]=\"primaryPharmacy\"\r\n                [nonCoveredText]=\"nonCoveredText\"\r\n                [showNotCovered]=\"!isPlanPharmacyCovered\"\r\n              ></vnext-plan-pharmacy-details>\r\n              <vnext-mail-order-pharmacy-details\r\n                class=\"plan-details-section-min-height\"\r\n                [isComparePage]=\"false\"\r\n                [mailOrderText]=\"mailOrderText\"\r\n                [showMailOrderPharmacy]=\"showMailOrderPharmacy\"\r\n                [coveredText]=\"coveredDrugsText\"\r\n                [notCoveredText]=\"nonCoveredText\"\r\n                [hasMailOrder]=\"detailedPlan.hasMailDrugBenefits && isPlanPharmacyCovered\"\r\n                [isMobile]=\"isMobile\"\r\n              ></vnext-mail-order-pharmacy-details>\r\n            </div>\r\n          </div>\r\n          <!-- Start other preferences panel -->\r\n          <div class=\"row mx-0 plan-details-section-min-height\" *ngIf=\"showOtherPreferencesSection\">\r\n            <div class=\"col-12 p-0\" role=\"table\" aria-labelledby=\"other-preferences-section-heading\">\r\n              <div role=\"rowgroup\" class=\"sr-only\">\r\n                <div role=\"row\">\r\n                  <span *liveEditProp=\"'Spa_Plan_Details_OtherPreferences_Text'\" role=\"columnheader\"\r\n                    >{{ otherPreferencesText }} information type</span\r\n                  >\r\n                  <span *liveEditProp=\"'Spa_Plan_Details_OtherPreferences_Text'\" role=\"columnheader\"\r\n                    >{{ otherPreferencesText }} coverage</span\r\n                  >\r\n                </div>\r\n              </div>\r\n              <div\r\n                role=\"row\"\r\n                class=\"d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-start justify-content-sm-between preferences-header gray2-static\"\r\n              >\r\n                <div role=\"rowheader\" class=\"preferences-header-content-left\">\r\n                  <i class=\"fas Spa_Style_OtherPreferencesIcon icon\" aria-hidden=\"true\"></i>\r\n                  <h3\r\n                    class=\"Spa_Style_H3 d-inline pl-1\"\r\n                    *liveEditProp=\"'Spa_Plan_Details_OtherPreferences_Text'\"\r\n                    id=\"other-preferences-section-heading\"\r\n                  >\r\n                    {{ otherPreferencesText }}\r\n                  </h3>\r\n                </div>\r\n                <div role=\"rowheader\" class=\"preferences-link pr-3\">\r\n                  <vnext-link\r\n                    [keyNameForLiveEdit]=\"'Spa_Site_Preferences_AddEdit_Link'\"\r\n                    [title]=\"preferencesAddEditLink\"\r\n                    [alwaysUnderlined]=\"true\"\r\n                    [linkTarget]=\"'_self'\"\r\n                    [role]=\"linkRoles.LINK\"\r\n                    (click)=\"navigateByPageTag(pageTags.GUIDED_HELP_OTHER_PREFERENCES)\"\r\n                    (keyup.enter)=\"navigateByPageTag(pageTags.GUIDED_HELP_OTHER_PREFERENCES)\"\r\n                  >\r\n                  </vnext-link>\r\n                </div>\r\n              </div>\r\n              <div *ngFor=\"let benefit of answeredPreferenceBenefits\">\r\n                <div role=\"row\" class=\"row mx-0 plan-details-section-min-height\">\r\n                  <div\r\n                    role=\"rowheader\"\r\n                    class=\"Spa_Style_H5 plan-level-header plan-details-section-left m-0 col-md-4\"\r\n                    [ngClass]=\"{ 'gray1-static': !isMobile }\"\r\n                  >\r\n                    {{ benefit.displayLabel }}\r\n                  </div>\r\n                  <div role=\"cell\" class=\"plan-details-section-right col-md-8\">\r\n                    <div>\r\n                      <span class=\"Spa_Style_H4 mb-0\" *ngIf=\"benefit.isCovered; else nonCovered\">\r\n                        <i class=\"fas fa-check-circle covered-drugs\" aria-hidden=\"true\"></i> {{ coveredBenefitText }}\r\n                      </span>\r\n                      <ng-template #nonCovered>\r\n                        <span class=\"Spa_Style_H4 mb-0\">\r\n                          <i class=\"fas fa-times-circle non-covered-drugs\" aria-hidden=\"true\"></i>\r\n                          {{ nonCoveredBenefitText }}\r\n                        </span>\r\n                      </ng-template>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n      </ngb-panel>\r\n    </ngb-accordion>\r\n  </div>\r\n\r\n  <div\r\n    class=\"plan-details-accordion accordion-container col-md-12 plan-details-section-min-height\"\r\n    [ngClass]=\"{ 'order-2': preferencesPositionLast, 'order-1': !preferencesPositionLast }\"\r\n    *ngIf=\"planDetailsFacade.showRiders(detailedPlan) && !isHCPlan\"\r\n  >\r\n    <ngb-accordion activeIds=\"riders-panel\">\r\n      <ngb-panel id=\"riders-panel\" class=\"card-header\">\r\n        <ng-template ngbPanelHeader let-opened=\"closed\">\r\n          <div class=\"d-flex align-items-center justify-content-between Spa_Style_Accent6_Background main-header\">\r\n            <button ngbPanelToggle class=\"btn container-fluid text-left pl-0\" [attr.aria-label]=\"addOnRidersHeader\" aria-expanded=\"true\">\r\n              <div class=\"m-0 Spa_Style_Secondary_Text_Color plan-level-section-optional-coverage\">\r\n                <span class=\"Spa_Style_H2 Spa_Style_Secondary_Text_Color\" role=\"heading\" aria-level=\"2\">\r\n                  <span *liveEditProp=\"'Spa_Plan_Details_AddOnRiders_Header'\">{{ addOnRidersHeader }}</span>\r\n                  <p class=\"Spa_Style_Paragraph_Light plan-level-section-available-cart\">{{ addOnRidersSubHeader }}</p>\r\n                </span>\r\n                <i class=\"fas fa-chevron-up pt-1 float-right\"></i>\r\n                <span class=\"sr-only\">Collapse</span>\r\n              </div>\r\n            </button>\r\n          </div>\r\n        </ng-template>\r\n        <ng-template ngbPanelContent>\r\n          <div role=\"table\">\r\n            <div\r\n              role=\"row\"\r\n              *ngFor=\"let riderCategory of riderCategories\"\r\n              class=\"row mx-0 plan-details-section-min-height\"\r\n              [ngClass]=\"{ 'border-bottom': isMobile }\"\r\n            >\r\n              <span role=\"rowheader\" class=\"Spa_Style_H5 plan-details-section-left m-0 col-md-4\" [ngClass]=\"{ gray: !isMobile }\">\r\n                <i\r\n                  *ngIf=\"riderCategory.waiverStateRider\"\r\n                  class=\"{{ riderCategory.icon }} Spa_Style_Primary_Link_Color icon\"\r\n                  aria-hidden=\"true\"\r\n                ></i>\r\n                {{ riderCategory.label }}\r\n                <i\r\n                  *ngIf=\"riderCategory.waiverTooltip\"\r\n                  container=\"body\"\r\n                  class=\"fas Spa_Style_QuestionIcon\"\r\n                  [ngbTooltip]=\"riderCategory.waiverTooltip\"\r\n                  tabindex=\"0\"\r\n                  aria-label=\"Show tooltip\"\r\n                ></i>\r\n              </span>\r\n              <div role=\"cell\" class=\"plan-details-section-right col-md-8 Spa_Style_H4 mb-0\">\r\n                <div *ngFor=\"let rider of riderCategory.riders\" class=\"mb-2 pl-0\">\r\n                  <ng-container *ngIf=\"rider.isRequiredRider; then requiredRider; else normalRider\"></ng-container>\r\n\r\n                  <ng-template #requiredRider>\r\n                    <div class=\"Spa_Style_H4\">\r\n                      <i class=\"fas fa-check-circle included-icon Spa_Style_CheckmarksAndPreferredInNetwork\" aria-hidden=\"true\"></i>\r\n                      {{ riderIsIncludedText }}\r\n                    </div>\r\n                  </ng-template>\r\n                  <ng-template #normalRider>\r\n                    <div class=\"Spa_Style_Paragraph pb-2 no-translate-block\" *ngIf=\"rider.planName\">{{ rider.planName }}</div>\r\n                    <div>\r\n                      <span *ngIf=\"getRiderMedicalPremium(rider) !== null\"> {{ getRiderMedicalPremium(rider) | currency }}</span>\r\n                      <vnext-plan-rider-details\r\n                        [rider]=\"rider\"\r\n                        [showRiderDetails]=\"showRiderDetails\"\r\n                        [hideRiderDetailsText]=\"hideRiderDetailsText\"\r\n                        [showRiderDetailsText]=\"showRiderDetailsText\"\r\n                      ></vnext-plan-rider-details>\r\n                    </div>\r\n                  </ng-template>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n      </ngb-panel>\r\n    </ngb-accordion>\r\n  </div>\r\n\r\n  <div class=\"plan-details-accordion accordion-container col-12 order-2\" *ngIf=\"planDocuments?.name\">\r\n    <ngb-accordion activeIds=\"plan-document-container\">\r\n      <ngb-panel id=\"plan-document-container\" class=\"card-header\">\r\n        <ng-template ngbPanelHeader let-opened=\"open\">\r\n          <div class=\"d-flex align-items-center justify-content-between main-header Spa_Style_Accent6_Background\">\r\n            <button ngbPanelToggle class=\"btn container-fluid text-left pl-0\" [attr.aria-label]=\"planDetailsText\" aria-expanded=\"true\">\r\n              <span class=\"m-0 Spa_Style_H2 Spa_Style_Secondary_Text_Color\" role=\"heading\" aria-level=\"2\">\r\n                <span> {{ planDocuments.name }}</span>\r\n                <i class=\"fas fa-chevron-up pt-1 float-right\"></i>\r\n                <span class=\"sr-only\">Collapse</span>\r\n              </span>\r\n            </button>\r\n          </div>\r\n        </ng-template>\r\n        <ng-template ngbPanelContent>\r\n          <vnext-plan-benefit-details [showSubsidy]=\"showSubsidy\" [extendedDetails]=\"planDocuments\" [mobile]=\"isMobile\">\r\n          </vnext-plan-benefit-details>\r\n        </ng-template>\r\n      </ngb-panel>\r\n    </ngb-accordion>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n  <div class=\"col-md-12 mt-3 Spa_Style_Smaller_Font Spa_Style_Gray4_Color\" *liveEditProp=\"'Spa_PlanDetails_Bottom_Content_Header'\">\r\n    <div *ngIf=\"planId\">{{ planBottomContentHeader }}: {{ planId }}</div>\r\n  </div>\r\n  <div class=\"col-md-12 d-inline-block\">\r\n    <div class=\"Spa_Style_Smaller_Font Spa_Style_Gray4_Color\">\r\n      {{ planTypeText }}\r\n    </div>\r\n\r\n    <div\r\n      class=\"Spa_Style_Smaller_Font Spa_Style_Gray4_Color plantype-text\"\r\n      [innerHTML]=\"planDetailsBottomContentText | safe : 'html'\"\r\n      *liveEditProp=\"planBottomContentResource\"\r\n      navigationAdapter\r\n    ></div>\r\n  </div>\r\n</div>\r\n", styles: [".plan-details-accordion .fa-chevron-up:before{content:\"\\f077\";font-size:22px}.plan-details-accordion .collapsed .fa-chevron-up:before{content:\"\\f078\"}.plan-details-accordion:last-child .plan-details-section-left:last-child,.plan-details-accordion:last-child .plan-details-section-right:last-child{border-bottom:1px solid var(--static-Spa_Style_Accent1)}.section-header{padding:17px 5px;min-height:60px}.plan-details-section-right h4>p{margin-bottom:0!important}.main-header{padding:3px 5px 3px 10px;min-height:60px}.section-tooltip{width:323px}.icon-tooltip{font-size:18px}button,.btn{border:none}button:focus,.btn:focus{outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:inset 0 1px 1px var(--static-Spa_Style_Accent1),0 0 8px var(--static-Spa_Style_Accent1)}.plan-details-section-left{border-right:1px solid var(--static-Spa_Style_Accent1);border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:15px 0 15px 10px}.plan-details-section-right{border:1px solid var(--static-Spa_Style_Accent1);border-width:0 0 1px;padding:14px 0 10px 10px}.plan-details-section-min-height{min-height:60px}.covered-drugs{color:var(--static-Spa_Style_Accent5)}.non-covered-drugs{color:var(--static-Spa_Style_Accent1)}.icon{font-size:18px}.fa-chevron-up{font-size:22px}.preferences-header{min-height:60px;border-bottom:1px solid var(--static-Spa_Style_Accent1)}.preferences-header-content-left{padding-left:10px}.preferences-icon{width:20px}.included-icon{font-family:\"Font Awesome 5 Pro\"}.gray1-static{background-color:var(--static-Spa_Style_Gray1)}.gray2-static{background-color:var(--static-Spa_Style_Gray2)}.plan-level-section-optional-coverage{display:flex;justify-content:space-between}.plan-level-section-available-cart{display:contents}@media (max-width: 767px){.plan-details-section-left{border-width:0;padding:6px 5px 0 10px;min-height:28px}.plan-details-section-right{padding:4px 5px 15px 10px;border:none}.preferences-link{margin-left:40px}.main-header{min-height:70px}.plan-details-accordion:last-child .plan-details-section-left:last-child,.plan-details-accordion:last-child .plan-details-section-right:last-child{border:0}}@media (max-width: 479.98px){.preferences-header{padding-top:12px;min-height:70px}.preferences-icon{width:25px}.plan-details-section-min-height,.section-header{min-height:70px}}@media (min-width: 480px) and (max-width: 575.98px){.preferences-header{padding-top:12px;min-height:70px}}\n"] }]
    }], function () { return [{ type: PlanDetailsFacade }, { type: PlanFacade }, { type: i1.DrugsService }, { type: AnalyticsService }, { type: i1.NavigationService }, { type: HelpfulToolsService }, { type: i1.LocaleService }, { type: i0.ChangeDetectorRef }, { type: i2$1.ActivatedRoute }, { type: i1$2.ViewportScroller }, { type: i1.PreferencesService }, { type: i1.ProviderService }, { type: PharmacyFacade }, { type: RiderFacade }, { type: i2.Store }, { type: DrugDetailsFacade }, { type: i1.GuidedHelpModalContextService }]; }, { cabinet$: [], preferencesBannerEnabled: [{
            type: Input
        }], detailedPlan: [{
            type: Input
        }], planBottomContentHeader: [{
            type: Input
        }], planDetailsBottomContentText: [{
            type: Input
        }], costSectionHeader: [{
            type: Input
        }], planLevelContentLabel: [{
            type: Input
        }], showPlanLevelContent: [{
            type: Input
        }], premiumText: [{
            type: Input
        }], planBenefitSectionName: [{
            type: Input
        }], pharmacyText: [{
            type: Input
        }], preferencesText: [{
            type: Input
        }], preferencesExpanded: [{
            type: Input
        }], preferencesPositionLast: [{
            type: Input
        }], showPreferences: [{
            type: Input
        }], showProvider: [{
            type: Input
        }], showPrescription: [{
            type: Input
        }], showPharmacy: [{
            type: Input
        }], showOtherPreferences: [{
            type: Input
        }], providerText: [{
            type: Input
        }], prescriptionText: [{
            type: Input
        }], otherPreferencesText: [{
            type: Input
        }], addOnRidersHeader: [{
            type: Input
        }], addOnRidersSubHeader: [{
            type: Input
        }], prescriptionIcon: [{
            type: Input
        }], prescriptionAddEditLinkTitle: [{
            type: Input
        }], pharmacyLink: [{
            type: Input
        }], pharmacyAddEditLink: [{
            type: Input
        }], preferencesAddEditLink: [{
            type: Input
        }], providersLink: [{
            type: Input
        }], riderIsIncludedText: [{
            type: Input
        }], waiverStateRiderTooltips: [{
            type: Input
        }], inNetworkPreferredText: [{
            type: Input
        }], inNetworkStandardText: [{
            type: Input
        }], outOfNetworkText: [{
            type: Input
        }], coveredDrugsText: [{
            type: Input
        }], nonCoveredText: [{
            type: Input
        }], coveredBenefitText: [{
            type: Input
        }], nonCoveredBenefitText: [{
            type: Input
        }], guidedHelpEnabled: [{
            type: Input
        }], healthText: [{
            type: Input
        }], costMA: [{
            type: Input
        }], costMAPD: [{
            type: Input
        }], costMEDIGAP: [{
            type: Input
        }], costPDP: [{
            type: Input
        }], costDENTAL: [{
            type: Input
        }], costVISION: [{
            type: Input
        }], costHIP: [{
            type: Input
        }], costAddEditLinkText: [{
            type: Input
        }], healthEnabled: [{
            type: Input
        }], noCostAvailableText: [{
            type: Input
        }], planBottomContentResource: [{
            type: Input
        }], planTypeText: [{
            type: Input
        }], showRiderDetailsText: [{
            type: Input
        }], hideRiderDetailsText: [{
            type: Input
        }], showRiderDetails: [{
            type: Input
        }], riderHIPBenefitText: [{
            type: Input
        }], riderHIPBenefitDefaultDropdownText: [{
            type: Input
        }], prescriptionAddEditLinkDescription: [{
            type: Input
        }], pharmacyAddEditLinkDescription: [{
            type: Input
        }], drugCostAddEditLinkDescription: [{
            type: Input
        }], healthCostAddEditLinkDescription: [{
            type: Input
        }], selectedTab: [{
            type: Input
        }], isRetentionView: [{
            type: Input
        }], noCostMedSupPlanText: [{
            type: Input
        }], isLiveEdit: [{
            type: Input
        }], prescriptionDirectoryLink: [{
            type: Input
        }], searchPrescriptionsText: [{
            type: Input
        }], searchPharmacyLink: [{
            type: Input
        }], searchPharmacyText: [{
            type: Input
        }], searchProviderText: [{
            type: Input
        }], providersDirectoryLink: [{
            type: Input
        }], providersInternalDirectoryLink: [{
            type: Input
        }], providersCarrierDirectoryLink: [{
            type: Input
        }], isBothCarrierAndInternalProvidersDirectoryLinksEnabled: [{
            type: Input
        }], searchProviderLink: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }], documentsSection: [{
            type: Input
        }], planDetailsText: [{
            type: Input
        }], showCosts: [{
            type: Input
        }], annualCost: [{
            type: Input
        }], isMultiPharmacyEnabled: [{
            type: Input
        }], primaryPharmacyText: [{
            type: Input
        }], primaryPharmacy: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], pharmacies: [{
            type: Input
        }], isMailOrderSelected: [{
            type: Input
        }], showTierPharmacyNetworkLabel: [{
            type: Input
        }], pharmacyNetworkText: [{
            type: Input
        }], mailOrderPharmacyText: [{
            type: Input
        }], mailOrderText: [{
            type: Input
        }], showMailOrderPharmacy: [{
            type: Input
        }], providersAddEditLinkTitle: [{
            type: Input
        }], isProvidersEnabled: [{
            type: Input
        }], inNetworkProviderText: [{
            type: Input
        }], outOfNetworkProviderText: [{
            type: Input
        }], noProviderDetailsText: [{
            type: Input
        }], pcpText: [{
            type: Input
        }], selectedProviders: [{
            type: Input
        }], providerDetailResponse: [{
            type: Input
        }], isPlanPharmacyCovered: [{
            type: Input
        }], noProviderNetworkAccessText: [{
            type: Input
        }], canSellPlan: [{
            type: Input
        }], basePlanOptionLabel: [{
            type: Input
        }], planTotalPremium: [{
            type: Input
        }], showDrugAlternativesEnabled: [{
            type: Input
        }], showDrugAlternativesText: [{
            type: Input
        }], addHealthCostText: [{
            type: Input
        }], hideText: [{
            type: Input
        }], viewAllText: [{
            type: Input
        }], providerInfoEnabled: [{
            type: Input
        }], providers: [{
            type: Input
        }], acceptingNewPatientsText: [{
            type: Input
        }], acceptingNewPatientsIcon: [{
            type: Input
        }], languagesIcon: [{
            type: Input
        }], providerLanguages: [{
            type: Input
        }], providersAcceptingNewPatients: [{
            type: Input
        }], countryCode: [{
            type: Input
        }], planFeesEnabled: [{
            type: Input
        }], planFeesLabelText: [{
            type: Input
        }], planFeesIncludedInPremiumTooltipText: [{
            type: Input
        }], planFeesNotIncludedInPremiumTooltipText: [{
            type: Input
        }], snpPremiumRangeEnabled: [{
            type: Input
        }], providerMedicalGroups: [{
            type: Input
        }], isVbcAgreementEnabled: [{
            type: Input
        }], vbcAgreementLabel: [{
            type: Input
        }], vbcAgreementTooltip: [{
            type: Input
        }], modalHeaderHealthText: [{
            type: Input
        }], closeButtonText: [{
            type: Input
        }], healthCostsBenefits: [{
            type: Input
        }], healthCostsBodyText: [{
            type: Input
        }], healthCostsBenefitsBodyText: [{
            type: Input
        }], healthCostsBenefitsTableHeader: [{
            type: Input
        }], healthCostsUsageTableHeader: [{
            type: Input
        }], healthCostsDaysTableHeader: [{
            type: Input
        }], saveFailedText: [{
            type: Input
        }], saveSuccessText: [{
            type: Input
        }], healthCostsUpdateAnswersText: [{
            type: Input
        }], healthCostsSaveAnswersText: [{
            type: Input
        }], healthCostsRestoreDefaultsText: [{
            type: Input
        }], healthCostsCustomizationEnabled: [{
            type: Input
        }], healthAgeQuestionText: [{
            type: Input
        }], healthSliderHeader1Text: [{
            type: Input
        }], healthSliderHeader2Text: [{
            type: Input
        }], healthSliderHeader3Text: [{
            type: Input
        }], healthSliderBody1: [{
            type: Input
        }], healthSliderBody2: [{
            type: Input
        }], healthSliderBody3: [{
            type: Input
        }], healthSliderLabelText: [{
            type: Input
        }], healthModalView1HeadingText: [{
            type: Input
        }], healthModalView1IntroText: [{
            type: Input
        }], isZelisIntegrationEnabled: [{
            type: Input
        }], providerInputProps: [{
            type: Input
        }], prescriptionInputProps: [{
            type: Input
        }], modalHeaderProvidersText: [{
            type: Input
        }], modalHeaderPrescriptionsText: [{
            type: Input
        }], siteType: [{
            type: Input
        }], benefitRidersSelected: [{
            type: Output
        }], viewPossibleAlternativeDrugs: [{
            type: Output
        }], navigateByPageTag: [] }); })();

class PrescriptionModalComponent {
    constructor(activeModal, cdr, siteService, memberSessionService, spinnerService, store, guidedHelpService, localeService, elementRef, renderer, guidedHelpModalStyleService) {
        this.activeModal = activeModal;
        this.cdr = cdr;
        this.siteService = siteService;
        this.memberSessionService = memberSessionService;
        this.spinnerService = spinnerService;
        this.store = store;
        this.guidedHelpService = guidedHelpService;
        this.localeService = localeService;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.guidedHelpModalStyleService = guidedHelpModalStyleService;
        this.isMemberSessionUpdated = false;
        this.subscriptions = new Subscription();
        this.blueButtonStatus = BlueButtonStatus;
    }
    ngOnInit() {
        this.drugSearchFrequencyList = this.getFilteredFrequencyOptions();
        if (this.prescriptionInputProps?.isBlueButtonEnabled) {
            this.fetchUpdatedMemberDetails();
        }
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe(locale => {
            this.drugSearchFrequencyList = this.getFilteredFrequencyOptions();
            this.cdr.markForCheck();
        }));
    }
    ngAfterViewInit() {
        const modalElement = this.elementRef.nativeElement;
        if (modalElement) {
            this.guidedHelpModalStyleService.applyModalStyle(this.renderer, modalElement);
        }
    }
    fetchUpdatedMemberDetails() {
        if (this.siteService.isPPCSite(this.siteType)) {
            this.blueButtonUpdateInfo$ = this.store.select(MemberState.blueButtonInfo);
            const sessionId = this.memberSessionService.getMemberSessionId();
            this.spinnerService.show(SpinnerEvent.BLUE_BUTTON_LOADING);
            this.subscriptions.add(this.memberSessionService
                .fetchMemberSession$({ sessionId })
                .pipe(switchMap$1(() => this.blueButtonUpdateInfo$), switchMap$1((blueButtonUpdateInfo) => blueButtonUpdateInfo?.status === this.blueButtonStatus.SUCCESS ? from(this.memberSessionService.updateDrugs()) : of(null)))
                .subscribe(blueButtonUpdateInfo => {
                this.isMemberSessionUpdated = true;
                this.spinnerService.hide(SpinnerEvent.BLUE_BUTTON_LOADING);
                this.cdr.markForCheck();
            }));
        }
        else {
            this.isMemberSessionUpdated = true;
            this.cdr.markForCheck();
        }
    }
    cancel() {
        this.activeModal.dismiss();
        if (this.cancelAction) {
            this.cancelAction();
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    getFilteredFrequencyOptions() {
        return this.guidedHelpService.getFilteredFrequencyOptions(this.prescriptionInputProps.drugSearchFrequencyList);
    }
}
PrescriptionModalComponent.ɵfac = function PrescriptionModalComponent_Factory(t) { return new (t || PrescriptionModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(GuidedHelpModalStyleService)); };
PrescriptionModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PrescriptionModalComponent, selectors: [["vnext-prescription-modal"]], decls: 4, vars: 62, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "modal-body"], [3, "frequencyList", "contentSectionText", "dosageHeader", "quantityAndFrequencyHeader", "packageHeader", "addButtonText", "cancelButtonText", "backButtonText", "quantityMaxLimit", "medicineCabinetLimit", "cabinetLimitErrorMessage", "quantityErrorMessage", "placeholder", "drugSearchText", "drugsImage", "inCabinetErrorMessage", "medCabinetHeader", "genericOptionIcon", "showGenericOption", "genericOptionQuestion", "genericOptionInfo", "genericOptions", "checkDrugCoverageButtonText", "genericOptionDefaultSelection", "showCosts", "drugSearchIntroText", "drugSearchPageHeaderText", "errorKeywordText", "drugSearchFrequencyListBoxLabel", "prescriptionsText", "isBlueButtonEnabled", "blueButtonStartAddingDrugText", "orText", "blueButtonConnectToMyMedicareText", "blueButtonMyMedicareButtonText", "emailLabelText", "emailRequiredErrorText", "emailInvalidErrorText", "sendEmailButtonText", "blueButtonModalHeaderText", "blueButtonModalContent", "blueButtonSuccessText", "blueButtonDownloadText", "blueButtonSuccessMessage", "blueButtonEmailSendText", "blueButtonIssueLoadingText", "blueButtonBeneficiaryDeniedText", "blueButtonErrorLoadingText", "blueButtonBeneficiaryEmailDetails", "blueButtonImportLatestPrescriptionButtonText", "blueButtonImportLatestPrescriptionErrorText", "blueButtonAccessDeniedText", "blueButtonClaimDataLoadingErrorText", "isMemberSessionUpdated", "editDrugText", "isUseCMSDrugFlagEnabled", "modalView2HeaderText", "modalView2IntroText", "drugSearchInputLabelText"], [3, "cancelButtonText", "primaryButtonEnabled", "cancelButtonAction"]], template: function PrescriptionModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function PrescriptionModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.cancel(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "vnext-drug-search-modal", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "vnext-widget-modal-footer", 3);
        i0.ɵɵlistener("cancelButtonAction", function PrescriptionModalComponent_Template_vnext_widget_modal_footer_cancelButtonAction_3_listener() { return ctx.cancel(); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("frequencyList", ctx.drugSearchFrequencyList)("contentSectionText", ctx.prescriptionInputProps.contentSectionText)("dosageHeader", ctx.prescriptionInputProps.dosageHeader)("quantityAndFrequencyHeader", ctx.prescriptionInputProps.quantityAndFrequencyHeader)("packageHeader", ctx.prescriptionInputProps.packageHeader)("addButtonText", ctx.prescriptionInputProps.addButtonText)("cancelButtonText", ctx.prescriptionInputProps.cancelButtonText)("backButtonText", ctx.prescriptionInputProps.backButtonText)("quantityMaxLimit", ctx.prescriptionInputProps.quantityMaxLimit)("medicineCabinetLimit", ctx.prescriptionInputProps.medicineCabinetLimit)("cabinetLimitErrorMessage", ctx.prescriptionInputProps.cabinetLimitErrorMessage)("quantityErrorMessage", ctx.prescriptionInputProps.quantityErrorMessage)("placeholder", ctx.prescriptionInputProps.placeholder)("drugSearchText", ctx.prescriptionInputProps.drugSearchText)("drugsImage", ctx.prescriptionInputProps.drugsImage)("inCabinetErrorMessage", ctx.prescriptionInputProps.inCabinetErrorMessage)("medCabinetHeader", ctx.prescriptionInputProps.medCabinetHeader)("genericOptionIcon", ctx.prescriptionInputProps.genericOptionIcon)("showGenericOption", ctx.prescriptionInputProps.showGenericOption)("genericOptionQuestion", ctx.prescriptionInputProps.genericOptionQuestion)("genericOptionInfo", ctx.prescriptionInputProps.genericOptionInfo)("genericOptions", ctx.prescriptionInputProps.genericOptions)("checkDrugCoverageButtonText", ctx.prescriptionInputProps.checkDrugCoverageButtonText)("genericOptionDefaultSelection", ctx.prescriptionInputProps.genericOptionDefaultSelection)("showCosts", ctx.prescriptionInputProps.showCosts)("drugSearchIntroText", ctx.prescriptionInputProps.drugSearchIntroText)("drugSearchPageHeaderText", ctx.prescriptionInputProps.drugSearchPageHeaderText)("errorKeywordText", ctx.prescriptionInputProps.errorKeywordText)("drugSearchFrequencyListBoxLabel", ctx.prescriptionInputProps.drugSearchFrequencyListBoxLabel)("prescriptionsText", ctx.prescriptionInputProps.prescriptionsText)("isBlueButtonEnabled", ctx.prescriptionInputProps.isBlueButtonEnabled)("blueButtonStartAddingDrugText", ctx.prescriptionInputProps.blueButtonStartAddingDrugText)("orText", ctx.prescriptionInputProps.orText)("blueButtonConnectToMyMedicareText", ctx.prescriptionInputProps.blueButtonConnectToMyMedicareText)("blueButtonMyMedicareButtonText", ctx.prescriptionInputProps.blueButtonMyMedicareButtonText)("emailLabelText", ctx.prescriptionInputProps.emailLabelText)("emailRequiredErrorText", ctx.prescriptionInputProps.emailRequiredErrorText)("emailInvalidErrorText", ctx.prescriptionInputProps.emailInvalidErrorText)("sendEmailButtonText", ctx.prescriptionInputProps.sendEmailButtonText)("blueButtonModalHeaderText", ctx.prescriptionInputProps.blueButtonModalHeaderText)("blueButtonModalContent", ctx.prescriptionInputProps.blueButtonModalContent)("blueButtonSuccessText", ctx.prescriptionInputProps.blueButtonSuccessText)("blueButtonDownloadText", ctx.prescriptionInputProps.blueButtonDownloadText)("blueButtonSuccessMessage", ctx.prescriptionInputProps.blueButtonSuccessMessage)("blueButtonEmailSendText", ctx.prescriptionInputProps.blueButtonEmailSendText)("blueButtonIssueLoadingText", ctx.prescriptionInputProps.blueButtonIssueLoadingText)("blueButtonBeneficiaryDeniedText", ctx.prescriptionInputProps.blueButtonBeneficiaryDeniedText)("blueButtonErrorLoadingText", ctx.prescriptionInputProps.blueButtonErrorLoadingText)("blueButtonBeneficiaryEmailDetails", ctx.prescriptionInputProps.blueButtonBeneficiaryEmailDetails)("blueButtonImportLatestPrescriptionButtonText", ctx.prescriptionInputProps.blueButtonImportLatestPrescriptionButtonText)("blueButtonImportLatestPrescriptionErrorText", ctx.prescriptionInputProps.blueButtonImportLatestPrescriptionErrorText)("blueButtonAccessDeniedText", ctx.prescriptionInputProps.blueButtonAccessDeniedText)("blueButtonClaimDataLoadingErrorText", ctx.prescriptionInputProps.blueButtonClaimDataLoadingErrorText)("isMemberSessionUpdated", ctx.isMemberSessionUpdated)("editDrugText", ctx.prescriptionInputProps.editDrugText)("isUseCMSDrugFlagEnabled", ctx.prescriptionInputProps.isUseCMSDrugFlagEnabled)("modalView2HeaderText", ctx.prescriptionInputProps.modalView2HeaderText)("modalView2IntroText", ctx.prescriptionInputProps.modalView2IntroText)("drugSearchInputLabelText", ctx.prescriptionInputProps.drugSearchInputLabelText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("cancelButtonText", ctx.cancelButton)("primaryButtonEnabled", false);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PrescriptionModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-prescription-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"cancel()\"></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body\">\r\n  <vnext-drug-search-modal\r\n    [frequencyList]=\"drugSearchFrequencyList\"\r\n    [contentSectionText]=\"prescriptionInputProps.contentSectionText\"\r\n    [dosageHeader]=\"prescriptionInputProps.dosageHeader\"\r\n    [quantityAndFrequencyHeader]=\"prescriptionInputProps.quantityAndFrequencyHeader\"\r\n    [packageHeader]=\"prescriptionInputProps.packageHeader\"\r\n    [addButtonText]=\"prescriptionInputProps.addButtonText\"\r\n    [cancelButtonText]=\"prescriptionInputProps.cancelButtonText\"\r\n    [backButtonText]=\"prescriptionInputProps.backButtonText\"\r\n    [quantityMaxLimit]=\"prescriptionInputProps.quantityMaxLimit\"\r\n    [medicineCabinetLimit]=\"prescriptionInputProps.medicineCabinetLimit\"\r\n    [cabinetLimitErrorMessage]=\"prescriptionInputProps.cabinetLimitErrorMessage\"\r\n    [quantityErrorMessage]=\"prescriptionInputProps.quantityErrorMessage\"\r\n    [placeholder]=\"prescriptionInputProps.placeholder\"\r\n    [drugSearchText]=\"prescriptionInputProps.drugSearchText\"\r\n    [drugsImage]=\"prescriptionInputProps.drugsImage\"\r\n    [inCabinetErrorMessage]=\"prescriptionInputProps.inCabinetErrorMessage\"\r\n    [medCabinetHeader]=\"prescriptionInputProps.medCabinetHeader\"\r\n    [genericOptionIcon]=\"prescriptionInputProps.genericOptionIcon\"\r\n    [showGenericOption]=\"prescriptionInputProps.showGenericOption\"\r\n    [genericOptionQuestion]=\"prescriptionInputProps.genericOptionQuestion\"\r\n    [genericOptionInfo]=\"prescriptionInputProps.genericOptionInfo\"\r\n    [genericOptions]=\"prescriptionInputProps.genericOptions\"\r\n    [checkDrugCoverageButtonText]=\"prescriptionInputProps.checkDrugCoverageButtonText\"\r\n    [genericOptionDefaultSelection]=\"prescriptionInputProps.genericOptionDefaultSelection\"\r\n    [showCosts]=\"prescriptionInputProps.showCosts\"\r\n    [drugSearchIntroText]=\"prescriptionInputProps.drugSearchIntroText\"\r\n    [drugSearchPageHeaderText]=\"prescriptionInputProps.drugSearchPageHeaderText\"\r\n    [errorKeywordText]=\"prescriptionInputProps.errorKeywordText\"\r\n    [drugSearchFrequencyListBoxLabel]=\"prescriptionInputProps.drugSearchFrequencyListBoxLabel\"\r\n    [prescriptionsText]=\"prescriptionInputProps.prescriptionsText\"\r\n    [isBlueButtonEnabled]=\"prescriptionInputProps.isBlueButtonEnabled\"\r\n    [blueButtonStartAddingDrugText]=\"prescriptionInputProps.blueButtonStartAddingDrugText\"\r\n    [orText]=\"prescriptionInputProps.orText\"\r\n    [blueButtonConnectToMyMedicareText]=\"prescriptionInputProps.blueButtonConnectToMyMedicareText\"\r\n    [blueButtonMyMedicareButtonText]=\"prescriptionInputProps.blueButtonMyMedicareButtonText\"\r\n    [emailLabelText]=\"prescriptionInputProps.emailLabelText\"\r\n    [emailRequiredErrorText]=\"prescriptionInputProps.emailRequiredErrorText\"\r\n    [emailInvalidErrorText]=\"prescriptionInputProps.emailInvalidErrorText\"\r\n    [sendEmailButtonText]=\"prescriptionInputProps.sendEmailButtonText\"\r\n    [blueButtonModalHeaderText]=\"prescriptionInputProps.blueButtonModalHeaderText\"\r\n    [blueButtonModalContent]=\"prescriptionInputProps.blueButtonModalContent\"\r\n    [blueButtonSuccessText]=\"prescriptionInputProps.blueButtonSuccessText\"\r\n    [blueButtonDownloadText]=\"prescriptionInputProps.blueButtonDownloadText\"\r\n    [blueButtonSuccessMessage]=\"prescriptionInputProps.blueButtonSuccessMessage\"\r\n    [blueButtonEmailSendText]=\"prescriptionInputProps.blueButtonEmailSendText\"\r\n    [blueButtonIssueLoadingText]=\"prescriptionInputProps.blueButtonIssueLoadingText\"\r\n    [blueButtonBeneficiaryDeniedText]=\"prescriptionInputProps.blueButtonBeneficiaryDeniedText\"\r\n    [blueButtonErrorLoadingText]=\"prescriptionInputProps.blueButtonErrorLoadingText\"\r\n    [blueButtonBeneficiaryEmailDetails]=\"prescriptionInputProps.blueButtonBeneficiaryEmailDetails\"\r\n    [blueButtonImportLatestPrescriptionButtonText]=\"prescriptionInputProps.blueButtonImportLatestPrescriptionButtonText\"\r\n    [blueButtonImportLatestPrescriptionErrorText]=\"prescriptionInputProps.blueButtonImportLatestPrescriptionErrorText\"\r\n    [blueButtonAccessDeniedText]=\"prescriptionInputProps.blueButtonAccessDeniedText\"\r\n    [blueButtonClaimDataLoadingErrorText]=\"prescriptionInputProps.blueButtonClaimDataLoadingErrorText\"\r\n    [isMemberSessionUpdated]=\"isMemberSessionUpdated\"\r\n    [editDrugText]=\"prescriptionInputProps.editDrugText\"\r\n    [isUseCMSDrugFlagEnabled]=\"prescriptionInputProps.isUseCMSDrugFlagEnabled\"\r\n    [modalView2HeaderText]=\"prescriptionInputProps.modalView2HeaderText\"\r\n    [modalView2IntroText]=\"prescriptionInputProps.modalView2IntroText\"\r\n    [drugSearchInputLabelText]=\"prescriptionInputProps.drugSearchInputLabelText\"\r\n  ></vnext-drug-search-modal>\r\n</div>\r\n\r\n<vnext-widget-modal-footer\r\n  [cancelButtonText]=\"cancelButton\"\r\n  [primaryButtonEnabled]=\"false\"\r\n  (cancelButtonAction)=\"cancel()\"\r\n></vnext-widget-modal-footer>\r\n" }]
    }], function () { return [{ type: i1$1.NgbActiveModal }, { type: i0.ChangeDetectorRef }, { type: i1.SiteService }, { type: i1.MemberSessionService }, { type: i1.SpinnerService }, { type: i2.Store }, { type: i1.GuidedHelpService }, { type: i1.LocaleService }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: GuidedHelpModalStyleService }]; }, null); })();

function MultipleProviderAddressModalComponent_div_2_ng_container_5_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-widget-single-provider-address-selector", 16);
    i0.ɵɵlistener("selectProvider", function MultipleProviderAddressModalComponent_div_2_ng_container_5_ng_container_9_Template_vnext_widget_single_provider_address_selector_selectProvider_1_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r10.selectProvider($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("providersList", ctx_r7.sameProvidersList)("selectedProvider", ctx_r7.selectedProvider);
} }
function MultipleProviderAddressModalComponent_div_2_ng_container_5_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-widget-multiple-provider-address-selector", 17);
    i0.ɵɵlistener("selectProvider", function MultipleProviderAddressModalComponent_div_2_ng_container_5_ng_template_10_Template_vnext_widget_multiple_provider_address_selector_selectProvider_0_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r12.getProviderCountWithinLimits()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("providersList", ctx_r9.sameProvidersList)("selectedMultipleProviders", ctx_r9.selectedMultipleProviders);
} }
function MultipleProviderAddressModalComponent_div_2_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 12)(4, "p", 13);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "fieldset")(7, "legend", 14);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, MultipleProviderAddressModalComponent_div_2_ng_container_5_ng_container_9_Template, 2, 2, "ng-container", 10);
    i0.ɵɵtemplate(10, MultipleProviderAddressModalComponent_div_2_ng_container_5_ng_template_10_Template, 1, 2, "ng-template", null, 15, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r8 = i0.ɵɵreference(11);
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.providerMultiLocationText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.selectProviderLabelText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.selectProviderLabelText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.providerSingleSelectEnabled)("ngIfElse", _r8);
} }
function MultipleProviderAddressModalComponent_div_2_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 19)(2, "vnext-widget-provider-toggle", 20);
    i0.ɵɵlistener("optionSelected", function MultipleProviderAddressModalComponent_div_2_div_6_Template_vnext_widget_provider_toggle_optionSelected_2_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r14.onPcpToggleSelect($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "div", 21)(4, "vnext-widget-provider-toggle", 20);
    i0.ɵɵlistener("optionSelected", function MultipleProviderAddressModalComponent_div_2_div_6_Template_vnext_widget_provider_toggle_optionSelected_4_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r16 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r16.onNewPatientToggleSelect($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("isToggleEnabled", true)("toggleLabel", ctx_r3.pcpToggleLabel)("isDefaultSelected", (ctx_r3.selectedProvider == null ? null : ctx_r3.selectedProvider.isPrimary) ? ctx_r3.primaryCareProviderToggleValues.YES : ctx_r3.primaryCareProviderToggleValues.NO)("toggleOptions", ctx_r3.pcpToggleOptions);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("isToggleEnabled", ctx_r3.newPatientToggleEnabled && ctx_r3.selectedPcpToggleOption)("toggleLabel", ctx_r3.newPatientToggleLabel)("isDefaultSelected", (ctx_r3.selectedProvider == null ? null : ctx_r3.selectedProvider.isNewPatient) ? ctx_r3.newPatientToggleValues.YES : ctx_r3.newPatientToggleValues.NO)("toggleOptions", ctx_r3.newPatientToggleOptions);
} }
function MultipleProviderAddressModalComponent_div_2_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 22);
    i0.ɵɵlistener("keyup.enter", function MultipleProviderAddressModalComponent_div_2_ng_container_10_Template_button_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.confirm()); })("click", function MultipleProviderAddressModalComponent_div_2_ng_container_10_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r18); const ctx_r19 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r19.confirm()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", ctx_r4.isEditMode ? ctx_r4.updateLinkText : ctx_r4.addLinkText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.isEditMode ? ctx_r4.updateLinkText : ctx_r4.addLinkText, " ");
} }
function MultipleProviderAddressModalComponent_div_2_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23, 24);
    i0.ɵɵlistener("mouseleave", function MultipleProviderAddressModalComponent_div_2_ng_template_11_Template_button_mouseleave_0_listener() { i0.ɵɵrestoreView(_r22); const _r20 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r20.close()); })("click", function MultipleProviderAddressModalComponent_div_2_ng_template_11_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r22); const _r20 = i0.ɵɵreference(1); return i0.ɵɵresetView(_r20.open()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "span", 14);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngbTooltip", ctx_r6.maxCountErrorMessage);
    i0.ɵɵattribute("aria-label", ctx_r6.isEditMode ? ctx_r6.updateLinkText : ctx_r6.addLinkText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.isEditMode ? ctx_r6.updateLinkText : ctx_r6.addLinkText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r6.maxCountErrorMessage);
} }
function MultipleProviderAddressModalComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4)(3, "h2", 5);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, MultipleProviderAddressModalComponent_div_2_ng_container_5_Template, 12, 5, "ng-container", 6);
    i0.ɵɵtemplate(6, MultipleProviderAddressModalComponent_div_2_div_6_Template, 5, 8, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 8)(8, "button", 9);
    i0.ɵɵlistener("click", function MultipleProviderAddressModalComponent_div_2_Template_button_click_8_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r24.cancel()); })("keyup.enter", function MultipleProviderAddressModalComponent_div_2_Template_button_keyup_enter_8_listener() { i0.ɵɵrestoreView(_r25); const ctx_r26 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r26.cancel()); });
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, MultipleProviderAddressModalComponent_div_2_ng_container_10_Template, 3, 2, "ng-container", 10);
    i0.ɵɵtemplate(11, MultipleProviderAddressModalComponent_div_2_ng_template_11_Template, 5, 4, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r5 = i0.ɵɵreference(12);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.sameProvidersList[0].displayName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r1.sameProvidersList == null ? null : ctx_r1.sameProvidersList.length) > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.pcpToggleEnabled);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", ctx_r1.backButtonText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.backButtonText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.providerCountWithinLimits)("ngIfElse", _r5);
} }
class MultipleProviderAddressModalComponent extends MultipleProviderAddressComponent {
    constructor() {
        super(...arguments);
        this.onConfirm = new EventEmitter();
        this.onBack = new EventEmitter();
    }
    confirm() {
        super.confirm();
        this.onConfirm.emit();
    }
    cancel() {
        super.cancel();
        this.onBack.emit();
    }
}
MultipleProviderAddressModalComponent.ɵfac = /*@__PURE__*/ function () { let ɵMultipleProviderAddressModalComponent_BaseFactory; return function MultipleProviderAddressModalComponent_Factory(t) { return (ɵMultipleProviderAddressModalComponent_BaseFactory || (ɵMultipleProviderAddressModalComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MultipleProviderAddressModalComponent)))(t || MultipleProviderAddressModalComponent); }; }();
MultipleProviderAddressModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MultipleProviderAddressModalComponent, selectors: [["vnext-widget-multiple-provider-address-modal"]], inputs: { backButtonText: "backButtonText" }, outputs: { onConfirm: "onConfirm", onBack: "onBack" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 1, consts: [["multiAddressProviderList", ""], ["class", "provider mb-3 provider-border-color", 4, "ngIf"], [1, "provider", "mb-3", "provider-border-color"], [1, "pb-2"], [1, "d-flex", "pb-2"], [1, "Spa_Style_H2", "font-weight-bold", "no-translate-block"], [4, "ngIf"], ["class", "row my-4", 4, "ngIf"], [1, "col-12", "px-0", "mt-4", "footer-content"], ["type", "button", "tabindex", "0", 1, "btn", "Spa_Style_SecondaryButton", 3, "click", "keyup.enter"], [4, "ngIf", "ngIfElse"], ["showProviderLimitMessage", ""], [1, "toggle-container", "vertical"], [1, "Spa_Style_Bold_Weight"], [1, "sr-only"], ["providerMultiSelect", ""], [3, "providersList", "selectedProvider", "selectProvider"], [3, "providersList", "selectedMultipleProviders", "selectProvider"], [1, "row", "my-4"], [1, "col-12", "col-md-6"], [3, "isToggleEnabled", "toggleLabel", "isDefaultSelected", "toggleOptions", "optionSelected"], [1, "col-12", "col-md-6", "mt-2", "mt-md-0"], ["type", "button", "tabindex", "0", 1, "btn", "Spa_Style_PrimaryButton", 3, "keyup.enter", "click"], ["type", "button", "tabindex", "0", "triggers", "manual", "placement", "top", "container", "body", "autoClose", "true", 1, "btn", "Spa_Style_PrimaryButton", 3, "ngbTooltip", "mouseleave", "click"], ["providerLimitTooltip", "ngbTooltip"]], template: function MultipleProviderAddressModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", null, 0);
        i0.ɵɵtemplate(2, MultipleProviderAddressModalComponent_div_2_Template, 13, 7, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.sameProvidersList == null ? null : ctx.sameProvidersList.length) && ctx.pcpToggleEnabled || (ctx.sameProvidersList == null ? null : ctx.sameProvidersList.length) > 1 && !ctx.pcpToggleEnabled);
    } }, dependencies: [i1$2.NgIf, i1$1.NgbTooltip, ProviderToggleComponent, SingleProviderAddressSelectorComponent, MultipleProviderAddressSelectorComponent], styles: [".vertical[_ngcontent-%COMP%]{flex-direction:column;text-align:left}.footer-content[_ngcontent-%COMP%]{display:flex;justify-content:space-between}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultipleProviderAddressModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-multiple-provider-address-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div #multiAddressProviderList>\r\n  <div\r\n    class=\"provider mb-3 provider-border-color\"\r\n    *ngIf=\"(sameProvidersList?.length && pcpToggleEnabled) || (sameProvidersList?.length > 1 && !pcpToggleEnabled)\"\r\n  >\r\n    <div class=\"pb-2\">\r\n      <div class=\"d-flex pb-2\">\r\n        <h2 class=\"Spa_Style_H2 font-weight-bold no-translate-block\">{{ sameProvidersList[0].displayName }}</h2>\r\n      </div>\r\n      <ng-container *ngIf=\"sameProvidersList?.length > 1\">\r\n        <p>{{ providerMultiLocationText }}</p>\r\n        <div class=\"toggle-container vertical\">\r\n          <p class=\"Spa_Style_Bold_Weight\">{{ selectProviderLabelText }}</p>\r\n          <fieldset>\r\n            <legend class=\"sr-only\">{{ selectProviderLabelText }}</legend>\r\n            <ng-container *ngIf=\"providerSingleSelectEnabled; else providerMultiSelect\">\r\n              <vnext-widget-single-provider-address-selector\r\n                [providersList]=\"sameProvidersList\"\r\n                [selectedProvider]=\"selectedProvider\"\r\n                (selectProvider)=\"selectProvider($event)\"\r\n              ></vnext-widget-single-provider-address-selector>\r\n            </ng-container>\r\n            <ng-template #providerMultiSelect>\r\n              <vnext-widget-multiple-provider-address-selector\r\n                [providersList]=\"sameProvidersList\"\r\n                [selectedMultipleProviders]=\"selectedMultipleProviders\"\r\n                (selectProvider)=\"getProviderCountWithinLimits()\"\r\n              >\r\n              </vnext-widget-multiple-provider-address-selector>\r\n            </ng-template>\r\n          </fieldset>\r\n        </div>\r\n      </ng-container>\r\n\r\n      <div class=\"row my-4\" *ngIf=\"pcpToggleEnabled\">\r\n        <div class=\"col-12 col-md-6\">\r\n          <vnext-widget-provider-toggle\r\n            [isToggleEnabled]=\"true\"\r\n            [toggleLabel]=\"pcpToggleLabel\"\r\n            [isDefaultSelected]=\"selectedProvider?.isPrimary ? primaryCareProviderToggleValues.YES : primaryCareProviderToggleValues.NO\"\r\n            [toggleOptions]=\"pcpToggleOptions\"\r\n            (optionSelected)=\"onPcpToggleSelect($event)\"\r\n          >\r\n          </vnext-widget-provider-toggle>\r\n        </div>\r\n        <div class=\"col-12 col-md-6 mt-2 mt-md-0\">\r\n          <vnext-widget-provider-toggle\r\n            [isToggleEnabled]=\"newPatientToggleEnabled && selectedPcpToggleOption\"\r\n            [toggleLabel]=\"newPatientToggleLabel\"\r\n            [isDefaultSelected]=\"selectedProvider?.isNewPatient ? newPatientToggleValues.YES : newPatientToggleValues.NO\"\r\n            [toggleOptions]=\"newPatientToggleOptions\"\r\n            (optionSelected)=\"onNewPatientToggleSelect($event)\"\r\n          >\r\n          </vnext-widget-provider-toggle>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-12 px-0 mt-4 footer-content\">\r\n      <button\r\n        type=\"button\"\r\n        class=\"btn Spa_Style_SecondaryButton\"\r\n        tabindex=\"0\"\r\n        (click)=\"cancel()\"\r\n        (keyup.enter)=\"cancel()\"\r\n        [attr.aria-label]=\"backButtonText\"\r\n      >\r\n        {{ backButtonText }}\r\n      </button>\r\n\r\n      <ng-container *ngIf=\"providerCountWithinLimits; else showProviderLimitMessage\">\r\n        <button\r\n          type=\"button\"\r\n          (keyup.enter)=\"confirm()\"\r\n          (click)=\"confirm()\"\r\n          tabindex=\"0\"\r\n          class=\"btn Spa_Style_PrimaryButton\"\r\n          [attr.aria-label]=\"isEditMode ? updateLinkText : addLinkText\"\r\n        >\r\n          {{ isEditMode ? updateLinkText : addLinkText }}\r\n        </button>\r\n      </ng-container>\r\n\r\n      <ng-template #showProviderLimitMessage>\r\n        <button\r\n          type=\"button\"\r\n          tabindex=\"0\"\r\n          class=\"btn Spa_Style_PrimaryButton\"\r\n          [ngbTooltip]=\"maxCountErrorMessage\"\r\n          triggers=\"manual\"\r\n          placement=\"top\"\r\n          container=\"body\"\r\n          autoClose=\"true\"\r\n          #providerLimitTooltip=\"ngbTooltip\"\r\n          (mouseleave)=\"providerLimitTooltip.close()\"\r\n          (click)=\"providerLimitTooltip.open()\"\r\n          [attr.aria-label]=\"isEditMode ? updateLinkText : addLinkText\"\r\n        >\r\n          {{ isEditMode ? updateLinkText : addLinkText }}\r\n          <span class=\"sr-only\">{{ maxCountErrorMessage }}</span>\r\n        </button>\r\n      </ng-template>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".vertical{flex-direction:column;text-align:left}.footer-content{display:flex;justify-content:space-between}\n"] }]
    }], null, { backButtonText: [{
            type: Input
        }], onConfirm: [{
            type: Output
        }], onBack: [{
            type: Output
        }] }); })();

function SelectedProviderModalComponent_div_0_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.yourProviderText);
} }
function SelectedProviderModalComponent_div_0_div_3_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelement(1, "i", 22);
    i0.ɵɵelementStart(2, "span", 23);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "phone");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const selectedProvider_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(4, 1, selectedProvider_r3.phoneNumber, ctx_r4.countryCode));
} }
function SelectedProviderModalComponent_div_0_div_3_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "titlecase");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const selectedProvider_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, selectedProvider_r3.address2));
} }
function SelectedProviderModalComponent_div_0_div_3_div_22_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 26);
    i0.ɵɵlistener("click", function SelectedProviderModalComponent_div_0_div_3_div_22_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r16); const selectedProvider_r3 = i0.ɵɵnextContext(2).$implicit; const ctx_r14 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r14.editProvider.emit(selectedProvider_r3)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(4);
    i0.ɵɵattribute("aria-label", ctx_r13.editLinkText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.editLinkText, " ");
} }
function SelectedProviderModalComponent_div_0_div_3_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, SelectedProviderModalComponent_div_0_div_3_div_22_button_1_Template, 2, 2, "button", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const selectedProvider_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", selectedProvider_r3 == null ? null : selectedProvider_r3.addresses == null ? null : selectedProvider_r3.addresses.length);
} }
function SelectedProviderModalComponent_div_0_div_3_div_23_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 30);
    i0.ɵɵelement(2, "i", 31);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 32)(5, "i");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const selectedProvider_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("", ctx_r18.iconClass, " provider-primary-icon-size mr-1");
    i0.ɵɵproperty("ngStyle", ctx_r18.backgroundStyleColor);
    i0.ɵɵattribute("aria-label", ctx_r18.primaryCareProviderText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r18.primaryCareProviderText, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate((selectedProvider_r3 == null ? null : selectedProvider_r3.isNewPatient) ? ctx_r18.newPatientText : ctx_r18.existingPatientText);
} }
function SelectedProviderModalComponent_div_0_div_3_div_23_ng_template_2_vnext_link_0_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 34);
    i0.ɵɵlistener("click", function SelectedProviderModalComponent_div_0_div_3_div_23_ng_template_2_vnext_link_0_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r25); const selectedProvider_r3 = i0.ɵɵnextContext(3).$implicit; const ctx_r23 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r23.setAsPrimaryCareProvider.emit(selectedProvider_r3)); })("keyup.Enter", function SelectedProviderModalComponent_div_0_div_3_div_23_ng_template_2_vnext_link_0_Template_vnext_link_keyup_Enter_0_listener() { i0.ɵɵrestoreView(_r25); const selectedProvider_r3 = i0.ɵɵnextContext(3).$implicit; const ctx_r26 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r26.setAsPrimaryCareProvider.emit(selectedProvider_r3)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("title", ctx_r22.setPrimaryCareProviderText)("alwaysUnderlined", true)("makeInlineBlock", true)("isLinkButton", true);
} }
function SelectedProviderModalComponent_div_0_div_3_div_23_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SelectedProviderModalComponent_div_0_div_3_div_23_ng_template_2_vnext_link_0_Template, 1, 4, "vnext-link", 33);
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngIf", !ctx_r20.selectedProviderOptionsEnabled);
} }
function SelectedProviderModalComponent_div_0_div_3_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtemplate(1, SelectedProviderModalComponent_div_0_div_3_div_23_ng_container_1_Template, 7, 7, "ng-container", 28);
    i0.ɵɵtemplate(2, SelectedProviderModalComponent_div_0_div_3_div_23_ng_template_2_Template, 1, 1, "ng-template", null, 29, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r19 = i0.ɵɵreference(3);
    const selectedProvider_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r7.showEditLinkEnabled && (ctx_r7.providerSingleSelectEnabled || ctx_r7.singleProviderInListEnabled) ? "col-md-3" : "col-md-4");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", selectedProvider_r3.isPrimary)("ngIfElse", _r19);
} }
function SelectedProviderModalComponent_div_0_div_3_div_24_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35)(1, "div", 36)(2, "button", 37);
    i0.ɵɵlistener("click", function SelectedProviderModalComponent_div_0_div_3_div_24_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r31); const selectedProvider_r3 = i0.ɵɵnextContext().$implicit; const ctx_r29 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r29.editProvider.emit(selectedProvider_r3)); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "i", 38);
    i0.ɵɵlistener("keyup.Space", function SelectedProviderModalComponent_div_0_div_3_div_24_Template_i_keyup_Space_4_listener() { i0.ɵɵrestoreView(_r31); const selectedProvider_r3 = i0.ɵɵnextContext().$implicit; const ctx_r32 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r32.removeProvider.emit(selectedProvider_r3)); })("click", function SelectedProviderModalComponent_div_0_div_3_div_24_Template_i_click_4_listener() { i0.ɵɵrestoreView(_r31); const selectedProvider_r3 = i0.ɵɵnextContext().$implicit; const ctx_r34 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r34.removeProvider.emit(selectedProvider_r3)); })("keyup.enter", function SelectedProviderModalComponent_div_0_div_3_div_24_Template_i_keyup_enter_4_listener() { i0.ɵɵrestoreView(_r31); const selectedProvider_r3 = i0.ɵɵnextContext().$implicit; const ctx_r36 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r36.removeProvider.emit(selectedProvider_r3)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", ctx_r8.editLinkText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.editLinkText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r8.removeText);
    i0.ɵɵattribute("aria-label", ctx_r8.removeText);
} }
function SelectedProviderModalComponent_div_0_div_3_ng_template_25_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 39)(1, "div", 40);
    i0.ɵɵlistener("click", function SelectedProviderModalComponent_div_0_div_3_ng_template_25_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r40); const selectedProvider_r3 = i0.ɵɵnextContext().$implicit; const ctx_r38 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r38.removeProvider.emit(selectedProvider_r3)); })("keyup.enter", function SelectedProviderModalComponent_div_0_div_3_ng_template_25_Template_div_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r40); const selectedProvider_r3 = i0.ɵɵnextContext().$implicit; const ctx_r41 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r41.removeProvider.emit(selectedProvider_r3)); });
    i0.ɵɵelementStart(2, "span", 41);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "i", 42);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", ctx_r10.removeProviderText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r10.removeProviderText);
} }
function SelectedProviderModalComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "div", 7)(3, "div", 8)(4, "div", 9)(5, "div", 7)(6, "div", 10)(7, "h3", 11);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 12)(11, "i");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(13, SelectedProviderModalComponent_div_0_div_3_div_13_Template, 5, 4, "div", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 14)(15, "div", 15);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, SelectedProviderModalComponent_div_0_div_3_div_18_Template, 3, 3, "div", 16);
    i0.ɵɵelementStart(19, "div", 15);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "titlecase");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(22, SelectedProviderModalComponent_div_0_div_3_div_22_Template, 2, 1, "div", 17);
    i0.ɵɵtemplate(23, SelectedProviderModalComponent_div_0_div_3_div_23_Template, 4, 3, "div", 18);
    i0.ɵɵtemplate(24, SelectedProviderModalComponent_div_0_div_3_div_24_Template, 5, 4, "div", 19);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(25, SelectedProviderModalComponent_div_0_div_3_ng_template_25_Template, 5, 2, "ng-template", null, 20, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const selectedProvider_r3 = ctx.$implicit;
    const _r9 = i0.ɵɵreference(26);
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r2.selectedProviderOptionsEnabled ? "col-12" : "col-10 col-md-11");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 13, selectedProvider_r3.displayName));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(selectedProvider_r3.specialtyDisplayName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.countryCode && selectedProvider_r3.phoneNumber);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 15, selectedProvider_r3.address1));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", selectedProvider_r3.address2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3(" ", i0.ɵɵpipeBind1(21, 17, selectedProvider_r3.city), ", ", selectedProvider_r3.state, " ", selectedProvider_r3.zip, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.showEditLinkEnabled && !ctx_r2.selectedProviderOptionsEnabled && (ctx_r2.providerSingleSelectEnabled || ctx_r2.singleProviderInListEnabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", selectedProvider_r3.isIndividual);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.selectedProviderOptionsEnabled)("ngIfElse", _r9);
} }
function SelectedProviderModalComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "h2", 2);
    i0.ɵɵtemplate(2, SelectedProviderModalComponent_div_0_span_2_Template, 2, 1, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SelectedProviderModalComponent_div_0_div_3_Template, 27, 19, "div", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Provider_YourProvider_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.selectedProviders)("ngForTrackBy", ctx_r0.trackByProviderId);
} }
class SelectedProviderModalComponent extends SelectedProviderComponent {
    trackByProviderId(index, provider) {
        return provider.id;
    }
}
SelectedProviderModalComponent.ɵfac = /*@__PURE__*/ function () { let ɵSelectedProviderModalComponent_BaseFactory; return function SelectedProviderModalComponent_Factory(t) { return (ɵSelectedProviderModalComponent_BaseFactory || (ɵSelectedProviderModalComponent_BaseFactory = i0.ɵɵgetInheritedFactory(SelectedProviderModalComponent)))(t || SelectedProviderModalComponent); }; }();
SelectedProviderModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectedProviderModalComponent, selectors: [["vnext-widget-selected-provider-modal"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "mt-3 mt-md-5", 4, "ngIf"], [1, "mt-3", "mt-md-5"], [1, "Spa_Style_H2"], [4, "liveEditProp"], ["class", "mt-1", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "mt-1"], [1, "selected-provider", "px-3", "py-3"], [1, "row"], [3, "ngClass"], [1, "p-0"], [1, "col-6", "col-md-4", "no-translate-block", "order-1", "order-md-1"], [1, "Spa_Style_H4"], [1, "Spa_Style_Note"], ["class", "Spa_Style_Note mb-1", 4, "ngIf"], [1, "col-6", "col-md-3", "pr-0", "pl-4", "no-translate-block", "order-3", "order-md-2"], [1, "Spa_Style_Paragraph"], ["class", "Spa_Style_Paragraph", 4, "ngIf"], ["class", "col-2 pr-0 pl-4", 4, "ngIf"], ["class", "col-6 pr-0 pt-2 pt-md-0 order-2 order-md-3", 3, "ngClass", 4, "ngIf"], ["class", "col-6 col-md-2 order-4 order-md-4", 4, "ngIf", "ngIfElse"], ["defaultRemoveButton", ""], [1, "Spa_Style_Note", "mb-1"], [1, "accent1-static", "fas", "fa-phone"], [1, "pl-1"], [1, "col-2", "pr-0", "pl-4"], ["class", "Spa_Style_Link action-button", "tabindex", "0", 3, "click", 4, "ngIf"], ["tabindex", "0", 1, "Spa_Style_Link", "action-button", 3, "click"], [1, "col-6", "pr-0", "pt-2", "pt-md-0", "order-2", "order-md-3", 3, "ngClass"], [4, "ngIf", "ngIfElse"], ["showSetPcpLink", ""], [1, "Spa_Style_Paragraph", "pt-2"], ["role", "img", 3, "ngStyle"], [1, "Spa_Style_Note", "pt-2"], [3, "title", "alwaysUnderlined", "makeInlineBlock", "isLinkButton", "click", "keyup.Enter", 4, "ngIf"], [3, "title", "alwaysUnderlined", "makeInlineBlock", "isLinkButton", "click", "keyup.Enter"], [1, "col-6", "col-md-2", "order-4", "order-md-4"], [1, "float-right"], ["tabindex", "0", 1, "Spa_Style_Link", "action-button", "pr-2", 3, "click"], ["role", "button", "tabindex", "0", 1, "fas", "fa-times", "ml-3", "can-click", 3, "title", "keyup.Space", "click", "keyup.enter"], [1, "col-2", "col-md-1"], ["tabindex", "0", "role", "button", 1, "provider-tile-remove", 3, "click", "keyup.enter"], [1, "sr-only"], [1, "fas", "fa-times"]], template: function SelectedProviderModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SelectedProviderModalComponent_div_0_Template, 4, 3, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.selectedProviders && ctx.selectedProviders.length);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgStyle, LinkComponent, LiveEditPropDirective, IconAriaAttributesDirective, i1$2.TitleCasePipe, PhonePipe], styles: [".provider-tile-remove[_ngcontent-%COMP%]{font-size:var(--Spa_Style_Small_Font);float:right;display:flex;align-items:center;cursor:pointer;width:17px;height:17px;padding:3px}.provider-tile-remove[_ngcontent-%COMP%]:focus{border-radius:12px}.provider-primary-icon-size[_ngcontent-%COMP%]{font-size:var(--Spa_Style_Regular_Font)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectedProviderModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-selected-provider-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"mt-3 mt-md-5\" *ngIf=\"selectedProviders && selectedProviders.length\">\r\n  <h2 class=\"Spa_Style_H2\">\r\n    <span *liveEditProp=\"'Spa_Provider_YourProvider_Text'\">{{ yourProviderText }}</span>\r\n  </h2>\r\n  <div class=\"mt-1\" *ngFor=\"let selectedProvider of selectedProviders; trackBy: trackByProviderId\">\r\n    <div class=\"selected-provider px-3 py-3\">\r\n      <div class=\"row\">\r\n        <div [ngClass]=\"selectedProviderOptionsEnabled ? 'col-12' : 'col-10 col-md-11'\">\r\n          <div class=\"p-0\">\r\n            <div class=\"row\">\r\n              <div class=\"col-6 col-md-4 no-translate-block order-1 order-md-1\">\r\n                <h3 class=\"Spa_Style_H4\">{{ selectedProvider.displayName | titlecase }}</h3>\r\n                <div class=\"Spa_Style_Note\">\r\n                  <i>{{ selectedProvider.specialtyDisplayName }}</i>\r\n                </div>\r\n                <div class=\"Spa_Style_Note mb-1\" *ngIf=\"countryCode && selectedProvider.phoneNumber\">\r\n                  <i class=\"accent1-static fas fa-phone\"></i\r\n                  ><span class=\"pl-1\">{{ selectedProvider.phoneNumber | phone : countryCode }}</span>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-6 col-md-3 pr-0 pl-4 no-translate-block order-3 order-md-2\">\r\n                <div class=\"Spa_Style_Paragraph\">{{ selectedProvider.address1 | titlecase }}</div>\r\n                <div *ngIf=\"selectedProvider.address2\" class=\"Spa_Style_Paragraph\">{{ selectedProvider.address2 | titlecase }}</div>\r\n                <div class=\"Spa_Style_Paragraph\">\r\n                  {{ selectedProvider.city | titlecase }}, {{ selectedProvider.state }} {{ selectedProvider.zip }}\r\n                </div>\r\n              </div>\r\n              <div\r\n                class=\"col-2 pr-0 pl-4\"\r\n                *ngIf=\"\r\n                  showEditLinkEnabled && !selectedProviderOptionsEnabled && (providerSingleSelectEnabled || singleProviderInListEnabled)\r\n                \"\r\n              >\r\n                <button\r\n                  class=\"Spa_Style_Link action-button\"\r\n                  tabindex=\"0\"\r\n                  (click)=\"editProvider.emit(selectedProvider)\"\r\n                  [attr.aria-label]=\"editLinkText\"\r\n                  *ngIf=\"selectedProvider?.addresses?.length\"\r\n                >\r\n                  {{ editLinkText }}\r\n                </button>\r\n              </div>\r\n              <div\r\n                class=\"col-6 pr-0 pt-2 pt-md-0 order-2 order-md-3\"\r\n                *ngIf=\"selectedProvider.isIndividual\"\r\n                [ngClass]=\"showEditLinkEnabled && (providerSingleSelectEnabled || singleProviderInListEnabled) ? 'col-md-3' : 'col-md-4'\"\r\n              >\r\n                <ng-container *ngIf=\"selectedProvider.isPrimary; else showSetPcpLink\">\r\n                  <div class=\"Spa_Style_Paragraph pt-2\">\r\n                    <i\r\n                      class=\"{{ iconClass }} provider-primary-icon-size mr-1\"\r\n                      role=\"img\"\r\n                      [attr.aria-label]=\"primaryCareProviderText\"\r\n                      [ngStyle]=\"backgroundStyleColor\"\r\n                    ></i\r\n                    >{{ primaryCareProviderText }}\r\n                  </div>\r\n                  <div class=\"Spa_Style_Note pt-2\">\r\n                    <i>{{ selectedProvider?.isNewPatient ? newPatientText : existingPatientText }}</i>\r\n                  </div>\r\n                </ng-container>\r\n                <ng-template #showSetPcpLink>\r\n                  <vnext-link\r\n                    *ngIf=\"!selectedProviderOptionsEnabled\"\r\n                    [title]=\"setPrimaryCareProviderText\"\r\n                    [alwaysUnderlined]=\"true\"\r\n                    [makeInlineBlock]=\"true\"\r\n                    (click)=\"setAsPrimaryCareProvider.emit(selectedProvider)\"\r\n                    (keyup.Enter)=\"setAsPrimaryCareProvider.emit(selectedProvider)\"\r\n                    [isLinkButton]=\"true\"\r\n                  >\r\n                  </vnext-link>\r\n                </ng-template>\r\n              </div>\r\n              <div *ngIf=\"selectedProviderOptionsEnabled; else defaultRemoveButton\" class=\"col-6 col-md-2 order-4 order-md-4\">\r\n                <div class=\"float-right\">\r\n                  <button\r\n                    class=\"Spa_Style_Link action-button pr-2\"\r\n                    tabindex=\"0\"\r\n                    (click)=\"editProvider.emit(selectedProvider)\"\r\n                    [attr.aria-label]=\"editLinkText\"\r\n                  >\r\n                    {{ editLinkText }}\r\n                  </button>\r\n\r\n                  <i\r\n                    class=\"fas fa-times ml-3 can-click\"\r\n                    (keyup.Space)=\"removeProvider.emit(selectedProvider)\"\r\n                    (click)=\"removeProvider.emit(selectedProvider)\"\r\n                    (keyup.enter)=\"removeProvider.emit(selectedProvider)\"\r\n                    [title]=\"removeText\"\r\n                    [attr.aria-label]=\"removeText\"\r\n                    role=\"button\"\r\n                    tabindex=\"0\"\r\n                  ></i>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <ng-template #defaultRemoveButton>\r\n          <div class=\"col-2 col-md-1\">\r\n            <div\r\n              class=\"provider-tile-remove\"\r\n              tabindex=\"0\"\r\n              [attr.aria-label]=\"removeProviderText\"\r\n              role=\"button\"\r\n              (click)=\"removeProvider.emit(selectedProvider)\"\r\n              (keyup.enter)=\"removeProvider.emit(selectedProvider)\"\r\n            >\r\n              <span class=\"sr-only\">{{ removeProviderText }}</span>\r\n              <i class=\"fas fa-times\"></i>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".provider-tile-remove{font-size:var(--Spa_Style_Small_Font);float:right;display:flex;align-items:center;cursor:pointer;width:17px;height:17px;padding:3px}.provider-tile-remove:focus{border-radius:12px}.provider-primary-icon-size{font-size:var(--Spa_Style_Regular_Font)}\n"] }]
    }], null, null); })();

function ProviderSearchModalComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 6);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(6);
    i0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ProviderSearchModalComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 6);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(8);
    i0.ɵɵproperty("ngTemplateOutlet", _r5);
} }
function ProviderSearchModalComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 6);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r7 = i0.ɵɵreference(10);
    i0.ɵɵproperty("ngTemplateOutlet", _r7);
} }
function ProviderSearchModalComponent_ng_template_5_h1_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.modalProviderSearchViewHeadingText, " ");
} }
function ProviderSearchModalComponent_ng_template_5_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 27);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r10.modalProviderSearchViewIntroText, "html"), i0.ɵɵsanitizeHtml);
} }
function ProviderSearchModalComponent_ng_template_5_div_15_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵelement(1, "i", 33);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.providerErrorText, "");
} }
function ProviderSearchModalComponent_ng_template_5_div_15_label_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.providerNameText, " ");
} }
function ProviderSearchModalComponent_ng_template_5_div_15_input_3_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 35);
    i0.ɵɵlistener("keyup.enter", function ProviderSearchModalComponent_ng_template_5_div_15_input_3_Template_input_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r16.validateZip()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("placeholder", ctx_r15.providerNameHintText)("formControl", ctx_r15.providerName);
} }
function ProviderSearchModalComponent_ng_template_5_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtemplate(1, ProviderSearchModalComponent_ng_template_5_div_15_span_1_Template, 3, 1, "span", 29);
    i0.ɵɵtemplate(2, ProviderSearchModalComponent_ng_template_5_div_15_label_2_Template, 2, 1, "label", 30);
    i0.ɵɵtemplate(3, ProviderSearchModalComponent_ng_template_5_div_15_input_3_Template, 1, 2, "input", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.hasMinCharError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_ProviderName_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_ProviderName_HintText");
} }
function ProviderSearchModalComponent_ng_template_5_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-widget-selected-provider-modal", 36);
    i0.ɵɵlistener("removeProvider", function ProviderSearchModalComponent_ng_template_5_div_20_Template_vnext_widget_selected_provider_modal_removeProvider_1_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r18.removeProvider($event)); })("setAsPrimaryCareProvider", function ProviderSearchModalComponent_ng_template_5_div_20_Template_vnext_widget_selected_provider_modal_setAsPrimaryCareProvider_1_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r20 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r20.providerFacade.setAsPrimaryCareProvider($event)); })("editProvider", function ProviderSearchModalComponent_ng_template_5_div_20_Template_vnext_widget_selected_provider_modal_editProvider_1_listener($event) { i0.ɵɵrestoreView(_r19); const ctx_r21 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r21.editProvider($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("selectedProviders", ctx_r12.selectedProviders)("yourProviderText", ctx_r12.yourProviderText)("removeProviderText", ctx_r12.removeProviderText)("setPrimaryCareProviderText", ctx_r12.setPrimaryCareProviderText)("primaryCareProviderText", ctx_r12.primaryCareProviderText)("iconClass", ctx_r12.providerFacade.primaryPinIcon)("backgroundStyleColor", ctx_r12.providerFacade.getPrimaryProviderBackgroundColor())("countryCode", ctx_r12.countryCode)("editLinkText", ctx_r12.editLinkText)("showEditLinkEnabled", ctx_r12.showEditLinkEnabled)("providerSingleSelectEnabled", ctx_r12.providerSingleSelectEnabled)("singleProviderInListEnabled", ctx_r12.singleProviderInListEnabled)("newPatientText", ctx_r12.newPatientText)("existingPatientText", ctx_r12.existingPatientText)("selectedProviderOptionsEnabled", ctx_r12.selectedProviderOptionsEnabled)("removeText", ctx_r12.removeText);
} }
const _c0$_ = function (a0) { return { "flex-1": a0 }; };
function ProviderSearchModalComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8)(2, "div", 9)(3, "div", 10);
    i0.ɵɵtemplate(4, ProviderSearchModalComponent_ng_template_5_h1_4_Template, 2, 1, "h1", 11);
    i0.ɵɵtemplate(5, ProviderSearchModalComponent_ng_template_5_p_5_Template, 2, 4, "p", 12);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(6, "div", 13)(7, "div", 14)(8, "div", 15)(9, "div", 16)(10, "vnext-zip-code-input", 17);
    i0.ɵɵlistener("zip", function ProviderSearchModalComponent_ng_template_5_Template_vnext_zip_code_input_zip_10_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r22.setZipCode($event)); })("keyup.enter", function ProviderSearchModalComponent_ng_template_5_Template_vnext_zip_code_input_keyup_enter_10_listener() { i0.ɵɵrestoreView(_r23); const ctx_r24 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r24.validateZip()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 18)(12, "vnext-widget-general-practice-toggle", 19);
    i0.ɵɵlistener("optionSelected", function ProviderSearchModalComponent_ng_template_5_Template_vnext_widget_general_practice_toggle_optionSelected_12_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r25 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r25.onGeneralPracticeSelect($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "vnext-widget-value-based-provider-toggle", 20);
    i0.ɵɵlistener("optionSelected", function ProviderSearchModalComponent_ng_template_5_Template_vnext_widget_value_based_provider_toggle_optionSelected_13_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r26 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r26.onValueBasedToggleSelect($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 21);
    i0.ɵɵtemplate(15, ProviderSearchModalComponent_ng_template_5_div_15_Template, 4, 3, "div", 22);
    i0.ɵɵelementStart(16, "button", 23);
    i0.ɵɵlistener("click", function ProviderSearchModalComponent_ng_template_5_Template_button_click_16_listener() { i0.ɵɵrestoreView(_r23); const ctx_r27 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r27.validateZip()); });
    i0.ɵɵelementStart(17, "span", 24);
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(19, "i");
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵtemplate(20, ProviderSearchModalComponent_ng_template_5_div_20_Template, 2, 16, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("liveEditProp", "Spa_AddProviders_ModalProviderSearchView_HeadingText");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_AddProviders_ModalProviderSearchView_IntroText");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(31, _c0$_, ctx_r4.searchProviderByNameEnabled));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("customStyles", ctx_r4.zipCodeStyles)("showCounty", false)("retrieveZipCode", ctx_r4.retrieveZipCode)("retrieveFipsCode", ctx_r4.retrieveFipsCode)("errorKeywordText", ctx_r4.errorKeywordText)("zipCodeText", ctx_r4.zipLabel)("zipCodeErrorText", ctx_r4.zipErrorText)("countyLabel", ctx_r4.countyLabel)("showCountyLabel", ctx_r4.showCountyLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("generalPracticeFilterOptionEnabled", ctx_r4.generalPracticeFilterOptionEnabled)("generalPracticeLabel", ctx_r4.generalPracticeLabel)("generalPracticeToolTipText", ctx_r4.generalPracticeToolTipText)("generalPracticeOptions", ctx_r4.generalPracticeOptions)("selectedGeneralPracticeOption", ctx_r4.selectedGeneralPracticeOption);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("valueBasedCareToggleEnabled", ctx_r4.valueBasedCareToggleEnabled)("valueBasedCareToggleLabel", ctx_r4.valueBasedCareToggleLabel)("valueBasedCareToggleToolTipText", ctx_r4.valueBasedCareToggleToolTipText)("valueBasedCareToggleOptions", ctx_r4.valueBasedCareToggleOptions)("selectedValueBasedToggleOption", ctx_r4.selectedValueBasedToggleOption);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.searchProviderByNameEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("ml-1", ctx_r4.searchProviderByNameEnabled);
    i0.ɵɵattribute("aria-label", ctx_r4.providerNameText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.providerNameText);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("fas ", ctx_r4.mapFacade.showSpinner ? "fa-spinner fa-spin" : "fa-search", "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ((ctx_r4.providers == null ? null : ctx_r4.providers.length) || (ctx_r4.selectedProviders == null ? null : ctx_r4.selectedProviders.length)) && !ctx_r4.isHelpfulToolsView);
} }
function ProviderSearchModalComponent_ng_template_7_h1_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r28.modalProviderMapViewHeadingText, " ");
} }
function ProviderSearchModalComponent_ng_template_7_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 27);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r29.modalProviderMapViewIntroText, "html"), i0.ɵɵsanitizeHtml);
} }
function ProviderSearchModalComponent_ng_template_7_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelement(1, "span", 44);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementStart(3, "vnext-link", 45);
    i0.ɵɵlistener("click", function ProviderSearchModalComponent_ng_template_7_div_6_Template_vnext_link_click_3_listener() { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r34.openExternalLink()); })("keydown.enter", function ProviderSearchModalComponent_ng_template_7_div_6_Template_vnext_link_keydown_enter_3_listener() { i0.ɵɵrestoreView(_r35); const ctx_r36 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r36.openExternalLink()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 5, ctx_r30.valueBasedCareAvailableText, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("isLinkButton", true)("title", ctx_r30.valueBasedCareLearnMoreText)("makeInlineBlock", true)("ariaHasPopup", true);
} }
function ProviderSearchModalComponent_ng_template_7_div_7_div_1_ng_container_2_vnext_link_5_Template(rf, ctx) { if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 45);
    i0.ɵɵlistener("click", function ProviderSearchModalComponent_ng_template_7_div_7_div_1_ng_container_2_vnext_link_5_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r46); const providerFilter_r39 = i0.ɵɵnextContext(2).$implicit; const ctx_r44 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r44.onFilterLinkSelection(providerFilter_r39.value)); })("keydown.enter", function ProviderSearchModalComponent_ng_template_7_div_7_div_1_ng_container_2_vnext_link_5_Template_vnext_link_keydown_enter_0_listener($event) { i0.ɵɵrestoreView(_r46); const providerFilter_r39 = i0.ɵɵnextContext(2).$implicit; const ctx_r47 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r47.onFilterLinkSelection(providerFilter_r39.value, $event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const providerFilter_r39 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("isLinkButton", true)("title", providerFilter_r39.link)("makeInlineBlock", true)("ariaHasPopup", true);
} }
function ProviderSearchModalComponent_ng_template_7_div_7_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "input", 50, 51);
    i0.ɵɵlistener("change", function ProviderSearchModalComponent_ng_template_7_div_7_div_1_ng_container_2_Template_input_change_1_listener($event) { i0.ɵɵrestoreView(_r51); const ctx_r50 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r50.onFilterSelected($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 52);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ProviderSearchModalComponent_ng_template_7_div_7_div_1_ng_container_2_vnext_link_5_Template, 1, 4, "vnext-link", 53);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext();
    const providerFilter_r39 = ctx_r52.$implicit;
    const i_r40 = ctx_r52.index;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("value", providerFilter_r39.label);
    i0.ɵɵproperty("id", i_r40 + "providerFilterCheckBox")("checked", providerFilter_r39.initiallyChecked);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", i_r40 + "providerFilterCheckBox");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(providerFilter_r39.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", providerFilter_r39.link);
} }
const _c1$k = function (a0) { return { "Spa_Style_Paragraph ": a0 }; };
function ProviderSearchModalComponent_ng_template_7_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 49);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵtemplate(2, ProviderSearchModalComponent_ng_template_7_div_7_div_1_ng_container_2_Template, 6, 6, "ng-container", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const providerFilter_r39 = ctx.$implicit;
    const ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1$k, i0.ɵɵpipeBind1(1, 2, ctx_r37.providerFacade.isMobile$)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !providerFilter_r39.disabled);
} }
function ProviderSearchModalComponent_ng_template_7_div_7_div_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div")(2, "input", 56);
    i0.ɵɵlistener("change", function ProviderSearchModalComponent_ng_template_7_div_7_div_2_ng_container_3_Template_input_change_2_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r57); const i_r55 = restoredCtx.index; const ctx_r56 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r56.onVbcSelection(i_r55, $event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 52);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const vbc_r54 = ctx.$implicit;
    const i_r55 = ctx.index;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", vbc_r54.name)("checked", vbc_r54.selected)("id", i_r55 + "vbcCheckBox");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", i_r55 + "vbcCheckBox");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(vbc_r54.name);
} }
function ProviderSearchModalComponent_ng_template_7_div_7_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54)(1, "label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ProviderSearchModalComponent_ng_template_7_div_7_div_2_ng_container_3_Template, 5, 5, "ng-container", 55);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r38.vbcNameFilterLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r38.vbcList)("ngForTrackBy", ctx_r38.trackByVbcId);
} }
function ProviderSearchModalComponent_ng_template_7_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵtemplate(1, ProviderSearchModalComponent_ng_template_7_div_7_div_1_Template, 3, 6, "div", 47);
    i0.ɵɵtemplate(2, ProviderSearchModalComponent_ng_template_7_div_7_div_2_Template, 4, 3, "div", 48);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r31.providerFilters)("ngForTrackBy", ctx_r31.trackByIndex);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r31.vbcNameFilterEnabled && (ctx_r31.vbcList == null ? null : ctx_r31.vbcList.length) > 1);
} }
function ProviderSearchModalComponent_ng_template_7_div_9_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r65 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 61)(1, "vnext-widget-provider-list", 62);
    i0.ɵɵlistener("addProvider", function ProviderSearchModalComponent_ng_template_7_div_9_ng_container_2_div_1_Template_vnext_widget_provider_list_addProvider_1_listener($event) { i0.ɵɵrestoreView(_r65); const ctx_r64 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r64.addProvider($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const provider_r62 = ctx.$implicit;
    const i_r63 = ctx.index;
    const ctx_r61 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("alreadySelectedProvider", ctx_r61.providerFacade.selectedProviderIds[provider_r62.id])("isHelpfulToolsView", ctx_r61.isHelpfulToolsView)("provider", provider_r62)("pageSize", ctx_r61.pageSize)("pageIndex", ctx_r61.pageIndex)("selectedProviders", ctx_r61.selectedProviders)("addProviderText", ctx_r61.addProviderText)("providerLocationsText", ctx_r61.providerLocationsText)("providerAddedText", ctx_r61.providerAddedText)("maxCountErrorMessage", ctx_r61.maxCountErrorMessage)("maxCount", ctx_r61.maxCount)("customClass", ctx_r61.providerFacade.getProviderPinClass(provider_r62, false, ctx_r61.isHelpfulToolsView))("alternateViewClass", ctx_r61.providerFacade.noticeAlternateView(provider_r62))("alternateNumberIndicatorClass", ctx_r61.providerFacade.noticeAlternateProviderIndicator(provider_r62))("isProviderAdded", ctx_r61.providerFacade.isProviderAdded(provider_r62.id, provider_r62.addressId, provider_r62.providerGroup, !ctx_r61.providerSingleSelectEnabled))("backgroundStyle", ctx_r61.providerFacade.getPrimaryProviderBackgroundColor(provider_r62, ctx_r61.isHelpfulToolsView))("index", i_r63)("isPrimary", ctx_r61.providerFacade.isPcp(provider_r62))("providerExistsTooltipText", ctx_r61.providerExistsTooltipText)("countryCode", ctx_r61.countryCode)("acceptingNewPatientsIcon", ctx_r61.acceptingNewPatientsIcon)("acceptingNewPatientsText", ctx_r61.acceptingNewPatientsText)("languagesIcon", ctx_r61.languagesIcon)("providerGroup", provider_r62.providerGroup)("providerSingleSelectEnabled", ctx_r61.providerSingleSelectEnabled)("valueBasedCareEnabled", ctx_r61.valueBasedCareEnabled)("valueBasedCareIcon", ctx_r61.valueBasedCareIcon)("valueBasedCareText", ctx_r61.valueBasedCareText)("singleProviderInListEnabled", ctx_r61.singleProviderInListEnabled)("primaryCareProviderText", ctx_r61.primaryCareProviderText);
} }
function ProviderSearchModalComponent_ng_template_7_div_9_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProviderSearchModalComponent_ng_template_7_div_9_ng_container_2_div_1_Template, 2, 30, "div", 60);
    i0.ɵɵpipe(2, "slice");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r58 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(2, 2, ctx_r58.providerList, ctx_r58.startValueOfItemsToBeSliced, ctx_r58.endValueOfItemsToBeSliced))("ngForTrackBy", ctx_r58.trackByProviderId);
} }
function ProviderSearchModalComponent_ng_template_7_div_9_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 63)(2, "h3", 64);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p", 65);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r59 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r59.viewNotFoundHeaderText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r59.viewNotFoundBodyText, " ");
} }
function ProviderSearchModalComponent_ng_template_7_div_9_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r67 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 66)(1, "vnext-widget-map", 67);
    i0.ɵɵlistener("setZoom", function ProviderSearchModalComponent_ng_template_7_div_9_div_4_Template_vnext_widget_map_setZoom_1_listener($event) { i0.ɵɵrestoreView(_r67); const ctx_r66 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r66.setZoom($event)); })("resetToDefaultPageIndex", function ProviderSearchModalComponent_ng_template_7_div_9_div_4_Template_vnext_widget_map_resetToDefaultPageIndex_1_listener() { i0.ɵɵrestoreView(_r67); const ctx_r68 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r68.updateProviders({ pageSize: ctx_r68.itemsPerPage, defaultStartItem: 1 })); })("setMapCenter", function ProviderSearchModalComponent_ng_template_7_div_9_div_4_Template_vnext_widget_map_setMapCenter_1_listener($event) { i0.ɵɵrestoreView(_r67); const ctx_r69 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r69.setMapCenter.emit($event)); })("setMap", function ProviderSearchModalComponent_ng_template_7_div_9_div_4_Template_vnext_widget_map_setMap_1_listener($event) { i0.ɵɵrestoreView(_r67); const ctx_r70 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r70.initializeMap.emit($event)); })("setMapDefaultBounds", function ProviderSearchModalComponent_ng_template_7_div_9_div_4_Template_vnext_widget_map_setMapDefaultBounds_1_listener($event) { i0.ɵɵrestoreView(_r67); const ctx_r71 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r71.setMapDefaultBounds.emit($event)); })("addSelectedItem", function ProviderSearchModalComponent_ng_template_7_div_9_div_4_Template_vnext_widget_map_addSelectedItem_1_listener($event) { i0.ɵɵrestoreView(_r67); const ctx_r72 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r72.addToMapSelectedProvider($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r60 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("zip", ctx_r60.zip)("zoom", ctx_r60.zoom)("minZoom", ctx_r60.minZoom)("maxZoom", ctx_r60.maxZoom)("isHelpfulToolsView", ctx_r60.isHelpfulToolsView)("isProvider", true)("addButtonText", ctx_r60.addProviderText)("addedLabel", ctx_r60.providerAddedText)("markers", ctx_r60.markers)("markerGroups", ctx_r60.markerGroups)("limitErrorMessage", ctx_r60.maxCountErrorMessage)("groupAddedLabel", ctx_r60.providerGroupAddedLabelText)("groupAddText", ctx_r60.providerGroupAddLabelText)("providerExistsTooltipText", ctx_r60.providerExistsTooltipText)("providerSingleSelectEnabled", ctx_r60.providerSingleSelectEnabled)("primaryIconAriaLabelText", ctx_r60.primaryCareProviderText);
} }
const _c2$e = function (a0) { return { "mt-3": a0 }; };
function ProviderSearchModalComponent_ng_template_7_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 57)(1, "div", 58);
    i0.ɵɵtemplate(2, ProviderSearchModalComponent_ng_template_7_div_9_ng_container_2_Template, 3, 6, "ng-container", 25);
    i0.ɵɵtemplate(3, ProviderSearchModalComponent_ng_template_7_div_9_ng_container_3_Template, 6, 2, "ng-container", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ProviderSearchModalComponent_ng_template_7_div_9_div_4_Template, 2, 16, "div", 59);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c2$e, !ctx_r32.providerFiltersEnabled));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r32.providers == null ? null : ctx_r32.providers.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !((ctx_r32.providers == null ? null : ctx_r32.providers.length) > 0) && !ctx_r32.mapFacade.showSpinner);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r32.zip);
} }
function ProviderSearchModalComponent_ng_template_7_div_10_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r75 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 69)(1, "vnext-pagination", 70);
    i0.ɵɵlistener("updatePagination", function ProviderSearchModalComponent_ng_template_7_div_10_div_1_Template_vnext_pagination_updatePagination_1_listener($event) { i0.ɵɵrestoreView(_r75); const ctx_r74 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r74.updateProviders($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r73 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("pagination", ctx_r73.providerList)("defaultStartItem", ctx_r73.defaultStartItem)("itemsPerPage", ctx_r73.itemsPerPage)("paginationText", ctx_r73.paginationText);
} }
function ProviderSearchModalComponent_ng_template_7_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵtemplate(1, ProviderSearchModalComponent_ng_template_7_div_10_div_1_Template, 2, 4, "div", 68);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r33.providerPaginationEnabled && ctx_r33.itemsPerPage < (ctx_r33.providerList == null ? null : ctx_r33.providerList.length));
} }
function ProviderSearchModalComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r77 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 8)(2, "div", 9)(3, "div", 10);
    i0.ɵɵtemplate(4, ProviderSearchModalComponent_ng_template_7_h1_4_Template, 2, 1, "h1", 11);
    i0.ɵɵtemplate(5, ProviderSearchModalComponent_ng_template_7_p_5_Template, 2, 4, "p", 12);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(6, ProviderSearchModalComponent_ng_template_7_div_6_Template, 4, 8, "div", 37);
    i0.ɵɵtemplate(7, ProviderSearchModalComponent_ng_template_7_div_7_Template, 3, 3, "div", 38);
    i0.ɵɵelementStart(8, "div", 39);
    i0.ɵɵtemplate(9, ProviderSearchModalComponent_ng_template_7_div_9_Template, 5, 6, "div", 40);
    i0.ɵɵtemplate(10, ProviderSearchModalComponent_ng_template_7_div_10_Template, 2, 1, "div", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 41)(12, "button", 42);
    i0.ɵɵlistener("click", function ProviderSearchModalComponent_ng_template_7_Template_button_click_12_listener() { i0.ɵɵrestoreView(_r77); const ctx_r76 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r76.navigate(ctx_r76.providerModalViewName.SEARCH)); })("keyup.enter", function ProviderSearchModalComponent_ng_template_7_Template_button_keyup_enter_12_listener() { i0.ɵɵrestoreView(_r77); const ctx_r78 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r78.navigate(ctx_r78.providerModalViewName.SEARCH)); });
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("liveEditProp", "Spa_AddProviders_ModalProviderMapView_HeadingText");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_AddProviders_ModalProviderMapView_IntroText");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.isValueBasedCareLearnMoreLink2Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.providerFiltersEnabled && ctx_r6.mapFacade.showMap);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r6.mapFacade.showMap);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.mapFacade.showMap);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", ctx_r6.backButtonText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.backButtonText, " ");
} }
function ProviderSearchModalComponent_ng_template_9_h1_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r79 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r79.modalProviderLocationViewHeadingText, " ");
} }
function ProviderSearchModalComponent_ng_template_9_p_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 27);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r80 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r80.modalProviderLocationViewIntroText, "html"), i0.ɵɵsanitizeHtml);
} }
function ProviderSearchModalComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    const _r82 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 8)(2, "div", 9)(3, "div", 10);
    i0.ɵɵtemplate(4, ProviderSearchModalComponent_ng_template_9_h1_4_Template, 2, 1, "h1", 11);
    i0.ɵɵtemplate(5, ProviderSearchModalComponent_ng_template_9_p_5_Template, 2, 4, "p", 12);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(6, "vnext-widget-multiple-provider-address-modal", 71);
    i0.ɵɵlistener("addProviders", function ProviderSearchModalComponent_ng_template_9_Template_vnext_widget_multiple_provider_address_modal_addProviders_6_listener($event) { i0.ɵɵrestoreView(_r82); const ctx_r81 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r81.providersAddToList($event)); })("addProvider", function ProviderSearchModalComponent_ng_template_9_Template_vnext_widget_multiple_provider_address_modal_addProvider_6_listener($event) { i0.ɵɵrestoreView(_r82); const ctx_r83 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r83.addToSelectedProvider($event)); })("setAsPrimaryCareProvider", function ProviderSearchModalComponent_ng_template_9_Template_vnext_widget_multiple_provider_address_modal_setAsPrimaryCareProvider_6_listener($event) { i0.ɵɵrestoreView(_r82); const ctx_r84 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r84.providerFacade.setAsPrimaryCareProvider($event)); })("onBack", function ProviderSearchModalComponent_ng_template_9_Template_vnext_widget_multiple_provider_address_modal_onBack_6_listener() { i0.ɵɵrestoreView(_r82); const ctx_r85 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r85.onResultViewBack()); })("onConfirm", function ProviderSearchModalComponent_ng_template_9_Template_vnext_widget_multiple_provider_address_modal_onConfirm_6_listener() { i0.ɵɵrestoreView(_r82); const ctx_r86 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r86.onConfirm()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("liveEditProp", "Spa_AddProviders_ModalProviderLocationView_HeadingText");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_AddProviders_ModalProviderLocationView_IntroText");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("selectedProviders", ctx_r8.selectedProviders)("providers", ctx_r8.providers)("yourProviderText", ctx_r8.yourProviderText)("removeProviderText", ctx_r8.removeProviderText)("setPrimaryCareProviderText", ctx_r8.setPrimaryCareProviderText)("primaryCareProviderText", ctx_r8.primaryCareProviderText)("chosenProvider", ctx_r8.selectedProvider)("providerSingleSelectEnabled", ctx_r8.providerSingleSelectEnabled)("addLinkText", ctx_r8.addLinkText)("cancelProvidersLabel", ctx_r8.cancelProvidersLabel)("providerMultiLocationText", ctx_r8.providerMultiLocationText)("selectProviderLabelText", ctx_r8.selectProviderLabelText)("maxCount", ctx_r8.maxCount)("maxCountErrorMessage", ctx_r8.maxCountErrorMessage)("singleProviderInListEnabled", ctx_r8.singleProviderInListEnabled)("updateLinkText", ctx_r8.updateLinkText)("newPatientToggleEnabled", ctx_r8.newPatientToggleEnabled)("newPatientToggleLabel", ctx_r8.newPatientToggleLabel)("newPatientToggleOptions", ctx_r8.newPatientToggleOptions)("pcpToggleEnabled", ctx_r8.pcpToggleEnabled)("pcpToggleLabel", ctx_r8.pcpToggleLabel)("pcpToggleOptions", ctx_r8.pcpToggleOptions)("backButtonText", ctx_r8.backButtonText);
} }
class ProviderSearchModalComponent extends ProviderSearchComponent {
    constructor(cdr, configurableWidgetService, widgetValidationService, mapFacade, providerFacade, helpfulToolsContext, helpfulToolsService, spinnerService, mapContextService, formValidationService, providerContext, filterService, analyticsService, providerService, navigationService, stringFormatUtilityService, guidedHelpService) {
        super(cdr, configurableWidgetService, widgetValidationService, mapFacade, providerFacade, helpfulToolsContext, helpfulToolsService, spinnerService, mapContextService, formValidationService, providerContext, filterService, analyticsService, providerService, navigationService, stringFormatUtilityService);
        this.cdr = cdr;
        this.configurableWidgetService = configurableWidgetService;
        this.widgetValidationService = widgetValidationService;
        this.mapFacade = mapFacade;
        this.providerFacade = providerFacade;
        this.helpfulToolsContext = helpfulToolsContext;
        this.helpfulToolsService = helpfulToolsService;
        this.spinnerService = spinnerService;
        this.mapContextService = mapContextService;
        this.formValidationService = formValidationService;
        this.providerContext = providerContext;
        this.filterService = filterService;
        this.analyticsService = analyticsService;
        this.providerService = providerService;
        this.navigationService = navigationService;
        this.stringFormatUtilityService = stringFormatUtilityService;
        this.guidedHelpService = guidedHelpService;
        this.providerModalViewName = ProviderModalViewName;
        this.sameProvidersList = [];
    }
    addProvider(selectedProvider) {
        this.selectedProvider = selectedProvider;
        this.providerFacade.currentModalViewName = ProviderModalViewName.RESULT;
        this.cdr.markForCheck();
    }
    navigate(modalView) {
        this.providerFacade.currentModalViewName = modalView;
        if (this.providerFacade.currentModalViewName === ProviderModalViewName.SEARCH) {
            this.providerFacade.setProviderSearchLoaded(false);
        }
    }
    onProviderConfirm() {
        this.providerFacade.setProviderSearchLoaded(false);
        this.navigate(ProviderModalViewName.SEARCH);
    }
    validateZip() {
        super.validateZip();
        const errors = this.widgetValidationService.validate();
        if (errors.length === 0) {
            this.providerFacade.currentModalViewName = ProviderModalViewName.MAP;
        }
    }
    editProvider(selectedProvider) {
        super.editProvider(selectedProvider);
        this.providerFacade.currentModalViewName = ProviderModalViewName.RESULT;
    }
    onResultViewBack() {
        if (this.mapFacade.showMap) {
            this.providerFacade.currentModalViewName = ProviderModalViewName.MAP;
        }
        else {
            this.providerFacade.currentModalViewName = ProviderModalViewName.SEARCH;
        }
    }
    trackByIndex(index) {
        return index;
    }
    trackByProviderId(index, provider) {
        return provider.id;
    }
    removeProvider(provider) {
        super.removeProvider(provider);
        this.guidedHelpService.setGuidedHelpDirty(true);
    }
    onConfirm() {
        this.guidedHelpService.setGuidedHelpDirty(true);
        this.navigate(this.providerModalViewName.SEARCH);
    }
}
ProviderSearchModalComponent.ɵfac = function ProviderSearchModalComponent_Factory(t) { return new (t || ProviderSearchModalComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(MapFacade), i0.ɵɵdirectiveInject(ProviderFacade), i0.ɵɵdirectiveInject(HelpfulToolsContextService), i0.ɵɵdirectiveInject(HelpfulToolsService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(MapContextService), i0.ɵɵdirectiveInject(i1.FormValidationService), i0.ɵɵdirectiveInject(ProviderContextService), i0.ɵɵdirectiveInject(i1.FilterService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.ProviderService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.StringFormatUtilityService), i0.ɵɵdirectiveInject(i1.GuidedHelpService)); };
ProviderSearchModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProviderSearchModalComponent, selectors: [["vnext-provider-search-modal"]], inputs: { backButtonText: "backButtonText", modalProviderSearchViewHeadingText: "modalProviderSearchViewHeadingText", modalProviderSearchViewIntroText: "modalProviderSearchViewIntroText", modalProviderMapViewHeadingText: "modalProviderMapViewHeadingText", modalProviderMapViewIntroText: "modalProviderMapViewIntroText", modalProviderLocationViewHeadingText: "modalProviderLocationViewHeadingText", modalProviderLocationViewIntroText: "modalProviderLocationViewIntroText", providerModalViewName: "providerModalViewName" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 11, vars: 4, consts: [[1, "row", "provider-mh-50"], [1, "w-100", 3, "ngSwitch"], [3, "ngTemplateOutlet", 4, "ngSwitchCase"], ["searchView", ""], ["mapView", ""], ["resultView", ""], [3, "ngTemplateOutlet"], ["aria-live", "polite", 1, "col-12"], ["aria-relevant", "text", 1, "row"], [1, "col-12"], [1, "text-left"], ["class", "Spa_Style_H2", 4, "liveEditProp"], ["navigationAdapter", "", "class", "Spa_Style_IntroParagraph", 3, "innerHtml", 4, "liveEditProp"], [1, "px-1"], [1, "container-row", "flex-row-nowrap"], [1, "zip-code-name", "flex-row-nowrap", 3, "ngClass"], [1, "zip-code-input", "mr-lg-2", "col-auto", "p-0", "mr-lg-2"], [1, "zipcode-width", 3, "customStyles", "showCounty", "retrieveZipCode", "retrieveFipsCode", "errorKeywordText", "zipCodeText", "zipCodeErrorText", "countyLabel", "showCountyLabel", "zip", "keyup.enter"], [1, "col-auto", "flex-row-nowrap", "p-0", "mr-lg-5"], [3, "generalPracticeFilterOptionEnabled", "generalPracticeLabel", "generalPracticeToolTipText", "generalPracticeOptions", "selectedGeneralPracticeOption", "optionSelected"], [3, "valueBasedCareToggleEnabled", "valueBasedCareToggleLabel", "valueBasedCareToggleToolTipText", "valueBasedCareToggleOptions", "selectedValueBasedToggleOption", "optionSelected"], [1, "col-auto", "flex-row-nowrap", "p-0", "flex-1", "w-100"], ["class", "provider-name-field flex-1 mr-2", 4, "ngIf"], [1, "btn", "Spa_Style_SecondaryButton", "zipcode-search-button", "provider-border-color", "provider-search-button", "align-self-end", 3, "click"], [1, "sr-only"], [4, "ngIf"], [1, "Spa_Style_H2"], ["navigationAdapter", "", 1, "Spa_Style_IntroParagraph", 3, "innerHtml"], [1, "provider-name-field", "flex-1", "mr-2"], ["class", "error-display error-color text-nowrap", 4, "ngIf"], ["for", "provider-name-text-input", "class", "Spa_Style_Label w-100", 4, "liveEditProp"], ["id", "provider-name-text-input", "type", "text", "class", "Spa_Style_Paragraph provider-name-input", 3, "placeholder", "formControl", "keyup.enter", 4, "liveEditProp"], [1, "error-display", "error-color", "text-nowrap"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], ["for", "provider-name-text-input", 1, "Spa_Style_Label", "w-100"], ["id", "provider-name-text-input", "type", "text", 1, "Spa_Style_Paragraph", "provider-name-input", 3, "placeholder", "formControl", "keyup.enter"], [3, "selectedProviders", "yourProviderText", "removeProviderText", "setPrimaryCareProviderText", "primaryCareProviderText", "iconClass", "backgroundStyleColor", "countryCode", "editLinkText", "showEditLinkEnabled", "providerSingleSelectEnabled", "singleProviderInListEnabled", "newPatientText", "existingPatientText", "selectedProviderOptionsEnabled", "removeText", "removeProvider", "setAsPrimaryCareProvider", "editProvider"], ["class", "mt-2", 4, "ngIf"], ["class", "row", 4, "ngIf"], [1, "pl-3", "pr-3"], ["class", "row provider mb-3 provider-border-color no-translate-block", 3, "ngClass", 4, "ngIf"], [1, "col-12", "footer-content", "justify-content-start", "px-0"], ["type", "button", "tabindex", "0", 1, "btn", "Spa_Style_SecondaryButton", 3, "click", "keyup.enter"], [1, "mt-2"], [1, "provider-search-filter-text", "ml-1", 3, "innerHTML"], [1, "pl-2", 3, "isLinkButton", "title", "makeInlineBlock", "ariaHasPopup", "click", "keydown.enter"], [1, "row"], ["class", "provider-search-filter-item", 3, "ngClass", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "col-12 ml-1 provider-search-filter-text", 4, "ngIf"], [1, "provider-search-filter-item", 3, "ngClass"], ["type", "checkbox", "role", "checkbox", 3, "value", "id", "checked", "change"], ["providerFilterCheckBox", ""], [1, "provider-search-filter-text", "ml-1", 3, "for"], ["class", "pl-2", 3, "isLinkButton", "title", "makeInlineBlock", "ariaHasPopup", "click", "keydown.enter", 4, "ngIf"], [1, "col-12", "ml-1", "provider-search-filter-text"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["type", "checkbox", "role", "checkbox", 3, "value", "checked", "id", "change"], [1, "row", "provider", "mb-3", "provider-border-color", "no-translate-block", 3, "ngClass"], [1, "col-12", "col-md-12", "col-lg-5", "order-last", "order-lg-first", "provider-wrapper", "px-0"], ["class", "col-12 col-md-12 col-lg-7 order-first order-lg-last p-0", 4, "ngIf"], ["class", "provider-list provider-border-color", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "provider-list", "provider-border-color"], [3, "alreadySelectedProvider", "isHelpfulToolsView", "provider", "pageSize", "pageIndex", "selectedProviders", "addProviderText", "providerLocationsText", "providerAddedText", "maxCountErrorMessage", "maxCount", "customClass", "alternateViewClass", "alternateNumberIndicatorClass", "isProviderAdded", "backgroundStyle", "index", "isPrimary", "providerExistsTooltipText", "countryCode", "acceptingNewPatientsIcon", "acceptingNewPatientsText", "languagesIcon", "providerGroup", "providerSingleSelectEnabled", "valueBasedCareEnabled", "valueBasedCareIcon", "valueBasedCareText", "singleProviderInListEnabled", "primaryCareProviderText", "addProvider"], [1, "col-12", "px-2", "mt-2"], [1, "text-center", "Spa_Style_H3", "mt-1"], [1, "Spa_Style_Paragraph", "pt-1", "no-pharmacies-body-text"], [1, "col-12", "col-md-12", "col-lg-7", "order-first", "order-lg-last", "p-0"], [3, "zip", "zoom", "minZoom", "maxZoom", "isHelpfulToolsView", "isProvider", "addButtonText", "addedLabel", "markers", "markerGroups", "limitErrorMessage", "groupAddedLabel", "groupAddText", "providerExistsTooltipText", "providerSingleSelectEnabled", "primaryIconAriaLabelText", "setZoom", "resetToDefaultPageIndex", "setMapCenter", "setMap", "setMapDefaultBounds", "addSelectedItem"], ["class", "col-md-5 col-12 px-0 pr-md-3", 4, "ngIf"], [1, "col-md-5", "col-12", "px-0", "pr-md-3"], [3, "pagination", "defaultStartItem", "itemsPerPage", "paginationText", "updatePagination"], [3, "selectedProviders", "providers", "yourProviderText", "removeProviderText", "setPrimaryCareProviderText", "primaryCareProviderText", "chosenProvider", "providerSingleSelectEnabled", "addLinkText", "cancelProvidersLabel", "providerMultiLocationText", "selectProviderLabelText", "maxCount", "maxCountErrorMessage", "singleProviderInListEnabled", "updateLinkText", "newPatientToggleEnabled", "newPatientToggleLabel", "newPatientToggleOptions", "pcpToggleEnabled", "pcpToggleLabel", "pcpToggleOptions", "backButtonText", "addProviders", "addProvider", "setAsPrimaryCareProvider", "onBack", "onConfirm"]], template: function ProviderSearchModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, ProviderSearchModalComponent_ng_container_2_Template, 1, 1, "ng-container", 2);
        i0.ɵɵtemplate(3, ProviderSearchModalComponent_ng_container_3_Template, 1, 1, "ng-container", 2);
        i0.ɵɵtemplate(4, ProviderSearchModalComponent_ng_container_4_Template, 1, 1, "ng-container", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, ProviderSearchModalComponent_ng_template_5_Template, 21, 33, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(7, ProviderSearchModalComponent_ng_template_7_Template, 14, 8, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(9, ProviderSearchModalComponent_ng_template_9_Template, 7, 25, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitch", ctx.providerFacade.currentModalViewName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.providerModalViewName.SEARCH);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.providerModalViewName.MAP);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.providerModalViewName.RESULT);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgTemplateOutlet, i1$2.NgSwitch, i1$2.NgSwitchCase, i4.DefaultValueAccessor, i4.NgControlStatus, i4.FormControlDirective, ZipCodeInputComponent, PaginationComponent, LinkComponent, NavigationAdapterDirective, LiveEditPropDirective, IconAriaAttributesDirective, ProviderListComponent, MapComponent, GeneralPracticeToggleComponent, ValueBasedProviderToggleComponent, MultipleProviderAddressModalComponent, SelectedProviderModalComponent, i1$2.AsyncPipe, i1$2.SlicePipe, SafePipe], styles: [".provider-icon[_ngcontent-%COMP%]{font-size:46px}.zipcode-width[_ngcontent-%COMP%]{width:auto}.provider-name-input[_ngcontent-%COMP%]{height:38px;width:100%}.zipcode-search-button[_ngcontent-%COMP%]{line-height:1.4}.provider[_ngcontent-%COMP%]{border-radius:5px;border-width:1px;border-style:solid}.provider-wrapper[_ngcontent-%COMP%]{max-height:455px;overflow-y:auto}.provider-list[_ngcontent-%COMP%]{padding:10px 0;float:left;width:100%;border-width:0 0 1px;border-style:solid}.provider-search-filter-item[_ngcontent-%COMP%]{justify-content:space-around;padding:15px 0 10px 19px;margin:0;list-style:none}.provider-list[_ngcontent-%COMP%]:last-child{border-bottom:none}.underline[_ngcontent-%COMP%]{text-decoration:underline}.provider-border-color[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent1)}.provider-search-button[_ngcontent-%COMP%]{height:36px;min-width:36px}.no-pharmacies-body-text[_ngcontent-%COMP%]{line-height:24px}.flex-row-nowrap[_ngcontent-%COMP%]{display:flex;flex-wrap:nowrap;align-items:flex-end}.flex-1[_ngcontent-%COMP%]{flex:1}.bg-grey[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray2)}.provider-search-filter-text[_ngcontent-%COMP%]{font-family:montserrat_light;font-size:var(--Spa_Style_Small_Font);color:var(--static-Spa_Style_Black)}.provider-mh-50[_ngcontent-%COMP%]{min-height:50vh}@media print{.col-md-12.col-lg-5[_ngcontent-%COMP%]{flex:0 0 41.6667%;max-width:41.6667%}.col-md-12.col-lg-7[_ngcontent-%COMP%]{flex:0 0 58.3333%;max-width:58.3333%}.order-lg-first[_ngcontent-%COMP%]{order:-1}.order-lg-last[_ngcontent-%COMP%]{order:13}}@media (max-width: 767.98px){.provider-search-filter-item[_ngcontent-%COMP%]{padding:10px 0 6px 19px}.zip-code-name[_ngcontent-%COMP%]{flex-direction:column;align-items:flex-start;justify-content:flex-start;align-self:stretch}.container-row[_ngcontent-%COMP%]{flex-direction:column;align-items:flex-start;justify-content:flex-start}.provider-name-field[_ngcontent-%COMP%]{align-self:stretch;margin:1rem 0 0}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProviderSearchModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-provider-search-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row provider-mh-50\">\r\n  <div class=\"w-100\" [ngSwitch]=\"providerFacade.currentModalViewName\">\r\n    <ng-container *ngSwitchCase=\"providerModalViewName.SEARCH\" [ngTemplateOutlet]=\"searchView\"> </ng-container>\r\n    <ng-container *ngSwitchCase=\"providerModalViewName.MAP\" [ngTemplateOutlet]=\"mapView\"></ng-container>\r\n    <ng-container *ngSwitchCase=\"providerModalViewName.RESULT\" [ngTemplateOutlet]=\"resultView\"></ng-container>\r\n  </div>\r\n  <ng-template #searchView>\r\n    <div class=\"col-12\" aria-live=\"polite\">\r\n      <div class=\"row\" aria-relevant=\"text\">\r\n        <div class=\"col-12\">\r\n          <div class=\"text-left\">\r\n            <h1 *liveEditProp=\"'Spa_AddProviders_ModalProviderSearchView_HeadingText'\" class=\"Spa_Style_H2\">\r\n              {{ modalProviderSearchViewHeadingText }}\r\n            </h1>\r\n            <p\r\n              *liveEditProp=\"'Spa_AddProviders_ModalProviderSearchView_IntroText'\"\r\n              navigationAdapter\r\n              class=\"Spa_Style_IntroParagraph\"\r\n              [innerHtml]=\"modalProviderSearchViewIntroText | safe : 'html'\"\r\n            ></p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"px-1\">\r\n        <div class=\"container-row flex-row-nowrap\">\r\n          <div class=\"zip-code-name flex-row-nowrap\" [ngClass]=\"{ 'flex-1': searchProviderByNameEnabled }\">\r\n            <div class=\"zip-code-input mr-lg-2 col-auto p-0 mr-lg-2\">\r\n              <vnext-zip-code-input\r\n                class=\"zipcode-width\"\r\n                [customStyles]=\"zipCodeStyles\"\r\n                [showCounty]=\"false\"\r\n                [retrieveZipCode]=\"retrieveZipCode\"\r\n                [retrieveFipsCode]=\"retrieveFipsCode\"\r\n                [errorKeywordText]=\"errorKeywordText\"\r\n                [zipCodeText]=\"zipLabel\"\r\n                [zipCodeErrorText]=\"zipErrorText\"\r\n                [countyLabel]=\"countyLabel\"\r\n                [showCountyLabel]=\"showCountyLabel\"\r\n                (zip)=\"setZipCode($event)\"\r\n                (keyup.enter)=\"validateZip()\"\r\n              >\r\n              </vnext-zip-code-input>\r\n            </div>\r\n            <div class=\"col-auto flex-row-nowrap p-0 mr-lg-5\">\r\n              <vnext-widget-general-practice-toggle\r\n                [generalPracticeFilterOptionEnabled]=\"generalPracticeFilterOptionEnabled\"\r\n                [generalPracticeLabel]=\"generalPracticeLabel\"\r\n                [generalPracticeToolTipText]=\"generalPracticeToolTipText\"\r\n                [generalPracticeOptions]=\"generalPracticeOptions\"\r\n                [selectedGeneralPracticeOption]=\"selectedGeneralPracticeOption\"\r\n                (optionSelected)=\"onGeneralPracticeSelect($event)\"\r\n              >\r\n              </vnext-widget-general-practice-toggle>\r\n              <vnext-widget-value-based-provider-toggle\r\n                [valueBasedCareToggleEnabled]=\"valueBasedCareToggleEnabled\"\r\n                [valueBasedCareToggleLabel]=\"valueBasedCareToggleLabel\"\r\n                [valueBasedCareToggleToolTipText]=\"valueBasedCareToggleToolTipText\"\r\n                [valueBasedCareToggleOptions]=\"valueBasedCareToggleOptions\"\r\n                [selectedValueBasedToggleOption]=\"selectedValueBasedToggleOption\"\r\n                (optionSelected)=\"onValueBasedToggleSelect($event)\"\r\n              >\r\n              </vnext-widget-value-based-provider-toggle>\r\n            </div>\r\n            <div class=\"col-auto flex-row-nowrap p-0 flex-1 w-100\">\r\n              <div *ngIf=\"searchProviderByNameEnabled\" class=\"provider-name-field flex-1 mr-2\">\r\n                <span *ngIf=\"hasMinCharError\" class=\"error-display error-color text-nowrap\"\r\n                  ><i aria-hidden=\"true\" class=\"fas fa-exclamation-circle\"></i> {{ providerErrorText }}</span\r\n                >\r\n                <label *liveEditProp=\"'Spa_ProviderName_Text'\" for=\"provider-name-text-input\" class=\"Spa_Style_Label w-100\">\r\n                  {{ providerNameText }}\r\n                </label>\r\n                <input\r\n                  *liveEditProp=\"'Spa_ProviderName_HintText'\"\r\n                  id=\"provider-name-text-input\"\r\n                  type=\"text\"\r\n                  class=\"Spa_Style_Paragraph provider-name-input\"\r\n                  [placeholder]=\"providerNameHintText\"\r\n                  [formControl]=\"providerName\"\r\n                  (keyup.enter)=\"validateZip()\"\r\n                />\r\n              </div>\r\n              <button\r\n                class=\"btn Spa_Style_SecondaryButton zipcode-search-button provider-border-color provider-search-button align-self-end\"\r\n                [class.ml-1]=\"searchProviderByNameEnabled\"\r\n                (click)=\"validateZip()\"\r\n                [attr.aria-label]=\"providerNameText\"\r\n              >\r\n                <span class=\"sr-only\">{{ providerNameText }}</span>\r\n                <i class=\"fas {{ mapFacade.showSpinner ? 'fa-spinner fa-spin' : 'fa-search' }}\"></i>\r\n              </button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"(providers?.length || selectedProviders?.length) && !isHelpfulToolsView\">\r\n        <vnext-widget-selected-provider-modal\r\n          [selectedProviders]=\"selectedProviders\"\r\n          [yourProviderText]=\"yourProviderText\"\r\n          [removeProviderText]=\"removeProviderText\"\r\n          [setPrimaryCareProviderText]=\"setPrimaryCareProviderText\"\r\n          [primaryCareProviderText]=\"primaryCareProviderText\"\r\n          [iconClass]=\"providerFacade.primaryPinIcon\"\r\n          [backgroundStyleColor]=\"providerFacade.getPrimaryProviderBackgroundColor()\"\r\n          [countryCode]=\"countryCode\"\r\n          [editLinkText]=\"editLinkText\"\r\n          [showEditLinkEnabled]=\"showEditLinkEnabled\"\r\n          [providerSingleSelectEnabled]=\"providerSingleSelectEnabled\"\r\n          [singleProviderInListEnabled]=\"singleProviderInListEnabled\"\r\n          [newPatientText]=\"newPatientText\"\r\n          [existingPatientText]=\"existingPatientText\"\r\n          [selectedProviderOptionsEnabled]=\"selectedProviderOptionsEnabled\"\r\n          [removeText]=\"removeText\"\r\n          (removeProvider)=\"removeProvider($event)\"\r\n          (setAsPrimaryCareProvider)=\"providerFacade.setAsPrimaryCareProvider($event)\"\r\n          (editProvider)=\"editProvider($event)\"\r\n        >\r\n        </vnext-widget-selected-provider-modal>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template #mapView>\r\n    <div class=\"col-12\">\r\n      <div class=\"row\" aria-relevant=\"text\">\r\n        <div class=\"col-12\">\r\n          <div class=\"text-left\">\r\n            <h1 *liveEditProp=\"'Spa_AddProviders_ModalProviderMapView_HeadingText'\" class=\"Spa_Style_H2\">\r\n              {{ modalProviderMapViewHeadingText }}\r\n            </h1>\r\n            <p\r\n              *liveEditProp=\"'Spa_AddProviders_ModalProviderMapView_IntroText'\"\r\n              navigationAdapter\r\n              class=\"Spa_Style_IntroParagraph\"\r\n              [innerHtml]=\"modalProviderMapViewIntroText | safe : 'html'\"\r\n            ></p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"mt-2\" *ngIf=\"isValueBasedCareLearnMoreLink2Enabled\">\r\n        <span class=\"provider-search-filter-text ml-1\" [innerHTML]=\"valueBasedCareAvailableText | safe : 'html'\"></span>\r\n        <vnext-link\r\n          class=\"pl-2\"\r\n          [isLinkButton]=\"true\"\r\n          [title]=\"valueBasedCareLearnMoreText\"\r\n          [makeInlineBlock]=\"true\"\r\n          [ariaHasPopup]=\"true\"\r\n          (click)=\"openExternalLink()\"\r\n          (keydown.enter)=\"openExternalLink()\"\r\n        ></vnext-link>\r\n      </div>\r\n      <div class=\"row\" *ngIf=\"providerFiltersEnabled && mapFacade.showMap\">\r\n        <div\r\n          *ngFor=\"let providerFilter of providerFilters; index as i; trackBy: trackByIndex\"\r\n          class=\"provider-search-filter-item\"\r\n          [ngClass]=\"{ 'Spa_Style_Paragraph ': (providerFacade.isMobile$ | async) }\"\r\n        >\r\n          <ng-container *ngIf=\"!providerFilter.disabled\">\r\n            <input\r\n              #providerFilterCheckBox\r\n              type=\"checkbox\"\r\n              value=\"{{ providerFilter.label }}\"\r\n              role=\"checkbox\"\r\n              [id]=\"i + 'providerFilterCheckBox'\"\r\n              [checked]=\"providerFilter.initiallyChecked\"\r\n              (change)=\"onFilterSelected($event)\"\r\n            /><label [for]=\"i + 'providerFilterCheckBox'\" class=\"provider-search-filter-text ml-1\">{{ providerFilter.label }}</label>\r\n            <vnext-link\r\n              *ngIf=\"providerFilter.link\"\r\n              class=\"pl-2\"\r\n              [isLinkButton]=\"true\"\r\n              [title]=\"providerFilter.link\"\r\n              [makeInlineBlock]=\"true\"\r\n              [ariaHasPopup]=\"true\"\r\n              (click)=\"onFilterLinkSelection(providerFilter.value)\"\r\n              (keydown.enter)=\"onFilterLinkSelection(providerFilter.value, $event)\"\r\n            ></vnext-link>\r\n          </ng-container>\r\n        </div>\r\n        <div *ngIf=\"vbcNameFilterEnabled && vbcList?.length > 1\" class=\"col-12 ml-1 provider-search-filter-text\">\r\n          <label>{{ vbcNameFilterLabel }}</label>\r\n          <ng-container *ngFor=\"let vbc of vbcList; index as i; trackBy: trackByVbcId\">\r\n            <div>\r\n              <input\r\n                type=\"checkbox\"\r\n                [value]=\"vbc.name\"\r\n                [checked]=\"vbc.selected\"\r\n                role=\"checkbox\"\r\n                [id]=\"i + 'vbcCheckBox'\"\r\n                (change)=\"onVbcSelection(i, $event)\"\r\n              /><label [for]=\"i + 'vbcCheckBox'\" class=\"provider-search-filter-text ml-1\">{{ vbc.name }}</label>\r\n            </div>\r\n          </ng-container>\r\n        </div>\r\n      </div>\r\n      <div class=\"pl-3 pr-3\">\r\n        <div\r\n          *ngIf=\"mapFacade.showMap\"\r\n          [ngClass]=\"{ 'mt-3': !providerFiltersEnabled }\"\r\n          class=\"row provider mb-3 provider-border-color no-translate-block\"\r\n        >\r\n          <div class=\"col-12 col-md-12 col-lg-5 order-last order-lg-first provider-wrapper px-0\">\r\n            <ng-container *ngIf=\"providers?.length > 0\">\r\n              <div\r\n                class=\"provider-list provider-border-color\"\r\n                *ngFor=\"\r\n                  let provider of providerList | slice : startValueOfItemsToBeSliced : endValueOfItemsToBeSliced;\r\n                  index as i;\r\n                  trackBy: trackByProviderId\r\n                \"\r\n              >\r\n                <vnext-widget-provider-list\r\n                  [alreadySelectedProvider]=\"providerFacade.selectedProviderIds[provider.id]\"\r\n                  [isHelpfulToolsView]=\"isHelpfulToolsView\"\r\n                  [provider]=\"provider\"\r\n                  [pageSize]=\"pageSize\"\r\n                  [pageIndex]=\"pageIndex\"\r\n                  [selectedProviders]=\"selectedProviders\"\r\n                  [addProviderText]=\"addProviderText\"\r\n                  [providerLocationsText]=\"providerLocationsText\"\r\n                  [providerAddedText]=\"providerAddedText\"\r\n                  [maxCountErrorMessage]=\"maxCountErrorMessage\"\r\n                  [maxCount]=\"maxCount\"\r\n                  [customClass]=\"providerFacade.getProviderPinClass(provider, false, isHelpfulToolsView)\"\r\n                  [alternateViewClass]=\"providerFacade.noticeAlternateView(provider)\"\r\n                  [alternateNumberIndicatorClass]=\"providerFacade.noticeAlternateProviderIndicator(provider)\"\r\n                  [isProviderAdded]=\"\r\n                    providerFacade.isProviderAdded(provider.id, provider.addressId, provider.providerGroup, !providerSingleSelectEnabled)\r\n                  \"\r\n                  [backgroundStyle]=\"providerFacade.getPrimaryProviderBackgroundColor(provider, isHelpfulToolsView)\"\r\n                  [index]=\"i\"\r\n                  [isPrimary]=\"providerFacade.isPcp(provider)\"\r\n                  [providerExistsTooltipText]=\"providerExistsTooltipText\"\r\n                  [countryCode]=\"countryCode\"\r\n                  [acceptingNewPatientsIcon]=\"acceptingNewPatientsIcon\"\r\n                  [acceptingNewPatientsText]=\"acceptingNewPatientsText\"\r\n                  [languagesIcon]=\"languagesIcon\"\r\n                  [providerGroup]=\"provider.providerGroup\"\r\n                  [providerSingleSelectEnabled]=\"providerSingleSelectEnabled\"\r\n                  [valueBasedCareEnabled]=\"valueBasedCareEnabled\"\r\n                  [valueBasedCareIcon]=\"valueBasedCareIcon\"\r\n                  [valueBasedCareText]=\"valueBasedCareText\"\r\n                  [singleProviderInListEnabled]=\"singleProviderInListEnabled\"\r\n                  [primaryCareProviderText]=\"primaryCareProviderText\"\r\n                  (addProvider)=\"addProvider($event)\"\r\n                >\r\n                </vnext-widget-provider-list>\r\n              </div>\r\n            </ng-container>\r\n            <ng-container *ngIf=\"!(providers?.length > 0) && !mapFacade.showSpinner\">\r\n              <div class=\"col-12 px-2 mt-2\">\r\n                <h3 class=\"text-center Spa_Style_H3 mt-1\">\r\n                  {{ viewNotFoundHeaderText }}\r\n                </h3>\r\n                <p class=\"Spa_Style_Paragraph pt-1 no-pharmacies-body-text\">\r\n                  {{ viewNotFoundBodyText }}\r\n                </p>\r\n              </div>\r\n            </ng-container>\r\n          </div>\r\n          <div *ngIf=\"zip\" class=\"col-12 col-md-12 col-lg-7 order-first order-lg-last p-0\">\r\n            <vnext-widget-map\r\n              [zip]=\"zip\"\r\n              [zoom]=\"zoom\"\r\n              [minZoom]=\"minZoom\"\r\n              [maxZoom]=\"maxZoom\"\r\n              [isHelpfulToolsView]=\"isHelpfulToolsView\"\r\n              [isProvider]=\"true\"\r\n              [addButtonText]=\"addProviderText\"\r\n              [addedLabel]=\"providerAddedText\"\r\n              [markers]=\"markers\"\r\n              [markerGroups]=\"markerGroups\"\r\n              [limitErrorMessage]=\"maxCountErrorMessage\"\r\n              [groupAddedLabel]=\"providerGroupAddedLabelText\"\r\n              [groupAddText]=\"providerGroupAddLabelText\"\r\n              [providerExistsTooltipText]=\"providerExistsTooltipText\"\r\n              [providerSingleSelectEnabled]=\"providerSingleSelectEnabled\"\r\n              [primaryIconAriaLabelText]=\"primaryCareProviderText\"\r\n              (setZoom)=\"setZoom($event)\"\r\n              (resetToDefaultPageIndex)=\"updateProviders({ pageSize: itemsPerPage, defaultStartItem: 1 })\"\r\n              (setMapCenter)=\"setMapCenter.emit($event)\"\r\n              (setMap)=\"initializeMap.emit($event)\"\r\n              (setMapDefaultBounds)=\"setMapDefaultBounds.emit($event)\"\r\n              (addSelectedItem)=\"addToMapSelectedProvider($event)\"\r\n            >\r\n            </vnext-widget-map>\r\n          </div>\r\n        </div>\r\n        <div *ngIf=\"mapFacade.showMap\" class=\"row\">\r\n          <div *ngIf=\"providerPaginationEnabled && itemsPerPage < providerList?.length\" class=\"col-md-5 col-12 px-0 pr-md-3\">\r\n            <vnext-pagination\r\n              [pagination]=\"providerList\"\r\n              [defaultStartItem]=\"defaultStartItem\"\r\n              [itemsPerPage]=\"itemsPerPage\"\r\n              [paginationText]=\"paginationText\"\r\n              (updatePagination)=\"updateProviders($event)\"\r\n            ></vnext-pagination>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-12 footer-content justify-content-start px-0\">\r\n        <button\r\n          type=\"button\"\r\n          [attr.aria-label]=\"backButtonText\"\r\n          class=\"btn Spa_Style_SecondaryButton\"\r\n          tabindex=\"0\"\r\n          (click)=\"navigate(providerModalViewName.SEARCH)\"\r\n          (keyup.enter)=\"navigate(providerModalViewName.SEARCH)\"\r\n        >\r\n          {{ backButtonText }}\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template #resultView>\r\n    <div class=\"col-12\">\r\n      <div class=\"row\" aria-relevant=\"text\">\r\n        <div class=\"col-12\">\r\n          <div class=\"text-left\">\r\n            <h1 *liveEditProp=\"'Spa_AddProviders_ModalProviderLocationView_HeadingText'\" class=\"Spa_Style_H2\">\r\n              {{ modalProviderLocationViewHeadingText }}\r\n            </h1>\r\n            <p\r\n              *liveEditProp=\"'Spa_AddProviders_ModalProviderLocationView_IntroText'\"\r\n              navigationAdapter\r\n              class=\"Spa_Style_IntroParagraph\"\r\n              [innerHtml]=\"modalProviderLocationViewIntroText | safe : 'html'\"\r\n            ></p>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <vnext-widget-multiple-provider-address-modal\r\n        [selectedProviders]=\"selectedProviders\"\r\n        [providers]=\"providers\"\r\n        [yourProviderText]=\"yourProviderText\"\r\n        [removeProviderText]=\"removeProviderText\"\r\n        [setPrimaryCareProviderText]=\"setPrimaryCareProviderText\"\r\n        [primaryCareProviderText]=\"primaryCareProviderText\"\r\n        [chosenProvider]=\"selectedProvider\"\r\n        [providerSingleSelectEnabled]=\"providerSingleSelectEnabled\"\r\n        [addLinkText]=\"addLinkText\"\r\n        [cancelProvidersLabel]=\"cancelProvidersLabel\"\r\n        [providerMultiLocationText]=\"providerMultiLocationText\"\r\n        [selectProviderLabelText]=\"selectProviderLabelText\"\r\n        [maxCount]=\"maxCount\"\r\n        [maxCountErrorMessage]=\"maxCountErrorMessage\"\r\n        [singleProviderInListEnabled]=\"singleProviderInListEnabled\"\r\n        [updateLinkText]=\"updateLinkText\"\r\n        [newPatientToggleEnabled]=\"newPatientToggleEnabled\"\r\n        [newPatientToggleLabel]=\"newPatientToggleLabel\"\r\n        [newPatientToggleOptions]=\"newPatientToggleOptions\"\r\n        [pcpToggleEnabled]=\"pcpToggleEnabled\"\r\n        [pcpToggleLabel]=\"pcpToggleLabel\"\r\n        [pcpToggleOptions]=\"pcpToggleOptions\"\r\n        [backButtonText]=\"backButtonText\"\r\n        (addProviders)=\"providersAddToList($event)\"\r\n        (addProvider)=\"addToSelectedProvider($event)\"\r\n        (setAsPrimaryCareProvider)=\"providerFacade.setAsPrimaryCareProvider($event)\"\r\n        (onBack)=\"onResultViewBack()\"\r\n        (onConfirm)=\"onConfirm()\"\r\n      >\r\n      </vnext-widget-multiple-provider-address-modal>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n", styles: [".provider-icon{font-size:46px}.zipcode-width{width:auto}.provider-name-input{height:38px;width:100%}.zipcode-search-button{line-height:1.4}.provider{border-radius:5px;border-width:1px;border-style:solid}.provider-wrapper{max-height:455px;overflow-y:auto}.provider-list{padding:10px 0;float:left;width:100%;border-width:0 0 1px;border-style:solid}.provider-search-filter-item{justify-content:space-around;padding:15px 0 10px 19px;margin:0;list-style:none}.provider-list:last-child{border-bottom:none}.underline{text-decoration:underline}.provider-border-color{border-color:var(--static-Spa_Style_Accent1)}.provider-search-button{height:36px;min-width:36px}.no-pharmacies-body-text{line-height:24px}.flex-row-nowrap{display:flex;flex-wrap:nowrap;align-items:flex-end}.flex-1{flex:1}.bg-grey{background-color:var(--static-Spa_Style_Gray2)}.provider-search-filter-text{font-family:montserrat_light;font-size:var(--Spa_Style_Small_Font);color:var(--static-Spa_Style_Black)}.provider-mh-50{min-height:50vh}@media print{.col-md-12.col-lg-5{flex:0 0 41.6667%;max-width:41.6667%}.col-md-12.col-lg-7{flex:0 0 58.3333%;max-width:58.3333%}.order-lg-first{order:-1}.order-lg-last{order:13}}@media (max-width: 767.98px){.provider-search-filter-item{padding:10px 0 6px 19px}.zip-code-name{flex-direction:column;align-items:flex-start;justify-content:flex-start;align-self:stretch}.container-row{flex-direction:column;align-items:flex-start;justify-content:flex-start}.provider-name-field{align-self:stretch;margin:1rem 0 0}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: ConfigurableWidgetService }, { type: i1.WidgetValidationService }, { type: MapFacade }, { type: ProviderFacade }, { type: HelpfulToolsContextService }, { type: HelpfulToolsService }, { type: i1.SpinnerService }, { type: MapContextService }, { type: i1.FormValidationService }, { type: ProviderContextService }, { type: i1.FilterService }, { type: AnalyticsService }, { type: i1.ProviderService }, { type: i1.NavigationService }, { type: i1.StringFormatUtilityService }, { type: i1.GuidedHelpService }]; }, { backButtonText: [{
            type: Input
        }], modalProviderSearchViewHeadingText: [{
            type: Input
        }], modalProviderSearchViewIntroText: [{
            type: Input
        }], modalProviderMapViewHeadingText: [{
            type: Input
        }], modalProviderMapViewIntroText: [{
            type: Input
        }], modalProviderLocationViewHeadingText: [{
            type: Input
        }], modalProviderLocationViewIntroText: [{
            type: Input
        }], providerModalViewName: [{
            type: Input
        }] }); })();

class ProviderModalComponent {
    constructor(cdr, activeModal, providerFacade, mapFacade, mapContextService, localeService, elementRef, renderer, guidedHelpModalStyleService) {
        this.cdr = cdr;
        this.activeModal = activeModal;
        this.providerFacade = providerFacade;
        this.mapFacade = mapFacade;
        this.mapContextService = mapContextService;
        this.localeService = localeService;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.guidedHelpModalStyleService = guidedHelpModalStyleService;
        this.addProviderMaxLimit = AddProviderMaxLimit;
        this.providerFilters = [];
        this.subscriptions = new Subscription();
    }
    ngAfterViewInit() {
        const modalElement = this.elementRef.nativeElement;
        if (modalElement) {
            this.guidedHelpModalStyleService.applyModalStyle(this.renderer, modalElement);
        }
    }
    ngOnInit() {
        this.providerMaxLimitError = this.getProviderMaxLimitErrorMessage();
        this.providerFacade.setProviderSearchLoaded(false);
        this.providerFilters = [
            {
                label: this.providerInputProps.providerFilterIndividualText,
                value: ProviderFilterKeyType.PROVIDER_INDIVIDUAL,
                disabled: false,
                initiallyChecked: true,
                link: null
            },
            {
                label: this.providerInputProps.providerFacilitiesText,
                value: ProviderFilterKeyType.PROVIDER_FACILITIES,
                disabled: false,
                initiallyChecked: true,
                link: null
            },
            {
                label: this.providerInputProps.valueBasedCareFilterText,
                value: ProviderFilterKeyType.PROVIDER_VALUE_BASED_CARE,
                disabled: !(this.providerInputProps.valueBasedCareEnabled && this.providerInputProps.valueBasedCareFilterEnabled),
                initiallyChecked: this.providerInputProps.valueBasedCareFilterChecked,
                link: !this.providerInputProps.isValueBasedCareLearnMoreLink2Enabled && this.providerInputProps.valueBasedCareLearnMoreLinkEnabled
                    ? this.providerInputProps.valueBasedCareLearnMoreText
                    : null
            }
        ];
        this.subscriptions.add(this.localeService.getCountryCode$.subscribe(countryCode => {
            if (countryCode) {
                this.countryCode = countryCode;
            }
            this.cdr.markForCheck();
        }));
    }
    getProviderMaxLimitErrorMessage() {
        return this.providerInputProps.providerAddMaxLimitMessage && this.addProviderMaxLimit.MAX_COUNT
            ? this.providerInputProps.providerAddMaxLimitMessage.replace('<maxCount>', this.addProviderMaxLimit.MAX_COUNT.toString())
            : this.providerInputProps.providerAddMaxLimitMessage;
    }
    fetchProvidersFromLocation(providerSearchFilter) {
        if (providerSearchFilter?.latitude &&
            providerSearchFilter?.longitude &&
            providerSearchFilter?.bounds &&
            providerSearchFilter?.distance) {
            this.providerFacade.fetchProvidersFromLocation(providerSearchFilter);
        }
    }
    cancel() {
        this.providerFacade.currentModalViewName = ProviderModalViewName.SEARCH;
        this.providerFacade.setProviderSearchLoaded(false);
        if (this.cancelAction) {
            this.cancelAction();
        }
        this.activeModal.dismiss();
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
ProviderModalComponent.ɵfac = function ProviderModalComponent_Factory(t) { return new (t || ProviderModalComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$1.NgbActiveModal), i0.ɵɵdirectiveInject(ProviderFacade), i0.ɵɵdirectiveInject(MapFacade), i0.ɵɵdirectiveInject(MapContextService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(GuidedHelpModalStyleService)); };
ProviderModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProviderModalComponent, selectors: [["vnext-provider-modal"]], decls: 4, vars: 82, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "modal-body"], [3, "providersText", "providersBodyText", "providersMultiBodyText", "errorKeywordText", "zipLabel", "zipErrorText", "providerNameText", "providerNameHintText", "providerSearchButtonText", "providerLimit", "itemsPerPage", "providerPaginationEnabled", "viewNotFoundHeaderText", "viewNotFoundBodyText", "paginationText", "maxZoom", "minZoom", "providerMapDefaultZoom", "addProviderText", "providerAddedText", "maxCount", "maxCountErrorMessage", "yourProviderText", "removeProviderText", "setPrimaryCareProviderText", "primaryCareProviderText", "providerFiltersEnabled", "providerFilters", "providerGroupAddedLabelText", "providerGroupAddLabelText", "countyLabel", "showCountyLabel", "addLinkText", "cancelProvidersLabel", "providerSingleSelectEnabled", "selectProviderLabelText", "providerExistsTooltipText", "providerMultiLocationText", "countryCode", "providerLocationsText", "valueBasedCareEnabled", "valueBasedCareIcon", "valueBasedCareText", "generalPracticeOptions", "generalPracticeToolTipText", "generalPracticeLabel", "generalPracticeFilterOptionEnabled", "singleProviderInListEnabled", "updateLinkText", "editLinkText", "showEditLinkEnabled", "valueBasedCareAvailableText", "valueBasedCareLearnMoreLink", "isValueBasedCareLearnMoreLink2Enabled", "valueBasedCareToggleLabel", "valueBasedCareToggleToolTipText", "valueBasedCareToggleEnabled", "valueBasedCareToggleOptions", "newPatientToggleEnabled", "pcpToggleEnabled", "newPatientToggleOptions", "newPatientToggleLabel", "pcpToggleLabel", "pcpToggleOptions", "newPatientText", "existingPatientText", "vbcNameFilterEnabled", "vbcNameFilterLabel", "selectedProviderOptionsEnabled", "removeText", "selectAllText", "backButtonText", "modalProviderSearchViewHeadingText", "modalProviderSearchViewIntroText", "modalProviderMapViewHeadingText", "modalProviderMapViewIntroText", "modalProviderLocationViewHeadingText", "modalProviderLocationViewIntroText", "isPreferenceBannerEnabled", "fetchProvidersFromLocation", "setMapCenter", "initializeMap", "setMapDefaultBounds", "addProviders", "addProviderSelectedFromMarker", "fetchProvidersFromAPI"], [3, "cancelButtonText", "primaryButtonEnabled", "cancelButtonAction"]], template: function ProviderModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function ProviderModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_0_listener() { return ctx.cancel(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 1)(2, "vnext-provider-search-modal", 2);
        i0.ɵɵlistener("fetchProvidersFromLocation", function ProviderModalComponent_Template_vnext_provider_search_modal_fetchProvidersFromLocation_2_listener($event) { return ctx.fetchProvidersFromLocation($event); })("setMapCenter", function ProviderModalComponent_Template_vnext_provider_search_modal_setMapCenter_2_listener($event) { return ctx.mapFacade.setCenterPosition($event); })("initializeMap", function ProviderModalComponent_Template_vnext_provider_search_modal_initializeMap_2_listener($event) { return ctx.mapFacade.initializeMap($event); })("setMapDefaultBounds", function ProviderModalComponent_Template_vnext_provider_search_modal_setMapDefaultBounds_2_listener($event) { return ctx.mapContextService.setDefaultBounds($event); })("addProviders", function ProviderModalComponent_Template_vnext_provider_search_modal_addProviders_2_listener($event) { return ctx.providerFacade.addProviders($event); })("addProviderSelectedFromMarker", function ProviderModalComponent_Template_vnext_provider_search_modal_addProviderSelectedFromMarker_2_listener($event) { return ctx.providerFacade.addProviderSelectedFromMarker($event); })("fetchProvidersFromAPI", function ProviderModalComponent_Template_vnext_provider_search_modal_fetchProvidersFromAPI_2_listener($event) { return ctx.providerFacade.fetchProvidersFromAPI($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(3, "vnext-widget-modal-footer", 3);
        i0.ɵɵlistener("cancelButtonAction", function ProviderModalComponent_Template_vnext_widget_modal_footer_cancelButtonAction_3_listener() { return ctx.cancel(); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("modalTitleText", ctx.title);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("providersText", ctx.providerInputProps.providersText)("providersBodyText", ctx.providerInputProps.providersBodyText)("providersMultiBodyText", ctx.providerInputProps.providersMultiBodyText)("errorKeywordText", ctx.providerInputProps.errorKeywordText)("zipLabel", ctx.providerInputProps.zipLabel)("zipErrorText", ctx.providerInputProps.zipErrorText)("providerNameText", ctx.providerInputProps.providerNameText)("providerNameHintText", ctx.providerInputProps.providerNameHintText)("providerSearchButtonText", ctx.providerInputProps.providerSearchButtonText)("providerLimit", ctx.providerInputProps.providerLimit)("itemsPerPage", ctx.providerInputProps.itemsPerPage)("providerPaginationEnabled", ctx.providerInputProps.providerPaginationEnabled)("viewNotFoundHeaderText", ctx.providerInputProps.viewNotFoundHeaderText)("viewNotFoundBodyText", ctx.providerInputProps.viewNotFoundBodyText)("paginationText", ctx.providerInputProps.paginationText)("maxZoom", ctx.providerInputProps.maxZoom)("minZoom", ctx.providerInputProps.minZoom)("providerMapDefaultZoom", ctx.providerInputProps.providerMapDefaultZoom)("addProviderText", ctx.providerInputProps.addProviderText)("providerAddedText", ctx.providerInputProps.providerAddedText)("maxCount", ctx.addProviderMaxLimit.MAX_COUNT)("maxCountErrorMessage", ctx.providerMaxLimitError)("yourProviderText", ctx.providerInputProps.yourProviderText)("removeProviderText", ctx.providerInputProps.removeProviderText)("setPrimaryCareProviderText", ctx.providerInputProps.setPrimaryCareProviderText)("primaryCareProviderText", ctx.providerInputProps.primaryCareProviderText)("providerFiltersEnabled", ctx.providerInputProps.providerFiltersEnabled)("providerFilters", ctx.providerFilters)("providerGroupAddedLabelText", ctx.providerInputProps.providerGroupAddedLabelText)("providerGroupAddLabelText", ctx.providerInputProps.providerGroupAddLabelText)("countyLabel", ctx.providerInputProps.countyLabel)("showCountyLabel", ctx.providerInputProps.showCountyLabel)("addLinkText", ctx.providerInputProps.addLinkText)("cancelProvidersLabel", ctx.providerInputProps.cancelProvidersLabel)("providerSingleSelectEnabled", ctx.providerInputProps.providerSingleSelectEnabled)("selectProviderLabelText", ctx.providerInputProps.selectProviderLabelText)("providerExistsTooltipText", ctx.providerInputProps.providerExistsTooltipText)("providerMultiLocationText", ctx.providerInputProps.providerMultiLocationText)("countryCode", ctx.countryCode)("providerLocationsText", ctx.providerInputProps.providerLocationsText)("valueBasedCareEnabled", ctx.providerInputProps.valueBasedCareEnabled)("valueBasedCareIcon", ctx.providerInputProps.valueBasedCareIcon)("valueBasedCareText", ctx.providerInputProps.valueBasedCareText)("generalPracticeOptions", ctx.providerInputProps.generalPracticeOptions)("generalPracticeToolTipText", ctx.providerInputProps.generalPracticeToolTipText)("generalPracticeLabel", ctx.providerInputProps.generalPracticeLabel)("generalPracticeFilterOptionEnabled", ctx.providerInputProps.generalPracticeFilterOptionEnabled)("singleProviderInListEnabled", ctx.providerInputProps.singleProviderInListEnabled)("updateLinkText", ctx.providerInputProps.updateLinkText)("editLinkText", ctx.providerInputProps.editLinkText)("showEditLinkEnabled", ctx.providerInputProps.showEditLinkEnabled)("valueBasedCareAvailableText", ctx.providerInputProps.valueBasedCareAvailableText)("valueBasedCareLearnMoreLink", ctx.providerInputProps.valueBasedCareLearnMoreLink)("isValueBasedCareLearnMoreLink2Enabled", ctx.providerInputProps.isValueBasedCareLearnMoreLink2Enabled && ctx.providerInputProps.valueBasedCareEnabled)("valueBasedCareToggleLabel", ctx.providerInputProps.valueBasedCareToggleLabel)("valueBasedCareToggleToolTipText", ctx.providerInputProps.valueBasedCareToggleToolTipText)("valueBasedCareToggleEnabled", ctx.providerInputProps.valueBasedCareToggleEnabled && ctx.providerInputProps.valueBasedCareEnabled)("valueBasedCareToggleOptions", ctx.providerInputProps.valueBasedCareToggleOptions)("newPatientToggleEnabled", ctx.providerInputProps.newPatientToggleEnabled)("pcpToggleEnabled", ctx.providerInputProps.pcpToggleEnabled)("newPatientToggleOptions", ctx.providerInputProps.newPatientToggleOptions)("newPatientToggleLabel", ctx.providerInputProps.newPatientToggleLabel)("pcpToggleLabel", ctx.providerInputProps.pcpToggleLabel)("pcpToggleOptions", ctx.providerInputProps.pcpToggleOptions)("newPatientText", ctx.providerInputProps.newPatientText)("existingPatientText", ctx.providerInputProps.existingPatientText)("vbcNameFilterEnabled", ctx.providerInputProps.vbcNameFilterEnabled)("vbcNameFilterLabel", ctx.providerInputProps.vbcNameFilterLabel)("selectedProviderOptionsEnabled", ctx.providerInputProps.selectedProviderOptionsEnabled)("removeText", ctx.providerInputProps.removeText)("selectAllText", ctx.providerInputProps.selectAllText)("backButtonText", ctx.providerInputProps.backButtonText)("modalProviderSearchViewHeadingText", ctx.providerInputProps.modalProviderSearchViewHeadingText)("modalProviderSearchViewIntroText", ctx.providerInputProps.modalProviderSearchViewIntroText)("modalProviderMapViewHeadingText", ctx.providerInputProps.modalProviderMapViewHeadingText)("modalProviderMapViewIntroText", ctx.providerInputProps.modalProviderMapViewIntroText)("modalProviderLocationViewHeadingText", ctx.providerInputProps.modalProviderLocationViewHeadingText)("modalProviderLocationViewIntroText", ctx.providerInputProps.modalProviderLocationViewIntroText)("isPreferenceBannerEnabled", true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("cancelButtonText", ctx.cancelButton)("primaryButtonEnabled", false);
    } }, dependencies: [ModalFooterComponent, ModalHeaderComponent, ProviderSearchModalComponent], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProviderModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-provider-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-widget-modal-header [modalTitleText]=\"title\" (modalTitleCancelAction)=\"cancel()\"></vnext-widget-modal-header>\r\n\r\n<div class=\"modal-body\">\r\n  <vnext-provider-search-modal\r\n    [providersText]=\"providerInputProps.providersText\"\r\n    [providersBodyText]=\"providerInputProps.providersBodyText\"\r\n    [providersMultiBodyText]=\"providerInputProps.providersMultiBodyText\"\r\n    [errorKeywordText]=\"providerInputProps.errorKeywordText\"\r\n    [zipLabel]=\"providerInputProps.zipLabel\"\r\n    [zipErrorText]=\"providerInputProps.zipErrorText\"\r\n    [providerNameText]=\"providerInputProps.providerNameText\"\r\n    [providerNameHintText]=\"providerInputProps.providerNameHintText\"\r\n    [providerSearchButtonText]=\"providerInputProps.providerSearchButtonText\"\r\n    [providerLimit]=\"providerInputProps.providerLimit\"\r\n    [itemsPerPage]=\"providerInputProps.itemsPerPage\"\r\n    [providerPaginationEnabled]=\"providerInputProps.providerPaginationEnabled\"\r\n    [viewNotFoundHeaderText]=\"providerInputProps.viewNotFoundHeaderText\"\r\n    [viewNotFoundBodyText]=\"providerInputProps.viewNotFoundBodyText\"\r\n    [paginationText]=\"providerInputProps.paginationText\"\r\n    [maxZoom]=\"providerInputProps.maxZoom\"\r\n    [minZoom]=\"providerInputProps.minZoom\"\r\n    [providerMapDefaultZoom]=\"providerInputProps.providerMapDefaultZoom\"\r\n    [addProviderText]=\"providerInputProps.addProviderText\"\r\n    [providerAddedText]=\"providerInputProps.providerAddedText\"\r\n    [maxCount]=\"addProviderMaxLimit.MAX_COUNT\"\r\n    [maxCountErrorMessage]=\"providerMaxLimitError\"\r\n    [yourProviderText]=\"providerInputProps.yourProviderText\"\r\n    [removeProviderText]=\"providerInputProps.removeProviderText\"\r\n    [setPrimaryCareProviderText]=\"providerInputProps.setPrimaryCareProviderText\"\r\n    [primaryCareProviderText]=\"providerInputProps.primaryCareProviderText\"\r\n    (fetchProvidersFromLocation)=\"fetchProvidersFromLocation($event)\"\r\n    (setMapCenter)=\"mapFacade.setCenterPosition($event)\"\r\n    (initializeMap)=\"mapFacade.initializeMap($event)\"\r\n    (setMapDefaultBounds)=\"mapContextService.setDefaultBounds($event)\"\r\n    (addProviders)=\"providerFacade.addProviders($event)\"\r\n    (addProviderSelectedFromMarker)=\"providerFacade.addProviderSelectedFromMarker($event)\"\r\n    (fetchProvidersFromAPI)=\"providerFacade.fetchProvidersFromAPI($event)\"\r\n    [providerFiltersEnabled]=\"providerInputProps.providerFiltersEnabled\"\r\n    [providerFilters]=\"providerFilters\"\r\n    [providerGroupAddedLabelText]=\"providerInputProps.providerGroupAddedLabelText\"\r\n    [providerGroupAddLabelText]=\"providerInputProps.providerGroupAddLabelText\"\r\n    [countyLabel]=\"providerInputProps.countyLabel\"\r\n    [showCountyLabel]=\"providerInputProps.showCountyLabel\"\r\n    [addLinkText]=\"providerInputProps.addLinkText\"\r\n    [cancelProvidersLabel]=\"providerInputProps.cancelProvidersLabel\"\r\n    [providerSingleSelectEnabled]=\"providerInputProps.providerSingleSelectEnabled\"\r\n    [selectProviderLabelText]=\"providerInputProps.selectProviderLabelText\"\r\n    [providerExistsTooltipText]=\"providerInputProps.providerExistsTooltipText\"\r\n    [providerMultiLocationText]=\"providerInputProps.providerMultiLocationText\"\r\n    [countryCode]=\"countryCode\"\r\n    [providerLocationsText]=\"providerInputProps.providerLocationsText\"\r\n    [valueBasedCareEnabled]=\"providerInputProps.valueBasedCareEnabled\"\r\n    [valueBasedCareIcon]=\"providerInputProps.valueBasedCareIcon\"\r\n    [valueBasedCareText]=\"providerInputProps.valueBasedCareText\"\r\n    [generalPracticeOptions]=\"providerInputProps.generalPracticeOptions\"\r\n    [generalPracticeToolTipText]=\"providerInputProps.generalPracticeToolTipText\"\r\n    [generalPracticeLabel]=\"providerInputProps.generalPracticeLabel\"\r\n    [generalPracticeFilterOptionEnabled]=\"providerInputProps.generalPracticeFilterOptionEnabled\"\r\n    [singleProviderInListEnabled]=\"providerInputProps.singleProviderInListEnabled\"\r\n    [updateLinkText]=\"providerInputProps.updateLinkText\"\r\n    [editLinkText]=\"providerInputProps.editLinkText\"\r\n    [showEditLinkEnabled]=\"providerInputProps.showEditLinkEnabled\"\r\n    [valueBasedCareAvailableText]=\"providerInputProps.valueBasedCareAvailableText\"\r\n    [valueBasedCareLearnMoreLink]=\"providerInputProps.valueBasedCareLearnMoreLink\"\r\n    [isValueBasedCareLearnMoreLink2Enabled]=\"\r\n      providerInputProps.isValueBasedCareLearnMoreLink2Enabled && providerInputProps.valueBasedCareEnabled\r\n    \"\r\n    [valueBasedCareToggleLabel]=\"providerInputProps.valueBasedCareToggleLabel\"\r\n    [valueBasedCareToggleToolTipText]=\"providerInputProps.valueBasedCareToggleToolTipText\"\r\n    [valueBasedCareToggleEnabled]=\"providerInputProps.valueBasedCareToggleEnabled && providerInputProps.valueBasedCareEnabled\"\r\n    [valueBasedCareToggleOptions]=\"providerInputProps.valueBasedCareToggleOptions\"\r\n    [newPatientToggleEnabled]=\"providerInputProps.newPatientToggleEnabled\"\r\n    [pcpToggleEnabled]=\"providerInputProps.pcpToggleEnabled\"\r\n    [newPatientToggleOptions]=\"providerInputProps.newPatientToggleOptions\"\r\n    [newPatientToggleLabel]=\"providerInputProps.newPatientToggleLabel\"\r\n    [pcpToggleLabel]=\"providerInputProps.pcpToggleLabel\"\r\n    [pcpToggleOptions]=\"providerInputProps.pcpToggleOptions\"\r\n    [newPatientText]=\"providerInputProps.newPatientText\"\r\n    [existingPatientText]=\"providerInputProps.existingPatientText\"\r\n    [vbcNameFilterEnabled]=\"providerInputProps.vbcNameFilterEnabled\"\r\n    [vbcNameFilterLabel]=\"providerInputProps.vbcNameFilterLabel\"\r\n    [selectedProviderOptionsEnabled]=\"providerInputProps.selectedProviderOptionsEnabled\"\r\n    [removeText]=\"providerInputProps.removeText\"\r\n    [selectAllText]=\"providerInputProps.selectAllText\"\r\n    [backButtonText]=\"providerInputProps.backButtonText\"\r\n    [modalProviderSearchViewHeadingText]=\"providerInputProps.modalProviderSearchViewHeadingText\"\r\n    [modalProviderSearchViewIntroText]=\"providerInputProps.modalProviderSearchViewIntroText\"\r\n    [modalProviderMapViewHeadingText]=\"providerInputProps.modalProviderMapViewHeadingText\"\r\n    [modalProviderMapViewIntroText]=\"providerInputProps.modalProviderMapViewIntroText\"\r\n    [modalProviderLocationViewHeadingText]=\"providerInputProps.modalProviderLocationViewHeadingText\"\r\n    [modalProviderLocationViewIntroText]=\"providerInputProps.modalProviderLocationViewIntroText\"\r\n    [isPreferenceBannerEnabled]=\"true\"\r\n  >\r\n  </vnext-provider-search-modal>\r\n</div>\r\n\r\n<vnext-widget-modal-footer\r\n  [cancelButtonText]=\"cancelButton\"\r\n  [primaryButtonEnabled]=\"false\"\r\n  (cancelButtonAction)=\"cancel()\"\r\n></vnext-widget-modal-footer>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1$1.NgbActiveModal }, { type: ProviderFacade }, { type: MapFacade }, { type: MapContextService }, { type: i1.LocaleService }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: GuidedHelpModalStyleService }]; }, null); })();

class GuidedHelpModalService {
    constructor(modalService) {
        this.modalService = modalService;
        this.options = {
            ariaLabelledBy: 'modalHeaderTitle',
            centered: true,
            windowClass: 'modal--lg'
        };
    }
    openGuidedHelpModal(modalType, injector, props = {}) {
        let modalComponent;
        switch (modalType) {
            case PageTags.GUIDED_HELP_PROVIDER_SEARCH:
                modalComponent = ProviderModalComponent;
                break;
            case PageTags.GUIDED_HELP_PHARMACY_SEARCH:
                modalComponent = PharmacyModalComponent;
                break;
            case PageTags.GUIDED_HELP_PRESCRIPTIONS:
                modalComponent = PrescriptionModalComponent;
                break;
            case PageTags.GUIDED_HELP_ELIGIBILITY:
                modalComponent = EligibilityModalComponent;
                break;
            case PageTags.GUIDED_HELP_HEALTH:
                modalComponent = HealthModalComponent;
                break;
            default:
                return;
        }
        const modalRef = this.modalService.open(modalComponent, { ...this.options, injector: injector });
        Object.assign(modalRef.componentInstance, props);
    }
}
GuidedHelpModalService.ɵfac = function GuidedHelpModalService_Factory(t) { return new (t || GuidedHelpModalService)(i0.ɵɵinject(i1$1.NgbModal)); };
GuidedHelpModalService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: GuidedHelpModalService, factory: GuidedHelpModalService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuidedHelpModalService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.NgbModal }]; }, null); })();

function PharmacySelectionComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.canSellPlan ? ctx_r0.costBasedOnMailOrderPharmacy : ctx_r0.cantSellPlanCostBasedOnMailOrderPharmacy, " ");
} }
function PharmacySelectionComponent_ng_template_9_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.costBasedOnSelectedPharmacy, " ");
} }
function PharmacySelectionComponent_ng_template_9_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.canSellPlan ? ctx_r7.costBasedOnRetailPharmacy : ctx_r7.cantSellPlanCostBasedOnRetailPharmacy, " ");
} }
function PharmacySelectionComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PharmacySelectionComponent_ng_template_9_ng_container_0_Template, 2, 1, "ng-container", 7);
    i0.ɵɵtemplate(1, PharmacySelectionComponent_ng_template_9_ng_template_1_Template, 1, 1, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r6 = i0.ɵɵreference(2);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.selectedPharmacy && ctx_r2.canSellPlan)("ngIfElse", _r6);
} }
function PharmacySelectionComponent_span_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.selectedPharmacy.name, " ");
} }
function PharmacySelectionComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " | ");
    i0.ɵɵelementContainerEnd();
} }
class PharmacySelectionComponent {
    constructor(pharmacyFacade, analyticsService, navigationService, planFacade) {
        this.pharmacyFacade = pharmacyFacade;
        this.analyticsService = analyticsService;
        this.navigationService = navigationService;
        this.planFacade = planFacade;
        this.pageTags = PageTags;
        this.isSwitchToMail = false;
        this.hasMailOrder = false;
        this.linkRoles = LinkRoles;
    }
    ngOnInit() {
        if (this.plan) {
            this.hasMailOrder = this.plan.hasMailDrugBenefits;
            this.pharmacyFacade.switchMailOrder(false);
        }
    }
    ngOnDestroy() {
        this.pharmacyFacade.switchMailOrder(false);
    }
    get canSellPlan() {
        return this.planFacade.canSellPlan(this.plan);
    }
    toggleSwitchPharmacyLink() {
        if (!this.hasMailOrder) {
            return;
        }
        this.isSwitchToMail = !this.isSwitchToMail;
        this.pharmacyFacade.switchMailOrder(this.isSwitchToMail);
    }
    navigateByPageTag(pageTag) {
        if (pageTag === PageTags.GUIDED_HELP_PRESCRIPTIONS) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_DRUGS);
        }
        else if (pageTag === PageTags.GUIDED_HELP_PHARMACY_SEARCH) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_PHARMACY);
        }
        this.navigationService.navigateByPageTag(pageTag);
    }
}
PharmacySelectionComponent.ɵfac = function PharmacySelectionComponent_Factory(t) { return new (t || PharmacySelectionComponent)(i0.ɵɵdirectiveInject(PharmacyFacade), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(PlanFacade)); };
PharmacySelectionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PharmacySelectionComponent, selectors: [["vnext-plan-pharmacy-selection"]], inputs: { selectedPharmacy: "selectedPharmacy", costBasedOnRetailPharmacy: "costBasedOnRetailPharmacy", cantSellPlanCostBasedOnRetailPharmacy: "cantSellPlanCostBasedOnRetailPharmacy", costBasedOnSelectedPharmacy: "costBasedOnSelectedPharmacy", costBasedOnMailOrderPharmacy: "costBasedOnMailOrderPharmacy", cantSellPlanCostBasedOnMailOrderPharmacy: "cantSellPlanCostBasedOnMailOrderPharmacy", switchToMailLinkText: "switchToMailLinkText", switchToRetailLinkText: "switchToRetailLinkText", addPharmacyLink: "addPharmacyLink", editPharmacyLink: "editPharmacyLink", plan: "plan" }, decls: 16, vars: 14, consts: [[1, "pharmacy-selection", "Spa_Style_Gray1_Background"], [1, "row"], [1, "col-1"], [1, "Spa_Style_PharmacyIcon", "large-icon"], [1, "col-11", "m-auto"], [1, "col-12", "col-lg-6", "pl-2"], [1, "Spa_Style_Paragraph"], [4, "ngIf", "ngIfElse"], ["showPharmacyText", ""], ["class", "selected-pharmacy-name no-translate-block", 4, "ngIf"], [1, "col-12", "col-lg-6", "pl-2", "text-lg-right"], [1, "pharmacy-link", 3, "title", "alwaysUnderlined", "linkTarget", "hidden", "role", "click", "keyup.enter"], [4, "ngIf"], [1, "pharmacy-link", 3, "title", "alwaysUnderlined", "linkTarget", "role", "disabled", "click", "keyup.enter"], ["showRetailPharmacyText", ""], [1, "selected-pharmacy-name", "no-translate-block"]], template: function PharmacySelectionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵelement(3, "span", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4)(5, "div", 1)(6, "div", 5)(7, "div", 6);
        i0.ɵɵtemplate(8, PharmacySelectionComponent_ng_container_8_Template, 2, 1, "ng-container", 7);
        i0.ɵɵtemplate(9, PharmacySelectionComponent_ng_template_9_Template, 3, 2, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(11, PharmacySelectionComponent_span_11_Template, 2, 1, "span", 9);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(12, "div", 10)(13, "vnext-link", 11);
        i0.ɵɵlistener("click", function PharmacySelectionComponent_Template_vnext_link_click_13_listener() { return ctx.navigateByPageTag(ctx.pageTags.GUIDED_HELP_PHARMACY_SEARCH); })("keyup.enter", function PharmacySelectionComponent_Template_vnext_link_keyup_enter_13_listener() { return ctx.navigateByPageTag(ctx.pageTags.GUIDED_HELP_PHARMACY_SEARCH); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(14, PharmacySelectionComponent_ng_container_14_Template, 2, 0, "ng-container", 12);
        i0.ɵɵelementStart(15, "vnext-link", 13);
        i0.ɵɵlistener("click", function PharmacySelectionComponent_Template_vnext_link_click_15_listener() { return ctx.toggleSwitchPharmacyLink(); })("keyup.enter", function PharmacySelectionComponent_Template_vnext_link_keyup_enter_15_listener() { return ctx.toggleSwitchPharmacyLink(); });
        i0.ɵɵelementEnd()()()()()();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(10);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngIf", ctx.isSwitchToMail)("ngIfElse", _r1);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.isSwitchToMail && ctx.selectedPharmacy && ctx.canSellPlan);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("title", ctx.selectedPharmacy ? ctx.editPharmacyLink : ctx.addPharmacyLink)("alwaysUnderlined", true)("linkTarget", "_self")("hidden", ctx.isSwitchToMail)("role", ctx.linkRoles.LINK);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isSwitchToMail);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("title", !ctx.isSwitchToMail ? ctx.switchToMailLinkText : ctx.switchToRetailLinkText)("alwaysUnderlined", true)("linkTarget", "_self")("role", ctx.linkRoles.LINK)("disabled", !ctx.hasMailOrder);
    } }, dependencies: [i1$2.NgIf, LinkComponent], styles: [".pharmacy-selection[_ngcontent-%COMP%]{padding:10px;border-radius:5px}.pharmacy-link[_ngcontent-%COMP%]{display:inline-block}.selected-pharmacy-name[_ngcontent-%COMP%]{text-decoration:underline}.large-icon[_ngcontent-%COMP%]{font-size:28px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PharmacySelectionComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-pharmacy-selection', template: "<div class=\"pharmacy-selection Spa_Style_Gray1_Background\">\r\n  <div class=\"row\">\r\n    <div class=\"col-1\">\r\n      <span class=\"Spa_Style_PharmacyIcon large-icon\"></span>\r\n    </div>\r\n    <div class=\"col-11 m-auto\">\r\n      <div class=\"row\">\r\n        <div class=\"col-12 col-lg-6 pl-2\">\r\n          <div class=\"Spa_Style_Paragraph\">\r\n            <ng-container *ngIf=\"isSwitchToMail; else showPharmacyText\">\r\n              {{ canSellPlan ? costBasedOnMailOrderPharmacy : cantSellPlanCostBasedOnMailOrderPharmacy }}\r\n            </ng-container>\r\n            <ng-template #showPharmacyText>\r\n              <ng-container *ngIf=\"selectedPharmacy && canSellPlan; else showRetailPharmacyText\">\r\n                {{ costBasedOnSelectedPharmacy }}\r\n              </ng-container>\r\n              <ng-template #showRetailPharmacyText>\r\n                {{ canSellPlan ? costBasedOnRetailPharmacy : cantSellPlanCostBasedOnRetailPharmacy }}\r\n              </ng-template>\r\n            </ng-template>\r\n            <span *ngIf=\"!isSwitchToMail && selectedPharmacy && canSellPlan\" class=\"selected-pharmacy-name no-translate-block\">\r\n              {{ selectedPharmacy.name }}\r\n            </span>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-12 col-lg-6 pl-2 text-lg-right\">\r\n          <vnext-link\r\n            [title]=\"selectedPharmacy ? editPharmacyLink : addPharmacyLink\"\r\n            [alwaysUnderlined]=\"true\"\r\n            [linkTarget]=\"'_self'\"\r\n            class=\"pharmacy-link\"\r\n            [hidden]=\"isSwitchToMail\"\r\n            [role]=\"linkRoles.LINK\"\r\n            (click)=\"navigateByPageTag(pageTags.GUIDED_HELP_PHARMACY_SEARCH)\"\r\n            (keyup.enter)=\"navigateByPageTag(pageTags.GUIDED_HELP_PHARMACY_SEARCH)\"\r\n          >\r\n          </vnext-link>\r\n          <ng-container *ngIf=\"!isSwitchToMail\"> | </ng-container>\r\n          <vnext-link\r\n            [title]=\"!isSwitchToMail ? switchToMailLinkText : switchToRetailLinkText\"\r\n            [alwaysUnderlined]=\"true\"\r\n            [linkTarget]=\"'_self'\"\r\n            [role]=\"linkRoles.LINK\"\r\n            (click)=\"toggleSwitchPharmacyLink()\"\r\n            (keyup.enter)=\"toggleSwitchPharmacyLink()\"\r\n            class=\"pharmacy-link\"\r\n            [disabled]=\"!hasMailOrder\"\r\n          >\r\n          </vnext-link>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".pharmacy-selection{padding:10px;border-radius:5px}.pharmacy-link{display:inline-block}.selected-pharmacy-name{text-decoration:underline}.large-icon{font-size:28px}\n"] }]
    }], function () { return [{ type: PharmacyFacade }, { type: AnalyticsService }, { type: i1.NavigationService }, { type: PlanFacade }]; }, { selectedPharmacy: [{
            type: Input
        }], costBasedOnRetailPharmacy: [{
            type: Input
        }], cantSellPlanCostBasedOnRetailPharmacy: [{
            type: Input
        }], costBasedOnSelectedPharmacy: [{
            type: Input
        }], costBasedOnMailOrderPharmacy: [{
            type: Input
        }], cantSellPlanCostBasedOnMailOrderPharmacy: [{
            type: Input
        }], switchToMailLinkText: [{
            type: Input
        }], switchToRetailLinkText: [{
            type: Input
        }], addPharmacyLink: [{
            type: Input
        }], editPharmacyLink: [{
            type: Input
        }], plan: [{
            type: Input
        }] }); })();

function PrescriptionsTabComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "vnext-plan-pharmacy-selection", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", ctx_r0.plan)("selectedPharmacy", ctx_r0.selectedPharmacy)("costBasedOnRetailPharmacy", ctx_r0.costBasedOnRetailPharmacy)("cantSellPlanCostBasedOnRetailPharmacy", ctx_r0.cantSellPlanCostBasedOnRetailPharmacy)("costBasedOnMailOrderPharmacy", ctx_r0.costBasedOnMailOrderPharmacy)("cantSellPlanCostBasedOnMailOrderPharmacy", ctx_r0.cantSellPlanCostBasedOnMailOrderPharmacy)("costBasedOnSelectedPharmacy", ctx_r0.costBasedOnSelectedPharmacy)("switchToMailLinkText", ctx_r0.switchToMailLinkText)("switchToRetailLinkText", ctx_r0.switchToRetailLinkText)("addPharmacyLink", ctx_r0.addPharmacyLink)("editPharmacyLink", ctx_r0.editPharmacyLink);
} }
function PrescriptionsTabComponent_ng_container_4_h2_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r7.prescriptionNoCost);
} }
function PrescriptionsTabComponent_ng_container_4_p_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r8.prescriptionsTabIntro);
} }
function PrescriptionsTabComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 12)(2, "div", 13);
    i0.ɵɵtemplate(3, PrescriptionsTabComponent_ng_container_4_h2_3_Template, 2, 1, "h2", 14);
    i0.ɵɵtemplate(4, PrescriptionsTabComponent_ng_container_4_p_4_Template, 2, 1, "p", 15);
    i0.ɵɵelementStart(5, "button", 16);
    i0.ɵɵlistener("click", function PrescriptionsTabComponent_ng_container_4_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.openPrescriptions()); });
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", "Spa_PrescriptionsTab_NoCostTitle_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_PrescriptionsTab_Intro_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.addPrescriptionButton);
} }
function PrescriptionsTabComponent_ng_template_5_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelement(1, "div", 29);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 1, ctx_r11.prescriptionsDrugAlternativesInformationalText, "html"), i0.ɵɵsanitizeHtml);
} }
function PrescriptionsTabComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, PrescriptionsTabComponent_ng_template_5_div_0_Template, 3, 4, "div", 19);
    i0.ɵɵelementStart(1, "div", 20)(2, "div", 21)(3, "vnext-link", 22);
    i0.ɵɵlistener("click", function PrescriptionsTabComponent_ng_template_5_Template_vnext_link_click_3_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.openPrescriptions()); })("keyup.enter", function PrescriptionsTabComponent_ng_template_5_Template_vnext_link_keyup_enter_3_listener() { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.openPrescriptions()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div")(5, "h2", 23);
    i0.ɵɵelement(6, "i", 24);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(8, "vnext-drug-cost-details", 25);
    i0.ɵɵelementStart(9, "div", 26)(10, "h2", 23);
    i0.ɵɵelement(11, "i", 27);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "vnext-drug-cost-details", 28);
    i0.ɵɵlistener("viewPossibleAlternativeDrugs", function PrescriptionsTabComponent_ng_template_5_Template_vnext_drug_cost_details_viewPossibleAlternativeDrugs_13_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.onViewPossibleAlternativeDrugs($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r3.showDrugAlternativesInformationalText);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("keyNameForLiveEdit", "Spa_Prescription_Add_Edit_Link")("title", ctx_r3.prescriptionAddEditLinkTitle)("alwaysUnderlined", true)("linkTarget", "_self")("role", ctx_r3.linkRoles.LINK);
    i0.ɵɵattribute("aria-label", ctx_r3.addEditLinkDescription);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", ctx_r3.coveredPrescriptions, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("coveredTiers", ctx_r3.coveredDrugPlanTier)("noPrescriptionInTier", ctx_r3.noPrescriptionInTier)("isCovered", true)("medicineCabinet", ctx_r3.medicineCabinet)("plan", ctx_r3.plan)("showCosts", true)("isMailOrderSelected", ctx_r3.isMailOrderSelected)("showGenericOption", ctx_r3.showGenericOption)("selectedPharmacy", ctx_r3.selectedPharmacy);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", ctx_r3.nonCoveredPrescriptions, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("nonCoveredDrugCostDetails", ctx_r3.drugCostDetails)("noPrescriptionInTier", ctx_r3.noPrescriptionInTier)("isCovered", false)("medicineCabinet", ctx_r3.medicineCabinet)("showCosts", true)("plan", ctx_r3.plan)("showGenericOption", ctx_r3.showGenericOption)("selectedPharmacy", ctx_r3.selectedPharmacy)("isMailOrderSelected", ctx_r3.isMailOrderSelected)("isEnabledShowDrugAlternatives", ctx_r3.isEnabledShowDrugAlternatives)("prescriptionsDrugAlternativesButtonText", ctx_r3.prescriptionsDrugAlternativesButtonText)("pharmacies", ctx_r3.pharmacies);
} }
function PrescriptionsTabComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-non-covered-drug-alternatives-sub-details", 30);
    i0.ɵɵlistener("backToDefaultPrescriptionTab", function PrescriptionsTabComponent_ng_container_7_Template_vnext_non_covered_drug_alternatives_sub_details_backToDefaultPrescriptionTab_1_listener() { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.onBackToDefaultPrescriptionTab()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("backToPrescriptionLabelText", ctx_r4.backToPrescriptionLabelText)("hintAlternativesForCabinetHeaderText", ctx_r4.hintAlternativesForCabinetHeaderText)("hintAlternativesForCabinetText", ctx_r4.hintAlternativesForCabinetText)("hintNoAlternativesForCabinet", ctx_r4.hintNoAlternativesForCabinet)("drugCostsRetailCostText", ctx_r4.drugCostsRetailCostText)("conditionPrescribedForText", ctx_r4.conditionPrescribedForText)("noPrescriptionInTierText", ctx_r4.noPrescriptionInTier)("plan", ctx_r4.plan)("cabinet", ctx_r4.cabinetForAlternatives)("drugSearchFrequencies", ctx_r4.drugSearchFrequencies)("isMailOrder", ctx_r4.isMailOrderSelected)("selectedPharmacy", ctx_r4.selectedPharmacy)("drugListCardBrandText", ctx_r4.drugListCardBrandText)("drugListCardGenericText", ctx_r4.drugListCardGenericText)("changeMedicalConditionsEnabled", ctx_r4.changeMedicalConditionsEnabled)("footnoteIdsToShow", ctx_r4.footnoteIdsToShowForDrugAlternatives)("showGenericOption", ctx_r4.showGenericOption);
} }
function PrescriptionsTabComponent_vnext_footnote_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-footnote", 31);
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("footnoteIdsToShow", ctx_r5.footnoteIdsToShow)("footnoteHeader", ctx_r5.footnoteHeader)("footnotes", ctx_r5.footnotes);
} }
function PrescriptionsTabComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 32);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r6.faqContent ? i0.ɵɵpipeBind2(1, 1, ctx_r6.faqContent, "html") : "", i0.ɵɵsanitizeHtml);
} }
const _c0$Z = function (a0) { return { "d-none": a0 }; };
class PrescriptionsTabComponent {
    constructor(navigationService, pharmacyContext, drugCabinetContext, drugDetailsFacade, analyticsService, planDetailsFacade, guidedHelpModalContextService, cdr) {
        this.navigationService = navigationService;
        this.pharmacyContext = pharmacyContext;
        this.drugCabinetContext = drugCabinetContext;
        this.drugDetailsFacade = drugDetailsFacade;
        this.analyticsService = analyticsService;
        this.planDetailsFacade = planDetailsFacade;
        this.guidedHelpModalContextService = guidedHelpModalContextService;
        this.cdr = cdr;
        this.prescriptionTabView = PrescriptionTabViewMode.DEFAULT;
        this.pageTags = PageTags;
        this.planType = PlanType;
        this.prescriptionTabViewMode = PrescriptionTabViewMode;
        this.planTypeAbbreviation = PlanTypeAbbreviation;
        this.linkRoles = LinkRoles;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.cabinetDosages = this.medicineCabinet.map(p => p.dosage);
        this.coveredDrugPlanTier = this.getCoveredTiers();
        this.drugCostDetails = this.getNonCoveredTiers();
        if (this.isEnabledShowDrugAlternatives) {
            this.subscriptions.add(this.drugCabinetContext
                .getExtendedPlanWithDrugAlternatives$()
                .pipe(switchMap(extendedPlanWithDrugAlternatives => this.pharmacyContext.getFootnoteIdsToShow$(extendedPlanWithDrugAlternatives ?? this.plan)))
                .subscribe({
                next: footnoteIdsToShow => {
                    this.footnoteIdsToShow = footnoteIdsToShow;
                    this.cdr.markForCheck();
                }
            }));
        }
        else {
            this.subscriptions.add(this.pharmacyContext.getFootnoteIdsToShow$(this.plan).subscribe({
                next: footnoteIdsToShow => {
                    this.footnoteIdsToShow = footnoteIdsToShow;
                    this.cdr.markForCheck();
                }
            }));
        }
    }
    ngOnChanges(changes) {
        const { plan, isEnabledShowDrugAlternatives } = changes;
        if (changes.medicineCabinet &&
            !changes.medicineCabinet.firstChange &&
            changes.medicineCabinet.currentValue &&
            changes.medicineCabinet.previousValue !== changes.medicineCabinet.currentValue) {
            this.cabinetDosages = this.medicineCabinet.map(p => p.dosage);
        }
        if (changes.selectedPharmacy &&
            !changes.selectedPharmacy.firstChange &&
            changes.selectedPharmacy.previousValue !== changes.selectedPharmacy.currentValue) {
            this.coveredDrugPlanTier = this.getCoveredTiers();
            this.drugCostDetails = this.getNonCoveredTiers();
        }
        if (plan?.currentValue &&
            !_isEqual(plan.previousValue, plan.currentValue) &&
            isEnabledShowDrugAlternatives &&
            !_isEqual(isEnabledShowDrugAlternatives.previousValue, isEnabledShowDrugAlternatives.currentValue)) {
            this.showDrugAlternativesInformationalText =
                this.isEnabledShowDrugAlternatives && PLANS_WITH_ALTERNATIVE_DRUGS.includes(this.plan.planTypeAbbreviation);
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    navigateToAddPrescription() {
        this.navigationService.navigateByPageTag(PageTags.GUIDED_HELP_PRESCRIPTIONS);
    }
    navigateByPageTag(pageTag) {
        if (pageTag === PageTags.GUIDED_HELP_PRESCRIPTIONS) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_DRUGS);
        }
        else if (pageTag === PageTags.GUIDED_HELP_PHARMACY_SEARCH) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_PHARMACY);
        }
        this.navigationService.navigateByPageTag(pageTag);
    }
    tagsToUpdate() {
        return this.planDetailsFacade.tagsToUpdate(this.plan, this.noCostMedSupPlanText, this.isRetentionView, this.selectedTab, this.annualCost);
    }
    getAvailablePlanTiers() {
        return this.drugDetailsFacade.getCoveredPlanTiers(this.plan);
    }
    getCoveredTiers() {
        if (this.plan) {
            return this.drugDetailsFacade.getCoveredDrugsByTier(this.getAvailablePlanTiers(), this.cabinetDosages, this.drugDetailsFacade.getPlanRetailDrugCoverage(this.selectedPharmacy, this.plan));
        }
        return [];
    }
    getNonCoveredTiers() {
        return this.drugDetailsFacade.getNonCoveredDrugCostDetails(this.getAvailablePlanTiers(), this.cabinetDosages, this.drugDetailsFacade.getPlanRetailDrugCoverage(this.selectedPharmacy, this.plan));
    }
    onViewPossibleAlternativeDrugs(cabinet) {
        this.setAnalyticsForViewDrugAlternatives(this.plan, cabinet);
        this.drugCabinetContext.setDrugEntry(this.plan, cabinet);
        this.prescriptionTabView = this.prescriptionTabViewMode.ALTERNATIVES_OFF_FORMULARY_DRUGS;
        this.scrollToTop();
    }
    onBackToDefaultPrescriptionTab() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_DRUG_ALTERNATIVES_PREVIOUS_PAGE);
        this.prescriptionTabView = this.prescriptionTabViewMode.DEFAULT;
        this.drugCabinetContext.clearDrugEntry();
        this.drugCabinetContext.clearExtendedPlanWithDrugAlternatives();
        this.scrollToTop();
    }
    openPrescriptions() {
        if (this.preferencesBannerEnabled) {
            this.guidedHelpModalContextService.openGuidedHelpModal(PageTags.GUIDED_HELP_PRESCRIPTIONS);
        }
        else {
            this.navigateToAddPrescription();
        }
    }
    scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    setAnalyticsForViewDrugAlternatives(plan, cabinetEntry) {
        this.analyticsService.googleDataLayerTags = this.planDetailsFacade.getViewDrugAlternativesTag(plan, cabinetEntry, this.isMailOrderSelected);
    }
}
PrescriptionsTabComponent.ɵfac = function PrescriptionsTabComponent_Factory(t) { return new (t || PrescriptionsTabComponent)(i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(PharmacyContext), i0.ɵɵdirectiveInject(DrugCabinetContext), i0.ɵɵdirectiveInject(DrugDetailsFacade), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(PlanDetailsFacade), i0.ɵɵdirectiveInject(i1.GuidedHelpModalContextService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
PrescriptionsTabComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PrescriptionsTabComponent, selectors: [["vnext-plan-prescription-details"]], inputs: { preferencesBannerEnabled: "preferencesBannerEnabled", prescriptionAddEditLinkTitle: "prescriptionAddEditLinkTitle", prescriptionsTabIntro: "prescriptionsTabIntro", prescriptionNoCost: "prescriptionNoCost", addPrescriptionButton: "addPrescriptionButton", noPrescriptionInTier: "noPrescriptionInTier", nonCoveredPrescriptions: "nonCoveredPrescriptions", coveredPrescriptions: "coveredPrescriptions", isEnabledShowDrugAlternatives: "isEnabledShowDrugAlternatives", prescriptionsDrugAlternativesInformationalText: "prescriptionsDrugAlternativesInformationalText", prescriptionsDrugAlternativesButtonText: "prescriptionsDrugAlternativesButtonText", plan: "plan", medicineCabinet: "medicineCabinet", pharmacy: "pharmacy", showGenericOption: "showGenericOption", costBasedOnRetailPharmacy: "costBasedOnRetailPharmacy", cantSellPlanCostBasedOnRetailPharmacy: "cantSellPlanCostBasedOnRetailPharmacy", costBasedOnSelectedPharmacy: "costBasedOnSelectedPharmacy", costBasedOnMailOrderPharmacy: "costBasedOnMailOrderPharmacy", cantSellPlanCostBasedOnMailOrderPharmacy: "cantSellPlanCostBasedOnMailOrderPharmacy", switchToMailLinkText: "switchToMailLinkText", switchToRetailLinkText: "switchToRetailLinkText", addPharmacyLink: "addPharmacyLink", editPharmacyLink: "editPharmacyLink", formularyID: "formularyID", formularyVersionText: "formularyVersionText", footnotes: "footnotes", footnoteHeader: "footnoteHeader", showPharmacy: "showPharmacy", addEditLinkDescription: "addEditLinkDescription", selectedTab: "selectedTab", isRetentionView: "isRetentionView", noCostMedSupPlanText: "noCostMedSupPlanText", faqContent: "faqContent", prescriptionsDrugAlternativesFAQNode: "prescriptionsDrugAlternativesFAQNode", drugListCardBrandText: "drugListCardBrandText", drugListCardGenericText: "drugListCardGenericText", hideRetailMailOrderCost: "hideRetailMailOrderCost", annualCost: "annualCost", selectedPharmacy: "selectedPharmacy", prescriptionTabView: "prescriptionTabView", pharmacies: "pharmacies", isMailOrderSelected: "isMailOrderSelected", drugSearchFrequencies: "drugSearchFrequencies", backToPrescriptionLabelText: "backToPrescriptionLabelText", hintAlternativesForCabinetHeaderText: "hintAlternativesForCabinetHeaderText", hintAlternativesForCabinetText: "hintAlternativesForCabinetText", hintNoAlternativesForCabinet: "hintNoAlternativesForCabinet", drugCostsRetailCostText: "drugCostsRetailCostText", conditionPrescribedForText: "conditionPrescribedForText", changeMedicalConditionsEnabled: "changeMedicalConditionsEnabled", cabinetForAlternatives: "cabinetForAlternatives", footnoteIdsToShowForDrugAlternatives: "footnoteIdsToShowForDrugAlternatives" }, features: [i0.ɵɵNgOnChangesFeature], decls: 11, vars: 13, consts: [["vnextGoogleTagManager", "", 3, "tagsToUpdate"], [3, "ngClass"], ["class", "mb-5", 4, "ngIf"], [1, "row"], [4, "ngIf", "ngIfElse"], ["showDrugDetails", ""], [4, "ngIf"], [3, "footnoteIdsToShow", "footnoteHeader", "footnotes", 4, "ngIf"], [3, "plan", "formularyID", "formularyVersionText"], ["navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], [1, "mb-5"], [3, "plan", "selectedPharmacy", "costBasedOnRetailPharmacy", "cantSellPlanCostBasedOnRetailPharmacy", "costBasedOnMailOrderPharmacy", "cantSellPlanCostBasedOnMailOrderPharmacy", "costBasedOnSelectedPharmacy", "switchToMailLinkText", "switchToRetailLinkText", "addPharmacyLink", "editPharmacyLink"], [1, "col-12", "mt-5", "mb-4"], [1, "text-center"], ["class", "Spa_Style_H3", 4, "liveEditProp"], ["class", "Spa_Style_Paragraph", 4, "liveEditProp"], [1, "btn", "mb-2", "Spa_Style_PrimaryButton", 3, "click"], [1, "Spa_Style_H3"], [1, "Spa_Style_Paragraph"], ["class", "col-12", 4, "ngIf"], [1, "col-12"], [1, "text-right", "mb-2", "add-edit-link"], [3, "keyNameForLiveEdit", "title", "alwaysUnderlined", "linkTarget", "role", "click", "keyup.enter"], [1, "Spa_Style_H2"], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "covered-icon", "float-left", "mr-1"], [3, "coveredTiers", "noPrescriptionInTier", "isCovered", "medicineCabinet", "plan", "showCosts", "isMailOrderSelected", "showGenericOption", "selectedPharmacy"], [1, "mt-5"], ["aria-hidden", "true", 1, "fas", "Spa_Style_NonCoveredPrescriptions_Icon", "float-left", "mr-1"], [3, "nonCoveredDrugCostDetails", "noPrescriptionInTier", "isCovered", "medicineCabinet", "showCosts", "plan", "showGenericOption", "selectedPharmacy", "isMailOrderSelected", "isEnabledShowDrugAlternatives", "prescriptionsDrugAlternativesButtonText", "pharmacies", "viewPossibleAlternativeDrugs"], [1, "Spa_Style_Primary_Color", 3, "innerHTML"], [3, "backToPrescriptionLabelText", "hintAlternativesForCabinetHeaderText", "hintAlternativesForCabinetText", "hintNoAlternativesForCabinet", "drugCostsRetailCostText", "conditionPrescribedForText", "noPrescriptionInTierText", "plan", "cabinet", "drugSearchFrequencies", "isMailOrder", "selectedPharmacy", "drugListCardBrandText", "drugListCardGenericText", "changeMedicalConditionsEnabled", "footnoteIdsToShow", "showGenericOption", "backToDefaultPrescriptionTab"], [3, "footnoteIdsToShow", "footnoteHeader", "footnotes"], ["navigationAdapter", "", 3, "innerHTML"]], template: function PrescriptionsTabComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, PrescriptionsTabComponent_div_2_Template, 2, 11, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, PrescriptionsTabComponent_ng_container_4_Template, 7, 3, "ng-container", 4);
        i0.ɵɵtemplate(5, PrescriptionsTabComponent_ng_template_5_Template, 14, 30, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(7, PrescriptionsTabComponent_ng_container_7_Template, 2, 17, "ng-container", 6);
        i0.ɵɵtemplate(8, PrescriptionsTabComponent_vnext_footnote_8_Template, 1, 3, "vnext-footnote", 7);
        i0.ɵɵelement(9, "vnext-formulary-details", 8);
        i0.ɵɵtemplate(10, PrescriptionsTabComponent_div_10_Template, 2, 4, "div", 9);
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(6);
        i0.ɵɵproperty("tagsToUpdate", ctx.tagsToUpdate());
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c0$Z, ctx.prescriptionTabView !== ctx.prescriptionTabViewMode.DEFAULT));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showPharmacy && ctx.plan.planRetailDrugCoverageMultiPharmacy.length !== 0 && !ctx.hideRetailMailOrderCost);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.medicineCabinet.length === 0)("ngIfElse", _r2);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isEnabledShowDrugAlternatives && ctx.prescriptionTabView === ctx.prescriptionTabViewMode.ALTERNATIVES_OFF_FORMULARY_DRUGS && ctx.cabinetForAlternatives);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.footnoteIdsToShow == null ? null : ctx.footnoteIdsToShow.length) > 0 && ctx.plan.planType !== ctx.planType.MA);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("plan", ctx.plan)("formularyID", ctx.formularyID)("formularyVersionText", ctx.formularyVersionText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_Prescriptions_FAQ_Text");
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, LinkComponent, FootnoteComponent, NavigationAdapterDirective, LiveEditPropDirective, GoogleTagManagerDirective, IconAriaAttributesDirective, NonCoveredDrugAlternativesSubDetailsComponent, FormularyDetailsComponent, DrugCostDetailsComponent, PharmacySelectionComponent, SafePipe], styles: [".add-edit-link[_ngcontent-%COMP%]{float:left;width:100%;border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:5px 0;margin-bottom:10px}.icon-size[_ngcontent-%COMP%]{font-size:20px;margin-top:2px}.tier-description-text[_ngcontent-%COMP%]{font-weight:900}.covered-icon[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent5)}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], PrescriptionsTabComponent.prototype, "navigateToAddPrescription", null);
__decorate([
    LiveEditInactive()
], PrescriptionsTabComponent.prototype, "navigateByPageTag", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PrescriptionsTabComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-prescription-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div vnextGoogleTagManager [tagsToUpdate]=\"tagsToUpdate()\"></div>\r\n<div [ngClass]=\"{ 'd-none': prescriptionTabView !== prescriptionTabViewMode.DEFAULT }\">\r\n  <div class=\"mb-5\" *ngIf=\"showPharmacy && plan.planRetailDrugCoverageMultiPharmacy.length !== 0 && !hideRetailMailOrderCost\">\r\n    <vnext-plan-pharmacy-selection\r\n      [plan]=\"plan\"\r\n      [selectedPharmacy]=\"selectedPharmacy\"\r\n      [costBasedOnRetailPharmacy]=\"costBasedOnRetailPharmacy\"\r\n      [cantSellPlanCostBasedOnRetailPharmacy]=\"cantSellPlanCostBasedOnRetailPharmacy\"\r\n      [costBasedOnMailOrderPharmacy]=\"costBasedOnMailOrderPharmacy\"\r\n      [cantSellPlanCostBasedOnMailOrderPharmacy]=\"cantSellPlanCostBasedOnMailOrderPharmacy\"\r\n      [costBasedOnSelectedPharmacy]=\"costBasedOnSelectedPharmacy\"\r\n      [switchToMailLinkText]=\"switchToMailLinkText\"\r\n      [switchToRetailLinkText]=\"switchToRetailLinkText\"\r\n      [addPharmacyLink]=\"addPharmacyLink\"\r\n      [editPharmacyLink]=\"editPharmacyLink\"\r\n    ></vnext-plan-pharmacy-selection>\r\n  </div>\r\n  <div class=\"row\">\r\n    <ng-container *ngIf=\"medicineCabinet.length === 0; else showDrugDetails\">\r\n      <div class=\"col-12 mt-5 mb-4\">\r\n        <div class=\"text-center\">\r\n          <h2 class=\"Spa_Style_H3\" *liveEditProp=\"'Spa_PrescriptionsTab_NoCostTitle_Text'\">{{ prescriptionNoCost }}</h2>\r\n          <p class=\"Spa_Style_Paragraph\" *liveEditProp=\"'Spa_PrescriptionsTab_Intro_Text'\">{{ prescriptionsTabIntro }}</p>\r\n          <button class=\"btn mb-2 Spa_Style_PrimaryButton\" (click)=\"openPrescriptions()\">{{ addPrescriptionButton }}</button>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n    <ng-template #showDrugDetails>\r\n      <div class=\"col-12\" *ngIf=\"showDrugAlternativesInformationalText\">\r\n        <div class=\"Spa_Style_Primary_Color\" [innerHTML]=\"prescriptionsDrugAlternativesInformationalText | safe : 'html'\"></div>\r\n      </div>\r\n\r\n      <div class=\"col-12\">\r\n        <div class=\"text-right mb-2 add-edit-link\">\r\n          <vnext-link\r\n            [keyNameForLiveEdit]=\"'Spa_Prescription_Add_Edit_Link'\"\r\n            [title]=\"prescriptionAddEditLinkTitle\"\r\n            [alwaysUnderlined]=\"true\"\r\n            [linkTarget]=\"'_self'\"\r\n            (click)=\"openPrescriptions()\"\r\n            (keyup.enter)=\"openPrescriptions()\"\r\n            [attr.aria-label]=\"addEditLinkDescription\"\r\n            [role]=\"linkRoles.LINK\"\r\n          >\r\n          </vnext-link>\r\n        </div>\r\n        <div>\r\n          <h2 class=\"Spa_Style_H2\">\r\n            <i class=\"fas fa-check-circle covered-icon float-left mr-1\" aria-hidden=\"true\"></i>{{ coveredPrescriptions }}\r\n          </h2>\r\n        </div>\r\n        <!--Covered drugs section, no presciptions tag-->\r\n        <vnext-drug-cost-details\r\n          [coveredTiers]=\"coveredDrugPlanTier\"\r\n          [noPrescriptionInTier]=\"noPrescriptionInTier\"\r\n          [isCovered]=\"true\"\r\n          [medicineCabinet]=\"medicineCabinet\"\r\n          [plan]=\"plan\"\r\n          [showCosts]=\"true\"\r\n          [isMailOrderSelected]=\"isMailOrderSelected\"\r\n          [showGenericOption]=\"showGenericOption\"\r\n          [selectedPharmacy]=\"selectedPharmacy\"\r\n        ></vnext-drug-cost-details>\r\n\r\n        <div class=\"mt-5\">\r\n          <h2 class=\"Spa_Style_H2\">\r\n            <i class=\"fas Spa_Style_NonCoveredPrescriptions_Icon float-left mr-1\" aria-hidden=\"true\"></i>{{ nonCoveredPrescriptions }}\r\n          </h2>\r\n        </div>\r\n\r\n        <!--Nonovered drugs section (covered drugs), and no prescriptions tag-->\r\n        <vnext-drug-cost-details\r\n          [nonCoveredDrugCostDetails]=\"drugCostDetails\"\r\n          [noPrescriptionInTier]=\"noPrescriptionInTier\"\r\n          [isCovered]=\"false\"\r\n          [medicineCabinet]=\"medicineCabinet\"\r\n          [showCosts]=\"true\"\r\n          [plan]=\"plan\"\r\n          [showGenericOption]=\"showGenericOption\"\r\n          [selectedPharmacy]=\"selectedPharmacy\"\r\n          [isMailOrderSelected]=\"isMailOrderSelected\"\r\n          [isEnabledShowDrugAlternatives]=\"isEnabledShowDrugAlternatives\"\r\n          [prescriptionsDrugAlternativesButtonText]=\"prescriptionsDrugAlternativesButtonText\"\r\n          (viewPossibleAlternativeDrugs)=\"onViewPossibleAlternativeDrugs($event)\"\r\n          [pharmacies]=\"pharmacies\"\r\n        ></vnext-drug-cost-details>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n</div>\r\n\r\n<ng-container\r\n  *ngIf=\"\r\n    isEnabledShowDrugAlternatives &&\r\n    prescriptionTabView === prescriptionTabViewMode.ALTERNATIVES_OFF_FORMULARY_DRUGS &&\r\n    cabinetForAlternatives\r\n  \"\r\n>\r\n  <vnext-non-covered-drug-alternatives-sub-details\r\n    [backToPrescriptionLabelText]=\"backToPrescriptionLabelText\"\r\n    [hintAlternativesForCabinetHeaderText]=\"hintAlternativesForCabinetHeaderText\"\r\n    [hintAlternativesForCabinetText]=\"hintAlternativesForCabinetText\"\r\n    [hintNoAlternativesForCabinet]=\"hintNoAlternativesForCabinet\"\r\n    [drugCostsRetailCostText]=\"drugCostsRetailCostText\"\r\n    [conditionPrescribedForText]=\"conditionPrescribedForText\"\r\n    [noPrescriptionInTierText]=\"noPrescriptionInTier\"\r\n    [plan]=\"plan\"\r\n    [cabinet]=\"cabinetForAlternatives\"\r\n    [drugSearchFrequencies]=\"drugSearchFrequencies\"\r\n    [isMailOrder]=\"isMailOrderSelected\"\r\n    [selectedPharmacy]=\"selectedPharmacy\"\r\n    [drugListCardBrandText]=\"drugListCardBrandText\"\r\n    [drugListCardGenericText]=\"drugListCardGenericText\"\r\n    [changeMedicalConditionsEnabled]=\"changeMedicalConditionsEnabled\"\r\n    [footnoteIdsToShow]=\"footnoteIdsToShowForDrugAlternatives\"\r\n    [showGenericOption]=\"showGenericOption\"\r\n    (backToDefaultPrescriptionTab)=\"onBackToDefaultPrescriptionTab()\"\r\n  >\r\n  </vnext-non-covered-drug-alternatives-sub-details>\r\n</ng-container>\r\n\r\n<vnext-footnote\r\n  *ngIf=\"footnoteIdsToShow?.length > 0 && plan.planType !== planType.MA\"\r\n  [footnoteIdsToShow]=\"footnoteIdsToShow\"\r\n  [footnoteHeader]=\"footnoteHeader\"\r\n  [footnotes]=\"footnotes\"\r\n>\r\n</vnext-footnote>\r\n\r\n<vnext-formulary-details [plan]=\"plan\" [formularyID]=\"formularyID\" [formularyVersionText]=\"formularyVersionText\"></vnext-formulary-details>\r\n\r\n<div *liveEditProp=\"'Spa_Prescriptions_FAQ_Text'\" [innerHTML]=\"faqContent ? (faqContent | safe : 'html') : ''\" navigationAdapter></div>\r\n", styles: [".add-edit-link{float:left;width:100%;border-bottom:1px solid var(--static-Spa_Style_Accent1);padding:5px 0;margin-bottom:10px}.icon-size{font-size:20px;margin-top:2px}.tier-description-text{font-weight:900}.covered-icon{color:var(--static-Spa_Style_Accent5)}\n"] }]
    }], function () { return [{ type: i1.NavigationService }, { type: PharmacyContext }, { type: DrugCabinetContext }, { type: DrugDetailsFacade }, { type: AnalyticsService }, { type: PlanDetailsFacade }, { type: i1.GuidedHelpModalContextService }, { type: i0.ChangeDetectorRef }]; }, { preferencesBannerEnabled: [{
            type: Input
        }], prescriptionAddEditLinkTitle: [{
            type: Input
        }], prescriptionsTabIntro: [{
            type: Input
        }], prescriptionNoCost: [{
            type: Input
        }], addPrescriptionButton: [{
            type: Input
        }], noPrescriptionInTier: [{
            type: Input
        }], nonCoveredPrescriptions: [{
            type: Input
        }], coveredPrescriptions: [{
            type: Input
        }], isEnabledShowDrugAlternatives: [{
            type: Input
        }], prescriptionsDrugAlternativesInformationalText: [{
            type: Input
        }], prescriptionsDrugAlternativesButtonText: [{
            type: Input
        }], plan: [{
            type: Input
        }], medicineCabinet: [{
            type: Input
        }], pharmacy: [{
            type: Input
        }], showGenericOption: [{
            type: Input
        }], costBasedOnRetailPharmacy: [{
            type: Input
        }], cantSellPlanCostBasedOnRetailPharmacy: [{
            type: Input
        }], costBasedOnSelectedPharmacy: [{
            type: Input
        }], costBasedOnMailOrderPharmacy: [{
            type: Input
        }], cantSellPlanCostBasedOnMailOrderPharmacy: [{
            type: Input
        }], switchToMailLinkText: [{
            type: Input
        }], switchToRetailLinkText: [{
            type: Input
        }], addPharmacyLink: [{
            type: Input
        }], editPharmacyLink: [{
            type: Input
        }], formularyID: [{
            type: Input
        }], formularyVersionText: [{
            type: Input
        }], footnotes: [{
            type: Input
        }], footnoteHeader: [{
            type: Input
        }], showPharmacy: [{
            type: Input
        }], addEditLinkDescription: [{
            type: Input
        }], selectedTab: [{
            type: Input
        }], isRetentionView: [{
            type: Input
        }], noCostMedSupPlanText: [{
            type: Input
        }], faqContent: [{
            type: Input
        }], prescriptionsDrugAlternativesFAQNode: [{
            type: Input
        }], drugListCardBrandText: [{
            type: Input
        }], drugListCardGenericText: [{
            type: Input
        }], hideRetailMailOrderCost: [{
            type: Input
        }], annualCost: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], prescriptionTabView: [{
            type: Input
        }], pharmacies: [{
            type: Input
        }], isMailOrderSelected: [{
            type: Input
        }], drugSearchFrequencies: [{
            type: Input
        }], backToPrescriptionLabelText: [{
            type: Input
        }], hintAlternativesForCabinetHeaderText: [{
            type: Input
        }], hintAlternativesForCabinetText: [{
            type: Input
        }], hintNoAlternativesForCabinet: [{
            type: Input
        }], drugCostsRetailCostText: [{
            type: Input
        }], conditionPrescribedForText: [{
            type: Input
        }], changeMedicalConditionsEnabled: [{
            type: Input
        }], cabinetForAlternatives: [{
            type: Input
        }], footnoteIdsToShowForDrugAlternatives: [{
            type: Input
        }], navigateToAddPrescription: [], navigateByPageTag: [] }); })();

function PlanDetailsCostComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "i", 7);
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 8);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "currency");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const totalCostEquation_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(totalCostEquation_r1.label);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind4(6, 2, ctx_r0.getTotalCost(totalCostEquation_r1.title), "USD", "symbol", "1.2-2"), " ");
} }
class PlanDetailsCostComponent {
    getTotalCost(title) {
        if (title === 'drugCost' && this.monthlyCost.totalMonthlyDrugCostShare) {
            return this.monthlyCost.totalMonthlyDrugCostShare;
        }
        if (title === 'healthCost' && this.monthlyCost.totalMonthlyMedicalCostShare) {
            return this.monthlyCost.totalMonthlyMedicalCostShare;
        }
        if (title === 'premium') {
            return this.plan.medicalPremium + this.plan.drugPremium;
        }
        return 0;
    }
}
PlanDetailsCostComponent.ɵfac = function PlanDetailsCostComponent_Factory(t) { return new (t || PlanDetailsCostComponent)(); };
PlanDetailsCostComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanDetailsCostComponent, selectors: [["vnext-plan-details-cost-component"]], inputs: { monthlyCost: "monthlyCost", plan: "plan", totalCostDetails: "totalCostDetails", monthlyEstimatedCostText: "monthlyEstimatedCostText" }, decls: 9, vars: 8, consts: [["class", "col-md-auto cost-detail cost-section d-inline-block", 4, "ngFor", "ngForOf"], [1, "col-md-auto", "d-inline-block"], [1, "monthly-cost-section"], ["aria-hidden", "true", 1, "fas", "fa-equals", "cost-icon", "d-none", "d-md-block"], [1, "cost-label", "d-inline-block"], [1, "Spa_Style_Regular_Font", "Spa_Style_CostPremiumSmall", "cost", "Spa_Style_Bold_Weight"], [1, "col-md-auto", "cost-detail", "cost-section", "d-inline-block"], ["aria-hidden", "true", 1, "fas", "fa-plus", "cost-icon"], [1, "Spa_Style_Regular_Font", "cost", "Spa_Style_Bold_Weight"]], template: function PlanDetailsCostComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanDetailsCostComponent_div_0_Template, 7, 7, "div", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
        i0.ɵɵelement(3, "i", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵtext(7);
        i0.ɵɵpipe(8, "currency");
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.totalCostDetails);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.monthlyEstimatedCostText);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind4(8, 3, ctx.monthlyCost.totalMonthlyDrugCost + ctx.monthlyCost.totalMonthlyMedicalCost, "USD", "symbol", "1.2-2"), " ");
    } }, dependencies: [i1$2.NgForOf, IconAriaAttributesDirective, i1$2.CurrencyPipe], styles: [".cost-icon[_ngcontent-%COMP%]{float:left;margin:0 20px 0 0;height:45px;line-height:18px;font-size:10px}.cost-section[_ngcontent-%COMP%]:first-child   i.fas[_ngcontent-%COMP%]{visibility:hidden}@media (max-width: 768px){.monthly-breakdown[_ngcontent-%COMP%]{width:400px}.cost-label[_ngcontent-%COMP%]{width:140px;text-align:left}.cost[_ngcontent-%COMP%]{float:left;text-align:left;width:125px}.monthly-cost-section[_ngcontent-%COMP%]{border-top:1px solid var(--static-Spa_Style_Accent1);padding-top:10px;margin-left:29px}.cost-icon[_ngcontent-%COMP%]{height:30px}}@media (min-width: 992px){.cost-detail[_ngcontent-%COMP%]{width:25%}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanDetailsCostComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-details-cost-component', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"col-md-auto cost-detail cost-section d-inline-block\" *ngFor=\"let totalCostEquation of totalCostDetails\">\r\n  <i class=\"fas fa-plus cost-icon\" aria-hidden=\"true\"></i>\r\n  <div class=\"cost-label d-inline-block\">{{ totalCostEquation.label }}</div>\r\n  <div class=\"Spa_Style_Regular_Font cost Spa_Style_Bold_Weight\">\r\n    {{ getTotalCost(totalCostEquation.title) | currency : 'USD' : 'symbol' : '1.2-2' }}\r\n  </div>\r\n</div>\r\n<div class=\"col-md-auto d-inline-block\">\r\n  <div class=\"monthly-cost-section\">\r\n    <i class=\"fas fa-equals cost-icon d-none d-md-block\" aria-hidden=\"true\"></i>\r\n    <div class=\"cost-label d-inline-block\">{{ monthlyEstimatedCostText }}</div>\r\n    <div class=\"Spa_Style_Regular_Font Spa_Style_CostPremiumSmall cost Spa_Style_Bold_Weight\">\r\n      {{ monthlyCost.totalMonthlyDrugCost + monthlyCost.totalMonthlyMedicalCost | currency : 'USD' : 'symbol' : '1.2-2' }}\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".cost-icon{float:left;margin:0 20px 0 0;height:45px;line-height:18px;font-size:10px}.cost-section:first-child i.fas{visibility:hidden}@media (max-width: 768px){.monthly-breakdown{width:400px}.cost-label{width:140px;text-align:left}.cost{float:left;text-align:left;width:125px}.monthly-cost-section{border-top:1px solid var(--static-Spa_Style_Accent1);padding-top:10px;margin-left:29px}.cost-icon{height:30px}}@media (min-width: 992px){.cost-detail{width:25%}}\n"] }]
    }], null, { monthlyCost: [{
            type: Input
        }], plan: [{
            type: Input
        }], totalCostDetails: [{
            type: Input
        }], monthlyEstimatedCostText: [{
            type: Input
        }] }); })();

function MonthlyBreakdownCostComponent_div_0_div_1_div_12_sup_5_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const footnote_r6 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(footnote_r6);
} }
function MonthlyBreakdownCostComponent_div_0_div_1_div_12_sup_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "sup", 19);
    i0.ɵɵtemplate(1, MonthlyBreakdownCostComponent_div_0_div_1_div_12_sup_5_span_1_Template, 2, 1, "span", 20);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const drugInfo_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx_r4.pharmacyContext.getFootnoteIdsToShow$(ctx_r4.plan, drugInfo_r3.drugDosageID)));
} }
function MonthlyBreakdownCostComponent_div_0_div_1_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12)(2, "span", 13)(3, "span", 14);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, MonthlyBreakdownCostComponent_div_0_div_1_div_12_sup_5_Template, 3, 3, "sup", 15);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 16);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 17)(10, "div");
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 18)(13, "span");
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "currency");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const drugInfo_r3 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    let tmp_1_0;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(drugInfo_r3.drugName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ((tmp_1_0 = i0.ɵɵpipeBind1(6, 5, ctx_r2.pharmacyContext.getFootnoteIdsToShow$(ctx_r2.plan, drugInfo_r3.drugDosageID))) == null ? null : tmp_1_0.length) > 0);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.getPhaseText(drugInfo_r3.phase));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.getPhaseText(drugInfo_r3.phase));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind4(15, 7, drugInfo_r3.cost, "USD", "symbol", "1.2-2"));
} }
function MonthlyBreakdownCostComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "div", 5)(3, "div", 6)(4, "div", 7);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 8)(7, "div", 7);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 9)(10, "div", 7);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵtemplate(12, MonthlyBreakdownCostComponent_div_0_div_1_div_12_Template, 16, 12, "div", 10);
    i0.ɵɵpipe(13, "orderBy");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r1.monthlyBreakdownDrugLabelText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.monthlyBreakdownDrugPhaseLabelText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.monthlyBreakdownDrugCostLabelText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind4(13, 4, ctx_r1.drugCostInformation, "fullPrice", false, true));
} }
function MonthlyBreakdownCostComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, MonthlyBreakdownCostComponent_div_0_div_1_Template, 14, 9, "div", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.drugCostInformation);
} }
class MonthlyBreakdownCostComponent {
    constructor(pharmacyContext) {
        this.pharmacyContext = pharmacyContext;
        this.planType = PlanType;
    }
    getPhaseText(apiPhaseText) {
        return apiPhaseText
            .replace(DrugPhaseIds.COPAY, this.monthlyBreakdownCopay)
            .replace(DrugPhaseIds.GAP, this.monthlyBreakdownGap)
            .replace(DrugPhaseIds.CATASTROPHIC, this.monthlyBreakdownCatastrophic)
            .replace(DrugPhaseIds.DEDUCTIBLE, this.monthlyBreakdownDeductible);
    }
}
MonthlyBreakdownCostComponent.ɵfac = function MonthlyBreakdownCostComponent_Factory(t) { return new (t || MonthlyBreakdownCostComponent)(i0.ɵɵdirectiveInject(PharmacyContext)); };
MonthlyBreakdownCostComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MonthlyBreakdownCostComponent, selectors: [["vnext-monthly-breakdown-cost"]], inputs: { plan: "plan", drugCostInformation: "drugCostInformation", monthlyBreakdownDeductible: "monthlyBreakdownDeductible", monthlyBreakdownCopay: "monthlyBreakdownCopay", monthlyBreakdownGap: "monthlyBreakdownGap", monthlyBreakdownCatastrophic: "monthlyBreakdownCatastrophic", monthlyBreakdownDrugLabelText: "monthlyBreakdownDrugLabelText", monthlyBreakdownDrugPhaseLabelText: "monthlyBreakdownDrugPhaseLabelText", monthlyBreakdownDrugCostLabelText: "monthlyBreakdownDrugCostLabelText" }, decls: 1, vars: 1, consts: [["class", "m-3", 4, "ngIf"], [1, "m-3"], ["class", "mt-5 mb-3 Spa_Style_Small_Font", 4, "ngIf"], [1, "mt-5", "mb-3", "Spa_Style_Small_Font"], [1, "drug-label", "pb-2", "Spa_Style_Semi_Bold_Weight"], [1, "row", "drug-label-header"], [1, "col-5"], [1, "label"], [1, "col-3", "d-none", "d-sm-block"], [1, "col-4", "text-right"], ["class", "row monthly-breakdown Spa_Style_Small_Font pb-2 pt-2", 4, "ngFor", "ngForOf"], [1, "row", "monthly-breakdown", "Spa_Style_Small_Font", "pb-2", "pt-2"], [1, "col-5", "Spa_Style_Smaller_Font"], [1, "medicine-cabinet-drug-info"], [1, "no-translate-block"], ["class", "Spa_Style_Note medicine-cabinet-footnote", 4, "ngIf"], [1, "d-sm-none"], [1, "col-3", "d-none", "d-sm-block", "Spa_Style_Light_Weight"], [1, "col-4", "text-right", "Spa_Style_Regular_Font", "Spa_Style_Bold_Weight"], [1, "Spa_Style_Note", "medicine-cabinet-footnote"], ["class", "pl-1", 4, "ngFor", "ngForOf"], [1, "pl-1"]], template: function MonthlyBreakdownCostComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MonthlyBreakdownCostComponent_div_0_Template, 2, 1, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.plan.planType === 1 || ctx.plan.planType === 2);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, i1$2.AsyncPipe, i1$2.CurrencyPipe, OrderPipe], styles: [".drug-label-header[_ngcontent-%COMP%], .monthly-breakdown[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Accent1)}.monthly-breakdown[_ngcontent-%COMP%]:last-child{border-bottom:none}.medicine-cabinet-drug-info[_ngcontent-%COMP%]{position:relative}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MonthlyBreakdownCostComponent, [{
        type: Component,
        args: [{ selector: 'vnext-monthly-breakdown-cost', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"m-3\" *ngIf=\"plan.planType === 1 || plan.planType === 2\">\r\n  <div class=\"mt-5 mb-3 Spa_Style_Small_Font\" *ngIf=\"drugCostInformation\">\r\n    <div class=\"drug-label pb-2 Spa_Style_Semi_Bold_Weight\">\r\n      <div class=\"row drug-label-header\">\r\n        <div class=\"col-5\">\r\n          <div class=\"label\">{{ monthlyBreakdownDrugLabelText }}</div>\r\n        </div>\r\n        <div class=\"col-3 d-none d-sm-block\">\r\n          <div class=\"label\">{{ monthlyBreakdownDrugPhaseLabelText }}</div>\r\n        </div>\r\n        <div class=\"col-4 text-right\">\r\n          <div class=\"label\">{{ monthlyBreakdownDrugCostLabelText }}</div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div\r\n      class=\"row monthly-breakdown Spa_Style_Small_Font pb-2 pt-2\"\r\n      *ngFor=\"let drugInfo of drugCostInformation | orderBy : 'fullPrice' : false : true\"\r\n    >\r\n      <div class=\"col-5 Spa_Style_Smaller_Font\">\r\n        <span class=\"medicine-cabinet-drug-info\">\r\n          <span class=\"no-translate-block\">{{ drugInfo.drugName }}</span>\r\n          <sup\r\n            class=\"Spa_Style_Note medicine-cabinet-footnote\"\r\n            *ngIf=\"(pharmacyContext.getFootnoteIdsToShow$(plan, drugInfo.drugDosageID) | async)?.length > 0\"\r\n          >\r\n            <span class=\"pl-1\" *ngFor=\"let footnote of pharmacyContext.getFootnoteIdsToShow$(plan, drugInfo.drugDosageID) | async\">{{\r\n              footnote\r\n            }}</span>\r\n          </sup>\r\n        </span>\r\n        <div class=\"d-sm-none\">{{ getPhaseText(drugInfo.phase) }}</div>\r\n      </div>\r\n      <div class=\"col-3 d-none d-sm-block Spa_Style_Light_Weight\">\r\n        <div>{{ getPhaseText(drugInfo.phase) }}</div>\r\n      </div>\r\n      <div class=\"col-4 text-right Spa_Style_Regular_Font Spa_Style_Bold_Weight\">\r\n        <span>{{ drugInfo.cost | currency : 'USD' : 'symbol' : '1.2-2' }}</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".drug-label-header,.monthly-breakdown{border-bottom:1px solid var(--static-Spa_Style_Accent1)}.monthly-breakdown:last-child{border-bottom:none}.medicine-cabinet-drug-info{position:relative}\n"] }]
    }], function () { return [{ type: PharmacyContext }]; }, { plan: [{
            type: Input
        }], drugCostInformation: [{
            type: Input
        }], monthlyBreakdownDeductible: [{
            type: Input
        }], monthlyBreakdownCopay: [{
            type: Input
        }], monthlyBreakdownGap: [{
            type: Input
        }], monthlyBreakdownCatastrophic: [{
            type: Input
        }], monthlyBreakdownDrugLabelText: [{
            type: Input
        }], monthlyBreakdownDrugPhaseLabelText: [{
            type: Input
        }], monthlyBreakdownDrugCostLabelText: [{
            type: Input
        }] }); })();

function TotalCostsTabComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelement(1, "vnext-plan-pharmacy-selection", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", ctx_r0.plan)("selectedPharmacy", ctx_r0.selectedPharmacy)("costBasedOnRetailPharmacy", ctx_r0.costBasedOnRetailPharmacy)("cantSellPlanCostBasedOnRetailPharmacy", ctx_r0.cantSellPlanCostBasedOnRetailPharmacy)("costBasedOnMailOrderPharmacy", ctx_r0.costBasedOnMailOrderPharmacy)("cantSellPlanCostBasedOnMailOrderPharmacy", ctx_r0.cantSellPlanCostBasedOnMailOrderPharmacy)("costBasedOnSelectedPharmacy", ctx_r0.costBasedOnSelectedPharmacy)("switchToMailLinkText", ctx_r0.switchToMailLinkText)("switchToRetailLinkText", ctx_r0.switchToRetailLinkText)("addPharmacyLink", ctx_r0.addPharmacyLink)("editPharmacyLink", ctx_r0.editPharmacyLink);
} }
function TotalCostsTabComponent_p_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.totalCostDescriptionText);
} }
function TotalCostsTabComponent_div_12_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-link", 17);
    i0.ɵɵlistener("click", function TotalCostsTabComponent_div_12_div_1_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r9.openGuidedHelp(ctx_r9.pageTags.GUIDED_HELP_PRESCRIPTIONS)); })("keyup.enter", function TotalCostsTabComponent_div_12_div_1_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.openGuidedHelp(ctx_r11.pageTags.GUIDED_HELP_PRESCRIPTIONS)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("keyNameForLiveEdit", "Spa_Prescription_Add_Edit_Link")("title", ctx_r8.prescriptionAddEditLinkTitle)("alwaysUnderlined", true)("linkTarget", "_self")("role", ctx_r8.linkRoles.LINK)("customClass", "Spa_Style_Link width-fit-content");
    i0.ɵɵattribute("aria-label", ctx_r8.addEditLinkDescription);
} }
function TotalCostsTabComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, TotalCostsTabComponent_div_12_div_1_Template, 2, 7, "div", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.guidedHelpEnabled && ctx_r2.showPrescription);
} }
function TotalCostsTabComponent_ng_container_13_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function TotalCostsTabComponent_ng_container_13_button_13_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r16); const value_r14 = restoredCtx.$implicit; const ctx_r15 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r15.updateDropdownSelection(value_r14)); })("keyup.enter", function TotalCostsTabComponent_ng_container_13_button_13_Template_button_keyup_enter_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r16); const value_r14 = restoredCtx.$implicit; const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.updateDropdownSelection(value_r14)); });
    i0.ɵɵelementStart(1, "span", 22);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const value_r14 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(value_r14);
} }
function TotalCostsTabComponent_ng_container_13_div_14_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" - ", ctx_r18.getMonthLabels(ctx_r18.selectedMonthIndex), "");
} }
function TotalCostsTabComponent_ng_container_13_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29)(1, "div", 30)(2, "h2", 31)(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, TotalCostsTabComponent_ng_container_13_div_14_span_5_Template, 2, 1, "span", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 32);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "currency");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(9, "hr", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r13.getMonthLabels(1));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.selectedMonthIndex > 1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind4(8, 3, ctx_r13.defaultCost, "USD", "symbol", "1.0-0"));
} }
function TotalCostsTabComponent_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 18)(2, "span", 19);
    i0.ɵɵtext(3, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 20)(6, "button", 21)(7, "span", 22);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "i", 23);
    i0.ɵɵelementStart(10, "span", 24);
    i0.ɵɵtext(11, "Expand");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 25);
    i0.ɵɵtemplate(13, TotalCostsTabComponent_ng_container_13_button_13_Template, 3, 1, "button", 26);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(14, TotalCostsTabComponent_ng_container_13_div_14_Template, 10, 8, "div", 27);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.effectiveDateLabel, "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r3.selectedValue);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r3.effectiveDateDropDownItems);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.selectedMonthIndex !== 0);
} }
function TotalCostsTabComponent_div_14_div_1_ng_template_4_h2_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 45);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r21 = i0.ɵɵnextContext(2).index;
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r25.getMonthLabels(i_r21 + ctx_r25.selectedMonthIndex + 1), " ");
} }
function TotalCostsTabComponent_div_14_div_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, TotalCostsTabComponent_div_14_div_1_ng_template_4_h2_0_Template, 2, 1, "h2", 42);
    i0.ɵɵelementStart(1, "span", 32);
    i0.ɵɵelement(2, "i", 43);
    i0.ɵɵelementStart(3, "span", 24);
    i0.ɵɵtext(4, "Collapse");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "span", 44);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext();
    const i_r21 = ctx_r27.index;
    const monthlyCost_r20 = ctx_r27.$implicit;
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("liveEditProp", ctx_r23.getMonthResourceName(i_r21 + ctx_r23.selectedMonthIndex + 1));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind4(7, 2, (monthlyCost_r20 == null ? null : monthlyCost_r20.totalMonthlyDrugCost) + (monthlyCost_r20 == null ? null : monthlyCost_r20.totalMonthlyMedicalCost), "USD", "symbol", "1.2-2"));
} }
function TotalCostsTabComponent_div_14_div_1_ng_template_5_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-details-cost-component", 50);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const monthlyCost_r20 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("monthlyCost", monthlyCost_r20)("totalCostDetails", ctx_r28.totalCostEquationMAPD)("plan", ctx_r28.plan)("monthlyEstimatedCostText", ctx_r28.planMonthlyEstimatedCostText);
} }
function TotalCostsTabComponent_div_14_div_1_ng_template_5_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-details-cost-component", 50);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const monthlyCost_r20 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r29 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("monthlyCost", monthlyCost_r20)("totalCostDetails", ctx_r29.totalCostEquationMA)("plan", ctx_r29.plan)("monthlyEstimatedCostText", ctx_r29.planMonthlyEstimatedCostText);
} }
function TotalCostsTabComponent_div_14_div_1_ng_template_5_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-details-cost-component", 50);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const monthlyCost_r20 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r30 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("monthlyCost", monthlyCost_r20)("totalCostDetails", ctx_r30.totalCostEquationPDP)("plan", ctx_r30.plan)("monthlyEstimatedCostText", ctx_r30.planMonthlyEstimatedCostText);
} }
function TotalCostsTabComponent_div_14_div_1_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46)(1, "div", 47);
    i0.ɵɵtemplate(2, TotalCostsTabComponent_div_14_div_1_ng_template_5_div_2_Template, 2, 4, "div", 48);
    i0.ɵɵtemplate(3, TotalCostsTabComponent_div_14_div_1_ng_template_5_div_3_Template, 2, 4, "div", 48);
    i0.ɵɵtemplate(4, TotalCostsTabComponent_div_14_div_1_ng_template_5_div_4_Template, 2, 4, "div", 48);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(5, "vnext-monthly-breakdown-cost", 49);
} if (rf & 2) {
    const monthlyCost_r20 = i0.ɵɵnextContext().$implicit;
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r24.plan.planType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r24.planType.MAPD);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r24.planType.MA);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r24.planType.PDP);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", ctx_r24.plan)("drugCostInformation", monthlyCost_r20.drugCostInformation)("monthlyBreakdownDeductible", ctx_r24.monthlyBreakdownDeductible)("monthlyBreakdownCopay", ctx_r24.monthlyBreakdownCopay)("monthlyBreakdownGap", ctx_r24.monthlyBreakdownGap)("monthlyBreakdownCatastrophic", ctx_r24.monthlyBreakdownCatastrophic)("monthlyBreakdownDrugLabelText", ctx_r24.monthlyBreakdownDrugLabelText)("monthlyBreakdownDrugPhaseLabelText", ctx_r24.monthlyBreakdownDrugPhaseLabelText)("monthlyBreakdownDrugCostLabelText", ctx_r24.monthlyBreakdownDrugCostLabelText);
} }
function TotalCostsTabComponent_div_14_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 36)(1, "ngb-accordion", 37, 38);
    i0.ɵɵlistener("panelChange", function TotalCostsTabComponent_div_14_div_1_Template_ngb_accordion_panelChange_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r36); const monthlyCost_r20 = restoredCtx.$implicit; const ctx_r35 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r35.toggleAccordian($event, monthlyCost_r20)); });
    i0.ɵɵelementStart(3, "ngb-panel", 39);
    i0.ɵɵtemplate(4, TotalCostsTabComponent_div_14_div_1_ng_template_4_Template, 8, 7, "ng-template", 40);
    i0.ɵɵtemplate(5, TotalCostsTabComponent_div_14_div_1_ng_template_5_Template, 6, 13, "ng-template", 41);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const i_r21 = ctx.index;
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "monthly-cost-", i_r21, "");
} }
function TotalCostsTabComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵtemplate(1, TotalCostsTabComponent_div_14_div_1_Template, 6, 1, "div", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("mt-0", ctx_r4.pharmacyContext.isTotalCostByEffectiveDateEnabled && ctx_r4.selectedMonthIndex !== 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.monthlyCosts);
} }
function TotalCostsTabComponent_vnext_footnote_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-footnote", 51);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("footnoteIdsToShow", i0.ɵɵpipeBind1(1, 3, ctx_r5.pharmacyContext.getFootnoteIdsToShow$(ctx_r5.plan)))("footnoteHeader", ctx_r5.footnoteHeader)("footnotes", ctx_r5.footnotes);
} }
function TotalCostsTabComponent_vnext_formulary_details_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-formulary-details", 52);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("plan", ctx_r6.plan)("formularyID", ctx_r6.formularyID)("formularyVersionText", ctx_r6.formularyVersionText);
} }
function TotalCostsTabComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 53);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r7.faqContent, "html"), i0.ɵɵsanitizeHtml);
} }
class TotalCostsTabComponent {
    constructor(pharmacyContext, pharmacyFacade, analyticsService, navigationService, planDetailsFacade, spinnerService, guidedHelpModalContextService, planFacade) {
        this.pharmacyContext = pharmacyContext;
        this.pharmacyFacade = pharmacyFacade;
        this.analyticsService = analyticsService;
        this.navigationService = navigationService;
        this.planDetailsFacade = planDetailsFacade;
        this.spinnerService = spinnerService;
        this.guidedHelpModalContextService = guidedHelpModalContextService;
        this.planFacade = planFacade;
        this.selectedMonthIndex = 0;
        this.defaultCost = 0;
        this.pageTags = PageTags;
        this.planType = PlanType;
        this.linkRoles = LinkRoles;
        this.monthResourceNames = [
            'Spa_Site_Total_Est_Cost_Month_1',
            'Spa_Site_Total_Est_Cost_Month_2',
            'Spa_Site_Total_Est_Cost_Month_3',
            'Spa_Site_Total_Est_Cost_Month_4',
            'Spa_Site_Total_Est_Cost_Month_5',
            'Spa_Site_Total_Est_Cost_Month_6',
            'Spa_Site_Total_Est_Cost_Month_7',
            'Spa_Site_Total_Est_Cost_Month_8',
            'Spa_Site_Total_Est_Cost_Month_9',
            'Spa_Site_Total_Est_Cost_Month_10',
            'Spa_Site_Total_Est_Cost_Month_11',
            'Spa_Site_Total_Est_Cost_Month_12'
        ];
        this.monthlyCosts = [];
    }
    ngOnChanges(changes) {
        const { plan, annualCost, isMailOrder } = changes;
        if ((plan &&
            isMailOrder &&
            (isMailOrder?.previousValue !== isMailOrder?.currentValue || !_isEqual(plan?.previousValue, plan?.currentValue))) ||
            (annualCost && !_isEqual(annualCost.previousValue, annualCost.currentValue))) {
            this.monthlyCosts = this.getMonthlyCost(plan?.currentValue, isMailOrder?.currentValue);
        }
    }
    async updateDropdownSelection(value) {
        this.spinnerService.show(SpinnerEvent.PLANS_LOADING);
        this.selectedValue = value;
        // We need a valid ISO 8601 formatted date for constructing dates in IE11. e.g. 2021-10T00:00:00
        const date = await this.planDetailsFacade.convertAndUpdateValueFromDropdown(value);
        this.selectedMonthIndex = date.getMonth();
        this.planFacade.updateIsTotalEstimatedCostAnnuallyStatus(this.selectedMonthIndex);
    }
    /**
     * Look up the resource name for the given month index, assuming a 1-based index
     * @param month the 1 based index of the month to look up the resource name for (ie 1 - January, 2 - February)
     */
    getMonthResourceName(month) {
        return this.monthResourceNames[month - 1];
    }
    getMonthLabels(i) {
        const monthlabel = this.totalEstimatedAnnualCostsMonth.find(monthlyCost => monthlyCost.month === i);
        if (monthlabel) {
            return monthlabel.value;
        }
    }
    getMailOrderCost(plan) {
        return plan?.planAnnualMailOrderCost?.annualCostMultiPharmacy?.[0] ?? {};
    }
    getTotalEstimateCost(plan, isMailOrder) {
        if (isMailOrder) {
            const annualMailOrderCost = this.getMailOrderCost(plan);
            return annualMailOrderCost?.totalEstimatedCost ?? 0;
        }
        if (this.annualCost) {
            return this.annualCost.totalEstimatedCost;
        }
        return 0;
    }
    toggleAccordian(props, monthlyCost) {
        if (props.nextState) {
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLANS_EXPAND_COST_BREAKDOWN,
                [DataLayerGlobalVariable.PLANS_COST_MONTH]: (monthlyCost.totalMonthlyDrugCost + monthlyCost.totalMonthlyMedicalCost)
                    .toFixed(2)
                    .toString()
            };
        }
    }
    navigateByPageTag(pageTag) {
        if (pageTag === PageTags.GUIDED_HELP_PRESCRIPTIONS) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_DRUGS);
        }
        else if (pageTag === PageTags.GUIDED_HELP_PHARMACY_SEARCH) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_PHARMACY);
        }
        this.navigationService.navigateByPageTag(pageTag);
    }
    openGuidedHelp(pageTag) {
        if (this.preferencesBannerEnabled) {
            this.guidedHelpModalContextService.openGuidedHelpModal(pageTag);
        }
        else {
            this.navigationService.navigateByPageTag(pageTag);
        }
    }
    tagsToUpdate() {
        return this.planDetailsFacade.tagsToUpdate(this.plan, this.noCostMedSupPlanText, this.isRetentionView, this.selectedTab, this.annualCost);
    }
    getMonthlyCost(plan, isMailOrder) {
        let monthlyCosts = [];
        if (plan && isMailOrder) {
            const annualMailOrderCost = this.getMailOrderCost(plan);
            monthlyCosts = annualMailOrderCost?.monthlyCosts ?? [];
        }
        else if (this.annualCost) {
            monthlyCosts = this.annualCost.monthlyCosts;
        }
        return monthlyCosts;
    }
}
TotalCostsTabComponent.ɵfac = function TotalCostsTabComponent_Factory(t) { return new (t || TotalCostsTabComponent)(i0.ɵɵdirectiveInject(PharmacyContext), i0.ɵɵdirectiveInject(PharmacyFacade), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(PlanDetailsFacade), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i1.GuidedHelpModalContextService), i0.ɵɵdirectiveInject(PlanFacade)); };
TotalCostsTabComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TotalCostsTabComponent, selectors: [["vnext-total-costs-details"]], inputs: { preferencesBannerEnabled: "preferencesBannerEnabled", totalCostDescriptionText: "totalCostDescriptionText", totalEstAnnualCostText: "totalEstAnnualCostText", plan: "plan", totalEstimatedAnnualCostsMonth: "totalEstimatedAnnualCostsMonth", formularyID: "formularyID", formularyVersionText: "formularyVersionText", faqContent: "faqContent", prescriptionAddEditLinkTitle: "prescriptionAddEditLinkTitle", guidedHelpEnabled: "guidedHelpEnabled", showPrescription: "showPrescription", totalCostEquationMA: "totalCostEquationMA", totalCostEquationMAPD: "totalCostEquationMAPD", totalCostEquationPDP: "totalCostEquationPDP", monthlyBreakdownDeductible: "monthlyBreakdownDeductible", monthlyBreakdownCopay: "monthlyBreakdownCopay", monthlyBreakdownGap: "monthlyBreakdownGap", monthlyBreakdownCatastrophic: "monthlyBreakdownCatastrophic", footnotes: "footnotes", footnoteHeader: "footnoteHeader", isMailOrder: "isMailOrder", keyNameForLiveEdit: "keyNameForLiveEdit", costBasedOnRetailPharmacy: "costBasedOnRetailPharmacy", cantSellPlanCostBasedOnRetailPharmacy: "cantSellPlanCostBasedOnRetailPharmacy", costBasedOnSelectedPharmacy: "costBasedOnSelectedPharmacy", costBasedOnMailOrderPharmacy: "costBasedOnMailOrderPharmacy", cantSellPlanCostBasedOnMailOrderPharmacy: "cantSellPlanCostBasedOnMailOrderPharmacy", switchToMailLinkText: "switchToMailLinkText", switchToRetailLinkText: "switchToRetailLinkText", addPharmacyLink: "addPharmacyLink", editPharmacyLink: "editPharmacyLink", showPharmacy: "showPharmacy", selectedPharmacy: "selectedPharmacy", addEditLinkDescription: "addEditLinkDescription", selectedTab: "selectedTab", isRetentionView: "isRetentionView", noCostMedSupPlanText: "noCostMedSupPlanText", planMonthlyEstimatedCostText: "planMonthlyEstimatedCostText", monthlyBreakdownDrugLabelText: "monthlyBreakdownDrugLabelText", monthlyBreakdownDrugPhaseLabelText: "monthlyBreakdownDrugPhaseLabelText", monthlyBreakdownDrugCostLabelText: "monthlyBreakdownDrugCostLabelText", hideRetailMailOrderCost: "hideRetailMailOrderCost", annualCost: "annualCost", effectiveDateLabel: "effectiveDateLabel", totalEstCostText: "totalEstCostText", effectiveDateDropDownItems: "effectiveDateDropDownItems", selectedValue: "selectedValue", selectedMonthIndex: "selectedMonthIndex" }, features: [i0.ɵɵNgOnChangesFeature], decls: 19, vars: 22, consts: [["vnextGoogleTagManager", "", 3, "tagsToUpdate"], ["class", "mb-5", 4, "ngIf"], [1, "description-text"], ["class", "Spa_Style_Paragraph", 4, "liveEditProp"], [1, "mt-4", "mb-4", "total-cost-section", "Spa_Style_Cost_Background"], [1, "Spa_Style_H3", "align-text-bottom", "total-cost-section-label", "mb-0"], [1, "ml-4", "Spa_Style_Semi_Bold_Weight", "Spa_Style_Largest_Font", "Spa_Style_Cost_Text_Color"], ["class", "text-left mb-2 add-edit-link", 4, "ngIf"], [4, "ngIf"], ["class", "monthwise-cost-list Spa_Style_Primary_Color", 3, "mt-0", 4, "ngIf"], [3, "footnoteIdsToShow", "footnoteHeader", "footnotes", 4, "ngIf"], [3, "plan", "formularyID", "formularyVersionText", 4, "ngIf"], ["navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], [1, "mb-5"], [3, "plan", "selectedPharmacy", "costBasedOnRetailPharmacy", "cantSellPlanCostBasedOnRetailPharmacy", "costBasedOnMailOrderPharmacy", "cantSellPlanCostBasedOnMailOrderPharmacy", "costBasedOnSelectedPharmacy", "switchToMailLinkText", "switchToRetailLinkText", "addPharmacyLink", "editPharmacyLink"], [1, "Spa_Style_Paragraph"], [1, "text-left", "mb-2", "add-edit-link"], [3, "keyNameForLiveEdit", "title", "alwaysUnderlined", "linkTarget", "role", "customClass", "click", "keyup.enter"], ["id", "effectiveDateDropDownLabel", 1, "Spa_Style_Label", "pt-3"], [1, "input-error-asterisk"], ["ngbDropdown", ""], ["id", "effectiveDateDropDown", "role", "combobox", "aria-labelledby", "effectiveDateDropDownLabel effectiveDateDropDown", "ngbDropdownToggle", "", 1, "btn", "effective-date-width"], [1, "Spa_Style_Primary_Color"], [1, "fa", "fa-angle-down", "float-right"], [1, "sr-only"], ["ngbDropdownMenu", "", "aria-labelledby", "effectiveDateDropDown"], ["ngbDropdownItem", "", 3, "click", "keyup.enter", 4, "ngFor", "ngForOf"], ["class", "pt-4", 4, "ngIf"], ["ngbDropdownItem", "", 3, "click", "keyup.enter"], [1, "pt-4"], [1, "disabled-month", "Spa_Style_Accent1_Color", "Spa_Style_H3"], [1, "float-left", "Spa_Style_Large_Font", "mb-0"], [1, "float-right"], [1, "mt-4", "mb-0"], [1, "monthwise-cost-list", "Spa_Style_Primary_Color"], ["class", "list-unstyled mb-0 pb-3", 4, "ngFor", "ngForOf"], [1, "list-unstyled", "mb-0", "pb-3"], ["activeIds", "monthly-cost-0", 3, "panelChange"], ["acc", "ngbAccordion"], [3, "id"], ["ngbPanelTitle", ""], ["ngbPanelContent", ""], ["class", "Spa_Style_H3 float-left mb-0", 4, "liveEditProp"], [1, "pl-3", "Spa_Style_Primary_Color", "fas", "fa-chevron-up"], [1, "ml-4", "Spa_Style_CostPremiumSmall", "float-right"], [1, "Spa_Style_H3", "float-left", "mb-0"], [1, "row", "justify-content-lg-center", "monthly-breakdown", "Spa_Style_Small_Font"], [1, "w-100", 3, "ngSwitch"], [4, "ngSwitchCase"], [3, "plan", "drugCostInformation", "monthlyBreakdownDeductible", "monthlyBreakdownCopay", "monthlyBreakdownGap", "monthlyBreakdownCatastrophic", "monthlyBreakdownDrugLabelText", "monthlyBreakdownDrugPhaseLabelText", "monthlyBreakdownDrugCostLabelText"], [3, "monthlyCost", "totalCostDetails", "plan", "monthlyEstimatedCostText"], [3, "footnoteIdsToShow", "footnoteHeader", "footnotes"], [3, "plan", "formularyID", "formularyVersionText"], ["navigationAdapter", "", 3, "innerHTML"]], template: function TotalCostsTabComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "div", 0);
        i0.ɵɵtemplate(1, TotalCostsTabComponent_div_1_Template, 2, 11, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, TotalCostsTabComponent_p_3_Template, 2, 1, "p", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4)(5, "h2", 5);
        i0.ɵɵtext(6);
        i0.ɵɵpipe(7, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "span", 6);
        i0.ɵɵtext(9);
        i0.ɵɵpipe(10, "currency");
        i0.ɵɵpipe(11, "async");
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(12, TotalCostsTabComponent_div_12_Template, 2, 1, "div", 7);
        i0.ɵɵtemplate(13, TotalCostsTabComponent_ng_container_13_Template, 15, 4, "ng-container", 8);
        i0.ɵɵtemplate(14, TotalCostsTabComponent_div_14_Template, 2, 3, "div", 9);
        i0.ɵɵtemplate(15, TotalCostsTabComponent_vnext_footnote_15_Template, 2, 5, "vnext-footnote", 10);
        i0.ɵɵpipe(16, "async");
        i0.ɵɵtemplate(17, TotalCostsTabComponent_vnext_formulary_details_17_Template, 1, 3, "vnext-formulary-details", 11);
        i0.ɵɵtemplate(18, TotalCostsTabComponent_div_18_Template, 2, 4, "div", 12);
    } if (rf & 2) {
        let tmp_8_0;
        i0.ɵɵproperty("tagsToUpdate", ctx.tagsToUpdate());
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showPharmacy && ctx.plan.planRetailDrugCoverageMultiPharmacy.length !== 0 && !ctx.hideRetailMailOrderCost);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", ctx.keyNameForLiveEdit);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 11, ctx.planFacade.isTotalEstimatedCostAnnually$()) ? ctx.totalEstAnnualCostText : ctx.totalEstCostText, " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind4(10, 13, ctx.getTotalEstimateCost(ctx.plan, i0.ɵɵpipeBind1(11, 18, ctx.pharmacyFacade.mailOrder$)), "USD", "symbol", "1.0-0"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.plan.planType === 1 || ctx.plan.planType === 2);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.pharmacyContext.isTotalCostByEffectiveDateEnabled && (ctx.effectiveDateDropDownItems == null ? null : ctx.effectiveDateDropDownItems.length) > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.plan == null ? null : ctx.plan.planAnnualCost == null ? null : ctx.plan.planAnnualCost.annualCost == null ? null : ctx.plan.planAnnualCost.annualCost.monthlyCosts);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ((tmp_8_0 = i0.ɵɵpipeBind1(16, 20, ctx.pharmacyContext.getFootnoteIdsToShow$(ctx.plan))) == null ? null : tmp_8_0.length) > 0 && ctx.plan.planType !== ctx.planType.MA);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.plan.formularyExternalId);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_Total_Cost_FAQ_Text");
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, LinkComponent, FootnoteComponent, NavigationAdapterDirective, LiveEditPropDirective, GoogleTagManagerDirective, IconAriaAttributesDirective, i1$1.NgbAccordion, i1$1.NgbPanel, i1$1.NgbPanelTitle, i1$1.NgbPanelContent, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem, FormularyDetailsComponent, PlanDetailsCostComponent, PharmacySelectionComponent, MonthlyBreakdownCostComponent, i1$2.AsyncPipe, i1$2.CurrencyPipe, SafePipe], styles: [".total-cost-section[_ngcontent-%COMP%]{padding:10px 15px;border-radius:5px;text-align:right;margin-bottom:30px}.total-cost-section-label[_ngcontent-%COMP%]{display:inline;margin:0}.monthwise-cost-list[_ngcontent-%COMP%]{margin-top:30px}.monthwise-cost-list[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{margin-top:10px;border-bottom:1px solid var(--static-Spa_Style_Accent1)}.monthly-breakdown[_ngcontent-%COMP%]{text-align:center;padding-top:15px}.cost-icon[_ngcontent-%COMP%]{float:left;margin:0 20px 0 0;height:45px;line-height:18px;font-size:10px}.cost-label[_ngcontent-%COMP%]{float:left}.dropdown-toggle[_ngcontent-%COMP%]{line-height:18px;padding:8px 11px;box-shadow:inset 0 1px 1px #00000013;display:flex;justify-content:space-between;cursor:pointer;-webkit-user-select:none;user-select:none;border-width:1px;border-style:solid;border-color:var(--static-Spa_Style_Accent1);border-radius:5px;height:36px}.dropdown-item[_ngcontent-%COMP%]{cursor:pointer;-webkit-user-select:none;user-select:none}.dropdown-item[_ngcontent-%COMP%]:hover, .dropdown-item[_ngcontent-%COMP%]:focus, .dropdown-item[_ngcontent-%COMP%]:active{background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}.dropdown-toggle[_ngcontent-%COMP%] > .fa[_ngcontent-%COMP%]{padding-top:3px}.dropdown-toggle[_ngcontent-%COMP%]:after{content:none}.effective-date-width[_ngcontent-%COMP%]{width:220px}.disabled-month[_ngcontent-%COMP%]{padding:6px 28px 6px 12px}@media (max-width: 480px){.total-cost-section[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:block}}@media (max-width: 768px){.description-text[_ngcontent-%COMP%]{margin-top:15px}.monthly-breakdown[_ngcontent-%COMP%]{width:400px}.premium-label[_ngcontent-%COMP%]{margin-left:29px;margin-bottom:10px}.cost-label[_ngcontent-%COMP%], .premium-label[_ngcontent-%COMP%]{width:140px;float:left;text-align:left}.cost[_ngcontent-%COMP%]{float:left;text-align:left;width:125px}.cost-icon[_ngcontent-%COMP%]{height:30px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TotalCostsTabComponent, [{
        type: Component,
        args: [{ selector: 'vnext-total-costs-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div vnextGoogleTagManager [tagsToUpdate]=\"tagsToUpdate()\"></div>\r\n<div class=\"mb-5\" *ngIf=\"showPharmacy && plan.planRetailDrugCoverageMultiPharmacy.length !== 0 && !hideRetailMailOrderCost\">\r\n  <vnext-plan-pharmacy-selection\r\n    [plan]=\"plan\"\r\n    [selectedPharmacy]=\"selectedPharmacy\"\r\n    [costBasedOnRetailPharmacy]=\"costBasedOnRetailPharmacy\"\r\n    [cantSellPlanCostBasedOnRetailPharmacy]=\"cantSellPlanCostBasedOnRetailPharmacy\"\r\n    [costBasedOnMailOrderPharmacy]=\"costBasedOnMailOrderPharmacy\"\r\n    [cantSellPlanCostBasedOnMailOrderPharmacy]=\"cantSellPlanCostBasedOnMailOrderPharmacy\"\r\n    [costBasedOnSelectedPharmacy]=\"costBasedOnSelectedPharmacy\"\r\n    [switchToMailLinkText]=\"switchToMailLinkText\"\r\n    [switchToRetailLinkText]=\"switchToRetailLinkText\"\r\n    [addPharmacyLink]=\"addPharmacyLink\"\r\n    [editPharmacyLink]=\"editPharmacyLink\"\r\n  ></vnext-plan-pharmacy-selection>\r\n</div>\r\n<div class=\"description-text\">\r\n  <p class=\"Spa_Style_Paragraph\" *liveEditProp=\"keyNameForLiveEdit\">{{ totalCostDescriptionText }}</p>\r\n</div>\r\n<div class=\"mt-4 mb-4 total-cost-section Spa_Style_Cost_Background\">\r\n  <h2 class=\"Spa_Style_H3 align-text-bottom total-cost-section-label mb-0\">\r\n    {{ (planFacade.isTotalEstimatedCostAnnually$() | async) ? totalEstAnnualCostText : totalEstCostText }}\r\n  </h2>\r\n  <span class=\"ml-4 Spa_Style_Semi_Bold_Weight Spa_Style_Largest_Font Spa_Style_Cost_Text_Color\">\r\n    {{ getTotalEstimateCost(plan, pharmacyFacade.mailOrder$ | async) | currency : 'USD' : 'symbol' : '1.0-0' }}\r\n  </span>\r\n</div>\r\n<div class=\"text-left mb-2 add-edit-link\" *ngIf=\"plan.planType === 1 || plan.planType === 2\">\r\n  <div *ngIf=\"guidedHelpEnabled && showPrescription\">\r\n    <vnext-link\r\n      [keyNameForLiveEdit]=\"'Spa_Prescription_Add_Edit_Link'\"\r\n      [title]=\"prescriptionAddEditLinkTitle\"\r\n      [alwaysUnderlined]=\"true\"\r\n      [linkTarget]=\"'_self'\"\r\n      (click)=\"openGuidedHelp(pageTags.GUIDED_HELP_PRESCRIPTIONS)\"\r\n      (keyup.enter)=\"openGuidedHelp(pageTags.GUIDED_HELP_PRESCRIPTIONS)\"\r\n      [attr.aria-label]=\"addEditLinkDescription\"\r\n      [role]=\"linkRoles.LINK\"\r\n      [customClass]=\"'Spa_Style_Link width-fit-content'\"\r\n    >\r\n    </vnext-link>\r\n  </div>\r\n</div>\r\n<ng-container *ngIf=\"pharmacyContext.isTotalCostByEffectiveDateEnabled && effectiveDateDropDownItems?.length > 0\">\r\n  <label class=\"Spa_Style_Label pt-3\" id=\"effectiveDateDropDownLabel\"\r\n    ><span class=\"input-error-asterisk\">*</span> {{ effectiveDateLabel }}</label\r\n  >\r\n  <div ngbDropdown>\r\n    <button\r\n      class=\"btn effective-date-width\"\r\n      id=\"effectiveDateDropDown\"\r\n      role=\"combobox\"\r\n      aria-labelledby=\"effectiveDateDropDownLabel effectiveDateDropDown\"\r\n      ngbDropdownToggle\r\n    >\r\n      <span class=\"Spa_Style_Primary_Color\">{{ selectedValue }}</span>\r\n      <i class=\"fa fa-angle-down float-right\"></i>\r\n      <span class=\"sr-only\">Expand</span>\r\n    </button>\r\n    <div ngbDropdownMenu aria-labelledby=\"effectiveDateDropDown\">\r\n      <button\r\n        *ngFor=\"let value of effectiveDateDropDownItems\"\r\n        ngbDropdownItem\r\n        (click)=\"updateDropdownSelection(value)\"\r\n        (keyup.enter)=\"updateDropdownSelection(value)\"\r\n      >\r\n        <span class=\"Spa_Style_Primary_Color\">{{ value }}</span>\r\n      </button>\r\n    </div>\r\n  </div>\r\n  <div class=\"pt-4\" *ngIf=\"selectedMonthIndex !== 0\">\r\n    <div class=\"disabled-month Spa_Style_Accent1_Color Spa_Style_H3\">\r\n      <h2 class=\"float-left Spa_Style_Large_Font mb-0\">\r\n        <span>{{ getMonthLabels(1) }}</span>\r\n        <span *ngIf=\"selectedMonthIndex > 1\"> - {{ getMonthLabels(selectedMonthIndex) }}</span>\r\n      </h2>\r\n      <span class=\"float-right\">{{ defaultCost | currency : 'USD' : 'symbol' : '1.0-0' }}</span>\r\n    </div>\r\n    <hr class=\"mt-4 mb-0\" />\r\n  </div>\r\n</ng-container>\r\n<div\r\n  class=\"monthwise-cost-list Spa_Style_Primary_Color\"\r\n  [class.mt-0]=\"pharmacyContext.isTotalCostByEffectiveDateEnabled && selectedMonthIndex !== 0\"\r\n  *ngIf=\"plan?.planAnnualCost?.annualCost?.monthlyCosts\"\r\n>\r\n  <div class=\"list-unstyled mb-0 pb-3\" *ngFor=\"let monthlyCost of monthlyCosts; index as i\">\r\n    <ngb-accordion (panelChange)=\"toggleAccordian($event, monthlyCost)\" #acc=\"ngbAccordion\" activeIds=\"monthly-cost-0\">\r\n      <ngb-panel id=\"monthly-cost-{{ i }}\">\r\n        <ng-template ngbPanelTitle>\r\n          <h2 class=\"Spa_Style_H3 float-left mb-0\" *liveEditProp=\"getMonthResourceName(i + selectedMonthIndex + 1)\">\r\n            {{ getMonthLabels(i + selectedMonthIndex + 1) }}\r\n          </h2>\r\n          <span class=\"float-right\"\r\n            ><i class=\"pl-3 Spa_Style_Primary_Color fas fa-chevron-up\"></i><span class=\"sr-only\">Collapse</span></span\r\n          >\r\n          <span class=\"ml-4 Spa_Style_CostPremiumSmall float-right\">{{\r\n            monthlyCost?.totalMonthlyDrugCost + monthlyCost?.totalMonthlyMedicalCost | currency : 'USD' : 'symbol' : '1.2-2'\r\n          }}</span>\r\n        </ng-template>\r\n        <ng-template ngbPanelContent>\r\n          <div class=\"row justify-content-lg-center monthly-breakdown Spa_Style_Small_Font\">\r\n            <div [ngSwitch]=\"plan.planType\" class=\"w-100\">\r\n              <div *ngSwitchCase=\"planType.MAPD\">\r\n                <vnext-plan-details-cost-component\r\n                  [monthlyCost]=\"monthlyCost\"\r\n                  [totalCostDetails]=\"totalCostEquationMAPD\"\r\n                  [plan]=\"plan\"\r\n                  [monthlyEstimatedCostText]=\"planMonthlyEstimatedCostText\"\r\n                ></vnext-plan-details-cost-component>\r\n              </div>\r\n              <div *ngSwitchCase=\"planType.MA\">\r\n                <vnext-plan-details-cost-component\r\n                  [monthlyCost]=\"monthlyCost\"\r\n                  [totalCostDetails]=\"totalCostEquationMA\"\r\n                  [plan]=\"plan\"\r\n                  [monthlyEstimatedCostText]=\"planMonthlyEstimatedCostText\"\r\n                ></vnext-plan-details-cost-component>\r\n              </div>\r\n              <div *ngSwitchCase=\"planType.PDP\">\r\n                <vnext-plan-details-cost-component\r\n                  [monthlyCost]=\"monthlyCost\"\r\n                  [totalCostDetails]=\"totalCostEquationPDP\"\r\n                  [plan]=\"plan\"\r\n                  [monthlyEstimatedCostText]=\"planMonthlyEstimatedCostText\"\r\n                ></vnext-plan-details-cost-component>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <vnext-monthly-breakdown-cost\r\n            [plan]=\"plan\"\r\n            [drugCostInformation]=\"monthlyCost.drugCostInformation\"\r\n            [monthlyBreakdownDeductible]=\"monthlyBreakdownDeductible\"\r\n            [monthlyBreakdownCopay]=\"monthlyBreakdownCopay\"\r\n            [monthlyBreakdownGap]=\"monthlyBreakdownGap\"\r\n            [monthlyBreakdownCatastrophic]=\"monthlyBreakdownCatastrophic\"\r\n            [monthlyBreakdownDrugLabelText]=\"monthlyBreakdownDrugLabelText\"\r\n            [monthlyBreakdownDrugPhaseLabelText]=\"monthlyBreakdownDrugPhaseLabelText\"\r\n            [monthlyBreakdownDrugCostLabelText]=\"monthlyBreakdownDrugCostLabelText\"\r\n          >\r\n          </vnext-monthly-breakdown-cost>\r\n        </ng-template>\r\n      </ngb-panel>\r\n    </ngb-accordion>\r\n  </div>\r\n</div>\r\n\r\n<vnext-footnote\r\n  *ngIf=\"(pharmacyContext.getFootnoteIdsToShow$(plan) | async)?.length > 0 && plan.planType !== planType.MA\"\r\n  [footnoteIdsToShow]=\"pharmacyContext.getFootnoteIdsToShow$(plan) | async\"\r\n  [footnoteHeader]=\"footnoteHeader\"\r\n  [footnotes]=\"footnotes\"\r\n>\r\n</vnext-footnote>\r\n\r\n<vnext-formulary-details\r\n  [plan]=\"plan\"\r\n  *ngIf=\"plan.formularyExternalId\"\r\n  [formularyID]=\"formularyID\"\r\n  [formularyVersionText]=\"formularyVersionText\"\r\n></vnext-formulary-details>\r\n\r\n<div *liveEditProp=\"'Spa_Total_Cost_FAQ_Text'\" [innerHTML]=\"faqContent | safe : 'html'\" navigationAdapter></div>\r\n", styles: [".total-cost-section{padding:10px 15px;border-radius:5px;text-align:right;margin-bottom:30px}.total-cost-section-label{display:inline;margin:0}.monthwise-cost-list{margin-top:30px}.monthwise-cost-list ul li{margin-top:10px;border-bottom:1px solid var(--static-Spa_Style_Accent1)}.monthly-breakdown{text-align:center;padding-top:15px}.cost-icon{float:left;margin:0 20px 0 0;height:45px;line-height:18px;font-size:10px}.cost-label{float:left}.dropdown-toggle{line-height:18px;padding:8px 11px;box-shadow:inset 0 1px 1px #00000013;display:flex;justify-content:space-between;cursor:pointer;-webkit-user-select:none;user-select:none;border-width:1px;border-style:solid;border-color:var(--static-Spa_Style_Accent1);border-radius:5px;height:36px}.dropdown-item{cursor:pointer;-webkit-user-select:none;user-select:none}.dropdown-item:hover,.dropdown-item:focus,.dropdown-item:active{background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}.dropdown-toggle>.fa{padding-top:3px}.dropdown-toggle:after{content:none}.effective-date-width{width:220px}.disabled-month{padding:6px 28px 6px 12px}@media (max-width: 480px){.total-cost-section span{display:block}}@media (max-width: 768px){.description-text{margin-top:15px}.monthly-breakdown{width:400px}.premium-label{margin-left:29px;margin-bottom:10px}.cost-label,.premium-label{width:140px;float:left;text-align:left}.cost{float:left;text-align:left;width:125px}.cost-icon{height:30px}}\n"] }]
    }], function () { return [{ type: PharmacyContext }, { type: PharmacyFacade }, { type: AnalyticsService }, { type: i1.NavigationService }, { type: PlanDetailsFacade }, { type: i1.SpinnerService }, { type: i1.GuidedHelpModalContextService }, { type: PlanFacade }]; }, { preferencesBannerEnabled: [{
            type: Input
        }], totalCostDescriptionText: [{
            type: Input
        }], totalEstAnnualCostText: [{
            type: Input
        }], plan: [{
            type: Input
        }], totalEstimatedAnnualCostsMonth: [{
            type: Input
        }], formularyID: [{
            type: Input
        }], formularyVersionText: [{
            type: Input
        }], faqContent: [{
            type: Input
        }], prescriptionAddEditLinkTitle: [{
            type: Input
        }], guidedHelpEnabled: [{
            type: Input
        }], showPrescription: [{
            type: Input
        }], totalCostEquationMA: [{
            type: Input
        }], totalCostEquationMAPD: [{
            type: Input
        }], totalCostEquationPDP: [{
            type: Input
        }], monthlyBreakdownDeductible: [{
            type: Input
        }], monthlyBreakdownCopay: [{
            type: Input
        }], monthlyBreakdownGap: [{
            type: Input
        }], monthlyBreakdownCatastrophic: [{
            type: Input
        }], footnotes: [{
            type: Input
        }], footnoteHeader: [{
            type: Input
        }], isMailOrder: [{
            type: Input
        }], keyNameForLiveEdit: [{
            type: Input
        }], costBasedOnRetailPharmacy: [{
            type: Input
        }], cantSellPlanCostBasedOnRetailPharmacy: [{
            type: Input
        }], costBasedOnSelectedPharmacy: [{
            type: Input
        }], costBasedOnMailOrderPharmacy: [{
            type: Input
        }], cantSellPlanCostBasedOnMailOrderPharmacy: [{
            type: Input
        }], switchToMailLinkText: [{
            type: Input
        }], switchToRetailLinkText: [{
            type: Input
        }], addPharmacyLink: [{
            type: Input
        }], editPharmacyLink: [{
            type: Input
        }], showPharmacy: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], addEditLinkDescription: [{
            type: Input
        }], selectedTab: [{
            type: Input
        }], isRetentionView: [{
            type: Input
        }], noCostMedSupPlanText: [{
            type: Input
        }], planMonthlyEstimatedCostText: [{
            type: Input
        }], monthlyBreakdownDrugLabelText: [{
            type: Input
        }], monthlyBreakdownDrugPhaseLabelText: [{
            type: Input
        }], monthlyBreakdownDrugCostLabelText: [{
            type: Input
        }], hideRetailMailOrderCost: [{
            type: Input
        }], annualCost: [{
            type: Input
        }], effectiveDateLabel: [{
            type: Input
        }], totalEstCostText: [{
            type: Input
        }], effectiveDateDropDownItems: [{
            type: Input
        }], selectedValue: [{
            type: Input
        }], selectedMonthIndex: [{
            type: Input
        }] }); })();

function PharmacySelectorComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.pharmacySelectorText);
} }
function PharmacySelectorComponent_button_7_ng_container_5_ng_container_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", ctx_r10.preferredInNetworkText, ")");
} }
function PharmacySelectorComponent_button_7_ng_container_5_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", ctx_r12.standardInNetworkText, ")");
} }
function PharmacySelectorComponent_button_7_ng_container_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PharmacySelectorComponent_button_7_ng_container_5_ng_container_1_span_1_Template, 2, 1, "span", 16);
    i0.ɵɵtemplate(2, PharmacySelectorComponent_button_7_ng_container_5_ng_container_1_ng_template_2_Template, 2, 1, "ng-template", null, 17, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r11 = i0.ɵɵreference(3);
    const pharmacy_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", pharmacy_r4.isPreferred)("ngIfElse", _r11);
} }
function PharmacySelectorComponent_button_7_ng_container_5_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", ctx_r9.outOfNetworkText, ")");
} }
function PharmacySelectorComponent_button_7_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PharmacySelectorComponent_button_7_ng_container_5_ng_container_1_Template, 4, 2, "ng-container", 14);
    i0.ɵɵtemplate(2, PharmacySelectorComponent_button_7_ng_container_5_ng_template_2_Template, 2, 1, "ng-template", null, 15, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r8 = i0.ɵɵreference(3);
    const pharmacy_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", pharmacy_r4.isInNetwork)("ngIfElse", _r8);
} }
const _c0$Y = function (a0, a1) { return { "Spa_Style_SecondaryButtonSelected Spa_Style_Bold_Weight toggle-option-selected": a0, "Spa_Style_SecondaryButton Spa_Style_Regular_Weight": a1 }; };
const _c1$j = function (a0) { return { Spa_Style_Paragraph: a0 }; };
function PharmacySelectorComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10, 11);
    i0.ɵɵlistener("click", function PharmacySelectorComponent_button_7_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r16); const pharmacy_r4 = restoredCtx.$implicit; const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.onSelectedPharmacy(pharmacy_r4)); });
    i0.ɵɵelementStart(2, "span", 12)(3, "span", 13);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, PharmacySelectorComponent_button_7_ng_container_5_Template, 4, 2, "ng-container", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const pharmacy_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c0$Y, !ctx_r1.isMailOrderSelected && ctx_r1.selectedPharmacy.nabp === pharmacy_r4.nabp, ctx_r1.isMailOrderSelected || ctx_r1.selectedPharmacy.nabp !== pharmacy_r4.nabp));
    i0.ɵɵattribute("aria-checked", !ctx_r1.isMailOrderSelected && ctx_r1.selectedPharmacy.nabp === pharmacy_r4.nabp ? "true" : "false");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c1$j, ctx_r1.isMailOrderSelected || ctx_r1.selectedPharmacy.nabp !== pharmacy_r4.nabp));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(pharmacy_r4 == null ? null : pharmacy_r4.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showPlanNetwork);
} }
function PharmacySelectorComponent_button_8_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 18);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("(", ctx_r18.notCoveredText, ")");
} }
const _c2$d = function (a0, a1) { return { "Spa_Style_SecondaryButtonSelected Spa_Style_Bold_Weight selected": a0, "Spa_Style_SecondaryButton Spa_Style_Regular_Weight": a1 }; };
function PharmacySelectorComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10, 11);
    i0.ɵɵlistener("click", function PharmacySelectorComponent_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r19.onSelectedMailOrder()); });
    i0.ɵɵelementStart(2, "span", 12);
    i0.ɵɵtext(3);
    i0.ɵɵelement(4, "br");
    i0.ɵɵtemplate(5, PharmacySelectorComponent_button_8_ng_container_5_Template, 3, 1, "ng-container", 8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c2$d, ctx_r2.isMailOrderSelected, !ctx_r2.isMailOrderSelected));
    i0.ɵɵattribute("aria-checked", ctx_r2.isMailOrderSelected ? "true" : "false");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c1$j, !ctx_r2.isMailOrderSelected));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.mailOrderText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.showNotCoveredText);
} }
function PharmacySelectorComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 19)(2, "vnext-link", 20);
    i0.ɵɵlistener("click", function PharmacySelectorComponent_ng_container_9_Template_vnext_link_click_2_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r21.openGuidedHelp(ctx_r21.pageTags.GUIDED_HELP_PHARMACY_SEARCH)); })("keydown.enter", function PharmacySelectorComponent_ng_container_9_Template_vnext_link_keydown_enter_2_listener() { i0.ɵɵrestoreView(_r22); const ctx_r23 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r23.openGuidedHelp(ctx_r23.pageTags.GUIDED_HELP_PHARMACY_SEARCH)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("keyNameForLiveEdit", "Spa_Site_Pharmacy_AddEdit_Link")("title", ctx_r3.addEditPharmacyLink)("alwaysUnderlined", true)("linkTarget", "_self")("isLinkButton", true);
} }
class PharmacySelectorComponent {
    constructor(pharmacyFacade, guidedHelpModalContextService, navigationService) {
        this.pharmacyFacade = pharmacyFacade;
        this.guidedHelpModalContextService = guidedHelpModalContextService;
        this.navigationService = navigationService;
        this.selectPharmacy = new EventEmitter();
        this.navigateToPharmacyPage = new EventEmitter();
        this.selectMailOrder = new EventEmitter();
        this.pageTags = PageTags;
    }
    onSelectedPharmacy(pharmacy) {
        this.selectPharmacy.emit(pharmacy);
        this.pharmacyFacade.logDataLayerBasedOn(pharmacy);
    }
    onSelectedMailOrder() {
        this.selectMailOrder.emit();
        this.pharmacyFacade.logDataLayerBasedOn();
    }
    openGuidedHelp(pageTag) {
        if (this.preferencesBannerEnabled) {
            this.guidedHelpModalContextService.openGuidedHelpModal(pageTag);
        }
        else {
            this.navigationService.navigateByPageTag(pageTag);
        }
    }
}
PharmacySelectorComponent.ɵfac = function PharmacySelectorComponent_Factory(t) { return new (t || PharmacySelectorComponent)(i0.ɵɵdirectiveInject(PharmacyFacade), i0.ɵɵdirectiveInject(i1.GuidedHelpModalContextService), i0.ɵɵdirectiveInject(i1.NavigationService)); };
PharmacySelectorComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PharmacySelectorComponent, selectors: [["vnext-pharmacy-selector"]], inputs: { preferencesBannerEnabled: "preferencesBannerEnabled", pharmacySelectorTextKey: "pharmacySelectorTextKey", pharmacySelectorText: "pharmacySelectorText", pharmacies: "pharmacies", selectedPharmacy: "selectedPharmacy", showPlanNetwork: "showPlanNetwork", preferredInNetworkText: "preferredInNetworkText", standardInNetworkText: "standardInNetworkText", outOfNetworkText: "outOfNetworkText", addEditPharmacyLink: "addEditPharmacyLink", showMailOrderOption: "showMailOrderOption", isMailOrderSelected: "isMailOrderSelected", mailOrderText: "mailOrderText", notCoveredText: "notCoveredText", showNotCoveredText: "showNotCoveredText" }, outputs: { selectPharmacy: "selectPharmacy", navigateToPharmacyPage: "navigateToPharmacyPage", selectMailOrder: "selectMailOrder" }, decls: 10, vars: 5, consts: [[1, "pb-2"], [1, "d-flex", "pharmacy-selector-label", "align-items-center"], ["aria-hidden", "true", 1, "fas", "Spa_Style_PharmacyIcon", "pharmacy-selector-pin", "pr-2"], ["class", "header-text", 4, "liveEditProp"], [1, "toggle-container", "vertical"], [1, "sr-only"], ["class", "toggle-option Spa_Style_Small_Font", "role", "radio", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], ["class", "toggle-option Spa_Style_Small_Font", "role", "radio", 3, "ngClass", "click", 4, "ngIf"], [4, "ngIf"], [1, "header-text"], ["role", "radio", 1, "toggle-option", "Spa_Style_Small_Font", 3, "ngClass", "click"], ["toggles", ""], [3, "ngClass"], [1, "no-translate-block"], [4, "ngIf", "ngIfElse"], ["outOfNetwork", ""], ["class", "d-inline-block ml-1", 4, "ngIf", "ngIfElse"], ["standardNetwork", ""], [1, "d-inline-block", "ml-1"], [1, "py-2"], [3, "keyNameForLiveEdit", "title", "alwaysUnderlined", "linkTarget", "isLinkButton", "click", "keydown.enter"]], template: function PharmacySelectorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵelement(2, "i", 2);
        i0.ɵɵtemplate(3, PharmacySelectorComponent_span_3_Template, 2, 1, "span", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "fieldset", 4)(5, "legend", 5);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, PharmacySelectorComponent_button_7_Template, 6, 10, "button", 6);
        i0.ɵɵtemplate(8, PharmacySelectorComponent_button_8_Template, 6, 10, "button", 7);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(9, PharmacySelectorComponent_ng_container_9_Template, 3, 5, "ng-container", 8);
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", ctx.pharmacySelectorTextKey);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.pharmacySelectorText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.pharmacies);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showMailOrderOption);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.addEditPharmacyLink);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, LiveEditPropDirective, IconAriaAttributesDirective], styles: [".pharmacy-selector-label[_ngcontent-%COMP%]{padding-bottom:6px}.pharmacy-selector-pin[_ngcontent-%COMP%]{font-size:28px}.header-text[_ngcontent-%COMP%]{font-weight:700}.toggle-container[_ngcontent-%COMP%]{display:flex;text-align:center}.toggle-option[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;border:1px solid var(--static-Spa_Style_Accent1);padding:6px 5px;cursor:pointer;-webkit-user-select:none;user-select:none}.toggle-option-selected[_ngcontent-%COMP%], .toggle-option-selected[_ngcontent-%COMP%]:focus, .toggle-option-selected[_ngcontent-%COMP%]:active{border-color:var(--static-Spa_Style_Primary_Link)}.vertical[_ngcontent-%COMP%]{flex-direction:column;text-align:left}.vertical[_ngcontent-%COMP%] > .toggle-option[_ngcontent-%COMP%]{padding-left:15px;padding-right:15px}.vertical[_ngcontent-%COMP%] > .toggle-option[_ngcontent-%COMP%]:first-of-type{border-top-left-radius:5px;border-top-right-radius:5px}.vertical[_ngcontent-%COMP%] > .toggle-option[_ngcontent-%COMP%]:last-of-type{border-bottom-left-radius:5px;border-bottom-right-radius:5px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PharmacySelectorComponent, [{
        type: Component,
        args: [{ selector: 'vnext-pharmacy-selector', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"pb-2\">\r\n  <div class=\"d-flex pharmacy-selector-label align-items-center\">\r\n    <i class=\"fas Spa_Style_PharmacyIcon pharmacy-selector-pin pr-2\" aria-hidden=\"true\"></i>\r\n    <span *liveEditProp=\"pharmacySelectorTextKey\" class=\"header-text\">{{ pharmacySelectorText }}</span>\r\n  </div>\r\n  <fieldset class=\"toggle-container vertical\">\r\n    <legend class=\"sr-only\">{{ pharmacySelectorText }}</legend>\r\n    <button\r\n      *ngFor=\"let pharmacy of pharmacies\"\r\n      #toggles\r\n      class=\"toggle-option Spa_Style_Small_Font\"\r\n      [ngClass]=\"{\r\n        'Spa_Style_SecondaryButtonSelected Spa_Style_Bold_Weight toggle-option-selected':\r\n          !isMailOrderSelected && selectedPharmacy.nabp === pharmacy.nabp,\r\n        'Spa_Style_SecondaryButton Spa_Style_Regular_Weight': isMailOrderSelected || selectedPharmacy.nabp !== pharmacy.nabp\r\n      }\"\r\n      (click)=\"onSelectedPharmacy(pharmacy)\"\r\n      role=\"radio\"\r\n      [attr.aria-checked]=\"!isMailOrderSelected && selectedPharmacy.nabp === pharmacy.nabp ? 'true' : 'false'\"\r\n    >\r\n      <span [ngClass]=\"{ Spa_Style_Paragraph: isMailOrderSelected || selectedPharmacy.nabp !== pharmacy.nabp }\">\r\n        <span class=\"no-translate-block\">{{ pharmacy?.name }}</span>\r\n        <ng-container *ngIf=\"showPlanNetwork\">\r\n          <ng-container *ngIf=\"pharmacy.isInNetwork; else outOfNetwork\">\r\n            <span class=\"d-inline-block ml-1\" *ngIf=\"pharmacy.isPreferred; else standardNetwork\">({{ preferredInNetworkText }})</span>\r\n            <ng-template #standardNetwork>\r\n              <span class=\"d-inline-block ml-1\">({{ standardInNetworkText }})</span>\r\n            </ng-template>\r\n          </ng-container>\r\n          <ng-template #outOfNetwork>\r\n            <span class=\"d-inline-block ml-1\">({{ outOfNetworkText }})</span>\r\n          </ng-template>\r\n        </ng-container>\r\n      </span>\r\n    </button>\r\n    <button\r\n      *ngIf=\"showMailOrderOption\"\r\n      #toggles\r\n      class=\"toggle-option Spa_Style_Small_Font\"\r\n      [ngClass]=\"{\r\n        'Spa_Style_SecondaryButtonSelected Spa_Style_Bold_Weight selected': isMailOrderSelected,\r\n        'Spa_Style_SecondaryButton Spa_Style_Regular_Weight': !isMailOrderSelected\r\n      }\"\r\n      (click)=\"onSelectedMailOrder()\"\r\n      role=\"radio\"\r\n      [attr.aria-checked]=\"isMailOrderSelected ? 'true' : 'false'\"\r\n    >\r\n      <span [ngClass]=\"{ Spa_Style_Paragraph: !isMailOrderSelected }\">\r\n        {{ mailOrderText }} <br />\r\n        <ng-container *ngIf=\"showNotCoveredText\">\r\n          <span class=\"d-inline-block ml-1\">({{ notCoveredText }})</span>\r\n        </ng-container>\r\n      </span>\r\n    </button>\r\n  </fieldset>\r\n</div>\r\n<ng-container *ngIf=\"addEditPharmacyLink\">\r\n  <div class=\"py-2\">\r\n    <vnext-link\r\n      [keyNameForLiveEdit]=\"'Spa_Site_Pharmacy_AddEdit_Link'\"\r\n      [title]=\"addEditPharmacyLink\"\r\n      [alwaysUnderlined]=\"true\"\r\n      [linkTarget]=\"'_self'\"\r\n      [isLinkButton]=\"true\"\r\n      (click)=\"openGuidedHelp(pageTags.GUIDED_HELP_PHARMACY_SEARCH)\"\r\n      (keydown.enter)=\"openGuidedHelp(pageTags.GUIDED_HELP_PHARMACY_SEARCH)\"\r\n    >\r\n    </vnext-link>\r\n  </div>\r\n</ng-container>\r\n", styles: [".pharmacy-selector-label{padding-bottom:6px}.pharmacy-selector-pin{font-size:28px}.header-text{font-weight:700}.toggle-container{display:flex;text-align:center}.toggle-option{display:flex;align-items:center;justify-content:center;border:1px solid var(--static-Spa_Style_Accent1);padding:6px 5px;cursor:pointer;-webkit-user-select:none;user-select:none}.toggle-option-selected,.toggle-option-selected:focus,.toggle-option-selected:active{border-color:var(--static-Spa_Style_Primary_Link)}.vertical{flex-direction:column;text-align:left}.vertical>.toggle-option{padding-left:15px;padding-right:15px}.vertical>.toggle-option:first-of-type{border-top-left-radius:5px;border-top-right-radius:5px}.vertical>.toggle-option:last-of-type{border-bottom-left-radius:5px;border-bottom-right-radius:5px}\n"] }]
    }], function () { return [{ type: PharmacyFacade }, { type: i1.GuidedHelpModalContextService }, { type: i1.NavigationService }]; }, { preferencesBannerEnabled: [{
            type: Input
        }], pharmacySelectorTextKey: [{
            type: Input
        }], pharmacySelectorText: [{
            type: Input
        }], pharmacies: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], showPlanNetwork: [{
            type: Input
        }], preferredInNetworkText: [{
            type: Input
        }], standardInNetworkText: [{
            type: Input
        }], outOfNetworkText: [{
            type: Input
        }], addEditPharmacyLink: [{
            type: Input
        }], showMailOrderOption: [{
            type: Input
        }], isMailOrderSelected: [{
            type: Input
        }], mailOrderText: [{
            type: Input
        }], notCoveredText: [{
            type: Input
        }], showNotCoveredText: [{
            type: Input
        }], selectPharmacy: [{
            type: Output
        }], navigateToPharmacyPage: [{
            type: Output
        }], selectMailOrder: [{
            type: Output
        }] }); })();

function EffectiveDateDisplayComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r1.effectiveText, " ", ctx_r1.displayValue, "");
} }
function EffectiveDateDisplayComponent_ng_container_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "span", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 6);
    i0.ɵɵlistener("click", function EffectiveDateDisplayComponent_ng_container_0_ng_template_2_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.openEffectiveDateUpdateModal()); });
    i0.ɵɵtext(4);
    i0.ɵɵelement(5, "i", 7);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.effectiveText);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", ctx_r3.displayValue);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.displayValue, "");
} }
function EffectiveDateDisplayComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EffectiveDateDisplayComponent_ng_container_0_ng_container_1_Template, 3, 2, "ng-container", 1);
    i0.ɵɵtemplate(2, EffectiveDateDisplayComponent_ng_container_0_ng_template_2_Template, 6, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r2 = i0.ɵɵreference(3);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isReadOnly)("ngIfElse", _r2);
} }
class EffectiveDateDisplayComponent {
    constructor(modalService, injector, planDetailsFacade, planFacade, cdr, store, configResourceService, localeService) {
        this.modalService = modalService;
        this.injector = injector;
        this.planDetailsFacade = planDetailsFacade;
        this.planFacade = planFacade;
        this.cdr = cdr;
        this.store = store;
        this.configResourceService = configResourceService;
        this.localeService = localeService;
        this.activePlanType = PlanTypeAbbreviation.MAPD;
        this.isReadOnly = false;
        this.dateUpdated = new EventEmitter();
        this.updateEffectiveDateEnabled = false;
        this.effectiveText = 'Effective';
        this.listOfMonths = [];
        this.optionsListAsStrings = [];
        this.displayValue = '';
        this.subscriptions = new Subscription();
        this.initialTotalCostEffectiveDate = '';
    }
    ngOnInit() {
        this.updateEffectiveDateEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_UpdateEffectiveDate_Enabled', null, false);
        this.effectiveText = this.configResourceService.getProcessedResourceValue('Spa_Site_TotalEstimatedCost_EffectiveDate_Text', null, 'Effective');
        this.updateDates();
        this.updateComponentDisplay(this.activePlanType);
        this.updateResources();
        this.subscriptions.add(this.store.select(MemberState.totalCostEffectiveDate).subscribe((totalCostEffectiveDate) => {
            if (totalCostEffectiveDate) {
                this.totalCostEffectiveDate = totalCostEffectiveDate;
                this.updateDisplayValue();
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe(locale => {
            this.updateDates(locale);
            this.updateResources();
            this.cdr.markForCheck();
        }));
        this.cdr.markForCheck();
    }
    ngOnChanges(changes) {
        const activePlanType = changes.activePlanType;
        if (activePlanType?.currentValue && activePlanType.currentValue !== activePlanType.previousValue && !activePlanType.firstChange) {
            const currentValue = activePlanType.currentValue;
            this.updateComponentDisplay(currentValue);
        }
    }
    updateComponentDisplay(activePlanType) {
        this.displayComponent =
            this.updateEffectiveDateEnabled &&
                this.displayValue &&
                (activePlanType === PlanTypeAbbreviation.MAPD ||
                    activePlanType === PlanTypeAbbreviation.PDP ||
                    activePlanType === PlanTypeAbbreviation.MA) &&
                !this.planFacade.isLastMonthOfYear();
    }
    updateDates(locale) {
        const defaultEffectiveDateOption = this.planFacade.getDefaultEffectiveDateOption();
        this.listOfMonths = this.planDetailsFacade.getListOfEffectiveDateMonths();
        this.updateDisplayValue();
        if (defaultEffectiveDateOption !== DefaultEffectiveDateOption.FIRST_MONTH_OF_CURRENT_PLAN_YEAR) {
            this.optionsListAsStrings = this.listOfMonths.map(date => DateUtilities.getFormattedDate(date.toDate(), this.planDetailsFacade.getMonthYearDateFormat(), locale));
        }
    }
    updateDisplayValue() {
        const date = this.totalCostEffectiveDate ? new Date(`${this.totalCostEffectiveDate}`) : this.listOfMonths[0].toDate();
        this.displayValue = this.planDetailsFacade.formatDateAsMonthYear(date);
    }
    updateResources() {
        this.effectiveText = this.configResourceService.getProcessedResourceValue('Spa_Site_TotalEstimatedCost_EffectiveDate_Text', null, 'Effective');
        this.modalHeaderText = this.configResourceService.getProcessedResourceValue('Spa_UpdateEffectiveDate_ModalHeader_Text', null, 'Effective date');
        this.modalBodyText = this.configResourceService.getProcessedResourceValue('Spa_UpdateEffectiveDate_ModalBody_Text', null, 'Please select when you would like coverage to start.');
        this.modalLabelText = this.configResourceService.getProcessedResourceValue('Spa_UpdateEffectiveDate_ModalLabel_Text', null, 'Effective date');
        this.modalCancelText = this.configResourceService.getProcessedResourceValue('Spa_Site_Cancel', null, 'Cancel');
        this.modalShopText = this.configResourceService.getProcessedResourceValue('Spa_Site_ShopForPlans', null, 'Shop for plans');
    }
    openEffectiveDateUpdateModal() {
        this.initialTotalCostEffectiveDate = this.planDetailsFacade.formatDateAsMonthYear(new Date(this.totalCostEffectiveDate));
        const options = {
            ariaLabelledBy: 'modalHeaderTitle',
            centered: true,
            injector: this.injector
        };
        const updateModal = this.modalService.open(UpdateEffectiveDateModalComponent, options);
        updateModal.componentInstance.titleText = this.modalHeaderText;
        updateModal.componentInstance.bodyText = this.modalBodyText;
        updateModal.componentInstance.effectiveDateLabel = this.modalLabelText;
        updateModal.componentInstance.cancelButtonText = this.modalCancelText;
        updateModal.componentInstance.continueButtonText = this.modalShopText;
        updateModal.componentInstance.effectiveDateDropDownItems = this.optionsListAsStrings;
        updateModal.componentInstance.selectedValue = this.displayValue;
        updateModal.componentInstance.confirmAction = async (value) => {
            if (value !== this.initialTotalCostEffectiveDate) {
                await this.planDetailsFacade.convertAndUpdateValueFromDropdown(value, false, false);
                this.dateUpdated.emit();
            }
        };
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
EffectiveDateDisplayComponent.ɵfac = function EffectiveDateDisplayComponent_Factory(t) { return new (t || EffectiveDateDisplayComponent)(i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(PlanDetailsFacade), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.LocaleService)); };
EffectiveDateDisplayComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EffectiveDateDisplayComponent, selectors: [["vnext-effective-date-display"]], inputs: { activePlanType: "activePlanType", isReadOnly: "isReadOnly" }, outputs: { dateUpdated: "dateUpdated" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [4, "ngIf", "ngIfElse"], ["editable", ""], [1, "Spa_Style_Note", "py-2", "text-right"], [1, "pt-1", "pb-2"], [1, "pr-1", "Spa_Style_Small_Font", "Spa_Style_Primary_Color"], ["tabindex", "0", 1, "Spa_Style_Small_Font", "Spa_Style_Primary_Link_Color", "text-underline", "action-button", "p-1", 3, "click"], [1, "fa", "fa-edit", "ml-2"]], template: function EffectiveDateDisplayComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, EffectiveDateDisplayComponent_ng_container_0_Template, 4, 2, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.displayComponent);
    } }, dependencies: [i1$2.NgIf, IconAriaAttributesDirective], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EffectiveDateDisplayComponent, [{
        type: Component,
        args: [{ selector: 'vnext-effective-date-display', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"displayComponent\">\r\n  <ng-container *ngIf=\"isReadOnly; else editable\"\r\n    ><div class=\"Spa_Style_Note py-2 text-right\">{{ effectiveText }} {{ displayValue }}</div>\r\n  </ng-container>\r\n  <ng-template #editable>\r\n    <div class=\"pt-1 pb-2\">\r\n      <span class=\"pr-1 Spa_Style_Small_Font Spa_Style_Primary_Color\">{{ effectiveText }}</span>\r\n      <button\r\n        class=\"Spa_Style_Small_Font Spa_Style_Primary_Link_Color text-underline action-button p-1\"\r\n        tabindex=\"0\"\r\n        (click)=\"openEffectiveDateUpdateModal()\"\r\n        [attr.aria-label]=\"displayValue\"\r\n      >\r\n        {{ displayValue }}<i class=\"fa fa-edit ml-2\"></i>\r\n      </button>\r\n    </div>\r\n  </ng-template>\r\n</ng-container>\r\n" }]
    }], function () { return [{ type: i1$1.NgbModal }, { type: i0.Injector }, { type: PlanDetailsFacade }, { type: PlanFacade }, { type: i0.ChangeDetectorRef }, { type: i2.Store }, { type: i1.ConfigResourceService }, { type: i1.LocaleService }]; }, { activePlanType: [{
            type: Input
        }], isReadOnly: [{
            type: Input
        }], dateUpdated: [{
            type: Output
        }] }); })();

const _c0$X = ["planDetailsTab"];
function PlanDetailsComponent_div_0_vnext_link_5_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 24);
    i0.ɵɵlistener("click", function PlanDetailsComponent_div_0_vnext_link_5_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.backToPrevious()); })("keyup.enter", function PlanDetailsComponent_div_0_vnext_link_5_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r15.backToPrevious()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r1.isDeepLink ? ctx_r1.Spa_Site_Plan_List_Link : ctx_r1.Spa_Site_Previous)("showArrow", "left")("role", ctx_r1.linkRoles.LINK)("ariaLabel", ctx_r1.isDeepLink ? ctx_r1.Spa_Site_Plan_List_Link : ctx_r1.Spa_Site_Previous);
} }
function PlanDetailsComponent_div_0_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "h1", 25);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.detailedPlan.carrierName);
} }
function PlanDetailsComponent_div_0_h1_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.detailedPlan.planName, " ");
} }
function PlanDetailsComponent_div_0_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 26);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", ctx_r4.Spa_Site_PageSubHeader_Text ? i0.ɵɵpipeBind2(1, 1, ctx_r4.Spa_Site_PageSubHeader_Text, "html") : "", i0.ɵɵsanitizeHtml);
} }
function PlanDetailsComponent_div_0_div_13_div_2_ng_container_2_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 36);
    i0.ɵɵlistener("click", function PlanDetailsComponent_div_0_div_13_div_2_ng_container_2_li_1_Template_li_click_0_listener() { i0.ɵɵrestoreView(_r30); const tab_r24 = i0.ɵɵnextContext().$implicit; const ctx_r28 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r28.updateActiveTab(tab_r24.name)); })("keyup.enter", function PlanDetailsComponent_div_0_div_13_div_2_ng_container_2_li_1_Template_li_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r30); const tab_r24 = i0.ɵɵnextContext().$implicit; const ctx_r31 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r31.updateActiveTab(tab_r24.name)); })("keyup.Space", function PlanDetailsComponent_div_0_div_13_div_2_ng_container_2_li_1_Template_li_keyup_Space_0_listener() { i0.ɵɵrestoreView(_r30); const tab_r24 = i0.ɵɵnextContext().$implicit; const ctx_r33 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r33.updateActiveTab(tab_r24.name)); });
    i0.ɵɵelementStart(1, "vnext-plan-details-tab", 37, 38);
    i0.ɵɵlistener("setFocusToTabEvent", function PlanDetailsComponent_div_0_div_13_div_2_ng_container_2_li_1_Template_vnext_plan_details_tab_setFocusToTabEvent_1_listener($event) { i0.ɵɵrestoreView(_r30); const ctx_r35 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r35.shiftFocusToTabElement($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext();
    const tab_r24 = ctx_r36.$implicit;
    const index_r25 = ctx_r36.index;
    const ctx_r26 = i0.ɵɵnextContext(4);
    i0.ɵɵclassProp("active", ctx_r26.activeTab === tab_r24.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", tab_r24.title)("currentIndex", index_r25)("lastIndex", ctx_r26.planDetailTabs.length - 1)("isActiveTab", ctx_r26.activeTab === tab_r24.name)("ariaControlsId", tab_r24.id);
} }
function PlanDetailsComponent_div_0_div_13_div_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanDetailsComponent_div_0_div_13_div_2_ng_container_2_li_1_Template, 3, 7, "li", 35);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tab_r24 = ctx.$implicit;
    const ctx_r23 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r23.Spa_Site_TotalEstimatedCost_Enabled || tab_r24.name !== ctx_r23.planDetailsTabs.TOTAL_COSTS);
} }
function PlanDetailsComponent_div_0_div_13_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 32)(1, "ul", 33);
    i0.ɵɵtemplate(2, PlanDetailsComponent_div_0_div_13_div_2_ng_container_2_Template, 2, 1, "ng-container", 34);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r16.planDetailTabs);
} }
function PlanDetailsComponent_div_0_div_13_vnext_notice_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice", 39);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r18 = i0.ɵɵreference(6);
    i0.ɵɵproperty("type", "info")("bodyTemplate", _r18);
} }
function PlanDetailsComponent_div_0_div_13_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "vnext-link", 40);
    i0.ɵɵlistener("click", function PlanDetailsComponent_div_0_div_13_ng_template_5_Template_vnext_link_click_2_listener() { i0.ɵɵrestoreView(_r38); const ctx_r37 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r37.openMedSupForm()); })("keyup.enter", function PlanDetailsComponent_div_0_div_13_ng_template_5_Template_vnext_link_keyup_enter_2_listener() { i0.ɵɵrestoreView(_r38); const ctx_r39 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r39.openMedSupForm()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r19.Spa_MedSup_RestrictMedSupPlansByAge_InfoText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("makeInlineBlock", true)("title", ctx_r19.Spa_MedSup_RestrictMedSupPlansByAge_InfoLink);
} }
function PlanDetailsComponent_div_0_div_13_vnext_notice_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice", 39);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r21 = i0.ɵɵreference(10);
    i0.ɵɵproperty("type", "info")("bodyTemplate", _r21);
} }
function PlanDetailsComponent_div_0_div_13_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵtext(0);
    i0.ɵɵelementStart(1, "vnext-link", 41);
    i0.ɵɵlistener("click", function PlanDetailsComponent_div_0_div_13_ng_template_9_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r40.openMedSupForm()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r22.planFacade.getEffectiveDateRestrictionText(), " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("makeInlineBlock", true)("title", ctx_r22.Spa_MedSup_RestrictMedSupPlansByAge_InfoLink);
} }
function PlanDetailsComponent_div_0_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 27);
    i0.ɵɵtemplate(2, PlanDetailsComponent_div_0_div_13_div_2_Template, 3, 1, "div", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PlanDetailsComponent_div_0_div_13_vnext_notice_3_Template, 1, 2, "vnext-notice", 29);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵtemplate(5, PlanDetailsComponent_div_0_div_13_ng_template_5_Template, 3, 3, "ng-template", null, 30, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(7, PlanDetailsComponent_div_0_div_13_vnext_notice_7_Template, 1, 2, "vnext-notice", 29);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵtemplate(9, PlanDetailsComponent_div_0_div_13_ng_template_9_Template, 2, 3, "ng-template", null, 31, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.planDetailTabs && ctx_r5.planDetailTabs.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 3, ctx_r5.showAgeRestrictionBanner$));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(8, 5, ctx_r5.showEffectiveDateRestrictionBanner$));
} }
function PlanDetailsComponent_div_0_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-hip-details-banner", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("numberOfDaysText", ctx_r6.Spa_PlanFilters_DayLabel_Text)("daysText", ctx_r6.Spa_Site_Days_Text)("dayText", ctx_r6.Spa_Site_Day_Text)("editYourAnswersText", ctx_r6.Spa_PlanList_MedSupEditAnswersBanner_Text)("lumpSumText", ctx_r6.Spa_Site_LumpSum_Text)("basePlanText", ctx_r6.Spa_Site_HIP_BasePlanOption_Text)("daysAmount", ctx_r6.numberOfDaysHIPAnswer)("benefitAmount", ctx_r6.benefitAmountHIPAnswer);
} }
function PlanDetailsComponent_div_0_vnext_pharmacy_selector_19_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-pharmacy-selector", 43);
    i0.ɵɵlistener("selectPharmacy", function PlanDetailsComponent_div_0_vnext_pharmacy_selector_19_Template_vnext_pharmacy_selector_selectPharmacy_0_listener($event) { i0.ɵɵrestoreView(_r43); const ctx_r42 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r42.updateSelectedPharmacy($event)); })("navigateToPharmacyPage", function PlanDetailsComponent_div_0_vnext_pharmacy_selector_19_Template_vnext_pharmacy_selector_navigateToPharmacyPage_0_listener() { i0.ɵɵrestoreView(_r43); const ctx_r44 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r44.planDetailsFacade.navigateByPageTag(ctx_r44.pageTags.GUIDED_HELP_PHARMACY_SEARCH)); })("selectMailOrder", function PlanDetailsComponent_div_0_vnext_pharmacy_selector_19_Template_vnext_pharmacy_selector_selectMailOrder_0_listener() { i0.ɵɵrestoreView(_r43); const ctx_r45 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r45.pharmacyFacade.switchMailOrder(true)); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("preferencesBannerEnabled", ctx_r7.Spa_PreferenceBanner_Enabled)("pharmacySelectorTextKey", "Spa_Site_CostBasedOn_Text")("pharmacySelectorText", ctx_r7.Spa_Site_CostBasedOn_Text)("pharmacies", i0.ɵɵpipeBind1(1, 15, ctx_r7.selectedPharmacies$))("selectedPharmacy", ctx_r7.selectedPharmacy)("showPlanNetwork", true)("preferredInNetworkText", ctx_r7.Spa_Site_Preferred_In_Network_Text)("standardInNetworkText", ctx_r7.Spa_Site_Standard_In_Network_Text)("outOfNetworkText", ctx_r7.Spa_Site_Out_Of_Network_Text)("addEditPharmacyLink", ctx_r7.Spa_Site_Pharmacy_AddEdit_Link)("showMailOrderOption", ctx_r7.Spa_Site_Mail_Order_Pharmacy_Enabled)("mailOrderText", ctx_r7.Spa_PlanList_MailOrder_Text)("isMailOrderSelected", ctx_r7.isMailOrderSelected)("notCoveredText", ctx_r7.Spa_PlanDetails_Non_Covered_Text)("showNotCoveredText", !ctx_r7.detailedPlan.hasMailDrugBenefits);
} }
function PlanDetailsComponent_div_0_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵelement(1, "vnext-hospital-indemnity-information-nudge", 45);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("informationalText", ctx_r8.Spa_PlanDetails_HIP_Call_Out_Informational_Text)("callOutButtonText", ctx_r8.Spa_PlanDetails_HIP_Call_Out_Text_Button)("rateFactorModalTitle", ctx_r8.Spa_PlanDetails_HIP_RateFactorModal_Title)("rateFactorFormPromptText", ctx_r8.Spa_PlanList_HIPFormPrompt_Text)("rateFactorFormPageTitleText", ctx_r8.Spa_PlanList_HIP_PageTitle_Text)("errorKeywordText", ctx_r8.Spa_Site_ErrorKeyword_Text)("errorNoticeTitle", ctx_r8.Spa_Site_EnrollmentErrorNotice_Title)("dropdownDefaultText", ctx_r8.Spa_PlanList_MedSupFormDropdownDefault_Text)("rateFactorPlan", ctx_r8.detailedPlan)("areAllHospitalIndemnityQuestionsAnswered", ctx_r8.areAllHospitalIndemnityQuestionsAnswered)("addToQuoteMobileLimit", ctx_r8.Spa_PlanList_AddToQuote_Limit_Mobile)("addToQuoteDesktopLimit", ctx_r8.Spa_PlanList_AddToQuote_Limit);
} }
function PlanDetailsComponent_div_0_vnext_plan_prescription_details_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-plan-prescription-details", 46);
    i0.ɵɵpipe(1, "orderBy");
    i0.ɵɵpipe(2, "async");
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("preferencesBannerEnabled", ctx_r9.Spa_PreferenceBanner_Enabled)("plan", ctx_r9.detailedPlan)("prescriptionAddEditLinkTitle", ctx_r9.Spa_Prescription_Add_Edit_Link)("prescriptionsTabIntro", ctx_r9.Spa_PrescriptionsTab_Intro_Text)("prescriptionNoCost", ctx_r9.Spa_PrescriptionsTab_NoCostTitle_Text)("addPrescriptionButton", ctx_r9.Spa_PrescriptionsTab_AddPrescriptionButton_Text)("noPrescriptionInTier", ctx_r9.Spa_PrescriptionsTab_NotInTier_Text)("nonCoveredPrescriptions", ctx_r9.Spa_PrescriptionsTab_NonCovered_Text)("coveredPrescriptions", ctx_r9.Spa_PrescriptionsTab_Covered_Text)("isEnabledShowDrugAlternatives", ctx_r9.Spa_Site_ShowDrugAlternatives_Enabled && ctx_r9.Spa_PlanDetails_ShowDrugAlternatives_Nudge_Enabled)("prescriptionsDrugAlternativesInformationalText", ctx_r9.Spa_Prescriptions_ShowDrugAlternatives_Informational_Text)("prescriptionsDrugAlternativesButtonText", ctx_r9.Spa_Prescriptions_ShowDrugAlternatives_ViewAlternatives_Text)("medicineCabinet", i0.ɵɵpipeBind4(1, 51, i0.ɵɵpipeBind1(2, 56, ctx_r9.medicineCabinet$), "labelName", false, true))("showGenericOption", ctx_r9.Spa_Site_Show_GenericDrugOption)("costBasedOnRetailPharmacy", ctx_r9.Spa_PharmacySelection_RetailPharmacyCosts_Text)("cantSellPlanCostBasedOnRetailPharmacy", ctx_r9.Spa_PharmacySelection_CantSell_RetailPharmacyCosts_Text)("costBasedOnMailOrderPharmacy", ctx_r9.Spa_PharmacySelection_MailOrderPharmacyCosts_Text)("cantSellPlanCostBasedOnMailOrderPharmacy", ctx_r9.Spa_PharmacySelection_CantSell_MailOrderPharmacyCosts_Text)("costBasedOnSelectedPharmacy", ctx_r9.Spa_PharmacySelection_AddPharmacy_Text)("switchToMailLinkText", ctx_r9.Spa_PharmacySelection_Switch_To_MailOrder_Costs_Text)("switchToRetailLinkText", ctx_r9.Spa_PharmacySelection_Switch_To_Retail_Costs)("addPharmacyLink", ctx_r9.Spa_PharmacySelection_Add_Link_Text)("editPharmacyLink", ctx_r9.Spa_PharmacySelection_Edit_Link_Text)("formularyID", ctx_r9.Spa_Site_Formulary_ID_Text)("formularyVersionText", ctx_r9.Spa_Site_Formulary_Version_Text)("footnotes", ctx_r9.Spa_PlanDetails_Footnotes)("footnoteHeader", ctx_r9.Spa_PlanDetails_Footnote_Header)("showPharmacy", ctx_r9.Spa_Site_Pharmacy_Enabled)("addEditLinkDescription", ctx_r9.Spa_Prescription_Add_Edit_Link_Description)("selectedTab", ctx_r9.activeTab)("isRetentionView", ctx_r9.isRetentionView)("noCostMedSupPlanText", ctx_r9.noCostMedSupPlanText)("faqContent", ctx_r9.Spa_Prescriptions_FAQ_Text)("hideRetailMailOrderCost", ctx_r9.pharmacyFacade.showPharmacySelectorToggle(ctx_r9.detailedPlan.planTypeAbbreviation))("annualCost", ctx_r9.annualCost)("selectedPharmacy", ctx_r9.selectedPharmacy)("prescriptionTabView", ctx_r9.prescriptionTabViewMode)("pharmacies", ctx_r9.pharmacies)("isMailOrderSelected", ctx_r9.isMailOrderSelected)("drugSearchFrequencies", ctx_r9.Spa_DrugSearch_Frequency_List)("drugListCardBrandText", ctx_r9.Spa_DrugListCard_Brand_Text)("drugListCardGenericText", ctx_r9.Spa_DrugListCard_Generic_Text)("backToPrescriptionLabelText", ctx_r9.Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_BackToPrescriptions_Link_Text)("hintAlternativesForCabinetHeaderText", ctx_r9.Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_Header_Text)("hintNoAlternativesForCabinet", ctx_r9.Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_NoDrugs_Empty_Text)("hintAlternativesForCabinetText", ctx_r9.Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_Intro_Text)("drugCostsRetailCostText", ctx_r9.Spa_DrugCosts_RetailCostText)("conditionPrescribedForText", ctx_r9.Spa_Prescriptions_ShowDrugAlternatives_Condition_Modal_Text)("changeMedicalConditionsEnabled", ctx_r9.Spa_Site_ShowDrugAlternatives_Change_Medical_Conditions_Enabled)("cabinetForAlternatives", ctx_r9.cabinetForAlternatives)("footnoteIdsToShowForDrugAlternatives", ctx_r9.footnoteIdsToShowForDrugAlternatives);
} }
function PlanDetailsComponent_div_0_vnext_plan_sub_details_24_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-plan-sub-details", 47);
    i0.ɵɵlistener("benefitRidersSelected", function PlanDetailsComponent_div_0_vnext_plan_sub_details_24_Template_vnext_plan_sub_details_benefitRidersSelected_0_listener($event) { i0.ɵɵrestoreView(_r47); const ctx_r46 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r46.benefitRidersSelected($event)); })("viewPossibleAlternativeDrugs", function PlanDetailsComponent_div_0_vnext_plan_sub_details_24_Template_vnext_plan_sub_details_viewPossibleAlternativeDrugs_0_listener($event) { i0.ɵɵrestoreView(_r47); const ctx_r48 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r48.onViewPossibleAlternativeDrugs($event)); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("preferencesBannerEnabled", ctx_r10.Spa_PreferenceBanner_Enabled)("modalHeaderHealthText", ctx_r10.Spa_Site_Health_Text)("closeButtonText", ctx_r10.Spa_Site_Close_Modal)("healthCostsBenefits", ctx_r10.Spa_Site_HealthCosts_Benefits_JSON)("healthCostsBodyText", ctx_r10.Spa_HealthCosts_Body_Text)("healthCostsBenefitsBodyText", ctx_r10.Spa_HealthCosts_Benefits_Body_Text)("healthCostsBenefitsTableHeader", ctx_r10.Spa_Site_HealthCosts_Benefits_Table_Header)("healthCostsUsageTableHeader", ctx_r10.Spa_Site_HealthCosts_Usage_Table_Header)("healthCostsDaysTableHeader", ctx_r10.Spa_Site_HealthCosts_Days_Table_Header)("saveFailedText", ctx_r10.Spa_Site_HealthCosts_Save_Failed_Text)("saveSuccessText", ctx_r10.Spa_Site_HealthCosts_Save_Success_Text)("healthCostsRestoreDefaultsText", ctx_r10.Spa_Site_HealthCosts_Restore_Defaults_Text)("healthCostsUpdateAnswersText", ctx_r10.Spa_Site_HealthCosts_Update_Answers_Text)("healthCostsSaveAnswersText", ctx_r10.Spa_Site_HealthCosts_Save_Answers_Text)("healthAgeQuestionText", ctx_r10.Spa_GuidedHelp_Health_AgeQuestion_Text)("healthCostsCustomizationEnabled", ctx_r10.Spa_Site_HealthCosts_Customization_Enabled)("healthSliderHeader1Text", ctx_r10.Spa_GuidedHelp_Health_SliderHeader1_Text)("healthSliderHeader2Text", ctx_r10.Spa_GuidedHelp_Health_SliderHeader2_Text)("healthSliderHeader3Text", ctx_r10.Spa_GuidedHelp_Health_SliderHeader3_Text)("healthSliderBody1", ctx_r10.Spa_GuidedHelp_Health_SliderBody1)("healthSliderBody2", ctx_r10.Spa_GuidedHelp_Health_SliderBody2)("healthSliderBody3", ctx_r10.Spa_GuidedHelp_Health_SliderBody3)("healthSliderLabelText", ctx_r10.Spa_Site_Health_Slider_Label_Text)("healthModalView1HeadingText", ctx_r10.Spa_AddHealth_ModalView1_HeadingText)("healthModalView1IntroText", ctx_r10.Spa_AddHealth_ModalView1_IntroText)("detailedPlan", ctx_r10.detailedPlan)("planBottomContentHeader", ctx_r10.Spa_PlanDetails_Bottom_Content_Header)("planDetailsBottomContentText", ctx_r10.detailsDescription[ctx_r10.detailedPlan.planTypeAbbreviation])("planBottomContentResource", ctx_r10.getPlanDetailsBottomContentName(ctx_r10.detailedPlan.planTypeAbbreviation))("planTypeText", ctx_r10.planTypeText)("costSectionHeader", ctx_r10.Spa_PlanDetails_Costs_Header)("planLevelContentLabel", ctx_r10.planLevelContentLabel[ctx_r10.detailedPlan.planTypeAbbreviation])("showPlanLevelContent", ctx_r10.Spa_Show_Plan_Level_Content)("premiumText", ctx_r10.Spa_PlanDetails_Costs_Premium)("planBenefitSectionName", ctx_r10.Spa_Plan_Benefits_Section_Name)("pharmacyText", ctx_r10.Spa_Plan_Details_Preferences_Pharmacy_Text)("preferencesText", ctx_r10.Spa_Plan_Details_Preferences_Text)("preferencesExpanded", ctx_r10.Spa_Plan_Details_Preferences_Expanded)("preferencesPositionLast", ctx_r10.Spa_Plan_Details_Preferences_Position_Last)("showPreferences", ctx_r10.Spa_Plan_Details_Show_Preferences)("showProvider", ctx_r10.isProviderSectionAvailable(i0.ɵɵpipeBind1(1, 150, ctx_r10.planFacade.selectedProviders$)))("isProvidersEnabled", ctx_r10.Spa_Site_Providers_Enabled)("showPrescription", ctx_r10.Spa_Site_Prescriptions_Enabled && ctx_r10.Spa_Plan_Details_Preferences_Show_Prescription)("showPharmacy", ctx_r10.Spa_Site_Pharmacy_Enabled && ctx_r10.Spa_Plan_Details_Preferences_Show_Pharmacy)("showOtherPreferences", ctx_r10.Spa_Site_OtherPreferences_Enabled)("providerText", ctx_r10.Spa_Plan_Details_Preferences_Provider_Text)("prescriptionText", ctx_r10.Spa_Plan_Details_Preferences_Prescription_Text)("otherPreferencesText", ctx_r10.Spa_Plan_Details_OtherPreferences_Text)("addOnRidersHeader", ctx_r10.Spa_Plan_Details_AddOnRiders_Header)("addOnRidersSubHeader", ctx_r10.Spa_Plan_Details_AddOnRiders_SubHeader)("prescriptionAddEditLinkTitle", ctx_r10.Spa_Prescription_Add_Edit_Link)("providersLink", ctx_r10.Spa_Plan_Details_Providers_Link)("pharmacyLink", ctx_r10.Spa_Plan_Details_Pharmacy_Link)("preferencesAddEditLink", ctx_r10.Spa_Site_Preferences_AddEdit_Link)("pharmacyAddEditLink", ctx_r10.Spa_Site_Pharmacy_AddEdit_Link)("riderIsIncludedText", ctx_r10.Spa_ShoppingCart_IncludedRider_Text)("waiverStateRiderTooltips", ctx_r10.Spa_Plan_Details_WaiverStateRider_Tooltips)("inNetworkPreferredText", ctx_r10.Spa_Pharmacy_InNetwork_Preferred_Pricing_Text)("inNetworkStandardText", ctx_r10.Spa_Pharmacy_InNetwork_Standard_Pricing_Text)("outOfNetworkText", ctx_r10.Spa_Pharmacy_OutOfNetwork_Pricing_Text)("coveredDrugsText", ctx_r10.Spa_PlanDetails_Covered_Text)("nonCoveredText", ctx_r10.Spa_PlanDetails_Non_Covered_Text)("coveredBenefitText", ctx_r10.Spa_Site_Yes)("nonCoveredBenefitText", ctx_r10.Spa_Site_No)("guidedHelpEnabled", ctx_r10.Spa_GuidedHelp_Enabled)("healthEnabled", ctx_r10.Spa_Site_Health_Enabled)("healthText", ctx_r10.Spa_PlanDetails_Health_Cost_Text)("costMA", ctx_r10.Spa_Plandetails_Costs_MA)("costMAPD", ctx_r10.Spa_Plandetails_Costs_MAPD)("costPDP", ctx_r10.Spa_Plandetails_Costs_PDP)("costMEDIGAP", ctx_r10.Spa_Plandetails_Costs_MEDIGAP)("costDENTAL", ctx_r10.Spa_PlanDetails_Costs_DENTAL)("costVISION", ctx_r10.Spa_PlanDetails_Costs_VISION)("costHIP", ctx_r10.Spa_PlanDetails_Costs_HIP)("costAddEditLinkText", ctx_r10.Spa_Plandetails_Costs_Add_Edit_Link_Text)("noCostAvailableText", ctx_r10.Spa_Site_NotApplicable_Text)("showRiderDetailsText", ctx_r10.Spa_Plan_Details_ViewRiderDetails_Text)("hideRiderDetailsText", ctx_r10.Spa_Plan_Details_HideRiderDetails_Text)("showRiderDetails", ctx_r10.Spa_Site_RiderDetails_Show)("riderHIPBenefitText", ctx_r10.SPA_HIP_Rider_Benefit_Text)("basePlanOptionLabel", ctx_r10.Spa_Site_HIP_BasePlanOption_Text)("riderHIPBenefitDefaultDropdownText", ctx_r10.SPA_HIP_Rider_Benefit_Default_Dropdown_Text)("prescriptionAddEditLinkDescription", ctx_r10.Spa_Prescription_Add_Edit_Link_Description)("pharmacyAddEditLinkDescription", ctx_r10.Spa_Site_Pharmacy_Add_Edit_Link_Description)("drugCostAddEditLinkDescription", ctx_r10.Spa_DrugCost_Add_Edit_Link_Description)("healthCostAddEditLinkDescription", ctx_r10.Spa_HealthCost_Add_Edit_Link_Description)("selectedTab", ctx_r10.activeTab)("isRetentionView", ctx_r10.isRetentionView)("noCostMedSupPlanText", ctx_r10.noCostMedSupPlanText)("isLiveEdit", ctx_r10.isLiveEdit)("prescriptionDirectoryLink", ctx_r10.Spa_PlanDetails_Preferences_PrescriptionDirectory_Link)("searchProviderLink", ctx_r10.Spa_PlanDetails_Preferences_ProviderDirectory_Link)("searchPrescriptionsText", ctx_r10.Spa_PlanDetails_Preferences_SearchPrescriptions_Text)("searchPharmacyLink", ctx_r10.Spa_PlanDetails_Preferences_PharmacyDirectory_Link)("searchPharmacyText", ctx_r10.Spa_PlanDetails_Preferences_SearchPharmacy_Text)("searchProviderText", ctx_r10.Spa_Plan_Providers_Search_Provider_Text)("providersDirectoryLink", ctx_r10.Spa_Plan_Providers_Directory_Link)("providersInternalDirectoryLink", ctx_r10.Spa_Plan_Providers_Internal_Directory_Link_Text)("providersCarrierDirectoryLink", ctx_r10.Spa_Plan_Providers_Carrier_Directory_Link_Text)("isBothCarrierAndInternalProvidersDirectoryLinksEnabled", ctx_r10.Spa_Plan_Providers_BothCarrierAndInternal_DirectoryLinks_Enabled)("Spa_Site_Tooltip_Text", ctx_r10.Spa_Site_Tooltip_Text)("documentsSection", ctx_r10.documentsSection)("planDetailsText", ctx_r10.Spa_PlanCompare_PlanDocument_Text)("showCosts", ctx_r10.Spa_Site_PlanDetailsAndCompare_Show_Costs_MEDIGAP)("annualCost", ctx_r10.annualCost)("isMultiPharmacyEnabled", ctx_r10.pharmacyFacade.showPharmacySelectorToggle(ctx_r10.detailedPlan.planTypeAbbreviation))("primaryPharmacyText", ctx_r10.Spa_Site_PrimaryPharmacy_Indicator_Text)("primaryPharmacy", i0.ɵɵpipeBind1(2, 152, ctx_r10.pharmacyFacade.getPrimaryPharmacy$()))("selectedPharmacy", ctx_r10.selectedPharmacy)("pharmacies", i0.ɵɵpipeBind1(3, 154, ctx_r10.selectedPharmacies$))("isMailOrderSelected", ctx_r10.isMailOrderSelected)("showTierPharmacyNetworkLabel", ctx_r10.Spa_Site_Show_Pharmacy_Tier_Label)("pharmacyNetworkText", ctx_r10.planDetailsFacade.getPharmacyNetworkText(ctx_r10.detailedPlan, ctx_r10.selectedPharmacy))("mailOrderPharmacyText", ctx_r10.Spa_Site_Mail_Order_Pharmacy_Text)("mailOrderText", ctx_r10.Spa_PlanList_MailOrder_Text)("showMailOrderPharmacy", ctx_r10.Spa_Site_Mail_Order_Pharmacy_Enabled)("providersAddEditLinkTitle", ctx_r10.Spa_Providers_Add_Edit_Link)("inNetworkProviderText", ctx_r10.Spa_Provider_InNetwork_Text)("outOfNetworkProviderText", ctx_r10.Spa_Provider_OutOfNetwork_Text)("noProviderDetailsText", ctx_r10.Spa_Providers_No_Data_Exist_Text)("pcpText", ctx_r10.Spa_Site_Pcp_Text)("selectedProviders", i0.ɵɵpipeBind1(4, 156, ctx_r10.planFacade.selectedProviders$))("providerDetailResponse", ctx_r10.providerDetailResponse)("isPlanPharmacyCovered", ctx_r10.pharmacyFacade.isPlanPharmacyCovered(ctx_r10.detailedPlan))("noProviderNetworkAccessText", ctx_r10.Spa_Providers_NoProviderNetworkAccess_Text)("canSellPlan", ctx_r10.planFacade.canSellPlan(ctx_r10.detailedPlan))("planTotalPremium", ctx_r10.detailedPlanTotalPremium)("showDrugAlternativesEnabled", ctx_r10.Spa_Site_ShowDrugAlternatives_Enabled && ctx_r10.Spa_PlanDetails_ShowDrugAlternatives_Nudge_Enabled)("showDrugAlternativesText", ctx_r10.Spa_Prescriptions_ShowDrugAlternatives_ViewAlternatives_Text)("addHealthCostText", ctx_r10.Spa_HealthCostsTab_AddAgeHealth_Text)("hideText", ctx_r10.Spa_Site_Hide_Text)("viewAllText", ctx_r10.Spa_Site_ViewAll_Text)("providerInfoEnabled", ctx_r10.Spa_Site_Provider_ShowAllInNetworkLocations_Enabled)("providers", ctx_r10.providers)("acceptingNewPatientsIcon", ctx_r10.Spa_Providers_AcceptingNewPatients_Icon)("acceptingNewPatientsText", ctx_r10.Spa_Providers_AcceptingNewPatients_Text)("languagesIcon", ctx_r10.Spa_Providers_Languages_Icon)("providerLanguages", i0.ɵɵpipeBind1(5, 158, ctx_r10.providerLanguages$))("providerMedicalGroups", ctx_r10.providerMedicalGroups)("providersAcceptingNewPatients", i0.ɵɵpipeBind1(6, 160, ctx_r10.providersAcceptingNewPatients$))("countryCode", ctx_r10.countryCode)("planFeesEnabled", ctx_r10.Spa_Site_PlanFees_Enabled)("planFeesLabelText", ctx_r10.Spa_PlanFees_Label_Text)("planFeesIncludedInPremiumTooltipText", ctx_r10.Spa_PlanFees_IncludedInPremium_Tooltip_Text)("planFeesNotIncludedInPremiumTooltipText", ctx_r10.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text)("snpPremiumRangeEnabled", ctx_r10.Spa_Display_SNP_PremiumRange_Enabled)("isVbcAgreementEnabled", ctx_r10.Spa_Site_ValueBasedCare_Agreement_Enabled)("vbcAgreementLabel", ctx_r10.Spa_Site_ValueBasedCare_Agreement_Label)("vbcAgreementTooltip", ctx_r10.Spa_Site_ValueBasedCare_Agreement_Tooltip)("isZelisIntegrationEnabled", ctx_r10.Spa_Site_ZelisIntegration_Enabled);
} }
function PlanDetailsComponent_div_0_vnext_total_costs_details_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-total-costs-details", 48);
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("preferencesBannerEnabled", ctx_r11.Spa_PreferenceBanner_Enabled)("plan", ctx_r11.detailedPlan)("totalCostDescriptionText", ctx_r11.Spa_Site_Total_Costs_Description_Text)("totalEstAnnualCostText", ctx_r11.Spa_PlanDetails_TotalEstimatedAnnual_Cost_Text)("totalEstCostText", ctx_r11.Spa_PlanDetails_TotalEstimatedCost_Text)("totalEstimatedAnnualCostsMonth", ctx_r11.totalEstimatedAnnualCostsMonth)("formularyID", ctx_r11.Spa_Site_Formulary_ID_Text)("formularyVersionText", ctx_r11.Spa_Site_Formulary_Version_Text)("faqContent", ctx_r11.Spa_Total_Cost_FAQ_Text)("prescriptionAddEditLinkTitle", ctx_r11.Spa_Prescription_Add_Edit_Link)("guidedHelpEnabled", ctx_r11.Spa_GuidedHelp_Enabled)("showPrescription", ctx_r11.Spa_Site_Prescriptions_Enabled)("totalCostEquationMA", ctx_r11.totalCostEquationMA)("totalCostEquationMAPD", ctx_r11.totalCostEquationMAPD)("totalCostEquationPDP", ctx_r11.Spa_Total_Costs_Breakdown_Equation_PDP)("planMonthlyEstimatedCostText", ctx_r11.Spa_Plan_Monthly_Estimated_Cost_Text)("monthlyBreakdownDrugLabelText", ctx_r11.Spa_Plan_MonthlyBreakdown_Drug_Label_Text)("monthlyBreakdownDrugPhaseLabelText", ctx_r11.Spa_Plan_MonthlyBreakdown_DrugPhase_Label_Text)("monthlyBreakdownDrugCostLabelText", ctx_r11.Spa_Plan_MonthlyBreakdown_DrugCost_Label_Text)("monthlyBreakdownDeductible", ctx_r11.Spa_Site_MonthlyBreakdownDeductible)("monthlyBreakdownCopay", ctx_r11.Spa_Site_MonthlyBreakdownCopay)("monthlyBreakdownGap", ctx_r11.Spa_Site_MonthlyBreakdownGap)("monthlyBreakdownCatastrophic", ctx_r11.Spa_Site_MonthlyBreakdownCatastrophic)("footnotes", ctx_r11.Spa_PlanDetails_Footnotes)("footnoteHeader", ctx_r11.Spa_PlanDetails_Footnote_Header)("keyNameForLiveEdit", "Spa_Site_Total_Costs_Description_Text")("costBasedOnMailOrderPharmacy", ctx_r11.Spa_PharmacySelection_MailOrderPharmacyCosts_Text)("cantSellPlanCostBasedOnMailOrderPharmacy", ctx_r11.Spa_PharmacySelection_CantSell_MailOrderPharmacyCosts_Text)("costBasedOnRetailPharmacy", ctx_r11.Spa_PharmacySelection_RetailPharmacyCosts_Text)("cantSellPlanCostBasedOnRetailPharmacy", ctx_r11.Spa_PharmacySelection_CantSell_RetailPharmacyCosts_Text)("costBasedOnSelectedPharmacy", ctx_r11.Spa_PharmacySelection_AddPharmacy_Text)("switchToMailLinkText", ctx_r11.Spa_PharmacySelection_Switch_To_MailOrder_Costs_Text)("switchToRetailLinkText", ctx_r11.Spa_PharmacySelection_Switch_To_Retail_Costs)("addPharmacyLink", ctx_r11.Spa_PharmacySelection_Add_Link_Text)("editPharmacyLink", ctx_r11.Spa_PharmacySelection_Edit_Link_Text)("showPharmacy", ctx_r11.Spa_Site_Pharmacy_Enabled)("isMailOrder", ctx_r11.isMailOrderSelected)("selectedPharmacy", ctx_r11.selectedPharmacy)("addEditLinkDescription", ctx_r11.Spa_Prescription_Add_Edit_Link_Description)("selectedTab", ctx_r11.activeTab)("isRetentionView", ctx_r11.isRetentionView)("noCostMedSupPlanText", ctx_r11.noCostMedSupPlanText)("hideRetailMailOrderCost", ctx_r11.pharmacyFacade.showPharmacySelectorToggle(ctx_r11.detailedPlan.planTypeAbbreviation))("annualCost", ctx_r11.annualCost)("effectiveDateLabel", ctx_r11.Spa_TotalCost_EffectiveDateLabel_Text)("effectiveDateDropDownItems", ctx_r11.effectiveDateDropDownItems)("selectedValue", ctx_r11.selectedValue)("selectedMonthIndex", ctx_r11.selectedMonthIndex);
} }
function PlanDetailsComponent_div_0_vnext_health_costs_details_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-health-costs-details", 49);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("preferencesBannerEnabled", ctx_r12.Spa_PreferenceBanner_Enabled)("modalHeaderHealthText", ctx_r12.Spa_Site_Health_Text)("closeButtonText", ctx_r12.Spa_Site_Close_Modal)("healthCostsBodyText", ctx_r12.Spa_HealthCosts_Body_Text)("healthCostsBenefitsBodyText", ctx_r12.Spa_HealthCosts_Benefits_Body_Text)("saveSuccessText", ctx_r12.Spa_Site_HealthCosts_Save_Success_Text)("healthCostsRestoreDefaultsText", ctx_r12.Spa_Site_HealthCosts_Restore_Defaults_Text)("healthCostsUpdateAnswersText", ctx_r12.Spa_Site_HealthCosts_Update_Answers_Text)("healthCostsSaveAnswersText", ctx_r12.Spa_Site_HealthCosts_Save_Answers_Text)("saveFailedText", ctx_r12.Spa_Site_HealthCosts_Save_Failed_Text)("healthAgeQuestionText", ctx_r12.Spa_GuidedHelp_Health_AgeQuestion_Text)("healthCostsCustomizationEnabled", ctx_r12.Spa_Site_HealthCosts_Customization_Enabled)("healthSliderHeader1Text", ctx_r12.Spa_GuidedHelp_Health_SliderHeader1_Text)("healthSliderHeader2Text", ctx_r12.Spa_GuidedHelp_Health_SliderHeader2_Text)("healthSliderHeader3Text", ctx_r12.Spa_GuidedHelp_Health_SliderHeader3_Text)("healthSliderBody1", ctx_r12.Spa_GuidedHelp_Health_SliderBody1)("healthSliderBody2", ctx_r12.Spa_GuidedHelp_Health_SliderBody2)("healthSliderBody3", ctx_r12.Spa_GuidedHelp_Health_SliderBody3)("healthSliderLabelText", ctx_r12.Spa_Site_Health_Slider_Label_Text)("healthModalView1HeadingText", ctx_r12.Spa_AddHealth_ModalView1_HeadingText)("healthModalView1IntroText", ctx_r12.Spa_AddHealth_ModalView1_IntroText)("annualCost", ctx_r12.annualCost)("plan", ctx_r12.detailedPlan)("addHealthCostText", ctx_r12.Spa_HealthCostsTab_AddAgeHealth_Text)("healthCostsDescriptionText", ctx_r12.Spa_Site_Health_Costs_Description_Text)("noHealthCostTitle", ctx_r12.Spa_HealthCostsTab_NoCostTitle_Text)("introHealthCostTitle", ctx_r12.Spa_HealthCostsTab_Intro_Text)("healthCostsBenefitsTableHeader", ctx_r12.Spa_HealthCosts_Benefits_Table_Header_Text)("healthCostsUsageTableHeader", ctx_r12.Spa_HealthCosts_Usage_Table_Header_Text)("healthCostsDaysTableHeader", ctx_r12.Spa_HealthCosts_Days_Table_Header_Text)("healthCostsUsageTableMobileText", ctx_r12.Spa_HealthCosts_Usage_Table_Mobile_Text)("healthCostsDaysTableMobileText", ctx_r12.Spa_HealthCosts_Days_Table_Mobile_Text)("healthEstimatedCostTableHeader", ctx_r12.Spa_HealthCosts_EstCost_Table_Header_Text)("subTotalText", ctx_r12.Spa_HealthCosts_Subtotal_Text)("healthCostsBenefits", ctx_r12.Spa_Site_HealthCosts_Benefits_JSON)("totalEstimatedCostText", ctx_r12.Spa_PlanDetails_TotalEstimatedCost_Text)("totalEstimatedAnnualCostText", ctx_r12.Spa_PlanDetails_EstimatedHealthCosts_Text)("healthCostsOutOfPocketText", ctx_r12.Spa_PlanDetails_HealthCosts_Out_Of_Pocket_Text)("healthCostsMedicalDeductibleText", ctx_r12.Spa_PlanDetails_HealthCosts_MedicalDeductible_Text)("selectedTab", ctx_r12.activeTab)("isRetentionView", ctx_r12.isRetentionView)("noCostMedSupPlanText", ctx_r12.noCostMedSupPlanText);
} }
function PlanDetailsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "div", 4);
    i0.ɵɵtemplate(5, PlanDetailsComponent_div_0_vnext_link_5_Template, 1, 4, "vnext-link", 5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 3)(7, "div", 6);
    i0.ɵɵelementContainerStart(8, 7);
    i0.ɵɵtemplate(9, PlanDetailsComponent_div_0_div_9_Template, 3, 1, "div", 8);
    i0.ɵɵtemplate(10, PlanDetailsComponent_div_0_h1_10_Template, 2, 1, "h1", 9);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 10);
    i0.ɵɵtemplate(12, PlanDetailsComponent_div_0_div_12_Template, 2, 4, "div", 11);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(13, PlanDetailsComponent_div_0_div_13_Template, 11, 7, "div", 12);
    i0.ɵɵtemplate(14, PlanDetailsComponent_div_0_div_14_Template, 2, 8, "div", 0);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "div", 2)(16, "div", 13)(17, "div", 14);
    i0.ɵɵelement(18, "vnext-widget-plan-details-card", 15);
    i0.ɵɵtemplate(19, PlanDetailsComponent_div_0_vnext_pharmacy_selector_19_Template, 2, 17, "vnext-pharmacy-selector", 16);
    i0.ɵɵelement(20, "vnext-effective-date-display", 17);
    i0.ɵɵtemplate(21, PlanDetailsComponent_div_0_div_21_Template, 2, 12, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 19);
    i0.ɵɵtemplate(23, PlanDetailsComponent_div_0_vnext_plan_prescription_details_23_Template, 3, 58, "vnext-plan-prescription-details", 20);
    i0.ɵɵtemplate(24, PlanDetailsComponent_div_0_vnext_plan_sub_details_24_Template, 7, 162, "vnext-plan-sub-details", 21);
    i0.ɵɵtemplate(25, PlanDetailsComponent_div_0_vnext_total_costs_details_25_Template, 1, 48, "vnext-total-costs-details", 22);
    i0.ɵɵtemplate(26, PlanDetailsComponent_div_0_vnext_health_costs_details_26_Template, 1, 42, "vnext-health-costs-details", 23);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("liveEditProp", "isDeepLink ? Spa_Site_Plan_List_Link : Spa_Site_Previous");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngSwitch", ctx_r0.detailedPlan.planTypeAbbreviation);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.planTypeAbbreviation.HC);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_PageSubHeader_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isHCPlan);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isHCPlan);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r0.Spa_PlanDetails_StickyMiniCart_Enabled && !ctx_r0.isMobile ? "pt-4 pb-4 pt-sm-0 mt-0 mt-sm-4 h-100 sticky" : "mt-4");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", ctx_r0.detailedPlan)("planTotalPremium", ctx_r0.detailedPlanTotalPremium)("currentPlanText", ctx_r0.Spa_Site_Current_Plan_Text)("nextYearPlanText", ctx_r0.Spa_Site_Next_Year_Plan_Text)("quoteLinkText", ctx_r0.Spa_PlanCard_QuoteLinkName_Text)("sendQuoteButtonText", ctx_r0.Spa_Site_SendQuote_Button_Text)("monthlyPremiumText", ctx_r0.Spa_Site_HIP_MonthlyPremium_Text)("planLogoSize", ctx_r0.Spa_Site_PlanLogo_Size)("displayOptionLabels", ctx_r0.Spa_Retention_ClientDefinedPlanOptions_Enabled)("nonCommissionableText", ctx_r0.Spa_PlanDetails_NonCommissionable_Text)("isNonCommissionableFlagCheckEnabled", ctx_r0.Spa_PlanDetails_NonCommissionable_FlagCheck_Enabled)("optionOneText", ctx_r0.Spa_Site_Plan_Option_One_Text)("optionTwoText", ctx_r0.Spa_Site_Plan_Option_Two_Text)("stickyMiniCartEnabled", ctx_r0.Spa_PlanDetails_StickyMiniCart_Enabled)("planFeesEnabled", ctx_r0.Spa_Site_PlanFees_Enabled)("planFeesTooltipText", ctx_r0.Spa_PlanFees_Tooltip_Text)("planFeesIncludedInPremiumTooltipText", ctx_r0.Spa_PlanFees_IncludedInPremium_Tooltip_Text)("planFeesNotIncludedInPremiumTooltipText", ctx_r0.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text)("snpPremiumRangeEnabled", ctx_r0.Spa_Display_SNP_PremiumRange_Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.planDetailsFacade.showPharmacySelectorToggle(ctx_r0.detailedPlan));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("activePlanType", ctx_r0.detailedPlan.planTypeAbbreviation);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.Spa_PlanList_Tab_Show_HIP && ctx_r0.Spa_PlanDetails_HIP_Call_Out_Enabled && ctx_r0.isHIPCallOutAvailableToDetailedPlan && ctx_r0.hasHospitalIndemnityQuestions && ctx_r0.showHospitalCareCalloutBasedHidingStatesCoverage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r0.activeTab);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.planDetailsTabs.PRESCRIPTIONS);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.planDetailsTabs.PLAN_DETAILS);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.planDetailsTabs.TOTAL_COSTS);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.planDetailsTabs.HEALTH_COSTS);
} }
let PlanDetailsComponent = class PlanDetailsComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, passParameterService, deactivationGuardService, planDetailsFacade, activatedRoute, store, footnoteFacade, planFacade, plansService, pharmacyContext, configResourceService, planListFacade, siteService, localeService, pharmacyFacade, providerService, providerFacade, pharmacyService, drugCabinetContext, medSupService, hospitalIndemnityFormFacade, responsiveLayoutService, injector, guidedHelpModalService, guidedHelpModalContextService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.passParameterService = passParameterService;
        this.deactivationGuardService = deactivationGuardService;
        this.planDetailsFacade = planDetailsFacade;
        this.activatedRoute = activatedRoute;
        this.store = store;
        this.footnoteFacade = footnoteFacade;
        this.planFacade = planFacade;
        this.plansService = plansService;
        this.pharmacyContext = pharmacyContext;
        this.configResourceService = configResourceService;
        this.planListFacade = planListFacade;
        this.siteService = siteService;
        this.localeService = localeService;
        this.pharmacyFacade = pharmacyFacade;
        this.providerService = providerService;
        this.providerFacade = providerFacade;
        this.pharmacyService = pharmacyService;
        this.drugCabinetContext = drugCabinetContext;
        this.medSupService = medSupService;
        this.hospitalIndemnityFormFacade = hospitalIndemnityFormFacade;
        this.responsiveLayoutService = responsiveLayoutService;
        this.injector = injector;
        this.guidedHelpModalService = guidedHelpModalService;
        this.guidedHelpModalContextService = guidedHelpModalContextService;
        // defaultDescriptionContent is used as a default for some resources so it's defined here instead of with the rest of the local vars
        this.defaultDescriptionContent = `Limitations, copayments, and restrictions may apply. See above or contact the plan for more details.
  <br /><br />
  *Enrollee must continue to pay the medicarepart B premium.
  <br /><br />
  You may be able to get extra help to pay for your precription drug premium and costs. To see if you qualify for extra help, call:
  <ul style="list-style-type:disc;">
    <li>1-800-MEDICARE (1-800-633-4227). TTY users should call 1-877-486-2048. 24 hours a day, 7 days a week.</li>
    <li>The social security office at 1-800-722-1213. TTY users should call 1-800-325-0778. Monday through Friday, 7 a.m. to 7 p.m.</li>
    <li>Your state medicaid office.</li>
  </ul>`;
        // #region resources
        this.Spa_Site_Yes = 'Yes';
        this.Spa_Site_No = 'No';
        this.Spa_Site_Health_Costs_Description_Text = 'Estimated costs below are what you should expect to pay this year based on how often you expect to use each benefit.';
        this.Spa_HealthCosts_Benefits_Table_Header_Text = 'Health Benefit';
        this.Spa_HealthCosts_Usage_Table_Header_Text = 'Visits/Uses';
        this.Spa_HealthCosts_Days_Table_Header_Text = 'Total days';
        this.Spa_HealthCosts_EstCost_Table_Header_Text = 'Est medical cost';
        this.Spa_PlanDetails_EstimatedHealthCosts_Text = 'Estimated annual out of pocket medical cost';
        this.Spa_HealthCosts_Subtotal_Text = 'Subtotal';
        this.Spa_HealthCosts_Usage_Table_Mobile_Text = 'visits';
        this.Spa_HealthCosts_Days_Table_Mobile_Text = 'total days';
        this.Spa_PlanDetails_HealthCosts_MedicalDeductible_Text = `This plan has a <medicalDeductibleValue> medical deductible.
  You will pay the full cost for applicable services until the deductible is reached.
  To learn more see the plan Summary of Benefits on the Plan Details tab.`;
        this.Spa_PlanDetails_HealthCosts_Out_Of_Pocket_Text = 'This plan has a <medicalMaxOutOfPocketValue> In-network Out of Pocket Max.';
        this.Spa_HealthCosts_Benefits_Body_Text = 'Decide how often you might use these benefits annually to help estimate medical costs for each plan';
        this.Spa_Site_HealthCosts_Save_Failed_Text = 'Server error. Please try again.';
        this.Spa_Site_HealthCosts_Benefits_Table_Header = 'Benefit';
        this.Spa_Site_HealthCosts_Usage_Table_Header = 'Visits/Uses';
        this.Spa_Site_HealthCosts_Days_Table_Header = 'Total days';
        this.Spa_Site_HealthCosts_Restore_Defaults_Text = 'Restore defaults';
        this.Spa_Site_HealthCosts_Update_Answers_Text = 'Update answers';
        this.Spa_Site_HealthCosts_Save_Answers_Text = 'Save';
        this.Spa_Site_HealthCosts_Save_Success_Text = 'Saved';
        this.Spa_Site_Close_Modal = 'Close';
        this.Spa_Site_HealthCosts_Benefits_JSON = [];
        this.Spa_HealthCosts_Body_Text = 'Would you like to estimate your medical costs?';
        this.Spa_Site_Health_Slider_Label_Text = 'Select health status range';
        this.Spa_PlanDetails_NonCommissionable_Text = 'Non-Commissionable';
        this.Spa_PlanDetails_NonCommissionable_FlagCheck_Enabled = false;
        this.Spa_AddHealth_ModalView1_IntroText = 'Your health status helps calculate your estimated cost. It will not affect your premiums.';
        this.Spa_AddHealth_ModalView1_HeadingText = 'Estimate health costs';
        this.Spa_GuidedHelp_Health_AgeQuestion_Text = 'How old are you?';
        this.Spa_GuidedHelp_Health_SliderHeader1_Text = 'Generally healthy test';
        this.Spa_GuidedHelp_Health_SliderHeader2_Text = 'Some health needs';
        this.Spa_GuidedHelp_Health_SliderHeader3_Text = 'Significant health needs';
        this.Spa_GuidedHelp_Health_SliderBody1 = 'No major illnesses <br /> Less than 2 prescriptions for an illness <br /> Less than 2 visits to primary care';
        this.Spa_GuidedHelp_Health_SliderBody2 = 'Ongoing condition like diabetes <br /> Regular prescription needs <br /> 1 or more visits to a specialist';
        this.Spa_GuidedHelp_Health_SliderBody3 = 'Multiple prescriptions <br /> Managing a serious condition <br /> Multiple visits to specialists';
        this.Spa_PlanCard_QuoteLinkName_Text = 'Get a personalized quote';
        this.Spa_PlanDetails_Costs_Premium = 'Premium';
        this.Spa_Plan_Benefits_Section_Name = 'Benefits';
        this.Spa_Plan_Details_Preferences_Pharmacy_Text = 'Pharmacy';
        this.Spa_Plan_Details_Preferences_Text = 'Preferences';
        this.Spa_Plan_Details_OtherPreferences_Text = 'Other preferences';
        this.Spa_Plan_Details_Preferences_Expanded = true;
        this.Spa_Plan_Details_Preferences_Position_Last = true;
        this.Spa_Plan_Details_Show_Preferences = true;
        this.Spa_Plan_Details_Preferences_Show_Provider = true;
        this.Spa_Plan_Details_Preferences_Show_Prescription = true;
        this.Spa_Plan_Details_Preferences_Show_Pharmacy = true;
        this.Spa_Site_OtherPreferences_Enabled = false;
        this.Spa_Site_Prescriptions_Enabled = true;
        this.Spa_Site_Pharmacy_Enabled = true;
        this.Spa_Site_HealthCosts_Customization_Enabled = true;
        this.Spa_Site_ZelisIntegration_Enabled = false;
        this.Spa_PlanCard_Benefit_DentalDeductible_Text = 'Dental Deductible';
        this.Spa_PlanCard_Benefit_CalendarYearMax_Text = 'Calendar Year Maximum';
        this.Spa_PlanCard_Benefit_VisionDeductible_Text = 'Vision Deductible';
        this.Spa_Plan_Details_Preferences_Provider_Text = 'Provider';
        this.Spa_Plan_Details_Preferences_Prescription_Text = 'Prescription';
        this.Spa_Plan_Details_AddOnRiders_Header = 'Optional add-on coverage';
        this.Spa_Site_PageSubHeader_Text = '';
        this.Spa_Plan_Details_AddOnRiders_SubHeader = '(available in cart)';
        this.Spa_Plan_Details_Providers_Link = 'Medical provider Directory(PDF)';
        this.Spa_Plan_Details_Pharmacy_Link = 'Pharmacy link (PDF)';
        this.Spa_Plan_Providers_Search_Provider_Text = 'Search Provider';
        this.Spa_Plan_Providers_Directory_Link = 'Provider directory';
        this.Spa_Plan_Providers_Internal_Directory_Link_Text = 'Internal provider directory';
        this.Spa_Plan_Providers_Carrier_Directory_Link_Text = 'Carrier’s provider directory';
        this.Spa_Plan_Providers_BothCarrierAndInternal_DirectoryLinks_Enabled = false;
        this.Spa_PlanList_Tab_Show_HIP = false;
        this.Spa_PlanList_HIPFormPrompt_Text = 'Hospital indemnity plan premiums and eligibility may vary. Please provide the following additional information' +
            ' to calculate your plan premiums and determine if you are eligible for enrollment in the plan.';
        this.Spa_PlanList_HIP_PageTitle_Text = 'Hospital Indemnity Information';
        this.Spa_PlanDetails_Preferences_ProviderDirectory_Link = {
            title: this.Spa_Plan_Providers_Directory_Link,
            tag: 'HelpfulToolsPharmacySearch',
            href: ''
        };
        this.Spa_Plan_Details_WaiverStateRider_Tooltips = [
            {
                id: 'Combined Rider',
                body: 'This optional plan benefit is a combination of riders for one price.'
            },
            {
                id: 'Part A Deductible',
                body: `"Part A Deductible" covers the amount that you must pay for inpatient hospital stays before Medicare begins to pay.`
            },
            {
                id: 'Part B Deductible',
                body: `"Part B Deductible" covers the amount that you must pay for Medicare-approved
           Part B medical services before Medicare Part B begins to pay.`
            },
            {
                id: 'Part B Excess',
                body: `"Part B Excess Charges" covers the  difference between the Medicare eligible charge and the amount charged by
          the provider which shall be no greater than the actual charge or the limited charge allowed by Medicare, whichever is less.`
            },
            {
                id: 'Preventive Care',
                body: `"Preventive Care"  pays up to $120 a year for covered preventive screening
           test and services and an annual physical examination.`
            },
            {
                id: 'Usual and Customary Fees',
                body: `"Usual and Customary Charges Fees" covers the difference between the Medicare eligible charge and the amount charged by
           the provider which shall be no greater than the actual charge or the limited charge allowed by Medicare, whichever is less.`
            },
            {
                id: 'Part B Excess Charges',
                body: `Part B Excess Charges" covers the  difference between the Medicare eligible charge
        and the amount charged by the provider which shall be no greater than the actual charge or
        the limited charge allowed by Medicare, whichever is less.`
            },
            {
                id: 'Additional Home Health Care',
                body: ` "Additional Home Health" extends home care visits up to 365 visits per policy year.`
            },
            {
                id: 'Foreign Travel Emergency',
                body: ` "Foreign Travel Emergency" covers at least 80% of eligible expenses associated with emergency
          medical care received outside the U.S.A. beginning the first 60 days of a trip up to a
          lifetime maximum of $50,000 (after a  deductible of $250).`
            },
            {
                id: 'Co-Pay Rider',
                body: ` "Co-Pay Rider" pays the Part B coinsurance subject to a copayment or coinsurance of no more
          than $20 per office visit and no more than $50 per emergency room visit that is in
          addition to the Medicare Part B medical deductible  and in addition to out-pocket maximums.`
            },
            {
                id: '50% Part A Deductible',
                body: `"50% of Part A Deductible" pays 50% of the inpatient deductible for qualifying hospital stays.`
            },
            {
                id: 'Part B Copayment or Coinsurance',
                body: `"Part B Copayment or Coinsurance" covers the amount you must pay as your share of the cost for medical services.
          Copayment is usually a set amount whereas coinsurance is a percentage.`
            }
        ];
        this.Spa_MedSup_RestrictMedSupPlansByAge_InfoLink = 'edit your answers';
        this.Spa_MedSup_RestrictMedSupPlansByAge_InfoText = `Medicare Supplement plans for the selected birthday
   and effective date cannot be added to your cart until you are within 90 days of your
   65th birthday. Please try again closer to your 65th birthday or`;
        this.Spa_ShoppingCart_IncludedRider_Text = 'Included';
        // Prescriptions tab
        this.Spa_PrescriptionsTab_AddPrescriptionButton_Text = 'Add prescriptions';
        this.Spa_PrescriptionsTab_NotInTier_Text = 'None of your prescriptions are in this tier';
        this.Spa_PrescriptionsTab_NonCovered_Text = 'Non-covered prescriptions';
        this.Spa_PrescriptionsTab_Covered_Text = 'Covered prescriptions';
        this.Spa_PrescriptionsTab_NoCostTitle_Text = 'No costs available';
        this.Spa_PrescriptionsTab_Intro_Text = 'Add prescriptions to your list if you would like to view estimated annual cost';
        this.Spa_Add_Prescriptions_Button_Text = 'Add prescriptions';
        this.Spa_None_Prescriptions_Text = 'None of your prescriptions are in this tier';
        this.Spa_Non_Covered_Prescriptions_Text = 'Non-covered prescriptions';
        this.Spa_Covered_Prescriptions_Text = 'Covered prescriptions';
        this.Spa_Pharmacy_InNetwork_Preferred_Pricing_Text = 'In-network pharmacy with preferred pricing';
        this.Spa_Pharmacy_InNetwork_Standard_Pricing_Text = 'In-network pharmacy with standard pricing';
        this.Spa_Pharmacy_OutOfNetwork_Pricing_Text = 'Out-of-network pharmacy';
        this.Spa_PlanDetails_Covered_Text = 'Covered';
        this.Spa_PlanDetails_Non_Covered_Text = 'Not Covered';
        this.Spa_PlanDetails_TotalEstimatedAnnual_Cost_Text = 'Total estimated annual cost';
        this.Spa_PlanDetails_TotalEstimatedCost_Text = 'Total estimated cost';
        this.Spa_GuidedHelp_Enabled = true;
        this.Spa_Site_Health_Enabled = true;
        this.Spa_PharmacySelection_RetailPharmacyCosts_Text = 'Costs based on retail pharmacy';
        this.Spa_PharmacySelection_CantSell_RetailPharmacyCosts_Text = 'Costs based on retail pharmacy';
        this.Spa_PharmacySelection_MailOrderPharmacyCosts_Text = 'Costs based on mail order pharmacy';
        this.Spa_PharmacySelection_CantSell_MailOrderPharmacyCosts_Text = 'Costs based on mail order pharmacy';
        this.Spa_PharmacySelection_AddPharmacy_Text = 'Costs based on your selected pharmacy of';
        this.Spa_PharmacySelection_Switch_To_MailOrder_Costs_Text = 'Switch to Mail order costs';
        this.Spa_PharmacySelection_Switch_To_Retail_Costs = 'Switch to retail costs';
        this.Spa_PharmacySelection_Add_Link_Text = 'Add Pharmacy';
        this.Spa_PharmacySelection_Edit_Link_Text = 'Edit';
        this.Spa_Site_Show_GenericDrugOption = true;
        this.Spa_DrugCost_Add_Edit_Link_Description = 'Add or edit Drug Cost';
        this.Spa_HealthCost_Add_Edit_Link_Description = 'Add or edit Health Cost';
        this.Spa_Site_Tooltip_Text = 'Tooltip:';
        this.Spa_Site_PlanDetailsAndCompare_Show_Costs_MEDIGAP = false;
        this.Spa_Site_Previous = 'Previous';
        this.Spa_PlanLevel_Content_Label_PDP = 'Plan Highlights PDP';
        this.Spa_PlanLevel_Content_Label_MAPD = 'Plan Highlights MAPD';
        this.Spa_PlanLevel_Content_Label_MA = 'Plan Highlights MA';
        this.Spa_PlanLevel_Content_Label_MEDIGAP = 'Plan Highlights MEDIGAP';
        this.Spa_PlanLevel_Content_Label_DENTAL = 'Additional Information';
        this.Spa_PlanLevel_Content_Label_VISION = 'Additional Information';
        this.Spa_PlanLevel_Content_Label_HIP = 'Additional Information';
        this.Spa_Show_Plan_Level_Content = true;
        this.Spa_Plandetails_Costs_Add_Edit_Link_Text = 'Add/edit';
        this.Spa_Site_Health_Text = 'Health';
        this.Spa_PlanDetails_Health_Cost_Text = `${this.Spa_Site_Health_Text} Costs`;
        this.Spa_Plandetails_Costs_MAPD = [
            {
                title: PlanDetailsCostLabels.DRUG_COST,
                subText: 'Based on <totalDrugs> drugs',
                label: 'Annually Est Drug Cost',
                label2: 'Est Drug Cost',
                duration: 'annually',
                duration2: 'partial annually'
            },
            {
                title: PlanDetailsCostLabels.HEALTH_COST,
                subText: 'Estimated medical costs based on age <ageRange> and <healthStatus>.',
                label: 'Annually Health Cost',
                label2: 'Health Cost',
                duration: 'annually',
                duration2: 'partial annually'
            },
            {
                title: PlanDetailsCostLabels.TOTAL_ESTIMATED_COST,
                subText: 'Based on medical and drug costs.',
                label: 'Total est annual cost',
                label2: 'Total est cost',
                duration: 'annually',
                duration2: 'partial annually'
            }
        ];
        this.Spa_Plandetails_Costs_MA = [
            {
                title: PlanDetailsCostLabels.HEALTH_COST,
                subText: 'Estimated medical costs based on age <ageRange> and <healthStatus>.',
                label: 'Annually Health Cost',
                label2: 'Health Cost',
                duration: 'annually',
                duration2: 'partial annually'
            },
            {
                title: PlanDetailsCostLabels.TOTAL_ESTIMATED_COST,
                subText: 'Based on medical and drug costs.',
                label: 'Total est annual cost',
                label2: 'Total est cost',
                duration: 'annually',
                duration2: 'partial annually'
            }
        ];
        this.Spa_Plandetails_Costs_MEDIGAP = [
            {
                title: PlanDetailsCostLabels.HEALTH_COST,
                subText: 'Estimated medical costs based on age <ageRange> and <healthStatus>.',
                label: 'Health Cost',
                duration: 'annually'
            },
            {
                title: PlanDetailsCostLabels.TOTAL_ESTIMATED_COST,
                subText: 'Based on medical costs.',
                label: 'Total est annual cost',
                duration: 'annually'
            }
        ];
        this.Spa_Plandetails_Costs_PDP = [
            {
                title: PlanDetailsCostLabels.DRUG_COST,
                subText: 'Based on <totalDrugs> drugs',
                label: 'Annually Est Drug Cost',
                label2: 'Est Drug Cost',
                duration: 'annually',
                duration2: 'partial annually'
            },
            {
                title: PlanDetailsCostLabels.TOTAL_ESTIMATED_COST,
                subText: 'Based on medical and drug costs.',
                label: 'Total est annual cost',
                label2: 'Total est cost',
                duration: 'annually',
                duration2: 'partial annually'
            }
        ];
        this.Spa_PlanDetails_Costs_DENTAL = [
            {
                title: PlanDetailsCostLabels.PLAN_FEES,
                label: 'Fees',
                subText: '',
                duration: ''
            }
        ];
        this.Spa_PlanDetails_Costs_VISION = [
            {
                title: PlanDetailsCostLabels.PLAN_FEES,
                label: 'Fees',
                subText: '',
                duration: ''
            }
        ];
        this.Spa_PlanDetails_Costs_HIP = [
            {
                title: PlanDetailsCostLabels.PLAN_FEES,
                label: 'Fees',
                subText: '',
                duration: ''
            }
        ];
        this.Spa_Total_Costs_Breakdown_Equation_MA = [
            {
                title: 'premium',
                label: 'Premium'
            },
            {
                title: 'healthCost',
                label: 'Health Cost'
            }
        ];
        this.Spa_Total_Costs_Breakdown_Equation_MAPD = [
            {
                title: 'premium',
                label: 'Premium'
            },
            {
                title: 'drugCost',
                label: 'Drug cost'
            },
            {
                title: 'healthCost',
                label: 'Health cost'
            }
        ];
        this.Spa_Total_Costs_Breakdown_Equation_PDP = [
            {
                title: 'premium',
                label: 'Premium'
            },
            {
                title: 'drugCost',
                label: 'Drug cost'
            }
        ];
        this.Spa_PlanDetails_Bottom_Content_Header = 'Plan';
        this.Spa_PlanDetails_Bottom_Content_Text_PDP = this.defaultDescriptionContent;
        this.Spa_PlanDetails_Bottom_Content_Text_MAPD = this.defaultDescriptionContent;
        this.Spa_PlanDetails_Bottom_Content_Text_MA = this.defaultDescriptionContent;
        this.Spa_PlanDetails_Bottom_Content_Text_MEDIGAP = this.defaultDescriptionContent;
        this.Spa_PlanDetails_Bottom_Content_Text_DENTAL = '';
        this.Spa_PlanDetails_Bottom_Content_Text_VISION = '';
        this.Spa_PlanDetails_Bottom_Content_Text_HIP = '';
        this.Spa_PlanDetails_Costs_Header = 'Costs';
        this.Spa_Prescription_Add_Edit_Link = 'Add/edit prescription list';
        this.Spa_Site_Pharmacy_AddEdit_Link = 'Add/edit pharmacy';
        this.Spa_Site_Preferences_AddEdit_Link = 'Add/edit other preferences';
        this.Spa_Site_Total_Costs_TabText = 'Total costs';
        this.Spa_Site_Total_Costs_Description_Text = `Based on your health, age and prescriptions you've entered,
  these are the prices you should expect to pay each month. These values are approximate and are updated every two weeks.`;
        this.Spa_Site_Total_Est_Cost_Month_1 = 'January';
        this.Spa_Site_Total_Est_Cost_Month_2 = 'February';
        this.Spa_Site_Total_Est_Cost_Month_3 = 'March';
        this.Spa_Site_Total_Est_Cost_Month_4 = 'April';
        this.Spa_Site_Total_Est_Cost_Month_5 = 'May';
        this.Spa_Site_Total_Est_Cost_Month_6 = 'June';
        this.Spa_Site_Total_Est_Cost_Month_7 = 'July';
        this.Spa_Site_Total_Est_Cost_Month_8 = 'August';
        this.Spa_Site_Total_Est_Cost_Month_9 = 'September';
        this.Spa_Site_Total_Est_Cost_Month_10 = 'October';
        this.Spa_Site_Total_Est_Cost_Month_11 = 'November';
        this.Spa_Site_Total_Est_Cost_Month_12 = 'December';
        this.Spa_Site_Formulary_ID_Text = 'Formulary ID:';
        this.Spa_Site_Formulary_Version_Text = 'No changes made since:';
        this.Spa_Site_MonthlyBreakdownDeductible = 'Deductible';
        this.Spa_Site_MonthlyBreakdownCopay = 'Copay';
        this.Spa_Site_MonthlyBreakdownGap = 'Gap';
        this.Spa_Site_MonthlyBreakdownCatastrophic = 'Catastrophic';
        this.Spa_Site_SendQuote_Button_Text = 'Send quote';
        this.Spa_Site_NotApplicable_Text = 'n/a';
        this.Spa_Plan_Details_ViewRiderDetails_Text = 'View details';
        this.Spa_Plan_Details_HideRiderDetails_Text = 'Hide details';
        this.Spa_Site_RiderDetails_Show = true;
        this.Spa_Plan_Monthly_Estimated_Cost_Text = 'Monthly est. cost';
        this.Spa_Plan_MonthlyBreakdown_Drug_Label_Text = 'Drug';
        this.Spa_Plan_MonthlyBreakdown_DrugPhase_Label_Text = 'Phase';
        this.Spa_Plan_MonthlyBreakdown_DrugCost_Label_Text = 'Drug cost';
        this.Spa_HealthCostsTab_AddAgeHealth_Text = 'Add health information';
        this.Spa_HealthCostsTab_NoCostTitle_Text = 'No costs available';
        this.Spa_HealthCostsTab_Intro_Text = 'Add health information if you would like to view estimated annual costs';
        this.Spa_Prescriptions_FAQ_Text = '';
        this.Spa_Total_Cost_FAQ_Text = `
  <h5 class='Spa_Style_Larger_Font Spa_Style_Primary_Color mt-5 mb-3 pb-4 faq-border-bottom'>
  Frequently asked questions</h5>
  <div class='faq-border-bottom Spa_Style_Primary_Color'>
  <div class='Spa_Style_Large_Font mb-3'><strong>What are the differences between the coverage phases?</strong></div>
  <ul class='Spa_Style_Small_Font p-0 ml-3 mt-1'>
    <li>
      <div><strong>Full price (Deductible period)</strong></div>
      <p class='Spa_Style_Light_Weight'>
        Until you meet your Part D deductible, you will pay the full negotiated price for your covered prescription drugs. Once you have met
        the deductible, the plan will begin to cover the cost of your drugs. While deductibles can vary from plan to plan, no plan’s
        deductible can be higher than $415 in 2019, and some plans have no deductible.
      </p>
    </li>
    <li>
      <div><strong>Before gap (Initial coverage period)</strong></div>
      <p class='Spa_Style_Light_Weight'>
        After you meet your deductible, your plan will help pay for your covered prescription drugs. Your plan will pay some of the cost,
        and you will pay a copayment or coinsurance. How long you stay in the initial coverage period depends on your drug costs and your
        plan’s benefit structure. For most plans in 2019, the initial coverage period ends after you have accumulated $3,820 in total drug
        costs. Note: Total drug costs include the amount you and your plan have paid for your covered drugs.
      </p>
    </li>
    <li>
      <div><strong>During gap</strong></div>
      <p class='Spa_Style_Light_Weight'>
        After your total drug costs reach a certain amount ($3,820 for most plans), you enter the coverage gap, also known as the donut
        hole. During this period, your plan does not pay for your drugs. However, as a result of health reform there are federally funded
        discounts that help you pay for your drugs during the donut hole. In 2019, there is a 75% discount for most brand-name drugs, paid
        for by the manufacturer and the federal government. This means you pay the remaining 25% of the cost for brand-name drugs.
        Similarly, the government provides a 63% discount for generic drugs. This means you pay the remaining 37% of the cost for generics.
      </p>
    </li>
    <li>
      <div><strong>After gap (Catastrophic coverage)</strong></div>
      <p class='Spa_Style_Light_Weight mb-4'>
        In all Part D plans, after you have paid $5,100 in 2019 in out-of-pocket costs for covered drugs (this amount is just the amount you
        have paid, not the total drug costs that you and your plan have paid), you reach catastrophic coverage. During this period, you pay
        significantly lower copays or coinsurance for your covered drugs for the remainder of the year.
      </p>
    </li>
  </ul>
</div>
<div class='faq-border-bottom Spa_Style_Primary_Color'>
  <div class='Spa_Style_Large_Font mt-3 mb-3'><strong>What is the difference between a retail and mail order pharmacy?</strong></div>
  <ul class='Spa_Style_Small_Font p-0 ml-3 mt-1'>
    <li>
      <div><strong>Retail pharmacy</strong></div>
      <p class='Spa_Style_Light_Weight'>
        Retail pharmacies are physical locations where you have the option to drop off and pick up your prescription. Retail pharmacies can
        be stand-alone buildings or located within a grocery or super store. Typical supplies through a retail pharmacy is a 1 month supply.
      </p>
    </li>
    <li>
      <div><strong>Mail order pharmacy</strong></div>
      <p class='Spa_Style_Light_Weight'>
        Mail pharmacies are often pharmacy benefit managers (PBM) or carrier sponsored where your prescription medicines can be sent to you
        by mail. Typical supplies through a mail order pharmacy is a 3 month supply.
      </p>
    </li>
  </ul>
</div>`;
        this.Spa_PlanDetails_Footnotes = this.footnoteFacade.getFootNotes();
        this.Spa_Site_MailOrderFootnote_Text = 'This drug can be ordered through a mail order pharmacy.';
        this.Spa_Site_MailOrderFootnote_Index = '+';
        this.Spa_PlanDetails_Footnote_Header = '<b>Footnotes: </b>The footnote for each drug will appear after the drug name';
        this.Spa_Site_TotalEstimatedCost_Enabled = true;
        this.Spa_Site_InsulinFootnote_Index = '20';
        this.Spa_Site_PlanNotAvailableForNextYear_Text = 'Plan not available next year';
        this.Spa_Site_Keep_This_Plan_Button_Text = 'Keep this plan';
        this.Spa_Site_Current_Plan_Text = 'Current Plan';
        this.Spa_Site_Next_Year_Plan_Text = `Next year's plan`;
        this.Spa_Site_IsDeepLinking_Enabled = true;
        this.Spa_Site_SiteType = SiteType.CONSUMER;
        this.Spa_Prescription_Add_Edit_Link_Description = 'Add or edit Prescription list';
        this.Spa_Site_Pharmacy_Add_Edit_Link_Description = 'Add or edit Pharmacy list';
        this.Spa_PlanDetails_Preferences_SearchPrescriptions_Text = 'Search Prescriptions';
        this.Spa_PlanDetails_Preferences_PrescriptionDirectory_Title = 'Prescription Directory';
        this.Spa_PlanDetails_Preferences_PrescriptionDirectory_Link = {
            title: this.Spa_PlanDetails_Preferences_PrescriptionDirectory_Title,
            tag: 'HelpfulToolsPharmacySearch',
            href: ''
        };
        this.Spa_PlanDetails_Preferences_SearchPharmacy_Text = 'Search Pharmacy';
        this.Spa_PlanDetails_Preferences_PharmacyDirectory_Title = 'Pharmacy Directory';
        this.Spa_PlanDetails_Preferences_PharmacyDirectory_Link = {
            title: this.Spa_PlanDetails_Preferences_PharmacyDirectory_Title,
            tag: 'HelpfulToolsPharmacySearch',
            href: ''
        };
        this.Spa_PlanCompare_PlanDocument_Text = 'Plan Documents';
        this.Spa_Site_Preferred_In_Network_Text = 'Preferred In-network';
        this.Spa_Site_Standard_In_Network_Text = 'Standard In-network';
        this.Spa_Site_Out_Of_Network_Text = 'Out of network';
        this.Spa_Site_CostBasedOn_Text = 'Costs are based on';
        this.Spa_Site_PrimaryPharmacy_Indicator_Text = 'primary';
        this.Spa_Site_Mail_Order_Pharmacy_Enabled = false;
        this.Spa_PlanList_MailOrder_Text = 'Mail order';
        this.Spa_Site_Preferred_Text = 'preferred';
        this.Spa_Site_Standard_Text = 'standard';
        this.Spa_Site_Show_Pharmacy_Tier_Label = false;
        this.Spa_Site_Selected_Pharmacy_Network_Label = '<selectedPharmacy> is a <networkType> pharmacy';
        this.Spa_Site_Mail_Order_Pharmacy_Text = 'Mail order pharmacy';
        this.Spa_TotalCost_EffectiveDateLabel_Text = 'Effective date';
        this.Spa_Providers_Add_Edit_Link = 'Add/edit providers list';
        this.Spa_Provider_InNetwork_Text = 'In-network';
        this.Spa_Provider_OutOfNetwork_Text = 'Out-of-network';
        this.Spa_Providers_No_Data_Exist_Text = 'No provider data available for this carrier';
        this.Spa_Site_Pcp_Text = 'PCP';
        this.Spa_Site_Providers_Enabled = false;
        this.Spa_Site_Preferences_Score_Enabled = false;
        this.Spa_Providers_NoProviderNetworkAccess_Text = 'No access to provider network data';
        this.Spa_Site_HealthCosts_Enabled = true;
        this.Spa_Site_Plan_List_Link = 'Plan list';
        this.Spa_PlanDetails_HIP_Call_Out_Available_Plan_Types = [
            {
                title: 'Medicare Advantage Prescription Drug',
                enabled: true,
                tabType: PlanTypeAbbreviation.MAPD
            },
            {
                title: 'Medicare Advantage',
                enabled: true,
                tabType: PlanTypeAbbreviation.MA
            },
            {
                title: 'Medicare Supplement',
                enabled: false,
                tabType: PlanTypeAbbreviation.MEDIGAP
            }
        ];
        this.Spa_PlanDetails_HIP_Call_Out_Enabled = false;
        this.Spa_PlanDetails_HIP_Call_Out_Informational_Text = `
  <div class="col-12 text-left">
    <h4 class="Spa_Style_H4 my-2">Hospital Indemnity</h4>
  </div>

  <div class="col-12 mt-2">
    <div class="text-left Spa_Style_Paragraph">
      Hospital Indemnity can help you cover any extra hospital costs that may not be covered in another plan.
    </div>
  </div>
  `;
        this.Spa_PlanDetails_HIP_Call_Out_Text_Button = 'Add more coverage';
        this.Spa_PlanDetails_HIP_RateFactorModal_Title = 'Add on coverage with a Hospital indemnity Plan';
        this.Spa_Site_ErrorKeyword_Text = 'Error:';
        this.Spa_Site_EnrollmentErrorNotice_Title = 'Correct the following error(s) on the form, then submit again';
        this.Spa_PlanList_MedSupFormDropdownDefault_Text = 'Select an option';
        this.SPA_HIP_Rider_Benefit_Text = 'Benefit amount';
        this.Spa_Site_HIP_MonthlyPremium_Text = 'Updated based on benefit selections';
        this.SPA_HIP_Rider_Benefit_Default_Dropdown_Text = 'None';
        this.Spa_Site_HIP_BasePlanOption_Text = 'Base plan option';
        this.Spa_PlanList_AddToQuote_Limit_Mobile = 2;
        this.Spa_PlanList_AddToQuote_Limit = 3;
        this.Spa_Site_Hide_EmptyPlanTabs = [
            {
                tabType: PlanTypeAbbreviation.MAPD,
                states: []
            },
            {
                tabType: PlanTypeAbbreviation.MA,
                states: []
            },
            {
                tabType: PlanTypeAbbreviation.PDP,
                states: []
            },
            {
                tabType: PlanTypeAbbreviation.MEDIGAP,
                states: []
            },
            {
                tabType: PlanTypeAbbreviation.DENTAL,
                states: []
            },
            {
                tabType: PlanTypeAbbreviation.VISION,
                states: []
            },
            {
                tabType: PlanTypeAbbreviation.HC,
                states: []
            }
        ];
        this.Spa_Site_PlanLogo_Size = 'small';
        this.Spa_Site_ShowDrugAlternatives_Enabled = false;
        this.Spa_PlanDetails_ShowDrugAlternatives_Nudge_Enabled = false;
        this.Spa_Prescriptions_ShowDrugAlternatives_Informational_Text = 'View alternatives for each non-covered drug to see if there is a lower cost that may be available to you.';
        this.Spa_Prescriptions_ShowDrugAlternatives_ViewAlternatives_Text = 'View possible alternatives';
        this.Spa_DrugSearch_Frequency_List = [
            { label: "per month" /* FrequencyLabel.Month */, value: 30 /* FrequencyValue.Month */ },
            { label: "per two months" /* FrequencyLabel.TwoMonths */, value: 60 /* FrequencyValue.TwoMonths */ },
            { label: "per three months" /* FrequencyLabel.ThreeMonths */, value: 90 /* FrequencyValue.ThreeMonths */ },
            { label: "per six months" /* FrequencyLabel.SixMonths */, value: 180 /* FrequencyValue.SixMonths */ },
            { label: "per year" /* FrequencyLabel.PerYear */, value: 365 /* FrequencyValue.PerYear */ }
        ];
        this.Spa_DrugCosts_RetailCostText = 'Retail Cost';
        this.Spa_DrugListCard_Brand_Text = 'Branded';
        this.Spa_DrugListCard_Generic_Text = 'Generic';
        this.Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_BackToPrescriptions_Link_Text = 'Go to prescriptions';
        this.Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_Header_Text = 'Alternatives for';
        this.Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_Intro_Text = `
    Talk to your doctor if you are interested in switching to any of
    these alternatives. Doctors may not know the actual cost of each medication prescribed to you.
  `;
        this.Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_NoDrugs_Empty_Text = `
    <h4 class="Spa_Style_H4 my-2">No alternatives available.</h4>
    <span class="Spa_Style_Primary_Color">Make sure the condition listed above is correct.</span>
  `;
        this.Spa_PlanDetails_StickyMiniCart_Enabled = false;
        this.Spa_Prescriptions_ShowDrugAlternatives_Condition_Modal_Text = '<strong>Condition prescribed for</strong>';
        this.Spa_Site_ShowDrugAlternatives_Change_Medical_Conditions_Enabled = false;
        this.Spa_PlanFilters_DayLabel_Text = 'Number of days';
        this.Spa_Site_Days_Text = 'days';
        this.Spa_Site_Day_Text = 'day';
        this.Spa_PlanList_MedSupEditAnswersBanner_Text = 'Edit your answers.';
        this.Spa_Site_LumpSum_Text = 'Lump sum';
        this.Spa_Site_Hide_Text = 'Hide';
        this.Spa_Site_ViewAll_Text = 'View more';
        this.Spa_Site_Provider_ShowAllInNetworkLocations_Enabled = true;
        this.Spa_Retention_ClientDefinedPlanOptions_Enabled = false;
        this.Spa_Site_Plan_Option_One_Text = 'Option one';
        this.Spa_Site_Plan_Option_Two_Text = 'Option two';
        this.Spa_Providers_AcceptingNewPatients_Text = 'Accepting new patients';
        this.Spa_Providers_AcceptingNewPatients_Icon = 'fas fa-user-plus';
        this.Spa_Providers_Languages_Icon = 'fas fa-globe';
        this.Spa_Site_PlanFees_Enabled = false;
        this.Spa_PlanFees_Label_Text = 'Fees';
        this.Spa_PlanFees_Tooltip_Text = 'Fees';
        this.Spa_PlanFees_IncludedInPremium_Tooltip_Text = 'Included in premium';
        this.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text = 'Not included in premium';
        this.Spa_Display_SNP_PremiumRange_Enabled = false;
        this.Spa_Site_ValueBasedCare_Agreement_Enabled = false;
        this.Spa_Site_ValueBasedCare_Agreement_Label = 'Value Based Care agreement';
        this.Spa_Site_ValueBasedCare_Agreement_Tooltip = 'A Value Based Care agreement exists between your primary care provider and this carrier. See plan details for more information.';
        this.Spa_DrugSearch_Content_Section_Text = 'We defaulted the most common dosage so you have a better idea of what you might take.';
        this.Spa_DrugSearch_Dosage_Header = 'Select dose and form';
        this.Spa_DrugSearch_Frequency_Header = 'Enter quantity and frequency';
        this.Spa_DrugSearch_Package_Header = 'Select package';
        this.Spa_DrugSearch_Add_Button = 'Add';
        this.Spa_DrugSearch_Cancel_Button = 'Cancel';
        this.Spa_DrugSearch_Back_Button = 'Back';
        this.Spa_DrugSearch_EditDrug_Button = 'Edit Drug';
        this.Spa_DrugSearch_Quantity_Max_Limit = 1000;
        this.Spa_DrugSearch_Cabinet_Limit = 25;
        this.Spa_DrugSearch_MaxCount_Error_Message = `You can only add up to ${this.Spa_DrugSearch_Cabinet_Limit} drugs`;
        this.Spa_DrugSearch_Quantity_Error_Message = `
      Please provide a number between 0 and ${this.Spa_DrugSearch_Quantity_Max_Limit}`;
        this.Spa_DrugSearch_Label_Text = 'Drug Search';
        this.Spa_DrugSearch_InCabinetError_Text = 'This drug and dosage already exists in your list.';
        this.Spa_DrugSearch_Medicine_Header = 'Your prescriptions';
        this.Spa_DrugSearch_GenericOption_Icon = 'fas fa-tag';
        this.Spa_DrugSearch_GenericOption_Question = 'Would you like to use a Generic (<genericDrugName>) for <brandName>';
        this.Spa_DrugSearch_GenericOption_Info = `
        According to the FDA, this generic drug has the same quality, strength, safety and active ingredient as the brand name drug.
        Generic drugs are usually covered by part D plans and are generally a lower price.`;
        this.Spa_DrugSearch_GenericOptions = [
            { label: 'Yes', value: true },
            { label: 'No', value: false }
        ];
        this.Spa_DrugSearch_CheckDrugCoverageButton_Text = 'See if this drug is covered';
        this.Spa_DrugSearch_GenericOption_Default_Selection = false;
        this.Spa_DrugListCard_HideCosts_Flag = false;
        this.Spa_DrugSearch_Hint_Text = 'search for prescription';
        this.Spa_DrugSearch_Intro_Text = 'This will allow you to see how each plan provides coverage for your prescriptions.';
        this.Spa_DrugSearch_PageHeader_Text = 'Prescriptions';
        this.Spa_DrugSearch_Frequency_ListBox_Label = 'Choose any one the frequency from list of options available';
        this.Spa_Site_Enable_BlueButton = true;
        this.Spa_Site_OrText = 'OR';
        this.Spa_BlueButton_StartAddDrug_Text = 'Start adding drugs';
        this.Spa_BlueButton_MyMedicare_Connect_Text = `<div class="Spa_Style_H4 mb-1">Download your prescription list from myMedicare.gov.</div>
        <p class="Spa_Style_Primary_Color Spa_Style_Paragraph mb-0">The easy and secure way to download all current prescriptions.</p>`;
        this.Spa_BlueButton_MyMedicare_Button = 'MyMedicare.gov';
        this.Spa_Site_EmailAddress_Text = 'Email address';
        this.Spa_Profile_EmailRequired_Error = 'Please provide email address';
        this.Spa_Profile_EmailInvalid_Error = 'Please provide a valid email address';
        this.Spa_Site_SendEmailButton_Text = 'Send email';
        this.Spa_BlueButton_Modal_Header = 'You are leaving site';
        this.Spa_BlueButton_Modal_Content = `<p class="Spa_Style_Paragraph">Are you sure you want to continue to login to Mymedicare.gov?</p>
        <p class="Spa_Style_Paragraph">Connecture,Inc. is a trusted entity of Healthcare co. By allowing Connecture, Inc access to
        your drug list, you will be able to download your drugs to our site and be able to find a plan that covers them that
        much quicker.</p><p class="Spa_Style_Paragraph">Review Connecture's <a class="Spa_Style_Link" href="">privacy policy</a>
        and <a class="Spa_Style_Link" href="">terms and conditions</a> relating to the download of the prescriptions.</p>`;
        this.Spa_BlueButton_Success_Text = 'Prescriptions shared successully';
        this.Spa_BlueButton_Download_Text = 'Prescriptions last downloaded on ';
        this.Spa_BlueButton_Success_Message = ' Prescriptions last downloaded on';
        this.Spa_BlueButton_EmailSentToStatus_Text = `Email sent to {{[member.profile.emailAddress]}} on {{[member.blueButtonInfo.updateDate]}} `;
        this.Spa_BlueButton_Issue_Loading_Text = 'Issue loading prescriptions. Please try again.';
        this.Spa_BlueButton_Beneficiary_Denied_Text = 'Beneficiary denied access.';
        this.Spa_BlueButton_Error_Loading_Text = 'Unable to load latest prescriptions.';
        this.Spa_BlueButton_Beneficiary_Email_Details = 'You may need to email the beneficiary again to update their login information.';
        this.Spa_BlueButton_ImportLatestPrescription_Button_Text = 'Import latest prescriptions';
        this.Spa_BlueButton_ImportLatestPrescription_Error_Text = 'Unable to import latest prescriptions. Try again.';
        this.Spa_BlueButton_AccessDenied_Error_Text = 'Access denied. We are unable to load prescriptions';
        this.Spa_BlueButton_ClaimData_Loading_Error_Text = 'There was an issue loading your prescriptions. Please try again later';
        this.Spa_Drugs_UseCMSDrugFlag_Enabled = true;
        this.Spa_AddPrescriptions_ModalView1_HeadingText = 'Add prescriptions';
        this.Spa_AddPrescriptions_ModalView1_IntroText = 'Add your prescriptions to see how each plan provides coverage.';
        this.Spa_AddPrescriptions_ModalView2_HeadingText = '';
        this.Spa_AddPrescriptions_ModalView2_IntroText = '';
        this.Spa_DrugSearch_Text = 'Search for a prescription';
        this.Spa_Site_Prescriptions_Text = 'Prescriptions';
        this.Spa_Site_Providers_Text = 'Providers';
        this.Spa_Site_Providers_Body_Text = `See which plans cover your doctor, specialist, urgent care or hospital. Reference the plan's Medical Provider Directory to see up-to-date network information.`;
        this.Spa_Multi_Providers_Body_Text = `Add your providers to see which plans cover your doctor, specialist, urgent care or hospital. Choose the exact location for your provider because network status can vary for a provider based on the location.`;
        this.Spa_Provider_Add_Text = 'Add Provider';
        this.Spa_Provider_Added_Text = 'Provider added';
        this.Spa_Provider_RemoveProvider_Text = 'Remove provider';
        this.Spa_Provider_YourProvider_Text = 'My providers';
        this.Spa_Provider_Set_Primary_Care_Provider_Text = 'Set as primary care provider';
        this.Spa_Provider_Primary_Care_Provider_Text = 'Primary care provider';
        this.Spa_Site_ZipCodeInput_ZipCodeLabel = 'Zip code';
        this.Spa_Site_ZipCodeInput_ZipCodeError = 'Zip code is invalid';
        this.Spa_Providers_Filter_Enabled = false;
        this.Spa_Group_Provider_Add_Text = 'Add';
        this.Spa_Group_Provider_Added_Text = 'Added';
        this.Spa_ZipCodeInput_CountyLabel_Text = 'County';
        this.Spa_Site_Add = 'Add';
        this.Spa_Site_Cancel = 'Cancel';
        this.Spa_Select_Single_Provider_For_Multi_Address_Enabled = false;
        this.Spa_Select_Provider_Location_Text = 'Select the provider location';
        this.Spa_Provider_Exists_Text = 'You may only select one location for each provider';
        this.Spa_Provider_Multiple_Location_Text = 'This provider has multiple locations which may give different insurance information.';
        this.Spa_Plan_Providers_Locations_Link_Text = 'locations';
        this.Spa_Site_ValueBasedCare_Enabled = true;
        this.Spa_Site_ValueBasedCare_Icon = 'fas fa-briefcase-medical';
        this.Spa_Site_ValueBasedCare_Text = 'Value based care';
        this.Spa_Provider_Search_Filter_General_Practice_Options = [
            { display: 'Yes', value: true },
            { display: 'No', value: false }
        ];
        this.Spa_Provider_Search_General_Practice_Label_Text = 'General practice';
        this.Spa_Provider_Search_General_Practice_Tooltip_Text = 'General practitioners treat patients of all ages, but do not typically specialize in a particular area. They may treat your medical condition or refer you to a specialist.';
        this.Spa_Provider_Search_Filter_General_Practice_Option_Enabled = false;
        this.Spa_Provider_Search_ShowSingleProviderInList_Enabled = false;
        this.Spa_Site_Edit_Text = 'Edit';
        this.Spa_Site_Update_Text = 'Update';
        this.Spa_Provider_ShowEditLink_Enabled = false;
        this.Spa_ValueBasedCare_Available_Text = '<i class="fas fa-solid fa-info-circle"></i> Value Based Care providers may be available in your area';
        this.Spa_ValueBasedCare_LearnMore_Link = 'https://www.cms.gov/priorities/innovation-center/value-based-care-spotlight';
        this.Spa_ValueBasedCare_LearnMore_Text = 'Learn more';
        this.Spa_ValueBasedCare_LearnMoreLink2_Enabled = false;
        this.Spa_ValueBasedCare_Toggle_Label = 'Search Value Based Providers';
        this.Spa_ValueBasedCare_Toggle_ToolTip_Text = '';
        this.Spa_ValueBasedCare_Toggle_Enabled = false;
        this.Spa_Provider_Search_Filter_ValueBasedCare_Options = [
            { display: 'Yes', value: true },
            { display: 'No', value: false }
        ];
        this.Spa_Provider_New_Patient_Toggle_Enabled = false;
        this.Spa_Provider_New_Patient_Toggle_Label = 'Are you a new patient for this provider?';
        this.Spa_Provider_New_Patient_Options = [
            { display: 'Yes', value: 'yes' },
            { display: 'No', value: 'no' }
        ];
        this.Spa_Primary_Care_Provider_Toggle_Enabled = false;
        this.Spa_Primary_Care_Provider_Toggle_Label = 'Is this your primary care physician';
        this.Spa_Primary_Care_Provider_Options = [
            { display: 'Yes', value: 'yes' },
            { display: 'No', value: 'no' }
        ];
        this.Spa_New_Patient_For_Provider_Text = 'New Patient';
        this.Spa_Existing_Patient_For_Provider_Text = 'Existing patient';
        this.Spa_Provider_ValueBasedCare_Name_Filter_Enabled = false;
        this.Spa_Provider_ValueBasedCare_Name_Filter_Label = 'Participating Value Based Care organizations in this area';
        this.Spa_Selected_Provider_Options_Enabled = false;
        this.Spa_Site_Remove_Text = 'Remove';
        this.Spa_Site_SelectAll_Text = 'Select all';
        this.Spa_ProviderName_Text = 'Provider name';
        this.Spa_ProviderName_HintText = 'Provider name';
        this.Spa_Site_SearchButton_Text = 'Search';
        this.Spa_Provider_Limit = 25;
        this.Spa_ProviderSearch_Pagination_ItemsPerPage = 10;
        this.Spa_ProviderSearch_Pagination_Enabled = false;
        this.Spa_ProviderSearch_Pagination_View_Text = 'Viewing <startPageItem> - <endPageItem> of <totalPages>';
        this.Spa_Provider_Alt_View_Not_Found_Header_Text = 'No provider results';
        this.Spa_Provider_Alt_View_Not_Found_Body_Text = 'There are no providers available in this location. Try zooming out or entering a new ZIP code.';
        this.Spa_ProviderMap_Max_Zoom = 28;
        this.Spa_ProviderMap_Min_Zoom = 4;
        this.Spa_ProviderMap_Default_Zoom = 11;
        this.Spa_Provider_Add_Maximum_Limit_Message = 'You can only add up to <maxCount> providers';
        this.Spa_Providers_Filter_Individuals_Text = 'Doctors and other professionals';
        this.Spa_Providers_Filter_Facilties_Text = 'Facilities (hospitals, clinics and urgent care)';
        this.Spa_ValueBasedCare_Filter_Text = 'Only show Value Based Care providers';
        this.Spa_Site_ValueBasedCare_Filter_Enabled = true;
        this.Spa_ValueBasedCare_Filter_Checked = false;
        this.Spa_ValueBasedCare_LearnMoreLink_Enabled = true;
        this.Spa_Providers_Back_Button = 'Back';
        this.Spa_AddProviders_ModalProviderSearchView_HeadingText = 'Add providers';
        this.Spa_AddProviders_ModalProviderSearchView_IntroText = 'See which plans cover your doctor, specialist, urgent care or hospital.';
        this.Spa_AddProviders_ModalProviderMapView_HeadingText = '';
        this.Spa_AddProviders_ModalProviderMapView_IntroText = 'Choose the exact location for your provider. Network status can vary for a provider based on the location.';
        this.Spa_AddProviders_ModalProviderLocationView_HeadingText = '';
        this.Spa_AddProviders_ModalProviderLocationView_IntroText = 'If you see your provider at multiple locations, add all the locations at which you see them. Network status can vary for a provider based on the location.';
        this.Spa_ZipCodeInput_CountyLabel_Enabled = false;
        this.Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text = 'Pharmacies that are willing to give the plans a larger discount than other pharmacies.';
        this.Spa_PharmacySearch_Standard_In_Network_Tooltip_Text = 'These pharmacies may charge a higher copayment or co-insurance for filling your prescription.';
        this.Spa_Pharmacy_Alt_View_Not_Found_Header_Text = 'No pharmacy results';
        this.Spa_Pharmacy_Alt_View_Not_Found_Body_Text = 'There are no pharmacies available in this location. Try zooming out or entering a new ZIP code.';
        this.Spa_PharmacyName_Text = 'Pharmacy name';
        this.Spa_Add_Pharmacy_Button = 'Add pharmacy';
        this.Spa_Filter_Default_Filter_Text = 'No filters available';
        this.Spa_PharmacyName_HintText = 'Pharmacy name';
        this.Spa_Site_Pharmacy_Filter_Enabled = true;
        this.Spa_Site_Pharmacy_In_Network_Filter_Enabled = true;
        this.Spa_Site_Pharmacy_Other_Filter_Enabled = false;
        this.Spa_PlanFilters_Modal_Link = 'Plan filters';
        this.Spa_PlanFilters_Modal_Cancel_Button = 'Cancel';
        this.Spa_PlanFilters_Modal_Apply_Button = 'Apply';
        this.Spa_Site_Digital_Pharmacy_Enabled = false;
        this.Spa_Site_Pharmacy_Text = 'Pharmacy';
        this.Spa_Pharmacy_Limit = 25;
        this.Spa_PharmacyMap_Default_Zoom = 11;
        this.Spa_PharmacyMap_Max_Zoom = 28;
        this.Spa_PharmacyMap_Min_Zoom = 4;
        this.Spa_Site_Maximum_Pharmacy_Count = 3;
        this.Spa_Site_Set_Primary_Pharmacy_Link_Text = 'Set as primary pharmacy';
        this.Spa_Site_Multi_Pharmacy_Enabled = false;
        this.Spa_PharmacySearch_Back_Button = 'Back';
        this.Spa_AddPharmacy_ModalView1_IntroText = 'Add your pharmacy to get an estimated drug cost and compare across plans.';
        this.Spa_AddPharmacy_ModalView1_HeadingText = 'Add Pharmacies';
        this.Spa_AddPharmacy_ModalView2_IntroText = 'Drug costs vary based on the pharmacy you choose. Select multiple pharmacies to compare estimated drug costs for all available plans.';
        this.Spa_AddPharmacy_ModalView2_HeadingText = '';
        this.Spa_PharmacySearch_Pagination_ItemsPerPage = 10;
        this.Spa_PharmacySearch_Pagination_Enabled = false;
        this.Spa_PharmacySearch_Pagination_View_Text = 'Viewing <startPageItem> - <endPageItem> of <totalPages>';
        this.Spa_Site_AddPharmacy_YourMultiPharmacyText = 'Your Pharmacies';
        this.Spa_Pharmacy_Added_Label = 'Pharmacy Added';
        this.Spa_Pharmacy_Retail_Tab_Text = 'Retail';
        this.Spa_Pharmacy_Digital_Tab_Text = 'Digital';
        this.Spa_AddPharmacy_YourPharmacyText = 'Your Pharmacy';
        this.Spa_Site_ElectronicPrescription_ToolTipHeader = 'Electronic prescribing';
        this.Spa_Site_ElectronicPrescription_ToolTipBody = 'Prescriptions can be written and sent to the pharmacy electronically.';
        this.Spa_Site_Primary_Pharmacy_Text = 'Primary Pharmacy';
        this.Spa_Site_Primary_Pharmacy_Icon = 'fas fa-star';
        this.Spa_Site_Primary_Pharmacy_Icon_Color = '#b07d0f';
        this.Spa_Site_Plans_Text = 'plans';
        this.Spa_Pharmacy_Digital_Tab_Intro_Text = 'Many retail pharmacies have online options for ordering prescriptions. Similar to mail order pharmacies associated with your health plan, digital pharmacies allow you to order prescriptions online and have them delivered to your home. Inclusion in this list does not guarantee delivery to your service area.';
        this.Spa_Site_Plan_Text = 'plan';
        this.Spa_Filter_Header_Text = 'Filters';
        this.Spa_Filter_Clear_All = 'Clear all';
        this.Spa_PharmacySearch_PageHeader_Text = 'Pharmacy';
        this.Spa_Site_Pharmacy_Added_Text = 'has been added';
        this.Spa_Site_Pharmacy_Add_Text = 'Press Enter to add this Pharmacy';
        this.Spa_Site_EPrescribing_Alt_Text = 'This pharmacy supports e-prescribing.';
        this.Spa_PharmacySearch_Intro_Text = 'Find your pharmacy to help us estimate costs and show you which plans include in-network pharmacy discounts.';
        this.Spa_PharmacySearch_MultiPharmacy_Intro_Text = 'Add one or more pharmacies to help us estimate costs and show you which plans include in-network pharmacy discounts.';
        this.Spa_Site_Pharmacy_Limit_Error_Message = 'You can only add up to <maxPharmacyCount> pharmacies';
        this.Spa_Pharmacy_Filter_Open24hrs_Text = 'Open 24 hours';
        this.Spa_Pharmacy_Filter_Eprescribing_Text = 'Electronic prescribing(prescriptions can be written and sent to the pharmacy electronically)';
        this.Spa_Pharmacy_Filter_HandicapAccess_Text = 'Handicap accessible';
        this.Spa_Pharmacy_Filter_DurableEquipment_Text = 'Durable medical Equipment';
        this.Spa_Pharmacy_Filter_MailOrder_Text = 'Mail Order';
        this.Spa_Pharmacy_In_Network_Filters = [
            {
                dataKey: 'isStandard',
                displayName: '[[Spa_Site_Standard_In_Network_Text]] ([[Spa_PharmacySearch_Standard_In_Network_Tooltip_Text]])'
            },
            {
                dataKey: 'isPreferred',
                displayName: '[[Spa_Site_Preferred_In_Network_Text]] ([[Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text]])'
            }
        ];
        this.Spa_Pharmacy_Filters = [
            {
                dataKey: 'has24hrService',
                displayName: this.Spa_Pharmacy_Filter_Open24hrs_Text
            },
            {
                dataKey: 'hasEPrescriptions',
                displayName: this.Spa_Pharmacy_Filter_Eprescribing_Text
            },
            {
                dataKey: 'hasHandicapAccess',
                displayName: this.Spa_Pharmacy_Filter_HandicapAccess_Text
            },
            {
                dataKey: 'hasDurableEquipment',
                displayName: this.Spa_Pharmacy_Filter_DurableEquipment_Text
            },
            {
                dataKey: 'isMailOrder',
                displayName: this.Spa_Pharmacy_Filter_MailOrder_Text
            }
        ];
        this.Spa_PreferenceBanner_Enabled = false;
        // #endregion resources
        this.planDetailTabs = [];
        this.isActive = true;
        this.subscriptions = new Subscription();
        this.planTypeAbbreviation = PlanTypeAbbreviation;
        this.planLevelContentLabel = {};
        this.planDetailsTabs = PlanDetailsTabs;
        this.detailsDescription = {};
        this.selectedMonthIndex = 0;
        this.optionsListAsStrings = [];
        this.pageTags = PageTags;
        this.totalCostEquationMAPD = this.Spa_Total_Costs_Breakdown_Equation_MAPD;
        this.totalCostEquationMA = this.Spa_Total_Costs_Breakdown_Equation_MA;
        this.isDentalPlan = false;
        this.isVisionPlan = false;
        this.isHCPlan = false;
        this.noCostMedSupPlanText = 'NoCost-MedSup';
        this.isDeepLink = false;
        this.isHIPCallOutAvailableToDetailedPlan = false;
        this.detailedPlanTotalPremium = 0;
        this.hasHospitalIndemnityQuestions = false;
        this.showHospitalCareCalloutBasedHidingStatesCoverage = true;
        this.prescriptionTabViewMode = PrescriptionTabViewMode.DEFAULT;
        this.footnoteIdsToShowForDrugAlternatives = [];
        this.linkRoles = LinkRoles;
        this.vaccineAdminFeeText = '<Vaccine_Admin_Fee>';
        this._detailedPlan$ = new BehaviorSubject(null);
        this.detailedPlan$ = this._detailedPlan$.asObservable().pipe(distinctUntilChanged(_isEqual), filter(plan => !!plan));
        this.preProcess = () => {
            this.totalEstimatedAnnualCostsMonth = [
                { month: 1, value: this.Spa_Site_Total_Est_Cost_Month_1 },
                { month: 2, value: this.Spa_Site_Total_Est_Cost_Month_2 },
                { month: 3, value: this.Spa_Site_Total_Est_Cost_Month_3 },
                { month: 4, value: this.Spa_Site_Total_Est_Cost_Month_4 },
                { month: 5, value: this.Spa_Site_Total_Est_Cost_Month_5 },
                { month: 6, value: this.Spa_Site_Total_Est_Cost_Month_6 },
                { month: 7, value: this.Spa_Site_Total_Est_Cost_Month_7 },
                { month: 8, value: this.Spa_Site_Total_Est_Cost_Month_8 },
                { month: 9, value: this.Spa_Site_Total_Est_Cost_Month_9 },
                { month: 10, value: this.Spa_Site_Total_Est_Cost_Month_10 },
                { month: 11, value: this.Spa_Site_Total_Est_Cost_Month_11 },
                { month: 12, value: this.Spa_Site_Total_Est_Cost_Month_12 }
            ];
            this.planLevelContentLabel = {
                PDP: this.Spa_PlanLevel_Content_Label_PDP,
                MAPD: this.Spa_PlanLevel_Content_Label_MAPD,
                MA: this.Spa_PlanLevel_Content_Label_MA,
                MEDIGAP: this.Spa_PlanLevel_Content_Label_MEDIGAP,
                DENTAL: this.Spa_PlanLevel_Content_Label_DENTAL,
                VISION: this.Spa_PlanLevel_Content_Label_VISION,
                HC: this.Spa_PlanLevel_Content_Label_HIP
            };
            this.reInitiateFootNoteText();
            this.detailsDescription = {
                MAPD: this.Spa_PlanDetails_Bottom_Content_Text_MAPD,
                MA: this.Spa_PlanDetails_Bottom_Content_Text_MA,
                PDP: this.Spa_PlanDetails_Bottom_Content_Text_PDP,
                MEDIGAP: this.Spa_PlanDetails_Bottom_Content_Text_MEDIGAP,
                DENTAL: this.Spa_PlanDetails_Bottom_Content_Text_DENTAL,
                VISION: this.Spa_PlanDetails_Bottom_Content_Text_VISION,
                HC: this.Spa_PlanDetails_Bottom_Content_Text_HIP
            };
        };
    }
    get showAgeRestrictionBanner$() {
        return this.planFacade
            .showMedSupAgeRestrictionBanner$()
            .pipe(map(showBanner => this.planFacade.isMedSupPlan(this.detailedPlan) && showBanner));
    }
    get showEffectiveDateRestrictionBanner$() {
        return this.planFacade
            .showMedSupEffectiveDateRestrictionBanner$()
            .pipe(map(showBanner => this.planFacade.isMedSupPlan(this.detailedPlan) && showBanner));
    }
    set detailedPlan(detailedPlan) {
        this._detailedPlan = detailedPlan;
        this.setDetailedPlan(detailedPlan);
    }
    get detailedPlan() {
        return this._detailedPlan;
    }
    setDetailedPlan(plan) {
        this._detailedPlan$.next(plan);
    }
    ngOnInit() {
        super.ngOnInit();
        this.isMobile$ = this.responsiveLayoutService.isCompact$;
        this.prescriptionInputProps = this.getPrescriptionInputProps();
        this.providerInputProps = this.getProviderInputProps();
        this.pharmacyInputProps = this.getPharmacyInputProps();
        this.deactivationGuardService.addDeactivationGuard({
            canDeactivate: this.planDetailsDeactivationGuard.bind(this)
        });
        // deep linking: add the total cost effective date in the member's session if is not set
        if (!this.store.selectSnapshot(MemberState.totalCostEffectiveDate)) {
            this.planFacade.addEffectiveDateInMemberSession();
        }
        this.providers = this.providerService.getProviders();
        if (this.plansService.planDetailPlanID) {
            this.configurableWidgetService.spinnerService.show(SpinnerEvent.PLANS_LOADING);
            this.detailedPlan = this.plansService.getPlan(this.plansService.planDetailPlanID);
            this.plansService.planDetailPlanID = null;
        }
        else if (!this.plansService.planDetailPlanID) {
            this.activatedRoute.queryParams.pipe(take(1)).subscribe({
                next: queryParams => {
                    this.configurableWidgetService.spinnerService.show(SpinnerEvent.PLANS_LOADING);
                    let planToFetchDetails;
                    if (EnvironmentService.getEnvironment().liveedit) {
                        const statePlans = this.planFacade.getLiveEditPlans(this.widgetName);
                        if (statePlans.length) {
                            planToFetchDetails = this.plansService.getPlan(statePlans[0].id);
                        }
                    }
                    else {
                        planToFetchDetails = this.plansService.getPlan(queryParams.id);
                    }
                    this.documentsSection = queryParams.documentsSection !== 'false';
                    this.detailedPlan = planToFetchDetails;
                    this.cdr.markForCheck();
                }
            });
        }
        this.isHIPCallOutAvailableToDetailedPlan = this.planFacade
            .getEnabledPlanAbbreviations(this.Spa_PlanDetails_HIP_Call_Out_Available_Plan_Types)
            .includes(this.detailedPlan?.planTypeAbbreviation);
        this.isLiveEdit = this.isLiveEditMode();
        // if we have enabled total cost effective date we want to filter out null values as this is now required.
        // if we have this disabled then we can just get the default value from the store and continue
        const _totalCostEffectiveDate$ = this.planDetailsFacade.getTotalCostEffectiveDate$();
        this.totalCostEffectiveDate$ =
            !this.isLiveEdit && this.pharmacyContext.isTotalCostByEffectiveDateEnabled
                ? _totalCostEffectiveDate$.pipe(filter(totalCostEffectiveDate => !!totalCostEffectiveDate))
                : _totalCostEffectiveDate$;
        this.isRetentionView = this.siteService.isRetentionView();
        this.pharmacies$ = this.detailedPlan$.pipe(switchMap(plan => this.pharmacyService.getAPIPharmacyInfoForPlan$(plan.id)), distinctUntilChanged(_isEqual));
        this.subscriptions.add(this.detailedPlan$
            .pipe(mergeMap(plan => combineLatest([this.pharmacies$, this.pharmacyContext.getFootnoteIdsToShow$(plan), this.selectedPharmacy$])))
            .subscribe({
            next: ([pharmacies, footnoteIds, selectedPharmacy]) => {
                const planPharmacyCoverage = this.getPlanCoverageMultiPharmacy(pharmacies, selectedPharmacy);
                if (planPharmacyCoverage?.vaccineAdminFee) {
                    this.reInitiateFootNoteText();
                    footnoteIds.map(id => (this.Spa_PlanDetails_Footnotes[id] = this.Spa_PlanDetails_Footnotes[id].replace(this.vaccineAdminFeeText, this.isMailOrderSelected ? '$0.00' : `$${planPharmacyCoverage.vaccineAdminFee.toString()}`)));
                }
                this.cdr.markForCheck();
            }
        }));
        if (this.Spa_PlanDetails_HIP_Call_Out_Enabled) {
            this.store.selectOnce(PlansState.hasHospitalIndemnityQuestions).subscribe({
                next: (hasHospitalIndemnityQuestions) => {
                    this.hasHospitalIndemnityQuestions = hasHospitalIndemnityQuestions;
                    this.cdr.markForCheck();
                }
            });
            this.subscriptions.add(this.plansService.getAreAllHospitalIndemnityQuestionsAnswered$().subscribe({
                next: (areAllHospitalIndemnityQuestionsAnswered) => {
                    this.areAllHospitalIndemnityQuestionsAnswered = areAllHospitalIndemnityQuestionsAnswered;
                    this.cdr.markForCheck();
                }
            }));
        }
        this.subscriptions.add(this.pharmacies$.subscribe({
            next: pharmaciesForPlan => {
                this.pharmacies = pharmaciesForPlan;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.selectedPharmacy$.subscribe({
            next: selectedPharmacy => {
                this.selectedPharmacy = selectedPharmacy;
                this.cdr.markForCheck();
            }
        }));
        this.selectedPharmacies$ = this.pharmacies$.pipe(switchMap((pharmacies) => this.pharmacyFacade.getSortedSelectedPharmacies$(pharmacies)));
        this.subscriptions.add(combineLatest([this.pharmacyFacade.mailOrder$, this.detailedPlan$])
            .pipe(distinctUntilChanged(_isEqual), switchMap(([isMailOrderSelected, plan]) => {
            this.isMailOrderSelected = isMailOrderSelected;
            return this.planDetailsFacade.getAnnualCost$(plan, this.isMailOrderSelected);
        }))
            .subscribe({
            next: annualCost => {
                this.annualCost = annualCost;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(combineLatest([this.totalCostEffectiveDate$, this.localeService.getCurrentLocale$(), this.planFacade.getIsSelectedEffectiveDate$()])
            .pipe(distinctUntilChanged(_isEqual))
            .subscribe({
            next: ([totalCostEffectiveDate, currentLocale, isSelectedEffectiveDate]) => {
                if (currentLocale) {
                    // Moved logic to populate defaultEffectiveDateLabel and updateOptionsListAsStrings here
                    // so it get's update with any locale changes
                    const listOfMonths = this.planDetailsFacade.getListOfEffectiveDateMonths();
                    const defaultEffectiveDateOption = this.planFacade.getDefaultEffectiveDateOption();
                    const currentMonth = new Date().getMonth() + 1;
                    const defaultEffectiveDateLabel = this.getDefaultEffectiveDateLabel(listOfMonths, defaultEffectiveDateOption, currentMonth);
                    this.updateOptionsListAsStrings(listOfMonths, defaultEffectiveDateOption, currentLocale);
                    if (this.optionsListAsStrings) {
                        this.effectiveDateDropDownItems = this.optionsListAsStrings;
                    }
                    this.fetchPlan(this.detailedPlan, totalCostEffectiveDate).then(() => {
                        if (this.planDetailTabs[0] && !this.activeTab) {
                            if (this.store.selectSnapshot(PlansState.isActiveTabTotalCost)) {
                                this.updateActiveTab(PlanDetailsTabs.TOTAL_COSTS);
                            }
                            else if (this.store.selectSnapshot(PlansState.isActiveTabPrescription)) {
                                this.updateActiveTab(PlanDetailsTabs.PRESCRIPTIONS);
                            }
                            else {
                                this.updateActiveTab(this.planDetailTabs[0].name);
                            }
                        }
                        this.configurableWidgetService.spinnerService.hide(SpinnerEvent.PLANS_LOADING);
                        if (this.pharmacyContext.isTotalCostByEffectiveDateEnabled) {
                            let _selectedValue = DateUtilities.getDateInLocaleFromString(totalCostEffectiveDate, this.planDetailsFacade.getMonthYearDateFormat(), currentLocale);
                            if (defaultEffectiveDateLabel && !isSelectedEffectiveDate) {
                                _selectedValue = defaultEffectiveDateLabel;
                            }
                            this.selectedValue = _selectedValue;
                            this.selectedMonthIndex = DateUtilities.monthYearToDate(this.selectedValue, currentLocale).getMonth();
                            this.planFacade.updateIsTotalEstimatedCostAnnuallyStatus(this.selectedMonthIndex);
                        }
                        this.cdr.markForCheck();
                    });
                }
            }
        }));
        const availablePlanListTabs = this.planFacade.getPlanListTabData() ?? [];
        this.subscriptions.add(this.detailedPlan$
            .pipe(map((detailedPlan) => detailedPlan.id), distinctUntilChanged(_isEqual), switchMap((planId) => this.providerFacade.fetchProviderDetails$([planId], true)))
            .subscribe({
            next: (providerDetailsExtendedData) => {
                if (providerDetailsExtendedData) {
                    this.providerDetailResponse = providerDetailsExtendedData;
                    const medicalGroups = this.providerFacade.getProviderMedicalGroups(providerDetailsExtendedData);
                    this.providerMedicalGroups = medicalGroups?.[this.detailedPlan?.id]?.providers ?? null;
                    this.providersAcceptingNewPatients$ = this.providerService.planTypeSupportsProviders(this.detailedPlan?.planTypeAbbreviation)
                        ? of(providerDetailsExtendedData.plans[0].providers)
                        : of([]);
                    this.providerLanguages$ = this.providersAcceptingNewPatients$.pipe(map((providers) => {
                        return this.providerFacade.createProviderLanguagesMap(providers);
                    }));
                    this.cdr.markForCheck();
                }
            }
        }));
        this.subscriptions.add(this.planFacade.getNonCoveredPlanTabMap$(availablePlanListTabs, this.Spa_Site_Hide_EmptyPlanTabs).subscribe({
            next: nonCoveredPlanTabMap => {
                if (!nonCoveredPlanTabMap[PlanTypeAbbreviation.HC]?.display) {
                    this.showHospitalCareCalloutBasedHidingStatesCoverage = false;
                    this.cdr.markForCheck();
                }
            }
        }));
        if (this.Spa_Site_ShowDrugAlternatives_Enabled) {
            this.subscriptions.add(this.drugCabinetContext.getDrugEntry$().subscribe({
                next: drugEntry => {
                    this.cabinetForAlternatives = drugEntry?.cabinetEntry;
                    if (this.cabinetForAlternatives) {
                        this.prescriptionTabViewMode = PrescriptionTabViewMode.ALTERNATIVES_OFF_FORMULARY_DRUGS;
                        this.updateActiveTab(PlanDetailsTabs.PRESCRIPTIONS);
                    }
                    else {
                        this.prescriptionTabViewMode = PrescriptionTabViewMode.DEFAULT;
                    }
                    this.cdr.markForCheck();
                }
            }));
            this.subscriptions.add(combineLatest([this.detailedPlan$, this.drugCabinetContext.getDrugEntry$()])
                .pipe(distinctUntilChanged(_isEqual), filter(([detailedPlan, drugEntry]) => !!detailedPlan && !!drugEntry?.cabinetEntry), switchMap(([detailedPlan, { cabinetEntry: cabinetForAlternatives }]) => this.pharmacyContext.getFootnoteIdsToShow$(detailedPlan, cabinetForAlternatives.dosageID)))
                .subscribe({
                next: footnoteIdsToShow => {
                    this.footnoteIdsToShowForDrugAlternatives = footnoteIdsToShow;
                    this.cdr.markForCheck();
                }
            }));
        }
        this.subscriptions.add(this.localeService.getCountryCode$.subscribe({
            next: (countryCode) => {
                if (countryCode) {
                    this.countryCode = countryCode;
                }
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.isMobile$.subscribe({
            next: (isMobile) => {
                this.isMobile = isMobile;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.guidedHelpModalContextService.openGuidedHelpModal$().subscribe({
            next: pageTag => {
                if (pageTag === PageTags.GUIDED_HELP_PRESCRIPTIONS) {
                    this.openPrescriptionsModal();
                }
                else if (pageTag === PageTags.GUIDED_HELP_PROVIDER_SEARCH) {
                    this.openProvidersModal();
                }
                else if (pageTag === PageTags.GUIDED_HELP_PHARMACY_SEARCH) {
                    this.openPharmacyModal();
                }
            }
        }));
        // remove healthCost element from Resource's value if it is not required to show and also not add with TotalEstimatedCost
        if (!this.Spa_Site_HealthCosts_Enabled) {
            this.totalCostEquationMAPD = this.planFacade.removeHealthCostFromDetailCostEquations(this.Spa_Total_Costs_Breakdown_Equation_MAPD);
            this.totalCostEquationMA = this.planFacade.removeHealthCostFromDetailCostEquations(this.Spa_Total_Costs_Breakdown_Equation_MA);
        }
        this.activatedRoute.queryParams.subscribe({
            next: params => {
                this.isDeepLink = this.passParameterService.checkDeepLinkingRequest(params);
                this.cdr.markForCheck();
            }
        });
        const answers = this.hospitalIndemnityFormFacade.getHospitalIndemnityAnswers();
        this.benefitAmountHIPAnswer = answers.BenefitAmount;
        this.numberOfDaysHIPAnswer = answers.HCDaysCovered;
        this.cdr.markForCheck();
    }
    ngOnChanges(changes) {
        if (!this.Spa_Site_HealthCosts_Enabled) {
            if (changes.Spa_Total_Costs_Breakdown_Equation_MAPD?.currentValue &&
                changes.Spa_Total_Costs_Breakdown_Equation_MAPD.currentValue !== changes.Spa_Total_Costs_Breakdown_Equation_MAPD.previousValue) {
                this.totalCostEquationMAPD = this.planFacade.removeHealthCostFromDetailCostEquations(this.Spa_Total_Costs_Breakdown_Equation_MAPD);
            }
            if (changes.Spa_Total_Costs_Breakdown_Equation_MA?.currentValue &&
                changes.Spa_Total_Costs_Breakdown_Equation_MA.currentValue !== changes.Spa_Total_Costs_Breakdown_Equation_MA.previousValue) {
                this.totalCostEquationMA = this.planFacade.removeHealthCostFromDetailCostEquations(this.Spa_Total_Costs_Breakdown_Equation_MA);
            }
        }
    }
    updateSelectedPharmacy(updatedPharmacy) {
        this.pharmacyFacade.switchMailOrder(false);
        this.pharmacyFacade.setSelectedPharmacy(updatedPharmacy);
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.drugCabinetContext.clearDrugEntry();
        this.drugCabinetContext.clearExtendedPlanWithDrugAlternatives();
        this.store.dispatch(new SetActiveTabTotalCost(false));
        this.subscriptions.unsubscribe();
    }
    getPlanCoverageMultiPharmacy(pharmacies, selectedPharmacy) {
        if (pharmacies?.length) {
            let planPharmacyCoverage = pharmacies[0];
            if (selectedPharmacy && planPharmacyCoverage) {
                planPharmacyCoverage = pharmacies.find(planMultiCoveragePharmacy => planMultiCoveragePharmacy.nabp === selectedPharmacy.nabp);
            }
            return planPharmacyCoverage;
        }
        return {};
    }
    openMedSupForm() {
        this.planFacade.navigateToMedSupForm();
    }
    onViewPossibleAlternativeDrugs(drugWithPlan) {
        this.prescriptionTabViewMode = PrescriptionTabViewMode.ALTERNATIVES_OFF_FORMULARY_DRUGS;
        this.drugCabinetContext.setDrugEntry(this.detailedPlan, drugWithPlan.cabinet);
        this.updateActiveTab(PlanDetailsTabs.PRESCRIPTIONS);
        this.scrollToTop();
    }
    getPlanDetailsBottomContentName(planType) {
        if (planType) {
            return this.detailedPlan ? `Spa_PlanDetails_Bottom_Content_Text_${this.detailedPlan.planTypeAbbreviation}` : '';
        }
    }
    updateActiveTab(tabName) {
        if (tabName !== PlanDetailsTabs.TOTAL_COSTS) {
            this.store.dispatch(new SetActiveTabTotalCost(false));
        }
        this.activeTab = tabName;
        this.store.dispatch(new SetActivePlanDetailsTab(tabName));
    }
    shiftFocusToTabElement(focusIndex) {
        if (this.planDetailsTabElement) {
            this.planDetailsTabElement.forEach(tabElement => tabElement.nativeElement.firstChild.setAttribute('tabindex', '-1'));
            const optionElement = this.planDetailsTabElement.find((_element, index) => index === focusIndex);
            if (optionElement) {
                optionElement.nativeElement.firstChild.setAttribute('tabindex', '0');
                optionElement.nativeElement.firstChild.focus();
            }
        }
    }
    isProviderSectionAvailable(selectedProviders) {
        return (this.Spa_Plan_Details_Preferences_Show_Provider &&
            this.detailedPlan &&
            this.detailedPlan.planType !== PlanType.PDP &&
            (this.providerService.findProviderSearchLinkType(this.detailedPlan.providerURL, this.Spa_Site_Providers_Enabled, this.detailedPlan.showProviderSearch) !== ProvidersLinkType.NO_LINK ||
                (selectedProviders && !!selectedProviders.length)));
    }
    benefitRidersSelected(ridersSelected) {
        this.detailedPlanTotalPremium = this.planFacade.getTotalPremium([this.detailedPlan], ridersSelected);
        this.cdr.detectChanges();
    }
    backToPrevious() {
        this.planDetailsFacade.resetHelpfulToolsPlan();
        this.plansService.setOverrideActiveTab(false);
        if (this.isDeepLink) {
            this.configurableWidgetService.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
        }
        else {
            this.configurableWidgetService.navigationService.backToPrevious();
        }
    }
    scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    isGuidedHelpTab(tabName) {
        const subSections = [GuidedHelpSections.PHARMACY, GuidedHelpSections.PRESCRIPTIONS];
        return subSections.includes(tabName);
    }
    isLiveEditMode() {
        const environment = EnvironmentService.getEnvironment();
        return environment.liveedit;
    }
    setTabs(detailedPlan) {
        let tabs = [
            {
                title: this.configResourceService.getProcessedResourceValue('Spa_PlanCard_PlanDetails_ButtonText', this.widgetName, 'Plan Details'),
                name: PlanDetailsTabs.PLAN_DETAILS,
                id: PlanDetailsTabIdentifier.PLAN_DETAILS
            },
            {
                title: this.configResourceService.getProcessedResourceValue('Spa_Site_Prescriptions_Text', this.widgetName, 'Prescriptions'),
                name: PlanDetailsTabs.PRESCRIPTIONS,
                id: PlanDetailsTabIdentifier.PRESCRIPTIONS
            },
            {
                title: this.configResourceService.getProcessedResourceValue('Spa_Site_Health_Costs_TabText', this.widgetName, 'Health costs'),
                name: PlanDetailsTabs.HEALTH_COSTS,
                id: PlanDetailsTabIdentifier.HEALTH_COSTS
            },
            {
                title: this.configResourceService.getProcessedResourceValue('Spa_Site_Total_Costs_TabText', this.widgetName, 'Total costs'),
                name: PlanDetailsTabs.TOTAL_COSTS,
                id: PlanDetailsTabIdentifier.TOTAL_COSTS
            }
        ];
        if (detailedPlan) {
            if (detailedPlan.planType !== PlanType.PDP && detailedPlan.planType !== PlanType.MAPD) {
                tabs = tabs.filter(tab => tab.name !== PlanDetailsTabs.PRESCRIPTIONS);
            }
            if (BLACKLISTED_TOTAL_COSTS_PLAN_TYPES.includes(detailedPlan.planType)) {
                tabs = tabs.filter(tab => tab.name !== PlanDetailsTabs.TOTAL_COSTS);
            }
        }
        if (!this.Spa_GuidedHelp_Enabled) {
            // if guided help is disabled turn off these keys
            tabs = tabs.filter(tab => !this.isGuidedHelpTab(tab.name));
        }
        if (!this.Spa_Site_Prescriptions_Enabled) {
            tabs = tabs.filter(tab => tab.name !== GuidedHelpSections.PRESCRIPTIONS);
        }
        if (!this.Spa_Site_Pharmacy_Enabled) {
            tabs = tabs.filter(tab => tab.name !== GuidedHelpSections.PHARMACY);
        }
        if (!this.Spa_Site_HealthCosts_Customization_Enabled ||
            !this.Spa_Site_HealthCosts_Enabled ||
            !WHITELISTED_HEALTH_COSTS_PLAN_TYPES.includes(detailedPlan.planType)) {
            tabs = tabs.filter(tab => tab.name !== PlanDetailsTabs.HEALTH_COSTS);
        }
        this.planDetailTabs = tabs;
    }
    async fetchPlan(plan, totalCostEffectiveDate) {
        let effectiveDate = '';
        if (this.pharmacyContext.isTotalCostByEffectiveDateEnabled) {
            effectiveDate = DateUtilities.getFormattedDate(new Date(totalCostEffectiveDate));
        }
        if (plan) {
            // Probably need this in case they deep link to the plan details page and need providers and coveredPreference data
            const planType = plan?.planType ? +plan?.planType : 0;
            // Scoring plans will be redundant if we have already done this in a previous load so we are checking if they are
            // dirty here and haven't been loaded again in another part of the flow. If the plan type is dirty we assume the
            // provider networks and coveredPreferences need to be reloaded as well. This is probably only dirty in the case of
            // deep linking but will cover other cases where the plan type is dirtied and we go straight to plan details.
            const planTypeIsDirty = this.plansService.getArePlansDirty(planType);
            const scorePlans = planTypeIsDirty && this.plansService.shouldScorePlans(planType, this.medSupService.planTypeHasQuestionsIfRequired(planType));
            const searchOptions = { scorePlans, ...(effectiveDate && { effectiveDate }) };
            const updatedPlan = await this.plansService.fetchPlanDetails(plan, undefined, searchOptions);
            this.updatePlanWithDetails(updatedPlan);
            this.cdr.markForCheck();
        }
    }
    updatePlanWithDetails(detailedPlan) {
        if (detailedPlan) {
            this.planDetailsFacade.updatePayloadWithDetailedPlan(detailedPlan);
            const updatedDetailedPlan = this.plansService.getPlan(detailedPlan.id);
            this.detailedPlan = updatedDetailedPlan;
            this.isDentalPlan = this.planDetailsFacade.isDentalPlan(this.detailedPlan);
            this.isVisionPlan = this.planDetailsFacade.isVisionPlan(this.detailedPlan);
            this.isHCPlan = this.planDetailsFacade.isHCPlan(this.detailedPlan);
            if (this.isHCPlan) {
                this.detailedPlanTotalPremium = this.planDetailsFacade.getTotalPremiumBySelectedRiders(detailedPlan);
            }
            else {
                this.detailedPlanTotalPremium = this.planDetailsFacade.getTotalPremium([detailedPlan]);
            }
            this.setTabs(detailedPlan);
        }
    }
    async planDetailsDeactivationGuard() {
        this.store.dispatch(new SetActiveTabTotalCost(false));
        this.store.dispatch(new SetActiveTabPrescription(false));
        return true;
    }
    reInitiateFootNoteText() {
        this.Spa_PlanDetails_Footnotes = this.footnoteFacade.getFootNotes();
        this.Spa_PlanDetails_Footnotes[this.Spa_Site_MailOrderFootnote_Index] = this.Spa_Site_MailOrderFootnote_Text;
    }
    updateOptionsListAsStrings(listOfMonths, defaultEffectiveDateOption, currentLocale) {
        if (this.pharmacyContext.isTotalCostByEffectiveDateEnabled &&
            defaultEffectiveDateOption !== DefaultEffectiveDateOption.FIRST_MONTH_OF_CURRENT_PLAN_YEAR) {
            this.optionsListAsStrings = listOfMonths.map(date => DateUtilities.getFormattedDate(date.toDate(), this.planDetailsFacade.getMonthYearDateFormat(), currentLocale));
        }
    }
    getDefaultEffectiveDateLabel(listOfMonths, defaultEffectiveDateOption, currentMonth) {
        let defaultEffectiveDateLabel = null;
        if (this.pharmacyContext.isTotalCostByEffectiveDateEnabled) {
            defaultEffectiveDateLabel = this.planDetailsFacade.getDefaultEffectiveDateLabel(currentMonth, defaultEffectiveDateOption, listOfMonths[0]);
        }
        return defaultEffectiveDateLabel;
    }
    getPrescriptionInputProps() {
        return {
            contentSectionText: this.Spa_DrugSearch_Content_Section_Text,
            dosageHeader: this.Spa_DrugSearch_Dosage_Header,
            quantityAndFrequencyHeader: this.Spa_DrugSearch_Frequency_Header,
            packageHeader: this.Spa_DrugSearch_Package_Header,
            addButtonText: this.Spa_DrugSearch_Add_Button,
            cancelButtonText: this.Spa_DrugSearch_Cancel_Button,
            backButtonText: this.Spa_DrugSearch_Back_Button,
            quantityMaxLimit: this.Spa_DrugSearch_Quantity_Max_Limit,
            medicineCabinetLimit: this.Spa_DrugSearch_Cabinet_Limit,
            cabinetLimitErrorMessage: this.Spa_DrugSearch_MaxCount_Error_Message,
            quantityErrorMessage: this.Spa_DrugSearch_Quantity_Error_Message,
            placeholder: this.Spa_DrugSearch_Hint_Text,
            drugSearchText: this.Spa_DrugSearch_Label_Text,
            drugsImage: this.Spa_DrugSearch_Drugs_Image,
            inCabinetErrorMessage: this.Spa_DrugSearch_InCabinetError_Text,
            medCabinetHeader: this.Spa_DrugSearch_Medicine_Header,
            genericOptionIcon: this.Spa_DrugSearch_GenericOption_Icon,
            showGenericOption: this.Spa_Site_Show_GenericDrugOption,
            genericOptionQuestion: this.Spa_DrugSearch_GenericOption_Question,
            genericOptionInfo: this.Spa_DrugSearch_GenericOption_Info,
            genericOptions: this.Spa_DrugSearch_GenericOptions,
            checkDrugCoverageButtonText: this.Spa_DrugSearch_CheckDrugCoverageButton_Text,
            genericOptionDefaultSelection: this.Spa_DrugSearch_GenericOption_Default_Selection,
            showCosts: this.Spa_DrugListCard_HideCosts_Flag,
            drugSearchIntroText: this.Spa_AddPrescriptions_ModalView1_IntroText,
            drugSearchPageHeaderText: this.Spa_DrugSearch_PageHeader_Text,
            errorKeywordText: this.Spa_Site_ErrorKeyword_Text,
            drugSearchFrequencyListBoxLabel: this.Spa_DrugSearch_Frequency_ListBox_Label,
            drugSearchFrequencyList: this.Spa_DrugSearch_Frequency_List,
            prescriptionsText: this.Spa_AddPrescriptions_ModalView1_HeadingText,
            isBlueButtonEnabled: this.Spa_Site_Enable_BlueButton,
            blueButtonStartAddingDrugText: this.Spa_BlueButton_StartAddDrug_Text,
            orText: this.Spa_Site_OrText,
            blueButtonConnectToMyMedicareText: this.Spa_BlueButton_MyMedicare_Connect_Text,
            blueButtonMyMedicareButtonText: this.Spa_BlueButton_MyMedicare_Button,
            emailLabelText: this.Spa_Site_EmailAddress_Text,
            emailRequiredErrorText: this.Spa_Profile_EmailRequired_Error,
            emailInvalidErrorText: this.Spa_Profile_EmailInvalid_Error,
            sendEmailButtonText: this.Spa_Site_SendEmailButton_Text,
            blueButtonModalHeaderText: this.Spa_BlueButton_Modal_Header,
            blueButtonModalContent: this.Spa_BlueButton_Modal_Content,
            blueButtonSuccessText: this.Spa_BlueButton_Success_Text,
            blueButtonDownloadText: this.Spa_BlueButton_Download_Text,
            blueButtonSuccessMessage: this.Spa_BlueButton_Success_Message,
            blueButtonEmailSendText: this.Spa_BlueButton_EmailSentToStatus_Text,
            blueButtonIssueLoadingText: this.Spa_BlueButton_Issue_Loading_Text,
            blueButtonBeneficiaryDeniedText: this.Spa_BlueButton_Beneficiary_Denied_Text,
            blueButtonErrorLoadingText: this.Spa_BlueButton_Error_Loading_Text,
            blueButtonBeneficiaryEmailDetails: this.Spa_BlueButton_Beneficiary_Email_Details,
            blueButtonImportLatestPrescriptionButtonText: this.Spa_BlueButton_ImportLatestPrescription_Button_Text,
            blueButtonImportLatestPrescriptionErrorText: this.Spa_BlueButton_ImportLatestPrescription_Error_Text,
            blueButtonAccessDeniedText: this.Spa_BlueButton_AccessDenied_Error_Text,
            blueButtonClaimDataLoadingErrorText: this.Spa_BlueButton_ClaimData_Loading_Error_Text,
            editDrugText: this.Spa_DrugSearch_EditDrug_Button,
            isUseCMSDrugFlagEnabled: this.Spa_Drugs_UseCMSDrugFlag_Enabled,
            modalView2HeaderText: this.Spa_AddPrescriptions_ModalView2_HeadingText,
            modalView2IntroText: this.Spa_AddPrescriptions_ModalView2_IntroText,
            drugSearchInputLabelText: this.Spa_DrugSearch_Text
        };
    }
    getPharmacyInputProps() {
        return {
            addPharmacyButtonText: this.Spa_Add_Pharmacy_Button,
            zipLabel: this.Spa_Site_ZipCodeInput_ZipCodeLabel,
            pharmacyNameText: this.Spa_PharmacyName_Text,
            pharmacyNameHintText: this.Spa_PharmacyName_HintText,
            pharmacyLimit: this.Spa_Pharmacy_Limit,
            pharmacyMapDefaultZoom: this.Spa_PharmacyMap_Default_Zoom,
            maxZoom: this.Spa_PharmacyMap_Max_Zoom,
            minZoom: this.Spa_PharmacyMap_Min_Zoom,
            currentPharmacyText: this.Spa_Site_Multi_Pharmacy_Enabled
                ? this.Spa_Site_AddPharmacy_YourMultiPharmacyText
                : this.Spa_AddPharmacy_YourPharmacyText,
            pharmacyAddedLabel: this.Spa_Pharmacy_Added_Label,
            electronicPrescriptionTooltipHeader: this.Spa_Site_ElectronicPrescription_ToolTipHeader,
            electronicPrescriptionTooltipBody: this.Spa_Site_ElectronicPrescription_ToolTipBody,
            pharmacyPaginationEnabled: this.Spa_PharmacySearch_Pagination_Enabled,
            paginationText: this.Spa_PharmacySearch_Pagination_View_Text,
            viewNotFoundHeaderText: this.Spa_Pharmacy_Alt_View_Not_Found_Header_Text,
            viewNotFoundBodyText: this.Spa_Pharmacy_Alt_View_Not_Found_Body_Text,
            preferredInNetworkText: this.Spa_Site_Preferred_In_Network_Text,
            standardInNetworkText: this.Spa_Site_Standard_In_Network_Text,
            preferredInNetworkTooltipContent: this.Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text,
            standardInNetworkTooltipContent: this.Spa_PharmacySearch_Standard_In_Network_Tooltip_Text,
            pharmacySearchIntroText: this.Spa_Site_Multi_Pharmacy_Enabled
                ? this.Spa_PharmacySearch_MultiPharmacy_Intro_Text
                : this.Spa_PharmacySearch_Intro_Text,
            pharmacySearchHeaderText: this.Spa_PharmacySearch_PageHeader_Text,
            addedPharmacyText: this.Spa_Site_Pharmacy_Added_Text,
            addPharmacyText: this.Spa_Site_Pharmacy_Add_Text,
            pharmacyText: this.Spa_Site_Pharmacy_Text,
            ePrescribingAltText: this.Spa_Site_EPrescribing_Alt_Text,
            Spa_Site_Tooltip_Text: this.Spa_Site_Tooltip_Text,
            zipErrorText: this.Spa_Site_ZipCodeInput_ZipCodeError,
            pharmacySearchButtonText: this.Spa_Site_SearchButton_Text,
            multiPharmacyEnabled: this.Spa_Site_Multi_Pharmacy_Enabled,
            setAsPrimaryLinkText: this.Spa_Site_Set_Primary_Pharmacy_Link_Text,
            primaryPharmacyText: this.Spa_Site_Primary_Pharmacy_Text,
            pharmacyFilterText: this.Spa_Filter_Header_Text,
            isPharmacyFilterEnabled: this.Spa_Site_Pharmacy_Filter_Enabled,
            isPharmacyInNetworkFilterEnabled: this.Spa_Site_Pharmacy_In_Network_Filter_Enabled,
            isPharmacyOtherFilterEnabled: this.Spa_Site_Pharmacy_Other_Filter_Enabled,
            pharmacyFilterClearText: this.Spa_Filter_Clear_All,
            pharmacyFilterData: this.Spa_Pharmacy_Filters,
            defaultFilterText: this.Spa_Filter_Default_Filter_Text,
            clearAllText: this.Spa_Filter_Clear_All,
            filterHeaderText: this.Spa_Filter_Header_Text,
            modalCancelButtonText: this.Spa_PlanFilters_Modal_Cancel_Button,
            modalApplyButtonText: this.Spa_PlanFilters_Modal_Apply_Button,
            countyLabel: this.Spa_ZipCodeInput_CountyLabel_Text,
            showCountyLabel: this.Spa_ZipCodeInput_CountyLabel_Enabled,
            pharmacyInNetworkFilters: this.Spa_Pharmacy_In_Network_Filters,
            digitalPharmacyEnabled: this.Spa_Site_Digital_Pharmacy_Enabled,
            retailTabText: this.Spa_Pharmacy_Retail_Tab_Text,
            digitalTabText: this.Spa_Pharmacy_Digital_Tab_Text,
            digitalTabIntroText: this.Spa_Pharmacy_Digital_Tab_Intro_Text,
            itemsPerPage: this.Spa_PharmacySearch_Pagination_ItemsPerPage,
            pharmacyLimitErrorMessage: this.Spa_Site_Pharmacy_Limit_Error_Message,
            pharmacySearchBackButton: this.Spa_PharmacySearch_Back_Button,
            pharmacyModalView1HeadingText: this.Spa_AddPharmacy_ModalView1_HeadingText,
            pharmacyModalView1IntroText: this.Spa_AddPharmacy_ModalView1_IntroText,
            pharmacyModalView2HeadingText: this.Spa_AddPharmacy_ModalView2_HeadingText,
            pharmacyModalView2IntroText: this.Spa_AddPharmacy_ModalView2_IntroText,
            errorKeywordText: this.Spa_Site_ErrorKeyword_Text,
            isHelpfulToolsView: false,
            isPPCSite: this.siteService.isPPCSite(this.Spa_Site_SiteType)
        };
    }
    getProviderInputProps() {
        return {
            providersText: this.Spa_Site_Providers_Text,
            providersBodyText: this.Spa_Site_Providers_Body_Text,
            providersMultiBodyText: this.Spa_Multi_Providers_Body_Text,
            errorKeywordText: this.Spa_Site_ErrorKeyword_Text,
            zipLabel: this.Spa_Site_ZipCodeInput_ZipCodeLabel,
            zipErrorText: this.Spa_Site_ZipCodeInput_ZipCodeError,
            providerNameText: this.Spa_ProviderName_Text,
            providerNameHintText: this.Spa_ProviderName_HintText,
            providerSearchButtonText: this.Spa_Site_SearchButton_Text,
            providerLimit: this.Spa_Provider_Limit,
            itemsPerPage: this.Spa_ProviderSearch_Pagination_ItemsPerPage,
            providerPaginationEnabled: this.Spa_ProviderSearch_Pagination_Enabled,
            viewNotFoundHeaderText: this.Spa_Provider_Alt_View_Not_Found_Header_Text,
            viewNotFoundBodyText: this.Spa_Provider_Alt_View_Not_Found_Body_Text,
            paginationText: this.Spa_ProviderSearch_Pagination_View_Text,
            maxZoom: this.Spa_ProviderMap_Max_Zoom,
            minZoom: this.Spa_ProviderMap_Min_Zoom,
            providerMapDefaultZoom: this.Spa_ProviderMap_Default_Zoom,
            addProviderText: this.Spa_Provider_Add_Text,
            providerAddedText: this.Spa_Provider_Added_Text,
            yourProviderText: this.Spa_Provider_YourProvider_Text,
            removeProviderText: this.Spa_Provider_RemoveProvider_Text,
            setPrimaryCareProviderText: this.Spa_Provider_Set_Primary_Care_Provider_Text,
            primaryCareProviderText: this.Spa_Provider_Primary_Care_Provider_Text,
            providerFiltersEnabled: this.Spa_Providers_Filter_Enabled,
            providerGroupAddedLabelText: this.Spa_Group_Provider_Added_Text,
            providerGroupAddLabelText: this.Spa_Group_Provider_Add_Text,
            countyLabel: this.Spa_ZipCodeInput_CountyLabel_Text,
            showCountyLabel: this.Spa_ZipCodeInput_CountyLabel_Enabled,
            addLinkText: this.Spa_Site_Add,
            cancelProvidersLabel: this.Spa_Site_Cancel,
            providerSingleSelectEnabled: this.Spa_Select_Single_Provider_For_Multi_Address_Enabled,
            selectProviderLabelText: this.Spa_Select_Provider_Location_Text,
            providerExistsTooltipText: this.Spa_Provider_Exists_Text,
            providerMultiLocationText: this.Spa_Provider_Multiple_Location_Text,
            providerLocationsText: this.Spa_Plan_Providers_Locations_Link_Text,
            valueBasedCareEnabled: this.Spa_Site_ValueBasedCare_Enabled,
            valueBasedCareIcon: this.Spa_Site_ValueBasedCare_Icon,
            valueBasedCareText: this.Spa_Site_ValueBasedCare_Text,
            generalPracticeOptions: this.Spa_Provider_Search_Filter_General_Practice_Options,
            generalPracticeToolTipText: this.Spa_Provider_Search_General_Practice_Tooltip_Text,
            generalPracticeLabel: this.Spa_Provider_Search_General_Practice_Label_Text,
            generalPracticeFilterOptionEnabled: this.Spa_Provider_Search_Filter_General_Practice_Option_Enabled,
            singleProviderInListEnabled: this.Spa_Provider_Search_ShowSingleProviderInList_Enabled,
            updateLinkText: this.Spa_Site_Update_Text,
            editLinkText: this.Spa_Site_Edit_Text,
            showEditLinkEnabled: this.Spa_Provider_ShowEditLink_Enabled,
            valueBasedCareAvailableText: this.Spa_ValueBasedCare_Available_Text,
            valueBasedCareLearnMoreLink: this.Spa_ValueBasedCare_LearnMore_Link,
            valueBasedCareLearnMoreText: this.Spa_ValueBasedCare_LearnMore_Text,
            isValueBasedCareLearnMoreLink2Enabled: this.Spa_ValueBasedCare_LearnMoreLink2_Enabled,
            valueBasedCareToggleLabel: this.Spa_ValueBasedCare_Toggle_Label,
            valueBasedCareToggleToolTipText: this.Spa_ValueBasedCare_Toggle_ToolTip_Text,
            valueBasedCareToggleEnabled: this.Spa_ValueBasedCare_Toggle_Enabled,
            valueBasedCareToggleOptions: this.Spa_Provider_Search_Filter_ValueBasedCare_Options,
            pcpToggleEnabled: this.Spa_Primary_Care_Provider_Toggle_Enabled,
            newPatientToggleOptions: this.Spa_Provider_New_Patient_Options,
            newPatientToggleLabel: this.Spa_Provider_New_Patient_Toggle_Label,
            pcpToggleLabel: this.Spa_Primary_Care_Provider_Toggle_Label,
            pcpToggleOptions: this.Spa_Primary_Care_Provider_Options,
            newPatientText: this.Spa_New_Patient_For_Provider_Text,
            existingPatientText: this.Spa_Existing_Patient_For_Provider_Text,
            vbcNameFilterEnabled: this.Spa_Provider_ValueBasedCare_Name_Filter_Enabled,
            vbcNameFilterLabel: this.Spa_Provider_ValueBasedCare_Name_Filter_Label,
            selectedProviderOptionsEnabled: this.Spa_Selected_Provider_Options_Enabled,
            removeText: this.Spa_Site_Remove_Text,
            selectAllText: this.Spa_Site_SelectAll_Text,
            newPatientToggleEnabled: this.Spa_Provider_New_Patient_Toggle_Enabled,
            providerAddMaxLimitMessage: this.Spa_Provider_Add_Maximum_Limit_Message,
            providerFilterIndividualText: this.Spa_Providers_Filter_Individuals_Text,
            providerFacilitiesText: this.Spa_Providers_Filter_Facilties_Text,
            valueBasedCareFilterText: this.Spa_ValueBasedCare_Filter_Text,
            valueBasedCareFilterEnabled: this.Spa_Site_ValueBasedCare_Filter_Enabled,
            valueBasedCareFilterChecked: this.Spa_ValueBasedCare_Filter_Checked,
            valueBasedCareLearnMoreLinkEnabled: this.Spa_ValueBasedCare_LearnMoreLink_Enabled,
            backButtonText: this.Spa_Providers_Back_Button,
            modalProviderSearchViewHeadingText: this.Spa_AddProviders_ModalProviderSearchView_HeadingText,
            modalProviderSearchViewIntroText: this.Spa_AddProviders_ModalProviderSearchView_IntroText,
            modalProviderMapViewHeadingText: this.Spa_AddProviders_ModalProviderMapView_HeadingText,
            modalProviderMapViewIntroText: this.Spa_AddProviders_ModalProviderMapView_IntroText,
            modalProviderLocationViewHeadingText: this.Spa_AddProviders_ModalProviderLocationView_HeadingText,
            modalProviderLocationViewIntroText: this.Spa_AddProviders_ModalProviderLocationView_IntroText
        };
    }
    openProvidersModal() {
        this.guidedHelpModalService.openGuidedHelpModal(PageTags.GUIDED_HELP_PROVIDER_SEARCH, this.injector, {
            title: this.Spa_Site_Providers_Text,
            cancelButton: this.Spa_Site_Close_Modal,
            siteType: this.Spa_Site_SiteType,
            providerInputProps: this.providerInputProps
        });
    }
    openPrescriptionsModal() {
        this.guidedHelpModalService.openGuidedHelpModal(PageTags.GUIDED_HELP_PRESCRIPTIONS, this.injector, {
            title: this.Spa_Site_Prescriptions_Text,
            cancelButton: this.Spa_Site_Close_Modal,
            prescriptionInputProps: this.prescriptionInputProps,
            siteType: this.Spa_Site_SiteType
        });
    }
    openPharmacyModal() {
        this.guidedHelpModalService.openGuidedHelpModal(PageTags.GUIDED_HELP_PHARMACY_SEARCH, this.injector, {
            title: this.Spa_Site_Prescriptions_Text,
            cancelButton: this.Spa_Site_Close_Modal,
            pharmacyInputProps: this.pharmacyInputProps,
            siteType: this.Spa_Site_SiteType
        });
    }
};
PlanDetailsComponent.ɵfac = function PlanDetailsComponent_Factory(t) { return new (t || PlanDetailsComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.PassParameterService), i0.ɵɵdirectiveInject(i1.DeactivationGuardService), i0.ɵɵdirectiveInject(PlanDetailsFacade), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(FootnoteFacade), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(PharmacyContext), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(PlanListFacadeService), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(PharmacyFacade), i0.ɵɵdirectiveInject(i1.ProviderService), i0.ɵɵdirectiveInject(ProviderFacade), i0.ɵɵdirectiveInject(i1.PharmacyService), i0.ɵɵdirectiveInject(DrugCabinetContext), i0.ɵɵdirectiveInject(i1.MedSupService), i0.ɵɵdirectiveInject(HospitalIndemnityFormFacade), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(GuidedHelpModalService), i0.ɵɵdirectiveInject(i1.GuidedHelpModalContextService)); };
PlanDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanDetailsComponent, selectors: [["vnext-plan-details"]], viewQuery: function PlanDetailsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$X, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.planDetailsTabElement = _t);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService, PlanDetailsFacade]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "plan-page-title-tabs-container", "Spa_Style_Gray1_Background"], [1, "container"], [1, "row"], [1, "col-auto", "mx-auto", "text-center", "backToPlans"], [3, "title", "showArrow", "role", "ariaLabel", "click", "keyup.enter", 4, "liveEditProp"], [1, "col-md-12", "text-center", "no-translate-block"], [3, "ngSwitch"], [4, "ngSwitchCase"], ["class", "Spa_Style_H1 plan-name-header", 4, "ngSwitchDefault"], [1, "col-12", "mt-4"], ["navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["class", "row", 4, "ngIf"], [1, "row", "mb-3"], [1, "col-12", "col-md-4", "col-lg-3", "order-1", "order-md-2", 3, "ngClass"], [3, "plan", "planTotalPremium", "currentPlanText", "nextYearPlanText", "quoteLinkText", "sendQuoteButtonText", "monthlyPremiumText", "planLogoSize", "displayOptionLabels", "nonCommissionableText", "isNonCommissionableFlagCheckEnabled", "optionOneText", "optionTwoText", "stickyMiniCartEnabled", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "snpPremiumRangeEnabled"], [3, "preferencesBannerEnabled", "pharmacySelectorTextKey", "pharmacySelectorText", "pharmacies", "selectedPharmacy", "showPlanNetwork", "preferredInNetworkText", "standardInNetworkText", "outOfNetworkText", "addEditPharmacyLink", "showMailOrderOption", "mailOrderText", "isMailOrderSelected", "notCoveredText", "showNotCoveredText", "selectPharmacy", "navigateToPharmacyPage", "selectMailOrder", 4, "ngIf"], [3, "activePlanType"], ["class", "mt-3", 4, "ngIf"], [1, "col-12", "col-md-8", "col-lg-9", "order-2", "order-md-1", "mt-2", "mt-md-4", "details-list", 3, "ngSwitch"], ["aria-live", "polite", "id", "plan-prescriptions-tab", "role", "tabpanel", 3, "preferencesBannerEnabled", "plan", "prescriptionAddEditLinkTitle", "prescriptionsTabIntro", "prescriptionNoCost", "addPrescriptionButton", "noPrescriptionInTier", "nonCoveredPrescriptions", "coveredPrescriptions", "isEnabledShowDrugAlternatives", "prescriptionsDrugAlternativesInformationalText", "prescriptionsDrugAlternativesButtonText", "medicineCabinet", "showGenericOption", "costBasedOnRetailPharmacy", "cantSellPlanCostBasedOnRetailPharmacy", "costBasedOnMailOrderPharmacy", "cantSellPlanCostBasedOnMailOrderPharmacy", "costBasedOnSelectedPharmacy", "switchToMailLinkText", "switchToRetailLinkText", "addPharmacyLink", "editPharmacyLink", "formularyID", "formularyVersionText", "footnotes", "footnoteHeader", "showPharmacy", "addEditLinkDescription", "selectedTab", "isRetentionView", "noCostMedSupPlanText", "faqContent", "hideRetailMailOrderCost", "annualCost", "selectedPharmacy", "prescriptionTabView", "pharmacies", "isMailOrderSelected", "drugSearchFrequencies", "drugListCardBrandText", "drugListCardGenericText", "backToPrescriptionLabelText", "hintAlternativesForCabinetHeaderText", "hintNoAlternativesForCabinet", "hintAlternativesForCabinetText", "drugCostsRetailCostText", "conditionPrescribedForText", "changeMedicalConditionsEnabled", "cabinetForAlternatives", "footnoteIdsToShowForDrugAlternatives", 4, "ngSwitchCase"], ["id", "plan-details-tab", "role", "tabpanel", 3, "preferencesBannerEnabled", "modalHeaderHealthText", "closeButtonText", "healthCostsBenefits", "healthCostsBodyText", "healthCostsBenefitsBodyText", "healthCostsBenefitsTableHeader", "healthCostsUsageTableHeader", "healthCostsDaysTableHeader", "saveFailedText", "saveSuccessText", "healthCostsRestoreDefaultsText", "healthCostsUpdateAnswersText", "healthCostsSaveAnswersText", "healthAgeQuestionText", "healthCostsCustomizationEnabled", "healthSliderHeader1Text", "healthSliderHeader2Text", "healthSliderHeader3Text", "healthSliderBody1", "healthSliderBody2", "healthSliderBody3", "healthSliderLabelText", "healthModalView1HeadingText", "healthModalView1IntroText", "detailedPlan", "planBottomContentHeader", "planDetailsBottomContentText", "planBottomContentResource", "planTypeText", "costSectionHeader", "planLevelContentLabel", "showPlanLevelContent", "premiumText", "planBenefitSectionName", "pharmacyText", "preferencesText", "preferencesExpanded", "preferencesPositionLast", "showPreferences", "showProvider", "isProvidersEnabled", "showPrescription", "showPharmacy", "showOtherPreferences", "providerText", "prescriptionText", "otherPreferencesText", "addOnRidersHeader", "addOnRidersSubHeader", "prescriptionAddEditLinkTitle", "providersLink", "pharmacyLink", "preferencesAddEditLink", "pharmacyAddEditLink", "riderIsIncludedText", "waiverStateRiderTooltips", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "coveredDrugsText", "nonCoveredText", "coveredBenefitText", "nonCoveredBenefitText", "guidedHelpEnabled", "healthEnabled", "healthText", "costMA", "costMAPD", "costPDP", "costMEDIGAP", "costDENTAL", "costVISION", "costHIP", "costAddEditLinkText", "noCostAvailableText", "showRiderDetailsText", "hideRiderDetailsText", "showRiderDetails", "riderHIPBenefitText", "basePlanOptionLabel", "riderHIPBenefitDefaultDropdownText", "prescriptionAddEditLinkDescription", "pharmacyAddEditLinkDescription", "drugCostAddEditLinkDescription", "healthCostAddEditLinkDescription", "selectedTab", "isRetentionView", "noCostMedSupPlanText", "isLiveEdit", "prescriptionDirectoryLink", "searchProviderLink", "searchPrescriptionsText", "searchPharmacyLink", "searchPharmacyText", "searchProviderText", "providersDirectoryLink", "providersInternalDirectoryLink", "providersCarrierDirectoryLink", "isBothCarrierAndInternalProvidersDirectoryLinksEnabled", "Spa_Site_Tooltip_Text", "documentsSection", "planDetailsText", "showCosts", "annualCost", "isMultiPharmacyEnabled", "primaryPharmacyText", "primaryPharmacy", "selectedPharmacy", "pharmacies", "isMailOrderSelected", "showTierPharmacyNetworkLabel", "pharmacyNetworkText", "mailOrderPharmacyText", "mailOrderText", "showMailOrderPharmacy", "providersAddEditLinkTitle", "inNetworkProviderText", "outOfNetworkProviderText", "noProviderDetailsText", "pcpText", "selectedProviders", "providerDetailResponse", "isPlanPharmacyCovered", "noProviderNetworkAccessText", "canSellPlan", "planTotalPremium", "showDrugAlternativesEnabled", "showDrugAlternativesText", "addHealthCostText", "hideText", "viewAllText", "providerInfoEnabled", "providers", "acceptingNewPatientsIcon", "acceptingNewPatientsText", "languagesIcon", "providerLanguages", "providerMedicalGroups", "providersAcceptingNewPatients", "countryCode", "planFeesEnabled", "planFeesLabelText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "snpPremiumRangeEnabled", "isVbcAgreementEnabled", "vbcAgreementLabel", "vbcAgreementTooltip", "isZelisIntegrationEnabled", "benefitRidersSelected", "viewPossibleAlternativeDrugs", 4, "ngSwitchCase"], ["aria-live", "polite", "id", "plan-total-costs-tab", "role", "tabpanel", 3, "preferencesBannerEnabled", "plan", "totalCostDescriptionText", "totalEstAnnualCostText", "totalEstCostText", "totalEstimatedAnnualCostsMonth", "formularyID", "formularyVersionText", "faqContent", "prescriptionAddEditLinkTitle", "guidedHelpEnabled", "showPrescription", "totalCostEquationMA", "totalCostEquationMAPD", "totalCostEquationPDP", "planMonthlyEstimatedCostText", "monthlyBreakdownDrugLabelText", "monthlyBreakdownDrugPhaseLabelText", "monthlyBreakdownDrugCostLabelText", "monthlyBreakdownDeductible", "monthlyBreakdownCopay", "monthlyBreakdownGap", "monthlyBreakdownCatastrophic", "footnotes", "footnoteHeader", "keyNameForLiveEdit", "costBasedOnMailOrderPharmacy", "cantSellPlanCostBasedOnMailOrderPharmacy", "costBasedOnRetailPharmacy", "cantSellPlanCostBasedOnRetailPharmacy", "costBasedOnSelectedPharmacy", "switchToMailLinkText", "switchToRetailLinkText", "addPharmacyLink", "editPharmacyLink", "showPharmacy", "isMailOrder", "selectedPharmacy", "addEditLinkDescription", "selectedTab", "isRetentionView", "noCostMedSupPlanText", "hideRetailMailOrderCost", "annualCost", "effectiveDateLabel", "effectiveDateDropDownItems", "selectedValue", "selectedMonthIndex", 4, "ngSwitchCase"], [3, "preferencesBannerEnabled", "modalHeaderHealthText", "closeButtonText", "healthCostsBodyText", "healthCostsBenefitsBodyText", "saveSuccessText", "healthCostsRestoreDefaultsText", "healthCostsUpdateAnswersText", "healthCostsSaveAnswersText", "saveFailedText", "healthAgeQuestionText", "healthCostsCustomizationEnabled", "healthSliderHeader1Text", "healthSliderHeader2Text", "healthSliderHeader3Text", "healthSliderBody1", "healthSliderBody2", "healthSliderBody3", "healthSliderLabelText", "healthModalView1HeadingText", "healthModalView1IntroText", "annualCost", "plan", "addHealthCostText", "healthCostsDescriptionText", "noHealthCostTitle", "introHealthCostTitle", "healthCostsBenefitsTableHeader", "healthCostsUsageTableHeader", "healthCostsDaysTableHeader", "healthCostsUsageTableMobileText", "healthCostsDaysTableMobileText", "healthEstimatedCostTableHeader", "subTotalText", "healthCostsBenefits", "totalEstimatedCostText", "totalEstimatedAnnualCostText", "healthCostsOutOfPocketText", "healthCostsMedicalDeductibleText", "selectedTab", "isRetentionView", "noCostMedSupPlanText", 4, "ngSwitchCase"], [3, "title", "showArrow", "role", "ariaLabel", "click", "keyup.enter"], [1, "Spa_Style_H1", "plan-name-header"], ["navigationAdapter", "", 3, "innerHtml"], [1, "col-md-12"], ["class", "tabbing__content", 4, "ngIf"], ["class", "col-12", 3, "type", "bodyTemplate", 4, "ngIf"], ["ageRestrictionForEnrollment", ""], ["effectiveDateRestrictionForEnrollment", ""], [1, "tabbing__content"], ["role", "tablist", 1, "tabs", "tabs--horizontal", "plans-tab", "text-center"], [4, "ngFor", "ngForOf"], ["role", "presentation", "class", "tab Spa_Style_Gray2_Background Spa_Style_Primary_Color", 3, "active", "click", "keyup.enter", "keyup.Space", 4, "ngIf"], ["role", "presentation", 1, "tab", "Spa_Style_Gray2_Background", "Spa_Style_Primary_Color", 3, "click", "keyup.enter", "keyup.Space"], [3, "title", "currentIndex", "lastIndex", "isActiveTab", "ariaControlsId", "setFocusToTabEvent"], ["planDetailsTab", ""], [1, "col-12", 3, "type", "bodyTemplate"], [3, "makeInlineBlock", "title", "click", "keyup.enter"], [3, "makeInlineBlock", "title", "click"], [3, "numberOfDaysText", "daysText", "dayText", "editYourAnswersText", "lumpSumText", "basePlanText", "daysAmount", "benefitAmount"], [3, "preferencesBannerEnabled", "pharmacySelectorTextKey", "pharmacySelectorText", "pharmacies", "selectedPharmacy", "showPlanNetwork", "preferredInNetworkText", "standardInNetworkText", "outOfNetworkText", "addEditPharmacyLink", "showMailOrderOption", "mailOrderText", "isMailOrderSelected", "notCoveredText", "showNotCoveredText", "selectPharmacy", "navigateToPharmacyPage", "selectMailOrder"], [1, "mt-3"], [3, "informationalText", "callOutButtonText", "rateFactorModalTitle", "rateFactorFormPromptText", "rateFactorFormPageTitleText", "errorKeywordText", "errorNoticeTitle", "dropdownDefaultText", "rateFactorPlan", "areAllHospitalIndemnityQuestionsAnswered", "addToQuoteMobileLimit", "addToQuoteDesktopLimit"], ["aria-live", "polite", "id", "plan-prescriptions-tab", "role", "tabpanel", 3, "preferencesBannerEnabled", "plan", "prescriptionAddEditLinkTitle", "prescriptionsTabIntro", "prescriptionNoCost", "addPrescriptionButton", "noPrescriptionInTier", "nonCoveredPrescriptions", "coveredPrescriptions", "isEnabledShowDrugAlternatives", "prescriptionsDrugAlternativesInformationalText", "prescriptionsDrugAlternativesButtonText", "medicineCabinet", "showGenericOption", "costBasedOnRetailPharmacy", "cantSellPlanCostBasedOnRetailPharmacy", "costBasedOnMailOrderPharmacy", "cantSellPlanCostBasedOnMailOrderPharmacy", "costBasedOnSelectedPharmacy", "switchToMailLinkText", "switchToRetailLinkText", "addPharmacyLink", "editPharmacyLink", "formularyID", "formularyVersionText", "footnotes", "footnoteHeader", "showPharmacy", "addEditLinkDescription", "selectedTab", "isRetentionView", "noCostMedSupPlanText", "faqContent", "hideRetailMailOrderCost", "annualCost", "selectedPharmacy", "prescriptionTabView", "pharmacies", "isMailOrderSelected", "drugSearchFrequencies", "drugListCardBrandText", "drugListCardGenericText", "backToPrescriptionLabelText", "hintAlternativesForCabinetHeaderText", "hintNoAlternativesForCabinet", "hintAlternativesForCabinetText", "drugCostsRetailCostText", "conditionPrescribedForText", "changeMedicalConditionsEnabled", "cabinetForAlternatives", "footnoteIdsToShowForDrugAlternatives"], ["id", "plan-details-tab", "role", "tabpanel", 3, "preferencesBannerEnabled", "modalHeaderHealthText", "closeButtonText", "healthCostsBenefits", "healthCostsBodyText", "healthCostsBenefitsBodyText", "healthCostsBenefitsTableHeader", "healthCostsUsageTableHeader", "healthCostsDaysTableHeader", "saveFailedText", "saveSuccessText", "healthCostsRestoreDefaultsText", "healthCostsUpdateAnswersText", "healthCostsSaveAnswersText", "healthAgeQuestionText", "healthCostsCustomizationEnabled", "healthSliderHeader1Text", "healthSliderHeader2Text", "healthSliderHeader3Text", "healthSliderBody1", "healthSliderBody2", "healthSliderBody3", "healthSliderLabelText", "healthModalView1HeadingText", "healthModalView1IntroText", "detailedPlan", "planBottomContentHeader", "planDetailsBottomContentText", "planBottomContentResource", "planTypeText", "costSectionHeader", "planLevelContentLabel", "showPlanLevelContent", "premiumText", "planBenefitSectionName", "pharmacyText", "preferencesText", "preferencesExpanded", "preferencesPositionLast", "showPreferences", "showProvider", "isProvidersEnabled", "showPrescription", "showPharmacy", "showOtherPreferences", "providerText", "prescriptionText", "otherPreferencesText", "addOnRidersHeader", "addOnRidersSubHeader", "prescriptionAddEditLinkTitle", "providersLink", "pharmacyLink", "preferencesAddEditLink", "pharmacyAddEditLink", "riderIsIncludedText", "waiverStateRiderTooltips", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "coveredDrugsText", "nonCoveredText", "coveredBenefitText", "nonCoveredBenefitText", "guidedHelpEnabled", "healthEnabled", "healthText", "costMA", "costMAPD", "costPDP", "costMEDIGAP", "costDENTAL", "costVISION", "costHIP", "costAddEditLinkText", "noCostAvailableText", "showRiderDetailsText", "hideRiderDetailsText", "showRiderDetails", "riderHIPBenefitText", "basePlanOptionLabel", "riderHIPBenefitDefaultDropdownText", "prescriptionAddEditLinkDescription", "pharmacyAddEditLinkDescription", "drugCostAddEditLinkDescription", "healthCostAddEditLinkDescription", "selectedTab", "isRetentionView", "noCostMedSupPlanText", "isLiveEdit", "prescriptionDirectoryLink", "searchProviderLink", "searchPrescriptionsText", "searchPharmacyLink", "searchPharmacyText", "searchProviderText", "providersDirectoryLink", "providersInternalDirectoryLink", "providersCarrierDirectoryLink", "isBothCarrierAndInternalProvidersDirectoryLinksEnabled", "Spa_Site_Tooltip_Text", "documentsSection", "planDetailsText", "showCosts", "annualCost", "isMultiPharmacyEnabled", "primaryPharmacyText", "primaryPharmacy", "selectedPharmacy", "pharmacies", "isMailOrderSelected", "showTierPharmacyNetworkLabel", "pharmacyNetworkText", "mailOrderPharmacyText", "mailOrderText", "showMailOrderPharmacy", "providersAddEditLinkTitle", "inNetworkProviderText", "outOfNetworkProviderText", "noProviderDetailsText", "pcpText", "selectedProviders", "providerDetailResponse", "isPlanPharmacyCovered", "noProviderNetworkAccessText", "canSellPlan", "planTotalPremium", "showDrugAlternativesEnabled", "showDrugAlternativesText", "addHealthCostText", "hideText", "viewAllText", "providerInfoEnabled", "providers", "acceptingNewPatientsIcon", "acceptingNewPatientsText", "languagesIcon", "providerLanguages", "providerMedicalGroups", "providersAcceptingNewPatients", "countryCode", "planFeesEnabled", "planFeesLabelText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "snpPremiumRangeEnabled", "isVbcAgreementEnabled", "vbcAgreementLabel", "vbcAgreementTooltip", "isZelisIntegrationEnabled", "benefitRidersSelected", "viewPossibleAlternativeDrugs"], ["aria-live", "polite", "id", "plan-total-costs-tab", "role", "tabpanel", 3, "preferencesBannerEnabled", "plan", "totalCostDescriptionText", "totalEstAnnualCostText", "totalEstCostText", "totalEstimatedAnnualCostsMonth", "formularyID", "formularyVersionText", "faqContent", "prescriptionAddEditLinkTitle", "guidedHelpEnabled", "showPrescription", "totalCostEquationMA", "totalCostEquationMAPD", "totalCostEquationPDP", "planMonthlyEstimatedCostText", "monthlyBreakdownDrugLabelText", "monthlyBreakdownDrugPhaseLabelText", "monthlyBreakdownDrugCostLabelText", "monthlyBreakdownDeductible", "monthlyBreakdownCopay", "monthlyBreakdownGap", "monthlyBreakdownCatastrophic", "footnotes", "footnoteHeader", "keyNameForLiveEdit", "costBasedOnMailOrderPharmacy", "cantSellPlanCostBasedOnMailOrderPharmacy", "costBasedOnRetailPharmacy", "cantSellPlanCostBasedOnRetailPharmacy", "costBasedOnSelectedPharmacy", "switchToMailLinkText", "switchToRetailLinkText", "addPharmacyLink", "editPharmacyLink", "showPharmacy", "isMailOrder", "selectedPharmacy", "addEditLinkDescription", "selectedTab", "isRetentionView", "noCostMedSupPlanText", "hideRetailMailOrderCost", "annualCost", "effectiveDateLabel", "effectiveDateDropDownItems", "selectedValue", "selectedMonthIndex"], [3, "preferencesBannerEnabled", "modalHeaderHealthText", "closeButtonText", "healthCostsBodyText", "healthCostsBenefitsBodyText", "saveSuccessText", "healthCostsRestoreDefaultsText", "healthCostsUpdateAnswersText", "healthCostsSaveAnswersText", "saveFailedText", "healthAgeQuestionText", "healthCostsCustomizationEnabled", "healthSliderHeader1Text", "healthSliderHeader2Text", "healthSliderHeader3Text", "healthSliderBody1", "healthSliderBody2", "healthSliderBody3", "healthSliderLabelText", "healthModalView1HeadingText", "healthModalView1IntroText", "annualCost", "plan", "addHealthCostText", "healthCostsDescriptionText", "noHealthCostTitle", "introHealthCostTitle", "healthCostsBenefitsTableHeader", "healthCostsUsageTableHeader", "healthCostsDaysTableHeader", "healthCostsUsageTableMobileText", "healthCostsDaysTableMobileText", "healthEstimatedCostTableHeader", "subTotalText", "healthCostsBenefits", "totalEstimatedCostText", "totalEstimatedAnnualCostText", "healthCostsOutOfPocketText", "healthCostsMedicalDeductibleText", "selectedTab", "isRetentionView", "noCostMedSupPlanText"]], template: function PlanDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanDetailsComponent_div_0_Template, 27, 34, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.detailedPlan);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, i1$2.NgSwitchDefault, LinkComponent, NoticeComponent, NavigationAdapterDirective, LiveEditPropDirective, PlanDetailsTabComponent, PrescriptionsTabComponent, TotalCostsTabComponent, PlanSubDetailsComponent, PlanDetailsCardComponent, PharmacySelectorComponent, HealthCostTabComponent, HospitalIndemnityInformationNudgeComponent, EffectiveDateDisplayComponent, HIPDetailsBannerComponent, i1$2.AsyncPipe, SafePipe, OrderPipe], styles: [".backToPlans[_ngcontent-%COMP%]{margin-top:20px}.previous-text-link[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Primary_Link);font-size:14px;cursor:pointer}.previous-text-link[_ngcontent-%COMP%]:focus, .planNameHeader[_ngcontent-%COMP%]:focus{box-shadow:none;outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:inset 0 1px 1px #00000013,0 0 8px #72727299}.plan-name-header[_ngcontent-%COMP%]{margin-top:20px}.tab[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px 5px 0 0;margin:0 6px -1px;display:block;position:relative;text-decoration:none;outline:none;cursor:pointer}.tab[_ngcontent-%COMP%]:hover, .tab.active[_ngcontent-%COMP%]{background-color:#fff}.tab.active[_ngcontent-%COMP%]{border-bottom-color:#fff}.tabs[_ngcontent-%COMP%]{margin:0;padding:0;list-style:none;display:flex;justify-content:center;align-items:flex-end}.tabs--horizontal[_ngcontent-%COMP%]   .tab.active[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{border-bottom-color:#fff}.plans-tab.tabs[_ngcontent-%COMP%]{padding:15px 10px 0}.tabs--horizontal[_ngcontent-%COMP%]{margin-top:-1px}.tabTitle[_ngcontent-%COMP%]{font-weight:400}.details-list[_ngcontent-%COMP%]{margin:20px 0 0}.sticky[_ngcontent-%COMP%]{position:sticky;top:10px;background-color:#fff;z-index:1}.plan-page-title-tabs-container[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Accent1);margin:0 0 30px}"], changeDetection: 0 });
__decorate([
    Select(MedicineCabinetState.medicineCabinet)
], PlanDetailsComponent.prototype, "medicineCabinet$", void 0);
__decorate([
    Select(PharmacyState.selectedPharmacy)
], PlanDetailsComponent.prototype, "selectedPharmacy$", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Yes", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_No", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Health_Costs_Description_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_HealthCosts_Benefits_Table_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_HealthCosts_Usage_Table_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_HealthCosts_Days_Table_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_HealthCosts_EstCost_Table_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PlanDetails_EstimatedHealthCosts_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_HealthCosts_Subtotal_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_HealthCosts_Usage_Table_Mobile_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_HealthCosts_Days_Table_Mobile_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_HealthCosts_MedicalDeductible_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_HealthCosts_Out_Of_Pocket_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_HealthCosts_Benefits_Body_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_HealthCosts_Save_Failed_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_HealthCosts_Benefits_Table_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_HealthCosts_Usage_Table_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_HealthCosts_Days_Table_Header", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_HealthCosts_Restore_Defaults_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_HealthCosts_Update_Answers_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_HealthCosts_Save_Answers_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_HealthCosts_Save_Success_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Close_Modal", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_HealthCosts_Benefits_JSON", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_HealthCosts_Body_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Health_Slider_Label_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_NonCommissionable_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_NonCommissionable_FlagCheck_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_AddHealth_ModalView1_IntroText", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_AddHealth_ModalView1_HeadingText", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_GuidedHelp_Health_AgeQuestion_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_GuidedHelp_Health_SliderHeader1_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_GuidedHelp_Health_SliderHeader2_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_GuidedHelp_Health_SliderHeader3_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_GuidedHelp_Health_SliderBody1", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_GuidedHelp_Health_SliderBody2", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_GuidedHelp_Health_SliderBody3", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PlanCard_QuoteLinkName_Text", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Costs_Premium", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Plan_Benefits_Section_Name", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Plan_Details_Preferences_Pharmacy_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Plan_Details_Preferences_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Plan_Details_OtherPreferences_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Plan_Details_Preferences_Expanded", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Plan_Details_Preferences_Position_Last", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Plan_Details_Show_Preferences", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Plan_Details_Preferences_Show_Provider", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Plan_Details_Preferences_Show_Prescription", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Plan_Details_Preferences_Show_Pharmacy", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_OtherPreferences_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Prescriptions_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Pharmacy_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_HealthCosts_Customization_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_ZelisIntegration_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanCard_Benefit_DentalDeductible_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanCard_Benefit_CalendarYearMax_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanCard_Benefit_VisionDeductible_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Plan_Details_Preferences_Provider_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Plan_Details_Preferences_Prescription_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Plan_Details_AddOnRiders_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_PageSubHeader_Text", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_Plan_Details_AddOnRiders_SubHeader", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_Plan_Details_Providers_Link", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_Plan_Details_Pharmacy_Link", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Plan_Providers_Search_Provider_Text", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_Plan_Providers_Directory_Link", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Plan_Providers_Internal_Directory_Link_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Plan_Providers_Carrier_Directory_Link_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Plan_Providers_BothCarrierAndInternal_DirectoryLinks_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanList_Tab_Show_HIP", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PlanList_HIPFormPrompt_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PlanList_HIP_PageTitle_Text", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Preferences_ProviderDirectory_Link", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Plan_Details_WaiverStateRider_Tooltips", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_MedSup_RestrictMedSupPlansByAge_InfoLink", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_MedSup_RestrictMedSupPlansByAge_InfoText", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_ShoppingCart_IncludedRider_Text", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PrescriptionsTab_AddPrescriptionButton_Text", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PrescriptionsTab_NotInTier_Text", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PrescriptionsTab_NonCovered_Text", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PrescriptionsTab_Covered_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PrescriptionsTab_NoCostTitle_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PrescriptionsTab_Intro_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Add_Prescriptions_Button_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_None_Prescriptions_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Non_Covered_Prescriptions_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Covered_Prescriptions_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Pharmacy_InNetwork_Preferred_Pricing_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Pharmacy_InNetwork_Standard_Pricing_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Pharmacy_OutOfNetwork_Pricing_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Covered_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Non_Covered_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_TotalEstimatedAnnual_Cost_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_TotalEstimatedCost_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_GuidedHelp_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Health_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PharmacySelection_RetailPharmacyCosts_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PharmacySelection_CantSell_RetailPharmacyCosts_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PharmacySelection_MailOrderPharmacyCosts_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PharmacySelection_CantSell_MailOrderPharmacyCosts_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PharmacySelection_AddPharmacy_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PharmacySelection_Switch_To_MailOrder_Costs_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PharmacySelection_Switch_To_Retail_Costs", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PharmacySelection_Add_Link_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PharmacySelection_Edit_Link_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Show_GenericDrugOption", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugCost_Add_Edit_Link_Description", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_HealthCost_Add_Edit_Link_Description", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_PlanDetailsAndCompare_Show_Costs_MEDIGAP", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Previous", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PlanLevel_Content_Label_PDP", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PlanLevel_Content_Label_MAPD", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PlanLevel_Content_Label_MA", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PlanLevel_Content_Label_MEDIGAP", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PlanLevel_Content_Label_DENTAL", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PlanLevel_Content_Label_VISION", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PlanLevel_Content_Label_HIP", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_Show_Plan_Level_Content", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_Plandetails_Costs_Add_Edit_Link_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Health_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Health_Cost_Text", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_Plandetails_Costs_MAPD", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_Plandetails_Costs_MA", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_Plandetails_Costs_MEDIGAP", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_Plandetails_Costs_PDP", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Costs_DENTAL", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Costs_VISION", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Costs_HIP", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_Total_Costs_Breakdown_Equation_MA", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_Total_Costs_Breakdown_Equation_MAPD", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_Total_Costs_Breakdown_Equation_PDP", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Bottom_Content_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Bottom_Content_Text_PDP", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Bottom_Content_Text_MAPD", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Bottom_Content_Text_MA", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Bottom_Content_Text_MEDIGAP", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Bottom_Content_Text_DENTAL", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Bottom_Content_Text_VISION", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Bottom_Content_Text_HIP", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Costs_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Prescription_Add_Edit_Link", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Pharmacy_AddEdit_Link", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Preferences_AddEdit_Link", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Total_Costs_TabText", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Total_Costs_Description_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Total_Est_Cost_Month_1", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Total_Est_Cost_Month_2", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Total_Est_Cost_Month_3", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Total_Est_Cost_Month_4", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Total_Est_Cost_Month_5", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Total_Est_Cost_Month_6", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Total_Est_Cost_Month_7", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Total_Est_Cost_Month_8", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Total_Est_Cost_Month_9", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Total_Est_Cost_Month_10", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Total_Est_Cost_Month_11", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Total_Est_Cost_Month_12", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Formulary_ID_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Formulary_Version_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_MonthlyBreakdownDeductible", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_MonthlyBreakdownCopay", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_MonthlyBreakdownGap", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_MonthlyBreakdownCatastrophic", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_SendQuote_Button_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_NotApplicable_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Plan_Details_ViewRiderDetails_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Plan_Details_HideRiderDetails_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_RiderDetails_Show", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Plan_Monthly_Estimated_Cost_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Plan_MonthlyBreakdown_Drug_Label_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Plan_MonthlyBreakdown_DrugPhase_Label_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Plan_MonthlyBreakdown_DrugCost_Label_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_HealthCostsTab_AddAgeHealth_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_HealthCostsTab_NoCostTitle_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_HealthCostsTab_Intro_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Prescriptions_FAQ_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Total_Cost_FAQ_Text", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Footnotes", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_MailOrderFootnote_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_MailOrderFootnote_Index", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Footnote_Header", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_TotalEstimatedCost_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_InsulinFootnote_Index", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_PlanNotAvailableForNextYear_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Keep_This_Plan_Button_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Current_Plan_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Next_Year_Plan_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_IsDeepLinking_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_SiteType", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Prescription_Add_Edit_Link_Description", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Pharmacy_Add_Edit_Link_Description", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Preferences_SearchPrescriptions_Text", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Preferences_PrescriptionDirectory_Title", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Preferences_PrescriptionDirectory_Link", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Preferences_SearchPharmacy_Text", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Preferences_PharmacyDirectory_Title", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_Preferences_PharmacyDirectory_Link", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PlanCompare_PlanDocument_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Preferred_In_Network_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Standard_In_Network_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Out_Of_Network_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_CostBasedOn_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_PrimaryPharmacy_Indicator_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Mail_Order_Pharmacy_Enabled", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_PlanList_MailOrder_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Preferred_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Standard_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Show_Pharmacy_Tier_Label", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Selected_Pharmacy_Network_Label", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Mail_Order_Pharmacy_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_TotalCost_EffectiveDateLabel_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Providers_Add_Edit_Link", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_InNetwork_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_OutOfNetwork_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Providers_No_Data_Exist_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Pcp_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Providers_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Preferences_Score_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Providers_NoProviderNetworkAccess_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_HealthCosts_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Plan_List_Link", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_HIP_Call_Out_Available_Plan_Types", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_HIP_Call_Out_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_HIP_Call_Out_Informational_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_HIP_Call_Out_Text_Button", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_HIP_RateFactorModal_Title", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_ErrorKeyword_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_EnrollmentErrorNotice_Title", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanList_MedSupFormDropdownDefault_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "SPA_HIP_Rider_Benefit_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_HIP_MonthlyPremium_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "SPA_HIP_Rider_Benefit_Default_Dropdown_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_HIP_BasePlanOption_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanList_AddToQuote_Limit_Mobile", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanList_AddToQuote_Limit", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Hide_EmptyPlanTabs", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_PlanLogo_Size", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_ShowDrugAlternatives_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_ShowDrugAlternatives_Nudge_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Prescriptions_ShowDrugAlternatives_Informational_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Prescriptions_ShowDrugAlternatives_ViewAlternatives_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_Frequency_List", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugCosts_RetailCostText", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugListCard_Brand_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugListCard_Generic_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_BackToPrescriptions_Link_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_Header_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_Intro_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_NoDrugs_Empty_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanDetails_StickyMiniCart_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Prescriptions_ShowDrugAlternatives_Condition_Modal_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_ShowDrugAlternatives_Change_Medical_Conditions_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanFilters_DayLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Days_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Day_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanList_MedSupEditAnswersBanner_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_LumpSum_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Hide_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_ViewAll_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Provider_ShowAllInNetworkLocations_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Retention_ClientDefinedPlanOptions_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Plan_Option_One_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Plan_Option_Two_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Providers_AcceptingNewPatients_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Providers_AcceptingNewPatients_Icon", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Providers_Languages_Icon", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_PlanFees_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanFees_Label_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanFees_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanFees_IncludedInPremium_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Display_SNP_PremiumRange_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_ValueBasedCare_Agreement_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_ValueBasedCare_Agreement_Label", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_ValueBasedCare_Agreement_Tooltip", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_Content_Section_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_Dosage_Header", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_Frequency_Header", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_Package_Header", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_Add_Button", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_Cancel_Button", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_Back_Button", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_EditDrug_Button", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_Quantity_Max_Limit", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_Cabinet_Limit", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_MaxCount_Error_Message", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_Quantity_Error_Message", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_Label_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_Drugs_Image", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_InCabinetError_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_Medicine_Header", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_GenericOption_Icon", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_GenericOption_Question", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_GenericOption_Info", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_GenericOptions", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_CheckDrugCoverageButton_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_GenericOption_Default_Selection", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugListCard_HideCosts_Flag", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_DrugSearch_Hint_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_DrugSearch_Intro_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_DrugSearch_PageHeader_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_Frequency_ListBox_Label", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Enable_BlueButton", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_OrText", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_BlueButton_StartAddDrug_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_BlueButton_MyMedicare_Connect_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_BlueButton_MyMedicare_Button", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_EmailAddress_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Profile_EmailRequired_Error", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Profile_EmailInvalid_Error", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_SendEmailButton_Text", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_BlueButton_Modal_Header", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_BlueButton_Modal_Content", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_BlueButton_Success_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_BlueButton_Download_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_BlueButton_Success_Message", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_BlueButton_EmailSentToStatus_Text", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_BlueButton_Issue_Loading_Text", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_BlueButton_Beneficiary_Denied_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_BlueButton_Error_Loading_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_BlueButton_Beneficiary_Email_Details", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_BlueButton_ImportLatestPrescription_Button_Text", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_BlueButton_ImportLatestPrescription_Error_Text", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_BlueButton_AccessDenied_Error_Text", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_BlueButton_ClaimData_Loading_Error_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Drugs_UseCMSDrugFlag_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_AddPrescriptions_ModalView1_HeadingText", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_AddPrescriptions_ModalView1_IntroText", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_AddPrescriptions_ModalView2_HeadingText", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_AddPrescriptions_ModalView2_IntroText", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_DrugSearch_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Prescriptions_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Providers_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Providers_Body_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Multi_Providers_Body_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_Add_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_Added_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_RemoveProvider_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Provider_YourProvider_Text", void 0);
__decorate([
    PlatformProp()
], PlanDetailsComponent.prototype, "Spa_Provider_Set_Primary_Care_Provider_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_Primary_Care_Provider_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_ZipCodeInput_ZipCodeLabel", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_ZipCodeInput_ZipCodeError", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Providers_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Group_Provider_Add_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Group_Provider_Added_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Add", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Cancel", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Select_Single_Provider_For_Multi_Address_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Select_Provider_Location_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_Exists_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_Multiple_Location_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Plan_Providers_Locations_Link_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_ValueBasedCare_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_ValueBasedCare_Icon", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_ValueBasedCare_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_Search_Filter_General_Practice_Options", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_Search_General_Practice_Label_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_Search_General_Practice_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_Search_Filter_General_Practice_Option_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_Search_ShowSingleProviderInList_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Edit_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Update_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_ShowEditLink_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_ValueBasedCare_Available_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_ValueBasedCare_LearnMore_Link", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_ValueBasedCare_LearnMore_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_ValueBasedCare_LearnMoreLink2_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_ValueBasedCare_Toggle_Label", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_ValueBasedCare_Toggle_ToolTip_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_ValueBasedCare_Toggle_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_Search_Filter_ValueBasedCare_Options", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_New_Patient_Toggle_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_New_Patient_Toggle_Label", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_New_Patient_Options", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Primary_Care_Provider_Toggle_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Primary_Care_Provider_Toggle_Label", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Primary_Care_Provider_Options", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_New_Patient_For_Provider_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Existing_Patient_For_Provider_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_ValueBasedCare_Name_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_ValueBasedCare_Name_Filter_Label", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Selected_Provider_Options_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Remove_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_SelectAll_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_ProviderName_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_ProviderName_HintText", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_SearchButton_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_Limit", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_ProviderSearch_Pagination_ItemsPerPage", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_ProviderSearch_Pagination_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_ProviderSearch_Pagination_View_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_Alt_View_Not_Found_Header_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_Alt_View_Not_Found_Body_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_ProviderMap_Max_Zoom", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_ProviderMap_Min_Zoom", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_ProviderMap_Default_Zoom", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Provider_Add_Maximum_Limit_Message", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Providers_Filter_Individuals_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Providers_Filter_Facilties_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_ValueBasedCare_Filter_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_ValueBasedCare_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_ValueBasedCare_Filter_Checked", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_ValueBasedCare_LearnMoreLink_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Providers_Back_Button", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_AddProviders_ModalProviderSearchView_HeadingText", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_AddProviders_ModalProviderSearchView_IntroText", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_AddProviders_ModalProviderMapView_HeadingText", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_AddProviders_ModalProviderMapView_IntroText", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_AddProviders_ModalProviderLocationView_HeadingText", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_AddProviders_ModalProviderLocationView_IntroText", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PharmacySearch_Standard_In_Network_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Pharmacy_Alt_View_Not_Found_Header_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Pharmacy_Alt_View_Not_Found_Body_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PharmacyName_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Add_Pharmacy_Button", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Filter_Default_Filter_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PharmacyName_HintText", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Pharmacy_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Pharmacy_In_Network_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Pharmacy_Other_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanFilters_Modal_Link", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanFilters_Modal_Cancel_Button", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PlanFilters_Modal_Apply_Button", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Digital_Pharmacy_Enabled", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_Pharmacy_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Pharmacy_Limit", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PharmacyMap_Default_Zoom", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PharmacyMap_Max_Zoom", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PharmacyMap_Min_Zoom", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Maximum_Pharmacy_Count", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Set_Primary_Pharmacy_Link_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Multi_Pharmacy_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PharmacySearch_Back_Button", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_AddPharmacy_ModalView1_IntroText", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_AddPharmacy_ModalView1_HeadingText", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_AddPharmacy_ModalView2_IntroText", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_AddPharmacy_ModalView2_HeadingText", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PharmacySearch_Pagination_ItemsPerPage", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PharmacySearch_Pagination_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PharmacySearch_Pagination_View_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_Site_AddPharmacy_YourMultiPharmacyText", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Pharmacy_Added_Label", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Pharmacy_Retail_Tab_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Pharmacy_Digital_Tab_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_AddPharmacy_YourPharmacyText", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_ElectronicPrescription_ToolTipHeader", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_ElectronicPrescription_ToolTipBody", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Primary_Pharmacy_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Primary_Pharmacy_Icon", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Primary_Pharmacy_Icon_Color", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Plans_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Pharmacy_Digital_Tab_Intro_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Plan_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Filter_Header_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Filter_Clear_All", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PharmacySearch_PageHeader_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Pharmacy_Added_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_Pharmacy_Add_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Site_EPrescribing_Alt_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PharmacySearch_Intro_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanDetailsComponent.prototype, "Spa_PharmacySearch_MultiPharmacy_Intro_Text", void 0);
__decorate([
    GlobalResource(true)
], PlanDetailsComponent.prototype, "Spa_Site_Pharmacy_Limit_Error_Message", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Pharmacy_Filter_Open24hrs_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Pharmacy_Filter_Eprescribing_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Pharmacy_Filter_HandicapAccess_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Pharmacy_Filter_DurableEquipment_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Pharmacy_Filter_MailOrder_Text", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Pharmacy_In_Network_Filters", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_Pharmacy_Filters", void 0);
__decorate([
    GlobalResource()
], PlanDetailsComponent.prototype, "Spa_PreferenceBanner_Enabled", void 0);
__decorate([
    LiveEditInactive()
], PlanDetailsComponent.prototype, "updateSelectedPharmacy", null);
PlanDetailsComponent = __decorate([
    PlatformWidget
], PlanDetailsComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanDetailsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-details', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService, PlanDetailsFacade], template: "<div *ngIf=\"detailedPlan\">\r\n  <div class=\"plan-page-title-tabs-container Spa_Style_Gray1_Background\">\r\n    <div class=\"container\">\r\n      <div class=\"row\">\r\n        <div class=\"col-auto mx-auto text-center backToPlans\">\r\n          <vnext-link\r\n            [title]=\"isDeepLink ? Spa_Site_Plan_List_Link : Spa_Site_Previous\"\r\n            [showArrow]=\"'left'\"\r\n            (click)=\"backToPrevious()\"\r\n            (keyup.enter)=\"backToPrevious()\"\r\n            [role]=\"linkRoles.LINK\"\r\n            [ariaLabel]=\"isDeepLink ? Spa_Site_Plan_List_Link : Spa_Site_Previous\"\r\n            *liveEditProp=\"'isDeepLink ? Spa_Site_Plan_List_Link : Spa_Site_Previous'\"\r\n          >\r\n          </vnext-link>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12 text-center no-translate-block\">\r\n          <ng-container [ngSwitch]=\"detailedPlan.planTypeAbbreviation\">\r\n            <div *ngSwitchCase=\"planTypeAbbreviation.HC\">\r\n              <h1 class=\"Spa_Style_H1 plan-name-header\">{{ detailedPlan.carrierName }}</h1>\r\n            </div>\r\n\r\n            <h1 *ngSwitchDefault class=\"Spa_Style_H1 plan-name-header\">\r\n              {{ detailedPlan.planName }}\r\n            </h1>\r\n          </ng-container>\r\n        </div>\r\n        <div class=\"col-12 mt-4\">\r\n          <div\r\n            *liveEditProp=\"'Spa_Site_PageSubHeader_Text'\"\r\n            [innerHtml]=\"Spa_Site_PageSubHeader_Text ? (Spa_Site_PageSubHeader_Text | safe : 'html') : ''\"\r\n            navigationAdapter\r\n          ></div>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\" *ngIf=\"!isHCPlan\">\r\n        <div class=\"col-md-12\">\r\n          <div *ngIf=\"planDetailTabs && planDetailTabs.length\" class=\"tabbing__content\">\r\n            <ul class=\"tabs tabs--horizontal plans-tab text-center\" role=\"tablist\">\r\n              <ng-container *ngFor=\"let tab of planDetailTabs; index as index\">\r\n                <li\r\n                  role=\"presentation\"\r\n                  *ngIf=\"Spa_Site_TotalEstimatedCost_Enabled || tab.name !== planDetailsTabs.TOTAL_COSTS\"\r\n                  class=\"tab Spa_Style_Gray2_Background Spa_Style_Primary_Color\"\r\n                  (click)=\"updateActiveTab(tab.name)\"\r\n                  (keyup.enter)=\"updateActiveTab(tab.name)\"\r\n                  (keyup.Space)=\"updateActiveTab(tab.name)\"\r\n                  [class.active]=\"activeTab === tab.name\"\r\n                >\r\n                  <vnext-plan-details-tab\r\n                    #planDetailsTab\r\n                    [title]=\"tab.title\"\r\n                    [currentIndex]=\"index\"\r\n                    [lastIndex]=\"planDetailTabs.length - 1\"\r\n                    (setFocusToTabEvent)=\"shiftFocusToTabElement($event)\"\r\n                    [isActiveTab]=\"activeTab === tab.name\"\r\n                    [ariaControlsId]=\"tab.id\"\r\n                  >\r\n                  </vnext-plan-details-tab>\r\n                </li>\r\n              </ng-container>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n\r\n        <vnext-notice class=\"col-12\" [type]=\"'info'\" [bodyTemplate]=\"ageRestrictionForEnrollment\" *ngIf=\"showAgeRestrictionBanner$ | async\">\r\n        </vnext-notice>\r\n        <ng-template #ageRestrictionForEnrollment>\r\n          <span>\r\n            {{ Spa_MedSup_RestrictMedSupPlansByAge_InfoText }}\r\n            <vnext-link\r\n              [makeInlineBlock]=\"true\"\r\n              (click)=\"openMedSupForm()\"\r\n              (keyup.enter)=\"openMedSupForm()\"\r\n              [title]=\"Spa_MedSup_RestrictMedSupPlansByAge_InfoLink\"\r\n            ></vnext-link>\r\n          </span>\r\n        </ng-template>\r\n        <vnext-notice\r\n          class=\"col-12\"\r\n          [type]=\"'info'\"\r\n          [bodyTemplate]=\"effectiveDateRestrictionForEnrollment\"\r\n          *ngIf=\"showEffectiveDateRestrictionBanner$ | async\"\r\n        >\r\n        </vnext-notice>\r\n        <ng-template #effectiveDateRestrictionForEnrollment>\r\n          {{ planFacade.getEffectiveDateRestrictionText() }}\r\n          <vnext-link\r\n            [makeInlineBlock]=\"true\"\r\n            (click)=\"openMedSupForm()\"\r\n            [title]=\"Spa_MedSup_RestrictMedSupPlansByAge_InfoLink\"\r\n          ></vnext-link>\r\n        </ng-template>\r\n      </div>\r\n      <div *ngIf=\"isHCPlan\">\r\n        <vnext-hip-details-banner\r\n          [numberOfDaysText]=\"Spa_PlanFilters_DayLabel_Text\"\r\n          [daysText]=\"Spa_Site_Days_Text\"\r\n          [dayText]=\"Spa_Site_Day_Text\"\r\n          [editYourAnswersText]=\"Spa_PlanList_MedSupEditAnswersBanner_Text\"\r\n          [lumpSumText]=\"Spa_Site_LumpSum_Text\"\r\n          [basePlanText]=\"Spa_Site_HIP_BasePlanOption_Text\"\r\n          [daysAmount]=\"numberOfDaysHIPAnswer\"\r\n          [benefitAmount]=\"benefitAmountHIPAnswer\"\r\n        ></vnext-hip-details-banner>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"container\">\r\n    <div class=\"row mb-3\">\r\n      <div\r\n        class=\"col-12 col-md-4 col-lg-3 order-1 order-md-2\"\r\n        [ngClass]=\"Spa_PlanDetails_StickyMiniCart_Enabled && !isMobile ? 'pt-4 pb-4 pt-sm-0 mt-0 mt-sm-4 h-100 sticky' : 'mt-4'\"\r\n      >\r\n        <vnext-widget-plan-details-card\r\n          [plan]=\"detailedPlan\"\r\n          [planTotalPremium]=\"detailedPlanTotalPremium\"\r\n          [currentPlanText]=\"Spa_Site_Current_Plan_Text\"\r\n          [nextYearPlanText]=\"Spa_Site_Next_Year_Plan_Text\"\r\n          [quoteLinkText]=\"Spa_PlanCard_QuoteLinkName_Text\"\r\n          [sendQuoteButtonText]=\"Spa_Site_SendQuote_Button_Text\"\r\n          [monthlyPremiumText]=\"Spa_Site_HIP_MonthlyPremium_Text\"\r\n          [planLogoSize]=\"Spa_Site_PlanLogo_Size\"\r\n          [displayOptionLabels]=\"Spa_Retention_ClientDefinedPlanOptions_Enabled\"\r\n          [nonCommissionableText]=\"Spa_PlanDetails_NonCommissionable_Text\"\r\n          [isNonCommissionableFlagCheckEnabled]=\"Spa_PlanDetails_NonCommissionable_FlagCheck_Enabled\"\r\n          [optionOneText]=\"Spa_Site_Plan_Option_One_Text\"\r\n          [optionTwoText]=\"Spa_Site_Plan_Option_Two_Text\"\r\n          [stickyMiniCartEnabled]=\"Spa_PlanDetails_StickyMiniCart_Enabled\"\r\n          [planFeesEnabled]=\"Spa_Site_PlanFees_Enabled\"\r\n          [planFeesTooltipText]=\"Spa_PlanFees_Tooltip_Text\"\r\n          [planFeesIncludedInPremiumTooltipText]=\"Spa_PlanFees_IncludedInPremium_Tooltip_Text\"\r\n          [planFeesNotIncludedInPremiumTooltipText]=\"Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text\"\r\n          [snpPremiumRangeEnabled]=\"Spa_Display_SNP_PremiumRange_Enabled\"\r\n        >\r\n        </vnext-widget-plan-details-card>\r\n\r\n        <vnext-pharmacy-selector\r\n          *ngIf=\"planDetailsFacade.showPharmacySelectorToggle(detailedPlan)\"\r\n          [preferencesBannerEnabled]=\"Spa_PreferenceBanner_Enabled\"\r\n          [pharmacySelectorTextKey]=\"'Spa_Site_CostBasedOn_Text'\"\r\n          [pharmacySelectorText]=\"Spa_Site_CostBasedOn_Text\"\r\n          [pharmacies]=\"selectedPharmacies$ | async\"\r\n          [selectedPharmacy]=\"selectedPharmacy\"\r\n          [showPlanNetwork]=\"true\"\r\n          [preferredInNetworkText]=\"Spa_Site_Preferred_In_Network_Text\"\r\n          [standardInNetworkText]=\"Spa_Site_Standard_In_Network_Text\"\r\n          [outOfNetworkText]=\"Spa_Site_Out_Of_Network_Text\"\r\n          [addEditPharmacyLink]=\"Spa_Site_Pharmacy_AddEdit_Link\"\r\n          [showMailOrderOption]=\"Spa_Site_Mail_Order_Pharmacy_Enabled\"\r\n          [mailOrderText]=\"Spa_PlanList_MailOrder_Text\"\r\n          [isMailOrderSelected]=\"isMailOrderSelected\"\r\n          [notCoveredText]=\"Spa_PlanDetails_Non_Covered_Text\"\r\n          [showNotCoveredText]=\"!detailedPlan.hasMailDrugBenefits\"\r\n          (selectPharmacy)=\"updateSelectedPharmacy($event)\"\r\n          (navigateToPharmacyPage)=\"planDetailsFacade.navigateByPageTag(pageTags.GUIDED_HELP_PHARMACY_SEARCH)\"\r\n          (selectMailOrder)=\"pharmacyFacade.switchMailOrder(true)\"\r\n        >\r\n        </vnext-pharmacy-selector>\r\n        <vnext-effective-date-display [activePlanType]=\"detailedPlan.planTypeAbbreviation\"></vnext-effective-date-display>\r\n\r\n        <div\r\n          class=\"mt-3\"\r\n          *ngIf=\"\r\n            Spa_PlanList_Tab_Show_HIP &&\r\n            Spa_PlanDetails_HIP_Call_Out_Enabled &&\r\n            isHIPCallOutAvailableToDetailedPlan &&\r\n            hasHospitalIndemnityQuestions &&\r\n            showHospitalCareCalloutBasedHidingStatesCoverage\r\n          \"\r\n        >\r\n          <vnext-hospital-indemnity-information-nudge\r\n            [informationalText]=\"Spa_PlanDetails_HIP_Call_Out_Informational_Text\"\r\n            [callOutButtonText]=\"Spa_PlanDetails_HIP_Call_Out_Text_Button\"\r\n            [rateFactorModalTitle]=\"Spa_PlanDetails_HIP_RateFactorModal_Title\"\r\n            [rateFactorFormPromptText]=\"Spa_PlanList_HIPFormPrompt_Text\"\r\n            [rateFactorFormPageTitleText]=\"Spa_PlanList_HIP_PageTitle_Text\"\r\n            [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n            [errorNoticeTitle]=\"Spa_Site_EnrollmentErrorNotice_Title\"\r\n            [dropdownDefaultText]=\"Spa_PlanList_MedSupFormDropdownDefault_Text\"\r\n            [rateFactorPlan]=\"detailedPlan\"\r\n            [areAllHospitalIndemnityQuestionsAnswered]=\"areAllHospitalIndemnityQuestionsAnswered\"\r\n            [addToQuoteMobileLimit]=\"Spa_PlanList_AddToQuote_Limit_Mobile\"\r\n            [addToQuoteDesktopLimit]=\"Spa_PlanList_AddToQuote_Limit\"\r\n          >\r\n          </vnext-hospital-indemnity-information-nudge>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-12 col-md-8 col-lg-9 order-2 order-md-1 mt-2 mt-md-4 details-list\" [ngSwitch]=\"activeTab\">\r\n        <vnext-plan-prescription-details\r\n          *ngSwitchCase=\"planDetailsTabs.PRESCRIPTIONS\"\r\n          [preferencesBannerEnabled]=\"Spa_PreferenceBanner_Enabled\"\r\n          [plan]=\"detailedPlan\"\r\n          [prescriptionAddEditLinkTitle]=\"Spa_Prescription_Add_Edit_Link\"\r\n          [prescriptionsTabIntro]=\"Spa_PrescriptionsTab_Intro_Text\"\r\n          [prescriptionNoCost]=\"Spa_PrescriptionsTab_NoCostTitle_Text\"\r\n          [addPrescriptionButton]=\"Spa_PrescriptionsTab_AddPrescriptionButton_Text\"\r\n          [noPrescriptionInTier]=\"Spa_PrescriptionsTab_NotInTier_Text\"\r\n          [nonCoveredPrescriptions]=\"Spa_PrescriptionsTab_NonCovered_Text\"\r\n          [coveredPrescriptions]=\"Spa_PrescriptionsTab_Covered_Text\"\r\n          [isEnabledShowDrugAlternatives]=\"Spa_Site_ShowDrugAlternatives_Enabled && Spa_PlanDetails_ShowDrugAlternatives_Nudge_Enabled\"\r\n          [prescriptionsDrugAlternativesInformationalText]=\"Spa_Prescriptions_ShowDrugAlternatives_Informational_Text\"\r\n          [prescriptionsDrugAlternativesButtonText]=\"Spa_Prescriptions_ShowDrugAlternatives_ViewAlternatives_Text\"\r\n          [medicineCabinet]=\"medicineCabinet$ | async | orderBy : 'labelName' : false : true\"\r\n          [showGenericOption]=\"Spa_Site_Show_GenericDrugOption\"\r\n          [costBasedOnRetailPharmacy]=\"Spa_PharmacySelection_RetailPharmacyCosts_Text\"\r\n          [cantSellPlanCostBasedOnRetailPharmacy]=\"Spa_PharmacySelection_CantSell_RetailPharmacyCosts_Text\"\r\n          [costBasedOnMailOrderPharmacy]=\"Spa_PharmacySelection_MailOrderPharmacyCosts_Text\"\r\n          [cantSellPlanCostBasedOnMailOrderPharmacy]=\"Spa_PharmacySelection_CantSell_MailOrderPharmacyCosts_Text\"\r\n          [costBasedOnSelectedPharmacy]=\"Spa_PharmacySelection_AddPharmacy_Text\"\r\n          [switchToMailLinkText]=\"Spa_PharmacySelection_Switch_To_MailOrder_Costs_Text\"\r\n          [switchToRetailLinkText]=\"Spa_PharmacySelection_Switch_To_Retail_Costs\"\r\n          [addPharmacyLink]=\"Spa_PharmacySelection_Add_Link_Text\"\r\n          [editPharmacyLink]=\"Spa_PharmacySelection_Edit_Link_Text\"\r\n          [formularyID]=\"Spa_Site_Formulary_ID_Text\"\r\n          [formularyVersionText]=\"Spa_Site_Formulary_Version_Text\"\r\n          [footnotes]=\"Spa_PlanDetails_Footnotes\"\r\n          [footnoteHeader]=\"Spa_PlanDetails_Footnote_Header\"\r\n          [showPharmacy]=\"Spa_Site_Pharmacy_Enabled\"\r\n          aria-live=\"polite\"\r\n          id=\"plan-prescriptions-tab\"\r\n          role=\"tabpanel\"\r\n          [addEditLinkDescription]=\"Spa_Prescription_Add_Edit_Link_Description\"\r\n          [selectedTab]=\"activeTab\"\r\n          [isRetentionView]=\"isRetentionView\"\r\n          [noCostMedSupPlanText]=\"noCostMedSupPlanText\"\r\n          [faqContent]=\"Spa_Prescriptions_FAQ_Text\"\r\n          [hideRetailMailOrderCost]=\"pharmacyFacade.showPharmacySelectorToggle(detailedPlan.planTypeAbbreviation)\"\r\n          [annualCost]=\"annualCost\"\r\n          [selectedPharmacy]=\"selectedPharmacy\"\r\n          [prescriptionTabView]=\"prescriptionTabViewMode\"\r\n          [pharmacies]=\"pharmacies\"\r\n          [isMailOrderSelected]=\"isMailOrderSelected\"\r\n          [drugSearchFrequencies]=\"Spa_DrugSearch_Frequency_List\"\r\n          [drugListCardBrandText]=\"Spa_DrugListCard_Brand_Text\"\r\n          [drugListCardGenericText]=\"Spa_DrugListCard_Generic_Text\"\r\n          [backToPrescriptionLabelText]=\"Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_BackToPrescriptions_Link_Text\"\r\n          [hintAlternativesForCabinetHeaderText]=\"Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_Header_Text\"\r\n          [hintNoAlternativesForCabinet]=\"Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_NoDrugs_Empty_Text\"\r\n          [hintAlternativesForCabinetText]=\"Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_Intro_Text\"\r\n          [drugCostsRetailCostText]=\"Spa_DrugCosts_RetailCostText\"\r\n          [conditionPrescribedForText]=\"Spa_Prescriptions_ShowDrugAlternatives_Condition_Modal_Text\"\r\n          [changeMedicalConditionsEnabled]=\"Spa_Site_ShowDrugAlternatives_Change_Medical_Conditions_Enabled\"\r\n          [cabinetForAlternatives]=\"cabinetForAlternatives\"\r\n          [footnoteIdsToShowForDrugAlternatives]=\"footnoteIdsToShowForDrugAlternatives\"\r\n        >\r\n        </vnext-plan-prescription-details>\r\n\r\n        <vnext-plan-sub-details\r\n          *ngSwitchCase=\"planDetailsTabs.PLAN_DETAILS\"\r\n          [preferencesBannerEnabled]=\"Spa_PreferenceBanner_Enabled\"\r\n          [modalHeaderHealthText]=\"Spa_Site_Health_Text\"\r\n          [closeButtonText]=\"Spa_Site_Close_Modal\"\r\n          [healthCostsBenefits]=\"Spa_Site_HealthCosts_Benefits_JSON\"\r\n          [healthCostsBodyText]=\"Spa_HealthCosts_Body_Text\"\r\n          [healthCostsBenefitsBodyText]=\"Spa_HealthCosts_Benefits_Body_Text\"\r\n          [healthCostsBenefitsTableHeader]=\"Spa_Site_HealthCosts_Benefits_Table_Header\"\r\n          [healthCostsUsageTableHeader]=\"Spa_Site_HealthCosts_Usage_Table_Header\"\r\n          [healthCostsDaysTableHeader]=\"Spa_Site_HealthCosts_Days_Table_Header\"\r\n          [saveFailedText]=\"Spa_Site_HealthCosts_Save_Failed_Text\"\r\n          [saveSuccessText]=\"Spa_Site_HealthCosts_Save_Success_Text\"\r\n          [healthCostsRestoreDefaultsText]=\"Spa_Site_HealthCosts_Restore_Defaults_Text\"\r\n          [healthCostsUpdateAnswersText]=\"Spa_Site_HealthCosts_Update_Answers_Text\"\r\n          [healthCostsSaveAnswersText]=\"Spa_Site_HealthCosts_Save_Answers_Text\"\r\n          [healthAgeQuestionText]=\"Spa_GuidedHelp_Health_AgeQuestion_Text\"\r\n          [healthCostsCustomizationEnabled]=\"Spa_Site_HealthCosts_Customization_Enabled\"\r\n          [healthSliderHeader1Text]=\"Spa_GuidedHelp_Health_SliderHeader1_Text\"\r\n          [healthSliderHeader2Text]=\"Spa_GuidedHelp_Health_SliderHeader2_Text\"\r\n          [healthSliderHeader3Text]=\"Spa_GuidedHelp_Health_SliderHeader3_Text\"\r\n          [healthSliderBody1]=\"Spa_GuidedHelp_Health_SliderBody1\"\r\n          [healthSliderBody2]=\"Spa_GuidedHelp_Health_SliderBody2\"\r\n          [healthSliderBody3]=\"Spa_GuidedHelp_Health_SliderBody3\"\r\n          [healthSliderLabelText]=\"Spa_Site_Health_Slider_Label_Text\"\r\n          [healthModalView1HeadingText]=\"Spa_AddHealth_ModalView1_HeadingText\"\r\n          [healthModalView1IntroText]=\"Spa_AddHealth_ModalView1_IntroText\"\r\n          [detailedPlan]=\"detailedPlan\"\r\n          [planBottomContentHeader]=\"Spa_PlanDetails_Bottom_Content_Header\"\r\n          [planDetailsBottomContentText]=\"detailsDescription[detailedPlan.planTypeAbbreviation]\"\r\n          [planBottomContentResource]=\"getPlanDetailsBottomContentName(detailedPlan.planTypeAbbreviation)\"\r\n          [planTypeText]=\"planTypeText\"\r\n          [costSectionHeader]=\"Spa_PlanDetails_Costs_Header\"\r\n          [planLevelContentLabel]=\"planLevelContentLabel[detailedPlan.planTypeAbbreviation]\"\r\n          [showPlanLevelContent]=\"Spa_Show_Plan_Level_Content\"\r\n          [premiumText]=\"Spa_PlanDetails_Costs_Premium\"\r\n          [planBenefitSectionName]=\"Spa_Plan_Benefits_Section_Name\"\r\n          [pharmacyText]=\"Spa_Plan_Details_Preferences_Pharmacy_Text\"\r\n          [preferencesText]=\"Spa_Plan_Details_Preferences_Text\"\r\n          [preferencesExpanded]=\"Spa_Plan_Details_Preferences_Expanded\"\r\n          [preferencesPositionLast]=\"Spa_Plan_Details_Preferences_Position_Last\"\r\n          [showPreferences]=\"Spa_Plan_Details_Show_Preferences\"\r\n          [showProvider]=\"isProviderSectionAvailable(planFacade.selectedProviders$ | async)\"\r\n          [isProvidersEnabled]=\"Spa_Site_Providers_Enabled\"\r\n          [showPrescription]=\"Spa_Site_Prescriptions_Enabled && Spa_Plan_Details_Preferences_Show_Prescription\"\r\n          [showPharmacy]=\"Spa_Site_Pharmacy_Enabled && Spa_Plan_Details_Preferences_Show_Pharmacy\"\r\n          [showOtherPreferences]=\"Spa_Site_OtherPreferences_Enabled\"\r\n          [providerText]=\"Spa_Plan_Details_Preferences_Provider_Text\"\r\n          [prescriptionText]=\"Spa_Plan_Details_Preferences_Prescription_Text\"\r\n          [otherPreferencesText]=\"Spa_Plan_Details_OtherPreferences_Text\"\r\n          [addOnRidersHeader]=\"Spa_Plan_Details_AddOnRiders_Header\"\r\n          [addOnRidersSubHeader]=\"Spa_Plan_Details_AddOnRiders_SubHeader\"\r\n          [prescriptionAddEditLinkTitle]=\"Spa_Prescription_Add_Edit_Link\"\r\n          [providersLink]=\"Spa_Plan_Details_Providers_Link\"\r\n          [pharmacyLink]=\"Spa_Plan_Details_Pharmacy_Link\"\r\n          [preferencesAddEditLink]=\"Spa_Site_Preferences_AddEdit_Link\"\r\n          [pharmacyAddEditLink]=\"Spa_Site_Pharmacy_AddEdit_Link\"\r\n          [riderIsIncludedText]=\"Spa_ShoppingCart_IncludedRider_Text\"\r\n          [waiverStateRiderTooltips]=\"Spa_Plan_Details_WaiverStateRider_Tooltips\"\r\n          [inNetworkPreferredText]=\"Spa_Pharmacy_InNetwork_Preferred_Pricing_Text\"\r\n          [inNetworkStandardText]=\"Spa_Pharmacy_InNetwork_Standard_Pricing_Text\"\r\n          [outOfNetworkText]=\"Spa_Pharmacy_OutOfNetwork_Pricing_Text\"\r\n          [coveredDrugsText]=\"Spa_PlanDetails_Covered_Text\"\r\n          [nonCoveredText]=\"Spa_PlanDetails_Non_Covered_Text\"\r\n          [coveredBenefitText]=\"Spa_Site_Yes\"\r\n          [nonCoveredBenefitText]=\"Spa_Site_No\"\r\n          [guidedHelpEnabled]=\"Spa_GuidedHelp_Enabled\"\r\n          [healthEnabled]=\"Spa_Site_Health_Enabled\"\r\n          [healthText]=\"Spa_PlanDetails_Health_Cost_Text\"\r\n          [costMA]=\"Spa_Plandetails_Costs_MA\"\r\n          [costMAPD]=\"Spa_Plandetails_Costs_MAPD\"\r\n          [costPDP]=\"Spa_Plandetails_Costs_PDP\"\r\n          [costMEDIGAP]=\"Spa_Plandetails_Costs_MEDIGAP\"\r\n          [costDENTAL]=\"Spa_PlanDetails_Costs_DENTAL\"\r\n          [costVISION]=\"Spa_PlanDetails_Costs_VISION\"\r\n          [costHIP]=\"Spa_PlanDetails_Costs_HIP\"\r\n          [costAddEditLinkText]=\"Spa_Plandetails_Costs_Add_Edit_Link_Text\"\r\n          [noCostAvailableText]=\"Spa_Site_NotApplicable_Text\"\r\n          [showRiderDetailsText]=\"Spa_Plan_Details_ViewRiderDetails_Text\"\r\n          [hideRiderDetailsText]=\"Spa_Plan_Details_HideRiderDetails_Text\"\r\n          [showRiderDetails]=\"Spa_Site_RiderDetails_Show\"\r\n          [riderHIPBenefitText]=\"SPA_HIP_Rider_Benefit_Text\"\r\n          [basePlanOptionLabel]=\"Spa_Site_HIP_BasePlanOption_Text\"\r\n          [riderHIPBenefitDefaultDropdownText]=\"SPA_HIP_Rider_Benefit_Default_Dropdown_Text\"\r\n          id=\"plan-details-tab\"\r\n          role=\"tabpanel\"\r\n          [prescriptionAddEditLinkDescription]=\"Spa_Prescription_Add_Edit_Link_Description\"\r\n          [pharmacyAddEditLinkDescription]=\"Spa_Site_Pharmacy_Add_Edit_Link_Description\"\r\n          [drugCostAddEditLinkDescription]=\"Spa_DrugCost_Add_Edit_Link_Description\"\r\n          [healthCostAddEditLinkDescription]=\"Spa_HealthCost_Add_Edit_Link_Description\"\r\n          [selectedTab]=\"activeTab\"\r\n          [isRetentionView]=\"isRetentionView\"\r\n          [noCostMedSupPlanText]=\"noCostMedSupPlanText\"\r\n          [isLiveEdit]=\"isLiveEdit\"\r\n          [prescriptionDirectoryLink]=\"Spa_PlanDetails_Preferences_PrescriptionDirectory_Link\"\r\n          [searchProviderLink]=\"Spa_PlanDetails_Preferences_ProviderDirectory_Link\"\r\n          [searchPrescriptionsText]=\"Spa_PlanDetails_Preferences_SearchPrescriptions_Text\"\r\n          [searchPharmacyLink]=\"Spa_PlanDetails_Preferences_PharmacyDirectory_Link\"\r\n          [searchPharmacyText]=\"Spa_PlanDetails_Preferences_SearchPharmacy_Text\"\r\n          [searchProviderText]=\"Spa_Plan_Providers_Search_Provider_Text\"\r\n          [providersDirectoryLink]=\"Spa_Plan_Providers_Directory_Link\"\r\n          [providersInternalDirectoryLink]=\"Spa_Plan_Providers_Internal_Directory_Link_Text\"\r\n          [providersCarrierDirectoryLink]=\"Spa_Plan_Providers_Carrier_Directory_Link_Text\"\r\n          [isBothCarrierAndInternalProvidersDirectoryLinksEnabled]=\"Spa_Plan_Providers_BothCarrierAndInternal_DirectoryLinks_Enabled\"\r\n          [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n          [documentsSection]=\"documentsSection\"\r\n          [planDetailsText]=\"Spa_PlanCompare_PlanDocument_Text\"\r\n          [showCosts]=\"Spa_Site_PlanDetailsAndCompare_Show_Costs_MEDIGAP\"\r\n          [annualCost]=\"annualCost\"\r\n          [isMultiPharmacyEnabled]=\"pharmacyFacade.showPharmacySelectorToggle(detailedPlan.planTypeAbbreviation)\"\r\n          [primaryPharmacyText]=\"Spa_Site_PrimaryPharmacy_Indicator_Text\"\r\n          [primaryPharmacy]=\"pharmacyFacade.getPrimaryPharmacy$() | async\"\r\n          [selectedPharmacy]=\"selectedPharmacy\"\r\n          [pharmacies]=\"selectedPharmacies$ | async\"\r\n          [isMailOrderSelected]=\"isMailOrderSelected\"\r\n          [showTierPharmacyNetworkLabel]=\"Spa_Site_Show_Pharmacy_Tier_Label\"\r\n          [pharmacyNetworkText]=\"planDetailsFacade.getPharmacyNetworkText(detailedPlan, selectedPharmacy)\"\r\n          [mailOrderPharmacyText]=\"Spa_Site_Mail_Order_Pharmacy_Text\"\r\n          [mailOrderText]=\"Spa_PlanList_MailOrder_Text\"\r\n          [showMailOrderPharmacy]=\"Spa_Site_Mail_Order_Pharmacy_Enabled\"\r\n          [providersAddEditLinkTitle]=\"Spa_Providers_Add_Edit_Link\"\r\n          [inNetworkProviderText]=\"Spa_Provider_InNetwork_Text\"\r\n          [outOfNetworkProviderText]=\"Spa_Provider_OutOfNetwork_Text\"\r\n          [noProviderDetailsText]=\"Spa_Providers_No_Data_Exist_Text\"\r\n          [pcpText]=\"Spa_Site_Pcp_Text\"\r\n          [selectedProviders]=\"planFacade.selectedProviders$ | async\"\r\n          [providerDetailResponse]=\"providerDetailResponse\"\r\n          [isPlanPharmacyCovered]=\"pharmacyFacade.isPlanPharmacyCovered(detailedPlan)\"\r\n          [noProviderNetworkAccessText]=\"Spa_Providers_NoProviderNetworkAccess_Text\"\r\n          [canSellPlan]=\"planFacade.canSellPlan(detailedPlan)\"\r\n          (benefitRidersSelected)=\"benefitRidersSelected($event)\"\r\n          [planTotalPremium]=\"detailedPlanTotalPremium\"\r\n          [showDrugAlternativesEnabled]=\"Spa_Site_ShowDrugAlternatives_Enabled && Spa_PlanDetails_ShowDrugAlternatives_Nudge_Enabled\"\r\n          [showDrugAlternativesText]=\"Spa_Prescriptions_ShowDrugAlternatives_ViewAlternatives_Text\"\r\n          (viewPossibleAlternativeDrugs)=\"onViewPossibleAlternativeDrugs($event)\"\r\n          [addHealthCostText]=\"Spa_HealthCostsTab_AddAgeHealth_Text\"\r\n          [hideText]=\"Spa_Site_Hide_Text\"\r\n          [viewAllText]=\"Spa_Site_ViewAll_Text\"\r\n          [providerInfoEnabled]=\"Spa_Site_Provider_ShowAllInNetworkLocations_Enabled\"\r\n          [providers]=\"providers\"\r\n          [acceptingNewPatientsIcon]=\"Spa_Providers_AcceptingNewPatients_Icon\"\r\n          [acceptingNewPatientsText]=\"Spa_Providers_AcceptingNewPatients_Text\"\r\n          [languagesIcon]=\"Spa_Providers_Languages_Icon\"\r\n          [providerLanguages]=\"providerLanguages$ | async\"\r\n          [providerMedicalGroups]=\"providerMedicalGroups\"\r\n          [providersAcceptingNewPatients]=\"providersAcceptingNewPatients$ | async\"\r\n          [countryCode]=\"countryCode\"\r\n          [planFeesEnabled]=\"Spa_Site_PlanFees_Enabled\"\r\n          [planFeesLabelText]=\"Spa_PlanFees_Label_Text\"\r\n          [planFeesIncludedInPremiumTooltipText]=\"Spa_PlanFees_IncludedInPremium_Tooltip_Text\"\r\n          [planFeesNotIncludedInPremiumTooltipText]=\"Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text\"\r\n          [snpPremiumRangeEnabled]=\"Spa_Display_SNP_PremiumRange_Enabled\"\r\n          [isVbcAgreementEnabled]=\"Spa_Site_ValueBasedCare_Agreement_Enabled\"\r\n          [vbcAgreementLabel]=\"Spa_Site_ValueBasedCare_Agreement_Label\"\r\n          [vbcAgreementTooltip]=\"Spa_Site_ValueBasedCare_Agreement_Tooltip\"\r\n          [isZelisIntegrationEnabled]=\"Spa_Site_ZelisIntegration_Enabled\"\r\n        >\r\n        </vnext-plan-sub-details>\r\n\r\n        <vnext-total-costs-details\r\n          *ngSwitchCase=\"planDetailsTabs.TOTAL_COSTS\"\r\n          [preferencesBannerEnabled]=\"Spa_PreferenceBanner_Enabled\"\r\n          [plan]=\"detailedPlan\"\r\n          [totalCostDescriptionText]=\"Spa_Site_Total_Costs_Description_Text\"\r\n          [totalEstAnnualCostText]=\"Spa_PlanDetails_TotalEstimatedAnnual_Cost_Text\"\r\n          [totalEstCostText]=\"Spa_PlanDetails_TotalEstimatedCost_Text\"\r\n          [totalEstimatedAnnualCostsMonth]=\"totalEstimatedAnnualCostsMonth\"\r\n          [formularyID]=\"Spa_Site_Formulary_ID_Text\"\r\n          [formularyVersionText]=\"Spa_Site_Formulary_Version_Text\"\r\n          [faqContent]=\"Spa_Total_Cost_FAQ_Text\"\r\n          [prescriptionAddEditLinkTitle]=\"Spa_Prescription_Add_Edit_Link\"\r\n          [guidedHelpEnabled]=\"Spa_GuidedHelp_Enabled\"\r\n          [showPrescription]=\"Spa_Site_Prescriptions_Enabled\"\r\n          [totalCostEquationMA]=\"totalCostEquationMA\"\r\n          [totalCostEquationMAPD]=\"totalCostEquationMAPD\"\r\n          [totalCostEquationPDP]=\"Spa_Total_Costs_Breakdown_Equation_PDP\"\r\n          [planMonthlyEstimatedCostText]=\"Spa_Plan_Monthly_Estimated_Cost_Text\"\r\n          [monthlyBreakdownDrugLabelText]=\"Spa_Plan_MonthlyBreakdown_Drug_Label_Text\"\r\n          [monthlyBreakdownDrugPhaseLabelText]=\"Spa_Plan_MonthlyBreakdown_DrugPhase_Label_Text\"\r\n          [monthlyBreakdownDrugCostLabelText]=\"Spa_Plan_MonthlyBreakdown_DrugCost_Label_Text\"\r\n          [monthlyBreakdownDeductible]=\"Spa_Site_MonthlyBreakdownDeductible\"\r\n          [monthlyBreakdownCopay]=\"Spa_Site_MonthlyBreakdownCopay\"\r\n          [monthlyBreakdownGap]=\"Spa_Site_MonthlyBreakdownGap\"\r\n          [monthlyBreakdownCatastrophic]=\"Spa_Site_MonthlyBreakdownCatastrophic\"\r\n          [footnotes]=\"Spa_PlanDetails_Footnotes\"\r\n          [footnoteHeader]=\"Spa_PlanDetails_Footnote_Header\"\r\n          [keyNameForLiveEdit]=\"'Spa_Site_Total_Costs_Description_Text'\"\r\n          [costBasedOnMailOrderPharmacy]=\"Spa_PharmacySelection_MailOrderPharmacyCosts_Text\"\r\n          [cantSellPlanCostBasedOnMailOrderPharmacy]=\"Spa_PharmacySelection_CantSell_MailOrderPharmacyCosts_Text\"\r\n          [costBasedOnRetailPharmacy]=\"Spa_PharmacySelection_RetailPharmacyCosts_Text\"\r\n          [cantSellPlanCostBasedOnRetailPharmacy]=\"Spa_PharmacySelection_CantSell_RetailPharmacyCosts_Text\"\r\n          [costBasedOnSelectedPharmacy]=\"Spa_PharmacySelection_AddPharmacy_Text\"\r\n          [switchToMailLinkText]=\"Spa_PharmacySelection_Switch_To_MailOrder_Costs_Text\"\r\n          [switchToRetailLinkText]=\"Spa_PharmacySelection_Switch_To_Retail_Costs\"\r\n          [addPharmacyLink]=\"Spa_PharmacySelection_Add_Link_Text\"\r\n          [editPharmacyLink]=\"Spa_PharmacySelection_Edit_Link_Text\"\r\n          [showPharmacy]=\"Spa_Site_Pharmacy_Enabled\"\r\n          [isMailOrder]=\"isMailOrderSelected\"\r\n          [selectedPharmacy]=\"selectedPharmacy\"\r\n          aria-live=\"polite\"\r\n          id=\"plan-total-costs-tab\"\r\n          role=\"tabpanel\"\r\n          [addEditLinkDescription]=\"Spa_Prescription_Add_Edit_Link_Description\"\r\n          [selectedTab]=\"activeTab\"\r\n          [isRetentionView]=\"isRetentionView\"\r\n          [noCostMedSupPlanText]=\"noCostMedSupPlanText\"\r\n          [hideRetailMailOrderCost]=\"pharmacyFacade.showPharmacySelectorToggle(detailedPlan.planTypeAbbreviation)\"\r\n          [annualCost]=\"annualCost\"\r\n          [effectiveDateLabel]=\"Spa_TotalCost_EffectiveDateLabel_Text\"\r\n          [effectiveDateDropDownItems]=\"effectiveDateDropDownItems\"\r\n          [selectedValue]=\"selectedValue\"\r\n          [selectedMonthIndex]=\"selectedMonthIndex\"\r\n        ></vnext-total-costs-details>\r\n\r\n        <vnext-health-costs-details\r\n          *ngSwitchCase=\"planDetailsTabs.HEALTH_COSTS\"\r\n          [preferencesBannerEnabled]=\"Spa_PreferenceBanner_Enabled\"\r\n          [modalHeaderHealthText]=\"Spa_Site_Health_Text\"\r\n          [closeButtonText]=\"Spa_Site_Close_Modal\"\r\n          [healthCostsBodyText]=\"Spa_HealthCosts_Body_Text\"\r\n          [healthCostsBenefitsBodyText]=\"Spa_HealthCosts_Benefits_Body_Text\"\r\n          [saveSuccessText]=\"Spa_Site_HealthCosts_Save_Success_Text\"\r\n          [healthCostsRestoreDefaultsText]=\"Spa_Site_HealthCosts_Restore_Defaults_Text\"\r\n          [healthCostsUpdateAnswersText]=\"Spa_Site_HealthCosts_Update_Answers_Text\"\r\n          [healthCostsSaveAnswersText]=\"Spa_Site_HealthCosts_Save_Answers_Text\"\r\n          [saveFailedText]=\"Spa_Site_HealthCosts_Save_Failed_Text\"\r\n          [healthAgeQuestionText]=\"Spa_GuidedHelp_Health_AgeQuestion_Text\"\r\n          [healthCostsCustomizationEnabled]=\"Spa_Site_HealthCosts_Customization_Enabled\"\r\n          [healthSliderHeader1Text]=\"Spa_GuidedHelp_Health_SliderHeader1_Text\"\r\n          [healthSliderHeader2Text]=\"Spa_GuidedHelp_Health_SliderHeader2_Text\"\r\n          [healthSliderHeader3Text]=\"Spa_GuidedHelp_Health_SliderHeader3_Text\"\r\n          [healthSliderBody1]=\"Spa_GuidedHelp_Health_SliderBody1\"\r\n          [healthSliderBody2]=\"Spa_GuidedHelp_Health_SliderBody2\"\r\n          [healthSliderBody3]=\"Spa_GuidedHelp_Health_SliderBody3\"\r\n          [healthSliderLabelText]=\"Spa_Site_Health_Slider_Label_Text\"\r\n          [healthModalView1HeadingText]=\"Spa_AddHealth_ModalView1_HeadingText\"\r\n          [healthModalView1IntroText]=\"Spa_AddHealth_ModalView1_IntroText\"\r\n          [annualCost]=\"annualCost\"\r\n          [plan]=\"detailedPlan\"\r\n          [addHealthCostText]=\"Spa_HealthCostsTab_AddAgeHealth_Text\"\r\n          [healthCostsDescriptionText]=\"Spa_Site_Health_Costs_Description_Text\"\r\n          [noHealthCostTitle]=\"Spa_HealthCostsTab_NoCostTitle_Text\"\r\n          [introHealthCostTitle]=\"Spa_HealthCostsTab_Intro_Text\"\r\n          [healthCostsBenefitsTableHeader]=\"Spa_HealthCosts_Benefits_Table_Header_Text\"\r\n          [healthCostsUsageTableHeader]=\"Spa_HealthCosts_Usage_Table_Header_Text\"\r\n          [healthCostsDaysTableHeader]=\"Spa_HealthCosts_Days_Table_Header_Text\"\r\n          [healthCostsUsageTableMobileText]=\"Spa_HealthCosts_Usage_Table_Mobile_Text\"\r\n          [healthCostsDaysTableMobileText]=\"Spa_HealthCosts_Days_Table_Mobile_Text\"\r\n          [healthEstimatedCostTableHeader]=\"Spa_HealthCosts_EstCost_Table_Header_Text\"\r\n          [subTotalText]=\"Spa_HealthCosts_Subtotal_Text\"\r\n          [healthCostsBenefits]=\"Spa_Site_HealthCosts_Benefits_JSON\"\r\n          [totalEstimatedCostText]=\"Spa_PlanDetails_TotalEstimatedCost_Text\"\r\n          [totalEstimatedAnnualCostText]=\"Spa_PlanDetails_EstimatedHealthCosts_Text\"\r\n          [healthCostsOutOfPocketText]=\"Spa_PlanDetails_HealthCosts_Out_Of_Pocket_Text\"\r\n          [healthCostsMedicalDeductibleText]=\"Spa_PlanDetails_HealthCosts_MedicalDeductible_Text\"\r\n          [selectedTab]=\"activeTab\"\r\n          [isRetentionView]=\"isRetentionView\"\r\n          [noCostMedSupPlanText]=\"noCostMedSupPlanText\"\r\n        ></vnext-health-costs-details>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".backToPlans{margin-top:20px}.previous-text-link{color:var(--static-Spa_Style_Primary_Link);font-size:14px;cursor:pointer}.previous-text-link:focus,.planNameHeader:focus{box-shadow:none;outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:inset 0 1px 1px #00000013,0 0 8px #72727299}.plan-name-header{margin-top:20px}.tab{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px 5px 0 0;margin:0 6px -1px;display:block;position:relative;text-decoration:none;outline:none;cursor:pointer}.tab:hover,.tab.active{background-color:#fff}.tab.active{border-bottom-color:#fff}.tabs{margin:0;padding:0;list-style:none;display:flex;justify-content:center;align-items:flex-end}.tabs--horizontal .tab.active>a{border-bottom-color:#fff}.plans-tab.tabs{padding:15px 10px 0}.tabs--horizontal{margin-top:-1px}.tabTitle{font-weight:400}.details-list{margin:20px 0 0}.sticky{position:sticky;top:10px;background-color:#fff;z-index:1}.plan-page-title-tabs-container{border-bottom:1px solid var(--static-Spa_Style_Accent1);margin:0 0 30px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.PassParameterService }, { type: i1.DeactivationGuardService }, { type: PlanDetailsFacade }, { type: i2$1.ActivatedRoute }, { type: i2.Store }, { type: FootnoteFacade }, { type: PlanFacade }, { type: i1.PlansService }, { type: PharmacyContext }, { type: i1.ConfigResourceService }, { type: PlanListFacadeService }, { type: i1.SiteService }, { type: i1.LocaleService }, { type: PharmacyFacade }, { type: i1.ProviderService }, { type: ProviderFacade }, { type: i1.PharmacyService }, { type: DrugCabinetContext }, { type: i1.MedSupService }, { type: HospitalIndemnityFormFacade }, { type: i1.ResponsiveLayoutService }, { type: i0.Injector }, { type: GuidedHelpModalService }, { type: i1.GuidedHelpModalContextService }]; }, { planDetailsTabElement: [{
            type: ViewChildren,
            args: ['planDetailsTab', { read: ElementRef }]
        }], medicineCabinet$: [], selectedPharmacy$: [], Spa_Site_Yes: [], Spa_Site_No: [], Spa_Site_Health_Costs_Description_Text: [], Spa_HealthCosts_Benefits_Table_Header_Text: [], Spa_HealthCosts_Usage_Table_Header_Text: [], Spa_HealthCosts_Days_Table_Header_Text: [], Spa_HealthCosts_EstCost_Table_Header_Text: [], Spa_PlanDetails_EstimatedHealthCosts_Text: [], Spa_HealthCosts_Subtotal_Text: [], Spa_HealthCosts_Usage_Table_Mobile_Text: [], Spa_HealthCosts_Days_Table_Mobile_Text: [], Spa_PlanDetails_HealthCosts_MedicalDeductible_Text: [], Spa_PlanDetails_HealthCosts_Out_Of_Pocket_Text: [], Spa_HealthCosts_Benefits_Body_Text: [], Spa_Site_HealthCosts_Save_Failed_Text: [], Spa_Site_HealthCosts_Benefits_Table_Header: [], Spa_Site_HealthCosts_Usage_Table_Header: [], Spa_Site_HealthCosts_Days_Table_Header: [], Spa_Site_HealthCosts_Restore_Defaults_Text: [], Spa_Site_HealthCosts_Update_Answers_Text: [], Spa_Site_HealthCosts_Save_Answers_Text: [], Spa_Site_HealthCosts_Save_Success_Text: [], Spa_Site_Close_Modal: [], Spa_Site_HealthCosts_Benefits_JSON: [], Spa_HealthCosts_Body_Text: [], Spa_Site_Health_Slider_Label_Text: [], Spa_PlanDetails_NonCommissionable_Text: [], Spa_PlanDetails_NonCommissionable_FlagCheck_Enabled: [], Spa_AddHealth_ModalView1_IntroText: [], Spa_AddHealth_ModalView1_HeadingText: [], Spa_GuidedHelp_Health_AgeQuestion_Text: [], Spa_GuidedHelp_Health_SliderHeader1_Text: [], Spa_GuidedHelp_Health_SliderHeader2_Text: [], Spa_GuidedHelp_Health_SliderHeader3_Text: [], Spa_GuidedHelp_Health_SliderBody1: [], Spa_GuidedHelp_Health_SliderBody2: [], Spa_GuidedHelp_Health_SliderBody3: [], Spa_PlanCard_QuoteLinkName_Text: [], Spa_PlanDetails_Costs_Premium: [], Spa_Plan_Benefits_Section_Name: [], Spa_Plan_Details_Preferences_Pharmacy_Text: [], Spa_Plan_Details_Preferences_Text: [], Spa_Plan_Details_OtherPreferences_Text: [], Spa_Plan_Details_Preferences_Expanded: [], Spa_Plan_Details_Preferences_Position_Last: [], Spa_Plan_Details_Show_Preferences: [], Spa_Plan_Details_Preferences_Show_Provider: [], Spa_Plan_Details_Preferences_Show_Prescription: [], Spa_Plan_Details_Preferences_Show_Pharmacy: [], Spa_Site_OtherPreferences_Enabled: [], Spa_Site_Prescriptions_Enabled: [], Spa_Site_Pharmacy_Enabled: [], Spa_Site_HealthCosts_Customization_Enabled: [], Spa_Site_ZelisIntegration_Enabled: [], Spa_PlanCard_Benefit_DentalDeductible_Text: [], Spa_PlanCard_Benefit_CalendarYearMax_Text: [], Spa_PlanCard_Benefit_VisionDeductible_Text: [], Spa_Plan_Details_Preferences_Provider_Text: [], Spa_Plan_Details_Preferences_Prescription_Text: [], Spa_Plan_Details_AddOnRiders_Header: [], Spa_Site_PageSubHeader_Text: [], Spa_Plan_Details_AddOnRiders_SubHeader: [], Spa_Plan_Details_Providers_Link: [], Spa_Plan_Details_Pharmacy_Link: [], Spa_Plan_Providers_Search_Provider_Text: [], Spa_Plan_Providers_Directory_Link: [], Spa_Plan_Providers_Internal_Directory_Link_Text: [], Spa_Plan_Providers_Carrier_Directory_Link_Text: [], Spa_Plan_Providers_BothCarrierAndInternal_DirectoryLinks_Enabled: [], Spa_PlanList_Tab_Show_HIP: [], Spa_PlanList_HIPFormPrompt_Text: [], Spa_PlanList_HIP_PageTitle_Text: [], Spa_PlanDetails_Preferences_ProviderDirectory_Link: [], Spa_Plan_Details_WaiverStateRider_Tooltips: [], Spa_MedSup_RestrictMedSupPlansByAge_InfoLink: [], Spa_MedSup_RestrictMedSupPlansByAge_InfoText: [], Spa_ShoppingCart_IncludedRider_Text: [], Spa_PrescriptionsTab_AddPrescriptionButton_Text: [], Spa_PrescriptionsTab_NotInTier_Text: [], Spa_PrescriptionsTab_NonCovered_Text: [], Spa_PrescriptionsTab_Covered_Text: [], Spa_PrescriptionsTab_NoCostTitle_Text: [], Spa_PrescriptionsTab_Intro_Text: [], Spa_Add_Prescriptions_Button_Text: [], Spa_None_Prescriptions_Text: [], Spa_Non_Covered_Prescriptions_Text: [], Spa_Covered_Prescriptions_Text: [], Spa_Pharmacy_InNetwork_Preferred_Pricing_Text: [], Spa_Pharmacy_InNetwork_Standard_Pricing_Text: [], Spa_Pharmacy_OutOfNetwork_Pricing_Text: [], Spa_PlanDetails_Covered_Text: [], Spa_PlanDetails_Non_Covered_Text: [], Spa_PlanDetails_TotalEstimatedAnnual_Cost_Text: [], Spa_PlanDetails_TotalEstimatedCost_Text: [], Spa_GuidedHelp_Enabled: [], Spa_Site_Health_Enabled: [], Spa_PharmacySelection_RetailPharmacyCosts_Text: [], Spa_PharmacySelection_CantSell_RetailPharmacyCosts_Text: [], Spa_PharmacySelection_MailOrderPharmacyCosts_Text: [], Spa_PharmacySelection_CantSell_MailOrderPharmacyCosts_Text: [], Spa_PharmacySelection_AddPharmacy_Text: [], Spa_PharmacySelection_Switch_To_MailOrder_Costs_Text: [], Spa_PharmacySelection_Switch_To_Retail_Costs: [], Spa_PharmacySelection_Add_Link_Text: [], Spa_PharmacySelection_Edit_Link_Text: [], Spa_Site_Show_GenericDrugOption: [], Spa_DrugCost_Add_Edit_Link_Description: [], Spa_HealthCost_Add_Edit_Link_Description: [], Spa_Site_Tooltip_Text: [], Spa_Site_PlanDetailsAndCompare_Show_Costs_MEDIGAP: [], Spa_Site_Previous: [], Spa_PlanLevel_Content_Label_PDP: [], Spa_PlanLevel_Content_Label_MAPD: [], Spa_PlanLevel_Content_Label_MA: [], Spa_PlanLevel_Content_Label_MEDIGAP: [], Spa_PlanLevel_Content_Label_DENTAL: [], Spa_PlanLevel_Content_Label_VISION: [], Spa_PlanLevel_Content_Label_HIP: [], Spa_Show_Plan_Level_Content: [], Spa_Plandetails_Costs_Add_Edit_Link_Text: [], Spa_Site_Health_Text: [], Spa_PlanDetails_Health_Cost_Text: [], Spa_Plandetails_Costs_MAPD: [], Spa_Plandetails_Costs_MA: [], Spa_Plandetails_Costs_MEDIGAP: [], Spa_Plandetails_Costs_PDP: [], Spa_PlanDetails_Costs_DENTAL: [], Spa_PlanDetails_Costs_VISION: [], Spa_PlanDetails_Costs_HIP: [], Spa_Total_Costs_Breakdown_Equation_MA: [], Spa_Total_Costs_Breakdown_Equation_MAPD: [], Spa_Total_Costs_Breakdown_Equation_PDP: [], Spa_PlanDetails_Bottom_Content_Header: [], Spa_PlanDetails_Bottom_Content_Text_PDP: [], Spa_PlanDetails_Bottom_Content_Text_MAPD: [], Spa_PlanDetails_Bottom_Content_Text_MA: [], Spa_PlanDetails_Bottom_Content_Text_MEDIGAP: [], Spa_PlanDetails_Bottom_Content_Text_DENTAL: [], Spa_PlanDetails_Bottom_Content_Text_VISION: [], Spa_PlanDetails_Bottom_Content_Text_HIP: [], Spa_PlanDetails_Costs_Header: [], Spa_Prescription_Add_Edit_Link: [], Spa_Site_Pharmacy_AddEdit_Link: [], Spa_Site_Preferences_AddEdit_Link: [], Spa_Site_Total_Costs_TabText: [], Spa_Site_Total_Costs_Description_Text: [], Spa_Site_Total_Est_Cost_Month_1: [], Spa_Site_Total_Est_Cost_Month_2: [], Spa_Site_Total_Est_Cost_Month_3: [], Spa_Site_Total_Est_Cost_Month_4: [], Spa_Site_Total_Est_Cost_Month_5: [], Spa_Site_Total_Est_Cost_Month_6: [], Spa_Site_Total_Est_Cost_Month_7: [], Spa_Site_Total_Est_Cost_Month_8: [], Spa_Site_Total_Est_Cost_Month_9: [], Spa_Site_Total_Est_Cost_Month_10: [], Spa_Site_Total_Est_Cost_Month_11: [], Spa_Site_Total_Est_Cost_Month_12: [], Spa_Site_Formulary_ID_Text: [], Spa_Site_Formulary_Version_Text: [], Spa_Site_MonthlyBreakdownDeductible: [], Spa_Site_MonthlyBreakdownCopay: [], Spa_Site_MonthlyBreakdownGap: [], Spa_Site_MonthlyBreakdownCatastrophic: [], Spa_Site_SendQuote_Button_Text: [], Spa_Site_NotApplicable_Text: [], Spa_Plan_Details_ViewRiderDetails_Text: [], Spa_Plan_Details_HideRiderDetails_Text: [], Spa_Site_RiderDetails_Show: [], Spa_Plan_Monthly_Estimated_Cost_Text: [], Spa_Plan_MonthlyBreakdown_Drug_Label_Text: [], Spa_Plan_MonthlyBreakdown_DrugPhase_Label_Text: [], Spa_Plan_MonthlyBreakdown_DrugCost_Label_Text: [], Spa_HealthCostsTab_AddAgeHealth_Text: [], Spa_HealthCostsTab_NoCostTitle_Text: [], Spa_HealthCostsTab_Intro_Text: [], Spa_Prescriptions_FAQ_Text: [], Spa_Total_Cost_FAQ_Text: [], Spa_PlanDetails_Footnotes: [], Spa_Site_MailOrderFootnote_Text: [], Spa_Site_MailOrderFootnote_Index: [], Spa_PlanDetails_Footnote_Header: [], Spa_Site_TotalEstimatedCost_Enabled: [], Spa_Site_InsulinFootnote_Index: [], Spa_Site_PlanNotAvailableForNextYear_Text: [], Spa_Site_Keep_This_Plan_Button_Text: [], Spa_Site_Current_Plan_Text: [], Spa_Site_Next_Year_Plan_Text: [], Spa_Site_IsDeepLinking_Enabled: [], Spa_Site_SiteType: [], Spa_Prescription_Add_Edit_Link_Description: [], Spa_Site_Pharmacy_Add_Edit_Link_Description: [], Spa_PlanDetails_Preferences_SearchPrescriptions_Text: [], Spa_PlanDetails_Preferences_PrescriptionDirectory_Title: [], Spa_PlanDetails_Preferences_PrescriptionDirectory_Link: [], Spa_PlanDetails_Preferences_SearchPharmacy_Text: [], Spa_PlanDetails_Preferences_PharmacyDirectory_Title: [], Spa_PlanDetails_Preferences_PharmacyDirectory_Link: [], Spa_PlanCompare_PlanDocument_Text: [], Spa_Site_Preferred_In_Network_Text: [], Spa_Site_Standard_In_Network_Text: [], Spa_Site_Out_Of_Network_Text: [], Spa_Site_CostBasedOn_Text: [], Spa_Site_PrimaryPharmacy_Indicator_Text: [], Spa_Site_Mail_Order_Pharmacy_Enabled: [], Spa_PlanList_MailOrder_Text: [], Spa_Site_Preferred_Text: [], Spa_Site_Standard_Text: [], Spa_Site_Show_Pharmacy_Tier_Label: [], Spa_Site_Selected_Pharmacy_Network_Label: [], Spa_Site_Mail_Order_Pharmacy_Text: [], Spa_TotalCost_EffectiveDateLabel_Text: [], Spa_Providers_Add_Edit_Link: [], Spa_Provider_InNetwork_Text: [], Spa_Provider_OutOfNetwork_Text: [], Spa_Providers_No_Data_Exist_Text: [], Spa_Site_Pcp_Text: [], Spa_Site_Providers_Enabled: [], Spa_Site_Preferences_Score_Enabled: [], Spa_Providers_NoProviderNetworkAccess_Text: [], Spa_Site_HealthCosts_Enabled: [], Spa_Site_Plan_List_Link: [], Spa_PlanDetails_HIP_Call_Out_Available_Plan_Types: [], Spa_PlanDetails_HIP_Call_Out_Enabled: [], Spa_PlanDetails_HIP_Call_Out_Informational_Text: [], Spa_PlanDetails_HIP_Call_Out_Text_Button: [], Spa_PlanDetails_HIP_RateFactorModal_Title: [], Spa_Site_ErrorKeyword_Text: [], Spa_Site_EnrollmentErrorNotice_Title: [], Spa_PlanList_MedSupFormDropdownDefault_Text: [], SPA_HIP_Rider_Benefit_Text: [], Spa_Site_HIP_MonthlyPremium_Text: [], SPA_HIP_Rider_Benefit_Default_Dropdown_Text: [], Spa_Site_HIP_BasePlanOption_Text: [], Spa_PlanList_AddToQuote_Limit_Mobile: [], Spa_PlanList_AddToQuote_Limit: [], Spa_Site_Hide_EmptyPlanTabs: [], Spa_Site_PlanLogo_Size: [], Spa_Site_ShowDrugAlternatives_Enabled: [], Spa_PlanDetails_ShowDrugAlternatives_Nudge_Enabled: [], Spa_Prescriptions_ShowDrugAlternatives_Informational_Text: [], Spa_Prescriptions_ShowDrugAlternatives_ViewAlternatives_Text: [], Spa_DrugSearch_Frequency_List: [], Spa_DrugCosts_RetailCostText: [], Spa_DrugListCard_Brand_Text: [], Spa_DrugListCard_Generic_Text: [], Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_BackToPrescriptions_Link_Text: [], Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_Header_Text: [], Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_Intro_Text: [], Spa_Prescriptions_ShowDrugAlternatives_AlternativesTab_NoDrugs_Empty_Text: [], Spa_PlanDetails_StickyMiniCart_Enabled: [], Spa_Prescriptions_ShowDrugAlternatives_Condition_Modal_Text: [], Spa_Site_ShowDrugAlternatives_Change_Medical_Conditions_Enabled: [], Spa_PlanFilters_DayLabel_Text: [], Spa_Site_Days_Text: [], Spa_Site_Day_Text: [], Spa_PlanList_MedSupEditAnswersBanner_Text: [], Spa_Site_LumpSum_Text: [], Spa_Site_Hide_Text: [], Spa_Site_ViewAll_Text: [], Spa_Site_Provider_ShowAllInNetworkLocations_Enabled: [], Spa_Retention_ClientDefinedPlanOptions_Enabled: [], Spa_Site_Plan_Option_One_Text: [], Spa_Site_Plan_Option_Two_Text: [], Spa_Providers_AcceptingNewPatients_Text: [], Spa_Providers_AcceptingNewPatients_Icon: [], Spa_Providers_Languages_Icon: [], Spa_Site_PlanFees_Enabled: [], Spa_PlanFees_Label_Text: [], Spa_PlanFees_Tooltip_Text: [], Spa_PlanFees_IncludedInPremium_Tooltip_Text: [], Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text: [], Spa_Display_SNP_PremiumRange_Enabled: [], Spa_Site_ValueBasedCare_Agreement_Enabled: [], Spa_Site_ValueBasedCare_Agreement_Label: [], Spa_Site_ValueBasedCare_Agreement_Tooltip: [], Spa_DrugSearch_Content_Section_Text: [], Spa_DrugSearch_Dosage_Header: [], Spa_DrugSearch_Frequency_Header: [], Spa_DrugSearch_Package_Header: [], Spa_DrugSearch_Add_Button: [], Spa_DrugSearch_Cancel_Button: [], Spa_DrugSearch_Back_Button: [], Spa_DrugSearch_EditDrug_Button: [], Spa_DrugSearch_Quantity_Max_Limit: [], Spa_DrugSearch_Cabinet_Limit: [], Spa_DrugSearch_MaxCount_Error_Message: [], Spa_DrugSearch_Quantity_Error_Message: [], Spa_DrugSearch_Label_Text: [], Spa_DrugSearch_Drugs_Image: [], Spa_DrugSearch_InCabinetError_Text: [], Spa_DrugSearch_Medicine_Header: [], Spa_DrugSearch_GenericOption_Icon: [], Spa_DrugSearch_GenericOption_Question: [], Spa_DrugSearch_GenericOption_Info: [], Spa_DrugSearch_GenericOptions: [], Spa_DrugSearch_CheckDrugCoverageButton_Text: [], Spa_DrugSearch_GenericOption_Default_Selection: [], Spa_DrugListCard_HideCosts_Flag: [], Spa_DrugSearch_Hint_Text: [], Spa_DrugSearch_Intro_Text: [], Spa_DrugSearch_PageHeader_Text: [], Spa_DrugSearch_Frequency_ListBox_Label: [], Spa_Site_Enable_BlueButton: [], Spa_Site_OrText: [], Spa_BlueButton_StartAddDrug_Text: [], Spa_BlueButton_MyMedicare_Connect_Text: [], Spa_BlueButton_MyMedicare_Button: [], Spa_Site_EmailAddress_Text: [], Spa_Profile_EmailRequired_Error: [], Spa_Profile_EmailInvalid_Error: [], Spa_Site_SendEmailButton_Text: [], Spa_BlueButton_Modal_Header: [], Spa_BlueButton_Modal_Content: [], Spa_BlueButton_Success_Text: [], Spa_BlueButton_Download_Text: [], Spa_BlueButton_Success_Message: [], Spa_BlueButton_EmailSentToStatus_Text: [], Spa_BlueButton_Issue_Loading_Text: [], Spa_BlueButton_Beneficiary_Denied_Text: [], Spa_BlueButton_Error_Loading_Text: [], Spa_BlueButton_Beneficiary_Email_Details: [], Spa_BlueButton_ImportLatestPrescription_Button_Text: [], Spa_BlueButton_ImportLatestPrescription_Error_Text: [], Spa_BlueButton_AccessDenied_Error_Text: [], Spa_BlueButton_ClaimData_Loading_Error_Text: [], Spa_Drugs_UseCMSDrugFlag_Enabled: [], Spa_AddPrescriptions_ModalView1_HeadingText: [], Spa_AddPrescriptions_ModalView1_IntroText: [], Spa_AddPrescriptions_ModalView2_HeadingText: [], Spa_AddPrescriptions_ModalView2_IntroText: [], Spa_DrugSearch_Text: [], Spa_Site_Prescriptions_Text: [], Spa_Site_Providers_Text: [], Spa_Site_Providers_Body_Text: [], Spa_Multi_Providers_Body_Text: [], Spa_Provider_Add_Text: [], Spa_Provider_Added_Text: [], Spa_Provider_RemoveProvider_Text: [], Spa_Provider_YourProvider_Text: [], Spa_Provider_Set_Primary_Care_Provider_Text: [], Spa_Provider_Primary_Care_Provider_Text: [], Spa_Site_ZipCodeInput_ZipCodeLabel: [], Spa_Site_ZipCodeInput_ZipCodeError: [], Spa_Providers_Filter_Enabled: [], Spa_Group_Provider_Add_Text: [], Spa_Group_Provider_Added_Text: [], Spa_ZipCodeInput_CountyLabel_Text: [], Spa_Site_Add: [], Spa_Site_Cancel: [], Spa_Select_Single_Provider_For_Multi_Address_Enabled: [], Spa_Select_Provider_Location_Text: [], Spa_Provider_Exists_Text: [], Spa_Provider_Multiple_Location_Text: [], Spa_Plan_Providers_Locations_Link_Text: [], Spa_Site_ValueBasedCare_Enabled: [], Spa_Site_ValueBasedCare_Icon: [], Spa_Site_ValueBasedCare_Text: [], Spa_Provider_Search_Filter_General_Practice_Options: [], Spa_Provider_Search_General_Practice_Label_Text: [], Spa_Provider_Search_General_Practice_Tooltip_Text: [], Spa_Provider_Search_Filter_General_Practice_Option_Enabled: [], Spa_Provider_Search_ShowSingleProviderInList_Enabled: [], Spa_Site_Edit_Text: [], Spa_Site_Update_Text: [], Spa_Provider_ShowEditLink_Enabled: [], Spa_ValueBasedCare_Available_Text: [], Spa_ValueBasedCare_LearnMore_Link: [], Spa_ValueBasedCare_LearnMore_Text: [], Spa_ValueBasedCare_LearnMoreLink2_Enabled: [], Spa_ValueBasedCare_Toggle_Label: [], Spa_ValueBasedCare_Toggle_ToolTip_Text: [], Spa_ValueBasedCare_Toggle_Enabled: [], Spa_Provider_Search_Filter_ValueBasedCare_Options: [], Spa_Provider_New_Patient_Toggle_Enabled: [], Spa_Provider_New_Patient_Toggle_Label: [], Spa_Provider_New_Patient_Options: [], Spa_Primary_Care_Provider_Toggle_Enabled: [], Spa_Primary_Care_Provider_Toggle_Label: [], Spa_Primary_Care_Provider_Options: [], Spa_New_Patient_For_Provider_Text: [], Spa_Existing_Patient_For_Provider_Text: [], Spa_Provider_ValueBasedCare_Name_Filter_Enabled: [], Spa_Provider_ValueBasedCare_Name_Filter_Label: [], Spa_Selected_Provider_Options_Enabled: [], Spa_Site_Remove_Text: [], Spa_Site_SelectAll_Text: [], Spa_ProviderName_Text: [], Spa_ProviderName_HintText: [], Spa_Site_SearchButton_Text: [], Spa_Provider_Limit: [], Spa_ProviderSearch_Pagination_ItemsPerPage: [], Spa_ProviderSearch_Pagination_Enabled: [], Spa_ProviderSearch_Pagination_View_Text: [], Spa_Provider_Alt_View_Not_Found_Header_Text: [], Spa_Provider_Alt_View_Not_Found_Body_Text: [], Spa_ProviderMap_Max_Zoom: [], Spa_ProviderMap_Min_Zoom: [], Spa_ProviderMap_Default_Zoom: [], Spa_Provider_Add_Maximum_Limit_Message: [], Spa_Providers_Filter_Individuals_Text: [], Spa_Providers_Filter_Facilties_Text: [], Spa_ValueBasedCare_Filter_Text: [], Spa_Site_ValueBasedCare_Filter_Enabled: [], Spa_ValueBasedCare_Filter_Checked: [], Spa_ValueBasedCare_LearnMoreLink_Enabled: [], Spa_Providers_Back_Button: [], Spa_AddProviders_ModalProviderSearchView_HeadingText: [], Spa_AddProviders_ModalProviderSearchView_IntroText: [], Spa_AddProviders_ModalProviderMapView_HeadingText: [], Spa_AddProviders_ModalProviderMapView_IntroText: [], Spa_AddProviders_ModalProviderLocationView_HeadingText: [], Spa_AddProviders_ModalProviderLocationView_IntroText: [], Spa_ZipCodeInput_CountyLabel_Enabled: [], Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text: [], Spa_PharmacySearch_Standard_In_Network_Tooltip_Text: [], Spa_Pharmacy_Alt_View_Not_Found_Header_Text: [], Spa_Pharmacy_Alt_View_Not_Found_Body_Text: [], Spa_PharmacyName_Text: [], Spa_Add_Pharmacy_Button: [], Spa_Filter_Default_Filter_Text: [], Spa_PharmacyName_HintText: [], Spa_Site_Pharmacy_Filter_Enabled: [], Spa_Site_Pharmacy_In_Network_Filter_Enabled: [], Spa_Site_Pharmacy_Other_Filter_Enabled: [], Spa_PlanFilters_Modal_Link: [], Spa_PlanFilters_Modal_Cancel_Button: [], Spa_PlanFilters_Modal_Apply_Button: [], Spa_Site_Digital_Pharmacy_Enabled: [], Spa_Site_Pharmacy_Text: [], Spa_Pharmacy_Limit: [], Spa_PharmacyMap_Default_Zoom: [], Spa_PharmacyMap_Max_Zoom: [], Spa_PharmacyMap_Min_Zoom: [], Spa_Site_Maximum_Pharmacy_Count: [], Spa_Site_Set_Primary_Pharmacy_Link_Text: [], Spa_Site_Multi_Pharmacy_Enabled: [], Spa_PharmacySearch_Back_Button: [], Spa_AddPharmacy_ModalView1_IntroText: [], Spa_AddPharmacy_ModalView1_HeadingText: [], Spa_AddPharmacy_ModalView2_IntroText: [], Spa_AddPharmacy_ModalView2_HeadingText: [], Spa_PharmacySearch_Pagination_ItemsPerPage: [], Spa_PharmacySearch_Pagination_Enabled: [], Spa_PharmacySearch_Pagination_View_Text: [], Spa_Site_AddPharmacy_YourMultiPharmacyText: [], Spa_Pharmacy_Added_Label: [], Spa_Pharmacy_Retail_Tab_Text: [], Spa_Pharmacy_Digital_Tab_Text: [], Spa_AddPharmacy_YourPharmacyText: [], Spa_Site_ElectronicPrescription_ToolTipHeader: [], Spa_Site_ElectronicPrescription_ToolTipBody: [], Spa_Site_Primary_Pharmacy_Text: [], Spa_Site_Primary_Pharmacy_Icon: [], Spa_Site_Primary_Pharmacy_Icon_Color: [], Spa_Site_Plans_Text: [], Spa_Pharmacy_Digital_Tab_Intro_Text: [], Spa_Site_Plan_Text: [], Spa_Filter_Header_Text: [], Spa_Filter_Clear_All: [], Spa_PharmacySearch_PageHeader_Text: [], Spa_Site_Pharmacy_Added_Text: [], Spa_Site_Pharmacy_Add_Text: [], Spa_Site_EPrescribing_Alt_Text: [], Spa_PharmacySearch_Intro_Text: [], Spa_PharmacySearch_MultiPharmacy_Intro_Text: [], Spa_Site_Pharmacy_Limit_Error_Message: [], Spa_Pharmacy_Filter_Open24hrs_Text: [], Spa_Pharmacy_Filter_Eprescribing_Text: [], Spa_Pharmacy_Filter_HandicapAccess_Text: [], Spa_Pharmacy_Filter_DurableEquipment_Text: [], Spa_Pharmacy_Filter_MailOrder_Text: [], Spa_Pharmacy_In_Network_Filters: [], Spa_Pharmacy_Filters: [], Spa_PreferenceBanner_Enabled: [], updateSelectedPharmacy: [] }); })();

function PlanCompareAccordionComponent_ng_template_5_ng_container_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.accordionSectionHeader, "");
} }
function PlanCompareAccordionComponent_ng_template_5_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanCompareAccordionComponent_ng_template_5_ng_container_4_span_1_Template, 2, 1, "span", 17);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", ctx_r3.headerPropertyName);
} }
function PlanCompareAccordionComponent_ng_template_5_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate(ctx_r5.accordionSectionHeader);
} }
function PlanCompareAccordionComponent_ng_template_5_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r6.accordionSubHeaderClass);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.accordionSubHeader);
} }
function PlanCompareAccordionComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 7)(1, "button", 8)(2, "span", 9)(3, "span", 10);
    i0.ɵɵtemplate(4, PlanCompareAccordionComponent_ng_template_5_ng_container_4_Template, 2, 1, "ng-container", 11);
    i0.ɵɵtemplate(5, PlanCompareAccordionComponent_ng_template_5_ng_template_5_Template, 1, 1, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(7, PlanCompareAccordionComponent_ng_template_5_span_7_Template, 2, 4, "span", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 14);
    i0.ɵɵelement(9, "i", 15);
    i0.ɵɵelementStart(10, "span", 16);
    i0.ɵɵtext(11, "Collapse");
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const _r4 = i0.ɵɵreference(6);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.isLiveEditable)("ngIfElse", _r4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.accordionSubHeader);
} }
function PlanCompareAccordionComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 19)(2, "div", 20)(3, "span", 21);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 21);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "div", 22);
    i0.ɵɵprojection(8);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", ctx_r1.accordionSectionHeader, " type");
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-colspan", ctx_r1.plansLength);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r1.accordionSectionHeader, " amount");
} }
const _c0$W = ["*"];
class PlanCompareAccordionComponent {
}
PlanCompareAccordionComponent.ɵfac = function PlanCompareAccordionComponent_Factory(t) { return new (t || PlanCompareAccordionComponent)(); };
PlanCompareAccordionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCompareAccordionComponent, selectors: [["vnext-widget-plan-compare-accordion"]], inputs: { headerPropertyName: "headerPropertyName", isLiveEditable: "isLiveEditable", accordionId: "accordionId", accordionSectionHeader: "accordionSectionHeader", accordionIsOpen: "accordionIsOpen", accordionSubHeader: "accordionSubHeader", accordionSubHeaderClass: "accordionSubHeaderClass", plansLength: "plansLength" }, ngContentSelectors: _c0$W, decls: 7, vars: 2, consts: [[1, "plan-details-accordion", "accordion-container"], [1, "container-fluid"], [1, "row"], [1, "w-100", 3, "activeIds"], [1, "card-header", 3, "id"], ["ngbPanelHeader", ""], ["ngbPanelContent", ""], [1, "d-flex", "align-items-center", "justify-content-between", "Spa_Style_Accent6_Background", "mb-0"], ["ngbPanelToggle", "", "aria-expanded", "true", 1, "btn", "container-fluid", "text-left", "pl-0", "mx-0", "my-1"], ["role", "heading", "aria-level", "2", 1, "m-0", "Spa_Style_H2", "Spa_Style_Secondary_Text_Color", "d-flex", "justify-content-between", "align-items-center", "plan-compare-accordion-header"], [1, "text-center", "text-lg-left", "col-11", "px-0"], [4, "ngIf", "ngIfElse"], ["showHeaderName", ""], [3, "class", 4, "ngIf"], [1, "px-0"], [1, "fas", "fa-chevron-up", "mt-1"], [1, "sr-only"], [4, "liveEditProp"], ["role", "table"], ["role", "rowgroup", 1, "sr-only"], ["role", "row"], ["role", "columnheader"], ["role", "rowgroup"]], template: function PlanCompareAccordionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "ngb-accordion", 3)(4, "ngb-panel", 4);
        i0.ɵɵtemplate(5, PlanCompareAccordionComponent_ng_template_5_Template, 12, 3, "ng-template", 5);
        i0.ɵɵtemplate(6, PlanCompareAccordionComponent_ng_template_6_Template, 9, 3, "ng-template", 6);
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("activeIds", ctx.accordionIsOpen ? ctx.accordionId : "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("id", ctx.accordionId);
    } }, dependencies: [i1$2.NgIf, LiveEditPropDirective, IconAriaAttributesDirective, i1$1.NgbAccordion, i1$1.NgbPanel, i1$1.NgbPanelContent, i1$1.NgbPanelHeader, i1$1.NgbPanelToggle], styles: ["button[_ngcontent-%COMP%]{margin:1px 1px 3px}button[_ngcontent-%COMP%]:focus, .btn[_ngcontent-%COMP%]:focus{outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:inset 0 1px 1px var(--static-Spa_Style_Accent1),0 0 8px var(--static-Spa_Style_Accent1)}.plan-details-accordion[_ngcontent-%COMP%]   .fa-chevron-up[_ngcontent-%COMP%]:before{content:\"\\f077\";font-size:22px}.plan-details-accordion[_ngcontent-%COMP%]   .collapsed[_ngcontent-%COMP%]   .fa-chevron-up[_ngcontent-%COMP%]:before{content:\"\\f078\"}.plan-compare-accordion-header[_ngcontent-%COMP%]{padding-left:11px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCompareAccordionComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-compare-accordion', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"plan-details-accordion accordion-container\">\r\n  <div class=\"container-fluid\">\r\n    <div class=\"row\">\r\n      <ngb-accordion [activeIds]=\"accordionIsOpen ? accordionId : ''\" class=\"w-100\">\r\n        <ngb-panel [id]=\"accordionId\" class=\"card-header\">\r\n          <ng-template ngbPanelHeader let-opened=\"opened\">\r\n            <h2 class=\"d-flex align-items-center justify-content-between Spa_Style_Accent6_Background mb-0\">\r\n              <button ngbPanelToggle class=\"btn container-fluid text-left pl-0 mx-0 my-1\" aria-expanded=\"true\">\r\n                <span\r\n                  class=\"m-0 Spa_Style_H2 Spa_Style_Secondary_Text_Color d-flex justify-content-between align-items-center plan-compare-accordion-header\"\r\n                  role=\"heading\"\r\n                  aria-level=\"2\"\r\n                >\r\n                  <span class=\"text-center text-lg-left col-11 px-0\">\r\n                    <ng-container *ngIf=\"isLiveEditable; else showHeaderName\">\r\n                      <span *liveEditProp=\"headerPropertyName\"> {{ accordionSectionHeader }}</span>\r\n                    </ng-container>\r\n                    <ng-template #showHeaderName>{{ accordionSectionHeader }}</ng-template>\r\n                    <span class=\"{{ accordionSubHeaderClass }}\" *ngIf=\"accordionSubHeader\">{{ accordionSubHeader }}</span>\r\n                  </span>\r\n                  <span class=\"px-0\">\r\n                    <i class=\"fas fa-chevron-up mt-1\"></i>\r\n                    <span class=\"sr-only\">Collapse</span>\r\n                  </span>\r\n                </span>\r\n              </button>\r\n            </h2>\r\n          </ng-template>\r\n          <ng-template ngbPanelContent>\r\n            <div role=\"table\">\r\n              <div role=\"rowgroup\" class=\"sr-only\">\r\n                <div role=\"row\">\r\n                  <span role=\"columnheader\">{{ accordionSectionHeader }} type</span>\r\n                  <span role=\"columnheader\" [attr.aria-colspan]=\"plansLength\">{{ accordionSectionHeader }} amount</span>\r\n                </div>\r\n              </div>\r\n              <div role=\"rowgroup\">\r\n                <ng-content></ng-content>\r\n              </div>\r\n            </div>\r\n          </ng-template>\r\n        </ngb-panel>\r\n      </ngb-accordion>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: ["button{margin:1px 1px 3px}button:focus,.btn:focus{outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:inset 0 1px 1px var(--static-Spa_Style_Accent1),0 0 8px var(--static-Spa_Style_Accent1)}.plan-details-accordion .fa-chevron-up:before{content:\"\\f077\";font-size:22px}.plan-details-accordion .collapsed .fa-chevron-up:before{content:\"\\f078\"}.plan-compare-accordion-header{padding-left:11px}\n"] }]
    }], null, { headerPropertyName: [{
            type: Input
        }], isLiveEditable: [{
            type: Input
        }], accordionId: [{
            type: Input
        }], accordionSectionHeader: [{
            type: Input
        }], accordionIsOpen: [{
            type: Input
        }], accordionSubHeader: [{
            type: Input
        }], accordionSubHeaderClass: [{
            type: Input
        }], plansLength: [{
            type: Input
        }] }); })();

function PlanCompareCardLabelComponent_div_0_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div");
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r4.customClass);
} }
function PlanCompareCardLabelComponent_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanCompareCardLabelComponent_div_0_ng_container_2_div_1_Template, 1, 3, "div", 4);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵelement(3, "vnext-widget-plan-card-label", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const plan_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r3 === 0 && !ctx_r1.isMedium && !ctx_r1.isMobile);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("p-0 mt-3 ", ctx_r1.customClass, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", plan_r2)("customClass", (ctx_r1.plans == null ? null : ctx_r1.plans.length) > 2 ? "col-10 col-sm-7" : "col-10 col-sm-6 col-md-5")("currentPlanText", ctx_r1.currentPlanText)("nextYearPlanText", ctx_r1.nextYearPlanText)("optionOneText", ctx_r1.optionOneText)("optionTwoText", ctx_r1.optionTwoText)("displayOptionLabels", ctx_r1.displayOptionLabels)("disableNextYearDisplay", ctx_r1.disableNextYearDisplay)("nonCommissionableText", ctx_r1.nonCommissionableText)("isNonCommissionableFlagCheckEnabled", ctx_r1.isNonCommissionableFlagCheckEnabled);
} }
function PlanCompareCardLabelComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtemplate(2, PlanCompareCardLabelComponent_div_0_ng_container_2_Template, 4, 14, "ng-container", 3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.plans);
} }
class PlanCompareCardLabelComponent {
}
PlanCompareCardLabelComponent.ɵfac = function PlanCompareCardLabelComponent_Factory(t) { return new (t || PlanCompareCardLabelComponent)(); };
PlanCompareCardLabelComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCompareCardLabelComponent, selectors: [["vnext-widget-plan-compare-card-label"]], inputs: { plans: "plans", currentPlanText: "currentPlanText", nextYearPlanText: "nextYearPlanText", customClass: "customClass", isMobile: "isMobile", isMedium: "isMedium", optionOneText: "optionOneText", optionTwoText: "optionTwoText", disableNextYearDisplay: "disableNextYearDisplay", displayOptionLabels: "displayOptionLabels", hidePlanCardLabel: "hidePlanCardLabel", nonCommissionableText: "nonCommissionableText", isNonCommissionableFlagCheckEnabled: "isNonCommissionableFlagCheckEnabled" }, decls: 1, vars: 1, consts: [["class", "container p-0", 4, "ngIf"], [1, "container", "p-0"], [1, "row"], [4, "ngFor", "ngForOf"], [3, "class", 4, "ngIf"], [3, "plan", "customClass", "currentPlanText", "nextYearPlanText", "optionOneText", "optionTwoText", "displayOptionLabels", "disableNextYearDisplay", "nonCommissionableText", "isNonCommissionableFlagCheckEnabled"]], template: function PlanCompareCardLabelComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanCompareCardLabelComponent_div_0_Template, 3, 1, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.hidePlanCardLabel);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, PlanCardLabelComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCompareCardLabelComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-compare-card-label', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"!hidePlanCardLabel\" class=\"container p-0\">\r\n  <div class=\"row\">\r\n    <ng-container *ngFor=\"let plan of plans; index as i\">\r\n      <div class=\"{{ customClass }}\" *ngIf=\"i === 0 && !isMedium && !isMobile\"></div>\r\n      <div class=\"p-0 mt-3 {{ customClass }}\">\r\n        <vnext-widget-plan-card-label\r\n          [plan]=\"plan\"\r\n          [customClass]=\"plans?.length > 2 ? 'col-10 col-sm-7' : 'col-10 col-sm-6 col-md-5'\"\r\n          [currentPlanText]=\"currentPlanText\"\r\n          [nextYearPlanText]=\"nextYearPlanText\"\r\n          [optionOneText]=\"optionOneText\"\r\n          [optionTwoText]=\"optionTwoText\"\r\n          [displayOptionLabels]=\"displayOptionLabels\"\r\n          [disableNextYearDisplay]=\"disableNextYearDisplay\"\r\n          [nonCommissionableText]=\"nonCommissionableText\"\r\n          [isNonCommissionableFlagCheckEnabled]=\"isNonCommissionableFlagCheckEnabled\"\r\n        >\r\n        </vnext-widget-plan-card-label>\r\n      </div>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n" }]
    }], null, { plans: [{
            type: Input
        }], currentPlanText: [{
            type: Input
        }], nextYearPlanText: [{
            type: Input
        }], customClass: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], isMedium: [{
            type: Input
        }], optionOneText: [{
            type: Input
        }], optionTwoText: [{
            type: Input
        }], disableNextYearDisplay: [{
            type: Input
        }], displayOptionLabels: [{
            type: Input
        }], hidePlanCardLabel: [{
            type: Input
        }], nonCommissionableText: [{
            type: Input
        }], isNonCommissionableFlagCheckEnabled: [{
            type: Input
        }] }); })();

const _c0$V = ["starRating"];
const _c1$i = ["planLogo"];
const _c2$c = ["planName"];
const _c3$6 = ["premiumPrice"];
const _c4$3 = ["actionCompareButton"];
function PlanCompareCardComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.hospitalIndemnityBadgeText, " ");
} }
const _c5$3 = function (a0, a1) { return { "mapd-badge-extra-small": a0, "mapd-badge-small": a1 }; };
function PlanCompareCardComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c5$3, plan_r1.planTypeAbbreviation === ctx_r6.planTypeAbbreviation.MAPD && ctx_r6.locale === ctx_r6.cultureCode.ENGLISH_EN_US && ctx_r6.plans.length > 2, plan_r1.planTypeAbbreviation === ctx_r6.planTypeAbbreviation.MAPD && ctx_r6.locale === ctx_r6.cultureCode.SPANISH_ES_MX && ctx_r6.plans.length > 2));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.medicareHospitalIndemnityTitle, " ");
} }
const _c6$3 = function (a0, a1, a2) { return { "current-plan-card Spa_Style_Accent6_Border": a0, "next-year-plan-card Spa_Style_Primary_Link_Border": a1, "plan-card-vertical-border": a2 }; };
function PlanCompareCardComponent_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 29)(2, "i", 30);
    i0.ɵɵlistener("keyup.enter", function PlanCompareCardComponent_div_1_ng_container_3_Template_i_keyup_enter_2_listener() { i0.ɵɵrestoreView(_r25); const plan_r1 = i0.ɵɵnextContext().$implicit; const ctx_r23 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r23.removePlan(plan_r1)); })("click", function PlanCompareCardComponent_div_1_ng_container_3_Template_i_click_2_listener() { i0.ɵɵrestoreView(_r25); const plan_r1 = i0.ɵɵnextContext().$implicit; const ctx_r26 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r26.removePlan(plan_r1)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const plan_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(2, _c6$3, plan_r1.isCurrentYearPlan, plan_r1.isNextYearPlan && !plan_r1.isPlanRolloverTerminated, !plan_r1.isCurrentYearPlan && (!plan_r1.isNextYearPlan || plan_r1.isNextYearPlan && plan_r1.isPlanRolloverTerminated)));
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", ctx_r7.removePlanText);
} }
function PlanCompareCardComponent_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelement(1, "vnext-plan-logo", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("alternateText", plan_r1.logo2Description)("imageSrc", ctx_r9.planAttributeMap[plan_r1.id] == null ? null : ctx_r9.planAttributeMap[plan_r1.id].logoUrl)("classNames", "plan-logo")("planLogoSize", ctx_r9.planLogoSize);
} }
function PlanCompareCardComponent_div_1_vnext_star_rating_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-star-rating", 33);
} if (rf & 2) {
    const plan_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("starRating", plan_r1.planRating)("ratingValueDescription", plan_r1.planRatingValueDescription)("showLowPerformanceIndicator", plan_r1.isLowPerformingPlan);
} }
function PlanCompareCardComponent_div_1_vnext_link_18_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 34);
    i0.ɵɵlistener("click", function PlanCompareCardComponent_div_1_vnext_link_18_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r32); const ctx_r31 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r31.planFacade.navigateToMedSupForm()); })("keyup.enter", function PlanCompareCardComponent_div_1_vnext_link_18_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r32); const ctx_r33 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r33.planFacade.navigateToMedSupForm()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r14.planCardQuoteLinkText);
} }
function PlanCompareCardComponent_div_1_ng_template_19_div_0_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r1 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r37 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r37.planPremiumInitialRange[plan_r1.id]);
} }
function PlanCompareCardComponent_div_1_ng_template_19_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtemplate(1, PlanCompareCardComponent_div_1_ng_template_19_div_0_span_1_Template, 2, 1, "span", 5);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r34 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r34.snpPremiumRangeEnabled && ctx_r34.planPremiumInitialRange[plan_r1.id]);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, ctx_r34.planTotalPremium[plan_r1.id]), " ");
} }
function PlanCompareCardComponent_div_1_ng_template_19_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-plan-fees-tooltip", 38);
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(2);
    const plan_r1 = ctx_r40.$implicit;
    const isFirstPlan_r3 = ctx_r40.first;
    const isLastPlan_r4 = ctx_r40.last;
    const ctx_r36 = i0.ɵɵnextContext();
    i0.ɵɵproperty("planFees", plan_r1.fees)("planTotalPremium", ctx_r36.planTotalPremium[plan_r1.id])("planFeesTooltipText", ctx_r36.planFeesTooltipText)("planFeesIncludedInPremiumTooltipText", ctx_r36.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r36.planFeesNotIncludedInPremiumTooltipText)("tooltipPlacement", isFirstPlan_r3 ? "bottom-left" : isLastPlan_r4 ? "bottom-right" : "bottom-right bottom-left")("tooltipCustomClass", isFirstPlan_r3 || isLastPlan_r4 ? "inline-block-xs-layout inline-block-sm-layout" : "")("tooltipContainer", !ctx_r36.stickyMiniCartEnabled ? "body" : undefined);
} }
function PlanCompareCardComponent_div_1_ng_template_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanCompareCardComponent_div_1_ng_template_19_div_0_Template, 4, 4, "div", 35);
    i0.ɵɵtemplate(1, PlanCompareCardComponent_div_1_ng_template_19_ng_template_1_Template, 1, 8, "ng-template", null, 36, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r35 = i0.ɵɵreference(2);
    const plan_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r16 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r16.planFeesEnabled || !(plan_r1.fees == null ? null : plan_r1.fees.length))("ngIfElse", _r35);
} }
function PlanCompareCardComponent_div_1_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r17.monthlyPremiumText, " ");
} }
function PlanCompareCardComponent_div_1_ng_container_22_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 42);
    i0.ɵɵlistener("click", function PlanCompareCardComponent_div_1_ng_container_22_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r45); const plan_r1 = i0.ɵɵnextContext(2).$implicit; const ctx_r43 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r43.navigateToPlanDetailsPage(plan_r1)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r42 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate2("title", "", ctx_r42.planDetailsButton, " ", plan_r1.planName, "");
    i0.ɵɵattribute("role", ctx_r42.linkRoles.LINK)("aria-label", ctx_r42.planDetailsButton);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r42.planDetailsButton, " ");
} }
function PlanCompareCardComponent_div_1_ng_container_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 40);
    i0.ɵɵtemplate(2, PlanCompareCardComponent_div_1_ng_container_22_button_2_Template, 2, 5, "button", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const plan_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(2, _c6$3, plan_r1.isCurrentYearPlan, plan_r1.isNextYearPlan && !plan_r1.isPlanRolloverTerminated, !plan_r1.isCurrentYearPlan && (!plan_r1.isNextYearPlan || plan_r1.isNextYearPlan && plan_r1.isPlanRolloverTerminated)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.showPlanViewDetails);
} }
function PlanCompareCardComponent_div_1_div_27_Template(rf, ctx) { if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 43)(1, "button", 44);
    i0.ɵɵlistener("click", function PlanCompareCardComponent_div_1_div_27_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r50); const plan_r1 = i0.ɵɵnextContext().$implicit; const ctx_r48 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r48.navigateToPlanDetailsPage(plan_r1)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const plan_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r20 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r20.plans.length === 3 ? "col-md-12" : "col-md");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate2("title", "", plan_r1.planName, ": ", ctx_r20.planDetailsButton, "");
    i0.ɵɵattribute("aria-label", (plan_r1 == null ? null : plan_r1.planName) + ": " + ctx_r20.planDetailsButton)("role", ctx_r20.linkRoles.LINK);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r20.planDetailsButton, " ");
} }
function PlanCompareCardComponent_div_1_div_28_vnext_shopping_cart_button_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-shopping-cart-button", 47);
} if (rf & 2) {
    const plan_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("plan", plan_r1)("isComparePage", true);
} }
function PlanCompareCardComponent_div_1_div_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵtemplate(1, PlanCompareCardComponent_div_1_div_28_vnext_shopping_cart_button_1_Template, 1, 2, "vnext-shopping-cart-button", 46);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r21 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r21.plans.length === 3 ? "col-md-12" : "col-md");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r21.planAttributeMap[plan_r1.id] == null ? null : ctx_r21.planAttributeMap[plan_r1.id].hasPremium);
} }
const _c7$2 = function (a0, a1) { return { "col-6 plan-card-top-border": a0, "col-4": a1 }; };
function PlanCompareCardComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, PlanCompareCardComponent_div_1_div_1_Template, 2, 1, "div", 3);
    i0.ɵɵtemplate(2, PlanCompareCardComponent_div_1_div_2_Template, 2, 5, "div", 4);
    i0.ɵɵtemplate(3, PlanCompareCardComponent_div_1_ng_container_3_Template, 3, 6, "ng-container", 5);
    i0.ɵɵelementStart(4, "div", 6, 7);
    i0.ɵɵtemplate(6, PlanCompareCardComponent_div_1_div_6_Template, 2, 4, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 9, 10)(9, "span", 11);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 12, 13);
    i0.ɵɵtemplate(13, PlanCompareCardComponent_div_1_vnext_star_rating_13_Template, 1, 3, "vnext-star-rating", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 15, 16)(16, "div", 17);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, PlanCompareCardComponent_div_1_vnext_link_18_Template, 1, 1, "vnext-link", 18);
    i0.ɵɵtemplate(19, PlanCompareCardComponent_div_1_ng_template_19_Template, 3, 2, "ng-template", null, 19, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(21, PlanCompareCardComponent_div_1_div_21_Template, 2, 1, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(22, PlanCompareCardComponent_div_1_ng_container_22_Template, 3, 6, "ng-container", 5);
    i0.ɵɵelementStart(23, "div", 21, 22)(25, "div", 23)(26, "div", 24);
    i0.ɵɵtemplate(27, PlanCompareCardComponent_div_1_div_27_Template, 3, 6, "div", 25);
    i0.ɵɵtemplate(28, PlanCompareCardComponent_div_1_div_28_Template, 2, 2, "div", 26);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const plan_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const _r15 = i0.ɵɵreference(20);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(21, _c7$2, ctx_r0.plans.length === 2, ctx_r0.plans.length > 2));
    i0.ɵɵattribute("aria-colindex", i_r2 + 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.planAttributeMap[plan_r1.id] == null ? null : ctx_r0.planAttributeMap[plan_r1.id].isHospitalCarePlan);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.planAttributeMap[plan_r1.id] == null ? null : ctx_r0.planAttributeMap[plan_r1.id].isMedicare);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.plans.length > 2 || ctx_r0.showRemovePlanButtonForMobile);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(24, _c6$3, plan_r1.isCurrentYearPlan, plan_r1.isNextYearPlan && !plan_r1.isPlanRolloverTerminated, !plan_r1.isCurrentYearPlan && (!plan_r1.isNextYearPlan || plan_r1.isNextYearPlan && plan_r1.isPlanRolloverTerminated)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showLogo && (ctx_r0.planAttributeMap[plan_r1.id] == null ? null : ctx_r0.planAttributeMap[plan_r1.id].logoUrl));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(28, _c6$3, plan_r1.isCurrentYearPlan, plan_r1.isNextYearPlan && !plan_r1.isPlanRolloverTerminated, !plan_r1.isCurrentYearPlan && (!plan_r1.isNextYearPlan || plan_r1.isNextYearPlan && plan_r1.isPlanRolloverTerminated)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", "plan-compare-plan-name-header" + i_r2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", plan_r1.planTypeAbbreviation === ctx_r0.planTypeAbbreviation.HC ? plan_r1.carrierName + " " + plan_r1.planName : plan_r1.planName, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(32, _c6$3, plan_r1.isCurrentYearPlan, plan_r1.isNextYearPlan && !plan_r1.isPlanRolloverTerminated, !plan_r1.isCurrentYearPlan && (!plan_r1.isNextYearPlan || plan_r1.isNextYearPlan && plan_r1.isPlanRolloverTerminated)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !(ctx_r0.planAttributeMap[plan_r1.id] == null ? null : ctx_r0.planAttributeMap[plan_r1.id].isDentalPlan));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(36, _c6$3, plan_r1.isCurrentYearPlan, plan_r1.isNextYearPlan && !plan_r1.isPlanRolloverTerminated, !plan_r1.isCurrentYearPlan && (!plan_r1.isNextYearPlan || plan_r1.isNextYearPlan && plan_r1.isPlanRolloverTerminated)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.planFacade.getPremiumLabel());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(ctx_r0.planAttributeMap[plan_r1.id] == null ? null : ctx_r0.planAttributeMap[plan_r1.id].hasPremium))("ngIfElse", _r15);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.planAttributeMap[plan_r1.id] == null ? null : ctx_r0.planAttributeMap[plan_r1.id].isHospitalCarePlan);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isRetentionView);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(40, _c6$3, plan_r1.isCurrentYearPlan, plan_r1.isNextYearPlan && !plan_r1.isPlanRolloverTerminated, !plan_r1.isCurrentYearPlan && (!plan_r1.isNextYearPlan || plan_r1.isNextYearPlan && plan_r1.isPlanRolloverTerminated)));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r0.isRetentionView && ctx_r0.showPlanViewDetails);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.planAttributeMap[plan_r1.id] == null ? null : ctx_r0.planAttributeMap[plan_r1.id].addToCartButtonEnabled);
} }
class PlanCompareCardComponent {
    constructor(planFacade, renderer, modalService, cdr) {
        this.planFacade = planFacade;
        this.renderer = renderer;
        this.modalService = modalService;
        this.cdr = cdr;
        this.isAncillaryAddToCartEnabled = true;
        this.viewPlanDetailsPage = new EventEmitter();
        this.removePlanFromCompare = new EventEmitter();
        this.subscriptions = new Subscription();
        this.maxPlanLogoHeight = 0;
        this.maxPlanNameHeight = 0;
        this.maxPremiumPrices = 0;
        this.maxActionCompareButtons = 0;
        this.maxPlanRatingsHeight = 0;
        this.planTypeAbbreviation = PlanTypeAbbreviation;
        this.planTotalPremium = {};
        this.planPremiumInitialRange = {};
        this.linkRoles = LinkRoles;
        this.planAttributeMap = {};
        this.cultureCode = CultureCode;
    }
    ngOnChanges(changes) {
        const { plans, planRidersMap, planTypes, snpPremiumRangeEnabled } = changes;
        if (!_isEqual(plans?.currentValue, plans?.previousValue) ||
            !_isEqual(planRidersMap?.currentValue, planRidersMap?.previousValue) ||
            !_isEqual(snpPremiumRangeEnabled?.currentValue, snpPremiumRangeEnabled?.previousValue)) {
            for (const plan of this.plans) {
                this.planTotalPremium[plan.id] = this.planFacade.getTotalPremium([plan], this.planRidersMap?.[plan.id]);
                if (this.snpPremiumRangeEnabled) {
                    this.planPremiumInitialRange[plan.id] = this.planFacade.getPlanPremiumRange(plan, this.planTotalPremium[plan.id]);
                }
            }
        }
        if (!_isEqual(plans?.currentValue, plans?.previousValue) || !_isEqual(planTypes?.currentValue, planTypes?.previousValue)) {
            for (const plan of this.plans) {
                this.planFacade
                    .hasPremium$(plan)
                    .pipe(take(1))
                    .subscribe(hasPremium => {
                    const isDentalPlan = this.planFacade.isDentalPlan(plan);
                    const isHospitalCarePlan = this.planFacade.isHCPlan(plan);
                    const isVisionPlan = this.planFacade.isVisionPlan(plan);
                    const isAncillaryPlan = isDentalPlan || isHospitalCarePlan || isVisionPlan;
                    this.planAttributeMap[plan.id] = {
                        isDentalPlan,
                        isHospitalCarePlan,
                        isVisionPlan,
                        isAncillaryPlan,
                        isMedicare: this.isMedicare(plan),
                        logoUrl: this.planFacade.getPlanLogoUrl(plan),
                        hasPremium,
                        addToCartButtonEnabled: !isAncillaryPlan || (isAncillaryPlan && this.isAncillaryAddToCartEnabled)
                    };
                    this.cdr.markForCheck();
                });
            }
            this.existsMedicarePlan = this.plans.some(plan => this.isMedicare(plan));
            if (this.existsMedicarePlan) {
                const planTypeAbbreviations = this.plans.map(plan => plan.planTypeAbbreviation);
                this.medicareHospitalIndemnityTitle = this.planTypes.find(planType => planTypeAbbreviations.includes(planType.tabType))?.title;
            }
        }
    }
    ngAfterViewChecked() {
        this.maxPlanLogoHeight = this.calculateMaxSectionHeight(this.planLogos, this.maxPlanLogoHeight, true);
        this.maxPlanNameHeight = this.calculateMaxSectionHeight(this.planNames, this.maxPlanNameHeight, false);
        this.maxPremiumPrices = this.calculateMaxSectionHeight(this.premiumPrices, this.maxPremiumPrices, false);
        this.maxActionCompareButtons = this.calculateMaxSectionHeight(this.actionCompareButtons, this.maxActionCompareButtons, false);
        this.maxPlanRatingsHeight = this.calculateMaxSectionHeight(this.starRatings, this.maxPlanRatingsHeight, false);
    }
    isMedicare(plan) {
        return this.planFacade.isMedicareOnHospitalCare(plan, this.medicareTypes) && this.activeTabType === this.planTypeAbbreviation.HC;
    }
    navigateToPlanDetailsPage(plan) {
        this.viewPlanDetailsPage.emit(plan);
    }
    removePlan(plan) {
        if (this.showRemovePlanButtonForMobile) {
            const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true });
            confirmationModal.componentInstance.title = this.removeModalHeaderText;
            confirmationModal.componentInstance.prompt = this.removeModalIntroText;
            confirmationModal.componentInstance.cancelButton = this.removeModalCancelText;
            confirmationModal.componentInstance.confirmButton = this.removeModalButtonText;
            confirmationModal.componentInstance.confirmAction = () => {
                this.removePlanFromCompare.emit(plan);
                this.cdr.detectChanges();
            };
        }
        else {
            this.removePlanFromCompare.emit(plan);
            this.cdr.detectChanges();
        }
    }
    calculateMaxSectionHeight(elements, calculatedHeight, isMaxHeight) {
        if (elements?.length) {
            if (calculatedHeight !== 0) {
                this.setCalculatedHeight(elements, calculatedHeight, isMaxHeight);
                return calculatedHeight;
            }
            const customHeight = Math.max.apply(Math, elements.map(element => element.nativeElement.offsetHeight));
            this.setCalculatedHeight(elements, customHeight, isMaxHeight);
            return customHeight;
        }
    }
    setCalculatedHeight(elements, calculatedHeight, isMaxHeight) {
        elements.forEach(element => {
            this.renderer.setStyle(element.nativeElement, isMaxHeight ? 'max-height' : 'height', `${calculatedHeight}px`);
        });
    }
}
PlanCompareCardComponent.ɵfac = function PlanCompareCardComponent_Factory(t) { return new (t || PlanCompareCardComponent)(i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
PlanCompareCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCompareCardComponent, selectors: [["vnext-widget-plan-compare-card"]], viewQuery: function PlanCompareCardComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$V, 5);
        i0.ɵɵviewQuery(_c1$i, 5);
        i0.ɵɵviewQuery(_c2$c, 5);
        i0.ɵɵviewQuery(_c3$6, 5);
        i0.ɵɵviewQuery(_c4$3, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.starRatings = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.planLogos = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.planNames = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.premiumPrices = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.actionCompareButtons = _t);
    } }, inputs: { plans: "plans", planDetailsButton: "planDetailsButton", isRetentionView: "isRetentionView", isMobile: "isMobile", isMedium: "isMedium", locale: "locale", currentPlanText: "currentPlanText", nextYearPlanText: "nextYearPlanText", isCurrentYearPlanExist: "isCurrentYearPlanExist", planCardQuoteLinkText: "planCardQuoteLinkText", showLogo: "showLogo", showPlanViewDetails: "showPlanViewDetails", removePlanText: "removePlanText", hospitalIndemnityBadgeText: "hospitalIndemnityBadgeText", monthlyPremiumText: "monthlyPremiumText", planRidersMap: "planRidersMap", planTypes: "planTypes", activeTabType: "activeTabType", medicareTypes: "medicareTypes", planLogoSize: "planLogoSize", isAncillaryAddToCartEnabled: "isAncillaryAddToCartEnabled", stickyMiniCartEnabled: "stickyMiniCartEnabled", planFeesEnabled: "planFeesEnabled", planFeesTooltipText: "planFeesTooltipText", planFeesIncludedInPremiumTooltipText: "planFeesIncludedInPremiumTooltipText", removeModalHeaderText: "removeModalHeaderText", removeModalIntroText: "removeModalIntroText", removeModalCancelText: "removeModalCancelText", removeModalButtonText: "removeModalButtonText", planFeesNotIncludedInPremiumTooltipText: "planFeesNotIncludedInPremiumTooltipText", snpPremiumRangeEnabled: "snpPremiumRangeEnabled", showRemovePlanButtonForMobile: "showRemovePlanButtonForMobile" }, outputs: { viewPlanDetailsPage: "viewPlanDetailsPage", removePlanFromCompare: "removePlanFromCompare" }, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 1, consts: [["id", "plan-compare-main-column-header", 1, "row", "plan-card", "h-100"], ["class", "px-0 plan-card-column", "role", "cell", 3, "ngClass", 4, "ngFor", "ngForOf"], ["role", "cell", 1, "px-0", "plan-card-column", 3, "ngClass"], ["class", "hip-badge Spa_Style_Gray4_Background Spa_Style_Secondary_Text_Color text-wrap", 4, "ngIf"], ["class", "medicare-badge Spa_Style_Gray2_Background Spa_Style_Primary_Color text-wrap", 3, "ngClass", 4, "ngIf"], [4, "ngIf"], [1, "py-2", "px-2", "plan-card-section", 3, "ngClass"], ["planLogo", ""], ["class", "text-center image-responsive", "vnextHideMissingImage", "", 4, "ngIf"], [1, "py-1", "px-2", "text-center", "plan-card-section", 3, "ngClass"], ["planName", ""], [1, "Spa_Style_H4", "Spa_Style_Primary_Color", "my-0", "no-translate-block", 3, "id"], [1, "pb-3", "pt-2", "text-center", "px-2", "plan-card-section", 3, "ngClass"], ["starRating", ""], [3, "starRating", "ratingValueDescription", "showLowPerformanceIndicator", 4, "ngIf"], [1, "pb-md-3", "pb-4", "text-center", "plan-monthly-premium", "px-2", "plan-card-section", 3, "ngClass"], ["premiumPrice", ""], [1, "Spa_Style_Paragraph", "Spa_Style_Primary_Color"], [3, "title", "click", "keyup.enter", 4, "ngIf", "ngIfElse"], ["showPremium", ""], ["class", "Spa_Style_Note", 4, "ngIf"], [1, "px-2", "plan-card-bottom-border", "plan-card-section", "pb-2", 3, "ngClass"], ["actionCompareButton", ""], [1, "plan-card-button"], [1, "row", "justify-content-center", "plan-compare-buttons"], ["class", "col-12 px-1 mt-1", 3, "ngClass", 4, "ngIf"], ["class", "plan-card-button-section col-12 mt-1 px-1", 3, "ngClass", 4, "ngIf"], [1, "hip-badge", "Spa_Style_Gray4_Background", "Spa_Style_Secondary_Text_Color", "text-wrap"], [1, "medicare-badge", "Spa_Style_Gray2_Background", "Spa_Style_Primary_Color", "text-wrap", 3, "ngClass"], [1, "plan-card-remove-btn", "text-right", "plan-card-top-border", 3, "ngClass"], ["tabindex", "0", "role", "button", 1, "fas", "fa-times", "can-click", "Spa_Style_Smaller_Font", 3, "keyup.enter", "click"], ["vnextHideMissingImage", "", 1, "text-center", "image-responsive"], [3, "alternateText", "imageSrc", "classNames", "planLogoSize"], [3, "starRating", "ratingValueDescription", "showLowPerformanceIndicator"], [3, "title", "click", "keyup.enter"], ["class", "Spa_Style_CostPremiumSmall", 4, "ngIf", "ngIfElse"], ["showPremiumWithFees", ""], [1, "Spa_Style_CostPremiumSmall"], [3, "planFees", "planTotalPremium", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "tooltipPlacement", "tooltipCustomClass", "tooltipContainer"], [1, "Spa_Style_Note"], [1, "pb-1", "px-2", "plan-card-section", 3, "ngClass"], ["class", "btn Spa_Style_SecondaryButton btn-block Spa_Style_Small_Font", 3, "title", "click", 4, "ngIf"], [1, "btn", "Spa_Style_SecondaryButton", "btn-block", "Spa_Style_Small_Font", 3, "title", "click"], [1, "col-12", "px-1", "mt-1", 3, "ngClass"], [1, "btn", "Spa_Style_SecondaryButton", "btn-block", "Spa_Style_Small_Font", "p-md-1", 3, "title", "click"], [1, "plan-card-button-section", "col-12", "mt-1", "px-1", 3, "ngClass"], [3, "plan", "isComparePage", 4, "ngIf"], [3, "plan", "isComparePage"]], template: function PlanCompareCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, PlanCompareCardComponent_div_1_Template, 29, 44, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.plans);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, IconAriaAttributesDirective, HideMissingImageDirective, StarRatingComponent, ShoppingCartButtonComponent, PlanFeesTooltipComponent, PlanLogoComponent, i1$2.CurrencyPipe], styles: [".plan-card-vertical-border[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent1);border-right-width:1px;border-right-style:solid}.image-responsive[_ngcontent-%COMP%]{padding-right:0;max-width:100%;height:36px;text-align:center}.current-plan-card[_ngcontent-%COMP%], .next-year-plan-card[_ngcontent-%COMP%]{border-right-width:2px;border-right-style:solid;border-left-width:2px;border-left-style:solid}.current-plan-card.plan-card-bottom-border[_ngcontent-%COMP%], .next-year-plan-card.plan-card-bottom-border[_ngcontent-%COMP%]{border-bottom-width:2px}.plan-card-column[_ngcontent-%COMP%]:first-child{border-left-width:1px;border-left-style:solid;border-left-color:var(--static-Spa_Style_Accent1)}.plan-card-column[_ngcontent-%COMP%]:last-child   .plan-card-section[_ngcontent-%COMP%]:last-child{border-bottom-right-radius:5px}.plan-card[_ngcontent-%COMP%]   .current-plan-card[_ngcontent-%COMP%]:first-child, .plan-card[_ngcontent-%COMP%]   .next-year-plan-card[_ngcontent-%COMP%]:first-child{border-top-width:2px;border-top-style:solid}.plan-card-top-border[_ngcontent-%COMP%]{border-top-width:1px;border-top-style:solid;border-top-color:var(--static-Spa_Style_Accent1)}.current-plan-card.plan-card-top-border[_ngcontent-%COMP%]:first-child, .next-year-plan-card.plan-card-top-border[_ngcontent-%COMP%]:first-child{border-top-left-radius:0}.plan-card-column[_ngcontent-%COMP%]:last-child   .plan-card-remove-btn[_ngcontent-%COMP%]:first-child{border-top-right-radius:5px}.current-plan-text[_ngcontent-%COMP%], .next-year-plan-text[_ngcontent-%COMP%]{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.plan-card-column[_ngcontent-%COMP%]{display:flex;flex-flow:column}.plan-card-section[_ngcontent-%COMP%]{display:flex;align-items:stretch;flex-direction:column;flex-grow:1}.plan-card-bottom-border[_ngcontent-%COMP%]{border-bottom-width:1px;border-bottom-style:solid}.plan-card-button-section[_ngcontent-%COMP%]:empty{display:none}@media (max-width: 991.9px){.plan-card-top-border[_ngcontent-%COMP%]:last-child{border-top-right-radius:0}.plan-card-bottom-border[_ngcontent-%COMP%]:last-child{border-bottom-right-radius:0}.plan-card-column[_ngcontent-%COMP%]:last-child   .plan-card-section[_ngcontent-%COMP%]:last-child, .plan-card-column[_ngcontent-%COMP%]:last-child   .plan-card-remove-btn[_ngcontent-%COMP%]:first-child{border-radius:0}.plan-card[_ngcontent-%COMP%]{margin-right:-10px}.plan-card-column[_ngcontent-%COMP%]:first-child{border-left-width:0}.plan-card-column[_ngcontent-%COMP%]:last-child   div[_ngcontent-%COMP%]{border-right-width:0}.plan-compare-buttons[_ngcontent-%COMP%]{margin-bottom:30px}}@media print{.plan-card-column[_ngcontent-%COMP%]:first-child{border-left-width:1px}.plan-card-column[_ngcontent-%COMP%]:last-child   div[_ngcontent-%COMP%]{border-right-width:1px}}.plan-card-button[_ngcontent-%COMP%]{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width: 992px){.plan-compare-buttons[_ngcontent-%COMP%]{align-items:flex-end}}@media (max-width: 1200px){.plan-card-button[_ngcontent-%COMP%]{padding-left:15px;padding-right:15px}}.medicare-badge[_ngcontent-%COMP%], .hip-badge[_ngcontent-%COMP%]{bottom:100%;left:0;font-size:14px;position:absolute;border-top-left-radius:3px;border-top-right-radius:3px;font-family:montserrat_semibold;padding:2px 12px}.plan-card-remove-btn[_ngcontent-%COMP%]{padding-top:12px;padding-right:12px;line-height:0}.mapd-badge-small[_ngcontent-%COMP%]{max-width:200px}.mapd-badge-extra-small[_ngcontent-%COMP%]{max-width:180px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCompareCardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-compare-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row plan-card h-100\" id=\"plan-compare-main-column-header\">\r\n  <div\r\n    *ngFor=\"let plan of plans; index as i; first as isFirstPlan; last as isLastPlan\"\r\n    class=\"px-0 plan-card-column\"\r\n    [ngClass]=\"{ 'col-6 plan-card-top-border': plans.length === 2, 'col-4': plans.length > 2 }\"\r\n    role=\"cell\"\r\n    [attr.aria-colindex]=\"i + 1\"\r\n  >\r\n    <div\r\n      *ngIf=\"planAttributeMap[plan.id]?.isHospitalCarePlan\"\r\n      class=\"hip-badge Spa_Style_Gray4_Background Spa_Style_Secondary_Text_Color text-wrap\"\r\n    >\r\n      {{ hospitalIndemnityBadgeText }}\r\n    </div>\r\n\r\n    <div\r\n      *ngIf=\"planAttributeMap[plan.id]?.isMedicare\"\r\n      class=\"medicare-badge Spa_Style_Gray2_Background Spa_Style_Primary_Color text-wrap\"\r\n      [ngClass]=\"{\r\n        'mapd-badge-extra-small':\r\n          plan.planTypeAbbreviation === planTypeAbbreviation.MAPD && locale === cultureCode.ENGLISH_EN_US && plans.length > 2,\r\n        'mapd-badge-small':\r\n          plan.planTypeAbbreviation === planTypeAbbreviation.MAPD && locale === cultureCode.SPANISH_ES_MX && plans.length > 2\r\n      }\"\r\n    >\r\n      {{ medicareHospitalIndemnityTitle }}\r\n    </div>\r\n    <ng-container *ngIf=\"plans.length > 2 || showRemovePlanButtonForMobile\">\r\n      <div\r\n        class=\"plan-card-remove-btn text-right plan-card-top-border\"\r\n        [ngClass]=\"{\r\n          'current-plan-card Spa_Style_Accent6_Border': plan.isCurrentYearPlan,\r\n          'next-year-plan-card Spa_Style_Primary_Link_Border': plan.isNextYearPlan && !plan.isPlanRolloverTerminated,\r\n          'plan-card-vertical-border':\r\n            !plan.isCurrentYearPlan && (!plan.isNextYearPlan || (plan.isNextYearPlan && plan.isPlanRolloverTerminated))\r\n        }\"\r\n      >\r\n        <i\r\n          class=\"fas fa-times can-click Spa_Style_Smaller_Font\"\r\n          tabindex=\"0\"\r\n          role=\"button\"\r\n          (keyup.enter)=\"removePlan(plan)\"\r\n          (click)=\"removePlan(plan)\"\r\n          [attr.aria-label]=\"removePlanText\"\r\n        ></i>\r\n      </div>\r\n    </ng-container>\r\n    <div\r\n      #planLogo\r\n      class=\"py-2 px-2 plan-card-section\"\r\n      [ngClass]=\"{\r\n        'current-plan-card Spa_Style_Accent6_Border': plan.isCurrentYearPlan,\r\n        'next-year-plan-card Spa_Style_Primary_Link_Border': plan.isNextYearPlan && !plan.isPlanRolloverTerminated,\r\n        'plan-card-vertical-border':\r\n          !plan.isCurrentYearPlan && (!plan.isNextYearPlan || (plan.isNextYearPlan && plan.isPlanRolloverTerminated))\r\n      }\"\r\n    >\r\n      <div class=\"text-center image-responsive\" *ngIf=\"showLogo && planAttributeMap[plan.id]?.logoUrl\" vnextHideMissingImage>\r\n        <vnext-plan-logo\r\n          [alternateText]=\"plan.logo2Description\"\r\n          [imageSrc]=\"planAttributeMap[plan.id]?.logoUrl\"\r\n          [classNames]=\"'plan-logo'\"\r\n          [planLogoSize]=\"planLogoSize\"\r\n        ></vnext-plan-logo>\r\n      </div>\r\n    </div>\r\n    <div\r\n      #planName\r\n      class=\"py-1 px-2 text-center plan-card-section\"\r\n      [ngClass]=\"{\r\n        'current-plan-card Spa_Style_Accent6_Border': plan.isCurrentYearPlan,\r\n        'next-year-plan-card Spa_Style_Primary_Link_Border': plan.isNextYearPlan && !plan.isPlanRolloverTerminated,\r\n        'plan-card-vertical-border':\r\n          !plan.isCurrentYearPlan && (!plan.isNextYearPlan || (plan.isNextYearPlan && plan.isPlanRolloverTerminated))\r\n      }\"\r\n    >\r\n      <span [id]=\"'plan-compare-plan-name-header' + i\" class=\"Spa_Style_H4 Spa_Style_Primary_Color my-0 no-translate-block\">\r\n        {{ plan.planTypeAbbreviation === planTypeAbbreviation.HC ? plan.carrierName + ' ' + plan.planName : plan.planName }}\r\n      </span>\r\n    </div>\r\n    <div\r\n      #starRating\r\n      class=\"pb-3 pt-2 text-center px-2 plan-card-section\"\r\n      [ngClass]=\"{\r\n        'current-plan-card Spa_Style_Accent6_Border': plan.isCurrentYearPlan,\r\n        'next-year-plan-card Spa_Style_Primary_Link_Border': plan.isNextYearPlan && !plan.isPlanRolloverTerminated,\r\n        'plan-card-vertical-border':\r\n          !plan.isCurrentYearPlan && (!plan.isNextYearPlan || (plan.isNextYearPlan && plan.isPlanRolloverTerminated))\r\n      }\"\r\n    >\r\n      <vnext-star-rating\r\n        *ngIf=\"!planAttributeMap[plan.id]?.isDentalPlan\"\r\n        [starRating]=\"plan.planRating\"\r\n        [ratingValueDescription]=\"plan.planRatingValueDescription\"\r\n        [showLowPerformanceIndicator]=\"plan.isLowPerformingPlan\"\r\n      ></vnext-star-rating>\r\n    </div>\r\n    <div\r\n      #premiumPrice\r\n      class=\"pb-md-3 pb-4 text-center plan-monthly-premium px-2 plan-card-section\"\r\n      [ngClass]=\"{\r\n        'current-plan-card Spa_Style_Accent6_Border': plan.isCurrentYearPlan,\r\n        'next-year-plan-card Spa_Style_Primary_Link_Border': plan.isNextYearPlan && !plan.isPlanRolloverTerminated,\r\n        'plan-card-vertical-border':\r\n          !plan.isCurrentYearPlan && (!plan.isNextYearPlan || (plan.isNextYearPlan && plan.isPlanRolloverTerminated))\r\n      }\"\r\n    >\r\n      <div class=\"Spa_Style_Paragraph Spa_Style_Primary_Color\">{{ planFacade.getPremiumLabel() }}</div>\r\n      <vnext-link\r\n        [title]=\"planCardQuoteLinkText\"\r\n        (click)=\"planFacade.navigateToMedSupForm()\"\r\n        (keyup.enter)=\"planFacade.navigateToMedSupForm()\"\r\n        *ngIf=\"!planAttributeMap[plan.id]?.hasPremium; else showPremium\"\r\n      ></vnext-link>\r\n      <ng-template #showPremium>\r\n        <div *ngIf=\"!planFeesEnabled || !plan.fees?.length; else showPremiumWithFees\" class=\"Spa_Style_CostPremiumSmall\">\r\n          <span *ngIf=\"snpPremiumRangeEnabled && planPremiumInitialRange[plan.id]\">{{planPremiumInitialRange[plan.id]}}</span> {{ planTotalPremium[plan.id] | currency }}\r\n        </div>\r\n\r\n        <ng-template #showPremiumWithFees>\r\n          <vnext-widget-plan-fees-tooltip\r\n            [planFees]=\"plan.fees\"\r\n            [planTotalPremium]=\"planTotalPremium[plan.id]\"\r\n            [planFeesTooltipText]=\"planFeesTooltipText\"\r\n            [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n            [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n            [tooltipPlacement]=\"isFirstPlan ? 'bottom-left' : isLastPlan ? 'bottom-right' : 'bottom-right bottom-left'\"\r\n            [tooltipCustomClass]=\"isFirstPlan || isLastPlan ? 'inline-block-xs-layout inline-block-sm-layout' : ''\"\r\n            [tooltipContainer]=\"!stickyMiniCartEnabled ? 'body' : undefined\"\r\n          ></vnext-widget-plan-fees-tooltip>\r\n        </ng-template>\r\n      </ng-template>\r\n      <div *ngIf=\"planAttributeMap[plan.id]?.isHospitalCarePlan\" class=\"Spa_Style_Note\">\r\n        {{ monthlyPremiumText }}\r\n      </div>\r\n    </div>\r\n    <ng-container *ngIf=\"isRetentionView\">\r\n      <div\r\n        class=\"pb-1 px-2 plan-card-section\"\r\n        [ngClass]=\"{\r\n          'current-plan-card Spa_Style_Accent6_Border': plan.isCurrentYearPlan,\r\n          'next-year-plan-card Spa_Style_Primary_Link_Border': plan.isNextYearPlan && !plan.isPlanRolloverTerminated,\r\n          'plan-card-vertical-border':\r\n            !plan.isCurrentYearPlan && (!plan.isNextYearPlan || (plan.isNextYearPlan && plan.isPlanRolloverTerminated))\r\n        }\"\r\n      >\r\n        <button\r\n          class=\"btn Spa_Style_SecondaryButton btn-block Spa_Style_Small_Font\"\r\n          title=\"{{ planDetailsButton }} {{ plan.planName }}\"\r\n          [attr.role]=\"linkRoles.LINK\"\r\n          [attr.aria-label]=\"planDetailsButton\"\r\n          (click)=\"navigateToPlanDetailsPage(plan)\"\r\n          *ngIf=\"showPlanViewDetails\"\r\n        >\r\n          {{ planDetailsButton }}\r\n        </button>\r\n      </div>\r\n    </ng-container>\r\n    <div\r\n      #actionCompareButton\r\n      class=\"px-2 plan-card-bottom-border plan-card-section pb-2\"\r\n      [ngClass]=\"{\r\n        'current-plan-card Spa_Style_Accent6_Border': plan.isCurrentYearPlan,\r\n        'next-year-plan-card Spa_Style_Primary_Link_Border': plan.isNextYearPlan && !plan.isPlanRolloverTerminated,\r\n        'plan-card-vertical-border':\r\n          !plan.isCurrentYearPlan && (!plan.isNextYearPlan || (plan.isNextYearPlan && plan.isPlanRolloverTerminated))\r\n      }\"\r\n    >\r\n      <div class=\"plan-card-button\">\r\n        <div class=\"row justify-content-center plan-compare-buttons\">\r\n          <div\r\n            *ngIf=\"!isRetentionView && showPlanViewDetails\"\r\n            class=\"col-12 px-1 mt-1\"\r\n            [ngClass]=\"plans.length === 3 ? 'col-md-12' : 'col-md'\"\r\n          >\r\n            <button\r\n              class=\"btn Spa_Style_SecondaryButton btn-block Spa_Style_Small_Font p-md-1\"\r\n              title=\"{{ plan.planName }}: {{ planDetailsButton }}\"\r\n              (click)=\"navigateToPlanDetailsPage(plan)\"\r\n              [attr.aria-label]=\"plan?.planName + ': ' + planDetailsButton\"\r\n              [attr.role]=\"linkRoles.LINK\"\r\n            >\r\n              {{ planDetailsButton }}\r\n            </button>\r\n          </div>\r\n          <div\r\n            *ngIf=\"planAttributeMap[plan.id]?.addToCartButtonEnabled\"\r\n            class=\"plan-card-button-section col-12 mt-1 px-1\"\r\n            [ngClass]=\"plans.length === 3 ? 'col-md-12' : 'col-md'\"\r\n          >\r\n            <vnext-shopping-cart-button *ngIf=\"planAttributeMap[plan.id]?.hasPremium\" [plan]=\"plan\" [isComparePage]=\"true\">\r\n            </vnext-shopping-cart-button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".plan-card-vertical-border{border-color:var(--static-Spa_Style_Accent1);border-right-width:1px;border-right-style:solid}.image-responsive{padding-right:0;max-width:100%;height:36px;text-align:center}.current-plan-card,.next-year-plan-card{border-right-width:2px;border-right-style:solid;border-left-width:2px;border-left-style:solid}.current-plan-card.plan-card-bottom-border,.next-year-plan-card.plan-card-bottom-border{border-bottom-width:2px}.plan-card-column:first-child{border-left-width:1px;border-left-style:solid;border-left-color:var(--static-Spa_Style_Accent1)}.plan-card-column:last-child .plan-card-section:last-child{border-bottom-right-radius:5px}.plan-card .current-plan-card:first-child,.plan-card .next-year-plan-card:first-child{border-top-width:2px;border-top-style:solid}.plan-card-top-border{border-top-width:1px;border-top-style:solid;border-top-color:var(--static-Spa_Style_Accent1)}.current-plan-card.plan-card-top-border:first-child,.next-year-plan-card.plan-card-top-border:first-child{border-top-left-radius:0}.plan-card-column:last-child .plan-card-remove-btn:first-child{border-top-right-radius:5px}.current-plan-text,.next-year-plan-text{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px}.plan-card-column{display:flex;flex-flow:column}.plan-card-section{display:flex;align-items:stretch;flex-direction:column;flex-grow:1}.plan-card-bottom-border{border-bottom-width:1px;border-bottom-style:solid}.plan-card-button-section:empty{display:none}@media (max-width: 991.9px){.plan-card-top-border:last-child{border-top-right-radius:0}.plan-card-bottom-border:last-child{border-bottom-right-radius:0}.plan-card-column:last-child .plan-card-section:last-child,.plan-card-column:last-child .plan-card-remove-btn:first-child{border-radius:0}.plan-card{margin-right:-10px}.plan-card-column:first-child{border-left-width:0}.plan-card-column:last-child div{border-right-width:0}.plan-compare-buttons{margin-bottom:30px}}@media print{.plan-card-column:first-child{border-left-width:1px}.plan-card-column:last-child div{border-right-width:1px}}.plan-card-button{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width: 992px){.plan-compare-buttons{align-items:flex-end}}@media (max-width: 1200px){.plan-card-button{padding-left:15px;padding-right:15px}}.medicare-badge,.hip-badge{bottom:100%;left:0;font-size:14px;position:absolute;border-top-left-radius:3px;border-top-right-radius:3px;font-family:montserrat_semibold;padding:2px 12px}.plan-card-remove-btn{padding-top:12px;padding-right:12px;line-height:0}.mapd-badge-small{max-width:200px}.mapd-badge-extra-small{max-width:180px}\n"] }]
    }], function () { return [{ type: PlanFacade }, { type: i0.Renderer2 }, { type: i1$1.NgbModal }, { type: i0.ChangeDetectorRef }]; }, { starRatings: [{
            type: ViewChildren,
            args: ['starRating']
        }], planLogos: [{
            type: ViewChildren,
            args: ['planLogo']
        }], planNames: [{
            type: ViewChildren,
            args: ['planName']
        }], premiumPrices: [{
            type: ViewChildren,
            args: ['premiumPrice']
        }], actionCompareButtons: [{
            type: ViewChildren,
            args: ['actionCompareButton']
        }], plans: [{
            type: Input
        }], planDetailsButton: [{
            type: Input
        }], isRetentionView: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], isMedium: [{
            type: Input
        }], locale: [{
            type: Input
        }], currentPlanText: [{
            type: Input
        }], nextYearPlanText: [{
            type: Input
        }], isCurrentYearPlanExist: [{
            type: Input
        }], planCardQuoteLinkText: [{
            type: Input
        }], showLogo: [{
            type: Input
        }], showPlanViewDetails: [{
            type: Input
        }], removePlanText: [{
            type: Input
        }], hospitalIndemnityBadgeText: [{
            type: Input
        }], monthlyPremiumText: [{
            type: Input
        }], planRidersMap: [{
            type: Input
        }], planTypes: [{
            type: Input
        }], activeTabType: [{
            type: Input
        }], medicareTypes: [{
            type: Input
        }], planLogoSize: [{
            type: Input
        }], isAncillaryAddToCartEnabled: [{
            type: Input
        }], stickyMiniCartEnabled: [{
            type: Input
        }], planFeesEnabled: [{
            type: Input
        }], planFeesTooltipText: [{
            type: Input
        }], planFeesIncludedInPremiumTooltipText: [{
            type: Input
        }], removeModalHeaderText: [{
            type: Input
        }], removeModalIntroText: [{
            type: Input
        }], removeModalCancelText: [{
            type: Input
        }], removeModalButtonText: [{
            type: Input
        }], planFeesNotIncludedInPremiumTooltipText: [{
            type: Input
        }], snpPremiumRangeEnabled: [{
            type: Input
        }], showRemovePlanButtonForMobile: [{
            type: Input
        }], viewPlanDetailsPage: [{
            type: Output
        }], removePlanFromCompare: [{
            type: Output
        }] }); })();

function PlanComparePanelComponent_div_0_h3_2_i_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 9);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("fas icon ", ctx_r4.iconClass, "");
} }
function PlanComparePanelComponent_div_0_h3_2_vnext_tooltip_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-tooltip", 10);
    i0.ɵɵelement(1, "i", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("body", ctx_r5.tooltipContent)("Spa_Site_Tooltip_Text", ctx_r5.Spa_Site_Tooltip_Text)("ariaLabel", ctx_r5.tooltipAriaLabel);
} }
function PlanComparePanelComponent_div_0_h3_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 6);
    i0.ɵɵtemplate(1, PlanComparePanelComponent_div_0_h3_2_i_1_Template, 1, 3, "i", 7);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, PlanComparePanelComponent_div_0_h3_2_vnext_tooltip_3_Template, 2, 3, "vnext-tooltip", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r2.isPreferencesSection ? "Spa_Style_H3" : "Spa_Style_H2");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.iconClass);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.subSectionHeader, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isTooltipExist && ctx_r2.tooltipContent);
} }
function PlanComparePanelComponent_div_0_vnext_link_3_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 12);
    i0.ɵɵlistener("keyup.enter", function PlanComparePanelComponent_div_0_vnext_link_3_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r6.onClick(ctx_r6.tag)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tag", ctx_r3.tag)("keyNameForLiveEdit", ctx_r3.linkPropertyName)("title", ctx_r3.linkTitle)("alwaysUnderlined", true)("linkTarget", "_self")("additionalIcon", ctx_r3.additionalIcon)("makeInlineBlock", true)("ariaLabel", ctx_r3.linkTitle)("onClickAction", ctx_r3.onClick(ctx_r3.tag));
} }
const _c0$U = function (a0) { return { "preferences-header": a0 }; };
function PlanComparePanelComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtemplate(2, PlanComparePanelComponent_div_0_h3_2_Template, 4, 4, "h3", 4);
    i0.ɵɵtemplate(3, PlanComparePanelComponent_div_0_vnext_link_3_Template, 1, 9, "vnext-link", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$U, ctx_r0.isPreferencesSection));
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-colspan", ctx_r0.plans.length + 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", ctx_r0.headerPropertyName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.linkTitle && ctx_r0.isProvidersEnabled);
} }
function PlanComparePanelComponent_div_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r10.offScreenHighLightLabelText);
} }
function PlanComparePanelComponent_div_1_div_1_i_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 9);
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMapInterpolate1("", ctx_r11.panelContentIconClass, " icon");
} }
function PlanComparePanelComponent_div_1_div_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r12.panelLeftSectionContent);
} }
function PlanComparePanelComponent_div_1_div_1_vnext_tooltip_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-tooltip", 23);
    i0.ɵɵelement(1, "i", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("body", ctx_r13.panelContentTooltip)("Spa_Site_Tooltip_Text", ctx_r13.Spa_Site_Tooltip_Text)("ariaLabel", ctx_r13.tooltipAriaLabel)("customClass", "focus-circle");
} }
function PlanComparePanelComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, PlanComparePanelComponent_div_1_div_1_div_1_Template, 2, 1, "div", 17);
    i0.ɵɵelementStart(2, "div", 18);
    i0.ɵɵtemplate(3, PlanComparePanelComponent_div_1_div_1_i_3_Template, 1, 3, "i", 7);
    i0.ɵɵtemplate(4, PlanComparePanelComponent_div_1_div_1_span_4_Template, 2, 1, "span", 19);
    i0.ɵɵtemplate(5, PlanComparePanelComponent_div_1_div_1_vnext_tooltip_5_Template, 2, 4, "vnext-tooltip", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵprojection(6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.isHighLighted);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("plan-compare-left-section plan-compare-section-height Spa_Style_Primary_Color ", ctx_r8.customClass, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.panelContentIconClass && ctx_r8.showPanelContentIcon);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", ctx_r8.isPanelLeftSectionLiveEditable ? ctx_r8.panelLeftSectionLiveEditTag : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.isPanelContentTooltipExist && ctx_r8.panelContentTooltip);
} }
function PlanComparePanelComponent_div_1_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r14.offScreenHighLightLabelText);
} }
function PlanComparePanelComponent_div_1_div_2_span_3_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r20.healthCostText);
} }
function PlanComparePanelComponent_div_1_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, PlanComparePanelComponent_div_1_div_2_span_3_span_1_Template, 2, 1, "span", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_PlanDetails_Health_Cost_Text");
} }
function PlanComparePanelComponent_div_1_div_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "span", 32);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r16.panelLeftCostDetails.label);
} }
function PlanComparePanelComponent_div_1_div_2_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r17.panelLeftSectionContent);
} }
function PlanComparePanelComponent_div_1_div_2_div_6_span_3_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 36)(1, "vnext-link", 37);
    i0.ɵɵlistener("click", function PlanComparePanelComponent_div_1_div_2_div_6_span_3_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r22.navigateByPageTag(ctx_r22.panelLeftCostDetails.title)); })("keyup.enter", function PlanComparePanelComponent_div_1_div_2_div_6_span_3_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r23); const ctx_r24 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r24.navigateByPageTag(ctx_r24.panelLeftCostDetails.title)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r21.costAddEditLinkText)("makeInlineBlock", true)("alwaysUnderlined", true)("linkTarget", "_self")("customClass", "Spa_Style_Link Spa_Style_Smaller_Font")("ariaLabel", ctx_r21.getAriaLabelValue(ctx_r21.panelLeftCostDetails.title))("role", ctx_r21.linkRoles.LINK);
} }
function PlanComparePanelComponent_div_1_div_2_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33)(1, "span", 34);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PlanComparePanelComponent_div_1_div_2_div_6_span_3_Template, 2, 7, "span", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r18.getCostSubText(ctx_r18.panelLeftCostDetails));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r18.panelLeftCostDetails == null ? null : ctx_r18.panelLeftCostDetails.title) === ctx_r18.planDetailsCostLabels.DRUG_COST || (ctx_r18.panelLeftCostDetails == null ? null : ctx_r18.panelLeftCostDetails.title) === ctx_r18.planDetailsCostLabels.HEALTH_COST && ctx_r18.healthEnabled && ctx_r18.isHealthCostEstimated);
} }
function PlanComparePanelComponent_div_1_div_2_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" (", ctx_r19.effectiveDateText, ") ");
} }
function PlanComparePanelComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, PlanComparePanelComponent_div_1_div_2_div_1_Template, 2, 1, "div", 17);
    i0.ɵɵelementStart(2, "div", 26);
    i0.ɵɵtemplate(3, PlanComparePanelComponent_div_1_div_2_span_3_Template, 2, 1, "span", 27);
    i0.ɵɵtemplate(4, PlanComparePanelComponent_div_1_div_2_span_4_Template, 3, 1, "span", 27);
    i0.ɵɵtemplate(5, PlanComparePanelComponent_div_1_div_2_span_5_Template, 2, 1, "span", 28);
    i0.ɵɵtemplate(6, PlanComparePanelComponent_div_1_div_2_div_6_Template, 4, 2, "div", 29);
    i0.ɵɵtemplate(7, PlanComparePanelComponent_div_1_div_2_div_7_Template, 2, 1, "div", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵprojection(8, 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.isHighLighted);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("plan-compare-left-section plan-compare-section-height Spa_Style_Primary_Color ", ctx_r9.customClass, "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r9.panelLeftCostDetails == null ? null : ctx_r9.panelLeftCostDetails.title) === ctx_r9.planDetailsCostLabels.HEALTH_COST);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r9.panelLeftCostDetails == null ? null : ctx_r9.panelLeftCostDetails.title) === ctx_r9.planDetailsCostLabels.PLAN_FEES);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r9.panelLeftCostDetails == null ? null : ctx_r9.panelLeftCostDetails.title) !== ctx_r9.planDetailsCostLabels.HEALTH_COST && (ctx_r9.panelLeftCostDetails == null ? null : ctx_r9.panelLeftCostDetails.title) !== ctx_r9.planDetailsCostLabels.PLAN_FEES);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r9.panelLeftCostDetails == null ? null : ctx_r9.panelLeftCostDetails.title) !== ctx_r9.planDetailsCostLabels.PREMIUM);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.isEffectiveDateTextVisible);
} }
function PlanComparePanelComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, PlanComparePanelComponent_div_1_div_1_Template, 7, 7, "div", 14);
    i0.ɵɵtemplate(2, PlanComparePanelComponent_div_1_div_2_Template, 9, 9, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.isSubTextExist);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.isSubTextExist);
} }
const _c1$h = ["*", [["", "costSection", ""]]];
const _c2$b = ["*", "[costSection]"];
class PlanComparePanelComponent {
    constructor(planFacade, analyticsService, navigationService) {
        this.planFacade = planFacade;
        this.analyticsService = analyticsService;
        this.navigationService = navigationService;
        this.planDetailsCostLabels = PlanDetailsCostLabels;
        this.linkRoles = LinkRoles;
    }
    ngOnInit() {
        this.isHealthCostEstimated = this.planFacade.isHealthCostEstimated();
    }
    ngOnChanges(changes) {
        const { showEffectiveDateText, panelLeftCostDetails, effectiveDateText } = changes;
        if (showEffectiveDateText?.currentValue !== showEffectiveDateText?.previousValue ||
            effectiveDateText?.currentValue !== effectiveDateText?.previousValue ||
            !_isEqual(panelLeftCostDetails?.currentValue, panelLeftCostDetails?.previousValue)) {
            this.isEffectiveDateTextVisible =
                this.showEffectiveDateText &&
                    this.panelLeftCostDetails?.title === PlanDetailsCostLabels.TOTAL_ESTIMATED_COST &&
                    !!this.effectiveDateText;
        }
    }
    navigateByPageTag(label) {
        const pageTag = this.planFacade.getPageTag(label);
        this.getAnalyticsEvent(pageTag);
        this.navigationService.navigateByPageTag(pageTag);
    }
    getCostSubText(planCostDetails) {
        return this.planFacade.getCostSubText(planCostDetails, this.plans[0], this.selectedPharmacy);
    }
    getAriaLabelValue(title) {
        return title === PlanDetailsCostLabels.DRUG_COST
            ? this.drugCostAddEditLinkDescription
            : title === PlanDetailsCostLabels.HEALTH_COST && this.healthEnabled
                ? this.healthCostAddEditLinkDescription
                : '';
    }
    onClick(pageTag) {
        return () => {
            this.getAnalyticsEvent(pageTag);
        };
    }
    getAnalyticsEvent(pageTag) {
        if (pageTag === PageTags.GUIDED_HELP_PRESCRIPTIONS) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_DRUGS);
        }
        else if (pageTag === PageTags.GUIDED_HELP_PHARMACY_SEARCH) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_PHARMACY);
        }
        else if (pageTag === PageTags.GUIDED_HELP_PROVIDER_SEARCH) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_PROVIDER);
        }
        else if (pageTag === PageTags.GUIDED_HELP_HEALTH) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_ADD_OR_EDIT_HEALTH);
        }
    }
}
PlanComparePanelComponent.ɵfac = function PlanComparePanelComponent_Factory(t) { return new (t || PlanComparePanelComponent)(i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.NavigationService)); };
PlanComparePanelComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanComparePanelComponent, selectors: [["vnext-widget-plan-compare-panel"]], inputs: { isProvidersEnabled: "isProvidersEnabled", headerPropertyName: "headerPropertyName", isSubSectionHeaderExist: "isSubSectionHeaderExist", subSectionHeader: "subSectionHeader", tooltipContent: "tooltipContent", isTooltipExist: "isTooltipExist", isPanelContentExist: "isPanelContentExist", panelLeftSectionContent: "panelLeftSectionContent", customClass: "customClass", tag: "tag", linkPropertyName: "linkPropertyName", linkTitle: "linkTitle", iconClass: "iconClass", isPreferencesSection: "isPreferencesSection", additionalIcon: "additionalIcon", panelContentTooltip: "panelContentTooltip", isPanelContentTooltipExist: "isPanelContentTooltipExist", panelLeftCostDetails: "panelLeftCostDetails", healthEnabled: "healthEnabled", costAddEditLinkText: "costAddEditLinkText", plans: "plans", isSubTextExist: "isSubTextExist", panelContentIconClass: "panelContentIconClass", showPanelContentIcon: "showPanelContentIcon", drugCostAddEditLinkDescription: "drugCostAddEditLinkDescription", healthCostAddEditLinkDescription: "healthCostAddEditLinkDescription", addEditLinkDescription: "addEditLinkDescription", isPanelLeftSectionLiveEditable: "isPanelLeftSectionLiveEditable", panelLeftSectionLiveEditTag: "panelLeftSectionLiveEditTag", healthCostText: "healthCostText", isHighLighted: "isHighLighted", offScreenHighLightLabelText: "offScreenHighLightLabelText", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text", selectedPharmacy: "selectedPharmacy", showEffectiveDateText: "showEffectiveDateText", effectiveDateText: "effectiveDateText", tooltipAriaLabel: "tooltipAriaLabel" }, features: [i0.ɵɵNgOnChangesFeature], ngContentSelectors: _c2$b, decls: 2, vars: 2, consts: [["class", "gray2-static benefit-section-header d-flex justify-content-between", "role", "row", 3, "ngClass", 4, "ngIf"], ["class", "container-fluid plan-compare-details-section", 4, "ngIf"], ["role", "row", 1, "gray2-static", "benefit-section-header", "d-flex", "justify-content-between", 3, "ngClass"], ["role", "cell"], ["class", "m-0 text-center text-lg-left", 3, "ngClass", 4, "liveEditProp"], ["class", "link", 3, "tag", "keyNameForLiveEdit", "title", "alwaysUnderlined", "linkTarget", "additionalIcon", "makeInlineBlock", "ariaLabel", "onClickAction", "keyup.enter", 4, "ngIf"], [1, "m-0", "text-center", "text-lg-left", 3, "ngClass"], ["aria-hidden", "true", 3, "class", 4, "ngIf"], [3, "body", "Spa_Site_Tooltip_Text", "ariaLabel", 4, "ngIf"], ["aria-hidden", "true"], [3, "body", "Spa_Site_Tooltip_Text", "ariaLabel"], ["aria-hidden", "true", 1, "fas", "fa-question-circle", "icon-tooltip"], [1, "link", 3, "tag", "keyNameForLiveEdit", "title", "alwaysUnderlined", "linkTarget", "additionalIcon", "makeInlineBlock", "ariaLabel", "onClickAction", "keyup.enter"], [1, "container-fluid", "plan-compare-details-section"], ["class", "row", "role", "row", "id", "plan-compare-panel-section", 4, "ngIf"], ["class", "row", "role", "row", 4, "ngIf"], ["role", "row", "id", "plan-compare-panel-section", 1, "row"], ["class", "sr-only", 4, "ngIf"], ["role", "rowheader"], ["id", "plan-compare-details", 4, "liveEditProp"], [3, "body", "Spa_Site_Tooltip_Text", "ariaLabel", "customClass", 4, "ngIf"], [1, "sr-only"], ["id", "plan-compare-details"], [3, "body", "Spa_Site_Tooltip_Text", "ariaLabel", "customClass"], ["aria-hidden", "true", 1, "fas", "Spa_Style_QuestionIcon"], ["role", "row", 1, "row"], ["role", "rowheader", "id", "plan-compare-cost-section"], [4, "ngIf"], ["class", "Spa_Style_Primary_Color", 4, "ngIf"], ["class", "Spa_Style_Smaller_Font pt-1", 4, "ngIf"], ["class", "Spa_Style_Smaller_Font Spa_Style_Gray4_Color d-inline mr-1", 4, "ngIf"], ["class", "Spa_Style_Primary_Color", 4, "liveEditProp"], [1, "Spa_Style_Primary_Color"], [1, "Spa_Style_Smaller_Font", "pt-1"], [1, "Spa_Style_Gray4_Color", "d-inline", "mr-1"], ["class", "d-inline-block", 4, "ngIf"], [1, "d-inline-block"], [3, "title", "makeInlineBlock", "alwaysUnderlined", "linkTarget", "customClass", "ariaLabel", "role", "click", "keyup.enter"], [1, "Spa_Style_Smaller_Font", "Spa_Style_Gray4_Color", "d-inline", "mr-1"]], template: function PlanComparePanelComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c1$h);
        i0.ɵɵtemplate(0, PlanComparePanelComponent_div_0_Template, 4, 6, "div", 0);
        i0.ɵɵtemplate(1, PlanComparePanelComponent_div_1_Template, 3, 2, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.isSubSectionHeaderExist);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isPanelContentExist);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, LinkComponent, TooltipComponent, LiveEditPropDirective, IconAriaAttributesDirective], styles: [".gray1-static[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray1)}.gray2-static[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray2)}.benefit-section-header[_ngcontent-%COMP%]{padding:7px 12px;border-bottom:1px solid var(--static-Spa_Style_Accent1)}.icon-tooltip[_ngcontent-%COMP%]{font-size:18px}.plan-compare-left-section[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);padding:10px 14px}.plan-compare-section-height[_ngcontent-%COMP%]{min-height:70px}.preferences-header[_ngcontent-%COMP%]{height:84px;padding:30px 12px}.icon[_ngcontent-%COMP%]{font-size:18px;width:20px}@media (max-width: 991.9px){.plan-compare-left-section[_ngcontent-%COMP%]{border-right-width:0px;border-bottom:none;text-align:center}.plan-compare-details-section[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Accent1)}.plan-compare-section-height[_ngcontent-%COMP%]{min-height:auto}}@media (max-width: 576px){.link[_ngcontent-%COMP%]{width:174px}}@media print{.plan-compare-left-section[_ngcontent-%COMP%]{border-right-width:1px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanComparePanelComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-compare-panel', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  class=\"gray2-static benefit-section-header d-flex justify-content-between\"\r\n  [ngClass]=\"{ 'preferences-header': isPreferencesSection }\"\r\n  *ngIf=\"isSubSectionHeaderExist\"\r\n  role=\"row\"\r\n>\r\n  <div role=\"cell\" [attr.aria-colspan]=\"plans.length + 1\">\r\n    <h3\r\n      class=\"m-0 text-center text-lg-left\"\r\n      *liveEditProp=\"headerPropertyName\"\r\n      [ngClass]=\"isPreferencesSection ? 'Spa_Style_H3' : 'Spa_Style_H2'\"\r\n    >\r\n      <i *ngIf=\"iconClass\" class=\"fas icon {{ iconClass }}\" aria-hidden=\"true\"></i>\r\n      {{ subSectionHeader }}\r\n      <vnext-tooltip\r\n        [body]=\"tooltipContent\"\r\n        [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n        [ariaLabel]=\"tooltipAriaLabel\"\r\n        *ngIf=\"isTooltipExist && tooltipContent\"\r\n      >\r\n        <i class=\"fas fa-question-circle icon-tooltip\" aria-hidden=\"true\"></i>\r\n      </vnext-tooltip>\r\n    </h3>\r\n    <vnext-link\r\n      *ngIf=\"linkTitle && isProvidersEnabled\"\r\n      [tag]=\"tag\"\r\n      [keyNameForLiveEdit]=\"linkPropertyName\"\r\n      [title]=\"linkTitle\"\r\n      [alwaysUnderlined]=\"true\"\r\n      [linkTarget]=\"'_self'\"\r\n      [additionalIcon]=\"additionalIcon\"\r\n      class=\"link\"\r\n      [makeInlineBlock]=\"true\"\r\n      [ariaLabel]=\"linkTitle\"\r\n      [onClickAction]=\"onClick(tag)\"\r\n      (keyup.enter)=\"onClick(tag)\"\r\n    >\r\n    </vnext-link>\r\n  </div>\r\n</div>\r\n<div class=\"container-fluid plan-compare-details-section\" *ngIf=\"isPanelContentExist\">\r\n  <div class=\"row\" *ngIf=\"!isSubTextExist\" role=\"row\" id=\"plan-compare-panel-section\">\r\n    <div *ngIf=\"isHighLighted\" class=\"sr-only\">{{ offScreenHighLightLabelText }}</div>\r\n    <div role=\"rowheader\" class=\"plan-compare-left-section plan-compare-section-height Spa_Style_Primary_Color {{ customClass }}\">\r\n      <i class=\"{{ panelContentIconClass }} icon\" *ngIf=\"panelContentIconClass && showPanelContentIcon\" aria-hidden=\"true\"></i>\r\n      <span id=\"plan-compare-details\" *liveEditProp=\"isPanelLeftSectionLiveEditable ? panelLeftSectionLiveEditTag : ''\">{{\r\n        panelLeftSectionContent\r\n      }}</span>\r\n      <vnext-tooltip\r\n        [body]=\"panelContentTooltip\"\r\n        [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n        [ariaLabel]=\"tooltipAriaLabel\"\r\n        [customClass]=\"'focus-circle'\"\r\n        *ngIf=\"isPanelContentTooltipExist && panelContentTooltip\"\r\n      >\r\n        <i class=\"fas Spa_Style_QuestionIcon\" aria-hidden=\"true\"></i>\r\n      </vnext-tooltip>\r\n    </div>\r\n    <ng-content></ng-content>\r\n  </div>\r\n  <div class=\"row\" *ngIf=\"isSubTextExist\" role=\"row\">\r\n    <div *ngIf=\"isHighLighted\" class=\"sr-only\">{{ offScreenHighLightLabelText }}</div>\r\n    <div\r\n      role=\"rowheader\"\r\n      id=\"plan-compare-cost-section\"\r\n      class=\"plan-compare-left-section plan-compare-section-height Spa_Style_Primary_Color {{ customClass }}\"\r\n    >\r\n      <span *ngIf=\"panelLeftCostDetails?.title === planDetailsCostLabels.HEALTH_COST\">\r\n        <span class=\"Spa_Style_Primary_Color\" *liveEditProp=\"'Spa_PlanDetails_Health_Cost_Text'\">{{ healthCostText }}</span>\r\n      </span>\r\n      <span *ngIf=\"panelLeftCostDetails?.title === planDetailsCostLabels.PLAN_FEES\">\r\n        <span class=\"Spa_Style_Primary_Color\">{{ panelLeftCostDetails.label }}</span>\r\n      </span>\r\n      <span\r\n        *ngIf=\"\r\n          panelLeftCostDetails?.title !== planDetailsCostLabels.HEALTH_COST &&\r\n          panelLeftCostDetails?.title !== planDetailsCostLabels.PLAN_FEES\r\n        \"\r\n        class=\"Spa_Style_Primary_Color\"\r\n        >{{ panelLeftSectionContent }}</span\r\n      >\r\n      <div *ngIf=\"panelLeftCostDetails?.title !== planDetailsCostLabels.PREMIUM\" class=\"Spa_Style_Smaller_Font pt-1\">\r\n        <span class=\"Spa_Style_Gray4_Color d-inline mr-1\">{{ getCostSubText(panelLeftCostDetails) }}</span>\r\n        <span\r\n          class=\"d-inline-block\"\r\n          *ngIf=\"\r\n            panelLeftCostDetails?.title === planDetailsCostLabels.DRUG_COST ||\r\n            (panelLeftCostDetails?.title === planDetailsCostLabels.HEALTH_COST && healthEnabled && isHealthCostEstimated)\r\n          \"\r\n        >\r\n          <vnext-link\r\n            [title]=\"costAddEditLinkText\"\r\n            [makeInlineBlock]=\"true\"\r\n            [alwaysUnderlined]=\"true\"\r\n            [linkTarget]=\"'_self'\"\r\n            [customClass]=\"'Spa_Style_Link Spa_Style_Smaller_Font'\"\r\n            (click)=\"navigateByPageTag(panelLeftCostDetails.title)\"\r\n            (keyup.enter)=\"navigateByPageTag(panelLeftCostDetails.title)\"\r\n            [ariaLabel]=\"getAriaLabelValue(panelLeftCostDetails.title)\"\r\n            [role]=\"linkRoles.LINK\"\r\n          >\r\n          </vnext-link>\r\n        </span>\r\n      </div>\r\n      <div *ngIf=\"isEffectiveDateTextVisible\" class=\"Spa_Style_Smaller_Font Spa_Style_Gray4_Color d-inline mr-1\">\r\n        ({{ effectiveDateText }})\r\n      </div>\r\n    </div>\r\n    <ng-content select=\"[costSection]\"></ng-content>\r\n  </div>\r\n</div>\r\n", styles: [".gray1-static{background-color:var(--static-Spa_Style_Gray1)}.gray2-static{background-color:var(--static-Spa_Style_Gray2)}.benefit-section-header{padding:7px 12px;border-bottom:1px solid var(--static-Spa_Style_Accent1)}.icon-tooltip{font-size:18px}.plan-compare-left-section{border-right:1px solid var(--static-Spa_Style_Accent1);padding:10px 14px}.plan-compare-section-height{min-height:70px}.preferences-header{height:84px;padding:30px 12px}.icon{font-size:18px;width:20px}@media (max-width: 991.9px){.plan-compare-left-section{border-right-width:0px;border-bottom:none;text-align:center}.plan-compare-details-section{border-bottom:1px solid var(--static-Spa_Style_Accent1)}.plan-compare-section-height{min-height:auto}}@media (max-width: 576px){.link{width:174px}}@media print{.plan-compare-left-section{border-right-width:1px}}\n"] }]
    }], function () { return [{ type: PlanFacade }, { type: AnalyticsService }, { type: i1.NavigationService }]; }, { isProvidersEnabled: [{
            type: Input
        }], headerPropertyName: [{
            type: Input
        }], isSubSectionHeaderExist: [{
            type: Input
        }], subSectionHeader: [{
            type: Input
        }], tooltipContent: [{
            type: Input
        }], isTooltipExist: [{
            type: Input
        }], isPanelContentExist: [{
            type: Input
        }], panelLeftSectionContent: [{
            type: Input
        }], customClass: [{
            type: Input
        }], tag: [{
            type: Input
        }], linkPropertyName: [{
            type: Input
        }], linkTitle: [{
            type: Input
        }], iconClass: [{
            type: Input
        }], isPreferencesSection: [{
            type: Input
        }], additionalIcon: [{
            type: Input
        }], panelContentTooltip: [{
            type: Input
        }], isPanelContentTooltipExist: [{
            type: Input
        }], panelLeftCostDetails: [{
            type: Input
        }], healthEnabled: [{
            type: Input
        }], costAddEditLinkText: [{
            type: Input
        }], plans: [{
            type: Input
        }], isSubTextExist: [{
            type: Input
        }], panelContentIconClass: [{
            type: Input
        }], showPanelContentIcon: [{
            type: Input
        }], drugCostAddEditLinkDescription: [{
            type: Input
        }], healthCostAddEditLinkDescription: [{
            type: Input
        }], addEditLinkDescription: [{
            type: Input
        }], isPanelLeftSectionLiveEditable: [{
            type: Input
        }], panelLeftSectionLiveEditTag: [{
            type: Input
        }], healthCostText: [{
            type: Input
        }], isHighLighted: [{
            type: Input
        }], offScreenHighLightLabelText: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], showEffectiveDateText: [{
            type: Input
        }], effectiveDateText: [{
            type: Input
        }], tooltipAriaLabel: [{
            type: Input
        }] }); })();

function PlanCompareMedicalBenefitsComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "div")(3, "span", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const plan_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", ctx_r2.getMedicalBenefitHighlightStyles(ctx_r2.plans, ctx_r2.medicalDeductibleTitle))("ngClass", ctx_r2.customClassBenefitValue);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-colindex", i_r5 + 1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(plan_r4.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getMedicalBenefitValue(plan_r4, ctx_r2.notAvailableText, ctx_r2.medicalDeductibleTitle), " ");
} }
function PlanCompareMedicalBenefitsComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "div")(3, "span", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const plan_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", ctx_r3.getMedicalBenefitHighlightStyles(ctx_r3.plans, ctx_r3.medicalMaxOutOfPocketTitle))("ngClass", ctx_r3.customClassBenefitValue);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-colindex", i_r7 + 1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(plan_r6.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.getMedicalBenefitValue(plan_r6, ctx_r3.notAvailableText, ctx_r3.medicalMaxOutOfPocketTitle), " ");
} }
function PlanCompareMedicalBenefitsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 2)(2, "vnext-widget-plan-compare-panel", 3);
    i0.ɵɵtemplate(3, PlanCompareMedicalBenefitsComponent_div_0_div_3_Template, 6, 5, "div", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 2)(5, "vnext-widget-plan-compare-panel", 3);
    i0.ɵɵtemplate(6, PlanCompareMedicalBenefitsComponent_div_0_div_6_Template, 6, 5, "div", 4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("panelContentTooltip", ctx_r0.medicalDeductibleToolTipContent)("isPanelContentTooltipExist", ctx_r0.medicalDeductibleIsTooltipExist)("isSubSectionHeaderExist", ctx_r0.medicalDeductibleIsSubSectionHeaderExist)("isPanelContentExist", ctx_r0.medicalDeductibleIsContentExist)("panelLeftSectionContent", ctx_r0.medicalDeductibleLeftSectionContent)("customClass", ctx_r0.customClass)("isHighLighted", ctx_r0.getMedicalBenefitHighlightStyles(ctx_r0.plans, ctx_r0.medicalDeductibleTitle))("offScreenHighLightLabelText", ctx_r0.planCompareHighLightOffScreenText)("Spa_Site_Tooltip_Text", ctx_r0.Spa_Site_Tooltip_Text)("tooltipAriaLabel", ctx_r0.medicalCoverageAriaLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.plans);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("panelContentTooltip", ctx_r0.medicalMaxOutOfPocketToolTipContent)("isPanelContentTooltipExist", ctx_r0.medicalMaxOutOfPocketIsTooltipExist)("isSubSectionHeaderExist", ctx_r0.medicalMaxOutOfPocketIsSubSectionHeaderExist)("isPanelContentExist", ctx_r0.medicalMaxOutOfPocketIsContentExist)("panelLeftSectionContent", ctx_r0.medicalMaxOutOfPocketLeftSectionContent)("customClass", ctx_r0.customClass)("isHighLighted", ctx_r0.getMedicalBenefitHighlightStyles(ctx_r0.plans, ctx_r0.medicalMaxOutOfPocketTitle))("offScreenHighLightLabelText", ctx_r0.planCompareHighLightOffScreenText)("Spa_Site_Tooltip_Text", ctx_r0.Spa_Site_Tooltip_Text)("tooltipAriaLabel", ctx_r0.medicalCoverageAriaLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.plans);
} }
const _c0$T = function (a0) { return { benefit: a0 }; };
function PlanCompareMedicalBenefitsComponent_div_1_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 9)(2, "div")(3, "span", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "div", 10);
    i0.ɵɵpipe(6, "safe");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const plan_r11 = ctx.$implicit;
    const i_r12 = ctx.index;
    const benefit_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", ctx_r10.getPlanCompareStyles(ctx_r10.plans, i0.ɵɵpureFunction1(8, _c0$T, benefit_r8)))("ngClass", ctx_r10.customClassBenefitValue);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-colindex", i_r12 + 1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(plan_r11.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(6, 5, ctx_r10.getBenefitValue(plan_r11, ctx_r10.notAvailableText, benefit_r8), "html"), i0.ɵɵsanitizeHtml);
} }
function PlanCompareMedicalBenefitsComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "vnext-widget-plan-compare-panel", 3);
    i0.ɵɵtemplate(2, PlanCompareMedicalBenefitsComponent_div_1_div_1_div_2_Template, 7, 10, "div", 4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const benefit_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("panelContentTooltip", benefit_r8.tooltipContent)("isPanelContentTooltipExist", benefit_r8.showTooltip)("isSubSectionHeaderExist", false)("isPanelContentExist", true)("panelLeftSectionContent", benefit_r8.detail)("customClass", ctx_r9.customClass)("isHighLighted", ctx_r9.getPlanCompareStyles(ctx_r9.plans, i0.ɵɵpureFunction1(11, _c0$T, benefit_r8)))("offScreenHighLightLabelText", ctx_r9.planCompareHighLightOffScreenText)("Spa_Site_Tooltip_Text", ctx_r9.Spa_Site_Tooltip_Text)("tooltipAriaLabel", ctx_r9.medicalCoverageAriaLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r9.plans);
} }
function PlanCompareMedicalBenefitsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PlanCompareMedicalBenefitsComponent_div_1_div_1_Template, 3, 13, "div", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const benefit_r8 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.showBenefitValues(ctx_r1.plans, benefit_r8));
} }
class PlanCompareMedicalBenefitsComponent {
    constructor(planCompareFacade) {
        this.planCompareFacade = planCompareFacade;
        this.planCompareLabels = PlanCompareLabels;
        this.planType = PlanType;
    }
    getPlanCompareStyles(plans, options) {
        return this.planCompareFacade.getPlanCompareStyles(plans, this.notAvailableText, this.siteShowDifferencesChecked, this.planComparePlanDifferencesColor, this.planComparePlanDifferencesBorder, options);
    }
    getMedicalBenefitValue(plan, notAvailableText, title) {
        return this.planCompareFacade.getMedicalBenefitValue(plan, notAvailableText, title);
    }
    getBenefitValue(plan, notAvailableText, compareBenefit) {
        return this.planCompareFacade.getBenefitValue(plan, notAvailableText, compareBenefit);
    }
    getBenefitsBasedOnPlanType(plan, planCompareBenefitValuesMAPD, planCompareBenefitValuesMA, planCompareBenefitValuesMEDIGAP) {
        return this.planCompareFacade.getBenefitsBasedOnPlanType(plan, planCompareBenefitValuesMAPD, planCompareBenefitValuesMA, planCompareBenefitValuesMEDIGAP);
    }
    showBenefitValues(plan, compareBenefit) {
        return this.planCompareFacade.showBenefitValues(plan, compareBenefit);
    }
    benefitTrackByFn(index, item) {
        return item.benefitID;
    }
    getMedicalBenefitHighlightStyles(plans, benefitsTitle) {
        return this.planCompareFacade.getMedicalBenefitHighlightStyles(plans, this.notAvailableText, this.siteShowDifferencesChecked, this.planComparePlanDifferencesColor, this.planComparePlanDifferencesBorder, benefitsTitle);
    }
}
PlanCompareMedicalBenefitsComponent.ɵfac = function PlanCompareMedicalBenefitsComponent_Factory(t) { return new (t || PlanCompareMedicalBenefitsComponent)(i0.ɵɵdirectiveInject(PlanCompareFacade)); };
PlanCompareMedicalBenefitsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCompareMedicalBenefitsComponent, selectors: [["vnext-widget-plan-compare-medical-benefits"]], inputs: { medicalDeductibleToolTipContent: "medicalDeductibleToolTipContent", medicalDeductibleIsTooltipExist: "medicalDeductibleIsTooltipExist", medicalDeductibleIsSubSectionHeaderExist: "medicalDeductibleIsSubSectionHeaderExist", medicalDeductibleIsContentExist: "medicalDeductibleIsContentExist", medicalDeductibleLeftSectionContent: "medicalDeductibleLeftSectionContent", customClass: "customClass", plans: "plans", customClassBenefitValue: "customClassBenefitValue", notAvailableText: "notAvailableText", medicalDeductibleTitle: "medicalDeductibleTitle", medicalMaxOutOfPocketToolTipContent: "medicalMaxOutOfPocketToolTipContent", medicalMaxOutOfPocketIsTooltipExist: "medicalMaxOutOfPocketIsTooltipExist", medicalMaxOutOfPocketIsSubSectionHeaderExist: "medicalMaxOutOfPocketIsSubSectionHeaderExist", medicalMaxOutOfPocketIsContentExist: "medicalMaxOutOfPocketIsContentExist", medicalMaxOutOfPocketLeftSectionContent: "medicalMaxOutOfPocketLeftSectionContent", medicalMaxOutOfPocketTitle: "medicalMaxOutOfPocketTitle", planCompareBenefitValuesMAPD: "planCompareBenefitValuesMAPD", planCompareBenefitValuesMA: "planCompareBenefitValuesMA", planCompareBenefitValuesMEDIGAP: "planCompareBenefitValuesMEDIGAP", siteShowDifferencesChecked: "siteShowDifferencesChecked", planComparePlanDifferencesColor: "planComparePlanDifferencesColor", planComparePlanDifferencesBorder: "planComparePlanDifferencesBorder", planCompareHighLightOffScreenText: "planCompareHighLightOffScreenText", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text", medicalCoverageAriaLabel: "medicalCoverageAriaLabel" }, decls: 3, vars: 6, consts: [[4, "ngIf"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "plan-compare-benefit-section"], [3, "panelContentTooltip", "isPanelContentTooltipExist", "isSubSectionHeaderExist", "isPanelContentExist", "panelLeftSectionContent", "customClass", "isHighLighted", "offScreenHighLightLabelText", "Spa_Site_Tooltip_Text", "tooltipAriaLabel"], ["class", "plan-compare-list-section plan-compare-document text-center text-lg-left", "nonCostSection", "", 3, "ngStyle", "ngClass", 4, "ngFor", "ngForOf"], ["nonCostSection", "", 1, "plan-compare-list-section", "plan-compare-document", "text-center", "text-lg-left", 3, "ngStyle", "ngClass"], ["role", "cell", 1, "Spa_Style_Bold_Weight", "Spa_Style_Primary_Color"], [1, "sr-only", "no-translate-block"], ["class", "plan-compare-benefit-section", 4, "ngIf"], ["role", "cell"], ["navigationAdapter", "", 1, "Spa_Style_Bold_Weight", "Spa_Style_Primary_Color", 3, "innerHTML"]], template: function PlanCompareMedicalBenefitsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanCompareMedicalBenefitsComponent_div_0_Template, 7, 22, "div", 0);
        i0.ɵɵtemplate(1, PlanCompareMedicalBenefitsComponent_div_1_Template, 2, 1, "div", 1);
        i0.ɵɵpipe(2, "orderBy");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.plans[0].planType === ctx.planType.MA || ctx.plans[0].planType === ctx.planType.MAPD);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(2, 3, ctx.getBenefitsBasedOnPlanType(ctx.plans, ctx.planCompareBenefitValuesMAPD, ctx.planCompareBenefitValuesMA, ctx.planCompareBenefitValuesMEDIGAP), "ordinal"))("ngForTrackBy", ctx.benefitTrackByFn);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgStyle, NavigationAdapterDirective, PlanComparePanelComponent, SafePipe, OrderPipe], styles: [".plan-compare-list-section.plan-compare-document[_ngcontent-%COMP%]{padding:24px 0 22px 18px}.plan-compare-list-section[_ngcontent-%COMP%] + .plan-compare-list-section[_ngcontent-%COMP%]{border-left-width:0!important}.plan-compare-list-section[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);padding:10px 6px 10px 14px}.plan-compare-list-section[_ngcontent-%COMP%]:last-child{border-right-width:0px}.plan-compare-benefit-section[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Accent1)}@media (max-width: 991.9px){.plan-compare-list-section[_ngcontent-%COMP%], .plan-compare-card[_ngcontent-%COMP%]{border-width:0px}.plan-compare-list-section[_ngcontent-%COMP%]:last-child, .plan-compare-card[_ngcontent-%COMP%]:last-child{border-left:1px solid var(--static-Spa_Style_Accent1)}.plan-compare-list-section.plan-compare-document[_ngcontent-%COMP%]{padding:10px 14px}}@media print{.plan-compare-list-section[_ngcontent-%COMP%], .plan-compare-card[_ngcontent-%COMP%]{border-width:1px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCompareMedicalBenefitsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-compare-medical-benefits', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"plans[0].planType === planType.MA || plans[0].planType === planType.MAPD\">\r\n  <div class=\"plan-compare-benefit-section\">\r\n    <vnext-widget-plan-compare-panel\r\n      [panelContentTooltip]=\"medicalDeductibleToolTipContent\"\r\n      [isPanelContentTooltipExist]=\"medicalDeductibleIsTooltipExist\"\r\n      [isSubSectionHeaderExist]=\"medicalDeductibleIsSubSectionHeaderExist\"\r\n      [isPanelContentExist]=\"medicalDeductibleIsContentExist\"\r\n      [panelLeftSectionContent]=\"medicalDeductibleLeftSectionContent\"\r\n      [customClass]=\"customClass\"\r\n      [isHighLighted]=\"getMedicalBenefitHighlightStyles(plans, medicalDeductibleTitle)\"\r\n      [offScreenHighLightLabelText]=\"planCompareHighLightOffScreenText\"\r\n      [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n      [tooltipAriaLabel]=\"medicalCoverageAriaLabel\"\r\n    >\r\n      <div\r\n        [ngStyle]=\"getMedicalBenefitHighlightStyles(plans, medicalDeductibleTitle)\"\r\n        class=\"plan-compare-list-section plan-compare-document text-center text-lg-left\"\r\n        [ngClass]=\"customClassBenefitValue\"\r\n        *ngFor=\"let plan of plans; index as i\"\r\n        nonCostSection\r\n      >\r\n        <div role=\"cell\" [attr.aria-colindex]=\"i + 1\" class=\"Spa_Style_Bold_Weight Spa_Style_Primary_Color\">\r\n          <div>\r\n            <span class=\"sr-only no-translate-block\">{{ plan.planName }}</span>\r\n            {{ getMedicalBenefitValue(plan, notAvailableText, medicalDeductibleTitle) }}\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </vnext-widget-plan-compare-panel>\r\n  </div>\r\n  <div class=\"plan-compare-benefit-section\">\r\n    <vnext-widget-plan-compare-panel\r\n      [panelContentTooltip]=\"medicalMaxOutOfPocketToolTipContent\"\r\n      [isPanelContentTooltipExist]=\"medicalMaxOutOfPocketIsTooltipExist\"\r\n      [isSubSectionHeaderExist]=\"medicalMaxOutOfPocketIsSubSectionHeaderExist\"\r\n      [isPanelContentExist]=\"medicalMaxOutOfPocketIsContentExist\"\r\n      [panelLeftSectionContent]=\"medicalMaxOutOfPocketLeftSectionContent\"\r\n      [customClass]=\"customClass\"\r\n      [isHighLighted]=\"getMedicalBenefitHighlightStyles(plans, medicalMaxOutOfPocketTitle)\"\r\n      [offScreenHighLightLabelText]=\"planCompareHighLightOffScreenText\"\r\n      [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n      [tooltipAriaLabel]=\"medicalCoverageAriaLabel\"\r\n    >\r\n      <div\r\n        [ngStyle]=\"getMedicalBenefitHighlightStyles(plans, medicalMaxOutOfPocketTitle)\"\r\n        class=\"plan-compare-list-section plan-compare-document text-center text-lg-left\"\r\n        [ngClass]=\"customClassBenefitValue\"\r\n        *ngFor=\"let plan of plans; index as i\"\r\n        nonCostSection\r\n      >\r\n        <div [attr.aria-colindex]=\"i + 1\" role=\"cell\" class=\"Spa_Style_Bold_Weight Spa_Style_Primary_Color\">\r\n          <div>\r\n            <span class=\"sr-only no-translate-block\">{{ plan.planName }}</span>\r\n            {{ getMedicalBenefitValue(plan, notAvailableText, medicalMaxOutOfPocketTitle) }}\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </vnext-widget-plan-compare-panel>\r\n  </div>\r\n</div>\r\n<div\r\n  *ngFor=\"\r\n    let benefit of getBenefitsBasedOnPlanType(\r\n      plans,\r\n      planCompareBenefitValuesMAPD,\r\n      planCompareBenefitValuesMA,\r\n      planCompareBenefitValuesMEDIGAP\r\n    ) | orderBy: 'ordinal';\r\n    trackBy: benefitTrackByFn\r\n  \"\r\n>\r\n  <div class=\"plan-compare-benefit-section\" *ngIf=\"showBenefitValues(plans, benefit)\">\r\n    <vnext-widget-plan-compare-panel\r\n      [panelContentTooltip]=\"benefit.tooltipContent\"\r\n      [isPanelContentTooltipExist]=\"benefit.showTooltip\"\r\n      [isSubSectionHeaderExist]=\"false\"\r\n      [isPanelContentExist]=\"true\"\r\n      [panelLeftSectionContent]=\"benefit.detail\"\r\n      [customClass]=\"customClass\"\r\n      [isHighLighted]=\"getPlanCompareStyles(plans, { benefit: benefit })\"\r\n      [offScreenHighLightLabelText]=\"planCompareHighLightOffScreenText\"\r\n      [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n      [tooltipAriaLabel]=\"medicalCoverageAriaLabel\"\r\n    >\r\n      <div\r\n        [ngStyle]=\"getPlanCompareStyles(plans, { benefit: benefit })\"\r\n        class=\"plan-compare-list-section plan-compare-document text-center text-lg-left\"\r\n        [ngClass]=\"customClassBenefitValue\"\r\n        *ngFor=\"let plan of plans; index as i\"\r\n        nonCostSection\r\n      >\r\n        <div role=\"cell\" [attr.aria-colindex]=\"i + 1\">\r\n          <div>\r\n            <span class=\"sr-only no-translate-block\">{{ plan.planName }}</span>\r\n            <div\r\n              class=\"Spa_Style_Bold_Weight Spa_Style_Primary_Color\"\r\n              [innerHTML]=\"getBenefitValue(plan, notAvailableText, benefit) | safe: 'html'\"\r\n              navigationAdapter\r\n            ></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </vnext-widget-plan-compare-panel>\r\n  </div>\r\n</div>\r\n", styles: [".plan-compare-list-section.plan-compare-document{padding:24px 0 22px 18px}.plan-compare-list-section+.plan-compare-list-section{border-left-width:0!important}.plan-compare-list-section{border-right:1px solid var(--static-Spa_Style_Accent1);padding:10px 6px 10px 14px}.plan-compare-list-section:last-child{border-right-width:0px}.plan-compare-benefit-section{border-bottom:1px solid var(--static-Spa_Style_Accent1)}@media (max-width: 991.9px){.plan-compare-list-section,.plan-compare-card{border-width:0px}.plan-compare-list-section:last-child,.plan-compare-card:last-child{border-left:1px solid var(--static-Spa_Style_Accent1)}.plan-compare-list-section.plan-compare-document{padding:10px 14px}}@media print{.plan-compare-list-section,.plan-compare-card{border-width:1px}}\n"] }]
    }], function () { return [{ type: PlanCompareFacade }]; }, { medicalDeductibleToolTipContent: [{
            type: Input
        }], medicalDeductibleIsTooltipExist: [{
            type: Input
        }], medicalDeductibleIsSubSectionHeaderExist: [{
            type: Input
        }], medicalDeductibleIsContentExist: [{
            type: Input
        }], medicalDeductibleLeftSectionContent: [{
            type: Input
        }], customClass: [{
            type: Input
        }], plans: [{
            type: Input
        }], customClassBenefitValue: [{
            type: Input
        }], notAvailableText: [{
            type: Input
        }], medicalDeductibleTitle: [{
            type: Input
        }], medicalMaxOutOfPocketToolTipContent: [{
            type: Input
        }], medicalMaxOutOfPocketIsTooltipExist: [{
            type: Input
        }], medicalMaxOutOfPocketIsSubSectionHeaderExist: [{
            type: Input
        }], medicalMaxOutOfPocketIsContentExist: [{
            type: Input
        }], medicalMaxOutOfPocketLeftSectionContent: [{
            type: Input
        }], medicalMaxOutOfPocketTitle: [{
            type: Input
        }], planCompareBenefitValuesMAPD: [{
            type: Input
        }], planCompareBenefitValuesMA: [{
            type: Input
        }], planCompareBenefitValuesMEDIGAP: [{
            type: Input
        }], siteShowDifferencesChecked: [{
            type: Input
        }], planComparePlanDifferencesColor: [{
            type: Input
        }], planComparePlanDifferencesBorder: [{
            type: Input
        }], planCompareHighLightOffScreenText: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }], medicalCoverageAriaLabel: [{
            type: Input
        }] }); })();

const _c0$S = function (a0) { return { active: a0 }; };
function PlanComparePaginationComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 7);
} if (rf & 2) {
    const i_r2 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0$S, ctx_r0.activePage === i_r2));
} }
class PlanComparePaginationComponent {
    constructor() {
        this.pageChanged = new EventEmitter();
        this.activePage = 0;
        this.pages = [];
    }
    ngOnInit() {
        this.pages = Array.from({ length: this.planCount }, (_, index) => index);
    }
    previousPage() {
        if (this.activePage > 0) {
            this.activePage--;
        }
        else {
            this.activePage = this.planCount - 1;
        }
        this.pageChanged.emit(this.activePage);
    }
    nextPage() {
        if (this.activePage < this.planCount - 1) {
            this.activePage++;
        }
        else {
            this.activePage = 0;
        }
        this.pageChanged.emit(this.activePage);
    }
}
PlanComparePaginationComponent.ɵfac = function PlanComparePaginationComponent_Factory(t) { return new (t || PlanComparePaginationComponent)(); };
PlanComparePaginationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanComparePaginationComponent, selectors: [["vnext-widget-plan-compare-pagination"]], inputs: { planCount: "planCount" }, outputs: { pageChanged: "pageChanged" }, decls: 11, vars: 1, consts: [[1, "d-flex", "justify-content-between", "align-items-center"], [1, "pagination-btn", "rounded-circle", "d-flex", "justify-content-center", "align-items-center", 3, "click"], [1, "fa", "fa-angle-left"], [1, "sr-only"], [1, "col-5", "d-flex", "justify-content-around", "align-items-center"], ["class", "page rounded-circle", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "fa", "fa-angle-right"], [1, "page", "rounded-circle", 3, "ngClass"]], template: function PlanComparePaginationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵlistener("click", function PlanComparePaginationComponent_Template_div_click_1_listener() { return ctx.previousPage(); });
        i0.ɵɵelement(2, "i", 2);
        i0.ɵɵelementStart(3, "span", 3);
        i0.ɵɵtext(4, "Previous");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵtemplate(6, PlanComparePaginationComponent_div_6_Template, 1, 3, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 1);
        i0.ɵɵlistener("click", function PlanComparePaginationComponent_Template_div_click_7_listener() { return ctx.nextPage(); });
        i0.ɵɵelement(8, "i", 6);
        i0.ɵɵelementStart(9, "span", 3);
        i0.ɵɵtext(10, "Next");
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngForOf", ctx.pages);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, IconAriaAttributesDirective], styles: [".pagination-btn[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray4);color:var(--Spa_Style_Secondary_Text);width:22px;height:22px}.page[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Gray4);width:20px;height:20px}.page.active[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray4)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanComparePaginationComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-compare-pagination', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"d-flex justify-content-between align-items-center\">\r\n  <div class=\"pagination-btn rounded-circle d-flex justify-content-center align-items-center\" (click)=\"previousPage()\">\r\n    <i class=\"fa fa-angle-left\"></i>\r\n    <span class=\"sr-only\">Previous</span>\r\n  </div>\r\n  <div class=\"col-5 d-flex justify-content-around align-items-center\">\r\n    <div *ngFor=\"let page of pages; let i = index\" class=\"page rounded-circle\" [ngClass]=\"{ active: activePage === i }\"></div>\r\n  </div>\r\n  <div class=\"pagination-btn rounded-circle d-flex justify-content-center align-items-center\" (click)=\"nextPage()\">\r\n    <i class=\"fa fa-angle-right\"></i>\r\n    <span class=\"sr-only\">Next</span>\r\n  </div>\r\n</div>\r\n", styles: [".pagination-btn{background-color:var(--static-Spa_Style_Gray4);color:var(--Spa_Style_Secondary_Text);width:22px;height:22px}.page{border:1px solid var(--static-Spa_Style_Gray4);width:20px;height:20px}.page.active{background-color:var(--static-Spa_Style_Gray4)}\n"] }]
    }], null, { planCount: [{
            type: Input
        }], pageChanged: [{
            type: Output
        }] }); })();

function PlanComparePreferencesComponent_div_0_div_4_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "i", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.coveredBenefitText, " ");
} }
function PlanComparePreferencesComponent_div_0_div_4_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "i", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.nonCoveredBenefitText, " ");
} }
function PlanComparePreferencesComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div")(2, "span", 6);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtemplate(5, PlanComparePreferencesComponent_div_0_div_4_div_5_Template, 3, 1, "div", 7);
    i0.ɵɵtemplate(6, PlanComparePreferencesComponent_div_0_div_4_ng_template_6_Template, 3, 1, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const plan_r4 = ctx.$implicit;
    const _r7 = i0.ɵɵreference(7);
    const ctx_r9 = i0.ɵɵnextContext();
    const differentBenefitCoveredIndex_r2 = ctx_r9.index;
    const benefit_r1 = ctx_r9.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("plan-compare-list-section text-center text-lg-left ", ctx_r3.customRightSectionClass, "");
    i0.ɵɵproperty("ngStyle", ctx_r3.planCompareFacade.getBenefitCoveredDifferenceCustomStyles(ctx_r3.answeredPreferenceBenefits, ctx_r3.showHighlightPlanDifferences, ctx_r3.plans, differentBenefitCoveredIndex_r2));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(plan_r4.planName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.isBenefitCovered(plan_r4.id, benefit_r1.id))("ngIfElse", _r7);
} }
function PlanComparePreferencesComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "span", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PlanComparePreferencesComponent_div_0_div_4_Template, 8, 7, "div", 4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const benefit_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("Spa_Style_H5 plan-compare-left-section m-0 ", ctx_r0.customLeftSectionClass, "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", benefit_r1.displayLabel, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.plans);
} }
class PlanComparePreferencesComponent {
    constructor(planCompareFacade) {
        this.planCompareFacade = planCompareFacade;
    }
    isBenefitCovered(planId, benefitId) {
        const preference = this.answeredPreferenceBenefits.find(x => x.planId === planId);
        if (preference && preference.preferenceBenefits) {
            const preferenceOption = preference.preferenceBenefits.find(item => item.id === benefitId);
            return preferenceOption ? preferenceOption.isCovered : false;
        }
        return false;
    }
}
PlanComparePreferencesComponent.ɵfac = function PlanComparePreferencesComponent_Factory(t) { return new (t || PlanComparePreferencesComponent)(i0.ɵɵdirectiveInject(PlanCompareFacade)); };
PlanComparePreferencesComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanComparePreferencesComponent, selectors: [["vnext-plan-compare-preferences"]], inputs: { plans: "plans", isMobile: "isMobile", showHighlightPlanDifferences: "showHighlightPlanDifferences", customLeftSectionClass: "customLeftSectionClass", customRightSectionClass: "customRightSectionClass", coveredBenefitText: "coveredBenefitText", nonCoveredBenefitText: "nonCoveredBenefitText", answeredPreferenceBenefits: "answeredPreferenceBenefits" }, decls: 1, vars: 1, consts: [["class", "preferences-section", 4, "ngFor", "ngForOf"], [1, "preferences-section"], ["role", "row", 1, "row", "mx-0"], ["role", "rowheader"], ["role", "cell", 3, "ngStyle", "class", 4, "ngFor", "ngForOf"], ["role", "cell", 3, "ngStyle"], [1, "sr-only", "no-translate-block"], ["class", "Spa_Style_H4 mb-0", 4, "ngIf", "ngIfElse"], ["nonCovered", ""], [1, "Spa_Style_H4", "mb-0"], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "covered-benefits"], ["aria-hidden", "true", 1, "fas", "fa-times-circle", "non-covered-benefits"]], template: function PlanComparePreferencesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanComparePreferencesComponent_div_0_Template, 5, 5, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.answeredPreferenceBenefits[0] == null ? null : ctx.answeredPreferenceBenefits[0].preferenceBenefits);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, i1$2.NgStyle, IconAriaAttributesDirective], styles: [".covered-benefits[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent5)}.non-covered-benefits[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent1)}.preferences-section[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Accent1)}.gray1-static[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray1)}.plan-compare-left-section[_ngcontent-%COMP%], .plan-compare-list-section[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);padding:12px 14px 14px}.plan-compare-list-section[_ngcontent-%COMP%]:last-child{border-right-width:0px}.drug-section[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Accent1)}@media (max-width: 991.9px){.plan-compare-left-section[_ngcontent-%COMP%]{border-right-width:0px;text-align:center}.plan-compare-list-section[_ngcontent-%COMP%]:last-child{border-left:1px solid var(--static-Spa_Style_Accent1)}}@media print{.plan-compare-left-section[_ngcontent-%COMP%]{border-right-width:1px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanComparePreferencesComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-compare-preferences', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  class=\"preferences-section\"\r\n  *ngFor=\"let benefit of answeredPreferenceBenefits[0]?.preferenceBenefits; let differentBenefitCoveredIndex = index\"\r\n>\r\n  <div class=\"row mx-0\" role=\"row\">\r\n    <span role=\"rowheader\" class=\"Spa_Style_H5 plan-compare-left-section m-0 {{ customLeftSectionClass }}\">\r\n      {{ benefit.displayLabel }}\r\n    </span>\r\n    <div\r\n      role=\"cell\"\r\n      [ngStyle]=\"\r\n        planCompareFacade.getBenefitCoveredDifferenceCustomStyles(\r\n          answeredPreferenceBenefits,\r\n          showHighlightPlanDifferences,\r\n          plans,\r\n          differentBenefitCoveredIndex\r\n        )\r\n      \"\r\n      class=\"plan-compare-list-section text-center text-lg-left {{ customRightSectionClass }}\"\r\n      *ngFor=\"let plan of plans; let i = index\"\r\n    >\r\n      <div>\r\n        <span class=\"sr-only no-translate-block\">{{ plan.planName }}</span>\r\n        <div>\r\n          <div class=\"Spa_Style_H4 mb-0\" *ngIf=\"isBenefitCovered(plan.id, benefit.id); else nonCovered\">\r\n            <i class=\"fas fa-check-circle covered-benefits\" aria-hidden=\"true\"></i> {{ coveredBenefitText }}\r\n          </div>\r\n          <ng-template #nonCovered>\r\n            <div class=\"Spa_Style_H4 mb-0\">\r\n              <i class=\"fas fa-times-circle non-covered-benefits\" aria-hidden=\"true\"></i>\r\n              {{ nonCoveredBenefitText }}\r\n            </div>\r\n          </ng-template>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".covered-benefits{color:var(--static-Spa_Style_Accent5)}.non-covered-benefits{color:var(--static-Spa_Style_Accent1)}.preferences-section{border-bottom:1px solid var(--static-Spa_Style_Accent1)}.gray1-static{background-color:var(--static-Spa_Style_Gray1)}.plan-compare-left-section,.plan-compare-list-section{border-right:1px solid var(--static-Spa_Style_Accent1);padding:12px 14px 14px}.plan-compare-list-section:last-child{border-right-width:0px}.drug-section{border-bottom:1px solid var(--static-Spa_Style_Accent1)}@media (max-width: 991.9px){.plan-compare-left-section{border-right-width:0px;text-align:center}.plan-compare-list-section:last-child{border-left:1px solid var(--static-Spa_Style_Accent1)}}@media print{.plan-compare-left-section{border-right-width:1px}}\n"] }]
    }], function () { return [{ type: PlanCompareFacade }]; }, { plans: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], showHighlightPlanDifferences: [{
            type: Input
        }], customLeftSectionClass: [{
            type: Input
        }], customRightSectionClass: [{
            type: Input
        }], coveredBenefitText: [{
            type: Input
        }], nonCoveredBenefitText: [{
            type: Input
        }], answeredPreferenceBenefits: [{
            type: Input
        }] }); })();

function PlanComparePrescriptionCoverageComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div")(2, "span", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "currency");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const plan_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", ctx_r0.getDrugDeductibleCustomStyles())("ngClass", ctx_r0.prescriptionRightSectionCustomClass);
    i0.ɵɵattribute("aria-colindex", i_r5 + 1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(plan_r4.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind4(5, 5, plan_r4.drugDeductible, "USD", "symbol", "1.2-2"), " ");
} }
function PlanComparePrescriptionCoverageComponent_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div")(2, "span", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "currency");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const plan_r7 = ctx.$implicit;
    const i_r8 = ctx.index;
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", ctx_r6.getCoverageLimitCustomStyles())("ngClass", ctx_r6.prescriptionRightSectionCustomClass);
    i0.ɵɵattribute("aria-colindex", i_r8 + 1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(plan_r7.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind4(5, 5, plan_r7.initialCoverageLimit, "USD", "symbol", "1.2-2"), " ");
} }
function PlanComparePrescriptionCoverageComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "vnext-widget-plan-compare-panel", 1);
    i0.ɵɵtemplate(2, PlanComparePrescriptionCoverageComponent_div_3_div_2_Template, 6, 10, "div", 2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isSubSectionHeaderExist", false)("isPanelContentExist", true)("customClass", ctx_r1.prescriptionLeftSectionCustomClass)("panelLeftSectionContent", ctx_r1.prescriptionInitialCoverageText)("panelContentTooltip", ctx_r1.prescriptionInitialCoverageTooltip)("isPanelContentTooltipExist", ctx_r1.showPrescriptionInitialCoverageTooltip)("isHighLighted", ctx_r1.getCoverageLimitCustomStyles())("offScreenHighLightLabelText", ctx_r1.planCompareHighLightOffScreenText)("Spa_Site_Tooltip_Text", ctx_r1.Spa_Site_Tooltip_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.plans);
} }
function PlanComparePrescriptionCoverageComponent_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div")(2, "span", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 9);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "p", 10);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const plan_r10 = ctx.$implicit;
    const i_r11 = ctx.index;
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r9.prescriptionRightSectionCustomClass);
    i0.ɵɵattribute("aria-colindex", i_r11 + 1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(plan_r10.planName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", plan_r10.subsidy.lowIncomeSubsidyText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r9.lowIncomeSubsidyInformationalText);
} }
function PlanComparePrescriptionCoverageComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "vnext-widget-plan-compare-panel", 6);
    i0.ɵɵtemplate(2, PlanComparePrescriptionCoverageComponent_div_4_div_2_Template, 8, 5, "div", 7);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isSubSectionHeaderExist", false)("isPanelContentExist", true)("customClass", ctx_r2.prescriptionLeftSectionCustomClass)("panelLeftSectionContent", ctx_r2.lowIncomeSubsidyLabel)("isHighLighted", false)("offScreenHighLightLabelText", ctx_r2.planCompareHighLightOffScreenText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.plans);
} }
function PlanComparePrescriptionCoverageComponent_div_5_div_2_ng_container_3_ng_container_1_ng_container_1_ng_container_1_h3_1_vnext_tooltip_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-tooltip", 21);
    i0.ɵɵelement(1, "i", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const extendedDetails_r19 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r25 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("body", extendedDetails_r19.toolTip)("Spa_Site_Tooltip_Text", ctx_r25.Spa_Site_Tooltip_Text);
} }
function PlanComparePrescriptionCoverageComponent_div_5_div_2_ng_container_3_ng_container_1_ng_container_1_ng_container_1_h3_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 19);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, PlanComparePrescriptionCoverageComponent_div_5_div_2_ng_container_3_ng_container_1_ng_container_1_ng_container_1_h3_1_vnext_tooltip_2_Template, 2, 2, "vnext-tooltip", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const index_r22 = i0.ɵɵnextContext(2).index;
    const extendedDetails_r19 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", extendedDetails_r19.name, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", extendedDetails_r19.toolTip && index_r22 === 0);
} }
function PlanComparePrescriptionCoverageComponent_div_5_div_2_ng_container_3_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanComparePrescriptionCoverageComponent_div_5_div_2_ng_container_3_ng_container_1_ng_container_1_ng_container_1_h3_1_Template, 3, 2, "h3", 17);
    i0.ɵɵelementStart(2, "div", 18);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext();
    const index_r22 = ctx_r29.index;
    const sectionDetails_r21 = ctx_r29.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", index_r22 === 0);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", sectionDetails_r21.name, ": ", sectionDetails_r21.value, "");
} }
function PlanComparePrescriptionCoverageComponent_div_5_div_2_ng_container_3_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanComparePrescriptionCoverageComponent_div_5_div_2_ng_container_3_ng_container_1_ng_container_1_ng_container_1_Template, 4, 3, "ng-container", 16);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const sectionDetails_r21 = ctx.$implicit;
    const ctx_r20 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", sectionDetails_r21.valueTypeID === ctx_r20.planBenefitValueType.DRUG_BENEFIT);
} }
function PlanComparePrescriptionCoverageComponent_div_5_div_2_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanComparePrescriptionCoverageComponent_div_5_div_2_ng_container_3_ng_container_1_ng_container_1_Template, 2, 1, "ng-container", 15);
    i0.ɵɵpipe(2, "orderBy");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const extendedDetails_r19 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(2, 1, extendedDetails_r19.sectionDetails, "ordinal"));
} }
function PlanComparePrescriptionCoverageComponent_div_5_div_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanComparePrescriptionCoverageComponent_div_5_div_2_ng_container_3_ng_container_1_Template, 3, 4, "ng-container", 15);
    i0.ɵɵpipe(2, "orderBy");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const plan_r13 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(2, 1, plan_r13.extendedPlanDetails, "ordinal"));
} }
function PlanComparePrescriptionCoverageComponent_div_5_div_2_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate(ctx_r17.prescriptionDrugsNotApplicableText);
} }
const _c0$R = function (a0) { return [a0]; };
function PlanComparePrescriptionCoverageComponent_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "span", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PlanComparePrescriptionCoverageComponent_div_5_div_2_ng_container_3_Template, 3, 4, "ng-container", 13);
    i0.ɵɵtemplate(4, PlanComparePrescriptionCoverageComponent_div_5_div_2_ng_template_4_Template, 1, 1, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r13 = ctx.$implicit;
    const i_r14 = ctx.index;
    const _r16 = i0.ɵɵreference(5);
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", ctx_r12.getDrugHighlightStyles())("ngClass", ctx_r12.prescriptionRightSectionCustomClass);
    i0.ɵɵattribute("aria-colindex", i_r14 + 1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(plan_r13.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.planCompareFacade.isPrescriptionDrugExist(i0.ɵɵpureFunction1(6, _c0$R, plan_r13)))("ngIfElse", _r16);
} }
function PlanComparePrescriptionCoverageComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "vnext-widget-plan-compare-panel", 1);
    i0.ɵɵtemplate(2, PlanComparePrescriptionCoverageComponent_div_5_div_2_Template, 6, 8, "div", 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isSubSectionHeaderExist", false)("isPanelContentExist", true)("customClass", ctx_r3.prescriptionLeftSectionCustomClass)("panelLeftSectionContent", ctx_r3.prescriptionDrugsText)("panelContentTooltip", ctx_r3.prescriptionDrugsTooltip)("isPanelContentTooltipExist", ctx_r3.showPrescriptionDrugsTooltip)("isHighLighted", ctx_r3.getDrugHighlightStyles())("offScreenHighLightLabelText", ctx_r3.planCompareHighLightOffScreenText)("Spa_Site_Tooltip_Text", ctx_r3.Spa_Site_Tooltip_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.plans);
} }
class PlanComparePrescriptionCoverageComponent {
    constructor(planCompareFacade) {
        this.planCompareFacade = planCompareFacade;
        this.showInitialCoverageLimit = false;
        this.planBenefitValueType = PlanBenefitValueType;
    }
    ngOnInit() {
        this.lowIncomeSubsidyLabel = this.planCompareFacade.getLowIncomeSubsidyLabel();
        this.lowIncomeSubsidyInformationalText = this.planCompareFacade.getLowIncomeSubsidyInformationalText();
    }
    ngOnChanges(changes) {
        if (changes.plans) {
            const previousPlans = changes.plans.previousValue || [];
            const currentPlans = changes.plans.currentValue || [];
            if (!_isEqual(currentPlans, previousPlans)) {
                this.showSubsidyRows = this.plans.every(plan => !!plan.subsidy?.showSubsidy);
                this.plans = this.plans.map(plan => ({
                    ...plan,
                    subsidy: { ...plan.subsidy, lowIncomeSubsidyText: this.planCompareFacade.getLowIncomeSubsidyText(plan) }
                }));
            }
        }
    }
    getDrugDeductibleCustomStyles() {
        const drugDeductible = Array.from(new Set(this.plans.map(plan => plan.drugDeductible)));
        if (this.showHighlightPlanDifferences && drugDeductible.length !== 1) {
            return this.prescriptionRightSectionCustomStyles;
        }
    }
    getCoverageLimitCustomStyles() {
        const coverageLimit = Array.from(new Set(this.plans.map(plan => plan.initialCoverageLimit)));
        if (this.showHighlightPlanDifferences && coverageLimit.length !== 1) {
            return this.prescriptionRightSectionCustomStyles;
        }
    }
    getDrugHighlightStyles() {
        const drug = Array.from(new Set(this.plans.map(plan => plan.extendedPlanDetails.map(extendedPlan => extendedPlan.name))));
        if (this.showHighlightPlanDifferences && drug.length !== 1) {
            return this.prescriptionRightSectionCustomStyles;
        }
    }
}
PlanComparePrescriptionCoverageComponent.ɵfac = function PlanComparePrescriptionCoverageComponent_Factory(t) { return new (t || PlanComparePrescriptionCoverageComponent)(i0.ɵɵdirectiveInject(PlanCompareFacade)); };
PlanComparePrescriptionCoverageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanComparePrescriptionCoverageComponent, selectors: [["vnext-widget-plan-compare-prescription-coverage"]], inputs: { plans: "plans", prescriptionLeftSectionCustomClass: "prescriptionLeftSectionCustomClass", prescriptionRightSectionCustomClass: "prescriptionRightSectionCustomClass", prescriptionDeductibleText: "prescriptionDeductibleText", prescriptionDeductibleTooltip: "prescriptionDeductibleTooltip", showPrescriptionDeductibleTooltip: "showPrescriptionDeductibleTooltip", prescriptionInitialCoverageText: "prescriptionInitialCoverageText", prescriptionInitialCoverageTooltip: "prescriptionInitialCoverageTooltip", showPrescriptionInitialCoverageTooltip: "showPrescriptionInitialCoverageTooltip", prescriptionDrugsText: "prescriptionDrugsText", prescriptionDrugsTooltip: "prescriptionDrugsTooltip", showPrescriptionDrugsTooltip: "showPrescriptionDrugsTooltip", prescriptionDrugsNotApplicableText: "prescriptionDrugsNotApplicableText", prescriptionRightSectionCustomStyles: "prescriptionRightSectionCustomStyles", showHighlightPlanDifferences: "showHighlightPlanDifferences", planCompareHighLightOffScreenText: "planCompareHighLightOffScreenText", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text", showInitialCoverageLimit: "showInitialCoverageLimit" }, features: [i0.ɵɵNgOnChangesFeature], decls: 6, vars: 13, consts: [[1, "prescription-coverage-section"], [3, "isSubSectionHeaderExist", "isPanelContentExist", "customClass", "panelLeftSectionContent", "panelContentTooltip", "isPanelContentTooltipExist", "isHighLighted", "offScreenHighLightLabelText", "Spa_Site_Tooltip_Text"], ["role", "cell", "class", "plan-compare-list-section text-center text-lg-left Spa_Style_Primary_Color Spa_Style_Bold_Weight", "nonCostSection", "", 3, "ngStyle", "ngClass", 4, "ngFor", "ngForOf"], ["class", "prescription-coverage-section", 4, "ngIf"], ["role", "cell", "nonCostSection", "", 1, "plan-compare-list-section", "text-center", "text-lg-left", "Spa_Style_Primary_Color", "Spa_Style_Bold_Weight", 3, "ngStyle", "ngClass"], [1, "sr-only", "no-translate-block"], [3, "isSubSectionHeaderExist", "isPanelContentExist", "customClass", "panelLeftSectionContent", "isHighLighted", "offScreenHighLightLabelText"], ["role", "cell", "class", "plan-compare-list-section text-center text-lg-left Spa_Style_Primary_Color", "nonCostSection", "", 3, "ngClass", 4, "ngFor", "ngForOf"], ["role", "cell", "nonCostSection", "", 1, "plan-compare-list-section", "text-center", "text-lg-left", "Spa_Style_Primary_Color", 3, "ngClass"], [1, "Spa_Style_Bold_Weight"], [1, "Spa_Style_Note", "mt-1"], ["role", "cell", "class", "plan-compare-list-section text-center text-lg-left", "nonCostSection", "", 3, "ngStyle", "ngClass", 4, "ngFor", "ngForOf"], ["role", "cell", "nonCostSection", "", 1, "plan-compare-list-section", "text-center", "text-lg-left", 3, "ngStyle", "ngClass"], [4, "ngIf", "ngIfElse"], ["showNotApplicable", ""], [4, "ngFor", "ngForOf"], [4, "ngIf"], ["class", "Spa_Style_H4 prescription-benefits-header", 4, "ngIf"], [1, "Spa_Style_Note", "mb-1"], [1, "Spa_Style_H4", "prescription-benefits-header"], [3, "body", "Spa_Site_Tooltip_Text", 4, "ngIf"], [3, "body", "Spa_Site_Tooltip_Text"], ["aria-hidden", "true", 1, "fas", "fa-question-circle", "icon-tooltip"]], template: function PlanComparePrescriptionCoverageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "vnext-widget-plan-compare-panel", 1);
        i0.ɵɵtemplate(2, PlanComparePrescriptionCoverageComponent_div_2_Template, 6, 10, "div", 2);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(3, PlanComparePrescriptionCoverageComponent_div_3_Template, 3, 10, "div", 3);
        i0.ɵɵtemplate(4, PlanComparePrescriptionCoverageComponent_div_4_Template, 3, 7, "div", 3);
        i0.ɵɵtemplate(5, PlanComparePrescriptionCoverageComponent_div_5_Template, 3, 10, "div", 3);
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("isSubSectionHeaderExist", false)("isPanelContentExist", true)("customClass", ctx.prescriptionLeftSectionCustomClass)("panelLeftSectionContent", ctx.prescriptionDeductibleText)("panelContentTooltip", ctx.prescriptionDeductibleTooltip)("isPanelContentTooltipExist", ctx.showPrescriptionDeductibleTooltip)("isHighLighted", ctx.getDrugDeductibleCustomStyles())("offScreenHighLightLabelText", ctx.planCompareHighLightOffScreenText)("Spa_Site_Tooltip_Text", ctx.Spa_Site_Tooltip_Text);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.plans);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showInitialCoverageLimit);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showSubsidyRows);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.planCompareFacade.isPrescriptionDrugExist(ctx.plans) && !ctx.showSubsidyRows);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgStyle, TooltipComponent, IconAriaAttributesDirective, PlanComparePanelComponent, i1$2.CurrencyPipe, OrderPipe], styles: [".gray1-static[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray1)}.plan-compare-left-section[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);padding:12px 14px 14px}.plan-compare-list-section[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);padding:12px 6px 14px 14px}.plan-compare-list-section[_ngcontent-%COMP%]:last-child{border-right-width:0px}.prescription-coverage-section[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Accent1)}.prescription-benefits-header[_ngcontent-%COMP%]{margin-top:18px}.prescription-benefits-header[_ngcontent-%COMP%]:first-child{margin-top:0}.plan-compare-list-section[_ngcontent-%COMP%] + .plan-compare-list-section[_ngcontent-%COMP%]{border-left-width:0!important}@media (max-width: 991.9px){.plan-compare-left-section[_ngcontent-%COMP%]{border-right-width:0px;border-bottom:1px solid var(--static-Spa_Style_Accent1);text-align:center}.plan-compare-list-section[_ngcontent-%COMP%]:last-child{border-left:1px solid var(--static-Spa_Style_Accent1)}}@media print{.plan-compare-left-section[_ngcontent-%COMP%]{border-right-width:1px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanComparePrescriptionCoverageComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-compare-prescription-coverage', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"prescription-coverage-section\">\r\n  <vnext-widget-plan-compare-panel\r\n    [isSubSectionHeaderExist]=\"false\"\r\n    [isPanelContentExist]=\"true\"\r\n    [customClass]=\"prescriptionLeftSectionCustomClass\"\r\n    [panelLeftSectionContent]=\"prescriptionDeductibleText\"\r\n    [panelContentTooltip]=\"prescriptionDeductibleTooltip\"\r\n    [isPanelContentTooltipExist]=\"showPrescriptionDeductibleTooltip\"\r\n    [isHighLighted]=\"getDrugDeductibleCustomStyles()\"\r\n    [offScreenHighLightLabelText]=\"planCompareHighLightOffScreenText\"\r\n    [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n  >\r\n    <div\r\n      role=\"cell\"\r\n      [ngStyle]=\"getDrugDeductibleCustomStyles()\"\r\n      class=\"plan-compare-list-section text-center text-lg-left Spa_Style_Primary_Color Spa_Style_Bold_Weight\"\r\n      [ngClass]=\"prescriptionRightSectionCustomClass\"\r\n      *ngFor=\"let plan of plans; index as i\"\r\n      nonCostSection\r\n      [attr.aria-colindex]=\"i + 1\"\r\n    >\r\n      <div>\r\n        <span class=\"sr-only no-translate-block\">{{ plan.planName }}</span>\r\n        {{ plan.drugDeductible | currency : 'USD' : 'symbol' : '1.2-2' }}\r\n      </div>\r\n    </div>\r\n  </vnext-widget-plan-compare-panel>\r\n</div>\r\n<div class=\"prescription-coverage-section\" *ngIf=\"showInitialCoverageLimit\">\r\n  <vnext-widget-plan-compare-panel\r\n    [isSubSectionHeaderExist]=\"false\"\r\n    [isPanelContentExist]=\"true\"\r\n    [customClass]=\"prescriptionLeftSectionCustomClass\"\r\n    [panelLeftSectionContent]=\"prescriptionInitialCoverageText\"\r\n    [panelContentTooltip]=\"prescriptionInitialCoverageTooltip\"\r\n    [isPanelContentTooltipExist]=\"showPrescriptionInitialCoverageTooltip\"\r\n    [isHighLighted]=\"getCoverageLimitCustomStyles()\"\r\n    [offScreenHighLightLabelText]=\"planCompareHighLightOffScreenText\"\r\n    [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n  >\r\n    <div\r\n      role=\"cell\"\r\n      [ngStyle]=\"getCoverageLimitCustomStyles()\"\r\n      class=\"plan-compare-list-section text-center text-lg-left Spa_Style_Primary_Color Spa_Style_Bold_Weight\"\r\n      [ngClass]=\"prescriptionRightSectionCustomClass\"\r\n      *ngFor=\"let plan of plans; index as i\"\r\n      [attr.aria-colindex]=\"i + 1\"\r\n      nonCostSection\r\n    >\r\n      <div>\r\n        <span class=\"sr-only no-translate-block\">{{ plan.planName }}</span>\r\n        {{ plan.initialCoverageLimit | currency : 'USD' : 'symbol' : '1.2-2' }}\r\n      </div>\r\n    </div>\r\n  </vnext-widget-plan-compare-panel>\r\n</div>\r\n<div class=\"prescription-coverage-section\" *ngIf=\"showSubsidyRows\">\r\n  <vnext-widget-plan-compare-panel\r\n    [isSubSectionHeaderExist]=\"false\"\r\n    [isPanelContentExist]=\"true\"\r\n    [customClass]=\"prescriptionLeftSectionCustomClass\"\r\n    [panelLeftSectionContent]=\"lowIncomeSubsidyLabel\"\r\n    [isHighLighted]=\"false\"\r\n    [offScreenHighLightLabelText]=\"planCompareHighLightOffScreenText\"\r\n  >\r\n    <div\r\n      role=\"cell\"\r\n      class=\"plan-compare-list-section text-center text-lg-left Spa_Style_Primary_Color\"\r\n      [ngClass]=\"prescriptionRightSectionCustomClass\"\r\n      *ngFor=\"let plan of plans; index as i\"\r\n      nonCostSection\r\n      [attr.aria-colindex]=\"i + 1\"\r\n    >\r\n      <div>\r\n        <span class=\"sr-only no-translate-block\">{{ plan.planName }}</span>\r\n\r\n        <span class=\"Spa_Style_Bold_Weight\">\r\n          {{ plan.subsidy.lowIncomeSubsidyText }}\r\n        </span>\r\n\r\n        <p class=\"Spa_Style_Note mt-1\">{{ lowIncomeSubsidyInformationalText }}</p>\r\n      </div>\r\n    </div>\r\n  </vnext-widget-plan-compare-panel>\r\n</div>\r\n<div class=\"prescription-coverage-section\" *ngIf=\"planCompareFacade.isPrescriptionDrugExist(plans) && !showSubsidyRows\">\r\n  <vnext-widget-plan-compare-panel\r\n    [isSubSectionHeaderExist]=\"false\"\r\n    [isPanelContentExist]=\"true\"\r\n    [customClass]=\"prescriptionLeftSectionCustomClass\"\r\n    [panelLeftSectionContent]=\"prescriptionDrugsText\"\r\n    [panelContentTooltip]=\"prescriptionDrugsTooltip\"\r\n    [isPanelContentTooltipExist]=\"showPrescriptionDrugsTooltip\"\r\n    [isHighLighted]=\"getDrugHighlightStyles()\"\r\n    [offScreenHighLightLabelText]=\"planCompareHighLightOffScreenText\"\r\n    [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n  >\r\n    <div\r\n      role=\"cell\"\r\n      [ngStyle]=\"getDrugHighlightStyles()\"\r\n      class=\"plan-compare-list-section text-center text-lg-left\"\r\n      [ngClass]=\"prescriptionRightSectionCustomClass\"\r\n      *ngFor=\"let plan of plans; index as i\"\r\n      nonCostSection\r\n      [attr.aria-colindex]=\"i + 1\"\r\n    >\r\n      <span class=\"sr-only no-translate-block\">{{ plan.planName }}</span>\r\n      <ng-container *ngIf=\"planCompareFacade.isPrescriptionDrugExist([plan]); else showNotApplicable\">\r\n        <ng-container *ngFor=\"let extendedDetails of plan.extendedPlanDetails | orderBy : 'ordinal'\">\r\n          <ng-container *ngFor=\"let sectionDetails of extendedDetails.sectionDetails | orderBy : 'ordinal'; index as index\">\r\n            <ng-container *ngIf=\"sectionDetails.valueTypeID === planBenefitValueType.DRUG_BENEFIT\">\r\n              <h3 class=\"Spa_Style_H4 prescription-benefits-header\" *ngIf=\"index === 0\">\r\n                {{ extendedDetails.name }}\r\n                <vnext-tooltip\r\n                  [body]=\"extendedDetails.toolTip\"\r\n                  [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                  *ngIf=\"extendedDetails.toolTip && index === 0\"\r\n                >\r\n                  <i class=\"fas fa-question-circle icon-tooltip\" aria-hidden=\"true\"></i>\r\n                </vnext-tooltip>\r\n              </h3>\r\n              <div class=\"Spa_Style_Note mb-1\">{{ sectionDetails.name }}: {{ sectionDetails.value }}</div>\r\n            </ng-container>\r\n          </ng-container>\r\n        </ng-container>\r\n      </ng-container>\r\n      <ng-template #showNotApplicable>{{ prescriptionDrugsNotApplicableText }}</ng-template>\r\n    </div>\r\n  </vnext-widget-plan-compare-panel>\r\n</div>\r\n", styles: [".gray1-static{background-color:var(--static-Spa_Style_Gray1)}.plan-compare-left-section{border-right:1px solid var(--static-Spa_Style_Accent1);padding:12px 14px 14px}.plan-compare-list-section{border-right:1px solid var(--static-Spa_Style_Accent1);padding:12px 6px 14px 14px}.plan-compare-list-section:last-child{border-right-width:0px}.prescription-coverage-section{border-bottom:1px solid var(--static-Spa_Style_Accent1)}.prescription-benefits-header{margin-top:18px}.prescription-benefits-header:first-child{margin-top:0}.plan-compare-list-section+.plan-compare-list-section{border-left-width:0!important}@media (max-width: 991.9px){.plan-compare-left-section{border-right-width:0px;border-bottom:1px solid var(--static-Spa_Style_Accent1);text-align:center}.plan-compare-list-section:last-child{border-left:1px solid var(--static-Spa_Style_Accent1)}}@media print{.plan-compare-left-section{border-right-width:1px}}\n"] }]
    }], function () { return [{ type: PlanCompareFacade }]; }, { plans: [{
            type: Input
        }], prescriptionLeftSectionCustomClass: [{
            type: Input
        }], prescriptionRightSectionCustomClass: [{
            type: Input
        }], prescriptionDeductibleText: [{
            type: Input
        }], prescriptionDeductibleTooltip: [{
            type: Input
        }], showPrescriptionDeductibleTooltip: [{
            type: Input
        }], prescriptionInitialCoverageText: [{
            type: Input
        }], prescriptionInitialCoverageTooltip: [{
            type: Input
        }], showPrescriptionInitialCoverageTooltip: [{
            type: Input
        }], prescriptionDrugsText: [{
            type: Input
        }], prescriptionDrugsTooltip: [{
            type: Input
        }], showPrescriptionDrugsTooltip: [{
            type: Input
        }], prescriptionDrugsNotApplicableText: [{
            type: Input
        }], prescriptionRightSectionCustomStyles: [{
            type: Input
        }], showHighlightPlanDifferences: [{
            type: Input
        }], planCompareHighLightOffScreenText: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }], showInitialCoverageLimit: [{
            type: Input
        }] }); })();

function PlanComparePrescriptionComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.searchPrescriptionsText);
} }
function PlanComparePrescriptionComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 5)(2, "h4", 6)(3, "span")(4, "span", 7);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 8);
    i0.ɵɵlistener("click", function PlanComparePrescriptionComponent_div_3_Template_span_click_6_listener() { const restoredCtx = i0.ɵɵrestoreView(_r6); const plan_r3 = restoredCtx.$implicit; const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onPrescriptionClickAction(plan_r3)); });
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const plan_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("plan-compare-list-section text-center text-lg-left ", ctx_r1.customRightSectionClass, "");
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-colindex", i_r4 + 1);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(plan_r3.planName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.prescriptionDirectoryLink.title, " ");
} }
function PlanComparePrescriptionComponent_div_4_div_6_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "i", 18);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r11.coveredDrugsText, " ");
} }
function PlanComparePrescriptionComponent_div_4_div_6_ng_template_6_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "vnext-link", 22);
    i0.ɵɵlistener("click", function PlanComparePrescriptionComponent_div_4_div_6_ng_template_6_div_3_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r17); const plan_r9 = i0.ɵɵnextContext(2).$implicit; const drug_r7 = i0.ɵɵnextContext().$implicit; const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.onViewPossibleAlternativeDrugsClick(plan_r9, drug_r7)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r14.showDrugAlternativesText)("alwaysUnderlined", true)("showArrow", "right");
} }
function PlanComparePrescriptionComponent_div_4_div_6_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "i", 19);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PlanComparePrescriptionComponent_div_4_div_6_ng_template_6_div_3_Template, 2, 3, "div", 20);
} if (rf & 2) {
    const plan_r9 = i0.ɵɵnextContext().$implicit;
    const drug_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.nonCoveredDrugsText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.showDrugAlternativesEnabled && (ctx_r13.planAttributeMap[plan_r9.id][drug_r7.dosageID] == null ? null : ctx_r13.planAttributeMap[plan_r9.id][drug_r7.dosageID].showDrugAlternatives));
} }
const _c0$Q = function (a0) { return { ndc: a0 }; };
function PlanComparePrescriptionComponent_div_4_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div")(2, "span", 7);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtemplate(5, PlanComparePrescriptionComponent_div_4_div_6_div_5_Template, 3, 1, "div", 15);
    i0.ɵɵtemplate(6, PlanComparePrescriptionComponent_div_4_div_6_ng_template_6_Template, 4, 2, "ng-template", null, 16, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const plan_r9 = ctx.$implicit;
    const i_r10 = ctx.index;
    const _r12 = i0.ɵɵreference(7);
    const drug_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("plan-compare-list-section text-center text-lg-left ", ctx_r8.customRightSectionClass, "");
    i0.ɵɵproperty("ngStyle", ctx_r8.planCompareFacade.getPreferencesHighlightStyles(ctx_r8.plans, ctx_r8.showHighlightPlanDifferences, i0.ɵɵpureFunction1(8, _c0$Q, drug_r7.dosage.ndc)));
    i0.ɵɵattribute("aria-colindex", i_r10 + 1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(plan_r9.planName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r8.planCompareFacade.isDrugCovered(plan_r9, drug_r7.dosage.ndc))("ngIfElse", _r12);
} }
function PlanComparePrescriptionComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "span", 1)(3, "span", 11);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, PlanComparePrescriptionComponent_div_4_div_6_Template, 8, 10, "div", 13);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const drug_r7 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("Spa_Style_H5 plan-compare-left-section m-0 ", ctx_r2.customLeftSectionClass, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(drug_r7.labelName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", ctx_r2.planCompareFacade.getDrugFreqencyAndQuantity(drug_r7.dosage, drug_r7.packageId), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.plans);
} }
class PlanComparePrescriptionComponent {
    constructor(planCompareFacade, drugDetailsFacade) {
        this.planCompareFacade = planCompareFacade;
        this.drugDetailsFacade = drugDetailsFacade;
        this.viewPossibleAlternativeDrugs = new EventEmitter(null);
        this.planAttributeMap = {};
    }
    ngOnChanges(changes) {
        if (this.showDrugAlternativesEnabled) {
            const { plans, medicineCabinet, selectedPharmacy, isMailOrderSelected } = changes;
            if (!_isEqual(plans?.currentValue, plans?.previousValue) ||
                !_isEqual(medicineCabinet?.currentValue, medicineCabinet?.previousValue) ||
                !_isEqual(selectedPharmacy?.currentValue, selectedPharmacy?.previousValue) ||
                !_isEqual(isMailOrderSelected?.currentValue, isMailOrderSelected?.previousValue)) {
                this.planAttributeMap = this.drugDetailsFacade.getPlanAttributeMapWithDrugAlternatives(this.plans, this.selectedPharmacy, this.medicineCabinet, this.isMailOrderSelected);
            }
        }
    }
    onViewPossibleAlternativeDrugsClick(plan, cabinet) {
        this.viewPossibleAlternativeDrugs.emit({ plan, cabinet });
    }
}
PlanComparePrescriptionComponent.ɵfac = function PlanComparePrescriptionComponent_Factory(t) { return new (t || PlanComparePrescriptionComponent)(i0.ɵɵdirectiveInject(PlanCompareFacade), i0.ɵɵdirectiveInject(DrugDetailsFacade)); };
PlanComparePrescriptionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanComparePrescriptionComponent, selectors: [["vnext-widget-plan-compare-prescription"]], inputs: { plans: "plans", medicineCabinet: "medicineCabinet", isMobile: "isMobile", coveredDrugsText: "coveredDrugsText", nonCoveredDrugsText: "nonCoveredDrugsText", customLeftSectionClass: "customLeftSectionClass", customRightSectionClass: "customRightSectionClass", showHighlightPlanDifferences: "showHighlightPlanDifferences", prescriptionDirectoryLink: "prescriptionDirectoryLink", searchPrescriptionsText: "searchPrescriptionsText", searchPrescriptionsKey: "searchPrescriptionsKey", showDrugAlternativesEnabled: "showDrugAlternativesEnabled", showDrugAlternativesText: "showDrugAlternativesText", selectedPharmacy: "selectedPharmacy", isMailOrderSelected: "isMailOrderSelected", onPrescriptionClickAction: "onPrescriptionClickAction" }, outputs: { viewPossibleAlternativeDrugs: "viewPossibleAlternativeDrugs" }, features: [i0.ɵɵNgOnChangesFeature], decls: 6, vars: 11, consts: [["role", "row", 1, "row", "mx-0", "drug-section"], ["role", "rowheader"], [4, "liveEditProp"], [3, "class", 4, "ngFor", "ngForOf"], ["class", "drug-section", 4, "ngFor", "ngForOf"], ["role", "cell"], [1, "mb-0"], [1, "sr-only", "no-translate-block"], [1, "Spa_Style_Link", "Spa_Style_Small_Font", "can-click", 3, "click"], [1, "drug-section"], ["role", "row", 1, "row", "mx-0"], [1, "no-translate-block", "d-block"], [1, "pt-2", "Spa_Style_Note", "d-block", 3, "innerHTML"], ["role", "cell", 3, "class", "ngStyle", 4, "ngFor", "ngForOf"], ["role", "cell", 3, "ngStyle"], ["class", "Spa_Style_H4 mb-0", 4, "ngIf", "ngIfElse"], ["nonCovered", ""], [1, "Spa_Style_H4", "mb-0"], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "covered-drugs"], ["aria-hidden", "true", 1, "fas", "fa-times-circle", "non-covered-drugs"], ["class", "mt-2", 4, "ngIf"], [1, "mt-2"], [3, "title", "alwaysUnderlined", "showArrow", "click"]], template: function PlanComparePrescriptionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
        i0.ɵɵtemplate(2, PlanComparePrescriptionComponent_span_2_Template, 2, 1, "span", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, PlanComparePrescriptionComponent_div_3_Template, 8, 6, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, PlanComparePrescriptionComponent_div_4_Template, 7, 6, "div", 4);
        i0.ɵɵpipe(5, "orderBy");
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("Spa_Style_H5 plan-compare-left-section m-0 ", ctx.customLeftSectionClass, "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", ctx.searchPrescriptionsKey);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.plans);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind4(5, 6, ctx.medicineCabinet, "labelName", false, true));
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, i1$2.NgStyle, LinkComponent, LiveEditPropDirective, IconAriaAttributesDirective, OrderPipe], styles: [".gray1-static[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray1)}.plan-compare-left-section[_ngcontent-%COMP%], .plan-compare-list-section[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);padding:12px 14px 14px}.plan-compare-list-section[_ngcontent-%COMP%]:last-child{border-right-width:0px}.drug-section[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Accent1)}.covered-drugs[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent5)}.non-covered-drugs[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent1)}@media (max-width: 991.9px){.plan-compare-left-section[_ngcontent-%COMP%]{border-right-width:0px;text-align:center}.plan-compare-list-section[_ngcontent-%COMP%]:last-child{border-left:1px solid var(--static-Spa_Style_Accent1)}}@media print{.plan-compare-left-section[_ngcontent-%COMP%]{border-right-width:1px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanComparePrescriptionComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-compare-prescription', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row mx-0 drug-section\" role=\"row\">\r\n  <span role=\"rowheader\" class=\"Spa_Style_H5 plan-compare-left-section m-0 {{ customLeftSectionClass }}\">\r\n    <span *liveEditProp=\"searchPrescriptionsKey\">{{ searchPrescriptionsText }}</span>\r\n  </span>\r\n  <div class=\"plan-compare-list-section text-center text-lg-left {{ customRightSectionClass }}\" *ngFor=\"let plan of plans; index as i\">\r\n    <div [attr.aria-colindex]=\"i + 1\" role=\"cell\">\r\n      <h4 class=\"mb-0\">\r\n        <span>\r\n          <span class=\"sr-only no-translate-block\">{{ plan.planName }}</span>\r\n          <span class=\"Spa_Style_Link Spa_Style_Small_Font can-click\" (click)=\"onPrescriptionClickAction(plan)\">\r\n            {{ prescriptionDirectoryLink.title }}\r\n          </span>\r\n        </span>\r\n      </h4>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"drug-section\" *ngFor=\"let drug of medicineCabinet | orderBy : 'labelName' : false : true\">\r\n  <div class=\"row mx-0\" role=\"row\">\r\n    <span role=\"rowheader\" class=\"Spa_Style_H5 plan-compare-left-section m-0 {{ customLeftSectionClass }}\">\r\n      <span class=\"no-translate-block d-block\">{{ drug.labelName }}</span>\r\n      <span class=\"pt-2 Spa_Style_Note d-block\" [innerHTML]=\"planCompareFacade.getDrugFreqencyAndQuantity(drug.dosage, drug.packageId)\"></span>\r\n    </span>\r\n    <div\r\n      role=\"cell\"\r\n      class=\"plan-compare-list-section text-center text-lg-left {{ customRightSectionClass }}\"\r\n      [ngStyle]=\"planCompareFacade.getPreferencesHighlightStyles(plans, showHighlightPlanDifferences, { ndc: drug.dosage.ndc })\"\r\n      *ngFor=\"let plan of plans; index as i\"\r\n      [attr.aria-colindex]=\"i + 1\"\r\n    >\r\n      <div>\r\n        <span class=\"sr-only no-translate-block\">{{ plan.planName }}</span>\r\n        <div>\r\n          <div class=\"Spa_Style_H4 mb-0\" *ngIf=\"planCompareFacade.isDrugCovered(plan, drug.dosage.ndc); else nonCovered\">\r\n            <i class=\"fas fa-check-circle covered-drugs\" aria-hidden=\"true\"></i> {{ coveredDrugsText }}\r\n          </div>\r\n          <ng-template #nonCovered>\r\n            <div class=\"Spa_Style_H4 mb-0\">\r\n              <i class=\"fas fa-times-circle non-covered-drugs\" aria-hidden=\"true\"></i>\r\n              {{ nonCoveredDrugsText }}\r\n            </div>\r\n            <div *ngIf=\"showDrugAlternativesEnabled && planAttributeMap[plan.id][drug.dosageID]?.showDrugAlternatives\" class=\"mt-2\">\r\n              <vnext-link\r\n                (click)=\"onViewPossibleAlternativeDrugsClick(plan, drug)\"\r\n                [title]=\"showDrugAlternativesText\"\r\n                [alwaysUnderlined]=\"true\"\r\n                [showArrow]=\"'right'\"\r\n              ></vnext-link>\r\n            </div>\r\n          </ng-template>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".gray1-static{background-color:var(--static-Spa_Style_Gray1)}.plan-compare-left-section,.plan-compare-list-section{border-right:1px solid var(--static-Spa_Style_Accent1);padding:12px 14px 14px}.plan-compare-list-section:last-child{border-right-width:0px}.drug-section{border-bottom:1px solid var(--static-Spa_Style_Accent1)}.covered-drugs{color:var(--static-Spa_Style_Accent5)}.non-covered-drugs{color:var(--static-Spa_Style_Accent1)}@media (max-width: 991.9px){.plan-compare-left-section{border-right-width:0px;text-align:center}.plan-compare-list-section:last-child{border-left:1px solid var(--static-Spa_Style_Accent1)}}@media print{.plan-compare-left-section{border-right-width:1px}}\n"] }]
    }], function () { return [{ type: PlanCompareFacade }, { type: DrugDetailsFacade }]; }, { plans: [{
            type: Input
        }], medicineCabinet: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], coveredDrugsText: [{
            type: Input
        }], nonCoveredDrugsText: [{
            type: Input
        }], customLeftSectionClass: [{
            type: Input
        }], customRightSectionClass: [{
            type: Input
        }], showHighlightPlanDifferences: [{
            type: Input
        }], prescriptionDirectoryLink: [{
            type: Input
        }], searchPrescriptionsText: [{
            type: Input
        }], searchPrescriptionsKey: [{
            type: Input
        }], showDrugAlternativesEnabled: [{
            type: Input
        }], showDrugAlternativesText: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], isMailOrderSelected: [{
            type: Input
        }], onPrescriptionClickAction: [{
            type: Input
        }], viewPossibleAlternativeDrugs: [{
            type: Output
        }] }); })();

function PlanCompareRidersComponent_ng_container_0_div_3_ng_container_5_span_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function PlanCompareRidersComponent_ng_container_0_div_3_ng_container_5_span_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵelement(1, "i", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r11.shoppingCartIncludedRiderText, " ");
} }
function PlanCompareRidersComponent_ng_container_0_div_3_ng_container_5_span_1_ng_template_4_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rider_r8 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r14 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", rider_r8.planName, ": ", i0.ɵɵpipeBind1(2, 2, ctx_r14.planDetailsFacade.getRiderMedicalPremium(rider_r8)), " ");
} }
function PlanCompareRidersComponent_ng_container_0_div_3_ng_container_5_span_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanCompareRidersComponent_ng_container_0_div_3_ng_container_5_span_1_ng_template_4_span_0_Template, 3, 4, "span", 14);
    i0.ɵɵelement(1, "vnext-plan-rider-details", 15);
} if (rf & 2) {
    const rider_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r13 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngIf", ctx_r13.planDetailsFacade.getRiderMedicalPremium(rider_r8) !== null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("rider", rider_r8)("showRiderDetails", ctx_r13.showRiderDetails)("hideRiderDetailsText", ctx_r13.hideRiderDetailsText)("showRiderDetailsText", ctx_r13.showRiderDetailsText);
} }
function PlanCompareRidersComponent_ng_container_0_div_3_ng_container_5_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, PlanCompareRidersComponent_ng_container_0_div_3_ng_container_5_span_1_ng_container_1_Template, 1, 0, "ng-container", 9);
    i0.ɵɵtemplate(2, PlanCompareRidersComponent_ng_container_0_div_3_ng_container_5_span_1_ng_template_2_Template, 3, 1, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, PlanCompareRidersComponent_ng_container_0_div_3_ng_container_5_span_1_ng_template_4_Template, 2, 5, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rider_r8 = ctx.$implicit;
    const _r10 = i0.ɵɵreference(3);
    const _r12 = i0.ɵɵreference(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", rider_r8.isRequiredRider)("ngIfThen", _r10)("ngIfElse", _r12);
} }
function PlanCompareRidersComponent_ng_container_0_div_3_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanCompareRidersComponent_ng_container_0_div_3_ng_container_5_span_1_Template, 6, 3, "span", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const plan_r3 = i0.ɵɵnextContext().$implicit;
    const riderCategory_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.planDetailsFacade.getRidersWithMatchingCategory(riderCategory_r1, plan_r3));
} }
function PlanCompareRidersComponent_ng_container_0_div_3_ng_template_6_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r19.notApplicableText, " ");
} }
function PlanCompareRidersComponent_ng_container_0_div_3_ng_template_6_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 18);
    i0.ɵɵtext(1);
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r21.riderNotSupportedText);
} }
function PlanCompareRidersComponent_ng_container_0_div_3_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanCompareRidersComponent_ng_container_0_div_3_ng_template_6_ng_container_0_Template, 2, 1, "ng-container", 7);
    i0.ɵɵtemplate(1, PlanCompareRidersComponent_ng_container_0_div_3_ng_template_6_ng_template_1_Template, 2, 1, "ng-template", null, 17, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r20 = i0.ɵɵreference(2);
    const plan_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r6.planCompareFacade.isCurrentOrNextYearPlan(plan_r3))("ngIfElse", _r20);
} }
function PlanCompareRidersComponent_ng_container_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "span")(3, "span", 6);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, PlanCompareRidersComponent_ng_container_0_div_3_ng_container_5_Template, 2, 1, "ng-container", 7);
    i0.ɵɵtemplate(6, PlanCompareRidersComponent_ng_container_0_div_3_ng_template_6_Template, 3, 2, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const plan_r3 = ctx.$implicit;
    const _r5 = i0.ɵɵreference(7);
    const riderCategory_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("", ctx_r2.riderRightSectionCustomClass, " plan-compare-list-section text-center text-lg-left");
    i0.ɵɵproperty("ngStyle", ctx_r2.planCompareFacade.getRiderDifferenceCustomStyles(ctx_r2.plans, riderCategory_r1, ctx_r2.showHighlightPlanDifferences));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(plan_r3.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.planDetailsFacade.showRiders(plan_r3, riderCategory_r1))("ngIfElse", _r5);
} }
function PlanCompareRidersComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "vnext-widget-plan-compare-panel", 2);
    i0.ɵɵtemplate(3, PlanCompareRidersComponent_ng_container_0_div_3_Template, 8, 7, "div", 3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const riderCategory_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("isSubSectionHeaderExist", false)("isPanelContentExist", true)("panelLeftSectionContent", ctx_r0.planDetailsFacade.getRiderLabel(riderCategory_r1))("customClass", ctx_r0.riderLeftSectionCustomClass)("showPanelContentIcon", ctx_r0.planDetailsFacade.isMedicareRiderSubType(riderCategory_r1))("panelContentIconClass", ctx_r0.planCompareFacade.getriderIconClass(riderCategory_r1))("isPanelContentTooltipExist", true)("panelContentTooltip", ctx_r0.planDetailsFacade.getWaiverTooltip(riderCategory_r1, ctx_r0.waiverStateRidersTooltips))("isHighLighted", ctx_r0.planCompareFacade.getRiderDifferenceCustomStyles(ctx_r0.plans, riderCategory_r1, ctx_r0.showHighlightPlanDifferences))("offScreenHighLightLabelText", ctx_r0.planCompareHighLightOffScreenText)("Spa_Site_Tooltip_Text", ctx_r0.Spa_Site_Tooltip_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.plans);
} }
class PlanCompareRidersComponent {
    constructor(planCompareFacade, planDetailsFacade) {
        this.planCompareFacade = planCompareFacade;
        this.planDetailsFacade = planDetailsFacade;
    }
}
PlanCompareRidersComponent.ɵfac = function PlanCompareRidersComponent_Factory(t) { return new (t || PlanCompareRidersComponent)(i0.ɵɵdirectiveInject(PlanCompareFacade), i0.ɵɵdirectiveInject(PlanDetailsFacade)); };
PlanCompareRidersComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCompareRidersComponent, selectors: [["vnext-widget-plan-compare-riders"]], inputs: { plans: "plans", waiverStateRidersTooltips: "waiverStateRidersTooltips", shoppingCartIncludedRiderText: "shoppingCartIncludedRiderText", riderLeftSectionCustomClass: "riderLeftSectionCustomClass", riderRightSectionCustomClass: "riderRightSectionCustomClass", riderNotSupportedText: "riderNotSupportedText", showPanelContentIcon: "showPanelContentIcon", notApplicableText: "notApplicableText", showHighlightPlanDifferences: "showHighlightPlanDifferences", showRiderDetailsText: "showRiderDetailsText", hideRiderDetailsText: "hideRiderDetailsText", showRiderDetails: "showRiderDetails", planCompareHighLightOffScreenText: "planCompareHighLightOffScreenText", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text" }, decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], [1, "plan-compare-benefit-section"], [3, "isSubSectionHeaderExist", "isPanelContentExist", "panelLeftSectionContent", "customClass", "showPanelContentIcon", "panelContentIconClass", "isPanelContentTooltipExist", "panelContentTooltip", "isHighLighted", "offScreenHighLightLabelText", "Spa_Site_Tooltip_Text"], ["nonCostSection", "", "role", "cell", 3, "ngStyle", "class", 4, "ngFor", "ngForOf"], ["nonCostSection", "", "role", "cell", 3, "ngStyle"], [1, "Spa_Style_H4", "mb-0"], [1, "sr-only", "no-translate-block"], [4, "ngIf", "ngIfElse"], ["riderNotSupported", ""], [4, "ngIf", "ngIfThen", "ngIfElse"], ["requiredRider", ""], ["normalRider", ""], [1, "Spa_Style_H4"], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "included-icon", "included"], ["class", "no-translate-block", 4, "ngIf"], [3, "rider", "showRiderDetails", "hideRiderDetailsText", "showRiderDetailsText"], [1, "no-translate-block"], ["showNotSupported", ""], ["aria-hidden", "true", 1, "fas", "fa-times-circle", "non-covered", "mr-2"]], template: function PlanCompareRidersComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanCompareRidersComponent_ng_container_0_Template, 4, 12, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.planCompareFacade.getRiderCategories(ctx.plans));
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, i1$2.NgStyle, IconAriaAttributesDirective, PlanRiderDetailsComponent, PlanComparePanelComponent, i1$2.CurrencyPipe], styles: [".gray1-static[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray1)}.plan-compare-left-section[_ngcontent-%COMP%], .plan-compare-list-section[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);padding:12px 14px 14px}.plan-compare-list-section[_ngcontent-%COMP%]:last-child{border-right-width:0px}.plan-compare-benefit-section[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Accent1)}.plan-compare-list-section[_ngcontent-%COMP%] + .plan-compare-list-section[_ngcontent-%COMP%]{border-left-width:0!important}.plan-compare-benefit-section[_ngcontent-%COMP%]:last-child{border-bottom:0px}.included[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent5)}.non-covered[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent1)}@media (max-width: 991.9px){.plan-compare-left-section[_ngcontent-%COMP%]{border-right-width:0px;border-bottom:1px solid var(--static-Spa_Style_Accent1);text-align:center}.plan-compare-list-section[_ngcontent-%COMP%]:last-child{border-left:1px solid var(--static-Spa_Style_Accent1)}}@media print{.plan-compare-left-section[_ngcontent-%COMP%]{border-right-width:1px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCompareRidersComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-compare-riders', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngFor=\"let riderCategory of planCompareFacade.getRiderCategories(plans)\">\r\n  <div class=\"plan-compare-benefit-section\">\r\n    <vnext-widget-plan-compare-panel\r\n      [isSubSectionHeaderExist]=\"false\"\r\n      [isPanelContentExist]=\"true\"\r\n      [panelLeftSectionContent]=\"planDetailsFacade.getRiderLabel(riderCategory)\"\r\n      [customClass]=\"riderLeftSectionCustomClass\"\r\n      [showPanelContentIcon]=\"planDetailsFacade.isMedicareRiderSubType(riderCategory)\"\r\n      [panelContentIconClass]=\"planCompareFacade.getriderIconClass(riderCategory)\"\r\n      [isPanelContentTooltipExist]=\"true\"\r\n      [panelContentTooltip]=\"planDetailsFacade.getWaiverTooltip(riderCategory, waiverStateRidersTooltips)\"\r\n      [isHighLighted]=\"planCompareFacade.getRiderDifferenceCustomStyles(plans, riderCategory, showHighlightPlanDifferences)\"\r\n      [offScreenHighLightLabelText]=\"planCompareHighLightOffScreenText\"\r\n      [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n    >\r\n      <div\r\n        nonCostSection\r\n        [ngStyle]=\"planCompareFacade.getRiderDifferenceCustomStyles(plans, riderCategory, showHighlightPlanDifferences)\"\r\n        class=\"{{ riderRightSectionCustomClass }} plan-compare-list-section text-center text-lg-left\"\r\n        *ngFor=\"let plan of plans\"\r\n        role=\"cell\"\r\n      >\r\n        <div class=\"Spa_Style_H4 mb-0\">\r\n          <span>\r\n            <span class=\"sr-only no-translate-block\">{{ plan.planName }}</span>\r\n            <ng-container *ngIf=\"planDetailsFacade.showRiders(plan, riderCategory); else riderNotSupported\">\r\n              <span *ngFor=\"let rider of planDetailsFacade.getRidersWithMatchingCategory(riderCategory, plan)\">\r\n                <ng-container *ngIf=\"rider.isRequiredRider; then requiredRider; else normalRider\"></ng-container>\r\n\r\n                <ng-template #requiredRider>\r\n                  <span class=\"Spa_Style_H4\">\r\n                    <i class=\"fas fa-check-circle included-icon included\" aria-hidden=\"true\"></i>\r\n                    {{ shoppingCartIncludedRiderText }}\r\n                  </span>\r\n                </ng-template>\r\n                <ng-template #normalRider>\r\n                  <span *ngIf=\"planDetailsFacade.getRiderMedicalPremium(rider) !== null\" class=\"no-translate-block\">\r\n                    {{ rider.planName }}: {{ planDetailsFacade.getRiderMedicalPremium(rider) | currency }}\r\n                  </span>\r\n                  <vnext-plan-rider-details\r\n                    [rider]=\"rider\"\r\n                    [showRiderDetails]=\"showRiderDetails\"\r\n                    [hideRiderDetailsText]=\"hideRiderDetailsText\"\r\n                    [showRiderDetailsText]=\"showRiderDetailsText\"\r\n                  ></vnext-plan-rider-details>\r\n                </ng-template>\r\n              </span>\r\n            </ng-container>\r\n            <ng-template #riderNotSupported>\r\n              <ng-container *ngIf=\"planCompareFacade.isCurrentOrNextYearPlan(plan); else showNotSupported\">\r\n                {{ notApplicableText }}\r\n              </ng-container>\r\n              <ng-template #showNotSupported>\r\n                <i class=\"fas fa-times-circle non-covered mr-2\" aria-hidden=\"true\"></i>{{ riderNotSupportedText }}</ng-template\r\n              >\r\n            </ng-template>\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </vnext-widget-plan-compare-panel>\r\n  </div>\r\n</ng-container>\r\n", styles: [".gray1-static{background-color:var(--static-Spa_Style_Gray1)}.plan-compare-left-section,.plan-compare-list-section{border-right:1px solid var(--static-Spa_Style_Accent1);padding:12px 14px 14px}.plan-compare-list-section:last-child{border-right-width:0px}.plan-compare-benefit-section{border-bottom:1px solid var(--static-Spa_Style_Accent1)}.plan-compare-list-section+.plan-compare-list-section{border-left-width:0!important}.plan-compare-benefit-section:last-child{border-bottom:0px}.included{color:var(--static-Spa_Style_Accent5)}.non-covered{color:var(--static-Spa_Style_Accent1)}@media (max-width: 991.9px){.plan-compare-left-section{border-right-width:0px;border-bottom:1px solid var(--static-Spa_Style_Accent1);text-align:center}.plan-compare-list-section:last-child{border-left:1px solid var(--static-Spa_Style_Accent1)}}@media print{.plan-compare-left-section{border-right-width:1px}}\n"] }]
    }], function () { return [{ type: PlanCompareFacade }, { type: PlanDetailsFacade }]; }, { plans: [{
            type: Input
        }], waiverStateRidersTooltips: [{
            type: Input
        }], shoppingCartIncludedRiderText: [{
            type: Input
        }], riderLeftSectionCustomClass: [{
            type: Input
        }], riderRightSectionCustomClass: [{
            type: Input
        }], riderNotSupportedText: [{
            type: Input
        }], showPanelContentIcon: [{
            type: Input
        }], notApplicableText: [{
            type: Input
        }], showHighlightPlanDifferences: [{
            type: Input
        }], showRiderDetailsText: [{
            type: Input
        }], hideRiderDetailsText: [{
            type: Input
        }], showRiderDetails: [{
            type: Input
        }], planCompareHighLightOffScreenText: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }] }); })();

function PlanQuoteBenefitDetailComponent_ng_container_5_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-plan-rider-category-detail", 9);
    i0.ɵɵlistener("riderBenefitDropdownSelection", function PlanQuoteBenefitDetailComponent_ng_container_5_ng_container_3_Template_vnext_plan_rider_category_detail_riderBenefitDropdownSelection_1_listener($event) { i0.ɵɵrestoreView(_r8); const benefitPlanIndex_r2 = i0.ɵɵnextContext().index; const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.onRiderBenefitDropdownSelection($event, benefitPlanIndex_r2, ctx_r6.quoteBenefitRider.riderGroupKey)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    const riderBenefitsPlan_r1 = ctx_r9.$implicit;
    const benefitPlanIndex_r2 = ctx_r9.index;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("riderCategory", riderBenefitsPlan_r1)("riderHIPBenefitDefaultDropdownText", ctx_r3.hospitalCareRiderBenefitDefaultDropdownText)("riderHIPBenefitText", ctx_r3.hospitalCareRiderBenefitText)("basePlanNames", ctx_r3.hospitalCareBasePlanNames)("showBenefitNote", !(ctx_r3.existsMedicarePlan && benefitPlanIndex_r2 !== 0));
} }
function PlanQuoteBenefitDetailComponent_ng_container_5_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r5.notAvailableRiderBenefitText);
} }
const _c0$P = function (a0) { return { "col-md-4": a0 }; };
const _c1$g = function (a0) { return { "plan-quote-rider-benefit-section-no-left-border": a0 }; };
function PlanQuoteBenefitDetailComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5)(2, "div", 6);
    i0.ɵɵtemplate(3, PlanQuoteBenefitDetailComponent_ng_container_5_ng_container_3_Template, 2, 5, "ng-container", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PlanQuoteBenefitDetailComponent_ng_container_5_ng_template_4_Template, 2, 1, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const riderBenefitsPlan_r1 = ctx.$implicit;
    const benefitPlanIndex_r2 = ctx.index;
    const _r4 = i0.ɵɵreference(5);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$P, ctx_r0.quoteBenefitRider.riderBenefitsPlans.length === 3));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$g, benefitPlanIndex_r2 === 0));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", riderBenefitsPlan_r1)("ngIfElse", _r4);
} }
const _c2$a = function (a0, a1) { return { "col-12 col-md-3": a0, "col-12 col-md-4": a1 }; };
const _c3$5 = function (a0, a1) { return { "col-12 col-md-9": a0, "col-12 col-md-8": a1 }; };
class PlanQuoteBenefitDetailComponent {
    constructor(planFacade) {
        this.planFacade = planFacade;
        this.isMedicarePlan = {};
        this.selectedRiderBenefit = new EventEmitter();
    }
    ngOnChanges(changes) {
        if (!_isEqual(changes.plans?.currentValue, changes.plans?.previousValue)) {
            this.existsMedicarePlan = this.plans.some(plan => this.isMedicare(plan));
            for (const plan of this.plans) {
                this.isMedicarePlan[plan.id] = this.isMedicare(plan);
            }
        }
    }
    isMedicare(plan) {
        return this.planFacade.isMedicareOnHospitalCare(plan, this.medicareTypes);
    }
    onRiderBenefitDropdownSelection(selected, planIndex, riderGroupKey) {
        this.selectedRiderBenefit.emit({
            selected,
            planIndex,
            riderGroupKey
        });
    }
    trackByRiderGroupKey(index, riderBenefitQuoting) {
        return riderBenefitQuoting ? `${index} - ${riderBenefitQuoting.riderGroupKey}` : `${index}`;
    }
}
PlanQuoteBenefitDetailComponent.ɵfac = function PlanQuoteBenefitDetailComponent_Factory(t) { return new (t || PlanQuoteBenefitDetailComponent)(i0.ɵɵdirectiveInject(PlanFacade)); };
PlanQuoteBenefitDetailComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanQuoteBenefitDetailComponent, selectors: [["vnext-widget-plan-quote-benefit-detail"]], inputs: { plans: "plans", quoteBenefitRider: "quoteBenefitRider", basePlanOptionLabel: "basePlanOptionLabel", hospitalCareBasePlanNames: "hospitalCareBasePlanNames", hospitalCareRiderBenefitDefaultDropdownText: "hospitalCareRiderBenefitDefaultDropdownText", hospitalCareRiderBenefitText: "hospitalCareRiderBenefitText", notAvailableRiderBenefitText: "notAvailableRiderBenefitText", medicareTypes: "medicareTypes" }, outputs: { selectedRiderBenefit: "selectedRiderBenefit" }, features: [i0.ɵɵNgOnChangesFeature], decls: 6, vars: 11, consts: [[1, "pl-0", "pr-0", "mt-2", "mt-md-0", "mb-4", "mb-md-0", 3, "ngClass"], [1, "Spa_Style_H5", "plan-quote-rider-benefit-section-left", "gray1-static", "category-header-text", "text-center", "text-md-left", "pt-3"], [1, "pl-0", "pr-0", 3, "ngClass"], ["role", "row", 1, "row", "ml-0", "mr-0"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "mx-0", "pr-0", "pl-0", "col-6", 3, "ngClass"], ["role", "cell", 1, "plan-quote-rider-benefit-section-right", "pt-3", 3, "ngClass"], [4, "ngIf", "ngIfElse"], ["nonBenefitsAvailable", ""], [3, "riderCategory", "riderHIPBenefitDefaultDropdownText", "riderHIPBenefitText", "basePlanNames", "showBenefitNote", "riderBenefitDropdownSelection"], [1, "Spa_Style_H3"]], template: function PlanQuoteBenefitDetailComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "h5", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(3, "div", 2)(4, "div", 3);
        i0.ɵɵtemplate(5, PlanQuoteBenefitDetailComponent_ng_container_5_Template, 6, 8, "ng-container", 4);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c2$a, ctx.plans.length === 3, ctx.plans.length === 2));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.quoteBenefitRider.riderGroupKey, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c3$5, ctx.plans.length === 3, ctx.plans.length === 2));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.quoteBenefitRider.riderBenefitsPlans)("ngForTrackBy", ctx.trackByRiderGroupKey);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, RiderCategoryDetailComponent], styles: ["button[_ngcontent-%COMP%], .btn[_ngcontent-%COMP%]{border:none}button[_ngcontent-%COMP%]:focus, .btn[_ngcontent-%COMP%]:focus{outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:inset 0 1px 1px var(--static-Spa_Style_Accent1),0 0 8px var(--static-Spa_Style_Accent1)}.category-header-text[_ngcontent-%COMP%]{padding-right:1rem}@media (min-width: 320px){.gray1-static[_ngcontent-%COMP%]{background-color:transparent}.plan-quote-rider-benefit-section-no-left-border[_ngcontent-%COMP%]{border-width:0 0 1px 0!important}.plan-quote-rider-benefit-section-left[_ngcontent-%COMP%]{border-width:0;padding:6px 0 0 10px;padding-right:1em!important}.plan-quote-rider-benefit-section-right[_ngcontent-%COMP%]{padding:4px 1em 15px;min-height:120px;height:100%;border:1px solid var(--static-Spa_Style_Accent1);border-width:0 0 1px 1px}.plan-quote-rider-benefit-accordion[_ngcontent-%COMP%]:last-child   .plan-quote-rider-benefit-section-left[_ngcontent-%COMP%]:last-child, .plan-quote-rider-benefit-accordion[_ngcontent-%COMP%]:last-child   .plan-quote-rider-benefit-section-right[_ngcontent-%COMP%]:last-child{border:0}}@media (min-width: 768px){.plan-quote-rider-benefit-section-no-left-border[_ngcontent-%COMP%]{border-width:0 0 1px 1px!important}.plan-quote-rider-benefit-section-left[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Accent1);height:100%}.gray1-static[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray1)}}@media print{.container[_ngcontent-%COMP%]{min-width:initial!important}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanQuoteBenefitDetailComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-quote-benefit-detail', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  [ngClass]=\"{\r\n    'col-12 col-md-3': plans.length === 3,\r\n    'col-12 col-md-4': plans.length === 2\r\n  }\"\r\n  class=\"pl-0 pr-0 mt-2 mt-md-0 mb-4 mb-md-0\"\r\n>\r\n  <h5\r\n    class=\"Spa_Style_H5 plan-quote-rider-benefit-section-left gray1-static category-header-text text-center text-md-left pt-3\"\r\n  >\r\n    {{ quoteBenefitRider.riderGroupKey }}\r\n  </h5>\r\n</div>\r\n\r\n<div\r\n  [ngClass]=\"{\r\n    'col-12 col-md-9': plans.length === 3,\r\n    'col-12 col-md-8': plans.length === 2\r\n  }\"\r\n  class=\"pl-0 pr-0\"\r\n>\r\n  <div role=\"row\" class=\"row ml-0 mr-0\">\r\n    <ng-container\r\n      *ngFor=\"let riderBenefitsPlan of quoteBenefitRider.riderBenefitsPlans; index as benefitPlanIndex; trackBy: trackByRiderGroupKey\"\r\n    >\r\n      <div\r\n        [ngClass]=\"{\r\n          'col-md-4': quoteBenefitRider.riderBenefitsPlans.length === 3\r\n        }\"\r\n        class=\"mx-0 pr-0 pl-0 col-6\"\r\n      >\r\n        <div\r\n          role=\"cell\"\r\n          [ngClass]=\"{\r\n            'plan-quote-rider-benefit-section-no-left-border': benefitPlanIndex === 0\r\n          }\"\r\n          class=\"plan-quote-rider-benefit-section-right pt-3\"\r\n        >\r\n          <ng-container *ngIf=\"riderBenefitsPlan; else nonBenefitsAvailable\">\r\n            <vnext-plan-rider-category-detail\r\n              [riderCategory]=\"riderBenefitsPlan\"\r\n              [riderHIPBenefitDefaultDropdownText]=\"hospitalCareRiderBenefitDefaultDropdownText\"\r\n              [riderHIPBenefitText]=\"hospitalCareRiderBenefitText\"\r\n              [basePlanNames]=\"hospitalCareBasePlanNames\"\r\n              [showBenefitNote]=\"!(existsMedicarePlan && benefitPlanIndex !== 0)\"\r\n              (riderBenefitDropdownSelection)=\"onRiderBenefitDropdownSelection($event, benefitPlanIndex, quoteBenefitRider.riderGroupKey)\"\r\n            >\r\n            </vnext-plan-rider-category-detail>\r\n          </ng-container>\r\n        </div>\r\n\r\n        <ng-template #nonBenefitsAvailable>\r\n          <h3 class=\"Spa_Style_H3\">{{ notAvailableRiderBenefitText }}</h3>\r\n        </ng-template>\r\n      </div>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n", styles: ["button,.btn{border:none}button:focus,.btn:focus{outline:0;border-color:var(--static-Spa_Style_Gray4);box-shadow:inset 0 1px 1px var(--static-Spa_Style_Accent1),0 0 8px var(--static-Spa_Style_Accent1)}.category-header-text{padding-right:1rem}@media (min-width: 320px){.gray1-static{background-color:transparent}.plan-quote-rider-benefit-section-no-left-border{border-width:0 0 1px 0!important}.plan-quote-rider-benefit-section-left{border-width:0;padding:6px 0 0 10px;padding-right:1em!important}.plan-quote-rider-benefit-section-right{padding:4px 1em 15px;min-height:120px;height:100%;border:1px solid var(--static-Spa_Style_Accent1);border-width:0 0 1px 1px}.plan-quote-rider-benefit-accordion:last-child .plan-quote-rider-benefit-section-left:last-child,.plan-quote-rider-benefit-accordion:last-child .plan-quote-rider-benefit-section-right:last-child{border:0}}@media (min-width: 768px){.plan-quote-rider-benefit-section-no-left-border{border-width:0 0 1px 1px!important}.plan-quote-rider-benefit-section-left{border-bottom:1px solid var(--static-Spa_Style_Accent1);height:100%}.gray1-static{background-color:var(--static-Spa_Style_Gray1)}}@media print{.container{min-width:initial!important}}\n"] }]
    }], function () { return [{ type: PlanFacade }]; }, { plans: [{
            type: Input
        }], quoteBenefitRider: [{
            type: Input
        }], basePlanOptionLabel: [{
            type: Input
        }], hospitalCareBasePlanNames: [{
            type: Input
        }], hospitalCareRiderBenefitDefaultDropdownText: [{
            type: Input
        }], hospitalCareRiderBenefitText: [{
            type: Input
        }], notAvailableRiderBenefitText: [{
            type: Input
        }], medicareTypes: [{
            type: Input
        }], selectedRiderBenefit: [{
            type: Output
        }] }); })();

function PlanQuoteBenefitDetailsComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "button", 6)(2, "span", 7)(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "i", 8);
    i0.ɵɵelementStart(6, "span", 9);
    i0.ɵɵtext(7, "Collapse");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.sectionHeaderText);
} }
function PlanQuoteBenefitDetailsComponent_ng_template_4_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-widget-plan-quote-benefit-detail", 11);
    i0.ɵɵlistener("selectedRiderBenefit", function PlanQuoteBenefitDetailsComponent_ng_template_4_ng_container_0_Template_vnext_widget_plan_quote_benefit_detail_selectedRiderBenefit_1_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r5.onRiderBenefitDropdownSelection($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const quoteBenefitRider_r4 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plans", ctx_r3.plans)("medicareTypes", ctx_r3.medicareTypes)("quoteBenefitRider", quoteBenefitRider_r4)("basePlanOptionLabel", ctx_r3.basePlanOptionLabel)("hospitalCareBasePlanNames", ctx_r3.hospitalCareBasePlanNames)("hospitalCareRiderBenefitDefaultDropdownText", ctx_r3.hospitalCareRiderBenefitDefaultDropdownText)("hospitalCareRiderBenefitText", ctx_r3.hospitalCareRiderBenefitText)("notAvailableRiderBenefitText", ctx_r3.notAvailableRiderBenefitText);
} }
function PlanQuoteBenefitDetailsComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanQuoteBenefitDetailsComponent_ng_template_4_ng_container_0_Template, 2, 8, "ng-container", 10);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", ctx_r1.quoteBenefitRiders)("ngForTrackBy", ctx_r1.trackByRiderGroupKey);
} }
class PlanQuoteBenefitDetailsComponent {
    constructor(planFacade, planDetailsFacade, cdr) {
        this.planFacade = planFacade;
        this.planDetailsFacade = planDetailsFacade;
        this.cdr = cdr;
        this.quoteBenefitRiders = [];
        this.selectedRiderBenefits = new EventEmitter();
    }
    ngOnChanges(changes) {
        if (!_isEqual(changes.plans?.currentValue, changes.plans?.previousValue) ||
            !_isEqual(changes.locale?.currentValue, changes.locale?.previousValue)) {
            this.generateHospitalCareRiderQuoteBenefits();
        }
    }
    onRiderBenefitDropdownSelection(selectedRiderBenefitItem) {
        const plan = this.plans[selectedRiderBenefitItem.planIndex];
        const riderBenefitCategoriesHospitalCare = [];
        const selectedRider = selectedRiderBenefitItem.selected?.rider;
        this.quoteBenefitRiders = this.quoteBenefitRiders.map(quoteBenefitRider => {
            const benefitPlan = quoteBenefitRider.riderBenefitsPlans[selectedRiderBenefitItem.planIndex];
            if (benefitPlan) {
                const riderBenefitsPlans = quoteBenefitRider.riderBenefitsPlans.map((riderBenefitsPlan, index) => {
                    if (index === selectedRiderBenefitItem.planIndex) {
                        if (quoteBenefitRider.riderGroupKey === selectedRiderBenefitItem.riderGroupKey) {
                            const riderCategorySelected = riderBenefitsPlan?.riders.find(rider => rider.planID === selectedRider?.planID);
                            const riderBenefitSelected = {
                                ...riderBenefitsPlan,
                                selectedRider: riderCategorySelected ? riderCategorySelected : null
                            };
                            riderBenefitCategoriesHospitalCare.push(riderBenefitSelected);
                            return riderBenefitSelected;
                        }
                        riderBenefitCategoriesHospitalCare.push(riderBenefitsPlan);
                    }
                    return riderBenefitsPlan;
                });
                return {
                    ...quoteBenefitRider,
                    riderBenefitsPlans
                };
            }
            return quoteBenefitRider;
        });
        this.quoteBenefitRiders = this.updateIncludedRiderBenefits(this.quoteBenefitRiders, selectedRiderBenefitItem.planIndex, selectedRiderBenefitItem.selected.rider).filter(quoteBenefitRider => this.totalNonAvailableBenefitsRider(quoteBenefitRider) < this.plans.length);
        const filteredRiderBenefitCategories = this.getFilteredRiderBenefitCategories(riderBenefitCategoriesHospitalCare);
        const selectedRiderBenefitCategories = filteredRiderBenefitCategories.map(riderCategory => ({
            riderGroupKey: riderCategory.riderGroupKey,
            selectedRiderId: riderCategory.selectedRider.planID
        }));
        this.planFacade.updatePlansRiderBenefitCategories(plan.id, selectedRiderBenefitCategories);
        this.emitSelectedRiderBenefitCategories(plan.id, filteredRiderBenefitCategories);
        this.cdr.markForCheck();
    }
    trackByRiderGroupKey(index, riderBenefitRow) {
        return riderBenefitRow.riderGroupKey;
    }
    getFilteredRiderBenefitCategories(selectedRiderBenefitCategories) {
        const filteredRiderCategories = selectedRiderBenefitCategories.filter(riderCategory => riderCategory?.selectedRider);
        return filteredRiderCategories;
    }
    emitSelectedRiderBenefitCategories(planId, filteredRiderBenefitCategories) {
        const selectedRiders = filteredRiderBenefitCategories.map(riderCategory => riderCategory?.selectedRider);
        this.selectedRiderBenefits.emit({
            planId,
            riders: selectedRiders
        });
    }
    updateIncludedRiderBenefits(quoteCategories, planIndex, rider) {
        const basePlanRiderNotes = this.planFacade.parseRidersNotes(rider);
        const includedCategories = quoteCategories.map(quoteCategory => {
            const riderBenefitsPlans = quoteCategory?.riderBenefitsPlans?.map((riderBenefitsPlan, index) => {
                if (planIndex === index && !riderBenefitsPlan?.selectable) {
                    let riderBenefitsPlanMatched = riderBenefitsPlan;
                    const baseNote = basePlanRiderNotes.find(basePlanRiderNote => basePlanRiderNote[0] === quoteCategory.riderGroupKey);
                    if (baseNote) {
                        riderBenefitsPlanMatched = this.planFacade.convertToRiderCategory(baseNote);
                    }
                    return riderBenefitsPlanMatched;
                }
                return riderBenefitsPlan;
            });
            return {
                ...quoteCategory,
                riderBenefitsPlans: riderBenefitsPlans ? riderBenefitsPlans : null
            };
        });
        return includedCategories;
    }
    generateHospitalCareRiderQuoteBenefits() {
        const benefits = this.plans.reduce((riderBenfits, plan) => {
            const riderCategories = this.planDetailsFacade.getRiderCategories(plan).map(riderCategory => {
                const riderSortProperty = 'calculatedMedicalPremium';
                const riderMatchingProperty = this.planFacade.isHCPlan(plan) ? 'planTypeDescription' : 'planSubType';
                const riders = this.planFacade.sortRiders(this.planDetailsFacade.getRidersWithMatchingCategory(riderCategory, plan, riderMatchingProperty), riderSortProperty);
                const riderBenefitCategory = {
                    riderGroupKey: riderCategory,
                    icon: '',
                    label: this.planDetailsFacade.getRiderLabel(riderCategory),
                    waiverTooltip: '',
                    waiverStateRider: false,
                    selectable: true,
                    riders,
                    selectedRider: null
                };
                return riderBenefitCategory;
            });
            return [
                ...riderBenfits,
                {
                    categories: riderCategories,
                    plan
                }
            ];
        }, []);
        const selectedBenefitsCategories = {};
        this.hospitalCareBasePlanNames = this.planFacade.getNamesHospitalCareBasePlans(this.planFacade.getRidersHospitalCareBasePlans(benefits));
        this.quoteBenefitRiders = this.planFacade
            .quoteHospitalCareBenefitCategories(benefits, this.basePlanOptionLabel)
            .map(quoteBenefitRider => {
            const riderBenefitsPlans = quoteBenefitRider.riderBenefitsPlans.map((riderBenefitsPlan, riderBenefitsPlanIndex) => {
                const benefitsPlan = riderBenefitsPlan;
                if (benefitsPlan?.selectedRider) {
                    const ridersSelectedOnMap = selectedBenefitsCategories[this.plans[riderBenefitsPlanIndex]?.id] ?? [];
                    selectedBenefitsCategories[this.plans[riderBenefitsPlanIndex]?.id] = [...ridersSelectedOnMap, benefitsPlan];
                }
                return benefitsPlan;
            });
            return { ...quoteBenefitRider, riderBenefitsPlans };
        })
            .filter(quoteBenefitRider => this.totalNonAvailableBenefitsRider(quoteBenefitRider) < this.plans.length);
        for (const plan of this.plans) {
            if (selectedBenefitsCategories[plan.id]) {
                const filteredRiderBenefitCategories = this.getFilteredRiderBenefitCategories(selectedBenefitsCategories[plan.id]);
                const selectedRiderBenefitCategories = filteredRiderBenefitCategories.map(riderCategory => ({
                    riderGroupKey: riderCategory.riderGroupKey,
                    selectedRiderId: riderCategory.selectedRider.planID
                }));
                this.planFacade.updatePlansRiderBenefitCategories(plan.id, selectedRiderBenefitCategories);
                this.emitSelectedRiderBenefitCategories(plan.id, filteredRiderBenefitCategories);
            }
        }
    }
    totalNonAvailableBenefitsRider(quoteBenefitRider) {
        return quoteBenefitRider.riderBenefitsPlans.reduce((count, riderBenefitsPlan) => (riderBenefitsPlan ? count : count + 1), 0);
    }
}
PlanQuoteBenefitDetailsComponent.ɵfac = function PlanQuoteBenefitDetailsComponent_Factory(t) { return new (t || PlanQuoteBenefitDetailsComponent)(i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(PlanDetailsFacade), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
PlanQuoteBenefitDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanQuoteBenefitDetailsComponent, selectors: [["vnext-widget-plan-quote-benefit-details"]], inputs: { plans: "plans", locale: "locale", basePlanOptionLabel: "basePlanOptionLabel", sectionHeaderText: "sectionHeaderText", hospitalCareRiderBenefitDefaultDropdownText: "hospitalCareRiderBenefitDefaultDropdownText", hospitalCareRiderBenefitText: "hospitalCareRiderBenefitText", notAvailableRiderBenefitText: "notAvailableRiderBenefitText", medicareTypes: "medicareTypes" }, outputs: { selectedRiderBenefits: "selectedRiderBenefits" }, features: [i0.ɵɵNgOnChangesFeature], decls: 5, vars: 0, consts: [[1, "plan-details-accordion"], ["activeIds", "riders-panel"], ["id", "riders-panel", 1, "card-header"], ["ngbPanelHeader", ""], ["ngbPanelContent", ""], [1, "d-flex", "align-items-center", "justify-content-between", "main-header", "Spa_Style_Accent6_Background"], ["ngbPanelToggle", "", "aria-expanded", "true", 1, "btn", "container-fluid", "text-left", "pl-0"], [1, "m-0", "Spa_Style_H2", "Spa_Style_Secondary_Text_Color", "text-center", "text-md-left"], [1, "fas", "fa-chevron-up", "pt-1", "float-right"], [1, "sr-only"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "row", "ml-0", "mr-0", 3, "plans", "medicareTypes", "quoteBenefitRider", "basePlanOptionLabel", "hospitalCareBasePlanNames", "hospitalCareRiderBenefitDefaultDropdownText", "hospitalCareRiderBenefitText", "notAvailableRiderBenefitText", "selectedRiderBenefit"]], template: function PlanQuoteBenefitDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "ngb-accordion", 1)(2, "ngb-panel", 2);
        i0.ɵɵtemplate(3, PlanQuoteBenefitDetailsComponent_ng_template_3_Template, 8, 1, "ng-template", 3);
        i0.ɵɵtemplate(4, PlanQuoteBenefitDetailsComponent_ng_template_4_Template, 1, 2, "ng-template", 4);
        i0.ɵɵelementEnd()()();
    } }, dependencies: [i1$2.NgForOf, IconAriaAttributesDirective, i1$1.NgbAccordion, i1$1.NgbPanel, i1$1.NgbPanelContent, i1$1.NgbPanelHeader, i1$1.NgbPanelToggle, PlanQuoteBenefitDetailComponent], styles: [".plan-details-accordion[_ngcontent-%COMP%]   .fa-chevron-up[_ngcontent-%COMP%]:before{content:\"\\f077\";font-size:22px}.plan-details-accordion[_ngcontent-%COMP%]   .collapsed[_ngcontent-%COMP%]   .fa-chevron-up[_ngcontent-%COMP%]:before{content:\"\\f078\"}.main-header[_ngcontent-%COMP%]{padding:3px 5px 3px 10px;min-height:60px}"], changeDetection: 0 });
__decorate([
    Memoize()
], PlanQuoteBenefitDetailsComponent.prototype, "totalNonAvailableBenefitsRider", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanQuoteBenefitDetailsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-quote-benefit-details', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"plan-details-accordion\">\r\n  <ngb-accordion activeIds=\"riders-panel\">\r\n    <ngb-panel id=\"riders-panel\" class=\"card-header\">\r\n      <ng-template ngbPanelHeader let-opened=\"open\">\r\n        <div class=\"d-flex align-items-center justify-content-between main-header Spa_Style_Accent6_Background\">\r\n          <button ngbPanelToggle class=\"btn container-fluid text-left pl-0\" aria-expanded=\"true\">\r\n            <span class=\"m-0 Spa_Style_H2 Spa_Style_Secondary_Text_Color text-center text-md-left\">\r\n              <span>{{ sectionHeaderText }}</span>\r\n              <i class=\"fas fa-chevron-up pt-1 float-right\"></i>\r\n              <span class=\"sr-only\">Collapse</span>\r\n            </span>\r\n          </button>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template ngbPanelContent>\r\n        <ng-container *ngFor=\"let quoteBenefitRider of quoteBenefitRiders; trackBy: trackByRiderGroupKey\">\r\n          <vnext-widget-plan-quote-benefit-detail\r\n            class=\"row ml-0 mr-0\"\r\n            [plans]=\"plans\"\r\n            [medicareTypes]=\"medicareTypes\"\r\n            [quoteBenefitRider]=\"quoteBenefitRider\"\r\n            [basePlanOptionLabel]=\"basePlanOptionLabel\"\r\n            [hospitalCareBasePlanNames]=\"hospitalCareBasePlanNames\"\r\n            [hospitalCareRiderBenefitDefaultDropdownText]=\"hospitalCareRiderBenefitDefaultDropdownText\"\r\n            [hospitalCareRiderBenefitText]=\"hospitalCareRiderBenefitText\"\r\n            [notAvailableRiderBenefitText]=\"notAvailableRiderBenefitText\"\r\n            (selectedRiderBenefit)=\"onRiderBenefitDropdownSelection($event)\"\r\n          ></vnext-widget-plan-quote-benefit-detail>\r\n        </ng-container>\r\n      </ng-template>\r\n    </ngb-panel>\r\n  </ngb-accordion>\r\n</div>\r\n", styles: [".plan-details-accordion .fa-chevron-up:before{content:\"\\f077\";font-size:22px}.plan-details-accordion .collapsed .fa-chevron-up:before{content:\"\\f078\"}.main-header{padding:3px 5px 3px 10px;min-height:60px}\n"] }]
    }], function () { return [{ type: PlanFacade }, { type: PlanDetailsFacade }, { type: i0.ChangeDetectorRef }]; }, { plans: [{
            type: Input
        }], locale: [{
            type: Input
        }], basePlanOptionLabel: [{
            type: Input
        }], sectionHeaderText: [{
            type: Input
        }], hospitalCareRiderBenefitDefaultDropdownText: [{
            type: Input
        }], hospitalCareRiderBenefitText: [{
            type: Input
        }], notAvailableRiderBenefitText: [{
            type: Input
        }], medicareTypes: [{
            type: Input
        }], selectedRiderBenefits: [{
            type: Output
        }], totalNonAvailableBenefitsRider: [] }); })();

function PlanCompareComponent_vnext_link_3_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 10);
    i0.ɵɵlistener("keyup.enter", function PlanCompareComponent_vnext_link_3_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.backToPrevious()); })("click", function PlanCompareComponent_vnext_link_3_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.backToPrevious()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r0.isDeepLink ? ctx_r0.Spa_Site_Plan_List_Link : ctx_r0.Spa_Site_Previous)("showArrow", "left")("makeInlineBlock", true)("role", ctx_r0.linkRoles.LINK);
} }
function PlanCompareComponent_ng_container_5_h1_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.Spa_PlanCompare_Header, " ");
} }
function PlanCompareComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanCompareComponent_ng_container_5_h1_1_Template, 2, 1, "h1", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_PlanCompare_Header");
} }
function PlanCompareComponent_ng_template_6_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.Spa_Hospital_Indemnity_QuoteSummary_Header, " ");
} }
function PlanCompareComponent_ng_template_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-hip-details-banner", 15);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("numberOfDaysText", ctx_r11.Spa_PlanFilters_DayLabel_Text)("daysText", ctx_r11.Spa_Site_Days_Text)("dayText", ctx_r11.Spa_Site_Day_Text)("editYourAnswersText", ctx_r11.Spa_PlanList_MedSupEditAnswersBanner_Text)("lumpSumText", ctx_r11.Spa_Site_LumpSum_Text)("basePlanText", ctx_r11.Spa_Site_HIP_BasePlanOption_Text)("daysAmount", ctx_r11.numberOfDaysHIPAnswer)("benefitAmount", ctx_r11.benefitAmountHIPAnswer);
} }
function PlanCompareComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanCompareComponent_ng_template_6_div_0_Template, 2, 1, "div", 13);
    i0.ɵɵtemplate(1, PlanCompareComponent_ng_template_6_ng_container_1_Template, 2, 8, "ng-container", 9);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("liveEditProp", "Spa_Hospital_Indemnity_QuoteSummary_Header");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.areAnyPlansHIP);
} }
function PlanCompareComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 16);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r4.Spa_Site_PageSubHeader_Text ? i0.ɵɵpipeBind2(1, 1, ctx_r4.Spa_Site_PageSubHeader_Text, "html") : "", i0.ɵɵsanitizeHtml);
} }
function PlanCompareComponent_ng_container_10_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 21);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tagsToUpdate", ctx_r12.tagsToUpdate)("saveDefaultValues", ctx_r12.analyticsService.isDefaultTagToUpdate);
} }
function PlanCompareComponent_ng_container_10_div_3_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r15.Spa_PlanCompare_Header, " actions");
} }
function PlanCompareComponent_ng_container_10_div_3_div_10_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 41);
    i0.ɵɵlistener("click", function PlanCompareComponent_ng_container_10_div_3_div_10_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r20.planCompareFacade.openSendQuoteModal()); })("keyup.enter", function PlanCompareComponent_ng_container_10_div_3_div_10_button_2_Template_button_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r21); const ctx_r22 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r22.planCompareFacade.openSendQuoteModal()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r18.Spa_Site_SendQuote_Button_Text, " ");
} }
function PlanCompareComponent_ng_container_10_div_3_div_10_vnext_pharmacy_selector_3_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-pharmacy-selector", 42);
    i0.ɵɵlistener("selectMailOrder", function PlanCompareComponent_ng_container_10_div_3_div_10_vnext_pharmacy_selector_3_Template_vnext_pharmacy_selector_selectMailOrder_0_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r23.planCompareFacade.switchMailOrder(true)); })("selectPharmacy", function PlanCompareComponent_ng_container_10_div_3_div_10_vnext_pharmacy_selector_3_Template_vnext_pharmacy_selector_selectPharmacy_0_listener($event) { i0.ɵɵrestoreView(_r24); const ctx_r25 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r25.planCompareFacade.updateSelectedPharamcyAndFetchPlanDetails($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("preferencesBannerEnabled", ctx_r19.Spa_PreferenceBanner_Enabled)("pharmacySelectorTextKey", "Spa_Site_CostBasedOn_Text")("pharmacySelectorText", ctx_r19.Spa_Site_CostBasedOn_Text)("pharmacies", ctx_r19.selectedPharmacies)("selectedPharmacy", ctx_r19.selectedPharmacy)("preferredInNetworkText", ctx_r19.Spa_Site_Preferred_In_Network_Text)("standardInNetworkText", ctx_r19.Spa_Site_Standard_In_Network_Text)("outOfNetworkText", ctx_r19.Spa_Site_Out_Of_Network_Text)("mailOrderText", ctx_r19.Spa_PlanList_MailOrder_Text)("isMailOrderSelected", ctx_r19.mailOrder)("showMailOrderOption", ctx_r19.planCompareFacade.isMailOrderPharmacyAvailable(ctx_r19.plans));
} }
const _c0$O = function (a0) { return [a0]; };
function PlanCompareComponent_ng_container_10_div_3_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 36)(1, "vnext-checkbox-group", 37);
    i0.ɵɵlistener("change", function PlanCompareComponent_ng_container_10_div_3_div_10_Template_vnext_checkbox_group_change_1_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r26.onPlanDifferenceSelected()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, PlanCompareComponent_ng_container_10_div_3_div_10_button_2_Template, 2, 1, "button", 38);
    i0.ɵɵtemplate(3, PlanCompareComponent_ng_container_10_div_3_div_10_vnext_pharmacy_selector_3_Template, 1, 11, "vnext-pharmacy-selector", 39);
    i0.ɵɵelement(4, "vnext-effective-date-display", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", ctx_r16.getPlanCompareCustomClass(ctx_r16.isMobile, ctx_r16.isMedium, ctx_r16.plans.length, true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("items", i0.ɵɵpureFunction1(8, _c0$O, ctx_r16.showDifferencesCheckBoxItem))("customStyles", ctx_r16.getPlanDifferenceStyles(ctx_r16.isMobile, ctx_r16.isMedium))("enablePrimaryColor", true)("customClass", "Spa_Style_Bold_Weight Spa_Style_Primary_Color");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r16.disableSendQuote(ctx_r16.plans) && ctx_r16.isAddToQuoteAvailable(ctx_r16.plans));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.planCompareFacade.showPharmacySelectorToggle() && ctx_r16.selectedPharmacy);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("activePlanType", ctx_r16.activeTabType);
} }
function PlanCompareComponent_ng_container_10_div_3_vnext_widget_plan_compare_pagination_11_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-widget-plan-compare-pagination", 43);
    i0.ɵɵlistener("pageChanged", function PlanCompareComponent_ng_container_10_div_3_vnext_widget_plan_compare_pagination_11_Template_vnext_widget_plan_compare_pagination_pageChanged_0_listener($event) { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r28.onMobileComparePageChanged($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("planCount", ctx_r17.allMobilePlans == null ? null : ctx_r17.allMobilePlans.length);
} }
const _c1$f = function (a0, a1, a2) { return { "sticky": a0, "sticky-top-hip": a1, "sticky-top-hip-medicare": a2 }; };
const _c2$9 = function (a0) { return { "gray1-static": a0 }; };
const _c3$4 = function (a0, a1, a2, a3, a4, a5, a6) { return { "col-12": a0, "col-8": a1, "col-9": a2, "offset-md-4": a3, "offset-md-3": a4, "ml-0": a5, "plan-compare-card-quote-summary": a6 }; };
function PlanCompareComponent_ng_container_10_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "div", 23)(2, "div", 24);
    i0.ɵɵtemplate(3, PlanCompareComponent_ng_container_10_div_3_span_3_Template, 2, 1, "span", 25);
    i0.ɵɵelementStart(4, "span", 26);
    i0.ɵɵtext(5, "Plan descriptions");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(6, "div", 27)(7, "div", 28);
    i0.ɵɵelement(8, "vnext-widget-plan-compare-card-label", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 30);
    i0.ɵɵtemplate(10, PlanCompareComponent_ng_container_10_div_3_div_10_Template, 5, 10, "div", 31);
    i0.ɵɵtemplate(11, PlanCompareComponent_ng_container_10_div_3_vnext_widget_plan_compare_pagination_11_Template, 1, 1, "vnext-widget-plan-compare-pagination", 32);
    i0.ɵɵelement(12, "vnext-widget-plan-compare-card-label", 33);
    i0.ɵɵelementStart(13, "div", 34)(14, "vnext-widget-plan-compare-card", 35);
    i0.ɵɵlistener("viewPlanDetailsPage", function PlanCompareComponent_ng_container_10_div_3_Template_vnext_widget_plan_compare_card_viewPlanDetailsPage_14_listener($event) { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r30.viewPlanDetailsPage($event)); })("removePlanFromCompare", function PlanCompareComponent_ng_container_10_div_3_Template_vnext_widget_plan_compare_card_removePlanFromCompare_14_listener($event) { i0.ɵɵrestoreView(_r31); const ctx_r32 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r32.removePlanFromCompare($event)); });
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(64, _c1$f, ctx_r13.Spa_PlanCompare_StickyMiniCart_Enabled && !ctx_r13.isMobile, ctx_r13.Spa_PlanCompare_StickyMiniCart_Enabled && ctx_r13.isQuoteSummaryMode && !ctx_r13.isMobile, ctx_r13.Spa_PlanCompare_StickyMiniCart_Enabled && ctx_r13.isQuoteSummaryMode && ctx_r13.areAnyPlansMAPD && ctx_r13.plans.length === 3 && !ctx_r13.isMobile));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", "Spa_PlanCompare_Header");
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-colspan", ctx_r13.plans.length);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("plans", ctx_r13.plans)("isMobile", ctx_r13.isMobile)("isMedium", ctx_r13.isMedium)("currentPlanText", ctx_r13.Spa_Site_Current_Plan_Text)("nextYearPlanText", ctx_r13.Spa_Site_Next_Year_Plan_Text)("optionOneText", ctx_r13.Spa_Site_Plan_Option_One_Text)("optionTwoText", ctx_r13.Spa_Site_Plan_Option_Two_Text)("displayOptionLabels", ctx_r13.Spa_Retention_ClientDefinedPlanOptions_Enabled)("disableNextYearDisplay", ctx_r13.memberHasOptionsDefined && ctx_r13.Spa_Retention_ClientDefinedPlanOptions_Enabled)("nonCommissionableText", ctx_r13.Spa_PlanDetails_NonCommissionable_Text)("isNonCommissionableFlagCheckEnabled", ctx_r13.Spa_PlanDetails_NonCommissionable_FlagCheck_Enabled)("customClass", ctx_r13.getPlanCompareCustomClass(ctx_r13.isMobile, ctx_r13.isMedium, ctx_r13.plans.length, true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(68, _c2$9, ctx_r13.isQuoteSummaryMode && !ctx_r13.isMedium && !ctx_r13.isMobile));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r13.isQuoteSummaryMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.isMobile && (ctx_r13.allMobilePlans == null ? null : ctx_r13.allMobilePlans.length) === 3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r13.getPlanCompareCustomClass(ctx_r13.isMobile, ctx_r13.isMedium, ctx_r13.plans.length, true))("plans", ctx_r13.plans)("isMobile", ctx_r13.isMobile)("isMedium", ctx_r13.isMedium)("currentPlanText", ctx_r13.Spa_Site_Current_Plan_Text)("nextYearPlanText", ctx_r13.Spa_Site_Next_Year_Plan_Text)("optionOneText", ctx_r13.Spa_Site_Plan_Option_One_Text)("optionTwoText", ctx_r13.Spa_Site_Plan_Option_Two_Text)("displayOptionLabels", ctx_r13.Spa_Retention_ClientDefinedPlanOptions_Enabled)("nonCommissionableText", ctx_r13.Spa_PlanDetails_NonCommissionable_Text)("isNonCommissionableFlagCheckEnabled", ctx_r13.Spa_PlanDetails_NonCommissionable_FlagCheck_Enabled)("disableNextYearDisplay", ctx_r13.memberHasOptionsDefined && ctx_r13.Spa_Retention_ClientDefinedPlanOptions_Enabled)("customClass", ctx_r13.getPlanCompareCustomClass(ctx_r13.isMobile, ctx_r13.isMedium, ctx_r13.plans.length));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction7(70, _c3$4, ctx_r13.isMobile || ctx_r13.isMedium, ctx_r13.plans.length === 2 && !ctx_r13.isMobile && !ctx_r13.isMedium, ctx_r13.plans.length === 3 && !ctx_r13.isMobile && !ctx_r13.isMedium, ctx_r13.plans.length === 2 && ctx_r13.isQuoteSummaryMode, ctx_r13.plans.length === 3 && ctx_r13.isQuoteSummaryMode, ctx_r13.plans.length === 2 && ctx_r13.isQuoteSummaryMode && ctx_r13.isMedium, ctx_r13.isQuoteSummaryMode));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plans", ctx_r13.plans)("planRidersMap", ctx_r13.planRidersMap)("showLogo", ctx_r13.Spa_Site_Show_PlanLogo)("planTypes", ctx_r13.Spa_PlanDetails_HIP_Call_Out_Available_Plan_Types)("medicareTypes", ctx_r13.Spa_PlanDetails_HIP_Call_Out_Available_Plan_Types)("activeTabType", ctx_r13.activeTabType)("planDetailsButton", ctx_r13.Spa_PlanCard_PlanDetails_ButtonText)("isRetentionView", ctx_r13.isRetentionView)("isMobile", ctx_r13.isMobile)("isMedium", ctx_r13.isMedium)("locale", ctx_r13.locale)("currentPlanText", ctx_r13.Spa_Site_Current_Plan_Text)("nextYearPlanText", ctx_r13.Spa_Site_Next_Year_Plan_Text)("isCurrentYearPlanExist", ctx_r13.currentYearPlanExists(ctx_r13.plans))("planCardQuoteLinkText", ctx_r13.Spa_PlanCard_QuoteLinkName_Text)("showPlanViewDetails", ctx_r13.Spa_Site_PlanViewDetails_Enabled)("removePlanText", ctx_r13.Spa_Remove_Plan_Text)("hospitalIndemnityBadgeText", ctx_r13.Spa_Site_HIP_Description)("monthlyPremiumText", ctx_r13.Spa_Site_HIP_MonthlyPremium_Text)("planLogoSize", ctx_r13.Spa_Site_PlanLogo_Size)("isAncillaryAddToCartEnabled", ctx_r13.Spa_PlanCard_AncillaryAddtoCart_Enabled)("stickyMiniCartEnabled", ctx_r13.Spa_PlanCompare_StickyMiniCart_Enabled)("planFeesEnabled", ctx_r13.Spa_Site_PlanFees_Enabled)("planFeesTooltipText", ctx_r13.Spa_PlanFees_Tooltip_Text)("planFeesIncludedInPremiumTooltipText", ctx_r13.Spa_PlanFees_IncludedInPremium_Tooltip_Text)("planFeesNotIncludedInPremiumTooltipText", ctx_r13.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text)("snpPremiumRangeEnabled", ctx_r13.Spa_Display_SNP_PremiumRange_Enabled)("showRemovePlanButtonForMobile", ctx_r13.isMobile && ctx_r13.Spa_PlanCompare_Remove_Mobile_Enabled && (ctx_r13.allMobilePlans == null ? null : ctx_r13.allMobilePlans.length) === 3)("removeModalHeaderText", ctx_r13.Spa_PlanCard_Compare_Remove_Modal_Header_Text)("removeModalIntroText", ctx_r13.Spa_PlanCard_Compare_Remove_Modal_Intro_Text)("removeModalCancelText", ctx_r13.Spa_Site_Cancel)("removeModalButtonText", ctx_r13.Spa_PlanCard_Compare_Remove_Modal_Button_Text);
} }
function PlanCompareComponent_ng_container_10_div_4_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 50);
    i0.ɵɵelement(1, "vnext-plan-level-content", 51);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r38 = ctx.$implicit;
    const i_r39 = ctx.index;
    const ctx_r37 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", ctx_r37.getPlanCompareCustomClass(ctx_r37.isMobile, ctx_r37.isMedium, ctx_r37.plans.length));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", plan_r38)("isComparePage", true)("notApplicableText", ctx_r37.Spa_Site_NotApplicable_Text)("planLevelContentLabel", ctx_r37.planLevelContentLabel[plan_r38.planTypeAbbreviation])("colIndex", i_r39 + 1);
} }
function PlanCompareComponent_ng_container_10_div_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-widget-plan-compare-panel", 48);
    i0.ɵɵtemplate(2, PlanCompareComponent_ng_container_10_div_4_ng_container_1_div_2_Template, 2, 6, "div", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(3);
    let tmp_5_0;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isSubSectionHeaderExist", false)("isPanelContentExist", true)("customClass", ctx_r33.getPlanCompareCustomClass(ctx_r33.isMobile, ctx_r33.isMedium, ctx_r33.plans.length, true, true))("isPanelLeftSectionLiveEditable", true)("panelLeftSectionLiveEditTag", ctx_r33.planCompareFacade.getPlanLevelContentResourceTag())("panelLeftSectionContent", ctx_r33.planLevelContentLabel[(tmp_5_0 = ctx_r33.planCompareFacade.getSelectedCompareGroup()) == null ? null : tmp_5_0.groupKey.values[0]])("Spa_Site_Tooltip_Text", ctx_r33.Spa_Site_Tooltip_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r33.plans);
} }
function PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_ng_container_1_div_1_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-cost-section", 61);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r44 = i0.ɵɵnextContext().$implicit;
    const cost_r41 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r46 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("preferencesBannerEnabled", ctx_r46.Spa_PreferenceBanner_Enabled)("healthEnabled", ctx_r46.Spa_Site_Health_Enabled)("isComparePage", true)("costDetails", ctx_r46.getCostDetails(cost_r41))("plan", plan_r44)("costAddEditLinkText", ctx_r46.Spa_Plandetails_Costs_Add_Edit_Link_Text)("noCostAvailableText", ctx_r46.Spa_Site_NotApplicable_Text)("selectedPharmacy", ctx_r46.selectedPharmacy)("annualCost", i0.ɵɵpipeBind1(2, 13, ctx_r46.planDetailsFacade.getAnnualCost$(plan_r44)))("addHealthCostText", ctx_r46.Spa_HealthCostsTab_AddAgeHealth_Text)("planFeesEnabled", ctx_r46.Spa_Site_PlanFees_Enabled)("planFeesIncludedInPremiumTooltipText", ctx_r46.Spa_PlanFees_IncludedInPremium_Tooltip_Text)("planFeesNotIncludedInPremiumTooltipText", ctx_r46.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text);
} }
function PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_ng_container_1_div_1_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-cost-section", 62);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r44 = i0.ɵɵnextContext().$implicit;
    const cost_r41 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r47 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("preferencesBannerEnabled", ctx_r47.Spa_PreferenceBanner_Enabled)("healthEnabled", ctx_r47.Spa_Site_Health_Enabled)("isComparePage", true)("costDetails", ctx_r47.getCostDetails(cost_r41))("plan", plan_r44)("costAddEditLinkText", ctx_r47.Spa_Plandetails_Costs_Add_Edit_Link_Text)("noCostAvailableText", ctx_r47.Spa_Site_NotApplicable_Text)("selectedPharmacy", ctx_r47.selectedPharmacy)("annualCost", i0.ɵɵpipeBind1(2, 11, ctx_r47.planDetailsFacade.getAnnualCost$(plan_r44, ctx_r47.mailOrder)))("isMailOrderSelected", ctx_r47.mailOrder)("addHealthCostText", ctx_r47.Spa_HealthCostsTab_AddAgeHealth_Text);
} }
function PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_ng_container_1_div_1_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-cost-section", 63);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r44 = i0.ɵɵnextContext().$implicit;
    const cost_r41 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r48 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("preferencesBannerEnabled", ctx_r48.Spa_PreferenceBanner_Enabled)("healthEnabled", ctx_r48.Spa_Site_Health_Enabled)("isComparePage", true)("costDetails", ctx_r48.getCostDetails(cost_r41))("plan", plan_r44)("costAddEditLinkText", ctx_r48.Spa_Plandetails_Costs_Add_Edit_Link_Text)("noCostAvailableText", ctx_r48.Spa_Site_NotApplicable_Text)("selectedPharmacy", ctx_r48.selectedPharmacy)("annualCost", i0.ɵɵpipeBind1(2, 10, ctx_r48.planDetailsFacade.getAnnualCost$(plan_r44, false)))("addHealthCostText", ctx_r48.Spa_HealthCostsTab_AddAgeHealth_Text);
} }
function PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_ng_container_1_div_1_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-cost-section", 64);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r44 = i0.ɵɵnextContext().$implicit;
    const cost_r41 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r49 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("preferencesBannerEnabled", ctx_r49.Spa_PreferenceBanner_Enabled)("healthEnabled", ctx_r49.Spa_Site_Health_Enabled)("isComparePage", true)("costDetails", ctx_r49.getCostDetails(cost_r41))("plan", plan_r44)("costAddEditLinkText", ctx_r49.Spa_Plandetails_Costs_Add_Edit_Link_Text)("noCostAvailableText", ctx_r49.Spa_Site_NotApplicable_Text)("selectedPharmacy", ctx_r49.selectedPharmacy)("isMailOrderSelected", ctx_r49.mailOrder)("annualCost", i0.ɵɵpipeBind1(2, 11, ctx_r49.planDetailsFacade.getAnnualCost$(plan_r44, ctx_r49.mailOrder)))("addHealthCostText", ctx_r49.Spa_HealthCostsTab_AddAgeHealth_Text);
} }
function PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_ng_container_1_div_1_div_2_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-cost-section", 65);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r44 = i0.ɵɵnextContext().$implicit;
    const cost_r41 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r50 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("preferencesBannerEnabled", ctx_r50.Spa_PreferenceBanner_Enabled)("isComparePage", true)("costDetails", i0.ɵɵpureFunction1(8, _c0$O, cost_r41))("plan", plan_r44)("planFeesEnabled", ctx_r50.Spa_Site_PlanFees_Enabled)("noCostAvailableText", ctx_r50.Spa_Site_NotApplicable_Text)("planFeesIncludedInPremiumTooltipText", ctx_r50.Spa_PlanFees_IncludedInPremium_Tooltip_Text)("planFeesNotIncludedInPremiumTooltipText", ctx_r50.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text);
} }
function PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_ng_container_1_div_1_div_2_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-cost-section", 65);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r44 = i0.ɵɵnextContext().$implicit;
    const cost_r41 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r51 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("preferencesBannerEnabled", ctx_r51.Spa_PreferenceBanner_Enabled)("isComparePage", true)("costDetails", i0.ɵɵpureFunction1(8, _c0$O, cost_r41))("plan", plan_r44)("planFeesEnabled", ctx_r51.Spa_Site_PlanFees_Enabled)("noCostAvailableText", ctx_r51.Spa_Site_NotApplicable_Text)("planFeesIncludedInPremiumTooltipText", ctx_r51.Spa_PlanFees_IncludedInPremium_Tooltip_Text)("planFeesNotIncludedInPremiumTooltipText", ctx_r51.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text);
} }
function PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_ng_container_1_div_1_div_2_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-plan-cost-section", 65);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r44 = i0.ɵɵnextContext().$implicit;
    const cost_r41 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r52 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("preferencesBannerEnabled", ctx_r52.Spa_PreferenceBanner_Enabled)("isComparePage", true)("costDetails", i0.ɵɵpureFunction1(8, _c0$O, cost_r41))("plan", plan_r44)("planFeesEnabled", ctx_r52.Spa_Site_PlanFees_Enabled)("noCostAvailableText", ctx_r52.Spa_Site_NotApplicable_Text)("planFeesIncludedInPremiumTooltipText", ctx_r52.Spa_PlanFees_IncludedInPremium_Tooltip_Text)("planFeesNotIncludedInPremiumTooltipText", ctx_r52.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text);
} }
const _c4$2 = function (a0, a1) { return { costTitle: a0, isMailOrder: a1 }; };
function PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_ng_container_1_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 58)(1, "div", 59);
    i0.ɵɵtemplate(2, PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_ng_container_1_div_1_div_2_div_2_Template, 3, 15, "div", 60);
    i0.ɵɵtemplate(3, PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_ng_container_1_div_1_div_2_div_3_Template, 3, 13, "div", 60);
    i0.ɵɵtemplate(4, PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_ng_container_1_div_1_div_2_div_4_Template, 3, 12, "div", 60);
    i0.ɵɵtemplate(5, PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_ng_container_1_div_1_div_2_div_5_Template, 3, 13, "div", 60);
    i0.ɵɵtemplate(6, PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_ng_container_1_div_1_div_2_div_6_Template, 2, 10, "div", 60);
    i0.ɵɵtemplate(7, PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_ng_container_1_div_1_div_2_div_7_Template, 2, 10, "div", 60);
    i0.ɵɵtemplate(8, PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_ng_container_1_div_1_div_2_div_8_Template, 2, 10, "div", 60);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const plan_r44 = ctx.$implicit;
    const i_r45 = ctx.index;
    const cost_r41 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r43 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngStyle", ctx_r43.getPlanCompareStyles(ctx_r43.plans, i0.ɵɵpureFunction2(11, _c4$2, cost_r41.title, ctx_r43.mailOrder)))("ngClass", ctx_r43.getPlanCompareCustomClass(ctx_r43.isMobile, ctx_r43.isMedium, ctx_r43.plans.length, false, false, cost_r41.title));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", plan_r44.planType);
    i0.ɵɵattribute("aria-colindex", i_r45 + 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r43.planType.MEDIGAP);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r43.planType.MAPD);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r43.planType.MA);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r43.planType.PDP);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r43.planType.DENTAL);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r43.planType.VISION);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r43.planType.HC);
} }
function PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 55)(1, "vnext-widget-plan-compare-panel", 56);
    i0.ɵɵtemplate(2, PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_ng_container_1_div_1_div_2_Template, 9, 14, "div", 57);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const cost_r41 = i0.ɵɵnextContext().$implicit;
    const ctx_r42 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isSubSectionHeaderExist", false)("isPanelContentExist", true)("customClass", ctx_r42.getPlanCompareCustomClass(ctx_r42.isMobile, ctx_r42.isMedium, ctx_r42.plans.length, true, true, cost_r41.title))("panelLeftSectionContent", ctx_r42.isTotalEstimatedCostAnnually ? cost_r41.label : cost_r41.label2)("panelLeftCostDetails", cost_r41)("healthEnabled", ctx_r42.Spa_Site_Health_Enabled && !ctx_r42.isQuoteSummaryMode)("costAddEditLinkText", ctx_r42.Spa_Plandetails_Costs_Add_Edit_Link_Text)("plans", ctx_r42.plans)("isSubTextExist", true)("healthCostText", ctx_r42.isTotalEstimatedCostAnnually ? cost_r41.label : cost_r41.label2)("isHighLighted", ctx_r42.getPlanCompareStyles(ctx_r42.plans, i0.ɵɵpureFunction2(16, _c4$2, cost_r41.title, ctx_r42.mailOrder)))("offScreenHighLightLabelText", ctx_r42.Spa_Plan_Compare_HighLight_OffScreenText)("Spa_Site_Tooltip_Text", ctx_r42.Spa_Site_Tooltip_Text)("showEffectiveDateText", ctx_r42.showEffectiveDateText)("effectiveDateText", ctx_r42.effectiveDateText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r42.plans);
} }
function PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_ng_container_1_div_1_Template, 3, 19, "div", 54);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const cost_r41 = ctx.$implicit;
    const ctx_r40 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r40.showCost(cost_r41.title));
} }
function PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-widget-plan-compare-accordion", 52);
    i0.ɵɵtemplate(1, PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_ng_container_1_Template, 2, 1, "ng-container", 53);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("accordionId", "plan-cost-container")("accordionSectionHeader", ctx_r34.Spa_PlanDetails_Costs_Header)("isLiveEditable", true)("headerPropertyName", "Spa_PlanDetails_Costs_Header")("accordionIsOpen", true)("plansLength", ctx_r34.plans.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r34.getCostBasedOnPlanType(ctx_r34.plans));
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_panel_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-plan-compare-panel", 79);
} if (rf & 2) {
    const ctx_r69 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("subSectionHeader", ctx_r69.Spa_PlanCompare_MedicalCoverage_Text)("tooltipContent", ctx_r69.Spa_PlanCompare_MedicalCoverage_Tooltip)("isTooltipExist", ctx_r69.Spa_PlanCompare_Show_MedicalCoverage_Tooltip)("isSubSectionHeaderExist", true)("Spa_Site_Tooltip_Text", ctx_r69.Spa_Site_Tooltip_Text)("plans", ctx_r69.plans);
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_panel_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-plan-compare-panel", 79);
} if (rf & 2) {
    const ctx_r70 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("subSectionHeader", ctx_r70.Spa_PlanCompare_PrescriptionDrugCoverage_Text)("tooltipContent", ctx_r70.Spa_PlanCompare_PrescriptionDrugCoverage_Tooltip)("isTooltipExist", ctx_r70.Spa_PlanCompare_Show_PrescriptionDrugCoverage_Tooltip)("isSubSectionHeaderExist", true)("Spa_Site_Tooltip_Text", ctx_r70.Spa_Site_Tooltip_Text)("plans", ctx_r70.plans);
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_prescription_coverage_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-plan-compare-prescription-coverage", 80);
} if (rf & 2) {
    const ctx_r71 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("plans", ctx_r71.plans)("prescriptionLeftSectionCustomClass", ctx_r71.getPlanCompareCustomClass(ctx_r71.isMobile, ctx_r71.isMedium, ctx_r71.plans.length, true, true))("prescriptionRightSectionCustomStyles", ctx_r71.highlightStyles)("showHighlightPlanDifferences", ctx_r71.showDifferences)("prescriptionRightSectionCustomClass", ctx_r71.getPlanCompareCustomClass(ctx_r71.isMobile, ctx_r71.isMedium, ctx_r71.plans.length))("prescriptionDeductibleText", ctx_r71.Spa_Plan_Compare_PrescriptionDeductible_Text)("prescriptionDeductibleTooltip", ctx_r71.Spa_Plan_Compare_PrescriptionDeductible_Tooltip)("showPrescriptionDeductibleTooltip", ctx_r71.Spa_Plan_Compare_ShowPrescriptionDeductible_Tooltip)("prescriptionInitialCoverageText", ctx_r71.Spa_Plan_Compare_PrescriptionInitialCoverageLimit_Text)("prescriptionInitialCoverageTooltip", ctx_r71.Spa_Plan_Compare_PrescriptionInitialCoverageLimit_Tooltip)("showPrescriptionInitialCoverageTooltip", ctx_r71.Spa_Plan_Compare_ShowPrescriptionInitialCoverageLimit_Tooltip)("prescriptionDrugsText", ctx_r71.Spa_Plan_Compare_PrescriptionDrugs_Text)("prescriptionDrugsTooltip", ctx_r71.Spa_Plan_Compare_PrescriptionDrugs_Tooltip)("showPrescriptionDrugsTooltip", ctx_r71.Spa_Plan_Compare_ShowPrescriptionDrugs_Tooltip)("prescriptionDrugsNotApplicableText", ctx_r71.Spa_Site_NotApplicable_Text)("planCompareHighLightOffScreenText", ctx_r71.Spa_Plan_Compare_HighLight_OffScreenText)("Spa_Site_Tooltip_Text", ctx_r71.Spa_Site_Tooltip_Text)("showInitialCoverageLimit", ctx_r71.Spa_PlanCompare_Benefit_Show_InitialCoverageLimit);
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 89);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r81 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r81.Spa_Plan_Compare_HighLight_OffScreenText, " ");
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r82 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r82.Spa_Plan_Providers_Search_Provider_Text);
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_2_div_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r92 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 93);
    i0.ɵɵlistener("click", function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_2_div_4_ng_template_2_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r92); const plan_r84 = i0.ɵɵnextContext().$implicit; const ctx_r90 = i0.ɵɵnextContext(7); return i0.ɵɵresetView(ctx_r90.onProviderClick(plan_r84)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r86 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r86.Spa_Plan_Providers_Directory_Link, " ");
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_2_div_4_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-link", 94);
} if (rf & 2) {
    const plan_r84 = i0.ɵɵnextContext().$implicit;
    const ctx_r87 = i0.ɵɵnextContext(7);
    i0.ɵɵproperty("title", ctx_r87.Spa_Plan_Providers_Directory_Link)("alwaysUnderlined", true)("href", plan_r84.providerURL)("linkTarget", "_blank");
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_2_div_4_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r96 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 95);
    i0.ɵɵelement(1, "vnext-link", 94);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span", 93);
    i0.ɵɵlistener("click", function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_2_div_4_ng_template_4_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r96); const plan_r84 = i0.ɵɵnextContext().$implicit; const ctx_r94 = i0.ɵɵnextContext(7); return i0.ɵɵresetView(ctx_r94.onProviderClick(plan_r84)); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r84 = i0.ɵɵnextContext().$implicit;
    const ctx_r88 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r88.Spa_Plan_Providers_Carrier_Directory_Link_Text)("alwaysUnderlined", true)("href", plan_r84.providerURL)("linkTarget", "_blank");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r88.Spa_Plan_Providers_Internal_Directory_Link_Text, " ");
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_2_div_4_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r89 = i0.ɵɵnextContext(8);
    i0.ɵɵtextInterpolate1(" ", ctx_r89.Spa_Site_NotApplicable_Text, " ");
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 90)(1, "div", 59);
    i0.ɵɵtemplate(2, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_2_div_4_ng_template_2_Template, 2, 1, "ng-template", 91);
    i0.ɵɵtemplate(3, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_2_div_4_ng_template_3_Template, 1, 4, "ng-template", 91);
    i0.ɵɵtemplate(4, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_2_div_4_ng_template_4_Template, 4, 5, "ng-template", 91);
    i0.ɵɵtemplate(5, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_2_div_4_ng_template_5_Template, 1, 1, "ng-template", 92);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const plan_r84 = ctx.$implicit;
    const i_r85 = ctx.index;
    const ctx_r83 = i0.ɵɵnextContext(7);
    i0.ɵɵproperty("ngClass", ctx_r83.getPlanCompareCustomClass(ctx_r83.isMobile, ctx_r83.isMedium, ctx_r83.plans.length));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r83.getProviderLinkType(plan_r84));
    i0.ɵɵattribute("aria-colindex", i_r85 + 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r83.providersLinkType.INTERNAL);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r83.providersLinkType.EXTERNAL);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r83.providersLinkType.INTERNAL_AND_EXTERNAL);
} }
const _c5$2 = function () { return { isProvider: true }; };
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 84);
    i0.ɵɵtemplate(1, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_2_div_1_Template, 2, 1, "div", 85);
    i0.ɵɵelementStart(2, "span", 86);
    i0.ɵɵtemplate(3, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_2_span_3_Template, 2, 1, "span", 87);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_2_div_4_Template, 6, 6, "div", 88);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r79 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r79.planCompareFacade.getPreferencesHighlightStyles(ctx_r79.plans, ctx_r79.showDifferences, i0.ɵɵpureFunction0(4, _c5$2)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r79.getPlanCompareCustomClass(ctx_r79.isMobile, ctx_r79.isMedium, ctx_r79.plans.length, true, true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Plan_Providers_Search_Provider_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r79.plans);
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 99);
    i0.ɵɵelement(2, "vnext-plan-provider-details", 100);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const plan_r101 = ctx.$implicit;
    const i_r102 = ctx.index;
    const ctx_r103 = i0.ɵɵnextContext();
    const index_r99 = ctx_r103.index;
    const provider_r98 = ctx_r103.$implicit;
    const ctx_r100 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("plan-compare-list-section ", ctx_r100.getPlanCompareCustomClass(ctx_r100.isMobile, ctx_r100.isMedium, ctx_r100.plans.length), "");
    i0.ɵɵattribute("data-highlight-differences", index_r99)("aria-colindex", i_r102 + 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("planId", plan_r101.id)("provider", provider_r98)("isComparePage", true)("providerDetailResponse", ctx_r100.providerDetailResponse)("selectedProviderDetails", ctx_r100.planFacade.getSelectedProviderDetails(plan_r101.id, ctx_r100.providerDetailResponse, provider_r98))("inNetworkProviderText", ctx_r100.Spa_Provider_InNetwork_Text)("outOfNetworkProviderText", ctx_r100.Spa_Provider_OutOfNetwork_Text)("pcpText", ctx_r100.Spa_Site_Pcp_Text)("noProviderDetailsText", ctx_r100.Spa_Providers_No_Data_Exist_Text)("isMobile", ctx_r100.isMobile)("showNetworkDetails", true)("noProviderNetworkAccessText", ctx_r100.Spa_Providers_NoProviderNetworkAccess_Text)("noProviderDetailsText", ctx_r100.Spa_Providers_No_Data_Exist_Text)("hasProviderDetails", plan_r101.showProviderSearch)("canSellPlan", ctx_r100.planFacade.canSellPlan(plan_r101))("viewAllText", ctx_r100.Spa_Site_ViewAll_Text)("hideText", ctx_r100.Spa_Site_Hide_Text)("providerInfoEnabled", ctx_r100.providerInfoEnabled)("acceptingNewPatientsIcon", ctx_r100.Spa_Providers_AcceptingNewPatients_Icon)("acceptingNewPatientsText", ctx_r100.Spa_Providers_AcceptingNewPatients_Text)("providerLanguages", ctx_r100.languagesByPlanMap[plan_r101.id])("providerMedicalGroups", ctx_r100.planProviderMedicalGroups == null ? null : ctx_r100.planProviderMedicalGroups[plan_r101.id] == null ? null : ctx_r100.planProviderMedicalGroups[plan_r101.id].providers)("providersAcceptingNewPatients", ctx_r100.providersAcceptingNewPatientsByPlanMap[plan_r101.id])("countryCode", ctx_r100.countryCode)("isZelisIntegrationEnabled", ctx_r100.Spa_Site_ZelisIntegration_Enabled);
    i0.ɵɵattribute("data-highlight-differences-provider-details", index_r99)("data-highlight-ignore-text", plan_r101.planName);
} }
const _c6$2 = function (a0, a1) { return { plans: a0, providerDetails: a1 }; };
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 96)(1, "div", 97)(2, "div");
    i0.ɵɵelement(3, "vnext-plan-provider-details", 98);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_3_ng_container_4_Template, 3, 32, "ng-container", 53);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const provider_r98 = ctx.$implicit;
    const index_r99 = ctx.index;
    const ctx_r80 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("vnextHighlightDifferences", "data-highlight-differences-provider-details")("showDifferences", ctx_r80.showDifferences)("selectorsRowIndex", index_r99)("trackChanges", i0.ɵɵpureFunction2(30, _c6$2, ctx_r80.plans, ctx_r80.providerDetailResponse));
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("plan-compare-left-section ", ctx_r80.getPlanCompareCustomClass(ctx_r80.isMobile, ctx_r80.isMedium, ctx_r80.plans.length, true, true), "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("planId", ctx_r80.plans[0].id)("provider", provider_r98)("customClass", "Spa_Style_H5 m-0")("isComparePage", true)("showProviderDetails", true)("providerInfoEnabled", ctx_r80.providerInfoEnabled)("providerDetailResponse", ctx_r80.providerDetailResponse)("selectedProviderDetails", provider_r98)("pcpText", ctx_r80.Spa_Site_Pcp_Text)("isMobile", ctx_r80.isMobile)("isMedium", ctx_r80.isMedium)("acceptingNewPatientsIcon", ctx_r80.Spa_Providers_AcceptingNewPatients_Icon)("acceptingNewPatientsText", ctx_r80.Spa_Providers_AcceptingNewPatients_Text)("languagesIcon", ctx_r80.Spa_Providers_Languages_Icon)("providerLanguages", ctx_r80.languagesByPlanMap[ctx_r80.plans[0].id])("providerMedicalGroups", ctx_r80.planProviderMedicalGroups == null ? null : ctx_r80.planProviderMedicalGroups[ctx_r80.plans[0].id] == null ? null : ctx_r80.planProviderMedicalGroups[ctx_r80.plans[0].id].providers)("providersAcceptingNewPatients", ctx_r80.providersAcceptingNewPatientsByPlanMap[ctx_r80.plans[0].id])("countryCode", ctx_r80.countryCode)("isVbcAgreementEnabled", ctx_r80.Spa_Site_ValueBasedCare_Agreement_Enabled)("vbcAgreementLabel", ctx_r80.Spa_Site_ValueBasedCare_Agreement_Label)("vbcAgreementTooltip", ctx_r80.Spa_Site_ValueBasedCare_Agreement_Tooltip)("isZelisIntegrationEnabled", ctx_r80.Spa_Site_ZelisIntegration_Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r80.plans);
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-widget-plan-compare-panel", 81);
    i0.ɵɵtemplate(2, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_2_Template, 5, 5, "div", 82);
    i0.ɵɵtemplate(3, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_div_3_Template, 5, 33, "div", 83);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r75 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isSubSectionHeaderExist", true)("isProvidersEnabled", ctx_r75.Spa_Site_Providers_Enabled)("customClass", ctx_r75.getPlanCompareCustomClass(ctx_r75.isMobile, ctx_r75.isMedium, ctx_r75.plans.length, true, true))("headerPropertyName", "Spa_Plan_Details_Preferences_Provider_Text")("subSectionHeader", ctx_r75.Spa_Plan_Details_Preferences_Provider_Text)("iconClass", "fas fa-user-md icon Spa_Style_ProvidersIcon")("isPreferencesSection", true)("Spa_Site_Tooltip_Text", ctx_r75.Spa_Site_Tooltip_Text)("linkPropertyName", "Spa_Providers_Add_Edit_Link")("linkTitle", ctx_r75.Spa_Providers_Add_Edit_Link)("tag", ctx_r75.pageTags.GUIDED_HELP_PROVIDER_SEARCH)("plans", ctx_r75.plans);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r75.hasProviderUrlForAllPlans(ctx_r75.plans));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r75.selectedProviderList)("ngForTrackBy", ctx_r75.trackByProvider);
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r105 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-widget-plan-compare-panel", 101);
    i0.ɵɵelementStart(2, "vnext-widget-plan-compare-prescription", 102);
    i0.ɵɵlistener("viewPossibleAlternativeDrugs", function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_2_Template_vnext_widget_plan_compare_prescription_viewPossibleAlternativeDrugs_2_listener($event) { i0.ɵɵrestoreView(_r105); const ctx_r104 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r104.onViewPossibleAlternativeDrugs($event.plan, $event.cabinet)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r76 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isSubSectionHeaderExist", true)("customClass", ctx_r76.getPlanCompareCustomClass(ctx_r76.isMobile, ctx_r76.isMedium, ctx_r76.plans.length, true, true))("headerPropertyName", "Spa_Plan_Details_Preferences_Prescription_Text")("subSectionHeader", ctx_r76.Spa_Plan_Details_Preferences_Prescription_Text)("linkPropertyName", "Spa_Site_Pharmacy_AddEdit_Link")("iconClass", "Spa_Style_PrescriptionsIcon")("linkTitle", ctx_r76.Spa_Prescription_Add_Edit_Link)("tag", ctx_r76.pageTags.GUIDED_HELP_PRESCRIPTIONS)("isPreferencesSection", true)("Spa_Site_Tooltip_Text", ctx_r76.Spa_Site_Tooltip_Text)("plans", ctx_r76.plans);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("medicineCabinet", ctx_r76.planCompareFacade.getMedicineCabinet())("plans", ctx_r76.plans)("showHighlightPlanDifferences", ctx_r76.showDifferences)("coveredDrugsText", ctx_r76.Spa_PlanDetails_Covered_Text)("nonCoveredDrugsText", ctx_r76.Spa_PlanDetails_Non_Covered_Text)("isMobile", ctx_r76.isMobile)("customLeftSectionClass", ctx_r76.getPlanCompareCustomClass(ctx_r76.isMobile, ctx_r76.isMedium, ctx_r76.plans.length, true, true))("customRightSectionClass", ctx_r76.getPlanCompareCustomClass(ctx_r76.isMobile, ctx_r76.isMedium, ctx_r76.plans.length))("prescriptionDirectoryLink", ctx_r76.Spa_PlanDetails_Preferences_PrescriptionDirectory_Link)("searchPrescriptionsText", ctx_r76.Spa_PlanDetails_Preferences_SearchPrescriptions_Text)("searchPrescriptionsKey", "Spa_PlanDetails_Preferences_SearchPrescriptions_Text")("onPrescriptionClickAction", ctx_r76.onPrescriptionClick)("showDrugAlternativesEnabled", ctx_r76.Spa_Site_ShowDrugAlternatives_Enabled && ctx_r76.Spa_PlanCompare_ShowDrugAlternatives_Nudge_Enabled)("showDrugAlternativesText", ctx_r76.Spa_Prescriptions_ShowDrugAlternatives_ViewAlternatives_Text)("selectedPharmacy", ctx_r76.selectedPharmacy)("isMailOrderSelected", ctx_r76.mailOrder);
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r106 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r106.Spa_PlanDetails_Preferences_SearchPharmacy_Text, " ");
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r112 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 105)(1, "div")(2, "span", 106);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "h4", 107)(5, "span", 93);
    i0.ɵɵlistener("click", function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_div_5_Template_span_click_5_listener() { const restoredCtx = i0.ɵɵrestoreView(_r112); const plan_r109 = restoredCtx.$implicit; const ctx_r111 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r111.onPharmacyClick(plan_r109)); });
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const plan_r109 = ctx.$implicit;
    const i_r110 = ctx.index;
    const ctx_r107 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("ngClass", ctx_r107.getPlanCompareCustomClass(ctx_r107.isMobile, ctx_r107.isMedium, ctx_r107.plans.length));
    i0.ɵɵattribute("aria-colindex", i_r110 + 1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(plan_r109.planName);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r107.Spa_PlanDetails_Preferences_PharmacyDirectory_Link.title, " ");
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_ng_container_6_div_1_ng_container_5_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r119 = i0.ɵɵnextContext(9);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("(", ctx_r119.Spa_Site_PrimaryPharmacy_Indicator_Text, ")");
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_ng_container_6_div_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_ng_container_6_div_1_ng_container_5_span_1_Template, 2, 1, "span", 9);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const primaryPharmacy_r118 = ctx.ngIf;
    const pharmacy_r115 = i0.ɵɵnextContext().$implicit;
    const ctx_r116 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", primaryPharmacy_r118 && pharmacy_r115.nabp === primaryPharmacy_r118.nabp && ctx_r116.planCompareFacade.showPharmacySelectorToggle());
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_ng_container_6_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 114)(1, "div")(2, "span", 106);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "vnext-plan-pharmacy-details", 115);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const plan_r121 = ctx.$implicit;
    const i_r122 = ctx.index;
    const pharmacy_r115 = i0.ɵɵnextContext().$implicit;
    const ctx_r117 = i0.ɵɵnextContext(7);
    i0.ɵɵclassMapInterpolate1("plan-compare-list-section ", ctx_r117.getPlanCompareCustomClass(ctx_r117.isMobile, ctx_r117.isMedium, ctx_r117.plans.length), "");
    i0.ɵɵproperty("ngStyle", ctx_r117.planCompareFacade.getPreferencesHighlightStyles(ctx_r117.plans, ctx_r117.showDifferences, null, pharmacy_r115));
    i0.ɵɵattribute("aria-colindex", i_r122 + 1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(plan_r121.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isComparePage", true)("pharmacies", ctx_r117.planCompareFacade.getDetailsOfSelectedPharmacy(i0.ɵɵpipeBind1(5, 14, ctx_r117.getPharmacyInfoForPlan$(plan_r121.id)), pharmacy_r115))("planName", plan_r121.planName)("inNetworkPreferredText", ctx_r117.Spa_Pharmacy_InNetwork_Preferred_Pricing_Text)("inNetworkStandardText", ctx_r117.Spa_Pharmacy_InNetwork_Standard_Pricing_Text)("outOfNetworkText", ctx_r117.Spa_Pharmacy_OutOfNetwork_Pricing_Text)("nonCoveredText", ctx_r117.Spa_PlanDetails_Non_Covered_Text)("showNotCovered", ctx_r117.planCompareFacade.isPlanPharmacyNotCovered(plan_r121));
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 110)(1, "div", 97)(2, "div", 111)(3, "span", 112);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_ng_container_6_div_1_ng_container_5_Template, 2, 1, "ng-container", 9);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_ng_container_6_div_1_div_7_Template, 6, 16, "div", 113);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const pharmacy_r115 = ctx.$implicit;
    const ctx_r113 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("Spa_Style_H5 plan-compare-left-section m-0 ", ctx_r113.getPlanCompareCustomClass(ctx_r113.isMobile, ctx_r113.isMedium, ctx_r113.plans.length, true, true), "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(pharmacy_r115.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(6, 6, ctx_r113.planCompareFacade.getPrimaryPharmacy$()));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r113.plans);
} }
const _c7$1 = function () { return { mailOrder: true }; };
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_ng_container_6_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 114);
    i0.ɵɵelement(1, "vnext-mail-order-pharmacy-details", 116);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r125 = ctx.$implicit;
    const i_r126 = ctx.index;
    const ctx_r124 = i0.ɵɵnextContext(8);
    i0.ɵɵclassMapInterpolate1("plan-compare-list-section ", ctx_r124.getPlanCompareCustomClass(ctx_r124.isMobile, ctx_r124.isMedium, ctx_r124.plans.length), "");
    i0.ɵɵproperty("ngStyle", ctx_r124.planCompareFacade.getPreferencesHighlightStyles(ctx_r124.plans, ctx_r124.showDifferences, i0.ɵɵpureFunction0(12, _c7$1)));
    i0.ɵɵattribute("aria-colindex", i_r126 + 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isComparePage", true)("showMailOrderPharmacy", ctx_r124.Spa_Site_Mail_Order_Pharmacy_Enabled)("coveredText", ctx_r124.Spa_PlanDetails_Covered_Text)("notCoveredText", ctx_r124.Spa_PlanDetails_Non_Covered_Text)("hasMailOrder", plan_r125.hasMailDrugBenefits && !ctx_r124.planCompareFacade.isPlanPharmacyNotCovered(plan_r125))("planName", plan_r125.planName)("isMobile", ctx_r124.isMobile);
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_ng_container_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 97)(1, "span", 111);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_ng_container_6_div_2_div_3_Template, 2, 13, "div", 113);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r114 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("Spa_Style_H5 plan-compare-left-section m-0 ", ctx_r114.getPlanCompareCustomClass(ctx_r114.isMobile, ctx_r114.isMedium, ctx_r114.plans.length, true, true), "");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r114.Spa_PlanList_MailOrder_Text, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r114.plans);
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_ng_container_6_div_1_Template, 8, 8, "div", 108);
    i0.ɵɵtemplate(2, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_ng_container_6_div_2_Template, 4, 5, "div", 109);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r108 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r108.selectedPharmacies);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r108.Spa_Site_Mail_Order_Pharmacy_Enabled);
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-widget-plan-compare-panel", 101);
    i0.ɵɵelementStart(2, "div", 103)(3, "span", 86);
    i0.ɵɵtemplate(4, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_span_4_Template, 2, 1, "span", 87);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_div_5_Template, 7, 4, "div", 104);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_ng_container_6_Template, 3, 2, "ng-container", 9);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r77 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isSubSectionHeaderExist", true)("customClass", ctx_r77.getPlanCompareCustomClass(ctx_r77.isMobile, ctx_r77.isMedium, ctx_r77.plans.length, true, true))("headerPropertyName", "Spa_Plan_Details_Preferences_Pharmacy_Text")("subSectionHeader", ctx_r77.Spa_Plan_Details_Preferences_Pharmacy_Text)("linkPropertyName", "Spa_Site_Pharmacy_AddEdit_Link")("iconClass", "Spa_Style_PharmacyIcon")("linkTitle", ctx_r77.Spa_Site_Pharmacy_AddEdit_Link)("tag", ctx_r77.pageTags.GUIDED_HELP_PHARMACY_SEARCH)("isPreferencesSection", true)("Spa_Site_Tooltip_Text", ctx_r77.Spa_Site_Tooltip_Text)("plans", ctx_r77.plans);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r77.getPlanCompareCustomClass(ctx_r77.isMobile, ctx_r77.isMedium, ctx_r77.plans.length, true, true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_PlanDetails_Preferences_SearchPharmacy_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r77.plans);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r77.planCompareFacade.getSelectedPharmacy() && (ctx_r77.planPharmacyData == null ? null : ctx_r77.planPharmacyData.length));
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-widget-plan-compare-panel", 101)(2, "vnext-plan-compare-preferences", 117);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r78 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isSubSectionHeaderExist", true)("customClass", ctx_r78.getPlanCompareCustomClass(ctx_r78.isMobile, ctx_r78.isMedium, ctx_r78.plans.length, true, true))("headerPropertyName", "Spa_Plan_Details_OtherPreferences_Text")("subSectionHeader", ctx_r78.Spa_Plan_Details_OtherPreferences_Text)("linkPropertyName", "Spa_Site_Preferences_AddEdit_Link")("iconClass", "Spa_Style_OtherPreferencesIcon")("linkTitle", ctx_r78.Spa_Site_Preferences_AddEdit_Link)("tag", ctx_r78.pageTags.GUIDED_HELP_OTHER_PREFERENCES)("isPreferencesSection", true)("Spa_Site_Tooltip_Text", ctx_r78.Spa_Site_Tooltip_Text)("plans", ctx_r78.plans);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plans", ctx_r78.plans)("showHighlightPlanDifferences", ctx_r78.showDifferences)("answeredPreferenceBenefits", ctx_r78.planCompareFacade.getPreferenceBenefits(ctx_r78.plans))("coveredBenefitText", ctx_r78.Spa_Site_Yes)("nonCoveredBenefitText", ctx_r78.Spa_Site_No)("isMobile", ctx_r78.isMobile)("customLeftSectionClass", ctx_r78.getPlanCompareCustomClass(ctx_r78.isMobile, ctx_r78.isMedium, ctx_r78.plans.length, true, true))("customRightSectionClass", ctx_r78.getPlanCompareCustomClass(ctx_r78.isMobile, ctx_r78.isMedium, ctx_r78.plans.length));
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-widget-plan-compare-accordion", 69);
    i0.ɵɵtemplate(1, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_1_Template, 4, 15, "ng-container", 9);
    i0.ɵɵtemplate(2, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_2_Template, 3, 27, "ng-container", 9);
    i0.ɵɵtemplate(3, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_3_Template, 7, 15, "ng-container", 9);
    i0.ɵɵtemplate(4, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_ng_container_4_Template, 3, 19, "ng-container", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r72 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("accordionId", "plan-preferences-container")("accordionSectionHeader", ctx_r72.Spa_Plan_Details_Preferences_Text)("isLiveEditable", true)("headerPropertyName", "Spa_Plan_Details_Preferences_Text")("accordionIsOpen", ctx_r72.Spa_Plan_Details_Preferences_Expanded);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r72.showProviderSection);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r72.showPrescriptionSection);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r72.showPharmacySection);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r72.showOtherPreferencesSection);
} }
const _c8$1 = function (a0, a1) { return { "order-2": a0, "order-1": a1 }; };
function PlanCompareComponent_ng_container_10_div_4_div_4_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 118)(1, "vnext-widget-plan-compare-accordion", 119);
    i0.ɵɵelement(2, "vnext-widget-plan-compare-riders", 120);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r73 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(21, _c8$1, ctx_r73.Spa_Plan_Details_Preferences_Position_Last, !ctx_r73.Spa_Plan_Details_Preferences_Position_Last));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("accordionId", "plan-benefits-container")("accordionSectionHeader", ctx_r73.Spa_Plan_Details_AddOnRiders_Header)("isLiveEditable", true)("headerPropertyName", "Spa_Plan_Details_AddOnRiders_Header")("accordionIsOpen", true)("accordionSubHeaderClass", "Spa_Style_Paragraph_Light d-inline-block ml-sm-2 mb-0")("accordionSubHeader", ctx_r73.Spa_Plan_Details_AddOnRiders_SubHeader);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plans", ctx_r73.plans)("showHighlightPlanDifferences", ctx_r73.showDifferences)("waiverStateRidersTooltips", ctx_r73.Spa_Plan_Details_WaiverStateRider_Tooltips)("shoppingCartIncludedRiderText", ctx_r73.Spa_ShoppingCart_IncludedRider_Text)("riderNotSupportedText", ctx_r73.Spa_Site_Rider_NotSupported_Text)("notApplicableText", ctx_r73.Spa_Site_NotApplicable_Text)("riderLeftSectionCustomClass", ctx_r73.getPlanCompareCustomClass(ctx_r73.isMobile, ctx_r73.isMedium, ctx_r73.plans.length, true, true, "", "Spa_Style_H5"))("riderRightSectionCustomClass", ctx_r73.getPlanCompareCustomClass(ctx_r73.isMobile, ctx_r73.isMedium, ctx_r73.plans.length))("showRiderDetailsText", ctx_r73.Spa_Plan_Details_ViewRiderDetails_Text)("hideRiderDetailsText", ctx_r73.Spa_Plan_Details_HideRiderDetails_Text)("showRiderDetails", ctx_r73.Spa_Site_RiderDetails_Show)("planCompareHighLightOffScreenText", ctx_r73.Spa_Plan_Compare_HighLight_OffScreenText)("Spa_Site_Tooltip_Text", ctx_r73.Spa_Site_Tooltip_Text);
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_div_16_vnext_link_4_Template(rf, ctx) { if (rf & 1) {
    const _r132 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 123);
    i0.ɵɵlistener("click", function PlanCompareComponent_ng_container_10_div_4_div_4_div_16_vnext_link_4_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r132); const plan_r127 = i0.ɵɵnextContext().$implicit; const ctx_r130 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r130.viewPlanDetailsPage(plan_r127, false, true)); })("keyup.enter", function PlanCompareComponent_ng_container_10_div_4_div_4_div_16_vnext_link_4_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r132); const plan_r127 = i0.ɵɵnextContext().$implicit; const ctx_r133 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r133.viewPlanDetailsPage(plan_r127, false, true)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r129 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("title", ctx_r129.Spa_Site_ViewDetails)("alwaysUnderlined", true)("isLinkButton", true);
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 121)(1, "div")(2, "span", 106);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PlanCompareComponent_ng_container_10_div_4_div_4_div_16_vnext_link_4_Template, 1, 3, "vnext-link", 122);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const plan_r127 = ctx.$implicit;
    const i_r128 = ctx.index;
    const ctx_r74 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", ctx_r74.getPlanCompareCustomClass(ctx_r74.isMobile, ctx_r74.isMedium, ctx_r74.plans.length));
    i0.ɵɵattribute("aria-colindex", i_r128 + 1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(plan_r127.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r74.Spa_Site_PlanViewDetails_Enabled);
} }
function PlanCompareComponent_ng_container_10_div_4_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 66)(1, "div", 67)(2, "div", 68)(3, "vnext-widget-plan-compare-accordion", 69);
    i0.ɵɵtemplate(4, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_panel_4_Template, 1, 6, "vnext-widget-plan-compare-panel", 70);
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelement(6, "vnext-widget-plan-compare-medical-benefits", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_panel_7_Template, 1, 6, "vnext-widget-plan-compare-panel", 70);
    i0.ɵɵtemplate(8, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_prescription_coverage_8_Template, 1, 18, "vnext-widget-plan-compare-prescription-coverage", 72);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 68);
    i0.ɵɵtemplate(10, PlanCompareComponent_ng_container_10_div_4_div_4_vnext_widget_plan_compare_accordion_10_Template, 5, 9, "vnext-widget-plan-compare-accordion", 73);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, PlanCompareComponent_ng_container_10_div_4_div_4_div_11_Template, 3, 24, "div", 74);
    i0.ɵɵelementStart(12, "div", 75)(13, "vnext-widget-plan-compare-accordion", 76)(14, "div")(15, "vnext-widget-plan-compare-panel", 77);
    i0.ɵɵtemplate(16, PlanCompareComponent_ng_container_10_div_4_div_4_div_16_Template, 5, 4, "div", 78);
    i0.ɵɵelementEnd()()()()()();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(50, _c8$1, !ctx_r35.Spa_Plan_Details_Preferences_Position_Last, ctx_r35.Spa_Plan_Details_Preferences_Position_Last));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("accordionId", "plan-benefits-container")("accordionSectionHeader", ctx_r35.Spa_Plan_Benefits_Section_Name)("isLiveEditable", true)("headerPropertyName", "Spa_Plan_Benefits_Section_Name")("accordionIsOpen", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.plans[0].planType === ctx_r35.planType.MA || ctx_r35.plans[0].planType === ctx_r35.planType.MAPD);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("medicalDeductibleToolTipContent", ctx_r35.Spa_PlanCompare_Benefit_MedicalDeductible_Tooltip)("medicalDeductibleIsTooltipExist", ctx_r35.Spa_PlanCompare_Benefit_Show_MedicalDeductible_Tooltip)("medicalDeductibleIsSubSectionHeaderExist", false)("medicalDeductibleIsContentExist", true)("medicalDeductibleLeftSectionContent", ctx_r35.Spa_PlanCard_Benefit_MedicalDeductible_Text)("customClass", ctx_r35.getPlanCompareCustomClass(ctx_r35.isMobile, ctx_r35.isMedium, ctx_r35.plans.length, true, true))("plans", ctx_r35.plans)("customClassBenefitValue", ctx_r35.getPlanCompareCustomClass(ctx_r35.isMobile, ctx_r35.isMedium, ctx_r35.plans.length))("notAvailableText", ctx_r35.Spa_Site_NotApplicable_Text)("medicalDeductibleTitle", ctx_r35.Spa_PlanCard_Benefit_MedicalDeductible_Title)("medicalMaxOutOfPocketToolTipContent", ctx_r35.Spa_PlanCompare_Benefit_MedicalMaxOutOfPocket_Tooltip)("medicalMaxOutOfPocketIsTooltipExist", ctx_r35.Spa_PlanCompare_Benefit_Show_MedicalMaxOutOfPocket_Tooltip)("medicalMaxOutOfPocketIsSubSectionHeaderExist", false)("medicalMaxOutOfPocketIsContentExist", true)("medicalMaxOutOfPocketLeftSectionContent", ctx_r35.Spa_PlanCompare_Benefit_MedicalMaxOutOfPocket_Text)("medicalMaxOutOfPocketTitle", ctx_r35.Spa_PlanCompare_Benefit_MedicalMaxOutOfPocket_Title)("planCompareBenefitValuesMAPD", ctx_r35.Spa_PlanCompare_Benefit_values_MAPD)("planCompareBenefitValuesMA", ctx_r35.Spa_PlanCompare_Benefit_values_MA)("planCompareBenefitValuesMEDIGAP", ctx_r35.Spa_PlanCompare_Benefit_values_MEDIGAP)("siteShowDifferencesChecked", ctx_r35.showDifferences)("planComparePlanDifferencesColor", ctx_r35.Spa_PlanCompare_Plan_Differences_Color)("planComparePlanDifferencesBorder", ctx_r35.Spa_PlanCompare_Plan_Differences_Border)("planCompareHighLightOffScreenText", ctx_r35.Spa_Plan_Compare_HighLight_OffScreenText)("Spa_Site_Tooltip_Text", ctx_r35.Spa_Site_Tooltip_Text)("medicalCoverageAriaLabel", ctx_r35.medicalCoverageAriaLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.plans[0].planType === ctx_r35.planType.PDP || ctx_r35.plans[0].planType === ctx_r35.planType.MAPD);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.plans[0].planType === ctx_r35.planType.PDP || ctx_r35.plans[0].planType === ctx_r35.planType.MAPD && !ctx_r35.isQuoteSummaryMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(53, _c8$1, ctx_r35.Spa_Plan_Details_Preferences_Position_Last, !ctx_r35.Spa_Plan_Details_Preferences_Position_Last));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.Spa_Plan_Details_Show_Preferences && ctx_r35.Spa_GuidedHelp_Enabled && ctx_r35.plans[0].planType !== ctx_r35.planType.MEDIGAP && (ctx_r35.showProviderSection || ctx_r35.showPrescriptionSection || ctx_r35.showPharmacySection || ctx_r35.showOtherPreferencesSection) && !ctx_r35.isQuoteSummaryMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.riderCategories.length > 0 && !ctx_r35.Spa_Site_ShowPremiumAsAnnual && ctx_r35.Spa_ShoppingCart_Enabled && !ctx_r35.isQuoteSummaryMode);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("accordionId", "plan-benefits-container")("accordionSectionHeader", ctx_r35.Spa_PlanCompare_PlanDocument_Text)("isLiveEditable", true)("headerPropertyName", "Spa_PlanCompare_PlanDocument_Text")("accordionIsOpen", true)("accordionSubHeaderClass", "Spa_Style_Paragraph_Light d-inline-block ml-sm-2 mb-0");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("isSubSectionHeaderExist", false)("isPanelContentExist", true)("panelLeftSectionContent", ctx_r35.Spa_PlanCompare_PlanDocument_ViewMore_Text)("customClass", ctx_r35.getPlanCompareCustomClass(ctx_r35.isMobile, ctx_r35.isMedium, ctx_r35.plans.length, true, true))("Spa_Site_Tooltip_Text", ctx_r35.Spa_Site_Tooltip_Text)("plans", ctx_r35.plans);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r35.plans);
} }
function PlanCompareComponent_ng_container_10_div_4_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r136 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 124)(1, "div", 125)(2, "vnext-widget-plan-quote-benefit-details", 126);
    i0.ɵɵlistener("selectedRiderBenefits", function PlanCompareComponent_ng_container_10_div_4_div_5_Template_vnext_widget_plan_quote_benefit_details_selectedRiderBenefits_2_listener($event) { i0.ɵɵrestoreView(_r136); const ctx_r135 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r135.onRiderBenefitDropdownSelection($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("plans", ctx_r36.plans)("locale", ctx_r36.locale)("sectionHeaderText", ctx_r36.Spa_Plan_Benefits_Section_Name)("basePlanOptionLabel", ctx_r36.Spa_Site_HIP_BasePlanOption_Text)("medicareTypes", ctx_r36.Spa_PlanDetails_HIP_Call_Out_Available_Plan_Types)("hospitalCareRiderBenefitDefaultDropdownText", ctx_r36.SPA_HIP_Rider_Benefit_Default_Dropdown_Text)("hospitalCareRiderBenefitText", ctx_r36.SPA_HIP_Rider_Benefit_Text)("notAvailableRiderBenefitText", ctx_r36.SPA_Site_NotAvailable_Rider_Benefit_Text);
} }
function PlanCompareComponent_ng_container_10_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵtemplate(1, PlanCompareComponent_ng_container_10_div_4_ng_container_1_Template, 3, 8, "ng-container", 9);
    i0.ɵɵtemplate(2, PlanCompareComponent_ng_container_10_div_4_vnext_widget_plan_compare_accordion_2_Template, 2, 7, "vnext-widget-plan-compare-accordion", 45);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵtemplate(4, PlanCompareComponent_ng_container_10_div_4_div_4_Template, 17, 56, "div", 46);
    i0.ɵɵtemplate(5, PlanCompareComponent_ng_container_10_div_4_div_5_Template, 3, 8, "div", 47);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.Spa_Show_Plan_Level_Content && ctx_r14.planCompareFacade.isPlanLevelContentExist(ctx_r14.plans) && !ctx_r14.isQuoteSummaryMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (!ctx_r14.isQuoteSummaryMode || ctx_r14.Spa_Site_PlanFees_Enabled) && i0.ɵɵpipeBind1(3, 4, ctx_r14.showCostsSection$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r14.isQuoteSummaryMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.isQuoteSummaryMode);
} }
function PlanCompareComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵtemplate(2, PlanCompareComponent_ng_container_10_ng_container_2_Template, 1, 2, "ng-container", 18);
    i0.ɵɵtemplate(3, PlanCompareComponent_ng_container_10_div_3_Template, 15, 78, "div", 19);
    i0.ɵɵtemplate(4, PlanCompareComponent_ng_container_10_div_4_Template, 6, 6, "div", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.tagsToUpdate);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.plans.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.plans.length > 0);
} }
let PlanCompareComponent = class PlanCompareComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, passParameterService, activatedRoute, configResourceService, planCompareService, planCompareFacade, responsiveLayoutService, planDetailsFacade, planFacade, analyticsService, plansService, planListFacade, store, siteService, helpfulToolsService, localeService, providerService, pharmacyService, drugCabinetContext, spinnerService, navigationUtilityService, navigationContext, planCardFacade, hospitalIndemnityFormFacade, providerFacade) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.passParameterService = passParameterService;
        this.activatedRoute = activatedRoute;
        this.configResourceService = configResourceService;
        this.planCompareService = planCompareService;
        this.planCompareFacade = planCompareFacade;
        this.responsiveLayoutService = responsiveLayoutService;
        this.planDetailsFacade = planDetailsFacade;
        this.planFacade = planFacade;
        this.analyticsService = analyticsService;
        this.plansService = plansService;
        this.planListFacade = planListFacade;
        this.store = store;
        this.siteService = siteService;
        this.helpfulToolsService = helpfulToolsService;
        this.localeService = localeService;
        this.providerService = providerService;
        this.pharmacyService = pharmacyService;
        this.drugCabinetContext = drugCabinetContext;
        this.spinnerService = spinnerService;
        this.navigationUtilityService = navigationUtilityService;
        this.navigationContext = navigationContext;
        this.planCardFacade = planCardFacade;
        this.hospitalIndemnityFormFacade = hospitalIndemnityFormFacade;
        this.providerFacade = providerFacade;
        // #region resources
        this.Spa_Site_Previous = 'Previous';
        this.Spa_PlanCard_PlanDetails_ButtonText = 'Plan details';
        this.Spa_PlanCompare_Benefit_Show_MedicalDeductible_Tooltip = true;
        this.Spa_PlanCompare_Benefit_Show_MedicalMaxOutOfPocket_Tooltip = true;
        this.Spa_PlanCard_Benefit_MedicalDeductible_Title = 'medicalDeductible';
        this.Spa_PlanCompare_Benefit_MedicalMaxOutOfPocket_Title = 'medicalOutOfPocketMaximum';
        this.Spa_PlanCard_Benefit_MedicalDeductible_Text = 'Medical Deductible';
        this.Spa_PlanCompare_Benefit_MedicalMaxOutOfPocket_Text = 'Medical Out of Pocket Maximum';
        this.Spa_Site_Tooltip_Text = 'Tooltip:';
        this.Spa_Remove_Plan_Text = 'Remove Plan';
        this.Spa_PlanCompare_Benefit_MedicalDeductible_Tooltip = 'The amount that you pay in a calendar year for covered services before you receive benefits. For some services, your plan may pay most of the cost before you meet the deductible.';
        this.Spa_PlanCompare_Benefit_MedicalMaxOutOfPocket_Tooltip = 'The most that you must pay in a calendar year for covered services. Your plan pays 100% of the cost after you meet the out of pocket maximum.';
        this.Spa_PlanCompare_Benefit_values_MA = [
            {
                ordinal: 1,
                detail: 'Doctor Office Visit',
                showTooltip: true,
                benefitID: 9,
                tooltipContent: 'The amount that you pay for a visit to your primary care physician’s office, if your doctor is in the network.'
            },
            {
                ordinal: 2,
                detail: 'Specialist Office Visit',
                showTooltip: true,
                benefitID: 40,
                tooltipContent: 'The amount that you pay for a visit to a specialist doctor’s office, if the physician is in the network.'
            },
            {
                ordinal: 3,
                detail: 'Skilled Nursing Facility',
                showTooltip: true,
                benefitID: 6,
                tooltipContent: 'Health care given when you need skilled nursing or therapy staff to manage, observe, and evaluate your care. Examples of skilled care include intravenous injections and physical therapy. Medicare will only cover skilled care when you meet certain conditions. A skilled nursing facility could be part of a nursing home or hospital.'
            },
            {
                ordinal: 4,
                detail: 'Home Health Care',
                showTooltip: true,
                benefitID: 7,
                tooltipContent: 'Home health care is a wide range of health care services that can be given in your home for an illness or injury. Home health care is usually less expensive, more convenient, and just as effective as care you get in a hospital or skilled nursing facility.'
            },
            {
                ordinal: 5,
                detail: 'Outpatient Mental Health Care',
                showTooltip: true,
                benefitID: 12,
                tooltipContent: 'Mental health services help with conditions like depression and anxiety. These visits are often called counseling or therapy. Medicare only covers the visits when they’re provided by a health care provider who accepts assignment.'
            },
            {
                ordinal: 6,
                detail: 'Emergency Room',
                showTooltip: true,
                benefitID: 16,
                tooltipContent: 'Emergency department services when you have an injury, a sudden illness, or an illness that quickly gets much worse.'
            },
            {
                ordinal: 7,
                detail: 'Hospital Inpatient Stay',
                showTooltip: true,
                benefitID: 4,
                tooltipContent: 'The amount that you pay for a non-emergency stay in the hospital, if the hospital is in the network.'
            }
        ];
        this.Spa_PlanCompare_Benefit_values_MAPD = [
            {
                ordinal: 1,
                detail: 'Doctor Office Visit',
                showTooltip: true,
                benefitID: 9,
                tooltipContent: 'The amount that you pay for a visit to your primary care physician’s office, if your doctor is in the network.'
            },
            {
                ordinal: 2,
                detail: 'Specialist Office Visit',
                showTooltip: true,
                benefitID: 40,
                tooltipContent: 'The amount that you pay for a visit to a specialist doctor’s office, if the physician is in the network.'
            },
            {
                ordinal: 3,
                detail: 'Skilled Nursing Facility',
                showTooltip: true,
                benefitID: 6,
                tooltipContent: 'Health care given when you need skilled nursing or therapy staff to manage, observe, and evaluate your care. Examples of skilled care include intravenous injections and physical therapy. Medicare will only cover skilled care when you meet certain conditions. A skilled nursing facility could be part of a nursing home or hospital.'
            },
            {
                ordinal: 4,
                detail: 'Home Health Care',
                showTooltip: true,
                benefitID: 7,
                tooltipContent: 'Home health care is a wide range of health care services that can be given in your home for an illness or injury. Home health care is usually less expensive, more convenient, and just as effective as care you get in a hospital or skilled nursing facility.'
            },
            {
                ordinal: 5,
                detail: 'Outpatient Mental Health Care',
                showTooltip: true,
                benefitID: 12,
                tooltipContent: 'Mental health services help with conditions like depression and anxiety. These visits are often called counseling or therapy. Medicare only covers the visits when they’re provided by a health care provider who accepts assignment.'
            },
            {
                ordinal: 6,
                detail: 'Emergency Room',
                showTooltip: true,
                benefitID: 16,
                tooltipContent: 'Emergency department services when you have an injury, a sudden illness, or an illness that quickly gets much worse.'
            },
            {
                ordinal: 7,
                detail: 'Hospital Inpatient Stay',
                showTooltip: true,
                benefitID: 4,
                tooltipContent: 'The amount that you pay for a non-emergency stay in the hospital, if the hospital is in the network.'
            }
        ];
        this.Spa_PlanCompare_Benefit_values_MEDIGAP = [
            {
                ordinal: 2,
                showTooltip: false,
                benefitID: 343,
                tooltipContent: ''
            },
            {
                ordinal: 3,
                showTooltip: false,
                benefitID: 347,
                tooltipContent: ''
            },
            {
                ordinal: 1,
                showTooltip: false,
                benefitID: 6,
                tooltipContent: ''
            },
            {
                ordinal: 4,
                showTooltip: false,
                benefitID: 348,
                tooltipContent: ''
            },
            {
                ordinal: 5,
                showTooltip: false,
                benefitID: 351,
                tooltipContent: ''
            },
            {
                ordinal: 6,
                showTooltip: false,
                benefitID: 352,
                tooltipContent: ''
            },
            {
                ordinal: 7,
                showTooltip: false,
                benefitID: 353,
                tooltipContent: ''
            },
            {
                ordinal: 8,
                showTooltip: false,
                benefitID: 362,
                tooltipContent: ''
            },
            {
                ordinal: 9,
                showTooltip: false,
                benefitID: 354,
                tooltipContent: ''
            },
            {
                ordinal: 10,
                showTooltip: false,
                benefitID: 356,
                tooltipContent: ''
            },
            {
                ordinal: 11,
                showTooltip: false,
                benefitID: 360,
                tooltipContent: ''
            },
            {
                ordinal: 12,
                showTooltip: false,
                benefitID: 15,
                tooltipContent: ''
            },
            {
                ordinal: 13,
                showTooltip: false,
                benefitID: 342,
                tooltipContent: ''
            },
            {
                ordinal: 14,
                showTooltip: false,
                benefitID: 344,
                tooltipContent: ''
            },
            {
                ordinal: 15,
                showTooltip: false,
                benefitID: 345,
                tooltipContent: ''
            },
            {
                ordinal: 16,
                showTooltip: false,
                benefitID: 346,
                tooltipContent: ''
            },
            {
                ordinal: 17,
                showTooltip: false,
                benefitID: 260,
                tooltipContent: ''
            },
            {
                ordinal: 18,
                showTooltip: false,
                benefitID: 349,
                tooltipContent: ''
            },
            {
                ordinal: 19,
                showTooltip: false,
                benefitID: 350,
                tooltipContent: ''
            },
            {
                ordinal: 20,
                showTooltip: false,
                benefitID: 355,
                tooltipContent: ''
            },
            {
                ordinal: 21,
                showTooltip: false,
                benefitID: 358,
                tooltipContent: ''
            },
            {
                ordinal: 22,
                showTooltip: false,
                benefitID: 359,
                tooltipContent: ''
            },
            {
                ordinal: 23,
                showTooltip: false,
                benefitID: 361,
                tooltipContent: ''
            },
            {
                ordinal: 24,
                showTooltip: false,
                benefitID: 362,
                tooltipContent: ''
            },
            {
                ordinal: 25,
                showTooltip: false,
                benefitID: 363,
                tooltipContent: ''
            },
            {
                ordinal: 26,
                showTooltip: false,
                benefitID: 364,
                tooltipContent: ''
            },
            {
                ordinal: 27,
                showTooltip: false,
                benefitID: 365,
                tooltipContent: ''
            },
            {
                ordinal: 28,
                showTooltip: false,
                benefitID: 366,
                tooltipContent: ''
            }
        ];
        this.Spa_Site_ViewDetails = 'View details';
        this.Spa_Pharmacy_InNetwork_Preferred_Pricing_Text = 'In-network pharmacy with preferred pricing';
        this.Spa_Pharmacy_InNetwork_Standard_Pricing_Text = 'In-network pharmacy with standard pricing';
        this.Spa_Pharmacy_OutOfNetwork_Pricing_Text = 'Out-of-network pharmacy';
        this.Spa_Plan_Details_Show_Preferences = true;
        this.Spa_Plan_Details_Preferences_Show_Provider = true;
        this.Spa_Site_ZelisIntegration_Enabled = false;
        this.Spa_Site_Prescriptions_Enabled = true;
        this.Spa_Site_Pharmacy_Enabled = true;
        this.Spa_PlanDetails_Covered_Text = 'Covered';
        this.Spa_PlanDetails_Non_Covered_Text = 'Not Covered';
        this.Spa_Plan_Details_Preferences_Position_Last = true;
        this.Spa_GuidedHelp_Enabled = true;
        this.Spa_Plan_Details_Preferences_Expanded = true;
        this.Spa_Site_Health_Enabled = true;
        this.Spa_Site_TotalEstimatedCost_Enabled = true;
        this.Spa_Site_ShowDifferences_Checked = true;
        this.Spa_PlanCompare_Plan_Differences_Text = 'Show plan differences';
        this.Spa_PlanCompare_Plan_Differences_Color = '#fff3dc';
        this.Spa_PlanCompare_Plan_Differences_Border = '2px dotted #b07d0f';
        this.Spa_Site_Rider_NotSupported_Text = 'No';
        this.Spa_Site_ShowPremiumAsAnnual = false;
        this.Spa_ShoppingCart_Enabled = true;
        this.Spa_Site_NotApplicable_Text = 'N/A';
        this.Spa_Plan_Details_ViewRiderDetails_Text = 'View details';
        this.Spa_Plan_Details_HideRiderDetails_Text = 'Hide details';
        this.Spa_Site_RiderDetails_Show = true;
        this.Spa_HealthCostsTab_AddAgeHealth_Text = 'Add health information';
        this.Spa_Site_Hide_Text = 'Hide';
        this.Spa_Site_ViewAll_Text = 'View more';
        this.Spa_Plan_Details_WaiverStateRider_Tooltips = [
            {
                id: 'Combined Rider',
                body: 'This optional plan benefit is a combination of riders for one price.'
            },
            {
                id: 'Part A Deductible',
                body: `"Part A Deductible" covers the amount that you must pay for inpatient hospital stays before Medicare begins to pay.`
            },
            {
                id: 'Part B Deductible',
                body: `"Part B Deductible" covers the amount that you must pay for Medicare-approved
           Part B medical services before Medicare Part B begins to pay.`
            },
            {
                id: 'Part B Excess',
                body: `"Part B Excess Charges" covers the  difference between the Medicare eligible charge and the amount charged by
          the provider which shall be no greater than the actual charge or the limited charge allowed by Medicare, whichever is less.`
            },
            {
                id: 'Preventive Care',
                body: `"Preventive Care"  pays up to $120 a year for covered preventive screening
           test and services and an annual physical examination.`
            },
            {
                id: 'Usual and Customary Fees',
                body: `"Usual and Customary Charges Fees" covers the difference between the Medicare eligible charge and the amount charged by
           the provider which shall be no greater than the actual charge or the limited charge allowed by Medicare, whichever is less.`
            },
            {
                id: 'Part B Excess Charges',
                body: `Part B Excess Charges" covers the  difference between the Medicare eligible charge
        and the amount charged by the provider which shall be no greater than the actual charge or
        the limited charge allowed by Medicare, whichever is less.`
            },
            {
                id: 'Additional Home Health Care',
                body: ` "Additional Home Health" extends home care visits up to 365 visits per policy year.`
            },
            {
                id: 'Foreign Travel Emergency',
                body: ` "Foreign Travel Emergency" covers at least 80% of eligible expenses associated with emergency
          medical care received outside the U.S.A. beginning the first 60 days of a trip up to a
          lifetime maximum of $50,000 (after a  deductible of $250).`
            },
            {
                id: 'Co-Pay Rider',
                body: ` "Co-Pay Rider" pays the Part B coinsurance subject to a copayment or coinsurance of no more
          than $20 per office visit and no more than $50 per emergency room visit that is in
          addition to the Medicare Part B medical deductible  and in addition to out-pocket maximums.`
            },
            {
                id: '50% Part A Deductible',
                body: `"50% of Part A Deductible" pays 50% of the inpatient deductible for qualifying hospital stays.`
            },
            {
                id: 'Part B Copayment or Coinsurance',
                body: `"Part B Copayment or Coinsurance" covers the amount you must pay as your share of the cost for medical services.
          Copayment is usually a set amount whereas coinsurance is a percentage.`
            }
        ];
        this.Spa_PlanDetails_NonCommissionable_Text = 'Non-Commissionable';
        this.Spa_PlanDetails_NonCommissionable_FlagCheck_Enabled = false;
        this.Spa_Site_Current_Plan_Text = 'Current Plan';
        this.Spa_Site_Next_Year_Plan_Text = `Next year's plan`;
        this.Spa_Site_PlanNotAvailableForNextYear_Text = 'Plan not available next year';
        this.Spa_Site_Keep_This_Plan_Button_Text = 'Keep this plan';
        this.Spa_Site_Show_PlanLogo = true;
        this.Spa_Site_SendQuote_Button_Text = 'Send Quote';
        this.Spa_Site_IsDeepLinking_Enabled = true;
        this.Spa_Site_SiteType = SiteType.CONSUMER;
        this.Spa_Compare_ViewDetails_Description = 'View Details';
        this.Spa_DrugCost_Add_Edit_Link_Description = 'Add or edit Drug Cost';
        this.Spa_HealthCost_Add_Edit_Link_Description = 'Add or edit Health Cost';
        this.Spa_Prescription_Add_Edit_Link_Description = 'Add or edit Prescription list';
        this.Spa_Site_Pharmacy_Add_Edit_Link_Description = 'Add or edit Pharmacy list';
        this.Spa_Site_PlanViewDetails_Enabled = true;
        this.Spa_PlanCard_Benefit_VisionDeductible_Text = 'Vision Deductible';
        this.Spa_PlanCard_Benefit_DentalDeductible_Text = 'Dental Deductible';
        this.Spa_PlanCard_Benefit_CalendarYearMax_Text = 'Calendar Year Maximum';
        this.Spa_PlanLevel_Content_Label_PDP = 'Plan Highlights PDP';
        this.Spa_PlanLevel_Content_Label_MAPD = 'Plan Highlights MAPD';
        this.Spa_PlanLevel_Content_Label_MA = 'Plan Highlights MA';
        this.Spa_PlanLevel_Content_Label_MEDIGAP = 'Plan Highlights MEDIGAP';
        this.Spa_Show_Plan_Level_Content = true;
        this.Spa_Plan_Benefits_Section_Name = 'Benefits';
        this.Spa_PlanCompare_MedicalCoverage_Tooltip = 'Indicates medical costs for the selected plans.';
        this.Spa_PlanCompare_Show_MedicalCoverage_Tooltip = false;
        this.Spa_PlanCompare_PrescriptionDrugCoverage_Tooltip = 'Indicates prescription costs for the selected plans.';
        this.Spa_PlanCompare_Show_PrescriptionDrugCoverage_Tooltip = false;
        this.Spa_PlanCompare_PlanDocument_ViewMore_Text = 'To view more info, view the details of each plan';
        this.Spa_Plan_Providers_Search_Provider_Text = 'Search Provider';
        this.Spa_Plan_Providers_Directory_Link = 'Provider directory';
        this.Spa_Plan_Details_Preferences_Text = 'Preferences';
        this.Spa_Plan_Details_Preferences_Pharmacy_Text = 'Pharmacy';
        this.Spa_Plan_Details_Preferences_Prescription_Text = 'Prescription';
        this.Spa_Plan_Details_Preferences_Provider_Text = 'Provider';
        this.Spa_Plan_Details_Providers_Link = 'Medical provider Directory(PDF)';
        this.Spa_Plan_Compare_PrescriptionDeductible_Text = 'Prescription Deductible';
        this.Spa_Plan_Compare_PrescriptionDeductible_Tooltip = 'The amount that you pay in a calendar year for covered drugs before you only have to pay the smaller copay amount';
        this.Spa_Plan_Compare_ShowPrescriptionDeductible_Tooltip = true;
        this.Spa_Plan_Compare_PrescriptionDrugs_Text = 'Prescription Drugs';
        this.Spa_Plan_Compare_PrescriptionDrugs_Tooltip = 'Tier Benefits';
        this.Spa_Plan_Compare_ShowPrescriptionDrugs_Tooltip = false;
        this.Spa_PlanCompare_Benefit_Show_InitialCoverageLimit = false;
        this.Spa_Plan_Compare_PrescriptionInitialCoverageLimit_Text = 'Prescription Initial Coverage Limit';
        this.Spa_Plan_Compare_PrescriptionInitialCoverageLimit_Tooltip = `The amount that you and the plan have paid for drugs.
  After this amount is reached, you may pay more for drugs until you reach the out of pocket maximum. This period is known as
  the "coverage gap" or "donut hole."`;
        this.Spa_Plan_Compare_ShowPrescriptionInitialCoverageLimit_Tooltip = true;
        this.Spa_Plandetails_Costs_Add_Edit_Link_Text = 'Add/edit';
        this.Spa_Plan_Compare_HighLight_OffScreenText = 'Highlighted to show differences between plans';
        this.Spa_PlanDetails_Health_Cost_Text = `${this.configResourceService.getProcessedResourceValue('Spa_Site_Health_Text', null, 'Health')} Costs`;
        this.Spa_Plandetails_Costs_MAPD = [
            {
                title: PlanDetailsCostLabels.PREMIUM,
                subText: '',
                label: 'Premium',
                label2: 'Premium',
                duration: 'monthly',
                duration2: 'monthly'
            },
            {
                title: PlanDetailsCostLabels.DRUG_COST,
                subText: 'Based on <totalDrugs> drugs',
                label: 'Annual Est Drug Cost',
                label2: 'Est Drug Cost',
                duration: 'annually',
                duration2: 'partial annually'
            },
            {
                title: PlanDetailsCostLabels.HEALTH_COST,
                subText: 'Estimated medical costs based on age <ageRange> and <healthStatus>.',
                label: this.configResourceService.getProcessedResourceValue('Spa_PlanDetails_Health_Cost_Text', null, `Annual ${this.configResourceService.getProcessedResourceValue('Spa_Site_Health_Text', null, 'Health')} cost`),
                label2: 'Health cost',
                duration: 'annually',
                duration2: 'partial annually'
            },
            {
                title: PlanDetailsCostLabels.TOTAL_ESTIMATED_COST,
                subText: 'Based on medical and drug costs.',
                label: 'Total est annual cost',
                label2: 'Total est cost',
                duration: 'annually',
                duration2: 'partial annually'
            }
        ];
        this.Spa_Plandetails_Costs_MA = [
            {
                title: PlanDetailsCostLabels.PREMIUM,
                subText: '',
                label: 'Premium',
                label2: 'Premium',
                duration: 'monthly',
                duration2: 'monthly'
            },
            {
                title: PlanDetailsCostLabels.HEALTH_COST,
                subText: 'Estimated medical costs based on age <ageRange> and <healthStatus>.',
                label: this.configResourceService.getProcessedResourceValue('Spa_PlanDetails_Health_Cost_Text', null, `Annual ${this.configResourceService.getProcessedResourceValue('Spa_Site_Health_Text', null, 'Health')} cost`),
                label2: 'Health cost',
                duration: 'annually',
                duration2: 'partial annually'
            },
            {
                title: PlanDetailsCostLabels.TOTAL_ESTIMATED_COST,
                subText: 'Based on medical costs.',
                label: 'Total est annual cost',
                label2: 'Total est cost',
                duration: 'annually',
                duration2: 'partial annually'
            }
        ];
        this.Spa_Plandetails_Costs_PDP = [
            {
                title: PlanDetailsCostLabels.PREMIUM,
                subText: '',
                label: 'Premium',
                label2: 'Premium',
                duration: 'monthly',
                duration2: 'monthly'
            },
            {
                title: PlanDetailsCostLabels.DRUG_COST,
                subText: 'Based on <totalDrugs> drugs',
                label: 'Annually Est Drug Cost',
                label2: 'Est Drug Cost',
                duration2: 'partial annually',
                duration: 'annually'
            },
            {
                title: PlanDetailsCostLabels.TOTAL_ESTIMATED_COST,
                subText: 'Based on drug costs.',
                label: 'Total est annual cost',
                label2: 'Total est cost',
                duration: 'annually',
                duration2: 'partial annually'
            }
        ];
        this.Spa_Plandetails_Costs_MEDIGAP = [
            {
                title: PlanDetailsCostLabels.PREMIUM,
                subText: '',
                label: 'Premium',
                label2: 'Premium',
                duration: 'monthly',
                duration2: 'monthly'
            }
        ];
        this.Spa_PlanDetails_Costs_DENTAL = [
            {
                title: PlanDetailsCostLabels.PLAN_FEES,
                label: 'Fees',
                subText: '',
                duration: ''
            }
        ];
        this.Spa_PlanDetails_Costs_VISION = [
            {
                title: PlanDetailsCostLabels.PLAN_FEES,
                label: 'Fees',
                subText: '',
                duration: ''
            }
        ];
        this.Spa_PlanDetails_Costs_HIP = [
            {
                title: PlanDetailsCostLabels.PLAN_FEES,
                label: 'Fees',
                subText: '',
                duration: ''
            }
        ];
        this.Spa_ShoppingCart_IncludedRider_Text = 'Included';
        this.Spa_Plan_Details_AddOnRiders_SubHeader = '(available in cart)';
        this.Spa_PlanCard_QuoteLinkName_Text = 'Get a personalized quote';
        this.Spa_PlanDetails_Costs_Header = 'Costs';
        this.Spa_PlanCompare_Header = 'Compare Plans';
        this.Spa_PlanCompare_MedicalCoverage_Text = 'Medical coverage';
        this.Spa_PlanCompare_PrescriptionDrugCoverage_Text = 'Prescription drug coverage';
        this.Spa_PlanCompare_PlanDocument_Text = 'Plan documents';
        this.Spa_Prescription_Add_Edit_Link = 'Add/edit prescription list';
        this.Spa_Site_Pharmacy_AddEdit_Link = 'Add/edit pharmacy';
        this.Spa_Plan_Details_AddOnRiders_Header = 'Optional add-on coverage';
        this.Spa_Site_PageSubHeader_Text = '';
        this.Spa_PlanDetails_Preferences_SearchPrescriptions_Text = 'Search Prescriptions';
        this.Spa_PlanDetails_Preferences_PrescriptionDirectory_Title = 'Prescription Directory';
        this.Spa_PlanDetails_Preferences_PrescriptionDirectory_Link = {
            title: this.Spa_PlanDetails_Preferences_PrescriptionDirectory_Title,
            tag: 'HelpfulToolsPharmacySearch',
            href: ''
        };
        this.Spa_PlanDetails_Preferences_SearchPharmacy_Text = 'Search Pharmacy';
        this.Spa_PlanDetails_Preferences_PharmacyDirectory_Title = 'Pharmacy Directory';
        this.Spa_PlanDetails_Preferences_PharmacyDirectory_Link = {
            title: this.Spa_PlanDetails_Preferences_PharmacyDirectory_Title,
            tag: 'HelpfulToolsPharmacySearch',
            href: ''
        };
        this.Spa_Site_PrimaryPharmacy_Indicator_Text = 'primary';
        this.Spa_Site_Preferred_In_Network_Text = 'Preferred In-network';
        this.Spa_Site_Standard_In_Network_Text = 'Standard In-network';
        this.Spa_Site_Out_Of_Network_Text = 'Out of network';
        this.Spa_Site_CostBasedOn_Text = 'Costs are based on';
        this.Spa_Site_Mail_Order_Pharmacy_Enabled = true;
        this.Spa_PlanList_MailOrder_Text = 'Mail order';
        this.Spa_Provider_InNetwork_Text = 'In-network';
        this.Spa_Provider_OutOfNetwork_Text = 'Out-of-network';
        this.Spa_Providers_No_Data_Exist_Text = 'No provider data available for this carrier';
        this.Spa_Site_Pcp_Text = 'PCP';
        this.Spa_Providers_Add_Edit_Link = 'Add/edit providers list';
        this.Spa_Site_Providers_Enabled = false;
        this.Spa_Site_Preferences_AddEdit_Link = 'Add/edit other preferences';
        this.Spa_Plan_Details_OtherPreferences_Text = 'Other preferences';
        this.Spa_Site_OtherPreferences_Enabled = false;
        this.Spa_Site_Yes = 'Yes';
        this.Spa_Site_No = 'No';
        this.Spa_Providers_NoProviderNetworkAccess_Text = 'No access to provider network data';
        this.Spa_Site_HealthCosts_Enabled = true;
        this.Spa_Plan_Providers_Internal_Directory_Link_Text = 'Internal provider directory';
        this.Spa_Plan_Providers_Carrier_Directory_Link_Text = 'Carrier’s provider directory';
        this.Spa_Site_Plan_List_Link = 'Plan list';
        this.Spa_Plan_Providers_BothCarrierAndInternal_DirectoryLinks_Enabled = false;
        this.Spa_PlanDetails_Preferences_ProviderDirectory_Link = {
            title: this.Spa_Plan_Providers_Directory_Link,
            tag: 'HelpfulToolsPharmacySearch',
            href: ''
        };
        this.Spa_PlanDetails_Costs_Premium = 'Premium';
        this.SPA_HIP_Rider_Benefit_Default_Dropdown_Text = 'None';
        this.Spa_Site_HIP_BasePlanOption_Text = 'Base plan option';
        this.SPA_Site_NotAvailable_Rider_Benefit_Text = 'Not Available';
        this.SPA_HIP_Rider_Benefit_Text = 'Benefit amount';
        this.Spa_Site_HIP_Description = 'Hospital Indemnity';
        this.Spa_Site_HIP_MonthlyPremium_Text = 'Updated based on benefit selections';
        this.Spa_Hospital_Indemnity_QuoteSummary_Header = 'Quote summary';
        this.Spa_PlanDetails_HIP_Call_Out_Available_Plan_Types = [
            {
                title: 'Medicare Advantage Prescription Drug',
                enabled: true,
                tabType: PlanTypeAbbreviation.MAPD
            },
            {
                title: 'Medicare Advantage',
                enabled: true,
                tabType: PlanTypeAbbreviation.MA
            },
            {
                title: 'Medicare Supplement',
                enabled: false,
                tabType: PlanTypeAbbreviation.MEDIGAP
            }
        ];
        this.Spa_Site_Plan_Option_One_Text = 'Option one';
        this.Spa_Site_Plan_Option_Two_Text = 'Option two';
        this.Spa_Retention_ClientDefinedPlanOptions_Enabled = false;
        this.Spa_Site_PlanLogo_Size = 'small';
        this.Spa_PlanCard_AncillaryAddtoCart_Enabled = false;
        this.Spa_Site_ShowDrugAlternatives_Enabled = false;
        this.Spa_PlanCompare_ShowDrugAlternatives_Nudge_Enabled = false;
        this.Spa_Prescriptions_ShowDrugAlternatives_ViewAlternatives_Text = 'View possible alternatives';
        this.Spa_PlanFilters_DayLabel_Text = 'Number of days';
        this.Spa_Site_Days_Text = 'days';
        this.Spa_Site_Day_Text = 'day';
        this.Spa_PlanList_MedSupEditAnswersBanner_Text = 'Edit your answers.';
        this.Spa_Site_LumpSum_Text = 'Lump sum';
        this.Spa_Site_Provider_ShowAllInNetworkLocations_Enabled = false;
        this.Spa_PlanCompare_StickyMiniCart_Enabled = false;
        this.Spa_Providers_AcceptingNewPatients_Text = 'Accepting new patients';
        this.Spa_Providers_AcceptingNewPatients_Icon = 'fas fa-user-plus';
        this.Spa_Providers_Languages_Icon = 'fas fa-globe';
        this.Spa_Site_PlanFees_Enabled = false;
        this.Spa_PlanFees_Tooltip_Text = 'Fees';
        this.Spa_PlanFees_IncludedInPremium_Tooltip_Text = 'Included in premium';
        this.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text = 'Not included in premium';
        this.Spa_Display_SNP_PremiumRange_Enabled = false;
        this.Spa_PlanCard_Compare_Remove_Modal_Header_Text = 'Remove plan';
        this.Spa_PlanCard_Compare_Remove_Modal_Intro_Text = 'Are you sure you want to remove this plan?';
        this.Spa_Site_Cancel = 'Cancel';
        this.Spa_PlanCard_Compare_Remove_Modal_Button_Text = 'Remove plan';
        this.Spa_PlanCompare_Remove_Mobile_Enabled = false;
        this.Spa_Site_ValueBasedCare_Agreement_Enabled = false;
        this.Spa_Site_ValueBasedCare_Agreement_Label = 'Value Based Care agreement';
        this.Spa_Site_ValueBasedCare_Agreement_Tooltip = 'A Value Based Care agreement exists between your primary care provider and this carrier. See plan details for more information.';
        this.Spa_PreferenceBanner_Enabled = false;
        this.planPharmacyData = [];
        this.planLevelContentLabel = {};
        this.planType = PlanType;
        this.planCompareLabels = PlanCompareLabels;
        this.pageTags = PageTags;
        this.planDocument = 'Plan Documents';
        this.planDetailsCostLabels = PlanDetailsCostLabels;
        this.showDifferences = this.Spa_Site_ShowDifferences_Checked;
        this.showDifferencesCheckBoxItem = {
            label: this.Spa_PlanCompare_Plan_Differences_Text,
            value: 'planDifferences',
            disabled: false,
            initiallyChecked: this.Spa_Site_ShowDifferences_Checked
        };
        this.providersLinkType = ProvidersLinkType;
        this.isDeepLink = false;
        this.riderCategories = [];
        this.planRidersMap = {};
        this.isQuoteSummaryMode = false;
        this.memberHasOptionsDefined = false;
        this.isLiveEdit = EnvironmentService.getEnvironment().liveedit;
        this.liveEditPlans = [];
        this.showViewPossibleAlternatives = false;
        this.areAnyPlansHIP = false;
        this.showPharmacySection = false;
        this.showPrescriptionSection = false;
        this.showProviderSection = false;
        this.showOtherPreferencesSection = false;
        this.providerInfoEnabled = false;
        this.providersAcceptingNewPatientsByPlanMap = {};
        this.languagesByPlanMap = {};
        this.linkRoles = LinkRoles;
        this.medicalCoverageAriaLabel = 'More info about medical costs';
        this.subscriptions = [];
        this._deepLinkingPlanIds$ = new BehaviorSubject([]);
        this.onProviderClick = (plan) => {
            this.helpfulToolsService.navigateToDirectory(plan, this.Spa_PlanDetails_Preferences_ProviderDirectory_Link, HelpfulToolsTabs.Providers);
        };
        this.onPrescriptionClick = (plan) => {
            this.helpfulToolsService.navigateToDirectory(plan, this.Spa_PlanDetails_Preferences_PrescriptionDirectory_Link, HelpfulToolsTabs.Prescriptions);
        };
        this.onPharmacyClick = (plan) => {
            this.helpfulToolsService.navigateToDirectory(plan, this.Spa_PlanDetails_Preferences_PharmacyDirectory_Link, HelpfulToolsTabs.Pharmacy);
        };
        this.preProcess = () => {
            this.showDifferencesCheckBoxItem.label = this.Spa_PlanCompare_Plan_Differences_Text;
            this.planLevelContentLabel = {
                PDP: this.Spa_PlanLevel_Content_Label_PDP,
                MAPD: this.Spa_PlanLevel_Content_Label_MAPD,
                MA: this.Spa_PlanLevel_Content_Label_MA,
                MEDIGAP: this.Spa_PlanLevel_Content_Label_MEDIGAP
            };
        };
    }
    async ngOnInit() {
        super.ngOnInit();
        this.providerInfoEnabled = this.planCardFacade.isProviderInfoEnabled();
        this.providers = this.providerService.getProviders();
        this.isQuoteSummaryMode = this.navigationUtilityService.pageTagURLMatch(PageTags.HOSPITAL_INDEMNITY_VIEW_QUOTE, this.navigationContext.getUrl());
        if (this.isLiveEdit) {
            this.liveEditPlans = this.isQuoteSummaryMode
                ? this.planFacade.getHospitalCareQuoteSummaryLiveEditPlans(this.plansService.getAllPlans())
                : this.planFacade.getLiveEditPlans(this.widgetName);
            if (this.liveEditPlans.length) {
                this.planCompareService.setCompareGroup({
                    ...new CompareGroup(FilterKeyType.PLAN_TYPE_SHORT, [this.liveEditPlans[0].planTypeAbbreviation]),
                    items: this.liveEditPlans.slice(0, 3)
                });
                this.store.dispatch(new SetActiveTab(this.isQuoteSummaryMode ? PlanTypeAbbreviation.HC : this.liveEditPlans[0].planTypeAbbreviation));
            }
        }
        // don't want these in preprocess because they need an intial value but shouldn't update
        this.showDifferences = this.Spa_Site_ShowDifferences_Checked;
        this.showDifferencesCheckBoxItem.initiallyChecked = this.showDifferences;
        this.isMobile$ = this.responsiveLayoutService.isCompact$;
        this.isMedium$ = this.responsiveLayoutService.isMedium$;
        this.isTotalEstimatedCostAnnually$ = this.planFacade.isTotalEstimatedCostAnnually$();
        this.mailOrder$ = this.planCompareFacade.mailOrder$;
        this.selectedProviders$ = this.planCompareFacade.getSelectedProviders$();
        this.selectedPharmacy$ = this.planCompareFacade.getSelectedPharmacy$();
        this.selectedPharmacies$ = this.planCompareFacade.getSelectedPharmacies$();
        this.highlightBorder = this.Spa_PlanCompare_Plan_Differences_Border;
        this.highlightColor = this.Spa_PlanCompare_Plan_Differences_Color;
        this.highlightStyles = {
            'background-color': this.highlightColor,
            'border': this.highlightBorder
        };
        this.showCostsSection$ = this.planCompareFacade.showCostsSection$();
        this.isRetentionView = this.siteService.isRetentionView();
        this.memberHasOptionsDefined = this.planFacade.memberHasOptionsDefined();
        const locale$ = this.localeService.getCurrentLocale$();
        this.totalCostEffectiveDate$ = this.store.select(MemberState.totalCostEffectiveDate);
        const answers = this.hospitalIndemnityFormFacade.getHospitalIndemnityAnswers();
        this.benefitAmountHIPAnswer = answers.BenefitAmount;
        this.numberOfDaysHIPAnswer = answers.HCDaysCovered;
        await this.planFacade.setDefaultEffectiveDate();
        this.plans$ = this.isLiveEdit
            ? of(this.liveEditPlans.slice(0, 3))
            : combineLatest([locale$, this.totalCostEffectiveDate$]).pipe(distinctUntilChanged(_isEqual), switchMap(([locale, totalCostEffectiveDate]) => {
                this.locale = locale;
                if (this.isQuoteSummaryMode) {
                    return this.planCompareFacade.getHospitalCareQuoteComparePlans$(this.Spa_PlanDetails_HIP_Call_Out_Available_Plan_Types);
                }
                else {
                    return this.planCompareFacade.getPlansSelectedForCompare$();
                }
            }), distinctUntilChanged(_isEqual), switchMap(plans => {
                return combineLatest([of(plans), this.getDeepLinkingPlanIds$()]);
            }), map(([plans, deepLinkingPlanIds]) => {
                return this.sortPlans(plans, deepLinkingPlanIds);
            }));
        this.subscriptions.push(this.planCompareFacade.getPlansLoading$().subscribe({
            next: loading => {
                loading ? this.spinnerService.show(SpinnerEvent.PLANS_LOADING) : this.spinnerService.hide(SpinnerEvent.PLANS_LOADING);
            }
        }));
        this.subscriptions.push(locale$.subscribe({
            next: locale => {
                this.updateEffectiveDateText();
            }
        }));
        this.subscriptions.push(this.pharmacyService.getPharmacyData$().subscribe({
            next: (planPharmacyData) => {
                this.planPharmacyData = planPharmacyData;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.push(combineLatest([this.plans$, this.selectedProviders$]).subscribe({
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            next: async ([plans, selectedProviderList]) => {
                // TODO: We shouldn't be awaiting anything in a subscribe, so this whole section could use a refactor
                if (this.isMobile && plans.length >= 2) {
                    this.allMobilePlans = plans;
                    this.comparePlanGroupMobile(this.allMobilePlans[0], this.allMobilePlans[1]);
                }
                else {
                    this.plans = plans;
                }
                this.providerDetailResponse = await this.providerService.fetchProvidersDetailsBasedOnAvailablePlans(plans, this.Spa_Site_Provider_ShowAllInNetworkLocations_Enabled);
                this.selectedProviderList =
                    selectedProviderList?.map(provider => ({
                        ...provider,
                        hasAgreement: this.planFacade.getProviderByVbcAgreement(plans, this.providerDetailResponse, provider)?.hasAgreement || false
                    })) || [];
                const networkResult = await this.providerService.fetchProvidersDetails(this.providerService.getProviderDetailsRequest(plans), true);
                plans.forEach(plan => {
                    const planId = plan.id;
                    const planDataFromNetworkCall = networkResult?.plans?.find((plan) => plan.id === planId);
                    if (planDataFromNetworkCall) {
                        this.languagesByPlanMap[planId] = this.providerFacade.createProviderLanguagesMap(planDataFromNetworkCall.providers);
                        this.providersAcceptingNewPatientsByPlanMap[planId] = planDataFromNetworkCall.providers ?? [];
                    }
                });
                this.tagsToUpdate = this.planCompareFacade.getPlansCompareTags(plans);
                this.riderCategories = this.planCompareFacade.getRiderCategories(plans);
                this.updateShowPreferencesSections(plans);
                this.areAnyPlansHIP = plans.some(plan => plan.planTypeAbbreviation === PlanTypeAbbreviation.HC);
                this.areAnyPlansMAPD = plans.some(plan => plan.planTypeAbbreviation === PlanTypeAbbreviation.MAPD);
                this.planProviderMedicalGroups = this.providerFacade.getProviderMedicalGroups(this.providerDetailResponse);
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.push(this.planCompareFacade.getActiveTabType$().subscribe({
            next: (activeTabType) => {
                this.activeTabType = activeTabType;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.push(this.totalCostEffectiveDate$.subscribe({
            next: (totalCostEffectiveDate) => {
                this.updateEffectiveDateText();
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.push(this.isMobile$.subscribe({
            next: (isMobile) => {
                this.isMobile = isMobile;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.push(this.isMedium$.subscribe({
            next: (isMedium) => {
                this.isMedium = isMedium;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.push(this.isTotalEstimatedCostAnnually$.subscribe({
            next: (isTotalEstimatedCostAnnually) => {
                this.isTotalEstimatedCostAnnually = isTotalEstimatedCostAnnually;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.push(this.mailOrder$.subscribe({
            next: (mailOrder) => {
                this.mailOrder = mailOrder;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.push(this.selectedPharmacy$.subscribe({
            next: (selectedPharmacy) => {
                this.selectedPharmacy = selectedPharmacy;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.push(this.selectedPharmacies$.subscribe({
            next: (selectedPharmacies) => {
                this.selectedPharmacies = selectedPharmacies;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.push(this.localeService.getCountryCode$.subscribe({
            next: (countryCode) => {
                if (countryCode) {
                    this.countryCode = countryCode;
                }
                this.cdr.markForCheck();
            }
        }));
        this.activatedRoute.queryParams.subscribe({
            next: params => {
                this.isDeepLink = this.passParameterService.checkDeepLinkingRequest(params);
                this.setDeepLinkingPlanIds(params?.PlanID?.split(',') || []);
            }
        });
    }
    sortPlans(plans, deepLinkingPlanIds) {
        return plans
            .slice()
            .sort((a, b) => deepLinkingPlanIds.indexOf(this.planFacade.getFormattedFullPlanId(a)) -
            deepLinkingPlanIds.indexOf(this.planFacade.getFormattedFullPlanId(b)));
    }
    getDeepLinkingPlanIds$() {
        return this._deepLinkingPlanIds$.asObservable();
    }
    trackByProvider(index, provider) {
        return provider.id;
    }
    setDeepLinkingPlanIds(planIds) {
        this._deepLinkingPlanIds$.next(planIds);
    }
    onMobileComparePageChanged(page) {
        let nextIndex = 0;
        if (page !== this.allMobilePlans.length - 1) {
            nextIndex = page + 1;
        }
        this.comparePlanGroupMobile(this.allMobilePlans[page], this.allMobilePlans[nextIndex]);
    }
    comparePlanGroupMobile(firstPlan, secondPlan) {
        this.plans = [firstPlan, secondPlan];
        this.cdr.markForCheck();
    }
    updateShowPreferencesSections(plans) {
        this.showPrescriptionSection =
            this.Spa_Site_Prescriptions_Enabled && !BLACKLISTED_PRESCRIPTION_PLAN_TYPES.includes(this.plans[0]?.planType);
        this.showPharmacySection = this.Spa_Site_Pharmacy_Enabled && !BLACKLISTED_PHARMACY_PLAN_TYPES.includes(this.plans[0]?.planType);
        this.showProviderSection = this.getShowProviderSection(plans);
        this.showOtherPreferencesSection = this.getShowOtherPreferencesSection(plans);
    }
    onRiderBenefitDropdownSelection(value) {
        this.planRidersMap = {
            ...this.planRidersMap,
            [value.planId]: value.riders
        };
        this.store.dispatch(new SetPlansDirty(true, [PlanType.HC]));
        this.cdr.detectChanges();
    }
    getProviderLinkType(plan) {
        return this.providerService.findProviderSearchLinkType(plan.providerURL, this.Spa_Site_Providers_Enabled, plan.showProviderSearch, this.Spa_Plan_Providers_BothCarrierAndInternal_DirectoryLinks_Enabled);
    }
    hasProviderUrlForAllPlans(plans) {
        return plans.some(plan => !!plan.providerURL);
    }
    getPlanCompareCustomClass(isMobile, isMedium, totalPlans, isMainSection, isAccordionSection, costTitle, configurableResourceClass) {
        const totalEstimatedCostLabel = this.planDetailsCostLabels.TOTAL_ESTIMATED_COST;
        return this._getPlanCompareCustomClass(isMobile, isMedium, totalPlans, totalEstimatedCostLabel, isMainSection, isAccordionSection, costTitle, configurableResourceClass);
    }
    viewPlanDetailsPage(plan, isComparePlan = false, scrollToDocuments = false) {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, isComparePlan ? DataLayerEvent.CLICK_PLANS_COMPARE : DataLayerEvent.CLICK_PLANS_VIEW_DETAILS);
        this.configurableWidgetService.navigationService.navigateByPageTag(PageTags.PLAN_DETAILS, {
            queryParams: { id: plan.id },
            fragment: scrollToDocuments ? 'documents' : null
        });
    }
    onViewPossibleAlternativeDrugs(plan, cabinet) {
        this.setAnalyticsForViewDrugAlternatives(plan, cabinet);
        this.drugCabinetContext.setDrugEntry(plan, cabinet);
        this.configurableWidgetService.navigationService.navigateByPageTag(PageTags.PLAN_DETAILS, {
            queryParams: { id: plan.id }
        });
    }
    removePlanFromCompare(plan) {
        if (this.plans.length > 2 || (this.isMobile && this.allMobilePlans.length > 2)) {
            this.planCompareService.removePlanFromCompareGroup([this.planCompareFacade.getSelectedCompareGroup()], plan);
            if (this.planFacade.isMedicareOnHospitalCare(plan, this.Spa_PlanDetails_HIP_Call_Out_Available_Plan_Types)) {
                this.plansService.removeRateFactorPlan();
            }
            if (this.isMobile) {
                this.allMobilePlans = this.allMobilePlans.filter(comparePlan => comparePlan.id !== plan.id);
                this.plans = this.allMobilePlans;
            }
            else {
                this.plans = this.plans.filter(comparePlan => comparePlan.id !== plan.id);
            }
            this.cdr.markForCheck();
        }
    }
    disableSendQuote(plans) {
        return plans && plans.every(plan => plan.isPUF);
    }
    areAllDentalPlans(plans) {
        return plans && plans.every(plan => this.planFacade.isDentalPlan(plan));
    }
    areAllVisionPlans(plans) {
        return plans && plans.every(plan => this.planFacade.isVisionPlan(plan));
    }
    getCostDetails(cost) {
        const planCosts = [];
        planCosts.push(cost);
        return planCosts;
    }
    getCostBasedOnPlanType(plans) {
        let currentPlanType = [];
        const planTypeValue = plans[0].planType;
        if (planTypeValue === this.planType.MAPD) {
            currentPlanType = this.Spa_Plandetails_Costs_MAPD;
        }
        else if (planTypeValue === this.planType.MA) {
            currentPlanType = this.Spa_Plandetails_Costs_MA;
        }
        else if (planTypeValue === this.planType.PDP) {
            currentPlanType = this.Spa_Plandetails_Costs_PDP;
        }
        else if (planTypeValue === this.planType.MEDIGAP) {
            currentPlanType = this.Spa_Plandetails_Costs_MEDIGAP;
        }
        else if (planTypeValue === this.planType.DENTAL) {
            currentPlanType = this.Spa_PlanDetails_Costs_DENTAL;
        }
        else if (planTypeValue === this.planType.VISION) {
            currentPlanType = this.Spa_PlanDetails_Costs_VISION;
        }
        else if (planTypeValue === this.planType.HC) {
            currentPlanType = this.Spa_PlanDetails_Costs_HIP;
        }
        return currentPlanType;
    }
    showBenefitValues(plans, compareBenefit) {
        return (!!compareBenefit.title ||
            (plans.some(planBenefit => !!this.getPlanBenefit(planBenefit, compareBenefit)) && !!compareBenefit.benefitID));
    }
    showCost(title) {
        // SPA-14203: We are only interested in displaying the plan fees in the cost section for HIP Quote Summary
        if (this.isQuoteSummaryMode) {
            return title === PlanDetailsCostLabels.PLAN_FEES && this.plansService.getIsPlanFeesEnabled();
        }
        return this.planFacade.showCost(title);
    }
    onPlanDifferenceSelected() {
        this.showDifferences = !this.showDifferences;
    }
    showHighlightDifferences(plans, label, benefit, isMailOrder) {
        return this.planCompareFacade.showHighlightDifferences({
            plans,
            notAvailableText: this.Spa_Site_NotApplicable_Text,
            showDifferences: this.showDifferences,
            label,
            benefit,
            isMailOrder,
            isQuoteSummaryMode: this.isQuoteSummaryMode
        });
    }
    currentYearPlanExists(plans) {
        return plans.some(plan => !!plan.isCurrentYearPlan);
    }
    getPlanCompareStyles(plans, options) {
        if (this.showHighlightDifferences(plans, options.costTitle, options.benefit, options.isMailOrder)) {
            return this.highlightStyles;
        }
    }
    getPlanDifferenceStyles(isMobile, isMedium) {
        let customStyles = {
            'border-radius': '5px',
            'padding': '5px 5px 0',
            'margin-top': '48px'
        };
        if (isMobile || isMedium) {
            customStyles = {
                'border-radius': '5px',
                'padding': '5px 5px 0',
                'margin-top': '0px'
            };
        }
        if (this.showDifferences) {
            const border = 'border';
            customStyles[border] = this.highlightBorder;
            customStyles['background-color'] = this.highlightColor;
        }
        return customStyles;
    }
    getPlanBenefit(plan, compareBenefit) {
        return this.planCompareFacade.getPlanBenefit(plan, compareBenefit);
    }
    getShowProviderSection(plans) {
        return (plans?.length &&
            WHITELISTED_PROVIDER_PLAN_TYPES.includes(plans[0].planType) &&
            this.Spa_Plan_Details_Preferences_Show_Provider &&
            (this.hasProviderUrlForAllPlans(plans) || (this.planFacade.selectedProviders && !!this.planFacade.selectedProviders.length)));
    }
    getShowOtherPreferencesSection(plans) {
        return plans?.length && !BLACKLISTED_OTHER_PREFERENCES_PLAN_TYPES.includes(plans[0].planType) && this.Spa_Site_OtherPreferences_Enabled;
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
        this.spinnerService.reset();
    }
    backToPrevious() {
        this.plansService.setOverrideActiveTab(false);
        if (this.areAllDentalPlans(this.plans)) {
            this.planListFacade.updateActiveTab(PlanTypeAbbreviation.DENTAL);
        }
        else if (this.areAllVisionPlans(this.plans)) {
            this.planListFacade.updateActiveTab(PlanTypeAbbreviation.VISION);
        }
        else if (this.activeTabType === PlanTypeAbbreviation.HC) {
            this.planListFacade.updateActiveTab(PlanTypeAbbreviation.HC);
        }
        else {
            this.planListFacade.updateActiveTab(this.plans[0].planTypeAbbreviation);
        }
        if (this.isDeepLink) {
            this.configurableWidgetService.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
        }
        else {
            this.configurableWidgetService.navigationService.backToPrevious();
        }
    }
    updateEffectiveDateText() {
        this.showEffectiveDateText = !this.planFacade.isLastMonthOfYear();
        this.effectiveDateText = this.planFacade.getTotalEstimatedCostEffectiveDate();
    }
    getPharmacyInfoForPlan$(planId) {
        return this.pharmacyService.getAPIPharmacyInfoForPlan$(planId);
    }
    isAddToQuoteAvailable(plans) {
        return plans?.every(plan => this.planFacade.isAddToQuoteAvailable(plan.planTypeAbbreviation, plan)) ?? false;
    }
    _getPlanCompareCustomClass(isMobile, isMedium, totalPlans, totalEstimatedCostLabel, isMainSection, isAccordionSection, costTitle, configurableResourceClass) {
        let customClass = 'col-3';
        if ((isMobile || isMedium) && isMainSection) {
            if (costTitle && costTitle === totalEstimatedCostLabel) {
                customClass = 'col-12 Spa_Style_Cost_Background';
            }
            else {
                customClass = 'col-12';
            }
        }
        if ((isMobile || isMedium) && !isMainSection) {
            customClass = 'col-6';
        }
        if (totalPlans <= 2 && !(isMobile || isMedium)) {
            if (isAccordionSection) {
                customClass = 'col-4 gray1-static';
            }
            else {
                customClass = 'col-4';
            }
        }
        if (isAccordionSection && totalPlans > 2 && !(isMobile || isMedium)) {
            customClass = 'col-3 gray1-static';
        }
        if (configurableResourceClass) {
            customClass = customClass.concat(` ${configurableResourceClass}`);
        }
        return customClass.concat(costTitle && costTitle === totalEstimatedCostLabel ? ' Spa_Style_Cost_Background' : '');
    }
    setAnalyticsForViewDrugAlternatives(plan, cabinetEntry) {
        this.analyticsService.googleDataLayerTags = this.planDetailsFacade.getViewDrugAlternativesTag(plan, cabinetEntry, this.pharmacyService.getIsMailOrderSelected(), true);
    }
};
PlanCompareComponent.ɵfac = function PlanCompareComponent_Factory(t) { return new (t || PlanCompareComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.PassParameterService), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.PlanCompareService), i0.ɵɵdirectiveInject(PlanCompareFacade), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService), i0.ɵɵdirectiveInject(PlanDetailsFacade), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(PlanListFacadeService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(HelpfulToolsService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.ProviderService), i0.ɵɵdirectiveInject(i1.PharmacyService), i0.ɵɵdirectiveInject(DrugCabinetContext), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(i1.NavigationContext), i0.ɵɵdirectiveInject(PlanCardFacade), i0.ɵɵdirectiveInject(HospitalIndemnityFormFacade), i0.ɵɵdirectiveInject(ProviderFacade)); };
PlanCompareComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanCompareComponent, selectors: [["vnext-widget-plan-compare"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 11, vars: 5, consts: [[1, "container", "mb-2"], [1, "mt-2"], [1, "col-12", "mt-3", "text-center"], [3, "title", "showArrow", "makeInlineBlock", "role", "keyup.enter", "click", 4, "liveEditProp"], [1, "col-12", "mt-2", "mb-3", "text-center"], [4, "ngIf", "ngIfElse"], ["quoteSummaryHeader", ""], [1, "col-12", "mt-4", "mb-5"], ["navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [4, "ngIf"], [3, "title", "showArrow", "makeInlineBlock", "role", "keyup.enter", "click"], ["id", "plan-compare-page-heading", "class", "Spa_Style_H1", 4, "liveEditProp"], ["id", "plan-compare-page-heading", 1, "Spa_Style_H1"], ["class", "Spa_Style_H1", 4, "liveEditProp"], [1, "Spa_Style_H1"], [3, "numberOfDaysText", "daysText", "dayText", "editYourAnswersText", "lumpSumText", "basePlanText", "daysAmount", "benefitAmount"], ["navigationAdapter", "", 3, "innerHtml"], [1, "w-100"], ["vnextGoogleTagManager", "", 3, "tagsToUpdate", "saveDefaultValues", 4, "ngIf"], ["role", "table", "aria-labelledby", "plan-compare-page-heading", "class", "col-12 pb-0 px-0 mb-2", 3, "ngClass", 4, "ngIf"], ["class", "plan-compare-main-section col-12 p-0", 4, "ngIf"], ["vnextGoogleTagManager", "", 3, "tagsToUpdate", "saveDefaultValues"], ["role", "table", "aria-labelledby", "plan-compare-page-heading", 1, "col-12", "pb-0", "px-0", "mb-2", 3, "ngClass"], ["role", "rowgroup", 1, "sr-only"], ["role", "row"], ["role", "columnheader", 4, "liveEditProp"], ["role", "columnheader"], ["role", "rowgroup", 1, "container", "mb-1", "mb-md-1"], ["role", "row", 1, "row", "d-none", "d-lg-flex"], [1, "col-12", 3, "plans", "isMobile", "isMedium", "currentPlanText", "nextYearPlanText", "optionOneText", "optionTwoText", "displayOptionLabels", "disableNextYearDisplay", "nonCommissionableText", "isNonCommissionableFlagCheckEnabled", "customClass"], ["role", "row", 1, "row", "plan-compare-section", 3, "ngClass"], ["class", "plan-compare-checkbox-section gray1-static", "role", "rowheader", 3, "ngClass", 4, "ngIf"], ["class", "col-12", 3, "planCount", "pageChanged", 4, "ngIf"], [1, "d-print-none", "d-lg-none", 3, "ngClass", "plans", "isMobile", "isMedium", "currentPlanText", "nextYearPlanText", "optionOneText", "optionTwoText", "displayOptionLabels", "nonCommissionableText", "isNonCommissionableFlagCheckEnabled", "disableNextYearDisplay", "customClass"], [3, "ngClass"], [3, "plans", "planRidersMap", "showLogo", "planTypes", "medicareTypes", "activeTabType", "planDetailsButton", "isRetentionView", "isMobile", "isMedium", "locale", "currentPlanText", "nextYearPlanText", "isCurrentYearPlanExist", "planCardQuoteLinkText", "showPlanViewDetails", "removePlanText", "hospitalIndemnityBadgeText", "monthlyPremiumText", "planLogoSize", "isAncillaryAddToCartEnabled", "stickyMiniCartEnabled", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "snpPremiumRangeEnabled", "showRemovePlanButtonForMobile", "removeModalHeaderText", "removeModalIntroText", "removeModalCancelText", "removeModalButtonText", "viewPlanDetailsPage", "removePlanFromCompare"], ["role", "rowheader", 1, "plan-compare-checkbox-section", "gray1-static", 3, "ngClass"], [3, "items", "customStyles", "enablePrimaryColor", "customClass", "change"], ["class", "btn Spa_Style_SecondaryButton btn-block mt-2", 3, "click", "keyup.enter", 4, "ngIf"], [3, "preferencesBannerEnabled", "pharmacySelectorTextKey", "pharmacySelectorText", "pharmacies", "selectedPharmacy", "preferredInNetworkText", "standardInNetworkText", "outOfNetworkText", "mailOrderText", "isMailOrderSelected", "showMailOrderOption", "selectMailOrder", "selectPharmacy", 4, "ngIf"], [3, "activePlanType"], [1, "btn", "Spa_Style_SecondaryButton", "btn-block", "mt-2", 3, "click", "keyup.enter"], [3, "preferencesBannerEnabled", "pharmacySelectorTextKey", "pharmacySelectorText", "pharmacies", "selectedPharmacy", "preferredInNetworkText", "standardInNetworkText", "outOfNetworkText", "mailOrderText", "isMailOrderSelected", "showMailOrderOption", "selectMailOrder", "selectPharmacy"], [1, "col-12", 3, "planCount", "pageChanged"], [1, "plan-compare-main-section", "col-12", "p-0"], [3, "accordionId", "accordionSectionHeader", "isLiveEditable", "headerPropertyName", "accordionIsOpen", "plansLength", 4, "ngIf"], ["class", "container-fluid", 4, "ngIf"], ["class", "row ml-0 mr-0", 4, "ngIf"], [3, "isSubSectionHeaderExist", "isPanelContentExist", "customClass", "isPanelLeftSectionLiveEditable", "panelLeftSectionLiveEditTag", "panelLeftSectionContent", "Spa_Site_Tooltip_Text"], ["nonCostSection", "", "class", "plan-compare-list-section", 3, "ngClass", 4, "ngFor", "ngForOf"], ["nonCostSection", "", 1, "plan-compare-list-section", 3, "ngClass"], [3, "plan", "isComparePage", "notApplicableText", "planLevelContentLabel", "colIndex"], [3, "accordionId", "accordionSectionHeader", "isLiveEditable", "headerPropertyName", "accordionIsOpen", "plansLength"], [4, "ngFor", "ngForOf"], ["class", "plan-compare-benefit-section", "role", "row", 4, "ngIf"], ["role", "row", 1, "plan-compare-benefit-section"], [3, "isSubSectionHeaderExist", "isPanelContentExist", "customClass", "panelLeftSectionContent", "panelLeftCostDetails", "healthEnabled", "costAddEditLinkText", "plans", "isSubTextExist", "healthCostText", "isHighLighted", "offScreenHighLightLabelText", "Spa_Site_Tooltip_Text", "showEffectiveDateText", "effectiveDateText"], ["costSection", "", "class", "plan-compare-list-section text-center text-lg-left", 3, "ngStyle", "ngClass", 4, "ngFor", "ngForOf"], ["costSection", "", 1, "plan-compare-list-section", "text-center", "text-lg-left", 3, "ngStyle", "ngClass"], ["role", "cell", 3, "ngSwitch"], [4, "ngSwitchCase"], [3, "preferencesBannerEnabled", "healthEnabled", "isComparePage", "costDetails", "plan", "costAddEditLinkText", "noCostAvailableText", "selectedPharmacy", "annualCost", "addHealthCostText", "planFeesEnabled", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText"], [3, "preferencesBannerEnabled", "healthEnabled", "isComparePage", "costDetails", "plan", "costAddEditLinkText", "noCostAvailableText", "selectedPharmacy", "annualCost", "isMailOrderSelected", "addHealthCostText"], [3, "preferencesBannerEnabled", "healthEnabled", "isComparePage", "costDetails", "plan", "costAddEditLinkText", "noCostAvailableText", "selectedPharmacy", "annualCost", "addHealthCostText"], [3, "preferencesBannerEnabled", "healthEnabled", "isComparePage", "costDetails", "plan", "costAddEditLinkText", "noCostAvailableText", "selectedPharmacy", "isMailOrderSelected", "annualCost", "addHealthCostText"], [3, "preferencesBannerEnabled", "isComparePage", "costDetails", "plan", "planFeesEnabled", "noCostAvailableText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText"], [1, "container-fluid"], [1, "row"], [1, "col-12", "p-0", 3, "ngClass"], [3, "accordionId", "accordionSectionHeader", "isLiveEditable", "headerPropertyName", "accordionIsOpen"], [3, "subSectionHeader", "tooltipContent", "isTooltipExist", "isSubSectionHeaderExist", "Spa_Site_Tooltip_Text", "plans", 4, "ngIf"], [3, "medicalDeductibleToolTipContent", "medicalDeductibleIsTooltipExist", "medicalDeductibleIsSubSectionHeaderExist", "medicalDeductibleIsContentExist", "medicalDeductibleLeftSectionContent", "customClass", "plans", "customClassBenefitValue", "notAvailableText", "medicalDeductibleTitle", "medicalMaxOutOfPocketToolTipContent", "medicalMaxOutOfPocketIsTooltipExist", "medicalMaxOutOfPocketIsSubSectionHeaderExist", "medicalMaxOutOfPocketIsContentExist", "medicalMaxOutOfPocketLeftSectionContent", "medicalMaxOutOfPocketTitle", "planCompareBenefitValuesMAPD", "planCompareBenefitValuesMA", "planCompareBenefitValuesMEDIGAP", "siteShowDifferencesChecked", "planComparePlanDifferencesColor", "planComparePlanDifferencesBorder", "planCompareHighLightOffScreenText", "Spa_Site_Tooltip_Text", "medicalCoverageAriaLabel"], [3, "plans", "prescriptionLeftSectionCustomClass", "prescriptionRightSectionCustomStyles", "showHighlightPlanDifferences", "prescriptionRightSectionCustomClass", "prescriptionDeductibleText", "prescriptionDeductibleTooltip", "showPrescriptionDeductibleTooltip", "prescriptionInitialCoverageText", "prescriptionInitialCoverageTooltip", "showPrescriptionInitialCoverageTooltip", "prescriptionDrugsText", "prescriptionDrugsTooltip", "showPrescriptionDrugsTooltip", "prescriptionDrugsNotApplicableText", "planCompareHighLightOffScreenText", "Spa_Site_Tooltip_Text", "showInitialCoverageLimit", 4, "ngIf"], [3, "accordionId", "accordionSectionHeader", "isLiveEditable", "headerPropertyName", "accordionIsOpen", 4, "ngIf"], ["class", "col-12 p-0 order-2", 3, "ngClass", 4, "ngIf"], [1, "col-12", "p-0", "order-2"], [3, "accordionId", "accordionSectionHeader", "isLiveEditable", "headerPropertyName", "accordionIsOpen", "accordionSubHeaderClass"], [3, "isSubSectionHeaderExist", "isPanelContentExist", "panelLeftSectionContent", "customClass", "Spa_Site_Tooltip_Text", "plans"], ["role", "cell", "nonCostSection", "", "class", "plan-compare-list-section plan-compare-document text-center text-lg-left", 3, "ngClass", 4, "ngFor", "ngForOf"], [3, "subSectionHeader", "tooltipContent", "isTooltipExist", "isSubSectionHeaderExist", "Spa_Site_Tooltip_Text", "plans"], [3, "plans", "prescriptionLeftSectionCustomClass", "prescriptionRightSectionCustomStyles", "showHighlightPlanDifferences", "prescriptionRightSectionCustomClass", "prescriptionDeductibleText", "prescriptionDeductibleTooltip", "showPrescriptionDeductibleTooltip", "prescriptionInitialCoverageText", "prescriptionInitialCoverageTooltip", "showPrescriptionInitialCoverageTooltip", "prescriptionDrugsText", "prescriptionDrugsTooltip", "showPrescriptionDrugsTooltip", "prescriptionDrugsNotApplicableText", "planCompareHighLightOffScreenText", "Spa_Site_Tooltip_Text", "showInitialCoverageLimit"], [3, "isSubSectionHeaderExist", "isProvidersEnabled", "customClass", "headerPropertyName", "subSectionHeader", "iconClass", "isPreferencesSection", "Spa_Site_Tooltip_Text", "linkPropertyName", "linkTitle", "tag", "plans"], ["role", "row", "class", "row mx-0 provider-directory", 4, "ngIf"], ["class", "provider-section", 3, "vnextHighlightDifferences", "showDifferences", "selectorsRowIndex", "trackChanges", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["role", "row", 1, "row", "mx-0", "provider-directory"], ["class", "sr-only", 4, "ngIf"], ["role", "rowheader", 1, "Spa_Style_H5", "plan-compare-left-section", "m-0", 3, "ngClass"], [4, "liveEditProp"], ["class", "plan-compare-right-section text-center text-lg-left", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "sr-only"], [1, "plan-compare-right-section", "text-center", "text-lg-left", 3, "ngClass"], [3, "ngSwitchCase"], [3, "ngSwitchDefault"], [1, "Spa_Style_Link", "Spa_Style_Small_Font", "can-click", 3, "click"], [3, "title", "alwaysUnderlined", "href", "linkTarget"], [1, "pb-4"], [1, "provider-section", 3, "vnextHighlightDifferences", "showDifferences", "selectorsRowIndex", "trackChanges"], ["role", "row", 1, "row", "mx-0"], [3, "planId", "provider", "customClass", "isComparePage", "showProviderDetails", "providerInfoEnabled", "providerDetailResponse", "selectedProviderDetails", "pcpText", "isMobile", "isMedium", "acceptingNewPatientsIcon", "acceptingNewPatientsText", "languagesIcon", "providerLanguages", "providerMedicalGroups", "providersAcceptingNewPatients", "countryCode", "isVbcAgreementEnabled", "vbcAgreementLabel", "vbcAgreementTooltip", "isZelisIntegrationEnabled"], ["role", "cell", "nonCostSection", ""], [3, "planId", "provider", "isComparePage", "providerDetailResponse", "selectedProviderDetails", "inNetworkProviderText", "outOfNetworkProviderText", "pcpText", "noProviderDetailsText", "isMobile", "showNetworkDetails", "noProviderNetworkAccessText", "hasProviderDetails", "canSellPlan", "viewAllText", "hideText", "providerInfoEnabled", "acceptingNewPatientsIcon", "acceptingNewPatientsText", "providerLanguages", "providerMedicalGroups", "providersAcceptingNewPatients", "countryCode", "isZelisIntegrationEnabled"], [3, "isSubSectionHeaderExist", "customClass", "headerPropertyName", "subSectionHeader", "linkPropertyName", "iconClass", "linkTitle", "tag", "isPreferencesSection", "Spa_Site_Tooltip_Text", "plans"], [3, "medicineCabinet", "plans", "showHighlightPlanDifferences", "coveredDrugsText", "nonCoveredDrugsText", "isMobile", "customLeftSectionClass", "customRightSectionClass", "prescriptionDirectoryLink", "searchPrescriptionsText", "searchPrescriptionsKey", "onPrescriptionClickAction", "showDrugAlternativesEnabled", "showDrugAlternativesText", "selectedPharmacy", "isMailOrderSelected", "viewPossibleAlternativeDrugs"], ["role", "row", 1, "row", "mx-0", "pharmacy-directory"], ["role", "cell", "class", "plan-compare-right-section text-center text-lg-left", 3, "ngClass", 4, "ngFor", "ngForOf"], ["role", "cell", 1, "plan-compare-right-section", "text-center", "text-lg-left", 3, "ngClass"], [1, "sr-only", "no-translate-block"], [1, "mb-0"], ["class", "pharmacy-section", 4, "ngFor", "ngForOf"], ["class", "row mx-0", "role", "row", 4, "ngIf"], [1, "pharmacy-section"], ["role", "rowheader"], [1, "no-translate-block"], ["role", "cell", "nonCostSection", "", 3, "class", "ngStyle", 4, "ngFor", "ngForOf"], ["role", "cell", "nonCostSection", "", 3, "ngStyle"], [3, "isComparePage", "pharmacies", "planName", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "nonCoveredText", "showNotCovered"], [1, "plan-details-section-min-height", 3, "isComparePage", "showMailOrderPharmacy", "coveredText", "notCoveredText", "hasMailOrder", "planName", "isMobile"], [3, "plans", "showHighlightPlanDifferences", "answeredPreferenceBenefits", "coveredBenefitText", "nonCoveredBenefitText", "isMobile", "customLeftSectionClass", "customRightSectionClass"], [1, "col-12", "p-0", "order-2", 3, "ngClass"], [3, "accordionId", "accordionSectionHeader", "isLiveEditable", "headerPropertyName", "accordionIsOpen", "accordionSubHeaderClass", "accordionSubHeader"], [3, "plans", "showHighlightPlanDifferences", "waiverStateRidersTooltips", "shoppingCartIncludedRiderText", "riderNotSupportedText", "notApplicableText", "riderLeftSectionCustomClass", "riderRightSectionCustomClass", "showRiderDetailsText", "hideRiderDetailsText", "showRiderDetails", "planCompareHighLightOffScreenText", "Spa_Site_Tooltip_Text"], ["role", "cell", "nonCostSection", "", 1, "plan-compare-list-section", "plan-compare-document", "text-center", "text-lg-left", 3, "ngClass"], [3, "title", "alwaysUnderlined", "isLinkButton", "click", "keyup.enter", 4, "ngIf"], [3, "title", "alwaysUnderlined", "isLinkButton", "click", "keyup.enter"], [1, "row", "ml-0", "mr-0"], [1, "col-12", "pl-0", "pr-0"], [3, "plans", "locale", "sectionHeaderText", "basePlanOptionLabel", "medicareTypes", "hospitalCareRiderBenefitDefaultDropdownText", "hospitalCareRiderBenefitText", "notAvailableRiderBenefitText", "selectedRiderBenefits"]], template: function PlanCompareComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, PlanCompareComponent_vnext_link_3_Template, 1, 4, "vnext-link", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtemplate(5, PlanCompareComponent_ng_container_5_Template, 2, 1, "ng-container", 5);
        i0.ɵɵtemplate(6, PlanCompareComponent_ng_template_6_Template, 2, 2, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵtemplate(9, PlanCompareComponent_div_9_Template, 2, 4, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, PlanCompareComponent_ng_container_10_Template, 5, 3, "ng-container", 9);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(7);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "isDeepLink ? Spa_Site_Plan_List_Link : Spa_Site_Previous");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isQuoteSummaryMode)("ngIfElse", _r2);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_PageSubHeader_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.plans);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgStyle, i1$2.NgSwitch, i1$2.NgSwitchCase, i1$2.NgSwitchDefault, CheckboxGroupComponent, LinkComponent, NavigationAdapterDirective, LiveEditPropDirective, GoogleTagManagerDirective, HighlightDifferencesDirective, PlanCostSectionComponent, PharmacySelectorComponent, PlanPharmacyDetailsComponent, MailOrderPharmacyDetailsComponent, PlanLevelContentComponent, PlanCompareMedicalBenefitsComponent, PlanComparePanelComponent, PlanCompareAccordionComponent, PlanComparePrescriptionComponent, PlanComparePrescriptionCoverageComponent, PlanComparePreferencesComponent, PlanComparePaginationComponent, PlanCompareRidersComponent, PlanCompareCardLabelComponent, PlanCompareCardComponent, PlanQuoteBenefitDetailsComponent, PlanProviderDetailsComponent, EffectiveDateDisplayComponent, HIPDetailsBannerComponent, i1$2.AsyncPipe, SafePipe], styles: [".plan-compare-section[_ngcontent-%COMP%]{box-shadow:0 2px 4px 1px var(--static-Spa_Style_Accent1);margin-bottom:4px;border-radius:6px}.plan-compare-left-section[_ngcontent-%COMP%], .plan-compare-right-section[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);padding:12px 14px 14px}.plan-compare-right-section[_ngcontent-%COMP%]:last-child{border-right-width:0px}.plan-compare-list-section[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1);padding:10px 6px 10px 14px}.plan-compare-list-section[_ngcontent-%COMP%]:last-child{border-right-width:0px}.plan-compare-checkbox-section[_ngcontent-%COMP%]{border-top-left-radius:6px;border-bottom-left-radius:6px;border:1px solid var(--static-Spa_Style_Accent1);border-right-width:0px}.gray1-static[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray1)}.plan-compare-card-quote-summary[_ngcontent-%COMP%]{background-color:#fff}.plan-compare-benefit-section[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Accent1)}.plan-compare-list-section.plan-compare-document[_ngcontent-%COMP%]{padding:24px 0 22px 18px}.plan-compare-list-section[_ngcontent-%COMP%] + .plan-compare-list-section[_ngcontent-%COMP%]{border-left-width:0!important}.current-plan-text[_ngcontent-%COMP%], .next-year-plan-text[_ngcontent-%COMP%]{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px;padding:3px 16px}.current-plan-card-border[_ngcontent-%COMP%], .next-year-plan-card-border[_ngcontent-%COMP%]{border-width:2px;border-style:solid}.pharmacy-directory[_ngcontent-%COMP%], .provider-directory[_ngcontent-%COMP%], .provider-section[_ngcontent-%COMP%], .pharmacy-section[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Accent1)}.sticky[_ngcontent-%COMP%]{position:sticky;top:-15px;background-color:#fff;z-index:1}.sticky-top-hip[_ngcontent-%COMP%]{top:0;padding-top:10px}.sticky-top-hip-medicare[_ngcontent-%COMP%]{top:0;padding-top:29px}@media (max-width: 991.9px){.plan-compare-section[_ngcontent-%COMP%]{box-shadow:none;border-radius:0}.plan-compare-main-section[_ngcontent-%COMP%]{border-width:0px;border-bottom:1px solid var(--static-Spa_Style_Accent1)}.plan-compare-checkbox-section[_ngcontent-%COMP%]{border:0px}.plan-compare-card[_ngcontent-%COMP%]{border-width:0px}.plan-compare-card[_ngcontent-%COMP%]:last-child{border-radius:0}.plan-compare-list-section.plan-compare-document[_ngcontent-%COMP%]{padding:10px 14px}.plan-compare-left-section[_ngcontent-%COMP%]{border-right-width:0px;text-align:center}.plan-compare-right-section[_ngcontent-%COMP%]:last-child{border-left:1px solid var(--static-Spa_Style_Accent1)}}@media print{.container[_ngcontent-%COMP%]{min-width:initial!important}.plan-compare-section[_ngcontent-%COMP%]{border-radius:6px}.plan-compare-main-section[_ngcontent-%COMP%], .plan-compare-checkbox-section[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1)}.plan-compare-card[_ngcontent-%COMP%]{border-width:1px}.plan-compare-card[_ngcontent-%COMP%]:last-child{border-radius:6px}.plan-compare-left-section[_ngcontent-%COMP%]{border-right-width:1px}}"], changeDetection: 0 });
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_Site_Previous", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCard_PlanDetails_ButtonText", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCompare_Benefit_Show_MedicalDeductible_Tooltip", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCompare_Benefit_Show_MedicalMaxOutOfPocket_Tooltip", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCard_Benefit_MedicalDeductible_Title", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCompare_Benefit_MedicalMaxOutOfPocket_Title", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCard_Benefit_MedicalDeductible_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCompare_Benefit_MedicalMaxOutOfPocket_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Remove_Plan_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCompare_Benefit_MedicalDeductible_Tooltip", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCompare_Benefit_MedicalMaxOutOfPocket_Tooltip", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCompare_Benefit_values_MA", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCompare_Benefit_values_MAPD", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCompare_Benefit_values_MEDIGAP", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_ViewDetails", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Pharmacy_InNetwork_Preferred_Pricing_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Pharmacy_InNetwork_Standard_Pricing_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Pharmacy_OutOfNetwork_Pricing_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Plan_Details_Show_Preferences", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Plan_Details_Preferences_Show_Provider", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_ZelisIntegration_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Prescriptions_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Pharmacy_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanDetails_Covered_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanDetails_Non_Covered_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Plan_Details_Preferences_Position_Last", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_GuidedHelp_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Plan_Details_Preferences_Expanded", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Health_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_TotalEstimatedCost_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_ShowDifferences_Checked", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCompare_Plan_Differences_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCompare_Plan_Differences_Color", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCompare_Plan_Differences_Border", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Rider_NotSupported_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_ShowPremiumAsAnnual", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_ShoppingCart_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_NotApplicable_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Plan_Details_ViewRiderDetails_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Plan_Details_HideRiderDetails_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_RiderDetails_Show", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_HealthCostsTab_AddAgeHealth_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Hide_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_ViewAll_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Plan_Details_WaiverStateRider_Tooltips", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanDetails_NonCommissionable_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanDetails_NonCommissionable_FlagCheck_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Current_Plan_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Next_Year_Plan_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_PlanNotAvailableForNextYear_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Keep_This_Plan_Button_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Show_PlanLogo", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_SendQuote_Button_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_IsDeepLinking_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_SiteType", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Compare_ViewDetails_Description", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_DrugCost_Add_Edit_Link_Description", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_HealthCost_Add_Edit_Link_Description", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Prescription_Add_Edit_Link_Description", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Pharmacy_Add_Edit_Link_Description", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_PlanViewDetails_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCard_Benefit_VisionDeductible_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCard_Benefit_DentalDeductible_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCard_Benefit_CalendarYearMax_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_PlanLevel_Content_Label_PDP", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_PlanLevel_Content_Label_MAPD", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_PlanLevel_Content_Label_MA", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_PlanLevel_Content_Label_MEDIGAP", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_Show_Plan_Level_Content", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_Plan_Benefits_Section_Name", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_PlanCompare_MedicalCoverage_Tooltip", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_PlanCompare_Show_MedicalCoverage_Tooltip", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_PlanCompare_PrescriptionDrugCoverage_Tooltip", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_PlanCompare_Show_PrescriptionDrugCoverage_Tooltip", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_PlanCompare_PlanDocument_ViewMore_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_Plan_Providers_Search_Provider_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Plan_Providers_Directory_Link", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_Plan_Details_Preferences_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_Plan_Details_Preferences_Pharmacy_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_Plan_Details_Preferences_Prescription_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_Plan_Details_Preferences_Provider_Text", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_Plan_Details_Providers_Link", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_Plan_Compare_PrescriptionDeductible_Text", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_Plan_Compare_PrescriptionDeductible_Tooltip", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_Plan_Compare_ShowPrescriptionDeductible_Tooltip", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_Plan_Compare_PrescriptionDrugs_Text", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_Plan_Compare_PrescriptionDrugs_Tooltip", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_Plan_Compare_ShowPrescriptionDrugs_Tooltip", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_PlanCompare_Benefit_Show_InitialCoverageLimit", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_Plan_Compare_PrescriptionInitialCoverageLimit_Text", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_Plan_Compare_PrescriptionInitialCoverageLimit_Tooltip", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_Plan_Compare_ShowPrescriptionInitialCoverageLimit_Tooltip", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_Plandetails_Costs_Add_Edit_Link_Text", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_Plan_Compare_HighLight_OffScreenText", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_PlanDetails_Health_Cost_Text", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_Plandetails_Costs_MAPD", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_Plandetails_Costs_MA", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_Plandetails_Costs_PDP", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_Plandetails_Costs_MEDIGAP", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanDetails_Costs_DENTAL", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanDetails_Costs_VISION", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanDetails_Costs_HIP", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_ShoppingCart_IncludedRider_Text", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_Plan_Details_AddOnRiders_SubHeader", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_PlanCard_QuoteLinkName_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_PlanDetails_Costs_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_PlanCompare_Header", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_PlanCompare_MedicalCoverage_Text", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_PlanCompare_PrescriptionDrugCoverage_Text", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_PlanCompare_PlanDocument_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_Prescription_Add_Edit_Link", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_Site_Pharmacy_AddEdit_Link", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_Plan_Details_AddOnRiders_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_Site_PageSubHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_PlanDetails_Preferences_SearchPrescriptions_Text", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_PlanDetails_Preferences_PrescriptionDirectory_Title", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_PlanDetails_Preferences_PrescriptionDirectory_Link", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_PlanDetails_Preferences_SearchPharmacy_Text", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_PlanDetails_Preferences_PharmacyDirectory_Title", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_PlanDetails_Preferences_PharmacyDirectory_Link", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_PrimaryPharmacy_Indicator_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Preferred_In_Network_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Standard_In_Network_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Out_Of_Network_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_Site_CostBasedOn_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Mail_Order_Pharmacy_Enabled", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_PlanList_MailOrder_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Provider_InNetwork_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Provider_OutOfNetwork_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Providers_No_Data_Exist_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Pcp_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_Providers_Add_Edit_Link", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Providers_Enabled", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_Site_Preferences_AddEdit_Link", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_Plan_Details_OtherPreferences_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_OtherPreferences_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Yes", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_No", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Providers_NoProviderNetworkAccess_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_HealthCosts_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Plan_Providers_Internal_Directory_Link_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Plan_Providers_Carrier_Directory_Link_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Plan_List_Link", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Plan_Providers_BothCarrierAndInternal_DirectoryLinks_Enabled", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_PlanDetails_Preferences_ProviderDirectory_Link", void 0);
__decorate([
    PlatformProp()
], PlanCompareComponent.prototype, "Spa_PlanDetails_Costs_Premium", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "SPA_HIP_Rider_Benefit_Default_Dropdown_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_HIP_BasePlanOption_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "SPA_Site_NotAvailable_Rider_Benefit_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "SPA_HIP_Rider_Benefit_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_HIP_Description", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_HIP_MonthlyPremium_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanCompareComponent.prototype, "Spa_Hospital_Indemnity_QuoteSummary_Header", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanDetails_HIP_Call_Out_Available_Plan_Types", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Plan_Option_One_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Plan_Option_Two_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Retention_ClientDefinedPlanOptions_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_PlanLogo_Size", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCard_AncillaryAddtoCart_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_ShowDrugAlternatives_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCompare_ShowDrugAlternatives_Nudge_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Prescriptions_ShowDrugAlternatives_ViewAlternatives_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanFilters_DayLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Days_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Day_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanList_MedSupEditAnswersBanner_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_LumpSum_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Provider_ShowAllInNetworkLocations_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCompare_StickyMiniCart_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Providers_AcceptingNewPatients_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Providers_AcceptingNewPatients_Icon", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Providers_Languages_Icon", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_PlanFees_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanFees_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanFees_IncludedInPremium_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Display_SNP_PremiumRange_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCard_Compare_Remove_Modal_Header_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCard_Compare_Remove_Modal_Intro_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_Cancel", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCard_Compare_Remove_Modal_Button_Text", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PlanCompare_Remove_Mobile_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_ValueBasedCare_Agreement_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_ValueBasedCare_Agreement_Label", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_Site_ValueBasedCare_Agreement_Tooltip", void 0);
__decorate([
    GlobalResource()
], PlanCompareComponent.prototype, "Spa_PreferenceBanner_Enabled", void 0);
__decorate([
    Memoize()
], PlanCompareComponent.prototype, "areAllDentalPlans", null);
__decorate([
    Memoize()
], PlanCompareComponent.prototype, "areAllVisionPlans", null);
__decorate([
    Memoize()
], PlanCompareComponent.prototype, "_getPlanCompareCustomClass", null);
PlanCompareComponent = __decorate([
    PlatformWidget
], PlanCompareComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanCompareComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-compare', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"container mb-2\">\r\n  <div class=\"mt-2\">\r\n    <div class=\"col-12 mt-3 text-center\">\r\n      <vnext-link\r\n        [title]=\"isDeepLink ? Spa_Site_Plan_List_Link : Spa_Site_Previous\"\r\n        [showArrow]=\"'left'\"\r\n        [makeInlineBlock]=\"true\"\r\n        [role]=\"linkRoles.LINK\"\r\n        (keyup.enter)=\"backToPrevious()\"\r\n        (click)=\"backToPrevious()\"\r\n        *liveEditProp=\"'isDeepLink ? Spa_Site_Plan_List_Link : Spa_Site_Previous'\"\r\n      >\r\n      </vnext-link>\r\n    </div>\r\n    <div class=\"col-12 mt-2 mb-3 text-center\">\r\n      <ng-container *ngIf=\"!isQuoteSummaryMode; else quoteSummaryHeader\">\r\n        <h1 id=\"plan-compare-page-heading\" class=\"Spa_Style_H1\" *liveEditProp=\"'Spa_PlanCompare_Header'\">\r\n          {{ Spa_PlanCompare_Header }}\r\n        </h1>\r\n      </ng-container>\r\n\r\n      <ng-template #quoteSummaryHeader>\r\n        <div class=\"Spa_Style_H1\" *liveEditProp=\"'Spa_Hospital_Indemnity_QuoteSummary_Header'\">\r\n          {{ Spa_Hospital_Indemnity_QuoteSummary_Header }}\r\n        </div>\r\n        <ng-container *ngIf=\"areAnyPlansHIP\">\r\n          <vnext-hip-details-banner\r\n            [numberOfDaysText]=\"Spa_PlanFilters_DayLabel_Text\"\r\n            [daysText]=\"Spa_Site_Days_Text\"\r\n            [dayText]=\"Spa_Site_Day_Text\"\r\n            [editYourAnswersText]=\"Spa_PlanList_MedSupEditAnswersBanner_Text\"\r\n            [lumpSumText]=\"Spa_Site_LumpSum_Text\"\r\n            [basePlanText]=\"Spa_Site_HIP_BasePlanOption_Text\"\r\n            [daysAmount]=\"numberOfDaysHIPAnswer\"\r\n            [benefitAmount]=\"benefitAmountHIPAnswer\"\r\n          ></vnext-hip-details-banner>\r\n        </ng-container>\r\n      </ng-template>\r\n    </div>\r\n    <div class=\"col-12 mt-4 mb-5\">\r\n      <div\r\n        *liveEditProp=\"'Spa_Site_PageSubHeader_Text'\"\r\n        [innerHtml]=\"Spa_Site_PageSubHeader_Text ? (Spa_Site_PageSubHeader_Text | safe : 'html') : ''\"\r\n        navigationAdapter\r\n      ></div>\r\n    </div>\r\n    <ng-container *ngIf=\"plans\">\r\n      <div class=\"w-100\">\r\n        <ng-container\r\n          vnextGoogleTagManager\r\n          [tagsToUpdate]=\"tagsToUpdate\"\r\n          [saveDefaultValues]=\"analyticsService.isDefaultTagToUpdate\"\r\n          *ngIf=\"tagsToUpdate\"\r\n        >\r\n        </ng-container>\r\n        <div\r\n          role=\"table\"\r\n          aria-labelledby=\"plan-compare-page-heading\"\r\n          class=\"col-12 pb-0 px-0 mb-2\"\r\n          *ngIf=\"plans.length > 0\"\r\n          [ngClass]=\"{\r\n            'sticky': Spa_PlanCompare_StickyMiniCart_Enabled && !isMobile,\r\n            'sticky-top-hip': Spa_PlanCompare_StickyMiniCart_Enabled && isQuoteSummaryMode && !isMobile,\r\n            'sticky-top-hip-medicare':\r\n              Spa_PlanCompare_StickyMiniCart_Enabled && isQuoteSummaryMode && areAnyPlansMAPD && plans.length === 3 && !isMobile\r\n          }\"\r\n        >\r\n          <div role=\"rowgroup\" class=\"sr-only\">\r\n            <div role=\"row\">\r\n              <span *liveEditProp=\"'Spa_PlanCompare_Header'\" role=\"columnheader\">{{ Spa_PlanCompare_Header }} actions</span>\r\n              <span role=\"columnheader\" [attr.aria-colspan]=\"plans.length\">Plan descriptions</span>\r\n            </div>\r\n          </div>\r\n          <div class=\"container mb-1 mb-md-1\" role=\"rowgroup\">\r\n            <div class=\"row d-none d-lg-flex\" role=\"row\">\r\n              <vnext-widget-plan-compare-card-label\r\n                class=\"col-12\"\r\n                [plans]=\"plans\"\r\n                [isMobile]=\"isMobile\"\r\n                [isMedium]=\"isMedium\"\r\n                [currentPlanText]=\"Spa_Site_Current_Plan_Text\"\r\n                [nextYearPlanText]=\"Spa_Site_Next_Year_Plan_Text\"\r\n                [optionOneText]=\"Spa_Site_Plan_Option_One_Text\"\r\n                [optionTwoText]=\"Spa_Site_Plan_Option_Two_Text\"\r\n                [displayOptionLabels]=\"Spa_Retention_ClientDefinedPlanOptions_Enabled\"\r\n                [disableNextYearDisplay]=\"memberHasOptionsDefined && Spa_Retention_ClientDefinedPlanOptions_Enabled\"\r\n                [nonCommissionableText]=\"Spa_PlanDetails_NonCommissionable_Text\"\r\n                [isNonCommissionableFlagCheckEnabled]=\"Spa_PlanDetails_NonCommissionable_FlagCheck_Enabled\"\r\n                [customClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length, true)\"\r\n              >\r\n              </vnext-widget-plan-compare-card-label>\r\n            </div>\r\n            <div class=\"row plan-compare-section\" [ngClass]=\"{ 'gray1-static': isQuoteSummaryMode && !isMedium && !isMobile }\" role=\"row\">\r\n              <div\r\n                *ngIf=\"!isQuoteSummaryMode\"\r\n                class=\"plan-compare-checkbox-section gray1-static\"\r\n                [ngClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length, true)\"\r\n                role=\"rowheader\"\r\n              >\r\n                <vnext-checkbox-group\r\n                  [items]=\"[showDifferencesCheckBoxItem]\"\r\n                  [customStyles]=\"getPlanDifferenceStyles(isMobile, isMedium)\"\r\n                  (change)=\"onPlanDifferenceSelected()\"\r\n                  [enablePrimaryColor]=\"true\"\r\n                  [customClass]=\"'Spa_Style_Bold_Weight Spa_Style_Primary_Color'\"\r\n                >\r\n                </vnext-checkbox-group>\r\n                <!-- TODO: Figure out what to do with this send to quote button if all/some plans are PUF-->\r\n                <!-- Until that story is written, the button will show up even for PUF plans-->\r\n                <button\r\n                  class=\"btn Spa_Style_SecondaryButton btn-block mt-2\"\r\n                  *ngIf=\"!disableSendQuote(plans) && isAddToQuoteAvailable(plans)\"\r\n                  (click)=\"planCompareFacade.openSendQuoteModal()\"\r\n                  (keyup.enter)=\"planCompareFacade.openSendQuoteModal()\"\r\n                >\r\n                  {{ Spa_Site_SendQuote_Button_Text }}\r\n                </button>\r\n                <vnext-pharmacy-selector\r\n                  *ngIf=\"planCompareFacade.showPharmacySelectorToggle() && selectedPharmacy\"\r\n                  [preferencesBannerEnabled]=\"Spa_PreferenceBanner_Enabled\"\r\n                  [pharmacySelectorTextKey]=\"'Spa_Site_CostBasedOn_Text'\"\r\n                  [pharmacySelectorText]=\"Spa_Site_CostBasedOn_Text\"\r\n                  [pharmacies]=\"selectedPharmacies\"\r\n                  [selectedPharmacy]=\"selectedPharmacy\"\r\n                  [preferredInNetworkText]=\"Spa_Site_Preferred_In_Network_Text\"\r\n                  [standardInNetworkText]=\"Spa_Site_Standard_In_Network_Text\"\r\n                  [outOfNetworkText]=\"Spa_Site_Out_Of_Network_Text\"\r\n                  [mailOrderText]=\"Spa_PlanList_MailOrder_Text\"\r\n                  [isMailOrderSelected]=\"mailOrder\"\r\n                  [showMailOrderOption]=\"planCompareFacade.isMailOrderPharmacyAvailable(plans)\"\r\n                  (selectMailOrder)=\"planCompareFacade.switchMailOrder(true)\"\r\n                  (selectPharmacy)=\"planCompareFacade.updateSelectedPharamcyAndFetchPlanDetails($event)\"\r\n                >\r\n                </vnext-pharmacy-selector>\r\n                <vnext-effective-date-display [activePlanType]=\"activeTabType\"></vnext-effective-date-display>\r\n              </div>\r\n              <vnext-widget-plan-compare-pagination\r\n                *ngIf=\"isMobile && allMobilePlans?.length === 3\"\r\n                class=\"col-12\"\r\n                [planCount]=\"allMobilePlans?.length\"\r\n                (pageChanged)=\"onMobileComparePageChanged($event)\"\r\n              ></vnext-widget-plan-compare-pagination>\r\n              <vnext-widget-plan-compare-card-label\r\n                class=\"d-print-none d-lg-none\"\r\n                [ngClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length, true)\"\r\n                [plans]=\"plans\"\r\n                [isMobile]=\"isMobile\"\r\n                [isMedium]=\"isMedium\"\r\n                [currentPlanText]=\"Spa_Site_Current_Plan_Text\"\r\n                [nextYearPlanText]=\"Spa_Site_Next_Year_Plan_Text\"\r\n                [optionOneText]=\"Spa_Site_Plan_Option_One_Text\"\r\n                [optionTwoText]=\"Spa_Site_Plan_Option_Two_Text\"\r\n                [displayOptionLabels]=\"Spa_Retention_ClientDefinedPlanOptions_Enabled\"\r\n                [nonCommissionableText]=\"Spa_PlanDetails_NonCommissionable_Text\"\r\n                [isNonCommissionableFlagCheckEnabled]=\"Spa_PlanDetails_NonCommissionable_FlagCheck_Enabled\"\r\n                [disableNextYearDisplay]=\"memberHasOptionsDefined && Spa_Retention_ClientDefinedPlanOptions_Enabled\"\r\n                [customClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length)\"\r\n              >\r\n              </vnext-widget-plan-compare-card-label>\r\n              <div\r\n                [ngClass]=\"{\r\n                  'col-12': isMobile || isMedium,\r\n                  'col-8': plans.length === 2 && !isMobile && !isMedium,\r\n                  'col-9': plans.length === 3 && !isMobile && !isMedium,\r\n                  'offset-md-4': plans.length === 2 && isQuoteSummaryMode,\r\n                  'offset-md-3': plans.length === 3 && isQuoteSummaryMode,\r\n                  'ml-0': plans.length === 2 && isQuoteSummaryMode && isMedium,\r\n                  'plan-compare-card-quote-summary': isQuoteSummaryMode\r\n                }\"\r\n              >\r\n                <vnext-widget-plan-compare-card\r\n                  [plans]=\"plans\"\r\n                  [planRidersMap]=\"planRidersMap\"\r\n                  [showLogo]=\"Spa_Site_Show_PlanLogo\"\r\n                  [planTypes]=\"Spa_PlanDetails_HIP_Call_Out_Available_Plan_Types\"\r\n                  [medicareTypes]=\"Spa_PlanDetails_HIP_Call_Out_Available_Plan_Types\"\r\n                  [activeTabType]=\"activeTabType\"\r\n                  [planDetailsButton]=\"Spa_PlanCard_PlanDetails_ButtonText\"\r\n                  (viewPlanDetailsPage)=\"viewPlanDetailsPage($event)\"\r\n                  (removePlanFromCompare)=\"removePlanFromCompare($event)\"\r\n                  [isRetentionView]=\"isRetentionView\"\r\n                  [isMobile]=\"isMobile\"\r\n                  [isMedium]=\"isMedium\"\r\n                  [locale]=\"locale\"\r\n                  [currentPlanText]=\"Spa_Site_Current_Plan_Text\"\r\n                  [nextYearPlanText]=\"Spa_Site_Next_Year_Plan_Text\"\r\n                  [isCurrentYearPlanExist]=\"currentYearPlanExists(plans)\"\r\n                  [planCardQuoteLinkText]=\"Spa_PlanCard_QuoteLinkName_Text\"\r\n                  [showPlanViewDetails]=\"Spa_Site_PlanViewDetails_Enabled\"\r\n                  [removePlanText]=\"Spa_Remove_Plan_Text\"\r\n                  [hospitalIndemnityBadgeText]=\"Spa_Site_HIP_Description\"\r\n                  [monthlyPremiumText]=\"Spa_Site_HIP_MonthlyPremium_Text\"\r\n                  [planLogoSize]=\"Spa_Site_PlanLogo_Size\"\r\n                  [isAncillaryAddToCartEnabled]=\"Spa_PlanCard_AncillaryAddtoCart_Enabled\"\r\n                  [stickyMiniCartEnabled]=\"Spa_PlanCompare_StickyMiniCart_Enabled\"\r\n                  [planFeesEnabled]=\"Spa_Site_PlanFees_Enabled\"\r\n                  [planFeesTooltipText]=\"Spa_PlanFees_Tooltip_Text\"\r\n                  [planFeesIncludedInPremiumTooltipText]=\"Spa_PlanFees_IncludedInPremium_Tooltip_Text\"\r\n                  [planFeesNotIncludedInPremiumTooltipText]=\"Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text\"\r\n                  [snpPremiumRangeEnabled]=\"Spa_Display_SNP_PremiumRange_Enabled\"\r\n                  [showRemovePlanButtonForMobile]=\"isMobile && Spa_PlanCompare_Remove_Mobile_Enabled && allMobilePlans?.length === 3\"\r\n                  [removeModalHeaderText]=\"Spa_PlanCard_Compare_Remove_Modal_Header_Text\"\r\n                  [removeModalIntroText]=\"Spa_PlanCard_Compare_Remove_Modal_Intro_Text\"\r\n                  [removeModalCancelText]=\"Spa_Site_Cancel\"\r\n                  [removeModalButtonText]=\"Spa_PlanCard_Compare_Remove_Modal_Button_Text\"\r\n                >\r\n                </vnext-widget-plan-compare-card>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"plan-compare-main-section col-12 p-0\" *ngIf=\"plans.length > 0\">\r\n          <ng-container *ngIf=\"Spa_Show_Plan_Level_Content && planCompareFacade.isPlanLevelContentExist(plans) && !isQuoteSummaryMode\">\r\n            <vnext-widget-plan-compare-panel\r\n              [isSubSectionHeaderExist]=\"false\"\r\n              [isPanelContentExist]=\"true\"\r\n              [customClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length, true, true)\"\r\n              [isPanelLeftSectionLiveEditable]=\"true\"\r\n              [panelLeftSectionLiveEditTag]=\"planCompareFacade.getPlanLevelContentResourceTag()\"\r\n              [panelLeftSectionContent]=\"planLevelContentLabel[(planCompareFacade.getSelectedCompareGroup()?.groupKey.values)[0]]\"\r\n              [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n            >\r\n              <div\r\n                nonCostSection\r\n                class=\"plan-compare-list-section\"\r\n                [ngClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length)\"\r\n                *ngFor=\"let plan of plans; index as i\"\r\n              >\r\n                <vnext-plan-level-content\r\n                  [plan]=\"plan\"\r\n                  [isComparePage]=\"true\"\r\n                  [notApplicableText]=\"Spa_Site_NotApplicable_Text\"\r\n                  [planLevelContentLabel]=\"planLevelContentLabel[plan.planTypeAbbreviation]\"\r\n                  [colIndex]=\"i + 1\"\r\n                ></vnext-plan-level-content>\r\n              </div>\r\n            </vnext-widget-plan-compare-panel>\r\n          </ng-container>\r\n          <vnext-widget-plan-compare-accordion\r\n            [accordionId]=\"'plan-cost-container'\"\r\n            [accordionSectionHeader]=\"Spa_PlanDetails_Costs_Header\"\r\n            [isLiveEditable]=\"true\"\r\n            [headerPropertyName]=\"'Spa_PlanDetails_Costs_Header'\"\r\n            [accordionIsOpen]=\"true\"\r\n            [plansLength]=\"plans.length\"\r\n            *ngIf=\"(!isQuoteSummaryMode || Spa_Site_PlanFees_Enabled) && (showCostsSection$ | async)\"\r\n          >\r\n            <ng-container *ngFor=\"let cost of getCostBasedOnPlanType(plans)\">\r\n              <div class=\"plan-compare-benefit-section\" *ngIf=\"showCost(cost.title)\" role=\"row\">\r\n                <vnext-widget-plan-compare-panel\r\n                  [isSubSectionHeaderExist]=\"false\"\r\n                  [isPanelContentExist]=\"true\"\r\n                  [customClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length, true, true, cost.title)\"\r\n                  [panelLeftSectionContent]=\"isTotalEstimatedCostAnnually ? cost.label : cost.label2\"\r\n                  [panelLeftCostDetails]=\"cost\"\r\n                  [healthEnabled]=\"Spa_Site_Health_Enabled && !isQuoteSummaryMode\"\r\n                  [costAddEditLinkText]=\"Spa_Plandetails_Costs_Add_Edit_Link_Text\"\r\n                  [plans]=\"plans\"\r\n                  [isSubTextExist]=\"true\"\r\n                  [healthCostText]=\"isTotalEstimatedCostAnnually ? cost.label : cost.label2\"\r\n                  [isHighLighted]=\"getPlanCompareStyles(plans, { costTitle: cost.title, isMailOrder: mailOrder })\"\r\n                  [offScreenHighLightLabelText]=\"Spa_Plan_Compare_HighLight_OffScreenText\"\r\n                  [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                  [showEffectiveDateText]=\"showEffectiveDateText\"\r\n                  [effectiveDateText]=\"effectiveDateText\"\r\n                >\r\n                  <div\r\n                    costSection\r\n                    [ngStyle]=\"getPlanCompareStyles(plans, { costTitle: cost.title, isMailOrder: mailOrder })\"\r\n                    class=\"plan-compare-list-section text-center text-lg-left\"\r\n                    [ngClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length, false, false, cost.title)\"\r\n                    *ngFor=\"let plan of plans; index as i\"\r\n                  >\r\n                    <div role=\"cell\" [attr.aria-colindex]=\"i + 1\" [ngSwitch]=\"plan.planType\">\r\n                      <div *ngSwitchCase=\"planType.MEDIGAP\">\r\n                        <vnext-plan-cost-section\r\n                          [preferencesBannerEnabled]=\"Spa_PreferenceBanner_Enabled\"\r\n                          [healthEnabled]=\"Spa_Site_Health_Enabled\"\r\n                          [isComparePage]=\"true\"\r\n                          [costDetails]=\"getCostDetails(cost)\"\r\n                          [plan]=\"plan\"\r\n                          [costAddEditLinkText]=\"Spa_Plandetails_Costs_Add_Edit_Link_Text\"\r\n                          [noCostAvailableText]=\"Spa_Site_NotApplicable_Text\"\r\n                          [selectedPharmacy]=\"selectedPharmacy\"\r\n                          [annualCost]=\"planDetailsFacade.getAnnualCost$(plan) | async\"\r\n                          [addHealthCostText]=\"Spa_HealthCostsTab_AddAgeHealth_Text\"\r\n                          [planFeesEnabled]=\"Spa_Site_PlanFees_Enabled\"\r\n                          [planFeesIncludedInPremiumTooltipText]=\"Spa_PlanFees_IncludedInPremium_Tooltip_Text\"\r\n                          [planFeesNotIncludedInPremiumTooltipText]=\"Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text\"\r\n                        >\r\n                        </vnext-plan-cost-section>\r\n                      </div>\r\n                      <div *ngSwitchCase=\"planType.MAPD\">\r\n                        <vnext-plan-cost-section\r\n                          [preferencesBannerEnabled]=\"Spa_PreferenceBanner_Enabled\"\r\n                          [healthEnabled]=\"Spa_Site_Health_Enabled\"\r\n                          [isComparePage]=\"true\"\r\n                          [costDetails]=\"getCostDetails(cost)\"\r\n                          [plan]=\"plan\"\r\n                          [costAddEditLinkText]=\"Spa_Plandetails_Costs_Add_Edit_Link_Text\"\r\n                          [noCostAvailableText]=\"Spa_Site_NotApplicable_Text\"\r\n                          [selectedPharmacy]=\"selectedPharmacy\"\r\n                          [annualCost]=\"planDetailsFacade.getAnnualCost$(plan, mailOrder) | async\"\r\n                          [isMailOrderSelected]=\"mailOrder\"\r\n                          [addHealthCostText]=\"Spa_HealthCostsTab_AddAgeHealth_Text\"\r\n                        >\r\n                        </vnext-plan-cost-section>\r\n                      </div>\r\n                      <div *ngSwitchCase=\"planType.MA\">\r\n                        <vnext-plan-cost-section\r\n                          [preferencesBannerEnabled]=\"Spa_PreferenceBanner_Enabled\"\r\n                          [healthEnabled]=\"Spa_Site_Health_Enabled\"\r\n                          [isComparePage]=\"true\"\r\n                          [costDetails]=\"getCostDetails(cost)\"\r\n                          [plan]=\"plan\"\r\n                          [costAddEditLinkText]=\"Spa_Plandetails_Costs_Add_Edit_Link_Text\"\r\n                          [noCostAvailableText]=\"Spa_Site_NotApplicable_Text\"\r\n                          [selectedPharmacy]=\"selectedPharmacy\"\r\n                          [annualCost]=\"planDetailsFacade.getAnnualCost$(plan, false) | async\"\r\n                          [addHealthCostText]=\"Spa_HealthCostsTab_AddAgeHealth_Text\"\r\n                        >\r\n                        </vnext-plan-cost-section>\r\n                      </div>\r\n                      <div *ngSwitchCase=\"planType.PDP\">\r\n                        <vnext-plan-cost-section\r\n                          [preferencesBannerEnabled]=\"Spa_PreferenceBanner_Enabled\"\r\n                          [healthEnabled]=\"Spa_Site_Health_Enabled\"\r\n                          [isComparePage]=\"true\"\r\n                          [costDetails]=\"getCostDetails(cost)\"\r\n                          [plan]=\"plan\"\r\n                          [costAddEditLinkText]=\"Spa_Plandetails_Costs_Add_Edit_Link_Text\"\r\n                          [noCostAvailableText]=\"Spa_Site_NotApplicable_Text\"\r\n                          [selectedPharmacy]=\"selectedPharmacy\"\r\n                          [isMailOrderSelected]=\"mailOrder\"\r\n                          [annualCost]=\"planDetailsFacade.getAnnualCost$(plan, mailOrder) | async\"\r\n                          [addHealthCostText]=\"Spa_HealthCostsTab_AddAgeHealth_Text\"\r\n                        >\r\n                        </vnext-plan-cost-section>\r\n                      </div>\r\n                      <div *ngSwitchCase=\"planType.DENTAL\">\r\n                        <vnext-plan-cost-section\r\n                          [preferencesBannerEnabled]=\"Spa_PreferenceBanner_Enabled\"\r\n                          [isComparePage]=\"true\"\r\n                          [costDetails]=\"[cost]\"\r\n                          [plan]=\"plan\"\r\n                          [planFeesEnabled]=\"Spa_Site_PlanFees_Enabled\"\r\n                          [noCostAvailableText]=\"Spa_Site_NotApplicable_Text\"\r\n                          [planFeesIncludedInPremiumTooltipText]=\"Spa_PlanFees_IncludedInPremium_Tooltip_Text\"\r\n                          [planFeesNotIncludedInPremiumTooltipText]=\"Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text\"\r\n                        >\r\n                        </vnext-plan-cost-section>\r\n                      </div>\r\n                      <div *ngSwitchCase=\"planType.VISION\">\r\n                        <vnext-plan-cost-section\r\n                          [preferencesBannerEnabled]=\"Spa_PreferenceBanner_Enabled\"\r\n                          [isComparePage]=\"true\"\r\n                          [costDetails]=\"[cost]\"\r\n                          [plan]=\"plan\"\r\n                          [planFeesEnabled]=\"Spa_Site_PlanFees_Enabled\"\r\n                          [noCostAvailableText]=\"Spa_Site_NotApplicable_Text\"\r\n                          [planFeesIncludedInPremiumTooltipText]=\"Spa_PlanFees_IncludedInPremium_Tooltip_Text\"\r\n                          [planFeesNotIncludedInPremiumTooltipText]=\"Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text\"\r\n                        >\r\n                        </vnext-plan-cost-section>\r\n                      </div>\r\n                      <div *ngSwitchCase=\"planType.HC\">\r\n                        <vnext-plan-cost-section\r\n                          [preferencesBannerEnabled]=\"Spa_PreferenceBanner_Enabled\"\r\n                          [isComparePage]=\"true\"\r\n                          [costDetails]=\"[cost]\"\r\n                          [plan]=\"plan\"\r\n                          [planFeesEnabled]=\"Spa_Site_PlanFees_Enabled\"\r\n                          [noCostAvailableText]=\"Spa_Site_NotApplicable_Text\"\r\n                          [planFeesIncludedInPremiumTooltipText]=\"Spa_PlanFees_IncludedInPremium_Tooltip_Text\"\r\n                          [planFeesNotIncludedInPremiumTooltipText]=\"Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text\"\r\n                        >\r\n                        </vnext-plan-cost-section>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </vnext-widget-plan-compare-panel>\r\n              </div>\r\n            </ng-container>\r\n          </vnext-widget-plan-compare-accordion>\r\n          <div class=\"container-fluid\" *ngIf=\"!isQuoteSummaryMode\">\r\n            <div class=\"row\">\r\n              <div\r\n                class=\"col-12 p-0\"\r\n                [ngClass]=\"{\r\n                  'order-2': !Spa_Plan_Details_Preferences_Position_Last,\r\n                  'order-1': Spa_Plan_Details_Preferences_Position_Last\r\n                }\"\r\n              >\r\n                <vnext-widget-plan-compare-accordion\r\n                  [accordionId]=\"'plan-benefits-container'\"\r\n                  [accordionSectionHeader]=\"Spa_Plan_Benefits_Section_Name\"\r\n                  [isLiveEditable]=\"true\"\r\n                  [headerPropertyName]=\"'Spa_Plan_Benefits_Section_Name'\"\r\n                  [accordionIsOpen]=\"true\"\r\n                >\r\n                  <vnext-widget-plan-compare-panel\r\n                    *ngIf=\"plans[0].planType === planType.MA || plans[0].planType === planType.MAPD\"\r\n                    [subSectionHeader]=\"Spa_PlanCompare_MedicalCoverage_Text\"\r\n                    [tooltipContent]=\"Spa_PlanCompare_MedicalCoverage_Tooltip\"\r\n                    [isTooltipExist]=\"Spa_PlanCompare_Show_MedicalCoverage_Tooltip\"\r\n                    [isSubSectionHeaderExist]=\"true\"\r\n                    [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                    [plans]=\"plans\"\r\n                  ></vnext-widget-plan-compare-panel>\r\n                  <div>\r\n                    <vnext-widget-plan-compare-medical-benefits\r\n                      [medicalDeductibleToolTipContent]=\"Spa_PlanCompare_Benefit_MedicalDeductible_Tooltip\"\r\n                      [medicalDeductibleIsTooltipExist]=\"Spa_PlanCompare_Benefit_Show_MedicalDeductible_Tooltip\"\r\n                      [medicalDeductibleIsSubSectionHeaderExist]=\"false\"\r\n                      [medicalDeductibleIsContentExist]=\"true\"\r\n                      [medicalDeductibleLeftSectionContent]=\"Spa_PlanCard_Benefit_MedicalDeductible_Text\"\r\n                      [customClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length, true, true)\"\r\n                      [plans]=\"plans\"\r\n                      [customClassBenefitValue]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length)\"\r\n                      [notAvailableText]=\"Spa_Site_NotApplicable_Text\"\r\n                      [medicalDeductibleTitle]=\"Spa_PlanCard_Benefit_MedicalDeductible_Title\"\r\n                      [medicalMaxOutOfPocketToolTipContent]=\"Spa_PlanCompare_Benefit_MedicalMaxOutOfPocket_Tooltip\"\r\n                      [medicalMaxOutOfPocketIsTooltipExist]=\"Spa_PlanCompare_Benefit_Show_MedicalMaxOutOfPocket_Tooltip\"\r\n                      [medicalMaxOutOfPocketIsSubSectionHeaderExist]=\"false\"\r\n                      [medicalMaxOutOfPocketIsContentExist]=\"true\"\r\n                      [medicalMaxOutOfPocketLeftSectionContent]=\"Spa_PlanCompare_Benefit_MedicalMaxOutOfPocket_Text\"\r\n                      [medicalMaxOutOfPocketTitle]=\"Spa_PlanCompare_Benefit_MedicalMaxOutOfPocket_Title\"\r\n                      [planCompareBenefitValuesMAPD]=\"Spa_PlanCompare_Benefit_values_MAPD\"\r\n                      [planCompareBenefitValuesMA]=\"Spa_PlanCompare_Benefit_values_MA\"\r\n                      [planCompareBenefitValuesMEDIGAP]=\"Spa_PlanCompare_Benefit_values_MEDIGAP\"\r\n                      [siteShowDifferencesChecked]=\"showDifferences\"\r\n                      [planComparePlanDifferencesColor]=\"Spa_PlanCompare_Plan_Differences_Color\"\r\n                      [planComparePlanDifferencesBorder]=\"Spa_PlanCompare_Plan_Differences_Border\"\r\n                      [planCompareHighLightOffScreenText]=\"Spa_Plan_Compare_HighLight_OffScreenText\"\r\n                      [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                      [medicalCoverageAriaLabel]=\"medicalCoverageAriaLabel\"\r\n                    >\r\n                    </vnext-widget-plan-compare-medical-benefits>\r\n                  </div>\r\n                  <vnext-widget-plan-compare-panel\r\n                    *ngIf=\"plans[0].planType === planType.PDP || plans[0].planType === planType.MAPD\"\r\n                    [subSectionHeader]=\"Spa_PlanCompare_PrescriptionDrugCoverage_Text\"\r\n                    [tooltipContent]=\"Spa_PlanCompare_PrescriptionDrugCoverage_Tooltip\"\r\n                    [isTooltipExist]=\"Spa_PlanCompare_Show_PrescriptionDrugCoverage_Tooltip\"\r\n                    [isSubSectionHeaderExist]=\"true\"\r\n                    [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                    [plans]=\"plans\"\r\n                  ></vnext-widget-plan-compare-panel>\r\n                  <vnext-widget-plan-compare-prescription-coverage\r\n                    *ngIf=\"plans[0].planType === planType.PDP || (plans[0].planType === planType.MAPD && !isQuoteSummaryMode)\"\r\n                    [plans]=\"plans\"\r\n                    [prescriptionLeftSectionCustomClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length, true, true)\"\r\n                    [prescriptionRightSectionCustomStyles]=\"highlightStyles\"\r\n                    [showHighlightPlanDifferences]=\"showDifferences\"\r\n                    [prescriptionRightSectionCustomClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length)\"\r\n                    [prescriptionDeductibleText]=\"Spa_Plan_Compare_PrescriptionDeductible_Text\"\r\n                    [prescriptionDeductibleTooltip]=\"Spa_Plan_Compare_PrescriptionDeductible_Tooltip\"\r\n                    [showPrescriptionDeductibleTooltip]=\"Spa_Plan_Compare_ShowPrescriptionDeductible_Tooltip\"\r\n                    [prescriptionInitialCoverageText]=\"Spa_Plan_Compare_PrescriptionInitialCoverageLimit_Text\"\r\n                    [prescriptionInitialCoverageTooltip]=\"Spa_Plan_Compare_PrescriptionInitialCoverageLimit_Tooltip\"\r\n                    [showPrescriptionInitialCoverageTooltip]=\"Spa_Plan_Compare_ShowPrescriptionInitialCoverageLimit_Tooltip\"\r\n                    [prescriptionDrugsText]=\"Spa_Plan_Compare_PrescriptionDrugs_Text\"\r\n                    [prescriptionDrugsTooltip]=\"Spa_Plan_Compare_PrescriptionDrugs_Tooltip\"\r\n                    [showPrescriptionDrugsTooltip]=\"Spa_Plan_Compare_ShowPrescriptionDrugs_Tooltip\"\r\n                    [prescriptionDrugsNotApplicableText]=\"Spa_Site_NotApplicable_Text\"\r\n                    [planCompareHighLightOffScreenText]=\"Spa_Plan_Compare_HighLight_OffScreenText\"\r\n                    [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                    [showInitialCoverageLimit]=\"Spa_PlanCompare_Benefit_Show_InitialCoverageLimit\"\r\n                  >\r\n                  </vnext-widget-plan-compare-prescription-coverage>\r\n                </vnext-widget-plan-compare-accordion>\r\n              </div>\r\n              <!--Preferences section-->\r\n              <div\r\n                class=\"col-12 p-0\"\r\n                [ngClass]=\"{\r\n                  'order-2': Spa_Plan_Details_Preferences_Position_Last,\r\n                  'order-1': !Spa_Plan_Details_Preferences_Position_Last\r\n                }\"\r\n              >\r\n                <vnext-widget-plan-compare-accordion\r\n                  *ngIf=\"\r\n                    Spa_Plan_Details_Show_Preferences &&\r\n                    Spa_GuidedHelp_Enabled &&\r\n                    plans[0].planType !== planType.MEDIGAP &&\r\n                    (showProviderSection || showPrescriptionSection || showPharmacySection || showOtherPreferencesSection) &&\r\n                    !isQuoteSummaryMode\r\n                  \"\r\n                  [accordionId]=\"'plan-preferences-container'\"\r\n                  [accordionSectionHeader]=\"Spa_Plan_Details_Preferences_Text\"\r\n                  [isLiveEditable]=\"true\"\r\n                  [headerPropertyName]=\"'Spa_Plan_Details_Preferences_Text'\"\r\n                  [accordionIsOpen]=\"Spa_Plan_Details_Preferences_Expanded\"\r\n                >\r\n                  <!-- Providers panel -->\r\n                  <ng-container *ngIf=\"showProviderSection\">\r\n                    <vnext-widget-plan-compare-panel\r\n                      [isSubSectionHeaderExist]=\"true\"\r\n                      [isProvidersEnabled]=\"Spa_Site_Providers_Enabled\"\r\n                      [customClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length, true, true)\"\r\n                      [headerPropertyName]=\"'Spa_Plan_Details_Preferences_Provider_Text'\"\r\n                      [subSectionHeader]=\"Spa_Plan_Details_Preferences_Provider_Text\"\r\n                      [iconClass]=\"'fas fa-user-md icon Spa_Style_ProvidersIcon'\"\r\n                      [isPreferencesSection]=\"true\"\r\n                      [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                      [linkPropertyName]=\"'Spa_Providers_Add_Edit_Link'\"\r\n                      [linkTitle]=\"Spa_Providers_Add_Edit_Link\"\r\n                      [tag]=\"pageTags.GUIDED_HELP_PROVIDER_SEARCH\"\r\n                      [plans]=\"plans\"\r\n                    >\r\n                    </vnext-widget-plan-compare-panel>\r\n                    <div role=\"row\" class=\"row mx-0 provider-directory\" *ngIf=\"hasProviderUrlForAllPlans(plans)\">\r\n                      <div\r\n                        *ngIf=\"planCompareFacade.getPreferencesHighlightStyles(plans, showDifferences, { isProvider: true })\"\r\n                        class=\"sr-only\"\r\n                      >\r\n                        {{ Spa_Plan_Compare_HighLight_OffScreenText }}\r\n                      </div>\r\n                      <span\r\n                        role=\"rowheader\"\r\n                        class=\"Spa_Style_H5 plan-compare-left-section m-0\"\r\n                        [ngClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length, true, true)\"\r\n                      >\r\n                        <span *liveEditProp=\"'Spa_Plan_Providers_Search_Provider_Text'\">{{ Spa_Plan_Providers_Search_Provider_Text }}</span>\r\n                      </span>\r\n                      <div\r\n                        class=\"plan-compare-right-section text-center text-lg-left\"\r\n                        [ngClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length)\"\r\n                        *ngFor=\"let plan of plans; index as i\"\r\n                      >\r\n                        <div role=\"cell\" [attr.aria-colindex]=\"i + 1\" [ngSwitch]=\"getProviderLinkType(plan)\">\r\n                          <ng-template [ngSwitchCase]=\"providersLinkType.INTERNAL\">\r\n                            <span class=\"Spa_Style_Link Spa_Style_Small_Font can-click\" (click)=\"onProviderClick(plan)\">\r\n                              {{ Spa_Plan_Providers_Directory_Link }}\r\n                            </span>\r\n                          </ng-template>\r\n                          <ng-template [ngSwitchCase]=\"providersLinkType.EXTERNAL\">\r\n                            <vnext-link\r\n                              [title]=\"Spa_Plan_Providers_Directory_Link\"\r\n                              [alwaysUnderlined]=\"true\"\r\n                              [href]=\"plan.providerURL\"\r\n                              [linkTarget]=\"'_blank'\"\r\n                            ></vnext-link>\r\n                          </ng-template>\r\n                          <ng-template [ngSwitchCase]=\"providersLinkType.INTERNAL_AND_EXTERNAL\">\r\n                            <div class=\"pb-4\">\r\n                              <vnext-link\r\n                                [title]=\"Spa_Plan_Providers_Carrier_Directory_Link_Text\"\r\n                                [alwaysUnderlined]=\"true\"\r\n                                [href]=\"plan.providerURL\"\r\n                                [linkTarget]=\"'_blank'\"\r\n                              ></vnext-link>\r\n                            </div>\r\n                            <span class=\"Spa_Style_Link Spa_Style_Small_Font can-click\" (click)=\"onProviderClick(plan)\">\r\n                              {{ Spa_Plan_Providers_Internal_Directory_Link_Text }}\r\n                            </span>\r\n                          </ng-template>\r\n                          <ng-template [ngSwitchDefault]>\r\n                            {{ Spa_Site_NotApplicable_Text }}\r\n                          </ng-template>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                    <div\r\n                      class=\"provider-section\"\r\n                      *ngFor=\"let provider of selectedProviderList; index as index; trackBy: trackByProvider\"\r\n                      [vnextHighlightDifferences]=\"'data-highlight-differences-provider-details'\"\r\n                      [showDifferences]=\"showDifferences\"\r\n                      [selectorsRowIndex]=\"index\"\r\n                      [trackChanges]=\"{ plans: plans, providerDetails: providerDetailResponse }\"\r\n                    >\r\n                      <div class=\"row mx-0\" role=\"row\">\r\n                        <div\r\n                          class=\"plan-compare-left-section {{ getPlanCompareCustomClass(isMobile, isMedium, plans.length, true, true) }}\"\r\n                        >\r\n                          <vnext-plan-provider-details\r\n                            [planId]=\"plans[0].id\"\r\n                            [provider]=\"provider\"\r\n                            [customClass]=\"'Spa_Style_H5 m-0'\"\r\n                            [isComparePage]=\"true\"\r\n                            [showProviderDetails]=\"true\"\r\n                            [providerInfoEnabled]=\"providerInfoEnabled\"\r\n                            [providerDetailResponse]=\"providerDetailResponse\"\r\n                            [selectedProviderDetails]=\"provider\"\r\n                            [pcpText]=\"Spa_Site_Pcp_Text\"\r\n                            [isMobile]=\"isMobile\"\r\n                            [isMedium]=\"isMedium\"\r\n                            [acceptingNewPatientsIcon]=\"Spa_Providers_AcceptingNewPatients_Icon\"\r\n                            [acceptingNewPatientsText]=\"Spa_Providers_AcceptingNewPatients_Text\"\r\n                            [languagesIcon]=\"Spa_Providers_Languages_Icon\"\r\n                            [providerLanguages]=\"languagesByPlanMap[plans[0].id]\"\r\n                            [providerMedicalGroups]=\"planProviderMedicalGroups?.[plans[0].id]?.providers\"\r\n                            [providersAcceptingNewPatients]=\"providersAcceptingNewPatientsByPlanMap[plans[0].id]\"\r\n                            [countryCode]=\"countryCode\"\r\n                            [isVbcAgreementEnabled]=\"Spa_Site_ValueBasedCare_Agreement_Enabled\"\r\n                            [vbcAgreementLabel]=\"Spa_Site_ValueBasedCare_Agreement_Label\"\r\n                            [vbcAgreementTooltip]=\"Spa_Site_ValueBasedCare_Agreement_Tooltip\"\r\n                            [isZelisIntegrationEnabled]=\"Spa_Site_ZelisIntegration_Enabled\"\r\n                          >\r\n                          </vnext-plan-provider-details>\r\n                        </div>\r\n\r\n                        <ng-container *ngFor=\"let plan of plans; index as i\">\r\n                          <div\r\n                            role=\"cell\"\r\n                            nonCostSection\r\n                            class=\"plan-compare-list-section {{ getPlanCompareCustomClass(isMobile, isMedium, plans.length) }}\"\r\n                            [attr.data-highlight-differences]=\"index\"\r\n                            [attr.aria-colindex]=\"i + 1\"\r\n                          >\r\n                            <vnext-plan-provider-details\r\n                              [planId]=\"plan.id\"\r\n                              [attr.data-highlight-differences-provider-details]=\"index\"\r\n                              [attr.data-highlight-ignore-text]=\"plan.planName\"\r\n                              [provider]=\"provider\"\r\n                              [isComparePage]=\"true\"\r\n                              [providerDetailResponse]=\"providerDetailResponse\"\r\n                              [selectedProviderDetails]=\"planFacade.getSelectedProviderDetails(plan.id, providerDetailResponse, provider)\"\r\n                              [inNetworkProviderText]=\"Spa_Provider_InNetwork_Text\"\r\n                              [outOfNetworkProviderText]=\"Spa_Provider_OutOfNetwork_Text\"\r\n                              [pcpText]=\"Spa_Site_Pcp_Text\"\r\n                              [noProviderDetailsText]=\"Spa_Providers_No_Data_Exist_Text\"\r\n                              [isMobile]=\"isMobile\"\r\n                              [showNetworkDetails]=\"true\"\r\n                              [noProviderNetworkAccessText]=\"Spa_Providers_NoProviderNetworkAccess_Text\"\r\n                              [noProviderDetailsText]=\"Spa_Providers_No_Data_Exist_Text\"\r\n                              [hasProviderDetails]=\"plan.showProviderSearch\"\r\n                              [canSellPlan]=\"planFacade.canSellPlan(plan)\"\r\n                              [viewAllText]=\"Spa_Site_ViewAll_Text\"\r\n                              [hideText]=\"Spa_Site_Hide_Text\"\r\n                              [providerInfoEnabled]=\"providerInfoEnabled\"\r\n                              [acceptingNewPatientsIcon]=\"Spa_Providers_AcceptingNewPatients_Icon\"\r\n                              [acceptingNewPatientsText]=\"Spa_Providers_AcceptingNewPatients_Text\"\r\n                              [providerLanguages]=\"languagesByPlanMap[plan.id]\"\r\n                              [providerMedicalGroups]=\"planProviderMedicalGroups?.[plan.id]?.providers\"\r\n                              [providersAcceptingNewPatients]=\"providersAcceptingNewPatientsByPlanMap[plan.id]\"\r\n                              [countryCode]=\"countryCode\"\r\n                              [isZelisIntegrationEnabled]=\"Spa_Site_ZelisIntegration_Enabled\"\r\n                            ></vnext-plan-provider-details></div\r\n                        ></ng-container>\r\n                      </div>\r\n                    </div>\r\n                  </ng-container>\r\n                  <!-- Prescriptions panel -->\r\n                  <ng-container *ngIf=\"showPrescriptionSection\">\r\n                    <vnext-widget-plan-compare-panel\r\n                      [isSubSectionHeaderExist]=\"true\"\r\n                      [customClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length, true, true)\"\r\n                      [headerPropertyName]=\"'Spa_Plan_Details_Preferences_Prescription_Text'\"\r\n                      [subSectionHeader]=\"Spa_Plan_Details_Preferences_Prescription_Text\"\r\n                      [linkPropertyName]=\"'Spa_Site_Pharmacy_AddEdit_Link'\"\r\n                      [iconClass]=\"'Spa_Style_PrescriptionsIcon'\"\r\n                      [linkTitle]=\"Spa_Prescription_Add_Edit_Link\"\r\n                      [tag]=\"pageTags.GUIDED_HELP_PRESCRIPTIONS\"\r\n                      [isPreferencesSection]=\"true\"\r\n                      [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                      [plans]=\"plans\"\r\n                    >\r\n                    </vnext-widget-plan-compare-panel>\r\n                    <vnext-widget-plan-compare-prescription\r\n                      [medicineCabinet]=\"planCompareFacade.getMedicineCabinet()\"\r\n                      [plans]=\"plans\"\r\n                      [showHighlightPlanDifferences]=\"showDifferences\"\r\n                      [coveredDrugsText]=\"Spa_PlanDetails_Covered_Text\"\r\n                      [nonCoveredDrugsText]=\"Spa_PlanDetails_Non_Covered_Text\"\r\n                      [isMobile]=\"isMobile\"\r\n                      [customLeftSectionClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length, true, true)\"\r\n                      [customRightSectionClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length)\"\r\n                      [prescriptionDirectoryLink]=\"Spa_PlanDetails_Preferences_PrescriptionDirectory_Link\"\r\n                      [searchPrescriptionsText]=\"Spa_PlanDetails_Preferences_SearchPrescriptions_Text\"\r\n                      [searchPrescriptionsKey]=\"'Spa_PlanDetails_Preferences_SearchPrescriptions_Text'\"\r\n                      [onPrescriptionClickAction]=\"onPrescriptionClick\"\r\n                      [showDrugAlternativesEnabled]=\"\r\n                        Spa_Site_ShowDrugAlternatives_Enabled && Spa_PlanCompare_ShowDrugAlternatives_Nudge_Enabled\r\n                      \"\r\n                      [showDrugAlternativesText]=\"Spa_Prescriptions_ShowDrugAlternatives_ViewAlternatives_Text\"\r\n                      [selectedPharmacy]=\"selectedPharmacy\"\r\n                      [isMailOrderSelected]=\"mailOrder\"\r\n                      (viewPossibleAlternativeDrugs)=\"onViewPossibleAlternativeDrugs($event.plan, $event.cabinet)\"\r\n                    >\r\n                    </vnext-widget-plan-compare-prescription>\r\n                  </ng-container>\r\n                  <!-- Pharmacy panel -->\r\n                  <ng-container *ngIf=\"showPharmacySection\">\r\n                    <vnext-widget-plan-compare-panel\r\n                      [isSubSectionHeaderExist]=\"true\"\r\n                      [customClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length, true, true)\"\r\n                      [headerPropertyName]=\"'Spa_Plan_Details_Preferences_Pharmacy_Text'\"\r\n                      [subSectionHeader]=\"Spa_Plan_Details_Preferences_Pharmacy_Text\"\r\n                      [linkPropertyName]=\"'Spa_Site_Pharmacy_AddEdit_Link'\"\r\n                      [iconClass]=\"'Spa_Style_PharmacyIcon'\"\r\n                      [linkTitle]=\"Spa_Site_Pharmacy_AddEdit_Link\"\r\n                      [tag]=\"pageTags.GUIDED_HELP_PHARMACY_SEARCH\"\r\n                      [isPreferencesSection]=\"true\"\r\n                      [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                      [plans]=\"plans\"\r\n                    >\r\n                    </vnext-widget-plan-compare-panel>\r\n                    <div class=\"row mx-0 pharmacy-directory\" role=\"row\">\r\n                      <span\r\n                        role=\"rowheader\"\r\n                        class=\"Spa_Style_H5 plan-compare-left-section m-0\"\r\n                        [ngClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length, true, true)\"\r\n                      >\r\n                        <span *liveEditProp=\"'Spa_PlanDetails_Preferences_SearchPharmacy_Text'\"\r\n                          >{{ Spa_PlanDetails_Preferences_SearchPharmacy_Text }}\r\n                        </span>\r\n                      </span>\r\n                      <div\r\n                        role=\"cell\"\r\n                        class=\"plan-compare-right-section text-center text-lg-left\"\r\n                        [ngClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length)\"\r\n                        *ngFor=\"let plan of plans; index as i\"\r\n                        [attr.aria-colindex]=\"i + 1\"\r\n                      >\r\n                        <div>\r\n                          <span class=\"sr-only no-translate-block\">{{ plan.planName }}</span>\r\n                          <h4 class=\"mb-0\">\r\n                            <span class=\"Spa_Style_Link Spa_Style_Small_Font can-click\" (click)=\"onPharmacyClick(plan)\">\r\n                              {{ Spa_PlanDetails_Preferences_PharmacyDirectory_Link.title }}\r\n                            </span>\r\n                          </h4>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                    <ng-container *ngIf=\"planCompareFacade.getSelectedPharmacy() && planPharmacyData?.length\">\r\n                      <div class=\"pharmacy-section\" *ngFor=\"let pharmacy of selectedPharmacies\">\r\n                        <div class=\"row mx-0\" role=\"row\">\r\n                          <div\r\n                            role=\"rowheader\"\r\n                            class=\"Spa_Style_H5 plan-compare-left-section m-0 {{\r\n                              getPlanCompareCustomClass(isMobile, isMedium, plans.length, true, true)\r\n                            }}\"\r\n                          >\r\n                            <span class=\"no-translate-block\">{{ pharmacy.name }}</span>\r\n                            <ng-container *ngIf=\"planCompareFacade.getPrimaryPharmacy$() | async as primaryPharmacy\">\r\n                              <span\r\n                                *ngIf=\"\r\n                                  primaryPharmacy &&\r\n                                  pharmacy.nabp === primaryPharmacy.nabp &&\r\n                                  planCompareFacade.showPharmacySelectorToggle()\r\n                                \"\r\n                                >({{ Spa_Site_PrimaryPharmacy_Indicator_Text }})</span\r\n                              >\r\n                            </ng-container>\r\n                          </div>\r\n                          <div\r\n                            role=\"cell\"\r\n                            nonCostSection\r\n                            class=\"plan-compare-list-section {{ getPlanCompareCustomClass(isMobile, isMedium, plans.length) }}\"\r\n                            [ngStyle]=\"planCompareFacade.getPreferencesHighlightStyles(plans, showDifferences, null, pharmacy)\"\r\n                            *ngFor=\"let plan of plans; index as i\"\r\n                            [attr.aria-colindex]=\"i + 1\"\r\n                          >\r\n                            <div>\r\n                              <span class=\"sr-only no-translate-block\">{{ plan.planName }}</span>\r\n                              <vnext-plan-pharmacy-details\r\n                                [isComparePage]=\"true\"\r\n                                [pharmacies]=\"\r\n                                  planCompareFacade.getDetailsOfSelectedPharmacy(getPharmacyInfoForPlan$(plan.id) | async, pharmacy)\r\n                                \"\r\n                                [planName]=\"plan.planName\"\r\n                                [inNetworkPreferredText]=\"Spa_Pharmacy_InNetwork_Preferred_Pricing_Text\"\r\n                                [inNetworkStandardText]=\"Spa_Pharmacy_InNetwork_Standard_Pricing_Text\"\r\n                                [outOfNetworkText]=\"Spa_Pharmacy_OutOfNetwork_Pricing_Text\"\r\n                                [nonCoveredText]=\"Spa_PlanDetails_Non_Covered_Text\"\r\n                                [showNotCovered]=\"planCompareFacade.isPlanPharmacyNotCovered(plan)\"\r\n                              >\r\n                              </vnext-plan-pharmacy-details>\r\n                            </div>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                      <div class=\"row mx-0\" role=\"row\" *ngIf=\"Spa_Site_Mail_Order_Pharmacy_Enabled\">\r\n                        <span\r\n                          role=\"rowheader\"\r\n                          class=\"Spa_Style_H5 plan-compare-left-section m-0 {{\r\n                            getPlanCompareCustomClass(isMobile, isMedium, plans.length, true, true)\r\n                          }}\"\r\n                        >\r\n                          {{ Spa_PlanList_MailOrder_Text }}\r\n                        </span>\r\n                        <div\r\n                          role=\"cell\"\r\n                          nonCostSection\r\n                          class=\"plan-compare-list-section {{ getPlanCompareCustomClass(isMobile, isMedium, plans.length) }}\"\r\n                          [ngStyle]=\"planCompareFacade.getPreferencesHighlightStyles(plans, showDifferences, { mailOrder: true })\"\r\n                          *ngFor=\"let plan of plans; index as i\"\r\n                          [attr.aria-colindex]=\"i + 1\"\r\n                        >\r\n                          <vnext-mail-order-pharmacy-details\r\n                            class=\"plan-details-section-min-height\"\r\n                            [isComparePage]=\"true\"\r\n                            [showMailOrderPharmacy]=\"Spa_Site_Mail_Order_Pharmacy_Enabled\"\r\n                            [coveredText]=\"Spa_PlanDetails_Covered_Text\"\r\n                            [notCoveredText]=\"Spa_PlanDetails_Non_Covered_Text\"\r\n                            [hasMailOrder]=\"plan.hasMailDrugBenefits && !planCompareFacade.isPlanPharmacyNotCovered(plan)\"\r\n                            [planName]=\"plan.planName\"\r\n                            [isMobile]=\"isMobile\"\r\n                          >\r\n                          </vnext-mail-order-pharmacy-details>\r\n                        </div>\r\n                      </div>\r\n                    </ng-container>\r\n                  </ng-container>\r\n                  <!-- Other preferecnes panel -->\r\n                  <ng-container *ngIf=\"showOtherPreferencesSection\">\r\n                    <vnext-widget-plan-compare-panel\r\n                      [isSubSectionHeaderExist]=\"true\"\r\n                      [customClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length, true, true)\"\r\n                      [headerPropertyName]=\"'Spa_Plan_Details_OtherPreferences_Text'\"\r\n                      [subSectionHeader]=\"Spa_Plan_Details_OtherPreferences_Text\"\r\n                      [linkPropertyName]=\"'Spa_Site_Preferences_AddEdit_Link'\"\r\n                      [iconClass]=\"'Spa_Style_OtherPreferencesIcon'\"\r\n                      [linkTitle]=\"Spa_Site_Preferences_AddEdit_Link\"\r\n                      [tag]=\"pageTags.GUIDED_HELP_OTHER_PREFERENCES\"\r\n                      [isPreferencesSection]=\"true\"\r\n                      [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                      [plans]=\"plans\"\r\n                    >\r\n                    </vnext-widget-plan-compare-panel>\r\n                    <vnext-plan-compare-preferences\r\n                      [plans]=\"plans\"\r\n                      [showHighlightPlanDifferences]=\"showDifferences\"\r\n                      [answeredPreferenceBenefits]=\"planCompareFacade.getPreferenceBenefits(plans)\"\r\n                      [coveredBenefitText]=\"Spa_Site_Yes\"\r\n                      [nonCoveredBenefitText]=\"Spa_Site_No\"\r\n                      [isMobile]=\"isMobile\"\r\n                      [customLeftSectionClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length, true, true)\"\r\n                      [customRightSectionClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length)\"\r\n                    >\r\n                    </vnext-plan-compare-preferences>\r\n                  </ng-container>\r\n                </vnext-widget-plan-compare-accordion>\r\n              </div>\r\n              <div\r\n                class=\"col-12 p-0 order-2\"\r\n                [ngClass]=\"{\r\n                  'order-2': Spa_Plan_Details_Preferences_Position_Last,\r\n                  'order-1': !Spa_Plan_Details_Preferences_Position_Last\r\n                }\"\r\n                *ngIf=\"riderCategories.length > 0 && !Spa_Site_ShowPremiumAsAnnual && Spa_ShoppingCart_Enabled && !isQuoteSummaryMode\"\r\n              >\r\n                <vnext-widget-plan-compare-accordion\r\n                  [accordionId]=\"'plan-benefits-container'\"\r\n                  [accordionSectionHeader]=\"Spa_Plan_Details_AddOnRiders_Header\"\r\n                  [isLiveEditable]=\"true\"\r\n                  [headerPropertyName]=\"'Spa_Plan_Details_AddOnRiders_Header'\"\r\n                  [accordionIsOpen]=\"true\"\r\n                  [accordionSubHeaderClass]=\"'Spa_Style_Paragraph_Light d-inline-block ml-sm-2 mb-0'\"\r\n                  [accordionSubHeader]=\"Spa_Plan_Details_AddOnRiders_SubHeader\"\r\n                >\r\n                  <vnext-widget-plan-compare-riders\r\n                    [plans]=\"plans\"\r\n                    [showHighlightPlanDifferences]=\"showDifferences\"\r\n                    [waiverStateRidersTooltips]=\"Spa_Plan_Details_WaiverStateRider_Tooltips\"\r\n                    [shoppingCartIncludedRiderText]=\"Spa_ShoppingCart_IncludedRider_Text\"\r\n                    [riderNotSupportedText]=\"Spa_Site_Rider_NotSupported_Text\"\r\n                    [notApplicableText]=\"Spa_Site_NotApplicable_Text\"\r\n                    [riderLeftSectionCustomClass]=\"\r\n                      getPlanCompareCustomClass(isMobile, isMedium, plans.length, true, true, '', 'Spa_Style_H5')\r\n                    \"\r\n                    [riderRightSectionCustomClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length)\"\r\n                    [showRiderDetailsText]=\"Spa_Plan_Details_ViewRiderDetails_Text\"\r\n                    [hideRiderDetailsText]=\"Spa_Plan_Details_HideRiderDetails_Text\"\r\n                    [showRiderDetails]=\"Spa_Site_RiderDetails_Show\"\r\n                    [planCompareHighLightOffScreenText]=\"Spa_Plan_Compare_HighLight_OffScreenText\"\r\n                    [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                  ></vnext-widget-plan-compare-riders>\r\n                </vnext-widget-plan-compare-accordion>\r\n              </div>\r\n\r\n              <div class=\"col-12 p-0 order-2\">\r\n                <vnext-widget-plan-compare-accordion\r\n                  [accordionId]=\"'plan-benefits-container'\"\r\n                  [accordionSectionHeader]=\"Spa_PlanCompare_PlanDocument_Text\"\r\n                  [isLiveEditable]=\"true\"\r\n                  [headerPropertyName]=\"'Spa_PlanCompare_PlanDocument_Text'\"\r\n                  [accordionIsOpen]=\"true\"\r\n                  [accordionSubHeaderClass]=\"'Spa_Style_Paragraph_Light d-inline-block ml-sm-2 mb-0'\"\r\n                >\r\n                  <div>\r\n                    <vnext-widget-plan-compare-panel\r\n                      [isSubSectionHeaderExist]=\"false\"\r\n                      [isPanelContentExist]=\"true\"\r\n                      [panelLeftSectionContent]=\"Spa_PlanCompare_PlanDocument_ViewMore_Text\"\r\n                      [customClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length, true, true)\"\r\n                      [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                      [plans]=\"plans\"\r\n                    >\r\n                      <div\r\n                        role=\"cell\"\r\n                        nonCostSection\r\n                        class=\"plan-compare-list-section plan-compare-document text-center text-lg-left\"\r\n                        [ngClass]=\"getPlanCompareCustomClass(isMobile, isMedium, plans.length)\"\r\n                        *ngFor=\"let plan of plans; index as i\"\r\n                        [attr.aria-colindex]=\"i + 1\"\r\n                      >\r\n                        <div>\r\n                          <span class=\"sr-only no-translate-block\">{{ plan.planName }}</span>\r\n                          <vnext-link\r\n                            [title]=\"Spa_Site_ViewDetails\"\r\n                            (click)=\"viewPlanDetailsPage(plan, false, true)\"\r\n                            (keyup.enter)=\"viewPlanDetailsPage(plan, false, true)\"\r\n                            [alwaysUnderlined]=\"true\"\r\n                            [isLinkButton]=\"true\"\r\n                            *ngIf=\"Spa_Site_PlanViewDetails_Enabled\"\r\n                          >\r\n                          </vnext-link>\r\n                        </div>\r\n                      </div>\r\n                    </vnext-widget-plan-compare-panel>\r\n                  </div>\r\n                </vnext-widget-plan-compare-accordion>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <!-- Only For HC/HIP plans -->\r\n          <div class=\"row ml-0 mr-0\" *ngIf=\"isQuoteSummaryMode\">\r\n            <div class=\"col-12 pl-0 pr-0\">\r\n              <vnext-widget-plan-quote-benefit-details\r\n                [plans]=\"plans\"\r\n                [locale]=\"locale\"\r\n                [sectionHeaderText]=\"Spa_Plan_Benefits_Section_Name\"\r\n                [basePlanOptionLabel]=\"Spa_Site_HIP_BasePlanOption_Text\"\r\n                [medicareTypes]=\"Spa_PlanDetails_HIP_Call_Out_Available_Plan_Types\"\r\n                [hospitalCareRiderBenefitDefaultDropdownText]=\"SPA_HIP_Rider_Benefit_Default_Dropdown_Text\"\r\n                [hospitalCareRiderBenefitText]=\"SPA_HIP_Rider_Benefit_Text\"\r\n                [notAvailableRiderBenefitText]=\"SPA_Site_NotAvailable_Rider_Benefit_Text\"\r\n                (selectedRiderBenefits)=\"onRiderBenefitDropdownSelection($event)\"\r\n              ></vnext-widget-plan-quote-benefit-details>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n", styles: [".plan-compare-section{box-shadow:0 2px 4px 1px var(--static-Spa_Style_Accent1);margin-bottom:4px;border-radius:6px}.plan-compare-left-section,.plan-compare-right-section{border-right:1px solid var(--static-Spa_Style_Accent1);padding:12px 14px 14px}.plan-compare-right-section:last-child{border-right-width:0px}.plan-compare-list-section{border-right:1px solid var(--static-Spa_Style_Accent1);padding:10px 6px 10px 14px}.plan-compare-list-section:last-child{border-right-width:0px}.plan-compare-checkbox-section{border-top-left-radius:6px;border-bottom-left-radius:6px;border:1px solid var(--static-Spa_Style_Accent1);border-right-width:0px}.gray1-static{background-color:var(--static-Spa_Style_Gray1)}.plan-compare-card-quote-summary{background-color:#fff}.plan-compare-benefit-section{border-bottom:1px solid var(--static-Spa_Style_Accent1)}.plan-compare-list-section.plan-compare-document{padding:24px 0 22px 18px}.plan-compare-list-section+.plan-compare-list-section{border-left-width:0!important}.current-plan-text,.next-year-plan-text{font-size:14px;font-family:montserrat_semibold;color:#fff;border-top-left-radius:5px;border-top-right-radius:5px;padding:3px 16px}.current-plan-card-border,.next-year-plan-card-border{border-width:2px;border-style:solid}.pharmacy-directory,.provider-directory,.provider-section,.pharmacy-section{border-bottom:1px solid var(--static-Spa_Style_Accent1)}.sticky{position:sticky;top:-15px;background-color:#fff;z-index:1}.sticky-top-hip{top:0;padding-top:10px}.sticky-top-hip-medicare{top:0;padding-top:29px}@media (max-width: 991.9px){.plan-compare-section{box-shadow:none;border-radius:0}.plan-compare-main-section{border-width:0px;border-bottom:1px solid var(--static-Spa_Style_Accent1)}.plan-compare-checkbox-section{border:0px}.plan-compare-card{border-width:0px}.plan-compare-card:last-child{border-radius:0}.plan-compare-list-section.plan-compare-document{padding:10px 14px}.plan-compare-left-section{border-right-width:0px;text-align:center}.plan-compare-right-section:last-child{border-left:1px solid var(--static-Spa_Style_Accent1)}}@media print{.container{min-width:initial!important}.plan-compare-section{border-radius:6px}.plan-compare-main-section,.plan-compare-checkbox-section{border:1px solid var(--static-Spa_Style_Accent1)}.plan-compare-card{border-width:1px}.plan-compare-card:last-child{border-radius:6px}.plan-compare-left-section{border-right-width:1px}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.PassParameterService }, { type: i2$1.ActivatedRoute }, { type: i1.ConfigResourceService }, { type: i1.PlanCompareService }, { type: PlanCompareFacade }, { type: i1.ResponsiveLayoutService }, { type: PlanDetailsFacade }, { type: PlanFacade }, { type: AnalyticsService }, { type: i1.PlansService }, { type: PlanListFacadeService }, { type: i2.Store }, { type: i1.SiteService }, { type: HelpfulToolsService }, { type: i1.LocaleService }, { type: i1.ProviderService }, { type: i1.PharmacyService }, { type: DrugCabinetContext }, { type: i1.SpinnerService }, { type: i1.NavigationUtilityService }, { type: i1.NavigationContext }, { type: PlanCardFacade }, { type: HospitalIndemnityFormFacade }, { type: ProviderFacade }]; }, { Spa_Site_Previous: [], Spa_PlanCard_PlanDetails_ButtonText: [], Spa_PlanCompare_Benefit_Show_MedicalDeductible_Tooltip: [], Spa_PlanCompare_Benefit_Show_MedicalMaxOutOfPocket_Tooltip: [], Spa_PlanCard_Benefit_MedicalDeductible_Title: [], Spa_PlanCompare_Benefit_MedicalMaxOutOfPocket_Title: [], Spa_PlanCard_Benefit_MedicalDeductible_Text: [], Spa_PlanCompare_Benefit_MedicalMaxOutOfPocket_Text: [], Spa_Site_Tooltip_Text: [], Spa_Remove_Plan_Text: [], Spa_PlanCompare_Benefit_MedicalDeductible_Tooltip: [], Spa_PlanCompare_Benefit_MedicalMaxOutOfPocket_Tooltip: [], Spa_PlanCompare_Benefit_values_MA: [], Spa_PlanCompare_Benefit_values_MAPD: [], Spa_PlanCompare_Benefit_values_MEDIGAP: [], Spa_Site_ViewDetails: [], Spa_Pharmacy_InNetwork_Preferred_Pricing_Text: [], Spa_Pharmacy_InNetwork_Standard_Pricing_Text: [], Spa_Pharmacy_OutOfNetwork_Pricing_Text: [], Spa_Plan_Details_Show_Preferences: [], Spa_Plan_Details_Preferences_Show_Provider: [], Spa_Site_ZelisIntegration_Enabled: [], Spa_Site_Prescriptions_Enabled: [], Spa_Site_Pharmacy_Enabled: [], Spa_PlanDetails_Covered_Text: [], Spa_PlanDetails_Non_Covered_Text: [], Spa_Plan_Details_Preferences_Position_Last: [], Spa_GuidedHelp_Enabled: [], Spa_Plan_Details_Preferences_Expanded: [], Spa_Site_Health_Enabled: [], Spa_Site_TotalEstimatedCost_Enabled: [], Spa_Site_ShowDifferences_Checked: [], Spa_PlanCompare_Plan_Differences_Text: [], Spa_PlanCompare_Plan_Differences_Color: [], Spa_PlanCompare_Plan_Differences_Border: [], Spa_Site_Rider_NotSupported_Text: [], Spa_Site_ShowPremiumAsAnnual: [], Spa_ShoppingCart_Enabled: [], Spa_Site_NotApplicable_Text: [], Spa_Plan_Details_ViewRiderDetails_Text: [], Spa_Plan_Details_HideRiderDetails_Text: [], Spa_Site_RiderDetails_Show: [], Spa_HealthCostsTab_AddAgeHealth_Text: [], Spa_Site_Hide_Text: [], Spa_Site_ViewAll_Text: [], Spa_Plan_Details_WaiverStateRider_Tooltips: [], Spa_PlanDetails_NonCommissionable_Text: [], Spa_PlanDetails_NonCommissionable_FlagCheck_Enabled: [], Spa_Site_Current_Plan_Text: [], Spa_Site_Next_Year_Plan_Text: [], Spa_Site_PlanNotAvailableForNextYear_Text: [], Spa_Site_Keep_This_Plan_Button_Text: [], Spa_Site_Show_PlanLogo: [], Spa_Site_SendQuote_Button_Text: [], Spa_Site_IsDeepLinking_Enabled: [], Spa_Site_SiteType: [], Spa_Compare_ViewDetails_Description: [], Spa_DrugCost_Add_Edit_Link_Description: [], Spa_HealthCost_Add_Edit_Link_Description: [], Spa_Prescription_Add_Edit_Link_Description: [], Spa_Site_Pharmacy_Add_Edit_Link_Description: [], Spa_Site_PlanViewDetails_Enabled: [], Spa_PlanCard_Benefit_VisionDeductible_Text: [], Spa_PlanCard_Benefit_DentalDeductible_Text: [], Spa_PlanCard_Benefit_CalendarYearMax_Text: [], Spa_PlanLevel_Content_Label_PDP: [], Spa_PlanLevel_Content_Label_MAPD: [], Spa_PlanLevel_Content_Label_MA: [], Spa_PlanLevel_Content_Label_MEDIGAP: [], Spa_Show_Plan_Level_Content: [], Spa_Plan_Benefits_Section_Name: [], Spa_PlanCompare_MedicalCoverage_Tooltip: [], Spa_PlanCompare_Show_MedicalCoverage_Tooltip: [], Spa_PlanCompare_PrescriptionDrugCoverage_Tooltip: [], Spa_PlanCompare_Show_PrescriptionDrugCoverage_Tooltip: [], Spa_PlanCompare_PlanDocument_ViewMore_Text: [], Spa_Plan_Providers_Search_Provider_Text: [], Spa_Plan_Providers_Directory_Link: [], Spa_Plan_Details_Preferences_Text: [], Spa_Plan_Details_Preferences_Pharmacy_Text: [], Spa_Plan_Details_Preferences_Prescription_Text: [], Spa_Plan_Details_Preferences_Provider_Text: [], Spa_Plan_Details_Providers_Link: [], Spa_Plan_Compare_PrescriptionDeductible_Text: [], Spa_Plan_Compare_PrescriptionDeductible_Tooltip: [], Spa_Plan_Compare_ShowPrescriptionDeductible_Tooltip: [], Spa_Plan_Compare_PrescriptionDrugs_Text: [], Spa_Plan_Compare_PrescriptionDrugs_Tooltip: [], Spa_Plan_Compare_ShowPrescriptionDrugs_Tooltip: [], Spa_PlanCompare_Benefit_Show_InitialCoverageLimit: [], Spa_Plan_Compare_PrescriptionInitialCoverageLimit_Text: [], Spa_Plan_Compare_PrescriptionInitialCoverageLimit_Tooltip: [], Spa_Plan_Compare_ShowPrescriptionInitialCoverageLimit_Tooltip: [], Spa_Plandetails_Costs_Add_Edit_Link_Text: [], Spa_Plan_Compare_HighLight_OffScreenText: [], Spa_PlanDetails_Health_Cost_Text: [], Spa_Plandetails_Costs_MAPD: [], Spa_Plandetails_Costs_MA: [], Spa_Plandetails_Costs_PDP: [], Spa_Plandetails_Costs_MEDIGAP: [], Spa_PlanDetails_Costs_DENTAL: [], Spa_PlanDetails_Costs_VISION: [], Spa_PlanDetails_Costs_HIP: [], Spa_ShoppingCart_IncludedRider_Text: [], Spa_Plan_Details_AddOnRiders_SubHeader: [], Spa_PlanCard_QuoteLinkName_Text: [], Spa_PlanDetails_Costs_Header: [], Spa_PlanCompare_Header: [], Spa_PlanCompare_MedicalCoverage_Text: [], Spa_PlanCompare_PrescriptionDrugCoverage_Text: [], Spa_PlanCompare_PlanDocument_Text: [], Spa_Prescription_Add_Edit_Link: [], Spa_Site_Pharmacy_AddEdit_Link: [], Spa_Plan_Details_AddOnRiders_Header: [], Spa_Site_PageSubHeader_Text: [], Spa_PlanDetails_Preferences_SearchPrescriptions_Text: [], Spa_PlanDetails_Preferences_PrescriptionDirectory_Title: [], Spa_PlanDetails_Preferences_PrescriptionDirectory_Link: [], Spa_PlanDetails_Preferences_SearchPharmacy_Text: [], Spa_PlanDetails_Preferences_PharmacyDirectory_Title: [], Spa_PlanDetails_Preferences_PharmacyDirectory_Link: [], Spa_Site_PrimaryPharmacy_Indicator_Text: [], Spa_Site_Preferred_In_Network_Text: [], Spa_Site_Standard_In_Network_Text: [], Spa_Site_Out_Of_Network_Text: [], Spa_Site_CostBasedOn_Text: [], Spa_Site_Mail_Order_Pharmacy_Enabled: [], Spa_PlanList_MailOrder_Text: [], Spa_Provider_InNetwork_Text: [], Spa_Provider_OutOfNetwork_Text: [], Spa_Providers_No_Data_Exist_Text: [], Spa_Site_Pcp_Text: [], Spa_Providers_Add_Edit_Link: [], Spa_Site_Providers_Enabled: [], Spa_Site_Preferences_AddEdit_Link: [], Spa_Plan_Details_OtherPreferences_Text: [], Spa_Site_OtherPreferences_Enabled: [], Spa_Site_Yes: [], Spa_Site_No: [], Spa_Providers_NoProviderNetworkAccess_Text: [], Spa_Site_HealthCosts_Enabled: [], Spa_Plan_Providers_Internal_Directory_Link_Text: [], Spa_Plan_Providers_Carrier_Directory_Link_Text: [], Spa_Site_Plan_List_Link: [], Spa_Plan_Providers_BothCarrierAndInternal_DirectoryLinks_Enabled: [], Spa_PlanDetails_Preferences_ProviderDirectory_Link: [], Spa_PlanDetails_Costs_Premium: [], SPA_HIP_Rider_Benefit_Default_Dropdown_Text: [], Spa_Site_HIP_BasePlanOption_Text: [], SPA_Site_NotAvailable_Rider_Benefit_Text: [], SPA_HIP_Rider_Benefit_Text: [], Spa_Site_HIP_Description: [], Spa_Site_HIP_MonthlyPremium_Text: [], Spa_Hospital_Indemnity_QuoteSummary_Header: [], Spa_PlanDetails_HIP_Call_Out_Available_Plan_Types: [], Spa_Site_Plan_Option_One_Text: [], Spa_Site_Plan_Option_Two_Text: [], Spa_Retention_ClientDefinedPlanOptions_Enabled: [], Spa_Site_PlanLogo_Size: [], Spa_PlanCard_AncillaryAddtoCart_Enabled: [], Spa_Site_ShowDrugAlternatives_Enabled: [], Spa_PlanCompare_ShowDrugAlternatives_Nudge_Enabled: [], Spa_Prescriptions_ShowDrugAlternatives_ViewAlternatives_Text: [], Spa_PlanFilters_DayLabel_Text: [], Spa_Site_Days_Text: [], Spa_Site_Day_Text: [], Spa_PlanList_MedSupEditAnswersBanner_Text: [], Spa_Site_LumpSum_Text: [], Spa_Site_Provider_ShowAllInNetworkLocations_Enabled: [], Spa_PlanCompare_StickyMiniCart_Enabled: [], Spa_Providers_AcceptingNewPatients_Text: [], Spa_Providers_AcceptingNewPatients_Icon: [], Spa_Providers_Languages_Icon: [], Spa_Site_PlanFees_Enabled: [], Spa_PlanFees_Tooltip_Text: [], Spa_PlanFees_IncludedInPremium_Tooltip_Text: [], Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text: [], Spa_Display_SNP_PremiumRange_Enabled: [], Spa_PlanCard_Compare_Remove_Modal_Header_Text: [], Spa_PlanCard_Compare_Remove_Modal_Intro_Text: [], Spa_Site_Cancel: [], Spa_PlanCard_Compare_Remove_Modal_Button_Text: [], Spa_PlanCompare_Remove_Mobile_Enabled: [], Spa_Site_ValueBasedCare_Agreement_Enabled: [], Spa_Site_ValueBasedCare_Agreement_Label: [], Spa_Site_ValueBasedCare_Agreement_Tooltip: [], Spa_PreferenceBanner_Enabled: [], areAllDentalPlans: [], areAllVisionPlans: [], _getPlanCompareCustomClass: [] }); })();

function DSNPEligibilityMessageComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.titleText);
} }
function DSNPEligibilityMessageComponent_ng_template_2_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "span", 5);
    i0.ɵɵlistener("click", function DSNPEligibilityMessageComponent_ng_template_2_div_3_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r5.updateDSNPFilterHighlight()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "b");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.filterCodeText);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.selectedDSNPCode);
} }
function DSNPEligibilityMessageComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "vnext-learn-more-tooltip", 3);
    i0.ɵɵtemplate(3, DSNPEligibilityMessageComponent_ng_template_2_div_3_Template, 5, 2, "div", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.bodyText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isMobile", ctx_r3.isMobile)("tooltipContent", ctx_r3.tooltipText)("tooltipLabelText", ctx_r3.tooltipLabelText)("tooltipCustomClass", "dsnp-planlist-tooltip")("tooltipPlacement", "bottom")("triggers", "click")("autoClose", "outside")("underlineTooltipButton", true)("showTooltipCloseButton", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.showFilterDSNPCode);
} }
class DSNPEligibilityMessageComponent {
    constructor(cdr, profileService, filterContextService, demographicService, planListContextService) {
        this.cdr = cdr;
        this.profileService = profileService;
        this.filterContextService = filterContextService;
        this.demographicService = demographicService;
        this.planListContextService = planListContextService;
        this.filterCodeEnabled = false;
        this.subscriptions = new Subscription();
        this.dsnpBaseTypes = [];
        this.selectedDSNPCode = '';
        this.showFilterDSNPCode = false;
        this.eligibilityState = '';
    }
    ngOnInit() {
        this.subscriptions.add(this.profileService.getMedicaidEligibilityLevel$().subscribe({
            next: (dsnpCode) => {
                if (dsnpCode) {
                    this.selectedDSNPCode = dsnpCode;
                }
                this.updateLearnMoreVisibility();
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.filterContextService
            .getFilterValues$()
            .pipe(filter((filterValues) => filterValues?.filterName === FilterContextNames.DSNP))
            .subscribe({
            next: (filterValues) => {
                this.dsnpBaseTypes = filterValues.filterValues;
                this.updateLearnMoreVisibility();
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.demographicService.getSelectedCounty$().subscribe({
            next: (selectedCounty) => {
                this.selectedCounty = selectedCounty;
                this.updateLearnMoreVisibility();
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.profileService.getMedicaidStateSelection$().subscribe({
            next: (eligibilityState) => {
                this.eligibilityState = eligibilityState;
                this.updateLearnMoreVisibility();
                this.cdr.markForCheck();
            }
        }));
    }
    updateLearnMoreVisibility() {
        const selectedState = this.selectedCounty?.state;
        if (this.selectedDSNPCode && selectedState && selectedState === this.eligibilityState) {
            this.showFilterDSNPCode = this.filterCodeEnabled && this.dsnpBaseTypes?.includes(this.selectedDSNPCode);
        }
    }
    updateDSNPFilterHighlight() {
        if (this.selectedDSNPCode) {
            this.filterContextService.setFilterHighlights({ filterName: FilterContextNames.DSNP, filterValues: [this.selectedDSNPCode] });
            if (this.isMobile) {
                this.planListContextService.displayMobileFiltersModal();
            }
            else {
                const dsnpFilterListElement = document.querySelector('#dsnpFilterContainer');
                dsnpFilterListElement?.scrollIntoView(true);
            }
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
DSNPEligibilityMessageComponent.ɵfac = function DSNPEligibilityMessageComponent_Factory(t) { return new (t || DSNPEligibilityMessageComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.ProfileService), i0.ɵɵdirectiveInject(i1.FilterContextService), i0.ɵɵdirectiveInject(i1.DemographicService), i0.ɵɵdirectiveInject(PlanListContextService)); };
DSNPEligibilityMessageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DSNPEligibilityMessageComponent, selectors: [["vnext-dsnp-eligibility-message"]], inputs: { titleText: "titleText", bodyText: "bodyText", tooltipText: "tooltipText", tooltipLabelText: "tooltipLabelText", filterCodeEnabled: "filterCodeEnabled", filterCodeText: "filterCodeText", isMobile: "isMobile" }, decls: 5, vars: 2, consts: [["noticeTitle", ""], ["noticeBody", ""], [3, "titleTemplate", "bodyTemplate"], [3, "isMobile", "tooltipContent", "tooltipLabelText", "tooltipCustomClass", "tooltipPlacement", "triggers", "autoClose", "underlineTooltipButton", "showTooltipCloseButton"], [4, "ngIf"], [1, "can-click", "Spa_Style_Link", "mr-2", 3, "click"]], template: function DSNPEligibilityMessageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, DSNPEligibilityMessageComponent_ng_template_0_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(2, DSNPEligibilityMessageComponent_ng_template_2_Template, 4, 11, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelement(4, "vnext-notice", 2);
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(1);
        const _r2 = i0.ɵɵreference(3);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("titleTemplate", _r0)("bodyTemplate", _r2);
    } }, dependencies: [i1$2.NgIf, LearnMoreTooltipComponent, NoticeComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DSNPEligibilityMessageComponent, [{
        type: Component,
        args: [{ selector: 'vnext-dsnp-eligibility-message', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-template #noticeTitle>\r\n  <span>{{ titleText }}</span>\r\n</ng-template>\r\n<ng-template #noticeBody>\r\n  <span>\r\n    {{ bodyText }}\r\n    <vnext-learn-more-tooltip\r\n      [isMobile]=\"isMobile\"\r\n      [tooltipContent]=\"tooltipText\"\r\n      [tooltipLabelText]=\"tooltipLabelText\"\r\n      [tooltipCustomClass]=\"'dsnp-planlist-tooltip'\"\r\n      [tooltipPlacement]=\"'bottom'\"\r\n      [triggers]=\"'click'\"\r\n      [autoClose]=\"'outside'\"\r\n      [underlineTooltipButton]=\"true\"\r\n      [showTooltipCloseButton]=\"true\"\r\n    ></vnext-learn-more-tooltip>\r\n    <div *ngIf=\"showFilterDSNPCode\">\r\n      <span class=\"can-click Spa_Style_Link mr-2\" (click)=\"updateDSNPFilterHighlight()\">{{ filterCodeText }}</span>\r\n      <b>{{ selectedDSNPCode }}</b>\r\n    </div>\r\n  </span>\r\n</ng-template>\r\n<vnext-notice [titleTemplate]=\"noticeTitle\" [bodyTemplate]=\"noticeBody\"></vnext-notice>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.ProfileService }, { type: i1.FilterContextService }, { type: i1.DemographicService }, { type: PlanListContextService }]; }, { titleText: [{
            type: Input
        }], bodyText: [{
            type: Input
        }], tooltipText: [{
            type: Input
        }], tooltipLabelText: [{
            type: Input
        }], filterCodeEnabled: [{
            type: Input
        }], filterCodeText: [{
            type: Input
        }], isMobile: [{
            type: Input
        }] }); })();

function PlanSubTypeDropdownComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵlistener("click", function PlanSubTypeDropdownComponent_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.updatePlans()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.updatePlansText);
} }
class PlanSubTypeDropdownComponent {
    constructor(medSupFacade, store, cdr, analyticsService) {
        this.medSupFacade = medSupFacade;
        this.store = store;
        this.cdr = cdr;
        this.analyticsService = analyticsService;
        this.hideButton = false;
        this.planFilterModalEnabled = false;
        this.planSubTypeChanged = new EventEmitter();
        this.planSubTypes = [];
        this.subscriptions = [];
    }
    ngOnInit() {
        this.planSubTypes = this.medSupFacade.getPlanSubTypes();
        this.subscriptions.push(this.store.select(PlansState.selectedPlanSubType).subscribe({
            next: (planSubType) => {
                this.selectedPlanSubType = planSubType;
                this.cdr.markForCheck();
            }
        }));
        this.cdr.markForCheck();
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    valueReceived(planSubType) {
        this.selectedPlanSubType = planSubType;
        if (this.hideButton) {
            this.updatePlans();
        }
    }
    updatePlans() {
        if (this.selectedPlanSubType !== this.previousPlanSubType) {
            if (!this.planFilterModalEnabled) {
                this.medSupFacade.updateSelectedPlanSubType(this.selectedPlanSubType);
                this.logRecalculateMedsupRatesEvent();
            }
            this.previousPlanSubType = this.selectedPlanSubType;
            this.planSubTypeChanged.emit(this.selectedPlanSubType);
        }
    }
    logRecalculateMedsupRatesEvent() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLANS_RECALCULATE_RATES_MEDSUP,
            [DataLayerGlobalVariable.DATA_PLAN_SUBTYPE_SELECTION]: this.selectedPlanSubType
        };
    }
}
PlanSubTypeDropdownComponent.ɵfac = function PlanSubTypeDropdownComponent_Factory(t) { return new (t || PlanSubTypeDropdownComponent)(i0.ɵɵdirectiveInject(MedSupFacade), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.GoogleTagManagerService)); };
PlanSubTypeDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanSubTypeDropdownComponent, selectors: [["vnext-plan-sub-type-dropdown"]], inputs: { headerText: "headerText", placeholder: "placeholder", updatePlansText: "updatePlansText", hideButton: "hideButton", planFilterModalEnabled: "planFilterModalEnabled" }, outputs: { planSubTypeChanged: "planSubTypeChanged" }, features: [i0.ɵɵProvidersFeature([])], decls: 2, vars: 8, consts: [[3, "headerText", "placeholder", "planSubTypes", "selectedPlanSubType", "showError", "updateOnClick", "fullWidth", "valueSelected"], ["class", "btn Spa_Style_PrimaryButton mt-3 w-100", 3, "click", 4, "ngIf"], [1, "btn", "Spa_Style_PrimaryButton", "mt-3", "w-100", 3, "click"]], template: function PlanSubTypeDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "vnext-med-sup-plan-sub-type", 0);
        i0.ɵɵlistener("valueSelected", function PlanSubTypeDropdownComponent_Template_vnext_med_sup_plan_sub_type_valueSelected_0_listener($event) { return ctx.valueReceived($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(1, PlanSubTypeDropdownComponent_button_1_Template, 2, 1, "button", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("headerText", ctx.headerText)("placeholder", ctx.placeholder)("planSubTypes", ctx.planSubTypes)("selectedPlanSubType", ctx.selectedPlanSubType)("showError", false)("updateOnClick", false)("fullWidth", true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.hideButton);
    } }, dependencies: [i1$2.NgIf, MedSupPlanSubTypeComponent], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanSubTypeDropdownComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-sub-type-dropdown', changeDetection: ChangeDetectionStrategy.OnPush, providers: [], template: "<vnext-med-sup-plan-sub-type\r\n  (valueSelected)=\"valueReceived($event)\"\r\n  [headerText]=\"headerText\"\r\n  [placeholder]=\"placeholder\"\r\n  [planSubTypes]=\"planSubTypes\"\r\n  [selectedPlanSubType]=\"selectedPlanSubType\"\r\n  [showError]=\"false\"\r\n  [updateOnClick]=\"false\"\r\n  [fullWidth]=\"true\"\r\n></vnext-med-sup-plan-sub-type>\r\n<button class=\"btn Spa_Style_PrimaryButton mt-3 w-100\" *ngIf=\"!hideButton\" (click)=\"updatePlans()\">{{ updatePlansText }}</button>\r\n" }]
    }], function () { return [{ type: MedSupFacade }, { type: i2.Store }, { type: i0.ChangeDetectorRef }, { type: i1.GoogleTagManagerService }]; }, { headerText: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], updatePlansText: [{
            type: Input
        }], hideButton: [{
            type: Input
        }], planFilterModalEnabled: [{
            type: Input
        }], planSubTypeChanged: [{
            type: Output
        }] }); })();

function PlanFilterModalItemsComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function PlanFilterModalItemsComponent_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.closeModalEvent.emit()); });
    i0.ɵɵelement(1, "i", 7);
    i0.ɵɵelementStart(2, "span", 8);
    i0.ɵɵtext(3, "Close");
    i0.ɵɵelementEnd()();
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h4", 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r20.snpBaseTypeLabel, " ");
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-snp-toggle", 15);
    i0.ɵɵlistener("toggleSNPPlanChangeEvent", function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_3_Template_vnext_snp_toggle_toggleSNPPlanChangeEvent_1_listener($event) { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r25.onHideSNPPlanSelected($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("activeTabType", ctx_r21.activeTabType)("snpLabelText", ctx_r21.snpLabelText)("showCheckbox", ctx_r21.isPlanListPage)("hideAllSnpType", ctx_r21.hideAllSnpType);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-snp-category-toggle", 18);
    i0.ɵɵlistener("snpFilterSelectedEvent", function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_4_div_1_Template_vnext_snp_category_toggle_snpFilterSelectedEvent_1_listener($event) { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r30.onSnpFilterSelected($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("snpItems", ctx_r27.cSNPBaseTypes)("snpBaseTypesControlName", ctx_r27.snpBaseTypesControlName)("snpBaseTypesControlValue", ctx_r27.filterForm == null ? null : ctx_r27.filterForm.controls == null ? null : ctx_r27.filterForm.controls[ctx_r27.snpBaseTypesControlName] == null ? null : ctx_r27.filterForm.controls[ctx_r27.snpBaseTypesControlName].value)("snpSubTypesControlName", ctx_r27.snpSubTypesControlName)("snpSubTypesControlValue", ctx_r27.filterForm == null ? null : ctx_r27.filterForm.controls == null ? null : ctx_r27.filterForm.controls[ctx_r27.snpSubTypesControlName] == null ? null : ctx_r27.filterForm.controls[ctx_r27.snpSubTypesControlName].value)("snpSubItems", ctx_r27.cSNPSubTypes)("snpVisibility", ctx_r27.snpVisibility)("planFilterModalEnabled", ctx_r27.planFilterModalEnabled)("showTooltipIcon", true)("enablePrimaryColor", true)("clearSnpFilters", ctx_r27.clearSnpFilters);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_4_ng_template_2_div_0_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "vnext-checkbox-group", 19);
    i0.ɵɵlistener("change", function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_4_ng_template_2_div_0_ng_container_2_div_1_Template_vnext_checkbox_group_change_1_listener() { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(8); return i0.ɵɵresetView(ctx_r35.onSnpSubFilterSelected(ctx_r35.snpBaseTypesControlName, ctx_r35.snpSubTypesControlName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r34.snpSubTypesControlName);
    i0.ɵɵproperty("items", ctx_r34.cSNPSubTypes)("parentId", ctx_r34.snpSubTypesControlName)("showTooltipIcon", true)("enablePrimaryColor", true);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_4_ng_template_2_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_4_ng_template_2_div_0_ng_container_2_div_1_Template, 2, 5, "div", 20);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r33.cSNPSubTypes.length >= 1);
} }
const _c0$N = function (a0, a1) { return { "pl-1": a0, "disable-click": a1 }; };
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_4_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "vnext-checkbox-group", 19);
    i0.ɵɵlistener("change", function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_4_ng_template_2_div_0_Template_vnext_checkbox_group_change_1_listener() { i0.ɵɵrestoreView(_r38); const ctx_r37 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r37.onSnpSubFilterSelected(ctx_r37.snpBaseTypesControlName, ctx_r37.snpSubTypesControlName)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_4_ng_template_2_div_0_ng_container_2_Template, 2, 1, "ng-container", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c0$N, ctx_r32.planFilterModalEnabled, !ctx_r32.snpVisibility));
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r32.snpBaseTypesControlName);
    i0.ɵɵproperty("items", ctx_r32.cSNPBaseTypes)("parentId", ctx_r32.snpBaseTypesControlName)("showTooltipIcon", true)("enablePrimaryColor", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r32.cSNPSubTypes);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_4_ng_template_2_div_0_Template, 3, 10, "div", 11);
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("ngIf", ctx_r29.cSNPBaseTypes.length >= 1);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_4_div_1_Template, 2, 11, "div", 16);
    i0.ɵɵtemplate(2, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_4_ng_template_2_Template, 1, 1, "ng-template", null, 17, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r28 = i0.ɵɵreference(3);
    const ctx_r22 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r22.planFilterModalEnabled)("ngIfElse", _r28);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-snp-category-toggle", 18);
    i0.ɵɵlistener("snpFilterSelectedEvent", function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_5_div_1_Template_vnext_snp_category_toggle_snpFilterSelectedEvent_1_listener($event) { i0.ɵɵrestoreView(_r43); const ctx_r42 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r42.onSnpFilterSelected($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("snpItems", ctx_r39.dSNPBaseTypes)("snpBaseTypesControlName", ctx_r39.snpBaseTypesControlName)("snpBaseTypesControlValue", ctx_r39.filterForm == null ? null : ctx_r39.filterForm.controls == null ? null : ctx_r39.filterForm.controls[ctx_r39.snpBaseTypesControlName] == null ? null : ctx_r39.filterForm.controls[ctx_r39.snpBaseTypesControlName].value)("snpSubTypesControlName", ctx_r39.snpSubTypesControlName)("snpSubTypesControlValue", ctx_r39.filterForm == null ? null : ctx_r39.filterForm.controls == null ? null : ctx_r39.filterForm.controls[ctx_r39.snpSubTypesControlName] == null ? null : ctx_r39.filterForm.controls[ctx_r39.snpSubTypesControlName].value)("snpSubItems", ctx_r39.dSNPSubTypes)("snpVisibility", ctx_r39.snpVisibility)("planFilterModalEnabled", ctx_r39.planFilterModalEnabled)("showTooltipIcon", true)("enablePrimaryColor", true)("clearSnpFilters", ctx_r39.clearSnpFilters);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_5_ng_template_2_div_0_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "vnext-checkbox-group", 25);
    i0.ɵɵlistener("change", function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_5_ng_template_2_div_0_ng_container_2_div_1_Template_vnext_checkbox_group_change_1_listener() { i0.ɵɵrestoreView(_r48); const ctx_r47 = i0.ɵɵnextContext(8); return i0.ɵɵresetView(ctx_r47.onSnpSubFilterSelected(ctx_r47.snpBaseTypesControlName, ctx_r47.dsnpSubTypesControlName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r46.dsnpSubTypesControlName);
    i0.ɵɵproperty("highlightedItems", ctx_r46.highlightedDSNPCodes)("items", ctx_r46.dSNPSubTypes)("parentId", ctx_r46.dsnpSubTypesControlName)("showTooltipIcon", true)("enablePrimaryColor", true);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_5_ng_template_2_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_5_ng_template_2_div_0_ng_container_2_div_1_Template, 2, 6, "div", 23);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r45.dSNPSubTypes.length >= 1);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_5_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "vnext-checkbox-group", 19);
    i0.ɵɵlistener("change", function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_5_ng_template_2_div_0_Template_vnext_checkbox_group_change_1_listener() { i0.ɵɵrestoreView(_r50); const ctx_r49 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r49.onSnpSubFilterSelected(ctx_r49.snpBaseTypesControlName)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_5_ng_template_2_div_0_ng_container_2_Template, 2, 1, "ng-container", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c0$N, ctx_r44.planFilterModalEnabled, !ctx_r44.snpVisibility));
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r44.snpBaseTypesControlName);
    i0.ɵɵproperty("items", ctx_r44.dSNPBaseTypes)("parentId", ctx_r44.snpBaseTypesControlName)("showTooltipIcon", true)("enablePrimaryColor", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r44.dSNPSubTypes);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_5_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_5_ng_template_2_div_0_Template, 3, 10, "div", 11);
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("ngIf", ctx_r41.dSNPBaseTypes.length >= 1);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_5_div_1_Template, 2, 11, "div", 16);
    i0.ɵɵtemplate(2, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_5_ng_template_2_Template, 1, 1, "ng-template", null, 22, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r40 = i0.ɵɵreference(3);
    const ctx_r23 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r23.planFilterModalEnabled)("ngIfElse", _r40);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-snp-category-toggle", 18);
    i0.ɵɵlistener("snpFilterSelectedEvent", function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_6_div_1_Template_vnext_snp_category_toggle_snpFilterSelectedEvent_1_listener($event) { i0.ɵɵrestoreView(_r55); const ctx_r54 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r54.onSnpFilterSelected($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r51 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("snpItems", ctx_r51.iSNPBaseTypes)("snpBaseTypesControlName", ctx_r51.snpBaseTypesControlName)("snpBaseTypesControlValue", ctx_r51.filterForm == null ? null : ctx_r51.filterForm.controls == null ? null : ctx_r51.filterForm.controls[ctx_r51.snpBaseTypesControlName] == null ? null : ctx_r51.filterForm.controls[ctx_r51.snpBaseTypesControlName].value)("snpSubTypesControlName", ctx_r51.snpSubTypesControlName)("snpSubTypesControlValue", ctx_r51.filterForm == null ? null : ctx_r51.filterForm.controls == null ? null : ctx_r51.filterForm.controls[ctx_r51.snpSubTypesControlName] == null ? null : ctx_r51.filterForm.controls[ctx_r51.snpSubTypesControlName].value)("snpSubItems", ctx_r51.iSNPSubTypes)("snpVisibility", ctx_r51.snpVisibility)("planFilterModalEnabled", ctx_r51.planFilterModalEnabled)("showTooltipIcon", true)("enablePrimaryColor", true)("clearSnpFilters", ctx_r51.clearSnpFilters);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_6_ng_template_2_div_0_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r60 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "vnext-checkbox-group", 19);
    i0.ɵɵlistener("change", function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_6_ng_template_2_div_0_ng_container_2_div_1_Template_vnext_checkbox_group_change_1_listener() { i0.ɵɵrestoreView(_r60); const ctx_r59 = i0.ɵɵnextContext(8); return i0.ɵɵresetView(ctx_r59.onSnpSubFilterSelected(ctx_r59.snpBaseTypesControlName, ctx_r59.snpSubTypesControlName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r58 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r58.snpSubTypesControlName);
    i0.ɵɵproperty("items", ctx_r58.iSNPSubTypes)("parentId", ctx_r58.snpSubTypesControlName)("showTooltipIcon", true)("enablePrimaryColor", true);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_6_ng_template_2_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_6_ng_template_2_div_0_ng_container_2_div_1_Template, 2, 5, "div", 20);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r57 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r57.iSNPSubTypes.length >= 1);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_6_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r62 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "vnext-checkbox-group", 19);
    i0.ɵɵlistener("change", function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_6_ng_template_2_div_0_Template_vnext_checkbox_group_change_1_listener() { i0.ɵɵrestoreView(_r62); const ctx_r61 = i0.ɵɵnextContext(6); return i0.ɵɵresetView(ctx_r61.onSnpSubFilterSelected(ctx_r61.snpBaseTypesControlName, ctx_r61.snpSubTypesControlName)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_6_ng_template_2_div_0_ng_container_2_Template, 2, 1, "ng-container", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r56 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c0$N, ctx_r56.planFilterModalEnabled, !ctx_r56.snpVisibility));
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r56.snpBaseTypesControlName);
    i0.ɵɵproperty("items", ctx_r56.iSNPBaseTypes)("parentId", ctx_r56.snpBaseTypesControlName)("showTooltipIcon", true)("enablePrimaryColor", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r56.iSNPSubTypes);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_6_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_6_ng_template_2_div_0_Template, 3, 10, "div", 11);
} if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("ngIf", ctx_r53.iSNPBaseTypes.length >= 1);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_6_div_1_Template, 2, 11, "div", 16);
    i0.ɵɵtemplate(2, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_6_ng_template_2_Template, 1, 1, "ng-template", null, 26, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r52 = i0.ɵɵreference(3);
    const ctx_r24 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r24.planFilterModalEnabled)("ngIfElse", _r52);
} }
const _c1$e = function (a0) { return { "col-3": a0 }; };
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_1_Template, 3, 1, "ng-container", 13);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_3_Template, 2, 4, "ng-container", 13);
    i0.ɵɵtemplate(4, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_4_Template, 4, 2, "ng-container", 13);
    i0.ɵɵtemplate(5, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_5_Template, 4, 2, "ng-container", 13);
    i0.ɵɵtemplate(6, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_ng_container_6_Template, 4, 2, "ng-container", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c1$e, ctx_r19.planFilterModalEnabled && ((ctx_r19.cSNPBaseTypes == null ? null : ctx_r19.cSNPBaseTypes.length) || (ctx_r19.dSNPBaseTypes == null ? null : ctx_r19.dSNPBaseTypes.length) || (ctx_r19.iSNPBaseTypes == null ? null : ctx_r19.iSNPBaseTypes.length)) && !ctx_r19.isMobile));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 6, ctx_r19.snpBaseTypes$).length || !ctx_r19.snpVisibility && ctx_r19.planFilterModalEnabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r19.planFilterModalEnabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.cSNPBaseTypes);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.dSNPBaseTypes);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.iSNPBaseTypes);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_div_1_Template, 7, 10, "div", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.snpEnabled);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_3_ng_container_1_div_1_span_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 33);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r68 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r68.providersNpiTooltipText, "html"), i0.ɵɵsanitizeHtml);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_3_ng_container_1_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_3_ng_container_1_div_1_span_3_ng_template_1_Template, 2, 4, "ng-template", null, 31, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "i", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r67 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbTooltip", _r67);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_3_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r70 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "h4", 27);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, PlanFilterModalItemsComponent_ng_container_6_ng_container_3_ng_container_1_div_1_span_3_Template, 4, 1, "span", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "vnext-checkbox-group", 29);
    i0.ɵɵlistener("change", function PlanFilterModalItemsComponent_ng_container_6_ng_container_3_ng_container_1_div_1_Template_vnext_checkbox_group_change_4_listener() { i0.ɵɵrestoreView(_r70); const ctx_r69 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r69.onFilterSelected(ctx_r69.providersNpiName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const providerNpiOptions_r64 = i0.ɵɵnextContext().ngIf;
    const ctx_r65 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c1$e, ctx_r65.planFilterModalEnabled && !ctx_r65.isMobile));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r65.providersNpiHeaderText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r65.medicalDeductibleToolTipText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r65.providersNpiName);
    i0.ɵɵproperty("items", providerNpiOptions_r64)("parentId", ctx_r65.providersNpiName)("showTooltipUnderline", true)("enablePrimaryColor", true)("enableNoteStyle", false);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_3_ng_container_1_div_1_Template, 5, 11, "div", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const providerNpiOptions_r64 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", providerNpiOptions_r64.length);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_3_ng_container_1_Template, 2, 1, "ng-container", 13);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r6.providersNpiFilterEnabled && ctx_r6.providersEnabled && ctx_r6.providerNpiOptions$));
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "h4", 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "vnext-checkbox-group", 34);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r72 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c1$e, ctx_r72.planFilterModalEnabled && !ctx_r72.isMobile));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r72.licensingHeaderText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r72.sellableControlName);
    i0.ɵɵproperty("items", i0.ɵɵpipeBind1(4, 8, ctx_r72.planSellable$))("parentId", ctx_r72.sellableControlName)("showTooltipIcon", true)("enablePrimaryColor", true)("enableNoteStyle", false);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_4_div_1_Template, 5, 12, "div", 11);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r7.showSellablePlanFilter$) && !ctx_r7.currentTabIsMedigap);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_5_ng_container_1_div_1_span_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 33);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r78 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r78.medicalDeductibleToolTipText, "html"), i0.ɵɵsanitizeHtml);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_5_ng_container_1_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_5_ng_container_1_div_1_span_3_ng_template_1_Template, 2, 4, "ng-template", null, 36, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "i", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r77 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbTooltip", _r77);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_5_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "h4", 27);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, PlanFilterModalItemsComponent_ng_container_6_ng_container_5_ng_container_1_div_1_span_3_Template, 4, 1, "span", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "vnext-checkbox-group", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const medicalDeductible_r74 = i0.ɵɵnextContext().ngIf;
    const ctx_r75 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c1$e, ctx_r75.planFilterModalEnabled && !ctx_r75.isMobile));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r75.medicalDeductibleHeaderText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r75.medicalDeductibleToolTipText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r75.medicalDeductibleControlName);
    i0.ɵɵproperty("items", medicalDeductible_r74)("parentId", ctx_r75.medicalDeductibleControlName)("showTooltipUnderline", true)("enablePrimaryColor", true)("enableNoteStyle", false);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_5_ng_container_1_div_1_Template, 5, 11, "div", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const medicalDeductible_r74 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", medicalDeductible_r74.length);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_5_ng_container_1_Template, 2, 1, "ng-container", 13);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r8.costFilterEnabled && !ctx_r8.currentTabIsPDP && ctx_r8.medicalDeductible$));
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_6_ng_container_1_div_1_span_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 33);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r85 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r85.maximumOutOfPocketCostToolTipText, "html"), i0.ɵɵsanitizeHtml);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_6_ng_container_1_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_6_ng_container_1_div_1_span_3_ng_template_1_Template, 2, 4, "ng-template", null, 37, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "i", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r84 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbTooltip", _r84);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_6_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "h4", 27);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, PlanFilterModalItemsComponent_ng_container_6_ng_container_6_ng_container_1_div_1_span_3_Template, 4, 1, "span", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "vnext-checkbox-group", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const maximumOutOfPocketCost_r81 = i0.ɵɵnextContext().ngIf;
    const ctx_r82 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c1$e, ctx_r82.planFilterModalEnabled && !ctx_r82.isMobile));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r82.maximumOutOfPocketCostHeaderText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r82.maximumOutOfPocketCostToolTipText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r82.maximumOutOfPocketCostControlName);
    i0.ɵɵproperty("items", maximumOutOfPocketCost_r81)("parentId", ctx_r82.maximumOutOfPocketCostControlName)("showTooltipUnderline", true)("enablePrimaryColor", true)("enableNoteStyle", false);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_6_ng_container_1_div_1_Template, 5, 11, "div", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const maximumOutOfPocketCost_r81 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", maximumOutOfPocketCost_r81.length);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_6_ng_container_1_Template, 2, 1, "ng-container", 13);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r9.costFilterEnabled && !ctx_r9.currentTabIsPDP && ctx_r9.maximumOutOfPocketCost$));
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_7_ng_container_1_div_1_span_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 33);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r92 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r92.drugDeductibleToolTipText, "html"), i0.ɵɵsanitizeHtml);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_7_ng_container_1_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_7_ng_container_1_div_1_span_3_ng_template_1_Template, 2, 4, "ng-template", null, 38, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "i", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r91 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbTooltip", _r91);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_7_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "h4", 27);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, PlanFilterModalItemsComponent_ng_container_6_ng_container_7_ng_container_1_div_1_span_3_Template, 4, 1, "span", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "vnext-checkbox-group", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const drugDeductible_r88 = i0.ɵɵnextContext().ngIf;
    const ctx_r89 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c1$e, ctx_r89.planFilterModalEnabled && !ctx_r89.isMobile));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r89.drugDeductibleHeaderText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r89.drugDeductibleToolTipText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r89.drugDeductibleControlName);
    i0.ɵɵproperty("items", drugDeductible_r88)("parentId", ctx_r89.drugDeductibleControlName)("showTooltipUnderline", true)("enablePrimaryColor", true)("enableNoteStyle", false);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_7_ng_container_1_div_1_Template, 5, 11, "div", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const drugDeductible_r88 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", drugDeductible_r88.length);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_7_ng_container_1_Template, 2, 1, "ng-container", 13);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r10.costFilterEnabled && ctx_r10.currentTabIsPDP && ctx_r10.drugDeductible$));
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_8_ng_container_1_div_1_span_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 33);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r101 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r101.premiumToolTipText, "html"), i0.ɵɵsanitizeHtml);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_8_ng_container_1_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_8_ng_container_1_div_1_span_3_ng_template_1_Template, 2, 4, "ng-template", null, 39, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "i", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r100 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbTooltip", _r100);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_8_ng_container_1_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-checkbox-group", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const premium_r95 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r98 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r98.drugPremiumControlName);
    i0.ɵɵproperty("items", premium_r95.drugPremium)("parentId", ctx_r98.drugPremiumControlName)("showTooltipUnderline", true)("enablePrimaryColor", true)("enableNoteStyle", false);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_8_ng_container_1_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-checkbox-group", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const premium_r95 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r99 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r99.medicalPremiumControlName);
    i0.ɵɵproperty("items", premium_r95.medicalPremium)("parentId", ctx_r99.medicalPremiumControlName)("showTooltipUnderline", true)("enablePrimaryColor", true)("enableNoteStyle", false);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_8_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "h4", 27);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, PlanFilterModalItemsComponent_ng_container_6_ng_container_8_ng_container_1_div_1_span_3_Template, 4, 1, "span", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PlanFilterModalItemsComponent_ng_container_6_ng_container_8_ng_container_1_div_1_div_4_Template, 2, 6, "div", 13);
    i0.ɵɵtemplate(5, PlanFilterModalItemsComponent_ng_container_6_ng_container_8_ng_container_1_div_1_div_5_Template, 2, 6, "div", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const premium_r95 = i0.ɵɵnextContext().ngIf;
    const ctx_r96 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c1$e, ctx_r96.planFilterModalEnabled && !ctx_r96.isMobile));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r96.premiumHeaderText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r96.premiumToolTipText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r96.currentTabIsPDP && (premium_r95.drugPremium == null ? null : premium_r95.drugPremium.length));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r96.currentTabIsPDP && (premium_r95.medicalPremium == null ? null : premium_r95.medicalPremium.length));
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_8_ng_container_1_div_1_Template, 6, 7, "div", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const premium_r95 = ctx.ngIf;
    const ctx_r94 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r94.currentTabIsPDP && (premium_r95.medicalPremium == null ? null : premium_r95.medicalPremium.length) || ctx_r94.currentTabIsPDP && (premium_r95.drugPremium == null ? null : premium_r95.drugPremium.length));
} }
const _c2$8 = function (a0, a1) { return { medicalPremium: a0, drugPremium: a1 }; };
function PlanFilterModalItemsComponent_ng_container_6_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_8_ng_container_1_Template, 2, 1, "ng-container", 13);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.costFilterEnabled && i0.ɵɵpureFunction2(5, _c2$8, i0.ɵɵpipeBind1(2, 1, ctx_r11.medicalPremium$), i0.ɵɵpipeBind1(3, 3, ctx_r11.drugPremium$)));
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_9_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "h4", 27);
    i0.ɵɵtext(2);
    i0.ɵɵelement(3, "i", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "vnext-checkbox-group", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ridersOptions_r106 = i0.ɵɵnextContext().ngIf;
    const ctx_r107 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c1$e, ctx_r107.planFilterModalEnabled && !ctx_r107.isMobile));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r107.addOnFilterHeaderText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngbTooltip", ctx_r107.addOnTooltipText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r107.ridersPlanSubtypeName);
    i0.ɵɵproperty("items", ridersOptions_r106)("parentId", ctx_r107.ridersPlanSubtypeName)("showTooltipIcon", true)("enablePrimaryColor", true)("enableNoteStyle", false);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_9_ng_container_1_div_1_Template, 5, 11, "div", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ridersOptions_r106 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ridersOptions_r106.length);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_9_ng_container_1_Template, 2, 1, "ng-container", 13);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r12.addOnFilterEnabled && ctx_r12.ridersOptions$));
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_10_ng_container_1_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-checkbox-group", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r110 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r110.extraDataControlName);
    i0.ɵɵproperty("items", ctx_r110.allPlanBenefitFilter.modelDrugPrograms)("parentId", ctx_r110.extraDataControlName)("showTooltipIcon", true)("showTooltipUnderline", true)("enablePrimaryColor", true)("enableNoteStyle", false);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_10_ng_container_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "vnext-checkbox-group", 42);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r111 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r111.planBenefitsControlName);
    i0.ɵɵproperty("items", ctx_r111.allPlanBenefitFilter.defaultPlanBenefits)("parentId", ctx_r111.planBenefitsControlName)("showTooltipIcon", true)("showTooltipUnderline", true)("enablePrimaryColor", true)("enableNoteStyle", false);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 41)(2, "h4", 14);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PlanFilterModalItemsComponent_ng_container_6_ng_container_10_ng_container_1_div_4_Template, 2, 7, "div", 13);
    i0.ɵɵtemplate(5, PlanFilterModalItemsComponent_ng_container_6_ng_container_10_ng_container_1_div_5_Template, 2, 7, "div", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r109 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c1$e, ctx_r109.planFilterModalEnabled && !ctx_r109.isMobile));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r109.additionalSavingsHeaderText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r109.insulinSavingsEnabled && (ctx_r109.allPlanBenefitFilter.modelDrugPrograms == null ? null : ctx_r109.allPlanBenefitFilter.modelDrugPrograms.length));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r109.allPlanBenefitFilter.defaultPlanBenefits == null ? null : ctx_r109.allPlanBenefitFilter.defaultPlanBenefits.length);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_10_ng_container_1_Template, 6, 6, "ng-container", 13);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.defaultPlanBenefitFiltersEnabled && ((ctx_r13.allPlanBenefitFilter.modelDrugPrograms == null ? null : ctx_r13.allPlanBenefitFilter.modelDrugPrograms.length) || (ctx_r13.allPlanBenefitFilter.defaultPlanBenefits == null ? null : ctx_r13.allPlanBenefitFilter.defaultPlanBenefits.length)));
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_11_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "h4", 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "vnext-checkbox-group", 43);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const carriers_r113 = i0.ɵɵnextContext().ngIf;
    const ctx_r114 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c1$e, ctx_r114.planFilterModalEnabled && !ctx_r114.isMobile));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r114.filterCarrierText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r114.carriersControlName);
    i0.ɵɵproperty("items", carriers_r113)("parentId", ctx_r114.carriersControlName)("showTooltipIcon", true)("enablePrimaryColor", true)("noTranslateBlock", true)("enableNoteStyle", false);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_11_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_11_ng_container_1_div_1_Template, 4, 11, "div", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const carriers_r113 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", carriers_r113.length > 1);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_11_ng_container_1_Template, 2, 1, "ng-container", 13);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r14.carriers$));
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_12_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "h4", 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "vnext-checkbox-group", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const planSubTypes_r117 = i0.ɵɵnextContext().ngIf;
    const ctx_r118 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c1$e, ctx_r118.planFilterModalEnabled && !ctx_r118.isMobile));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r118.planSubTypeLabel, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r118.subTypesControlName);
    i0.ɵɵproperty("items", planSubTypes_r117)("parentId", ctx_r118.subTypesControlName)("showTooltipIcon", true)("enablePrimaryColor", true)("enableNoteStyle", false);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_12_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_12_ng_container_1_div_1_Template, 4, 10, "div", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const planSubTypes_r117 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", planSubTypes_r117.length > 1);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_12_ng_container_1_Template, 2, 1, "ng-container", 13);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r15.displayPlanSubTypes && ctx_r15.planSubTypes$));
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_13_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "h4", 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "vnext-checkbox-group", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ancillaryPlanTypes_r121 = i0.ɵɵnextContext().ngIf;
    const ctx_r122 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c1$e, ctx_r122.planFilterModalEnabled && !ctx_r122.isMobile));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r122.planTypeLabel, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r122.ancillaryPlanTypeControlName);
    i0.ɵɵproperty("items", ancillaryPlanTypes_r121)("parentId", ctx_r122.ancillaryPlanTypeControlName)("showTooltipIcon", true)("enablePrimaryColor", true)("enableNoteStyle", false);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_13_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_13_ng_container_1_div_1_Template, 4, 10, "div", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ancillaryPlanTypes_r121 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ancillaryPlanTypes_r121.length > 1);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_13_ng_container_1_Template, 2, 1, "ng-container", 13);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r16.displayDentalVisionFilters && ctx_r16.ancillaryPlanTypes$));
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_14_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r126 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 12)(2, "vnext-plan-sub-type-dropdown", 44);
    i0.ɵɵlistener("planSubTypeChanged", function PlanFilterModalItemsComponent_ng_container_6_ng_container_14_ng_container_1_Template_vnext_plan_sub_type_dropdown_planSubTypeChanged_2_listener($event) { i0.ɵɵrestoreView(_r126); const ctx_r125 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r125.planSubTypeChanged.emit($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r124 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$e, !ctx_r124.isMobile));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("headerText", ctx_r124.medsupPlanSubTypeHeaderText)("placeholder", ctx_r124.medsupPlanSubTypePlacholderText)("updatePlansText", ctx_r124.medsupPlanSubTypeUpdateText)("hideButton", true)("planFilterModalEnabled", ctx_r124.planFilterModalEnabled);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_14_ng_container_1_Template, 3, 8, "ng-container", 13);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r17.isMedigapEnabled && ctx_r17.currentTabIsMedigap && ctx_r17.planFilterModalEnabled);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_15_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 12)(2, "h4", 14);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "vnext-checkbox-group", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r127 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c1$e, !ctx_r127.isMobile));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r127.starRatingLabelText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r127.starRatingControlName);
    i0.ɵɵproperty("items", ctx_r127.starRatingFilterOptions)("parentId", ctx_r127.starRatingControlName)("showTooltipIcon", true)("enablePrimaryColor", true)("enableNoteStyle", false);
} }
function PlanFilterModalItemsComponent_ng_container_6_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterModalItemsComponent_ng_container_6_ng_container_15_ng_container_1_Template, 5, 10, "ng-container", 13);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.starRatingEnabled && ctx_r18.planFilterModalEnabled);
} }
function PlanFilterModalItemsComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0)(1, 9);
    i0.ɵɵtemplate(2, PlanFilterModalItemsComponent_ng_container_6_ng_container_2_Template, 2, 1, "ng-container", 10);
    i0.ɵɵtemplate(3, PlanFilterModalItemsComponent_ng_container_6_ng_container_3_Template, 3, 3, "ng-container", 10);
    i0.ɵɵtemplate(4, PlanFilterModalItemsComponent_ng_container_6_ng_container_4_Template, 3, 3, "ng-container", 10);
    i0.ɵɵtemplate(5, PlanFilterModalItemsComponent_ng_container_6_ng_container_5_Template, 3, 3, "ng-container", 10);
    i0.ɵɵtemplate(6, PlanFilterModalItemsComponent_ng_container_6_ng_container_6_Template, 3, 3, "ng-container", 10);
    i0.ɵɵtemplate(7, PlanFilterModalItemsComponent_ng_container_6_ng_container_7_Template, 3, 3, "ng-container", 10);
    i0.ɵɵtemplate(8, PlanFilterModalItemsComponent_ng_container_6_ng_container_8_Template, 4, 8, "ng-container", 10);
    i0.ɵɵtemplate(9, PlanFilterModalItemsComponent_ng_container_6_ng_container_9_Template, 3, 3, "ng-container", 10);
    i0.ɵɵtemplate(10, PlanFilterModalItemsComponent_ng_container_6_ng_container_10_Template, 2, 1, "ng-container", 10);
    i0.ɵɵtemplate(11, PlanFilterModalItemsComponent_ng_container_6_ng_container_11_Template, 3, 3, "ng-container", 10);
    i0.ɵɵtemplate(12, PlanFilterModalItemsComponent_ng_container_6_ng_container_12_Template, 3, 3, "ng-container", 10);
    i0.ɵɵtemplate(13, PlanFilterModalItemsComponent_ng_container_6_ng_container_13_Template, 3, 3, "ng-container", 10);
    i0.ɵɵtemplate(14, PlanFilterModalItemsComponent_ng_container_6_ng_container_14_Template, 2, 1, "ng-container", 10);
    i0.ɵɵtemplate(15, PlanFilterModalItemsComponent_ng_container_6_ng_container_15_Template, 2, 1, "ng-container", 10);
    i0.ɵɵelementContainerEnd()();
} if (rf & 2) {
    const filter_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", filter_r4.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.snpBaseTypeLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.providersNpiHeaderText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.licensingHeaderText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.medicalDeductibleHeaderText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.maximumOutOfPocketCostHeaderText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.drugDeductibleHeaderText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.premiumHeaderText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.addOnFilterHeaderText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.additionalSavingsHeaderText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.filterCarrierText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.planSubTypeLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.planTypeLabel);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.medsupPlanSubTypeHeaderText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r1.starRatingLabelText);
} }
const _c3$3 = function (a0, a1) { return { "col-12 px-0": a0, "cursor-pointer": a1 }; };
const _c4$1 = function (a0) { return { "d-none": a0 }; };
const _c5$1 = function (a0) { return { "Spa_Style_Link mr-4": a0 }; };
const _c6$1 = function (a0) { return { "row filter-container": a0 }; };
class PlanFilterModalItemsComponent {
    constructor(filterService, cdr, planFilterItemsFacade, inputResetContextService, filterContextService, plansService, snpService, analyticsService) {
        this.filterService = filterService;
        this.cdr = cdr;
        this.planFilterItemsFacade = planFilterItemsFacade;
        this.inputResetContextService = inputResetContextService;
        this.filterContextService = filterContextService;
        this.plansService = plansService;
        this.snpService = snpService;
        this.analyticsService = analyticsService;
        this.planFilterModalEnabled = false;
        this.isMobile = false;
        this.closeModalEvent = new EventEmitter();
        this.planSubTypeChanged = new EventEmitter();
        this.toggleSNPPlanChangeEvent = new EventEmitter();
        this.currentTabIsMedigap = false;
        this.currentTabIsPDP = false;
        this.currentTabIsHospitalCare = false;
        this.highlightedDSNPCodes = [];
        this.clearSnpFilters = false;
        this.allPlanBenefitFilter = {
            modelDrugPrograms: [],
            defaultPlanBenefits: []
        };
        this.subscriptions = new Subscription();
        this.filterList$ = new BehaviorSubject([]);
        // Obtained from "tabTypes" and "filters" properties on each tab in "Spa_PlanList_Tabs_Data"
        this.currentTabFiltersSubject$ = new BehaviorSubject([]);
        this.currentTabFilters$ = this.currentTabFiltersSubject$.asObservable();
        // Selected by the user
        this.hasCurrentTabSelectedFilters$ = this.currentTabFilters$.pipe(switchMap(currentTabFilters => this.filterService.hasSelectedFilters$(currentTabFilters, false)));
    }
    ngOnChanges(changes) {
        if (changes?.currentTab && !_isEqual(changes.currentTab.currentValue, changes.currentTab.previousValue)) {
            this.currentTabFiltersSubject$.next(this.currentTab.filters);
            this.currentTabIsMedigap = this.isActiveTab(PlanTypeAbbreviation.MEDIGAP);
            this.currentTabIsPDP = this.isActiveTab(PlanTypeAbbreviation.PDP);
            this.currentTabIsHospitalCare = this.isActiveTab(PlanTypeAbbreviation.HC);
            this.currentTabIsDental = this.isActiveTab(PlanTypeAbbreviation.DENTAL);
            this.currentTabIsVision = this.isActiveTab(PlanTypeAbbreviation.VISION);
            this.displayPlanSubTypes = !(this.currentTabIsDental || this.currentTabIsVision);
            this.displayDentalVisionFilters = this.currentTabIsDental || this.currentTabIsVision;
        }
        if (changes.planFiltersSortOptions?.currentValue &&
            !_isEqual(changes.planFiltersSortOptions?.previousValue, changes.planFiltersSortOptions?.currentValue)) {
            this.planFiltersSortOptions = this.planFiltersSortOptions?.sort((a, b) => a.ordinal - b.ordinal);
        }
        if (this.planFilterModalEnabled &&
            changes.snpVisibility?.firstChange === false &&
            !_isEqual(changes.snpVisibility.currentValue, changes.snpVisibility.previousValue) &&
            !changes.snpVisibility.currentValue) {
            this.snpService.setAllSNPTypesVisibility(true);
        }
    }
    ngOnInit() {
        this.filterForm = this.planFilterItemsFacade.createFilterForm();
        this.filterFormTypes = this.planFilterItemsFacade.getFormFilterTypes();
        this.showSellablePlanFilter$ = this.planFilterItemsFacade.getShowSellablePlanFilter$();
        this.carriers$ = this.planFilterItemsFacade.getCarriersControls$(this.filterList$);
        this.subscriptions.add(this.hasCurrentTabSelectedFilters$.subscribe({
            next: hasCurrentTabSelectedFilters => {
                if (!hasCurrentTabSelectedFilters && (this.filterForm.dirty || this.filterForm.touched)) {
                    this.uncheckAllFilters();
                    this.snpVisibility = false;
                    this.cdr.markForCheck();
                }
            }
        }));
        this.subscriptions.add(this.filterContextService
            .getFilterHighlights$()
            .pipe(filter((filterValues) => filterValues?.filterName === FilterContextNames.DSNP), delay(0))
            .subscribe({
            next: (filterValues) => {
                this.highlightedDSNPCodes = filterValues.filterValues ?? [];
                if (this.highlightedDSNPCodes.some(code => Object.values(DSNPCodes).includes(code))) {
                    document.querySelector(`#dsnpMobileFilterContainer`)?.scrollIntoView(true);
                }
                this.cdr.markForCheck();
            }
        }));
        if (this.defaultPlanBenefitFiltersEnabled) {
            this.planBenefits$ = this.planFilterItemsFacade.getPlanBenefitsControls$(this.filterList$, this.defaultPlanBenefitFilters);
            this.subscriptions.add(this.planBenefits$.subscribe({
                next: defaultPlanBenefits => {
                    this.allPlanBenefitFilter.defaultPlanBenefits = defaultPlanBenefits;
                    this.cdr.markForCheck();
                }
            }));
            if (this.insulinSavingsEnabled) {
                this.modelDrugPrograms$ = this.planFilterItemsFacade.getModelDrugProgramControls$(this.filterList$);
                this.subscriptions.add(this.modelDrugPrograms$.subscribe({
                    next: modelDrugPrograms => {
                        this.allPlanBenefitFilter.modelDrugPrograms = modelDrugPrograms;
                        this.cdr.markForCheck();
                    }
                }));
                this.extraDataControlName = this.planFilterItemsFacade.getExtraDataControlName();
            }
        }
        this.planSubTypes$ = this.planFilterItemsFacade.getPlanSubTypeControls$(this.filterList$);
        this.ancillaryPlanTypes$ = this.planFilterItemsFacade.getAncillaryPlanTypeControls$(this.filterList$);
        this.planSellable$ = this.planFilterItemsFacade.getPlanSellableControls$(this.filterList$);
        this.snpBaseTypes$ = this.planFilterItemsFacade.getSNPBaseControls$(this.filterList$);
        this.cSNPSubTypes$ = this.planFilterItemsFacade.getCSNPBaseControls$(this.filterList$).pipe(switchMap(cSNPBaseTypes => {
            this.cSNPBaseTypes = cSNPBaseTypes;
            if (cSNPBaseTypes?.length > 0) {
                return this.planFilterItemsFacade.getSNPSubControls$(this.filterList$, SNP_CATEGORY_FILTER_TYPES.ID_IS_CSNP, cSNPBaseTypes[0].value);
            }
            return of([]);
        }));
        this.dSNPSubTypes$ = this.planFilterItemsFacade.getDSNPBaseControls$(this.filterList$).pipe(switchMap(dSNPBaseTypes => {
            this.dSNPBaseTypes = dSNPBaseTypes;
            if (dSNPBaseTypes?.length > 0 && this.filterDSNPMedicaidCodesEnabled) {
                return this.planFilterItemsFacade.getDSNPSubControls$(this.filterList$);
            }
            return of([]);
        }));
        this.hideAllSnpType = {
            label: this.snpLabelText,
            value: 1,
            disabled: false,
            initiallyChecked: this.filteredPlansHasSNPPlans && !this.snpVisibility && !this.areAllSNPTypesVisible(this.snpService.getSNPVisibility())
        };
        this.iSNPSubTypes$ = this.planFilterItemsFacade.getISNPBaseControls$(this.filterList$).pipe(switchMap(iSNPBaseTypes => {
            this.iSNPBaseTypes = iSNPBaseTypes;
            if (iSNPBaseTypes?.length > 0) {
                return this.planFilterItemsFacade.getSNPSubControls$(this.filterList$, SNP_CATEGORY_FILTER_TYPES.ID_IS_ISNP, iSNPBaseTypes[0].value);
            }
            return of([]);
        }));
        this.subscriptions.add(this.cSNPSubTypes$.subscribe({
            next: cSNPSubTypes => {
                this.cSNPSubTypes = cSNPSubTypes;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.iSNPSubTypes$.subscribe({
            next: iSNPSubTypes => {
                this.iSNPSubTypes = iSNPSubTypes;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.dSNPSubTypes$.subscribe({
            next: dSNPSubTypes => {
                this.dSNPSubTypes = dSNPSubTypes;
                this.cdr.markForCheck();
            }
        }));
        this.ridersOptions$ = this.planFilterItemsFacade.getRidersControls$(this.filterList$);
        this.providerNpiOptions$ = this.planFilterItemsFacade.getProvidersNpiControls$(this.filterList$, this.allInNetworkLocationsEnabled);
        this.carriersControlName = this.planFilterItemsFacade.getCarriersControlName();
        this.planBenefitsControlName = this.planFilterItemsFacade.getplanBenefitsControlName();
        this.subTypesControlName = this.planFilterItemsFacade.getSubTypesControlName();
        this.ancillaryPlanTypeControlName = this.planFilterItemsFacade.getAncillaryPlanTypeControlName();
        this.snpBaseTypesControlName = this.planFilterItemsFacade.getSnpBaseTypesControlName();
        this.dsnpSubTypesControlName = this.planFilterItemsFacade.getDSNPSubTypesControlName();
        this.sellableControlName = this.planFilterItemsFacade.getSellableControlName();
        this.snpSubTypesControlName = this.planFilterItemsFacade.getSNPSubTypesControlName();
        this.ridersPlanSubtypeName = this.planFilterItemsFacade.getRidersPlanSubtypeName();
        this.providersNpiName = this.planFilterItemsFacade.getProvidersNpiName();
        this.starRatingControlName = this.planFilterItemsFacade.getStarRatingControlName();
        this.medicalDeductible$ = this.planFilterItemsFacade.getCostFilterControl$(this.filterList$, FilterKeyType.PLAN_MEDICAL_DEDUCTIBLE);
        this.medicalDeductibleControlName = this.planFilterItemsFacade.getCostFilterControlName(FilterKeyType.PLAN_MEDICAL_DEDUCTIBLE);
        this.maximumOutOfPocketCost$ = this.planFilterItemsFacade.getCostFilterControl$(this.filterList$, FilterKeyType.PLAN_MAXIMUM_OUT_POCKET_COST);
        this.maximumOutOfPocketCostControlName = this.planFilterItemsFacade.getCostFilterControlName(FilterKeyType.PLAN_MAXIMUM_OUT_POCKET_COST);
        this.drugDeductible$ = this.planFilterItemsFacade.getCostFilterControl$(this.filterList$, FilterKeyType.PLAN_PHARMACY_DEDUCTIBLE);
        this.drugDeductibleControlName = this.planFilterItemsFacade.getCostFilterControlName(FilterKeyType.PLAN_PHARMACY_DEDUCTIBLE);
        this.medicalPremium$ = this.planFilterItemsFacade.getCostFilterControl$(this.filterList$, FilterKeyType.PLAN_PREMIUM);
        this.medicalPremiumControlName = this.planFilterItemsFacade.getCostFilterControlName(FilterKeyType.PLAN_PREMIUM);
        this.drugPremium$ = this.planFilterItemsFacade.getCostFilterControl$(this.filterList$, FilterKeyType.PLAN_DRUG_PREMIUM);
        this.drugPremiumControlName = this.planFilterItemsFacade.getCostFilterControlName(FilterKeyType.PLAN_DRUG_PREMIUM);
        this.filterService
            .getFiltersByFilterGroup$(this.currentTab.filters)
            .pipe(take(1))
            .subscribe({
            next: filters => {
                if (this.filterFormTypes && this.filterList$) {
                    const visibleFilters = filters.filter(({ visible }) => visible);
                    this.updateWholeForm(visibleFilters);
                    this.filterList$.next(visibleFilters);
                    this.cdr.markForCheck();
                }
            }
        });
        this.cdr.markForCheck();
    }
    onSnpFilterSelected(snpToggleFilter) {
        this.clearSnpFilters = false;
        this.filterForm.controls[snpToggleFilter?.snpBaseTypesControlName]?.setValue(snpToggleFilter?.snpSelectedItems || null);
        this.filterForm.controls[snpToggleFilter?.snpSubTypesControlName]?.setValue(snpToggleFilter?.subSnpSelectedItems);
        this.onSnpSubFilterSelected(snpToggleFilter?.snpBaseTypesControlName, snpToggleFilter?.snpSubTypesControlName);
    }
    areAllSNPTypesVisible(snpTypeVisibility) {
        return snpTypeVisibility && snpTypeVisibility.dSNP && snpTypeVisibility.cSNP && snpTypeVisibility.iSNP;
    }
    onFilterSelected(controlName) {
        if (controlName === FilterKeyType.PLAN_ISPUF) {
            this.carriers$ = this.planFilterItemsFacade.getCarriersControls$(this.filterList$);
        }
        this.plansService.setActiveTabPlanCountCheckEnabled(false);
        this.planFilterItemsFacade.onFilterSelected(this.filterForm, this.currentTab.filters, controlName, this.currentTab.tabTypes[0]);
    }
    onSnpSubFilterSelected(snpBaseFilterControlName, snpSubTypeControlName) {
        let subTypeValue;
        const baseTypeValue = this.filterForm.get(snpBaseFilterControlName).value;
        const values = [];
        if (snpSubTypeControlName) {
            subTypeValue = this.filterForm.get(snpSubTypeControlName).value;
            subTypeValue?.forEach(value => {
                if (value.syncOtherActiveFilter && !values.includes(value.syncOtherActiveFilter.values)) {
                    values.push(value.syncOtherActiveFilter.values);
                }
                else if (value?.name === FilterKeyType.DSNP_COVERAGE_CODES && !values.includes(SNPBaseType.dSNP)) {
                    return values.push(SNPBaseType.dSNP);
                }
            });
        }
        baseTypeValue?.forEach(value => {
            if (!values.includes(value)) {
                values.push(value);
            }
        });
        this.filterForm.patchValue({ [snpBaseFilterControlName]: values });
        if (!this.planFilterModalEnabled) {
            this.planFilterItemsFacade.onFilterSelected(this.filterForm, this.currentTab.filters, snpBaseFilterControlName, this.currentTab.tabTypes[0]);
        }
        if (snpSubTypeControlName) {
            this.filterForm.patchValue({ [snpSubTypeControlName]: subTypeValue });
            if (!this.planFilterModalEnabled) {
                this.planFilterItemsFacade.onFilterSelected(this.filterForm, this.currentTab.filters, snpSubTypeControlName, this.currentTab.tabTypes[0]);
            }
        }
    }
    onHideSNPPlanSelected(snpVisibility) {
        this.filterForm.controls[this.snpBaseTypesControlName]?.setValue(null);
        this.filterForm.controls[this.snpSubTypesControlName]?.setValue(null);
        this.snpVisibility = snpVisibility;
        this.toggleSNPPlanChangeEvent.emit(snpVisibility);
        this.cdr.markForCheck();
    }
    updateFilterForm(controlName, planFilter) {
        this.planFilterItemsFacade.updateFilterForm(this.filterForm, controlName, planFilter);
        this.cdr.markForCheck();
    }
    updateWholeForm(filters) {
        Object.keys(this.filterFormTypes).forEach(key => {
            this.updateFilterForm(key, filters.find(filter => filter.key === this.filterFormTypes[key]));
        });
    }
    updateFilters() {
        Object.keys(this.filterForm.controls).forEach(controlName => {
            if (controlName !== this.extraDataControlName || (this.defaultPlanBenefitFiltersEnabled && this.insulinSavingsEnabled)) {
                this.onFilterSelected(controlName);
            }
        });
    }
    uncheckAllFilters() {
        // Reset the checkbox on click of clear all on mobile but don't clear from the store unless user clicked on apply button
        Object.entries(this.filterForm.controls).forEach(([controlName, control]) => {
            if (controlName !== this.extraDataControlName || (this.defaultPlanBenefitFiltersEnabled && this.insulinSavingsEnabled)) {
                control.setValue([]);
                this.inputResetContextService.clearInputById(controlName);
                this.onFilterSelected(controlName);
            }
        });
        this.toggleSNPPlanChangeEvent.emit(true);
        this.clearSnpFilters = true;
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_FILTERS_MODAL_CLEAR_ALL);
    }
    trackByFilterName(index, sortOption) {
        return sortOption?.name;
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        this.filterList$.complete();
    }
    isActiveTab(planTypeAbbreviation) {
        return this.currentTab.tabTypes.includes(planTypeAbbreviation);
    }
}
PlanFilterModalItemsComponent.ɵfac = function PlanFilterModalItemsComponent_Factory(t) { return new (t || PlanFilterModalItemsComponent)(i0.ɵɵdirectiveInject(i1.FilterService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlanFilterItemsFacade), i0.ɵɵdirectiveInject(i1.InputResetContextService), i0.ɵɵdirectiveInject(i1.FilterContextService), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(i1.SNPService), i0.ɵɵdirectiveInject(AnalyticsService)); };
PlanFilterModalItemsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanFilterModalItemsComponent, selectors: [["vnext-plan-filter-modal-items"]], inputs: { filterDayText: "filterDayText", selectFilterDayText: "selectFilterDayText", currentTab: "currentTab", clearAllText: "clearAllText", filterCarrierText: "filterCarrierText", planSubTypeLabel: "planSubTypeLabel", licensingHeaderText: "licensingHeaderText", snpBaseTypeLabel: "snpBaseTypeLabel", snpEnabled: "snpEnabled", additionalSavingsHeaderText: "additionalSavingsHeaderText", insulinSavingsEnabled: "insulinSavingsEnabled", filterDSNPMedicaidCodesEnabled: "filterDSNPMedicaidCodesEnabled", costFilterEnabled: "costFilterEnabled", medicalDeductibleHeaderText: "medicalDeductibleHeaderText", medicalDeductibleToolTipText: "medicalDeductibleToolTipText", maximumOutOfPocketCostHeaderText: "maximumOutOfPocketCostHeaderText", maximumOutOfPocketCostToolTipText: "maximumOutOfPocketCostToolTipText", drugDeductibleHeaderText: "drugDeductibleHeaderText", drugDeductibleToolTipText: "drugDeductibleToolTipText", premiumHeaderText: "premiumHeaderText", premiumToolTipText: "premiumToolTipText", defaultPlanBenefitFilters: "defaultPlanBenefitFilters", defaultPlanBenefitFiltersEnabled: "defaultPlanBenefitFiltersEnabled", addOnFilterHeaderText: "addOnFilterHeaderText", addOnFilterEnabled: "addOnFilterEnabled", addOnTooltipText: "addOnTooltipText", providersNpiHeaderText: "providersNpiHeaderText", providersNpiFilterEnabled: "providersNpiFilterEnabled", providersEnabled: "providersEnabled", providersNpiTooltipText: "providersNpiTooltipText", planTypeLabel: "planTypeLabel", allInNetworkLocationsEnabled: "allInNetworkLocationsEnabled", planFilterModalEnabled: "planFilterModalEnabled", isMobile: "isMobile", isMedigapEnabled: "isMedigapEnabled", medsupPlanSubTypeHeaderText: "medsupPlanSubTypeHeaderText", medsupPlanSubTypePlacholderText: "medsupPlanSubTypePlacholderText", medsupPlanSubTypeUpdateText: "medsupPlanSubTypeUpdateText", activeTabType: "activeTabType", snpLabelText: "snpLabelText", filteredPlansHasSNPPlans: "filteredPlansHasSNPPlans", isPlanListPage: "isPlanListPage", snpVisibility: "snpVisibility", starRatingEnabled: "starRatingEnabled", starRatingLabelText: "starRatingLabelText", starRatingFilterOptions: "starRatingFilterOptions", planFiltersSortOptions: "planFiltersSortOptions" }, outputs: { closeModalEvent: "closeModalEvent", planSubTypeChanged: "planSubTypeChanged", toggleSNPPlanChangeEvent: "toggleSNPPlanChangeEvent" }, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 19, consts: [[1, "float-right", "clear-all", 3, "ngClass"], [1, "triangle-arrow", 3, "ngClass"], ["tabindex", "0", 1, "action-button", 3, "ngClass", "click", "keyup.enter"], ["class", "action-button ml-3", 3, "click", 4, "ngIf"], [3, "formGroup", "ngClass"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "action-button", "ml-3", 3, "click"], [1, "fas", "fa-times", "Spa_Style_Primary_Color"], [1, "sr-only"], [3, "ngSwitch"], [4, "ngSwitchCase"], [3, "ngClass", 4, "ngIf"], [3, "ngClass"], [4, "ngIf"], [1, "Spa_Style_H4", "my-2"], [3, "activeTabType", "snpLabelText", "showCheckbox", "hideAllSnpType", "toggleSNPPlanChangeEvent"], [4, "ngIf", "ngIfElse"], ["defaultCSnpTypes", ""], [1, "plan-filter-items", 3, "snpItems", "snpBaseTypesControlName", "snpBaseTypesControlValue", "snpSubTypesControlName", "snpSubTypesControlValue", "snpSubItems", "snpVisibility", "planFilterModalEnabled", "showTooltipIcon", "enablePrimaryColor", "clearSnpFilters", "snpFilterSelectedEvent"], [1, "plan-filter-items", 3, "items", "formControlName", "parentId", "showTooltipIcon", "enablePrimaryColor", "change"], ["class", "sub-items", 4, "ngIf"], [1, "sub-items"], ["defaultDSnpTypes", ""], ["class", "sub-items", "id", "dsnpMobileFilterContainer", 4, "ngIf"], ["id", "dsnpMobileFilterContainer", 1, "sub-items"], [1, "plan-filter-items", 3, "highlightedItems", "items", "formControlName", "parentId", "showTooltipIcon", "enablePrimaryColor", "change"], ["defaultISnpTypes", ""], [1, "Spa_Style_H4", "ml-1", "my-2"], ["class", "pl-1", 4, "ngIf"], [1, "plan-filter-items", 3, "items", "formControlName", "parentId", "showTooltipUnderline", "enablePrimaryColor", "enableNoteStyle", "change"], [1, "pl-1"], ["providersNpiTooltip", ""], ["container", "body", "aria-label", "Show tooltip", 1, "fas", "Spa_Style_QuestionIcon", 3, "ngbTooltip"], ["navigationAdapter", "", 1, "Spa_Style_ToolTip", 3, "innerHtml"], [1, "plan-filter-items", 3, "items", "formControlName", "parentId", "showTooltipIcon", "enablePrimaryColor", "enableNoteStyle"], [1, "plan-filter-items", 3, "items", "formControlName", "parentId", "showTooltipUnderline", "enablePrimaryColor", "enableNoteStyle"], ["medicalDeductibleTooltip", ""], ["maximumOutOfPocketCostTooltip", ""], ["drugDeductibleTooltip", ""], ["premiumTooltip", ""], ["aria-label", "Show tooltip", "container", "body", 1, "fas", "fa-question-circle", "Spa_Style_Gray4_Color", 3, "ngbTooltip"], [1, "additional-savings-filter-wrapper", 3, "ngClass"], [1, "plan-filter-items", 3, "items", "formControlName", "parentId", "showTooltipIcon", "showTooltipUnderline", "enablePrimaryColor", "enableNoteStyle"], [1, "plan-filter-items", 3, "items", "formControlName", "parentId", "showTooltipIcon", "enablePrimaryColor", "noTranslateBlock", "enableNoteStyle"], [3, "headerText", "placeholder", "updatePlansText", "hideButton", "planFilterModalEnabled", "planSubTypeChanged"]], template: function PlanFilterModalItemsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵelementStart(2, "button", 2);
        i0.ɵɵlistener("click", function PlanFilterModalItemsComponent_Template_button_click_2_listener() { return ctx.uncheckAllFilters(); })("keyup.enter", function PlanFilterModalItemsComponent_Template_button_keyup_enter_2_listener() { return ctx.uncheckAllFilters(); });
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, PlanFilterModalItemsComponent_button_4_Template, 4, 0, "button", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "form", 4);
        i0.ɵɵtemplate(6, PlanFilterModalItemsComponent_ng_container_6_Template, 16, 15, "ng-container", 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(10, _c3$3, ctx.planFilterModalEnabled, !ctx.planFilterModalEnabled));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c4$1, !ctx.planFilterModalEnabled));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c5$1, ctx.planFilterModalEnabled));
        i0.ɵɵattribute("aria-label", ctx.clearAllText);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.clearAllText, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.planFilterModalEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.filterForm)("ngClass", i0.ɵɵpureFunction1(17, _c6$1, ctx.planFilterModalEnabled && !ctx.isMobile));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.planFiltersSortOptions)("ngForTrackBy", ctx.trackByFilterName);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, i4.ɵNgNoValidate, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, CheckboxGroupComponent, SNPToggleComponent, SNPCategoryToggleComponent, NavigationAdapterDirective, IconAriaAttributesDirective, i1$1.NgbTooltip, PlanSubTypeDropdownComponent, i1$2.AsyncPipe, SafePipe], styles: [".clear-all[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Primary_Link);font-family:montserrat_light;font-size:var(--Spa_Style_Small_Font);text-align:right;margin-top:6px}.sub-items[_ngcontent-%COMP%]{margin-left:15px}.dropdown-spacer[_ngcontent-%COMP%]{height:100px}.filter-container[_ngcontent-%COMP%]{scrollbar-width:thin}.disable-click[_ngcontent-%COMP%]{pointer-events:none;opacity:.7}.triangle-arrow[_ngcontent-%COMP%]{width:0;height:0px;border-left:14px solid transparent;border-right:14px solid transparent;border-bottom:14px solid var(--static-Spa_Style_Accent1);position:relative;top:-20px;left:5px}.triangle-arrow[_ngcontent-%COMP%]:after{content:\"\";position:absolute;top:2px;left:-18px;width:0;height:0;border-left:18px solid transparent;border-right:18px solid transparent;border-bottom:18px solid white}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanFilterModalItemsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-filter-modal-items', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div [ngClass]=\"{ 'col-12 px-0': planFilterModalEnabled, 'cursor-pointer': !planFilterModalEnabled }\" class=\"float-right clear-all\">\r\n  <div class=\"triangle-arrow\" [ngClass]=\"{ 'd-none': !planFilterModalEnabled }\"></div>\r\n  <button\r\n    class=\"action-button\"\r\n    (click)=\"uncheckAllFilters()\"\r\n    [attr.aria-label]=\"clearAllText\"\r\n    [ngClass]=\"{ 'Spa_Style_Link mr-4': planFilterModalEnabled }\"\r\n    tabindex=\"0\"\r\n    (keyup.enter)=\"uncheckAllFilters()\"\r\n  >\r\n    {{ clearAllText }}\r\n  </button>\r\n\r\n  <button *ngIf=\"planFilterModalEnabled\" class=\"action-button ml-3\" (click)=\"closeModalEvent.emit()\">\r\n    <i class=\"fas fa-times Spa_Style_Primary_Color\"></i>\r\n    <span class=\"sr-only\">Close</span>\r\n  </button>\r\n</div>\r\n\r\n<form [formGroup]=\"filterForm\" [ngClass]=\"{ 'row filter-container': planFilterModalEnabled && !isMobile }\">\r\n  <ng-container *ngFor=\"let filter of planFiltersSortOptions; trackBy: trackByFilterName\">\r\n    <ng-container [ngSwitch]=\"filter.name\">\r\n      <ng-container *ngSwitchCase=\"snpBaseTypeLabel\">\r\n        <div\r\n          *ngIf=\"snpEnabled\"\r\n          [ngClass]=\"{\r\n            'col-3': planFilterModalEnabled && (cSNPBaseTypes?.length || dSNPBaseTypes?.length || iSNPBaseTypes?.length) && !isMobile\r\n          }\"\r\n        >\r\n          <ng-container *ngIf=\"(snpBaseTypes$ | async).length || (!snpVisibility && planFilterModalEnabled)\">\r\n            <h4 class=\"Spa_Style_H4 my-2\">\r\n              {{ snpBaseTypeLabel }}\r\n            </h4>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"planFilterModalEnabled\">\r\n            <vnext-snp-toggle\r\n              [activeTabType]=\"activeTabType\"\r\n              [snpLabelText]=\"snpLabelText\"\r\n              [showCheckbox]=\"isPlanListPage\"\r\n              [hideAllSnpType]=\"hideAllSnpType\"\r\n              (toggleSNPPlanChangeEvent)=\"onHideSNPPlanSelected($event)\"\r\n            >\r\n            </vnext-snp-toggle>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"cSNPBaseTypes\">\r\n            <div *ngIf=\"planFilterModalEnabled; else defaultCSnpTypes\">\r\n              <vnext-snp-category-toggle\r\n                [snpItems]=\"cSNPBaseTypes\"\r\n                class=\"plan-filter-items\"\r\n                [snpBaseTypesControlName]=\"snpBaseTypesControlName\"\r\n                [snpBaseTypesControlValue]=\"filterForm?.controls?.[snpBaseTypesControlName]?.value\"\r\n                [snpSubTypesControlName]=\"snpSubTypesControlName\"\r\n                [snpSubTypesControlValue]=\"filterForm?.controls?.[snpSubTypesControlName]?.value\"\r\n                [snpSubItems]=\"cSNPSubTypes\"\r\n                [snpVisibility]=\"snpVisibility\"\r\n                [planFilterModalEnabled]=\"planFilterModalEnabled\"\r\n                [showTooltipIcon]=\"true\"\r\n                [enablePrimaryColor]=\"true\"\r\n                [clearSnpFilters]=\"clearSnpFilters\"\r\n                (snpFilterSelectedEvent)=\"onSnpFilterSelected($event)\"\r\n              ></vnext-snp-category-toggle>\r\n            </div>\r\n\r\n            <ng-template #defaultCSnpTypes>\r\n              <div *ngIf=\"cSNPBaseTypes.length >= 1\" [ngClass]=\"{ 'pl-1': planFilterModalEnabled, 'disable-click': !snpVisibility }\">\r\n                <vnext-checkbox-group\r\n                  [items]=\"cSNPBaseTypes\"\r\n                  class=\"plan-filter-items\"\r\n                  (change)=\"onSnpSubFilterSelected(snpBaseTypesControlName, snpSubTypesControlName)\"\r\n                  formControlName=\"{{ snpBaseTypesControlName }}\"\r\n                  [parentId]=\"snpBaseTypesControlName\"\r\n                  [showTooltipIcon]=\"true\"\r\n                  [enablePrimaryColor]=\"true\"\r\n                >\r\n                </vnext-checkbox-group>\r\n                <ng-container *ngIf=\"cSNPSubTypes\">\r\n                  <div *ngIf=\"cSNPSubTypes.length >= 1\" class=\"sub-items\">\r\n                    <vnext-checkbox-group\r\n                      [items]=\"cSNPSubTypes\"\r\n                      class=\"plan-filter-items\"\r\n                      (change)=\"onSnpSubFilterSelected(snpBaseTypesControlName, snpSubTypesControlName)\"\r\n                      formControlName=\"{{ snpSubTypesControlName }}\"\r\n                      [parentId]=\"snpSubTypesControlName\"\r\n                      [showTooltipIcon]=\"true\"\r\n                      [enablePrimaryColor]=\"true\"\r\n                    >\r\n                    </vnext-checkbox-group>\r\n                  </div>\r\n                </ng-container>\r\n              </div>\r\n            </ng-template>\r\n          </ng-container>\r\n\r\n          <ng-container *ngIf=\"dSNPBaseTypes\">\r\n            <div *ngIf=\"planFilterModalEnabled; else defaultDSnpTypes\">\r\n              <vnext-snp-category-toggle\r\n                [snpItems]=\"dSNPBaseTypes\"\r\n                class=\"plan-filter-items\"\r\n                [snpBaseTypesControlName]=\"snpBaseTypesControlName\"\r\n                [snpBaseTypesControlValue]=\"filterForm?.controls?.[snpBaseTypesControlName]?.value\"\r\n                [snpSubTypesControlName]=\"snpSubTypesControlName\"\r\n                [snpSubTypesControlValue]=\"filterForm?.controls?.[snpSubTypesControlName]?.value\"\r\n                [snpSubItems]=\"dSNPSubTypes\"\r\n                [snpVisibility]=\"snpVisibility\"\r\n                [planFilterModalEnabled]=\"planFilterModalEnabled\"\r\n                [showTooltipIcon]=\"true\"\r\n                [enablePrimaryColor]=\"true\"\r\n                [clearSnpFilters]=\"clearSnpFilters\"\r\n                (snpFilterSelectedEvent)=\"onSnpFilterSelected($event)\"\r\n              ></vnext-snp-category-toggle>\r\n            </div>\r\n            <ng-template #defaultDSnpTypes>\r\n              <div *ngIf=\"dSNPBaseTypes.length >= 1\" [ngClass]=\"{ 'pl-1': planFilterModalEnabled, 'disable-click': !snpVisibility }\">\r\n                <vnext-checkbox-group\r\n                  [items]=\"dSNPBaseTypes\"\r\n                  class=\"plan-filter-items\"\r\n                  (change)=\"onSnpSubFilterSelected(snpBaseTypesControlName)\"\r\n                  formControlName=\"{{ snpBaseTypesControlName }}\"\r\n                  [parentId]=\"snpBaseTypesControlName\"\r\n                  [showTooltipIcon]=\"true\"\r\n                  [enablePrimaryColor]=\"true\"\r\n                >\r\n                </vnext-checkbox-group>\r\n                <ng-container *ngIf=\"dSNPSubTypes\">\r\n                  <div *ngIf=\"dSNPSubTypes.length >= 1\" class=\"sub-items\" id=\"dsnpMobileFilterContainer\">\r\n                    <vnext-checkbox-group\r\n                      [highlightedItems]=\"highlightedDSNPCodes\"\r\n                      [items]=\"dSNPSubTypes\"\r\n                      class=\"plan-filter-items\"\r\n                      (change)=\"onSnpSubFilterSelected(snpBaseTypesControlName, dsnpSubTypesControlName)\"\r\n                      formControlName=\"{{ dsnpSubTypesControlName }}\"\r\n                      [parentId]=\"dsnpSubTypesControlName\"\r\n                      [showTooltipIcon]=\"true\"\r\n                      [enablePrimaryColor]=\"true\"\r\n                    >\r\n                    </vnext-checkbox-group>\r\n                  </div>\r\n                </ng-container>\r\n              </div>\r\n            </ng-template>\r\n          </ng-container>\r\n          <ng-container *ngIf=\"iSNPBaseTypes\"\r\n            ><div *ngIf=\"planFilterModalEnabled; else defaultISnpTypes\">\r\n              <vnext-snp-category-toggle\r\n                [snpItems]=\"iSNPBaseTypes\"\r\n                class=\"plan-filter-items\"\r\n                [snpBaseTypesControlName]=\"snpBaseTypesControlName\"\r\n                [snpBaseTypesControlValue]=\"filterForm?.controls?.[snpBaseTypesControlName]?.value\"\r\n                [snpSubTypesControlName]=\"snpSubTypesControlName\"\r\n                [snpSubTypesControlValue]=\"filterForm?.controls?.[snpSubTypesControlName]?.value\"\r\n                [snpSubItems]=\"iSNPSubTypes\"\r\n                [snpVisibility]=\"snpVisibility\"\r\n                [planFilterModalEnabled]=\"planFilterModalEnabled\"\r\n                [showTooltipIcon]=\"true\"\r\n                [enablePrimaryColor]=\"true\"\r\n                [clearSnpFilters]=\"clearSnpFilters\"\r\n                (snpFilterSelectedEvent)=\"onSnpFilterSelected($event)\"\r\n              ></vnext-snp-category-toggle>\r\n            </div>\r\n            <ng-template #defaultISnpTypes>\r\n              <div *ngIf=\"iSNPBaseTypes.length >= 1\" [ngClass]=\"{ 'pl-1': planFilterModalEnabled, 'disable-click': !snpVisibility }\">\r\n                <vnext-checkbox-group\r\n                  [items]=\"iSNPBaseTypes\"\r\n                  class=\"plan-filter-items\"\r\n                  (change)=\"onSnpSubFilterSelected(snpBaseTypesControlName, snpSubTypesControlName)\"\r\n                  formControlName=\"{{ snpBaseTypesControlName }}\"\r\n                  [parentId]=\"snpBaseTypesControlName\"\r\n                  [showTooltipIcon]=\"true\"\r\n                  [enablePrimaryColor]=\"true\"\r\n                >\r\n                </vnext-checkbox-group>\r\n                <ng-container *ngIf=\"iSNPSubTypes\">\r\n                  <div *ngIf=\"iSNPSubTypes.length >= 1\" class=\"sub-items\">\r\n                    <vnext-checkbox-group\r\n                      [items]=\"iSNPSubTypes\"\r\n                      class=\"plan-filter-items\"\r\n                      (change)=\"onSnpSubFilterSelected(snpBaseTypesControlName, snpSubTypesControlName)\"\r\n                      formControlName=\"{{ snpSubTypesControlName }}\"\r\n                      [parentId]=\"snpSubTypesControlName\"\r\n                      [showTooltipIcon]=\"true\"\r\n                      [enablePrimaryColor]=\"true\"\r\n                    >\r\n                    </vnext-checkbox-group>\r\n                  </div>\r\n                </ng-container>\r\n              </div>\r\n            </ng-template>\r\n          </ng-container>\r\n        </div>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"providersNpiHeaderText\">\r\n        <ng-container *ngIf=\"providersNpiFilterEnabled && providersEnabled && providerNpiOptions$ | async as providerNpiOptions\">\r\n          <div *ngIf=\"providerNpiOptions.length\" [ngClass]=\"{ 'col-3': planFilterModalEnabled && !isMobile }\">\r\n            <h4 class=\"Spa_Style_H4 ml-1 my-2\">\r\n              {{ providersNpiHeaderText }}\r\n              <span class=\"pl-1\" *ngIf=\"medicalDeductibleToolTipText\">\r\n                <ng-template #providersNpiTooltip>\r\n                  <div [innerHtml]=\"providersNpiTooltipText | safe : 'html'\" class=\"Spa_Style_ToolTip\" navigationAdapter></div>\r\n                </ng-template>\r\n                <i class=\"fas Spa_Style_QuestionIcon\" container=\"body\" [ngbTooltip]=\"providersNpiTooltip\" aria-label=\"Show tooltip\"></i>\r\n              </span>\r\n            </h4>\r\n            <vnext-checkbox-group\r\n              [items]=\"providerNpiOptions\"\r\n              class=\"plan-filter-items\"\r\n              (change)=\"onFilterSelected(providersNpiName)\"\r\n              formControlName=\"{{ providersNpiName }}\"\r\n              [parentId]=\"providersNpiName\"\r\n              [showTooltipUnderline]=\"true\"\r\n              [enablePrimaryColor]=\"true\"\r\n              [enableNoteStyle]=\"false\"\r\n            >\r\n            </vnext-checkbox-group>\r\n          </div>\r\n        </ng-container>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"licensingHeaderText\">\r\n        <div *ngIf=\"(showSellablePlanFilter$ | async) && !currentTabIsMedigap\" [ngClass]=\"{ 'col-3': planFilterModalEnabled && !isMobile }\">\r\n          <h4 class=\"Spa_Style_H4 my-2\">\r\n            {{ licensingHeaderText }}\r\n          </h4>\r\n          <vnext-checkbox-group\r\n            [items]=\"planSellable$ | async\"\r\n            class=\"plan-filter-items\"\r\n            formControlName=\"{{ sellableControlName }}\"\r\n            [parentId]=\"sellableControlName\"\r\n            [showTooltipIcon]=\"true\"\r\n            [enablePrimaryColor]=\"true\"\r\n            [enableNoteStyle]=\"false\"\r\n          >\r\n          </vnext-checkbox-group>\r\n        </div>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"medicalDeductibleHeaderText\">\r\n        <ng-container *ngIf=\"costFilterEnabled && !currentTabIsPDP && medicalDeductible$ | async as medicalDeductible\">\r\n          <div *ngIf=\"medicalDeductible.length\" [ngClass]=\"{ 'col-3': planFilterModalEnabled && !isMobile }\">\r\n            <h4 class=\"Spa_Style_H4 ml-1 my-2\">\r\n              {{ medicalDeductibleHeaderText }}\r\n              <span class=\"pl-1\" *ngIf=\"medicalDeductibleToolTipText\">\r\n                <ng-template #medicalDeductibleTooltip>\r\n                  <div [innerHtml]=\"medicalDeductibleToolTipText | safe : 'html'\" class=\"Spa_Style_ToolTip\" navigationAdapter></div>\r\n                </ng-template>\r\n                <i\r\n                  class=\"fas Spa_Style_QuestionIcon\"\r\n                  container=\"body\"\r\n                  [ngbTooltip]=\"medicalDeductibleTooltip\"\r\n                  aria-label=\"Show tooltip\"\r\n                ></i>\r\n              </span>\r\n            </h4>\r\n            <vnext-checkbox-group\r\n              [items]=\"medicalDeductible\"\r\n              class=\"plan-filter-items\"\r\n              formControlName=\"{{ medicalDeductibleControlName }}\"\r\n              [parentId]=\"medicalDeductibleControlName\"\r\n              [showTooltipUnderline]=\"true\"\r\n              [enablePrimaryColor]=\"true\"\r\n              [enableNoteStyle]=\"false\"\r\n            >\r\n            </vnext-checkbox-group>\r\n          </div>\r\n        </ng-container>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"maximumOutOfPocketCostHeaderText\">\r\n        <ng-container *ngIf=\"costFilterEnabled && !currentTabIsPDP && maximumOutOfPocketCost$ | async as maximumOutOfPocketCost\">\r\n          <div *ngIf=\"maximumOutOfPocketCost.length\" [ngClass]=\"{ 'col-3': planFilterModalEnabled && !isMobile }\">\r\n            <h4 class=\"Spa_Style_H4 ml-1 my-2\">\r\n              {{ maximumOutOfPocketCostHeaderText }}\r\n              <span class=\"pl-1\" *ngIf=\"maximumOutOfPocketCostToolTipText\">\r\n                <ng-template #maximumOutOfPocketCostTooltip>\r\n                  <div [innerHtml]=\"maximumOutOfPocketCostToolTipText | safe : 'html'\" class=\"Spa_Style_ToolTip\" navigationAdapter></div>\r\n                </ng-template>\r\n                <i\r\n                  class=\"fas Spa_Style_QuestionIcon\"\r\n                  container=\"body\"\r\n                  [ngbTooltip]=\"maximumOutOfPocketCostTooltip\"\r\n                  aria-label=\"Show tooltip\"\r\n                ></i>\r\n              </span>\r\n            </h4>\r\n            <vnext-checkbox-group\r\n              [items]=\"maximumOutOfPocketCost\"\r\n              class=\"plan-filter-items\"\r\n              formControlName=\"{{ maximumOutOfPocketCostControlName }}\"\r\n              [parentId]=\"maximumOutOfPocketCostControlName\"\r\n              [showTooltipUnderline]=\"true\"\r\n              [enablePrimaryColor]=\"true\"\r\n              [enableNoteStyle]=\"false\"\r\n            >\r\n            </vnext-checkbox-group>\r\n          </div>\r\n        </ng-container>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"drugDeductibleHeaderText\">\r\n        <ng-container *ngIf=\"costFilterEnabled && currentTabIsPDP && drugDeductible$ | async as drugDeductible\">\r\n          <div *ngIf=\"drugDeductible.length\" [ngClass]=\"{ 'col-3': planFilterModalEnabled && !isMobile }\">\r\n            <h4 class=\"Spa_Style_H4 ml-1 my-2\">\r\n              {{ drugDeductibleHeaderText }}\r\n              <span class=\"pl-1\" *ngIf=\"drugDeductibleToolTipText\">\r\n                <ng-template #drugDeductibleTooltip>\r\n                  <div [innerHtml]=\"drugDeductibleToolTipText | safe : 'html'\" class=\"Spa_Style_ToolTip\" navigationAdapter></div>\r\n                </ng-template>\r\n                <i class=\"fas Spa_Style_QuestionIcon\" container=\"body\" [ngbTooltip]=\"drugDeductibleTooltip\" aria-label=\"Show tooltip\"></i>\r\n              </span>\r\n            </h4>\r\n            <vnext-checkbox-group\r\n              [items]=\"drugDeductible\"\r\n              class=\"plan-filter-items\"\r\n              formControlName=\"{{ drugDeductibleControlName }}\"\r\n              [parentId]=\"drugDeductibleControlName\"\r\n              [showTooltipUnderline]=\"true\"\r\n              [enablePrimaryColor]=\"true\"\r\n              [enableNoteStyle]=\"false\"\r\n            >\r\n            </vnext-checkbox-group>\r\n          </div>\r\n        </ng-container>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"premiumHeaderText\">\r\n        <ng-container\r\n          *ngIf=\"costFilterEnabled && { medicalPremium: medicalPremium$ | async, drugPremium: drugPremium$ | async } as premium\"\r\n        >\r\n          <div\r\n            *ngIf=\"(!currentTabIsPDP && premium.medicalPremium?.length) || (currentTabIsPDP && premium.drugPremium?.length)\"\r\n            [ngClass]=\"{ 'col-3': planFilterModalEnabled && !isMobile }\"\r\n          >\r\n            <h4 class=\"Spa_Style_H4 ml-1 my-2\">\r\n              {{ premiumHeaderText }}\r\n              <span class=\"pl-1\" *ngIf=\"premiumToolTipText\">\r\n                <ng-template #premiumTooltip>\r\n                  <div [innerHtml]=\"premiumToolTipText | safe : 'html'\" class=\"Spa_Style_ToolTip\" navigationAdapter></div>\r\n                </ng-template>\r\n                <i class=\"fas Spa_Style_QuestionIcon\" container=\"body\" [ngbTooltip]=\"premiumTooltip\" aria-label=\"Show tooltip\"></i>\r\n              </span>\r\n            </h4>\r\n            <div *ngIf=\"currentTabIsPDP && premium.drugPremium?.length\">\r\n              <vnext-checkbox-group\r\n                [items]=\"premium.drugPremium\"\r\n                class=\"plan-filter-items\"\r\n                formControlName=\"{{ drugPremiumControlName }}\"\r\n                [parentId]=\"drugPremiumControlName\"\r\n                [showTooltipUnderline]=\"true\"\r\n                [enablePrimaryColor]=\"true\"\r\n                [enableNoteStyle]=\"false\"\r\n              >\r\n              </vnext-checkbox-group>\r\n            </div>\r\n            <div *ngIf=\"!currentTabIsPDP && premium.medicalPremium?.length\">\r\n              <vnext-checkbox-group\r\n                [items]=\"premium.medicalPremium\"\r\n                class=\"plan-filter-items\"\r\n                formControlName=\"{{ medicalPremiumControlName }}\"\r\n                [parentId]=\"medicalPremiumControlName\"\r\n                [showTooltipUnderline]=\"true\"\r\n                [enablePrimaryColor]=\"true\"\r\n                [enableNoteStyle]=\"false\"\r\n              >\r\n              </vnext-checkbox-group>\r\n            </div>\r\n          </div>\r\n        </ng-container>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"addOnFilterHeaderText\">\r\n        <ng-container *ngIf=\"addOnFilterEnabled && ridersOptions$ | async as ridersOptions\">\r\n          <div *ngIf=\"ridersOptions.length\" [ngClass]=\"{ 'col-3': planFilterModalEnabled && !isMobile }\">\r\n            <h4 class=\"Spa_Style_H4 ml-1 my-2\">\r\n              {{ addOnFilterHeaderText }}\r\n              <i\r\n                class=\"fas fa-question-circle Spa_Style_Gray4_Color\"\r\n                aria-label=\"Show tooltip\"\r\n                container=\"body\"\r\n                [ngbTooltip]=\"addOnTooltipText\"\r\n              ></i>\r\n            </h4>\r\n            <vnext-checkbox-group\r\n              [items]=\"ridersOptions\"\r\n              class=\"plan-filter-items\"\r\n              formControlName=\"{{ ridersPlanSubtypeName }}\"\r\n              [parentId]=\"ridersPlanSubtypeName\"\r\n              [showTooltipIcon]=\"true\"\r\n              [enablePrimaryColor]=\"true\"\r\n              [enableNoteStyle]=\"false\"\r\n            >\r\n            </vnext-checkbox-group>\r\n          </div>\r\n        </ng-container>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"additionalSavingsHeaderText\">\r\n        <ng-container\r\n          *ngIf=\"\r\n            defaultPlanBenefitFiltersEnabled &&\r\n            (allPlanBenefitFilter.modelDrugPrograms?.length || allPlanBenefitFilter.defaultPlanBenefits?.length)\r\n          \"\r\n        >\r\n          <div class=\"additional-savings-filter-wrapper\" [ngClass]=\"{ 'col-3': planFilterModalEnabled && !isMobile }\">\r\n            <h4 class=\"Spa_Style_H4 my-2\">{{ additionalSavingsHeaderText }}</h4>\r\n            <div *ngIf=\"insulinSavingsEnabled && allPlanBenefitFilter.modelDrugPrograms?.length\">\r\n              <vnext-checkbox-group\r\n                [items]=\"allPlanBenefitFilter.modelDrugPrograms\"\r\n                class=\"plan-filter-items\"\r\n                formControlName=\"{{ extraDataControlName }}\"\r\n                [parentId]=\"extraDataControlName\"\r\n                [showTooltipIcon]=\"true\"\r\n                [showTooltipUnderline]=\"true\"\r\n                [enablePrimaryColor]=\"true\"\r\n                [enableNoteStyle]=\"false\"\r\n              >\r\n              </vnext-checkbox-group>\r\n            </div>\r\n            <div *ngIf=\"allPlanBenefitFilter.defaultPlanBenefits?.length\">\r\n              <vnext-checkbox-group\r\n                [items]=\"allPlanBenefitFilter.defaultPlanBenefits\"\r\n                class=\"plan-filter-items\"\r\n                formControlName=\"{{ planBenefitsControlName }}\"\r\n                [parentId]=\"planBenefitsControlName\"\r\n                [showTooltipIcon]=\"true\"\r\n                [showTooltipUnderline]=\"true\"\r\n                [enablePrimaryColor]=\"true\"\r\n                [enableNoteStyle]=\"false\"\r\n              >\r\n              </vnext-checkbox-group>\r\n            </div>\r\n          </div>\r\n        </ng-container>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"filterCarrierText\">\r\n        <ng-container *ngIf=\"carriers$ | async as carriers\">\r\n          <div *ngIf=\"carriers.length > 1\" [ngClass]=\"{ 'col-3': planFilterModalEnabled && !isMobile }\">\r\n            <h4 class=\"Spa_Style_H4 my-2\">\r\n              {{ filterCarrierText }}\r\n            </h4>\r\n            <vnext-checkbox-group\r\n              [items]=\"carriers\"\r\n              class=\"plan-filter-items\"\r\n              formControlName=\"{{ carriersControlName }}\"\r\n              [parentId]=\"carriersControlName\"\r\n              [showTooltipIcon]=\"true\"\r\n              [enablePrimaryColor]=\"true\"\r\n              [noTranslateBlock]=\"true\"\r\n              [enableNoteStyle]=\"false\"\r\n            >\r\n            </vnext-checkbox-group>\r\n          </div>\r\n        </ng-container>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"planSubTypeLabel\">\r\n        <ng-container *ngIf=\"displayPlanSubTypes && planSubTypes$ | async as planSubTypes\">\r\n          <div *ngIf=\"planSubTypes.length > 1\" [ngClass]=\"{ 'col-3': planFilterModalEnabled && !isMobile }\">\r\n            <h4 class=\"Spa_Style_H4 my-2\">\r\n              {{ planSubTypeLabel }}\r\n            </h4>\r\n            <vnext-checkbox-group\r\n              [items]=\"planSubTypes\"\r\n              class=\"plan-filter-items\"\r\n              formControlName=\"{{ subTypesControlName }}\"\r\n              [parentId]=\"subTypesControlName\"\r\n              [showTooltipIcon]=\"true\"\r\n              [enablePrimaryColor]=\"true\"\r\n              [enableNoteStyle]=\"false\"\r\n            >\r\n            </vnext-checkbox-group>\r\n          </div>\r\n        </ng-container>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"planTypeLabel\">\r\n        <ng-container *ngIf=\"displayDentalVisionFilters && ancillaryPlanTypes$ | async as ancillaryPlanTypes\">\r\n          <div *ngIf=\"ancillaryPlanTypes.length > 1\" [ngClass]=\"{ 'col-3': planFilterModalEnabled && !isMobile }\">\r\n            <h4 class=\"Spa_Style_H4 my-2\">\r\n              {{ planTypeLabel }}\r\n            </h4>\r\n            <vnext-checkbox-group\r\n              [items]=\"ancillaryPlanTypes\"\r\n              class=\"plan-filter-items\"\r\n              formControlName=\"{{ ancillaryPlanTypeControlName }}\"\r\n              [parentId]=\"ancillaryPlanTypeControlName\"\r\n              [showTooltipIcon]=\"true\"\r\n              [enablePrimaryColor]=\"true\"\r\n              [enableNoteStyle]=\"false\"\r\n            >\r\n            </vnext-checkbox-group>\r\n          </div>\r\n        </ng-container>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"medsupPlanSubTypeHeaderText\">\r\n        <ng-container *ngIf=\"isMedigapEnabled && currentTabIsMedigap && planFilterModalEnabled\">\r\n          <div [ngClass]=\"{ 'col-3': !isMobile }\">\r\n            <vnext-plan-sub-type-dropdown\r\n              [headerText]=\"medsupPlanSubTypeHeaderText\"\r\n              [placeholder]=\"medsupPlanSubTypePlacholderText\"\r\n              [updatePlansText]=\"medsupPlanSubTypeUpdateText\"\r\n              [hideButton]=\"true\"\r\n              [planFilterModalEnabled]=\"planFilterModalEnabled\"\r\n              (planSubTypeChanged)=\"planSubTypeChanged.emit($event)\"\r\n            >\r\n            </vnext-plan-sub-type-dropdown>\r\n          </div>\r\n        </ng-container>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"starRatingLabelText\">\r\n        <ng-container *ngIf=\"starRatingEnabled && planFilterModalEnabled\">\r\n          <div [ngClass]=\"{ 'col-3': !isMobile }\">\r\n            <h4 class=\"Spa_Style_H4 my-2\">\r\n              {{ starRatingLabelText }}\r\n            </h4>\r\n            <vnext-checkbox-group\r\n              [items]=\"starRatingFilterOptions\"\r\n              class=\"plan-filter-items\"\r\n              formControlName=\"{{ starRatingControlName }}\"\r\n              [parentId]=\"starRatingControlName\"\r\n              [showTooltipIcon]=\"true\"\r\n              [enablePrimaryColor]=\"true\"\r\n              [enableNoteStyle]=\"false\"\r\n            >\r\n            </vnext-checkbox-group>\r\n          </div>\r\n        </ng-container>\r\n      </ng-container>\r\n    </ng-container>\r\n  </ng-container>\r\n</form>\r\n", styles: [".clear-all{color:var(--static-Spa_Style_Primary_Link);font-family:montserrat_light;font-size:var(--Spa_Style_Small_Font);text-align:right;margin-top:6px}.sub-items{margin-left:15px}.dropdown-spacer{height:100px}.filter-container{scrollbar-width:thin}.disable-click{pointer-events:none;opacity:.7}.triangle-arrow{width:0;height:0px;border-left:14px solid transparent;border-right:14px solid transparent;border-bottom:14px solid var(--static-Spa_Style_Accent1);position:relative;top:-20px;left:5px}.triangle-arrow:after{content:\"\";position:absolute;top:2px;left:-18px;width:0;height:0;border-left:18px solid transparent;border-right:18px solid transparent;border-bottom:18px solid white}\n"] }]
    }], function () { return [{ type: i1.FilterService }, { type: i0.ChangeDetectorRef }, { type: PlanFilterItemsFacade }, { type: i1.InputResetContextService }, { type: i1.FilterContextService }, { type: i1.PlansService }, { type: i1.SNPService }, { type: AnalyticsService }]; }, { filterDayText: [{
            type: Input
        }], selectFilterDayText: [{
            type: Input
        }], currentTab: [{
            type: Input
        }], clearAllText: [{
            type: Input
        }], filterCarrierText: [{
            type: Input
        }], planSubTypeLabel: [{
            type: Input
        }], licensingHeaderText: [{
            type: Input
        }], snpBaseTypeLabel: [{
            type: Input
        }], snpEnabled: [{
            type: Input
        }], additionalSavingsHeaderText: [{
            type: Input
        }], insulinSavingsEnabled: [{
            type: Input
        }], filterDSNPMedicaidCodesEnabled: [{
            type: Input
        }], costFilterEnabled: [{
            type: Input
        }], medicalDeductibleHeaderText: [{
            type: Input
        }], medicalDeductibleToolTipText: [{
            type: Input
        }], maximumOutOfPocketCostHeaderText: [{
            type: Input
        }], maximumOutOfPocketCostToolTipText: [{
            type: Input
        }], drugDeductibleHeaderText: [{
            type: Input
        }], drugDeductibleToolTipText: [{
            type: Input
        }], premiumHeaderText: [{
            type: Input
        }], premiumToolTipText: [{
            type: Input
        }], defaultPlanBenefitFilters: [{
            type: Input
        }], defaultPlanBenefitFiltersEnabled: [{
            type: Input
        }], addOnFilterHeaderText: [{
            type: Input
        }], addOnFilterEnabled: [{
            type: Input
        }], addOnTooltipText: [{
            type: Input
        }], providersNpiHeaderText: [{
            type: Input
        }], providersNpiFilterEnabled: [{
            type: Input
        }], providersEnabled: [{
            type: Input
        }], providersNpiTooltipText: [{
            type: Input
        }], planTypeLabel: [{
            type: Input
        }], allInNetworkLocationsEnabled: [{
            type: Input
        }], planFilterModalEnabled: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], isMedigapEnabled: [{
            type: Input
        }], medsupPlanSubTypeHeaderText: [{
            type: Input
        }], medsupPlanSubTypePlacholderText: [{
            type: Input
        }], medsupPlanSubTypeUpdateText: [{
            type: Input
        }], activeTabType: [{
            type: Input
        }], snpLabelText: [{
            type: Input
        }], filteredPlansHasSNPPlans: [{
            type: Input
        }], isPlanListPage: [{
            type: Input
        }], snpVisibility: [{
            type: Input
        }], starRatingEnabled: [{
            type: Input
        }], starRatingLabelText: [{
            type: Input
        }], starRatingFilterOptions: [{
            type: Input
        }], planFiltersSortOptions: [{
            type: Input
        }], closeModalEvent: [{
            type: Output
        }], planSubTypeChanged: [{
            type: Output
        }], toggleSNPPlanChangeEvent: [{
            type: Output
        }] }); })();

class PlanFilterModalComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
    }
    cancelChanges() {
        this.activeModal.dismiss();
    }
    applyFilter() {
        this.planFilterModalItems.updateFilters();
        this.activeModal.dismiss();
    }
}
PlanFilterModalComponent.ɵfac = function PlanFilterModalComponent_Factory(t) { return new (t || PlanFilterModalComponent)(i0.ɵɵdirectiveInject(i1$1.NgbActiveModal)); };
PlanFilterModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanFilterModalComponent, selectors: [["vnext-plan-filter-modal"]], viewQuery: function PlanFilterModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(PlanFilterModalItemsComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.planFilterModalItems = _t.first);
    } }, decls: 9, vars: 49, consts: [[3, "modalTitleText", "modalTitleCancelAction"], [1, "modal-body", "plan-filter-modal-content"], [3, "planSubTypeLabel", "filterDayText", "selectFilterDayText", "filterCarrierText", "clearAllText", "currentTab", "snpBaseTypeLabel", "licensingHeaderText", "snpEnabled", "additionalSavingsHeaderText", "insulinSavingsEnabled", "filterDSNPMedicaidCodesEnabled", "costFilterEnabled", "medicalDeductibleHeaderText", "medicalDeductibleToolTipText", "maximumOutOfPocketCostHeaderText", "maximumOutOfPocketCostToolTipText", "drugDeductibleHeaderText", "drugDeductibleToolTipText", "premiumHeaderText", "premiumToolTipText", "defaultPlanBenefitFilters", "defaultPlanBenefitFiltersEnabled", "addOnTooltipText", "addOnFilterHeaderText", "addOnFilterEnabled", "providersNpiHeaderText", "providersNpiFilterEnabled", "providersEnabled", "providersNpiTooltipText", "planTypeLabel", "allInNetworkLocationsEnabled", "filterModalEnabled", "isMedigapEnabled", "medsupPlanSubTypeHeaderText", "medsupPlanSubTypePlacholderText", "medsupPlanSubTypeUpdateText", "activeTabType", "snpLabelText", "filteredPlansHasSNPPlans", "isPlanListPage", "snpVisibility", "starRatingEnabled", "starRatingLabelText", "starRatingFilterOptions", "planFiltersSortOptions"], [1, "modal-footer", "justify-content-between"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", 3, "click"], ["type", "button", 1, "btn", "Spa_Style_PrimaryButton", 3, "click"]], template: function PlanFilterModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div")(1, "vnext-widget-modal-header", 0);
        i0.ɵɵlistener("modalTitleCancelAction", function PlanFilterModalComponent_Template_vnext_widget_modal_header_modalTitleCancelAction_1_listener() { return ctx.cancelChanges(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 1);
        i0.ɵɵelement(3, "vnext-plan-filter-modal-items", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3)(5, "button", 4);
        i0.ɵɵlistener("click", function PlanFilterModalComponent_Template_button_click_5_listener() { return ctx.cancelChanges(); });
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "button", 5);
        i0.ɵɵlistener("click", function PlanFilterModalComponent_Template_button_click_7_listener() { return ctx.applyFilter(); });
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("modalTitleText", ctx.filterHeaderText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("planSubTypeLabel", ctx.planSubTypeLabel)("filterDayText", ctx.filterDayText)("selectFilterDayText", ctx.selectFilterDayText)("filterCarrierText", ctx.filterCarrierText)("clearAllText", ctx.filterClearAllText)("currentTab", ctx.currentTab)("snpBaseTypeLabel", ctx.snpBaseTypeLabel)("licensingHeaderText", ctx.licensingHeaderText)("snpEnabled", ctx.snpEnabled)("additionalSavingsHeaderText", ctx.additionalSavingsHeaderText)("insulinSavingsEnabled", ctx.insulinSavingsEnabled)("filterDSNPMedicaidCodesEnabled", ctx.filterDSNPMedicaidCodesEnabled)("costFilterEnabled", ctx.costFilterEnabled)("medicalDeductibleHeaderText", ctx.medicalDeductibleHeaderText)("medicalDeductibleToolTipText", ctx.medicalDeductibleToolTipText)("maximumOutOfPocketCostHeaderText", ctx.maximumOutOfPocketCostHeaderText)("maximumOutOfPocketCostToolTipText", ctx.maximumOutOfPocketCostToolTipText)("drugDeductibleHeaderText", ctx.drugDeductibleHeaderText)("drugDeductibleToolTipText", ctx.drugDeductibleToolTipText)("premiumHeaderText", ctx.premiumHeaderText)("premiumToolTipText", ctx.premiumToolTipText)("defaultPlanBenefitFilters", ctx.defaultPlanBenefitFilters)("defaultPlanBenefitFiltersEnabled", ctx.defaultPlanBenefitFiltersEnabled)("addOnTooltipText", ctx.addOnTooltipText)("addOnFilterHeaderText", ctx.addOnFilterHeaderText)("addOnFilterEnabled", ctx.addOnFilterEnabled)("providersNpiHeaderText", ctx.providersNpiHeaderText)("providersNpiFilterEnabled", ctx.providersNpiFilterEnabled)("providersEnabled", ctx.providersEnabled)("providersNpiTooltipText", ctx.providersNpiTooltipText)("planTypeLabel", ctx.planTypeLabel)("allInNetworkLocationsEnabled", ctx.allInNetworkLocationsEnabled)("filterModalEnabled", ctx.filterModalEnabled)("isMedigapEnabled", ctx.isMedigapEnabled)("medsupPlanSubTypeHeaderText", ctx.medsupPlanSubTypeHeaderText)("medsupPlanSubTypePlacholderText", ctx.medsupPlanSubTypePlacholderText)("medsupPlanSubTypeUpdateText", ctx.medsupPlanSubTypeUpdateText)("activeTabType", ctx.activeTabType)("snpLabelText", ctx.snpLabelText)("filteredPlansHasSNPPlans", ctx.filteredPlansHasSNPPlans)("isPlanListPage", ctx.isPlanListPage)("snpVisibility", ctx.snpVisibility)("starRatingEnabled", ctx.starRatingEnabled)("starRatingLabelText", ctx.starRatingLabelText)("starRatingFilterOptions", ctx.starRatingFilterOptions)("planFiltersSortOptions", ctx.planFiltersSortOptions);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.filterModalCancelButtonText);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.filterModalApplyButtonText);
    } }, dependencies: [ModalHeaderComponent, PlanFilterModalItemsComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanFilterModalComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-filter-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div>\r\n  <vnext-widget-modal-header [modalTitleText]=\"filterHeaderText\" (modalTitleCancelAction)=\"cancelChanges()\"></vnext-widget-modal-header>\r\n\r\n  <div class=\"modal-body plan-filter-modal-content\">\r\n    <vnext-plan-filter-modal-items\r\n      [planSubTypeLabel]=\"planSubTypeLabel\"\r\n      [filterDayText]=\"filterDayText\"\r\n      [selectFilterDayText]=\"selectFilterDayText\"\r\n      [filterCarrierText]=\"filterCarrierText\"\r\n      [clearAllText]=\"filterClearAllText\"\r\n      [currentTab]=\"currentTab\"\r\n      [snpBaseTypeLabel]=\"snpBaseTypeLabel\"\r\n      [licensingHeaderText]=\"licensingHeaderText\"\r\n      [snpEnabled]=\"snpEnabled\"\r\n      [additionalSavingsHeaderText]=\"additionalSavingsHeaderText\"\r\n      [insulinSavingsEnabled]=\"insulinSavingsEnabled\"\r\n      [filterDSNPMedicaidCodesEnabled]=\"filterDSNPMedicaidCodesEnabled\"\r\n      [costFilterEnabled]=\"costFilterEnabled\"\r\n      [medicalDeductibleHeaderText]=\"medicalDeductibleHeaderText\"\r\n      [medicalDeductibleToolTipText]=\"medicalDeductibleToolTipText\"\r\n      [maximumOutOfPocketCostHeaderText]=\"maximumOutOfPocketCostHeaderText\"\r\n      [maximumOutOfPocketCostToolTipText]=\"maximumOutOfPocketCostToolTipText\"\r\n      [drugDeductibleHeaderText]=\"drugDeductibleHeaderText\"\r\n      [drugDeductibleToolTipText]=\"drugDeductibleToolTipText\"\r\n      [premiumHeaderText]=\"premiumHeaderText\"\r\n      [premiumToolTipText]=\"premiumToolTipText\"\r\n      [defaultPlanBenefitFilters]=\"defaultPlanBenefitFilters\"\r\n      [defaultPlanBenefitFiltersEnabled]=\"defaultPlanBenefitFiltersEnabled\"\r\n      [addOnTooltipText]=\"addOnTooltipText\"\r\n      [addOnFilterHeaderText]=\"addOnFilterHeaderText\"\r\n      [addOnFilterEnabled]=\"addOnFilterEnabled\"\r\n      [providersNpiHeaderText]=\"providersNpiHeaderText\"\r\n      [providersNpiFilterEnabled]=\"providersNpiFilterEnabled\"\r\n      [providersEnabled]=\"providersEnabled\"\r\n      [providersNpiTooltipText]=\"providersNpiTooltipText\"\r\n      [planTypeLabel]=\"planTypeLabel\"\r\n      [allInNetworkLocationsEnabled]=\"allInNetworkLocationsEnabled\"\r\n      [filterModalEnabled]=\"filterModalEnabled\"\r\n      [isMedigapEnabled]=\"isMedigapEnabled\"\r\n      [medsupPlanSubTypeHeaderText]=\"medsupPlanSubTypeHeaderText\"\r\n      [medsupPlanSubTypePlacholderText]=\"medsupPlanSubTypePlacholderText\"\r\n      [medsupPlanSubTypeUpdateText]=\"medsupPlanSubTypeUpdateText\"\r\n      [activeTabType]=\"activeTabType\"\r\n      [snpLabelText]=\"snpLabelText\"\r\n      [filteredPlansHasSNPPlans]=\"filteredPlansHasSNPPlans\"\r\n      [isPlanListPage]=\"isPlanListPage\"\r\n      [snpVisibility]=\"snpVisibility\"\r\n      [starRatingEnabled]=\"starRatingEnabled\"\r\n      [starRatingLabelText]=\"starRatingLabelText\"\r\n      [starRatingFilterOptions]=\"starRatingFilterOptions\"\r\n      [planFiltersSortOptions]=\"planFiltersSortOptions\"\r\n    ></vnext-plan-filter-modal-items>\r\n  </div>\r\n  <div class=\"modal-footer justify-content-between\">\r\n    <button type=\"button\" class=\"btn Spa_Style_SecondaryButton\" (click)=\"cancelChanges()\">{{ filterModalCancelButtonText }}</button>\r\n    <button type=\"button\" class=\"btn Spa_Style_PrimaryButton\" (click)=\"applyFilter()\">{{ filterModalApplyButtonText }}</button>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: i1$1.NgbActiveModal }]; }, { planFilterModalItems: [{
            type: ViewChild,
            args: [PlanFilterModalItemsComponent]
        }] }); })();

function PlanFilterItemsComponent_div_1_div_1_span_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r16.providersNpiTooltipText, "html"), i0.ɵɵsanitizeHtml);
} }
function PlanFilterItemsComponent_div_1_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_div_1_div_1_span_3_ng_template_1_Template, 2, 4, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "i", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r15 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbTooltip", _r15);
} }
function PlanFilterItemsComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "h3", 2);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, PlanFilterItemsComponent_div_1_div_1_span_3_Template, 4, 1, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "vnext-checkbox-group", 4);
    i0.ɵɵlistener("change", function PlanFilterItemsComponent_div_1_div_1_Template_vnext_checkbox_group_change_4_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r17.onFilterSelected(ctx_r17.providersNpiName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const providerNpiOptions_r12 = i0.ɵɵnextContext().ngIf;
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.providersNpiHeaderText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.medicalDeductibleToolTipText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r13.providersNpiName);
    i0.ɵɵproperty("items", providerNpiOptions_r12)("parentId", ctx_r13.providersNpiName)("showTooltipUnderline", true)("enablePrimaryColor", true);
} }
function PlanFilterItemsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_div_1_div_1_Template, 5, 7, "div", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const providerNpiOptions_r12 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", providerNpiOptions_r12.length);
} }
function PlanFilterItemsComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "h3", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "vnext-checkbox-group", 9);
    i0.ɵɵlistener("change", function PlanFilterItemsComponent_div_3_Template_vnext_checkbox_group_change_3_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.onFilterSelected(ctx_r20.sellableControlName)); });
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.licensingHeaderText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r1.sellableControlName);
    i0.ɵɵproperty("items", i0.ɵɵpipeBind1(4, 6, ctx_r1.planSellable$))("parentId", ctx_r1.sellableControlName)("showTooltipUnderline", true)("enablePrimaryColor", true);
} }
function PlanFilterItemsComponent_ng_container_5_div_1_span_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r26.medicalDeductibleToolTipText, "html"), i0.ɵɵsanitizeHtml);
} }
function PlanFilterItemsComponent_ng_container_5_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_ng_container_5_div_1_span_3_ng_template_1_Template, 2, 4, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "i", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r25 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbTooltip", _r25);
} }
function PlanFilterItemsComponent_ng_container_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "h3", 2);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, PlanFilterItemsComponent_ng_container_5_div_1_span_3_Template, 4, 1, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "vnext-checkbox-group", 9);
    i0.ɵɵlistener("change", function PlanFilterItemsComponent_ng_container_5_div_1_Template_vnext_checkbox_group_change_4_listener() { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r27.onFilterSelected(ctx_r27.medicalDeductibleControlName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const medicalDeductible_r22 = i0.ɵɵnextContext().ngIf;
    const ctx_r23 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r23.medicalDeductibleHeaderText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r23.medicalDeductibleToolTipText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r23.medicalDeductibleControlName);
    i0.ɵɵproperty("items", medicalDeductible_r22)("parentId", ctx_r23.medicalDeductibleControlName)("showTooltipUnderline", true)("enablePrimaryColor", true);
} }
function PlanFilterItemsComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_ng_container_5_div_1_Template, 5, 7, "div", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const medicalDeductible_r22 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", medicalDeductible_r22.length);
} }
function PlanFilterItemsComponent_ng_container_7_div_1_span_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r34.maximumOutOfPocketCostToolTipText, "html"), i0.ɵɵsanitizeHtml);
} }
function PlanFilterItemsComponent_ng_container_7_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_ng_container_7_div_1_span_3_ng_template_1_Template, 2, 4, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "i", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r33 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbTooltip", _r33);
} }
function PlanFilterItemsComponent_ng_container_7_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "h3", 2);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, PlanFilterItemsComponent_ng_container_7_div_1_span_3_Template, 4, 1, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "vnext-checkbox-group", 9);
    i0.ɵɵlistener("change", function PlanFilterItemsComponent_ng_container_7_div_1_Template_vnext_checkbox_group_change_4_listener() { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r35.onFilterSelected(ctx_r35.maximumOutOfPocketCostControlName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const maximumOutOfPocketCost_r30 = i0.ɵɵnextContext().ngIf;
    const ctx_r31 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r31.maximumOutOfPocketCostHeaderText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r31.maximumOutOfPocketCostToolTipText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r31.maximumOutOfPocketCostControlName);
    i0.ɵɵproperty("items", maximumOutOfPocketCost_r30)("parentId", ctx_r31.maximumOutOfPocketCostControlName)("showTooltipUnderline", true)("enablePrimaryColor", true);
} }
function PlanFilterItemsComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_ng_container_7_div_1_Template, 5, 7, "div", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const maximumOutOfPocketCost_r30 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", maximumOutOfPocketCost_r30.length);
} }
function PlanFilterItemsComponent_ng_container_9_div_1_span_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 18);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r42.drugDeductibleToolTipText, "html"), i0.ɵɵsanitizeHtml);
} }
function PlanFilterItemsComponent_ng_container_9_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_ng_container_9_div_1_span_3_ng_template_1_Template, 2, 4, "ng-template", null, 16, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "i", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r41 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbTooltip", _r41);
} }
function PlanFilterItemsComponent_ng_container_9_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "h3", 2);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, PlanFilterItemsComponent_ng_container_9_div_1_span_3_Template, 4, 1, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "vnext-checkbox-group", 9);
    i0.ɵɵlistener("change", function PlanFilterItemsComponent_ng_container_9_div_1_Template_vnext_checkbox_group_change_4_listener() { i0.ɵɵrestoreView(_r44); const ctx_r43 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r43.onFilterSelected(ctx_r43.drugDeductibleControlName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const drugDeductible_r38 = i0.ɵɵnextContext().ngIf;
    const ctx_r39 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r39.drugDeductibleHeaderText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r39.drugDeductibleToolTipText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r39.drugDeductibleControlName);
    i0.ɵɵproperty("items", drugDeductible_r38)("parentId", ctx_r39.drugDeductibleControlName)("showTooltipUnderline", true)("enablePrimaryColor", true);
} }
function PlanFilterItemsComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_ng_container_9_div_1_Template, 5, 7, "div", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const drugDeductible_r38 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", drugDeductible_r38.length);
} }
function PlanFilterItemsComponent_ng_container_11_div_1_span_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 21);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r52.premiumToolTipText, "html"), i0.ɵɵsanitizeHtml);
} }
function PlanFilterItemsComponent_ng_container_11_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_ng_container_11_div_1_span_3_ng_template_1_Template, 2, 4, "ng-template", null, 19, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "i", 20);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r51 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbTooltip", _r51);
} }
function PlanFilterItemsComponent_ng_container_11_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-checkbox-group", 9);
    i0.ɵɵlistener("change", function PlanFilterItemsComponent_ng_container_11_div_1_div_4_Template_vnext_checkbox_group_change_1_listener() { i0.ɵɵrestoreView(_r54); const ctx_r53 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r53.onFilterSelected(ctx_r53.drugPremiumControlName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const premium_r46 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r49 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r49.drugPremiumControlName);
    i0.ɵɵproperty("items", premium_r46.drugPremium)("parentId", ctx_r49.drugPremiumControlName)("showTooltipUnderline", true)("enablePrimaryColor", true);
} }
function PlanFilterItemsComponent_ng_container_11_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-checkbox-group", 9);
    i0.ɵɵlistener("change", function PlanFilterItemsComponent_ng_container_11_div_1_div_5_Template_vnext_checkbox_group_change_1_listener() { i0.ɵɵrestoreView(_r57); const ctx_r56 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r56.onFilterSelected(ctx_r56.medicalPremiumControlName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const premium_r46 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r50 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r50.medicalPremiumControlName);
    i0.ɵɵproperty("items", premium_r46.medicalPremium)("parentId", ctx_r50.medicalPremiumControlName)("showTooltipUnderline", true)("enablePrimaryColor", true);
} }
function PlanFilterItemsComponent_ng_container_11_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "h3", 2);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, PlanFilterItemsComponent_ng_container_11_div_1_span_3_Template, 4, 1, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PlanFilterItemsComponent_ng_container_11_div_1_div_4_Template, 2, 5, "div", 1);
    i0.ɵɵtemplate(5, PlanFilterItemsComponent_ng_container_11_div_1_div_5_Template, 2, 5, "div", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const premium_r46 = i0.ɵɵnextContext().ngIf;
    const ctx_r47 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r47.premiumHeaderText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r47.premiumToolTipText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r47.currentTabIsPDP && (premium_r46.drugPremium == null ? null : premium_r46.drugPremium.length));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r47.currentTabIsPDP && (premium_r46.medicalPremium == null ? null : premium_r46.medicalPremium.length));
} }
function PlanFilterItemsComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_ng_container_11_div_1_Template, 6, 4, "div", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const premium_r46 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (premium_r46.medicalPremium == null ? null : premium_r46.medicalPremium.length) || (premium_r46.drugPremium == null ? null : premium_r46.drugPremium.length));
} }
function PlanFilterItemsComponent_div_14_div_1_span_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 24);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r64 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r64.addOnTooltipText, "html"), i0.ɵɵsanitizeHtml);
} }
function PlanFilterItemsComponent_div_14_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_div_14_div_1_span_3_ng_template_1_Template, 2, 4, "ng-template", null, 22, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "i", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r63 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngbTooltip", _r63);
} }
function PlanFilterItemsComponent_div_14_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "h3", 2);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, PlanFilterItemsComponent_div_14_div_1_span_3_Template, 4, 1, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "vnext-checkbox-group", 9);
    i0.ɵɵlistener("change", function PlanFilterItemsComponent_div_14_div_1_Template_vnext_checkbox_group_change_4_listener() { i0.ɵɵrestoreView(_r66); const ctx_r65 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r65.onFilterSelected(ctx_r65.ridersPlanSubtypeName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ridersOptions_r60 = i0.ɵɵnextContext().ngIf;
    const ctx_r61 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r61.addOnFilterHeaderText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r61.addOnTooltipText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r61.ridersPlanSubtypeName);
    i0.ɵɵproperty("items", ridersOptions_r60)("parentId", ctx_r61.ridersPlanSubtypeName)("showTooltipUnderline", true)("enablePrimaryColor", true);
} }
function PlanFilterItemsComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_div_14_div_1_Template, 5, 7, "div", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ridersOptions_r60 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ridersOptions_r60.length);
} }
function PlanFilterItemsComponent_ng_container_16_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r71 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-checkbox-group", 9);
    i0.ɵɵlistener("change", function PlanFilterItemsComponent_ng_container_16_div_4_Template_vnext_checkbox_group_change_1_listener() { i0.ɵɵrestoreView(_r71); const ctx_r70 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r70.onFilterSelected(ctx_r70.extraDataControlName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r68 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r68.extraDataControlName);
    i0.ɵɵproperty("items", ctx_r68.allPlanBenefitFilter.modelDrugPrograms)("parentId", ctx_r68.extraDataControlName)("showTooltipUnderline", true)("enablePrimaryColor", true);
} }
function PlanFilterItemsComponent_ng_container_16_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r73 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-checkbox-group", 9);
    i0.ɵɵlistener("change", function PlanFilterItemsComponent_ng_container_16_div_5_Template_vnext_checkbox_group_change_1_listener() { i0.ɵɵrestoreView(_r73); const ctx_r72 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r72.onFilterSelected(ctx_r72.planBenefitsControlName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r69 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r69.planBenefitsControlName);
    i0.ɵɵproperty("items", ctx_r69.allPlanBenefitFilter.defaultPlanBenefits)("parentId", ctx_r69.planBenefitsControlName)("showTooltipUnderline", true)("enablePrimaryColor", true);
} }
function PlanFilterItemsComponent_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 25)(2, "h3", 2);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PlanFilterItemsComponent_ng_container_16_div_4_Template, 2, 5, "div", 1);
    i0.ɵɵtemplate(5, PlanFilterItemsComponent_ng_container_16_div_5_Template, 2, 5, "div", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r7.additionalSavingsHeaderText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.insulinSavingsEnabled && (ctx_r7.allPlanBenefitFilter.modelDrugPrograms == null ? null : ctx_r7.allPlanBenefitFilter.modelDrugPrograms.length));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.allPlanBenefitFilter.defaultPlanBenefits == null ? null : ctx_r7.allPlanBenefitFilter.defaultPlanBenefits.length);
} }
function PlanFilterItemsComponent_ng_container_17_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r77 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "h3", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "vnext-checkbox-group", 26);
    i0.ɵɵlistener("change", function PlanFilterItemsComponent_ng_container_17_div_1_Template_vnext_checkbox_group_change_3_listener() { i0.ɵɵrestoreView(_r77); const ctx_r76 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r76.onFilterSelected(ctx_r76.carriersControlName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const carriers_r74 = i0.ɵɵnextContext().ngIf;
    const ctx_r75 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r75.filterCarrierText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r75.carriersControlName);
    i0.ɵɵproperty("items", carriers_r74)("parentId", ctx_r75.carriersControlName)("showTooltipUnderline", true)("enablePrimaryColor", true)("noTranslateBlock", true);
} }
function PlanFilterItemsComponent_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_ng_container_17_div_1_Template, 4, 7, "div", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const carriers_r74 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", carriers_r74.length > 1);
} }
function PlanFilterItemsComponent_ng_container_19_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r82 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "h3", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "vnext-checkbox-group", 9);
    i0.ɵɵlistener("change", function PlanFilterItemsComponent_ng_container_19_div_1_Template_vnext_checkbox_group_change_3_listener() { i0.ɵɵrestoreView(_r82); const ctx_r81 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r81.onFilterSelected(ctx_r81.subTypesControlName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const planSubTypes_r79 = i0.ɵɵnextContext().ngIf;
    const ctx_r80 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r80.planSubTypeLabel, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r80.subTypesControlName);
    i0.ɵɵproperty("items", planSubTypes_r79)("parentId", ctx_r80.subTypesControlName)("showTooltipUnderline", true)("enablePrimaryColor", true);
} }
function PlanFilterItemsComponent_ng_container_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_ng_container_19_div_1_Template, 4, 6, "div", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const planSubTypes_r79 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", planSubTypes_r79.length > 1);
} }
function PlanFilterItemsComponent_ng_container_21_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r87 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "h3", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "vnext-checkbox-group", 9);
    i0.ɵɵlistener("change", function PlanFilterItemsComponent_ng_container_21_div_1_Template_vnext_checkbox_group_change_3_listener() { i0.ɵɵrestoreView(_r87); const ctx_r86 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r86.onFilterSelected(ctx_r86.ancillaryPlanTypeControlName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ancillaryPlanTypes_r84 = i0.ɵɵnextContext().ngIf;
    const ctx_r85 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r85.planTypeLabel, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r85.ancillaryPlanTypeControlName);
    i0.ɵɵproperty("items", ancillaryPlanTypes_r84)("parentId", ctx_r85.ancillaryPlanTypeControlName)("showTooltipUnderline", true)("enablePrimaryColor", true);
} }
function PlanFilterItemsComponent_ng_container_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_ng_container_21_div_1_Template, 4, 6, "div", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ancillaryPlanTypes_r84 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ancillaryPlanTypes_r84.length > 1);
} }
function PlanFilterItemsComponent_ng_container_23_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h3", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r89 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r89.snpBaseTypeLabel, " ");
} }
function PlanFilterItemsComponent_ng_container_23_ng_container_3_div_1_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r97 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28)(1, "vnext-checkbox-group", 9);
    i0.ɵɵlistener("change", function PlanFilterItemsComponent_ng_container_23_ng_container_3_div_1_ng_container_2_div_1_Template_vnext_checkbox_group_change_1_listener() { i0.ɵɵrestoreView(_r97); const ctx_r96 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r96.onSnpSubFilterSelected(ctx_r96.snpBaseTypesControlName, ctx_r96.snpSubTypesControlName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r95 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r95.snpSubTypesControlName);
    i0.ɵɵproperty("items", ctx_r95.cSNPSubTypes)("parentId", ctx_r95.snpSubTypesControlName)("showTooltipUnderline", true)("enablePrimaryColor", true);
} }
function PlanFilterItemsComponent_ng_container_23_ng_container_3_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_ng_container_23_ng_container_3_div_1_ng_container_2_div_1_Template, 2, 5, "div", 27);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r94 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r94.cSNPSubTypes.length >= 1);
} }
function PlanFilterItemsComponent_ng_container_23_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r99 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-checkbox-group", 9);
    i0.ɵɵlistener("change", function PlanFilterItemsComponent_ng_container_23_ng_container_3_div_1_Template_vnext_checkbox_group_change_1_listener() { i0.ɵɵrestoreView(_r99); const ctx_r98 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r98.onSnpSubFilterSelected(ctx_r98.snpBaseTypesControlName, ctx_r98.snpSubTypesControlName)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, PlanFilterItemsComponent_ng_container_23_ng_container_3_div_1_ng_container_2_Template, 2, 1, "ng-container", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r93 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r93.snpBaseTypesControlName);
    i0.ɵɵproperty("items", ctx_r93.cSNPBaseTypes)("parentId", ctx_r93.snpBaseTypesControlName)("showTooltipUnderline", true)("enablePrimaryColor", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r93.cSNPSubTypes);
} }
function PlanFilterItemsComponent_ng_container_23_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_ng_container_23_ng_container_3_div_1_Template, 3, 6, "div", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r90 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r90.cSNPBaseTypes.length >= 1);
} }
function PlanFilterItemsComponent_ng_container_23_ng_container_4_div_1_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r104 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30)(1, "vnext-checkbox-group", 31);
    i0.ɵɵlistener("change", function PlanFilterItemsComponent_ng_container_23_ng_container_4_div_1_ng_container_2_div_1_Template_vnext_checkbox_group_change_1_listener() { i0.ɵɵrestoreView(_r104); const ctx_r103 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r103.onSnpSubFilterSelected(ctx_r103.snpBaseTypesControlName, ctx_r103.dsnpSubTypesControlName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r102 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r102.dsnpSubTypesControlName);
    i0.ɵɵproperty("highlightedItems", ctx_r102.highlightedDSNPCodes)("items", ctx_r102.dSNPSubTypes)("parentId", ctx_r102.dsnpSubTypesControlName)("showTooltipUnderline", true)("enablePrimaryColor", true);
} }
function PlanFilterItemsComponent_ng_container_23_ng_container_4_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_ng_container_23_ng_container_4_div_1_ng_container_2_div_1_Template, 2, 6, "div", 29);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r101 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r101.dSNPSubTypes.length >= 1);
} }
function PlanFilterItemsComponent_ng_container_23_ng_container_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r106 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-checkbox-group", 9);
    i0.ɵɵlistener("change", function PlanFilterItemsComponent_ng_container_23_ng_container_4_div_1_Template_vnext_checkbox_group_change_1_listener() { i0.ɵɵrestoreView(_r106); const ctx_r105 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r105.onSnpSubFilterSelected(ctx_r105.snpBaseTypesControlName)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, PlanFilterItemsComponent_ng_container_23_ng_container_4_div_1_ng_container_2_Template, 2, 1, "ng-container", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r100 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r100.snpBaseTypesControlName);
    i0.ɵɵproperty("items", ctx_r100.dSNPBaseTypes)("parentId", ctx_r100.snpBaseTypesControlName)("showTooltipUnderline", true)("enablePrimaryColor", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r100.dSNPSubTypes);
} }
function PlanFilterItemsComponent_ng_container_23_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_ng_container_23_ng_container_4_div_1_Template, 3, 6, "div", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r91 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r91.dSNPBaseTypes.length >= 1);
} }
function PlanFilterItemsComponent_ng_container_23_ng_container_5_div_1_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r111 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 28)(1, "vnext-checkbox-group", 9);
    i0.ɵɵlistener("change", function PlanFilterItemsComponent_ng_container_23_ng_container_5_div_1_ng_container_2_div_1_Template_vnext_checkbox_group_change_1_listener() { i0.ɵɵrestoreView(_r111); const ctx_r110 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r110.onSnpSubFilterSelected(ctx_r110.snpBaseTypesControlName, ctx_r110.snpSubTypesControlName)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r109 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r109.snpSubTypesControlName);
    i0.ɵɵproperty("items", ctx_r109.iSNPSubTypes)("parentId", ctx_r109.snpSubTypesControlName)("showTooltipUnderline", true)("enablePrimaryColor", true);
} }
function PlanFilterItemsComponent_ng_container_23_ng_container_5_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_ng_container_23_ng_container_5_div_1_ng_container_2_div_1_Template, 2, 5, "div", 27);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r108 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r108.iSNPSubTypes.length >= 1);
} }
function PlanFilterItemsComponent_ng_container_23_ng_container_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r113 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-checkbox-group", 9);
    i0.ɵɵlistener("change", function PlanFilterItemsComponent_ng_container_23_ng_container_5_div_1_Template_vnext_checkbox_group_change_1_listener() { i0.ɵɵrestoreView(_r113); const ctx_r112 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r112.onSnpSubFilterSelected(ctx_r112.snpBaseTypesControlName, ctx_r112.snpSubTypesControlName)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, PlanFilterItemsComponent_ng_container_23_ng_container_5_div_1_ng_container_2_Template, 2, 1, "ng-container", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r107 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("formControlName", ctx_r107.snpBaseTypesControlName);
    i0.ɵɵproperty("items", ctx_r107.iSNPBaseTypes)("parentId", ctx_r107.snpBaseTypesControlName)("showTooltipUnderline", true)("enablePrimaryColor", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r107.iSNPSubTypes);
} }
function PlanFilterItemsComponent_ng_container_23_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_ng_container_23_ng_container_5_div_1_Template, 3, 6, "div", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r92 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r92.iSNPBaseTypes.length >= 1);
} }
function PlanFilterItemsComponent_ng_container_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanFilterItemsComponent_ng_container_23_ng_container_1_Template, 3, 1, "ng-container", 1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, PlanFilterItemsComponent_ng_container_23_ng_container_3_Template, 2, 1, "ng-container", 1);
    i0.ɵɵtemplate(4, PlanFilterItemsComponent_ng_container_23_ng_container_4_Template, 2, 1, "ng-container", 1);
    i0.ɵɵtemplate(5, PlanFilterItemsComponent_ng_container_23_ng_container_5_Template, 2, 1, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 4, ctx_r11.snpBaseTypes$).length);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r11.cSNPBaseTypes);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.dSNPBaseTypes);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.iSNPBaseTypes);
} }
const _c0$M = function (a0, a1) { return { medicalPremium: a0, drugPremium: a1 }; };
class PlanFilterItemsComponent {
    constructor(filterService, cdr, planFilterItemsFacade, inputResetContextService, filterContextService, plansService) {
        this.filterService = filterService;
        this.cdr = cdr;
        this.planFilterItemsFacade = planFilterItemsFacade;
        this.inputResetContextService = inputResetContextService;
        this.filterContextService = filterContextService;
        this.plansService = plansService;
        this.planTypeLabel = 'Plan type';
        this.snpBaseTypeLabel = 'Special needs plans (SNP)';
        this.showAllMedSupEnabled = false;
        this.costFilterEnabled = false;
        this.filterItemClicked = new EventEmitter();
        this.currentTabIsMedigap = false;
        this.currentTabIsDental = false;
        this.currentTabIsVision = false;
        this.currentTabIsPDP = false;
        this.allPlanBenefitFilter = {
            modelDrugPrograms: [],
            defaultPlanBenefits: []
        };
        this.displayPlanSubTypes = true;
        this.displayDentalVisionFilters = false;
        this.highlightedDSNPCodes = [];
        this.subscriptions = new Subscription();
        this.filterList$ = new BehaviorSubject([]);
        // Obtained from "tabTypes" and "filters" properties on each tab in "Spa_PlanList_Tabs_Data"
        this.currentTabFiltersSubject$ = new BehaviorSubject([]);
        this.currentTabFilters$ = this.currentTabFiltersSubject$.asObservable();
        // Selected filters by the user
        this.hasCurrentTabSelectedFilters$ = this.currentTabFilters$.pipe(switchMap(currentTabFilters => this.filterService.hasSelectedFilters$(currentTabFilters, false)));
    }
    ngOnInit() {
        this.filterForm = this.planFilterItemsFacade.createFilterForm();
        this.filterFormTypes = this.planFilterItemsFacade.getFormFilterTypes();
        this.showSellablePlanFilter$ = this.planFilterItemsFacade.getShowSellablePlanFilter$();
        this.carriers$ = this.planFilterItemsFacade.getCarriersControls$(this.filterList$);
        this.subscriptions.add(this.currentTabFilters$
            .pipe(switchMap(currentTabFilters => this.filterService.getFiltersByFilterGroup$(currentTabFilters).pipe(take(1))))
            .subscribe({
            next: filters => {
                if (this.filterFormTypes) {
                    const visibleFilters = filters.filter(({ visible }) => visible);
                    this.updateWholeForm(visibleFilters);
                    this.filterList$.next(visibleFilters);
                    this.checkboxGroups?.forEach(checkboxGroup => {
                        checkboxGroup.markForCheck();
                    });
                    this.cdr.markForCheck();
                }
            }
        }));
        this.subscriptions.add(this.hasCurrentTabSelectedFilters$.subscribe({
            next: hasCurrentTabSelectedFilters => {
                if (!hasCurrentTabSelectedFilters && (this.filterForm.dirty || this.filterForm.touched)) {
                    this.uncheckAllFilters();
                    this.cdr.markForCheck();
                }
            }
        }));
        if (this.defaultPlanBenefitFiltersEnabled) {
            this.planBenefits$ = this.planFilterItemsFacade.getPlanBenefitsControls$(this.filterList$, this.defaultPlanBenefitFilters);
            this.subscriptions.add(this.planBenefits$.subscribe({
                next: defaultPlanBenefits => {
                    this.allPlanBenefitFilter.defaultPlanBenefits = defaultPlanBenefits;
                    this.cdr.markForCheck();
                }
            }));
            if (this.insulinSavingsEnabled) {
                this.modelDrugPrograms$ = this.planFilterItemsFacade.getModelDrugProgramControls$(this.filterList$);
                this.subscriptions.add(this.modelDrugPrograms$.subscribe({
                    next: modelDrugPrograms => {
                        this.allPlanBenefitFilter.modelDrugPrograms = modelDrugPrograms;
                        this.cdr.markForCheck();
                    }
                }));
                this.extraDataControlName = this.planFilterItemsFacade.getExtraDataControlName();
            }
        }
        this.cSNPSubTypes$ = this.planFilterItemsFacade.getCSNPBaseControls$(this.filterList$).pipe(switchMap(cSNPBaseTypes => {
            this.cSNPBaseTypes = cSNPBaseTypes;
            if (cSNPBaseTypes?.length > 0) {
                return this.planFilterItemsFacade.getSNPSubControls$(this.filterList$, SNP_CATEGORY_FILTER_TYPES.ID_IS_CSNP, cSNPBaseTypes[0].value);
            }
            return of([]);
        }));
        this.dSNPSubTypes$ = this.planFilterItemsFacade.getDSNPBaseControls$(this.filterList$).pipe(switchMap(dSNPBaseTypes => {
            this.dSNPBaseTypes = dSNPBaseTypes;
            if (dSNPBaseTypes?.length > 0 && this.filterDSNPMedicaidCodesEnabled) {
                return this.planFilterItemsFacade.getDSNPSubControls$(this.filterList$);
            }
            return of([]);
        }));
        this.iSNPSubTypes$ = this.planFilterItemsFacade.getISNPBaseControls$(this.filterList$).pipe(switchMap(iSNPBaseTypes => {
            this.iSNPBaseTypes = iSNPBaseTypes;
            if (iSNPBaseTypes?.length > 0) {
                return this.planFilterItemsFacade.getSNPSubControls$(this.filterList$, SNP_CATEGORY_FILTER_TYPES.ID_IS_ISNP, iSNPBaseTypes[0].value);
            }
            return of([]);
        }));
        this.subscriptions.add(this.cSNPSubTypes$.subscribe({
            next: cSNPSubTypes => {
                this.cSNPSubTypes = cSNPSubTypes;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.iSNPSubTypes$.subscribe({
            next: iSNPSubTypes => {
                this.iSNPSubTypes = iSNPSubTypes;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.dSNPSubTypes$.subscribe({
            next: dSNPSubTypes => {
                this.dSNPSubTypes = dSNPSubTypes;
                this.filterContextService.setFilterValues({
                    filterName: FilterContextNames.DSNP,
                    filterValues: dSNPSubTypes.map((type) => type.label)
                });
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.filterContextService
            .getFilterHighlights$()
            .pipe(filter((filterValues) => filterValues?.filterName === FilterContextNames.DSNP))
            .subscribe({
            next: (filterValues) => {
                this.highlightedDSNPCodes = filterValues.filterValues ?? [];
                this.cdr.markForCheck();
            }
        }));
        this.planSubTypes$ = this.planFilterItemsFacade.getPlanSubTypeControls$(this.filterList$);
        this.ancillaryPlanTypes$ = this.planFilterItemsFacade.getAncillaryPlanTypeControls$(this.filterList$);
        this.planSellable$ = this.planFilterItemsFacade.getPlanSellableControls$(this.filterList$);
        this.snpBaseTypes$ = this.planFilterItemsFacade.getSNPBaseControls$(this.filterList$);
        this.ridersOptions$ = this.planFilterItemsFacade.getRidersControls$(this.filterList$);
        this.providerNpiOptions$ = this.planFilterItemsFacade.getProvidersNpiControls$(this.filterList$, this.allInNetworkLocationsEnabled);
        this.carriersControlName = this.planFilterItemsFacade.getCarriersControlName();
        this.planBenefitsControlName = this.planFilterItemsFacade.getplanBenefitsControlName();
        this.subTypesControlName = this.planFilterItemsFacade.getSubTypesControlName();
        this.ancillaryPlanTypeControlName = this.planFilterItemsFacade.getAncillaryPlanTypeControlName();
        this.snpBaseTypesControlName = this.planFilterItemsFacade.getSnpBaseTypesControlName();
        this.sellableControlName = this.planFilterItemsFacade.getSellableControlName();
        this.snpSubTypesControlName = this.planFilterItemsFacade.getSNPSubTypesControlName();
        this.dsnpSubTypesControlName = this.planFilterItemsFacade.getDSNPSubTypesControlName();
        this.ridersPlanSubtypeName = this.planFilterItemsFacade.getRidersPlanSubtypeName();
        this.providersNpiName = this.planFilterItemsFacade.getProvidersNpiName();
        this.medicalDeductible$ = this.planFilterItemsFacade.getCostFilterControl$(this.filterList$, FilterKeyType.PLAN_MEDICAL_DEDUCTIBLE);
        this.medicalDeductibleControlName = this.planFilterItemsFacade.getCostFilterControlName(FilterKeyType.PLAN_MEDICAL_DEDUCTIBLE);
        this.maximumOutOfPocketCost$ = this.planFilterItemsFacade.getCostFilterControl$(this.filterList$, FilterKeyType.PLAN_MAXIMUM_OUT_POCKET_COST);
        this.maximumOutOfPocketCostControlName = this.planFilterItemsFacade.getCostFilterControlName(FilterKeyType.PLAN_MAXIMUM_OUT_POCKET_COST);
        this.drugDeductible$ = this.planFilterItemsFacade.getCostFilterControl$(this.filterList$, FilterKeyType.PLAN_PHARMACY_DEDUCTIBLE);
        this.drugDeductibleControlName = this.planFilterItemsFacade.getCostFilterControlName(FilterKeyType.PLAN_PHARMACY_DEDUCTIBLE);
        this.medicalPremium$ = this.planFilterItemsFacade.getCostFilterControl$(this.filterList$, FilterKeyType.PLAN_PREMIUM);
        this.medicalPremiumControlName = this.planFilterItemsFacade.getCostFilterControlName(FilterKeyType.PLAN_PREMIUM);
        this.drugPremium$ = this.planFilterItemsFacade.getCostFilterControl$(this.filterList$, FilterKeyType.PLAN_DRUG_PREMIUM);
        this.drugPremiumControlName = this.planFilterItemsFacade.getCostFilterControlName(FilterKeyType.PLAN_DRUG_PREMIUM);
        this.cdr.markForCheck();
    }
    ngOnChanges(changes) {
        if (changes?.currentTab && !_isEqual(changes.currentTab.currentValue, changes.currentTab.previousValue)) {
            this.currentTabFiltersSubject$.next(this.currentTab.filters);
            this.currentTabIsMedigap = this.isActiveTab(PlanTypeAbbreviation.MEDIGAP);
            this.currentTabIsDental = this.isActiveTab(PlanTypeAbbreviation.DENTAL);
            this.currentTabIsVision = this.isActiveTab(PlanTypeAbbreviation.VISION);
            this.currentTabIsPDP = this.isActiveTab(PlanTypeAbbreviation.PDP);
            this.displayPlanSubTypes = !(this.currentTabIsDental || this.currentTabIsVision);
            this.displayDentalVisionFilters = this.currentTabIsDental || this.currentTabIsVision;
        }
    }
    onFilterSelected(controlName) {
        if (controlName === FilterKeyType.PLAN_ISPUF) {
            this.carriers$ = this.planFilterItemsFacade.getCarriersControls$(this.filterList$);
        }
        this.plansService.setActiveTabPlanCountCheckEnabled(false);
        this.planFilterItemsFacade.onFilterSelected(this.filterForm, this.currentTab.filters, controlName, this.currentTab.tabTypes[0]);
        this.filterItemClicked.emit();
    }
    onSnpSubFilterSelected(snpBaseFilterControlName, snpSubTypeControlName) {
        let subTypeValue;
        const baseTypeValue = this.filterForm.get(snpBaseFilterControlName).value;
        const values = [];
        if (snpSubTypeControlName) {
            subTypeValue = this.filterForm.get(snpSubTypeControlName).value;
            subTypeValue?.forEach(value => {
                if (value.syncOtherActiveFilter && !values.includes(value.syncOtherActiveFilter.values)) {
                    values.push(value.syncOtherActiveFilter.values);
                }
            });
        }
        baseTypeValue?.forEach(value => {
            if (!values.includes(value)) {
                values.push(value);
            }
        });
        this.filterForm.patchValue({ [snpBaseFilterControlName]: values });
        this.planFilterItemsFacade.onFilterSelected(this.filterForm, this.currentTab.filters, snpBaseFilterControlName, this.currentTab.tabTypes[0]);
        if (snpSubTypeControlName) {
            this.filterForm.patchValue({ [snpSubTypeControlName]: subTypeValue });
            this.planFilterItemsFacade.onFilterSelected(this.filterForm, this.currentTab.filters, snpSubTypeControlName, this.currentTab.tabTypes[0]);
        }
        this.filterItemClicked.emit();
    }
    uncheckAllFilters() {
        Object.entries(this.filterForm.controls).forEach(([controlName, control]) => {
            if (controlName !== this.extraDataControlName || (this.defaultPlanBenefitFiltersEnabled && this.insulinSavingsEnabled)) {
                control.setValue([]);
                this.inputResetContextService.clearInputById(controlName);
            }
        });
    }
    updateFilterForm(controlName, planFilter) {
        this.planFilterItemsFacade.updateFilterForm(this.filterForm, controlName, planFilter);
        this.cdr.markForCheck();
    }
    updateWholeForm(filters) {
        Object.keys(this.filterFormTypes).forEach(key => {
            this.updateFilterForm(key, filters.find(filter => filter.key === this.filterFormTypes[key]));
        });
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        this.filterList$.complete();
    }
    isActiveTab(planTypeAbbreviation) {
        return this.currentTab.tabTypes.includes(planTypeAbbreviation);
    }
}
PlanFilterItemsComponent.ɵfac = function PlanFilterItemsComponent_Factory(t) { return new (t || PlanFilterItemsComponent)(i0.ɵɵdirectiveInject(i1.FilterService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PlanFilterItemsFacade), i0.ɵɵdirectiveInject(i1.InputResetContextService), i0.ɵɵdirectiveInject(i1.FilterContextService), i0.ɵɵdirectiveInject(i1.PlansService)); };
PlanFilterItemsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanFilterItemsComponent, selectors: [["vnext-plan-filter-items"]], viewQuery: function PlanFilterItemsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(CheckboxGroupComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.checkboxGroups = _t);
    } }, inputs: { filterDayText: "filterDayText", selectFilterDayText: "selectFilterDayText", filterCarrierText: "filterCarrierText", planSubTypeLabel: "planSubTypeLabel", planTypeLabel: "planTypeLabel", snpBaseTypeLabel: "snpBaseTypeLabel", licensingHeaderText: "licensingHeaderText", currentTab: "currentTab", snpEnabled: "snpEnabled", additionalSavingsHeaderText: "additionalSavingsHeaderText", insulinSavingsEnabled: "insulinSavingsEnabled", filterDSNPMedicaidCodesEnabled: "filterDSNPMedicaidCodesEnabled", showAllMedSupEnabled: "showAllMedSupEnabled", costFilterEnabled: "costFilterEnabled", medicalDeductibleHeaderText: "medicalDeductibleHeaderText", medicalDeductibleToolTipText: "medicalDeductibleToolTipText", maximumOutOfPocketCostHeaderText: "maximumOutOfPocketCostHeaderText", maximumOutOfPocketCostToolTipText: "maximumOutOfPocketCostToolTipText", drugDeductibleHeaderText: "drugDeductibleHeaderText", drugDeductibleToolTipText: "drugDeductibleToolTipText", premiumHeaderText: "premiumHeaderText", premiumToolTipText: "premiumToolTipText", defaultPlanBenefitFilters: "defaultPlanBenefitFilters", defaultPlanBenefitFiltersEnabled: "defaultPlanBenefitFiltersEnabled", addOnTooltipText: "addOnTooltipText", addOnFilterHeaderText: "addOnFilterHeaderText", addOnFilterEnabled: "addOnFilterEnabled", providersNpiHeaderText: "providersNpiHeaderText", providersNpiFilterEnabled: "providersNpiFilterEnabled", providersEnabled: "providersEnabled", providersNpiTooltipText: "providersNpiTooltipText", allInNetworkLocationsEnabled: "allInNetworkLocationsEnabled" }, outputs: { filterItemClicked: "filterItemClicked" }, features: [i0.ɵɵNgOnChangesFeature], decls: 24, vars: 38, consts: [[3, "formGroup"], [4, "ngIf"], [1, "Spa_Style_H4", "ml-1", "mt-2", "mb-2"], ["class", "pl-1", 4, "ngIf"], [1, "plan-filter-items", "no-translate-block", 3, "items", "formControlName", "parentId", "showTooltipUnderline", "enablePrimaryColor", "change"], [1, "pl-1"], ["providersNpiTooltip", ""], ["tabindex", "0", "aria-labelledby", "providersNpiTooltipId", "role", "tooltip", 1, "fas", "Spa_Style_QuestionIcon", 3, "ngbTooltip"], ["id", "providersNpiTooltipId", "navigationAdapter", "", 1, "Spa_Style_ToolTip", 3, "innerHtml"], [1, "plan-filter-items", 3, "items", "formControlName", "parentId", "showTooltipUnderline", "enablePrimaryColor", "change"], ["medicalDeductibleTooltip", ""], ["tabindex", "0", "role", "tooltip", "aria-labelledby", "medicalDeductibleToolTipId", 1, "fas", "Spa_Style_QuestionIcon", 3, "ngbTooltip"], ["id", "medicalDeductibleToolTipId", "navigationAdapter", "", 1, "Spa_Style_ToolTip", 3, "innerHtml"], ["maximumOutOfPocketCostTooltip", ""], ["tabindex", "0", "role", "tooltip", "aria-labelledby", "maximumOutOfPocketCostToolTipId", 1, "fas", "Spa_Style_QuestionIcon", 3, "ngbTooltip"], ["id", "maximumOutOfPocketCostToolTipId", "navigationAdapter", "", 1, "Spa_Style_ToolTip", 3, "innerHtml"], ["drugDeductibleTooltip", ""], ["tabindex", "0", "role", "tooltip", "aria-labelledby", "drugDeductibleToolTipId", 1, "fas", "Spa_Style_QuestionIcon", 3, "ngbTooltip"], ["id", "drugDeductibleToolTipId", "navigationAdapter", "", 1, "Spa_Style_ToolTip", 3, "innerHtml"], ["premiumTooltip", ""], ["tabindex", "0", "aria-labelledby", "premiumToolTipId", "role", "tooltip", 1, "fas", "Spa_Style_QuestionIcon", 3, "ngbTooltip"], ["id", "premiumToolTipId", "navigationAdapter", "", 1, "Spa_Style_ToolTip", 3, "innerHtml"], ["addOnTooltip", ""], ["tabindex", "0", "aria-labelledby", "addOnTooltipId", "role", "tooltip", 1, "fas", "Spa_Style_QuestionIcon", 3, "ngbTooltip"], ["id", "addOnTooltipId", "navigationAdapter", "", 1, "Spa_Style_ToolTip", 3, "innerHtml"], [1, "additional-savings-filter-wrapper"], [1, "plan-filter-items", 3, "items", "formControlName", "parentId", "showTooltipUnderline", "enablePrimaryColor", "noTranslateBlock", "change"], ["class", "sub-items", 4, "ngIf"], [1, "sub-items"], ["class", "sub-items", "id", "dsnpFilterContainer", 4, "ngIf"], ["id", "dsnpFilterContainer", 1, "sub-items"], [1, "plan-filter-items", 3, "highlightedItems", "items", "formControlName", "parentId", "showTooltipUnderline", "enablePrimaryColor", "change"]], template: function PlanFilterItemsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 0);
        i0.ɵɵtemplate(1, PlanFilterItemsComponent_div_1_Template, 2, 1, "div", 1);
        i0.ɵɵpipe(2, "async");
        i0.ɵɵtemplate(3, PlanFilterItemsComponent_div_3_Template, 5, 8, "div", 1);
        i0.ɵɵpipe(4, "async");
        i0.ɵɵtemplate(5, PlanFilterItemsComponent_ng_container_5_Template, 2, 1, "ng-container", 1);
        i0.ɵɵpipe(6, "async");
        i0.ɵɵtemplate(7, PlanFilterItemsComponent_ng_container_7_Template, 2, 1, "ng-container", 1);
        i0.ɵɵpipe(8, "async");
        i0.ɵɵtemplate(9, PlanFilterItemsComponent_ng_container_9_Template, 2, 1, "ng-container", 1);
        i0.ɵɵpipe(10, "async");
        i0.ɵɵtemplate(11, PlanFilterItemsComponent_ng_container_11_Template, 2, 1, "ng-container", 1);
        i0.ɵɵpipe(12, "async");
        i0.ɵɵpipe(13, "async");
        i0.ɵɵtemplate(14, PlanFilterItemsComponent_div_14_Template, 2, 1, "div", 1);
        i0.ɵɵpipe(15, "async");
        i0.ɵɵtemplate(16, PlanFilterItemsComponent_ng_container_16_Template, 6, 3, "ng-container", 1);
        i0.ɵɵtemplate(17, PlanFilterItemsComponent_ng_container_17_Template, 2, 1, "ng-container", 1);
        i0.ɵɵpipe(18, "async");
        i0.ɵɵtemplate(19, PlanFilterItemsComponent_ng_container_19_Template, 2, 1, "ng-container", 1);
        i0.ɵɵpipe(20, "async");
        i0.ɵɵtemplate(21, PlanFilterItemsComponent_ng_container_21_Template, 2, 1, "ng-container", 1);
        i0.ɵɵpipe(22, "async");
        i0.ɵɵtemplate(23, PlanFilterItemsComponent_ng_container_23_Template, 6, 6, "ng-container", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.filterForm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 13, ctx.providersNpiFilterEnabled && ctx.providersEnabled && ctx.providerNpiOptions$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.currentTabIsMedigap && i0.ɵɵpipeBind1(4, 15, ctx.showSellablePlanFilter$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(6, 17, ctx.costFilterEnabled && !ctx.currentTabIsPDP && ctx.medicalDeductible$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(8, 19, ctx.costFilterEnabled && !ctx.currentTabIsPDP && ctx.maximumOutOfPocketCost$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(10, 21, ctx.costFilterEnabled && ctx.currentTabIsPDP && ctx.drugDeductible$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.costFilterEnabled && i0.ɵɵpureFunction2(35, _c0$M, i0.ɵɵpipeBind1(12, 23, ctx.medicalPremium$), i0.ɵɵpipeBind1(13, 25, ctx.drugPremium$)));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(15, 27, ctx.addOnFilterEnabled && ctx.ridersOptions$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.defaultPlanBenefitFiltersEnabled && ((ctx.allPlanBenefitFilter.modelDrugPrograms == null ? null : ctx.allPlanBenefitFilter.modelDrugPrograms.length) || (ctx.allPlanBenefitFilter.defaultPlanBenefits == null ? null : ctx.allPlanBenefitFilter.defaultPlanBenefits.length)));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(18, 29, ctx.carriers$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(20, 31, !(ctx.showAllMedSupEnabled && ctx.currentTabIsMedigap) && ctx.displayPlanSubTypes && ctx.planSubTypes$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(22, 33, ctx.displayDentalVisionFilters && ctx.ancillaryPlanTypes$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.snpEnabled);
    } }, dependencies: [i1$2.NgIf, i4.ɵNgNoValidate, i4.NgControlStatus, i4.NgControlStatusGroup, i4.FormGroupDirective, i4.FormControlName, CheckboxGroupComponent, NavigationAdapterDirective, i1$1.NgbTooltip, i1$2.AsyncPipe, SafePipe], styles: [".sub-items[_ngcontent-%COMP%]{margin-left:15px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanFilterItemsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-filter-items', changeDetection: ChangeDetectionStrategy.OnPush, template: "<form [formGroup]=\"filterForm\">\r\n  <div *ngIf=\"providersNpiFilterEnabled && providersEnabled && providerNpiOptions$ | async as providerNpiOptions\">\r\n    <div *ngIf=\"providerNpiOptions.length\">\r\n      <h3 class=\"Spa_Style_H4 ml-1 mt-2 mb-2\">\r\n        {{ providersNpiHeaderText }}\r\n        <span class=\"pl-1\" *ngIf=\"medicalDeductibleToolTipText\">\r\n          <ng-template #providersNpiTooltip>\r\n            <div\r\n              id=\"providersNpiTooltipId\"\r\n              [innerHtml]=\"providersNpiTooltipText | safe : 'html'\"\r\n              class=\"Spa_Style_ToolTip\"\r\n              navigationAdapter\r\n            ></div>\r\n          </ng-template>\r\n          <i\r\n            class=\"fas Spa_Style_QuestionIcon\"\r\n            [ngbTooltip]=\"providersNpiTooltip\"\r\n            tabindex=\"0\"\r\n            aria-labelledby=\"providersNpiTooltipId\"\r\n            role=\"tooltip\"\r\n          ></i>\r\n        </span>\r\n      </h3>\r\n      <vnext-checkbox-group\r\n        [items]=\"providerNpiOptions\"\r\n        class=\"plan-filter-items no-translate-block\"\r\n        (change)=\"onFilterSelected(providersNpiName)\"\r\n        formControlName=\"{{ providersNpiName }}\"\r\n        [parentId]=\"providersNpiName\"\r\n        [showTooltipUnderline]=\"true\"\r\n        [enablePrimaryColor]=\"true\"\r\n      >\r\n      </vnext-checkbox-group>\r\n    </div>\r\n  </div>\r\n  <div *ngIf=\"!currentTabIsMedigap && (showSellablePlanFilter$ | async)\">\r\n    <h3 class=\"Spa_Style_H4 ml-1 mt-2 mb-2\">\r\n      {{ licensingHeaderText }}\r\n    </h3>\r\n    <vnext-checkbox-group\r\n      [items]=\"planSellable$ | async\"\r\n      class=\"plan-filter-items\"\r\n      (change)=\"onFilterSelected(sellableControlName)\"\r\n      formControlName=\"{{ sellableControlName }}\"\r\n      [parentId]=\"sellableControlName\"\r\n      [showTooltipUnderline]=\"true\"\r\n      [enablePrimaryColor]=\"true\"\r\n    >\r\n    </vnext-checkbox-group>\r\n  </div>\r\n  <ng-container *ngIf=\"costFilterEnabled && !currentTabIsPDP && medicalDeductible$ | async as medicalDeductible\">\r\n    <div *ngIf=\"medicalDeductible.length\">\r\n      <h3 class=\"Spa_Style_H4 ml-1 mt-2 mb-2\">\r\n        {{ medicalDeductibleHeaderText }}\r\n        <span class=\"pl-1\" *ngIf=\"medicalDeductibleToolTipText\">\r\n          <ng-template #medicalDeductibleTooltip>\r\n            <div\r\n              id=\"medicalDeductibleToolTipId\"\r\n              [innerHtml]=\"medicalDeductibleToolTipText | safe : 'html'\"\r\n              class=\"Spa_Style_ToolTip\"\r\n              navigationAdapter\r\n            ></div>\r\n          </ng-template>\r\n          <i\r\n            class=\"fas Spa_Style_QuestionIcon\"\r\n            [ngbTooltip]=\"medicalDeductibleTooltip\"\r\n            tabindex=\"0\"\r\n            role=\"tooltip\"\r\n            aria-labelledby=\"medicalDeductibleToolTipId\"\r\n          ></i>\r\n        </span>\r\n      </h3>\r\n      <vnext-checkbox-group\r\n        [items]=\"medicalDeductible\"\r\n        class=\"plan-filter-items\"\r\n        (change)=\"onFilterSelected(medicalDeductibleControlName)\"\r\n        formControlName=\"{{ medicalDeductibleControlName }}\"\r\n        [parentId]=\"medicalDeductibleControlName\"\r\n        [showTooltipUnderline]=\"true\"\r\n        [enablePrimaryColor]=\"true\"\r\n      >\r\n      </vnext-checkbox-group>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"costFilterEnabled && !currentTabIsPDP && maximumOutOfPocketCost$ | async as maximumOutOfPocketCost\">\r\n    <div *ngIf=\"maximumOutOfPocketCost.length\">\r\n      <h3 class=\"Spa_Style_H4 ml-1 mt-2 mb-2\">\r\n        {{ maximumOutOfPocketCostHeaderText }}\r\n        <span class=\"pl-1\" *ngIf=\"maximumOutOfPocketCostToolTipText\">\r\n          <ng-template #maximumOutOfPocketCostTooltip>\r\n            <div\r\n              id=\"maximumOutOfPocketCostToolTipId\"\r\n              [innerHtml]=\"maximumOutOfPocketCostToolTipText | safe : 'html'\"\r\n              class=\"Spa_Style_ToolTip\"\r\n              navigationAdapter\r\n            ></div>\r\n          </ng-template>\r\n          <i\r\n            class=\"fas Spa_Style_QuestionIcon\"\r\n            [ngbTooltip]=\"maximumOutOfPocketCostTooltip\"\r\n            tabindex=\"0\"\r\n            role=\"tooltip\"\r\n            aria-labelledby=\"maximumOutOfPocketCostToolTipId\"\r\n          ></i>\r\n        </span>\r\n      </h3>\r\n      <vnext-checkbox-group\r\n        [items]=\"maximumOutOfPocketCost\"\r\n        class=\"plan-filter-items\"\r\n        (change)=\"onFilterSelected(maximumOutOfPocketCostControlName)\"\r\n        formControlName=\"{{ maximumOutOfPocketCostControlName }}\"\r\n        [parentId]=\"maximumOutOfPocketCostControlName\"\r\n        [showTooltipUnderline]=\"true\"\r\n        [enablePrimaryColor]=\"true\"\r\n      >\r\n      </vnext-checkbox-group>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"costFilterEnabled && currentTabIsPDP && drugDeductible$ | async as drugDeductible\">\r\n    <div *ngIf=\"drugDeductible.length\">\r\n      <h3 class=\"Spa_Style_H4 ml-1 mt-2 mb-2\">\r\n        {{ drugDeductibleHeaderText }}\r\n        <span class=\"pl-1\" *ngIf=\"drugDeductibleToolTipText\">\r\n          <ng-template #drugDeductibleTooltip>\r\n            <div\r\n              id=\"drugDeductibleToolTipId\"\r\n              [innerHtml]=\"drugDeductibleToolTipText | safe : 'html'\"\r\n              class=\"Spa_Style_ToolTip\"\r\n              navigationAdapter\r\n            ></div>\r\n          </ng-template>\r\n          <i\r\n            class=\"fas Spa_Style_QuestionIcon\"\r\n            [ngbTooltip]=\"drugDeductibleTooltip\"\r\n            tabindex=\"0\"\r\n            role=\"tooltip\"\r\n            aria-labelledby=\"drugDeductibleToolTipId\"\r\n          ></i>\r\n        </span>\r\n      </h3>\r\n      <vnext-checkbox-group\r\n        [items]=\"drugDeductible\"\r\n        class=\"plan-filter-items\"\r\n        (change)=\"onFilterSelected(drugDeductibleControlName)\"\r\n        formControlName=\"{{ drugDeductibleControlName }}\"\r\n        [parentId]=\"drugDeductibleControlName\"\r\n        [showTooltipUnderline]=\"true\"\r\n        [enablePrimaryColor]=\"true\"\r\n      >\r\n      </vnext-checkbox-group>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"costFilterEnabled && { medicalPremium: medicalPremium$ | async, drugPremium: drugPremium$ | async } as premium\">\r\n    <div *ngIf=\"premium.medicalPremium?.length || premium.drugPremium?.length\">\r\n      <h3 class=\"Spa_Style_H4 ml-1 mt-2 mb-2\">\r\n        {{ premiumHeaderText }}\r\n        <span class=\"pl-1\" *ngIf=\"premiumToolTipText\">\r\n          <ng-template #premiumTooltip>\r\n            <div id=\"premiumToolTipId\" [innerHtml]=\"premiumToolTipText | safe : 'html'\" class=\"Spa_Style_ToolTip\" navigationAdapter></div>\r\n          </ng-template>\r\n          <i\r\n            class=\"fas Spa_Style_QuestionIcon\"\r\n            [ngbTooltip]=\"premiumTooltip\"\r\n            tabindex=\"0\"\r\n            aria-labelledby=\"premiumToolTipId\"\r\n            role=\"tooltip\"\r\n          ></i>\r\n        </span>\r\n      </h3>\r\n      <div *ngIf=\"currentTabIsPDP && premium.drugPremium?.length\">\r\n        <vnext-checkbox-group\r\n          [items]=\"premium.drugPremium\"\r\n          class=\"plan-filter-items\"\r\n          (change)=\"onFilterSelected(drugPremiumControlName)\"\r\n          formControlName=\"{{ drugPremiumControlName }}\"\r\n          [parentId]=\"drugPremiumControlName\"\r\n          [showTooltipUnderline]=\"true\"\r\n          [enablePrimaryColor]=\"true\"\r\n        >\r\n        </vnext-checkbox-group>\r\n      </div>\r\n      <div *ngIf=\"!currentTabIsPDP && premium.medicalPremium?.length\">\r\n        <vnext-checkbox-group\r\n          [items]=\"premium.medicalPremium\"\r\n          class=\"plan-filter-items\"\r\n          (change)=\"onFilterSelected(medicalPremiumControlName)\"\r\n          formControlName=\"{{ medicalPremiumControlName }}\"\r\n          [parentId]=\"medicalPremiumControlName\"\r\n          [showTooltipUnderline]=\"true\"\r\n          [enablePrimaryColor]=\"true\"\r\n        >\r\n        </vnext-checkbox-group>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <div *ngIf=\"addOnFilterEnabled && ridersOptions$ | async as ridersOptions\">\r\n    <div *ngIf=\"ridersOptions.length\">\r\n      <h3 class=\"Spa_Style_H4 ml-1 mt-2 mb-2\">\r\n        {{ addOnFilterHeaderText }}\r\n        <span class=\"pl-1\" *ngIf=\"addOnTooltipText\">\r\n          <ng-template #addOnTooltip>\r\n            <div id=\"addOnTooltipId\" [innerHtml]=\"addOnTooltipText | safe : 'html'\" class=\"Spa_Style_ToolTip\" navigationAdapter></div>\r\n          </ng-template>\r\n          <i\r\n            class=\"fas Spa_Style_QuestionIcon\"\r\n            [ngbTooltip]=\"addOnTooltip\"\r\n            tabindex=\"0\"\r\n            aria-labelledby=\"addOnTooltipId\"\r\n            role=\"tooltip\"\r\n          ></i>\r\n        </span>\r\n      </h3>\r\n      <vnext-checkbox-group\r\n        [items]=\"ridersOptions\"\r\n        class=\"plan-filter-items\"\r\n        (change)=\"onFilterSelected(ridersPlanSubtypeName)\"\r\n        formControlName=\"{{ ridersPlanSubtypeName }}\"\r\n        [parentId]=\"ridersPlanSubtypeName\"\r\n        [showTooltipUnderline]=\"true\"\r\n        [enablePrimaryColor]=\"true\"\r\n      >\r\n      </vnext-checkbox-group>\r\n    </div>\r\n  </div>\r\n\r\n  <ng-container\r\n    *ngIf=\"\r\n      defaultPlanBenefitFiltersEnabled &&\r\n      (allPlanBenefitFilter.modelDrugPrograms?.length || allPlanBenefitFilter.defaultPlanBenefits?.length)\r\n    \"\r\n  >\r\n    <div class=\"additional-savings-filter-wrapper\">\r\n      <h3 class=\"Spa_Style_H4 ml-1 mt-2 mb-2\">{{ additionalSavingsHeaderText }}</h3>\r\n      <div *ngIf=\"insulinSavingsEnabled && allPlanBenefitFilter.modelDrugPrograms?.length\">\r\n        <vnext-checkbox-group\r\n          [items]=\"allPlanBenefitFilter.modelDrugPrograms\"\r\n          class=\"plan-filter-items\"\r\n          (change)=\"onFilterSelected(extraDataControlName)\"\r\n          formControlName=\"{{ extraDataControlName }}\"\r\n          [parentId]=\"extraDataControlName\"\r\n          [showTooltipUnderline]=\"true\"\r\n          [enablePrimaryColor]=\"true\"\r\n        >\r\n        </vnext-checkbox-group>\r\n      </div>\r\n      <div *ngIf=\"allPlanBenefitFilter.defaultPlanBenefits?.length\">\r\n        <vnext-checkbox-group\r\n          [items]=\"allPlanBenefitFilter.defaultPlanBenefits\"\r\n          class=\"plan-filter-items\"\r\n          (change)=\"onFilterSelected(planBenefitsControlName)\"\r\n          formControlName=\"{{ planBenefitsControlName }}\"\r\n          [parentId]=\"planBenefitsControlName\"\r\n          [showTooltipUnderline]=\"true\"\r\n          [enablePrimaryColor]=\"true\"\r\n        >\r\n        </vnext-checkbox-group>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"carriers$ | async as carriers\">\r\n    <div *ngIf=\"carriers.length > 1\">\r\n      <h3 class=\"Spa_Style_H4 ml-1 mt-2 mb-2\">\r\n        {{ filterCarrierText }}\r\n      </h3>\r\n      <vnext-checkbox-group\r\n        [items]=\"carriers\"\r\n        class=\"plan-filter-items\"\r\n        (change)=\"onFilterSelected(carriersControlName)\"\r\n        formControlName=\"{{ carriersControlName }}\"\r\n        [parentId]=\"carriersControlName\"\r\n        [showTooltipUnderline]=\"true\"\r\n        [enablePrimaryColor]=\"true\"\r\n        [noTranslateBlock]=\"true\"\r\n      >\r\n      </vnext-checkbox-group>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"!(showAllMedSupEnabled && currentTabIsMedigap) && displayPlanSubTypes && planSubTypes$ | async as planSubTypes\">\r\n    <div *ngIf=\"planSubTypes.length > 1\">\r\n      <h3 class=\"Spa_Style_H4 ml-1 mt-2 mb-2\">\r\n        {{ planSubTypeLabel }}\r\n      </h3>\r\n      <vnext-checkbox-group\r\n        [items]=\"planSubTypes\"\r\n        class=\"plan-filter-items\"\r\n        (change)=\"onFilterSelected(subTypesControlName)\"\r\n        formControlName=\"{{ subTypesControlName }}\"\r\n        [parentId]=\"subTypesControlName\"\r\n        [showTooltipUnderline]=\"true\"\r\n        [enablePrimaryColor]=\"true\"\r\n      >\r\n      </vnext-checkbox-group>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"displayDentalVisionFilters && ancillaryPlanTypes$ | async as ancillaryPlanTypes\">\r\n    <div *ngIf=\"ancillaryPlanTypes.length > 1\">\r\n      <h3 class=\"Spa_Style_H4 ml-1 mt-2 mb-2\">\r\n        {{ planTypeLabel }}\r\n      </h3>\r\n      <vnext-checkbox-group\r\n        [items]=\"ancillaryPlanTypes\"\r\n        class=\"plan-filter-items\"\r\n        (change)=\"onFilterSelected(ancillaryPlanTypeControlName)\"\r\n        formControlName=\"{{ ancillaryPlanTypeControlName }}\"\r\n        [parentId]=\"ancillaryPlanTypeControlName\"\r\n        [showTooltipUnderline]=\"true\"\r\n        [enablePrimaryColor]=\"true\"\r\n      >\r\n      </vnext-checkbox-group>\r\n    </div>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"snpEnabled\">\r\n    <ng-container *ngIf=\"(snpBaseTypes$ | async).length\">\r\n      <h3 class=\"Spa_Style_H4 ml-1 mt-2 mb-2\">\r\n        {{ snpBaseTypeLabel }}\r\n      </h3>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"cSNPBaseTypes\">\r\n      <div *ngIf=\"cSNPBaseTypes.length >= 1\">\r\n        <vnext-checkbox-group\r\n          [items]=\"cSNPBaseTypes\"\r\n          class=\"plan-filter-items\"\r\n          (change)=\"onSnpSubFilterSelected(snpBaseTypesControlName, snpSubTypesControlName)\"\r\n          formControlName=\"{{ snpBaseTypesControlName }}\"\r\n          [parentId]=\"snpBaseTypesControlName\"\r\n          [showTooltipUnderline]=\"true\"\r\n          [enablePrimaryColor]=\"true\"\r\n        >\r\n        </vnext-checkbox-group>\r\n        <ng-container *ngIf=\"cSNPSubTypes\">\r\n          <div *ngIf=\"cSNPSubTypes.length >= 1\" class=\"sub-items\">\r\n            <vnext-checkbox-group\r\n              [items]=\"cSNPSubTypes\"\r\n              class=\"plan-filter-items\"\r\n              (change)=\"onSnpSubFilterSelected(snpBaseTypesControlName, snpSubTypesControlName)\"\r\n              formControlName=\"{{ snpSubTypesControlName }}\"\r\n              [parentId]=\"snpSubTypesControlName\"\r\n              [showTooltipUnderline]=\"true\"\r\n              [enablePrimaryColor]=\"true\"\r\n            >\r\n            </vnext-checkbox-group>\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"dSNPBaseTypes\">\r\n      <div *ngIf=\"dSNPBaseTypes.length >= 1\">\r\n        <vnext-checkbox-group\r\n          [items]=\"dSNPBaseTypes\"\r\n          class=\"plan-filter-items\"\r\n          (change)=\"onSnpSubFilterSelected(snpBaseTypesControlName)\"\r\n          formControlName=\"{{ snpBaseTypesControlName }}\"\r\n          [parentId]=\"snpBaseTypesControlName\"\r\n          [showTooltipUnderline]=\"true\"\r\n          [enablePrimaryColor]=\"true\"\r\n        >\r\n        </vnext-checkbox-group>\r\n        <ng-container *ngIf=\"dSNPSubTypes\">\r\n          <!--This ID is used by a notice in plan list component to scrollIntoView-->\r\n          <div *ngIf=\"dSNPSubTypes.length >= 1\" class=\"sub-items\" id=\"dsnpFilterContainer\">\r\n            <vnext-checkbox-group\r\n              [highlightedItems]=\"highlightedDSNPCodes\"\r\n              [items]=\"dSNPSubTypes\"\r\n              class=\"plan-filter-items\"\r\n              (change)=\"onSnpSubFilterSelected(snpBaseTypesControlName, dsnpSubTypesControlName)\"\r\n              formControlName=\"{{ dsnpSubTypesControlName }}\"\r\n              [parentId]=\"dsnpSubTypesControlName\"\r\n              [showTooltipUnderline]=\"true\"\r\n              [enablePrimaryColor]=\"true\"\r\n            >\r\n            </vnext-checkbox-group>\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"iSNPBaseTypes\">\r\n      <div *ngIf=\"iSNPBaseTypes.length >= 1\">\r\n        <vnext-checkbox-group\r\n          [items]=\"iSNPBaseTypes\"\r\n          class=\"plan-filter-items\"\r\n          (change)=\"onSnpSubFilterSelected(snpBaseTypesControlName, snpSubTypesControlName)\"\r\n          formControlName=\"{{ snpBaseTypesControlName }}\"\r\n          [parentId]=\"snpBaseTypesControlName\"\r\n          [showTooltipUnderline]=\"true\"\r\n          [enablePrimaryColor]=\"true\"\r\n        >\r\n        </vnext-checkbox-group>\r\n        <ng-container *ngIf=\"iSNPSubTypes\">\r\n          <div *ngIf=\"iSNPSubTypes.length >= 1\" class=\"sub-items\">\r\n            <vnext-checkbox-group\r\n              [items]=\"iSNPSubTypes\"\r\n              class=\"plan-filter-items\"\r\n              (change)=\"onSnpSubFilterSelected(snpBaseTypesControlName, snpSubTypesControlName)\"\r\n              formControlName=\"{{ snpSubTypesControlName }}\"\r\n              [parentId]=\"snpSubTypesControlName\"\r\n              [showTooltipUnderline]=\"true\"\r\n              [enablePrimaryColor]=\"true\"\r\n            >\r\n            </vnext-checkbox-group>\r\n          </div>\r\n        </ng-container>\r\n      </div> </ng-container\r\n  ></ng-container>\r\n</form>\r\n", styles: [".sub-items{margin-left:15px}\n"] }]
    }], function () { return [{ type: i1.FilterService }, { type: i0.ChangeDetectorRef }, { type: PlanFilterItemsFacade }, { type: i1.InputResetContextService }, { type: i1.FilterContextService }, { type: i1.PlansService }]; }, { filterDayText: [{
            type: Input
        }], selectFilterDayText: [{
            type: Input
        }], filterCarrierText: [{
            type: Input
        }], planSubTypeLabel: [{
            type: Input
        }], planTypeLabel: [{
            type: Input
        }], snpBaseTypeLabel: [{
            type: Input
        }], licensingHeaderText: [{
            type: Input
        }], currentTab: [{
            type: Input
        }], snpEnabled: [{
            type: Input
        }], additionalSavingsHeaderText: [{
            type: Input
        }], insulinSavingsEnabled: [{
            type: Input
        }], filterDSNPMedicaidCodesEnabled: [{
            type: Input
        }], showAllMedSupEnabled: [{
            type: Input
        }], costFilterEnabled: [{
            type: Input
        }], medicalDeductibleHeaderText: [{
            type: Input
        }], medicalDeductibleToolTipText: [{
            type: Input
        }], maximumOutOfPocketCostHeaderText: [{
            type: Input
        }], maximumOutOfPocketCostToolTipText: [{
            type: Input
        }], drugDeductibleHeaderText: [{
            type: Input
        }], drugDeductibleToolTipText: [{
            type: Input
        }], premiumHeaderText: [{
            type: Input
        }], premiumToolTipText: [{
            type: Input
        }], defaultPlanBenefitFilters: [{
            type: Input
        }], defaultPlanBenefitFiltersEnabled: [{
            type: Input
        }], addOnTooltipText: [{
            type: Input
        }], addOnFilterHeaderText: [{
            type: Input
        }], addOnFilterEnabled: [{
            type: Input
        }], providersNpiHeaderText: [{
            type: Input
        }], providersNpiFilterEnabled: [{
            type: Input
        }], providersEnabled: [{
            type: Input
        }], providersNpiTooltipText: [{
            type: Input
        }], allInNetworkLocationsEnabled: [{
            type: Input
        }], filterItemClicked: [{
            type: Output
        }], checkboxGroups: [{
            type: ViewChildren,
            args: [CheckboxGroupComponent]
        }] }); })();

const _c0$L = function (a0, a1) { return { "fa-angle-up": a0, "fa-angle-down": a1 }; };
function PlanFilterComponent_ng_container_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "h2", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "i", 8);
    i0.ɵɵelementStart(4, "span", 9);
    i0.ɵɵtext(5, "Expand/Collapse");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.filterHeaderText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c0$L, ctx_r2.isPanelExpanded, !ctx_r2.isPanelExpanded));
} }
function PlanFilterComponent_ng_container_0_ng_template_5_vnext_link_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 15);
    i0.ɵɵlistener("click", function PlanFilterComponent_ng_container_0_ng_template_5_vnext_link_2_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r8.onClearFilters()); })("keyup.enter", function PlanFilterComponent_ng_container_0_ng_template_5_vnext_link_2_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r10.onClearFilters()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("title", ctx_r4.filterClearAll)("makeInlineBlock", true)("ariaLabel", ctx_r4.filterClearAll)("role", ctx_r4.linkRoles.BUTTON);
} }
function PlanFilterComponent_ng_container_0_ng_template_5_vnext_plan_filter_items_3_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-plan-filter-items", 16);
    i0.ɵɵlistener("filterItemClicked", function PlanFilterComponent_ng_container_0_ng_template_5_vnext_plan_filter_items_3_Template_vnext_plan_filter_items_filterItemClicked_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r11.filterClicked()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("planSubTypeLabel", ctx_r5.planSubTypeLabel)("filterDayText", ctx_r5.filterDayText)("selectFilterDayText", ctx_r5.selectFilterDayText)("filterCarrierText", ctx_r5.filterCarrierText)("licensingHeaderText", ctx_r5.licensingHeaderText)("snpBaseTypeLabel", ctx_r5.snpBaseTypeLabel)("currentTab", ctx_r5.currentTab)("snpEnabled", ctx_r5.snpEnabled)("defaultPlanBenefitFilters", ctx_r5.defaultPlanBenefitFilters)("defaultPlanBenefitFiltersEnabled", ctx_r5.defaultPlanBenefitFiltersEnabled)("additionalSavingsHeaderText", ctx_r5.additionalSavingsHeaderText)("insulinSavingsEnabled", ctx_r5.insulinSavingsEnabled)("filterDSNPMedicaidCodesEnabled", ctx_r5.filterDSNPMedicaidCodesEnabled)("costFilterEnabled", ctx_r5.costFilterEnabled)("medicalDeductibleHeaderText", ctx_r5.medicalDeductibleHeaderText)("medicalDeductibleToolTipText", ctx_r5.medicalDeductibleToolTipText)("maximumOutOfPocketCostHeaderText", ctx_r5.maximumOutOfPocketCostHeaderText)("maximumOutOfPocketCostToolTipText", ctx_r5.maximumOutOfPocketCostToolTipText)("drugDeductibleHeaderText", ctx_r5.drugDeductibleHeaderText)("drugDeductibleToolTipText", ctx_r5.drugDeductibleToolTipText)("premiumHeaderText", ctx_r5.premiumHeaderText)("premiumToolTipText", ctx_r5.premiumToolTipText)("addOnFilterHeaderText", ctx_r5.addOnFilterHeaderText)("addOnFilterEnabled", ctx_r5.addOnFilterEnabled)("addOnTooltipText", ctx_r5.addOnTooltipText)("providersNpiHeaderText", ctx_r5.providersNpiHeaderText)("providersNpiFilterEnabled", ctx_r5.providersNpiFilterEnabled)("providersEnabled", ctx_r5.providersEnabled)("providersNpiTooltipText", ctx_r5.providersNpiTooltipText)("planTypeLabel", ctx_r5.planTypeLabel)("allInNetworkLocationsEnabled", ctx_r5.allInNetworkLocationsEnabled);
} }
function PlanFilterComponent_ng_container_0_ng_template_5_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r7.defaultFilterText);
} }
function PlanFilterComponent_ng_container_0_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 11);
    i0.ɵɵtemplate(2, PlanFilterComponent_ng_container_0_ng_template_5_vnext_link_2_Template, 1, 4, "vnext-link", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PlanFilterComponent_ng_container_0_ng_template_5_vnext_plan_filter_items_3_Template, 1, 31, "vnext-plan-filter-items", 13);
    i0.ɵɵtemplate(4, PlanFilterComponent_ng_container_0_ng_template_5_ng_template_4_Template, 2, 1, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r6 = i0.ɵɵreference(5);
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.showFilter);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.showFilter)("ngIfElse", _r6);
} }
function PlanFilterComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ngb-accordion", 1, 2);
    i0.ɵɵlistener("panelChange", function PlanFilterComponent_ng_container_0_Template_ngb_accordion_panelChange_1_listener() { i0.ɵɵrestoreView(_r14); const _r1 = i0.ɵɵreference(2); const ctx_r13 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r13.togglePanelIcon(_r1)); });
    i0.ɵɵelementStart(3, "ngb-panel", 3);
    i0.ɵɵtemplate(4, PlanFilterComponent_ng_container_0_ng_template_4_Template, 6, 5, "ng-template", 4);
    i0.ɵɵtemplate(5, PlanFilterComponent_ng_container_0_ng_template_5_Template, 6, 3, "ng-template", 5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("activeIds", ctx_r0.isTabFilterExpanded ? ctx_r0.panelId : "");
} }
class PlanFilterComponent {
    constructor(filterService, store, plansService) {
        this.filterService = filterService;
        this.store = store;
        this.plansService = plansService;
        this.filterItemClicked = new EventEmitter();
        this.clearAllFiltersClicked = new EventEmitter();
        this.showFilter = false;
        this.linkRoles = LinkRoles;
        this.panelId = 'filter-panel';
    }
    ngOnChanges(changes) {
        const { currentTab, showNoPlansFromAnswersMessage, showEmptyFilterMessage } = changes;
        if ((currentTab && !_isEqual(currentTab.previousValue, currentTab.currentValue)) ||
            (showNoPlansFromAnswersMessage && showNoPlansFromAnswersMessage.previousValue !== showNoPlansFromAnswersMessage.currentValue) ||
            (showEmptyFilterMessage && showEmptyFilterMessage.previousValue !== showEmptyFilterMessage.currentValue)) {
            this.clearTab = this.currentTab?.filters;
            this.showFilter = this.getShowFilter();
        }
    }
    ngOnInit() {
        this.togglePanelIcon(this.filterPanel);
    }
    onClearFilters() {
        // clear all filters.
        this.filterService.clearFilterGroupFilters(this.clearTab);
        this.clearAllFiltersClicked.emit();
    }
    filterClicked() {
        this.filterItemClicked.emit();
    }
    getShowFilter() {
        return this.clearTab?.length > 0 &&
            this.clearTab[0].values?.some(tabType => [...ANCILLARY_PLANS, PlanTypeAbbreviation.MEDIGAP, PlanTypeAbbreviation.HC].includes(tabType)) &&
            this.showNoPlansFromAnswersMessage
            ? false
            : !this.showEmptyFilterMessage;
    }
    togglePanelIcon(panel) {
        // Event emitted right before the panel toggle happens
        this.isPanelExpanded = !panel?.isExpanded(this.panelId);
    }
    hasMedSupAnswers() {
        return this.plansService.getHasMedSupAnswers();
    }
    hasAncillaryAnswers() {
        return this.plansService.getHasAncillaryPlanAnswers();
    }
    hasHospitalIndemnityAnswers() {
        return this.plansService.getHasHospitalIndemnityAnswers();
    }
    isCurrentTabMedSup() {
        return this.clearTab?.[0].values?.includes(PlanTypeAbbreviation.MEDIGAP);
    }
    isCurrentTabAncillaryPlan() {
        return this.clearTab?.[0].values?.some(tabType => ANCILLARY_PLANS.includes(tabType));
    }
    isCurrentTabHospitalIndemnityPlan() {
        return this.clearTab?.[0].values?.includes(PlanTypeAbbreviation.HC);
    }
}
PlanFilterComponent.ɵfac = function PlanFilterComponent_Factory(t) { return new (t || PlanFilterComponent)(i0.ɵɵdirectiveInject(i1.FilterService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.PlansService)); };
PlanFilterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanFilterComponent, selectors: [["vnext-plan-filter"]], viewQuery: function PlanFilterComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(NgbAccordion, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.filterPanel = _t.first);
    } }, inputs: { filterDayText: "filterDayText", selectFilterDayText: "selectFilterDayText", filterCarrierText: "filterCarrierText", defaultFilterText: "defaultFilterText", filterHeaderText: "filterHeaderText", filterClearAll: "filterClearAll", planSubTypeLabel: "planSubTypeLabel", snpBaseTypeLabel: "snpBaseTypeLabel", showEmptyFilterMessage: "showEmptyFilterMessage", showNoPlansFromAnswersMessage: "showNoPlansFromAnswersMessage", licensingHeaderText: "licensingHeaderText", currentTab: "currentTab", snpEnabled: "snpEnabled", additionalSavingsHeaderText: "additionalSavingsHeaderText", defaultPlanBenefitFilters: "defaultPlanBenefitFilters", defaultPlanBenefitFiltersEnabled: "defaultPlanBenefitFiltersEnabled", insulinSavingsEnabled: "insulinSavingsEnabled", filterDSNPMedicaidCodesEnabled: "filterDSNPMedicaidCodesEnabled", costFilterEnabled: "costFilterEnabled", medicalDeductibleHeaderText: "medicalDeductibleHeaderText", medicalDeductibleToolTipText: "medicalDeductibleToolTipText", maximumOutOfPocketCostHeaderText: "maximumOutOfPocketCostHeaderText", maximumOutOfPocketCostToolTipText: "maximumOutOfPocketCostToolTipText", drugDeductibleHeaderText: "drugDeductibleHeaderText", drugDeductibleToolTipText: "drugDeductibleToolTipText", premiumHeaderText: "premiumHeaderText", premiumToolTipText: "premiumToolTipText", addOnFilterHeaderText: "addOnFilterHeaderText", addOnFilterEnabled: "addOnFilterEnabled", addOnTooltipText: "addOnTooltipText", isTabFilterExpanded: "isTabFilterExpanded", providersNpiHeaderText: "providersNpiHeaderText", providersNpiFilterEnabled: "providersNpiFilterEnabled", providersEnabled: "providersEnabled", providersNpiTooltipText: "providersNpiTooltipText", showTabFilter: "showTabFilter", planTypeLabel: "planTypeLabel", allInNetworkLocationsEnabled: "allInNetworkLocationsEnabled" }, outputs: { filterItemClicked: "filterItemClicked", clearAllFiltersClicked: "clearAllFiltersClicked" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "activeIds", "panelChange"], ["filterPanel", "ngbAccordion"], ["id", "filter-panel"], ["ngbPanelTitle", ""], ["ngbPanelContent", ""], [1, "d-flex", "justify-content-between", "can-click", "p-1"], [1, "Spa_Style_H3", "accordion-header", "py-2", "mb-0"], ["aria-hidden", "true", 1, "fas", "py-2", 3, "ngClass"], [1, "sr-only"], [1, "plan-filter-container"], [1, "text-right", "mt-2"], ["class", "can-click", 3, "title", "makeInlineBlock", "ariaLabel", "role", "click", "keyup.enter", 4, "ngIf"], [3, "planSubTypeLabel", "filterDayText", "selectFilterDayText", "filterCarrierText", "licensingHeaderText", "snpBaseTypeLabel", "currentTab", "snpEnabled", "defaultPlanBenefitFilters", "defaultPlanBenefitFiltersEnabled", "additionalSavingsHeaderText", "insulinSavingsEnabled", "filterDSNPMedicaidCodesEnabled", "costFilterEnabled", "medicalDeductibleHeaderText", "medicalDeductibleToolTipText", "maximumOutOfPocketCostHeaderText", "maximumOutOfPocketCostToolTipText", "drugDeductibleHeaderText", "drugDeductibleToolTipText", "premiumHeaderText", "premiumToolTipText", "addOnFilterHeaderText", "addOnFilterEnabled", "addOnTooltipText", "providersNpiHeaderText", "providersNpiFilterEnabled", "providersEnabled", "providersNpiTooltipText", "planTypeLabel", "allInNetworkLocationsEnabled", "filterItemClicked", 4, "ngIf", "ngIfElse"], ["showNoFilterMessage", ""], [1, "can-click", 3, "title", "makeInlineBlock", "ariaLabel", "role", "click", "keyup.enter"], [3, "planSubTypeLabel", "filterDayText", "selectFilterDayText", "filterCarrierText", "licensingHeaderText", "snpBaseTypeLabel", "currentTab", "snpEnabled", "defaultPlanBenefitFilters", "defaultPlanBenefitFiltersEnabled", "additionalSavingsHeaderText", "insulinSavingsEnabled", "filterDSNPMedicaidCodesEnabled", "costFilterEnabled", "medicalDeductibleHeaderText", "medicalDeductibleToolTipText", "maximumOutOfPocketCostHeaderText", "maximumOutOfPocketCostToolTipText", "drugDeductibleHeaderText", "drugDeductibleToolTipText", "premiumHeaderText", "premiumToolTipText", "addOnFilterHeaderText", "addOnFilterEnabled", "addOnTooltipText", "providersNpiHeaderText", "providersNpiFilterEnabled", "providersEnabled", "providersNpiTooltipText", "planTypeLabel", "allInNetworkLocationsEnabled", "filterItemClicked"], [1, "my-3", "Spa_Style_Note"]], template: function PlanFilterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanFilterComponent_ng_container_0_Template, 6, 1, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showTabFilter);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, LinkComponent, IconAriaAttributesDirective, i1$1.NgbAccordion, i1$1.NgbPanel, i1$1.NgbPanelTitle, i1$1.NgbPanelContent, PlanFilterItemsComponent], styles: ["i[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Primary)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanFilterComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-filter', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"showTabFilter\">\r\n  <ngb-accordion #filterPanel=\"ngbAccordion\" [activeIds]=\"isTabFilterExpanded ? panelId : ''\" (panelChange)=\"togglePanelIcon(filterPanel)\">\r\n    <ngb-panel id=\"filter-panel\">\r\n      <ng-template ngbPanelTitle>\r\n        <div class=\"d-flex justify-content-between can-click p-1\">\r\n          <h2 class=\"Spa_Style_H3 accordion-header py-2 mb-0\">\r\n            {{ filterHeaderText }}\r\n          </h2>\r\n          <i class=\"fas py-2\" aria-hidden=\"true\" [ngClass]=\"{ 'fa-angle-up': isPanelExpanded, 'fa-angle-down': !isPanelExpanded }\"></i>\r\n          <span class=\"sr-only\">Expand/Collapse</span>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template ngbPanelContent>\r\n        <div class=\"plan-filter-container\">\r\n          <div class=\"text-right mt-2\">\r\n            <vnext-link\r\n              (click)=\"onClearFilters()\"\r\n              (keyup.enter)=\"onClearFilters()\"\r\n              *ngIf=\"showFilter\"\r\n              [title]=\"filterClearAll\"\r\n              class=\"can-click\"\r\n              [makeInlineBlock]=\"true\"\r\n              [ariaLabel]=\"filterClearAll\"\r\n              [role]=\"linkRoles.BUTTON\"\r\n            ></vnext-link>\r\n          </div>\r\n          <vnext-plan-filter-items\r\n            *ngIf=\"showFilter; else showNoFilterMessage\"\r\n            [planSubTypeLabel]=\"planSubTypeLabel\"\r\n            [filterDayText]=\"filterDayText\"\r\n            [selectFilterDayText]=\"selectFilterDayText\"\r\n            [filterCarrierText]=\"filterCarrierText\"\r\n            [licensingHeaderText]=\"licensingHeaderText\"\r\n            [snpBaseTypeLabel]=\"snpBaseTypeLabel\"\r\n            [currentTab]=\"currentTab\"\r\n            [snpEnabled]=\"snpEnabled\"\r\n            [defaultPlanBenefitFilters]=\"defaultPlanBenefitFilters\"\r\n            [defaultPlanBenefitFiltersEnabled]=\"defaultPlanBenefitFiltersEnabled\"\r\n            [additionalSavingsHeaderText]=\"additionalSavingsHeaderText\"\r\n            [insulinSavingsEnabled]=\"insulinSavingsEnabled\"\r\n            [filterDSNPMedicaidCodesEnabled]=\"filterDSNPMedicaidCodesEnabled\"\r\n            [costFilterEnabled]=\"costFilterEnabled\"\r\n            [medicalDeductibleHeaderText]=\"medicalDeductibleHeaderText\"\r\n            [medicalDeductibleToolTipText]=\"medicalDeductibleToolTipText\"\r\n            [maximumOutOfPocketCostHeaderText]=\"maximumOutOfPocketCostHeaderText\"\r\n            [maximumOutOfPocketCostToolTipText]=\"maximumOutOfPocketCostToolTipText\"\r\n            [drugDeductibleHeaderText]=\"drugDeductibleHeaderText\"\r\n            [drugDeductibleToolTipText]=\"drugDeductibleToolTipText\"\r\n            [premiumHeaderText]=\"premiumHeaderText\"\r\n            [premiumToolTipText]=\"premiumToolTipText\"\r\n            [addOnFilterHeaderText]=\"addOnFilterHeaderText\"\r\n            [addOnFilterEnabled]=\"addOnFilterEnabled\"\r\n            [addOnTooltipText]=\"addOnTooltipText\"\r\n            [providersNpiHeaderText]=\"providersNpiHeaderText\"\r\n            [providersNpiFilterEnabled]=\"providersNpiFilterEnabled\"\r\n            [providersEnabled]=\"providersEnabled\"\r\n            [providersNpiTooltipText]=\"providersNpiTooltipText\"\r\n            (filterItemClicked)=\"filterClicked()\"\r\n            [planTypeLabel]=\"planTypeLabel\"\r\n            [allInNetworkLocationsEnabled]=\"allInNetworkLocationsEnabled\"\r\n          >\r\n          </vnext-plan-filter-items>\r\n          <ng-template #showNoFilterMessage>\r\n            <div class=\"my-3 Spa_Style_Note\">{{ defaultFilterText }}</div>\r\n          </ng-template>\r\n        </div>\r\n      </ng-template>\r\n    </ngb-panel>\r\n  </ngb-accordion>\r\n</ng-container>\r\n", styles: ["i{color:var(--static-Spa_Style_Primary)}\n"] }]
    }], function () { return [{ type: i1.FilterService }, { type: i2.Store }, { type: i1.PlansService }]; }, { filterDayText: [{
            type: Input
        }], selectFilterDayText: [{
            type: Input
        }], filterCarrierText: [{
            type: Input
        }], defaultFilterText: [{
            type: Input
        }], filterHeaderText: [{
            type: Input
        }], filterClearAll: [{
            type: Input
        }], planSubTypeLabel: [{
            type: Input
        }], snpBaseTypeLabel: [{
            type: Input
        }], showEmptyFilterMessage: [{
            type: Input
        }], showNoPlansFromAnswersMessage: [{
            type: Input
        }], licensingHeaderText: [{
            type: Input
        }], currentTab: [{
            type: Input
        }], snpEnabled: [{
            type: Input
        }], additionalSavingsHeaderText: [{
            type: Input
        }], defaultPlanBenefitFilters: [{
            type: Input
        }], defaultPlanBenefitFiltersEnabled: [{
            type: Input
        }], insulinSavingsEnabled: [{
            type: Input
        }], filterDSNPMedicaidCodesEnabled: [{
            type: Input
        }], costFilterEnabled: [{
            type: Input
        }], medicalDeductibleHeaderText: [{
            type: Input
        }], medicalDeductibleToolTipText: [{
            type: Input
        }], maximumOutOfPocketCostHeaderText: [{
            type: Input
        }], maximumOutOfPocketCostToolTipText: [{
            type: Input
        }], drugDeductibleHeaderText: [{
            type: Input
        }], drugDeductibleToolTipText: [{
            type: Input
        }], premiumHeaderText: [{
            type: Input
        }], premiumToolTipText: [{
            type: Input
        }], addOnFilterHeaderText: [{
            type: Input
        }], addOnFilterEnabled: [{
            type: Input
        }], addOnTooltipText: [{
            type: Input
        }], isTabFilterExpanded: [{
            type: Input
        }], providersNpiHeaderText: [{
            type: Input
        }], providersNpiFilterEnabled: [{
            type: Input
        }], providersEnabled: [{
            type: Input
        }], providersNpiTooltipText: [{
            type: Input
        }], showTabFilter: [{
            type: Input
        }], planTypeLabel: [{
            type: Input
        }], allInNetworkLocationsEnabled: [{
            type: Input
        }], filterItemClicked: [{
            type: Output
        }], clearAllFiltersClicked: [{
            type: Output
        }], filterPanel: [{
            type: ViewChild,
            args: [NgbAccordion]
        }] }); })();

function PlanListAccordionComponent_ngb_panel_2_ng_template_1_h2_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.guidedHelpHeaderText, " ");
} }
function PlanListAccordionComponent_ngb_panel_2_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵlistener("click", function PlanListAccordionComponent_ngb_panel_2_ng_template_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(2); const _r0 = i0.ɵɵreference(1); return i0.ɵɵresetView(ctx_r5.isLiveEdit && _r0.toggle("guided-help-panel")); });
    i0.ɵɵtemplate(1, PlanListAccordionComponent_ngb_panel_2_ng_template_1_h2_1_Template, 2, 1, "h2", 7);
    i0.ɵɵelement(2, "i", 8);
    i0.ɵɵelementStart(3, "span", 9);
    i0.ɵɵtext(4, "Expand/Collapse");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    const _r0 = i0.ɵɵreference(1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", ctx_r2.guidedHelpHeaderTextKeyName);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMapInterpolate1("fas ", _r0.isExpanded("guided-help-panel") ? "fa-angle-up" : "fa-angle-down", " py-2");
} }
function PlanListAccordionComponent_ngb_panel_2_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-guided-help-tab", 11);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("guidedHelpPreferenceText", ctx_r3.guidedHelpPreferenceText)("preferenceButtonText", ctx_r3.guidedHelpPreferenceButtonText)("guidedHelpHideLinkText", ctx_r3.guidedHelpHideLinkText)("guidedHelpViewAllLinkText", ctx_r3.guidedHelpViewAllLinkText)("guidedHelpGetStartedText", ctx_r3.guidedHelpGetStartedText)("guidedHelpHealthText", ctx_r3.guidedHelpHealthText)("guidedHelpPrescriptionsText", ctx_r3.guidedHelpPrescriptionsText)("guidedHelpPharmacyText", ctx_r3.guidedHelpPharmacyText)("guidedHelpOtherPreferencesText", ctx_r3.guidedHelpOtherPreferencesText)("guidedHelpOtherPreferencesMessageText", ctx_r3.guidedHelpOtherPreferencesMessageText)("guidedHelpOtherPreferencesMessageKey", ctx_r3.guidedHelpOtherPreferencesMessageKey)("multiPharmacyEnabled", ctx_r3.multiPharmacyEnabled)("primaryPharmacyIndicatorText", ctx_r3.primaryPharmacyIndicatorText)("guidedHelpProvidersText", ctx_r3.guidedHelpProvidersText)("pcpText", ctx_r3.pcpText)("subsidyLabelText", ctx_r3.subsidyLabelText)("medicaidEligibilityCheckEnabled", ctx_r3.medicaidEligibilityCheckEnabled)("medicaidCodeText", ctx_r3.medicaidCodeText);
} }
function PlanListAccordionComponent_ngb_panel_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ngb-panel", 3);
    i0.ɵɵtemplate(1, PlanListAccordionComponent_ngb_panel_2_ng_template_1_Template, 5, 4, "ng-template", 4);
    i0.ɵɵtemplate(2, PlanListAccordionComponent_ngb_panel_2_ng_template_2_Template, 1, 18, "ng-template", 5);
    i0.ɵɵelementEnd();
} }
class PlanListAccordionComponent {
    constructor() {
        this.linkRoles = LinkRoles;
    }
}
PlanListAccordionComponent.ɵfac = function PlanListAccordionComponent_Factory(t) { return new (t || PlanListAccordionComponent)(); };
PlanListAccordionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanListAccordionComponent, selectors: [["vnext-plan-list-accordion"]], inputs: { guidedHelpHeaderText: "guidedHelpHeaderText", guidedHelpHeaderTextKeyName: "guidedHelpHeaderTextKeyName", guidedHelpPreferenceText: "guidedHelpPreferenceText", guidedHelpPreferenceButtonText: "guidedHelpPreferenceButtonText", guidedHelpEnabled: "guidedHelpEnabled", guidedHelpHideLinkText: "guidedHelpHideLinkText", guidedHelpViewAllLinkText: "guidedHelpViewAllLinkText", guidedHelpGetStartedText: "guidedHelpGetStartedText", guidedHelpHealthText: "guidedHelpHealthText", guidedHelpPrescriptionsText: "guidedHelpPrescriptionsText", guidedHelpPharmacyText: "guidedHelpPharmacyText", guidedHelpOtherPreferencesText: "guidedHelpOtherPreferencesText", guidedHelpOtherPreferencesMessageText: "guidedHelpOtherPreferencesMessageText", guidedHelpOtherPreferencesMessageKey: "guidedHelpOtherPreferencesMessageKey", isLiveEdit: "isLiveEdit", multiPharmacyEnabled: "multiPharmacyEnabled", primaryPharmacyIndicatorText: "primaryPharmacyIndicatorText", guidedHelpProvidersText: "guidedHelpProvidersText", pcpText: "pcpText", subsidyLabelText: "subsidyLabelText", medicaidEligibilityCheckEnabled: "medicaidEligibilityCheckEnabled", medicaidCodeText: "medicaidCodeText" }, decls: 3, vars: 1, consts: [["activeIds", "guided-help-panel"], ["planListAccordion", "ngbAccordion"], ["id", "guided-help-panel", 4, "ngIf"], ["id", "guided-help-panel"], ["ngbPanelTitle", ""], ["ngbPanelContent", ""], [1, "d-flex", "justify-content-between", "can-click", "p-1", 3, "click"], ["class", "Spa_Style_H3 accordion-header py-2 mb-0", 4, "liveEditProp"], ["aria-hidden", "true"], [1, "sr-only"], [1, "Spa_Style_H3", "accordion-header", "py-2", "mb-0"], [1, "mt-1", 3, "guidedHelpPreferenceText", "preferenceButtonText", "guidedHelpHideLinkText", "guidedHelpViewAllLinkText", "guidedHelpGetStartedText", "guidedHelpHealthText", "guidedHelpPrescriptionsText", "guidedHelpPharmacyText", "guidedHelpOtherPreferencesText", "guidedHelpOtherPreferencesMessageText", "guidedHelpOtherPreferencesMessageKey", "multiPharmacyEnabled", "primaryPharmacyIndicatorText", "guidedHelpProvidersText", "pcpText", "subsidyLabelText", "medicaidEligibilityCheckEnabled", "medicaidCodeText"]], template: function PlanListAccordionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ngb-accordion", 0, 1);
        i0.ɵɵtemplate(2, PlanListAccordionComponent_ngb_panel_2_Template, 3, 0, "ngb-panel", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.guidedHelpEnabled);
    } }, dependencies: [i1$2.NgIf, LiveEditPropDirective, i1$1.NgbAccordion, i1$1.NgbPanel, i1$1.NgbPanelTitle, i1$1.NgbPanelContent, GuidedHelpPlanListComponent], styles: ["i[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Primary)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanListAccordionComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-list-accordion', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ngb-accordion #planListAccordion=\"ngbAccordion\" activeIds=\"guided-help-panel\">\r\n  <ngb-panel *ngIf=\"guidedHelpEnabled\" id=\"guided-help-panel\">\r\n    <ng-template ngbPanelTitle>\r\n      <div class=\"d-flex justify-content-between can-click p-1\" (click)=\"isLiveEdit && planListAccordion.toggle('guided-help-panel')\">\r\n        <h2 *liveEditProp=\"guidedHelpHeaderTextKeyName\" class=\"Spa_Style_H3 accordion-header py-2 mb-0\">\r\n          {{ guidedHelpHeaderText }}\r\n        </h2>\r\n        <i\r\n          class=\"fas {{ planListAccordion.isExpanded('guided-help-panel') ? 'fa-angle-up' : 'fa-angle-down' }} py-2\"\r\n          aria-hidden=\"true\"\r\n        ></i>\r\n        <span class=\"sr-only\">Expand/Collapse</span>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template ngbPanelContent>\r\n      <vnext-guided-help-tab\r\n        class=\"mt-1\"\r\n        [guidedHelpPreferenceText]=\"guidedHelpPreferenceText\"\r\n        [preferenceButtonText]=\"guidedHelpPreferenceButtonText\"\r\n        [guidedHelpHideLinkText]=\"guidedHelpHideLinkText\"\r\n        [guidedHelpViewAllLinkText]=\"guidedHelpViewAllLinkText\"\r\n        [guidedHelpGetStartedText]=\"guidedHelpGetStartedText\"\r\n        [guidedHelpHealthText]=\"guidedHelpHealthText\"\r\n        [guidedHelpPrescriptionsText]=\"guidedHelpPrescriptionsText\"\r\n        [guidedHelpPharmacyText]=\"guidedHelpPharmacyText\"\r\n        [guidedHelpOtherPreferencesText]=\"guidedHelpOtherPreferencesText\"\r\n        [guidedHelpOtherPreferencesMessageText]=\"guidedHelpOtherPreferencesMessageText\"\r\n        [guidedHelpOtherPreferencesMessageKey]=\"guidedHelpOtherPreferencesMessageKey\"\r\n        [multiPharmacyEnabled]=\"multiPharmacyEnabled\"\r\n        [primaryPharmacyIndicatorText]=\"primaryPharmacyIndicatorText\"\r\n        [guidedHelpProvidersText]=\"guidedHelpProvidersText\"\r\n        [pcpText]=\"pcpText\"\r\n        [subsidyLabelText]=\"subsidyLabelText\"\r\n        [medicaidEligibilityCheckEnabled]=\"medicaidEligibilityCheckEnabled\"\r\n        [medicaidCodeText]=\"medicaidCodeText\"\r\n      ></vnext-guided-help-tab>\r\n    </ng-template>\r\n  </ngb-panel>\r\n</ngb-accordion>\r\n", styles: ["i{color:var(--static-Spa_Style_Primary)}\n"] }]
    }], null, { guidedHelpHeaderText: [{
            type: Input
        }], guidedHelpHeaderTextKeyName: [{
            type: Input
        }], guidedHelpPreferenceText: [{
            type: Input
        }], guidedHelpPreferenceButtonText: [{
            type: Input
        }], guidedHelpEnabled: [{
            type: Input
        }], guidedHelpHideLinkText: [{
            type: Input
        }], guidedHelpViewAllLinkText: [{
            type: Input
        }], guidedHelpGetStartedText: [{
            type: Input
        }], guidedHelpHealthText: [{
            type: Input
        }], guidedHelpPrescriptionsText: [{
            type: Input
        }], guidedHelpPharmacyText: [{
            type: Input
        }], guidedHelpOtherPreferencesText: [{
            type: Input
        }], guidedHelpOtherPreferencesMessageText: [{
            type: Input
        }], guidedHelpOtherPreferencesMessageKey: [{
            type: Input
        }], isLiveEdit: [{
            type: Input
        }], multiPharmacyEnabled: [{
            type: Input
        }], primaryPharmacyIndicatorText: [{
            type: Input
        }], guidedHelpProvidersText: [{
            type: Input
        }], pcpText: [{
            type: Input
        }], subsidyLabelText: [{
            type: Input
        }], medicaidEligibilityCheckEnabled: [{
            type: Input
        }], medicaidCodeText: [{
            type: Input
        }] }); })();

function RateFactorWarningComponent_ng_container_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-inner-text-link", 4);
    i0.ɵɵlistener("innerTextClicked", function RateFactorWarningComponent_ng_container_0_ng_template_1_Template_vnext_inner_text_link_innerTextClicked_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r5.onLoadRateFactorForm()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("customClass", "Spa_Style_Small_Font Spa_Style_Primary_Link_Color Spa_Style_Link")("outerText", ctx_r4.rateFactorWarningBannerText)("innerText", ctx_r4.rateFactorWarningBannerClickableText);
} }
function RateFactorWarningComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, RateFactorWarningComponent_ng_container_0_ng_template_1_Template, 1, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "vnext-notice", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r3 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("titleTemplate", _r3)("type", "warn");
} }
function RateFactorWarningComponent_ng_template_1_div_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-inner-text-link", 4);
    i0.ɵɵlistener("innerTextClicked", function RateFactorWarningComponent_ng_template_1_div_0_ng_template_1_Template_vnext_inner_text_link_innerTextClicked_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r10.onLoadRateFactorForm()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("customClass", "Spa_Style_Small_Font Spa_Style_Primary_Link_Color Spa_Style_Link")("outerText", ctx_r9.rateFactorEditAnswersBannerText)("innerText", ctx_r9.rateFactorEditAnswersBannerClickableText);
} }
function RateFactorWarningComponent_ng_template_1_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, RateFactorWarningComponent_ng_template_1_div_0_ng_template_1_Template, 1, 3, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelement(3, "vnext-notice", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r8 = i0.ɵɵreference(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("titleTemplate", _r8)("type", "warn");
} }
function RateFactorWarningComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, RateFactorWarningComponent_ng_template_1_div_0_Template, 4, 2, "div", 5);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.hasRateFactorAnswers);
} }
class RateFactorWarningComponent {
    constructor() {
        this.loadRateFactorForm = new EventEmitter();
    }
    onLoadRateFactorForm() {
        this.loadRateFactorForm.emit();
    }
}
RateFactorWarningComponent.ɵfac = function RateFactorWarningComponent_Factory(t) { return new (t || RateFactorWarningComponent)(); };
RateFactorWarningComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RateFactorWarningComponent, selectors: [["vnext-rate-factor-warning"]], inputs: { showRateFactorWarningBanner: "showRateFactorWarningBanner", hasRateFactorAnswers: "hasRateFactorAnswers", rateFactorWarningBannerText: "rateFactorWarningBannerText", rateFactorWarningBannerClickableText: "rateFactorWarningBannerClickableText", rateFactorEditAnswersBannerText: "rateFactorEditAnswersBannerText", rateFactorEditAnswersBannerClickableText: "rateFactorEditAnswersBannerClickableText" }, outputs: { loadRateFactorForm: "loadRateFactorForm" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["showEditAnswersBanner", ""], ["warningTitle", ""], [3, "titleTemplate", "type"], [3, "customClass", "outerText", "innerText", "innerTextClicked"], ["class", "mt-5", 4, "ngIf"], [1, "mt-5"], ["editAnswers", ""]], template: function RateFactorWarningComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, RateFactorWarningComponent_ng_container_0_Template, 4, 2, "ng-container", 0);
        i0.ɵɵtemplate(1, RateFactorWarningComponent_ng_template_1_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.showRateFactorWarningBanner)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgIf, InnerTextLinkComponent, NoticeComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RateFactorWarningComponent, [{
        type: Component,
        args: [{ selector: 'vnext-rate-factor-warning', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"showRateFactorWarningBanner; else showEditAnswersBanner\">\r\n  <ng-template #warningTitle>\r\n    <vnext-inner-text-link\r\n      [customClass]=\"'Spa_Style_Small_Font Spa_Style_Primary_Link_Color Spa_Style_Link'\"\r\n      [outerText]=\"rateFactorWarningBannerText\"\r\n      [innerText]=\"rateFactorWarningBannerClickableText\"\r\n      (innerTextClicked)=\"onLoadRateFactorForm()\"\r\n    >\r\n    </vnext-inner-text-link>\r\n  </ng-template>\r\n  <vnext-notice [titleTemplate]=\"warningTitle\" [type]=\"'warn'\"></vnext-notice>\r\n</ng-container>\r\n\r\n<ng-template #showEditAnswersBanner>\r\n  <div class=\"mt-5\" *ngIf=\"hasRateFactorAnswers\">\r\n    <ng-template #editAnswers>\r\n      <vnext-inner-text-link\r\n        [customClass]=\"'Spa_Style_Small_Font Spa_Style_Primary_Link_Color Spa_Style_Link'\"\r\n        [outerText]=\"rateFactorEditAnswersBannerText\"\r\n        [innerText]=\"rateFactorEditAnswersBannerClickableText\"\r\n        (innerTextClicked)=\"onLoadRateFactorForm()\"\r\n      >\r\n      </vnext-inner-text-link>\r\n    </ng-template>\r\n    <vnext-notice [titleTemplate]=\"editAnswers\" [type]=\"'warn'\"></vnext-notice>\r\n  </div>\r\n</ng-template>\r\n" }]
    }], null, { showRateFactorWarningBanner: [{
            type: Input
        }], hasRateFactorAnswers: [{
            type: Input
        }], rateFactorWarningBannerText: [{
            type: Input
        }], rateFactorWarningBannerClickableText: [{
            type: Input
        }], rateFactorEditAnswersBannerText: [{
            type: Input
        }], rateFactorEditAnswersBannerClickableText: [{
            type: Input
        }], loadRateFactorForm: [{
            type: Output
        }] }); })();

const _c0$K = function (a0) { return { active: a0 }; };
function PlanSortComponent_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function PlanSortComponent_button_10_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r3); const sort_r1 = restoredCtx.$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onSelectSort(sort_r1)); })("keyup.enter", function PlanSortComponent_button_10_Template_button_keyup_enter_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r3); const sort_r1 = restoredCtx.$implicit; const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.onSelectSort(sort_r1)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sort_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$K, sort_r1 && ctx_r0.selectedSort && sort_r1.dataKey === ctx_r0.selectedSort.dataKey));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", sort_r1.displayName, " ");
} }
class PlanSortComponent {
    constructor(sortService, planFacade, analyticsService, planListFacadeService, cdr) {
        this.sortService = sortService;
        this.planFacade = planFacade;
        this.analyticsService = analyticsService;
        this.planListFacadeService = planListFacadeService;
        this.cdr = cdr;
        this.sortClicked = new EventEmitter();
        this.sortPrimaryKey = SortPrimaryKey;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        this.subscriptions.add(combineLatest([this.activeTabType$, this.sortGroups$])
            .pipe(switchMap(([activeTab]) => {
            this.tabs.forEach(tab => {
                if (tab.filters.some(filter => filter.values.includes(activeTab))) {
                    this.currentTab = tab;
                }
            });
            return this.sortService.getSortBySortGroup$(this.currentTab.sortGroup);
        }))
            .subscribe({
            next: selectedSort => {
                if (selectedSort) {
                    this.selectedSort = selectedSort;
                    this.cdr.markForCheck();
                }
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    sortTransformer(plan) {
        return this.planFacade.getTotalPremium([plan]);
    }
    sortTransformerTotalEstimatedCost(plans) {
        if (!plans || !plans.length) {
            return 0;
        }
        return this.planFacade.getTotalEstimatedCost(plans[0], this.selectedPharmacy, this.isMailOrderSelected);
    }
    sortTransformerTotalDrugCost(plans) {
        if (!plans || !plans.length) {
            return 0;
        }
        return this.planFacade.getTotalAnnualDrugCostShare(plans[0], this.selectedPharmacy, this.isMailOrderSelected);
    }
    onSelectSort(value) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLANS_SORT,
            [DataLayerGlobalVariable.PLANS_SORT_SELECTION]: value.displayName
        };
        const sortTransformer = this.planListFacadeService.getSortTransformer(value.dataKey);
        this.sortService.updateSortGroup(this.currentTab.sortGroup, new Sort(this.sortPrimaryKey.IS_CURRENT_YEAR_PLAN, value.dataKey, value.secondaryDataKey, value.dataKeyType, value.sortType, value.displayName, value.display, sortTransformer, value.secondarySortType), true);
        this.sortClicked.emit();
    }
}
PlanSortComponent.ɵfac = function PlanSortComponent_Factory(t) { return new (t || PlanSortComponent)(i0.ɵɵdirectiveInject(i1.SortService), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(PlanListFacadeService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
PlanSortComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanSortComponent, selectors: [["vnext-plan-sort"]], inputs: { tabs: "tabs", planSortList: "planSortList", planSortHeader: "planSortHeader", selectedPharmacy: "selectedPharmacy", isMailOrderSelected: "isMailOrderSelected" }, outputs: { sortClicked: "sortClicked" }, decls: 12, vars: 7, consts: [["id", "sortDropDownLabel", 1, "Spa_Style_Label", "mb-2"], ["ngbDropdown", "", 1, "mt-2"], ["id", "sortDropDown", "role", "combobox", "ngbDropdownToggle", "", 1, "btn", "sort-dropdown-button"], [1, "Spa_Style_Paragraph", "pr-2"], [1, "fa", "fa-angle-down", "float-right"], [1, "sr-only"], ["ngbDropdownMenu", "", "aria-labelledby", "sortDropDown"], ["class", "Spa_Style_Paragraph can-click", "ngbDropdownItem", "", 3, "ngClass", "click", "keyup.enter", 4, "ngFor", "ngForOf"], ["ngbDropdownItem", "", 1, "Spa_Style_Paragraph", "can-click", 3, "ngClass", "click", "keyup.enter"]], template: function PlanSortComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "label", 0);
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 1)(3, "button", 2)(4, "span", 3);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(6, "i", 4);
        i0.ɵɵelementStart(7, "span", 5);
        i0.ɵɵtext(8, "Expand");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵtemplate(10, PlanSortComponent_button_10_Template, 2, 4, "button", 7);
        i0.ɵɵpipe(11, "orderBy");
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.planSortHeader);
        i0.ɵɵadvance(2);
        i0.ɵɵattribute("aria-label", ctx.selectedSort ? ctx.selectedSort.displayName : "sortDropDownLabel sortDropDown");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.selectedSort ? ctx.selectedSort.displayName : "");
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(11, 4, ctx.planSortList, "order"));
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, IconAriaAttributesDirective, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem, OrderPipe], styles: [".sort-label[_ngcontent-%COMP%]{margin:10px 0 0}.dropdown[_ngcontent-%COMP%]   .sort-dropdown-button[_ngcontent-%COMP%]{border-color:var(--static-Spa_Style_Accent1);width:100%;text-align:left}.sort-dropdown-button[_ngcontent-%COMP%]   .fa[_ngcontent-%COMP%]{margin-top:5px;margin-left:-12px}.dropdown[_ngcontent-%COMP%]   .dropdown-menu[_ngcontent-%COMP%]{width:100%;padding:0;margin-top:0;border-color:var(--static-Spa_Style_Accent1)}.dropdown-menu[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]{padding:6px 10px;white-space:normal}.dropdown-menu[_ngcontent-%COMP%]   .dropdown-item.active[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray2);color:var(--static-Spa_Style_Primary)}.dropdown-menu[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]:hover, .dropdown[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]:focus, .dropdown[_ngcontent-%COMP%]   .dropdown-item[_ngcontent-%COMP%]:active{background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}.fa-angle-down[_ngcontent-%COMP%]{position:absolute;top:8px;left:calc(100% - 15px)}.sort-dropdown-button[_ngcontent-%COMP%]   .Spa_Style_Paragraph[_ngcontent-%COMP%]{overflow:hidden;width:100%;display:inline-flex}"], changeDetection: 0 });
__decorate([
    Select(PlansState.activeTabType)
], PlanSortComponent.prototype, "activeTabType$", void 0);
__decorate([
    Select(PlansState.sortGroups)
], PlanSortComponent.prototype, "sortGroups$", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanSortComponent, [{
        type: Component,
        args: [{ selector: 'vnext-plan-sort', changeDetection: ChangeDetectionStrategy.OnPush, template: "<label class=\"Spa_Style_Label mb-2\" id=\"sortDropDownLabel\">{{ planSortHeader }}</label>\r\n<div ngbDropdown class=\"mt-2\">\r\n  <button class=\"btn sort-dropdown-button\" id=\"sortDropDown\" role=\"combobox\" [attr.aria-label]=\"selectedSort ? selectedSort.displayName : 'sortDropDownLabel sortDropDown'\" ngbDropdownToggle>\r\n    <span class=\"Spa_Style_Paragraph pr-2\">{{ selectedSort ? selectedSort.displayName : '' }}</span>\r\n    <i class=\"fa fa-angle-down float-right\"></i>\r\n    <span class=\"sr-only\">Expand</span>\r\n  </button>\r\n  <div ngbDropdownMenu aria-labelledby=\"sortDropDown\">\r\n    <button\r\n      *ngFor=\"let sort of planSortList | orderBy: 'order'\"\r\n      class=\"Spa_Style_Paragraph can-click\"\r\n      [ngClass]=\"{ active: sort && selectedSort && sort.dataKey === selectedSort.dataKey }\"\r\n      ngbDropdownItem\r\n      (click)=\"onSelectSort(sort)\"\r\n      (keyup.enter)=\"onSelectSort(sort)\"\r\n    >\r\n      {{ sort.displayName }}\r\n    </button>\r\n  </div>\r\n</div>\r\n", styles: [".sort-label{margin:10px 0 0}.dropdown .sort-dropdown-button{border-color:var(--static-Spa_Style_Accent1);width:100%;text-align:left}.sort-dropdown-button .fa{margin-top:5px;margin-left:-12px}.dropdown .dropdown-menu{width:100%;padding:0;margin-top:0;border-color:var(--static-Spa_Style_Accent1)}.dropdown-menu .dropdown-item{padding:6px 10px;white-space:normal}.dropdown-menu .dropdown-item.active{background-color:var(--static-Spa_Style_Gray2);color:var(--static-Spa_Style_Primary)}.dropdown-menu .dropdown-item:hover,.dropdown .dropdown-item:focus,.dropdown .dropdown-item:active{background-color:var(--static-Spa_Style_Gray1);color:var(--static-Spa_Style_Primary)}.fa-angle-down{position:absolute;top:8px;left:calc(100% - 15px)}.sort-dropdown-button .Spa_Style_Paragraph{overflow:hidden;width:100%;display:inline-flex}\n"] }]
    }], function () { return [{ type: i1.SortService }, { type: PlanFacade }, { type: AnalyticsService }, { type: PlanListFacadeService }, { type: i0.ChangeDetectorRef }]; }, { activeTabType$: [], sortGroups$: [], tabs: [{
            type: Input
        }], planSortList: [{
            type: Input
        }], planSortHeader: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], isMailOrderSelected: [{
            type: Input
        }], sortClicked: [{
            type: Output
        }] }); })();

function PlanQuoteItemComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.planName);
} }
function PlanQuoteItemComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r3.totalPremium), " ");
} }
function PlanQuoteItemComponent_ng_container_16_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function PlanQuoteItemComponent_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanQuoteItemComponent_ng_container_16_ng_container_1_Template, 1, 0, "ng-container", 20);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r6 = i0.ɵɵreference(25);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r6);
} }
function PlanQuoteItemComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r5.totalPremium), " ");
} }
function PlanQuoteItemComponent_ng_template_24_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 7);
    i0.ɵɵlistener("click", function PlanQuoteItemComponent_ng_template_24_ng_template_0_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r12.onGetPersonalizedQuote()); })("keyup.enter", function PlanQuoteItemComponent_ng_template_24_ng_template_0_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r14.onGetPersonalizedQuote()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r10.planCardQuoteLinkNameText)("alwaysUnderlined", true);
} }
function PlanQuoteItemComponent_ng_template_24_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, PlanQuoteItemComponent_ng_template_24_ng_template_0_Template, 1, 2, "ng-template", null, 22, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(2, "i", 23, 24);
    i0.ɵɵlistener("mouseover", function PlanQuoteItemComponent_ng_template_24_Template_i_mouseover_2_listener() { i0.ɵɵrestoreView(_r16); const _r11 = i0.ɵɵreference(3); return i0.ɵɵresetView(_r11.open()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r9 = i0.ɵɵreference(1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngbTooltip", _r9)("autoClose", "outside");
} }
class PlanQuoteItemComponent {
    constructor(planFacade, planDetailsFacade) {
        this.planFacade = planFacade;
        this.planDetailsFacade = planDetailsFacade;
        this.viewPlanDetails = new EventEmitter();
        this.removePlanFromQuoteGroup = new EventEmitter();
        this.getPersonalizedQuote = new EventEmitter();
        this.planTypeAbbreviation = PlanTypeAbbreviation;
        this.planQuoteHospitalCareHeightSelectors = PlanQuoteHospitalCareHeightSelectors;
        this.planNameMaxLength = 30;
    }
    ngOnChanges(changes) {
        const { plan, planTypes, activeTabType } = changes;
        if (plan && !_isEqual(plan.previousValue, plan.currentValue)) {
            this.isHospitalCare = this.plan.planTypeAbbreviation === PlanTypeAbbreviation.HC;
            this.planName = this.isHospitalCare ? `${this.plan.carrierName} ${this.plan.planName}` : this.plan.planName;
            if (this.isHospitalCare) {
                const planExtraction = this.planDetailsFacade.getPlanExtraction(this.plan);
                this.planOption = planExtraction;
            }
            this.inpatientHospitalCareText = this.getInpatientHospitalCareText();
        }
        if ((plan && !_isEqual(plan.previousValue, plan.currentValue)) ||
            (planTypes && !_isEqual(planTypes.previousValue, planTypes.currentValue)) ||
            (activeTabType && activeTabType.previousValue !== activeTabType.currentValue)) {
            this.planTypeData = this.planTypes.find(planType => planType.tabType === this.plan.planTypeAbbreviation);
            if (this.activeTabType === PlanTypeAbbreviation.HC) {
                const isMedicare = this.planFacade.isMedicareOnHospitalCare(this.plan, this.planTypes);
                if (isMedicare) {
                    this.totalPremium = this.planFacade.getTotalPremium([this.plan]);
                    this.hasPremium = this.planFacade.areAllMedSupQuestionsAnswered(this.plan);
                }
                else {
                    this.totalPremium = this.planDetailsFacade.getTotalPremiumBySelectedRiders(this.plan);
                    this.hasPremium = true;
                }
            }
            else {
                this.totalPremium = this.plan.medicalPremium;
            }
        }
    }
    trackIndex(index) {
        return index;
    }
    onViewPlanDetails() {
        this.viewPlanDetails.emit(this.plan);
    }
    onRemovePlanFromQuoteGroup() {
        this.removePlanFromQuoteGroup.emit(this.plan);
    }
    onGetPersonalizedQuote() {
        this.getPersonalizedQuote.emit(this.plan);
    }
    getInpatientHospitalCareText() {
        let inpatientHospitalCareText;
        if (this.isHospitalCare) {
            inpatientHospitalCareText = this.planOption?.value;
        }
        else {
            // plan Inpatient Hospital Care data will always(if exists) be available in this ID
            const medCategoryId = MedCategoryID.INPATIENT_HOSPITAL_CARE;
            inpatientHospitalCareText = this.plan?.planDataFields?.find(data => data.benefitID === medCategoryId)?.description;
        }
        return inpatientHospitalCareText;
    }
}
PlanQuoteItemComponent.ɵfac = function PlanQuoteItemComponent_Factory(t) { return new (t || PlanQuoteItemComponent)(i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(PlanDetailsFacade)); };
PlanQuoteItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanQuoteItemComponent, selectors: [["vnext-widget-plan-quote-item"]], inputs: { plan: "plan", activeTabType: "activeTabType", planTypes: "planTypes", hospitalIndemnityBadgeText: "hospitalIndemnityBadgeText", planCardQuoteLinkNameText: "planCardQuoteLinkNameText" }, outputs: { viewPlanDetails: "viewPlanDetails", removePlanFromQuoteGroup: "removePlanFromQuoteGroup", getPersonalizedQuote: "getPersonalizedQuote" }, features: [i0.ɵɵNgOnChangesFeature], decls: 26, vars: 23, consts: [[1, "w-100"], [3, "ngClass"], [1, "underline", "plan-type-badge", "px-2", "text-wrap"], [1, "col-8", "col-md-6", "col-sm-12", "col-lg-12", "pr-0", "pr-sm-2"], [1, "d-flex", "flex-column", "w-100", "flex-lg-row", "mh-100", "justify-content-start", "justify-content-lg-between", "align-items-lg-center"], ["placement", "top", 1, "col-12", "col-md-12", "col-sm-7", "col-lg-7", "pl-0", "pr-0", "pb-lg-0", "plan-name", "no-translate-block", 3, "disableTooltip", "ngbTooltip"], ["addToQuoteTooltip", "ngbTooltip"], [3, "title", "alwaysUnderlined", "click", "keyup.enter"], ["planNameTooltipContent", ""], ["class", "col-4 pl-2 pr-0 Spa_Style_CostPremiumSmall d-none d-lg-block", 4, "ngIf"], [1, "d-none", "d-lg-block"], [4, "ngIf"], ["tabIndex", "0", 1, "fal", "fa-times", "font-weight-bold", "can-click", 3, "click", "keyup.enter"], [1, "col-4", "col-md-6", "col-lg-4", "px-0", "d-lg-none", "d-flex", "justify-content-end"], ["class", "col-8 Spa_Style_CostPremiumSmall align-items-center", 4, "ngIf", "ngIfElse"], [1, "col-4", "text-right", "text-lg-center", "order-lg-last", "align-items-center"], [1, "Spa_Style_Note", "pt-2", "pb-2", "pb-sm-0", "pr-2", "pl-2", "d-flex", "flex-column", "w-100", "flex-lg-row", "justify-content-start", "justify-content-lg-between", 3, "innerHTML"], ["showPersonalizedQuoteTooltip", ""], ["navigationAdapter", "", 1, "no-translate-block"], [1, "col-4", "pl-2", "pr-0", "Spa_Style_CostPremiumSmall", "d-none", "d-lg-block"], [4, "ngTemplateOutlet"], [1, "col-8", "Spa_Style_CostPremiumSmall", "align-items-center"], ["getPersonalizedQuoteTooltip", ""], ["aria-hidden", "true", "triggers", "clicks", 1, "fas", "fa-exclamation-triangle", "mr-3", "warn-icon", 3, "ngbTooltip", "autoClose", "mouseover"], ["tooltip", "ngbTooltip"]], template: function PlanQuoteItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div")(2, "div", 1)(3, "span", 2);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(5, "div")(6, "div", 3)(7, "div", 4)(8, "div", 5, 6)(10, "vnext-link", 7);
        i0.ɵɵlistener("click", function PlanQuoteItemComponent_Template_vnext_link_click_10_listener() { return ctx.onViewPlanDetails(); })("keyup.enter", function PlanQuoteItemComponent_Template_vnext_link_keyup_enter_10_listener() { return ctx.onViewPlanDetails(); });
        i0.ɵɵpipe(11, "ellipsis");
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(12, PlanQuoteItemComponent_ng_template_12_Template, 2, 1, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(14, PlanQuoteItemComponent_div_14_Template, 3, 3, "div", 9);
        i0.ɵɵelementStart(15, "div", 10);
        i0.ɵɵtemplate(16, PlanQuoteItemComponent_ng_container_16_Template, 2, 1, "ng-container", 11);
        i0.ɵɵelementStart(17, "i", 12);
        i0.ɵɵlistener("click", function PlanQuoteItemComponent_Template_i_click_17_listener() { return ctx.onRemovePlanFromQuoteGroup(); })("keyup.enter", function PlanQuoteItemComponent_Template_i_keyup_enter_17_listener() { return ctx.onRemovePlanFromQuoteGroup(); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(18, "div", 13);
        i0.ɵɵtemplate(19, PlanQuoteItemComponent_div_19_Template, 3, 3, "div", 14);
        i0.ɵɵelementStart(20, "div", 15)(21, "i", 12);
        i0.ɵɵlistener("click", function PlanQuoteItemComponent_Template_i_click_21_listener() { return ctx.onRemovePlanFromQuoteGroup(); })("keyup.enter", function PlanQuoteItemComponent_Template_i_keyup_enter_21_listener() { return ctx.onRemovePlanFromQuoteGroup(); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelement(22, "div", 16);
        i0.ɵɵpipe(23, "safe");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(24, PlanQuoteItemComponent_ng_template_24_Template, 4, 2, "ng-template", null, 17, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(13);
        const _r6 = i0.ɵɵreference(25);
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("mb-2 pl-2 ", ctx.planQuoteHospitalCareHeightSelectors.BADGE_TITLE, "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.isHospitalCare ? "badge Spa_Style_Gray4_Background Spa_Style_Secondary_Text_Color" : "badge Spa_Style_Gray2_Background Spa_Style_Primary_Color");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.isHospitalCare ? ctx.hospitalIndemnityBadgeText : ctx.planTypeData == null ? null : ctx.planTypeData.title, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵclassMapInterpolate1("row align-items-center pb-2 pr-2 pl-2 ", ctx.planQuoteHospitalCareHeightSelectors.PLAN_NAME, "");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disableTooltip", (ctx.planName == null ? null : ctx.planName.length) <= ctx.planNameMaxLength)("ngbTooltip", _r1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("title", i0.ɵɵpipeBind2(11, 17, ctx.planName, ctx.planNameMaxLength))("alwaysUnderlined", true);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.hasPremium);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.hasPremium);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.hasPremium)("ngIfElse", _r6);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(23, 20, ctx.inpatientHospitalCareText, "html"), i0.ɵɵsanitizeHtml);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$2.NgTemplateOutlet, LinkComponent, NavigationAdapterDirective, IconAriaAttributesDirective, i1$1.NgbTooltip, i1$2.CurrencyPipe, SafePipe, EllipsisPipe], styles: [".plan-type-badge[_ngcontent-%COMP%]{font-size:14px;overflow:hidden;text-overflow:ellipsis}.badge[_ngcontent-%COMP%]{border-radius:5px;font-family:montserrat_semibold}.warn-icon[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Warn_Darker)}.text-ellipsis[_ngcontent-%COMP%]{text-overflow:ellipsis;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;display:-webkit-box}.plan-name[_ngcontent-%COMP%]{line-height:1rem}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], PlanQuoteItemComponent.prototype, "onViewPlanDetails", null);
__decorate([
    LiveEditInactive()
], PlanQuoteItemComponent.prototype, "onRemovePlanFromQuoteGroup", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanQuoteItemComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-quote-item', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"w-100\">\r\n  <div class=\"mb-2 pl-2 {{ planQuoteHospitalCareHeightSelectors.BADGE_TITLE }}\">\r\n    <div\r\n      [ngClass]=\"\r\n        isHospitalCare\r\n          ? 'badge Spa_Style_Gray4_Background Spa_Style_Secondary_Text_Color'\r\n          : 'badge Spa_Style_Gray2_Background Spa_Style_Primary_Color'\r\n      \"\r\n    >\r\n      <span class=\"underline plan-type-badge px-2 text-wrap\">\r\n        {{ isHospitalCare ? hospitalIndemnityBadgeText : planTypeData?.title }}\r\n      </span>\r\n    </div>\r\n  </div>\r\n  <div class=\"row align-items-center pb-2 pr-2 pl-2 {{ planQuoteHospitalCareHeightSelectors.PLAN_NAME }}\">\r\n    <div class=\"col-8 col-md-6 col-sm-12 col-lg-12 pr-0 pr-sm-2\">\r\n      <div class=\"d-flex flex-column w-100 flex-lg-row mh-100 justify-content-start justify-content-lg-between align-items-lg-center\">\r\n        <div\r\n          #addToQuoteTooltip=\"ngbTooltip\"\r\n          [disableTooltip]=\"planName?.length <= planNameMaxLength\"\r\n          placement=\"top\"\r\n          [ngbTooltip]=\"planNameTooltipContent\"\r\n          class=\"col-12 col-md-12 col-sm-7 col-lg-7 pl-0 pr-0 pb-lg-0 plan-name no-translate-block\"\r\n        >\r\n          <vnext-link\r\n            [title]=\"planName | ellipsis: planNameMaxLength\"\r\n            (click)=\"onViewPlanDetails()\"\r\n            (keyup.enter)=\"onViewPlanDetails()\"\r\n            [alwaysUnderlined]=\"true\"\r\n          >\r\n          </vnext-link>\r\n        </div>\r\n        <ng-template #planNameTooltipContent>\r\n          <div navigationAdapter class=\"no-translate-block\">{{ planName }}</div>\r\n        </ng-template>\r\n        <div *ngIf=\"hasPremium\" class=\"col-4 pl-2 pr-0 Spa_Style_CostPremiumSmall d-none d-lg-block\">\r\n          {{ totalPremium | currency }}\r\n        </div>\r\n        <div class=\"d-none d-lg-block\">\r\n          <ng-container *ngIf=\"!hasPremium\">\r\n            <ng-container *ngTemplateOutlet=\"showPersonalizedQuoteTooltip\"></ng-container>\r\n          </ng-container>\r\n          <i\r\n            class=\"fal fa-times font-weight-bold can-click\"\r\n            tabIndex=\"0\"\r\n            (click)=\"onRemovePlanFromQuoteGroup()\"\r\n            (keyup.enter)=\"onRemovePlanFromQuoteGroup()\"\r\n          ></i>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-4 col-md-6 col-lg-4 px-0 d-lg-none d-flex justify-content-end\">\r\n      <div *ngIf=\"hasPremium; else showPersonalizedQuoteTooltip\" class=\"col-8 Spa_Style_CostPremiumSmall align-items-center\">\r\n        {{ totalPremium | currency }}\r\n      </div>\r\n      <div class=\"col-4 text-right text-lg-center order-lg-last align-items-center\">\r\n        <i\r\n          class=\"fal fa-times font-weight-bold can-click\"\r\n          tabIndex=\"0\"\r\n          (click)=\"onRemovePlanFromQuoteGroup()\"\r\n          (keyup.enter)=\"onRemovePlanFromQuoteGroup()\"\r\n        ></i>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div\r\n    class=\"Spa_Style_Note pt-2 pb-2 pb-sm-0 pr-2 pl-2 d-flex flex-column w-100 flex-lg-row justify-content-start justify-content-lg-between\"\r\n    [innerHTML]=\"inpatientHospitalCareText | safe: 'html'\"\r\n  ></div>\r\n</div>\r\n\r\n<ng-template #showPersonalizedQuoteTooltip>\r\n  <ng-template #getPersonalizedQuoteTooltip>\r\n    <vnext-link\r\n      [title]=\"planCardQuoteLinkNameText\"\r\n      (click)=\"onGetPersonalizedQuote()\"\r\n      (keyup.enter)=\"onGetPersonalizedQuote()\"\r\n      [alwaysUnderlined]=\"true\"\r\n    >\r\n    </vnext-link>\r\n  </ng-template>\r\n  <i\r\n    class=\"fas fa-exclamation-triangle mr-3 warn-icon\"\r\n    #tooltip=\"ngbTooltip\"\r\n    aria-hidden=\"true\"\r\n    [ngbTooltip]=\"getPersonalizedQuoteTooltip\"\r\n    [autoClose]=\"'outside'\"\r\n    triggers=\"clicks\"\r\n    (mouseover)=\"tooltip.open()\"\r\n  ></i>\r\n</ng-template>\r\n", styles: [".plan-type-badge{font-size:14px;overflow:hidden;text-overflow:ellipsis}.badge{border-radius:5px;font-family:montserrat_semibold}.warn-icon{color:var(--static-Spa_Style_Warn_Darker)}.text-ellipsis{text-overflow:ellipsis;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;display:-webkit-box}.plan-name{line-height:1rem}\n"] }]
    }], function () { return [{ type: PlanFacade }, { type: PlanDetailsFacade }]; }, { plan: [{
            type: Input
        }], activeTabType: [{
            type: Input
        }], planTypes: [{
            type: Input
        }], hospitalIndemnityBadgeText: [{
            type: Input
        }], planCardQuoteLinkNameText: [{
            type: Input
        }], viewPlanDetails: [{
            type: Output
        }], removePlanFromQuoteGroup: [{
            type: Output
        }], getPersonalizedQuote: [{
            type: Output
        }], onViewPlanDetails: [], onRemovePlanFromQuoteGroup: [] }); })();

const _c0$J = function (a0, a1, a2) { return { "col-12": a0, "col-6": a1, "col-4 plan-quote-last-card": a2 }; };
function PlanQuoteComponent_ng_container_0_ng_container_9_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15)(2, "div", 16)(3, "vnext-link", 17);
    i0.ɵɵlistener("click", function PlanQuoteComponent_ng_container_0_ng_container_9_div_1_Template_vnext_link_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const plan_r7 = restoredCtx.$implicit; const ctx_r8 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r8.onViewPlanDetails(plan_r7)); })("keyup.enter", function PlanQuoteComponent_ng_container_0_ng_container_9_div_1_Template_vnext_link_keyup_enter_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const plan_r7 = restoredCtx.$implicit; const ctx_r10 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r10.onViewPlanDetails(plan_r7)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 18);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "currency");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 19)(8, "i", 20);
    i0.ɵɵlistener("click", function PlanQuoteComponent_ng_container_0_ng_container_9_div_1_Template_i_click_8_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const plan_r7 = restoredCtx.$implicit; const ctx_r11 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r11.onRemovePlanFromQuoteGroup(plan_r7)); })("keyup.enter", function PlanQuoteComponent_ng_container_0_ng_container_9_div_1_Template_i_keyup_enter_8_listener() { const restoredCtx = i0.ɵɵrestoreView(_r9); const plan_r7 = restoredCtx.$implicit; const ctx_r12 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r12.onRemovePlanFromQuoteGroup(plan_r7)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 21);
    i0.ɵɵtext(10, "Remove plan");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const plan_r7 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(7, _c0$J, ctx_r5.plansSelectedToQuote.length === 1, ctx_r5.plansSelectedToQuote.length > 1 && ctx_r5.plansSelectedToQuote.length < ctx_r5.addToQuoteLimit, ctx_r5.plansSelectedToQuote.length === ctx_r5.addToQuoteLimit));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", plan_r7.planName)("alwaysUnderlined", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 5, plan_r7.medicalPremium), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-label", ctx_r5.removeFromQuoteText);
} }
function PlanQuoteComponent_ng_container_0_ng_container_9_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "div", 23);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "currency");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const plan_r13 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(4, _c0$J, ctx_r6.plansSelectedToQuote.length === 1, ctx_r6.plansSelectedToQuote.length > 1 && ctx_r6.plansSelectedToQuote.length < ctx_r6.addToQuoteLimit, ctx_r6.plansSelectedToQuote.length === ctx_r6.addToQuoteLimit));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, plan_r13.medicalPremium));
} }
function PlanQuoteComponent_ng_container_0_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanQuoteComponent_ng_container_0_ng_container_9_div_1_Template, 11, 11, "div", 12);
    i0.ɵɵtemplate(2, PlanQuoteComponent_ng_container_0_ng_container_9_div_2_Template, 4, 8, "div", 13);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.plansSelectedToQuote)("ngForTrackBy", ctx_r1.trackIndex);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.plansSelectedToQuote)("ngForTrackBy", ctx_r1.trackIndex);
} }
const _c1$d = function (a0, a1, a2) { return { "col-12 col-sm-12": a0, "col-12 col-sm-6": a1, "col-12 col-sm-4 plan-quote-last-card": a2 }; };
function PlanQuoteComponent_ng_container_0_ng_template_10_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26)(1, "vnext-widget-plan-quote-item", 27);
    i0.ɵɵlistener("viewPlanDetails", function PlanQuoteComponent_ng_container_0_ng_template_10_div_1_Template_vnext_widget_plan_quote_item_viewPlanDetails_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r17); const plan_r15 = restoredCtx.$implicit; const ctx_r16 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r16.onViewPlanDetails(plan_r15)); })("removePlanFromQuoteGroup", function PlanQuoteComponent_ng_container_0_ng_template_10_div_1_Template_vnext_widget_plan_quote_item_removePlanFromQuoteGroup_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r17); const plan_r15 = restoredCtx.$implicit; const ctx_r18 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r18.onRemovePlanFromQuoteGroup(plan_r15)); })("getPersonalizedQuote", function PlanQuoteComponent_ng_container_0_ng_template_10_div_1_Template_vnext_widget_plan_quote_item_getPersonalizedQuote_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r17); const plan_r15 = restoredCtx.$implicit; const ctx_r19 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r19.onGetPersonalizedQuote(plan_r15)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const plan_r15 = ctx.$implicit;
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(7, _c1$d, ctx_r14.plansSelectedToQuote.length === 1, ctx_r14.plansSelectedToQuote.length > 1 && ctx_r14.plansSelectedToQuote.length < ctx_r14.addToQuoteLimit, ctx_r14.plansSelectedToQuote.length === ctx_r14.addToQuoteLimit));
    i0.ɵɵattribute("data-plan-id", plan_r15.id);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", plan_r15)("activeTabType", ctx_r14.activeTabType)("planTypes", ctx_r14.planTypes)("hospitalIndemnityBadgeText", ctx_r14.hospitalIndemnityBadgeText)("planCardQuoteLinkNameText", ctx_r14.planCardQuoteLinkNameText);
} }
function PlanQuoteComponent_ng_container_0_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, PlanQuoteComponent_ng_container_0_ng_template_10_div_1_Template, 2, 11, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("heightSelectorsToCompare", ctx_r3.planQuoteHeightSelectors)("parentElementIdentifier", ctx_r3.planQuoteParentHeightIdentifier);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.plansSelectedToQuote)("ngForTrackBy", ctx_r3.trackIndex);
} }
function PlanQuoteComponent_ng_container_0_ng_container_12_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31)(1, "vnext-link", 17);
    i0.ɵɵlistener("click", function PlanQuoteComponent_ng_container_0_ng_container_12_div_4_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r21.onAddMedicareAdvantagePlan()); })("keyup.enter", function PlanQuoteComponent_ng_container_0_ng_container_12_div_4_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r22); const ctx_r23 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r23.onAddMedicareAdvantagePlan()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r20.addMedicareAdvantagePlanText)("alwaysUnderlined", true);
} }
const _c2$7 = function (a0, a1, a2, a3) { return { "d-none d-md-flex": a0, "d-flex": a1, "col-12 col-sm-8": a2, "col-4": a3 }; };
function PlanQuoteComponent_ng_container_0_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 28)(2, "div", 29);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PlanQuoteComponent_ng_container_0_ng_container_12_div_4_Template, 2, 2, "div", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(3, _c2$7, !ctx_r4.isMedicareQuote, ctx_r4.isMedicareQuote, ctx_r4.plansSelectedToQuote.length === 1, ctx_r4.plansSelectedToQuote.length > 1));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.quoteHintText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.areAllHospitalIndemnityPlans && ctx_r4.showAddMedicareAdvantageButton);
} }
const _c3$2 = function (a0, a1, a2) { return { "col-12 col-sm-4": a0, "col-12 col-sm-8": a1, "col-12": a2 }; };
function PlanQuoteComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 2)(6, "div", 5)(7, "div", 6)(8, "div", 7);
    i0.ɵɵtemplate(9, PlanQuoteComponent_ng_container_0_ng_container_9_Template, 3, 4, "ng-container", 8);
    i0.ɵɵtemplate(10, PlanQuoteComponent_ng_container_0_ng_template_10_Template, 2, 4, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(12, PlanQuoteComponent_ng_container_0_ng_container_12_Template, 5, 8, "ng-container", 0);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(13, "div", 10)(14, "button", 11);
    i0.ɵɵlistener("click", function PlanQuoteComponent_ng_container_0_Template_button_click_14_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r24.onOpenSendQuoteModel()); });
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r2 = i0.ɵɵreference(11);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(5, _c3$2, ctx_r0.plansSelectedToQuote.length === 1, ctx_r0.plansSelectedToQuote.length > 1 && ctx_r0.plansSelectedToQuote.length < ctx_r0.addToQuoteLimit, ctx_r0.plansSelectedToQuote.length === ctx_r0.addToQuoteLimit));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0.isMedicareQuote)("ngIfElse", _r2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.plansSelectedToQuote.length < ctx_r0.addToQuoteLimit);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.isMedicareQuote ? ctx_r0.viewQuoteButtonText : ctx_r0.sendQuoteButtonText, " ");
} }
class PlanQuoteComponent {
    constructor(planFacade) {
        this.planFacade = planFacade;
        this.viewPlanDetails = new EventEmitter();
        this.removePlanFromQuoteGroup = new EventEmitter();
        this.openSendQuoteModal = new EventEmitter();
        this.addMedicareAdvantagePlan = new EventEmitter();
        this.getPersonalizedQuote = new EventEmitter();
        this.planTypeAbbreviation = PlanTypeAbbreviation;
        this.planQuoteHeightSelectors = [PlanQuoteHospitalCareHeightSelectors.BADGE_TITLE, PlanQuoteHospitalCareHeightSelectors.PLAN_NAME];
        this.planQuoteParentHeightIdentifier = 'plan-id';
    }
    trackIndex(index) {
        return index;
    }
    onViewPlanDetails(plan) {
        this.viewPlanDetails.emit(plan);
    }
    onRemovePlanFromQuoteGroup(plan) {
        this.removePlanFromQuoteGroup.emit({ selectedQuoteGroup: this.selectedQuoteGroup, plan });
    }
    onGetPersonalizedQuote(plan) {
        this.getPersonalizedQuote.emit(plan);
    }
    onOpenSendQuoteModel() {
        this.openSendQuoteModal.emit();
    }
    ngOnChanges(changes) {
        if (changes.plansSelectedToQuote && !_isEqual(changes.plansSelectedToQuote.previousValue, changes.plansSelectedToQuote.currentValue)) {
            this.areAllHospitalIndemnityPlans =
                this.plansSelectedToQuote && this.plansSelectedToQuote.every(plan => this.planFacade.isHCPlan(plan));
        }
    }
    onAddMedicareAdvantagePlan() {
        this.addMedicareAdvantagePlan.emit();
    }
}
PlanQuoteComponent.ɵfac = function PlanQuoteComponent_Factory(t) { return new (t || PlanQuoteComponent)(i0.ɵɵdirectiveInject(PlanFacade)); };
PlanQuoteComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanQuoteComponent, selectors: [["vnext-widget-plan-quote"]], inputs: { activeTabType: "activeTabType", plansSelectedToQuote: "plansSelectedToQuote", selectedQuoteGroup: "selectedQuoteGroup", sendQuoteButtonText: "sendQuoteButtonText", quoteHintText: "quoteHintText", addToQuoteLimit: "addToQuoteLimit", isMedicareQuote: "isMedicareQuote", viewQuoteButtonText: "viewQuoteButtonText", planTypes: "planTypes", removeFromQuoteText: "removeFromQuoteText", hospitalIndemnityBadgeText: "hospitalIndemnityBadgeText", addMedicareAdvantagePlanText: "addMedicareAdvantagePlanText", showAddMedicareAdvantageButton: "showAddMedicareAdvantageButton", planCardQuoteLinkNameText: "planCardQuoteLinkNameText" }, outputs: { viewPlanDetails: "viewPlanDetails", removePlanFromQuoteGroup: "removePlanFromQuoteGroup", openSendQuoteModal: "openSendQuoteModal", addMedicareAdvantagePlan: "addMedicareAdvantagePlan", getPersonalizedQuote: "getPersonalizedQuote" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "container", "plan-selected-quote"], [1, "row"], [1, "col-12", "col-sm-8", "col-md-9", "col-lg-10", "px-0"], [1, "container"], [1, "p-0", "quote-card-container", 3, "ngClass"], [1, "container", "h-100", "mh-100"], [1, "row", "h-100", "mh-100"], [4, "ngIf", "ngIfElse"], ["medicareQuote", ""], [1, "col-12", "col-sm-4", "col-md-3", "col-lg-2", "text-center", "send-quote-container"], [1, "btn", "Spa_Style_SecondaryButton", "send-quote", "btn-block", 3, "click"], ["class", "plan-quote-card px-2 pt-2 pb-lg-2", 3, "ngClass", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "plan-quote-card px-2 pb-2 d-lg-none", 3, "ngClass", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "plan-quote-card", "px-2", "pt-2", "pb-lg-2", 3, "ngClass"], [1, "d-flex", "flex-column", "w-100", "flex-lg-row", "mh-100", "justify-content-start", "justify-content-lg-between", "align-items-lg-center"], [1, "col-lg-6", "pl-0", "pr-0", "pr-lg-3", "pb-2", "pb-lg-0", "no-translate-block"], [3, "title", "alwaysUnderlined", "click", "keyup.enter"], [1, "Spa_Style_CostPremiumSmall", "pr-2", "pr-lg-3", "d-none", "d-lg-block"], [1, "text-right", "text-lg-center", "order-first", "order-lg-last"], ["tabIndex", "0", "role", "button", 1, "fal", "fa-times", "font-weight-bold", "can-click", 3, "click", "keyup.enter"], [1, "sr-only"], [1, "plan-quote-card", "px-2", "pb-2", "d-lg-none", 3, "ngClass"], [1, "Spa_Style_CostPremiumSmall", "pr-2", "pr-lg-3"], ["vnextMaximumHeight", "", 1, "row", "mx-0", 3, "heightSelectorsToCompare", "parentElementIdentifier"], ["class", "medicare-plan-quote-card px-2 pt-2 pb-lg-2 mx-0", 3, "ngClass", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "medicare-plan-quote-card", "px-2", "pt-2", "pb-lg-2", "mx-0", 3, "ngClass"], [3, "plan", "activeTabType", "planTypes", "hospitalIndemnityBadgeText", "planCardQuoteLinkNameText", "viewPlanDetails", "removePlanFromQuoteGroup", "getPersonalizedQuote"], [1, "Spa_Style_Paragraph", "quote-hint-container", "medicare-quote-text", "flex-column", "align-items-start", "justify-content-center", "py-3", "py-sm-0", 3, "ngClass"], [1, "text-center", "text-sm-left", "px-2"], ["class", "text-center text-sm-left px-2 pt-2", 4, "ngIf"], [1, "text-center", "text-sm-left", "px-2", "pt-2"]], template: function PlanQuoteComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanQuoteComponent_ng_container_0_Template, 16, 9, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.plansSelectedToQuote == null ? null : ctx.plansSelectedToQuote.length);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, IconAriaAttributesDirective, MaximumHeightDirective, PlanQuoteItemComponent, i1$2.CurrencyPipe], styles: [".plan-selected-quote[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-radius:4px}.quote-card-container[_ngcontent-%COMP%]{min-height:40px}.plan-quote-card[_ngcontent-%COMP%], .medicare-plan-quote-card[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1)}.send-quote[_ngcontent-%COMP%], .quote-hint-text[_ngcontent-%COMP%]{position:relative;top:50%;transform:translateY(-50%)}.send-quote-container[_ngcontent-%COMP%], .quote-hint-container[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Gray1)}@media (max-width: 1200px){.container[_ngcontent-%COMP%]{padding-left:15px;padding-right:15px}}@media (max-width: 575.98px){.send-quote-container[_ngcontent-%COMP%]{padding:0}.send-quote.btn[_ngcontent-%COMP%]{border-radius:0;border-width:1px 0 1px}.plan-quote-last-card[_ngcontent-%COMP%]:nth-child(3n){border-right-width:0px}.medicare-plan-quote-card[_ngcontent-%COMP%]{border-right-width:0px;border-bottom:1px solid var(--static-Spa_Style_Accent1)}}@media print{.container[_ngcontent-%COMP%]{min-width:initial!important}}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], PlanQuoteComponent.prototype, "onViewPlanDetails", null);
__decorate([
    LiveEditInactive()
], PlanQuoteComponent.prototype, "onRemovePlanFromQuoteGroup", null);
__decorate([
    LiveEditInactive()
], PlanQuoteComponent.prototype, "onOpenSendQuoteModel", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanQuoteComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-quote', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"plansSelectedToQuote?.length\">\r\n  <div class=\"container plan-selected-quote\">\r\n    <div class=\"row\">\r\n      <div class=\"col-12 col-sm-8 col-md-9 col-lg-10 px-0\">\r\n        <div class=\"container\">\r\n          <div class=\"row\">\r\n            <div\r\n              class=\"p-0 quote-card-container\"\r\n              [ngClass]=\"{\r\n                'col-12 col-sm-4': plansSelectedToQuote.length === 1,\r\n                'col-12 col-sm-8': plansSelectedToQuote.length > 1 && plansSelectedToQuote.length < addToQuoteLimit,\r\n                'col-12': plansSelectedToQuote.length === addToQuoteLimit\r\n              }\"\r\n            >\r\n              <div class=\"container h-100 mh-100\">\r\n                <div class=\"row h-100 mh-100\">\r\n                  <ng-container *ngIf=\"!isMedicareQuote; else medicareQuote\">\r\n                    <div\r\n                      class=\"plan-quote-card px-2 pt-2 pb-lg-2\"\r\n                      [ngClass]=\"{\r\n                        'col-12': plansSelectedToQuote.length === 1,\r\n                        'col-6': plansSelectedToQuote.length > 1 && plansSelectedToQuote.length < addToQuoteLimit,\r\n                        'col-4 plan-quote-last-card': plansSelectedToQuote.length === addToQuoteLimit\r\n                      }\"\r\n                      *ngFor=\"let plan of plansSelectedToQuote; trackBy: trackIndex\"\r\n                    >\r\n                      <div\r\n                        class=\"d-flex flex-column w-100 flex-lg-row mh-100 justify-content-start justify-content-lg-between align-items-lg-center\"\r\n                      >\r\n                        <div class=\"col-lg-6 pl-0 pr-0 pr-lg-3 pb-2 pb-lg-0 no-translate-block\">\r\n                          <vnext-link\r\n                            [title]=\"plan.planName\"\r\n                            (click)=\"onViewPlanDetails(plan)\"\r\n                            (keyup.enter)=\"onViewPlanDetails(plan)\"\r\n                            [alwaysUnderlined]=\"true\"\r\n                          >\r\n                          </vnext-link>\r\n                        </div>\r\n                        <div class=\"Spa_Style_CostPremiumSmall pr-2 pr-lg-3 d-none d-lg-block\">\r\n                          {{ plan.medicalPremium | currency }}\r\n                        </div>\r\n                        <div class=\"text-right text-lg-center order-first order-lg-last\">\r\n                          <i\r\n                            class=\"fal fa-times font-weight-bold can-click\"\r\n                            tabIndex=\"0\"\r\n                            role=\"button\"\r\n                            [attr.aria-label]=\"removeFromQuoteText\"\r\n                            (click)=\"onRemovePlanFromQuoteGroup(plan)\"\r\n                            (keyup.enter)=\"onRemovePlanFromQuoteGroup(plan)\"\r\n                          ></i>\r\n                          <span class=\"sr-only\">Remove plan</span>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                    <div\r\n                      class=\"plan-quote-card px-2 pb-2 d-lg-none\"\r\n                      [ngClass]=\"{\r\n                        'col-12': plansSelectedToQuote.length === 1,\r\n                        'col-6': plansSelectedToQuote.length > 1 && plansSelectedToQuote.length < addToQuoteLimit,\r\n                        'col-4 plan-quote-last-card': plansSelectedToQuote.length === addToQuoteLimit\r\n                      }\"\r\n                      *ngFor=\"let plan of plansSelectedToQuote; trackBy: trackIndex\"\r\n                    >\r\n                      <div class=\"Spa_Style_CostPremiumSmall pr-2 pr-lg-3\">{{ plan.medicalPremium | currency }}</div>\r\n                    </div>\r\n                  </ng-container>\r\n                  <ng-template #medicareQuote>\r\n                    <div\r\n                      class=\"row mx-0\"\r\n                      vnextMaximumHeight\r\n                      [heightSelectorsToCompare]=\"planQuoteHeightSelectors\"\r\n                      [parentElementIdentifier]=\"planQuoteParentHeightIdentifier\"\r\n                    >\r\n                      <div\r\n                        class=\"medicare-plan-quote-card px-2 pt-2 pb-lg-2 mx-0\"\r\n                        *ngFor=\"let plan of plansSelectedToQuote; trackBy: trackIndex\"\r\n                        [ngClass]=\"{\r\n                          'col-12 col-sm-12': plansSelectedToQuote.length === 1,\r\n                          'col-12 col-sm-6': plansSelectedToQuote.length > 1 && plansSelectedToQuote.length < addToQuoteLimit,\r\n                          'col-12 col-sm-4 plan-quote-last-card': plansSelectedToQuote.length === addToQuoteLimit\r\n                        }\"\r\n                        [attr.data-plan-id]=\"plan.id\"\r\n                      >\r\n                        <vnext-widget-plan-quote-item\r\n                          [plan]=\"plan\"\r\n                          [activeTabType]=\"activeTabType\"\r\n                          [planTypes]=\"planTypes\"\r\n                          [hospitalIndemnityBadgeText]=\"hospitalIndemnityBadgeText\"\r\n                          [planCardQuoteLinkNameText]=\"planCardQuoteLinkNameText\"\r\n                          (viewPlanDetails)=\"onViewPlanDetails(plan)\"\r\n                          (removePlanFromQuoteGroup)=\"onRemovePlanFromQuoteGroup(plan)\"\r\n                          (getPersonalizedQuote)=\"onGetPersonalizedQuote(plan)\"\r\n                        ></vnext-widget-plan-quote-item>\r\n                      </div>\r\n                    </div>\r\n                  </ng-template>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <ng-container *ngIf=\"plansSelectedToQuote.length < addToQuoteLimit\">\r\n              <div\r\n                class=\"Spa_Style_Paragraph quote-hint-container medicare-quote-text flex-column align-items-start justify-content-center py-3 py-sm-0\"\r\n                [ngClass]=\"{\r\n                  'd-none d-md-flex': !isMedicareQuote,\r\n                  'd-flex': isMedicareQuote,\r\n                  'col-12 col-sm-8': plansSelectedToQuote.length === 1,\r\n                  'col-4': plansSelectedToQuote.length > 1\r\n                }\"\r\n              >\r\n                <div class=\"text-center text-sm-left px-2\">\r\n                  {{ quoteHintText }}\r\n                </div>\r\n\r\n                <div *ngIf=\"areAllHospitalIndemnityPlans && showAddMedicareAdvantageButton\" class=\"text-center text-sm-left px-2 pt-2\">\r\n                  <vnext-link\r\n                    [title]=\"addMedicareAdvantagePlanText\"\r\n                    (click)=\"onAddMedicareAdvantagePlan()\"\r\n                    (keyup.enter)=\"onAddMedicareAdvantagePlan()\"\r\n                    [alwaysUnderlined]=\"true\"\r\n                  >\r\n                  </vnext-link>\r\n                </div>\r\n              </div>\r\n            </ng-container>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"col-12 col-sm-4 col-md-3 col-lg-2 text-center send-quote-container\">\r\n        <!-- TODO: in future stories a different method will be called when isMedicareQuote is true -->\r\n        <button class=\"btn Spa_Style_SecondaryButton send-quote btn-block\" (click)=\"onOpenSendQuoteModel()\">\r\n          {{ isMedicareQuote ? viewQuoteButtonText : sendQuoteButtonText }}\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n", styles: [".plan-selected-quote{border:1px solid var(--static-Spa_Style_Accent1);border-radius:4px}.quote-card-container{min-height:40px}.plan-quote-card,.medicare-plan-quote-card{border-right:1px solid var(--static-Spa_Style_Accent1)}.send-quote,.quote-hint-text{position:relative;top:50%;transform:translateY(-50%)}.send-quote-container,.quote-hint-container{background-color:var(--static-Spa_Style_Gray1)}@media (max-width: 1200px){.container{padding-left:15px;padding-right:15px}}@media (max-width: 575.98px){.send-quote-container{padding:0}.send-quote.btn{border-radius:0;border-width:1px 0 1px}.plan-quote-last-card:nth-child(3n){border-right-width:0px}.medicare-plan-quote-card{border-right-width:0px;border-bottom:1px solid var(--static-Spa_Style_Accent1)}}@media print{.container{min-width:initial!important}}\n"] }]
    }], function () { return [{ type: PlanFacade }]; }, { activeTabType: [{
            type: Input
        }], plansSelectedToQuote: [{
            type: Input
        }], selectedQuoteGroup: [{
            type: Input
        }], sendQuoteButtonText: [{
            type: Input
        }], quoteHintText: [{
            type: Input
        }], addToQuoteLimit: [{
            type: Input
        }], isMedicareQuote: [{
            type: Input
        }], viewQuoteButtonText: [{
            type: Input
        }], planTypes: [{
            type: Input
        }], removeFromQuoteText: [{
            type: Input
        }], hospitalIndemnityBadgeText: [{
            type: Input
        }], addMedicareAdvantagePlanText: [{
            type: Input
        }], showAddMedicareAdvantageButton: [{
            type: Input
        }], planCardQuoteLinkNameText: [{
            type: Input
        }], viewPlanDetails: [{
            type: Output
        }], removePlanFromQuoteGroup: [{
            type: Output
        }], openSendQuoteModal: [{
            type: Output
        }], addMedicareAdvantagePlan: [{
            type: Output
        }], getPersonalizedQuote: [{
            type: Output
        }], onViewPlanDetails: [], onRemovePlanFromQuoteGroup: [], onOpenSendQuoteModel: [] }); })();

class SelectPlanQuoteErrorComponent {
}
SelectPlanQuoteErrorComponent.ɵfac = function SelectPlanQuoteErrorComponent_Factory(t) { return new (t || SelectPlanQuoteErrorComponent)(); };
SelectPlanQuoteErrorComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectPlanQuoteErrorComponent, selectors: [["vnext-widget-select-plan-quote-error"]], inputs: { selectRequiredFieldsError: "selectRequiredFieldsError", fieldName: "fieldName" }, decls: 3, vars: 2, consts: [[1, "error-container", "mb-1", "d-flex", "align-items-end", "Spa_Style_Small_Font"], [1, "error-color"]], template: function SelectPlanQuoteErrorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate2("", ctx.selectRequiredFieldsError, " ", ctx.fieldName, " ");
    } }, styles: [".plan-type-badge[_ngcontent-%COMP%]{font-size:14px;overflow:hidden;text-overflow:ellipsis}.plan-type-badge-selected-plan[_ngcontent-%COMP%]{border-radius:5px;background:var(--static-Spa_Style_Gray2);color:var(--static-Spa_Style_Gray4);font-family:montserrat_semibold}.medicare-quote-text[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Gray4)}.error-container[_ngcontent-%COMP%]{min-height:35px;max-height:35px;line-height:18px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectPlanQuoteErrorComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-select-plan-quote-error', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"error-container mb-1 d-flex align-items-end Spa_Style_Small_Font\">\r\n  <span class=\"error-color\">{{ selectRequiredFieldsError }} {{ fieldName }} </span>\r\n</div>\r\n", styles: [".plan-type-badge{font-size:14px;overflow:hidden;text-overflow:ellipsis}.plan-type-badge-selected-plan{border-radius:5px;background:var(--static-Spa_Style_Gray2);color:var(--static-Spa_Style_Gray4);font-family:montserrat_semibold}.medicare-quote-text{color:var(--static-Spa_Style_Gray4)}.error-container{min-height:35px;max-height:35px;line-height:18px}\n"] }]
    }], null, { selectRequiredFieldsError: [{
            type: Input
        }], fieldName: [{
            type: Input
        }] }); })();

function SelectPlanQuoteComponent_div_15_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 28);
} }
function SelectPlanQuoteComponent_div_15_vnext_widget_select_plan_quote_error_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-select-plan-quote-error", 29);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("selectRequiredFieldsError", ctx_r6.pleaseSelectRequiredFieldsErrorText)("fieldName", ctx_r6.planTypeText);
} }
function SelectPlanQuoteComponent_div_15_button_16_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 30);
    i0.ɵɵlistener("click", function SelectPlanQuoteComponent_div_15_button_16_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r11); const planType_r9 = restoredCtx.$implicit; const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.onSelectPlanType(planType_r9)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const planType_r9 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", planType_r9.title, " ");
} }
function SelectPlanQuoteComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, SelectPlanQuoteComponent_div_15_div_1_Template, 1, 0, "div", 17);
    i0.ɵɵtemplate(2, SelectPlanQuoteComponent_div_15_vnext_widget_select_plan_quote_error_2_Template, 1, 2, "vnext-widget-select-plan-quote-error", 18);
    i0.ɵɵelementStart(3, "label", 19)(4, "span", 5);
    i0.ɵɵtext(5, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 20, 21)(9, "button", 22)(10, "span", 23);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "i", 24);
    i0.ɵɵelementStart(13, "span", 25);
    i0.ɵɵtext(14, "Expand");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "div", 26);
    i0.ɵɵtemplate(16, SelectPlanQuoteComponent_div_15_button_16_Template, 2, 1, "button", 27);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.checkRequiredOptions && !ctx_r0.hasSelectedAllOptions && ctx_r0.selectedPlanType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.checkRequiredOptions && !ctx_r0.hasSelectedAllOptions && !ctx_r0.selectedPlanType);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", ctx_r0.planTypeText, " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.selectedPlanType ? ctx_r0.selectedPlanType.title : ctx_r0.planTypeHintText);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r0.planTypes);
} }
function SelectPlanQuoteComponent_div_16_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 28);
} }
function SelectPlanQuoteComponent_div_16_vnext_widget_select_plan_quote_error_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-select-plan-quote-error", 29);
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("selectRequiredFieldsError", ctx_r13.pleaseSelectRequiredFieldsErrorText)("fieldName", ctx_r13.carriersText);
} }
function SelectPlanQuoteComponent_div_16_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 36);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r15.selectedCarrier);
} }
function SelectPlanQuoteComponent_div_16_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r17.carriersHintText, " ");
} }
function SelectPlanQuoteComponent_div_16_button_18_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37);
    i0.ɵɵlistener("click", function SelectPlanQuoteComponent_div_16_button_18_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r21); const carrier_r19 = restoredCtx.$implicit; const ctx_r20 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r20.onSelectCarrier(carrier_r19)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const carrier_r19 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", carrier_r19, " ");
} }
function SelectPlanQuoteComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵtemplate(1, SelectPlanQuoteComponent_div_16_div_1_Template, 1, 0, "div", 17);
    i0.ɵɵtemplate(2, SelectPlanQuoteComponent_div_16_vnext_widget_select_plan_quote_error_2_Template, 1, 2, "vnext-widget-select-plan-quote-error", 18);
    i0.ɵɵelementStart(3, "label", 19)(4, "span", 5);
    i0.ɵɵtext(5, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 20, 32)(9, "button", 22)(10, "span", 23);
    i0.ɵɵtemplate(11, SelectPlanQuoteComponent_div_16_ng_container_11_Template, 3, 1, "ng-container", 33);
    i0.ɵɵtemplate(12, SelectPlanQuoteComponent_div_16_ng_template_12_Template, 1, 1, "ng-template", null, 34, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "i", 24);
    i0.ɵɵelementStart(15, "span", 25);
    i0.ɵɵtext(16, "Expand");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "div", 26);
    i0.ɵɵtemplate(18, SelectPlanQuoteComponent_div_16_button_18_Template, 2, 1, "button", 35);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const _r16 = i0.ɵɵreference(13);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.checkRequiredOptions && !ctx_r1.hasSelectedAllOptions && ctx_r1.selectedCarrier);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.checkRequiredOptions && !ctx_r1.hasSelectedAllOptions && !ctx_r1.selectedCarrier);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", ctx_r1.carriersText, " ");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.selectedCarrier)("ngIfElse", _r16);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngForOf", ctx_r1.carriers);
} }
function SelectPlanQuoteComponent_div_17_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 28);
} }
function SelectPlanQuoteComponent_div_17_vnext_widget_select_plan_quote_error_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-select-plan-quote-error", 29);
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("selectRequiredFieldsError", ctx_r23.pleaseSelectRequiredFieldsErrorText)("fieldName", ctx_r23.plansToQuoteText);
} }
function SelectPlanQuoteComponent_div_17_button_16_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37);
    i0.ɵɵlistener("click", function SelectPlanQuoteComponent_div_17_button_16_Template_button_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r28); const plan_r26 = restoredCtx.$implicit; const ctx_r27 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r27.onSelectPlanName(plan_r26)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r26 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", plan_r26.planName, " ");
} }
function SelectPlanQuoteComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵtemplate(1, SelectPlanQuoteComponent_div_17_div_1_Template, 1, 0, "div", 17);
    i0.ɵɵtemplate(2, SelectPlanQuoteComponent_div_17_vnext_widget_select_plan_quote_error_2_Template, 1, 2, "vnext-widget-select-plan-quote-error", 18);
    i0.ɵɵelementStart(3, "label", 19)(4, "span", 5);
    i0.ɵɵtext(5, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 20, 39)(9, "button", 22)(10, "span", 40);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "i", 24);
    i0.ɵɵelementStart(13, "span", 25);
    i0.ɵɵtext(14, "Expand");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "div", 26);
    i0.ɵɵtemplate(16, SelectPlanQuoteComponent_div_17_button_16_Template, 2, 1, "button", 35);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.checkRequiredOptions && !ctx_r2.hasSelectedAllOptions && ctx_r2.selectedPlan);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.checkRequiredOptions && !ctx_r2.hasSelectedAllOptions && !ctx_r2.selectedPlan);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", ctx_r2.plansToQuoteText, " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r2.selectedPlan ? ctx_r2.selectedPlan.planName : ctx_r2.plansToQuoteHintText);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r2.plansToQuote);
} }
const _c0$I = function (a0, a1) { return { "col-12 col-sm-8": a0, "col-12": a1 }; };
function SelectPlanQuoteComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41)(1, "label", 42);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 43);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c0$I, ctx_r3.planTypes == null ? null : ctx_r3.planTypes.length, !(ctx_r3.planTypes == null ? null : ctx_r3.planTypes.length)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.noPlansAvailableText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.noPlansAvailableHintText, " ");
} }
function SelectPlanQuoteComponent_div_19_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 47);
} }
function SelectPlanQuoteComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵtemplate(1, SelectPlanQuoteComponent_div_19_div_1_Template, 1, 0, "div", 45);
    i0.ɵɵelementStart(2, "button", 46);
    i0.ɵɵlistener("click", function SelectPlanQuoteComponent_div_19_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r30.onSetSelectedPlan()); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.checkRequiredOptions && !ctx_r4.hasSelectedAllOptions);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.selectPlanButtonText, " ");
} }
const _c1$c = function (a0, a1) { return { "col-12 col-sm-8 col-md-9 col-lg-10": a0, "col-12": a1 }; };
class SelectPlanQuoteComponent {
    constructor(cdr, store, analyticsService) {
        this.cdr = cdr;
        this.store = store;
        this.analyticsService = analyticsService;
        this.selectPlanNameToQuote = new EventEmitter();
        this.subscriptions = new Subscription();
        this.selectedPlanType$ = new Subject();
        this.subscriptions.add(this.selectedPlanType$
            .pipe(filter(selectedPlanType => !!selectedPlanType), switchMap(selectedPlanType => this.store.select(PlansState.getPlansByPlanType(selectedPlanType))))
            .subscribe({
            next: (plansByPlanType) => {
                this.setCarriers(plansByPlanType);
            }
        }));
    }
    ngOnChanges(changes) {
        const { planTypes } = changes;
        if (planTypes && !_isEqual(planTypes.previousValue, planTypes.currentValue)) {
            // If we get only 1 result in the list, pre-select it on the dropdown
            if (this.planTypes?.length === 1) {
                this.onSelectPlanType(this.planTypes[0]);
            }
            else if (planTypes.currentValue.length === 0) {
                this.hasNoResultsForPlanType = true;
            }
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    onSelectPlanType(planType) {
        this.checkRequiredOptions = false;
        if (!_isEqual(planType, this.selectedPlanType)) {
            this.selectedPlanType = planType;
            this.selectedPlanTypeToQuote = planType.tabType;
            this.plansToQuote = [];
            this.selectedPlanType$.next(planType.tabType);
        }
    }
    setCarriers(plansByPlanType) {
        this.carriers = [...new Set(plansByPlanType.map(plan => this.getPlanCarrierName(plan)))].sort();
        // If we get only 1 result in the list, pre-select it on the dropdown
        if (this.carriers?.length === 1) {
            this.onSelectCarrier(this.carriers[0]);
        }
        else {
            this.selectedCarrier = null;
            this.selectedPlan = null;
        }
        this.checkHasNoResultsForPlanType();
        this.cdr.markForCheck();
    }
    onSelectCarrier(carrier) {
        this.checkRequiredOptions = false;
        this.selectedCarrier = carrier;
        this.plansToQuote = _sortBy(this.store.selectSnapshot(PlansState.getPlansWithOptions(this.getPlanTypeOptions())), 'planName');
        // If we get only 1 result in the list, pre-select it on the dropdown
        if (this.plansToQuote?.length === 1) {
            this.onSelectPlanName(this.plansToQuote[0]);
        }
        else {
            this.selectedPlan = this.selectedPlan?.carrierName === carrier ? this.selectedPlan : null;
        }
    }
    onSelectPlanName(plan) {
        this.checkRequiredOptions = false;
        this.selectedPlan = plan;
    }
    onSetSelectedPlan() {
        this.checkRequiredOptions = true;
        this.checkHasSelectedAllOptions();
        if (this.hasSelectedAllOptions) {
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLANS_SELECT_HEALTH_PLAN_ADDON_COVERAGE,
                [DataLayerGlobalVariable.PLANTYPE_ADDON]: this.selectedPlanType.tabType,
                [DataLayerGlobalVariable.PLAN_CARRIER_ADDON]: this.selectedPlan.carrierName,
                [DataLayerGlobalVariable.PLAN_ID_ADDON]: this.selectedPlan.planId
            };
            this.selectPlanNameToQuote.emit(this.selectedPlan);
        }
    }
    checkHasNoResultsForPlanType() {
        this.hasNoResultsForPlanType = this.selectedPlanType && this.carriers?.length === 0;
    }
    checkHasSelectedAllOptions() {
        this.hasSelectedAllOptions = !!this.selectedPlanType && !!this.selectedCarrier && !!this.selectedPlan;
    }
    getPlanCarrierName(plan) {
        let carrierName = plan.carrierInformation?.organizationName || plan.carrierName;
        if (this.planMarketingNameEnabled && plan.planMarketingName) {
            carrierName = plan.planMarketingName;
        }
        return carrierName;
    }
    getPlanTypeOptions() {
        const planTypeOptions = {
            planTypeAbbreviation: this.selectedPlanTypeToQuote,
            carrierName: this.selectedCarrier,
            planMarketingNameEnabled: this.planMarketingNameEnabled
        };
        return planTypeOptions;
    }
}
SelectPlanQuoteComponent.ɵfac = function SelectPlanQuoteComponent_Factory(t) { return new (t || SelectPlanQuoteComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(AnalyticsService)); };
SelectPlanQuoteComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectPlanQuoteComponent, selectors: [["vnext-widget-select-plan-quote"]], inputs: { planTypes: "planTypes", planTypeInstructionalText: "planTypeInstructionalText", selectPlanButtonText: "selectPlanButtonText", planTypeHintText: "planTypeHintText", planTypeText: "planTypeText", carriersHintText: "carriersHintText", carriersText: "carriersText", plansToQuoteHintText: "plansToQuoteHintText", plansToQuoteText: "plansToQuoteText", noPlansAvailableText: "noPlansAvailableText", noPlansAvailableHintText: "noPlansAvailableHintText", requiredFieldsHintText: "requiredFieldsHintText", pleaseSelectRequiredFieldsErrorText: "pleaseSelectRequiredFieldsErrorText", planMarketingNameEnabled: "planMarketingNameEnabled" }, outputs: { selectPlanNameToQuote: "selectPlanNameToQuote" }, features: [i0.ɵɵNgOnChangesFeature], decls: 20, vars: 11, consts: [[1, "container", "plan-selected-quote", "Spa_Style_Primary_Color"], [1, "row"], [1, "Spa_Style_Paragraph", "col-12", "mt-4", "mb-2"], [1, "quote-hint-text", "text-left"], [1, "select-quote-hint-text", "Spa_Style_SecondaryButton_Text", "Spa_Style_Smaller_Font", "h-100"], [1, "input-error-asterisk"], [1, "px-0", "pb-2", "pb-sm-4", 3, "ngClass"], [1, "container"], [1, "p-0", "quote-card-container", "col-12"], [1, "container", "h-100", "mh-100"], [1, "row", "h-100", "mh-100"], ["class", "plan-quote-card pt-2 pb-lg-2 col-12 col-sm-4", 4, "ngIf"], ["class", "plan-quote-card pt-2 pb-lg-2 col-12 col-sm-4 plan-quote-card", 4, "ngIf"], ["class", "plan-quote-card pt-2 pb-lg-2 col-12 col-sm-4 plan-quote-last-card", 4, "ngIf"], ["class", "plan-quote-card pt-2 pb-lg-2 col-12 col-sm-8 plan-quote-last-card", 3, "ngClass", 4, "ngIf"], ["class", "col-12 col-sm-4 mt-sm-0 mt-4 col-md-3 col-lg-2 text-center send-quote-container", 4, "ngIf"], [1, "plan-quote-card", "pt-2", "pb-lg-2", "col-12", "col-sm-4"], ["class", "mb-1 error-container d-none d-lg-block", 4, "ngIf"], [3, "selectRequiredFieldsError", "fieldName", 4, "ngIf"], [1, "Spa_Style_Small_Font", "Spa_Style_Semi_Bold_Weight", "w-100"], ["ngbDropdown", "", 1, "d-inline-block", "pr-1", "w-100"], ["selectPlanTypeDropdown", "ngbDropdown"], ["ngbDropdownToggle", "", "tabindex", "0", "aria-required", "true", "role", "combobox", "selectDropdownByCharacter", "", 1, "month-toggle", "med-sup-dropdown-toggle", "w-100"], [1, "Spa_Style_Primary_Color", "dropdown-selected-value", "text-left"], [1, "fa", "fa-angle-down", "pt-1", "pl-2"], [1, "sr-only"], ["ngbDropdownMenu", ""], ["ngbDropdownItem", "", "class", "Spa_Style_Primary_Color", "tabindex", "0", 3, "click", 4, "ngFor", "ngForOf"], [1, "mb-1", "error-container", "d-none", "d-lg-block"], [3, "selectRequiredFieldsError", "fieldName"], ["ngbDropdownItem", "", "tabindex", "0", 1, "Spa_Style_Primary_Color", 3, "click"], [1, "plan-quote-card", "pt-2", "pb-lg-2", "col-12", "col-sm-4", "plan-quote-card"], ["selectCarrierDropdown", "ngbDropdown"], [4, "ngIf", "ngIfElse"], ["carriersHint", ""], ["ngbDropdownItem", "", "class", "Spa_Style_Primary_Color no-translate-block", "tabindex", "0", 3, "click", 4, "ngFor", "ngForOf"], [1, "no-translate-block"], ["ngbDropdownItem", "", "tabindex", "0", 1, "Spa_Style_Primary_Color", "no-translate-block", 3, "click"], [1, "plan-quote-card", "pt-2", "pb-lg-2", "col-12", "col-sm-4", "plan-quote-last-card"], ["selectPlanDropdown", "ngbDropdown"], [1, "Spa_Style_Primary_Color", "dropdown-selected-value", "text-left", "no-translate-block"], [1, "plan-quote-card", "pt-2", "pb-lg-2", "col-12", "col-sm-8", "plan-quote-last-card", 3, "ngClass"], [1, "Spa_Style_Small_Font", "Spa_Style_Semi_Bold_Weight", "w-100", "text-center"], [1, "Spa_Style_Small_Font", "w-100", "text-center"], [1, "col-12", "col-sm-4", "mt-sm-0", "mt-4", "col-md-3", "col-lg-2", "text-center", "send-quote-container"], ["class", "mb-1 btn-error-spacer d-none d-lg-block", 4, "ngIf"], [1, "btn", "Spa_Style_SecondaryButton", "send-quote", "btn-block", 3, "click"], [1, "mb-1", "btn-error-spacer", "d-none", "d-lg-block"]], template: function SelectPlanQuoteComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4)(6, "span", 5);
        i0.ɵɵtext(7, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "div", 6)(10, "div", 7)(11, "div", 1)(12, "div", 8)(13, "div", 9)(14, "div", 10);
        i0.ɵɵtemplate(15, SelectPlanQuoteComponent_div_15_Template, 17, 5, "div", 11);
        i0.ɵɵtemplate(16, SelectPlanQuoteComponent_div_16_Template, 19, 6, "div", 12);
        i0.ɵɵtemplate(17, SelectPlanQuoteComponent_div_17_Template, 17, 5, "div", 13);
        i0.ɵɵtemplate(18, SelectPlanQuoteComponent_div_18_Template, 5, 6, "div", 14);
        i0.ɵɵelementEnd()()()()()();
        i0.ɵɵtemplate(19, SelectPlanQuoteComponent_div_19_Template, 4, 2, "div", 15);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.planTypeInstructionalText);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.requiredFieldsHintText, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c1$c, !ctx.hasNoResultsForPlanType, ctx.hasNoResultsForPlanType));
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.planTypes == null ? null : ctx.planTypes.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.hasNoResultsForPlanType && ctx.selectedPlanType);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedCarrier);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasNoResultsForPlanType);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.hasNoResultsForPlanType);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, SelectDropdownByCharacterDirective, IconAriaAttributesDirective, i1$1.NgbDropdown, i1$1.NgbDropdownToggle, i1$1.NgbDropdownMenu, i1$1.NgbDropdownItem, SelectPlanQuoteErrorComponent], styles: [".plan-selected-quote[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-radius:4px}.quote-card-container[_ngcontent-%COMP%]{min-height:40px}.send-quote[_ngcontent-%COMP%], .select-quote-hint-text[_ngcontent-%COMP%]{position:relative;top:50%;transform:translateY(-50%)}.dropdown-selected-value[_ngcontent-%COMP%]{display:inline-block;overflow-x:hidden;width:calc(100% - 15px);text-overflow:ellipsis;font-size:14px}.error-container[_ngcontent-%COMP%]{min-height:35px;max-height:35px;line-height:18px}.btn-error-spacer[_ngcontent-%COMP%]{min-height:18px;max-height:18px;line-height:18px}@media (max-width: 1200px){.container[_ngcontent-%COMP%]{padding-left:15px;padding-right:15px}}@media (max-width: 575.98px){.send-quote-container[_ngcontent-%COMP%]{padding:0}.send-quote.btn[_ngcontent-%COMP%]{border-radius:0;border-width:1px 0 1px}.plan-quote-last-card[_ngcontent-%COMP%]:nth-child(3n){border-right-width:0px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectPlanQuoteComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-select-plan-quote', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container plan-selected-quote Spa_Style_Primary_Color\">\r\n  <div class=\"row\">\r\n    <div class=\"Spa_Style_Paragraph col-12 mt-4 mb-2\">\r\n      <div class=\"quote-hint-text text-left\">{{ planTypeInstructionalText }}</div>\r\n      <div class=\"select-quote-hint-text Spa_Style_SecondaryButton_Text Spa_Style_Smaller_Font h-100\">\r\n        <span class=\"input-error-asterisk\">*</span> {{ requiredFieldsHintText }}\r\n      </div>\r\n    </div>\r\n    <div\r\n      class=\"px-0 pb-2 pb-sm-4\"\r\n      [ngClass]=\"{\r\n        'col-12 col-sm-8 col-md-9 col-lg-10': !hasNoResultsForPlanType,\r\n        'col-12': hasNoResultsForPlanType\r\n      }\"\r\n    >\r\n      <div class=\"container\">\r\n        <div class=\"row\">\r\n          <div class=\"p-0 quote-card-container col-12\">\r\n            <div class=\"container h-100 mh-100\">\r\n              <div class=\"row h-100 mh-100\">\r\n                <div class=\"plan-quote-card pt-2 pb-lg-2 col-12 col-sm-4\" *ngIf=\"planTypes?.length\">\r\n                  <div\r\n                    class=\"mb-1 error-container d-none d-lg-block\"\r\n                    *ngIf=\"checkRequiredOptions && !hasSelectedAllOptions && selectedPlanType\"\r\n                  ></div>\r\n                  <vnext-widget-select-plan-quote-error\r\n                    *ngIf=\"checkRequiredOptions && !hasSelectedAllOptions && !selectedPlanType\"\r\n                    [selectRequiredFieldsError]=\"pleaseSelectRequiredFieldsErrorText\"\r\n                    [fieldName]=\"planTypeText\"\r\n                  ></vnext-widget-select-plan-quote-error>\r\n                  <label class=\"Spa_Style_Small_Font Spa_Style_Semi_Bold_Weight w-100\">\r\n                    <span class=\"input-error-asterisk\">*</span>{{ planTypeText }}\r\n                  </label>\r\n\r\n                  <div class=\"d-inline-block pr-1 w-100\" ngbDropdown #selectPlanTypeDropdown=\"ngbDropdown\">\r\n                    <button\r\n                      ngbDropdownToggle\r\n                      class=\"month-toggle med-sup-dropdown-toggle w-100\"\r\n                      tabindex=\"0\"\r\n                      aria-required=\"true\"\r\n                      role=\"combobox\"\r\n                      selectDropdownByCharacter\r\n                    >\r\n                      <span class=\"Spa_Style_Primary_Color dropdown-selected-value text-left\">{{\r\n                        selectedPlanType ? selectedPlanType.title : planTypeHintText\r\n                      }}</span>\r\n                      <i class=\"fa fa-angle-down pt-1 pl-2\"></i>\r\n                      <span class=\"sr-only\">Expand</span>\r\n                    </button>\r\n                    <div ngbDropdownMenu>\r\n                      <button\r\n                        *ngFor=\"let planType of planTypes\"\r\n                        ngbDropdownItem\r\n                        class=\"Spa_Style_Primary_Color\"\r\n                        (click)=\"onSelectPlanType(planType)\"\r\n                        tabindex=\"0\"\r\n                      >\r\n                        {{ planType.title }}\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n\r\n                <div\r\n                  class=\"plan-quote-card pt-2 pb-lg-2 col-12 col-sm-4 plan-quote-card\"\r\n                  *ngIf=\"!hasNoResultsForPlanType && selectedPlanType\"\r\n                >\r\n                  <div\r\n                    class=\"mb-1 error-container d-none d-lg-block\"\r\n                    *ngIf=\"checkRequiredOptions && !hasSelectedAllOptions && selectedCarrier\"\r\n                  ></div>\r\n                  <vnext-widget-select-plan-quote-error\r\n                    *ngIf=\"checkRequiredOptions && !hasSelectedAllOptions && !selectedCarrier\"\r\n                    [selectRequiredFieldsError]=\"pleaseSelectRequiredFieldsErrorText\"\r\n                    [fieldName]=\"carriersText\"\r\n                  ></vnext-widget-select-plan-quote-error>\r\n                  <label class=\"Spa_Style_Small_Font Spa_Style_Semi_Bold_Weight w-100\">\r\n                    <span class=\"input-error-asterisk\">*</span>{{ carriersText }}\r\n                  </label>\r\n\r\n                  <div class=\"d-inline-block pr-1 w-100\" ngbDropdown #selectCarrierDropdown=\"ngbDropdown\">\r\n                    <button\r\n                      ngbDropdownToggle\r\n                      class=\"month-toggle med-sup-dropdown-toggle w-100\"\r\n                      tabindex=\"0\"\r\n                      aria-required=\"true\"\r\n                      role=\"combobox\"\r\n                      selectDropdownByCharacter\r\n                    >\r\n                      <span class=\"Spa_Style_Primary_Color dropdown-selected-value text-left\">\r\n                        <ng-container *ngIf=\"selectedCarrier; else carriersHint\">\r\n                          <span class=\"no-translate-block\">{{ selectedCarrier }}</span>\r\n                        </ng-container>\r\n                        <ng-template #carriersHint>\r\n                          {{ carriersHintText }}\r\n                        </ng-template>\r\n                      </span>\r\n                      <i class=\"fa fa-angle-down pt-1 pl-2\"></i>\r\n                      <span class=\"sr-only\">Expand</span>\r\n                    </button>\r\n                    <div ngbDropdownMenu>\r\n                      <button\r\n                        *ngFor=\"let carrier of carriers\"\r\n                        ngbDropdownItem\r\n                        class=\"Spa_Style_Primary_Color no-translate-block\"\r\n                        (click)=\"onSelectCarrier(carrier)\"\r\n                        tabindex=\"0\"\r\n                      >\r\n                        {{ carrier }}\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n\r\n                <div class=\"plan-quote-card pt-2 pb-lg-2 col-12 col-sm-4 plan-quote-last-card\" *ngIf=\"selectedCarrier\">\r\n                  <div\r\n                    class=\"mb-1 error-container d-none d-lg-block\"\r\n                    *ngIf=\"checkRequiredOptions && !hasSelectedAllOptions && selectedPlan\"\r\n                  ></div>\r\n                  <vnext-widget-select-plan-quote-error\r\n                    *ngIf=\"checkRequiredOptions && !hasSelectedAllOptions && !selectedPlan\"\r\n                    [selectRequiredFieldsError]=\"pleaseSelectRequiredFieldsErrorText\"\r\n                    [fieldName]=\"plansToQuoteText\"\r\n                  ></vnext-widget-select-plan-quote-error>\r\n                  <label class=\"Spa_Style_Small_Font Spa_Style_Semi_Bold_Weight w-100\">\r\n                    <span class=\"input-error-asterisk\">*</span>{{ plansToQuoteText }}\r\n                  </label>\r\n\r\n                  <div class=\"d-inline-block pr-1 w-100\" ngbDropdown #selectPlanDropdown=\"ngbDropdown\">\r\n                    <button\r\n                      ngbDropdownToggle\r\n                      class=\"month-toggle med-sup-dropdown-toggle w-100\"\r\n                      tabindex=\"0\"\r\n                      aria-required=\"true\"\r\n                      role=\"combobox\"\r\n                      selectDropdownByCharacter\r\n                    >\r\n                      <span class=\"Spa_Style_Primary_Color dropdown-selected-value text-left no-translate-block\">{{\r\n                        selectedPlan ? selectedPlan.planName : plansToQuoteHintText\r\n                      }}</span>\r\n                      <i class=\"fa fa-angle-down pt-1 pl-2\"></i>\r\n                      <span class=\"sr-only\">Expand</span>\r\n                    </button>\r\n                    <div ngbDropdownMenu>\r\n                      <button\r\n                        *ngFor=\"let plan of plansToQuote\"\r\n                        ngbDropdownItem\r\n                        class=\"Spa_Style_Primary_Color no-translate-block\"\r\n                        (click)=\"onSelectPlanName(plan)\"\r\n                        tabindex=\"0\"\r\n                      >\r\n                        {{ plan.planName }}\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n\r\n                <div\r\n                  class=\"plan-quote-card pt-2 pb-lg-2 col-12 col-sm-8 plan-quote-last-card\"\r\n                  [ngClass]=\"{\r\n                    'col-12 col-sm-8': planTypes?.length,\r\n                    'col-12': !planTypes?.length\r\n                  }\"\r\n                  *ngIf=\"hasNoResultsForPlanType\"\r\n                >\r\n                  <label class=\"Spa_Style_Small_Font Spa_Style_Semi_Bold_Weight w-100 text-center\">\r\n                    {{ noPlansAvailableText }}\r\n                  </label>\r\n\r\n                  <label class=\"Spa_Style_Small_Font w-100 text-center\">\r\n                    {{ noPlansAvailableHintText }}\r\n                  </label>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div *ngIf=\"!hasNoResultsForPlanType\" class=\"col-12 col-sm-4 mt-sm-0 mt-4 col-md-3 col-lg-2 text-center send-quote-container\">\r\n      <div class=\"mb-1 btn-error-spacer d-none d-lg-block\" *ngIf=\"checkRequiredOptions && !hasSelectedAllOptions\"></div>\r\n      <button class=\"btn Spa_Style_SecondaryButton send-quote btn-block\" (click)=\"onSetSelectedPlan()\">\r\n        {{ selectPlanButtonText }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".plan-selected-quote{border:1px solid var(--static-Spa_Style_Accent1);border-radius:4px}.quote-card-container{min-height:40px}.send-quote,.select-quote-hint-text{position:relative;top:50%;transform:translateY(-50%)}.dropdown-selected-value{display:inline-block;overflow-x:hidden;width:calc(100% - 15px);text-overflow:ellipsis;font-size:14px}.error-container{min-height:35px;max-height:35px;line-height:18px}.btn-error-spacer{min-height:18px;max-height:18px;line-height:18px}@media (max-width: 1200px){.container{padding-left:15px;padding-right:15px}}@media (max-width: 575.98px){.send-quote-container{padding:0}.send-quote.btn{border-radius:0;border-width:1px 0 1px}.plan-quote-last-card:nth-child(3n){border-right-width:0px}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i2.Store }, { type: AnalyticsService }]; }, { planTypes: [{
            type: Input
        }], planTypeInstructionalText: [{
            type: Input
        }], selectPlanButtonText: [{
            type: Input
        }], planTypeHintText: [{
            type: Input
        }], planTypeText: [{
            type: Input
        }], carriersHintText: [{
            type: Input
        }], carriersText: [{
            type: Input
        }], plansToQuoteHintText: [{
            type: Input
        }], plansToQuoteText: [{
            type: Input
        }], noPlansAvailableText: [{
            type: Input
        }], noPlansAvailableHintText: [{
            type: Input
        }], requiredFieldsHintText: [{
            type: Input
        }], pleaseSelectRequiredFieldsErrorText: [{
            type: Input
        }], planMarketingNameEnabled: [{
            type: Input
        }], selectPlanNameToQuote: [{
            type: Output
        }] }); })();

function PreferencesBannerComponent_div_0_div_6_ng_container_1_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function PreferencesBannerComponent_div_0_div_6_ng_container_1_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r9); const button_r3 = i0.ɵɵnextContext().$implicit; const ctx_r7 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r7.onButtonClick(button_r3.sectionType)); });
    i0.ɵɵelementStart(1, "span", 16);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const button_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(button_r3.buttonText);
} }
function PreferencesBannerComponent_div_0_div_6_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17)(1, "div", 18)(2, "h3", 16);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 19)(5, "p", 20);
    i0.ɵɵelement(6, "span", 21);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "button", 22);
    i0.ɵɵlistener("click", function PreferencesBannerComponent_div_0_div_6_ng_container_1_ng_template_2_Template_button_click_8_listener() { i0.ɵɵrestoreView(_r13); const button_r3 = i0.ɵɵnextContext().$implicit; const ctx_r11 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r11.onViewClick(button_r3.sectionType)); });
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const button_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", button_r3.sectionTitle, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2(" ", ctx_r6.preferenceSectionCount == null ? null : ctx_r6.preferenceSectionCount[button_r3.sectionType], " ", ctx_r6.addedButtonText, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.viewButtonText, " ");
} }
function PreferencesBannerComponent_div_0_div_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PreferencesBannerComponent_div_0_div_6_ng_container_1_button_1_Template, 3, 1, "button", 13);
    i0.ɵɵtemplate(2, PreferencesBannerComponent_div_0_div_6_ng_container_1_ng_template_2_Template, 10, 4, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const button_r3 = ctx.$implicit;
    const _r5 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(ctx_r2.preferenceSectionCount == null ? null : ctx_r2.preferenceSectionCount[button_r3.sectionType]))("ngIfElse", _r5);
} }
function PreferencesBannerComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, PreferencesBannerComponent_div_0_div_6_ng_container_1_Template, 4, 2, "ng-container", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.preferenceBannerButtons)("ngForTrackBy", ctx_r1.trackByIndex);
} }
function PreferencesBannerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3)(3, "div", 4)(4, "h2", 5);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, PreferencesBannerComponent_div_0_div_6_Template, 2, 2, "div", 6);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "div", 7)(8, "button", 8);
    i0.ɵɵlistener("click", function PreferencesBannerComponent_div_0_Template_button_click_8_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.showPreferencesBannerToggle()); })("keyup.enter", function PreferencesBannerComponent_div_0_Template_button_keyup_enter_8_listener() { i0.ɵɵrestoreView(_r16); const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.showPreferencesBannerToggle()); });
    i0.ɵɵelement(9, "i", 9);
    i0.ɵɵelementStart(10, "span", 10);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.bannerHeaderText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showPreferencesBanner);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-expanded", ctx_r0.showPreferencesBanner);
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r0.showPreferencesBanner ? "fas fa-chevron-up" : "fas fa-chevron-down");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.showPreferencesBanner ? ctx_r0.viewBannerButtonText : ctx_r0.hideBannerButtonText);
} }
class PreferencesBannerComponent {
    constructor(cdr, injector, guidedHelpModalService, guidedHelpModalContextService) {
        this.cdr = cdr;
        this.injector = injector;
        this.guidedHelpModalService = guidedHelpModalService;
        this.guidedHelpModalContextService = guidedHelpModalContextService;
        this.medicineCabinet = [];
        this.onModalClosed = new EventEmitter();
        this.isMobile = false;
        this.showPreferencesBanner = true;
        this.preferenceBannerButtons = [];
        this.preferenceSectionCount = {};
        this.subscriptions = new Subscription();
    }
    showPreferencesBannerToggle() {
        this.showPreferencesBanner = !this.showPreferencesBanner;
        this.cdr.markForCheck();
    }
    ngOnInit() {
        this.subscriptions.add(this.guidedHelpModalContextService.openGuidedHelpModal$().subscribe({
            next: pageTag => {
                if (pageTag === PageTags.GUIDED_HELP_PRESCRIPTIONS) {
                    this.openPrescriptionsModal();
                }
                else if (pageTag === PageTags.GUIDED_HELP_PHARMACY_SEARCH) {
                    this.openPharmacyModal();
                }
                else if (pageTag === PageTags.GUIDED_HELP_PROVIDER_SEARCH) {
                    this.openProvidersModal();
                }
            }
        }));
    }
    ngOnChanges(changes) {
        if (!_isEqual(changes.buttonConfig?.previousValue, changes.buttonConfig?.currentValue)) {
            this.filterAndSortButtons();
        }
        if (!_isEqual(changes.medicineCabinet?.previousValue, changes.medicineCabinet?.currentValue)) {
            this.updateCount(PreferenceBannerSectionType.PRESCRIPTIONS, this.medicineCabinet?.length || 0);
        }
        if (!_isEqual(changes.selectedProviders?.previousValue, changes.selectedProviders?.currentValue)) {
            this.updateCount(PreferenceBannerSectionType.PROVIDERS, this.selectedProviders?.length || 0);
        }
        if (!_isEqual(changes.selectedPharmacies?.previousValue, changes.selectedPharmacies?.currentValue)) {
            this.updateCount(PreferenceBannerSectionType.PHARMACY, this.selectedPharmacies?.length || 0);
        }
    }
    filterAndSortButtons() {
        this.preferenceBannerButtons = this.buttonConfig.filter(button => button.display).sort((a, b) => a.order - b.order);
    }
    onButtonClick(sectionType) {
        switch (sectionType) {
            case PreferenceBannerSectionType.PROVIDERS:
                this.openProvidersModal();
                break;
            case PreferenceBannerSectionType.PHARMACY:
                this.openPharmacyModal();
                break;
            case PreferenceBannerSectionType.PRESCRIPTIONS:
                this.openPrescriptionsModal();
                break;
            case PreferenceBannerSectionType.ELIGIBILITY:
                this.openEligibilityModal();
                break;
            case PreferenceBannerSectionType.HEALTH:
                this.openHealthModal();
                break;
            default:
                break;
        }
    }
    onViewClick(sectionType) {
        this.onButtonClick(sectionType);
    }
    updateCount(sectionType, count) {
        this.preferenceSectionCount = { ...this.preferenceSectionCount, [sectionType]: count };
    }
    trackByIndex(index) {
        return index;
    }
    openProvidersModal() {
        this.guidedHelpModalService.openGuidedHelpModal(PageTags.GUIDED_HELP_PROVIDER_SEARCH, this.injector, {
            title: this.modalHeaderProvidersText,
            cancelButton: this.closeButtonText,
            siteType: this.siteType,
            providerInputProps: this.providerInputProps,
            cancelAction: () => {
                this.onModalClosed.emit();
            }
        });
        // Logic to add count to Providers Button
    }
    openPharmacyModal() {
        this.guidedHelpModalService.openGuidedHelpModal(PageTags.GUIDED_HELP_PHARMACY_SEARCH, this.injector, {
            title: this.modalHeaderPharmacyText,
            cancelButton: this.closeButtonText,
            pharmacyInputProps: this.pharmacyInputProps,
            siteType: this.siteType,
            cancelAction: () => {
                this.onModalClosed.emit();
            }
        });
    }
    openPrescriptionsModal() {
        this.guidedHelpModalService.openGuidedHelpModal(PageTags.GUIDED_HELP_PRESCRIPTIONS, this.injector, {
            title: this.modalHeaderPrescriptionsText,
            cancelButton: this.closeButtonText,
            prescriptionInputProps: this.prescriptionInputProps,
            siteType: this.siteType,
            cancelAction: () => {
                this.onModalClosed.emit();
            }
        });
    }
    openEligibilityModal() {
        this.guidedHelpModalService.openGuidedHelpModal(PageTags.GUIDED_HELP_ELIGIBILITY, this.injector, {
            title: this.modalHeaderEligibilityText,
            cancelButton: this.closeButtonText,
            showSubsidyAccordion: this.showSubsidyAccordion,
            optionalLabel: this.optionalLabel,
            accordionHeaderText: this.accordionHeaderText,
            errorKeywordText: this.errorKeywordText,
            isMobile: this.isMobile,
            eligibilityModalView1HeadingText: this.eligibilityModalView1HeadingText
        });
    }
    openHealthModal() {
        this.guidedHelpModalService.openGuidedHelpModal(PageTags.GUIDED_HELP_HEALTH, this.injector, {
            title: this.modalHeaderHealthText,
            cancelButton: this.closeButtonText,
            healthCostsBenefits: this.healthCostsBenefits,
            healthCostsBodyText: this.healthCostsBodyText,
            healthCostsBenefitsBodyText: this.healthCostsBenefitsBodyText,
            healthCostsBenefitsTableHeader: this.healthCostsBenefitsTableHeader,
            healthCostsUsageTableHeader: this.healthCostsUsageTableHeader,
            healthCostsDaysTableHeader: this.healthCostsDaysTableHeader,
            saveFailedText: this.saveFailedText,
            saveSuccessText: this.saveSuccessText,
            healthCostsUpdateAnswersText: this.healthCostsUpdateAnswersText,
            healthCostsSaveAnswersText: this.healthCostsSaveAnswersText,
            healthCostsRestoreDefaultsText: this.healthCostsRestoreDefaultsText,
            healthCostsCustomizationEnabled: this.healthCostsCustomizationEnabled,
            healthAgeQuestionText: this.healthAgeQuestionText,
            healthSliderHeader1Text: this.healthSliderHeader1Text,
            healthSliderHeader2Text: this.healthSliderHeader2Text,
            healthSliderHeader3Text: this.healthSliderHeader3Text,
            healthSliderBody1: this.healthSliderBody1,
            healthSliderBody2: this.healthSliderBody2,
            healthSliderBody3: this.healthSliderBody3,
            healthSliderLabelText: this.healthSliderLabelText,
            healthModalView1HeadingText: this.healthModalView1HeadingText,
            healthModalView1IntroText: this.healthModalView1IntroText
        });
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
PreferencesBannerComponent.ɵfac = function PreferencesBannerComponent_Factory(t) { return new (t || PreferencesBannerComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(GuidedHelpModalService), i0.ɵɵdirectiveInject(i1.GuidedHelpModalContextService)); };
PreferencesBannerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PreferencesBannerComponent, selectors: [["vnext-widget-preferences-banner"]], inputs: { bannerHeaderText: "bannerHeaderText", viewBannerButtonText: "viewBannerButtonText", hideBannerButtonText: "hideBannerButtonText", buttonConfig: "buttonConfig", viewButtonText: "viewButtonText", addedButtonText: "addedButtonText", modalHeaderPrescriptionsText: "modalHeaderPrescriptionsText", modalHeaderEligibilityText: "modalHeaderEligibilityText", modalHeaderHealthText: "modalHeaderHealthText", modalHeaderProvidersText: "modalHeaderProvidersText", modalHeaderPharmacyText: "modalHeaderPharmacyText", closeButtonText: "closeButtonText", healthCostsBenefits: "healthCostsBenefits", healthCostsBodyText: "healthCostsBodyText", healthCostsBenefitsBodyText: "healthCostsBenefitsBodyText", healthCostsBenefitsTableHeader: "healthCostsBenefitsTableHeader", healthCostsUsageTableHeader: "healthCostsUsageTableHeader", healthCostsDaysTableHeader: "healthCostsDaysTableHeader", healthCostsRestoreDefaultsText: "healthCostsRestoreDefaultsText", healthCostsUpdateAnswersText: "healthCostsUpdateAnswersText", healthCostsSaveAnswersText: "healthCostsSaveAnswersText", saveFailedText: "saveFailedText", saveSuccessText: "saveSuccessText", healthAgeQuestionText: "healthAgeQuestionText", healthCostsCustomizationEnabled: "healthCostsCustomizationEnabled", healthSliderHeader1Text: "healthSliderHeader1Text", healthSliderHeader2Text: "healthSliderHeader2Text", healthSliderHeader3Text: "healthSliderHeader3Text", healthSliderBody1: "healthSliderBody1", healthSliderBody2: "healthSliderBody2", healthSliderBody3: "healthSliderBody3", healthSliderLabelText: "healthSliderLabelText", healthModalView1HeadingText: "healthModalView1HeadingText", healthModalView1IntroText: "healthModalView1IntroText", prescriptionInputProps: "prescriptionInputProps", isMemberSessionUpdated: "isMemberSessionUpdated", frequencyList: "frequencyList", siteType: "siteType", medicineCabinet: "medicineCabinet", showSubsidyAccordion: "showSubsidyAccordion", optionalLabel: "optionalLabel", accordionHeaderText: "accordionHeaderText", errorKeywordText: "errorKeywordText", isMobile: "isMobile", eligibilityModalView1HeadingText: "eligibilityModalView1HeadingText", eligibilityModalView1IntroText: "eligibilityModalView1IntroText", providerInputProps: "providerInputProps", pharmacyInputProps: "pharmacyInputProps", selectedProviders: "selectedProviders", selectedPharmacies: "selectedPharmacies" }, outputs: { onModalClosed: "onModalClosed" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "preferences-banner-container Spa_Style_Accent6_Background", "id", "preferencesBannerContainer", 4, "ngIf"], ["id", "preferencesBannerContainer", 1, "preferences-banner-container", "Spa_Style_Accent6_Background"], [1, "container"], [1, "row"], [1, "col-md-12"], [1, "Spa_Style_H2", "preferences-banner-title"], ["class", "preferences-banner-button-container", 4, "ngIf"], [1, "preferences-banner-toggle-container", "d-md-none"], ["aria-controls", "preferencesBannerContainer", 1, "preferences-banner-toggle-btn", "btn-reset", "Spa_Style_LinkOnDarkBackgrounds", 3, "click", "keyup.enter"], ["aria-hidden", "true"], [1, "sr-only"], [1, "preferences-banner-button-container"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "btn-reset preferences-banner-button preferences-banner-button-empty", 3, "click", 4, "ngIf", "ngIfElse"], ["countContent", ""], [1, "btn-reset", "preferences-banner-button", "preferences-banner-button-empty", 3, "click"], [1, "preferences-banner-button-title", "Spa_Style_H4"], [1, "preferences-banner-button"], [1, "preferences-banner-button-inner"], [1, "preferences-banner-button-data"], [1, "mb-1"], [1, "preferenecs-banner-button-icon", "fas", "fa-check-circle", "mr-1"], [1, "btn-reset", "Spa_Style_LinkOnDarkBackgrounds", 3, "click"]], template: function PreferencesBannerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PreferencesBannerComponent_div_0_Template, 12, 6, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.preferenceBannerButtons.length);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf], styles: [".preferences-banner-title[_ngcontent-%COMP%]{color:var(--Spa_Style_Secondary_Text);margin-bottom:18px}.preferences-banner-container[_ngcontent-%COMP%]{box-shadow:-4px 4px 3px 0 var(--static-Spa_Style_Accent1);color:var(--Spa_Style_Secondary_Text);padding:52px 0 36px;position:relative}.preferences-banner-button-container[_ngcontent-%COMP%]{display:flex;flex-wrap:nowrap;gap:0 18px;justify-content:space-between}.preferences-banner-button[_ngcontent-%COMP%]{border:1px solid rgba(255,255,255,.4);border-radius:5px;color:var(--Spa_Style_Secondary_Text);font-size:var(--Spa_Style_Small_Font);min-height:90px;padding:12px;display:flex;flex-basis:100%;width:100%}.preferences-banner-button-title[_ngcontent-%COMP%]{color:var(--Spa_Style_Secondary_Text);flex-grow:1;margin:0 0 4px}.preferences-banner-button.preferences-banner-button-empty[_ngcontent-%COMP%]   .preferences-banner-button-title[_ngcontent-%COMP%]{margin:0}.preferences-banner-button[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{width:100%}.preferences-banner-button.preferences-banner-button-empty[_ngcontent-%COMP%]{align-items:center;background:rgba(255,255,255,.2);color:var(--Spa_Style_Secondary_Text);cursor:pointer;text-align:center}.preferences-banner-button.preferences-banner-button-empty[_ngcontent-%COMP%]:hover, .preferences-banner-button.preferences-banner-button-empty[_ngcontent-%COMP%]:focus{background:rgba(255,255,255,.1)}.preferences-banner-button-data[_ngcontent-%COMP%]{display:flex;justify-content:space-between;width:100%}.preferences-banner-button-data[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]{align-self:flex-start;font-size:var(--Spa_Style_Small_Font);margin:-8px;padding:8px;text-decoration:underline}.preferenecs-banner-button-icon[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent5)}.preferences-banner-toggle-container[_ngcontent-%COMP%]{display:flex;height:52px;justify-content:space-around;text-align:center;position:absolute;left:0;right:0;bottom:0}.preferences-banner-toggle-btn[_ngcontent-%COMP%]{font-size:24px;padding:0 24px}@media screen and (min-width: 768px) and (max-width: 991.98px){.preferences-banner-button-data[_ngcontent-%COMP%]{flex-direction:column}}@media screen and (max-width: 767.98px){.preferences-banner-button-container[_ngcontent-%COMP%]{flex-direction:column;gap:18px 0}.preferences-banner-button[_ngcontent-%COMP%]{min-height:73px}.preferences-banner-container[_ngcontent-%COMP%]{padding:20px 0 52px}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PreferencesBannerComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-preferences-banner', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  *ngIf=\"preferenceBannerButtons.length\"\r\n  class=\"preferences-banner-container Spa_Style_Accent6_Background\"\r\n  id=\"preferencesBannerContainer\"\r\n>\r\n  <div class=\"container\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <h2 class=\"Spa_Style_H2 preferences-banner-title\">{{ bannerHeaderText }}</h2>\r\n        <div *ngIf=\"showPreferencesBanner\" class=\"preferences-banner-button-container\">\r\n          <ng-container *ngFor=\"let button of preferenceBannerButtons; trackBy: trackByIndex\">\r\n            <button\r\n              *ngIf=\"!preferenceSectionCount?.[button.sectionType]; else countContent\"\r\n              class=\"btn-reset preferences-banner-button preferences-banner-button-empty\"\r\n              (click)=\"onButtonClick(button.sectionType)\"\r\n            >\r\n              <span class=\"preferences-banner-button-title Spa_Style_H4\">{{ button.buttonText }}</span>\r\n            </button>\r\n            <ng-template #countContent>\r\n              <div class=\"preferences-banner-button\">\r\n                <div class=\"preferences-banner-button-inner\">\r\n                  <h3 class=\"preferences-banner-button-title Spa_Style_H4\">\r\n                    {{ button.sectionTitle }}\r\n                  </h3>\r\n                  <div class=\"preferences-banner-button-data\">\r\n                    <p class=\"mb-1\">\r\n                      <span class=\"preferenecs-banner-button-icon fas fa-check-circle mr-1\"></span>\r\n                      {{ preferenceSectionCount?.[button.sectionType] }} {{ addedButtonText }}\r\n                    </p>\r\n                    <button class=\"btn-reset Spa_Style_LinkOnDarkBackgrounds\" (click)=\"onViewClick(button.sectionType)\">\r\n                      {{ viewButtonText }}\r\n                    </button>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </ng-template>\r\n          </ng-container>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"preferences-banner-toggle-container d-md-none\">\r\n    <button\r\n      class=\"preferences-banner-toggle-btn btn-reset Spa_Style_LinkOnDarkBackgrounds\"\r\n      [attr.aria-expanded]=\"showPreferencesBanner\"\r\n      aria-controls=\"preferencesBannerContainer\"\r\n      (click)=\"showPreferencesBannerToggle()\"\r\n      (keyup.enter)=\"showPreferencesBannerToggle()\"\r\n    >\r\n      <i [class]=\"showPreferencesBanner ? 'fas fa-chevron-up' : 'fas fa-chevron-down'\" aria-hidden=\"true\"></i>\r\n      <span class=\"sr-only\">{{ showPreferencesBanner ? viewBannerButtonText : hideBannerButtonText }}</span>\r\n    </button>\r\n  </div>\r\n</div>\r\n", styles: [".preferences-banner-title{color:var(--Spa_Style_Secondary_Text);margin-bottom:18px}.preferences-banner-container{box-shadow:-4px 4px 3px 0 var(--static-Spa_Style_Accent1);color:var(--Spa_Style_Secondary_Text);padding:52px 0 36px;position:relative}.preferences-banner-button-container{display:flex;flex-wrap:nowrap;gap:0 18px;justify-content:space-between}.preferences-banner-button{border:1px solid rgba(255,255,255,.4);border-radius:5px;color:var(--Spa_Style_Secondary_Text);font-size:var(--Spa_Style_Small_Font);min-height:90px;padding:12px;display:flex;flex-basis:100%;width:100%}.preferences-banner-button-title{color:var(--Spa_Style_Secondary_Text);flex-grow:1;margin:0 0 4px}.preferences-banner-button.preferences-banner-button-empty .preferences-banner-button-title{margin:0}.preferences-banner-button>div{width:100%}.preferences-banner-button.preferences-banner-button-empty{align-items:center;background:rgba(255,255,255,.2);color:var(--Spa_Style_Secondary_Text);cursor:pointer;text-align:center}.preferences-banner-button.preferences-banner-button-empty:hover,.preferences-banner-button.preferences-banner-button-empty:focus{background:rgba(255,255,255,.1)}.preferences-banner-button-data{display:flex;justify-content:space-between;width:100%}.preferences-banner-button-data>button{align-self:flex-start;font-size:var(--Spa_Style_Small_Font);margin:-8px;padding:8px;text-decoration:underline}.preferenecs-banner-button-icon{color:var(--static-Spa_Style_Accent5)}.preferences-banner-toggle-container{display:flex;height:52px;justify-content:space-around;text-align:center;position:absolute;left:0;right:0;bottom:0}.preferences-banner-toggle-btn{font-size:24px;padding:0 24px}@media screen and (min-width: 768px) and (max-width: 991.98px){.preferences-banner-button-data{flex-direction:column}}@media screen and (max-width: 767.98px){.preferences-banner-button-container{flex-direction:column;gap:18px 0}.preferences-banner-button{min-height:73px}.preferences-banner-container{padding:20px 0 52px}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Injector }, { type: GuidedHelpModalService }, { type: i1.GuidedHelpModalContextService }]; }, { bannerHeaderText: [{
            type: Input
        }], viewBannerButtonText: [{
            type: Input
        }], hideBannerButtonText: [{
            type: Input
        }], buttonConfig: [{
            type: Input
        }], viewButtonText: [{
            type: Input
        }], addedButtonText: [{
            type: Input
        }], modalHeaderPrescriptionsText: [{
            type: Input
        }], modalHeaderEligibilityText: [{
            type: Input
        }], modalHeaderHealthText: [{
            type: Input
        }], modalHeaderProvidersText: [{
            type: Input
        }], modalHeaderPharmacyText: [{
            type: Input
        }], closeButtonText: [{
            type: Input
        }], healthCostsBenefits: [{
            type: Input
        }], healthCostsBodyText: [{
            type: Input
        }], healthCostsBenefitsBodyText: [{
            type: Input
        }], healthCostsBenefitsTableHeader: [{
            type: Input
        }], healthCostsUsageTableHeader: [{
            type: Input
        }], healthCostsDaysTableHeader: [{
            type: Input
        }], healthCostsRestoreDefaultsText: [{
            type: Input
        }], healthCostsUpdateAnswersText: [{
            type: Input
        }], healthCostsSaveAnswersText: [{
            type: Input
        }], saveFailedText: [{
            type: Input
        }], saveSuccessText: [{
            type: Input
        }], healthAgeQuestionText: [{
            type: Input
        }], healthCostsCustomizationEnabled: [{
            type: Input
        }], healthSliderHeader1Text: [{
            type: Input
        }], healthSliderHeader2Text: [{
            type: Input
        }], healthSliderHeader3Text: [{
            type: Input
        }], healthSliderBody1: [{
            type: Input
        }], healthSliderBody2: [{
            type: Input
        }], healthSliderBody3: [{
            type: Input
        }], healthSliderLabelText: [{
            type: Input
        }], healthModalView1HeadingText: [{
            type: Input
        }], healthModalView1IntroText: [{
            type: Input
        }], prescriptionInputProps: [{
            type: Input
        }], isMemberSessionUpdated: [{
            type: Input
        }], frequencyList: [{
            type: Input
        }], siteType: [{
            type: Input
        }], medicineCabinet: [{
            type: Input
        }], onModalClosed: [{
            type: Output
        }], showSubsidyAccordion: [{
            type: Input
        }], optionalLabel: [{
            type: Input
        }], accordionHeaderText: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], eligibilityModalView1HeadingText: [{
            type: Input
        }], eligibilityModalView1IntroText: [{
            type: Input
        }], providerInputProps: [{
            type: Input
        }], pharmacyInputProps: [{
            type: Input
        }], selectedProviders: [{
            type: Input
        }], selectedPharmacies: [{
            type: Input
        }] }); })();

const _c0$H = ["planListFilterButton"];
const _c1$b = ["tooltip"];
const _c2$6 = ["planListTab"];
function PlanListComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-widget-preferences-banner", 21);
    i0.ɵɵlistener("onModalClosed", function PlanListComponent_div_0_ng_container_1_Template_vnext_widget_preferences_banner_onModalClosed_1_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r20.onModalClosed()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("bannerHeaderText", ctx_r3.Spa_PreferenceBanner_Header_Text)("viewBannerButtonText", ctx_r3.Spa_PreferenceBanner_View_ButtonText)("hideBannerButtonText", ctx_r3.Spa_PreferenceBanner_Hide_ButtonText)("buttonConfig", ctx_r3.Spa_PreferenceBanner_DisplayButtons_JSON)("viewButtonText", ctx_r3.Spa_Site_View)("addedButtonText", ctx_r3.Spa_PreferenceBanner_Added_ButtonText)("modalHeaderPrescriptionsText", ctx_r3.Spa_Site_Prescriptions_Text)("modalHeaderEligibilityText", ctx_r3.Spa_Site_Eligibility_Text)("modalHeaderHealthText", ctx_r3.Spa_Site_Health_Text)("modalHeaderProvidersText", ctx_r3.Spa_Site_Providers_Text)("modalHeaderPharmacyText", ctx_r3.Spa_Site_Pharmacy_Text)("closeButtonText", ctx_r3.Spa_Site_Close_Modal)("healthCostsBenefits", ctx_r3.Spa_Site_HealthCosts_Benefits_JSON)("healthCostsBodyText", ctx_r3.Spa_HealthCosts_Body_Text)("healthCostsBenefitsBodyText", ctx_r3.Spa_HealthCosts_Benefits_Body_Text)("healthCostsBenefitsTableHeader", ctx_r3.Spa_Site_HealthCosts_Benefits_Table_Header)("healthCostsUsageTableHeader", ctx_r3.Spa_Site_HealthCosts_Usage_Table_Header)("healthCostsDaysTableHeader", ctx_r3.Spa_Site_HealthCosts_Days_Table_Header)("healthCostsRestoreDefaultsText", ctx_r3.Spa_Site_HealthCosts_Restore_Defaults_Text)("healthCostsUpdateAnswersText", ctx_r3.Spa_Site_HealthCosts_Update_Answers_Text)("healthCostsSaveAnswersText", ctx_r3.Spa_Site_HealthCosts_Save_Answers_Text)("saveFailedText", ctx_r3.Spa_Site_HealthCosts_Save_Failed_Text)("saveSuccessText", ctx_r3.Spa_Site_HealthCosts_Save_Success_Text)("healthAgeQuestionText", ctx_r3.Spa_GuidedHelp_Health_AgeQuestion_Text)("healthCostsCustomizationEnabled", ctx_r3.Spa_Site_HealthCosts_Customization_Enabled)("healthSliderHeader1Text", ctx_r3.Spa_GuidedHelp_Health_SliderHeader1_Text)("healthSliderHeader2Text", ctx_r3.Spa_GuidedHelp_Health_SliderHeader2_Text)("healthSliderHeader3Text", ctx_r3.Spa_GuidedHelp_Health_SliderHeader3_Text)("healthSliderBody1", ctx_r3.Spa_GuidedHelp_Health_SliderBody1)("healthSliderBody2", ctx_r3.Spa_GuidedHelp_Health_SliderBody2)("healthSliderBody3", ctx_r3.Spa_GuidedHelp_Health_SliderBody3)("healthSliderLabelText", ctx_r3.Spa_Site_Health_Slider_Label_Text)("healthModalView1HeadingText", ctx_r3.Spa_AddHealth_ModalView1_HeadingText)("healthModalView1IntroText", ctx_r3.Spa_AddHealth_ModalView1_IntroText)("prescriptionInputProps", ctx_r3.prescriptionInputProps)("medicineCabinet", ctx_r3.medicineCabinet)("siteType", ctx_r3.Spa_Site_SiteType)("showSubsidyAccordion", ctx_r3.Spa_GettingStarted_ShowSubsidyAccordion_Flag)("optionalLabel", ctx_r3.Spa_GuidedHelp_OptionalLabel_Text)("accordionHeaderText", ctx_r3.Spa_GettingStarted_SubsidyHeader_Text)("errorKeywordText", ctx_r3.Spa_Site_ErrorKeyword_Text)("eligibilityModalView1HeadingText", ctx_r3.Spa_AddEligibility_ModalView1_HeadingText)("eligibilityModalView1IntroText", ctx_r3.Spa_AddEligibility_ModalView1_IntroText)("providerInputProps", ctx_r3.providerInputProps)("pharmacyInputProps", ctx_r3.pharmacyInputProps)("selectedProviders", ctx_r3.selectedProviders)("isMobile", ctx_r3.mobile)("selectedPharmacies", ctx_r3.selectedPharmacies);
} }
function PlanListComponent_div_0_ng_container_5_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30)(1, "vnext-link", 31);
    i0.ɵɵlistener("click", function PlanListComponent_div_0_ng_container_5_div_2_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r26.planFacade.navigateToSummary()); })("keydown.enter", function PlanListComponent_div_0_ng_container_5_div_2_Template_vnext_link_keydown_enter_1_listener() { i0.ɵɵrestoreView(_r27); const ctx_r28 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r28.planFacade.navigateToSummary()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r22.Spa_Site_BackToSummary_Link_Text)("showArrow", "left")("makeInlineBlock", true);
} }
function PlanListComponent_div_0_ng_container_5_h1_3_vnext_plan_year_label_7_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-plan-year-label", 36);
    i0.ɵɵlistener("onPlanYearUpdate", function PlanListComponent_div_0_ng_container_5_h1_3_vnext_plan_year_label_7_Template_vnext_plan_year_label_onPlanYearUpdate_0_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r30.onPlanYearUpdate()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("dualPlanYearPrefix", ctx_r29.dualPlanYearPrefix)("isPlanYearUpdateModalEnabled", ctx_r29.isPlanYearUpdateModalEnabled)("dualPlanYearText", ctx_r29.dualPlanYear)("dualPlanYear", ctx_r29.dualPlanYear)("dualPlanYearPostfix", ctx_r29.dualPlanYearPostfix);
} }
const _c3$1 = function (a0) { return { "readonly Spa_Style_Gray4_Color": a0 }; };
function PlanListComponent_div_0_ng_container_5_h1_3_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "h1", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "button", 33);
    i0.ɵɵlistener("click", function PlanListComponent_div_0_ng_container_5_h1_3_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r33); const ctx_r32 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r32.editZipCode()); });
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵtext(5);
    i0.ɵɵelement(6, "i", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, PlanListComponent_div_0_ng_container_5_h1_3_vnext_plan_year_label_7_Template, 1, 5, "vnext-plan-year-label", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r23.totalPlanCount, " ", ctx_r23.totalPlanCount === 1 ? ctx_r23.Spa_PlanList_PlansAvailableSingular_Text : ctx_r23.Spa_PlanList_PlansAvailablePlural_Text, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("title", ctx_r23.Spa_PlanList_EditZipCode_Label);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c3$1, i0.ɵɵpipeBind1(3, 8, ctx_r23.ssoPopulatedFieldService.isFieldReadOnly$("Demographic.ZipCode"))))("disabled", i0.ɵɵpipeBind1(4, 10, ctx_r23.ssoPopulatedFieldService.isFieldReadOnly$("Demographic.ZipCode")));
    i0.ɵɵattribute("aria-label", ctx_r23.Spa_PlanList_EditZipCode_ButtonLabel);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r23.zipCode, "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r23.planYearTextEnabled);
} }
function PlanListComponent_div_0_ng_container_5_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 37);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r24.totalCountsText);
} }
function PlanListComponent_div_0_ng_container_5_vnext_link_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-link", 38);
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("title", ctx_r25.Spa_PlanList_AddNonLicensedPlans_Text)("onClickAction", ctx_r25.fetchAllPlans)("isLinkButton", ctx_r25.isLiveEdit ? false : true)("makeInlineBlock", true);
} }
function PlanListComponent_div_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵtemplate(2, PlanListComponent_div_0_ng_container_5_div_2_Template, 2, 3, "div", 23);
    i0.ɵɵtemplate(3, PlanListComponent_div_0_ng_container_5_h1_3_Template, 8, 14, "h1", 24);
    i0.ɵɵelementStart(4, "div", 25);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 26)(8, "div", 27);
    i0.ɵɵtemplate(9, PlanListComponent_div_0_ng_container_5_span_9_Template, 2, 1, "span", 28);
    i0.ɵɵtemplate(10, PlanListComponent_div_0_ng_container_5_vnext_link_10_Template, 1, 4, "vnext-link", 29);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.isQuotingSite || ctx_r4.isRetentionView && ctx_r4.planFacade.hasRetentionPage());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", ctx_r4.totalPlanCount === 1 ? "Spa_PlanList_PlansAvailableSingular_Text" : "Spa_PlanList_PlansAvailablePlural_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 5, ctx_r4.stateCountyInformationalText$), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r4.Spa_Site_TotalSiteCountsPPC_Enabled && ctx_r4.totalCountsText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.showAddNonLicensedPlans());
} }
function PlanListComponent_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 39);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", ctx_r5.Spa_Site_PageSubHeader_Text ? i0.ɵɵpipeBind2(1, 1, ctx_r5.Spa_Site_PageSubHeader_Text, "html") : "", i0.ɵɵsanitizeHtml);
} }
const _c4 = function (a0, a1, a2, a3) { return { "filter-tab-small": a0, "filter-tab-small-2": a1, "filter-tab-small-3": a2, "filter-tab-small-wide": a3 }; };
function PlanListComponent_div_0_div_8_ng_container_1_vnext_filter_tab_1_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-filter-tab", 43, 44);
    i0.ɵɵlistener("setFocusToTabEvent", function PlanListComponent_div_0_div_8_ng_container_1_vnext_filter_tab_1_Template_vnext_filter_tab_setFocusToTabEvent_0_listener($event) { i0.ɵɵrestoreView(_r40); const ctx_r39 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r39.shiftFocusToTabElement($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext();
    const tab_r35 = ctx_r41.$implicit;
    const i_r36 = ctx_r41.index;
    const ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(17, _c4, ctx_r37.tabs.length <= 5, ctx_r37.tabs.length === 6, ctx_r37.tabs.length > 6, tab_r35.tabTypes[0] === ctx_r37.planTypeAbbreviation.MAPD))("tabData", tab_r35)("isActive", i_r36 === ctx_r37.activeTabIndex)("bestCoverageText", ctx_r37.Spa_PlanList_BestCoverage_Text)("plansText", ctx_r37.Spa_Site_Plans_Text)("planText", ctx_r37.Spa_Site_Plan_Text)("currentIndex", i_r36)("lastIndex", ctx_r37.tabs.length - 1)("ariaControlsId", "plan-list-container")("showBestCoverageBanner", ctx_r37.Spa_PlanList_BestCoverageType_Enabled)("showAllMedSupEnabled", ctx_r37.Spa_PlanList_ShowAllMedigap_Enabled)("bestCoverageIcon", ctx_r37.Spa_PlanList_BestMatch_Icon)("bestCoverageText", ctx_r37.Spa_PlanList_BestCoverageType_Text)("bestCoverageTooltip", ctx_r37.getReturnToPreferencesClickAction())("bestCoverageTabTypeAbbreviation", ctx_r37.bestCoverageTabTypeAbbreviation)("loaderIconEnabled", ctx_r37.Spa_Site_Loader_Updated_Icon_Enabled)("plansLoadingText", ctx_r37.Spa_Site_Plans_Loading_Text);
} }
function PlanListComponent_div_0_div_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanListComponent_div_0_div_8_ng_container_1_vnext_filter_tab_1_Template, 2, 22, "vnext-filter-tab", 42);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const tab_r35 = ctx.$implicit;
    const ctx_r34 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r34.nonCoveredPlanTabMap[tab_r35.tabTypes[0]] == null ? null : ctx_r34.nonCoveredPlanTabMap[tab_r35.tabTypes[0]].display);
} }
const _c5 = function (a0) { return { tabs: a0 }; };
function PlanListComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵtemplate(1, PlanListComponent_div_0_div_8_ng_container_1_Template, 2, 1, "ng-container", 41);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c5, ctx_r6.isReadyToShowZipcodeLink));
    i0.ɵɵattribute("aria-label", ctx_r6.Spa_Site_PlanType_Header);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r6.tabs)("ngForTrackBy", ctx_r6.tabKey);
} }
const _c6 = function (a0) { return { "filter-tab-small-wide": a0 }; };
function PlanListComponent_div_0_div_9_vnext_filter_tab_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-filter-tab", 48);
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c6, ctx_r42.tabMobilePrimary.tabTypes[0] === ctx_r42.planTypeAbbreviation.MAPD))("tabData", ctx_r42.tabMobilePrimary)("isActive", ctx_r42.isActiveMobilePrimaryTab)("bestCoverageText", ctx_r42.Spa_PlanList_BestCoverage_Text)("plansText", ctx_r42.Spa_Site_Plans_Text)("planText", ctx_r42.Spa_Site_Plan_Text)("showAllMedSupEnabled", ctx_r42.Spa_PlanList_ShowAllMedigap_Enabled);
} }
function PlanListComponent_div_0_div_9_vnext_filter_tab_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-filter-tab", 48);
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c6, (ctx_r43.lastActiveTabThatIsNotDefault || ctx_r43.tabs[1]).tabTypes[0] === ctx_r43.planTypeAbbreviation.MAPD))("tabData", ctx_r43.isMobileExtraSmallOrExactlyThreeTabs ? ctx_r43.tabs[1] : ctx_r43.lastActiveTabThatIsNotDefault || ctx_r43.tabs[1])("isActive", ctx_r43.isMobileExtraSmallOrExactlyThreeTabs ? ctx_r43.activeTabIndex === (ctx_r43.tabs[1] == null ? null : ctx_r43.tabs[1].tabIndex) : (ctx_r43.lastActiveTabThatIsNotDefault == null ? null : ctx_r43.lastActiveTabThatIsNotDefault.tabIndex) === ctx_r43.activeTabIndex)("bestCoverageText", ctx_r43.Spa_PlanList_BestCoverage_Text)("plansText", ctx_r43.Spa_Site_Plans_Text)("planText", ctx_r43.Spa_Site_Plan_Text)("showAllMedSupEnabled", ctx_r43.Spa_PlanList_ShowAllMedigap_Enabled);
} }
function PlanListComponent_div_0_div_9_vnext_filter_tab_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-filter-tab", 48);
} if (rf & 2) {
    const ctx_r44 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c6, ctx_r44.tabs[2].tabTypes[0] === ctx_r44.planTypeAbbreviation.MAPD))("tabData", ctx_r44.tabs[2])("isActive", (ctx_r44.tabs[2] == null ? null : ctx_r44.tabs[2].tabIndex) === ctx_r44.activeTabIndex)("bestCoverageText", ctx_r44.Spa_PlanList_BestCoverage_Text)("plansText", ctx_r44.Spa_Site_Plans_Text)("planText", ctx_r44.Spa_Site_Plan_Text)("showAllMedSupEnabled", ctx_r44.Spa_PlanList_ShowAllMedigap_Enabled);
} }
function PlanListComponent_div_0_div_9_vnext_filter_tab_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-filter-tab", 49);
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("mobileTab", true)("dropdownTabs", ctx_r45.mobileTabs)("moreOptionsText", ctx_r45.Spa_Site_MoreOptions_Text);
} }
function PlanListComponent_div_0_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵtemplate(1, PlanListComponent_div_0_div_9_vnext_filter_tab_1_Template, 1, 9, "vnext-filter-tab", 46);
    i0.ɵɵtemplate(2, PlanListComponent_div_0_div_9_vnext_filter_tab_2_Template, 1, 9, "vnext-filter-tab", 46);
    i0.ɵɵtemplate(3, PlanListComponent_div_0_div_9_vnext_filter_tab_3_Template, 1, 9, "vnext-filter-tab", 46);
    i0.ɵɵtemplate(4, PlanListComponent_div_0_div_9_vnext_filter_tab_4_Template, 1, 3, "vnext-filter-tab", 47);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.tabMobilePrimary);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.mobileExtraSmall && (ctx_r7.tabs == null ? null : ctx_r7.tabs.length) === 2 || !ctx_r7.mobileExtraSmall && (ctx_r7.tabs == null ? null : ctx_r7.tabs.length) > 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r7.mobileExtraSmall && (ctx_r7.tabs == null ? null : ctx_r7.tabs.length) === 3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.mobileExtraSmall && (ctx_r7.tabs == null ? null : ctx_r7.tabs.length) > 2 || !ctx_r7.mobileExtraSmall && (ctx_r7.tabs == null ? null : ctx_r7.tabs.length) > 3);
} }
function PlanListComponent_div_0_ng_container_10_vnext_notice_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice", 55);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r50 = i0.ɵɵreference(6);
    i0.ɵɵproperty("type", "info")("bodyTemplate", _r50);
} }
function PlanListComponent_div_0_ng_container_10_vnext_notice_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice", 55);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r52 = i0.ɵɵreference(8);
    i0.ɵɵproperty("type", "info")("bodyTemplate", _r52);
} }
function PlanListComponent_div_0_ng_container_10_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 56)(1, "vnext-plan-sub-type-dropdown", 57);
    i0.ɵɵlistener("planSubTypeChanged", function PlanListComponent_div_0_ng_container_10_div_3_Template_vnext_plan_sub_type_dropdown_planSubTypeChanged_1_listener() { i0.ɵɵrestoreView(_r58); const ctx_r57 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r57.planSubTypeChanged()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("headerText", ctx_r48.Spa_PlanList_MedSupPlanSubTypeHeader_Text)("placeholder", ctx_r48.Spa_PlanList_MedSupPlanSubTypePlaceholder_Text)("updatePlansText", ctx_r48.Spa_PlanList_MedSupPlanSubTypeUpdate_Text)("planFilterModalEnabled", ctx_r48.Spa_PlanList_FilterModal_Enabled);
} }
function PlanListComponent_div_0_ng_container_10_vnext_guided_help_tab_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-guided-help-tab", 58);
} if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("guidedHelpPreferenceText", ctx_r49.Spa_GuidedHelp_PreferenceInfo_Text)("preferenceButtonText", ctx_r49.Spa_Site_AddPreferences)("guidedHelpGetStartedText", ctx_r49.Spa_Site_GetStarted_Text)("guidedHelpHealthText", ctx_r49.Spa_Site_Health_Text)("guidedHelpPrescriptionsText", ctx_r49.Spa_Site_Prescriptions_Text)("guidedHelpPharmacyText", ctx_r49.Spa_Site_Pharmacy_Text)("guidedHelpOtherPreferencesText", ctx_r49.Spa_Site_OtherPreferences_Text)("guidedHelpOtherPreferencesMessageText", ctx_r49.Spa_GuidedHelp_ReviewOtherPreferences_Text)("guidedHelpOtherPreferencesMessageKey", "Spa_GuidedHelp_ReviewOtherPreferences_Text")("multiPharmacyEnabled", ctx_r49.Spa_Site_Multi_Pharmacy_Enabled)("primaryPharmacyIndicatorText", ctx_r49.Spa_Site_PrimaryPharmacy_Indicator_Text)("guidedHelpProvidersText", ctx_r49.Spa_Site_Providers_Text)("pcpText", ctx_r49.Spa_Site_Pcp_Text)("subsidyLabelText", ctx_r49.subsidyLabelText)("medicaidEligibilityCheckEnabled", ctx_r49.Spa_Profile_StateEligibilityCheck_Enabled)("medicaidCodeText", ctx_r49.Spa_GettingStarted_MedicaidCode_Text);
} }
function PlanListComponent_div_0_ng_container_10_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r60 = i0.ɵɵgetCurrentView();
    i0.ɵɵtext(0);
    i0.ɵɵelementStart(1, "vnext-link", 59);
    i0.ɵɵlistener("click", function PlanListComponent_div_0_ng_container_10_ng_template_5_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r60); const ctx_r59 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r59.planFacade.updateMedSupFormOpen(true)); })("keyup.enter", function PlanListComponent_div_0_ng_container_10_ng_template_5_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r60); const ctx_r61 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r61.planFacade.updateMedSupFormOpen(true)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r51 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r51.Spa_MedSup_RestrictMedSupPlansByAge_InfoText, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("makeInlineBlock", true)("title", ctx_r51.Spa_MedSup_RestrictMedSupPlansByAge_InfoLink);
} }
function PlanListComponent_div_0_ng_container_10_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r63 = i0.ɵɵgetCurrentView();
    i0.ɵɵtext(0);
    i0.ɵɵelementStart(1, "vnext-link", 59);
    i0.ɵɵlistener("click", function PlanListComponent_div_0_ng_container_10_ng_template_7_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r63); const ctx_r62 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r62.planFacade.updateMedSupFormOpen(true)); })("keyup.enter", function PlanListComponent_div_0_ng_container_10_ng_template_7_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r63); const ctx_r64 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r64.planFacade.updateMedSupFormOpen(true)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r53 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r53.planFacade.getEffectiveDateRestrictionText(), " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("makeInlineBlock", true)("title", ctx_r53.Spa_MedSup_RestrictMedSupPlansByAge_InfoLink);
} }
function PlanListComponent_div_0_ng_container_10_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-med-sup-form", 60);
    i0.ɵɵlistener("formClose", function PlanListComponent_div_0_ng_container_10_div_10_Template_vnext_med_sup_form_formClose_1_listener($event) { i0.ɵɵrestoreView(_r66); const ctx_r65 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r65.dentalVisionFormClose($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r54 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("showPreviousLink", ctx_r54.Spa_PlanList_RateFactorsPreviousLink_Enabled)("productType", ctx_r54.productType.DENTAL)("previousLabel", ctx_r54.Spa_Site_Previous)("inchesLabel", ctx_r54.Spa_PlanList_MedSupFormInchesLabel_Text)("feetLabel", ctx_r54.Spa_PlanList_MedSupFormFeetLabel_Text)("poundsLabel", ctx_r54.Spa_PlanList_MedSupFormPoundsLabel_Text)("selectMonthText", ctx_r54.Spa_PlanList_MedSupFormMonthLabel_Text)("selectYearText", ctx_r54.Spa_PlanList_MedSupFormYearLabel_Text)("dropdownDefaultText", ctx_r54.Spa_PlanList_MedSupFormDropdownDefault_Text)("continueButtonText", ctx_r54.Spa_Site_ContinueToPlanList)("formTitle", ctx_r54.Spa_PlanList_DentalFormTitle_Text)("formPrompt", ctx_r54.Spa_PlanList_DentalFormPrompt_Text)("sortedQuestions", ctx_r54.ancillaryQuestions)("questionMetaData", ctx_r54.filteredAncillaryQuestionMetaData)("guaranteedIssueOptions", ctx_r54.guaranteedIssueOptions)("guaranteedIssueText", ctx_r54.Spa_PlanList_GuaranteedIssue_Text)("guaranteedIssueTooltip", ctx_r54.Spa_PlanList_GuaranteedIssue_Tooltip)("plansLoading", ctx_r54.plansLoading)("errorKeywordText", ctx_r54.Spa_Site_ErrorKeyword_Text)("spaPageSubHeader", ctx_r54.Spa_Dental_PageSubHeader_Text)("errorNoticeTitle", ctx_r54.Spa_Site_EnrollmentErrorNotice_Title)("totalPlanCount", ctx_r54.totalPlanCount)("effectiveDateMessage", ctx_r54.Spa_PlanList_Effective_Date_Text)("rateFactorDisclaimer", ctx_r54.Spa_Rate_Factor_Disclaimer_Text)("rateFactorDisclaimerEnabled", ctx_r54.Spa_Rate_Factor_Disclaimer_Enabled);
} }
function PlanListComponent_div_0_ng_container_10_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r68 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-med-sup-form", 60);
    i0.ɵɵlistener("formClose", function PlanListComponent_div_0_ng_container_10_div_11_Template_vnext_med_sup_form_formClose_1_listener($event) { i0.ɵɵrestoreView(_r68); const ctx_r67 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r67.dentalVisionFormClose($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r55 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("showPreviousLink", ctx_r55.Spa_PlanList_RateFactorsPreviousLink_Enabled)("productType", ctx_r55.productType.VISION)("previousLabel", ctx_r55.Spa_Site_Previous)("inchesLabel", ctx_r55.Spa_PlanList_MedSupFormInchesLabel_Text)("feetLabel", ctx_r55.Spa_PlanList_MedSupFormFeetLabel_Text)("poundsLabel", ctx_r55.Spa_PlanList_MedSupFormPoundsLabel_Text)("selectMonthText", ctx_r55.Spa_PlanList_MedSupFormMonthLabel_Text)("selectYearText", ctx_r55.Spa_PlanList_MedSupFormYearLabel_Text)("dropdownDefaultText", ctx_r55.Spa_PlanList_MedSupFormDropdownDefault_Text)("continueButtonText", ctx_r55.Spa_Site_ContinueToPlanList)("formTitle", ctx_r55.Spa_PlanList_VisionFormTitle_Text)("formPrompt", ctx_r55.Spa_PlanList_VisionFormPrompt_Text)("sortedQuestions", ctx_r55.ancillaryQuestions)("questionMetaData", ctx_r55.filteredAncillaryQuestionMetaData)("guaranteedIssueOptions", ctx_r55.guaranteedIssueOptions)("guaranteedIssueText", ctx_r55.Spa_PlanList_GuaranteedIssue_Text)("guaranteedIssueTooltip", ctx_r55.Spa_PlanList_GuaranteedIssue_Tooltip)("plansLoading", ctx_r55.plansLoading)("errorKeywordText", ctx_r55.Spa_Site_ErrorKeyword_Text)("spaPageSubHeader", ctx_r55.Spa_Vision_PageSubHeader_Text)("errorNoticeTitle", ctx_r55.Spa_Site_EnrollmentErrorNotice_Title)("totalPlanCount", ctx_r55.totalPlanCount)("effectiveDateMessage", ctx_r55.Spa_PlanList_Effective_Date_Text)("rateFactorDisclaimer", ctx_r55.Spa_Rate_Factor_Disclaimer_Text)("rateFactorDisclaimerEnabled", ctx_r55.Spa_Rate_Factor_Disclaimer_Enabled);
} }
function PlanListComponent_div_0_ng_container_10_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r70 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-hospital-indemnity-form", 61);
    i0.ɵɵlistener("formClose", function PlanListComponent_div_0_ng_container_10_div_12_Template_vnext_hospital_indemnity_form_formClose_1_listener($event) { i0.ɵɵrestoreView(_r70); const ctx_r69 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r69.onHospitalIndemnityFormClose($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r56 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plansLoading", ctx_r56.plansLoading)("showPreviousLink", ctx_r56.Spa_PlanList_RateFactorsPreviousLink_Enabled)("spaPageSubHeader", ctx_r56.Spa_PlanList_HIPFormPrompt_Text)("spaPageTitle", ctx_r56.Spa_PlanList_HIP_PageTitle_Text)("errorKeywordText", ctx_r56.Spa_Site_ErrorKeyword_Text)("errorNoticeTitle", ctx_r56.Spa_Site_EnrollmentErrorNotice_Title)("dropdownDefaultText", ctx_r56.Spa_PlanList_MedSupFormDropdownDefault_Text)("continueButtonText", ctx_r56.Spa_Site_ContinueToPlanList)("noPlansAvailableHeaderText", ctx_r56.Spa_PlanList_NoPlansAvailable_Text)("noPlansAvailableBodyText", ctx_r56.Spa_PlanList_Tab_Text_NoPlans_HIP)("noneText", ctx_r56.SPA_HIP_Rider_Benefit_Default_Dropdown_Text)("rateFactorDisclaimer", ctx_r56.Spa_Rate_Factor_Disclaimer_Text)("rateFactorDisclaimerEnabled", ctx_r56.Spa_Rate_Factor_Disclaimer_Enabled);
} }
function PlanListComponent_div_0_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanListComponent_div_0_ng_container_10_vnext_notice_1_Template, 1, 2, "vnext-notice", 50);
    i0.ɵɵtemplate(2, PlanListComponent_div_0_ng_container_10_vnext_notice_2_Template, 1, 2, "vnext-notice", 50);
    i0.ɵɵtemplate(3, PlanListComponent_div_0_ng_container_10_div_3_Template, 2, 4, "div", 51);
    i0.ɵɵtemplate(4, PlanListComponent_div_0_ng_container_10_vnext_guided_help_tab_4_Template, 1, 16, "vnext-guided-help-tab", 52);
    i0.ɵɵtemplate(5, PlanListComponent_div_0_ng_container_10_ng_template_5_Template, 2, 3, "ng-template", null, 53, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(7, PlanListComponent_div_0_ng_container_10_ng_template_7_Template, 2, 3, "ng-template", null, 54, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(9, "div", 5);
    i0.ɵɵtemplate(10, PlanListComponent_div_0_ng_container_10_div_10_Template, 2, 25, "div", 3);
    i0.ɵɵtemplate(11, PlanListComponent_div_0_ng_container_10_div_11_Template, 2, 25, "div", 3);
    i0.ɵɵtemplate(12, PlanListComponent_div_0_ng_container_10_div_12_Template, 2, 13, "div", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.showMedSupAgeRestrictionBanner);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.showMedSupEffectiveDateRestrictionBanner);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.Spa_PlanList_ShowAllMedigap_Enabled && ctx_r8.mobile && ctx_r8.activeTabType === ctx_r8.planTypeAbbreviation.MEDIGAP && !ctx_r8.Spa_PlanList_FilterModal_Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.mobile && ctx_r8.Spa_GuidedHelp_Enabled);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r8.showDentalForm && ctx_r8.activeTabType === ctx_r8.planTypeAbbreviation.DENTAL);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.showVisionForm && ctx_r8.activeTabType === ctx_r8.planTypeAbbreviation.VISION);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.showHospitalIndemnityForm && ctx_r8.activeTabType === ctx_r8.planTypeAbbreviation.HC);
} }
function PlanListComponent_div_0_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r72 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "vnext-med-sup-form", 62);
    i0.ɵɵlistener("formClose", function PlanListComponent_div_0_div_11_Template_vnext_med_sup_form_formClose_1_listener($event) { i0.ɵɵrestoreView(_r72); const ctx_r71 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r71.medSupFormClose($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("previousLabel", ctx_r9.Spa_Site_Previous)("inchesLabel", ctx_r9.Spa_PlanList_MedSupFormInchesLabel_Text)("feetLabel", ctx_r9.Spa_PlanList_MedSupFormFeetLabel_Text)("poundsLabel", ctx_r9.Spa_PlanList_MedSupFormPoundsLabel_Text)("selectMonthText", ctx_r9.Spa_PlanList_MedSupFormMonthLabel_Text)("selectYearText", ctx_r9.Spa_PlanList_MedSupFormYearLabel_Text)("dropdownDefaultText", ctx_r9.Spa_PlanList_MedSupFormDropdownDefault_Text)("continueButtonText", ctx_r9.Spa_Site_ContinueToPlanList)("formTitle", ctx_r9.Spa_PlanList_MedSupFormTitle_Text)("formPrompt", ctx_r9.Spa_PlanList_MedSupFormPrompt_Text)("showPreviousLink", ctx_r9.Spa_PlanList_RateFactorsPreviousLink_Enabled)("sortedQuestions", ctx_r9.sortedQuestions)("questionMetaData", ctx_r9.filteredQuestionMetaData)("guaranteedIssueOptions", ctx_r9.guaranteedIssueOptions)("guaranteedIssueText", ctx_r9.Spa_PlanList_GuaranteedIssue_Text)("guaranteedIssueTooltip", ctx_r9.Spa_PlanList_GuaranteedIssue_Tooltip)("plansLoading", ctx_r9.plansLoading)("errorKeywordText", ctx_r9.Spa_Site_ErrorKeyword_Text)("spaPageSubHeader", ctx_r9.Spa_MedSup_PageSubHeader_Text)("errorNoticeTitle", ctx_r9.Spa_Site_EnrollmentErrorNotice_Title)("planSubTypeEnabled", ctx_r9.Spa_PlanList_ShowAllMedigap_Enabled)("planSubTypeHeaderText", ctx_r9.Spa_PlanList_MedSupPlanSubTypeHeader_Text)("planSubTypePlaceholderText", ctx_r9.Spa_PlanList_MedSupPlanSubTypePlaceholder_Text)("totalPlanCount", ctx_r9.totalPlanCount)("effectiveDateMessage", ctx_r9.Spa_PlanList_Effective_Date_Text)("rateFactorDisclaimer", ctx_r9.Spa_Rate_Factor_Disclaimer_Text)("rateFactorDisclaimerEnabled", ctx_r9.Spa_Rate_Factor_Disclaimer_Enabled);
} }
function PlanListComponent_div_0_ng_container_16_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 65);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r76 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r76.getEducationalText(ctx_r76.activeTabType), "html"), i0.ɵɵsanitizeHtml);
} }
function PlanListComponent_div_0_ng_container_16_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanListComponent_div_0_ng_container_16_ng_container_1_div_1_Template, 2, 4, "div", 64);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r73 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", ctx_r73.educationalTextResource);
} }
function PlanListComponent_div_0_ng_container_16_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 65);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r75 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r75.getEducationalText(ctx_r75.activeTabType), "html"), i0.ɵɵsanitizeHtml);
} }
function PlanListComponent_div_0_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanListComponent_div_0_ng_container_16_ng_container_1_Template, 2, 1, "ng-container", 19);
    i0.ɵɵtemplate(2, PlanListComponent_div_0_ng_container_16_ng_template_2_Template, 2, 4, "ng-template", null, 63, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r74 = i0.ɵɵreference(3);
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.activeTabType !== ctx_r10.planTypeAbbreviation.MEDIGAP && ctx_r10.educationalTextResource)("ngIfElse", _r74);
} }
function PlanListComponent_div_0_vnext_pharmacy_selector_17_Template(rf, ctx) { if (rf & 1) {
    const _r78 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-pharmacy-selector", 66);
    i0.ɵɵlistener("selectMailOrder", function PlanListComponent_div_0_vnext_pharmacy_selector_17_Template_vnext_pharmacy_selector_selectMailOrder_0_listener() { i0.ɵɵrestoreView(_r78); const ctx_r77 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r77.pharmacyFacade.switchMailOrder(true)); })("selectPharmacy", function PlanListComponent_div_0_vnext_pharmacy_selector_17_Template_vnext_pharmacy_selector_selectPharmacy_0_listener($event) { i0.ɵɵrestoreView(_r78); const ctx_r79 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r79.updateSelectedPharmacy($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("preferencesBannerEnabled", ctx_r11.Spa_PreferenceBanner_Enabled)("pharmacySelectorTextKey", "Spa_Site_CostBasedOn_Text")("pharmacySelectorText", ctx_r11.Spa_Site_CostBasedOn_Text)("pharmacies", ctx_r11.selectedPharmacies)("selectedPharmacy", ctx_r11.selectedPharmacy)("mailOrderText", ctx_r11.Spa_PlanList_MailOrder_Text)("isMailOrderSelected", ctx_r11.mailOrder)("showMailOrderOption", ctx_r11.planFacade.isMailOrderPharmacyAvailable(ctx_r11.filteredPlans));
} }
function PlanListComponent_div_0_vnext_effective_date_display_18_Template(rf, ctx) { if (rf & 1) {
    const _r81 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-effective-date-display", 67);
    i0.ɵɵlistener("dateUpdated", function PlanListComponent_div_0_vnext_effective_date_display_18_Template_vnext_effective_date_display_dateUpdated_0_listener() { i0.ɵɵrestoreView(_r81); const ctx_r80 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r80.onEffectiveDateModalChange()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("activePlanType", ctx_r12.activeTabType);
} }
function PlanListComponent_div_0_ng_container_19_Template(rf, ctx) { if (rf & 1) {
    const _r83 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6)(2, "div", 13)(3, "vnext-rate-factor-warning", 68);
    i0.ɵɵlistener("loadRateFactorForm", function PlanListComponent_div_0_ng_container_19_Template_vnext_rate_factor_warning_loadRateFactorForm_3_listener() { i0.ɵɵrestoreView(_r83); const ctx_r82 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r82.loadMedSupForm()); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("showRateFactorWarningBanner", !ctx_r13.hasMedSupAnswers)("hasRateFactorAnswers", ctx_r13.hasMedSupAnswers)("rateFactorWarningBannerText", ctx_r13.Spa_PlanList_MedSupWarningBanner_Text)("rateFactorWarningBannerClickableText", ctx_r13.Spa_PlanList_MedSupWarningBannerClickable_Text)("rateFactorEditAnswersBannerText", ctx_r13.Spa_PlanList_MedSupEditAnswersBanner_Text)("rateFactorEditAnswersBannerClickableText", ctx_r13.Spa_PlanList_MedSupEditAnswersBannerClickable_Text);
} }
function PlanListComponent_div_0_ng_container_20_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r92 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "vnext-rate-factor-warning", 68);
    i0.ɵɵlistener("loadRateFactorForm", function PlanListComponent_div_0_ng_container_20_div_3_Template_vnext_rate_factor_warning_loadRateFactorForm_1_listener() { i0.ɵɵrestoreView(_r92); const ctx_r91 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r91.loadMedSupForm()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r84 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("showRateFactorWarningBanner", !ctx_r84.hasMedSupAnswers && ctx_r84.medSupPlansWithoutFilters.length)("hasRateFactorAnswers", ctx_r84.hasMedSupAnswers)("rateFactorWarningBannerText", ctx_r84.Spa_PlanList_MedSupWarningBanner_Text)("rateFactorWarningBannerClickableText", ctx_r84.Spa_PlanList_MedSupWarningBannerClickable_Text)("rateFactorEditAnswersBannerText", ctx_r84.Spa_PlanList_MedSupEditAnswersBanner_Text)("rateFactorEditAnswersBannerClickableText", ctx_r84.Spa_PlanList_MedSupEditAnswersBannerClickable_Text);
} }
function PlanListComponent_div_0_ng_container_20_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r94 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "vnext-rate-factor-warning", 68);
    i0.ɵɵlistener("loadRateFactorForm", function PlanListComponent_div_0_ng_container_20_div_4_Template_vnext_rate_factor_warning_loadRateFactorForm_1_listener() { i0.ɵɵrestoreView(_r94); const ctx_r93 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r93.loadDentalVisionForm(ctx_r93.planTypeAbbreviation.DENTAL)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r85 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("showRateFactorWarningBanner", !ctx_r85.hasAncillaryAnswers && ctx_r85.dentalPlansWithoutFilters.length)("hasRateFactorAnswers", ctx_r85.hasAncillaryAnswers)("rateFactorWarningBannerText", ctx_r85.Spa_PlanList_DentalVisionWarningBanner_Text)("rateFactorWarningBannerClickableText", ctx_r85.Spa_PlanList_DentalVisionWarningBannerClickable_Text)("rateFactorEditAnswersBannerText", ctx_r85.Spa_PlanList_DentalVisionEditAnswersBanner_Text)("rateFactorEditAnswersBannerClickableText", ctx_r85.Spa_PlanList_DentalVisionEditAnswersBannerClickable_Text);
} }
function PlanListComponent_div_0_ng_container_20_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r96 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "vnext-rate-factor-warning", 68);
    i0.ɵɵlistener("loadRateFactorForm", function PlanListComponent_div_0_ng_container_20_div_5_Template_vnext_rate_factor_warning_loadRateFactorForm_1_listener() { i0.ɵɵrestoreView(_r96); const ctx_r95 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r95.loadDentalVisionForm(ctx_r95.planTypeAbbreviation.VISION)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r86 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("showRateFactorWarningBanner", !ctx_r86.hasAncillaryAnswers && ctx_r86.visionPlansWithoutFilters.length)("hasRateFactorAnswers", ctx_r86.hasAncillaryAnswers)("rateFactorWarningBannerText", ctx_r86.Spa_PlanList_DentalVisionWarningBanner_Text)("rateFactorWarningBannerClickableText", ctx_r86.Spa_PlanList_DentalVisionWarningBannerClickable_Text)("rateFactorEditAnswersBannerText", ctx_r86.Spa_PlanList_DentalVisionEditAnswersBanner_Text)("rateFactorEditAnswersBannerClickableText", ctx_r86.Spa_PlanList_DentalVisionEditAnswersBannerClickable_Text);
} }
function PlanListComponent_div_0_ng_container_20_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelement(1, "vnext-hip-details-banner", 73);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r87 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("numberOfDaysText", ctx_r87.Spa_PlanFilters_DayLabel_Text)("daysText", ctx_r87.Spa_Site_Days_Text)("dayText", ctx_r87.Spa_Site_Day_Text)("editYourAnswersText", ctx_r87.Spa_PlanList_MedSupEditAnswersBanner_Text)("lumpSumText", ctx_r87.Spa_Site_LumpSum_Text)("basePlanText", ctx_r87.Spa_Site_HIP_BasePlanOption_Text)("daysAmount", ctx_r87.hospitalIndemnityAnswers == null ? null : ctx_r87.hospitalIndemnityAnswers.HCDaysCovered)("benefitAmount", ctx_r87.hospitalIndemnityAnswers == null ? null : ctx_r87.hospitalIndemnityAnswers.BenefitAmount);
} }
function PlanListComponent_div_0_ng_container_20_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelement(1, "vnext-dsnp-eligibility-message", 74);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r88 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("titleText", ctx_r88.Spa_PlanList_DSNP_EligibleMessage_Header_Text)("bodyText", ctx_r88.Spa_PlanList_DSNP_EligibleMessage_Info_Text)("tooltipText", ctx_r88.Spa_DSNP_Eligibility_Tooltip_Text)("tooltipLabelText", ctx_r88.Spa_DSNP_Eligibility_LearnMore_Text)("filterCodeText", ctx_r88.Spa_DSNPEligibility_FilterCodeMessage_Text)("isMobile", ctx_r88.mobile)("filterCodeEnabled", ctx_r88.Spa_DSNPEligibility_FilterCodeMessage_Enabled);
} }
function PlanListComponent_div_0_ng_container_20_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r98 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 75)(1, "div", 13)(2, "vnext-widget-select-plan-quote", 76);
    i0.ɵɵlistener("selectPlanNameToQuote", function PlanListComponent_div_0_ng_container_20_div_8_Template_vnext_widget_select_plan_quote_selectPlanNameToQuote_2_listener($event) { i0.ɵɵrestoreView(_r98); const ctx_r97 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r97.selectPlanNameToQuote($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r89 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("planTypeInstructionalText", ctx_r89.Spa_PlanList_PlanType_Instructional_Text)("planTypes", ctx_r89.enabledPlanTypesData)("planTypeHintText", ctx_r89.Spa_PlanList_SelectPlanType_Hint_Text)("planTypeText", ctx_r89.Spa_Site_PlanType_Header)("selectPlanButtonText", ctx_r89.Spa_PlanList_SelectPlan_Button_Text)("carriersHintText", ctx_r89.Spa_PlanList_SelectPlan_Carriers_Hint_Text)("carriersText", ctx_r89.Spa_Site_Carrier_Header)("plansToQuoteHintText", ctx_r89.Spa_PlanList_SelectPlan_Hint_Text)("plansToQuoteText", ctx_r89.Spa_PlanList_SelectPlan_Text)("noPlansAvailableText", ctx_r89.Spa_PlanList_NoPlansAvailable_Text)("noPlansAvailableHintText", ctx_r89.Spa_PlanList_NoPlansAvailable_Hint_Text)("requiredFieldsHintText", ctx_r89.Spa_PlanList_RequiredFields_Hint_Text)("pleaseSelectRequiredFieldsErrorText", ctx_r89.Spa_PlanList_PleaseSelect_Error_Text)("planMarketingNameEnabled", ctx_r89.Spa_Filter_Plan_Marketing_Name_Enabled);
} }
function PlanListComponent_div_0_ng_container_20_div_9_div_2_vnext_widget_plan_quote_2_Template(rf, ctx) { if (rf & 1) {
    const _r103 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-widget-plan-quote", 80);
    i0.ɵɵlistener("addMedicareAdvantagePlan", function PlanListComponent_div_0_ng_container_20_div_9_div_2_vnext_widget_plan_quote_2_Template_vnext_widget_plan_quote_addMedicareAdvantagePlan_0_listener() { i0.ɵɵrestoreView(_r103); const ctx_r102 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r102.addMedicareAdvantagePlan()); })("viewPlanDetails", function PlanListComponent_div_0_ng_container_20_div_9_div_2_vnext_widget_plan_quote_2_Template_vnext_widget_plan_quote_viewPlanDetails_0_listener($event) { i0.ɵɵrestoreView(_r103); const ctx_r104 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r104.planFacade.viewPlanDetailsPage($event)); })("removePlanFromQuoteGroup", function PlanListComponent_div_0_ng_container_20_div_9_div_2_vnext_widget_plan_quote_2_Template_vnext_widget_plan_quote_removePlanFromQuoteGroup_0_listener($event) { i0.ɵɵrestoreView(_r103); const ctx_r105 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r105.removeHospitalIndemnityPlanFromQuoteGroup($event.selectedQuoteGroup, $event.plan)); })("openSendQuoteModal", function PlanListComponent_div_0_ng_container_20_div_9_div_2_vnext_widget_plan_quote_2_Template_vnext_widget_plan_quote_openSendQuoteModal_0_listener() { i0.ɵɵrestoreView(_r103); const ctx_r106 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r106.openHospitalIndemnityViewQuote()); })("getPersonalizedQuote", function PlanListComponent_div_0_ng_container_20_div_9_div_2_vnext_widget_plan_quote_2_Template_vnext_widget_plan_quote_getPersonalizedQuote_0_listener($event) { i0.ɵɵrestoreView(_r103); const ctx_r107 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r107.updateActiveTab($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r101 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("activeTabType", ctx_r101.activeTabType)("selectedQuoteGroup", ctx_r101.tabs[ctx_r101.activeTabIndex] == null ? null : ctx_r101.tabs[ctx_r101.activeTabIndex].compareGroup[0])("plansSelectedToQuote", ctx_r101.selectedHospitalIndemnityPlans)("sendQuoteButtonText", ctx_r101.Spa_Site_SendQuote_Button_Text)("viewQuoteButtonText", ctx_r101.Spa_PlanList_ViewQuote_Text)("planCardQuoteLinkNameText", ctx_r101.Spa_PlanCard_QuoteLinkName_Text)("quoteHintText", ctx_r101.quoteHintText)("addToQuoteLimit", ctx_r101.addToQuoteLimit)("isMedicareQuote", true)("planTypes", ctx_r101.enabledPlanTypesData)("hospitalIndemnityBadgeText", ctx_r101.Spa_Site_HIP_Description)("addMedicareAdvantagePlanText", ctx_r101.Spa_Site_HIP_Add_Medicare_Advantage_Plan_Text)("showAddMedicareAdvantageButton", !ctx_r101.showAddMedicareAdvantagePlan && ctx_r101.isSelectPlanQuote)("removeFromQuoteText", ctx_r101.Spa_PlanCard_RemoveFromQuote_Text);
} }
function PlanListComponent_div_0_ng_container_20_div_9_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 75)(1, "div", 13);
    i0.ɵɵtemplate(2, PlanListComponent_div_0_ng_container_20_div_9_div_2_vnext_widget_plan_quote_2_Template, 1, 14, "vnext-widget-plan-quote", 79);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r99 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r99.showAddMedicareAdvantagePlan);
} }
function PlanListComponent_div_0_ng_container_20_div_9_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r109 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 75)(1, "div", 13)(2, "vnext-widget-plan-quote", 81);
    i0.ɵɵlistener("viewPlanDetails", function PlanListComponent_div_0_ng_container_20_div_9_div_3_Template_vnext_widget_plan_quote_viewPlanDetails_2_listener($event) { i0.ɵɵrestoreView(_r109); const ctx_r108 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r108.planFacade.viewPlanDetailsPage($event)); })("removePlanFromQuoteGroup", function PlanListComponent_div_0_ng_container_20_div_9_div_3_Template_vnext_widget_plan_quote_removePlanFromQuoteGroup_2_listener($event) { i0.ɵɵrestoreView(_r109); const ctx_r110 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r110.removePlanFromQuoteGroup($event.selectedQuoteGroup, $event.plan)); })("openSendQuoteModal", function PlanListComponent_div_0_ng_container_20_div_9_div_3_Template_vnext_widget_plan_quote_openSendQuoteModal_2_listener() { i0.ɵɵrestoreView(_r109); const ctx_r111 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r111.planFacade.openSendQuoteModal()); });
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r100 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("selectedQuoteGroup", ctx_r100.tabs[ctx_r100.activeTabIndex] == null ? null : ctx_r100.tabs[ctx_r100.activeTabIndex].quoteGroups[0])("plansSelectedToQuote", i0.ɵɵpipeBind1(3, 9, ctx_r100.getPlansSelectedToQuote$()))("sendQuoteButtonText", ctx_r100.Spa_Site_SendQuote_Button_Text)("viewQuoteButtonText", ctx_r100.Spa_PlanList_ViewQuote_Text)("quoteHintText", ctx_r100.quoteHintText)("addToQuoteLimit", ctx_r100.Spa_PlanList_AddToQuote_Limit)("isMedicareQuote", ctx_r100.isSelectPlanQuote)("planTypes", ctx_r100.enabledPlanTypesData)("removeFromQuoteText", ctx_r100.Spa_PlanCard_RemoveFromQuote_Text);
} }
function PlanListComponent_div_0_ng_container_20_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementContainerStart(1, 69);
    i0.ɵɵtemplate(2, PlanListComponent_div_0_ng_container_20_div_9_div_2_Template, 3, 1, "div", 77);
    i0.ɵɵtemplate(3, PlanListComponent_div_0_ng_container_20_div_9_div_3_Template, 4, 11, "div", 78);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r90 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r90.activeTabType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r90.planTypeAbbreviation.HC);
} }
function PlanListComponent_div_0_ng_container_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementContainerStart(2, 69);
    i0.ɵɵtemplate(3, PlanListComponent_div_0_ng_container_20_div_3_Template, 2, 6, "div", 70);
    i0.ɵɵtemplate(4, PlanListComponent_div_0_ng_container_20_div_4_Template, 2, 6, "div", 70);
    i0.ɵɵtemplate(5, PlanListComponent_div_0_ng_container_20_div_5_Template, 2, 6, "div", 70);
    i0.ɵɵtemplate(6, PlanListComponent_div_0_ng_container_20_div_6_Template, 2, 8, "div", 70);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(7, PlanListComponent_div_0_ng_container_20_div_7_Template, 2, 7, "div", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, PlanListComponent_div_0_ng_container_20_div_8_Template, 3, 14, "div", 72);
    i0.ɵɵtemplate(9, PlanListComponent_div_0_ng_container_20_div_9_Template, 4, 2, "div", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitch", ctx_r14.activeTabType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r14.planTypeAbbreviation.MEDIGAP);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r14.planTypeAbbreviation.DENTAL);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r14.planTypeAbbreviation.VISION);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r14.planTypeAbbreviation.HC);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.Spa_PlanList_Show_DSNP_EligibleMessage && ctx_r14.dSNPPlansCount && ctx_r14.subsidySelected === ctx_r14.subsidies.MEDICAID);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.showSelectPlanQuote);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.showPlanQuote);
} }
function PlanListComponent_div_0_div_22_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r118 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-plan-sub-type-dropdown", 57);
    i0.ɵɵlistener("planSubTypeChanged", function PlanListComponent_div_0_div_22_ng_container_1_Template_vnext_plan_sub_type_dropdown_planSubTypeChanged_1_listener() { i0.ɵɵrestoreView(_r118); const ctx_r117 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r117.planSubTypeChanged()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r112 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("headerText", ctx_r112.Spa_PlanList_MedSupPlanSubTypeHeader_Text)("placeholder", ctx_r112.Spa_PlanList_MedSupPlanSubTypePlaceholder_Text)("updatePlansText", ctx_r112.Spa_PlanList_MedSupPlanSubTypeUpdate_Text)("planFilterModalEnabled", ctx_r112.Spa_PlanList_FilterModal_Enabled);
} }
function PlanListComponent_div_0_div_22_vnext_pharmacy_selector_2_Template(rf, ctx) { if (rf & 1) {
    const _r120 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-pharmacy-selector", 66);
    i0.ɵɵlistener("selectMailOrder", function PlanListComponent_div_0_div_22_vnext_pharmacy_selector_2_Template_vnext_pharmacy_selector_selectMailOrder_0_listener() { i0.ɵɵrestoreView(_r120); const ctx_r119 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r119.selectMailOrder()); })("selectPharmacy", function PlanListComponent_div_0_div_22_vnext_pharmacy_selector_2_Template_vnext_pharmacy_selector_selectPharmacy_0_listener($event) { i0.ɵɵrestoreView(_r120); const ctx_r121 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r121.updateSelectedPharmacy($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r113 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("preferencesBannerEnabled", ctx_r113.Spa_PreferenceBanner_Enabled)("pharmacySelectorTextKey", "Spa_Site_CostBasedOn_Text")("pharmacySelectorText", ctx_r113.Spa_Site_CostBasedOn_Text)("pharmacies", ctx_r113.selectedPharmacies)("selectedPharmacy", ctx_r113.selectedPharmacy)("mailOrderText", ctx_r113.Spa_PlanList_MailOrder_Text)("isMailOrderSelected", ctx_r113.mailOrder)("showMailOrderOption", ctx_r113.planFacade.isMailOrderPharmacyAvailable(ctx_r113.filteredPlans));
} }
function PlanListComponent_div_0_div_22_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-plan-list-accordion", 83);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r114 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("guidedHelpEnabled", ctx_r114.Spa_GuidedHelp_Enabled)("guidedHelpHeaderText", ctx_r114.Spa_GuidedHelp_Preference_Text)("guidedHelpHeaderTextKeyName", "Spa_GuidedHelp_Preference_Text")("guidedHelpPreferenceText", ctx_r114.Spa_GuidedHelp_PreferenceInfo_Text)("guidedHelpPreferenceButtonText", ctx_r114.Spa_Site_AddPreferences)("guidedHelpHideLinkText", ctx_r114.Spa_Site_Hide_Text)("guidedHelpViewAllLinkText", ctx_r114.Spa_Site_ViewAll_Text)("guidedHelpGetStartedText", ctx_r114.Spa_Site_GetStarted_Text)("guidedHelpHealthText", ctx_r114.Spa_Site_Health_Text)("guidedHelpPrescriptionsText", ctx_r114.Spa_Site_Prescriptions_Text)("guidedHelpPharmacyText", ctx_r114.Spa_Site_Pharmacy_Text)("guidedHelpOtherPreferencesText", ctx_r114.Spa_Site_OtherPreferences_Text)("guidedHelpOtherPreferencesMessageText", ctx_r114.Spa_GuidedHelp_ReviewOtherPreferences_Text)("guidedHelpOtherPreferencesMessageKey", "Spa_GuidedHelp_ReviewOtherPreferences_Text")("multiPharmacyEnabled", ctx_r114.Spa_Site_Multi_Pharmacy_Enabled)("isLiveEdit", ctx_r114.isLiveEdit)("primaryPharmacyIndicatorText", ctx_r114.Spa_Site_PrimaryPharmacy_Indicator_Text)("guidedHelpProvidersText", ctx_r114.Spa_Site_Providers_Text)("pcpText", ctx_r114.Spa_Site_Pcp_Text)("subsidyLabelText", ctx_r114.subsidyLabelText)("medicaidEligibilityCheckEnabled", ctx_r114.Spa_Profile_StateEligibilityCheck_Enabled)("medicaidCodeText", ctx_r114.Spa_GettingStarted_MedicaidCode_Text);
} }
function PlanListComponent_div_0_div_22_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r123 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-plan-filter", 84);
    i0.ɵɵlistener("filterItemClicked", function PlanListComponent_div_0_div_22_ng_container_5_Template_vnext_plan_filter_filterItemClicked_1_listener() { i0.ɵɵrestoreView(_r123); const ctx_r122 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r122.filterClicked()); })("clearAllFiltersClicked", function PlanListComponent_div_0_div_22_ng_container_5_Template_vnext_plan_filter_clearAllFiltersClicked_1_listener() { i0.ɵɵrestoreView(_r123); const ctx_r124 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r124.filterClicked()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r115 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("defaultFilterText", ctx_r115.Spa_PlanFilters_DefaultText)("filterDayText", ctx_r115.Spa_PlanFilters_DayLabel_Text)("selectFilterDayText", ctx_r115.Spa_PlanFilters_SelectDayLabel_Text)("filterCarrierText", ctx_r115.Spa_PlanFilters_CarrierLabel_Text)("filterHeaderText", ctx_r115.Spa_Filter_Header_Text)("filterClearAll", ctx_r115.Spa_Filter_Clear_All)("planSubTypeLabel", ctx_r115.Spa_PlanFilters_SubType_Label)("showEmptyFilterMessage", ctx_r115.showEmptyFilterMessage)("showNoPlansFromAnswersMessage", ctx_r115.showNoPlansFromAnswersMessage)("licensingHeaderText", ctx_r115.Spa_Filter_LicensingHeader_Text)("snpBaseTypeLabel", ctx_r115.Spa_Filter_SNPBaseTypes_Label)("currentTab", ctx_r115.currentTab)("snpEnabled", ctx_r115.Spa_Site_SNPTools_Enabled)("additionalSavingsHeaderText", ctx_r115.Spa_Filter_AdditionalSavingsHeader_Text)("defaultPlanBenefitFilters", ctx_r115.Spa_Site_Default_Plan_Benefit_Filter)("insulinSavingsEnabled", ctx_r115.Spa_Filter_InsulinSavings_Enabled)("filterDSNPMedicaidCodesEnabled", ctx_r115.Spa_Filter_DSNPMedicaidCodes_Enabled)("defaultPlanBenefitFiltersEnabled", ctx_r115.Spa_Filter_PlanBenefitsGroup_Enabled)("costFilterEnabled", ctx_r115.isCostFilterEnabled)("medicalDeductibleHeaderText", ctx_r115.Spa_Filter_MedicalDeductible_Text)("medicalDeductibleToolTipText", ctx_r115.Spa_Filter_MedicalDeductible_ToolTip_Text)("maximumOutOfPocketCostHeaderText", ctx_r115.Spa_Filter_MaximumOutOfPocketCost_Text)("maximumOutOfPocketCostToolTipText", ctx_r115.Spa_Filter_MaximumOutOfPocketCost_ToolTip_Text)("drugDeductibleHeaderText", ctx_r115.Spa_Filter_PharmacyDeductible_Text)("drugDeductibleToolTipText", ctx_r115.Spa_Filter_PharmacyDeductible_ToolTip_Text)("premiumHeaderText", ctx_r115.Spa_Filter_Premium_Text)("premiumToolTipText", ctx_r115.Spa_Filter_Premium_ToolTip_Text)("addOnTooltipText", ctx_r115.Spa_Filter_AddOn_Coverage_ToolTip_Text)("addOnFilterHeaderText", ctx_r115.Spa_PlanList_AddOn_Header_Text)("addOnFilterEnabled", ctx_r115.Spa_PlanList_AddOn_Filter_Enabled)("isTabFilterExpanded", ctx_r115.Spa_PlanList_Filters_Expanded)("providersNpiTooltipText", ctx_r115.Spa_Filter_Providers_ToolTip_Text)("providersNpiHeaderText", ctx_r115.Spa_Site_Providers_Header_Text)("providersEnabled", ctx_r115.Spa_Site_Providers_Enabled)("providersNpiFilterEnabled", ctx_r115.Spa_Npi_Filter_Enabled)("showTabFilter", ctx_r115.showTabFilter)("planTypeLabel", ctx_r115.Spa_Site_PlanType_Header)("allInNetworkLocationsEnabled", ctx_r115.Spa_Site_Provider_ShowAllInNetworkLocations_Enabled);
} }
function PlanListComponent_div_0_div_22_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-plan-list-accordion", 83);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r116 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("guidedHelpEnabled", ctx_r116.Spa_GuidedHelp_Enabled)("guidedHelpHeaderText", ctx_r116.Spa_GuidedHelp_Preference_Text)("guidedHelpHeaderTextKeyName", "Spa_GuidedHelp_Preference_Text")("guidedHelpPreferenceText", ctx_r116.Spa_GuidedHelp_PreferenceInfo_Text)("guidedHelpPreferenceButtonText", ctx_r116.Spa_Site_AddPreferences)("guidedHelpHideLinkText", ctx_r116.Spa_Site_Hide_Text)("guidedHelpViewAllLinkText", ctx_r116.Spa_Site_ViewAll_Text)("guidedHelpGetStartedText", ctx_r116.Spa_Site_GetStarted_Text)("guidedHelpHealthText", ctx_r116.Spa_Site_Health_Text)("guidedHelpPrescriptionsText", ctx_r116.Spa_Site_Prescriptions_Text)("guidedHelpPharmacyText", ctx_r116.Spa_Site_Pharmacy_Text)("guidedHelpOtherPreferencesText", ctx_r116.Spa_Site_OtherPreferences_Text)("guidedHelpOtherPreferencesMessageText", ctx_r116.Spa_GuidedHelp_ReviewOtherPreferences_Text)("guidedHelpOtherPreferencesMessageKey", "Spa_GuidedHelp_ReviewOtherPreferences_Text")("multiPharmacyEnabled", ctx_r116.Spa_Site_Multi_Pharmacy_Enabled)("isLiveEdit", ctx_r116.isLiveEdit)("primaryPharmacyIndicatorText", ctx_r116.Spa_Site_PrimaryPharmacy_Indicator_Text)("guidedHelpProvidersText", ctx_r116.Spa_Site_Providers_Text)("pcpText", ctx_r116.Spa_Site_Pcp_Text)("subsidyLabelText", ctx_r116.subsidyLabelText)("medicaidEligibilityCheckEnabled", ctx_r116.Spa_Profile_StateEligibilityCheck_Enabled)("medicaidCodeText", ctx_r116.Spa_GettingStarted_MedicaidCode_Text);
} }
function PlanListComponent_div_0_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r126 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 82);
    i0.ɵɵtemplate(1, PlanListComponent_div_0_div_22_ng_container_1_Template, 2, 4, "ng-container", 3);
    i0.ɵɵtemplate(2, PlanListComponent_div_0_div_22_vnext_pharmacy_selector_2_Template, 1, 8, "vnext-pharmacy-selector", 15);
    i0.ɵɵelementStart(3, "vnext-effective-date-display", 67);
    i0.ɵɵlistener("dateUpdated", function PlanListComponent_div_0_div_22_Template_vnext_effective_date_display_dateUpdated_3_listener() { i0.ɵɵrestoreView(_r126); const ctx_r125 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r125.onEffectiveDateModalChange()); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PlanListComponent_div_0_div_22_ng_container_4_Template, 2, 22, "ng-container", 3);
    i0.ɵɵtemplate(5, PlanListComponent_div_0_div_22_ng_container_5_Template, 2, 38, "ng-container", 3);
    i0.ɵɵtemplate(6, PlanListComponent_div_0_div_22_ng_container_6_Template, 2, 22, "ng-container", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.Spa_PlanList_ShowAllMedigap_Enabled && ctx_r15.activeTabType === ctx_r15.planTypeAbbreviation.MEDIGAP);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.pharmacyFacade.showPharmacySelectorToggle(ctx_r15.activeTabType));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("activePlanType", ctx_r15.activeTabType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r15.hasEnteredPreferences);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.activeTabType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.hasEnteredPreferences);
} }
function PlanListComponent_div_0_ng_container_24_div_3_div_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 94);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r134 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r134.selectedPlanSubType, " ");
} }
function PlanListComponent_div_0_ng_container_24_div_3_div_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r138 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 94);
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "button", 95);
    i0.ɵɵlistener("click", function PlanListComponent_div_0_ng_container_24_div_3_div_4_ng_container_2_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r138); const ctx_r137 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r137.toggleSNPPlanVisibility(true)); })("keyup.enter", function PlanListComponent_div_0_ng_container_24_div_3_div_4_ng_container_2_Template_button_keyup_enter_3_listener() { i0.ɵɵrestoreView(_r138); const ctx_r139 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r139.toggleSNPPlanVisibility(true)); });
    i0.ɵɵelement(4, "i", 96);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r135 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r135.Spa_PlanList_HideSNPLink_Text, " ");
} }
function PlanListComponent_div_0_ng_container_24_div_3_div_4_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r145 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 94);
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "button", 95);
    i0.ɵɵlistener("click", function PlanListComponent_div_0_ng_container_24_div_3_div_4_ng_container_3_ng_container_1_Template_button_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r145); const filterValue_r142 = restoredCtx.$implicit; const filter_r140 = i0.ɵɵnextContext().$implicit; const ctx_r143 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r143.clearSelectedFilter(filter_r140.key, filterValue_r142)); })("keyup.enter", function PlanListComponent_div_0_ng_container_24_div_3_div_4_ng_container_3_ng_container_1_Template_button_keyup_enter_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r145); const filterValue_r142 = restoredCtx.$implicit; const filter_r140 = i0.ɵɵnextContext().$implicit; const ctx_r146 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r146.clearSelectedFilter(filter_r140.key, filterValue_r142)); });
    i0.ɵɵelement(4, "i", 97);
    i0.ɵɵelementStart(5, "span", 98);
    i0.ɵɵtext(6, "Clear filters");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const filterValue_r142 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", filterValue_r142 == null ? null : filterValue_r142.label, " ");
} }
function PlanListComponent_div_0_ng_container_24_div_3_div_4_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanListComponent_div_0_ng_container_24_div_3_div_4_ng_container_3_ng_container_1_Template, 7, 1, "ng-container", 41);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const filter_r140 = ctx.$implicit;
    const ctx_r136 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", filter_r140 == null ? null : filter_r140.values)("ngForTrackBy", ctx_r136.trackByFilterValue);
} }
function PlanListComponent_div_0_ng_container_24_div_3_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 93);
    i0.ɵɵtemplate(1, PlanListComponent_div_0_ng_container_24_div_3_div_4_ng_container_1_Template, 3, 1, "ng-container", 3);
    i0.ɵɵtemplate(2, PlanListComponent_div_0_ng_container_24_div_3_div_4_ng_container_2_Template, 5, 1, "ng-container", 3);
    i0.ɵɵtemplate(3, PlanListComponent_div_0_ng_container_24_div_3_div_4_ng_container_3_Template, 2, 2, "ng-container", 41);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r133 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r133.Spa_PlanList_ShowAllMedigap_Enabled && ctx_r133.selectedPlanSubType && ctx_r133.activeTabType === ctx_r133.planTypeAbbreviation.MEDIGAP);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r133.snpVisibility && ctx_r133.activeTabType === ctx_r133.planTypeAbbreviation.MAPD);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r133.selectedFilters)("ngForTrackBy", ctx_r133.trackByFilterKey);
} }
function PlanListComponent_div_0_ng_container_24_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r149 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 90)(2, "button", 91);
    i0.ɵɵlistener("click", function PlanListComponent_div_0_ng_container_24_div_3_Template_button_click_2_listener($event) { i0.ɵɵrestoreView(_r149); const ctx_r148 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r148.openFilterModal($event)); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, PlanListComponent_div_0_ng_container_24_div_3_div_4_Template, 4, 4, "div", 92);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r127 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", ctx_r127.Spa_PlanFilters_Modal_Button_Label);
    i0.ɵɵattribute("aria-label", ctx_r127.Spa_PlanFilters_Modal_Button_Label);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r127.Spa_PlanFilters_Modal_Button_Label, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r127.filterPopupOpen);
} }
function PlanListComponent_div_0_ng_container_24_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-snp-toggle", 99);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r128 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("showLinkText", ctx_r128.Spa_PlanList_ShowSNPLink_Text)("hideLinkText", ctx_r128.Spa_PlanList_HideSNPLink_Text)("activeTabType", ctx_r128.activeTabType)("filteredPlansHasSNPPlans", ctx_r128.filteredPlansHasSNPPlans);
} }
function PlanListComponent_div_0_ng_container_24_ng_container_5_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r156 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 103, 104);
    i0.ɵɵlistener("click", function PlanListComponent_div_0_ng_container_24_ng_container_5_div_1_ng_container_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r156); const ctx_r155 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r155.openMobileFiltersModal()); });
    i0.ɵɵelement(3, "i", 105);
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "span", 106);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r151 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r151.Spa_PlanFilters_Modal_Link);
    i0.ɵɵattribute("aria-label", ctx_r151.Spa_PlanFilters_Modal_Link);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r151.Spa_PlanFilters_Modal_Link);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r151.totalAppliedFilters);
} }
function PlanListComponent_div_0_ng_container_24_ng_container_5_div_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 107);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r153 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r153.Spa_PlanFilters_DefaultText);
} }
function PlanListComponent_div_0_ng_container_24_ng_container_5_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 101);
    i0.ɵɵtemplate(1, PlanListComponent_div_0_ng_container_24_ng_container_5_div_1_ng_container_1_Template, 8, 4, "ng-container", 19);
    i0.ɵɵtemplate(2, PlanListComponent_div_0_ng_container_24_ng_container_5_div_1_ng_template_2_Template, 2, 1, "ng-template", null, 102, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r152 = i0.ɵɵreference(3);
    const ctx_r150 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r150.showEmptyFilterMessage && !ctx_r150.showNoPlansFromAnswersMessage)("ngIfElse", _r152);
} }
function PlanListComponent_div_0_ng_container_24_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanListComponent_div_0_ng_container_24_ng_container_5_div_1_Template, 4, 2, "div", 100);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r129 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r129.Spa_PlanList_FilterModal_Enabled);
} }
function PlanListComponent_div_0_ng_container_24_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r158 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-plan-sort", 108);
    i0.ɵɵlistener("sortClicked", function PlanListComponent_div_0_ng_container_24_ng_container_7_Template_vnext_plan_sort_sortClicked_1_listener() { i0.ɵɵrestoreView(_r158); const ctx_r157 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r157.sortClicked()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r130 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("planSortList", ctx_r130.selectedTabSortList)("selectedPharmacy", ctx_r130.selectedPharmacy)("planSortHeader", ctx_r130.Spa_PlanSort_Header)("tabs", ctx_r130.tabs)("isMailOrderSelected", ctx_r130.mailOrder);
} }
function PlanListComponent_div_0_ng_container_24_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r160 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 109)(1, "vnext-effective-date-display", 110);
    i0.ɵɵlistener("dateUpdated", function PlanListComponent_div_0_ng_container_24_div_8_Template_vnext_effective_date_display_dateUpdated_1_listener() { i0.ɵɵrestoreView(_r160); const ctx_r159 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r159.onEffectiveDateModalChange()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r131 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("activePlanType", ctx_r131.activeTabType)("isReadOnly", true);
} }
function PlanListComponent_div_0_ng_container_24_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r162 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 111)(1, "div", 112)(2, "vnext-plan-filter-modal-items", 113);
    i0.ɵɵlistener("planSubTypeChanged", function PlanListComponent_div_0_ng_container_24_div_9_Template_vnext_plan_filter_modal_items_planSubTypeChanged_2_listener($event) { i0.ɵɵrestoreView(_r162); const ctx_r161 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r161.medsupPlanSubTypeChanged($event)); })("closeModalEvent", function PlanListComponent_div_0_ng_container_24_div_9_Template_vnext_plan_filter_modal_items_closeModalEvent_2_listener() { i0.ɵɵrestoreView(_r162); const ctx_r163 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r163.closeFilterModal()); })("toggleSNPPlanChangeEvent", function PlanListComponent_div_0_ng_container_24_div_9_Template_vnext_plan_filter_modal_items_toggleSNPPlanChangeEvent_2_listener($event) { i0.ɵɵrestoreView(_r162); const ctx_r164 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r164.toggleSNPPlanChangeEvent($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "div", 114)(4, "button", 115);
    i0.ɵɵlistener("click", function PlanListComponent_div_0_ng_container_24_div_9_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r162); const ctx_r165 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r165.applyFilter()); });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r132 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("planSubTypeLabel", ctx_r132.Spa_PlanFilters_SubType_Label)("filterDayText", ctx_r132.Spa_PlanFilters_DayLabel_Text)("selectFilterDayText", ctx_r132.Spa_PlanFilters_SelectDayLabel_Text)("filterCarrierText", ctx_r132.Spa_PlanFilters_CarrierLabel_Text)("clearAllText", ctx_r132.Spa_Filter_Clear_All)("currentTab", ctx_r132.currentTab)("snpBaseTypeLabel", ctx_r132.Spa_Filter_SNPBaseTypes_Label)("licensingHeaderText", ctx_r132.Spa_Filter_LicensingHeader_Text)("snpEnabled", ctx_r132.Spa_Site_SNPTools_Enabled && ctx_r132.activeTabType === ctx_r132.planTypeAbbreviation.MAPD)("additionalSavingsHeaderText", ctx_r132.Spa_Filter_AdditionalSavingsHeader_Text)("insulinSavingsEnabled", ctx_r132.Spa_Filter_PlanBenefitsGroup_Enabled && ctx_r132.Spa_Filter_InsulinSavings_Enabled)("filterDSNPMedicaidCodesEnabled", ctx_r132.Spa_Filter_DSNPMedicaidCodes_Enabled)("costFilterEnabled", ctx_r132.isCostFilterEnabled)("medicalDeductibleHeaderText", ctx_r132.Spa_Filter_MedicalDeductible_Text)("medicalDeductibleToolTipText", ctx_r132.Spa_Filter_MedicalDeductible_ToolTip_Text)("maximumOutOfPocketCostHeaderText", ctx_r132.Spa_Filter_MaximumOutOfPocketCost_Text)("maximumOutOfPocketCostToolTipText", ctx_r132.Spa_Filter_MaximumOutOfPocketCost_ToolTip_Text)("drugDeductibleHeaderText", ctx_r132.Spa_Filter_PharmacyDeductible_Text)("drugDeductibleToolTipText", ctx_r132.Spa_Filter_PharmacyDeductible_ToolTip_Text)("premiumHeaderText", ctx_r132.Spa_Filter_Premium_Text)("premiumToolTipText", ctx_r132.Spa_Filter_Premium_ToolTip_Text)("defaultPlanBenefitFilters", ctx_r132.Spa_Site_Default_Plan_Benefit_Filter)("defaultPlanBenefitFiltersEnabled", ctx_r132.Spa_Filter_PlanBenefitsGroup_Enabled)("addOnTooltipText", ctx_r132.Spa_Filter_AddOn_Coverage_ToolTip_Text)("addOnFilterHeaderText", ctx_r132.Spa_PlanList_AddOn_Header_Text)("addOnFilterEnabled", ctx_r132.Spa_PlanList_AddOn_Filter_Enabled)("providersNpiHeaderText", ctx_r132.Spa_Site_Providers_Header_Text)("providersNpiFilterEnabled", ctx_r132.Spa_Npi_Filter_Enabled)("providersEnabled", ctx_r132.Spa_Site_Providers_Enabled)("providersNpiTooltipText", ctx_r132.Spa_Filter_Providers_ToolTip_Text)("planTypeLabel", ctx_r132.Spa_Site_PlanType_Header)("allInNetworkLocationsEnabled", ctx_r132.Spa_Site_Provider_ShowAllInNetworkLocations_Enabled)("planFilterModalEnabled", ctx_r132.Spa_PlanList_FilterModal_Enabled)("isMedigapEnabled", ctx_r132.Spa_PlanList_ShowAllMedigap_Enabled)("medsupPlanSubTypeHeaderText", ctx_r132.Spa_PlanList_MedSupPlanSubTypeHeader_Text)("medsupPlanSubTypePlacholderText", ctx_r132.Spa_PlanList_MedSupPlanSubTypePlaceholder_Text)("medsupPlanSubTypeUpdateText", ctx_r132.Spa_PlanList_MedSupPlanSubTypeUpdate_Text)("starRatingEnabled", ctx_r132.Spa_StarRating_Enabled && (ctx_r132.activeTabType === ctx_r132.planTypeAbbreviation.MAPD || ctx_r132.activeTabType === ctx_r132.planTypeAbbreviation.MA || ctx_r132.activeTabType === ctx_r132.planTypeAbbreviation.PDP))("isPlanListPage", true)("snpLabelText", ctx_r132.Spa_PlanList_HideSNPLink_Text)("activeTabType", ctx_r132.activeTabType)("starRatingLabelText", ctx_r132.Spa_StarRating_Label_Text)("starRatingFilterOptions", ctx_r132.Spa_StarRating_Filter_Options)("isMobile", ctx_r132.mobile)("filteredPlansHasSNPPlans", ctx_r132.filteredPlansHasSNPPlans)("snpVisibility", ctx_r132.snpVisibility)("planFiltersSortOptions", ctx_r132.Spa_PlanFilters_Sort_Options_For_Modal);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r132.Spa_PlanFilters_Modal_Apply_Button, " ");
} }
const _c7 = function (a0) { return { "align-items-start": a0 }; };
const _c8 = function (a0, a1) { return { "col-md-8 col-sm-12 pr-0 pl-2": a0, "col-md-6": a1 }; };
const _c9 = function (a0, a1) { return { "col-md-4 col-sm-12": a0, "col-sm-6 col-md-5": a1 }; };
function PlanListComponent_div_0_ng_container_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 85)(2, "div", 86);
    i0.ɵɵtemplate(3, PlanListComponent_div_0_ng_container_24_div_3_Template, 5, 4, "div", 87);
    i0.ɵɵtemplate(4, PlanListComponent_div_0_ng_container_24_ng_container_4_Template, 2, 4, "ng-container", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, PlanListComponent_div_0_ng_container_24_ng_container_5_Template, 2, 1, "ng-container", 3);
    i0.ɵɵelementStart(6, "div", 86);
    i0.ɵɵtemplate(7, PlanListComponent_div_0_ng_container_24_ng_container_7_Template, 2, 5, "ng-container", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, PlanListComponent_div_0_ng_container_24_div_8_Template, 2, 2, "div", 88);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, PlanListComponent_div_0_ng_container_24_div_9_Template, 6, 48, "div", 89);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c7, ctx_r16.Spa_PlanList_FilterModal_Enabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c8, ctx_r16.Spa_PlanList_FilterModal_Enabled, !ctx_r16.Spa_PlanList_FilterModal_Enabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.Spa_PlanList_FilterModal_Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.Spa_Site_SNPTools_Enabled && !ctx_r16.Spa_PlanList_FilterModal_Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.activeTabType && ctx_r16.showTabFilter);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(14, _c9, ctx_r16.Spa_PlanList_FilterModal_Enabled, !ctx_r16.Spa_PlanList_FilterModal_Enabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.activeTabType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.Spa_PlanList_FilterModal_Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r16.filterPopupOpen && ctx_r16.Spa_PlanList_FilterModal_Enabled);
} }
function PlanListComponent_div_0_ng_container_25_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r170 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 13)(2, "vnext-widget-plan-card", 117);
    i0.ɵɵlistener("quoteClicked", function PlanListComponent_div_0_ng_container_25_div_1_Template_vnext_widget_plan_card_quoteClicked_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r170); const plan_r167 = restoredCtx.$implicit; const ctx_r169 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r169.getPersonalizedQuote(plan_r167)); })("quoteGroupChanged", function PlanListComponent_div_0_ng_container_25_div_1_Template_vnext_widget_plan_card_quoteGroupChanged_2_listener() { i0.ɵɵrestoreView(_r170); const ctx_r171 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r171.quoteGroupChanged()); });
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const plan_r167 = ctx.$implicit;
    const queuePosition_r168 = ctx.index;
    const ctx_r166 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("plan", plan_r167)("activeTabType", ctx_r166.activeTabType)("isNotLicensedToSell", ctx_r166.isNotLicensedToSell(plan_r167))("selectedCompareGroup", ctx_r166.tabs[ctx_r166.activeTabIndex] == null ? null : ctx_r166.tabs[ctx_r166.activeTabIndex].compareGroup[0])("compareGroups", ctx_r166.compareGroups)("planBenefits", ctx_r166.tabs[ctx_r166.activeTabIndex] == null ? null : ctx_r166.tabs[ctx_r166.activeTabIndex].benefits)("displayDrugsCovered", ctx_r166.Spa_PlanList_DisplayDrugsCovered)("planPreferences", ctx_r166.tabs[ctx_r166.activeTabIndex] == null ? null : ctx_r166.tabs[ctx_r166.activeTabIndex].benefitPreferences)("bestMatchIcon", ctx_r166.Spa_PlanList_BestMatch_Icon)("bestMatchText", ctx_r166.Spa_Site_BestMatch_Plan_Text)("bestMatchTooltip", ctx_r166.bestMatchReturnToPreferencesTooltip)("bestMatchPlanId", ctx_r166.bestMatchPlanId)("currentPlanText", ctx_r166.Spa_Site_Current_Plan_Text)("nextYearPlanText", ctx_r166.Spa_Site_Next_Year_Plan_Text)("selectedQuoteGroup", ctx_r166.tabs[ctx_r166.activeTabIndex] == null ? null : ctx_r166.tabs[ctx_r166.activeTabIndex].quoteGroups[0])("quoteGroups", ctx_r166.quoteGroups)("addToQuoteLimit", ctx_r166.Spa_PlanList_AddToQuote_Limit)("noCostAvailableText", ctx_r166.Spa_Site_NotApplicable_Text)("isRetentionView", ctx_r166.isRetentionView)("isQuotingSite", ctx_r166.isQuotingSite)("Spa_Site_ShowRiderIcons", ctx_r166.Spa_Site_ShowRiderIcons)("Spa_Site_Dental_Rider_Display_Text", ctx_r166.Spa_Site_Dental_Rider_Display_Text)("Spa_Site_Vision_Rider_Display_Text", ctx_r166.Spa_Site_Vision_Rider_Display_Text)("Spa_Site_Hearing_Rider_Display_Text", ctx_r166.Spa_Site_Hearing_Rider_Display_Text)("Spa_PlanCard_DentalAddOnCoverage_Text", ctx_r166.Spa_PlanCard_DentalAddOnCoverage_Text)("Spa_PlanCard_HearingAddOnCoverage_Text", ctx_r166.Spa_PlanCard_HearingAddOnCoverage_Text)("Spa_PlanCard_VisionAddOnCoverage_Text", ctx_r166.Spa_PlanCard_VisionAddOnCoverage_Text)("Spa_PlanCard_AddOnCoverage_Text", ctx_r166.Spa_PlanCard_AddOnCoverage_Text)("Spa_PlanCard_AddToCompare_Text", ctx_r166.Spa_PlanCard_AddToCompare_Text)("Spa_Site_ShowRidersOnPlanCards", ctx_r166.Spa_Site_ShowRidersOnPlanCards)("Spa_ShoppingCart_Enabled", ctx_r166.Spa_ShoppingCart_Enabled)("Spa_PlanCard_PlanDetails_ButtonText", ctx_r166.Spa_PlanCard_PlanDetails_ButtonText)("Spa_Site_Show_PlanLogo", ctx_r166.Spa_Site_Show_PlanLogo)("Spa_Site_Show_AncillaryPlanLogo", ctx_r166.Spa_Site_Show_AncillaryPlanLogo)("Spa_PlanCard_QuoteLinkName_Text", ctx_r166.Spa_PlanCard_QuoteLinkName_Text)("Spa_PlanCard_PlanType_Text", ctx_r166.Spa_PlanCard_PlanType_Text)("Spa_PlanCard_ShowRidersOnMACards", ctx_r166.Spa_PlanCard_ShowRidersOnMACards)("Spa_PlanCard_ShowRidersOnPDPCards", ctx_r166.Spa_PlanCard_ShowRidersOnPDPCards)("Spa_PlanCard_ShowRidersOnMAPDCards", ctx_r166.Spa_PlanCard_ShowRidersOnMAPDCards)("Spa_PlanCard_ShowRidersOnMEDIGAPCards", ctx_r166.Spa_PlanCard_ShowRidersOnMEDIGAPCards)("Spa_PlanCard_ShowRidersOnDentalCards", ctx_r166.Spa_PlanCard_ShowRidersOnDentalCards)("Spa_PlanCard_ShowRidersOnVisionCards", ctx_r166.Spa_PlanCard_ShowRidersOnVisionCards)("Spa_Site_ShowPremiumAsAnnual", ctx_r166.Spa_Site_ShowPremiumAsAnnual)("Spa_PlanCard_AddOnCoverageInCart_Text", ctx_r166.Spa_PlanCard_AddOnCoverageInCart_Text)("Spa_PlanCard_AddOnCoverageTooltip_Body", ctx_r166.Spa_PlanCard_AddOnCoverageTooltip_Body)("Spa_Site_NotApplicable_Text", ctx_r166.Spa_Site_NotApplicable_Text)("Spa_PlanDetails_Non_Covered_Text", ctx_r166.Spa_PlanDetails_Non_Covered_Text)("Spa_Site_Pharmacy_Text", ctx_r166.Spa_Site_Pharmacy_Text)("Spa_PlanCard_Pharmacy_Covered_Text", ctx_r166.Spa_PlanCard_Pharmacy_Covered_Text)("Spa_Site_Prescriptions_Text", ctx_r166.Spa_Site_Prescriptions_Text)("Spa_PlanCard_Drug_Covered_Text", ctx_r166.Spa_PlanCard_Drug_Covered_Text)("Spa_PlanCard_CompareNow_Text", ctx_r166.Spa_PlanCard_CompareNow_Text)("Spa_PlanCard_CompareWarning_Tooltip", ctx_r166.Spa_PlanCard_CompareWarning_Tooltip)("Spa_PlanCard_CompareLimit_Desktop", ctx_r166.Spa_PlanCard_CompareLimit_Desktop)("Spa_PlanCard_CompareLimit_Mobile", ctx_r166.Spa_PlanCard_CompareLimit_Mobile)("Spa_PlanCard_Total_Estimated_Cost_Tooltip", ctx_r166.Spa_PlanCard_Total_Estimated_Cost_Tooltip)("Spa_Site_TotalEstimatedCost_Enabled", ctx_r166.Spa_Site_TotalEstimatedCost_Enabled)("Spa_PlanCard_TotalEstimatedAnnualCost_Text", ctx_r166.Spa_PlanCard_TotalEstimatedAnnualCost_Text)("Spa_PlanCard_TotalEstimatedCost_Text", ctx_r166.Spa_PlanCard_TotalEstimatedCost_Text)("Spa_PlanCard_AddToQuote_Text", ctx_r166.Spa_PlanCard_AddToQuote_Text)("Spa_PlanCard_RemoveFromQuote_Text", ctx_r166.Spa_PlanCard_RemoveFromQuote_Text)("Spa_PlanCard_AddToQuote_Warning_Tooltip", ctx_r166.Spa_PlanCard_AddToQuote_Warning_Tooltip)("Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip", ctx_r166.Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip)("Spa_PlanList_AddToQuote_Limit", ctx_r166.Spa_PlanList_AddToQuote_Limit)("Spa_PlanList_AddToQuote_Limit_Mobile", ctx_r166.Spa_PlanList_AddToQuote_Limit_Mobile)("Spa_Site_MedigapPlanType_Enabled", ctx_r166.Spa_Site_MedigapPlanType_Enabled)("Spa_Site_AddToCompare_Enabled", ctx_r166.Spa_Site_AddToCompare_Enabled)("Spa_Site_PlanViewDetails_Enabled", ctx_r166.Spa_Site_PlanViewDetails_Enabled)("Spa_Site_Tooltip_Text", ctx_r166.Spa_Site_Tooltip_Text)("Spa_Site_ComboPlanLabel_Text", ctx_r166.Spa_Site_ComboPlanLabel_Text)("Spa_Site_ComboPlanTooltip_Text", ctx_r166.Spa_Site_ComboPlanTooltip_Text)("Spa_Site_ShowDrugAlternatives_Enabled", ctx_r166.Spa_Site_ShowDrugAlternatives_Enabled)("Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled", ctx_r166.Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled)("Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text", ctx_r166.Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text)("Spa_PlanCard_ShowDrugAlternatives_Nudge_Text", ctx_r166.Spa_PlanCard_ShowDrugAlternatives_Nudge_Text)("Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon", ctx_r166.Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon)("queuePosition", queuePosition_r168)("plansSelectedToQuote", i0.ɵɵpipeBind1(3, 180, ctx_r166.getPlansSelectedToQuote$()))("viewCostTooltipHeaderText", ctx_r166.Spa_PlanList_ViewCost_Header_Text)("viewCostTooltipHeaderContent", ctx_r166.Spa_PlanList_ViewCost_Header_Content)("inNetworkPreferredText", ctx_r166.Spa_PlanList_Pharmacy_InNetwork_Preferred_Pricing_Text)("inNetworkStandardText", ctx_r166.Spa_PlanList_Pharmacy_InNetwork_Standard_Pricing_Text)("outOfNetworkText", ctx_r166.Spa_PlanList_Pharmacy_OutOfNetwork_Pricing_Text)("selectedPharmacy", ctx_r166.selectedPharmacy)("isMailOrderSelected", ctx_r166.mailOrder)("mailOrderText", ctx_r166.Spa_PlanList_MailOrder_Text)("selectedProviders", ctx_r166.selectedProviders)("providerDetails", ctx_r166.providerDetails)("providersInNetworkText", ctx_r166.Spa_PlanCard_Providers_InNetwork_Text)("pcpInNetworkText", ctx_r166.Spa_Site_Pcp_InNetwork_Text)("pcpOutOfNetworkText", ctx_r166.Spa_Site_Pcp_OutOfNetwork_Text)("providersNoDataText", ctx_r166.Spa_Providers_No_Data_Exist_Text)("isProviderEnabled", ctx_r166.Spa_Site_Providers_Enabled)("showStarRating", plan_r167.planTypeAbbreviation !== ctx_r166.planTypeAbbreviation.DENTAL && plan_r167.planTypeAbbreviation !== ctx_r166.planTypeAbbreviation.VISION && plan_r167.planTypeAbbreviation !== ctx_r166.planTypeAbbreviation.HC)("showPreferenceScore", ctx_r166.Spa_Site_Show_Preferences_Score && plan_r167.planTypeAbbreviation !== ctx_r166.planTypeAbbreviation.DENTAL && plan_r167.planTypeAbbreviation !== ctx_r166.planTypeAbbreviation.VISION && plan_r167.planTypeAbbreviation !== ctx_r166.planTypeAbbreviation.HC)("showRatingMethod", ctx_r166.Spa_Rating_Method_Enabled && plan_r167.planTypeAbbreviation === ctx_r166.planTypeAbbreviation.MEDIGAP)("monthlyPremiumText", ctx_r166.Spa_Site_HIP_MonthlyPremium_Text)("moreBenefitsInstructionText", ctx_r166.Spa_Site_HIP_MoreBenefits_Instruction_Text)("basePlanOptionText", ctx_r166.Spa_Site_HIP_BasePlanOption_Text)("CSNPEnabled", ctx_r166.Spa_Site_SNPTools_Enabled ? ctx_r166.Spa_PlanCard_CSNP_Indicator_Enabled : false)("DSNPEnabled", ctx_r166.Spa_Site_SNPTools_Enabled ? ctx_r166.Spa_PlanCard_DSNP_Indicator_Enabled : false)("ISNPEnabled", ctx_r166.Spa_Site_SNPTools_Enabled ? ctx_r166.Spa_PlanCard_ISNP_Indicator_Enabled : false)("CSNPText", ctx_r166.Spa_PlanCard_CSNP_Tooltip_Text)("DSNPText", ctx_r166.Spa_PlanCard_DSNP_Tooltip_Text)("ISNPText", ctx_r166.Spa_PlanCard_ISNP_Tooltip_Text)("SNPText", ctx_r166.Spa_PlanCard_SNP_Indicator_Text)("nonLicensedPlanText", ctx_r166.planListFacade.getNonLicensedPlanCardBadgeText())("nonLicensedMessageText", ctx_r166.planListFacade.getNonLicensedPlanCardMessageText())("includeNonLicensedPlans", ctx_r166.Spa_PlanList_Include_NonLicensed_Plans)("noProviderNetworkAccessText", ctx_r166.Spa_Providers_NoProviderNetworkAccess_Text)("viewDetailsDescriptionText", ctx_r166.Spa_Site_ViewDetailsLink_Description_Text)("medSupPaymentMethod", i0.ɵɵpipeBind1(4, 182, ctx_r166.paymentMethod$))("nonMonthlyRateText", ctx_r166.Spa_PlanCard_NonMonthlyRateText)("showNonMonthlyRateText", ctx_r166.Spa_PlanCard_NonMonthlyRateText_Enabled)("medSupPaymentMethodDisplayText", ctx_r166.medSupPaymentMethodDisplayText)("displayOptionLabels", ctx_r166.Spa_Retention_ClientDefinedPlanOptions_Enabled)("nonCommissionableText", ctx_r166.Spa_PlanDetails_NonCommissionable_Text)("isNonCommissionableFlagCheckEnabled", ctx_r166.Spa_PlanDetails_NonCommissionable_FlagCheck_Enabled)("memberHasOptionsDefined", ctx_r166.memberHasOptionsDefined)("optionOneText", ctx_r166.Spa_Site_Plan_Option_One_Text)("optionTwoText", ctx_r166.Spa_Site_Plan_Option_Two_Text)("totalCostEffectiveDate", ctx_r166.totalCostEffectiveDate)("medicineCabinet", ctx_r166.medicineCabinet)("planCardPreferenceDetailedEnabled", ctx_r166.Spa_PlanCard_Preferences_Detailed_Enabled)("planLogoSize", ctx_r166.Spa_Site_PlanLogo_Size)("showAddToCartForAncillaryPlans", ctx_r166.Spa_PlanCard_AncillaryAddtoCart_Enabled)("showAncillaryIcons", ctx_r166.Spa_PlanCard_ShowAncillaryIcons_Enabled)("loaderIconEnabled", ctx_r166.Spa_Site_Loader_Updated_Icon_Enabled)("hideLinkText", ctx_r166.Spa_Site_Hide_Text)("viewAllLinkText", ctx_r166.Spa_Site_ViewAll_Text)("Spa_PlanCard_SupplementalBenefits_Enabled", ctx_r166.Spa_PlanCard_SupplementalBenefits_Enabled)("Spa_PlanCard_SupplementalBenefits_List", ctx_r166.Spa_PlanCard_SupplementalBenefits_List)("editLinkText", ctx_r166.editLinkText)("providerOneOrMoreOutOfNetworkText", ctx_r166.Spa_PlanCard_Providers_OneOrMore_OutOfNetwork_Text)("Spa_RatingMethod_AttainedAge_Tooltip_Text", ctx_r166.Spa_RatingMethod_AttainedAge_Tooltip_Text)("Spa_RatingMethod_IssueAge_Tooltip_Text", ctx_r166.Spa_RatingMethod_IssueAge_Tooltip_Text)("Spa_RatingMethod_CommunityRated_Tooltip_Text", ctx_r166.Spa_RatingMethod_CommunityRated_Tooltip_Text)("providerInNetworkOnOtherLocationsTooltipText", ctx_r166.Spa_Providers_InNetwork_OnOtherLocations_Tooltip_Text)("providerShowPartialIndicatorEnabled", ctx_r166.Spa_Provider_ShowPartialIndicator_Enabled)("planFeesEnabled", ctx_r166.Spa_Site_PlanFees_Enabled)("planFeesTooltipText", ctx_r166.Spa_PlanFees_Tooltip_Text)("planFeesIncludedInPremiumTooltipText", ctx_r166.Spa_PlanFees_IncludedInPremium_Tooltip_Text)("planFeesNotIncludedInPremiumTooltipText", ctx_r166.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text)("showAvailableRateFactorsEnabled", ctx_r166.Spa_PlanCard_ShowAvailableRateFactors_Enabled)("personalizedQuoteLabelText", ctx_r166.Spa_PlanCard_PersonalizedQuoteLabel_Text)("availableRateFactorsData", ctx_r166.Spa_PlanCard_AvailableRateFactors_Data)("snpPremiumRangeEnabled", ctx_r166.Spa_Display_SNP_PremiumRange_Enabled)("snpRangeLinkText", ctx_r166.Spa_SNPRange_Link_Text)("showPlanId", ctx_r166.Spa_PlanCard_Show_PlanId_Enabled)("planIdText", ctx_r166.Spa_PlanCard_PlanId_Text)("enableDSNPCodes", ctx_r166.Spa_PlanCard_DSNPCodeDisplay_Enabled)("availableText", ctx_r166.Spa_Site_Available_Text)("unavailableText", ctx_r166.Spa_Site_NotAvailable_Text)("viewProvidersButtonText", ctx_r166.Spa_PlanCard_Providers_ViewButton_Text)("viewPrescriptionsButtonText", ctx_r166.Spa_PlanCard_Prescriptions_ViewButton_Text)("supplementalBenefitsHighlightText", ctx_r166.Spa_PlanCard_SupplementalBenefitsHighlight_Text)("preferencesText", ctx_r166.Spa_Plan_Details_Preferences_Text)("viewMoreDetailsText", ctx_r166.Spa_PlanCard_ViewMoreDetails_ButtonText)("hideDetailsText", ctx_r166.Spa_PlanCard_HideDetails_ButtonText)("newPlanCardDesignEnabled", ctx_r166.Spa_PlanCard_NewDesign_Enabled)("viewAllPlanDetailsText", ctx_r166.Spa_PlanCard_ViewAllPlanDetails_ButtonText)("shareThisPlanText", ctx_r166.Spa_PlanCard_ShareThisPlan_ButtonText)("viewCostDetailsText", ctx_r166.Spa_PlanCard_ViewCostDetails_ButtonText)("closeText", ctx_r166.Spa_Site_Close)("planBenefitHighlightItems", ctx_r166.Spa_PlanCard_PlanBenefitHighlight_Items)("planBenefitHighlightsHeaderText", ctx_r166.Spa_PlanCard_PlanBenefitHighlights_Text)("showRiderDetails", ctx_r166.Spa_Site_RiderDetails_Show)("showRiderDetailsText", ctx_r166.Spa_Plan_Details_ViewRiderDetails_Text)("hideRiderDetailsText", ctx_r166.Spa_Plan_Details_HideRiderDetails_Text)("riderIsIncludedText", ctx_r166.Spa_ShoppingCart_IncludedRider_Text)("waiverStateRiderTooltips", ctx_r166.Spa_Plan_Details_WaiverStateRider_Tooltips)("costMA", ctx_r166.Spa_Plandetails_Costs_MA)("costMAPD", ctx_r166.Spa_Plandetails_Costs_MAPD)("costPDP", ctx_r166.Spa_Plandetails_Costs_PDP)("costMEDIGAP", ctx_r166.Spa_Plandetails_Costs_MEDIGAP)("costDENTAL", ctx_r166.Spa_PlanDetails_Costs_DENTAL)("costVISION", ctx_r166.Spa_PlanDetails_Costs_VISION)("isVbcAgreementEnabled", ctx_r166.Spa_Site_ValueBasedCare_Agreement_Enabled)("vbcAgreementLabel", ctx_r166.Spa_Site_ValueBasedCare_Agreement_Label)("vbcAgreementTooltip", ctx_r166.Spa_Site_ValueBasedCare_Agreement_Tooltip);
} }
function PlanListComponent_div_0_ng_container_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlanListComponent_div_0_ng_container_25_div_1_Template, 5, 184, "div", 116);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r17.visiblePlans)("ngForTrackBy", ctx_r17.planKey);
} }
function PlanListComponent_div_0_ng_template_26_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 120)(2, "div", 121);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "div", 122);
    i0.ɵɵpipe(5, "safe");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r172 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r172.tabs[ctx_r172.activeTabIndex] == null ? null : ctx_r172.tabs[ctx_r172.activeTabIndex].tabError.heading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(5, 2, ctx_r172.Spa_PlanList_Tab_Text_NoPlans_MedicareforDualPlanYear, "html"), i0.ɵɵsanitizeHtml);
} }
function PlanListComponent_div_0_ng_template_26_ng_template_1_ng_container_0_vnext_inner_text_link_7_Template(rf, ctx) { if (rf & 1) {
    const _r184 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-inner-text-link", 126);
    i0.ɵɵlistener("innerTextClicked", function PlanListComponent_div_0_ng_template_26_ng_template_1_ng_container_0_vnext_inner_text_link_7_Template_vnext_inner_text_link_innerTextClicked_0_listener() { i0.ɵɵrestoreView(_r184); const ctx_r183 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r183.openAncillaryForm(ctx_r183.activeTabType)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r178 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("outerText", ctx_r178.Spa_PlanList_MedSupNoResultsError_Text)("innerText", ctx_r178.Spa_PlanList_MedSupNoResultsErrorClickable_Text)("customTextClass", "Spa_Style_Paragraph");
} }
function PlanListComponent_div_0_ng_template_26_ng_template_1_ng_container_0_vnext_inner_text_link_8_Template(rf, ctx) { if (rf & 1) {
    const _r186 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-inner-text-link", 126);
    i0.ɵɵlistener("innerTextClicked", function PlanListComponent_div_0_ng_template_26_ng_template_1_ng_container_0_vnext_inner_text_link_8_Template_vnext_inner_text_link_innerTextClicked_0_listener() { i0.ɵɵrestoreView(_r186); const ctx_r185 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r185.openAncillaryForm(ctx_r185.activeTabType)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r179 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("outerText", ctx_r179.Spa_PlanList_DentalNoResultsError_Text)("innerText", ctx_r179.Spa_PlanList_MedSupNoResultsErrorClickable_Text)("customTextClass", "Spa_Style_Paragraph");
} }
function PlanListComponent_div_0_ng_template_26_ng_template_1_ng_container_0_vnext_inner_text_link_9_Template(rf, ctx) { if (rf & 1) {
    const _r188 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-inner-text-link", 126);
    i0.ɵɵlistener("innerTextClicked", function PlanListComponent_div_0_ng_template_26_ng_template_1_ng_container_0_vnext_inner_text_link_9_Template_vnext_inner_text_link_innerTextClicked_0_listener() { i0.ɵɵrestoreView(_r188); const ctx_r187 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r187.openAncillaryForm(ctx_r187.activeTabType)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r180 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("outerText", ctx_r180.Spa_PlanList_VisionNoResultsError_Text)("innerText", ctx_r180.Spa_PlanList_MedSupNoResultsErrorClickable_Text)("customTextClass", "Spa_Style_Paragraph");
} }
function PlanListComponent_div_0_ng_template_26_ng_template_1_ng_container_0_vnext_inner_text_link_10_Template(rf, ctx) { if (rf & 1) {
    const _r190 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-inner-text-link", 126);
    i0.ɵɵlistener("innerTextClicked", function PlanListComponent_div_0_ng_template_26_ng_template_1_ng_container_0_vnext_inner_text_link_10_Template_vnext_inner_text_link_innerTextClicked_0_listener() { i0.ɵɵrestoreView(_r190); const ctx_r189 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r189.openAncillaryForm(ctx_r189.activeTabType)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r181 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("outerText", ctx_r181.Spa_PlanList_HospitalIndemnityNoResultsError_Text)("innerText", ctx_r181.Spa_PlanList_MedSupNoResultsErrorClickable_Text)("customTextClass", "Spa_Style_Paragraph");
} }
function PlanListComponent_div_0_ng_template_26_ng_template_1_ng_container_0_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 127);
    i0.ɵɵelement(1, "span", 128);
    i0.ɵɵpipe(2, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r182 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 1, ctx_r182.planFacade.getNotTurning65AsOfEffectiveDateMonthText(), "html"), i0.ɵɵsanitizeHtml);
} }
function PlanListComponent_div_0_ng_template_26_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0)(1);
    i0.ɵɵelementStart(2, "div", 120)(3, "div", 13)(4, "h3", 123);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(6, 69);
    i0.ɵɵtemplate(7, PlanListComponent_div_0_ng_template_26_ng_template_1_ng_container_0_vnext_inner_text_link_7_Template, 1, 3, "vnext-inner-text-link", 124);
    i0.ɵɵtemplate(8, PlanListComponent_div_0_ng_template_26_ng_template_1_ng_container_0_vnext_inner_text_link_8_Template, 1, 3, "vnext-inner-text-link", 124);
    i0.ɵɵtemplate(9, PlanListComponent_div_0_ng_template_26_ng_template_1_ng_container_0_vnext_inner_text_link_9_Template, 1, 3, "vnext-inner-text-link", 124);
    i0.ɵɵtemplate(10, PlanListComponent_div_0_ng_template_26_ng_template_1_ng_container_0_vnext_inner_text_link_10_Template, 1, 3, "vnext-inner-text-link", 124);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(11, PlanListComponent_div_0_ng_template_26_ng_template_1_ng_container_0_div_11_Template, 3, 4, "div", 125);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r177 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r177.Spa_PlanList_Tab_Header_NoPlans);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r177.activeTabType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r177.planTypeAbbreviation.MEDIGAP);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r177.planTypeAbbreviation.DENTAL);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r177.planTypeAbbreviation.VISION);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r177.planTypeAbbreviation.HC);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r177.showTurning65AtEffectiveDateMessage);
} }
function PlanListComponent_div_0_ng_template_26_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanListComponent_div_0_ng_template_26_ng_template_1_ng_container_0_Template, 12, 7, "ng-container", 19);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r175 = i0.ɵɵreference(4);
    const ctx_r174 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r174.showNoPlansFromAnswersMessage)("ngIfElse", _r175);
} }
function PlanListComponent_div_0_ng_template_26_ng_template_3_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 120)(2, "h3", 130);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p", 131);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r191 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r191.tabs[ctx_r191.activeTabIndex] == null ? null : ctx_r191.tabs[ctx_r191.activeTabIndex].tabError.heading);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r191.Spa_PlanFilters_No_Plans_Available_Message);
} }
function PlanListComponent_div_0_ng_template_26_ng_template_3_ng_template_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-snp-toggle", 99);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r194 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("showLinkText", ctx_r194.Spa_PlanList_ShowSNPLink_Text)("hideLinkText", ctx_r194.Spa_PlanList_HideSNPLink_Text)("activeTabType", ctx_r194.activeTabType)("filteredPlansHasSNPPlans", ctx_r194.filteredPlansHasSNPPlans);
} }
function PlanListComponent_div_0_ng_template_26_ng_template_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 120)(1, "div", 13)(2, "h3", 123);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "p", 132);
    i0.ɵɵpipe(5, "safe");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, PlanListComponent_div_0_ng_template_26_ng_template_3_ng_template_1_ng_container_6_Template, 2, 4, "ng-container", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r193 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r193.tabs[ctx_r193.activeTabIndex] == null ? null : ctx_r193.tabs[ctx_r193.activeTabIndex].tabError.heading);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(5, 3, ctx_r193.tabs[ctx_r193.activeTabIndex] == null ? null : ctx_r193.tabs[ctx_r193.activeTabIndex].tabError.body, "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r193.Spa_Site_SNPTools_Enabled && !ctx_r193.currentTabPlanCount);
} }
function PlanListComponent_div_0_ng_template_26_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanListComponent_div_0_ng_template_26_ng_template_3_ng_container_0_Template, 6, 2, "ng-container", 19);
    i0.ɵɵtemplate(1, PlanListComponent_div_0_ng_template_26_ng_template_3_ng_template_1_Template, 7, 6, "ng-template", null, 129, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r192 = i0.ɵɵreference(2);
    const ctx_r176 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r176.totalAppliedFilters > 1)("ngIfElse", _r192);
} }
function PlanListComponent_div_0_ng_template_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PlanListComponent_div_0_ng_template_26_ng_container_0_Template, 6, 5, "ng-container", 19);
    i0.ɵɵtemplate(1, PlanListComponent_div_0_ng_template_26_ng_template_1_Template, 1, 2, "ng-template", null, 118, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(3, PlanListComponent_div_0_ng_template_26_ng_template_3_Template, 3, 2, "ng-template", null, 119, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r173 = i0.ɵɵreference(2);
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r19.isMedicareTab && ctx_r19.hasPlanYearPermissionError)("ngIfElse", _r173);
} }
const _c10 = function (a0) { return { "d-none": a0 }; };
const _c11 = function (a0, a1) { return { "col-md-9": a0, "col-md-12": a1 }; };
function PlanListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r196 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, PlanListComponent_div_0_ng_container_1_Template, 2, 48, "ng-container", 3);
    i0.ɵɵelementStart(2, "div", 4)(3, "div", 5)(4, "div", 6);
    i0.ɵɵtemplate(5, PlanListComponent_div_0_ng_container_5_Template, 11, 7, "ng-container", 3);
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵtemplate(7, PlanListComponent_div_0_div_7_Template, 2, 4, "div", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, PlanListComponent_div_0_div_8_Template, 2, 6, "div", 9);
    i0.ɵɵtemplate(9, PlanListComponent_div_0_div_9_Template, 5, 4, "div", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, PlanListComponent_div_0_ng_container_10_Template, 13, 7, "ng-container", 3);
    i0.ɵɵtemplate(11, PlanListComponent_div_0_div_11_Template, 2, 27, "div", 11);
    i0.ɵɵelementStart(12, "div", 12)(13, "div", 6)(14, "div", 13)(15, "p", 14);
    i0.ɵɵtemplate(16, PlanListComponent_div_0_ng_container_16_Template, 4, 2, "ng-container", 3);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(17, PlanListComponent_div_0_vnext_pharmacy_selector_17_Template, 1, 8, "vnext-pharmacy-selector", 15);
    i0.ɵɵtemplate(18, PlanListComponent_div_0_vnext_effective_date_display_18_Template, 1, 1, "vnext-effective-date-display", 16);
    i0.ɵɵtemplate(19, PlanListComponent_div_0_ng_container_19_Template, 4, 6, "ng-container", 3);
    i0.ɵɵtemplate(20, PlanListComponent_div_0_ng_container_20_Template, 10, 8, "ng-container", 3);
    i0.ɵɵelementStart(21, "div", 6);
    i0.ɵɵtemplate(22, PlanListComponent_div_0_div_22_Template, 7, 6, "div", 17);
    i0.ɵɵelementStart(23, "div", 18);
    i0.ɵɵlistener("scrolled", function PlanListComponent_div_0_Template_div_scrolled_23_listener() { i0.ɵɵrestoreView(_r196); const ctx_r195 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r195.onScrollDown()); });
    i0.ɵɵtemplate(24, PlanListComponent_div_0_ng_container_24_Template, 10, 17, "ng-container", 3);
    i0.ɵɵtemplate(25, PlanListComponent_div_0_ng_container_25_Template, 2, 2, "ng-container", 19);
    i0.ɵɵtemplate(26, PlanListComponent_div_0_ng_template_26_Template, 5, 2, "ng-template", null, 20, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const _r18 = i0.ɵɵreference(27);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disableCommonEvent", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.Spa_PreferenceBanner_Enabled);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.Spa_PlanList_PlansAvailableText_Enabled && ctx_r0.isReadyToShowZipcodeLink);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_PageSubHeader_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.tabs && ctx_r0.tabs.length && !ctx_r0.mobile);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.mobile && (ctx_r0.tabs == null ? null : ctx_r0.tabs.length));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.currentTabPlanCount > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showMedSupForm);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(21, _c10, ctx_r0.showMedSupForm || ctx_r0.showDentalForm || ctx_r0.showVisionForm || ctx_r0.showHospitalIndemnityForm));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.Spa_Plan_Tab_Educational_Text_Show);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.mobile && ctx_r0.Spa_GuidedHelp_Enabled && ctx_r0.pharmacyFacade.showPharmacySelectorToggle(ctx_r0.activeTabType));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.mobile && !ctx_r0.Spa_PlanList_FilterModal_Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.Spa_MedSupForm_AllowFormWhenNoPlansAvailable_Enabled && ctx_r0.activeTabType === ctx_r0.planTypeAbbreviation.MEDIGAP && ctx_r0.currentTabPlanCount === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.currentTabPlanCount);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.currentTabPlanCount && !ctx_r0.Spa_PlanList_FilterModal_Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("infiniteScrollDistance", 2)("infiniteScrollThrottle", 50)("ngClass", i0.ɵɵpureFunction2(23, _c11, ctx_r0.currentTabPlanCount && !ctx_r0.Spa_PlanList_FilterModal_Enabled, ctx_r0.currentTabPlanCount && ctx_r0.Spa_PlanList_FilterModal_Enabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.currentTabPlanCount);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.filteredPlans == null ? null : ctx_r0.filteredPlans.length)("ngIfElse", _r18);
} }
function PlanListComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "vnext-not-licensed-plan-list", 133);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("tagsToUpdate", ctx_r2.nonLicensedGoogleDataTags)("headerText", ctx_r2.planListFacade.getNonLicensedHeaderText())("informationalText", ctx_r2.planListFacade.getNonLicensedInformationText());
} }
let PlanListComponent = class PlanListComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, planFacade, injector, modalService, plansService, medSupService, medSupFacade, weglotService, planCompareService, planListFacade, planListContext, preferencesService, providerService, providerFacade, memberSessionService, quoteService, siteService, analyticsService, router, guidedHelpService, millimanService, spinnerService, liveEditState, pharmacyFacade, store, sessionHttpService, configResourceService, filterService, snpService, ssoPopulatedFieldService, drugsService, sortService, planFilterItemsFacade, hospitalIndemnityFormFacade, planCompareFacade, navigationService, pharmacyService, retentionFacade, demographicService, planYearResourceService, planYearService, carriersService, zipCodeService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.planFacade = planFacade;
        this.injector = injector;
        this.modalService = modalService;
        this.plansService = plansService;
        this.medSupService = medSupService;
        this.medSupFacade = medSupFacade;
        this.weglotService = weglotService;
        this.planCompareService = planCompareService;
        this.planListFacade = planListFacade;
        this.planListContext = planListContext;
        this.preferencesService = preferencesService;
        this.providerService = providerService;
        this.providerFacade = providerFacade;
        this.memberSessionService = memberSessionService;
        this.quoteService = quoteService;
        this.siteService = siteService;
        this.analyticsService = analyticsService;
        this.router = router;
        this.guidedHelpService = guidedHelpService;
        this.millimanService = millimanService;
        this.spinnerService = spinnerService;
        this.liveEditState = liveEditState;
        this.pharmacyFacade = pharmacyFacade;
        this.store = store;
        this.sessionHttpService = sessionHttpService;
        this.configResourceService = configResourceService;
        this.filterService = filterService;
        this.snpService = snpService;
        this.ssoPopulatedFieldService = ssoPopulatedFieldService;
        this.drugsService = drugsService;
        this.sortService = sortService;
        this.planFilterItemsFacade = planFilterItemsFacade;
        this.hospitalIndemnityFormFacade = hospitalIndemnityFormFacade;
        this.planCompareFacade = planCompareFacade;
        this.navigationService = navigationService;
        this.pharmacyService = pharmacyService;
        this.retentionFacade = retentionFacade;
        this.demographicService = demographicService;
        this.planYearResourceService = planYearResourceService;
        this.planYearService = planYearService;
        this.carriersService = carriersService;
        this.zipCodeService = zipCodeService;
        this.filteredPlans = [];
        this.planPharmacyData = [];
        this.carriersFilters = {};
        this.planSubTypeFilters = {};
        this.modelDrugProgramsFilters = {};
        this.planSellableFilters = {};
        this.cSNPBaseTypeFilters = {};
        this.cSNPSubTypesFilters = {};
        this.dSNPSubTypesFilters = {};
        this.dSNPBaseTypesFilters = {};
        this.iSNPBaseTypesFilters = {};
        this.iSNPSubTypesFilters = {};
        this.medicalDeductibleFilters = {};
        this.maximumOutOfPocketCostFilters = {};
        this.drugDeductibleFilters = {};
        this.medicalPremiumFilters = {};
        this.drugPremiumFilters = {};
        this.planBenefitsFilters = {};
        this.addOnFilters = {};
        this.providerFilters = {};
        this.numberOfDaysFilters = {};
        this.isMedsupPlanSubTypeChange = false;
        this.isZipModalOpen = false;
        // These flags determine whether the logic to set the
        // activetab(default tab or based on scores, coveragetype etc)
        // needs to be executed for a given plans call.
        // We do not want to redirect to default/score-based tabs from within planlist page
        this.recalculateActiveTab = true;
        this.recalculateActiveTabWithScores = true;
        this.isCostFilterEnabled = false;
        this.preferenceScoresEnabled = false;
        this.planYearTextEnabled = false;
        this.isPlanListInfoTracked = false;
        this.hasEnteredPreferences = false;
        this.filterPopupOpen = false;
        this.selectedFilters = [];
        this.clearSelectedFilterTag = false;
        // #region resources
        this.Spa_PlanDetails_NonCommissionable_Text = 'Non-Commissionable';
        this.Spa_Site_Pharmacy_Filter_Enabled = true;
        this.Spa_PlanDetails_NonCommissionable_FlagCheck_Enabled = false;
        this.Spa_PlanList_AddNonLicensedPlans_Text = 'Add non-licensed plans';
        this.Spa_PlanList_BestCoverage_Text = 'Best coverage';
        this.Spa_Site_BackToSummary_Link_Text = 'Back to summary';
        this.Spa_Site_Pharmacy_In_Network_Filter_Enabled = true;
        this.Spa_Site_Pharmacy_Other_Filter_Enabled = false;
        this.Spa_Filter_Default_Filter_Text = 'No filters available';
        this.Spa_Pharmacy_Filter_Open24hrs_Text = 'Open 24 hours';
        this.Spa_Pharmacy_Filter_Eprescribing_Text = 'Electronic prescribing(prescriptions can be written and sent to the pharmacy electronically)';
        this.Spa_Pharmacy_Filter_HandicapAccess_Text = 'Handicap accessible';
        this.Spa_Pharmacy_Filter_DurableEquipment_Text = 'Durable medical Equipment';
        this.Spa_Pharmacy_Filter_MailOrder_Text = 'Mail Order';
        this.Spa_Pharmacy_Filters = [
            {
                dataKey: 'has24hrService',
                displayName: this.Spa_Pharmacy_Filter_Open24hrs_Text
            },
            {
                dataKey: 'hasEPrescriptions',
                displayName: this.Spa_Pharmacy_Filter_Eprescribing_Text
            },
            {
                dataKey: 'hasHandicapAccess',
                displayName: this.Spa_Pharmacy_Filter_HandicapAccess_Text
            },
            {
                dataKey: 'hasDurableEquipment',
                displayName: this.Spa_Pharmacy_Filter_DurableEquipment_Text
            },
            {
                dataKey: 'isMailOrder',
                displayName: this.Spa_Pharmacy_Filter_MailOrder_Text
            }
        ];
        this.Spa_Site_Plans_Text = 'plans';
        this.Spa_Site_Plan_Text = 'plan';
        this.Spa_Filter_Header_Text = 'Filters';
        this.Spa_Filter_Clear_All = 'Clear all';
        this.Spa_PlanFilters_DefaultText = 'There are no filters for your available plans.';
        this.Spa_PlanFilters_DayLabel_Text = 'Number of days';
        this.Spa_PlanFilters_SelectDayLabel_Text = 'Select an option';
        this.Spa_PlanFilters_CarrierLabel_Text = 'Carriers';
        this.Spa_PlanFilters_SubType_Label = 'Plan subtypes';
        this.Spa_Plan_Tab_Educational_Text_Show = true;
        this.Spa_Site_Tooltip_Text = 'Tooltip:';
        this.Spa_Site_ComboPlanLabel_Text = 'Combo plan';
        this.Spa_Site_ComboPlanTooltip_Text = '<h4>Combo plan</h4><div>This plan may include any of the following coverages:  Dental, Vision, and Hearing.  Find more information on what this plan covers in the details.</div>';
        this.Spa_PlanFilters_Modal_Link = 'Plan filters';
        this.Spa_PlanFilters_Modal_Cancel_Button = 'Cancel';
        this.Spa_PlanFilters_Modal_Apply_Button = 'Apply';
        this.Spa_PlanFilters_No_Plans_Available_Message = 'Please remove some or clear all your filters to view plans.';
        this.Spa_StarRating_Enabled = true;
        this.Spa_PlanList_Sort_By_PreferenceScore_Enabled = false;
        this.Spa_PlanList_Effective_Date_Text = 'This will apply to all product types except medicare';
        this.Spa_Rate_Factor_Disclaimer_Text = 'This date will be applied for all product types wherever rate factor questions are displayed. (TBD)';
        this.Spa_Rate_Factor_Disclaimer_Enabled = false;
        this.Spa_PlanSort_Header = 'Sort:';
        this.Spa_Site_PlanLogo_Size = 'small';
        this.AppID = 0;
        this.Spa_PlanList_Sort_Options_MA = [
            Sort.create({
                dataKey: SortLabels.PLAN_NAME,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 3,
                dataKeyType: DataKeyType.STRING,
                sortType: SortType.ASCENDING,
                displayName: 'Plan name (A - Z)',
                isDefault: false,
                display: true
            }),
            Sort.create({
                dataKey: SortLabels.MEDICAL_PREMIUM,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 1,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Premium',
                isDefault: false,
                display: true
            }),
            Sort.create({
                dataKey: SortLabels.PLAN_RATING,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 4,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Star Rating',
                isDefault: false,
                display: true
            }),
            Sort.create({
                dataKey: SortLabels.TOTAL_ESTIMATED_COST,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 2,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Total Estimated Cost',
                isDefault: false,
                display: true
            }),
            Sort.create({
                dataKey: SortLabels.SCORE,
                secondaryDataKey: SortLabels.TOTAL_ESTIMATED_COST,
                order: 5,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.DESCENDING,
                displayName: this.planListFacade.getPlanListSortByScoreLabel(),
                isDefault: true,
                display: true,
                secondarySortType: SortType.ASCENDING
            }),
            Sort.create({
                dataKey: SortLabels.MEDICAL_DEDUCTIBLE,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 6,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Medical Deductible',
                isDefault: false,
                display: false
            }),
            Sort.create({
                dataKey: SortLabels.MAXIMUM_OUT_OF_POCKET_COST,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 7,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Medical Out of Pocket Maximum',
                isDefault: false,
                display: false
            })
        ];
        this.Spa_PlanList_Sort_Options_MAPD = [
            Sort.create({
                dataKey: SortLabels.PLAN_NAME,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 3,
                dataKeyType: DataKeyType.STRING,
                sortType: SortType.ASCENDING,
                displayName: 'Plan name (A - Z)',
                isDefault: false,
                display: true
            }),
            Sort.create({
                dataKey: SortLabels.MEDICAL_PREMIUM,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 1,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Premium',
                isDefault: false,
                display: true
            }),
            Sort.create({
                dataKey: SortLabels.PLAN_RATING,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 4,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Star Rating',
                isDefault: false,
                display: true
            }),
            Sort.create({
                dataKey: SortLabels.TOTAL_ESTIMATED_COST,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 2,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Total Estimated Cost',
                isDefault: false,
                display: true
            }),
            Sort.create({
                dataKey: SortLabels.SCORE,
                secondaryDataKey: SortLabels.TOTAL_ESTIMATED_COST,
                order: 5,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.DESCENDING,
                displayName: this.planListFacade.getPlanListSortByScoreLabel(),
                isDefault: true,
                display: true,
                secondarySortType: SortType.ASCENDING
            }),
            Sort.create({
                dataKey: SortLabels.MEDICAL_DEDUCTIBLE,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 6,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Medical Deductible',
                isDefault: false,
                display: false
            }),
            Sort.create({
                dataKey: SortLabels.MAXIMUM_OUT_OF_POCKET_COST,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 7,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Medical Out of Pocket Maximum',
                isDefault: false,
                display: false
            })
        ];
        this.Spa_PlanList_Sort_Options_PDP = [
            Sort.create({
                dataKey: SortLabels.PLAN_NAME,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 3,
                dataKeyType: DataKeyType.STRING,
                sortType: SortType.ASCENDING,
                displayName: 'Plan name (A - Z)',
                isDefault: false,
                display: true
            }),
            Sort.create({
                dataKey: SortLabels.MEDICAL_PREMIUM,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 1,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Premium',
                isDefault: false,
                display: true
            }),
            Sort.create({
                dataKey: SortLabels.PLAN_RATING,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 4,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Star Rating',
                isDefault: false,
                display: true
            }),
            Sort.create({
                dataKey: SortLabels.TOTAL_ESTIMATED_COST,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 2,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Total Estimated Cost',
                isDefault: false,
                display: true
            }),
            Sort.create({
                dataKey: SortLabels.SCORE,
                secondaryDataKey: SortLabels.TOTAL_ESTIMATED_COST,
                order: 5,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.DESCENDING,
                displayName: this.planListFacade.getPlanListSortByScoreLabel(),
                isDefault: true,
                display: true,
                secondarySortType: SortType.ASCENDING
            }),
            Sort.create({
                dataKey: SortLabels.MEDICAL_DEDUCTIBLE,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 6,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Medical Deductible',
                isDefault: false,
                display: false
            }),
            Sort.create({
                dataKey: SortLabels.MAXIMUM_OUT_OF_POCKET_COST,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 7,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Medical Out of Pocket Maximum',
                isDefault: false,
                display: false
            })
        ];
        this.Spa_PlanList_Sort_Options_MEDIGAP = [
            Sort.create({
                dataKey: SortLabels.PLAN_NAME,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 2,
                dataKeyType: DataKeyType.STRING,
                sortType: SortType.ASCENDING,
                displayName: 'Plan name (A - Z)',
                isDefault: false,
                display: true
            }),
            Sort.create({
                dataKey: SortLabels.MEDICAL_PREMIUM,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 1,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Premium',
                isDefault: false,
                display: true
            }),
            Sort.create({
                dataKey: SortLabels.SCORE,
                secondaryDataKey: SortLabels.MEDICAL_PREMIUM,
                order: 3,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.DESCENDING,
                displayName: this.planListFacade.getPlanListSortByScoreLabel(),
                isDefault: true,
                display: true,
                secondarySortType: SortType.ASCENDING
            }),
            Sort.create({
                dataKey: SortLabels.MEDICAL_DEDUCTIBLE,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 4,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Medical Deductible',
                isDefault: false,
                display: false
            }),
            Sort.create({
                dataKey: SortLabels.MAXIMUM_OUT_OF_POCKET_COST,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 5,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Medical Out of Pocket Maximum',
                isDefault: false,
                display: false
            })
        ];
        this.Spa_PlanList_Sort_Options_DENTAL = [
            Sort.create({
                dataKey: SortLabels.ANNUAL_PLAN_PREMIUM,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 1,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Premium',
                isDefault: true,
                display: true
            }),
            Sort.create({
                dataKey: SortLabels.PLAN_NAME,
                secondaryDataKey: SortLabels.ANNUAL_PLAN_PREMIUM,
                order: 2,
                dataKeyType: DataKeyType.STRING,
                sortType: SortType.ASCENDING,
                displayName: 'Plan name (A - Z)',
                isDefault: false,
                display: true
            })
        ];
        this.Spa_PlanList_Sort_Options_VISION = [
            Sort.create({
                dataKey: SortLabels.ANNUAL_PLAN_PREMIUM,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 1,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Premium',
                isDefault: true,
                display: true
            }),
            Sort.create({
                dataKey: SortLabels.PLAN_NAME,
                secondaryDataKey: SortLabels.ANNUAL_PLAN_PREMIUM,
                order: 2,
                dataKeyType: DataKeyType.STRING,
                sortType: SortType.ASCENDING,
                displayName: 'Plan name (A - Z)',
                isDefault: false,
                display: true
            })
        ];
        this.Spa_PlanList_Sort_Options_HIP = [
            Sort.create({
                dataKey: SortLabels.CALCULATED_BASE_PLAN_PREMIUM,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 1,
                dataKeyType: DataKeyType.NUMERIC,
                sortType: SortType.ASCENDING,
                displayName: 'Plan Premium (Low to High)',
                isDefault: true,
                display: true
            }),
            Sort.create({
                dataKey: SortLabels.CARRIER_NAME,
                secondaryDataKey: SortLabels.PLAN_NAME,
                order: 2,
                dataKeyType: DataKeyType.STRING,
                sortType: SortType.ASCENDING,
                displayName: 'Plan name (A - Z)',
                isDefault: false,
                display: true
            }),
            Sort.create({
                dataKey: SortLabels.PLAN_NAME,
                secondaryDataKey: SortLabels.CARRIER_NAME,
                order: 3,
                dataKeyType: DataKeyType.NUMERIC_STRING,
                sortType: SortType.ASCENDING,
                displayName: 'Number of days',
                isDefault: false,
                display: true
            })
        ];
        this.Spa_Site_Health_Text = 'Health';
        this.Spa_PlanCard_Benefit_MA = [
            { title: 'medicalDeductible', label: 'Medical Deductible', order: 1 },
            { title: 'maximumOutOfPocketCost', label: 'Out Of Pocket Max', order: 2 }
        ];
        this.Spa_PlanCard_Benefit_MAPD = [
            { title: 'medicalDeductible', label: 'Medical Deductible', order: 1 },
            { title: 'maximumOutOfPocketCost', label: 'Out Of Pocket Max', order: 2 },
            { title: 'drugDeductible', label: 'Pharmacy Deductible', order: 3 },
            { title: 'initialCoverageLimit', label: 'Initial Coverage Limit', order: 4 }
        ];
        this.Spa_PlanCard_Benefit_PDP = [
            { title: 'drugDeductible', label: 'Pharmacy Deductible', order: 1 },
            { title: 'initialCoverageLimit', label: 'Initial Coverage Limit', order: 2 }
        ];
        this.Spa_PlanCard_Benefit_DENTAL = [
            { title: 'medicalDeductible', label: 'Deductible', order: 1 },
            { title: 'annualMaximumBenefit', label: 'Calendar year max', order: 2 }
        ];
        this.Spa_PlanCard_Preferences_MA = [
            { title: 'providers', label: 'Providers', order: 1 },
            { title: 'drugCost', label: 'Est. drug cost', order: 2 },
            { title: 'healthCost', label: `${this.Spa_Site_Health_Text} cost`, order: 3 }
        ];
        this.Spa_PlanCard_Preferences_MAPD = [
            { title: 'providers', label: 'Providers', order: 1 },
            { title: 'prescription', label: 'Prescription', order: 3 },
            { title: 'pharmacy', label: 'Pharmacy', order: 4 }
        ];
        this.Spa_PlanCard_Preferences_PDP = [
            { title: 'drugCost', label: 'Est. drug cost', order: 1 },
            { title: 'prescription', label: 'Prescription', order: 2 },
            { title: 'pharmacy', label: 'Pharmacy', order: 3 }
        ];
        this.Spa_Site_Multi_Pharmacy_Enabled = false;
        this.Spa_PlanList_Tab_Text_NoPlans_MA = "We are sorry, but we don't currently offer coverage in your area.";
        this.Spa_PlanList_Tab_Text_NoPlans_MAPD = "We are sorry, but we don't currently offer coverage in your area.";
        this.Spa_PlanList_Tab_Text_NoPlans_PDP = "We are sorry, but we don't currently offer coverage in your area.";
        this.Spa_PlanList_Tab_Text_NoPlans_MEDIGAP = "We are sorry, but we don't currently offer coverage in your area.";
        this.Spa_PlanList_Tab_Text_NoPlans_DENTAL = "We are sorry, but we don't currently offer coverage in your area.";
        this.Spa_PlanList_Tab_Text_NoPlans_MedicareforDualPlanYear = 'You are not able to view the plans for the current plan year';
        this.Spa_PlanList_ActiveTab_BasedOn_PreferenceScore_Enabled = false;
        this.Spa_PlanList_Filters_Expanded = true;
        this.Spa_PlanList_RateFactorsPreviousLink_Enabled = true;
        this.Spa_PlanList_PlansAvailableSingular_Text = 'Medicare plan available in';
        this.Spa_PlanList_PlansAvailablePlural_Text = 'Medicare plans available in';
        this.Spa_DualPlanYear_PlanList_Text_Enabled = true;
        this.Spa_DualPlanYear_Enabled = true;
        this.Spa_DualPlanYear_Update_Enabled = true;
        this.Spa_DualPlanYear_PlanList_Text = 'for <YYYY>';
        this.Spa_Site_PageSubHeader_Text = '';
        this.Spa_MedSup_PageSubHeader_Text = '';
        this.Spa_PlanList_Tab_Educational_Text_MAPD = '';
        this.Spa_PlanList_Tab_Educational_Text_MA = '';
        this.Spa_PlanList_Tab_Educational_Text_PDP = '';
        this.Spa_PlanList_Tab_Educational_Text_DENTAL = '';
        this.Spa_PlanList_Tab_Educational_Text_VISION = '';
        this.Spa_Site_CostBasedOn_Text = 'Costs are based on';
        this.Spa_PlanList_Tab_Educational_Text_HIP = 'Hospital indemnity insurance supplements your existing health insurance coverage to help pay costs for' +
            ' hospital stays.  Even if your medical insurance covers most of your hospitalization, you can still receive' +
            ' cash payments from your hospital indemnity insurance plan for extra costs while recovering.';
        this.Spa_PlanList_Tab_Educational_Text_MEDIGAP = '';
        this.Spa_PlanList_ViewCost_Header_Text = 'View costs for other pharmacies';
        this.Spa_PlanList_ViewCost_Header_Content = 'Switch your pharmacy to the left of plans to view costs of other pharmacies';
        this.Spa_PlanCard_AddToCompare_Text = 'Add to compare';
        this.Spa_PlanList_PlansAvailableText_Enabled = true;
        this.Spa_PlanList_EditZipCode_Label = 'Click here to change your ZIP code';
        this.Spa_PlanList_Tabs_Data = [
            {
                title: 'Medicare Advantage Prescription Drug',
                defaultActive: true,
                secondaryDefaultActive: false,
                errorHeading: 'No plan results',
                errorBody: `We are sorry, but we don't currently offer coverage in your area.\n Call <a href='tel:5555555555' class='Spa_Style_Large_Font Spa_Style_Primary_Color'>(555) 555-5555</a> to contact your broker.`,
                tabTypes: [PlanTypeAbbreviation.MAPD],
                planTabEducationalText: this.Spa_PlanList_Tab_Educational_Text_MAPD,
                sortList: this.Spa_PlanList_Sort_Options_MAPD,
                benefits: this.Spa_PlanCard_Benefit_MAPD,
                benefitPreferences: this.Spa_PlanCard_Preferences_MAPD
            },
            {
                title: 'Medicare Advantage',
                defaultActive: false,
                secondaryDefaultActive: true,
                errorHeading: 'No plan results',
                errorBody: `We are sorry, but we don't currently offer coverage in your area.\n Call <a href='tel:5555555555' class='Spa_Style_Large_Font Spa_Style_Primary_Color'>(555) 555-5555</a> to contact your broker.`,
                tabTypes: [PlanTypeAbbreviation.MA],
                planTabEducationalText: this.Spa_PlanList_Tab_Educational_Text_MA,
                sortList: this.Spa_PlanList_Sort_Options_MA,
                benefits: this.Spa_PlanCard_Benefit_MA,
                benefitPreferences: this.Spa_PlanCard_Preferences_MA
            },
            {
                title: 'Prescription Drug',
                defaultActive: false,
                secondaryDefaultActive: false,
                errorHeading: 'No plan results',
                errorBody: `We are sorry, but we don't currently offer coverage in your area.\n Call <a href='tel:5555555555' class='Spa_Style_Large_Font Spa_Style_Primary_Color'>(555) 555-5555</a> to contact your broker.`,
                tabTypes: [PlanTypeAbbreviation.PDP],
                planTabEducationalText: this.Spa_PlanList_Tab_Educational_Text_PDP,
                sortList: this.Spa_PlanList_Sort_Options_PDP,
                benefits: this.Spa_PlanCard_Benefit_PDP,
                benefitPreferences: this.Spa_PlanCard_Preferences_PDP
            },
            {
                title: 'Medicare Supplemental',
                defaultActive: false,
                secondaryDefaultActive: false,
                errorHeading: 'No plan results',
                errorBody: `We are sorry, but we don't currently offer coverage in your area.\n Call <a href='tel:5555555555' class='Spa_Style_Large_Font Spa_Style_Primary_Color'>(555) 555-5555</a> to contact your broker.`,
                tabTypes: [PlanTypeAbbreviation.MEDIGAP],
                planTabEducationalText: this.Spa_PlanList_Tab_Educational_Text_MEDIGAP,
                sortList: this.Spa_PlanList_Sort_Options_MEDIGAP
            },
            {
                title: 'Dental',
                defaultActive: false,
                secondaryDefaultActive: false,
                errorHeading: 'No plan results',
                errorBody: `We are sorry, but we don't currently offer coverage in your area.\n Call <a href='tel:5555555555' class='Spa_Style_Large_Font Spa_Style_Primary_Color'>(555) 555-5555</a> to contact your broker.`,
                tabTypes: [PlanTypeAbbreviation.DENTAL],
                planTabEducationalText: this.Spa_PlanList_Tab_Educational_Text_DENTAL,
                sortList: this.Spa_PlanList_Sort_Options_DENTAL
            },
            {
                title: 'Vision',
                defaultActive: false,
                secondaryDefaultActive: false,
                errorHeading: 'No plan results',
                errorBody: `We are sorry, but we don't currently offer coverage in your area.\n Call <a href='tel:5555555555' class='Spa_Style_Large_Font Spa_Style_Primary_Color'>(555) 555-5555</a> to contact your broker.`,
                tabTypes: [PlanTypeAbbreviation.VISION],
                planTabEducationalText: this.Spa_PlanList_Tab_Educational_Text_VISION,
                sortList: this.Spa_PlanList_Sort_Options_VISION
            },
            {
                title: 'Hospital Indemnity',
                defaultActive: false,
                secondaryDefaultActive: false,
                errorHeading: 'No plan results',
                errorBody: `We are sorry, but we don't currently offer coverage in your area.\n Call <a href='tel:5555555555' class='Spa_Style_Large_Font Spa_Style_Primary_Color'>(555) 555-5555</a> to contact your broker.`,
                tabTypes: [PlanTypeAbbreviation.HC],
                planTabEducationalText: this.Spa_PlanList_Tab_Educational_Text_HIP,
                sortList: this.Spa_PlanList_Sort_Options_HIP
            }
        ];
        this.Spa_Site_Hide_EmptyPlanTabs = [
            {
                tabType: PlanTypeAbbreviation.MAPD,
                states: []
            },
            {
                tabType: PlanTypeAbbreviation.MA,
                states: []
            },
            {
                tabType: PlanTypeAbbreviation.PDP,
                states: []
            },
            {
                tabType: PlanTypeAbbreviation.MEDIGAP,
                states: []
            },
            {
                tabType: PlanTypeAbbreviation.DENTAL,
                states: []
            },
            {
                tabType: PlanTypeAbbreviation.VISION,
                states: []
            },
            {
                tabType: PlanTypeAbbreviation.HC,
                states: []
            }
        ];
        this.Spa_PlanDetails_HIP_Call_Out_Available_Plan_Types = [
            {
                title: 'Medicare Advantage Prescription Drug',
                enabled: true,
                tabType: PlanTypeAbbreviation.MAPD
            },
            {
                title: 'Medicare Advantage',
                enabled: true,
                tabType: PlanTypeAbbreviation.MA
            },
            {
                title: 'Medicare Supplement',
                enabled: false,
                tabType: PlanTypeAbbreviation.MEDIGAP
            }
        ];
        // Med Sup form keys
        this.Spa_Site_Previous = 'previous';
        this.Spa_PlanList_MedSupFormInchesLabel_Text = 'in';
        this.Spa_PlanList_MedSupFormFeetLabel_Text = 'ft';
        this.Spa_PlanList_MedSupFormPoundsLabel_Text = 'lbs';
        this.Spa_PlanList_MedSupFormMonthLabel_Text = 'Month';
        this.Spa_PlanList_MedSupFormYearLabel_Text = 'Year';
        this.Spa_PlanList_MedSupFormDropdownDefault_Text = 'Select an option';
        this.Spa_Site_ContinueToPlanList = 'Continue to plans';
        this.Spa_PlanList_MedSupFormTitle_Text = 'Medicare Supplemental Information';
        this.Spa_PlanList_DentalFormTitle_Text = '';
        this.Spa_PlanList_VisionFormTitle_Text = '';
        this.Spa_Dental_PageSubHeader_Text = '';
        this.Spa_Vision_PageSubHeader_Text = '';
        this.Spa_PlanList_HIPFormPrompt_Text = 'Hospital indemnity plan premiums and eligibility may vary. Please provide the following additional information' +
            ' to calculate your plan premiums and determine if you are eligible for enrollment in the plan.';
        this.Spa_PlanList_HIP_PageTitle_Text = 'Hospital Indemnity Information';
        this.Spa_PlanList_Tab_Header_NoPlans = 'No plan results';
        this.Spa_PlanList_DentalNoResultsError_Text = 'There are no plans available based on the information you provided. Review your answers';
        this.Spa_PlanList_VisionNoResultsError_Text = 'There are no plans available based on the information you provided. Review your answers';
        this.Spa_PlanList_HospitalIndemnityNoResultsError_Text = 'There are no plans available based on the information you provided. Review your answers';
        this.Spa_PlanList_MedSupNoResultsError_Text = 'There are no plans available based on the information you provided. Review your answers';
        this.Spa_PlanList_MedSupNoResultsErrorClickable_Text = 'Review your answers';
        this.Spa_PlanList_MedSupFormPrompt_Text = 'Medicare Supplement plan premiums and eligibility may vary. Please provide the following additional ' +
            'information to calculate your plan premiums and determine if you are eligible for enrollment in the plan.';
        this.Spa_PlanList_DentalFormPrompt_Text = 'Dental insurance can save you money by preventing oral or dental issues and will help you financially if any injury or accident occurs.';
        this.Spa_PlanList_VisionFormPrompt_Text = '';
        this.Spa_PlanList_MedSupQuestion_Data = [
            { key: 'DateOfBirth', defaultValue: '' },
            { key: 'Gender', defaultValue: 'Male' },
            { key: 'Tobacco', defaultValue: 'Smoker' },
            { key: 'Weight', defaultValue: 0 },
            { key: 'Height', defaultValue: '' },
            { key: 'PaymentMethod', defaultValue: '' },
            { key: 'Household', defaultValue: '' },
            { key: 'EffectiveDate', defaultValue: '' },
            { key: 'PartAEffectiveDate', defaultValue: '' },
            { key: 'PartBEffectiveDate', defaultValue: '' },
            { key: 'GuaranteedIssue', defaultValue: '' },
            { key: 'GIAdditional', defaultValue: '' }
        ];
        this.Spa_PlanList_DentalVisionQuestion_Data = [
            { key: 'DateOfBirth', defaultValue: '', ordinal: 1, required: true },
            { key: 'EffectiveDate', defaultValue: '', ordinal: 2, required: true },
            { key: 'Gender', defaultValue: 'Male', ordinal: 3, required: true },
            { key: 'Tobacco', defaultValue: 'Smoker', ordinal: 4, required: true }
        ];
        this.Spa_PlanList_GuaranteedIssue_Header = 'Do any of these apply to you?';
        this.Spa_PlanList_GuaranteedIssue_Text = 'If so, you likely qualify for Guaranteed Issue, which is a policy available to any eligible applicant without regard to health status.';
        this.Spa_PlanList_GuaranteedIssue_Tooltip = `<h4>Guaranteed Issue</h4>
    <p>Guaranteed Issue rights (also called "Medigap protections") are rights you have in certain situations when insurance companies must offer you certain Medigap policies. In these situations, an insurance company:</p>
    <ul>
      <li>Must sell you a Medigap policy</li>
      <li>Must cover all your pre-existing health conditions</li>
      <li>Can't charge you more for a Medigap policy because of past or present health problems</li>
    </ul>
    <p>In most cases, you have guaranteed issue rights when you have other health coverage that changes in some way, like when you lose the other health care coverage.</p>`;
        this.Spa_Site_SiteType = SiteType.CONSUMER;
        this.Spa_PlanList_DentalVisionWarningBanner_Text = 'You must answer a few questions to get a personalized quote.';
        this.Spa_PlanList_DentalVisionWarningBannerClickable_Text = 'get a personalized quote';
        this.Spa_PlanList_DentalVisionEditAnswersBanner_Text = 'Edit your answers';
        this.Spa_PlanList_DentalVisionEditAnswersBannerClickable_Text = 'Edit your answers';
        this.Spa_PlanList_MedSupWarningBanner_Text = 'You must answer a few questions and get a personalized quote to enroll in these plans.';
        this.Spa_PlanList_MedSupWarningBannerClickable_Text = 'answer a few questions';
        this.Spa_PlanList_MedSupEditAnswersBanner_Text = 'Edit your answers for a more personalized quote.';
        this.Spa_PlanList_MedSupEditAnswersBannerClickable_Text = 'Edit your answers';
        this.Spa_MedSup_RestrictMedSupPlansByAge_InfoText = `Medicare Supplement plans for the selected birthday and effective date cannot be added to your cart until you are within 90 days of your
    65th birthday. Please try again closer to your 65th birthday or`;
        this.Spa_MedSup_RestrictMedSupPlansByAge_InfoLink = 'edit your answers';
        this.Spa_Site_EPrescribing_Alt_Text = 'This pharmacy supports e-prescribing.';
        this.Spa_Site_Pharmacy_Added_Text = 'has been added';
        this.Spa_Site_Pharmacy_Add_Text = 'Press Enter to add this Pharmacy';
        this.Spa_GuidedHelp_Preference_Text = 'Preferences';
        this.Spa_GuidedHelp_PreferenceInfo_Text = 'Enter preferences to get a best match coverage type.';
        this.Spa_Site_AddPreferences = 'Add preferences';
        this.Spa_Site_GetStarted_Text = 'Get started';
        this.Spa_Site_Prescriptions_Text = 'Prescriptions';
        this.Spa_Site_Pharmacy_Text = 'Pharmacy';
        this.Spa_Site_Eligibility_Text = 'Eligibility';
        this.Spa_Site_OtherPreferences_Text = 'Other preferences';
        this.Spa_GuidedHelp_ReviewOtherPreferences_Text = 'Review and edit your other preferences.';
        this.Spa_GuidedHelp_Enabled = true;
        this.Spa_Site_Hide_Text = 'Hide';
        this.Spa_Site_ViewAll_Text = 'View all';
        this.Spa_Site_TotalEstimatedCost_Enabled = true;
        this.Spa_PlanList_BestMatch_Icon = 'fas fa-trophy';
        this.Spa_Site_BestMatch_Plan_Text = 'Best Match Plan';
        this.Spa_PlanList_BestMatchPlan_Tooltip = `Based on the preference information, this is the highest scored plan across all available plans. <returnToPreferencesAction> to update.`;
        this.Spa_PlanList_BestCoverageType_Enabled = false;
        this.Spa_PlanList_BestCoverageType_Text = 'Best coverage';
        this.Spa_PlanList_BestMatchPlan_Enabled = false;
        this.Spa_PlanList_BestCoverageType_Tooltip = `Based on the indicated interested coverage type, this is the best plan type to choose.
   <returnToPreferencesAction> to update.`;
        this.Spa_Site_ReturnToPreferences_Text = `Return to preferences`;
        this.Spa_Site_Current_Plan_Text = 'Current Plan';
        this.Spa_Site_Next_Year_Plan_Text = `Next year's plan`;
        this.Spa_Site_PlanNotAvailableForNextYear_Text = 'Plan not available next year';
        this.Spa_Site_Keep_This_Plan_Button_Text = 'Keep this plan';
        this.Spa_Site_AddToQuote_Enabled = true;
        this.Spa_Site_SendQuote_Button_Text = 'Send quote';
        this.Spa_PlanList_AddToQuote_Limit = 3;
        this.Spa_PlanList_AddToQuote_Limit_Mobile = 2;
        this.Spa_PlanList_AddToQuote_Hint_Text = `Quote up to <quoteLimit> plans`;
        this.Spa_Site_PlanList_HIP_Medicare_Quote_Enabled = false;
        this.Spa_PlanList_PlanType_Instructional_Text = 'Select Medicare coverage to see how Hospital Indemnity benefits can help cover gaps in costs for that specific plan.';
        this.Spa_Site_HIP_MonthlyPremium_Text = 'Updated based on benefit selections';
        this.Spa_Site_HIP_MoreBenefits_Instruction_Text = 'Add more benefits in details';
        this.Spa_Site_HIP_BasePlanOption_Text = 'Base plan option';
        this.Spa_Site_HIP_Description = 'Hospital Indemnity';
        this.Spa_Site_HIP_Add_Medicare_Advantage_Plan_Text = 'Add a Medicare Advantage plan';
        this.Spa_PlanList_SelectPlan_Button_Text = 'Select plan';
        this.Spa_PlanList_PleaseSelect_Error_Text = 'Please select';
        this.Spa_Site_PlanType_Header = 'Plan type';
        this.Spa_PlanList_SelectPlanType_Hint_Text = 'Select plan type...';
        this.Spa_Site_Carrier_Header = 'Carrier';
        this.Spa_PlanList_SelectPlan_Carriers_Hint_Text = 'Select carrier...';
        this.Spa_PlanList_SelectPlan_Text = 'Plan name';
        this.Spa_PlanList_SelectPlan_Hint_Text = 'Select Plan...';
        this.Spa_PlanList_NoPlansAvailable_Text = 'No plans available';
        this.Spa_PlanList_NoPlansAvailable_Hint_Text = 'There are no plans in this coverage area. Please select a new plan type.';
        this.Spa_PlanList_RequiredFields_Hint_Text = 'Indicates required fields';
        this.Spa_PlanList_ViewQuote_Text = 'View Quote';
        this.Spa_Site_IsDeepLinking_Enabled = true;
        this.Spa_Site_ErrorKeyword_Text = 'Error:';
        this.Spa_PlanList_EditZipCode_ButtonLabel = 'Change Zip Code';
        this.Spa_PlanList_DisplayDrugsCovered = true;
        this.Spa_Site_ShowRiderIcons = true;
        this.Spa_Site_ShowRidersOnPlanCards = true;
        this.Spa_Site_Dental_Rider_Display_Text = 'Dental';
        this.Spa_Site_Vision_Rider_Display_Text = 'Vision';
        this.Spa_Site_Hearing_Rider_Display_Text = 'Hearing';
        this.Spa_PlanCard_DentalAddOnCoverage_Text = 'Dental Included';
        this.Spa_PlanCard_HearingAddOnCoverage_Text = 'Hearing Included';
        this.Spa_PlanCard_VisionAddOnCoverage_Text = 'Vision Included';
        this.Spa_PlanCard_AddOnCoverage_Text = 'Add-on coverage';
        this.Spa_PlanCard_AddOnCoverageInCart_Text = 'Add-on coverage available in cart';
        this.Spa_PlanCard_ShowRidersOnMACards = true;
        this.Spa_PlanCard_ShowRidersOnPDPCards = true;
        this.Spa_PlanCard_ShowRidersOnMAPDCards = true;
        this.Spa_PlanCard_ShowRidersOnMEDIGAPCards = true;
        this.Spa_PlanCard_ShowRidersOnDentalCards = true;
        this.Spa_PlanCard_ShowRidersOnVisionCards = true;
        this.Spa_ShoppingCart_Enabled = true;
        this.Spa_PlanCard_PlanDetails_ButtonText = 'Plan details';
        this.Spa_Site_Show_PlanLogo = true;
        this.Spa_PlanCard_QuoteLinkName_Text = 'Get a personalized quote';
        this.Spa_PlanCard_PlanType_Text = 'Plan Type';
        this.Spa_Site_ShowPremiumAsAnnual = false;
        this.Spa_PlanCard_AddOnCoverageTooltip_Body = `<span>Available add-on coverage</span><br/>
  <span> To learn more about the add-on coverage available for this plan, either go to plan details or add this plan to your cart.</span>`;
        this.Spa_Site_NotApplicable_Text = 'N/A';
        this.Spa_PlanDetails_Non_Covered_Text = 'Not Covered';
        this.Spa_PlanCard_Pharmacy_Covered_Text = '<coveredPharmacies> of <totalPharamcies> covered';
        this.Spa_PlanCard_Drug_Covered_Text = '<coveredDrugCount> of <totalDrugCount> covered';
        this.Spa_PlanCard_CompareNow_Text = 'Compare now';
        this.Spa_PlanCard_CompareWarning_Tooltip = 'You may select up to <compareLimit> plans for comparison at a time';
        this.Spa_PlanCard_CompareLimit_Desktop = 3;
        this.Spa_PlanCard_CompareLimit_Mobile = 2;
        this.Spa_PlanCard_Total_Estimated_Cost_Tooltip = {
            header: 'Total estimated annual cost',
            body: 'Your total estimated annual cost is based on the plans yearly premium, your drug costs, and your health status and age.'
        };
        this.Spa_PlanCard_TotalEstimatedAnnualCost_Text = 'Total est. annual cost';
        this.Spa_PlanCard_TotalEstimatedCost_Text = 'Total est. cost';
        this.Spa_PlanCard_AddToQuote_Text = 'Add to quote';
        this.Spa_PlanCard_RemoveFromQuote_Text = 'Remove from quote';
        this.Spa_PlanCard_AddToQuote_Warning_Tooltip = { body: `You may select up to ${this.Spa_PlanList_AddToQuote_Limit} plans to quote` };
        this.Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip = { body: `You may select up to <quoteLimit> plans to quote` };
        this.Spa_Site_MedigapPlanType_Enabled = true;
        this.Spa_Site_AddToCompare_Enabled = true;
        this.Spa_Site_PlanViewDetails_Enabled = true;
        this.Spa_ProfileNavBar_ShowPlanList_Flag = false; // only here so it shows up on plan list in admin tool
        this.Spa_Filter_LicensingHeader_Text = 'Licensing';
        this.Spa_Filter_SellablePlansOnlyCheckbox_Label = 'Only show plans I can sell';
        this.Spa_Filter_SNPBaseTypes_Label = 'Special Needs Plans (SNP)';
        this.Spa_Site_MoreOptions_Text = 'More Options';
        this.Spa_Site_EnrollmentErrorNotice_Title = 'Correct the following error(s) on the form, then submit again';
        this.Spa_PlanList_Pharmacy_InNetwork_Preferred_Pricing_Text = 'Preferred In-network';
        this.Spa_PlanList_Pharmacy_InNetwork_Standard_Pricing_Text = 'Standard In-network';
        this.Spa_PlanList_Pharmacy_OutOfNetwork_Pricing_Text = 'Out of network';
        this.Spa_Site_PrimaryPharmacy_Indicator_Text = 'primary';
        this.Spa_Site_Providers_Text = 'Providers';
        this.Spa_Site_Mail_Order_Pharmacy_Enabled = true;
        this.Spa_PlanList_MailOrder_Text = 'Mail order';
        this.Spa_Site_Providers_Header_Text = 'Your providers';
        this.Spa_Site_Pcp_Text = 'PCP';
        this.Spa_PlanCard_Providers_InNetwork_Text = '<inNetwork> of <totalProviders> In-network';
        this.Spa_Site_Pcp_InNetwork_Text = 'PCP In-network';
        this.Spa_Site_Pcp_OutOfNetwork_Text = 'PCP Out-of-network';
        this.Spa_Providers_No_Data_Exist_Text = 'No provider data for this carrier';
        this.Spa_Providers_NoProviderNetworkAccess_Text = 'No access to provider network data';
        this.Spa_Site_Providers_Enabled = false;
        this.Spa_Npi_Filter_Enabled = false;
        this.Spa_Site_Show_Preferences_Score = false;
        this.Spa_PlanList_ShowSNPLink_Text = 'Add all Special Needs Plans (SNP)';
        this.Spa_PlanList_HideSNPLink_Text = 'Hide all Special Needs Plans (SNP)';
        this.Spa_Site_ShowSNPPlansDefault_Flag = false;
        this.Spa_PlanCard_CSNP_Indicator_Enabled = true;
        this.Spa_PlanCard_DSNP_Indicator_Enabled = true;
        this.Spa_PlanCard_ISNP_Indicator_Enabled = true;
        this.Spa_Site_ElectronicPrescription_ToolTipBody = 'Prescriptions can be written and sent to the pharmacy electronically.';
        this.Spa_Pharmacy_Added_Label = 'Pharmacy Added';
        this.Spa_AddPharmacy_YourPharmacyText = 'Your Pharmacy';
        this.Spa_Site_ElectronicPrescription_ToolTipHeader = 'Electronic prescribing';
        this.Spa_PlanCard_CSNP_Tooltip_Text = 'Chronic Condition Special Needs Plan – This plan is designed for an individual with a severe or disabling chronic condition, as specified by CMS.';
        this.Spa_PlanCard_DSNP_Tooltip_Text = 'Dual Eligible Special Needs Plan – This plan is designed for an individual eligible for both Medicare and Medicaid.';
        this.Spa_PlanCard_ISNP_Tooltip_Text = 'Institutional Special Needs Plan – This plan is designed for an individual residing in a long term care facility.';
        this.Spa_PlanCard_SNP_Indicator_Text = '<snpType> Plan';
        this.Spa_Site_SNPTools_Enabled = true;
        this.Spa_MedSupForm_DateOfBirthTooltip_Text = '';
        this.Spa_MedSupForm_EffectiveDateTooltip_Text = '';
        this.Spa_MedSupForm_GenderTooltip_Text = '';
        this.Spa_MedSupForm_TobaccoTooltip_Text = '';
        this.Spa_MedSupForm_HeightTooltip_Text = '';
        this.Spa_MedSupForm_WeightTooltip_Text = '';
        this.Spa_MedSupForm_PaymentMethodTooltip_Text = '';
        this.Spa_MedSupForm_HouseholdTooltip_Text = '';
        this.Spa_MedSupForm_PartAEffectiveDateTooltip_Text = '';
        this.Spa_MedSupForm_PartBEffectiveDateTooltip_Text = '';
        this.Spa_Site_CSNP_Label = 'Chronic condition';
        this.Spa_Site_DSNP_Label = 'Medicare and Medicaid';
        this.Spa_Site_ISNP_Label = 'Long term care';
        this.Spa_Site_ChronicDependence_SNPTooltip_Text = 'Limited to: Polyarteritis nodosa, Polymyalgia rheumatica, Polymyositis, Rheumatoid arthritis, and Systemic lupus erythematosus';
        this.Spa_Site_AutoImmune_SNPTooltip_Text = '';
        this.Spa_Site_Cancer_SNPTooltip_Text = '';
        this.Spa_Site_Cardiovascular_SNPTooltip_Text = 'Limited to: Cardiac arrhythmias, Coronary artery disease, Peripheral vascular disease, and Chronic venous thromboembolic disorder';
        this.Spa_Site_ChronicHeartFailure_SNPTooltip_Text = '';
        this.Spa_Site_Dementia_SNPTooltip_Text = '';
        this.Spa_Site_Diabetes_SNPTooltip_Text = '';
        this.Spa_Site_EndStageLiver_SNPTooltip_Text = '';
        this.Spa_Site_EndStageRenal_SNPTooltip_Text = '';
        this.Spa_Site_Hematologic_SNPTooltip_Text = 'Limited to: Aplastic anemia, Hemophilia, Immune thrombocytopenic purpura, Myelodysplatic syndrome, Sickle-cell disease (excluding sickle-cell trait), and Chronic venous thromboembolic disorder';
        this.Spa_Site_HIVAIDS_SNPTooltip_Text = '';
        this.Spa_Site_ChronicLung_SNPTooltip_Text = 'Limited to: Asthma, Chronic bronchitis, Emphysema, Pulmonary fibrosis, and Pulmonary hypertension';
        this.Spa_Site_ChronicMentalHealth_SNPTooltip_Text = 'Limited to: Bipolar disorders, Major depressive disorders, Paranoid disorder, Schizophrenia, and Schizoaffective disorder';
        this.Spa_Site_Neurologic_SNPTooltip_Text = 'Limited to: Amyotrophic lateral sclerosis (ALS), Epilepsy, Extensive paralysis (i.e., hemiplegia, quadriplegia, paraplegia, monoplegia), Huntington’s disease, Multiple sclerosis, Parkinson’s disease, Polyneuropathy, Spinal stenosis, and Stroke-related neurologic deficit';
        this.Spa_Site_Stroke_SNPTooltip_Text = '';
        this.Spa_Site_NursingHome_SNPTooltip_Text = '';
        this.Spa_Site_RequiresNursingCare_SNPTooltip_Text = '';
        this.Spa_Site_ChronicDependence_SNPLabel_Text = 'Chronic alcohol and other drug dependence';
        this.Spa_Site_AutoImmune_SNPLabel_Text = 'Autoimmune disorders';
        this.Spa_Site_Cancer_SNPLabel_Text = 'Cancer (excluding pre-cancer conditions)';
        this.Spa_Site_Cardiovascular_SNPLabel_Text = 'Cardiovascular disorders';
        this.Spa_Site_ChronicHeartFailure_SNPLabel_Text = 'Chronic heart failure';
        this.Spa_Site_Dementia_SNPLabel_Text = 'Dementia';
        this.Spa_Site_Diabetes_SNPLabel_Text = 'Diabetes mellitus';
        this.Spa_Site_EndStageLiver_SNPLabel_Text = 'End-stage liver disease';
        this.Spa_Site_EndStageRenal_SNPLabel_Text = 'End-Stage Renal Disease (ESRD) requiring dialysis (any mode of dialysis)';
        this.Spa_Site_Hematologic_SNPLabel_Text = 'Severe hematologic disorders';
        this.Spa_Site_HIVAIDS_SNPLabel_Text = 'HIV/AIDS';
        this.Spa_Site_ChronicLung_SNPLabel_Text = 'Chronic lung disorders';
        this.Spa_Site_ChronicMentalHealth_SNPLabel_Text = 'Chronic and disabling mental health conditions';
        this.Spa_Site_Neurologic_SNPLabel_Text = 'Neurologic disorders';
        this.Spa_Site_Stroke_SNPLabel_Text = 'Stroke';
        this.Spa_Site_NursingHome_SNPLabel_Text = 'Nursing home';
        this.Spa_Site_RequiresNursingCare_SNPLabel_Text = 'Require nursing care at home';
        this.Spa_PlanCard_NonMonthlyRateText = 'Your rate if you pay <paymentMethod>';
        this.Spa_PlanCard_NonMonthlyRateText_Enabled = false;
        this.Spa_MedSupForm_PaymentMethodBiMonthly_Text = 'Bi-monthly';
        this.Spa_MedSupForm_PaymentMethodMonthly_Text = 'Monthly';
        this.Spa_MedSupForm_PaymentMethodQuarterly_Text = 'Quarterly';
        this.Spa_MedSupForm_PaymentMethodSemiAnnually_Text = 'Semi-annually';
        this.Spa_MedSupForm_PaymentMethodAnnually_Text = 'Annually';
        this.Spa_MedSupForm_PaymentMethodLumpSum_Text = 'Lump sum';
        // Adding these simply so they show up in client configuration. May want to explore a way of
        // adding these to client configuration without having to add this annotation in the future.
        this.Spa_CrossSell_Confirm_Link_Text = 'Go to cart';
        this.Spa_CrossSell_Header_Text = 'Plan added to cart';
        this.Spa_Site_Digital_Pharmacy_Enabled = false;
        this.Spa_Pharmacy_Retail_Tab_Text = 'Retail';
        this.Spa_Pharmacy_Digital_Tab_Text = 'Digital';
        this.Spa_Pharmacy_Digital_Tab_Intro_Text = 'Many retail pharmacies have online options for ordering prescriptions. Similar to mail order pharmacies associated with your health plan, digital pharmacies allow you to order prescriptions online and have them delivered to your home. Inclusion in this list does not guarantee delivery to your service area.';
        this.Spa_CrossSell_Medsup_Marketing_Text = 'Adding a Medicare Supplement plan can help save money on your doctor visits and hospital stays.';
        this.Spa_Pharmacy_In_Network_Filters = [
            {
                dataKey: 'isStandard',
                displayName: '[[Spa_Site_Standard_In_Network_Text]] ([[Spa_PharmacySearch_Standard_In_Network_Tooltip_Text]])'
            },
            {
                dataKey: 'isPreferred',
                displayName: '[[Spa_Site_Preferred_In_Network_Text]] ([[Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text]])'
            }
        ];
        this.Spa_CrossSell_Medsup_Prompt_Text = 'Add a Medicare Supplement plan';
        this.Spa_CrossSell_PDP_Marketing_Text = 'Adding a Prescription Drug plan can help save money on your prescription costs.';
        this.Spa_CrossSell_PDP_Prompt_Text = 'Add a Prescription Drug plan';
        this.Spa_CrossSell_Success_Message_Text = '<planName> was added to your cart.';
        this.Spa_CrossSell_Enabled = false;
        this.Spa_ZipCodeInput_CountyLabel_Enabled = false;
        this.Spa_Filter_AdditionalSavingsHeader_Text = 'Plan Benefits';
        this.Spa_Filter_InsulinSavings_Enabled = false;
        this.Spa_Site_ViewDetailsLink_Description_Text = 'Press Enter to view plan details of ';
        this.Spa_PlanList_Tab_Show_DENTAL = false;
        this.Spa_PlanList_Tab_Show_VISION = false;
        this.Spa_PlanList_Tab_Show_HIP = false;
        this.Spa_PlanList_ShowAllMedigap_Enabled = false;
        this.Spa_PlanList_AddOn_Filter_Enabled = false;
        this.Spa_Filter_AddOn_Coverage_ToolTip_Text = '<div class="Spa_Style_H4"><b>Add-on coverage</b></div> View plans that include your selected add-on coverage options. Note that these are additional costs and not included in the base plan benefits.';
        this.Spa_Filter_Providers_ToolTip_Text = '<div class="Spa_Style_H4"><b>Your provider</b></div> View in-network plans for your selected providers.';
        this.Spa_PlanList_AddOn_Header_Text = 'Add-on coverage options';
        this.Spa_PlanList_MedSupPlanSubTypeHeader_Text = 'Plan type';
        this.Spa_PlanList_MedSupPlanSubTypePlaceholder_Text = 'Select one';
        this.Spa_PlanList_MedSupPlanSubTypeUpdate_Text = 'Update plans';
        this.Spa_Filter_MedicalDeductible_Text = 'Deductible';
        this.Spa_Filter_MedicalDeductible_ToolTip_Text = '<div class="Spa_Style_H4"><b>Deductible</b></div> The amount you pay for covered health care services before your insurance plan starts to pay.';
        this.Spa_Filter_MaximumOutOfPocketCost_Text = 'Out of pocket maximum';
        this.Spa_Filter_MaximumOutOfPocketCost_ToolTip_Text = '<div class="Spa_Style_H4"><b>Out Of Pocket Maximum</b></div> The most you have to pay for covered services in a plan year.';
        this.Spa_Filter_PharmacyDeductible_Text = 'Pharmacy deductible';
        this.Spa_Filter_PharmacyDeductible_ToolTip_Text = '<div class="Spa_Style_H4"><b>Pharmacy Deductible</b></div> The amount you pay for covered prescription drugs before your insurance plan starts to pay.';
        this.Spa_Filter_Premium_Text = 'Premium';
        this.Spa_Filter_Premium_ToolTip_Text = '<div class="Spa_Style_H4"><b>Premium</b></div> The amount you pay for your health insurance every month. In addition to your premium, you usually have to pay other costs for your health care, including a deductible, copayments, and coinsurance.';
        this.Spa_Filter_PlanBenefitsGroup_Enabled = false;
        this.Spa_PlanCard_Preferences_Detailed_Enabled = true;
        this.Spa_Site_Show_AncillaryPlanLogo = false;
        this.Spa_Display_SNP_PremiumRange_Enabled = false;
        this.Spa_SNPRange_Link_Text = 'Eligible for extra help?';
        this.Spa_Site_Default_Plan_Benefit_Filter = [
            {
                name: 'Additional Telehealth',
                value: 333,
                tooltip: 'This plan includes the option for telehealth appointments with a physician',
                enable: true
            },
            {
                name: 'Fitness Benefit',
                value: 319,
                tooltip: 'This plan includes a Fitness Benefit',
                enable: true
            },
            {
                name: 'Meal Benefit',
                value: 375,
                tooltip: 'This plan includes a Meal Benefit',
                enable: true
            },
            {
                name: 'Transportation',
                value: 36,
                tooltip: 'This plan includes a Transportation benefit',
                enable: true
            },
            {
                name: 'Part B Giveback',
                value: 388,
                tooltip: 'This plan includes Part B Giveback',
                enable: true
            }
        ];
        this.Spa_Retention_ClientDefinedPlanOptions_Enabled = false;
        this.Spa_Site_Plan_Option_One_Text = 'Option one';
        this.Spa_Site_Plan_Option_Two_Text = 'Option two';
        this.Spa_Filter_Plan_Marketing_Name_Enabled = false;
        this.Spa_MedSupForm_AllowFormWhenNoPlansAvailable_Enabled = false;
        this.Spa_PlanCard_AncillaryAddtoCart_Enabled = false;
        this.Spa_PlanCard_ShowAncillaryIcons_Enabled = false;
        this.Spa_Site_ShowDrugAlternatives_Enabled = false;
        this.Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled = false;
        this.Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text = 'There may be lower cost alternatives to your non-covered prescriptions.';
        this.Spa_PlanCard_ShowDrugAlternatives_Nudge_Text = 'Save on prescriptions';
        this.Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon = 'fa fa-solid fa-tag';
        this.Spa_Site_Preferences_Score_Enabled = false;
        this.Spa_PlanList_Tab_Text_NoPlans_HIP = "We are sorry, but we don't currently offer coverage in your area.";
        this.SPA_HIP_Rider_Benefit_Default_Dropdown_Text = 'None';
        this.Spa_Site_Days_Text = 'days';
        this.Spa_Site_Day_Text = 'day';
        this.Spa_Site_LumpSum_Text = 'Lump sum';
        this.Spa_Site_Loader_Updated_Icon_Enabled = false;
        this.Spa_Site_Plans_Loading_Text = 'Loading...';
        this.Spa_Site_Provider_ShowAllInNetworkLocations_Enabled = false;
        this.Spa_PlanCard_SupplementalBenefits_Enabled = false;
        this.Spa_PlanCard_SupplementalBenefits_List = [];
        this.Spa_RatingMethod_AttainedAge_Tooltip_Text = 'Premiums based on current age and may increase with age. Future rate increases may occur due to inflation or other factors.';
        this.Spa_RatingMethod_IssueAge_Tooltip_Text = 'Premiums based on age when coverage is first issued and will not increase on age, but rates may change due to inflation or other factors.';
        this.Spa_RatingMethod_CommunityRated_Tooltip_Text = 'Premiums are same for all within a specific location. Future rate increases may occur due to inflation or other factors, but not age.';
        this.Spa_PlanCard_Providers_OneOrMore_OutOfNetwork_Text = 'One or more locations are out of network';
        this.Spa_Providers_InNetwork_OnOtherLocations_Tooltip_Text = 'Selected location is out-of-network, however in-network locations are available.';
        this.Spa_AddHealth_ModalView1_HeadingText = 'Estimate health costs';
        this.Spa_AddHealth_ModalView1_IntroText = 'Your health status helps calculate your estimated cost. It will not affect your premiums.';
        this.Spa_AddEligibility_ModalView1_HeadingText = 'Eligibility information';
        this.Spa_AddEligibility_ModalView1_IntroText = 'Add your subsidy to see if you qualify for special needs plans which typically provide benefits not otherwise available in traditional Medicare and generally do not charge a premium.';
        this.Spa_Provider_ShowPartialIndicator_Enabled = false;
        this.Spa_Site_PlanFees_Enabled = false;
        this.Spa_PlanFees_Tooltip_Text = 'Fees';
        this.Spa_PlanFees_IncludedInPremium_Tooltip_Text = 'Included in premium';
        this.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text = 'Not included in premium';
        this.Spa_PlanCard_ShowAvailableRateFactors_Enabled = false;
        this.Spa_PlanCard_PersonalizedQuoteLabel_Text = 'Personalized quote';
        this.Spa_PlanCard_AvailableRateFactors_Data = [
            {
                key: MedSupQuestionNames.Household,
                displayName: 'Household Discount',
                ordinal: 1,
                display: true
            },
            {
                key: MedSupQuestionNames.Disability,
                displayName: 'Disability',
                ordinal: 2,
                display: true
            },
            {
                key: MedSupQuestionNames.EFTDiscount,
                displayName: 'EFT Discount',
                ordinal: 3,
                display: true
            },
            {
                key: MedSupQuestionNames.Tobacco,
                displayName: 'Tobacco',
                ordinal: 4,
                display: true
            }
        ];
        this.Spa_PlanCard_Show_PlanId_Enabled = false;
        this.Spa_PlanList_Show_DSNP_EligibleMessage = false;
        this.Spa_PlanList_DSNP_EligibleMessage_Header_Text = 'Receiving help from Medicaid could qualify for a Dual Eligible Special Needs Plan.';
        this.Spa_PlanList_DSNP_EligibleMessage_Info_Text = 'View plans labeled DSNP to review plan benefits.';
        this.Spa_DSNP_Eligibility_LearnMore_Text = 'Learn more';
        this.Spa_DSNP_Eligibility_Tooltip_Text = 'Dual eligible Special Needs Plans (DSNP) are for people who receive both Medicare and Medicaid (dual eligible). Premium depends on your level of Extra Help. You must continue to pay your Medicare Part B premium, unless it is covered through your State Medicaid Program. If you receive Medicaid cost-sharing assistance, you may pay nothing for medical deductibles, copayments, and coinsurance.';
        this.Spa_Site_TotalSiteCountsPPC_Enabled = false;
        this.Spa_Site_TotalSiteCounts_Text = 'Licensed to sell {{[plans.totalSiteCarrierCount]}} carrier organizations with {{[plans.totalSitePlanCount]}} plans for [[PlanYear]]';
        this.Spa_PlanCard_PlanId_Text = 'Plan ID';
        this.Spa_Profile_StateEligibilityCheck_Enabled = false;
        this.Spa_GettingStarted_MedicaidCode_Text = '<medicaidCode> in <state> <checkedDate>';
        this.Spa_PlanCard_DSNPCodeDisplay_Enabled = false;
        this.Spa_Filter_DSNPMedicaidCodes_Enabled = false;
        this.Spa_DSNPEligibility_FilterCodeMessage_Enabled = false;
        this.Spa_DSNPEligibility_FilterCodeMessage_Text = false;
        this.Spa_Site_Available_Text = 'Available';
        this.Spa_Site_NotAvailable_Text = 'Not Available';
        this.Spa_PlanCard_Providers_ViewButton_Text = 'View providers';
        this.Spa_PlanCard_Prescriptions_ViewButton_Text = 'View prescriptions';
        this.Spa_PlanCard_SupplementalBenefitsHighlight_Text = 'Highlights';
        this.Spa_Plan_Details_Preferences_Text = 'Preferences';
        this.Spa_PlanCard_ViewMoreDetails_ButtonText = 'View more details';
        this.Spa_PlanCard_HideDetails_ButtonText = 'Hide details';
        this.Spa_PlanCard_NewDesign_Enabled = false;
        this.Spa_PlanCard_ViewAllPlanDetails_ButtonText = 'View all plan details';
        this.Spa_PlanCard_ShareThisPlan_ButtonText = 'Share this plan';
        this.Spa_PlanCard_ViewCostDetails_ButtonText = 'View cost details';
        this.Spa_Site_Close = 'Close';
        this.Spa_PlanList_FilterModal_Enabled = false;
        this.Spa_PlanFilters_Modal_Button_Label = 'Filters';
        this.Spa_PlanCard_PlanBenefitHighlight_Items = [
            {
                name: 'Specialist Office Visit'
            },
            {
                name: 'Inpatient Hospital Care'
            },
            {
                name: 'Total est. cost'
            }
        ];
        this.Spa_PlanCard_PlanBenefitHighlights_Text = 'Plan benefit highlights';
        this.Spa_Site_RiderDetails_Show = false;
        this.Spa_Plan_Details_ViewRiderDetails_Text = 'View details';
        this.Spa_Plan_Details_HideRiderDetails_Text = 'Hide details';
        this.Spa_ShoppingCart_IncludedRider_Text = 'Included';
        this.Spa_Site_ValueBasedCare_Agreement_Enabled = false;
        this.Spa_Site_ValueBasedCare_Agreement_Label = 'Value Based Care agreement';
        this.Spa_Site_ValueBasedCare_Agreement_Tooltip = 'A Value Based Care agreement exists between your primary care provider and this carrier. See plan details for more information.';
        this.Spa_Plan_Details_WaiverStateRider_Tooltips = [
            {
                id: 'Combined Rider',
                body: 'This optional plan benefit is a combination of riders for one price.'
            },
            {
                id: 'Part A Deductible',
                body: `"Part A Deductible" covers the amount that you must pay for inpatient hospital stays before Medicare begins to pay.`
            },
            {
                id: 'Part B Deductible',
                body: `"Part B Deductible" covers the amount that you must pay for Medicare-approved
           Part B medical services before Medicare Part B begins to pay.`
            },
            {
                id: 'Part B Excess',
                body: `"Part B Excess Charges" covers the  difference between the Medicare eligible charge and the amount charged by
          the provider which shall be no greater than the actual charge or the limited charge allowed by Medicare, whichever is less.`
            },
            {
                id: 'Preventive Care',
                body: `"Preventive Care"  pays up to $120 a year for covered preventive screening
           test and services and an annual physical examination.`
            },
            {
                id: 'Usual and Customary Fees',
                body: `"Usual and Customary Charges Fees" covers the difference between the Medicare eligible charge and the amount charged by
           the provider which shall be no greater than the actual charge or the limited charge allowed by Medicare, whichever is less.`
            },
            {
                id: 'Part B Excess Charges',
                body: `Part B Excess Charges" covers the  difference between the Medicare eligible charge
        and the amount charged by the provider which shall be no greater than the actual charge or
        the limited charge allowed by Medicare, whichever is less.`
            },
            {
                id: 'Additional Home Health Care',
                body: ` "Additional Home Health" extends home care visits up to 365 visits per policy year.`
            },
            {
                id: 'Foreign Travel Emergency',
                body: ` "Foreign Travel Emergency" covers at least 80% of eligible expenses associated with emergency
          medical care received outside the U.S.A. beginning the first 60 days of a trip up to a
          lifetime maximum of $50,000 (after a  deductible of $250).`
            },
            {
                id: 'Co-Pay Rider',
                body: ` "Co-Pay Rider" pays the Part B coinsurance subject to a copayment or coinsurance of no more
          than $20 per office visit and no more than $50 per emergency room visit that is in
          addition to the Medicare Part B medical deductible  and in addition to out-pocket maximums.`
            },
            {
                id: '50% Part A Deductible',
                body: `"50% of Part A Deductible" pays 50% of the inpatient deductible for qualifying hospital stays.`
            },
            {
                id: 'Part B Copayment or Coinsurance',
                body: `"Part B Copayment or Coinsurance" covers the amount you must pay as your share of the cost for medical services.
          Copayment is usually a set amount whereas coinsurance is a percentage.`
            }
        ];
        this.Spa_Plandetails_Costs_MAPD = [
            {
                title: PlanDetailsCostLabels.DRUG_COST,
                subText: 'Based on <totalDrugs> drugs',
                label: 'Annually Est Drug Cost',
                label2: 'Est Drug Cost',
                duration: 'annually',
                duration2: 'partial annually'
            },
            {
                title: PlanDetailsCostLabels.HEALTH_COST,
                subText: 'Estimated medical costs based on age <ageRange> and <healthStatus>.',
                label: 'Annually Health Cost',
                label2: 'Health Cost',
                duration: 'annually',
                duration2: 'partial annually'
            },
            {
                title: PlanDetailsCostLabels.TOTAL_ESTIMATED_COST,
                subText: 'Based on medical and drug costs.',
                label: 'Total est annual cost',
                label2: 'Total est cost',
                duration: 'annually',
                duration2: 'partial annually'
            }
        ];
        this.Spa_Plandetails_Costs_MA = [
            {
                title: PlanDetailsCostLabels.HEALTH_COST,
                subText: 'Estimated medical costs based on age <ageRange> and <healthStatus>.',
                label: 'Annually Health Cost',
                label2: 'Health Cost',
                duration: 'annually',
                duration2: 'partial annually'
            },
            {
                title: PlanDetailsCostLabels.TOTAL_ESTIMATED_COST,
                subText: 'Based on medical and drug costs.',
                label: 'Total est annual cost',
                label2: 'Total est cost',
                duration: 'annually',
                duration2: 'partial annually'
            }
        ];
        this.Spa_Plandetails_Costs_MEDIGAP = [
            {
                title: PlanDetailsCostLabels.HEALTH_COST,
                subText: 'Estimated medical costs based on age <ageRange> and <healthStatus>.',
                label: 'Health Cost',
                duration: 'annually'
            },
            {
                title: PlanDetailsCostLabels.TOTAL_ESTIMATED_COST,
                subText: 'Based on medical costs.',
                label: 'Total est annual cost',
                duration: 'annually'
            }
        ];
        this.Spa_Plandetails_Costs_PDP = [
            {
                title: PlanDetailsCostLabels.DRUG_COST,
                subText: 'Based on <totalDrugs> drugs',
                label: 'Annually Est Drug Cost',
                label2: 'Est Drug Cost',
                duration: 'annually',
                duration2: 'partial annually'
            },
            {
                title: PlanDetailsCostLabels.TOTAL_ESTIMATED_COST,
                subText: 'Based on medical and drug costs.',
                label: 'Total est annual cost',
                label2: 'Total est cost',
                duration: 'annually',
                duration2: 'partial annually'
            }
        ];
        this.Spa_PlanDetails_Costs_DENTAL = [
            {
                title: PlanDetailsCostLabels.PLAN_FEES,
                label: 'Fees',
                subText: '',
                duration: ''
            }
        ];
        this.Spa_PlanDetails_Costs_VISION = [
            {
                title: PlanDetailsCostLabels.PLAN_FEES,
                label: 'Fees',
                subText: '',
                duration: ''
            }
        ];
        this.Spa_StarRating_Label_Text = 'Medicare star rating';
        this.Spa_StarRating_Filter_Options = [
            { label: '5 stars', value: 5, disabled: false, tooltip: '' },
            { label: '4 stars', value: 4, disabled: false, tooltip: '' },
            { label: '3 stars', value: 3, disabled: false, tooltip: '' }
        ];
        this.Spa_PlanFilters_Sort_Options_For_Modal = [
            {
                name: this.Spa_Filter_SNPBaseTypes_Label,
                ordinal: 1
            },
            {
                name: this.Spa_Filter_LicensingHeader_Text,
                ordinal: 2
            },
            {
                name: this.Spa_Filter_MedicalDeductible_Text,
                ordinal: 3
            },
            {
                name: this.Spa_Filter_MaximumOutOfPocketCost_Text,
                ordinal: 4
            },
            {
                name: this.Spa_Filter_PharmacyDeductible_Text,
                ordinal: 5
            },
            {
                name: this.Spa_Filter_Premium_Text,
                ordinal: 6
            },
            {
                name: this.Spa_PlanList_AddOn_Header_Text,
                ordinal: 7
            },
            {
                name: this.Spa_Filter_AdditionalSavingsHeader_Text,
                ordinal: 8
            },
            {
                name: this.Spa_PlanFilters_CarrierLabel_Text,
                ordinal: 9
            },
            {
                name: this.Spa_PlanFilters_SubType_Label,
                ordinal: 10
            },
            {
                name: this.Spa_Site_PlanType_Header,
                ordinal: 11
            },
            {
                name: this.Spa_Site_Providers_Header_Text,
                ordinal: 12
            },
            {
                name: this.Spa_PlanList_MedSupPlanSubTypeHeader_Text,
                ordinal: 13
            },
            {
                name: this.Spa_StarRating_Label_Text,
                ordinal: 14
            }
        ];
        this.Spa_PharmacySearch_Back_Button = 'Back';
        this.Spa_AddPharmacy_ModalView1_IntroText = 'Add your pharmacy to get an estimated drug cost and compare across plans.';
        this.Spa_AddPharmacy_ModalView1_HeadingText = 'Add Pharmacies';
        this.Spa_AddPharmacy_ModalView2_IntroText = 'Drug costs vary based on the pharmacy you choose. Select multiple pharmacies to compare estimated drug costs for all available plans.';
        this.Spa_AddPharmacy_ModalView2_HeadingText = '';
        this.Spa_PharmacySearch_Pagination_ItemsPerPage = 10;
        this.Spa_PharmacySearch_Pagination_Enabled = false;
        this.Spa_PharmacySearch_Pagination_View_Text = 'Viewing <startPageItem> - <endPageItem> of <totalPages>';
        this.Spa_Site_Standard_In_Network_Text = 'Standard In-network';
        this.Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text = 'Pharmacies that are willing to give the plans a larger discount than other pharmacies.';
        this.Spa_PharmacySearch_Standard_In_Network_Tooltip_Text = 'These pharmacies may charge a higher copayment or co-insurance for filling your prescription.';
        this.Spa_Pharmacy_Alt_View_Not_Found_Header_Text = 'No pharmacy results';
        this.Spa_Pharmacy_Alt_View_Not_Found_Body_Text = 'There are no pharmacies available in this location. Try zooming out or entering a new ZIP code.';
        this.Spa_Site_Preferred_In_Network_Text = 'Preferred In-network';
        this.Spa_PharmacyName_Text = 'Pharmacy name';
        this.Spa_Add_Pharmacy_Button = 'Add pharmacy';
        this.Spa_PreferenceBanner_Enabled = false;
        this.Spa_PreferenceBanner_Header_Text = 'Add details to help decide which plan is best.';
        this.Spa_PreferenceBanner_View_ButtonText = 'View the preferences bar';
        this.Spa_PreferenceBanner_Hide_ButtonText = 'Hide the preferences bar';
        this.Spa_Site_View = 'View';
        this.Spa_PreferenceBanner_Added_ButtonText = 'added';
        this.Spa_Site_Close_Modal = 'Close';
        this.Spa_PharmacyName_HintText = 'Pharmacy name';
        this.Spa_GuidedHelp_Health_AgeQuestion_Text = 'How old are you?';
        this.Spa_Site_Health_Slider_Label_Text = 'Select health status range';
        this.Spa_HealthCosts_Body_Text = 'Would you like to estimate your medical costs?';
        this.Spa_Site_HealthCosts_Save_Failed_Text = 'Server error. Please try again.';
        this.Spa_Site_HealthCosts_Customization_Enabled = true;
        this.Spa_Pharmacy_Limit = 25;
        this.Spa_Provider_Limit = 25;
        this.Spa_PharmacyMap_Default_Zoom = 11;
        this.Spa_ProviderMap_Default_Zoom = 11;
        this.Spa_PharmacyMap_Max_Zoom = 28;
        this.Spa_PharmacyMap_Min_Zoom = 4;
        this.Spa_ProviderMap_Max_Zoom = 28;
        this.Spa_ProviderMap_Min_Zoom = 4;
        this.Spa_Site_Maximum_Pharmacy_Count = 3;
        this.Spa_Site_Set_Primary_Pharmacy_Link_Text = 'Set as primary pharmacy';
        this.Spa_Site_Primary_Pharmacy_Text = 'Primary Pharmacy';
        this.Spa_Site_Primary_Pharmacy_Icon = 'fas fa-star';
        this.Spa_Site_Primary_Pharmacy_Icon_Color = '#b07d0f';
        this.Spa_PharmacySearch_PageHeader_Text = 'Pharmacy';
        this.Spa_PharmacySearch_Intro_Text = 'Find your pharmacy to help us estimate costs and show you which plans include in-network pharmacy discounts.';
        this.Spa_PharmacySearch_MultiPharmacy_Intro_Text = 'Add one or more pharmacies to help us estimate costs and show you which plans include in-network pharmacy discounts.';
        this.Spa_Site_Pharmacy_Limit_Error_Message = 'You can only add up to <maxPharmacyCount> pharmacies';
        this.Spa_Multi_Providers_Body_Text = `Add your providers to see which plans cover your doctor, specialist, urgent care or hospital. Choose the exact location for your provider because network status can vary for a provider based on the location.`;
        this.Spa_Site_AddPharmacy_YourMultiPharmacyText = 'Your Pharmacies';
        this.Spa_OtherPreferences_PageCount_Text = 'Page <currentPage> of <lastPage>';
        this.Spa_GuidedHelp_OtherPreferences_EnterZip_Text = 'Search';
        this.Spa_GuidedHelp_OtherPreferences_ProvideZip_Text = 'Please enter your zip code to see other preferences.';
        this.Spa_GuidedHelp_Health_SliderHeader1_Text = 'Generally healthy test';
        this.Spa_GuidedHelp_Health_SliderHeader2_Text = 'Some health needs';
        this.Spa_GuidedHelp_Health_SliderHeader3_Text = 'Significant health needs';
        this.Spa_GuidedHelp_Health_SliderBody1 = 'No major illnesses <br /> Less than 2 prescriptions for an illness <br /> Less than 2 visits to primary care';
        this.Spa_GuidedHelp_Health_SliderBody2 = 'Ongoing condition like diabetes <br /> Regular prescription needs <br /> 1 or more visits to a specialist';
        this.Spa_GuidedHelp_Health_SliderBody3 = 'Multiple prescriptions <br /> Managing a serious condition <br /> Multiple visits to specialists';
        this.Spa_HealthCosts_Benefits_Body_Text = 'Decide how often you might use these benefits annually to help estimate medical costs for each plan. test';
        this.Spa_Site_HealthCosts_Benefits_Table_Header = 'Benefit';
        this.Spa_Site_HealthCosts_Usage_Table_Header = 'Visits/Uses';
        this.Spa_Site_HealthCosts_Days_Table_Header = 'Total days';
        this.Spa_Site_HealthCosts_Restore_Defaults_Text = 'Restore defaults';
        this.Spa_Site_HealthCosts_Update_Answers_Text = 'Update answers';
        this.Spa_Site_HealthCosts_Save_Answers_Text = 'Save';
        this.Spa_Site_HealthCosts_Save_Success_Text = 'Saved';
        this.Spa_DrugSearch_Content_Section_Text = 'We defaulted the most common dosage so you have a better idea of what you might take.';
        this.Spa_DrugSearch_Dosage_Header = 'Select dose and form';
        this.Spa_DrugSearch_Frequency_Header = 'Enter quantity and frequency';
        this.Spa_DrugSearch_Package_Header = 'Select package';
        this.Spa_DrugSearch_Add_Button = 'Add';
        this.Spa_DrugSearch_Cancel_Button = 'Cancel';
        this.Spa_DrugSearch_Back_Button = 'Back';
        this.Spa_DrugSearch_EditDrug_Button = 'Edit Drug';
        this.Spa_DrugSearch_Quantity_Max_Limit = 1000;
        this.Spa_DrugSearch_Cabinet_Limit = 25;
        this.Spa_DrugSearch_MaxCount_Error_Message = `You can only add up to ${this.Spa_DrugSearch_Cabinet_Limit} drugs`;
        this.Spa_DrugSearch_Quantity_Error_Message = `
  Please provide a number between 0 and ${this.Spa_DrugSearch_Quantity_Max_Limit}`;
        this.Spa_DrugSearch_Label_Text = 'Drug Search';
        this.Spa_DrugSearch_InCabinetError_Text = 'This drug and dosage already exists in your list.';
        this.Spa_DrugSearch_Medicine_Header = 'Your prescriptions';
        this.Spa_DrugSearch_GenericOption_Icon = 'fas fa-tag';
        this.Spa_Site_Show_GenericDrugOption = true;
        this.Spa_DrugSearch_GenericOption_Question = 'Would you like to use a Generic (<genericDrugName>) for <brandName>';
        this.Spa_DrugSearch_GenericOption_Info = `
    According to the FDA, this generic drug has the same quality, strength, safety and active ingredient as the brand name drug.
    Generic drugs are usually covered by part D plans and are generally a lower price.`;
        this.Spa_DrugSearch_GenericOptions = [
            { label: 'Yes', value: true },
            { label: 'No', value: false }
        ];
        this.Spa_DrugSearch_CheckDrugCoverageButton_Text = 'See if this drug is covered';
        this.Spa_DrugSearch_GenericOption_Default_Selection = false;
        this.Spa_DrugListCard_HideCosts_Flag = false;
        this.Spa_DrugSearch_Hint_Text = 'search for prescription';
        this.Spa_DrugSearch_Intro_Text = 'This will allow you to see how each plan provides coverage for your prescriptions.';
        this.Spa_DrugSearch_PageHeader_Text = 'Prescriptions';
        this.Spa_DrugSearch_Frequency_ListBox_Label = 'Choose any one the frequency from list of options available';
        this.Spa_Site_Enable_BlueButton = true;
        this.Spa_Site_OrText = 'OR';
        this.Spa_BlueButton_StartAddDrug_Text = 'Start adding drugs';
        this.Spa_BlueButton_MyMedicare_Connect_Text = `<div class="Spa_Style_H4 mb-1">Download your prescription list from myMedicare.gov.</div>
    <p class="Spa_Style_Primary_Color Spa_Style_Paragraph mb-0">The easy and secure way to download all current prescriptions.</p>`;
        this.Spa_BlueButton_MyMedicare_Button = 'MyMedicare.gov';
        this.Spa_Site_EmailAddress_Text = 'Email address';
        this.Spa_Profile_EmailRequired_Error = 'Please provide email address';
        this.Spa_Profile_EmailInvalid_Error = 'Please provide a valid email address';
        this.Spa_Site_SendEmailButton_Text = 'Send email';
        this.Spa_BlueButton_Modal_Header = 'You are leaving site';
        this.Spa_BlueButton_Modal_Content = `<p class="Spa_Style_Paragraph">Are you sure you want to continue to login to Mymedicare.gov?</p>
    <p class="Spa_Style_Paragraph">Connecture,Inc. is a trusted entity of Healthcare co. By allowing Connecture, Inc access to
    your drug list, you will be able to download your drugs to our site and be able to find a plan that covers them that
    much quicker.</p><p class="Spa_Style_Paragraph">Review Connecture's <a class="Spa_Style_Link" href="">privacy policy</a>
    and <a class="Spa_Style_Link" href="">terms and conditions</a> relating to the download of the prescriptions.</p>`;
        this.Spa_BlueButton_Success_Text = 'Prescriptions shared successully';
        this.Spa_BlueButton_Download_Text = 'Prescriptions last downloaded on ';
        this.Spa_BlueButton_Success_Message = ' Prescriptions last downloaded on';
        this.Spa_BlueButton_EmailSentToStatus_Text = `Email sent to {{[member.profile.emailAddress]}} on {{[member.blueButtonInfo.updateDate]}} `;
        this.Spa_BlueButton_Issue_Loading_Text = 'Issue loading prescriptions. Please try again.';
        this.Spa_BlueButton_Beneficiary_Denied_Text = 'Beneficiary denied access.';
        this.Spa_BlueButton_Error_Loading_Text = 'Unable to load latest prescriptions.';
        this.Spa_BlueButton_Beneficiary_Email_Details = 'You may need to email the beneficiary again to update their login information.';
        this.Spa_BlueButton_ImportLatestPrescription_Button_Text = 'Import latest prescriptions';
        this.Spa_BlueButton_ImportLatestPrescription_Error_Text = 'Unable to import latest prescriptions. Try again.';
        this.Spa_BlueButton_AccessDenied_Error_Text = 'Access denied. We are unable to load prescriptions';
        this.Spa_BlueButton_ClaimData_Loading_Error_Text = 'There was an issue loading your prescriptions. Please try again later';
        this.Spa_Drugs_UseCMSDrugFlag_Enabled = true;
        this.Spa_AddPrescriptions_ModalView1_HeadingText = 'Add prescriptions';
        this.Spa_AddPrescriptions_ModalView1_IntroText = 'Add your prescriptions to see how each plan provides coverage.';
        this.Spa_AddPrescriptions_ModalView2_HeadingText = '';
        this.Spa_AddPrescriptions_ModalView2_IntroText = '';
        this.Spa_DrugSearch_Text = 'Search for a prescription';
        this.Spa_DrugSearch_Frequency_List = [
            { label: "per month" /* FrequencyLabel.Month */, value: 30 /* FrequencyValue.Month */ },
            { label: "per two months" /* FrequencyLabel.TwoMonths */, value: 60 /* FrequencyValue.TwoMonths */ },
            { label: "per three months" /* FrequencyLabel.ThreeMonths */, value: 90 /* FrequencyValue.ThreeMonths */ },
            { label: "per six months" /* FrequencyLabel.SixMonths */, value: 180 /* FrequencyValue.SixMonths */ },
            { label: "per year" /* FrequencyLabel.PerYear */, value: 365 /* FrequencyValue.PerYear */ }
        ];
        this.Spa_GettingStarted_ShowSubsidyAccordion_Flag = true;
        this.Spa_GuidedHelp_OptionalLabel_Text = '(Optional)';
        this.Spa_GettingStarted_SubsidyHeader_Text = 'Do you receive extra help with paying for your prescription drugs?';
        this.Spa_Site_Providers_Body_Text = `See which plans cover your doctor, specialist, urgent care or hospital. Reference the plan's Medical Provider Directory to see up-to-date network information.`;
        this.Spa_Provider_Add_Text = 'Add Provider';
        this.Spa_Provider_Added_Text = 'Provider added';
        this.Spa_Provider_RemoveProvider_Text = 'Remove provider';
        this.Spa_Provider_YourProvider_Text = 'My providers';
        this.Spa_Provider_Set_Primary_Care_Provider_Text = 'Set as primary care provider';
        this.Spa_Provider_Primary_Care_Provider_Text = 'Primary care provider';
        this.Spa_Site_ZipCodeInput_ZipCodeLabel = 'Zip code';
        this.Spa_Site_ZipCodeInput_ZipCodeError = 'Zip code is invalid';
        this.Spa_Providers_Filter_Enabled = false;
        this.Spa_Group_Provider_Add_Text = 'Add';
        this.Spa_Group_Provider_Added_Text = 'Added';
        this.Spa_ZipCodeInput_CountyLabel_Text = 'County';
        this.Spa_Site_Add = 'Add';
        this.Spa_Site_Cancel = 'Cancel';
        this.Spa_Select_Single_Provider_For_Multi_Address_Enabled = false;
        this.Spa_Select_Provider_Location_Text = 'Select the provider location';
        this.Spa_Provider_Exists_Text = 'You may only select one location for each provider';
        this.Spa_Provider_Multiple_Location_Text = 'This provider has multiple locations which may give different insurance information.';
        this.Spa_Plan_Providers_Locations_Link_Text = 'locations';
        this.Spa_Site_ValueBasedCare_Enabled = true;
        this.Spa_Site_ValueBasedCare_Icon = 'fas fa-briefcase-medical';
        this.Spa_Site_ValueBasedCare_Text = 'Value based care';
        this.Spa_Provider_Search_Filter_General_Practice_Options = [
            { display: 'Yes', value: true },
            { display: 'No', value: false }
        ];
        this.Spa_Provider_Search_General_Practice_Label_Text = 'General practice';
        this.Spa_Provider_Search_General_Practice_Tooltip_Text = 'General practitioners treat patients of all ages, but do not typically specialize in a particular area. They may treat your medical condition or refer you to a specialist.';
        this.Spa_Provider_Search_Filter_General_Practice_Option_Enabled = false;
        this.Spa_Provider_Search_ShowSingleProviderInList_Enabled = false;
        this.Spa_Site_Edit_Text = 'Edit';
        this.Spa_Site_Update_Text = 'Update';
        this.Spa_Provider_ShowEditLink_Enabled = false;
        this.Spa_ValueBasedCare_Available_Text = '<i class="fas fa-solid fa-info-circle"></i> Value Based Care providers may be available in your area';
        this.Spa_ValueBasedCare_LearnMore_Link = 'https://www.cms.gov/priorities/innovation-center/value-based-care-spotlight';
        this.Spa_ValueBasedCare_LearnMore_Text = 'Learn more';
        this.Spa_ValueBasedCare_LearnMoreLink2_Enabled = false;
        this.Spa_ValueBasedCare_Toggle_Label = 'Search Value Based Providers';
        this.Spa_ValueBasedCare_Toggle_ToolTip_Text = '';
        this.Spa_ValueBasedCare_Toggle_Enabled = false;
        this.Spa_Provider_Search_Filter_ValueBasedCare_Options = [
            { display: 'Yes', value: true },
            { display: 'No', value: false }
        ];
        this.Spa_Provider_New_Patient_Toggle_Enabled = false;
        this.Spa_Provider_New_Patient_Toggle_Label = 'Are you a new patient for this provider?';
        this.Spa_Provider_New_Patient_Options = [
            { display: 'Yes', value: 'yes' },
            { display: 'No', value: 'no' }
        ];
        this.Spa_Primary_Care_Provider_Toggle_Enabled = false;
        this.Spa_Primary_Care_Provider_Toggle_Label = 'Is this your primary care physician';
        this.Spa_Primary_Care_Provider_Options = [
            { display: 'Yes', value: 'yes' },
            { display: 'No', value: 'no' }
        ];
        this.Spa_New_Patient_For_Provider_Text = 'New Patient';
        this.Spa_Existing_Patient_For_Provider_Text = 'Existing patient';
        this.Spa_Provider_ValueBasedCare_Name_Filter_Enabled = false;
        this.Spa_Provider_ValueBasedCare_Name_Filter_Label = 'Participating Value Based Care organizations in this area';
        this.Spa_Selected_Provider_Options_Enabled = false;
        this.Spa_Site_Remove_Text = 'Remove';
        this.Spa_Site_SelectAll_Text = 'Select all';
        this.Spa_ProviderName_Text = 'Provider name';
        this.Spa_ProviderName_HintText = 'Provider name';
        this.Spa_Site_SearchButton_Text = 'Search';
        this.Spa_ProviderSearch_Pagination_ItemsPerPage = 10;
        this.Spa_ProviderSearch_Pagination_Enabled = false;
        this.Spa_ProviderSearch_Pagination_View_Text = 'Viewing <startPageItem> - <endPageItem> of <totalPages>';
        this.Spa_Provider_Alt_View_Not_Found_Header_Text = 'No provider results';
        this.Spa_Provider_Alt_View_Not_Found_Body_Text = 'There are no providers available in this location. Try zooming out or entering a new ZIP code.';
        this.Spa_Provider_Add_Maximum_Limit_Message = 'You can only add up to <maxCount> providers';
        this.Spa_Providers_Filter_Individuals_Text = 'Doctors and other professionals';
        this.Spa_Providers_Filter_Facilties_Text = 'Facilities (hospitals, clinics and urgent care)';
        this.Spa_ValueBasedCare_Filter_Text = 'Only show Value Based Care providers';
        this.Spa_Site_ValueBasedCare_Filter_Enabled = true;
        this.Spa_ValueBasedCare_Filter_Checked = false;
        this.Spa_ValueBasedCare_LearnMoreLink_Enabled = true;
        this.Spa_Providers_Back_Button = 'Back';
        this.Spa_AddProviders_ModalProviderSearchView_HeadingText = 'Add providers';
        this.Spa_AddProviders_ModalProviderSearchView_IntroText = 'See which plans cover your doctor, specialist, urgent care or hospital.';
        this.Spa_AddProviders_ModalProviderMapView_HeadingText = '';
        this.Spa_AddProviders_ModalProviderMapView_IntroText = 'Choose the exact location for your provider. Network status can vary for a provider based on the location.';
        this.Spa_AddProviders_ModalProviderLocationView_HeadingText = '';
        this.Spa_AddProviders_ModalProviderLocationView_IntroText = 'If you see your provider at multiple locations, add all the locations at which you see them. Network status can vary for a provider based on the location.';
        this.Spa_PreferenceBanner_DisplayButtons_JSON = [
            {
                sectionType: PreferenceBannerSectionType.PROVIDERS,
                sectionTitle: 'Providers',
                display: false,
                buttonText: 'Add providers',
                order: 1
            },
            {
                sectionType: PreferenceBannerSectionType.PHARMACY,
                sectionTitle: 'Pharmacies',
                display: false,
                buttonText: 'Add pharmacies',
                order: 2
            },
            {
                sectionType: PreferenceBannerSectionType.PRESCRIPTIONS,
                sectionTitle: 'Prescriptions',
                display: false,
                buttonText: 'Add prescriptions',
                order: 3
            },
            {
                sectionType: PreferenceBannerSectionType.ELIGIBILITY,
                sectionTitle: 'Eligibility',
                display: false,
                buttonText: 'Add eligibility',
                order: 4
            },
            {
                sectionType: PreferenceBannerSectionType.HEALTH,
                sectionTitle: 'Health',
                display: false,
                buttonText: 'Add health',
                order: 5
            }
        ];
        // #endregion
        this.guaranteedIssueOptions = [];
        this.tabs = [];
        this.subscriptions = new Subscription();
        this.sortPrimaryKey = SortPrimaryKey;
        this.snpVisibility = true;
        this.siteType = SiteType;
        this.planTypeAbbreviation = PlanTypeAbbreviation;
        this.productType = ProductType;
        this.cSNPPlansCount = 0;
        this.dSNPPlansCount = 0;
        this.iSNPPlansCount = 0;
        this.selectedHospitalIndemnityPlans = [];
        this.medicineCabinet = [];
        this.quoteHintText = '';
        this.nonCoveredPlanTabMap = {};
        this.showSelectPlanQuote = false;
        this.subsidies = SubsidySelected;
        this.totalCountsText = '';
        this.setDefaultFilter = true;
        this.comboPlans = COMBO_PLANS;
        this.DEFAULT_VISIBLE_TABS = 10;
        this._visiblePlanIndex$ = new BehaviorSubject(5);
        this.visiblePlanIndex$ = this._visiblePlanIndex$.asObservable();
        this.trackPlanListInfoOnPageLoadOnce = false;
        this.activeTabOverrideSelectionComplete$ = new BehaviorSubject(false);
        this._isFirstAppearsEditZipCodeModal$ = new BehaviorSubject(false);
        this.isFirstAppearsEditZipCodeModal$ = this._isFirstAppearsEditZipCodeModal$.asObservable();
        this.arePlansOrShortPlansLoading$ = this.planListFacade.getArePlansOrShortPlansLoading$();
        this.trackingFilterList$ = new BehaviorSubject([]);
        this.fetchAllPlans = () => {
            this.plansService.updatePUFPlanSetting(true);
            this.plansService.updateNonLicensedPlanSetting(true);
            this.plansService.setAllPlansDirty(true);
            this.fetchPlans();
            this.analyticsService.googleDataLayerTags = this.getNonLicensedPlanTags();
        };
        this.zipCode$ = this.planListFacade.getZipCode$();
        this.fipsCode$ = this.planListFacade.getFipsCode$();
        this.activeTabType$ = this.planListFacade.getActiveTabType$();
        this.storeFilterGroups$ = this.planListFacade.getFilterGroups$();
        this.defaultTabType$ = this.planListFacade.getDefaultTabType$();
        this.medSupQuestions$ = this.planListFacade.getMedSupQuestions$();
        this.hasMedSupAnswers$ = this.planListFacade.getHasMedSupAnswers$();
        this.hasAncillaryAnswers$ = this.planListFacade.getHasAncillaryAnswers$();
        this.hasHospitalIndemnityAnswers$ = this.hospitalIndemnityFormFacade.getHasHospitalIndemnityAnswers$();
        this.hospitalIndemnityAnswers$ = this.hospitalIndemnityFormFacade.getHospitalIndemnityAnswers$();
        this.medSupStateIsLoading$ = this.planListFacade.getMedSupStateIsLoading$();
        this.compareGroups$ = this.planListFacade.getCompareGroups$();
        this.quoteGroups$ = this.planListFacade.getQuoteGroups$();
        this.selectedPharmacies$ = this.guidedHelpService.getSelectedPharmacies$();
    }
    onDocumentClick(event) {
        const clickedInside = event.target.closest('.filter-modal');
        if (!clickedInside && this.filterPopupOpen) {
            this.filterPopupOpen = false;
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_FILTERS_MODAL_CANCEL);
        }
    }
    async ngOnInit() {
        super.ngOnInit();
        this.spinnerService.show(SpinnerEvent.PLANS_LOADING);
        this.environment = EnvironmentService.getEnvironment();
        this.initTabs();
        this.planListContext.setTabs(this.tabs);
        this.editLinkText = this.getEditLinkText();
        this.subsidyLabelText = this.getSubsidyLabelText();
        this.subsidySelected = this.demographicService.getSubsidySelected();
        this.googleTagManagerNotApplicableText = this.analyticsService.getGoogleTagManagerNotApplicableText();
        this.isRetentionView = this.siteService.isRetentionView();
        this.isQuotingSite = this.siteService.isQuotingSite();
        this.memberHasOptionsDefined = this.planFacade.memberHasOptionsDefined();
        this.isPlanYearUpdateModalEnabled = this.planListFacade.isPlanYearUpdateModalEnabled(this.widgetName);
        this.prescriptionInputProps = this.getPrescriptionInputProps();
        this.providerInputProps = this.getProviderInputProps();
        this.pharmacyInputProps = this.getPharmacyInputProps();
        await this.planFacade.setDefaultEffectiveDate();
        this.isLiveEdit = this.isLiveEditMode();
        if (this.isLiveEdit) {
            this.planListFacade.updateDefaultTabForLiveEdit();
            this.planFacade.getLiveEditPlans(this.widgetName);
        }
        else {
            const activeTabType = this.planListFacade.getActiveTabType();
            const activeTabAbbreviation = this.plansService.getActivePlanTypeAbbreviation(activeTabType, this.tabs);
            // Ensures to check the active tab's plan count to select a tab with coverage
            this.plansService.setActiveTabPlanCountCheckEnabled(true);
            // Prevent repeated fetchPlans() when refreshing page in any ancillary plan type
            this.fetchPlans(activeTabAbbreviation).then(() => {
                this.hasFinishedInitialPlansLoad = true;
            });
        }
        const selectedCounty = this.demographicService.getSelectedCounty();
        const selectedZipCode = this.demographicService.getSelectedZipCode();
        if (!selectedCounty && selectedZipCode) {
            await this.demographicService.fetchCountyData(selectedZipCode);
        }
        // if snpVisibility has any nulls, visibility has been reset at some point, so re-init it
        this.snpService.updateNullVisibilities();
        this.medSupFormIsOpen$ = this.medSupService.medSupFormOpen$;
        this.dentalVisionFormIsOpen$ = this.medSupService.dentalVisionFormOpen$;
        this.enabledPlanTypesData = this.planListFacade.getEnabledPlanTypesData(this.Spa_PlanDetails_HIP_Call_Out_Available_Plan_Types);
        this.planListContext.setActiveTabHasPlanTypeExclusion(false);
        this.planListContext.setMedSupFormIsOpen(this.medSupFormIsOpen$);
        this.planListContext.setDentalVisionFormIsOpen(this.dentalVisionFormIsOpen$);
        this.visiblePlanCountsByTabIndex$ = this.planListFacade.getVisiblePlanCountsByTabIndex$();
        this.totalPlanCount$ = this.planListFacade.getTotalPlanCount$();
        this.activeTabIndex$ = this.planListFacade.getActiveTabIndex$();
        this.currentTabPlanCount$ = this.planListFacade.getCurrentTabPlanCount$();
        this.lastActiveTabThatIsNotDefault$ = this.planListFacade.getLastActiveTabThatIsNotDefault$();
        this.filteredPlans$ = this.planListFacade.getFilteredPlans$();
        this.filteredPlansHasSNPPlans$ = this.planListFacade.getFilteredPlansHasSNPPlans$();
        this.totalAppliedFilters$ = this.planListFacade.getTotalAppliedFilters$();
        this.appliedFilterValues$ = this.planListFacade.getAppliedFilterValues$();
        this.showEmptyFilterMessage$ = this.planListFacade.getShowEmptyFilterMessage$();
        this.medSupPlansWithoutFilters$ = this.planListFacade.getMedSupPlansWithoutFilters$();
        this.dentalPlansWithoutFilters$ = this.planListFacade.getDentalPlansWithoutFilters$();
        this.visionPlansWithoutFilters$ = this.planListFacade.getVisionPlansWithoutFilters$();
        this.hospitalIndemnityPlansWithoutFilters$ = this.hospitalIndemnityFormFacade.getHospitalIndemnityPlansWithoutFilters$();
        this.selectedTabSortList$ = this.planListFacade.getSelectedTabSortList$();
        this.showNoPlansFromAnswersMessage$ = this.planListFacade.getShowNoPlansFromAnswersMessage$();
        this.showMedSupForm$ = this.planListFacade.getShowMedSupForm$();
        this.showDentalForm$ = this.planListFacade.getShowDentalForm$();
        this.showVisionForm$ = this.planListFacade.getShowVisionForm$();
        this.showHospitalIndemnityForm$ = this.planListFacade.getShowHospitalIndemnityForm$();
        this.sortedQuestions$ = this.planListFacade.getSortedQuestions$();
        this.filteredQuestionMetaData$ = this.planListFacade.getFilteredQuestionsMetaData$();
        this.ancillaryQuestions$ = this.planListFacade.getAncillaryQuestions$();
        this.filteredAncillaryQuestionMetaData$ = this.planListFacade.getFilteredAncillaryQuestionsMetaData$();
        this.mailOrder$ = this.pharmacyFacade.mailOrder$;
        this.showMedSupAgeRestrictionBanner$ = this.medSupService.showMedSupAgeRestrictionBanner$();
        this.showMedSupEffectiveDateRestrictionBanner$ = this.medSupService.showMedSupEffectiveDateRestrictionBanner$();
        this.showTurning65AtEffectiveDateMessage$ = this.medSupService.showTurning65AtEffectiveDateMessage$();
        this.cSNPPlansCount$ = this.planListFacade.getFilteredCSNPPlansCount$();
        this.dSNPPlansCount$ = this.planListFacade.getFilteredDSNPPlansCount$();
        this.iSNPPlansCount$ = this.planListFacade.getFilteredISNPPlansCount$();
        this.planShortLoading$ = this.plansService.getAreShortPlansLoading$();
        this.getNonCoveredPlanTabMap$ = this.planFacade.getNonCoveredPlanTabMap$(this.Spa_PlanList_Tabs_Data, this.Spa_Site_Hide_EmptyPlanTabs);
        this.plansLoading$ = this.activeTabType$.pipe(switchMap((activeTabType) => {
            const activePlanType = this.plansService.getPlanType(activeTabType);
            const searchPlanTypes = this.plansService.getSearchPlanTypes(activePlanType);
            return this.plansService.getArePlanTypesLoading$(searchPlanTypes);
        }));
        this.plansLoaded$ = this.activeTabType$.pipe(switchMap((activeTabType) => {
            const activePlanType = this.plansService.getPlanType(activeTabType);
            const searchPlanTypes = this.plansService.getSearchPlanTypes(activePlanType);
            return this.plansService.getArePlanTypesLoaded$(searchPlanTypes);
        }));
        this.plansDirty$ = this.activeTabType$.pipe(switchMap((activeTabType) => {
            const activePlanType = this.plansService.getPlanType(activeTabType);
            const searchPlanTypes = this.plansService.getSearchPlanTypes(activePlanType);
            return this.plansService.getArePlanTypesDirty$(searchPlanTypes);
        }));
        this.isMedicareTab$ = this.activeTabType$.pipe(map((activeTabType) => PlansUtilityService.isMedicarePlanType(activeTabType)));
        if (this.Spa_ZipCodeInput_CountyLabel_Enabled) {
            this.stateCountyInformationalText$ = this.planFacade.getStateCountyInformationalText$(false);
        }
        this.isTagsToUpdate = false;
        if (this.Spa_GuidedHelp_Enabled) {
            this.subscriptions.add(this.guidedHelpService.getHasVisited$().subscribe({
                next: hasVisited => {
                    this.hasEnteredPreferences = hasVisited;
                    this.cdr.markForCheck();
                }
            }));
        }
        if (this.Spa_PlanList_Tab_Show_DENTAL || this.Spa_PlanList_Tab_Show_VISION) {
            this.subscriptions.add(combineLatest([this.activeTabType$, this.hasAncillaryAnswers$]).subscribe({
                next: ([activeTabType, hasAncillaryAnswers]) => {
                    this.hasAncillaryAnswers = hasAncillaryAnswers;
                    // If the dental/vision form is not filled update the sort based on plan name once answered sort based on default value
                    if (!this.hasAncillaryAnswers) {
                        if (activeTabType === PlanTypeAbbreviation.DENTAL) {
                            const dentalTab = this.Spa_PlanList_Tabs_Data.find(planListTab => planListTab.tabTypes.includes(PlanTypeAbbreviation.DENTAL));
                            if (dentalTab) {
                                this.planListFacade.updateTabSortGroups(dentalTab, sort => sort.dataKey === SortLabels.PLAN_NAME);
                            }
                        }
                        else if (activeTabType === PlanTypeAbbreviation.VISION) {
                            const visionTab = this.Spa_PlanList_Tabs_Data.find(planListTab => planListTab.tabTypes.includes(PlanTypeAbbreviation.VISION));
                            if (visionTab) {
                                this.planListFacade.updateTabSortGroups(visionTab, sort => sort.dataKey === SortLabels.PLAN_NAME);
                            }
                        }
                        // force dental/vision form before plan list if rate factor questions have not already been answered
                        if (this.Spa_Site_ForceDentalVisionFormBeforePlansList) {
                            this.planFacade.updateDentalVisionFormOpen(true);
                        }
                        else if (!this.siteService.isPPCSite()) {
                            this.medSupService.fetchDentalVisionQuestions();
                        }
                    }
                    else {
                        this.medSupService.fetchDentalVisionQuestions();
                    }
                    this.cdr.markForCheck();
                }
            }));
            this.subscriptions.add(this.filteredAncillaryQuestionMetaData$.subscribe({
                next: filteredAncillaryQuestionMetaData => {
                    this.filteredAncillaryQuestionMetaData = filteredAncillaryQuestionMetaData;
                    this.cdr.markForCheck();
                }
            }));
            this.subscriptions.add(this.ancillaryQuestions$.subscribe({
                next: ancillaryQuestions => {
                    this.ancillaryQuestions = ancillaryQuestions;
                    this.cdr.markForCheck();
                }
            }));
            this.subscriptions.add(this.pharmacyService.getPharmacyData$().subscribe({
                next: planPharmacyData => {
                    this.planPharmacyData = planPharmacyData;
                    this.cdr.markForCheck();
                }
            }));
        }
        if (this.Spa_PlanList_Tab_Show_DENTAL) {
            this.subscriptions.add(this.showDentalForm$.subscribe({
                next: showDentalForm => {
                    this.showDentalForm = showDentalForm;
                    this.cdr.markForCheck();
                }
            }));
            this.subscriptions.add(this.dentalPlansWithoutFilters$.subscribe({
                next: dentalPlansWithoutFilters => {
                    this.dentalPlansWithoutFilters = dentalPlansWithoutFilters;
                    this.cdr.markForCheck();
                }
            }));
        }
        if (this.Spa_PlanList_Tab_Show_VISION) {
            this.subscriptions.add(this.showVisionForm$.subscribe({
                next: showVisionForm => {
                    this.showVisionForm = showVisionForm;
                    this.cdr.markForCheck();
                }
            }));
            this.subscriptions.add(this.visionPlansWithoutFilters$.subscribe({
                next: visionPlansWithoutFilters => {
                    this.visionPlansWithoutFilters = visionPlansWithoutFilters;
                    this.cdr.markForCheck();
                }
            }));
        }
        if (this.Spa_PlanList_Tab_Show_HIP) {
            this.subscriptions.add(combineLatest([this.activeTabType$, this.hasHospitalIndemnityAnswers$]).subscribe({
                next: ([activeTabType, hasHospitalIndemnityAnswers]) => {
                    this.hasHospitalIndemnityAnswers = hasHospitalIndemnityAnswers;
                    // If the hospital indemnity form is not filled update the sort based on plan name once answered sort based on default value
                    if (!this.hasHospitalIndemnityAnswers) {
                        if (activeTabType === PlanTypeAbbreviation.HC) {
                            const hospitalIndemnityTab = this.Spa_PlanList_Tabs_Data.find(planListTab => planListTab.tabTypes.includes(PlanTypeAbbreviation.HC));
                            if (hospitalIndemnityTab) {
                                this.planListFacade.updateTabSortGroups(hospitalIndemnityTab, sort => sort.dataKey === SortLabels.PLAN_NAME);
                            }
                        }
                        // force hospital indemnity form before plan list if rate factor questions have not already been answered
                        this.hospitalIndemnityFormFacade.updateHospitalIndemnityFormOpen(true);
                    }
                    else {
                        this.hospitalIndemnityFormFacade.fetchHospitalIndemnityQuestions();
                    }
                    this.cdr.markForCheck();
                }
            }));
            this.subscriptions.add(this.showHospitalIndemnityForm$.subscribe({
                next: showHospitalIndemnityForm => {
                    this.showHospitalIndemnityForm = showHospitalIndemnityForm;
                    this.cdr.markForCheck();
                }
            }));
            this.subscriptions.add(this.hospitalIndemnityPlansWithoutFilters$.subscribe({
                next: hospitalIndemnityPlansWithoutFilters => {
                    this.hospitalIndemnityPlansWithoutFilters = hospitalIndemnityPlansWithoutFilters;
                    this.cdr.markForCheck();
                }
            }));
            this.subscriptions.add(this.getHospitalIndemnityPlansSelectedToQuote$().subscribe({
                next: (selectedHospitalIndemnityPlans) => {
                    this.selectedHospitalIndemnityPlans = selectedHospitalIndemnityPlans;
                    this.showAddMedicareAdvantagePlan = this.selectedHospitalIndemnityPlans.length === 0;
                    this.displayPlanQuote();
                    this.updateShowSelectPlanQuote();
                    this.cdr.markForCheck();
                }
            }));
            this.subscriptions.add(this.hospitalIndemnityAnswers$.subscribe({
                next: (hospitalIndemnityAnswers) => {
                    this.hospitalIndemnityAnswers = hospitalIndemnityAnswers;
                    this.cdr.markForCheck();
                }
            }));
        }
        this.subscriptions.add(this.filteredPlans$.pipe(withLatestFrom(this.activeTabType$), distinctUntilChanged(_isEqual)).subscribe({
            next: ([filteredPlans, activeTabType]) => {
                this.filteredPlans = filteredPlans;
                if (this.hasFinishedInitialPlansLoad) {
                    const tabChanged = true;
                    const activePlanType = this.plansService.getPlanType(activeTabType);
                    const searchPlanTypes = this.plansService.getSearchPlanTypes(activePlanType, tabChanged);
                    const activeTabAbbreviation = this.plansService.getActivePlanTypeAbbreviation(activeTabType ?? this.activeTabType, this.tabs);
                    const mustFetchPlans = this.plansService.getArePlanTypesDirty(searchPlanTypes) &&
                        !this.plansService.getArePlanTypesLoading(searchPlanTypes) &&
                        !this.forceFormBeforePlansList(activeTabAbbreviation);
                    if (mustFetchPlans) {
                        this.fetchPlans(activeTabType, tabChanged);
                    }
                }
            }
        }));
        this.subscriptions.add(this.activeTabType$.pipe(distinctUntilChanged(_isEqual)).subscribe({
            next: activeTabType => {
                this._visiblePlanIndex$.next(this.DEFAULT_VISIBLE_TABS);
                this.activeTabType = activeTabType;
                this.snpVisibility = this.areAllSNPTypesVisible(this.snpService.getSNPVisibility());
                const activeTabData = this.planListFacade.getActiveTabData(activeTabType);
                this.showTabFilter = activeTabData?.showFilters;
                this.clearSelectedFilterTag = false;
                this.educationalTextResource = this.getEducationalTextResource(activeTabType);
                this.isCostFilterEnabled = this.planListFacade.isCostFilterEnabled;
                this.isHospitalIndemnityTab = this.activeTabType === this.planTypeAbbreviation.HC;
                this.isSelectPlanQuote = this.Spa_Site_PlanList_HIP_Medicare_Quote_Enabled && this.isHospitalIndemnityTab;
                this.filterPopupOpen = false;
                this.updateShowSelectPlanQuote();
                this.displayPlanQuote();
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.totalPlanCount$.subscribe({
            next: totalPlanCount => {
                this.totalPlanCount = totalPlanCount;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(combineLatest([this.lastActiveTabThatIsNotDefault$, this.activeTabIndex$]).subscribe({
            next: ([lastActiveTabThatIsNotDefault, activeTabIndex]) => {
                this.mobileTabs = this.planListFacade.getMobileTabs(lastActiveTabThatIsNotDefault, this.mobileExtraSmall, activeTabIndex);
                this.lastActiveTabThatIsNotDefault = lastActiveTabThatIsNotDefault;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.currentTabPlanCount$.subscribe({
            next: currentTabPlanCount => {
                this.currentTabPlanCount = currentTabPlanCount;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.showMedSupForm$.subscribe({
            next: showMedSupForm => {
                this.showMedSupForm = showMedSupForm;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.hasMedSupAnswers$.subscribe({
            next: hasMedSupAnswers => {
                this.hasMedSupAnswers = hasMedSupAnswers;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.filteredPlansHasSNPPlans$.subscribe({
            next: filteredPlansHasSNPPlans => {
                this.filteredPlansHasSNPPlans = filteredPlansHasSNPPlans;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.cSNPPlansCount$.subscribe({
            next: cSNPPlansCount => {
                this.cSNPPlansCount = cSNPPlansCount;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.dSNPPlansCount$.subscribe({
            next: dSNPPlansCount => {
                this.dSNPPlansCount = dSNPPlansCount;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.iSNPPlansCount$.subscribe({
            next: iSNPPlansCount => {
                this.iSNPPlansCount = iSNPPlansCount;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.selectedPharmacy$.subscribe({
            next: selectedPharmacy => {
                this.selectedPharmacy = selectedPharmacy;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.zipCode$.subscribe({
            next: zipCode => {
                this.zipCode = zipCode;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(combineLatest([this.storeFilterGroups$, this.activeTabType$, this.filteredPlans$]).subscribe({
            next: ([filterGroups, activeTabType, plans]) => {
                this.setSelectedFilterTags(filterGroups);
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.showMedSupAgeRestrictionBanner$.subscribe({
            next: showMedSupAgeRestrictionBanner => {
                this.showMedSupAgeRestrictionBanner = showMedSupAgeRestrictionBanner;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.showMedSupEffectiveDateRestrictionBanner$.subscribe({
            next: showMedSupEffectiveDateRestrictionBanner => {
                this.showMedSupEffectiveDateRestrictionBanner = showMedSupEffectiveDateRestrictionBanner;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.sortedQuestions$.subscribe({
            next: sortedQuestions => {
                this.sortedQuestions = sortedQuestions;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.filteredQuestionMetaData$.subscribe({
            next: filteredQuestionMetaData => {
                this.filteredQuestionMetaData = filteredQuestionMetaData;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.planListFacade.getEnrollmentSettingsLoading$().subscribe({
            next: loading => {
                loading ? this.spinnerService.show(SpinnerEvent.MEMBER_LOADING) : this.spinnerService.hide(SpinnerEvent.MEMBER_LOADING);
            }
        }));
        this.subscriptions.add(combineLatest([this.planShortLoading$, this.plansLoading$]).subscribe({
            next: ([planShortLoading, plansLoading]) => {
                this.planShortLoading = planShortLoading;
                if (plansLoading || planShortLoading) {
                    this.spinnerService.show(SpinnerEvent.PLANS_LOADING);
                }
                else {
                    this.spinnerService.hide(SpinnerEvent.PLANS_LOADING);
                }
                this.plansLoading = plansLoading;
                this.cdr.markForCheck();
            },
            error: () => {
                this.spinnerService.hide(SpinnerEvent.PLANS_LOADING);
            }
        }));
        this.subscriptions.add(this.medSupPlansWithoutFilters$.subscribe({
            next: medSupPlansWithoutFilters => {
                this.medSupPlansWithoutFilters = medSupPlansWithoutFilters;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.showEmptyFilterMessage$.subscribe({
            next: showEmptyFilterMessage => {
                this.showEmptyFilterMessage = showEmptyFilterMessage;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.showNoPlansFromAnswersMessage$.subscribe({
            next: showNoPlansFromAnswersMessage => {
                this.showNoPlansFromAnswersMessage = showNoPlansFromAnswersMessage;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.selectedTabSortList$.subscribe({
            next: selectedTabSortList => {
                this.selectedTabSortList = selectedTabSortList;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.compareGroups$.subscribe({
            next: compareGroups => {
                this.compareGroups = compareGroups;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.quoteGroups$.subscribe({
            next: quoteGroups => {
                this.quoteGroups = quoteGroups;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.selectedPharmacies$.subscribe({
            next: selectedPharmacies => {
                this.selectedPharmacies = selectedPharmacies;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.totalAppliedFilters$.subscribe({
            next: totalAppliedFilters => {
                this.totalAppliedFilters = totalAppliedFilters;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(combineLatest([this.zipCode$, this.fipsCode$, this.totalPlanCount$, this.isFirstAppearsEditZipCodeModal$, this.plansLoading$])
            .pipe(distinctUntilChanged(_isEqual))
            .subscribe({
            next: ([zipCode, fipsCode, totalPlanCount, isFirstAppearsEditZipCodeModal, arePlansLoading]) => {
                this.isReadyToShowZipcodeLink =
                    this.isEmptyCoreGeographicsForSearchingPlans(zipCode, fipsCode) ||
                        isFirstAppearsEditZipCodeModal ||
                        totalPlanCount > 0 ||
                        !arePlansLoading;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.appliedFilterValues$.subscribe({
            next: appliedFilterValues => {
                this.appliedFilterValues = appliedFilterValues;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.mailOrder$.subscribe({
            next: mailOrder => {
                this.mailOrder = mailOrder;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.showTurning65AtEffectiveDateMessage$.subscribe({
            next: showTurning65AtEffectiveDateMessage => {
                this.showTurning65AtEffectiveDateMessage = showTurning65AtEffectiveDateMessage;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.isMobile$.pipe(filter(compact => this.mobile !== compact)).subscribe({
            next: compact => {
                // TODO update this so adjusting window size works
                this.mobile = compact;
                this.quoteHintText = this.getQuoteHintText(this.mobile);
                this.addToQuoteLimit = this.mobile ? this.Spa_PlanList_AddToQuote_Limit_Mobile : this.Spa_PlanList_AddToQuote_Limit;
                this.mobileTabs = this.planListFacade.getMobileTabs(this.lastActiveTabThatIsNotDefault);
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(combineLatest([this.isExtraSmall$, this.activeTabIndex$])
            .pipe(filter(([mobileExtraSmall]) => this.mobileExtraSmall !== mobileExtraSmall))
            .subscribe({
            next: ([mobileExtraSmall, activeTabIndex]) => {
                this.mobileExtraSmall = mobileExtraSmall;
                this.mobileTabs = this.planListFacade.getMobileTabs(this.lastActiveTabThatIsNotDefault, this.mobileExtraSmall, activeTabIndex);
                this.isMobileExtraSmallOrExactlyThreeTabs = this.mobileExtraSmall || this.mobileTabs.length === 3;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(combineLatest([this.activeTabIndex$, this.isExtraSmall$, this.lastActiveTabThatIsNotDefault$])
            .pipe(distinctUntilChanged(_isEqual))
            .subscribe({
            next: ([activeTabIndex, mobileExtraSmall, lastActiveTabThatIsNotDefault]) => {
                const isFirstTabSelected = this.tabs[0].tabIndex === activeTabIndex;
                this.isActiveMobilePrimaryTab =
                    mobileExtraSmall && this.tabs.length > 2
                        ? isFirstTabSelected || lastActiveTabThatIsNotDefault?.tabIndex === activeTabIndex
                        : isFirstTabSelected;
                if (mobileExtraSmall && lastActiveTabThatIsNotDefault?.tabIndex === activeTabIndex && this.tabs.length > 2) {
                    this.tabMobilePrimary = lastActiveTabThatIsNotDefault;
                }
                else {
                    this.tabMobilePrimary = this.tabs[0];
                }
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(combineLatest([
            this.activeTabType$.pipe(filter((activeTabType) => !!activeTabType)),
            this.medSupService.getHasMedSupAnswers$()
        ]).subscribe({
            next: ([activeTabType, hasAnswers]) => {
                // If the medigap form is not filled update the sort based on plan name once answered sort based on default value
                if (!hasAnswers) {
                    const tab = this.Spa_PlanList_Tabs_Data.find(tab => tab.tabTypes[0] === PlanTypeAbbreviation.MEDIGAP);
                    if (tab && activeTabType === PlanTypeAbbreviation.MEDIGAP) {
                        this.planListFacade.updateTabSortGroups(tab, sort => sort.dataKey === SortLabels.PLAN_NAME);
                    }
                    const hasMillimanServiceBeenCalled = this.millimanService.hasMillimanServiceBeenCalled();
                    if (this.zipCode) {
                        if ((this.Spa_Site_ForceMedSupFormBeforePlansList || this.Spa_PlanList_ShowAllMedigap_Enabled) &&
                            !hasMillimanServiceBeenCalled) {
                            this.planFacade.updateMedSupFormOpen(true, false);
                        }
                        else if (!this.siteService.isPPCSite()) {
                            this.medSupService.fetchMedSupQuestions();
                        }
                    }
                }
                else {
                    if (this.zipCode) {
                        this.medSupService.fetchMedSupQuestions();
                    }
                }
            }
        }));
        this.subscriptions.add(this.activeTabIndex$.subscribe({
            next: activeTabIndex => {
                this.currentTab = this.tabs[activeTabIndex];
                this.activeTabIndex = activeTabIndex;
                this.sortGroup = this.currentTab.sortGroup;
                const selectedPlanSmartDetails = this.store.selectSnapshot(PlansState.selectedPlanSmartDetails);
                // Default active plan tab when redirected from plan smart
                const planType = selectedPlanSmartDetails?.memberId
                    ? PlansUtilityService.getPlanTypeName(selectedPlanSmartDetails?.memberRequest?.currentYearPlanTypeId)
                    : this.currentTab.tabTypes[0];
                this.planListFacade.updateDefaultTab(planType);
                this.setMedicareQuoteParams();
                this.displayPlanQuote();
                // We could end up with an active tab index that might not match the current active tab due to an automatic selection.
                // This will ensure to keep the selected active tab index and the current active tab in sync
                if (this.activeTabType !== this.currentTab.tabTypes[0]) {
                    this.planListFacade.updateActiveTab(this.currentTab.tabTypes[0]);
                }
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(combineLatest([
            this.plansLoading$.pipe(filter((plansLoading) => !plansLoading)),
            this.plansDirty$.pipe(filter((isDirty) => !isDirty)),
            this.activeTabOverrideSelectionComplete$
        ])
            .pipe(withLatestFrom(this.filteredPlans$))
            .subscribe({
            next: ([flags, plans]) => {
                this.planCount = plans?.length;
            }
        }));
        this.subscriptions.add(this.currentLocale$.subscribe({
            next: () => {
                this.tabs = this.sort(this.Spa_PlanList_Tabs_Data).map((tab, index) => new FilterTab(tab, index));
                this.planListContext.setTabs(this.tabs);
                this.guaranteedIssueOptions = this.medSupFacade.getFormattedGuaranteedIssueReasons();
                this.bestMatchReturnToPreferencesTooltip = this.planListFacade.getReturnToPreferencesClickAction(this.Spa_PlanList_BestMatchPlan_Tooltip, this.Spa_Site_ReturnToPreferences_Text);
                this.quoteHintText = this.getQuoteHintText(this.mobile);
                this.editLinkText = this.getEditLinkText();
                this.subsidyLabelText = this.getSubsidyLabelText();
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.planListContext.openZipCodeModal$.subscribe({
            next: () => {
                if (!this.guidedHelpService.getSelectedZipCode() && !this.isZipModalOpen) {
                    this.editZipCode();
                }
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.planListContext.openMobileFiltersModal$.pipe(withLatestFrom(this.isMobile$)).subscribe({
            next: ([, isMobile]) => {
                if (isMobile) {
                    this.openMobileFiltersModal();
                }
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(
        // display enter zip code modal if no zip code selected
        combineLatest([this.zipCode$, this.fipsCode$])
            .pipe(take(1))
            .subscribe({
            next: ([zipCode, fipsCode]) => {
                if (this.isEmptyCoreGeographicsForSearchingPlans(zipCode, fipsCode) && !this.isZipModalOpen && !this.environment.liveedit) {
                    this.editZipCode();
                    this.tagsToUpdate();
                }
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.liveEditState.currentLiveEditState$.subscribe({
            next: state => {
                if (state) {
                    if (state.name === 'Show medsup form') {
                        this.planFacade.updateMedSupFormOpen(true);
                        this.planListFacade.updateActiveTab(PlanTypeAbbreviation.MEDIGAP);
                    }
                    else {
                        this.planFacade.updateMedSupFormOpen(false);
                    }
                }
            }
        }));
        this.subscriptions.add(combineLatest([this.filteredPlans$, this.visiblePlanIndex$]).subscribe({
            next: ([plans, visiblePlanIndex]) => {
                this.visiblePlans = plans?.slice(0, visiblePlanIndex);
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.filteredPlans$.pipe(withLatestFrom(this.visiblePlanIndex$)).subscribe({
            next: ([plans, visiblePlanIndex]) => {
                const previousPlanCount = this.planCount;
                this.filteredPlans = plans;
                this.planCount = plans?.length;
                // SPA-21529
                // We do not update the visible count if the plan count is equal the previous count, as that means we did not actually
                // change the list, we just updated it some way, ie fetching plan details.
                // The counts will differ if we click on a filter (or a tab, which is handled in its own subscription),
                // so in that case we do want to reset to 10 in case we would otherwise have to load up
                // to the old visible index of new plans.
                if (visiblePlanIndex > this.planCount && previousPlanCount !== this.planCount) {
                    this._visiblePlanIndex$.next(this.DEFAULT_VISIBLE_TABS);
                }
                const currentYearPlan = plans?.find(plan => plan.isCurrentYearPlan);
                if (currentYearPlan) {
                    this.currentYearPlanId = currentYearPlan.id;
                }
                this.nextYearPlanId = this.retentionFacade.getNextYearPlanFromPlansList(plans)?.id;
                this.option2PlanId = this.retentionFacade.getOption2PlanFromPlansList(plans)?.id;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.getNonCoveredPlanTabMap$.subscribe({
            next: nonCoveredPlanTabMap => {
                this.nonCoveredPlanTabMap = nonCoveredPlanTabMap;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.providerFacade.getProviderDetails$().subscribe({
            next: providerDetails => {
                this.providerDetails = providerDetails;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(combineLatest([
            this.arePlansOrShortPlansLoading$,
            this.planListFacade.plans$,
            this.planListFacade.getOverrideActiveTab$(),
            this.plansService.getLoadedPlanTypes$(),
            this.plansService.getDirtyPlanTypes$(),
            this.getNonCoveredPlanTabMap$
        ])
            .pipe(filter(([arePlansOrShortPlansLoading]) => !arePlansOrShortPlansLoading))
            .subscribe({
            next: ([arePlansOrShortPlansLoading, plans, overrideActiveTab, loadedPlanTypes, dirtyPlanTypes]) => {
                // overrideActiveTab is set to false when we want to use the ActiveTab defined
                // in the component from where we are navigating to Planlist page
                // Do not recalculate activetab if the overrideActiveTab is set to false
                if (overrideActiveTab) {
                    const planScoresExist = plans.some(plan => plan.score !== undefined && plan.score !== null);
                    if (plans?.length) {
                        if (this.Spa_PlanList_ActiveTab_BasedOn_PreferenceScore_Enabled &&
                            this.plansService.bestMatchTabTypesLoaded(loadedPlanTypes) &&
                            !this.plansService.bestMatchTabTypesDirty(dirtyPlanTypes)) {
                            this.setRecalculateActiveTabWithScores(plans);
                            if (planScoresExist) {
                                if (this.recalculateActiveTabWithScores) {
                                    // If scores have changed, then recalculate the active tab appropriately based on scores
                                    // NOTE --------------> This will chose the highest score across tabs
                                    this.activeTabIndex = this.planListFacade.getInitialActiveTabIndexBasedOnScores(plans);
                                    this.recalculateActiveTabWithScores = false;
                                    this.setCurrentTab();
                                }
                            }
                            else if (this.recalculateActiveTab) {
                                /*
                                  setActiveTab resolves as follows
                                  // this.store.selectSnapshot(GuidedHelpState.selectedCoverageType);
                                  // OR const defaultTabType = this.store.selectSnapshot(PlansState.defaultTabType);
                                */
                                // Recalculate and set the active tab to site default tab or coverage type based default tab
                                this.setActiveTab();
                            }
                        }
                        else if (this.recalculateActiveTab) {
                            // TODO: if we just respond to medicare and medicaid above then when does this come in to play and are there any gaps?
                            // Recalculate and set the active tab to site default tab or coverage type based default tab
                            // TODO: may need to make sure that tab is loaded or no? Actually probably not since this isn't using anything from the list is it?
                            this.setActiveTab();
                        }
                    }
                }
            }
        }));
        // Spa_PlanList_BestMatchPlan_Enabled will consider plans from the following coverage types MA, PDP, MAPD, Medsup
        if (this.Spa_PlanList_BestMatchPlan_Enabled) {
            this.subscriptions.add(this.planListFacade.getBestMatchPlanId$().subscribe({
                next: bestMatchPlanId => {
                    this.bestMatchPlanId = bestMatchPlanId;
                    this.cdr.markForCheck();
                }
            }));
        }
        if (this.Spa_PlanList_BestCoverageType_Enabled) {
            this.subscriptions.add(this.planListFacade.getBestCoverageTabAbbreviation$().subscribe({
                next: bestCoverageTabTypeAbbreviation => {
                    this.bestCoverageTabTypeAbbreviation = bestCoverageTabTypeAbbreviation;
                    this.cdr.markForCheck();
                }
            }));
        }
        this.subscriptions.add(this.store.select(MemberState.totalCostEffectiveDate).subscribe({
            next: (totalCostEffectiveDate) => {
                this.totalCostEffectiveDate = totalCostEffectiveDate;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.guidedHelpService.getMedicineCabinet$().subscribe({
            next: medicines => {
                this.medicineCabinet = medicines;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.planYearResourceService.getSelectedPlanYear$().subscribe({
            next: selectedPlanYear => {
                this.selectedPlanYear = selectedPlanYear;
                this.setDualPlanYearText(selectedPlanYear);
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.planYearService.getHasPlanYearPermissionError$().subscribe({
            next: hasPlanYearPermissionError => {
                this.hasPlanYearPermissionError = hasPlanYearPermissionError;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.isMedicareTab$.subscribe({
            next: isMedicareTab => {
                this.isMedicareTab = isMedicareTab;
                this.cdr.markForCheck();
            }
        }));
        if (this.Spa_Site_TotalSiteCountsPPC_Enabled) {
            this.subscriptions.add(this.carriersService.getTotalCountsResource$().subscribe({
                next: (totalCountString) => {
                    this.totalCountsText = totalCountString;
                    this.cdr.markForCheck();
                }
            }));
        }
        this.guidedHelpService.rehydrateGuidedHelpVisitedStatus();
        this.paymentMethod$ = this.medSupService.getMedSupAnswers$().pipe(map(answers => {
            if (answers?.PaymentMethod) {
                return answers.PaymentMethod.toLowerCase();
            }
        }));
        if (this.trackPlanListInfoOnPageLoadOnce) {
            this.trackPlanListInfo(AnalyticsActionType.PAGELOAD);
        }
        if (this.siteService.isPPCSite() &&
            (typeof this.Spa_Rating_Method_Enabled === 'undefined' || this.Spa_Rating_Method_Enabled === null)) {
            this.Spa_Rating_Method_Enabled = true;
        }
        this.subscriptions.add(combineLatest([this.arePlansOrShortPlansLoading$, this.planListFacade.getActiveTabType$(), this.plansLoaded$])
            .pipe(skipWhile(([arePlansOrShortPlansLoading, activeTabType, plansLoaded]) => !activeTabType || !plansLoaded || arePlansOrShortPlansLoading), take(1))
            .subscribe({
            next: () => {
                this.tagsToUpdate(true);
                this.isTagsToUpdate = true;
            }
        }));
        this.subscriptions.add(this.planFilterItemsFacade.getOnFilterClicked$().subscribe({
            next: () => {
                this.trackPlanListInfo(AnalyticsActionType.FILTER);
            }
        }));
        this.subscriptions.add(this.planFacade.selectedProviders$.subscribe({
            next: selectedProviders => {
                this.selectedProviders = selectedProviders;
                this.cdr.markForCheck();
            }
        }));
        if (this.Spa_PlanList_ShowAllMedigap_Enabled) {
            this.subscriptions.add(this.store.select(PlansState.selectedPlanSubType).subscribe({
                next: (planSubType) => {
                    this.selectedPlanSubType = planSubType;
                    this.cdr.markForCheck();
                }
            }));
        }
    }
    filterClicked() {
        this.planFilterItemsFacade.filterClicked();
    }
    setSelectedFilterTags(filterGroups) {
        this.selectedFilters = [];
        filterGroups?.forEach(filterGroup => {
            if (filterGroup?.groupKey?.values.some(tab => tab === this.activeTabType)) {
                this.activeTabFilterGroup = filterGroup;
                filterGroup?.filters?.forEach(selectedFilter => {
                    const selectedFilterValues = [];
                    if (selectedFilter.key === FilterKeyType.PLAN_BENEFIT_NAME) {
                        selectedFilter?.values?.forEach(filter => {
                            const selectedPlanBenefit = this.Spa_Site_Default_Plan_Benefit_Filter?.find(planBenefit => planBenefit.value === filter.benefitID);
                            if (!selectedFilterValues?.some(filterValue => filterValue?.label === selectedPlanBenefit?.name)) {
                                selectedFilterValues.push({ label: selectedPlanBenefit?.name, value: filter.benefitID });
                            }
                        });
                    }
                    else if (selectedFilter.key === FilterKeyType.SNP_BASE_TYPE) {
                        selectedFilter?.values?.forEach(value => {
                            if (!selectedFilterValues?.some(filterValue => filterValue?.label === value?.label)) {
                                selectedFilterValues.push({ label: this.snpService.getSNPAbbreviation(value), value });
                            }
                        });
                    }
                    else if (selectedFilter.key === FilterKeyType.PLAN_RATING) {
                        selectedFilter?.values?.forEach(value => {
                            if (!selectedFilterValues?.some(filterValue => filterValue?.label === value?.label)) {
                                selectedFilterValues.push({
                                    label: this.Spa_StarRating_Filter_Options.find(opt => opt.value === value)?.label,
                                    value
                                });
                            }
                        });
                    }
                    else if (selectedFilter.key === FilterKeyType.PLAN_ISPUF) {
                        selectedFilter?.values?.forEach(value => {
                            if (!selectedFilterValues?.some(filterValue => filterValue?.label === value?.label)) {
                                selectedFilterValues.push({
                                    label: this.Spa_Filter_SellablePlansOnlyCheckbox_Label,
                                    value
                                });
                            }
                        });
                    }
                    else if (selectedFilter?.values?.length) {
                        selectedFilter?.values?.forEach(value => {
                            if (selectedFilter?.key === FilterKeyType.PLAN_MAXIMUM_OUT_POCKET_COST ||
                                selectedFilter?.key === FilterKeyType.PLAN_MEDICAL_DEDUCTIBLE ||
                                selectedFilter?.key === FilterKeyType.PLAN_DRUG_PREMIUM ||
                                selectedFilter?.key === FilterKeyType.PLAN_PREMIUM) {
                                if (!selectedFilterValues?.some(filterValue => filterValue?.label?.includes(value?.label))) {
                                    let groupName = '';
                                    let filterLabel = '';
                                    if (selectedFilter?.key === FilterKeyType.PLAN_MAXIMUM_OUT_POCKET_COST) {
                                        groupName = FilterKeyGroupName.OOP;
                                        filterLabel = StaticFilterLabel.OOP;
                                    }
                                    else if (selectedFilter?.key === FilterKeyType.PLAN_MEDICAL_DEDUCTIBLE) {
                                        groupName = FilterKeyGroupName.MEDICAL_DEDUCTIBLE;
                                        filterLabel = StaticFilterLabel.MEDICAL_DEDUCTIBLE;
                                    }
                                    else if (selectedFilter?.key === FilterKeyType.PLAN_DRUG_PREMIUM ||
                                        selectedFilter?.key === FilterKeyType.PLAN_PREMIUM) {
                                        groupName = FilterKeyGroupName.PREMIUM;
                                    }
                                    if (groupName) {
                                        const filterOptions = this.planFilterItemsFacade.getCostFilterOptions(groupName);
                                        const selectedFilterOption = filterOptions?.find(option => _isEqual(option.value, value));
                                        selectedFilterValues.push({
                                            label: `${filterLabel} ${selectedFilterOption?.label}`,
                                            key: selectedFilter.key,
                                            value
                                        });
                                    }
                                }
                            }
                            else if ([FilterKeyType.RIDERS_PLAN_SUB_TYPE, FilterKeyType.SNP_BASE_TYPE, FilterKeyType.SNP_CATEGORY].includes(selectedFilter?.key)) {
                                if (!selectedFilterValues?.some(filterValue => filterValue?.label === value?.label)) {
                                    const labelMapping = {
                                        [FilterKeyType.RIDERS_PLAN_SUB_TYPE]: () => this.planFilterItemsFacade.getRidersLabelForTags(value?.predicates),
                                        [FilterKeyType.SNP_BASE_TYPE]: () => this.planFilterItemsFacade.getSNPBaseLabelForTags(value),
                                        [FilterKeyType.SNP_CATEGORY]: () => this.planFilterItemsFacade.getSNPSubTypeLabelForTags(value)
                                    };
                                    selectedFilterValues.push({
                                        label: labelMapping[selectedFilter.key]?.() || value,
                                        key: selectedFilter.key,
                                        value
                                    });
                                }
                            }
                            else {
                                if (!selectedFilterValues?.some(filterValue => filterValue?.label === value?.label)) {
                                    selectedFilterValues.push({ label: value?.label || value, key: selectedFilter.key, value });
                                }
                            }
                        });
                    }
                    this.selectedFilters.push({ key: selectedFilter.key, values: selectedFilterValues });
                });
            }
        });
        if (!this.selectedFilters?.length &&
            this.Spa_PlanList_FilterModal_Enabled &&
            this.activeTabType === PlanTypeAbbreviation.MAPD &&
            this.setDefaultFilter) {
            const snpPlans = this.plansService.getFilteredPlansBySNPVisibility();
            if (snpPlans?.length) {
                this.toggleSNPPlanVisibility(false);
                this.setDefaultFilter = false;
                this.cdr.markForCheck();
            }
        }
        const selectedFiltersAbbreviations = this.selectedFilters
            ?.map(selectedFilter => this.getFilterAbbreviation(selectedFilter.key))
            .join(FILTER_ABBREVIATION_DELIMITER);
        if (this.clearSelectedFilterTag) {
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLANS_FILTERS_REMOVE,
                [DataLayerGlobalVariable.PLAN_FILTER_REMOVED]: this.getRemovedFilterAbbreviation(selectedFiltersAbbreviations, this.selectedFiltersAbbreviations),
                [DataLayerGlobalVariable.PLAN_FILTERS_APPLIED]: this.getFilterAbbreviation(selectedFiltersAbbreviations) ?? GOOGLE_ANALYTICS_NONE
            };
            this.clearSelectedFilterTag = false;
            this.selectedFiltersAbbreviations = selectedFiltersAbbreviations;
        }
        else if (this.selectedFiltersAbbreviations !== selectedFiltersAbbreviations) {
            this.analyticsService.googleDataLayerTags = {
                [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLANS_FILTERS_APPLY,
                [DataLayerGlobalVariable.PLAN_FILTERS_APPLIED]: selectedFiltersAbbreviations ?? GOOGLE_ANALYTICS_NONE
            };
            this.selectedFiltersAbbreviations = selectedFiltersAbbreviations;
        }
    }
    getRemovedFilterAbbreviation(currentSelectedFiltersAbbreviations, previousSelectedFiltersAbbreviations) {
        const currentFilterText = currentSelectedFiltersAbbreviations.split(FILTER_ABBREVIATION_DELIMITER);
        const previousFilterText = previousSelectedFiltersAbbreviations.split(FILTER_ABBREVIATION_DELIMITER);
        const differences = previousFilterText.filter(text => !currentFilterText.includes(text));
        return differences?.length ? differences?.[0] : '';
    }
    sortClicked() {
        this.trackPlanListInfo(AnalyticsActionType.SORT);
    }
    preProcessProperties() {
        this.medSupPaymentMethodDisplayText = {
            [MedSupPaymentMethod.BI_MONTHLY]: (this.Spa_MedSupForm_PaymentMethodBiMonthly_Text || '').toLowerCase(),
            [MedSupPaymentMethod.MONTHLY]: (this.Spa_MedSupForm_PaymentMethodMonthly_Text || '').toLowerCase(),
            [MedSupPaymentMethod.QUARTERLY]: (this.Spa_MedSupForm_PaymentMethodQuarterly_Text || '').toLowerCase(),
            [MedSupPaymentMethod.SEMI_ANNUALLY]: (this.Spa_MedSupForm_PaymentMethodSemiAnnually_Text || '').toLowerCase(),
            [MedSupPaymentMethod.ANNUALLY]: (this.Spa_MedSupForm_PaymentMethodAnnually_Text || '').toLowerCase(),
            [MedSupPaymentMethod.LUMP_SUM]: (this.Spa_MedSupForm_PaymentMethodLumpSum_Text || '').toLowerCase()
        };
        this.setDualPlanYearText(this.planYearResourceService.getSelectedPlanYear());
        this.planYearTextEnabled = this.planYearResourceService.getIsDualPlanYearSite() && this.Spa_DualPlanYear_PlanList_Text_Enabled;
    }
    async trackPlanListInfo(analyticsActionType) {
        const planListAbbreviation = this.planListFacade.getCoverageTypeAbbreviation();
        return await this.plansService.trackPlanListInfo(this.filteredPlans, this.getFilters(), this.getSortSelectedName(), analyticsActionType, planListAbbreviation);
    }
    setRecalculateActiveTabWithScores(plans) {
        // Because the first plan$ emit uses the existing scores and
        // the second emission gives the refreshed the scores, recalculate Active tab when scores change
        if (this.recalculateActiveTabWithScores) {
            this.previousMaxPlanScoresByTab = this.planListFacade.getHighestScoreByTabIndex(plans);
        }
        this.currentMaxPlanScoresByTab = this.planListFacade.getHighestScoreByTabIndex(plans);
        //  The JSON.stringify comparison should work fine since this is an array of primitives
        if (JSON.stringify(this.previousMaxPlanScoresByTab) !== JSON.stringify(this.currentMaxPlanScoresByTab)) {
            this.recalculateActiveTabWithScores = true;
        }
    }
    openAncillaryForm(activeTabType) {
        switch (activeTabType) {
            case PlanTypeAbbreviation.MEDIGAP:
                this.planFacade.updateMedSupFormOpen(true);
                break;
            case PlanTypeAbbreviation.DENTAL:
                this.loadDentalVisionForm(PlanTypeAbbreviation.DENTAL);
                break;
            case PlanTypeAbbreviation.VISION:
                this.loadDentalVisionForm(PlanTypeAbbreviation.VISION);
                break;
            case PlanTypeAbbreviation.HC:
                this.hospitalIndemnityFormFacade.updateHospitalIndemnityFormOpen(true, true);
                break;
            default:
                break;
        }
    }
    loadMedSupForm() {
        this.planFacade.updateMedSupFormOpen(true, true);
    }
    loadDentalVisionForm(planTypeAbbreviation) {
        this.planFacade.updateDentalVisionFormOpen(true, planTypeAbbreviation, true);
    }
    // The tab data we're originally getting is all from configs, we need to transform it into actual tabs
    initTabs() {
        const currentFilterGroups = this.planListFacade.getFilterGroups();
        this.tabs = this.sort(this.Spa_PlanList_Tabs_Data).map((tab, index) => new FilterTab(tab, index));
        this.Spa_PlanList_Tabs_Data.forEach(tab => {
            const isTabFilterSelected = currentFilterGroups.some(filterGroup => filterGroup.groupKey && _isEqual(filterGroup.groupKey.values, tab.tabTypes) && filterGroup.filters?.length);
            // SPA-18831 - Filters should not drop when user goes to another page
            if (!isTabFilterSelected) {
                const filters = tab.filters?.map(filter => new Filter({ ...filter })) ?? [];
                this.configurableWidgetService.filterService.setFilterGroup({
                    groupKey: new Filter({ key: FilterKeyType.PLAN_TYPE_SHORT, values: tab.tabTypes }),
                    filters
                });
            }
            this.setCompareGroup(tab);
            let defaultSortOption = tab.sortList.find(sort => sort.isDefault);
            if (!defaultSortOption) {
                defaultSortOption = tab.sortList.sort(sortData => sortData.order).find(sort => sort.display);
            }
            if (this.isSetSortGroupRequired(tab.tabTypes[0])) {
                this.setSortGroup(tab.tabTypes, defaultSortOption);
            }
            if (this.Spa_Site_AddToQuote_Enabled) {
                this.setQuoteGroup(tab);
            }
        });
    }
    /**
     * sorts the plan list tabs by default and secondary. Didn't use a sort function because their
     * are a lot of odd edge cases that a IC can input.
     */
    sort(planList) {
        return this.planListFacade.sort(planList);
    }
    getEducationalTextResource(tabType) {
        if (tabType && tabType === PlanTypeAbbreviation.HC) {
            return 'Spa_PlanList_Tab_Educational_Text_HIP';
        }
        return tabType ? `Spa_PlanList_Tab_Educational_Text_${tabType}` : '';
    }
    getEducationalText(tabType) {
        switch (tabType) {
            case PlanTypeAbbreviation.MEDIGAP:
                return this.Spa_PlanList_Tab_Educational_Text_MEDIGAP;
            case PlanTypeAbbreviation.PDP:
                return this.Spa_PlanList_Tab_Educational_Text_PDP;
            case PlanTypeAbbreviation.MA:
                return this.Spa_PlanList_Tab_Educational_Text_MA;
            case PlanTypeAbbreviation.MAPD:
                return this.Spa_PlanList_Tab_Educational_Text_MAPD;
            case PlanTypeAbbreviation.DENTAL:
                return this.Spa_PlanList_Tab_Educational_Text_DENTAL;
            case PlanTypeAbbreviation.VISION:
                return this.Spa_PlanList_Tab_Educational_Text_VISION;
            case PlanTypeAbbreviation.HC:
                return this.Spa_PlanList_Tab_Educational_Text_HIP;
            default:
                return '';
        }
    }
    isNotLicensedToSell(plan) {
        return this.plansService.isNotLicensedToSell(plan);
    }
    showAddNonLicensedPlans() {
        return !this.isRetentionView && this.siteService.isPPCSite() && this.plansService.showAddNonLicensedPlans();
    }
    setCompareGroup(tab) {
        const compareGroups = this.configurableWidgetService.store.selectSnapshot(PlansState.compareGroups);
        const currentGroup = compareGroups.find(group => group.groupKey && group.groupKey.values[0] === tab.tabTypes[0]);
        let plans = [];
        if (currentGroup) {
            plans = currentGroup.items;
        }
        this.planCompareService.setCompareGroup({
            // Consider the tab's first type value as the main type
            ...new CompareGroup(FilterKeyType.PLAN_TYPE_SHORT, [tab.tabTypes[0]]),
            items: plans
        });
    }
    setQuoteGroup(tab) {
        const quoteGroups = this.configurableWidgetService.store.selectSnapshot(PlansState.quoteGroups);
        const currentQuoteGroup = quoteGroups.find(group => group.groupKey && group.groupKey.values[0] === tab.tabTypes[0]);
        let plans = [];
        if (currentQuoteGroup) {
            plans = currentQuoteGroup.items;
        }
        this.quoteService.setQuoteGroup({
            ...new CompareGroup(FilterKeyType.PLAN_TYPE_SHORT, tab.tabTypes),
            items: plans
        });
    }
    toggleSNPPlanChangeEvent(hideSNPPlans) {
        this.hideSNPPlans = hideSNPPlans;
    }
    // trackBy function for plans
    planKey(index, plan) {
        // on successive calls plans with the same IDs won't be detached and reattached to the DOM
        // this is to increase render times on plans list updates
        return plan.id;
    }
    tabKey(index, tab) {
        return tab.title;
    }
    trackByFilterKey(index, selectedFilter) {
        return selectedFilter?.key;
    }
    trackByFilterValue(index, filterValue) {
        return filterValue?.label;
    }
    async openMobileFiltersModal() {
        const options = {
            scrollable: true,
            ariaLabelledBy: this.Spa_PlanFilters_Modal_Link,
            injector: this.injector,
            size: 'xl'
        };
        const planFilterModal = this.configurableWidgetService.modalService.open(PlanFilterModalComponent, options);
        planFilterModal.componentInstance.currentTab = this.currentTab;
        planFilterModal.componentInstance.filterCarrierText = this.Spa_PlanFilters_CarrierLabel_Text;
        planFilterModal.componentInstance.defaultFilterText = this.Spa_PlanFilters_DefaultText;
        planFilterModal.componentInstance.filterHeaderText = this.Spa_Filter_Header_Text;
        planFilterModal.componentInstance.licensingHeaderText = this.Spa_Filter_LicensingHeader_Text;
        planFilterModal.componentInstance.snpBaseTypeLabel = this.Spa_Filter_SNPBaseTypes_Label;
        planFilterModal.componentInstance.filterClearAllText = this.Spa_Filter_Clear_All;
        planFilterModal.componentInstance.planSubTypeLabel = this.Spa_PlanFilters_SubType_Label;
        planFilterModal.componentInstance.filterModalCancelButtonText = this.Spa_PlanFilters_Modal_Cancel_Button;
        planFilterModal.componentInstance.filterModalApplyButtonText = this.Spa_PlanFilters_Modal_Apply_Button;
        planFilterModal.componentInstance.snpEnabled = this.Spa_Site_SNPTools_Enabled;
        planFilterModal.componentInstance.additionalSavingsHeaderText = this.Spa_Filter_AdditionalSavingsHeader_Text;
        planFilterModal.componentInstance.addOnFilterHeaderText = this.Spa_PlanList_AddOn_Header_Text;
        planFilterModal.componentInstance.addOnFilterEnabled = this.Spa_PlanList_AddOn_Filter_Enabled;
        planFilterModal.componentInstance.addOnTooltipText = this.Spa_Filter_AddOn_Coverage_ToolTip_Text;
        planFilterModal.componentInstance.allInNetworkLocationsEnabled = this.Spa_Site_Provider_ShowAllInNetworkLocations_Enabled;
        planFilterModal.componentInstance.providersNpiHeaderText = this.Spa_Site_Providers_Header_Text;
        planFilterModal.componentInstance.providersNpiFilterEnabled = this.Spa_Npi_Filter_Enabled;
        planFilterModal.componentInstance.providersEnabled = this.Spa_Site_Providers_Enabled;
        planFilterModal.componentInstance.providersNpiTooltipText = this.Spa_Filter_Providers_ToolTip_Text;
        planFilterModal.componentInstance.filterDayText = this.Spa_PlanFilters_DayLabel_Text;
        planFilterModal.componentInstance.selectFilterDayText = this.Spa_PlanFilters_SelectDayLabel_Text;
        planFilterModal.componentInstance.planTypeLabel = this.Spa_Site_PlanType_Header;
        if (this.Spa_Filter_PlanBenefitsGroup_Enabled) {
            planFilterModal.componentInstance.defaultPlanBenefitFiltersEnabled = this.Spa_Filter_PlanBenefitsGroup_Enabled;
            planFilterModal.componentInstance.defaultPlanBenefitFilters = this.Spa_Site_Default_Plan_Benefit_Filter;
            if (this.Spa_Filter_InsulinSavings_Enabled) {
                planFilterModal.componentInstance.insulinSavingsEnabled = this.Spa_Filter_InsulinSavings_Enabled;
            }
        }
        planFilterModal.componentInstance.filterDSNPMedicaidCodesEnabled = this.Spa_Filter_DSNPMedicaidCodes_Enabled;
        planFilterModal.componentInstance.costFilterEnabled = this.isCostFilterEnabled;
        planFilterModal.componentInstance.medicalDeductibleHeaderText = this.Spa_Filter_MedicalDeductible_Text;
        planFilterModal.componentInstance.medicalDeductibleToolTipText = this.Spa_Filter_MedicalDeductible_ToolTip_Text;
        planFilterModal.componentInstance.maximumOutOfPocketCostHeaderText = this.Spa_Filter_MaximumOutOfPocketCost_Text;
        planFilterModal.componentInstance.maximumOutOfPocketCostToolTipText = this.Spa_Filter_MaximumOutOfPocketCost_ToolTip_Text;
        planFilterModal.componentInstance.drugDeductibleHeaderText = this.Spa_Filter_PharmacyDeductible_Text;
        planFilterModal.componentInstance.drugDeductibleToolTipText = this.Spa_Filter_PharmacyDeductible_ToolTip_Text;
        planFilterModal.componentInstance.premiumHeaderText = this.Spa_Filter_Premium_Text;
        planFilterModal.componentInstance.premiumToolTipText = this.Spa_Filter_Premium_ToolTip_Text;
        planFilterModal.componentInstance.addOnFilterEnabled = this.Spa_Filter_AddOn_Coverage_ToolTip_Text;
        planFilterModal.componentInstance.isMedigapEnabled = this.Spa_PlanList_ShowAllMedigap_Enabled;
        planFilterModal.componentInstance.medsupPlanSubTypeHeaderText = this.Spa_PlanList_MedSupPlanSubTypeHeader_Text;
        planFilterModal.componentInstance.medsupPlanSubTypePlacholderText = this.Spa_PlanList_MedSupPlanSubTypePlaceholder_Text;
        planFilterModal.componentInstance.medsupPlanSubTypeUpdateText = this.Spa_PlanList_MedSupPlanSubTypeUpdate_Text;
        planFilterModal.componentInstance.activeTabType = this.activeTabType;
        planFilterModal.componentInstance.snpLabelText = this.Spa_PlanList_HideSNPLink_Text;
        planFilterModal.componentInstance.filteredPlansHasSNPPlans = this.filteredPlansHasSNPPlans;
        planFilterModal.componentInstance.isPlanListPage = true;
        planFilterModal.componentInstance.snpVisibility = this.snpVisibility;
        planFilterModal.componentInstance.starRatingEnabled =
            this.Spa_StarRating_Enabled &&
                (this.activeTabType === PlanTypeAbbreviation.MAPD ||
                    this.activeTabType === PlanTypeAbbreviation.MA ||
                    this.activeTabType === PlanTypeAbbreviation.PDP);
        planFilterModal.componentInstance.starRatingLabelText = this.Spa_StarRating_Label_Text;
        planFilterModal.componentInstance.starRatingFilterOptions = this.Spa_StarRating_Filter_Options;
        planFilterModal.componentInstance.planFiltersSortOptions = this.Spa_PlanFilters_Sort_Options_For_Modal;
        planFilterModal.result
            .then(() => { }, () => {
            this.setFocusToFilterPlansButton();
        })
            .catch(() => {
            this.setFocusToFilterPlansButton();
        });
    }
    applyFilter() {
        this.planFilterModalItems.updateFilters();
        if (this.isMedsupPlanSubTypeChange && this.updatedPlanSubType) {
            this.medSupFacade.updateSelectedPlanSubType(this.updatedPlanSubType);
            this.planSubTypeChanged();
        }
        this.snpVisibility = this.hideSNPPlans;
        this.planListFacade.toggleSNPPlanVisibility(this.snpVisibility, this.activeTabType, this.Spa_PlanList_FilterModal_Enabled);
        this.filterPopupOpen = false;
        this.isMedsupPlanSubTypeChange = false;
        this.updatedPlanSubType = '';
    }
    openFilterModal(event) {
        this.filterPopupOpen = !this.filterPopupOpen;
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_FILTERS_MODAL_OPEN);
        event.stopPropagation();
    }
    closeFilterModal() {
        this.filterPopupOpen = !this.filterPopupOpen;
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_FILTERS_MODAL_CANCEL);
    }
    clearSelectedFilter(filterKeyType, filterValue) {
        if (this.activeTabFilterGroup) {
            const selectedFilterType = this.activeTabFilterGroup?.filters?.find(filter => filter.key === filterKeyType);
            if (selectedFilterType) {
                const filterValues = this.getFilterValues(selectedFilterType, filterValue);
                if (filterValues?.length > 0) {
                    this.filterService.addFilterToFilterGroups([this.activeTabFilterGroup?.groupKey], {
                        ...selectedFilterType,
                        values: filterValues
                    });
                }
                else {
                    this.filterService.clearFilterGroupFilter(this.currentTab?.filters, filterKeyType);
                }
            }
            this.clearSelectedFilterTag = true;
        }
    }
    onModalClosed() {
        if (this.guidedHelpService.isGuidedHelpDirty()) {
            this.plansService.setAllPlansDirty(true);
            this.fetchPlans();
        }
        this.guidedHelpService.setGuidedHelpDirty(false);
    }
    getFilterAbbreviation(filterKeyType) {
        switch (filterKeyType) {
            case FilterKeyType.SNP_BASE_TYPE:
            case FilterKeyType.SNP_CATEGORY:
            case FilterKeyType.ASP_SNP_TYPE:
                return PlanFilterAbbreviation.SNP;
            case FilterKeyType.PLAN_ISPUF:
                return PlanFilterAbbreviation.LICENSE;
            case FilterKeyType.PLAN_MEDICAL_DEDUCTIBLE:
                return PlanFilterAbbreviation.MEDICAL_DEDUCTIBLE;
            case FilterKeyType.PLAN_MAXIMUM_OUT_POCKET_COST:
                return PlanFilterAbbreviation.MEDICAL_OUT_POCKET_COST;
            case FilterKeyType.PLAN_PHARMACY_DEDUCTIBLE:
                return PlanFilterAbbreviation.PRESCRIPTION_DEDUCTIBLE;
            case FilterKeyType.PLAN_PREMIUM:
                return PlanFilterAbbreviation.PREMIUM_MEDICAL;
            case FilterKeyType.PLAN_DRUG_PREMIUM:
                return PlanFilterAbbreviation.PREMIUM_PHARMACY;
            case FilterKeyType.RIDERS_PLAN_SUB_TYPE:
                return PlanFilterAbbreviation.ADDON_COVERAGE;
            case FilterKeyType.PLAN_BENEFIT_NAME:
                return PlanFilterAbbreviation.ADDITIONAL_SAVING;
            case FilterKeyType.PLAN_CARRIER_FILTER:
            case FilterKeyType.PLAN_CARRIER_NAME:
                return PlanFilterAbbreviation.CARRIER;
            case FilterKeyType.PLAN_SUB_TYPE:
                return PlanFilterAbbreviation.PLAN_SUBTYPES;
            case FilterKeyType.PLAN_TYPE_SHORT:
            case FilterKeyType.PLAN_TYPE_DESCRIPTION:
                return PlanFilterAbbreviation.PLANTYPE;
            case FilterKeyType.PLAN_RATING:
                return PlanFilterAbbreviation.RATING;
            default:
                return filterKeyType;
        }
    }
    getFilterValues(selectedFilterType, filterValue) {
        if (selectedFilterType.key === FilterKeyType.SNP_BASE_TYPE || selectedFilterType.key === FilterKeyType.PLAN_RATING) {
            return selectedFilterType.values?.filter(value => value !== filterValue?.value) || [];
        }
        else if (selectedFilterType.key === FilterKeyType.PLAN_BENEFIT_NAME) {
            return selectedFilterType.values?.filter(value => value?.benefitID !== filterValue?.value) || [];
        }
        else if (selectedFilterType.key === FilterKeyType.PLAN_ISPUF) {
            return selectedFilterType.values?.filter(value => value !== filterValue?.value) || [];
        }
        else if (selectedFilterType.key === FilterKeyType.PLAN_MAXIMUM_OUT_POCKET_COST ||
            selectedFilterType.key === FilterKeyType.PLAN_MEDICAL_DEDUCTIBLE ||
            selectedFilterType.key === FilterKeyType.PLAN_DRUG_PREMIUM ||
            selectedFilterType.key === FilterKeyType.PLAN_PREMIUM) {
            return selectedFilterType.values?.filter(value => value?.label !== filterValue?.value?.label) || [];
        }
        else if (selectedFilterType.key === FilterKeyType.RIDERS_PLAN_SUB_TYPE) {
            return selectedFilterType.values?.filter(value => !_isEqual(value.predicates, filterValue?.value?.predicates)) || [];
        }
        else if (selectedFilterType.key === FilterKeyType.SNP_CATEGORY) {
            return selectedFilterType.values?.filter(value => !_isEqual(value, filterValue?.value)) || [];
        }
        else {
            return (selectedFilterType.values?.filter(value => (value?.label ? value?.label !== filterValue?.label : value !== filterValue?.label)) ||
                []);
        }
    }
    setFocusToFilterPlansButton() {
        if (this.planListFilterButtonElement) {
            this.planListFilterButtonElement.nativeElement.focus();
        }
    }
    async editZipCode() {
        const options = {
            ariaLabelledBy: 'modalHeaderTitle',
            centered: true,
            injector: this.injector
        };
        this.isZipModalOpen = true;
        this._isFirstAppearsEditZipCodeModal$.next(true);
        this.modalService
            .open(ZipCodeModalComponent, options)
            .result.then(async () => {
            this.removeAllPlansFromCompareGroup();
            this.clearAllFilters();
            const answersSources = [this.hasMedSupAnswers$];
            const loadingQuestionSources = [this.medSupService.getLoadingMedSupQuestions$()];
            if (this.Spa_PlanList_Tab_Show_DENTAL || this.Spa_PlanList_Tab_Show_VISION) {
                answersSources.push(this.hasAncillaryAnswers$);
                loadingQuestionSources.push(this.plansService.getLoadingAncillaryQuestions$());
            }
            else {
                // Push an Observable that emits the default value to keep the positions in the array when dental/vision feature is disabled
                answersSources.push(of(false));
            }
            if (this.Spa_PlanList_Tab_Show_HIP) {
                answersSources.push(this.hasHospitalIndemnityAnswers$);
                loadingQuestionSources.push(this.plansService.getLoadingHospitalIndemnityQuestions$());
                this.clearRateFactorPlan();
            }
            combineLatest(answersSources)
                .pipe(take(1))
                .subscribe({
                next: ([hasMedSupAnswers, hasDentalVisionAnswers, hasHospitalIndemnityAnswers]) => {
                    if (hasMedSupAnswers) {
                        this.zipCodeService.updateZipCountyForMedSupAnswers();
                    }
                    if (hasDentalVisionAnswers) {
                        this.updateZipCountyForDentalVisionAnswers();
                    }
                    if (hasHospitalIndemnityAnswers) {
                        this.updateZipCountyForHospitalIndemnityAnswers();
                    }
                }
            });
            this.medSupService.fetchMedSupQuestions();
            if (!(this.Spa_Site_ForceMedSupFormBeforePlansList || this.Spa_PlanList_ShowAllMedigap_Enabled)) {
                this.medSupService.setMedSupFormOpenSource(false);
            }
            if (this.Spa_PlanList_Tab_Show_DENTAL || this.Spa_PlanList_Tab_Show_VISION) {
                this.medSupService.fetchDentalVisionQuestions();
            }
            if (this.Spa_PlanList_Tab_Show_HIP) {
                this.hospitalIndemnityFormFacade.fetchHospitalIndemnityQuestions();
            }
            const currentFilterGroups = this.planListFacade.getFilterGroups();
            if (!currentFilterGroups.length) {
                this.initTabs();
            }
            // Disabling the active tab's plan count check before fetching the plans ensures to keep the current active tab.
            // This will prevent any undesired automatic selections while the plans and plan counts are being updated.
            // Once it is done, we will enabled it back to check if the current tab still has coverage or we should select another automatically
            this.plansService.setActiveTabPlanCountCheckEnabled(false);
            // zip changed so we need to reset the plans in the store
            this.plansService.resetPlans();
            // I believe we need to set this here so we calculate the active tab if plan scores are available
            // when the zip changes and we re-fetch plans again
            this.plansService.setOverrideActiveTab(true);
            combineLatest(loadingQuestionSources)
                .pipe(filter((loadingRateFactorQuestions) => loadingRateFactorQuestions.every(loadingQuestions => !loadingQuestions)), take(1), switchMap(() => from(this.fetchPlans())), 
            // wait for the plans and short to finish loading in order to verify the visible tabs based on their available plans count
            switchMap(() => this.arePlansOrShortPlansLoading$), filter(arePlansOrShortPlansLoading => !arePlansOrShortPlansLoading), take(1))
                .subscribe({
                next: () => {
                    // Ensures to check the active tab's plan count to select a tab with coverage
                    this.plansService.setActiveTabPlanCountCheckEnabled(true);
                    // then we update the active tab and set the current tab based on the same criteria of visible tabs after fetching the plans
                    this.setCurrentTab();
                    this.updatePrimaryPlanListPageTags();
                }
            });
        })
            .catch(() => {
            // If a new zip code is entered, we will fetch its counties and replace the existing counties of the current zip
            // In case the user cancel the edition, we fetch again the counties for the current zip code to display the selected county
            const selectedZipCode = this.demographicService.getSelectedZipCode();
            if (selectedZipCode) {
                this.demographicService.fetchCountyData(selectedZipCode);
            }
        })
            .finally(() => {
            this.isZipModalOpen = false;
        });
    }
    /**
     * Updates Dental/Vision zipcode and County once the zipcode is changed
     */
    updateZipCountyForDentalVisionAnswers() {
        const ancillaryQuestions = this.medSupService.getAncillaryQuestions();
        if (ancillaryQuestions.length > 0) {
            const demographicsOptions = this.plansService.createPlansDemographicsOptionsWithDefaults();
            const savedAnswers = this.medSupService.getAncillaryAnswers();
            if (demographicsOptions.zip !== savedAnswers.ZipCode && demographicsOptions.fips !== savedAnswers.County_FIPS) {
                const sessionId = this.configurableWidgetService.store.selectSnapshot(MemberState.sessionId);
                const year = this.planYearResourceService.getSelectedPlanYear();
                const updatedAncillaryQuestions = this.zipCodeService.updateZipCountyAnswers(demographicsOptions, savedAnswers, ancillaryQuestions);
                if (this.Spa_PlanList_Tab_Show_DENTAL) {
                    this.medSupService.getAncillarySelectedQuestions(sessionId, year, updatedAncillaryQuestions, ProductType.DENTAL);
                }
                if (this.Spa_PlanList_Tab_Show_VISION) {
                    this.medSupService.getAncillarySelectedQuestions(sessionId, year, updatedAncillaryQuestions, ProductType.VISION);
                }
            }
        }
    }
    /**
     * Updates Hospital Indemnity zipcode and County once the zipcode is changed
     */
    updateZipCountyForHospitalIndemnityAnswers() {
        const hospitalIndemnityQuestions = this.hospitalIndemnityFormFacade.getHospitalIndemnityQuestions();
        if (hospitalIndemnityQuestions.length > 0) {
            const demographicsOptions = this.plansService.createPlansDemographicsOptionsWithDefaults();
            const savedAnswers = this.hospitalIndemnityFormFacade.getHospitalIndemnityAnswers();
            if (demographicsOptions.zip !== savedAnswers.ZipCode && demographicsOptions.fips !== savedAnswers.County_FIPS) {
                const { sessionId, year } = this.hospitalIndemnityFormFacade.getRateFactorSessionDetails();
                const updatedHospitalIndemnityQuestions = this.zipCodeService.updateZipCountyAnswers(demographicsOptions, savedAnswers, hospitalIndemnityQuestions);
                this.hospitalIndemnityFormFacade.getHospitalIndemnitySelectedQuestions(sessionId, year, updatedHospitalIndemnityQuestions);
            }
        }
    }
    removeAllPlansFromCompareGroup() {
        const compareGroups = this.tabs.map(group => group.compareGroup[0]);
        compareGroups.forEach(compareGroup => {
            this.planCompareService.removeAllPlansFromCompareGroup([compareGroup]);
        });
    }
    /**
     * tabChanged - if we have selected/clicked a new individual tab rather than landing on a tab on init or redirect
     * we want to know this because on page load we need to load multiple tabs types for best match to do cross tab
     * comparison where as when we navigate to a tab directly we just want to load those plans
     */
    async fetchPlans(activeTabType, tabChanged, planYearUpdate) {
        const hospitalIndemnityAnswers = this.plansService.getHospitalIndemnityAnswers();
        const dentalVisionAnswers = this.medSupService.getAncillaryAnswers();
        const medigapAnswers = this.medSupService.getMedSupAnswers();
        const medicineCabinet = this.configurableWidgetService.store.selectSnapshot(MedicineCabinetState.medicineCabinet);
        const memberData = this.memberSessionService.getMemberSession();
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        const pharmacies = this.plansService.getSelectedAPIPharmacyInfo();
        // MedSup Premium filter
        this.addPremiumFilter(medigapAnswers, [PlanTypeAbbreviation.MEDIGAP]);
        if (this.Spa_PlanList_Tab_Show_DENTAL) {
            // Dental Premium filter
            this.addPremiumFilter(dentalVisionAnswers, ANCILLARY_PLANS);
        }
        if (this.Spa_PlanList_Tab_Show_VISION) {
            // Vision Premium filter
            this.addPremiumFilter(dentalVisionAnswers, ANCILLARY_PLANS.reverse());
        }
        if (this.Spa_PlanList_Tab_Show_HIP) {
            // Hospital Indemnity Premium filter
            this.addPremiumFilter(hospitalIndemnityAnswers, [PlanTypeAbbreviation.HC]);
        }
        const demographicsOptions = this.plansService.createPlansDemographicsOptionsWithDefaults();
        const activeTabAbbreviation = this.plansService.getActivePlanTypeAbbreviation(activeTabType ?? this.activeTabType, this.tabs);
        const activePlanType = this.plansService.getActivePlanType(activeTabType ?? this.activeTabType, this.tabs);
        let searchPlanTypes = this.plansService.getSearchPlanTypes(activePlanType, tabChanged);
        if (this.showSelectPlanQuote && !this.plansService.getArePlanTypesLoaded([PlanType.MEDICARE])) {
            // SPA-13248 HIP tab (and theoretically any tab) needs MA/MAPD plans loaded for the sake of selecting plans via a dropdown for quotes
            // So if we are able to show that section, we need to load those plans at the same time.
            searchPlanTypes.push(PlanType.MEDICARE);
            searchPlanTypes = [...new Set(searchPlanTypes)];
        }
        const overrideSearchOptions = { planType: PlansUtilityService.toBitWiseString(searchPlanTypes) };
        const searchOptions = this.plansService.createPlansSearchOptionsWithDefaults(overrideSearchOptions);
        const providers = this.providerService.getNpiAndAddressOfSelectedProviders();
        const sendPreferencesFlag = this.setSendPreferencesFlag(pharmacies, medicineCabinet, this.Spa_Site_Preferences_Score_Enabled);
        if ((this.plansService.getArePlanTypesDirty(searchPlanTypes) &&
            !this.plansService.getArePlanTypesLoading(searchPlanTypes) &&
            this.plansService.validPlansCallData(demographicsOptions, searchOptions)) ||
            this.isRetentionView) {
            const hasUnloadedPlanTypes = !!this.plansService.getUnloadedPlanTypes(searchPlanTypes)?.length;
            const hasQuestionsIfRequired = this.medSupService.hasQuestionsIfRequired(activeTabAbbreviation);
            // if plans or plan counts are never loaded we do not have the information we need to open the medsup
            // form before plans list if required. this is because we need to know if there are plans available
            // before forcing the form before plans list and if we have no plans and no counts we cannot tell if
            // plans are available. because of this we always need to load plan counts to know ahead of time if
            // plans are available and thus we can open the form before plans
            const planCountsLoaded = this.plansService.arePlanCountsLoaded();
            if (planYearUpdate || (!this.forceFormBeforePlansList(activeTabAbbreviation) && hasQuestionsIfRequired)) {
                return await this.fetchPlansWithOptions(demographicsOptions, searchOptions, pharmacies, providers, medicineCabinet, memberData, dentalVisionAnswers, hospitalIndemnityAnswers, medigapAnswers, agentGuid, hasUnloadedPlanTypes, hasQuestionsIfRequired, sendPreferencesFlag, false);
                // if we need to show the form before plans can be loaded we still want to get plan counts
                // if we arent already loading them
            }
            else if ((hasUnloadedPlanTypes || !planCountsLoaded) && !this.planShortLoading) {
                return await this.fetchPlansWithOptions(demographicsOptions, searchOptions, pharmacies, providers, medicineCabinet, memberData, dentalVisionAnswers, hospitalIndemnityAnswers, medigapAnswers, agentGuid, hasUnloadedPlanTypes || !planCountsLoaded, hasQuestionsIfRequired, sendPreferencesFlag, true // just making the plan short call
                );
            }
        }
        if (this.planListFacade.zipCode) {
            this.trackPlanListInfoOnPageLoadOnce = true;
        }
    }
    addPremiumFilter(answers, planType) {
        if (RateFactorsUtilityService.hasAnswers(answers)) {
            this.clearAllSelectedFilters(planType);
            this.configurableWidgetService.filterService.addFilterToFilterGroups([new Filter({ key: FilterKeyType.PLAN_TYPE_SHORT, values: planType })], // which tab (filter group) to add the filter to
            new Filter({ key: FilterKeyType.PLAN_PREMIUM, values: [], comparator: ComparatorType.EXISTS, visible: false }) // filter to add
            );
            // Consider the tab's first type value as the main type
            const tab = this.Spa_PlanList_Tabs_Data.find(tabs => tabs.tabTypes[0] === planType[0]);
            this.planListFacade.updateTabSortGroups(tab, sort => sort.isDefault);
        }
    }
    setSendPreferencesFlag(pharmacies, medicineCabinet, preferenceScoreEnabled) {
        let sendFlag = false;
        if (preferenceScoreEnabled) {
            if (pharmacies?.length) {
                sendFlag = true;
            }
            if (!sendFlag) {
                // performance: fetch the providers info from the store
                const hasProviders = this.providerService.hasProviders();
                if (hasProviders) {
                    sendFlag = true;
                }
            }
            if (!sendFlag) {
                const hasSelectedProviders = this.providerService.hasSelectedProviders();
                if (hasSelectedProviders) {
                    sendFlag = true;
                }
            }
            if (!sendFlag) {
                const hasDrugs = medicineCabinet && Object.keys(medicineCabinet).length > 0;
                if (preferenceScoreEnabled && hasDrugs) {
                    sendFlag = true;
                }
            }
            this.weights = this.preferencesService.getPreferenceWeights();
            this.preferences = this.weights;
            const preferenceQuestionsAndAnswers = this.preferencesService.getPreferenceQuestionAnswers();
            if (preferenceQuestionsAndAnswers?.length) {
                this.preferences.forEach(preference => {
                    const preferenceQA = preferenceQuestionsAndAnswers.find(preferenceQA => preferenceQA.key === preference.key);
                    if (preferenceQA) {
                        preference.values = preferenceQA.values;
                        if (!sendFlag && preferenceQA.values.length) {
                            sendFlag = true;
                        }
                    }
                });
            }
            else {
                this.preferences.forEach(preference => {
                    if (preference.key === PreferenceType.BENEFITS ||
                        preference.key === PreferenceType.CHRONIC ||
                        preference.key === PreferenceType.MEDSUP) {
                        preference.values = [];
                    }
                });
            }
        }
        return sendFlag;
    }
    clearAllSelectedFilters(tabType) {
        this.configurableWidgetService.filterService.clearFilterGroupFilters([
            new Filter({ key: FilterKeyType.PLAN_TYPE_SHORT, values: tabType })
        ]);
    }
    replaceAdditionalGiQuestionText(medSupQuestions) {
        return medSupQuestions.map(question => {
            if (question.name === MedSupQuestionNames.GIAdditional) {
                return { ...question, text: this.Spa_PlanList_GuaranteedIssue_Header };
            }
            return question;
        });
    }
    medSupFormClose(fetchPlans) {
        const hasMedSupAnswers = this.plansService.getHasMedSupAnswers();
        this.fetchPlansAfterRateFactorsFormClose(fetchPlans, PlanTypeAbbreviation.MEDIGAP);
        if (fetchPlans || !(this.Spa_Site_ForceMedSupFormBeforePlansList || this.Spa_PlanList_ShowAllMedigap_Enabled) || hasMedSupAnswers) {
            // Do not allow them to close the form if they clicked previous,
            // and the site is configured to show form by default, and there are no answers yet
            this.planFacade.updateMedSupFormOpen(false);
            if (fetchPlans && hasMedSupAnswers) {
                this.planFacade.updateDentalVisionFormOpen(false);
                this.hospitalIndemnityFormFacade.updateHospitalIndemnityFormOpen(false);
            }
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }
    dentalVisionFormClose(fetchPlans) {
        const hasAncillaryAnswers = this.plansService.getHasAncillaryPlanAnswers();
        this.fetchPlansAfterRateFactorsFormClose(fetchPlans);
        if (fetchPlans || !this.Spa_Site_ForceDentalVisionFormBeforePlansList || hasAncillaryAnswers) {
            // Do not allow them to close the form if they clicked previous,
            // and the site is configured to show form by default, and there are no answers yet
            this.planFacade.updateDentalVisionFormOpen(false);
            if (fetchPlans && hasAncillaryAnswers) {
                this.planFacade.updateMedSupFormOpen(false);
                this.hospitalIndemnityFormFacade.updateHospitalIndemnityFormOpen(false);
            }
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }
    onHospitalIndemnityFormClose(fetchPlans) {
        this.fetchPlansAfterRateFactorsFormClose(fetchPlans);
        this.hospitalIndemnityFormFacade.onHospitalIndemnityFormClose(fetchPlans);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    getPlansSelectedToQuote$() {
        return this.planListFacade.getPlansSelectedToQuote$();
    }
    getHospitalIndemnityPlansSelectedToQuote$() {
        return this.planCompareFacade
            .getHospitalIndemnityPlansSelectedForQuote$()
            .pipe(map((activeCompareGroup) => activeCompareGroup?.items || []));
    }
    removeHospitalIndemnityPlanFromQuoteGroup(selectedQuoteGroup, plan) {
        this.planCompareService.removePlanFromCompareGroup([selectedQuoteGroup], plan);
        if (plan.id === this.selectedPlanNameToQuote?.id) {
            this.clearRateFactorPlan();
        }
    }
    openHospitalIndemnityViewQuote() {
        if (this.selectedHospitalIndemnityPlans.length === 1) {
            this.planFacade.viewPlanDetailsPage(this.selectedHospitalIndemnityPlans[0]);
            return;
        }
        this.planCompareService.setPlanComparePlanType(this.activeTabType);
        this.navigationService.navigateByPageTag(PageTags.HOSPITAL_INDEMNITY_VIEW_QUOTE);
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_PLANS_COMPARE);
    }
    getPersonalizedQuote(plan) {
        if (plan.planTypeAbbreviation === PlanTypeAbbreviation.MEDIGAP) {
            this.planFacade.updateMedSupFormOpen(true);
        }
        if (ANCILLARY_PLANS.includes(plan.planTypeAbbreviation)) {
            this.planFacade.updateDentalVisionFormOpen(true);
        }
    }
    // TODO: maybe need to get active tab... need to find out what is happening here before deciding
    async tagsToUpdate(initialPageLoad) {
        // Moves the isTagsToUpdate into this function instead of surrounding every call, but also makes it so
        // If we have a zip, but the plans are not yet loaded, we skip analytics.
        // Zip code check is needed for the sake of anonymous consumers (or other scenarios) landing on the plan list page without a zip,
        // and thus no plans being loaded is a valid case.
        if (!initialPageLoad &&
            (!this.isTagsToUpdate || (this.demographicService.getSelectedZipCode() && !this.store.selectSnapshot(PlansState.loaded)))) {
            return;
        }
        const activeTabType = this.configurableWidgetService.store.selectSnapshot(PlansState.activeTabType);
        if (!this.analyticsService.googleDataLayerTags[DataLayerGlobalVariable.CLIENT_GAID]) {
            let additionalDataLayerTags = {};
            if (this.isRetentionView) {
                this.isTagsToUpdate = false;
                additionalDataLayerTags = {
                    ...additionalDataLayerTags,
                    ...this.getRetentionTags(activeTabType)
                };
            }
            else {
                if (activeTabType) {
                    this.isTagsToUpdate = false;
                    additionalDataLayerTags = {
                        ...additionalDataLayerTags,
                        ...(await this.getActiveTabTags(activeTabType))
                    };
                }
            }
            await this.analyticsService.initializeGoogleDataLayerTags(additionalDataLayerTags);
            return;
        }
        if (this.isRetentionView) {
            this.isTagsToUpdate = false;
            this.analyticsService.googleDataLayerTags = this.getRetentionTags(activeTabType);
        }
        else {
            if (activeTabType) {
                this.isTagsToUpdate = false;
                this.analyticsService.googleDataLayerTags = await this.getActiveTabTags(activeTabType);
            }
        }
    }
    shiftFocusToTabElement(focusIndex) {
        if (this.planListTabElement) {
            this.planListTabElement.forEach(tabElement => tabElement.nativeElement.firstElementChild.setAttribute('tabindex', '-1'));
            const optionElement = this.planListTabElement.find((_element, index) => index === focusIndex);
            if (optionElement) {
                optionElement.nativeElement.firstElementChild.setAttribute('tabindex', '0');
                optionElement.nativeElement.firstElementChild.focus();
            }
        }
    }
    updateSelectedPharmacy(updatedPharmacy) {
        this.pharmacyFacade.switchMailOrder(false);
        this.pharmacyFacade.setSelectedPharmacy(updatedPharmacy);
        this.planListFacade.updateMailOrder(false);
        this.getExistingSortAndUpdate();
    }
    selectMailOrder() {
        this.pharmacyFacade.switchMailOrder(true);
        this.planListFacade.updateMailOrder(true);
        this.getExistingSortAndUpdate();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        // Important: unsubscribing first prevents further undesired handling of possible emissions during cleanup.
        this.subscriptions.unsubscribe();
        this.planFacade.updateMedSupFormOpen(false);
        this.planFacade.updateDentalVisionFormOpen(false);
        this.hospitalIndemnityFormFacade.updateHospitalIndemnityFormOpen(false);
        // Reset override flag to true
        const activeTab = this.activeTabType;
        this.plansService.setOverrideActiveTab(true);
        this.planListFacade.updateActiveTab(activeTab);
        this.spinnerService.reset();
        // Ensures to check the active tab's plan count to select a tab with coverage
        this.plansService.setActiveTabPlanCountCheckEnabled(true);
        // reset selected plan smart details
        this.store.dispatch(new ResetSelectedPlanSmartDetails());
    }
    toggleSNPPlanVisibility(snpVisibility) {
        if (!snpVisibility) {
            this.activeTabType$.pipe(take(1)).subscribe({
                next: tabType => {
                    const filter = { comparator: ComparatorType.EQUAL, key: FilterKeyType.PLAN_TYPE_SHORT, values: [tabType] };
                    this.filterService.clearFilterGroupFilter([filter], FilterKeyType.SNP_BASE_TYPE);
                }
            });
        }
        this.snpService.setAllSNPTypesVisibility(snpVisibility);
        this.snpVisibility = snpVisibility;
    }
    areAnySNPTypesVisible(snpTypeVisibility) {
        return snpTypeVisibility.dSNP || snpTypeVisibility.cSNP || snpTypeVisibility.iSNP;
    }
    areAllSNPTypesVisible(snpTypeVisibility) {
        return snpTypeVisibility.dSNP && snpTypeVisibility.cSNP && snpTypeVisibility.iSNP;
    }
    onScrollDown() {
        this.visiblePlanIndex$.pipe(take(1)).subscribe({
            next: visiblePlanIndex => {
                if (this.filteredPlans?.length > visiblePlanIndex) {
                    this._visiblePlanIndex$.next(visiblePlanIndex + 5);
                }
            }
        });
    }
    medsupPlanSubTypeChanged(selectedPlanSubType) {
        this.isMedsupPlanSubTypeChange = true;
        // updatedPlanSubType contains the plan type dropdown selection value until user applied the selected filters for filter modal UI
        this.updatedPlanSubType = selectedPlanSubType;
    }
    planSubTypeChanged() {
        this.fetchPlans().then(() => {
            this.updatePrimaryPlanListPageTags();
        });
    }
    getReturnToPreferencesClickAction() {
        return this.planListFacade.getReturnToPreferencesClickAction(this.Spa_PlanList_BestCoverageType_Tooltip, this.Spa_Site_ReturnToPreferences_Text);
    }
    selectPlanNameToQuote(plan) {
        this.selectedPlanNameToQuote = plan;
        if (this.activeTabType === PlanTypeAbbreviation.HC &&
            (this.selectedHospitalIndemnityPlans.length < this.addToQuoteLimit ||
                this.selectedHospitalIndemnityPlans.some((hospitalIndemnityPlan) => !this.planFacade.isHCPlan(hospitalIndemnityPlan)))) {
            this.planCompareService.updateFirstPlanInCompareGroup([this.tabs[this.activeTabIndex].compareGroup[0]], this.selectedPlanNameToQuote);
            this.showAddMedicareAdvantagePlan = false;
        }
        else {
            this.quoteService.updateFirstPlanInQuoteGroup([this.tabs[this.activeTabIndex].quoteGroups[0]], this.selectedPlanNameToQuote);
        }
        this.plansService.setRateFactorPlan(this.selectedPlanNameToQuote);
        this.displayPlanQuote();
        this.updateShowSelectPlanQuote();
    }
    addMedicareAdvantagePlan() {
        this.showAddMedicareAdvantagePlan = true;
        this.updateShowSelectPlanQuote();
    }
    removePlanFromQuoteGroup(selectedQuoteGroup, plan) {
        this.planFacade.removePlanFromQuoteGroup(selectedQuoteGroup, plan);
        if (plan.id === this.selectedPlanNameToQuote?.id) {
            this.clearRateFactorPlan();
        }
    }
    quoteGroupChanged() {
        if (!this.selectedPlanNameToQuote && this.selectedHospitalIndemnityPlans.length > 0) {
            this.showAddMedicareAdvantagePlan = false;
            this.updateShowSelectPlanQuote();
        }
    }
    onEffectiveDateModalChange() {
        this.fetchPlans();
    }
    updateActiveTab(plan) {
        this.planListFacade.updateActiveTab(plan.planTypeAbbreviation);
    }
    async onPlanYearUpdate() {
        // Clearing the plan year session data will also reset the plan counts and the plan type data map. Therefore, we reset this flag to fetch the plans below
        this.hasFinishedInitialPlansLoad = false;
        // Disabling the active tab's plan count check before clearing the plan year session ensures to keep the current active tab.
        // This will prevent any undesired automatic selections while the plans and plan counts are being updated.
        // Once it is done, we will enabled it back to check if the current tab still has coverage or we should select another automatically
        this.plansService.setActiveTabPlanCountCheckEnabled(false);
        this.planYearService.clearPlanYearSessionData();
        this.plansService.resetTotalCostEffectiveDate();
        this.plansService.setIsSelectedEffectiveDate(false);
        await this.planFacade.setDefaultEffectiveDate();
        this.fetchPlans(undefined, undefined, true).then(() => {
            this.hasFinishedInitialPlansLoad = true;
            // Ensures to check the active tab's plan count to select a tab with coverage
            this.plansService.setActiveTabPlanCountCheckEnabled(true);
        });
    }
    async fetchPlansWithOptions(demographicsOptions, searchOptions, pharmacies, providers, medicineCabinet, memberData, ancillaryAnswers, hospitalIndemnityAnswers, medSupAnswers, agentGuid, fetchPlanCounts, hasQuestionsIfRequired, sendPreferencesFlag, shortDataOnly) {
        const planType = searchOptions?.planType ? +searchOptions.planType : 0;
        // only get plan counts if we have unloaded plan types
        searchOptions.planCount = fetchPlanCounts;
        // only score plans if preferences are enabled
        searchOptions.scorePlans = sendPreferencesFlag && this.plansService.isScoredPlanType(planType) && hasQuestionsIfRequired;
        let drugs = [];
        const hasCabinetEntries = medicineCabinet && Object.keys(medicineCabinet).length > 0;
        if (hasCabinetEntries) {
            drugs = this.drugsService.mapCabinetToDosage(medicineCabinet);
        }
        let currentYearPlanId;
        if (memberData?.currentYearPlanID) {
            currentYearPlanId = memberData.currentYearPlanID;
        }
        this.planYearService.setHasPlanYearPermissionError(false);
        if (this.showNonLicensed) {
            this.showNonLicensed = !this.showNonLicensed;
            this.cdr.markForCheck();
        }
        const includeBenefits = this.Spa_Filter_PlanBenefitsGroup_Enabled;
        searchOptions.getClientDefinedPlans = this.configResourceService.getProcessedResourceValue('Spa_Retention_ClientDefinedPlanOptions_Enabled', null, false);
        let memberID = '';
        if (searchOptions.getClientDefinedPlans) {
            memberID = this.store.selectSnapshot(MemberState.memberID);
        }
        try {
            const plans = await this.plansService.fetchPlansByOptionsAndSave({
                demographicsOptions,
                searchOptions,
                medigapAnswers: this.plansService.getMergedMedigapAnswers({ medSupAnswers, ancillaryAnswers, hospitalIndemnityAnswers }),
                drugs,
                pharmacies,
                providers,
                currentYearPlanId,
                includeBenefits,
                agentGuid,
                memberID,
                ...(sendPreferencesFlag && { preferences: this.preferences }),
                externallyRatedDataFetchType: ExternallyRatedDataFetchType.SEQUENTIAL,
                shortDataOnly
            });
            const splitPlanTypes = PlansUtilityService.splitBitWise(planType);
            const hasProviderType = PlansUtilityService.hasProviderType(splitPlanTypes);
            // If we are not scoring plans we won't be getting providerNetworks but may need them without scores
            // so we can still make this call if we didn't call for plan scores in the plan short call.
            if (!shortDataOnly &&
                plans?.length &&
                this.Spa_Site_Providers_Enabled &&
                // SPA-14342: Currently, only MAPD and MA have providers.
                // We check if the plan type contains them since they're fetched as part of Medicare plans
                hasProviderType) {
                this.providerService
                    .fetchProvidersDetailsBasedOnAvailablePlans$(plans, false // This would return way too much data if it's ever true, should only be true for 1-3 plan scenarios
                )
                    .pipe(take(1))
                    .subscribe({
                    next: (providerDetails) => {
                        this.store.dispatch(new SetProvidersDetails(providerDetails));
                        this.cdr.markForCheck();
                    }
                });
            }
            // We wait for the plans/short to finish loading before tracking the Plan List info to prevent a plan count mismatch
            this.subscriptions.add(combineLatest([this.plansLoading$, this.planShortLoading$])
                .pipe(distinctUntilChanged(_isEqual), filter(([arePlansLoading, isPlanShortLoading]) => !arePlansLoading && !isPlanShortLoading), take(1))
                .subscribe({
                next: () => {
                    this.trackPlanListInfo(AnalyticsActionType.PAGELOAD);
                }
            }));
            return plans;
        }
        catch (error) {
            this.plansService.setPlansLoading(this.plansService.getAllPlansSearchPlanTypes(), false);
            this.processPlansError(error);
        }
    }
    forceFormBeforePlansList(activeTabType) {
        if (activeTabType === PlanTypeAbbreviation.MEDIGAP) {
            const hasAllMedSupAnswers = this.planListFacade.getAreAllMedSupQuestionsAnswered();
            if (this.Spa_Site_ForceMedSupFormBeforePlansList || this.Spa_PlanList_ShowAllMedigap_Enabled) {
                return !hasAllMedSupAnswers;
            }
            return this.plansService.getHasMedSupAnswers() && !hasAllMedSupAnswers;
        }
        if ([PlanTypeAbbreviation.DENTAL, PlanTypeAbbreviation.VISION].includes(activeTabType)) {
            const hasAllDentalVisionAnswers = this.planListFacade.getAreAllAncillaryQuestionsAnswered();
            return this.Spa_Site_ForceDentalVisionFormBeforePlansList && !hasAllDentalVisionAnswers;
        }
        if (activeTabType === PlanTypeAbbreviation.HC) {
            const hasAllHospitalIndemnityAnswers = this.hospitalIndemnityFormFacade.getAreAllHospitalIndemnityQuestionsAnswered();
            return !hasAllHospitalIndemnityAnswers;
        }
        return false;
    }
    fetchPlansAfterRateFactorsFormClose(fetchPlans, planTypeAbbreviation) {
        if (fetchPlans) {
            this.plansService.setActiveTabPlanCountCheckEnabled(false);
            this.removeAllPlansFromCompareGroup();
            this.clearAllFilters();
            this.fetchPlans(planTypeAbbreviation, !!planTypeAbbreviation).then(() => {
                this.updatePrimaryPlanListPageTags();
                this.spinnerService.hide(SpinnerEvent.PLANS_LOADING);
                this.plansService.setActiveTabPlanCountCheckEnabled(true);
            });
        }
    }
    setMedicareQuoteParams() {
        if (this.isSelectPlanQuote) {
            this.activeRateFactorPlan = this.plansService.getRateFactorPlan();
            if (this.activeRateFactorPlan) {
                this.selectPlanNameToQuote(this.activeRateFactorPlan);
            }
        }
    }
    displayPlanQuote() {
        this.showPlanQuote = this.planFacade.isSendQuoteAvailable(this.activeTabType);
    }
    getNonLicensedPlanTags() {
        return {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLANS_VIEW_NON_LICENSED
        };
    }
    getFilters() {
        this.planFilterItemsFacade
            .getCarriersControls$(this.trackingFilterList$)
            .pipe(take(1))
            .subscribe(carriers => {
            this.carriersFilters = carriers && carriers.length > 1 ? this.getFiltersSelectionInfo(carriers, this.appliedFilterValues) : {};
        });
        this.planFilterItemsFacade
            .getPlanSubTypeControls$(this.trackingFilterList$)
            .pipe(take(1))
            .subscribe(planSubTypes => {
            this.planSubTypeFilters =
                planSubTypes && planSubTypes.length > 1
                    ? this.getFiltersSelectionInfo(planSubTypes, this.appliedFilterValues, this.comboPlans)
                    : {};
        });
        if (this.Spa_Filter_PlanBenefitsGroup_Enabled && this.Spa_Filter_InsulinSavings_Enabled) {
            this.planFilterItemsFacade
                .getModelDrugProgramControls$(this.trackingFilterList$)
                .pipe(take(1))
                .subscribe(modelDrugPrograms => {
                this.modelDrugProgramsFilters = this.getFiltersSelectionInfo(modelDrugPrograms, this.appliedFilterValues);
            });
        }
        const hasSellablePlans = this.filteredPlans?.some(plan => !!plan.isPUF);
        const isActiveTabMedigap = this.currentTab?.tabTypes.includes(PlanTypeAbbreviation.MEDIGAP);
        if (hasSellablePlans && !isActiveTabMedigap) {
            this.planFilterItemsFacade
                .getPlanSellableControls$(this.trackingFilterList$)
                .pipe(take(1))
                .subscribe(planSellable => {
                this.planSellableFilters = this.getFiltersSelectionInfo(planSellable, this.appliedFilterValues);
            });
        }
        if (this.Spa_Site_SNPTools_Enabled) {
            this.planFilterItemsFacade
                .getCSNPBaseControls$(this.trackingFilterList$)
                .pipe(take(1))
                .subscribe(cSNPBaseType => {
                this.cSNPBaseTypeFilters = this.getFiltersSelectionInfo(cSNPBaseType, this.appliedFilterValues);
                this.planFilterItemsFacade
                    .getSNPSubControls$(this.trackingFilterList$, SNP_CATEGORY_FILTER_TYPES.ID_IS_CSNP, cSNPBaseType[0]?.value)
                    .pipe(take(1))
                    .subscribe(cSNPSubTypes => {
                    this.cSNPSubTypesFilters = this.getFiltersSelectionInfo(cSNPSubTypes, this.appliedFilterValues);
                });
            });
            this.planFilterItemsFacade
                .getDSNPBaseControls$(this.trackingFilterList$)
                .pipe(take(1))
                .subscribe(dSNPBaseTypes => {
                this.dSNPBaseTypesFilters = this.getFiltersSelectionInfo(dSNPBaseTypes, this.appliedFilterValues);
            });
            if (this.Spa_Filter_DSNPMedicaidCodes_Enabled) {
                this.planFilterItemsFacade
                    .getDSNPSubControls$(this.trackingFilterList$)
                    .pipe(take(1))
                    .subscribe(dSNPSubTypes => {
                    this.dSNPSubTypesFilters = this.getFiltersSelectionInfo(dSNPSubTypes, this.appliedFilterValues);
                });
            }
            this.planFilterItemsFacade
                .getISNPBaseControls$(this.trackingFilterList$)
                .pipe(take(1))
                .subscribe(iSNPBaseTypes => {
                this.iSNPBaseTypesFilters = this.getFiltersSelectionInfo(iSNPBaseTypes, this.appliedFilterValues);
                this.planFilterItemsFacade
                    .getSNPSubControls$(this.trackingFilterList$, SNP_CATEGORY_FILTER_TYPES.ID_IS_ISNP, iSNPBaseTypes[0]?.value)
                    .pipe(take(1))
                    .subscribe(iSNPSubTypes => {
                    this.iSNPSubTypesFilters = this.getFiltersSelectionInfo(iSNPSubTypes, this.appliedFilterValues);
                });
            });
        }
        if (this.isCostFilterEnabled) {
            this.costFilterSelectionInfo(this.trackingFilterList$);
        }
        if (this.Spa_Filter_PlanBenefitsGroup_Enabled) {
            this.planFilterItemsFacade
                .getPlanBenefitsControls$(this.trackingFilterList$, this.Spa_Site_Default_Plan_Benefit_Filter)
                .pipe(take(1))
                .subscribe(planBenefits => {
                this.planBenefitsFilters = this.getFiltersSelectionInfo(planBenefits, this.appliedFilterValues);
            });
        }
        if (this.Spa_PlanList_AddOn_Filter_Enabled) {
            this.planFilterItemsFacade
                .getRidersControls$(this.trackingFilterList$)
                .pipe(take(1))
                .subscribe(riders => {
                this.addOnFilters = this.getFiltersSelectionInfo(riders, this.appliedFilterValues);
            });
        }
        if (this.Spa_Npi_Filter_Enabled) {
            this.planFilterItemsFacade
                .getProvidersNpiControls$(this.trackingFilterList$, this.Spa_Site_Provider_ShowAllInNetworkLocations_Enabled)
                .pipe(take(1))
                .subscribe(providers => {
                this.providerFilters = this.getFiltersSelectionInfo(providers, this.appliedFilterValues);
            });
        }
        const filtersSelected = this.getFiltersJsonString();
        return filtersSelected;
    }
    getFiltersJsonString() {
        let filtersJson = '';
        if (this.carriersFilters && Object.keys(this.carriersFilters).length > 0) {
            filtersJson = this.getJsonString(this.Spa_PlanFilters_CarrierLabel_Text, this.carriersFilters);
        }
        if (!(this.Spa_PlanList_ShowAllMedigap_Enabled && this.activeTabType === PlanTypeAbbreviation.MEDIGAP) &&
            this.planSubTypeFilters &&
            Object.keys(this.planSubTypeFilters).length > 0) {
            filtersJson += this.getJsonString(this.Spa_PlanFilters_SubType_Label, this.planSubTypeFilters);
        }
        if (this.Spa_Filter_PlanBenefitsGroup_Enabled &&
            ((this.modelDrugProgramsFilters && Object.keys(this.modelDrugProgramsFilters).length > 0) ||
                (this.planBenefitsFilters && Object.keys(this.planBenefitsFilters).length > 0))) {
            const planBenefitsAllFilters = { ...this.modelDrugProgramsFilters, ...this.planBenefitsFilters };
            filtersJson += this.getJsonString(this.Spa_Filter_AdditionalSavingsHeader_Text, planBenefitsAllFilters);
        }
        if (this.planSellableFilters && Object.keys(this.planSellableFilters).length > 0) {
            filtersJson += this.getJsonString(this.Spa_Filter_LicensingHeader_Text, this.planSellableFilters);
        }
        if (this.isCostFilterEnabled) {
            const costFiltersJsonString = this.getCostFiltersJsonString();
            if (costFiltersJsonString) {
                filtersJson += costFiltersJsonString;
            }
        }
        if (this.Spa_PlanList_AddOn_Filter_Enabled && this.addOnFilters && Object.keys(this.addOnFilters).length > 0) {
            filtersJson += this.getJsonString(this.Spa_PlanList_AddOn_Header_Text, this.addOnFilters);
        }
        if (this.Spa_Npi_Filter_Enabled &&
            this.Spa_Site_Providers_Enabled &&
            this.providerFilters &&
            Object.keys(this.providerFilters).length > 0) {
            filtersJson += this.getJsonString(this.Spa_Site_Providers_Header_Text, this.providerFilters);
        }
        if (this.activeTabType === PlanTypeAbbreviation.HC && this.numberOfDaysFilters && Object.keys(this.numberOfDaysFilters).length > 0) {
            filtersJson += this.getJsonString(this.Spa_PlanFilters_DayLabel_Text, this.numberOfDaysFilters);
        }
        const snpTypeFilters = {
            ...this.cSNPBaseTypeFilters,
            ...this.cSNPSubTypesFilters,
            ...this.dSNPBaseTypesFilters,
            ...this.dSNPSubTypesFilters,
            ...this.iSNPBaseTypesFilters,
            ...this.iSNPSubTypesFilters
        };
        if (snpTypeFilters && Object.keys(snpTypeFilters).length > 0) {
            filtersJson += this.getJsonString(this.Spa_Filter_SNPBaseTypes_Label, snpTypeFilters);
        }
        return filtersJson.slice(2);
    }
    getJsonString(filterType, filterObject) {
        return `, ${filterType}: ${JSON.stringify(filterObject)}`;
    }
    getFiltersSelectionInfo(filters, appliedFilterValues, comboPlans) {
        const filtersInfo = {};
        const comboPlanLabel = this.planFacade.getComboPlanLabel();
        if (filters?.length) {
            filters.forEach(filter => {
                if (filter) {
                    if (filter.label === comboPlanLabel) {
                        const filterValue = Array.isArray(filter.value) ? filter.value : [filter.value];
                        if (filterValue.every(comboPlan => comboPlans?.includes(comboPlan) && appliedFilterValues.includes(comboPlan))) {
                            filtersInfo[filter.label] = 'Y';
                        }
                    }
                    else if (appliedFilterValues?.some(appliedFilterValue => _isEqual(appliedFilterValue, filter.value))) {
                        filtersInfo[filter.label] = 'Y';
                    }
                    else {
                        filtersInfo[filter.label] = 'N';
                    }
                }
            });
        }
        return filtersInfo;
    }
    costFilterSelectionInfo(filterList$) {
        this.planFilterItemsFacade
            .getCostFilterControl$(filterList$, FilterKeyType.PLAN_MEDICAL_DEDUCTIBLE)
            .pipe(take(1))
            .subscribe(medicalDeductible => {
            this.medicalDeductibleFilters = this.getFiltersSelectionInfo(medicalDeductible, this.appliedFilterValues);
        });
        this.planFilterItemsFacade
            .getCostFilterControl$(filterList$, FilterKeyType.PLAN_MAXIMUM_OUT_POCKET_COST)
            .pipe(take(1))
            .subscribe(maximumOutOfPocketCost => {
            this.maximumOutOfPocketCostFilters = this.getFiltersSelectionInfo(maximumOutOfPocketCost, this.appliedFilterValues);
        });
        this.planFilterItemsFacade
            .getCostFilterControl$(filterList$, FilterKeyType.PLAN_PHARMACY_DEDUCTIBLE)
            .pipe(take(1))
            .subscribe(drugDeductible => {
            this.drugDeductibleFilters = this.getFiltersSelectionInfo(drugDeductible, this.appliedFilterValues);
        });
        this.planFilterItemsFacade
            .getCostFilterControl$(filterList$, FilterKeyType.PLAN_PREMIUM)
            .pipe(take(1))
            .subscribe(medicalPremium => {
            this.medicalPremiumFilters = this.getFiltersSelectionInfo(medicalPremium, this.appliedFilterValues);
        });
        this.planFilterItemsFacade
            .getCostFilterControl$(filterList$, FilterKeyType.PLAN_DRUG_PREMIUM)
            .pipe(take(1))
            .subscribe(drugPremium => {
            this.drugPremiumFilters = this.getFiltersSelectionInfo(drugPremium, this.appliedFilterValues);
        });
    }
    getCostFiltersJsonString() {
        let costFiltersJsonString = '';
        const isActiveTabPDP = this.activeTabType === PlanTypeAbbreviation.PDP;
        if (!isActiveTabPDP && this.medicalDeductibleFilters && Object.keys(this.medicalDeductibleFilters).length > 0) {
            costFiltersJsonString += this.getJsonString(this.Spa_Filter_MedicalDeductible_Text, this.medicalDeductibleFilters);
        }
        if (!isActiveTabPDP && this.maximumOutOfPocketCostFilters && Object.keys(this.maximumOutOfPocketCostFilters).length > 0) {
            costFiltersJsonString += this.getJsonString(this.Spa_Filter_MaximumOutOfPocketCost_Text, this.maximumOutOfPocketCostFilters);
        }
        if (isActiveTabPDP && this.drugDeductibleFilters && Object.keys(this.drugDeductibleFilters).length > 0) {
            costFiltersJsonString += this.getJsonString(this.Spa_Filter_PharmacyDeductible_Text, this.drugDeductibleFilters);
        }
        if ((this.medicalPremiumFilters && Object.keys(this.medicalPremiumFilters).length > 0) ||
            (this.drugPremiumFilters && Object.keys(this.drugPremiumFilters).length > 0)) {
            const premiumFilter = { ...this.drugPremiumFilters, ...this.medicalPremiumFilters };
            costFiltersJsonString += this.getJsonString(this.Spa_Filter_Premium_Text, premiumFilter);
        }
        return costFiltersJsonString;
    }
    getSortSelectedName() {
        let displayName = '';
        this.sortService
            .getSortBySortGroup$(this.sortGroup)
            .pipe(take(1))
            .subscribe(selectedSort => {
            if (selectedSort) {
                displayName = selectedSort.displayName;
            }
        });
        return displayName;
    }
    setActiveTab() {
        const initialActiveTabType = this.planListFacade.getInitialActiveTabType();
        const initialActiveTab = this.tabs.find(tab => tab.tabTypes[0] === initialActiveTabType);
        if (initialActiveTab && this.checkTabVisibilityAndCoverage(initialActiveTab, this.nonCoveredPlanTabMap)) {
            // this.store.selectSnapshot(GuidedHelpState.selectedCoverageType);
            // OR const defaultTabType = this.store.selectSnapshot(PlansState.defaultTabType);
            this.activeTabIndex = this.planListFacade.getInitialActiveTabIndex(initialActiveTabType);
            this.recalculateActiveTab = false;
            this.setCurrentTab();
        }
    }
    // This should only be called when we are overriding the active tab. Only changing the active tab
    // if we have loaded plans for that tab but if this is causing issues it may be a candidate for removal.
    // We are doing this because previously the override active tab logic made the assumption everything was loaded.
    setCurrentTab() {
        const selectedTab = this.selectedTabForNonCoveredPlanByStates(this.tabs, this.planListFacade.getTabType(this.activeTabIndex), this.nonCoveredPlanTabMap);
        this.planListFacade.updateActiveTab(selectedTab);
        this.activeTabOverrideSelectionComplete$.next(true);
        this.currentTab = this.tabs[this.activeTabIndex];
        this.cdr.markForCheck();
    }
    selectedTabForNonCoveredPlanByStates(tabs, activeTab, nonCoveredPlanTabMap) {
        // Check if the active tab is still visible and has coverage before selecting it again
        if (nonCoveredPlanTabMap[activeTab]?.display && nonCoveredPlanTabMap[activeTab]?.planCount > 0) {
            return activeTab;
        }
        // Select the default tab when the active tab is hidden or has no coverage
        const defaultActiveFlag = 'defaultActive';
        const defaultTab = tabs.find(tab => this.checkTabVisibilityAndCoverage(tab, nonCoveredPlanTabMap, defaultActiveFlag));
        if (defaultTab) {
            return defaultTab.tabTypes[0];
        }
        // Select the secondary default tab when the active and default tabs are hidden or have no coverage
        const secondaryDefaultActiveFlag = 'secondaryDefaultActive';
        const secondaryDefaultTab = tabs.find(tab => this.checkTabVisibilityAndCoverage(tab, nonCoveredPlanTabMap, secondaryDefaultActiveFlag));
        if (secondaryDefaultTab) {
            return secondaryDefaultTab.tabTypes[0];
        }
        // When the active and default tabs are hidden or have no coverage, we select the next visible tab with coverage.
        // If all tabs have no coverage, then we will keep selected the current active tab
        return tabs.find(tab => this.checkTabVisibilityAndCoverage(tab, nonCoveredPlanTabMap))?.tabTypes[0] ?? activeTab;
    }
    checkTabVisibilityAndCoverage(tab, nonCoveredPlanTabMap, additionalTabFlag) {
        const tabType = tab?.tabTypes[0];
        const isTabVisibleAndHasCoverage = nonCoveredPlanTabMap[tabType]?.display && nonCoveredPlanTabMap[tabType]?.planCount > 0;
        if (additionalTabFlag) {
            return tab[additionalTabFlag] && isTabVisibleAndHasCoverage;
        }
        return isTabVisibleAndHasCoverage;
    }
    getNonLicensedViewTagsToUpdate() {
        return {
            [DataLayerGlobalVariable.PAGE_TAB_NAME]: OUTSIDE_LICENSED_AREA,
            [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
            [DataLayerGlobalVariable.PLANS_COUNT]: NO_PLANS_COUNT,
            [DataLayerGlobalVariable.PLAN_TYPE]: this.googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.CSNP_PLAN_COUNT]: this.cSNPPlansCount.toString(),
            [DataLayerGlobalVariable.DSNP_PLAN_COUNT]: this.dSNPPlansCount.toString(),
            [DataLayerGlobalVariable.ISNP_PLAN_COUNT]: this.iSNPPlansCount.toString(),
            [DataLayerGlobalVariable.PLAN_TYPE_BEST_MATCH]: this.planListFacade.getBestCoverageTabAbbreviationValueForAnalytics(),
            [DataLayerGlobalVariable.PLAN_ID_BEST_MATCH]: this.planListFacade.getBestCoverageTabAbbreviationValueForAnalytics()
        };
    }
    processPlansError(error) {
        if (this.siteService.isPPCSite() && PlansUtilityService.isAgentSellingPermissionError(error)) {
            const aspErrorType = PlansUtilityService.getAgentSellingPermissionErrorType(error);
            if (this.Spa_PlanList_NotLicensed_Enabled) {
                this.nonLicensedGoogleDataTags = this.getNonLicensedViewTagsToUpdate();
                if (aspErrorType.includes(AgentSellingPermissionError.NO_ASP_ALP_TITLE)) {
                    this.showNonLicensed = true;
                }
            }
            this.cdr.markForCheck();
        }
    }
    setSortGroup(tabTypes, defaultSortOption) {
        this.configurableWidgetService.sortService.setSortGroup({
            ...new SortGroup(FilterKeyType.PLAN_TYPE_SHORT, tabTypes),
            sort: new Sort(this.sortPrimaryKey.IS_CURRENT_YEAR_PLAN, defaultSortOption.dataKey, defaultSortOption.secondaryDataKey, defaultSortOption.dataKeyType === 'numeric' ? DataKeyType.NUMERIC : DataKeyType.STRING, defaultSortOption.sortType === 'ascending' ? SortType.ASCENDING : SortType.DESCENDING, defaultSortOption.displayName, defaultSortOption.display, this.planListFacade.getSortTransformer(defaultSortOption.dataKey), this.getSecondarySortType(defaultSortOption))
        });
    }
    isSetSortGroupRequired(tabType) {
        return !(this.planListFacade.isSaveSortOrderEnabled() && this.hasCurrentSortSelection(tabType));
    }
    hasCurrentSortSelection(tabType) {
        return !!this.planFacade.getCurrentSortType(tabType);
    }
    getSecondarySortType(defaultSortOption) {
        if (defaultSortOption.secondarySortType) {
            if (defaultSortOption.secondarySortType === SortType.ASCENDING) {
                return SortType.ASCENDING;
            }
            return SortType.DESCENDING;
        }
        return null;
    }
    getExistingSortAndUpdate() {
        const activeTabType = this.configurableWidgetService.store.selectSnapshot(PlansState.activeTabType);
        const sortOption = this.planFacade.getCurrentSortType(activeTabType);
        this.planListFacade.updateSortGroup(sortOption, activeTabType);
    }
    isLiveEditMode() {
        const environment = EnvironmentService.getEnvironment();
        return environment.liveedit;
    }
    getRetentionTags(activeTabType) {
        return {
            [DataLayerGlobalVariable.PLAN_ID_CURRENT]: this.currentYearPlanId || this.Spa_Site_NotApplicable_Text,
            [DataLayerGlobalVariable.PLAN_ID_NEXT_YEAR]: this.nextYearPlanId || this.Spa_Site_NotApplicable_Text,
            [DataLayerGlobalVariable.PLAN_ID_NEXT_YEAR2]: this.option2PlanId || this.Spa_Site_NotApplicable_Text,
            [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
            [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE,
            [DataLayerGlobalVariable.CSNP_PLAN_COUNT]: this.cSNPPlansCount.toString(),
            [DataLayerGlobalVariable.DSNP_PLAN_COUNT]: this.dSNPPlansCount.toString(),
            [DataLayerGlobalVariable.ISNP_PLAN_COUNT]: this.iSNPPlansCount.toString(),
            [DataLayerGlobalVariable.PAGE_TAB_NAME]: activeTabType || this.googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.PLAN_TYPE]: activeTabType || this.googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.PLANS_COUNT]: !this.planCount ? '0' : this.planCount.toString(),
            [DataLayerGlobalVariable.PLAN_TYPE_BEST_MATCH]: this.planListFacade.getBestCoverageTabAbbreviationValueForAnalytics(),
            [DataLayerGlobalVariable.PLAN_ID_BEST_MATCH]: this.planListFacade.getBestCoverageTabAbbreviationValueForAnalytics()
        };
    }
    getSubsidyAnalyticsValue(selectedCoverageType, subsidyValue) {
        const coverageTypeAnalyticsValue = this.guidedHelpService.getMemberPreferenceCoverageAnalyticsValue(selectedCoverageType);
        return coverageTypeAnalyticsValue === 'MA' ? '' : this.guidedHelpService.getMemberPreferenceSubsidyAnalyticsValue(subsidyValue);
    }
    async getActiveTabTags(activeTabType) {
        const siteType = this.Spa_Site_SiteType;
        const appId = this.AppID.toString();
        const memberSession = this.memberSessionService.getMemberSession();
        const agentUserName = this.store.selectSnapshot(AgentState.userName);
        const userName = agentUserName || memberSession.userName;
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        const agentIsProfileAdmin = this.store.selectSnapshot(AgentState.agentIsProfileAdmin);
        const providers = this.providerService.getSelectedProviders();
        const drugsCount = this.guidedHelpService.getMedicineCabinet()?.length;
        const guidedHelpHealthStatus = this.demographicService.getHealthStatus();
        const selectedSubsidy = this.demographicService.getSubsidySelected();
        const selectedSubsidyPercent = this.demographicService.getSubsidyPercent();
        const ageRange = this.demographicService.getAgeRange();
        const tabType = activeTabType || this.googleTagManagerNotApplicableText;
        const selectedCoverageType = this.store.selectSnapshot(GuidedHelpState.selectedCoverageType);
        const subsidyValue = selectedSubsidyPercent || selectedSubsidy;
        const googleDataLayerTagsToUpdate = this.getPrimaryPlanListPageTags(tabType, DataLayerGlobalVariable.VIEW_PAGE);
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.CSNP_PLAN_COUNT] = this.cSNPPlansCount.toString();
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.DSNP_PLAN_COUNT] = this.dSNPPlansCount.toString();
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.ISNP_PLAN_COUNT] = this.iSNPPlansCount.toString();
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.DRUG_COUNT] = drugsCount ? `${drugsCount}` : NO_DRUGS_COUNT;
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.MEMBER_PREF_COVERAGE] =
            this.guidedHelpService.getMemberPreferenceCoverageAnalyticsValue(selectedCoverageType);
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.PLANS_COUNT_VBC] = this.planFacade.getPlanVbcAgreementCount(this.visiblePlans);
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.MEMBER_PREF_SUBSIDY] = this.getSubsidyAnalyticsValue(selectedCoverageType, subsidyValue);
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.MEMBER_PREF_HEALTH] =
            this.guidedHelpService.getMemberPreferencesHealthAnalyticsValue(guidedHelpHealthStatus);
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.MEMBER_PREF_AGE] =
            this.guidedHelpService.getMemberPreferenceAgeAnalyticsValue(ageRange);
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.PLAN_ID_BEST_MATCH] = this.planListFacade.getBestMatchPlanIdValueForAnalytics();
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.PLAN_TYPE_BEST_MATCH] =
            this.planListFacade.getBestCoverageTabAbbreviationValueForAnalytics();
        if (agentGuid) {
            googleDataLayerTagsToUpdate[DataLayerGlobalVariable.AGENT_GUID] = agentGuid;
        }
        if (agentIsProfileAdmin) {
            googleDataLayerTagsToUpdate[DataLayerGlobalVariable.AGENT_IS_PROFILE_ADMIN] = agentIsProfileAdmin;
        }
        if (memberSession?.memberID) {
            googleDataLayerTagsToUpdate[DataLayerGlobalVariable.MEMBER_ID] = memberSession.memberID;
        }
        else if (memberSession?.sessionId && siteType === SiteType.CONSUMER) {
            const memberData = await this.sessionHttpService.getMemberSession$(memberSession.sessionId).toPromise();
            if (memberData?.memberID) {
                googleDataLayerTagsToUpdate[DataLayerGlobalVariable.MEMBER_ID] = memberData.memberID;
            }
        }
        if (this.siteService.isPPCSite()) {
            const nonLicensedPlansCount = this.plansService.getNonLicensedPlansCount(this.filteredPlans) || 0;
            googleDataLayerTagsToUpdate[DataLayerGlobalVariable.PLANS_COUNT_NON_LICENSED] = nonLicensedPlansCount.toString();
        }
        if (activeTabType && this.planCount > 0) {
            const externalMemberId = this.store.selectSnapshot(DeepLinkingParamsState.ssoValue);
            const externalReferenceId = this.store.selectSnapshot(DeepLinkingParamsState.pegi);
            const additionalDataLayerTags = {
                [DataLayerGlobalVariable.SITE_ID]: this.store.selectSnapshot(AppConfigState.shortSiteId),
                [DataLayerGlobalVariable.SITE_CHANNEL]: siteType,
                [DataLayerGlobalVariable.SITE_URL]: this.analyticsService.getBaseUrl(),
                [DataLayerGlobalVariable.LANGUAGE_ID]: this.weglotService.getCurrentWeglotLocaleOrDefault(),
                [DataLayerGlobalVariable.CLIENT_ID]: this.memberSessionService.getClientId(),
                [DataLayerGlobalVariable.CLIENT_GAID]: this.configResourceService.getProcessedResourceValue('GoogleAnalyticsClientPropertyID'),
                [DataLayerGlobalVariable.APP_SESSION_ID]: memberSession ? memberSession.sessionId : null,
                [DataLayerGlobalVariable.USER_NAME]: userName || null,
                [DataLayerGlobalVariable.USER_ID_METHOD]: this.memberSessionService.getAuthType(),
                [DataLayerGlobalVariable.COUNTY_FIPS]: memberSession.demographic.fips,
                [DataLayerGlobalVariable.ZIP]: memberSession.demographic.zip,
                [DataLayerGlobalVariable.APP_ID]: appId,
                [DataLayerGlobalVariable.EXTERNAL_MEMBER_ID]: externalMemberId || this.googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.EXTERNAL_REFERENCE_ID]: externalReferenceId || this.googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.PROVIDER_COUNT]: providers?.length ? providers.length.toString() : '0',
                [DataLayerGlobalVariable.SITE_PLAN_YEAR]: this.planYearResourceService.getSelectedPlanYear()
            };
            return { ...additionalDataLayerTags, ...googleDataLayerTagsToUpdate };
        }
        return googleDataLayerTagsToUpdate;
    }
    clearAllFilters() {
        // SPA-7838, clear all filters on zip/plan change to prevent issues with old filters applying but no longer being visible
        this.plansService
            .getAllVisibleTabTypeAbbreviations()
            .map(item => ({
            comparator: ComparatorType.EQUAL,
            defaultReturnValue: true,
            key: FilterKeyType.PLAN_TYPE_SHORT,
            values: [item],
            visible: true
        }))
            .forEach(filter => {
            // While clearFilterGroupFilters takes an array, it only clears the first tab if we were to call it with multiple tabs
            // ie something like [maFilter,mapdFilter]
            this.filterService.clearFilterGroupFilters([filter]);
        });
    }
    getPrimaryPlanListPageTags(tabType, event) {
        const googleDataLayerTagsToUpdate = {};
        if (event) {
            googleDataLayerTagsToUpdate[DataLayerGlobalVariable.EVENT] = event;
        }
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.PLANS_COUNT] = !this.planCount ? '0' : this.planCount.toString();
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.CSNP_PLAN_COUNT] = this.cSNPPlansCount.toString();
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.DSNP_PLAN_COUNT] = this.dSNPPlansCount.toString();
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.ISNP_PLAN_COUNT] = this.iSNPPlansCount.toString();
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.PAGE_TAB_NAME] = tabType;
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.PLAN_TYPE] = tabType;
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.PAGE_PATH] = this.router.url;
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.PLAN_TYPE_BEST_MATCH] =
            this.planListFacade.getBestCoverageTabAbbreviationValueForAnalytics();
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.PLAN_ID_BEST_MATCH] = this.planListFacade.getBestMatchPlanIdValueForAnalytics();
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.SELECTED_PHARMACY] = this.pharmacyFacade.getSelectedNABPPharmacies();
        googleDataLayerTagsToUpdate[DataLayerGlobalVariable.PLANS_COUNT_VBC] = this.planFacade.getPlanVbcAgreementCount(this.visiblePlans);
        return googleDataLayerTagsToUpdate;
    }
    updatePrimaryPlanListPageTags() {
        const activeTabType = this.configurableWidgetService.store.selectSnapshot(PlansState.activeTabType);
        const tabType = activeTabType || this.googleTagManagerNotApplicableText;
        this.analyticsService.googleDataLayerTags = this.getPrimaryPlanListPageTags(tabType, DataLayerGlobalVariable.VIEW_PAGE);
    }
    getQuoteHintText(isMobile) {
        const quoteLimit = isMobile ? this.Spa_PlanList_AddToQuote_Limit_Mobile : this.Spa_PlanList_AddToQuote_Limit;
        return this.Spa_PlanList_AddToQuote_Hint_Text.replace('<quoteLimit>', quoteLimit.toString());
    }
    clearRateFactorPlan() {
        this.selectedPlanNameToQuote = null;
        this.plansService.removeRateFactorPlan();
    }
    updateShowSelectPlanQuote() {
        this.showSelectPlanQuote = this.isSelectPlanQuote && this.showAddMedicareAdvantagePlan;
    }
    isEmptyCoreGeographicsForSearchingPlans(zipCode, fipsCode) {
        return !zipCode || !fipsCode;
    }
    setDualPlanYearText(selectedPlanYear) {
        if (this.planYearTextEnabled) {
            const dualPlanYearChunks = this.Spa_DualPlanYear_PlanList_Text.split('<YYYY>');
            this.dualPlanYearPrefix = dualPlanYearChunks[0];
            this.dualPlanYear = `${selectedPlanYear || ''}`;
            this.dualPlanYearPostfix = dualPlanYearChunks[1];
        }
    }
    getEditLinkText() {
        return this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_PlanCard_EditLink_Text', null, 'Edit preferences');
    }
    getSubsidyLabelText() {
        return this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_SubsidyLabel_Text', null, 'Subsidy:');
    }
    getPharmacyInputProps() {
        return {
            addPharmacyButtonText: this.Spa_Add_Pharmacy_Button,
            zipLabel: this.Spa_Site_ZipCodeInput_ZipCodeLabel,
            pharmacyNameText: this.Spa_PharmacyName_Text,
            pharmacyNameHintText: this.Spa_PharmacyName_HintText,
            pharmacyLimit: this.Spa_Pharmacy_Limit,
            pharmacyMapDefaultZoom: this.Spa_PharmacyMap_Default_Zoom,
            maxZoom: this.Spa_PharmacyMap_Max_Zoom,
            minZoom: this.Spa_PharmacyMap_Min_Zoom,
            currentPharmacyText: this.Spa_Site_Multi_Pharmacy_Enabled
                ? this.Spa_Site_AddPharmacy_YourMultiPharmacyText
                : this.Spa_AddPharmacy_YourPharmacyText,
            pharmacyAddedLabel: this.Spa_Pharmacy_Added_Label,
            electronicPrescriptionTooltipHeader: this.Spa_Site_ElectronicPrescription_ToolTipHeader,
            electronicPrescriptionTooltipBody: this.Spa_Site_ElectronicPrescription_ToolTipBody,
            pharmacyPaginationEnabled: this.Spa_PharmacySearch_Pagination_Enabled,
            paginationText: this.Spa_PharmacySearch_Pagination_View_Text,
            viewNotFoundHeaderText: this.Spa_Pharmacy_Alt_View_Not_Found_Header_Text,
            viewNotFoundBodyText: this.Spa_Pharmacy_Alt_View_Not_Found_Body_Text,
            preferredInNetworkText: this.Spa_Site_Preferred_In_Network_Text,
            standardInNetworkText: this.Spa_Site_Standard_In_Network_Text,
            preferredInNetworkTooltipContent: this.Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text,
            standardInNetworkTooltipContent: this.Spa_PharmacySearch_Standard_In_Network_Tooltip_Text,
            pharmacySearchIntroText: this.Spa_Site_Multi_Pharmacy_Enabled
                ? this.Spa_PharmacySearch_MultiPharmacy_Intro_Text
                : this.Spa_PharmacySearch_Intro_Text,
            pharmacySearchHeaderText: this.Spa_PharmacySearch_PageHeader_Text,
            addedPharmacyText: this.Spa_Site_Pharmacy_Added_Text,
            addPharmacyText: this.Spa_Site_Pharmacy_Add_Text,
            pharmacyText: this.Spa_Site_Pharmacy_Text,
            ePrescribingAltText: this.Spa_Site_EPrescribing_Alt_Text,
            Spa_Site_Tooltip_Text: this.Spa_Site_Tooltip_Text,
            zipErrorText: this.Spa_Site_ZipCodeInput_ZipCodeError,
            pharmacySearchButtonText: this.Spa_Site_SearchButton_Text,
            multiPharmacyEnabled: this.Spa_Site_Multi_Pharmacy_Enabled,
            setAsPrimaryLinkText: this.Spa_Site_Set_Primary_Pharmacy_Link_Text,
            primaryPharmacyText: this.Spa_Site_Primary_Pharmacy_Text,
            pharmacyFilterText: this.Spa_Filter_Header_Text,
            isPharmacyFilterEnabled: this.Spa_Site_Pharmacy_Filter_Enabled,
            isPharmacyInNetworkFilterEnabled: this.Spa_Site_Pharmacy_In_Network_Filter_Enabled,
            isPharmacyOtherFilterEnabled: this.Spa_Site_Pharmacy_Other_Filter_Enabled,
            pharmacyFilterClearText: this.Spa_Filter_Clear_All,
            pharmacyFilterData: this.Spa_Pharmacy_Filters,
            defaultFilterText: this.Spa_Filter_Default_Filter_Text,
            clearAllText: this.Spa_Filter_Clear_All,
            filterHeaderText: this.Spa_Filter_Header_Text,
            modalCancelButtonText: this.Spa_PlanFilters_Modal_Cancel_Button,
            modalApplyButtonText: this.Spa_PlanFilters_Modal_Apply_Button,
            countyLabel: this.Spa_ZipCodeInput_CountyLabel_Text,
            showCountyLabel: this.Spa_ZipCodeInput_CountyLabel_Enabled,
            pharmacyInNetworkFilters: this.Spa_Pharmacy_In_Network_Filters,
            digitalPharmacyEnabled: this.Spa_Site_Digital_Pharmacy_Enabled,
            retailTabText: this.Spa_Pharmacy_Retail_Tab_Text,
            digitalTabText: this.Spa_Pharmacy_Digital_Tab_Text,
            digitalTabIntroText: this.Spa_Pharmacy_Digital_Tab_Intro_Text,
            itemsPerPage: this.Spa_PharmacySearch_Pagination_ItemsPerPage,
            pharmacyLimitErrorMessage: this.Spa_Site_Pharmacy_Limit_Error_Message,
            pharmacySearchBackButton: this.Spa_PharmacySearch_Back_Button,
            pharmacyModalView1HeadingText: this.Spa_AddPharmacy_ModalView1_HeadingText,
            pharmacyModalView1IntroText: this.Spa_AddPharmacy_ModalView1_IntroText,
            pharmacyModalView2HeadingText: this.Spa_AddPharmacy_ModalView2_HeadingText,
            pharmacyModalView2IntroText: this.Spa_AddPharmacy_ModalView2_IntroText,
            errorKeywordText: this.Spa_Site_ErrorKeyword_Text,
            isHelpfulToolsView: false,
            isPPCSite: this.siteService.isPPCSite(this.Spa_Site_SiteType)
        };
    }
    getPrescriptionInputProps() {
        return {
            contentSectionText: this.Spa_DrugSearch_Content_Section_Text,
            dosageHeader: this.Spa_DrugSearch_Dosage_Header,
            quantityAndFrequencyHeader: this.Spa_DrugSearch_Frequency_Header,
            packageHeader: this.Spa_DrugSearch_Package_Header,
            addButtonText: this.Spa_DrugSearch_Add_Button,
            cancelButtonText: this.Spa_DrugSearch_Cancel_Button,
            backButtonText: this.Spa_DrugSearch_Back_Button,
            quantityMaxLimit: this.Spa_DrugSearch_Quantity_Max_Limit,
            medicineCabinetLimit: this.Spa_DrugSearch_Cabinet_Limit,
            cabinetLimitErrorMessage: this.Spa_DrugSearch_MaxCount_Error_Message,
            quantityErrorMessage: this.Spa_DrugSearch_Quantity_Error_Message,
            placeholder: this.Spa_DrugSearch_Hint_Text,
            drugSearchText: this.Spa_DrugSearch_Label_Text,
            drugsImage: this.Spa_DrugSearch_Drugs_Image,
            inCabinetErrorMessage: this.Spa_DrugSearch_InCabinetError_Text,
            medCabinetHeader: this.Spa_DrugSearch_Medicine_Header,
            genericOptionIcon: this.Spa_DrugSearch_GenericOption_Icon,
            showGenericOption: this.Spa_Site_Show_GenericDrugOption,
            genericOptionQuestion: this.Spa_DrugSearch_GenericOption_Question,
            genericOptionInfo: this.Spa_DrugSearch_GenericOption_Info,
            genericOptions: this.Spa_DrugSearch_GenericOptions,
            checkDrugCoverageButtonText: this.Spa_DrugSearch_CheckDrugCoverageButton_Text,
            genericOptionDefaultSelection: this.Spa_DrugSearch_GenericOption_Default_Selection,
            showCosts: this.Spa_DrugListCard_HideCosts_Flag,
            drugSearchIntroText: this.Spa_AddPrescriptions_ModalView1_IntroText,
            drugSearchPageHeaderText: this.Spa_DrugSearch_PageHeader_Text,
            errorKeywordText: this.Spa_Site_ErrorKeyword_Text,
            drugSearchFrequencyListBoxLabel: this.Spa_DrugSearch_Frequency_ListBox_Label,
            drugSearchFrequencyList: this.Spa_DrugSearch_Frequency_List,
            prescriptionsText: this.Spa_AddPrescriptions_ModalView1_HeadingText,
            isBlueButtonEnabled: this.Spa_Site_Enable_BlueButton,
            blueButtonStartAddingDrugText: this.Spa_BlueButton_StartAddDrug_Text,
            orText: this.Spa_Site_OrText,
            blueButtonConnectToMyMedicareText: this.Spa_BlueButton_MyMedicare_Connect_Text,
            blueButtonMyMedicareButtonText: this.Spa_BlueButton_MyMedicare_Button,
            emailLabelText: this.Spa_Site_EmailAddress_Text,
            emailRequiredErrorText: this.Spa_Profile_EmailRequired_Error,
            emailInvalidErrorText: this.Spa_Profile_EmailInvalid_Error,
            sendEmailButtonText: this.Spa_Site_SendEmailButton_Text,
            blueButtonModalHeaderText: this.Spa_BlueButton_Modal_Header,
            blueButtonModalContent: this.Spa_BlueButton_Modal_Content,
            blueButtonSuccessText: this.Spa_BlueButton_Success_Text,
            blueButtonDownloadText: this.Spa_BlueButton_Download_Text,
            blueButtonSuccessMessage: this.Spa_BlueButton_Success_Message,
            blueButtonEmailSendText: this.Spa_BlueButton_EmailSentToStatus_Text,
            blueButtonIssueLoadingText: this.Spa_BlueButton_Issue_Loading_Text,
            blueButtonBeneficiaryDeniedText: this.Spa_BlueButton_Beneficiary_Denied_Text,
            blueButtonErrorLoadingText: this.Spa_BlueButton_Error_Loading_Text,
            blueButtonBeneficiaryEmailDetails: this.Spa_BlueButton_Beneficiary_Email_Details,
            blueButtonImportLatestPrescriptionButtonText: this.Spa_BlueButton_ImportLatestPrescription_Button_Text,
            blueButtonImportLatestPrescriptionErrorText: this.Spa_BlueButton_ImportLatestPrescription_Error_Text,
            blueButtonAccessDeniedText: this.Spa_BlueButton_AccessDenied_Error_Text,
            blueButtonClaimDataLoadingErrorText: this.Spa_BlueButton_ClaimData_Loading_Error_Text,
            editDrugText: this.Spa_DrugSearch_EditDrug_Button,
            isUseCMSDrugFlagEnabled: this.Spa_Drugs_UseCMSDrugFlag_Enabled,
            modalView2HeaderText: this.Spa_AddPrescriptions_ModalView2_HeadingText,
            modalView2IntroText: this.Spa_AddPrescriptions_ModalView2_IntroText,
            drugSearchInputLabelText: this.Spa_DrugSearch_Text
        };
    }
    getProviderInputProps() {
        return {
            providersText: this.Spa_Site_Providers_Text,
            providersBodyText: this.Spa_Site_Providers_Body_Text,
            providersMultiBodyText: this.Spa_Multi_Providers_Body_Text,
            errorKeywordText: this.Spa_Site_ErrorKeyword_Text,
            zipLabel: this.Spa_Site_ZipCodeInput_ZipCodeLabel,
            zipErrorText: this.Spa_Site_ZipCodeInput_ZipCodeError,
            providerNameText: this.Spa_ProviderName_Text,
            providerNameHintText: this.Spa_ProviderName_HintText,
            providerSearchButtonText: this.Spa_Site_SearchButton_Text,
            providerLimit: this.Spa_Provider_Limit,
            itemsPerPage: this.Spa_ProviderSearch_Pagination_ItemsPerPage,
            providerPaginationEnabled: this.Spa_ProviderSearch_Pagination_Enabled,
            viewNotFoundHeaderText: this.Spa_Provider_Alt_View_Not_Found_Header_Text,
            viewNotFoundBodyText: this.Spa_Provider_Alt_View_Not_Found_Body_Text,
            paginationText: this.Spa_ProviderSearch_Pagination_View_Text,
            maxZoom: this.Spa_ProviderMap_Max_Zoom,
            minZoom: this.Spa_ProviderMap_Min_Zoom,
            providerMapDefaultZoom: this.Spa_ProviderMap_Default_Zoom,
            addProviderText: this.Spa_Provider_Add_Text,
            providerAddedText: this.Spa_Provider_Added_Text,
            yourProviderText: this.Spa_Provider_YourProvider_Text,
            removeProviderText: this.Spa_Provider_RemoveProvider_Text,
            setPrimaryCareProviderText: this.Spa_Provider_Set_Primary_Care_Provider_Text,
            primaryCareProviderText: this.Spa_Provider_Primary_Care_Provider_Text,
            providerFiltersEnabled: this.Spa_Providers_Filter_Enabled,
            providerGroupAddedLabelText: this.Spa_Group_Provider_Added_Text,
            providerGroupAddLabelText: this.Spa_Group_Provider_Add_Text,
            countyLabel: this.Spa_ZipCodeInput_CountyLabel_Text,
            showCountyLabel: this.Spa_ZipCodeInput_CountyLabel_Enabled,
            addLinkText: this.Spa_Site_Add,
            cancelProvidersLabel: this.Spa_Site_Cancel,
            providerSingleSelectEnabled: this.Spa_Select_Single_Provider_For_Multi_Address_Enabled,
            selectProviderLabelText: this.Spa_Select_Provider_Location_Text,
            providerExistsTooltipText: this.Spa_Provider_Exists_Text,
            providerMultiLocationText: this.Spa_Provider_Multiple_Location_Text,
            providerLocationsText: this.Spa_Plan_Providers_Locations_Link_Text,
            valueBasedCareEnabled: this.Spa_Site_ValueBasedCare_Enabled,
            valueBasedCareIcon: this.Spa_Site_ValueBasedCare_Icon,
            valueBasedCareText: this.Spa_Site_ValueBasedCare_Text,
            generalPracticeOptions: this.Spa_Provider_Search_Filter_General_Practice_Options,
            generalPracticeToolTipText: this.Spa_Provider_Search_General_Practice_Tooltip_Text,
            generalPracticeLabel: this.Spa_Provider_Search_General_Practice_Label_Text,
            generalPracticeFilterOptionEnabled: this.Spa_Provider_Search_Filter_General_Practice_Option_Enabled,
            singleProviderInListEnabled: this.Spa_Provider_Search_ShowSingleProviderInList_Enabled,
            updateLinkText: this.Spa_Site_Update_Text,
            editLinkText: this.Spa_Site_Edit_Text,
            showEditLinkEnabled: this.Spa_Provider_ShowEditLink_Enabled,
            valueBasedCareAvailableText: this.Spa_ValueBasedCare_Available_Text,
            valueBasedCareLearnMoreLink: this.Spa_ValueBasedCare_LearnMore_Link,
            valueBasedCareLearnMoreText: this.Spa_ValueBasedCare_LearnMore_Text,
            isValueBasedCareLearnMoreLink2Enabled: this.Spa_ValueBasedCare_LearnMoreLink2_Enabled,
            valueBasedCareToggleLabel: this.Spa_ValueBasedCare_Toggle_Label,
            valueBasedCareToggleToolTipText: this.Spa_ValueBasedCare_Toggle_ToolTip_Text,
            valueBasedCareToggleEnabled: this.Spa_ValueBasedCare_Toggle_Enabled,
            valueBasedCareToggleOptions: this.Spa_Provider_Search_Filter_ValueBasedCare_Options,
            pcpToggleEnabled: this.Spa_Primary_Care_Provider_Toggle_Enabled,
            newPatientToggleOptions: this.Spa_Provider_New_Patient_Options,
            newPatientToggleLabel: this.Spa_Provider_New_Patient_Toggle_Label,
            pcpToggleLabel: this.Spa_Primary_Care_Provider_Toggle_Label,
            pcpToggleOptions: this.Spa_Primary_Care_Provider_Options,
            newPatientText: this.Spa_New_Patient_For_Provider_Text,
            existingPatientText: this.Spa_Existing_Patient_For_Provider_Text,
            vbcNameFilterEnabled: this.Spa_Provider_ValueBasedCare_Name_Filter_Enabled,
            vbcNameFilterLabel: this.Spa_Provider_ValueBasedCare_Name_Filter_Label,
            selectedProviderOptionsEnabled: this.Spa_Selected_Provider_Options_Enabled,
            removeText: this.Spa_Site_Remove_Text,
            selectAllText: this.Spa_Site_SelectAll_Text,
            newPatientToggleEnabled: this.Spa_Provider_New_Patient_Toggle_Enabled,
            providerAddMaxLimitMessage: this.Spa_Provider_Add_Maximum_Limit_Message,
            providerFilterIndividualText: this.Spa_Providers_Filter_Individuals_Text,
            providerFacilitiesText: this.Spa_Providers_Filter_Facilties_Text,
            valueBasedCareFilterText: this.Spa_ValueBasedCare_Filter_Text,
            valueBasedCareFilterEnabled: this.Spa_Site_ValueBasedCare_Filter_Enabled,
            valueBasedCareFilterChecked: this.Spa_ValueBasedCare_Filter_Checked,
            valueBasedCareLearnMoreLinkEnabled: this.Spa_ValueBasedCare_LearnMoreLink_Enabled,
            backButtonText: this.Spa_Providers_Back_Button,
            modalProviderSearchViewHeadingText: this.Spa_AddProviders_ModalProviderSearchView_HeadingText,
            modalProviderSearchViewIntroText: this.Spa_AddProviders_ModalProviderSearchView_IntroText,
            modalProviderMapViewHeadingText: this.Spa_AddProviders_ModalProviderMapView_HeadingText,
            modalProviderMapViewIntroText: this.Spa_AddProviders_ModalProviderMapView_IntroText,
            modalProviderLocationViewHeadingText: this.Spa_AddProviders_ModalProviderLocationView_HeadingText,
            modalProviderLocationViewIntroText: this.Spa_AddProviders_ModalProviderLocationView_IntroText
        };
    }
};
PlanListComponent.ɵfac = function PlanListComponent_Factory(t) { return new (t || PlanListComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(i1.MedSupService), i0.ɵɵdirectiveInject(MedSupFacade), i0.ɵɵdirectiveInject(i1.WeglotService), i0.ɵɵdirectiveInject(i1.PlanCompareService), i0.ɵɵdirectiveInject(PlanListFacadeService), i0.ɵɵdirectiveInject(PlanListContextService), i0.ɵɵdirectiveInject(i1.PreferencesService), i0.ɵɵdirectiveInject(i1.ProviderService), i0.ɵɵdirectiveInject(ProviderFacade), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.QuoteService), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(i1.MillimanService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i1.LiveEditStateContext), i0.ɵɵdirectiveInject(PharmacyFacade), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.MemberSessionHttpService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.FilterService), i0.ɵɵdirectiveInject(i1.SNPService), i0.ɵɵdirectiveInject(i1.SSOPopulatedFieldService), i0.ɵɵdirectiveInject(i1.DrugsService), i0.ɵɵdirectiveInject(i1.SortService), i0.ɵɵdirectiveInject(PlanFilterItemsFacade), i0.ɵɵdirectiveInject(HospitalIndemnityFormFacade), i0.ɵɵdirectiveInject(PlanCompareFacade), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.PharmacyService), i0.ɵɵdirectiveInject(RetentionFacade), i0.ɵɵdirectiveInject(i1.DemographicService), i0.ɵɵdirectiveInject(i1.PlanYearResourceService), i0.ɵɵdirectiveInject(i1.PlanYearService), i0.ɵɵdirectiveInject(i1.CarriersService), i0.ɵɵdirectiveInject(i1.ZipCodeService)); };
PlanListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PlanListComponent, selectors: [["vnext-widget-plan-list"]], viewQuery: function PlanListComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$H, 5);
        i0.ɵɵviewQuery(_c1$b, 5);
        i0.ɵɵviewQuery(PlanFilterModalItemsComponent, 5);
        i0.ɵɵviewQuery(_c2$6, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.planListFilterButtonElement = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltip = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.planFilterModalItems = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.planListTabElement = _t);
    } }, hostBindings: function PlanListComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function PlanListComponent_click_HostBindingHandler($event) { return ctx.onDocumentClick($event); }, false, i0.ɵɵresolveDocument);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService, InputResetContextService]), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [["vnextGoogleTagManager", "", 3, "disableCommonEvent", 4, "ngIf", "ngIfElse"], ["nonLicensed", ""], ["vnextGoogleTagManager", "", 3, "disableCommonEvent"], [4, "ngIf"], [1, "plan-page-title-tabs-container", "Spa_Style_Gray1_Background"], [1, "container"], [1, "row"], [1, "col-12", "mt-4"], ["navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["role", "tablist", "class", "d-flex justify-content-center", 3, "ngClass", 4, "ngIf"], ["class", "row justify-content-center tabs", 4, "ngIf"], ["class", "container", 4, "ngIf"], ["id", "plan-list-container", "role", "tabpanel", 1, "container", 3, "ngClass"], [1, "col-12"], [1, "mb-0"], [3, "preferencesBannerEnabled", "pharmacySelectorTextKey", "pharmacySelectorText", "pharmacies", "selectedPharmacy", "mailOrderText", "isMailOrderSelected", "showMailOrderOption", "selectMailOrder", "selectPharmacy", 4, "ngIf"], [3, "activePlanType", "dateUpdated", 4, "ngIf"], ["class", "aside-second d-none d-md-block col-md-3", 4, "ngIf"], ["infiniteScroll", "", "aria-live", "polite", "aria-atomic", "true", 1, "col-12", 3, "infiniteScrollDistance", "infiniteScrollThrottle", "ngClass", "scrolled"], [4, "ngIf", "ngIfElse"], ["withoutFilteredPlans", ""], [3, "bannerHeaderText", "viewBannerButtonText", "hideBannerButtonText", "buttonConfig", "viewButtonText", "addedButtonText", "modalHeaderPrescriptionsText", "modalHeaderEligibilityText", "modalHeaderHealthText", "modalHeaderProvidersText", "modalHeaderPharmacyText", "closeButtonText", "healthCostsBenefits", "healthCostsBodyText", "healthCostsBenefitsBodyText", "healthCostsBenefitsTableHeader", "healthCostsUsageTableHeader", "healthCostsDaysTableHeader", "healthCostsRestoreDefaultsText", "healthCostsUpdateAnswersText", "healthCostsSaveAnswersText", "saveFailedText", "saveSuccessText", "healthAgeQuestionText", "healthCostsCustomizationEnabled", "healthSliderHeader1Text", "healthSliderHeader2Text", "healthSliderHeader3Text", "healthSliderBody1", "healthSliderBody2", "healthSliderBody3", "healthSliderLabelText", "healthModalView1HeadingText", "healthModalView1IntroText", "prescriptionInputProps", "medicineCabinet", "siteType", "showSubsidyAccordion", "optionalLabel", "accordionHeaderText", "errorKeywordText", "eligibilityModalView1HeadingText", "eligibilityModalView1IntroText", "providerInputProps", "pharmacyInputProps", "selectedProviders", "isMobile", "selectedPharmacies", "onModalClosed"], [1, "col-md-12", "text-center"], ["class", "mt-5", 4, "ngIf"], ["class", "Spa_Style_H1 plan-list-title", 4, "liveEditProp"], [1, "Spa_Style_Paragraph", "text-center", "mb-2", "mt-2", "no-translate-block"], [1, "justify-content-md-center", "mb-3", "mt-4"], [1, "col-md-auto", "text-center"], ["class", "Spa_Style_Note pr-2", 4, "ngIf"], ["alwaysUnderlined", "true", "role", "button", "linkTarget", "_self", 3, "title", "onClickAction", "isLinkButton", "makeInlineBlock", 4, "ngIf"], [1, "mt-5"], [3, "title", "showArrow", "makeInlineBlock", "click", "keydown.enter"], [1, "Spa_Style_H1", "plan-list-title"], ["tabindex", "0", 1, "link", "zip-code-link", "Spa_Style_Largest_Font", "Spa_Style_Link", "d-inline", "focus-text", "action-button", 3, "ngClass", "title", "disabled", "click"], [1, "fa", "fa-edit", "ml-2"], [3, "dualPlanYearPrefix", "isPlanYearUpdateModalEnabled", "dualPlanYearText", "dualPlanYear", "dualPlanYearPostfix", "onPlanYearUpdate", 4, "ngIf"], [3, "dualPlanYearPrefix", "isPlanYearUpdateModalEnabled", "dualPlanYearText", "dualPlanYear", "dualPlanYearPostfix", "onPlanYearUpdate"], [1, "Spa_Style_Note", "pr-2"], ["alwaysUnderlined", "true", "role", "button", "linkTarget", "_self", 3, "title", "onClickAction", "isLinkButton", "makeInlineBlock"], ["navigationAdapter", "", 3, "innerHtml"], ["role", "tablist", 1, "d-flex", "justify-content-center", 3, "ngClass"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "filter-tab", 3, "ngClass", "tabData", "isActive", "bestCoverageText", "plansText", "planText", "currentIndex", "lastIndex", "ariaControlsId", "showBestCoverageBanner", "showAllMedSupEnabled", "bestCoverageIcon", "bestCoverageTooltip", "bestCoverageTabTypeAbbreviation", "loaderIconEnabled", "plansLoadingText", "setFocusToTabEvent", 4, "ngIf"], [1, "filter-tab", 3, "ngClass", "tabData", "isActive", "bestCoverageText", "plansText", "planText", "currentIndex", "lastIndex", "ariaControlsId", "showBestCoverageBanner", "showAllMedSupEnabled", "bestCoverageIcon", "bestCoverageTooltip", "bestCoverageTabTypeAbbreviation", "loaderIconEnabled", "plansLoadingText", "setFocusToTabEvent"], ["planListTab", ""], [1, "row", "justify-content-center", "tabs"], ["class", "filter-tab", 3, "ngClass", "tabData", "isActive", "bestCoverageText", "plansText", "planText", "showAllMedSupEnabled", 4, "ngIf"], ["class", "mobile-tab filter-tab", 3, "mobileTab", "dropdownTabs", "moreOptionsText", 4, "ngIf"], [1, "filter-tab", 3, "ngClass", "tabData", "isActive", "bestCoverageText", "plansText", "planText", "showAllMedSupEnabled"], [1, "mobile-tab", "filter-tab", 3, "mobileTab", "dropdownTabs", "moreOptionsText"], ["class", "col-12", 3, "type", "bodyTemplate", 4, "ngIf"], ["class", "mb-3 px-3", 4, "ngIf"], ["class", "mt-1", 3, "guidedHelpPreferenceText", "preferenceButtonText", "guidedHelpGetStartedText", "guidedHelpHealthText", "guidedHelpPrescriptionsText", "guidedHelpPharmacyText", "guidedHelpOtherPreferencesText", "guidedHelpOtherPreferencesMessageText", "guidedHelpOtherPreferencesMessageKey", "multiPharmacyEnabled", "primaryPharmacyIndicatorText", "guidedHelpProvidersText", "pcpText", "subsidyLabelText", "medicaidEligibilityCheckEnabled", "medicaidCodeText", 4, "ngIf"], ["ageRestrictionForEnrollment", ""], ["effectiveDateRestrictionForEnrollment", ""], [1, "col-12", 3, "type", "bodyTemplate"], [1, "mb-3", "px-3"], [3, "headerText", "placeholder", "updatePlansText", "planFilterModalEnabled", "planSubTypeChanged"], [1, "mt-1", 3, "guidedHelpPreferenceText", "preferenceButtonText", "guidedHelpGetStartedText", "guidedHelpHealthText", "guidedHelpPrescriptionsText", "guidedHelpPharmacyText", "guidedHelpOtherPreferencesText", "guidedHelpOtherPreferencesMessageText", "guidedHelpOtherPreferencesMessageKey", "multiPharmacyEnabled", "primaryPharmacyIndicatorText", "guidedHelpProvidersText", "pcpText", "subsidyLabelText", "medicaidEligibilityCheckEnabled", "medicaidCodeText"], [3, "makeInlineBlock", "title", "click", "keyup.enter"], [3, "showPreviousLink", "productType", "previousLabel", "inchesLabel", "feetLabel", "poundsLabel", "selectMonthText", "selectYearText", "dropdownDefaultText", "continueButtonText", "formTitle", "formPrompt", "sortedQuestions", "questionMetaData", "guaranteedIssueOptions", "guaranteedIssueText", "guaranteedIssueTooltip", "plansLoading", "errorKeywordText", "spaPageSubHeader", "errorNoticeTitle", "totalPlanCount", "effectiveDateMessage", "rateFactorDisclaimer", "rateFactorDisclaimerEnabled", "formClose"], [3, "plansLoading", "showPreviousLink", "spaPageSubHeader", "spaPageTitle", "errorKeywordText", "errorNoticeTitle", "dropdownDefaultText", "continueButtonText", "noPlansAvailableHeaderText", "noPlansAvailableBodyText", "noneText", "rateFactorDisclaimer", "rateFactorDisclaimerEnabled", "formClose"], [3, "previousLabel", "inchesLabel", "feetLabel", "poundsLabel", "selectMonthText", "selectYearText", "dropdownDefaultText", "continueButtonText", "formTitle", "formPrompt", "showPreviousLink", "sortedQuestions", "questionMetaData", "guaranteedIssueOptions", "guaranteedIssueText", "guaranteedIssueTooltip", "plansLoading", "errorKeywordText", "spaPageSubHeader", "errorNoticeTitle", "planSubTypeEnabled", "planSubTypeHeaderText", "planSubTypePlaceholderText", "totalPlanCount", "effectiveDateMessage", "rateFactorDisclaimer", "rateFactorDisclaimerEnabled", "formClose"], ["nonLiveEditable", ""], ["class", "educational-text", "navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], ["navigationAdapter", "", 1, "educational-text", 3, "innerHTML"], [3, "preferencesBannerEnabled", "pharmacySelectorTextKey", "pharmacySelectorText", "pharmacies", "selectedPharmacy", "mailOrderText", "isMailOrderSelected", "showMailOrderOption", "selectMailOrder", "selectPharmacy"], [3, "activePlanType", "dateUpdated"], [3, "showRateFactorWarningBanner", "hasRateFactorAnswers", "rateFactorWarningBannerText", "rateFactorWarningBannerClickableText", "rateFactorEditAnswersBannerText", "rateFactorEditAnswersBannerClickableText", "loadRateFactorForm"], [3, "ngSwitch"], ["class", "col-12", 4, "ngSwitchCase"], ["class", "col-12", 4, "ngIf"], ["class", "row mt-2 mb-2", 4, "ngIf"], [3, "numberOfDaysText", "daysText", "dayText", "editYourAnswersText", "lumpSumText", "basePlanText", "daysAmount", "benefitAmount"], [3, "titleText", "bodyText", "tooltipText", "tooltipLabelText", "filterCodeText", "isMobile", "filterCodeEnabled"], [1, "row", "mt-2", "mb-2"], [3, "planTypeInstructionalText", "planTypes", "planTypeHintText", "planTypeText", "selectPlanButtonText", "carriersHintText", "carriersText", "plansToQuoteHintText", "plansToQuoteText", "noPlansAvailableText", "noPlansAvailableHintText", "requiredFieldsHintText", "pleaseSelectRequiredFieldsErrorText", "planMarketingNameEnabled", "selectPlanNameToQuote"], ["class", "row mt-2 mb-2", 4, "ngSwitchCase"], ["class", "row mt-2 mb-2", 4, "ngSwitchDefault"], [3, "activeTabType", "selectedQuoteGroup", "plansSelectedToQuote", "sendQuoteButtonText", "viewQuoteButtonText", "planCardQuoteLinkNameText", "quoteHintText", "addToQuoteLimit", "isMedicareQuote", "planTypes", "hospitalIndemnityBadgeText", "addMedicareAdvantagePlanText", "showAddMedicareAdvantageButton", "removeFromQuoteText", "addMedicareAdvantagePlan", "viewPlanDetails", "removePlanFromQuoteGroup", "openSendQuoteModal", "getPersonalizedQuote", 4, "ngIf"], [3, "activeTabType", "selectedQuoteGroup", "plansSelectedToQuote", "sendQuoteButtonText", "viewQuoteButtonText", "planCardQuoteLinkNameText", "quoteHintText", "addToQuoteLimit", "isMedicareQuote", "planTypes", "hospitalIndemnityBadgeText", "addMedicareAdvantagePlanText", "showAddMedicareAdvantageButton", "removeFromQuoteText", "addMedicareAdvantagePlan", "viewPlanDetails", "removePlanFromQuoteGroup", "openSendQuoteModal", "getPersonalizedQuote"], [3, "selectedQuoteGroup", "plansSelectedToQuote", "sendQuoteButtonText", "viewQuoteButtonText", "quoteHintText", "addToQuoteLimit", "isMedicareQuote", "planTypes", "removeFromQuoteText", "viewPlanDetails", "removePlanFromQuoteGroup", "openSendQuoteModal"], [1, "aside-second", "d-none", "d-md-block", "col-md-3"], [3, "guidedHelpEnabled", "guidedHelpHeaderText", "guidedHelpHeaderTextKeyName", "guidedHelpPreferenceText", "guidedHelpPreferenceButtonText", "guidedHelpHideLinkText", "guidedHelpViewAllLinkText", "guidedHelpGetStartedText", "guidedHelpHealthText", "guidedHelpPrescriptionsText", "guidedHelpPharmacyText", "guidedHelpOtherPreferencesText", "guidedHelpOtherPreferencesMessageText", "guidedHelpOtherPreferencesMessageKey", "multiPharmacyEnabled", "isLiveEdit", "primaryPharmacyIndicatorText", "guidedHelpProvidersText", "pcpText", "subsidyLabelText", "medicaidEligibilityCheckEnabled", "medicaidCodeText"], [3, "defaultFilterText", "filterDayText", "selectFilterDayText", "filterCarrierText", "filterHeaderText", "filterClearAll", "planSubTypeLabel", "showEmptyFilterMessage", "showNoPlansFromAnswersMessage", "licensingHeaderText", "snpBaseTypeLabel", "currentTab", "snpEnabled", "additionalSavingsHeaderText", "defaultPlanBenefitFilters", "insulinSavingsEnabled", "filterDSNPMedicaidCodesEnabled", "defaultPlanBenefitFiltersEnabled", "costFilterEnabled", "medicalDeductibleHeaderText", "medicalDeductibleToolTipText", "maximumOutOfPocketCostHeaderText", "maximumOutOfPocketCostToolTipText", "drugDeductibleHeaderText", "drugDeductibleToolTipText", "premiumHeaderText", "premiumToolTipText", "addOnTooltipText", "addOnFilterHeaderText", "addOnFilterEnabled", "isTabFilterExpanded", "providersNpiTooltipText", "providersNpiHeaderText", "providersEnabled", "providersNpiFilterEnabled", "showTabFilter", "planTypeLabel", "allInNetworkLocationsEnabled", "filterItemClicked", "clearAllFiltersClicked"], [1, "row", "plan-list-settings", 3, "ngClass"], [1, "col-12", 3, "ngClass"], ["class", "row", 4, "ngIf"], ["class", "col-12 text-right", 4, "ngIf"], ["class", "filter-modal col-12", 4, "ngIf"], [1, "col-xs-12", "ml-4"], ["type", "button", "tabindex", "0", 1, "btn", "Spa_Style_SecondaryButton", 3, "title", "click"], ["class", "col-10 col-xs-12 pr-0", 4, "ngIf"], [1, "col-10", "col-xs-12", "pr-0"], [1, "selected-filter-tag"], [1, "action-button", "ml-2", 3, "click", "keyup.enter"], [1, "fas", "fa-times"], [1, "fa", "fa-times"], [1, "sr-only"], [3, "showLinkText", "hideLinkText", "activeTabType", "filteredPlansHasSNPPlans"], ["class", "col-12 col-sm-6 d-flex d-md-none align-items-end", 4, "ngIf"], [1, "col-12", "col-sm-6", "d-flex", "d-md-none", "align-items-end"], ["displayFilterNotExist", ""], ["type", "button", "tabindex", "0", 1, "plan-mobile-filter", "my-auto", "action-button", "Spa_Style_Link", "d-inline", "p-1", 3, "title", "click"], ["planListFilterButton", ""], [1, "fas", "fa-filter", "mr-2"], [1, "badge", "mb-1", "text-center", "ml-2"], [1, "mb-1"], [3, "planSortList", "selectedPharmacy", "planSortHeader", "tabs", "isMailOrderSelected", "sortClicked"], [1, "col-12", "text-right"], [3, "activePlanType", "isReadOnly", "dateUpdated"], [1, "filter-modal", "col-12"], [1, "mb-2"], [3, "planSubTypeLabel", "filterDayText", "selectFilterDayText", "filterCarrierText", "clearAllText", "currentTab", "snpBaseTypeLabel", "licensingHeaderText", "snpEnabled", "additionalSavingsHeaderText", "insulinSavingsEnabled", "filterDSNPMedicaidCodesEnabled", "costFilterEnabled", "medicalDeductibleHeaderText", "medicalDeductibleToolTipText", "maximumOutOfPocketCostHeaderText", "maximumOutOfPocketCostToolTipText", "drugDeductibleHeaderText", "drugDeductibleToolTipText", "premiumHeaderText", "premiumToolTipText", "defaultPlanBenefitFilters", "defaultPlanBenefitFiltersEnabled", "addOnTooltipText", "addOnFilterHeaderText", "addOnFilterEnabled", "providersNpiHeaderText", "providersNpiFilterEnabled", "providersEnabled", "providersNpiTooltipText", "planTypeLabel", "allInNetworkLocationsEnabled", "planFilterModalEnabled", "isMedigapEnabled", "medsupPlanSubTypeHeaderText", "medsupPlanSubTypePlacholderText", "medsupPlanSubTypeUpdateText", "starRatingEnabled", "isPlanListPage", "snpLabelText", "activeTabType", "starRatingLabelText", "starRatingFilterOptions", "isMobile", "filteredPlansHasSNPPlans", "snpVisibility", "planFiltersSortOptions", "planSubTypeChanged", "closeModalEvent", "toggleSNPPlanChangeEvent"], [1, "d-flex", "justify-content-end"], ["type", "button", 1, "btn", "Spa_Style_PrimaryButton", 3, "click"], ["class", "row", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "plan", "activeTabType", "isNotLicensedToSell", "selectedCompareGroup", "compareGroups", "planBenefits", "displayDrugsCovered", "planPreferences", "bestMatchIcon", "bestMatchText", "bestMatchTooltip", "bestMatchPlanId", "currentPlanText", "nextYearPlanText", "selectedQuoteGroup", "quoteGroups", "addToQuoteLimit", "noCostAvailableText", "isRetentionView", "isQuotingSite", "Spa_Site_ShowRiderIcons", "Spa_Site_Dental_Rider_Display_Text", "Spa_Site_Vision_Rider_Display_Text", "Spa_Site_Hearing_Rider_Display_Text", "Spa_PlanCard_DentalAddOnCoverage_Text", "Spa_PlanCard_HearingAddOnCoverage_Text", "Spa_PlanCard_VisionAddOnCoverage_Text", "Spa_PlanCard_AddOnCoverage_Text", "Spa_PlanCard_AddToCompare_Text", "Spa_Site_ShowRidersOnPlanCards", "Spa_ShoppingCart_Enabled", "Spa_PlanCard_PlanDetails_ButtonText", "Spa_Site_Show_PlanLogo", "Spa_Site_Show_AncillaryPlanLogo", "Spa_PlanCard_QuoteLinkName_Text", "Spa_PlanCard_PlanType_Text", "Spa_PlanCard_ShowRidersOnMACards", "Spa_PlanCard_ShowRidersOnPDPCards", "Spa_PlanCard_ShowRidersOnMAPDCards", "Spa_PlanCard_ShowRidersOnMEDIGAPCards", "Spa_PlanCard_ShowRidersOnDentalCards", "Spa_PlanCard_ShowRidersOnVisionCards", "Spa_Site_ShowPremiumAsAnnual", "Spa_PlanCard_AddOnCoverageInCart_Text", "Spa_PlanCard_AddOnCoverageTooltip_Body", "Spa_Site_NotApplicable_Text", "Spa_PlanDetails_Non_Covered_Text", "Spa_Site_Pharmacy_Text", "Spa_PlanCard_Pharmacy_Covered_Text", "Spa_Site_Prescriptions_Text", "Spa_PlanCard_Drug_Covered_Text", "Spa_PlanCard_CompareNow_Text", "Spa_PlanCard_CompareWarning_Tooltip", "Spa_PlanCard_CompareLimit_Desktop", "Spa_PlanCard_CompareLimit_Mobile", "Spa_PlanCard_Total_Estimated_Cost_Tooltip", "Spa_Site_TotalEstimatedCost_Enabled", "Spa_PlanCard_TotalEstimatedAnnualCost_Text", "Spa_PlanCard_TotalEstimatedCost_Text", "Spa_PlanCard_AddToQuote_Text", "Spa_PlanCard_RemoveFromQuote_Text", "Spa_PlanCard_AddToQuote_Warning_Tooltip", "Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip", "Spa_PlanList_AddToQuote_Limit", "Spa_PlanList_AddToQuote_Limit_Mobile", "Spa_Site_MedigapPlanType_Enabled", "Spa_Site_AddToCompare_Enabled", "Spa_Site_PlanViewDetails_Enabled", "Spa_Site_Tooltip_Text", "Spa_Site_ComboPlanLabel_Text", "Spa_Site_ComboPlanTooltip_Text", "Spa_Site_ShowDrugAlternatives_Enabled", "Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled", "Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text", "Spa_PlanCard_ShowDrugAlternatives_Nudge_Text", "Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon", "queuePosition", "plansSelectedToQuote", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "selectedPharmacy", "isMailOrderSelected", "mailOrderText", "selectedProviders", "providerDetails", "providersInNetworkText", "pcpInNetworkText", "pcpOutOfNetworkText", "providersNoDataText", "isProviderEnabled", "showStarRating", "showPreferenceScore", "showRatingMethod", "monthlyPremiumText", "moreBenefitsInstructionText", "basePlanOptionText", "CSNPEnabled", "DSNPEnabled", "ISNPEnabled", "CSNPText", "DSNPText", "ISNPText", "SNPText", "nonLicensedPlanText", "nonLicensedMessageText", "includeNonLicensedPlans", "noProviderNetworkAccessText", "viewDetailsDescriptionText", "medSupPaymentMethod", "nonMonthlyRateText", "showNonMonthlyRateText", "medSupPaymentMethodDisplayText", "displayOptionLabels", "nonCommissionableText", "isNonCommissionableFlagCheckEnabled", "memberHasOptionsDefined", "optionOneText", "optionTwoText", "totalCostEffectiveDate", "medicineCabinet", "planCardPreferenceDetailedEnabled", "planLogoSize", "showAddToCartForAncillaryPlans", "showAncillaryIcons", "loaderIconEnabled", "hideLinkText", "viewAllLinkText", "Spa_PlanCard_SupplementalBenefits_Enabled", "Spa_PlanCard_SupplementalBenefits_List", "editLinkText", "providerOneOrMoreOutOfNetworkText", "Spa_RatingMethod_AttainedAge_Tooltip_Text", "Spa_RatingMethod_IssueAge_Tooltip_Text", "Spa_RatingMethod_CommunityRated_Tooltip_Text", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "showAvailableRateFactorsEnabled", "personalizedQuoteLabelText", "availableRateFactorsData", "snpPremiumRangeEnabled", "snpRangeLinkText", "showPlanId", "planIdText", "enableDSNPCodes", "availableText", "unavailableText", "viewProvidersButtonText", "viewPrescriptionsButtonText", "supplementalBenefitsHighlightText", "preferencesText", "viewMoreDetailsText", "hideDetailsText", "newPlanCardDesignEnabled", "viewAllPlanDetailsText", "shareThisPlanText", "viewCostDetailsText", "closeText", "planBenefitHighlightItems", "planBenefitHighlightsHeaderText", "showRiderDetails", "showRiderDetailsText", "hideRiderDetailsText", "riderIsIncludedText", "waiverStateRiderTooltips", "costMA", "costMAPD", "costPDP", "costMEDIGAP", "costDENTAL", "costVISION", "isVbcAgreementEnabled", "vbcAgreementLabel", "vbcAgreementTooltip", "quoteClicked", "quoteGroupChanged"], ["validPlanYear", ""], ["otherNoPlans", ""], [1, "col-md-12", "no-plan-error"], [1, "Spa_Style_Large_Font", "font-weight-bold"], ["navigationAdapter", "", 1, "Spa_Style_H5", 3, "innerHTML"], [1, "Spa_Style_Large_Font", "Spa_Style_H3"], [3, "outerText", "innerText", "customTextClass", "innerTextClicked", 4, "ngSwitchCase"], ["class", "mt-4", 4, "ngIf"], [3, "outerText", "innerText", "customTextClass", "innerTextClicked"], [1, "mt-4"], [3, "innerHTML"], ["showNoPlansAvailable", ""], [1, "mt-2", "Spa_Style_H3", "text-center"], [1, "text-center", "Spa_Style_Paragraph", "mb-3"], ["navigationAdapter", "", 1, "Spa_Style_Paragraph", 3, "innerHTML"], ["vnextGoogleTagManager", "", 3, "tagsToUpdate", "headerText", "informationalText"]], template: function PlanListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlanListComponent_div_0_Template, 28, 26, "div", 0);
        i0.ɵɵtemplate(1, PlanListComponent_ng_template_1_Template, 2, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", !ctx.showNonLicensed)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, i1$2.NgSwitchDefault, HospitalIndemnityFormComponent, LinkComponent, InnerTextLinkComponent, SNPToggleComponent, NotLicensedPlanListComponent, NoticeComponent, NavigationAdapterDirective, LiveEditPropDirective, GoogleTagManagerDirective, IconAriaAttributesDirective, i2$2.InfiniteScrollDirective, FilterTabComponent, PlanCardComponent, PlanFilterModalItemsComponent, PlanFilterComponent, MedSupFormComponent, PlanSubTypeDropdownComponent, RateFactorWarningComponent, PlanSortComponent, GuidedHelpPlanListComponent, PlanListAccordionComponent, PharmacySelectorComponent, PlanQuoteComponent, SelectPlanQuoteComponent, EffectiveDateDisplayComponent, HIPDetailsBannerComponent, PlanYearLabelComponent, DSNPEligibilityMessageComponent, PreferencesBannerComponent, i1$2.AsyncPipe, SafePipe], styles: [".plan-list-title[_ngcontent-%COMP%]{margin-top:60px;margin-bottom:10px}.zip-code-link[_ngcontent-%COMP%]{text-decoration:underline;position:relative;cursor:pointer}.fa-edit[_ngcontent-%COMP%]{font-size:var(--Spa_Style_Regular_Font);position:relative;top:-6px}.zip-code-link[_ngcontent-%COMP%]   .fa-edit[_ngcontent-%COMP%]{font-size:.5em}.plans-tab.tabs[_ngcontent-%COMP%]{padding:15px 10px 0}.no-plan-error[_ngcontent-%COMP%]{white-space:pre-line;text-align:center;margin-top:80px;line-height:28px}.filter-tab[_ngcontent-%COMP%]{margin-right:6px;margin-left:6px;max-width:22%;min-width:15%;min-height:100%;margin-bottom:-1px;line-height:1.2}.filter-tab-small[_ngcontent-%COMP%]{max-width:18%;min-width:10%}.filter-tab-small-2[_ngcontent-%COMP%]{max-width:15%;min-width:10%}.filter-tab-small-3[_ngcontent-%COMP%]{max-width:12%;min-width:8%}.filter-tab-small-wide[_ngcontent-%COMP%]{max-width:22%}.filter-modal[_ngcontent-%COMP%]{position:absolute;padding:0 20px 20px;border-radius:8px;font-family:Arial,sans-serif;z-index:1;top:70px;background:#fff!important;width:98%;border:1px solid var(--static-Spa_Style_Accent1)}.selected-filter-tag[_ngcontent-%COMP%]{padding:2px 10px;background-color:#dfdfdf;color:#1f1f1f;margin:5px;border-radius:10px;display:inline-block}@media (min-width: 576px) and (max-width: 767.98px){.filter-tab-small-wide[_ngcontent-%COMP%]{max-width:30%}}@media (min-width: 992px){.filter-tab-small-3[_ngcontent-%COMP%]{max-width:14%}.filter-tab-small-wide[_ngcontent-%COMP%]{max-width:19%}}select[_ngcontent-%COMP%]{width:100%}.mobile-tab[_ngcontent-%COMP%]{max-width:20%;min-width:18%}a.plan-mobile-filter[_ngcontent-%COMP%]{font-size:var(--Spa_Style_Regular_Font);font-family:montserratregular;color:var(--static-Spa_Style_Primary_Link)}.plan-mobile-filter[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:var(--Spa_Style_Small_Font)}.badge[_ngcontent-%COMP%]{font-size:var(--Spa_Style_Small_Fonter);background:var(--static-Spa_Style_Accent4);color:var(--static-Spa_Style_Primary);border-radius:10px}.educational-text[_ngcontent-%COMP%]{font-family:montserrat_light;font-size:var(--Spa_Style_Regular_Font);line-height:22px;color:var(--static-Spa_Style_Black)}.medigap-info[_ngcontent-%COMP%]{background-color:var(--static-Spa_Style_Warn_Lighter)}.plan-list-settings[_ngcontent-%COMP%]{display:flex;align-items:flex-end;justify-content:space-between;margin-bottom:18px}vnext-med-sup-form[_ngcontent-%COMP%]{width:97%}.aside-second[_ngcontent-%COMP%]{padding-top:40px}.plan-page-title-tabs-container[_ngcontent-%COMP%]{border-bottom:1px solid var(--static-Spa_Style_Accent1);margin:0 0 30px}@media (max-width: 575.98px){.educational-text[_ngcontent-%COMP%]{font-size:var(--Spa_Style_Small_Font)}.filter-tab[_ngcontent-%COMP%], .filter-tab-small-wide[_ngcontent-%COMP%]{max-width:40%}.aside-second[_ngcontent-%COMP%]{padding-top:0}}"], changeDetection: 0 });
__decorate([
    Select(PharmacyState.selectedPharmacy)
], PlanListComponent.prototype, "selectedPharmacy$", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanDetails_NonCommissionable_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Pharmacy_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanDetails_NonCommissionable_FlagCheck_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_AddNonLicensedPlans_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_BestCoverage_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_BackToSummary_Link_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Pharmacy_In_Network_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Pharmacy_Other_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_Default_Filter_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Pharmacy_Filter_Open24hrs_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Pharmacy_Filter_Eprescribing_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Pharmacy_Filter_HandicapAccess_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Pharmacy_Filter_DurableEquipment_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Pharmacy_Filter_MailOrder_Text", void 0);
__decorate([
    PlatformProp()
], PlanListComponent.prototype, "Spa_Pharmacy_Filters", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Plans_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Plan_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_Header_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_Clear_All", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanFilters_DefaultText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanFilters_DayLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanFilters_SelectDayLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanFilters_CarrierLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanFilters_SubType_Label", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Plan_Tab_Educational_Text_Show", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ComboPlanLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ComboPlanTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanFilters_Modal_Link", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanFilters_Modal_Cancel_Button", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanFilters_Modal_Apply_Button", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanFilters_No_Plans_Available_Message", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_StarRating_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Sort_By_PreferenceScore_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Effective_Date_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Rate_Factor_Disclaimer_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Rate_Factor_Disclaimer_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanSort_Header", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_PlanLogo_Size", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "AppID", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Sort_Options_MA", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Sort_Options_MAPD", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Sort_Options_PDP", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Sort_Options_MEDIGAP", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Sort_Options_DENTAL", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Sort_Options_VISION", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Sort_Options_HIP", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_Site_Health_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_Benefit_MA", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_Benefit_MAPD", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_Benefit_PDP", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_Benefit_DENTAL", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_Preferences_MA", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_Preferences_MAPD", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_Preferences_PDP", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Multi_Pharmacy_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Tab_Text_NoPlans_MA", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Tab_Text_NoPlans_MAPD", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Tab_Text_NoPlans_PDP", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Tab_Text_NoPlans_MEDIGAP", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Tab_Text_NoPlans_DENTAL", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Tab_Text_NoPlans_MedicareforDualPlanYear", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_ActiveTab_BasedOn_PreferenceScore_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Filters_Expanded", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_RateFactorsPreviousLink_Enabled", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_PlanList_PlansAvailableSingular_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_PlanList_PlansAvailablePlural_Text", void 0);
__decorate([
    GlobalResource(true)
], PlanListComponent.prototype, "Spa_DualPlanYear_PlanList_Text_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DualPlanYear_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DualPlanYear_Update_Enabled", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_DualPlanYear_PlanList_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_Site_PageSubHeader_Text", void 0);
__decorate([
    PlatformProp()
], PlanListComponent.prototype, "Spa_MedSup_PageSubHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_PlanList_Tab_Educational_Text_MAPD", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_PlanList_Tab_Educational_Text_MA", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_PlanList_Tab_Educational_Text_PDP", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_PlanList_Tab_Educational_Text_DENTAL", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_PlanList_Tab_Educational_Text_VISION", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_Site_CostBasedOn_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Tab_Educational_Text_HIP", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Tab_Educational_Text_MEDIGAP", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_ViewCost_Header_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_ViewCost_Header_Content", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_PlanCard_AddToCompare_Text", void 0);
__decorate([
    PlatformProp()
], PlanListComponent.prototype, "Spa_PlanList_PlansAvailableText_Enabled", void 0);
__decorate([
    PlatformProp()
], PlanListComponent.prototype, "Spa_PlanList_EditZipCode_Label", void 0);
__decorate([
    PlatformProp()
], PlanListComponent.prototype, "Spa_PlanList_Tabs_Data", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Hide_EmptyPlanTabs", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanDetails_HIP_Call_Out_Available_Plan_Types", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_Site_Previous", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_MedSupFormInchesLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_MedSupFormFeetLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_MedSupFormPoundsLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_MedSupFormMonthLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_MedSupFormYearLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_MedSupFormDropdownDefault_Text", void 0);
__decorate([
    PlatformProp()
], PlanListComponent.prototype, "Spa_Site_ContinueToPlanList", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_MedSupFormTitle_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_DentalFormTitle_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_VisionFormTitle_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Dental_PageSubHeader_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Vision_PageSubHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_PlanList_HIPFormPrompt_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_PlanList_HIP_PageTitle_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Tab_Header_NoPlans", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_DentalNoResultsError_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_VisionNoResultsError_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_HospitalIndemnityNoResultsError_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_MedSupNoResultsError_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_MedSupNoResultsErrorClickable_Text", void 0);
__decorate([
    PlatformProp()
], PlanListComponent.prototype, "Spa_PlanList_MedSupFormPrompt_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_DentalFormPrompt_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_VisionFormPrompt_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_MedSupQuestion_Data", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_DentalVisionQuestion_Data", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_GuaranteedIssue_Header", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_GuaranteedIssue_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_GuaranteedIssue_Tooltip", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_SiteType", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ForceMedSupFormBeforePlansList", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ForceDentalVisionFormBeforePlansList", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_DentalVisionWarningBanner_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_DentalVisionWarningBannerClickable_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_DentalVisionEditAnswersBanner_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_DentalVisionEditAnswersBannerClickable_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_MedSupWarningBanner_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_MedSupWarningBannerClickable_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_MedSupEditAnswersBanner_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_MedSupEditAnswersBannerClickable_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_MedSup_RestrictMedSupPlansByAge_InfoText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_MedSup_RestrictMedSupPlansByAge_InfoLink", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_EPrescribing_Alt_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Pharmacy_Added_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Pharmacy_Add_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_GuidedHelp_Preference_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_GuidedHelp_PreferenceInfo_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_Site_AddPreferences", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_Site_GetStarted_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_Site_Prescriptions_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_Site_Pharmacy_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_Site_Eligibility_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_Site_OtherPreferences_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_GuidedHelp_ReviewOtherPreferences_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_GuidedHelp_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Hide_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ViewAll_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_TotalEstimatedCost_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_BestMatch_Icon", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_BestMatch_Plan_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_BestMatchPlan_Tooltip", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_BestCoverageType_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_BestCoverageType_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_BestMatchPlan_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_BestCoverageType_Tooltip", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ReturnToPreferences_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Current_Plan_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Next_Year_Plan_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_PlanNotAvailableForNextYear_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Keep_This_Plan_Button_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_AddToQuote_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_SendQuote_Button_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_AddToQuote_Limit", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_AddToQuote_Limit_Mobile", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_AddToQuote_Hint_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_PlanList_HIP_Medicare_Quote_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_PlanType_Instructional_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_HIP_MonthlyPremium_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_HIP_MoreBenefits_Instruction_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_HIP_BasePlanOption_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_HIP_Description", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_HIP_Add_Medicare_Advantage_Plan_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_SelectPlan_Button_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_PleaseSelect_Error_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_PlanType_Header", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_SelectPlanType_Hint_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Carrier_Header", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_SelectPlan_Carriers_Hint_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_SelectPlan_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_SelectPlan_Hint_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_NoPlansAvailable_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_NoPlansAvailable_Hint_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_RequiredFields_Hint_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_ViewQuote_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_IsDeepLinking_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ErrorKeyword_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_EditZipCode_ButtonLabel", void 0);
__decorate([
    PlatformProp()
], PlanListComponent.prototype, "Spa_PlanList_DisplayDrugsCovered", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ShowRiderIcons", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ShowRidersOnPlanCards", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Dental_Rider_Display_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Vision_Rider_Display_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Hearing_Rider_Display_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_DentalAddOnCoverage_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_HearingAddOnCoverage_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_VisionAddOnCoverage_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_AddOnCoverage_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_AddOnCoverageInCart_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_ShowRidersOnMACards", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_ShowRidersOnPDPCards", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_ShowRidersOnMAPDCards", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_ShowRidersOnMEDIGAPCards", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_ShowRidersOnDentalCards", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_ShowRidersOnVisionCards", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_ShoppingCart_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_PlanDetails_ButtonText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Show_PlanLogo", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_QuoteLinkName_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_PlanType_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ShowPremiumAsAnnual", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_AddOnCoverageTooltip_Body", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_NotApplicable_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanDetails_Non_Covered_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_Pharmacy_Covered_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_Drug_Covered_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_CompareNow_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_CompareWarning_Tooltip", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_CompareLimit_Desktop", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_CompareLimit_Mobile", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_Total_Estimated_Cost_Tooltip", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_TotalEstimatedAnnualCost_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_TotalEstimatedCost_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_AddToQuote_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_RemoveFromQuote_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_AddToQuote_Warning_Tooltip", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_MedigapPlanType_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_AddToCompare_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_PlanViewDetails_Enabled", void 0);
__decorate([
    PlatformProp()
], PlanListComponent.prototype, "Spa_ProfileNavBar_ShowPlanList_Flag", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_LicensingHeader_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_SellablePlansOnlyCheckbox_Label", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_SNPBaseTypes_Label", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_MoreOptions_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_EnrollmentErrorNotice_Title", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Pharmacy_InNetwork_Preferred_Pricing_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Pharmacy_InNetwork_Standard_Pricing_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Pharmacy_OutOfNetwork_Pricing_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_PrimaryPharmacy_Indicator_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_Site_Providers_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Mail_Order_Pharmacy_Enabled", void 0);
__decorate([
    PlatformProp()
], PlanListComponent.prototype, "Spa_PlanList_MailOrder_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Providers_Header_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Pcp_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_Providers_InNetwork_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Pcp_InNetwork_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Pcp_OutOfNetwork_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Providers_No_Data_Exist_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Providers_NoProviderNetworkAccess_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Providers_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Npi_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Show_Preferences_Score", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_ShowSNPLink_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_HideSNPLink_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ShowSNPPlansDefault_Flag", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_CSNP_Indicator_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_DSNP_Indicator_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_ISNP_Indicator_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ElectronicPrescription_ToolTipBody", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Pharmacy_Added_Label", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_AddPharmacy_YourPharmacyText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ElectronicPrescription_ToolTipHeader", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_CSNP_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_DSNP_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_ISNP_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_SNP_Indicator_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_NotLicensed_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_SNPTools_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_MedSupForm_DateOfBirthTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_MedSupForm_EffectiveDateTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_MedSupForm_GenderTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_MedSupForm_TobaccoTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_MedSupForm_HeightTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_MedSupForm_WeightTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_MedSupForm_PaymentMethodTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_MedSupForm_HouseholdTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_MedSupForm_PartAEffectiveDateTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_MedSupForm_PartBEffectiveDateTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_CSNP_Label", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_DSNP_Label", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ISNP_Label", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ChronicDependence_SNPTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_AutoImmune_SNPTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Cancer_SNPTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Cardiovascular_SNPTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ChronicHeartFailure_SNPTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Dementia_SNPTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Diabetes_SNPTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_EndStageLiver_SNPTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_EndStageRenal_SNPTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Hematologic_SNPTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_HIVAIDS_SNPTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ChronicLung_SNPTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ChronicMentalHealth_SNPTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Neurologic_SNPTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Stroke_SNPTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_NursingHome_SNPTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_RequiresNursingCare_SNPTooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ChronicDependence_SNPLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_AutoImmune_SNPLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Cancer_SNPLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Cardiovascular_SNPLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ChronicHeartFailure_SNPLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Dementia_SNPLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Diabetes_SNPLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_EndStageLiver_SNPLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_EndStageRenal_SNPLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Hematologic_SNPLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_HIVAIDS_SNPLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ChronicLung_SNPLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ChronicMentalHealth_SNPLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Neurologic_SNPLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Stroke_SNPLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_NursingHome_SNPLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_RequiresNursingCare_SNPLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_NonMonthlyRateText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_NonMonthlyRateText_Enabled", void 0);
__decorate([
    GlobalResource(true)
], PlanListComponent.prototype, "Spa_MedSupForm_PaymentMethodBiMonthly_Text", void 0);
__decorate([
    GlobalResource(true)
], PlanListComponent.prototype, "Spa_MedSupForm_PaymentMethodMonthly_Text", void 0);
__decorate([
    GlobalResource(true)
], PlanListComponent.prototype, "Spa_MedSupForm_PaymentMethodQuarterly_Text", void 0);
__decorate([
    GlobalResource(true)
], PlanListComponent.prototype, "Spa_MedSupForm_PaymentMethodSemiAnnually_Text", void 0);
__decorate([
    GlobalResource(true)
], PlanListComponent.prototype, "Spa_MedSupForm_PaymentMethodAnnually_Text", void 0);
__decorate([
    GlobalResource(true)
], PlanListComponent.prototype, "Spa_MedSupForm_PaymentMethodLumpSum_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_CrossSell_Confirm_Link_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_CrossSell_Header_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Digital_Pharmacy_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Pharmacy_Retail_Tab_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Pharmacy_Digital_Tab_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Pharmacy_Digital_Tab_Intro_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_CrossSell_Medsup_Marketing_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Pharmacy_In_Network_Filters", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_CrossSell_Medsup_Prompt_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_CrossSell_PDP_Marketing_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_CrossSell_PDP_Prompt_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_CrossSell_Success_Message_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_CrossSell_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_AdditionalSavingsHeader_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_InsulinSavings_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ViewDetailsLink_Description_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Tab_Show_DENTAL", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Tab_Show_VISION", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Tab_Show_HIP", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_ShowAllMedigap_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_AddOn_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_AddOn_Coverage_ToolTip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_Providers_ToolTip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_AddOn_Header_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_MedSupPlanSubTypeHeader_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_MedSupPlanSubTypePlaceholder_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_MedSupPlanSubTypeUpdate_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Include_NonLicensed_Plans", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_MedicalDeductible_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_MedicalDeductible_ToolTip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_MaximumOutOfPocketCost_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_MaximumOutOfPocketCost_ToolTip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_PharmacyDeductible_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_PharmacyDeductible_ToolTip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_Premium_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_Premium_ToolTip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_PlanBenefitsGroup_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_Preferences_Detailed_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Show_AncillaryPlanLogo", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Display_SNP_PremiumRange_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_SNPRange_Link_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Default_Plan_Benefit_Filter", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Retention_ClientDefinedPlanOptions_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Plan_Option_One_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Plan_Option_Two_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_Plan_Marketing_Name_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_MedSupForm_AllowFormWhenNoPlansAvailable_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_AncillaryAddtoCart_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_ShowAncillaryIcons_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ShowDrugAlternatives_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_ShowDrugAlternatives_Nudge_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Preferences_Score_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Tab_Text_NoPlans_HIP", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "SPA_HIP_Rider_Benefit_Default_Dropdown_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Days_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Day_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_LumpSum_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Loader_Updated_Icon_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Plans_Loading_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Provider_ShowAllInNetworkLocations_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_SupplementalBenefits_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_SupplementalBenefits_List", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Rating_Method_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_RatingMethod_AttainedAge_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_RatingMethod_IssueAge_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_RatingMethod_CommunityRated_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_Providers_OneOrMore_OutOfNetwork_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Providers_InNetwork_OnOtherLocations_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_AddHealth_ModalView1_HeadingText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_AddHealth_ModalView1_IntroText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_AddEligibility_ModalView1_HeadingText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_AddEligibility_ModalView1_IntroText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_ShowPartialIndicator_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_PlanFees_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanFees_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanFees_IncludedInPremium_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_ShowAvailableRateFactors_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_PersonalizedQuoteLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_AvailableRateFactors_Data", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_Show_PlanId_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_Show_DSNP_EligibleMessage", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_DSNP_EligibleMessage_Header_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_DSNP_EligibleMessage_Info_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DSNP_Eligibility_LearnMore_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DSNP_Eligibility_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_TotalSiteCountsPPC_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_TotalSiteCounts_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_PlanId_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Profile_StateEligibilityCheck_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_GettingStarted_MedicaidCode_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_DSNPCodeDisplay_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Filter_DSNPMedicaidCodes_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DSNPEligibility_FilterCodeMessage_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DSNPEligibility_FilterCodeMessage_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Available_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_NotAvailable_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_Providers_ViewButton_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_Prescriptions_ViewButton_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_SupplementalBenefitsHighlight_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Plan_Details_Preferences_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_ViewMoreDetails_ButtonText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_HideDetails_ButtonText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_NewDesign_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_ViewAllPlanDetails_ButtonText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_ShareThisPlan_ButtonText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_ViewCostDetails_ButtonText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Close", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanList_FilterModal_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanFilters_Modal_Button_Label", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_PlanBenefitHighlight_Items", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanCard_PlanBenefitHighlights_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_RiderDetails_Show", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Plan_Details_ViewRiderDetails_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Plan_Details_HideRiderDetails_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_ShoppingCart_IncludedRider_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ValueBasedCare_Agreement_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ValueBasedCare_Agreement_Label", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ValueBasedCare_Agreement_Tooltip", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Plan_Details_WaiverStateRider_Tooltips", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Plandetails_Costs_MAPD", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Plandetails_Costs_MA", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Plandetails_Costs_MEDIGAP", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Plandetails_Costs_PDP", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanDetails_Costs_DENTAL", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanDetails_Costs_VISION", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_StarRating_Label_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_StarRating_Filter_Options", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PlanFilters_Sort_Options_For_Modal", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PharmacySearch_Back_Button", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_AddPharmacy_ModalView1_IntroText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_AddPharmacy_ModalView1_HeadingText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_AddPharmacy_ModalView2_IntroText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_AddPharmacy_ModalView2_HeadingText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PharmacySearch_Pagination_ItemsPerPage", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PharmacySearch_Pagination_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PharmacySearch_Pagination_View_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Standard_In_Network_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PharmacySearch_Standard_In_Network_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Pharmacy_Alt_View_Not_Found_Header_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Pharmacy_Alt_View_Not_Found_Body_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Preferred_In_Network_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_PharmacyName_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Add_Pharmacy_Button", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PreferenceBanner_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PreferenceBanner_Header_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PreferenceBanner_View_ButtonText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PreferenceBanner_Hide_ButtonText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_View", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PreferenceBanner_Added_ButtonText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Close_Modal", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_PharmacyName_HintText", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_GuidedHelp_Health_AgeQuestion_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Health_Slider_Label_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_HealthCosts_Body_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_HealthCosts_Save_Failed_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_HealthCosts_Customization_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Pharmacy_Limit", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_Limit", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PharmacyMap_Default_Zoom", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_ProviderMap_Default_Zoom", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PharmacyMap_Max_Zoom", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PharmacyMap_Min_Zoom", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_ProviderMap_Max_Zoom", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_ProviderMap_Min_Zoom", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Maximum_Pharmacy_Count", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Set_Primary_Pharmacy_Link_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Primary_Pharmacy_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Primary_Pharmacy_Icon", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Primary_Pharmacy_Icon_Color", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_PharmacySearch_PageHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_PharmacySearch_Intro_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_PharmacySearch_MultiPharmacy_Intro_Text", void 0);
__decorate([
    GlobalResource(true)
], PlanListComponent.prototype, "Spa_Site_Pharmacy_Limit_Error_Message", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_Multi_Providers_Body_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_Site_AddPharmacy_YourMultiPharmacyText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_OtherPreferences_PageCount_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_GuidedHelp_OtherPreferences_EnterZip_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_GuidedHelp_OtherPreferences_ProvideZip_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_GuidedHelp_Health_SliderHeader1_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_GuidedHelp_Health_SliderHeader2_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_GuidedHelp_Health_SliderHeader3_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_GuidedHelp_Health_SliderBody1", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_GuidedHelp_Health_SliderBody2", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_GuidedHelp_Health_SliderBody3", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_HealthCosts_Benefits_Body_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_Site_HealthCosts_Benefits_Table_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_Site_HealthCosts_Usage_Table_Header", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_Site_HealthCosts_Days_Table_Header", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_HealthCosts_Restore_Defaults_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_HealthCosts_Update_Answers_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_HealthCosts_Save_Answers_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_HealthCosts_Save_Success_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_HealthCosts_Benefits_JSON", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_Content_Section_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_Dosage_Header", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_Frequency_Header", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_Package_Header", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_Add_Button", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_Cancel_Button", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_Back_Button", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_EditDrug_Button", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_Quantity_Max_Limit", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_Cabinet_Limit", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_MaxCount_Error_Message", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_Quantity_Error_Message", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_Label_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_Drugs_Image", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_InCabinetError_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_Medicine_Header", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_GenericOption_Icon", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Show_GenericDrugOption", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_GenericOption_Question", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_GenericOption_Info", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_GenericOptions", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_CheckDrugCoverageButton_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_GenericOption_Default_Selection", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugListCard_HideCosts_Flag", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_DrugSearch_Hint_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_DrugSearch_Intro_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_DrugSearch_PageHeader_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_Frequency_ListBox_Label", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Enable_BlueButton", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_OrText", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_BlueButton_StartAddDrug_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_BlueButton_MyMedicare_Connect_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_BlueButton_MyMedicare_Button", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_EmailAddress_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Profile_EmailRequired_Error", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Profile_EmailInvalid_Error", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_Site_SendEmailButton_Text", void 0);
__decorate([
    PlatformProp()
], PlanListComponent.prototype, "Spa_BlueButton_Modal_Header", void 0);
__decorate([
    PlatformProp()
], PlanListComponent.prototype, "Spa_BlueButton_Modal_Content", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_BlueButton_Success_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_BlueButton_Download_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_BlueButton_Success_Message", void 0);
__decorate([
    PlatformProp()
], PlanListComponent.prototype, "Spa_BlueButton_EmailSentToStatus_Text", void 0);
__decorate([
    PlatformProp()
], PlanListComponent.prototype, "Spa_BlueButton_Issue_Loading_Text", void 0);
__decorate([
    PlatformProp()
], PlanListComponent.prototype, "Spa_BlueButton_Beneficiary_Denied_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_BlueButton_Error_Loading_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_BlueButton_Beneficiary_Email_Details", void 0);
__decorate([
    PlatformProp()
], PlanListComponent.prototype, "Spa_BlueButton_ImportLatestPrescription_Button_Text", void 0);
__decorate([
    PlatformProp()
], PlanListComponent.prototype, "Spa_BlueButton_ImportLatestPrescription_Error_Text", void 0);
__decorate([
    PlatformProp()
], PlanListComponent.prototype, "Spa_BlueButton_AccessDenied_Error_Text", void 0);
__decorate([
    PlatformProp()
], PlanListComponent.prototype, "Spa_BlueButton_ClaimData_Loading_Error_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Drugs_UseCMSDrugFlag_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_AddPrescriptions_ModalView1_HeadingText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_AddPrescriptions_ModalView1_IntroText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_AddPrescriptions_ModalView2_HeadingText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_AddPrescriptions_ModalView2_IntroText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_DrugSearch_Frequency_List", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_GettingStarted_ShowSubsidyAccordion_Flag", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_GuidedHelp_OptionalLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_GettingStarted_SubsidyHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_Site_Providers_Body_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_Add_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_Added_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_RemoveProvider_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_Provider_YourProvider_Text", void 0);
__decorate([
    PlatformProp()
], PlanListComponent.prototype, "Spa_Provider_Set_Primary_Care_Provider_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_Primary_Care_Provider_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ZipCodeInput_ZipCodeLabel", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ZipCodeInput_ZipCodeError", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Providers_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Group_Provider_Add_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Group_Provider_Added_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Add", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Cancel", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Select_Single_Provider_For_Multi_Address_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Select_Provider_Location_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_Exists_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_Multiple_Location_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Plan_Providers_Locations_Link_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ValueBasedCare_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ValueBasedCare_Icon", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ValueBasedCare_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_Search_Filter_General_Practice_Options", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_Search_General_Practice_Label_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_Search_General_Practice_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_Search_Filter_General_Practice_Option_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_Search_ShowSingleProviderInList_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Edit_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Update_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_ShowEditLink_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_ValueBasedCare_Available_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_ValueBasedCare_LearnMore_Link", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_ValueBasedCare_LearnMore_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_ValueBasedCare_LearnMoreLink2_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_ValueBasedCare_Toggle_Label", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_ValueBasedCare_Toggle_ToolTip_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_ValueBasedCare_Toggle_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_Search_Filter_ValueBasedCare_Options", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_New_Patient_Toggle_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_New_Patient_Toggle_Label", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_New_Patient_Options", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Primary_Care_Provider_Toggle_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Primary_Care_Provider_Toggle_Label", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Primary_Care_Provider_Options", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_New_Patient_For_Provider_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Existing_Patient_For_Provider_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_ValueBasedCare_Name_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_ValueBasedCare_Name_Filter_Label", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Selected_Provider_Options_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_Remove_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_SelectAll_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_ProviderName_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], PlanListComponent.prototype, "Spa_ProviderName_HintText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_SearchButton_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_ProviderSearch_Pagination_ItemsPerPage", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_ProviderSearch_Pagination_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_ProviderSearch_Pagination_View_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_Alt_View_Not_Found_Header_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_Alt_View_Not_Found_Body_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Provider_Add_Maximum_Limit_Message", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Providers_Filter_Individuals_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Providers_Filter_Facilties_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_ValueBasedCare_Filter_Text", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Site_ValueBasedCare_Filter_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_ValueBasedCare_Filter_Checked", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_ValueBasedCare_LearnMoreLink_Enabled", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_Providers_Back_Button", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_AddProviders_ModalProviderSearchView_HeadingText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_AddProviders_ModalProviderSearchView_IntroText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_AddProviders_ModalProviderMapView_HeadingText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_AddProviders_ModalProviderMapView_IntroText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_AddProviders_ModalProviderLocationView_HeadingText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_AddProviders_ModalProviderLocationView_IntroText", void 0);
__decorate([
    GlobalResource()
], PlanListComponent.prototype, "Spa_PreferenceBanner_DisplayButtons_JSON", void 0);
__decorate([
    ResponsiveLayout(BreakPoint.EXTRA_SMALL)
], PlanListComponent.prototype, "isExtraSmall$", void 0);
__decorate([
    ResponsiveLayout(BreakPoint.COMPACT)
], PlanListComponent.prototype, "isMobile$", void 0);
__decorate([
    Memoize()
], PlanListComponent.prototype, "getFiltersSelectionInfo", null);
__decorate([
    Memoize()
], PlanListComponent.prototype, "selectedTabForNonCoveredPlanByStates", null);
__decorate([
    Memoize()
], PlanListComponent.prototype, "checkTabVisibilityAndCoverage", null);
PlanListComponent = __decorate([
    PlatformWidget
], PlanListComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlanListComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-plan-list', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService, InputResetContextService], template: "<div *ngIf=\"!showNonLicensed; else nonLicensed\" vnextGoogleTagManager [disableCommonEvent]=\"true\">\r\n  <ng-container *ngIf=\"Spa_PreferenceBanner_Enabled\">\r\n    <vnext-widget-preferences-banner\r\n      [bannerHeaderText]=\"Spa_PreferenceBanner_Header_Text\"\r\n      [viewBannerButtonText]=\"Spa_PreferenceBanner_View_ButtonText\"\r\n      [hideBannerButtonText]=\"Spa_PreferenceBanner_Hide_ButtonText\"\r\n      [buttonConfig]=\"Spa_PreferenceBanner_DisplayButtons_JSON\"\r\n      [viewButtonText]=\"Spa_Site_View\"\r\n      [addedButtonText]=\"Spa_PreferenceBanner_Added_ButtonText\"\r\n      [modalHeaderPrescriptionsText]=\"Spa_Site_Prescriptions_Text\"\r\n      [modalHeaderEligibilityText]=\"Spa_Site_Eligibility_Text\"\r\n      [modalHeaderHealthText]=\"Spa_Site_Health_Text\"\r\n      [modalHeaderProvidersText]=\"Spa_Site_Providers_Text\"\r\n      [modalHeaderPharmacyText]=\"Spa_Site_Pharmacy_Text\"\r\n      [closeButtonText]=\"Spa_Site_Close_Modal\"\r\n      [healthCostsBenefits]=\"Spa_Site_HealthCosts_Benefits_JSON\"\r\n      [healthCostsBodyText]=\"Spa_HealthCosts_Body_Text\"\r\n      [healthCostsBenefitsBodyText]=\"Spa_HealthCosts_Benefits_Body_Text\"\r\n      [healthCostsBenefitsTableHeader]=\"Spa_Site_HealthCosts_Benefits_Table_Header\"\r\n      [healthCostsUsageTableHeader]=\"Spa_Site_HealthCosts_Usage_Table_Header\"\r\n      [healthCostsDaysTableHeader]=\"Spa_Site_HealthCosts_Days_Table_Header\"\r\n      [healthCostsRestoreDefaultsText]=\"Spa_Site_HealthCosts_Restore_Defaults_Text\"\r\n      [healthCostsUpdateAnswersText]=\"Spa_Site_HealthCosts_Update_Answers_Text\"\r\n      [healthCostsSaveAnswersText]=\"Spa_Site_HealthCosts_Save_Answers_Text\"\r\n      [saveFailedText]=\"Spa_Site_HealthCosts_Save_Failed_Text\"\r\n      [saveSuccessText]=\"Spa_Site_HealthCosts_Save_Success_Text\"\r\n      [healthAgeQuestionText]=\"Spa_GuidedHelp_Health_AgeQuestion_Text\"\r\n      [healthCostsCustomizationEnabled]=\"Spa_Site_HealthCosts_Customization_Enabled\"\r\n      [healthSliderHeader1Text]=\"Spa_GuidedHelp_Health_SliderHeader1_Text\"\r\n      [healthSliderHeader2Text]=\"Spa_GuidedHelp_Health_SliderHeader2_Text\"\r\n      [healthSliderHeader3Text]=\"Spa_GuidedHelp_Health_SliderHeader3_Text\"\r\n      [healthSliderBody1]=\"Spa_GuidedHelp_Health_SliderBody1\"\r\n      [healthSliderBody2]=\"Spa_GuidedHelp_Health_SliderBody2\"\r\n      [healthSliderBody3]=\"Spa_GuidedHelp_Health_SliderBody3\"\r\n      [healthSliderLabelText]=\"Spa_Site_Health_Slider_Label_Text\"\r\n      [healthModalView1HeadingText]=\"Spa_AddHealth_ModalView1_HeadingText\"\r\n      [healthModalView1IntroText]=\"Spa_AddHealth_ModalView1_IntroText\"\r\n      [prescriptionInputProps]=\"prescriptionInputProps\"\r\n      [medicineCabinet]=\"medicineCabinet\"\r\n      [siteType]=\"Spa_Site_SiteType\"\r\n      (onModalClosed)=\"onModalClosed()\"\r\n      [showSubsidyAccordion]=\"Spa_GettingStarted_ShowSubsidyAccordion_Flag\"\r\n      [optionalLabel]=\"Spa_GuidedHelp_OptionalLabel_Text\"\r\n      [accordionHeaderText]=\"Spa_GettingStarted_SubsidyHeader_Text\"\r\n      [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n      [eligibilityModalView1HeadingText]=\"Spa_AddEligibility_ModalView1_HeadingText\"\r\n      [eligibilityModalView1IntroText]=\"Spa_AddEligibility_ModalView1_IntroText\"\r\n      [providerInputProps]=\"providerInputProps\"\r\n      [pharmacyInputProps]=\"pharmacyInputProps\"\r\n      [selectedProviders]=\"selectedProviders\"\r\n      [isMobile]=\"mobile\"\r\n      [selectedPharmacies]=\"selectedPharmacies\"\r\n    ></vnext-widget-preferences-banner>\r\n  </ng-container>\r\n  <div class=\"plan-page-title-tabs-container Spa_Style_Gray1_Background\">\r\n    <div class=\"container\">\r\n      <div class=\"row\">\r\n        <ng-container *ngIf=\"Spa_PlanList_PlansAvailableText_Enabled && isReadyToShowZipcodeLink\">\r\n          <div class=\"col-md-12 text-center\">\r\n            <div *ngIf=\"isQuotingSite || (isRetentionView && planFacade.hasRetentionPage())\" class=\"mt-5\">\r\n              <vnext-link\r\n                [title]=\"Spa_Site_BackToSummary_Link_Text\"\r\n                [showArrow]=\"'left'\"\r\n                (click)=\"planFacade.navigateToSummary()\"\r\n                (keydown.enter)=\"planFacade.navigateToSummary()\"\r\n                [makeInlineBlock]=\"true\"\r\n              >\r\n              </vnext-link>\r\n            </div>\r\n            <h1\r\n              class=\"Spa_Style_H1 plan-list-title\"\r\n              *liveEditProp=\"totalPlanCount === 1 ? 'Spa_PlanList_PlansAvailableSingular_Text' : 'Spa_PlanList_PlansAvailablePlural_Text'\"\r\n            >\r\n              {{ totalPlanCount }}\r\n              {{ totalPlanCount === 1 ? Spa_PlanList_PlansAvailableSingular_Text : Spa_PlanList_PlansAvailablePlural_Text }}\r\n\r\n              <button\r\n                class=\"link zip-code-link Spa_Style_Largest_Font Spa_Style_Link d-inline focus-text action-button\"\r\n                [ngClass]=\"{ 'readonly Spa_Style_Gray4_Color': ssoPopulatedFieldService.isFieldReadOnly$('Demographic.ZipCode') | async }\"\r\n                tabindex=\"0\"\r\n                title=\"{{ Spa_PlanList_EditZipCode_Label }}\"\r\n                (click)=\"editZipCode()\"\r\n                [attr.aria-label]=\"Spa_PlanList_EditZipCode_ButtonLabel\"\r\n                [disabled]=\"ssoPopulatedFieldService.isFieldReadOnly$('Demographic.ZipCode') | async\"\r\n              >\r\n                {{ zipCode }}<i class=\"fa fa-edit ml-2\"></i>\r\n              </button>\r\n              <vnext-plan-year-label\r\n                *ngIf=\"planYearTextEnabled\"\r\n                [dualPlanYearPrefix]=\"dualPlanYearPrefix\"\r\n                [isPlanYearUpdateModalEnabled]=\"isPlanYearUpdateModalEnabled\"\r\n                [dualPlanYearText]=\"dualPlanYear\"\r\n                [dualPlanYear]=\"dualPlanYear\"\r\n                [dualPlanYearPostfix]=\"dualPlanYearPostfix\"\r\n                (onPlanYearUpdate)=\"onPlanYearUpdate()\"\r\n              ></vnext-plan-year-label>\r\n            </h1>\r\n            <div class=\"Spa_Style_Paragraph text-center mb-2 mt-2 no-translate-block\">\r\n              {{ stateCountyInformationalText$ | async }}\r\n            </div>\r\n            <div class=\"justify-content-md-center mb-3 mt-4\">\r\n              <div class=\"col-md-auto text-center\">\r\n                <span *ngIf=\"Spa_Site_TotalSiteCountsPPC_Enabled && totalCountsText\" class=\"Spa_Style_Note pr-2\">{{\r\n                  totalCountsText\r\n                }}</span>\r\n                <vnext-link\r\n                  *ngIf=\"showAddNonLicensedPlans()\"\r\n                  [title]=\"Spa_PlanList_AddNonLicensedPlans_Text\"\r\n                  alwaysUnderlined=\"true\"\r\n                  [onClickAction]=\"fetchAllPlans\"\r\n                  role=\"button\"\r\n                  linkTarget=\"_self\"\r\n                  [isLinkButton]=\"isLiveEdit ? false : true\"\r\n                  [makeInlineBlock]=\"true\"\r\n                ></vnext-link>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </ng-container>\r\n        <div class=\"col-12 mt-4\">\r\n          <div\r\n            *liveEditProp=\"'Spa_Site_PageSubHeader_Text'\"\r\n            [innerHtml]=\"Spa_Site_PageSubHeader_Text ? (Spa_Site_PageSubHeader_Text | safe : 'html') : ''\"\r\n            navigationAdapter\r\n          ></div>\r\n        </div>\r\n      </div>\r\n      <div\r\n        role=\"tablist\"\r\n        *ngIf=\"tabs && tabs.length && !mobile\"\r\n        [ngClass]=\"{ tabs: isReadyToShowZipcodeLink }\"\r\n        class=\"d-flex justify-content-center\"\r\n        [attr.aria-label]=\"Spa_Site_PlanType_Header\"\r\n      >\r\n        <ng-container *ngFor=\"let tab of tabs; trackBy: tabKey; index as i\">\r\n          <vnext-filter-tab\r\n            *ngIf=\"nonCoveredPlanTabMap[tab.tabTypes[0]]?.display\"\r\n            class=\"filter-tab\"\r\n            [ngClass]=\"{\r\n              'filter-tab-small': tabs.length <= 5,\r\n              'filter-tab-small-2': tabs.length === 6,\r\n              'filter-tab-small-3': tabs.length > 6,\r\n              'filter-tab-small-wide': tab.tabTypes[0] === planTypeAbbreviation.MAPD\r\n            }\"\r\n            #planListTab\r\n            [tabData]=\"tab\"\r\n            [isActive]=\"i === activeTabIndex\"\r\n            [bestCoverageText]=\"Spa_PlanList_BestCoverage_Text\"\r\n            [plansText]=\"Spa_Site_Plans_Text\"\r\n            [planText]=\"Spa_Site_Plan_Text\"\r\n            [currentIndex]=\"i\"\r\n            [lastIndex]=\"tabs.length - 1\"\r\n            [ariaControlsId]=\"'plan-list-container'\"\r\n            (setFocusToTabEvent)=\"shiftFocusToTabElement($event)\"\r\n            [showBestCoverageBanner]=\"Spa_PlanList_BestCoverageType_Enabled\"\r\n            [showAllMedSupEnabled]=\"Spa_PlanList_ShowAllMedigap_Enabled\"\r\n            [bestCoverageIcon]=\"Spa_PlanList_BestMatch_Icon\"\r\n            [bestCoverageText]=\"Spa_PlanList_BestCoverageType_Text\"\r\n            [bestCoverageTooltip]=\"getReturnToPreferencesClickAction()\"\r\n            [bestCoverageTabTypeAbbreviation]=\"bestCoverageTabTypeAbbreviation\"\r\n            [loaderIconEnabled]=\"Spa_Site_Loader_Updated_Icon_Enabled\"\r\n            [plansLoadingText]=\"Spa_Site_Plans_Loading_Text\"\r\n          >\r\n          </vnext-filter-tab>\r\n        </ng-container>\r\n      </div>\r\n      <div *ngIf=\"mobile && tabs?.length\" class=\"row justify-content-center tabs\">\r\n        <!--  since its sorted primary tab is 0 -->\r\n        <vnext-filter-tab\r\n          *ngIf=\"tabMobilePrimary\"\r\n          [ngClass]=\"{\r\n            'filter-tab-small-wide': tabMobilePrimary.tabTypes[0] === planTypeAbbreviation.MAPD\r\n          }\"\r\n          [tabData]=\"tabMobilePrimary\"\r\n          [isActive]=\"isActiveMobilePrimaryTab\"\r\n          class=\"filter-tab\"\r\n          [bestCoverageText]=\"Spa_PlanList_BestCoverage_Text\"\r\n          [plansText]=\"Spa_Site_Plans_Text\"\r\n          [planText]=\"Spa_Site_Plan_Text\"\r\n          [showAllMedSupEnabled]=\"Spa_PlanList_ShowAllMedigap_Enabled\"\r\n        >\r\n        </vnext-filter-tab>\r\n        <!-- selected tab, will be tab 1 (secondary default) if no selected tab -->\r\n        <vnext-filter-tab\r\n          *ngIf=\"(mobileExtraSmall && tabs?.length === 2) || (!mobileExtraSmall && tabs?.length > 1)\"\r\n          class=\"filter-tab\"\r\n          [ngClass]=\"{\r\n            'filter-tab-small-wide': (lastActiveTabThatIsNotDefault || tabs[1]).tabTypes[0] === planTypeAbbreviation.MAPD\r\n          }\"\r\n          [tabData]=\"isMobileExtraSmallOrExactlyThreeTabs ? tabs[1] : lastActiveTabThatIsNotDefault || tabs[1]\"\r\n          [isActive]=\"\r\n            isMobileExtraSmallOrExactlyThreeTabs\r\n              ? activeTabIndex === tabs[1]?.tabIndex\r\n              : lastActiveTabThatIsNotDefault?.tabIndex === activeTabIndex\r\n          \"\r\n          [bestCoverageText]=\"Spa_PlanList_BestCoverage_Text\"\r\n          [plansText]=\"Spa_Site_Plans_Text\"\r\n          [planText]=\"Spa_Site_Plan_Text\"\r\n          [showAllMedSupEnabled]=\"Spa_PlanList_ShowAllMedigap_Enabled\"\r\n        >\r\n        </vnext-filter-tab>\r\n        <!-- will be tab 2 if no selected tab and exactly three plan tabs are available on tablet-sized devices -->\r\n        <vnext-filter-tab\r\n          *ngIf=\"!mobileExtraSmall && tabs?.length === 3\"\r\n          class=\"filter-tab\"\r\n          [ngClass]=\"{\r\n            'filter-tab-small-wide': tabs[2].tabTypes[0] === planTypeAbbreviation.MAPD\r\n          }\"\r\n          [tabData]=\"tabs[2]\"\r\n          [isActive]=\"tabs[2]?.tabIndex === activeTabIndex\"\r\n          [bestCoverageText]=\"Spa_PlanList_BestCoverage_Text\"\r\n          [plansText]=\"Spa_Site_Plans_Text\"\r\n          [planText]=\"Spa_Site_Plan_Text\"\r\n          [showAllMedSupEnabled]=\"Spa_PlanList_ShowAllMedigap_Enabled\"\r\n        >\r\n        </vnext-filter-tab>\r\n        <!-- show the more tab only if there are more than 2 tabs on sm-sized viewports, or more than 1 on xs-sized viewports -->\r\n        <vnext-filter-tab\r\n          class=\"mobile-tab filter-tab\"\r\n          *ngIf=\"(mobileExtraSmall && tabs?.length > 2) || (!mobileExtraSmall && tabs?.length > 3)\"\r\n          [mobileTab]=\"true\"\r\n          [dropdownTabs]=\"mobileTabs\"\r\n          [moreOptionsText]=\"Spa_Site_MoreOptions_Text\"\r\n        ></vnext-filter-tab>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <ng-container *ngIf=\"currentTabPlanCount > 0\">\r\n    <vnext-notice class=\"col-12\" [type]=\"'info'\" [bodyTemplate]=\"ageRestrictionForEnrollment\" *ngIf=\"showMedSupAgeRestrictionBanner\">\r\n    </vnext-notice>\r\n    <vnext-notice\r\n      class=\"col-12\"\r\n      [type]=\"'info'\"\r\n      [bodyTemplate]=\"effectiveDateRestrictionForEnrollment\"\r\n      *ngIf=\"showMedSupEffectiveDateRestrictionBanner\"\r\n    >\r\n    </vnext-notice>\r\n    <div\r\n      class=\"mb-3 px-3\"\r\n      *ngIf=\"\r\n        Spa_PlanList_ShowAllMedigap_Enabled && mobile && activeTabType === planTypeAbbreviation.MEDIGAP && !Spa_PlanList_FilterModal_Enabled\r\n      \"\r\n    >\r\n      <vnext-plan-sub-type-dropdown\r\n        [headerText]=\"Spa_PlanList_MedSupPlanSubTypeHeader_Text\"\r\n        [placeholder]=\"Spa_PlanList_MedSupPlanSubTypePlaceholder_Text\"\r\n        [updatePlansText]=\"Spa_PlanList_MedSupPlanSubTypeUpdate_Text\"\r\n        [planFilterModalEnabled]=\"Spa_PlanList_FilterModal_Enabled\"\r\n        (planSubTypeChanged)=\"planSubTypeChanged()\"\r\n      >\r\n      </vnext-plan-sub-type-dropdown>\r\n    </div>\r\n\r\n    <vnext-guided-help-tab\r\n      *ngIf=\"mobile && Spa_GuidedHelp_Enabled\"\r\n      class=\"mt-1\"\r\n      [guidedHelpPreferenceText]=\"Spa_GuidedHelp_PreferenceInfo_Text\"\r\n      [preferenceButtonText]=\"Spa_Site_AddPreferences\"\r\n      [guidedHelpGetStartedText]=\"Spa_Site_GetStarted_Text\"\r\n      [guidedHelpHealthText]=\"Spa_Site_Health_Text\"\r\n      [guidedHelpPrescriptionsText]=\"Spa_Site_Prescriptions_Text\"\r\n      [guidedHelpPharmacyText]=\"Spa_Site_Pharmacy_Text\"\r\n      [guidedHelpOtherPreferencesText]=\"Spa_Site_OtherPreferences_Text\"\r\n      [guidedHelpOtherPreferencesMessageText]=\"Spa_GuidedHelp_ReviewOtherPreferences_Text\"\r\n      [guidedHelpOtherPreferencesMessageKey]=\"'Spa_GuidedHelp_ReviewOtherPreferences_Text'\"\r\n      [multiPharmacyEnabled]=\"Spa_Site_Multi_Pharmacy_Enabled\"\r\n      [primaryPharmacyIndicatorText]=\"Spa_Site_PrimaryPharmacy_Indicator_Text\"\r\n      [guidedHelpProvidersText]=\"Spa_Site_Providers_Text\"\r\n      [pcpText]=\"Spa_Site_Pcp_Text\"\r\n      [subsidyLabelText]=\"subsidyLabelText\"\r\n      [medicaidEligibilityCheckEnabled]=\"Spa_Profile_StateEligibilityCheck_Enabled\"\r\n      [medicaidCodeText]=\"Spa_GettingStarted_MedicaidCode_Text\"\r\n    ></vnext-guided-help-tab>\r\n    <ng-template #ageRestrictionForEnrollment>\r\n      {{ Spa_MedSup_RestrictMedSupPlansByAge_InfoText }}\r\n      <vnext-link\r\n        [makeInlineBlock]=\"true\"\r\n        (click)=\"planFacade.updateMedSupFormOpen(true)\"\r\n        (keyup.enter)=\"planFacade.updateMedSupFormOpen(true)\"\r\n        [title]=\"Spa_MedSup_RestrictMedSupPlansByAge_InfoLink\"\r\n      ></vnext-link>\r\n    </ng-template>\r\n    <ng-template #effectiveDateRestrictionForEnrollment>\r\n      {{ planFacade.getEffectiveDateRestrictionText() }}\r\n      <vnext-link\r\n        [makeInlineBlock]=\"true\"\r\n        (click)=\"planFacade.updateMedSupFormOpen(true)\"\r\n        (keyup.enter)=\"planFacade.updateMedSupFormOpen(true)\"\r\n        [title]=\"Spa_MedSup_RestrictMedSupPlansByAge_InfoLink\"\r\n      ></vnext-link>\r\n    </ng-template>\r\n    <div class=\"container\">\r\n      <div *ngIf=\"showDentalForm && activeTabType === planTypeAbbreviation.DENTAL\">\r\n        <vnext-med-sup-form\r\n          (formClose)=\"dentalVisionFormClose($event)\"\r\n          [showPreviousLink]=\"Spa_PlanList_RateFactorsPreviousLink_Enabled\"\r\n          [productType]=\"productType.DENTAL\"\r\n          [previousLabel]=\"Spa_Site_Previous\"\r\n          [inchesLabel]=\"Spa_PlanList_MedSupFormInchesLabel_Text\"\r\n          [feetLabel]=\"Spa_PlanList_MedSupFormFeetLabel_Text\"\r\n          [poundsLabel]=\"Spa_PlanList_MedSupFormPoundsLabel_Text\"\r\n          [selectMonthText]=\"Spa_PlanList_MedSupFormMonthLabel_Text\"\r\n          [selectYearText]=\"Spa_PlanList_MedSupFormYearLabel_Text\"\r\n          [dropdownDefaultText]=\"Spa_PlanList_MedSupFormDropdownDefault_Text\"\r\n          [continueButtonText]=\"Spa_Site_ContinueToPlanList\"\r\n          [formTitle]=\"Spa_PlanList_DentalFormTitle_Text\"\r\n          [formPrompt]=\"Spa_PlanList_DentalFormPrompt_Text\"\r\n          [sortedQuestions]=\"ancillaryQuestions\"\r\n          [questionMetaData]=\"filteredAncillaryQuestionMetaData\"\r\n          [guaranteedIssueOptions]=\"guaranteedIssueOptions\"\r\n          [guaranteedIssueText]=\"Spa_PlanList_GuaranteedIssue_Text\"\r\n          [guaranteedIssueTooltip]=\"Spa_PlanList_GuaranteedIssue_Tooltip\"\r\n          [plansLoading]=\"plansLoading\"\r\n          [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n          [spaPageSubHeader]=\"Spa_Dental_PageSubHeader_Text\"\r\n          [errorNoticeTitle]=\"Spa_Site_EnrollmentErrorNotice_Title\"\r\n          [totalPlanCount]=\"totalPlanCount\"\r\n          [effectiveDateMessage]=\"Spa_PlanList_Effective_Date_Text\"\r\n          [rateFactorDisclaimer]=\"Spa_Rate_Factor_Disclaimer_Text\"\r\n          [rateFactorDisclaimerEnabled]=\"Spa_Rate_Factor_Disclaimer_Enabled\"\r\n        ></vnext-med-sup-form>\r\n      </div>\r\n      <div *ngIf=\"showVisionForm && activeTabType === planTypeAbbreviation.VISION\">\r\n        <vnext-med-sup-form\r\n          (formClose)=\"dentalVisionFormClose($event)\"\r\n          [showPreviousLink]=\"Spa_PlanList_RateFactorsPreviousLink_Enabled\"\r\n          [productType]=\"productType.VISION\"\r\n          [previousLabel]=\"Spa_Site_Previous\"\r\n          [inchesLabel]=\"Spa_PlanList_MedSupFormInchesLabel_Text\"\r\n          [feetLabel]=\"Spa_PlanList_MedSupFormFeetLabel_Text\"\r\n          [poundsLabel]=\"Spa_PlanList_MedSupFormPoundsLabel_Text\"\r\n          [selectMonthText]=\"Spa_PlanList_MedSupFormMonthLabel_Text\"\r\n          [selectYearText]=\"Spa_PlanList_MedSupFormYearLabel_Text\"\r\n          [dropdownDefaultText]=\"Spa_PlanList_MedSupFormDropdownDefault_Text\"\r\n          [continueButtonText]=\"Spa_Site_ContinueToPlanList\"\r\n          [formTitle]=\"Spa_PlanList_VisionFormTitle_Text\"\r\n          [formPrompt]=\"Spa_PlanList_VisionFormPrompt_Text\"\r\n          [sortedQuestions]=\"ancillaryQuestions\"\r\n          [questionMetaData]=\"filteredAncillaryQuestionMetaData\"\r\n          [guaranteedIssueOptions]=\"guaranteedIssueOptions\"\r\n          [guaranteedIssueText]=\"Spa_PlanList_GuaranteedIssue_Text\"\r\n          [guaranteedIssueTooltip]=\"Spa_PlanList_GuaranteedIssue_Tooltip\"\r\n          [plansLoading]=\"plansLoading\"\r\n          [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n          [spaPageSubHeader]=\"Spa_Vision_PageSubHeader_Text\"\r\n          [errorNoticeTitle]=\"Spa_Site_EnrollmentErrorNotice_Title\"\r\n          [totalPlanCount]=\"totalPlanCount\"\r\n          [effectiveDateMessage]=\"Spa_PlanList_Effective_Date_Text\"\r\n          [rateFactorDisclaimer]=\"Spa_Rate_Factor_Disclaimer_Text\"\r\n          [rateFactorDisclaimerEnabled]=\"Spa_Rate_Factor_Disclaimer_Enabled\"\r\n        ></vnext-med-sup-form>\r\n      </div>\r\n      <div *ngIf=\"showHospitalIndemnityForm && activeTabType === planTypeAbbreviation.HC\">\r\n        <vnext-hospital-indemnity-form\r\n          [plansLoading]=\"plansLoading\"\r\n          [showPreviousLink]=\"Spa_PlanList_RateFactorsPreviousLink_Enabled\"\r\n          [spaPageSubHeader]=\"Spa_PlanList_HIPFormPrompt_Text\"\r\n          [spaPageTitle]=\"Spa_PlanList_HIP_PageTitle_Text\"\r\n          [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n          [errorNoticeTitle]=\"Spa_Site_EnrollmentErrorNotice_Title\"\r\n          [dropdownDefaultText]=\"Spa_PlanList_MedSupFormDropdownDefault_Text\"\r\n          [continueButtonText]=\"Spa_Site_ContinueToPlanList\"\r\n          [noPlansAvailableHeaderText]=\"Spa_PlanList_NoPlansAvailable_Text\"\r\n          [noPlansAvailableBodyText]=\"Spa_PlanList_Tab_Text_NoPlans_HIP\"\r\n          [noneText]=\"SPA_HIP_Rider_Benefit_Default_Dropdown_Text\"\r\n          [rateFactorDisclaimer]=\"Spa_Rate_Factor_Disclaimer_Text\"\r\n          [rateFactorDisclaimerEnabled]=\"Spa_Rate_Factor_Disclaimer_Enabled\"\r\n          (formClose)=\"onHospitalIndemnityFormClose($event)\"\r\n        ></vnext-hospital-indemnity-form>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n  <div *ngIf=\"showMedSupForm\" class=\"container\">\r\n    <vnext-med-sup-form\r\n      (formClose)=\"medSupFormClose($event)\"\r\n      [previousLabel]=\"Spa_Site_Previous\"\r\n      [inchesLabel]=\"Spa_PlanList_MedSupFormInchesLabel_Text\"\r\n      [feetLabel]=\"Spa_PlanList_MedSupFormFeetLabel_Text\"\r\n      [poundsLabel]=\"Spa_PlanList_MedSupFormPoundsLabel_Text\"\r\n      [selectMonthText]=\"Spa_PlanList_MedSupFormMonthLabel_Text\"\r\n      [selectYearText]=\"Spa_PlanList_MedSupFormYearLabel_Text\"\r\n      [dropdownDefaultText]=\"Spa_PlanList_MedSupFormDropdownDefault_Text\"\r\n      [continueButtonText]=\"Spa_Site_ContinueToPlanList\"\r\n      [formTitle]=\"Spa_PlanList_MedSupFormTitle_Text\"\r\n      [formPrompt]=\"Spa_PlanList_MedSupFormPrompt_Text\"\r\n      [showPreviousLink]=\"Spa_PlanList_RateFactorsPreviousLink_Enabled\"\r\n      [sortedQuestions]=\"sortedQuestions\"\r\n      [questionMetaData]=\"filteredQuestionMetaData\"\r\n      [guaranteedIssueOptions]=\"guaranteedIssueOptions\"\r\n      [guaranteedIssueText]=\"Spa_PlanList_GuaranteedIssue_Text\"\r\n      [guaranteedIssueTooltip]=\"Spa_PlanList_GuaranteedIssue_Tooltip\"\r\n      [plansLoading]=\"plansLoading\"\r\n      [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n      [spaPageSubHeader]=\"Spa_MedSup_PageSubHeader_Text\"\r\n      [errorNoticeTitle]=\"Spa_Site_EnrollmentErrorNotice_Title\"\r\n      [planSubTypeEnabled]=\"Spa_PlanList_ShowAllMedigap_Enabled\"\r\n      [planSubTypeHeaderText]=\"Spa_PlanList_MedSupPlanSubTypeHeader_Text\"\r\n      [planSubTypePlaceholderText]=\"Spa_PlanList_MedSupPlanSubTypePlaceholder_Text\"\r\n      [totalPlanCount]=\"totalPlanCount\"\r\n      [effectiveDateMessage]=\"Spa_PlanList_Effective_Date_Text\"\r\n      [rateFactorDisclaimer]=\"Spa_Rate_Factor_Disclaimer_Text\"\r\n      [rateFactorDisclaimerEnabled]=\"Spa_Rate_Factor_Disclaimer_Enabled\"\r\n    ></vnext-med-sup-form>\r\n  </div>\r\n  <div\r\n    class=\"container\"\r\n    [ngClass]=\"{ 'd-none': showMedSupForm || showDentalForm || showVisionForm || showHospitalIndemnityForm }\"\r\n    id=\"plan-list-container\"\r\n    role=\"tabpanel\"\r\n  >\r\n    <div class=\"row\">\r\n      <div class=\"col-12\">\r\n        <p class=\"mb-0\">\r\n          <ng-container *ngIf=\"Spa_Plan_Tab_Educational_Text_Show\">\r\n            <!-- SPA-8897 - Need to check for educationalTextResource because we were getting into a situation \r\n              where the if predicate would resolve and be stuck in the else block even after educationTextResource\r\n              until switching tabs. We also need the text resource for the liveEditableBlock -->\r\n            <ng-container *ngIf=\"activeTabType !== planTypeAbbreviation.MEDIGAP && educationalTextResource; else nonLiveEditable\">\r\n              <div\r\n                class=\"educational-text\"\r\n                *liveEditProp=\"educationalTextResource\"\r\n                [innerHTML]=\"getEducationalText(activeTabType) | safe : 'html'\"\r\n                navigationAdapter\r\n              ></div>\r\n            </ng-container>\r\n            <ng-template #nonLiveEditable>\r\n              <div class=\"educational-text\" [innerHTML]=\"getEducationalText(activeTabType) | safe : 'html'\" navigationAdapter></div>\r\n            </ng-template>\r\n          </ng-container>\r\n        </p>\r\n      </div>\r\n    </div>\r\n    <vnext-pharmacy-selector\r\n      *ngIf=\"mobile && Spa_GuidedHelp_Enabled && pharmacyFacade.showPharmacySelectorToggle(activeTabType)\"\r\n      [preferencesBannerEnabled]=\"Spa_PreferenceBanner_Enabled\"\r\n      [pharmacySelectorTextKey]=\"'Spa_Site_CostBasedOn_Text'\"\r\n      [pharmacySelectorText]=\"Spa_Site_CostBasedOn_Text\"\r\n      [pharmacies]=\"selectedPharmacies\"\r\n      [selectedPharmacy]=\"selectedPharmacy\"\r\n      [mailOrderText]=\"Spa_PlanList_MailOrder_Text\"\r\n      [isMailOrderSelected]=\"mailOrder\"\r\n      [showMailOrderOption]=\"planFacade.isMailOrderPharmacyAvailable(filteredPlans)\"\r\n      (selectMailOrder)=\"pharmacyFacade.switchMailOrder(true)\"\r\n      (selectPharmacy)=\"updateSelectedPharmacy($event)\"\r\n    >\r\n    </vnext-pharmacy-selector>\r\n    <vnext-effective-date-display\r\n      *ngIf=\"mobile && !Spa_PlanList_FilterModal_Enabled\"\r\n      [activePlanType]=\"activeTabType\"\r\n      (dateUpdated)=\"onEffectiveDateModalChange()\"\r\n    ></vnext-effective-date-display>\r\n    <ng-container\r\n      *ngIf=\"\r\n        Spa_MedSupForm_AllowFormWhenNoPlansAvailable_Enabled && activeTabType === planTypeAbbreviation.MEDIGAP && currentTabPlanCount === 0\r\n      \"\r\n    >\r\n      <div class=\"row\">\r\n        <div class=\"col-12\">\r\n          <vnext-rate-factor-warning\r\n            [showRateFactorWarningBanner]=\"!hasMedSupAnswers\"\r\n            [hasRateFactorAnswers]=\"hasMedSupAnswers\"\r\n            [rateFactorWarningBannerText]=\"Spa_PlanList_MedSupWarningBanner_Text\"\r\n            [rateFactorWarningBannerClickableText]=\"Spa_PlanList_MedSupWarningBannerClickable_Text\"\r\n            [rateFactorEditAnswersBannerText]=\"Spa_PlanList_MedSupEditAnswersBanner_Text\"\r\n            [rateFactorEditAnswersBannerClickableText]=\"Spa_PlanList_MedSupEditAnswersBannerClickable_Text\"\r\n            (loadRateFactorForm)=\"loadMedSupForm()\"\r\n          >\r\n          </vnext-rate-factor-warning>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"currentTabPlanCount\">\r\n      <div class=\"row\">\r\n        <!-- TODO: SPA-60 -->\r\n        <ng-container [ngSwitch]=\"activeTabType\">\r\n          <div class=\"col-12\" *ngSwitchCase=\"planTypeAbbreviation.MEDIGAP\">\r\n            <vnext-rate-factor-warning\r\n              [showRateFactorWarningBanner]=\"!hasMedSupAnswers && medSupPlansWithoutFilters.length\"\r\n              [hasRateFactorAnswers]=\"hasMedSupAnswers\"\r\n              [rateFactorWarningBannerText]=\"Spa_PlanList_MedSupWarningBanner_Text\"\r\n              [rateFactorWarningBannerClickableText]=\"Spa_PlanList_MedSupWarningBannerClickable_Text\"\r\n              [rateFactorEditAnswersBannerText]=\"Spa_PlanList_MedSupEditAnswersBanner_Text\"\r\n              [rateFactorEditAnswersBannerClickableText]=\"Spa_PlanList_MedSupEditAnswersBannerClickable_Text\"\r\n              (loadRateFactorForm)=\"loadMedSupForm()\"\r\n            >\r\n            </vnext-rate-factor-warning>\r\n          </div>\r\n\r\n          <div class=\"col-12\" *ngSwitchCase=\"planTypeAbbreviation.DENTAL\">\r\n            <vnext-rate-factor-warning\r\n              [showRateFactorWarningBanner]=\"!hasAncillaryAnswers && dentalPlansWithoutFilters.length\"\r\n              [hasRateFactorAnswers]=\"hasAncillaryAnswers\"\r\n              [rateFactorWarningBannerText]=\"Spa_PlanList_DentalVisionWarningBanner_Text\"\r\n              [rateFactorWarningBannerClickableText]=\"Spa_PlanList_DentalVisionWarningBannerClickable_Text\"\r\n              [rateFactorEditAnswersBannerText]=\"Spa_PlanList_DentalVisionEditAnswersBanner_Text\"\r\n              [rateFactorEditAnswersBannerClickableText]=\"Spa_PlanList_DentalVisionEditAnswersBannerClickable_Text\"\r\n              (loadRateFactorForm)=\"loadDentalVisionForm(planTypeAbbreviation.DENTAL)\"\r\n            >\r\n            </vnext-rate-factor-warning>\r\n          </div>\r\n\r\n          <div class=\"col-12\" *ngSwitchCase=\"planTypeAbbreviation.VISION\">\r\n            <vnext-rate-factor-warning\r\n              [showRateFactorWarningBanner]=\"!hasAncillaryAnswers && visionPlansWithoutFilters.length\"\r\n              [hasRateFactorAnswers]=\"hasAncillaryAnswers\"\r\n              [rateFactorWarningBannerText]=\"Spa_PlanList_DentalVisionWarningBanner_Text\"\r\n              [rateFactorWarningBannerClickableText]=\"Spa_PlanList_DentalVisionWarningBannerClickable_Text\"\r\n              [rateFactorEditAnswersBannerText]=\"Spa_PlanList_DentalVisionEditAnswersBanner_Text\"\r\n              [rateFactorEditAnswersBannerClickableText]=\"Spa_PlanList_DentalVisionEditAnswersBannerClickable_Text\"\r\n              (loadRateFactorForm)=\"loadDentalVisionForm(planTypeAbbreviation.VISION)\"\r\n            >\r\n            </vnext-rate-factor-warning>\r\n          </div>\r\n\r\n          <div class=\"col-12\" *ngSwitchCase=\"planTypeAbbreviation.HC\">\r\n            <vnext-hip-details-banner\r\n              [numberOfDaysText]=\"Spa_PlanFilters_DayLabel_Text\"\r\n              [daysText]=\"Spa_Site_Days_Text\"\r\n              [dayText]=\"Spa_Site_Day_Text\"\r\n              [editYourAnswersText]=\"Spa_PlanList_MedSupEditAnswersBanner_Text\"\r\n              [lumpSumText]=\"Spa_Site_LumpSum_Text\"\r\n              [basePlanText]=\"Spa_Site_HIP_BasePlanOption_Text\"\r\n              [daysAmount]=\"hospitalIndemnityAnswers?.HCDaysCovered\"\r\n              [benefitAmount]=\"hospitalIndemnityAnswers?.BenefitAmount\"\r\n            ></vnext-hip-details-banner>\r\n          </div>\r\n        </ng-container>\r\n        <div class=\"col-12\" *ngIf=\"Spa_PlanList_Show_DSNP_EligibleMessage && dSNPPlansCount && subsidySelected === subsidies.MEDICAID\">\r\n          <vnext-dsnp-eligibility-message\r\n            [titleText]=\"Spa_PlanList_DSNP_EligibleMessage_Header_Text\"\r\n            [bodyText]=\"Spa_PlanList_DSNP_EligibleMessage_Info_Text\"\r\n            [tooltipText]=\"Spa_DSNP_Eligibility_Tooltip_Text\"\r\n            [tooltipLabelText]=\"Spa_DSNP_Eligibility_LearnMore_Text\"\r\n            [filterCodeText]=\"Spa_DSNPEligibility_FilterCodeMessage_Text\"\r\n            [isMobile]=\"mobile\"\r\n            [filterCodeEnabled]=\"Spa_DSNPEligibility_FilterCodeMessage_Enabled\"\r\n          ></vnext-dsnp-eligibility-message>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row mt-2 mb-2\" *ngIf=\"showSelectPlanQuote\">\r\n        <div class=\"col-12\">\r\n          <vnext-widget-select-plan-quote\r\n            [planTypeInstructionalText]=\"Spa_PlanList_PlanType_Instructional_Text\"\r\n            [planTypes]=\"enabledPlanTypesData\"\r\n            [planTypeHintText]=\"Spa_PlanList_SelectPlanType_Hint_Text\"\r\n            [planTypeText]=\"Spa_Site_PlanType_Header\"\r\n            [selectPlanButtonText]=\"Spa_PlanList_SelectPlan_Button_Text\"\r\n            [carriersHintText]=\"Spa_PlanList_SelectPlan_Carriers_Hint_Text\"\r\n            [carriersText]=\"Spa_Site_Carrier_Header\"\r\n            [plansToQuoteHintText]=\"Spa_PlanList_SelectPlan_Hint_Text\"\r\n            [plansToQuoteText]=\"Spa_PlanList_SelectPlan_Text\"\r\n            [noPlansAvailableText]=\"Spa_PlanList_NoPlansAvailable_Text\"\r\n            [noPlansAvailableHintText]=\"Spa_PlanList_NoPlansAvailable_Hint_Text\"\r\n            [requiredFieldsHintText]=\"Spa_PlanList_RequiredFields_Hint_Text\"\r\n            [pleaseSelectRequiredFieldsErrorText]=\"Spa_PlanList_PleaseSelect_Error_Text\"\r\n            [planMarketingNameEnabled]=\"Spa_Filter_Plan_Marketing_Name_Enabled\"\r\n            (selectPlanNameToQuote)=\"selectPlanNameToQuote($event)\"\r\n          ></vnext-widget-select-plan-quote>\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"showPlanQuote\">\r\n        <ng-container [ngSwitch]=\"activeTabType\">\r\n          <div class=\"row mt-2 mb-2\" *ngSwitchCase=\"planTypeAbbreviation.HC\">\r\n            <div class=\"col-12\">\r\n              <vnext-widget-plan-quote\r\n                *ngIf=\"!showAddMedicareAdvantagePlan\"\r\n                [activeTabType]=\"activeTabType\"\r\n                [selectedQuoteGroup]=\"tabs[activeTabIndex]?.compareGroup[0]\"\r\n                [plansSelectedToQuote]=\"selectedHospitalIndemnityPlans\"\r\n                [sendQuoteButtonText]=\"Spa_Site_SendQuote_Button_Text\"\r\n                [viewQuoteButtonText]=\"Spa_PlanList_ViewQuote_Text\"\r\n                [planCardQuoteLinkNameText]=\"Spa_PlanCard_QuoteLinkName_Text\"\r\n                [quoteHintText]=\"quoteHintText\"\r\n                [addToQuoteLimit]=\"addToQuoteLimit\"\r\n                [isMedicareQuote]=\"true\"\r\n                [planTypes]=\"enabledPlanTypesData\"\r\n                [hospitalIndemnityBadgeText]=\"Spa_Site_HIP_Description\"\r\n                [addMedicareAdvantagePlanText]=\"Spa_Site_HIP_Add_Medicare_Advantage_Plan_Text\"\r\n                [showAddMedicareAdvantageButton]=\"!showAddMedicareAdvantagePlan && isSelectPlanQuote\"\r\n                [removeFromQuoteText]=\"Spa_PlanCard_RemoveFromQuote_Text\"\r\n                (addMedicareAdvantagePlan)=\"addMedicareAdvantagePlan()\"\r\n                (viewPlanDetails)=\"planFacade.viewPlanDetailsPage($event)\"\r\n                (removePlanFromQuoteGroup)=\"removeHospitalIndemnityPlanFromQuoteGroup($event.selectedQuoteGroup, $event.plan)\"\r\n                (openSendQuoteModal)=\"openHospitalIndemnityViewQuote()\"\r\n                (getPersonalizedQuote)=\"updateActiveTab($event)\"\r\n              ></vnext-widget-plan-quote>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"row mt-2 mb-2\" *ngSwitchDefault>\r\n            <div class=\"col-12\">\r\n              <vnext-widget-plan-quote\r\n                [selectedQuoteGroup]=\"tabs[activeTabIndex]?.quoteGroups[0]\"\r\n                [plansSelectedToQuote]=\"getPlansSelectedToQuote$() | async\"\r\n                [sendQuoteButtonText]=\"Spa_Site_SendQuote_Button_Text\"\r\n                [viewQuoteButtonText]=\"Spa_PlanList_ViewQuote_Text\"\r\n                [quoteHintText]=\"quoteHintText\"\r\n                [addToQuoteLimit]=\"Spa_PlanList_AddToQuote_Limit\"\r\n                [isMedicareQuote]=\"isSelectPlanQuote\"\r\n                [planTypes]=\"enabledPlanTypesData\"\r\n                [removeFromQuoteText]=\"Spa_PlanCard_RemoveFromQuote_Text\"\r\n                (viewPlanDetails)=\"planFacade.viewPlanDetailsPage($event)\"\r\n                (removePlanFromQuoteGroup)=\"removePlanFromQuoteGroup($event.selectedQuoteGroup, $event.plan)\"\r\n                (openSendQuoteModal)=\"planFacade.openSendQuoteModal()\"\r\n              ></vnext-widget-plan-quote>\r\n            </div>\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n    </ng-container>\r\n    <div class=\"row\">\r\n      <div class=\"aside-second d-none d-md-block col-md-3\" *ngIf=\"currentTabPlanCount && !Spa_PlanList_FilterModal_Enabled\">\r\n        <ng-container *ngIf=\"Spa_PlanList_ShowAllMedigap_Enabled && activeTabType === planTypeAbbreviation.MEDIGAP\">\r\n          <vnext-plan-sub-type-dropdown\r\n            [headerText]=\"Spa_PlanList_MedSupPlanSubTypeHeader_Text\"\r\n            [placeholder]=\"Spa_PlanList_MedSupPlanSubTypePlaceholder_Text\"\r\n            [updatePlansText]=\"Spa_PlanList_MedSupPlanSubTypeUpdate_Text\"\r\n            [planFilterModalEnabled]=\"Spa_PlanList_FilterModal_Enabled\"\r\n            (planSubTypeChanged)=\"planSubTypeChanged()\"\r\n          >\r\n          </vnext-plan-sub-type-dropdown>\r\n        </ng-container>\r\n        <vnext-pharmacy-selector\r\n          *ngIf=\"pharmacyFacade.showPharmacySelectorToggle(activeTabType)\"\r\n          [preferencesBannerEnabled]=\"Spa_PreferenceBanner_Enabled\"\r\n          [pharmacySelectorTextKey]=\"'Spa_Site_CostBasedOn_Text'\"\r\n          [pharmacySelectorText]=\"Spa_Site_CostBasedOn_Text\"\r\n          [pharmacies]=\"selectedPharmacies\"\r\n          [selectedPharmacy]=\"selectedPharmacy\"\r\n          [mailOrderText]=\"Spa_PlanList_MailOrder_Text\"\r\n          [isMailOrderSelected]=\"mailOrder\"\r\n          [showMailOrderOption]=\"planFacade.isMailOrderPharmacyAvailable(filteredPlans)\"\r\n          (selectMailOrder)=\"this.selectMailOrder()\"\r\n          (selectPharmacy)=\"updateSelectedPharmacy($event)\"\r\n        ></vnext-pharmacy-selector>\r\n        <vnext-effective-date-display\r\n          [activePlanType]=\"activeTabType\"\r\n          (dateUpdated)=\"onEffectiveDateModalChange()\"\r\n        ></vnext-effective-date-display>\r\n        <ng-container *ngIf=\"!hasEnteredPreferences\">\r\n          <vnext-plan-list-accordion\r\n            [guidedHelpEnabled]=\"Spa_GuidedHelp_Enabled\"\r\n            [guidedHelpHeaderText]=\"Spa_GuidedHelp_Preference_Text\"\r\n            [guidedHelpHeaderTextKeyName]=\"'Spa_GuidedHelp_Preference_Text'\"\r\n            [guidedHelpPreferenceText]=\"Spa_GuidedHelp_PreferenceInfo_Text\"\r\n            [guidedHelpPreferenceButtonText]=\"Spa_Site_AddPreferences\"\r\n            [guidedHelpHideLinkText]=\"Spa_Site_Hide_Text\"\r\n            [guidedHelpViewAllLinkText]=\"Spa_Site_ViewAll_Text\"\r\n            [guidedHelpGetStartedText]=\"Spa_Site_GetStarted_Text\"\r\n            [guidedHelpHealthText]=\"Spa_Site_Health_Text\"\r\n            [guidedHelpPrescriptionsText]=\"Spa_Site_Prescriptions_Text\"\r\n            [guidedHelpPharmacyText]=\"Spa_Site_Pharmacy_Text\"\r\n            [guidedHelpOtherPreferencesText]=\"Spa_Site_OtherPreferences_Text\"\r\n            [guidedHelpOtherPreferencesMessageText]=\"Spa_GuidedHelp_ReviewOtherPreferences_Text\"\r\n            [guidedHelpOtherPreferencesMessageKey]=\"'Spa_GuidedHelp_ReviewOtherPreferences_Text'\"\r\n            [multiPharmacyEnabled]=\"Spa_Site_Multi_Pharmacy_Enabled\"\r\n            [isLiveEdit]=\"isLiveEdit\"\r\n            [primaryPharmacyIndicatorText]=\"Spa_Site_PrimaryPharmacy_Indicator_Text\"\r\n            [guidedHelpProvidersText]=\"Spa_Site_Providers_Text\"\r\n            [pcpText]=\"Spa_Site_Pcp_Text\"\r\n            [subsidyLabelText]=\"subsidyLabelText\"\r\n            [medicaidEligibilityCheckEnabled]=\"Spa_Profile_StateEligibilityCheck_Enabled\"\r\n            [medicaidCodeText]=\"Spa_GettingStarted_MedicaidCode_Text\"\r\n          ></vnext-plan-list-accordion>\r\n        </ng-container>\r\n        <ng-container *ngIf=\"activeTabType\">\r\n          <vnext-plan-filter\r\n            [defaultFilterText]=\"Spa_PlanFilters_DefaultText\"\r\n            [filterDayText]=\"Spa_PlanFilters_DayLabel_Text\"\r\n            [selectFilterDayText]=\"Spa_PlanFilters_SelectDayLabel_Text\"\r\n            [filterCarrierText]=\"Spa_PlanFilters_CarrierLabel_Text\"\r\n            [filterHeaderText]=\"Spa_Filter_Header_Text\"\r\n            [filterClearAll]=\"Spa_Filter_Clear_All\"\r\n            [planSubTypeLabel]=\"Spa_PlanFilters_SubType_Label\"\r\n            [showEmptyFilterMessage]=\"showEmptyFilterMessage\"\r\n            [showNoPlansFromAnswersMessage]=\"showNoPlansFromAnswersMessage\"\r\n            [licensingHeaderText]=\"Spa_Filter_LicensingHeader_Text\"\r\n            [snpBaseTypeLabel]=\"Spa_Filter_SNPBaseTypes_Label\"\r\n            [currentTab]=\"currentTab\"\r\n            [snpEnabled]=\"Spa_Site_SNPTools_Enabled\"\r\n            [additionalSavingsHeaderText]=\"Spa_Filter_AdditionalSavingsHeader_Text\"\r\n            [defaultPlanBenefitFilters]=\"Spa_Site_Default_Plan_Benefit_Filter\"\r\n            [insulinSavingsEnabled]=\"Spa_Filter_InsulinSavings_Enabled\"\r\n            [filterDSNPMedicaidCodesEnabled]=\"Spa_Filter_DSNPMedicaidCodes_Enabled\"\r\n            [defaultPlanBenefitFiltersEnabled]=\"Spa_Filter_PlanBenefitsGroup_Enabled\"\r\n            [costFilterEnabled]=\"isCostFilterEnabled\"\r\n            [medicalDeductibleHeaderText]=\"Spa_Filter_MedicalDeductible_Text\"\r\n            [medicalDeductibleToolTipText]=\"Spa_Filter_MedicalDeductible_ToolTip_Text\"\r\n            [maximumOutOfPocketCostHeaderText]=\"Spa_Filter_MaximumOutOfPocketCost_Text\"\r\n            [maximumOutOfPocketCostToolTipText]=\"Spa_Filter_MaximumOutOfPocketCost_ToolTip_Text\"\r\n            [drugDeductibleHeaderText]=\"Spa_Filter_PharmacyDeductible_Text\"\r\n            [drugDeductibleToolTipText]=\"Spa_Filter_PharmacyDeductible_ToolTip_Text\"\r\n            [premiumHeaderText]=\"Spa_Filter_Premium_Text\"\r\n            [premiumToolTipText]=\"Spa_Filter_Premium_ToolTip_Text\"\r\n            [addOnTooltipText]=\"Spa_Filter_AddOn_Coverage_ToolTip_Text\"\r\n            [addOnFilterHeaderText]=\"Spa_PlanList_AddOn_Header_Text\"\r\n            [addOnFilterEnabled]=\"Spa_PlanList_AddOn_Filter_Enabled\"\r\n            [isTabFilterExpanded]=\"Spa_PlanList_Filters_Expanded\"\r\n            [providersNpiTooltipText]=\"Spa_Filter_Providers_ToolTip_Text\"\r\n            [providersNpiHeaderText]=\"Spa_Site_Providers_Header_Text\"\r\n            [providersEnabled]=\"Spa_Site_Providers_Enabled\"\r\n            [providersNpiFilterEnabled]=\"Spa_Npi_Filter_Enabled\"\r\n            [showTabFilter]=\"showTabFilter\"\r\n            (filterItemClicked)=\"filterClicked()\"\r\n            (clearAllFiltersClicked)=\"filterClicked()\"\r\n            [planTypeLabel]=\"Spa_Site_PlanType_Header\"\r\n            [allInNetworkLocationsEnabled]=\"Spa_Site_Provider_ShowAllInNetworkLocations_Enabled\"\r\n          >\r\n          </vnext-plan-filter>\r\n        </ng-container>\r\n        <ng-container *ngIf=\"hasEnteredPreferences\">\r\n          <vnext-plan-list-accordion\r\n            [guidedHelpEnabled]=\"Spa_GuidedHelp_Enabled\"\r\n            [guidedHelpHeaderText]=\"Spa_GuidedHelp_Preference_Text\"\r\n            [guidedHelpHeaderTextKeyName]=\"'Spa_GuidedHelp_Preference_Text'\"\r\n            [guidedHelpPreferenceText]=\"Spa_GuidedHelp_PreferenceInfo_Text\"\r\n            [guidedHelpPreferenceButtonText]=\"Spa_Site_AddPreferences\"\r\n            [guidedHelpHideLinkText]=\"Spa_Site_Hide_Text\"\r\n            [guidedHelpViewAllLinkText]=\"Spa_Site_ViewAll_Text\"\r\n            [guidedHelpGetStartedText]=\"Spa_Site_GetStarted_Text\"\r\n            [guidedHelpHealthText]=\"Spa_Site_Health_Text\"\r\n            [guidedHelpPrescriptionsText]=\"Spa_Site_Prescriptions_Text\"\r\n            [guidedHelpPharmacyText]=\"Spa_Site_Pharmacy_Text\"\r\n            [guidedHelpOtherPreferencesText]=\"Spa_Site_OtherPreferences_Text\"\r\n            [guidedHelpOtherPreferencesMessageText]=\"Spa_GuidedHelp_ReviewOtherPreferences_Text\"\r\n            [guidedHelpOtherPreferencesMessageKey]=\"'Spa_GuidedHelp_ReviewOtherPreferences_Text'\"\r\n            [multiPharmacyEnabled]=\"Spa_Site_Multi_Pharmacy_Enabled\"\r\n            [isLiveEdit]=\"isLiveEdit\"\r\n            [primaryPharmacyIndicatorText]=\"Spa_Site_PrimaryPharmacy_Indicator_Text\"\r\n            [guidedHelpProvidersText]=\"Spa_Site_Providers_Text\"\r\n            [pcpText]=\"Spa_Site_Pcp_Text\"\r\n            [subsidyLabelText]=\"subsidyLabelText\"\r\n            [medicaidEligibilityCheckEnabled]=\"Spa_Profile_StateEligibilityCheck_Enabled\"\r\n            [medicaidCodeText]=\"Spa_GettingStarted_MedicaidCode_Text\"\r\n          ></vnext-plan-list-accordion>\r\n        </ng-container>\r\n      </div>\r\n      <div\r\n        class=\"col-12\"\r\n        infiniteScroll\r\n        [infiniteScrollDistance]=\"2\"\r\n        [infiniteScrollThrottle]=\"50\"\r\n        (scrolled)=\"onScrollDown()\"\r\n        [ngClass]=\"{ 'col-md-9': currentTabPlanCount && !Spa_PlanList_FilterModal_Enabled, 'col-md-12': currentTabPlanCount && Spa_PlanList_FilterModal_Enabled, }\"\r\n        aria-live=\"polite\"\r\n        aria-atomic=\"true\"\r\n      >\r\n        <ng-container *ngIf=\"currentTabPlanCount\">\r\n          <div class=\"row plan-list-settings\" [ngClass]=\"{ 'align-items-start': Spa_PlanList_FilterModal_Enabled }\">\r\n            <div\r\n              class=\"col-12\"\r\n              [ngClass]=\"{\r\n                'col-md-8 col-sm-12 pr-0 pl-2': Spa_PlanList_FilterModal_Enabled,\r\n                'col-md-6': !Spa_PlanList_FilterModal_Enabled\r\n              }\"\r\n            >\r\n              <div *ngIf=\"Spa_PlanList_FilterModal_Enabled\" class=\"row\">\r\n                <div class=\"col-xs-12 ml-4\">\r\n                  <button\r\n                    type=\"button\"\r\n                    [attr.aria-label]=\"Spa_PlanFilters_Modal_Button_Label\"\r\n                    tabindex=\"0\"\r\n                    class=\"btn Spa_Style_SecondaryButton\"\r\n                    [title]=\"Spa_PlanFilters_Modal_Button_Label\"\r\n                    (click)=\"openFilterModal($event)\"\r\n                  >\r\n                    {{ Spa_PlanFilters_Modal_Button_Label }}\r\n                  </button>\r\n                </div>\r\n                <div *ngIf=\"!filterPopupOpen\" class=\"col-10 col-xs-12 pr-0\">\r\n                  <ng-container\r\n                    *ngIf=\"Spa_PlanList_ShowAllMedigap_Enabled && selectedPlanSubType && activeTabType === planTypeAbbreviation.MEDIGAP\"\r\n                  >\r\n                    <span class=\"selected-filter-tag\">{{ selectedPlanSubType }} </span>\r\n                  </ng-container>\r\n                  <ng-container *ngIf=\"!snpVisibility && activeTabType === planTypeAbbreviation.MAPD\">\r\n                    <span class=\"selected-filter-tag\"\r\n                      >{{ Spa_PlanList_HideSNPLink_Text }}\r\n                      <button\r\n                        class=\"action-button ml-2\"\r\n                        (click)=\"toggleSNPPlanVisibility(true)\"\r\n                        (keyup.enter)=\"toggleSNPPlanVisibility(true)\"\r\n                      >\r\n                        <i class=\"fas fa-times\"></i>\r\n                      </button>\r\n                    </span>\r\n                  </ng-container>\r\n                  <ng-container *ngFor=\"let filter of selectedFilters; trackBy: trackByFilterKey\">\r\n                    <ng-container *ngFor=\"let filterValue of filter?.values; trackBy: trackByFilterValue\">\r\n                      <span class=\"selected-filter-tag\"\r\n                        >{{ filterValue?.label }}\r\n                        <button\r\n                          class=\"action-button ml-2\"\r\n                          (click)=\"clearSelectedFilter(filter.key, filterValue)\"\r\n                          (keyup.enter)=\"clearSelectedFilter(filter.key, filterValue)\"\r\n                        >\r\n                          <i class=\"fa fa-times\"></i>\r\n                          <span class=\"sr-only\">Clear filters</span>\r\n                        </button>\r\n                      </span>\r\n                    </ng-container>\r\n                  </ng-container>\r\n                </div>\r\n              </div>\r\n\r\n              <ng-container *ngIf=\"Spa_Site_SNPTools_Enabled && !Spa_PlanList_FilterModal_Enabled\">\r\n                <vnext-snp-toggle\r\n                  [showLinkText]=\"Spa_PlanList_ShowSNPLink_Text\"\r\n                  [hideLinkText]=\"Spa_PlanList_HideSNPLink_Text\"\r\n                  [activeTabType]=\"activeTabType\"\r\n                  [filteredPlansHasSNPPlans]=\"filteredPlansHasSNPPlans\"\r\n                >\r\n                </vnext-snp-toggle>\r\n              </ng-container>\r\n            </div>\r\n            <ng-container *ngIf=\"activeTabType && showTabFilter\">\r\n              <!-- vvv this is the mobile one -->\r\n              <div *ngIf=\"!Spa_PlanList_FilterModal_Enabled\" class=\"col-12 col-sm-6 d-flex d-md-none align-items-end\">\r\n                <ng-container *ngIf=\"!showEmptyFilterMessage && !showNoPlansFromAnswersMessage; else displayFilterNotExist\">\r\n                  <button\r\n                    #planListFilterButton\r\n                    type=\"button\"\r\n                    [attr.aria-label]=\"Spa_PlanFilters_Modal_Link\"\r\n                    tabindex=\"0\"\r\n                    (click)=\"openMobileFiltersModal()\"\r\n                    class=\"plan-mobile-filter my-auto action-button Spa_Style_Link d-inline p-1\"\r\n                    [title]=\"Spa_PlanFilters_Modal_Link\"\r\n                  >\r\n                    <i class=\"fas fa-filter mr-2\"></i>\r\n                    <span>{{ Spa_PlanFilters_Modal_Link }}</span>\r\n                  </button>\r\n                  <span class=\"badge mb-1 text-center ml-2\">{{ totalAppliedFilters }}</span>\r\n                </ng-container>\r\n                <ng-template #displayFilterNotExist>\r\n                  <div class=\"mb-1\">{{ Spa_PlanFilters_DefaultText }}</div>\r\n                </ng-template>\r\n              </div>\r\n              <!-- ^^^ this is the mobile one -->\r\n            </ng-container>\r\n            <div\r\n              class=\"col-12\"\r\n              [ngClass]=\"{ 'col-md-4 col-sm-12': Spa_PlanList_FilterModal_Enabled, 'col-sm-6 col-md-5': !Spa_PlanList_FilterModal_Enabled }\"\r\n            >\r\n              <ng-container *ngIf=\"activeTabType\">\r\n                <vnext-plan-sort\r\n                  [planSortList]=\"selectedTabSortList\"\r\n                  [selectedPharmacy]=\"selectedPharmacy\"\r\n                  [planSortHeader]=\"Spa_PlanSort_Header\"\r\n                  [tabs]=\"tabs\"\r\n                  [isMailOrderSelected]=\"mailOrder\"\r\n                  (sortClicked)=\"sortClicked()\"\r\n                >\r\n                </vnext-plan-sort>\r\n              </ng-container>\r\n            </div>\r\n            <div *ngIf=\"Spa_PlanList_FilterModal_Enabled\" class=\"col-12 text-right\">\r\n              <vnext-effective-date-display\r\n                [activePlanType]=\"activeTabType\"\r\n                [isReadOnly]=\"true\"\r\n                (dateUpdated)=\"onEffectiveDateModalChange()\"\r\n              ></vnext-effective-date-display>\r\n            </div>\r\n          </div>\r\n          <div *ngIf=\"filterPopupOpen && Spa_PlanList_FilterModal_Enabled\" class=\"filter-modal col-12\">\r\n            <div class=\"mb-2\">\r\n              <vnext-plan-filter-modal-items\r\n                [planSubTypeLabel]=\"Spa_PlanFilters_SubType_Label\"\r\n                [filterDayText]=\"Spa_PlanFilters_DayLabel_Text\"\r\n                [selectFilterDayText]=\"Spa_PlanFilters_SelectDayLabel_Text\"\r\n                [filterCarrierText]=\"Spa_PlanFilters_CarrierLabel_Text\"\r\n                [clearAllText]=\"Spa_Filter_Clear_All\"\r\n                [currentTab]=\"currentTab\"\r\n                [snpBaseTypeLabel]=\"Spa_Filter_SNPBaseTypes_Label\"\r\n                [licensingHeaderText]=\"Spa_Filter_LicensingHeader_Text\"\r\n                [snpEnabled]=\"Spa_Site_SNPTools_Enabled && activeTabType === planTypeAbbreviation.MAPD\"\r\n                [additionalSavingsHeaderText]=\"Spa_Filter_AdditionalSavingsHeader_Text\"\r\n                [insulinSavingsEnabled]=\"Spa_Filter_PlanBenefitsGroup_Enabled && Spa_Filter_InsulinSavings_Enabled\"\r\n                [filterDSNPMedicaidCodesEnabled]=\"Spa_Filter_DSNPMedicaidCodes_Enabled\"\r\n                [costFilterEnabled]=\"isCostFilterEnabled\"\r\n                [medicalDeductibleHeaderText]=\"Spa_Filter_MedicalDeductible_Text\"\r\n                [medicalDeductibleToolTipText]=\"Spa_Filter_MedicalDeductible_ToolTip_Text\"\r\n                [maximumOutOfPocketCostHeaderText]=\"Spa_Filter_MaximumOutOfPocketCost_Text\"\r\n                [maximumOutOfPocketCostToolTipText]=\"Spa_Filter_MaximumOutOfPocketCost_ToolTip_Text\"\r\n                [drugDeductibleHeaderText]=\"Spa_Filter_PharmacyDeductible_Text\"\r\n                [drugDeductibleToolTipText]=\"Spa_Filter_PharmacyDeductible_ToolTip_Text\"\r\n                [premiumHeaderText]=\"Spa_Filter_Premium_Text\"\r\n                [premiumToolTipText]=\"Spa_Filter_Premium_ToolTip_Text\"\r\n                [defaultPlanBenefitFilters]=\"Spa_Site_Default_Plan_Benefit_Filter\"\r\n                [defaultPlanBenefitFiltersEnabled]=\"Spa_Filter_PlanBenefitsGroup_Enabled\"\r\n                [addOnTooltipText]=\"Spa_Filter_AddOn_Coverage_ToolTip_Text\"\r\n                [addOnFilterHeaderText]=\"Spa_PlanList_AddOn_Header_Text\"\r\n                [addOnFilterEnabled]=\"Spa_PlanList_AddOn_Filter_Enabled\"\r\n                [providersNpiHeaderText]=\"Spa_Site_Providers_Header_Text\"\r\n                [providersNpiFilterEnabled]=\"Spa_Npi_Filter_Enabled\"\r\n                [providersEnabled]=\"Spa_Site_Providers_Enabled\"\r\n                [providersNpiTooltipText]=\"Spa_Filter_Providers_ToolTip_Text\"\r\n                [planTypeLabel]=\"Spa_Site_PlanType_Header\"\r\n                [allInNetworkLocationsEnabled]=\"Spa_Site_Provider_ShowAllInNetworkLocations_Enabled\"\r\n                [planFilterModalEnabled]=\"Spa_PlanList_FilterModal_Enabled\"\r\n                [isMedigapEnabled]=\"Spa_PlanList_ShowAllMedigap_Enabled\"\r\n                [medsupPlanSubTypeHeaderText]=\"Spa_PlanList_MedSupPlanSubTypeHeader_Text\"\r\n                [medsupPlanSubTypePlacholderText]=\"Spa_PlanList_MedSupPlanSubTypePlaceholder_Text\"\r\n                [medsupPlanSubTypeUpdateText]=\"Spa_PlanList_MedSupPlanSubTypeUpdate_Text\"\r\n                [starRatingEnabled]=\"\r\n                  Spa_StarRating_Enabled &&\r\n                  (activeTabType === planTypeAbbreviation.MAPD ||\r\n                    activeTabType === planTypeAbbreviation.MA ||\r\n                    activeTabType === planTypeAbbreviation.PDP)\r\n                \"\r\n                [isPlanListPage]=\"true\"\r\n                [snpLabelText]=\"Spa_PlanList_HideSNPLink_Text\"\r\n                [activeTabType]=\"activeTabType\"\r\n                [starRatingLabelText]=\"Spa_StarRating_Label_Text\"\r\n                [starRatingFilterOptions]=\"Spa_StarRating_Filter_Options\"\r\n                [isMobile]=\"mobile\"\r\n                [filteredPlansHasSNPPlans]=\"filteredPlansHasSNPPlans\"\r\n                [snpVisibility]=\"snpVisibility\"\r\n                [planFiltersSortOptions]=\"Spa_PlanFilters_Sort_Options_For_Modal\"\r\n                (planSubTypeChanged)=\"medsupPlanSubTypeChanged($event)\"\r\n                (closeModalEvent)=\"closeFilterModal()\"\r\n                (toggleSNPPlanChangeEvent)=\"toggleSNPPlanChangeEvent($event)\"\r\n              ></vnext-plan-filter-modal-items>\r\n            </div>\r\n            <div class=\"d-flex justify-content-end\">\r\n              <button type=\"button\" class=\"btn Spa_Style_PrimaryButton\" (click)=\"applyFilter()\">\r\n                {{ Spa_PlanFilters_Modal_Apply_Button }}\r\n              </button>\r\n            </div>\r\n          </div>\r\n        </ng-container>\r\n        <ng-container *ngIf=\"filteredPlans?.length; else withoutFilteredPlans\">\r\n          <div class=\"row\" *ngFor=\"let plan of visiblePlans; trackBy: planKey; index as queuePosition\">\r\n            <div class=\"col-12\">\r\n              <vnext-widget-plan-card\r\n                [plan]=\"plan\"\r\n                [activeTabType]=\"activeTabType\"\r\n                [isNotLicensedToSell]=\"isNotLicensedToSell(plan)\"\r\n                [selectedCompareGroup]=\"tabs[activeTabIndex]?.compareGroup[0]\"\r\n                [compareGroups]=\"compareGroups\"\r\n                [planBenefits]=\"tabs[activeTabIndex]?.benefits\"\r\n                (quoteClicked)=\"getPersonalizedQuote(plan)\"\r\n                [displayDrugsCovered]=\"Spa_PlanList_DisplayDrugsCovered\"\r\n                [planPreferences]=\"tabs[activeTabIndex]?.benefitPreferences\"\r\n                [bestMatchIcon]=\"Spa_PlanList_BestMatch_Icon\"\r\n                [bestMatchText]=\"Spa_Site_BestMatch_Plan_Text\"\r\n                [bestMatchTooltip]=\"bestMatchReturnToPreferencesTooltip\"\r\n                [bestMatchPlanId]=\"bestMatchPlanId\"\r\n                [currentPlanText]=\"Spa_Site_Current_Plan_Text\"\r\n                [nextYearPlanText]=\"Spa_Site_Next_Year_Plan_Text\"\r\n                [selectedQuoteGroup]=\"tabs[activeTabIndex]?.quoteGroups[0]\"\r\n                [quoteGroups]=\"quoteGroups\"\r\n                [addToQuoteLimit]=\"Spa_PlanList_AddToQuote_Limit\"\r\n                [noCostAvailableText]=\"Spa_Site_NotApplicable_Text\"\r\n                [isRetentionView]=\"isRetentionView\"\r\n                [isQuotingSite]=\"isQuotingSite\"\r\n                [Spa_Site_ShowRiderIcons]=\"Spa_Site_ShowRiderIcons\"\r\n                [Spa_Site_Dental_Rider_Display_Text]=\"Spa_Site_Dental_Rider_Display_Text\"\r\n                [Spa_Site_Vision_Rider_Display_Text]=\"Spa_Site_Vision_Rider_Display_Text\"\r\n                [Spa_Site_Hearing_Rider_Display_Text]=\"Spa_Site_Hearing_Rider_Display_Text\"\r\n                [Spa_PlanCard_DentalAddOnCoverage_Text]=\"Spa_PlanCard_DentalAddOnCoverage_Text\"\r\n                [Spa_PlanCard_HearingAddOnCoverage_Text]=\"Spa_PlanCard_HearingAddOnCoverage_Text\"\r\n                [Spa_PlanCard_VisionAddOnCoverage_Text]=\"Spa_PlanCard_VisionAddOnCoverage_Text\"\r\n                [Spa_PlanCard_AddOnCoverage_Text]=\"Spa_PlanCard_AddOnCoverage_Text\"\r\n                [Spa_PlanCard_AddToCompare_Text]=\"Spa_PlanCard_AddToCompare_Text\"\r\n                [Spa_Site_ShowRidersOnPlanCards]=\"Spa_Site_ShowRidersOnPlanCards\"\r\n                [Spa_ShoppingCart_Enabled]=\"Spa_ShoppingCart_Enabled\"\r\n                [Spa_PlanCard_PlanDetails_ButtonText]=\"Spa_PlanCard_PlanDetails_ButtonText\"\r\n                [Spa_Site_Show_PlanLogo]=\"Spa_Site_Show_PlanLogo\"\r\n                [Spa_Site_Show_AncillaryPlanLogo]=\"Spa_Site_Show_AncillaryPlanLogo\"\r\n                [Spa_PlanCard_QuoteLinkName_Text]=\"Spa_PlanCard_QuoteLinkName_Text\"\r\n                [Spa_PlanCard_PlanType_Text]=\"Spa_PlanCard_PlanType_Text\"\r\n                [Spa_PlanCard_ShowRidersOnMACards]=\"Spa_PlanCard_ShowRidersOnMACards\"\r\n                [Spa_PlanCard_ShowRidersOnPDPCards]=\"Spa_PlanCard_ShowRidersOnPDPCards\"\r\n                [Spa_PlanCard_ShowRidersOnMAPDCards]=\"Spa_PlanCard_ShowRidersOnMAPDCards\"\r\n                [Spa_PlanCard_ShowRidersOnMEDIGAPCards]=\"Spa_PlanCard_ShowRidersOnMEDIGAPCards\"\r\n                [Spa_PlanCard_ShowRidersOnDentalCards]=\"Spa_PlanCard_ShowRidersOnDentalCards\"\r\n                [Spa_PlanCard_ShowRidersOnVisionCards]=\"Spa_PlanCard_ShowRidersOnVisionCards\"\r\n                [Spa_Site_ShowPremiumAsAnnual]=\"Spa_Site_ShowPremiumAsAnnual\"\r\n                [Spa_PlanCard_AddOnCoverageInCart_Text]=\"Spa_PlanCard_AddOnCoverageInCart_Text\"\r\n                [Spa_PlanCard_AddOnCoverageTooltip_Body]=\"Spa_PlanCard_AddOnCoverageTooltip_Body\"\r\n                [Spa_Site_NotApplicable_Text]=\"Spa_Site_NotApplicable_Text\"\r\n                [Spa_PlanDetails_Non_Covered_Text]=\"Spa_PlanDetails_Non_Covered_Text\"\r\n                [Spa_Site_Pharmacy_Text]=\"Spa_Site_Pharmacy_Text\"\r\n                [Spa_PlanCard_Pharmacy_Covered_Text]=\"Spa_PlanCard_Pharmacy_Covered_Text\"\r\n                [Spa_Site_Prescriptions_Text]=\"Spa_Site_Prescriptions_Text\"\r\n                [Spa_PlanCard_Drug_Covered_Text]=\"Spa_PlanCard_Drug_Covered_Text\"\r\n                [Spa_PlanCard_CompareNow_Text]=\"Spa_PlanCard_CompareNow_Text\"\r\n                [Spa_PlanCard_CompareWarning_Tooltip]=\"Spa_PlanCard_CompareWarning_Tooltip\"\r\n                [Spa_PlanCard_CompareLimit_Desktop]=\"Spa_PlanCard_CompareLimit_Desktop\"\r\n                [Spa_PlanCard_CompareLimit_Mobile]=\"Spa_PlanCard_CompareLimit_Mobile\"\r\n                [Spa_PlanCard_Total_Estimated_Cost_Tooltip]=\"Spa_PlanCard_Total_Estimated_Cost_Tooltip\"\r\n                [Spa_Site_TotalEstimatedCost_Enabled]=\"Spa_Site_TotalEstimatedCost_Enabled\"\r\n                [Spa_PlanCard_TotalEstimatedAnnualCost_Text]=\"Spa_PlanCard_TotalEstimatedAnnualCost_Text\"\r\n                [Spa_PlanCard_TotalEstimatedCost_Text]=\"Spa_PlanCard_TotalEstimatedCost_Text\"\r\n                [Spa_PlanCard_AddToQuote_Text]=\"Spa_PlanCard_AddToQuote_Text\"\r\n                [Spa_PlanCard_RemoveFromQuote_Text]=\"Spa_PlanCard_RemoveFromQuote_Text\"\r\n                [Spa_PlanCard_AddToQuote_Warning_Tooltip]=\"Spa_PlanCard_AddToQuote_Warning_Tooltip\"\r\n                [Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip]=\"Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip\"\r\n                [Spa_PlanList_AddToQuote_Limit]=\"Spa_PlanList_AddToQuote_Limit\"\r\n                [Spa_PlanList_AddToQuote_Limit_Mobile]=\"Spa_PlanList_AddToQuote_Limit_Mobile\"\r\n                [Spa_Site_MedigapPlanType_Enabled]=\"Spa_Site_MedigapPlanType_Enabled\"\r\n                [Spa_Site_AddToCompare_Enabled]=\"Spa_Site_AddToCompare_Enabled\"\r\n                [Spa_Site_PlanViewDetails_Enabled]=\"Spa_Site_PlanViewDetails_Enabled\"\r\n                [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                [Spa_Site_ComboPlanLabel_Text]=\"Spa_Site_ComboPlanLabel_Text\"\r\n                [Spa_Site_ComboPlanTooltip_Text]=\"Spa_Site_ComboPlanTooltip_Text\"\r\n                [Spa_Site_ShowDrugAlternatives_Enabled]=\"Spa_Site_ShowDrugAlternatives_Enabled\"\r\n                [Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled]=\"Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled\"\r\n                [Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text]=\"Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text\"\r\n                [Spa_PlanCard_ShowDrugAlternatives_Nudge_Text]=\"Spa_PlanCard_ShowDrugAlternatives_Nudge_Text\"\r\n                [Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon]=\"Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon\"\r\n                [queuePosition]=\"queuePosition\"\r\n                [plansSelectedToQuote]=\"getPlansSelectedToQuote$() | async\"\r\n                [viewCostTooltipHeaderText]=\"Spa_PlanList_ViewCost_Header_Text\"\r\n                [viewCostTooltipHeaderContent]=\"Spa_PlanList_ViewCost_Header_Content\"\r\n                [inNetworkPreferredText]=\"Spa_PlanList_Pharmacy_InNetwork_Preferred_Pricing_Text\"\r\n                [inNetworkStandardText]=\"Spa_PlanList_Pharmacy_InNetwork_Standard_Pricing_Text\"\r\n                [outOfNetworkText]=\"Spa_PlanList_Pharmacy_OutOfNetwork_Pricing_Text\"\r\n                [selectedPharmacy]=\"selectedPharmacy\"\r\n                [isMailOrderSelected]=\"mailOrder\"\r\n                [mailOrderText]=\"Spa_PlanList_MailOrder_Text\"\r\n                [selectedProviders]=\"selectedProviders\"\r\n                [providerDetails]=\"providerDetails\"\r\n                [providersInNetworkText]=\"Spa_PlanCard_Providers_InNetwork_Text\"\r\n                [pcpInNetworkText]=\"Spa_Site_Pcp_InNetwork_Text\"\r\n                [pcpOutOfNetworkText]=\"Spa_Site_Pcp_OutOfNetwork_Text\"\r\n                [providersNoDataText]=\"Spa_Providers_No_Data_Exist_Text\"\r\n                [isProviderEnabled]=\"Spa_Site_Providers_Enabled\"\r\n                [showStarRating]=\"\r\n                  plan.planTypeAbbreviation !== planTypeAbbreviation.DENTAL &&\r\n                  plan.planTypeAbbreviation !== planTypeAbbreviation.VISION &&\r\n                  plan.planTypeAbbreviation !== planTypeAbbreviation.HC\r\n                \"\r\n                [showPreferenceScore]=\"\r\n                  Spa_Site_Show_Preferences_Score &&\r\n                  plan.planTypeAbbreviation !== planTypeAbbreviation.DENTAL &&\r\n                  plan.planTypeAbbreviation !== planTypeAbbreviation.VISION &&\r\n                  plan.planTypeAbbreviation !== planTypeAbbreviation.HC\r\n                \"\r\n                [showRatingMethod]=\"Spa_Rating_Method_Enabled && plan.planTypeAbbreviation === planTypeAbbreviation.MEDIGAP\"\r\n                [monthlyPremiumText]=\"Spa_Site_HIP_MonthlyPremium_Text\"\r\n                [moreBenefitsInstructionText]=\"Spa_Site_HIP_MoreBenefits_Instruction_Text\"\r\n                [basePlanOptionText]=\"Spa_Site_HIP_BasePlanOption_Text\"\r\n                [CSNPEnabled]=\"Spa_Site_SNPTools_Enabled ? Spa_PlanCard_CSNP_Indicator_Enabled : false\"\r\n                [DSNPEnabled]=\"Spa_Site_SNPTools_Enabled ? Spa_PlanCard_DSNP_Indicator_Enabled : false\"\r\n                [ISNPEnabled]=\"Spa_Site_SNPTools_Enabled ? Spa_PlanCard_ISNP_Indicator_Enabled : false\"\r\n                [CSNPText]=\"Spa_PlanCard_CSNP_Tooltip_Text\"\r\n                [DSNPText]=\"Spa_PlanCard_DSNP_Tooltip_Text\"\r\n                [ISNPText]=\"Spa_PlanCard_ISNP_Tooltip_Text\"\r\n                [SNPText]=\"Spa_PlanCard_SNP_Indicator_Text\"\r\n                [nonLicensedPlanText]=\"planListFacade.getNonLicensedPlanCardBadgeText()\"\r\n                [nonLicensedMessageText]=\"planListFacade.getNonLicensedPlanCardMessageText()\"\r\n                [includeNonLicensedPlans]=\"Spa_PlanList_Include_NonLicensed_Plans\"\r\n                [noProviderNetworkAccessText]=\"Spa_Providers_NoProviderNetworkAccess_Text\"\r\n                [viewDetailsDescriptionText]=\"Spa_Site_ViewDetailsLink_Description_Text\"\r\n                [medSupPaymentMethod]=\"paymentMethod$ | async\"\r\n                [nonMonthlyRateText]=\"Spa_PlanCard_NonMonthlyRateText\"\r\n                [showNonMonthlyRateText]=\"Spa_PlanCard_NonMonthlyRateText_Enabled\"\r\n                [medSupPaymentMethodDisplayText]=\"medSupPaymentMethodDisplayText\"\r\n                [displayOptionLabels]=\"Spa_Retention_ClientDefinedPlanOptions_Enabled\"\r\n                [nonCommissionableText]=\"Spa_PlanDetails_NonCommissionable_Text\"\r\n                [isNonCommissionableFlagCheckEnabled]=\"Spa_PlanDetails_NonCommissionable_FlagCheck_Enabled\"\r\n                [memberHasOptionsDefined]=\"memberHasOptionsDefined\"\r\n                [optionOneText]=\"Spa_Site_Plan_Option_One_Text\"\r\n                [optionTwoText]=\"Spa_Site_Plan_Option_Two_Text\"\r\n                [totalCostEffectiveDate]=\"totalCostEffectiveDate\"\r\n                [medicineCabinet]=\"medicineCabinet\"\r\n                [planCardPreferenceDetailedEnabled]=\"Spa_PlanCard_Preferences_Detailed_Enabled\"\r\n                (quoteGroupChanged)=\"quoteGroupChanged()\"\r\n                [planLogoSize]=\"Spa_Site_PlanLogo_Size\"\r\n                [showAddToCartForAncillaryPlans]=\"Spa_PlanCard_AncillaryAddtoCart_Enabled\"\r\n                [showAncillaryIcons]=\"Spa_PlanCard_ShowAncillaryIcons_Enabled\"\r\n                [loaderIconEnabled]=\"Spa_Site_Loader_Updated_Icon_Enabled\"\r\n                [hideLinkText]=\"Spa_Site_Hide_Text\"\r\n                [viewAllLinkText]=\"Spa_Site_ViewAll_Text\"\r\n                [Spa_PlanCard_SupplementalBenefits_Enabled]=\"Spa_PlanCard_SupplementalBenefits_Enabled\"\r\n                [Spa_PlanCard_SupplementalBenefits_List]=\"Spa_PlanCard_SupplementalBenefits_List\"\r\n                [editLinkText]=\"editLinkText\"\r\n                [providerOneOrMoreOutOfNetworkText]=\"Spa_PlanCard_Providers_OneOrMore_OutOfNetwork_Text\"\r\n                [Spa_RatingMethod_AttainedAge_Tooltip_Text]=\"Spa_RatingMethod_AttainedAge_Tooltip_Text\"\r\n                [Spa_RatingMethod_IssueAge_Tooltip_Text]=\"Spa_RatingMethod_IssueAge_Tooltip_Text\"\r\n                [Spa_RatingMethod_CommunityRated_Tooltip_Text]=\"Spa_RatingMethod_CommunityRated_Tooltip_Text\"\r\n                [providerInNetworkOnOtherLocationsTooltipText]=\"Spa_Providers_InNetwork_OnOtherLocations_Tooltip_Text\"\r\n                [providerShowPartialIndicatorEnabled]=\"Spa_Provider_ShowPartialIndicator_Enabled\"\r\n                [planFeesEnabled]=\"Spa_Site_PlanFees_Enabled\"\r\n                [planFeesTooltipText]=\"Spa_PlanFees_Tooltip_Text\"\r\n                [planFeesIncludedInPremiumTooltipText]=\"Spa_PlanFees_IncludedInPremium_Tooltip_Text\"\r\n                [planFeesNotIncludedInPremiumTooltipText]=\"Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text\"\r\n                [showAvailableRateFactorsEnabled]=\"Spa_PlanCard_ShowAvailableRateFactors_Enabled\"\r\n                [personalizedQuoteLabelText]=\"Spa_PlanCard_PersonalizedQuoteLabel_Text\"\r\n                [availableRateFactorsData]=\"Spa_PlanCard_AvailableRateFactors_Data\"\r\n                [snpPremiumRangeEnabled]=\"Spa_Display_SNP_PremiumRange_Enabled\"\r\n                [snpRangeLinkText]=\"Spa_SNPRange_Link_Text\"\r\n                [showPlanId]=\"Spa_PlanCard_Show_PlanId_Enabled\"\r\n                [planIdText]=\"Spa_PlanCard_PlanId_Text\"\r\n                [enableDSNPCodes]=\"Spa_PlanCard_DSNPCodeDisplay_Enabled\"\r\n                [availableText]=\"Spa_Site_Available_Text\"\r\n                [unavailableText]=\"Spa_Site_NotAvailable_Text\"\r\n                [viewProvidersButtonText]=\"Spa_PlanCard_Providers_ViewButton_Text\"\r\n                [viewPrescriptionsButtonText]=\"Spa_PlanCard_Prescriptions_ViewButton_Text\"\r\n                [supplementalBenefitsHighlightText]=\"Spa_PlanCard_SupplementalBenefitsHighlight_Text\"\r\n                [preferencesText]=\"Spa_Plan_Details_Preferences_Text\"\r\n                [viewMoreDetailsText]=\"Spa_PlanCard_ViewMoreDetails_ButtonText\"\r\n                [hideDetailsText]=\"Spa_PlanCard_HideDetails_ButtonText\"\r\n                [newPlanCardDesignEnabled]=\"Spa_PlanCard_NewDesign_Enabled\"\r\n                [viewAllPlanDetailsText]=\"Spa_PlanCard_ViewAllPlanDetails_ButtonText\"\r\n                [shareThisPlanText]=\"Spa_PlanCard_ShareThisPlan_ButtonText\"\r\n                [viewCostDetailsText]=\"Spa_PlanCard_ViewCostDetails_ButtonText\"\r\n                [closeText]=\"Spa_Site_Close\"\r\n                [planBenefitHighlightItems]=\"Spa_PlanCard_PlanBenefitHighlight_Items\"\r\n                [planBenefitHighlightsHeaderText]=\"Spa_PlanCard_PlanBenefitHighlights_Text\"\r\n                [showRiderDetails]=\"Spa_Site_RiderDetails_Show\"\r\n                [showRiderDetailsText]=\"Spa_Plan_Details_ViewRiderDetails_Text\"\r\n                [hideRiderDetailsText]=\"Spa_Plan_Details_HideRiderDetails_Text\"\r\n                [riderIsIncludedText]=\"Spa_ShoppingCart_IncludedRider_Text\"\r\n                [waiverStateRiderTooltips]=\"Spa_Plan_Details_WaiverStateRider_Tooltips\"\r\n                [costMA]=\"Spa_Plandetails_Costs_MA\"\r\n                [costMAPD]=\"Spa_Plandetails_Costs_MAPD\"\r\n                [costPDP]=\"Spa_Plandetails_Costs_PDP\"\r\n                [costMEDIGAP]=\"Spa_Plandetails_Costs_MEDIGAP\"\r\n                [costDENTAL]=\"Spa_PlanDetails_Costs_DENTAL\"\r\n                [costVISION]=\"Spa_PlanDetails_Costs_VISION\"\r\n                [isVbcAgreementEnabled]=\"Spa_Site_ValueBasedCare_Agreement_Enabled\"\r\n                [vbcAgreementLabel]=\"Spa_Site_ValueBasedCare_Agreement_Label\"\r\n                [vbcAgreementTooltip]=\"Spa_Site_ValueBasedCare_Agreement_Tooltip\"\r\n              ></vnext-widget-plan-card>\r\n            </div>\r\n          </div>\r\n        </ng-container>\r\n\r\n        <ng-template #withoutFilteredPlans>\r\n          <ng-container *ngIf=\"isMedicareTab && hasPlanYearPermissionError; else validPlanYear\">\r\n            <div class=\"col-md-12 no-plan-error\">\r\n              <div class=\"Spa_Style_Large_Font font-weight-bold\">{{ tabs[activeTabIndex]?.tabError.heading }}</div>\r\n              <div\r\n                class=\"Spa_Style_H5\"\r\n                [innerHTML]=\"Spa_PlanList_Tab_Text_NoPlans_MedicareforDualPlanYear | safe : 'html'\"\r\n                navigationAdapter\r\n              ></div>\r\n            </div>\r\n          </ng-container>\r\n          <ng-template #validPlanYear>\r\n            <ng-container *ngIf=\"showNoPlansFromAnswersMessage; else otherNoPlans\">\r\n              <ng-container>\r\n                <div class=\"col-md-12 no-plan-error\">\r\n                  <div class=\"col-12\">\r\n                    <h3 class=\"Spa_Style_Large_Font Spa_Style_H3\">{{ Spa_PlanList_Tab_Header_NoPlans }}</h3>\r\n                    <ng-container [ngSwitch]=\"activeTabType\">\r\n                      <vnext-inner-text-link\r\n                        *ngSwitchCase=\"planTypeAbbreviation.MEDIGAP\"\r\n                        [outerText]=\"Spa_PlanList_MedSupNoResultsError_Text\"\r\n                        [innerText]=\"Spa_PlanList_MedSupNoResultsErrorClickable_Text\"\r\n                        [customTextClass]=\"'Spa_Style_Paragraph'\"\r\n                        (innerTextClicked)=\"openAncillaryForm(activeTabType)\"\r\n                      >\r\n                      </vnext-inner-text-link>\r\n                      <vnext-inner-text-link\r\n                        *ngSwitchCase=\"planTypeAbbreviation.DENTAL\"\r\n                        [outerText]=\"Spa_PlanList_DentalNoResultsError_Text\"\r\n                        [innerText]=\"Spa_PlanList_MedSupNoResultsErrorClickable_Text\"\r\n                        [customTextClass]=\"'Spa_Style_Paragraph'\"\r\n                        (innerTextClicked)=\"openAncillaryForm(activeTabType)\"\r\n                      >\r\n                      </vnext-inner-text-link>\r\n                      <vnext-inner-text-link\r\n                        *ngSwitchCase=\"planTypeAbbreviation.VISION\"\r\n                        [outerText]=\"Spa_PlanList_VisionNoResultsError_Text\"\r\n                        [innerText]=\"Spa_PlanList_MedSupNoResultsErrorClickable_Text\"\r\n                        [customTextClass]=\"'Spa_Style_Paragraph'\"\r\n                        (innerTextClicked)=\"openAncillaryForm(activeTabType)\"\r\n                      >\r\n                      </vnext-inner-text-link>\r\n                      <vnext-inner-text-link\r\n                        *ngSwitchCase=\"planTypeAbbreviation.HC\"\r\n                        [outerText]=\"Spa_PlanList_HospitalIndemnityNoResultsError_Text\"\r\n                        [innerText]=\"Spa_PlanList_MedSupNoResultsErrorClickable_Text\"\r\n                        [customTextClass]=\"'Spa_Style_Paragraph'\"\r\n                        (innerTextClicked)=\"openAncillaryForm(activeTabType)\"\r\n                      >\r\n                      </vnext-inner-text-link>\r\n                    </ng-container>\r\n                  </div>\r\n                </div>\r\n              </ng-container>\r\n              <div class=\"mt-4\" *ngIf=\"showTurning65AtEffectiveDateMessage\">\r\n                <span [innerHTML]=\"planFacade.getNotTurning65AsOfEffectiveDateMonthText() | safe : 'html'\"></span>\r\n              </div>\r\n            </ng-container>\r\n          </ng-template>\r\n          <ng-template #otherNoPlans>\r\n            <ng-container *ngIf=\"totalAppliedFilters > 1; else showNoPlansAvailable\">\r\n              <div class=\"col-md-12 no-plan-error\">\r\n                <h3 class=\"mt-2 Spa_Style_H3 text-center\">{{ tabs[activeTabIndex]?.tabError.heading }}</h3>\r\n                <p class=\"text-center Spa_Style_Paragraph mb-3\">{{ Spa_PlanFilters_No_Plans_Available_Message }}</p>\r\n              </div>\r\n            </ng-container>\r\n            <ng-template #showNoPlansAvailable>\r\n              <div class=\"col-md-12 no-plan-error\">\r\n                <div class=\"col-12\">\r\n                  <h3 class=\"Spa_Style_Large_Font Spa_Style_H3\">{{ tabs[activeTabIndex]?.tabError.heading }}</h3>\r\n                  <p class=\"Spa_Style_Paragraph\" [innerHTML]=\"tabs[activeTabIndex]?.tabError.body | safe : 'html'\" navigationAdapter></p>\r\n                </div>\r\n\r\n                <ng-container *ngIf=\"Spa_Site_SNPTools_Enabled && !currentTabPlanCount\">\r\n                  <vnext-snp-toggle\r\n                    [showLinkText]=\"Spa_PlanList_ShowSNPLink_Text\"\r\n                    [hideLinkText]=\"Spa_PlanList_HideSNPLink_Text\"\r\n                    [activeTabType]=\"activeTabType\"\r\n                    [filteredPlansHasSNPPlans]=\"filteredPlansHasSNPPlans\"\r\n                  >\r\n                  </vnext-snp-toggle>\r\n                </ng-container>\r\n              </div>\r\n            </ng-template>\r\n          </ng-template>\r\n        </ng-template>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<ng-template #nonLicensed>\r\n  <div class=\"container\">\r\n    <vnext-not-licensed-plan-list\r\n      vnextGoogleTagManager\r\n      [tagsToUpdate]=\"nonLicensedGoogleDataTags\"\r\n      [headerText]=\"planListFacade.getNonLicensedHeaderText()\"\r\n      [informationalText]=\"planListFacade.getNonLicensedInformationText()\"\r\n    ></vnext-not-licensed-plan-list>\r\n  </div>\r\n</ng-template>\r\n", styles: [".plan-list-title{margin-top:60px;margin-bottom:10px}.zip-code-link{text-decoration:underline;position:relative;cursor:pointer}.fa-edit{font-size:var(--Spa_Style_Regular_Font);position:relative;top:-6px}.zip-code-link .fa-edit{font-size:.5em}.plans-tab.tabs{padding:15px 10px 0}.no-plan-error{white-space:pre-line;text-align:center;margin-top:80px;line-height:28px}.filter-tab{margin-right:6px;margin-left:6px;max-width:22%;min-width:15%;min-height:100%;margin-bottom:-1px;line-height:1.2}.filter-tab-small{max-width:18%;min-width:10%}.filter-tab-small-2{max-width:15%;min-width:10%}.filter-tab-small-3{max-width:12%;min-width:8%}.filter-tab-small-wide{max-width:22%}.filter-modal{position:absolute;padding:0 20px 20px;border-radius:8px;font-family:Arial,sans-serif;z-index:1;top:70px;background:#fff!important;width:98%;border:1px solid var(--static-Spa_Style_Accent1)}.selected-filter-tag{padding:2px 10px;background-color:#dfdfdf;color:#1f1f1f;margin:5px;border-radius:10px;display:inline-block}@media (min-width: 576px) and (max-width: 767.98px){.filter-tab-small-wide{max-width:30%}}@media (min-width: 992px){.filter-tab-small-3{max-width:14%}.filter-tab-small-wide{max-width:19%}}select{width:100%}.mobile-tab{max-width:20%;min-width:18%}a.plan-mobile-filter{font-size:var(--Spa_Style_Regular_Font);font-family:montserratregular;color:var(--static-Spa_Style_Primary_Link)}.plan-mobile-filter i{font-size:var(--Spa_Style_Small_Font)}.badge{font-size:var(--Spa_Style_Small_Fonter);background:var(--static-Spa_Style_Accent4);color:var(--static-Spa_Style_Primary);border-radius:10px}.educational-text{font-family:montserrat_light;font-size:var(--Spa_Style_Regular_Font);line-height:22px;color:var(--static-Spa_Style_Black)}.medigap-info{background-color:var(--static-Spa_Style_Warn_Lighter)}.plan-list-settings{display:flex;align-items:flex-end;justify-content:space-between;margin-bottom:18px}vnext-med-sup-form{width:97%}.aside-second{padding-top:40px}.plan-page-title-tabs-container{border-bottom:1px solid var(--static-Spa_Style_Accent1);margin:0 0 30px}@media (max-width: 575.98px){.educational-text{font-size:var(--Spa_Style_Small_Font)}.filter-tab,.filter-tab-small-wide{max-width:40%}.aside-second{padding-top:0}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: PlanFacade }, { type: i0.Injector }, { type: i1$1.NgbModal }, { type: i1.PlansService }, { type: i1.MedSupService }, { type: MedSupFacade }, { type: i1.WeglotService }, { type: i1.PlanCompareService }, { type: PlanListFacadeService }, { type: PlanListContextService }, { type: i1.PreferencesService }, { type: i1.ProviderService }, { type: ProviderFacade }, { type: i1.MemberSessionService }, { type: i1.QuoteService }, { type: i1.SiteService }, { type: AnalyticsService }, { type: i2$1.Router }, { type: i1.GuidedHelpService }, { type: i1.MillimanService }, { type: i1.SpinnerService }, { type: i1.LiveEditStateContext }, { type: PharmacyFacade }, { type: i2.Store }, { type: i1.MemberSessionHttpService }, { type: i1.ConfigResourceService }, { type: i1.FilterService }, { type: i1.SNPService }, { type: i1.SSOPopulatedFieldService }, { type: i1.DrugsService }, { type: i1.SortService }, { type: PlanFilterItemsFacade }, { type: HospitalIndemnityFormFacade }, { type: PlanCompareFacade }, { type: i1.NavigationService }, { type: i1.PharmacyService }, { type: RetentionFacade }, { type: i1.DemographicService }, { type: i1.PlanYearResourceService }, { type: i1.PlanYearService }, { type: i1.CarriersService }, { type: i1.ZipCodeService }]; }, { planListTabElement: [{
            type: ViewChildren,
            args: ['planListTab', { read: ElementRef }]
        }], planListFilterButtonElement: [{
            type: ViewChild,
            args: ['planListFilterButton']
        }], tooltip: [{
            type: ViewChild,
            args: ['tooltip']
        }], planFilterModalItems: [{
            type: ViewChild,
            args: [PlanFilterModalItemsComponent]
        }], selectedPharmacy$: [], Spa_PlanDetails_NonCommissionable_Text: [], Spa_Site_Pharmacy_Filter_Enabled: [], Spa_PlanDetails_NonCommissionable_FlagCheck_Enabled: [], Spa_PlanList_AddNonLicensedPlans_Text: [], Spa_PlanList_BestCoverage_Text: [], Spa_Site_BackToSummary_Link_Text: [], Spa_Site_Pharmacy_In_Network_Filter_Enabled: [], Spa_Site_Pharmacy_Other_Filter_Enabled: [], Spa_Filter_Default_Filter_Text: [], Spa_Pharmacy_Filter_Open24hrs_Text: [], Spa_Pharmacy_Filter_Eprescribing_Text: [], Spa_Pharmacy_Filter_HandicapAccess_Text: [], Spa_Pharmacy_Filter_DurableEquipment_Text: [], Spa_Pharmacy_Filter_MailOrder_Text: [], Spa_Pharmacy_Filters: [], Spa_Site_Plans_Text: [], Spa_Site_Plan_Text: [], Spa_Filter_Header_Text: [], Spa_Filter_Clear_All: [], Spa_PlanFilters_DefaultText: [], Spa_PlanFilters_DayLabel_Text: [], Spa_PlanFilters_SelectDayLabel_Text: [], Spa_PlanFilters_CarrierLabel_Text: [], Spa_PlanFilters_SubType_Label: [], Spa_Plan_Tab_Educational_Text_Show: [], Spa_Site_Tooltip_Text: [], Spa_Site_ComboPlanLabel_Text: [], Spa_Site_ComboPlanTooltip_Text: [], Spa_PlanFilters_Modal_Link: [], Spa_PlanFilters_Modal_Cancel_Button: [], Spa_PlanFilters_Modal_Apply_Button: [], Spa_PlanFilters_No_Plans_Available_Message: [], Spa_StarRating_Enabled: [], Spa_PlanList_Sort_By_PreferenceScore_Enabled: [], Spa_PlanList_Effective_Date_Text: [], Spa_Rate_Factor_Disclaimer_Text: [], Spa_Rate_Factor_Disclaimer_Enabled: [], Spa_PlanSort_Header: [], Spa_Site_PlanLogo_Size: [], AppID: [], Spa_PlanList_Sort_Options_MA: [], Spa_PlanList_Sort_Options_MAPD: [], Spa_PlanList_Sort_Options_PDP: [], Spa_PlanList_Sort_Options_MEDIGAP: [], Spa_PlanList_Sort_Options_DENTAL: [], Spa_PlanList_Sort_Options_VISION: [], Spa_PlanList_Sort_Options_HIP: [], Spa_Site_Health_Text: [], Spa_PlanCard_Benefit_MA: [], Spa_PlanCard_Benefit_MAPD: [], Spa_PlanCard_Benefit_PDP: [], Spa_PlanCard_Benefit_DENTAL: [], Spa_PlanCard_Preferences_MA: [], Spa_PlanCard_Preferences_MAPD: [], Spa_PlanCard_Preferences_PDP: [], Spa_Site_Multi_Pharmacy_Enabled: [], Spa_PlanList_Tab_Text_NoPlans_MA: [], Spa_PlanList_Tab_Text_NoPlans_MAPD: [], Spa_PlanList_Tab_Text_NoPlans_PDP: [], Spa_PlanList_Tab_Text_NoPlans_MEDIGAP: [], Spa_PlanList_Tab_Text_NoPlans_DENTAL: [], Spa_PlanList_Tab_Text_NoPlans_MedicareforDualPlanYear: [], Spa_PlanList_ActiveTab_BasedOn_PreferenceScore_Enabled: [], Spa_PlanList_Filters_Expanded: [], Spa_PlanList_RateFactorsPreviousLink_Enabled: [], Spa_PlanList_PlansAvailableSingular_Text: [], Spa_PlanList_PlansAvailablePlural_Text: [], Spa_DualPlanYear_PlanList_Text_Enabled: [], Spa_DualPlanYear_Enabled: [], Spa_DualPlanYear_Update_Enabled: [], Spa_DualPlanYear_PlanList_Text: [], Spa_Site_PageSubHeader_Text: [], Spa_MedSup_PageSubHeader_Text: [], Spa_PlanList_Tab_Educational_Text_MAPD: [], Spa_PlanList_Tab_Educational_Text_MA: [], Spa_PlanList_Tab_Educational_Text_PDP: [], Spa_PlanList_Tab_Educational_Text_DENTAL: [], Spa_PlanList_Tab_Educational_Text_VISION: [], Spa_Site_CostBasedOn_Text: [], Spa_PlanList_Tab_Educational_Text_HIP: [], Spa_PlanList_Tab_Educational_Text_MEDIGAP: [], Spa_PlanList_ViewCost_Header_Text: [], Spa_PlanList_ViewCost_Header_Content: [], Spa_PlanCard_AddToCompare_Text: [], Spa_PlanList_PlansAvailableText_Enabled: [], Spa_PlanList_EditZipCode_Label: [], Spa_PlanList_Tabs_Data: [], Spa_Site_Hide_EmptyPlanTabs: [], Spa_PlanDetails_HIP_Call_Out_Available_Plan_Types: [], Spa_Site_Previous: [], Spa_PlanList_MedSupFormInchesLabel_Text: [], Spa_PlanList_MedSupFormFeetLabel_Text: [], Spa_PlanList_MedSupFormPoundsLabel_Text: [], Spa_PlanList_MedSupFormMonthLabel_Text: [], Spa_PlanList_MedSupFormYearLabel_Text: [], Spa_PlanList_MedSupFormDropdownDefault_Text: [], Spa_Site_ContinueToPlanList: [], Spa_PlanList_MedSupFormTitle_Text: [], Spa_PlanList_DentalFormTitle_Text: [], Spa_PlanList_VisionFormTitle_Text: [], Spa_Dental_PageSubHeader_Text: [], Spa_Vision_PageSubHeader_Text: [], Spa_PlanList_HIPFormPrompt_Text: [], Spa_PlanList_HIP_PageTitle_Text: [], Spa_PlanList_Tab_Header_NoPlans: [], Spa_PlanList_DentalNoResultsError_Text: [], Spa_PlanList_VisionNoResultsError_Text: [], Spa_PlanList_HospitalIndemnityNoResultsError_Text: [], Spa_PlanList_MedSupNoResultsError_Text: [], Spa_PlanList_MedSupNoResultsErrorClickable_Text: [], Spa_PlanList_MedSupFormPrompt_Text: [], Spa_PlanList_DentalFormPrompt_Text: [], Spa_PlanList_VisionFormPrompt_Text: [], Spa_PlanList_MedSupQuestion_Data: [], Spa_PlanList_DentalVisionQuestion_Data: [], Spa_PlanList_GuaranteedIssue_Header: [], Spa_PlanList_GuaranteedIssue_Text: [], Spa_PlanList_GuaranteedIssue_Tooltip: [], Spa_Site_SiteType: [], Spa_Site_ForceMedSupFormBeforePlansList: [], Spa_Site_ForceDentalVisionFormBeforePlansList: [], Spa_PlanList_DentalVisionWarningBanner_Text: [], Spa_PlanList_DentalVisionWarningBannerClickable_Text: [], Spa_PlanList_DentalVisionEditAnswersBanner_Text: [], Spa_PlanList_DentalVisionEditAnswersBannerClickable_Text: [], Spa_PlanList_MedSupWarningBanner_Text: [], Spa_PlanList_MedSupWarningBannerClickable_Text: [], Spa_PlanList_MedSupEditAnswersBanner_Text: [], Spa_PlanList_MedSupEditAnswersBannerClickable_Text: [], Spa_MedSup_RestrictMedSupPlansByAge_InfoText: [], Spa_MedSup_RestrictMedSupPlansByAge_InfoLink: [], Spa_Site_EPrescribing_Alt_Text: [], Spa_Site_Pharmacy_Added_Text: [], Spa_Site_Pharmacy_Add_Text: [], Spa_GuidedHelp_Preference_Text: [], Spa_GuidedHelp_PreferenceInfo_Text: [], Spa_Site_AddPreferences: [], Spa_Site_GetStarted_Text: [], Spa_Site_Prescriptions_Text: [], Spa_Site_Pharmacy_Text: [], Spa_Site_Eligibility_Text: [], Spa_Site_OtherPreferences_Text: [], Spa_GuidedHelp_ReviewOtherPreferences_Text: [], Spa_GuidedHelp_Enabled: [], Spa_Site_Hide_Text: [], Spa_Site_ViewAll_Text: [], Spa_Site_TotalEstimatedCost_Enabled: [], Spa_PlanList_BestMatch_Icon: [], Spa_Site_BestMatch_Plan_Text: [], Spa_PlanList_BestMatchPlan_Tooltip: [], Spa_PlanList_BestCoverageType_Enabled: [], Spa_PlanList_BestCoverageType_Text: [], Spa_PlanList_BestMatchPlan_Enabled: [], Spa_PlanList_BestCoverageType_Tooltip: [], Spa_Site_ReturnToPreferences_Text: [], Spa_Site_Current_Plan_Text: [], Spa_Site_Next_Year_Plan_Text: [], Spa_Site_PlanNotAvailableForNextYear_Text: [], Spa_Site_Keep_This_Plan_Button_Text: [], Spa_Site_AddToQuote_Enabled: [], Spa_Site_SendQuote_Button_Text: [], Spa_PlanList_AddToQuote_Limit: [], Spa_PlanList_AddToQuote_Limit_Mobile: [], Spa_PlanList_AddToQuote_Hint_Text: [], Spa_Site_PlanList_HIP_Medicare_Quote_Enabled: [], Spa_PlanList_PlanType_Instructional_Text: [], Spa_Site_HIP_MonthlyPremium_Text: [], Spa_Site_HIP_MoreBenefits_Instruction_Text: [], Spa_Site_HIP_BasePlanOption_Text: [], Spa_Site_HIP_Description: [], Spa_Site_HIP_Add_Medicare_Advantage_Plan_Text: [], Spa_PlanList_SelectPlan_Button_Text: [], Spa_PlanList_PleaseSelect_Error_Text: [], Spa_Site_PlanType_Header: [], Spa_PlanList_SelectPlanType_Hint_Text: [], Spa_Site_Carrier_Header: [], Spa_PlanList_SelectPlan_Carriers_Hint_Text: [], Spa_PlanList_SelectPlan_Text: [], Spa_PlanList_SelectPlan_Hint_Text: [], Spa_PlanList_NoPlansAvailable_Text: [], Spa_PlanList_NoPlansAvailable_Hint_Text: [], Spa_PlanList_RequiredFields_Hint_Text: [], Spa_PlanList_ViewQuote_Text: [], Spa_Site_IsDeepLinking_Enabled: [], Spa_Site_ErrorKeyword_Text: [], Spa_PlanList_EditZipCode_ButtonLabel: [], Spa_PlanList_DisplayDrugsCovered: [], Spa_Site_ShowRiderIcons: [], Spa_Site_ShowRidersOnPlanCards: [], Spa_Site_Dental_Rider_Display_Text: [], Spa_Site_Vision_Rider_Display_Text: [], Spa_Site_Hearing_Rider_Display_Text: [], Spa_PlanCard_DentalAddOnCoverage_Text: [], Spa_PlanCard_HearingAddOnCoverage_Text: [], Spa_PlanCard_VisionAddOnCoverage_Text: [], Spa_PlanCard_AddOnCoverage_Text: [], Spa_PlanCard_AddOnCoverageInCart_Text: [], Spa_PlanCard_ShowRidersOnMACards: [], Spa_PlanCard_ShowRidersOnPDPCards: [], Spa_PlanCard_ShowRidersOnMAPDCards: [], Spa_PlanCard_ShowRidersOnMEDIGAPCards: [], Spa_PlanCard_ShowRidersOnDentalCards: [], Spa_PlanCard_ShowRidersOnVisionCards: [], Spa_ShoppingCart_Enabled: [], Spa_PlanCard_PlanDetails_ButtonText: [], Spa_Site_Show_PlanLogo: [], Spa_PlanCard_QuoteLinkName_Text: [], Spa_PlanCard_PlanType_Text: [], Spa_Site_ShowPremiumAsAnnual: [], Spa_PlanCard_AddOnCoverageTooltip_Body: [], Spa_Site_NotApplicable_Text: [], Spa_PlanDetails_Non_Covered_Text: [], Spa_PlanCard_Pharmacy_Covered_Text: [], Spa_PlanCard_Drug_Covered_Text: [], Spa_PlanCard_CompareNow_Text: [], Spa_PlanCard_CompareWarning_Tooltip: [], Spa_PlanCard_CompareLimit_Desktop: [], Spa_PlanCard_CompareLimit_Mobile: [], Spa_PlanCard_Total_Estimated_Cost_Tooltip: [], Spa_PlanCard_TotalEstimatedAnnualCost_Text: [], Spa_PlanCard_TotalEstimatedCost_Text: [], Spa_PlanCard_AddToQuote_Text: [], Spa_PlanCard_RemoveFromQuote_Text: [], Spa_PlanCard_AddToQuote_Warning_Tooltip: [], Spa_PlanCard_HIP_AddToQuote_Warning_Tooltip: [], Spa_Site_MedigapPlanType_Enabled: [], Spa_Site_AddToCompare_Enabled: [], Spa_Site_PlanViewDetails_Enabled: [], Spa_ProfileNavBar_ShowPlanList_Flag: [], Spa_Filter_LicensingHeader_Text: [], Spa_Filter_SellablePlansOnlyCheckbox_Label: [], Spa_Filter_SNPBaseTypes_Label: [], Spa_Site_MoreOptions_Text: [], Spa_Site_EnrollmentErrorNotice_Title: [], Spa_PlanList_Pharmacy_InNetwork_Preferred_Pricing_Text: [], Spa_PlanList_Pharmacy_InNetwork_Standard_Pricing_Text: [], Spa_PlanList_Pharmacy_OutOfNetwork_Pricing_Text: [], Spa_Site_PrimaryPharmacy_Indicator_Text: [], Spa_Site_Providers_Text: [], Spa_Site_Mail_Order_Pharmacy_Enabled: [], Spa_PlanList_MailOrder_Text: [], Spa_Site_Providers_Header_Text: [], Spa_Site_Pcp_Text: [], Spa_PlanCard_Providers_InNetwork_Text: [], Spa_Site_Pcp_InNetwork_Text: [], Spa_Site_Pcp_OutOfNetwork_Text: [], Spa_Providers_No_Data_Exist_Text: [], Spa_Providers_NoProviderNetworkAccess_Text: [], Spa_Site_Providers_Enabled: [], Spa_Npi_Filter_Enabled: [], Spa_Site_Show_Preferences_Score: [], Spa_PlanList_ShowSNPLink_Text: [], Spa_PlanList_HideSNPLink_Text: [], Spa_Site_ShowSNPPlansDefault_Flag: [], Spa_PlanCard_CSNP_Indicator_Enabled: [], Spa_PlanCard_DSNP_Indicator_Enabled: [], Spa_PlanCard_ISNP_Indicator_Enabled: [], Spa_Site_ElectronicPrescription_ToolTipBody: [], Spa_Pharmacy_Added_Label: [], Spa_AddPharmacy_YourPharmacyText: [], Spa_Site_ElectronicPrescription_ToolTipHeader: [], Spa_PlanCard_CSNP_Tooltip_Text: [], Spa_PlanCard_DSNP_Tooltip_Text: [], Spa_PlanCard_ISNP_Tooltip_Text: [], Spa_PlanCard_SNP_Indicator_Text: [], Spa_PlanList_NotLicensed_Enabled: [], Spa_Site_SNPTools_Enabled: [], Spa_MedSupForm_DateOfBirthTooltip_Text: [], Spa_MedSupForm_EffectiveDateTooltip_Text: [], Spa_MedSupForm_GenderTooltip_Text: [], Spa_MedSupForm_TobaccoTooltip_Text: [], Spa_MedSupForm_HeightTooltip_Text: [], Spa_MedSupForm_WeightTooltip_Text: [], Spa_MedSupForm_PaymentMethodTooltip_Text: [], Spa_MedSupForm_HouseholdTooltip_Text: [], Spa_MedSupForm_PartAEffectiveDateTooltip_Text: [], Spa_MedSupForm_PartBEffectiveDateTooltip_Text: [], Spa_Site_CSNP_Label: [], Spa_Site_DSNP_Label: [], Spa_Site_ISNP_Label: [], Spa_Site_ChronicDependence_SNPTooltip_Text: [], Spa_Site_AutoImmune_SNPTooltip_Text: [], Spa_Site_Cancer_SNPTooltip_Text: [], Spa_Site_Cardiovascular_SNPTooltip_Text: [], Spa_Site_ChronicHeartFailure_SNPTooltip_Text: [], Spa_Site_Dementia_SNPTooltip_Text: [], Spa_Site_Diabetes_SNPTooltip_Text: [], Spa_Site_EndStageLiver_SNPTooltip_Text: [], Spa_Site_EndStageRenal_SNPTooltip_Text: [], Spa_Site_Hematologic_SNPTooltip_Text: [], Spa_Site_HIVAIDS_SNPTooltip_Text: [], Spa_Site_ChronicLung_SNPTooltip_Text: [], Spa_Site_ChronicMentalHealth_SNPTooltip_Text: [], Spa_Site_Neurologic_SNPTooltip_Text: [], Spa_Site_Stroke_SNPTooltip_Text: [], Spa_Site_NursingHome_SNPTooltip_Text: [], Spa_Site_RequiresNursingCare_SNPTooltip_Text: [], Spa_Site_ChronicDependence_SNPLabel_Text: [], Spa_Site_AutoImmune_SNPLabel_Text: [], Spa_Site_Cancer_SNPLabel_Text: [], Spa_Site_Cardiovascular_SNPLabel_Text: [], Spa_Site_ChronicHeartFailure_SNPLabel_Text: [], Spa_Site_Dementia_SNPLabel_Text: [], Spa_Site_Diabetes_SNPLabel_Text: [], Spa_Site_EndStageLiver_SNPLabel_Text: [], Spa_Site_EndStageRenal_SNPLabel_Text: [], Spa_Site_Hematologic_SNPLabel_Text: [], Spa_Site_HIVAIDS_SNPLabel_Text: [], Spa_Site_ChronicLung_SNPLabel_Text: [], Spa_Site_ChronicMentalHealth_SNPLabel_Text: [], Spa_Site_Neurologic_SNPLabel_Text: [], Spa_Site_Stroke_SNPLabel_Text: [], Spa_Site_NursingHome_SNPLabel_Text: [], Spa_Site_RequiresNursingCare_SNPLabel_Text: [], Spa_PlanCard_NonMonthlyRateText: [], Spa_PlanCard_NonMonthlyRateText_Enabled: [], Spa_MedSupForm_PaymentMethodBiMonthly_Text: [], Spa_MedSupForm_PaymentMethodMonthly_Text: [], Spa_MedSupForm_PaymentMethodQuarterly_Text: [], Spa_MedSupForm_PaymentMethodSemiAnnually_Text: [], Spa_MedSupForm_PaymentMethodAnnually_Text: [], Spa_MedSupForm_PaymentMethodLumpSum_Text: [], Spa_CrossSell_Confirm_Link_Text: [], Spa_CrossSell_Header_Text: [], Spa_Site_Digital_Pharmacy_Enabled: [], Spa_Pharmacy_Retail_Tab_Text: [], Spa_Pharmacy_Digital_Tab_Text: [], Spa_Pharmacy_Digital_Tab_Intro_Text: [], Spa_CrossSell_Medsup_Marketing_Text: [], Spa_Pharmacy_In_Network_Filters: [], Spa_CrossSell_Medsup_Prompt_Text: [], Spa_CrossSell_PDP_Marketing_Text: [], Spa_CrossSell_PDP_Prompt_Text: [], Spa_CrossSell_Success_Message_Text: [], Spa_CrossSell_Enabled: [], Spa_ZipCodeInput_CountyLabel_Enabled: [], Spa_Filter_AdditionalSavingsHeader_Text: [], Spa_Filter_InsulinSavings_Enabled: [], Spa_Site_ViewDetailsLink_Description_Text: [], Spa_PlanList_Tab_Show_DENTAL: [], Spa_PlanList_Tab_Show_VISION: [], Spa_PlanList_Tab_Show_HIP: [], Spa_PlanList_ShowAllMedigap_Enabled: [], Spa_PlanList_AddOn_Filter_Enabled: [], Spa_Filter_AddOn_Coverage_ToolTip_Text: [], Spa_Filter_Providers_ToolTip_Text: [], Spa_PlanList_AddOn_Header_Text: [], Spa_PlanList_MedSupPlanSubTypeHeader_Text: [], Spa_PlanList_MedSupPlanSubTypePlaceholder_Text: [], Spa_PlanList_MedSupPlanSubTypeUpdate_Text: [], Spa_PlanList_Include_NonLicensed_Plans: [], Spa_Filter_MedicalDeductible_Text: [], Spa_Filter_MedicalDeductible_ToolTip_Text: [], Spa_Filter_MaximumOutOfPocketCost_Text: [], Spa_Filter_MaximumOutOfPocketCost_ToolTip_Text: [], Spa_Filter_PharmacyDeductible_Text: [], Spa_Filter_PharmacyDeductible_ToolTip_Text: [], Spa_Filter_Premium_Text: [], Spa_Filter_Premium_ToolTip_Text: [], Spa_Filter_PlanBenefitsGroup_Enabled: [], Spa_PlanCard_Preferences_Detailed_Enabled: [], Spa_Site_Show_AncillaryPlanLogo: [], Spa_Display_SNP_PremiumRange_Enabled: [], Spa_SNPRange_Link_Text: [], Spa_Site_Default_Plan_Benefit_Filter: [], Spa_Retention_ClientDefinedPlanOptions_Enabled: [], Spa_Site_Plan_Option_One_Text: [], Spa_Site_Plan_Option_Two_Text: [], Spa_Filter_Plan_Marketing_Name_Enabled: [], Spa_MedSupForm_AllowFormWhenNoPlansAvailable_Enabled: [], Spa_PlanCard_AncillaryAddtoCart_Enabled: [], Spa_PlanCard_ShowAncillaryIcons_Enabled: [], Spa_Site_ShowDrugAlternatives_Enabled: [], Spa_PlanCard_ShowDrugAlternatives_Nudge_Enabled: [], Spa_PlanCard_ShowDrugAlternatives_Tooltip_Text: [], Spa_PlanCard_ShowDrugAlternatives_Nudge_Text: [], Spa_PlanCard_ShowDrugAlternatives_Indicator_Icon: [], Spa_Site_Preferences_Score_Enabled: [], Spa_PlanList_Tab_Text_NoPlans_HIP: [], SPA_HIP_Rider_Benefit_Default_Dropdown_Text: [], Spa_Site_Days_Text: [], Spa_Site_Day_Text: [], Spa_Site_LumpSum_Text: [], Spa_Site_Loader_Updated_Icon_Enabled: [], Spa_Site_Plans_Loading_Text: [], Spa_Site_Provider_ShowAllInNetworkLocations_Enabled: [], Spa_PlanCard_SupplementalBenefits_Enabled: [], Spa_PlanCard_SupplementalBenefits_List: [], Spa_Rating_Method_Enabled: [], Spa_RatingMethod_AttainedAge_Tooltip_Text: [], Spa_RatingMethod_IssueAge_Tooltip_Text: [], Spa_RatingMethod_CommunityRated_Tooltip_Text: [], Spa_PlanCard_Providers_OneOrMore_OutOfNetwork_Text: [], Spa_Providers_InNetwork_OnOtherLocations_Tooltip_Text: [], Spa_AddHealth_ModalView1_HeadingText: [], Spa_AddHealth_ModalView1_IntroText: [], Spa_AddEligibility_ModalView1_HeadingText: [], Spa_AddEligibility_ModalView1_IntroText: [], Spa_Provider_ShowPartialIndicator_Enabled: [], Spa_Site_PlanFees_Enabled: [], Spa_PlanFees_Tooltip_Text: [], Spa_PlanFees_IncludedInPremium_Tooltip_Text: [], Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text: [], Spa_PlanCard_ShowAvailableRateFactors_Enabled: [], Spa_PlanCard_PersonalizedQuoteLabel_Text: [], Spa_PlanCard_AvailableRateFactors_Data: [], Spa_PlanCard_Show_PlanId_Enabled: [], Spa_PlanList_Show_DSNP_EligibleMessage: [], Spa_PlanList_DSNP_EligibleMessage_Header_Text: [], Spa_PlanList_DSNP_EligibleMessage_Info_Text: [], Spa_DSNP_Eligibility_LearnMore_Text: [], Spa_DSNP_Eligibility_Tooltip_Text: [], Spa_Site_TotalSiteCountsPPC_Enabled: [], Spa_Site_TotalSiteCounts_Text: [], Spa_PlanCard_PlanId_Text: [], Spa_Profile_StateEligibilityCheck_Enabled: [], Spa_GettingStarted_MedicaidCode_Text: [], Spa_PlanCard_DSNPCodeDisplay_Enabled: [], Spa_Filter_DSNPMedicaidCodes_Enabled: [], Spa_DSNPEligibility_FilterCodeMessage_Enabled: [], Spa_DSNPEligibility_FilterCodeMessage_Text: [], Spa_Site_Available_Text: [], Spa_Site_NotAvailable_Text: [], Spa_PlanCard_Providers_ViewButton_Text: [], Spa_PlanCard_Prescriptions_ViewButton_Text: [], Spa_PlanCard_SupplementalBenefitsHighlight_Text: [], Spa_Plan_Details_Preferences_Text: [], Spa_PlanCard_ViewMoreDetails_ButtonText: [], Spa_PlanCard_HideDetails_ButtonText: [], Spa_PlanCard_NewDesign_Enabled: [], Spa_PlanCard_ViewAllPlanDetails_ButtonText: [], Spa_PlanCard_ShareThisPlan_ButtonText: [], Spa_PlanCard_ViewCostDetails_ButtonText: [], Spa_Site_Close: [], Spa_PlanList_FilterModal_Enabled: [], Spa_PlanFilters_Modal_Button_Label: [], Spa_PlanCard_PlanBenefitHighlight_Items: [], Spa_PlanCard_PlanBenefitHighlights_Text: [], Spa_Site_RiderDetails_Show: [], Spa_Plan_Details_ViewRiderDetails_Text: [], Spa_Plan_Details_HideRiderDetails_Text: [], Spa_ShoppingCart_IncludedRider_Text: [], Spa_Site_ValueBasedCare_Agreement_Enabled: [], Spa_Site_ValueBasedCare_Agreement_Label: [], Spa_Site_ValueBasedCare_Agreement_Tooltip: [], Spa_Plan_Details_WaiverStateRider_Tooltips: [], Spa_Plandetails_Costs_MAPD: [], Spa_Plandetails_Costs_MA: [], Spa_Plandetails_Costs_MEDIGAP: [], Spa_Plandetails_Costs_PDP: [], Spa_PlanDetails_Costs_DENTAL: [], Spa_PlanDetails_Costs_VISION: [], Spa_StarRating_Label_Text: [], Spa_StarRating_Filter_Options: [], Spa_PlanFilters_Sort_Options_For_Modal: [], Spa_PharmacySearch_Back_Button: [], Spa_AddPharmacy_ModalView1_IntroText: [], Spa_AddPharmacy_ModalView1_HeadingText: [], Spa_AddPharmacy_ModalView2_IntroText: [], Spa_AddPharmacy_ModalView2_HeadingText: [], Spa_PharmacySearch_Pagination_ItemsPerPage: [], Spa_PharmacySearch_Pagination_Enabled: [], Spa_PharmacySearch_Pagination_View_Text: [], Spa_Site_Standard_In_Network_Text: [], Spa_PharmacySearch_Preferred_In_Network_Tooltip_Text: [], Spa_PharmacySearch_Standard_In_Network_Tooltip_Text: [], Spa_Pharmacy_Alt_View_Not_Found_Header_Text: [], Spa_Pharmacy_Alt_View_Not_Found_Body_Text: [], Spa_Site_Preferred_In_Network_Text: [], Spa_PharmacyName_Text: [], Spa_Add_Pharmacy_Button: [], Spa_PreferenceBanner_Enabled: [], Spa_PreferenceBanner_Header_Text: [], Spa_PreferenceBanner_View_ButtonText: [], Spa_PreferenceBanner_Hide_ButtonText: [], Spa_Site_View: [], Spa_PreferenceBanner_Added_ButtonText: [], Spa_Site_Close_Modal: [], Spa_PharmacyName_HintText: [], Spa_GuidedHelp_Health_AgeQuestion_Text: [], Spa_Site_Health_Slider_Label_Text: [], Spa_HealthCosts_Body_Text: [], Spa_Site_HealthCosts_Save_Failed_Text: [], Spa_Site_HealthCosts_Customization_Enabled: [], Spa_Pharmacy_Limit: [], Spa_Provider_Limit: [], Spa_PharmacyMap_Default_Zoom: [], Spa_ProviderMap_Default_Zoom: [], Spa_PharmacyMap_Max_Zoom: [], Spa_PharmacyMap_Min_Zoom: [], Spa_ProviderMap_Max_Zoom: [], Spa_ProviderMap_Min_Zoom: [], Spa_Site_Maximum_Pharmacy_Count: [], Spa_Site_Set_Primary_Pharmacy_Link_Text: [], Spa_Site_Primary_Pharmacy_Text: [], Spa_Site_Primary_Pharmacy_Icon: [], Spa_Site_Primary_Pharmacy_Icon_Color: [], Spa_PharmacySearch_PageHeader_Text: [], Spa_PharmacySearch_Intro_Text: [], Spa_PharmacySearch_MultiPharmacy_Intro_Text: [], Spa_Site_Pharmacy_Limit_Error_Message: [], Spa_Multi_Providers_Body_Text: [], Spa_Site_AddPharmacy_YourMultiPharmacyText: [], Spa_OtherPreferences_PageCount_Text: [], Spa_GuidedHelp_OtherPreferences_EnterZip_Text: [], Spa_GuidedHelp_OtherPreferences_ProvideZip_Text: [], Spa_GuidedHelp_Health_SliderHeader1_Text: [], Spa_GuidedHelp_Health_SliderHeader2_Text: [], Spa_GuidedHelp_Health_SliderHeader3_Text: [], Spa_GuidedHelp_Health_SliderBody1: [], Spa_GuidedHelp_Health_SliderBody2: [], Spa_GuidedHelp_Health_SliderBody3: [], Spa_HealthCosts_Benefits_Body_Text: [], Spa_Site_HealthCosts_Benefits_Table_Header: [], Spa_Site_HealthCosts_Usage_Table_Header: [], Spa_Site_HealthCosts_Days_Table_Header: [], Spa_Site_HealthCosts_Restore_Defaults_Text: [], Spa_Site_HealthCosts_Update_Answers_Text: [], Spa_Site_HealthCosts_Save_Answers_Text: [], Spa_Site_HealthCosts_Save_Success_Text: [], Spa_Site_HealthCosts_Benefits_JSON: [], Spa_DrugSearch_Content_Section_Text: [], Spa_DrugSearch_Dosage_Header: [], Spa_DrugSearch_Frequency_Header: [], Spa_DrugSearch_Package_Header: [], Spa_DrugSearch_Add_Button: [], Spa_DrugSearch_Cancel_Button: [], Spa_DrugSearch_Back_Button: [], Spa_DrugSearch_EditDrug_Button: [], Spa_DrugSearch_Quantity_Max_Limit: [], Spa_DrugSearch_Cabinet_Limit: [], Spa_DrugSearch_MaxCount_Error_Message: [], Spa_DrugSearch_Quantity_Error_Message: [], Spa_DrugSearch_Label_Text: [], Spa_DrugSearch_Drugs_Image: [], Spa_DrugSearch_InCabinetError_Text: [], Spa_DrugSearch_Medicine_Header: [], Spa_DrugSearch_GenericOption_Icon: [], Spa_Site_Show_GenericDrugOption: [], Spa_DrugSearch_GenericOption_Question: [], Spa_DrugSearch_GenericOption_Info: [], Spa_DrugSearch_GenericOptions: [], Spa_DrugSearch_CheckDrugCoverageButton_Text: [], Spa_DrugSearch_GenericOption_Default_Selection: [], Spa_DrugListCard_HideCosts_Flag: [], Spa_DrugSearch_Hint_Text: [], Spa_DrugSearch_Intro_Text: [], Spa_DrugSearch_PageHeader_Text: [], Spa_DrugSearch_Frequency_ListBox_Label: [], Spa_Site_Enable_BlueButton: [], Spa_Site_OrText: [], Spa_BlueButton_StartAddDrug_Text: [], Spa_BlueButton_MyMedicare_Connect_Text: [], Spa_BlueButton_MyMedicare_Button: [], Spa_Site_EmailAddress_Text: [], Spa_Profile_EmailRequired_Error: [], Spa_Profile_EmailInvalid_Error: [], Spa_Site_SendEmailButton_Text: [], Spa_BlueButton_Modal_Header: [], Spa_BlueButton_Modal_Content: [], Spa_BlueButton_Success_Text: [], Spa_BlueButton_Download_Text: [], Spa_BlueButton_Success_Message: [], Spa_BlueButton_EmailSentToStatus_Text: [], Spa_BlueButton_Issue_Loading_Text: [], Spa_BlueButton_Beneficiary_Denied_Text: [], Spa_BlueButton_Error_Loading_Text: [], Spa_BlueButton_Beneficiary_Email_Details: [], Spa_BlueButton_ImportLatestPrescription_Button_Text: [], Spa_BlueButton_ImportLatestPrescription_Error_Text: [], Spa_BlueButton_AccessDenied_Error_Text: [], Spa_BlueButton_ClaimData_Loading_Error_Text: [], Spa_Drugs_UseCMSDrugFlag_Enabled: [], Spa_AddPrescriptions_ModalView1_HeadingText: [], Spa_AddPrescriptions_ModalView1_IntroText: [], Spa_AddPrescriptions_ModalView2_HeadingText: [], Spa_AddPrescriptions_ModalView2_IntroText: [], Spa_DrugSearch_Text: [], Spa_DrugSearch_Frequency_List: [], Spa_GettingStarted_ShowSubsidyAccordion_Flag: [], Spa_GuidedHelp_OptionalLabel_Text: [], Spa_GettingStarted_SubsidyHeader_Text: [], Spa_Site_Providers_Body_Text: [], Spa_Provider_Add_Text: [], Spa_Provider_Added_Text: [], Spa_Provider_RemoveProvider_Text: [], Spa_Provider_YourProvider_Text: [], Spa_Provider_Set_Primary_Care_Provider_Text: [], Spa_Provider_Primary_Care_Provider_Text: [], Spa_Site_ZipCodeInput_ZipCodeLabel: [], Spa_Site_ZipCodeInput_ZipCodeError: [], Spa_Providers_Filter_Enabled: [], Spa_Group_Provider_Add_Text: [], Spa_Group_Provider_Added_Text: [], Spa_ZipCodeInput_CountyLabel_Text: [], Spa_Site_Add: [], Spa_Site_Cancel: [], Spa_Select_Single_Provider_For_Multi_Address_Enabled: [], Spa_Select_Provider_Location_Text: [], Spa_Provider_Exists_Text: [], Spa_Provider_Multiple_Location_Text: [], Spa_Plan_Providers_Locations_Link_Text: [], Spa_Site_ValueBasedCare_Enabled: [], Spa_Site_ValueBasedCare_Icon: [], Spa_Site_ValueBasedCare_Text: [], Spa_Provider_Search_Filter_General_Practice_Options: [], Spa_Provider_Search_General_Practice_Label_Text: [], Spa_Provider_Search_General_Practice_Tooltip_Text: [], Spa_Provider_Search_Filter_General_Practice_Option_Enabled: [], Spa_Provider_Search_ShowSingleProviderInList_Enabled: [], Spa_Site_Edit_Text: [], Spa_Site_Update_Text: [], Spa_Provider_ShowEditLink_Enabled: [], Spa_ValueBasedCare_Available_Text: [], Spa_ValueBasedCare_LearnMore_Link: [], Spa_ValueBasedCare_LearnMore_Text: [], Spa_ValueBasedCare_LearnMoreLink2_Enabled: [], Spa_ValueBasedCare_Toggle_Label: [], Spa_ValueBasedCare_Toggle_ToolTip_Text: [], Spa_ValueBasedCare_Toggle_Enabled: [], Spa_Provider_Search_Filter_ValueBasedCare_Options: [], Spa_Provider_New_Patient_Toggle_Enabled: [], Spa_Provider_New_Patient_Toggle_Label: [], Spa_Provider_New_Patient_Options: [], Spa_Primary_Care_Provider_Toggle_Enabled: [], Spa_Primary_Care_Provider_Toggle_Label: [], Spa_Primary_Care_Provider_Options: [], Spa_New_Patient_For_Provider_Text: [], Spa_Existing_Patient_For_Provider_Text: [], Spa_Provider_ValueBasedCare_Name_Filter_Enabled: [], Spa_Provider_ValueBasedCare_Name_Filter_Label: [], Spa_Selected_Provider_Options_Enabled: [], Spa_Site_Remove_Text: [], Spa_Site_SelectAll_Text: [], Spa_ProviderName_Text: [], Spa_ProviderName_HintText: [], Spa_Site_SearchButton_Text: [], Spa_ProviderSearch_Pagination_ItemsPerPage: [], Spa_ProviderSearch_Pagination_Enabled: [], Spa_ProviderSearch_Pagination_View_Text: [], Spa_Provider_Alt_View_Not_Found_Header_Text: [], Spa_Provider_Alt_View_Not_Found_Body_Text: [], Spa_Provider_Add_Maximum_Limit_Message: [], Spa_Providers_Filter_Individuals_Text: [], Spa_Providers_Filter_Facilties_Text: [], Spa_ValueBasedCare_Filter_Text: [], Spa_Site_ValueBasedCare_Filter_Enabled: [], Spa_ValueBasedCare_Filter_Checked: [], Spa_ValueBasedCare_LearnMoreLink_Enabled: [], Spa_Providers_Back_Button: [], Spa_AddProviders_ModalProviderSearchView_HeadingText: [], Spa_AddProviders_ModalProviderSearchView_IntroText: [], Spa_AddProviders_ModalProviderMapView_HeadingText: [], Spa_AddProviders_ModalProviderMapView_IntroText: [], Spa_AddProviders_ModalProviderLocationView_HeadingText: [], Spa_AddProviders_ModalProviderLocationView_IntroText: [], Spa_PreferenceBanner_DisplayButtons_JSON: [], isExtraSmall$: [], isMobile$: [], onDocumentClick: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], getFiltersSelectionInfo: [], selectedTabForNonCoveredPlanByStates: [], checkTabVisibilityAndCoverage: [] }); })();

function AddProfileComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.Spa_AddProfile_Title);
} }
function AddProfileComponent_ng_container_5_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 30);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", ctx_r19.Spa_EditProfile_PageSubHeader_Text ? i0.ɵɵpipeBind2(1, 1, ctx_r19.Spa_EditProfile_PageSubHeader_Text, "html") : "", i0.ɵɵsanitizeHtml);
} }
function AddProfileComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AddProfileComponent_ng_container_5_div_1_Template, 2, 4, "div", 29);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_EditProfile_PageSubHeader_Text");
} }
function AddProfileComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 30);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r3.Spa_NewProfile_PageSubHeader_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function AddProfileComponent_vnext_member_quote_history_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-member-quote-history", 31);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("memberQuoteHistoryHeaderText", ctx_r4.Spa_MemberQuoteHistory_Header_Text)("memberQuoteHistoryNoQuotesMessageText", ctx_r4.Spa_MemberQuoteHistory_NoQuotesMessageText)("memberQuoteHistoryQuoteSentText", ctx_r4.Spa_MemberQuoteHistory_QuoteSentText)("memberQuoteHistoryAuthorizationEmailBodyText", ctx_r4.Spa_SentQuote_AuthorizationEmail_Body)("memberQuoteHistory", ctx_r4.filterQuickQuoteEnrollments(i0.ɵɵpipeBind1(1, 22, ctx_r4.memberQuoteHistoryForAgent$)))("deliveryMethodPrefix", ctx_r4.Spa_MemberQuoteHistory_DeliveryMethod_Prefix)("deliveryMethodSeparator", ctx_r4.Spa_MemberQuoteHistory_DeliveryMethod_Separator)("planTypeHeader", ctx_r4.Spa_Site_PlanType_Header)("requestedEffectiveDateHeader", ctx_r4.Spa_EnrollmentHistory_RequestedEffectiveDate_Text)("pacificTimePostFix", ctx_r4.Spa_EnrollmentHistory_Pacific_StandardTime_Text)("displayQuoteSentInformation", ctx_r4.Spa_MemberQuoteHistory_DisplayQuoteSentInformation)("displayPlanType", ctx_r4.Spa_MemberQuoteHistory_DisplayPlanType)("displayRequestedEffectiveDate", ctx_r4.Spa_MemberQuoteHistory_DisplayRequestedEffectiveDate)("displayAuthCode", ctx_r4.Spa_MemberQuoteHistory_DisplayAuthCode)("displayPersonalizedMessage", ctx_r4.Spa_MemberQuoteHistory_DisplayPersonalizedMessage)("displayAgentFullName", ctx_r4.Spa_MemberQuoteHistory_DisplayAgentFullName)("displayAgentUserName", ctx_r4.Spa_MemberQuoteHistory_DisplayAgentUserName)("memberQuoteHistoryPlanNameEnabled", ctx_r4.Spa_MemberQuoteHistory_DisplayPlanName)("memberQuoteHistoryCarrierNameEnabled", ctx_r4.Spa_MemberQuoteHistory_DisplayCarrierName)("showPlanYearBadge", ctx_r4.isDualPlanYearSite && ctx_r4.Spa_MemberQuoteHistory_ShowPlanYearBadge_Enabled)("sendQuoteAgentOfRecordEnabled", ctx_r4.Spa_SendQuote_AgentOfRecord_Enabled)("currentAgentGuid", ctx_r4.currentAgentGuid);
} }
function AddProfileComponent_vnext_member_enrollment_history_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-member-enrollment-history", 32);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("memberEnrollments", ctx_r5.memberEnrollments)("memberQuoteHistory", i0.ɵɵpipeBind1(1, 64, ctx_r5.memberQuoteHistoryForAgent$))("memberEnrollmentHistoryHeaderText", ctx_r5.Spa_EnrollmentHistory_Header_Text)("noEnrollmentMessageText", ctx_r5.Spa_EnrollmentHistory_NoEnrollmentMessageText)("pacificStandardTimeText", ctx_r5.Spa_EnrollmentHistory_Pacific_StandardTime_Text)("memberEnrollmentHistoryEffectiveDateText", ctx_r5.Spa_EnrollmentHistory_RequestedEffectiveDate_Text)("totalMonthlyPremiumLabel", ctx_r5.Spa_Site_TotalMonthlyPremiumLabel)("viewApplicationLinkText", ctx_r5.Spa_Site_ViewApplication_Link_Text)("confirmationText", ctx_r5.Spa_EnrollmentHistory_Confirmation_Text)("submittedDateText", ctx_r5.Spa_EnrollmentHistory_SubmittedDate_Text)("lastUpdatedText", ctx_r5.Spa_EnrollmentHistory_UpdatedDate_Text)("confirmationNumberEnabled", ctx_r5.Spa_EnrollmentHistory_ConfirmationNumber_Enabled)("planNameEnabled", ctx_r5.Spa_EnrollmentHistory_PlanName_Enabled)("effectiveDateEnabled", ctx_r5.Spa_EnrollmentHistory_EffectiveDate_Enabled)("totalMonthlyPremiumEnabled", ctx_r5.Spa_EnrollmentHistory_TotalMonthlyPremium_Enabled)("submissionDateEnabled", ctx_r5.Spa_EnrollmentHistory_SubmissionDate_Enabled)("updatedDateEnabled", ctx_r5.Spa_EnrollmentHistory_UpdatedDate_Enabled)("ridersEnabled", ctx_r5.Spa_EnrollmentHistory_Riders_Enabled)("continueEnrollmentButtonText", ctx_r5.Spa_EnrollmentHistory_ContinueEnrollment_ButtonText)("hraPDFLinkText", ctx_r5.SPA_EnrollmentHistory_HRALink_Text)("hraConfirmationText", ctx_r5.Spa_EnrollmentHistory_hraConfirmation_Text)("hraConfirmationNumberEnabled", ctx_r5.Spa_EnrollmentHistory_hraConfirmation_Enabled)("displayPlanAllowsCallRecordingIconEnabled", ctx_r5.Spa_Site_AgentCallRecording_DisplayPlanAllowsCallRecordingIcon_Enabled)("planAllowsCallRecordingText", ctx_r5.Spa_Site_AgentCallRecording_PlanAllowsCallRecording_Text)("agentCallInProgressAcceptCallIcon", ctx_r5.Spa_AgentCallInProgressAcceptCall_Icon)("isHRAEnabled", ctx_r5.Spa_Site_HRA_Enabled)("completeHRAButtonEnabled", ctx_r5.Spa_Site_CompleteHRA_Button_Enabled)("openExternalInNewTab", ctx_r5.Spa_EnrollmentConfirmation_OpenExternalHRAInNewTab_Enabled)("completeHRAButtonText", ctx_r5.Spa_Site_CompleteHRA_Button_Text)("completeHRALastVisitedText", ctx_r5.Spa_Site_CompleteHRA_LastVisited_Text)("completeHRADaysLeftText", ctx_r5.Spa_Site_CompleteHRA_DaysLeft_Text)("isMobile", ctx_r5.isMobile)("showPlanYearBadge", ctx_r5.Spa_EnrollmentHistory_ShowPlanYearBadge_Enabled)("planFeesEnabled", ctx_r5.Spa_Site_PlanFees_Enabled)("planFeesTooltipText", ctx_r5.Spa_PlanFees_Tooltip_Text)("planFeesIncludedInPremiumTooltipText", ctx_r5.Spa_PlanFees_IncludedInPremium_Tooltip_Text)("planFeesNotIncludedInPremiumTooltipText", ctx_r5.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text)("memberEnrollmentStatus", i0.ɵɵpipeBind1(2, 66, ctx_r5.memberEnrollmentStatus$))("enrollmentStatusEnabled", ctx_r5.Spa_EnrollmentHistory_EnrollmentStatus_Enabled)("statusDateText", ctx_r5.Spa_EnrollmentStatus_Date_Text)("statusText", ctx_r5.Spa_EnrollmentStatus_Label_Text)("defaultStatusText", ctx_r5.Spa_EnrollmentStatus_Default)("enrollmentHistoryProfileLinkEnabled", ctx_r5.Spa_Site_EnrollmentHistory_ProfileLink_Enabled)("enrollmentHistoryLinkText", ctx_r5.Spa_Enrollment_History_Link_Text)("enrollmentStatusHeaderText", ctx_r5.Spa_EnrollmentHistory_EnrollmentStatus_HeaderText)("enrollmentMoreDetailsText", ctx_r5.Spa_Site_EnrollmentHistory_MoreDetailsText)("enrollmentHraHeaderText", ctx_r5.Spa_EnrollmentHistory_HealthRiskAssessment_HeaderText)("enrollmentConfirmationHeaderText", ctx_r5.Spa_EnrollmentHistory_Confirmation_HeaderText)("memberEnrollmentEffectiveDateHeaderText", ctx_r5.Spa_EnrollmentHistory_RequestedEffectiveDate_HeaderText)("riderHeaderText", ctx_r5.Spa_EnrollmentHistory_Riders_HeaderText)("callRecordingHeaderText", ctx_r5.Spa_EnrollmentHistory_CallRecordings_HeaderText)("uploadDocumentHeaderText", ctx_r5.Spa_EnrollmentHistory_UploadedDocuments_HeaderText)("partialEnrollmentDisabledText", ctx_r5.Spa_Site_EnrollmentHistory_ContinueButton_Alternate_Text)("valueBasedCareConfirmationEnabled", ctx_r5.Spa_ValueBasedCare_Confirmation_Enabled)("valueBasedCareConfirmationText", ctx_r5.Spa_EnrollmentHistory_ValueBasedCare_HeaderText)("valueBasedCareProviders", ctx_r5.valueBasedCareProviders)("isEnrollmentContinueButtonEnabled", ctx_r5.Spa_EnrollmentHistory_PartialEnrollmentContinueButton_Enabled)("partialEnrollmentAllowedDate", ctx_r5.Spa_PartialEnrollment_Allowed_Date)("enrollerButtonTooltipText", ctx_r5.Spa_Site_EnrollerButton_Tooltip_Text)("valueBasedCareConfirmationExpiration", ctx_r5.Spa_ValueBasedCare_ConfirmationExpirationDays_Count)("isHRAPDFAccessEnabled", ctx_r5.Spa_EditProfile_AccessHRAPDF_Enabled)("isProfileAdmin", ctx_r5.isProfileAdmin)("isCompleteHRAProfileAdminEnabled", ctx_r5.Spa_EditProfile_CompleteHRAProfileAdmin_Enabled)("excludedCarrierIds", ctx_r5.Spa_HRA_ExcludedCarriers);
} }
function AddProfileComponent_vnext_link_15_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 33);
    i0.ɵɵlistener("click", function AddProfileComponent_vnext_link_15_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.onPreviousClick()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r6.Spa_Site_Previous)("showArrow", "left")("makeInlineBlock", true);
} }
function AddProfileComponent_ng_container_16_vnext_link_1_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 35, 36);
    i0.ɵɵlistener("click", function AddProfileComponent_ng_container_16_vnext_link_1_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r25); const _r23 = i0.ɵɵreference(1); const ctx_r24 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r24.saveAndNavigate(ctx_r24.pageTags.GUIDED_HELP_GETTING_STARTED, _r23)); })("keyup.enter", function AddProfileComponent_ng_container_16_vnext_link_1_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r25); const _r23 = i0.ɵɵreference(1); const ctx_r26 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r26.saveAndNavigate(ctx_r26.pageTags.GUIDED_HELP_GETTING_STARTED, _r23)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    const _r11 = i0.ɵɵreference(22);
    i0.ɵɵproperty("title", ctx_r22.Spa_Site_AddPreferences)("showArrow", "right")("makeInlineBlock", true)("ngbTooltip", _r11);
} }
function AddProfileComponent_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AddProfileComponent_ng_container_16_vnext_link_1_Template, 2, 4, "vnext-link", 34);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_AddPreferences");
} }
function AddProfileComponent_ng_container_18_vnext_link_1_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 38, 36);
    i0.ɵɵlistener("click", function AddProfileComponent_ng_container_18_vnext_link_1_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r30); const _r28 = i0.ɵɵreference(1); const ctx_r29 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r29.saveAndNavigate(ctx_r29.pageTags.GUIDED_HELP_GETTING_STARTED, _r28)); })("keyup.enter", function AddProfileComponent_ng_container_18_vnext_link_1_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r30); const _r28 = i0.ɵɵreference(1); const ctx_r31 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r31.saveAndNavigate(ctx_r31.pageTags.GUIDED_HELP_GETTING_STARTED, _r28)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(2);
    const _r11 = i0.ɵɵreference(22);
    i0.ɵɵproperty("title", ctx_r27.Spa_Site_AddPreferences)("showArrow", "right")("makeInlineBlock", true)("ngbTooltip", _r11);
} }
function AddProfileComponent_ng_container_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AddProfileComponent_ng_container_18_vnext_link_1_Template, 2, 4, "vnext-link", 37);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_AddPreferences");
} }
function AddProfileComponent_button_19_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r33.Spa_Site_ContinueToSOA, "");
} }
function AddProfileComponent_button_19_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 39, 40);
    i0.ɵɵlistener("click", function AddProfileComponent_button_19_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r35); const _r32 = i0.ɵɵreference(1); const ctx_r34 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r34.saveAndNavigate(ctx_r34.pageTags.SOA, _r32)); })("keyup.enter", function AddProfileComponent_button_19_Template_button_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r35); const _r32 = i0.ɵɵreference(1); const ctx_r36 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r36.saveAndNavigate(ctx_r36.pageTags.SOA, _r32)); });
    i0.ɵɵtemplate(2, AddProfileComponent_button_19_span_2_Template, 2, 1, "span", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r11 = i0.ɵɵreference(22);
    i0.ɵɵproperty("ngbTooltip", _r11);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_ContinueToSOA");
} }
function AddProfileComponent_button_20_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 41, 42);
    i0.ɵɵlistener("click", function AddProfileComponent_button_20_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r39); const _r37 = i0.ɵɵreference(1); const ctx_r38 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r38.saveAndNavigate(ctx_r38.pageTags.PLAN_LIST, _r37)); })("keyup.enter", function AddProfileComponent_button_20_Template_button_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r39); const _r37 = i0.ɵɵreference(1); const ctx_r40 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r40.saveAndNavigate(ctx_r40.pageTags.PLAN_LIST, _r37)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    const _r11 = i0.ɵɵreference(22);
    i0.ɵɵproperty("ngbTooltip", _r11);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.Spa_Site_ContinueToPlanList, " ");
} }
const _c0$G = function (a0) { return { error: a0 }; };
const _c1$a = function (a0) { return { "fa-exclamation-circle": a0 }; };
function AddProfileComponent_ng_template_21_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵelement(1, "i", 45);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$G, ctx_r41.showError));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c1$a, ctx_r41.showError));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r41.Spa_AddProfile_MemberCreate_Error_Text, " ");
} }
function AddProfileComponent_ng_template_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, AddProfileComponent_ng_template_21_div_0_Template, 3, 7, "div", 43);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r12.showError);
} }
function AddProfileComponent_vnext_copy_purl_plus_24_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-copy-purl-plus", 46);
    i0.ɵɵlistener("onCopyClick", function AddProfileComponent_vnext_copy_purl_plus_24_Template_vnext_copy_purl_plus_onCopyClick_0_listener() { i0.ɵɵrestoreView(_r43); const ctx_r42 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r42.copyPurl()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵproperty("purlToConsumerAccountButtonText", ctx_r13.Spa_Agent_Profile_PURLToConsumerAccount_ButtonText)("purlToConsumerAccountErrorText", ctx_r13.Spa_Agent_Profile_PURLToConsumerAccount_ErrorText)("copiedInfoText", ctx_r13.Spa_Agent_AccountOverview_CopiedInfo_Text)("memberEmail", ctx_r13.memberEmail)("memberCellPhone", ctx_r13.memberCellPhone);
} }
function AddProfileComponent_vnext_agent_of_record_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-agent-of-record", 47);
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵproperty("agentOfRecord", ctx_r14.agentOfRecord)("agentOfRecordHeaderLabel", ctx_r14.Spa_AddProfile_AssignedAgent_Text)("agentOfRecordReassignText", ctx_r14.Spa_AgentOfRecord_ModalHeader_Text)("agentOfRecordUnassignedText", ctx_r14.Spa_Site_Unassigned_Text)("isAgentAdmin", ctx_r14.isAgentAdmin)("isProfileAdmin", ctx_r14.isProfileAdmin);
} }
function AddProfileComponent_vnext_agent_retire_flo_26_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-agent-retire-flo", 48);
    i0.ɵɵlistener("openSendRetireFloModal", function AddProfileComponent_vnext_agent_retire_flo_26_Template_vnext_agent_retire_flo_openSendRetireFloModal_0_listener() { i0.ɵɵrestoreView(_r45); const ctx_r44 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r44.showRetireFloModal()); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext();
    i0.ɵɵproperty("agentHasRetireFlo", ctx_r15.agentHasRetireFlo)("agentRetireFloHeaderLabel", ctx_r15.Spa_Agent_Profile_RetireFlo_Header_Text)("agentRetireFloSignUpContentText", ctx_r15.Spa_Agent_Profile_RetireFlo_SignUp_Content_Text)("agentRetireFloSignUpButtonText", ctx_r15.Spa_Agent_AccountOverview_RetireFlo_SignUp_ButtonText)("agentRetireFloSendServeyButtonText", ctx_r15.Spa_Agent_Profile_RetireFlo_SendSurvey_ButtonText)("memberAgentNotes", i0.ɵɵpipeBind1(1, 6, ctx_r15.memberAgentRetireFlos$));
} }
function AddProfileComponent_vnext_agent_progress_tracker_27_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-agent-progress-tracker", 49);
    i0.ɵɵlistener("redirectRouteEvent", function AddProfileComponent_vnext_agent_progress_tracker_27_Template_vnext_agent_progress_tracker_redirectRouteEvent_0_listener($event) { i0.ɵɵrestoreView(_r47); const ctx_r46 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r46.navigateToPageTag($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isMemberProgressVisible", ctx_r16.Spa_Profile_Member_Progress_Visible)("memberProgressTitle", ctx_r16.Spa_Profile_Member_Progress_Title)("progressEvent", ctx_r16.Spa_Profile_Member_Progress_Event_Types)("memberProgressInfo", ctx_r16.memberProgressInfo)("transferCodeLabelText", ctx_r16.Spa_Site_TransferCode_Label_Text)("isTransferCodeEnabled", ctx_r16.Spa_Site_TransferCode_Enabled)("isProfilePage", true)("prescriptionsEnabled", ctx_r16.Spa_Site_Prescriptions_Enabled)("pharmacyEnabled", ctx_r16.Spa_Site_Pharmacy_Enabled)("providersEnabled", ctx_r16.Spa_Site_Providers_Enabled);
} }
function AddProfileComponent_vnext_member_profile_retention_summary_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-member-profile-retention-summary", 50);
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext();
    i0.ɵɵproperty("retentionSummaryHeaderText", ctx_r17.Spa_RetentionSummary_Profile_Header)("retentionSummaryBodyText", ctx_r17.Spa_RetentionSummary_Profile_Body)("retentionSummaryLinkText", ctx_r17.Spa_RetentionSummary_Profile_Link);
} }
function AddProfileComponent_vnext_agent_call_recording_shopping_box_40_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-agent-call-recording-shopping-box", 51);
    i0.ɵɵlistener("viewRecording", function AddProfileComponent_vnext_agent_call_recording_shopping_box_40_Template_vnext_agent_call_recording_shopping_box_viewRecording_0_listener() { i0.ɵɵrestoreView(_r49); const ctx_r48 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r48.onViewRecording()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵproperty("agentCallRecordingShoppingHeaderText", ctx_r18.Spa_Site_AgentCallRecordingShopping_ProfileBox_Header_Text)("agentCallRecordingShoppingSectionText", ctx_r18.Spa_Site_AgentCallRecordingShopping_ProfileBox_Section_Text)("agentCallRecordingShoppingLinkText", ctx_r18.Spa_Site_AgentCallRecordingShopping_ProfileBox_Link_Text);
} }
let AddProfileComponent = class AddProfileComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, navigationService, agentNoteFacade, agentTaskFacade, guidedHelpService, memberSessionService, memberRegistrationFacade, siteService, enrollmentHistoryFacade, agentPermissionService, agentCallRecordingFacade, responsiveLayoutService, hraFormFacade, analyticsService, planYearResourceService, soaFacade, providerFacade, agentService, spinnerService, localeService, agentRetireFloFacade, activatedRoute, profileFacade, accountOverviewFacade) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.navigationService = navigationService;
        this.agentNoteFacade = agentNoteFacade;
        this.agentTaskFacade = agentTaskFacade;
        this.guidedHelpService = guidedHelpService;
        this.memberSessionService = memberSessionService;
        this.memberRegistrationFacade = memberRegistrationFacade;
        this.siteService = siteService;
        this.enrollmentHistoryFacade = enrollmentHistoryFacade;
        this.agentPermissionService = agentPermissionService;
        this.agentCallRecordingFacade = agentCallRecordingFacade;
        this.responsiveLayoutService = responsiveLayoutService;
        this.hraFormFacade = hraFormFacade;
        this.analyticsService = analyticsService;
        this.planYearResourceService = planYearResourceService;
        this.soaFacade = soaFacade;
        this.providerFacade = providerFacade;
        this.agentService = agentService;
        this.spinnerService = spinnerService;
        this.localeService = localeService;
        this.agentRetireFloFacade = agentRetireFloFacade;
        this.activatedRoute = activatedRoute;
        this.profileFacade = profileFacade;
        this.accountOverviewFacade = accountOverviewFacade;
        this.Spa_Site_SOA_Enabled = true;
        this.Spa_Site_SiteType = SiteType.CONSUMER;
        this.Spa_Site_AddToQuote_Enabled = true;
        this.Spa_SendEnrollment_TextMessage_Enabled = true;
        this.Spa_Quote_CreateProfile_Enabled = true;
        this.Spa_SendEnrollment_Prompt = 'How would the beneficiary like to receive the application to finish enrolling?';
        this.Spa_Site_TotalMonthlyPremiumLabel = 'Total monthly premium';
        this.Spa_Site_EnrollmentHistory_Enabled = true;
        this.Spa_AddProfile_AgentNote_Header_Label = 'Notes';
        this.Spa_AddProfile_AgentNote_EmptyNote_Text = 'You have no notes for this profile';
        this.Spa_AddProfile_AgentNote_AddNoteLink_Text = 'Add Note';
        this.Spa_AddProfile_AgentNote_Created_Label = 'Created';
        this.Spa_AddProfile_AgentNote_AgentName_Prefix = '-';
        this.Spa_AddProfile_AgentTask_Header_Label = 'Tasks';
        this.Spa_AddProfile_AgentTask_EmptyTask_Text = 'You have no tasks for this profile';
        this.Spa_AddProfile_AgentTask_AddTaskLink_Text = 'Add Task';
        this.Spa_AddProfile_AgentTask_AgentName_Prefix = '-';
        this.Spa_AddProfile_AgentNote_Due_Label = 'Due';
        this.Spa_AddProfile_AgentNote_Completed_Label = 'Completed';
        this.Spa_AddProfile_MemberCreate_Error_Text = 'Try again';
        this.Spa_AddProfile_AgentSOA_Header_Label = 'SOA';
        this.Spa_AddProfile_AgentSOA_Empty_Text = 'You have no SOAs for this profile';
        this.Spa_MemberQuoteHistory_QuoteSentText = 'Quote sent';
        this.Spa_SentQuote_AuthorizationEmail_Body = 'Authorization Code:';
        this.Spa_MemberQuoteHistory_DeliveryMethod_Prefix = 'to';
        this.Spa_MemberQuoteHistory_DeliveryMethod_Separator = ',';
        this.Spa_Member_Profile_Address1_Display = true;
        this.Spa_Member_Profile_Address_Required = false;
        this.Spa_Member_Profile_Address2_Display = true;
        this.Spa_Member_Profile_City_Display = true;
        this.Spa_Member_Profile_City_Required = false;
        this.Spa_Member_Profile_CRM_Display = true;
        this.Spa_Member_Profile_CRM_Label = 'CRM ID';
        this.Spa_Member_Profile_CRM_Required = false;
        this.Spa_Member_Profile_CustomField1_Display = true;
        this.Spa_Member_Profile_CustomField1_Label = '';
        this.Spa_Member_Profile_CustomField2_Display = true;
        this.Spa_Member_Profile_CustomField2_Label = '';
        this.Spa_Member_Profile_CustomField3_Display = true;
        this.Spa_Member_Profile_CustomField3_Label = '';
        this.Spa_Member_Profile_CustomField4_Display = true;
        this.Spa_Member_Profile_CustomField4_Label = '';
        this.Spa_Member_Profile_CustomField5_Display = true;
        this.Spa_Member_Profile_CustomField5_Label = '';
        this.Spa_Member_Profile_DateOfBirth_Display = true;
        this.Spa_Member_Profile_DateOfBirth_Required = false;
        this.Spa_Member_Profile_Email_Display = true;
        this.Spa_Member_Profile_Email_Required = false;
        this.Spa_Member_Profile_PhoneNumber_Display = true;
        this.Spa_Member_Profile_PhoneNumber_Required = false;
        this.Spa_Member_Profile_Relationship_Required = false;
        this.Spa_Member_Profile_Relationship_Label = 'Relationship to beneficiary';
        this.Spa_Member_Profile_RepAddress1_Display = true;
        this.Spa_Member_Profile_RepAddress2_Display = true;
        this.Spa_Member_Profile_RepAddress_Required = false;
        this.Spa_Member_Profile_RepCity_Display = true;
        this.Spa_Member_Profile_RepCity_Required = false;
        this.Spa_Member_Profile_RepEmail_Display = true;
        this.Spa_Member_Profile_RepEmail_Required = false;
        this.Spa_Member_Profile_RepFirstName_Display = true;
        this.Spa_Member_Profile_RepFirstName_Required = false;
        this.Spa_Member_Profile_RepLastName_Display = true;
        this.Spa_Member_Profile_RepLastName_Required = false;
        this.Spa_Member_Profile_RepPhoneNumber_Display = true;
        this.Spa_Member_Profile_RepPhoneNumber_Required = false;
        this.Spa_Member_Profile_Relationship_Display = true;
        this.Spa_Member_Profile_RepState_Display = true;
        this.Spa_Member_Profile_RepState_Required = false;
        this.Spa_Member_Profile_RepZipCode_Display = true;
        this.Spa_Member_Profile_RepZipCode_Required = false;
        this.Spa_Member_Profile_State_Display = true;
        this.Spa_Member_Profile_State_Required = false;
        this.Spa_Site_PlanType_Header = 'Plan type:';
        this.Spa_MemberQuoteHistory_DisplayQuoteSentInformation = true;
        this.Spa_MemberQuoteHistory_DisplayPlanType = true;
        this.Spa_MemberQuoteHistory_DisplayRequestedEffectiveDate = true;
        this.Spa_MemberQuoteHistory_DisplayAuthCode = true;
        this.Spa_MemberQuoteHistory_DisplayPersonalizedMessage = true;
        this.Spa_MemberQuoteHistory_DisplayAgentFullName = true;
        this.Spa_MemberQuoteHistory_DisplayAgentUserName = true;
        this.Spa_AgentTask_AddFollowUp_Enabled = false;
        this.Spa_AgentTask_FollowUp_CreateTask_Header_Label = 'Create a task to follow up with the beneficiary';
        this.Spa_AgentTask_FollowUp_Quote_Text = 'Follow up on quote';
        this.Spa_AgentTask_FollowUp_Enrollment_Text = 'Follow up on Application for <plan name>';
        this.Spa_AgentTask_FollowUp_SOA_Text = 'Follow up on Scope of Appointment';
        this.Spa_AgentTask_FollowUp_TaskCreated_Text = 'Task created';
        this.Spa_AgentTask_DueDate_Label = 'Due date';
        this.Spa_AgentTask_Task_Label = 'Create a task';
        this.Spa_AgentTask_Save_Button = 'Add Task';
        this.Spa_AgentTask_ContentErrorText = 'Task is required';
        this.Spa_AgentTask_DateErrorText = 'Date is required';
        this.Spa_AgentTask_DateInvalidText = 'Please provide a valid date';
        this.Spa_AgentTask_PastDateInvalidText = 'can not be in the past';
        this.Spa_AgentTask_FollowUp_BlueButton_Text = 'Follow up on MyMedicare.gov invitation';
        this.Spa_AgentTask_FollowUp_BlueButton_Title = 'MyMedicare.gov invitation sent';
        this.Spa_MemberQuoteHistory_DisplayPlanName = false;
        this.Spa_MemberQuoteHistory_DisplayCarrierName = false;
        this.Spa_Site_AgentCallRecording_DisplayPlanAllowsCallRecordingIcon_Enabled = false;
        this.Spa_Site_AgentCallRecording_PlanAllowsCallRecording_Text = 'Call recording is available';
        this.Spa_AgentCallInProgressAcceptCall_Icon = 'fas fa-phone';
        this.Spa_RetentionSummary_Profile_Enabled = false;
        this.Spa_RetentionSummary_Profile_Header = 'Retention summary';
        this.Spa_RetentionSummary_Profile_Body = 'View plans associated with this beneficiary';
        this.Spa_RetentionSummary_Profile_Link = 'View associated plans';
        this.Spa_ValueBasedCare_Confirmation_Enabled = false;
        this.Spa_ValueBasedCare_ConfirmationExpirationDays_Count = 7;
        this.Spa_EnrollmentHistory_ValueBasedCare_HeaderText = 'Value based care provider selected';
        this.Spa_Site_ValueBasedCare_Enabled = false;
        this.Spa_EnrollmentHistory_ConfirmationNumber_Enabled = true;
        this.Spa_EnrollmentHistory_PlanName_Enabled = true;
        this.Spa_EnrollmentHistory_EffectiveDate_Enabled = true;
        this.Spa_EnrollmentHistory_TotalMonthlyPremium_Enabled = true;
        this.Spa_EnrollmentHistory_SubmissionDate_Enabled = true;
        this.Spa_EnrollmentHistory_Riders_Enabled = true;
        this.Spa_EnrollmentHistory_UpdatedDate_Enabled = true;
        this.Spa_EnrollmentHistory_RequestedEffectiveDate_Text = 'Requested effective date';
        this.Spa_EnrollmentHistory_Confirmation_Text = 'Confirmation';
        this.Spa_EnrollmentHistory_SubmittedDate_Text = 'Submitted';
        this.Spa_EnrollmentHistory_Pacific_StandardTime_Text = 'PST';
        this.Spa_EnrollmentHistory_UpdatedDate_Text = 'last updated';
        this.Spa_EnrollmentHistory_ContinueEnrollment_ButtonText = 'Continue enrollment';
        this.Spa_Site_ViewApplication_Link_Text = 'View application';
        this.Spa_SendEnrollment_Email_Enabled = true;
        this.Spa_SendEnrollment_EnrollForm_Button_Text = 'Send to beneficiary';
        this.Spa_SendEnrollment_Continue = 'Send enrollment';
        this.Spa_SendEnrollment_Title = 'Send enrollment';
        this.SPA_EnrollmentHistory_HRALink_Text = 'Health Risk Assessment';
        this.Spa_EnrollmentHistory_hraConfirmation_Text = 'HRA Confirmation';
        this.Spa_EnrollmentHistory_hraConfirmation_Enabled = true;
        this.Spa_EditProfile_AccessHRAPDF_Enabled = true;
        this.Spa_EditProfile_CompleteHRAProfileAdmin_Enabled = false;
        this.Spa_HRA_ExcludedCarriers = [];
        this.Spa_MemberQuoteHistory_Header_Text = 'Quote history';
        this.Spa_MemberQuoteHistory_NoQuotesMessageText = 'No quotes sent for this beneficiary';
        this.Spa_EnrollmentHistory_Header_Text = 'Enrollment History';
        this.Spa_EnrollmentHistory_NoEnrollmentMessageText = 'You have no enrollments for this beneficiary';
        this.SPA_Member_Profile_Sub_Header_Label = 'Personal information';
        this.SPA_Member_Profile_Home_Header_Label = 'Home address';
        this.SPA_Member_Profile_Additional_Information_Header_Label = 'Additional information';
        this.SPA_Member_Profile_SectionHeader_Sales_Information_Label = 'Sales information';
        this.Spa_Member_Profile_Save_Button_Label = 'Save';
        this.SPA_Member_Profile_Is_Sales_Contact_Different_Label = 'Is the sales contact different from the beneficiary';
        this.Spa_AddProfile_Title = 'Profile';
        this.Spa_Site_Previous = 'Previous';
        this.Spa_Site_ContinueToSOA = 'Continue to SOA';
        this.Spa_Site_ContinueToPlanList = 'Continue to plans';
        this.Spa_Site_AddPreferences = 'Add preferences';
        this.Spa_NewProfile_PageSubHeader_Text = '';
        this.Spa_EditProfile_PageSubHeader_Text = '';
        this.Spa_GuidedHelp_OptionalLabel_Text = '(Optional)';
        this.Spa_Site_CompleteHRA_Button_Enabled = false;
        this.Spa_EnrollmentConfirmation_OpenExternalHRAInNewTab_Enabled = false;
        this.Spa_Site_CompleteHRA_Button_Text = 'Complete HRA';
        this.Spa_Site_CompleteHRA_LastVisited_Text = 'Last visited';
        this.Spa_Site_CompleteHRA_DaysLeft_Text = '<hraDaysLeft> days left to complete HRA';
        this.Spa_Site_Cancel = 'Cancel';
        this.Spa_Site_Continue = 'Continue';
        this.Spa_EnrollmentConfirmation_ExternalHRATitle_Text = 'You are about to leave the site';
        this.Spa_EnrollmentConfirmation_ExternalHRABody_Text = 'You will now be directed to an external site to complete the Health Risk Assessment.';
        this.Spa_Site_HRA_Enabled = false;
        this.Spa_Profile_AgentCallRecordingShopping_DisplayRecordingLink_Enabled = false;
        this.Spa_Site_AgentCallRecordingShopping_ProfileBox_Header_Text = 'Call Recordings';
        this.Spa_Site_AgentCallRecordingShopping_ProfileBox_Section_Text = 'View recordings associated with this beneficiary';
        this.Spa_Site_AgentCallRecordingShopping_ProfileBox_Link_Text = 'View recordings';
        this.Spa_EnrollmentHistory_ShowPlanYearBadge_Enabled = true;
        this.Spa_MemberQuoteHistory_ShowPlanYearBadge_Enabled = true;
        this.Spa_PartialEnrollment_Allowed_Date = '12/08';
        this.Spa_Site_EnrollmentHistory_ContinueButton_Alternate_Text = 'Partial enrollment not available';
        this.Spa_Site_PlanFees_Enabled = false;
        this.Spa_PlanFees_Tooltip_Text = 'Fees';
        this.Spa_PlanFees_IncludedInPremium_Tooltip_Text = 'Included in premium';
        this.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text = 'Not included in premium';
        this.Spa_EnrollmentHistory_EnrollmentStatus_Enabled = false;
        this.Spa_EnrollmentStatus_Label_Text = 'Status:';
        this.Spa_EnrollmentStatus_Date_Text = 'Last Updated';
        this.Spa_EnrollmentStatus_Default = 'Status unknown';
        this.Spa_Site_EnrollmentHistory_ProfileLink_Enabled = true;
        this.Spa_Enrollment_History_Link_Text = 'View all enrollments';
        this.Spa_Site_EnrollmentHistory_MoreDetailsText = 'More details';
        this.Spa_EnrollmentHistory_EnrollmentStatus_HeaderText = 'Enrollment status';
        this.Spa_EnrollmentHistory_HealthRiskAssessment_HeaderText = 'Health Risk Assessment';
        this.Spa_EnrollmentHistory_Confirmation_HeaderText = 'Enrollment confirmation';
        this.Spa_EnrollmentHistory_RequestedEffectiveDate_HeaderText = 'Requested effective date';
        this.Spa_EnrollmentHistory_Riders_HeaderText = 'Riders';
        this.Spa_EnrollmentHistory_CallRecordings_HeaderText = 'Call recordings';
        this.Spa_EnrollmentHistory_UploadedDocuments_HeaderText = 'Uploaded documents';
        this.Spa_EnrollmentHistory_PartialEnrollmentContinueButton_Enabled = false;
        this.Spa_MemberProfile_AgentofRecordDisplay_Enabled = false;
        this.Spa_AgentOfRecord_ModalHeader_Text = 'Reassign agent of record';
        this.Spa_Site_Unassigned_Text = 'Unassigned';
        this.Spa_AddProfile_AssignedAgent_Text = 'Agent of record';
        this.Spa_Site_EnrollerButton_Tooltip_Text = `You don't have permission to take this action.`;
        this.Spa_SendQuote_AgentOfRecord_Enabled = false;
        this.Spa_Profile_StateEligibilityCheck_Enabled = false;
        this.Spa_Profile_StateEligibilityCheck_Description = 'Check State Medicaid eligibility';
        this.Spa_Profile_StateEligibilityCheck_MedicaidID = 'Medicaid ID';
        this.Spa_Profile_StateEligibilityCheck_ButtonText = 'Check State Medicaid eligibility';
        this.Spa_Profile_StateEligibilityCheck_NoMedicaidID_Text = 'Input a Medicaid ID to check eligibility';
        this.Spa_Profile_StateEligibilityCheck_Pending_Text = 'Pending';
        this.Spa_Profile_StateEligibilityCheck_Pending_DescriptionText = 'This may take a few minutes. Continue to the next page and come back at a later time';
        this.Spa_Profile_StateEligibilityCheck_NoZip_Text = 'Input a Zip code to check eligibility';
        this.Spa_Profile_StateEligibilityCheck_MedicaidCode_Text = 'Potential Medicaid code: <medicaidCode> in <state>';
        this.Spa_Profile_StateEligibilityCheck_DateReceived_Text = 'Date received:';
        this.Spa_Profile_StateEligibilityCheck_Days = 30;
        this.Spa_Profile_StateEligibilityCheck_CannotCompleteError_Text = 'Could not complete eligibility check. Please try again later.';
        this.Spa_Profile_StateEligibilityCheck_CheckedNote_Text = 'State Medicaid eligibility checked in <state> <checkedDate>';
        this.Spa_Profile_FederalEligibilityForState_Required = false;
        this.Spa_Profile_FederalEligibilityForStateRequired_Text = 'Federal eligibility is required.';
        this.Spa_Profile_StateNotEligibile_Text = 'This beneficiary’s state is not eligible for a State Medicaid level check.';
        this.Spa_MedicaidIntegrationConfig_Json = [
            { state: 'WV', integrationID: 'Humana', authenticationID: 'Humana' },
            { state: 'TX', integrationID: 'Wipro', authenticationID: 'Wipro' }
        ];
        this.Spa_Profile_NotEligible_Text = 'Not eligible';
        this.Spa_GettingStarted_ShowSubsidyAccordion_Flag = true;
        this.Spa_Site_Gender_Text = 'Gender';
        this.Spa_Profile_Gender_Enabled = false;
        this.Spa_Profile_GenderMale_Text = 'Male';
        this.Spa_Profile_GenderFemale_Text = 'Female';
        this.Spa_Profile_GenderRequired_Error = 'Please provide gender';
        this.Spa_Profile_Member_Progress_Enabled = false;
        this.Spa_Profile_Member_Progress_Visible = false;
        this.Spa_Profile_Member_Progress_Title = 'Progress Tracker';
        this.Spa_Site_TransferCode_Label_Text = 'Transfer code';
        this.Spa_Site_TransferCode_Enabled = false;
        this.Spa_Profile_Member_Progress_Event_Types = [
            {
                name: 'Profile Created',
                value: 1,
                enabled: true
            },
            {
                name: 'Providers Updated',
                value: 2,
                enabled: true
            },
            {
                name: 'Prescriptions Updated',
                value: 3,
                enabled: true
            },
            {
                name: 'Pharmacies Updated',
                value: 4,
                enabled: true
            },
            {
                name: 'Quote Sent',
                value: 5,
                enabled: true
            },
            {
                name: 'Plan in Cart',
                value: 6,
                enabled: true
            },
            {
                name: 'Send to Beneficiary',
                value: 7,
                enabled: true
            },
            {
                name: 'Enrollment Started',
                value: 8,
                enabled: true
            },
            {
                name: 'Enrollment Completed',
                value: 9,
                enabled: true
            }
        ];
        this.Spa_Site_Prescriptions_Enabled = true;
        this.Spa_Site_Pharmacy_Enabled = true;
        this.Spa_Site_Providers_Enabled = true;
        this.Spa_RetireFlo_Enabled = false;
        this.Spa_Agent_Profile_RetireFlo_SignUp_Content_Text = 'Reassign agent of record';
        this.Spa_Agent_AccountOverview_RetireFlo_SignUp_ButtonText = 'Sign Up!';
        this.Spa_Agent_Profile_RetireFlo_Header_Text = 'Agent RetireFlo';
        this.Spa_Agent_Profile_RetireFlo_SendSurvey_ButtonText = 'Agent RetireFlo';
        this.Spa_Agent_Profile_PURLToConsumerAccount_Enabled = false;
        this.Spa_Agent_Profile_PURLToConsumerAccount_ButtonText = "Copy link to beneficiary's account";
        this.Spa_Agent_Profile_PURLToConsumerAccount_ErrorText = 'You must have mobile phone number or email added before copying link';
        this.Spa_Agent_AccountOverview_CopiedInfo_Text = 'Copied';
        this.Spa_Agent_AccountOverview_Purl_Enabled = false;
        this.Spa_ConsumerSiteID_Enabled = false;
        this.Spa_Agent_Profile_PURLToConsumerAccount_RedirectPageTag = PageTags.HOME;
        this.showError = false;
        this.pageTags = PageTags;
        this.siteType = SiteType;
        this.memberEnrollments = [];
        this.valueBasedCareProviders = {};
        this.shouldUpdateTags = false;
        this.memberPhone = '';
        this.memberName = '';
        this.planTypeText = '';
        this.isAgentAdmin = false;
        this.isProfileAdmin = false;
        this.currentAgentGuid = '';
        this.agentHasRetireFlo = false;
        this.memberEmail = '';
        this.memberCellPhone = '';
        this.currentPlanYearPurl = '';
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        super.ngOnInit();
        this.fetchRetireFloStatus();
        // Need to fetch the session again with includeEnrollmentHistory = true,
        // as the member state needs to be updated if the user has navigated to SOA, since the includeEnrollmentHistory will be false
        // when fetching session in case of SOA and it will be updated to the member State without complete enrollment histories.
        const session = this.memberSessionService.getMemberSession();
        const { sessionId } = session;
        const isAdmin = this.agentPermissionService.isAdmin();
        this.isAgentAdmin = this.agentPermissionService.isAgentAdmin();
        this.isProfileAdmin = this.agentService.getIsProfileAdmin();
        const includeAgentCallHistory = isAdmin && this.agentCallRecordingFacade.isDisplayRecordingLinkEnabled();
        this.isDualPlanYearSite = this.planYearResourceService.getIsDualPlanYearSite();
        this.memberName = this.soaFacade.getMemberName();
        this.currentAgentGuid = this.agentService.getAgentInContextGuid();
        this.subscriptions.add(this.memberSessionService
            .fetchMemberSession$({
            sessionId,
            isEnrollmentHistoryIncluded: true,
            includeAgentCallHistory,
            isMemberInitialLoad: true,
            includeSOA: true,
            includeMemberProgress: this.Spa_Profile_Member_Progress_Enabled && !!this.Spa_Profile_Member_Progress_Event_Types?.length
        })
            .pipe(switchMap(() => forkJoin([
            this.agentService.fetchAgentOfRecord$(),
            this.soaFacade.fetchSOATransactions$(),
            from(this.memberSessionService.updateSelectedMemberDetails())
        ])))
            .subscribe({
            next: () => {
                this.cdr.markForCheck();
            }
        }));
        this.isRetentionMemberProfile = this.memberSessionService.isRetentionMemberFromSource();
        if (this.Spa_Profile_AgentCallRecordingShopping_DisplayRecordingLink_Enabled) {
            this.subscriptions.add(this.memberSessionService.getMemberAgentCallRecords$().subscribe((callRecordings) => {
                this.isAgentCallRecordingBoxDisplayed = this.agentPermissionService.isAgentAdmin() && callRecordings.length > 0;
                this.cdr.markForCheck();
            }));
        }
        this.memberAgentNotes$ = this.agentNoteFacade.getMemberAgentNotes$();
        this.memberAgentRetireFlos$ = this.agentRetireFloFacade.getMemberRetireFlo$();
        this.memberAgentTasks$ = this.agentTaskFacade.getMemberAgentTasks$();
        if (this.Spa_EnrollmentHistory_EnrollmentStatus_Enabled) {
            this.memberEnrollmentStatus$ = this.memberSessionService.getEnrollmentStatuses$(sessionId);
        }
        this.memberQuoteHistoryForAgent$ = this.memberSessionService.getMemberQuoteHistoryForAgent$();
        this.subscriptions.add(this.memberRegistrationFacade
            .getMemberPlanEnrollments$()
            .pipe(this.memberRegistrationFacade.mapMemberEnrollmentsWithFees(), switchMap(memberEnrollments => {
            let completedEnrollments = [];
            if (memberEnrollments) {
                completedEnrollments = this.enrollmentHistoryFacade.getCompletedEnrollments(memberEnrollments, false);
                this.memberEnrollments = this.enrollmentHistoryFacade.setCompletedMemberEnrollmentFlags(memberEnrollments, false);
                this.tagsToUpdate = this.logEnterHRAFormAvailableGoogleTag(memberEnrollments);
                this.shouldUpdateTags = true;
                this.cdr.markForCheck();
            }
            const npis = this.providerFacade.getFormattedNpisfromEnrollments(completedEnrollments);
            const isVbcProviderEnabled = this.Spa_Site_ValueBasedCare_Enabled && this.Spa_ValueBasedCare_Confirmation_Enabled && npis.length;
            return isVbcProviderEnabled
                ? this.providerFacade.getValueBasedCareProvider$(npis, this.localeService.getCurrentLocale())
                : of([]);
        }))
            .subscribe((vbcProviderList) => {
            this.valueBasedCareProviders = this.providerFacade.reformatVbcProvidersforEnrollments(vbcProviderList);
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.responsiveLayoutService.isCompact$.subscribe((isCompact) => {
            this.isMobile = isCompact;
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.memberSessionService.getMemberHasFullName$().subscribe(hasFullName => {
            this.memberHasFullName = hasFullName;
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.profileFacade.getMemberEmail$().subscribe(email => {
            this.memberEmail = email;
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.profileFacade.getMemberCellPhone$().subscribe(cellPhone => {
            this.memberCellPhone = cellPhone;
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.soaFacade.getMemberProfilePhone$().subscribe(phone => {
            this.memberPhone = phone;
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.soaFacade.getSOAActivities$(isAdmin).subscribe(activities => {
            this.soaActivity = this.soaFacade.latestStartedActivity(activities);
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.agentService.getAgentOfRecord$().subscribe((agentOfRecord) => {
            this.agentOfRecord = agentOfRecord;
            if (agentOfRecord?.loaded) {
                this.spinnerService.hide(SpinnerEvent.MEMBER_LOADING);
            }
            else {
                this.spinnerService.show(SpinnerEvent.MEMBER_LOADING);
            }
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.agentService.getAgentProgressEvents$().subscribe((memberProgressInfo) => {
            this.memberProgressInfo = memberProgressInfo;
            this.cdr.markForCheck();
        }));
        this.tagsToUpdate = this.memberProfileGoogleTag();
        this.subscriptions.add(this.agentService.getAgentHasRetireFlo$().subscribe(agentHasRetireFlo => {
            this.agentHasRetireFlo = agentHasRetireFlo;
            this.cdr.markForCheck();
        }));
    }
    get isSOAEnabled() {
        return this.Spa_Site_SOA_Enabled && this.siteService.isPPCSite(this.Spa_Site_SiteType);
    }
    filterQuickQuoteEnrollments(quoteHistory) {
        return quoteHistory ? quoteHistory.filter(quote => quote.quoteType === QuoteType.QUICKQUOTE) : [];
    }
    preProcessProperties() {
        if (this.Spa_Site_EnrollmentHistory_Enabled === null || this.Spa_Site_EnrollmentHistory_Enabled === undefined) {
            this.Spa_Site_EnrollmentHistory_Enabled = this.siteService.isPPCSite(this.Spa_Site_SiteType);
        }
        this.genderItems = [
            { display: this.Spa_Profile_GenderMale_Text, value: GenderCode.MALE },
            { display: this.Spa_Profile_GenderFemale_Text, value: GenderCode.FEMALE }
        ];
    }
    onPreviousClick() {
        this.navigationService.backToPrevious();
    }
    onViewRecording() {
        this.navigationService.navigateByPageTag(this.pageTags.MEMBER_RECORDINGS);
    }
    showAgentNoteModal() {
        this.agentNoteFacade.showAgentNoteModal();
    }
    showAgentTaskModal() {
        this.agentTaskFacade.showAgentTaskModal();
    }
    showRetireFloModal() {
        this.agentRetireFloFacade.showRetireFloModal();
    }
    changeTaskStatus(memberTaskDetails) {
        if (memberTaskDetails.status === MemberAgentTaskStatus.COMPLETE) {
            this.unCompleteTask(memberTaskDetails.memberAgentNoteID);
        }
        else {
            this.completeTask(memberTaskDetails.memberAgentNoteID);
        }
    }
    completeTask(agentNoteId) {
        const memberAgentNotes = {
            userAgentGUID: '',
            agentNoteActionType: NoteActionType.OtherTask,
            description: '',
            memberAgentNoteID: agentNoteId,
            agentName: '',
            scheduledDate: '',
            completedWhen: this.formatDate(new Date().toString()),
            createdWhen: '',
            modifiedWhen: ''
        };
        // Only 'completedWhen' value is updated by the API. All other values are just placeholders.
        // !!Note!! When the api is changed to update all values in the future,
        // the correct 'agentNoteActionType' needs to be passed back !!Note!!
        this.agentTaskFacade.updateAgentTask(memberAgentNotes);
    }
    unCompleteTask(agentNoteId) {
        const memberAgentNotes = {
            userAgentGUID: '',
            agentNoteActionType: NoteActionType.OtherTask,
            description: '',
            memberAgentNoteID: agentNoteId,
            agentName: '',
            scheduledDate: '',
            completedWhen: '',
            createdWhen: '',
            modifiedWhen: ''
        };
        // Only 'completedWhen' value is updated by the API. All other values are just placeholders.
        // !!Note!! When the api is changed to update all values in the future,
        // the correct 'agentNoteActionType' needs to be passed back !!Note!!
        this.agentTaskFacade.updateAgentTask(memberAgentNotes);
    }
    formatDate(date) {
        const format = DateUtilities.defaultDateTimeISOFormat;
        return DateUtilities.getFormattedPTDate(new Date(date), format);
    }
    navigateToPageTag(pageTag) {
        if (pageTag === PageTags.GUIDED_HELP_GETTING_STARTED) {
            this.guidedHelpService.goToFirstLink();
        }
        else {
            if (pageTag === PageTags.PLAN_LIST) {
                this.addOnViewPlansClickGoogleTag();
            }
            this.navigationService.navigateByPageTag(pageTag);
        }
    }
    async saveMemberData(tooltip) {
        return new Promise(async (resolve, reject) => {
            const result = await this.memberRegistrationComponent.saveMemberProfileExternal();
            if (result === MemberSaveExecutionResultType.SuccessfulSave || result === MemberSaveExecutionResultType.NoChangesDetected) {
                resolve(result);
            }
            else if (result === MemberSaveExecutionResultType.ValidationError) {
                reject(result);
            }
            else if (result === MemberSaveExecutionResultType.ServerError) {
                this.showError = true;
                tooltip.open();
                this.closeTooltip(TOOLTIP_TIMEOUT, tooltip);
                reject(result);
            }
        });
    }
    async saveAndNavigate(pageTag, tooltip) {
        if (this.memberRegistrationComponent) {
            this.memberRegistrationComponent.validateMemberProfile();
            this.memberRegistrationComponent.updateDemographics();
            if (this.memberRegistrationComponent.createMemberProfile.dirty) {
                await this.saveMemberData(tooltip)
                    .then(() => {
                    this.navigateToPageTag(pageTag);
                })
                    .catch(() => {
                    // can't save member data because a validation error occured on save
                });
            }
            else {
                this.navigateToPageTag(pageTag);
            }
        }
    }
    closeTooltip(wait = 0, tooltip) {
        timer(wait)
            .pipe(take(1))
            .subscribe(() => {
            this.showError = false;
            if (tooltip.isOpen()) {
                tooltip.close();
            }
        });
    }
    copyPurl() {
        if (this.currentPlanYearPurl) {
            this.accountOverviewFacade.copyPurl(this.currentPlanYearPurl);
        }
        else {
            const agentData = this.accountOverviewFacade.getAgentData();
            const accountGuid = this.profileFacade.getAccountGuid();
            const getCurrentPlanYearPurlRequest = this.accountOverviewFacade.getPurl({
                userName: agentData.userName,
                baseUrl: this.accountOverviewFacade.getSiteBaseUrl(),
                encode: true,
                ...(this.Spa_ConsumerSiteID_Enabled && { selectedStaticPurlYear: AgentStaticPurlYear.PLAN_YEAR }),
                redirectPageTag: this.Spa_Agent_Profile_PURLToConsumerAccount_RedirectPageTag,
                accountGuid
            });
            getCurrentPlanYearPurlRequest.then(currentPlanYearPurl => {
                this.currentPlanYearPurl = currentPlanYearPurl;
                this.accountOverviewFacade.copyPurl(this.currentPlanYearPurl);
                this.cdr.markForCheck();
            });
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
    addOnViewPlansClickGoogleTag() {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_ACCOUNT_VIEW_PLANS
        };
    }
    logEnterHRAFormAvailableGoogleTag(memberEnrollments) {
        return {
            [DataLayerGlobalVariable.HRA_FORM_LINK_AVAILABLE]: this.getFormLinkAvailablesTextGoogleTag(memberEnrollments)
        };
    }
    memberProfileGoogleTag() {
        return {
            [DataLayerGlobalVariable.PROFILE_PROGRESS_TRACKER_ISPRESENT]: this.Spa_Profile_Member_Progress_Enabled
                ? GOOGLE_ANALYTICS_YES
                : GOOGLE_ANALYTICS_NO
        };
    }
    getFormLinkAvailablesTextGoogleTag(memberEnrollments) {
        const enrollmentsPlanHRAType = this.getEnrollmentsPlanHRAType(memberEnrollments);
        if (!this.Spa_Site_HRA_Enabled || !enrollmentsPlanHRAType.length) {
            return 'no';
        }
        const availableFormLink = enrollmentsPlanHRAType.map(hraPlanType => hraPlanType.toLowerCase()).join('_');
        return `yes|${availableFormLink}`;
    }
    getEnrollmentsPlanHRAType(memberEnrollments) {
        return memberEnrollments
            .filter(memberEnrollment => {
            const hraDaysLeft = memberEnrollment?.hraDaysLeft || 0;
            const remainingHRADays = this.hraFormFacade.getRemainingDaysToSumbmitHRA(memberEnrollment, hraDaysLeft);
            return !!memberEnrollment.hraUserType && remainingHRADays > 0;
        })
            .map(memberEnrollment => this.getPlanHRAType(memberEnrollment));
    }
    getPlanHRAType(memberEnrollment) {
        return !!memberEnrollment?.hraExternalUrl ? PlanHRAType.EXTERNAL : PlanHRAType.INTERNAL;
    }
    fetchRetireFloStatus() {
        this.activatedRoute.queryParams.subscribe(params => {
            if (params?.checkRetireFloStatus) {
                this.agentService.fetchRetireFloStatus();
            }
        });
    }
};
AddProfileComponent.ɵfac = function AddProfileComponent_Factory(t) { return new (t || AddProfileComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(AgentNoteFacade), i0.ɵɵdirectiveInject(AgentTaskFacade), i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(MemberRegistrationFacade), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(EnrollmentHistoryFacade), i0.ɵɵdirectiveInject(i1.AgentPermissionsService), i0.ɵɵdirectiveInject(AgentCallRecordingFacade), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService), i0.ɵɵdirectiveInject(HRAFormFacade), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.PlanYearResourceService), i0.ɵɵdirectiveInject(SOAFacade), i0.ɵɵdirectiveInject(ProviderFacade), i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(AgentRetireFloFacade), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(ProfileFacade), i0.ɵɵdirectiveInject(AccountOverviewFacade)); };
AddProfileComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AddProfileComponent, selectors: [["vnext-add-profile"]], viewQuery: function AddProfileComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(MemberRegistrationComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.memberRegistrationComponent = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 41, vars: 73, consts: [["vnextGoogleTagManager", "", 1, "container", "add-profile-wrapper", 3, "saveDefaultValues", "shouldUpdateTags", "tagsToUpdate"], [1, "row"], [1, "col-12", "Spa_Style_H1", "text-center"], [4, "liveEditProp"], [1, "col-12", "mt-4"], [4, "ngIf", "ngIfElse"], ["newHeaderText", ""], [1, "col-12", "col-md-8"], [3, "profileSubHeaderLabel", "profileHomeHeaderLabel", "profileAdditionalInformationHeaderLabel", "profileSectionHeaderSalesInformationLabel", "profileIsSalesContactDifferentLabel", "profileSaveButtonLabel", "isStateEligibilityCheckEnabled", "stateEligibilityCheckDescription", "medicaidIdLabel", "stateEligibilityCheckButtonLabel", "noMedicaidIdErrorLabel", "eligibilityCheckPendingLabel", "eligibilityCheckPendingDescriptionLabel", "noZipCodeText", "medicaidCodeText", "medicaidCheckDateReceivedText", "medicaidCheckDays", "medicaidCheckCannotCompleteErrorText", "medicaidCheckedNoteText", "isFederalEligibilityForStateRequired", "federalEligibilityForStateRequiredText", "stateNotEligibleText", "medicaidIntegrationConfig", "notEligibleText", "showSubsidyAccordionOnProfile", "optionalLabel", "genderEnabled", "genderItems", "genderLabel", "genderRequiredErrorText"], [3, "memberQuoteHistoryHeaderText", "memberQuoteHistoryNoQuotesMessageText", "memberQuoteHistoryQuoteSentText", "memberQuoteHistoryAuthorizationEmailBodyText", "memberQuoteHistory", "deliveryMethodPrefix", "deliveryMethodSeparator", "planTypeHeader", "requestedEffectiveDateHeader", "pacificTimePostFix", "displayQuoteSentInformation", "displayPlanType", "displayRequestedEffectiveDate", "displayAuthCode", "displayPersonalizedMessage", "displayAgentFullName", "displayAgentUserName", "memberQuoteHistoryPlanNameEnabled", "memberQuoteHistoryCarrierNameEnabled", "showPlanYearBadge", "sendQuoteAgentOfRecordEnabled", "currentAgentGuid", 4, "ngIf"], [3, "memberEnrollments", "memberQuoteHistory", "memberEnrollmentHistoryHeaderText", "noEnrollmentMessageText", "pacificStandardTimeText", "memberEnrollmentHistoryEffectiveDateText", "totalMonthlyPremiumLabel", "viewApplicationLinkText", "confirmationText", "submittedDateText", "lastUpdatedText", "confirmationNumberEnabled", "planNameEnabled", "effectiveDateEnabled", "totalMonthlyPremiumEnabled", "submissionDateEnabled", "updatedDateEnabled", "ridersEnabled", "continueEnrollmentButtonText", "hraPDFLinkText", "hraConfirmationText", "hraConfirmationNumberEnabled", "displayPlanAllowsCallRecordingIconEnabled", "planAllowsCallRecordingText", "agentCallInProgressAcceptCallIcon", "isHRAEnabled", "completeHRAButtonEnabled", "openExternalInNewTab", "completeHRAButtonText", "completeHRALastVisitedText", "completeHRADaysLeftText", "isMobile", "showPlanYearBadge", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "memberEnrollmentStatus", "enrollmentStatusEnabled", "statusDateText", "statusText", "defaultStatusText", "enrollmentHistoryProfileLinkEnabled", "enrollmentHistoryLinkText", "enrollmentStatusHeaderText", "enrollmentMoreDetailsText", "enrollmentHraHeaderText", "enrollmentConfirmationHeaderText", "memberEnrollmentEffectiveDateHeaderText", "riderHeaderText", "callRecordingHeaderText", "uploadDocumentHeaderText", "partialEnrollmentDisabledText", "valueBasedCareConfirmationEnabled", "valueBasedCareConfirmationText", "valueBasedCareProviders", "isEnrollmentContinueButtonEnabled", "partialEnrollmentAllowedDate", "enrollerButtonTooltipText", "valueBasedCareConfirmationExpiration", "isHRAPDFAccessEnabled", "isProfileAdmin", "isCompleteHRAProfileAdminEnabled", "excludedCarrierIds", 4, "ngIf"], [1, "col-md-12", "col-lg-9", "shorter-width", "shorter-width", 3, "providedPrevious", "showPrevious"], ["previous-link", "", 1, "d-flex", "justify-content-between"], ["class", "pr-2", 3, "title", "showArrow", "makeInlineBlock", "click", 4, "liveEditProp"], [4, "ngIf"], ["continue-button", ""], ["class", "btn Spa_Style_SecondaryButton col-xs-12 col-md-auto mr-md-2 mb-md-0 mb-2", "triggers", "manual", 3, "ngbTooltip", "click", "keyup.enter", 4, "ngIf"], ["class", "btn Spa_Style_PrimaryButton col-xs-12 col-md-auto", "triggers", "manual", 3, "ngbTooltip", "click", "keyup.enter", 4, "liveEditProp"], ["errorTooltip", ""], [1, "member-sidebar", "col-12", "col-md-4"], [3, "purlToConsumerAccountButtonText", "purlToConsumerAccountErrorText", "copiedInfoText", "memberEmail", "memberCellPhone", "onCopyClick", 4, "ngIf"], [3, "agentOfRecord", "agentOfRecordHeaderLabel", "agentOfRecordReassignText", "agentOfRecordUnassignedText", "isAgentAdmin", "isProfileAdmin", 4, "ngIf"], [3, "agentHasRetireFlo", "agentRetireFloHeaderLabel", "agentRetireFloSignUpContentText", "agentRetireFloSignUpButtonText", "agentRetireFloSendServeyButtonText", "memberAgentNotes", "openSendRetireFloModal", 4, "ngIf"], [3, "isMemberProgressVisible", "memberProgressTitle", "progressEvent", "memberProgressInfo", "transferCodeLabelText", "isTransferCodeEnabled", "isProfilePage", "prescriptionsEnabled", "pharmacyEnabled", "providersEnabled", "redirectRouteEvent", 4, "ngIf"], [3, "agentSOAHeader", "agentSOAEmptyText", "soaActivity", "memberName", "memberPhone"], [3, "agentNoteHeader", "agentNoteEmptyNoteText", "agentNoteAddNoteLink", "agentNoteCreatedLabel", "agentNoteAgentNamePreFixLabel", "memberAgentNotes", "openNoteModal"], [3, "agentTaskHeader", "agentTaskEmptyTaskText", "agentTaskAddTaskLink", "agentTaskAgentNamePreFixLabel", "agentTaskDueLabel", "agentTaskCompleteLabel", "memberAgentTasks", "openTaskModal", "onTaskStatusChanged"], [3, "retentionSummaryHeaderText", "retentionSummaryBodyText", "retentionSummaryLinkText", 4, "ngIf"], [3, "agentCallRecordingShoppingHeaderText", "agentCallRecordingShoppingSectionText", "agentCallRecordingShoppingLinkText", "viewRecording", 4, "ngIf"], ["navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["navigationAdapter", "", 3, "innerHtml"], [3, "memberQuoteHistoryHeaderText", "memberQuoteHistoryNoQuotesMessageText", "memberQuoteHistoryQuoteSentText", "memberQuoteHistoryAuthorizationEmailBodyText", "memberQuoteHistory", "deliveryMethodPrefix", "deliveryMethodSeparator", "planTypeHeader", "requestedEffectiveDateHeader", "pacificTimePostFix", "displayQuoteSentInformation", "displayPlanType", "displayRequestedEffectiveDate", "displayAuthCode", "displayPersonalizedMessage", "displayAgentFullName", "displayAgentUserName", "memberQuoteHistoryPlanNameEnabled", "memberQuoteHistoryCarrierNameEnabled", "showPlanYearBadge", "sendQuoteAgentOfRecordEnabled", "currentAgentGuid"], [3, "memberEnrollments", "memberQuoteHistory", "memberEnrollmentHistoryHeaderText", "noEnrollmentMessageText", "pacificStandardTimeText", "memberEnrollmentHistoryEffectiveDateText", "totalMonthlyPremiumLabel", "viewApplicationLinkText", "confirmationText", "submittedDateText", "lastUpdatedText", "confirmationNumberEnabled", "planNameEnabled", "effectiveDateEnabled", "totalMonthlyPremiumEnabled", "submissionDateEnabled", "updatedDateEnabled", "ridersEnabled", "continueEnrollmentButtonText", "hraPDFLinkText", "hraConfirmationText", "hraConfirmationNumberEnabled", "displayPlanAllowsCallRecordingIconEnabled", "planAllowsCallRecordingText", "agentCallInProgressAcceptCallIcon", "isHRAEnabled", "completeHRAButtonEnabled", "openExternalInNewTab", "completeHRAButtonText", "completeHRALastVisitedText", "completeHRADaysLeftText", "isMobile", "showPlanYearBadge", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "memberEnrollmentStatus", "enrollmentStatusEnabled", "statusDateText", "statusText", "defaultStatusText", "enrollmentHistoryProfileLinkEnabled", "enrollmentHistoryLinkText", "enrollmentStatusHeaderText", "enrollmentMoreDetailsText", "enrollmentHraHeaderText", "enrollmentConfirmationHeaderText", "memberEnrollmentEffectiveDateHeaderText", "riderHeaderText", "callRecordingHeaderText", "uploadDocumentHeaderText", "partialEnrollmentDisabledText", "valueBasedCareConfirmationEnabled", "valueBasedCareConfirmationText", "valueBasedCareProviders", "isEnrollmentContinueButtonEnabled", "partialEnrollmentAllowedDate", "enrollerButtonTooltipText", "valueBasedCareConfirmationExpiration", "isHRAPDFAccessEnabled", "isProfileAdmin", "isCompleteHRAProfileAdminEnabled", "excludedCarrierIds"], [1, "pr-2", 3, "title", "showArrow", "makeInlineBlock", "click"], ["class", "pr-2", "triggers", "manual", 3, "title", "showArrow", "makeInlineBlock", "ngbTooltip", "click", "keyup.enter", 4, "liveEditProp"], ["triggers", "manual", 1, "pr-2", 3, "title", "showArrow", "makeInlineBlock", "ngbTooltip", "click", "keyup.enter"], ["preferencesTooltipController", "ngbTooltip"], ["class", "pr-3", "triggers", "manual", 3, "title", "showArrow", "makeInlineBlock", "ngbTooltip", "click", "keyup.enter", 4, "liveEditProp"], ["triggers", "manual", 1, "pr-3", 3, "title", "showArrow", "makeInlineBlock", "ngbTooltip", "click", "keyup.enter"], ["triggers", "manual", 1, "btn", "Spa_Style_SecondaryButton", "col-xs-12", "col-md-auto", "mr-md-2", "mb-md-0", "mb-2", 3, "ngbTooltip", "click", "keyup.enter"], ["soaTooltipController", "ngbTooltip"], ["triggers", "manual", 1, "btn", "Spa_Style_PrimaryButton", "col-xs-12", "col-md-auto", 3, "ngbTooltip", "click", "keyup.enter"], ["planListTooltipController", "ngbTooltip"], ["class", "text-center", 3, "ngClass", 4, "ngIf"], [1, "text-center", 3, "ngClass"], ["aria-hidden", "true", 1, "fas", 3, "ngClass"], [3, "purlToConsumerAccountButtonText", "purlToConsumerAccountErrorText", "copiedInfoText", "memberEmail", "memberCellPhone", "onCopyClick"], [3, "agentOfRecord", "agentOfRecordHeaderLabel", "agentOfRecordReassignText", "agentOfRecordUnassignedText", "isAgentAdmin", "isProfileAdmin"], [3, "agentHasRetireFlo", "agentRetireFloHeaderLabel", "agentRetireFloSignUpContentText", "agentRetireFloSignUpButtonText", "agentRetireFloSendServeyButtonText", "memberAgentNotes", "openSendRetireFloModal"], [3, "isMemberProgressVisible", "memberProgressTitle", "progressEvent", "memberProgressInfo", "transferCodeLabelText", "isTransferCodeEnabled", "isProfilePage", "prescriptionsEnabled", "pharmacyEnabled", "providersEnabled", "redirectRouteEvent"], [3, "retentionSummaryHeaderText", "retentionSummaryBodyText", "retentionSummaryLinkText"], [3, "agentCallRecordingShoppingHeaderText", "agentCallRecordingShoppingSectionText", "agentCallRecordingShoppingLinkText", "viewRecording"]], template: function AddProfileComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, AddProfileComponent_span_3_Template, 2, 1, "span", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtemplate(5, AddProfileComponent_ng_container_5_Template, 2, 1, "ng-container", 5);
        i0.ɵɵtemplate(6, AddProfileComponent_ng_template_6_Template, 2, 4, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "div", 1)(9, "div", 7);
        i0.ɵɵelement(10, "vnext-member-registration", 8);
        i0.ɵɵtemplate(11, AddProfileComponent_vnext_member_quote_history_11_Template, 2, 24, "vnext-member-quote-history", 9);
        i0.ɵɵtemplate(12, AddProfileComponent_vnext_member_enrollment_history_12_Template, 3, 68, "vnext-member-enrollment-history", 10);
        i0.ɵɵelementStart(13, "vnext-navigation-banner", 11)(14, "div", 12);
        i0.ɵɵtemplate(15, AddProfileComponent_vnext_link_15_Template, 1, 3, "vnext-link", 13);
        i0.ɵɵtemplate(16, AddProfileComponent_ng_container_16_Template, 2, 1, "ng-container", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 15);
        i0.ɵɵtemplate(18, AddProfileComponent_ng_container_18_Template, 2, 1, "ng-container", 14);
        i0.ɵɵtemplate(19, AddProfileComponent_button_19_Template, 3, 2, "button", 16);
        i0.ɵɵtemplate(20, AddProfileComponent_button_20_Template, 3, 2, "button", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(21, AddProfileComponent_ng_template_21_Template, 1, 1, "ng-template", null, 18, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(23, "div", 19);
        i0.ɵɵtemplate(24, AddProfileComponent_vnext_copy_purl_plus_24_Template, 1, 5, "vnext-copy-purl-plus", 20);
        i0.ɵɵtemplate(25, AddProfileComponent_vnext_agent_of_record_25_Template, 1, 6, "vnext-agent-of-record", 21);
        i0.ɵɵtemplate(26, AddProfileComponent_vnext_agent_retire_flo_26_Template, 2, 8, "vnext-agent-retire-flo", 22);
        i0.ɵɵtemplate(27, AddProfileComponent_vnext_agent_progress_tracker_27_Template, 1, 10, "vnext-agent-progress-tracker", 23);
        i0.ɵɵelement(28, "vnext-agent-soa", 24);
        i0.ɵɵelementStart(29, "vnext-agent-note", 25);
        i0.ɵɵlistener("openNoteModal", function AddProfileComponent_Template_vnext_agent_note_openNoteModal_29_listener() { return ctx.showAgentNoteModal(); });
        i0.ɵɵpipe(30, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(31, "br")(32, "br");
        i0.ɵɵelementStart(33, "vnext-agent-task", 26);
        i0.ɵɵlistener("openTaskModal", function AddProfileComponent_Template_vnext_agent_task_openTaskModal_33_listener() { return ctx.showAgentTaskModal(); })("onTaskStatusChanged", function AddProfileComponent_Template_vnext_agent_task_onTaskStatusChanged_33_listener($event) { return ctx.changeTaskStatus($event); });
        i0.ɵɵpipe(34, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(35, "br")(36, "br");
        i0.ɵɵtemplate(37, AddProfileComponent_vnext_member_profile_retention_summary_37_Template, 1, 3, "vnext-member-profile-retention-summary", 27);
        i0.ɵɵelement(38, "br")(39, "br");
        i0.ɵɵtemplate(40, AddProfileComponent_vnext_agent_call_recording_shopping_box_40_Template, 1, 3, "vnext-agent-call-recording-shopping-box", 28);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(7);
        i0.ɵɵproperty("saveDefaultValues", true)("shouldUpdateTags", ctx.shouldUpdateTags)("tagsToUpdate", ctx.tagsToUpdate);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "Spa_AddProfile_Title");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.memberHasFullName)("ngIfElse", _r2);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("profileSubHeaderLabel", ctx.SPA_Member_Profile_Sub_Header_Label)("profileHomeHeaderLabel", ctx.SPA_Member_Profile_Home_Header_Label)("profileAdditionalInformationHeaderLabel", ctx.SPA_Member_Profile_Additional_Information_Header_Label)("profileSectionHeaderSalesInformationLabel", ctx.SPA_Member_Profile_SectionHeader_Sales_Information_Label)("profileIsSalesContactDifferentLabel", ctx.SPA_Member_Profile_Is_Sales_Contact_Different_Label)("profileSaveButtonLabel", ctx.Spa_Member_Profile_Save_Button_Label)("isStateEligibilityCheckEnabled", ctx.Spa_Profile_StateEligibilityCheck_Enabled)("stateEligibilityCheckDescription", ctx.Spa_Profile_StateEligibilityCheck_Description)("medicaidIdLabel", ctx.Spa_Profile_StateEligibilityCheck_MedicaidID)("stateEligibilityCheckButtonLabel", ctx.Spa_Profile_StateEligibilityCheck_ButtonText)("noMedicaidIdErrorLabel", ctx.Spa_Profile_StateEligibilityCheck_NoMedicaidID_Text)("eligibilityCheckPendingLabel", ctx.Spa_Profile_StateEligibilityCheck_Pending_Text)("eligibilityCheckPendingDescriptionLabel", ctx.Spa_Profile_StateEligibilityCheck_Pending_DescriptionText)("noZipCodeText", ctx.Spa_Profile_StateEligibilityCheck_NoZip_Text)("medicaidCodeText", ctx.Spa_Profile_StateEligibilityCheck_MedicaidCode_Text)("medicaidCheckDateReceivedText", ctx.Spa_Profile_StateEligibilityCheck_DateReceived_Text)("medicaidCheckDays", ctx.Spa_Profile_StateEligibilityCheck_Days)("medicaidCheckCannotCompleteErrorText", ctx.Spa_Profile_StateEligibilityCheck_CannotCompleteError_Text)("medicaidCheckedNoteText", ctx.Spa_Profile_StateEligibilityCheck_CheckedNote_Text)("isFederalEligibilityForStateRequired", ctx.Spa_Profile_FederalEligibilityForState_Required)("federalEligibilityForStateRequiredText", ctx.Spa_Profile_FederalEligibilityForStateRequired_Text)("stateNotEligibleText", ctx.Spa_Profile_StateNotEligibile_Text)("medicaidIntegrationConfig", ctx.Spa_MedicaidIntegrationConfig_Json)("notEligibleText", ctx.Spa_Profile_NotEligible_Text)("showSubsidyAccordionOnProfile", ctx.Spa_GettingStarted_ShowSubsidyAccordion_Flag)("optionalLabel", ctx.Spa_GuidedHelp_OptionalLabel_Text)("genderEnabled", ctx.Spa_Profile_Gender_Enabled)("genderItems", ctx.genderItems)("genderLabel", ctx.Spa_Site_Gender_Text)("genderRequiredErrorText", ctx.Spa_Profile_GenderRequired_Error);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Site_AddToQuote_Enabled && ctx.memberHasFullName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Site_EnrollmentHistory_Enabled && ctx.memberHasFullName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("providedPrevious", true)("showPrevious", true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_Previous");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isMobile);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isMobile);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSOAEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_ContinueToPlanList");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.Spa_Agent_Profile_PURLToConsumerAccount_Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_MemberProfile_AgentofRecordDisplay_Enabled && ctx.memberHasFullName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_RetireFlo_Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Profile_Member_Progress_Enabled && ctx.Spa_Profile_Member_Progress_Visible || ctx.Spa_Site_TransferCode_Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("agentSOAHeader", ctx.Spa_AddProfile_AgentSOA_Header_Label)("agentSOAEmptyText", ctx.Spa_AddProfile_AgentSOA_Empty_Text)("soaActivity", ctx.soaActivity)("memberName", ctx.memberName)("memberPhone", ctx.memberPhone);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("agentNoteHeader", ctx.Spa_AddProfile_AgentNote_Header_Label)("agentNoteEmptyNoteText", ctx.Spa_AddProfile_AgentNote_EmptyNote_Text)("agentNoteAddNoteLink", ctx.Spa_AddProfile_AgentNote_AddNoteLink_Text)("agentNoteCreatedLabel", ctx.Spa_AddProfile_AgentNote_Created_Label)("agentNoteAgentNamePreFixLabel", ctx.Spa_AddProfile_AgentNote_AgentName_Prefix)("memberAgentNotes", i0.ɵɵpipeBind1(30, 69, ctx.memberAgentNotes$));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("agentTaskHeader", ctx.Spa_AddProfile_AgentTask_Header_Label)("agentTaskEmptyTaskText", ctx.Spa_AddProfile_AgentTask_EmptyTask_Text)("agentTaskAddTaskLink", ctx.Spa_AddProfile_AgentTask_AddTaskLink_Text)("agentTaskAgentNamePreFixLabel", ctx.Spa_AddProfile_AgentTask_AgentName_Prefix)("agentTaskDueLabel", ctx.Spa_AddProfile_AgentNote_Due_Label)("agentTaskCompleteLabel", ctx.Spa_AddProfile_AgentNote_Completed_Label)("memberAgentTasks", i0.ɵɵpipeBind1(34, 71, ctx.memberAgentTasks$));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.Spa_RetentionSummary_Profile_Enabled && ctx.isRetentionMemberProfile && ctx.memberHasFullName);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isAgentCallRecordingBoxDisplayed);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, NavigationBannerComponent, LinkComponent, AgentCallRecordingShoppingBoxComponent, NavigationAdapterDirective, LiveEditPropDirective, GoogleTagManagerDirective, IconAriaAttributesDirective, i1$1.NgbTooltip, MemberRegistrationComponent, MemberQuoteHistoryComponent, MemberEnrollmentHistoryComponent, MemberProfileRetentionSummaryComponent, AgentNoteComponent, AgentSOAComponent, AgentOfRecordComponent, CopyPurlPlusComponent, AgentTaskComponent, AgentProgressTrackerComponent, AgentRetireFloComponent, i1$2.AsyncPipe, SafePipe], styles: [".add-profile-wrapper[_ngcontent-%COMP%]{margin:20px auto}.shorter-width[_ngcontent-%COMP%]{padding-left:41px;padding-right:41px}.error[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent2)}@media print{.member-sidebar[_ngcontent-%COMP%]{overflow-x:hidden}}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_SOA_Enabled", void 0);
__decorate([
    GlobalResource(true)
], AddProfileComponent.prototype, "Spa_Site_SiteType", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_AddToQuote_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_SendEnrollment_TextMessage_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Quote_CreateProfile_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_SendEnrollment_Prompt", void 0);
__decorate([
    PlatformProp('live-edit')
], AddProfileComponent.prototype, "Spa_Site_TotalMonthlyPremiumLabel", void 0);
__decorate([
    GlobalResource(true)
], AddProfileComponent.prototype, "Spa_Site_EnrollmentHistory_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AddProfile_AgentNote_Header_Label", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AddProfile_AgentNote_EmptyNote_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AddProfile_AgentNote_AddNoteLink_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AddProfile_AgentNote_Created_Label", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AddProfile_AgentNote_AgentName_Prefix", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AddProfile_AgentTask_Header_Label", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AddProfile_AgentTask_EmptyTask_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AddProfile_AgentTask_AddTaskLink_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AddProfile_AgentTask_AgentName_Prefix", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AddProfile_AgentNote_Due_Label", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AddProfile_AgentNote_Completed_Label", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AddProfile_MemberCreate_Error_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AddProfile_AgentSOA_Header_Label", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AddProfile_AgentSOA_Empty_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_MemberQuoteHistory_QuoteSentText", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_SentQuote_AuthorizationEmail_Body", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_MemberQuoteHistory_DeliveryMethod_Prefix", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_MemberQuoteHistory_DeliveryMethod_Separator", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_Address1_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_Address_Required", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_Address2_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_City_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_City_Required", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_CRM_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_CRM_Label", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_CRM_Required", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_CustomField1_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_CustomField1_Label", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_CustomField2_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_CustomField2_Label", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_CustomField3_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_CustomField3_Label", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_CustomField4_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_CustomField4_Label", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_CustomField5_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_CustomField5_Label", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_DateOfBirth_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_DateOfBirth_Required", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_Email_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_Email_Required", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_PhoneNumber_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_PhoneNumber_Required", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_Relationship_Required", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_Relationship_Label", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_RepAddress1_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_RepAddress2_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_RepAddress_Required", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_RepCity_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_RepCity_Required", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_RepEmail_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_RepEmail_Required", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_RepFirstName_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_RepFirstName_Required", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_RepLastName_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_RepLastName_Required", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_RepPhoneNumber_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_RepPhoneNumber_Required", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_Relationship_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_RepState_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_RepState_Required", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_RepZipCode_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_RepZipCode_Required", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_State_Display", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Member_Profile_State_Required", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_PlanType_Header", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_MemberQuoteHistory_DisplayQuoteSentInformation", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_MemberQuoteHistory_DisplayPlanType", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_MemberQuoteHistory_DisplayRequestedEffectiveDate", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_MemberQuoteHistory_DisplayAuthCode", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_MemberQuoteHistory_DisplayPersonalizedMessage", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_MemberQuoteHistory_DisplayAgentFullName", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_MemberQuoteHistory_DisplayAgentUserName", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AgentTask_AddFollowUp_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AgentTask_FollowUp_CreateTask_Header_Label", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AgentTask_FollowUp_Quote_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AgentTask_FollowUp_Enrollment_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AgentTask_FollowUp_SOA_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AgentTask_FollowUp_TaskCreated_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AgentTask_DueDate_Label", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AgentTask_Task_Label", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AgentTask_Save_Button", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AgentTask_ContentErrorText", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AgentTask_DateErrorText", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AgentTask_DateInvalidText", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AgentTask_PastDateInvalidText", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AgentTask_FollowUp_BlueButton_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AgentTask_FollowUp_BlueButton_Title", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_MemberQuoteHistory_DisplayPlanName", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_MemberQuoteHistory_DisplayCarrierName", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_AgentCallRecording_DisplayPlanAllowsCallRecordingIcon_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_AgentCallRecording_PlanAllowsCallRecording_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AgentCallInProgressAcceptCall_Icon", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_RetentionSummary_Profile_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_RetentionSummary_Profile_Header", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_RetentionSummary_Profile_Body", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_RetentionSummary_Profile_Link", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_ValueBasedCare_Confirmation_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_ValueBasedCare_ConfirmationExpirationDays_Count", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_ValueBasedCare_HeaderText", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_ValueBasedCare_Enabled", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_ConfirmationNumber_Enabled", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_PlanName_Enabled", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_EffectiveDate_Enabled", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_TotalMonthlyPremium_Enabled", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_SubmissionDate_Enabled", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_Riders_Enabled", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_UpdatedDate_Enabled", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_RequestedEffectiveDate_Text", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_Confirmation_Text", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_SubmittedDate_Text", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_Pacific_StandardTime_Text", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_UpdatedDate_Text", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_ContinueEnrollment_ButtonText", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_Site_ViewApplication_Link_Text", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_SendEnrollment_Email_Enabled", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_SendEnrollment_EnrollForm_Button_Text", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_SendEnrollment_Continue", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_SendEnrollment_Title", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "SPA_EnrollmentHistory_HRALink_Text", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_hraConfirmation_Text", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_hraConfirmation_Enabled", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_EditProfile_AccessHRAPDF_Enabled", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_EditProfile_CompleteHRAProfileAdmin_Enabled", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_HRA_ExcludedCarriers", void 0);
__decorate([
    PlatformProp('live-edit')
], AddProfileComponent.prototype, "Spa_MemberQuoteHistory_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AddProfileComponent.prototype, "Spa_MemberQuoteHistory_NoQuotesMessageText", void 0);
__decorate([
    PlatformProp('live-edit')
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_NoEnrollmentMessageText", void 0);
__decorate([
    PlatformProp('live-edit')
], AddProfileComponent.prototype, "SPA_Member_Profile_Sub_Header_Label", void 0);
__decorate([
    PlatformProp('live-edit')
], AddProfileComponent.prototype, "SPA_Member_Profile_Home_Header_Label", void 0);
__decorate([
    PlatformProp('live-edit')
], AddProfileComponent.prototype, "SPA_Member_Profile_Additional_Information_Header_Label", void 0);
__decorate([
    PlatformProp('live-edit')
], AddProfileComponent.prototype, "SPA_Member_Profile_SectionHeader_Sales_Information_Label", void 0);
__decorate([
    PlatformProp('live-edit')
], AddProfileComponent.prototype, "Spa_Member_Profile_Save_Button_Label", void 0);
__decorate([
    PlatformProp('live-edit')
], AddProfileComponent.prototype, "SPA_Member_Profile_Is_Sales_Contact_Different_Label", void 0);
__decorate([
    PlatformProp('live-edit')
], AddProfileComponent.prototype, "Spa_AddProfile_Title", void 0);
__decorate([
    PlatformProp('live-edit')
], AddProfileComponent.prototype, "Spa_Site_Previous", void 0);
__decorate([
    PlatformProp('live-edit')
], AddProfileComponent.prototype, "Spa_Site_ContinueToSOA", void 0);
__decorate([
    PlatformProp('live-edit')
], AddProfileComponent.prototype, "Spa_Site_ContinueToPlanList", void 0);
__decorate([
    PlatformProp('live-edit')
], AddProfileComponent.prototype, "Spa_Site_AddPreferences", void 0);
__decorate([
    PlatformProp()
], AddProfileComponent.prototype, "Spa_NewProfile_PageSubHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AddProfileComponent.prototype, "Spa_EditProfile_PageSubHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], AddProfileComponent.prototype, "Spa_GuidedHelp_OptionalLabel_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_CompleteHRA_Button_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_EnrollmentConfirmation_OpenExternalHRAInNewTab_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_CompleteHRA_Button_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_CompleteHRA_LastVisited_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_CompleteHRA_DaysLeft_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_Cancel", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_Continue", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_EnrollmentConfirmation_ExternalHRATitle_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_EnrollmentConfirmation_ExternalHRABody_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_HRA_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_AgentCallRecordingShopping_DisplayRecordingLink_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_AgentCallRecordingShopping_ProfileBox_Header_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_AgentCallRecordingShopping_ProfileBox_Section_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_AgentCallRecordingShopping_ProfileBox_Link_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_ShowPlanYearBadge_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_MemberQuoteHistory_ShowPlanYearBadge_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_PartialEnrollment_Allowed_Date", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_EnrollmentHistory_ContinueButton_Alternate_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_PlanFees_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_PlanFees_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_PlanFees_IncludedInPremium_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_EnrollmentStatus_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_EnrollmentStatus_Label_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_EnrollmentStatus_Date_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_EnrollmentStatus_Default", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_EnrollmentHistory_ProfileLink_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Enrollment_History_Link_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_EnrollmentHistory_MoreDetailsText", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_EnrollmentStatus_HeaderText", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_HealthRiskAssessment_HeaderText", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_Confirmation_HeaderText", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_RequestedEffectiveDate_HeaderText", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_Riders_HeaderText", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_CallRecordings_HeaderText", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_UploadedDocuments_HeaderText", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_EnrollmentHistory_PartialEnrollmentContinueButton_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_MemberProfile_AgentofRecordDisplay_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AgentOfRecord_ModalHeader_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_Unassigned_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_AddProfile_AssignedAgent_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_EnrollerButton_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_SendQuote_AgentOfRecord_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_StateEligibilityCheck_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_StateEligibilityCheck_Description", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_StateEligibilityCheck_MedicaidID", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_StateEligibilityCheck_ButtonText", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_StateEligibilityCheck_NoMedicaidID_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_StateEligibilityCheck_Pending_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_StateEligibilityCheck_Pending_DescriptionText", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_StateEligibilityCheck_NoZip_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_StateEligibilityCheck_MedicaidCode_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_StateEligibilityCheck_DateReceived_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_StateEligibilityCheck_Days", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_StateEligibilityCheck_CannotCompleteError_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_StateEligibilityCheck_CheckedNote_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_FederalEligibilityForState_Required", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_FederalEligibilityForStateRequired_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_StateNotEligibile_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_MedicaidIntegrationConfig_Json", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_NotEligible_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_GettingStarted_ShowSubsidyAccordion_Flag", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_Gender_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_Gender_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_GenderMale_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_GenderFemale_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_GenderRequired_Error", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_Member_Progress_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_Member_Progress_Visible", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_Member_Progress_Title", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_TransferCode_Label_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_TransferCode_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Profile_Member_Progress_Event_Types", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_Prescriptions_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_Pharmacy_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Site_Providers_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_RetireFlo_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Agent_Profile_RetireFlo_SignUp_Content_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Agent_AccountOverview_RetireFlo_SignUp_ButtonText", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Agent_Profile_RetireFlo_Header_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Agent_Profile_RetireFlo_SendSurvey_ButtonText", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Agent_Profile_PURLToConsumerAccount_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Agent_Profile_PURLToConsumerAccount_ButtonText", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Agent_Profile_PURLToConsumerAccount_ErrorText", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Agent_AccountOverview_CopiedInfo_Text", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Agent_AccountOverview_Purl_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_ConsumerSiteID_Enabled", void 0);
__decorate([
    GlobalResource()
], AddProfileComponent.prototype, "Spa_Agent_Profile_PURLToConsumerAccount_RedirectPageTag", void 0);
__decorate([
    LiveEditInactive()
], AddProfileComponent.prototype, "onPreviousClick", null);
__decorate([
    LiveEditInactive()
], AddProfileComponent.prototype, "saveAndNavigate", null);
__decorate([
    Memoize()
], AddProfileComponent.prototype, "getEnrollmentsPlanHRAType", null);
__decorate([
    Memoize()
], AddProfileComponent.prototype, "getPlanHRAType", null);
AddProfileComponent = __decorate([
    PlatformWidget
], AddProfileComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddProfileComponent, [{
        type: Component,
        args: [{ selector: 'vnext-add-profile', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div\r\n  class=\"container add-profile-wrapper\"\r\n  vnextGoogleTagManager\r\n  [saveDefaultValues]=\"true\"\r\n  [shouldUpdateTags]=\"shouldUpdateTags\"\r\n  [tagsToUpdate]=\"tagsToUpdate\"\r\n>\r\n  <div class=\"row\">\r\n    <div class=\"col-12 Spa_Style_H1 text-center\">\r\n      <span *liveEditProp=\"'Spa_AddProfile_Title'\">{{ Spa_AddProfile_Title }}</span>\r\n    </div>\r\n    <div class=\"col-12 mt-4\">\r\n      <ng-container *ngIf=\"memberHasFullName; else newHeaderText\">\r\n        <div\r\n          *liveEditProp=\"'Spa_EditProfile_PageSubHeader_Text'\"\r\n          [innerHtml]=\"Spa_EditProfile_PageSubHeader_Text ? (Spa_EditProfile_PageSubHeader_Text | safe : 'html') : ''\"\r\n          navigationAdapter\r\n        ></div>\r\n      </ng-container>\r\n      <ng-template #newHeaderText>\r\n        <div [innerHtml]=\"Spa_NewProfile_PageSubHeader_Text | safe : 'html'\" navigationAdapter></div>\r\n      </ng-template>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-12 col-md-8\">\r\n      <vnext-member-registration\r\n        [profileSubHeaderLabel]=\"SPA_Member_Profile_Sub_Header_Label\"\r\n        [profileHomeHeaderLabel]=\"SPA_Member_Profile_Home_Header_Label\"\r\n        [profileAdditionalInformationHeaderLabel]=\"SPA_Member_Profile_Additional_Information_Header_Label\"\r\n        [profileSectionHeaderSalesInformationLabel]=\"SPA_Member_Profile_SectionHeader_Sales_Information_Label\"\r\n        [profileIsSalesContactDifferentLabel]=\"SPA_Member_Profile_Is_Sales_Contact_Different_Label\"\r\n        [profileSaveButtonLabel]=\"Spa_Member_Profile_Save_Button_Label\"\r\n        [isStateEligibilityCheckEnabled]=\"Spa_Profile_StateEligibilityCheck_Enabled\"\r\n        [stateEligibilityCheckDescription]=\"Spa_Profile_StateEligibilityCheck_Description\"\r\n        [medicaidIdLabel]=\"Spa_Profile_StateEligibilityCheck_MedicaidID\"\r\n        [stateEligibilityCheckButtonLabel]=\"Spa_Profile_StateEligibilityCheck_ButtonText\"\r\n        [noMedicaidIdErrorLabel]=\"Spa_Profile_StateEligibilityCheck_NoMedicaidID_Text\"\r\n        [eligibilityCheckPendingLabel]=\"Spa_Profile_StateEligibilityCheck_Pending_Text\"\r\n        [eligibilityCheckPendingDescriptionLabel]=\"Spa_Profile_StateEligibilityCheck_Pending_DescriptionText\"\r\n        [noZipCodeText]=\"Spa_Profile_StateEligibilityCheck_NoZip_Text\"\r\n        [medicaidCodeText]=\"Spa_Profile_StateEligibilityCheck_MedicaidCode_Text\"\r\n        [medicaidCheckDateReceivedText]=\"Spa_Profile_StateEligibilityCheck_DateReceived_Text\"\r\n        [medicaidCheckDays]=\"Spa_Profile_StateEligibilityCheck_Days\"\r\n        [medicaidCheckCannotCompleteErrorText]=\"Spa_Profile_StateEligibilityCheck_CannotCompleteError_Text\"\r\n        [medicaidCheckedNoteText]=\"Spa_Profile_StateEligibilityCheck_CheckedNote_Text\"\r\n        [isFederalEligibilityForStateRequired]=\"Spa_Profile_FederalEligibilityForState_Required\"\r\n        [federalEligibilityForStateRequiredText]=\"Spa_Profile_FederalEligibilityForStateRequired_Text\"\r\n        [stateNotEligibleText]=\"Spa_Profile_StateNotEligibile_Text\"\r\n        [medicaidIntegrationConfig]=\"Spa_MedicaidIntegrationConfig_Json\"\r\n        [notEligibleText]=\"Spa_Profile_NotEligible_Text\"\r\n        [showSubsidyAccordionOnProfile]=\"Spa_GettingStarted_ShowSubsidyAccordion_Flag\"\r\n        [optionalLabel]=\"Spa_GuidedHelp_OptionalLabel_Text\"\r\n        [genderEnabled]=\"Spa_Profile_Gender_Enabled\"\r\n        [genderItems]=\"genderItems\"\r\n        [genderLabel]=\"Spa_Site_Gender_Text\"\r\n        [genderRequiredErrorText]=\"Spa_Profile_GenderRequired_Error\"\r\n      ></vnext-member-registration>\r\n      <vnext-member-quote-history\r\n        *ngIf=\"Spa_Site_AddToQuote_Enabled && memberHasFullName\"\r\n        [memberQuoteHistoryHeaderText]=\"Spa_MemberQuoteHistory_Header_Text\"\r\n        [memberQuoteHistoryNoQuotesMessageText]=\"Spa_MemberQuoteHistory_NoQuotesMessageText\"\r\n        [memberQuoteHistoryQuoteSentText]=\"Spa_MemberQuoteHistory_QuoteSentText\"\r\n        [memberQuoteHistoryAuthorizationEmailBodyText]=\"Spa_SentQuote_AuthorizationEmail_Body\"\r\n        [memberQuoteHistory]=\"filterQuickQuoteEnrollments(memberQuoteHistoryForAgent$ | async)\"\r\n        [deliveryMethodPrefix]=\"Spa_MemberQuoteHistory_DeliveryMethod_Prefix\"\r\n        [deliveryMethodSeparator]=\"Spa_MemberQuoteHistory_DeliveryMethod_Separator\"\r\n        [planTypeHeader]=\"Spa_Site_PlanType_Header\"\r\n        [requestedEffectiveDateHeader]=\"Spa_EnrollmentHistory_RequestedEffectiveDate_Text\"\r\n        [pacificTimePostFix]=\"Spa_EnrollmentHistory_Pacific_StandardTime_Text\"\r\n        [displayQuoteSentInformation]=\"Spa_MemberQuoteHistory_DisplayQuoteSentInformation\"\r\n        [displayPlanType]=\"Spa_MemberQuoteHistory_DisplayPlanType\"\r\n        [displayRequestedEffectiveDate]=\"Spa_MemberQuoteHistory_DisplayRequestedEffectiveDate\"\r\n        [displayAuthCode]=\"Spa_MemberQuoteHistory_DisplayAuthCode\"\r\n        [displayPersonalizedMessage]=\"Spa_MemberQuoteHistory_DisplayPersonalizedMessage\"\r\n        [displayAgentFullName]=\"Spa_MemberQuoteHistory_DisplayAgentFullName\"\r\n        [displayAgentUserName]=\"Spa_MemberQuoteHistory_DisplayAgentUserName\"\r\n        [memberQuoteHistoryPlanNameEnabled]=\"Spa_MemberQuoteHistory_DisplayPlanName\"\r\n        [memberQuoteHistoryCarrierNameEnabled]=\"Spa_MemberQuoteHistory_DisplayCarrierName\"\r\n        [showPlanYearBadge]=\"isDualPlanYearSite && Spa_MemberQuoteHistory_ShowPlanYearBadge_Enabled\"\r\n        [sendQuoteAgentOfRecordEnabled]=\"Spa_SendQuote_AgentOfRecord_Enabled\"\r\n        [currentAgentGuid]=\"currentAgentGuid\"\r\n      >\r\n      </vnext-member-quote-history>\r\n      <vnext-member-enrollment-history\r\n        *ngIf=\"Spa_Site_EnrollmentHistory_Enabled && memberHasFullName\"\r\n        [memberEnrollments]=\"memberEnrollments\"\r\n        [memberQuoteHistory]=\"memberQuoteHistoryForAgent$ | async\"\r\n        [memberEnrollmentHistoryHeaderText]=\"Spa_EnrollmentHistory_Header_Text\"\r\n        [noEnrollmentMessageText]=\"Spa_EnrollmentHistory_NoEnrollmentMessageText\"\r\n        [pacificStandardTimeText]=\"Spa_EnrollmentHistory_Pacific_StandardTime_Text\"\r\n        [memberEnrollmentHistoryEffectiveDateText]=\"Spa_EnrollmentHistory_RequestedEffectiveDate_Text\"\r\n        [totalMonthlyPremiumLabel]=\"Spa_Site_TotalMonthlyPremiumLabel\"\r\n        [viewApplicationLinkText]=\"Spa_Site_ViewApplication_Link_Text\"\r\n        [confirmationText]=\"Spa_EnrollmentHistory_Confirmation_Text\"\r\n        [submittedDateText]=\"Spa_EnrollmentHistory_SubmittedDate_Text\"\r\n        [lastUpdatedText]=\"Spa_EnrollmentHistory_UpdatedDate_Text\"\r\n        [confirmationNumberEnabled]=\"Spa_EnrollmentHistory_ConfirmationNumber_Enabled\"\r\n        [planNameEnabled]=\"Spa_EnrollmentHistory_PlanName_Enabled\"\r\n        [effectiveDateEnabled]=\"Spa_EnrollmentHistory_EffectiveDate_Enabled\"\r\n        [totalMonthlyPremiumEnabled]=\"Spa_EnrollmentHistory_TotalMonthlyPremium_Enabled\"\r\n        [submissionDateEnabled]=\"Spa_EnrollmentHistory_SubmissionDate_Enabled\"\r\n        [updatedDateEnabled]=\"Spa_EnrollmentHistory_UpdatedDate_Enabled\"\r\n        [ridersEnabled]=\"Spa_EnrollmentHistory_Riders_Enabled\"\r\n        [continueEnrollmentButtonText]=\"Spa_EnrollmentHistory_ContinueEnrollment_ButtonText\"\r\n        [hraPDFLinkText]=\"SPA_EnrollmentHistory_HRALink_Text\"\r\n        [hraConfirmationText]=\"Spa_EnrollmentHistory_hraConfirmation_Text\"\r\n        [hraConfirmationNumberEnabled]=\"Spa_EnrollmentHistory_hraConfirmation_Enabled\"\r\n        [displayPlanAllowsCallRecordingIconEnabled]=\"Spa_Site_AgentCallRecording_DisplayPlanAllowsCallRecordingIcon_Enabled\"\r\n        [planAllowsCallRecordingText]=\"Spa_Site_AgentCallRecording_PlanAllowsCallRecording_Text\"\r\n        [agentCallInProgressAcceptCallIcon]=\"Spa_AgentCallInProgressAcceptCall_Icon\"\r\n        [isHRAEnabled]=\"Spa_Site_HRA_Enabled\"\r\n        [completeHRAButtonEnabled]=\"Spa_Site_CompleteHRA_Button_Enabled\"\r\n        [openExternalInNewTab]=\"Spa_EnrollmentConfirmation_OpenExternalHRAInNewTab_Enabled\"\r\n        [completeHRAButtonText]=\"Spa_Site_CompleteHRA_Button_Text\"\r\n        [completeHRALastVisitedText]=\"Spa_Site_CompleteHRA_LastVisited_Text\"\r\n        [completeHRADaysLeftText]=\"Spa_Site_CompleteHRA_DaysLeft_Text\"\r\n        [isMobile]=\"isMobile\"\r\n        [showPlanYearBadge]=\"Spa_EnrollmentHistory_ShowPlanYearBadge_Enabled\"\r\n        [planFeesEnabled]=\"Spa_Site_PlanFees_Enabled\"\r\n        [planFeesTooltipText]=\"Spa_PlanFees_Tooltip_Text\"\r\n        [planFeesIncludedInPremiumTooltipText]=\"Spa_PlanFees_IncludedInPremium_Tooltip_Text\"\r\n        [planFeesNotIncludedInPremiumTooltipText]=\"Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text\"\r\n        [memberEnrollmentStatus]=\"memberEnrollmentStatus$ | async\"\r\n        [enrollmentStatusEnabled]=\"Spa_EnrollmentHistory_EnrollmentStatus_Enabled\"\r\n        [statusDateText]=\"Spa_EnrollmentStatus_Date_Text\"\r\n        [statusText]=\"Spa_EnrollmentStatus_Label_Text\"\r\n        [defaultStatusText]=\"Spa_EnrollmentStatus_Default\"\r\n        [enrollmentHistoryProfileLinkEnabled]=\"Spa_Site_EnrollmentHistory_ProfileLink_Enabled\"\r\n        [enrollmentHistoryLinkText]=\"Spa_Enrollment_History_Link_Text\"\r\n        [enrollmentStatusHeaderText]=\"Spa_EnrollmentHistory_EnrollmentStatus_HeaderText\"\r\n        [enrollmentMoreDetailsText]=\"Spa_Site_EnrollmentHistory_MoreDetailsText\"\r\n        [enrollmentHraHeaderText]=\"Spa_EnrollmentHistory_HealthRiskAssessment_HeaderText\"\r\n        [enrollmentConfirmationHeaderText]=\"Spa_EnrollmentHistory_Confirmation_HeaderText\"\r\n        [memberEnrollmentEffectiveDateHeaderText]=\"Spa_EnrollmentHistory_RequestedEffectiveDate_HeaderText\"\r\n        [riderHeaderText]=\"Spa_EnrollmentHistory_Riders_HeaderText\"\r\n        [callRecordingHeaderText]=\"Spa_EnrollmentHistory_CallRecordings_HeaderText\"\r\n        [uploadDocumentHeaderText]=\"Spa_EnrollmentHistory_UploadedDocuments_HeaderText\"\r\n        [partialEnrollmentDisabledText]=\"Spa_Site_EnrollmentHistory_ContinueButton_Alternate_Text\"\r\n        [valueBasedCareConfirmationEnabled]=\"Spa_ValueBasedCare_Confirmation_Enabled\"\r\n        [valueBasedCareConfirmationText]=\"Spa_EnrollmentHistory_ValueBasedCare_HeaderText\"\r\n        [valueBasedCareProviders]=\"valueBasedCareProviders\"\r\n        [isEnrollmentContinueButtonEnabled]=\"Spa_EnrollmentHistory_PartialEnrollmentContinueButton_Enabled\"\r\n        [partialEnrollmentAllowedDate]=\"Spa_PartialEnrollment_Allowed_Date\"\r\n        [enrollerButtonTooltipText]=\"Spa_Site_EnrollerButton_Tooltip_Text\"\r\n        [valueBasedCareConfirmationExpiration]=\"Spa_ValueBasedCare_ConfirmationExpirationDays_Count\"\r\n        [isHRAPDFAccessEnabled]=\"Spa_EditProfile_AccessHRAPDF_Enabled\"\r\n        [isProfileAdmin]=\"isProfileAdmin\"\r\n        [isCompleteHRAProfileAdminEnabled]=\"Spa_EditProfile_CompleteHRAProfileAdmin_Enabled\"\r\n        [excludedCarrierIds]=\"Spa_HRA_ExcludedCarriers\"\r\n      ></vnext-member-enrollment-history>\r\n      <vnext-navigation-banner class=\"col-md-12 col-lg-9 shorter-width shorter-width\" [providedPrevious]=\"true\" [showPrevious]=\"true\">\r\n        <div previous-link class=\"d-flex justify-content-between\">\r\n          <vnext-link\r\n            [title]=\"Spa_Site_Previous\"\r\n            [showArrow]=\"'left'\"\r\n            [makeInlineBlock]=\"true\"\r\n            class=\"pr-2\"\r\n            *liveEditProp=\"'Spa_Site_Previous'\"\r\n            (click)=\"onPreviousClick()\"\r\n          >\r\n          </vnext-link>\r\n          <ng-container *ngIf=\"isMobile\">\r\n            <vnext-link\r\n              [title]=\"Spa_Site_AddPreferences\"\r\n              [showArrow]=\"'right'\"\r\n              [makeInlineBlock]=\"true\"\r\n              class=\"pr-2\"\r\n              (click)=\"saveAndNavigate(pageTags.GUIDED_HELP_GETTING_STARTED, preferencesTooltipController)\"\r\n              (keyup.enter)=\"saveAndNavigate(pageTags.GUIDED_HELP_GETTING_STARTED, preferencesTooltipController)\"\r\n              #preferencesTooltipController=\"ngbTooltip\"\r\n              [ngbTooltip]=\"errorTooltip\"\r\n              triggers=\"manual\"\r\n              *liveEditProp=\"'Spa_Site_AddPreferences'\"\r\n            >\r\n            </vnext-link>\r\n          </ng-container>\r\n        </div>\r\n        <div continue-button>\r\n          <ng-container *ngIf=\"!isMobile\">\r\n            <vnext-link\r\n              [title]=\"Spa_Site_AddPreferences\"\r\n              [showArrow]=\"'right'\"\r\n              [makeInlineBlock]=\"true\"\r\n              class=\"pr-3\"\r\n              (click)=\"saveAndNavigate(pageTags.GUIDED_HELP_GETTING_STARTED, preferencesTooltipController)\"\r\n              (keyup.enter)=\"saveAndNavigate(pageTags.GUIDED_HELP_GETTING_STARTED, preferencesTooltipController)\"\r\n              #preferencesTooltipController=\"ngbTooltip\"\r\n              [ngbTooltip]=\"errorTooltip\"\r\n              triggers=\"manual\"\r\n              *liveEditProp=\"'Spa_Site_AddPreferences'\"\r\n            >\r\n            </vnext-link>\r\n          </ng-container>\r\n          <button\r\n            class=\"btn Spa_Style_SecondaryButton col-xs-12 col-md-auto mr-md-2 mb-md-0 mb-2\"\r\n            (click)=\"saveAndNavigate(pageTags.SOA, soaTooltipController)\"\r\n            (keyup.enter)=\"saveAndNavigate(pageTags.SOA, soaTooltipController)\"\r\n            *ngIf=\"isSOAEnabled\"\r\n            #soaTooltipController=\"ngbTooltip\"\r\n            [ngbTooltip]=\"errorTooltip\"\r\n            triggers=\"manual\"\r\n          >\r\n            <span *liveEditProp=\"'Spa_Site_ContinueToSOA'\"> {{ Spa_Site_ContinueToSOA }}</span>\r\n          </button>\r\n          <button\r\n            class=\"btn Spa_Style_PrimaryButton col-xs-12 col-md-auto\"\r\n            (click)=\"saveAndNavigate(pageTags.PLAN_LIST, planListTooltipController)\"\r\n            (keyup.enter)=\"saveAndNavigate(pageTags.PLAN_LIST, planListTooltipController)\"\r\n            #planListTooltipController=\"ngbTooltip\"\r\n            [ngbTooltip]=\"errorTooltip\"\r\n            triggers=\"manual\"\r\n            *liveEditProp=\"'Spa_Site_ContinueToPlanList'\"\r\n          >\r\n            {{ Spa_Site_ContinueToPlanList }}\r\n          </button>\r\n        </div>\r\n        <ng-template #errorTooltip>\r\n          <div *ngIf=\"showError\" class=\"text-center\" [ngClass]=\"{ error: showError }\">\r\n            <i class=\"fas\" [ngClass]=\"{ 'fa-exclamation-circle': showError }\" aria-hidden=\"true\"></i>\r\n            {{ Spa_AddProfile_MemberCreate_Error_Text }}\r\n          </div>\r\n        </ng-template>\r\n      </vnext-navigation-banner>\r\n    </div>\r\n    <div class=\"member-sidebar col-12 col-md-4\">\r\n      <vnext-copy-purl-plus\r\n        *ngIf=\"Spa_Agent_Profile_PURLToConsumerAccount_Enabled\"\r\n        [purlToConsumerAccountButtonText]=\"Spa_Agent_Profile_PURLToConsumerAccount_ButtonText\"\r\n        [purlToConsumerAccountErrorText]=\"Spa_Agent_Profile_PURLToConsumerAccount_ErrorText\"\r\n        [copiedInfoText]=\"Spa_Agent_AccountOverview_CopiedInfo_Text\"\r\n        [memberEmail]=\"memberEmail\"\r\n        [memberCellPhone]=\"memberCellPhone\"\r\n        (onCopyClick)=\"copyPurl()\"\r\n      >\r\n      </vnext-copy-purl-plus>\r\n      <vnext-agent-of-record\r\n        *ngIf=\"Spa_MemberProfile_AgentofRecordDisplay_Enabled && memberHasFullName\"\r\n        [agentOfRecord]=\"agentOfRecord\"\r\n        [agentOfRecordHeaderLabel]=\"Spa_AddProfile_AssignedAgent_Text\"\r\n        [agentOfRecordReassignText]=\"Spa_AgentOfRecord_ModalHeader_Text\"\r\n        [agentOfRecordUnassignedText]=\"Spa_Site_Unassigned_Text\"\r\n        [isAgentAdmin]=\"isAgentAdmin\"\r\n        [isProfileAdmin]=\"isProfileAdmin\"\r\n      ></vnext-agent-of-record>\r\n      <vnext-agent-retire-flo\r\n        *ngIf=\"Spa_RetireFlo_Enabled\"\r\n        [agentHasRetireFlo]=\"agentHasRetireFlo\"\r\n        [agentRetireFloHeaderLabel]=\"Spa_Agent_Profile_RetireFlo_Header_Text\"\r\n        [agentRetireFloSignUpContentText]=\"Spa_Agent_Profile_RetireFlo_SignUp_Content_Text\"\r\n        [agentRetireFloSignUpButtonText]=\"Spa_Agent_AccountOverview_RetireFlo_SignUp_ButtonText\"\r\n        [agentRetireFloSendServeyButtonText]=\"Spa_Agent_Profile_RetireFlo_SendSurvey_ButtonText\"\r\n        [memberAgentNotes]=\"memberAgentRetireFlos$ | async\"\r\n        (openSendRetireFloModal)=\"showRetireFloModal()\"\r\n      ></vnext-agent-retire-flo>\r\n      <vnext-agent-progress-tracker\r\n        *ngIf=\"(Spa_Profile_Member_Progress_Enabled && Spa_Profile_Member_Progress_Visible) || Spa_Site_TransferCode_Enabled\"\r\n        [isMemberProgressVisible]=\"Spa_Profile_Member_Progress_Visible\"\r\n        [memberProgressTitle]=\"Spa_Profile_Member_Progress_Title\"\r\n        [progressEvent]=\"Spa_Profile_Member_Progress_Event_Types\"\r\n        [memberProgressInfo]=\"memberProgressInfo\"\r\n        [transferCodeLabelText]=\"Spa_Site_TransferCode_Label_Text\"\r\n        [isTransferCodeEnabled]=\"Spa_Site_TransferCode_Enabled\"\r\n        [isProfilePage]=\"true\"\r\n        [prescriptionsEnabled]=\"Spa_Site_Prescriptions_Enabled\"\r\n        [pharmacyEnabled]=\"Spa_Site_Pharmacy_Enabled\"\r\n        [providersEnabled]=\"Spa_Site_Providers_Enabled\"\r\n        (redirectRouteEvent)=\"navigateToPageTag($event)\"\r\n      >\r\n      </vnext-agent-progress-tracker>\r\n      <vnext-agent-soa\r\n        [agentSOAHeader]=\"Spa_AddProfile_AgentSOA_Header_Label\"\r\n        [agentSOAEmptyText]=\"Spa_AddProfile_AgentSOA_Empty_Text\"\r\n        [soaActivity]=\"soaActivity\"\r\n        [memberName]=\"memberName\"\r\n        [memberPhone]=\"memberPhone\"\r\n      ></vnext-agent-soa>\r\n      <vnext-agent-note\r\n        [agentNoteHeader]=\"Spa_AddProfile_AgentNote_Header_Label\"\r\n        [agentNoteEmptyNoteText]=\"Spa_AddProfile_AgentNote_EmptyNote_Text\"\r\n        [agentNoteAddNoteLink]=\"Spa_AddProfile_AgentNote_AddNoteLink_Text\"\r\n        [agentNoteCreatedLabel]=\"Spa_AddProfile_AgentNote_Created_Label\"\r\n        [agentNoteAgentNamePreFixLabel]=\"Spa_AddProfile_AgentNote_AgentName_Prefix\"\r\n        [memberAgentNotes]=\"memberAgentNotes$ | async\"\r\n        (openNoteModal)=\"showAgentNoteModal()\"\r\n      >\r\n      </vnext-agent-note>\r\n      <br />\r\n      <br />\r\n      <vnext-agent-task\r\n        [agentTaskHeader]=\"Spa_AddProfile_AgentTask_Header_Label\"\r\n        [agentTaskEmptyTaskText]=\"Spa_AddProfile_AgentTask_EmptyTask_Text\"\r\n        [agentTaskAddTaskLink]=\"Spa_AddProfile_AgentTask_AddTaskLink_Text\"\r\n        [agentTaskAgentNamePreFixLabel]=\"Spa_AddProfile_AgentTask_AgentName_Prefix\"\r\n        [agentTaskDueLabel]=\"Spa_AddProfile_AgentNote_Due_Label\"\r\n        [agentTaskCompleteLabel]=\"Spa_AddProfile_AgentNote_Completed_Label\"\r\n        [memberAgentTasks]=\"memberAgentTasks$ | async\"\r\n        (openTaskModal)=\"showAgentTaskModal()\"\r\n        (onTaskStatusChanged)=\"changeTaskStatus($event)\"\r\n      >\r\n      </vnext-agent-task>\r\n      <br />\r\n      <br />\r\n      <vnext-member-profile-retention-summary\r\n        *ngIf=\"Spa_RetentionSummary_Profile_Enabled && isRetentionMemberProfile && memberHasFullName\"\r\n        [retentionSummaryHeaderText]=\"Spa_RetentionSummary_Profile_Header\"\r\n        [retentionSummaryBodyText]=\"Spa_RetentionSummary_Profile_Body\"\r\n        [retentionSummaryLinkText]=\"Spa_RetentionSummary_Profile_Link\"\r\n      >\r\n      </vnext-member-profile-retention-summary>\r\n      <br />\r\n      <br />\r\n      <vnext-agent-call-recording-shopping-box\r\n        *ngIf=\"isAgentCallRecordingBoxDisplayed\"\r\n        [agentCallRecordingShoppingHeaderText]=\"Spa_Site_AgentCallRecordingShopping_ProfileBox_Header_Text\"\r\n        [agentCallRecordingShoppingSectionText]=\"Spa_Site_AgentCallRecordingShopping_ProfileBox_Section_Text\"\r\n        [agentCallRecordingShoppingLinkText]=\"Spa_Site_AgentCallRecordingShopping_ProfileBox_Link_Text\"\r\n        (viewRecording)=\"onViewRecording()\"\r\n      >\r\n      </vnext-agent-call-recording-shopping-box>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".add-profile-wrapper{margin:20px auto}.shorter-width{padding-left:41px;padding-right:41px}.error{color:var(--static-Spa_Style_Accent2)}@media print{.member-sidebar{overflow-x:hidden}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.NavigationService }, { type: AgentNoteFacade }, { type: AgentTaskFacade }, { type: i1.GuidedHelpService }, { type: i1.MemberSessionService }, { type: MemberRegistrationFacade }, { type: i1.SiteService }, { type: EnrollmentHistoryFacade }, { type: i1.AgentPermissionsService }, { type: AgentCallRecordingFacade }, { type: i1.ResponsiveLayoutService }, { type: HRAFormFacade }, { type: AnalyticsService }, { type: i1.PlanYearResourceService }, { type: SOAFacade }, { type: ProviderFacade }, { type: i1.AgentService }, { type: i1.SpinnerService }, { type: i1.LocaleService }, { type: AgentRetireFloFacade }, { type: i2$1.ActivatedRoute }, { type: ProfileFacade }, { type: AccountOverviewFacade }]; }, { Spa_Site_SOA_Enabled: [], Spa_Site_SiteType: [], Spa_Site_AddToQuote_Enabled: [], Spa_SendEnrollment_TextMessage_Enabled: [], Spa_Quote_CreateProfile_Enabled: [], Spa_SendEnrollment_Prompt: [], Spa_Site_TotalMonthlyPremiumLabel: [], Spa_Site_EnrollmentHistory_Enabled: [], Spa_AddProfile_AgentNote_Header_Label: [], Spa_AddProfile_AgentNote_EmptyNote_Text: [], Spa_AddProfile_AgentNote_AddNoteLink_Text: [], Spa_AddProfile_AgentNote_Created_Label: [], Spa_AddProfile_AgentNote_AgentName_Prefix: [], Spa_AddProfile_AgentTask_Header_Label: [], Spa_AddProfile_AgentTask_EmptyTask_Text: [], Spa_AddProfile_AgentTask_AddTaskLink_Text: [], Spa_AddProfile_AgentTask_AgentName_Prefix: [], Spa_AddProfile_AgentNote_Due_Label: [], Spa_AddProfile_AgentNote_Completed_Label: [], Spa_AddProfile_MemberCreate_Error_Text: [], Spa_AddProfile_AgentSOA_Header_Label: [], Spa_AddProfile_AgentSOA_Empty_Text: [], Spa_MemberQuoteHistory_QuoteSentText: [], Spa_SentQuote_AuthorizationEmail_Body: [], Spa_MemberQuoteHistory_DeliveryMethod_Prefix: [], Spa_MemberQuoteHistory_DeliveryMethod_Separator: [], Spa_Member_Profile_Address1_Display: [], Spa_Member_Profile_Address_Required: [], Spa_Member_Profile_Address2_Display: [], Spa_Member_Profile_City_Display: [], Spa_Member_Profile_City_Required: [], Spa_Member_Profile_CRM_Display: [], Spa_Member_Profile_CRM_Label: [], Spa_Member_Profile_CRM_Required: [], Spa_Member_Profile_CustomField1_Display: [], Spa_Member_Profile_CustomField1_Label: [], Spa_Member_Profile_CustomField2_Display: [], Spa_Member_Profile_CustomField2_Label: [], Spa_Member_Profile_CustomField3_Display: [], Spa_Member_Profile_CustomField3_Label: [], Spa_Member_Profile_CustomField4_Display: [], Spa_Member_Profile_CustomField4_Label: [], Spa_Member_Profile_CustomField5_Display: [], Spa_Member_Profile_CustomField5_Label: [], Spa_Member_Profile_DateOfBirth_Display: [], Spa_Member_Profile_DateOfBirth_Required: [], Spa_Member_Profile_Email_Display: [], Spa_Member_Profile_Email_Required: [], Spa_Member_Profile_PhoneNumber_Display: [], Spa_Member_Profile_PhoneNumber_Required: [], Spa_Member_Profile_Relationship_Required: [], Spa_Member_Profile_Relationship_Label: [], Spa_Member_Profile_RepAddress1_Display: [], Spa_Member_Profile_RepAddress2_Display: [], Spa_Member_Profile_RepAddress_Required: [], Spa_Member_Profile_RepCity_Display: [], Spa_Member_Profile_RepCity_Required: [], Spa_Member_Profile_RepEmail_Display: [], Spa_Member_Profile_RepEmail_Required: [], Spa_Member_Profile_RepFirstName_Display: [], Spa_Member_Profile_RepFirstName_Required: [], Spa_Member_Profile_RepLastName_Display: [], Spa_Member_Profile_RepLastName_Required: [], Spa_Member_Profile_RepPhoneNumber_Display: [], Spa_Member_Profile_RepPhoneNumber_Required: [], Spa_Member_Profile_Relationship_Display: [], Spa_Member_Profile_RepState_Display: [], Spa_Member_Profile_RepState_Required: [], Spa_Member_Profile_RepZipCode_Display: [], Spa_Member_Profile_RepZipCode_Required: [], Spa_Member_Profile_State_Display: [], Spa_Member_Profile_State_Required: [], Spa_Site_PlanType_Header: [], Spa_MemberQuoteHistory_DisplayQuoteSentInformation: [], Spa_MemberQuoteHistory_DisplayPlanType: [], Spa_MemberQuoteHistory_DisplayRequestedEffectiveDate: [], Spa_MemberQuoteHistory_DisplayAuthCode: [], Spa_MemberQuoteHistory_DisplayPersonalizedMessage: [], Spa_MemberQuoteHistory_DisplayAgentFullName: [], Spa_MemberQuoteHistory_DisplayAgentUserName: [], Spa_AgentTask_AddFollowUp_Enabled: [], Spa_AgentTask_FollowUp_CreateTask_Header_Label: [], Spa_AgentTask_FollowUp_Quote_Text: [], Spa_AgentTask_FollowUp_Enrollment_Text: [], Spa_AgentTask_FollowUp_SOA_Text: [], Spa_AgentTask_FollowUp_TaskCreated_Text: [], Spa_AgentTask_DueDate_Label: [], Spa_AgentTask_Task_Label: [], Spa_AgentTask_Save_Button: [], Spa_AgentTask_ContentErrorText: [], Spa_AgentTask_DateErrorText: [], Spa_AgentTask_DateInvalidText: [], Spa_AgentTask_PastDateInvalidText: [], Spa_AgentTask_FollowUp_BlueButton_Text: [], Spa_AgentTask_FollowUp_BlueButton_Title: [], Spa_MemberQuoteHistory_DisplayPlanName: [], Spa_MemberQuoteHistory_DisplayCarrierName: [], Spa_Site_AgentCallRecording_DisplayPlanAllowsCallRecordingIcon_Enabled: [], Spa_Site_AgentCallRecording_PlanAllowsCallRecording_Text: [], Spa_AgentCallInProgressAcceptCall_Icon: [], Spa_RetentionSummary_Profile_Enabled: [], Spa_RetentionSummary_Profile_Header: [], Spa_RetentionSummary_Profile_Body: [], Spa_RetentionSummary_Profile_Link: [], Spa_ValueBasedCare_Confirmation_Enabled: [], Spa_ValueBasedCare_ConfirmationExpirationDays_Count: [], Spa_EnrollmentHistory_ValueBasedCare_HeaderText: [], Spa_Site_ValueBasedCare_Enabled: [], Spa_EnrollmentHistory_ConfirmationNumber_Enabled: [], Spa_EnrollmentHistory_PlanName_Enabled: [], Spa_EnrollmentHistory_EffectiveDate_Enabled: [], Spa_EnrollmentHistory_TotalMonthlyPremium_Enabled: [], Spa_EnrollmentHistory_SubmissionDate_Enabled: [], Spa_EnrollmentHistory_Riders_Enabled: [], Spa_EnrollmentHistory_UpdatedDate_Enabled: [], Spa_EnrollmentHistory_RequestedEffectiveDate_Text: [], Spa_EnrollmentHistory_Confirmation_Text: [], Spa_EnrollmentHistory_SubmittedDate_Text: [], Spa_EnrollmentHistory_Pacific_StandardTime_Text: [], Spa_EnrollmentHistory_UpdatedDate_Text: [], Spa_EnrollmentHistory_ContinueEnrollment_ButtonText: [], Spa_Site_ViewApplication_Link_Text: [], Spa_SendEnrollment_Email_Enabled: [], Spa_SendEnrollment_EnrollForm_Button_Text: [], Spa_SendEnrollment_Continue: [], Spa_SendEnrollment_Title: [], SPA_EnrollmentHistory_HRALink_Text: [], Spa_EnrollmentHistory_hraConfirmation_Text: [], Spa_EnrollmentHistory_hraConfirmation_Enabled: [], Spa_EditProfile_AccessHRAPDF_Enabled: [], Spa_EditProfile_CompleteHRAProfileAdmin_Enabled: [], Spa_HRA_ExcludedCarriers: [], Spa_MemberQuoteHistory_Header_Text: [], Spa_MemberQuoteHistory_NoQuotesMessageText: [], Spa_EnrollmentHistory_Header_Text: [], Spa_EnrollmentHistory_NoEnrollmentMessageText: [], SPA_Member_Profile_Sub_Header_Label: [], SPA_Member_Profile_Home_Header_Label: [], SPA_Member_Profile_Additional_Information_Header_Label: [], SPA_Member_Profile_SectionHeader_Sales_Information_Label: [], Spa_Member_Profile_Save_Button_Label: [], SPA_Member_Profile_Is_Sales_Contact_Different_Label: [], Spa_AddProfile_Title: [], Spa_Site_Previous: [], Spa_Site_ContinueToSOA: [], Spa_Site_ContinueToPlanList: [], Spa_Site_AddPreferences: [], Spa_NewProfile_PageSubHeader_Text: [], Spa_EditProfile_PageSubHeader_Text: [], Spa_GuidedHelp_OptionalLabel_Text: [], Spa_Site_CompleteHRA_Button_Enabled: [], Spa_EnrollmentConfirmation_OpenExternalHRAInNewTab_Enabled: [], Spa_Site_CompleteHRA_Button_Text: [], Spa_Site_CompleteHRA_LastVisited_Text: [], Spa_Site_CompleteHRA_DaysLeft_Text: [], Spa_Site_Cancel: [], Spa_Site_Continue: [], Spa_EnrollmentConfirmation_ExternalHRATitle_Text: [], Spa_EnrollmentConfirmation_ExternalHRABody_Text: [], Spa_Site_HRA_Enabled: [], Spa_Profile_AgentCallRecordingShopping_DisplayRecordingLink_Enabled: [], Spa_Site_AgentCallRecordingShopping_ProfileBox_Header_Text: [], Spa_Site_AgentCallRecordingShopping_ProfileBox_Section_Text: [], Spa_Site_AgentCallRecordingShopping_ProfileBox_Link_Text: [], Spa_EnrollmentHistory_ShowPlanYearBadge_Enabled: [], Spa_MemberQuoteHistory_ShowPlanYearBadge_Enabled: [], Spa_PartialEnrollment_Allowed_Date: [], Spa_Site_EnrollmentHistory_ContinueButton_Alternate_Text: [], Spa_Site_PlanFees_Enabled: [], Spa_PlanFees_Tooltip_Text: [], Spa_PlanFees_IncludedInPremium_Tooltip_Text: [], Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text: [], Spa_EnrollmentHistory_EnrollmentStatus_Enabled: [], Spa_EnrollmentStatus_Label_Text: [], Spa_EnrollmentStatus_Date_Text: [], Spa_EnrollmentStatus_Default: [], Spa_Site_EnrollmentHistory_ProfileLink_Enabled: [], Spa_Enrollment_History_Link_Text: [], Spa_Site_EnrollmentHistory_MoreDetailsText: [], Spa_EnrollmentHistory_EnrollmentStatus_HeaderText: [], Spa_EnrollmentHistory_HealthRiskAssessment_HeaderText: [], Spa_EnrollmentHistory_Confirmation_HeaderText: [], Spa_EnrollmentHistory_RequestedEffectiveDate_HeaderText: [], Spa_EnrollmentHistory_Riders_HeaderText: [], Spa_EnrollmentHistory_CallRecordings_HeaderText: [], Spa_EnrollmentHistory_UploadedDocuments_HeaderText: [], Spa_EnrollmentHistory_PartialEnrollmentContinueButton_Enabled: [], Spa_MemberProfile_AgentofRecordDisplay_Enabled: [], Spa_AgentOfRecord_ModalHeader_Text: [], Spa_Site_Unassigned_Text: [], Spa_AddProfile_AssignedAgent_Text: [], Spa_Site_EnrollerButton_Tooltip_Text: [], Spa_SendQuote_AgentOfRecord_Enabled: [], Spa_Profile_StateEligibilityCheck_Enabled: [], Spa_Profile_StateEligibilityCheck_Description: [], Spa_Profile_StateEligibilityCheck_MedicaidID: [], Spa_Profile_StateEligibilityCheck_ButtonText: [], Spa_Profile_StateEligibilityCheck_NoMedicaidID_Text: [], Spa_Profile_StateEligibilityCheck_Pending_Text: [], Spa_Profile_StateEligibilityCheck_Pending_DescriptionText: [], Spa_Profile_StateEligibilityCheck_NoZip_Text: [], Spa_Profile_StateEligibilityCheck_MedicaidCode_Text: [], Spa_Profile_StateEligibilityCheck_DateReceived_Text: [], Spa_Profile_StateEligibilityCheck_Days: [], Spa_Profile_StateEligibilityCheck_CannotCompleteError_Text: [], Spa_Profile_StateEligibilityCheck_CheckedNote_Text: [], Spa_Profile_FederalEligibilityForState_Required: [], Spa_Profile_FederalEligibilityForStateRequired_Text: [], Spa_Profile_StateNotEligibile_Text: [], Spa_MedicaidIntegrationConfig_Json: [], Spa_Profile_NotEligible_Text: [], Spa_GettingStarted_ShowSubsidyAccordion_Flag: [], Spa_Site_Gender_Text: [], Spa_Profile_Gender_Enabled: [], Spa_Profile_GenderMale_Text: [], Spa_Profile_GenderFemale_Text: [], Spa_Profile_GenderRequired_Error: [], Spa_Profile_Member_Progress_Enabled: [], Spa_Profile_Member_Progress_Visible: [], Spa_Profile_Member_Progress_Title: [], Spa_Site_TransferCode_Label_Text: [], Spa_Site_TransferCode_Enabled: [], Spa_Profile_Member_Progress_Event_Types: [], Spa_Site_Prescriptions_Enabled: [], Spa_Site_Pharmacy_Enabled: [], Spa_Site_Providers_Enabled: [], Spa_RetireFlo_Enabled: [], Spa_Agent_Profile_RetireFlo_SignUp_Content_Text: [], Spa_Agent_AccountOverview_RetireFlo_SignUp_ButtonText: [], Spa_Agent_Profile_RetireFlo_Header_Text: [], Spa_Agent_Profile_RetireFlo_SendSurvey_ButtonText: [], Spa_Agent_Profile_PURLToConsumerAccount_Enabled: [], Spa_Agent_Profile_PURLToConsumerAccount_ButtonText: [], Spa_Agent_Profile_PURLToConsumerAccount_ErrorText: [], Spa_Agent_AccountOverview_CopiedInfo_Text: [], Spa_Agent_AccountOverview_Purl_Enabled: [], Spa_ConsumerSiteID_Enabled: [], Spa_Agent_Profile_PURLToConsumerAccount_RedirectPageTag: [], memberRegistrationComponent: [{
            type: ViewChild,
            args: [MemberRegistrationComponent]
        }], onPreviousClick: [], saveAndNavigate: [], getEnrollmentsPlanHRAType: [], getPlanHRAType: [] }); })();

class ContactYourAgentStepComponent {
    constructor() {
        this.goBackHome = new EventEmitter();
    }
    backToHome() {
        this.goBackHome.emit();
    }
}
ContactYourAgentStepComponent.ɵfac = function ContactYourAgentStepComponent_Factory(t) { return new (t || ContactYourAgentStepComponent)(); };
ContactYourAgentStepComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ContactYourAgentStepComponent, selectors: [["vnext-contact-your-agent-step"]], inputs: { contactYourAgentTextSegments: "contactYourAgentTextSegments", contactYourAgentLink: "contactYourAgentLink", goHomeButtonText: "goHomeButtonText" }, outputs: { goBackHome: "goBackHome" }, decls: 9, vars: 6, consts: [[1, "row", "justify-content-center", "mt-3"], [1, "col-12", "col-sm-8", "col-md-6", "Spa_Style_Paragraph"], [3, "link", "alwaysUnderlined", "customClass"], [1, "col-12", "col-sm-6", "col-md-4"], [1, "btn", "w-100", "px-3", "mt-4", "Spa_Style_PrimaryButton", 3, "click"]], template: function ContactYourAgentStepComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelement(3, "vnext-contact-us", 2);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div", 0)(6, "div", 3)(7, "button", 4);
        i0.ɵɵlistener("click", function ContactYourAgentStepComponent_Template_button_click_7_listener() { return ctx.backToHome(); });
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.contactYourAgentTextSegments == null ? null : ctx.contactYourAgentTextSegments.start, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("link", ctx.contactYourAgentLink)("alwaysUnderlined", true)("customClass", "Spa_Style_Small_Font Spa_Style_Primary_Link_Color");
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.contactYourAgentTextSegments == null ? null : ctx.contactYourAgentTextSegments.end, " ");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.goHomeButtonText);
    } }, dependencies: [ContactUsComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContactYourAgentStepComponent, [{
        type: Component,
        args: [{ selector: 'vnext-contact-your-agent-step', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row justify-content-center mt-3\">\r\n  <div class=\"col-12 col-sm-8 col-md-6 Spa_Style_Paragraph\">\r\n    {{ contactYourAgentTextSegments?.start }}\r\n    <vnext-contact-us\r\n      [link]=\"contactYourAgentLink\"\r\n      [alwaysUnderlined]=\"true\"\r\n      [customClass]=\"'Spa_Style_Small_Font Spa_Style_Primary_Link_Color'\"\r\n    ></vnext-contact-us>\r\n    {{ contactYourAgentTextSegments?.end }}\r\n  </div>\r\n</div>\r\n\r\n<div class=\"row justify-content-center mt-3\">\r\n  <div class=\"col-12 col-sm-6 col-md-4\">\r\n    <button class=\"btn w-100 px-3 mt-4 Spa_Style_PrimaryButton\" (click)=\"backToHome()\">{{ goHomeButtonText }}</button>\r\n  </div>\r\n</div>\r\n" }]
    }], null, { contactYourAgentTextSegments: [{
            type: Input
        }], contactYourAgentLink: [{
            type: Input
        }], goHomeButtonText: [{
            type: Input
        }], goBackHome: [{
            type: Output
        }] }); })();

function VerificationCodeSentComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 7)(4, "span", 8);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 6);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "span", 6);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.enterCodeEmailTextSegments == null ? null : ctx_r0.enterCodeEmailTextSegments.start);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.obfuscatedEmailSegments == null ? null : ctx_r0.obfuscatedEmailSegments.start);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.obfuscatedEmailSegments == null ? null : ctx_r0.obfuscatedEmailSegments.end);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.enterCodeEmailTextSegments == null ? null : ctx_r0.enterCodeEmailTextSegments.end);
} }
function VerificationCodeSentComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 7)(4, "span", 8);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 6);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "span", 6);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.enterCodeMobilePhoneTextSegments == null ? null : ctx_r1.enterCodeMobilePhoneTextSegments.start);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.obfuscatedCellPhoneSegments == null ? null : ctx_r1.obfuscatedCellPhoneSegments.start);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.obfuscatedCellPhoneSegments == null ? null : ctx_r1.obfuscatedCellPhoneSegments.end);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.enterCodeMobilePhoneTextSegments == null ? null : ctx_r1.enterCodeMobilePhoneTextSegments.end);
} }
class VerificationCodeSentComponent {
    constructor() {
        this.MFA_CONTACT_TYPES = MFA_CONTACT_TYPES;
    }
}
VerificationCodeSentComponent.ɵfac = function VerificationCodeSentComponent_Factory(t) { return new (t || VerificationCodeSentComponent)(); };
VerificationCodeSentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: VerificationCodeSentComponent, selectors: [["vnext-verification-code-sent"]], inputs: { selectedContactMethod: "selectedContactMethod", obfuscatedEmailSegments: "obfuscatedEmailSegments", obfuscatedCellPhoneSegments: "obfuscatedCellPhoneSegments", enterCodeEmailTextSegments: "enterCodeEmailTextSegments", enterCodeMobilePhoneTextSegments: "enterCodeMobilePhoneTextSegments", expirationText: "expirationText" }, decls: 8, vars: 4, consts: [[1, "row", "justify-content-center", "mt-3"], [1, "col-12", "col-sm-10", "col-md-8", "col-lg-7", "px-sm-0", "Spa_Style_Paragraph"], [3, "ngSwitch"], [4, "ngSwitchCase"], [1, "row", "justify-content-center", "mt-3", "pb-3"], [1, "col-12", "Spa_Style_Note"], [1, "non-obfuscated"], [1, "text-nowrap"], [1, "obfuscated", "Spa_Style_Bold_Weight"]], template: function VerificationCodeSentComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵelementContainerStart(2, 2);
        i0.ɵɵtemplate(3, VerificationCodeSentComponent_ng_container_3_Template, 10, 4, "ng-container", 3);
        i0.ɵɵtemplate(4, VerificationCodeSentComponent_ng_container_4_Template, 10, 4, "ng-container", 3);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "div", 4)(6, "div", 5);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngSwitch", ctx.selectedContactMethod);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.MFA_CONTACT_TYPES.EMAIL);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.MFA_CONTACT_TYPES.PHONE);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.expirationText);
    } }, dependencies: [i1$2.NgSwitch, i1$2.NgSwitchCase], styles: [".obfuscated[_ngcontent-%COMP%]{font-size:28px;vertical-align:sub;line-height:14px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VerificationCodeSentComponent, [{
        type: Component,
        args: [{ selector: 'vnext-verification-code-sent', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row justify-content-center mt-3\">\r\n  <div class=\"col-12 col-sm-10 col-md-8 col-lg-7 px-sm-0 Spa_Style_Paragraph\">\r\n    <ng-container [ngSwitch]=\"selectedContactMethod\">\r\n      <ng-container *ngSwitchCase=\"MFA_CONTACT_TYPES.EMAIL\">\r\n        <span class=\"non-obfuscated\">{{ enterCodeEmailTextSegments?.start }}</span\r\n        ><span class=\"text-nowrap\"\r\n          ><span class=\"obfuscated Spa_Style_Bold_Weight\">{{ obfuscatedEmailSegments?.start }}</span\r\n          ><span class=\"non-obfuscated\">{{ obfuscatedEmailSegments?.end }}</span></span\r\n        ><span class=\"non-obfuscated\">{{ enterCodeEmailTextSegments?.end }}</span>\r\n      </ng-container>\r\n\r\n      <ng-container *ngSwitchCase=\"MFA_CONTACT_TYPES.PHONE\">\r\n        <span class=\"non-obfuscated\">{{ enterCodeMobilePhoneTextSegments?.start }}</span\r\n        ><span class=\"text-nowrap\"\r\n          ><span class=\"obfuscated Spa_Style_Bold_Weight\">{{ obfuscatedCellPhoneSegments?.start }}</span\r\n          ><span class=\"non-obfuscated\">{{ obfuscatedCellPhoneSegments?.end }}</span></span\r\n        ><span class=\"non-obfuscated\">{{ enterCodeMobilePhoneTextSegments?.end }}</span>\r\n      </ng-container>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"row justify-content-center mt-3 pb-3\">\r\n  <div class=\"col-12 Spa_Style_Note\">{{ expirationText }}</div>\r\n</div>\r\n", styles: [".obfuscated{font-size:28px;vertical-align:sub;line-height:14px}\n"] }]
    }], null, { selectedContactMethod: [{
            type: Input
        }], obfuscatedEmailSegments: [{
            type: Input
        }], obfuscatedCellPhoneSegments: [{
            type: Input
        }], enterCodeEmailTextSegments: [{
            type: Input
        }], enterCodeMobilePhoneTextSegments: [{
            type: Input
        }], expirationText: [{
            type: Input
        }] }); })();

const _c0$F = ["enterTotpCodeField"];
function EnterVerificationCodeStepComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵelement(2, "i", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.codeSentText, " ");
} }
function EnterVerificationCodeStepComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 6);
    i0.ɵɵelement(2, "i", 7);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r1.maxRequestsExceededText, " ");
} }
function EnterVerificationCodeStepComponent_div_3_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelement(1, "i", 25);
    i0.ɵɵelementStart(2, "span", 26);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.errorKeywordText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.verificationCodeErrorText, " ");
} }
const _c1$9 = function (a0, a1) { return { "Spa_Style_Primary_Color": a0, "error-color": a1 }; };
const _c2$5 = function (a0) { return { "has-error": a0 }; };
function EnterVerificationCodeStepComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9)(2, "form", 10);
    i0.ɵɵlistener("ngSubmit", function EnterVerificationCodeStepComponent_div_3_Template_form_ngSubmit_2_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onSubmit()); });
    i0.ɵɵelementStart(3, "div", 11);
    i0.ɵɵtemplate(4, EnterVerificationCodeStepComponent_div_3_div_4_Template, 5, 2, "div", 12);
    i0.ɵɵelementStart(5, "label", 13)(6, "span", 14);
    i0.ɵɵtext(7, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 15);
    i0.ɵɵelement(11, "input", 16, 17);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "div", 18)(14, "button", 19);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(16, "div", 20)(17, "div", 21)(18, "span", 22);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "vnext-link", 23);
    i0.ɵɵlistener("click", function EnterVerificationCodeStepComponent_div_3_Template_vnext_link_click_20_listener() { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.onResendCode()); });
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formGroup", ctx_r2.codeVerificationForm);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.codeVerificationForm.invalid && (ctx_r2.codeVerificationForm.touched || ctx_r2.codeVerificationForm.dirty || ctx_r2.formSubmitted));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", ctx_r2.codeVerificationForm.controls.totpCode == null ? null : ctx_r2.codeVerificationForm.controls.totpCode.name)("ngClass", i0.ɵɵpureFunction2(15, _c1$9, ctx_r2.codeVerificationForm.valid || ctx_r2.codeVerificationForm.untouched && ctx_r2.codeVerificationForm.pristine && !ctx_r2.formSubmitted, ctx_r2.codeVerificationForm.invalid && (ctx_r2.codeVerificationForm.touched || ctx_r2.codeVerificationForm.dirty || ctx_r2.formSubmitted)));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r2.enterCodeLabelText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r2.codeVerificationForm.controls.totpCode == null ? null : ctx_r2.codeVerificationForm.controls.totpCode.name)("maxlength", ctx_r2.totpLength)("formControlName", ctx_r2.codeVerificationForm.controls.totpCode == null ? null : ctx_r2.codeVerificationForm.controls.totpCode.name)("ngClass", i0.ɵɵpureFunction1(18, _c2$5, ctx_r2.codeVerificationForm.invalid && (ctx_r2.codeVerificationForm.touched || ctx_r2.codeVerificationForm.dirty || ctx_r2.formSubmitted)));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.continueButtonText, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r2.resendCodeText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r2.resendCodeLinkText)("alwaysUnderlined", true)("makeInlineBlock", true)("customClass", "Spa_Style_Link Spa_Style_Smaller_Font");
} }
class EnterVerificationCodeStepComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.validateTOTPCode = new EventEmitter();
        this.resendCode = new EventEmitter();
        this.formSubmitted = false;
    }
    onSubmit() {
        if (this.codeVerificationForm?.valid) {
            this.validateTOTPCode.emit(this.codeVerificationForm.value);
        }
        this.formSubmitted = true;
    }
    onResendCode() {
        this.resendCode.emit();
    }
    markForCheck() {
        this.cdr.markForCheck();
    }
}
EnterVerificationCodeStepComponent.ɵfac = function EnterVerificationCodeStepComponent_Factory(t) { return new (t || EnterVerificationCodeStepComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
EnterVerificationCodeStepComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EnterVerificationCodeStepComponent, selectors: [["vnext-enter-verification-code-step"]], viewQuery: function EnterVerificationCodeStepComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$F, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.enterTotpCodeField = _t.first);
    } }, inputs: { selectedContactMethod: "selectedContactMethod", codeVerificationForm: "codeVerificationForm", totpLength: "totpLength", obfuscatedEmailSegments: "obfuscatedEmailSegments", obfuscatedCellPhoneSegments: "obfuscatedCellPhoneSegments", enterCodeEmailTextSegments: "enterCodeEmailTextSegments", enterCodeMobilePhoneTextSegments: "enterCodeMobilePhoneTextSegments", expirationText: "expirationText", enterCodeLabelText: "enterCodeLabelText", continueButtonText: "continueButtonText", resendCodeText: "resendCodeText", resendCodeLinkText: "resendCodeLinkText", codeSentText: "codeSentText", errorKeywordText: "errorKeywordText", verificationCodeErrorText: "verificationCodeErrorText", displayCodeSentText: "displayCodeSentText", maxRequestsExceeded: "maxRequestsExceeded", maxRequestsExceededText: "maxRequestsExceededText" }, outputs: { validateTOTPCode: "validateTOTPCode", resendCode: "resendCode" }, decls: 4, vars: 9, consts: [[3, "selectedContactMethod", "obfuscatedEmailSegments", "obfuscatedCellPhoneSegments", "enterCodeEmailTextSegments", "enterCodeMobilePhoneTextSegments", "expirationText"], ["class", "row justify-content-center pb-3", 4, "ngIf"], ["class", "row justify-content-center pt-4", 4, "ngIf"], [1, "row", "justify-content-center", "pb-3"], [1, "code-sent", "Spa_Style_Small_Font"], [1, "pr-1", "fas", "fa-check-circle"], [1, "col-12", "col-sm-6", "col-md-4", "error-container"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], [1, "row", "justify-content-center", "pt-4"], [1, "col-12", "col-sm-6", "col-md-4"], ["disableKeyDownSubmit", "", 3, "formGroup", "ngSubmit"], [1, "form-row"], ["class", "error-container mb-3 d-flex align-items-baseline has-error text-left Spa_Style_Small_Font", 4, "ngIf"], [1, "Spa_Style_Bold_Weight", "Spa_Style_Small_Font", "text-left", 3, "for", "ngClass"], [1, "input-error-asterisk"], [1, "input-group"], ["type", "text", "tabindex", "0", "autocomplete", "new-text", "placeholder", "", 1, "form-control", 3, "id", "maxlength", "formControlName", "ngClass"], ["enterTotpCodeField", ""], [1, "form-row", "mt-4"], ["type", "submit", "tabindex", "0", 1, "btn", "Spa_Style_PrimaryButton", "w-100"], [1, "row", "justify-content-center", "mt-3"], [1, "col-12", "Spa_Style_Note"], [1, "pr-2"], [3, "title", "alwaysUnderlined", "makeInlineBlock", "customClass", "click"], [1, "error-container", "mb-3", "d-flex", "align-items-baseline", "has-error", "text-left", "Spa_Style_Small_Font"], [1, "fas", "fa-exclamation-circle"], [1, "sr-only"]], template: function EnterVerificationCodeStepComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "vnext-verification-code-sent", 0);
        i0.ɵɵtemplate(1, EnterVerificationCodeStepComponent_div_1_Template, 4, 1, "div", 1);
        i0.ɵɵtemplate(2, EnterVerificationCodeStepComponent_div_2_Template, 4, 1, "div", 1);
        i0.ɵɵtemplate(3, EnterVerificationCodeStepComponent_div_3_Template, 21, 20, "div", 2);
    } if (rf & 2) {
        i0.ɵɵproperty("selectedContactMethod", ctx.selectedContactMethod)("obfuscatedEmailSegments", ctx.obfuscatedEmailSegments)("obfuscatedCellPhoneSegments", ctx.obfuscatedCellPhoneSegments)("enterCodeEmailTextSegments", ctx.enterCodeEmailTextSegments)("enterCodeMobilePhoneTextSegments", ctx.enterCodeMobilePhoneTextSegments)("expirationText", ctx.expirationText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.displayCodeSentText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.maxRequestsExceeded);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.codeVerificationForm);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.MaxLengthValidator, i4.FormGroupDirective, i4.FormControlName, LinkComponent, FormInputSubmitDirective, IconAriaAttributesDirective, VerificationCodeSentComponent], styles: [".code-sent[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text)}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnterVerificationCodeStepComponent, [{
        type: Component,
        args: [{ selector: 'vnext-enter-verification-code-step', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-verification-code-sent\r\n  [selectedContactMethod]=\"selectedContactMethod\"\r\n  [obfuscatedEmailSegments]=\"obfuscatedEmailSegments\"\r\n  [obfuscatedCellPhoneSegments]=\"obfuscatedCellPhoneSegments\"\r\n  [enterCodeEmailTextSegments]=\"enterCodeEmailTextSegments\"\r\n  [enterCodeMobilePhoneTextSegments]=\"enterCodeMobilePhoneTextSegments\"\r\n  [expirationText]=\"expirationText\"\r\n></vnext-verification-code-sent>\r\n\r\n<div *ngIf=\"displayCodeSentText\" class=\"row justify-content-center pb-3\">\r\n  <div class=\"code-sent Spa_Style_Small_Font\">\r\n    <i class=\"pr-1 fas fa-check-circle\"></i>\r\n    {{ codeSentText }}\r\n  </div>\r\n</div>\r\n\r\n<div *ngIf=\"maxRequestsExceeded\" class=\"row justify-content-center pb-3\">\r\n  <div class=\"col-12 col-sm-6 col-md-4 error-container\">\r\n    <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>{{ maxRequestsExceededText }}\r\n  </div>\r\n</div>\r\n\r\n<div *ngIf=\"codeVerificationForm\" class=\"row justify-content-center pt-4\">\r\n  <div class=\"col-12 col-sm-6 col-md-4\">\r\n    <form disableKeyDownSubmit [formGroup]=\"codeVerificationForm\" (ngSubmit)=\"onSubmit()\">\r\n      <div class=\"form-row\">\r\n        <div\r\n          *ngIf=\"codeVerificationForm.invalid && (codeVerificationForm.touched || codeVerificationForm.dirty || formSubmitted)\"\r\n          class=\"error-container mb-3 d-flex align-items-baseline has-error text-left Spa_Style_Small_Font\"\r\n        >\r\n          <i class=\"fas fa-exclamation-circle\"></i>\r\n          <span class=\"sr-only\">{{ errorKeywordText }}</span>\r\n          {{ verificationCodeErrorText }}\r\n        </div>\r\n\r\n        <label\r\n          class=\"Spa_Style_Bold_Weight Spa_Style_Small_Font text-left\"\r\n          [for]=\"codeVerificationForm.controls.totpCode?.name\"\r\n          [ngClass]=\"{\r\n            'Spa_Style_Primary_Color':\r\n              codeVerificationForm.valid || (codeVerificationForm.untouched && codeVerificationForm.pristine && !formSubmitted),\r\n            'error-color': codeVerificationForm.invalid && (codeVerificationForm.touched || codeVerificationForm.dirty || formSubmitted)\r\n          }\"\r\n        >\r\n          <span class=\"input-error-asterisk\">*</span><span>{{ enterCodeLabelText }}</span>\r\n        </label>\r\n        <div class=\"input-group\">\r\n          <input\r\n            #enterTotpCodeField\r\n            type=\"text\"\r\n            tabindex=\"0\"\r\n            autocomplete=\"new-text\"\r\n            placeholder=\"\"\r\n            class=\"form-control\"\r\n            [id]=\"codeVerificationForm.controls.totpCode?.name\"\r\n            [maxlength]=\"totpLength\"\r\n            [formControlName]=\"codeVerificationForm.controls.totpCode?.name\"\r\n            [ngClass]=\"{\r\n              'has-error': codeVerificationForm.invalid && (codeVerificationForm.touched || codeVerificationForm.dirty || formSubmitted)\r\n            }\"\r\n          />\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-row mt-4\">\r\n        <button type=\"submit\" tabindex=\"0\" class=\"btn Spa_Style_PrimaryButton w-100\">\r\n          {{ continueButtonText }}\r\n        </button>\r\n      </div>\r\n    </form>\r\n\r\n    <div class=\"row justify-content-center mt-3\">\r\n      <div class=\"col-12 Spa_Style_Note\">\r\n        <span class=\"pr-2\">{{ resendCodeText }}</span>\r\n        <vnext-link\r\n          [title]=\"resendCodeLinkText\"\r\n          [alwaysUnderlined]=\"true\"\r\n          [makeInlineBlock]=\"true\"\r\n          [customClass]=\"'Spa_Style_Link Spa_Style_Smaller_Font'\"\r\n          (click)=\"onResendCode()\"\r\n        ></vnext-link>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".code-sent{color:var(--static-Spa_Style_Cost_Text)}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { selectedContactMethod: [{
            type: Input
        }], codeVerificationForm: [{
            type: Input
        }], totpLength: [{
            type: Input
        }], obfuscatedEmailSegments: [{
            type: Input
        }], obfuscatedCellPhoneSegments: [{
            type: Input
        }], enterCodeEmailTextSegments: [{
            type: Input
        }], enterCodeMobilePhoneTextSegments: [{
            type: Input
        }], expirationText: [{
            type: Input
        }], enterCodeLabelText: [{
            type: Input
        }], continueButtonText: [{
            type: Input
        }], resendCodeText: [{
            type: Input
        }], resendCodeLinkText: [{
            type: Input
        }], codeSentText: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], verificationCodeErrorText: [{
            type: Input
        }], displayCodeSentText: [{
            type: Input
        }], maxRequestsExceeded: [{
            type: Input
        }], maxRequestsExceededText: [{
            type: Input
        }], validateTOTPCode: [{
            type: Output
        }], resendCode: [{
            type: Output
        }], enterTotpCodeField: [{
            type: ViewChild,
            args: ['enterTotpCodeField']
        }] }); })();

function SelectContactMethodStepComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 9);
    i0.ɵɵelement(2, "i", 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.maxRequestsExceededText);
} }
function SelectContactMethodStepComponent_label_10_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 11)(1, "div", 12)(2, "input", 13);
    i0.ɵɵlistener("change", function SelectContactMethodStepComponent_label_10_Template_input_change_2_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.radioChange(ctx_r3.MFA_CONTACT_TYPES.EMAIL)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "div")(4, "div", 14);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 15)(7, "span", 16);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 17);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r1.emailAddressText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.obfuscatedEmailSegments.start);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.obfuscatedEmailSegments.end);
} }
function SelectContactMethodStepComponent_label_11_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 11)(1, "div", 12)(2, "input", 18);
    i0.ɵɵlistener("change", function SelectContactMethodStepComponent_label_11_Template_input_change_2_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.radioChange(ctx_r5.MFA_CONTACT_TYPES.PHONE)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "div")(4, "div", 19);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 15)(7, "span", 16);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 17);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r2.cellphoneNumberText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.obfuscatedCellPhoneSegments.start);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.obfuscatedCellPhoneSegments.end);
} }
class SelectContactMethodStepComponent {
    constructor() {
        this.sendCode = new EventEmitter();
        this.MFA_CONTACT_TYPES = MFA_CONTACT_TYPES;
        this.selectedContactMethod = null;
    }
    radioChange(contactMethod) {
        this.selectedContactMethod = contactMethod;
    }
    onSendCode() {
        this.sendCode.emit(this.selectedContactMethod);
    }
}
SelectContactMethodStepComponent.ɵfac = function SelectContactMethodStepComponent_Factory(t) { return new (t || SelectContactMethodStepComponent)(); };
SelectContactMethodStepComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectContactMethodStepComponent, selectors: [["vnext-select-contact-method-step"]], inputs: { obfuscatedEmailSegments: "obfuscatedEmailSegments", obfuscatedCellPhoneSegments: "obfuscatedCellPhoneSegments", subheaderText: "subheaderText", authenticationMethodText: "authenticationMethodText", emailAddressText: "emailAddressText", cellphoneNumberText: "cellphoneNumberText", sendCodeText: "sendCodeText", expirationText: "expirationText", maxRequestsExceeded: "maxRequestsExceeded", maxRequestsExceededText: "maxRequestsExceededText" }, outputs: { sendCode: "sendCode" }, decls: 17, vars: 7, consts: [[1, "row", "mt-3"], [1, "col-12", "Spa_Style_Paragraph"], ["class", "row mt-3", 4, "ngIf"], [1, "col-12", "Spa_Style_Bold_Weight"], [1, "col-12"], [1, "d-inline-block", "Spa_Style_Small_Font"], ["class", "radio-item", 4, "ngIf"], [1, "btn", "Spa_Style_PrimaryButton", "w-100", "mt-4", 3, "click"], [1, "col-12", "Spa_Style_Note"], [1, "col-12", "error-container"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], [1, "radio-item"], [1, "mr-2"], ["type", "radio", "name", "contactMethodRadioGroup", "aria-labelledby", "emailAddressLabelId", 3, "change"], ["id", "emailAddressLabelId", 1, "Spa_Style_Bold_Weight"], [1, "radio-text"], [1, "obfuscated", "Spa_Style_Bold_Weight"], [1, "non-obfuscated"], ["type", "radio", "name", "contactMethodRadioGroup", "aria-labelledby", "cellphoneNumberLabelId", 3, "change"], ["id", "cellphoneNumberLabelId", 1, "Spa_Style_Bold_Weight"]], template: function SelectContactMethodStepComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(3, SelectContactMethodStepComponent_div_3_Template, 4, 1, "div", 2);
        i0.ɵɵelementStart(4, "div", 0)(5, "div", 3);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 0)(8, "div", 4)(9, "div", 5);
        i0.ɵɵtemplate(10, SelectContactMethodStepComponent_label_10_Template, 11, 3, "label", 6);
        i0.ɵɵtemplate(11, SelectContactMethodStepComponent_label_11_Template, 11, 3, "label", 6);
        i0.ɵɵelementStart(12, "button", 7);
        i0.ɵɵlistener("click", function SelectContactMethodStepComponent_Template_button_click_12_listener() { return ctx.onSendCode(); });
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 0)(15, "div", 8);
        i0.ɵɵtext(16);
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.subheaderText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.maxRequestsExceeded);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.authenticationMethodText);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", !!(ctx.obfuscatedEmailSegments == null ? null : ctx.obfuscatedEmailSegments.end));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !!(ctx.obfuscatedCellPhoneSegments == null ? null : ctx.obfuscatedCellPhoneSegments.end));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.sendCodeText);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.expirationText);
    } }, dependencies: [i1$2.NgIf, IconAriaAttributesDirective], styles: [".radio-item[_ngcontent-%COMP%]{display:flex;text-align:left;cursor:pointer}.obfuscated[_ngcontent-%COMP%]{font-size:28px;margin-top:-5px}.radio-text[_ngcontent-%COMP%]{display:flex;align-items:center}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectContactMethodStepComponent, [{
        type: Component,
        args: [{ selector: 'vnext-select-contact-method-step', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row mt-3\">\r\n  <div class=\"col-12 Spa_Style_Paragraph\">{{ subheaderText }}</div>\r\n</div>\r\n<div *ngIf=\"maxRequestsExceeded\" class=\"row mt-3\">\r\n  <div class=\"col-12 error-container\"><i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>{{ maxRequestsExceededText }}</div>\r\n</div>\r\n<div class=\"row mt-3\">\r\n  <div class=\"col-12 Spa_Style_Bold_Weight\">{{ authenticationMethodText }}</div>\r\n</div>\r\n<div class=\"row mt-3\">\r\n  <div class=\"col-12\">\r\n    <div class=\"d-inline-block Spa_Style_Small_Font\">\r\n      <label *ngIf=\"!!obfuscatedEmailSegments?.end\" class=\"radio-item\">\r\n        <div class=\"mr-2\">\r\n          <input\r\n            type=\"radio\"\r\n            name=\"contactMethodRadioGroup\"\r\n            aria-labelledby=\"emailAddressLabelId\"\r\n            (change)=\"radioChange(MFA_CONTACT_TYPES.EMAIL)\"\r\n          />\r\n        </div>\r\n        <div>\r\n          <div id=\"emailAddressLabelId\" class=\"Spa_Style_Bold_Weight\">{{ emailAddressText }}</div>\r\n          <div class=\"radio-text\">\r\n            <span class=\"obfuscated Spa_Style_Bold_Weight\">{{ obfuscatedEmailSegments.start }}</span\r\n            ><span class=\"non-obfuscated\">{{ obfuscatedEmailSegments.end }}</span>\r\n          </div>\r\n        </div>\r\n      </label>\r\n      <label *ngIf=\"!!obfuscatedCellPhoneSegments?.end\" class=\"radio-item\">\r\n        <div class=\"mr-2\">\r\n          <input\r\n            type=\"radio\"\r\n            name=\"contactMethodRadioGroup\"\r\n            aria-labelledby=\"cellphoneNumberLabelId\"\r\n            (change)=\"radioChange(MFA_CONTACT_TYPES.PHONE)\"\r\n          />\r\n        </div>\r\n        <div>\r\n          <div id=\"cellphoneNumberLabelId\" class=\"Spa_Style_Bold_Weight\">{{ cellphoneNumberText }}</div>\r\n          <div class=\"radio-text\">\r\n            <span class=\"obfuscated Spa_Style_Bold_Weight\">{{ obfuscatedCellPhoneSegments.start }}</span\r\n            ><span class=\"non-obfuscated\">{{ obfuscatedCellPhoneSegments.end }}</span>\r\n          </div>\r\n        </div>\r\n      </label>\r\n      <button class=\"btn Spa_Style_PrimaryButton w-100 mt-4\" (click)=\"onSendCode()\">{{ sendCodeText }}</button>\r\n      <div class=\"row mt-3\">\r\n        <div class=\"col-12 Spa_Style_Note\">{{ expirationText }}</div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".radio-item{display:flex;text-align:left;cursor:pointer}.obfuscated{font-size:28px;margin-top:-5px}.radio-text{display:flex;align-items:center}\n"] }]
    }], null, { obfuscatedEmailSegments: [{
            type: Input
        }], obfuscatedCellPhoneSegments: [{
            type: Input
        }], subheaderText: [{
            type: Input
        }], authenticationMethodText: [{
            type: Input
        }], emailAddressText: [{
            type: Input
        }], cellphoneNumberText: [{
            type: Input
        }], sendCodeText: [{
            type: Input
        }], expirationText: [{
            type: Input
        }], maxRequestsExceeded: [{
            type: Input
        }], maxRequestsExceededText: [{
            type: Input
        }], sendCode: [{
            type: Output
        }] }); })();

class PINLockedStepComponent {
    constructor() {
        this.goBackHome = new EventEmitter();
    }
    backToHome() {
        this.goBackHome.emit();
    }
}
PINLockedStepComponent.ɵfac = function PINLockedStepComponent_Factory(t) { return new (t || PINLockedStepComponent)(); };
PINLockedStepComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PINLockedStepComponent, selectors: [["vnext-pin-locked-step"]], inputs: { selectedContactMethod: "selectedContactMethod", obfuscatedEmailSegments: "obfuscatedEmailSegments", obfuscatedCellPhoneSegments: "obfuscatedCellPhoneSegments", enterCodeEmailTextSegments: "enterCodeEmailTextSegments", enterCodeMobilePhoneTextSegments: "enterCodeMobilePhoneTextSegments", expirationText: "expirationText", verificationAttemptsExceededText: "verificationAttemptsExceededText", goHomeButtonText: "goHomeButtonText" }, outputs: { goBackHome: "goBackHome" }, decls: 8, vars: 8, consts: [[3, "selectedContactMethod", "obfuscatedEmailSegments", "obfuscatedCellPhoneSegments", "enterCodeEmailTextSegments", "enterCodeMobilePhoneTextSegments", "expirationText"], [1, "row", "justify-content-center", "mt-3"], [1, "col-12", "col-sm-6", "col-md-4"], [1, "error-container", "mb-3", "d-flex", "align-items-baseline", "text-left", "Spa_Style_Small_Font"], [1, "fas", "fa-exclamation-circle"], [1, "btn", "w-100", "px-3", "mt-4", "Spa_Style_PrimaryButton", 3, "click"]], template: function PINLockedStepComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "vnext-verification-code-sent", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3);
        i0.ɵɵelement(4, "i", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "button", 5);
        i0.ɵɵlistener("click", function PINLockedStepComponent_Template_button_click_6_listener() { return ctx.backToHome(); });
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵproperty("selectedContactMethod", ctx.selectedContactMethod)("obfuscatedEmailSegments", ctx.obfuscatedEmailSegments)("obfuscatedCellPhoneSegments", ctx.obfuscatedCellPhoneSegments)("enterCodeEmailTextSegments", ctx.enterCodeEmailTextSegments)("enterCodeMobilePhoneTextSegments", ctx.enterCodeMobilePhoneTextSegments)("expirationText", ctx.expirationText);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", ctx.verificationAttemptsExceededText, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.goHomeButtonText);
    } }, dependencies: [IconAriaAttributesDirective, VerificationCodeSentComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PINLockedStepComponent, [{
        type: Component,
        args: [{ selector: 'vnext-pin-locked-step', changeDetection: ChangeDetectionStrategy.OnPush, template: "<vnext-verification-code-sent\r\n  [selectedContactMethod]=\"selectedContactMethod\"\r\n  [obfuscatedEmailSegments]=\"obfuscatedEmailSegments\"\r\n  [obfuscatedCellPhoneSegments]=\"obfuscatedCellPhoneSegments\"\r\n  [enterCodeEmailTextSegments]=\"enterCodeEmailTextSegments\"\r\n  [enterCodeMobilePhoneTextSegments]=\"enterCodeMobilePhoneTextSegments\"\r\n  [expirationText]=\"expirationText\"\r\n></vnext-verification-code-sent>\r\n\r\n<div class=\"row justify-content-center mt-3\">\r\n  <div class=\"col-12 col-sm-6 col-md-4\">\r\n    <div class=\"error-container mb-3 d-flex align-items-baseline text-left Spa_Style_Small_Font\">\r\n      <i class=\"fas fa-exclamation-circle\"></i>\r\n      {{ verificationAttemptsExceededText }}\r\n    </div>\r\n\r\n    <button class=\"btn w-100 px-3 mt-4 Spa_Style_PrimaryButton\" (click)=\"backToHome()\">{{ goHomeButtonText }}</button>\r\n  </div>\r\n</div>\r\n" }]
    }], null, { selectedContactMethod: [{
            type: Input
        }], obfuscatedEmailSegments: [{
            type: Input
        }], obfuscatedCellPhoneSegments: [{
            type: Input
        }], enterCodeEmailTextSegments: [{
            type: Input
        }], enterCodeMobilePhoneTextSegments: [{
            type: Input
        }], expirationText: [{
            type: Input
        }], verificationAttemptsExceededText: [{
            type: Input
        }], goHomeButtonText: [{
            type: Input
        }], goBackHome: [{
            type: Output
        }] }); })();

function MultiFactorAuthenticationComponent_div_2_vnext_link_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 12);
    i0.ɵɵlistener("click", function MultiFactorAuthenticationComponent_div_2_vnext_link_1_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.backToPrevious()); })("keyup.enter", function MultiFactorAuthenticationComponent_div_2_vnext_link_1_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r9.backToPrevious()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r6.Spa_Site_Previous)("showArrow", "left")("alwaysUnderlined", true);
} }
function MultiFactorAuthenticationComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, MultiFactorAuthenticationComponent_div_2_vnext_link_1_Template, 1, 3, "vnext-link", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_Previous");
} }
function MultiFactorAuthenticationComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-select-contact-method-step", 13);
    i0.ɵɵlistener("sendCode", function MultiFactorAuthenticationComponent_ng_container_11_Template_vnext_select_contact_method_step_sendCode_1_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.sendCode($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("obfuscatedEmailSegments", ctx_r1.obfuscatedEmailSegments)("obfuscatedCellPhoneSegments", ctx_r1.obfuscatedCellPhoneSegments)("subheaderText", ctx_r1.Spa_Site_MFA_Subheader_Text)("authenticationMethodText", ctx_r1.Spa_MFA_AuthenticationMethod_Text)("emailAddressText", ctx_r1.Spa_Site_EmailAddress_Text)("cellphoneNumberText", ctx_r1.Spa_Site_CellPhoneNumber_Text)("sendCodeText", ctx_r1.Spa_MFA_SendCode_Text)("expirationText", ctx_r1.Spa_Site_MFA_Expiration_Text)("maxRequestsExceeded", ctx_r1.maxRequestsExceeded)("maxRequestsExceededText", ctx_r1.Spa_Site_MFA_Max_Codes_Text);
} }
function MultiFactorAuthenticationComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-enter-verification-code-step", 14);
    i0.ɵɵlistener("validateTOTPCode", function MultiFactorAuthenticationComponent_ng_container_12_Template_vnext_enter_verification_code_step_validateTOTPCode_1_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.validateTOTPCode($event)); })("resendCode", function MultiFactorAuthenticationComponent_ng_container_12_Template_vnext_enter_verification_code_step_resendCode_1_listener() { i0.ɵɵrestoreView(_r13); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.resendCode()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("selectedContactMethod", ctx_r2.selectedContactMethod)("codeVerificationForm", ctx_r2.codeVerificationForm)("totpLength", ctx_r2.totpLength)("obfuscatedEmailSegments", ctx_r2.obfuscatedEmailSegments)("obfuscatedCellPhoneSegments", ctx_r2.obfuscatedCellPhoneSegments)("enterCodeEmailTextSegments", ctx_r2.enterCodeEmailTextSegments)("enterCodeMobilePhoneTextSegments", ctx_r2.enterCodeMobilePhoneTextSegments)("expirationText", ctx_r2.Spa_Site_MFA_Expiration_Text)("enterCodeLabelText", ctx_r2.Spa_Site_MFA_Modal_EnterCode_Label_Text)("continueButtonText", ctx_r2.Spa_Site_Continue)("resendCodeText", ctx_r2.Spa_Site_MFA_Resend_Code_Text)("resendCodeLinkText", ctx_r2.Spa_Site_MFA_Resend_Code_Link_Text)("codeSentText", ctx_r2.Spa_Site_MFA_CodeSent_Text)("errorKeywordText", ctx_r2.Spa_Site_ErrorKeyword_Text)("verificationCodeErrorText", ctx_r2.Spa_Retention_MFA_Modal_Verification_Code_Error_Text)("displayCodeSentText", ctx_r2.displayCodeSentText)("maxRequestsExceeded", ctx_r2.maxRequestsExceeded)("maxRequestsExceededText", ctx_r2.Spa_Site_MFA_Max_Codes_Text);
} }
function MultiFactorAuthenticationComponent_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-pin-locked-step", 15);
    i0.ɵɵlistener("goBackHome", function MultiFactorAuthenticationComponent_ng_container_13_Template_vnext_pin_locked_step_goBackHome_1_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.backToHome()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("selectedContactMethod", ctx_r3.selectedContactMethod)("obfuscatedEmailSegments", ctx_r3.obfuscatedEmailSegments)("obfuscatedCellPhoneSegments", ctx_r3.obfuscatedCellPhoneSegments)("enterCodeEmailTextSegments", ctx_r3.enterCodeEmailTextSegments)("enterCodeMobilePhoneTextSegments", ctx_r3.enterCodeMobilePhoneTextSegments)("expirationText", ctx_r3.Spa_Site_MFA_Expiration_Text)("verificationAttemptsExceededText", ctx_r3.Spa_Login_ConsumerAttemptsExceeded_Text)("goHomeButtonText", ctx_r3.Spa_Consumer_MFA_HomeButton_Text);
} }
function MultiFactorAuthenticationComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-contact-your-agent-step", 16);
    i0.ɵɵlistener("goBackHome", function MultiFactorAuthenticationComponent_ng_container_14_Template_vnext_contact_your_agent_step_goBackHome_1_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.backToHome()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("contactYourAgentTextSegments", ctx_r4.contactYourAgentTextSegments)("contactYourAgentLink", ctx_r4.contactYourAgentLink)("goHomeButtonText", ctx_r4.Spa_Consumer_MFA_HomeButton_Text);
} }
function MultiFactorAuthenticationComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17)(1, "vnext-inner-text-link", 18);
    i0.ɵɵlistener("innerTextClicked", function MultiFactorAuthenticationComponent_div_15_Template_vnext_inner_text_link_innerTextClicked_1_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r19.navigateToConsumerLogin()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("outerText", ctx_r5.Spa_Consumer_MFA_Login_Text)("innerText", ctx_r5.Spa_Consumer_MFA_Login_ClickableText);
} }
let MultiFactorAuthenticationComponent = class MultiFactorAuthenticationComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, navigationService, profileService, configResourceService, memberSessionService, mfaService, formBuilder, spinnerService, navigationUtilityService, retentionFacade, injector, agentService, activatedRoute, siteService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.navigationService = navigationService;
        this.profileService = profileService;
        this.configResourceService = configResourceService;
        this.memberSessionService = memberSessionService;
        this.mfaService = mfaService;
        this.formBuilder = formBuilder;
        this.spinnerService = spinnerService;
        this.navigationUtilityService = navigationUtilityService;
        this.retentionFacade = retentionFacade;
        this.injector = injector;
        this.agentService = agentService;
        this.activatedRoute = activatedRoute;
        this.siteService = siteService;
        this.Spa_Consumer_MFA_ContactAgent_Text = 'An email address or mobile phone number is required for two step verification on this site, please <contactYourAgent> to have these added to your account.';
        this.Spa_Consumer_MFA_ContactAgentLink_Text = 'contact your agent';
        this.Spa_Consumer_MFA_HomeButton_Text = 'Go back to login';
        this.Spa_Retention_MFA_EnterCode_Email_Text = '[[Spa_ClientName]] has sent a verification code to <emailAddress>. Please check your spam folder before requesting a new code.';
        this.Spa_Retention_MFA_EnterCode_MobilePhone_Text = '[[Spa_ClientName]] has sent a verification code to <mobilePhoneNumber>.';
        this.Spa_Site_MFA_Expiration_Text = 'This code will expire in 15 minutes.';
        this.Spa_Site_MFA_Modal_EnterCode_Label_Text = 'Enter code';
        this.Spa_Site_Continue = 'Continue';
        this.Spa_Site_MFA_Resend_Code_Text = "It may take a minute to receive your code. Haven't received it?";
        this.Spa_Site_MFA_Resend_Code_Link_Text = 'Resend code';
        this.Spa_Site_MFA_CodeSent_Text = "We've sent you another code.";
        this.Spa_Retention_MFA_Modal_Verification_Code_Error_Text = 'Please enter a valid code';
        this.Spa_Login_ConsumerAttemptsExceeded_Text = 'You login attempts have been exceeded. Try again later.';
        this.Spa_Site_ErrorKeyword_Text = 'Error:';
        this.Spa_Site_MFA_Header_Text = '2 step verification';
        this.Spa_Site_MFA_Subheader_Text = 'This site uses 2 Step Verification for additional security when signing into your account.';
        this.Spa_MFA_AuthenticationMethod_Text = 'Select where to receive your code';
        this.Spa_Site_EmailAddress_Text = 'Email address';
        this.Spa_Site_CellPhoneNumber_Text = 'Mobile phone number';
        this.Spa_MFA_SendCode_Text = 'Send code';
        this.Spa_MFA_Title_Text = 'Security and privacy';
        this.Spa_Site_Previous = 'previous';
        this.Spa_MFA_TextMessage_Body = 'Hello, Enter the following code where prompted on the site to verify your account. This code expires in 15 minutes. Verification code: [mfaCode]';
        this.Spa_Site_MFA_Email_Subject = '[[Spa_ClientName]] Account Verification';
        this.Spa_Site_MFA_Max_Codes_Text = 'Too many codes requested, please try again later';
        this.Spa_Site_Loader_Message_Json = [];
        this.Spa_HeaderFooter_PrimaryClientLogo = '';
        this.Spa_HeaderFooter_PrimaryClientLogo_Url = '';
        this.Spa_HeaderFooter_SecondaryClientLogo = '';
        this.Spa_HeaderFooter_SecondaryClientLogo_Url = '';
        this.Spa_Consumer_MFA_Login_Text = 'or Login';
        this.Spa_Consumer_MFA_Login_ClickableText = 'Login';
        this.multiFactorAuthenticationStep = MultiFactorAuthenticationStep;
        this.totpLength = 6;
        this.contactYourAgentLink = {
            title: this.Spa_Consumer_MFA_ContactAgentLink_Text,
            action: SubHeaderActions.CONTACT
        };
        this.obfuscatedEmailSegments = {
            start: '',
            end: ''
        };
        this.obfuscatedCellPhoneSegments = {
            start: '',
            end: ''
        };
        this.contactYourAgentTextSegments = {
            start: '',
            end: ''
        };
        this.enterCodeEmailTextSegments = {
            start: '',
            end: ''
        };
        this.enterCodeMobilePhoneTextSegments = {
            start: '',
            end: ''
        };
        this.selectedContactMethod = null;
        this.displayCodeSentText = false;
        this.maxRequestsExceeded = false;
        this.showLoginLink = false;
        this.urlParamsExist = false;
        this.isRetentionSite = false;
        this.memberLogoutRedirectPageTag = this.configResourceService.getProcessedResourceValue('Spa_Site_Retention_MemberLogout_RedirectPageTag', null, PageTags.RETENTION);
        this.subscriptions = new Subscription();
    }
    preProcessProperties() {
        this.contactYourAgentTextSegments = this.getSplittedTextSegments(this.Spa_Consumer_MFA_ContactAgent_Text, '<contactYourAgent>');
        this.enterCodeEmailTextSegments = this.getSplittedTextSegments(this.Spa_Retention_MFA_EnterCode_Email_Text, '<emailAddress>');
        this.enterCodeMobilePhoneTextSegments = this.getSplittedTextSegments(this.Spa_Retention_MFA_EnterCode_MobilePhone_Text, '<mobilePhoneNumber>');
        this.contactYourAgentLink = {
            title: this.Spa_Consumer_MFA_ContactAgentLink_Text,
            action: SubHeaderActions.CONTACT
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.currentAuthenticationStep$ = this.mfaService.getCurrentAuthenticationStep$();
        this.codeVerificationForm = this.getTOTPCodeVerificationForm();
        this.subscriptions.add(this.activatedRoute.queryParams
            .pipe(switchMap((params) => {
            if (params?.accountGuid) {
                this.urlParamsExist = true;
                this.showLoginLink = true;
                this.spinnerService.show(SpinnerEvent.AUTHENTICATION_LOADING);
                this.accountGuid = params.accountGuid;
                const authInfo = {
                    auth1: params.accountGuid
                };
                return this.memberSessionService.authenticateConsumerFromEnrollment$(authInfo);
            }
            // Returns of(null) instead of EMPTY,
            // Reason: EMPTY completes the inner observable, breaking the switchMap chain, calling the callback()`complete` instead of `next()`
            return of(null);
        }), switchMap((response) => {
            this.spinnerService.hide(SpinnerEvent.AUTHENTICATION_LOADING);
            if (response?.profile) {
                return this.profileService.updateProfile$(response.profile);
            }
            // Returns of(null) instead of EMPTY,
            // Reason: EMPTY completes the inner observable, breaking the switchMap chain, calling the callback()`complete` instead of `next()`
            return of(null);
        }))
            .subscribe({
            next: () => {
                this.initAuthenticationStep();
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.mfaService.getSelectedContactMethod$().subscribe({
            next: selectedContactMethod => {
                this.selectedContactMethod = selectedContactMethod;
                this.cdr.markForCheck();
            }
        }));
        this.isRetentionSite = this.siteService.isRetentionView();
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
    navigateToConsumerLogin() {
        this.navigationService.navigateByPageTag(PageTags.HOME);
    }
    sendCode(selectedContactMethod) {
        if (selectedContactMethod !== null) {
            const sendCodeOperation$ = this.getSendCodeOperation$(selectedContactMethod);
            this.subscriptions.add(sendCodeOperation$.subscribe({
                next: response => {
                    if (!this.maxRequestsExceeded) {
                        this.mfaService.setSelectedContactMethod(selectedContactMethod);
                        this.mfaService.setCurrentAuthenticationStep(MultiFactorAuthenticationStep.ENTER_VERIFICATION_CODE);
                    }
                }
            }));
        }
    }
    resendCode() {
        if (this.selectedContactMethod !== null) {
            const sendCodeOperation$ = this.getSendCodeOperation$(this.selectedContactMethod);
            this.subscriptions.add(sendCodeOperation$.subscribe({
                next: response => {
                    if (!this.maxRequestsExceeded &&
                        this.mfaService.isCurrentAuthenticationStep(MultiFactorAuthenticationStep.ENTER_VERIFICATION_CODE)) {
                        this.displayCodeSentText = true;
                        this.cdr.markForCheck();
                    }
                }
            }));
        }
    }
    validateTOTPCode(submittedTOTPCode) {
        const { totpCode } = submittedTOTPCode;
        const loaderText = this.navigationUtilityService.getLoaderTextByPageTag(this.Spa_Site_Loader_Message_Json, this.getNextPageTag());
        this.spinnerService.show(SpinnerEvent.SUBMITTED_FORM_LOADING, undefined, loaderText);
        this.mfaService.validateTOTPCode(totpCode, this.urlParamsExist, this.accountGuid).then(hasLoginError => {
            if (hasLoginError) {
                this.setCodeVerificationFormInvalid();
            }
            else if (this.urlParamsExist) {
                this.loginConsumerWithTOTPCode();
            }
            else {
                this.handleRetentionMemberLogin();
            }
            this.spinnerService.hide(SpinnerEvent.SUBMITTED_FORM_LOADING);
            this.cdr.markForCheck();
        });
    }
    loginConsumerWithTOTPCode() {
        this.navigationService.navigateByPageTag(PageTags.CONSUMER_ACCOUNT_SUMMARY);
    }
    async handleRetentionMemberLogin() {
        return await this.retentionFacade.handleRetentionMemberLogin(this.getNextPageTag(), this.injector);
    }
    backToPrevious() {
        if (this.mfaService.isCurrentAuthenticationStep(MultiFactorAuthenticationStep.ENTER_VERIFICATION_CODE)) {
            this.mfaService.resetMultiFactorAuthenticationStep();
            this.codeVerificationForm.reset();
            this.displayCodeSentText = false;
            this.cdr.markForCheck();
        }
        else {
            this.backToHome();
        }
    }
    backToHome() {
        this.memberSessionService.memberLogout({ clearMultiFactorAuthenticationSteps: false });
        const pageTag = this.isRetentionSite ? this.memberLogoutRedirectPageTag : PageTags.HOME;
        this.navigationService.navigateByPageTag(pageTag).then(() => {
            this.mfaService.resetMultiFactorAuthenticationStep();
        });
    }
    getSplittedTextSegments(text, separator) {
        const [start = '', end = ''] = text?.split(separator) ?? [];
        return { start, end };
    }
    initAuthenticationStep() {
        const obfuscatedEmail = this.profileService.getEmailAddress();
        const obfuscatedCellPhone = this.profileService.getCellPhone();
        if (!obfuscatedEmail && !obfuscatedCellPhone) {
            this.mfaService.setCurrentAuthenticationStep(MultiFactorAuthenticationStep.CONTACT_YOUR_AGENT);
        }
        // If they previously had to contact their agent because they lacked a contact method, we will reset the steps now that they have one contact method available
        else if (this.mfaService.isCurrentAuthenticationStep(MultiFactorAuthenticationStep.CONTACT_YOUR_AGENT)) {
            this.mfaService.resetMultiFactorAuthenticationStep();
        }
        if (obfuscatedEmail) {
            this.obfuscatedEmailSegments = this.getObfuscatedSegments(obfuscatedEmail);
        }
        if (obfuscatedCellPhone) {
            this.obfuscatedCellPhoneSegments = this.getObfuscatedSegments(obfuscatedCellPhone);
        }
    }
    getObfuscatedSegments(obfuscatedText) {
        const end = obfuscatedText.replace(/\*/g, '');
        const start = obfuscatedText.replace(end, '').replace(/\*/g, '•');
        return { start, end };
    }
    getTOTPCodeVerificationForm() {
        const totpCodeControl = VnextFormControl.create({
            name: 'totpCode',
            formState: '',
            validatorOrOpts: {
                validators: [
                    Validators.required,
                    Validators.minLength(this.totpLength),
                    Validators.maxLength(this.totpLength),
                    Validators.pattern(/^\d+?$/)
                ],
                updateOn: 'submit'
            }
        });
        return this.formBuilder.group({ [totpCodeControl.name]: totpCodeControl });
    }
    getSendCodeOperation$(selectedContactMethod) {
        this.maxRequestsExceeded = false;
        let messageTemplate$;
        if (selectedContactMethod === MFA_CONTACT_TYPES.EMAIL) {
            messageTemplate$ = this.mfaService.getMFAEmailTemplate$();
        }
        else if (selectedContactMethod === MFA_CONTACT_TYPES.PHONE) {
            // TODO: SPA-14304, make sure this key has the actual desired value.
            messageTemplate$ = of(this.Spa_MFA_TextMessage_Body);
        }
        return messageTemplate$.pipe(switchMap(messageTemplate => {
            const accountGuid$ = this.accountGuid ? of(this.accountGuid) : of(null);
            return accountGuid$.pipe(switchMap(accountGuid => this.mfaService.sendVerificationCode$(selectedContactMethod, messageTemplate, this.Spa_Site_MFA_Email_Subject, accountGuid)));
        }), take(1), catchError((error) => {
            const errorBody = error?.error;
            if (errorBody?.Status === HttpStatusCode.TOO_MANY_REQUESTS) {
                this.maxRequestsExceeded = true;
                this.cdr.detectChanges();
                return of(null);
            }
            else {
                throw error;
            }
        }));
    }
    setCodeVerificationFormInvalid() {
        if (this.mfaService.isCurrentAuthenticationStep(MultiFactorAuthenticationStep.ENTER_VERIFICATION_CODE)) {
            this.codeVerificationForm.setErrors({ invalid: true });
            // We call "cdr.markForCheck()" on EnterVerificationCodeStepComponent to check for changes in that component and display the form's error message
            this.enterVerificationCodeStepComponent?.markForCheck();
            this.enterVerificationCodeStepComponent?.enterTotpCodeField?.nativeElement?.focus();
        }
    }
    getNextPageTag() {
        const isPurlRedirectEnabled = this.agentService.isPurlRedirectEnabled();
        const consumerAccountSummary = this.configResourceService.getProcessedResourceValue('Spa_Agent_Profile_PURLToConsumerAccount_RedirectPageTag', null, PageTags.CONSUMER_ACCOUNT_SUMMARY);
        const retentionSummary = this.configResourceService.getProcessedResourceValue('Spa_RetentionSite_Custom_Navigation_PageTag', null, PageTags.RETENTION_SUMMARY);
        return isPurlRedirectEnabled ? consumerAccountSummary : retentionSummary;
    }
};
MultiFactorAuthenticationComponent.ɵfac = function MultiFactorAuthenticationComponent_Factory(t) { return new (t || MultiFactorAuthenticationComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.ProfileService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.MultiFactorAuthenticationService), i0.ɵɵdirectiveInject(i4.UntypedFormBuilder), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(RetentionFacade), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i1.SiteService)); };
MultiFactorAuthenticationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MultiFactorAuthenticationComponent, selectors: [["vnext-multi-factor-authentication"]], viewQuery: function MultiFactorAuthenticationComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(EnterVerificationCodeStepComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.enterVerificationCodeStepComponent = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 16, vars: 16, consts: [[3, "headerType", "primaryLogo", "primaryLogoUrl", "secondaryLogo", "secondaryLogoUrl"], [1, "container", "text-center", "Spa_Style_Primary_Color"], ["class", "col-auto mx-auto mt-5", 4, "ngIf"], [1, "row", "mt-3"], [1, "col-12", "Spa_Style_H1"], [1, "row", "mt-2"], [1, "col-12", "Spa_Style_H2"], [3, "ngSwitch"], [4, "ngSwitchCase"], ["class", "mt-2 Spa_Style_Paragraph", 4, "ngIf"], [1, "col-auto", "mx-auto", "mt-5"], [3, "title", "showArrow", "alwaysUnderlined", "click", "keyup.enter", 4, "liveEditProp"], [3, "title", "showArrow", "alwaysUnderlined", "click", "keyup.enter"], [3, "obfuscatedEmailSegments", "obfuscatedCellPhoneSegments", "subheaderText", "authenticationMethodText", "emailAddressText", "cellphoneNumberText", "sendCodeText", "expirationText", "maxRequestsExceeded", "maxRequestsExceededText", "sendCode"], [3, "selectedContactMethod", "codeVerificationForm", "totpLength", "obfuscatedEmailSegments", "obfuscatedCellPhoneSegments", "enterCodeEmailTextSegments", "enterCodeMobilePhoneTextSegments", "expirationText", "enterCodeLabelText", "continueButtonText", "resendCodeText", "resendCodeLinkText", "codeSentText", "errorKeywordText", "verificationCodeErrorText", "displayCodeSentText", "maxRequestsExceeded", "maxRequestsExceededText", "validateTOTPCode", "resendCode"], [3, "selectedContactMethod", "obfuscatedEmailSegments", "obfuscatedCellPhoneSegments", "enterCodeEmailTextSegments", "enterCodeMobilePhoneTextSegments", "expirationText", "verificationAttemptsExceededText", "goHomeButtonText", "goBackHome"], [3, "contactYourAgentTextSegments", "contactYourAgentLink", "goHomeButtonText", "goBackHome"], [1, "mt-2", "Spa_Style_Paragraph"], [3, "outerText", "innerText", "innerTextClicked"]], template: function MultiFactorAuthenticationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "vnext-dynamic-header", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, MultiFactorAuthenticationComponent_div_2_Template, 2, 1, "div", 2);
        i0.ɵɵelementStart(3, "div", 3)(4, "div", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "div", 5)(7, "div", 6);
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementContainerStart(9, 7);
        i0.ɵɵpipe(10, "async");
        i0.ɵɵtemplate(11, MultiFactorAuthenticationComponent_ng_container_11_Template, 2, 10, "ng-container", 8);
        i0.ɵɵtemplate(12, MultiFactorAuthenticationComponent_ng_container_12_Template, 2, 18, "ng-container", 8);
        i0.ɵɵtemplate(13, MultiFactorAuthenticationComponent_ng_container_13_Template, 2, 8, "ng-container", 8);
        i0.ɵɵtemplate(14, MultiFactorAuthenticationComponent_ng_container_14_Template, 2, 3, "ng-container", 8);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵtemplate(15, MultiFactorAuthenticationComponent_div_15_Template, 2, 2, "div", 9);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("headerType", "basic")("primaryLogo", ctx.Spa_HeaderFooter_PrimaryClientLogo)("primaryLogoUrl", ctx.Spa_HeaderFooter_PrimaryClientLogo_Url)("secondaryLogo", ctx.Spa_HeaderFooter_SecondaryClientLogo)("secondaryLogoUrl", ctx.Spa_HeaderFooter_SecondaryClientLogo_Url);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isRetentionSite);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.Spa_MFA_Title_Text);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.Spa_Site_MFA_Header_Text);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitch", i0.ɵɵpipeBind1(10, 14, ctx.currentAuthenticationStep$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngSwitchCase", ctx.multiFactorAuthenticationStep.SELECT_CONTACT_METHOD);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.multiFactorAuthenticationStep.ENTER_VERIFICATION_CODE);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.multiFactorAuthenticationStep.PIN_LOCKED);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", ctx.multiFactorAuthenticationStep.CONTACT_YOUR_AGENT);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showLoginLink);
    } }, dependencies: [i1$2.NgIf, i1$2.NgSwitch, i1$2.NgSwitchCase, LinkComponent, InnerTextLinkComponent, LiveEditPropDirective, ContactYourAgentStepComponent, SelectContactMethodStepComponent, EnterVerificationCodeStepComponent, PINLockedStepComponent, DynamicHeaderComponent, i1$2.AsyncPipe], encapsulation: 2, changeDetection: 0 });
__decorate([
    GlobalResource(true)
], MultiFactorAuthenticationComponent.prototype, "Spa_Consumer_MFA_ContactAgent_Text", void 0);
__decorate([
    GlobalResource(true)
], MultiFactorAuthenticationComponent.prototype, "Spa_Consumer_MFA_ContactAgentLink_Text", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_Consumer_MFA_HomeButton_Text", void 0);
__decorate([
    GlobalResource(true)
], MultiFactorAuthenticationComponent.prototype, "Spa_Retention_MFA_EnterCode_Email_Text", void 0);
__decorate([
    GlobalResource(true)
], MultiFactorAuthenticationComponent.prototype, "Spa_Retention_MFA_EnterCode_MobilePhone_Text", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_Site_MFA_Expiration_Text", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_Site_MFA_Modal_EnterCode_Label_Text", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_Site_Continue", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_Site_MFA_Resend_Code_Text", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_Site_MFA_Resend_Code_Link_Text", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_Site_MFA_CodeSent_Text", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_Retention_MFA_Modal_Verification_Code_Error_Text", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_Login_ConsumerAttemptsExceeded_Text", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_Site_ErrorKeyword_Text", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_Site_MFA_Header_Text", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_Site_MFA_Subheader_Text", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_MFA_AuthenticationMethod_Text", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_Site_EmailAddress_Text", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_Site_CellPhoneNumber_Text", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_MFA_SendCode_Text", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_MFA_Title_Text", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_Site_Previous", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_MFA_TextMessage_Body", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_Site_MFA_Email_Subject", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_Site_MFA_Max_Codes_Text", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_Site_Loader_Message_Json", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo_Url", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo_Url", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_Consumer_MFA_Login_Text", void 0);
__decorate([
    GlobalResource()
], MultiFactorAuthenticationComponent.prototype, "Spa_Consumer_MFA_Login_ClickableText", void 0);
__decorate([
    Memoize()
], MultiFactorAuthenticationComponent.prototype, "getSplittedTextSegments", null);
MultiFactorAuthenticationComponent = __decorate([
    PlatformWidget
], MultiFactorAuthenticationComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiFactorAuthenticationComponent, [{
        type: Component,
        args: [{ selector: 'vnext-multi-factor-authentication', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<vnext-dynamic-header\r\n  [headerType]=\"'basic'\"\r\n  [primaryLogo]=\"Spa_HeaderFooter_PrimaryClientLogo\"\r\n  [primaryLogoUrl]=\"Spa_HeaderFooter_PrimaryClientLogo_Url\"\r\n  [secondaryLogo]=\"Spa_HeaderFooter_SecondaryClientLogo\"\r\n  [secondaryLogoUrl]=\"Spa_HeaderFooter_SecondaryClientLogo_Url\"\r\n>\r\n</vnext-dynamic-header>\r\n<div class=\"container text-center Spa_Style_Primary_Color\">\r\n  <div *ngIf=\"isRetentionSite\" class=\"col-auto mx-auto mt-5\">\r\n    <vnext-link\r\n      [title]=\"Spa_Site_Previous\"\r\n      [showArrow]=\"'left'\"\r\n      [alwaysUnderlined]=\"true\"\r\n      (click)=\"backToPrevious()\"\r\n      (keyup.enter)=\"backToPrevious()\"\r\n      *liveEditProp=\"'Spa_Site_Previous'\"\r\n    >\r\n    </vnext-link>\r\n  </div>\r\n  <div class=\"row mt-3\">\r\n    <div class=\"col-12 Spa_Style_H1\">{{ Spa_MFA_Title_Text }}</div>\r\n  </div>\r\n  <div class=\"row mt-2\">\r\n    <div class=\"col-12 Spa_Style_H2\">{{ Spa_Site_MFA_Header_Text }}</div>\r\n  </div>\r\n\r\n  <ng-container [ngSwitch]=\"currentAuthenticationStep$ | async\">\r\n    <ng-container *ngSwitchCase=\"multiFactorAuthenticationStep.SELECT_CONTACT_METHOD\">\r\n      <vnext-select-contact-method-step\r\n        [obfuscatedEmailSegments]=\"obfuscatedEmailSegments\"\r\n        [obfuscatedCellPhoneSegments]=\"obfuscatedCellPhoneSegments\"\r\n        [subheaderText]=\"Spa_Site_MFA_Subheader_Text\"\r\n        [authenticationMethodText]=\"Spa_MFA_AuthenticationMethod_Text\"\r\n        [emailAddressText]=\"Spa_Site_EmailAddress_Text\"\r\n        [cellphoneNumberText]=\"Spa_Site_CellPhoneNumber_Text\"\r\n        [sendCodeText]=\"Spa_MFA_SendCode_Text\"\r\n        [expirationText]=\"Spa_Site_MFA_Expiration_Text\"\r\n        [maxRequestsExceeded]=\"maxRequestsExceeded\"\r\n        [maxRequestsExceededText]=\"Spa_Site_MFA_Max_Codes_Text\"\r\n        (sendCode)=\"sendCode($event)\"\r\n      ></vnext-select-contact-method-step>\r\n    </ng-container>\r\n\r\n    <ng-container *ngSwitchCase=\"multiFactorAuthenticationStep.ENTER_VERIFICATION_CODE\">\r\n      <vnext-enter-verification-code-step\r\n        [selectedContactMethod]=\"selectedContactMethod\"\r\n        [codeVerificationForm]=\"codeVerificationForm\"\r\n        [totpLength]=\"totpLength\"\r\n        [obfuscatedEmailSegments]=\"obfuscatedEmailSegments\"\r\n        [obfuscatedCellPhoneSegments]=\"obfuscatedCellPhoneSegments\"\r\n        [enterCodeEmailTextSegments]=\"enterCodeEmailTextSegments\"\r\n        [enterCodeMobilePhoneTextSegments]=\"enterCodeMobilePhoneTextSegments\"\r\n        [expirationText]=\"Spa_Site_MFA_Expiration_Text\"\r\n        [enterCodeLabelText]=\"Spa_Site_MFA_Modal_EnterCode_Label_Text\"\r\n        [continueButtonText]=\"Spa_Site_Continue\"\r\n        [resendCodeText]=\"Spa_Site_MFA_Resend_Code_Text\"\r\n        [resendCodeLinkText]=\"Spa_Site_MFA_Resend_Code_Link_Text\"\r\n        [codeSentText]=\"Spa_Site_MFA_CodeSent_Text\"\r\n        [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n        [verificationCodeErrorText]=\"Spa_Retention_MFA_Modal_Verification_Code_Error_Text\"\r\n        [displayCodeSentText]=\"displayCodeSentText\"\r\n        [maxRequestsExceeded]=\"maxRequestsExceeded\"\r\n        [maxRequestsExceededText]=\"Spa_Site_MFA_Max_Codes_Text\"\r\n        (validateTOTPCode)=\"validateTOTPCode($event)\"\r\n        (resendCode)=\"resendCode()\"\r\n      ></vnext-enter-verification-code-step>\r\n    </ng-container>\r\n\r\n    <ng-container *ngSwitchCase=\"multiFactorAuthenticationStep.PIN_LOCKED\">\r\n      <vnext-pin-locked-step\r\n        [selectedContactMethod]=\"selectedContactMethod\"\r\n        [obfuscatedEmailSegments]=\"obfuscatedEmailSegments\"\r\n        [obfuscatedCellPhoneSegments]=\"obfuscatedCellPhoneSegments\"\r\n        [enterCodeEmailTextSegments]=\"enterCodeEmailTextSegments\"\r\n        [enterCodeMobilePhoneTextSegments]=\"enterCodeMobilePhoneTextSegments\"\r\n        [expirationText]=\"Spa_Site_MFA_Expiration_Text\"\r\n        [verificationAttemptsExceededText]=\"Spa_Login_ConsumerAttemptsExceeded_Text\"\r\n        [goHomeButtonText]=\"Spa_Consumer_MFA_HomeButton_Text\"\r\n        (goBackHome)=\"backToHome()\"\r\n      ></vnext-pin-locked-step>\r\n    </ng-container>\r\n\r\n    <ng-container *ngSwitchCase=\"multiFactorAuthenticationStep.CONTACT_YOUR_AGENT\">\r\n      <vnext-contact-your-agent-step\r\n        [contactYourAgentTextSegments]=\"contactYourAgentTextSegments\"\r\n        [contactYourAgentLink]=\"contactYourAgentLink\"\r\n        [goHomeButtonText]=\"Spa_Consumer_MFA_HomeButton_Text\"\r\n        (goBackHome)=\"backToHome()\"\r\n      ></vnext-contact-your-agent-step>\r\n    </ng-container>\r\n  </ng-container>\r\n  <div *ngIf=\"showLoginLink\" class=\"mt-2 Spa_Style_Paragraph\">\r\n    <vnext-inner-text-link\r\n      [outerText]=\"Spa_Consumer_MFA_Login_Text\"\r\n      [innerText]=\"Spa_Consumer_MFA_Login_ClickableText\"\r\n      (innerTextClicked)=\"navigateToConsumerLogin()\"\r\n    >\r\n    </vnext-inner-text-link>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.NavigationService }, { type: i1.ProfileService }, { type: i1.ConfigResourceService }, { type: i1.MemberSessionService }, { type: i1.MultiFactorAuthenticationService }, { type: i4.UntypedFormBuilder }, { type: i1.SpinnerService }, { type: i1.NavigationUtilityService }, { type: RetentionFacade }, { type: i0.Injector }, { type: i1.AgentService }, { type: i2$1.ActivatedRoute }, { type: i1.SiteService }]; }, { Spa_Consumer_MFA_ContactAgent_Text: [], Spa_Consumer_MFA_ContactAgentLink_Text: [], Spa_Consumer_MFA_HomeButton_Text: [], Spa_Retention_MFA_EnterCode_Email_Text: [], Spa_Retention_MFA_EnterCode_MobilePhone_Text: [], Spa_Site_MFA_Expiration_Text: [], Spa_Site_MFA_Modal_EnterCode_Label_Text: [], Spa_Site_Continue: [], Spa_Site_MFA_Resend_Code_Text: [], Spa_Site_MFA_Resend_Code_Link_Text: [], Spa_Site_MFA_CodeSent_Text: [], Spa_Retention_MFA_Modal_Verification_Code_Error_Text: [], Spa_Login_ConsumerAttemptsExceeded_Text: [], Spa_Site_ErrorKeyword_Text: [], Spa_Site_MFA_Header_Text: [], Spa_Site_MFA_Subheader_Text: [], Spa_MFA_AuthenticationMethod_Text: [], Spa_Site_EmailAddress_Text: [], Spa_Site_CellPhoneNumber_Text: [], Spa_MFA_SendCode_Text: [], Spa_MFA_Title_Text: [], Spa_Site_Previous: [], Spa_MFA_TextMessage_Body: [], Spa_Site_MFA_Email_Subject: [], Spa_Site_MFA_Max_Codes_Text: [], Spa_Site_Loader_Message_Json: [], Spa_HeaderFooter_PrimaryClientLogo: [], Spa_HeaderFooter_PrimaryClientLogo_Url: [], Spa_HeaderFooter_SecondaryClientLogo: [], Spa_HeaderFooter_SecondaryClientLogo_Url: [], Spa_Consumer_MFA_Login_Text: [], Spa_Consumer_MFA_Login_ClickableText: [], enterVerificationCodeStepComponent: [{
            type: ViewChild,
            args: [EnterVerificationCodeStepComponent]
        }], getSplittedTextSegments: [] }); })();

const MEMBER_RECORDING_PLACEHOLDER = '<member>';

function RecordingsComponent_vnext_link_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 7);
    i0.ɵɵlistener("click", function RecordingsComponent_vnext_link_3_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onPreviousClick()); })("keyup.enter", function RecordingsComponent_vnext_link_3_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.onPreviousClick()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r0.Spa_Site_Previous)("showArrow", "left");
} }
const _c0$E = function (a0) { return { "border-right": a0 }; };
function RecordingsComponent_div_8_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵelementStart(2, "span", 18);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const callRecord_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$E, ctx_r7.agentCallRecordsMap[callRecord_r6.recordingID] == null ? null : ctx_r7.agentCallRecordsMap[callRecord_r6.recordingID].hasEnrollment));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r7.Spa_Site_SOA_Text);
} }
const _c1$8 = function (a0) { return { "pl-2": a0 }; };
function RecordingsComponent_div_8_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "i", 17);
    i0.ɵɵelementStart(2, "span", 18);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const callRecord_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1$8, ctx_r8.agentCallRecordsMap[callRecord_r6.recordingID] == null ? null : ctx_r8.agentCallRecordsMap[callRecord_r6.recordingID].hasSOA));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r8.Spa_Site_Enrollment_Text);
} }
function RecordingsComponent_div_8_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 11);
    i0.ɵɵelement(2, "vnext-call-recording-audio-player", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 13)(4, "div", 14);
    i0.ɵɵtemplate(5, RecordingsComponent_div_8_div_1_div_5_Template, 4, 4, "div", 15);
    i0.ɵɵtemplate(6, RecordingsComponent_div_8_div_1_div_6_Template, 4, 4, "div", 15);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const callRecord_r6 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("callRecord", callRecord_r6)("pacificStandardTimeText", ctx_r5.Spa_EnrollmentHistory_Pacific_StandardTime_Text)("showVerticalPadding", false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r5.agentCallRecordsMap[callRecord_r6.recordingID] == null ? null : ctx_r5.agentCallRecordsMap[callRecord_r6.recordingID].hasSOA);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.agentCallRecordsMap[callRecord_r6.recordingID] == null ? null : ctx_r5.agentCallRecordsMap[callRecord_r6.recordingID].hasEnrollment);
} }
function RecordingsComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, RecordingsComponent_div_8_div_1_Template, 7, 5, "div", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.agentCallRecords)("ngForTrackBy", ctx_r1.trackByRecordingId);
} }
let RecordingsComponent = class RecordingsComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, sessionService, profileService, localeService, analyticsService, router) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.sessionService = sessionService;
        this.profileService = profileService;
        this.localeService = localeService;
        this.analyticsService = analyticsService;
        this.router = router;
        this.Spa_Profile_Recordings_Header_Text = `Recordings for ${MEMBER_RECORDING_PLACEHOLDER}`;
        this.Spa_Profile_AgentCallRecording_DisplayPlayAudioRecording_Enabled = false;
        this.Spa_EnrollmentHistory_Pacific_StandardTime_Text = 'PST';
        this.Spa_Site_Enrollment_Text = 'Enrollment';
        this.Spa_Site_SOA_Text = 'SOA';
        this.Spa_Site_Previous = 'Previous';
        this.agentCallRecordsMap = {};
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        super.ngOnInit();
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe((locale) => {
            this.headerText = this.Spa_Profile_Recordings_Header_Text.replace(MEMBER_RECORDING_PLACEHOLDER, this.profileService.getMemberFullName());
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.sessionService.getMemberAgentCallRecords$().subscribe({
            next: (agentCallRecords) => {
                this.agentCallRecords = agentCallRecords;
                this.agentCallRecords.forEach((callRecord) => {
                    this.agentCallRecordsMap[callRecord.recordingID] = {
                        hasSOA: callRecord.enrollments.some((enrollment) => enrollment.enrollmentType === AgentCallRecordingEnrollmentType.SOA),
                        hasEnrollment: callRecord.enrollments.some((enrollment) => enrollment.enrollmentType === AgentCallRecordingEnrollmentType.ENROLLMENT)
                    };
                });
                this.cdr.markForCheck();
            }
        }));
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.PAGE_PATH]: this.router.url,
            [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE
        };
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
    onPreviousClick() {
        this.configurableWidgetService.navigationService.backToPrevious();
    }
    trackByRecordingId(index, agentCallRecord) {
        return agentCallRecord.recordingID;
    }
};
RecordingsComponent.ɵfac = function RecordingsComponent_Factory(t) { return new (t || RecordingsComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.ProfileService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i2$1.Router)); };
RecordingsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RecordingsComponent, selectors: [["vnext-recordings"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 9, vars: 3, consts: [[1, "container", "recordings-wrapper"], [1, "row"], [1, "col-auto", "mx-auto", "text-center", "backToPlans"], [3, "title", "showArrow", "click", "keyup.enter", 4, "liveEditProp"], [1, "col-12", "text-center"], [1, "py-4", "Spa_Style_H1"], ["class", "row justify-content-center justify-content-xl-start", 4, "ngIf"], [3, "title", "showArrow", "click", "keyup.enter"], [1, "row", "justify-content-center", "justify-content-xl-start"], ["class", "col-12 row recording-card-container", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "col-12", "row", "recording-card-container"], [1, "col-12", "col-md-9"], [3, "callRecord", "pacificStandardTimeText", "showVerticalPadding"], [1, "col-12", "col-md-3"], [1, "row", "mx-0"], ["class", "completed-form d-flex align-items-center", 3, "ngClass", 4, "ngIf"], [1, "completed-form", "d-flex", "align-items-center", 3, "ngClass"], [1, "check-circle", "fas", "fa-check-circle"], [1, "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font"]], template: function RecordingsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, RecordingsComponent_vnext_link_3_Template, 1, 2, "vnext-link", 3);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 1)(5, "div", 4)(6, "h1", 5);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(8, RecordingsComponent_div_8_Template, 2, 2, "div", 6);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_Previous");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.headerText);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.agentCallRecords == null ? null : ctx.agentCallRecords.length);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LinkComponent, LiveEditPropDirective, IconAriaAttributesDirective, CallRecordingAudioPlayerComponent], styles: [".recordings-wrapper[_ngcontent-%COMP%]{margin:32px auto}.recording-card-container[_ngcontent-%COMP%]{padding:10px;position:relative;margin-top:10px;display:flex;word-wrap:break-word;background-color:#fff;border:1px solid var(--static-Spa_Style_Accent1);border-radius:4px}.check-circle[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent5);padding-right:5px;font-size:14px}.completed-form[_ngcontent-%COMP%]{padding-right:10px}.border-right[_ngcontent-%COMP%]{border-right:1px solid var(--static-Spa_Style_Accent1)}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], RecordingsComponent.prototype, "Spa_Profile_Recordings_Header_Text", void 0);
__decorate([
    GlobalResource()
], RecordingsComponent.prototype, "Spa_Profile_AgentCallRecording_DisplayPlayAudioRecording_Enabled", void 0);
__decorate([
    GlobalResource()
], RecordingsComponent.prototype, "Spa_EnrollmentHistory_Pacific_StandardTime_Text", void 0);
__decorate([
    GlobalResource()
], RecordingsComponent.prototype, "Spa_Site_Enrollment_Text", void 0);
__decorate([
    GlobalResource()
], RecordingsComponent.prototype, "Spa_Site_SOA_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], RecordingsComponent.prototype, "Spa_Site_Previous", void 0);
RecordingsComponent = __decorate([
    PlatformWidget
], RecordingsComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RecordingsComponent, [{
        type: Component,
        args: [{ selector: 'vnext-recordings', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"container recordings-wrapper\">\r\n  <div class=\"row\">\r\n    <div class=\"col-auto mx-auto text-center backToPlans\">\r\n      <vnext-link\r\n        [title]=\"Spa_Site_Previous\"\r\n        [showArrow]=\"'left'\"\r\n        (click)=\"onPreviousClick()\"\r\n        (keyup.enter)=\"onPreviousClick()\"\r\n        *liveEditProp=\"'Spa_Site_Previous'\"\r\n      >\r\n      </vnext-link>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-12 text-center\">\r\n      <h1 class=\"py-4 Spa_Style_H1\">{{ headerText }}</h1>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row justify-content-center justify-content-xl-start\" *ngIf=\"agentCallRecords?.length\">\r\n    <div class=\"col-12 row recording-card-container\" *ngFor=\"let callRecord of agentCallRecords; trackBy: trackByRecordingId\">\r\n      <div class=\"col-12 col-md-9\">\r\n        <vnext-call-recording-audio-player\r\n          [callRecord]=\"callRecord\"\r\n          [pacificStandardTimeText]=\"Spa_EnrollmentHistory_Pacific_StandardTime_Text\"\r\n          [showVerticalPadding]=\"false\"\r\n        ></vnext-call-recording-audio-player>\r\n      </div>\r\n\r\n      <div class=\"col-12 col-md-3\">\r\n        <div class=\"row mx-0\">\r\n          <div\r\n            *ngIf=\"agentCallRecordsMap[callRecord.recordingID]?.hasSOA\"\r\n            class=\"completed-form d-flex align-items-center\"\r\n            [ngClass]=\"{ 'border-right': agentCallRecordsMap[callRecord.recordingID]?.hasEnrollment }\"\r\n          >\r\n            <i class=\"check-circle fas fa-check-circle\"></i>\r\n            <span class=\"Spa_Style_Gray4_Color Spa_Style_Smaller_Font\">{{ Spa_Site_SOA_Text }}</span>\r\n          </div>\r\n          <div\r\n            *ngIf=\"agentCallRecordsMap[callRecord.recordingID]?.hasEnrollment\"\r\n            class=\"completed-form d-flex align-items-center\"\r\n            [ngClass]=\"{ 'pl-2': agentCallRecordsMap[callRecord.recordingID]?.hasSOA }\"\r\n          >\r\n            <i class=\"check-circle fas fa-check-circle\"></i>\r\n            <span class=\"Spa_Style_Gray4_Color Spa_Style_Smaller_Font\">{{ Spa_Site_Enrollment_Text }}</span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>", styles: [".recordings-wrapper{margin:32px auto}.recording-card-container{padding:10px;position:relative;margin-top:10px;display:flex;word-wrap:break-word;background-color:#fff;border:1px solid var(--static-Spa_Style_Accent1);border-radius:4px}.check-circle{color:var(--static-Spa_Style_Accent5);padding-right:5px;font-size:14px}.completed-form{padding-right:10px}.border-right{border-right:1px solid var(--static-Spa_Style_Accent1)}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.MemberSessionService }, { type: i1.ProfileService }, { type: i1.LocaleService }, { type: AnalyticsService }, { type: i2$1.Router }]; }, { Spa_Profile_Recordings_Header_Text: [], Spa_Profile_AgentCallRecording_DisplayPlayAudioRecording_Enabled: [], Spa_EnrollmentHistory_Pacific_StandardTime_Text: [], Spa_Site_Enrollment_Text: [], Spa_Site_SOA_Text: [], Spa_Site_Previous: [] }); })();

function ResetPasswordComponent_div_2_ng_container_4_div_3_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.Spa_Profile_PasswordRequired_Error, " ");
} }
function ResetPasswordComponent_div_2_ng_container_4_div_3_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.Spa_Profile_PasswordInvalid_Error, " ");
} }
function ResetPasswordComponent_div_2_ng_container_4_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "i", 20);
    i0.ɵɵtemplate(2, ResetPasswordComponent_div_2_ng_container_4_div_3_span_2_Template, 2, 1, "span", 21);
    i0.ɵɵtemplate(3, ResetPasswordComponent_div_2_ng_container_4_div_3_span_3_Template, 2, 1, "span", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.getErrors("password").required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.getErrors("password").pattern);
} }
function ResetPasswordComponent_div_2_ng_container_4_div_13_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.Spa_Profile_PasswordConfirmRequired_Error, " ");
} }
function ResetPasswordComponent_div_2_ng_container_4_div_13_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.Spa_Profile_PasswordMismatch_Error, " ");
} }
function ResetPasswordComponent_div_2_ng_container_4_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelement(1, "i", 20);
    i0.ɵɵtemplate(2, ResetPasswordComponent_div_2_ng_container_4_div_13_span_2_Template, 2, 1, "span", 21);
    i0.ɵɵtemplate(3, ResetPasswordComponent_div_2_ng_container_4_div_13_span_3_Template, 2, 1, "span", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.getErrors("passwordConfirm").required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.getErrors("passwordConfirm").valueMismatch);
} }
const _c0$D = function (a0) { return { "error-border": a0 }; };
function ResetPasswordComponent_div_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "form", 8);
    i0.ɵɵlistener("ngSubmit", function ResetPasswordComponent_div_2_ng_container_4_Template_form_ngSubmit_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.submitPasswordReset()); });
    i0.ɵɵelementStart(2, "label", 9);
    i0.ɵɵtemplate(3, ResetPasswordComponent_div_2_ng_container_4_div_3_Template, 4, 2, "div", 10);
    i0.ɵɵelementStart(4, "div")(5, "span", 11);
    i0.ɵɵtext(6, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 12);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "input", 13);
    i0.ɵɵlistener("blur", function ResetPasswordComponent_div_2_ng_container_4_Template_input_blur_9_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r12.revalidateConfirm()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "p", 14);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "label", 15);
    i0.ɵɵtemplate(13, ResetPasswordComponent_div_2_ng_container_4_div_13_Template, 4, 2, "div", 10);
    i0.ɵɵelementStart(14, "div")(15, "span", 11);
    i0.ɵɵtext(16, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "span", 12);
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(19, "input", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "button", 17);
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "vnext-inner-text-link", 18);
    i0.ɵɵlistener("innerTextClicked", function ResetPasswordComponent_div_2_ng_container_4_Template_vnext_inner_text_link_innerTextClicked_22_listener() { i0.ɵɵrestoreView(_r11); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.navToLogin()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r1.resetPasswordForm);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.fieldCanShowErrors("password"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r1.Spa_Profile_Password_Label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c0$D, ctx_r1.fieldCanShowErrors("password")));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.Spa_Profile_PasswordHint_Text, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.fieldCanShowErrors("passwordConfirm"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r1.Spa_Profile_PasswordConfirm_Label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c0$D, ctx_r1.fieldCanShowErrors("passwordConfirm")));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate("Reset password");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("outerText", ctx_r1.Spa_LoginWidget_LoginToAccount_Text)("innerText", ctx_r1.Spa_LoginWidget_LoginToAccount_ClickableText)("customTextClass", "Spa_Style_Paragraph")("customClass", "Spa_Style_Link");
} }
function ResetPasswordComponent_div_2_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p", 22);
    i0.ɵɵelement(1, "i", 23);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 24);
    i0.ɵɵlistener("click", function ResetPasswordComponent_div_2_ng_template_5_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r14.navToLogin()); });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.Spa_PasswordReset_Successful_Text);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.Spa_LoginWidget_Login_Header_Text);
} }
function ResetPasswordComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "h2", 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 5);
    i0.ɵɵtemplate(4, ResetPasswordComponent_div_2_ng_container_4_Template, 23, 17, "ng-container", 6);
    i0.ɵɵtemplate(5, ResetPasswordComponent_div_2_ng_template_5_Template, 5, 2, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r2 = i0.ɵɵreference(6);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.Spa_PasswordReset_Header_Text);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.passwordResetSuccessful)("ngIfElse", _r2);
} }
let ResetPasswordComponent = class ResetPasswordComponent extends ConfigurableWidget {
    constructor(passwordResetService, navigationService, activatedRoute, formValidationService, analyticsService, router, cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.passwordResetService = passwordResetService;
        this.navigationService = navigationService;
        this.activatedRoute = activatedRoute;
        this.formValidationService = formValidationService;
        this.analyticsService = analyticsService;
        this.router = router;
        this.Spa_Site_AgentDomain = 'DRX';
        this.Spa_PasswordReset_Header_Text = 'Reset your password';
        this.Spa_PasswordReset_Successful_Text = 'Your account has been reset';
        this.Spa_Profile_PasswordHint_Text = 'Must contain at least 8 characters with 1 number and 1 capital letter.';
        this.Spa_Profile_Password_Label = 'Create a password';
        this.Spa_Profile_PasswordRequired_Error = 'Please provide a password';
        this.Spa_Profile_PasswordInvalid_Error = 'Please provide a valid password';
        this.Spa_Profile_PasswordConfirm_Label = 'Confirm password';
        this.Spa_Profile_PasswordConfirmRequired_Error = 'Please confirm your password';
        this.Spa_Profile_PasswordMismatch_Error = 'Passwords do not match';
        this.Spa_LoginWidget_LoginToAccount_Text = 'Or login to your account';
        this.Spa_LoginWidget_Login_Header_Text = 'Login';
        this.Spa_LoginWidget_LoginToAccount_ClickableText = 'login';
        this.Spa_Agent_HashValidity_Time = 60;
        this.Spa_Consumer_HashValidity_Time = 60;
        this.Spa_HeaderFooter_PrimaryClientLogo = '';
        this.Spa_HeaderFooter_PrimaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_HeaderFooter_SecondaryClientLogo = '';
        this.Spa_HeaderFooter_SecondaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.hashChecked = false;
        this.passwordResetSuccessful = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.subscriptions = [
            this.activatedRoute.queryParams.subscribe({
                next: params => {
                    this.resetHash = params.r;
                    this.userName = params.u;
                    this.userEmail = params.e;
                    this.userType = params.t;
                    if (this.resetHash && this.userName) {
                        const hashValidityTime = this.userType === PasswordResetUserType.AGENT ? this.Spa_Agent_HashValidity_Time : this.Spa_Consumer_HashValidity_Time;
                        if (this.userType === PasswordResetUserType.CONSUMER) {
                            this.hashChecked = true;
                            this.cdr.markForCheck();
                        }
                        else {
                            this.passwordResetService
                                .validateRecoveryHash(this.resetHash, hashValidityTime, this.userType)
                                .catch(error => {
                                this.navigationService.navigateTo404();
                            })
                                .finally(() => {
                                this.hashChecked = true;
                                this.cdr.markForCheck();
                            });
                        }
                    }
                    else {
                        this.navigationService.navigateTo404();
                    }
                }
            })
        ];
        this.resetPasswordForm = new UntypedFormGroup({
            password: new UntypedFormControl('', [Validators.required, Validators.pattern(this.formValidationService.alphaNumericPasswordPattern)]),
            passwordConfirm: new UntypedFormControl('', [Validators.required])
        }, { updateOn: 'blur', validators: [this.formValidationService.getMatchFieldsValidator('password', 'passwordConfirm')] });
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    fieldCanShowErrors(fieldName) {
        const control = this.resetPasswordForm.get(fieldName);
        return control.errors && control.touched;
    }
    getErrors(fieldName) {
        return this.resetPasswordForm.get(fieldName).errors;
    }
    submitPasswordReset() {
        this.resetPasswordForm.markAllAsTouched();
        if (this.resetPasswordForm.status === 'VALID') {
            this.passwordResetService
                .resetPassword(this.userName, this.resetPasswordForm.get('password').value, this.Spa_Site_AgentDomain, this.userType, this.resetHash)
                .then(success => {
                this.passwordResetSuccessful = true;
            })
                .catch(error => {
                this.resetPasswordForm.get('password').setErrors({ pattern: true });
            })
                .finally(() => {
                this.cdr.markForCheck();
            });
        }
    }
    navToLogin() {
        if (this.userType === PasswordResetUserType.AGENT) {
            this.navigationService.navigateByPageTag(PageTags.AGENT_LOGIN);
        }
        else {
            this.navigationService.navigateByPageTag(PageTags.HOME);
        }
    }
    revalidateConfirm() {
        // this fixes a rare case where someone may type in the confirm password field first, then the create
        this.resetPasswordForm.get('passwordConfirm').updateValueAndValidity();
    }
    get isLiveEdit() {
        const environment = EnvironmentService.getEnvironment();
        return environment.liveedit;
    }
};
ResetPasswordComponent.ɵfac = function ResetPasswordComponent_Factory(t) { return new (t || ResetPasswordComponent)(i0.ɵɵdirectiveInject(i1.PasswordResetService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i1.FormValidationService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService)); };
ResetPasswordComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ResetPasswordComponent, selectors: [["vnext-reset-password"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 7, consts: [[3, "headerType", "primaryLogo", "primaryLogoUrl", "secondaryLogo", "secondaryLogoUrl"], ["vnextGoogleTagManager", "", 1, "reset-password-container", "container", 3, "saveDefaultValues"], ["class", "row", 4, "ngIf"], [1, "row"], [1, "col-xs-12", "col-md-6", "offset-xs-0", "offset-md-3", "password-reset-header"], [1, "col-xs-12", "col-md-6", "col-lg-4", "offset-xs-0", "offset-md-3", "offset-lg-4", "text-center"], [4, "ngIf", "ngIfElse"], ["passwordResetSuccessfulTemplate", ""], ["disableKeyDownSubmit", "", 3, "formGroup", "ngSubmit"], ["for", "password", 1, "text-left", "px-0", "col-12"], ["class", "error-container", 4, "ngIf"], [1, "input-error-asterisk"], [1, "Spa_Style_Label", "input-label-text"], ["id", "password", "type", "password", "formControlName", "password", "maxlength", "100", 1, "col-12", 3, "ngClass", "blur"], [1, "text-left", "px-0", "Spa_Style_Note"], ["for", "passwordConfirm", 1, "text-left", "px-0", "col-12"], ["id", "passwordConfirm", "type", "password", "formControlName", "passwordConfirm", "maxlength", "100", 1, "col-12", 3, "ngClass"], ["type", "submit", 1, "btn", "Spa_Style_PrimaryButton", "col-12"], [1, "", 3, "outerText", "innerText", "customTextClass", "customClass", "innerTextClicked"], [1, "error-container"], ["aria-hidden", "true", 1, "fa", "fa-exclamation-circle"], [4, "ngIf"], [1, "email-success"], ["aria-hidden", "true", 1, "fas", "fa-check-circle"], [1, "btn", "Spa_Style_PrimaryButton", "col-12", 3, "click"]], template: function ResetPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "vnext-dynamic-header", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, ResetPasswordComponent_div_2_Template, 7, 3, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("headerType", "basic")("primaryLogo", ctx.Spa_HeaderFooter_PrimaryClientLogo)("primaryLogoUrl", ctx.Spa_HeaderFooter_PrimaryClientLogo_Url)("secondaryLogo", ctx.Spa_HeaderFooter_SecondaryClientLogo)("secondaryLogoUrl", ctx.Spa_HeaderFooter_SecondaryClientLogo_Url);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("saveDefaultValues", ctx.analyticsService.isDefaultTagToUpdate);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hashChecked || ctx.isLiveEdit);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.MaxLengthValidator, i4.FormGroupDirective, i4.FormControlName, InnerTextLinkComponent, FormInputSubmitDirective, GoogleTagManagerDirective, IconAriaAttributesDirective, DynamicHeaderComponent], styles: [".btn[_ngcontent-%COMP%]{margin-bottom:15px}.password-reset-header[_ngcontent-%COMP%]{margin-top:60px;margin-bottom:15px;text-align:center}.reset-password-container[_ngcontent-%COMP%]{margin-top:30px}.email-success[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text);white-space:pre-wrap;margin-top:30px}.email-success[_ngcontent-%COMP%] > .fa-check-circle[_ngcontent-%COMP%]{margin-right:5px}button[_ngcontent-%COMP%]{margin-top:30px}.error-border[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent2)}"] });
__decorate([
    GlobalResource()
], ResetPasswordComponent.prototype, "Spa_Site_AgentDomain", void 0);
__decorate([
    GlobalResource()
], ResetPasswordComponent.prototype, "Spa_PasswordReset_Header_Text", void 0);
__decorate([
    GlobalResource()
], ResetPasswordComponent.prototype, "Spa_PasswordReset_Successful_Text", void 0);
__decorate([
    GlobalResource()
], ResetPasswordComponent.prototype, "Spa_Profile_PasswordHint_Text", void 0);
__decorate([
    GlobalResource()
], ResetPasswordComponent.prototype, "Spa_Profile_Password_Label", void 0);
__decorate([
    GlobalResource()
], ResetPasswordComponent.prototype, "Spa_Profile_PasswordRequired_Error", void 0);
__decorate([
    GlobalResource()
], ResetPasswordComponent.prototype, "Spa_Profile_PasswordInvalid_Error", void 0);
__decorate([
    GlobalResource()
], ResetPasswordComponent.prototype, "Spa_Profile_PasswordConfirm_Label", void 0);
__decorate([
    GlobalResource()
], ResetPasswordComponent.prototype, "Spa_Profile_PasswordConfirmRequired_Error", void 0);
__decorate([
    GlobalResource()
], ResetPasswordComponent.prototype, "Spa_Profile_PasswordMismatch_Error", void 0);
__decorate([
    GlobalResource()
], ResetPasswordComponent.prototype, "Spa_LoginWidget_LoginToAccount_Text", void 0);
__decorate([
    GlobalResource()
], ResetPasswordComponent.prototype, "Spa_LoginWidget_Login_Header_Text", void 0);
__decorate([
    GlobalResource()
], ResetPasswordComponent.prototype, "Spa_LoginWidget_LoginToAccount_ClickableText", void 0);
__decorate([
    GlobalResource()
], ResetPasswordComponent.prototype, "Spa_Agent_HashValidity_Time", void 0);
__decorate([
    GlobalResource()
], ResetPasswordComponent.prototype, "Spa_Consumer_HashValidity_Time", void 0);
__decorate([
    GlobalResource()
], ResetPasswordComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo", void 0);
__decorate([
    GlobalResource()
], ResetPasswordComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo_Url", void 0);
__decorate([
    GlobalResource()
], ResetPasswordComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo", void 0);
__decorate([
    GlobalResource()
], ResetPasswordComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo_Url", void 0);
__decorate([
    LiveEditInactive()
], ResetPasswordComponent.prototype, "submitPasswordReset", null);
__decorate([
    LiveEditInactive()
], ResetPasswordComponent.prototype, "navToLogin", null);
ResetPasswordComponent = __decorate([
    PlatformWidget
], ResetPasswordComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ResetPasswordComponent, [{
        type: Component,
        args: [{ selector: 'vnext-reset-password', providers: [WidgetService], template: "<vnext-dynamic-header\r\n  [headerType]=\"'basic'\"\r\n  [primaryLogo]=\"Spa_HeaderFooter_PrimaryClientLogo\"\r\n  [primaryLogoUrl]=\"Spa_HeaderFooter_PrimaryClientLogo_Url\"\r\n  [secondaryLogo]=\"Spa_HeaderFooter_SecondaryClientLogo\"\r\n  [secondaryLogoUrl]=\"Spa_HeaderFooter_SecondaryClientLogo_Url\"\r\n>\r\n</vnext-dynamic-header>\r\n<div class=\"reset-password-container container\" vnextGoogleTagManager [saveDefaultValues]=\"analyticsService.isDefaultTagToUpdate\">\r\n  <div class=\"row\" *ngIf=\"hashChecked || isLiveEdit\">\r\n    <h2 class=\"col-xs-12 col-md-6 offset-xs-0 offset-md-3 password-reset-header\">{{ Spa_PasswordReset_Header_Text }}</h2>\r\n    <div class=\"col-xs-12 col-md-6 col-lg-4 offset-xs-0 offset-md-3 offset-lg-4 text-center\">\r\n      <ng-container *ngIf=\"!passwordResetSuccessful; else passwordResetSuccessfulTemplate\"\r\n        ><form disableKeyDownSubmit [formGroup]=\"resetPasswordForm\" (ngSubmit)=\"submitPasswordReset()\">\r\n          <label for=\"password\" class=\"text-left px-0 col-12\">\r\n            <div class=\"error-container\" *ngIf=\"fieldCanShowErrors('password')\">\r\n              <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"getErrors('password').required\"> {{ Spa_Profile_PasswordRequired_Error }} </span>\r\n              <span *ngIf=\"getErrors('password').pattern\"> {{ Spa_Profile_PasswordInvalid_Error }} </span>\r\n            </div>\r\n            <div>\r\n              <span class=\"input-error-asterisk\">*</span\r\n              ><span class=\"Spa_Style_Label input-label-text\">{{ Spa_Profile_Password_Label }}</span>\r\n            </div>\r\n\r\n            <input\r\n              id=\"password\"\r\n              type=\"password\"\r\n              class=\"col-12\"\r\n              formControlName=\"password\"\r\n              maxlength=\"100\"\r\n              [ngClass]=\"{ 'error-border': fieldCanShowErrors('password') }\"\r\n              (blur)=\"revalidateConfirm()\"\r\n            />\r\n          </label>\r\n\r\n          <p class=\"text-left px-0 Spa_Style_Note\">\r\n            {{ Spa_Profile_PasswordHint_Text }}\r\n          </p>\r\n          <label for=\"passwordConfirm\" class=\"text-left px-0 col-12\">\r\n            <div class=\"error-container\" *ngIf=\"fieldCanShowErrors('passwordConfirm')\">\r\n              <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n              <span *ngIf=\"getErrors('passwordConfirm').required\"> {{ Spa_Profile_PasswordConfirmRequired_Error }} </span>\r\n              <span *ngIf=\"getErrors('passwordConfirm').valueMismatch\"> {{ Spa_Profile_PasswordMismatch_Error }} </span>\r\n            </div>\r\n            <div>\r\n              <span class=\"input-error-asterisk\">*</span\r\n              ><span class=\"Spa_Style_Label input-label-text\">{{ Spa_Profile_PasswordConfirm_Label }}</span>\r\n            </div>\r\n\r\n            <input\r\n              id=\"passwordConfirm\"\r\n              type=\"password\"\r\n              class=\"col-12\"\r\n              formControlName=\"passwordConfirm\"\r\n              maxlength=\"100\"\r\n              [ngClass]=\"{ 'error-border': fieldCanShowErrors('passwordConfirm') }\"\r\n            />\r\n          </label>\r\n\r\n          <button type=\"submit\" class=\"btn Spa_Style_PrimaryButton col-12\">{{ 'Reset password' }}</button>\r\n          <vnext-inner-text-link\r\n            class=\"\"\r\n            [outerText]=\"Spa_LoginWidget_LoginToAccount_Text\"\r\n            [innerText]=\"Spa_LoginWidget_LoginToAccount_ClickableText\"\r\n            (innerTextClicked)=\"navToLogin()\"\r\n            [customTextClass]=\"'Spa_Style_Paragraph'\"\r\n            [customClass]=\"'Spa_Style_Link'\"\r\n          ></vnext-inner-text-link></form\r\n      ></ng-container>\r\n      <ng-template #passwordResetSuccessfulTemplate>\r\n        <p class=\"email-success\"><i class=\"fas fa-check-circle\" aria-hidden=\"true\"></i>{{ Spa_PasswordReset_Successful_Text }}</p>\r\n        <button class=\"btn Spa_Style_PrimaryButton col-12\" (click)=\"navToLogin()\">{{ Spa_LoginWidget_Login_Header_Text }}</button>\r\n      </ng-template>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".btn{margin-bottom:15px}.password-reset-header{margin-top:60px;margin-bottom:15px;text-align:center}.reset-password-container{margin-top:30px}.email-success{color:var(--static-Spa_Style_Cost_Text);white-space:pre-wrap;margin-top:30px}.email-success>.fa-check-circle{margin-right:5px}button{margin-top:30px}.error-border{border:1px solid var(--static-Spa_Style_Accent2)}\n"] }]
    }], function () { return [{ type: i1.PasswordResetService }, { type: i1.NavigationService }, { type: i2$1.ActivatedRoute }, { type: i1.FormValidationService }, { type: AnalyticsService }, { type: i2$1.Router }, { type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }]; }, { Spa_Site_AgentDomain: [], Spa_PasswordReset_Header_Text: [], Spa_PasswordReset_Successful_Text: [], Spa_Profile_PasswordHint_Text: [], Spa_Profile_Password_Label: [], Spa_Profile_PasswordRequired_Error: [], Spa_Profile_PasswordInvalid_Error: [], Spa_Profile_PasswordConfirm_Label: [], Spa_Profile_PasswordConfirmRequired_Error: [], Spa_Profile_PasswordMismatch_Error: [], Spa_LoginWidget_LoginToAccount_Text: [], Spa_LoginWidget_Login_Header_Text: [], Spa_LoginWidget_LoginToAccount_ClickableText: [], Spa_Agent_HashValidity_Time: [], Spa_Consumer_HashValidity_Time: [], Spa_HeaderFooter_PrimaryClientLogo: [], Spa_HeaderFooter_PrimaryClientLogo_Url: [], Spa_HeaderFooter_SecondaryClientLogo: [], Spa_HeaderFooter_SecondaryClientLogo_Url: [], submitPasswordReset: [], navToLogin: [] }); })();

const _c0$C = ["userPINField"];
function RetentionLandingComponent_h1_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h1", 30);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r0.Spa_RetentionLanding_Header_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function RetentionLandingComponent_div_13_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.Spa_RetentionLogin_PIN_DOB_Error_Text, " ");
} }
function RetentionLandingComponent_div_13_ng_template_5_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r11.Spa_RetentionLogin_Valid_PIN_DOB_Error_Text, " ");
} }
function RetentionLandingComponent_div_13_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, RetentionLandingComponent_div_13_ng_template_5_ng_container_0_Template, 2, 1, "ng-container", 33);
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r9 = i0.ɵɵreference(8);
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r8.retentionLoginForm.controls.userPIN.invalid && ctx_r8.formSubmitted || ctx_r8.retentionLoginForm.controls.userDateOfBirth.invalid && ctx_r8.formSubmitted)("ngIfElse", _r9);
} }
function RetentionLandingComponent_div_13_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.loginErrorMessageText, " ");
} }
function RetentionLandingComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelement(1, "i", 32);
    i0.ɵɵelementStart(2, "span", 16);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, RetentionLandingComponent_div_13_ng_container_4_Template, 2, 1, "ng-container", 33);
    i0.ɵɵtemplate(5, RetentionLandingComponent_div_13_ng_template_5_Template, 1, 2, "ng-template", null, 34, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(7, RetentionLandingComponent_div_13_ng_template_7_Template, 1, 1, "ng-template", null, 35, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r7 = i0.ɵɵreference(6);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.Spa_Site_ErrorKeyword_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.retentionLoginForm.controls.userPIN.value === "" && ctx_r1.formSubmitted || ctx_r1.retentionLoginForm.controls.userDateOfBirth.value === "" && ctx_r1.formSubmitted)("ngIfElse", _r7);
} }
function RetentionLandingComponent_div_42_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelement(1, "i", 32);
    i0.ɵɵelementStart(2, "span", 16);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.Spa_Site_ErrorKeyword_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.Spa_RetentionLogin_Disclaimer_Error_Text, " ");
} }
function RetentionLandingComponent_ng_container_43_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 42);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r12.Spa_RetentionLogin_Disclaimer_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function RetentionLandingComponent_ng_container_43_vnext_link_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-link", 43);
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("makeInlineBlock", true)("title", ctx_r13.Spa_RetentionLogin_ViewDetails_Link_Text)("keyNameForLiveEdit", "Spa_RetentionLogin_ViewDetails_Link_Text")("alwaysUnderlined", true)("href", ctx_r13.Spa_RetentionLogin_ViewDetails_Link_Url[0].href)("tag", ctx_r13.Spa_RetentionLogin_ViewDetails_Link_Url[0].tag)("linkTarget", ctx_r13.Spa_RetentionLogin_ViewDetails_Link_Url[0].target);
} }
function RetentionLandingComponent_ng_container_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "label", 37);
    i0.ɵɵelement(2, "input", 38);
    i0.ɵɵelementStart(3, "span", 39)(4, "span", 16);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, RetentionLandingComponent_ng_container_43_span_7_Template, 2, 4, "span", 40);
    i0.ɵɵtemplate(8, RetentionLandingComponent_ng_container_43_vnext_link_8_Template, 1, 7, "vnext-link", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-checked", ctx_r4.retentionLoginForm && ctx_r4.retentionLoginForm.controls && ctx_r4.retentionLoginForm.controls.agreeToDisclaimer ? ctx_r4.retentionLoginForm.controls.agreeToDisclaimer.valid : "false");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r4.Spa_Site_Required_Field);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_RetentionLogin_Disclaimer_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.Spa_RetentionLogin_ViewDetails_Link_Enabled);
} }
function RetentionLandingComponent_vnext_link_50_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 44);
    i0.ɵɵlistener("click", function RetentionLandingComponent_vnext_link_50_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.onContinueWithoutPinClick()); })("keyup.enter", function RetentionLandingComponent_vnext_link_50_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r15); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.onContinueWithoutPinClick()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r5.Spa_RetentionLogin_ContinueWithoutPin_Link_Text);
} }
const _c1$7 = function (a0) { return { "background-image": a0 }; };
const _c2$4 = function (a0) { return { "label-invalid": a0 }; };
const _c3 = function (a0) { return { "retention-invalid": a0 }; };
let RetentionLandingComponent = class RetentionLandingComponent extends ConfigurableWidget {
    constructor(cdr, store, widgetValidationService, configurableWidgetService, zoneService, widgetService, navigationService, loginService, loginFacade, imageService, spinnerService, analyticsService, siteService, navigationUtilityService, configResourceService, retentionFacade, agentService, injector) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.store = store;
        this.navigationService = navigationService;
        this.loginService = loginService;
        this.loginFacade = loginFacade;
        this.imageService = imageService;
        this.spinnerService = spinnerService;
        this.analyticsService = analyticsService;
        this.siteService = siteService;
        this.navigationUtilityService = navigationUtilityService;
        this.configResourceService = configResourceService;
        this.retentionFacade = retentionFacade;
        this.agentService = agentService;
        this.injector = injector;
        this.Spa_RetentionLanding_Background_Url = 'phoenix/assets/images/couple_dog.jpg';
        this.Spa_RetentionLanding_Background_UrlMobile = 'phoenix/assets/images/couple_dog_mobile.jpg';
        this.Spa_Site_Required_Field = 'Required Field';
        this.Spa_RetentionLogin_Disclaimer_Enabled = true;
        this.Spa_RetentionLogin_ViewDetails_Link_Enabled = true;
        this.Spa_RetentionLogin_ViewDetails_Link_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_RetentionLogin_Pin_Text = 'PIN Number';
        this.Spa_RetentionLogin_GetStarted_Text = 'Get started';
        this.Spa_RetentionLogin_ContinueWithoutPin_Link_Enabled = true;
        this.Spa_RetentionLogin_ContinueWithoutPin_Link_Text = 'Continue without a Pin';
        this.Spa_RetentionLogin_PIN_DOB_Error_Text = 'Please provide your PIN and date of birth';
        this.Spa_RetentionLogin_Valid_PIN_DOB_Error_Text = 'Please provide valid PIN and date of birth';
        this.Spa_RetentionLogin_Disclaimer_Error_Text = 'Please check the box to continue';
        this.Spa_RetentionLogin_Dob_Text = 'Date of birth:';
        this.Spa_Site_ErrorKeyword_Text = 'Error:';
        this.Spa_Site_IsDeepLinking_Enabled = true;
        this.Spa_Site_MFA_Enabled = false;
        this.Spa_RetentionLanding_Header_Text = `Relax, we've done all the work for you`;
        this.Spa_RetentionLogin_ViewDetails_Link_Text = 'View details';
        this.Spa_RetentionLogin_Disclaimer_Text = '<strong> I agree to using my personal information </strong> to provide recommendations of related products.';
        this.Spa_Site_Loader_Message_Json = [];
        this.Spa_Login_ConsumerAttemptsExceeded_Text = 'You login attempts have been exceeded. Try again later.';
        this.Spa_Login_Error_Message = 'Please provide valid login credentials.';
        this.homePage = PageTags.HOME;
        this.summaryPage = PageTags.RETENTION_SUMMARY;
        this.formSubmitted = false;
        this.disclaimerEnabled = false;
        this.isPinAndDobValid = false;
        this.isDisclaimerValid = false;
        this.isNotAuthorized = false;
        this.mask = '00/00/0000';
        this.checkFocus = false;
    }
    ngOnInit() {
        super.ngOnInit();
        const params = {};
        if (this.siteService.consumerSiteTypeSnapshot() !== ConsumerSiteType.RETENTION) {
            this.siteService.setConsumerSiteType(ConsumerSiteType.RETENTION);
        }
        this.disclaimerEnabled = this.Spa_RetentionLogin_Disclaimer_Enabled;
        const basicData = this.loginFacade.getMemberBasicData();
        this.loginError$ = basicData.loginError$;
        this.retentionLoginForm = new UntypedFormGroup({
            userPIN: new UntypedFormControl('', [Validators.required, Validators.minLength(4)]),
            userDateOfBirth: new UntypedFormControl('', [Validators.required, Validators.pattern(/^\d{8}$/)]),
            agreeToDisclaimer: new UntypedFormControl('', Validators.required)
        });
        // catch and store passed parameter form the summary page
        const passedParams = window.history.state;
        if (passedParams && Object.keys(passedParams).length) {
            Object.assign(params, passedParams);
        }
        this.store.dispatch(new SetDeepLinkingParams(PassParams.mapToDeepLinkingParams(params)));
        this.loaderText = this.getRetentionSummaryLoaderText();
    }
    ngAfterViewChecked() {
        if (this.checkFocus) {
            const firstInvalidRetentionLoginInput = document.querySelector('input.ng-invalid');
            const firstInvalidElement = firstInvalidRetentionLoginInput;
            if (firstInvalidElement) {
                firstInvalidElement.focus();
            }
            this.checkFocus = false;
        }
    }
    getDateOfBirthStatus() {
        return this.retentionLoginForm.controls.userDateOfBirth.invalid;
    }
    getDisclaimerStatus() {
        return this.retentionLoginForm.controls.agreeToDisclaimer.invalid;
    }
    getPinStatus() {
        return this.retentionLoginForm.controls.userPIN.invalid;
    }
    onContinueWithoutPinClick() {
        this.siteService.setConsumerSiteType(ConsumerSiteType.ANONYMOUS);
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_HOME_CONTINUE_WITHOUT_PIN);
        this.navigationService.navigateByPageTag(PageTags.HOME);
    }
    async submitForm() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_HOME_GET_STARTED);
        let isValid = false;
        this.isNotAuthorized = false;
        const userPinInvalid = this.retentionLoginForm.controls.userPIN.invalid;
        const dateOfBirthInvalid = this.retentionLoginForm.controls.userDateOfBirth.invalid;
        this.isDisclaimerValid = this.retentionLoginForm.controls.agreeToDisclaimer.valid;
        this.isPinAndDobValid = !userPinInvalid && !dateOfBirthInvalid;
        // only show validation after unsuccessful login
        this.formSubmitted = true;
        // if disclaimer is not enabled and invalid disclaimer no need to show validation
        if (this.isPinAndDobValid && !this.disclaimerEnabled && !this.isDisclaimerValid) {
            isValid = true;
        }
        // do not authentication/intiate request if pin/dob or disclaimer is invalid (if enabled)
        if (this.isPinAndDobValid && this.disclaimerEnabled && this.isDisclaimerValid) {
            isValid = true;
        }
        if (userPinInvalid || dateOfBirthInvalid || !this.isDisclaimerValid) {
            this.checkFocus = true;
        }
        if (isValid) {
            this.spinnerService.show(SpinnerEvent.SUBMITTED_FORM_LOADING, undefined, this.loaderText);
            const userPIN = this.retentionLoginForm.value.userPIN;
            const userDOB = this.retentionLoginForm.value.userDateOfBirth;
            const authInfo = {
                auth1: userPIN,
                auth2: userDOB
            };
            const memberLoginOptions = {
                ...MemberLoginOptions.createDefaultOptions(),
                planTypesToFetch: ALL_MEDICARE_PLUS_MEDIGAP_PLAN_TYPE_VALUES
            };
            this.loginService.authenticateUserWithPIN(authInfo, memberLoginOptions).then(() => {
                // We would like to avoid overwriting the previous subscription each time we call submitForm.
                // The latest assignment would be unsubscribed in ngOnDestroy as a result.
                // Multiple attempts to submit will overwrite the previous subscription
                // Pipe the observable and take the first emission.
                this.loginError$.pipe(take(1)).subscribe({
                    next: res => {
                        if (!res) {
                            this.handleRetentionMemberLogin();
                        }
                        else {
                            this.isNotAuthorized = true;
                        }
                        this.spinnerService.hide(SpinnerEvent.SUBMITTED_FORM_LOADING);
                        this.cdr.markForCheck();
                    }
                });
            }, error => {
                this.handleLoginError(error);
            });
        }
    }
    async handleRetentionMemberLogin() {
        const nextPageTag = this.getNextPageTag();
        return await this.retentionFacade.handleRetentionMemberLogin(nextPageTag, this.injector);
    }
    getRetentionSummaryLoaderText() {
        const nextPageTag = this.getNextPageTag();
        return this.navigationUtilityService.getLoaderTextByPageTag(this.Spa_Site_Loader_Message_Json, nextPageTag);
    }
    handleLoginError(error) {
        if (error?.status === HttpStatusCode.TOO_MANY_REQUESTS) {
            this.loginErrorMessageText = this.Spa_Login_ConsumerAttemptsExceeded_Text;
        }
        else {
            this.loginErrorMessageText = this.Spa_Login_Error_Message;
        }
        this.userPINField?.nativeElement?.focus();
        this.isNotAuthorized = true;
        this.spinnerService.hide(SpinnerEvent.SUBMITTED_FORM_LOADING);
        this.cdr.markForCheck();
    }
    getNextPageTag() {
        const isMFAEnabled = this.configResourceService.getProcessedResourceValue('Spa_Site_MFA_Enabled', null, false);
        if (isMFAEnabled) {
            return PageTags.BENEFICIARY_AUTHENTICATION;
        }
        const isPurlRedirectEnabled = this.agentService.isPurlRedirectEnabled();
        const consumerAccountSummary = this.configResourceService.getProcessedResourceValue('Spa_Agent_Profile_PURLToConsumerAccount_RedirectPageTag', null, PageTags.CONSUMER_ACCOUNT_SUMMARY);
        const retentionSummary = this.configResourceService.getProcessedResourceValue('Spa_RetentionSite_Custom_Navigation_PageTag', null, PageTags.RETENTION_SUMMARY);
        return isPurlRedirectEnabled ? consumerAccountSummary : retentionSummary;
    }
};
RetentionLandingComponent.ɵfac = function RetentionLandingComponent_Factory(t) { return new (t || RetentionLandingComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.LoginService), i0.ɵɵdirectiveInject(LoginFacade), i0.ɵɵdirectiveInject(i1.ImageService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(i1.NavigationUtilityService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(RetentionFacade), i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(i0.Injector)); };
RetentionLandingComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RetentionLandingComponent, selectors: [["vnext-retention-landing"]], viewQuery: function RetentionLandingComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$C, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.userPINField = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 51, vars: 31, consts: [["vnextGoogleTagManager", "", 1, "Spa_Style_Banner_Background", 3, "saveDefaultValues"], [1, "container", "banner"], [1, "background-img", "d-md-none", 3, "ngStyle"], [1, "background-img", "d-none", "d-md-block", 3, "ngStyle"], ["id", "retention_widget", 1, "retention-widget"], [1, "col-md-10"], [1, "row"], [1, "col-md-8"], ["class", "Spa_Style_H1", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [1, "mt-1"], ["disableKeyDownSubmit", "", 3, "formGroup", "ngSubmit"], [1, "col-xs-12", "col-md-9"], ["id", "pinDobFieldValidationError", "role", "alert", "class", "error-color", 4, "ngIf"], [1, "form-group", "mt-2", "mb-2"], ["for", "retention_user_pin"], [1, "error-color"], [1, "sr-only"], [1, "ml-1", "Spa_Style_Label", 3, "ngClass"], ["id", "retention_user_pin", "name", "userPIN", "type", "text", "formControlName", "userPIN", "autocomplete", "off", "required", "", "aria-describedby", "pinDobFieldValidationError", "aria-required", "true", 1, "retention-input", 3, "ngClass"], ["userPINField", ""], [1, "col-xs-12", "col-md-8"], [1, "form-group", "mb-2"], ["for", "retention_user_dob"], ["id", "retention_user_dob", "name", "dob", "type", "text", "placeholder", "mm/dd/yyyy", "autocomplete", "off", "formControlName", "userDateOfBirth", "required", "", "aria-describedby", "pinDobFieldValidationError", "aria-required", "true", 1, "retention-input", 3, "mask", "ngClass"], [1, "form-group", "mt-1", "mb-1"], ["role", "alert", "class", "error-color", "id", "disclaimerFieldError", 4, "ngIf"], [4, "ngIf"], [1, "row", "mt-2"], ["type", "submit", 1, "btn", "Spa_Style_PrimaryButton"], [3, "title", "click", "keyup.enter", 4, "ngIf"], ["navigationAdapter", "", 1, "Spa_Style_H1", 3, "innerHtml"], ["id", "pinDobFieldValidationError", "role", "alert", 1, "error-color"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle", "mr-1"], [4, "ngIf", "ngIfElse"], ["validErrorText", ""], ["loginErrorText", ""], ["role", "alert", "id", "disclaimerFieldError", 1, "error-color"], ["for", "retention_disclaimer"], ["id", "retention_disclaimer", "type", "checkbox", "tabindex", "0", "name", "agreeToDisclaimer", "formControlName", "agreeToDisclaimer", "required", "", "aria-describedby", "disclaimerFieldError", "aria-required", "true", "role", "checkbox"], [1, "error-color", "ml-1"], ["class", "Spa_Style_Paragraph", "navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], [3, "makeInlineBlock", "title", "keyNameForLiveEdit", "alwaysUnderlined", "href", "tag", "linkTarget", 4, "ngIf"], ["navigationAdapter", "", 1, "Spa_Style_Paragraph", 3, "innerHTML"], [3, "makeInlineBlock", "title", "keyNameForLiveEdit", "alwaysUnderlined", "href", "tag", "linkTarget"], [3, "title", "click", "keyup.enter"]], template: function RetentionLandingComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵelement(2, "div", 2)(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4)(5, "div", 5)(6, "div", 6)(7, "div", 7);
        i0.ɵɵtemplate(8, RetentionLandingComponent_h1_8_Template, 2, 4, "h1", 8);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "div", 9)(10, "form", 10);
        i0.ɵɵlistener("ngSubmit", function RetentionLandingComponent_Template_form_ngSubmit_10_listener() { return ctx.submitForm(); });
        i0.ɵɵelementStart(11, "div", 6)(12, "div", 11);
        i0.ɵɵtemplate(13, RetentionLandingComponent_div_13_Template, 9, 3, "div", 12);
        i0.ɵɵelementStart(14, "div", 13)(15, "div")(16, "label", 14)(17, "span", 15)(18, "span", 16);
        i0.ɵɵtext(19);
        i0.ɵɵelementEnd();
        i0.ɵɵtext(20, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "span", 17);
        i0.ɵɵtext(22);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(23, "div");
        i0.ɵɵelement(24, "input", 18, 19);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(26, "div", 6)(27, "div", 20)(28, "div", 21)(29, "div")(30, "label", 22)(31, "span", 15)(32, "span", 16);
        i0.ɵɵtext(33);
        i0.ɵɵelementEnd();
        i0.ɵɵtext(34, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(35, "span", 17);
        i0.ɵɵtext(36);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(37, "div");
        i0.ɵɵelement(38, "input", 23);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(39, "div", 6)(40, "div", 20)(41, "div", 24);
        i0.ɵɵtemplate(42, RetentionLandingComponent_div_42_Template, 5, 2, "div", 25);
        i0.ɵɵtemplate(43, RetentionLandingComponent_ng_container_43_Template, 9, 4, "ng-container", 26);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(44, "div", 27)(45, "div", 20)(46, "button", 28);
        i0.ɵɵtext(47);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(48, "div", 27)(49, "div", 20);
        i0.ɵɵtemplate(50, RetentionLandingComponent_vnext_link_50_Template, 1, 1, "vnext-link", 29);
        i0.ɵɵelementEnd()()()()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("saveDefaultValues", true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(19, _c1$7, "url(" + ctx.imageService.resolveFullImagePath(ctx.Spa_RetentionLanding_Background_UrlMobile) + ")"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(21, _c1$7, "url(" + ctx.imageService.resolveFullImagePath(ctx.Spa_RetentionLanding_Background_Url) + ")"));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("liveEditProp", "Spa_RetentionLanding_Header_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("formGroup", ctx.retentionLoginForm);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.isNotAuthorized || ctx.retentionLoginForm.controls.userPIN.invalid && ctx.formSubmitted || ctx.retentionLoginForm.controls.userDateOfBirth.invalid && ctx.formSubmitted);
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate(ctx.Spa_Site_Required_Field);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(23, _c2$4, ctx.getPinStatus() && ctx.formSubmitted));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.Spa_RetentionLogin_Pin_Text);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(25, _c3, ctx.getPinStatus() && ctx.formSubmitted));
        i0.ɵɵadvance(9);
        i0.ɵɵtextInterpolate(ctx.Spa_Site_Required_Field);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(27, _c2$4, ctx.getDateOfBirthStatus() && ctx.formSubmitted));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate(ctx.Spa_RetentionLogin_Dob_Text);
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate("mask", ctx.mask);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(29, _c3, ctx.getDateOfBirthStatus() && ctx.formSubmitted));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.Spa_RetentionLogin_Disclaimer_Enabled && ctx.getDisclaimerStatus() && ctx.formSubmitted);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_RetentionLogin_Disclaimer_Enabled);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", ctx.Spa_RetentionLogin_GetStarted_Text, " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.Spa_RetentionLogin_ContinueWithoutPin_Link_Enabled);
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, i1$2.NgStyle, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.CheckboxControlValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.RequiredValidator, i4.CheckboxRequiredValidator, i4.FormGroupDirective, i4.FormControlName, LinkComponent, NavigationAdapterDirective, LiveEditPropDirective, FormInputSubmitDirective, GoogleTagManagerDirective, IconAriaAttributesDirective, i8.MaskDirective, SafePipe], styles: [".banner[_ngcontent-%COMP%]{width:100%;height:auto;max-width:1150px;max-height:950px;min-height:500px;margin-top:0;padding-top:100px;padding-bottom:25px;position:relative}.retention-widget[_ngcontent-%COMP%]{position:relative;width:90%;left:5.5%;bottom:0}.background-img[_ngcontent-%COMP%]{position:absolute;left:0;top:0;width:100%;height:100%;background-repeat:no-repeat;background-size:cover;background-position:50% 50%}@media (max-width: 992px){.banner[_ngcontent-%COMP%]{height:auto;max-height:750px;display:flex;flex-direction:column-reverse;padding-top:320px}@media (orientation: landscape){.banner[_ngcontent-%COMP%]{padding-top:500px}.background-img[_ngcontent-%COMP%]{background-position:50% 15%}}}@media (max-width: 767px){.background-img[_ngcontent-%COMP%]{background-position:50% 15%}}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], RetentionLandingComponent.prototype, "Spa_RetentionLanding_Background_Url", void 0);
__decorate([
    GlobalResource()
], RetentionLandingComponent.prototype, "Spa_RetentionLanding_Background_UrlMobile", void 0);
__decorate([
    GlobalResource()
], RetentionLandingComponent.prototype, "Spa_Site_Required_Field", void 0);
__decorate([
    GlobalResource()
], RetentionLandingComponent.prototype, "Spa_RetentionLogin_Disclaimer_Enabled", void 0);
__decorate([
    GlobalResource()
], RetentionLandingComponent.prototype, "Spa_RetentionLogin_ViewDetails_Link_Enabled", void 0);
__decorate([
    GlobalResource()
], RetentionLandingComponent.prototype, "Spa_RetentionLogin_ViewDetails_Link_Url", void 0);
__decorate([
    GlobalResource()
], RetentionLandingComponent.prototype, "Spa_RetentionLogin_Pin_Text", void 0);
__decorate([
    GlobalResource()
], RetentionLandingComponent.prototype, "Spa_RetentionLogin_GetStarted_Text", void 0);
__decorate([
    GlobalResource()
], RetentionLandingComponent.prototype, "Spa_RetentionLogin_ContinueWithoutPin_Link_Enabled", void 0);
__decorate([
    GlobalResource()
], RetentionLandingComponent.prototype, "Spa_RetentionLogin_ContinueWithoutPin_Link_Text", void 0);
__decorate([
    GlobalResource()
], RetentionLandingComponent.prototype, "Spa_RetentionLogin_PIN_DOB_Error_Text", void 0);
__decorate([
    GlobalResource()
], RetentionLandingComponent.prototype, "Spa_RetentionLogin_Valid_PIN_DOB_Error_Text", void 0);
__decorate([
    GlobalResource()
], RetentionLandingComponent.prototype, "Spa_RetentionLogin_Disclaimer_Error_Text", void 0);
__decorate([
    GlobalResource()
], RetentionLandingComponent.prototype, "Spa_RetentionLogin_Dob_Text", void 0);
__decorate([
    GlobalResource()
], RetentionLandingComponent.prototype, "Spa_Site_ErrorKeyword_Text", void 0);
__decorate([
    GlobalResource()
], RetentionLandingComponent.prototype, "Spa_Site_IsDeepLinking_Enabled", void 0);
__decorate([
    GlobalResource()
], RetentionLandingComponent.prototype, "Spa_Site_MFA_Enabled", void 0);
__decorate([
    PlatformProp('live-edit')
], RetentionLandingComponent.prototype, "Spa_RetentionLanding_Header_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], RetentionLandingComponent.prototype, "Spa_RetentionLogin_ViewDetails_Link_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], RetentionLandingComponent.prototype, "Spa_RetentionLogin_Disclaimer_Text", void 0);
__decorate([
    GlobalResource()
], RetentionLandingComponent.prototype, "Spa_Site_Loader_Message_Json", void 0);
__decorate([
    GlobalResource()
], RetentionLandingComponent.prototype, "Spa_Login_ConsumerAttemptsExceeded_Text", void 0);
__decorate([
    GlobalResource()
], RetentionLandingComponent.prototype, "Spa_Login_Error_Message", void 0);
__decorate([
    LiveEditInactive()
], RetentionLandingComponent.prototype, "onContinueWithoutPinClick", null);
__decorate([
    LiveEditInactive()
], RetentionLandingComponent.prototype, "submitForm", null);
__decorate([
    LiveEditInactive()
], RetentionLandingComponent.prototype, "handleRetentionMemberLogin", null);
RetentionLandingComponent = __decorate([
    PlatformWidget
], RetentionLandingComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RetentionLandingComponent, [{
        type: Component,
        args: [{ selector: 'vnext-retention-landing', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"Spa_Style_Banner_Background\" vnextGoogleTagManager [saveDefaultValues]=\"true\">\r\n  <div class=\"container banner\">\r\n    <div\r\n      class=\"background-img d-md-none\"\r\n      [ngStyle]=\"{ 'background-image': 'url(' + imageService.resolveFullImagePath(Spa_RetentionLanding_Background_UrlMobile) + ')' }\"\r\n    ></div>\r\n    <div\r\n      class=\"background-img d-none d-md-block\"\r\n      [ngStyle]=\"{ 'background-image': 'url(' + imageService.resolveFullImagePath(Spa_RetentionLanding_Background_Url) + ')' }\"\r\n    ></div>\r\n    <div id=\"retention_widget\" class=\"retention-widget\">\r\n      <div class=\"col-md-10\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-8\">\r\n            <h1\r\n              *liveEditProp=\"'Spa_RetentionLanding_Header_Text'\"\r\n              class=\"Spa_Style_H1\"\r\n              [innerHtml]=\"Spa_RetentionLanding_Header_Text | safe : 'html'\"\r\n              navigationAdapter\r\n            ></h1>\r\n          </div>\r\n        </div>\r\n        <div class=\"mt-1\">\r\n          <form disableKeyDownSubmit [formGroup]=\"retentionLoginForm\" (ngSubmit)=\"submitForm()\">\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-12 col-md-9\">\r\n                <!--show validation on invalid state changes only after form submitted to prevent shaky behavior-->\r\n                <div\r\n                  id=\"pinDobFieldValidationError\"\r\n                  role=\"alert\"\r\n                  *ngIf=\"\r\n                    isNotAuthorized ||\r\n                    (this.retentionLoginForm.controls.userPIN.invalid && formSubmitted) ||\r\n                    (this.retentionLoginForm.controls.userDateOfBirth.invalid && formSubmitted)\r\n                  \"\r\n                  class=\"error-color\"\r\n                >\r\n                  <i class=\"fas fa-exclamation-circle mr-1\" aria-hidden=\"true\"></i>\r\n                  <span class=\"sr-only\">{{ Spa_Site_ErrorKeyword_Text }}</span>\r\n                  <ng-container\r\n                    *ngIf=\"\r\n                      (this.retentionLoginForm.controls.userPIN.value === '' && formSubmitted) ||\r\n                        (this.retentionLoginForm.controls.userDateOfBirth.value === '' && formSubmitted);\r\n                      else validErrorText\r\n                    \"\r\n                  >\r\n                    {{ Spa_RetentionLogin_PIN_DOB_Error_Text }}\r\n                  </ng-container>\r\n                  <ng-template #validErrorText>\r\n                    <ng-container\r\n                      *ngIf=\"\r\n                        (this.retentionLoginForm.controls.userPIN.invalid && formSubmitted) ||\r\n                          (this.retentionLoginForm.controls.userDateOfBirth.invalid && formSubmitted);\r\n                        else loginErrorText\r\n                      \"\r\n                    >\r\n                      {{ Spa_RetentionLogin_Valid_PIN_DOB_Error_Text }}\r\n                    </ng-container>\r\n                  </ng-template>\r\n                  <ng-template #loginErrorText>\r\n                    {{ loginErrorMessageText }}\r\n                  </ng-template>\r\n                </div>\r\n                <div class=\"form-group mt-2 mb-2\">\r\n                  <div>\r\n                    <label for=\"retention_user_pin\">\r\n                      <span class=\"error-color\"\r\n                        ><span class=\"sr-only\">{{ Spa_Site_Required_Field }}</span\r\n                        >*</span\r\n                      >\r\n                      <span class=\"ml-1 Spa_Style_Label\" [ngClass]=\"{ 'label-invalid': getPinStatus() && formSubmitted }\">{{\r\n                        Spa_RetentionLogin_Pin_Text\r\n                      }}</span>\r\n                    </label>\r\n                  </div>\r\n                  <div>\r\n                    <input\r\n                      #userPINField\r\n                      id=\"retention_user_pin\"\r\n                      name=\"userPIN\"\r\n                      type=\"text\"\r\n                      formControlName=\"userPIN\"\r\n                      class=\"retention-input\"\r\n                      autocomplete=\"off\"\r\n                      required\r\n                      aria-describedby=\"pinDobFieldValidationError\"\r\n                      aria-required=\"true\"\r\n                      [ngClass]=\"{ 'retention-invalid': getPinStatus() && formSubmitted }\"\r\n                    />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-12 col-md-8\">\r\n                <div class=\"form-group mb-2\">\r\n                  <div>\r\n                    <label for=\"retention_user_dob\">\r\n                      <span class=\"error-color\"\r\n                        ><span class=\"sr-only\">{{ Spa_Site_Required_Field }}</span\r\n                        >*</span\r\n                      >\r\n                      <span class=\"ml-1 Spa_Style_Label\" [ngClass]=\"{ 'label-invalid': getDateOfBirthStatus() && formSubmitted }\">{{\r\n                        Spa_RetentionLogin_Dob_Text\r\n                      }}</span>\r\n                    </label>\r\n                  </div>\r\n                  <div>\r\n                    <input\r\n                      id=\"retention_user_dob\"\r\n                      class=\"retention-input\"\r\n                      name=\"dob\"\r\n                      type=\"text\"\r\n                      placeholder=\"mm/dd/yyyy\"\r\n                      autocomplete=\"off\"\r\n                      formControlName=\"userDateOfBirth\"\r\n                      mask=\"{{ mask }}\"\r\n                      required\r\n                      aria-describedby=\"pinDobFieldValidationError\"\r\n                      aria-required=\"true\"\r\n                      [ngClass]=\"{ 'retention-invalid': getDateOfBirthStatus() && formSubmitted }\"\r\n                    />\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <!--Disclaimer-->\r\n              <div class=\"col-xs-12 col-md-8\">\r\n                <div class=\"form-group mt-1 mb-1\">\r\n                  <div\r\n                    role=\"alert\"\r\n                    *ngIf=\"Spa_RetentionLogin_Disclaimer_Enabled && getDisclaimerStatus() && formSubmitted\"\r\n                    class=\"error-color\"\r\n                    id=\"disclaimerFieldError\"\r\n                  >\r\n                    <i class=\"fas fa-exclamation-circle mr-1\" aria-hidden=\"true\"></i>\r\n                    <span class=\"sr-only\">{{ Spa_Site_ErrorKeyword_Text }}</span>\r\n                    {{ Spa_RetentionLogin_Disclaimer_Error_Text }}\r\n                  </div>\r\n                  <ng-container *ngIf=\"Spa_RetentionLogin_Disclaimer_Enabled\">\r\n                    <label for=\"retention_disclaimer\">\r\n                      <input\r\n                        id=\"retention_disclaimer\"\r\n                        type=\"checkbox\"\r\n                        tabindex=\"0\"\r\n                        name=\"agreeToDisclaimer\"\r\n                        formControlName=\"agreeToDisclaimer\"\r\n                        required\r\n                        aria-describedby=\"disclaimerFieldError\"\r\n                        aria-required=\"true\"\r\n                        role=\"checkbox\"\r\n                        [attr.aria-checked]=\"\r\n                          retentionLoginForm && retentionLoginForm.controls && retentionLoginForm.controls.agreeToDisclaimer\r\n                            ? retentionLoginForm.controls.agreeToDisclaimer.valid\r\n                            : 'false'\r\n                        \"\r\n                      />\r\n                      <span class=\"error-color ml-1\"\r\n                        ><span class=\"sr-only\">{{ Spa_Site_Required_Field }}</span\r\n                        >*</span\r\n                      >\r\n                      <span\r\n                        class=\"Spa_Style_Paragraph\"\r\n                        *liveEditProp=\"'Spa_RetentionLogin_Disclaimer_Text'\"\r\n                        [innerHTML]=\"Spa_RetentionLogin_Disclaimer_Text | safe : 'html'\"\r\n                        navigationAdapter\r\n                      ></span>\r\n                      <vnext-link\r\n                        *ngIf=\"Spa_RetentionLogin_ViewDetails_Link_Enabled\"\r\n                        [makeInlineBlock]=\"true\"\r\n                        [title]=\"Spa_RetentionLogin_ViewDetails_Link_Text\"\r\n                        [keyNameForLiveEdit]=\"'Spa_RetentionLogin_ViewDetails_Link_Text'\"\r\n                        [alwaysUnderlined]=\"true\"\r\n                        [href]=\"Spa_RetentionLogin_ViewDetails_Link_Url[0].href\"\r\n                        [tag]=\"Spa_RetentionLogin_ViewDetails_Link_Url[0].tag\"\r\n                        [linkTarget]=\"Spa_RetentionLogin_ViewDetails_Link_Url[0].target\"\r\n                      >\r\n                      </vnext-link>\r\n                    </label>\r\n                  </ng-container>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"row mt-2\">\r\n              <div class=\"col-xs-12 col-md-8\">\r\n                <button class=\"btn Spa_Style_PrimaryButton\" type=\"submit\">\r\n                  {{ Spa_RetentionLogin_GetStarted_Text }}\r\n                </button>\r\n              </div>\r\n            </div>\r\n          </form>\r\n          <div class=\"row mt-2\">\r\n            <div class=\"col-xs-12 col-md-8\">\r\n              <vnext-link\r\n                (click)=\"onContinueWithoutPinClick()\"\r\n                (keyup.enter)=\"onContinueWithoutPinClick()\"\r\n                *ngIf=\"Spa_RetentionLogin_ContinueWithoutPin_Link_Enabled\"\r\n                [title]=\"Spa_RetentionLogin_ContinueWithoutPin_Link_Text\"\r\n              ></vnext-link>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".banner{width:100%;height:auto;max-width:1150px;max-height:950px;min-height:500px;margin-top:0;padding-top:100px;padding-bottom:25px;position:relative}.retention-widget{position:relative;width:90%;left:5.5%;bottom:0}.background-img{position:absolute;left:0;top:0;width:100%;height:100%;background-repeat:no-repeat;background-size:cover;background-position:50% 50%}@media (max-width: 992px){.banner{height:auto;max-height:750px;display:flex;flex-direction:column-reverse;padding-top:320px}@media (orientation: landscape){.banner{padding-top:500px}.background-img{background-position:50% 15%}}}@media (max-width: 767px){.background-img{background-position:50% 15%}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i2.Store }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.NavigationService }, { type: i1.LoginService }, { type: LoginFacade }, { type: i1.ImageService }, { type: i1.SpinnerService }, { type: AnalyticsService }, { type: i1.SiteService }, { type: i1.NavigationUtilityService }, { type: i1.ConfigResourceService }, { type: RetentionFacade }, { type: i1.AgentService }, { type: i0.Injector }]; }, { Spa_RetentionLanding_Background_Url: [], Spa_RetentionLanding_Background_UrlMobile: [], Spa_Site_Required_Field: [], Spa_RetentionLogin_Disclaimer_Enabled: [], Spa_RetentionLogin_ViewDetails_Link_Enabled: [], Spa_RetentionLogin_ViewDetails_Link_Url: [], Spa_RetentionLogin_Pin_Text: [], Spa_RetentionLogin_GetStarted_Text: [], Spa_RetentionLogin_ContinueWithoutPin_Link_Enabled: [], Spa_RetentionLogin_ContinueWithoutPin_Link_Text: [], Spa_RetentionLogin_PIN_DOB_Error_Text: [], Spa_RetentionLogin_Valid_PIN_DOB_Error_Text: [], Spa_RetentionLogin_Disclaimer_Error_Text: [], Spa_RetentionLogin_Dob_Text: [], Spa_Site_ErrorKeyword_Text: [], Spa_Site_IsDeepLinking_Enabled: [], Spa_Site_MFA_Enabled: [], Spa_RetentionLanding_Header_Text: [], Spa_RetentionLogin_ViewDetails_Link_Text: [], Spa_RetentionLogin_Disclaimer_Text: [], Spa_Site_Loader_Message_Json: [], Spa_Login_ConsumerAttemptsExceeded_Text: [], Spa_Login_Error_Message: [], userPINField: [{
            type: ViewChild,
            args: ['userPINField']
        }], onContinueWithoutPinClick: [], submitForm: [], handleRetentionMemberLogin: [] }); })();

function RetentionPlanCardComponent_h2_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h2", 6);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r0.pickPlanText, "html"), i0.ɵɵsanitizeHtml);
} }
function RetentionPlanCardComponent_ng_container_3_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "vnext-widget-plan-card", 11);
    i0.ɵɵlistener("quoteClicked", function RetentionPlanCardComponent_ng_container_3_div_3_Template_vnext_widget_plan_card_quoteClicked_2_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8.quoteClick()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const plan_r7 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("plan", plan_r7)("planBenefits", ctx_r6.benefits)("isRetentionSummaryPage", true)("displayDrugsCovered", ctx_r6.displayDrugsCovered)("planPreferences", ctx_r6.benefitPreferences)("hideCompareBoxOverride", true)("currentPlanText", ctx_r6.currentPlanText)("nextYearPlanText", ctx_r6.nextYearPlanText)("noCostAvailableText", ctx_r6.noCostAvailableText)("isRetentionView", ctx_r6.isRetention)("Spa_Site_ShowRiderIcons", ctx_r6.Spa_Site_ShowRiderIcons)("Spa_Site_Dental_Rider_Display_Text", ctx_r6.Spa_Site_Dental_Rider_Display_Text)("Spa_Site_Vision_Rider_Display_Text", ctx_r6.Spa_Site_Vision_Rider_Display_Text)("Spa_Site_Hearing_Rider_Display_Text", ctx_r6.Spa_Site_Hearing_Rider_Display_Text)("Spa_PlanCard_DentalAddOnCoverage_Text", ctx_r6.Spa_PlanCard_DentalAddOnCoverage_Text)("Spa_PlanCard_HearingAddOnCoverage_Text", ctx_r6.Spa_PlanCard_HearingAddOnCoverage_Text)("Spa_PlanCard_VisionAddOnCoverage_Text", ctx_r6.Spa_PlanCard_VisionAddOnCoverage_Text)("Spa_PlanCard_AddOnCoverage_Text", ctx_r6.Spa_PlanCard_AddOnCoverage_Text)("Spa_PlanCard_Pharmacy_Covered_Text", ctx_r6.pharmacyCoveredText)("Spa_PlanCard_Drug_Covered_Text", ctx_r6.drugCoveredText)("Spa_Site_Show_PlanLogo", ctx_r6.showPlanLogo)("Spa_PlanCard_TotalEstimatedAnnualCost_Text", ctx_r6.totalEstimatedAnnualCostText)("Spa_PlanCard_TotalEstimatedCost_Text", ctx_r6.totalEstimatedCostText)("Spa_PlanCard_Total_Estimated_Cost_Tooltip", ctx_r6.totalEstimatedCostTooltip)("Spa_Site_TotalEstimatedCost_Enabled", ctx_r6.isTotalEstimatedCostEnabled)("Spa_Site_ShowRidersOnPlanCards", ctx_r6.showRidersOnPlanCards)("Spa_Site_ShowPremiumAsAnnual", ctx_r6.showPremiumAsAnnual)("Spa_PlanCard_PlanDetails_ButtonText", ctx_r6.planDetailsButtonText)("Spa_PlanCard_PlanType_Text", ctx_r6.planTypeText)("Spa_PlanCard_AddOnCoverageInCart_Text", ctx_r6.addOnCoverageText)("Spa_PlanCard_AddOnCoverageTooltip_Body", ctx_r6.addOnCoverageTooltip)("Spa_PlanCard_QuoteLinkName_Text", ctx_r6.planCardQuoteLinkText)("Spa_PlanDetails_Non_Covered_Text", ctx_r6.planDetailsNonCoveredText)("Spa_Site_Prescriptions_Text", ctx_r6.prescriptionText)("Spa_Site_Pharmacy_Text", ctx_r6.pharmacyText)("Spa_ShoppingCart_Enabled", ctx_r6.shoppingCartEnabled)("Spa_Site_NotApplicable_Text", ctx_r6.planBenefitNoValueLabel)("Spa_Site_MedigapPlanType_Enabled", ctx_r6.Spa_Site_MedigapPlanType_Enabled)("Spa_Site_AddToCompare_Enabled", ctx_r6.Spa_Site_AddToCompare_Enabled)("Spa_Site_PlanViewDetails_Enabled", ctx_r6.Spa_Site_PlanViewDetails_Enabled)("Spa_PlanCard_ShowRidersOnMACards", ctx_r6.riderDisplayMap.MA)("Spa_PlanCard_ShowRidersOnPDPCards", ctx_r6.riderDisplayMap.PDP)("Spa_PlanCard_ShowRidersOnMAPDCards", ctx_r6.riderDisplayMap.MAPD)("Spa_PlanCard_ShowRidersOnMEDIGAPCards", ctx_r6.riderDisplayMap.MEDIGAP)("Spa_Site_Tooltip_Text", ctx_r6.Spa_Site_Tooltip_Text)("inNetworkPreferredText", ctx_r6.inNetworkPreferredText)("inNetworkStandardText", ctx_r6.inNetworkStandardText)("outOfNetworkText", ctx_r6.outOfNetworkText)("isMailOrderSelected", ctx_r6.isMailOrderSelected)("viewCostTooltipHeaderText", ctx_r6.viewCostTooltipHeaderText)("viewCostTooltipHeaderContent", ctx_r6.viewCostTooltipHeaderContent)("mailOrderText", ctx_r6.mailOrderText)("providersInNetworkText", ctx_r6.providersInNetworkText)("pcpInNetworkText", ctx_r6.pcpInNetworkText)("pcpOutOfNetworkText", ctx_r6.pcpOutOfNetworkText)("providersNoDataText", ctx_r6.providersNoDataText)("isProviderEnabled", ctx_r6.isProviderEnabled)("selectedProviders", ctx_r6.selectedProviders)("providerDetails", ctx_r6.providerDetails)("selectedPharmacy", ctx_r6.selectedPharmacy)("optionOneText", ctx_r6.optionOneText)("optionTwoText", ctx_r6.optionTwoText)("displayOptionLabels", ctx_r6.clientDefinedOptionsEnabled)("planLogoSize", ctx_r6.planLogoSize)("showAddToCartForAncillaryPlans", ctx_r6.showAddToCartForAncillaryPlans)("editLinkText", ctx_r6.editLinkText)("planCardPreferenceDetailedEnabled", ctx_r6.planCardPreferenceDetailedEnabled)("providerOneOrMoreOutOfNetworkText", ctx_r6.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r6.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r6.providerShowPartialIndicatorEnabled)("planFeesEnabled", ctx_r6.planFeesEnabled)("planFeesTooltipText", ctx_r6.planFeesTooltipText)("planFeesIncludedInPremiumTooltipText", ctx_r6.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r6.planFeesNotIncludedInPremiumTooltipText)("showPlanId", ctx_r6.showPlanId)("showPlanYear", ctx_r6.showPlanYear)("planIdText", ctx_r6.planIdText)("availableText", ctx_r6.availableText)("unavailableText", ctx_r6.unavailableText)("viewProvidersButtonText", ctx_r6.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r6.viewPrescriptionsButtonText)("supplementalBenefitsHighlightText", ctx_r6.supplementalBenefitsHighlightText)("preferencesText", ctx_r6.preferencesText)("viewMoreDetailsText", ctx_r6.viewMoreDetailsText)("hideDetailsText", ctx_r6.hideDetailsText)("newPlanCardDesignEnabled", ctx_r6.newPlanCardDesignEnabled)("viewAllPlanDetailsText", ctx_r6.viewAllPlanDetailsText)("shareThisPlanText", ctx_r6.shareThisPlanText)("viewCostDetailsText", ctx_r6.viewCostDetailsText)("closeText", ctx_r6.closeText)("planBenefitHighlightItems", ctx_r6.planBenefitHighlightItems)("planBenefitHighlightsHeaderText", ctx_r6.planBenefitHighlightsHeaderText)("showRiderDetails", ctx_r6.showRiderDetails)("showRiderDetailsText", ctx_r6.showRiderDetailsText)("hideRiderDetailsText", ctx_r6.hideRiderDetailsText)("riderIsIncludedText", ctx_r6.riderIsIncludedText)("waiverStateRiderTooltips", ctx_r6.waiverStateRiderTooltips)("costMA", ctx_r6.costMA)("costMAPD", ctx_r6.costMAPD)("costPDP", ctx_r6.costPDP)("costMEDIGAP", ctx_r6.costMEDIGAP)("costDENTAL", ctx_r6.costDENTAL)("costVISION", ctx_r6.costVISION);
} }
function RetentionPlanCardComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 7)(2, "div", 0);
    i0.ɵɵtemplate(3, RetentionPlanCardComponent_ng_container_3_div_3_Template, 3, 103, "div", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.plans);
} }
function RetentionPlanCardComponent_ng_template_4_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 10)(2, "vnext-widget-plan-card-tile", 12);
    i0.ɵɵlistener("quoteClicked", function RetentionPlanCardComponent_ng_template_4_ng_container_0_Template_vnext_widget_plan_card_tile_quoteClicked_2_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.quoteClick()); })("viewPlanDetails", function RetentionPlanCardComponent_ng_template_4_ng_container_0_Template_vnext_widget_plan_card_tile_viewPlanDetails_2_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r13 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r13.viewPlanDetailsPage($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("plans", ctx_r10.plans)("planCardQuoteLinkText", ctx_r10.planCardQuoteLinkText)("planDetailsButtonText", ctx_r10.planDetailsButtonText)("planTypeText", ctx_r10.planTypeText)("addOnCoverageText", ctx_r10.addOnCoverageText)("addOnCoverageTooltipBody", ctx_r10.addOnCoverageTooltip)("planDetailsNonCoveredText", ctx_r10.planDetailsNonCoveredText)("prescriptionText", ctx_r10.prescriptionText)("pharmacyText", ctx_r10.pharmacyText)("isTotalEstimatedCostEnabled", ctx_r10.isTotalEstimatedCostEnabled)("isRetention", ctx_r10.isRetention)("totalEstimatedAnnualCostText", ctx_r10.totalEstimatedAnnualCostText)("totalEstimatedCostText", ctx_r10.totalEstimatedCostText)("totalEstimatedCostTooltip", ctx_r10.totalEstimatedCostTooltip)("showPlanLogo", ctx_r10.showPlanLogo)("planBenefits", ctx_r10.benefits)("planPreferences", ctx_r10.benefitPreferences)("showRidersOnPlanCards", ctx_r10.showRidersOnPlanCards)("showPremiumAsAnnual", ctx_r10.showPremiumAsAnnual)("riderDisplayMap", ctx_r10.riderDisplayMap)("shoppingCartEnabled", ctx_r10.shoppingCartEnabled)("drugCoveredText", ctx_r10.drugCoveredText)("pharmacyCoveredText", ctx_r10.pharmacyCoveredText)("displayDrugsCovered", ctx_r10.displayDrugsCovered)("planBenefitNoValueLabel", ctx_r10.planBenefitNoValueLabel)("currentPlanText", ctx_r10.currentPlanText)("nextYearPlanText", ctx_r10.nextYearPlanText)("noCostAvailableText", ctx_r10.noCostAvailableText)("Spa_Site_ShowRiderIcons", ctx_r10.Spa_Site_ShowRiderIcons)("Spa_Site_Dental_Rider_Display_Text", ctx_r10.Spa_Site_Dental_Rider_Display_Text)("Spa_Site_Vision_Rider_Display_Text", ctx_r10.Spa_Site_Vision_Rider_Display_Text)("Spa_Site_Hearing_Rider_Display_Text", ctx_r10.Spa_Site_Hearing_Rider_Display_Text)("Spa_PlanCard_DentalAddOnCoverage_Text", ctx_r10.Spa_PlanCard_DentalAddOnCoverage_Text)("Spa_PlanCard_HearingAddOnCoverage_Text", ctx_r10.Spa_PlanCard_HearingAddOnCoverage_Text)("Spa_PlanCard_VisionAddOnCoverage_Text", ctx_r10.Spa_PlanCard_VisionAddOnCoverage_Text)("Spa_PlanCard_AddOnCoverage_Text", ctx_r10.Spa_PlanCard_AddOnCoverage_Text)("Spa_Site_MedigapPlanType_Enabled", ctx_r10.Spa_Site_MedigapPlanType_Enabled)("Spa_Site_AddToCompare_Enabled", ctx_r10.Spa_Site_AddToCompare_Enabled)("Spa_Site_PlanViewDetails_Enabled", ctx_r10.Spa_Site_PlanViewDetails_Enabled)("Spa_Site_Tooltip_Text", ctx_r10.Spa_Site_Tooltip_Text)("inNetworkPreferredText", ctx_r10.inNetworkPreferredText)("inNetworkStandardText", ctx_r10.inNetworkStandardText)("outOfNetworkText", ctx_r10.outOfNetworkText)("isMailOrderSelected", ctx_r10.isMailOrderSelected)("viewCostTooltipHeaderText", ctx_r10.viewCostTooltipHeaderText)("viewCostTooltipHeaderContent", ctx_r10.viewCostTooltipHeaderContent)("mailOrderText", ctx_r10.mailOrderText)("providersInNetworkText", ctx_r10.providersInNetworkText)("pcpInNetworkText", ctx_r10.pcpInNetworkText)("pcpOutOfNetworkText", ctx_r10.pcpOutOfNetworkText)("providersNoDataText", ctx_r10.providersNoDataText)("isProviderEnabled", ctx_r10.isProviderEnabled)("selectedProviders", ctx_r10.selectedProviders)("providerDetails", ctx_r10.providerDetails)("viewDetailsDescriptionText", ctx_r10.viewDetailsDescriptionText)("optionOneText", ctx_r10.optionOneText)("optionTwoText", ctx_r10.optionTwoText)("displayOptionLabels", ctx_r10.clientDefinedOptionsEnabled)("planLogoSize", ctx_r10.planLogoSize)("editLinkText", ctx_r10.editLinkText)("planCardPreferenceDetailedEnabled", ctx_r10.planCardPreferenceDetailedEnabled)("providerOneOrMoreOutOfNetworkText", ctx_r10.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r10.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r10.providerShowPartialIndicatorEnabled)("planFeesEnabled", ctx_r10.planFeesEnabled)("planFeesTooltipText", ctx_r10.planFeesTooltipText)("planFeesIncludedInPremiumTooltipText", ctx_r10.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r10.planFeesNotIncludedInPremiumTooltipText)("showPlanYear", ctx_r10.showPlanYear)("viewProvidersButtonText", ctx_r10.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r10.viewPrescriptionsButtonText);
} }
function RetentionPlanCardComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, RetentionPlanCardComponent_ng_template_4_ng_container_0_Template, 3, 71, "ng-container", 3);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngIf", ctx_r3.plans.length === 3)("ngIfElse", _r4);
} }
function RetentionPlanCardComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "vnext-plan-card-two-tiles", 13);
    i0.ɵɵlistener("quoteClicked", function RetentionPlanCardComponent_ng_template_6_Template_vnext_plan_card_two_tiles_quoteClicked_1_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r14.quoteClick()); })("viewPlanDetails", function RetentionPlanCardComponent_ng_template_6_Template_vnext_plan_card_two_tiles_viewPlanDetails_1_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.viewPlanDetailsPage($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plans", ctx_r5.plans)("planCardQuoteLinkText", ctx_r5.planCardQuoteLinkText)("planDetailsButtonText", ctx_r5.planDetailsButtonText)("planTypeText", ctx_r5.planTypeText)("addOnCoverageText", ctx_r5.addOnCoverageText)("addOnCoverageTooltipBody", ctx_r5.addOnCoverageTooltip)("planDetailsNonCoveredText", ctx_r5.planDetailsNonCoveredText)("prescriptionText", ctx_r5.prescriptionText)("pharmacyText", ctx_r5.pharmacyText)("isTotalEstimatedCostEnabled", ctx_r5.isTotalEstimatedCostEnabled)("isRetention", ctx_r5.isRetention)("totalEstimatedAnnualCostText", ctx_r5.totalEstimatedAnnualCostText)("totalEstimatedCostText", ctx_r5.totalEstimatedCostText)("totalEstimatedCostTooltip", ctx_r5.totalEstimatedCostTooltip)("showPlanLogo", ctx_r5.showPlanLogo)("planBenefits", ctx_r5.benefits)("planPreferences", ctx_r5.benefitPreferences)("showRidersOnPlanCards", ctx_r5.showRidersOnPlanCards)("showPremiumAsAnnual", ctx_r5.showPremiumAsAnnual)("riderDisplayMap", ctx_r5.riderDisplayMap)("shoppingCartEnabled", ctx_r5.shoppingCartEnabled)("drugCoveredText", ctx_r5.drugCoveredText)("pharmacyCoveredText", ctx_r5.pharmacyCoveredText)("displayDrugsCovered", ctx_r5.displayDrugsCovered)("hidePlanCardLabel", ctx_r5.hidePlanCardLabel)("planBenefitNoValueLabel", ctx_r5.planBenefitNoValueLabel)("currentPlanText", ctx_r5.currentPlanText)("nextYearPlanText", ctx_r5.nextYearPlanText)("noCostAvailableText", ctx_r5.noCostAvailableText)("Spa_Site_ShowRiderIcons", ctx_r5.Spa_Site_ShowRiderIcons)("Spa_Site_Dental_Rider_Display_Text", ctx_r5.Spa_Site_Dental_Rider_Display_Text)("Spa_Site_Vision_Rider_Display_Text", ctx_r5.Spa_Site_Vision_Rider_Display_Text)("Spa_Site_Hearing_Rider_Display_Text", ctx_r5.Spa_Site_Hearing_Rider_Display_Text)("Spa_PlanCard_DentalAddOnCoverage_Text", ctx_r5.Spa_PlanCard_DentalAddOnCoverage_Text)("Spa_PlanCard_HearingAddOnCoverage_Text", ctx_r5.Spa_PlanCard_HearingAddOnCoverage_Text)("Spa_PlanCard_VisionAddOnCoverage_Text", ctx_r5.Spa_PlanCard_VisionAddOnCoverage_Text)("Spa_PlanCard_AddOnCoverage_Text", ctx_r5.Spa_PlanCard_AddOnCoverage_Text)("Spa_Site_MedigapPlanType_Enabled", ctx_r5.Spa_Site_MedigapPlanType_Enabled)("Spa_Site_AddToCompare_Enabled", ctx_r5.Spa_Site_AddToCompare_Enabled)("Spa_Site_PlanViewDetails_Enabled", ctx_r5.Spa_Site_PlanViewDetails_Enabled)("Spa_Site_Tooltip_Text", ctx_r5.Spa_Site_Tooltip_Text)("inNetworkPreferredText", ctx_r5.inNetworkPreferredText)("inNetworkStandardText", ctx_r5.inNetworkStandardText)("outOfNetworkText", ctx_r5.outOfNetworkText)("isMailOrderSelected", ctx_r5.isMailOrderSelected)("viewCostTooltipHeaderText", ctx_r5.viewCostTooltipHeaderText)("viewCostTooltipHeaderContent", ctx_r5.viewCostTooltipHeaderContent)("mailOrderText", ctx_r5.mailOrderText)("providersInNetworkText", ctx_r5.providersInNetworkText)("pcpInNetworkText", ctx_r5.pcpInNetworkText)("pcpOutOfNetworkText", ctx_r5.pcpOutOfNetworkText)("providersNoDataText", ctx_r5.providersNoDataText)("isProviderEnabled", ctx_r5.isProviderEnabled)("selectedProviders", ctx_r5.selectedProviders)("providerDetails", ctx_r5.providerDetails)("viewDetailsDescriptionText", ctx_r5.viewDetailsDescriptionText)("optionOneText", ctx_r5.optionOneText)("optionTwoText", ctx_r5.optionTwoText)("displayOptionLabels", ctx_r5.clientDefinedOptionsEnabled)("planLogoSize", ctx_r5.planLogoSize)("editLinkText", ctx_r5.editLinkText)("planCardPreferenceDetailedEnabled", ctx_r5.planCardPreferenceDetailedEnabled)("providerOneOrMoreOutOfNetworkText", ctx_r5.providerOneOrMoreOutOfNetworkText)("providerInNetworkOnOtherLocationsTooltipText", ctx_r5.providerInNetworkOnOtherLocationsTooltipText)("providerShowPartialIndicatorEnabled", ctx_r5.providerShowPartialIndicatorEnabled)("planFeesEnabled", ctx_r5.planFeesEnabled)("planFeesTooltipText", ctx_r5.planFeesTooltipText)("planFeesIncludedInPremiumTooltipText", ctx_r5.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r5.planFeesNotIncludedInPremiumTooltipText)("showPlanYear", ctx_r5.showPlanYear)("viewProvidersButtonText", ctx_r5.viewProvidersButtonText)("viewPrescriptionsButtonText", ctx_r5.viewPrescriptionsButtonText);
} }
class RetentionPlanCardComponent {
    constructor(planFacade) {
        this.planFacade = planFacade;
        this.showPlanYear = false;
        this.newPlanCardDesignEnabled = false;
        this.planBenefitHighlightItems = [];
        this.waiverStateRiderTooltips = [];
        this.quoteClicked = new EventEmitter();
        this.viewPlanDetails = new EventEmitter();
    }
    quoteClick() {
        this.quoteClicked.emit();
    }
    viewPlanDetailsPage(plan) {
        this.viewPlanDetails.emit(plan);
    }
}
RetentionPlanCardComponent.ɵfac = function RetentionPlanCardComponent_Factory(t) { return new (t || RetentionPlanCardComponent)(i0.ɵɵdirectiveInject(PlanFacade)); };
RetentionPlanCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RetentionPlanCardComponent, selectors: [["vnext-widget-retention-plan-card"]], inputs: { plans: "plans", pickPlanText: "pickPlanText", planCardQuoteLinkText: "planCardQuoteLinkText", showPlanLogo: "showPlanLogo", planDetailsButtonText: "planDetailsButtonText", planBenefitNoValueLabel: "planBenefitNoValueLabel", planTypeText: "planTypeText", addOnCoverageText: "addOnCoverageText", addOnCoverageTooltip: "addOnCoverageTooltip", planDetailsNonCoveredText: "planDetailsNonCoveredText", prescriptionText: "prescriptionText", pharmacyText: "pharmacyText", isTotalEstimatedCostEnabled: "isTotalEstimatedCostEnabled", isRetention: "isRetention", totalEstimatedAnnualCostText: "totalEstimatedAnnualCostText", totalEstimatedCostText: "totalEstimatedCostText", totalEstimatedCostTooltip: "totalEstimatedCostTooltip", showRidersOnPlanCards: "showRidersOnPlanCards", showPremiumAsAnnual: "showPremiumAsAnnual", riderDisplayMap: "riderDisplayMap", shoppingCartEnabled: "shoppingCartEnabled", drugCoveredText: "drugCoveredText", pharmacyCoveredText: "pharmacyCoveredText", displayDrugsCovered: "displayDrugsCovered", hidePlanCardLabel: "hidePlanCardLabel", benefits: "benefits", benefitPreferences: "benefitPreferences", currentPlanText: "currentPlanText", isMobile: "isMobile", nextYearPlanText: "nextYearPlanText", noCostAvailableText: "noCostAvailableText", inNetworkPreferredText: "inNetworkPreferredText", inNetworkStandardText: "inNetworkStandardText", outOfNetworkText: "outOfNetworkText", isMailOrderSelected: "isMailOrderSelected", viewCostTooltipHeaderText: "viewCostTooltipHeaderText", viewCostTooltipHeaderContent: "viewCostTooltipHeaderContent", mailOrderText: "mailOrderText", providersInNetworkText: "providersInNetworkText", pcpInNetworkText: "pcpInNetworkText", pcpOutOfNetworkText: "pcpOutOfNetworkText", providersNoDataText: "providersNoDataText", isProviderEnabled: "isProviderEnabled", selectedProviders: "selectedProviders", providerDetails: "providerDetails", selectedPharmacy: "selectedPharmacy", Spa_Site_ShowRiderIcons: "Spa_Site_ShowRiderIcons", Spa_Site_Dental_Rider_Display_Text: "Spa_Site_Dental_Rider_Display_Text", Spa_Site_Vision_Rider_Display_Text: "Spa_Site_Vision_Rider_Display_Text", Spa_Site_Hearing_Rider_Display_Text: "Spa_Site_Hearing_Rider_Display_Text", Spa_PlanCard_DentalAddOnCoverage_Text: "Spa_PlanCard_DentalAddOnCoverage_Text", Spa_PlanCard_HearingAddOnCoverage_Text: "Spa_PlanCard_HearingAddOnCoverage_Text", Spa_PlanCard_VisionAddOnCoverage_Text: "Spa_PlanCard_VisionAddOnCoverage_Text", Spa_PlanCard_AddOnCoverage_Text: "Spa_PlanCard_AddOnCoverage_Text", Spa_Site_MedigapPlanType_Enabled: "Spa_Site_MedigapPlanType_Enabled", Spa_Site_AddToCompare_Enabled: "Spa_Site_AddToCompare_Enabled", Spa_Site_PlanViewDetails_Enabled: "Spa_Site_PlanViewDetails_Enabled", Spa_Site_Tooltip_Text: "Spa_Site_Tooltip_Text", viewDetailsDescriptionText: "viewDetailsDescriptionText", clientDefinedOptionsEnabled: "clientDefinedOptionsEnabled", optionOneText: "optionOneText", optionTwoText: "optionTwoText", planLogoSize: "planLogoSize", showAddToCartForAncillaryPlans: "showAddToCartForAncillaryPlans", editLinkText: "editLinkText", planCardPreferenceDetailedEnabled: "planCardPreferenceDetailedEnabled", providerOneOrMoreOutOfNetworkText: "providerOneOrMoreOutOfNetworkText", providerInNetworkOnOtherLocationsTooltipText: "providerInNetworkOnOtherLocationsTooltipText", providerShowPartialIndicatorEnabled: "providerShowPartialIndicatorEnabled", planFeesEnabled: "planFeesEnabled", planFeesTooltipText: "planFeesTooltipText", planFeesIncludedInPremiumTooltipText: "planFeesIncludedInPremiumTooltipText", planFeesNotIncludedInPremiumTooltipText: "planFeesNotIncludedInPremiumTooltipText", showPlanId: "showPlanId", showPlanYear: "showPlanYear", planIdText: "planIdText", availableText: "availableText", unavailableText: "unavailableText", viewProvidersButtonText: "viewProvidersButtonText", viewPrescriptionsButtonText: "viewPrescriptionsButtonText", supplementalBenefitsHighlightText: "supplementalBenefitsHighlightText", preferencesText: "preferencesText", viewMoreDetailsText: "viewMoreDetailsText", hideDetailsText: "hideDetailsText", newPlanCardDesignEnabled: "newPlanCardDesignEnabled", viewAllPlanDetailsText: "viewAllPlanDetailsText", shareThisPlanText: "shareThisPlanText", viewCostDetailsText: "viewCostDetailsText", closeText: "closeText", planBenefitHighlightItems: "planBenefitHighlightItems", planBenefitHighlightsHeaderText: "planBenefitHighlightsHeaderText", showRiderDetails: "showRiderDetails", hideRiderDetailsText: "hideRiderDetailsText", showRiderDetailsText: "showRiderDetailsText", riderIsIncludedText: "riderIsIncludedText", waiverStateRiderTooltips: "waiverStateRiderTooltips", costMA: "costMA", costMAPD: "costMAPD", costMEDIGAP: "costMEDIGAP", costPDP: "costPDP", costDENTAL: "costDENTAL", costVISION: "costVISION" }, outputs: { quoteClicked: "quoteClicked", viewPlanDetails: "viewPlanDetails" }, decls: 8, vars: 3, consts: [[1, "container"], [1, "row", "mt-3"], ["class", "col-12 my-2 Spa_Style_Large_Font", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [4, "ngIf", "ngIfElse"], ["threeTiles", ""], ["twoTiles", ""], ["navigationAdapter", "", 1, "col-12", "my-2", "Spa_Style_Large_Font", 3, "innerHtml"], [1, "col-12", "px-0"], ["class", "row", 4, "ngFor", "ngForOf"], [1, "row"], [1, "col-12"], [3, "plan", "planBenefits", "isRetentionSummaryPage", "displayDrugsCovered", "planPreferences", "hideCompareBoxOverride", "currentPlanText", "nextYearPlanText", "noCostAvailableText", "isRetentionView", "Spa_Site_ShowRiderIcons", "Spa_Site_Dental_Rider_Display_Text", "Spa_Site_Vision_Rider_Display_Text", "Spa_Site_Hearing_Rider_Display_Text", "Spa_PlanCard_DentalAddOnCoverage_Text", "Spa_PlanCard_HearingAddOnCoverage_Text", "Spa_PlanCard_VisionAddOnCoverage_Text", "Spa_PlanCard_AddOnCoverage_Text", "Spa_PlanCard_Pharmacy_Covered_Text", "Spa_PlanCard_Drug_Covered_Text", "Spa_Site_Show_PlanLogo", "Spa_PlanCard_TotalEstimatedAnnualCost_Text", "Spa_PlanCard_TotalEstimatedCost_Text", "Spa_PlanCard_Total_Estimated_Cost_Tooltip", "Spa_Site_TotalEstimatedCost_Enabled", "Spa_Site_ShowRidersOnPlanCards", "Spa_Site_ShowPremiumAsAnnual", "Spa_PlanCard_PlanDetails_ButtonText", "Spa_PlanCard_PlanType_Text", "Spa_PlanCard_AddOnCoverageInCart_Text", "Spa_PlanCard_AddOnCoverageTooltip_Body", "Spa_PlanCard_QuoteLinkName_Text", "Spa_PlanDetails_Non_Covered_Text", "Spa_Site_Prescriptions_Text", "Spa_Site_Pharmacy_Text", "Spa_ShoppingCart_Enabled", "Spa_Site_NotApplicable_Text", "Spa_Site_MedigapPlanType_Enabled", "Spa_Site_AddToCompare_Enabled", "Spa_Site_PlanViewDetails_Enabled", "Spa_PlanCard_ShowRidersOnMACards", "Spa_PlanCard_ShowRidersOnPDPCards", "Spa_PlanCard_ShowRidersOnMAPDCards", "Spa_PlanCard_ShowRidersOnMEDIGAPCards", "Spa_Site_Tooltip_Text", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "isMailOrderSelected", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "mailOrderText", "providersInNetworkText", "pcpInNetworkText", "pcpOutOfNetworkText", "providersNoDataText", "isProviderEnabled", "selectedProviders", "providerDetails", "selectedPharmacy", "optionOneText", "optionTwoText", "displayOptionLabels", "planLogoSize", "showAddToCartForAncillaryPlans", "editLinkText", "planCardPreferenceDetailedEnabled", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "showPlanId", "showPlanYear", "planIdText", "availableText", "unavailableText", "viewProvidersButtonText", "viewPrescriptionsButtonText", "supplementalBenefitsHighlightText", "preferencesText", "viewMoreDetailsText", "hideDetailsText", "newPlanCardDesignEnabled", "viewAllPlanDetailsText", "shareThisPlanText", "viewCostDetailsText", "closeText", "planBenefitHighlightItems", "planBenefitHighlightsHeaderText", "showRiderDetails", "showRiderDetailsText", "hideRiderDetailsText", "riderIsIncludedText", "waiverStateRiderTooltips", "costMA", "costMAPD", "costPDP", "costMEDIGAP", "costDENTAL", "costVISION", "quoteClicked"], [3, "plans", "planCardQuoteLinkText", "planDetailsButtonText", "planTypeText", "addOnCoverageText", "addOnCoverageTooltipBody", "planDetailsNonCoveredText", "prescriptionText", "pharmacyText", "isTotalEstimatedCostEnabled", "isRetention", "totalEstimatedAnnualCostText", "totalEstimatedCostText", "totalEstimatedCostTooltip", "showPlanLogo", "planBenefits", "planPreferences", "showRidersOnPlanCards", "showPremiumAsAnnual", "riderDisplayMap", "shoppingCartEnabled", "drugCoveredText", "pharmacyCoveredText", "displayDrugsCovered", "planBenefitNoValueLabel", "currentPlanText", "nextYearPlanText", "noCostAvailableText", "Spa_Site_ShowRiderIcons", "Spa_Site_Dental_Rider_Display_Text", "Spa_Site_Vision_Rider_Display_Text", "Spa_Site_Hearing_Rider_Display_Text", "Spa_PlanCard_DentalAddOnCoverage_Text", "Spa_PlanCard_HearingAddOnCoverage_Text", "Spa_PlanCard_VisionAddOnCoverage_Text", "Spa_PlanCard_AddOnCoverage_Text", "Spa_Site_MedigapPlanType_Enabled", "Spa_Site_AddToCompare_Enabled", "Spa_Site_PlanViewDetails_Enabled", "Spa_Site_Tooltip_Text", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "isMailOrderSelected", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "mailOrderText", "providersInNetworkText", "pcpInNetworkText", "pcpOutOfNetworkText", "providersNoDataText", "isProviderEnabled", "selectedProviders", "providerDetails", "viewDetailsDescriptionText", "optionOneText", "optionTwoText", "displayOptionLabels", "planLogoSize", "editLinkText", "planCardPreferenceDetailedEnabled", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "showPlanYear", "viewProvidersButtonText", "viewPrescriptionsButtonText", "quoteClicked", "viewPlanDetails"], [3, "plans", "planCardQuoteLinkText", "planDetailsButtonText", "planTypeText", "addOnCoverageText", "addOnCoverageTooltipBody", "planDetailsNonCoveredText", "prescriptionText", "pharmacyText", "isTotalEstimatedCostEnabled", "isRetention", "totalEstimatedAnnualCostText", "totalEstimatedCostText", "totalEstimatedCostTooltip", "showPlanLogo", "planBenefits", "planPreferences", "showRidersOnPlanCards", "showPremiumAsAnnual", "riderDisplayMap", "shoppingCartEnabled", "drugCoveredText", "pharmacyCoveredText", "displayDrugsCovered", "hidePlanCardLabel", "planBenefitNoValueLabel", "currentPlanText", "nextYearPlanText", "noCostAvailableText", "Spa_Site_ShowRiderIcons", "Spa_Site_Dental_Rider_Display_Text", "Spa_Site_Vision_Rider_Display_Text", "Spa_Site_Hearing_Rider_Display_Text", "Spa_PlanCard_DentalAddOnCoverage_Text", "Spa_PlanCard_HearingAddOnCoverage_Text", "Spa_PlanCard_VisionAddOnCoverage_Text", "Spa_PlanCard_AddOnCoverage_Text", "Spa_Site_MedigapPlanType_Enabled", "Spa_Site_AddToCompare_Enabled", "Spa_Site_PlanViewDetails_Enabled", "Spa_Site_Tooltip_Text", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "isMailOrderSelected", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "mailOrderText", "providersInNetworkText", "pcpInNetworkText", "pcpOutOfNetworkText", "providersNoDataText", "isProviderEnabled", "selectedProviders", "providerDetails", "viewDetailsDescriptionText", "optionOneText", "optionTwoText", "displayOptionLabels", "planLogoSize", "editLinkText", "planCardPreferenceDetailedEnabled", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "showPlanYear", "viewProvidersButtonText", "viewPrescriptionsButtonText", "quoteClicked", "viewPlanDetails"]], template: function RetentionPlanCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, RetentionPlanCardComponent_h2_2_Template, 2, 4, "h2", 2);
        i0.ɵɵtemplate(3, RetentionPlanCardComponent_ng_container_3_Template, 4, 1, "ng-container", 3);
        i0.ɵɵtemplate(4, RetentionPlanCardComponent_ng_template_4_Template, 1, 2, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(6, RetentionPlanCardComponent_ng_template_6_Template, 2, 72, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(5);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_Retention_PickPlan_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isMobile || ctx.plans.length === 1)("ngIfElse", _r2);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, NavigationAdapterDirective, LiveEditPropDirective, PlanCardComponent, PlanCardTileComponent, PlanCardTileTwoComponent, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RetentionPlanCardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-retention-plan-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container\">\r\n  <div class=\"row mt-3\">\r\n    <h2\r\n      class=\"col-12 my-2 Spa_Style_Large_Font\"\r\n      *liveEditProp=\"'Spa_Retention_PickPlan_Text'\"\r\n      [innerHtml]=\"pickPlanText | safe : 'html'\"\r\n      navigationAdapter\r\n    ></h2>\r\n    <ng-container *ngIf=\"isMobile || plans.length === 1; else threeTiles\">\r\n      <div class=\"col-12 px-0\">\r\n        <div class=\"container\">\r\n          <div class=\"row\" *ngFor=\"let plan of plans\">\r\n            <div class=\"col-12\">\r\n              <vnext-widget-plan-card\r\n                [plan]=\"plan\"\r\n                [planBenefits]=\"benefits\"\r\n                [isRetentionSummaryPage]=\"true\"\r\n                [displayDrugsCovered]=\"displayDrugsCovered\"\r\n                [planPreferences]=\"benefitPreferences\"\r\n                [hideCompareBoxOverride]=\"true\"\r\n                [currentPlanText]=\"currentPlanText\"\r\n                [nextYearPlanText]=\"nextYearPlanText\"\r\n                (quoteClicked)=\"quoteClick()\"\r\n                [noCostAvailableText]=\"noCostAvailableText\"\r\n                [isRetentionView]=\"isRetention\"\r\n                [Spa_Site_ShowRiderIcons]=\"Spa_Site_ShowRiderIcons\"\r\n                [Spa_Site_Dental_Rider_Display_Text]=\"Spa_Site_Dental_Rider_Display_Text\"\r\n                [Spa_Site_Vision_Rider_Display_Text]=\"Spa_Site_Vision_Rider_Display_Text\"\r\n                [Spa_Site_Hearing_Rider_Display_Text]=\"Spa_Site_Hearing_Rider_Display_Text\"\r\n                [Spa_PlanCard_DentalAddOnCoverage_Text]=\"Spa_PlanCard_DentalAddOnCoverage_Text\"\r\n                [Spa_PlanCard_HearingAddOnCoverage_Text]=\"Spa_PlanCard_HearingAddOnCoverage_Text\"\r\n                [Spa_PlanCard_VisionAddOnCoverage_Text]=\"Spa_PlanCard_VisionAddOnCoverage_Text\"\r\n                [Spa_PlanCard_AddOnCoverage_Text]=\"Spa_PlanCard_AddOnCoverage_Text\"\r\n                [Spa_PlanCard_Pharmacy_Covered_Text]=\"pharmacyCoveredText\"\r\n                [Spa_PlanCard_Drug_Covered_Text]=\"drugCoveredText\"\r\n                [Spa_Site_Show_PlanLogo]=\"showPlanLogo\"\r\n                [Spa_PlanCard_TotalEstimatedAnnualCost_Text]=\"totalEstimatedAnnualCostText\"\r\n                [Spa_PlanCard_TotalEstimatedCost_Text]=\"totalEstimatedCostText\"\r\n                [Spa_PlanCard_Total_Estimated_Cost_Tooltip]=\"totalEstimatedCostTooltip\"\r\n                [Spa_Site_TotalEstimatedCost_Enabled]=\"isTotalEstimatedCostEnabled\"\r\n                [Spa_Site_ShowRidersOnPlanCards]=\"showRidersOnPlanCards\"\r\n                [Spa_Site_ShowPremiumAsAnnual]=\"showPremiumAsAnnual\"\r\n                [Spa_PlanCard_PlanDetails_ButtonText]=\"planDetailsButtonText\"\r\n                [Spa_PlanCard_PlanType_Text]=\"planTypeText\"\r\n                [Spa_PlanCard_AddOnCoverageInCart_Text]=\"addOnCoverageText\"\r\n                [Spa_PlanCard_AddOnCoverageTooltip_Body]=\"addOnCoverageTooltip\"\r\n                [Spa_PlanCard_QuoteLinkName_Text]=\"planCardQuoteLinkText\"\r\n                [Spa_PlanDetails_Non_Covered_Text]=\"planDetailsNonCoveredText\"\r\n                [Spa_Site_Prescriptions_Text]=\"prescriptionText\"\r\n                [Spa_Site_Pharmacy_Text]=\"pharmacyText\"\r\n                [Spa_ShoppingCart_Enabled]=\"shoppingCartEnabled\"\r\n                [Spa_Site_NotApplicable_Text]=\"planBenefitNoValueLabel\"\r\n                [Spa_Site_MedigapPlanType_Enabled]=\"Spa_Site_MedigapPlanType_Enabled\"\r\n                [Spa_Site_AddToCompare_Enabled]=\"Spa_Site_AddToCompare_Enabled\"\r\n                [Spa_Site_PlanViewDetails_Enabled]=\"Spa_Site_PlanViewDetails_Enabled\"\r\n                [Spa_PlanCard_ShowRidersOnMACards]=\"riderDisplayMap.MA\"\r\n                [Spa_PlanCard_ShowRidersOnPDPCards]=\"riderDisplayMap.PDP\"\r\n                [Spa_PlanCard_ShowRidersOnMAPDCards]=\"riderDisplayMap.MAPD\"\r\n                [Spa_PlanCard_ShowRidersOnMEDIGAPCards]=\"riderDisplayMap.MEDIGAP\"\r\n                [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n                [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n                [inNetworkStandardText]=\"inNetworkStandardText\"\r\n                [outOfNetworkText]=\"outOfNetworkText\"\r\n                [isMailOrderSelected]=\"isMailOrderSelected\"\r\n                [viewCostTooltipHeaderText]=\"viewCostTooltipHeaderText\"\r\n                [viewCostTooltipHeaderContent]=\"viewCostTooltipHeaderContent\"\r\n                [mailOrderText]=\"mailOrderText\"\r\n                [providersInNetworkText]=\"providersInNetworkText\"\r\n                [pcpInNetworkText]=\"pcpInNetworkText\"\r\n                [pcpOutOfNetworkText]=\"pcpOutOfNetworkText\"\r\n                [providersNoDataText]=\"providersNoDataText\"\r\n                [isProviderEnabled]=\"isProviderEnabled\"\r\n                [selectedProviders]=\"selectedProviders\"\r\n                [providerDetails]=\"providerDetails\"\r\n                [selectedPharmacy]=\"selectedPharmacy\"\r\n                [optionOneText]=\"optionOneText\"\r\n                [optionTwoText]=\"optionTwoText\"\r\n                [displayOptionLabels]=\"clientDefinedOptionsEnabled\"\r\n                [planLogoSize]=\"planLogoSize\"\r\n                [showAddToCartForAncillaryPlans]=\"showAddToCartForAncillaryPlans\"\r\n                [editLinkText]=\"editLinkText\"\r\n                [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n                [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n                [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n                [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n                [planFeesEnabled]=\"planFeesEnabled\"\r\n                [planFeesTooltipText]=\"planFeesTooltipText\"\r\n                [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n                [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n                [showPlanId]=\"showPlanId\"\r\n                [showPlanYear]=\"showPlanYear\"\r\n                [planIdText]=\"planIdText\"\r\n                [availableText]=\"availableText\"\r\n                [unavailableText]=\"unavailableText\"\r\n                [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n                [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n                [supplementalBenefitsHighlightText]=\"supplementalBenefitsHighlightText\"\r\n                [preferencesText]=\"preferencesText\"\r\n                [viewMoreDetailsText]=\"viewMoreDetailsText\"\r\n                [hideDetailsText]=\"hideDetailsText\"\r\n                [newPlanCardDesignEnabled]=\"newPlanCardDesignEnabled\"\r\n                [viewAllPlanDetailsText]=\"viewAllPlanDetailsText\"\r\n                [shareThisPlanText]=\"shareThisPlanText\"\r\n                [viewCostDetailsText]=\"viewCostDetailsText\"\r\n                [closeText]=\"closeText\"\r\n                [planBenefitHighlightItems]=\"planBenefitHighlightItems\"\r\n                [planBenefitHighlightsHeaderText]=\"planBenefitHighlightsHeaderText\"\r\n                [showRiderDetails]=\"showRiderDetails\"\r\n                [showRiderDetailsText]=\"showRiderDetailsText\"\r\n                [hideRiderDetailsText]=\"hideRiderDetailsText\"\r\n                [riderIsIncludedText]=\"riderIsIncludedText\"\r\n                [waiverStateRiderTooltips]=\"waiverStateRiderTooltips\"\r\n                [costMA]=\"costMA\"\r\n                [costMAPD]=\"costMAPD\"\r\n                [costPDP]=\"costPDP\"\r\n                [costMEDIGAP]=\"costMEDIGAP\"\r\n                [costDENTAL]=\"costDENTAL\"\r\n                [costVISION]=\"costVISION\"\r\n              ></vnext-widget-plan-card>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n    <ng-template #threeTiles>\r\n      <ng-container *ngIf=\"plans.length === 3; else twoTiles\">\r\n        <div class=\"col-12\">\r\n          <vnext-widget-plan-card-tile\r\n            [plans]=\"plans\"\r\n            [planCardQuoteLinkText]=\"planCardQuoteLinkText\"\r\n            [planDetailsButtonText]=\"planDetailsButtonText\"\r\n            [planTypeText]=\"planTypeText\"\r\n            [addOnCoverageText]=\"addOnCoverageText\"\r\n            [addOnCoverageTooltipBody]=\"addOnCoverageTooltip\"\r\n            [planDetailsNonCoveredText]=\"planDetailsNonCoveredText\"\r\n            [prescriptionText]=\"prescriptionText\"\r\n            [pharmacyText]=\"pharmacyText\"\r\n            [isTotalEstimatedCostEnabled]=\"isTotalEstimatedCostEnabled\"\r\n            [isRetention]=\"isRetention\"\r\n            [totalEstimatedAnnualCostText]=\"totalEstimatedAnnualCostText\"\r\n            [totalEstimatedCostText]=\"totalEstimatedCostText\"\r\n            [totalEstimatedCostTooltip]=\"totalEstimatedCostTooltip\"\r\n            [showPlanLogo]=\"showPlanLogo\"\r\n            [planBenefits]=\"benefits\"\r\n            [planPreferences]=\"benefitPreferences\"\r\n            [showRidersOnPlanCards]=\"showRidersOnPlanCards\"\r\n            [showPremiumAsAnnual]=\"showPremiumAsAnnual\"\r\n            [riderDisplayMap]=\"riderDisplayMap\"\r\n            [shoppingCartEnabled]=\"shoppingCartEnabled\"\r\n            [drugCoveredText]=\"drugCoveredText\"\r\n            [pharmacyCoveredText]=\"pharmacyCoveredText\"\r\n            [displayDrugsCovered]=\"displayDrugsCovered\"\r\n            [planBenefitNoValueLabel]=\"planBenefitNoValueLabel\"\r\n            [currentPlanText]=\"currentPlanText\"\r\n            [nextYearPlanText]=\"nextYearPlanText\"\r\n            (quoteClicked)=\"quoteClick()\"\r\n            (viewPlanDetails)=\"viewPlanDetailsPage($event)\"\r\n            [noCostAvailableText]=\"noCostAvailableText\"\r\n            [Spa_Site_ShowRiderIcons]=\"Spa_Site_ShowRiderIcons\"\r\n            [Spa_Site_Dental_Rider_Display_Text]=\"Spa_Site_Dental_Rider_Display_Text\"\r\n            [Spa_Site_Vision_Rider_Display_Text]=\"Spa_Site_Vision_Rider_Display_Text\"\r\n            [Spa_Site_Hearing_Rider_Display_Text]=\"Spa_Site_Hearing_Rider_Display_Text\"\r\n            [Spa_PlanCard_DentalAddOnCoverage_Text]=\"Spa_PlanCard_DentalAddOnCoverage_Text\"\r\n            [Spa_PlanCard_HearingAddOnCoverage_Text]=\"Spa_PlanCard_HearingAddOnCoverage_Text\"\r\n            [Spa_PlanCard_VisionAddOnCoverage_Text]=\"Spa_PlanCard_VisionAddOnCoverage_Text\"\r\n            [Spa_PlanCard_AddOnCoverage_Text]=\"Spa_PlanCard_AddOnCoverage_Text\"\r\n            [Spa_Site_MedigapPlanType_Enabled]=\"Spa_Site_MedigapPlanType_Enabled\"\r\n            [Spa_Site_AddToCompare_Enabled]=\"Spa_Site_AddToCompare_Enabled\"\r\n            [Spa_Site_PlanViewDetails_Enabled]=\"Spa_Site_PlanViewDetails_Enabled\"\r\n            [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n            [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n            [inNetworkStandardText]=\"inNetworkStandardText\"\r\n            [outOfNetworkText]=\"outOfNetworkText\"\r\n            [isMailOrderSelected]=\"isMailOrderSelected\"\r\n            [viewCostTooltipHeaderText]=\"viewCostTooltipHeaderText\"\r\n            [viewCostTooltipHeaderContent]=\"viewCostTooltipHeaderContent\"\r\n            [mailOrderText]=\"mailOrderText\"\r\n            [providersInNetworkText]=\"providersInNetworkText\"\r\n            [pcpInNetworkText]=\"pcpInNetworkText\"\r\n            [pcpOutOfNetworkText]=\"pcpOutOfNetworkText\"\r\n            [providersNoDataText]=\"providersNoDataText\"\r\n            [isProviderEnabled]=\"isProviderEnabled\"\r\n            [selectedProviders]=\"selectedProviders\"\r\n            [providerDetails]=\"providerDetails\"\r\n            [viewDetailsDescriptionText]=\"viewDetailsDescriptionText\"\r\n            [optionOneText]=\"optionOneText\"\r\n            [optionTwoText]=\"optionTwoText\"\r\n            [displayOptionLabels]=\"clientDefinedOptionsEnabled\"\r\n            [planLogoSize]=\"planLogoSize\"\r\n            [editLinkText]=\"editLinkText\"\r\n            [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n            [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n            [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n            [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n            [planFeesEnabled]=\"planFeesEnabled\"\r\n            [planFeesTooltipText]=\"planFeesTooltipText\"\r\n            [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n            [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n            [showPlanYear]=\"showPlanYear\"\r\n            [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n            [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n          ></vnext-widget-plan-card-tile>\r\n        </div>\r\n      </ng-container>\r\n    </ng-template>\r\n    <ng-template #twoTiles>\r\n      <div class=\"col-12\">\r\n        <vnext-plan-card-two-tiles\r\n          [plans]=\"plans\"\r\n          [planCardQuoteLinkText]=\"planCardQuoteLinkText\"\r\n          [planDetailsButtonText]=\"planDetailsButtonText\"\r\n          [planTypeText]=\"planTypeText\"\r\n          [addOnCoverageText]=\"addOnCoverageText\"\r\n          [addOnCoverageTooltipBody]=\"addOnCoverageTooltip\"\r\n          [planDetailsNonCoveredText]=\"planDetailsNonCoveredText\"\r\n          [prescriptionText]=\"prescriptionText\"\r\n          [pharmacyText]=\"pharmacyText\"\r\n          [isTotalEstimatedCostEnabled]=\"isTotalEstimatedCostEnabled\"\r\n          [isRetention]=\"isRetention\"\r\n          [totalEstimatedAnnualCostText]=\"totalEstimatedAnnualCostText\"\r\n          [totalEstimatedCostText]=\"totalEstimatedCostText\"\r\n          [totalEstimatedCostTooltip]=\"totalEstimatedCostTooltip\"\r\n          [showPlanLogo]=\"showPlanLogo\"\r\n          [planBenefits]=\"benefits\"\r\n          [planPreferences]=\"benefitPreferences\"\r\n          [showRidersOnPlanCards]=\"showRidersOnPlanCards\"\r\n          [showPremiumAsAnnual]=\"showPremiumAsAnnual\"\r\n          [riderDisplayMap]=\"riderDisplayMap\"\r\n          [shoppingCartEnabled]=\"shoppingCartEnabled\"\r\n          [drugCoveredText]=\"drugCoveredText\"\r\n          [pharmacyCoveredText]=\"pharmacyCoveredText\"\r\n          [displayDrugsCovered]=\"displayDrugsCovered\"\r\n          [hidePlanCardLabel]=\"hidePlanCardLabel\"\r\n          [planBenefitNoValueLabel]=\"planBenefitNoValueLabel\"\r\n          [currentPlanText]=\"currentPlanText\"\r\n          [nextYearPlanText]=\"nextYearPlanText\"\r\n          (quoteClicked)=\"quoteClick()\"\r\n          (viewPlanDetails)=\"viewPlanDetailsPage($event)\"\r\n          [noCostAvailableText]=\"noCostAvailableText\"\r\n          [Spa_Site_ShowRiderIcons]=\"Spa_Site_ShowRiderIcons\"\r\n          [Spa_Site_Dental_Rider_Display_Text]=\"Spa_Site_Dental_Rider_Display_Text\"\r\n          [Spa_Site_Vision_Rider_Display_Text]=\"Spa_Site_Vision_Rider_Display_Text\"\r\n          [Spa_Site_Hearing_Rider_Display_Text]=\"Spa_Site_Hearing_Rider_Display_Text\"\r\n          [Spa_PlanCard_DentalAddOnCoverage_Text]=\"Spa_PlanCard_DentalAddOnCoverage_Text\"\r\n          [Spa_PlanCard_HearingAddOnCoverage_Text]=\"Spa_PlanCard_HearingAddOnCoverage_Text\"\r\n          [Spa_PlanCard_VisionAddOnCoverage_Text]=\"Spa_PlanCard_VisionAddOnCoverage_Text\"\r\n          [Spa_PlanCard_AddOnCoverage_Text]=\"Spa_PlanCard_AddOnCoverage_Text\"\r\n          [Spa_Site_MedigapPlanType_Enabled]=\"Spa_Site_MedigapPlanType_Enabled\"\r\n          [Spa_Site_AddToCompare_Enabled]=\"Spa_Site_AddToCompare_Enabled\"\r\n          [Spa_Site_PlanViewDetails_Enabled]=\"Spa_Site_PlanViewDetails_Enabled\"\r\n          [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n          [inNetworkPreferredText]=\"inNetworkPreferredText\"\r\n          [inNetworkStandardText]=\"inNetworkStandardText\"\r\n          [outOfNetworkText]=\"outOfNetworkText\"\r\n          [isMailOrderSelected]=\"isMailOrderSelected\"\r\n          [viewCostTooltipHeaderText]=\"viewCostTooltipHeaderText\"\r\n          [viewCostTooltipHeaderContent]=\"viewCostTooltipHeaderContent\"\r\n          [mailOrderText]=\"mailOrderText\"\r\n          [providersInNetworkText]=\"providersInNetworkText\"\r\n          [pcpInNetworkText]=\"pcpInNetworkText\"\r\n          [pcpOutOfNetworkText]=\"pcpOutOfNetworkText\"\r\n          [providersNoDataText]=\"providersNoDataText\"\r\n          [isProviderEnabled]=\"isProviderEnabled\"\r\n          [selectedProviders]=\"selectedProviders\"\r\n          [providerDetails]=\"providerDetails\"\r\n          [viewDetailsDescriptionText]=\"viewDetailsDescriptionText\"\r\n          [optionOneText]=\"optionOneText\"\r\n          [optionTwoText]=\"optionTwoText\"\r\n          [displayOptionLabels]=\"clientDefinedOptionsEnabled\"\r\n          [planLogoSize]=\"planLogoSize\"\r\n          [editLinkText]=\"editLinkText\"\r\n          [planCardPreferenceDetailedEnabled]=\"planCardPreferenceDetailedEnabled\"\r\n          [providerOneOrMoreOutOfNetworkText]=\"providerOneOrMoreOutOfNetworkText\"\r\n          [providerInNetworkOnOtherLocationsTooltipText]=\"providerInNetworkOnOtherLocationsTooltipText\"\r\n          [providerShowPartialIndicatorEnabled]=\"providerShowPartialIndicatorEnabled\"\r\n          [planFeesEnabled]=\"planFeesEnabled\"\r\n          [planFeesTooltipText]=\"planFeesTooltipText\"\r\n          [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n          [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n          [showPlanYear]=\"showPlanYear\"\r\n          [viewProvidersButtonText]=\"viewProvidersButtonText\"\r\n          [viewPrescriptionsButtonText]=\"viewPrescriptionsButtonText\"\r\n        ></vnext-plan-card-two-tiles></div\r\n    ></ng-template>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: PlanFacade }]; }, { plans: [{
            type: Input
        }], pickPlanText: [{
            type: Input
        }], planCardQuoteLinkText: [{
            type: Input
        }], showPlanLogo: [{
            type: Input
        }], planDetailsButtonText: [{
            type: Input
        }], planBenefitNoValueLabel: [{
            type: Input
        }], planTypeText: [{
            type: Input
        }], addOnCoverageText: [{
            type: Input
        }], addOnCoverageTooltip: [{
            type: Input
        }], planDetailsNonCoveredText: [{
            type: Input
        }], prescriptionText: [{
            type: Input
        }], pharmacyText: [{
            type: Input
        }], isTotalEstimatedCostEnabled: [{
            type: Input
        }], isRetention: [{
            type: Input
        }], totalEstimatedAnnualCostText: [{
            type: Input
        }], totalEstimatedCostText: [{
            type: Input
        }], totalEstimatedCostTooltip: [{
            type: Input
        }], showRidersOnPlanCards: [{
            type: Input
        }], showPremiumAsAnnual: [{
            type: Input
        }], riderDisplayMap: [{
            type: Input
        }], shoppingCartEnabled: [{
            type: Input
        }], drugCoveredText: [{
            type: Input
        }], pharmacyCoveredText: [{
            type: Input
        }], displayDrugsCovered: [{
            type: Input
        }], hidePlanCardLabel: [{
            type: Input
        }], benefits: [{
            type: Input
        }], benefitPreferences: [{
            type: Input
        }], currentPlanText: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], nextYearPlanText: [{
            type: Input
        }], noCostAvailableText: [{
            type: Input
        }], inNetworkPreferredText: [{
            type: Input
        }], inNetworkStandardText: [{
            type: Input
        }], outOfNetworkText: [{
            type: Input
        }], isMailOrderSelected: [{
            type: Input
        }], viewCostTooltipHeaderText: [{
            type: Input
        }], viewCostTooltipHeaderContent: [{
            type: Input
        }], mailOrderText: [{
            type: Input
        }], providersInNetworkText: [{
            type: Input
        }], pcpInNetworkText: [{
            type: Input
        }], pcpOutOfNetworkText: [{
            type: Input
        }], providersNoDataText: [{
            type: Input
        }], isProviderEnabled: [{
            type: Input
        }], selectedProviders: [{
            type: Input
        }], providerDetails: [{
            type: Input
        }], selectedPharmacy: [{
            type: Input
        }], Spa_Site_ShowRiderIcons: [{
            type: Input
        }], Spa_Site_Dental_Rider_Display_Text: [{
            type: Input
        }], Spa_Site_Vision_Rider_Display_Text: [{
            type: Input
        }], Spa_Site_Hearing_Rider_Display_Text: [{
            type: Input
        }], Spa_PlanCard_DentalAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_HearingAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_VisionAddOnCoverage_Text: [{
            type: Input
        }], Spa_PlanCard_AddOnCoverage_Text: [{
            type: Input
        }], Spa_Site_MedigapPlanType_Enabled: [{
            type: Input
        }], Spa_Site_AddToCompare_Enabled: [{
            type: Input
        }], Spa_Site_PlanViewDetails_Enabled: [{
            type: Input
        }], Spa_Site_Tooltip_Text: [{
            type: Input
        }], viewDetailsDescriptionText: [{
            type: Input
        }], clientDefinedOptionsEnabled: [{
            type: Input
        }], optionOneText: [{
            type: Input
        }], optionTwoText: [{
            type: Input
        }], planLogoSize: [{
            type: Input
        }], showAddToCartForAncillaryPlans: [{
            type: Input
        }], editLinkText: [{
            type: Input
        }], planCardPreferenceDetailedEnabled: [{
            type: Input
        }], providerOneOrMoreOutOfNetworkText: [{
            type: Input
        }], providerInNetworkOnOtherLocationsTooltipText: [{
            type: Input
        }], providerShowPartialIndicatorEnabled: [{
            type: Input
        }], planFeesEnabled: [{
            type: Input
        }], planFeesTooltipText: [{
            type: Input
        }], planFeesIncludedInPremiumTooltipText: [{
            type: Input
        }], planFeesNotIncludedInPremiumTooltipText: [{
            type: Input
        }], showPlanId: [{
            type: Input
        }], showPlanYear: [{
            type: Input
        }], planIdText: [{
            type: Input
        }], availableText: [{
            type: Input
        }], unavailableText: [{
            type: Input
        }], viewProvidersButtonText: [{
            type: Input
        }], viewPrescriptionsButtonText: [{
            type: Input
        }], supplementalBenefitsHighlightText: [{
            type: Input
        }], preferencesText: [{
            type: Input
        }], viewMoreDetailsText: [{
            type: Input
        }], hideDetailsText: [{
            type: Input
        }], newPlanCardDesignEnabled: [{
            type: Input
        }], viewAllPlanDetailsText: [{
            type: Input
        }], shareThisPlanText: [{
            type: Input
        }], viewCostDetailsText: [{
            type: Input
        }], closeText: [{
            type: Input
        }], planBenefitHighlightItems: [{
            type: Input
        }], planBenefitHighlightsHeaderText: [{
            type: Input
        }], showRiderDetails: [{
            type: Input
        }], hideRiderDetailsText: [{
            type: Input
        }], showRiderDetailsText: [{
            type: Input
        }], riderIsIncludedText: [{
            type: Input
        }], waiverStateRiderTooltips: [{
            type: Input
        }], costMA: [{
            type: Input
        }], costMAPD: [{
            type: Input
        }], costMEDIGAP: [{
            type: Input
        }], costPDP: [{
            type: Input
        }], costDENTAL: [{
            type: Input
        }], costVISION: [{
            type: Input
        }], quoteClicked: [{
            type: Output
        }], viewPlanDetails: [{
            type: Output
        }] }); })();

function RetentionUserInfoComponent_h2_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h2", 17);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r0.personalDetailsHeaderText, "html"), i0.ɵɵsanitizeHtml);
} }
function RetentionUserInfoComponent_ng_container_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.zip);
} }
function RetentionUserInfoComponent_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.zip);
} }
function RetentionUserInfoComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r4.countyLabel);
} }
function RetentionUserInfoComponent_ng_container_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, ",");
    i0.ɵɵelementContainerEnd();
} }
function RetentionUserInfoComponent_div_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "h3", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "h4", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.userEmailLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r6.memberData == null ? null : ctx_r6.memberData.profile == null ? null : ctx_r6.memberData.profile.emailAddress, " ");
} }
class RetentionUserInfoComponent {
    constructor() {
        this.editZipCodeClicked = new EventEmitter();
    }
    editZipCode() {
        this.editZipCodeClicked.emit();
    }
    ngOnChanges(changes) {
        const { memberData } = changes;
        if (memberData?.currentValue && !_isEqual(memberData.currentValue?.profile?.addresses, memberData.previousValue?.profile?.addresses)) {
            const address = this.memberData?.profile?.addresses?.find(address => address.isPrimaryAddress);
            this.zip = address?.zip ?? '';
        }
    }
}
RetentionUserInfoComponent.ɵfac = function RetentionUserInfoComponent_Factory(t) { return new (t || RetentionUserInfoComponent)(); };
RetentionUserInfoComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RetentionUserInfoComponent, selectors: [["vnext-widget-retention-user-info"]], inputs: { personalDetailsHeaderText: "personalDetailsHeaderText", userNameLabel: "userNameLabel", userZipcodeLabel: "userZipcodeLabel", userEmailLabel: "userEmailLabel", memberData: "memberData", userZipcodeEditLabel: "userZipcodeEditLabel", selectedCounty: "selectedCounty", userZipcodeEditDescripion: "userZipcodeEditDescripion", countyLabel: "countyLabel", showCountyLabel: "showCountyLabel" }, outputs: { editZipCodeClicked: "editZipCodeClicked" }, features: [i0.ɵɵNgOnChangesFeature], decls: 28, vars: 13, consts: [[1, "container"], [1, "row", "mt-3"], [1, "col-12"], ["class", "Spa_Style_H2", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [1, "row", "user-details-container", "rounded"], [1, "col-xs-12", "col-md-6", "col-lg-3"], [1, "Spa_Style_Smaller_Font", "Spa_Style_Semi_Bold_Weight", "mb-1", "no-translate-block"], [1, "Spa_Style_Smaller_Font", "no-translate-block"], [1, "Spa_Style_Smaller_Font", "Spa_Style_Semi_Bold_Weight", "mb-1"], ["type", "button", 1, "retention-edit-link", "Spa_Style_Link", "action-button", "d-inline", "ml-3", 3, "click"], [1, "Spa_Style_Smaller_Font"], [4, "ngIf", "ngIfElse"], ["inlineLabel", ""], ["class", "Spa_Style_Note d-block", 4, "ngIf"], [1, "no-translate-block"], [4, "ngIf"], ["class", "col-xs-12 col-md-6 col-lg-3", 4, "ngIf"], ["navigationAdapter", "", 1, "Spa_Style_H2", 3, "innerHtml"], [1, "mb-2"], [1, "Spa_Style_Note", "d-block"]], template: function RetentionUserInfoComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, RetentionUserInfoComponent_h2_3_Template, 2, 4, "h2", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2)(5, "div", 0)(6, "div", 4)(7, "div", 5)(8, "h3", 6);
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "h4", 7);
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(12, "div", 5)(13, "h3", 8);
        i0.ɵɵtext(14);
        i0.ɵɵelementStart(15, "span")(16, "button", 9);
        i0.ɵɵlistener("click", function RetentionUserInfoComponent_Template_button_click_16_listener() { return ctx.editZipCode(); });
        i0.ɵɵtext(17);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(18, "h4", 10);
        i0.ɵɵtemplate(19, RetentionUserInfoComponent_ng_container_19_Template, 3, 1, "ng-container", 11);
        i0.ɵɵtemplate(20, RetentionUserInfoComponent_ng_template_20_Template, 2, 1, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(22, RetentionUserInfoComponent_div_22_Template, 2, 1, "div", 13);
        i0.ɵɵelementStart(23, "span", 14);
        i0.ɵɵtext(24);
        i0.ɵɵtemplate(25, RetentionUserInfoComponent_ng_container_25_Template, 2, 0, "ng-container", 15);
        i0.ɵɵtext(26);
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(27, RetentionUserInfoComponent_div_27_Template, 5, 2, "div", 16);
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(21);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "Spa_RetentionUserInfo_PersonalDetailsHeader_Text");
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", ctx.userNameLabel, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate((ctx.memberData == null ? null : ctx.memberData.profile == null ? null : ctx.memberData.profile.firstName) + " " + (ctx.memberData == null ? null : ctx.memberData.profile == null ? null : ctx.memberData.profile.lastName));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.userZipcodeLabel, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵattribute("aria-label", ctx.userZipcodeEditDescripion);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.userZipcodeEditLabel, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.showCountyLabel)("ngIfElse", _r2);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.showCountyLabel);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.selectedCounty == null ? null : ctx.selectedCounty.countyName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.selectedCounty == null ? null : ctx.selectedCounty.countyName) && (ctx.selectedCounty == null ? null : ctx.selectedCounty.state));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.selectedCounty == null ? null : ctx.selectedCounty.state, "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.memberData == null ? null : ctx.memberData.profile == null ? null : ctx.memberData.profile.emailAddress);
    } }, dependencies: [i1$2.NgIf, NavigationAdapterDirective, LiveEditPropDirective, SafePipe], styles: [".user-details-container[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);padding:15px 0}.retention-edit-link[_ngcontent-%COMP%]{cursor:pointer;display:inline-block;text-decoration:underline}@media (max-width: 992px){.user-details-container[_ngcontent-%COMP%]{height:auto;padding:15px 0}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RetentionUserInfoComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-retention-user-info', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container\">\r\n  <div class=\"row mt-3\">\r\n    <div class=\"col-12\">\r\n      <h2\r\n        *liveEditProp=\"'Spa_RetentionUserInfo_PersonalDetailsHeader_Text'\"\r\n        class=\"Spa_Style_H2\"\r\n        [innerHtml]=\"personalDetailsHeaderText | safe : 'html'\"\r\n        navigationAdapter\r\n      ></h2>\r\n    </div>\r\n    <div class=\"col-12\">\r\n      <div class=\"container\">\r\n        <div class=\"row user-details-container rounded\">\r\n          <div class=\"col-xs-12 col-md-6 col-lg-3\">\r\n            <h3 class=\"Spa_Style_Smaller_Font Spa_Style_Semi_Bold_Weight mb-1 no-translate-block\">\r\n              {{ userNameLabel }}\r\n            </h3>\r\n            <h4 class=\"Spa_Style_Smaller_Font no-translate-block\">{{ memberData?.profile?.firstName + ' ' + memberData?.profile?.lastName }}</h4>\r\n          </div>\r\n          <div class=\"col-xs-12 col-md-6 col-lg-3\">\r\n            <h3 class=\"Spa_Style_Smaller_Font Spa_Style_Semi_Bold_Weight mb-1\">\r\n              {{ userZipcodeLabel }}\r\n              <span>\r\n                <button\r\n                  type=\"button\"\r\n                  (click)=\"editZipCode()\"\r\n                  [attr.aria-label]=\"userZipcodeEditDescripion\"\r\n                  class=\"retention-edit-link Spa_Style_Link action-button d-inline ml-3\"\r\n                >\r\n                  {{ userZipcodeEditLabel }}\r\n                </button></span\r\n              >\r\n            </h3>\r\n            <h4 class=\"Spa_Style_Smaller_Font\">\r\n              <ng-container *ngIf=\"showCountyLabel; else inlineLabel\">\r\n                <div class=\"mb-2\">{{ zip }}</div>\r\n              </ng-container>\r\n              <ng-template #inlineLabel>\r\n                <span>{{ zip }}</span>\r\n              </ng-template>\r\n              <div *ngIf=\"showCountyLabel\" class=\"Spa_Style_Note d-block\">{{ countyLabel }}</div>\r\n              <span class=\"no-translate-block\">{{ selectedCounty?.countyName }}<ng-container *ngIf=\"selectedCounty?.countyName && selectedCounty?.state\">,</ng-container>\r\n              {{ selectedCounty?.state }}</span>\r\n            </h4>\r\n          </div>\r\n          <div class=\"col-xs-12 col-md-6 col-lg-3\" *ngIf=\"memberData?.profile?.emailAddress\">\r\n            <h3 class=\"Spa_Style_Smaller_Font Spa_Style_Semi_Bold_Weight mb-1\">\r\n              {{ userEmailLabel }}\r\n            </h3>\r\n            <h4 class=\"Spa_Style_Smaller_Font no-translate-block\">\r\n              {{ memberData?.profile?.emailAddress }}\r\n            </h4>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".user-details-container{border:1px solid var(--static-Spa_Style_Accent1);padding:15px 0}.retention-edit-link{cursor:pointer;display:inline-block;text-decoration:underline}@media (max-width: 992px){.user-details-container{height:auto;padding:15px 0}}\n"] }]
    }], null, { personalDetailsHeaderText: [{
            type: Input
        }], userNameLabel: [{
            type: Input
        }], userZipcodeLabel: [{
            type: Input
        }], userEmailLabel: [{
            type: Input
        }], memberData: [{
            type: Input
        }], userZipcodeEditLabel: [{
            type: Input
        }], selectedCounty: [{
            type: Input
        }], userZipcodeEditDescripion: [{
            type: Input
        }], countyLabel: [{
            type: Input
        }], showCountyLabel: [{
            type: Input
        }], editZipCodeClicked: [{
            type: Output
        }] }); })();

const _c0$B = function (a0) { return { "background-image": a0 }; };
function RetentionWelcomeComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9);
    i0.ɵɵelement(2, "div", 10)(3, "div", 11);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(2, _c0$B, "url(" + ctx_r0.fullImageMobilePath + ")"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(4, _c0$B, "url(" + ctx_r0.fullImagePath + ")"));
} }
function RetentionWelcomeComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.greetingText + " ");
} }
function RetentionWelcomeComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r2.memberData == null ? null : ctx_r2.memberData.profile == null ? null : ctx_r2.memberData.profile.firstName, ",");
} }
function RetentionWelcomeComponent_p_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.memberData == null ? null : ctx_r3.memberData.memberMessages[0] == null ? null : ctx_r3.memberData.memberMessages[0].message, " ");
} }
class RetentionWelcomeComponent {
}
RetentionWelcomeComponent.ɵfac = function RetentionWelcomeComponent_Factory(t) { return new (t || RetentionWelcomeComponent)(); };
RetentionWelcomeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RetentionWelcomeComponent, selectors: [["vnext-widget-retention-welcome"]], inputs: { fullImagePath: "fullImagePath", fullImageMobilePath: "fullImageMobilePath", greetingText: "greetingText", memberData: "memberData", backgroundUrlEnabled: "backgroundUrlEnabled" }, decls: 8, vars: 4, consts: [["class", "Spa_Style_Banner_Background", 4, "ngIf"], [1, "container"], [1, "mt-4"], [1, "Spa_Style_H1"], [4, "liveEditProp"], ["class", "no-translate-block", 4, "ngIf"], [1, "mb-5"], ["class", "Spa_Style_Paragraph", 4, "ngIf"], [1, "Spa_Style_Banner_Background"], [1, "container", "p-0"], [1, "retention-banner-img", "d-md-none", 3, "ngStyle"], [1, "retention-banner-img", "d-none", "d-md-block", 3, "ngStyle"], [1, "no-translate-block"], [1, "Spa_Style_Paragraph"]], template: function RetentionWelcomeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, RetentionWelcomeComponent_div_0_Template, 4, 6, "div", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "h1", 3);
        i0.ɵɵtemplate(4, RetentionWelcomeComponent_span_4_Template, 2, 1, "span", 4);
        i0.ɵɵtemplate(5, RetentionWelcomeComponent_span_5_Template, 2, 1, "span", 5);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵtemplate(7, RetentionWelcomeComponent_p_7_Template, 2, 1, "p", 7);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.backgroundUrlEnabled);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("liveEditProp", "Spa_Site_RetentionWelcome_Greeting_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.memberData == null ? null : ctx.memberData.profile == null ? null : ctx.memberData.profile.firstName);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.memberData == null ? null : ctx.memberData.memberMessages[0] == null ? null : ctx.memberData.memberMessages[0].message);
    } }, dependencies: [i1$2.NgIf, i1$2.NgStyle, LiveEditPropDirective], styles: [".retention-banner-img[_ngcontent-%COMP%]{width:100%;height:300px;background-size:cover}@media (max-width: 992px){.retention-banner-img[_ngcontent-%COMP%]{width:100%;height:200px;background-size:cover}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RetentionWelcomeComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-retention-welcome', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div *ngIf=\"backgroundUrlEnabled\" class=\"Spa_Style_Banner_Background\">\r\n  <div class=\"container p-0\">\r\n    <div class=\"retention-banner-img d-md-none\" [ngStyle]=\"{ 'background-image': 'url(' + fullImageMobilePath + ')' }\"></div>\r\n    <div class=\"retention-banner-img d-none d-md-block\" [ngStyle]=\"{ 'background-image': 'url(' + fullImagePath + ')' }\"></div>\r\n  </div>\r\n</div>\r\n<div class=\"container\">\r\n  <div class=\"mt-4\">\r\n    <h1 class=\"Spa_Style_H1\">\r\n      <span *liveEditProp=\"'Spa_Site_RetentionWelcome_Greeting_Text'\">{{ greetingText + ' ' }}</span>\r\n      <span *ngIf=\"memberData?.profile?.firstName\" class=\"no-translate-block\">{{ memberData?.profile?.firstName }},</span>\r\n    </h1>\r\n  </div>\r\n  <div class=\"mb-5\">\r\n    <p class=\"Spa_Style_Paragraph\" *ngIf=\"(memberData?.memberMessages)[0]?.message\">\r\n      {{ (memberData?.memberMessages)[0]?.message }}\r\n    </p>\r\n  </div>\r\n</div>\r\n", styles: [".retention-banner-img{width:100%;height:300px;background-size:cover}@media (max-width: 992px){.retention-banner-img{width:100%;height:200px;background-size:cover}}\n"] }]
    }], null, { fullImagePath: [{
            type: Input
        }], fullImageMobilePath: [{
            type: Input
        }], greetingText: [{
            type: Input
        }], memberData: [{
            type: Input
        }], backgroundUrlEnabled: [{
            type: Input
        }] }); })();

function RetentionSummaryComponent_ng_container_7_vnext_widget_retention_plan_card_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-widget-retention-plan-card", 8);
    i0.ɵɵlistener("quoteClicked", function RetentionSummaryComponent_ng_container_7_vnext_widget_retention_plan_card_1_Template_vnext_widget_retention_plan_card_quoteClicked_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r5.planFacade.updateMedSupFormOpen(true)); })("viewPlanDetails", function RetentionSummaryComponent_ng_container_7_vnext_widget_retention_plan_card_1_Template_vnext_widget_retention_plan_card_viewPlanDetails_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r7.retentionFacade.viewPlanDetailsPage($event)); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const filteredPlans_r2 = i0.ɵɵnextContext().ngIf;
    const ctx_r3 = i0.ɵɵnextContext();
    let tmp_24_0;
    let tmp_25_0;
    i0.ɵɵproperty("plans", filteredPlans_r2)("pickPlanText", ctx_r3.Spa_Retention_PickPlan_Text)("planCardQuoteLinkText", ctx_r3.Spa_PlanCard_QuoteLinkName_Text)("planDetailsButtonText", ctx_r3.Spa_PlanCard_PlanDetails_ButtonText)("planBenefitNoValueLabel", ctx_r3.Spa_Site_NotApplicable_Text)("planTypeText", ctx_r3.Spa_PlanCard_PlanType_Text)("addOnCoverageText", ctx_r3.Spa_PlanCard_AddOnCoverageInCart_Text)("addOnCoverageTooltip", ctx_r3.Spa_PlanCard_AddOnCoverageTooltip_Body)("planDetailsNonCoveredText", ctx_r3.Spa_PlanDetails_Non_Covered_Text)("prescriptionText", ctx_r3.Spa_Site_Prescriptions_Text)("pharmacyText", ctx_r3.Spa_Site_Pharmacy_Text)("isTotalEstimatedCostEnabled", ctx_r3.Spa_Site_TotalEstimatedCost_Enabled)("isRetention", ctx_r3.isRetentionView)("totalEstimatedAnnualCostText", ctx_r3.Spa_PlanCard_TotalEstimatedAnnualCost_Text)("totalEstimatedCostText", ctx_r3.Spa_PlanCard_TotalEstimatedCost_Text)("totalEstimatedCostTooltip", ctx_r3.Spa_PlanCard_Total_Estimated_Cost_Tooltip)("showPlanLogo", ctx_r3.Spa_Site_Show_PlanLogo)("showRidersOnPlanCards", ctx_r3.Spa_Site_ShowRidersOnPlanCards)("showPremiumAsAnnual", ctx_r3.Spa_Site_ShowPremiumAsAnnual)("riderDisplayMap", ctx_r3.riderDisplayMap)("shoppingCartEnabled", ctx_r3.Spa_ShoppingCart_Enabled)("drugCoveredText", ctx_r3.Spa_PlanCard_Drug_Covered_Text)("pharmacyCoveredText", ctx_r3.Spa_PlanCard_Pharmacy_Covered_Text)("displayDrugsCovered", ctx_r3.Spa_PlanList_DisplayDrugsCovered)("benefits", (tmp_24_0 = ctx_r3.retentionFacade.getActiveTab()) == null ? null : tmp_24_0.benefits)("benefitPreferences", (tmp_25_0 = ctx_r3.retentionFacade.getActiveTab()) == null ? null : tmp_25_0.benefitPreferences)("currentPlanText", ctx_r3.Spa_Site_Current_Plan_Text)("isMobile", i0.ɵɵpipeBind1(1, 101, ctx_r3.isMobile$))("nextYearPlanText", ctx_r3.Spa_Site_Next_Year_Plan_Text)("noCostAvailableText", ctx_r3.Spa_Site_NotApplicable_Text)("Spa_Site_ShowRiderIcons", ctx_r3.Spa_Site_ShowRiderIcons)("Spa_Site_Dental_Rider_Display_Text", ctx_r3.Spa_Site_Dental_Rider_Display_Text)("Spa_Site_Vision_Rider_Display_Text", ctx_r3.Spa_Site_Vision_Rider_Display_Text)("Spa_Site_Hearing_Rider_Display_Text", ctx_r3.Spa_Site_Hearing_Rider_Display_Text)("Spa_PlanCard_DentalAddOnCoverage_Text", ctx_r3.Spa_PlanCard_DentalAddOnCoverage_Text)("Spa_PlanCard_HearingAddOnCoverage_Text", ctx_r3.Spa_PlanCard_HearingAddOnCoverage_Text)("Spa_PlanCard_VisionAddOnCoverage_Text", ctx_r3.Spa_PlanCard_VisionAddOnCoverage_Text)("Spa_PlanCard_AddOnCoverage_Text", ctx_r3.Spa_PlanCard_AddOnCoverage_Text)("Spa_Site_MedigapPlanType_Enabled", ctx_r3.Spa_Site_MedigapPlanType_Enabled)("Spa_Site_AddToCompare_Enabled", ctx_r3.Spa_Site_AddToCompare_Enabled)("Spa_Site_PlanViewDetails_Enabled", ctx_r3.Spa_Site_PlanViewDetails_Enabled)("Spa_Site_Tooltip_Text", ctx_r3.Spa_Site_Tooltip_Text)("inNetworkPreferredText", ctx_r3.Spa_PlanList_Pharmacy_InNetwork_Preferred_Pricing_Text)("inNetworkStandardText", ctx_r3.Spa_PlanList_Pharmacy_InNetwork_Standard_Pricing_Text)("outOfNetworkText", ctx_r3.Spa_PlanList_Pharmacy_OutOfNetwork_Pricing_Text)("isMailOrderSelected", i0.ɵɵpipeBind1(2, 103, ctx_r3.pharmacyFacade.mailOrder$))("viewCostTooltipHeaderText", ctx_r3.Spa_PlanList_ViewCost_Header_Text)("viewCostTooltipHeaderContent", ctx_r3.Spa_PlanList_ViewCost_Header_Content)("mailOrderText", ctx_r3.Spa_PlanList_MailOrder_Text)("providersInNetworkText", ctx_r3.Spa_PlanCard_Providers_InNetwork_Text)("pcpInNetworkText", ctx_r3.Spa_Site_Pcp_InNetwork_Text)("pcpOutOfNetworkText", ctx_r3.Spa_Site_Pcp_OutOfNetwork_Text)("providersNoDataText", ctx_r3.Spa_Providers_No_Data_Exist_Text)("isProviderEnabled", ctx_r3.Spa_Site_Providers_Enabled)("selectedProviders", ctx_r3.providers)("providerDetails", i0.ɵɵpipeBind1(3, 105, ctx_r3.providerDetails$))("selectedPharmacy", ctx_r3.selectedPharmacy)("viewDetailsDescriptionText", ctx_r3.Spa_Site_ViewDetailsLink_Description_Text)("clientDefinedOptionsEnabled", ctx_r3.Spa_Retention_ClientDefinedPlanOptions_Enabled)("optionOneText", ctx_r3.Spa_Site_Plan_Option_One_Text)("optionTwoText", ctx_r3.Spa_Site_Plan_Option_Two_Text)("planLogoSize", ctx_r3.Spa_Site_PlanLogo_Size)("showAddToCartForAncillaryPlans", ctx_r3.Spa_PlanCard_AncillaryAddtoCart_Enabled)("editLinkText", ctx_r3.editLinkText)("planCardPreferenceDetailedEnabled", ctx_r3.Spa_PlanCard_Preferences_Detailed_Enabled)("providerOneOrMoreOutOfNetworkText", ctx_r3.Spa_PlanCard_Providers_OneOrMore_OutOfNetwork_Text)("providerInNetworkOnOtherLocationsTooltipText", ctx_r3.Spa_Providers_InNetwork_OnOtherLocations_Tooltip_Text)("providerShowPartialIndicatorEnabled", ctx_r3.Spa_Provider_ShowPartialIndicator_Enabled)("planFeesEnabled", ctx_r3.Spa_Site_PlanFees_Enabled)("planFeesTooltipText", ctx_r3.Spa_PlanFees_Tooltip_Text)("planFeesIncludedInPremiumTooltipText", ctx_r3.Spa_PlanFees_IncludedInPremium_Tooltip_Text)("planFeesNotIncludedInPremiumTooltipText", ctx_r3.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text)("showPlanId", ctx_r3.Spa_PlanCard_Show_PlanId_Enabled)("showPlanYear", ctx_r3.Spa_PlanCard_PlanYearBadge_Enabled)("planIdText", ctx_r3.Spa_PlanCard_PlanId_Text)("availableText", ctx_r3.Spa_Site_Available_Text)("unavailableText", ctx_r3.Spa_Site_NotAvailable_Text)("viewProvidersButtonText", ctx_r3.Spa_PlanCard_Providers_ViewButton_Text)("viewPrescriptionsButtonText", ctx_r3.Spa_PlanCard_Prescriptions_ViewButton_Text)("supplementalBenefitsHighlightText", ctx_r3.Spa_PlanCard_SupplementalBenefitsHighlight_Text)("preferencesText", ctx_r3.Spa_Plan_Details_Preferences_Text)("viewMoreDetailsText", ctx_r3.Spa_PlanCard_ViewMoreDetails_ButtonText)("hideDetailsText", ctx_r3.Spa_PlanCard_HideDetails_ButtonText)("newPlanCardDesignEnabled", ctx_r3.Spa_PlanCard_NewDesign_Enabled)("viewAllPlanDetailsText", ctx_r3.Spa_PlanCard_ViewAllPlanDetails_ButtonText)("shareThisPlanText", ctx_r3.Spa_PlanCard_ShareThisPlan_ButtonText)("viewCostDetailsText", ctx_r3.Spa_PlanCard_ViewCostDetails_ButtonText)("closeText", ctx_r3.Spa_Site_Close)("planBenefitHighlightItems", ctx_r3.Spa_PlanCard_PlanBenefitHighlight_Items)("planBenefitHighlightsHeaderText", ctx_r3.Spa_PlanCard_PlanBenefitHighlights_Text)("showRiderDetails", ctx_r3.Spa_Site_RiderDetails_Show)("showRiderDetailsText", ctx_r3.Spa_Plan_Details_ViewRiderDetails_Text)("hideRiderDetailsText", ctx_r3.Spa_Plan_Details_HideRiderDetails_Text)("riderIsIncludedText", ctx_r3.Spa_ShoppingCart_IncludedRider_Text)("waiverStateRiderTooltips", ctx_r3.Spa_Plan_Details_WaiverStateRider_Tooltips)("costMA", ctx_r3.Spa_Plandetails_Costs_MA)("costMAPD", ctx_r3.Spa_Plandetails_Costs_MAPD)("costPDP", ctx_r3.Spa_Plandetails_Costs_PDP)("costMEDIGAP", ctx_r3.Spa_Plandetails_Costs_MEDIGAP)("costDENTAL", ctx_r3.Spa_PlanDetails_Costs_DENTAL)("costVISION", ctx_r3.Spa_PlanDetails_Costs_VISION);
} }
function RetentionSummaryComponent_ng_container_7_div_2_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 11);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r9.Spa_Site_Provider_Disclaimer, "html"), i0.ɵɵsanitizeHtml);
} }
function RetentionSummaryComponent_ng_container_7_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, RetentionSummaryComponent_ng_container_7_div_2_p_1_Template, 2, 4, "p", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_Provider_Disclaimer");
} }
function RetentionSummaryComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, RetentionSummaryComponent_ng_container_7_vnext_widget_retention_plan_card_1_Template, 4, 107, "vnext-widget-retention-plan-card", 5);
    i0.ɵɵtemplate(2, RetentionSummaryComponent_ng_container_7_div_2_Template, 2, 1, "div", 6);
    i0.ɵɵelementStart(3, "vnext-summary-buttons", 7);
    i0.ɵɵlistener("comparePlansSelected", function RetentionSummaryComponent_ng_container_7_Template_vnext_summary_buttons_comparePlansSelected_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r11); const filteredPlans_r2 = restoredCtx.ngIf; const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.retentionFacade.updatePlansOnCompareGroupAndNavigate(filteredPlans_r2)); })("shopForPlansSelected", function RetentionSummaryComponent_ng_container_7_Template_vnext_summary_buttons_shopForPlansSelected_3_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.retentionFacade.shopAllPlans()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const filteredPlans_r2 = ctx.ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (filteredPlans_r2 == null ? null : filteredPlans_r2.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.Spa_Site_Providers_Enabled && (filteredPlans_r2 == null ? null : filteredPlans_r2.length));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("filteredPlans", filteredPlans_r2)("shopAllPlansButtonText", ctx_r0.Spa_Site_Shop_All_Plans_Button_Text)("compareThesePlansButtonText", ctx_r0.Spa_Retention_CompareThesePlans_Button_Text);
} }
function RetentionSummaryComponent_vnext_summary_coverage_types_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-summary-coverage-types", 12);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("planTiles", ctx_r1.planTiles)("shopsAllCoverageText", ctx_r1.Spa_Site_ShopAllCoverage_Text)("planCounts", ctx_r1.planCounts)("pickPlanLabel", ctx_r1.Spa_Retention_PickPlan_Text)("filteredPlans", ctx_r1.filteredPlans)("notAvailableText", ctx_r1.Spa_Retention_NotAvailable_Text)("planTabEducationalTextShow", ctx_r1.Spa_Plan_Tab_Educational_Text_Show);
} }
let RetentionSummaryComponent = class RetentionSummaryComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, store, memberSessionService, guidedHelpService, retentionFacade, planFacade, plansService, imageService, responsiveLayoutService, injector, modalService, planListFacade, siteService, configResourceService, localeService, pharmacyFacade, analyticsService, router) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.store = store;
        this.memberSessionService = memberSessionService;
        this.guidedHelpService = guidedHelpService;
        this.retentionFacade = retentionFacade;
        this.planFacade = planFacade;
        this.plansService = plansService;
        this.imageService = imageService;
        this.responsiveLayoutService = responsiveLayoutService;
        this.injector = injector;
        this.modalService = modalService;
        this.planListFacade = planListFacade;
        this.siteService = siteService;
        this.configResourceService = configResourceService;
        this.localeService = localeService;
        this.pharmacyFacade = pharmacyFacade;
        this.analyticsService = analyticsService;
        this.router = router;
        this.Spa_Site_RetentionWelcome_Background_Url = 'phoenix/assets/images/couple_dog.jpg';
        this.Spa_Site_RetentionWelcome_Background_MobileUrl = 'phoenix/assets/images/couple_dog_mobile.jpg';
        this.Spa_Site_RetentionUserInfo_Name_Label = 'Name';
        this.Spa_Site_RetentionUserInfo_ZipCode_Label = 'ZIP code';
        this.Spa_Site_RetentionUserInfo_Email_Label = 'Email address';
        this.Spa_PlanCard_QuoteLinkName_Text = 'Get a personalized quote';
        this.Spa_PlanCard_PlanDetails_ButtonText = 'Plan details';
        this.Spa_Site_NotApplicable_Text = 'N/A';
        this.Spa_PlanCard_PlanType_Text = 'Plan Type';
        this.Spa_PlanCard_AddOnCoverageInCart_Text = 'Add-on coverage available in cart';
        this.Spa_PlanCard_AddOnCoverageTooltip_Body = `<span>Available add-on coverage</span><br/>
  <span> To learn more about the add-on coverage available for this plan, either go to plan details or add this plan to your cart.</span>`;
        this.Spa_Site_Show_PlanLogo = true;
        this.Spa_PlanDetails_Non_Covered_Text = 'Not Covered';
        this.Spa_Site_Prescriptions_Text = 'Prescriptions';
        this.Spa_Site_Pharmacy_Text = 'Pharmacy';
        this.Spa_Site_TotalEstimatedCost_Enabled = true;
        this.Spa_PlanCard_TotalEstimatedAnnualCost_Text = 'Total est. annual cost';
        this.Spa_PlanCard_TotalEstimatedCost_Text = 'Total est. cost';
        this.Spa_PlanCard_Total_Estimated_Cost_Tooltip = {
            header: 'Total estimated annual cost',
            body: 'Your total estimated annual cost is based on the plans yearly premium, your drug costs, and your health status and age.'
        };
        this.Spa_Site_ShowPremiumAsAnnual = false;
        this.Spa_Site_ShowRiderIcons = true;
        this.Spa_Site_ShowRidersOnPlanCards = true;
        this.Spa_Site_Dental_Rider_Display_Text = 'Dental';
        this.Spa_Site_Vision_Rider_Display_Text = 'Vision';
        this.Spa_Site_Hearing_Rider_Display_Text = 'Hearing';
        this.Spa_PlanCard_DentalAddOnCoverage_Text = 'Dental Included';
        this.Spa_PlanCard_HearingAddOnCoverage_Text = 'Hearing Included';
        this.Spa_PlanCard_VisionAddOnCoverage_Text = 'Vision Included';
        this.Spa_PlanCard_AddOnCoverage_Text = 'Add-on coverage';
        this.Spa_PlanCard_ShowRidersOnMACards = true;
        this.Spa_PlanCard_ShowRidersOnPDPCards = true;
        this.Spa_PlanCard_ShowRidersOnMAPDCards = true;
        this.Spa_PlanCard_ShowRidersOnMEDIGAPCards = true;
        this.Spa_ShoppingCart_Enabled = true;
        this.Spa_PlanCard_Drug_Covered_Text = '<coveredDrugCount> of <totalDrugCount> covered';
        this.Spa_PlanCard_Pharmacy_Covered_Text = '<coveredPharmacies> of <totalPharamcies> covered';
        this.Spa_Site_Health_Text = 'Health';
        this.Spa_Site_QualifiedHelp_Text = 'Qualified help';
        this.Spa_GettingStarted_ShowSubsidyAccordion_Flag = true;
        this.Spa_Site_Hide_Text = 'Hide';
        this.Spa_Site_ViewAll_Text = 'View more';
        this.Spa_GuidedHelp_Enabled = true;
        this.Spa_Site_Health_Enabled = true;
        this.Spa_Site_Prescriptions_Enabled = true;
        this.Spa_Site_Pharmacy_Enabled = true;
        this.Spa_Site_GetStarted_Enabled = true;
        this.Spa_Site_Preferences_Edit_Text = 'Edit';
        this.Spa_GuidedHelp_PlanList_AddLink_Text = 'Add';
        this.Spa_Site_Current_Plan_Text = 'Current Plan';
        this.Spa_Site_Next_Year_Plan_Text = `Next year's plan`;
        this.Spa_Site_PlanNotAvailableForNextYear_Text = 'Plan not available next year';
        this.Spa_Site_Keep_This_Plan_Button_Text = 'Keep this plan';
        this.Spa_Site_RetentionUserInfo_Zipcode_Edit_Label = 'Edit';
        this.Spa_Site_UserInfo_Zipcode_Edit_Description = 'Edit Zipcode';
        this.Spa_Site_Shop_All_Plans_Button_Text = 'Shop all available plans';
        this.Spa_Retention_CompareThesePlans_Button_Text = 'Compare these plans';
        this.Spa_Retention_NotAvailable_Text = 'Not available';
        this.Spa_Site_Preferences_Edit_Description = 'Edit Preferences';
        this.Spa_Site_MedigapPlanType_Enabled = true;
        this.Spa_Site_AddToCompare_Enabled = true;
        this.Spa_Site_PlanViewDetails_Enabled = true;
        this.Spa_Site_Providers_Enabled = false;
        this.Spa_Site_Providers_Text = 'Providers';
        this.Spa_Site_Pcp_Text = 'PCP';
        this.Spa_PlanCard_Providers_InNetwork_Text = '<inNetwork> of <totalProviders> In-network';
        this.Spa_Site_Pcp_InNetwork_Text = 'PCP In-network';
        this.Spa_Site_Pcp_OutOfNetwork_Text = 'PCP Out-of-network';
        this.Spa_Providers_No_Data_Exist_Text = 'No provider data for this carrier';
        this.Spa_ZipCodeInput_CountyLabel_Text = 'County';
        this.Spa_ZipCodeInput_CountyLabel_Enabled = false;
        this.Spa_PlanList_DisplayDrugsCovered = true;
        this.Spa_RetentionUserInfo_PersonalDetailsHeader_Text = 'Review your information';
        this.Spa_Retention_PickPlan_Text = 'Pick a plan';
        this.Spa_Site_ShopAllCoverage_Text = 'Shop all coverage types';
        this.Spa_Summary_AddPreferences_Text = 'Add your preferences (Optional)';
        this.Spa_Site_RetentionWelcome_Greeting_Text = 'Hi';
        this.Spa_Site_Provider_Disclaimer = 'Note: Double check the provider directory in case the data is outdated. You may access the provider directory from the plan details.';
        this.Spa_Plan_Tab_Educational_Text_Show = true;
        this.Spa_Site_Tooltip_Text = 'Tooltip:';
        this.Spa_Site_Multi_Pharmacy_Enabled = false;
        this.Spa_Site_PrimaryPharmacy_Indicator_Text = 'primary';
        this.Spa_PlanList_Pharmacy_InNetwork_Preferred_Pricing_Text = 'Preferred In-network';
        this.Spa_PlanList_Pharmacy_InNetwork_Standard_Pricing_Text = 'Standard In-network';
        this.Spa_PlanList_Pharmacy_OutOfNetwork_Pricing_Text = 'Out of network';
        this.Spa_PlanList_ViewCost_Header_Text = 'View costs for other pharmacies';
        this.Spa_PlanList_ViewCost_Header_Content = 'Switch your pharmacy to the left of plans to view costs of other pharmacies';
        this.Spa_PlanList_MailOrder_Text = 'Mail order';
        this.Spa_Site_OtherPreferences_Text = 'Other preferences';
        this.Spa_Site_OtherPreferences_Enabled = false;
        this.Spa_GuidedHelp_ReviewOtherPreferences_Text = 'Review and edit your other preferences.';
        this.Spa_Site_ViewDetailsLink_Description_Text = 'Press Enter to view plan details of ';
        this.Spa_Retention_ClientDefinedPlanOptions_Enabled = false;
        this.Spa_Site_PlanLogo_Size = 'small';
        this.Spa_PlanCard_AncillaryAddtoCart_Enabled = false;
        this.Spa_Site_Provider_ShowAllInNetworkLocations_Enabled = true;
        this.Spa_Site_RetentionWelcome_Background_Url_Enabled = true;
        this.Spa_Site_Retention_CoverageTypesSection_Enabled = true;
        this.Spa_PlanCard_Preferences_Detailed_Enabled = true;
        this.Spa_PlanCard_Providers_OneOrMore_OutOfNetwork_Text = 'One or more locations are out of network';
        this.Spa_Providers_InNetwork_OnOtherLocations_Tooltip_Text = 'Selected location is out-of-network, however in-network locations are available.';
        this.Spa_Provider_ShowPartialIndicator_Enabled = false;
        this.Spa_Site_PlanFees_Enabled = false;
        this.Spa_PlanFees_Tooltip_Text = 'Fees';
        this.Spa_PlanFees_IncludedInPremium_Tooltip_Text = 'Included in premium';
        this.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text = 'Not included in premium';
        this.Spa_PlanCard_Show_PlanId_Enabled = false;
        this.Spa_PlanCard_PlanYearBadge_Enabled = false;
        this.Spa_PlanCard_PlanId_Text = 'Plan ID';
        this.Spa_Site_Available_Text = 'Available';
        this.Spa_Site_NotAvailable_Text = 'Not Available';
        this.Spa_PlanCard_Providers_ViewButton_Text = 'View providers';
        this.Spa_PlanCard_Prescriptions_ViewButton_Text = 'View prescriptions';
        this.Spa_PlanCard_SupplementalBenefitsHighlight_Text = 'Highlights';
        this.Spa_Plan_Details_Preferences_Text = 'Preferences';
        this.Spa_PlanCard_ViewMoreDetails_ButtonText = 'View more details';
        this.Spa_PlanCard_HideDetails_ButtonText = 'Hide details';
        this.Spa_PlanCard_NewDesign_Enabled = false;
        this.Spa_PlanCard_ViewAllPlanDetails_ButtonText = 'View all plan details';
        this.Spa_PlanCard_ShareThisPlan_ButtonText = 'Share this plan';
        this.Spa_PlanCard_ViewCostDetails_ButtonText = 'View cost details';
        this.Spa_Site_Close = 'Close';
        this.Spa_PlanCard_PlanBenefitHighlight_Items = [
            {
                name: 'Specialist Office Visit'
            },
            {
                name: 'Inpatient Hospital Care'
            },
            {
                name: 'Total est. cost'
            }
        ];
        this.Spa_PlanCard_PlanBenefitHighlights_Text = 'Plan benefit highlights';
        this.Spa_Site_RiderDetails_Show = false;
        this.Spa_Plan_Details_ViewRiderDetails_Text = 'View details';
        this.Spa_Plan_Details_HideRiderDetails_Text = 'Hide details';
        this.Spa_ShoppingCart_IncludedRider_Text = 'Included';
        this.Spa_Plan_Details_WaiverStateRider_Tooltips = [
            {
                id: 'Combined Rider',
                body: 'This optional plan benefit is a combination of riders for one price.'
            },
            {
                id: 'Part A Deductible',
                body: `"Part A Deductible" covers the amount that you must pay for inpatient hospital stays before Medicare begins to pay.`
            },
            {
                id: 'Part B Deductible',
                body: `"Part B Deductible" covers the amount that you must pay for Medicare-approved
           Part B medical services before Medicare Part B begins to pay.`
            },
            {
                id: 'Part B Excess',
                body: `"Part B Excess Charges" covers the  difference between the Medicare eligible charge and the amount charged by
          the provider which shall be no greater than the actual charge or the limited charge allowed by Medicare, whichever is less.`
            },
            {
                id: 'Preventive Care',
                body: `"Preventive Care"  pays up to $120 a year for covered preventive screening
           test and services and an annual physical examination.`
            },
            {
                id: 'Usual and Customary Fees',
                body: `"Usual and Customary Charges Fees" covers the difference between the Medicare eligible charge and the amount charged by
           the provider which shall be no greater than the actual charge or the limited charge allowed by Medicare, whichever is less.`
            },
            {
                id: 'Part B Excess Charges',
                body: `Part B Excess Charges" covers the  difference between the Medicare eligible charge
        and the amount charged by the provider which shall be no greater than the actual charge or
        the limited charge allowed by Medicare, whichever is less.`
            },
            {
                id: 'Additional Home Health Care',
                body: ` "Additional Home Health" extends home care visits up to 365 visits per policy year.`
            },
            {
                id: 'Foreign Travel Emergency',
                body: ` "Foreign Travel Emergency" covers at least 80% of eligible expenses associated with emergency
          medical care received outside the U.S.A. beginning the first 60 days of a trip up to a
          lifetime maximum of $50,000 (after a  deductible of $250).`
            },
            {
                id: 'Co-Pay Rider',
                body: ` "Co-Pay Rider" pays the Part B coinsurance subject to a copayment or coinsurance of no more
          than $20 per office visit and no more than $50 per emergency room visit that is in
          addition to the Medicare Part B medical deductible  and in addition to out-pocket maximums.`
            },
            {
                id: '50% Part A Deductible',
                body: `"50% of Part A Deductible" pays 50% of the inpatient deductible for qualifying hospital stays.`
            },
            {
                id: 'Part B Copayment or Coinsurance',
                body: `"Part B Copayment or Coinsurance" covers the amount you must pay as your share of the cost for medical services.
          Copayment is usually a set amount whereas coinsurance is a percentage.`
            }
        ];
        this.Spa_Plandetails_Costs_MAPD = [
            {
                title: PlanDetailsCostLabels.DRUG_COST,
                subText: 'Based on <totalDrugs> drugs',
                label: 'Annually Est Drug Cost',
                label2: 'Est Drug Cost',
                duration: 'annually',
                duration2: 'partial annually'
            },
            {
                title: PlanDetailsCostLabels.HEALTH_COST,
                subText: 'Estimated medical costs based on age <ageRange> and <healthStatus>.',
                label: 'Annually Health Cost',
                label2: 'Health Cost',
                duration: 'annually',
                duration2: 'partial annually'
            },
            {
                title: PlanDetailsCostLabels.TOTAL_ESTIMATED_COST,
                subText: 'Based on medical and drug costs.',
                label: 'Total est annual cost',
                label2: 'Total est cost',
                duration: 'annually',
                duration2: 'partial annually'
            }
        ];
        this.Spa_Plandetails_Costs_MA = [
            {
                title: PlanDetailsCostLabels.HEALTH_COST,
                subText: 'Estimated medical costs based on age <ageRange> and <healthStatus>.',
                label: 'Annually Health Cost',
                label2: 'Health Cost',
                duration: 'annually',
                duration2: 'partial annually'
            },
            {
                title: PlanDetailsCostLabels.TOTAL_ESTIMATED_COST,
                subText: 'Based on medical and drug costs.',
                label: 'Total est annual cost',
                label2: 'Total est cost',
                duration: 'annually',
                duration2: 'partial annually'
            }
        ];
        this.Spa_Plandetails_Costs_MEDIGAP = [
            {
                title: PlanDetailsCostLabels.HEALTH_COST,
                subText: 'Estimated medical costs based on age <ageRange> and <healthStatus>.',
                label: 'Health Cost',
                duration: 'annually'
            },
            {
                title: PlanDetailsCostLabels.TOTAL_ESTIMATED_COST,
                subText: 'Based on medical costs.',
                label: 'Total est annual cost',
                duration: 'annually'
            }
        ];
        this.Spa_Plandetails_Costs_PDP = [
            {
                title: PlanDetailsCostLabels.DRUG_COST,
                subText: 'Based on <totalDrugs> drugs',
                label: 'Annually Est Drug Cost',
                label2: 'Est Drug Cost',
                duration: 'annually',
                duration2: 'partial annually'
            },
            {
                title: PlanDetailsCostLabels.TOTAL_ESTIMATED_COST,
                subText: 'Based on medical and drug costs.',
                label: 'Total est annual cost',
                label2: 'Total est cost',
                duration: 'annually',
                duration2: 'partial annually'
            }
        ];
        this.Spa_PlanDetails_Costs_DENTAL = [
            {
                title: PlanDetailsCostLabels.PLAN_FEES,
                label: 'Fees',
                subText: '',
                duration: ''
            }
        ];
        this.Spa_PlanDetails_Costs_VISION = [
            {
                title: PlanDetailsCostLabels.PLAN_FEES,
                label: 'Fees',
                subText: '',
                duration: ''
            }
        ];
        this.filteredPlans = [];
        this.planTiles = [];
        this.tabs = [];
        this.otherPreferences = [];
        this.initFinished = false;
        this.welcomeBannerBackgroundFullImagePath = '';
        this.welcomeBannerBackgroundFullImageMobilePath = '';
        this.subscriptions = new Subscription();
    }
    async ngOnInit() {
        super.ngOnInit();
        this.editLinkText = this.getEditLinkText();
        await this.planFacade.addEffectiveDateInMemberSession();
        this.selectedCounty$ = this.retentionFacade.getCounty$();
        this.medicineCabinet$ = this.guidedHelpService.getMedicineCabinet$();
        this.primaryPharmacy$ = this.guidedHelpService.getPrimaryPharmacy$();
        this.selectedPharmacies$ = this.guidedHelpService.getSelectedPharmacies$();
        this.locale$ = this.localeService.getCurrentLocale$();
        this.subsidyPercentage = this.planFacade.getSubsidyPercentage();
        this.isMobile$ = this.responsiveLayoutService.isCompact$;
        if (this.plansService.getArePlanTypesDirty(ALL_MEDICARE_PLUS_MEDIGAP_PLAN_TYPE_VALUES)) {
            this.retentionFacade.fetchPlans();
        }
        this.retentionFacade.checkActiveTabTypeExist();
        this.retentionFacade.setCompareGroup();
        this.retentionFacade.setSortGroup();
        this.riderDisplayMap = {
            [PlanTypeAbbreviation.MA]: this.Spa_PlanCard_ShowRidersOnMACards,
            [PlanTypeAbbreviation.MAPD]: this.Spa_PlanCard_ShowRidersOnMAPDCards,
            [PlanTypeAbbreviation.PDP]: this.Spa_PlanCard_ShowRidersOnPDPCards,
            [PlanTypeAbbreviation.MEDIGAP]: this.Spa_PlanCard_ShowRidersOnMEDIGAPCards
        };
        if (this.Spa_Site_RetentionWelcome_Background_Url_Enabled) {
            this.welcomeBannerBackgroundFullImagePath = this.imageService.resolveFullImagePath(this.Spa_Site_RetentionWelcome_Background_Url);
            this.welcomeBannerBackgroundFullImageMobilePath = this.imageService.resolveFullImagePath(this.Spa_Site_RetentionWelcome_Background_MobileUrl);
        }
        this.subscriptions.add(this.plansService.getPlanCounts$().subscribe({
            next: planCounts => {
                this.planCounts = planCounts;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.siteService.isRetentionView$().subscribe({
            next: isRetentionView => {
                this.isRetentionView = isRetentionView;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.memberSessionService.getMemberSession$().subscribe({
            next: memberData => {
                this.memberData = memberData;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.guidedHelpService.getSelectedPharmacy$().subscribe({
            next: selectedPharmacy => {
                this.selectedPharmacy = selectedPharmacy;
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.loading$.subscribe({
            next: loading => {
                loading
                    ? this.configurableWidgetService.spinnerService.show(SpinnerEvent.PLANS_LOADING)
                    : this.configurableWidgetService.spinnerService.hide(SpinnerEvent.PLANS_LOADING);
            }
        }));
        this.subscriptions.add(this.locale$.subscribe({
            next: locale => {
                if (locale) {
                    if (this.initFinished) {
                        this.retentionFacade.fetchPlans();
                    }
                    this.editLinkText = this.getEditLinkText();
                    this.cdr.markForCheck();
                }
            }
        }));
        this.subscriptions.add(this.retentionFacade.getProviders$().subscribe({
            next: providers => {
                this.providers = providers;
                this.cdr.markForCheck();
            }
        }));
        this.filteredPlans$ = this.locale$.pipe(switchMap(() => this.retentionFacade.getPlans$()), distinctUntilChanged(_isEqual));
        this.providerDetails$ = this.filteredPlans$.pipe(mergeMap(plans => {
            if (plans && plans.length && this.Spa_Site_Providers_Enabled) {
                return this.retentionFacade.fetchProvidersDetails$(plans, this.Spa_Site_Provider_ShowAllInNetworkLocations_Enabled);
            }
            return EMPTY;
        }));
        const isAnalyticsDataReady$ = combineLatest([
            this.loading$,
            this.plansService.getAreShortPlansLoading$(),
            this.memberSessionService.isMemberLoading$(),
            this.memberSessionService.isSelectedMemberDetailsUpdating$()
        ]).pipe(map(([arePlansLoading, areShortPlansLoading, isMemberLoading, isSelectedMemberDetailsUpdating]) => !arePlansLoading && !areShortPlansLoading && !isSelectedMemberDetailsUpdating && !isMemberLoading), distinctUntilChanged());
        this.subscriptions.add(combineLatest([this.filteredPlans$, isAnalyticsDataReady$])
            .pipe(withLatestFrom(this.memberSessionService.getMemberSession$()), distinctUntilChanged(_isEqual))
            .subscribe({
            next: ([[filteredPlans, isAnalyticsDataReady], memberData]) => {
                const currentYearPlan = filteredPlans.find(plan => plan.isCurrentYearPlan);
                if (currentYearPlan) {
                    this.currentYearPlanId = currentYearPlan.id;
                }
                const nextYearPlan = filteredPlans.find(plan => plan.isNextYearPlan);
                if (nextYearPlan) {
                    this.nextYearPlanId = nextYearPlan.id;
                }
                this.option2PlanId = this.retentionFacade.getOption2PlanFromPlansList(filteredPlans)?.id;
                // validate analytics if member exists for retention site
                if (memberData && isAnalyticsDataReady && this.siteService.isRetentionView()) {
                    this.tagsToUpdate(memberData);
                }
                this.filteredPlans = filteredPlans;
                this.cdr.markForCheck();
            }
        }));
        this.initFinished = true;
        this.cdr.markForCheck();
    }
    preProcessProperties() {
        // Have to mark everything as whitelisted since we are currently recalculating
        // these variables on any change.
        // TODO: possibly refactor this to limit the whitelist scope
        if (this.Spa_Site_Retention_CoverageTypesSection_Enabled) {
            this.planTiles = this.retentionFacade.getTabDetails();
        }
        this.selectedHealthStatus = this.planFacade.healthStatusLabel;
        this.subsidySelected = this.planFacade.getSubsidySelected();
    }
    editZipCode() {
        const options = {
            ariaLabelledBy: 'modalHeaderTitle',
            centered: true,
            injector: this.injector
        };
        const zipCodeModalComponent = this.modalService.open(ZipCodeModalComponent, options);
        zipCodeModalComponent.componentInstance.redirectToSummary = true;
        zipCodeModalComponent.componentInstance.isProfileZip = false;
        zipCodeModalComponent.result
            .then(() => {
            this.selectedCounty$ = this.retentionFacade.getCounty$();
            this.retentionFacade.fetchPlans();
        })
            .catch(() => {
            // eat the error to prevent a console error
        });
        this.cdr.markForCheck();
    }
    tagsToUpdate(memberData) {
        const selectedPharmacies = this.pharmacyFacade.getSelectedNABPPharmacies();
        const appId = this.configResourceService.getProcessedResourceValue('AppID', null, 0).toString();
        const providers = this.guidedHelpService.getSelectedProviders();
        let agentIsProfileAdmin = null;
        const agentGuid = this.store.selectSnapshot(AgentState.agentGuid);
        if (memberData.agentGuid === agentGuid) {
            agentIsProfileAdmin = this.store.selectSnapshot(AgentState.agentIsProfileAdmin);
        }
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerGlobalVariable.VIEW_PAGE,
            [DataLayerGlobalVariable.MEMBER_ID]: memberData.memberID,
            [DataLayerGlobalVariable.AGENT_GUID]: memberData.agentGuid,
            [DataLayerGlobalVariable.AGENT_IS_PROFILE_ADMIN]: agentIsProfileAdmin,
            [DataLayerGlobalVariable.ZIP]: memberData.demographic.zip,
            [DataLayerGlobalVariable.COUNTY_FIPS]: memberData.demographic.fips,
            [DataLayerGlobalVariable.SITE_HAS_GUIDED_HELP_INFO]: this.guidedHelpService.getHasVisited() ? 'yes' : 'no',
            [DataLayerGlobalVariable.SELECTED_PHARMACY]: selectedPharmacies,
            [DataLayerGlobalVariable.PLAN_ID_CURRENT]: this.currentYearPlanId || this.Spa_Site_NotApplicable_Text,
            [DataLayerGlobalVariable.PLAN_ID_NEXT_YEAR]: this.nextYearPlanId || this.Spa_Site_NotApplicable_Text,
            [DataLayerGlobalVariable.PLAN_ID_NEXT_YEAR2]: this.option2PlanId || this.Spa_Site_NotApplicable_Text,
            [DataLayerGlobalVariable.APP_SESSION_ID]: memberData.sessionId ? memberData.sessionId : null,
            [DataLayerGlobalVariable.USER_NAME]: memberData.userName ? memberData.userName : null,
            [DataLayerGlobalVariable.APP_ID]: appId,
            [DataLayerGlobalVariable.CLIENT_ID]: this.memberSessionService.getClientId(),
            [DataLayerGlobalVariable.PROVIDER_COUNT]: providers && providers.length ? providers.length.toString() : '0',
            [DataLayerGlobalVariable.PAGE_PATH]: this.router.url
        };
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
    getEditLinkText() {
        return this.configResourceService.getProcessedResourceValue('Spa_GuidedHelp_PlanCard_EditLink_Text', null, 'Edit preferences');
    }
};
RetentionSummaryComponent.ɵfac = function RetentionSummaryComponent_Factory(t) { return new (t || RetentionSummaryComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(RetentionFacade), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(i1.ImageService), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(PlanListFacadeService), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(PharmacyFacade), i0.ɵɵdirectiveInject(i1.GoogleTagManagerService), i0.ɵɵdirectiveInject(i2$1.Router)); };
RetentionSummaryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RetentionSummaryComponent, selectors: [["vnext-widget-retention-summary"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 9, vars: 58, consts: [[3, "greetingText", "memberData", "fullImagePath", "fullImageMobilePath", "backgroundUrlEnabled"], [3, "personalDetailsHeaderText", "userNameLabel", "userZipcodeLabel", "userEmailLabel", "memberData", "userZipcodeEditLabel", "selectedCounty", "userZipcodeEditDescripion", "countyLabel", "showCountyLabel", "editZipCodeClicked"], [3, "addPreferencesText", "healthText", "qualifiedHelpText", "prescriptionsText", "pharmacyText", "guidedHelpHideLinkText", "guidedHelpViewAllLinkText", "guidedHelpEnabled", "getStartedEnabled", "healthEnabled", "showSubsidyAccordion", "prescriptionsEnabled", "pharmacyEnabled", "selectedPharmacy", "medicineCabinet", "preferencesEditText", "addLinkText", "selectedHealthStatus", "subsidySelected", "subsidyPercentage", "isRetention", "preferencesEditDescription", "selectedPharmacies", "multiPharmacyEnabled", "primaryPharmacy", "primaryPharmacyIndicatorText", "providersEnabled", "providers", "providersText", "pcpText", "otherPreferencesEnabled", "otherPreferencesText", "guidedHelpOtherPreferencesMessageText"], [4, "ngIf"], [3, "planTiles", "shopsAllCoverageText", "planCounts", "pickPlanLabel", "filteredPlans", "notAvailableText", "planTabEducationalTextShow", 4, "ngIf"], [3, "plans", "pickPlanText", "planCardQuoteLinkText", "planDetailsButtonText", "planBenefitNoValueLabel", "planTypeText", "addOnCoverageText", "addOnCoverageTooltip", "planDetailsNonCoveredText", "prescriptionText", "pharmacyText", "isTotalEstimatedCostEnabled", "isRetention", "totalEstimatedAnnualCostText", "totalEstimatedCostText", "totalEstimatedCostTooltip", "showPlanLogo", "showRidersOnPlanCards", "showPremiumAsAnnual", "riderDisplayMap", "shoppingCartEnabled", "drugCoveredText", "pharmacyCoveredText", "displayDrugsCovered", "benefits", "benefitPreferences", "currentPlanText", "isMobile", "nextYearPlanText", "noCostAvailableText", "Spa_Site_ShowRiderIcons", "Spa_Site_Dental_Rider_Display_Text", "Spa_Site_Vision_Rider_Display_Text", "Spa_Site_Hearing_Rider_Display_Text", "Spa_PlanCard_DentalAddOnCoverage_Text", "Spa_PlanCard_HearingAddOnCoverage_Text", "Spa_PlanCard_VisionAddOnCoverage_Text", "Spa_PlanCard_AddOnCoverage_Text", "Spa_Site_MedigapPlanType_Enabled", "Spa_Site_AddToCompare_Enabled", "Spa_Site_PlanViewDetails_Enabled", "Spa_Site_Tooltip_Text", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "isMailOrderSelected", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "mailOrderText", "providersInNetworkText", "pcpInNetworkText", "pcpOutOfNetworkText", "providersNoDataText", "isProviderEnabled", "selectedProviders", "providerDetails", "selectedPharmacy", "viewDetailsDescriptionText", "clientDefinedOptionsEnabled", "optionOneText", "optionTwoText", "planLogoSize", "showAddToCartForAncillaryPlans", "editLinkText", "planCardPreferenceDetailedEnabled", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "showPlanId", "showPlanYear", "planIdText", "availableText", "unavailableText", "viewProvidersButtonText", "viewPrescriptionsButtonText", "supplementalBenefitsHighlightText", "preferencesText", "viewMoreDetailsText", "hideDetailsText", "newPlanCardDesignEnabled", "viewAllPlanDetailsText", "shareThisPlanText", "viewCostDetailsText", "closeText", "planBenefitHighlightItems", "planBenefitHighlightsHeaderText", "showRiderDetails", "showRiderDetailsText", "hideRiderDetailsText", "riderIsIncludedText", "waiverStateRiderTooltips", "costMA", "costMAPD", "costPDP", "costMEDIGAP", "costDENTAL", "costVISION", "quoteClicked", "viewPlanDetails", 4, "ngIf"], ["class", "container", 4, "ngIf"], [3, "filteredPlans", "shopAllPlansButtonText", "compareThesePlansButtonText", "comparePlansSelected", "shopForPlansSelected"], [3, "plans", "pickPlanText", "planCardQuoteLinkText", "planDetailsButtonText", "planBenefitNoValueLabel", "planTypeText", "addOnCoverageText", "addOnCoverageTooltip", "planDetailsNonCoveredText", "prescriptionText", "pharmacyText", "isTotalEstimatedCostEnabled", "isRetention", "totalEstimatedAnnualCostText", "totalEstimatedCostText", "totalEstimatedCostTooltip", "showPlanLogo", "showRidersOnPlanCards", "showPremiumAsAnnual", "riderDisplayMap", "shoppingCartEnabled", "drugCoveredText", "pharmacyCoveredText", "displayDrugsCovered", "benefits", "benefitPreferences", "currentPlanText", "isMobile", "nextYearPlanText", "noCostAvailableText", "Spa_Site_ShowRiderIcons", "Spa_Site_Dental_Rider_Display_Text", "Spa_Site_Vision_Rider_Display_Text", "Spa_Site_Hearing_Rider_Display_Text", "Spa_PlanCard_DentalAddOnCoverage_Text", "Spa_PlanCard_HearingAddOnCoverage_Text", "Spa_PlanCard_VisionAddOnCoverage_Text", "Spa_PlanCard_AddOnCoverage_Text", "Spa_Site_MedigapPlanType_Enabled", "Spa_Site_AddToCompare_Enabled", "Spa_Site_PlanViewDetails_Enabled", "Spa_Site_Tooltip_Text", "inNetworkPreferredText", "inNetworkStandardText", "outOfNetworkText", "isMailOrderSelected", "viewCostTooltipHeaderText", "viewCostTooltipHeaderContent", "mailOrderText", "providersInNetworkText", "pcpInNetworkText", "pcpOutOfNetworkText", "providersNoDataText", "isProviderEnabled", "selectedProviders", "providerDetails", "selectedPharmacy", "viewDetailsDescriptionText", "clientDefinedOptionsEnabled", "optionOneText", "optionTwoText", "planLogoSize", "showAddToCartForAncillaryPlans", "editLinkText", "planCardPreferenceDetailedEnabled", "providerOneOrMoreOutOfNetworkText", "providerInNetworkOnOtherLocationsTooltipText", "providerShowPartialIndicatorEnabled", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "showPlanId", "showPlanYear", "planIdText", "availableText", "unavailableText", "viewProvidersButtonText", "viewPrescriptionsButtonText", "supplementalBenefitsHighlightText", "preferencesText", "viewMoreDetailsText", "hideDetailsText", "newPlanCardDesignEnabled", "viewAllPlanDetailsText", "shareThisPlanText", "viewCostDetailsText", "closeText", "planBenefitHighlightItems", "planBenefitHighlightsHeaderText", "showRiderDetails", "showRiderDetailsText", "hideRiderDetailsText", "riderIsIncludedText", "waiverStateRiderTooltips", "costMA", "costMAPD", "costPDP", "costMEDIGAP", "costDENTAL", "costVISION", "quoteClicked", "viewPlanDetails"], [1, "container"], ["class", "Spa_Style_Note", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["navigationAdapter", "", 1, "Spa_Style_Note", 3, "innerHtml"], [3, "planTiles", "shopsAllCoverageText", "planCounts", "pickPlanLabel", "filteredPlans", "notAvailableText", "planTabEducationalTextShow"]], template: function RetentionSummaryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "vnext-widget-retention-welcome", 0);
        i0.ɵɵelementStart(1, "vnext-widget-retention-user-info", 1);
        i0.ɵɵlistener("editZipCodeClicked", function RetentionSummaryComponent_Template_vnext_widget_retention_user_info_editZipCodeClicked_1_listener() { return ctx.editZipCode(); });
        i0.ɵɵpipe(2, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(3, "vnext-summary-preferences", 2);
        i0.ɵɵpipe(4, "async");
        i0.ɵɵpipe(5, "async");
        i0.ɵɵpipe(6, "async");
        i0.ɵɵtemplate(7, RetentionSummaryComponent_ng_container_7_Template, 4, 5, "ng-container", 3);
        i0.ɵɵtemplate(8, RetentionSummaryComponent_vnext_summary_coverage_types_8_Template, 1, 7, "vnext-summary-coverage-types", 4);
    } if (rf & 2) {
        i0.ɵɵproperty("greetingText", ctx.Spa_Site_RetentionWelcome_Greeting_Text)("memberData", ctx.memberData)("fullImagePath", ctx.welcomeBannerBackgroundFullImagePath)("fullImageMobilePath", ctx.welcomeBannerBackgroundFullImageMobilePath)("backgroundUrlEnabled", ctx.Spa_Site_RetentionWelcome_Background_Url_Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("personalDetailsHeaderText", ctx.Spa_RetentionUserInfo_PersonalDetailsHeader_Text)("userNameLabel", ctx.Spa_Site_RetentionUserInfo_Name_Label)("userZipcodeLabel", ctx.Spa_Site_RetentionUserInfo_ZipCode_Label)("userEmailLabel", ctx.Spa_Site_RetentionUserInfo_Email_Label)("memberData", ctx.memberData)("userZipcodeEditLabel", ctx.Spa_Site_RetentionUserInfo_Zipcode_Edit_Label)("selectedCounty", i0.ɵɵpipeBind1(2, 50, ctx.selectedCounty$))("userZipcodeEditDescripion", ctx.Spa_Site_UserInfo_Zipcode_Edit_Description)("countyLabel", ctx.Spa_ZipCodeInput_CountyLabel_Text)("showCountyLabel", ctx.Spa_ZipCodeInput_CountyLabel_Enabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("addPreferencesText", ctx.Spa_Summary_AddPreferences_Text)("healthText", ctx.Spa_Site_Health_Text)("qualifiedHelpText", ctx.Spa_Site_QualifiedHelp_Text)("prescriptionsText", ctx.Spa_Site_Prescriptions_Text)("pharmacyText", ctx.Spa_Site_Pharmacy_Text)("guidedHelpHideLinkText", ctx.Spa_Site_Hide_Text)("guidedHelpViewAllLinkText", ctx.Spa_Site_ViewAll_Text)("guidedHelpEnabled", ctx.Spa_GuidedHelp_Enabled)("getStartedEnabled", ctx.Spa_Site_GetStarted_Enabled)("healthEnabled", ctx.Spa_Site_Health_Enabled)("showSubsidyAccordion", ctx.Spa_GettingStarted_ShowSubsidyAccordion_Flag)("prescriptionsEnabled", ctx.Spa_Site_Prescriptions_Enabled)("pharmacyEnabled", ctx.Spa_Site_Pharmacy_Enabled)("selectedPharmacy", ctx.selectedPharmacy)("medicineCabinet", i0.ɵɵpipeBind1(4, 52, ctx.medicineCabinet$))("preferencesEditText", ctx.Spa_Site_Preferences_Edit_Text)("addLinkText", ctx.Spa_GuidedHelp_PlanList_AddLink_Text)("selectedHealthStatus", ctx.selectedHealthStatus)("subsidySelected", ctx.subsidySelected)("subsidyPercentage", ctx.subsidyPercentage)("isRetention", ctx.isRetentionView)("preferencesEditDescription", ctx.Spa_Site_Preferences_Edit_Description)("selectedPharmacies", i0.ɵɵpipeBind1(5, 54, ctx.selectedPharmacies$))("multiPharmacyEnabled", ctx.Spa_Site_Multi_Pharmacy_Enabled)("primaryPharmacy", i0.ɵɵpipeBind1(6, 56, ctx.primaryPharmacy$))("primaryPharmacyIndicatorText", ctx.Spa_Site_PrimaryPharmacy_Indicator_Text)("providersEnabled", ctx.Spa_Site_Providers_Enabled)("providers", ctx.providers)("providersText", ctx.Spa_Site_Providers_Text)("pcpText", ctx.Spa_Site_Pcp_Text)("otherPreferencesEnabled", ctx.Spa_Site_OtherPreferences_Enabled)("otherPreferencesText", ctx.Spa_Site_OtherPreferences_Text)("guidedHelpOtherPreferencesMessageText", ctx.Spa_GuidedHelp_ReviewOtherPreferences_Text);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.filteredPlans);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Site_Retention_CoverageTypesSection_Enabled);
    } }, dependencies: [i1$2.NgIf, NavigationAdapterDirective, LiveEditPropDirective, SummaryCoverageTypesComponent, RetentionUserInfoComponent, RetentionWelcomeComponent, SummaryPreferencesComponent, RetentionPlanCardComponent, SummaryButtonsComponent, i1$2.AsyncPipe, SafePipe], encapsulation: 2, changeDetection: 0 });
__decorate([
    Select(PlansState.planTypesLoading(ALL_MEDICARE_PLUS_MEDIGAP_PLAN_TYPE_VALUES))
], RetentionSummaryComponent.prototype, "loading$", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_RetentionWelcome_Background_Url", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_RetentionWelcome_Background_MobileUrl", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_RetentionUserInfo_Name_Label", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_RetentionUserInfo_ZipCode_Label", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_RetentionUserInfo_Email_Label", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanCard_QuoteLinkName_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanCard_PlanDetails_ButtonText", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_NotApplicable_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanCard_PlanType_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanCard_AddOnCoverageInCart_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanCard_AddOnCoverageTooltip_Body", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Show_PlanLogo", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanDetails_Non_Covered_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Prescriptions_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Pharmacy_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_TotalEstimatedCost_Enabled", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanCard_TotalEstimatedAnnualCost_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanCard_TotalEstimatedCost_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanCard_Total_Estimated_Cost_Tooltip", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_ShowPremiumAsAnnual", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_ShowRiderIcons", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_ShowRidersOnPlanCards", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Dental_Rider_Display_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Vision_Rider_Display_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Hearing_Rider_Display_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanCard_DentalAddOnCoverage_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanCard_HearingAddOnCoverage_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanCard_VisionAddOnCoverage_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanCard_AddOnCoverage_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanCard_ShowRidersOnMACards", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanCard_ShowRidersOnPDPCards", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanCard_ShowRidersOnMAPDCards", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanCard_ShowRidersOnMEDIGAPCards", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_ShoppingCart_Enabled", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanCard_Drug_Covered_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanCard_Pharmacy_Covered_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Health_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_QualifiedHelp_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_GettingStarted_ShowSubsidyAccordion_Flag", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Hide_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_ViewAll_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_GuidedHelp_Enabled", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Health_Enabled", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Prescriptions_Enabled", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Pharmacy_Enabled", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_GetStarted_Enabled", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Preferences_Edit_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_GuidedHelp_PlanList_AddLink_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Current_Plan_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Next_Year_Plan_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_PlanNotAvailableForNextYear_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Keep_This_Plan_Button_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_RetentionUserInfo_Zipcode_Edit_Label", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_UserInfo_Zipcode_Edit_Description", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Shop_All_Plans_Button_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Retention_CompareThesePlans_Button_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Retention_NotAvailable_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Preferences_Edit_Description", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_MedigapPlanType_Enabled", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_AddToCompare_Enabled", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_PlanViewDetails_Enabled", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Providers_Enabled", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Providers_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Pcp_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanCard_Providers_InNetwork_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Pcp_InNetwork_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Pcp_OutOfNetwork_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Providers_No_Data_Exist_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_ZipCodeInput_CountyLabel_Enabled", void 0);
__decorate([
    PlatformProp(null, true)
], RetentionSummaryComponent.prototype, "Spa_PlanList_DisplayDrugsCovered", void 0);
__decorate([
    PlatformProp('live-edit', true)
], RetentionSummaryComponent.prototype, "Spa_RetentionUserInfo_PersonalDetailsHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], RetentionSummaryComponent.prototype, "Spa_Retention_PickPlan_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], RetentionSummaryComponent.prototype, "Spa_Site_ShopAllCoverage_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], RetentionSummaryComponent.prototype, "Spa_Summary_AddPreferences_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], RetentionSummaryComponent.prototype, "Spa_Site_RetentionWelcome_Greeting_Text", void 0);
__decorate([
    PlatformProp('live-edit', true)
], RetentionSummaryComponent.prototype, "Spa_Site_Provider_Disclaimer", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Plan_Tab_Educational_Text_Show", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Tooltip_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Multi_Pharmacy_Enabled", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_PrimaryPharmacy_Indicator_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanList_Pharmacy_InNetwork_Preferred_Pricing_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanList_Pharmacy_InNetwork_Standard_Pricing_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanList_Pharmacy_OutOfNetwork_Pricing_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanList_ViewCost_Header_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanList_ViewCost_Header_Content", void 0);
__decorate([
    PlatformProp(null, true)
], RetentionSummaryComponent.prototype, "Spa_PlanList_MailOrder_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_OtherPreferences_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_OtherPreferences_Enabled", void 0);
__decorate([
    PlatformProp('live-edit', true)
], RetentionSummaryComponent.prototype, "Spa_GuidedHelp_ReviewOtherPreferences_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_ViewDetailsLink_Description_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Retention_ClientDefinedPlanOptions_Enabled", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Plan_Option_One_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Plan_Option_Two_Text", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_PlanLogo_Size", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_PlanCard_AncillaryAddtoCart_Enabled", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Provider_ShowAllInNetworkLocations_Enabled", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_RetentionWelcome_Background_Url_Enabled", void 0);
__decorate([
    GlobalResource(true)
], RetentionSummaryComponent.prototype, "Spa_Site_Retention_CoverageTypesSection_Enabled", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanCard_Preferences_Detailed_Enabled", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanCard_Providers_OneOrMore_OutOfNetwork_Text", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_Providers_InNetwork_OnOtherLocations_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_Provider_ShowPartialIndicator_Enabled", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_Site_PlanFees_Enabled", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanFees_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanFees_IncludedInPremium_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanCard_Show_PlanId_Enabled", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanCard_PlanYearBadge_Enabled", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanCard_PlanId_Text", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_Site_Available_Text", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_Site_NotAvailable_Text", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanCard_Providers_ViewButton_Text", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanCard_Prescriptions_ViewButton_Text", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanCard_SupplementalBenefitsHighlight_Text", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_Plan_Details_Preferences_Text", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanCard_ViewMoreDetails_ButtonText", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanCard_HideDetails_ButtonText", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanCard_NewDesign_Enabled", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanCard_ViewAllPlanDetails_ButtonText", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanCard_ShareThisPlan_ButtonText", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanCard_ViewCostDetails_ButtonText", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_Site_Close", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanCard_PlanBenefitHighlight_Items", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanCard_PlanBenefitHighlights_Text", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_Site_RiderDetails_Show", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_Plan_Details_ViewRiderDetails_Text", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_Plan_Details_HideRiderDetails_Text", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_ShoppingCart_IncludedRider_Text", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_Plan_Details_WaiverStateRider_Tooltips", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_Plandetails_Costs_MAPD", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_Plandetails_Costs_MA", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_Plandetails_Costs_MEDIGAP", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_Plandetails_Costs_PDP", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanDetails_Costs_DENTAL", void 0);
__decorate([
    GlobalResource()
], RetentionSummaryComponent.prototype, "Spa_PlanDetails_Costs_VISION", void 0);
RetentionSummaryComponent = __decorate([
    PlatformWidget
], RetentionSummaryComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RetentionSummaryComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-retention-summary', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<vnext-widget-retention-welcome\r\n  [greetingText]=\"Spa_Site_RetentionWelcome_Greeting_Text\"\r\n  [memberData]=\"memberData\"\r\n  [fullImagePath]=\"welcomeBannerBackgroundFullImagePath\"\r\n  [fullImageMobilePath]=\"welcomeBannerBackgroundFullImageMobilePath\"\r\n  [backgroundUrlEnabled]=\"Spa_Site_RetentionWelcome_Background_Url_Enabled\"\r\n></vnext-widget-retention-welcome>\r\n\r\n<vnext-widget-retention-user-info\r\n  [personalDetailsHeaderText]=\"Spa_RetentionUserInfo_PersonalDetailsHeader_Text\"\r\n  [userNameLabel]=\"Spa_Site_RetentionUserInfo_Name_Label\"\r\n  [userZipcodeLabel]=\"Spa_Site_RetentionUserInfo_ZipCode_Label\"\r\n  [userEmailLabel]=\"Spa_Site_RetentionUserInfo_Email_Label\"\r\n  [memberData]=\"memberData\"\r\n  [userZipcodeEditLabel]=\"Spa_Site_RetentionUserInfo_Zipcode_Edit_Label\"\r\n  [selectedCounty]=\"selectedCounty$ | async\"\r\n  (editZipCodeClicked)=\"editZipCode()\"\r\n  [userZipcodeEditDescripion]=\"Spa_Site_UserInfo_Zipcode_Edit_Description\"\r\n  [countyLabel]=\"Spa_ZipCodeInput_CountyLabel_Text\"\r\n  [showCountyLabel]=\"Spa_ZipCodeInput_CountyLabel_Enabled\"\r\n>\r\n</vnext-widget-retention-user-info>\r\n<vnext-summary-preferences\r\n  [addPreferencesText]=\"Spa_Summary_AddPreferences_Text\"\r\n  [healthText]=\"Spa_Site_Health_Text\"\r\n  [qualifiedHelpText]=\"Spa_Site_QualifiedHelp_Text\"\r\n  [prescriptionsText]=\"Spa_Site_Prescriptions_Text\"\r\n  [pharmacyText]=\"Spa_Site_Pharmacy_Text\"\r\n  [guidedHelpHideLinkText]=\"Spa_Site_Hide_Text\"\r\n  [guidedHelpViewAllLinkText]=\"Spa_Site_ViewAll_Text\"\r\n  [guidedHelpEnabled]=\"Spa_GuidedHelp_Enabled\"\r\n  [getStartedEnabled]=\"Spa_Site_GetStarted_Enabled\"\r\n  [healthEnabled]=\"Spa_Site_Health_Enabled\"\r\n  [showSubsidyAccordion]=\"Spa_GettingStarted_ShowSubsidyAccordion_Flag\"\r\n  [prescriptionsEnabled]=\"Spa_Site_Prescriptions_Enabled\"\r\n  [pharmacyEnabled]=\"Spa_Site_Pharmacy_Enabled\"\r\n  [selectedPharmacy]=\"selectedPharmacy\"\r\n  [medicineCabinet]=\"medicineCabinet$ | async\"\r\n  [preferencesEditText]=\"Spa_Site_Preferences_Edit_Text\"\r\n  [addLinkText]=\"Spa_GuidedHelp_PlanList_AddLink_Text\"\r\n  [selectedHealthStatus]=\"selectedHealthStatus\"\r\n  [subsidySelected]=\"subsidySelected\"\r\n  [subsidyPercentage]=\"subsidyPercentage\"\r\n  [isRetention]=\"isRetentionView\"\r\n  [preferencesEditDescription]=\"Spa_Site_Preferences_Edit_Description\"\r\n  [selectedPharmacies]=\"selectedPharmacies$ | async\"\r\n  [multiPharmacyEnabled]=\"Spa_Site_Multi_Pharmacy_Enabled\"\r\n  [primaryPharmacy]=\"primaryPharmacy$ | async\"\r\n  [primaryPharmacyIndicatorText]=\"Spa_Site_PrimaryPharmacy_Indicator_Text\"\r\n  [providersEnabled]=\"Spa_Site_Providers_Enabled\"\r\n  [providers]=\"providers\"\r\n  [providersText]=\"Spa_Site_Providers_Text\"\r\n  [pcpText]=\"Spa_Site_Pcp_Text\"\r\n  [otherPreferencesEnabled]=\"Spa_Site_OtherPreferences_Enabled\"\r\n  [otherPreferencesText]=\"Spa_Site_OtherPreferences_Text\"\r\n  [guidedHelpOtherPreferencesMessageText]=\"Spa_GuidedHelp_ReviewOtherPreferences_Text\"\r\n></vnext-summary-preferences>\r\n\r\n<ng-container *ngIf=\"filteredPlans as filteredPlans\">\r\n  <vnext-widget-retention-plan-card\r\n    *ngIf=\"filteredPlans?.length > 0\"\r\n    [plans]=\"filteredPlans\"\r\n    [pickPlanText]=\"Spa_Retention_PickPlan_Text\"\r\n    [planCardQuoteLinkText]=\"Spa_PlanCard_QuoteLinkName_Text\"\r\n    [planDetailsButtonText]=\"Spa_PlanCard_PlanDetails_ButtonText\"\r\n    [planBenefitNoValueLabel]=\"Spa_Site_NotApplicable_Text\"\r\n    [planTypeText]=\"Spa_PlanCard_PlanType_Text\"\r\n    [addOnCoverageText]=\"Spa_PlanCard_AddOnCoverageInCart_Text\"\r\n    [addOnCoverageTooltip]=\"Spa_PlanCard_AddOnCoverageTooltip_Body\"\r\n    [planDetailsNonCoveredText]=\"Spa_PlanDetails_Non_Covered_Text\"\r\n    [prescriptionText]=\"Spa_Site_Prescriptions_Text\"\r\n    [pharmacyText]=\"Spa_Site_Pharmacy_Text\"\r\n    [isTotalEstimatedCostEnabled]=\"Spa_Site_TotalEstimatedCost_Enabled\"\r\n    [isRetention]=\"isRetentionView\"\r\n    [totalEstimatedAnnualCostText]=\"Spa_PlanCard_TotalEstimatedAnnualCost_Text\"\r\n    [totalEstimatedCostText]=\"Spa_PlanCard_TotalEstimatedCost_Text\"\r\n    [totalEstimatedCostTooltip]=\"Spa_PlanCard_Total_Estimated_Cost_Tooltip\"\r\n    [showPlanLogo]=\"Spa_Site_Show_PlanLogo\"\r\n    [showRidersOnPlanCards]=\"Spa_Site_ShowRidersOnPlanCards\"\r\n    [showPremiumAsAnnual]=\"Spa_Site_ShowPremiumAsAnnual\"\r\n    [riderDisplayMap]=\"riderDisplayMap\"\r\n    [shoppingCartEnabled]=\"Spa_ShoppingCart_Enabled\"\r\n    [drugCoveredText]=\"Spa_PlanCard_Drug_Covered_Text\"\r\n    [pharmacyCoveredText]=\"Spa_PlanCard_Pharmacy_Covered_Text\"\r\n    [displayDrugsCovered]=\"Spa_PlanList_DisplayDrugsCovered\"\r\n    [benefits]=\"retentionFacade.getActiveTab()?.benefits\"\r\n    [benefitPreferences]=\"retentionFacade.getActiveTab()?.benefitPreferences\"\r\n    [currentPlanText]=\"Spa_Site_Current_Plan_Text\"\r\n    [isMobile]=\"isMobile$ | async\"\r\n    [nextYearPlanText]=\"Spa_Site_Next_Year_Plan_Text\"\r\n    (quoteClicked)=\"planFacade.updateMedSupFormOpen(true)\"\r\n    (viewPlanDetails)=\"retentionFacade.viewPlanDetailsPage($event)\"\r\n    [noCostAvailableText]=\"Spa_Site_NotApplicable_Text\"\r\n    [Spa_Site_ShowRiderIcons]=\"Spa_Site_ShowRiderIcons\"\r\n    [Spa_Site_Dental_Rider_Display_Text]=\"Spa_Site_Dental_Rider_Display_Text\"\r\n    [Spa_Site_Vision_Rider_Display_Text]=\"Spa_Site_Vision_Rider_Display_Text\"\r\n    [Spa_Site_Hearing_Rider_Display_Text]=\"Spa_Site_Hearing_Rider_Display_Text\"\r\n    [Spa_PlanCard_DentalAddOnCoverage_Text]=\"Spa_PlanCard_DentalAddOnCoverage_Text\"\r\n    [Spa_PlanCard_HearingAddOnCoverage_Text]=\"Spa_PlanCard_HearingAddOnCoverage_Text\"\r\n    [Spa_PlanCard_VisionAddOnCoverage_Text]=\"Spa_PlanCard_VisionAddOnCoverage_Text\"\r\n    [Spa_PlanCard_AddOnCoverage_Text]=\"Spa_PlanCard_AddOnCoverage_Text\"\r\n    [Spa_Site_MedigapPlanType_Enabled]=\"Spa_Site_MedigapPlanType_Enabled\"\r\n    [Spa_Site_AddToCompare_Enabled]=\"Spa_Site_AddToCompare_Enabled\"\r\n    [Spa_Site_PlanViewDetails_Enabled]=\"Spa_Site_PlanViewDetails_Enabled\"\r\n    [Spa_Site_Tooltip_Text]=\"Spa_Site_Tooltip_Text\"\r\n    [inNetworkPreferredText]=\"Spa_PlanList_Pharmacy_InNetwork_Preferred_Pricing_Text\"\r\n    [inNetworkStandardText]=\"Spa_PlanList_Pharmacy_InNetwork_Standard_Pricing_Text\"\r\n    [outOfNetworkText]=\"Spa_PlanList_Pharmacy_OutOfNetwork_Pricing_Text\"\r\n    [isMailOrderSelected]=\"pharmacyFacade.mailOrder$ | async\"\r\n    [viewCostTooltipHeaderText]=\"Spa_PlanList_ViewCost_Header_Text\"\r\n    [viewCostTooltipHeaderContent]=\"Spa_PlanList_ViewCost_Header_Content\"\r\n    [mailOrderText]=\"Spa_PlanList_MailOrder_Text\"\r\n    [providersInNetworkText]=\"Spa_PlanCard_Providers_InNetwork_Text\"\r\n    [pcpInNetworkText]=\"Spa_Site_Pcp_InNetwork_Text\"\r\n    [pcpOutOfNetworkText]=\"Spa_Site_Pcp_OutOfNetwork_Text\"\r\n    [providersNoDataText]=\"Spa_Providers_No_Data_Exist_Text\"\r\n    [isProviderEnabled]=\"Spa_Site_Providers_Enabled\"\r\n    [selectedProviders]=\"providers\"\r\n    [providerDetails]=\"providerDetails$ | async\"\r\n    [selectedPharmacy]=\"selectedPharmacy\"\r\n    [viewDetailsDescriptionText]=\"Spa_Site_ViewDetailsLink_Description_Text\"\r\n    [clientDefinedOptionsEnabled]=\"Spa_Retention_ClientDefinedPlanOptions_Enabled\"\r\n    [optionOneText]=\"Spa_Site_Plan_Option_One_Text\"\r\n    [optionTwoText]=\"Spa_Site_Plan_Option_Two_Text\"\r\n    [planLogoSize]=\"Spa_Site_PlanLogo_Size\"\r\n    [showAddToCartForAncillaryPlans]=\"Spa_PlanCard_AncillaryAddtoCart_Enabled\"\r\n    [editLinkText]=\"editLinkText\"\r\n    [planCardPreferenceDetailedEnabled]=\"Spa_PlanCard_Preferences_Detailed_Enabled\"\r\n    [providerOneOrMoreOutOfNetworkText]=\"Spa_PlanCard_Providers_OneOrMore_OutOfNetwork_Text\"\r\n    [providerInNetworkOnOtherLocationsTooltipText]=\"Spa_Providers_InNetwork_OnOtherLocations_Tooltip_Text\"\r\n    [providerShowPartialIndicatorEnabled]=\"Spa_Provider_ShowPartialIndicator_Enabled\"\r\n    [planFeesEnabled]=\"Spa_Site_PlanFees_Enabled\"\r\n    [planFeesTooltipText]=\"Spa_PlanFees_Tooltip_Text\"\r\n    [planFeesIncludedInPremiumTooltipText]=\"Spa_PlanFees_IncludedInPremium_Tooltip_Text\"\r\n    [planFeesNotIncludedInPremiumTooltipText]=\"Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text\"\r\n    [showPlanId]=\"Spa_PlanCard_Show_PlanId_Enabled\"\r\n    [showPlanYear]=\"Spa_PlanCard_PlanYearBadge_Enabled\"\r\n    [planIdText]=\"Spa_PlanCard_PlanId_Text\"\r\n    [availableText]=\"Spa_Site_Available_Text\"\r\n    [unavailableText]=\"Spa_Site_NotAvailable_Text\"\r\n    [viewProvidersButtonText]=\"Spa_PlanCard_Providers_ViewButton_Text\"\r\n    [viewPrescriptionsButtonText]=\"Spa_PlanCard_Prescriptions_ViewButton_Text\"\r\n    [supplementalBenefitsHighlightText]=\"Spa_PlanCard_SupplementalBenefitsHighlight_Text\"\r\n    [preferencesText]=\"Spa_Plan_Details_Preferences_Text\"\r\n    [viewMoreDetailsText]=\"Spa_PlanCard_ViewMoreDetails_ButtonText\"\r\n    [hideDetailsText]=\"Spa_PlanCard_HideDetails_ButtonText\"\r\n    [newPlanCardDesignEnabled]=\"Spa_PlanCard_NewDesign_Enabled\"\r\n    [viewAllPlanDetailsText]=\"Spa_PlanCard_ViewAllPlanDetails_ButtonText\"\r\n    [shareThisPlanText]=\"Spa_PlanCard_ShareThisPlan_ButtonText\"\r\n    [viewCostDetailsText]=\"Spa_PlanCard_ViewCostDetails_ButtonText\"\r\n    [closeText]=\"Spa_Site_Close\"\r\n    [planBenefitHighlightItems]=\"Spa_PlanCard_PlanBenefitHighlight_Items\"\r\n    [planBenefitHighlightsHeaderText]=\"Spa_PlanCard_PlanBenefitHighlights_Text\"\r\n    [showRiderDetails]=\"Spa_Site_RiderDetails_Show\"\r\n    [showRiderDetailsText]=\"Spa_Plan_Details_ViewRiderDetails_Text\"\r\n    [hideRiderDetailsText]=\"Spa_Plan_Details_HideRiderDetails_Text\"\r\n    [riderIsIncludedText]=\"Spa_ShoppingCart_IncludedRider_Text\"\r\n    [waiverStateRiderTooltips]=\"Spa_Plan_Details_WaiverStateRider_Tooltips\"\r\n    [costMA]=\"Spa_Plandetails_Costs_MA\"\r\n    [costMAPD]=\"Spa_Plandetails_Costs_MAPD\"\r\n    [costPDP]=\"Spa_Plandetails_Costs_PDP\"\r\n    [costMEDIGAP]=\"Spa_Plandetails_Costs_MEDIGAP\"\r\n    [costDENTAL]=\"Spa_PlanDetails_Costs_DENTAL\"\r\n    [costVISION]=\"Spa_PlanDetails_Costs_VISION\"\r\n  ></vnext-widget-retention-plan-card>\r\n\r\n  <div class=\"container\" *ngIf=\"Spa_Site_Providers_Enabled && filteredPlans?.length\">\r\n    <p\r\n      class=\"Spa_Style_Note\"\r\n      *liveEditProp=\"'Spa_Site_Provider_Disclaimer'\"\r\n      [innerHtml]=\"Spa_Site_Provider_Disclaimer | safe : 'html'\"\r\n      navigationAdapter\r\n    ></p>\r\n  </div>\r\n\r\n  <vnext-summary-buttons\r\n    [filteredPlans]=\"filteredPlans\"\r\n    [shopAllPlansButtonText]=\"Spa_Site_Shop_All_Plans_Button_Text\"\r\n    [compareThesePlansButtonText]=\"Spa_Retention_CompareThesePlans_Button_Text\"\r\n    (comparePlansSelected)=\"retentionFacade.updatePlansOnCompareGroupAndNavigate(filteredPlans)\"\r\n    (shopForPlansSelected)=\"retentionFacade.shopAllPlans()\"\r\n  ></vnext-summary-buttons>\r\n</ng-container>\r\n\r\n<vnext-summary-coverage-types\r\n  *ngIf=\"Spa_Site_Retention_CoverageTypesSection_Enabled\"\r\n  [planTiles]=\"planTiles\"\r\n  [shopsAllCoverageText]=\"Spa_Site_ShopAllCoverage_Text\"\r\n  [planCounts]=\"planCounts\"\r\n  [pickPlanLabel]=\"Spa_Retention_PickPlan_Text\"\r\n  [filteredPlans]=\"filteredPlans\"\r\n  [notAvailableText]=\"Spa_Retention_NotAvailable_Text\"\r\n  [planTabEducationalTextShow]=\"Spa_Plan_Tab_Educational_Text_Show\"\r\n>\r\n</vnext-summary-coverage-types>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i2.Store }, { type: i1.MemberSessionService }, { type: i1.GuidedHelpService }, { type: RetentionFacade }, { type: PlanFacade }, { type: i1.PlansService }, { type: i1.ImageService }, { type: i1.ResponsiveLayoutService }, { type: i0.Injector }, { type: i1$1.NgbModal }, { type: PlanListFacadeService }, { type: i1.SiteService }, { type: i1.ConfigResourceService }, { type: i1.LocaleService }, { type: PharmacyFacade }, { type: i1.GoogleTagManagerService }, { type: i2$1.Router }]; }, { loading$: [], Spa_Site_RetentionWelcome_Background_Url: [], Spa_Site_RetentionWelcome_Background_MobileUrl: [], Spa_Site_RetentionUserInfo_Name_Label: [], Spa_Site_RetentionUserInfo_ZipCode_Label: [], Spa_Site_RetentionUserInfo_Email_Label: [], Spa_PlanCard_QuoteLinkName_Text: [], Spa_PlanCard_PlanDetails_ButtonText: [], Spa_Site_NotApplicable_Text: [], Spa_PlanCard_PlanType_Text: [], Spa_PlanCard_AddOnCoverageInCart_Text: [], Spa_PlanCard_AddOnCoverageTooltip_Body: [], Spa_Site_Show_PlanLogo: [], Spa_PlanDetails_Non_Covered_Text: [], Spa_Site_Prescriptions_Text: [], Spa_Site_Pharmacy_Text: [], Spa_Site_TotalEstimatedCost_Enabled: [], Spa_PlanCard_TotalEstimatedAnnualCost_Text: [], Spa_PlanCard_TotalEstimatedCost_Text: [], Spa_PlanCard_Total_Estimated_Cost_Tooltip: [], Spa_Site_ShowPremiumAsAnnual: [], Spa_Site_ShowRiderIcons: [], Spa_Site_ShowRidersOnPlanCards: [], Spa_Site_Dental_Rider_Display_Text: [], Spa_Site_Vision_Rider_Display_Text: [], Spa_Site_Hearing_Rider_Display_Text: [], Spa_PlanCard_DentalAddOnCoverage_Text: [], Spa_PlanCard_HearingAddOnCoverage_Text: [], Spa_PlanCard_VisionAddOnCoverage_Text: [], Spa_PlanCard_AddOnCoverage_Text: [], Spa_PlanCard_ShowRidersOnMACards: [], Spa_PlanCard_ShowRidersOnPDPCards: [], Spa_PlanCard_ShowRidersOnMAPDCards: [], Spa_PlanCard_ShowRidersOnMEDIGAPCards: [], Spa_ShoppingCart_Enabled: [], Spa_PlanCard_Drug_Covered_Text: [], Spa_PlanCard_Pharmacy_Covered_Text: [], Spa_Site_Health_Text: [], Spa_Site_QualifiedHelp_Text: [], Spa_GettingStarted_ShowSubsidyAccordion_Flag: [], Spa_Site_Hide_Text: [], Spa_Site_ViewAll_Text: [], Spa_GuidedHelp_Enabled: [], Spa_Site_Health_Enabled: [], Spa_Site_Prescriptions_Enabled: [], Spa_Site_Pharmacy_Enabled: [], Spa_Site_GetStarted_Enabled: [], Spa_Site_Preferences_Edit_Text: [], Spa_GuidedHelp_PlanList_AddLink_Text: [], Spa_Site_Current_Plan_Text: [], Spa_Site_Next_Year_Plan_Text: [], Spa_Site_PlanNotAvailableForNextYear_Text: [], Spa_Site_Keep_This_Plan_Button_Text: [], Spa_Site_RetentionUserInfo_Zipcode_Edit_Label: [], Spa_Site_UserInfo_Zipcode_Edit_Description: [], Spa_Site_Shop_All_Plans_Button_Text: [], Spa_Retention_CompareThesePlans_Button_Text: [], Spa_Retention_NotAvailable_Text: [], Spa_Site_Preferences_Edit_Description: [], Spa_Site_MedigapPlanType_Enabled: [], Spa_Site_AddToCompare_Enabled: [], Spa_Site_PlanViewDetails_Enabled: [], Spa_Site_Providers_Enabled: [], Spa_Site_Providers_Text: [], Spa_Site_Pcp_Text: [], Spa_PlanCard_Providers_InNetwork_Text: [], Spa_Site_Pcp_InNetwork_Text: [], Spa_Site_Pcp_OutOfNetwork_Text: [], Spa_Providers_No_Data_Exist_Text: [], Spa_ZipCodeInput_CountyLabel_Text: [], Spa_ZipCodeInput_CountyLabel_Enabled: [], Spa_PlanList_DisplayDrugsCovered: [], Spa_RetentionUserInfo_PersonalDetailsHeader_Text: [], Spa_Retention_PickPlan_Text: [], Spa_Site_ShopAllCoverage_Text: [], Spa_Summary_AddPreferences_Text: [], Spa_Site_RetentionWelcome_Greeting_Text: [], Spa_Site_Provider_Disclaimer: [], Spa_Plan_Tab_Educational_Text_Show: [], Spa_Site_Tooltip_Text: [], Spa_Site_Multi_Pharmacy_Enabled: [], Spa_Site_PrimaryPharmacy_Indicator_Text: [], Spa_PlanList_Pharmacy_InNetwork_Preferred_Pricing_Text: [], Spa_PlanList_Pharmacy_InNetwork_Standard_Pricing_Text: [], Spa_PlanList_Pharmacy_OutOfNetwork_Pricing_Text: [], Spa_PlanList_ViewCost_Header_Text: [], Spa_PlanList_ViewCost_Header_Content: [], Spa_PlanList_MailOrder_Text: [], Spa_Site_OtherPreferences_Text: [], Spa_Site_OtherPreferences_Enabled: [], Spa_GuidedHelp_ReviewOtherPreferences_Text: [], Spa_Site_ViewDetailsLink_Description_Text: [], Spa_Retention_ClientDefinedPlanOptions_Enabled: [], Spa_Site_Plan_Option_One_Text: [], Spa_Site_Plan_Option_Two_Text: [], Spa_Site_PlanLogo_Size: [], Spa_PlanCard_AncillaryAddtoCart_Enabled: [], Spa_Site_Provider_ShowAllInNetworkLocations_Enabled: [], Spa_Site_RetentionWelcome_Background_Url_Enabled: [], Spa_Site_Retention_CoverageTypesSection_Enabled: [], Spa_PlanCard_Preferences_Detailed_Enabled: [], Spa_PlanCard_Providers_OneOrMore_OutOfNetwork_Text: [], Spa_Providers_InNetwork_OnOtherLocations_Tooltip_Text: [], Spa_Provider_ShowPartialIndicator_Enabled: [], Spa_Site_PlanFees_Enabled: [], Spa_PlanFees_Tooltip_Text: [], Spa_PlanFees_IncludedInPremium_Tooltip_Text: [], Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text: [], Spa_PlanCard_Show_PlanId_Enabled: [], Spa_PlanCard_PlanYearBadge_Enabled: [], Spa_PlanCard_PlanId_Text: [], Spa_Site_Available_Text: [], Spa_Site_NotAvailable_Text: [], Spa_PlanCard_Providers_ViewButton_Text: [], Spa_PlanCard_Prescriptions_ViewButton_Text: [], Spa_PlanCard_SupplementalBenefitsHighlight_Text: [], Spa_Plan_Details_Preferences_Text: [], Spa_PlanCard_ViewMoreDetails_ButtonText: [], Spa_PlanCard_HideDetails_ButtonText: [], Spa_PlanCard_NewDesign_Enabled: [], Spa_PlanCard_ViewAllPlanDetails_ButtonText: [], Spa_PlanCard_ShareThisPlan_ButtonText: [], Spa_PlanCard_ViewCostDetails_ButtonText: [], Spa_Site_Close: [], Spa_PlanCard_PlanBenefitHighlight_Items: [], Spa_PlanCard_PlanBenefitHighlights_Text: [], Spa_Site_RiderDetails_Show: [], Spa_Plan_Details_ViewRiderDetails_Text: [], Spa_Plan_Details_HideRiderDetails_Text: [], Spa_ShoppingCart_IncludedRider_Text: [], Spa_Plan_Details_WaiverStateRider_Tooltips: [], Spa_Plandetails_Costs_MAPD: [], Spa_Plandetails_Costs_MA: [], Spa_Plandetails_Costs_MEDIGAP: [], Spa_Plandetails_Costs_PDP: [], Spa_PlanDetails_Costs_DENTAL: [], Spa_PlanDetails_Costs_VISION: [] }); })();

function RetireFloSurveyComponent_h1_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h1", 13);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r1.Spa_RetireFloLanding_Heading_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function RetireFloSurveyComponent_p_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 14);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r2.Spa_RetireFloLanding_Instructional_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function RetireFloSurveyComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelement(1, "i", 16);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.Spa_RetireFloLanding_MissingAgentError_Text);
} }
function RetireFloSurveyComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelement(1, "i", 16);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r4.Spa_RetireFloLanding_AccessDeniedError_Text);
} }
function RetireFloSurveyComponent_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵlistener("click", function RetireFloSurveyComponent_button_11_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r8.onSurveyClick()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r5.isAgentInContext === false);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.Spa_RetireFloLanding_SurveyButton_Text, " ");
} }
function RetireFloSurveyComponent_p_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 18);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r6.Spa_RetireFloLanding_SkipSurvey_Instructional_Text, "html"), i0.ɵɵsanitizeHtml);
} }
function RetireFloSurveyComponent_vnext_link_14_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 19);
    i0.ɵɵlistener("click", function RetireFloSurveyComponent_vnext_link_14_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r10.navigateToHome()); })("keyup.enter", function RetireFloSurveyComponent_vnext_link_14_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r12.navigateToHome()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r7.Spa_RetireFloLanding_SkipSurvey_Button_Text)("isLinkButton", true)("makeInlineBlock", true);
} }
const _c0$A = function (a0) { return { "background-image": a0 }; };
let RetireFloSurveyComponent = class RetireFloSurveyComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, navigationService, agentRetireFloFacade, agentService, spinnerService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.cdr = cdr;
        this.widgetValidationService = widgetValidationService;
        this.configurableWidgetService = configurableWidgetService;
        this.zoneService = zoneService;
        this.widgetService = widgetService;
        this.navigationService = navigationService;
        this.agentRetireFloFacade = agentRetireFloFacade;
        this.agentService = agentService;
        this.spinnerService = spinnerService;
        this.Spa_RetireFloLanding_Heading_Text = 'Help your agent find coverage';
        this.Spa_RetireFloLanding_Instructional_Text = 'Enter basic information along with prescriptions, doctors, and pharmacies so that your agent can more quickly find the best plan for you.';
        this.Spa_RetireFloLanding_SurveyButton_Text = 'Answer a few questions';
        this.Spa_RetireFloLanding_SkipSurvey_Instructional_Text = 'Don’t want to answer questions right now?';
        this.Spa_RetireFloLanding_SkipSurvey_Button_Text = 'Continue to plans';
        this.Spa_RetireFloLanding_Banner_Image_Url = 'phoenix/assets/images/making_pasta.jpg';
        this.Spa_RetireFloLanding_Banner_Image_UrlMobile = 'phoenix/assets/images/making_pasta_mobile.jpg';
        this.Spa_RetireFlo_ExternalLink_Instructions_Text = 'You are about to leave our site and visit an external URL. Do you wish to continue?';
        this.Spa_RetireFloLanding_MissingAgentError_Text = 'Unable to proceed to survey: agent information is missing. Please contact your agent for a new link.';
        this.Spa_RetireFloLanding_AccessDeniedError_Text = 'Access Denied: you do not have the required permissions to access the survey. Please contact your agent for assistance.';
        this.isAgentInContext = null;
        this.surveyAccessDenied = false;
        this.subscriptions = new Subscription();
    }
    ngOnInit() {
        super.ngOnInit();
        this.getAgentInContext();
    }
    getAgentInContext() {
        this.subscriptions.add(this.agentService.getAgentInContextGuid$().subscribe({
            next: agentInContextGuid => {
                this.isAgentInContext = !!agentInContextGuid;
                this.cdr.markForCheck();
            }
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        super.ngOnDestroy();
    }
    onSurveyClick() {
        if (this.isAgentInContext) {
            this.spinnerService.show(SpinnerEvent.INITIALIZE_SURVEY_VIEW);
            this.agentRetireFloFacade
                .getRetireFloSurveyUrl$()
                .pipe(take$1(1))
                .subscribe({
                next: (surveyData) => {
                    this.spinnerService.hide(SpinnerEvent.INITIALIZE_SURVEY_VIEW);
                    if (surveyData?.surveyUrl) {
                        this.agentRetireFloFacade.showRetireFloSurveyModal(surveyData.surveyUrl);
                    }
                    else {
                        this.surveyAccessDenied = true;
                    }
                    this.cdr.markForCheck();
                },
                error: () => {
                    this.spinnerService.hide(SpinnerEvent.INITIALIZE_SURVEY_VIEW);
                    this.surveyAccessDenied = true;
                    this.cdr.markForCheck();
                }
            });
        }
    }
    navigateToHome() {
        this.navigationService.navigateByPageTag(PageTags.HOME);
    }
};
RetireFloSurveyComponent.ɵfac = function RetireFloSurveyComponent_Factory(t) { return new (t || RetireFloSurveyComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(AgentRetireFloFacade), i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(i1.SpinnerService)); };
RetireFloSurveyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RetireFloSurveyComponent, selectors: [["vnext-widget-retire-flo-survey"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 15, vars: 13, consts: [[1, "survey-wrapper", "Spa_Style_Banner_Background"], [1, "banner", "container"], ["backgroundImage", ""], [1, "background-img", "d-block", "d-md-none", 3, "ngStyle"], [1, "background-img", "mobile", "d-none", "d-md-block", 3, "ngStyle"], [1, "survey-widget"], ["class", "Spa_Style_H1", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["class", "Spa_Style_Paragraph", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], ["class", "Spa_Style_ErrorText my-2", "role", "alert", 4, "ngIf"], ["class", "btn Spa_Style_PrimaryButton", 3, "disabled", "click", 4, "liveEditProp"], [1, "mt-5"], ["class", "Spa_Style_Paragraph mb-1", "navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [3, "title", "isLinkButton", "makeInlineBlock", "click", "keyup.enter", 4, "liveEditProp"], ["navigationAdapter", "", 1, "Spa_Style_H1", 3, "innerHtml"], ["navigationAdapter", "", 1, "Spa_Style_Paragraph", 3, "innerHtml"], ["role", "alert", 1, "Spa_Style_ErrorText", "my-2"], ["aria-hidden", "true", 1, "fa", "fa-exclamation-circle", "mr-1"], [1, "btn", "Spa_Style_PrimaryButton", 3, "disabled", "click"], ["navigationAdapter", "", 1, "Spa_Style_Paragraph", "mb-1", 3, "innerHtml"], [3, "title", "isLinkButton", "makeInlineBlock", "click", "keyup.enter"]], template: function RetireFloSurveyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵelementContainerStart(2, null, 2);
        i0.ɵɵelement(4, "div", 3)(5, "div", 4);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵtemplate(7, RetireFloSurveyComponent_h1_7_Template, 2, 4, "h1", 6);
        i0.ɵɵtemplate(8, RetireFloSurveyComponent_p_8_Template, 2, 4, "p", 7);
        i0.ɵɵtemplate(9, RetireFloSurveyComponent_div_9_Template, 4, 1, "div", 8);
        i0.ɵɵtemplate(10, RetireFloSurveyComponent_div_10_Template, 4, 1, "div", 8);
        i0.ɵɵtemplate(11, RetireFloSurveyComponent_button_11_Template, 2, 2, "button", 9);
        i0.ɵɵelementStart(12, "div", 10);
        i0.ɵɵtemplate(13, RetireFloSurveyComponent_p_13_Template, 2, 4, "p", 11);
        i0.ɵɵtemplate(14, RetireFloSurveyComponent_vnext_link_14_Template, 1, 3, "vnext-link", 12);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(9, _c0$A, "url(" + ctx.Spa_RetireFloLanding_Banner_Image_UrlMobile + ")"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(11, _c0$A, "url(" + ctx.Spa_RetireFloLanding_Banner_Image_Url + ")"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_Demographic_MainHeader_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_Demographic_SecondaryHeader_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isAgentInContext === false);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.surveyAccessDenied);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_RetireFloLanding_SurveyButton_Text");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_RetireFloLanding_SkipSurvey_Instructional_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("liveEditProp", "Spa_RetireFloLanding_SkipSurvey_Button_Text");
    } }, dependencies: [i1$2.NgIf, i1$2.NgStyle, LinkComponent, NavigationAdapterDirective, LiveEditPropDirective, IconAriaAttributesDirective, SafePipe], styles: [".banner[_ngcontent-%COMP%]{width:100%;height:auto;max-height:650px;min-height:450px;margin-top:0;padding-top:100px;position:relative}.background-img[_ngcontent-%COMP%]{position:absolute;left:0;top:0;width:100%;height:100%;background-repeat:no-repeat;background-size:cover;background-position:50% 50%}.survey-widget[_ngcontent-%COMP%]{width:550px;position:relative}@media (min-width: 768px) and (max-width: 1024px){.banner[_ngcontent-%COMP%]{height:600px;display:flex;flex-direction:column-reverse}.survey-widget[_ngcontent-%COMP%]{padding-bottom:15px}}@media (max-width: 767px){.background-img[_ngcontent-%COMP%]{background-position:top center;background-size:auto}.banner[_ngcontent-%COMP%]{height:600px;display:flex;flex-direction:column-reverse}.survey-widget[_ngcontent-%COMP%]{width:100%;padding-bottom:15px}}"], changeDetection: 0 });
__decorate([
    PlatformProp('live-edit')
], RetireFloSurveyComponent.prototype, "Spa_RetireFloLanding_Heading_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], RetireFloSurveyComponent.prototype, "Spa_RetireFloLanding_Instructional_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], RetireFloSurveyComponent.prototype, "Spa_RetireFloLanding_SurveyButton_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], RetireFloSurveyComponent.prototype, "Spa_RetireFloLanding_SkipSurvey_Instructional_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], RetireFloSurveyComponent.prototype, "Spa_RetireFloLanding_SkipSurvey_Button_Text", void 0);
__decorate([
    PlatformProp()
], RetireFloSurveyComponent.prototype, "Spa_RetireFloLanding_Banner_Image_Url", void 0);
__decorate([
    PlatformProp()
], RetireFloSurveyComponent.prototype, "Spa_RetireFloLanding_Banner_Image_UrlMobile", void 0);
__decorate([
    GlobalResource()
], RetireFloSurveyComponent.prototype, "Spa_RetireFlo_ExternalLink_Instructions_Text", void 0);
__decorate([
    GlobalResource()
], RetireFloSurveyComponent.prototype, "Spa_RetireFloLanding_MissingAgentError_Text", void 0);
__decorate([
    GlobalResource()
], RetireFloSurveyComponent.prototype, "Spa_RetireFloLanding_AccessDeniedError_Text", void 0);
RetireFloSurveyComponent = __decorate([
    PlatformWidget
], RetireFloSurveyComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RetireFloSurveyComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-retire-flo-survey', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"survey-wrapper Spa_Style_Banner_Background\">\r\n  <div class=\"banner container\">\r\n    <ng-container #backgroundImage>\r\n      <div\r\n        class=\"background-img d-block d-md-none\"\r\n        [ngStyle]=\"{ 'background-image': 'url(' + Spa_RetireFloLanding_Banner_Image_UrlMobile + ')' }\"\r\n      ></div>\r\n      <div\r\n        class=\"background-img mobile d-none d-md-block\"\r\n        [ngStyle]=\"{ 'background-image': 'url(' + Spa_RetireFloLanding_Banner_Image_Url + ')' }\"\r\n      ></div>\r\n    </ng-container>\r\n    <div class=\"survey-widget\">\r\n      <h1\r\n        *liveEditProp=\"'Spa_Demographic_MainHeader_Text'\"\r\n        class=\"Spa_Style_H1\"\r\n        [innerHtml]=\"Spa_RetireFloLanding_Heading_Text | safe : 'html'\"\r\n        navigationAdapter\r\n      ></h1>\r\n      <p\r\n        *liveEditProp=\"'Spa_Demographic_SecondaryHeader_Text'\"\r\n        class=\"Spa_Style_Paragraph\"\r\n        [innerHtml]=\"Spa_RetireFloLanding_Instructional_Text | safe : 'html'\"\r\n        navigationAdapter\r\n      ></p>\r\n      <div *ngIf=\"isAgentInContext === false\" class=\"Spa_Style_ErrorText my-2\" role=\"alert\">\r\n        <i aria-hidden=\"true\" class=\"fa fa-exclamation-circle mr-1\"></i>\r\n        <span>{{ Spa_RetireFloLanding_MissingAgentError_Text }}</span>\r\n      </div>\r\n      <div *ngIf=\"surveyAccessDenied\" class=\"Spa_Style_ErrorText my-2\" role=\"alert\">\r\n        <i aria-hidden=\"true\" class=\"fa fa-exclamation-circle mr-1\"></i>\r\n        <span>{{ Spa_RetireFloLanding_AccessDeniedError_Text }}</span>\r\n      </div>\r\n      <button\r\n        *liveEditProp=\"'Spa_RetireFloLanding_SurveyButton_Text'\"\r\n        [disabled]=\"isAgentInContext === false\"\r\n        class=\"btn Spa_Style_PrimaryButton\"\r\n        (click)=\"onSurveyClick()\"\r\n      >\r\n        {{ Spa_RetireFloLanding_SurveyButton_Text }}\r\n      </button>\r\n\r\n      <div class=\"mt-5\">\r\n        <p\r\n          *liveEditProp=\"'Spa_RetireFloLanding_SkipSurvey_Instructional_Text'\"\r\n          class=\"Spa_Style_Paragraph mb-1\"\r\n          [innerHtml]=\"Spa_RetireFloLanding_SkipSurvey_Instructional_Text | safe : 'html'\"\r\n          navigationAdapter\r\n        ></p>\r\n\r\n        <vnext-link\r\n          *liveEditProp=\"'Spa_RetireFloLanding_SkipSurvey_Button_Text'\"\r\n          [title]=\"Spa_RetireFloLanding_SkipSurvey_Button_Text\"\r\n          [isLinkButton]=\"true\"\r\n          [makeInlineBlock]=\"true\"\r\n          (click)=\"navigateToHome()\"\r\n          (keyup.enter)=\"navigateToHome()\"\r\n        >\r\n        </vnext-link>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".banner{width:100%;height:auto;max-height:650px;min-height:450px;margin-top:0;padding-top:100px;position:relative}.background-img{position:absolute;left:0;top:0;width:100%;height:100%;background-repeat:no-repeat;background-size:cover;background-position:50% 50%}.survey-widget{width:550px;position:relative}@media (min-width: 768px) and (max-width: 1024px){.banner{height:600px;display:flex;flex-direction:column-reverse}.survey-widget{padding-bottom:15px}}@media (max-width: 767px){.background-img{background-position:top center;background-size:auto}.banner{height:600px;display:flex;flex-direction:column-reverse}.survey-widget{width:100%;padding-bottom:15px}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.NavigationService }, { type: AgentRetireFloFacade }, { type: i1.AgentService }, { type: i1.SpinnerService }]; }, { Spa_RetireFloLanding_Heading_Text: [], Spa_RetireFloLanding_Instructional_Text: [], Spa_RetireFloLanding_SurveyButton_Text: [], Spa_RetireFloLanding_SkipSurvey_Instructional_Text: [], Spa_RetireFloLanding_SkipSurvey_Button_Text: [], Spa_RetireFloLanding_Banner_Image_Url: [], Spa_RetireFloLanding_Banner_Image_UrlMobile: [], Spa_RetireFlo_ExternalLink_Instructions_Text: [], Spa_RetireFloLanding_MissingAgentError_Text: [], Spa_RetireFloLanding_AccessDeniedError_Text: [] }); })();

class SalesForceAuthFacade {
    constructor(configResourceService, navigationUtilityService) {
        this.configResourceService = configResourceService;
        this.navigationUtilityService = navigationUtilityService;
    }
    getAuthUrl() {
        const redirectUrl = this.getRedirectUrl();
        return this.getAuthEndpoint() + '?response_type=code&client_id=' + this.getClientId() + '&redirect_uri=' + redirectUrl;
    }
    getTokenUrl() {
        const redirectUrl = this.getRedirectUrl();
        const authCode = this.getAuthCode();
        const tokenUrl = this.getTokenEndpoint() +
            '?grant_type=authorization_code&client_id=' +
            this.getClientId() +
            '&client_secret=' +
            this.getClientSecret() +
            '&code=' +
            authCode +
            '&redirect_uri=' +
            redirectUrl;
        return tokenUrl;
    }
    getAuthCode() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('code');
    }
    getClientSecret(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SF_Client_Secret', widgetName, '');
    }
    getTokenEndpoint(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SF_Token_Endpoint', widgetName, '');
    }
    getAuthEndpoint(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SF_Auth_Endpoint', widgetName, '');
    }
    getClientId(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SF_Client_Id', widgetName, '');
    }
    getRedirectPage(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_SF_Redirect_Uri', widgetName, '');
    }
    getRedirectUrl() {
        return this.navigationUtilityService.constructFullHref(this.getRedirectPage('oauthretrievesalesforceaccesstoken'));
    }
}
SalesForceAuthFacade.ɵfac = function SalesForceAuthFacade_Factory(t) { return new (t || SalesForceAuthFacade)(i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(i1.NavigationUtilityService)); };
SalesForceAuthFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SalesForceAuthFacade, factory: SalesForceAuthFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SalesForceAuthFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.ConfigResourceService }, { type: i1.NavigationUtilityService }]; }, null); })();

function SalesForceAuthComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 1)(4, "button", 4);
    i0.ɵɵlistener("click", function SalesForceAuthComponent_div_12_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.getSalesForceRefreshToken()); })("keyup.enter", function SalesForceAuthComponent_div_12_Template_button_keyup_enter_4_listener() { i0.ɵɵrestoreView(_r2); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.getSalesForceRefreshToken()); });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.Spa_SalesForce_Auth_TokenButton_Intro_Text);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", ctx_r0.Spa_SalesForce_Auth_TokenButton_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.Spa_SalesForce_Auth_TokenButton_Text, " ");
} }
let SalesForceAuthComponent = class SalesForceAuthComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, store, salesForceAuthFacade, navigationService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.store = store;
        this.salesForceAuthFacade = salesForceAuthFacade;
        this.navigationService = navigationService;
        this.Spa_SalesForce_Auth_Header_Text = 'Get Salesforce Token';
        this.Spa_SalesForce_Auth_Intro_Text = `First click the "Get Salesforce Authentication" button, login to salsforce, when it back to this page again, please click the second
  "Get Salesforce Token" button, then save the value of referesh_token into resource "SalesForceRefreshToken".`;
        this.Spa_SalesForce_Auth_AuthButton_Text = 'Get Salesforce Authentication';
        this.Spa_SalesForce_Auth_AuthButton_Intro_Text = 'Click the following button to get Salesforce Authentication:';
        this.Spa_SalesForce_Auth_TokenButton_Text = 'Get Salesforce Token';
        this.Spa_SalesForce_Auth_TokenButton_Intro_Text = `Now we got the authorization code, please click the following button to get the Token and then save the value of referesh_token into
  resource "SalesForceRefreshToken".`;
        this.isAuthUrlAvailable = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.checkAuthCode();
        this.createSalesForceAuthLink();
        this.createRefreshTokenLink();
    }
    getSalesForceAuth() {
        if (this.authLink) {
            this.navigationService.navigate(this.authLink);
        }
    }
    getSalesForceRefreshToken() {
        if (this.refreshTokenLink) {
            this.navigationService.navigate(this.refreshTokenLink);
        }
    }
    createRefreshTokenLink() {
        this.refreshTokenLink = {
            title: this.Spa_SalesForce_Auth_TokenButton_Text,
            type: LinkType.EXTERNAL,
            href: this.salesForceAuthFacade.getTokenUrl(),
            target: '_self',
            validateWidgets: false
        };
    }
    createSalesForceAuthLink() {
        this.authLink = {
            title: this.Spa_SalesForce_Auth_AuthButton_Text,
            type: LinkType.EXTERNAL,
            href: this.salesForceAuthFacade.getAuthUrl(),
            target: '_self',
            validateWidgets: false
        };
    }
    checkAuthCode() {
        if (this.salesForceAuthFacade.getAuthCode()) {
            this.isAuthUrlAvailable = true;
        }
    }
};
SalesForceAuthComponent.ɵfac = function SalesForceAuthComponent_Factory(t) { return new (t || SalesForceAuthComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(SalesForceAuthFacade), i0.ɵɵdirectiveInject(i1.NavigationService)); };
SalesForceAuthComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SalesForceAuthComponent, selectors: [["vnext-sales-force-auth"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 13, vars: 6, consts: [[1, "container"], [1, "col-12", "mt-4", "text-center"], [1, "Spa_Style_H1", "text-center"], [1, "col-12", "mt-4", "mb-4", "text-center"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", 3, "title", "click", "keyup.enter"], [4, "ngIf"]], template: function SalesForceAuthComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div")(2, "div", 1)(3, "h1", 2);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "p");
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "p");
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 3)(10, "button", 4);
        i0.ɵɵlistener("click", function SalesForceAuthComponent_Template_button_click_10_listener() { return ctx.getSalesForceAuth(); })("keyup.enter", function SalesForceAuthComponent_Template_button_keyup_enter_10_listener() { return ctx.getSalesForceAuth(); });
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(12, SalesForceAuthComponent_div_12_Template, 6, 3, "div", 5);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.Spa_SalesForce_Auth_Header_Text);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.Spa_SalesForce_Auth_Intro_Text);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.Spa_SalesForce_Auth_AuthButton_Intro_Text);
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate("title", ctx.Spa_SalesForce_Auth_AuthButton_Text);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.Spa_SalesForce_Auth_AuthButton_Text, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isAuthUrlAvailable);
    } }, dependencies: [i1$2.NgIf], encapsulation: 2, changeDetection: 0 });
__decorate([
    GlobalResource()
], SalesForceAuthComponent.prototype, "Spa_SalesForce_Auth_Header_Text", void 0);
__decorate([
    GlobalResource()
], SalesForceAuthComponent.prototype, "Spa_SalesForce_Auth_Intro_Text", void 0);
__decorate([
    GlobalResource()
], SalesForceAuthComponent.prototype, "Spa_SalesForce_Auth_AuthButton_Text", void 0);
__decorate([
    GlobalResource()
], SalesForceAuthComponent.prototype, "Spa_SalesForce_Auth_AuthButton_Intro_Text", void 0);
__decorate([
    GlobalResource()
], SalesForceAuthComponent.prototype, "Spa_SalesForce_Auth_TokenButton_Text", void 0);
__decorate([
    GlobalResource()
], SalesForceAuthComponent.prototype, "Spa_SalesForce_Auth_TokenButton_Intro_Text", void 0);
SalesForceAuthComponent = __decorate([
    PlatformWidget
], SalesForceAuthComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SalesForceAuthComponent, [{
        type: Component,
        args: [{ selector: 'vnext-sales-force-auth', providers: [WidgetService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container\">\r\n  <div>\r\n    <div class=\"col-12 mt-4 text-center\">\r\n      <h1 class=\"Spa_Style_H1 text-center\">{{ Spa_SalesForce_Auth_Header_Text }}</h1>\r\n    </div>\r\n    <p>{{ Spa_SalesForce_Auth_Intro_Text }}</p>\r\n    <p>{{ Spa_SalesForce_Auth_AuthButton_Intro_Text }}</p>\r\n    <div class=\"col-12 mt-4 mb-4 text-center\">\r\n      <button\r\n        type=\"button\"\r\n        class=\"btn Spa_Style_SecondaryButton\"\r\n        (click)=\"getSalesForceAuth()\"\r\n        (keyup.enter)=\"getSalesForceAuth()\"\r\n        title=\"{{ Spa_SalesForce_Auth_AuthButton_Text }}\"\r\n      >\r\n        {{ Spa_SalesForce_Auth_AuthButton_Text }}\r\n      </button>\r\n    </div>\r\n    <div *ngIf=\"isAuthUrlAvailable\">\r\n      <p>{{ Spa_SalesForce_Auth_TokenButton_Intro_Text }}</p>\r\n      <div class=\"col-12 mt-4 text-center\">\r\n        <button\r\n          type=\"button\"\r\n          class=\"btn Spa_Style_SecondaryButton\"\r\n          (click)=\"getSalesForceRefreshToken()\"\r\n          (keyup.enter)=\"getSalesForceRefreshToken()\"\r\n          title=\"{{ Spa_SalesForce_Auth_TokenButton_Text }}\"\r\n        >\r\n          {{ Spa_SalesForce_Auth_TokenButton_Text }}\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i2.Store }, { type: SalesForceAuthFacade }, { type: i1.NavigationService }]; }, { Spa_SalesForce_Auth_Header_Text: [], Spa_SalesForce_Auth_Intro_Text: [], Spa_SalesForce_Auth_AuthButton_Text: [], Spa_SalesForce_Auth_AuthButton_Intro_Text: [], Spa_SalesForce_Auth_TokenButton_Text: [], Spa_SalesForce_Auth_TokenButton_Intro_Text: [] }); })();

function ScriptingContainerComponent_div_0_i_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i", 5);
} }
function ScriptingContainerComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 6);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r2.scriptingText, "html"), i0.ɵɵsanitizeHtml);
} }
const _c0$z = function (a0) { return { "scripting-fixed-top": a0 }; };
function ScriptingContainerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtemplate(2, ScriptingContainerComponent_div_0_i_2_Template, 1, 0, "i", 3);
    i0.ɵɵtemplate(3, ScriptingContainerComponent_div_0_div_3_Template, 2, 4, "div", 4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$z, ctx_r0.isSticky));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.Spa_Site_Show_BlackQuotation_Icon_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_Scripting_Text");
} }
let ScriptingContainerComponent = class ScriptingContainerComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, scriptResourceService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.scriptResourceService = scriptResourceService;
        this.Spa_Site_Show_BlackQuotation_Icon_Text = true;
        this.Spa_Site_Sticky_Enable = true;
        this.Spa_Site_ScriptingContainer_Enabled = true;
        this.siteType = SiteType;
        this.isSticky = false;
        this.headerHeight = 100;
    }
    preProcessProperties() {
        this.scriptingText = this.scriptResourceService.getProcessedResourceValue('Spa_Site_Scripting_Text', this.Spa_Site_Scripting_Text, true, 'ScriptingContainerComponent');
    }
    get isLiveEdit() {
        return EnvironmentService.getEnvironment().liveedit;
    }
    onScroll(event) {
        if (this.Spa_Site_Sticky_Enable) {
            this.isSticky = window.scrollY > this.headerHeight;
            this.cdr.detectChanges();
        }
    }
};
ScriptingContainerComponent.ɵfac = function ScriptingContainerComponent_Factory(t) { return new (t || ScriptingContainerComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.ScriptResourceService)); };
ScriptingContainerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ScriptingContainerComponent, selectors: [["vnext-scripting-container"]], hostBindings: function ScriptingContainerComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("scroll", function ScriptingContainerComponent_scroll_HostBindingHandler($event) { return ctx.onScroll($event); }, false, i0.ɵɵresolveWindow);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "page-scripting-wrapper p-3 Spa_Style_Gray1_Background", 3, "ngClass", 4, "ngIf"], [1, "page-scripting-wrapper", "p-3", "Spa_Style_Gray1_Background", 3, "ngClass"], [1, "container"], ["class", "fas fa-quote-left float-left pr-2", "aria-hidden", "true", 4, "ngIf"], ["class", "Spa_Style_Paragraph float-left scripting-text", "navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], ["aria-hidden", "true", 1, "fas", "fa-quote-left", "float-left", "pr-2"], ["navigationAdapter", "", 1, "Spa_Style_Paragraph", "float-left", "scripting-text", 3, "innerHTML"]], template: function ScriptingContainerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ScriptingContainerComponent_div_0_Template, 4, 5, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.Spa_Site_ScriptingContainer_Enabled && (ctx.scriptingText || ctx.isLiveEdit));
    } }, dependencies: [i1$2.NgClass, i1$2.NgIf, NavigationAdapterDirective, LiveEditPropDirective, IconAriaAttributesDirective, SafePipe], styles: [".page-scripting-wrapper[_ngcontent-%COMP%]{max-height:200px;overflow-y:auto}.scripting-text[_ngcontent-%COMP%]{width:96%}.scripting-fixed-top[_ngcontent-%COMP%]{position:fixed;top:0;left:0;right:0;z-index:1030}@media (max-width: 768px){.scripting-text[_ngcontent-%COMP%]{width:92%}}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], ScriptingContainerComponent.prototype, "Spa_Site_Show_BlackQuotation_Icon_Text", void 0);
__decorate([
    GlobalResource()
], ScriptingContainerComponent.prototype, "Spa_Site_Sticky_Enable", void 0);
__decorate([
    GlobalResource()
], ScriptingContainerComponent.prototype, "Spa_Site_ScriptingContainer_Enabled", void 0);
__decorate([
    PlatformProp('live-edit', true)
], ScriptingContainerComponent.prototype, "Spa_Site_Scripting_Text", void 0);
ScriptingContainerComponent = __decorate([
    PlatformWidget
], ScriptingContainerComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ScriptingContainerComponent, [{
        type: Component,
        args: [{ selector: 'vnext-scripting-container', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div\r\n  class=\"page-scripting-wrapper p-3 Spa_Style_Gray1_Background\"\r\n  *ngIf=\"Spa_Site_ScriptingContainer_Enabled && (scriptingText || isLiveEdit)\"\r\n  [ngClass]=\"{ 'scripting-fixed-top': isSticky }\"\r\n>\r\n  <div class=\"container\">\r\n    <i class=\"fas fa-quote-left float-left pr-2\" aria-hidden=\"true\" *ngIf=\"Spa_Site_Show_BlackQuotation_Icon_Text\"></i>\r\n    <div\r\n      class=\"Spa_Style_Paragraph float-left scripting-text\"\r\n      *liveEditProp=\"'Spa_Site_Scripting_Text'\"\r\n      [innerHTML]=\"scriptingText | safe: 'html'\"\r\n      navigationAdapter\r\n    ></div>\r\n  </div>\r\n</div>\r\n", styles: [".page-scripting-wrapper{max-height:200px;overflow-y:auto}.scripting-text{width:96%}.scripting-fixed-top{position:fixed;top:0;left:0;right:0;z-index:1030}@media (max-width: 768px){.scripting-text{width:92%}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.ScriptResourceService }]; }, { Spa_Site_Show_BlackQuotation_Icon_Text: [], Spa_Site_Sticky_Enable: [], Spa_Site_ScriptingContainer_Enabled: [], Spa_Site_Scripting_Text: [], onScroll: [{
            type: HostListener,
            args: ['window:scroll', ['$event']]
        }] }); })();

function CallRecordingIconComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.agentCallRecordingPlanAllowsCallRecordingText);
} }
class CallRecordingIconComponent {
}
CallRecordingIconComponent.ɵfac = function CallRecordingIconComponent_Factory(t) { return new (t || CallRecordingIconComponent)(); };
CallRecordingIconComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CallRecordingIconComponent, selectors: [["vnext-call-recording-icon"]], inputs: { isMobile: "isMobile", agentCallInProgressAcceptCallIcon: "agentCallInProgressAcceptCallIcon", agentCallRecordingPlanAllowsCallRecordingText: "agentCallRecordingPlanAllowsCallRecordingText" }, decls: 4, vars: 6, consts: [[1, "Spa_Style_Gray4_Color", "mt-1", "text-left", "text-sm-right"], ["placement", "left", "aria-hidden", "true", 3, "disableTooltip", "ngbTooltip", "mouseover"], ["allowsRecordingTooltip", "ngbTooltip"], ["class", "ml-2", 4, "ngIf"], [1, "ml-2"]], template: function CallRecordingIconComponent_Template(rf, ctx) { if (rf & 1) {
        const _r2 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 0)(1, "i", 1, 2);
        i0.ɵɵlistener("mouseover", function CallRecordingIconComponent_Template_i_mouseover_1_listener() { i0.ɵɵrestoreView(_r2); const _r0 = i0.ɵɵreference(2); return i0.ɵɵresetView(_r0.open()); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, CallRecordingIconComponent_span_3_Template, 2, 1, "span", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵclassMap(ctx.agentCallInProgressAcceptCallIcon);
        i0.ɵɵproperty("disableTooltip", ctx.isMobile)("ngbTooltip", ctx.agentCallRecordingPlanAllowsCallRecordingText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isMobile);
    } }, dependencies: [i1$2.NgIf, i1$1.NgbTooltip], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CallRecordingIconComponent, [{
        type: Component,
        args: [{ selector: 'vnext-call-recording-icon', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"Spa_Style_Gray4_Color mt-1 text-left text-sm-right\">\r\n  <i [disableTooltip]=\"isMobile\" #allowsRecordingTooltip=\"ngbTooltip\"\r\n    [ngbTooltip]=\"agentCallRecordingPlanAllowsCallRecordingText\" placement=\"left\"\r\n    (mouseover)=\"allowsRecordingTooltip.open()\" class=\"{{ agentCallInProgressAcceptCallIcon }}\" aria-hidden=\"true\"></i>\r\n  <span class=\"ml-2\" *ngIf=\"isMobile\">{{ agentCallRecordingPlanAllowsCallRecordingText }}</span>\r\n</div>" }]
    }], null, { isMobile: [{
            type: Input
        }], agentCallInProgressAcceptCallIcon: [{
            type: Input
        }], agentCallRecordingPlanAllowsCallRecordingText: [{
            type: Input
        }] }); })();

function CartRiderComponent_div_0_h3_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.addOnRidersHeader, " ");
} }
function CartRiderComponent_div_0_div_4_h4_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h4", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const riderCategory_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(riderCategory_r3.header);
} }
function CartRiderComponent_div_0_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelement(1, "i", 14);
    i0.ɵɵelementStart(2, "span", 15);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r5.planRiderConflictMessageText);
} }
function CartRiderComponent_div_0_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const riderCategory_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(riderCategory_r3.informationalText);
} }
function CartRiderComponent_div_0_div_4_div_4_span_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function CartRiderComponent_div_0_div_4_div_4_span_5_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r21.hideDetailsText);
} }
function CartRiderComponent_div_0_div_4_div_4_span_5_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r23.showDetailsText);
} }
function CartRiderComponent_div_0_div_4_div_4_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵlistener("click", function CartRiderComponent_div_0_div_4_div_4_span_5_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r26); const rider_r10 = i0.ɵɵnextContext().$implicit; const ctx_r24 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r24.isRiderCardOpen(rider_r10)); })("keyup.enter", function CartRiderComponent_div_0_div_4_div_4_span_5_Template_span_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r26); const rider_r10 = i0.ɵɵnextContext().$implicit; const ctx_r27 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r27.isRiderCardOpen(rider_r10)); });
    i0.ɵɵtemplate(1, CartRiderComponent_div_0_div_4_div_4_span_5_ng_container_1_Template, 1, 0, "ng-container", 25);
    i0.ɵɵtemplate(2, CartRiderComponent_div_0_div_4_div_4_span_5_ng_template_2_Template, 3, 1, "ng-template", null, 31, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, CartRiderComponent_div_0_div_4_div_4_span_5_ng_template_4_Template, 3, 1, "ng-template", null, 32, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r20 = i0.ɵɵreference(3);
    const _r22 = i0.ɵɵreference(5);
    const rider_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-expanded", ctx_r11.isOpen[rider_r10.planID] ? "true" : "false")("aria-label", ctx_r11.isOpen[rider_r10.planID] ? ctx_r11.hideDetailsLabelText : ctx_r11.viewDetailsLabelText + " " + rider_r10.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.isOpen[rider_r10.planID])("ngIfThen", _r20)("ngIfElse", _r22);
} }
function CartRiderComponent_div_0_div_4_div_4_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const rider_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r12 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r12.riderFacade.getRiderMedicalPremium(rider_r10)), "");
} }
function CartRiderComponent_div_0_div_4_div_4_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function CartRiderComponent_div_0_div_4_div_4_ng_template_10_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r31.includedText);
} }
function CartRiderComponent_div_0_div_4_div_4_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelement(1, "i", 36);
    i0.ɵɵtemplate(2, CartRiderComponent_div_0_div_4_div_4_ng_template_10_span_2_Template, 2, 1, "span", 37);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_ShoppingCart_IncludedRider_Text");
} }
function CartRiderComponent_div_0_div_4_div_4_ng_template_12_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function CartRiderComponent_div_0_div_4_div_4_ng_template_12_ng_container_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵlistener("click", function CartRiderComponent_div_0_div_4_div_4_ng_template_12_ng_container_0_ng_template_2_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r40); const rider_r10 = i0.ɵɵnextContext(3).$implicit; const ctx_r38 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r38.removeRider(rider_r10, true)); })("keyup.enter", function CartRiderComponent_div_0_div_4_div_4_ng_template_12_ng_container_0_ng_template_2_Template_div_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r40); const rider_r10 = i0.ɵɵnextContext(3).$implicit; const ctx_r41 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r41.removeRider(rider_r10, true)); });
    i0.ɵɵelementStart(1, "i", 41);
    i0.ɵɵlistener("keyup.enter", function CartRiderComponent_div_0_div_4_div_4_ng_template_12_ng_container_0_ng_template_2_Template_i_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r40); const rider_r10 = i0.ɵɵnextContext(3).$implicit; const ctx_r43 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r43.removeRider(rider_r10, true)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const rider_r10 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r35 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-label", ctx_r35.removePlanText + " " + rider_r10.planName)("aria-hidden", true);
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("aria-label", ctx_r35.removePlanText + " " + rider_r10.planName);
} }
function CartRiderComponent_div_0_div_4_div_4_ng_template_12_ng_container_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 42);
    i0.ɵɵlistener("click", function CartRiderComponent_div_0_div_4_div_4_ng_template_12_ng_container_0_ng_template_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r48); const rider_r10 = i0.ɵɵnextContext(3).$implicit; const ctx_r46 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r46.selectRider(rider_r10)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rider_r10 = i0.ɵɵnextContext(3).$implicit;
    const riderCategory_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r37 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-label", ctx_r37.showReplaceButton(rider_r10.planID) ? ctx_r37.replaceText + " " + riderCategory_r3.header : ctx_r37.addText + " " + riderCategory_r3.header);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r37.showReplaceButton(rider_r10.planID) ? ctx_r37.replaceText : ctx_r37.addText, " ");
} }
function CartRiderComponent_div_0_div_4_div_4_ng_template_12_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CartRiderComponent_div_0_div_4_div_4_ng_template_12_ng_container_0_ng_container_1_Template, 1, 0, "ng-container", 25);
    i0.ɵɵtemplate(2, CartRiderComponent_div_0_div_4_div_4_ng_template_12_ng_container_0_ng_template_2_Template, 2, 3, "ng-template", null, 38, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, CartRiderComponent_div_0_div_4_div_4_ng_template_12_ng_container_0_ng_template_4_Template, 2, 2, "ng-template", null, 39, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r34 = i0.ɵɵreference(3);
    const _r36 = i0.ɵɵreference(5);
    const rider_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r32 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r32.riderIsSelected(rider_r10.planID))("ngIfThen", _r34)("ngIfElse", _r36);
} }
function CartRiderComponent_div_0_div_4_div_4_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, CartRiderComponent_div_0_div_4_div_4_ng_template_12_ng_container_0_Template, 6, 3, "ng-container", 23);
} if (rf & 2) {
    const rider_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", !ctx_r17.unselectableRiderIds.includes(rider_r10.planID));
} }
function CartRiderComponent_div_0_div_4_div_4_div_15_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45)(1, "div", 46);
    i0.ɵɵelement(2, "i", 47);
    i0.ɵɵelementStart(3, "p", 48);
    i0.ɵɵtext(4);
    i0.ɵɵelement(5, "span", 49);
    i0.ɵɵpipe(6, "safe");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const detail_r55 = ctx.$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", detail_r55.name, " : ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(6, 2, detail_r55.value, "html"), i0.ɵɵsanitizeHtml);
} }
const _c0$y = function (a0) { return { "rider-columns": a0 }; };
function CartRiderComponent_div_0_div_4_div_4_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵtemplate(1, CartRiderComponent_div_0_div_4_div_4_div_15_div_1_Template, 7, 5, "div", 44);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const planDetails_r53 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$y, (planDetails_r53 == null ? null : planDetails_r53.sectionDetails == null ? null : planDetails_r53.sectionDetails.length) > 2));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", planDetails_r53.sectionDetails);
} }
const _c1$6 = function (a0, a1, a2) { return { "selected-rider": a0, "Spa_Style_RiderBackgroundAndBorderBeforeAdded": a1, "Spa_Style_BackgroundBoxRidersAfterAdded Spa_Style_BoxBorderRidersAfterAdded": a2 }; };
const _c2$3 = function (a0) { return { "d-none": a0 }; };
function CartRiderComponent_div_0_div_4_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("mouseenter", function CartRiderComponent_div_0_div_4_div_4_Template_div_mouseenter_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r57); const rider_r10 = restoredCtx.$implicit; const ctx_r56 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r56.toggleHover(rider_r10.planID, true)); })("mouseleave", function CartRiderComponent_div_0_div_4_div_4_Template_div_mouseleave_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r57); const rider_r10 = restoredCtx.$implicit; const ctx_r58 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r58.toggleHover(rider_r10.planID, false)); });
    i0.ɵɵelementStart(1, "div", 18)(2, "div", 19);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 20);
    i0.ɵɵtemplate(5, CartRiderComponent_div_0_div_4_div_4_span_5_Template, 6, 5, "span", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 22);
    i0.ɵɵtemplate(7, CartRiderComponent_div_0_div_4_div_4_ng_container_7_Template, 3, 3, "ng-container", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 24);
    i0.ɵɵtemplate(9, CartRiderComponent_div_0_div_4_div_4_ng_container_9_Template, 1, 0, "ng-container", 25);
    i0.ɵɵtemplate(10, CartRiderComponent_div_0_div_4_div_4_ng_template_10_Template, 3, 1, "ng-template", null, 26, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(12, CartRiderComponent_div_0_div_4_div_4_ng_template_12_Template, 1, 1, "ng-template", null, 27, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 28);
    i0.ɵɵtemplate(15, CartRiderComponent_div_0_div_4_div_4_div_15_Template, 2, 4, "div", 29);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const rider_r10 = ctx.$implicit;
    const _r14 = i0.ɵɵreference(11);
    const _r16 = i0.ɵɵreference(13);
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(10, _c1$6, ctx_r7.riderIsSelected(rider_r10.planID), !ctx_r7.riderIsSelected(rider_r10.planID), ctx_r7.isHover[rider_r10.planID] || ctx_r7.riderIsSelected(rider_r10.planID)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(rider_r10.planName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", rider_r10.extendedPlanDetails.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r7.riderIsSelected(rider_r10.planID) ? "selected-rider Spa_Style_Cost_Text_Color" : "");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !rider_r10.isRequiredRider);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", rider_r10.isRequiredRider)("ngIfThen", _r14)("ngIfElse", _r16);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c2$3, !ctx_r7.isOpen[rider_r10.planID]));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", rider_r10.extendedPlanDetails);
} }
function CartRiderComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, CartRiderComponent_div_0_div_4_h4_1_Template, 2, 1, "h4", 8);
    i0.ɵɵtemplate(2, CartRiderComponent_div_0_div_4_div_2_Template, 4, 1, "div", 9);
    i0.ɵɵtemplate(3, CartRiderComponent_div_0_div_4_div_3_Template, 2, 1, "div", 10);
    i0.ɵɵtemplate(4, CartRiderComponent_div_0_div_4_div_4_Template, 16, 16, "div", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const riderCategory_r3 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", riderCategory_r3.header);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.riderCategoryConflicts[riderCategory_r3.id]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", riderCategory_r3.showInformationalText);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", riderCategory_r3.riders);
} }
function CartRiderComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtemplate(2, CartRiderComponent_div_0_h3_2_Template, 2, 1, "h3", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵtemplate(4, CartRiderComponent_div_0_div_4_Template, 5, 4, "div", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_ShoppingCart_AddOnRiders_Header");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.riderCategories);
} }
let CartRiderComponent = class CartRiderComponent {
    constructor(riderFacade, demographicService, analyticsService, cdr, localeService, planRiderTypeConflictContextService) {
        this.riderFacade = riderFacade;
        this.demographicService = demographicService;
        this.analyticsService = analyticsService;
        this.cdr = cdr;
        this.localeService = localeService;
        this.planRiderTypeConflictContextService = planRiderTypeConflictContextService;
        this.planRiderConflictMessageEnabled = false;
        this.planRiderConflictMessageText = '';
        this.riderCategories = [];
        this.isOpen = {};
        this.isHover = {};
        this.selectedRiderIds = [];
        this.unselectableRiderIds = [];
        this.riderCompatibility = [];
        this.riderIdsWithReplaceButton = [];
        this.ridersIdsWithConflicts = [];
        this.conflictingRiders = [];
        this.riderCategoryConflicts = {};
        this.subscriptions = new Subscription();
    }
    ngOnChanges(changes) {
        const { riders } = changes;
        if (riders && !_isEqual(riders.previousValue, riders.currentValue)) {
            this.updateRiderInformation();
        }
    }
    ngOnInit() {
        this.updateRiderInformation();
        this.subscriptions.add(this.riderFacade.getSelectedRiders$().subscribe(selectedRiders => {
            this.selectedRiderIds = selectedRiders?.map(rider => rider.planID) || [];
            this.planRiderTypeConflictContextService.updateSelectedRiders(selectedRiders);
            this.updatePlanRiderConflicts();
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe(locale => {
            this.initializeRiderCategories();
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.planRiderTypeConflictContextService.getConflicts$().subscribe(conflicts => {
            this.conflictingRiders = [];
            Object.keys(conflicts).forEach(planId => {
                this.selectedRiderIds.forEach(selectedRiderId => {
                    if (conflicts[planId].includes(selectedRiderId)) {
                        this.conflictingRiders.push(selectedRiderId);
                    }
                });
            });
            this.cdr.markForCheck();
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    updatePlanRiderConflicts() {
        if (this.planRiderConflictMessageEnabled) {
            this.riderCategories.forEach(category => {
                this.riderCategoryConflicts[category.id] = this.containerHasRiderConflicts(category.riders);
            });
        }
    }
    initRiderCompatibility() {
        const riderCompatibility = [];
        const riderIds = this.riders.map(rider => rider.planID);
        if (this.isWaiverStateAndMedigap) {
            // Go off of partnerRiders arrays from data
            this.riders.forEach(rider => {
                riderCompatibility.push({
                    name: rider.planName,
                    id: rider.planID,
                    isRequired: rider.isRequiredRider,
                    incompatible: riderIds.filter(riderId => riderId !== rider.planID && !rider.partnerRiders.map(partnerRider => partnerRider.planID).includes(riderId))
                });
            });
        }
        else {
            // Create our own partnerRiders array from buckets
            this.riders.forEach(rider => {
                // find buckets containing the current rider
                const bucketsWithRider = [];
                Object.keys(this.riderBuckets).forEach(bucketType => {
                    const bucket = this.riderBuckets[bucketType];
                    if (bucket.find(riderInBucket => riderInBucket.planID === rider.planID) !== undefined) {
                        bucketsWithRider.push(bucket);
                    }
                });
                // create flat list of unique ids sharing buckets with the current rider
                const idsInBucketsWithRider = [...new Set(bucketsWithRider.reduce((acc, val) => acc.concat(val), []))]
                    .filter(riderFromBucket => riderFromBucket.planID !== rider.planID)
                    .map(rider => rider.planID);
                riderCompatibility.push({
                    name: rider.planName,
                    id: rider.planID,
                    isRequired: rider.isRequiredRider,
                    incompatible: idsInBucketsWithRider
                });
            });
        }
        this.riderCompatibility = riderCompatibility;
    }
    containerHasRiderConflicts(riders) {
        let conflictFound = false;
        for (const rider of riders) {
            if (this.conflictingRiders.includes(rider.planID)) {
                conflictFound = true;
                break;
            }
        }
        return conflictFound;
    }
    selectRider(newSelectedRider) {
        this.updateTags(newSelectedRider);
        // Go through every currently selected rider, and unselect it if incompatible with the newly selected rider
        this.selectedRiderIds.forEach(selectedRiderId => {
            const matchingCompatibility = this.riderCompatibility.find(compatibility => compatibility.id === selectedRiderId);
            if (matchingCompatibility && matchingCompatibility.incompatible.includes(newSelectedRider.planID)) {
                const matchingRider = this.riders.find(rider => rider.planID === selectedRiderId);
                if (matchingRider) {
                    this.removeRider(matchingRider, false);
                }
            }
        });
        this.riderFacade.selectRider(newSelectedRider, this.plan.id);
        this.updateRidersWithReplaceButtons();
        this.cdr.markForCheck();
    }
    removeRider(rider, updateReplaceableRiders) {
        if (!rider.isRequiredRider) {
            this.riderFacade.removeRider(rider.planID, this.plan.id);
            if (updateReplaceableRiders) {
                this.updateRidersWithReplaceButtons();
            }
            this.cdr.markForCheck();
        }
    }
    isRiderCardOpen(rider) {
        if (!this.isOpen[rider.planID]) {
            this.updateTags(rider, true);
        }
        return (this.isOpen[rider.planID] = !this.isOpen[rider.planID]);
    }
    showReplaceButton(riderId) {
        return this.riderIdsWithReplaceButton.includes(riderId);
    }
    toggleHover(riderId, flag) {
        this.isHover[riderId] = flag;
    }
    riderIsSelected(riderId) {
        return this.selectedRiderIds.includes(riderId);
    }
    updateRiderInformation() {
        this.selectRequiredRiders();
        this.initializeRiderCategories();
        this.initRiderCompatibility();
        this.setUnselectableRiders();
    }
    updateRidersWithReplaceButtons() {
        const newRiderIdsWithReplaceButtons = [];
        const compatibilityForSelectedRiders = this.riderCompatibility.filter(compatibility => this.selectedRiderIds.includes(compatibility.id));
        this.riders
            .map(rider => rider.planID)
            .forEach(riderId => {
            // if any rider is incompatible with a selectedRider, set its button to show 'replace'
            compatibilityForSelectedRiders.forEach(selectedRiderCompatibility => {
                if (selectedRiderCompatibility.incompatible.includes(riderId)) {
                    newRiderIdsWithReplaceButtons.push(riderId);
                }
            });
        });
        this.riderIdsWithReplaceButton = [...new Set(newRiderIdsWithReplaceButtons)];
    }
    initializeRiderCategories() {
        this.isWaiverStateAndMedigap = this.demographicService.isWaiverStateAndMedigap(this.plan);
        this.riderCategories = this.riderFacade.createRiderCategories(this.riders, this.isWaiverStateAndMedigap);
        this.riderBuckets = this.riderFacade.createRiderBuckets(this.riders);
    }
    updateTags(rider, isViewRiderDetails) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: isViewRiderDetails
                ? DataLayerEvent.CLICK_CART_VIEW_RIDERDETAILS
                : DataLayerEvent.CLICK_CART_ADD_RIDER,
            [DataLayerGlobalVariable.RIDER_NAME]: rider.planName,
            [DataLayerGlobalVariable.RIDER_PLANID]: rider.planID,
            [DataLayerGlobalVariable.RIDER_PLANTYPE]: rider.planType.toString()
        };
    }
    setUnselectableRiders() {
        // if a rider is incompatible with a required rider, it is impossible to select
        // I was told this shouldn't happen, but that it isn't 100% impossible, so still being defensive here
        const unselectableRiderIds = [];
        this.riderCompatibility
            .filter(riderCompatibility => riderCompatibility.isRequired)
            .map(riderCompatibility => riderCompatibility.incompatible)
            .forEach(ids => ids.forEach(id => unselectableRiderIds.push(id)));
        this.unselectableRiderIds = [...new Set(unselectableRiderIds)];
    }
    selectRequiredRiders() {
        this.riders.filter(rider => rider.isRequiredRider).forEach(requiredRider => this.selectRider(requiredRider));
    }
};
CartRiderComponent.ɵfac = function CartRiderComponent_Factory(t) { return new (t || CartRiderComponent)(i0.ɵɵdirectiveInject(RiderFacade), i0.ɵɵdirectiveInject(i1.DemographicService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.PlanRiderTypeConflictContextService)); };
CartRiderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CartRiderComponent, selectors: [["vnext-cart-rider"]], inputs: { plan: "plan", riders: "riders", showDetailsText: "showDetailsText", hideDetailsText: "hideDetailsText", replaceText: "replaceText", addText: "addText", includedText: "includedText", addOnRidersHeader: "addOnRidersHeader", viewDetailsLabelText: "viewDetailsLabelText", hideDetailsLabelText: "hideDetailsLabelText", removePlanText: "removePlanText", planRiderConflictMessageEnabled: "planRiderConflictMessageEnabled", planRiderConflictMessageText: "planRiderConflictMessageText" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "col-12 pt-2 mb-4 plan-row", 4, "ngIf"], [1, "col-12", "pt-2", "mb-4", "plan-row"], [1, "Spa_Style_Primary_Color", "Spa_Style_H4"], ["class", "riders-header mb-2 Spa_Style_H2", 4, "liveEditProp"], [1, "mt-2"], ["class", "rider-category-wrapper", 4, "ngFor", "ngForOf"], [1, "riders-header", "mb-2", "Spa_Style_H2"], [1, "rider-category-wrapper"], ["class", "Spa_Style_H4 mb-2", 4, "ngIf"], ["class", "mt-1 mb-3 warn-container", 4, "ngIf"], ["class", "Spa_Style_Note", 4, "ngIf"], ["class", "rider-card", 3, "ngClass", "mouseenter", "mouseleave", 4, "ngFor", "ngForOf"], [1, "Spa_Style_H4", "mb-2"], [1, "mt-1", "mb-3", "warn-container"], [1, "Spa_Style_Accent4_Color", "fas", "fa-exclamation-triangle", "mr-2"], [1, "Spa_Style_Paragraph"], [1, "Spa_Style_Note"], [1, "rider-card", 3, "ngClass", "mouseenter", "mouseleave"], [1, "rider-header", "row"], [1, "col-6", "col-sm-7", "col-md-5", "col-lg-7", "order-1", "no-translate-block"], [1, "col-6", "col-sm-6", "col-md-3", "col-lg-2", "order-last", "order-md-2", "order-sm-3"], ["class", "Spa_Style_Link link focus-text can-click", "tabindex", "0", "role", "button", 3, "click", "keyup.enter", 4, "ngIf"], [1, "col-6", "col-sm-5", "col-md-2", "col-lg-1", "rider-amount", "order-3", "order-sm-2", "text-right", "Spa_Style_Semi_Bold_Weight", "Spa_Style_Large_Font", 3, "ngClass"], [4, "ngIf"], [1, "col-6", "col-sm-6", "col-md-2", "col-lg-2", "text-right", "order-last", "order-md-4"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["requiredRiderText", ""], ["normalRiderButtons", ""], [1, "rider-details", 3, "ngClass"], ["class", "rider-details-list", 3, "ngClass", 4, "ngFor", "ngForOf"], ["tabindex", "0", "role", "button", 1, "Spa_Style_Link", "link", "focus-text", "can-click", 3, "click", "keyup.enter"], ["hideDetails", ""], ["viewDetails", ""], ["aria-hidden", "true", 1, "ml-1", "fas", "fa-angle-up"], ["aria-hidden", "true", 1, "ml-1", "fas", "fa-angle-down"], [1, "Spa_Style_H4"], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "included-icon", "Spa_Style_CheckmarksAndPreferredInNetwork"], [4, "liveEditProp"], ["removeButton", ""], ["addButton", ""], ["role", "button", "tabindex", "0", 1, "remove-button", "can-click", 3, "click", "keyup.enter"], ["role", "button", 1, "fas", "fa-times", 3, "keyup.enter"], [1, "btn", "Spa_Style_SecondaryButton", 3, "click"], [1, "rider-details-list", 3, "ngClass"], ["class", "details-list-item", 4, "ngFor", "ngForOf"], [1, "details-list-item"], [1, "details-list-item-body", "Spa_Style_Note"], ["aria-hidden", "true", 1, "fas", "fa-circle", "list-bullet"], [1, ""], [3, "innerHtml"]], template: function CartRiderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CartRiderComponent_div_0_Template, 5, 2, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.riderCategories && ctx.riderCategories.length && ctx.riderCategories[0].riders && ctx.riderCategories[0].riders.length);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, LiveEditPropDirective, IconAriaAttributesDirective, i1$2.CurrencyPipe, SafePipe], styles: [".plan-row[_ngcontent-%COMP%]{border-top:1px solid var(--static-Spa_Style_Accent1)}.rider-category-wrapper[_ngcontent-%COMP%]{margin-bottom:3px;width:100%}.rider-header[_ngcontent-%COMP%]{align-items:center}.rider-card[_ngcontent-%COMP%]{border-width:1px;border-style:solid;border-radius:5px;padding:10px 18px;font-size:14px;margin-bottom:5px}.Spa_Style_Link[_ngcontent-%COMP%]{text-decoration:underline}.remove-button[_ngcontent-%COMP%]{line-height:38px;height:38px;padding-left:45px;display:inline-block}.remove-button[_ngcontent-%COMP%]:hover{cursor:pointer}.selected-rider[_ngcontent-%COMP%]   .rider-amount[_ngcontent-%COMP%]{align-items:center;display:flex}.selected-rider[_ngcontent-%COMP%]   .rider-amount[_ngcontent-%COMP%]:before{content:\"\\f067\";font-size:12px;font-family:\"Font Awesome 5 Pro\";margin-right:5px;margin-top:1px;width:100%}.rider-details-list[_ngcontent-%COMP%]{padding-top:15px}.rider-columns[_ngcontent-%COMP%]{columns:2}@media (max-width: 768px){.rider-columns[_ngcontent-%COMP%]{columns:1}}.details-list-item[_ngcontent-%COMP%]{display:inline-block;width:100%}.details-list-item-body[_ngcontent-%COMP%]{display:flex}.list-bullet[_ngcontent-%COMP%]{font-size:6px;padding-top:8px;padding-right:15px}.included-icon[_ngcontent-%COMP%], .fa-circle[_ngcontent-%COMP%]:before{font-family:\"Font Awesome 5 Pro\"}.warning-text[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Warn_Darker)}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], CartRiderComponent.prototype, "selectRider", null);
__decorate([
    LiveEditInactive()
], CartRiderComponent.prototype, "removeRider", null);
CartRiderComponent = __decorate([
    PlatformWidget
], CartRiderComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CartRiderComponent, [{
        type: Component,
        args: [{ selector: 'vnext-cart-rider', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\r\n  class=\"col-12 pt-2 mb-4 plan-row\"\r\n  *ngIf=\"riderCategories && riderCategories.length && riderCategories[0].riders && riderCategories[0].riders.length\"\r\n>\r\n  <div class=\"Spa_Style_Primary_Color Spa_Style_H4\">\r\n    <h3 class=\"riders-header mb-2 Spa_Style_H2\" *liveEditProp=\"'Spa_ShoppingCart_AddOnRiders_Header'\">\r\n      {{ addOnRidersHeader }}\r\n    </h3>\r\n  </div>\r\n  <div class=\"mt-2\">\r\n    <div class=\"rider-category-wrapper\" *ngFor=\"let riderCategory of riderCategories\">\r\n      <h4 class=\"Spa_Style_H4 mb-2\" *ngIf=\"riderCategory.header\">{{ riderCategory.header }}</h4>\r\n      <div *ngIf=\"riderCategoryConflicts[riderCategory.id]\" class=\"mt-1 mb-3 warn-container\">\r\n        <i class=\"Spa_Style_Accent4_Color fas fa-exclamation-triangle mr-2\"></i><span class=\"Spa_Style_Paragraph\">{{ planRiderConflictMessageText }}</span>\r\n      </div>\r\n      <div class=\"Spa_Style_Note\" *ngIf=\"riderCategory.showInformationalText\">{{ riderCategory.informationalText }}</div>\r\n      <div\r\n        class=\"rider-card\"\r\n        *ngFor=\"let rider of riderCategory.riders\"\r\n        (mouseenter)=\"toggleHover(rider.planID, true)\"\r\n        (mouseleave)=\"toggleHover(rider.planID, false)\"\r\n        [ngClass]=\"{\r\n          'selected-rider': riderIsSelected(rider.planID),\r\n          'Spa_Style_RiderBackgroundAndBorderBeforeAdded': !riderIsSelected(rider.planID),\r\n          'Spa_Style_BackgroundBoxRidersAfterAdded Spa_Style_BoxBorderRidersAfterAdded':\r\n            isHover[rider.planID] || riderIsSelected(rider.planID)\r\n        }\"\r\n      >\r\n        <div class=\"rider-header row\">\r\n          <div class=\"col-6 col-sm-7 col-md-5 col-lg-7 order-1 no-translate-block\">{{ rider.planName }}</div>\r\n\r\n          <div class=\"col-6 col-sm-6 col-md-3 col-lg-2 order-last order-md-2 order-sm-3\">\r\n            <span\r\n              class=\"Spa_Style_Link link focus-text can-click\"\r\n              *ngIf=\"rider.extendedPlanDetails.length\"\r\n              (click)=\"isRiderCardOpen(rider)\"\r\n              (keyup.enter)=\"isRiderCardOpen(rider)\"\r\n              tabindex=\"0\"\r\n              role=\"button\"\r\n              [attr.aria-expanded]=\"isOpen[rider.planID] ? 'true' : 'false'\"\r\n              [attr.aria-label]=\"isOpen[rider.planID] ? hideDetailsLabelText : viewDetailsLabelText + ' ' + rider.planName\"\r\n            >\r\n              <ng-container *ngIf=\"isOpen[rider.planID]; then hideDetails; else viewDetails\"></ng-container>\r\n              <ng-template #hideDetails>\r\n                <span>{{ hideDetailsText }}<i aria-hidden=\"true\" class=\"ml-1 fas fa-angle-up\"></i></span>\r\n              </ng-template>\r\n              <ng-template #viewDetails>\r\n                <span>{{ showDetailsText }}<i aria-hidden=\"true\" class=\"ml-1 fas fa-angle-down\"></i></span>\r\n              </ng-template>\r\n            </span>\r\n          </div>\r\n          <div\r\n            class=\"col-6 col-sm-5 col-md-2 col-lg-1 rider-amount order-3 order-sm-2 text-right Spa_Style_Semi_Bold_Weight Spa_Style_Large_Font\"\r\n            [ngClass]=\"riderIsSelected(rider.planID) ? 'selected-rider Spa_Style_Cost_Text_Color' : ''\"\r\n          >\r\n            <ng-container *ngIf=\"!rider.isRequiredRider\"> {{ riderFacade.getRiderMedicalPremium(rider) | currency }}</ng-container>\r\n          </div>\r\n          <div class=\"col-6 col-sm-6 col-md-2 col-lg-2 text-right order-last order-md-4\">\r\n            <ng-container *ngIf=\"rider.isRequiredRider; then requiredRiderText; else normalRiderButtons\"> </ng-container>\r\n            <ng-template #requiredRiderText>\r\n              <div class=\"Spa_Style_H4\">\r\n                <i class=\"fas fa-check-circle included-icon Spa_Style_CheckmarksAndPreferredInNetwork\" aria-hidden=\"true\"></i>\r\n                <span *liveEditProp=\"'Spa_ShoppingCart_IncludedRider_Text'\">{{ includedText }}</span>\r\n              </div>\r\n            </ng-template>\r\n            <ng-template #normalRiderButtons>\r\n              <ng-container *ngIf=\"!unselectableRiderIds.includes(rider.planID)\">\r\n                <ng-container *ngIf=\"riderIsSelected(rider.planID); then removeButton; else addButton\"> </ng-container>\r\n                <ng-template #removeButton>\r\n                  <div\r\n                    class=\"remove-button can-click\"\r\n                    (click)=\"removeRider(rider, true)\"\r\n                    (keyup.enter)=\"removeRider(rider, true)\"\r\n                    role=\"button\"\r\n                    tabindex=\"0\"\r\n                    [attr.aria-label]=\"removePlanText + ' ' + rider.planName\"\r\n                    [attr.aria-hidden]=\"true\"\r\n                  >\r\n                    <i\r\n                      class=\"fas fa-times\"\r\n                      (keyup.enter)=\"removeRider(rider, true)\"\r\n                      [attr.aria-label]=\"removePlanText + ' ' + rider.planName\"\r\n                      role=\"button\"\r\n                    ></i>\r\n                  </div>\r\n                </ng-template>\r\n                <ng-template #addButton>\r\n                  <button\r\n                    class=\"btn Spa_Style_SecondaryButton\"\r\n                    (click)=\"selectRider(rider)\"\r\n                    [attr.aria-label]=\"\r\n                      showReplaceButton(rider.planID) ? replaceText + ' ' + riderCategory.header : addText + ' ' + riderCategory.header\r\n                    \"\r\n                  >\r\n                    {{ showReplaceButton(rider.planID) ? replaceText : addText }}\r\n                  </button>\r\n                </ng-template>\r\n              </ng-container>\r\n            </ng-template>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"rider-details\" [ngClass]=\"{ 'd-none': !isOpen[rider.planID] }\">\r\n          <div *ngFor=\"let planDetails of rider.extendedPlanDetails\" class=\"rider-details-list\" [ngClass]=\"{ 'rider-columns': planDetails?.sectionDetails?.length > 2 }\">\r\n            <div class=\"details-list-item\" *ngFor=\"let detail of planDetails.sectionDetails\">\r\n              <div class=\"details-list-item-body Spa_Style_Note\">\r\n                <i class=\"fas fa-circle list-bullet\" aria-hidden=\"true\"></i>\r\n                <p class=\"\">{{ detail.name }} : <span [innerHtml]=\"detail.value | safe: 'html'\"></span></p>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".plan-row{border-top:1px solid var(--static-Spa_Style_Accent1)}.rider-category-wrapper{margin-bottom:3px;width:100%}.rider-header{align-items:center}.rider-card{border-width:1px;border-style:solid;border-radius:5px;padding:10px 18px;font-size:14px;margin-bottom:5px}.Spa_Style_Link{text-decoration:underline}.remove-button{line-height:38px;height:38px;padding-left:45px;display:inline-block}.remove-button:hover{cursor:pointer}.selected-rider .rider-amount{align-items:center;display:flex}.selected-rider .rider-amount:before{content:\"\\f067\";font-size:12px;font-family:\"Font Awesome 5 Pro\";margin-right:5px;margin-top:1px;width:100%}.rider-details-list{padding-top:15px}.rider-columns{columns:2}@media (max-width: 768px){.rider-columns{columns:1}}.details-list-item{display:inline-block;width:100%}.details-list-item-body{display:flex}.list-bullet{font-size:6px;padding-top:8px;padding-right:15px}.included-icon,.fa-circle:before{font-family:\"Font Awesome 5 Pro\"}.warning-text{color:var(--static-Spa_Style_Warn_Darker)}\n"] }]
    }], function () { return [{ type: RiderFacade }, { type: i1.DemographicService }, { type: AnalyticsService }, { type: i0.ChangeDetectorRef }, { type: i1.LocaleService }, { type: i1.PlanRiderTypeConflictContextService }]; }, { plan: [{
            type: Input
        }], riders: [{
            type: Input
        }], showDetailsText: [{
            type: Input
        }], hideDetailsText: [{
            type: Input
        }], replaceText: [{
            type: Input
        }], addText: [{
            type: Input
        }], includedText: [{
            type: Input
        }], addOnRidersHeader: [{
            type: Input
        }], viewDetailsLabelText: [{
            type: Input
        }], hideDetailsLabelText: [{
            type: Input
        }], removePlanText: [{
            type: Input
        }], planRiderConflictMessageEnabled: [{
            type: Input
        }], planRiderConflictMessageText: [{
            type: Input
        }], selectRider: [], removeRider: [] }); })();

function HospitalIndemnityCoverageCartNudgeComponent_h2_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.shoppingCartHIPCallOutTitle, " ");
} }
function HospitalIndemnityCoverageCartNudgeComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r1.shoppingCartHIPCallOutInstructional, "html"), i0.ɵɵsanitizeHtml);
} }
class HospitalIndemnityCoverageCartNudgeComponent {
    constructor(injector, modalService, analyticsService, responsiveLayoutService, configurableWidgetService, planListFacade, plansService, planCompareFacade, store) {
        this.injector = injector;
        this.modalService = modalService;
        this.analyticsService = analyticsService;
        this.responsiveLayoutService = responsiveLayoutService;
        this.configurableWidgetService = configurableWidgetService;
        this.planListFacade = planListFacade;
        this.plansService = plansService;
        this.planCompareFacade = planCompareFacade;
        this.store = store;
        this.subscriptions = [];
    }
    ngOnInit() {
        this.subscriptions.push(this.responsiveLayoutService.isCompact$.subscribe((isMobile) => {
            this.addToQuoteLimit = isMobile ? this.addToQuoteMobileLimit : this.addToQuoteDesktopLimit;
        }));
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }
    onClickInformationNudge() {
        if (this.areAllHospitalIndemnityQuestionsAnswered) {
            this.configurableWidgetService.spinnerService.show(SpinnerEvent.PLANS_LOADING);
            const hospitalIndemnityPlansSelectedForQuote = this.planCompareFacade.getHospitalIndemnityPlansSelectedForQuote();
            const activeRateFactorPlan = this.store.selectSnapshot(PlansState.activeRateFactorPlan);
            if (hospitalIndemnityPlansSelectedForQuote?.items?.length < this.addToQuoteLimit && !activeRateFactorPlan) {
                this.plansService.setRateFactorPlan(this.enrollingPlan);
            }
            this.plansService.setOverrideActiveTab(false);
            this.planListFacade.updateActiveTab(PlanTypeAbbreviation.HC);
            this.configurableWidgetService.navigationService.navigateByPageTag(PageTags.PLAN_LIST).then(() => {
                this.configurableWidgetService.spinnerService.hide(SpinnerEvent.PLANS_LOADING);
            });
        }
        else {
            this.openRateFactorModal();
        }
    }
    openRateFactorModal() {
        const options = {
            ariaLabelledBy: 'modalHeaderTitle',
            centered: true,
            injector: this.injector,
            size: 'lg'
        };
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_PLANS_ADDONCOVERAGE
        };
        const hospitalIndemnityFactorModal = this.modalService.open(HospitalIndemnityFactorModalComponent, options);
        hospitalIndemnityFactorModal.componentInstance.title = this.rateFactorModalTitle;
        hospitalIndemnityFactorModal.componentInstance.rateFactorFormPromptText = this.rateFactorFormPromptText;
        hospitalIndemnityFactorModal.componentInstance.rateFactorFormPageTitleText = this.rateFactorFormPageTitleText;
        hospitalIndemnityFactorModal.componentInstance.errorKeywordText = this.errorKeywordText;
        hospitalIndemnityFactorModal.componentInstance.errorNoticeTitle = this.errorNoticeTitle;
        hospitalIndemnityFactorModal.componentInstance.dropdownDefaultText = this.dropdownDefaultText;
        hospitalIndemnityFactorModal.componentInstance.rateFactorPlan = this.enrollingPlan;
        hospitalIndemnityFactorModal.componentInstance.addToQuoteLimit = this.addToQuoteLimit;
        // If we select "Add more coverage" from cart, it should NOT replace the previously selected medicare plan
        hospitalIndemnityFactorModal.componentInstance.shouldReplaceExistingRateFactor = false;
    }
}
HospitalIndemnityCoverageCartNudgeComponent.ɵfac = function HospitalIndemnityCoverageCartNudgeComponent_Factory(t) { return new (t || HospitalIndemnityCoverageCartNudgeComponent)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(PlanListFacadeService), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(PlanCompareFacade), i0.ɵɵdirectiveInject(i2.Store)); };
HospitalIndemnityCoverageCartNudgeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HospitalIndemnityCoverageCartNudgeComponent, selectors: [["vnext-hospital-indemnity-coverage-cart-nudge"]], inputs: { shoppingCartHIPCallOutTitle: "shoppingCartHIPCallOutTitle", shoppingCartHIPCallOutInstructional: "shoppingCartHIPCallOutInstructional", cartCallOutButtonText: "cartCallOutButtonText", rateFactorModalTitle: "rateFactorModalTitle", rateFactorFormPromptText: "rateFactorFormPromptText", rateFactorFormPageTitleText: "rateFactorFormPageTitleText", errorKeywordText: "errorKeywordText", errorNoticeTitle: "errorNoticeTitle", dropdownDefaultText: "dropdownDefaultText", enrollingPlan: "enrollingPlan", areAllHospitalIndemnityQuestionsAnswered: "areAllHospitalIndemnityQuestionsAnswered", addToQuoteMobileLimit: "addToQuoteMobileLimit", addToQuoteDesktopLimit: "addToQuoteDesktopLimit" }, decls: 8, vars: 3, consts: [[1, "row"], [1, "text-left", "my-2"], ["class", "Spa_Style_H4 Spa_Style_Primary", 4, "liveEditProp"], [1, "col-12", "py-3", "nudge-wrapper", "Spa_Style_Banner_Background"], ["class", "Spa_Style_Primary_Color", 3, "innerHTML", 4, "liveEditProp"], [1, "d-flex", "flex-row", "justify-content-end", "mt-3"], ["type", "button", 1, "btn", "btn-block", "shop-button", "Spa_Style_PrimaryButton", "px-1", 3, "click"], [1, "Spa_Style_H4", "Spa_Style_Primary"], [1, "Spa_Style_Primary_Color", 3, "innerHTML"]], template: function HospitalIndemnityCoverageCartNudgeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtemplate(2, HospitalIndemnityCoverageCartNudgeComponent_h2_2_Template, 2, 1, "h2", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, HospitalIndemnityCoverageCartNudgeComponent_div_4_Template, 2, 4, "div", 4);
        i0.ɵɵelementStart(5, "div", 5)(6, "button", 6);
        i0.ɵɵlistener("click", function HospitalIndemnityCoverageCartNudgeComponent_Template_button_click_6_listener() { return ctx.onClickInformationNudge(); });
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_ShoppingCart_HIP_CallOut_Title");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_ShoppingCart_HIP_CallOut_Instructional");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.cartCallOutButtonText, " ");
    } }, dependencies: [LiveEditPropDirective, SafePipe], styles: [".nudge-wrapper[_ngcontent-%COMP%]{border-radius:5px}@media (min-width: 320px){.shop-button[_ngcontent-%COMP%]{width:100%}}@media (min-width: 768px){.shop-button[_ngcontent-%COMP%]{width:40%}}@media (min-width: 1024px){.shop-button[_ngcontent-%COMP%]{width:32%}}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HospitalIndemnityCoverageCartNudgeComponent, [{
        type: Component,
        args: [{ selector: 'vnext-hospital-indemnity-coverage-cart-nudge', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row\">\r\n  <div class=\"text-left my-2\">\r\n    <h2 class=\"Spa_Style_H4 Spa_Style_Primary\" *liveEditProp=\"'Spa_ShoppingCart_HIP_CallOut_Title'\">\r\n      {{shoppingCartHIPCallOutTitle }}\r\n    </h2>\r\n  </div>\r\n\r\n  <div class=\"col-12 py-3 nudge-wrapper Spa_Style_Banner_Background\">\r\n    <div class=\"Spa_Style_Primary_Color\" *liveEditProp=\"'Spa_ShoppingCart_HIP_CallOut_Instructional'\"\r\n      [innerHTML]=\"shoppingCartHIPCallOutInstructional | safe: 'html'\">\r\n    </div>\r\n    <div class=\"d-flex flex-row justify-content-end mt-3\">\r\n      <button type=\"button\" (click)=\"onClickInformationNudge()\"\r\n        class=\"btn btn-block shop-button Spa_Style_PrimaryButton px-1\">\r\n        {{ cartCallOutButtonText }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".nudge-wrapper{border-radius:5px}@media (min-width: 320px){.shop-button{width:100%}}@media (min-width: 768px){.shop-button{width:40%}}@media (min-width: 1024px){.shop-button{width:32%}}\n"] }]
    }], function () { return [{ type: i0.Injector }, { type: i1$1.NgbModal }, { type: AnalyticsService }, { type: i1.ResponsiveLayoutService }, { type: ConfigurableWidgetService }, { type: PlanListFacadeService }, { type: i1.PlansService }, { type: PlanCompareFacade }, { type: i2.Store }]; }, { shoppingCartHIPCallOutTitle: [{
            type: Input
        }], shoppingCartHIPCallOutInstructional: [{
            type: Input
        }], cartCallOutButtonText: [{
            type: Input
        }], rateFactorModalTitle: [{
            type: Input
        }], rateFactorFormPromptText: [{
            type: Input
        }], rateFactorFormPageTitleText: [{
            type: Input
        }], errorKeywordText: [{
            type: Input
        }], errorNoticeTitle: [{
            type: Input
        }], dropdownDefaultText: [{
            type: Input
        }], enrollingPlan: [{
            type: Input
        }], areAllHospitalIndemnityQuestionsAnswered: [{
            type: Input
        }], addToQuoteMobileLimit: [{
            type: Input
        }], addToQuoteDesktopLimit: [{
            type: Input
        }] }); })();

const _c0$x = function (a0) { return { "margin-bottom": a0 }; };
function MiniCartPlanRiderComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(2, _c0$x, ctx_r0.showEnrollmentViewDetails ? "0px" : "20px"));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.planRiderWithTotalPremium.rider.riderCategoryHeader, "\n");
} }
function MiniCartPlanRiderComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "vnext-link", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r1.enrollmentViewDetailsText)("alwaysUnderlined", true)("tag", ctx_r1.planDetailsTag);
} }
class MiniCartPlanRiderComponent {
    constructor() {
        this.planDetailsTag = PageTags.PLAN_DETAILS;
    }
}
MiniCartPlanRiderComponent.ɵfac = function MiniCartPlanRiderComponent_Factory(t) { return new (t || MiniCartPlanRiderComponent)(); };
MiniCartPlanRiderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MiniCartPlanRiderComponent, selectors: [["vnext-widget-mini-cart-plan-rider"]], inputs: { planRiderWithTotalPremium: "planRiderWithTotalPremium", showEnrollmentViewDetails: "showEnrollmentViewDetails", enrollmentViewDetailsText: "enrollmentViewDetailsText" }, decls: 8, vars: 6, consts: [[1, "row", "item-header-row"], [1, "col-12", "Spa_Style_H4", "text-break", "no-translate-block"], ["class", "Spa_Style_Paragraph", 3, "ngStyle", 4, "ngIf"], ["class", "details-link-container", 4, "ngIf"], [1, "text-right", "Spa_Style_CostPremiumSmall", "total-premium"], [1, "Spa_Style_Paragraph", 3, "ngStyle"], [1, "details-link-container"], [3, "title", "alwaysUnderlined", "tag"]], template: function MiniCartPlanRiderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "h3", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(3, MiniCartPlanRiderComponent_div_3_Template, 2, 4, "div", 2);
        i0.ɵɵtemplate(4, MiniCartPlanRiderComponent_div_4_Template, 2, 3, "div", 3);
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵtext(6);
        i0.ɵɵpipe(7, "currency");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.planRiderWithTotalPremium == null ? null : ctx.planRiderWithTotalPremium.rider.planName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.planRiderWithTotalPremium == null ? null : ctx.planRiderWithTotalPremium.rider.riderCategoryHeader);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showEnrollmentViewDetails);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 4, ctx.planRiderWithTotalPremium == null ? null : ctx.planRiderWithTotalPremium.totalPremium));
    } }, dependencies: [i1$2.NgIf, i1$2.NgStyle, LinkComponent, i1$2.CurrencyPipe], styles: [".row[_ngcontent-%COMP%]{border-top:1px solid var(--static-Spa_Style_Accent1)}.item-header-row[_ngcontent-%COMP%]{padding-top:8px}.item-header-row[_ngcontent-%COMP%] > .currency[_ngcontent-%COMP%]{text-align:right}.details-link-container[_ngcontent-%COMP%]{padding-top:8px;padding-bottom:15px}.Spa_Style_CostPremiumSmall[_ngcontent-%COMP%]{padding-left:0}.total-premium[_ngcontent-%COMP%]{padding:8px 0}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MiniCartPlanRiderComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-mini-cart-plan-rider', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row item-header-row\">\r\n  <h3 class=\"col-12 Spa_Style_H4 text-break no-translate-block\">{{ planRiderWithTotalPremium?.rider.planName }}</h3>\r\n</div>\r\n\r\n<div\r\n  *ngIf=\"planRiderWithTotalPremium?.rider.riderCategoryHeader\"\r\n  class=\"Spa_Style_Paragraph\"\r\n  [ngStyle]=\"{ 'margin-bottom': showEnrollmentViewDetails ? '0px' : '20px' }\"\r\n>\r\n  {{ planRiderWithTotalPremium.rider.riderCategoryHeader }}\r\n</div>\r\n\r\n<div *ngIf=\"showEnrollmentViewDetails\" class=\"details-link-container\">\r\n  <vnext-link [title]=\"enrollmentViewDetailsText\" [alwaysUnderlined]=\"true\" [tag]=\"planDetailsTag\"></vnext-link>\r\n</div>\r\n\r\n<div class=\"text-right Spa_Style_CostPremiumSmall total-premium\">{{ planRiderWithTotalPremium?.totalPremium | currency }}</div>\r\n", styles: [".row{border-top:1px solid var(--static-Spa_Style_Accent1)}.item-header-row{padding-top:8px}.item-header-row>.currency{text-align:right}.details-link-container{padding-top:8px;padding-bottom:15px}.Spa_Style_CostPremiumSmall{padding-left:0}.total-premium{padding:8px 0}\n"] }]
    }], null, { planRiderWithTotalPremium: [{
            type: Input
        }], showEnrollmentViewDetails: [{
            type: Input
        }], enrollmentViewDetailsText: [{
            type: Input
        }] }); })();

const _c0$w = ["benefitsForHIPPopover"];
function MiniCartPlanCardComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function MiniCartPlanCardComponent_ng_template_1_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "vnext-plan-logo", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("alternateText", ctx_r7.plan.logo2Description)("imageSrc", ctx_r7.planLogoUrl)("classNames", "img-row plan-logo")("planLogoSize", ctx_r7.planLogoSize);
} }
function MiniCartPlanCardComponent_ng_template_1_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-link", 14);
    i0.ɵɵlistener("click", function MiniCartPlanCardComponent_ng_template_1_div_7_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r14.onViewPlanDetails(ctx_r14.plan)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r8.enrollmentViewDetailsText)("alwaysUnderlined", true);
} }
function MiniCartPlanCardComponent_ng_template_1_div_8_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 19);
    i0.ɵɵelementStart(3, "span", 20);
    i0.ɵɵtext(4, "Expand");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r17.benefitsSelectionText);
} }
function MiniCartPlanCardComponent_ng_template_1_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 15, 16);
    i0.ɵɵlistener("click", function MiniCartPlanCardComponent_ng_template_1_div_8_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r18.onShowHospitalIndemnityBenefits(ctx_r18.plan)); })("keyup.enter", function MiniCartPlanCardComponent_ng_template_1_div_8_Template_button_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r19); const ctx_r20 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r20.onShowHospitalIndemnityBenefits(ctx_r20.plan)); });
    i0.ɵɵtemplate(3, MiniCartPlanCardComponent_ng_template_1_div_8_span_3_Template, 5, 1, "span", 17);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    const _r5 = i0.ɵɵreference(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("placement", ctx_r9.isMobile ? "bottom-left" : "bottom-right")("autoClose", "outside")("ngbPopover", _r5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_ShoppingCart_BenefitsSelection_Text");
} }
function MiniCartPlanCardComponent_ng_template_1_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r10.planTotalPremium), " ");
} }
function MiniCartPlanCardComponent_ng_template_1_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-plan-fees-tooltip", 22);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("planFees", ctx_r12.plan.fees)("planTotalPremium", ctx_r12.planTotalPremium)("planFeesTooltipText", ctx_r12.planFeesTooltipText)("planFeesIncludedInPremiumTooltipText", ctx_r12.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r12.planFeesNotIncludedInPremiumTooltipText)("customClass", "stacked-content pb-2")("tooltipCustomClass", "stacked-content");
} }
function MiniCartPlanCardComponent_ng_template_1_ng_container_12_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-widget-mini-cart-plan-rider", 24);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const planRiderWithTotalPremium_r22 = ctx.$implicit;
    const ctx_r21 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("planRiderWithTotalPremium", planRiderWithTotalPremium_r22)("showEnrollmentViewDetails", ctx_r21.showEnrollmentViewDetails)("enrollmentViewDetailsText", ctx_r21.enrollmentViewDetailsText);
} }
function MiniCartPlanCardComponent_ng_template_1_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MiniCartPlanCardComponent_ng_template_1_ng_container_12_ng_container_1_Template, 2, 3, "ng-container", 23);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r13.planRidersWithTotalPremium)("ngForTrackBy", ctx_r13.trackByRiderId);
} }
function MiniCartPlanCardComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, MiniCartPlanCardComponent_ng_template_1_div_0_Template, 2, 4, "div", 4);
    i0.ɵɵelementStart(1, "div", 5)(2, "h3", 6);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 7);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 8);
    i0.ɵɵtemplate(7, MiniCartPlanCardComponent_ng_template_1_div_7_Template, 2, 2, "div", 9);
    i0.ɵɵtemplate(8, MiniCartPlanCardComponent_ng_template_1_div_8_Template, 4, 4, "div", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, MiniCartPlanCardComponent_ng_template_1_div_9_Template, 3, 3, "div", 10);
    i0.ɵɵtemplate(10, MiniCartPlanCardComponent_ng_template_1_ng_template_10_Template, 1, 7, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(12, MiniCartPlanCardComponent_ng_template_1_ng_container_12_Template, 2, 2, "ng-container", 9);
} if (rf & 2) {
    const _r11 = i0.ɵɵreference(11);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r2.planLogoUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.plan.planName, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.planDescription, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.showDetailsLink);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.showHIPBenefits && ctx_r2.plan.planTypeAbbreviation === ctx_r2.planTypeAbbreviation.HC);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.planFeesEnabled || !(ctx_r2.plan.fees == null ? null : ctx_r2.plan.fees.length))("ngIfElse", _r11);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r2.showPremiumAsAnnual);
} }
function MiniCartPlanCardComponent_ng_template_3_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelement(1, "vnext-plan-logo", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("alternateText", ctx_r23.plan.logo2Description)("imageSrc", ctx_r23.planLogoUrl)("classNames", "img-row plan-logo")("planLogoSize", ctx_r23.planLogoSize);
} }
function MiniCartPlanCardComponent_ng_template_3_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30)(1, "vnext-link", 14);
    i0.ɵɵlistener("click", function MiniCartPlanCardComponent_ng_template_3_div_6_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r30.onViewPlanDetails(ctx_r30.plan)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r24.enrollmentViewDetailsText)("alwaysUnderlined", true);
} }
function MiniCartPlanCardComponent_ng_template_3_div_7_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 19);
    i0.ɵɵelementStart(3, "span", 20);
    i0.ɵɵtext(4, "Expand");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r33.benefitsSelectionText);
} }
function MiniCartPlanCardComponent_ng_template_3_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "button", 15, 16);
    i0.ɵɵlistener("click", function MiniCartPlanCardComponent_ng_template_3_div_7_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r34.onShowHospitalIndemnityBenefits(ctx_r34.plan)); })("keyup.enter", function MiniCartPlanCardComponent_ng_template_3_div_7_Template_button_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r35); const ctx_r36 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r36.onShowHospitalIndemnityBenefits(ctx_r36.plan)); });
    i0.ɵɵtemplate(3, MiniCartPlanCardComponent_ng_template_3_div_7_span_3_Template, 5, 1, "span", 17);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    const _r5 = i0.ɵɵreference(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("placement", ctx_r25.isMobile ? "bottom-left" : "bottom-right")("autoClose", "outside")("ngbPopover", _r5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_ShoppingCart_BenefitsSelection_Text");
} }
function MiniCartPlanCardComponent_ng_template_3_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r26.planTotalPremium), " ");
} }
function MiniCartPlanCardComponent_ng_template_3_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-plan-fees-tooltip", 22);
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("planFees", ctx_r28.plan.fees)("planTotalPremium", ctx_r28.planTotalPremium)("planFeesTooltipText", ctx_r28.planFeesTooltipText)("planFeesIncludedInPremiumTooltipText", ctx_r28.planFeesIncludedInPremiumTooltipText)("planFeesNotIncludedInPremiumTooltipText", ctx_r28.planFeesNotIncludedInPremiumTooltipText)("customClass", "stacked-content pb-2")("tooltipCustomClass", "stacked-content");
} }
function MiniCartPlanCardComponent_ng_template_3_ng_container_11_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-widget-mini-cart-plan-rider", 24);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const planRiderWithTotalPremium_r38 = ctx.$implicit;
    const ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("planRiderWithTotalPremium", planRiderWithTotalPremium_r38)("showEnrollmentViewDetails", ctx_r37.showEnrollmentViewDetails)("enrollmentViewDetailsText", ctx_r37.enrollmentViewDetailsText);
} }
function MiniCartPlanCardComponent_ng_template_3_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MiniCartPlanCardComponent_ng_template_3_ng_container_11_ng_container_1_Template, 2, 3, "ng-container", 23);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r29.planRidersWithTotalPremium)("ngForTrackBy", ctx_r29.trackByRiderId);
} }
const _c1$5 = function (a0) { return { "margin-bottom": a0 }; };
function MiniCartPlanCardComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, MiniCartPlanCardComponent_ng_template_3_div_0_Template, 2, 4, "div", 25);
    i0.ɵɵelementStart(1, "div", 5)(2, "h3", 26);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 27);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, MiniCartPlanCardComponent_ng_template_3_div_6_Template, 2, 2, "div", 28);
    i0.ɵɵtemplate(7, MiniCartPlanCardComponent_ng_template_3_div_7_Template, 4, 4, "div", 9);
    i0.ɵɵtemplate(8, MiniCartPlanCardComponent_ng_template_3_div_8_Template, 3, 3, "div", 10);
    i0.ɵɵtemplate(9, MiniCartPlanCardComponent_ng_template_3_ng_template_9_Template, 1, 7, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(11, MiniCartPlanCardComponent_ng_template_3_ng_container_11_Template, 2, 2, "ng-container", 9);
} if (rf & 2) {
    const _r27 = i0.ɵɵreference(10);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r4.planLogoUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.planDescription, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(9, _c1$5, ctx_r4.showEnrollmentViewDetails ? "0px" : "20px"));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r4.plan.planName, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.showDetailsLink);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.showHIPBenefits && ctx_r4.plan.planTypeAbbreviation === ctx_r4.planTypeAbbreviation.HC);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.planFeesEnabled || !(ctx_r4.plan.fees == null ? null : ctx_r4.plan.fees.length))("ngIfElse", _r27);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r4.showPremiumAsAnnual);
} }
function MiniCartPlanCardComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-benefits-display", 31);
    i0.ɵɵlistener("closeButtonAction", function MiniCartPlanCardComponent_ng_template_5_Template_vnext_benefits_display_closeButtonAction_0_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r40.onCloseHospitalIndemnityBenefitsPopover()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const benefitsData_r39 = ctx.selectedBenefitDetails;
    i0.ɵɵproperty("benefitsData", benefitsData_r39);
} }
class MiniCartPlanCardComponent {
    constructor(planFacade, riderFacade) {
        this.planFacade = planFacade;
        this.riderFacade = riderFacade;
        this.viewPlanDetails = new EventEmitter();
        this.showHospitalIndemnityBenefits = new EventEmitter();
        this.closeHospitalIndemnityBenefitsPopover = new EventEmitter();
        this.planDetailsTag = PageTags.PLAN_DETAILS;
        this.planTypeAbbreviation = PlanTypeAbbreviation;
        this.planTotalPremium = 0;
        this.planLogoUrl = '';
        this.planDescription = '';
        this.planRidersWithTotalPremium = [];
    }
    ngOnChanges(changes) {
        const { plan, sortedRiders, widgetName } = changes;
        if ((plan && !_isEqual(plan.previousValue, plan.currentValue)) ||
            (widgetName && widgetName.previousValue !== widgetName.currentValue)) {
            if (this.plan) {
                this.planTotalPremium = this.getTotalPremium([this.plan]);
                this.planDescription = this.getPlanDescription(this.plan, this.widgetName);
                if (this.showPlanLogo) {
                    this.planLogoUrl = this.getPlanLogo(this.plan);
                }
            }
        }
        if ((plan && !_isEqual(plan.previousValue, plan.currentValue)) ||
            (sortedRiders && !_isEqual(sortedRiders.previousValue, sortedRiders.currentValue))) {
            if (this.plan && this.sortedRiders?.length) {
                this.planRidersWithTotalPremium = this.getPlanRidersWithTotalPremium(this.plan.id, this.sortedRiders);
            }
        }
    }
    getTotalPremium(plans, riders) {
        return this.planFacade.getTotalPremium(plans, riders);
    }
    getPlanDescription(plan, widgetName) {
        return this.planFacade.getPlanDescription(plan, widgetName);
    }
    getPlanLogo(plan) {
        return this.planFacade.getPlanLogoUrl(plan);
    }
    getRiderPremium(rider) {
        return this.riderFacade.getRiderMedicalPremium(rider);
    }
    getPlanRidersWithTotalPremium(planId, riders) {
        return riders.reduce((selectedRiders, rider) => {
            if (this.isRiderSelectedForPlan(planId, rider.planID)) {
                selectedRiders.push({ rider, totalPremium: this.getRiderPremium(rider) });
            }
            return selectedRiders;
        }, []);
    }
    isRiderSelectedForPlan(planId, riderId) {
        const selectedRiderIds = this.riderFacade.selectedPlanRiderIds(planId);
        return selectedRiderIds && selectedRiderIds.includes(riderId);
    }
    onViewPlanDetails(plan) {
        this.viewPlanDetails.emit(plan);
    }
    onShowHospitalIndemnityBenefits(plan) {
        this.showHospitalIndemnityBenefits.emit({ plan, benefitsPopover: this.benefitsForHIPPopover });
    }
    onCloseHospitalIndemnityBenefitsPopover() {
        this.closeHospitalIndemnityBenefitsPopover.emit(this.benefitsForHIPPopover);
    }
    trackByRiderId(index, planRiderWithTotalPremium) {
        return planRiderWithTotalPremium.rider.planID;
    }
}
MiniCartPlanCardComponent.ɵfac = function MiniCartPlanCardComponent_Factory(t) { return new (t || MiniCartPlanCardComponent)(i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(RiderFacade)); };
MiniCartPlanCardComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MiniCartPlanCardComponent, selectors: [["vnext-widget-mini-cart-plan-card"]], viewQuery: function MiniCartPlanCardComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$w, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.benefitsForHIPPopover = _t.first);
    } }, inputs: { plan: "plan", widgetName: "widgetName", showOldTemplate: "showOldTemplate", sortedRiders: "sortedRiders", isMobile: "isMobile", showPlanLogo: "showPlanLogo", planLogoSize: "planLogoSize", showDetailsLink: "showDetailsLink", showHIPBenefits: "showHIPBenefits", benefitsSelectionText: "benefitsSelectionText", showPremiumAsAnnual: "showPremiumAsAnnual", showEnrollmentViewDetails: "showEnrollmentViewDetails", enrollmentViewDetailsText: "enrollmentViewDetailsText", planFeesEnabled: "planFeesEnabled", planFeesTooltipText: "planFeesTooltipText", planFeesIncludedInPremiumTooltipText: "planFeesIncludedInPremiumTooltipText", planFeesNotIncludedInPremiumTooltipText: "planFeesNotIncludedInPremiumTooltipText" }, outputs: { viewPlanDetails: "viewPlanDetails", showHospitalIndemnityBenefits: "showHospitalIndemnityBenefits", closeHospitalIndemnityBenefitsPopover: "closeHospitalIndemnityBenefitsPopover" }, features: [i0.ɵɵNgOnChangesFeature], decls: 7, vars: 3, consts: [[4, "ngIf", "ngIfThen", "ngIfElse"], ["basicTemplate", ""], ["oldTemplate", ""], ["benefitsForHIPPopoverTemplate", ""], ["class", "pl-3 py-2 row", 4, "ngIf"], [1, "row", "item-header-row"], [1, "col-12", "Spa_Style_H4", "no-translate-block"], [1, "Spa_Style_Paragraph"], [1, "details-link-container", "new-template"], [4, "ngIf"], ["class", "text-right Spa_Style_CostPremiumSmall total-premium", 4, "ngIf", "ngIfElse"], ["showPremiumWithFees", ""], [1, "pl-3", "py-2", "row"], [3, "alternateText", "imageSrc", "classNames", "planLogoSize"], [3, "title", "alwaysUnderlined", "click"], ["type", "button", "triggers", "manual", "popoverClass", "hip-benefits-popover", 1, "pr-2", "can-click", "action-button", "Spa_Style_Link", "d-inline", "view-benefits-button", 3, "placement", "autoClose", "ngbPopover", "click", "keyup.enter"], ["benefitsForHIPPopover", "ngbPopover"], ["class", "underline", 4, "liveEditProp"], [1, "underline"], [1, "ml-1", "fas", "fa-chevron-down"], [1, "sr-only"], [1, "text-right", "Spa_Style_CostPremiumSmall", "total-premium"], [3, "planFees", "planTotalPremium", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "customClass", "tooltipCustomClass"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "planRiderWithTotalPremium", "showEnrollmentViewDetails", "enrollmentViewDetailsText"], ["class", "row", 4, "ngIf"], [1, "col-12", "Spa_Style_H4"], [1, "Spa_Style_Paragraph", "no-translate-block", 3, "ngStyle"], ["class", "details-link-container", 4, "ngIf"], [1, "row"], [1, "details-link-container"], [3, "benefitsData", "closeButtonAction"]], template: function MiniCartPlanCardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MiniCartPlanCardComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        i0.ɵɵtemplate(1, MiniCartPlanCardComponent_ng_template_1_Template, 13, 8, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(3, MiniCartPlanCardComponent_ng_template_3_Template, 12, 11, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(5, MiniCartPlanCardComponent_ng_template_5_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        const _r3 = i0.ɵɵreference(4);
        i0.ɵɵproperty("ngIf", !ctx.showOldTemplate)("ngIfThen", _r1)("ngIfElse", _r3);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, i1$2.NgStyle, LinkComponent, LiveEditPropDirective, IconAriaAttributesDirective, i1$1.NgbPopover, MiniCartPlanRiderComponent, PlanFeesTooltipComponent, BenefitsDisplayComponent, PlanLogoComponent, i1$2.CurrencyPipe], styles: [".row[_ngcontent-%COMP%]{border-top:1px solid var(--static-Spa_Style_Accent1)}.img-row[_ngcontent-%COMP%]{margin:10px 15px}.item-header-row[_ngcontent-%COMP%]{padding-top:8px}.item-header-row[_ngcontent-%COMP%] > .currency[_ngcontent-%COMP%]{text-align:right}.details-link-container[_ngcontent-%COMP%]{padding-top:8px;padding-bottom:15px}.details-link-container.new-template[_ngcontent-%COMP%]{margin-top:20px}.link[_ngcontent-%COMP%], .underline[_ngcontent-%COMP%]{text-decoration:underline}.Spa_Style_CostPremiumSmall[_ngcontent-%COMP%]{padding-left:0}.view-benefits-button[_ngcontent-%COMP%]{margin-top:24px}.total-premium[_ngcontent-%COMP%]{padding:8px 0}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MiniCartPlanCardComponent, [{
        type: Component,
        args: [{ selector: 'vnext-widget-mini-cart-plan-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<!-- \r\n  We needed significant minicart updates for the 2023 plan year, but without making those changes for 2022.\r\n  So we have two different templates. We will ideally remove the old template after every site is off 2022, if possible.\r\n-->\r\n<ng-container *ngIf=\"!showOldTemplate; then basicTemplate; else oldTemplate\"></ng-container>\r\n\r\n<ng-template #basicTemplate>\r\n  <div class=\"pl-3 py-2 row\" *ngIf=\"planLogoUrl\">\r\n    <vnext-plan-logo\r\n      [alternateText]=\"plan.logo2Description\"\r\n      [imageSrc]=\"planLogoUrl\"\r\n      [classNames]=\"'img-row plan-logo'\"\r\n      [planLogoSize]=\"planLogoSize\"\r\n    ></vnext-plan-logo>\r\n  </div>\r\n  <div class=\"row item-header-row\">\r\n    <h3 class=\"col-12 Spa_Style_H4 no-translate-block\">\r\n      {{ plan.planName }}\r\n    </h3>\r\n  </div>\r\n  <div class=\"Spa_Style_Paragraph\">\r\n    {{ planDescription }}\r\n  </div>\r\n  <div class=\"details-link-container new-template\">\r\n    <div *ngIf=\"showDetailsLink\">\r\n      <vnext-link [title]=\"enrollmentViewDetailsText\" [alwaysUnderlined]=\"true\" (click)=\"onViewPlanDetails(plan)\"></vnext-link>\r\n    </div>\r\n    <div *ngIf=\"showHIPBenefits && plan.planTypeAbbreviation === planTypeAbbreviation.HC\">\r\n      <button\r\n        type=\"button\"\r\n        class=\"pr-2 can-click action-button Spa_Style_Link d-inline view-benefits-button\"\r\n        (click)=\"onShowHospitalIndemnityBenefits(plan)\"\r\n        (keyup.enter)=\"onShowHospitalIndemnityBenefits(plan)\"\r\n        [placement]=\"isMobile ? 'bottom-left' : 'bottom-right'\"\r\n        triggers=\"manual\"\r\n        [autoClose]=\"'outside'\"\r\n        [ngbPopover]=\"benefitsForHIPPopoverTemplate\"\r\n        #benefitsForHIPPopover=\"ngbPopover\"\r\n        popoverClass=\"hip-benefits-popover\"\r\n      >\r\n        <span class=\"underline\" *liveEditProp=\"'Spa_ShoppingCart_BenefitsSelection_Text'\"\r\n          >{{ benefitsSelectionText }}<i class=\"ml-1 fas fa-chevron-down\"></i\r\n        ><span class=\"sr-only\">Expand</span></span>\r\n      </button>\r\n    </div>\r\n  </div>\r\n  <div *ngIf=\"!planFeesEnabled || !plan.fees?.length; else showPremiumWithFees\" class=\"text-right Spa_Style_CostPremiumSmall total-premium\">\r\n    {{ planTotalPremium | currency }}\r\n  </div>\r\n\r\n  <ng-template #showPremiumWithFees>\r\n    <vnext-widget-plan-fees-tooltip\r\n      [planFees]=\"plan.fees\"\r\n      [planTotalPremium]=\"planTotalPremium\"\r\n      [planFeesTooltipText]=\"planFeesTooltipText\"\r\n      [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n      [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n      [customClass]=\"'stacked-content pb-2'\"\r\n      [tooltipCustomClass]=\"'stacked-content'\"\r\n    ></vnext-widget-plan-fees-tooltip>\r\n  </ng-template>\r\n\r\n  <ng-container *ngIf=\"!showPremiumAsAnnual\">\r\n    <ng-container *ngFor=\"let planRiderWithTotalPremium of planRidersWithTotalPremium; trackBy: trackByRiderId\">\r\n      <vnext-widget-mini-cart-plan-rider\r\n        [planRiderWithTotalPremium]=\"planRiderWithTotalPremium\"\r\n        [showEnrollmentViewDetails]=\"showEnrollmentViewDetails\"\r\n        [enrollmentViewDetailsText]=\"enrollmentViewDetailsText\"\r\n      ></vnext-widget-mini-cart-plan-rider>\r\n    </ng-container>\r\n  </ng-container>\r\n</ng-template>\r\n\r\n<ng-template #oldTemplate>\r\n  <div class=\"row\" *ngIf=\"planLogoUrl\">\r\n    <vnext-plan-logo\r\n      [alternateText]=\"plan.logo2Description\"\r\n      [imageSrc]=\"planLogoUrl\"\r\n      [classNames]=\"'img-row plan-logo'\"\r\n      [planLogoSize]=\"planLogoSize\"\r\n    ></vnext-plan-logo>\r\n  </div>\r\n  <div class=\"row item-header-row\">\r\n    <h3 class=\"col-12 Spa_Style_H4\">\r\n      {{ planDescription }}\r\n    </h3>\r\n  </div>\r\n  <div class=\"Spa_Style_Paragraph no-translate-block\" [ngStyle]=\"{ 'margin-bottom': showEnrollmentViewDetails ? '0px' : '20px' }\">\r\n    {{ plan.planName }}\r\n  </div>\r\n  <div *ngIf=\"showDetailsLink\" class=\"details-link-container\">\r\n    <vnext-link [title]=\"enrollmentViewDetailsText\" [alwaysUnderlined]=\"true\" (click)=\"onViewPlanDetails(plan)\"></vnext-link>\r\n  </div>\r\n  <div *ngIf=\"showHIPBenefits && plan.planTypeAbbreviation === planTypeAbbreviation.HC\">\r\n    <button\r\n      type=\"button\"\r\n      class=\"pr-2 can-click action-button Spa_Style_Link d-inline view-benefits-button\"\r\n      (click)=\"onShowHospitalIndemnityBenefits(plan)\"\r\n      (keyup.enter)=\"onShowHospitalIndemnityBenefits(plan)\"\r\n      [placement]=\"isMobile ? 'bottom-left' : 'bottom-right'\"\r\n      triggers=\"manual\"\r\n      [autoClose]=\"'outside'\"\r\n      [ngbPopover]=\"benefitsForHIPPopoverTemplate\"\r\n      #benefitsForHIPPopover=\"ngbPopover\"\r\n      popoverClass=\"hip-benefits-popover\"\r\n    >\r\n      <span class=\"underline\" *liveEditProp=\"'Spa_ShoppingCart_BenefitsSelection_Text'\"\r\n        >{{ benefitsSelectionText }}<i class=\"ml-1 fas fa-chevron-down\"></i\r\n      ><span class=\"sr-only\">Expand</span></span>\r\n    </button>\r\n  </div>\r\n  <div *ngIf=\"!planFeesEnabled || !plan.fees?.length; else showPremiumWithFees\" class=\"text-right Spa_Style_CostPremiumSmall total-premium\">\r\n    {{ planTotalPremium | currency }}\r\n  </div>\r\n\r\n  <ng-template #showPremiumWithFees>\r\n    <vnext-widget-plan-fees-tooltip\r\n      [planFees]=\"plan.fees\"\r\n      [planTotalPremium]=\"planTotalPremium\"\r\n      [planFeesTooltipText]=\"planFeesTooltipText\"\r\n      [planFeesIncludedInPremiumTooltipText]=\"planFeesIncludedInPremiumTooltipText\"\r\n      [planFeesNotIncludedInPremiumTooltipText]=\"planFeesNotIncludedInPremiumTooltipText\"\r\n      [customClass]=\"'stacked-content pb-2'\"\r\n      [tooltipCustomClass]=\"'stacked-content'\"\r\n    ></vnext-widget-plan-fees-tooltip>\r\n  </ng-template>\r\n\r\n  <ng-container *ngIf=\"!showPremiumAsAnnual\">\r\n    <ng-container *ngFor=\"let planRiderWithTotalPremium of planRidersWithTotalPremium; trackBy: trackByRiderId\">\r\n      <vnext-widget-mini-cart-plan-rider\r\n        [planRiderWithTotalPremium]=\"planRiderWithTotalPremium\"\r\n        [showEnrollmentViewDetails]=\"showEnrollmentViewDetails\"\r\n        [enrollmentViewDetailsText]=\"enrollmentViewDetailsText\"\r\n      ></vnext-widget-mini-cart-plan-rider>\r\n    </ng-container>\r\n  </ng-container>\r\n</ng-template>\r\n\r\n<ng-template #benefitsForHIPPopoverTemplate let-benefitsData=\"selectedBenefitDetails\">\r\n  <vnext-benefits-display\r\n    [benefitsData]=\"benefitsData\"\r\n    (closeButtonAction)=\"onCloseHospitalIndemnityBenefitsPopover()\"\r\n  ></vnext-benefits-display>\r\n</ng-template>\r\n", styles: [".row{border-top:1px solid var(--static-Spa_Style_Accent1)}.img-row{margin:10px 15px}.item-header-row{padding-top:8px}.item-header-row>.currency{text-align:right}.details-link-container{padding-top:8px;padding-bottom:15px}.details-link-container.new-template{margin-top:20px}.link,.underline{text-decoration:underline}.Spa_Style_CostPremiumSmall{padding-left:0}.view-benefits-button{margin-top:24px}.total-premium{padding:8px 0}\n"] }]
    }], function () { return [{ type: PlanFacade }, { type: RiderFacade }]; }, { benefitsForHIPPopover: [{
            type: ViewChild,
            args: ['benefitsForHIPPopover']
        }], plan: [{
            type: Input
        }], widgetName: [{
            type: Input
        }], showOldTemplate: [{
            type: Input
        }], sortedRiders: [{
            type: Input
        }], isMobile: [{
            type: Input
        }], showPlanLogo: [{
            type: Input
        }], planLogoSize: [{
            type: Input
        }], showDetailsLink: [{
            type: Input
        }], showHIPBenefits: [{
            type: Input
        }], benefitsSelectionText: [{
            type: Input
        }], showPremiumAsAnnual: [{
            type: Input
        }], showEnrollmentViewDetails: [{
            type: Input
        }], enrollmentViewDetailsText: [{
            type: Input
        }], planFeesEnabled: [{
            type: Input
        }], planFeesTooltipText: [{
            type: Input
        }], planFeesIncludedInPremiumTooltipText: [{
            type: Input
        }], planFeesNotIncludedInPremiumTooltipText: [{
            type: Input
        }], viewPlanDetails: [{
            type: Output
        }], showHospitalIndemnityBenefits: [{
            type: Output
        }], closeHospitalIndemnityBenefitsPopover: [{
            type: Output
        }] }); })();

function MiniCartComponent_div_2_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "vnext-widget-mini-cart-plan-card", 16);
    i0.ɵɵlistener("viewPlanDetails", function MiniCartComponent_div_2_div_13_Template_vnext_widget_mini_cart_plan_card_viewPlanDetails_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.onViewPlanDetails($event)); })("showHospitalIndemnityBenefits", function MiniCartComponent_div_2_div_13_Template_vnext_widget_mini_cart_plan_card_showHospitalIndemnityBenefits_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r5.onShowHospitalIndemnityBenefits($event)); })("closeHospitalIndemnityBenefitsPopover", function MiniCartComponent_div_2_div_13_Template_vnext_widget_mini_cart_plan_card_closeHospitalIndemnityBenefitsPopover_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r6 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r6.onCloseHospitalIndemnityBenefitsPopover($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const plan_r2 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("plan", plan_r2)("widgetName", ctx_r1.widgetName)("sortedRiders", ctx_r1.sortedRiders)("isMobile", ctx_r1.isMobile)("showPlanLogo", ctx_r1.Spa_Site_Show_PlanLogo)("planLogoSize", ctx_r1.Spa_Site_PlanLogo_Size)("showDetailsLink", ctx_r1.Spa_Enrollment_MiniCartViewDetails_Enabled && ctx_r1.Spa_Site_PlanViewDetails_Enabled)("showHIPBenefits", ctx_r1.Spa_ShoppingCart_ShowHIPBenefits_Enabled)("benefitsSelectionText", ctx_r1.Spa_ShoppingCart_BenefitsSelection_Text)("showPremiumAsAnnual", ctx_r1.Spa_Site_ShowPremiumAsAnnual)("showEnrollmentViewDetails", ctx_r1.Spa_Enrollment_MiniCartViewDetails_Enabled)("enrollmentViewDetailsText", ctx_r1.Spa_Enrollment_ViewDetails_Text)("planFeesEnabled", ctx_r1.Spa_Site_PlanFees_Enabled)("planFeesTooltipText", ctx_r1.Spa_PlanFees_Tooltip_Text)("planFeesIncludedInPremiumTooltipText", ctx_r1.Spa_PlanFees_IncludedInPremium_Tooltip_Text)("planFeesNotIncludedInPremiumTooltipText", ctx_r1.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text);
} }
const _c0$v = function (a0) { return { "rounded-bottom": a0 }; };
const _c1$4 = function (a0, a1) { return { "fa-angle-up": a0, "fa-angle-down": a1 }; };
const _c2$2 = function (a0) { return { "invisible": a0 }; };
function MiniCartComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "h2", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 5);
    i0.ɵɵlistener("click", function MiniCartComponent_div_2_Template_div_click_4_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.toggleCartBody($event)); })("keyup.enter", function MiniCartComponent_div_2_Template_div_keyup_enter_4_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.toggleCartBody($event)); });
    i0.ɵɵelementStart(5, "h2", 4);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 6);
    i0.ɵɵelement(8, "i", 7);
    i0.ɵɵelementStart(9, "span", 8);
    i0.ɵɵtext(10, "Expand/Collapse");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(11, "div", 9)(12, "div", 10);
    i0.ɵɵtemplate(13, MiniCartComponent_div_2_div_13_Template, 2, 16, "div", 11);
    i0.ɵɵelementStart(14, "div", 12)(15, "div", 13)(16, "h3", 14);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "span", 15);
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "currency");
    i0.ɵɵelementEnd()()()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c0$v, !ctx_r0.showCartBody));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.Spa_Enrollment_MiniCart_Header);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c0$v, !ctx_r0.showCartBody));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.Spa_Enrollment_MiniCart_Header);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(17, _c1$4, ctx_r0.showCartBody, !ctx_r0.showCartBody));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("collapsibleList", ctx_r0.showCartBody);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c2$2, ctx_r0.isMobile && !ctx_r0.showCartBody));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.plans)("ngForTrackBy", ctx_r0.trackByPlanId);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r0.totalPremiumLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(20, 11, ctx_r0.totalPremium));
} }
let MiniCartComponent = class MiniCartComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, planFacade, riderFacade, cartFacade, enrollmentFormService, responsiveLayoutService, demographicService, planYearResourceService, localeService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.planFacade = planFacade;
        this.riderFacade = riderFacade;
        this.cartFacade = cartFacade;
        this.enrollmentFormService = enrollmentFormService;
        this.responsiveLayoutService = responsiveLayoutService;
        this.demographicService = demographicService;
        this.planYearResourceService = planYearResourceService;
        this.localeService = localeService;
        this.Spa_Enrollment_MiniCartViewDetails_Enabled = false;
        this.Spa_Enrollment_ViewDetails_Text = 'View details';
        this.Spa_ShoppingCart_BenefitsSelection_Text = 'Benefit selections';
        this.Spa_Enrollment_MiniCart_Header = 'Shopping cart';
        this.Spa_Site_ShowPremiumAsAnnual = false;
        this.Spa_Site_Show_PlanLogo = true;
        this.Spa_Site_PlanViewDetails_Enabled = true;
        this.Spa_Site_PlanLogo_Size = 'small';
        this.Spa_ShoppingCart_IndividualEnrollmentButtons_Enabled = false;
        this.Spa_ShoppingCart_ShowHIPBenefits_Enabled = false;
        this.Spa_Site_PlanFees_Enabled = false;
        this.Spa_PlanFees_Tooltip_Text = 'Fees';
        this.Spa_PlanFees_IncludedInPremium_Tooltip_Text = 'Included in premium';
        this.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text = 'Not included in premium';
        this.showCartBody = true;
        this.plans = [];
        this.isMobile = false;
        this.totalPremiumLabel = '';
        this.totalPremium = 0;
        this.subscriptions = new Subscription();
    }
    toggleCartBody($event) {
        $event.stopPropagation();
        this.showCartBody = !this.showCartBody;
    }
    ngOnInit() {
        super.ngOnInit();
        this.crossSellSortedPlans$ = this.enrollmentFormService.crossSellSortedPlans$(this.Spa_ShoppingCart_IndividualEnrollmentButtons_Enabled ? 1 : undefined);
        this.subscriptions.add(this.responsiveLayoutService.isCompact$.subscribe(isMobile => {
            this.isMobile = isMobile;
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.planYearResourceService.getSelectedPlanYear$().subscribe(selectedPlanYear => {
            this.selectedPlanYear = +selectedPlanYear;
            this.cdr.markForCheck();
        }));
        this.subscriptions.add(this.localeService.getCurrentLocale$().subscribe({
            next: () => {
                this.totalPremiumLabel = this.planFacade.getTotalPremiumLabel();
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(combineLatest([this.crossSellSortedPlans$, this.riderFacade.getSelectedRiders$()]).subscribe({
            next: ([crossSellSortedPlans, selectedRiders]) => {
                this.plans = crossSellSortedPlans;
                this.totalPremium = this.planFacade.getTotalPremium(this.plans, selectedRiders);
                this.cdr.markForCheck();
            }
        }));
        this.subscriptions.add(this.riderFacade
            .getRidersSortedByCategory$()
            .pipe(map(riders => riders.map(rider => ({
            ...rider,
            riderCategoryHeader: this.riderFacade.createRiderCategories([rider], this.demographicService.isWaiverStateAndMedigap(this.riderFacade.getParentPlanOfSelectedRider(rider.planID)))?.[0]?.header
        }))))
            .subscribe({
            next: sortedRiders => {
                this.sortedRiders = sortedRiders;
                this.cdr.markForCheck();
            }
        }));
    }
    onViewPlanDetails(plan) {
        this.cartFacade.viewPlanDetails(plan);
    }
    onShowHospitalIndemnityBenefits(planWithBenefitsPopover) {
        if (planWithBenefitsPopover) {
            const { plan, benefitsPopover } = planWithBenefitsPopover;
            this.cartFacade.showHospitalIndemnityBenefits(plan, benefitsPopover);
        }
    }
    onCloseHospitalIndemnityBenefitsPopover(benefitsPopover) {
        benefitsPopover?.close();
    }
    trackByPlanId(index, plan) {
        return plan.id;
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.subscriptions.unsubscribe();
    }
};
MiniCartComponent.ɵfac = function MiniCartComponent_Factory(t) { return new (t || MiniCartComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(RiderFacade), i0.ɵɵdirectiveInject(CartFacade), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService), i0.ɵɵdirectiveInject(i1.DemographicService), i0.ɵɵdirectiveInject(i1.PlanYearResourceService), i0.ɵɵdirectiveInject(i1.LocaleService)); };
MiniCartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MiniCartComponent, selectors: [["vnext-mini-cart"]], viewQuery: function MiniCartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(MiniCartPlanCardComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.miniCartPlanCardComponent = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 1, consts: [[1, "pl-3", "pr-3", "pl-md-2", "pr-md-2"], ["class", "container-fluid mini-cart-wrapper", 4, "ngIf"], [1, "container-fluid", "mini-cart-wrapper"], [1, "row", "mini-cart-header", "d-none", "d-md-block", 3, "ngClass"], [1, "Spa_Style_H4"], ["role", "button", "tabindex", "0", 1, "row", "mini-cart-header", "d-md-none", 3, "ngClass", "click", "keyup.enter"], [1, "px-4", "toggle-cart-button", "d-md-none"], [1, "fa", 3, "ngClass"], [1, "sr-only"], [1, "animation-container", 3, "collapsibleList"], [1, "list-item-container", 3, "ngClass"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "row", "item-header-row", "total-premium", "rounded-bottom", "Spa_Style_Cost_Background"], [1, "col-12", "text-right"], [1, "Spa_Style_Paragraph", "Spa_Style_Bold_Weight"], [1, "Spa_Style_CostPremiumSmall", "ml-2"], [3, "plan", "widgetName", "sortedRiders", "isMobile", "showPlanLogo", "planLogoSize", "showDetailsLink", "showHIPBenefits", "benefitsSelectionText", "showPremiumAsAnnual", "showEnrollmentViewDetails", "enrollmentViewDetailsText", "planFeesEnabled", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "viewPlanDetails", "showHospitalIndemnityBenefits", "closeHospitalIndemnityBenefitsPopover"]], template: function MiniCartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵelementStart(1, "div", 0);
        i0.ɵɵtemplate(2, MiniCartComponent_div_2_Template, 21, 22, "div", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.plans == null ? null : ctx.plans.length);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, IconAriaAttributesDirective, CollapsibleListAnimationDirective, MiniCartPlanCardComponent, i1$2.CurrencyPipe], styles: [".row[_ngcontent-%COMP%]{border-top:1px solid var(--static-Spa_Style_Accent1)}.mini-cart-wrapper[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px;margin-top:20px;background-color:#fff}.mini-cart-header[_ngcontent-%COMP%]{font-family:montserrat_bold;background-color:var(--static-Spa_Style_Gray1);border-top:none;padding-left:15px;padding-top:5px;padding-bottom:5px;justify-content:space-between;border-top-left-radius:5px;border-top-right-radius:5px}.toggle-cart-button[_ngcontent-%COMP%]{cursor:pointer}.item-header-row[_ngcontent-%COMP%]{padding-top:8px}.item-header-row[_ngcontent-%COMP%] > .currency[_ngcontent-%COMP%]{text-align:right}.total-premium[_ngcontent-%COMP%]{padding:8px 0}.rounded-bottom[_ngcontent-%COMP%]{border-bottom-left-radius:5px;border-bottom-right-radius:5px}@media (min-width: 768px){.animation-container[_ngcontent-%COMP%]{opacity:1!important;height:initial!important}}.Spa_Style_CostPremiumSmall[_ngcontent-%COMP%]{padding-left:0}.view-benefits-button[_ngcontent-%COMP%]{margin-top:24px}"], data: { animation: [collapsibleList] }, changeDetection: 0 });
__decorate([
    PlatformProp()
], MiniCartComponent.prototype, "Spa_Enrollment_MiniCartViewDetails_Enabled", void 0);
__decorate([
    PlatformProp('live-edit')
], MiniCartComponent.prototype, "Spa_Enrollment_ViewDetails_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], MiniCartComponent.prototype, "Spa_ShoppingCart_BenefitsSelection_Text", void 0);
__decorate([
    GlobalResource()
], MiniCartComponent.prototype, "Spa_Enrollment_MiniCart_Header", void 0);
__decorate([
    GlobalResource()
], MiniCartComponent.prototype, "Spa_Site_ShowPremiumAsAnnual", void 0);
__decorate([
    GlobalResource()
], MiniCartComponent.prototype, "Spa_Site_Show_PlanLogo", void 0);
__decorate([
    GlobalResource()
], MiniCartComponent.prototype, "Spa_Site_PlanViewDetails_Enabled", void 0);
__decorate([
    GlobalResource()
], MiniCartComponent.prototype, "Spa_Site_PlanLogo_Size", void 0);
__decorate([
    GlobalResource()
], MiniCartComponent.prototype, "Spa_ShoppingCart_IndividualEnrollmentButtons_Enabled", void 0);
__decorate([
    GlobalResource()
], MiniCartComponent.prototype, "Spa_ShoppingCart_ShowHIPBenefits_Enabled", void 0);
__decorate([
    GlobalResource()
], MiniCartComponent.prototype, "Spa_Site_PlanFees_Enabled", void 0);
__decorate([
    GlobalResource()
], MiniCartComponent.prototype, "Spa_PlanFees_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], MiniCartComponent.prototype, "Spa_PlanFees_IncludedInPremium_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], MiniCartComponent.prototype, "Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text", void 0);
__decorate([
    LiveEditInactive()
], MiniCartComponent.prototype, "onViewPlanDetails", null);
MiniCartComponent = __decorate([
    PlatformWidget
], MiniCartComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MiniCartComponent, [{
        type: Component,
        args: [{ selector: 'vnext-mini-cart', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], animations: [collapsibleList], template: "<ng-container>\r\n  <div class=\"pl-3 pr-3 pl-md-2 pr-md-2\">\r\n    <div *ngIf=\"plans?.length\" class=\"container-fluid mini-cart-wrapper\">\r\n      <div class=\"row mini-cart-header d-none d-md-block\" [ngClass]=\"{ 'rounded-bottom': !showCartBody }\">\r\n        <h2 class=\"Spa_Style_H4\">{{ Spa_Enrollment_MiniCart_Header }}</h2>\r\n      </div>\r\n      <div\r\n        class=\"row mini-cart-header d-md-none\"\r\n        role=\"button\"\r\n        tabindex=\"0\"\r\n        (click)=\"toggleCartBody($event)\"\r\n        (keyup.enter)=\"toggleCartBody($event)\"\r\n        [ngClass]=\"{ 'rounded-bottom': !showCartBody }\"\r\n      >\r\n        <h2 class=\"Spa_Style_H4\">{{ Spa_Enrollment_MiniCart_Header }}</h2>\r\n        <span class=\"px-4 toggle-cart-button d-md-none\">\r\n          <i class=\"fa\" [ngClass]=\"{ 'fa-angle-up': showCartBody, 'fa-angle-down': !showCartBody }\"></i>\r\n          <span class=\"sr-only\">Expand/Collapse</span>\r\n        </span>\r\n      </div>\r\n\r\n      <div [collapsibleList]=\"showCartBody\" class=\"animation-container\">\r\n        <div [ngClass]=\"{ 'invisible': isMobile && !showCartBody }\" class=\"list-item-container\">\r\n          <div *ngFor=\"let plan of plans; trackBy: trackByPlanId\">\r\n            <vnext-widget-mini-cart-plan-card\r\n              [plan]=\"plan\"\r\n              [widgetName]=\"widgetName\"\r\n              [sortedRiders]=\"sortedRiders\"\r\n              [isMobile]=\"isMobile\"\r\n              [showPlanLogo]=\"Spa_Site_Show_PlanLogo\"\r\n              [planLogoSize]=\"Spa_Site_PlanLogo_Size\"\r\n              [showDetailsLink]=\"Spa_Enrollment_MiniCartViewDetails_Enabled && Spa_Site_PlanViewDetails_Enabled\"\r\n              [showHIPBenefits]=\"Spa_ShoppingCart_ShowHIPBenefits_Enabled\"\r\n              [benefitsSelectionText]=\"Spa_ShoppingCart_BenefitsSelection_Text\"\r\n              [showPremiumAsAnnual]=\"Spa_Site_ShowPremiumAsAnnual\"\r\n              [showEnrollmentViewDetails]=\"Spa_Enrollment_MiniCartViewDetails_Enabled\"\r\n              [enrollmentViewDetailsText]=\"Spa_Enrollment_ViewDetails_Text\"\r\n              [planFeesEnabled]=\"Spa_Site_PlanFees_Enabled\"\r\n              [planFeesTooltipText]=\"Spa_PlanFees_Tooltip_Text\"\r\n              [planFeesIncludedInPremiumTooltipText]=\"Spa_PlanFees_IncludedInPremium_Tooltip_Text\"\r\n              [planFeesNotIncludedInPremiumTooltipText]=\"Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text\"\r\n              (viewPlanDetails)=\"onViewPlanDetails($event)\"\r\n              (showHospitalIndemnityBenefits)=\"onShowHospitalIndemnityBenefits($event)\"\r\n              (closeHospitalIndemnityBenefitsPopover)=\"onCloseHospitalIndemnityBenefitsPopover($event)\"\r\n            ></vnext-widget-mini-cart-plan-card>\r\n          </div>\r\n\r\n          <div class=\"row item-header-row total-premium rounded-bottom Spa_Style_Cost_Background\">\r\n            <div class=\"col-12 text-right\">\r\n              <h3 class=\"Spa_Style_Paragraph Spa_Style_Bold_Weight\">{{ totalPremiumLabel }}</h3>\r\n              <span class=\"Spa_Style_CostPremiumSmall ml-2\">{{ totalPremium | currency }}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <!-- end of collapsed area-->\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n", styles: [".row{border-top:1px solid var(--static-Spa_Style_Accent1)}.mini-cart-wrapper{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px;margin-top:20px;background-color:#fff}.mini-cart-header{font-family:montserrat_bold;background-color:var(--static-Spa_Style_Gray1);border-top:none;padding-left:15px;padding-top:5px;padding-bottom:5px;justify-content:space-between;border-top-left-radius:5px;border-top-right-radius:5px}.toggle-cart-button{cursor:pointer}.item-header-row{padding-top:8px}.item-header-row>.currency{text-align:right}.total-premium{padding:8px 0}.rounded-bottom{border-bottom-left-radius:5px;border-bottom-right-radius:5px}@media (min-width: 768px){.animation-container{opacity:1!important;height:initial!important}}.Spa_Style_CostPremiumSmall{padding-left:0}.view-benefits-button{margin-top:24px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: PlanFacade }, { type: RiderFacade }, { type: CartFacade }, { type: i1.EnrollmentFormService }, { type: i1.ResponsiveLayoutService }, { type: i1.DemographicService }, { type: i1.PlanYearResourceService }, { type: i1.LocaleService }]; }, { miniCartPlanCardComponent: [{
            type: ViewChild,
            args: [MiniCartPlanCardComponent]
        }], Spa_Enrollment_MiniCartViewDetails_Enabled: [], Spa_Enrollment_ViewDetails_Text: [], Spa_ShoppingCart_BenefitsSelection_Text: [], Spa_Enrollment_MiniCart_Header: [], Spa_Site_ShowPremiumAsAnnual: [], Spa_Site_Show_PlanLogo: [], Spa_Site_PlanViewDetails_Enabled: [], Spa_Site_PlanLogo_Size: [], Spa_ShoppingCart_IndividualEnrollmentButtons_Enabled: [], Spa_ShoppingCart_ShowHIPBenefits_Enabled: [], Spa_Site_PlanFees_Enabled: [], Spa_PlanFees_Tooltip_Text: [], Spa_PlanFees_IncludedInPremium_Tooltip_Text: [], Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text: [], onViewPlanDetails: [] }); })();

const _c0$u = ["benefitsForHIPPopover"];
function ShoppingCartComponent_div_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_div_0_vnext_link_1_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 30);
    i0.ɵɵlistener("click", function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_div_0_vnext_link_1_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r24.backToPlanList()); })("keyup.enter", function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_div_0_vnext_link_1_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r25); const ctx_r26 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r26.backToPlanList()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("title", ctx_r23.Spa_Enrollment_Plans_Not_Available_Go_Back_Text)("showArrow", "left")("role", ctx_r23.linkRoles.BUTTON)("ariaLabel", ctx_r23.Spa_Enrollment_Plans_Not_Available_Go_Back_Text);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtemplate(1, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_div_0_vnext_link_1_Template, 1, 4, "vnext-link", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_ShoppingCart_BackToPlansLink_Enabled");
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_h1_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 31);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r13.Spa_ShoppingCart_MyCart_Text);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 32);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHtml", ctx_r14.Spa_Site_PageSubHeader_Text ? i0.ɵɵpipeBind2(1, 1, ctx_r14.Spa_Site_PageSubHeader_Text, "html") : "", i0.ɵɵsanitizeHtml);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_vnext_shopping_cart_cross_sell_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-shopping-cart-cross-sell", 33);
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("bundlePlansPrompt", ctx_r15.crossSellAttributes.bundlePlansPrompt)("marketingMessage", ctx_r15.crossSellAttributes.marketingMessage)("shopButton", ctx_r15.crossSellAttributes.shopButton)("shopAction", ctx_r15.crossSellAttributes.shopAction);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_vnext_notice_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-notice", 34);
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("title", ctx_r16.sendEnrollmentFacade.getRestrictProfessionalPlansNoticeTitle())("messages", ctx_r16.sendEnrollmentFacade.getRestrictProfessionalPlansNoticeMessage())("warningCustomClass", "mb-0");
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_vnext_notice_7_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-notice", 35);
    i0.ɵɵlistener("applyEvent", function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_vnext_notice_7_Template_vnext_notice_applyEvent_0_listener() { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r27.navigateToMemberProfilePage()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("type", "warn")("warningCustomClass", "mb-0")("buttonCustomClass", "float-right align-middle")("hasButton", ctx_r17.Spa_Site_CheckSOACompleted_ShowGoToProfileButton_Enabled)("buttonText", ctx_r17.Spa_Site_GoToProfile_Label)("title", ctx_r17.Spa_Site_SOA_NotComplete_Title)("messages", ctx_r17.soaNotCompletedMessages);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelement(1, "vnext-hospital-indemnity-coverage-cart-nudge", 37);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("shoppingCartHIPCallOutTitle", ctx_r18.Spa_ShoppingCart_HIP_CallOut_Title)("shoppingCartHIPCallOutInstructional", ctx_r18.Spa_ShoppingCart_HIP_CallOut_Instructional)("cartCallOutButtonText", ctx_r18.Spa_ShoppingCart_HIP_CallOut_Button_Text)("rateFactorModalTitle", ctx_r18.Spa_PlanDetails_HIP_RateFactorModal_Title)("rateFactorFormPromptText", ctx_r18.Spa_PlanList_HIPFormPrompt_Text)("rateFactorFormPageTitleText", ctx_r18.Spa_PlanList_HIP_PageTitle_Text)("errorKeywordText", ctx_r18.Spa_Site_ErrorKeyword_Text)("errorNoticeTitle", ctx_r18.Spa_Site_EnrollmentErrorNotice_Title)("dropdownDefaultText", ctx_r18.Spa_PlanList_MedSupFormDropdownDefault_Text)("enrollingPlan", ctx_r18.enrollingPlan)("areAllHospitalIndemnityQuestionsAnswered", ctx_r18.areAllHospitalIndemnityQuestionsAnswered)("addToQuoteMobileLimit", ctx_r18.Spa_PlanList_AddToQuote_Limit_Mobile)("addToQuoteDesktopLimit", ctx_r18.Spa_PlanList_AddToQuote_Limit);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 61);
    i0.ɵɵelement(1, "i", 62);
    i0.ɵɵelementStart(2, "span", 63);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r43.Spa_ShoppingCart_PlanRiderConflict_Text);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 58)(1, "h2", 59);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_3_div_3_Template, 4, 1, "div", 60);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r29 = i0.ɵɵnextContext().$implicit;
    const ctx_r30 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r30.plansConfig[plan_r29.id] == null ? null : ctx_r30.plansConfig[plan_r29.id].planDescription, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r30.Spa_ShoppingCart_PlanRiderConflict_Enabled && !!(ctx_r30.planRiderConflicts[plan_r29.id] == null ? null : ctx_r30.planRiderConflicts[plan_r29.id].length));
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 64);
    i0.ɵɵelement(1, "vnext-plan-logo", 65);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r29 = i0.ɵɵnextContext().$implicit;
    const ctx_r31 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("alternateText", plan_r29.planName)("imageSrc", ctx_r31.getPlanLogo(plan_r29))("classNames", "plan-logo")("planLogoSize", ctx_r31.Spa_Site_PlanLogo_Size);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_h3_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 66);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r29 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", plan_r29.planName, " ");
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵelement(1, "i", 68)(2, "span", 69);
    i0.ɵɵpipe(3, "safe");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(3, 1, ctx_r33.getPcpWarningText(), "html"), i0.ɵɵsanitizeHtml);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 70);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r34.Spa_ShoppingCart_RequestedStartDate_Text, ": ", i0.ɵɵpipeBind1(2, 2, ctx_r34.getFormattedEffectiveDate$()), " ");
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_container_17_ng_container_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 74);
    i0.ɵɵelementStart(3, "span", 75);
    i0.ɵɵtext(4, "Expand");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r50 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r50.Spa_ShoppingCart_BenefitsSelection_Text);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_container_17_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r53 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 72, 73);
    i0.ɵɵlistener("click", function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_container_17_ng_container_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r53); const plan_r29 = i0.ɵɵnextContext(2).$implicit; const ctx_r51 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r51.showHospitalIndemnityBenefits(plan_r29)); })("keyup.enter", function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_container_17_ng_container_1_Template_button_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r53); const plan_r29 = i0.ɵɵnextContext(2).$implicit; const ctx_r54 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r54.showHospitalIndemnityBenefits(plan_r29)); });
    i0.ɵɵtemplate(3, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_container_17_ng_container_1_span_3_Template, 5, 1, "span", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(6);
    const _r3 = i0.ɵɵreference(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("autoClose", "outside")("ngbPopover", _r3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_ShoppingCart_BenefitsSelection_Text");
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_container_17_vnext_link_2_Template(rf, ctx) { if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 76);
    i0.ɵɵlistener("click", function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_container_17_vnext_link_2_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r58); const plan_r29 = i0.ɵɵnextContext(2).$implicit; const ctx_r56 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r56.viewPlanDetails(plan_r29)); })("keyup.enter", function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_container_17_vnext_link_2_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r58); const plan_r29 = i0.ɵɵnextContext(2).$implicit; const ctx_r59 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r59.viewPlanDetails(plan_r29)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r29 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r48 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", plan_r29.planTypeAbbreviation === ctx_r48.planTypeAbbreviation.HC ? "px-2" : "pr-2")("title", ctx_r48.Spa_ShoppingCart_ViewDetails_Text)("ariaDescribedByText", "viewDetailsDescriptionText")("keyNameForLiveEdit", "Spa_ShoppingCart_ViewDetails_Text")("role", ctx_r48.linkRoles.BUTTON)("ariaLabel", ctx_r48.Spa_ShoppingCart_ViewDetails_Text);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_container_17_ng_container_1_Template, 4, 3, "ng-container", 5);
    i0.ɵɵtemplate(2, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_container_17_vnext_link_2_Template, 1, 6, "vnext-link", 71);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const plan_r29 = i0.ɵɵnextContext().$implicit;
    const ctx_r35 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", plan_r29.planTypeAbbreviation === ctx_r35.planTypeAbbreviation.HC);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.Spa_ShoppingCart_ViewDetails_Enabled);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_span_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r36.Spa_ShoppingCart_RemovePlan_Text, "");
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_21_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 83);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r63 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r63.premiumLabel, " ");
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_21_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "currency");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const plan_r29 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r64 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, (ctx_r64.plansConfig[plan_r29.id] == null ? null : ctx_r64.plansConfig[plan_r29.id].planTotalPremium) || 0), " ");
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_21_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-widget-plan-fees-tooltip", 84);
} if (rf & 2) {
    const plan_r29 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r66 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("planFees", plan_r29.fees)("planTotalPremium", (ctx_r66.plansConfig[plan_r29.id] == null ? null : ctx_r66.plansConfig[plan_r29.id].planTotalPremium) || 0)("planFeesTooltipText", ctx_r66.Spa_PlanFees_Tooltip_Text)("planFeesIncludedInPremiumTooltipText", ctx_r66.Spa_PlanFees_IncludedInPremium_Tooltip_Text)("planFeesNotIncludedInPremiumTooltipText", ctx_r66.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text)("customClass", "inline-block-layout")("tooltipCustomClass", "inline-block-layout");
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_21_div_6_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r71 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r71.Spa_ShoppingCart_BasedOnBenefits_Text);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_21_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 85);
    i0.ɵɵtemplate(1, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_21_div_6_span_1_Template, 2, 1, "span", 52);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_ShoppingCart_BasedOnBenefits_Text");
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_21_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-call-recording-icon", 86);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r68 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isMobile", ctx_r68.isMobile)("agentCallInProgressAcceptCallIcon", ctx_r68.Spa_AgentCallInProgressAcceptCall_Icon)("agentCallRecordingPlanAllowsCallRecordingText", ctx_r68.Spa_Site_AgentCallRecording_PlanAllowsCallRecording_Text);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 77);
    i0.ɵɵtemplate(1, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_21_div_1_Template, 2, 1, "div", 78);
    i0.ɵɵelementStart(2, "div", 79);
    i0.ɵɵtemplate(3, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_21_ng_container_3_Template, 3, 3, "ng-container", 80);
    i0.ɵɵtemplate(4, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_21_ng_template_4_Template, 1, 7, "ng-template", null, 81, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_21_div_6_Template, 2, 1, "div", 82);
    i0.ɵɵtemplate(7, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_21_ng_container_7_Template, 2, 3, "ng-container", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r65 = i0.ɵɵreference(5);
    const plan_r29 = i0.ɵɵnextContext().$implicit;
    const ctx_r37 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_MonthlyPremiumLabel");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r37.Spa_Site_PlanFees_Enabled || !(plan_r29.fees == null ? null : plan_r29.fees.length))("ngIfElse", _r65);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", plan_r29.planTypeAbbreviation === ctx_r37.planTypeAbbreviation.HC);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r37.showIndividualContinueButtons && (ctx_r37.plansConfig[plan_r29.id] == null ? null : ctx_r37.plansConfig[plan_r29.id].allowsCallRecording));
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_vnext_cart_rider_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-cart-rider", 87);
} if (rf & 2) {
    const plan_r29 = i0.ɵɵnextContext().$implicit;
    const ctx_r38 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("plan", plan_r29)("riders", plan_r29.riders)("hideDetailsText", ctx_r38.Spa_ShoppingCart_HideDetails_Text)("showDetailsText", ctx_r38.Spa_ShoppingCart_ShowDetails_Text)("replaceText", ctx_r38.Spa_ShoppingCart_Replace_Text)("addText", ctx_r38.Spa_ShoppingCart_Add_Text)("includedText", ctx_r38.Spa_ShoppingCart_IncludedRider_Text)("addOnRidersHeader", ctx_r38.Spa_ShoppingCart_AddOnRiders_Header)("viewDetailsLabelText", ctx_r38.Spa_Site_ViewDetailsLink_Description_Text)("hideDetailsLabelText", ctx_r38.Spa_Site_HideDetailsLink_Description_Text)("removePlanText", ctx_r38.Spa_ShoppingCart_RemovePlan_Text)("planRiderConflictMessageEnabled", ctx_r38.Spa_ShoppingCart_PlanRiderConflict_Enabled)("planRiderConflictMessageText", ctx_r38.Spa_ShoppingCart_PlanRiderConflict_Text);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_23_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r79 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 91)(1, "vnext-agent-form-selection", 92);
    i0.ɵɵlistener("userFormType", function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_23_div_1_Template_vnext_agent_form_selection_userFormType_1_listener($event) { i0.ɵɵrestoreView(_r79); const plan_r29 = i0.ɵɵnextContext(2).$implicit; const ctx_r77 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r77.updateUserFormType($event, plan_r29.id)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const plan_r29 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r74 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("labelText", ctx_r74.Spa_ShoppingCart_UserForm_Option_Title)("consumerText", ctx_r74.Spa_ShoppingCart_ConsumerOption_Text)("consumerFormDefault", ctx_r74.Spa_ShoppingCart_ConsumerOption_Default)("brokerFormDefault", ctx_r74.Spa_ShoppingCart_BrokerOption_Default)("brokerText", ctx_r74.Spa_ShoppingCart_BrokerOption_Text)("plan", plan_r29)("errorKeyword", ctx_r74.Spa_Site_ErrorKeyword_Text)("errorText", ctx_r74.Spa_ShoppingCart_ConsumerBroker_Error_Text);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_23_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-existing-member-cart", 93);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const plan_r29 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r75 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("yesText", ctx_r75.Spa_Site_Yes)("noText", ctx_r75.Spa_Site_No)("titleText", ctx_r75.Spa_ShoppingCart_ExistingMember_Title)("bodyText", ctx_r75.Spa_ShoppingCart_ExistingMember_Body)("fullWidth", ctx_r75.showConsumerBrokerSelection(ctx_r75.enrollingPlan))("planId", plan_r29.id);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_23_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 88);
    i0.ɵɵtemplate(1, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_23_div_1_Template, 2, 8, "div", 89);
    i0.ɵɵelementStart(2, "div", 90);
    i0.ɵɵtemplate(3, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_23_ng_container_3_Template, 2, 6, "ng-container", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_23_ng_container_4_Template, 1, 0, "ng-container", 56);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r29 = i0.ɵɵnextContext().$implicit;
    const _r41 = i0.ɵɵreference(26);
    const ctx_r39 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r39.plansConfig[plan_r29.id] == null ? null : ctx_r39.plansConfig[plan_r29.id].showConsumerBrokerSelection);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r39.plansConfig[plan_r29.id] == null ? null : ctx_r39.plansConfig[plan_r29.id].isPlanWithShortForm);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r39.plansConfig[plan_r29.id] == null ? null : ctx_r39.plansConfig[plan_r29.id].shouldAlignCartButton)("ngIfThen", _r41);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_container_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_template_25_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 96)(2, "div", 97);
    i0.ɵɵelement(3, "i", 98);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 99);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const plan_r29 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r84 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", ctx_r84.Spa_EnrollmentConfirmation_ApplicationSubmitted_Title, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", ctx_r84.Spa_EnrollmentConfirmation_Title, " #", ctx_r84.confirmationNumberMap[plan_r29.id], " ");
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_template_25_div_0_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 104);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r29 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r87 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", ctx_r87.Spa_Site_LastVisitedOn_Text, " ", ctx_r87.lastAccessedDates[plan_r29.id], " ");
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_template_25_div_0_ng_container_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 105);
    i0.ɵɵelement(2, "vnext-call-recording-icon", 86);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r88 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("isMobile", ctx_r88.isMobile)("agentCallInProgressAcceptCallIcon", ctx_r88.Spa_AgentCallInProgressAcceptCall_Icon)("agentCallRecordingPlanAllowsCallRecordingText", ctx_r88.Spa_Site_AgentCallRecording_PlanAllowsCallRecording_Text);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_template_25_div_0_ng_container_2_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r90 = i0.ɵɵnextContext(8);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r90.enrollFacade.getShoppingCartApplyButtonText());
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_template_25_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r93 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_template_25_div_0_ng_container_2_div_1_Template, 2, 2, "div", 100);
    i0.ɵɵelementStart(2, "div", 101);
    i0.ɵɵtemplate(3, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_template_25_div_0_ng_container_2_ng_container_3_Template, 3, 3, "ng-container", 5);
    i0.ɵɵelementStart(4, "div", 26)(5, "button", 102, 103);
    i0.ɵɵlistener("click", function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_template_25_div_0_ng_container_2_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r93); const _r89 = i0.ɵɵreference(6); const plan_r29 = i0.ɵɵnextContext(3).$implicit; const ctx_r92 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r92.onContinueToApply(_r89, plan_r29.id)); })("blur", function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_template_25_div_0_ng_container_2_Template_button_blur_5_listener() { i0.ɵɵrestoreView(_r93); const _r89 = i0.ɵɵreference(6); const ctx_r95 = i0.ɵɵnextContext(7); return i0.ɵɵresetView(ctx_r95.cartFacade.closeTooltip(_r89)); });
    i0.ɵɵtemplate(7, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_template_25_div_0_ng_container_2_span_7_Template, 2, 1, "span", 52);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const plan_r29 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r85 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r85.lastAccessedDates[plan_r29.id]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r85.plansConfig[plan_r29.id] == null ? null : ctx_r85.plansConfig[plan_r29.id].allowsCallRecording);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngbTooltip", ctx_r85.Spa_Site_EnrollerButton_Tooltip_Text);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_ShoppingCart_ApplyButton_Text");
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_template_25_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 95);
    i0.ɵɵtemplate(1, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_template_25_div_0_ng_container_1_Template, 7, 3, "ng-container", 5);
    i0.ɵɵtemplate(2, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_template_25_div_0_ng_container_2_Template, 8, 4, "ng-container", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r29 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r83 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", !(ctx_r83.plansConfig[plan_r29.id] == null ? null : ctx_r83.plansConfig[plan_r29.id].shouldAlignCartButton) ? "mb-3" : "col-lg-3 pt-4 pt-lg-0 px-0 ml-auto");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r83.enrolledPlanIds == null ? null : ctx_r83.enrolledPlanIds.includes(plan_r29.id));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r83.Spa_Enrollment_Allow_AlreadyEnrolled_Plans || !(ctx_r83.enrolledPlanIds == null ? null : ctx_r83.enrolledPlanIds.includes(plan_r29.id)));
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_template_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_template_25_div_0_Template, 3, 3, "div", 94);
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("ngIf", ctx_r42.showIndividualContinueButtons);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r99 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 38)(2, "div", 39);
    i0.ɵɵtemplate(3, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_3_Template, 4, 2, "div", 40);
    i0.ɵɵelementStart(4, "div", 41)(5, "div", 20);
    i0.ɵɵtemplate(6, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_6_Template, 2, 4, "div", 42);
    i0.ɵɵelementStart(7, "div", 43);
    i0.ɵɵtemplate(8, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_h3_8_Template, 2, 1, "h3", 44);
    i0.ɵɵtemplate(9, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_9_Template, 4, 4, "div", 45);
    i0.ɵɵtemplate(10, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_10_Template, 3, 4, "div", 46);
    i0.ɵɵpipe(11, "async");
    i0.ɵɵelementStart(12, "div", 47)(13, "p", 48);
    i0.ɵɵtext(14);
    i0.ɵɵelementStart(15, "span", 49);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(17, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_container_17_Template, 3, 2, "ng-container", 5);
    i0.ɵɵelementStart(18, "vnext-link", 50);
    i0.ɵɵlistener("click", function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_Template_vnext_link_click_18_listener() { const restoredCtx = i0.ɵɵrestoreView(_r99); const plan_r29 = restoredCtx.$implicit; const ctx_r98 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r98.changePlanInCart(plan_r29)); })("keyup.enter", function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_Template_vnext_link_keyup_enter_18_listener() { const restoredCtx = i0.ɵɵrestoreView(_r99); const plan_r29 = restoredCtx.$implicit; const ctx_r100 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r100.changePlanInCart(plan_r29)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "button", 51);
    i0.ɵɵlistener("click", function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_Template_button_click_19_listener() { const restoredCtx = i0.ɵɵrestoreView(_r99); const plan_r29 = restoredCtx.$implicit; const ctx_r101 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r101.removeFromCart(plan_r29)); });
    i0.ɵɵtemplate(20, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_span_20_Template, 2, 1, "span", 52);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(21, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_21_Template, 8, 5, "div", 53);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(22, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_vnext_cart_rider_22_Template, 1, 13, "vnext-cart-rider", 54);
    i0.ɵɵtemplate(23, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_div_23_Template, 5, 4, "div", 55);
    i0.ɵɵtemplate(24, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_container_24_Template, 1, 0, "ng-container", 56);
    i0.ɵɵtemplate(25, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_ng_template_25_Template, 1, 1, "ng-template", null, 57, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const plan_r29 = ctx.$implicit;
    const _r41 = i0.ɵɵreference(26);
    const ctx_r19 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r19.Spa_ShoppingCart_PlanType_Enabled);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r19.Spa_Site_Show_PlanLogo && ctx_r19.getPlanLogo(plan_r29));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r19.Spa_ShoppingCart_PlanName_Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.planIdsWithInvalidPCP.includes(plan_r29.id));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.Spa_ShoppingCart_RequestedStartDate_Enabled && (ctx_r19.plansConfig[plan_r29.id] == null ? null : ctx_r19.plansConfig[plan_r29.id].isPlanTypeAncillaryOrMedigap) && !!i0.ɵɵpipeBind1(11, 20, ctx_r19.effectiveDate$));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r19.Spa_Site_ViewDetailsLink_Description_Text, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(plan_r29.planName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.Spa_Site_PlanViewDetails_Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r19.Spa_ShoppingCart_ChangePlan_Text)("keyNameForLiveEdit", "Spa_ShoppingCart_ChangePlan_Text")("role", ctx_r19.linkRoles.BUTTON)("ariaLabel", ctx_r19.Spa_ShoppingCart_ChangePlan_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r19.Spa_ShoppingCart_RemovePlan_Text);
    i0.ɵɵattribute("aria-label", ctx_r19.Spa_ShoppingCart_RemovePlan_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_ShoppingCart_RemovePlan_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.Spa_ShoppingCart_PlanPremium_Enabled);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r19.Spa_Site_ShowPremiumAsAnnual && plan_r29.planTypeAbbreviation !== ctx_r19.planTypeAbbreviation.HC && (plan_r29.riders == null ? null : plan_r29.riders.length));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r19.plansConfig[plan_r29.id] == null ? null : ctx_r19.plansConfig[plan_r29.id].showConsumerBrokerSelection) || (ctx_r19.plansConfig[plan_r29.id] == null ? null : ctx_r19.plansConfig[plan_r29.id].isPlanWithShortForm));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(ctx_r19.plansConfig[plan_r29.id] == null ? null : ctx_r19.plansConfig[plan_r29.id].shouldAlignCartButton))("ngIfThen", _r41);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r103 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 106)(1, "div", 107)(2, "vnext-inner-text-link", 108);
    i0.ɵɵlistener("innerTextClicked", function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_div_11_Template_vnext_inner_text_link_innerTextClicked_2_listener() { i0.ɵɵrestoreView(_r103); const ctx_r102 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r102.clearShoppingCart()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("outerText", ctx_r20.Spa_ShoppingCart_ClearCart_Text)("innerText", ctx_r20.Spa_ShoppingCart_ClearCartClickable_Text)("customClass", "Spa_Style_Regular_Font Spa_Style_Primary_Link_Color Spa_Style_Link")("role", ctx_r20.linkRoles.BUTTON)("ariaLabel", ctx_r20.Spa_ShoppingCart_ClearCartClickable_Text);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_vnext_link_20_Template(rf, ctx) { if (rf & 1) {
    const _r105 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 109);
    i0.ɵɵlistener("click", function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_vnext_link_20_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r105); const ctx_r104 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r104.backToPrevious()); })("keyup.enter", function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_vnext_link_20_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r105); const ctx_r106 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r106.backToPrevious()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("title", ctx_r21.Spa_Site_Previous)("showArrow", "left")("customClass", "Spa_Style_Link p-1")("makeInlineBlock", true)("role", ctx_r21.linkRoles.BUTTON)("ariaLabel", ctx_r21.Spa_Site_Previous);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_button_22_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r108 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r108.enrollFacade.getShoppingCartApplyButtonText());
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_button_22_Template(rf, ctx) { if (rf & 1) {
    const _r110 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 102, 103);
    i0.ɵɵlistener("click", function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_button_22_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r110); const _r107 = i0.ɵɵreference(1); const ctx_r109 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r109.onContinueToApply(_r107)); })("blur", function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_button_22_Template_button_blur_0_listener() { i0.ɵɵrestoreView(_r110); const _r107 = i0.ɵɵreference(1); const ctx_r111 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r111.cartFacade.closeTooltip(_r107)); });
    i0.ɵɵtemplate(2, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_button_22_span_2_Template, 2, 1, "span", 52);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngbTooltip", ctx_r22.Spa_Site_EnrollerButton_Tooltip_Text);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_ShoppingCart_ApplyButton_Text");
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_div_0_Template, 2, 1, "div", 9);
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵtemplate(2, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_h1_2_Template, 2, 1, "h1", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 12);
    i0.ɵɵtemplate(4, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_div_4_Template, 2, 4, "div", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_vnext_shopping_cart_cross_sell_5_Template, 1, 4, "vnext-shopping-cart-cross-sell", 14);
    i0.ɵɵtemplate(6, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_vnext_notice_6_Template, 1, 3, "vnext-notice", 15);
    i0.ɵɵtemplate(7, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_vnext_notice_7_Template, 1, 7, "vnext-notice", 16);
    i0.ɵɵtemplate(8, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_div_8_Template, 2, 13, "div", 17);
    i0.ɵɵtemplate(9, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_ng_container_9_Template, 27, 22, "ng-container", 18);
    i0.ɵɵpipe(10, "orderBy");
    i0.ɵɵtemplate(11, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_div_11_Template, 3, 5, "div", 19);
    i0.ɵɵelementStart(12, "div", 20)(13, "div", 21);
    i0.ɵɵelement(14, "vnext-total-premium-banner", 22);
    i0.ɵɵpipe(15, "async");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 20)(17, "div", 21)(18, "vnext-navigation-banner", 23)(19, "div", 24);
    i0.ɵɵtemplate(20, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_vnext_link_20_Template, 1, 6, "vnext-link", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 26);
    i0.ɵɵtemplate(22, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_button_22_Template, 3, 2, "button", 27);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const plans_r6 = i0.ɵɵnextContext().ngIf;
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r9.Spa_ShoppingCart_BackToPlansLink_Enabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_ShoppingCart_MyCart_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_PageSubHeader_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !!ctx_r9.crossSellAttributes && ctx_r9.showCrossSellOnShoppingCart);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.sendEnrollmentFacade.isPlanRestricted(plans_r6[0]));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.showSOANotCompleted);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.Spa_PlanList_Tab_Show_HIP && ctx_r9.Spa_ShoppingCart_HIP_CallOut_Enabled && ctx_r9.isHIPCallOutAvailableToShoppingCart && ctx_r9.hasHospitalIndemnityQuestions);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(10, 16, plans_r6, ctx_r9.sortOption))("ngForTrackBy", ctx_r9.plansTrackByFn);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r9.Spa_ShoppingCart_ClearCartLink_Enabled && (plans_r6 == null ? null : plans_r6.length));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("plans", plans_r6)("riders", i0.ɵɵpipeBind1(15, 19, ctx_r9.riders$));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("providedPrevious", true)("showPrevious", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_Previous");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r9.showIndividualContinueButtons);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_4_div_0_h3_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 120);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r114 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r114.Spa_ShoppingCart_EmptyCart_Title, " ");
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_4_div_0_ng_container_5_p_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p", 122);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r119 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("innerHtml", ctx_r119.Spa_Site_PageSubHeader_Text ? i0.ɵɵpipeBind2(1, 1, ctx_r119.Spa_Site_PageSubHeader_Text, "html") : "", i0.ɵɵsanitizeHtml);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_4_div_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ShoppingCartComponent_div_1_ng_container_1_ng_template_4_div_0_ng_container_5_p_1_Template, 2, 4, "p", 121);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_PageSubHeader_Text");
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_4_div_0_p_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 123);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r116 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r116.Spa_ShoppingCart_EmptyCart_Message, " ");
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_4_div_0_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r121 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 124);
    i0.ɵɵlistener("click", function ShoppingCartComponent_div_1_ng_container_1_ng_template_4_div_0_button_7_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r121); const ctx_r120 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r120.emptyCartNavToPlans()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r117 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r117.Spa_ShoppingCart_EmptyCartButton_Text, " ");
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_4_div_0_vnext_link_9_Template(rf, ctx) { if (rf & 1) {
    const _r123 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 125);
    i0.ɵɵlistener("click", function ShoppingCartComponent_div_1_ng_container_1_ng_template_4_div_0_vnext_link_9_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r123); const ctx_r122 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r122.configurableWidgetService.navigationService.backToPrevious()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r118 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("title", ctx_r118.Spa_Site_Previous)("showArrow", "left")("role", ctx_r118.linkRoles.BUTTON)("ariaLabel", ctx_r118.Spa_Site_Previous);
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_4_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 111);
    i0.ɵɵelement(1, "i", 112);
    i0.ɵɵelementStart(2, "div", 113);
    i0.ɵɵtemplate(3, ShoppingCartComponent_div_1_ng_container_1_ng_template_4_div_0_h3_3_Template, 2, 1, "h3", 114);
    i0.ɵɵelementStart(4, "div", 115);
    i0.ɵɵtemplate(5, ShoppingCartComponent_div_1_ng_container_1_ng_template_4_div_0_ng_container_5_Template, 2, 1, "ng-container", 5);
    i0.ɵɵtemplate(6, ShoppingCartComponent_div_1_ng_container_1_ng_template_4_div_0_p_6_Template, 2, 1, "p", 116);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, ShoppingCartComponent_div_1_ng_container_1_ng_template_4_div_0_button_7_Template, 2, 1, "button", 117);
    i0.ɵɵelementStart(8, "div", 118);
    i0.ɵɵtemplate(9, ShoppingCartComponent_div_1_ng_container_1_ng_template_4_div_0_vnext_link_9_Template, 1, 4, "vnext-link", 119);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r113 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", "Spa_ShoppingCart_EmptyCart_Title");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r113.Spa_Site_PageSubHeader_Text == null ? null : ctx_r113.Spa_Site_PageSubHeader_Text.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_ShoppingCart_EmptyCart_Message");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_ShoppingCart_EmptyCartButton_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_Previous");
} }
function ShoppingCartComponent_div_1_ng_container_1_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ShoppingCartComponent_div_1_ng_container_1_ng_template_4_div_0_Template, 10, 5, "div", 110);
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r11.showEmptyCart);
} }
function ShoppingCartComponent_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ShoppingCartComponent_div_1_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵtemplate(2, ShoppingCartComponent_div_1_ng_container_1_ng_template_2_Template, 23, 21, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, ShoppingCartComponent_div_1_ng_container_1_ng_template_4_Template, 1, 1, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const plans_r6 = ctx.ngIf;
    const _r8 = i0.ɵɵreference(3);
    const _r10 = i0.ɵɵreference(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", plans_r6.length)("ngIfThen", _r8)("ngIfElse", _r10);
} }
function ShoppingCartComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, ShoppingCartComponent_div_1_ng_container_1_Template, 6, 3, "ng-container", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tagsToUpdate", ctx_r0.tagsToUpdate)("saveDefaultValues", true)("shouldUpdateTags", ctx_r0.shouldUpdateTags);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.selectedPlans);
} }
function ShoppingCartComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r125 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelement(1, "vnext-enrollment-unavailable", 126);
    i0.ɵɵelementStart(2, "div", 118)(3, "vnext-link", 127);
    i0.ɵɵlistener("click", function ShoppingCartComponent_ng_template_2_Template_vnext_link_click_3_listener() { i0.ɵɵrestoreView(_r125); const ctx_r124 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r124.resetStatus()); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r2.Spa_ShoppingCart_EnrollmentUnavailable_Title)("button", ctx_r2.Spa_ShoppingCart_EnrollmentUnavailable_Button)("message", ctx_r2.getEnrollmentUnavailableMessage());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", ctx_r2.Spa_ShoppingCart_PreviousLink_Text)("showArrow", "left")("keyNameForLiveEdit", "Spa_ShoppingCart_PreviousLink_Text");
} }
function ShoppingCartComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r128 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-benefits-display", 128);
    i0.ɵɵlistener("closeButtonAction", function ShoppingCartComponent_ng_template_4_Template_vnext_benefits_display_closeButtonAction_0_listener() { i0.ɵɵrestoreView(_r128); const ctx_r127 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r127.closeHIPBenefitsPopover()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const benefitsData_r126 = ctx.selectedBenefitDetails;
    i0.ɵɵproperty("benefitsData", benefitsData_r126);
} }
let ShoppingCartComponent = class ShoppingCartComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, store, injector, navigationService, shoppingCartService, shoppingCartContextService, demographicService, configResourceService, jsonAnalyticsService, localeService, plansService, spinnerService, cartFacade, planFacade, enrollFacade, sendEnrollmentFacade, crossSellPlanContext, enrollmentFormService, enrollmentConfirmationService, liveEditStateContext, modalService, providerFacade, createAccountContext, agentCallRecordingFacade, loginFacade, analyticsService, planListFacade, soaFacade, responsiveLayoutService, planRiderTypeConflictContextService, twilioService, router, externalEnrollmentContext, siteService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.store = store;
        this.injector = injector;
        this.navigationService = navigationService;
        this.shoppingCartService = shoppingCartService;
        this.shoppingCartContextService = shoppingCartContextService;
        this.demographicService = demographicService;
        this.configResourceService = configResourceService;
        this.jsonAnalyticsService = jsonAnalyticsService;
        this.localeService = localeService;
        this.plansService = plansService;
        this.spinnerService = spinnerService;
        this.cartFacade = cartFacade;
        this.planFacade = planFacade;
        this.enrollFacade = enrollFacade;
        this.sendEnrollmentFacade = sendEnrollmentFacade;
        this.crossSellPlanContext = crossSellPlanContext;
        this.enrollmentFormService = enrollmentFormService;
        this.enrollmentConfirmationService = enrollmentConfirmationService;
        this.liveEditStateContext = liveEditStateContext;
        this.modalService = modalService;
        this.providerFacade = providerFacade;
        this.createAccountContext = createAccountContext;
        this.agentCallRecordingFacade = agentCallRecordingFacade;
        this.loginFacade = loginFacade;
        this.analyticsService = analyticsService;
        this.planListFacade = planListFacade;
        this.soaFacade = soaFacade;
        this.responsiveLayoutService = responsiveLayoutService;
        this.planRiderTypeConflictContextService = planRiderTypeConflictContextService;
        this.twilioService = twilioService;
        this.router = router;
        this.externalEnrollmentContext = externalEnrollmentContext;
        this.siteService = siteService;
        this.Spa_Site_Previous = 'Previous';
        this.Spa_ShoppingCart_ChangePlan_Text = 'Change plan';
        this.Spa_Site_Show_PlanLogo = true;
        this.Spa_ShoppingCart_RequestedStartDate_Enabled = true;
        this.Spa_ShoppingCart_PlanType_Enabled = true;
        this.Spa_ShoppingCart_PlanPremium_Enabled = true;
        this.Spa_ShoppingCart_PlanName_Enabled = true;
        this.Spa_ShoppingCart_MyCart_Text = 'My cart';
        this.Spa_ShoppingCart_RequestedStartDate_Text = 'Requested start date';
        this.Spa_ShoppingCart_ViewDetails_Enabled = true;
        this.Spa_ShoppingCart_ViewDetails_Text = 'View details';
        this.Spa_ShoppingCart_RemovePlan_Text = 'Remove plan';
        this.Spa_Site_Enrollment_Enabled = true;
        this.Spa_Site_MedSupEnrollment_Enabled = true;
        this.Spa_Site_DentalEnrollment_Enabled = true;
        this.Spa_Site_VisionEnrollment_Enabled = true;
        this.Spa_Site_HIPEnrollment_Enabled = true;
        this.Spa_ShoppingCart_ApplyButton_Text = 'Continue to apply';
        this.Spa_Site_ShowPremiumAsAnnual = false;
        this.Spa_ShoppingCart_HideDetails_Text = 'Hide details';
        this.Spa_ShoppingCart_ShowDetails_Text = 'Show details';
        this.Spa_ShoppingCart_Add_Text = 'Add';
        this.Spa_ShoppingCart_Replace_Text = 'Replace';
        this.Spa_ShoppingCart_IncludedRider_Text = 'Included';
        this.SPA_Site_Medigap_Enrollment_InterimPage_Enable = true;
        this.Spa_Enrollment_ShowExistingMemberPromptInCart_Flag = false;
        this.Spa_Site_EnrollerButton_Tooltip_Text = `You don't have permission to take this action.`;
        this.Spa_ShoppingCart_AddOnRiders_Header = 'Optional add-on coverage';
        this.Spa_Site_NotApplicable_Text = 'n/a';
        this.Spa_Site_Yes = 'Yes';
        this.Spa_Site_No = 'No';
        this.Spa_Site_ErrorKeyword_Text = 'Error:';
        this.Spa_Site_EnrollmentErrorNotice_Title = 'Correct the following error(s) on the form, then submit again';
        this.Spa_PlanList_MedSupFormDropdownDefault_Text = 'Select an option';
        this.Spa_ShoppingCart_ConsumerBroker_Error_Text = 'Please select and answer';
        this.Spa_ShoppingCart_UserForm_Option_Title = 'How will you be completing this form?';
        this.Spa_ShoppingCart_ConsumerOption_Text = 'Send to beneficiary to sign and submit';
        this.Spa_ShoppingCart_BrokerOption_Text = 'Complete and submit form myself';
        this.Spa_ShoppingCart_ExistingMember_Title = 'Are you an existing member?';
        this.Spa_ShoppingCart_ConsumerOption_Default = false;
        this.Spa_ShoppingCart_BrokerOption_Default = false;
        this.Spa_Site_EnrollInExternalPlansFirst_Enabled = false;
        this.Spa_ShoppingCart_ExistingMember_Body = 'If so, you will be able to complete a shorter form.';
        this.Spa_Site_ViewDetailsLink_Description_Text = 'Press Enter to view plan details of ';
        this.Spa_Site_HideDetailsLink_Description_Text = 'Press Enter to hide plan details';
        this.Spa_Site_PlanViewDetails_Enabled = true;
        this.Spa_CrossSell_BothPlansExternalModal_Title = 'Attention!';
        this.Spa_CrossSell_BothPlansExternalModal_Close = 'Close';
        this.Spa_CrossSell_BothPlansExternalModal_Message = 'Both plans in your cart require enrollment in an external site. ' +
            'After you enroll in your first plan, you may need to return to your cart on this site to enroll in the next plan.';
        this.Spa_ShoppingCart_PcpWarning_Text = 'is ineligible to be a primary care provider(PCP) for this plan';
        this.Spa_ShoppingCart_EmptyCart_Title = 'Your cart is empty';
        this.Spa_ShoppingCart_EmptyCart_Message = `You currently have no plans in your cart, but it doesn't have to be that way.`;
        this.Spa_ShoppingCart_EmptyCartButton_Text = 'Shop for plans';
        this.Spa_ShoppingCart_MedSupUnavailable_Message = 'Enrollment in Medicare Supplemental plans is not currently available.  Please come back soon to enroll in your plan.';
        this.Spa_ShoppingCart_EnrollmentUnavailable_Message = 'The annual enrollment period opens on October 15th. Please come back at that time to apply for coverage.';
        this.Spa_ShoppingCart_EnrollmentUnavailable_Title = 'Enrollment is not currently available';
        this.Spa_ShoppingCart_EnrollmentUnavailable_Button = 'Continue shopping';
        this.Spa_Site_PCPPlanEligibilityCheck_Enabled = true;
        this.Spa_Site_PCPPlanEligibilityCheck_PlanSubtypeItems = [
            { planSubType: PlanSubTypes.Cost, enabled: true },
            { planSubType: PlanSubTypes.HMO, enabled: true },
            { planSubType: PlanSubTypes.HMOPOS, enabled: true },
            { planSubType: PlanSubTypes.LPPO, enabled: true },
            { planSubType: PlanSubTypes.MSA, enabled: true },
            { planSubType: PlanSubTypes.PFFS, enabled: true },
            { planSubType: PlanSubTypes.PPO, enabled: true },
            { planSubType: PlanSubTypes.RPPO, enabled: true }
        ];
        this.Spa_PlanList_Tab_Show_HIP = false;
        this.Spa_ShoppingCart_HIP_Call_Out_Available_Plan_Types = [
            {
                title: 'Medicare Advantage Prescription Drug',
                enabled: true,
                tabType: PlanTypeAbbreviation.MAPD
            },
            {
                title: 'Medicare Advantage',
                enabled: true,
                tabType: PlanTypeAbbreviation.MA
            },
            {
                title: 'Medicare Supplement',
                enabled: false,
                tabType: PlanTypeAbbreviation.MEDIGAP
            }
        ];
        this.Spa_ShoppingCart_HIP_CallOut_Enabled = false;
        this.Spa_PlanDetails_HIP_RateFactorModal_Title = 'Add on coverage with a Hospital indemnity Plan';
        this.Spa_PlanList_HIPFormPrompt_Text = 'Hospital indemnity plan premiums and eligibility may vary. Please provide the following additional information' +
            ' to calculate your plan premiums and determine if you are eligible for enrollment in the plan.';
        this.Spa_ShoppingCart_HIP_CallOut_Title = 'Add a Hospital Indemnity Plan';
        this.Spa_ShoppingCart_HIP_CallOut_Instructional = 'Hospital Indemnity can help you cover any extra hospital costs that may not be covered in another plan.';
        this.Spa_ShoppingCart_HIP_CallOut_Button_Text = 'Shop Hospital Indemnity plans';
        this.Spa_PlanList_HIP_PageTitle_Text = 'Hospital Indemnity Information';
        this.Spa_ShoppingCart_PreviousLink_Text = 'Back to cart';
        this.Spa_Site_PageSubHeader_Text = '';
        this.Spa_Site_MonthlyPremiumLabel = 'Monthly premium';
        this.Spa_Site_TotalMonthlyPremiumLabel = 'Total monthly premium';
        this.Spa_Site_SOA_NotComplete_Title = 'The Scope of Appointment is not completed for this beneficiary.';
        this.Spa_Site_SOA_NotComplete_Label = 'Send, upload, or print an SOA form or continue with this enrollment.';
        this.Spa_Site_GoToProfile_Label = 'Go to profile';
        this.Spa_Site_CheckSOACompleted_ShowGoToProfileButton_Enabled = true;
        this.Spa_PlanList_AddToQuote_Limit_Mobile = 2;
        this.Spa_PlanList_AddToQuote_Limit = 3;
        this.Spa_Site_PlanLogo_Size = 'small';
        this.Spa_Site_AgentCallRecording_DisplayPlanAllowsCallRecordingIcon_Enabled = false;
        this.Spa_Site_AgentCallRecording_PlanAllowsCallRecording_Text = 'Call recording is available';
        this.Spa_AgentCallInProgressAcceptCall_Icon = 'fas fa-phone';
        this.Spa_ShoppingCart_BenefitsSelection_Text = 'Benefit selections';
        this.Spa_ShoppingCart_BasedOnBenefits_Text = 'Based on benefit selections';
        this.Spa_EnrollmentConfirmation_ApplicationSubmitted_Title = 'Application submitted';
        this.Spa_Site_LastVisitedOn_Text = 'Last visited on';
        this.Spa_ShoppingCart_IndividualEnrollmentButtons_Enabled = false;
        this.Spa_ShoppingCart_ClearCart_Text = 'You may clear the cart if you have completed all enrollments.';
        this.Spa_ShoppingCart_ClearCartClickable_Text = 'clear the cart';
        this.Spa_ShoppingCart_ClearCartLink_Enabled = false;
        this.Spa_EnrollmentConfirmation_Title = 'Confirmation';
        this.Spa_Enrollment_Allow_AlreadyEnrolled_Plans = false;
        this.Spa_ShoppingCart_PlanRiderConflict_Enabled = false;
        this.Spa_ShoppingCart_PlanRiderConflict_Text = 'You already have a plan in the cart that may cover these benefits.';
        this.Spa_ShoppingCart_BackToPlansLink_Enabled = true;
        this.Spa_Enrollment_Plans_Not_Available_Go_Back_Text = 'Back to plans';
        this.Spa_Site_PlanFees_Enabled = false;
        this.Spa_PlanFees_Tooltip_Text = 'Fees';
        this.Spa_PlanFees_IncludedInPremium_Tooltip_Text = 'Included in premium';
        this.Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text = 'Not included in premium';
        this.Spa_EnrollMessageEnrollmentModal_Close = 'Close';
        this.Spa_EnrollMessageEnrollmentModal_Continue = 'Continue';
        this.Spa_DualPlanEnrollMessage_EnrollmentModal_Enabled = false;
        this.Spa_DualPlanEnrollMessage_EnrollmentModalTitle_Text = 'Enrollment of [[DualPlanYear]] plan';
        this.Spa_DualPlanEnrollMessage_EnrollmentModalBody_Text = 'You are enrolling in a [[DualPlanYear]] plan.';
        this.planType = PlanType;
        this.planSettings = [];
        this.showConsumerBrokerFormToggle = false;
        this.plansWithShortForm = [];
        this.planIdsWithInvalidPCP = [];
        this.isHIPCallOutAvailableToShoppingCart = false;
        this.hasHospitalIndemnityQuestions = false;
        this.tagsToUpdate = {};
        this.shouldUpdateTags = false;
        this.showSOANotCompleted = false;
        this.planTypeAbbreviation = PlanTypeAbbreviation;
        this.plansConfig = {};
        this.completedEnrollments = [];
        this.enrolledPlanIds = [];
        this.confirmationNumberMap = {};
        this.selectedPlans = [];
        this.showIndividualContinueButtons = true;
        this.lastAccessedDates = {};
        this.showCrossSellOnShoppingCart = false;
        this.planRiderConflicts = {};
        this.showEmptyCart = false;
        this.activities = [];
        this.documentsList = [];
        this.isUploadedSOAExpired = false;
        this.linkRoles = LinkRoles;
    }
    ngOnInit() {
        super.ngOnInit();
        this.spinnerService.show(SpinnerEvent.SHOPPING_CART_LOADING);
        this.showIndividualContinueButtons = this.Spa_ShoppingCart_IndividualEnrollmentButtons_Enabled;
        let overrideEnrollmentStateDefaults;
        if (this.agentCallRecordingFacade.isAgentCallRecordingShoppingEnabled() && this.twilioService.isConnectionOpen()) {
            overrideEnrollmentStateDefaults = { callRecordingAvailable: true };
        }
        this.shoppingCartService.resetEnrollmentState(overrideEnrollmentStateDefaults);
        this.enrollmentFormService.resetActiveEnrollmentKey();
        this.enrollmentFormService.resetCrossSellEnrollmentTypes();
        this.setComponentValues();
        this.soaNotCompletedMessages = this.getSOANotCompletedMessages();
        if (this.configResourceService.getProcessedResourceValue('JsonAnalytics_Enabled', null, false)) {
            this.updateJsonAnalyticsData();
        }
        this.sortOption = this.planFacade.displayAncillaryPlans() ? 'ordinal' : 'planType';
        const isDeepLink = this.shoppingCartService.isCartEnabled() &&
            this.shoppingCartService.isDeepLinkingEnabled() &&
            this.isDeepLinkingAllowed(this.router?.snapshot?.queryParams);
        if (isDeepLink) {
            this.cartFacade
                .getDeepLinkPlanAndNavigationPageTag$()
                .pipe(take(1))
                .subscribe(deepLink => {
                deepLink?.plan
                    ? this.cartFacade.selectAndValidatePlan(deepLink.plan, null, false)
                    : this.navigationService.navigateByPageTag(deepLink?.navigateTo);
                this.cdr.markForCheck();
            });
        }
        this.getLastAccessedDates();
        this.subscriptions = [
            this.localeService
                .getCurrentLocale$()
                // performance: skip the initial value since we already have the plan details at this point.
                // additionally, we already set the premium labels and the cross sell attributes by previously calling setComponentValues()
                .pipe(skip(1))
                .subscribe({
                next: () => {
                    this.setPremiumLabels();
                    if (this.selectedPlans?.length) {
                        const planIds = this.selectedPlans.map(plan => plan.id);
                        const planTypes = new Set(this.selectedPlans.map(plan => plan.planType));
                        this.plansService
                            .fetchAndUpdatePlansDetails(planIds, PlansUtilityService.toBitWiseString(Array.from(planTypes)))
                            .finally(() => {
                            this.spinnerService.hide(SpinnerEvent.SHOPPING_CART_PLANS_ENROLLMENT_SETTINGS_LOADING);
                        });
                    }
                    this.setCrossSellAttributes(this.selectedPlans);
                    this.soaNotCompletedMessages = this.getSOANotCompletedMessages();
                }
            }),
            this.selectedPlans$.subscribe({
                next: selectedPlans => {
                    this.selectedPlans = selectedPlans?.filter(selectedPlan => this.planFacade.isAddToCartAvailableForPlan(selectedPlan)) ?? [];
                    this.cdr.markForCheck();
                }
            }),
            this.crossSellPlanContext.resetCrossSellAttributes$.subscribe({
                next: () => {
                    this.setCrossSellAttributes(this.selectedPlans);
                }
            }),
            this.liveEditStateContext.currentLiveEditState$.subscribe(liveEditState => {
                if (liveEditState) {
                    if (liveEditState.name === 'Enrollment Unavailable') {
                        this.handleLiveEditUpdateForUnavailableComponent();
                    }
                    this.cdr.markForCheck();
                }
            }),
            combineLatest([
                this.soaFacade.rehydrateSOATransactions$().pipe(switchMap(() => this.soaFacade.getSOAActivities$())),
                this.loggedInMemberId$.pipe(filter(memberId => !!memberId), switchMap(memberId => this.soaFacade.getDocumentList$(memberId)))
            ]).subscribe(([activities, documents]) => {
                this.mustShowSOANotCompleted(activities, documents);
                this.cdr.markForCheck();
            }),
            this.planRiderTypeConflictContextService.getConflicts$().subscribe(conflicts => {
                this.planRiderConflicts = conflicts;
                this.cdr.markForCheck();
            })
        ];
        if (this.Spa_ShoppingCart_HIP_CallOut_Enabled) {
            this.store.selectOnce(PlansState.hasHospitalIndemnityQuestions).subscribe((hasHospitalIndemnityQuestions) => {
                this.hasHospitalIndemnityQuestions = hasHospitalIndemnityQuestions;
                this.cdr.markForCheck();
            });
            this.subscriptions.push(this.plansService.getAreAllHospitalIndemnityQuestionsAnswered$().subscribe(areAllHospitalIndemnityQuestionsAnswered => {
                this.areAllHospitalIndemnityQuestionsAnswered = areAllHospitalIndemnityQuestionsAnswered;
                this.cdr.markForCheck();
            }));
        }
        if (this.pcpEligibilityCheck(true)) {
            this.store.dispatch(new RemovePrimaryCareProvider());
            this.subscriptions.push(this.providerFacade.providerEligibleAsPcpForPlan$().subscribe(response => {
                this.planIdsWithInvalidPCP = this.selectedPlans
                    .filter(plan => plan.planTypeAbbreviation === PlanTypeAbbreviation.MA || plan.planTypeAbbreviation === PlanTypeAbbreviation.MAPD)
                    .map(plan => plan.id);
                const matchingPCP = response?.filter(pcpInfo => pcpInfo.pcpId || pcpInfo.pcp) ?? [];
                if (response?.length) {
                    if (matchingPCP?.length) {
                        const pcp = matchingPCP[0];
                        const selectedPcp = this.providerFacade.getSelectedPCP();
                        const primaryCareProvider = {
                            pcpId: pcp.pcpId,
                            displayName: selectedPcp?.displayName,
                            pcpFirstName: selectedPcp?.firstName,
                            pcpLastName: selectedPcp?.lastName,
                            npi: selectedPcp?.id?.toString(),
                            vbcid: selectedPcp?.valueBasedCare?.vbcid,
                            isNewPatient: selectedPcp?.isNewPatient,
                            vbcOrgName: selectedPcp?.valueBasedCare?.vbcOrgName,
                            ...(pcp.externalId && { externalId: pcp.externalId })
                        };
                        matchingPCP.forEach(matchingItem => {
                            this.planIdsWithInvalidPCP = this.planIdsWithInvalidPCP.filter(id => id !== matchingItem.planId);
                        });
                        this.store.dispatch(new AddPrimaryCareProvider(primaryCareProvider));
                    }
                }
                this.cdr.markForCheck();
                const planIdsWithPCPData = matchingPCP?.map(pcpData => pcpData.planId) ?? [];
                this.updateTags(planIdsWithPCPData);
            }));
        }
        else if (this.pcpEligibilityCheck(false)) {
            const selectedPcp = this.providerFacade.getSelectedPCP();
            if (selectedPcp) {
                const primaryCareProvider = {
                    pcpId: '',
                    displayName: selectedPcp?.displayName,
                    pcpFirstName: selectedPcp?.firstName,
                    pcpLastName: selectedPcp?.lastName,
                    npi: selectedPcp?.id?.toString(),
                    vbcid: selectedPcp?.valueBasedCare?.vbcid,
                    isNewPatient: selectedPcp?.isNewPatient,
                    vbcOrgName: selectedPcp?.valueBasedCare?.vbcOrgName
                };
                this.store.dispatch(new AddPrimaryCareProvider(primaryCareProvider));
            }
            this.updateTags();
        }
        else {
            this.updateTags();
        }
        this.subscriptions.push(this.isMemberLoading$.subscribe({
            next: loading => {
                loading ? this.spinnerService.show(SpinnerEvent.MEMBER_LOADING) : this.spinnerService.hide(SpinnerEvent.MEMBER_LOADING);
            }
        }));
        this.subscriptions.push(this.plansLoading$.subscribe(loading => {
            loading ? this.spinnerService.show(SpinnerEvent.PLANS_LOADING) : this.spinnerService.hide(SpinnerEvent.PLANS_LOADING);
        }));
        this.subscriptions.push(combineLatest([this.isMemberEnrollmentPlanSettingsLoading$, this.plansLoading$]).subscribe({
            next: ([isMemberEnrollmentPlanSettingsLoading, plansLoading]) => {
                if (isMemberEnrollmentPlanSettingsLoading || plansLoading) {
                    this.spinnerService.show(SpinnerEvent.SHOPPING_CART_PLANS_ENROLLMENT_SETTINGS_LOADING);
                }
                else {
                    this.spinnerService.hide(SpinnerEvent.SHOPPING_CART_PLANS_ENROLLMENT_SETTINGS_LOADING);
                }
            }
        }));
        this.subscriptions.push(combineLatest([
            this.isMemberLoading$,
            this.isMemberEnrollmentPlanSettingsLoading$,
            this.plansLoading$,
            this.selectedPlans$,
            this.planSettings$
        ])
            .pipe(filter(([isMemberLoading, isMemberEnrollmentPlanSettingsLoading, arePlansLoading]) => !isMemberLoading && !isMemberEnrollmentPlanSettingsLoading && !arePlansLoading), withLatestFrom(this.planFacade.getNonCoveredPlanTabMap$()))
            .subscribe({
            next: ([[isMemberLoading, isMemberEnrollmentPlanSettingsLoading, arePlansLoading, selectedPlans, settings], nonCoveredPlanTabMap]) => {
                this.selectedPlans = selectedPlans?.filter(selectedPlan => this.planFacade.isAddToCartAvailableForPlan(selectedPlan)) ?? [];
                if (selectedPlans?.length) {
                    this.showEmptyCart = false;
                    this.showCrossSellOnShoppingCart = this.cartFacade.showCrossSellOnShoppingCart(selectedPlans, nonCoveredPlanTabMap);
                    this.planRiderTypeConflictContextService.updateSelectedPlans(selectedPlans);
                    this.cartFacade.selectHIPDefaultBenefitsForPlans(selectedPlans);
                    this.isHIPCallOutAvailableToShoppingCart =
                        nonCoveredPlanTabMap?.[PlanTypeAbbreviation.HC]?.display &&
                            selectedPlans.every(plan => plan.planTypeAbbreviation !== PlanTypeAbbreviation.HC) &&
                            selectedPlans.some(plan => this.planFacade
                                .getEnabledPlanAbbreviations(this.Spa_ShoppingCart_HIP_Call_Out_Available_Plan_Types)
                                .includes(plan.planTypeAbbreviation));
                    if (this.isHIPCallOutAvailableToShoppingCart) {
                        this.enrollingPlan = this.choosePlanToEnroll();
                    }
                    this.createAccountContext.displayCreateAccountNudge();
                    this.completedEnrollments =
                        this.enrollmentConfirmationService
                            .getEnrollments(selectedPlans.map(p => p.id))
                            ?.filter(enrollment => !!enrollment.completedWhen) || [];
                    this.enrolledPlanIds = this.completedEnrollments?.map(enrolledPlan => enrolledPlan.planID);
                    this.confirmationNumberMap = {};
                    this.completedEnrollments?.forEach(completedEnrollment => {
                        this.confirmationNumberMap[completedEnrollment.planID] = completedEnrollment.confirmationNumber;
                    });
                }
                else {
                    this.showEmptyCart = true;
                    this.createAccountContext.hideCreateAccountNudge();
                }
                // If PPC site and different long formIds exist then show toggle.
                // Assumption one of the long forms MUST be aimed at a consumer, from brokers perspective.
                this.planSettings = [...this.planSettings, ...settings];
                this.shortFormSettings = settings.filter(setting => setting.foamFormType === EnrollmentFormType.SHORT && setting.formId !== null);
                this.longFormSettings = settings.filter(setting => setting.foamFormType === EnrollmentFormType.LONG && setting.formId !== null);
                this.checkForShortForm(this.shoppingCartService.getSelectedPlanIds());
                this.plansConfig = selectedPlans.reduce((planConfig, plan) => {
                    const showConsumerBrokerSelection = this.showConsumerBrokerSelection(plan);
                    const isPlanWithShortForm = this.Spa_Enrollment_ShowExistingMemberPromptInCart_Flag && this.plansWithShortForm.includes(plan.id);
                    const isPlanTypeAncillaryOrMedigap = this.isPlanTypeAncillaryOrMedigap(plan);
                    planConfig[plan.id] = {
                        showConsumerBrokerSelection,
                        planDescription: this.getPlanDescription(plan),
                        isPlanTypeAncillaryOrMedigap,
                        isPlanWithShortForm,
                        allowsCallRecording: this.agentCallRecordingFacade.isAgentCallRecordingEnabled() &&
                            this.Spa_Site_AgentCallRecording_DisplayPlanAllowsCallRecordingIcon_Enabled &&
                            this.shoppingCartService.isMultiCarrierSite() &&
                            this.shoppingCartService.allowsCallRecordingOnMultiCarrier(plan.id),
                        shouldAlignCartButton: (showConsumerBrokerSelection || isPlanWithShortForm) && !isPlanTypeAncillaryOrMedigap,
                        planTotalPremium: this.planFacade.getTotalPremium([plan])
                    };
                    return planConfig;
                }, {});
                this.setCrossSellAttributes(this.selectedPlans);
                this.spinnerService.hide(SpinnerEvent.SHOPPING_CART_LOADING);
                this.cdr.markForCheck();
            },
            error: () => {
                this.spinnerService.hide(SpinnerEvent.SHOPPING_CART_LOADING);
            }
        }));
        this.subscriptions.push(this.responsiveLayoutService.isCompact$.subscribe((isCompact) => {
            this.isMobile = isCompact;
            this.cdr.markForCheck();
        }));
        this.subscriptions.push(this.externalEnrollmentContext.observeExternalModalEvent$().subscribe({
            next: modalEvent => {
                if (modalEvent?.type === ExternalEnrollmentModalEventTypes.OPEN) {
                    this.cdr.detach();
                }
                else if (modalEvent?.type === ExternalEnrollmentModalEventTypes.CLOSE) {
                    this.cdr.reattach();
                }
            }
        }));
        this.subscriptions.push(this.externalEnrollmentContext.observeExternalNonModalEvent$().subscribe({
            next: nonModalEvent => {
                this.cdr.detach();
            }
        }));
    }
    getLastAccessedDates() {
        if (this.showIndividualContinueButtons) {
            this.cartFacade
                .fetchSessionForLastAccessedDate$()
                .pipe(take(1))
                .subscribe(() => {
                this.setLastAccessedDates();
            });
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.spinnerService.reset();
        this.modalService.dismissAll();
        this.createAccountContext.hideCreateAccountNudge();
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }
    preProcessProperties() {
        this.pcpEligibilityPlanSubtypeItems = this.Spa_Site_PCPPlanEligibilityCheck_PlanSubtypeItems.filter(item => item.enabled);
    }
    getPlanLogo(plan) {
        return this.planFacade.getPlanLogoUrl(plan);
    }
    plansTrackByFn(index, plan) {
        return plan.id;
    }
    removeFromCart(plan) {
        this.cartFacade.removeFromCart(plan);
    }
    changePlanInCart(plan) {
        this.cartFacade.changePlanInCart(plan);
    }
    getPlanDescription(plan) {
        return this.planFacade.getPlanDescription(plan, this.widgetService.widgetName);
    }
    emptyCartNavToPlans() {
        this.cartFacade.navigateToPlans(this.injector);
    }
    viewPlanDetails(plan) {
        this.cartFacade.viewPlanDetails(plan);
    }
    apply(toolTip) {
        const plans = this.shoppingCartService.getSelectedPlans();
        if (this.crossSellEnrollmentTypes === CrossSellEnrollmentTypes.BOTH_EXTERNAL) {
            this.showBothPlansExternalModal(() => {
                this.prepareAndEnroll(toolTip, plans);
            });
        }
        else {
            this.prepareAndEnroll(toolTip, plans);
        }
    }
    onContinueToApply(toolTip, planId) {
        this.enrollingPlan = this.choosePlanToEnroll(planId);
        if (this.enrollmentFormService.planHasNextGenForm(this.enrollingPlan.id)) {
            if (this.showConsumerBrokerSelection(this.enrollingPlan)) {
                const formTypeSelected = this.isFormTypeSelected(this.enrollingPlan.id);
                if (!formTypeSelected) {
                    return;
                }
            }
            const selectedFormType = this.enrollmentFormService.getSelectedFormType(this.enrollingPlan.id);
            let userFormType = this.enrollmentFormService.getUserFormType(this.enrollingPlan.id);
            if (!userFormType) {
                userFormType = UserTypeKeys[this.enrollmentFormService.getSiteUserType(this.enrollingPlan.id).toUpperCase()];
                this.enrollmentFormService.updateUserFormType$(userFormType, this.enrollingPlan.id);
            }
            const planEnrollmentSettings = this.enrollmentFormService.getPlanEnrollmentSettingsByType(this.enrollingPlan.id, selectedFormType, userFormType);
            if (!planEnrollmentSettings) {
                this.navigationService.navigateTo404();
                return;
            }
            else {
                this.setFormVersionIdFromEnrollmentSettings(planEnrollmentSettings.formVersionId);
            }
        }
        if (this.enrollingPlan.enrollViaSTBOnly && !this.siteService.isPPCSite()) {
            toolTip.open();
            // the tooltip will close if the user tabs or clicks elsewhere, or after 3 seconds
            this.cartFacade.closeTooltip(toolTip, TOOLTIP_TIMEOUT);
        }
        else if (this.Spa_DualPlanEnrollMessage_EnrollmentModal_Enabled && this.plansService.isDualPlanYear(this.enrollingPlan?.planYear)) {
            const plans = this.shoppingCartService.getSelectedPlans();
            if (this.validateFormAndFormType(plans)) {
                const fips = this.demographicService.getSelectedFipsCode();
                const date = this.cartFacade.getAgentPlanPermissionEffectiveDate(this.enrollingPlan.planType);
                this.cartFacade.processAgentEnrollPermissions(this.enrollingPlan, date, fips, toolTip, () => {
                    this.showDualPlanEnrollmentMessageModal(() => {
                        this.continueToApply(toolTip);
                    });
                });
            }
        }
        else {
            this.continueToApply(toolTip);
        }
    }
    getPcpWarningText() {
        const selectedPcp = this.providerFacade.getSelectedPCP();
        if (selectedPcp?.displayName) {
            return selectedPcp.displayName.concat(` ${this.Spa_ShoppingCart_PcpWarning_Text}`);
        }
    }
    enroll(planId) {
        this.shoppingCartContextService
            .getInvalidEnrollmentPlans$()
            .pipe(take(1))
            .subscribe(invalidEnrollmentPlans => {
            if (!invalidEnrollmentPlans?.includes(planId)) {
                this.enrollmentFormService.setActiveEnrollmentKey(planId);
                const isMedSupEnrollment = this.cartFacade.isMedSupEnrollment(planId);
                const planType = this.cartFacade.getPlanTypeByPlanId(planId);
                if (this.crossSellEnrollmentTypes === CrossSellEnrollmentTypes.BOTH_MESSAGE ||
                    (this.crossSellEnrollmentTypes === CrossSellEnrollmentTypes.EXTERNAL_AND_MESSAGE && !this.shouldEnrollInExternalFirst)) {
                    // Handle the enrollment when both plans on Crosssell are MessageOnly
                    // Or one plan is External and one plan is MessageOnly and External plan is not selected first
                    this.enrollWhenBothMessageOrMessageExternal(isMedSupEnrollment, planType);
                }
                else {
                    if (isMedSupEnrollment) {
                        this.enrollInMedSupPlan();
                    }
                    else {
                        this.enrollInNonMedSupPlan(planType, false);
                    }
                }
            }
            this.cdr.markForCheck();
        });
    }
    enrollWhenBothMessageOrMessageExternal(isMedSupEnrollment, planType) {
        // Handle the enrollment when both plans on Crosssell are MessageOnly
        // Or one plan is External and one plan is MessageOnly
        if (isMedSupEnrollment) {
            this.handleMedsupEnrollment(this.prepareAndEnrollInSecondPlan.bind(this));
        }
        else {
            this.enrollInNonMedSupPlan(planType, true);
        }
    }
    enrollInNonMedSupPlan(planType, prepareAndEnrollInSecondPlan) {
        if (this.shoppingCartService.isEnrollmentEnabledByPlanType(planType)) {
            if (prepareAndEnrollInSecondPlan) {
                this.planFacade.enroll(this.widgetName, this.prepareAndEnrollInSecondPlan.bind(this));
            }
            else {
                this.planFacade.enroll(this.widgetName);
            }
        }
        else {
            this.enrollmentUnavailablePlanType = planType;
        }
    }
    sendApplication() {
        this.enrollFacade.showSendEnrollmentModal();
    }
    resetStatus() {
        this.enrollmentUnavailablePlanType = null;
    }
    updateTags(planIdsWithPCPData) {
        const selectedPlan = this.getFirstSelectedPlan();
        const googleTagManagerNotApplicableText = this.Spa_Site_NotApplicable_Text.toLowerCase();
        if (selectedPlan) {
            let medSupCrossSell;
            const mustShowCrossSell = this.cartFacade.showCrossSellOnShoppingCart(this.selectedPlans);
            if (mustShowCrossSell && CROSS_SELL_PLANS.includes(selectedPlan.planType)) {
                medSupCrossSell = this.getCrossSellDataLayerGlobalVariable(selectedPlan.planType);
            }
            this.tagsToUpdate = {
                [DataLayerGlobalVariable.PLAN_ID]: this.getPlanIdsForAnalytics(this.selectedPlans),
                [DataLayerGlobalVariable.PLAN_CARRIER]: this.getPlanCarriersForAnalytics(this.selectedPlans),
                [DataLayerGlobalVariable.PLAN_TYPE]: this.getPlanTypesForAnalytics(this.selectedPlans),
                [DataLayerGlobalVariable.PLAN_ID_BEST_MATCH]: this.planListFacade.getBestMatchPlanIdValueForAnalytics(),
                [DataLayerGlobalVariable.PLAN_TYPE_BEST_MATCH]: this.planListFacade.getBestCoverageTabAbbreviationValueForAnalytics(),
                [DataLayerGlobalVariable.CROSS_SELL_DISPLAYED]: medSupCrossSell ?? googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.PLAN_PCP_ELIGIBILITY]: this.getPCPEligibilityForAnalytics(this.selectedPlans, planIdsWithPCPData),
                [DataLayerGlobalVariable.ENROLLMENT_PLAN_COUNT]: `${this.shoppingCartService.getEnrollmentPlanCount()}`,
                [DataLayerGlobalVariable.PLAN_PROVIDER_VBC_STATUS]: this.planFacade.isVbcAgreementExists(selectedPlan)
                    ? GOOGLE_ANALYTICS_YES
                    : GOOGLE_ANALYTICS_NO
            };
        }
        else {
            this.tagsToUpdate = {
                [DataLayerGlobalVariable.PLAN_CARRIER]: googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.PLAN_TYPE]: googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.PLAN_PCP_ELIGIBILITY]: googleTagManagerNotApplicableText,
                [DataLayerGlobalVariable.ENROLLMENT_PLAN_COUNT]: `${this.shoppingCartService.getEnrollmentPlanCount()}`
            };
        }
        this.shouldUpdateTags = true;
    }
    getFormattedEffectiveDate$() {
        return this.effectiveDate$.pipe(map(effectiveDate => DateUtilities.getFormattedDate(new Date(effectiveDate), 'LL')));
    }
    getFirstSelectedPlan() {
        return this.selectedPlans[0];
    }
    updateUserFormType(userFormTypeSelection, planId) {
        // On shopping cart:
        // If "send to beneficiary to sign and submit", userFormTypeSelection = UserTypeKeys.CONSUMER
        // If "complete and submit form myself", userFormTypeSelection = UserTypeKeys.BROKER
        let userFormType;
        const siteType = this.configResourceService.getProcessedResourceValue('Spa_Site_SiteType');
        if (siteType) {
            userFormType = userFormTypeSelection === UserTypeKeys.BROKER ? this.enrollFacade.getUserTypeKey(siteType) : UserTypeKeys.CONSUMER;
        }
        this.enrollFacade.updateUserFormType$(userFormType, planId);
    }
    showConsumerBrokerSelection(plan) {
        return (this.plansService.isConsumerBrokerSelectionAllowedForPlanType(plan) &&
            this.checkConsumerBrokerSelectionForPlan(plan) &&
            this.enrollFacade.getConsumerBrokerToggleEnabled() &&
            this.enrollFacade.canSendApplicationToBeneficiary(plan));
    }
    checkConsumerBrokerSelectionForPlan(plan) {
        if (this.planSettings && plan) {
            const planEnrollmentSettings = this.planSettings.filter(settings => settings.planIds.includes(plan.id));
            return planEnrollmentSettings && this.enrollmentFormService.showAgentFormSelection(planEnrollmentSettings);
        }
        return false;
    }
    checkForShortForm(planIds) {
        planIds.forEach(planId => {
            if (this.shortFormSettings && this.shortFormSettings.some(settings => settings.planIds.includes(planId))) {
                this.addPlanToShortFormPlanList(planId);
            }
            if (!this.enrollFacade.getSelectedFormType(planId)) {
                this.enrollFacade.updateSelectedFormType$(EnrollmentFormType.LONG, planId);
            }
        });
    }
    enrollInMedSupPlan() {
        if (this.Spa_Site_MedSupEnrollment_Enabled) {
            if (this.SPA_Site_Medigap_Enrollment_InterimPage_Enable) {
                this.navigationService.navigateByPageTag(PageTags.MEDIGAP_INTERIM);
            }
            else {
                this.planFacade.enroll(this.widgetName);
            }
        }
        else {
            this.enrollmentUnavailablePlanType = PlanType.MEDIGAP;
        }
    }
    enrollInSecondPlan(planId) {
        // Enroll in the second plan when both plans on Crosssell are MessageOnly
        // Or one plan is External and one plan is MessageOnly
        this.enrollmentFormService.setActiveEnrollmentKey(planId);
        const isMedSupEnrollment = this.cartFacade.isMedSupEnrollment(planId);
        const planType = this.cartFacade.getPlanTypeByPlanId(planId);
        if (isMedSupEnrollment) {
            if (this.crossSellEnrollmentTypes === CrossSellEnrollmentTypes.EXTERNAL_AND_MESSAGE) {
                this.enrollInMedSupPlan();
            }
            else {
                this.handleMedsupEnrollment();
            }
        }
        else {
            this.enrollInNonMedSupPlan(planType, false);
        }
    }
    backToPrevious() {
        this.plansService.setOverrideActiveTab(false);
        this.configurableWidgetService.navigationService.backToPrevious();
    }
    navigateToMemberProfilePage() {
        this.cartFacade.navigateToMemberProfilePage();
    }
    showHospitalIndemnityBenefits(plan) {
        this.cartFacade.showHospitalIndemnityBenefits(plan, this.benefitsForHIPPopover);
    }
    closeHIPBenefitsPopover() {
        this.benefitsForHIPPopover.close();
    }
    getEnrollmentUnavailableMessage() {
        if (this.enrollmentUnavailablePlanType === PlanType.MEDIGAP) {
            return this.Spa_ShoppingCart_MedSupUnavailable_Message;
        }
        return this.Spa_ShoppingCart_EnrollmentUnavailable_Message;
        // TODO: Possibly add in Dental/Vision/HIP messages
    }
    setLastAccessedDates() {
        const externalEnrollments = this.cartFacade.getExternalEnrollments();
        this.lastAccessedDates = {};
        externalEnrollments?.forEach(externalEnrollment => {
            // An internal enrollment can have a listing in this data for its attached HRA form, we need to skip those here
            // External enrollments cant have HRAs so we ultimately ignore all hra entries in this particular case
            if (!externalEnrollment.isHRA && externalEnrollment.lastAccessedDate) {
                const formattedDate = DateUtilities.getFormattedDate(new Date(externalEnrollment.lastAccessedDate));
                if (formattedDate) {
                    this.lastAccessedDates[externalEnrollment.planId] = formattedDate;
                }
            }
        });
        this.cdr.markForCheck();
    }
    updateLastAccessedDates(planId) {
        if (planId) {
            const isMedSupEnrollment = this.cartFacade.isMedSupEnrollment(planId);
            if (isMedSupEnrollment) {
                return;
            }
            const enrollmentSetting = this.planSettings?.find(planSetting => planSetting.planIds[0] === planId);
            const enrollType = this.enrollmentConfirmationService.getEnrollmentType(enrollmentSetting);
            if (!enrollType || enrollType === EnrollmentType$1.INTERNAL) {
                return;
            }
            const externalEnrollments = this.cartFacade.getExternalEnrollments();
            if (!externalEnrollments?.find(e => e.planId === planId)) {
                this.lastAccessedDates[planId] = DateUtilities.getFormattedDateTime(new Date(DateUtilities.getFormattedPTDate()), DateUtilities.defaultFormat);
            }
        }
    }
    clearShoppingCart() {
        this.cartFacade.clearShoppingCart();
        this.selectedPlans = [];
        this.showEmptyCart = true;
        this.cdr.markForCheck();
    }
    backToPlanList() {
        this.navigationService.navigateByPageTag(PageTags.PLAN_LIST);
    }
    getPlanIdsForAnalytics(plans) {
        return plans.map(plan => plan.id).join('|');
    }
    getPlanCarriersForAnalytics(plans) {
        return plans.map(plan => plan.carrierName).join('|');
    }
    getPlanTypesForAnalytics(plans) {
        return plans.map(plan => plan.planTypeAbbreviation).join('|');
    }
    getPCPEligibilityForAnalytics(plans, planIdsWithPCPData) {
        // Undefined planIdsWithPCPData means the call never happened, so we only send n/a's
        // empty planIdsWithPCPData means the call came back but with no data, so we can fill it with no's
        return plans
            .map(plan => {
            let analyticsRepsone = this.Spa_Site_NotApplicable_Text.toLowerCase();
            if (this.Spa_Site_PCPPlanEligibilityCheck_Enabled &&
                planIdsWithPCPData !== undefined &&
                (plan.planTypeAbbreviation === PlanTypeAbbreviation.MA || plan.planTypeAbbreviation === PlanTypeAbbreviation.MAPD)) {
                analyticsRepsone = planIdsWithPCPData.includes(plan.id) ? this.Spa_Site_Yes : this.Spa_Site_No;
            }
            return analyticsRepsone;
        })
            .join('|');
    }
    // When we have a medigap plan, the cross-sell must be PDP, and vice versa
    getCrossSellDataLayerGlobalVariable(planType) {
        switch (planType) {
            case PlanType.MEDIGAP:
                return DataLayerGlobalVariable.CROSS_SELL_PDP;
            case PlanType.PDP:
                return DataLayerGlobalVariable.CROSS_SELL_MEDSUP;
            default:
                return null;
        }
    }
    googleTagsToUpdate(event) {
        const selectedPlan = this.getFirstSelectedPlan();
        const googleTagManagerNotApplicableText = this.Spa_Site_NotApplicable_Text.toLowerCase();
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: event,
            [DataLayerGlobalVariable.PLAN_ID]: selectedPlan?.id ?? googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.PLAN_TYPE]: selectedPlan?.planTypeAbbreviation ?? googleTagManagerNotApplicableText,
            [DataLayerGlobalVariable.REMOVED_PLAN_PROVIDER_VBC_STATUS]: this.planFacade.isVbcAgreementExists(selectedPlan)
                ? GOOGLE_ANALYTICS_YES
                : GOOGLE_ANALYTICS_NO
        };
    }
    pcpEligibilityCheck(validatePlanSubTypeHMO) {
        if (!this.Spa_Site_PCPPlanEligibilityCheck_Enabled) {
            return false;
        }
        return this.selectedPlans.some(selectedPlan => {
            const isPcpSelected = this.providerFacade.isPcpSelected();
            const hasSelectedPlan = !!selectedPlan;
            const planTypeIsPCPEligible = selectedPlan.planType === PlanType.MA || selectedPlan.planType === PlanType.MAPD;
            const providerNetworkStatus = this.providerFacade.getProviderNetworkStatus([selectedPlan.id]);
            let planHasEligibleSubtype = false;
            if (validatePlanSubTypeHMO) {
                planHasEligibleSubtype =
                    (selectedPlan.planSubType === PlanSubTypes.HMO || selectedPlan.planSubType === PlanSubTypes.HMOPOS) &&
                        this.pcpEligibilityPlanSubtypeItems.some(({ planSubType }) => selectedPlan.planSubType === planSubType);
            }
            else {
                planHasEligibleSubtype = selectedPlan.planSubType !== PlanSubTypes.HMO && selectedPlan.planSubType !== PlanSubTypes.HMOPOS;
            }
            return isPcpSelected && hasSelectedPlan && planTypeIsPCPEligible && planHasEligibleSubtype && providerNetworkStatus;
        });
    }
    prepareAndEnroll(toolTip, plans) {
        const isValid = this.validateFormAndFormType(plans);
        if (isValid) {
            const fips = this.demographicService.getSelectedFipsCode();
            const date = this.cartFacade.getAgentPlanPermissionEffectiveDate(this.enrollingPlan.planType);
            this.cartFacade.checkEnrollmentStatusAndAgentPermissions(this.enrollingPlan, date, fips, toolTip, this.enroll.bind(this));
        }
    }
    handleLiveEditUpdateForUnavailableComponent() {
        if (!this.Spa_Site_Enrollment_Enabled) {
            this.enrollmentUnavailablePlanType = PlanType.MA;
        }
        else {
            if (!this.Spa_Site_MedSupEnrollment_Enabled) {
                this.enrollmentUnavailablePlanType = PlanType.MEDIGAP;
            }
        }
    }
    isFormTypeSelected(planId) {
        const userFormType = this.enrollFacade.getUserFormType(planId);
        if (userFormType === null) {
            this.shoppingCartContextService.setIsValidForEnrollment(planId, false);
            return false;
        }
        return true;
    }
    areNonEnrollingPlansValid(plans) {
        plans?.forEach(plan => {
            if (plan.id !== this.enrollingPlan.id) {
                if (this.showConsumerBrokerSelection(plan)) {
                    const formTypeSelected = this.isFormTypeSelected(plan.id);
                    if (!formTypeSelected) {
                        return false;
                    }
                }
            }
        });
        return true;
    }
    validateFormAndFormType(plans) {
        // We don't need to worry about the validity of non enrolling plans if we are using individual continue buttons.
        const nonEnrollingPlansValid = this.Spa_ShoppingCart_IndividualEnrollmentButtons_Enabled || this.areNonEnrollingPlansValid(plans);
        if (!nonEnrollingPlansValid) {
            return false;
        }
        if (this.showConsumerBrokerSelection(this.enrollingPlan)) {
            const formTypeSelected = this.isFormTypeSelected(this.enrollingPlan.id);
            if (!formTypeSelected) {
                return false;
            }
            // As long form is default we need to check if there is a matching long form for the selection
            // so as to not error out.  Per validation above userType must be set.
            this.enrollFacade.validateMatchingLongForm(this.enrollingPlan.id, this.longFormSettings);
            // As short forms aren't usually given we need to check if there is one and
            // reset the default to long if there isn't one for the agent/form selection.
            this.enrollFacade.validateMatchingShortForm(this.enrollingPlan.id, this.shortFormSettings);
        }
        return true;
    }
    getCrossSellPlanEnrollmentAttributes(plans) {
        this.crossSellPlanEnrollmentAttributes = plans.map(plan => {
            const crossSellPlanEnrollmentAttributes = {
                planId: plan.id,
                enrollmentType: null,
                userFormType: null
            };
            const enrollmentSetting = this.planSettings?.find(planSetting => planSetting.planIds[0] === plan.id);
            const enrollType = this.enrollmentConfirmationService.getEnrollmentType(enrollmentSetting);
            if (enrollType) {
                crossSellPlanEnrollmentAttributes.enrollmentType = enrollType;
            }
            const userFormType = this.enrollFacade.getUserFormType(plan.id);
            if (userFormType) {
                crossSellPlanEnrollmentAttributes.userFormType = userFormType;
            }
            return crossSellPlanEnrollmentAttributes;
        });
    }
    choosePlanToEnroll(planId) {
        if (planId) {
            return this.selectedPlans?.find(plan => plan.id === planId);
        }
        if (this.selectedPlans?.length === 1) {
            return this.selectedPlans[0];
        }
        const plansNotEnrolled = this.selectedPlans.filter(plan => !this.enrolledPlanIds.includes(plan.id));
        if (plansNotEnrolled?.length > 1) {
            this.getCrossSellPlanEnrollmentAttributes(plansNotEnrolled);
            const chosenPlanId = this.pickBasedOnEnrollmentAttributes();
            return plansNotEnrolled.find(plan => plan.id === chosenPlanId);
        }
        return this.shoppingCartService.getSelectedPlan();
    }
    pickBasedOnEnrollmentAttributes() {
        // For now, we are assuming the shopping cart can have atmost 2 plans at any time
        this.crossSellEnrollmentTypes = this.shoppingCartService.getEnrollmentTypeFlag(this.crossSellPlanEnrollmentAttributes);
        this.enrollmentFormService.setCrossSellEnrollmentTypes(this.crossSellEnrollmentTypes);
        this.crossSellSendToBeneficiaryOptions = this.shoppingCartService.getUserFormTypeFlag(this.crossSellPlanEnrollmentAttributes);
        this.shouldEnrollInExternalFirst = this.configResourceService.getProcessedResourceValue('Spa_Site_EnrollInExternalPlansFirst_Enabled');
        // Determine which plan to select for enrollment first.
        // The other plan will be picked for enrollment after the first is done based on the enrollmenttype.
        if (this.crossSellEnrollmentTypes === CrossSellEnrollmentTypes.BOTH_INTERNAL ||
            this.crossSellEnrollmentTypes === CrossSellEnrollmentTypes.BOTH_EXTERNAL ||
            this.crossSellEnrollmentTypes === CrossSellEnrollmentTypes.BOTH_MESSAGE) {
            return this.pickPlanForEnrollment();
        }
        if (this.crossSellEnrollmentTypes === CrossSellEnrollmentTypes.ONE_INTERNAL) {
            const externalPlan = this.crossSellPlanEnrollmentAttributes.find(planEnrollmentAttributes => planEnrollmentAttributes.enrollmentType === EnrollmentType$1.EXTERNAL);
            if (externalPlan && this.shouldEnrollInExternalFirst) {
                return externalPlan.planId;
            }
            const selectedPlan = this.crossSellPlanEnrollmentAttributes.find(planEnrollmentAttributes => planEnrollmentAttributes.enrollmentType === EnrollmentType$1.INTERNAL);
            return selectedPlan.planId;
        }
        if (this.crossSellEnrollmentTypes === CrossSellEnrollmentTypes.EXTERNAL_AND_MESSAGE) {
            // If there is one External and one MessageOnly plan,
            // select External plan for enrollment first, if Spa_Site_EnrollInExternalPlansFirst_Enabled is true
            // If not, select the MessageOnly plan
            if (this.shouldEnrollInExternalFirst) {
                const selectedPlan = this.crossSellPlanEnrollmentAttributes.find(planEnrollmentAttributes => planEnrollmentAttributes.enrollmentType === EnrollmentType$1.EXTERNAL);
                return selectedPlan.planId;
            }
            const selectedPlan = this.crossSellPlanEnrollmentAttributes.find(planEnrollmentAttributes => planEnrollmentAttributes.enrollmentType === EnrollmentType$1.MESSAGE_ONLY);
            return selectedPlan.planId;
        }
        return this.crossSellPlanEnrollmentAttributes[0].planId;
    }
    pickPlanForEnrollment() {
        if (this.crossSellEnrollmentTypes === CrossSellEnrollmentTypes.BOTH_INTERNAL &&
            this.crossSellSendToBeneficiaryOptions === CrossSellSendToBeneficiaryOptions.ONE_SENDTOBENE) {
            // If Send to Beneficiary option is chosen on one of the hosted/internal plans,
            // select the plan that can be completed fully(Not send to bene) first
            const selectedPlan = this.crossSellPlanEnrollmentAttributes.find(planEnrollmentAttributes => planEnrollmentAttributes.enrollmentType === EnrollmentType$1.INTERNAL &&
                planEnrollmentAttributes.userFormType !== UserTypeKeys.CONSUMER);
            return selectedPlan.planId;
        }
        // select the first plan in the cart for enrollment
        return this.crossSellPlanEnrollmentAttributes[0]?.planId;
    }
    showDualPlanEnrollmentMessageModal(confirmAction) {
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true, backdrop: 'static', keyboard: false });
        confirmationModal.componentInstance.title = this.Spa_DualPlanEnrollMessage_EnrollmentModalTitle_Text;
        confirmationModal.componentInstance.prompt = this.Spa_DualPlanEnrollMessage_EnrollmentModalBody_Text;
        confirmationModal.componentInstance.confirmButton = this.Spa_EnrollMessageEnrollmentModal_Continue;
        confirmationModal.componentInstance.confirmAction = confirmAction;
        confirmationModal.componentInstance.cancelButton = this.Spa_EnrollMessageEnrollmentModal_Close;
    }
    continueToApply(toolTip) {
        if (this.agentCallRecordingFacade.isAgentCallRecordingEnabled() &&
            this.enrollFacade.getUserFormType(this.getFirstSelectedPlan()?.id) !== UserTypeKeys.CONSUMER) {
            if (this.shoppingCartService.isMultiCarrierSite() || this.Spa_ShoppingCart_IndividualEnrollmentButtons_Enabled) {
                if (this.shoppingCartService.allowsCallRecordingOnMultiCarrier(this.enrollingPlan?.id)) {
                    this.showAgentCallRecordingModal(() => {
                        this.apply(toolTip);
                    });
                }
                else {
                    this.apply(toolTip);
                }
            }
            else {
                this.showAgentCallRecordingModal(() => {
                    this.apply(toolTip);
                });
            }
        }
        else if (this.loginFacade.checkToPromptMemberPortalLogin()) {
            this.googleTagsToUpdate(DataLayerEvent.CLICK_EXTERNAL_ENROLL_NOTIFICATION_OPEN);
            const selectedPlan = this.getFirstSelectedPlan();
            this.loginFacade.showExternalLoginPrompt(true, selectedPlan?.id, selectedPlan?.planTypeAbbreviation);
        }
        else {
            this.apply(toolTip);
            this.googleTagsToUpdate(DataLayerEvent.CLICK_CART_ENROLL);
        }
        this.updateLastAccessedDates(this.enrollingPlan?.id);
    }
    showBothPlansExternalModal(closeAction) {
        const title = this.shoppingCartService.getBothPlansExternalModalTitle();
        const message = this.shoppingCartService.getBothPlansExternalModalMessage();
        const confirmButtonText = this.shoppingCartService.getBothPlansExternalModalCloseText();
        const confirmationModal = this.modalService.open(ConfirmationModalComponent, { centered: true, backdrop: 'static', keyboard: false });
        confirmationModal.componentInstance.title = title;
        confirmationModal.componentInstance.prompt = message || '';
        confirmationModal.componentInstance.cancelButton = confirmButtonText;
        confirmationModal.componentInstance.cancelAction = closeAction;
        confirmationModal.componentInstance.singleButtonOnCenter = true;
    }
    showAgentCallRecordingModal(confirmAction) {
        this.analyticsService.googleDataLayerTags = {
            [DataLayerGlobalVariable.EVENT]: DataLayerEvent.CLICK_CALL_RECORDING_MODAL_OPEN
        };
        const confirmationModal = this.modalService.open(AgentCallRecordingModalComponent, {
            centered: true,
            backdrop: 'static',
            size: 'lg'
        });
        confirmationModal.componentInstance.confirmAction = confirmAction;
        confirmationModal.componentInstance.enrollingPlan = this.enrollingPlan;
    }
    prepareAndEnrollInSecondPlan(toolTip) {
        // Prepare and Enroll in the second plan
        const plans = this.shoppingCartService.getSelectedPlans();
        const enrolledPlanId = this.enrollmentFormService.getActiveEnrollmentKey();
        let planNotEnrolled;
        if (enrolledPlanId) {
            planNotEnrolled = plans.find(plan => plan.id !== enrolledPlanId);
        }
        if (planNotEnrolled) {
            this.enrollingPlan = planNotEnrolled;
            const isValid = this.validateFormAndFormType(plans);
            if (isValid) {
                const fips = this.demographicService.getSelectedFipsCode();
                const date = this.cartFacade.getAgentPlanPermissionEffectiveDate(this.enrollingPlan.planType);
                this.cartFacade.checkEnrollmentStatusAndAgentPermissions(this.enrollingPlan, date, fips, toolTip, this.enrollInSecondPlan.bind(this));
            }
        }
    }
    handleMedsupEnrollment(action) {
        if (this.Spa_Site_MedSupEnrollment_Enabled) {
            // If we are coming here for enrollment of the first plan(medsup),
            // then enroll in the first plan and go on to enroll in the second plan
            // Else, enroll in the plan and stop.
            this.planFacade.enroll(this.widgetName, action);
        }
        else {
            this.enrollmentUnavailablePlanType = PlanType.MEDIGAP;
        }
    }
    addPlanToShortFormPlanList(planId) {
        if (planId && !this.plansWithShortForm.includes(planId)) {
            this.plansWithShortForm.push(planId);
        }
    }
    updateJsonAnalyticsData() {
        this.jsonAnalyticsService.setJsonAnalyticsTag(JsonAnalyticsGlobalVariable.AGE_RANGE, this.planFacade.getAgeRangeKey());
        const dosagesCount = this.store.selectSnapshot(MedicineCabinetState.medicineCabinet)?.length;
        this.jsonAnalyticsService.setJsonAnalyticsTag(JsonAnalyticsGlobalVariable.DOSAGES_COUNT, dosagesCount.toString());
        this.jsonAnalyticsService.addToDataLayer();
    }
    setComponentValues() {
        this.planIds$ = this.cartFacade.getSelectedPlanIds$();
        this.isMemberLoading$ = this.cartFacade.isMemberLoading$();
        this.loggedInMemberId$ = this.cartFacade.loggedInMemberId$();
        this.isMemberEnrollmentPlanSettingsLoading$ = this.cartFacade.isMemberEnrollmentPlanSettingsLoading$();
        this.selectedPlans$ = this.updateAndGetSelectedPlans$();
        this.planSettings$ = this.isMemberLoading$.pipe(filter(isMemberLoading => !isMemberLoading), switchMap(() => this.cartFacade.getPlanEnrollmentSettingsForAllPlans$()));
        this.riders$ = this.shoppingCartService.getSelectedRiders$();
        this.effectiveDate$ = this.shoppingCartService.getEffectiveDate$();
        // TOOD: add planType
        this.plansLoading$ = this.shoppingCartService.getLoadingStatus$();
        this.setPremiumLabels();
    }
    setPremiumLabels() {
        this.premiumLabel = this.planFacade.getPremiumLabel();
        this.totalPremiumLabel = this.planFacade.getTotalPremiumLabel();
    }
    setCrossSellAttributes(cartPlans) {
        if (this.cartFacade.showCrossSellOnShoppingCart(cartPlans)) {
            const selectedPlan = this.crossSellPlanInCart(cartPlans);
            if (selectedPlan?.planType === PlanType.PDP) {
                this.crossSellAttributes = this.cartFacade.getMedSupCrossSellAttributes(selectedPlan, true);
            }
            else if (selectedPlan?.planType === PlanType.MEDIGAP) {
                this.crossSellAttributes = this.cartFacade.getPDPCrossSellAttributes(selectedPlan, true);
            }
        }
    }
    crossSellPlanInCart(cartPlans) {
        return this.cartFacade.getCrossSellPlanInCart(cartPlans);
    }
    mustShowSOANotCompleted(activities, documents) {
        this.showSOANotCompleted = this.cartFacade.mustShowSOANotCompleted(activities, documents);
    }
    getSOANotCompletedMessages() {
        return [
            {
                message: `${this.Spa_Site_SOA_NotComplete_Label}`,
                liveEditProp: ''
            }
        ];
    }
    isDeepLinkingAllowed(queryParams) {
        if (queryParams) {
            // We only want to allow deep linking if there are query params that are not the type param
            // This param is returned from USAA during external/internal cross sell and caused the issues
            // noted in SCS-58994/SPA-18876
            const { type: omitted, ...params } = queryParams;
            return !!Object.keys(params).length;
        }
        return false;
    }
    isPlanTypeAncillaryOrMedigap(plan) {
        return plan.planType === this.planType.MEDIGAP || ANCILLARY_PLAN_TYPES.includes(plan.planType);
    }
    updateAndGetSelectedPlans$(shoppingCartPlanTypes = this.shoppingCartService.getShoppingCartPlanTypes()) {
        const allShoppingCartPlanIds = this.shoppingCartService.getShoppingCartPlanIds() ?? [];
        const nonDetailedIds = allShoppingCartPlanIds.filter(planId => !this.plansService.isPlanDetailedById(planId));
        if (nonDetailedIds?.length) {
            // This function automatically updates the store, and thus getSelectedPlans$, so no need to set/assign
            this.plansService.fetchAndUpdatePlansDetails(nonDetailedIds, PlansUtilityService.toBitWiseString(shoppingCartPlanTypes));
        }
        return this.cartFacade.getSelectedPlans$().pipe(map(source => {
            return this.planFacade.sortPlansInCartByOrdinal(source);
        }));
    }
    setFormVersionIdFromEnrollmentSettings(formVersionId) {
        this.enrollmentFormService.setFormVersionIdFromEnrollmentSettings(formVersionId);
    }
};
ShoppingCartComponent.ɵfac = function ShoppingCartComponent_Factory(t) { return new (t || ShoppingCartComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.ShoppingCartService), i0.ɵɵdirectiveInject(ShoppingCartContextService), i0.ɵɵdirectiveInject(i1.DemographicService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.JsonAnalyticsService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(i1.PlansService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(CartFacade), i0.ɵɵdirectiveInject(PlanFacade), i0.ɵɵdirectiveInject(EnrollmentFormFacade), i0.ɵɵdirectiveInject(SendEnrollmentFacade), i0.ɵɵdirectiveInject(CrossSellPlanContext), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(EnrollmentConfirmationService), i0.ɵɵdirectiveInject(i1.LiveEditStateContext), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(ProviderFacade), i0.ɵɵdirectiveInject(CreateAccountContext), i0.ɵɵdirectiveInject(AgentCallRecordingFacade), i0.ɵɵdirectiveInject(LoginFacade), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(PlanListFacadeService), i0.ɵɵdirectiveInject(SOAFacade), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService), i0.ɵɵdirectiveInject(i1.PlanRiderTypeConflictContextService), i0.ɵɵdirectiveInject(i1.TwilioDeviceService), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i1.ExternalEnrollmentContext), i0.ɵɵdirectiveInject(i1.SiteService)); };
ShoppingCartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ShoppingCartComponent, selectors: [["vnext-shopping-cart"]], viewQuery: function ShoppingCartComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$u, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.benefitsForHIPPopover = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 6, vars: 2, consts: [[1, "container"], ["class", "container", "aria-live", "polite", "vnextGoogleTagManager", "", 3, "tagsToUpdate", "saveDefaultValues", "shouldUpdateTags", 4, "ngIf", "ngIfElse"], ["enrollmentUnavailableSection", ""], ["benefitsForHIPPopoverTemplate", ""], ["aria-live", "polite", "vnextGoogleTagManager", "", 1, "container", 3, "tagsToUpdate", "saveDefaultValues", "shouldUpdateTags"], [4, "ngIf"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["cartWithItems", ""], ["emptyCart", ""], ["class", "col-auto mx-auto text-center mt-5 width-fit-content", 4, "ngIf"], ["aria-live", "off", 1, "cart-main-title"], ["class", "page-title Spa_Style_H1", 4, "liveEditProp"], [1, "col-12", "mt-4"], [3, "innerHtml", 4, "liveEditProp"], [3, "bundlePlansPrompt", "marketingMessage", "shopButton", "shopAction", 4, "ngIf"], ["class", "row mb-3", "type", "warn", 3, "title", "messages", "warningCustomClass", 4, "ngIf"], ["class", "row mb-3", 3, "type", "warningCustomClass", "buttonCustomClass", "hasButton", "buttonText", "title", "messages", "applyEvent", 4, "ngIf"], ["class", "mb-3", 4, "ngIf"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "row clear-cart-link", 4, "ngIf"], [1, "row"], [1, "col-12", "px-0"], [3, "plans", "riders"], [3, "providedPrevious", "showPrevious"], ["previous-link", ""], [3, "title", "showArrow", "customClass", "makeInlineBlock", "role", "ariaLabel", "click", "keyup.enter", 4, "liveEditProp"], ["continue-button", ""], ["type", "button", "triggers", "manual", "continue-button", "", "class", "btn Spa_Style_PrimaryButton width-full width-md-initial col-md-auto", 3, "ngbTooltip", "click", "blur", 4, "ngIf"], [1, "col-auto", "mx-auto", "text-center", "mt-5", "width-fit-content"], [3, "title", "showArrow", "role", "ariaLabel", "click", "keyup.enter", 4, "liveEditProp"], [3, "title", "showArrow", "role", "ariaLabel", "click", "keyup.enter"], [1, "page-title", "Spa_Style_H1"], [3, "innerHtml"], [3, "bundlePlansPrompt", "marketingMessage", "shopButton", "shopAction"], ["type", "warn", 1, "row", "mb-3", 3, "title", "messages", "warningCustomClass"], [1, "row", "mb-3", 3, "type", "warningCustomClass", "buttonCustomClass", "hasButton", "buttonText", "title", "messages", "applyEvent"], [1, "mb-3"], [3, "shoppingCartHIPCallOutTitle", "shoppingCartHIPCallOutInstructional", "cartCallOutButtonText", "rateFactorModalTitle", "rateFactorFormPromptText", "rateFactorFormPageTitleText", "errorKeywordText", "errorNoticeTitle", "dropdownDefaultText", "enrollingPlan", "areAllHospitalIndemnityQuestionsAnswered", "addToQuoteMobileLimit", "addToQuoteDesktopLimit"], [1, "plan-card", "row", "mb-4"], ["aria-live", "off", 1, "w-100", "mb-2"], ["class", "card-header panel-header-cart", 4, "ngIf"], [1, "card-body", "card-body-cart"], ["class", "col-xs-12 col-sm-2 image-responsive", 4, "ngIf"], [1, "col-xs-12", "col-sm-7", "col-md-6"], ["class", "Spa_Style_IntroParagraph no-translate-block", 4, "ngIf"], ["class", "Spa_Style_Accent4_Color", 4, "ngIf"], ["class", "Spa_Style_Paragraph mt-2", 4, "ngIf"], [1, "actions", "d-flex"], ["id", "viewDetailsDescriptionText", 1, "hidden-off-screen"], [1, "no-translate-block"], [1, "px-2", "border-right", "can-click", 3, "title", "keyNameForLiveEdit", "role", "ariaLabel", "click", "keyup.enter"], ["type", "button", 1, "p-1", "can-click", "action-button", "Spa_Style_Link", "d-inline", 3, "title", "click"], [4, "liveEditProp"], ["class", "col-12 col-sm card-right-section", 4, "ngIf"], ["class", "w-100", "aria-live", "off", 3, "plan", "riders", "hideDetailsText", "showDetailsText", "replaceText", "addText", "includedText", "addOnRidersHeader", "viewDetailsLabelText", "hideDetailsLabelText", "removePlanText", "planRiderConflictMessageEnabled", "planRiderConflictMessageText", 4, "ngIf"], ["class", "plan-row row ml-0 pt-2 mt-2 mb-4 col-12 align-items-start", 4, "ngIf"], [4, "ngIf", "ngIfThen"], ["shoppingCartButton", ""], [1, "card-header", "panel-header-cart"], [1, "Spa_Style_H3"], ["class", "warn-container mb-2", 4, "ngIf"], [1, "warn-container", "mb-2"], [1, "Spa_Style_Accent4_Color", "fas", "fa-exclamation-triangle", "mr-2"], [1, "Spa_Style_Paragraph"], [1, "col-xs-12", "col-sm-2", "image-responsive"], [3, "alternateText", "imageSrc", "classNames", "planLogoSize"], [1, "Spa_Style_IntroParagraph", "no-translate-block"], [1, "Spa_Style_Accent4_Color"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-triangle", "mr-1"], ["navigationAdapter", "", 3, "innerHTML"], [1, "Spa_Style_Paragraph", "mt-2"], ["class", "can-click border-right", 3, "ngClass", "title", "ariaDescribedByText", "keyNameForLiveEdit", "role", "ariaLabel", "click", "keyup.enter", 4, "ngIf"], ["type", "button", "placement", "bottom-left", "triggers", "manual", "popoverClass", "hip-benefits-popover", 1, "pr-2", "can-click", "border-right", "action-button", "Spa_Style_Link", "d-inline", "view-benefits-button", 3, "autoClose", "ngbPopover", "click", "keyup.enter"], ["benefitsForHIPPopover", "ngbPopover"], [1, "ml-1", "fas", "fa-chevron-down"], [1, "sr-only"], [1, "can-click", "border-right", 3, "ngClass", "title", "ariaDescribedByText", "keyNameForLiveEdit", "role", "ariaLabel", "click", "keyup.enter"], [1, "col-12", "col-sm", "card-right-section"], ["class", "text-right Spa_Style_Paragraph", 4, "liveEditProp"], [1, "text-right", "Spa_Style_Cost_Text_Color", "Spa_Style_Semi_Bold_Weight", "Spa_Style_Large_Font"], [4, "ngIf", "ngIfElse"], ["showPremiumWithFees", ""], ["class", "text-right Spa_Style_Note Spa_Style_Primary_Color", 4, "ngIf"], [1, "text-right", "Spa_Style_Paragraph"], [3, "planFees", "planTotalPremium", "planFeesTooltipText", "planFeesIncludedInPremiumTooltipText", "planFeesNotIncludedInPremiumTooltipText", "customClass", "tooltipCustomClass"], [1, "text-right", "Spa_Style_Note", "Spa_Style_Primary_Color"], [3, "isMobile", "agentCallInProgressAcceptCallIcon", "agentCallRecordingPlanAllowsCallRecordingText"], ["aria-live", "off", 1, "w-100", 3, "plan", "riders", "hideDetailsText", "showDetailsText", "replaceText", "addText", "includedText", "addOnRidersHeader", "viewDetailsLabelText", "hideDetailsLabelText", "removePlanText", "planRiderConflictMessageEnabled", "planRiderConflictMessageText"], [1, "plan-row", "row", "ml-0", "pt-2", "mt-2", "mb-4", "col-12", "align-items-start"], ["class", "col-12 col-lg-6", 4, "ngIf"], [1, "col-12", "col-lg-3", "pt-4", "pt-lg-0"], [1, "col-12", "col-lg-6"], [3, "labelText", "consumerText", "consumerFormDefault", "brokerFormDefault", "brokerText", "plan", "errorKeyword", "errorText", "userFormType"], [3, "yesText", "noText", "titleText", "bodyText", "fullWidth", "planId"], ["class", "individual-continue-button col-12", 3, "ngClass", 4, "ngIf"], [1, "individual-continue-button", "col-12", 3, "ngClass"], [1, "application-submitted"], [1, "Spa_Style_Cost_Text_Color", "Spa_Style_Bold_Weight"], [1, "fas", "fa-check-circle", "mr-2"], [1, "Spa_Style_Paragraph", "text-right"], ["class", "Spa_Style_Note", 4, "ngIf"], [1, "d-flex", "flex-column", "flex-sm-row", "justify-content-sm-end", "align-items-sm-center"], ["type", "button", "triggers", "manual", "continue-button", "", 1, "btn", "Spa_Style_PrimaryButton", "width-full", "width-md-initial", "col-md-auto", 3, "ngbTooltip", "click", "blur"], ["enrollTooltip", "ngbTooltip"], [1, "Spa_Style_Note"], [1, "mr-2", "mb-2"], [1, "row", "clear-cart-link"], [1, "col-12", "text-center", "Spa_Style_Primary_Color"], [3, "outerText", "innerText", "customClass", "role", "ariaLabel", "innerTextClicked"], [3, "title", "showArrow", "customClass", "makeInlineBlock", "role", "ariaLabel", "click", "keyup.enter"], ["class", "empty-cart d-flex flex-column", 4, "ngIf"], [1, "empty-cart", "d-flex", "flex-column"], ["aria-hidden", "true", 1, "fa", "fa-shopping-cart"], [1, "col-12", "empty-shopping-cart"], ["class", "empty-cart-title Spa_Style_H3", 4, "liveEditProp"], [1, "mt-2", "mb-4", "Spa_Style_Paragraph"], ["class", "empty-cart-message m-0", 4, "liveEditProp"], ["class", "btn Spa_Style_PrimaryButton", 3, "click", 4, "liveEditProp"], [1, "d-flex", "justify-content-center", "pt-3"], [3, "title", "showArrow", "role", "ariaLabel", "click", 4, "liveEditProp"], [1, "empty-cart-title", "Spa_Style_H3"], ["class", "my-1", 3, "innerHtml", 4, "liveEditProp"], [1, "my-1", 3, "innerHtml"], [1, "empty-cart-message", "m-0"], [1, "btn", "Spa_Style_PrimaryButton", 3, "click"], [3, "title", "showArrow", "role", "ariaLabel", "click"], [3, "title", "button", "message"], [3, "title", "showArrow", "keyNameForLiveEdit", "click"], [3, "benefitsData", "closeButtonAction"]], template: function ShoppingCartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, ShoppingCartComponent_div_1_Template, 2, 4, "div", 1);
        i0.ɵɵtemplate(2, ShoppingCartComponent_ng_template_2_Template, 4, 6, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, ShoppingCartComponent_ng_template_4_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(3);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.enrollmentUnavailablePlanType)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, TotalPremiumBannerComponent, NavigationBannerComponent, LinkComponent, InnerTextLinkComponent, ShoppingCartCrossSellComponent, NoticeComponent, NavigationAdapterDirective, LiveEditPropDirective, GoogleTagManagerDirective, IconAriaAttributesDirective, i1$1.NgbPopover, i1$1.NgbTooltip, EnrollmentUnavailableComponent, HospitalIndemnityCoverageCartNudgeComponent, CartRiderComponent, PlanFeesTooltipComponent, ExistingMemberCartComponent, AgentFormSelectionComponent, BenefitsDisplayComponent, PlanLogoComponent, CallRecordingIconComponent, i1$2.AsyncPipe, i1$2.CurrencyPipe, SafePipe, OrderPipe], styles: [".cart-main-title[_ngcontent-%COMP%]{margin-top:40px;margin-bottom:60px;text-align:center}.page-title[_ngcontent-%COMP%]{margin:5px 15px 15px}.panel-header-cart[_ngcontent-%COMP%]{padding-left:15px}.image-responsive[_ngcontent-%COMP%]{padding-right:0;max-width:100%}.card-header[_ngcontent-%COMP%]{background:white;border-bottom:none}.card-header-cart[_ngcontent-%COMP%]{padding:15px 15px 10px;display:block}.card-body-cart[_ngcontent-%COMP%]{padding:0 15px 10px;display:block}.plan-row[_ngcontent-%COMP%]{border-top:1px solid rgba(0,0,0,.1)}.plan-card[_ngcontent-%COMP%]{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px;box-shadow:0 0 5px var(--static-Spa_Style_Accent1)}.cart-btn[_ngcontent-%COMP%]:not(:first-child){border-left:1px solid var(--static-Spa_Style_Gray2);padding-left:8px}.plan-name[_ngcontent-%COMP%]{margin-top:10px;margin-bottom:10px;font-weight:400;font-size:var(--Spa_Style_Regular_Font)}.actions[_ngcontent-%COMP%]{margin-top:15px;align-items:baseline}.empty-cart[_ngcontent-%COMP%]{text-align:center;padding-top:60px}.empty-cart[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{font-size:48px;color:var(--static-Spa_Style_Accent1)}.empty-cart-title[_ngcontent-%COMP%]{margin-top:30px}.empty-cart-message[_ngcontent-%COMP%]{line-height:28px}.previous-btn[_ngcontent-%COMP%]{float:left;margin:10px;font-size:14px}.continue-btn[_ngcontent-%COMP%]{float:right}@media (min-width: 768px){.view-benefits-button[_ngcontent-%COMP%]{white-space:nowrap}}.individual-continue-button[_ngcontent-%COMP%]{text-align:right}.clear-cart-link[_ngcontent-%COMP%]{margin-bottom:90px}.warning-text[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Warn_Darker)}"], changeDetection: 0 });
__decorate([
    PlatformProp('live-edit')
], ShoppingCartComponent.prototype, "Spa_Site_Previous", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_ChangePlan_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_Show_PlanLogo", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_RequestedStartDate_Enabled", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_PlanType_Enabled", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_PlanPremium_Enabled", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_PlanName_Enabled", void 0);
__decorate([
    PlatformProp('live-edit')
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_MyCart_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_RequestedStartDate_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_ViewDetails_Enabled", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_ViewDetails_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_RemovePlan_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_Enrollment_Enabled", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_MedSupEnrollment_Enabled", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_DentalEnrollment_Enabled", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_VisionEnrollment_Enabled", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_HIPEnrollment_Enabled", void 0);
__decorate([
    PlatformProp('live-edit')
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_ApplyButton_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_ShowPremiumAsAnnual", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_HideDetails_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_ShowDetails_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_Add_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_Replace_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_IncludedRider_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "SPA_Site_Medigap_Enrollment_InterimPage_Enable", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Enrollment_ShowExistingMemberPromptInCart_Flag", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_EnrollerButton_Tooltip_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_AddOnRiders_Header", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_NotApplicable_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_Yes", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_No", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_DentalHearingRiderInformationalSection_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_DentalRiderInformationalSection_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_DentalVisionHearingRiderInformationalSection_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_DentalVisionRiderInformationalSection_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_HearingRiderInformationalSection_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_VisionHearingRiderInformationalSection_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_VisionRiderInformationalSection_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_ErrorKeyword_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_EnrollmentErrorNotice_Title", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_PlanList_MedSupFormDropdownDefault_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_ConsumerBroker_Error_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_UserForm_Option_Title", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_ConsumerOption_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_BrokerOption_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_ExistingMember_Title", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_ConsumerOption_Default", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_BrokerOption_Default", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_EnrollInExternalPlansFirst_Enabled", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_ExistingMember_Body", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_ViewDetailsLink_Description_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_HideDetailsLink_Description_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_PlanViewDetails_Enabled", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_CrossSell_BothPlansExternalModal_Title", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_CrossSell_BothPlansExternalModal_Close", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_CrossSell_BothPlansExternalModal_Message", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_PcpWarning_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_EmptyCart_Title", void 0);
__decorate([
    PlatformProp('live-edit')
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_EmptyCart_Message", void 0);
__decorate([
    PlatformProp('live-edit')
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_EmptyCartButton_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_MedSupUnavailable_Message", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_EnrollmentUnavailable_Message", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_EnrollmentUnavailable_Title", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_EnrollmentUnavailable_Button", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_PCPPlanEligibilityCheck_Enabled", void 0);
__decorate([
    GlobalResource(true)
], ShoppingCartComponent.prototype, "Spa_Site_PCPPlanEligibilityCheck_PlanSubtypeItems", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_PlanList_Tab_Show_HIP", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_HIP_Call_Out_Available_Plan_Types", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_HIP_CallOut_Enabled", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_PlanDetails_HIP_RateFactorModal_Title", void 0);
__decorate([
    PlatformProp('live-edit')
], ShoppingCartComponent.prototype, "Spa_PlanList_HIPFormPrompt_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_HIP_CallOut_Title", void 0);
__decorate([
    PlatformProp('live-edit')
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_HIP_CallOut_Instructional", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_HIP_CallOut_Button_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], ShoppingCartComponent.prototype, "Spa_PlanList_HIP_PageTitle_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_PreviousLink_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], ShoppingCartComponent.prototype, "Spa_Site_PageSubHeader_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], ShoppingCartComponent.prototype, "Spa_Site_MonthlyPremiumLabel", void 0);
__decorate([
    PlatformProp('live-edit')
], ShoppingCartComponent.prototype, "Spa_Site_TotalMonthlyPremiumLabel", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_SOA_NotComplete_Title", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_SOA_NotComplete_Label", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_GoToProfile_Label", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_CheckSOACompleted_ShowGoToProfileButton_Enabled", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_PlanList_AddToQuote_Limit_Mobile", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_PlanList_AddToQuote_Limit", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_PlanLogo_Size", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_AgentCallRecording_DisplayPlanAllowsCallRecordingIcon_Enabled", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_AgentCallRecording_PlanAllowsCallRecording_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_AgentCallInProgressAcceptCall_Icon", void 0);
__decorate([
    PlatformProp('live-edit')
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_BenefitsSelection_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_BasedOnBenefits_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_EnrollmentConfirmation_ApplicationSubmitted_Title", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_LastVisitedOn_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_IndividualEnrollmentButtons_Enabled", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_ClearCart_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_ClearCartClickable_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_ClearCartLink_Enabled", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_EnrollmentConfirmation_Title", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Enrollment_Allow_AlreadyEnrolled_Plans", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_PlanRiderConflict_Enabled", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_PlanRiderConflict_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_EnrollmentConfirmation_DentalApplicationSubmitted_Title", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_EnrollmentConfirmation_VisionApplicationSubmitted_Title", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_EnrollmentConfirmation_HIPApplicationSubmitted_Title", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_HRAConfirmation_ApplicationSubmitted_Title", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_EnrollmentConfirmation_DentalNoticeBox_Header", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_EnrollmentConfirmation_VisionNoticeBox_Header", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_EnrollmentConfirmation_HIPNoticeBox_Header", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_EnrollmentConfirmation_DentalNoticeBox_Body", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_EnrollmentConfirmation_VisionNoticeBox_Body", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_EnrollmentConfirmation_HIPNoticeBox_Body", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_EnrollmentConfirmation_DentalWhatToExpect_Title", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_EnrollmentConfirmation_VisionWhatToExpect_Title", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_EnrollmentConfirmation_HIPWhatToExpect_Title", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_ShoppingCart_BackToPlansLink_Enabled", void 0);
__decorate([
    PlatformProp('live-edit')
], ShoppingCartComponent.prototype, "Spa_Enrollment_Plans_Not_Available_Go_Back_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_Site_PlanFees_Enabled", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_PlanFees_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_PlanFees_IncludedInPremium_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_EnrollMessageEnrollmentModal_Close", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_EnrollMessageEnrollmentModal_Continue", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_DualPlanEnrollMessage_EnrollmentModal_Enabled", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_DualPlanEnrollMessage_EnrollmentModalTitle_Text", void 0);
__decorate([
    GlobalResource()
], ShoppingCartComponent.prototype, "Spa_DualPlanEnrollMessage_EnrollmentModalBody_Text", void 0);
__decorate([
    LiveEditInactive()
], ShoppingCartComponent.prototype, "removeFromCart", null);
__decorate([
    LiveEditInactive()
], ShoppingCartComponent.prototype, "changePlanInCart", null);
__decorate([
    LiveEditInactive()
], ShoppingCartComponent.prototype, "emptyCartNavToPlans", null);
__decorate([
    LiveEditInactive()
], ShoppingCartComponent.prototype, "viewPlanDetails", null);
__decorate([
    LiveEditInactive()
], ShoppingCartComponent.prototype, "apply", null);
__decorate([
    LiveEditInactive()
], ShoppingCartComponent.prototype, "onContinueToApply", null);
__decorate([
    LiveEditInactive()
], ShoppingCartComponent.prototype, "enroll", null);
__decorate([
    LiveEditInactive()
], ShoppingCartComponent.prototype, "sendApplication", null);
__decorate([
    LiveEditInactive()
], ShoppingCartComponent.prototype, "resetStatus", null);
ShoppingCartComponent = __decorate([
    PlatformWidget
], ShoppingCartComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ShoppingCartComponent, [{
        type: Component,
        args: [{ selector: 'vnext-shopping-cart', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"container\">\r\n  <div\r\n    class=\"container\"\r\n    aria-live=\"polite\"\r\n    *ngIf=\"!enrollmentUnavailablePlanType; else enrollmentUnavailableSection\"\r\n    vnextGoogleTagManager\r\n    [tagsToUpdate]=\"tagsToUpdate\"\r\n    [saveDefaultValues]=\"true\"\r\n    [shouldUpdateTags]=\"shouldUpdateTags\"\r\n  >\r\n    <ng-container *ngIf=\"selectedPlans as plans\">\r\n      <ng-container *ngIf=\"plans.length; then cartWithItems; else emptyCart\"></ng-container>\r\n      <ng-template #cartWithItems>\r\n        <div *ngIf=\"Spa_ShoppingCart_BackToPlansLink_Enabled\" class=\"col-auto mx-auto text-center mt-5 width-fit-content\">\r\n          <vnext-link\r\n            [title]=\"Spa_Enrollment_Plans_Not_Available_Go_Back_Text\"\r\n            [showArrow]=\"'left'\"\r\n            (click)=\"backToPlanList()\"\r\n            (keyup.enter)=\"backToPlanList()\"\r\n            [role]=\"linkRoles.BUTTON\"\r\n            [ariaLabel]=\"Spa_Enrollment_Plans_Not_Available_Go_Back_Text\"\r\n            *liveEditProp=\"'Spa_ShoppingCart_BackToPlansLink_Enabled'\"\r\n          >\r\n          </vnext-link>\r\n        </div>\r\n        <div class=\"cart-main-title\" aria-live=\"off\">\r\n          <h1 class=\"page-title Spa_Style_H1\" *liveEditProp=\"'Spa_ShoppingCart_MyCart_Text'\">{{ Spa_ShoppingCart_MyCart_Text }}</h1>\r\n        </div>\r\n        <div class=\"col-12 mt-4\">\r\n          <div\r\n            *liveEditProp=\"'Spa_Site_PageSubHeader_Text'\"\r\n            [innerHtml]=\"Spa_Site_PageSubHeader_Text ? (Spa_Site_PageSubHeader_Text | safe : 'html') : ''\"\r\n          ></div>\r\n        </div>\r\n        <vnext-shopping-cart-cross-sell\r\n          *ngIf=\"!!crossSellAttributes && showCrossSellOnShoppingCart\"\r\n          [bundlePlansPrompt]=\"crossSellAttributes.bundlePlansPrompt\"\r\n          [marketingMessage]=\"crossSellAttributes.marketingMessage\"\r\n          [shopButton]=\"crossSellAttributes.shopButton\"\r\n          [shopAction]=\"crossSellAttributes.shopAction\"\r\n        >\r\n        </vnext-shopping-cart-cross-sell>\r\n        <vnext-notice\r\n          class=\"row mb-3\"\r\n          type=\"warn\"\r\n          [title]=\"sendEnrollmentFacade.getRestrictProfessionalPlansNoticeTitle()\"\r\n          [messages]=\"sendEnrollmentFacade.getRestrictProfessionalPlansNoticeMessage()\"\r\n          [warningCustomClass]=\"'mb-0'\"\r\n          *ngIf=\"sendEnrollmentFacade.isPlanRestricted(plans[0])\"\r\n        >\r\n        </vnext-notice>\r\n        <vnext-notice\r\n          *ngIf=\"showSOANotCompleted\"\r\n          class=\"row mb-3\"\r\n          [type]=\"'warn'\"\r\n          [warningCustomClass]=\"'mb-0'\"\r\n          [buttonCustomClass]=\"'float-right align-middle'\"\r\n          [hasButton]=\"Spa_Site_CheckSOACompleted_ShowGoToProfileButton_Enabled\"\r\n          [buttonText]=\"Spa_Site_GoToProfile_Label\"\r\n          [title]=\"Spa_Site_SOA_NotComplete_Title\"\r\n          [messages]=\"soaNotCompletedMessages\"\r\n          (applyEvent)=\"navigateToMemberProfilePage()\"\r\n        >\r\n        </vnext-notice>\r\n        <div\r\n          class=\"mb-3\"\r\n          *ngIf=\"\r\n            Spa_PlanList_Tab_Show_HIP &&\r\n            Spa_ShoppingCart_HIP_CallOut_Enabled &&\r\n            isHIPCallOutAvailableToShoppingCart &&\r\n            hasHospitalIndemnityQuestions\r\n          \"\r\n        >\r\n          <vnext-hospital-indemnity-coverage-cart-nudge\r\n            [shoppingCartHIPCallOutTitle]=\"Spa_ShoppingCart_HIP_CallOut_Title\"\r\n            [shoppingCartHIPCallOutInstructional]=\"Spa_ShoppingCart_HIP_CallOut_Instructional\"\r\n            [cartCallOutButtonText]=\"Spa_ShoppingCart_HIP_CallOut_Button_Text\"\r\n            [rateFactorModalTitle]=\"Spa_PlanDetails_HIP_RateFactorModal_Title\"\r\n            [rateFactorFormPromptText]=\"Spa_PlanList_HIPFormPrompt_Text\"\r\n            [rateFactorFormPageTitleText]=\"Spa_PlanList_HIP_PageTitle_Text\"\r\n            [errorKeywordText]=\"Spa_Site_ErrorKeyword_Text\"\r\n            [errorNoticeTitle]=\"Spa_Site_EnrollmentErrorNotice_Title\"\r\n            [dropdownDefaultText]=\"Spa_PlanList_MedSupFormDropdownDefault_Text\"\r\n            [enrollingPlan]=\"enrollingPlan\"\r\n            [areAllHospitalIndemnityQuestionsAnswered]=\"areAllHospitalIndemnityQuestionsAnswered\"\r\n            [addToQuoteMobileLimit]=\"Spa_PlanList_AddToQuote_Limit_Mobile\"\r\n            [addToQuoteDesktopLimit]=\"Spa_PlanList_AddToQuote_Limit\"\r\n          >\r\n          </vnext-hospital-indemnity-coverage-cart-nudge>\r\n        </div>\r\n        <ng-container *ngFor=\"let plan of plans | orderBy : sortOption; trackBy: plansTrackByFn\">\r\n          <div class=\"plan-card row mb-4\">\r\n            <div class=\"w-100 mb-2\" aria-live=\"off\">\r\n              <div class=\"card-header panel-header-cart\" *ngIf=\"Spa_ShoppingCart_PlanType_Enabled\">\r\n                <h2 class=\"Spa_Style_H3\">\r\n                  {{ plansConfig[plan.id]?.planDescription }}\r\n                </h2>\r\n                <div\r\n                  *ngIf=\"Spa_ShoppingCart_PlanRiderConflict_Enabled && !!planRiderConflicts[plan.id]?.length\"\r\n                  class=\"warn-container mb-2\"\r\n                >\r\n                  <i class=\"Spa_Style_Accent4_Color fas fa-exclamation-triangle mr-2\"></i\r\n                  ><span class=\"Spa_Style_Paragraph\">{{ Spa_ShoppingCart_PlanRiderConflict_Text }}</span>\r\n                </div>\r\n              </div>\r\n              <div class=\"card-body card-body-cart\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-xs-12 col-sm-2 image-responsive\" *ngIf=\"Spa_Site_Show_PlanLogo && getPlanLogo(plan)\">\r\n                    <vnext-plan-logo\r\n                      [alternateText]=\"plan.planName\"\r\n                      [imageSrc]=\"getPlanLogo(plan)\"\r\n                      [classNames]=\"'plan-logo'\"\r\n                      [planLogoSize]=\"Spa_Site_PlanLogo_Size\"\r\n                    ></vnext-plan-logo>\r\n                  </div>\r\n                  <div class=\"col-xs-12 col-sm-7 col-md-6\">\r\n                    <h3 class=\"Spa_Style_IntroParagraph no-translate-block\" *ngIf=\"Spa_ShoppingCart_PlanName_Enabled\">\r\n                      {{ plan.planName }}\r\n                    </h3>\r\n                    <div *ngIf=\"planIdsWithInvalidPCP.includes(plan.id)\" class=\"Spa_Style_Accent4_Color\">\r\n                      <i class=\"fas fa-exclamation-triangle mr-1\" aria-hidden=\"true\"></i\r\n                      ><span [innerHTML]=\"getPcpWarningText() | safe : 'html'\" navigationAdapter></span>\r\n                    </div>\r\n                    <div\r\n                      class=\"Spa_Style_Paragraph mt-2\"\r\n                      *ngIf=\"\r\n                        Spa_ShoppingCart_RequestedStartDate_Enabled &&\r\n                        plansConfig[plan.id]?.isPlanTypeAncillaryOrMedigap &&\r\n                        !!(effectiveDate$ | async)\r\n                      \"\r\n                    >\r\n                      {{ Spa_ShoppingCart_RequestedStartDate_Text }}: {{ getFormattedEffectiveDate$() | async }}\r\n                    </div>\r\n                    <div class=\"actions d-flex\">\r\n                      <p id=\"viewDetailsDescriptionText\" class=\"hidden-off-screen\">\r\n                        {{ Spa_Site_ViewDetailsLink_Description_Text }} <span class=\"no-translate-block\">{{ plan.planName }}</span>\r\n                      </p>\r\n                      <ng-container *ngIf=\"Spa_Site_PlanViewDetails_Enabled\">\r\n                        <ng-container *ngIf=\"plan.planTypeAbbreviation === planTypeAbbreviation.HC\">\r\n                          <button\r\n                            type=\"button\"\r\n                            class=\"pr-2 can-click border-right action-button Spa_Style_Link d-inline view-benefits-button\"\r\n                            (click)=\"showHospitalIndemnityBenefits(plan)\"\r\n                            (keyup.enter)=\"showHospitalIndemnityBenefits(plan)\"\r\n                            placement=\"bottom-left\"\r\n                            triggers=\"manual\"\r\n                            [autoClose]=\"'outside'\"\r\n                            [ngbPopover]=\"benefitsForHIPPopoverTemplate\"\r\n                            #benefitsForHIPPopover=\"ngbPopover\"\r\n                            popoverClass=\"hip-benefits-popover\"\r\n                          >\r\n                            <span *liveEditProp=\"'Spa_ShoppingCart_BenefitsSelection_Text'\"\r\n                              >{{ Spa_ShoppingCart_BenefitsSelection_Text }}<i class=\"ml-1 fas fa-chevron-down\"></i\r\n                            ><span class=\"sr-only\">Expand</span></span>\r\n                          </button>\r\n                        </ng-container>\r\n                        <vnext-link\r\n                          *ngIf=\"Spa_ShoppingCart_ViewDetails_Enabled\"\r\n                          class=\"can-click border-right\"\r\n                          [ngClass]=\"plan.planTypeAbbreviation === planTypeAbbreviation.HC ? 'px-2' : 'pr-2'\"\r\n                          (click)=\"viewPlanDetails(plan)\"\r\n                          (keyup.enter)=\"viewPlanDetails(plan)\"\r\n                          [title]=\"Spa_ShoppingCart_ViewDetails_Text\"\r\n                          [ariaDescribedByText]=\"'viewDetailsDescriptionText'\"\r\n                          [keyNameForLiveEdit]=\"'Spa_ShoppingCart_ViewDetails_Text'\"\r\n                          [role]=\"linkRoles.BUTTON\"\r\n                          [ariaLabel]=\"Spa_ShoppingCart_ViewDetails_Text\"\r\n                        ></vnext-link>\r\n                      </ng-container>\r\n                      <vnext-link\r\n                        class=\"px-2 border-right can-click\"\r\n                        (click)=\"changePlanInCart(plan)\"\r\n                        (keyup.enter)=\"changePlanInCart(plan)\"\r\n                        [title]=\"Spa_ShoppingCart_ChangePlan_Text\"\r\n                        [keyNameForLiveEdit]=\"'Spa_ShoppingCart_ChangePlan_Text'\"\r\n                        [role]=\"linkRoles.BUTTON\"\r\n                        [ariaLabel]=\"Spa_ShoppingCart_ChangePlan_Text\"\r\n                      ></vnext-link>\r\n                      <button\r\n                        type=\"button\"\r\n                        class=\"p-1 can-click action-button Spa_Style_Link d-inline\"\r\n                        (click)=\"removeFromCart(plan)\"\r\n                        [title]=\"Spa_ShoppingCart_RemovePlan_Text\"\r\n                        [attr.aria-label]=\"Spa_ShoppingCart_RemovePlan_Text\"\r\n                      >\r\n                        <span *liveEditProp=\"'Spa_ShoppingCart_RemovePlan_Text'\"> {{ Spa_ShoppingCart_RemovePlan_Text }}</span>\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-12 col-sm card-right-section\" *ngIf=\"Spa_ShoppingCart_PlanPremium_Enabled\">\r\n                    <div *liveEditProp=\"'Spa_Site_MonthlyPremiumLabel'\" class=\"text-right Spa_Style_Paragraph\">\r\n                      {{ premiumLabel }}\r\n                    </div>\r\n                    <div class=\"text-right Spa_Style_Cost_Text_Color Spa_Style_Semi_Bold_Weight Spa_Style_Large_Font\">\r\n                      <ng-container *ngIf=\"!Spa_Site_PlanFees_Enabled || !plan.fees?.length; else showPremiumWithFees\">\r\n                        {{ plansConfig[plan.id]?.planTotalPremium || 0 | currency }}\r\n                      </ng-container>\r\n\r\n                      <ng-template #showPremiumWithFees>\r\n                        <vnext-widget-plan-fees-tooltip\r\n                          [planFees]=\"plan.fees\"\r\n                          [planTotalPremium]=\"plansConfig[plan.id]?.planTotalPremium || 0\"\r\n                          [planFeesTooltipText]=\"Spa_PlanFees_Tooltip_Text\"\r\n                          [planFeesIncludedInPremiumTooltipText]=\"Spa_PlanFees_IncludedInPremium_Tooltip_Text\"\r\n                          [planFeesNotIncludedInPremiumTooltipText]=\"Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text\"\r\n                          [customClass]=\"'inline-block-layout'\"\r\n                          [tooltipCustomClass]=\"'inline-block-layout'\"\r\n                        ></vnext-widget-plan-fees-tooltip>\r\n                      </ng-template>\r\n                    </div>\r\n                    <div\r\n                      *ngIf=\"plan.planTypeAbbreviation === planTypeAbbreviation.HC\"\r\n                      class=\"text-right Spa_Style_Note Spa_Style_Primary_Color\"\r\n                    >\r\n                      <span *liveEditProp=\"'Spa_ShoppingCart_BasedOnBenefits_Text'\">{{ Spa_ShoppingCart_BasedOnBenefits_Text }}</span>\r\n                    </div>\r\n                    <ng-container *ngIf=\"!showIndividualContinueButtons && plansConfig[plan.id]?.allowsCallRecording\">\r\n                      <vnext-call-recording-icon\r\n                        [isMobile]=\"isMobile\"\r\n                        [agentCallInProgressAcceptCallIcon]=\"Spa_AgentCallInProgressAcceptCall_Icon\"\r\n                        [agentCallRecordingPlanAllowsCallRecordingText]=\"Spa_Site_AgentCallRecording_PlanAllowsCallRecording_Text\"\r\n                      >\r\n                      </vnext-call-recording-icon>\r\n                    </ng-container>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <vnext-cart-rider\r\n              *ngIf=\"!Spa_Site_ShowPremiumAsAnnual && plan.planTypeAbbreviation !== planTypeAbbreviation.HC && plan.riders?.length\"\r\n              class=\"w-100\"\r\n              aria-live=\"off\"\r\n              [plan]=\"plan\"\r\n              [riders]=\"plan.riders\"\r\n              [hideDetailsText]=\"Spa_ShoppingCart_HideDetails_Text\"\r\n              [showDetailsText]=\"Spa_ShoppingCart_ShowDetails_Text\"\r\n              [replaceText]=\"Spa_ShoppingCart_Replace_Text\"\r\n              [addText]=\"Spa_ShoppingCart_Add_Text\"\r\n              [includedText]=\"Spa_ShoppingCart_IncludedRider_Text\"\r\n              [addOnRidersHeader]=\"Spa_ShoppingCart_AddOnRiders_Header\"\r\n              [viewDetailsLabelText]=\"Spa_Site_ViewDetailsLink_Description_Text\"\r\n              [hideDetailsLabelText]=\"Spa_Site_HideDetailsLink_Description_Text\"\r\n              [removePlanText]=\"Spa_ShoppingCart_RemovePlan_Text\"\r\n              [planRiderConflictMessageEnabled]=\"Spa_ShoppingCart_PlanRiderConflict_Enabled\"\r\n              [planRiderConflictMessageText]=\"Spa_ShoppingCart_PlanRiderConflict_Text\"\r\n            ></vnext-cart-rider>\r\n            <div\r\n              class=\"plan-row row ml-0 pt-2 mt-2 mb-4 col-12 align-items-start\"\r\n              *ngIf=\"plansConfig[plan.id]?.showConsumerBrokerSelection || plansConfig[plan.id]?.isPlanWithShortForm\"\r\n            >\r\n              <div class=\"col-12 col-lg-6\" *ngIf=\"plansConfig[plan.id]?.showConsumerBrokerSelection\">\r\n                <vnext-agent-form-selection\r\n                  [labelText]=\"Spa_ShoppingCart_UserForm_Option_Title\"\r\n                  [consumerText]=\"Spa_ShoppingCart_ConsumerOption_Text\"\r\n                  [consumerFormDefault]=\"Spa_ShoppingCart_ConsumerOption_Default\"\r\n                  [brokerFormDefault]=\"Spa_ShoppingCart_BrokerOption_Default\"\r\n                  [brokerText]=\"Spa_ShoppingCart_BrokerOption_Text\"\r\n                  [plan]=\"plan\"\r\n                  [errorKeyword]=\"Spa_Site_ErrorKeyword_Text\"\r\n                  [errorText]=\"Spa_ShoppingCart_ConsumerBroker_Error_Text\"\r\n                  (userFormType)=\"updateUserFormType($event, plan.id)\"\r\n                >\r\n                </vnext-agent-form-selection>\r\n              </div>\r\n              <div class=\"col-12 col-lg-3 pt-4 pt-lg-0\">\r\n                <ng-container *ngIf=\"plansConfig[plan.id]?.isPlanWithShortForm\">\r\n                  <vnext-existing-member-cart\r\n                    [yesText]=\"Spa_Site_Yes\"\r\n                    [noText]=\"Spa_Site_No\"\r\n                    [titleText]=\"Spa_ShoppingCart_ExistingMember_Title\"\r\n                    [bodyText]=\"Spa_ShoppingCart_ExistingMember_Body\"\r\n                    [fullWidth]=\"showConsumerBrokerSelection(enrollingPlan)\"\r\n                    [planId]=\"plan.id\"\r\n                  >\r\n                  </vnext-existing-member-cart>\r\n                </ng-container>\r\n              </div>\r\n              <ng-container *ngIf=\"plansConfig[plan.id]?.shouldAlignCartButton; then shoppingCartButton\"> </ng-container>\r\n            </div>\r\n            <ng-container *ngIf=\"!plansConfig[plan.id]?.shouldAlignCartButton; then shoppingCartButton\"> </ng-container>\r\n            <ng-template #shoppingCartButton>\r\n              <div\r\n                *ngIf=\"showIndividualContinueButtons\"\r\n                class=\"individual-continue-button col-12\"\r\n                [ngClass]=\"!plansConfig[plan.id]?.shouldAlignCartButton ? 'mb-3' : 'col-lg-3 pt-4 pt-lg-0 px-0 ml-auto'\"\r\n              >\r\n                <ng-container *ngIf=\"enrolledPlanIds?.includes(plan.id)\">\r\n                  <div class=\"application-submitted\">\r\n                    <div class=\"Spa_Style_Cost_Text_Color Spa_Style_Bold_Weight\">\r\n                      <i class=\"fas fa-check-circle mr-2\"></i>{{ Spa_EnrollmentConfirmation_ApplicationSubmitted_Title }}\r\n                    </div>\r\n                    <div class=\"Spa_Style_Paragraph text-right\">\r\n                      {{ Spa_EnrollmentConfirmation_Title }} #{{ confirmationNumberMap[plan.id] }}\r\n                    </div>\r\n                  </div>\r\n                </ng-container>\r\n                <ng-container *ngIf=\"Spa_Enrollment_Allow_AlreadyEnrolled_Plans || !enrolledPlanIds?.includes(plan.id)\">\r\n                  <div class=\"Spa_Style_Note\" *ngIf=\"lastAccessedDates[plan.id]\">\r\n                    {{ Spa_Site_LastVisitedOn_Text }} {{ lastAccessedDates[plan.id] }}\r\n                  </div>\r\n                  <div class=\"d-flex flex-column flex-sm-row justify-content-sm-end align-items-sm-center\">\r\n                    <ng-container *ngIf=\"plansConfig[plan.id]?.allowsCallRecording\">\r\n                      <div class=\"mr-2 mb-2\">\r\n                        <vnext-call-recording-icon\r\n                          [isMobile]=\"isMobile\"\r\n                          [agentCallInProgressAcceptCallIcon]=\"Spa_AgentCallInProgressAcceptCall_Icon\"\r\n                          [agentCallRecordingPlanAllowsCallRecordingText]=\"Spa_Site_AgentCallRecording_PlanAllowsCallRecording_Text\"\r\n                        >\r\n                        </vnext-call-recording-icon>\r\n                      </div>\r\n                    </ng-container>\r\n                    <div continue-button>\r\n                      <button\r\n                        type=\"button\"\r\n                        triggers=\"manual\"\r\n                        #enrollTooltip=\"ngbTooltip\"\r\n                        [ngbTooltip]=\"Spa_Site_EnrollerButton_Tooltip_Text\"\r\n                        continue-button\r\n                        class=\"btn Spa_Style_PrimaryButton width-full width-md-initial col-md-auto\"\r\n                        (click)=\"onContinueToApply(enrollTooltip, plan.id)\"\r\n                        (blur)=\"cartFacade.closeTooltip(enrollTooltip)\"\r\n                      >\r\n                        <span *liveEditProp=\"'Spa_ShoppingCart_ApplyButton_Text'\">{{ enrollFacade.getShoppingCartApplyButtonText() }}</span>\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                </ng-container>\r\n              </div>\r\n            </ng-template>\r\n          </div>\r\n        </ng-container>\r\n        <!-- end plan shopping card -->\r\n        <div *ngIf=\"Spa_ShoppingCart_ClearCartLink_Enabled && plans?.length\" class=\"row clear-cart-link\">\r\n          <div class=\"col-12 text-center Spa_Style_Primary_Color\">\r\n            <vnext-inner-text-link\r\n              [outerText]=\"Spa_ShoppingCart_ClearCart_Text\"\r\n              [innerText]=\"Spa_ShoppingCart_ClearCartClickable_Text\"\r\n              (innerTextClicked)=\"clearShoppingCart()\"\r\n              [customClass]=\"'Spa_Style_Regular_Font Spa_Style_Primary_Link_Color Spa_Style_Link'\"\r\n              [role]=\"linkRoles.BUTTON\"\r\n              [ariaLabel]=\"Spa_ShoppingCart_ClearCartClickable_Text\"\r\n            >\r\n            </vnext-inner-text-link>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col-12 px-0\">\r\n            <vnext-total-premium-banner [plans]=\"plans\" [riders]=\"riders$ | async\"></vnext-total-premium-banner>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col-12 px-0\">\r\n            <vnext-navigation-banner [providedPrevious]=\"true\" [showPrevious]=\"true\">\r\n              <div previous-link>\r\n                <vnext-link\r\n                  [title]=\"Spa_Site_Previous\"\r\n                  [showArrow]=\"'left'\"\r\n                  (click)=\"backToPrevious()\"\r\n                  [customClass]=\"'Spa_Style_Link p-1'\"\r\n                  (keyup.enter)=\"backToPrevious()\"\r\n                  [makeInlineBlock]=\"true\"\r\n                  [role]=\"linkRoles.BUTTON\"\r\n                  [ariaLabel]=\"Spa_Site_Previous\"\r\n                  *liveEditProp=\"'Spa_Site_Previous'\"\r\n                >\r\n                </vnext-link>\r\n              </div>\r\n              <div continue-button>\r\n                <button\r\n                  *ngIf=\"!showIndividualContinueButtons\"\r\n                  type=\"button\"\r\n                  triggers=\"manual\"\r\n                  #enrollTooltip=\"ngbTooltip\"\r\n                  [ngbTooltip]=\"Spa_Site_EnrollerButton_Tooltip_Text\"\r\n                  continue-button\r\n                  class=\"btn Spa_Style_PrimaryButton width-full width-md-initial col-md-auto\"\r\n                  (click)=\"onContinueToApply(enrollTooltip)\"\r\n                  (blur)=\"cartFacade.closeTooltip(enrollTooltip)\"\r\n                >\r\n                  <span *liveEditProp=\"'Spa_ShoppingCart_ApplyButton_Text'\">{{ enrollFacade.getShoppingCartApplyButtonText() }}</span>\r\n                </button>\r\n              </div>\r\n            </vnext-navigation-banner>\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template #emptyCart>\r\n        <div *ngIf=\"showEmptyCart\" class=\"empty-cart d-flex flex-column\">\r\n          <i class=\"fa fa-shopping-cart\" aria-hidden=\"true\"></i>\r\n          <div class=\"col-12 empty-shopping-cart\">\r\n            <h3 class=\"empty-cart-title Spa_Style_H3\" *liveEditProp=\"'Spa_ShoppingCart_EmptyCart_Title'\">\r\n              {{ Spa_ShoppingCart_EmptyCart_Title }}\r\n            </h3>\r\n            <div class=\"mt-2 mb-4 Spa_Style_Paragraph\">\r\n              <ng-container *ngIf=\"Spa_Site_PageSubHeader_Text?.length > 0\">\r\n                <p\r\n                  class=\"my-1\"\r\n                  *liveEditProp=\"'Spa_Site_PageSubHeader_Text'\"\r\n                  [innerHtml]=\"Spa_Site_PageSubHeader_Text ? (Spa_Site_PageSubHeader_Text | safe : 'html') : ''\"\r\n                ></p>\r\n              </ng-container>\r\n\r\n              <p class=\"empty-cart-message m-0\" *liveEditProp=\"'Spa_ShoppingCart_EmptyCart_Message'\">\r\n                {{ Spa_ShoppingCart_EmptyCart_Message }}\r\n              </p>\r\n            </div>\r\n          </div>\r\n          <button\r\n            class=\"btn Spa_Style_PrimaryButton\"\r\n            (click)=\"emptyCartNavToPlans()\"\r\n            *liveEditProp=\"'Spa_ShoppingCart_EmptyCartButton_Text'\"\r\n          >\r\n            {{ Spa_ShoppingCart_EmptyCartButton_Text }}\r\n          </button>\r\n          <div class=\"d-flex justify-content-center pt-3\">\r\n            <vnext-link\r\n              [title]=\"Spa_Site_Previous\"\r\n              [showArrow]=\"'left'\"\r\n              *liveEditProp=\"'Spa_Site_Previous'\"\r\n              [role]=\"linkRoles.BUTTON\"\r\n              [ariaLabel]=\"Spa_Site_Previous\"\r\n              (click)=\"configurableWidgetService.navigationService.backToPrevious()\"\r\n            >\r\n            </vnext-link>\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n    </ng-container>\r\n  </div>\r\n  <ng-template #enrollmentUnavailableSection>\r\n    <div class=\"container\">\r\n      <vnext-enrollment-unavailable\r\n        [title]=\"Spa_ShoppingCart_EnrollmentUnavailable_Title\"\r\n        [button]=\"Spa_ShoppingCart_EnrollmentUnavailable_Button\"\r\n        [message]=\"getEnrollmentUnavailableMessage()\"\r\n      >\r\n      </vnext-enrollment-unavailable>\r\n      <div class=\"d-flex justify-content-center pt-3\">\r\n        <vnext-link\r\n          [title]=\"Spa_ShoppingCart_PreviousLink_Text\"\r\n          (click)=\"resetStatus()\"\r\n          [showArrow]=\"'left'\"\r\n          [keyNameForLiveEdit]=\"'Spa_ShoppingCart_PreviousLink_Text'\"\r\n        >\r\n        </vnext-link>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n\r\n<ng-template #benefitsForHIPPopoverTemplate let-benefitsData=\"selectedBenefitDetails\">\r\n  <vnext-benefits-display [benefitsData]=\"benefitsData\" (closeButtonAction)=\"closeHIPBenefitsPopover()\"></vnext-benefits-display>\r\n</ng-template>\r\n", styles: [".cart-main-title{margin-top:40px;margin-bottom:60px;text-align:center}.page-title{margin:5px 15px 15px}.panel-header-cart{padding-left:15px}.image-responsive{padding-right:0;max-width:100%}.card-header{background:white;border-bottom:none}.card-header-cart{padding:15px 15px 10px;display:block}.card-body-cart{padding:0 15px 10px;display:block}.plan-row{border-top:1px solid rgba(0,0,0,.1)}.plan-card{border:1px solid var(--static-Spa_Style_Accent1);border-radius:5px;box-shadow:0 0 5px var(--static-Spa_Style_Accent1)}.cart-btn:not(:first-child){border-left:1px solid var(--static-Spa_Style_Gray2);padding-left:8px}.plan-name{margin-top:10px;margin-bottom:10px;font-weight:400;font-size:var(--Spa_Style_Regular_Font)}.actions{margin-top:15px;align-items:baseline}.empty-cart{text-align:center;padding-top:60px}.empty-cart>i{font-size:48px;color:var(--static-Spa_Style_Accent1)}.empty-cart-title{margin-top:30px}.empty-cart-message{line-height:28px}.previous-btn{float:left;margin:10px;font-size:14px}.continue-btn{float:right}@media (min-width: 768px){.view-benefits-button{white-space:nowrap}}.individual-continue-button{text-align:right}.clear-cart-link{margin-bottom:90px}.warning-text{color:var(--static-Spa_Style_Warn_Darker)}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i2.Store }, { type: i0.Injector }, { type: i1.NavigationService }, { type: i1.ShoppingCartService }, { type: ShoppingCartContextService }, { type: i1.DemographicService }, { type: i1.ConfigResourceService }, { type: i1.JsonAnalyticsService }, { type: i1.LocaleService }, { type: i1.PlansService }, { type: i1.SpinnerService }, { type: CartFacade }, { type: PlanFacade }, { type: EnrollmentFormFacade }, { type: SendEnrollmentFacade }, { type: CrossSellPlanContext }, { type: i1.EnrollmentFormService }, { type: EnrollmentConfirmationService }, { type: i1.LiveEditStateContext }, { type: i1$1.NgbModal }, { type: ProviderFacade }, { type: CreateAccountContext }, { type: AgentCallRecordingFacade }, { type: LoginFacade }, { type: AnalyticsService }, { type: PlanListFacadeService }, { type: SOAFacade }, { type: i1.ResponsiveLayoutService }, { type: i1.PlanRiderTypeConflictContextService }, { type: i1.TwilioDeviceService }, { type: i2$1.ActivatedRoute }, { type: i1.ExternalEnrollmentContext }, { type: i1.SiteService }]; }, { benefitsForHIPPopover: [{
            type: ViewChild,
            args: ['benefitsForHIPPopover']
        }], Spa_Site_Previous: [], Spa_ShoppingCart_ChangePlan_Text: [], Spa_Site_Show_PlanLogo: [], Spa_ShoppingCart_RequestedStartDate_Enabled: [], Spa_ShoppingCart_PlanType_Enabled: [], Spa_ShoppingCart_PlanPremium_Enabled: [], Spa_ShoppingCart_PlanName_Enabled: [], Spa_ShoppingCart_MyCart_Text: [], Spa_ShoppingCart_RequestedStartDate_Text: [], Spa_ShoppingCart_ViewDetails_Enabled: [], Spa_ShoppingCart_ViewDetails_Text: [], Spa_ShoppingCart_RemovePlan_Text: [], Spa_Site_Enrollment_Enabled: [], Spa_Site_MedSupEnrollment_Enabled: [], Spa_Site_DentalEnrollment_Enabled: [], Spa_Site_VisionEnrollment_Enabled: [], Spa_Site_HIPEnrollment_Enabled: [], Spa_ShoppingCart_ApplyButton_Text: [], Spa_Site_ShowPremiumAsAnnual: [], Spa_ShoppingCart_HideDetails_Text: [], Spa_ShoppingCart_ShowDetails_Text: [], Spa_ShoppingCart_Add_Text: [], Spa_ShoppingCart_Replace_Text: [], Spa_ShoppingCart_IncludedRider_Text: [], SPA_Site_Medigap_Enrollment_InterimPage_Enable: [], Spa_Enrollment_ShowExistingMemberPromptInCart_Flag: [], Spa_Site_EnrollerButton_Tooltip_Text: [], Spa_ShoppingCart_AddOnRiders_Header: [], Spa_Site_NotApplicable_Text: [], Spa_Site_Yes: [], Spa_Site_No: [], Spa_ShoppingCart_DentalHearingRiderInformationalSection_Text: [], Spa_ShoppingCart_DentalRiderInformationalSection_Text: [], Spa_ShoppingCart_DentalVisionHearingRiderInformationalSection_Text: [], Spa_ShoppingCart_DentalVisionRiderInformationalSection_Text: [], Spa_ShoppingCart_HearingRiderInformationalSection_Text: [], Spa_ShoppingCart_VisionHearingRiderInformationalSection_Text: [], Spa_ShoppingCart_VisionRiderInformationalSection_Text: [], Spa_Site_ErrorKeyword_Text: [], Spa_Site_EnrollmentErrorNotice_Title: [], Spa_PlanList_MedSupFormDropdownDefault_Text: [], Spa_ShoppingCart_ConsumerBroker_Error_Text: [], Spa_ShoppingCart_UserForm_Option_Title: [], Spa_ShoppingCart_ConsumerOption_Text: [], Spa_ShoppingCart_BrokerOption_Text: [], Spa_ShoppingCart_ExistingMember_Title: [], Spa_ShoppingCart_ConsumerOption_Default: [], Spa_ShoppingCart_BrokerOption_Default: [], Spa_Site_EnrollInExternalPlansFirst_Enabled: [], Spa_ShoppingCart_ExistingMember_Body: [], Spa_Site_ViewDetailsLink_Description_Text: [], Spa_Site_HideDetailsLink_Description_Text: [], Spa_Site_PlanViewDetails_Enabled: [], Spa_CrossSell_BothPlansExternalModal_Title: [], Spa_CrossSell_BothPlansExternalModal_Close: [], Spa_CrossSell_BothPlansExternalModal_Message: [], Spa_ShoppingCart_PcpWarning_Text: [], Spa_ShoppingCart_EmptyCart_Title: [], Spa_ShoppingCart_EmptyCart_Message: [], Spa_ShoppingCart_EmptyCartButton_Text: [], Spa_ShoppingCart_MedSupUnavailable_Message: [], Spa_ShoppingCart_EnrollmentUnavailable_Message: [], Spa_ShoppingCart_EnrollmentUnavailable_Title: [], Spa_ShoppingCart_EnrollmentUnavailable_Button: [], Spa_Site_PCPPlanEligibilityCheck_Enabled: [], Spa_Site_PCPPlanEligibilityCheck_PlanSubtypeItems: [], Spa_PlanList_Tab_Show_HIP: [], Spa_ShoppingCart_HIP_Call_Out_Available_Plan_Types: [], Spa_ShoppingCart_HIP_CallOut_Enabled: [], Spa_PlanDetails_HIP_RateFactorModal_Title: [], Spa_PlanList_HIPFormPrompt_Text: [], Spa_ShoppingCart_HIP_CallOut_Title: [], Spa_ShoppingCart_HIP_CallOut_Instructional: [], Spa_ShoppingCart_HIP_CallOut_Button_Text: [], Spa_PlanList_HIP_PageTitle_Text: [], Spa_ShoppingCart_PreviousLink_Text: [], Spa_Site_PageSubHeader_Text: [], Spa_Site_MonthlyPremiumLabel: [], Spa_Site_TotalMonthlyPremiumLabel: [], Spa_Site_SOA_NotComplete_Title: [], Spa_Site_SOA_NotComplete_Label: [], Spa_Site_GoToProfile_Label: [], Spa_Site_CheckSOACompleted_ShowGoToProfileButton_Enabled: [], Spa_PlanList_AddToQuote_Limit_Mobile: [], Spa_PlanList_AddToQuote_Limit: [], Spa_Site_PlanLogo_Size: [], Spa_Site_AgentCallRecording_DisplayPlanAllowsCallRecordingIcon_Enabled: [], Spa_Site_AgentCallRecording_PlanAllowsCallRecording_Text: [], Spa_AgentCallInProgressAcceptCall_Icon: [], Spa_ShoppingCart_BenefitsSelection_Text: [], Spa_ShoppingCart_BasedOnBenefits_Text: [], Spa_EnrollmentConfirmation_ApplicationSubmitted_Title: [], Spa_Site_LastVisitedOn_Text: [], Spa_ShoppingCart_IndividualEnrollmentButtons_Enabled: [], Spa_ShoppingCart_ClearCart_Text: [], Spa_ShoppingCart_ClearCartClickable_Text: [], Spa_ShoppingCart_ClearCartLink_Enabled: [], Spa_EnrollmentConfirmation_Title: [], Spa_Enrollment_Allow_AlreadyEnrolled_Plans: [], Spa_ShoppingCart_PlanRiderConflict_Enabled: [], Spa_ShoppingCart_PlanRiderConflict_Text: [], Spa_EnrollmentConfirmation_DentalApplicationSubmitted_Title: [], Spa_EnrollmentConfirmation_VisionApplicationSubmitted_Title: [], Spa_EnrollmentConfirmation_HIPApplicationSubmitted_Title: [], Spa_HRAConfirmation_ApplicationSubmitted_Title: [], Spa_EnrollmentConfirmation_DentalNoticeBox_Header: [], Spa_EnrollmentConfirmation_VisionNoticeBox_Header: [], Spa_EnrollmentConfirmation_HIPNoticeBox_Header: [], Spa_EnrollmentConfirmation_DentalNoticeBox_Body: [], Spa_EnrollmentConfirmation_VisionNoticeBox_Body: [], Spa_EnrollmentConfirmation_HIPNoticeBox_Body: [], Spa_EnrollmentConfirmation_DentalWhatToExpect_Title: [], Spa_EnrollmentConfirmation_VisionWhatToExpect_Title: [], Spa_EnrollmentConfirmation_HIPWhatToExpect_Title: [], Spa_ShoppingCart_BackToPlansLink_Enabled: [], Spa_Enrollment_Plans_Not_Available_Go_Back_Text: [], Spa_Site_PlanFees_Enabled: [], Spa_PlanFees_Tooltip_Text: [], Spa_PlanFees_IncludedInPremium_Tooltip_Text: [], Spa_PlanFees_NotIncludedInPremiumText_Tooltip_Text: [], Spa_EnrollMessageEnrollmentModal_Close: [], Spa_EnrollMessageEnrollmentModal_Continue: [], Spa_DualPlanEnrollMessage_EnrollmentModal_Enabled: [], Spa_DualPlanEnrollMessage_EnrollmentModalTitle_Text: [], Spa_DualPlanEnrollMessage_EnrollmentModalBody_Text: [], removeFromCart: [], changePlanInCart: [], emptyCartNavToPlans: [], viewPlanDetails: [], apply: [], onContinueToApply: [], enroll: [], sendApplication: [], resetStatus: [] }); })();

var NextGenSOAPageName;
(function (NextGenSOAPageName) {
    NextGenSOAPageName["BeneficiaryPage"] = "SOABeneficiaryPage";
    NextGenSOAPageName["AgentPage"] = "SOAAgentPage";
})(NextGenSOAPageName || (NextGenSOAPageName = {}));

const _c0$t = ["errorContainer"];
function NextGenSOAFormComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵelement(2, "nextgen-enrollment-form-renderer", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "vnext-enrollment-form-navigation", 3);
    i0.ɵɵlistener("backEvent", function NextGenSOAFormComponent_ng_container_0_Template_vnext_enrollment_form_navigation_backEvent_3_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.back()); })("nextEvent", function NextGenSOAFormComponent_ng_container_0_Template_vnext_enrollment_form_navigation_nextEvent_3_listener() { i0.ɵɵrestoreView(_r2); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.next()); })("submitEvent", function NextGenSOAFormComponent_ng_container_0_Template_vnext_enrollment_form_navigation_submitEvent_3_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r4 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r4.onSubmit($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("isSOAForm", true)("formId", ctx_r0.enrollingFormId)("formVersion", ctx_r0.enrollingFormVersion)("formVersionId", ctx_r0.enrollingFormVersionId)("soaTransactionId", ctx_r0.soaTransactionId)("isAgentAdmin", ctx_r0.isAgentAdmin)("surveyInitialized", ctx_r0.surveyInitialized);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("showNext", ctx_r0.showNext())("showSubmit", ctx_r0.showSubmit())("showPrevious", false)("showSendApplicationEmail", false)("nextButtonText", ctx_r0.continueButtonText)("submitButtonText", ctx_r0.submitButtonText);
} }
class NextGenSOAFormComponent {
    constructor(cdr, spinnerService, activatedRoute, viewContainer, authService, navigationService, enrollmentFormErrorsContext, nextGenSOAFormFacade, addressService, formPagesMetadataContext, formRootService, formRootStrategyService, analyticsService, agentPermissionsService, nextGenSOAFormNavigationContext, groupValidatorContextService) {
        this.cdr = cdr;
        this.spinnerService = spinnerService;
        this.activatedRoute = activatedRoute;
        this.viewContainer = viewContainer;
        this.authService = authService;
        this.navigationService = navigationService;
        this.enrollmentFormErrorsContext = enrollmentFormErrorsContext;
        this.nextGenSOAFormFacade = nextGenSOAFormFacade;
        this.addressService = addressService;
        this.formPagesMetadataContext = formPagesMetadataContext;
        this.formRootService = formRootService;
        this.formRootStrategyService = formRootStrategyService;
        this.analyticsService = analyticsService;
        this.agentPermissionsService = agentPermissionsService;
        this.nextGenSOAFormNavigationContext = nextGenSOAFormNavigationContext;
        this.groupValidatorContextService = groupValidatorContextService;
        this.selectedSOATransactionType = SOATransactionEventType.IN_PERSON;
        this.consumerFormSubmitted = new EventEmitter();
        this.agentFormSubmitted = new EventEmitter();
        this.setSelectedActivityById = new EventEmitter();
        this.subscriptions = new Subscription();
        this.surveyInitialized = false;
        this.nextGenFormQuestionNames = [];
        this.requestSubmitSubject$ = new Subject();
        this.requestSubmit$ = this.requestSubmitSubject$.asObservable();
    }
    onSurveyBeforeViewInitialized(event) {
        this.spinnerService.show(SpinnerEvent.INITIALIZE_SURVEY_VIEW);
    }
    onSurveyAfterViewInitialized(event) {
        this.surveyInitialized = true;
        this.spinnerService.hide(SpinnerEvent.INITIALIZE_SURVEY_VIEW);
    }
    onSurveyAfterPageRendered(event) {
        setTimeout(() => {
            const answers = _get(event, 'detail.answers');
            const inputElement = this.nextGenSOAFormFacade.findFirstFocusableInput(answers, document);
            if (inputElement) {
                inputElement.focus();
            }
        }, 0);
    }
    clearFormErrors(event) {
        this.enrollmentFormErrorsContext.clearFormErrors();
    }
    setFormPageInfo(event) {
        // There's also currently a pageCount val in here we aren't using
        const formInfo = _get(event, 'detail.formInfo');
        this.nextGenSOAFormFacade.setFormTitle(formInfo.formMetaData.formTitle);
        this.formPagesMetadataContext.setFormPagesMetadata(formInfo, this.getPageLevelValidationConfigurations());
    }
    setFormPageErrors(event) {
        const pageErrors = _get(event, 'detail.pageErrors');
        const scroll = _get(event, 'detail.scroll');
        if (pageErrors?.length) {
            this.addErrorsAndScroll({
                title: this.formRootService.getEnrollmentErrorNoticeTitle(),
                messages: pageErrors.map(pageError => ({ message: pageError?.message, severity: 'error' }))
            }, scroll);
        }
        else {
            this.enrollmentFormErrorsContext.clearFormErrors();
        }
    }
    async nextgenAutocompleteAddress(event) {
        const autocompletePayload = _get(event, 'detail');
        const { questionName, partial, zip, selected } = autocompletePayload;
        try {
            const addressList = await this.addressService.callAPIForData(partial, zip, selected);
            this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ADDRESS_AUTOCOMPLETE_RESPONSE, {
                questionName,
                addressList
            });
        }
        catch (error) {
            this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ADDRESS_AUTOCOMPLETE_ERROR_RESPONSE, { questionName, error });
        }
    }
    /**
     * This event gets fired by the PC1 - Spa.Net Host aka "Host layer" code, drx.enrollment.callback.js
     * If we need additional changes to when/how this is fired, we would need to work with John Stanely to update that.
     * That code then was originally designed to cooperate with the HOPE bundle code to update specific fields on the host layer side.
     * This event and its work is intended to move as much of the existing logic into a position for us to manipulate it freely here
     * instead of in other layers.
     */
    updateViAQueryParams(event) {
        const xmlAsJSON = this.nextGenSOAFormFacade.convertEnrollmentCallbackMapToJSON();
        // xmlAsJSON should be an object such as {'Provider_Name':'"PrimaryCarePhysician"}
        // This maps the names we use in the queryParams to the values we actually use as field names.
        const queryParams = _get(event, 'detail');
        // queryParams should be an object such as {'Provider_Name':'BRUCE+W.+DENNIS'}
        const answers = [];
        Object.keys(queryParams).forEach(keyName => {
            const name = xmlAsJSON[keyName];
            if (name) {
                const value = queryParams[keyName]?.replaceAll('+', ' ') ?? '';
                answers.push({ name, value });
            }
        });
        this.updateFormAnswers(answers);
    }
    nextGenNavigateToPageName(event) {
        const pageName = _get(event, 'detail.pageName');
        this.nextGenSOAFormNavigationContext.setPageName(pageName);
    }
    ngOnChanges(changes) {
        const { showNewConsumerForm, showConsumerForm, selectedActivity, selectedSOATransactionType } = changes;
        if ((showNewConsumerForm && showNewConsumerForm.previousValue !== showNewConsumerForm.currentValue) ||
            (selectedSOATransactionType && selectedSOATransactionType.previousValue !== selectedSOATransactionType.currentValue)) {
            if (this.showNewConsumerForm && this.selectedSOATransactionType !== null) {
                this.newConsumerForm(this.selectedSOATransactionType);
            }
        }
        if (!this.showNewConsumerForm) {
            if (showConsumerForm && showConsumerForm.currentValue !== showConsumerForm.previousValue) {
                this.setInitialPageName(this.showConsumerForm);
            }
            if (selectedActivity?.currentValue && !_isEqual(selectedActivity.previousValue, selectedActivity.currentValue)) {
                this.getSOAForm(this.selectedActivity);
            }
        }
    }
    ngOnInit() {
        this.formRootStrategyService.setStrategy(NextGenBundleFormRootStrategy);
        this.environment = EnvironmentService.getEnvironment();
        this.isFormLoading$ = this.nextGenSOAFormFacade.getSOAFormLoading$(this.enrollingFormId).pipe(distinctUntilChanged(), shareReplay(1));
        this.isAgentAdmin = this.agentPermissionsService.isAgentAdmin();
        this.initializeSubscriptions(this.environment.liveedit);
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        this.nextGenSOAFormNavigationContext.resetPageName();
    }
    newConsumerForm(selectedSOATransactionType = SOATransactionEventType.IN_PERSON) {
        const selectedFormId = this.nextGenSOAFormFacade.getSelectedSOAFormId([selectedSOATransactionType]);
        this.spinnerService.show(SpinnerEvent.SOA_LOADING);
        this.nextGenSOAFormFacade
            .startNextGenSOATransaction$(selectedFormId, [selectedSOATransactionType])
            .pipe(finalize(() => {
            this.spinnerService.hide(SpinnerEvent.SOA_LOADING);
        }))
            .subscribe({
            next: ([formVersionInfo, soaTransaction]) => {
                this.soaTransactionId = soaTransaction.newEnrollmentTransactionGuid;
                this.enrollingFormId = formVersionInfo.formId;
                this.enrollingFormVersion = formVersionInfo.formVersion;
                this.enrollingFormVersionId = formVersionInfo.formVersionId;
                this.setSelectedActivityById.emit(this.soaTransactionId);
                this.cdr.markForCheck();
            }
        });
    }
    getSOAForm(selectedActivity) {
        this.spinnerService.show(SpinnerEvent.SOA_LOADING);
        this.nextGenSOAFormFacade
            .fetchFormVersionInfo$(selectedActivity.publicFormID)
            .pipe(finalize(() => {
            this.spinnerService.hide(SpinnerEvent.SOA_LOADING);
        }))
            .subscribe({
            next: formVersionInfo => {
                this.soaTransactionId = selectedActivity.transactionId;
                this.enrollingFormId = formVersionInfo.formId;
                this.enrollingFormVersion = formVersionInfo.formVersion;
                this.enrollingFormVersionId = formVersionInfo.formVersionId;
                this.cdr.markForCheck();
            }
        });
    }
    back() {
        this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ENROLLMENT_BACK);
    }
    getCurrentIndex() {
        return this.formRootStrategyService.getCurrentIndex();
    }
    async next() {
        const nextGenPageErrors = await this.getNextGenPageErrors();
        if (nextGenPageErrors?.length) {
            this.addNextGenErrorsAndScroll(nextGenPageErrors);
        }
        else {
            this.continueToNext();
        }
    }
    onSubmit(tooltip) {
        this.requestSubmit();
    }
    handleSubmit$() {
        return from(this.handleSubmit());
    }
    async submit() {
        const nextGenFormErrors = await this.getNextGenFormErrors();
        if (nextGenFormErrors?.length) {
            this.spinnerService.hide(SpinnerEvent.SOA_LOADING);
            this.addNextGenErrorsAndScroll(nextGenFormErrors);
        }
        else {
            await this.nextGenSubmitEvent();
        }
    }
    async nextGenSubmitEvent() {
        if (!this.authService.isCurrentTokenValid()) {
            await this.authService.loadJWT();
        }
        this.trackGTMContinueEvent(this.selectedSOATransactionType);
        const pageIndex = this.getCurrentIndex();
        const currentPageAnswers = this.retrieveFormAnswers();
        const allAnswers = this.retrieveAllFormAnswers();
        //
        const validationResults = await this.formRootStrategyService.runPageLevelValidations(allAnswers, pageIndex);
        const canContinueToSubmit = !!validationResults?.every(result => !!result?.isValid);
        if (canContinueToSubmit) {
            await this.nextGenSOAFormFacade.saveFormAnswers(this.soaTransactionId, currentPageAnswers);
            try {
                await this.completeEnrollment(this.soaTransactionId);
            }
            catch (error) {
                this.nextGenSOAFormFacade.setFormLoading$(this.enrollingFormId, false);
                this.spinnerService.hide(SpinnerEvent.SOA_LOADING);
                await this.handleCompleteEnrollmentErrors(error);
            }
        }
        else {
            const continueText = validationResults?.find(result => result?.type === PageLevelValidatorType.EligibilityCheck)?.continueText;
            this.addErrorsAndScroll({
                title: this.formRootService.getEnrollmentErrorNoticeTitle(),
                messages: this.formatPageLevelValidationErrors(validationResults),
                ...(continueText && { continueText })
            });
        }
        //
        // show spinner
        // validate page
        // loadjwt setuff again?
        // complete enrollment
        // dispatch a navigation event
        // hide spinner
        // TODO: complete enrollment for nextgen
    }
    async completeEnrollment(transactionId) {
        await this.nextGenSOAFormFacade
            .completeNextGenSOATransaction(transactionId)
            .then(() => {
            this.formRootService.processNextGenTransactionResponse(this.nextGenSOAFormFacade.getSOATransaction(transactionId), () => {
                this.spinnerService.hide(SpinnerEvent.SUBMITTED_FORM_LOADING);
                this.agentFormSubmitted.emit(this.soaTransactionId);
            });
        })
            .finally(() => {
            this.spinnerService.hide(SpinnerEvent.SOA_LOADING);
        });
    }
    async getNextGenPageErrors() {
        const element = this.viewContainer.element.nativeElement;
        return await new Promise((resolve, reject) => {
            const listener = (responseEvent) => {
                const responseData = responseEvent.detail.pageErrors;
                resolve(responseData);
            };
            element.addEventListener(NextGenEnrollmentEvents.REQUEST_PAGE_ERRORS_RESPONSE, listener, { once: true });
            const myCustomEvent = new CustomEvent(NextGenEnrollmentEvents.REQUEST_PAGE_ERRORS, { bubbles: true });
            element.dispatchEvent(myCustomEvent);
            setTimeout(() => {
                element.removeEventListener(NextGenEnrollmentEvents.REQUEST_PAGE_ERRORS_RESPONSE, listener);
                reject(new Error('Unable to retrieve errors from enrollment form'));
            }, 2000);
        });
    }
    async getNextGenFormErrors() {
        const element = this.viewContainer.element.nativeElement;
        return await new Promise((resolve, reject) => {
            const listener = (responseEvent) => {
                const responseData = responseEvent.detail.pageErrors;
                resolve(responseData);
            };
            element.addEventListener(NextGenEnrollmentEvents.REQUEST_FORM_ERRORS_RESPONSE, listener, { once: true });
            const myCustomEvent = new CustomEvent(NextGenEnrollmentEvents.REQUEST_FORM_ERRORS, { bubbles: true });
            element.dispatchEvent(myCustomEvent);
            setTimeout(() => {
                element.removeEventListener(NextGenEnrollmentEvents.REQUEST_FORM_ERRORS_RESPONSE, listener);
                reject(new Error('Unable to retrieve errors from enrollment form'));
            }, 2000);
        });
    }
    getFormPages(enrollingFormId) {
        return this.formRootStrategyService.getFormPages(enrollingFormId);
    }
    showNext() {
        const pageName = this.getCurrentPageName();
        return pageName === NextGenSOAPageName.BeneficiaryPage;
    }
    showSubmit() {
        const pageName = this.getCurrentPageName();
        return pageName === NextGenSOAPageName.AgentPage;
    }
    retrieveFormAnswers() {
        const inputValues = this.childForms?.first?.retrieveFormInputValues();
        return this.formRootService.convertFormInputValuesToAnswers(inputValues);
    }
    retrieveAllFormAnswers() {
        const inputValues = this.childForms?.first?.retrieveAllFormInputValues();
        return this.formRootService.convertFormInputValuesToAnswers(inputValues);
    }
    initializeSubscriptions(liveEdit = false) {
        if (!liveEdit) {
            this.subscriptions.add(fromEvent(document, `${NextGenEnrollmentEvents.CLEAR_PREFILL_DATA}`)
                .pipe(distinctUntilChanged((prev, curr) => {
                return !(prev.detail.timeStamp + 200 < curr.detail.timeStamp ||
                    !_isEqual(prev.detail.clearedPrefillDataFields, curr.detail.clearedPrefillDataFields));
            }))
                .subscribe({
                next: event => {
                    this.nextGenSOAFormFacade.clearPrefillData(this.enrollingFormId, event, this.childForms);
                }
            }));
            // Subscribe to loading
            this.subscriptions.add(this.isFormLoading$.subscribe({
                next: isFormLoading => {
                    if (isFormLoading) {
                        this.spinnerService.show(SpinnerEvent.SOA_LOADING);
                    }
                    else {
                        this.spinnerService.hide(SpinnerEvent.SOA_LOADING);
                        // this.updateTags();
                    }
                }
            }));
            this.subscriptions.add(this.requestSubmit$.pipe(exhaustMap(() => this.handleSubmit$())).subscribe({
                next: () => {
                    this.cdr.markForCheck();
                }
            }));
        }
    }
    requestSubmit() {
        this.requestSubmitSubject$.next();
    }
    async handleSubmit() {
        this.spinnerService.show(SpinnerEvent.SUBMITTED_FORM_LOADING);
        await this.submit();
    }
    getCurrentPageName() {
        return this.formRootStrategyService.getCurrentPageName();
    }
    setInitialPageName(showConsumerForm) {
        const initialPageName = showConsumerForm ? NextGenSOAPageName.BeneficiaryPage : NextGenSOAPageName.AgentPage;
        this.nextGenSOAFormNavigationContext.setPageName(initialPageName);
    }
    getPageLevelValidationConfigurations() {
        return {
            [PageLevelValidatorType.EligibilityCheck]: {
                asyncValidation: async (payload) => await this.nextGenSOAFormFacade.checkMemberEligibility(payload),
                dispatchEvent: (details) => {
                    this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ADD_PAGE_LEVEL_ERROR_TO_QUESTION, details);
                }
            },
            [PageLevelValidatorType.StateAndZip]: {
                asyncValidation: async (payload, validationType) => await this.nextGenSOAFormFacade.validateEnrollment(payload, validationType),
                dispatchEvent: (details) => {
                    this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ADD_PAGE_LEVEL_ERROR_TO_QUESTION, details);
                }
            },
            [PageLevelValidatorType.Group]: {
                asyncValidation: async (conditionExpression, errorMessage) => await this.groupValidatorContextService.nextGenValidateGroup(conditionExpression, this.viewContainer.element.nativeElement, NextGenEnrollmentEvents.VALIDATE_GROUP_RESPONSE, () => {
                    this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.VALIDATE_GROUP, {
                        validatorType: PageLevelValidatorType.Group,
                        expression: conditionExpression,
                        errorMessage
                    });
                }),
                dispatchEvent: (details) => {
                    this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ADD_PAGE_LEVEL_ERROR_TO_QUESTION, details);
                }
            }
        };
    }
    updateFormAnswers(answers) {
        this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.SET_FORM_FIELD, {
            fields: answers.map(answer => ({ name: answer.name, value: answer.value }))
        });
    }
    async continueToNext() {
        if (!this.authService.isCurrentTokenValid()) {
            await this.authService.loadJWT();
        }
        const pageIndex = this.getCurrentIndex();
        let currentPageAnswers = this.retrieveFormAnswers();
        try {
            const allAnswers = this.retrieveAllFormAnswers();
            this.spinnerService.show(SpinnerEvent.SOA_LOADING);
            const validationResults = await this.formRootStrategyService.runPageLevelValidations(allAnswers, pageIndex);
            const canContinueToNextPage = !!validationResults?.every(result => !!result?.isValid);
            if (canContinueToNextPage) {
                // Update SOABeneficiaryConfirmationCode when the beneficiary completes the SOA form (text/email workflow)
                if (this.showConsumerForm && this.nextGenSOAFormFacade.isConsumerSOAActivity(this.selectedActivity)) {
                    currentPageAnswers = this.nextGenSOAFormFacade.updateSOABeneficiaryConfirmationCodeAnswer(currentPageAnswers);
                }
                await this.nextGenSOAFormFacade.saveFormAnswers(this.soaTransactionId, currentPageAnswers);
                if (this.nextGenSOAFormFacade.allFormPagesComplete(this.soaTransactionId)) {
                    await this.nextGenSOAFormFacade.completeNextGenSOATransaction(this.soaTransactionId);
                }
                else {
                    this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ENROLLMENT_NEXT);
                }
                // We use a setTimeout here to split the task and move the emission at the end of the call stack in order to give more chance to set the page name
                setTimeout(() => {
                    this.consumerFormSubmitted.emit(this.soaTransactionId);
                }, 0);
            }
            else {
                const continueText = validationResults?.find(result => result?.type === PageLevelValidatorType.EligibilityCheck)?.continueText;
                this.addErrorsAndScroll({
                    title: this.formRootService.getEnrollmentErrorNoticeTitle(),
                    messages: this.formatPageLevelValidationErrors(validationResults),
                    ...(continueText && { continueText })
                });
            }
        }
        finally {
            this.spinnerService.hide(SpinnerEvent.SOA_LOADING);
        }
    }
    async handleCompleteEnrollmentErrors(error) {
        if (error) {
            const errorStatus = error.status;
            const innerError = error.error;
            let errorMessages = [];
            let title = this.nextGenSOAFormFacade.getEnrollmentErrorNoticeTitle();
            if (errorStatus && innerError) {
                if (errorStatus === HttpStatusCode.BAD_REQUEST && innerError?.AdditionalInfo) {
                    errorMessages = Object.keys(innerError.AdditionalInfo).reduce((errors, errorKey) => {
                        const errorMessage = innerError.AdditionalInfo[errorKey];
                        if (errorMessage) {
                            errors.push({ message: errorMessage });
                        }
                        return errors;
                    }, []);
                }
                else if (errorStatus === HttpStatusCode.INTERNAL_SERVER_ERROR) {
                    title = this.unableToProcessErrorsTitleText;
                    errorMessages = [{ message: this.unableToProcessErrorsMessageText, severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER }];
                }
                else {
                    title = this.unableToProcessErrorsTitleText;
                    errorMessages = [{ message: this.unableToProcessErrorsMessageText, severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER }];
                }
            }
            let errors = {
                title,
                messages: errorMessages.length
                    ? errorMessages
                    : [{ message: error.message, severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER }]
            };
            // errors won't display if no severity is sent back
            // API should do this but we will code defensively here
            if (errorMessages.every(errorMessage => !errorMessage.severity)) {
                errorMessages = errorMessages.map(errorMessage => ({ ...errorMessage, severity: NOTICE_TYPE.ERROR }));
                errors = { ...errors, messages: errorMessages };
            }
            this.addErrorsAndScroll(errors);
        }
    }
    addNextGenErrorsAndScroll(nextGenErrors) {
        this.addErrorsAndScroll({
            title: this.nextGenSOAFormFacade.getEnrollmentErrorNoticeTitle(),
            messages: nextGenErrors.map(pageError => ({
                message: pageError?.message,
                severity: NOTICE_TYPE.ERROR,
                source: MESSAGE_SOURCE.CLIENT
            }))
        });
    }
    addErrorsAndScroll(errors, scroll = true) {
        this.enrollmentFormErrorsContext.addErrors(errors);
        this.enrollmentFormErrorsContext
            .observeForFormErrors$()
            .pipe(take(1))
            .subscribe({
            next: () => {
                if (scroll) {
                    this.enrollmentFormErrorsContext.scrollToErrors();
                }
            }
        });
    }
    formatPageLevelValidationErrors(validationResults) {
        return (validationResults?.reduce((noticeMessages, validationResult) => {
            if (!validationResult.isValid) {
                noticeMessages.push({
                    message: validationResult.errorMessage,
                    severity: validationResult.severity,
                    source: MESSAGE_SOURCE.CLIENT
                });
            }
            return noticeMessages;
        }, []) ?? []);
    }
    scrollToErrors() {
        this.errorContainer?.first?.nativeElement?.scrollIntoView({ behavior: 'smooth' });
    }
    trackGTMContinueEvent(selectedSOATransactionType = SOATransactionEventType.IN_PERSON) {
        if (selectedSOATransactionType === SOATransactionEventType.IN_PERSON) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_SOA_INPERSON_CONTINUE);
        }
    }
}
NextGenSOAFormComponent.ɵfac = function NextGenSOAFormComponent_Factory(t) { return new (t || NextGenSOAFormComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i1.AuthService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.EnrollmentFormErrorsContext), i0.ɵɵdirectiveInject(NextGenSOAFormFacade), i0.ɵɵdirectiveInject(i1.AddressService), i0.ɵɵdirectiveInject(i1.FormPagesMetadataContext), i0.ɵɵdirectiveInject(FormRootService), i0.ɵɵdirectiveInject(FormRootStrategyService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.AgentPermissionsService), i0.ɵɵdirectiveInject(NextGenSOAFormNavigationContext), i0.ɵɵdirectiveInject(i1.GroupValidatorContextService)); };
NextGenSOAFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NextGenSOAFormComponent, selectors: [["nextgen-soa-form"]], viewQuery: function NextGenSOAFormComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(NextGenEnrollmentFormRendererComponent, 5);
        i0.ɵɵviewQuery(_c0$t, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childForms = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.errorContainer = _t);
    } }, hostBindings: function NextGenSOAFormComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("NextGenForm_Before_Survey_View_Initialization", function NextGenSOAFormComponent_NextGenForm_Before_Survey_View_Initialization_HostBindingHandler($event) { return ctx.onSurveyBeforeViewInitialized($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_After_Survey_View_Initialization", function NextGenSOAFormComponent_NextGenForm_After_Survey_View_Initialization_HostBindingHandler($event) { return ctx.onSurveyAfterViewInitialized($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_On_After_Page_Rendered", function NextGenSOAFormComponent_NextGenForm_On_After_Page_Rendered_HostBindingHandler($event) { return ctx.onSurveyAfterPageRendered($event); }, false, i0.ɵɵresolveDocument)("NextGenFormClientEvent_Navigate_To_Previous_Page", function NextGenSOAFormComponent_NextGenFormClientEvent_Navigate_To_Previous_Page_HostBindingHandler($event) { return ctx.clearFormErrors($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_Emit_FormInfo", function NextGenSOAFormComponent_NextGenForm_Emit_FormInfo_HostBindingHandler($event) { return ctx.setFormPageInfo($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_Emit_PageErrors", function NextGenSOAFormComponent_NextGenForm_Emit_PageErrors_HostBindingHandler($event) { return ctx.setFormPageErrors($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_Address_Autocomplete_Request", function NextGenSOAFormComponent_NextGenForm_Address_Autocomplete_Request_HostBindingHandler($event) { return ctx.nextgenAutocompleteAddress($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_Update_Via_Query_Params_Event", function NextGenSOAFormComponent_NextGenForm_Update_Via_Query_Params_Event_HostBindingHandler($event) { return ctx.updateViAQueryParams($event); })("NextGenForm_Enrollment_Go_To_Page", function NextGenSOAFormComponent_NextGenForm_Enrollment_Go_To_Page_HostBindingHandler($event) { return ctx.nextGenNavigateToPageName($event); }, false, i0.ɵɵresolveDocument);
    } }, inputs: { continueButtonText: "continueButtonText", continueButtonKeyText: "continueButtonKeyText", submitButtonText: "submitButtonText", submitButtonKeyText: "submitButtonKeyText", soaFormSubmitErrorText: "soaFormSubmitErrorText", memberProfileErrorMessagesTitleText: "memberProfileErrorMessagesTitleText", showConsumerForm: "showConsumerForm", showNewConsumerForm: "showNewConsumerForm", selectedActivity: "selectedActivity", selectedSOATransactionType: "selectedSOATransactionType", unableToProcessErrorsTitleText: "unableToProcessErrorsTitleText", unableToProcessErrorsMessageText: "unableToProcessErrorsMessageText" }, outputs: { consumerFormSubmitted: "consumerFormSubmitted", agentFormSubmitted: "agentFormSubmitted", setSelectedActivityById: "setSelectedActivityById" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "px-3"], [3, "isSOAForm", "formId", "formVersion", "formVersionId", "soaTransactionId", "isAgentAdmin", "surveyInitialized"], [3, "showNext", "showSubmit", "showPrevious", "showSendApplicationEmail", "nextButtonText", "submitButtonText", "sendApplicationButtonText", "enrollSubmitTooltipText", "backEvent", "nextEvent", "submitEvent"]], template: function NextGenSOAFormComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, NextGenSOAFormComponent_ng_container_0_Template, 4, 13, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.selectedActivity);
    } }, dependencies: [i1$2.NgIf, EnrollmentFormNavigationComponent, NextGenEnrollmentFormRendererComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NextGenSOAFormComponent, [{
        type: Component,
        args: [{ selector: 'nextgen-soa-form', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"selectedActivity\">\r\n  <div class=\"px-3\">\r\n    <nextgen-enrollment-form-renderer\r\n      [isSOAForm]=\"true\"\r\n      [formId]=\"enrollingFormId\"\r\n      [formVersion]=\"enrollingFormVersion\"\r\n      [formVersionId]=\"enrollingFormVersionId\"\r\n      [soaTransactionId]=\"soaTransactionId\"\r\n      [isAgentAdmin]=\"isAgentAdmin\"\r\n      [surveyInitialized]=\"surveyInitialized\"\r\n    ></nextgen-enrollment-form-renderer>\r\n  </div>\r\n\r\n  <vnext-enrollment-form-navigation\r\n    [showNext]=\"showNext()\"\r\n    [showSubmit]=\"showSubmit()\"\r\n    [showPrevious]=\"false\"\r\n    [showSendApplicationEmail]=\"false\"\r\n    [nextButtonText]=\"continueButtonText\"\r\n    [submitButtonText]=\"submitButtonText\"\r\n    [sendApplicationButtonText]=\"\"\r\n    [enrollSubmitTooltipText]=\"\"\r\n    (backEvent)=\"back()\"\r\n    (nextEvent)=\"next()\"\r\n    (submitEvent)=\"onSubmit($event)\"\r\n  ></vnext-enrollment-form-navigation>\r\n</ng-container>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.SpinnerService }, { type: i2$1.ActivatedRoute }, { type: i0.ViewContainerRef }, { type: i1.AuthService }, { type: i1.NavigationService }, { type: i1.EnrollmentFormErrorsContext }, { type: NextGenSOAFormFacade }, { type: i1.AddressService }, { type: i1.FormPagesMetadataContext }, { type: FormRootService }, { type: FormRootStrategyService }, { type: AnalyticsService }, { type: i1.AgentPermissionsService }, { type: NextGenSOAFormNavigationContext }, { type: i1.GroupValidatorContextService }]; }, { childForms: [{
            type: ViewChildren,
            args: [NextGenEnrollmentFormRendererComponent]
        }], errorContainer: [{
            type: ViewChildren,
            args: ['errorContainer']
        }], continueButtonText: [{
            type: Input
        }], continueButtonKeyText: [{
            type: Input
        }], submitButtonText: [{
            type: Input
        }], submitButtonKeyText: [{
            type: Input
        }], soaFormSubmitErrorText: [{
            type: Input
        }], memberProfileErrorMessagesTitleText: [{
            type: Input
        }], showConsumerForm: [{
            type: Input
        }], showNewConsumerForm: [{
            type: Input
        }], selectedActivity: [{
            type: Input
        }], selectedSOATransactionType: [{
            type: Input
        }], unableToProcessErrorsTitleText: [{
            type: Input
        }], unableToProcessErrorsMessageText: [{
            type: Input
        }], consumerFormSubmitted: [{
            type: Output
        }], agentFormSubmitted: [{
            type: Output
        }], setSelectedActivityById: [{
            type: Output
        }], onSurveyBeforeViewInitialized: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.SURVEY_BEFORE_VIEW_INITIALIZED}`, ['$event']]
        }], onSurveyAfterViewInitialized: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.SURVEY_AFTER_VIEW_INITIALIZED}`, ['$event']]
        }], onSurveyAfterPageRendered: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.SURVEY_AFTER_PAGE_RENDERED}`, ['$event']]
        }], clearFormErrors: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.NAVIGATE_PREVIOUS_PAGE}`, ['$event']]
        }], setFormPageInfo: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.FORM_INFO}`, ['$event']]
        }], setFormPageErrors: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.PAGE_ERRORS}`, ['$event']]
        }], nextgenAutocompleteAddress: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.ADDRESS_AUTOCOMPLETE_REQUEST}`, ['$event']]
        }], updateViAQueryParams: [{
            type: HostListener,
            args: [`${NextGenEnrollmentEvents.UPDATE_VIA_QUERY_PARAMS}`, ['$event']]
        }], nextGenNavigateToPageName: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.ENROLLMENT_GO_TO_PAGE}`, ['$event']]
        }] }); })();

function SOAActivityItemComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SOAActivityItemComponent_ng_container_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SOAActivityItemComponent_ng_container_5_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SOAActivityItemComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵtemplate(2, SOAActivityItemComponent_ng_container_5_ng_container_2_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 16)(4, "div", 17);
    i0.ɵɵtemplate(5, SOAActivityItemComponent_ng_container_5_ng_container_5_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r11 = i0.ɵɵreference(19);
    const _r13 = i0.ɵɵreference(21);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r11);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", _r13);
} }
function SOAActivityItemComponent_div_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SOAActivityItemComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, SOAActivityItemComponent_div_6_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r15 = i0.ɵɵreference(23);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r15);
} }
function SOAActivityItemComponent_ng_container_8_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SOAActivityItemComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 19);
    i0.ɵɵtemplate(2, SOAActivityItemComponent_ng_container_8_ng_container_2_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r9 = i0.ɵɵreference(17);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r9);
} }
function SOAActivityItemComponent_ng_container_9_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SOAActivityItemComponent_ng_container_9_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SOAActivityItemComponent_ng_container_9_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SOAActivityItemComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 20)(2, "div", 21);
    i0.ɵɵtemplate(3, SOAActivityItemComponent_ng_container_9_ng_container_3_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 22);
    i0.ɵɵtemplate(5, SOAActivityItemComponent_ng_container_9_ng_container_5_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 23);
    i0.ɵɵtemplate(7, SOAActivityItemComponent_ng_container_9_ng_container_7_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r9 = i0.ɵɵreference(17);
    const _r13 = i0.ɵɵreference(21);
    const _r11 = i0.ɵɵreference(19);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", _r9);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r13);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r11);
} }
function SOAActivityItemComponent_div_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SOAActivityItemComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtemplate(1, SOAActivityItemComponent_div_10_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r15 = i0.ɵɵreference(23);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r15);
} }
function SOAActivityItemComponent_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SOAActivityItemComponent_ng_container_14_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SOAActivityItemComponent_ng_container_14_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SOAActivityItemComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 24);
    i0.ɵɵtemplate(2, SOAActivityItemComponent_ng_container_14_ng_container_2_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 24);
    i0.ɵɵtemplate(4, SOAActivityItemComponent_ng_container_14_ng_container_4_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r11 = i0.ɵɵreference(19);
    const _r13 = i0.ɵɵreference(21);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r11);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", _r13);
} }
function SOAActivityItemComponent_div_15_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SOAActivityItemComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, SOAActivityItemComponent_div_15_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r15 = i0.ɵɵreference(23);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r15);
} }
function SOAActivityItemComponent_ng_template_16_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r28.confirmationNumber, " ");
} }
const _c0$s = function (a0, a1) { return { "finished-activity": a0, "Spa_Style_Gray4_Color": a1 }; };
function SOAActivityItemComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelement(1, "i", 27);
    i0.ɵɵelementStart(2, "div", 28)(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, SOAActivityItemComponent_ng_template_16_div_5_Template, 2, 1, "div", 29);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c0$s, ctx_r10.item.type === ctx_r10.soaActivityType.COMPLETED || ctx_r10.item.type === ctx_r10.soaActivityType.UPLOADED_FILE || ctx_r10.item.type === ctx_r10.soaActivityType.COMPLETED_IN_PERSON || ctx_r10.item.type === ctx_r10.soaActivityType.COMPLETED_BY_PHONE, ctx_r10.item.type === ctx_r10.soaActivityType.PARTIAL || ctx_r10.item.type === ctx_r10.soaActivityType.STARTED_TEXT || ctx_r10.item.type === ctx_r10.soaActivityType.STARTED_EMAIL || ctx_r10.item.type === ctx_r10.soaActivityType.STARTED_IN_PERSON || ctx_r10.item.type === ctx_r10.soaActivityType.STARTED_BY_PHONE || ctx_r10.item.type === ctx_r10.soaActivityType.PARTIAL_IN_PERSON || ctx_r10.item.type === ctx_r10.soaActivityType.PARTIAL_BY_PHONE));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r10.message);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.item.type === ctx_r10.soaActivityType.COMPLETED || ctx_r10.item.type === ctx_r10.soaActivityType.COMPLETED_IN_PERSON || ctx_r10.item.type === ctx_r10.soaActivityType.COMPLETED_BY_PHONE);
} }
function SOAActivityItemComponent_ng_template_18_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r29.item.fileName);
} }
function SOAActivityItemComponent_ng_template_18_ul_1_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const plan_r32 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(plan_r32);
} }
function SOAActivityItemComponent_ng_template_18_ul_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 32);
    i0.ɵɵtemplate(1, SOAActivityItemComponent_ng_template_18_ul_1_li_1_Template, 2, 1, "li", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r30.item.plans);
} }
function SOAActivityItemComponent_ng_template_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SOAActivityItemComponent_ng_template_18_span_0_Template, 2, 1, "span", 5);
    i0.ɵɵtemplate(1, SOAActivityItemComponent_ng_template_18_ul_1_Template, 2, 1, "ul", 31);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r12.item.fileName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.item.plans && ctx_r12.item.plans.length);
} }
function SOAActivityItemComponent_ng_template_20_a_0_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 37);
    i0.ɵɵlistener("click", function SOAActivityItemComponent_ng_template_20_a_0_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r35.viewItem()); })("keyup.enter", function SOAActivityItemComponent_ng_template_20_a_0_Template_a_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r36); const ctx_r37 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r37.viewItem()); });
    i0.ɵɵelement(1, "i", 38);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r33.viewText);
} }
function SOAActivityItemComponent_ng_template_20_button_1_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r38.buttonText, " ");
} }
function SOAActivityItemComponent_ng_template_20_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 39);
    i0.ɵɵlistener("click", function SOAActivityItemComponent_ng_template_20_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r40); const ctx_r39 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r39.toggleForm()); });
    i0.ɵɵtemplate(1, SOAActivityItemComponent_ng_template_20_button_1_span_1_Template, 2, 1, "span", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", ctx_r34.resourceName);
} }
function SOAActivityItemComponent_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SOAActivityItemComponent_ng_template_20_a_0_Template, 3, 1, "a", 35);
    i0.ɵɵtemplate(1, SOAActivityItemComponent_ng_template_20_button_1_Template, 2, 1, "button", 36);
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r14.item.type === ctx_r14.soaActivityType.COMPLETED || ctx_r14.item.type === ctx_r14.soaActivityType.UPLOADED_FILE || ctx_r14.item.type === ctx_r14.soaActivityType.COMPLETED_IN_PERSON || ctx_r14.item.type === ctx_r14.soaActivityType.COMPLETED_BY_PHONE);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.item.type === ctx_r14.soaActivityType.PARTIAL || ctx_r14.item.type === ctx_r14.soaActivityType.PARTIAL_IN_PERSON || ctx_r14.item.type === ctx_r14.soaActivityType.PARTIAL_BY_PHONE || ctx_r14.item.type === ctx_r14.soaActivityType.STARTED_IN_PERSON || ctx_r14.item.type === ctx_r14.soaActivityType.STARTED_BY_PHONE);
} }
function SOAActivityItemComponent_ng_template_22_vnext_call_recording_audio_player_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-call-recording-audio-player", 42);
} if (rf & 2) {
    const callRecord_r42 = ctx.$implicit;
    const ctx_r41 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("callRecord", callRecord_r42)("pacificStandardTimeText", ctx_r41.pacificStandardTimeText);
} }
function SOAActivityItemComponent_ng_template_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SOAActivityItemComponent_ng_template_22_vnext_call_recording_audio_player_0_Template, 1, 2, "vnext-call-recording-audio-player", 41);
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", ctx_r16.item.agentCallRecords);
} }
const _c1$3 = function (a0) { return { "mb-2": a0 }; };
const _c2$1 = function (a0, a1) { return { "col-4": a0, "col-12": a1 }; };
class SOAActivityItemComponent {
    constructor(soaFacade, store, analyticsService, fileUtilityService) {
        this.soaFacade = soaFacade;
        this.store = store;
        this.analyticsService = analyticsService;
        this.fileUtilityService = fileUtilityService;
        this.formOpen = false;
        this.completeButtonFormClick = new EventEmitter();
        this.soaActivityType = SOAActivityType;
        this.showAgentCallRecordsSection = false;
    }
    get confirmationNumber() {
        return `${this.confirmationText} #${this.item.confirmationNumber}`;
    }
    get buttonText() {
        return this.formOpen ? this.activityCloseFormText : this.activityCompletedFormText;
    }
    get resourceName() {
        return this.formOpen ? 'Spa_SOA_Activity_CloseForm_Text' : 'Spa_SOA_Activity_CompleteForm_Text';
    }
    ngOnInit() {
        this.showAgentCallRecordsSection =
            this.isAdmin && this.agentCallRecordsEnabled && !!this.item.agentCallRecords?.length && this.soaFacade.isSOACompleted(this.item.type);
    }
    viewItem() {
        if (this.item.type === this.soaActivityType.UPLOADED_FILE) {
            this.downloadDocument();
        }
        else if ((this.item.type === this.soaActivityType.COMPLETED ||
            this.item.type === this.soaActivityType.COMPLETED_IN_PERSON ||
            this.item.type === this.soaActivityType.COMPLETED_BY_PHONE) &&
            this.item.transactionId) {
            this.downloadSOAFormPDF(this.item.transactionId);
        }
    }
    toggleForm() {
        if (!this.formOpen) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_SOA_COMPLETE_FORM);
        }
        this.formOpen = !this.formOpen;
        this.completeButtonFormClick.emit(this.formOpen);
    }
    downloadDocument() {
        this.soaFacade.downloadDocument(this.item.documentId, this.memberId).then(file => {
            const dataURI = `data:${file.ContentType};base64,${file.DocumentContext}`;
            this.fileUtilityService.downloadFile(dataURI, file.FileName, file.ContentType);
        });
    }
    downloadSOAFormPDF(transactionId) {
        this.soaFacade.generateBase64PDF(transactionId).then(base64PDF => {
            const firstName = this.store.selectSnapshot(ProfileState.firstName);
            const lastName = this.store.selectSnapshot(ProfileState.lastName);
            const beneficiaryName = (firstName + (firstName && lastName ? '_' : '') + lastName).replace('.', '');
            const date = DateUtilities.getFormattedDate(new Date(this.item.date));
            const contentType = 'application/pdf';
            const dataURI = `data:${contentType};base64,${base64PDF}`;
            const fileName = `SOA_${beneficiaryName}_${date}.pdf`;
            this.fileUtilityService.downloadFile(dataURI, fileName, contentType);
        });
    }
}
SOAActivityItemComponent.ɵfac = function SOAActivityItemComponent_Factory(t) { return new (t || SOAActivityItemComponent)(i0.ɵɵdirectiveInject(SOAFacade), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.FileDownloadUtilityService)); };
SOAActivityItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SOAActivityItemComponent, selectors: [["vnext-soa-activity-item"]], inputs: { activityCompletedFormText: "activityCompletedFormText", activityCloseFormText: "activityCloseFormText", item: "item", message: "message", confirmationText: "confirmationText", memberId: "memberId", viewText: "viewText", isLastActivity: "isLastActivity", formOpen: "formOpen", pacificStandardTimeText: "pacificStandardTimeText", agentCallRecordsEnabled: "agentCallRecordsEnabled", isAdmin: "isAdmin" }, outputs: { completeButtonFormClick: "completeButtonFormClick" }, decls: 24, vars: 16, consts: [[1, "Spa_Style_Gray1_Background", "Spa_Style_Paragraph", "row", "px-1", "py-3", 3, "ngClass"], [1, "d-none", "d-lg-flex", "w-100", "align-items-center"], [1, "row", "mx-2", "w-100"], [3, "ngClass"], [4, "ngTemplateOutlet"], [4, "ngIf"], ["class", "col-12 mt-3 pb-2 soa-separator px-3", 4, "ngIf"], [1, "d-none", "d-sm-flex", "d-lg-none", "w-100", "row", "mx-2"], [1, "d-block", "d-sm-none", "w-100", "row", "mx-1"], [1, "col-12", "pl-0"], ["class", "col-12 mt-3 pb-2 soa-separator px-0", 4, "ngIf"], ["activityMessage", ""], ["plansAndFileName", ""], ["linkAndButton", ""], ["agentCallRecords", ""], [1, "col-5"], [1, "col-3", "text-center"], [1, "w-100"], [1, "col-12", "mt-3", "pb-2", "soa-separator", "px-3"], [1, "col-12"], [1, "col-5", "d-flex", "flex-column"], [1, "mb-2"], [1, "mt-auto", "w-100"], [1, "col-7"], [1, "col-12", "mt-2", "px-0"], [1, "col-12", "mt-3", "pb-2", "soa-separator", "px-0"], [1, "d-table-row", 3, "ngClass"], ["aria-hidden", "true", 1, "fas", "fa-check-circle", "d-table-cell", "pr-1"], [1, "d-table-cell"], ["class", "Spa_Style_Gray4_Color Spa_Style_Smaller_Font", 4, "ngIf"], [1, "Spa_Style_Gray4_Color", "Spa_Style_Smaller_Font"], ["class", "mb-0 pl-3", 4, "ngIf"], [1, "mb-0", "pl-3"], ["class", "Spa_Style_Primary_Color Spa_Style_Note", 4, "ngFor", "ngForOf"], [1, "Spa_Style_Primary_Color", "Spa_Style_Note"], ["tabindex", "0", "class", "Spa_Style_Link", 3, "click", "keyup.enter", 4, "ngIf"], ["class", "btn Spa_Style_SecondaryButton w-100", "type", "button", 3, "click", 4, "ngIf"], ["tabindex", "0", 1, "Spa_Style_Link", 3, "click", "keyup.enter"], ["aria-hidden", "true", 1, "fas", "fa-file-alt", "pr-1"], ["type", "button", 1, "btn", "Spa_Style_SecondaryButton", "w-100", 3, "click"], [4, "liveEditProp"], [3, "callRecord", "pacificStandardTimeText", 4, "ngFor", "ngForOf"], [3, "callRecord", "pacificStandardTimeText"]], template: function SOAActivityItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3);
        i0.ɵɵtemplate(4, SOAActivityItemComponent_ng_container_4_Template, 1, 0, "ng-container", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, SOAActivityItemComponent_ng_container_5_Template, 6, 2, "ng-container", 5);
        i0.ɵɵtemplate(6, SOAActivityItemComponent_div_6_Template, 2, 1, "div", 6);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 7);
        i0.ɵɵtemplate(8, SOAActivityItemComponent_ng_container_8_Template, 3, 1, "ng-container", 5);
        i0.ɵɵtemplate(9, SOAActivityItemComponent_ng_container_9_Template, 8, 3, "ng-container", 5);
        i0.ɵɵtemplate(10, SOAActivityItemComponent_div_10_Template, 2, 1, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 8)(12, "div", 9);
        i0.ɵɵtemplate(13, SOAActivityItemComponent_ng_container_13_Template, 1, 0, "ng-container", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(14, SOAActivityItemComponent_ng_container_14_Template, 5, 2, "ng-container", 5);
        i0.ɵɵtemplate(15, SOAActivityItemComponent_div_15_Template, 2, 1, "div", 10);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(16, SOAActivityItemComponent_ng_template_16_Template, 6, 6, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(18, SOAActivityItemComponent_ng_template_18_Template, 2, 2, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(20, SOAActivityItemComponent_ng_template_20_Template, 2, 2, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(22, SOAActivityItemComponent_ng_template_22_Template, 1, 1, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r9 = i0.ɵɵreference(17);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c1$3, !ctx.isLastActivity));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(13, _c2$1, ctx.item.type !== ctx.soaActivityType.STARTED_EMAIL && ctx.item.type !== ctx.soaActivityType.STARTED_TEXT, ctx.item.type === ctx.soaActivityType.STARTED_EMAIL || ctx.item.type === ctx.soaActivityType.STARTED_TEXT));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngTemplateOutlet", _r9);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.item.type !== ctx.soaActivityType.STARTED_EMAIL && ctx.item.type !== ctx.soaActivityType.STARTED_TEXT);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showAgentCallRecordsSection);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.item.type === ctx.soaActivityType.STARTED_EMAIL || ctx.item.type === ctx.soaActivityType.STARTED_TEXT);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.item.type !== ctx.soaActivityType.STARTED_EMAIL && ctx.item.type !== ctx.soaActivityType.STARTED_TEXT);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showAgentCallRecordsSection);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngTemplateOutlet", _r9);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.item.type !== ctx.soaActivityType.STARTED_EMAIL && ctx.item.type !== ctx.soaActivityType.STARTED_TEXT);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showAgentCallRecordsSection);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i1$2.NgTemplateOutlet, LiveEditPropDirective, IconAriaAttributesDirective, CallRecordingAudioPlayerComponent], styles: [".activity[_ngcontent-%COMP%]{display:inline-block;border:1px solid white;border-radius:5px;width:100%;margin:9px 0;padding:20px}.activity[_ngcontent-%COMP%]   .fas[_ngcontent-%COMP%]{margin-right:8px}.item-wrapper[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.Spa_Style_Link[_ngcontent-%COMP%]{cursor:pointer}.DFSpaButton[_ngcontent-%COMP%]{height:100%!important;margin:0;border-radius:.25rem;font-family:montserrat_semibold!important}.finished-activity[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Cost_Text)}.soa-separator[_ngcontent-%COMP%]{border-top:1px solid var(--static-Spa_Style_Gray2);border-bottom:1px solid var(--static-Spa_Style_Gray2);margin:2px}"], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], SOAActivityItemComponent.prototype, "viewItem", null);
__decorate([
    LiveEditInactive()
], SOAActivityItemComponent.prototype, "toggleForm", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SOAActivityItemComponent, [{
        type: Component,
        args: [{ selector: 'vnext-soa-activity-item', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"Spa_Style_Gray1_Background Spa_Style_Paragraph row px-1 py-3\" [ngClass]=\"{ 'mb-2': !isLastActivity }\">\r\n  <!-- Desktop -->\r\n  <div class=\"d-none d-lg-flex w-100 align-items-center\">\r\n    <div class=\"row mx-2 w-100\">\r\n      <div\r\n        [ngClass]=\"{\r\n          'col-4': item.type !== soaActivityType.STARTED_EMAIL && item.type !== soaActivityType.STARTED_TEXT,\r\n          'col-12': item.type === soaActivityType.STARTED_EMAIL || item.type === soaActivityType.STARTED_TEXT\r\n        }\"\r\n      >\r\n        <ng-container *ngTemplateOutlet=\"activityMessage\"></ng-container>\r\n      </div>\r\n      <ng-container *ngIf=\"item.type !== soaActivityType.STARTED_EMAIL && item.type !== soaActivityType.STARTED_TEXT\">\r\n        <div class=\"col-5\">\r\n          <ng-container *ngTemplateOutlet=\"plansAndFileName\"></ng-container>\r\n        </div>\r\n        <div class=\"col-3 text-center\">\r\n          <div class=\"w-100\">\r\n            <ng-container *ngTemplateOutlet=\"linkAndButton\"></ng-container>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n\r\n      <div *ngIf=\"showAgentCallRecordsSection\" class=\"col-12 mt-3 pb-2 soa-separator px-3\">\r\n        <ng-container *ngTemplateOutlet=\"agentCallRecords\"></ng-container>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- Tablet -->\r\n  <div class=\"d-none d-sm-flex d-lg-none w-100 row mx-2\">\r\n    <ng-container *ngIf=\"item.type === soaActivityType.STARTED_EMAIL || item.type === soaActivityType.STARTED_TEXT\">\r\n      <div class=\"col-12\">\r\n        <ng-container *ngTemplateOutlet=\"activityMessage\"></ng-container>\r\n      </div>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"item.type !== soaActivityType.STARTED_EMAIL && item.type !== soaActivityType.STARTED_TEXT\">\r\n      <div class=\"col-5 d-flex flex-column\">\r\n        <div class=\"mb-2\"><ng-container *ngTemplateOutlet=\"activityMessage\"></ng-container></div>\r\n        <div class=\"mt-auto w-100\"><ng-container *ngTemplateOutlet=\"linkAndButton\"></ng-container></div>\r\n      </div>\r\n      <div class=\"col-7\">\r\n        <ng-container *ngTemplateOutlet=\"plansAndFileName\"></ng-container>\r\n      </div>\r\n    </ng-container>\r\n\r\n    <div *ngIf=\"showAgentCallRecordsSection\" class=\"col-12 mt-3 pb-2 soa-separator px-3\">\r\n      <ng-container *ngTemplateOutlet=\"agentCallRecords\"></ng-container>\r\n    </div>\r\n  </div>\r\n\r\n  <!-- Mobile -->\r\n  <div class=\"d-block d-sm-none w-100 row mx-1\">\r\n    <div class=\"col-12 pl-0\">\r\n      <ng-container *ngTemplateOutlet=\"activityMessage\"></ng-container>\r\n    </div>\r\n    <ng-container *ngIf=\"item.type !== soaActivityType.STARTED_EMAIL && item.type !== soaActivityType.STARTED_TEXT\">\r\n      <div class=\"col-12 mt-2 px-0\">\r\n        <ng-container *ngTemplateOutlet=\"plansAndFileName\"></ng-container>\r\n      </div>\r\n      <div class=\"col-12 mt-2 px-0\">\r\n        <ng-container *ngTemplateOutlet=\"linkAndButton\"></ng-container>\r\n      </div>\r\n    </ng-container>\r\n    <div *ngIf=\"showAgentCallRecordsSection\" class=\"col-12 mt-3 pb-2 soa-separator px-0\">\r\n      <ng-container *ngTemplateOutlet=\"agentCallRecords\"></ng-container>\r\n    </div>\r\n  </div>\r\n</div>\r\n<ng-template #activityMessage>\r\n  <div\r\n    class=\"d-table-row\"\r\n    [ngClass]=\"{\r\n      'finished-activity':\r\n        item.type === soaActivityType.COMPLETED ||\r\n        item.type === soaActivityType.UPLOADED_FILE ||\r\n        item.type === soaActivityType.COMPLETED_IN_PERSON ||\r\n        item.type === soaActivityType.COMPLETED_BY_PHONE,\r\n      'Spa_Style_Gray4_Color':\r\n        item.type === soaActivityType.PARTIAL ||\r\n        item.type === soaActivityType.STARTED_TEXT ||\r\n        item.type === soaActivityType.STARTED_EMAIL ||\r\n        item.type === soaActivityType.STARTED_IN_PERSON ||\r\n        item.type === soaActivityType.STARTED_BY_PHONE ||\r\n        item.type === soaActivityType.PARTIAL_IN_PERSON ||\r\n        item.type === soaActivityType.PARTIAL_BY_PHONE\r\n    }\"\r\n  >\r\n    <i class=\"fas fa-check-circle d-table-cell pr-1\" aria-hidden=\"true\"></i>\r\n    <div class=\"d-table-cell\">\r\n      <div>{{ message }}</div>\r\n      <div\r\n        *ngIf=\"\r\n          item.type === soaActivityType.COMPLETED ||\r\n          item.type === soaActivityType.COMPLETED_IN_PERSON ||\r\n          item.type === soaActivityType.COMPLETED_BY_PHONE\r\n        \"\r\n        class=\"Spa_Style_Gray4_Color Spa_Style_Smaller_Font\"\r\n      >\r\n        {{ confirmationNumber }}\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n<ng-template #plansAndFileName>\r\n  <span *ngIf=\"item.fileName\">{{ item.fileName }}</span>\r\n  <ul *ngIf=\"item.plans && item.plans.length\" class=\"mb-0 pl-3\">\r\n    <li *ngFor=\"let plan of item.plans\" class=\"Spa_Style_Primary_Color Spa_Style_Note\">{{ plan }}</li>\r\n  </ul>\r\n</ng-template>\r\n<ng-template #linkAndButton>\r\n  <!--\r\n    this is supposed to be a vnext-link but a lot of time was spent failing to figure out why it didnt work\r\n    specifically, it's the click event that is not firing here. Keyup.enter does indeed work\r\n    <vnext-link [title]=\"viewText\" [additionalIcon]=\"'fas fa-file-alt'\" (click)=\"viewItem()\" (keyup.enter)=\"viewItem()\"></vnext-link>\r\n  -->\r\n  <a\r\n    (click)=\"viewItem()\"\r\n    (keyup.enter)=\"viewItem()\"\r\n    tabindex=\"0\"\r\n    class=\"Spa_Style_Link\"\r\n    *ngIf=\"\r\n      item.type === soaActivityType.COMPLETED ||\r\n      item.type === soaActivityType.UPLOADED_FILE ||\r\n      item.type === soaActivityType.COMPLETED_IN_PERSON ||\r\n      item.type === soaActivityType.COMPLETED_BY_PHONE\r\n    \"\r\n    ><i class=\"fas fa-file-alt pr-1\" aria-hidden=\"true\"></i>{{ viewText }}</a\r\n  >\r\n  <button\r\n    (click)=\"toggleForm()\"\r\n    class=\"btn Spa_Style_SecondaryButton w-100\"\r\n    type=\"button\"\r\n    *ngIf=\"\r\n      item.type === soaActivityType.PARTIAL ||\r\n      item.type === soaActivityType.PARTIAL_IN_PERSON ||\r\n      item.type === soaActivityType.PARTIAL_BY_PHONE ||\r\n      item.type === soaActivityType.STARTED_IN_PERSON ||\r\n      item.type === soaActivityType.STARTED_BY_PHONE\r\n    \"\r\n  >\r\n    <span *liveEditProp=\"resourceName\">\r\n      {{ buttonText }}\r\n    </span>\r\n  </button>\r\n</ng-template>\r\n<ng-template #agentCallRecords>\r\n  <vnext-call-recording-audio-player\r\n    *ngFor=\"let callRecord of item.agentCallRecords\"\r\n    [callRecord]=\"callRecord\"\r\n    [pacificStandardTimeText]=\"pacificStandardTimeText\"\r\n  ></vnext-call-recording-audio-player>\r\n</ng-template>\r\n", styles: [".activity{display:inline-block;border:1px solid white;border-radius:5px;width:100%;margin:9px 0;padding:20px}.activity .fas{margin-right:8px}.item-wrapper{display:flex;justify-content:space-between}.Spa_Style_Link{cursor:pointer}.DFSpaButton{height:100%!important;margin:0;border-radius:.25rem;font-family:montserrat_semibold!important}.finished-activity{color:var(--static-Spa_Style_Cost_Text)}.soa-separator{border-top:1px solid var(--static-Spa_Style_Gray2);border-bottom:1px solid var(--static-Spa_Style_Gray2);margin:2px}\n"] }]
    }], function () { return [{ type: SOAFacade }, { type: i2.Store }, { type: AnalyticsService }, { type: i1.FileDownloadUtilityService }]; }, { activityCompletedFormText: [{
            type: Input
        }], activityCloseFormText: [{
            type: Input
        }], item: [{
            type: Input
        }], message: [{
            type: Input
        }], confirmationText: [{
            type: Input
        }], memberId: [{
            type: Input
        }], viewText: [{
            type: Input
        }], isLastActivity: [{
            type: Input
        }], formOpen: [{
            type: Input
        }], pacificStandardTimeText: [{
            type: Input
        }], agentCallRecordsEnabled: [{
            type: Input
        }], isAdmin: [{
            type: Input
        }], completeButtonFormClick: [{
            type: Output
        }], viewItem: [], toggleForm: [] }); })();

function SOAActivityComponent_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-soa-activity-item", 6);
    i0.ɵɵlistener("completeButtonFormClick", function SOAActivityComponent_div_1_ng_container_2_Template_vnext_soa_activity_item_completeButtonFormClick_1_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r7); const activity_r4 = restoredCtx.$implicit; const ctx_r6 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r6.toggleForm($event, activity_r4)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const activity_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("item", activity_r4)("message", ctx_r3.getActivityMessage(activity_r4))("confirmationText", ctx_r3.confirmationText)("memberId", ctx_r3.memberId)("viewText", ctx_r3.viewText)("formOpen", activity_r4.formOpen)("isLastActivity", i_r5 + 1 === ctx_r3.fullItemList.length)("activityCompletedFormText", ctx_r3.activityCompletedFormText)("pacificStandardTimeText", ctx_r3.pacificStandardTimeText)("agentCallRecordsEnabled", ctx_r3.agentCallRecordsEnabled)("activityCloseFormText", ctx_r3.activityCloseFormText)("isAdmin", ctx_r3.isAdmin);
} }
function SOAActivityComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵtemplate(2, SOAActivityComponent_div_1_ng_container_2_Template, 2, 12, "ng-container", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.fullItemList);
} }
function SOAActivityComponent_ng_template_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r8.noActivityText);
} }
function SOAActivityComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, SOAActivityComponent_ng_template_2_span_1_Template, 2, 1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_SOA_Activity_NoSOAText");
} }
class SOAActivityComponent {
    /** Should only show one instance of started soa activity type */
    constructor(soaFacade) {
        this.soaFacade = soaFacade;
        this.startedText = 'Email sent to <soaEmail> on <soaDate>';
        this.uploadedText = 'Uploaded <soaDate>';
        this.partialText = 'Completed by <soaMemberName> on <soaDate>';
        this.partialAgentText = 'Completed by agent with <soaMemberName> on <soaDate>';
        this.completedText = 'Completed <soaDate>';
        this.completedAgentText = 'Completed (phone/in-person) <soaDate>';
        this.agentStartedText = 'SOA started on <soaDate>';
        this.memberName = '';
        this.completeFormClick = new EventEmitter();
        this.fullItemList = [];
        this.agentCallRecordsEnabled = false;
    }
    ngOnChanges(changes) {
        const { selectedActivity, activities, documents, shoppingRecordingEnabled, agentCallRecordingDisplayPlayAudioRecordingEnabled } = changes;
        if (!_isEqual(selectedActivity?.previousValue, selectedActivity?.currentValue) ||
            !_isEqual(activities?.previousValue, activities?.currentValue) ||
            !_isEqual(documents?.previousValue, documents?.currentValue)) {
            this.getAllActivityInfo();
        }
        if ((shoppingRecordingEnabled && shoppingRecordingEnabled.previousValue !== shoppingRecordingEnabled.currentValue) ||
            (agentCallRecordingDisplayPlayAudioRecordingEnabled &&
                agentCallRecordingDisplayPlayAudioRecordingEnabled.previousValue !==
                    agentCallRecordingDisplayPlayAudioRecordingEnabled.currentValue)) {
            this.agentCallRecordsEnabled = this.shoppingRecordingEnabled && this.agentCallRecordingDisplayPlayAudioRecordingEnabled;
        }
    }
    getAllActivityInfo() {
        this.activityList = this.activities?.map(activity => ({
            ...activity,
            formOpen: activity.transactionId === this.selectedActivity?.transactionId || activity.transactionSId === this.selectedActivity?.transactionSId
        }));
        if (this.activityList) {
            this.latestStartedEmailActivity = this.getLatestActivity(SOAActivityType.STARTED_EMAIL);
            this.latestStartedTextActivity = this.getLatestActivity(SOAActivityType.STARTED_TEXT);
            this.inPersonSOAActivities = this.getActivities(SOAActivityType.STARTED_IN_PERSON);
            this.byPhoneSOAActivities = this.getActivities(SOAActivityType.STARTED_BY_PHONE);
            this.partialActivities = this.getActivities(SOAActivityType.PARTIAL);
            this.partialInPersonActivities = this.getActivities(SOAActivityType.PARTIAL_IN_PERSON);
            this.partialByPhoneActivities = this.getActivities(SOAActivityType.PARTIAL_BY_PHONE);
            this.completedActivities = this.getActivities(SOAActivityType.COMPLETED);
            this.inPersonCompletedActivities = this.getActivities(SOAActivityType.COMPLETED_IN_PERSON);
            this.byPhoneCompletedActivities = this.getActivities(SOAActivityType.COMPLETED_BY_PHONE);
            this.documentsAsActivity = this.getDocumentsAsActivity();
            this.fullItemList = this.getFullItemList();
        }
    }
    getLatestActivity(soaActivityType) {
        return this.soaFacade.latestStartedActivity(this.activityList, soaActivityType);
    }
    getActivities(soaActivityType) {
        return this.activityList?.filter(activity => activity.type === soaActivityType) ?? [];
    }
    getDocumentsAsActivity() {
        return (this.documents?.map(document => {
            const newActivity = {
                type: SOAActivityType.UPLOADED_FILE,
                fileName: document.Filename,
                date: document.UploadedDate,
                documentId: document.Documentid
            };
            return newActivity;
        }) || []);
    }
    getFullItemList() {
        const activities = [
            this.latestStartedEmailActivity,
            this.latestStartedTextActivity,
            ...this.documentsAsActivity,
            ...this.partialActivities,
            ...this.completedActivities,
            ...this.inPersonSOAActivities,
            ...this.inPersonCompletedActivities,
            ...this.partialInPersonActivities,
            ...this.byPhoneSOAActivities,
            ...this.byPhoneCompletedActivities,
            ...this.partialByPhoneActivities
        ];
        return activities
            .filter(activity => activity.date)
            .sort((activityA, activityB) => new Date(activityB.date).getTime() - new Date(activityA.date).getTime());
    }
    getActivityMessage(activity) {
        return this.soaFacade.getActivityMessage(activity, this.memberName, this.memberPhone);
    }
    toggleForm(showForm, selectedActivity) {
        this.activityList.forEach(activity => {
            if (activity.transactionId !== selectedActivity.transactionId) {
                activity.formOpen = false;
            }
        });
        selectedActivity.formOpen = showForm;
        showForm ? this.completeFormClick.emit(selectedActivity) : this.completeFormClick.emit(false);
    }
}
SOAActivityComponent.ɵfac = function SOAActivityComponent_Factory(t) { return new (t || SOAActivityComponent)(i0.ɵɵdirectiveInject(SOAFacade)); };
SOAActivityComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SOAActivityComponent, selectors: [["vnext-soa-activity"]], inputs: { activityCompletedFormText: "activityCompletedFormText", activityCloseFormText: "activityCloseFormText", noActivityText: "noActivityText", selectedActivity: "selectedActivity", activities: "activities", startedText: "startedText", uploadedText: "uploadedText", partialText: "partialText", partialAgentText: "partialAgentText", completedText: "completedText", completedAgentText: "completedAgentText", agentStartedText: "agentStartedText", confirmationText: "confirmationText", textSentText: "textSentText", memberPhone: "memberPhone", memberName: "memberName", documents: "documents", memberId: "memberId", viewText: "viewText", pacificStandardTimeText: "pacificStandardTimeText", shoppingRecordingEnabled: "shoppingRecordingEnabled", agentCallRecordingDisplayPlayAudioRecordingEnabled: "agentCallRecordingDisplayPlayAudioRecordingEnabled", isAdmin: "isAdmin" }, outputs: { completeFormClick: "completeFormClick" }, features: [i0.ɵɵNgOnChangesFeature], decls: 4, vars: 2, consts: [[1, "row"], ["class", "col-12", 4, "ngIf", "ngIfElse"], ["noActivites", ""], [1, "col-12"], [1, "container"], [4, "ngFor", "ngForOf"], [3, "item", "message", "confirmationText", "memberId", "viewText", "formOpen", "isLastActivity", "activityCompletedFormText", "pacificStandardTimeText", "agentCallRecordsEnabled", "activityCloseFormText", "isAdmin", "completeButtonFormClick"], [1, "col-12", "text-center"], [4, "liveEditProp"]], template: function SOAActivityComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, SOAActivityComponent_div_1_Template, 3, 1, "div", 1);
        i0.ɵɵtemplate(2, SOAActivityComponent_ng_template_2_Template, 2, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(3);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fullItemList && ctx.fullItemList.length > 0)("ngIfElse", _r1);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, LiveEditPropDirective, SOAActivityItemComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SOAActivityComponent, [{
        type: Component,
        args: [{ selector: 'vnext-soa-activity', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"row\">\r\n  <div class=\"col-12\" *ngIf=\"fullItemList && fullItemList.length > 0; else noActivites\">\r\n    <div class=\"container\">\r\n      <ng-container *ngFor=\"let activity of fullItemList; index as i\">\r\n        <vnext-soa-activity-item\r\n          [item]=\"activity\"\r\n          [message]=\"getActivityMessage(activity)\"\r\n          [confirmationText]=\"confirmationText\"\r\n          [memberId]=\"memberId\"\r\n          [viewText]=\"viewText\"\r\n          [formOpen]=\"activity.formOpen\"\r\n          [isLastActivity]=\"i + 1 === fullItemList.length\"\r\n          (completeButtonFormClick)=\"toggleForm($event, activity)\"\r\n          [activityCompletedFormText]=\"activityCompletedFormText\"\r\n          [pacificStandardTimeText]=\"pacificStandardTimeText\"\r\n          [agentCallRecordsEnabled]=\"agentCallRecordsEnabled\"\r\n          [activityCloseFormText]=\"activityCloseFormText\"\r\n          [isAdmin]=\"isAdmin\"\r\n        ></vnext-soa-activity-item>\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n  <ng-template #noActivites>\r\n    <div class=\"col-12 text-center\">\r\n      <span *liveEditProp=\"'Spa_SOA_Activity_NoSOAText'\">{{ noActivityText }}</span>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: SOAFacade }]; }, { activityCompletedFormText: [{
            type: Input
        }], activityCloseFormText: [{
            type: Input
        }], noActivityText: [{
            type: Input
        }], selectedActivity: [{
            type: Input
        }], activities: [{
            type: Input
        }], startedText: [{
            type: Input
        }], uploadedText: [{
            type: Input
        }], partialText: [{
            type: Input
        }], partialAgentText: [{
            type: Input
        }], completedText: [{
            type: Input
        }], completedAgentText: [{
            type: Input
        }], agentStartedText: [{
            type: Input
        }], confirmationText: [{
            type: Input
        }], textSentText: [{
            type: Input
        }], memberPhone: [{
            type: Input
        }], memberName: [{
            type: Input
        }], documents: [{
            type: Input
        }], memberId: [{
            type: Input
        }], viewText: [{
            type: Input
        }], pacificStandardTimeText: [{
            type: Input
        }], shoppingRecordingEnabled: [{
            type: Input
        }], agentCallRecordingDisplayPlayAudioRecordingEnabled: [{
            type: Input
        }], isAdmin: [{
            type: Input
        }], completeFormClick: [{
            type: Output
        }] }); })();

const _c0$r = ["errorContainer"];
function SoaAgentFormComponent_ng_container_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-notice", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r2.memberProfileErrorMessagesTitleText)("messages", ctx_r2.errorBannerList)("type", "error");
} }
function SoaAgentFormComponent_ng_container_0_vnext_status_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-status-button", 12);
    i0.ɵɵlistener("click", function SoaAgentFormComponent_ng_container_0_vnext_status_button_13_Template_vnext_status_button_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r4.onSubmit()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("buttonText", ctx_r3.submitButtonText)("buttonClass", "Spa_Style_PrimaryButton h-100")("tooltipMessageError", ctx_r3.soaFormSubmitErrorText);
} }
function SoaAgentFormComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "div", 2, 3);
    i0.ɵɵtemplate(4, SoaAgentFormComponent_ng_container_0_ng_container_4_Template, 2, 3, "ng-container", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 4);
    i0.ɵɵelement(6, "form", 5);
    i0.ɵɵpipe(7, "safe");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 6)(10, "div", 7)(11, "vnext-navigation-banner", 8)(12, "div", 9);
    i0.ɵɵtemplate(13, SoaAgentFormComponent_ng_container_0_vnext_status_button_13_Template, 1, 3, "vnext-status-button", 10);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.errorBannerList.length);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r0.formId)("innerHTML", i0.ɵɵpipeBind2(7, 5, i0.ɵɵpipeBind1(8, 8, ctx_r0.html$), "html"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("providedPrevious", false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", ctx_r0.submitButtonKeyText);
} }
var FormIds;
(function (FormIds) {
    FormIds["AGENT_FIRSTNAME"] = "Input_54";
    FormIds["AGENT_LASTNAME"] = "Input_55";
    FormIds["DATE_OF_APPOINTMENT"] = "Date_25";
})(FormIds || (FormIds = {}));
class SoaAgentFormComponent extends FormRendererComponent {
    constructor(elementRef, enrollmentFormService, activatedRoute, cdr, soaFormFacade, soaFacade, analyticsService) {
        super(elementRef, enrollmentFormService, activatedRoute, cdr);
        this.elementRef = elementRef;
        this.enrollmentFormService = enrollmentFormService;
        this.activatedRoute = activatedRoute;
        this.cdr = cdr;
        this.soaFormFacade = soaFormFacade;
        this.soaFacade = soaFacade;
        this.analyticsService = analyticsService;
        this.formSubmitted = new EventEmitter(false);
        this.errorBannerList = [];
        this.checkFocus = false;
        this.VALIDATE_FORM_METHOD = 'ValidateForm';
    }
    get selectedActivity() {
        return this._selectedActivity;
    }
    set selectedActivity(activity) {
        this._selectedActivity = activity;
        this.getForm();
    }
    ngAfterViewChecked() {
        if (this.checkFocus) {
            const firstInvalidSOAAgentFormInput = document.querySelector('input.input-validation-error');
            const firstInvalidSOAAgentElement = firstInvalidSOAAgentFormInput;
            if (firstInvalidSOAAgentElement) {
                firstInvalidSOAAgentElement.focus();
            }
            this.checkFocus = false;
        }
    }
    getForm() {
        this.html$ = this.soaFormFacade.getFormPage$(this.selectedActivity.transactionId, 'SOAAgentStartPage').pipe(tap(formHtml => {
            if (formHtml) {
                setTimeout(() => {
                    this.loadPrerequisiteScripts();
                    this.initializeView();
                    this.viewInitialized$.next(true);
                    this.prePopulatedInfo = this.setPrePopulatedInfo();
                });
            }
        }));
    }
    getFOAMErrors() {
        const validateFormMethod = window && window[this.VALIDATE_FORM_METHOD];
        // passing true in order to get error messages back rather than a pure boolean pass/fail result
        return !validateFormMethod || validateFormMethod(true);
    }
    onSubmit() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_SOA_SUBMIT_FORM_BY_AGENT);
        this.errorBannerList = this.getFOAMErrors();
        if (this.errorBannerList.length > 0) {
            this.checkFocus = true;
            this.scrollToErrors();
        }
        else {
            const answers = this.retrieveFormAnswers();
            this.soaFormFacade
                .submitForm$(this.selectedActivity.transactionSId, { answers, pageIndex: 1 })
                .pipe(switchMap(() => this.soaFormFacade.finishForm$(this.selectedActivity.transactionSId, { answers })), switchMap(() => this.soaFacade.fetchSOATransactions$()), take(1))
                .subscribe({
                next: response => {
                    this.formSubmitted.emit(true);
                }
            });
        }
    }
    retrieveFormAnswers() {
        const inputAnswers = this.retrieveFormInputValues();
        return Object.keys(inputAnswers).map(key => new Answer(key, inputAnswers[key]));
    }
    scrollToErrors() {
        this.errorContainer.first.nativeElement.scrollIntoView({ behavior: 'smooth' });
    }
    setPrePopulatedInfo() {
        const agent = this.soaFacade.getAgent();
        const firstName = document.getElementById(FormIds.AGENT_FIRSTNAME);
        if (firstName) {
            firstName.value = agent.firstName;
        }
        const lastName = document.getElementById(FormIds.AGENT_LASTNAME);
        if (lastName) {
            lastName.value = agent.lastName;
        }
        const dateOfAppointmentCompleted = document.getElementById(FormIds.DATE_OF_APPOINTMENT);
        if (dateOfAppointmentCompleted) {
            dateOfAppointmentCompleted.value = DateUtilities.getFormattedCurrentDate();
        }
    }
}
SoaAgentFormComponent.ɵfac = function SoaAgentFormComponent_Factory(t) { return new (t || SoaAgentFormComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(SoaFormFacade), i0.ɵɵdirectiveInject(SOAFacade), i0.ɵɵdirectiveInject(AnalyticsService)); };
SoaAgentFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SoaAgentFormComponent, selectors: [["vnext-soa-agent-form"]], viewQuery: function SoaAgentFormComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(StatusButtonComponent, 5);
        i0.ɵɵviewQuery(_c0$r, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.submitButton = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.errorContainer = _t);
    } }, inputs: { selectedActivity: "selectedActivity", submitButtonText: "submitButtonText", submitButtonKeyText: "submitButtonKeyText", soaFormSubmitErrorText: "soaFormSubmitErrorText", memberProfileErrorMessagesTitleText: "memberProfileErrorMessagesTitleText" }, outputs: { formSubmitted: "formSubmitted" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "container"], [1, "row", "mt-5"], ["errorContainer", ""], [1, "px-3"], ["navigationAdapter", "", 1, "mt-3", 3, "id", "innerHTML"], [1, "row"], [1, "col-12"], [3, "providedPrevious"], ["continue-button", ""], [3, "buttonText", "buttonClass", "tooltipMessageError", "click", 4, "liveEditProp"], [1, "col-12", 3, "title", "messages", "type"], [3, "buttonText", "buttonClass", "tooltipMessageError", "click"]], template: function SoaAgentFormComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SoaAgentFormComponent_ng_container_0_Template, 14, 10, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.selectedActivity);
    } }, dependencies: [i1$2.NgIf, i4.ɵNgNoValidate, i4.NgControlStatusGroup, i4.NgForm, NavigationBannerComponent, StatusButtonComponent, NoticeComponent, NavigationAdapterDirective, LiveEditPropDirective, i1$2.AsyncPipe, SafePipe], changeDetection: 0 });
__decorate([
    LiveEditInactive()
], SoaAgentFormComponent.prototype, "onSubmit", null);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SoaAgentFormComponent, [{
        type: Component,
        args: [{ selector: 'vnext-soa-agent-form', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"selectedActivity\">\r\n  <div class=\"container\">\r\n    <div #errorContainer class=\"row mt-5\">\r\n      <ng-container *ngIf=\"errorBannerList.length\">\r\n        <vnext-notice\r\n          [title]=\"memberProfileErrorMessagesTitleText\"\r\n          [messages]=\"errorBannerList\"\r\n          [type]=\"'error'\"\r\n          class=\"col-12\"\r\n        ></vnext-notice>\r\n      </ng-container>\r\n    </div>\r\n    <div class=\"px-3\">\r\n      <form class=\"mt-3\" [id]=\"formId\" [innerHTML]=\"html$ | async | safe: 'html'\" navigationAdapter></form>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-12\">\r\n        <vnext-navigation-banner [providedPrevious]=\"false\">\r\n          <div continue-button>\r\n            <vnext-status-button\r\n              [buttonText]=\"submitButtonText\"\r\n              [buttonClass]=\"'Spa_Style_PrimaryButton h-100'\"\r\n              [tooltipMessageError]=\"soaFormSubmitErrorText\"\r\n              (click)=\"onSubmit()\"\r\n              *liveEditProp=\"submitButtonKeyText\"\r\n            >\r\n            </vnext-status-button>\r\n          </div>\r\n        </vnext-navigation-banner>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n" }]
    }], function () { return [{ type: i0.ElementRef }, { type: i1.EnrollmentFormService }, { type: i2$1.ActivatedRoute }, { type: i0.ChangeDetectorRef }, { type: SoaFormFacade }, { type: SOAFacade }, { type: AnalyticsService }]; }, { selectedActivity: [{
            type: Input
        }], submitButtonText: [{
            type: Input
        }], submitButtonKeyText: [{
            type: Input
        }], soaFormSubmitErrorText: [{
            type: Input
        }], memberProfileErrorMessagesTitleText: [{
            type: Input
        }], formSubmitted: [{
            type: Output
        }], errorContainer: [{
            type: ViewChildren,
            args: ['errorContainer']
        }], submitButton: [{
            type: ViewChild,
            args: [StatusButtonComponent]
        }], onSubmit: [] }); })();

const _c0$q = ["soaFormHtml"];
function SoaFormRendererComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "form", 1, 2);
    i0.ɵɵpipe(3, "safe");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("id", ctx_r0.formId)("innerHTML", i0.ɵɵpipeBind2(3, 2, ctx_r0.html, "html"), i0.ɵɵsanitizeHtml);
} }
class SoaFormRendererComponent extends FormRendererComponent {
    constructor(elementRef, enrollmentFormService, activatedRoute, cdr) {
        super(elementRef, enrollmentFormService, activatedRoute, cdr);
        this.elementRef = elementRef;
        this.enrollmentFormService = enrollmentFormService;
        this.activatedRoute = activatedRoute;
        this.cdr = cdr;
    }
    set formHtml(html) {
        this.html = html;
        if (this.html) {
            this.cdr.markForCheck();
            setTimeout(() => {
                this.loadPrerequisiteScripts();
                this.initializeView();
                this.viewInitialized$.next(true);
            });
        }
    }
}
SoaFormRendererComponent.ɵfac = function SoaFormRendererComponent_Factory(t) { return new (t || SoaFormRendererComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.EnrollmentFormService), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
SoaFormRendererComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SoaFormRendererComponent, selectors: [["vnext-soa-form-renderer"]], viewQuery: function SoaFormRendererComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$q, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.soaFormHtml = _t.first);
    } }, inputs: { formHtml: "formHtml" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["navigationAdapter", "", 3, "id", "innerHTML"], ["soaFormHtml", ""]], template: function SoaFormRendererComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SoaFormRendererComponent_ng_container_0_Template, 4, 5, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.html);
    } }, dependencies: [i1$2.NgIf, i4.ɵNgNoValidate, i4.NgControlStatusGroup, i4.NgForm, NavigationAdapterDirective, SafePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SoaFormRendererComponent, [{
        type: Component,
        args: [{ selector: 'vnext-soa-form-renderer', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container *ngIf=\"html\">\r\n  <form #soaFormHtml [id]=\"formId\" [innerHTML]=\"html | safe: 'html'\" navigationAdapter></form>\r\n</ng-container>\r\n" }]
    }], function () { return [{ type: i0.ElementRef }, { type: i1.EnrollmentFormService }, { type: i2$1.ActivatedRoute }, { type: i0.ChangeDetectorRef }]; }, { soaFormHtml: [{
            type: ViewChild,
            args: ['soaFormHtml']
        }], formHtml: [{
            type: Input
        }] }); })();

const _c0$p = ["errorContainer"];
function SOAConsumerFormComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-notice", 10);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r1.memberProfileErrorMessagesTitleText)("messages", ctx_r1.errorBannerList)("type", "error");
} }
function SOAConsumerFormComponent_vnext_soa_form_renderer_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-soa-form-renderer", 11, 12);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formHtml", ctx_r2.formHtml);
} }
class SOAConsumerFormComponent {
    constructor(cdr, soaFormFacade, soaFacade, spinnerService, analyticsService) {
        this.cdr = cdr;
        this.soaFormFacade = soaFormFacade;
        this.soaFacade = soaFacade;
        this.spinnerService = spinnerService;
        this.analyticsService = analyticsService;
        this.selectedSOATransactionType = SOATransactionEventType.IN_PERSON;
        this.formSubmitted = new EventEmitter();
        this.setSelectedActivityById = new EventEmitter();
        this.errorBannerList = [];
        this.checkFocus = false;
        this.VALIDATE_FORM_METHOD = 'ValidateForm';
    }
    ngOnChanges(changes) {
        const { showNewConsumerForm, selectedActivity, selectedSOATransactionType } = changes;
        if ((showNewConsumerForm && showNewConsumerForm.previousValue !== showNewConsumerForm.currentValue) ||
            (selectedSOATransactionType && selectedSOATransactionType.previousValue !== selectedSOATransactionType.currentValue)) {
            if (this.showNewConsumerForm) {
                this.newConsumerForm(this.selectedSOATransactionType);
            }
        }
        if (!this.showNewConsumerForm && selectedActivity && selectedActivity.previousValue !== selectedActivity.currentValue) {
            this.getSOAForm(this.selectedActivity);
        }
    }
    ngAfterViewChecked() {
        if (this.checkFocus) {
            const firstInvalidSOAAgentFormInput = document.querySelector('input.input-validation-error');
            const firstInvalidSOAAgentElement = firstInvalidSOAAgentFormInput;
            if (firstInvalidSOAAgentElement) {
                firstInvalidSOAAgentElement.focus();
            }
            this.checkFocus = false;
        }
    }
    newConsumerForm(selectedSOATransactionType = SOATransactionEventType.IN_PERSON) {
        this.spinnerService.show();
        this.formHtml = '';
        this.errorBannerList = [];
        this.soaFacade
            .startSOATransaction$([selectedSOATransactionType])
            .pipe(switchMap(soaTransactionResponse => {
            this.soaTransactionSID = soaTransactionResponse?.soaTransactionId;
            return this.soaFormFacade.getFormInfo$(this.soaTransactionSID);
        }), switchMap(formInfo => {
            this.pageInfo = formInfo;
            return this.soaFormFacade.getFormPage$(this.soaTransactionSID, this.pageInfo.pages[0].pageName);
        }), take(1), finalize(() => {
            this.spinnerService.hide();
        }))
            .subscribe({
            next: formHTML => {
                this.formHtml = formHTML;
                this.cdr.markForCheck();
                this.setSelectedActivityById.emit(this.soaTransactionSID);
            }
        });
    }
    getSOAForm(selectedActivity) {
        this.spinnerService.show();
        this.soaTransactionSID = selectedActivity.transactionSId;
        this.formHtml = '';
        this.errorBannerList = [];
        this.soaFormFacade
            .getFormInfo$(this.soaTransactionSID)
            .pipe(switchMap(formInfo => {
            this.pageInfo = formInfo;
            return this.soaFormFacade.getFormPage$(this.soaTransactionSID, this.pageInfo.pages[0].pageName);
        }), take(1), finalize(() => {
            this.spinnerService.hide();
        }))
            .subscribe({
            next: formHTML => {
                this.formHtml = formHTML;
                this.cdr.markForCheck();
            }
        });
    }
    getFOAMErrors() {
        const validateFormMethod = window && window[this.VALIDATE_FORM_METHOD];
        // passing true in order to get error messages back rather than a pure boolean pass/fail result
        return !validateFormMethod || validateFormMethod(true);
    }
    onSubmit() {
        this.errorBannerList = this.getFOAMErrors();
        this.trackGTMContinueEvent(this.selectedSOATransactionType);
        if (this.errorBannerList.length > 0) {
            this.checkFocus = true;
            this.scrollToErrors();
        }
        else {
            const answers = this.retrieveFormAnswers();
            this.soaFormFacade
                .submitForm$(this.soaTransactionSID, { answers, pageIndex: 0 })
                .pipe(take(1))
                .subscribe({
                next: (response) => {
                    // catch any issues that client validation couldn't.
                    if (response?.validations?.length) {
                        this.errorBannerList = response.validations;
                        this.scrollToErrors();
                        this.cdr.markForCheck();
                        return;
                    }
                    this.formSubmitted.emit(this.soaTransactionSID);
                }
            });
        }
    }
    retrieveFormAnswers() {
        const inputAnswers = this.form?.retrieveFormInputValues();
        let formAnswers = [];
        if (inputAnswers) {
            formAnswers = Object.keys(inputAnswers).map(key => new Answer(key, inputAnswers[key]));
        }
        return formAnswers;
    }
    scrollToErrors() {
        this.errorContainer?.first?.nativeElement?.scrollIntoView({ behavior: 'smooth' });
    }
    trackGTMContinueEvent(selectedSOATransactionType = SOATransactionEventType.IN_PERSON) {
        if (selectedSOATransactionType === SOATransactionEventType.IN_PERSON) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_SOA_INPERSON_CONTINUE);
        }
    }
}
SOAConsumerFormComponent.ɵfac = function SOAConsumerFormComponent_Factory(t) { return new (t || SOAConsumerFormComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(SoaFormFacade), i0.ɵɵdirectiveInject(SOAFacade), i0.ɵɵdirectiveInject(i3$1.NgxSpinnerService), i0.ɵɵdirectiveInject(AnalyticsService)); };
SOAConsumerFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SOAConsumerFormComponent, selectors: [["vnext-soa-consumer-form"]], viewQuery: function SOAConsumerFormComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(SoaFormRendererComponent, 5);
        i0.ɵɵviewQuery(_c0$p, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.form = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.errorContainer = _t);
    } }, inputs: { submitButtonText: "submitButtonText", soaFormSubmitErrorText: "soaFormSubmitErrorText", memberProfileErrorMessagesTitleText: "memberProfileErrorMessagesTitleText", showNewConsumerForm: "showNewConsumerForm", selectedActivity: "selectedActivity", selectedSOATransactionType: "selectedSOATransactionType" }, outputs: { formSubmitted: "formSubmitted", setSelectedActivityById: "setSelectedActivityById" }, features: [i0.ɵɵNgOnChangesFeature], decls: 13, vars: 6, consts: [[1, "container"], [1, "row", "mt-5"], ["errorContainer", ""], [4, "ngIf"], [1, "row"], [1, "col-12"], [3, "formHtml", 4, "ngIf"], [3, "providedPrevious"], ["continue-button", ""], [3, "buttonText", "buttonClass", "tooltipMessageError", "click"], [1, "col-12", 3, "title", "messages", "type"], [3, "formHtml"], ["soaForm", ""]], template: function SOAConsumerFormComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementContainerStart(0);
        i0.ɵɵelementStart(1, "div", 0)(2, "div", 1, 2);
        i0.ɵɵtemplate(4, SOAConsumerFormComponent_ng_container_4_Template, 2, 3, "ng-container", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4)(6, "div", 5);
        i0.ɵɵtemplate(7, SOAConsumerFormComponent_vnext_soa_form_renderer_7_Template, 2, 1, "vnext-soa-form-renderer", 6);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "div", 4)(9, "div", 5)(10, "vnext-navigation-banner", 7)(11, "div", 8)(12, "vnext-status-button", 9);
        i0.ɵɵlistener("click", function SOAConsumerFormComponent_Template_vnext_status_button_click_12_listener() { return ctx.onSubmit(); });
        i0.ɵɵelementEnd()()()()()();
        i0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.errorBannerList.length);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.formHtml);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("providedPrevious", false);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("buttonText", ctx.submitButtonText)("buttonClass", "Spa_Style_PrimaryButton h-100")("tooltipMessageError", ctx.soaFormSubmitErrorText);
    } }, dependencies: [i1$2.NgIf, NavigationBannerComponent, StatusButtonComponent, NoticeComponent, SoaFormRendererComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SOAConsumerFormComponent, [{
        type: Component,
        args: [{ selector: 'vnext-soa-consumer-form', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-container>\r\n  <div class=\"container\">\r\n    <div #errorContainer class=\"row mt-5\">\r\n      <ng-container *ngIf=\"errorBannerList.length\">\r\n        <vnext-notice\r\n          [title]=\"memberProfileErrorMessagesTitleText\"\r\n          [messages]=\"errorBannerList\"\r\n          [type]=\"'error'\"\r\n          class=\"col-12\"\r\n        ></vnext-notice>\r\n      </ng-container>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-12\">\r\n        <vnext-soa-form-renderer #soaForm *ngIf=\"formHtml\" [formHtml]=\"formHtml\"></vnext-soa-form-renderer>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-12\">\r\n        <vnext-navigation-banner [providedPrevious]=\"false\">\r\n          <div continue-button>\r\n            <vnext-status-button\r\n              [buttonText]=\"submitButtonText\"\r\n              [buttonClass]=\"'Spa_Style_PrimaryButton h-100'\"\r\n              [tooltipMessageError]=\"soaFormSubmitErrorText\"\r\n              (click)=\"onSubmit()\"\r\n            >\r\n            </vnext-status-button>\r\n          </div>\r\n        </vnext-navigation-banner>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: SoaFormFacade }, { type: SOAFacade }, { type: i3$1.NgxSpinnerService }, { type: AnalyticsService }]; }, { submitButtonText: [{
            type: Input
        }], soaFormSubmitErrorText: [{
            type: Input
        }], memberProfileErrorMessagesTitleText: [{
            type: Input
        }], showNewConsumerForm: [{
            type: Input
        }], selectedActivity: [{
            type: Input
        }], selectedSOATransactionType: [{
            type: Input
        }], formSubmitted: [{
            type: Output
        }], setSelectedActivityById: [{
            type: Output
        }], form: [{
            type: ViewChild,
            args: [SoaFormRendererComponent]
        }], errorContainer: [{
            type: ViewChildren,
            args: ['errorContainer']
        }] }); })();

const _c0$o = ["soaForm"];
const _c1$2 = ["errorContainer"];
function SOAFormComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8)(2, "div", 9)(3, "div", 10);
    i0.ɵɵelement(4, "vnext-personalized-video", 11);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("videoURL", ctx_r0.soaVideoURL)("iframeTitle", ctx_r0.Spa_PersonalizedVideo_SOAForm_FrameTitle);
} }
function SOAFormComponent_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 12)(2, "div", 13)(3, "nextgen-soa-form", 14);
    i0.ɵɵlistener("consumerFormSubmitted", function SOAFormComponent_ng_container_3_ng_container_1_Template_nextgen_soa_form_consumerFormSubmitted_3_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r8.onSubmit()); })("agentFormSubmitted", function SOAFormComponent_ng_container_3_ng_container_1_Template_nextgen_soa_form_agentFormSubmitted_3_listener() { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.onSubmit()); });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("continueButtonText", ctx_r7.Spa_SOA_Form_SubmitButton_Text)("continueButtonKeyText", "Spa_SOA_Form_SubmitButton_Text")("soaFormSubmitErrorText", ctx_r7.Spa_SOA_Form_SubmitError_Text)("memberProfileErrorMessagesTitleText", ctx_r7.Spa_Member_Profile_ErrorMessages_TitleText)("showConsumerForm", true)("showNewConsumerForm", false)("selectedActivity", ctx_r7.selectedActivity)("unableToProcessErrorsTitleText", ctx_r7.Spa_Site_UnableToProcessErrorsTitle_Text)("unableToProcessErrorsMessageText", ctx_r7.Spa_Site_UnableToProcessErrorsMessage_Text);
} }
function SOAFormComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SOAFormComponent_ng_container_3_ng_container_1_Template, 4, 9, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.soaFormDisplay)("ngIfElse", _r4);
} }
function SOAFormComponent_ng_template_4_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "vnext-notice", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r13.Spa_Member_Profile_ErrorMessages_TitleText)("messages", ctx_r13.errorBannerList)("type", "error");
} }
function SOAFormComponent_ng_template_4_ng_container_0_vnext_soa_form_renderer_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "vnext-soa-form-renderer", 20, 21);
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formHtml", ctx_r14.formHtml)("saveDefaultValues", true)("tagsToUpdate", ctx_r14.tagsToUpdate);
} }
function SOAFormComponent_ng_template_4_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 15, 16);
    i0.ɵɵtemplate(3, SOAFormComponent_ng_template_4_ng_container_0_ng_container_3_Template, 2, 3, "ng-container", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 12)(5, "div", 13);
    i0.ɵɵtemplate(6, SOAFormComponent_ng_template_4_ng_container_0_vnext_soa_form_renderer_6_Template, 2, 3, "vnext-soa-form-renderer", 18);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r11.errorBannerList.length);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r11.formHtml);
} }
function SOAFormComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SOAFormComponent_ng_template_4_ng_container_0_Template, 7, 2, "ng-container", 3);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const _r4 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngIf", ctx_r3.soaFormDisplay)("ngIfElse", _r4);
} }
function SOAFormComponent_ng_template_6_h2_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 34);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r16.Spa_SOA_Form_Header_Text);
} }
function SOAFormComponent_ng_template_6_h4_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h4", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r17.Spa_SOA_Form_Success_SubHeader1_Text);
} }
function SOAFormComponent_ng_template_6_li_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const product_r22 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(product_r22);
} }
function SOAFormComponent_ng_template_6_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 36);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r19.Spa_SOA_Form_WhatToBring_Html, "html"), i0.ɵɵsanitizeHtml);
} }
function SOAFormComponent_ng_template_6_img_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 37);
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r20.medicareCardSOAFormImageSource, i0.ɵɵsanitizeUrl)("alt", ctx_r20.Spa_Site_MedicareCard_SOA_Image_AlternateText);
} }
function SOAFormComponent_ng_template_6_ng_container_12_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r23.Spa_Medicare_Card_SOA_Form_Image_Text, " ");
} }
function SOAFormComponent_ng_template_6_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SOAFormComponent_ng_template_6_ng_container_12_div_1_Template, 2, 1, "div", 38);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Medicare_Card_SOA_Form_Image_Text");
} }
function SOAFormComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SOAFormComponent_ng_template_6_h2_0_Template, 2, 1, "h2", 22);
    i0.ɵɵelementStart(1, "div", 23);
    i0.ɵɵelement(2, "vnext-notice", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 25);
    i0.ɵɵtemplate(4, SOAFormComponent_ng_template_6_h4_4_Template, 2, 1, "h4", 26);
    i0.ɵɵelementStart(5, "ul", 27);
    i0.ɵɵtemplate(6, SOAFormComponent_ng_template_6_li_6_Template, 2, 1, "li", 28);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 29)(8, "div", 30);
    i0.ɵɵtemplate(9, SOAFormComponent_ng_template_6_div_9_Template, 2, 4, "div", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 32);
    i0.ɵɵtemplate(11, SOAFormComponent_ng_template_6_img_11_Template, 1, 2, "img", 33);
    i0.ɵɵtemplate(12, SOAFormComponent_ng_template_6_ng_container_12_Template, 2, 1, "ng-container", 17);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("liveEditProp", "Spa_SOA_Form_Header_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", "success")("messages", ctx_r5.successMessage);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_SOA_Form_Success_SubHeader1_Text");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r5.selectedSoaPlanTypes);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", "Spa_SOA_Form_WhatToBring_Html");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.Spa_Medicare_Card_SOA_Form_Image);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.Spa_Medicare_Card_SOA_Form_Image);
} }
function SOAFormComponent_vnext_navigation_banner_8_vnext_status_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-status-button", 42);
    i0.ɵɵlistener("click", function SOAFormComponent_vnext_navigation_banner_8_vnext_status_button_2_Template_vnext_status_button_click_0_listener() { i0.ɵɵrestoreView(_r26); const ctx_r25 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r25.onSubmit()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("buttonText", ctx_r24.Spa_SOA_Form_SubmitButton_Text)("buttonClass", "Spa_Style_PrimaryButton h-100")("tooltipMessageError", ctx_r24.Spa_SOA_Form_SubmitError_Text);
} }
function SOAFormComponent_vnext_navigation_banner_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "vnext-navigation-banner", 13)(1, "div", 40);
    i0.ɵɵtemplate(2, SOAFormComponent_vnext_navigation_banner_8_vnext_status_button_2_Template, 1, 3, "vnext-status-button", 41);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_SOA_Form_SubmitButton_Text");
} }
let SOAFormComponent = class SOAFormComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, soaFormFacade, soaFacade, spinnerService, analyticsService, imageService, localeService, nextGenSOAFormNavigationContext) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.soaFormFacade = soaFormFacade;
        this.soaFacade = soaFacade;
        this.spinnerService = spinnerService;
        this.analyticsService = analyticsService;
        this.imageService = imageService;
        this.localeService = localeService;
        this.nextGenSOAFormNavigationContext = nextGenSOAFormNavigationContext;
        this.Spa_SOA_Form_Header_Text = 'Scope of Appointment';
        this.Spa_SOA_Form_Success_SubHeader1_Text = `We'll discuss: `;
        this.Spa_SOA_Form_SubmitButton_Text = 'Submit form';
        this.Spa_SOA_Form_Success_Message_Text = 'Thank you, your scope of appointment has been submitted. Close your browser.';
        this.Spa_SOA_Form_Success_SubMessage_Text = 'Your broker will get in touch with you soon.';
        this.Spa_SOA_Form_WhatToBring_Html = `
  <h4 class="Spa_Style_H4 mt-3">Make sure you have the following for our meeting:</h4>

  <ul class="Spa_Style_IntroParagraph Spa_Style_Small_Font col-12 col-md-8 ml-0">
    <li>Medicare card</li>
    <li>All medications</li>
    <li>List of all your current physicians along with their phone numbers and addresses</li>
  </ul>
`;
        this.Spa_SOA_Form_SubmitError_Text = 'Try again';
        this.Spa_SOA_AgentEmail_Subject = 'Customer completed SOA';
        this.Spa_SOA_AgentEmail_Header = '{|memberFullName|} completed the SOA';
        this.Spa_SOA_AgentEmail_Subheader = 'Products to discuss:';
        this.Spa_SOA_AgentEmail_Link_Text = 'Login to view SOA';
        this.Spa_SOA_AgentEmail_CheckCircle_Image = 'https://content.destinationrx.com/ContentServer/DRxProductContent/pc4_clientimages/257_857a1d31e38a479ea950cee8b8211df0/check_circle_256_green_03232020110009275.png';
        this.Spa_SOA_Email_DoNotReplyText = 'Do not reply to this email';
        this.Spa_Medicare_Card_SOA_Form_Image_Text = 'Sample Medicare card you will need for the meeting with your broker.';
        this.Spa_Medicare_Card_SOA_Form_Image = 'phoenix/assets/images/medicare_health_insurance_sample.png';
        this.Spa_Site_AgentLogin_Url = 'http://localhost:4200';
        this.Spa_Member_Profile_ErrorMessages_TitleText = 'Correct the following error(s) on the form, then submit again';
        this.Spa_HeaderFooter_Broker = 'Licensed Agent';
        this.Spa_HeaderFooter_PrimaryClientLogo = '';
        this.Spa_HeaderFooter_PrimaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_HeaderFooter_SecondaryClientLogo = '';
        this.Spa_HeaderFooter_SecondaryClientLogo_Url = [{ target: '_self', href: '', tag: 'Home' }];
        this.Spa_Site_Broker_Info_Enabled = true;
        this.Spa_Site_MedicareCard_SOA_Image_AlternateText = 'Medicare card SOA form image';
        this.Spa_PersonalizedVideo_Enabled = false;
        this.Spa_PersonalizedVideo_SOAForm_Enabled = false;
        this.Spa_Site_Is_BLAM = false;
        this.Spa_Site_SOA_NextGen_Enabled = false;
        this.Spa_PersonalizedVideo_SOAForm_FrameTitle = 'Review plans offered, what the Scope of Appointment form is, and how to contact your agent.';
        this.Spa_Site_UnableToProcessErrorsTitle_Text = 'Unable to Process Application';
        this.Spa_Site_UnableToProcessErrorsMessage_Text = 'We are unable to process your application at this time. Contact your administrator for assistance.';
        this.submitted = false;
        this.errorBannerList = [];
        this.answers = [];
        this.selectedSoaPlanTypes = [];
        this.isLiveEdit = false;
        this.checkFocus = false;
        this.previouslySubmittedSOA = false;
        this.soaFormDisplay = true;
        this.soaPersonalizedVideoDisplay = true;
        this.subscriptions = new Subscription();
        this.tagsToUpdate = {};
        this.hasAgentInformation = false;
        this.VALIDATE_FORM_METHOD = 'ValidateForm';
    }
    get successMessage() {
        return [
            {
                message: `<h5 class="notice__title my-0">${this.Spa_SOA_Form_Success_Message_Text}</h5>`,
                liveEditProp: `Spa_SOA_Form_Success_Message_Text`
            },
            {
                message: `${this.Spa_SOA_Form_Success_SubMessage_Text}`,
                liveEditProp: `Spa_SOA_Form_Success_SubMessage_Text`
            }
        ];
    }
    onInputBlur(event) {
        const validationErrors = Array.from(_get(event, 'detail.ValidationErrors') || []).map(formError => ({
            message: formError.message,
            severity: formError.severity,
            source: MESSAGE_SOURCE.CLIENT
        }));
        if (!_isEqual(this.errorBannerList, validationErrors)) {
            this.errorBannerList = validationErrors;
            this.setFormDisplay();
            this.cdr.markForCheck();
        }
    }
    ngOnInit() {
        super.ngOnInit();
        const environment = EnvironmentService.getEnvironment();
        this.isLiveEdit = environment.liveedit;
        this.getAgentInContextGuid$ = this.soaFormFacade.getAgentInContextGuid$();
        this.setFormDisplay();
        this.tagsToUpdate = this.getTagsToUpdate();
        if (this.Spa_Site_SOA_NextGen_Enabled) {
            this.initializeNextGenSubscriptions(environment.liveedit);
        }
        else {
            this.initializeSubscriptions(environment.liveedit);
        }
    }
    ngAfterViewInit() {
        // nested widgets lose their ability to look up values from the config
        // by providing the parent widget id and name, look ups are possible
        if (this.header) {
            this.header.widgetName = this.widgetName;
            this.header.widgetId = this.widgetId;
            this.header.ngOnInit();
        }
    }
    ngAfterViewChecked() {
        if (this.checkFocus) {
            const formElement = document.getElementById(this.focusFieldID);
            if (formElement) {
                formElement.focus();
            }
            this.checkFocus = false;
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        super.ngOnDestroy();
    }
    preProcessProperties() {
        if (this.Spa_Medicare_Card_SOA_Form_Image) {
            this.medicareCardSOAFormImageSource = this.imageService.resolveFullImagePath(this.Spa_Medicare_Card_SOA_Form_Image);
        }
    }
    getFOAMErrors() {
        const validateFormMethod = window && window[this.VALIDATE_FORM_METHOD];
        // passing true in order to get error messages back rather than a pure boolean pass/fail result
        return !validateFormMethod || validateFormMethod(true);
    }
    async onSubmit() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_SOA_SUBMIT_FORM);
        if (this.Spa_Site_SOA_NextGen_Enabled) {
            await this.onNextGenSubmit();
        }
        else {
            await this.onHopeSubmit();
        }
    }
    async onHopeSubmit() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_SOA_SUBMIT_FORM);
        this.errorBannerList = this.getFOAMErrors();
        this.setFormDisplay();
        if (this.errorBannerList.length > 0) {
            this.scrollToErrors();
            this.focusFieldID = this.getFOAMErrors()[0].focusFieldID;
            this.checkFocus = true;
            return;
        }
        const currentFormAnswers = this.retrieveFormAnswers();
        this.answers = this.soaFormFacade.updateSOABeneficiaryConfirmationCodeAnswer(currentFormAnswers);
        this.selectedSoaPlanTypes = this.getSoaPlanTypeFromForm();
        this.soaUserType = this.soaFormFacade.getSOAUserType();
        this.saveButton.toggleSpinner(true);
        this.inferredFormPage = this.soaFormFacade.getInferredFormPage(this.answers);
        this.soaFormFacade
            .submitForm$(this.soaTransactionSID, { answers: this.answers, pageIndex: this.getSOAPageIndex() }, true)
            .pipe(switchMap(response => combineLatest(this.soaFormFacade.updateSOATransactionAnswers$(this.soaTransactionSID, this.answers), of(response))), switchMap(([dispatch, response]) => {
            if (this.soaFormFacade.allFormPagesComplete(this.soaTransactionSID)) {
                return this.soaFormFacade.finishForm$(this.soaTransactionSID, { answers: this.answers });
            }
            return of(response);
        }), 
        // switchMap(() => this.soaFacade.fetchSOATransactions$()),// TODO: do we need to get the updated transactions in this flow?
        take(1))
            .subscribe({
            next: async (response) => {
                // catch any issues that client validation couldn't.
                if (response.validations.length) {
                    this.errorBannerList = response.validations;
                    this.setFormDisplay();
                    this.scrollToErrors();
                    this.saveButton.showErrorMessage();
                    this.saveButton.closeTooltip(TOOLTIP_TIMEOUT);
                    this.cdr.markForCheck();
                    return;
                }
                const pageName = response.pageName;
                // we only update the member session and/or send the email on SOAUserType.BOTH or SOAUserType.CONSUMER
                if (!this.Spa_Site_Is_BLAM || this.soaUserType !== SOAUserType.BROKER) {
                    await this.updateMemberSession();
                }
                let hasNextPage = false;
                // if soaUserType is both then we need to navigate to the next page if one exists
                if (this.soaUserType === SOAUserType.BOTH && response.status !== 'COMPLETED') {
                    if (pageName !== this.soaFormFacade.getSOAPageName()) {
                        this.soaFormFacade.setActivePage(pageName);
                        hasNextPage = true;
                    }
                }
                if (!hasNextPage) {
                    this.saveButton.showSuccessMessage();
                    this.saveButton.closeTooltip(3000);
                }
                this.submitted = !hasNextPage;
                this.setFormDisplay();
            },
            error: () => {
                this.saveButton.showErrorMessage();
                this.saveButton.closeTooltip(TOOLTIP_TIMEOUT);
                this.cdr.markForCheck();
            },
            complete: () => {
                this.saveButton.toggleSpinner(false);
            }
        });
    }
    async onNextGenSubmit() {
        const allFormAnswers = this.retrieveAllNextGenFormAnswers();
        this.answers = this.soaFormFacade.updateSOABeneficiaryConfirmationCodeAnswer(allFormAnswers);
        this.selectedSoaPlanTypes = this.getSoaPlanTypeFromForm();
        this.soaUserType = this.soaFormFacade.getSOAUserType();
        this.inferredFormPage = this.soaFormFacade.getInferredFormPage(this.answers);
        // we only update the member session and/or send the email on SOAUserType.BOTH or SOAUserType.CONSUMER
        if (!this.Spa_Site_Is_BLAM || this.soaUserType !== SOAUserType.BROKER) {
            await this.updateMemberSession();
        }
        // if soaUserType is both then we need to navigate to the next page if one exists
        this.nextGenSOAFormNavigationContext
            .getPageName$()
            .pipe(take(1))
            .subscribe({
            next: pageName => {
                const hasNextPage = this.soaUserType === SOAUserType.BOTH && pageName === NextGenSOAPageName.AgentPage;
                this.submitted = !hasNextPage;
                this.setFormDisplay();
            }
        });
    }
    retrieveFormAnswers() {
        const inputAnswers = this.form?.retrieveFormInputValues();
        let formAnswers = [];
        if (inputAnswers) {
            formAnswers = Object.keys(inputAnswers).map(key => new Answer(key, inputAnswers[key]));
        }
        return formAnswers;
    }
    retrieveAllNextGenFormAnswers() {
        return this.nextGenSOAForm?.retrieveAllFormAnswers() ?? [];
    }
    getSOAPageIndex() {
        const soaPageName = this.soaFormFacade.getSOAPageName();
        const soaPageIndex = this.pageInfo?.pages?.findIndex(page => page.pageName === soaPageName);
        return soaPageIndex !== -1 ? soaPageIndex : 0;
    }
    getProfileValues(member) {
        let updatedProfileValues = {};
        // Get the overrides from FOAM.
        const firstName = this.getFormAnswerByName(['BeneficiaryFirstName', 'ApplicantFirstName']);
        const lastName = this.getFormAnswerByName(['BeneficiaryLastName', 'ApplicantLastName']);
        const homePhone = this.getFormAnswerByName(['BeneficiaryPhone', 'BeneficiaryPhoneNumber', 'ApplicantPhone']);
        const beneficiaryAddress1 = this.getFormAnswerByName(['BeneficiaryAddress1', 'ApplicantAddress1']);
        const beneficiaryAddress2 = this.getFormAnswerByName(['BeneficiaryAddress2', 'ApplicantAddress2']);
        const beneficiaryCity = this.getFormAnswerByName(['BeneficiaryCity', 'ApplicantCity']);
        const beneficiaryState = this.getFormAnswerByName(['BeneficiaryState', 'ApplicantState']);
        const beneficiaryZip = this.getFormAnswerByName(['BeneficiaryZip', 'ApplicantZip']);
        if (firstName?.value) {
            member.firstName = firstName.value;
        }
        if (lastName?.value) {
            member.lastName = lastName.value;
        }
        if (homePhone?.value) {
            member.homePhone = homePhone.value;
        }
        const addresses = [...member.addresses];
        let currentAddress;
        if (addresses[0]) {
            currentAddress = addresses[0];
        }
        else {
            currentAddress = {};
        }
        if (beneficiaryAddress1?.value) {
            currentAddress = { ...currentAddress, address1: beneficiaryAddress1.value };
        }
        if (beneficiaryAddress2?.value) {
            currentAddress = { ...currentAddress, address2: beneficiaryAddress2.value };
        }
        if (beneficiaryCity?.value) {
            currentAddress = { ...currentAddress, city: beneficiaryCity.value };
        }
        if (beneficiaryState?.value) {
            currentAddress = { ...currentAddress, state: beneficiaryState.value };
        }
        if (beneficiaryZip?.value) {
            currentAddress = { ...currentAddress, zip: beneficiaryZip.value };
        }
        updatedProfileValues = {
            firstName: member.firstName,
            lastName: member.lastName,
            homePhone: member.homePhone,
            addresses: [currentAddress]
        };
        return updatedProfileValues;
    }
    displaySOAForm() {
        return (!this.submitted || this.errorBannerList.length) && !this.isLiveEdit && !this.previouslySubmittedSOA;
    }
    getTagsToUpdate() {
        const personalizedVideoIsPresent = this.displaySOAVideo() ? GOOGLE_ANALYTICS_YES : GOOGLE_ANALYTICS_NO;
        return {
            [DataLayerGlobalVariable.PERSONALIZED_VIDEO_IS_PRESENT]: personalizedVideoIsPresent
        };
    }
    initializeSubscriptions(liveEdit = false) {
        if (!liveEdit) {
            this.spinnerService.show(SpinnerEvent.SOA_LOADING);
            this.formHtml$ = combineLatest([this.soaFormFacade.getFormTransaction$(), this.localeService.getCurrentLocale$()]).pipe(switchMap(() => {
                this.soaTransactionSID = this.soaFormFacade.getSOATransactionSID();
                return this.soaFormFacade.getFormInfo$(this.soaTransactionSID);
            }), switchMap(formInfo => {
                this.pageInfo = formInfo;
                return combineLatest(this.soaFormFacade.getSOAPageName$(), this.soaFacade.fetchSOAActivities$()).pipe(distinctUntilChanged(_isEqual));
            }), switchMap(([activePageName, soaActivities]) => {
                this.previouslySubmittedSOA = this.isPreviousSubmittedSOA(soaActivities, this.soaTransactionSID);
                if (this.previouslySubmittedSOA) {
                    return of(null);
                }
                return this.soaFormFacade.getFormPage$(this.soaTransactionSID, activePageName ?? this.pageInfo.pages[0].pageName);
            }), tap(() => {
                this.spinnerService.hide(SpinnerEvent.SOA_LOADING);
            }), catchError(() => {
                this.spinnerService.hide(SpinnerEvent.SOA_LOADING);
                return of(null);
            }));
            this.subscriptions.add(this.getAgentInContextGuid$.subscribe({
                next: agentInContextGuid => {
                    this.hasAgentInformation = !!agentInContextGuid;
                    this.cdr.markForCheck();
                }
            }));
            this.subscriptions.add(this.formHtml$.subscribe({
                next: formHTML => {
                    this.formHtml = formHTML;
                    if (this.Spa_PersonalizedVideo_Enabled && this.Spa_PersonalizedVideo_SOAForm_Enabled) {
                        this.soaVideoURL = this.soaFormFacade.getSOAPersonalizedVideoURL(this.soaTransactionSID);
                    }
                    this.setFormDisplay();
                    this.tagsToUpdate = this.getTagsToUpdate();
                    this.cdr.markForCheck();
                }
            }));
        }
    }
    initializeNextGenSubscriptions(liveEdit = false) {
        if (!liveEdit) {
            this.spinnerService.show(SpinnerEvent.SOA_LOADING);
            this.subscriptions.add(combineLatest([this.soaFormFacade.getSSOSOA$(), this.localeService.getCurrentLocale$()])
                .pipe(distinctUntilChanged(_isEqual), switchMap(([ssoSOAValues]) => this.soaFacade.fetchSOAActivities$().pipe(map(soaActivities => [ssoSOAValues, soaActivities]))), distinctUntilChanged(_isEqual), finalize(() => {
                this.spinnerService.hide(SpinnerEvent.SOA_LOADING);
            }))
                .subscribe({
                next: ([ssoSOAValues, soaActivities]) => {
                    this.ssoSOAValues = ssoSOAValues;
                    this.selectedActivity = soaActivities?.find(activities => activities.transactionId === ssoSOAValues.transactionSID || activities.transactionSId === ssoSOAValues.transactionSID);
                    this.previouslySubmittedSOA = this.isPreviousSubmittedSOA(soaActivities, ssoSOAValues.transactionSID);
                    this.cdr.markForCheck();
                }
            }));
            this.subscriptions.add(this.getAgentInContextGuid$.subscribe({
                next: agentInContextGuid => {
                    this.hasAgentInformation = !!agentInContextGuid;
                    this.cdr.markForCheck();
                }
            }));
        }
    }
    async updateMemberSession() {
        if (!this.Spa_Site_Is_BLAM || this.inferredFormPage === SOAFormPage.CONSUMER) {
            const member = { ...this.soaFacade.getMember() };
            const profileValues = this.getProfileValues(member);
            this.soaFormFacade.updateMember$({ profile: profileValues }).toPromise();
            this.cdr.markForCheck();
        }
        // only send email if we are on the consumer form so the agent is alerted to the
        // consumer finishing their part of the form. if the form type is both the broker
        // page should immediately follow the consumer page and if this is the broker form
        // then the broker does not need to be alerted
        if (!this.Spa_Site_Is_BLAM || this.soaUserType === SOAUserType.CONSUMER) {
            this.sendAgentEmail();
        }
    }
    getSoaPlanTypeFromForm() {
        return this.soaFacade.getSoaPlanTypeListFromAnswer(this.getFormAnswerByName(['SOAPlanType'])?.value);
    }
    emailInputs(soaPlanTypes, memberFirstName, memberLastName) {
        return [
            {
                key: 'plantypes',
                value: `${soaPlanTypes.map(planType => `<li style="padding:0; margin:0;">${planType}</li>`).join('')}`
            },
            { key: 'memberFullName', value: `${memberFirstName} ${memberLastName}` },
            { key: 'primaryButtonColor', value: this.soaFacade.getPrimaryButtonColor() }
        ];
    }
    async sendAgentEmail() {
        const memberFirstName = this.getFormAnswerByName(['BeneficiaryFirstName', 'ApplicantFirstName'])?.value;
        const memberLastName = this.getFormAnswerByName(['BeneficiaryLastName', 'ApplicantLastName'])?.value;
        const emailInputs = this.emailInputs(this.selectedSoaPlanTypes, memberFirstName, memberLastName);
        const agentEmailLinkUrl = new URL(this.Spa_Site_AgentLogin_Url);
        agentEmailLinkUrl.searchParams.set(UTMParameter.UTM_SOURCE, UTMValue.UTM_SOURCE_PLAN_COMPARE);
        agentEmailLinkUrl.searchParams.set(UTMParameter.UTM_MEDIUM, UTMValue.UTM_MEDIUM_EMAIL);
        agentEmailLinkUrl.searchParams.set(UTMParameter.UTM_CAMPAIGN, UTMValue.UTM_CAMPAIGN_SOA_DONE);
        const agentEmailShortUrl = await this.soaFacade.getShortUrl(agentEmailLinkUrl.href);
        emailInputs.push({ key: 'agentEmailLinkUrl', value: agentEmailShortUrl });
        this.soaFacade.sendAgentEmail$(this.Spa_SOA_AgentEmail_Subject, emailInputs).toPromise();
    }
    scrollToErrors() {
        this.errorContainer.first.nativeElement.scrollIntoView({ behavior: 'smooth' });
    }
    isPreviousSubmittedSOA(soaActivities, soaTransactionSID) {
        return (soaActivities.length > 0 &&
            soaActivities.some(activity => activity.transactionSId === soaTransactionSID &&
                activity.soaBeneficiaryConfirmationCode &&
                activity.soaBeneficiaryConfirmationCode.length > 0 &&
                activity.type !== SOAActivityType.PARTIAL));
    }
    displaySOAVideo() {
        return !!(this.Spa_PersonalizedVideo_Enabled && this.Spa_PersonalizedVideo_SOAForm_Enabled && this.soaFormDisplay && this.soaVideoURL);
    }
    setFormDisplay() {
        this.soaFormDisplay = this.displaySOAForm();
        this.soaPersonalizedVideoDisplay = this.displaySOAVideo();
    }
    getFormAnswerByName(possibleQuestionNames) {
        return this.answers?.find(answer => possibleQuestionNames.includes(answer.name));
    }
};
SOAFormComponent.ɵfac = function SOAFormComponent_Factory(t) { return new (t || SOAFormComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(SoaFormFacade), i0.ɵɵdirectiveInject(SOAFacade), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.ImageService), i0.ɵɵdirectiveInject(i1.LocaleService), i0.ɵɵdirectiveInject(NextGenSOAFormNavigationContext)); };
SOAFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SOAFormComponent, selectors: [["vnext-soa-form"]], viewQuery: function SOAFormComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(StatusButtonComponent, 5);
        i0.ɵɵviewQuery(SoaFormRendererComponent, 5);
        i0.ɵɵviewQuery(DynamicHeaderComponent, 5);
        i0.ɵɵviewQuery(_c0$o, 5);
        i0.ɵɵviewQuery(NextGenSOAFormComponent, 5);
        i0.ɵɵviewQuery(_c1$2, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.saveButton = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.form = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.header = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.soaForm = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nextGenSOAForm = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.errorContainer = _t);
    } }, hostBindings: function SOAFormComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("SpaInputBlurEvent", function SOAFormComponent_SpaInputBlurEvent_HostBindingHandler($event) { return ctx.onInputBlur($event); });
    } }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 9, vars: 11, consts: [[3, "headerType", "isBrokerInfoEnabled", "broker", "primaryLogo", "primaryLogoUrl", "secondaryLogo", "secondaryLogoUrl"], ["class", "Spa_Style_Banner_Background", 4, "ngIf"], [1, "container"], [4, "ngIf", "ngIfElse"], ["hopeSOAForm", ""], ["confirmationSection", ""], ["class", "col-12", 4, "ngIf"], [1, "Spa_Style_Banner_Background"], [1, "container", "p-0"], [1, "soa-banner-video", "d-flex", "justify-content-center"], [1, "personalized-video-wrapper"], [3, "videoURL", "iframeTitle"], [1, "row"], [1, "col-12"], [3, "continueButtonText", "continueButtonKeyText", "soaFormSubmitErrorText", "memberProfileErrorMessagesTitleText", "showConsumerForm", "showNewConsumerForm", "selectedActivity", "unableToProcessErrorsTitleText", "unableToProcessErrorsMessageText", "consumerFormSubmitted", "agentFormSubmitted"], [1, "row", "mt-5"], ["errorContainer", ""], [4, "ngIf"], ["vnextGoogleTagManager", "", 3, "formHtml", "saveDefaultValues", "tagsToUpdate", 4, "ngIf"], [1, "col-12", 3, "title", "messages", "type"], ["vnextGoogleTagManager", "", 3, "formHtml", "saveDefaultValues", "tagsToUpdate"], ["soaForm", ""], ["class", "Spa_Style_H1 my-5 text-center", 4, "liveEditProp"], [1, "mt-3", "mb-5"], [3, "type", "messages"], [1, "row", "d-flex", "flex-column", "ml-0"], ["class", "Spa_Style_H4 mt-4", 4, "liveEditProp"], [1, "Spa_Style_IntroParagraph", "Spa_Style_Small_Font", "col-12", "col-md-8", "ml-0"], [4, "ngFor", "ngForOf"], [1, "row", "mt-3"], [1, "col-12", "col-md-8"], ["navigationAdapter", "", 3, "innerHTML", 4, "liveEditProp"], [1, "col-md-4", "col-12"], ["class", "medicare-card", 3, "src", "alt", 4, "ngIf"], [1, "Spa_Style_H1", "my-5", "text-center"], [1, "Spa_Style_H4", "mt-4"], ["navigationAdapter", "", 3, "innerHTML"], [1, "medicare-card", 3, "src", "alt"], ["class", "Spa_Style_Note mt-2", 4, "liveEditProp"], [1, "Spa_Style_Note", "mt-2"], ["continue-button", ""], [3, "buttonText", "buttonClass", "tooltipMessageError", "click", 4, "liveEditProp"], [3, "buttonText", "buttonClass", "tooltipMessageError", "click"]], template: function SOAFormComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "vnext-dynamic-header", 0);
        i0.ɵɵtemplate(1, SOAFormComponent_div_1_Template, 5, 2, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, SOAFormComponent_ng_container_3_Template, 2, 2, "ng-container", 3);
        i0.ɵɵtemplate(4, SOAFormComponent_ng_template_4_Template, 1, 2, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(6, SOAFormComponent_ng_template_6_Template, 13, 8, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(8, SOAFormComponent_vnext_navigation_banner_8_Template, 3, 1, "vnext-navigation-banner", 6);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(5);
        i0.ɵɵproperty("headerType", "soa")("isBrokerInfoEnabled", ctx.Spa_Site_Broker_Info_Enabled && ctx.hasAgentInformation)("broker", ctx.Spa_HeaderFooter_Broker)("primaryLogo", ctx.Spa_HeaderFooter_PrimaryClientLogo)("primaryLogoUrl", ctx.Spa_HeaderFooter_PrimaryClientLogo_Url)("secondaryLogo", ctx.Spa_HeaderFooter_SecondaryClientLogo)("secondaryLogoUrl", ctx.Spa_HeaderFooter_SecondaryClientLogo_Url);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.soaPersonalizedVideoDisplay);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.Spa_Site_SOA_NextGen_Enabled)("ngIfElse", _r2);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", !ctx.Spa_Site_SOA_NextGen_Enabled && !ctx.submitted && !ctx.previouslySubmittedSOA);
    } }, dependencies: [i1$2.NgForOf, i1$2.NgIf, NavigationBannerComponent, StatusButtonComponent, NoticeComponent, NavigationAdapterDirective, LiveEditPropDirective, GoogleTagManagerDirective, DynamicHeaderComponent, SoaFormRendererComponent, NextGenSOAFormComponent, PersonalizedVideoComponent, SafePipe], styles: [".medicare-card[_ngcontent-%COMP%]{width:100%;max-width:300px}.soa-banner-video[_ngcontent-%COMP%]{height:350px;background-size:cover;padding-top:25px;padding-bottom:25px}.personalized-video-wrapper[_ngcontent-%COMP%]{width:533.33px}@media (max-width: 992px){.quote-banner-video[_ngcontent-%COMP%]{height:200px;background-size:cover}.personalized-video-wrapper[_ngcontent-%COMP%]{width:355.55px}.soa-banner-video[_ngcontent-%COMP%]{height:200px;padding-top:0;padding-bottom:0}}"], changeDetection: 0 });
__decorate([
    GlobalResource()
], SOAFormComponent.prototype, "Spa_SOA_Form_Header_Text", void 0);
__decorate([
    GlobalResource()
], SOAFormComponent.prototype, "Spa_SOA_Form_Success_SubHeader1_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], SOAFormComponent.prototype, "Spa_SOA_Form_SubmitButton_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], SOAFormComponent.prototype, "Spa_SOA_Form_Success_Message_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], SOAFormComponent.prototype, "Spa_SOA_Form_Success_SubMessage_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], SOAFormComponent.prototype, "Spa_SOA_Form_WhatToBring_Html", void 0);
__decorate([
    PlatformProp()
], SOAFormComponent.prototype, "Spa_SOA_Form_SubmitError_Text", void 0);
__decorate([
    PlatformProp()
], SOAFormComponent.prototype, "Spa_SOA_AgentEmail_Subject", void 0);
__decorate([
    PlatformProp()
], SOAFormComponent.prototype, "Spa_SOA_AgentEmail_Header", void 0);
__decorate([
    PlatformProp()
], SOAFormComponent.prototype, "Spa_SOA_AgentEmail_Subheader", void 0);
__decorate([
    PlatformProp()
], SOAFormComponent.prototype, "Spa_SOA_AgentEmail_Link_Text", void 0);
__decorate([
    PlatformProp()
], SOAFormComponent.prototype, "Spa_SOA_AgentEmail_CheckCircle_Image", void 0);
__decorate([
    PlatformProp()
], SOAFormComponent.prototype, "Spa_SOA_Email_DoNotReplyText", void 0);
__decorate([
    GlobalResource()
], SOAFormComponent.prototype, "Spa_Medicare_Card_SOA_Form_Image_Text", void 0);
__decorate([
    PlatformProp()
], SOAFormComponent.prototype, "Spa_Medicare_Card_SOA_Form_Image", void 0);
__decorate([
    PlatformProp()
], SOAFormComponent.prototype, "Spa_Site_AgentLogin_Url", void 0);
__decorate([
    PlatformProp()
], SOAFormComponent.prototype, "Spa_Member_Profile_ErrorMessages_TitleText", void 0);
__decorate([
    PlatformProp()
], SOAFormComponent.prototype, "Spa_HeaderFooter_Broker", void 0);
__decorate([
    PlatformProp()
], SOAFormComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo", void 0);
__decorate([
    PlatformProp()
], SOAFormComponent.prototype, "Spa_HeaderFooter_PrimaryClientLogo_Url", void 0);
__decorate([
    PlatformProp()
], SOAFormComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo", void 0);
__decorate([
    PlatformProp()
], SOAFormComponent.prototype, "Spa_HeaderFooter_SecondaryClientLogo_Url", void 0);
__decorate([
    GlobalResource()
], SOAFormComponent.prototype, "Spa_Site_Broker_Info_Enabled", void 0);
__decorate([
    GlobalResource()
], SOAFormComponent.prototype, "Spa_Site_MedicareCard_SOA_Image_AlternateText", void 0);
__decorate([
    GlobalResource()
], SOAFormComponent.prototype, "Spa_PersonalizedVideo_Enabled", void 0);
__decorate([
    GlobalResource()
], SOAFormComponent.prototype, "Spa_PersonalizedVideo_SOAForm_Enabled", void 0);
__decorate([
    GlobalResource()
], SOAFormComponent.prototype, "Spa_Site_Is_BLAM", void 0);
__decorate([
    GlobalResource()
], SOAFormComponent.prototype, "Spa_Site_SOA_NextGen_Enabled", void 0);
__decorate([
    GlobalResource()
], SOAFormComponent.prototype, "Spa_PersonalizedVideo_SOAForm_FrameTitle", void 0);
__decorate([
    GlobalResource()
], SOAFormComponent.prototype, "Spa_Site_UnableToProcessErrorsTitle_Text", void 0);
__decorate([
    GlobalResource()
], SOAFormComponent.prototype, "Spa_Site_UnableToProcessErrorsMessage_Text", void 0);
SOAFormComponent = __decorate([
    PlatformWidget
], SOAFormComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SOAFormComponent, [{
        type: Component,
        args: [{ selector: 'vnext-soa-form', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<vnext-dynamic-header\r\n  [headerType]=\"'soa'\"\r\n  [isBrokerInfoEnabled]=\"Spa_Site_Broker_Info_Enabled && hasAgentInformation\"\r\n  [broker]=\"Spa_HeaderFooter_Broker\"\r\n  [primaryLogo]=\"Spa_HeaderFooter_PrimaryClientLogo\"\r\n  [primaryLogoUrl]=\"Spa_HeaderFooter_PrimaryClientLogo_Url\"\r\n  [secondaryLogo]=\"Spa_HeaderFooter_SecondaryClientLogo\"\r\n  [secondaryLogoUrl]=\"Spa_HeaderFooter_SecondaryClientLogo_Url\"\r\n>\r\n</vnext-dynamic-header>\r\n<div class=\"Spa_Style_Banner_Background\" *ngIf=\"soaPersonalizedVideoDisplay\">\r\n  <div class=\"container p-0\">\r\n    <div class=\"soa-banner-video d-flex justify-content-center\">\r\n      <div class=\"personalized-video-wrapper\">\r\n        <vnext-personalized-video\r\n          [videoURL]=\"soaVideoURL\"\r\n          [iframeTitle]=\"Spa_PersonalizedVideo_SOAForm_FrameTitle\"\r\n        ></vnext-personalized-video>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"container\">\r\n  <ng-container *ngIf=\"Spa_Site_SOA_NextGen_Enabled; else hopeSOAForm\">\r\n    <ng-container *ngIf=\"soaFormDisplay; else confirmationSection\">\r\n      <div class=\"row\">\r\n        <div class=\"col-12\">\r\n          <nextgen-soa-form\r\n            [continueButtonText]=\"Spa_SOA_Form_SubmitButton_Text\"\r\n            [continueButtonKeyText]=\"'Spa_SOA_Form_SubmitButton_Text'\"\r\n            [soaFormSubmitErrorText]=\"Spa_SOA_Form_SubmitError_Text\"\r\n            [memberProfileErrorMessagesTitleText]=\"Spa_Member_Profile_ErrorMessages_TitleText\"\r\n            [showConsumerForm]=\"true\"\r\n            [showNewConsumerForm]=\"false\"\r\n            [selectedActivity]=\"selectedActivity\"\r\n            [unableToProcessErrorsTitleText]=\"Spa_Site_UnableToProcessErrorsTitle_Text\"\r\n            [unableToProcessErrorsMessageText]=\"Spa_Site_UnableToProcessErrorsMessage_Text\"\r\n            (consumerFormSubmitted)=\"onSubmit()\"\r\n            (agentFormSubmitted)=\"onSubmit()\"\r\n          ></nextgen-soa-form>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n  </ng-container>\r\n\r\n  <ng-template #hopeSOAForm>\r\n    <!--\r\n      adding a check for live edit in here so that the confirmation page will show up and be editable in live edit mode\r\n      without this we'll just get the form view with no form and it would never be accessible\r\n      this prevents the form from being viewed in live edit, but it does not ever need to be\r\n    -->\r\n    <ng-container *ngIf=\"soaFormDisplay; else confirmationSection\">\r\n      <div class=\"row mt-5\" #errorContainer>\r\n        <ng-container *ngIf=\"errorBannerList.length\">\r\n          <vnext-notice\r\n            [title]=\"Spa_Member_Profile_ErrorMessages_TitleText\"\r\n            [messages]=\"errorBannerList\"\r\n            [type]=\"'error'\"\r\n            class=\"col-12\"\r\n          ></vnext-notice>\r\n        </ng-container>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col-12\">\r\n          <vnext-soa-form-renderer\r\n            #soaForm\r\n            *ngIf=\"formHtml\"\r\n            [formHtml]=\"formHtml\"\r\n            vnextGoogleTagManager\r\n            [saveDefaultValues]=\"true\"\r\n            [tagsToUpdate]=\"tagsToUpdate\"\r\n          ></vnext-soa-form-renderer>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n  </ng-template>\r\n\r\n  <ng-template #confirmationSection>\r\n    <h2 class=\"Spa_Style_H1 my-5 text-center\" *liveEditProp=\"'Spa_SOA_Form_Header_Text'\">{{ Spa_SOA_Form_Header_Text }}</h2>\r\n    <div class=\"mt-3 mb-5\">\r\n      <vnext-notice [type]=\"'success'\" [messages]=\"successMessage\"></vnext-notice>\r\n    </div>\r\n    <div class=\"row d-flex flex-column ml-0\">\r\n      <h4 class=\"Spa_Style_H4 mt-4\" *liveEditProp=\"'Spa_SOA_Form_Success_SubHeader1_Text'\">{{ Spa_SOA_Form_Success_SubHeader1_Text }}</h4>\r\n      <ul class=\"Spa_Style_IntroParagraph Spa_Style_Small_Font col-12 col-md-8 ml-0\">\r\n        <li *ngFor=\"let product of selectedSoaPlanTypes\">{{ product }}</li>\r\n      </ul>\r\n    </div>\r\n\r\n    <div class=\"row mt-3\">\r\n      <div class=\"col-12 col-md-8\">\r\n        <div\r\n          *liveEditProp=\"'Spa_SOA_Form_WhatToBring_Html'\"\r\n          [innerHTML]=\"Spa_SOA_Form_WhatToBring_Html | safe : 'html'\"\r\n          navigationAdapter\r\n        ></div>\r\n      </div>\r\n      <div class=\"col-md-4 col-12\">\r\n        <img\r\n          *ngIf=\"Spa_Medicare_Card_SOA_Form_Image\"\r\n          class=\"medicare-card\"\r\n          [src]=\"medicareCardSOAFormImageSource\"\r\n          [alt]=\"Spa_Site_MedicareCard_SOA_Image_AlternateText\"\r\n        />\r\n        <ng-container *ngIf=\"Spa_Medicare_Card_SOA_Form_Image\">\r\n          <div class=\"Spa_Style_Note mt-2\" *liveEditProp=\"'Spa_Medicare_Card_SOA_Form_Image_Text'\">\r\n            {{ Spa_Medicare_Card_SOA_Form_Image_Text }}\r\n          </div>\r\n        </ng-container>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n  <vnext-navigation-banner class=\"col-12\" *ngIf=\"!Spa_Site_SOA_NextGen_Enabled && !submitted && !previouslySubmittedSOA\">\r\n    <div continue-button>\r\n      <vnext-status-button\r\n        [buttonText]=\"Spa_SOA_Form_SubmitButton_Text\"\r\n        [buttonClass]=\"'Spa_Style_PrimaryButton h-100'\"\r\n        [tooltipMessageError]=\"Spa_SOA_Form_SubmitError_Text\"\r\n        *liveEditProp=\"'Spa_SOA_Form_SubmitButton_Text'\"\r\n        (click)=\"onSubmit()\"\r\n      >\r\n      </vnext-status-button>\r\n    </div>\r\n  </vnext-navigation-banner>\r\n</div>\r\n", styles: [".medicare-card{width:100%;max-width:300px}.soa-banner-video{height:350px;background-size:cover;padding-top:25px;padding-bottom:25px}.personalized-video-wrapper{width:533.33px}@media (max-width: 992px){.quote-banner-video{height:200px;background-size:cover}.personalized-video-wrapper{width:355.55px}.soa-banner-video{height:200px;padding-top:0;padding-bottom:0}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: SoaFormFacade }, { type: SOAFacade }, { type: i1.SpinnerService }, { type: AnalyticsService }, { type: i1.ImageService }, { type: i1.LocaleService }, { type: NextGenSOAFormNavigationContext }]; }, { Spa_SOA_Form_Header_Text: [], Spa_SOA_Form_Success_SubHeader1_Text: [], Spa_SOA_Form_SubmitButton_Text: [], Spa_SOA_Form_Success_Message_Text: [], Spa_SOA_Form_Success_SubMessage_Text: [], Spa_SOA_Form_WhatToBring_Html: [], Spa_SOA_Form_SubmitError_Text: [], Spa_SOA_AgentEmail_Subject: [], Spa_SOA_AgentEmail_Header: [], Spa_SOA_AgentEmail_Subheader: [], Spa_SOA_AgentEmail_Link_Text: [], Spa_SOA_AgentEmail_CheckCircle_Image: [], Spa_SOA_Email_DoNotReplyText: [], Spa_Medicare_Card_SOA_Form_Image_Text: [], Spa_Medicare_Card_SOA_Form_Image: [], Spa_Site_AgentLogin_Url: [], Spa_Member_Profile_ErrorMessages_TitleText: [], Spa_HeaderFooter_Broker: [], Spa_HeaderFooter_PrimaryClientLogo: [], Spa_HeaderFooter_PrimaryClientLogo_Url: [], Spa_HeaderFooter_SecondaryClientLogo: [], Spa_HeaderFooter_SecondaryClientLogo_Url: [], Spa_Site_Broker_Info_Enabled: [], Spa_Site_MedicareCard_SOA_Image_AlternateText: [], Spa_PersonalizedVideo_Enabled: [], Spa_PersonalizedVideo_SOAForm_Enabled: [], Spa_Site_Is_BLAM: [], Spa_Site_SOA_NextGen_Enabled: [], Spa_PersonalizedVideo_SOAForm_FrameTitle: [], Spa_Site_UnableToProcessErrorsTitle_Text: [], Spa_Site_UnableToProcessErrorsMessage_Text: [], saveButton: [{
            type: ViewChild,
            args: [StatusButtonComponent]
        }], form: [{
            type: ViewChild,
            args: [SoaFormRendererComponent]
        }], errorContainer: [{
            type: ViewChildren,
            args: ['errorContainer']
        }], header: [{
            type: ViewChild,
            args: [DynamicHeaderComponent]
        }], soaForm: [{
            type: ViewChild,
            args: ['soaForm']
        }], nextGenSOAForm: [{
            type: ViewChild,
            args: [NextGenSOAFormComponent]
        }], onInputBlur: [{
            type: HostListener,
            args: [`${CustomFOAMEvents.INPUT_BLUR}`, ['$event']]
        }] }); })();

const _c0$n = ["uploadInput"];
function SOAComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.Spa_SOA_Title);
} }
function SOAComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 24);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", ctx_r2.Spa_SOA_ExplanatoryText ? i0.ɵɵpipeBind2(1, 1, ctx_r2.Spa_SOA_ExplanatoryText, "html") : "", i0.ɵɵsanitizeHtml);
} }
function SOAComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.Spa_SOA_Activity_Title);
} }
function SOAComponent_div_14_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 27);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const error_r14 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(error_r14);
} }
function SOAComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, SOAComponent_div_14_div_1_Template, 4, 1, "div", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.fileUploadErrors);
} }
function SOAComponent_span_19_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 28)(1, "vnext-link", 29);
    i0.ɵɵlistener("click", function SOAComponent_span_19_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r15.openConsumerForm()); })("keyup.enter", function SOAComponent_span_19_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r16); const ctx_r17 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r17.openConsumerForm()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span", 30);
    i0.ɵɵtext(3, "|");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r5.Spa_SOA_Activity_ConsumerFormLink_Text)("additionalIcon", "fas fa-file-alt")("makeInlineBlock", true)("keyNameForLiveEdit", "Spa_SOA_Activity_ConsumerFormLink_Text");
} }
function SOAComponent_span_20_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 28)(1, "vnext-link", 29);
    i0.ɵɵlistener("click", function SOAComponent_span_20_Template_vnext_link_click_1_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.openConsumerForm(ctx_r18.soaTransactionEventType.BY_PHONE)); })("keyup.enter", function SOAComponent_span_20_Template_vnext_link_keyup_enter_1_listener() { i0.ɵɵrestoreView(_r19); const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.openConsumerForm(ctx_r20.soaTransactionEventType.BY_PHONE)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span", 30);
    i0.ɵɵtext(3, "|");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", ctx_r6.Spa_SOA_Activity_ConsumerFormByPhoneLink_Text)("additionalIcon", "fas fa-phone")("makeInlineBlock", true)("keyNameForLiveEdit", "Spa_SOA_Activity_ConsumerFormByPhoneLink_Text");
} }
function SOAComponent_span_23_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 28)(1, "span", 30);
    i0.ɵɵtext(2, "|");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "vnext-link", 29);
    i0.ɵɵlistener("click", function SOAComponent_span_23_Template_vnext_link_click_3_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r21.openUpload()); })("keyup.enter", function SOAComponent_span_23_Template_vnext_link_keyup_enter_3_listener() { i0.ɵɵrestoreView(_r22); const ctx_r23 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r23.openUpload()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", ctx_r7.Spa_Site_UploadLink_Text)("additionalIcon", "fas fa-upload")("makeInlineBlock", true)("keyNameForLiveEdit", "Spa_Site_UploadLink_Text");
} }
function SOAComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31)(1, "button", 32);
    i0.ɵɵlistener("click", function SOAComponent_div_24_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r24.showSOAModal()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.Spa_Site_SendSOA_Button_Text, " ");
} }
function SOAComponent_ng_container_25_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "nextgen-soa-form", 33);
    i0.ɵɵlistener("consumerFormSubmitted", function SOAComponent_ng_container_25_Template_nextgen_soa_form_consumerFormSubmitted_1_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r26.onConsumerFormSubmit($event)); })("agentFormSubmitted", function SOAComponent_ng_container_25_Template_nextgen_soa_form_agentFormSubmitted_1_listener() { i0.ɵɵrestoreView(_r27); const ctx_r28 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r28.onFormSubmit()); })("setSelectedActivityById", function SOAComponent_ng_container_25_Template_nextgen_soa_form_setSelectedActivityById_1_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r29 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r29.setSelectedActivityById($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("continueButtonText", ctx_r9.Spa_SOA_ContinueForm_Text)("continueButtonKeyText", "Spa_SOA_ContinueForm_Text")("submitButtonText", ctx_r9.Spa_SOA_SubmitBrokerForm_Text)("submitButtonKeyText", "Spa_SOA_SubmitBrokerForm_Text")("soaFormSubmitErrorText", ctx_r9.Spa_SOA_Form_SubmitError_Text)("memberProfileErrorMessagesTitleText", ctx_r9.Spa_Member_Profile_ErrorMessages_TitleText)("showConsumerForm", ctx_r9.showConsumerFormSection)("showNewConsumerForm", ctx_r9.showNewConsumerForm)("selectedActivity", ctx_r9.selectedActivity)("selectedSOATransactionType", ctx_r9.selectedSOATransactionType)("unableToProcessErrorsTitleText", ctx_r9.Spa_Site_UnableToProcessErrorsTitle_Text)("unableToProcessErrorsMessageText", ctx_r9.Spa_Site_UnableToProcessErrorsMessage_Text);
} }
function SOAComponent_ng_template_26_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "vnext-soa-consumer-form", 35);
    i0.ɵɵlistener("setSelectedActivityById", function SOAComponent_ng_template_26_ng_container_0_Template_vnext_soa_consumer_form_setSelectedActivityById_1_listener($event) { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r33.setSelectedActivityById($event)); })("formSubmitted", function SOAComponent_ng_template_26_ng_container_0_Template_vnext_soa_consumer_form_formSubmitted_1_listener($event) { i0.ɵɵrestoreView(_r34); const ctx_r35 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r35.onConsumerFormSubmit($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("submitButtonText", ctx_r30.Spa_SOA_ContinueForm_Text)("soaFormSubmitErrorText", ctx_r30.Spa_SOA_Form_SubmitError_Text)("memberProfileErrorMessagesTitleText", ctx_r30.Spa_Member_Profile_ErrorMessages_TitleText)("showNewConsumerForm", ctx_r30.showNewConsumerForm)("selectedActivity", ctx_r30.selectedActivity)("selectedSOATransactionType", ctx_r30.selectedSOATransactionType);
} }
function SOAComponent_ng_template_26_ng_template_1_vnext_soa_agent_form_0_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-soa-agent-form", 37);
    i0.ɵɵlistener("formSubmitted", function SOAComponent_ng_template_26_ng_template_1_vnext_soa_agent_form_0_Template_vnext_soa_agent_form_formSubmitted_0_listener() { i0.ɵɵrestoreView(_r38); const ctx_r37 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r37.onFormSubmit()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("selectedActivity", ctx_r36.selectedActivity)("submitButtonKeyText", "Spa_SOA_SubmitBrokerForm_Text")("submitButtonText", ctx_r36.Spa_SOA_SubmitBrokerForm_Text)("soaFormSubmitErrorText", ctx_r36.Spa_SOA_Form_SubmitError_Text)("memberProfileErrorMessagesTitleText", ctx_r36.Spa_Member_Profile_ErrorMessages_TitleText);
} }
function SOAComponent_ng_template_26_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SOAComponent_ng_template_26_ng_template_1_vnext_soa_agent_form_0_Template, 1, 5, "vnext-soa-agent-form", 36);
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r32.selectedActivity);
} }
function SOAComponent_ng_template_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SOAComponent_ng_template_26_ng_container_0_Template, 2, 6, "ng-container", 21);
    i0.ɵɵtemplate(1, SOAComponent_ng_template_26_ng_template_1_Template, 1, 1, "ng-template", null, 34, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r31 = i0.ɵɵreference(2);
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r11.showConsumerFormSection)("ngIfElse", _r31);
} }
function SOAComponent_ng_container_28_ng_container_1_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 55);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r48.Spa_SOA_EmailInput_Error_InvalidFormat, "");
} }
function SOAComponent_ng_container_28_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵelement(1, "i", 53);
    i0.ɵɵtemplate(2, SOAComponent_ng_container_28_ng_container_1_div_2_span_2_Template, 2, 1, "span", 54);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r43 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r43.emailAddressInput.errors == null ? null : ctx_r43.emailAddressInput.errors.required) || (ctx_r43.emailAddressInput.errors == null ? null : ctx_r43.emailAddressInput.errors.pattern));
} }
function SOAComponent_ng_container_28_ng_container_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1, "\u00A0");
    i0.ɵɵelementEnd();
} }
function SOAComponent_ng_container_28_ng_container_1_button_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 56);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r46.Spa_SOA_EmailButton_Text, " ");
} }
function SOAComponent_ng_container_28_ng_container_1_ng_container_13_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 55);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r52.Spa_SOA_PhoneInput_Error_InvalidFormat, "");
} }
function SOAComponent_ng_container_28_ng_container_1_ng_container_13_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 52);
    i0.ɵɵelement(1, "i", 53);
    i0.ɵɵtemplate(2, SOAComponent_ng_container_28_ng_container_1_ng_container_13_div_2_span_2_Template, 2, 1, "span", 54);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r49.phoneNumberInput.errors == null ? null : ctx_r49.phoneNumberInput.errors.required) || (ctx_r49.phoneNumberInput.errors == null ? null : ctx_r49.phoneNumberInput.errors.pattern));
} }
function SOAComponent_ng_container_28_ng_container_1_ng_container_13_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1, "\u00A0");
    i0.ɵɵelementEnd();
} }
const _c1$1 = function (a0) { return { Spa_Style_Gray4_Color: a0 }; };
const _c2 = function (a0) { return { "Spa_Style_Gray4_Color readonly": a0 }; };
function SOAComponent_ng_container_28_ng_container_1_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 57);
    i0.ɵɵtemplate(2, SOAComponent_ng_container_28_ng_container_1_ng_container_13_div_2_Template, 3, 1, "div", 46);
    i0.ɵɵtemplate(3, SOAComponent_ng_container_28_ng_container_1_ng_container_13_ng_template_3_Template, 2, 0, "ng-template", null, 58, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "form", 48);
    i0.ɵɵlistener("ngSubmit", function SOAComponent_ng_container_28_ng_container_1_ng_container_13_Template_form_ngSubmit_5_listener() { i0.ɵɵrestoreView(_r54); const ctx_r53 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r53.sendSOAText()); });
    i0.ɵɵelementStart(6, "label", 59);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "input", 60);
    i0.ɵɵlistener("focus", function SOAComponent_ng_container_28_ng_container_1_ng_container_13_Template_input_focus_9_listener() { i0.ɵɵrestoreView(_r54); const ctx_r55 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r55.showPhoneError = false); });
    i0.ɵɵpipe(10, "async");
    i0.ɵɵpipe(11, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "button", 61);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r50 = i0.ɵɵreference(4);
    const ctx_r47 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r47.showPhoneError && ctx_r47.phoneNumberInput.invalid)("ngIfElse", _r50);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c1$1, i0.ɵɵpipeBind1(7, 9, ctx_r47.ssoPopulatedFieldService.isFieldReadOnly$("Profile.HomePhone"))));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r47.Spa_Site_PhoneNumber_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("mask", ctx_r47.phoneMask)("formControl", ctx_r47.phoneNumberInput)("ngClass", i0.ɵɵpureFunction1(17, _c2, i0.ɵɵpipeBind1(10, 11, ctx_r47.ssoPopulatedFieldService.isFieldReadOnly$("Profile.HomePhone"))))("readonly", i0.ɵɵpipeBind1(11, 13, ctx_r47.ssoPopulatedFieldService.isFieldReadOnly$("Profile.HomePhone")));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r47.Spa_SOA_PhoneButton_Text, " ");
} }
function SOAComponent_ng_container_28_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 45);
    i0.ɵɵtemplate(2, SOAComponent_ng_container_28_ng_container_1_div_2_Template, 3, 1, "div", 46);
    i0.ɵɵtemplate(3, SOAComponent_ng_container_28_ng_container_1_ng_template_3_Template, 2, 0, "ng-template", null, 47, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "form", 48);
    i0.ɵɵlistener("ngSubmit", function SOAComponent_ng_container_28_ng_container_1_Template_form_ngSubmit_5_listener() { i0.ɵɵrestoreView(_r57); const ctx_r56 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r56.sendSOAEmail()); });
    i0.ɵɵelementStart(6, "label", 49);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "input", 50);
    i0.ɵɵlistener("focus", function SOAComponent_ng_container_28_ng_container_1_Template_input_focus_9_listener() { i0.ɵɵrestoreView(_r57); const ctx_r58 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r58.showEmailError = false); });
    i0.ɵɵpipe(10, "async");
    i0.ɵɵpipe(11, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, SOAComponent_ng_container_28_ng_container_1_button_12_Template, 2, 1, "button", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, SOAComponent_ng_container_28_ng_container_1_ng_container_13_Template, 14, 19, "ng-container", 23);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r44 = i0.ɵɵreference(4);
    const ctx_r39 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r39.showEmailError && ctx_r39.emailAddressInput.invalid)("ngIfElse", _r44);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c1$1, i0.ɵɵpipeBind1(7, 9, ctx_r39.ssoPopulatedFieldService.isFieldReadOnly$("Profile.PrimaryEmailAddress"))));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r39.Spa_Site_EmailAddress_Text);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControl", ctx_r39.emailAddressInput)("ngClass", i0.ɵɵpureFunction1(17, _c2, i0.ɵɵpipeBind1(10, 11, ctx_r39.ssoPopulatedFieldService.isFieldReadOnly$("Profile.PrimaryEmailAddress"))))("readonly", i0.ɵɵpipeBind1(11, 13, ctx_r39.ssoPopulatedFieldService.isFieldReadOnly$("Profile.PrimaryEmailAddress")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("liveEditProp", "Spa_SOA_EmailButton_Text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r39.textSOAEnabled);
} }
function SOAComponent_ng_container_28_vnext_link_5_Template(rf, ctx) { if (rf & 1) {
    const _r60 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "vnext-link", 62);
    i0.ɵɵlistener("click", function SOAComponent_ng_container_28_vnext_link_5_Template_vnext_link_click_0_listener() { i0.ɵɵrestoreView(_r60); const ctx_r59 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r59.configurableWidgetService.navigationService.backToPrevious()); })("keyup.enter", function SOAComponent_ng_container_28_vnext_link_5_Template_vnext_link_keyup_enter_0_listener() { i0.ɵɵrestoreView(_r60); const ctx_r61 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r61.configurableWidgetService.navigationService.backToPrevious()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r40.Spa_Site_Previous)("showArrow", "left")("makeInlineBlock", true);
} }
function SOAComponent_ng_container_28_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r63 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 63);
    i0.ɵɵlistener("click", function SOAComponent_ng_container_28_button_7_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r63); const ctx_r62 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r62.navigateToPageTag(ctx_r62.pageTags.GUIDED_HELP_GETTING_STARTED)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r41.Spa_Site_AddPreferences, " ");
} }
function SOAComponent_ng_container_28_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r65 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 64);
    i0.ɵɵlistener("click", function SOAComponent_ng_container_28_button_8_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r65); const ctx_r64 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r64.navigateToPageTag(ctx_r64.pageTags.PLAN_LIST)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r42.Spa_Site_ContinueToPlanList, " ");
} }
function SOAComponent_ng_container_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SOAComponent_ng_container_28_ng_container_1_Template, 14, 19, "ng-container", 23);
    i0.ɵɵelementStart(2, "div", 38)(3, "vnext-navigation-banner", 39)(4, "div", 40);
    i0.ɵɵtemplate(5, SOAComponent_ng_container_28_vnext_link_5_Template, 1, 3, "vnext-link", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 42);
    i0.ɵɵtemplate(7, SOAComponent_ng_container_28_button_7_Template, 2, 1, "button", 43);
    i0.ɵɵtemplate(8, SOAComponent_ng_container_28_button_8_Template, 2, 1, "button", 44);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r12.Spa_SOA_RequireAuthCode_Enabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("providedPrevious", true)("showPrevious", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_Previous");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_AddPreferences");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("liveEditProp", "Spa_Site_ContinueToPlanList");
} }
let SOAComponent = class SOAComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, modalService, agentTaskFacade, store, navigationService, guidedHelpService, soaFacade, soaService, formValidationService, spinnerService, analyticsService, agentService, agentPermissionsService, ssoPopulatedFieldService, configResourceService, siteService, agentSearchFacade, sessionService, phoneUtilityService, profileService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.modalService = modalService;
        this.agentTaskFacade = agentTaskFacade;
        this.store = store;
        this.navigationService = navigationService;
        this.guidedHelpService = guidedHelpService;
        this.soaFacade = soaFacade;
        this.soaService = soaService;
        this.formValidationService = formValidationService;
        this.spinnerService = spinnerService;
        this.analyticsService = analyticsService;
        this.agentService = agentService;
        this.agentPermissionsService = agentPermissionsService;
        this.ssoPopulatedFieldService = ssoPopulatedFieldService;
        this.configResourceService = configResourceService;
        this.siteService = siteService;
        this.agentSearchFacade = agentSearchFacade;
        this.sessionService = sessionService;
        this.phoneUtilityService = phoneUtilityService;
        this.profileService = profileService;
        this.Spa_SOA_SubmitBrokerForm_Text = 'Submit broker form';
        this.Spa_SOA_Title = 'Scope of Appointment';
        this.Spa_SOA_ExplanatoryText = 'A Scope of Appointment is required for all sales appointments. Submit the SOA once you have received it from the beneficiary.';
        this.Spa_SOA_Activity_NoSOAText = 'You have no SOAs for this profile';
        this.Spa_SOA_EmailButton_Text = 'Email SOA';
        this.Spa_SOA_Activity_Title = 'SOAs';
        this.Spa_SOA_PdfForm_PrintLink_Text = 'Print consumer form';
        this.Spa_Site_UploadLink_Text = 'Upload';
        this.Spa_Site_AddPreferences = 'Add preferences';
        this.Spa_Site_ContinueToPlanList = 'Continue to plans';
        this.Spa_Site_Previous = 'Previous';
        this.Spa_SOA_Activity_ConsumerFormLink_Text = 'Complete SOA form in-person';
        this.Spa_SOA_Activity_ConsumerFormByPhoneLink_Text = 'Complete SOA form by phone';
        this.Spa_EnrollmentHistory_Confirmation_Text = 'Confirmation';
        this.Spa_SOA_Activity_CompleteForm_Text = 'Complete form';
        this.Spa_SOA_Activity_CloseForm_Text = 'Close form';
        this.Spa_SOA_Form_SubmitError_Text = 'Try again';
        this.Spa_Site_EmailAddress_Text = 'Email address';
        this.Spa_Site_PhoneNumber_Text = 'Phone number';
        this.Spa_SOA_PhoneButton_Text = 'Text SOA';
        this.Spa_SOA_EmailInput_Error_RequiredField = 'Please provide email address';
        this.Spa_SOA_EmailInput_Error_InvalidFormat = 'Please provide a valid email address';
        this.Spa_SOA_PhoneInput_Error_InvalidFormat = 'Please provide a valid phone number';
        this.Spa_SOA_ConsumerEmail_Subject = 'Scope of Appointment form';
        this.Spa_SOA_ConsumerEmail_Image = 'https://contentserver-dev.destinationrx.com/drxproductcontent/phoenix/assets/images/SOA_email_banner.jpg';
        this.Spa_SOA_ConsumerEmail_MobileImage = 'https://contentserver-dev.destinationrx.com/drxproductcontent/phoenix/assets/images/SOA_email_mobile_banner.jpg';
        this.Spa_SOA_ConsumerEmail_Header = 'Hi {{[member.profile.firstName]}},';
        this.Spa_SOA_ConsumerEmail_Subheader = 'I am looking forward to meeting with you...';
        this.Spa_SOA_ConsumerEmail_Body = "<p>Please fill out the Scope of Appointment online form. Be sure to select the Medicare health plan options that you are interested in discussing during our visit</p><p>It's important that you complete the form prior to our visit it is required by the Center for Medicare and Medical Services.</p>";
        this.Spa_SOA_ConsumerEmail_From = 'donotreply@connecture.com';
        this.Spa_SOA_ConsumerEmail_LinkText = 'Complete "Scope of Appointment" form';
        this.Spa_SOA_Email_DoNotReplyText = 'Do not reply to this email';
        this.Spa_SOA_Activity_StartedText = 'Email sent to <soaEmail> on <soaDate>';
        this.Spa_SOA_Activity_PartialText = 'Completed by <soaMemberName> on <soaDate>';
        this.Spa_SOA_Agent_Activity_PartialText = 'Completed by agent with <soaMemberName> on <soaDate>';
        this.Spa_SOA_Agent_Activity_StartedText = 'SOA started on <soaDate>';
        this.Spa_SOA_Activity_TextSentText = 'Text sent to <phone> on <soaDate>';
        this.Spa_SOA_Activity_UploadedFile_Text = 'Uploaded <soaDate>';
        this.Spa_SOA_EnableFileUpload_Flag = true;
        this.Spa_SOA_Activity_ConsumerFormLink_Enabled = false;
        this.Spa_SOA_Activity_ConsumerFormByPhoneLink_Enabled = false;
        this.Spa_SOA_PdfForm_Url = 'https://contentserver.destinationrx.com/ContentServer/DRxProductContent/Documents/Scope%20of%20AppointmentForm%20-%20Generic.pdf';
        this.Spa_SOA_ViewDocument_Text = 'View';
        this.Spa_Member_Profile_ErrorMessages_TitleText = 'Correct the following error(s) on the form, then submit again';
        this.Spa_SOAFollowUpModal_Title_Text = 'Scope of Appointment sent';
        this.Spa_SOA_ContinueForm_Text = 'Continue';
        this.Spa_SOA_Agent_Activity_CompletedText = 'Completed (phone/in-person) <soaDate>';
        this.Spa_Site_AgentCallRecordingShopping_Enabled = false;
        this.Spa_SOA_AgentCallRecording_DisplayPlayAudioRecording_Enabled = false;
        this.Spa_EnrollmentHistory_Pacific_StandardTime_Text = 'PST';
        this.Spa_SOA_RequireAuthCode_Enabled = false;
        this.Spa_Site_SendSOA_Button_Text = 'Send SOA';
        this.Spa_Site_SOA_NextGen_Enabled = false;
        this.Spa_Site_UnableToProcessErrorsTitle_Text = 'Unable to Process Application';
        this.Spa_Site_UnableToProcessErrorsMessage_Text = 'We are unable to process your application at this time. Contact your administrator for assistance.';
        this.pageTags = PageTags;
        this.memberEmailAddress = '';
        this.memberPhoneNumber = '';
        this.emailAddressInput = new UntypedFormControl(this.memberEmailAddress, [
            Validators.required,
            Validators.pattern(FormValidationService.emailPattern)
        ]);
        this.phoneNumberInput = new UntypedFormControl(this.memberPhoneNumber, [
            Validators.required,
            Validators.pattern(FormValidationService.phoneNumberPattern)
        ]);
        this.phoneMask = FormValidationService.phoneMask;
        this.agentName = '';
        this.agentEmail = '';
        this.agentGuid = '';
        this.agentPhoneAndHours = '';
        this.memberId = '';
        this.memberName = '';
        this.showPhoneError = false;
        this.showEmailError = false;
        this.fileUploadErrors = [];
        this.documentList = [];
        this.soaActivities = [];
        this.checkFocus = false;
        this.isAdmin = false;
        this.phoneNumbersMatch = false;
        this.soaTransactionEventType = SOATransactionEventType;
    }
    ngOnInit() {
        super.ngOnInit();
        // SPA-15527 we only care if numbers were equal or not on page load
        this.phoneNumbersMatch = this.profileService.getArePhoneNumbersEqual();
        this.textSOAEnabled = this.soaService.isSOATextEnabled();
        this.isAdmin = this.agentPermissionsService.isAgentAdmin();
        this.rehydrateAndInit(true);
        this.isAddFollowUpTaskEnabled = this.configResourceService.getProcessedResourceValue('Spa_AgentTask_AddFollowUp_Enabled', null, false);
    }
    ngAfterViewChecked() {
        if (this.checkFocus) {
            const firstInvalidSOAFormInput = document.querySelector('input.ng-invalid');
            const firstInvalidSOAElement = firstInvalidSOAFormInput;
            if (firstInvalidSOAElement) {
                firstInvalidSOAElement.focus();
            }
            this.checkFocus = false;
        }
    }
    openUpload() {
        this.uploadInput.nativeElement.click();
    }
    trackGtmPrintEvent() {
        this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_SOA_PRINT_FORM);
    }
    openForm(activity) {
        this.showConsumerFormSection = STARTED_BY_AGENT_SOA_ACTIVITY_TYPES.includes(activity?.type);
        this.showNewConsumerForm = false;
        this.selectedActivity = activity;
    }
    showSOAFollowUpModal(soaActivityType) {
        const confirmationModal = this.modalService.open(SOAFollowUpModalComponent, { centered: true });
        confirmationModal.componentInstance.modalTitleText = this.getSOAModalTitle();
        confirmationModal.componentInstance.modalSentConfirmationText = this.getConfirmationText(soaActivityType);
        confirmationModal.componentInstance.modalViewMemberLink = this.getViewMemberLink();
        confirmationModal.componentInstance.modalCancelText = this.getSOAModalCancel();
        // create new session on cancel if profile has been updated
        confirmationModal.componentInstance.cancelAction = this.confirmationModalCancelAction.bind(this);
        confirmationModal.componentInstance.showViewMemberLink = this.profileService.getShowViewMemberLink();
        confirmationModal.result
            .then(async () => {
            this.agentSearchFacade.navigateByPageTag(PageTags.ADD_NEW_PROFILE);
        })
            .catch(() => {
            // eat the error to prevent a console error
        });
    }
    getSOAModalTitle() {
        return this.configResourceService.getProcessedResourceValue('Spa_SOAFollowUpModal_Title_Text', null, 'Scope of Appointment sent');
    }
    getSOAModalCancel() {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Close', null, 'Close');
    }
    getViewMemberLink(widgetName) {
        const isCreateProfileEnabled = this.configResourceService.getProcessedResourceValue('Spa_Quote_CreateProfile_Enabled', widgetName, this.siteService.isPPCSite());
        const createProfileLink = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_CreateProfile_Link_Text', widgetName, 'Create a profile');
        const viewMemberLink = this.configResourceService.getProcessedResourceValue('Spa_SendQuote_ViewMemberProfile_Link_Text', widgetName, `View 's profile`);
        if (this.profileService.hasMemberProfile() || isCreateProfileEnabled) {
            const fullName = this.profileService.getMemberFullName();
            return this.profileService.getViewLinkText(viewMemberLink, fullName);
        }
        else {
            return createProfileLink;
        }
    }
    getConfirmationText(soaActivityType) {
        const emailSentText = this.configResourceService.getProcessedResourceValue('Spa_SOA_Activity_StartedText', null, 'Email sent to <soaEmail> on <soaDate>');
        const textSentText = this.configResourceService.getProcessedResourceValue('Spa_SOA_Activity_TextSentText', null, 'Text sent to <phone> on <soaDate>');
        if (soaActivityType === SOAActivityType.STARTED_EMAIL) {
            return this.replaceTextReplacementVariables(emailSentText, this.soaFacade.latestStartedActivity(this.soaActivities, soaActivityType));
        }
        else if (soaActivityType === SOAActivityType.STARTED_TEXT) {
            return this.replaceTextReplacementVariables(textSentText, this.soaFacade.latestStartedActivity(this.soaActivities, soaActivityType));
        }
    }
    confirmationModalCancelAction() {
        // Create a new member session if we have updated the store for an email address but if no
        // member profile exists.
        const isNewMemberSessionNeeded = !this.profileService.hasMemberProfile() && this.store.selectSnapshot(ProfileState.emailAddress);
        if (isNewMemberSessionNeeded) {
            this.sessionService.createMemberSession$().toPromise();
        }
    }
    navigateToPageTag(pageTag) {
        if (pageTag === PageTags.GUIDED_HELP_GETTING_STARTED) {
            this.guidedHelpService.goToFirstLink();
        }
        else {
            this.navigationService.navigateByPageTag(pageTag);
        }
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        super.ngOnDestroy();
    }
    fileChange(files) {
        this.fileUploadErrors = [];
        const FILE_MAX_SIZE = 5000000;
        const FILE_TYPES = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif', 'application/pdf'];
        const file = files.item(0);
        if (file.size > FILE_MAX_SIZE) {
            this.fileUploadErrors.push(this.formValidationService.errorMessages.soaFileSize());
        }
        if (!FILE_TYPES.includes(file.type)) {
            this.fileUploadErrors.push(this.formValidationService.errorMessages.soaFileType());
        }
        if (!this.fileUploadErrors.length) {
            this.soaFacade.uploadDocument(file, this.memberId).then(() => {
                this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_SOA_UPLOAD_FORM);
            });
        }
    }
    onFormSubmit() {
        this.selectedActivity = null;
        this.selectedSOATransactionType = null;
        this.rehydrateAndInit(true);
        this.agentTaskFacade.removeAssociatedTasksByType([NoteActionType.SOATask]);
    }
    openConsumerForm(soaTransactionType = SOATransactionEventType.IN_PERSON) {
        this.showConsumerFormSection = true;
        this.showNewConsumerForm = true;
        this.selectedSOATransactionType = soaTransactionType;
        if (soaTransactionType === SOATransactionEventType.IN_PERSON) {
            this.analyticsService.setGoogleDataLayerTag(DataLayerGlobalVariable.EVENT, DataLayerEvent.CLICK_SOA_INPERSON_START);
        }
        this.cdr.markForCheck();
    }
    onConsumerFormSubmit(soaTransactionSID) {
        this.rehydrateAndInit(true);
        this.setSelectedActivityById(soaTransactionSID);
        this.showConsumerFormSection = false;
        this.cdr.markForCheck();
    }
    setSelectedActivityById(soaTransactionID) {
        this.selectedActivity = this.soaActivities.find(activity => activity.transactionSId === soaTransactionID || activity.transactionId === soaTransactionID);
        this.cdr.markForCheck();
    }
    sendSOAEmail() {
        this.showEmailError = true;
        if (!this.emailAddressInput.invalid) {
            const soaForm = {
                emailAddressIsDirty: this.emailAddressInput.dirty,
                emailAddress: this.emailAddressInput.value,
                phoneIsDirty: false,
                phone: null
            };
            this.memberEmailAddress = this.emailAddressInput.value;
            this.soaFacade.sendSOA(soaForm);
        }
        else {
            this.checkFocus = true;
        }
    }
    sendSOAText() {
        this.showPhoneError = true;
        if (!this.phoneNumberInput.invalid) {
            const soaForm = {
                emailAddressIsDirty: false,
                emailAddress: null,
                phoneIsDirty: this.phoneNumberInput.dirty,
                phone: this.phoneNumberInput.value
            };
            this.memberPhoneNumber = this.phoneNumberInput.value;
            this.soaFacade.sendSOA(soaForm);
        }
        else {
            this.checkFocus = true;
        }
    }
    showSOAModal() {
        this.soaFacade.showSOAModal();
    }
    replaceTextReplacementVariables(message, activity) {
        const soaEmail = activity.email ? activity.email : '';
        const soaDate = activity.date ? activity.date : '';
        const soaDateInMMddyyyy = soaDate ? DateUtilities.getFormattedPTDate(new Date(soaDate), DateUtilities.defaultFormat) : ''; // Convert soaDate from UTC to Pacific Time (PT)
        return message
            .replace('<soaEmail>', soaEmail)
            .replace('<phone>', this.memberPhoneNumber && this.memberPhoneNumber.length === 10
            ? this.phoneUtilityService.getNationalPhoneNumber(this.memberPhoneNumber)
            : '')
            .replace('<soaDate>', soaDateInMMddyyyy);
    }
    initializeSubscriptions() {
        this.subscriptions?.unsubscribe();
        this.subscriptions = new Subscription();
        // Get loading / spinner
        this.subscriptions.add(this.subscribeToSpinner());
        // Get agent contact info at bottom of email
        this.subscriptions.add(this.subscribeToAgentContactInfo());
        // Get member email
        this.subscriptions.add(this.subscribeToMemberEmail());
        if (this.textSOAEnabled) {
            // Get member phone number if enabled
            this.subscriptions.add(this.subscribeToMemberPhone());
        }
        // Get soa transaction activities
        this.subscriptions.add(this.subscribeToSOAActivities());
        // Get uploaded documents
        this.subscriptions.add(this.subscribeToDocumentList());
    }
    subscribeToAgentContactInfo() {
        return this.soaFacade
            .getAgentContactInfo$()
            .pipe(distinctUntilChanged(_isEqual))
            .subscribe({
            next: info => {
                this.agentEmail = info.agentEmailAddress ? info.agentEmailAddress : '';
                this.agentName = info.agentFullName;
                const agentHours = info.agentHours ? info.agentHours : '';
                const agentPhoneNumber = this.phoneUtilityService.formatPhoneNumberWithExtension(info.agentPhoneNumber, this.agentService.getAgentExtension());
                this.agentPhoneAndHours = agentHours && agentPhoneNumber ? `${agentHours} | ${agentPhoneNumber}` : agentHours + agentPhoneNumber;
                this.cdr.markForCheck();
            }
        });
    }
    subscribeToMemberPhone() {
        return this.soaFacade
            .getMemberProfilePhone$()
            .pipe(take(1))
            .subscribe({
            next: phone => {
                this.memberPhoneNumber = phone;
                this.phoneNumberInput.setValue(phone);
                this.cdr.markForCheck();
            }
        });
    }
    subscribeToMemberEmail() {
        return this.soaFacade.memberEmail$.pipe(distinctUntilChanged()).subscribe({
            next: email => {
                this.memberEmailAddress = email;
                this.emailAddressInput.setValue(email);
                this.cdr.markForCheck();
            }
        });
    }
    subscribeToSOAActivities() {
        return this.soaFacade
            .getSOAActivities$(this.isAdmin)
            .pipe(distinctUntilChanged(_isEqual))
            .subscribe({
            next: activities => {
                this.soaActivities = activities;
                this.cdr.markForCheck();
            }
        });
    }
    subscribeToDocumentList() {
        return this.soaFacade
            .getDocumentList$(this.memberId)
            .pipe(distinctUntilChanged(_isEqual))
            .subscribe({
            next: documents => {
                this.documentList = documents;
                this.cdr.markForCheck();
            }
        });
    }
    subscribeToSpinner() {
        return this.soaFacade.isLoading$.pipe(distinctUntilChanged()).subscribe({
            next: loading => {
                loading ? this.spinnerService.show(SpinnerEvent.SOA_LOADING) : this.spinnerService.hide(SpinnerEvent.SOA_LOADING);
            }
        });
    }
    rehydrateAndInit(fetchSession) {
        this.spinnerService.show(SpinnerEvent.SUBMITTED_FORM_LOADING);
        this.soaFacade
            .rehydrateSOATransactions$(fetchSession, this.isAdmin)
            .pipe(take(1))
            .subscribe({
            next: () => {
                this.memberId = this.configurableWidgetService.store.selectSnapshot(MemberState.memberID);
                this.memberName = this.soaFacade.getMemberName();
                this.initializeSubscriptions();
            },
            complete: () => {
                this.spinnerService.hide(SpinnerEvent.SUBMITTED_FORM_LOADING);
            }
        });
    }
};
SOAComponent.ɵfac = function SOAComponent_Factory(t) { return new (t || SOAComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1$1.NgbModal), i0.ɵɵdirectiveInject(AgentTaskFacade), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.GuidedHelpService), i0.ɵɵdirectiveInject(SOAFacade), i0.ɵɵdirectiveInject(i1.SOAService), i0.ɵɵdirectiveInject(i1.FormValidationService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(AnalyticsService), i0.ɵɵdirectiveInject(i1.AgentService), i0.ɵɵdirectiveInject(i1.AgentPermissionsService), i0.ɵɵdirectiveInject(i1.SSOPopulatedFieldService), i0.ɵɵdirectiveInject(i1.ConfigResourceService), i0.ɵɵdirectiveInject(i1.SiteService), i0.ɵɵdirectiveInject(AgentSearchFacade), i0.ɵɵdirectiveInject(i1.MemberSessionService), i0.ɵɵdirectiveInject(i1.PhoneUtilityService), i0.ɵɵdirectiveInject(i1.ProfileService)); };
SOAComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SOAComponent, selectors: [["vnext-soa"]], viewQuery: function SOAComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$n, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.uploadInput = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 29, vars: 41, consts: [["hidden", "", "type", "file", "accept", ".pdf,.jpg,.gif,.png", 3, "change"], ["uploadInput", ""], ["vnextGoogleTagManager", "", 1, "container", "soa-wrapper", 3, "saveDefaultValues"], [1, "row"], [1, "col-12", "text-center", "Spa_Style_H1"], [4, "liveEditProp"], [1, "col-12", "mt-4", "Spa_Style_Primary_Color"], ["navigationAdapter", "", 3, "innerHtml", 4, "liveEditProp"], [1, "col-12", "mt-4", "section-break", "Spa_Style_H2"], [1, "mt-1", "darker-line"], [1, "row", "soa-list-wrapper"], [1, "col-12", 3, "activityCompletedFormText", "completedAgentText", "activityCloseFormText", "startedText", "uploadedText", "partialText", "partialAgentText", "noActivityText", "textSentText", "confirmationText", "agentStartedText", "activities", "documents", "memberId", "viewText", "memberName", "memberPhone", "selectedActivity", "pacificStandardTimeText", "shoppingRecordingEnabled", "agentCallRecordingDisplayPlayAudioRecordingEnabled", "isAdmin", "completeFormClick"], [1, "row", "justify-content-between", "flex-md-row-reverse", "mt-3"], ["class", "warn-color col-12", 4, "ngIf"], [1, "col-12"], [1, "col-12", "col-md-6", "text-left", "text-md-right"], [1, "d-flex", "justify-content-end"], ["class", "link-wrapper upload-link-wrapper", 4, "ngIf"], [1, "link-wrapper"], [3, "title", "additionalIcon", "makeInlineBlock", "href", "linkTarget", "keyNameForLiveEdit", "click"], ["class", "col-12 col-md-6", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["hopeSOAForm", ""], [4, "ngIf"], ["navigationAdapter", "", 3, "innerHtml"], [1, "warn-color", "col-12"], [4, "ngFor", "ngForOf"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-triangle", "mr-2"], [1, "link-wrapper", "upload-link-wrapper"], [3, "title", "additionalIcon", "makeInlineBlock", "keyNameForLiveEdit", "click", "keyup.enter"], [1, "link-pipe"], [1, "col-12", "col-md-6"], [1, "btn", "Spa_Style_PrimaryButton", "col-xs-12", "col-md-auto", "mt-2", "mt-md-0", 3, "click"], [1, "w-100", 3, "continueButtonText", "continueButtonKeyText", "submitButtonText", "submitButtonKeyText", "soaFormSubmitErrorText", "memberProfileErrorMessagesTitleText", "showConsumerForm", "showNewConsumerForm", "selectedActivity", "selectedSOATransactionType", "unableToProcessErrorsTitleText", "unableToProcessErrorsMessageText", "consumerFormSubmitted", "agentFormSubmitted", "setSelectedActivityById"], ["showAgentForm", ""], [3, "submitButtonText", "soaFormSubmitErrorText", "memberProfileErrorMessagesTitleText", "showNewConsumerForm", "selectedActivity", "selectedSOATransactionType", "setSelectedActivityById", "formSubmitted"], [3, "selectedActivity", "submitButtonKeyText", "submitButtonText", "soaFormSubmitErrorText", "memberProfileErrorMessagesTitleText", "formSubmitted", 4, "ngIf"], [3, "selectedActivity", "submitButtonKeyText", "submitButtonText", "soaFormSubmitErrorText", "memberProfileErrorMessagesTitleText", "formSubmitted"], [1, "row", "navigation-bar-wrapper"], [1, "col-12", 3, "providedPrevious", "showPrevious"], ["previous-link", ""], [3, "title", "showArrow", "makeInlineBlock", "click", "keyup.enter", 4, "liveEditProp"], ["continue-button", ""], ["class", "btn Spa_Style_SecondaryButton col-xs-12 col-md-auto mr-md-2 mb-md-0 mb-2", 3, "click", 4, "liveEditProp"], ["class", "btn Spa_Style_PrimaryButton col-xs-12 col-md-auto", 3, "click", 4, "liveEditProp"], [1, "row", "mt-2"], ["class", "col-12 error-color", 4, "ngIf", "ngIfElse"], ["errorPlaceHolder", ""], ["disableKeyDownSubmit", "", 1, "row", "email-wrapper", "no-gutters", 3, "ngSubmit"], ["for", "soa-email-input", 1, "col-12", "Spa_Style_Label", 3, "ngClass"], ["id", "soa-email-input", "type", "text", 1, "col-12", "col-md-3", "email-input", 3, "formControl", "ngClass", "readonly", "focus"], ["class", "col-auto email-button mt-4 mt-md-0 btn Spa_Style_SecondaryButton", "type", "submit", 4, "liveEditProp"], [1, "col-12", "error-color"], ["aria-hidden", "true", 1, "fas", "fa-exclamation-circle"], ["role", "alert", 4, "ngIf"], ["role", "alert"], ["type", "submit", 1, "col-auto", "email-button", "mt-4", "mt-md-0", "btn", "Spa_Style_SecondaryButton"], [1, "row", "mt-3"], ["phoneErrorPlaceHolder", ""], ["for", "soa-phone-text-input", 1, "col-12", "Spa_Style_Label", 3, "ngClass"], ["id", "soa-phone-text-input", "type", "text", 1, "col-12", "col-md-3", "phone-input", 3, "mask", "formControl", "ngClass", "readonly", "focus"], ["type", "submit", 1, "col-auto", "phone-button", "mt-4", "mt-md-0", "btn", "Spa_Style_SecondaryButton"], [3, "title", "showArrow", "makeInlineBlock", "click", "keyup.enter"], [1, "btn", "Spa_Style_SecondaryButton", "col-xs-12", "col-md-auto", "mr-md-2", "mb-md-0", "mb-2", 3, "click"], [1, "btn", "Spa_Style_PrimaryButton", "col-xs-12", "col-md-auto", 3, "click"]], template: function SOAComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "input", 0, 1);
        i0.ɵɵlistener("change", function SOAComponent_Template_input_change_0_listener($event) { return ctx.fileChange($event.target.files); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4);
        i0.ɵɵtemplate(5, SOAComponent_span_5_Template, 2, 1, "span", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵtemplate(7, SOAComponent_span_7_Template, 2, 4, "span", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 8);
        i0.ɵɵtemplate(9, SOAComponent_span_9_Template, 2, 1, "span", 5);
        i0.ɵɵelement(10, "hr", 9);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(11, "div", 10)(12, "vnext-soa-activity", 11);
        i0.ɵɵlistener("completeFormClick", function SOAComponent_Template_vnext_soa_activity_completeFormClick_12_listener($event) { return ctx.openForm($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "div", 12);
        i0.ɵɵtemplate(14, SOAComponent_div_14_Template, 2, 1, "div", 13);
        i0.ɵɵelementStart(15, "div", 14);
        i0.ɵɵelement(16, "hr");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 15)(18, "div", 16);
        i0.ɵɵtemplate(19, SOAComponent_span_19_Template, 4, 4, "span", 17);
        i0.ɵɵtemplate(20, SOAComponent_span_20_Template, 4, 4, "span", 17);
        i0.ɵɵelementStart(21, "span", 18)(22, "vnext-link", 19);
        i0.ɵɵlistener("click", function SOAComponent_Template_vnext_link_click_22_listener() { return ctx.trackGtmPrintEvent(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(23, SOAComponent_span_23_Template, 4, 4, "span", 17);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(24, SOAComponent_div_24_Template, 3, 1, "div", 20);
        i0.ɵɵtemplate(25, SOAComponent_ng_container_25_Template, 2, 12, "ng-container", 21);
        i0.ɵɵtemplate(26, SOAComponent_ng_template_26_Template, 3, 2, "ng-template", null, 22, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(28, SOAComponent_ng_container_28_Template, 9, 6, "ng-container", 23);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r10 = i0.ɵɵreference(27);
        i0.ɵɵattribute("aria-label", ctx.Spa_Site_UploadLink_Text);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("saveDefaultValues", true);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "Spa_SOA_Title");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_SOA_ExplanatoryText");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("liveEditProp", "Spa_SOA_Activity_Title");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("activityCompletedFormText", ctx.Spa_SOA_Activity_CompleteForm_Text)("completedAgentText", ctx.Spa_SOA_Agent_Activity_CompletedText)("activityCloseFormText", ctx.Spa_SOA_Activity_CloseForm_Text)("startedText", ctx.Spa_SOA_Activity_StartedText)("uploadedText", ctx.Spa_SOA_Activity_UploadedFile_Text)("partialText", ctx.Spa_SOA_Activity_PartialText)("partialAgentText", ctx.Spa_SOA_Agent_Activity_PartialText)("noActivityText", ctx.Spa_SOA_Activity_NoSOAText)("textSentText", ctx.Spa_SOA_Activity_TextSentText)("confirmationText", ctx.Spa_EnrollmentHistory_Confirmation_Text)("agentStartedText", ctx.Spa_SOA_Agent_Activity_StartedText)("activities", ctx.soaActivities)("documents", ctx.documentList)("memberId", ctx.memberId)("viewText", ctx.Spa_SOA_ViewDocument_Text)("memberName", ctx.memberName)("memberPhone", ctx.memberPhoneNumber)("selectedActivity", ctx.selectedActivity)("pacificStandardTimeText", ctx.Spa_EnrollmentHistory_Pacific_StandardTime_Text)("shoppingRecordingEnabled", ctx.Spa_Site_AgentCallRecordingShopping_Enabled)("agentCallRecordingDisplayPlayAudioRecordingEnabled", ctx.Spa_SOA_AgentCallRecording_DisplayPlayAudioRecording_Enabled)("isAdmin", ctx.isAdmin);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.fileUploadErrors.length);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.Spa_SOA_Activity_ConsumerFormLink_Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_SOA_Activity_ConsumerFormByPhoneLink_Enabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("title", ctx.Spa_SOA_PdfForm_PrintLink_Text)("additionalIcon", "fas fa-print")("makeInlineBlock", true)("href", ctx.Spa_SOA_PdfForm_Url)("linkTarget", "_blank")("keyNameForLiveEdit", "Spa_SOA_PdfForm_PrintLink_Text");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_SOA_EnableFileUpload_Flag);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_SOA_RequireAuthCode_Enabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.Spa_Site_SOA_NextGen_Enabled)("ngIfElse", _r10);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.selectedActivity && !ctx.showConsumerFormSection);
    } }, dependencies: [i1$2.NgClass, i1$2.NgForOf, i1$2.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.NgForm, i4.FormControlDirective, NavigationBannerComponent, LinkComponent, NavigationAdapterDirective, LiveEditPropDirective, FormInputSubmitDirective, GoogleTagManagerDirective, IconAriaAttributesDirective, i8.MaskDirective, SoaAgentFormComponent, SOAActivityComponent, SOAConsumerFormComponent, NextGenSOAFormComponent, i1$2.AsyncPipe, SafePipe], styles: [".soa-wrapper[_ngcontent-%COMP%]{margin:32px auto}.email-button[_ngcontent-%COMP%], .phone-button[_ngcontent-%COMP%]{min-width:120px}.email-input[_ngcontent-%COMP%], .phone-input[_ngcontent-%COMP%]{padding-left:10px;padding-right:10px}.navigation-bar-wrapper[_ngcontent-%COMP%]{padding-left:15px;padding-right:15px}.email-input[_ngcontent-%COMP%], .phone-input[_ngcontent-%COMP%]{border-top-right-radius:0;border-bottom-right-radius:0}.email-button[_ngcontent-%COMP%], .phone-button[_ngcontent-%COMP%]{border-top-left-radius:0;border-bottom-left-radius:0}.darker-line[_ngcontent-%COMP%]{border-top-color:var(--static-Spa_Style_Accent1);border-top-width:2px}.link-wrapper[_ngcontent-%COMP%]{display:flex}.link-pipe[_ngcontent-%COMP%]{color:var(--static-Spa_Style_Accent1);margin:0 5px}@media (max-width: 769px){.email-input[_ngcontent-%COMP%], .phone-button[_ngcontent-%COMP%]{border-radius:5px}.email-button[_ngcontent-%COMP%], .phone-button[_ngcontent-%COMP%]{border-radius:.25rem}}"], changeDetection: 0 });
__decorate([
    PlatformProp('live-edit')
], SOAComponent.prototype, "Spa_SOA_SubmitBrokerForm_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], SOAComponent.prototype, "Spa_SOA_Title", void 0);
__decorate([
    PlatformProp('live-edit')
], SOAComponent.prototype, "Spa_SOA_ExplanatoryText", void 0);
__decorate([
    PlatformProp('live-edit')
], SOAComponent.prototype, "Spa_SOA_Activity_NoSOAText", void 0);
__decorate([
    PlatformProp('live-edit')
], SOAComponent.prototype, "Spa_SOA_EmailButton_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], SOAComponent.prototype, "Spa_SOA_Activity_Title", void 0);
__decorate([
    PlatformProp('live-edit')
], SOAComponent.prototype, "Spa_SOA_PdfForm_PrintLink_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], SOAComponent.prototype, "Spa_Site_UploadLink_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], SOAComponent.prototype, "Spa_Site_AddPreferences", void 0);
__decorate([
    PlatformProp('live-edit')
], SOAComponent.prototype, "Spa_Site_ContinueToPlanList", void 0);
__decorate([
    PlatformProp('live-edit')
], SOAComponent.prototype, "Spa_Site_Previous", void 0);
__decorate([
    PlatformProp('live-edit')
], SOAComponent.prototype, "Spa_SOA_Activity_ConsumerFormLink_Text", void 0);
__decorate([
    PlatformProp('live-edit')
], SOAComponent.prototype, "Spa_SOA_Activity_ConsumerFormByPhoneLink_Text", void 0);
__decorate([
    PlatformProp()
], SOAComponent.prototype, "Spa_EnrollmentHistory_Confirmation_Text", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_Activity_CompleteForm_Text", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_Activity_CloseForm_Text", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_Form_SubmitError_Text", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_Site_EmailAddress_Text", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_Site_PhoneNumber_Text", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_PhoneButton_Text", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_EmailInput_Error_RequiredField", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_EmailInput_Error_InvalidFormat", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_PhoneInput_Error_InvalidFormat", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_ConsumerEmail_Subject", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_ConsumerEmail_Image", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_ConsumerEmail_MobileImage", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_ConsumerEmail_Header", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_ConsumerEmail_Subheader", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_ConsumerEmail_Body", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_ConsumerEmail_From", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_ConsumerEmail_LinkText", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_Email_DoNotReplyText", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_Activity_StartedText", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_Activity_PartialText", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_Agent_Activity_PartialText", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_Agent_Activity_StartedText", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_Activity_TextSentText", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_Activity_UploadedFile_Text", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_EnableFileUpload_Flag", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_Activity_ConsumerFormLink_Enabled", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_Activity_ConsumerFormByPhoneLink_Enabled", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_PdfForm_Url", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_ViewDocument_Text", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_Member_Profile_ErrorMessages_TitleText", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOAFollowUpModal_Title_Text", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_ContinueForm_Text", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_Agent_Activity_CompletedText", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_Site_AgentCallRecordingShopping_Enabled", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_AgentCallRecording_DisplayPlayAudioRecording_Enabled", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_EnrollmentHistory_Pacific_StandardTime_Text", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_SOA_RequireAuthCode_Enabled", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_Site_SendSOA_Button_Text", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_Site_SOA_NextGen_Enabled", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_Site_UnableToProcessErrorsTitle_Text", void 0);
__decorate([
    GlobalResource()
], SOAComponent.prototype, "Spa_Site_UnableToProcessErrorsMessage_Text", void 0);
__decorate([
    LiveEditInactive()
], SOAComponent.prototype, "openUpload", null);
__decorate([
    LiveEditInactive()
], SOAComponent.prototype, "trackGtmPrintEvent", null);
__decorate([
    LiveEditInactive()
], SOAComponent.prototype, "openForm", null);
__decorate([
    LiveEditInactive()
], SOAComponent.prototype, "navigateToPageTag", null);
SOAComponent = __decorate([
    PlatformWidget
], SOAComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SOAComponent, [{
        type: Component,
        args: [{ selector: 'vnext-soa', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<input\r\n  #uploadInput\r\n  hidden\r\n  type=\"file\"\r\n  accept=\".pdf,.jpg,.gif,.png\"\r\n  [attr.aria-label]=\"Spa_Site_UploadLink_Text\"\r\n  (change)=\"fileChange($event.target.files)\"\r\n/>\r\n\r\n<div class=\"container soa-wrapper\" vnextGoogleTagManager [saveDefaultValues]=\"true\">\r\n  <div class=\"row\">\r\n    <div class=\"col-12 text-center Spa_Style_H1\">\r\n      <span *liveEditProp=\"'Spa_SOA_Title'\">{{ Spa_SOA_Title }}</span>\r\n    </div>\r\n    <div class=\"col-12 mt-4 Spa_Style_Primary_Color\">\r\n      <span\r\n        *liveEditProp=\"'Spa_SOA_ExplanatoryText'\"\r\n        [innerHtml]=\"Spa_SOA_ExplanatoryText ? (Spa_SOA_ExplanatoryText | safe : 'html') : ''\"\r\n        navigationAdapter\r\n      ></span>\r\n    </div>\r\n    <div class=\"col-12 mt-4 section-break Spa_Style_H2\">\r\n      <span *liveEditProp=\"'Spa_SOA_Activity_Title'\">{{ Spa_SOA_Activity_Title }}</span>\r\n      <hr class=\"mt-1 darker-line\" />\r\n    </div>\r\n  </div>\r\n  <div class=\"row soa-list-wrapper\">\r\n    <vnext-soa-activity\r\n      class=\"col-12\"\r\n      [activityCompletedFormText]=\"Spa_SOA_Activity_CompleteForm_Text\"\r\n      [completedAgentText]=\"Spa_SOA_Agent_Activity_CompletedText\"\r\n      [activityCloseFormText]=\"Spa_SOA_Activity_CloseForm_Text\"\r\n      [startedText]=\"Spa_SOA_Activity_StartedText\"\r\n      [uploadedText]=\"Spa_SOA_Activity_UploadedFile_Text\"\r\n      [partialText]=\"Spa_SOA_Activity_PartialText\"\r\n      [partialAgentText]=\"Spa_SOA_Agent_Activity_PartialText\"\r\n      [noActivityText]=\"Spa_SOA_Activity_NoSOAText\"\r\n      [textSentText]=\"Spa_SOA_Activity_TextSentText\"\r\n      [confirmationText]=\"Spa_EnrollmentHistory_Confirmation_Text\"\r\n      [agentStartedText]=\"Spa_SOA_Agent_Activity_StartedText\"\r\n      [activities]=\"soaActivities\"\r\n      [documents]=\"documentList\"\r\n      [memberId]=\"memberId\"\r\n      [viewText]=\"Spa_SOA_ViewDocument_Text\"\r\n      [memberName]=\"memberName\"\r\n      [memberPhone]=\"memberPhoneNumber\"\r\n      [selectedActivity]=\"selectedActivity\"\r\n      [pacificStandardTimeText]=\"Spa_EnrollmentHistory_Pacific_StandardTime_Text\"\r\n      [shoppingRecordingEnabled]=\"Spa_Site_AgentCallRecordingShopping_Enabled\"\r\n      [agentCallRecordingDisplayPlayAudioRecordingEnabled]=\"Spa_SOA_AgentCallRecording_DisplayPlayAudioRecording_Enabled\"\r\n      [isAdmin]=\"isAdmin\"\r\n      (completeFormClick)=\"openForm($event)\"\r\n    >\r\n    </vnext-soa-activity>\r\n  </div>\r\n  <div class=\"row justify-content-between flex-md-row-reverse mt-3\">\r\n    <div class=\"warn-color col-12\" *ngIf=\"fileUploadErrors.length\">\r\n      <div *ngFor=\"let error of fileUploadErrors\">\r\n        <i class=\"fas fa-exclamation-triangle mr-2\" aria-hidden=\"true\"></i> <span>{{ error }}</span>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-12\">\r\n      <hr />\r\n    </div>\r\n    <div class=\"col-12 col-md-6 text-left text-md-right\">\r\n      <div class=\"d-flex justify-content-end\">\r\n        <span *ngIf=\"Spa_SOA_Activity_ConsumerFormLink_Enabled\" class=\"link-wrapper upload-link-wrapper\">\r\n          <vnext-link\r\n            [title]=\"Spa_SOA_Activity_ConsumerFormLink_Text\"\r\n            (click)=\"openConsumerForm()\"\r\n            (keyup.enter)=\"openConsumerForm()\"\r\n            [additionalIcon]=\"'fas fa-file-alt'\"\r\n            [makeInlineBlock]=\"true\"\r\n            [keyNameForLiveEdit]=\"'Spa_SOA_Activity_ConsumerFormLink_Text'\"\r\n          ></vnext-link>\r\n          <span class=\"link-pipe\">|</span>\r\n        </span>\r\n        <span *ngIf=\"Spa_SOA_Activity_ConsumerFormByPhoneLink_Enabled\" class=\"link-wrapper upload-link-wrapper\">\r\n          <vnext-link\r\n            [title]=\"Spa_SOA_Activity_ConsumerFormByPhoneLink_Text\"\r\n            [additionalIcon]=\"'fas fa-phone'\"\r\n            [makeInlineBlock]=\"true\"\r\n            [keyNameForLiveEdit]=\"'Spa_SOA_Activity_ConsumerFormByPhoneLink_Text'\"\r\n            (click)=\"openConsumerForm(soaTransactionEventType.BY_PHONE)\"\r\n            (keyup.enter)=\"openConsumerForm(soaTransactionEventType.BY_PHONE)\"\r\n          ></vnext-link>\r\n          <span class=\"link-pipe\">|</span>\r\n        </span>\r\n        <span class=\"link-wrapper\">\r\n          <vnext-link\r\n            [title]=\"Spa_SOA_PdfForm_PrintLink_Text\"\r\n            [additionalIcon]=\"'fas fa-print'\"\r\n            [makeInlineBlock]=\"true\"\r\n            [href]=\"Spa_SOA_PdfForm_Url\"\r\n            [linkTarget]=\"'_blank'\"\r\n            (click)=\"trackGtmPrintEvent()\"\r\n            [keyNameForLiveEdit]=\"'Spa_SOA_PdfForm_PrintLink_Text'\"\r\n          ></vnext-link>\r\n        </span>\r\n        <span *ngIf=\"Spa_SOA_EnableFileUpload_Flag\" class=\"link-wrapper upload-link-wrapper\">\r\n          <span class=\"link-pipe\">|</span>\r\n          <vnext-link\r\n            [title]=\"Spa_Site_UploadLink_Text\"\r\n            (click)=\"openUpload()\"\r\n            (keyup.enter)=\"openUpload()\"\r\n            [additionalIcon]=\"'fas fa-upload'\"\r\n            [makeInlineBlock]=\"true\"\r\n            [keyNameForLiveEdit]=\"'Spa_Site_UploadLink_Text'\"\r\n          ></vnext-link>\r\n        </span>\r\n      </div>\r\n    </div>\r\n\r\n    <div *ngIf=\"Spa_SOA_RequireAuthCode_Enabled\" class=\"col-12 col-md-6\">\r\n      <button class=\"btn Spa_Style_PrimaryButton col-xs-12 col-md-auto mt-2 mt-md-0\" (click)=\"showSOAModal()\">\r\n        {{ Spa_Site_SendSOA_Button_Text }}\r\n      </button>\r\n    </div>\r\n\r\n    <ng-container *ngIf=\"Spa_Site_SOA_NextGen_Enabled; else hopeSOAForm\">\r\n      <nextgen-soa-form\r\n        class=\"w-100\"\r\n        [continueButtonText]=\"Spa_SOA_ContinueForm_Text\"\r\n        [continueButtonKeyText]=\"'Spa_SOA_ContinueForm_Text'\"\r\n        [submitButtonText]=\"Spa_SOA_SubmitBrokerForm_Text\"\r\n        [submitButtonKeyText]=\"'Spa_SOA_SubmitBrokerForm_Text'\"\r\n        [soaFormSubmitErrorText]=\"Spa_SOA_Form_SubmitError_Text\"\r\n        [memberProfileErrorMessagesTitleText]=\"Spa_Member_Profile_ErrorMessages_TitleText\"\r\n        [showConsumerForm]=\"showConsumerFormSection\"\r\n        [showNewConsumerForm]=\"showNewConsumerForm\"\r\n        [selectedActivity]=\"selectedActivity\"\r\n        [selectedSOATransactionType]=\"selectedSOATransactionType\"\r\n        [unableToProcessErrorsTitleText]=\"Spa_Site_UnableToProcessErrorsTitle_Text\"\r\n        [unableToProcessErrorsMessageText]=\"Spa_Site_UnableToProcessErrorsMessage_Text\"\r\n        (consumerFormSubmitted)=\"onConsumerFormSubmit($event)\"\r\n        (agentFormSubmitted)=\"onFormSubmit()\"\r\n        (setSelectedActivityById)=\"setSelectedActivityById($event)\"\r\n      ></nextgen-soa-form>\r\n    </ng-container>\r\n\r\n    <ng-template #hopeSOAForm>\r\n      <ng-container *ngIf=\"showConsumerFormSection; else showAgentForm\">\r\n        <vnext-soa-consumer-form\r\n          [submitButtonText]=\"Spa_SOA_ContinueForm_Text\"\r\n          [soaFormSubmitErrorText]=\"Spa_SOA_Form_SubmitError_Text\"\r\n          [memberProfileErrorMessagesTitleText]=\"Spa_Member_Profile_ErrorMessages_TitleText\"\r\n          [showNewConsumerForm]=\"showNewConsumerForm\"\r\n          [selectedActivity]=\"selectedActivity\"\r\n          [selectedSOATransactionType]=\"selectedSOATransactionType\"\r\n          (setSelectedActivityById)=\"setSelectedActivityById($event)\"\r\n          (formSubmitted)=\"onConsumerFormSubmit($event)\"\r\n        ></vnext-soa-consumer-form>\r\n      </ng-container>\r\n\r\n      <ng-template #showAgentForm>\r\n        <vnext-soa-agent-form\r\n          *ngIf=\"selectedActivity\"\r\n          [selectedActivity]=\"selectedActivity\"\r\n          [submitButtonKeyText]=\"'Spa_SOA_SubmitBrokerForm_Text'\"\r\n          [submitButtonText]=\"Spa_SOA_SubmitBrokerForm_Text\"\r\n          [soaFormSubmitErrorText]=\"Spa_SOA_Form_SubmitError_Text\"\r\n          [memberProfileErrorMessagesTitleText]=\"Spa_Member_Profile_ErrorMessages_TitleText\"\r\n          (formSubmitted)=\"onFormSubmit()\"\r\n        ></vnext-soa-agent-form>\r\n      </ng-template>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <ng-container *ngIf=\"!selectedActivity && !showConsumerFormSection\">\r\n    <ng-container *ngIf=\"!Spa_SOA_RequireAuthCode_Enabled\">\r\n      <div class=\"row mt-2\">\r\n        <div class=\"col-12 error-color\" *ngIf=\"showEmailError && emailAddressInput.invalid; else errorPlaceHolder\">\r\n          <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n          <span *ngIf=\"emailAddressInput.errors?.required || emailAddressInput.errors?.pattern\" role=\"alert\">\r\n            {{ Spa_SOA_EmailInput_Error_InvalidFormat }}</span\r\n          >\r\n        </div>\r\n        <ng-template #errorPlaceHolder>\r\n          <div class=\"col-12\">&nbsp;</div>\r\n        </ng-template>\r\n      </div>\r\n      <form disableKeyDownSubmit (ngSubmit)=\"sendSOAEmail()\" class=\"row email-wrapper no-gutters\">\r\n        <label\r\n          for=\"soa-email-input\"\r\n          class=\"col-12 Spa_Style_Label\"\r\n          [ngClass]=\"{ Spa_Style_Gray4_Color: ssoPopulatedFieldService.isFieldReadOnly$('Profile.PrimaryEmailAddress') | async }\"\r\n          >{{ Spa_Site_EmailAddress_Text }}</label\r\n        >\r\n        <input\r\n          id=\"soa-email-input\"\r\n          class=\"col-12 col-md-3 email-input\"\r\n          type=\"text\"\r\n          [formControl]=\"emailAddressInput\"\r\n          [ngClass]=\"{ 'Spa_Style_Gray4_Color readonly': ssoPopulatedFieldService.isFieldReadOnly$('Profile.PrimaryEmailAddress') | async }\"\r\n          [readonly]=\"ssoPopulatedFieldService.isFieldReadOnly$('Profile.PrimaryEmailAddress') | async\"\r\n          (focus)=\"showEmailError = false\"\r\n        />\r\n        <button\r\n          class=\"col-auto email-button mt-4 mt-md-0 btn Spa_Style_SecondaryButton\"\r\n          *liveEditProp=\"'Spa_SOA_EmailButton_Text'\"\r\n          type=\"submit\"\r\n        >\r\n          {{ Spa_SOA_EmailButton_Text }}\r\n        </button>\r\n      </form>\r\n      <ng-container *ngIf=\"textSOAEnabled\">\r\n        <div class=\"row mt-3\">\r\n          <div class=\"col-12 error-color\" *ngIf=\"showPhoneError && phoneNumberInput.invalid; else phoneErrorPlaceHolder\">\r\n            <i class=\"fas fa-exclamation-circle\" aria-hidden=\"true\"></i>\r\n            <span *ngIf=\"phoneNumberInput.errors?.required || phoneNumberInput.errors?.pattern\" role=\"alert\">\r\n              {{ Spa_SOA_PhoneInput_Error_InvalidFormat }}</span\r\n            >\r\n          </div>\r\n          <ng-template #phoneErrorPlaceHolder>\r\n            <div class=\"col-12\">&nbsp;</div>\r\n          </ng-template>\r\n        </div>\r\n        <form disableKeyDownSubmit (ngSubmit)=\"sendSOAText()\" class=\"row email-wrapper no-gutters\">\r\n          <label\r\n            for=\"soa-phone-text-input\"\r\n            class=\"col-12 Spa_Style_Label\"\r\n            [ngClass]=\"{ Spa_Style_Gray4_Color: ssoPopulatedFieldService.isFieldReadOnly$('Profile.HomePhone') | async }\"\r\n            >{{ Spa_Site_PhoneNumber_Text }}</label\r\n          >\r\n          <input\r\n            id=\"soa-phone-text-input\"\r\n            class=\"col-12 col-md-3 phone-input\"\r\n            type=\"text\"\r\n            [mask]=\"phoneMask\"\r\n            [formControl]=\"phoneNumberInput\"\r\n            [ngClass]=\"{ 'Spa_Style_Gray4_Color readonly': ssoPopulatedFieldService.isFieldReadOnly$('Profile.HomePhone') | async }\"\r\n            [readonly]=\"ssoPopulatedFieldService.isFieldReadOnly$('Profile.HomePhone') | async\"\r\n            (focus)=\"showPhoneError = false\"\r\n          />\r\n          <button class=\"col-auto phone-button mt-4 mt-md-0 btn Spa_Style_SecondaryButton\" type=\"submit\">\r\n            {{ Spa_SOA_PhoneButton_Text }}\r\n          </button>\r\n        </form>\r\n      </ng-container>\r\n    </ng-container>\r\n\r\n    <div class=\"row navigation-bar-wrapper\">\r\n      <vnext-navigation-banner [providedPrevious]=\"true\" [showPrevious]=\"true\" class=\"col-12\">\r\n        <div previous-link>\r\n          <vnext-link\r\n            [title]=\"Spa_Site_Previous\"\r\n            [showArrow]=\"'left'\"\r\n            (click)=\"configurableWidgetService.navigationService.backToPrevious()\"\r\n            (keyup.enter)=\"configurableWidgetService.navigationService.backToPrevious()\"\r\n            [makeInlineBlock]=\"true\"\r\n            *liveEditProp=\"'Spa_Site_Previous'\"\r\n          >\r\n          </vnext-link>\r\n        </div>\r\n        <div continue-button>\r\n          <button\r\n            class=\"btn Spa_Style_SecondaryButton col-xs-12 col-md-auto mr-md-2 mb-md-0 mb-2\"\r\n            (click)=\"navigateToPageTag(pageTags.GUIDED_HELP_GETTING_STARTED)\"\r\n            *liveEditProp=\"'Spa_Site_AddPreferences'\"\r\n          >\r\n            {{ Spa_Site_AddPreferences }}\r\n          </button>\r\n          <button\r\n            *liveEditProp=\"'Spa_Site_ContinueToPlanList'\"\r\n            class=\"btn Spa_Style_PrimaryButton col-xs-12 col-md-auto\"\r\n            (click)=\"navigateToPageTag(pageTags.PLAN_LIST)\"\r\n          >\r\n            {{ Spa_Site_ContinueToPlanList }}\r\n          </button>\r\n        </div>\r\n      </vnext-navigation-banner>\r\n    </div>\r\n  </ng-container>\r\n</div>\r\n", styles: [".soa-wrapper{margin:32px auto}.email-button,.phone-button{min-width:120px}.email-input,.phone-input{padding-left:10px;padding-right:10px}.navigation-bar-wrapper{padding-left:15px;padding-right:15px}.email-input,.phone-input{border-top-right-radius:0;border-bottom-right-radius:0}.email-button,.phone-button{border-top-left-radius:0;border-bottom-left-radius:0}.darker-line{border-top-color:var(--static-Spa_Style_Accent1);border-top-width:2px}.link-wrapper{display:flex}.link-pipe{color:var(--static-Spa_Style_Accent1);margin:0 5px}@media (max-width: 769px){.email-input,.phone-button{border-radius:5px}.email-button,.phone-button{border-radius:.25rem}}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1$1.NgbModal }, { type: AgentTaskFacade }, { type: i2.Store }, { type: i1.NavigationService }, { type: i1.GuidedHelpService }, { type: SOAFacade }, { type: i1.SOAService }, { type: i1.FormValidationService }, { type: i1.SpinnerService }, { type: AnalyticsService }, { type: i1.AgentService }, { type: i1.AgentPermissionsService }, { type: i1.SSOPopulatedFieldService }, { type: i1.ConfigResourceService }, { type: i1.SiteService }, { type: AgentSearchFacade }, { type: i1.MemberSessionService }, { type: i1.PhoneUtilityService }, { type: i1.ProfileService }]; }, { Spa_SOA_SubmitBrokerForm_Text: [], Spa_SOA_Title: [], Spa_SOA_ExplanatoryText: [], Spa_SOA_Activity_NoSOAText: [], Spa_SOA_EmailButton_Text: [], Spa_SOA_Activity_Title: [], Spa_SOA_PdfForm_PrintLink_Text: [], Spa_Site_UploadLink_Text: [], Spa_Site_AddPreferences: [], Spa_Site_ContinueToPlanList: [], Spa_Site_Previous: [], Spa_SOA_Activity_ConsumerFormLink_Text: [], Spa_SOA_Activity_ConsumerFormByPhoneLink_Text: [], Spa_EnrollmentHistory_Confirmation_Text: [], Spa_SOA_Activity_CompleteForm_Text: [], Spa_SOA_Activity_CloseForm_Text: [], Spa_SOA_Form_SubmitError_Text: [], Spa_Site_EmailAddress_Text: [], Spa_Site_PhoneNumber_Text: [], Spa_SOA_PhoneButton_Text: [], Spa_SOA_EmailInput_Error_RequiredField: [], Spa_SOA_EmailInput_Error_InvalidFormat: [], Spa_SOA_PhoneInput_Error_InvalidFormat: [], Spa_SOA_ConsumerEmail_Subject: [], Spa_SOA_ConsumerEmail_Image: [], Spa_SOA_ConsumerEmail_MobileImage: [], Spa_SOA_ConsumerEmail_Header: [], Spa_SOA_ConsumerEmail_Subheader: [], Spa_SOA_ConsumerEmail_Body: [], Spa_SOA_ConsumerEmail_From: [], Spa_SOA_ConsumerEmail_LinkText: [], Spa_SOA_Email_DoNotReplyText: [], Spa_SOA_Activity_StartedText: [], Spa_SOA_Activity_PartialText: [], Spa_SOA_Agent_Activity_PartialText: [], Spa_SOA_Agent_Activity_StartedText: [], Spa_SOA_Activity_TextSentText: [], Spa_SOA_Activity_UploadedFile_Text: [], Spa_SOA_EnableFileUpload_Flag: [], Spa_SOA_Activity_ConsumerFormLink_Enabled: [], Spa_SOA_Activity_ConsumerFormByPhoneLink_Enabled: [], Spa_SOA_PdfForm_Url: [], Spa_SOA_ViewDocument_Text: [], Spa_Member_Profile_ErrorMessages_TitleText: [], Spa_SOAFollowUpModal_Title_Text: [], Spa_SOA_ContinueForm_Text: [], Spa_SOA_Agent_Activity_CompletedText: [], Spa_Site_AgentCallRecordingShopping_Enabled: [], Spa_SOA_AgentCallRecording_DisplayPlayAudioRecording_Enabled: [], Spa_EnrollmentHistory_Pacific_StandardTime_Text: [], Spa_SOA_RequireAuthCode_Enabled: [], Spa_Site_SendSOA_Button_Text: [], Spa_Site_SOA_NextGen_Enabled: [], Spa_Site_UnableToProcessErrorsTitle_Text: [], Spa_Site_UnableToProcessErrorsMessage_Text: [], uploadInput: [{
            type: ViewChild,
            args: ['uploadInput']
        }], openUpload: [], trackGtmPrintEvent: [], openForm: [], navigateToPageTag: [] }); })();

function StandaloneFormConfirmationComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
    i0.ɵɵpipe(1, "safe");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r0.Spa_StandAloneForm_ConfirmationMessageText, "html"), i0.ɵɵsanitizeHtml);
} }
let StandaloneFormConfirmationComponent = class StandaloneFormConfirmationComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.Spa_StandAloneForm_ConfirmationMessageText = '<br><center><h3>Your generic form is complete.</h3>\r\n<h5>Enrollment confirmation number: {{getConfirmationNumber()}}</h5></center>';
    }
    ngOnInit() {
        super.ngOnInit();
    }
};
StandaloneFormConfirmationComponent.ɵfac = function StandaloneFormConfirmationComponent_Factory(t) { return new (t || StandaloneFormConfirmationComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService)); };
StandaloneFormConfirmationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StandaloneFormConfirmationComponent, selectors: [["vnext-standalone-form-confirmation"]], features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 1, consts: [[1, "container"], [1, "row"], [1, "col-12", "text-center"], ["class", "page-title Spa_Style_H1 Spa_Style_Primary_Color Spa_Style_Bold_Weight", 3, "innerHTML", 4, "liveEditProp"], [1, "page-title", "Spa_Style_H1", "Spa_Style_Primary_Color", "Spa_Style_Bold_Weight", 3, "innerHTML"]], template: function StandaloneFormConfirmationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, StandaloneFormConfirmationComponent_div_3_Template, 2, 4, "div", 3);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("liveEditProp", "Spa_StandAloneForm_ConfirmationMessageText");
    } }, dependencies: [LiveEditPropDirective, SafePipe], styles: [".page-title[_ngcontent-%COMP%]{margin-top:60px}"], changeDetection: 0 });
__decorate([
    PlatformProp('live-edit')
], StandaloneFormConfirmationComponent.prototype, "Spa_StandAloneForm_ConfirmationMessageText", void 0);
StandaloneFormConfirmationComponent = __decorate([
    PlatformWidget
], StandaloneFormConfirmationComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StandaloneFormConfirmationComponent, [{
        type: Component,
        args: [{ selector: 'vnext-standalone-form-confirmation', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-12 text-center\">\r\n      <div\r\n        class=\"page-title Spa_Style_H1 Spa_Style_Primary_Color Spa_Style_Bold_Weight\"\r\n        *liveEditProp=\"'Spa_StandAloneForm_ConfirmationMessageText'\"\r\n        [innerHTML]=\"Spa_StandAloneForm_ConfirmationMessageText | safe : 'html'\"\r\n      ></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".page-title{margin-top:60px}\n"] }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }]; }, { Spa_StandAloneForm_ConfirmationMessageText: [] }); })();

class StandaloneFormFacade {
    constructor(router, standaloneFormService, enrollmentFormService, configResourceService, globalFacade, localeService, formRootService) {
        this.router = router;
        this.standaloneFormService = standaloneFormService;
        this.enrollmentFormService = enrollmentFormService;
        this.configResourceService = configResourceService;
        this.globalFacade = globalFacade;
        this.localeService = localeService;
        this.formRootService = formRootService;
    }
    getActiveEnrollmentKey() {
        return this.standaloneFormService.getActiveEnrollmentKey();
    }
    getTransactionId(formId) {
        return this.standaloneFormService.getTransactionId(formId);
    }
    getTransaction(formId) {
        return this.standaloneFormService.getTransaction(formId);
    }
    getCurrentLocale$() {
        return this.localeService.getCurrentLocale$();
    }
    getFormLoading$(formId) {
        return this.standaloneFormService.getFormLoading$(formId);
    }
    setFormLoading$(formId, loading) {
        return this.standaloneFormService.setFormLoading$(formId, loading);
    }
    setFormTitle(formTitle) {
        this.standaloneFormService.setFormTitle(formTitle);
    }
    getSubmitText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Submit', widgetName, 'Submit');
    }
    getPreviousText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Previous', widgetName, 'Previous');
    }
    getNextText(widgetName) {
        return this.configResourceService.getProcessedResourceValue('Spa_Site_Next', widgetName, 'Next');
    }
    closeTooltip(tooltip, wait) {
        this.globalFacade.closeTooltip(tooltip, wait);
    }
    getFormType(formId) {
        return this.standaloneFormService.getFormType(formId);
    }
    getStandaloneFormBaseUrl(path) {
        return this.standaloneFormService.getStandaloneFormBaseUrl(path);
    }
    isAncillaryFormPage(path) {
        return this.standaloneFormService.isAncillaryFormPage(path);
    }
    observeForNavigationEvent$() {
        return this.enrollmentFormService.observeForNavigationEvent$();
    }
    updateTransaction$(answers, formId) {
        return this.standaloneFormService.updateTransaction$(answers, formId);
    }
    async completeEnrollment(answers, formId, isHRA) {
        await this.standaloneFormService.completeEnrollment(answers, formId, isHRA);
    }
    getEnrollmentErrorNoticeTitle(widgetName) {
        return this.formRootService.getEnrollmentErrorNoticeTitle(widgetName);
    }
    fetchTransaction$(sessionId, formId, transactionId) {
        return this.enrollmentFormService.fetchNextGenTransaction$(sessionId, formId, transactionId);
    }
    async validateEnrollment(payload, validationType) {
        return await this.enrollmentFormService.nextGenValidateEnrollment(payload, validationType);
    }
    async checkMemberEligibility(payload) {
        return await this.enrollmentFormService.nextGenCheckMemberEligibility(payload);
    }
    findFirstFocusableInput(answers, document) {
        return this.formRootService.findFirstFocusableInput(answers, document);
    }
    convertEnrollmentCallbackMapToJSON() {
        return this.formRootService.convertEnrollmentCallbackMapToJSON();
    }
    async saveFormAnswers(formId, answers) {
        const nextGenAnswers = this.updateAnswerDateFormat(answers);
        await this.enrollmentFormService.updateNextGenTransaction$(nextGenAnswers, formId).toPromise();
    }
    navigateTo(pageName) {
        const formBaseUrl = this.standaloneFormService.getStandaloneFormBaseUrl();
        if (formBaseUrl && pageName) {
            this.router.navigate([formBaseUrl, pageName]);
        }
    }
    clearPrefillData(enrollmentKey, event, childForms) {
        const { mergedFieldsToUpdate, transactionFields } = this.enrollmentFormService.getFieldsToClearPrefillData(event, childForms);
        if (mergedFieldsToUpdate?.length && !_isEqual(mergedFieldsToUpdate, transactionFields)) {
            this.updateTransaction$(mergedFieldsToUpdate, enrollmentKey);
        }
    }
    updateAnswerDateFormat(answers) {
        answers.forEach(answer => {
            if (DateUtilities.isValidFormat(answer.value, DateUtilities.defaultDateISOFormat)) {
                answer.value = DateUtilities.convertDateFormat(answer.value);
            }
        });
        return answers;
    }
}
StandaloneFormFacade.ɵfac = function StandaloneFormFacade_Factory(t) { return new (t || StandaloneFormFacade)(i0.ɵɵinject(i2$1.Router), i0.ɵɵinject(i1.StandaloneFormService), i0.ɵɵinject(i1.EnrollmentFormService), i0.ɵɵinject(i1.ConfigResourceService), i0.ɵɵinject(GlobalFacade), i0.ɵɵinject(i1.LocaleService), i0.ɵɵinject(FormRootService)); };
StandaloneFormFacade.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: StandaloneFormFacade, factory: StandaloneFormFacade.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StandaloneFormFacade, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i2$1.Router }, { type: i1.StandaloneFormService }, { type: i1.EnrollmentFormService }, { type: i1.ConfigResourceService }, { type: GlobalFacade }, { type: i1.LocaleService }, { type: FormRootService }]; }, null); })();

let StandaloneFormComponent = class StandaloneFormComponent extends ConfigurableWidget {
    constructor(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService, spinnerService, activatedRoute, viewContainer, authService, navigationService, enrollmentFormErrorsContext, standaloneFormService, standaloneFormFacade, addressService, formPagesMetadataContext, formRootService, formRootStrategyService, groupValidatorContextService) {
        super(cdr, widgetValidationService, configurableWidgetService, zoneService, widgetService);
        this.cdr = cdr;
        this.widgetValidationService = widgetValidationService;
        this.configurableWidgetService = configurableWidgetService;
        this.zoneService = zoneService;
        this.widgetService = widgetService;
        this.spinnerService = spinnerService;
        this.activatedRoute = activatedRoute;
        this.viewContainer = viewContainer;
        this.authService = authService;
        this.navigationService = navigationService;
        this.enrollmentFormErrorsContext = enrollmentFormErrorsContext;
        this.standaloneFormService = standaloneFormService;
        this.standaloneFormFacade = standaloneFormFacade;
        this.addressService = addressService;
        this.formPagesMetadataContext = formPagesMetadataContext;
        this.formRootService = formRootService;
        this.formRootStrategyService = formRootStrategyService;
        this.groupValidatorContextService = groupValidatorContextService;
        this.Spa_Site_Submit = 'Submit';
        this.Spa_Site_Previous = 'Previous';
        this.Spa_Site_Next = 'Next';
        this.Spa_Site_UnableToProcessErrorsTitle_Text = 'Unable to Process Application';
        this.Spa_Site_UnableToProcessErrorsMessage_Text = 'We are unable to process your application at this time. Contact your administrator for assistance.';
        this.subscriptions = new Subscription();
        this.surveyInitialized = false;
        this.nextGenFormQuestionNames = [];
        this.requestSubmitSubject$ = new Subject();
        this.requestSubmit$ = this.requestSubmitSubject$.asObservable();
    }
    onSurveyBeforeViewInitialized(event) {
        this.spinnerService.show(SpinnerEvent.INITIALIZE_SURVEY_VIEW);
    }
    onSurveyAfterViewInitialized(event) {
        this.surveyInitialized = true;
        this.spinnerService.hide(SpinnerEvent.INITIALIZE_SURVEY_VIEW);
    }
    onSurveyAfterPageRendered(event) {
        setTimeout(() => {
            const answers = _get(event, 'detail.answers');
            const inputElement = this.standaloneFormFacade.findFirstFocusableInput(answers, document);
            if (inputElement) {
                inputElement.focus();
            }
        }, 0);
    }
    clearFormErrors(event) {
        this.enrollmentFormErrorsContext.clearFormErrors();
    }
    setFormPageInfo(event) {
        // There's also currently a pageCount val in here we aren't using
        const formInfo = _get(event, 'detail.formInfo');
        this.standaloneFormFacade.setFormTitle(formInfo.formMetaData.formTitle);
        this.formPagesMetadataContext.setFormPagesMetadata(formInfo, this.getPageLevelValidationConfigurations());
    }
    setFormPageErrors(event) {
        const pageErrors = _get(event, 'detail.pageErrors');
        const scroll = _get(event, 'detail.scroll');
        if (pageErrors?.length) {
            this.addErrorsAndScroll({
                title: this.formRootService.getEnrollmentErrorNoticeTitle(),
                messages: pageErrors.map(pageError => ({ message: pageError?.message, severity: 'error' }))
            }, scroll);
        }
        else {
            this.enrollmentFormErrorsContext.clearFormErrors();
        }
    }
    async nextgenAutocompleteAddress(event) {
        const autocompletePayload = _get(event, 'detail');
        const { questionName, partial, zip, selected } = autocompletePayload;
        try {
            const addressList = await this.addressService.callAPIForData(partial, zip, selected);
            this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ADDRESS_AUTOCOMPLETE_RESPONSE, {
                questionName,
                addressList
            });
        }
        catch (error) {
            this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ADDRESS_AUTOCOMPLETE_ERROR_RESPONSE, { questionName, error });
        }
    }
    /**
     * This event gets fired by the PC1 - Spa.Net Host aka "Host layer" code, drx.enrollment.callback.js
     * If we need additional changes to when/how this is fired, we would need to work with John Stanely to update that.
     * That code then was originally designed to cooperate with the HOPE bundle code to update specific fields on the host layer side.
     * This event and its work is intended to move as much of the existing logic into a position for us to manipulate it freely here
     * instead of in other layers.
     */
    updateViAQueryParams(event) {
        const xmlAsJSON = this.standaloneFormFacade.convertEnrollmentCallbackMapToJSON();
        // xmlAsJSON should be an object such as {'Provider_Name':'"PrimaryCarePhysician"}
        // This maps the names we use in the queryParams to the values we actually use as field names.
        const queryParams = _get(event, 'detail');
        // queryParams should be an object such as {'Provider_Name':'BRUCE+W.+DENNIS'}
        const answers = [];
        Object.keys(queryParams).forEach(keyName => {
            const name = xmlAsJSON[keyName];
            if (name) {
                const value = queryParams[keyName]?.replaceAll('+', ' ') ?? '';
                answers.push({ name, value });
            }
        });
        this.updateFormAnswers(answers);
    }
    nextGenNavigateToPageName(event) {
        const pageName = _get(event, 'detail.pageName');
        if (pageName && (!this.pageName || this.pageName !== pageName)) {
            this.standaloneFormFacade.navigateTo(pageName);
        }
    }
    ngOnInit() {
        super.ngOnInit();
        this.formRootStrategyService.setStrategy(NextGenBundleFormRootStrategy);
        this.environment = EnvironmentService.getEnvironment();
        this.enrollingFormId = this.standaloneFormFacade.getActiveEnrollmentKey();
        this.pageName$ = this.activatedRoute.params.pipe(pluck('pageName'), distinctUntilChanged(), shareReplay(1));
        this.isFormLoading$ = this.standaloneFormFacade.getFormLoading$(this.enrollingFormId).pipe(distinctUntilChanged(), shareReplay(1));
        this.initializeSubscriptions(this.environment.liveedit);
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        super.ngOnDestroy();
    }
    back() {
        this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ENROLLMENT_BACK);
    }
    getCurrentIndex() {
        return this.formRootStrategyService.getCurrentIndex(this.enrollingFormId);
    }
    async next() {
        const nextGenPageErrors = await this.getNextGenPageErrors();
        if (nextGenPageErrors?.length) {
            this.addNextGenErrorsAndScroll(nextGenPageErrors);
        }
        else {
            this.continueToNext();
        }
    }
    onSubmit(tooltip) {
        this.requestSubmit();
    }
    handleSubmit$() {
        return from(this.handleSubmit());
    }
    async submit() {
        const nextGenFormErrors = await this.getNextGenFormErrors();
        if (nextGenFormErrors?.length) {
            this.spinnerService.hide(SpinnerEvent.ENROLLMENT_LOADING);
            this.addNextGenErrorsAndScroll(nextGenFormErrors);
        }
        else {
            await this.nextGenSubmitEvent();
        }
    }
    async nextGenSubmitEvent() {
        if (!this.authService.isCurrentTokenValid()) {
            await this.authService.loadJWT();
        }
        const pageIndex = this.getCurrentIndex();
        const currentPageAnswers = this.retrieveFormAnswers(this.childForms);
        const allAnswers = this.retrieveAllFormAnswers(this.childForms);
        //
        const validationResults = await this.formRootStrategyService.runPageLevelValidations(allAnswers, pageIndex);
        const canContinueToSubmit = !!validationResults?.every(result => !!result?.isValid);
        if (canContinueToSubmit) {
            await this.standaloneFormFacade.saveFormAnswers(this.enrollingFormId, currentPageAnswers);
            try {
                await this.completeEnrollment(allAnswers, this.enrollingFormId);
                // TODO: create custom complete event
                // this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ENROLLMENT_NEXT);
            }
            catch (error) {
                this.standaloneFormFacade.setFormLoading$(this.enrollingFormId, false);
                this.spinnerService.hide(SpinnerEvent.ENROLLMENT_LOADING);
                await this.handleCompleteEnrollmentErrors(error);
            }
        }
        else {
            const continueText = validationResults?.find(result => result?.type === PageLevelValidatorType.EligibilityCheck)?.continueText;
            this.addErrorsAndScroll({
                title: this.formRootService.getEnrollmentErrorNoticeTitle(),
                messages: this.formatPageLevelValidationErrors(validationResults),
                ...(continueText && { continueText })
            });
        }
    }
    async completeEnrollment(answers, formId) {
        await this.standaloneFormFacade
            .completeEnrollment(answers, formId)
            .then(() => {
            this.formRootService.processNextGenTransactionResponse(this.standaloneFormFacade.getTransaction(formId), () => {
                this.spinnerService.hide(SpinnerEvent.SUBMITTED_FORM_LOADING);
                this.navigationService.navigateByPageTag(this.Spa_StandaloneForm_RedirectTag);
            });
        })
            .catch(error => {
            throw error;
        })
            .finally(() => {
            this.spinnerService.hide(SpinnerEvent.ENROLLMENT_LOADING);
        });
    }
    async getNextGenPageErrors() {
        const element = this.viewContainer.element.nativeElement;
        return await new Promise((resolve, reject) => {
            const listener = (responseEvent) => {
                const responseData = responseEvent.detail.pageErrors;
                resolve(responseData);
            };
            element.addEventListener(NextGenEnrollmentEvents.REQUEST_PAGE_ERRORS_RESPONSE, listener, { once: true });
            const myCustomEvent = new CustomEvent(NextGenEnrollmentEvents.REQUEST_PAGE_ERRORS, { bubbles: true });
            element.dispatchEvent(myCustomEvent);
            setTimeout(() => {
                element.removeEventListener(NextGenEnrollmentEvents.REQUEST_PAGE_ERRORS_RESPONSE, listener);
                reject(new Error('Unable to retrieve errors from enrollment form'));
            }, 2000);
        });
    }
    async getNextGenFormErrors() {
        const element = this.viewContainer.element.nativeElement;
        return await new Promise((resolve, reject) => {
            const listener = (responseEvent) => {
                const responseData = responseEvent.detail.pageErrors;
                resolve(responseData);
            };
            element.addEventListener(NextGenEnrollmentEvents.REQUEST_FORM_ERRORS_RESPONSE, listener, { once: true });
            const myCustomEvent = new CustomEvent(NextGenEnrollmentEvents.REQUEST_FORM_ERRORS, { bubbles: true });
            element.dispatchEvent(myCustomEvent);
            setTimeout(() => {
                element.removeEventListener(NextGenEnrollmentEvents.REQUEST_FORM_ERRORS_RESPONSE, listener);
                reject(new Error('Unable to retrieve errors from enrollment form'));
            }, 2000);
        });
    }
    showNext() {
        const pageName = this.getCurrentPageName();
        const formPages = this.getFormPages(this.enrollingFormId);
        return formPages?.length && !this.isLastPage(pageName);
    }
    getFormPages(enrollingFormId) {
        return this.formRootStrategyService.getFormPages(enrollingFormId);
    }
    showBack() {
        const pageName = this.getCurrentPageName();
        return !this.isFirstPage(pageName);
    }
    showSubmit() {
        const pageName = this.getCurrentPageName();
        return this.isLastPage(pageName);
    }
    closeEnrollmentTooltip(toolTip) {
        this.standaloneFormFacade.closeTooltip(toolTip);
    }
    initializeSubscriptions(liveEdit = false) {
        if (!liveEdit) {
            this.subscriptions.add(fromEvent(document, `${NextGenEnrollmentEvents.CLEAR_PREFILL_DATA}`)
                .pipe(distinctUntilChanged((prev, curr) => {
                return !(prev.detail.timeStamp + 200 < curr.detail.timeStamp ||
                    !_isEqual(prev.detail.clearedPrefillDataFields, curr.detail.clearedPrefillDataFields));
            }))
                .subscribe({
                next: event => {
                    this.standaloneFormFacade.clearPrefillData(this.enrollingFormId, event, this.childForms);
                }
            }));
            this.subscriptions.add(this.pageName$.subscribe({
                next: pageName => {
                    this.pageName = pageName;
                    this.cdr.markForCheck();
                }
            }));
            // Subscribe to loading
            this.subscriptions.add(this.isFormLoading$.subscribe({
                next: isFormLoading => {
                    if (isFormLoading) {
                        this.spinnerService.show(SpinnerEvent.STANDALONE_FORM_LOADING);
                    }
                    else {
                        this.spinnerService.hide(SpinnerEvent.STANDALONE_FORM_LOADING);
                        // this.updateTags();
                    }
                }
            }));
            this.subscriptions.add(this.standaloneFormFacade
                .getCurrentLocale$()
                .pipe(withLatestFrom(this.pageName$))
                .subscribe({
                next: ([locale, pageName]) => {
                    this.locale = locale;
                    if (pageName) {
                        this.enrollmentFormErrorsContext.clearFormErrors();
                    }
                    this.setLocalizedText();
                }
            }));
            this.subscriptions.add(this.standaloneFormService.fetchFormVersionInfo$(this.enrollingFormId).subscribe({
                next: formVersionInfo => {
                    this.formVersionInfo = formVersionInfo;
                    this.cdr.markForCheck();
                }
            }));
            this.subscriptions.add(this.requestSubmit$.pipe(exhaustMap(() => this.handleSubmit$())).subscribe({
                next: () => {
                    this.cdr.markForCheck();
                }
            }));
        }
    }
    setLocalizedText() {
        this.previousText = this.standaloneFormFacade.getPreviousText(this.widgetName);
        this.nextText = this.standaloneFormFacade.getNextText(this.widgetName);
        this.submitText = this.standaloneFormFacade.getSubmitText(this.widgetName);
    }
    requestSubmit() {
        this.requestSubmitSubject$.next(null);
    }
    async handleSubmit() {
        this.spinnerService.show(SpinnerEvent.SUBMITTED_FORM_LOADING);
        await this.submit();
    }
    getCurrentPageName() {
        return this.formRootStrategyService.getCurrentPageName();
    }
    isFirstPage(pageName) {
        return this.formRootStrategyService.isFirstPage(pageName, this.enrollingFormId);
    }
    isLastPage(pageName) {
        return this.formRootStrategyService.isLastPage(pageName, this.enrollingFormId);
    }
    getPageLevelValidationConfigurations() {
        return {
            [PageLevelValidatorType.EligibilityCheck]: {
                asyncValidation: async (payload) => await this.standaloneFormFacade.checkMemberEligibility(payload),
                dispatchEvent: (details) => {
                    this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ADD_PAGE_LEVEL_ERROR_TO_QUESTION, details);
                }
            },
            [PageLevelValidatorType.StateAndZip]: {
                asyncValidation: async (payload, validationType) => await this.standaloneFormFacade.validateEnrollment(payload, validationType),
                dispatchEvent: (details) => {
                    this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ADD_PAGE_LEVEL_ERROR_TO_QUESTION, details);
                }
            },
            [PageLevelValidatorType.Group]: {
                asyncValidation: async (conditionExpression, errorMessage) => await this.groupValidatorContextService.nextGenValidateGroup(conditionExpression, this.viewContainer.element.nativeElement, NextGenEnrollmentEvents.VALIDATE_GROUP_RESPONSE, () => {
                    this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.VALIDATE_GROUP, {
                        validatorType: PageLevelValidatorType.Group,
                        expression: conditionExpression,
                        errorMessage
                    });
                }),
                dispatchEvent: (details) => {
                    this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ADD_PAGE_LEVEL_ERROR_TO_QUESTION, details);
                }
            }
        };
    }
    retrieveFormAnswers(childForms) {
        const inputValues = childForms?.first?.retrieveFormInputValues();
        return this.formRootService.convertFormInputValuesToAnswers(inputValues);
    }
    retrieveAllFormAnswers(childForms) {
        const inputValues = childForms?.first?.retrieveAllFormInputValues();
        return this.formRootService.convertFormInputValuesToAnswers(inputValues);
    }
    updateFormAnswers(answers) {
        this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.SET_FORM_FIELD, {
            fields: answers.map(answer => ({ name: answer.name, value: answer.value }))
        });
    }
    async continueToNext() {
        if (!this.authService.isCurrentTokenValid()) {
            await this.authService.loadJWT();
        }
        const pageIndex = this.getCurrentIndex();
        const currentPageAnswers = this.retrieveFormAnswers(this.childForms);
        try {
            const allAnswers = this.retrieveAllFormAnswers(this.childForms);
            this.spinnerService.show(SpinnerEvent.ENROLLMENT_LOADING);
            const validationResults = await this.formRootStrategyService.runPageLevelValidations(allAnswers, pageIndex);
            const canContinueToNextPage = !!validationResults?.every(result => !!result?.isValid);
            if (canContinueToNextPage) {
                await this.standaloneFormFacade.saveFormAnswers(this.enrollingFormId, currentPageAnswers);
                this.formRootStrategyService.dispatchEvent(this.viewContainer.element.nativeElement, CustomEventType.ENROLLMENT_NEXT);
            }
            else {
                const continueText = validationResults?.find(result => result?.type === PageLevelValidatorType.EligibilityCheck)?.continueText;
                this.addErrorsAndScroll({
                    title: this.formRootService.getEnrollmentErrorNoticeTitle(),
                    messages: this.formatPageLevelValidationErrors(validationResults),
                    ...(continueText && { continueText })
                });
            }
        }
        finally {
            this.spinnerService.hide(SpinnerEvent.ENROLLMENT_LOADING);
        }
    }
    async handleCompleteEnrollmentErrors(error) {
        if (error) {
            const errorStatus = error.status;
            const innerError = error.error;
            let errorMessages = [];
            let title = this.standaloneFormFacade.getEnrollmentErrorNoticeTitle();
            if (errorStatus && innerError) {
                if (errorStatus === HttpStatusCode.BAD_REQUEST && innerError?.AdditionalInfo) {
                    errorMessages = Object.keys(innerError.AdditionalInfo).reduce((errors, errorKey) => {
                        const errorMessage = innerError.AdditionalInfo[errorKey];
                        if (errorMessage) {
                            errors.push({ message: errorMessage });
                        }
                        return errors;
                    }, []);
                }
                else if (errorStatus === HttpStatusCode.INTERNAL_SERVER_ERROR) {
                    title = this.Spa_Site_UnableToProcessErrorsTitle_Text;
                    errorMessages = [
                        { message: this.Spa_Site_UnableToProcessErrorsMessage_Text, severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER }
                    ];
                }
                else {
                    title = this.Spa_Site_UnableToProcessErrorsTitle_Text;
                    errorMessages = [
                        { message: this.Spa_Site_UnableToProcessErrorsMessage_Text, severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER }
                    ];
                }
            }
            let errors = {
                title,
                messages: errorMessages.length
                    ? errorMessages
                    : [{ message: error.message, severity: NOTICE_TYPE.ERROR, source: MESSAGE_SOURCE.SERVER }]
            };
            // errors won't display if no severity is sent back
            // API should do this but we will code defensively here
            if (errorMessages.every(errorMessage => !errorMessage.severity)) {
                errorMessages = errorMessages.map(errorMessage => ({ ...errorMessage, severity: NOTICE_TYPE.ERROR }));
                errors = { ...errors, messages: errorMessages };
            }
            this.addErrorsAndScroll(errors);
        }
    }
    addNextGenErrorsAndScroll(nextGenErrors) {
        this.addErrorsAndScroll({
            title: this.standaloneFormFacade.getEnrollmentErrorNoticeTitle(),
            messages: nextGenErrors.map(pageError => ({
                message: pageError?.message,
                severity: NOTICE_TYPE.ERROR,
                source: MESSAGE_SOURCE.CLIENT
            }))
        });
    }
    addErrorsAndScroll(errors, scroll = true) {
        this.enrollmentFormErrorsContext.addErrors(errors);
        this.enrollmentFormErrorsContext
            .observeForFormErrors$()
            .pipe(take(1))
            .subscribe({
            next: () => {
                if (scroll) {
                    this.enrollmentFormErrorsContext.scrollToErrors();
                }
            }
        });
    }
    formatPageLevelValidationErrors(validationResults) {
        return (validationResults?.reduce((noticeMessages, validationResult) => {
            if (!validationResult.isValid) {
                noticeMessages.push({
                    message: validationResult.errorMessage,
                    severity: validationResult.severity,
                    source: MESSAGE_SOURCE.CLIENT
                });
            }
            return noticeMessages;
        }, []) ?? []);
    }
};
StandaloneFormComponent.ɵfac = function StandaloneFormComponent_Factory(t) { return new (t || StandaloneFormComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(ConfigurableWidgetService), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(WidgetService), i0.ɵɵdirectiveInject(i1.SpinnerService), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i1.AuthService), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i1.EnrollmentFormErrorsContext), i0.ɵɵdirectiveInject(i1.StandaloneFormService), i0.ɵɵdirectiveInject(StandaloneFormFacade), i0.ɵɵdirectiveInject(i1.AddressService), i0.ɵɵdirectiveInject(i1.FormPagesMetadataContext), i0.ɵɵdirectiveInject(FormRootService), i0.ɵɵdirectiveInject(FormRootStrategyService), i0.ɵɵdirectiveInject(i1.GroupValidatorContextService)); };
StandaloneFormComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StandaloneFormComponent, selectors: [["vnext-standalone-form"]], viewQuery: function StandaloneFormComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(NextGenEnrollmentFormRendererComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childForms = _t);
    } }, hostBindings: function StandaloneFormComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("NextGenForm_Before_Survey_View_Initialization", function StandaloneFormComponent_NextGenForm_Before_Survey_View_Initialization_HostBindingHandler($event) { return ctx.onSurveyBeforeViewInitialized($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_After_Survey_View_Initialization", function StandaloneFormComponent_NextGenForm_After_Survey_View_Initialization_HostBindingHandler($event) { return ctx.onSurveyAfterViewInitialized($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_On_After_Page_Rendered", function StandaloneFormComponent_NextGenForm_On_After_Page_Rendered_HostBindingHandler($event) { return ctx.onSurveyAfterPageRendered($event); }, false, i0.ɵɵresolveDocument)("NextGenFormClientEvent_Navigate_To_Previous_Page", function StandaloneFormComponent_NextGenFormClientEvent_Navigate_To_Previous_Page_HostBindingHandler($event) { return ctx.clearFormErrors($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_Emit_FormInfo", function StandaloneFormComponent_NextGenForm_Emit_FormInfo_HostBindingHandler($event) { return ctx.setFormPageInfo($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_Emit_PageErrors", function StandaloneFormComponent_NextGenForm_Emit_PageErrors_HostBindingHandler($event) { return ctx.setFormPageErrors($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_Address_Autocomplete_Request", function StandaloneFormComponent_NextGenForm_Address_Autocomplete_Request_HostBindingHandler($event) { return ctx.nextgenAutocompleteAddress($event); }, false, i0.ɵɵresolveDocument)("NextGenForm_Update_Via_Query_Params_Event", function StandaloneFormComponent_NextGenForm_Update_Via_Query_Params_Event_HostBindingHandler($event) { return ctx.updateViAQueryParams($event); })("NextGenForm_Enrollment_Go_To_Page", function StandaloneFormComponent_NextGenForm_Enrollment_Go_To_Page_HostBindingHandler($event) { return ctx.nextGenNavigateToPageName($event); }, false, i0.ɵɵresolveDocument);
    } }, features: [i0.ɵɵProvidersFeature([WidgetService]), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 11, consts: [[1, "px-3"], [3, "formId", "formVersion", "formVersionId", "surveyInitialized"], [3, "showNext", "showSubmit", "showPrevious", "showSendApplicationEmail", "previousButtonText", "nextButtonText", "submitButtonText", "sendApplicationButtonText", "enrollSubmitTooltipText", "backEvent", "nextEvent", "submitEvent", "closeTooltipEvent"]], template: function StandaloneFormComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "nextgen-enrollment-form-renderer", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "vnext-enrollment-form-navigation", 2);
        i0.ɵɵlistener("backEvent", function StandaloneFormComponent_Template_vnext_enrollment_form_navigation_backEvent_2_listener() { return ctx.back(); })("nextEvent", function StandaloneFormComponent_Template_vnext_enrollment_form_navigation_nextEvent_2_listener() { return ctx.next(); })("submitEvent", function StandaloneFormComponent_Template_vnext_enrollment_form_navigation_submitEvent_2_listener($event) { return ctx.onSubmit($event); })("closeTooltipEvent", function StandaloneFormComponent_Template_vnext_enrollment_form_navigation_closeTooltipEvent_2_listener($event) { return ctx.closeEnrollmentTooltip($event); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formId", ctx.enrollingFormId)("formVersion", ctx.formVersionInfo == null ? null : ctx.formVersionInfo.formVersion)("formVersionId", ctx.formVersionInfo == null ? null : ctx.formVersionInfo.formVersionId)("surveyInitialized", ctx.surveyInitialized);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("showNext", ctx.showNext())("showSubmit", ctx.showSubmit())("showPrevious", ctx.showBack())("showSendApplicationEmail", false)("previousButtonText", ctx.previousText)("nextButtonText", ctx.nextText)("submitButtonText", ctx.submitText);
    } }, dependencies: [EnrollmentFormNavigationComponent, NextGenEnrollmentFormRendererComponent], encapsulation: 2, changeDetection: 0 });
__decorate([
    GlobalResource()
], StandaloneFormComponent.prototype, "Spa_Site_Submit", void 0);
__decorate([
    GlobalResource()
], StandaloneFormComponent.prototype, "Spa_Site_Previous", void 0);
__decorate([
    GlobalResource()
], StandaloneFormComponent.prototype, "Spa_Site_Next", void 0);
__decorate([
    GlobalResource()
], StandaloneFormComponent.prototype, "Spa_StandaloneForm_RedirectTag", void 0);
__decorate([
    GlobalResource()
], StandaloneFormComponent.prototype, "Spa_Site_UnableToProcessErrorsTitle_Text", void 0);
__decorate([
    GlobalResource()
], StandaloneFormComponent.prototype, "Spa_Site_UnableToProcessErrorsMessage_Text", void 0);
StandaloneFormComponent = __decorate([
    PlatformWidget
], StandaloneFormComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StandaloneFormComponent, [{
        type: Component,
        args: [{ selector: 'vnext-standalone-form', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetService], template: "<div class=\"px-3\">\r\n  <nextgen-enrollment-form-renderer\r\n    [formId]=\"enrollingFormId\"\r\n    [formVersion]=\"formVersionInfo?.formVersion\"\r\n    [formVersionId]=\"formVersionInfo?.formVersionId\"\r\n    [surveyInitialized]=\"surveyInitialized\"\r\n  ></nextgen-enrollment-form-renderer>\r\n</div>\r\n\r\n<vnext-enrollment-form-navigation\r\n  [showNext]=\"showNext()\"\r\n  [showSubmit]=\"showSubmit()\"\r\n  [showPrevious]=\"showBack()\"\r\n  [showSendApplicationEmail]=\"false\"\r\n  [previousButtonText]=\"previousText\"\r\n  [nextButtonText]=\"nextText\"\r\n  [submitButtonText]=\"submitText\"\r\n  [sendApplicationButtonText]=\"\"\r\n  [enrollSubmitTooltipText]=\"\"\r\n  (backEvent)=\"back()\"\r\n  (nextEvent)=\"next()\"\r\n  (submitEvent)=\"onSubmit($event)\"\r\n  (closeTooltipEvent)=\"closeEnrollmentTooltip($event)\"\r\n></vnext-enrollment-form-navigation>\r\n" }]
    }], function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.WidgetValidationService }, { type: ConfigurableWidgetService }, { type: ZoneService }, { type: WidgetService }, { type: i1.SpinnerService }, { type: i2$1.ActivatedRoute }, { type: i0.ViewContainerRef }, { type: i1.AuthService }, { type: i1.NavigationService }, { type: i1.EnrollmentFormErrorsContext }, { type: i1.StandaloneFormService }, { type: StandaloneFormFacade }, { type: i1.AddressService }, { type: i1.FormPagesMetadataContext }, { type: FormRootService }, { type: FormRootStrategyService }, { type: i1.GroupValidatorContextService }]; }, { childForms: [{
            type: ViewChildren,
            args: [NextGenEnrollmentFormRendererComponent]
        }], Spa_Site_Submit: [], Spa_Site_Previous: [], Spa_Site_Next: [], Spa_StandaloneForm_RedirectTag: [], Spa_Site_UnableToProcessErrorsTitle_Text: [], Spa_Site_UnableToProcessErrorsMessage_Text: [], onSurveyBeforeViewInitialized: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.SURVEY_BEFORE_VIEW_INITIALIZED}`, ['$event']]
        }], onSurveyAfterViewInitialized: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.SURVEY_AFTER_VIEW_INITIALIZED}`, ['$event']]
        }], onSurveyAfterPageRendered: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.SURVEY_AFTER_PAGE_RENDERED}`, ['$event']]
        }], clearFormErrors: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.NAVIGATE_PREVIOUS_PAGE}`, ['$event']]
        }], setFormPageInfo: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.FORM_INFO}`, ['$event']]
        }], setFormPageErrors: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.PAGE_ERRORS}`, ['$event']]
        }], nextgenAutocompleteAddress: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.ADDRESS_AUTOCOMPLETE_REQUEST}`, ['$event']]
        }], updateViAQueryParams: [{
            type: HostListener,
            args: [`${NextGenEnrollmentEvents.UPDATE_VIA_QUERY_PARAMS}`, ['$event']]
        }], nextGenNavigateToPageName: [{
            type: HostListener,
            args: [`document:${NextGenEnrollmentEvents.ENROLLMENT_GO_TO_PAGE}`, ['$event']]
        }] }); })();

const VNEXT_WIDGET_EXPORTS = [
    DrugFootNoteComponent,
    DrugTypeComponent,
    SoaAgentFormComponent,
    SOAFormComponent,
    BackNextNavigationComponent,
    DemographicComponent,
    HelpfulToolsPlanListComponent,
    HelpfulToolsPharmacySearchComponent,
    HelpfulToolsPlanCardComponent,
    HelpfulToolsLinkComponent,
    HelpfulToolsPharmacySearchTabComponent,
    HelpfulToolsPrescriptionSearchTabComponent,
    HelpfulToolsProviderSearchTabComponent,
    RetentionLandingComponent,
    ContactYourAgentStepComponent,
    SelectContactMethodStepComponent,
    VerificationCodeSentComponent,
    EnterVerificationCodeStepComponent,
    PINLockedStepComponent,
    MultiFactorAuthenticationComponent,
    AccountOverviewComponent,
    ActiveSellingPermissionsComponent,
    AddAgentSellingPermissionsComponent,
    DuplicatedPermissionModalComponent,
    FilterSellingPermissionsComponent,
    CheckboxDropdownComponent,
    NgbdSortableHeaderDirective,
    AgentContainerComponent,
    AgentProfileSearchComponent,
    AgentSearchResultComponent,
    AgentHeaderComponent,
    AgentRoleSelectorComponent,
    BeneficiaryComponent,
    RetentionSummaryComponent,
    SummaryCoverageTypesComponent,
    RetentionUserInfoComponent,
    QuoteUserInfoComponent,
    RetentionWelcomeComponent,
    QuoteWelcomeComponent,
    SummaryPreferencesComponent,
    QuoteSummaryPreferencesComponent,
    PopoverComponent,
    FilterTabComponent,
    HtmlComponent,
    GoogleTagManagerComponent,
    ScriptComponent,
    ImageComponent,
    DrugSearchComponent,
    ProviderSearchComponent,
    DrugDetailsComponent,
    DrugDetailsFooterComponent,
    DrugDosageComponent,
    DrugGenericEquivalentComponent,
    DrugPackageComponent,
    DrugQuantityFrequencyComponent,
    DrugListCardComponent,
    MedicineCabinetComponent,
    MedicineCabinetModalComponent,
    DrugListCardModalComponent,
    SharePrescriptionComponent,
    SharePrescriptionListComponent,
    PageNavButtonsComponent,
    PlanCardRateFactorStatusComponent,
    PlanCardRateFactorsStatusesComponent,
    PlanCardComponent,
    NextgenPlanCardComponent,
    NextgenPlanCardDetailExpandableComponent,
    NextgenPlanSubDetailsComponent,
    LegacyPlanCardComponent,
    SNPInfoModalComponent,
    RiderCardComponent,
    LoginContainerComponent,
    LoginComponent,
    PlanCostSectionComponent,
    PlanFilterModalComponent,
    PlanSmartFilterModalComponent,
    PlanFilterModalItemsComponent,
    PlanFilterComponent,
    PharmacyFilterItemsComponent,
    PlanFilterItemsComponent,
    PlanListComponent,
    StarRatingComponent,
    TextComponent,
    DynamicFooterComponent,
    EnrollmentFormRendererComponent,
    NextGenEnrollmentFormRendererComponent,
    EnrollmentConfirmationComponent,
    EnrollmentCallRecordingComponent,
    EnrollmentCallRecordingActionsComponent,
    EnrollmentNavigationBarComponent,
    NextGenEnrollmentNavigationBarComponent,
    PlanCompareEnrollmentNavigationBarComponent,
    EnrollmentUnavailableComponent,
    FormRootComponent,
    EnrollmentNoticeComponent,
    DefaultLinkPageComponent,
    DynamicHeaderComponent,
    ClientNavigationHeaderComponent,
    ScriptingContainerComponent,
    DisclaimerSectionComponent,
    ShoppingCartComponent,
    ShoppingCartIconComponent,
    ShoppingCartButtonComponent,
    PlanBenefitsComponent,
    PlanDetailsComponent,
    PlanDetailsTabComponent,
    PlanRiderDetailsComponent,
    PrescriptionsTabComponent,
    NonCoveredDrugAlternativesSubDetailsComponent,
    MedicalConditionsDrugAlternativesDetailsComponent,
    TotalCostsTabComponent,
    PlanCardBestMatchComponent,
    PlanDrugAlternativesIndicatorComponent,
    FormularyDetailsComponent,
    RiderBenefitDetailsComponent,
    RiderBenefitsComponent,
    PlanSubDetailsComponent,
    RiderCategoryDetailComponent,
    RiderCategoryComponent,
    PharmacyListComponent,
    DigitalPharmacyComponent,
    DigitalPharmacyCardComponent,
    PharmacyFilterModalComponent,
    ProviderListComponent,
    PharmacySearchHeaderComponent,
    EnrollmentNavigationStepComponent,
    EnrollmentNavigationBarBaseComponent,
    EnrollmentInformationComponent,
    MedSupFormComponent,
    MedsupMillimanAuthorizationComponent,
    MedSupPlanSubTypeComponent,
    PlanSubTypeDropdownComponent,
    CollapsibleListAnimationDirective,
    MiniCartPlanCardComponent,
    MiniCartPlanRiderComponent,
    MiniCartComponent,
    HospitalIndemnityCoverageCartNudgeComponent,
    MedicareBlockTextComponent,
    PlanDetailsCardComponent,
    RateFactorWarningComponent,
    PlanSortComponent,
    CartRiderComponent,
    GuidedHelpComponent,
    GuidedHelpNavigationComponent,
    GuidedHelpNavigationTextComponent,
    GuidedHelpPlanListComponent,
    PharmacySearchComponent,
    PlanListAccordionComponent,
    PharmacySelectorComponent,
    MemberResultCardComponent,
    GuidedHelpBlockComponent,
    MapComponent,
    SelectedPharmacyComponent,
    DrugCostDetailsComponent,
    DrugCardComponent,
    DrugRestrictionsComponent,
    DrugCostsComponent,
    PlanDetailsCostComponent,
    GuidedHelpCoverageTypeComponent,
    PlanPharmacyDetailsComponent,
    HealthCostTabComponent,
    HealthCostTableComponent,
    HospitalIndemnityInformationNudgeComponent,
    MailOrderPharmacyDetailsComponent,
    GuidedHelpGetStartedComponent,
    PharmacySelectionComponent,
    GuidedHelpOtherPreferencesComponent,
    GuidedHelpZipCodeComponent,
    PlanCompareComponent,
    PlanFeesComponent,
    PlanFeesTooltipComponent,
    HealthComponent,
    PlanPreferenceTextComponent,
    PlanCoveragePreferencesComponent,
    LegacyPlanCoveragePreferencesComponent,
    NextgenPlanCoveragePreferencesComponent,
    PlanCardSupplementalBenefitsComponent,
    PlanCardSupplementalBenefitLabelComponent,
    PlanCoverageProvidersComponent,
    PlanCoverageProvidersLabelComponent,
    PlanCoveragePrescriptionsComponent,
    PlanCoveragePrescriptionsLabelComponent,
    GuidedHelpAgeSelectComponent,
    CreateAccountComponent,
    CreateAccountNudgeComponent,
    MonthlyBreakdownCostComponent,
    HealthSliderComponent,
    HealthCostCustomizationComponent,
    HealthCostCustomizationTableComponent,
    AgentLoginComponent,
    PlanLevelContentComponent,
    PlanCostDetailsComponent,
    PlanBenefitDetailsComponent,
    PlanCompareMedicalBenefitsComponent,
    PlanComparePanelComponent,
    PlanCompareAccordionComponent,
    ProfileNavigationBarComponent,
    ProfileNavigationAgentItemComponent,
    ProfileNavbarDropdownComponent,
    PlanComparePrescriptionComponent,
    PlanComparePrescriptionCoverageComponent,
    PlanComparePreferencesComponent,
    PlanComparePaginationComponent,
    ForgotPasswordComponent,
    ForgotUsernameComponent,
    ResetPasswordComponent,
    MedigapEnrollmentInterimComponent,
    ImageBannerContainerComponent,
    PageNotFoundComponent,
    GroupMessageComponent,
    AddProfileComponent,
    RecordingsComponent,
    RetentionPlanCardComponent,
    QuotePlanCardComponent,
    PlanCardTileComponent,
    PlanCardTileTwoComponent,
    MemberRegistrationComponent,
    MemberQuoteCardComponent,
    MemberQuoteHistoryComponent,
    MemberEligibilityCheckComponent,
    MemberEnrollmentCardComponent,
    MemberExpandableEnrollmentCardComponent,
    MemberPartialEnrollmentCardComponent,
    MemberExpandablePartialEnrollmentCardComponent,
    MemberEnrollmentHistoryComponent,
    MemberProfileRetentionSummaryComponent,
    AgentSearchComponent,
    QualifiedHelpSummaryComponent,
    PlanCompareRidersComponent,
    SummaryButtonsComponent,
    PlanCardLabelComponent,
    PlanCompareCardLabelComponent,
    AgentNoteComponent,
    AgentNoteDetailComponent,
    AgentSOAComponent,
    AgentOfRecordComponent,
    CopyPurlPlusComponent,
    SOAComponent,
    TalkingPointSideNavComponent,
    PageSpinnerComponent,
    SOAActivityComponent,
    SOAActivityItemComponent,
    PlanCompareCardComponent,
    AgentTaskComponent,
    AgentTaskDetailComponent,
    PlanCoveragePrescriptionInfoModalComponent,
    AgentDashboardTaskDetailComponent,
    AgentDashboardTaskListComponent,
    EventStylingDirective,
    SendQuoteModalComponent,
    SendSoaModalComponent,
    SendQuoteConfirmationModalComponent,
    SelectRxTaskComponent,
    SOAFollowUpModalComponent,
    BlueButtonFollowUpModalComponent,
    PlanQuoteComponent,
    PlanQuoteItemComponent,
    PlanQuoteBenefitDetailsComponent,
    PlanQuoteBenefitDetailComponent,
    SelectPlanQuoteComponent,
    SelectPlanQuoteErrorComponent,
    PlanQuoteButtonComponent,
    PlanCardRidersComponent,
    SoaFormRendererComponent,
    SOAConsumerFormComponent,
    NextGenSOAFormComponent,
    QuoteSummaryComponent,
    ExistingMemberFormComponent,
    ExistingMemberCartComponent,
    AgentFormSelectionComponent,
    TitleComponent,
    GenericFormComponent,
    StandaloneFormComponent,
    MedicaidEligibilityCheckComponent,
    HRAFormComponent,
    GenericFormRendererComponent,
    HRAFormRendererComponent,
    BlueButtonComponent,
    SelectRXSectionComponent,
    SalesForceAuthComponent,
    EnrollDisplayComponent,
    AgentProfilePictureComponent,
    AgentProfileUploadComponent,
    SelectedProviderComponent,
    GeneralPracticeToggleComponent,
    ValueBasedProviderToggleComponent,
    ProviderToggleComponent,
    MultipleProviderAddressComponent,
    SingleProviderAddressSelectorComponent,
    MultipleProviderAddressSelectorComponent,
    MapPinComponent,
    PlanProviderDetailsComponent,
    SummaryPreferencesProviderComponent,
    PlanSNPIndicatorComponent,
    MedSupMonthYearDropdownComponent,
    MedSupDateDropdownComponent,
    PharmacyFilterModalItemsComponent,
    AccountSummaryComponent,
    AccountSummaryInputComponent,
    ReportsSummaryComponent,
    CallToActionAreaComponent,
    CallToActionTile,
    ReportSearchComponent,
    ReportListComponent,
    CreateAccountNudgeComponent,
    AgentDashboardComponent,
    AgentTrainingMaterialsComponent,
    UniqueCodeSearchComponent,
    TransferCodeSearchComponent,
    ConsumerForgotPasswordComponent,
    ConsumerForgotUsernameComponent,
    EnrollmentConfirmationHRASectionComponent,
    EnrollmentConfirmationVBCSectionComponent,
    HRAConfirmationComponent,
    HRACompleteSectionComponent,
    GenericFormConfirmationComponent,
    StandaloneFormConfirmationComponent,
    EffectiveDateDisplayComponent,
    PersonalizedVideoComponent,
    BrowserDeniedComponent,
    BenefitsDisplayComponent,
    HIPDetailsBannerComponent,
    PlanSmartComponent,
    PlanSmartTabComponent,
    PlanSmartTabListComponent,
    PlanSmartTabContentComponent,
    PlanSmartCardComponent,
    PlanSmartCardReportSummary,
    PlanSmartReportButtonComponent,
    PlanYearLabelComponent,
    PlanRatingMethodComponent,
    ValueBasedCareModalComponent,
    CompletedEnrollmentsHistoryComponent,
    EnrollmentCardDetailsComponent,
    PlanDefaultCostComponent,
    PCPNetworkStatusComponent,
    DSNPEligibilityMessageComponent,
    AgentProgressTrackerComponent,
    ProgressStatusComponent,
    AgentRetireFloComponent,
    AgentRetirefloDetailComponent,
    PreferencesBannerComponent,
    EligibilityModalComponent,
    PrescriptionModalComponent,
    DrugSearchModalComponent,
    ProviderModalComponent,
    PharmacyModalComponent,
    HealthModalComponent,
    RetireFloSurveyComponent,
    ProviderSearchModalComponent,
    PharmacySearchModalComponent
];
const VNEXT_WIDGET_DECLARATIONS = [
    ...VNEXT_WIDGET_EXPORTS,
    SubHeaderComponent,
    CopyrightComponent,
    CmsApprovalCodeComponent,
    CallRecordingStickyBoxComponent,
    LogoComponent,
    DefaultLinksComponent,
    SiteDisclaimerComponent,
    AccordionComponent,
    HeaderMenuDropdownComponent,
    TextSizeComponent,
    LocalePickerComponent,
    MotionPointLocalePickerComponent,
    SubHeaderActionComponent,
    ContactUsComponent,
    MedSupToggleComponent,
    MedSupDropdownComponent,
    MedSupIntegerComponent,
    MedSupHeightComponent,
    MedSupDateComponent,
    MedSupEffectiveDateComponent,
    MedSupBirthDateComponent,
    MedSupEffectiveDateAComponent,
    MedSupEffectiveDateBComponent,
    MedSupCheckboxesComponent,
    MedSupCheckboxComponent,
    MedSupMillimanFormComponent,
    MedSupMillimanHealthQuestionComponent,
    MemberEffectiveDateComponent,
    SaveProgressComponent,
    FocusOnMainContentComponent,
    MedSupPaymentMethodComponent,
    SpeakWithAgentComponent,
    AgentCallRecordingModalComponent,
    AgentCallRecordingShoppingModalComponent,
    ReportSummaryFilterItemsComponent,
    CallRecordingAudioPlayerComponent,
    PlanLogoComponent,
    BenefitsDisplayComponent,
    CallRecordingIconComponent,
    PlanSmartFilterComponent,
    PlanSmartFilterItemsComponent,
    SubscriptionFormComponent,
    CheckOutFormComponent,
    SubscriptionConfirmationComponent,
    MultipleProviderAddressModalComponent,
    SelectedProviderModalComponent
];
const VNEXT_WIDGET_ENTRY_COMPONENTS = [
    AgentSearchComponent,
    BeneficiaryComponent,
    SOAFormComponent,
    BackNextNavigationComponent,
    DemographicComponent,
    HelpfulToolsPlanListComponent,
    HelpfulToolsPlanCardComponent,
    HelpfulToolsPharmacySearchComponent,
    HelpfulToolsLinkComponent,
    HelpfulToolsPharmacySearchTabComponent,
    HelpfulToolsPrescriptionSearchTabComponent,
    HelpfulToolsProviderSearchTabComponent,
    RetentionLandingComponent,
    ContactYourAgentStepComponent,
    SelectContactMethodStepComponent,
    VerificationCodeSentComponent,
    EnterVerificationCodeStepComponent,
    PINLockedStepComponent,
    MultiFactorAuthenticationComponent,
    RetentionSummaryComponent,
    RetentionWelcomeComponent,
    SummaryCoverageTypesComponent,
    RetentionUserInfoComponent,
    QuoteUserInfoComponent,
    PopoverComponent,
    SummaryPreferencesComponent,
    QuoteSummaryPreferencesComponent,
    DrugSearchComponent,
    DrugListCardComponent,
    PlanCardRateFactorStatusComponent,
    PlanCardRateFactorsStatusesComponent,
    ProviderSearchComponent,
    PharmacyListComponent,
    DigitalPharmacyComponent,
    DigitalPharmacyCardComponent,
    ProviderListComponent,
    PharmacySearchHeaderComponent,
    DrugDetailsComponent,
    DrugDetailsFooterComponent,
    DrugDosageComponent,
    DrugGenericEquivalentComponent,
    DrugPackageComponent,
    DrugQuantityFrequencyComponent,
    MedicineCabinetComponent,
    MedicineCabinetModalComponent,
    DrugListCardModalComponent,
    SharePrescriptionComponent,
    SharePrescriptionListComponent,
    HtmlComponent,
    GoogleTagManagerComponent,
    ScriptComponent,
    ImageComponent,
    EnrollmentNavigationBarComponent,
    MedicareBlockTextComponent,
    PageNavButtonsComponent,
    ShoppingCartComponent,
    PlanDetailsComponent,
    PlanFilterModalComponent,
    PlanFilterModalItemsComponent,
    PlanFilterComponent,
    PlanSmartFilterModalComponent,
    PharmacyFilterItemsComponent,
    PlanFilterItemsComponent,
    PlanListComponent,
    TextComponent,
    DynamicFooterComponent,
    DefaultLinkPageComponent,
    FormRootComponent,
    EnrollmentNoticeComponent,
    DynamicHeaderComponent,
    ClientNavigationHeaderComponent,
    ScriptingContainerComponent,
    DisclaimerSectionComponent,
    EnrollmentConfirmationComponent,
    EnrollmentCallRecordingComponent,
    MiniCartPlanCardComponent,
    MiniCartPlanRiderComponent,
    MiniCartComponent,
    HospitalIndemnityCoverageCartNudgeComponent,
    EnrollmentInformationComponent,
    PlanCostSectionComponent,
    PlanDetailsCardComponent,
    PlanSortComponent,
    PharmacySearchComponent,
    MapComponent,
    GuidedHelpComponent,
    GuidedHelpBlockComponent,
    SelectedPharmacyComponent,
    DrugCostDetailsComponent,
    DrugCardComponent,
    DrugCostsComponent,
    DrugRestrictionsComponent,
    PrescriptionsTabComponent,
    NonCoveredDrugAlternativesSubDetailsComponent,
    MedicalConditionsDrugAlternativesDetailsComponent,
    TotalCostsTabComponent,
    PlanCardBestMatchComponent,
    PlanDrugAlternativesIndicatorComponent,
    FormularyDetailsComponent,
    PlanCompareComponent,
    PlanFeesComponent,
    PlanFeesTooltipComponent,
    PharmacySelectionComponent,
    AgentLoginComponent,
    PlanDetailsCostComponent,
    AccountOverviewComponent,
    ActiveSellingPermissionsComponent,
    DuplicatedPermissionModalComponent,
    AgentContainerComponent,
    AgentProfileSearchComponent,
    AgentSearchResultComponent,
    ProfileNavigationBarComponent,
    ProfileNavigationAgentItemComponent,
    ForgotPasswordComponent,
    ForgotUsernameComponent,
    ResetPasswordComponent,
    MedigapEnrollmentInterimComponent,
    AddProfileComponent,
    RecordingsComponent,
    PlanCardTileTwoComponent,
    MemberRegistrationComponent,
    MemberQuoteCardComponent,
    MemberQuoteHistoryComponent,
    MemberEligibilityCheckComponent,
    MemberEnrollmentCardComponent,
    MemberExpandableEnrollmentCardComponent,
    MedicaidEligibilityCheckComponent,
    MemberPartialEnrollmentCardComponent,
    MemberExpandablePartialEnrollmentCardComponent,
    MemberEnrollmentHistoryComponent,
    QualifiedHelpSummaryComponent,
    PlanCoveragePrescriptionInfoModalComponent,
    AgentNoteComponent,
    AgentSOAComponent,
    AgentOfRecordComponent,
    CopyPurlPlusComponent,
    SOAComponent,
    TalkingPointSideNavComponent,
    SOAActivityComponent,
    SOAActivityItemComponent,
    AgentTaskComponent,
    SendQuoteModalComponent,
    SendSoaModalComponent,
    QuoteSummaryComponent,
    ExistingMemberCartComponent,
    AgentFormSelectionComponent,
    SelectRXSectionComponent,
    ExistingMemberFormComponent,
    SendQuoteConfirmationModalComponent,
    SelectRxTaskComponent,
    SOAFollowUpModalComponent,
    BlueButtonFollowUpModalComponent,
    TitleComponent,
    GenericFormComponent,
    StandaloneFormComponent,
    HRAFormComponent,
    GenericFormRendererComponent,
    HRAFormRendererComponent,
    BlueButtonComponent,
    SalesForceAuthComponent,
    EnrollDisplayComponent,
    PlanSNPIndicatorComponent,
    PharmacyFilterModalComponent,
    PharmacyFilterModalItemsComponent,
    AccountSummaryComponent,
    AccountSummaryInputComponent,
    ReportsSummaryComponent,
    ReportSearchComponent,
    ReportListComponent,
    CreateAccountNudgeComponent,
    AgentDashboardComponent,
    AgentTrainingMaterialsComponent,
    AgentCallRecordingModalComponent,
    AgentCallRecordingShoppingModalComponent,
    EnrollmentConfirmationHRASectionComponent,
    EnrollmentConfirmationVBCSectionComponent,
    HRAConfirmationComponent,
    HRACompleteSectionComponent,
    ReportSummaryFilterItemsComponent,
    PlanLogoComponent,
    GenericFormConfirmationComponent,
    StandaloneFormConfirmationComponent,
    PlanSmartComponent,
    PlanSmartTabComponent,
    PlanSmartTabListComponent,
    PlanSmartTabContentComponent,
    PlanSmartCardComponent,
    PlanSmartCardReportSummary,
    PlanSmartReportButtonComponent,
    PlanRatingMethodComponent,
    ValueBasedCareModalComponent,
    CompletedEnrollmentsHistoryComponent,
    SNPInfoModalComponent,
    EnrollmentCardDetailsComponent,
    PlanDefaultCostComponent,
    PCPNetworkStatusComponent,
    DSNPEligibilityMessageComponent,
    AgentProgressTrackerComponent,
    ProgressStatusComponent,
    AgentRetireFloComponent,
    AgentRetirefloDetailComponent,
    SubscriptionFormComponent,
    CheckOutFormComponent,
    SubscriptionConfirmationComponent,
    EligibilityModalComponent,
    PrescriptionModalComponent,
    DrugSearchModalComponent,
    ProviderModalComponent,
    PharmacyModalComponent,
    HealthModalComponent,
    RetireFloSurveyComponent,
    ProviderSearchModalComponent,
    PharmacySearchModalComponent,
    MultipleProviderAddressModalComponent,
    SelectedProviderModalComponent
];

const VNEXT_WIDGET_IMPORTS = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ComponentsModule,
    ConfigsModule,
    DirectivesModule,
    PipesModule,
    NgbModule,
    DigitOnlyModule,
    BrowserAnimationsModule,
    NgxMaskModule.forRoot(),
    AgmOverlays,
    AgmCoreModule.forRoot({
        apiKey: 'AIzaSyBSXj-Zdc9o6DlxScMUjKYP_XRXtL-gie0'
    }),
    AgmSnazzyInfoWindowModule,
    InfiniteScrollModule,
    NgxSpinnerModule
];
class WidgetsModule {
    static forRoot(environment, config) {
        return {
            ngModule: WidgetsModule,
            providers: [
                {
                    provide: 'environment',
                    useValue: environment
                },
                {
                    provide: 'config',
                    useValue: config
                }
            ]
        };
    }
}
WidgetsModule.ɵfac = function WidgetsModule_Factory(t) { return new (t || WidgetsModule)(); };
WidgetsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: WidgetsModule });
WidgetsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [CurrencyPipe, OrderPipe], imports: [VNEXT_WIDGET_IMPORTS] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WidgetsModule, [{
        type: NgModule,
        args: [{
                imports: VNEXT_WIDGET_IMPORTS,
                declarations: VNEXT_WIDGET_DECLARATIONS,
                providers: [CurrencyPipe, OrderPipe],
                exports: VNEXT_WIDGET_EXPORTS,
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(WidgetsModule, { declarations: [DrugFootNoteComponent, DrugTypeComponent, SoaAgentFormComponent, SOAFormComponent, BackNextNavigationComponent, DemographicComponent, HelpfulToolsPlanListComponent, HelpfulToolsPharmacySearchComponent, HelpfulToolsPlanCardComponent, HelpfulToolsLinkComponent, HelpfulToolsPharmacySearchTabComponent, HelpfulToolsPrescriptionSearchTabComponent, HelpfulToolsProviderSearchTabComponent, RetentionLandingComponent, ContactYourAgentStepComponent, SelectContactMethodStepComponent, VerificationCodeSentComponent, EnterVerificationCodeStepComponent, PINLockedStepComponent, MultiFactorAuthenticationComponent, AccountOverviewComponent, ActiveSellingPermissionsComponent, AddAgentSellingPermissionsComponent, DuplicatedPermissionModalComponent, FilterSellingPermissionsComponent, CheckboxDropdownComponent, NgbdSortableHeaderDirective, AgentContainerComponent, AgentProfileSearchComponent, AgentSearchResultComponent, AgentHeaderComponent, AgentRoleSelectorComponent, BeneficiaryComponent, RetentionSummaryComponent, SummaryCoverageTypesComponent, RetentionUserInfoComponent, QuoteUserInfoComponent, RetentionWelcomeComponent, QuoteWelcomeComponent, SummaryPreferencesComponent, QuoteSummaryPreferencesComponent, PopoverComponent, FilterTabComponent, HtmlComponent, GoogleTagManagerComponent, ScriptComponent, ImageComponent, DrugSearchComponent, ProviderSearchComponent, DrugDetailsComponent, DrugDetailsFooterComponent, DrugDosageComponent, DrugGenericEquivalentComponent, DrugPackageComponent, DrugQuantityFrequencyComponent, DrugListCardComponent, MedicineCabinetComponent, MedicineCabinetModalComponent, DrugListCardModalComponent, SharePrescriptionComponent, SharePrescriptionListComponent, PageNavButtonsComponent, PlanCardRateFactorStatusComponent, PlanCardRateFactorsStatusesComponent, PlanCardComponent, NextgenPlanCardComponent, NextgenPlanCardDetailExpandableComponent, NextgenPlanSubDetailsComponent, LegacyPlanCardComponent, SNPInfoModalComponent, RiderCardComponent, LoginContainerComponent, LoginComponent, PlanCostSectionComponent, PlanFilterModalComponent, PlanSmartFilterModalComponent, PlanFilterModalItemsComponent, PlanFilterComponent, PharmacyFilterItemsComponent, PlanFilterItemsComponent, PlanListComponent, StarRatingComponent, TextComponent, DynamicFooterComponent, EnrollmentFormRendererComponent, NextGenEnrollmentFormRendererComponent, EnrollmentConfirmationComponent, EnrollmentCallRecordingComponent, EnrollmentCallRecordingActionsComponent, EnrollmentNavigationBarComponent, NextGenEnrollmentNavigationBarComponent, PlanCompareEnrollmentNavigationBarComponent, EnrollmentUnavailableComponent, FormRootComponent, EnrollmentNoticeComponent, DefaultLinkPageComponent, DynamicHeaderComponent, ClientNavigationHeaderComponent, ScriptingContainerComponent, DisclaimerSectionComponent, ShoppingCartComponent, ShoppingCartIconComponent, ShoppingCartButtonComponent, PlanBenefitsComponent, PlanDetailsComponent, PlanDetailsTabComponent, PlanRiderDetailsComponent, PrescriptionsTabComponent, NonCoveredDrugAlternativesSubDetailsComponent, MedicalConditionsDrugAlternativesDetailsComponent, TotalCostsTabComponent, PlanCardBestMatchComponent, PlanDrugAlternativesIndicatorComponent, FormularyDetailsComponent, RiderBenefitDetailsComponent, RiderBenefitsComponent, PlanSubDetailsComponent, RiderCategoryDetailComponent, RiderCategoryComponent, PharmacyListComponent, DigitalPharmacyComponent, DigitalPharmacyCardComponent, PharmacyFilterModalComponent, ProviderListComponent, PharmacySearchHeaderComponent, EnrollmentNavigationStepComponent, EnrollmentNavigationBarBaseComponent, EnrollmentInformationComponent, MedSupFormComponent, MedsupMillimanAuthorizationComponent, MedSupPlanSubTypeComponent, PlanSubTypeDropdownComponent, CollapsibleListAnimationDirective, MiniCartPlanCardComponent, MiniCartPlanRiderComponent, MiniCartComponent, HospitalIndemnityCoverageCartNudgeComponent, MedicareBlockTextComponent, PlanDetailsCardComponent, RateFactorWarningComponent, PlanSortComponent, CartRiderComponent, GuidedHelpComponent, GuidedHelpNavigationComponent, GuidedHelpNavigationTextComponent, GuidedHelpPlanListComponent, PharmacySearchComponent, PlanListAccordionComponent, PharmacySelectorComponent, MemberResultCardComponent, GuidedHelpBlockComponent, MapComponent, SelectedPharmacyComponent, DrugCostDetailsComponent, DrugCardComponent, DrugRestrictionsComponent, DrugCostsComponent, PlanDetailsCostComponent, GuidedHelpCoverageTypeComponent, PlanPharmacyDetailsComponent, HealthCostTabComponent, HealthCostTableComponent, HospitalIndemnityInformationNudgeComponent, MailOrderPharmacyDetailsComponent, GuidedHelpGetStartedComponent, PharmacySelectionComponent, GuidedHelpOtherPreferencesComponent, GuidedHelpZipCodeComponent, PlanCompareComponent, PlanFeesComponent, PlanFeesTooltipComponent, HealthComponent, PlanPreferenceTextComponent, PlanCoveragePreferencesComponent, LegacyPlanCoveragePreferencesComponent, NextgenPlanCoveragePreferencesComponent, PlanCardSupplementalBenefitsComponent, PlanCardSupplementalBenefitLabelComponent, PlanCoverageProvidersComponent, PlanCoverageProvidersLabelComponent, PlanCoveragePrescriptionsComponent, PlanCoveragePrescriptionsLabelComponent, GuidedHelpAgeSelectComponent, CreateAccountComponent, CreateAccountNudgeComponent, MonthlyBreakdownCostComponent, HealthSliderComponent, HealthCostCustomizationComponent, HealthCostCustomizationTableComponent, AgentLoginComponent, PlanLevelContentComponent, PlanCostDetailsComponent, PlanBenefitDetailsComponent, PlanCompareMedicalBenefitsComponent, PlanComparePanelComponent, PlanCompareAccordionComponent, ProfileNavigationBarComponent, ProfileNavigationAgentItemComponent, ProfileNavbarDropdownComponent, PlanComparePrescriptionComponent, PlanComparePrescriptionCoverageComponent, PlanComparePreferencesComponent, PlanComparePaginationComponent, ForgotPasswordComponent, ForgotUsernameComponent, ResetPasswordComponent, MedigapEnrollmentInterimComponent, ImageBannerContainerComponent, PageNotFoundComponent, GroupMessageComponent, AddProfileComponent, RecordingsComponent, RetentionPlanCardComponent, QuotePlanCardComponent, PlanCardTileComponent, PlanCardTileTwoComponent, MemberRegistrationComponent, MemberQuoteCardComponent, MemberQuoteHistoryComponent, MemberEligibilityCheckComponent, MemberEnrollmentCardComponent, MemberExpandableEnrollmentCardComponent, MemberPartialEnrollmentCardComponent, MemberExpandablePartialEnrollmentCardComponent, MemberEnrollmentHistoryComponent, MemberProfileRetentionSummaryComponent, AgentSearchComponent, QualifiedHelpSummaryComponent, PlanCompareRidersComponent, SummaryButtonsComponent, PlanCardLabelComponent, PlanCompareCardLabelComponent, AgentNoteComponent, AgentNoteDetailComponent, AgentSOAComponent, AgentOfRecordComponent, CopyPurlPlusComponent, SOAComponent, TalkingPointSideNavComponent, PageSpinnerComponent, SOAActivityComponent, SOAActivityItemComponent, PlanCompareCardComponent, AgentTaskComponent, AgentTaskDetailComponent, PlanCoveragePrescriptionInfoModalComponent, AgentDashboardTaskDetailComponent, AgentDashboardTaskListComponent, EventStylingDirective, SendQuoteModalComponent, SendSoaModalComponent, SendQuoteConfirmationModalComponent, SelectRxTaskComponent, SOAFollowUpModalComponent, BlueButtonFollowUpModalComponent, PlanQuoteComponent, PlanQuoteItemComponent, PlanQuoteBenefitDetailsComponent, PlanQuoteBenefitDetailComponent, SelectPlanQuoteComponent, SelectPlanQuoteErrorComponent, PlanQuoteButtonComponent, PlanCardRidersComponent, SoaFormRendererComponent, SOAConsumerFormComponent, NextGenSOAFormComponent, QuoteSummaryComponent, ExistingMemberFormComponent, ExistingMemberCartComponent, AgentFormSelectionComponent, TitleComponent, GenericFormComponent, StandaloneFormComponent, MedicaidEligibilityCheckComponent, HRAFormComponent, GenericFormRendererComponent, HRAFormRendererComponent, BlueButtonComponent, SelectRXSectionComponent, SalesForceAuthComponent, EnrollDisplayComponent, AgentProfilePictureComponent, AgentProfileUploadComponent, SelectedProviderComponent, GeneralPracticeToggleComponent, ValueBasedProviderToggleComponent, ProviderToggleComponent, MultipleProviderAddressComponent, SingleProviderAddressSelectorComponent, MultipleProviderAddressSelectorComponent, MapPinComponent, PlanProviderDetailsComponent, SummaryPreferencesProviderComponent, PlanSNPIndicatorComponent, MedSupMonthYearDropdownComponent, MedSupDateDropdownComponent, PharmacyFilterModalItemsComponent, AccountSummaryComponent, AccountSummaryInputComponent, ReportsSummaryComponent, CallToActionAreaComponent, CallToActionTile, ReportSearchComponent, ReportListComponent, CreateAccountNudgeComponent, AgentDashboardComponent, AgentTrainingMaterialsComponent, UniqueCodeSearchComponent, TransferCodeSearchComponent, ConsumerForgotPasswordComponent, ConsumerForgotUsernameComponent, EnrollmentConfirmationHRASectionComponent, EnrollmentConfirmationVBCSectionComponent, HRAConfirmationComponent, HRACompleteSectionComponent, GenericFormConfirmationComponent, StandaloneFormConfirmationComponent, EffectiveDateDisplayComponent, PersonalizedVideoComponent, BrowserDeniedComponent, BenefitsDisplayComponent, HIPDetailsBannerComponent, PlanSmartComponent, PlanSmartTabComponent, PlanSmartTabListComponent, PlanSmartTabContentComponent, PlanSmartCardComponent, PlanSmartCardReportSummary, PlanSmartReportButtonComponent, PlanYearLabelComponent, PlanRatingMethodComponent, ValueBasedCareModalComponent, CompletedEnrollmentsHistoryComponent, EnrollmentCardDetailsComponent, PlanDefaultCostComponent, PCPNetworkStatusComponent, DSNPEligibilityMessageComponent, AgentProgressTrackerComponent, ProgressStatusComponent, AgentRetireFloComponent, AgentRetirefloDetailComponent, PreferencesBannerComponent, EligibilityModalComponent, PrescriptionModalComponent, DrugSearchModalComponent, ProviderModalComponent, PharmacyModalComponent, HealthModalComponent, RetireFloSurveyComponent, ProviderSearchModalComponent, PharmacySearchModalComponent, SubHeaderComponent, CopyrightComponent, CmsApprovalCodeComponent, CallRecordingStickyBoxComponent, LogoComponent, DefaultLinksComponent, SiteDisclaimerComponent, AccordionComponent, HeaderMenuDropdownComponent, TextSizeComponent, LocalePickerComponent, MotionPointLocalePickerComponent, SubHeaderActionComponent, ContactUsComponent, MedSupToggleComponent, MedSupDropdownComponent, MedSupIntegerComponent, MedSupHeightComponent, MedSupDateComponent, MedSupEffectiveDateComponent, MedSupBirthDateComponent, MedSupEffectiveDateAComponent, MedSupEffectiveDateBComponent, MedSupCheckboxesComponent, MedSupCheckboxComponent, MedSupMillimanFormComponent, MedSupMillimanHealthQuestionComponent, MemberEffectiveDateComponent, SaveProgressComponent, FocusOnMainContentComponent, MedSupPaymentMethodComponent, SpeakWithAgentComponent, AgentCallRecordingModalComponent, AgentCallRecordingShoppingModalComponent, ReportSummaryFilterItemsComponent, CallRecordingAudioPlayerComponent, PlanLogoComponent, BenefitsDisplayComponent, CallRecordingIconComponent, PlanSmartFilterComponent, PlanSmartFilterItemsComponent, SubscriptionFormComponent, CheckOutFormComponent, SubscriptionConfirmationComponent, MultipleProviderAddressModalComponent, SelectedProviderModalComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ComponentsModule,
        ConfigsModule,
        DirectivesModule,
        PipesModule,
        NgbModule,
        DigitOnlyModule,
        BrowserAnimationsModule, i8.NgxMaskModule, AgmOverlays, i1$4.AgmCoreModule, AgmSnazzyInfoWindowModule,
        InfiniteScrollModule,
        NgxSpinnerModule], exports: [DrugFootNoteComponent, DrugTypeComponent, SoaAgentFormComponent, SOAFormComponent, BackNextNavigationComponent, DemographicComponent, HelpfulToolsPlanListComponent, HelpfulToolsPharmacySearchComponent, HelpfulToolsPlanCardComponent, HelpfulToolsLinkComponent, HelpfulToolsPharmacySearchTabComponent, HelpfulToolsPrescriptionSearchTabComponent, HelpfulToolsProviderSearchTabComponent, RetentionLandingComponent, ContactYourAgentStepComponent, SelectContactMethodStepComponent, VerificationCodeSentComponent, EnterVerificationCodeStepComponent, PINLockedStepComponent, MultiFactorAuthenticationComponent, AccountOverviewComponent, ActiveSellingPermissionsComponent, AddAgentSellingPermissionsComponent, DuplicatedPermissionModalComponent, FilterSellingPermissionsComponent, CheckboxDropdownComponent, NgbdSortableHeaderDirective, AgentContainerComponent, AgentProfileSearchComponent, AgentSearchResultComponent, AgentHeaderComponent, AgentRoleSelectorComponent, BeneficiaryComponent, RetentionSummaryComponent, SummaryCoverageTypesComponent, RetentionUserInfoComponent, QuoteUserInfoComponent, RetentionWelcomeComponent, QuoteWelcomeComponent, SummaryPreferencesComponent, QuoteSummaryPreferencesComponent, PopoverComponent, FilterTabComponent, HtmlComponent, GoogleTagManagerComponent, ScriptComponent, ImageComponent, DrugSearchComponent, ProviderSearchComponent, DrugDetailsComponent, DrugDetailsFooterComponent, DrugDosageComponent, DrugGenericEquivalentComponent, DrugPackageComponent, DrugQuantityFrequencyComponent, DrugListCardComponent, MedicineCabinetComponent, MedicineCabinetModalComponent, DrugListCardModalComponent, SharePrescriptionComponent, SharePrescriptionListComponent, PageNavButtonsComponent, PlanCardRateFactorStatusComponent, PlanCardRateFactorsStatusesComponent, PlanCardComponent, NextgenPlanCardComponent, NextgenPlanCardDetailExpandableComponent, NextgenPlanSubDetailsComponent, LegacyPlanCardComponent, SNPInfoModalComponent, RiderCardComponent, LoginContainerComponent, LoginComponent, PlanCostSectionComponent, PlanFilterModalComponent, PlanSmartFilterModalComponent, PlanFilterModalItemsComponent, PlanFilterComponent, PharmacyFilterItemsComponent, PlanFilterItemsComponent, PlanListComponent, StarRatingComponent, TextComponent, DynamicFooterComponent, EnrollmentFormRendererComponent, NextGenEnrollmentFormRendererComponent, EnrollmentConfirmationComponent, EnrollmentCallRecordingComponent, EnrollmentCallRecordingActionsComponent, EnrollmentNavigationBarComponent, NextGenEnrollmentNavigationBarComponent, PlanCompareEnrollmentNavigationBarComponent, EnrollmentUnavailableComponent, FormRootComponent, EnrollmentNoticeComponent, DefaultLinkPageComponent, DynamicHeaderComponent, ClientNavigationHeaderComponent, ScriptingContainerComponent, DisclaimerSectionComponent, ShoppingCartComponent, ShoppingCartIconComponent, ShoppingCartButtonComponent, PlanBenefitsComponent, PlanDetailsComponent, PlanDetailsTabComponent, PlanRiderDetailsComponent, PrescriptionsTabComponent, NonCoveredDrugAlternativesSubDetailsComponent, MedicalConditionsDrugAlternativesDetailsComponent, TotalCostsTabComponent, PlanCardBestMatchComponent, PlanDrugAlternativesIndicatorComponent, FormularyDetailsComponent, RiderBenefitDetailsComponent, RiderBenefitsComponent, PlanSubDetailsComponent, RiderCategoryDetailComponent, RiderCategoryComponent, PharmacyListComponent, DigitalPharmacyComponent, DigitalPharmacyCardComponent, PharmacyFilterModalComponent, ProviderListComponent, PharmacySearchHeaderComponent, EnrollmentNavigationStepComponent, EnrollmentNavigationBarBaseComponent, EnrollmentInformationComponent, MedSupFormComponent, MedsupMillimanAuthorizationComponent, MedSupPlanSubTypeComponent, PlanSubTypeDropdownComponent, CollapsibleListAnimationDirective, MiniCartPlanCardComponent, MiniCartPlanRiderComponent, MiniCartComponent, HospitalIndemnityCoverageCartNudgeComponent, MedicareBlockTextComponent, PlanDetailsCardComponent, RateFactorWarningComponent, PlanSortComponent, CartRiderComponent, GuidedHelpComponent, GuidedHelpNavigationComponent, GuidedHelpNavigationTextComponent, GuidedHelpPlanListComponent, PharmacySearchComponent, PlanListAccordionComponent, PharmacySelectorComponent, MemberResultCardComponent, GuidedHelpBlockComponent, MapComponent, SelectedPharmacyComponent, DrugCostDetailsComponent, DrugCardComponent, DrugRestrictionsComponent, DrugCostsComponent, PlanDetailsCostComponent, GuidedHelpCoverageTypeComponent, PlanPharmacyDetailsComponent, HealthCostTabComponent, HealthCostTableComponent, HospitalIndemnityInformationNudgeComponent, MailOrderPharmacyDetailsComponent, GuidedHelpGetStartedComponent, PharmacySelectionComponent, GuidedHelpOtherPreferencesComponent, GuidedHelpZipCodeComponent, PlanCompareComponent, PlanFeesComponent, PlanFeesTooltipComponent, HealthComponent, PlanPreferenceTextComponent, PlanCoveragePreferencesComponent, LegacyPlanCoveragePreferencesComponent, NextgenPlanCoveragePreferencesComponent, PlanCardSupplementalBenefitsComponent, PlanCardSupplementalBenefitLabelComponent, PlanCoverageProvidersComponent, PlanCoverageProvidersLabelComponent, PlanCoveragePrescriptionsComponent, PlanCoveragePrescriptionsLabelComponent, GuidedHelpAgeSelectComponent, CreateAccountComponent, CreateAccountNudgeComponent, MonthlyBreakdownCostComponent, HealthSliderComponent, HealthCostCustomizationComponent, HealthCostCustomizationTableComponent, AgentLoginComponent, PlanLevelContentComponent, PlanCostDetailsComponent, PlanBenefitDetailsComponent, PlanCompareMedicalBenefitsComponent, PlanComparePanelComponent, PlanCompareAccordionComponent, ProfileNavigationBarComponent, ProfileNavigationAgentItemComponent, ProfileNavbarDropdownComponent, PlanComparePrescriptionComponent, PlanComparePrescriptionCoverageComponent, PlanComparePreferencesComponent, PlanComparePaginationComponent, ForgotPasswordComponent, ForgotUsernameComponent, ResetPasswordComponent, MedigapEnrollmentInterimComponent, ImageBannerContainerComponent, PageNotFoundComponent, GroupMessageComponent, AddProfileComponent, RecordingsComponent, RetentionPlanCardComponent, QuotePlanCardComponent, PlanCardTileComponent, PlanCardTileTwoComponent, MemberRegistrationComponent, MemberQuoteCardComponent, MemberQuoteHistoryComponent, MemberEligibilityCheckComponent, MemberEnrollmentCardComponent, MemberExpandableEnrollmentCardComponent, MemberPartialEnrollmentCardComponent, MemberExpandablePartialEnrollmentCardComponent, MemberEnrollmentHistoryComponent, MemberProfileRetentionSummaryComponent, AgentSearchComponent, QualifiedHelpSummaryComponent, PlanCompareRidersComponent, SummaryButtonsComponent, PlanCardLabelComponent, PlanCompareCardLabelComponent, AgentNoteComponent, AgentNoteDetailComponent, AgentSOAComponent, AgentOfRecordComponent, CopyPurlPlusComponent, SOAComponent, TalkingPointSideNavComponent, PageSpinnerComponent, SOAActivityComponent, SOAActivityItemComponent, PlanCompareCardComponent, AgentTaskComponent, AgentTaskDetailComponent, PlanCoveragePrescriptionInfoModalComponent, AgentDashboardTaskDetailComponent, AgentDashboardTaskListComponent, EventStylingDirective, SendQuoteModalComponent, SendSoaModalComponent, SendQuoteConfirmationModalComponent, SelectRxTaskComponent, SOAFollowUpModalComponent, BlueButtonFollowUpModalComponent, PlanQuoteComponent, PlanQuoteItemComponent, PlanQuoteBenefitDetailsComponent, PlanQuoteBenefitDetailComponent, SelectPlanQuoteComponent, SelectPlanQuoteErrorComponent, PlanQuoteButtonComponent, PlanCardRidersComponent, SoaFormRendererComponent, SOAConsumerFormComponent, NextGenSOAFormComponent, QuoteSummaryComponent, ExistingMemberFormComponent, ExistingMemberCartComponent, AgentFormSelectionComponent, TitleComponent, GenericFormComponent, StandaloneFormComponent, MedicaidEligibilityCheckComponent, HRAFormComponent, GenericFormRendererComponent, HRAFormRendererComponent, BlueButtonComponent, SelectRXSectionComponent, SalesForceAuthComponent, EnrollDisplayComponent, AgentProfilePictureComponent, AgentProfileUploadComponent, SelectedProviderComponent, GeneralPracticeToggleComponent, ValueBasedProviderToggleComponent, ProviderToggleComponent, MultipleProviderAddressComponent, SingleProviderAddressSelectorComponent, MultipleProviderAddressSelectorComponent, MapPinComponent, PlanProviderDetailsComponent, SummaryPreferencesProviderComponent, PlanSNPIndicatorComponent, MedSupMonthYearDropdownComponent, MedSupDateDropdownComponent, PharmacyFilterModalItemsComponent, AccountSummaryComponent, AccountSummaryInputComponent, ReportsSummaryComponent, CallToActionAreaComponent, CallToActionTile, ReportSearchComponent, ReportListComponent, CreateAccountNudgeComponent, AgentDashboardComponent, AgentTrainingMaterialsComponent, UniqueCodeSearchComponent, TransferCodeSearchComponent, ConsumerForgotPasswordComponent, ConsumerForgotUsernameComponent, EnrollmentConfirmationHRASectionComponent, EnrollmentConfirmationVBCSectionComponent, HRAConfirmationComponent, HRACompleteSectionComponent, GenericFormConfirmationComponent, StandaloneFormConfirmationComponent, EffectiveDateDisplayComponent, PersonalizedVideoComponent, BrowserDeniedComponent, BenefitsDisplayComponent, HIPDetailsBannerComponent, PlanSmartComponent, PlanSmartTabComponent, PlanSmartTabListComponent, PlanSmartTabContentComponent, PlanSmartCardComponent, PlanSmartCardReportSummary, PlanSmartReportButtonComponent, PlanYearLabelComponent, PlanRatingMethodComponent, ValueBasedCareModalComponent, CompletedEnrollmentsHistoryComponent, EnrollmentCardDetailsComponent, PlanDefaultCostComponent, PCPNetworkStatusComponent, DSNPEligibilityMessageComponent, AgentProgressTrackerComponent, ProgressStatusComponent, AgentRetireFloComponent, AgentRetirefloDetailComponent, PreferencesBannerComponent, EligibilityModalComponent, PrescriptionModalComponent, DrugSearchModalComponent, ProviderModalComponent, PharmacyModalComponent, HealthModalComponent, RetireFloSurveyComponent, ProviderSearchModalComponent, PharmacySearchModalComponent] }); })();
i0.ɵɵsetComponentScope(SelectRxTaskComponent, function () { return [i1$2.NgIf, FollowUpTaskComponent, ModalHeaderComponent]; }, []);
i0.ɵɵsetComponentScope(PrescriptionModalComponent, function () { return [ModalFooterComponent, ModalHeaderComponent, DrugSearchModalComponent]; }, []);

class WidgetLookupService {
    constructor() {
        // DO NOT change the format of this without updating the widget export
        // utility at src/builder/widgets/index.js
        this.componentMapping = {
            'planlist': PlanListComponent,
            'basicimage': ImageComponent,
            'textarea': TextComponent,
            'demographic': DemographicComponent,
            'helpfultoolsplanlist': HelpfulToolsPlanListComponent,
            'helpfultoolspharmacysearch': HelpfulToolsPharmacySearchComponent,
            'retentionlanding': RetentionLandingComponent,
            'retentionsummary': RetentionSummaryComponent,
            'multifactorauthentication': MultiFactorAuthenticationComponent,
            'drugsearch': DrugSearchComponent,
            'medicinecabinet': MedicineCabinetComponent,
            'shareprescriptions': SharePrescriptionComponent,
            'enrollmentnavigationbar': EnrollmentNavigationBarComponent,
            'page-nav-buttons': PageNavButtonsComponent,
            'rawhtml': HtmlComponent,
            'googletagmanager': GoogleTagManagerComponent,
            'rawscript': ScriptComponent,
            'pageflownavigation': BackNextNavigationComponent,
            'plan-filter-tabs': FilterTabComponent,
            'shoppingcart': ShoppingCartComponent,
            'plandetails': PlanDetailsComponent,
            'dynamicfooter': DynamicFooterComponent,
            'enrollmentform': FormRootComponent,
            'enrollmentnotice': EnrollmentNoticeComponent,
            'defaultlinkpage': DefaultLinkPageComponent,
            'dynamicheader': DynamicHeaderComponent,
            'clientnavigationheader': ClientNavigationHeaderComponent,
            'scriptingcontainer': ScriptingContainerComponent,
            'enrollmentconfirmation': EnrollmentConfirmationComponent,
            'enrollmentcallrecording': EnrollmentCallRecordingComponent,
            'minicart': MiniCartComponent,
            'enrollmentinformation': EnrollmentInformationComponent,
            'medicareblocktext': MedicareBlockTextComponent,
            'guidedhelp': GuidedHelpComponent,
            'pharmacysearch': PharmacySearchComponent,
            'guidedhelpblock': GuidedHelpBlockComponent,
            'plancompare': PlanCompareComponent,
            'agentlogin': AgentLoginComponent,
            'accountoverview': AccountOverviewComponent,
            'agentsearch': AgentProfileSearchComponent,
            'forgotpassword': ForgotPasswordComponent,
            'forgotusername': ForgotUsernameComponent,
            'resetpassword': ResetPasswordComponent,
            'medigapinterim': MedigapEnrollmentInterimComponent,
            'oauthretrievesalesforceaccesstoken': SalesForceAuthComponent,
            'addprofile': AddProfileComponent,
            'helpfultoolsprescriptions': HelpfulToolsPrescriptionSearchTabComponent,
            'helpfultoolsproviders': HelpfulToolsProviderSearchTabComponent,
            'soa': SOAComponent,
            'profilesearch': AgentSearchComponent,
            'beneficiary': BeneficiaryComponent,
            'quotesummary': QuoteSummaryComponent,
            'soaform': SOAFormComponent,
            'title': TitleComponent,
            'genericform': GenericFormComponent,
            'standaloneform': StandaloneFormComponent,
            'pagenotfound': PageNotFoundComponent,
            'enrolldisplay': EnrollDisplayComponent,
            'consumeraccountsummary': AccountSummaryComponent,
            'reportssummary': ReportsSummaryComponent,
            'plansmart': PlanSmartComponent,
            'consumeraccountnudge': CreateAccountNudgeComponent,
            'agentdashboard': AgentDashboardComponent,
            'agenttrainingmaterials': AgentTrainingMaterialsComponent,
            'hraform': HRAFormComponent,
            'hraconfirmation': HRAConfirmationComponent,
            'genericformconfirmation': GenericFormConfirmationComponent,
            'standaloneformconfirmation': StandaloneFormConfirmationComponent,
            'browserdenied': BrowserDeniedComponent,
            'recordings': RecordingsComponent,
            'completedenrollments': CompletedEnrollmentsHistoryComponent,
            'groupmessage': GroupMessageComponent,
            'talkingpointsidenav': TalkingPointSideNavComponent,
            'agentsubscription': SubscriptionFormComponent,
            'checkoutform': CheckOutFormComponent,
            'subscriptionconfirmation': SubscriptionConfirmationComponent,
            'retireflosurvey': RetireFloSurveyComponent
        };
    }
    getComponent(key) {
        const component = this.componentMapping[key.toLowerCase()];
        if (!component) {
            console.log(`Unable to find component with key: ${key}`);
        }
        return component;
    }
}
WidgetLookupService.ɵfac = function WidgetLookupService_Factory(t) { return new (t || WidgetLookupService)(); };
WidgetLookupService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: WidgetLookupService, factory: WidgetLookupService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WidgetLookupService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

const IS_WIDGET_ENABLED_PROP = 'IsWidgetEnabled';
/**
 * A service for config-driven page, zone, and widget rendering
 */
class ConfigRenderService {
    constructor(componentFactoryResolver, widgetLookupService, resourceService) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.widgetLookupService = widgetLookupService;
        this.resourceService = resourceService;
    }
    assignComponentValue(componentRef, prop, widgetName) {
        let value;
        if (prop.type === PropertyType.VALUE) {
            value = prop.value;
        }
        else if (prop.type === PropertyType.RESOURCE) {
            // prop.value is the resource key in this case
            value = this.resourceService.lookupPropertyValue(prop, widgetName);
        }
        if (value != null) {
            componentRef.instance[prop.prop] = value;
        }
    }
    /**
     * Constructs and loads a component into the provided view container
     * @param widget
     * @param vcr
     */
    loadWidget(widget, zoneKey, vcr) {
        // find the component class given a component name
        const componentClass = this.widgetLookupService.getComponent(widget.widget);
        if (componentClass) {
            let isWidgetEnabled;
            // platform overrides
            const overrides = widget.overrides;
            const widgetName = widget.widget;
            if (overrides && overrides.length) {
                isWidgetEnabled = this.processIsWidgetEnabledWidgetOverride(overrides, widgetName);
            }
            // if we had no overrides then we can look for a global resource
            if (isWidgetEnabled === undefined || isWidgetEnabled === null) {
                isWidgetEnabled = this.processIsWidgetEnabledResourceBundleOverride(widgetName);
            }
            if (isWidgetEnabled === true || (typeof isWidgetEnabled === 'string' && isWidgetEnabled.toLowerCase() === 'true')) {
                // TODO: think on error logging solution
                const componentFactory = this.componentFactoryResolver.resolveComponentFactory(componentClass);
                const widgetRef = vcr.createComponent(componentFactory);
                // NOTE: instance properties will ONLY be set on the top level component! This means if
                // you nest components and expect to use widgetName or zoneKey in a nested component you
                // will need to manually pass them down
                const instance = widgetRef.instance;
                instance.widgetName = widgetName;
                // platform overrides
                instance.setOverrides(overrides);
                return widgetRef;
            }
        }
        // component not created
        return null;
    }
    /**
     * Loads components into the ViewContainerRef from configuration given a zone key.
     * @param zoneKey
     * @param vcr
     */
    loadWidgets(content, zoneKey, vcr) {
        const componentRefs = [];
        if (content) {
            const widgets = content[zoneKey];
            // make sure we have config information for this section
            if (widgets) {
                for (let i = 0, n = widgets.length; i < n; ++i) {
                    const widget = widgets[i];
                    const componentRef = this.loadWidget(widget, zoneKey, vcr);
                    if (componentRef) {
                        componentRefs.push(componentRef);
                    }
                }
            }
        }
        else {
            console.log('No content found.');
        }
        return componentRefs;
    }
    destroyComponents(componentRefs) {
        // clean up refs after our component goes out of scope
        componentRefs.forEach(ref => ref.destroy());
    }
    processIsWidgetEnabledWidgetOverride(overrides, widgetName) {
        const isWidgetEnabledProp = overrides.find(override => override.prop === IS_WIDGET_ENABLED_PROP);
        if (isWidgetEnabledProp) {
            if (isWidgetEnabledProp.type === PropertyType.VALUE) {
                return ((typeof isWidgetEnabledProp.value === 'string' && isWidgetEnabledProp.value.toLowerCase() === 'true') ||
                    isWidgetEnabledProp.value === true);
            }
            else {
                // if this is a resource type then value is referencing
                return this.resourceService.getProcessedResourceValue(isWidgetEnabledProp.value, widgetName, 'true');
            }
        }
    }
    processIsWidgetEnabledResourceBundleOverride(widgetName) {
        const isWidgetEnabledResource = this.resourceService.getProcessedResourceValue(IS_WIDGET_ENABLED_PROP, widgetName, 'true');
        return (isWidgetEnabledResource === undefined ||
            isWidgetEnabledResource === null ||
            isWidgetEnabledResource === 'true' ||
            isWidgetEnabledResource === true);
    }
}
ConfigRenderService.ɵfac = function ConfigRenderService_Factory(t) { return new (t || ConfigRenderService)(i0.ɵɵinject(i0.ComponentFactoryResolver), i0.ɵɵinject(WidgetLookupService), i0.ɵɵinject(i1.ConfigResourceService)); };
ConfigRenderService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ConfigRenderService, factory: ConfigRenderService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfigRenderService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i0.ComponentFactoryResolver }, { type: WidgetLookupService }, { type: i1.ConfigResourceService }]; }, null); })();

class ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr) {
        this.appConfigService = appConfigService;
        this.store = store;
        this.navigationService = navigationService;
        this.cdr = cdr;
        // our active refs to our constructed components.
        // used for destroying the refs when the component goes out of scope.
        this.componentRefs = [];
        const environment = EnvironmentService.getEnvironment();
        if (environment.liveedit) {
            this.store.select(AppConfigState.contents(this.navigationService.getCurrentPageBaseUrl())).subscribe({
                next: response => {
                    this.content = response ? response : null;
                    if (this.componentRefs) {
                        this.appConfigService.destroyComponents(this.componentRefs);
                    }
                    if (this.zoneKey && this.vcr) {
                        this.componentRefs = this.appConfigService.loadWidgets(this.content, this.zoneKey, this.vcr);
                        this.cdr.markForCheck();
                    }
                }
            });
        }
        else {
            this.store
                .selectOnce(AppConfigState.contents(this.navigationService.getCurrentPageBaseUrl()))
                .subscribe({ next: response => (this.content = response ? response : null) });
        }
    }
    ngOnInit() {
        if (this.zoneKey && this.vcr) {
            this.componentRefs = this.appConfigService.loadWidgets(this.content, this.zoneKey, this.vcr);
        }
    }
    ngOnDestroy() {
        this.appConfigService.destroyComponents(this.componentRefs);
    }
}
ConfigurableZone.ɵfac = function ConfigurableZone_Factory(t) { return new (t || ConfigurableZone)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
ConfigurableZone.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: ConfigurableZone });
__decorate([
    Select(AppConfigState.currentLocale)
], ConfigurableZone.prototype, "currentLocale$", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfigurableZone, [{
        type: Directive
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }]; }, { currentLocale$: [] }); })();

const _c0$m = ["afterContent"];
function AfterContentZoneComponent_ng_template_1_Template(rf, ctx) { }
class AfterContentZoneComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        // TODO: add comments for documentation
        this.zoneKey = 'afterContent';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
AfterContentZoneComponent.ɵfac = function AfterContentZoneComponent_Factory(t) { return new (t || AfterContentZoneComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
AfterContentZoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AfterContentZoneComponent, selectors: [["vnext-zone-after-content"]], viewQuery: function AfterContentZoneComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$m, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService] // provides zone data to components down the tree
        ), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["afterContent", ""]], template: function AfterContentZoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, AfterContentZoneComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AfterContentZoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-after-content', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ZoneService] // provides zone data to components down the tree
                , template: "<div>\r\n  <ng-template #afterContent></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['afterContent', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$l = ["afterMain"];
function AfterMainZoneComponent_ng_template_1_Template(rf, ctx) { }
class AfterMainZoneComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.zoneKey = 'afterMain';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
AfterMainZoneComponent.ɵfac = function AfterMainZoneComponent_Factory(t) { return new (t || AfterMainZoneComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
AfterMainZoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AfterMainZoneComponent, selectors: [["vnext-zone-after-main"]], viewQuery: function AfterMainZoneComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$l, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService]), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["afterMain", ""]], template: function AfterMainZoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, AfterMainZoneComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AfterMainZoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-after-main', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ZoneService], template: "<div>\r\n  <ng-template #afterMain></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['afterMain', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$k = ["asideFirst"];
function AsideFirstZoneComponent_ng_template_1_Template(rf, ctx) { }
class AsideFirstZoneComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.zoneKey = 'asideFirst';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
AsideFirstZoneComponent.ɵfac = function AsideFirstZoneComponent_Factory(t) { return new (t || AsideFirstZoneComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
AsideFirstZoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AsideFirstZoneComponent, selectors: [["vnext-zone-aside-first"]], viewQuery: function AsideFirstZoneComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$k, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService]), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["asideFirst", ""]], template: function AsideFirstZoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, AsideFirstZoneComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AsideFirstZoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-aside-first', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ZoneService], template: "<div>\r\n  <ng-template #asideFirst></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['asideFirst', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$j = ["asideSecond"];
function AsideSecondZoneComponent_ng_template_1_Template(rf, ctx) { }
class AsideSecondZoneComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.zoneKey = 'asideSecond';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
AsideSecondZoneComponent.ɵfac = function AsideSecondZoneComponent_Factory(t) { return new (t || AsideSecondZoneComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
AsideSecondZoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AsideSecondZoneComponent, selectors: [["vnext-zone-aside-second"]], viewQuery: function AsideSecondZoneComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$j, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService]), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["asideSecond", ""]], template: function AsideSecondZoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, AsideSecondZoneComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AsideSecondZoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-aside-second', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ZoneService], template: "<div>\r\n  <ng-template #asideSecond></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['asideSecond', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$i = ["beforeContent"];
function BeforeContentZoneComponent_ng_template_1_Template(rf, ctx) { }
class BeforeContentZoneComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.zoneKey = 'beforeContent';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
BeforeContentZoneComponent.ɵfac = function BeforeContentZoneComponent_Factory(t) { return new (t || BeforeContentZoneComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
BeforeContentZoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BeforeContentZoneComponent, selectors: [["vnext-zone-before-content"]], viewQuery: function BeforeContentZoneComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$i, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService] // provides zone data to components down the tree
        ), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["beforeContent", ""]], template: function BeforeContentZoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, BeforeContentZoneComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BeforeContentZoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-before-content', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ZoneService] // provides zone data to components down the tree
                , template: "<div>\r\n  <ng-template #beforeContent></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['beforeContent', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$h = ["beforeMain"];
function BeforeMainZoneComponent_ng_template_1_Template(rf, ctx) { }
class BeforeMainZoneComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.zoneKey = 'beforeMain';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
BeforeMainZoneComponent.ɵfac = function BeforeMainZoneComponent_Factory(t) { return new (t || BeforeMainZoneComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
BeforeMainZoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BeforeMainZoneComponent, selectors: [["vnext-zone-before-main"]], viewQuery: function BeforeMainZoneComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$h, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService]), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["beforeMain", ""]], template: function BeforeMainZoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, BeforeMainZoneComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BeforeMainZoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-before-main', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ZoneService], template: "<div>\r\n  <ng-template #beforeMain></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['beforeMain', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$g = ["content2"];
function Content2ZoneComponent_ng_template_1_Template(rf, ctx) { }
class Content2ZoneComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.zoneKey = 'content2';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
Content2ZoneComponent.ɵfac = function Content2ZoneComponent_Factory(t) { return new (t || Content2ZoneComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
Content2ZoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: Content2ZoneComponent, selectors: [["vnext-zone-content-2"]], viewQuery: function Content2ZoneComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$g, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService] // provides zone data to components down the tree
        ), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["content2", ""]], template: function Content2ZoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, Content2ZoneComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Content2ZoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-content-2', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ZoneService] // provides zone data to components down the tree
                , template: "<div>\r\n  <ng-template #content2></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['content2', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$f = ["content3"];
function Content3ZoneComponent_ng_template_1_Template(rf, ctx) { }
class Content3ZoneComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.zoneKey = 'content3';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
Content3ZoneComponent.ɵfac = function Content3ZoneComponent_Factory(t) { return new (t || Content3ZoneComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
Content3ZoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: Content3ZoneComponent, selectors: [["vnext-zone-content-3"]], viewQuery: function Content3ZoneComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$f, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService] // provides zone data to components down the tree
        ), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["content3", ""]], template: function Content3ZoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, Content3ZoneComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Content3ZoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-content-3', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ZoneService] // provides zone data to components down the tree
                , template: "<div>\r\n  <ng-template #content3></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['content3', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$e = ["content4"];
function Content4ZoneComponent_ng_template_1_Template(rf, ctx) { }
class Content4ZoneComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.zoneKey = 'content4';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
Content4ZoneComponent.ɵfac = function Content4ZoneComponent_Factory(t) { return new (t || Content4ZoneComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
Content4ZoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: Content4ZoneComponent, selectors: [["vnext-zone-content-4"]], viewQuery: function Content4ZoneComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$e, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService] // provides zone data to components down the tree
        ), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["content4", ""]], template: function Content4ZoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, Content4ZoneComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(Content4ZoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-content-4', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ZoneService] // provides zone data to components down the tree
                , template: "<div>\r\n  <ng-template #content4></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['content4', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$d = ["contentLeft"];
function ContentLeftComponent_ng_template_1_Template(rf, ctx) { }
class ContentLeftComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.zoneKey = 'contentLeft';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
ContentLeftComponent.ɵfac = function ContentLeftComponent_Factory(t) { return new (t || ContentLeftComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
ContentLeftComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ContentLeftComponent, selectors: [["vnext-zone-content-left"]], viewQuery: function ContentLeftComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$d, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService]), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["contentLeft", ""]], template: function ContentLeftComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, ContentLeftComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContentLeftComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-content-left', providers: [ZoneService], template: "<div>\r\n  <ng-template #contentLeft></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['contentLeft', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$c = ["contentRight"];
function ContentRightComponent_ng_template_1_Template(rf, ctx) { }
class ContentRightComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.zoneKey = 'contentRight';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
ContentRightComponent.ɵfac = function ContentRightComponent_Factory(t) { return new (t || ContentRightComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
ContentRightComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ContentRightComponent, selectors: [["vnext-zone-content-right"]], viewQuery: function ContentRightComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$c, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService]), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["contentRight", ""]], template: function ContentRightComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, ContentRightComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContentRightComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-content-right', providers: [ZoneService], template: "<div>\r\n  <ng-template #contentRight></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['contentRight', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$b = ["content"];
const _c1 = ["contentContainer"];
function ContentZoneComponent_ng_template_2_Template(rf, ctx) { }
class ContentZoneComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService, skipToMainContentService, renderer) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.skipToMainContentService = skipToMainContentService;
        this.renderer = renderer;
        this.zoneKey = 'content';
        this.zoneService.zoneKey = this.zoneKey;
    }
    ngOnInit() {
        super.ngOnInit();
        this.skipToMainContentService._setFocusToMainContent$.subscribe({
            next: value => {
                /* Prevent scroll from focus as Firefox browser doesn't support scroll on focus event.
                So we need to handle that separately by using scrollIntoView function (works with all browser) */
                this.contentContainer.nativeElement.focus({ preventScroll: true });
                this.contentContainer.nativeElement.scrollIntoView();
                const firstFocusableElement = this.contentContainer.nativeElement.querySelector('input, button, a,  [role="link"]');
                if (firstFocusableElement) {
                    this.renderer.selectRootElement(firstFocusableElement, true).focus();
                }
            }
        });
    }
}
ContentZoneComponent.ɵfac = function ContentZoneComponent_Factory(t) { return new (t || ContentZoneComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService), i0.ɵɵdirectiveInject(SkipToMainContentService), i0.ɵɵdirectiveInject(i0.Renderer2)); };
ContentZoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ContentZoneComponent, selectors: [["vnext-zone-content"]], viewQuery: function ContentZoneComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$b, 7, ViewContainerRef);
        i0.ɵɵviewQuery(_c1, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentContainer = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService] // provides zone data to components down the tree
        ), i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 0, consts: [["tabindex", "-1"], ["contentContainer", ""], ["content", ""]], template: function ContentZoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0, 1);
        i0.ɵɵtemplate(2, ContentZoneComponent_ng_template_2_Template, 0, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContentZoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-content', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ZoneService] // provides zone data to components down the tree
                , template: "<div #contentContainer tabindex=\"-1\">\r\n  <ng-template #content></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }, { type: SkipToMainContentService }, { type: i0.Renderer2 }]; }, { vcr: [{
            type: ViewChild,
            args: ['content', { read: ViewContainerRef, static: true }]
        }], contentContainer: [{
            type: ViewChild,
            args: ['contentContainer', { static: true }]
        }] }); })();

const _c0$a = ["featured"];
function FeaturedZoneComponent_ng_template_1_Template(rf, ctx) { }
class FeaturedZoneComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.zoneKey = 'featured';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
FeaturedZoneComponent.ɵfac = function FeaturedZoneComponent_Factory(t) { return new (t || FeaturedZoneComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
FeaturedZoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FeaturedZoneComponent, selectors: [["vnext-zone-featured"]], viewQuery: function FeaturedZoneComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$a, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService] // provides zone data to components down the tree
        ), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["featured", ""]], template: function FeaturedZoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, FeaturedZoneComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FeaturedZoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-featured', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ZoneService] // provides zone data to components down the tree
                , template: "<div>\r\n  <ng-template #featured></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['featured', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$9 = ["footerMain"];
function FooterMainZoneComponent_ng_template_1_Template(rf, ctx) { }
class FooterMainZoneComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.zoneKey = 'footerMain';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
FooterMainZoneComponent.ɵfac = function FooterMainZoneComponent_Factory(t) { return new (t || FooterMainZoneComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
FooterMainZoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FooterMainZoneComponent, selectors: [["vnext-zone-footer-main"]], viewQuery: function FooterMainZoneComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$9, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService] // provides zone data to components down the tree
        ), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["footerMain", ""]], template: function FooterMainZoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, FooterMainZoneComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FooterMainZoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-footer-main', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ZoneService] // provides zone data to components down the tree
                , template: "<div>\r\n  <ng-template #footerMain></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['footerMain', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$8 = ["footerTop"];
function FooterTopZoneComponent_ng_template_1_Template(rf, ctx) { }
class FooterTopZoneComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.zoneKey = 'footerTop';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
FooterTopZoneComponent.ɵfac = function FooterTopZoneComponent_Factory(t) { return new (t || FooterTopZoneComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
FooterTopZoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FooterTopZoneComponent, selectors: [["vnext-zone-footer-top"]], viewQuery: function FooterTopZoneComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$8, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService] // provides zone data to components down the tree
        ), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["footerTop", ""]], template: function FooterTopZoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, FooterTopZoneComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FooterTopZoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-footer-top', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ZoneService] // provides zone data to components down the tree
                , template: "<div>\r\n  <ng-template #footerTop></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['footerTop', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$7 = ["footer"];
function FooterZoneComponent_ng_template_1_Template(rf, ctx) { }
class FooterZoneComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.zoneKey = 'footer';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
FooterZoneComponent.ɵfac = function FooterZoneComponent_Factory(t) { return new (t || FooterZoneComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
FooterZoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FooterZoneComponent, selectors: [["vnext-zone-footer"]], viewQuery: function FooterZoneComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$7, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService] // provides zone data to components down the tree
        ), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["footer", ""]], template: function FooterZoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, FooterZoneComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FooterZoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-footer', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ZoneService] // provides zone data to components down the tree
                , template: "<div>\r\n  <ng-template #footer></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['footer', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$6 = ["header"];
function HeaderZoneComponent_ng_template_1_Template(rf, ctx) { }
class HeaderZoneComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.zoneKey = 'header';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
HeaderZoneComponent.ɵfac = function HeaderZoneComponent_Factory(t) { return new (t || HeaderZoneComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
HeaderZoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HeaderZoneComponent, selectors: [["vnext-zone-header"]], viewQuery: function HeaderZoneComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$6, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService] // provides zone data to components down the tree
        ), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["header", ""]], template: function HeaderZoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, HeaderZoneComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HeaderZoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-header', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ZoneService] // provides zone data to components down the tree
                , template: "<div>\r\n  <ng-template #header></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['header', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$5 = ["messages"];
function MessagesZoneComponent_ng_template_1_Template(rf, ctx) { }
class MessagesZoneComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.zoneKey = 'messages';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
MessagesZoneComponent.ɵfac = function MessagesZoneComponent_Factory(t) { return new (t || MessagesZoneComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
MessagesZoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MessagesZoneComponent, selectors: [["vnext-zone-messages"]], viewQuery: function MessagesZoneComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$5, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService]), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["messages", ""]], template: function MessagesZoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, MessagesZoneComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessagesZoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-messages', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ZoneService], template: "<div>\r\n  <ng-template #messages></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['messages', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$4 = ["navigation"];
function NavigationZoneComponent_ng_template_1_Template(rf, ctx) { }
class NavigationZoneComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.zoneKey = 'navigation';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
NavigationZoneComponent.ɵfac = function NavigationZoneComponent_Factory(t) { return new (t || NavigationZoneComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
NavigationZoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NavigationZoneComponent, selectors: [["vnext-zone-navigation"]], viewQuery: function NavigationZoneComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$4, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService] // provides zone data to components down the tree
        ), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["navigation", ""]], template: function NavigationZoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, NavigationZoneComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavigationZoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-navigation', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ZoneService] // provides zone data to components down the tree
                , template: "<div>\r\n  <ng-template #navigation></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['navigation', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$3 = ["tripelFirst"];
function TripelFirstZoneComponent_ng_template_1_Template(rf, ctx) { }
class TripelFirstZoneComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.zoneKey = 'tripelFirst';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
TripelFirstZoneComponent.ɵfac = function TripelFirstZoneComponent_Factory(t) { return new (t || TripelFirstZoneComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
TripelFirstZoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TripelFirstZoneComponent, selectors: [["vnext-zone-tripel-first"]], viewQuery: function TripelFirstZoneComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$3, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService]), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["tripelFirst", ""]], template: function TripelFirstZoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, TripelFirstZoneComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TripelFirstZoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-tripel-first', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ZoneService], template: "<div>\r\n  <ng-template #tripelFirst></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['tripelFirst', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$2 = ["tripelSecond"];
function TripelSecondZoneComponent_ng_template_1_Template(rf, ctx) { }
class TripelSecondZoneComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.zoneKey = 'tripelSecond';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
TripelSecondZoneComponent.ɵfac = function TripelSecondZoneComponent_Factory(t) { return new (t || TripelSecondZoneComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
TripelSecondZoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TripelSecondZoneComponent, selectors: [["vnext-zone-tripel-second"]], viewQuery: function TripelSecondZoneComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$2, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService]), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["tripelSecond", ""]], template: function TripelSecondZoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, TripelSecondZoneComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TripelSecondZoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-tripel-second', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ZoneService], template: "<div>\r\n  <ng-template #tripelSecond></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['tripelSecond', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$1 = ["tripelThird"];
function TripelThirdZoneComponent_ng_template_1_Template(rf, ctx) { }
class TripelThirdZoneComponent extends ConfigurableZone {
    constructor(appConfigService, store, navigationService, cdr, zoneService) {
        super(appConfigService, store, navigationService, cdr);
        this.zoneService = zoneService;
        this.zoneKey = 'tripelThird';
        this.zoneService.zoneKey = this.zoneKey;
    }
}
TripelThirdZoneComponent.ɵfac = function TripelThirdZoneComponent_Factory(t) { return new (t || TripelThirdZoneComponent)(i0.ɵɵdirectiveInject(ConfigRenderService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i1.NavigationService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ZoneService)); };
TripelThirdZoneComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TripelThirdZoneComponent, selectors: [["vnext-zone-tripel-third"]], viewQuery: function TripelThirdZoneComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1, 7, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([ZoneService]), i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 0, consts: [["tripelThird", ""]], template: function TripelThirdZoneComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, TripelThirdZoneComponent_ng_template_1_Template, 0, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TripelThirdZoneComponent, [{
        type: Component,
        args: [{ selector: 'vnext-zone-tripel-third', changeDetection: ChangeDetectionStrategy.OnPush, providers: [ZoneService], template: "<div>\r\n  <ng-template #tripelThird></ng-template>\r\n</div>\r\n" }]
    }], function () { return [{ type: ConfigRenderService }, { type: i2.Store }, { type: i1.NavigationService }, { type: i0.ChangeDetectorRef }, { type: ZoneService }]; }, { vcr: [{
            type: ViewChild,
            args: ['tripelThird', { read: ViewContainerRef, static: true }]
        }] }); })();

const VNEXT_ZONE_EXPORTS = [
    AfterContentZoneComponent,
    AfterMainZoneComponent,
    AsideFirstZoneComponent,
    AsideSecondZoneComponent,
    BeforeContentZoneComponent,
    BeforeMainZoneComponent,
    ContentZoneComponent,
    Content2ZoneComponent,
    Content3ZoneComponent,
    Content4ZoneComponent,
    FeaturedZoneComponent,
    FooterMainZoneComponent,
    FooterTopZoneComponent,
    FooterZoneComponent,
    HeaderZoneComponent,
    MessagesZoneComponent,
    NavigationZoneComponent,
    TripelFirstZoneComponent,
    TripelSecondZoneComponent,
    TripelThirdZoneComponent,
    ContentLeftComponent,
    ContentRightComponent
];
const VNEXT_ZONE_DECLARATIONS = [...VNEXT_ZONE_EXPORTS];

class ZonesModule {
}
ZonesModule.ɵfac = function ZonesModule_Factory(t) { return new (t || ZonesModule)(); };
ZonesModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ZonesModule });
ZonesModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ZonesModule, [{
        type: NgModule,
        args: [{
                declarations: VNEXT_ZONE_DECLARATIONS,
                exports: VNEXT_ZONE_EXPORTS,
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ZonesModule, { declarations: [AfterContentZoneComponent, AfterMainZoneComponent, AsideFirstZoneComponent, AsideSecondZoneComponent, BeforeContentZoneComponent, BeforeMainZoneComponent, ContentZoneComponent, Content2ZoneComponent, Content3ZoneComponent, Content4ZoneComponent, FeaturedZoneComponent, FooterMainZoneComponent, FooterTopZoneComponent, FooterZoneComponent, HeaderZoneComponent, MessagesZoneComponent, NavigationZoneComponent, TripelFirstZoneComponent, TripelSecondZoneComponent, TripelThirdZoneComponent, ContentLeftComponent, ContentRightComponent], exports: [AfterContentZoneComponent, AfterMainZoneComponent, AsideFirstZoneComponent, AsideSecondZoneComponent, BeforeContentZoneComponent, BeforeMainZoneComponent, ContentZoneComponent, Content2ZoneComponent, Content3ZoneComponent, Content4ZoneComponent, FeaturedZoneComponent, FooterMainZoneComponent, FooterTopZoneComponent, FooterZoneComponent, HeaderZoneComponent, MessagesZoneComponent, NavigationZoneComponent, TripelFirstZoneComponent, TripelSecondZoneComponent, TripelThirdZoneComponent, ContentLeftComponent, ContentRightComponent] }); })();

class BasicTemplateComponent extends ConfigurablePage {
}
BasicTemplateComponent.ɵfac = /*@__PURE__*/ function () { let ɵBasicTemplateComponent_BaseFactory; return function BasicTemplateComponent_Factory(t) { return (ɵBasicTemplateComponent_BaseFactory || (ɵBasicTemplateComponent_BaseFactory = i0.ɵɵgetInheritedFactory(BasicTemplateComponent)))(t || BasicTemplateComponent); }; }();
BasicTemplateComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BasicTemplateComponent, selectors: [["vnext-template-basic"]], features: [i0.ɵɵProvidersFeature([WidgetValidationService, DeactivationGuardService]), i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 0, consts: [["id", "templateContainer"]], template: function BasicTemplateComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "vnext-zone-before-content")(2, "vnext-zone-content")(3, "vnext-zone-after-content");
        i0.ɵɵelementEnd();
    } }, dependencies: [AfterContentZoneComponent, BeforeContentZoneComponent, ContentZoneComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BasicTemplateComponent, [{
        type: Component,
        args: [{ selector: 'vnext-template-basic', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetValidationService, DeactivationGuardService], template: "<div id=\"templateContainer\">\r\n  <vnext-zone-before-content></vnext-zone-before-content>\r\n  <vnext-zone-content></vnext-zone-content>\r\n  <vnext-zone-after-content></vnext-zone-after-content>\r\n</div>\r\n" }]
    }], null, null); })();

class LandingTemplateComponent extends ConfigurablePage {
}
LandingTemplateComponent.ɵfac = /*@__PURE__*/ function () { let ɵLandingTemplateComponent_BaseFactory; return function LandingTemplateComponent_Factory(t) { return (ɵLandingTemplateComponent_BaseFactory || (ɵLandingTemplateComponent_BaseFactory = i0.ɵɵgetInheritedFactory(LandingTemplateComponent)))(t || LandingTemplateComponent); }; }();
LandingTemplateComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LandingTemplateComponent, selectors: [["vnext-template-landing"]], features: [i0.ɵɵProvidersFeature([WidgetValidationService, DeactivationGuardService]), i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 0, template: function LandingTemplateComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "vnext-zone-header")(1, "vnext-zone-navigation")(2, "vnext-zone-content")(3, "vnext-zone-content-2")(4, "vnext-zone-content-3")(5, "vnext-zone-content-4")(6, "vnext-zone-footer-top")(7, "vnext-zone-footer-main");
    } }, dependencies: [ContentZoneComponent, Content2ZoneComponent, Content3ZoneComponent, Content4ZoneComponent, FooterMainZoneComponent, FooterTopZoneComponent, HeaderZoneComponent, NavigationZoneComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LandingTemplateComponent, [{
        type: Component,
        args: [{ selector: 'vnext-template-landing', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetValidationService, DeactivationGuardService], template: "<vnext-zone-header></vnext-zone-header>\r\n<vnext-zone-navigation></vnext-zone-navigation>\r\n<vnext-zone-content></vnext-zone-content>\r\n<vnext-zone-content-2></vnext-zone-content-2>\r\n<vnext-zone-content-3></vnext-zone-content-3>\r\n<vnext-zone-content-4></vnext-zone-content-4>\r\n<vnext-zone-footer-top></vnext-zone-footer-top>\r\n<vnext-zone-footer-main></vnext-zone-footer-main>\r\n" }]
    }], null, null); })();

const _c0 = ["contentContainer"];
class RightAsideTemplateComponent extends ConfigurablePage {
    constructor(widgetValidationService, deactivationGuardService, skipToMainContentService, responsiveLayoutService) {
        super(widgetValidationService, deactivationGuardService);
        this.skipToMainContentService = skipToMainContentService;
        this.responsiveLayoutService = responsiveLayoutService;
    }
    ngOnInit() {
        this.skipToMainContentService._setFocusToMainContent$.subscribe({
            next: value => {
                this.contentContainer.nativeElement.focus();
            }
        });
        this.isMobile$ = this.responsiveLayoutService.isCompact$;
    }
}
RightAsideTemplateComponent.ɵfac = function RightAsideTemplateComponent_Factory(t) { return new (t || RightAsideTemplateComponent)(i0.ɵɵdirectiveInject(i1.WidgetValidationService), i0.ɵɵdirectiveInject(i1.DeactivationGuardService), i0.ɵɵdirectiveInject(SkipToMainContentService), i0.ɵɵdirectiveInject(i1.ResponsiveLayoutService)); };
RightAsideTemplateComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RightAsideTemplateComponent, selectors: [["vnext-template-right-aside"]], viewQuery: function RightAsideTemplateComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentContainer = _t.first);
    } }, features: [i0.ɵɵProvidersFeature([WidgetValidationService, DeactivationGuardService]), i0.ɵɵInheritDefinitionFeature], decls: 10, vars: 0, consts: [["id", "templateContainer"], ["tabindex", "-1", 1, "container"], ["contentContainer", ""], [1, "row", "d-print-inline-flex", "pl-0", "justify-content-between"], [1, "col-md-3", "col-lg-3", "offset-lg-1", "mb-2", "pl-lg-4", "pl-0", "pr-0", "order-1", "order-md-2"], [1, "col-md-9", "col-lg-8", "pl-0", "order-2", "order-md-1"]], template: function RightAsideTemplateComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "vnext-zone-header");
        i0.ɵɵelementStart(2, "div", 1, 2);
        i0.ɵɵelement(4, "vnext-zone-before-content");
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵelement(6, "vnext-zone-content-right", 4)(7, "vnext-zone-content-left", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(8, "vnext-zone-after-content");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(9, "vnext-zone-footer");
        i0.ɵɵelementEnd();
    } }, dependencies: [AfterContentZoneComponent, BeforeContentZoneComponent, FooterZoneComponent, HeaderZoneComponent, ContentLeftComponent, ContentRightComponent], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RightAsideTemplateComponent, [{
        type: Component,
        args: [{ selector: 'vnext-template-right-aside', providers: [WidgetValidationService, DeactivationGuardService], template: "<div id=\"templateContainer\">\r\n  <vnext-zone-header></vnext-zone-header>\r\n  <div #contentContainer tabindex=\"-1\" class=\"container\">\r\n    <vnext-zone-before-content></vnext-zone-before-content>\r\n    <div class=\"row d-print-inline-flex pl-0 justify-content-between\">\r\n      <vnext-zone-content-right class=\"col-md-3 col-lg-3 offset-lg-1 mb-2 pl-lg-4 pl-0 pr-0 order-1 order-md-2\"></vnext-zone-content-right>\r\n      <vnext-zone-content-left class=\"col-md-9 col-lg-8 pl-0 order-2 order-md-1\"></vnext-zone-content-left>\r\n    </div>\r\n    <vnext-zone-after-content></vnext-zone-after-content>\r\n  </div>\r\n  <vnext-zone-footer></vnext-zone-footer>\r\n</div>\r\n" }]
    }], function () { return [{ type: i1.WidgetValidationService }, { type: i1.DeactivationGuardService }, { type: SkipToMainContentService }, { type: i1.ResponsiveLayoutService }]; }, { contentContainer: [{
            type: ViewChild,
            args: ['contentContainer', { static: true }]
        }] }); })();

class StandardTemplateComponent extends ConfigurablePage {
    constructor() {
        super(...arguments);
        this.hostClasses = 'template-standard';
    }
}
StandardTemplateComponent.ɵfac = /*@__PURE__*/ function () { let ɵStandardTemplateComponent_BaseFactory; return function StandardTemplateComponent_Factory(t) { return (ɵStandardTemplateComponent_BaseFactory || (ɵStandardTemplateComponent_BaseFactory = i0.ɵɵgetInheritedFactory(StandardTemplateComponent)))(t || StandardTemplateComponent); }; }();
StandardTemplateComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StandardTemplateComponent, selectors: [["vnext-template-standard"]], hostVars: 2, hostBindings: function StandardTemplateComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassMap(ctx.hostClasses);
    } }, features: [i0.ɵɵProvidersFeature([WidgetValidationService, DeactivationGuardService]), i0.ɵɵInheritDefinitionFeature], decls: 16, vars: 0, consts: [["id", "templateContainer"], [1, "flex-grow-1"]], template: function StandardTemplateComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "vnext-zone-header")(2, "vnext-zone-navigation")(3, "vnext-zone-featured")(4, "vnext-zone-before-main")(5, "vnext-zone-aside-first")(6, "vnext-zone-messages")(7, "vnext-zone-before-content")(8, "vnext-zone-content", 1)(9, "vnext-zone-after-content")(10, "vnext-zone-aside-second")(11, "vnext-zone-after-main")(12, "vnext-zone-tripel-first")(13, "vnext-zone-tripel-second")(14, "vnext-zone-tripel-third")(15, "vnext-zone-footer");
        i0.ɵɵelementEnd();
    } }, dependencies: [AfterContentZoneComponent, AfterMainZoneComponent, AsideFirstZoneComponent, AsideSecondZoneComponent, BeforeContentZoneComponent, BeforeMainZoneComponent, ContentZoneComponent, FeaturedZoneComponent, FooterZoneComponent, HeaderZoneComponent, MessagesZoneComponent, NavigationZoneComponent, TripelFirstZoneComponent, TripelSecondZoneComponent, TripelThirdZoneComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StandardTemplateComponent, [{
        type: Component,
        args: [{ selector: 'vnext-template-standard', changeDetection: ChangeDetectionStrategy.OnPush, providers: [WidgetValidationService, DeactivationGuardService], template: "<div id=\"templateContainer\">\r\n  <vnext-zone-header></vnext-zone-header>\r\n  <vnext-zone-navigation></vnext-zone-navigation>\r\n  <vnext-zone-featured></vnext-zone-featured>\r\n  <vnext-zone-before-main></vnext-zone-before-main>\r\n  <vnext-zone-aside-first></vnext-zone-aside-first>\r\n  <vnext-zone-messages></vnext-zone-messages>\r\n  <vnext-zone-before-content></vnext-zone-before-content>\r\n  <vnext-zone-content class=\"flex-grow-1\"></vnext-zone-content>\r\n  <vnext-zone-after-content></vnext-zone-after-content>\r\n  <vnext-zone-aside-second></vnext-zone-aside-second>\r\n  <vnext-zone-after-main></vnext-zone-after-main>\r\n  <vnext-zone-tripel-first></vnext-zone-tripel-first>\r\n  <vnext-zone-tripel-second></vnext-zone-tripel-second>\r\n  <vnext-zone-tripel-third></vnext-zone-tripel-third>\r\n  <vnext-zone-footer></vnext-zone-footer>\r\n</div>\r\n" }]
    }], null, { hostClasses: [{
            type: HostBinding,
            args: ['class']
        }] }); })();

const VNEXT_TEMPLATE_EXPORTS = [
    BasicTemplateComponent,
    LandingTemplateComponent,
    StandardTemplateComponent,
    RightAsideTemplateComponent
];
const VNEXT_TEMPLATE_DECLARATIONS = [...VNEXT_TEMPLATE_EXPORTS];

const VNEXT_TEMPLATE_IMPORTS = [CommonModule, ZonesModule];
class TemplatesModule {
}
TemplatesModule.ɵfac = function TemplatesModule_Factory(t) { return new (t || TemplatesModule)(); };
TemplatesModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TemplatesModule });
TemplatesModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [VNEXT_TEMPLATE_IMPORTS] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TemplatesModule, [{
        type: NgModule,
        args: [{
                imports: VNEXT_TEMPLATE_IMPORTS,
                declarations: VNEXT_TEMPLATE_DECLARATIONS,
                exports: VNEXT_TEMPLATE_EXPORTS
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TemplatesModule, { declarations: [BasicTemplateComponent, LandingTemplateComponent, StandardTemplateComponent, RightAsideTemplateComponent], imports: [CommonModule, ZonesModule], exports: [BasicTemplateComponent, LandingTemplateComponent, StandardTemplateComponent, RightAsideTemplateComponent] }); })();

const VNEXT_ANIMATION_EXPORTS = [];
const VNEXT_ANIMATION_DECLARATIONS = [...VNEXT_ANIMATION_EXPORTS];
const VNEXT_ANIMATION_ENTRY_COMPONENTS = [];

class AnimationsModule {
}
AnimationsModule.ɵfac = function AnimationsModule_Factory(t) { return new (t || AnimationsModule)(); };
AnimationsModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AnimationsModule });
AnimationsModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserAnimationsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AnimationsModule, [{
        type: NgModule,
        args: [{
                imports: [BrowserAnimationsModule],
                declarations: VNEXT_ANIMATION_DECLARATIONS,
                exports: VNEXT_ANIMATION_EXPORTS
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(AnimationsModule, { imports: [BrowserAnimationsModule] }); })();

// Public API Surface of vnext-widgets

/**
 * Generated bundle index. Do not edit.
 */

export { AccordionComponent, AccountOverviewComponent, AccountSummaryComponent, AccountSummaryInputComponent, ActiveSellingPermissionsComponent, AddAgentSellingPermissionsComponent, AddProfileComponent, AfterContentZoneComponent, AfterMainZoneComponent, AgencyNameSelectorInputComponent, AgentCallRecordingModalComponent, AgentCallRecordingShoppingBoxComponent, AgentCallRecordingShoppingModalComponent, AgentContainerComponent, AgentDashboardComponent, AgentDashboardTaskDetailComponent, AgentDashboardTaskListComponent, AgentFormSelectionComponent, AgentHeaderComponent, AgentLoginComponent, AgentNoteComponent, AgentNoteDetailComponent, AgentNoteModalComponent, AgentOfRecordComponent, AgentOfRecordModalComponent, AgentOfRecordModalResultsComponent, AgentOfRecordModalSearchComponent, AgentOfRecordModalSuccessComponent, AgentProfilePictureComponent, AgentProfileSearchComponent, AgentProfileUploadComponent, AgentProgressTrackerComponent, AgentRetireFloComponent, AgentRetireFloSignupModalComponent, AgentRetirefloDetailComponent, AgentRoleSelectorComponent, AgentSOAComponent, AgentSearchComponent, AgentSearchResultComponent, AgentTaskComponent, AgentTaskDetailComponent, AgentTaskModalComponent, AgentTrainingMaterialsComponent, AnimationsModule, AsideFirstZoneComponent, AsideSecondZoneComponent, AuthorizationCodeSignatureModalComponent, AuthorizationCodeSignatureStatementComponent, BackNextNavigationComponent, BasicTemplateComponent, BeforeContentZoneComponent, BeforeMainZoneComponent, BeneficiaryComponent, BenefitsDisplayComponent, BlueButtonComponent, BlueButtonFollowUpModalComponent, BrowserDeniedComponent, CallRecordingStickyBoxComponent, CallToActionAreaComponent, CallToActionTile, CartRiderComponent, CheckBoxItemComponent, CheckOutFormComponent, CheckboxDropdownComponent, CheckboxGroupComponent, ClientNavigationHeaderComponent, CmsApprovalCodeComponent, CollapsibleListAnimationDirective, CompletedEnrollmentsHistoryComponent, ComponentsModule, ConfigsModule, ConfigurableTooltipComponent, ConsumerForgotPasswordComponent, ConsumerForgotUsernameComponent, ContactUsComponent, ContactUsModalComponent, ContactYourAgentStepComponent, ContainerComponent, Content2ZoneComponent, Content3ZoneComponent, Content4ZoneComponent, ContentLeftComponent, ContentRightComponent, ContentZoneComponent, CopyPurlPlusComponent, CopyrightComponent, CreateAccountComponent, CreateAccountNudgeComponent, CustomCurrencyPipe, DSNPEligibilityMessageComponent, DatePickerInputComponent, DefaultLinkPageComponent, DefaultLinksComponent, DemographicComponent, DigitalPharmacyCardComponent, DigitalPharmacyComponent, DirectivesModule, DisclaimerSectionComponent, DropdownButtonComponent, DrugCardComponent, DrugCostDetailsComponent, DrugCostsComponent, DrugDetailsComponent, DrugDetailsFooterComponent, DrugDosageComponent, DrugFootNoteComponent, DrugGenericEquivalentComponent, DrugListCardComponent, DrugListCardModalComponent, DrugPackageComponent, DrugQuantityFrequencyComponent, DrugRestrictionsComponent, DrugSearchComponent, DrugSearchModalComponent, DrugTypeComponent, DuplicatedPermissionModalComponent, DynamicFooterComponent, DynamicHeaderComponent, EffectiveDateDisplayComponent, EligibilityModalComponent, EllipsisPipe, EmailConfirmationModalComponent, EmailConfirmationSuccessModalComponent, EnrollDisplayComponent, EnrollmentCallRecordingActionsComponent, EnrollmentCallRecordingComponent, EnrollmentCardDetailsComponent, EnrollmentConfirmationComponent, EnrollmentConfirmationHRASectionComponent, EnrollmentConfirmationVBCSectionComponent, EnrollmentFormNavigationComponent, EnrollmentFormRendererComponent, EnrollmentInformationComponent, EnrollmentNavigationBarBaseComponent, EnrollmentNavigationBarComponent, EnrollmentNavigationStepComponent, EnrollmentNoticeComponent, EnrollmentUnavailableComponent, EnterVerificationCodeStepComponent, EventStylingDirective, ExistingMemberCartComponent, ExistingMemberFormComponent, FeaturedZoneComponent, FieldErrorComponent, FieldErrorsComponent, FilterSellingPermissionsComponent, FilterTabComponent, FocusOnMainContentComponent, FollowUpTaskComponent, FooterMainZoneComponent, FooterTopZoneComponent, FooterZoneComponent, FootnoteComponent, ForgotPasswordComponent, ForgotUsernameComponent, FormDateComponent, FormInputSubmitDirective, FormMonthYearDropdownComponent, FormRootComponent, FormularyDetailsComponent, GeneralPracticeToggleComponent, GenericFormComponent, GenericFormConfirmationComponent, GenericFormRendererComponent, GoogleTagManagerComponent, GoogleTagManagerDirective, GroupMessageComponent, GuidedHelpAgeSelectComponent, GuidedHelpBlockComponent, GuidedHelpComponent, GuidedHelpCoverageTypeComponent, GuidedHelpGetStartedComponent, GuidedHelpNavigationComponent, GuidedHelpNavigationTextComponent, GuidedHelpOtherPreferencesComponent, GuidedHelpPlanListComponent, GuidedHelpZipCodeComponent, HIPDetailsBannerComponent, HRACompleteSectionComponent, HRAConfirmationComponent, HRAFormComponent, HRAFormRendererComponent, HeaderMenuDropdownComponent, HeaderZoneComponent, HealthComponent, HealthCostCustomizationComponent, HealthCostCustomizationTableComponent, HealthCostTabComponent, HealthCostTableComponent, HealthModalComponent, HealthSliderComponent, HelpfulToolsLinkComponent, HelpfulToolsPharmacySearchComponent, HelpfulToolsPharmacySearchTabComponent, HelpfulToolsPlanCardComponent, HelpfulToolsPlanListComponent, HelpfulToolsPrescriptionSearchTabComponent, HelpfulToolsProviderSearchTabComponent, HideMissingImageDirective, HighlightDifferencesDirective, HospitalIndemnityCoverageCartNudgeComponent, HospitalIndemnityFactorModalComponent, HospitalIndemnityFormComponent, HospitalIndemnityInformationNudgeComponent, HtmlComponent, HtmlConfirmationModalComponent, IconAriaAttributesDirective, ImageBannerContainerComponent, ImageComponent, InnerTextLinkComponent, LandingTemplateComponent, LearnMoreTooltipComponent, LegacyPlanCardComponent, LegacyPlanCoveragePreferencesComponent, LinkComponent, LiveEditModalComponent, LiveEditPropDirective, LoaderPlaceholderComponent, LocaleDatePipe, LocalePickerComponent, LoginComponent, LoginContainerComponent, LogoComponent, LogoutButtonComponent, MailOrderPharmacyDetailsComponent, MapComponent, MapPinComponent, MaximumHeightDirective, MedSupBirthDateComponent, MedSupCheckboxComponent, MedSupCheckboxesComponent, MedSupDateComponent, MedSupDateDropdownComponent, MedSupDropdownComponent, MedSupEffectiveDateAComponent, MedSupEffectiveDateBComponent, MedSupEffectiveDateComponent, MedSupFormComponent, MedSupHeightComponent, MedSupIntegerComponent, MedSupMillimanFormComponent, MedSupMillimanHealthQuestionComponent, MedSupMonthYearDropdownComponent, MedSupPaymentMethodComponent, MedSupPlanSubTypeComponent, MedSupToggleComponent, MedicaidEligibilityCheckComponent, MedicalConditionDrugAlternativesSelectionModalComponent, MedicalConditionsDrugAlternativesDetailsComponent, MedicareBlockTextComponent, MedicineCabinetComponent, MedicineCabinetModalComponent, MedigapEnrollmentInterimComponent, MedsupMillimanAuthorizationComponent, MemberEffectiveDateComponent, MemberEligibilityCheckComponent, MemberEnrollmentCardComponent, MemberEnrollmentHistoryComponent, MemberExpandableEnrollmentCardComponent, MemberExpandablePartialEnrollmentCardComponent, MemberPartialEnrollmentCardComponent, MemberProfileRetentionSummaryComponent, MemberQuoteCardComponent, MemberQuoteHistoryComponent, MemberRegistrationComponent, MemberResultCardComponent, MessagesZoneComponent, MiniCartComponent, MiniCartPlanCardComponent, MiniCartPlanRiderComponent, ModalFooterComponent, ModalHeaderComponent, MonthlyBreakdownCostComponent, MotionPointLocalePickerComponent, MultiFactorAuthenticationComponent, MultipleProviderAddressComponent, MultipleProviderAddressModalComponent, MultipleProviderAddressSelectorComponent, NavigationAdapterDirective, NavigationBannerComponent, NavigationZoneComponent, NextGenEnrollmentFormRendererComponent, NextGenEnrollmentNavigationBarComponent, NextGenSOAFormComponent, NextgenPlanCardComponent, NextgenPlanCardDetailExpandableComponent, NextgenPlanCoveragePreferencesComponent, NextgenPlanSubDetailsComponent, NgbdSortableHeaderDirective, NonCoveredDrugAlternativesSubDetailsComponent, NotLicensedPlanListComponent, NoticeComponent, NoticeContainerComponent, NoticeErrorListComponent, NoticeInfoListComponent, NoticeSuccessListComponent, NoticeWarnListComponent, OrderPipe, PCPNetworkStatusComponent, PINLockedStepComponent, PageNavButtonComponent, PageNavButtonsComponent, PageNotFoundComponent, PageSpinnerComponent, PaginationComponent, PersonalizedVideoComponent, PharmacyFilterItemsComponent, PharmacyFilterModalComponent, PharmacyFilterModalItemsComponent, PharmacyListComponent, PharmacyModalComponent, PharmacySearchComponent, PharmacySearchHeaderComponent, PharmacySearchModalComponent, PharmacySelectionComponent, PharmacySelectorComponent, PhonePipe, PipesModule, PlanBenefitDetailsComponent, PlanBenefitsComponent, PlanCardBestMatchComponent, PlanCardComponent, PlanCardLabelComponent, PlanCardRateFactorStatusComponent, PlanCardRateFactorsStatusesComponent, PlanCardRidersComponent, PlanCardSupplementalBenefitLabelComponent, PlanCardSupplementalBenefitsComponent, PlanCardTileComponent, PlanCardTileTwoComponent, PlanCompareAccordionComponent, PlanCompareCardComponent, PlanCompareCardLabelComponent, PlanCompareComponent, PlanCompareEnrollmentNavigationBarComponent, PlanCompareMedicalBenefitsComponent, PlanComparePaginationComponent, PlanComparePanelComponent, PlanComparePreferencesComponent, PlanComparePrescriptionComponent, PlanComparePrescriptionCoverageComponent, PlanCompareRidersComponent, PlanCostDetailsComponent, PlanCostSectionComponent, PlanCoveragePreferencesComponent, PlanCoveragePrescriptionInfoModalComponent, PlanCoveragePrescriptionsComponent, PlanCoveragePrescriptionsLabelComponent, PlanCoverageProviderInfoModalComponent, PlanCoverageProvidersComponent, PlanCoverageProvidersLabelComponent, PlanDefaultCostComponent, PlanDetailsCardComponent, PlanDetailsComponent, PlanDetailsCostComponent, PlanDetailsTabComponent, PlanDrugAlternativesIndicatorComponent, PlanFeesComponent, PlanFeesTooltipComponent, PlanFilterComponent, PlanFilterItemsComponent, PlanFilterModalComponent, PlanFilterModalItemsComponent, PlanLevelContentComponent, PlanListAccordionComponent, PlanListComponent, PlanLogoComponent, PlanPharmacyDetailsComponent, PlanPreferenceTextComponent, PlanProviderDetailsComponent, PlanQuoteBenefitDetailComponent, PlanQuoteBenefitDetailsComponent, PlanQuoteButtonComponent, PlanQuoteComponent, PlanQuoteItemComponent, PlanRatingMethodComponent, PlanRiderDetailsComponent, PlanSNPIndicatorComponent, PlanSmartCardComponent, PlanSmartCardReportSummary, PlanSmartComponent, PlanSmartFilterComponent, PlanSmartFilterItemsComponent, PlanSmartFilterModalComponent, PlanSmartReportButtonComponent, PlanSmartTabComponent, PlanSmartTabContentComponent, PlanSmartTabListComponent, PlanSortComponent, PlanSubDetailsComponent, PlanSubTypeDropdownComponent, PlanYearBadgeComponent, PlanYearLabelComponent, PlanYearModalComponent, PopoverComponent, PreferencesBannerComponent, PrescriptionModalComponent, PrescriptionsTabComponent, ProfileNavbarDropdownComponent, ProfileNavigationAgentItemComponent, ProfileNavigationBarComponent, ProgressStatusComponent, ProviderAcceptingNewPatientsComponent, ProviderInlineElementComponent, ProviderListComponent, ProviderModalComponent, ProviderPhoneComponent, ProviderSearchComponent, ProviderSearchModalComponent, ProviderToggleComponent, QualifiedHelpSummaryComponent, QuotePlanCardComponent, QuoteSummaryComponent, QuoteSummaryPreferencesComponent, QuoteUserInfoComponent, QuoteWelcomeComponent, RangeSliderDirective, RateFactorAppliedPipe, RateFactorBirthDateComponent, RateFactorDateComponent, RateFactorDropdownComponent, RateFactorEffectiveDateComponent, RateFactorToggleComponent, RateFactorWarningComponent, RateFactorsFormComponent, RecordingsComponent, ReportListComponent, ReportSearchComponent, ReportSummaryFilterItemsComponent, ReportsSummaryComponent, ResetPasswordComponent, RetentionLandingComponent, RetentionPlanCardComponent, RetentionSummaryComponent, RetentionUserInfoComponent, RetentionWelcomeComponent, RetireFloSurveyComponent, RetireFloSurveyModalComponent, RiderBenefitDetailsComponent, RiderBenefitsComponent, RiderCardComponent, RiderCategoryComponent, RiderCategoryDetailComponent, RightAsideTemplateComponent, SNPCategoryToggleComponent, SNPInfoModalComponent, SNPToggleComponent, SOAActivityComponent, SOAActivityItemComponent, SOAComponent, SOAConsumerFormComponent, SOAFollowUpModalComponent, SOAFormComponent, SafePipe, SalesForceAuthComponent, SaveProgressComponent, ScriptComponent, ScriptingContainerComponent, ScrollableMultiSelectCheckboxComponent, SelectContactMethodStepComponent, SelectDropdownByCharacterDirective, SelectPlanQuoteComponent, SelectPlanQuoteErrorComponent, SelectRXSectionComponent, SelectRxTaskComponent, SelectedPharmacyComponent, SelectedProviderComponent, SelectedProviderModalComponent, SendQuoteConfirmationModalComponent, SendQuoteModalComponent, SendRetireFloModalComponent, SendSoaModalComponent, SharePrescriptionComponent, SharePrescriptionListComponent, ShoppingCartButtonComponent, ShoppingCartComponent, ShoppingCartCrossSellComponent, ShoppingCartCrossSellModalComponent, ShoppingCartIconComponent, ShortNamePipe, SingleProviderAddressSelectorComponent, SiteDisclaimerComponent, SoaAgentFormComponent, SoaFormRendererComponent, SpeakWithAgentComponent, SpinnerComponent, StandaloneFormComponent, StandaloneFormConfirmationComponent, StandardTemplateComponent, StarRatingComponent, StateSelectorInputComponent, StatusButtonComponent, SubHeaderActionComponent, SubHeaderComponent, SubscriptionConfirmationComponent, SubscriptionFormComponent, SummaryButtonsComponent, SummaryCoverageTypesComponent, SummaryPreferencesComponent, SummaryPreferencesProviderComponent, TabComponent, TabListComponent, TalkingPointSideNavComponent, TemplatesModule, TextComponent, TextSizeComponent, TitleComponent, ToggleMultiSelectComponent, ToggleSelectComponent, TooltipComponent, TotalCostsTabComponent, TotalPremiumBannerComponent, TransferCodeSearchComponent, TrimTextPipe, TripelFirstZoneComponent, TripelSecondZoneComponent, TripelThirdZoneComponent, UniqueCodeSearchComponent, UpdateEffectiveDateModalComponent, VNEXT_ANIMATION_DECLARATIONS, VNEXT_ANIMATION_ENTRY_COMPONENTS, VNEXT_ANIMATION_EXPORTS, VNEXT_COMPONENT_DECLARATIONS, VNEXT_COMPONENT_ENTRY_COMPONENTS, VNEXT_COMPONENT_EXPORTS, VNEXT_CONFIG_COMPONENT_DECLARATIONS, VNEXT_CONFIG_COMPONENT_ENTRY_COMPONENTS, VNEXT_CONFIG_COMPONENT_EXPORTS, VNEXT_DIRECTIVES_DECLARATIONS, VNEXT_DIRECTIVES_EXPORTS, VNEXT_PIPE_DECLARATIONS, VNEXT_PIPE_EXPORTS, VNEXT_TEMPLATE_DECLARATIONS, VNEXT_TEMPLATE_EXPORTS, VNEXT_WIDGET_DECLARATIONS, VNEXT_WIDGET_ENTRY_COMPONENTS, VNEXT_WIDGET_EXPORTS, VNEXT_ZONE_DECLARATIONS, VNEXT_ZONE_EXPORTS, ValueBasedCareAgreementComponent, ValueBasedCareModalComponent, ValueBasedProviderToggleComponent, VerificationCodeSentComponent, VoiceSignatureModalComponent, VoiceSignatureStatementComponent, WarningMessageManyResultsAgentSearchComponent, WidgetsModule, ZipCodeInputComponent, ZipCodeModalComponent, ZonesModule, collapsibleList };
